/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1456);
	module.exports = __webpack_require__(1067);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(1523);
	} else {
	  module.exports = require('./cjs/react.development.js');
	}


/***/ },
/* 2 */
/***/ function(module, exports) {

	function _interopRequireDefault(e) {
	  return e && e.__esModule ? e : {
	    "default": e
	  };
	}
	module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var ReactIs = require('react-is');
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(1365)();
	}


/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.removalItemExclusiveBanner2 = exports.removalItemExclusiveBanner1 = exports.removalItemBigBanner = exports.uploadBrochureNew = exports.uploadThumbNew = exports.getRoleMenus = exports.getRoleListV1 = exports.saveCity = exports.getContacts = exports.getCityList = exports.getAreaNamesListV2 = exports.getSchoolDetail = exports.getImagesList = exports.getCMSSiteList = exports.getInsightList = exports.getCommunityPaged = exports.getCampsPaged = exports.getAFAPaged = exports.getTuitionsPaged = exports.uploadEditorImage = exports.getMail = exports.getMailList = exports.getSchoolNoOfUnRegistered = exports.getSchoolNoOfRegistered = exports.getVerticalUserCount = exports.getPreSchoolsPaged = exports.getParentsPaged = exports.getSchoolsPaged = exports.findpartnersendotplink = exports.verifyVendor = exports.saveArea = exports.getAreaNamesList = exports.getJobsList = exports.checkpushLead = exports.CheckCreatePartner = exports.getIncompleteLeads = exports.savePayLink = exports.discount_update = exports.getJobs = exports.updateOpt = exports.getCampaignBatches = exports.getAllUnpaidUsers = exports.deleteOtherAdEntry = exports.cancelRemoveCampaign = exports.cancelCampaign = exports.getCampaignMailInfo = exports.updateEmailCampaign = exports.getEmailCampaign = exports.startEmailCampaign = exports.saveEmailCampaign = exports.uploadEmailImage = exports.getMailCampaignList = exports.partnerSubscriptionAfterRazorPayLinks = exports.getPaymentLinkInfoDetail = exports.getRazorPayTransactionList = exports.updatePaymentInfo = exports.getPaymentLinkInfo = exports.getDiscountNew = undefined;
	exports.sendMailPayLink = exports.getPayLink = exports.getMailInfo = exports.moveup_update = exports.removelead = exports.removefeatured = exports.creatediscount = exports.moveup = exports.checkDiscountInfo = exports.checkiffeatured = exports.getLead_Stats = exports.createLead = exports.getStamps = exports.checkifEligibleForStamping = exports.getPartnerLeadNew = exports.stampSchool = exports.getSEOContents = exports.removeTopFiveEntry = exports.getPremiumList = exports.updatePremiumList = exports.getSuggest = exports.uploadThumb2 = exports.uploadThumb1 = exports.uploadFile2 = exports.uploadFile1 = exports.deleteAdEntry = exports.submitAdsEntryOther = exports.submitAdsEntry = exports.uploadGallery = exports.exclprtshipsList = exports.uploadBrochure = exports.getOtherAds = exports.getAllAds = exports.getPartnerAds = exports.getPartnerLeadInfo = exports.updateLeadAction = exports.checkPaidOrNot = exports.ParterSeenLead = exports.getLeadsByPartner = exports.getLeads = exports.partnerReportV1 = exports.packageAPI = exports.splEvent = exports.updateSplEvent = exports.importRetailer = exports.retailerUpdate = exports.retailerAPI = exports.eventReject = exports.communityReject = exports.learningReject = exports.tuitionReject = exports.hobbiesReject = exports.playareaReject = exports.presclReject = exports.sclReject = exports.eventEdit = exports.learningEdit = exports.communityEdit = exports.tuitionEdit = exports.hobbiesEdit = exports.playareaEdit = exports.presclEdit = exports.sclEdit = exports.AddExclUserData = exports.adminExclUser = exports.makeMessageRead = exports.changeStatusExclPart = exports.sendAdminMessage = exports.getUnseenEntries = exports.deleteExclPartnership = exports.getExclusiveList = exports.getExclPtnrsEntryById = exports.getExclPtnrsEntryB2B = exports.getExclPtnrsEntry = exports.removeExclPtnrsEntry = exports.submitEntry = exports.saveEntry = exports.uploadVideo = exports.uploadImage = exports.uploadOtherAd = exports.uploadBannerAd = exports.uploadBanner = exports.uploadLogo = exports.uploadMedia = exports.sendWelcomeEmailCamp = exports.getCuratedRegistrationList = exports.getCuratedPaymentList = exports.UpdateCuratedCampsByAdmin = exports.ApproveCuratedCamp = exports.UpdateCuratedCamps = exports.AddCuratedCamps = exports.partnerSubCategories = exports.partnerMainCategory = exports.add_curated_camp = exports.approveVendorInfoCurated = exports.getCuratedCampListAll = exports.getCuratedCampList = exports.getSearchList = exports.add_Summer_Camp = exports.deleteSummerCamp = undefined;
	exports.getSummerCampList = exports.adminReport = exports.pNotification = exports.adminPriceChart = exports.uploadArticleImage = exports.indUploadDocs = exports.adminUser = exports.adminRoles = exports.benchApi = exports.insightApi = exports.partnerBranch = exports.updateRemoveCategory = exports.getLocation = exports.partnerSubscription = exports.partnerAfaCategory = exports.partnerCategory = exports.subPartner = exports.getAllcategoryData = exports.getAllverticalData = exports.activateUser = exports.updateResource = exports.eventResource = exports.exportBirthdayEvents = exports.exportCommunitysupport = exports.exportLearningcamps = exports.exportTuition = exports.exportAfterschool = exports.exportKidsplayArea = exports.exportSchool = exports.exportPreschool = exports.deactivateUser = exports.promodata = exports.taxdata = exports.emailExist_check = exports.updatePackageData = exports.getPackageType = exports.getPackageDetail = exports.removePackage = exports.getPackageList = exports.updateInsights = exports.getAuthorSuggest = exports.getInsightDetail = exports.removeInsight = exports.updateVideo = exports.updateAdminVideo = exports.getVideoDataAdmin = exports.getVideoListAdmin = exports.RatingExport = exports.WishExport = exports.DAFExport = exports.CSPExport = exports.subExport = exports.transactionExport = exports.contactPartnerExport = exports.contactUserExport = exports.partnerDocupload = exports.vendorExport = exports.userExport = exports.bewiseuserExport = exports.partnerApi = exports.signUpApi = exports.updategallery = exports.UpdateVendorPlan = exports.commonAPI = exports.getWishList = exports.getDeviceAccess = exports.getContactServiceList = exports.AddDiscount = exports.EditDiscountData = exports.getDiscount = exports.rejectVendorInfo = exports.getRatingList = exports.getEnquiriesList = exports.indComSignup = exports.indVerifyLink = exports.indResponse = exports.registerPartnerInd = exports.getCommentList = exports.emailExist = exports.adminDashboard = exports.vendorDashboard = exports.approveVendorInfo = exports.getCatList = exports.getPartnerDetails = exports.getInvoiceInfo = exports.getTransactionList = exports.ProfileUpdate = exports.CreatePay = exports.getPlan = exports.verifyLogin = exports.EditSubuserData = exports.AddUserData = exports.deleteUser = exports.getSubuser = exports.EditRoleData = exports.deleteRole = exports.getRoles = exports.AddRole = exports.getMenu = exports.getVendorInfo = undefined;
	exports.getVendorList = exports.deletePreSchl = exports.getLocationList = exports.getUserInfo = exports.getUserList = exports.ContactData = exports.SubscribeData = exports.ImportExcelCommunity = exports.ImportExcelCamp = exports.ImportExcelEvents = exports.ImportExcelTutions = exports.ImportExcelHobbies = exports.ImportExcelPlayarea = exports.ImportExcelPreSchool = exports.ImportExcelSchool = exports.addYoga = exports.addMusic = exports.addDrawing = exports.addDance = exports.getAllPlayareas = exports.addPlayArea = exports.addPreschool = exports.AddPartyHall = exports.AddSports = exports.AddTutions = exports.createSchool = exports.AddCamps = exports.AddCakeShop = exports.AddEntertainers = exports.AddVenues = exports.AddSuppliers = exports.getSchoolListData = exports.AddCounselors = exports.AddNannier = exports.getAdvicelists = exports.preschoolDel = exports.tutionDel = exports.eventsDel = exports.deleteHobby = exports.registerVendor = exports.LoginAdmin = exports.deleteSchl = exports.deletePlayArea = exports.deleteSesCamp = exports.adviceDel = exports.sclList = exports.preSclList = exports.getCatDrop = exports.checkOTP = exports.SentOtp = exports.changePass = exports.ResetPass = exports.ForgotPass = exports.getCommunitySupport = exports.getSeasonalCampList = exports.getEvents = exports.getTutionList = exports.getAfterSchools = exports.getPreSchools = exports.getSchools = exports.saveMail = exports.removeCMSSiteContent = exports.saveSiteContent = exports.getTransactionListV1 = exports.getRazorPayTransactionListV1 = exports.getPlanList = exports.saveGST = exports.getGST = exports.saveRole = exports.getPartnerPaged = exports.getExclusivePartnersPaged = exports.getBewiseUsersPaged = exports.getPromoCodeList = exports.getResourceList = exports.getBeWiseCuratedCampList = exports.getNewsList = exports.saveNews = exports.getNews = exports.getArticleDetail = exports.getWebsiteAds = exports.getRoleDetail = exports.LoginBeWise = exports.getInsightListTotal = exports.getInsightListPaged = exports.getTotalUsers = exports.getLatestNews = exports.getCuratedCampListV2 = exports.partnerArticles = exports.beWiseArticles = exports.tuitionCount = exports.learningcampCount = exports.afaCount = exports.preschoolCount = exports.schoolCount = exports.removethisItem = exports.getTotal = exports.eventsCount = exports.getTotalPartners = exports.getEventsPaged = exports.getTotalParents = undefined;
	exports.getTotalBewiseUsers = exports.getTotalTransactions = exports.getTotalLeads = exports.findTeachers = exports.checkifduplicateExist = exports.getTotalSubscribers = exports.getSubscribersListPaged = exports.exportWcSubscribers = exports.getKidsPlayAreaPaged = exports.confirmLead = exports.createLeadManual = exports.updateEntry = exports.getDuplicatesPaged = exports.getTotalDuplicates = exports.checkDuplicateUrl = exports.editExclUser = exports.removeExclUser = exports.deActivatePartner = exports.restoreTrash = exports.movetoTrash = exports.getPartnerPagedTrashed = exports.getTotalPartnersTrashed = exports.approveBulk = exports.approveInsight = exports.getjobs = exports.updatejob = exports.getJobDetailTeacher = exports.postajob = exports.getTotalApplicants = exports.saveJobStatus = exports.getApplicants = exports.getTalents = exports.getOtherCoursesListPaged = exports.getCoursesListPaged = exports.LoginCourse = exports.saveCourse = exports.getCoursesbyUser = exports.getCourseById = exports.updateCourse = exports.approvecourse = exports.createprovider = exports.addjobimporting = exports.getJobDetail = exports.getBlogCategory = exports.partnerSubscriptionV1 = exports.getPartnerSubscriptions = exports.getAuroScholarPaged = exports.getTotalAuroSubscribers = exports.checkAndsubscribeWiseConnect = exports.checkifWcSubscribedTrial = exports.getExclPartnerShipDetailById = exports.getJobsListPaged = exports.getTotalJobs = exports.getTotalBlogs = exports.getBlogsListPaged = exports.postanextblog = exports.updateablog = exports.getExtBlogById = exports.processReminderMail = exports.sendCustomMail = exports.getNewsLetterSubscribersListPaged = exports.getTotalNewsLetterSubscribers = exports.getRegisteredListPaged = exports.getTotalRegistered = exports.getProfileDetail = exports.getExperiences = exports.getEducations = exports.generatePdfHtml = exports.partnerAddBranch = exports.getAddonList = exports.getSpecialDiscount = exports.blockThisUser = exports.unBlockThisUser = exports.getCitiesByKeyWord = exports.sendProComFollowUp = exports.getTotalEnquiries = exports.getEnquiries = exports.getPaymentInfo = exports.getSpecialPageList = exports.approvePage = exports.updatePage = exports.getPageDetail = exports.sendRegretNoData = exports.bringNoDateMail = exports.uploadBannerB2b = exports.saveExclEnqLead = exports.exclprtshipsListPartners = exports.generateThumbnails = exports.generateDataGraph = exports.showresultssearch = exports.registerVendorNew = exports.checkifLeadsReceived = exports.resetPasswordSend = exports.saveAbout = exports.leadCharts = exports.leadreportstext = exports.getcuratedviews = exports.activatePartner = exports.fetch_category_by_ids = exports.getBlobList = undefined;
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var addPlayArea = function () {
	  var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(data) {
	    var formData, key, i, result;
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            formData = new FormData();
	
	            console.log(data);
	            for (key in data) {
	              if (key == 'photos') {
	                for (i = 0; i < data[key].length; i++) {
	                  formData.append('photos', data[key][i]);
	                }
	              } else {
	                formData.append(key, data[key]);
	              }
	            }
	            console.log(formData);
	            _context.next = 6;
	            return fetch(_DomainName2.default.register + 'playarea', {
	              method: 'POST',
	              mode: 'cors',
	              headers: { 'x-auth-token': token },
	              body: formData
	            });
	
	          case 6:
	            result = _context.sent;
	
	            console.log('Success');
	            return _context.abrupt('return', result.json());
	
	          case 9:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, this);
	  }));
	
	  return function addPlayArea(_x) {
	    return _ref.apply(this, arguments);
	  };
	}();
	
	var addDance = function () {
	  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(data) {
	    var formData, key, result;
	    return _regenerator2.default.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            formData = new FormData();
	
	            console.log(data);
	            for (key in data) {
	              formData.append(key, data[key]);
	            }
	            console.log(formData);
	            _context2.next = 6;
	            return fetch(_DomainName2.default.register + 'creativeActivity', {
	              method: 'POST',
	              mode: 'cors',
	              headers: { 'x-auth-token': token },
	              body: formData
	            });
	
	          case 6:
	            result = _context2.sent;
	
	            console.log('Success');
	            return _context2.abrupt('return', result.json());
	
	          case 9:
	          case 'end':
	            return _context2.stop();
	        }
	      }
	    }, _callee2, this);
	  }));
	
	  return function addDance(_x2) {
	    return _ref2.apply(this, arguments);
	  };
	}();
	
	var addMusic = function () {
	  var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(data) {
	    var formData, key, result;
	    return _regenerator2.default.wrap(function _callee3$(_context3) {
	      while (1) {
	        switch (_context3.prev = _context3.next) {
	          case 0:
	            formData = new FormData();
	
	            console.log(data);
	            for (key in data) {
	              formData.append(key, data[key]);
	            }
	            console.log(formData);
	            _context3.next = 6;
	            return fetch(_DomainName2.default.register + 'creativeActivity', {
	              method: 'POST',
	              mode: 'cors',
	              headers: { 'x-auth-token': token },
	              body: formData
	            });
	
	          case 6:
	            result = _context3.sent;
	
	            console.log('Success');
	            return _context3.abrupt('return', result.json());
	
	          case 9:
	          case 'end':
	            return _context3.stop();
	        }
	      }
	    }, _callee3, this);
	  }));
	
	  return function addMusic(_x3) {
	    return _ref3.apply(this, arguments);
	  };
	}();
	
	var addYoga = function () {
	  var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(data) {
	    var formData, key, result;
	    return _regenerator2.default.wrap(function _callee4$(_context4) {
	      while (1) {
	        switch (_context4.prev = _context4.next) {
	          case 0:
	            formData = new FormData();
	
	            console.log(data);
	            for (key in data) {
	              formData.append(key, data[key]);
	            }
	            console.log(formData);
	            _context4.next = 6;
	            return fetch(_DomainName2.default.register + 'creativeActivity', {
	              method: 'POST',
	              mode: 'cors',
	              headers: { 'x-auth-token': token },
	              body: formData
	            });
	
	          case 6:
	            result = _context4.sent;
	
	            console.log('Success');
	            return _context4.abrupt('return', result.json());
	
	          case 9:
	          case 'end':
	            return _context4.stop();
	        }
	      }
	    }, _callee4, this);
	  }));
	
	  return function addYoga(_x4) {
	    return _ref4.apply(this, arguments);
	  };
	}();
	
	var addDrawing = function () {
	  var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(data) {
	    var formData, key, result;
	    return _regenerator2.default.wrap(function _callee5$(_context5) {
	      while (1) {
	        switch (_context5.prev = _context5.next) {
	          case 0:
	            formData = new FormData();
	
	            console.log(data);
	            for (key in data) {
	              formData.append(key, data[key]);
	            }
	            console.log(formData);
	            _context5.next = 6;
	            return fetch(_DomainName2.default.register + 'creativeActivity', {
	              method: 'POST',
	              mode: 'cors',
	              headers: { 'x-auth-token': token },
	              body: formData
	            });
	
	          case 6:
	            result = _context5.sent;
	
	            console.log('Success');
	            return _context5.abrupt('return', result.json());
	
	          case 9:
	          case 'end':
	            return _context5.stop();
	        }
	      }
	    }, _callee5, this);
	  }));
	
	  return function addDrawing(_x5) {
	    return _ref5.apply(this, arguments);
	  };
	}();
	
	var AddPartyHall = function () {
	  var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(data) {
	    var formData, key, result;
	    return _regenerator2.default.wrap(function _callee6$(_context6) {
	      while (1) {
	        switch (_context6.prev = _context6.next) {
	          case 0:
	            formData = new FormData();
	
	            console.log(data);
	            for (key in data) {
	              formData.append(key, data[key]);
	            }
	            console.log(formData);
	            _context6.next = 6;
	            return fetch(_DomainName2.default.register + 'partyhall', {
	              method: 'POST',
	              mode: 'cors',
	              headers: { 'x-auth-token': token },
	              body: formData
	            });
	
	          case 6:
	            result = _context6.sent;
	
	            console.log('Success');
	            return _context6.abrupt('return', result.json());
	
	          case 9:
	          case 'end':
	            return _context6.stop();
	        }
	      }
	    }, _callee6, this);
	  }));
	
	  return function AddPartyHall(_x6) {
	    return _ref6.apply(this, arguments);
	  };
	}();
	
	var AddCakeShop = function () {
	  var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(data) {
	    var formData, key, result;
	    return _regenerator2.default.wrap(function _callee7$(_context7) {
	      while (1) {
	        switch (_context7.prev = _context7.next) {
	          case 0:
	            formData = new FormData();
	
	            console.log(data);
	            for (key in data) {
	              formData.append(key, data[key]);
	            }
	            console.log(formData);
	            _context7.next = 6;
	            return fetch(_DomainName2.default.register + 'cake', {
	              method: 'POST',
	              mode: 'cors',
	              headers: { 'x-auth-token': token },
	              body: formData
	            });
	
	          case 6:
	            result = _context7.sent;
	
	            console.log('Success');
	            return _context7.abrupt('return', result.json());
	
	          case 9:
	          case 'end':
	            return _context7.stop();
	        }
	      }
	    }, _callee7, this);
	  }));
	
	  return function AddCakeShop(_x7) {
	    return _ref7.apply(this, arguments);
	  };
	}();
	
	var AddEntertainers = function () {
	  var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee8(data) {
	    var formData, key, result;
	    return _regenerator2.default.wrap(function _callee8$(_context8) {
	      while (1) {
	        switch (_context8.prev = _context8.next) {
	          case 0:
	            formData = new FormData();
	
	            console.log(data);
	            for (key in data) {
	              formData.append(key, data[key]);
	            }
	            console.log(formData);
	            _context8.next = 6;
	            return fetch(_DomainName2.default.register + 'entatainer', {
	              method: 'POST',
	              mode: 'cors',
	              headers: { 'x-auth-token': token },
	              body: formData
	            });
	
	          case 6:
	            result = _context8.sent;
	
	            console.log('Success');
	            return _context8.abrupt('return', result.json());
	
	          case 9:
	          case 'end':
	            return _context8.stop();
	        }
	      }
	    }, _callee8, this);
	  }));
	
	  return function AddEntertainers(_x8) {
	    return _ref8.apply(this, arguments);
	  };
	}();
	
	var AddSuppliers = function () {
	  var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee9(data) {
	    var formData, key, i, result;
	    return _regenerator2.default.wrap(function _callee9$(_context9) {
	      while (1) {
	        switch (_context9.prev = _context9.next) {
	          case 0:
	            formData = new FormData();
	
	            console.log(data);
	            for (key in data) {
	              if (key == 'photos') {
	                for (i = 0; i < data[key].length; i++) {
	                  formData.append('photos', data[key][i]);
	                }
	              } else {
	                formData.append(key, data[key]);
	              }
	            }
	            console.log(formData);
	            _context9.next = 6;
	            return fetch(_DomainName2.default.register + 'admin/events', {
	              method: 'POST',
	              mode: 'cors',
	              headers: { 'x-auth-token': token },
	              body: formData
	            });
	
	          case 6:
	            result = _context9.sent;
	
	            console.log('Success');
	            return _context9.abrupt('return', result.json());
	
	          case 9:
	          case 'end':
	            return _context9.stop();
	        }
	      }
	    }, _callee9, this);
	  }));
	
	  return function AddSuppliers(_x9) {
	    return _ref9.apply(this, arguments);
	  };
	}();
	
	var AddVenues = function () {
	  var _ref10 = _asyncToGenerator(_regenerator2.default.mark(function _callee10(data) {
	    var formData, key, result;
	    return _regenerator2.default.wrap(function _callee10$(_context10) {
	      while (1) {
	        switch (_context10.prev = _context10.next) {
	          case 0:
	            formData = new FormData();
	
	            console.log(data);
	            for (key in data) {
	              formData.append(key, data[key]);
	            }
	            console.log(formData);
	            _context10.next = 6;
	            return fetch(_DomainName2.default.register + 'venue', {
	              method: 'POST',
	              mode: 'cors',
	              headers: { 'x-auth-token': token },
	              body: formData
	            });
	
	          case 6:
	            result = _context10.sent;
	
	            console.log('Success');
	            return _context10.abrupt('return', result.json());
	
	          case 9:
	          case 'end':
	            return _context10.stop();
	        }
	      }
	    }, _callee10, this);
	  }));
	
	  return function AddVenues(_x10) {
	    return _ref10.apply(this, arguments);
	  };
	}();
	
	var AddCamps = function () {
	  var _ref11 = _asyncToGenerator(_regenerator2.default.mark(function _callee11(data) {
	    var formData, key, i, result;
	    return _regenerator2.default.wrap(function _callee11$(_context11) {
	      while (1) {
	        switch (_context11.prev = _context11.next) {
	          case 0:
	            formData = new FormData();
	
	            console.log(data);
	            for (key in data) {
	              if (key == 'photos') {
	                for (i = 0; i < data[key].length; i++) {
	                  formData.append('photos', data[key][i]);
	                }
	              } else {
	                formData.append(key, data[key]);
	              }
	            }
	            console.log(formData);
	            _context11.next = 6;
	            return fetch(_DomainName2.default.register + 'camps', {
	              method: 'POST',
	              mode: 'cors',
	              headers: { 'x-auth-token': token },
	              body: formData
	            });
	
	          case 6:
	            result = _context11.sent;
	
	            console.log('Success');
	            return _context11.abrupt('return', result.json());
	
	          case 9:
	          case 'end':
	            return _context11.stop();
	        }
	      }
	    }, _callee11, this);
	  }));
	
	  return function AddCamps(_x11) {
	    return _ref11.apply(this, arguments);
	  };
	}();
	
	var AddSports = function () {
	  var _ref12 = _asyncToGenerator(_regenerator2.default.mark(function _callee12(data) {
	    var formData, key, i, result;
	    return _regenerator2.default.wrap(function _callee12$(_context12) {
	      while (1) {
	        switch (_context12.prev = _context12.next) {
	          case 0:
	            formData = new FormData();
	
	            console.log(data);
	            for (key in data) {
	              if (key == 'photos') {
	                for (i = 0; i < data[key].length; i++) {
	                  formData.append('photos', data[key][i]);
	                }
	              } else {
	                formData.append(key, data[key]);
	              }
	            }
	            console.log(formData);
	            _context12.next = 6;
	            return fetch(_DomainName2.default.register + 'admin/hobbies_intrest', {
	              method: 'POST',
	              mode: 'cors',
	              headers: { 'x-auth-token': token },
	              body: formData
	            });
	
	          case 6:
	            result = _context12.sent;
	
	            console.log('Success', result);
	            return _context12.abrupt('return', result.json());
	
	          case 9:
	          case 'end':
	            return _context12.stop();
	        }
	      }
	    }, _callee12, this);
	  }));
	
	  return function AddSports(_x12) {
	    return _ref12.apply(this, arguments);
	  };
	}();
	
	var AddTutions = function () {
	  var _ref13 = _asyncToGenerator(_regenerator2.default.mark(function _callee13(data) {
	    var formData, key, i, result;
	    return _regenerator2.default.wrap(function _callee13$(_context13) {
	      while (1) {
	        switch (_context13.prev = _context13.next) {
	          case 0:
	            formData = new FormData();
	
	            console.log(data);
	            for (key in data) {
	              if (key == 'photos') {
	                for (i = 0; i < data[key].length; i++) {
	                  formData.append('photos', data[key][i]);
	                }
	              } else {
	                formData.append(key, data[key]);
	              }
	            }
	            console.log(formData);
	            _context13.next = 6;
	            return fetch(_DomainName2.default.register + 'tution', {
	              method: 'POST',
	              mode: 'cors',
	              headers: { 'x-auth-token': token },
	              body: formData
	            });
	
	          case 6:
	            result = _context13.sent;
	
	            console.log('Success');
	            return _context13.abrupt('return', result.json());
	
	          case 9:
	          case 'end':
	            return _context13.stop();
	        }
	      }
	    }, _callee13, this);
	  }));
	
	  return function AddTutions(_x13) {
	    return _ref13.apply(this, arguments);
	  };
	}();
	
	var createSchool = function () {
	  var _ref14 = _asyncToGenerator(_regenerator2.default.mark(function _callee14(data) {
	    var formData, key, i, result;
	    return _regenerator2.default.wrap(function _callee14$(_context14) {
	      while (1) {
	        switch (_context14.prev = _context14.next) {
	          case 0:
	            formData = new FormData();
	
	            for (key in data) {
	              if (key == 'photos') {
	                for (i = 0; i < data[key].length; i++) {
	                  formData.append('photos', data[key][i]);
	                }
	              } else {
	                formData.append(key, data[key]);
	              }
	            }
	            _context14.next = 4;
	            return fetch(_DomainName2.default.register + 'admin/schools/add', {
	              method: 'POST',
	              mode: 'cors',
	              headers: { 'x-auth-token': token },
	              body: formData
	            });
	
	          case 4:
	            result = _context14.sent;
	
	            console.log('Success');
	            return _context14.abrupt('return', result.json());
	
	          case 7:
	          case 'end':
	            return _context14.stop();
	        }
	      }
	    }, _callee14, this);
	  }));
	
	  return function createSchool(_x14) {
	    return _ref14.apply(this, arguments);
	  };
	}();
	
	var addPreschool = function () {
	  var _ref15 = _asyncToGenerator(_regenerator2.default.mark(function _callee15(data) {
	    var formData, key, i, result;
	    return _regenerator2.default.wrap(function _callee15$(_context15) {
	      while (1) {
	        switch (_context15.prev = _context15.next) {
	          case 0:
	            formData = new FormData();
	
	            for (key in data) {
	              if (key == 'photos') {
	                for (i = 0; i < data[key].length; i++) {
	                  formData.append('photos', data[key][i]);
	                }
	              } else {
	                formData.append(key, data[key]);
	              }
	            }
	            console.log(formData);
	            _context15.next = 5;
	            return fetch(_DomainName2.default.register + 'preschool', {
	              method: 'POST',
	              mode: 'cors',
	              headers: { 'x-auth-token': token },
	              body: formData
	            });
	
	          case 5:
	            result = _context15.sent;
	
	            console.log('Success');
	            return _context15.abrupt('return', result.json());
	
	          case 8:
	          case 'end':
	            return _context15.stop();
	        }
	      }
	    }, _callee15, this);
	  }));
	
	  return function addPreschool(_x15) {
	    return _ref15.apply(this, arguments);
	  };
	}();
	
	// changes
	
	
	var getSchoolListData = function () {
	  var _ref16 = _asyncToGenerator(_regenerator2.default.mark(function _callee16(data) {
	    var formData, result;
	    return _regenerator2.default.wrap(function _callee16$(_context16) {
	      while (1) {
	        switch (_context16.prev = _context16.next) {
	          case 0:
	            formData = new FormData();
	            // for (let key in data) {
	
	            formData.append('keyword', 'timing');
	            // }
	            console.log(formData);
	            _context16.next = 5;
	            return fetch(_DomainName2.default.register + 'admin/common/get_drop_down', {
	              method: 'POST',
	              mode: 'cors',
	              headers: { 'x-auth-token': token },
	              body: JSON.stringify({
	                keyword: 'timing'
	              })
	            });
	
	          case 5:
	            result = _context16.sent;
	
	            console.log('Success');
	            return _context16.abrupt('return', result.json());
	
	          case 8:
	          case 'end':
	            return _context16.stop();
	        }
	      }
	    }, _callee16, this);
	  }));
	
	  return function getSchoolListData(_x16) {
	    return _ref16.apply(this, arguments);
	  };
	}();
	
	var AddCounselors = function () {
	  var _ref17 = _asyncToGenerator(_regenerator2.default.mark(function _callee17(data) {
	    var formData, key, result;
	    return _regenerator2.default.wrap(function _callee17$(_context17) {
	      while (1) {
	        switch (_context17.prev = _context17.next) {
	          case 0:
	            formData = new FormData();
	
	            console.log('school-data', data);
	            console.log(data);
	            for (key in data) {
	              formData.append(key, data[key]);
	            }
	            console.log('school', formData);
	            _context17.next = 7;
	            return fetch(_DomainName2.default.register + 'admin/advice/add_advice', {
	              method: 'POST',
	              mode: 'cors',
	              headers: { 'x-auth-token': token },
	              body: formData
	            });
	
	          case 7:
	            result = _context17.sent;
	
	            console.log('Success');
	            return _context17.abrupt('return', result.json());
	
	          case 10:
	          case 'end':
	            return _context17.stop();
	        }
	      }
	    }, _callee17, this);
	  }));
	
	  return function AddCounselors(_x17) {
	    return _ref17.apply(this, arguments);
	  };
	}();
	
	var AddNannier = function () {
	  var _ref18 = _asyncToGenerator(_regenerator2.default.mark(function _callee18(data) {
	    var formData, key, i, result;
	    return _regenerator2.default.wrap(function _callee18$(_context18) {
	      while (1) {
	        switch (_context18.prev = _context18.next) {
	          case 0:
	            formData = new FormData();
	
	            console.log(data);
	            for (key in data) {
	              if (key == 'photos') {
	                for (i = 0; i < data[key].length; i++) {
	                  formData.append('photos', data[key][i]);
	                }
	              } else {
	                formData.append(key, data[key]);
	              }
	            }
	            console.log('formData', formData);
	            _context18.next = 6;
	            return fetch(_DomainName2.default.register + 'admin/advice', {
	              method: 'POST',
	              mode: 'cors',
	              headers: { 'x-auth-token': token },
	              body: formData
	            });
	
	          case 6:
	            result = _context18.sent;
	
	            console.log('Success/////');
	            return _context18.abrupt('return', result.json());
	
	          case 9:
	          case 'end':
	            return _context18.stop();
	        }
	      }
	    }, _callee18, this);
	  }));
	
	  return function AddNannier(_x18) {
	    return _ref18.apply(this, arguments);
	  };
	}();
	
	var getAdvicelists = function () {
	  var _ref19 = _asyncToGenerator(_regenerator2.default.mark(function _callee19(data) {
	    var formData, key, result;
	    return _regenerator2.default.wrap(function _callee19$(_context19) {
	      while (1) {
	        switch (_context19.prev = _context19.next) {
	          case 0:
	            formData = new FormData();
	
	            console.log(data);
	            for (key in data) {
	              formData.append(key, data[key]);
	            }
	            console.log('formData', formData);
	            _context19.next = 6;
	            return fetch(_DomainName2.default.register + 'admin/advice/adviceList', {
	              method: 'POST',
	              mode: 'cors',
	              headers: { 'x-auth-token': token },
	              body: formData
	            });
	
	          case 6:
	            result = _context19.sent;
	            return _context19.abrupt('return', result.json());
	
	          case 8:
	          case 'end':
	            return _context19.stop();
	        }
	      }
	    }, _callee19, this);
	  }));
	
	  return function getAdvicelists(_x19) {
	    return _ref19.apply(this, arguments);
	  };
	}();
	
	var preschoolDel = function () {
	  var _ref20 = _asyncToGenerator(_regenerator2.default.mark(function _callee20(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee20$(_context20) {
	      while (1) {
	        switch (_context20.prev = _context20.next) {
	          case 0:
	            _context20.next = 2;
	            return fetch(_DomainName2.default.register + 'preschool/deleteId', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context20.sent;
	
	            console.log('Success');
	            return _context20.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context20.stop();
	        }
	      }
	    }, _callee20, this);
	  }));
	
	  return function preschoolDel(_x20) {
	    return _ref20.apply(this, arguments);
	  };
	}();
	
	var tutionDel = function () {
	  var _ref21 = _asyncToGenerator(_regenerator2.default.mark(function _callee21(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee21$(_context21) {
	      while (1) {
	        switch (_context21.prev = _context21.next) {
	          case 0:
	            _context21.next = 2;
	            return fetch(_DomainName2.default.register + 'tution/deleteId', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context21.sent;
	
	            console.log('Success');
	            return _context21.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context21.stop();
	        }
	      }
	    }, _callee21, this);
	  }));
	
	  return function tutionDel(_x21) {
	    return _ref21.apply(this, arguments);
	  };
	}();
	
	var eventsDel = function () {
	  var _ref22 = _asyncToGenerator(_regenerator2.default.mark(function _callee22(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee22$(_context22) {
	      while (1) {
	        switch (_context22.prev = _context22.next) {
	          case 0:
	            _context22.next = 2;
	            return fetch(_DomainName2.default.register + 'admin/events/deleteId', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context22.sent;
	
	            console.log('Success');
	            return _context22.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context22.stop();
	        }
	      }
	    }, _callee22, this);
	  }));
	
	  return function eventsDel(_x22) {
	    return _ref22.apply(this, arguments);
	  };
	}();
	
	var registerVendorNew = function () {
	  var _ref23 = _asyncToGenerator(_regenerator2.default.mark(function _callee23(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee23$(_context23) {
	      while (1) {
	        switch (_context23.prev = _context23.next) {
	          case 0:
	            _context23.next = 2;
	            return fetch(_DomainName2.default.register + 'login/register_ins_partner_new', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context23.sent;
	
	            console.log('Success');
	            return _context23.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context23.stop();
	        }
	      }
	    }, _callee23, this);
	  }));
	
	  return function registerVendorNew(_x23) {
	    return _ref23.apply(this, arguments);
	  };
	}();
	
	var registerVendor = function () {
	  var _ref24 = _asyncToGenerator(_regenerator2.default.mark(function _callee24(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee24$(_context24) {
	      while (1) {
	        switch (_context24.prev = _context24.next) {
	          case 0:
	            _context24.next = 2;
	            return fetch(_DomainName2.default.register + 'login/register_ins_partner', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context24.sent;
	
	            console.log('Success');
	            return _context24.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context24.stop();
	        }
	      }
	    }, _callee24, this);
	  }));
	
	  return function registerVendor(_x24) {
	    return _ref24.apply(this, arguments);
	  };
	}();
	
	var registerPartnerInd = function () {
	  var _ref25 = _asyncToGenerator(_regenerator2.default.mark(function _callee25(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee25$(_context25) {
	      while (1) {
	        switch (_context25.prev = _context25.next) {
	          case 0:
	            _context25.next = 2;
	            return fetch(_DomainName2.default.register + 'login/register_partner_ind', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context25.sent;
	
	            console.log('Success');
	            return _context25.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context25.stop();
	        }
	      }
	    }, _callee25, this);
	  }));
	
	  return function registerPartnerInd(_x25) {
	    return _ref25.apply(this, arguments);
	  };
	}();
	
	var emailExist = function () {
	  var _ref26 = _asyncToGenerator(_regenerator2.default.mark(function _callee26(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee26$(_context26) {
	      while (1) {
	        switch (_context26.prev = _context26.next) {
	          case 0:
	            _context26.next = 2;
	            return fetch(_DomainName2.default.register + 'login/isEmailExist', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context26.sent;
	
	            console.log('Success');
	            return _context26.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context26.stop();
	        }
	      }
	    }, _callee26, this);
	  }));
	
	  return function emailExist(_x26) {
	    return _ref26.apply(this, arguments);
	  };
	}();
	
	var emailExist_check = function () {
	  var _ref27 = _asyncToGenerator(_regenerator2.default.mark(function _callee27(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee27$(_context27) {
	      while (1) {
	        switch (_context27.prev = _context27.next) {
	          case 0:
	            _context27.next = 2;
	            return fetch(_DomainName2.default.register + 'login/isemailExist_check', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context27.sent;
	
	            console.log('Success');
	            return _context27.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context27.stop();
	        }
	      }
	    }, _callee27, this);
	  }));
	
	  return function emailExist_check(_x27) {
	    return _ref27.apply(this, arguments);
	  };
	}();
	
	var LoginAdmin = function () {
	  var _ref28 = _asyncToGenerator(_regenerator2.default.mark(function _callee28(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee28$(_context28) {
	      while (1) {
	        switch (_context28.prev = _context28.next) {
	          case 0:
	            _context28.next = 2;
	            return fetch(_DomainName2.default.register + 'login/', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context28.sent;
	
	            console.log('Success');
	            return _context28.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context28.stop();
	        }
	      }
	    }, _callee28, this);
	  }));
	
	  return function LoginAdmin(_x28) {
	    return _ref28.apply(this, arguments);
	  };
	}();
	
	var SentOtp = function () {
	  var _ref29 = _asyncToGenerator(_regenerator2.default.mark(function _callee29(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee29$(_context29) {
	      while (1) {
	        switch (_context29.prev = _context29.next) {
	          case 0:
	            _context29.next = 2;
	            return fetch(_DomainName2.default.register + 'login/resendOtp', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context29.sent;
	
	            console.log('Success');
	            return _context29.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context29.stop();
	        }
	      }
	    }, _callee29, this);
	  }));
	
	  return function SentOtp(_x29) {
	    return _ref29.apply(this, arguments);
	  };
	}();
	
	var checkOTP = function () {
	  var _ref30 = _asyncToGenerator(_regenerator2.default.mark(function _callee30(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee30$(_context30) {
	      while (1) {
	        switch (_context30.prev = _context30.next) {
	          case 0:
	            _context30.next = 2;
	            return fetch(_DomainName2.default.register + 'login/checkOtp', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context30.sent;
	
	            console.log('Success');
	            return _context30.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context30.stop();
	        }
	      }
	    }, _callee30, this);
	  }));
	
	  return function checkOTP(_x30) {
	    return _ref30.apply(this, arguments);
	  };
	}();
	
	var deleteSchl = function () {
	  var _ref31 = _asyncToGenerator(_regenerator2.default.mark(function _callee31(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee31$(_context31) {
	      while (1) {
	        switch (_context31.prev = _context31.next) {
	          case 0:
	            _context31.next = 2;
	            return fetch(_DomainName2.default.register + 'school/deleteScl', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context31.sent;
	
	            console.log('Success');
	            return _context31.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context31.stop();
	        }
	      }
	    }, _callee31, this);
	  }));
	
	  return function deleteSchl(_x31) {
	    return _ref31.apply(this, arguments);
	  };
	}();
	
	var deactivateUser = function () {
	  var _ref32 = _asyncToGenerator(_regenerator2.default.mark(function _callee32(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee32$(_context32) {
	      while (1) {
	        switch (_context32.prev = _context32.next) {
	          case 0:
	            console.log(data);
	            _context32.next = 3;
	            return fetch(_DomainName2.default.register + 'admin/common/deactivateUsr', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 3:
	            result = _context32.sent;
	
	            console.log('Success');
	            return _context32.abrupt('return', result.json());
	
	          case 6:
	          case 'end':
	            return _context32.stop();
	        }
	      }
	    }, _callee32, this);
	  }));
	
	  return function deactivateUser(_x32) {
	    return _ref32.apply(this, arguments);
	  };
	}();
	
	var getLocation = function () {
	  var _ref33 = _asyncToGenerator(_regenerator2.default.mark(function _callee33(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee33$(_context33) {
	      while (1) {
	        switch (_context33.prev = _context33.next) {
	          case 0:
	            _context33.next = 2;
	            return fetch(_DomainName2.default.register + 'admin/common/getLocation', {
	              method: 'GET',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              }
	            });
	
	          case 2:
	            result = _context33.sent;
	
	            console.log('Success');
	            return _context33.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context33.stop();
	        }
	      }
	    }, _callee33, this);
	  }));
	
	  return function getLocation(_x33) {
	    return _ref33.apply(this, arguments);
	  };
	}();
	
	var activateUser = function () {
	  var _ref34 = _asyncToGenerator(_regenerator2.default.mark(function _callee34(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee34$(_context34) {
	      while (1) {
	        switch (_context34.prev = _context34.next) {
	          case 0:
	            console.log(data);
	            _context34.next = 3;
	            return fetch(_DomainName2.default.register + 'admin/common/activateUsr', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 3:
	            result = _context34.sent;
	
	            console.log('Success');
	            return _context34.abrupt('return', result.json());
	
	          case 6:
	          case 'end':
	            return _context34.stop();
	        }
	      }
	    }, _callee34, this);
	  }));
	
	  return function activateUser(_x34) {
	    return _ref34.apply(this, arguments);
	  };
	}();
	
	var deletePreSchl = function () {
	  var _ref35 = _asyncToGenerator(_regenerator2.default.mark(function _callee35(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee35$(_context35) {
	      while (1) {
	        switch (_context35.prev = _context35.next) {
	          case 0:
	            _context35.next = 2;
	            return fetch(_DomainName2.default.register + 'preschool/deleteScl', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context35.sent;
	
	            console.log('Success');
	            return _context35.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context35.stop();
	        }
	      }
	    }, _callee35, this);
	  }));
	
	  return function deletePreSchl(_x35) {
	    return _ref35.apply(this, arguments);
	  };
	}();
	
	var deletePlayArea = function () {
	  var _ref36 = _asyncToGenerator(_regenerator2.default.mark(function _callee36(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee36$(_context36) {
	      while (1) {
	        switch (_context36.prev = _context36.next) {
	          case 0:
	            _context36.next = 2;
	            return fetch(_DomainName2.default.register + 'playarea/deleteScl', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context36.sent;
	
	            console.log('Success');
	            return _context36.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context36.stop();
	        }
	      }
	    }, _callee36, this);
	  }));
	
	  return function deletePlayArea(_x36) {
	    return _ref36.apply(this, arguments);
	  };
	}();
	
	var deleteSesCamp = function () {
	  var _ref37 = _asyncToGenerator(_regenerator2.default.mark(function _callee37(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee37$(_context37) {
	      while (1) {
	        switch (_context37.prev = _context37.next) {
	          case 0:
	            _context37.next = 2;
	            return fetch(_DomainName2.default.register + 'camps/deleteScl', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context37.sent;
	
	            console.log('Success');
	            return _context37.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context37.stop();
	        }
	      }
	    }, _callee37, this);
	  }));
	
	  return function deleteSesCamp(_x37) {
	    return _ref37.apply(this, arguments);
	  };
	}();
	
	var adviceDel = function () {
	  var _ref38 = _asyncToGenerator(_regenerator2.default.mark(function _callee38(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee38$(_context38) {
	      while (1) {
	        switch (_context38.prev = _context38.next) {
	          case 0:
	            _context38.next = 2;
	            return fetch(_DomainName2.default.register + 'admin/advice/deleteId', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context38.sent;
	
	            console.log('Success');
	            return _context38.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context38.stop();
	        }
	      }
	    }, _callee38, this);
	  }));
	
	  return function adviceDel(_x38) {
	    return _ref38.apply(this, arguments);
	  };
	}();
	
	var deleteHobby = function () {
	  var _ref39 = _asyncToGenerator(_regenerator2.default.mark(function _callee39(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee39$(_context39) {
	      while (1) {
	        switch (_context39.prev = _context39.next) {
	          case 0:
	            _context39.next = 2;
	            return fetch(_DomainName2.default.register + 'admin/hobbies_intrest/deleteHob', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context39.sent;
	
	            console.log('Success');
	            return _context39.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context39.stop();
	        }
	      }
	    }, _callee39, this);
	  }));
	
	  return function deleteHobby(_x39) {
	    return _ref39.apply(this, arguments);
	  };
	}();
	
	var ForgotPass = function () {
	  var _ref40 = _asyncToGenerator(_regenerator2.default.mark(function _callee40(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee40$(_context40) {
	      while (1) {
	        switch (_context40.prev = _context40.next) {
	          case 0:
	            _context40.next = 2;
	            return fetch(_DomainName2.default.register + 'admin/common/reset_password', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context40.sent;
	
	            console.log('Success');
	            return _context40.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context40.stop();
	        }
	      }
	    }, _callee40, this);
	  }));
	
	  return function ForgotPass(_x40) {
	    return _ref40.apply(this, arguments);
	  };
	}();
	
	var ResetPass = function () {
	  var _ref41 = _asyncToGenerator(_regenerator2.default.mark(function _callee41(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee41$(_context41) {
	      while (1) {
	        switch (_context41.prev = _context41.next) {
	          case 0:
	            _context41.next = 2;
	            return fetch(_DomainName2.default.register + 'admin/common/update_password', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context41.sent;
	
	            console.log('Success');
	            return _context41.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context41.stop();
	        }
	      }
	    }, _callee41, this);
	  }));
	
	  return function ResetPass(_x41) {
	    return _ref41.apply(this, arguments);
	  };
	}();
	
	var changePass = function () {
	  var _ref42 = _asyncToGenerator(_regenerator2.default.mark(function _callee42(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee42$(_context42) {
	      while (1) {
	        switch (_context42.prev = _context42.next) {
	          case 0:
	            _context42.next = 2;
	            return fetch(_DomainName2.default.register + 'admin/common/change_password', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context42.sent;
	
	            console.log('Success');
	            return _context42.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context42.stop();
	        }
	      }
	    }, _callee42, this);
	  }));
	
	  return function changePass(_x42) {
	    return _ref42.apply(this, arguments);
	  };
	}();
	
	var getCatDrop = function () {
	  var _ref43 = _asyncToGenerator(_regenerator2.default.mark(function _callee43(id) {
	    var result;
	    return _regenerator2.default.wrap(function _callee43$(_context43) {
	      while (1) {
	        switch (_context43.prev = _context43.next) {
	          case 0:
	            _context43.next = 2;
	            return fetch(_DomainName2.default.register + 'admin/common/getCateDrop/' + id, {
	              method: 'GET',
	              'x-auth-token': token,
	              mode: 'cors',
	              headers: { 'Content-Type': 'application/json', 'x-auth-token': token }
	            });
	
	          case 2:
	            result = _context43.sent;
	            return _context43.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context43.stop();
	        }
	      }
	    }, _callee43, this);
	  }));
	
	  return function getCatDrop(_x43) {
	    return _ref43.apply(this, arguments);
	  };
	}();
	
	var getStamps = function () {
	  var _ref44 = _asyncToGenerator(_regenerator2.default.mark(function _callee44(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee44$(_context44) {
	      while (1) {
	        switch (_context44.prev = _context44.next) {
	          case 0:
	            _context44.next = 2;
	            return fetch(_DomainName2.default.register + 'stamping/getStamps', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context44.sent;
	            return _context44.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context44.stop();
	        }
	      }
	    }, _callee44, this);
	  }));
	
	  return function getStamps(_x44) {
	    return _ref44.apply(this, arguments);
	  };
	}();
	
	var getSchools = function () {
	  var _ref45 = _asyncToGenerator(_regenerator2.default.mark(function _callee45(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee45$(_context45) {
	      while (1) {
	        switch (_context45.prev = _context45.next) {
	          case 0:
	            _context45.next = 2;
	            return fetch(_DomainName2.default.register + 'school', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context45.sent;
	            return _context45.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context45.stop();
	        }
	      }
	    }, _callee45, this);
	  }));
	
	  return function getSchools(_x45) {
	    return _ref45.apply(this, arguments);
	  };
	}();
	
	var getSchoolsPaged = function () {
	  var _ref46 = _asyncToGenerator(_regenerator2.default.mark(function _callee46(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee46$(_context46) {
	      while (1) {
	        switch (_context46.prev = _context46.next) {
	          case 0:
	            _context46.next = 2;
	            return fetch(_DomainName2.default.register + 'bewiseapi/school/schoolpaged', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context46.sent;
	            return _context46.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context46.stop();
	        }
	      }
	    }, _callee46, this);
	  }));
	
	  return function getSchoolsPaged(_x46) {
	    return _ref46.apply(this, arguments);
	  };
	}();
	
	var getTuitionsPaged = function () {
	  var _ref47 = _asyncToGenerator(_regenerator2.default.mark(function _callee47(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee47$(_context47) {
	      while (1) {
	        switch (_context47.prev = _context47.next) {
	          case 0:
	            _context47.next = 2;
	            return fetch(_DomainName2.default.register + 'bewiseapi/tuition/tuitionpaged', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context47.sent;
	            return _context47.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context47.stop();
	        }
	      }
	    }, _callee47, this);
	  }));
	
	  return function getTuitionsPaged(_x47) {
	    return _ref47.apply(this, arguments);
	  };
	}();
	
	var getPreSchoolsPaged = function () {
	  var _ref48 = _asyncToGenerator(_regenerator2.default.mark(function _callee48(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee48$(_context48) {
	      while (1) {
	        switch (_context48.prev = _context48.next) {
	          case 0:
	            _context48.next = 2;
	            return fetch(_DomainName2.default.register + 'bewiseapi/preschool/preschoolpaged', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context48.sent;
	            return _context48.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context48.stop();
	        }
	      }
	    }, _callee48, this);
	  }));
	
	  return function getPreSchoolsPaged(_x48) {
	    return _ref48.apply(this, arguments);
	  };
	}();
	
	var getAFAPaged = function () {
	  var _ref49 = _asyncToGenerator(_regenerator2.default.mark(function _callee49(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee49$(_context49) {
	      while (1) {
	        switch (_context49.prev = _context49.next) {
	          case 0:
	            _context49.next = 2;
	            return fetch(_DomainName2.default.register + 'bewiseapi/afa/afapaged', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context49.sent;
	            return _context49.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context49.stop();
	        }
	      }
	    }, _callee49, this);
	  }));
	
	  return function getAFAPaged(_x49) {
	    return _ref49.apply(this, arguments);
	  };
	}();
	
	var getCampsPaged = function () {
	  var _ref50 = _asyncToGenerator(_regenerator2.default.mark(function _callee50(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee50$(_context50) {
	      while (1) {
	        switch (_context50.prev = _context50.next) {
	          case 0:
	            _context50.next = 2;
	            return fetch(_DomainName2.default.register + 'bewiseapi/camps/campspaged', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context50.sent;
	            return _context50.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context50.stop();
	        }
	      }
	    }, _callee50, this);
	  }));
	
	  return function getCampsPaged(_x50) {
	    return _ref50.apply(this, arguments);
	  };
	}();
	
	var getCommunityPaged = function () {
	  var _ref51 = _asyncToGenerator(_regenerator2.default.mark(function _callee51(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee51$(_context51) {
	      while (1) {
	        switch (_context51.prev = _context51.next) {
	          case 0:
	            _context51.next = 2;
	            return fetch(_DomainName2.default.register + 'bewiseapi/community/communitypaged', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context51.sent;
	            return _context51.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context51.stop();
	        }
	      }
	    }, _callee51, this);
	  }));
	
	  return function getCommunityPaged(_x51) {
	    return _ref51.apply(this, arguments);
	  };
	}();
	
	var getEventsPaged = function () {
	  var _ref52 = _asyncToGenerator(_regenerator2.default.mark(function _callee52(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee52$(_context52) {
	      while (1) {
	        switch (_context52.prev = _context52.next) {
	          case 0:
	            _context52.next = 2;
	            return fetch(_DomainName2.default.register + 'bewiseapi/events/eventspaged', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context52.sent;
	            return _context52.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context52.stop();
	        }
	      }
	    }, _callee52, this);
	  }));
	
	  return function getEventsPaged(_x52) {
	    return _ref52.apply(this, arguments);
	  };
	}();
	
	var getInsightList = function () {
	  var _ref53 = _asyncToGenerator(_regenerator2.default.mark(function _callee53(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee53$(_context53) {
	      while (1) {
	        switch (_context53.prev = _context53.next) {
	          case 0:
	            _context53.next = 2;
	            return fetch(_DomainName2.default.register + 'bewiseapi/insights/insightspaged', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context53.sent;
	            return _context53.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context53.stop();
	        }
	      }
	    }, _callee53, this);
	  }));
	
	  return function getInsightList(_x53) {
	    return _ref53.apply(this, arguments);
	  };
	}();
	
	var getPreSchools = function () {
	  var _ref54 = _asyncToGenerator(_regenerator2.default.mark(function _callee54(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee54$(_context54) {
	      while (1) {
	        switch (_context54.prev = _context54.next) {
	          case 0:
	            _context54.next = 2;
	            return fetch(_DomainName2.default.register + 'preschool/getList', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context54.sent;
	            return _context54.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context54.stop();
	        }
	      }
	    }, _callee54, this);
	  }));
	
	  return function getPreSchools(_x54) {
	    return _ref54.apply(this, arguments);
	  };
	}();
	
	var getAllPlayareas = function () {
	  var _ref55 = _asyncToGenerator(_regenerator2.default.mark(function _callee55(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee55$(_context55) {
	      while (1) {
	        switch (_context55.prev = _context55.next) {
	          case 0:
	            _context55.next = 2;
	            return fetch(_DomainName2.default.register + 'playarea/getList', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context55.sent;
	            return _context55.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context55.stop();
	        }
	      }
	    }, _callee55, this);
	  }));
	
	  return function getAllPlayareas(_x55) {
	    return _ref55.apply(this, arguments);
	  };
	}();
	
	var getAfterSchools = function () {
	  var _ref56 = _asyncToGenerator(_regenerator2.default.mark(function _callee56(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee56$(_context56) {
	      while (1) {
	        switch (_context56.prev = _context56.next) {
	          case 0:
	            _context56.next = 2;
	            return fetch(_DomainName2.default.register + 'admin/hobbies_intrest/getList', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context56.sent;
	            return _context56.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context56.stop();
	        }
	      }
	    }, _callee56, this);
	  }));
	
	  return function getAfterSchools(_x56) {
	    return _ref56.apply(this, arguments);
	  };
	}();
	
	var getTutionList = function () {
	  var _ref57 = _asyncToGenerator(_regenerator2.default.mark(function _callee57(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee57$(_context57) {
	      while (1) {
	        switch (_context57.prev = _context57.next) {
	          case 0:
	            _context57.next = 2;
	            return fetch(_DomainName2.default.register + 'tution/getList', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context57.sent;
	            return _context57.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context57.stop();
	        }
	      }
	    }, _callee57, this);
	  }));
	
	  return function getTutionList(_x57) {
	    return _ref57.apply(this, arguments);
	  };
	}();
	
	var getEvents = function () {
	  var _ref58 = _asyncToGenerator(_regenerator2.default.mark(function _callee58(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee58$(_context58) {
	      while (1) {
	        switch (_context58.prev = _context58.next) {
	          case 0:
	            _context58.next = 2;
	            return fetch(_DomainName2.default.register + 'admin/events/getList', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context58.sent;
	            return _context58.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context58.stop();
	        }
	      }
	    }, _callee58, this);
	  }));
	
	  return function getEvents(_x58) {
	    return _ref58.apply(this, arguments);
	  };
	}();
	
	var getSeasonalCampList = function () {
	  var _ref59 = _asyncToGenerator(_regenerator2.default.mark(function _callee59(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee59$(_context59) {
	      while (1) {
	        switch (_context59.prev = _context59.next) {
	          case 0:
	            _context59.next = 2;
	            return fetch(_DomainName2.default.register + 'camps/getList', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context59.sent;
	            return _context59.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context59.stop();
	        }
	      }
	    }, _callee59, this);
	  }));
	
	  return function getSeasonalCampList(_x59) {
	    return _ref59.apply(this, arguments);
	  };
	}();
	
	var getCommunitySupport = function () {
	  var _ref60 = _asyncToGenerator(_regenerator2.default.mark(function _callee60(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee60$(_context60) {
	      while (1) {
	        switch (_context60.prev = _context60.next) {
	          case 0:
	            _context60.next = 2;
	            return fetch(_DomainName2.default.register + 'admin/advice/getList', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context60.sent;
	            return _context60.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context60.stop();
	        }
	      }
	    }, _callee60, this);
	  }));
	
	  return function getCommunitySupport(_x60) {
	    return _ref60.apply(this, arguments);
	  };
	}();
	
	var ImportExcelSchool = function () {
	  var _ref61 = _asyncToGenerator(_regenerator2.default.mark(function _callee61(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee61$(_context61) {
	      while (1) {
	        switch (_context61.prev = _context61.next) {
	          case 0:
	            _context61.next = 2;
	            return fetch(_DomainName2.default.register + 'import_excel/schools', {
	              method: 'POST',
	              mode: 'cors',
	              headers: { 'x-auth-token': token },
	              body: data
	            });
	
	          case 2:
	            result = _context61.sent;
	
	            console.log('Success');
	            return _context61.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context61.stop();
	        }
	      }
	    }, _callee61, this);
	  }));
	
	  return function ImportExcelSchool(_x61) {
	    return _ref61.apply(this, arguments);
	  };
	}();
	
	var ImportExcelPreSchool = function () {
	  var _ref62 = _asyncToGenerator(_regenerator2.default.mark(function _callee62(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee62$(_context62) {
	      while (1) {
	        switch (_context62.prev = _context62.next) {
	          case 0:
	            _context62.next = 2;
	            return fetch(_DomainName2.default.register + 'import_excel/preschools', {
	              method: 'POST',
	              mode: 'cors',
	              headers: { 'x-auth-token': token },
	              body: data
	            });
	
	          case 2:
	            result = _context62.sent;
	
	            console.log('Success');
	            return _context62.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context62.stop();
	        }
	      }
	    }, _callee62, this);
	  }));
	
	  return function ImportExcelPreSchool(_x62) {
	    return _ref62.apply(this, arguments);
	  };
	}();
	
	var ImportExcelPlayarea = function () {
	  var _ref63 = _asyncToGenerator(_regenerator2.default.mark(function _callee63(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee63$(_context63) {
	      while (1) {
	        switch (_context63.prev = _context63.next) {
	          case 0:
	            _context63.next = 2;
	            return fetch(_DomainName2.default.register + 'import_excel/playareas', {
	              method: 'POST',
	              mode: 'cors',
	              headers: { 'x-auth-token': token },
	              body: data
	            });
	
	          case 2:
	            result = _context63.sent;
	
	            console.log('Success');
	            return _context63.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context63.stop();
	        }
	      }
	    }, _callee63, this);
	  }));
	
	  return function ImportExcelPlayarea(_x63) {
	    return _ref63.apply(this, arguments);
	  };
	}();
	
	var ImportExcelHobbies = function () {
	  var _ref64 = _asyncToGenerator(_regenerator2.default.mark(function _callee64(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee64$(_context64) {
	      while (1) {
	        switch (_context64.prev = _context64.next) {
	          case 0:
	            _context64.next = 2;
	            return fetch(_DomainName2.default.register + 'import_excel/hobby_interest', {
	              method: 'POST',
	              mode: 'cors',
	              headers: { 'x-auth-token': token },
	              body: data
	            });
	
	          case 2:
	            result = _context64.sent;
	
	            console.log('Success');
	            return _context64.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context64.stop();
	        }
	      }
	    }, _callee64, this);
	  }));
	
	  return function ImportExcelHobbies(_x64) {
	    return _ref64.apply(this, arguments);
	  };
	}();
	
	var ImportExcelTutions = function () {
	  var _ref65 = _asyncToGenerator(_regenerator2.default.mark(function _callee65(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee65$(_context65) {
	      while (1) {
	        switch (_context65.prev = _context65.next) {
	          case 0:
	            _context65.next = 2;
	            return fetch(_DomainName2.default.register + 'import_excel/tutions', {
	              method: 'POST',
	              mode: 'cors',
	              headers: { 'x-auth-token': token },
	              body: data
	            });
	
	          case 2:
	            result = _context65.sent;
	
	            console.log('Success');
	            return _context65.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context65.stop();
	        }
	      }
	    }, _callee65, this);
	  }));
	
	  return function ImportExcelTutions(_x65) {
	    return _ref65.apply(this, arguments);
	  };
	}();
	
	var ImportExcelEvents = function () {
	  var _ref66 = _asyncToGenerator(_regenerator2.default.mark(function _callee66(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee66$(_context66) {
	      while (1) {
	        switch (_context66.prev = _context66.next) {
	          case 0:
	            _context66.next = 2;
	            return fetch(_DomainName2.default.register + 'import_excel/events', {
	              method: 'POST',
	              mode: 'cors',
	              headers: { 'x-auth-token': token },
	              body: data
	            });
	
	          case 2:
	            result = _context66.sent;
	
	            console.log('Success');
	            return _context66.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context66.stop();
	        }
	      }
	    }, _callee66, this);
	  }));
	
	  return function ImportExcelEvents(_x66) {
	    return _ref66.apply(this, arguments);
	  };
	}();
	
	var ImportExcelCamp = function () {
	  var _ref67 = _asyncToGenerator(_regenerator2.default.mark(function _callee67(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee67$(_context67) {
	      while (1) {
	        switch (_context67.prev = _context67.next) {
	          case 0:
	            _context67.next = 2;
	            return fetch(_DomainName2.default.register + 'import_excel/camps', {
	              method: 'POST',
	              mode: 'cors',
	              headers: { 'x-auth-token': token },
	              body: data
	            });
	
	          case 2:
	            result = _context67.sent;
	
	            console.log('Success');
	            return _context67.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context67.stop();
	        }
	      }
	    }, _callee67, this);
	  }));
	
	  return function ImportExcelCamp(_x67) {
	    return _ref67.apply(this, arguments);
	  };
	}();
	
	var ImportExcelCommunity = function () {
	  var _ref68 = _asyncToGenerator(_regenerator2.default.mark(function _callee68(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee68$(_context68) {
	      while (1) {
	        switch (_context68.prev = _context68.next) {
	          case 0:
	            _context68.next = 2;
	            return fetch(_DomainName2.default.register + 'import_excel/community', {
	              method: 'POST',
	              mode: 'cors',
	              headers: { 'x-auth-token': token },
	              body: data
	            });
	
	          case 2:
	            result = _context68.sent;
	
	            console.log('Success');
	            return _context68.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context68.stop();
	        }
	      }
	    }, _callee68, this);
	  }));
	
	  return function ImportExcelCommunity(_x68) {
	    return _ref68.apply(this, arguments);
	  };
	}();
	
	var SubscribeData = function () {
	  var _ref69 = _asyncToGenerator(_regenerator2.default.mark(function _callee69(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee69$(_context69) {
	      while (1) {
	        switch (_context69.prev = _context69.next) {
	          case 0:
	            _context69.next = 2;
	            return fetch(_DomainName2.default.register + 'admin/common/getsubscribe', {
	              method: 'GET',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context69.sent;
	
	            console.log('Success');
	            return _context69.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context69.stop();
	        }
	      }
	    }, _callee69, this);
	  }));
	
	  return function SubscribeData(_x69) {
	    return _ref69.apply(this, arguments);
	  };
	}();
	
	var ContactData = function () {
	  var _ref70 = _asyncToGenerator(_regenerator2.default.mark(function _callee70(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee70$(_context70) {
	      while (1) {
	        switch (_context70.prev = _context70.next) {
	          case 0:
	            _context70.next = 2;
	            return fetch(_DomainName2.default.register + 'admin/common/getcontactus', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context70.sent;
	
	            console.log('Success');
	            return _context70.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context70.stop();
	        }
	      }
	    }, _callee70, this);
	  }));
	
	  return function ContactData(_x70) {
	    return _ref70.apply(this, arguments);
	  };
	}();
	
	var getUserList = function () {
	  var _ref71 = _asyncToGenerator(_regenerator2.default.mark(function _callee71(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee71$(_context71) {
	      while (1) {
	        switch (_context71.prev = _context71.next) {
	          case 0:
	            _context71.next = 2;
	            return fetch(_DomainName2.default.register + 'admin/common/getUser', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context71.sent;
	
	            console.log('Success');
	            return _context71.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context71.stop();
	        }
	      }
	    }, _callee71, this);
	  }));
	
	  return function getUserList(_x71) {
	    return _ref71.apply(this, arguments);
	  };
	}();
	
	var getVendorList = function () {
	  var _ref72 = _asyncToGenerator(_regenerator2.default.mark(function _callee72(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee72$(_context72) {
	      while (1) {
	        switch (_context72.prev = _context72.next) {
	          case 0:
	            _context72.next = 2;
	            return fetch(_DomainName2.default.register + 'admin/common/getVendor', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context72.sent;
	
	            console.log('Success');
	            return _context72.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context72.stop();
	        }
	      }
	    }, _callee72, this);
	  }));
	
	  return function getVendorList(_x72) {
	    return _ref72.apply(this, arguments);
	  };
	}();
	
	var getLocationList = function () {
	  var _ref73 = _asyncToGenerator(_regenerator2.default.mark(function _callee73(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee73$(_context73) {
	      while (1) {
	        switch (_context73.prev = _context73.next) {
	          case 0:
	            _context73.next = 2;
	            return fetch(_DomainName2.default.register + 'admin/common/getLocation', {
	              method: 'GET',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context73.sent;
	
	            console.log('Success');
	            return _context73.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context73.stop();
	        }
	      }
	    }, _callee73, this);
	  }));
	
	  return function getLocationList(_x73) {
	    return _ref73.apply(this, arguments);
	  };
	}();
	
	var getUserInfo = function () {
	  var _ref74 = _asyncToGenerator(_regenerator2.default.mark(function _callee74(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee74$(_context74) {
	      while (1) {
	        switch (_context74.prev = _context74.next) {
	          case 0:
	            _context74.next = 2;
	            return fetch(_DomainName2.default.register + 'admin/common/getUserInfo', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context74.sent;
	
	            console.log('Success');
	            return _context74.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context74.stop();
	        }
	      }
	    }, _callee74, this);
	  }));
	
	  return function getUserInfo(_x74) {
	    return _ref74.apply(this, arguments);
	  };
	}();
	
	var getVendorInfo = function () {
	  var _ref75 = _asyncToGenerator(_regenerator2.default.mark(function _callee75(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee75$(_context75) {
	      while (1) {
	        switch (_context75.prev = _context75.next) {
	          case 0:
	            _context75.next = 2;
	            return fetch(_DomainName2.default.register + 'admin/common/getVendorInfo', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context75.sent;
	
	            console.log('Success');
	            return _context75.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context75.stop();
	        }
	      }
	    }, _callee75, this);
	  }));
	
	  return function getVendorInfo(_x75) {
	    return _ref75.apply(this, arguments);
	  };
	}();
	
	var indResponse = function () {
	  var _ref76 = _asyncToGenerator(_regenerator2.default.mark(function _callee76(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee76$(_context76) {
	      while (1) {
	        switch (_context76.prev = _context76.next) {
	          case 0:
	            _context76.next = 2;
	            return fetch(_DomainName2.default.register + 'login/ind_sendresponse', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context76.sent;
	
	            console.log('Success');
	            return _context76.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context76.stop();
	        }
	      }
	    }, _callee76, this);
	  }));
	
	  return function indResponse(_x76) {
	    return _ref76.apply(this, arguments);
	  };
	}();
	
	var indVerifyLink = function () {
	  var _ref77 = _asyncToGenerator(_regenerator2.default.mark(function _callee77(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee77$(_context77) {
	      while (1) {
	        switch (_context77.prev = _context77.next) {
	          case 0:
	            _context77.next = 2;
	            return fetch(_DomainName2.default.register + 'login/verifypaymentLink', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context77.sent;
	
	            console.log('Success');
	            return _context77.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context77.stop();
	        }
	      }
	    }, _callee77, this);
	  }));
	
	  return function indVerifyLink(_x77) {
	    return _ref77.apply(this, arguments);
	  };
	}();
	
	var indComSignup = function () {
	  var _ref78 = _asyncToGenerator(_regenerator2.default.mark(function _callee78(data) {
	    var formData, key, result;
	    return _regenerator2.default.wrap(function _callee78$(_context78) {
	      while (1) {
	        switch (_context78.prev = _context78.next) {
	          case 0:
	            formData = new FormData();
	
	            for (key in data) {
	              formData.append(key, data[key]);
	            }
	            _context78.next = 4;
	            return fetch(_DomainName2.default.register + 'login/indsignup', {
	              method: 'POST',
	              mode: 'cors',
	              headers: { 'x-auth-token': token },
	              body: formData
	            });
	
	          case 4:
	            result = _context78.sent;
	
	            console.log('Success');
	            return _context78.abrupt('return', result.json());
	
	          case 7:
	          case 'end':
	            return _context78.stop();
	        }
	      }
	    }, _callee78, this);
	  }));
	
	  return function indComSignup(_x78) {
	    return _ref78.apply(this, arguments);
	  };
	}();
	
	var indUploadDocs = function () {
	  var _ref79 = _asyncToGenerator(_regenerator2.default.mark(function _callee79(data) {
	    var formData, key, result;
	    return _regenerator2.default.wrap(function _callee79$(_context79) {
	      while (1) {
	        switch (_context79.prev = _context79.next) {
	          case 0:
	            formData = new FormData();
	
	            for (key in data) {
	              formData.append(key, data[key]);
	            }
	            _context79.next = 4;
	            return fetch(_DomainName2.default.register + 'login/indUploadDocs', {
	              method: 'POST',
	              mode: 'cors',
	              headers: { 'x-auth-token': token },
	              body: formData
	            });
	
	          case 4:
	            result = _context79.sent;
	
	            console.log('Success');
	            return _context79.abrupt('return', result.json());
	
	          case 7:
	          case 'end':
	            return _context79.stop();
	        }
	      }
	    }, _callee79, this);
	  }));
	
	  return function indUploadDocs(_x79) {
	    return _ref79.apply(this, arguments);
	  };
	}();
	
	var getMenu = function () {
	  var _ref80 = _asyncToGenerator(_regenerator2.default.mark(function _callee80(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee80$(_context80) {
	      while (1) {
	        switch (_context80.prev = _context80.next) {
	          case 0:
	            _context80.next = 2;
	            return fetch(_DomainName2.default.register + 'admin/common/getMenu', {
	              method: 'GET',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context80.sent;
	
	            console.log('Success');
	            return _context80.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context80.stop();
	        }
	      }
	    }, _callee80, this);
	  }));
	
	  return function getMenu(_x80) {
	    return _ref80.apply(this, arguments);
	  };
	}();
	
	var AddRole = function () {
	  var _ref81 = _asyncToGenerator(_regenerator2.default.mark(function _callee81(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee81$(_context81) {
	      while (1) {
	        switch (_context81.prev = _context81.next) {
	          case 0:
	            _context81.next = 2;
	            return fetch(_DomainName2.default.register + 'admin/common/addrole_data', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context81.sent;
	
	            console.log('Success');
	            return _context81.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context81.stop();
	        }
	      }
	    }, _callee81, this);
	  }));
	
	  return function AddRole(_x81) {
	    return _ref81.apply(this, arguments);
	  };
	}();
	
	var getRoles = function () {
	  var _ref82 = _asyncToGenerator(_regenerator2.default.mark(function _callee82(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee82$(_context82) {
	      while (1) {
	        switch (_context82.prev = _context82.next) {
	          case 0:
	            _context82.next = 2;
	            return fetch(_DomainName2.default.register + 'admin/common/getRoles', {
	              method: 'GET',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context82.sent;
	
	            console.log('Success');
	            return _context82.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context82.stop();
	        }
	      }
	    }, _callee82, this);
	  }));
	
	  return function getRoles(_x82) {
	    return _ref82.apply(this, arguments);
	  };
	}();
	
	var getRolelist = function () {
	  var _ref83 = _asyncToGenerator(_regenerator2.default.mark(function _callee83(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee83$(_context83) {
	      while (1) {
	        switch (_context83.prev = _context83.next) {
	          case 0:
	            _context83.next = 2;
	            return fetch(_DomainName2.default.register + 'admin/common/getRolelist', {
	              method: 'GET',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context83.sent;
	
	            console.log('Success');
	            return _context83.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context83.stop();
	        }
	      }
	    }, _callee83, this);
	  }));
	
	  return function getRolelist(_x83) {
	    return _ref83.apply(this, arguments);
	  };
	}();
	
	var deleteRole = function () {
	  var _ref84 = _asyncToGenerator(_regenerator2.default.mark(function _callee84(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee84$(_context84) {
	      while (1) {
	        switch (_context84.prev = _context84.next) {
	          case 0:
	            _context84.next = 2;
	            return fetch(_DomainName2.default.register + 'admin/common/deleteRole', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context84.sent;
	
	            console.log('Success');
	            return _context84.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context84.stop();
	        }
	      }
	    }, _callee84, this);
	  }));
	
	  return function deleteRole(_x84) {
	    return _ref84.apply(this, arguments);
	  };
	}();
	
	var EditRoleData = function () {
	  var _ref85 = _asyncToGenerator(_regenerator2.default.mark(function _callee85(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee85$(_context85) {
	      while (1) {
	        switch (_context85.prev = _context85.next) {
	          case 0:
	            _context85.next = 2;
	            return fetch(_DomainName2.default.register + 'admin/common/editRole', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context85.sent;
	
	            console.log('Success');
	            return _context85.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context85.stop();
	        }
	      }
	    }, _callee85, this);
	  }));
	
	  return function EditRoleData(_x85) {
	    return _ref85.apply(this, arguments);
	  };
	}();
	
	var getSubuser = function () {
	  var _ref86 = _asyncToGenerator(_regenerator2.default.mark(function _callee86(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee86$(_context86) {
	      while (1) {
	        switch (_context86.prev = _context86.next) {
	          case 0:
	            _context86.next = 2;
	            return fetch(_DomainName2.default.register + 'admin/common/getSubuser', {
	              method: 'GET',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context86.sent;
	
	            console.log('Success');
	            return _context86.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context86.stop();
	        }
	      }
	    }, _callee86, this);
	  }));
	
	  return function getSubuser(_x86) {
	    return _ref86.apply(this, arguments);
	  };
	}();
	
	var deleteUser = function () {
	  var _ref87 = _asyncToGenerator(_regenerator2.default.mark(function _callee87(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee87$(_context87) {
	      while (1) {
	        switch (_context87.prev = _context87.next) {
	          case 0:
	            _context87.next = 2;
	            return fetch(_DomainName2.default.register + 'admin/common/deleteUser', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context87.sent;
	
	            console.log('Success');
	            return _context87.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context87.stop();
	        }
	      }
	    }, _callee87, this);
	  }));
	
	  return function deleteUser(_x87) {
	    return _ref87.apply(this, arguments);
	  };
	}();
	
	var AddUserData = function () {
	  var _ref88 = _asyncToGenerator(_regenerator2.default.mark(function _callee88(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee88$(_context88) {
	      while (1) {
	        switch (_context88.prev = _context88.next) {
	          case 0:
	            _context88.next = 2;
	            return fetch(_DomainName2.default.register + 'admin/common/adduser_data', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context88.sent;
	
	            console.log('Success');
	            return _context88.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context88.stop();
	        }
	      }
	    }, _callee88, this);
	  }));
	
	  return function AddUserData(_x88) {
	    return _ref88.apply(this, arguments);
	  };
	}();
	
	var AddExclUserData = function () {
	  var _ref89 = _asyncToGenerator(_regenerator2.default.mark(function _callee89(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee89$(_context89) {
	      while (1) {
	        switch (_context89.prev = _context89.next) {
	          case 0:
	            _context89.next = 2;
	            return fetch(_DomainName2.default.register + 'adminuser/addexcluser_data', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context89.sent;
	
	            console.log('Success');
	            return _context89.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context89.stop();
	        }
	      }
	    }, _callee89, this);
	  }));
	
	  return function AddExclUserData(_x89) {
	    return _ref89.apply(this, arguments);
	  };
	}();
	
	var EditSubuserData = function () {
	  var _ref90 = _asyncToGenerator(_regenerator2.default.mark(function _callee90(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee90$(_context90) {
	      while (1) {
	        switch (_context90.prev = _context90.next) {
	          case 0:
	            _context90.next = 2;
	            return fetch(_DomainName2.default.register + 'adminuser/editUser', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context90.sent;
	
	            console.log('Success');
	            return _context90.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context90.stop();
	        }
	      }
	    }, _callee90, this);
	  }));
	
	  return function EditSubuserData(_x90) {
	    return _ref90.apply(this, arguments);
	  };
	}();
	
	var editExclUser = function () {
	  var _ref91 = _asyncToGenerator(_regenerator2.default.mark(function _callee91(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee91$(_context91) {
	      while (1) {
	        switch (_context91.prev = _context91.next) {
	          case 0:
	            _context91.next = 2;
	            return fetch(_DomainName2.default.register + 'adminuser/editExclUser', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context91.sent;
	
	            console.log('Success');
	            return _context91.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context91.stop();
	        }
	      }
	    }, _callee91, this);
	  }));
	
	  return function editExclUser(_x91) {
	    return _ref91.apply(this, arguments);
	  };
	}();
	
	var verifyLogin = function () {
	  var _ref92 = _asyncToGenerator(_regenerator2.default.mark(function _callee92(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee92$(_context92) {
	      while (1) {
	        switch (_context92.prev = _context92.next) {
	          case 0:
	            _context92.next = 2;
	            return fetch(_DomainName2.default.register + 'login/verifylogin', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context92.sent;
	            return _context92.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context92.stop();
	        }
	      }
	    }, _callee92, this);
	  }));
	
	  return function verifyLogin(_x92) {
	    return _ref92.apply(this, arguments);
	  };
	}();
	
	var getPlan = function () {
	  var _ref93 = _asyncToGenerator(_regenerator2.default.mark(function _callee93(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee93$(_context93) {
	      while (1) {
	        switch (_context93.prev = _context93.next) {
	          case 0:
	            _context93.next = 2;
	            return fetch(_DomainName2.default.register + 'packages/getPlan', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context93.sent;
	            return _context93.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context93.stop();
	        }
	      }
	    }, _callee93, this);
	  }));
	
	  return function getPlan(_x93) {
	    return _ref93.apply(this, arguments);
	  };
	}();
	
	var CreatePay = function () {
	  var _ref94 = _asyncToGenerator(_regenerator2.default.mark(function _callee94(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee94$(_context94) {
	      while (1) {
	        switch (_context94.prev = _context94.next) {
	          case 0:
	            _context94.next = 2;
	            return fetch(_DomainName2.default.register + 'admin/common/orders', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context94.sent;
	
	            console.log('Success');
	            return _context94.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context94.stop();
	        }
	      }
	    }, _callee94, this);
	  }));
	
	  return function CreatePay(_x94) {
	    return _ref94.apply(this, arguments);
	  };
	}();
	
	var ProfileUpdate = function () {
	  var _ref95 = _asyncToGenerator(_regenerator2.default.mark(function _callee95(data) {
	    var formData, key, i, result;
	    return _regenerator2.default.wrap(function _callee95$(_context95) {
	      while (1) {
	        switch (_context95.prev = _context95.next) {
	          case 0:
	            formData = new FormData();
	
	            for (key in data) {
	              if (key == 'photos') {
	                for (i = 0; i < data[key].length; i++) {
	                  formData.append('photos', data[key][i]);
	                }
	              } else {
	                formData.append(key, data[key]);
	              }
	            }
	            _context95.next = 4;
	            return fetch(_DomainName2.default.register + 'admin/schools/update_profile', {
	              method: 'POST',
	              mode: 'cors',
	              headers: { 'x-auth-token': token },
	              body: formData
	            });
	
	          case 4:
	            result = _context95.sent;
	
	            console.log('Success');
	            return _context95.abrupt('return', result.json());
	
	          case 7:
	          case 'end':
	            return _context95.stop();
	        }
	      }
	    }, _callee95, this);
	  }));
	
	  return function ProfileUpdate(_x95) {
	    return _ref95.apply(this, arguments);
	  };
	}();
	
	var getTransactionList = function () {
	  var _ref96 = _asyncToGenerator(_regenerator2.default.mark(function _callee96(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee96$(_context96) {
	      while (1) {
	        switch (_context96.prev = _context96.next) {
	          case 0:
	            _context96.next = 2;
	            return fetch(_DomainName2.default.register + 'admin_transaction/getTransaction', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context96.sent;
	
	            console.log('Success');
	            return _context96.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context96.stop();
	        }
	      }
	    }, _callee96, this);
	  }));
	
	  return function getTransactionList(_x96) {
	    return _ref96.apply(this, arguments);
	  };
	}();
	
	var getInvoiceInfo = function () {
	  var _ref97 = _asyncToGenerator(_regenerator2.default.mark(function _callee97(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee97$(_context97) {
	      while (1) {
	        switch (_context97.prev = _context97.next) {
	          case 0:
	            _context97.next = 2;
	            return fetch(_DomainName2.default.register + 'admin_transaction/getInvoice', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context97.sent;
	
	            console.log('Success');
	            return _context97.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context97.stop();
	        }
	      }
	    }, _callee97, this);
	  }));
	
	  return function getInvoiceInfo(_x97) {
	    return _ref97.apply(this, arguments);
	  };
	}();
	
	var getPartnerDetails = function () {
	  var _ref98 = _asyncToGenerator(_regenerator2.default.mark(function _callee98(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee98$(_context98) {
	      while (1) {
	        switch (_context98.prev = _context98.next) {
	          case 0:
	            _context98.next = 2;
	            return fetch(_DomainName2.default.register + 'admin/schools/partner', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context98.sent;
	
	            console.log('Success');
	            return _context98.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context98.stop();
	        }
	      }
	    }, _callee98, this);
	  }));
	
	  return function getPartnerDetails(_x98) {
	    return _ref98.apply(this, arguments);
	  };
	}();
	
	var getCatList = function () {
	  var _ref99 = _asyncToGenerator(_regenerator2.default.mark(function _callee99(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee99$(_context99) {
	      while (1) {
	        switch (_context99.prev = _context99.next) {
	          case 0:
	            _context99.next = 2;
	            return fetch(_DomainName2.default.register + 'admin/common/getcategory_list', {
	              method: 'GET',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context99.sent;
	
	            console.log('Success');
	            return _context99.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context99.stop();
	        }
	      }
	    }, _callee99, this);
	  }));
	
	  return function getCatList(_x99) {
	    return _ref99.apply(this, arguments);
	  };
	}();
	
	var approveVendorInfo = function () {
	  var _ref100 = _asyncToGenerator(_regenerator2.default.mark(function _callee100(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee100$(_context100) {
	      while (1) {
	        switch (_context100.prev = _context100.next) {
	          case 0:
	            _context100.next = 2;
	            return fetch(_DomainName2.default.register + 'admin/common/approve_vendor', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context100.sent;
	
	            console.log('Success');
	            return _context100.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context100.stop();
	        }
	      }
	    }, _callee100, this);
	  }));
	
	  return function approveVendorInfo(_x100) {
	    return _ref100.apply(this, arguments);
	  };
	}();
	
	var approveVendorInfoCurated = function () {
	  var _ref101 = _asyncToGenerator(_regenerator2.default.mark(function _callee101(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee101$(_context101) {
	      while (1) {
	        switch (_context101.prev = _context101.next) {
	          case 0:
	            _context101.next = 2;
	            return fetch(_DomainName2.default.register + 'admin/common/approve_vendor_curated', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context101.sent;
	
	            console.log('Success');
	            return _context101.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context101.stop();
	        }
	      }
	    }, _callee101, this);
	  }));
	
	  return function approveVendorInfoCurated(_x101) {
	    return _ref101.apply(this, arguments);
	  };
	}();
	
	var getCommentList = function () {
	  var _ref102 = _asyncToGenerator(_regenerator2.default.mark(function _callee102(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee102$(_context102) {
	      while (1) {
	        switch (_context102.prev = _context102.next) {
	          case 0:
	            _context102.next = 2;
	            return fetch(_DomainName2.default.register + 'admin/common/comments_vendor', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context102.sent;
	
	            console.log('Success');
	            return _context102.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context102.stop();
	        }
	      }
	    }, _callee102, this);
	  }));
	
	  return function getCommentList(_x102) {
	    return _ref102.apply(this, arguments);
	  };
	}();
	
	var getEnquiriesList = function () {
	  var _ref103 = _asyncToGenerator(_regenerator2.default.mark(function _callee103(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee103$(_context103) {
	      while (1) {
	        switch (_context103.prev = _context103.next) {
	          case 0:
	            _context103.next = 2;
	            return fetch(_DomainName2.default.register + 'admin/common/enquiries', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context103.sent;
	
	            console.log('Success');
	            return _context103.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context103.stop();
	        }
	      }
	    }, _callee103, this);
	  }));
	
	  return function getEnquiriesList(_x103) {
	    return _ref103.apply(this, arguments);
	  };
	}();
	
	var getRatingList = function () {
	  var _ref104 = _asyncToGenerator(_regenerator2.default.mark(function _callee104(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee104$(_context104) {
	      while (1) {
	        switch (_context104.prev = _context104.next) {
	          case 0:
	            _context104.next = 2;
	            return fetch(_DomainName2.default.register + 'admin/common/rating_vendor', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context104.sent;
	
	            console.log('Success');
	            return _context104.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context104.stop();
	        }
	      }
	    }, _callee104, this);
	  }));
	
	  return function getRatingList(_x104) {
	    return _ref104.apply(this, arguments);
	  };
	}();
	
	var rejectVendorInfo = function () {
	  var _ref105 = _asyncToGenerator(_regenerator2.default.mark(function _callee105(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee105$(_context105) {
	      while (1) {
	        switch (_context105.prev = _context105.next) {
	          case 0:
	            _context105.next = 2;
	            return fetch(_DomainName2.default.register + 'admin/common/reject_vendor', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context105.sent;
	
	            console.log('Success');
	            return _context105.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context105.stop();
	        }
	      }
	    }, _callee105, this);
	  }));
	
	  return function rejectVendorInfo(_x105) {
	    return _ref105.apply(this, arguments);
	  };
	}();
	
	var vendorDashboard = function () {
	  var _ref106 = _asyncToGenerator(_regenerator2.default.mark(function _callee106(data) {
	    var t, result;
	    return _regenerator2.default.wrap(function _callee106$(_context106) {
	      while (1) {
	        switch (_context106.prev = _context106.next) {
	          case 0:
	            console.log('**f', JSON.parse(data));
	            t = JSON.parse(data);
	            _context106.next = 4;
	            return fetch(_DomainName2.default.register + 'admin/dasboard_venodr/' + t.url, {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 4:
	            result = _context106.sent;
	
	            console.log('Success');
	            return _context106.abrupt('return', result.json());
	
	          case 7:
	          case 'end':
	            return _context106.stop();
	        }
	      }
	    }, _callee106, this);
	  }));
	
	  return function vendorDashboard(_x106) {
	    return _ref106.apply(this, arguments);
	  };
	}();
	
	var adminDashboard = function () {
	  var _ref107 = _asyncToGenerator(_regenerator2.default.mark(function _callee107(data) {
	    var t, result;
	    return _regenerator2.default.wrap(function _callee107$(_context107) {
	      while (1) {
	        switch (_context107.prev = _context107.next) {
	          case 0:
	            console.log('**f', JSON.parse(data));
	            t = JSON.parse(data);
	            _context107.next = 4;
	            return fetch(_DomainName2.default.register + 'admin/dasboard_admin/' + t.url, {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 4:
	            result = _context107.sent;
	
	            console.log('Success');
	            return _context107.abrupt('return', result.json());
	
	          case 7:
	          case 'end':
	            return _context107.stop();
	        }
	      }
	    }, _callee107, this);
	  }));
	
	  return function adminDashboard(_x107) {
	    return _ref107.apply(this, arguments);
	  };
	}();
	
	var getDiscount = function () {
	  var _ref108 = _asyncToGenerator(_regenerator2.default.mark(function _callee108(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee108$(_context108) {
	      while (1) {
	        switch (_context108.prev = _context108.next) {
	          case 0:
	            _context108.next = 2;
	            return fetch(_DomainName2.default.register + 'admin/common/getDiscount', {
	              method: 'GET',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context108.sent;
	
	            console.log('Success');
	            return _context108.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context108.stop();
	        }
	      }
	    }, _callee108, this);
	  }));
	
	  return function getDiscount(_x108) {
	    return _ref108.apply(this, arguments);
	  };
	}();
	
	var EditDiscountData = function () {
	  var _ref109 = _asyncToGenerator(_regenerator2.default.mark(function _callee109(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee109$(_context109) {
	      while (1) {
	        switch (_context109.prev = _context109.next) {
	          case 0:
	            _context109.next = 2;
	            return fetch(_DomainName2.default.register + 'admin/common/editDis', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context109.sent;
	
	            console.log('Success');
	            return _context109.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context109.stop();
	        }
	      }
	    }, _callee109, this);
	  }));
	
	  return function EditDiscountData(_x109) {
	    return _ref109.apply(this, arguments);
	  };
	}();
	
	var AddDiscount = function () {
	  var _ref110 = _asyncToGenerator(_regenerator2.default.mark(function _callee110(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee110$(_context110) {
	      while (1) {
	        switch (_context110.prev = _context110.next) {
	          case 0:
	            _context110.next = 2;
	            return fetch(_DomainName2.default.register + 'admin/common/adddiscount_data', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context110.sent;
	
	            console.log('Success');
	            return _context110.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context110.stop();
	        }
	      }
	    }, _callee110, this);
	  }));
	
	  return function AddDiscount(_x110) {
	    return _ref110.apply(this, arguments);
	  };
	}();
	
	var getContactServiceList = function () {
	  var _ref111 = _asyncToGenerator(_regenerator2.default.mark(function _callee111(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee111$(_context111) {
	      while (1) {
	        switch (_context111.prev = _context111.next) {
	          case 0:
	            _context111.next = 2;
	            return fetch(_DomainName2.default.register + 'admin/dasboard_venodr/service_provider_report', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context111.sent;
	
	            console.log('Success');
	            return _context111.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context111.stop();
	        }
	      }
	    }, _callee111, this);
	  }));
	
	  return function getContactServiceList(_x111) {
	    return _ref111.apply(this, arguments);
	  };
	}();
	
	var getDeviceAccess = function () {
	  var _ref112 = _asyncToGenerator(_regenerator2.default.mark(function _callee112(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee112$(_context112) {
	      while (1) {
	        switch (_context112.prev = _context112.next) {
	          case 0:
	            _context112.next = 2;
	            return fetch(_DomainName2.default.register + 'admin/dasboard_venodr/device_report', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context112.sent;
	
	            console.log('Success');
	            return _context112.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context112.stop();
	        }
	      }
	    }, _callee112, this);
	  }));
	
	  return function getDeviceAccess(_x112) {
	    return _ref112.apply(this, arguments);
	  };
	}();
	
	var getWishList = function () {
	  var _ref113 = _asyncToGenerator(_regenerator2.default.mark(function _callee113(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee113$(_context113) {
	      while (1) {
	        switch (_context113.prev = _context113.next) {
	          case 0:
	            _context113.next = 2;
	            return fetch(_DomainName2.default.register + 'admin/dasboard_venodr/wishlist_report', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context113.sent;
	
	            console.log('Success');
	            return _context113.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context113.stop();
	        }
	      }
	    }, _callee113, this);
	  }));
	
	  return function getWishList(_x113) {
	    return _ref113.apply(this, arguments);
	  };
	}();
	
	var commonAPI = function () {
	  var _ref114 = _asyncToGenerator(_regenerator2.default.mark(function _callee114(data) {
	    var t, result;
	    return _regenerator2.default.wrap(function _callee114$(_context114) {
	      while (1) {
	        switch (_context114.prev = _context114.next) {
	          case 0:
	            t = JSON.parse(data);
	            _context114.next = 3;
	            return fetch(_DomainName2.default.register + 'admin/common/' + t.url, {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 3:
	            result = _context114.sent;
	            return _context114.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context114.stop();
	        }
	      }
	    }, _callee114, this);
	  }));
	
	  return function commonAPI(_x114) {
	    return _ref114.apply(this, arguments);
	  };
	}();
	
	var UpdateVendorPlan = function () {
	  var _ref115 = _asyncToGenerator(_regenerator2.default.mark(function _callee115(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee115$(_context115) {
	      while (1) {
	        switch (_context115.prev = _context115.next) {
	          case 0:
	            _context115.next = 2;
	            return fetch(_DomainName2.default.register + 'login/updatevendorplan', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context115.sent;
	
	            console.log('Success');
	            return _context115.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context115.stop();
	        }
	      }
	    }, _callee115, this);
	  }));
	
	  return function UpdateVendorPlan(_x115) {
	    return _ref115.apply(this, arguments);
	  };
	}();
	
	var updategallery = function () {
	  var _ref116 = _asyncToGenerator(_regenerator2.default.mark(function _callee116(data) {
	    var formData, key, i, result;
	    return _regenerator2.default.wrap(function _callee116$(_context116) {
	      while (1) {
	        switch (_context116.prev = _context116.next) {
	          case 0:
	            console.log('data', data);
	            formData = new FormData();
	
	            for (key in data) {
	              if (key == 'photos') {
	                for (i = 0; i < data[key].length; i++) {
	                  formData.append('photos', data[key][i]);
	                }
	              } else {
	                formData.append(key, data[key]);
	              }
	            }
	            _context116.next = 5;
	            return fetch(_DomainName2.default.register + 'admin/partnerapi/updategallery', {
	              method: 'POST',
	              mode: 'cors',
	              headers: { 'x-auth-token': token },
	              body: formData
	            });
	
	          case 5:
	            result = _context116.sent;
	
	            console.log('Success');
	            return _context116.abrupt('return', result.json());
	
	          case 8:
	          case 'end':
	            return _context116.stop();
	        }
	      }
	    }, _callee116, this);
	  }));
	
	  return function updategallery(_x116) {
	    return _ref116.apply(this, arguments);
	  };
	}();
	
	var updateVideo = function () {
	  var _ref117 = _asyncToGenerator(_regenerator2.default.mark(function _callee117(data) {
	    var formData, key, result;
	    return _regenerator2.default.wrap(function _callee117$(_context117) {
	      while (1) {
	        switch (_context117.prev = _context117.next) {
	          case 0:
	            console.log('data', data);
	            formData = new FormData();
	
	            for (key in data) {
	              formData.append(key, data[key]);
	            }
	            _context117.next = 5;
	            return fetch(_DomainName2.default.register + 'admin/partnerapi/update_video', {
	              method: 'POST',
	              mode: 'cors',
	              headers: { 'x-auth-token': token },
	              body: formData
	            });
	
	          case 5:
	            result = _context117.sent;
	
	            console.log('Success');
	            return _context117.abrupt('return', result.json());
	
	          case 8:
	          case 'end':
	            return _context117.stop();
	        }
	      }
	    }, _callee117, this);
	  }));
	
	  return function updateVideo(_x117) {
	    return _ref117.apply(this, arguments);
	  };
	}();
	
	var signUpApi = function () {
	  var _ref118 = _asyncToGenerator(_regenerator2.default.mark(function _callee118(data) {
	    var t, result;
	    return _regenerator2.default.wrap(function _callee118$(_context118) {
	      while (1) {
	        switch (_context118.prev = _context118.next) {
	          case 0:
	            t = JSON.parse(data);
	            _context118.next = 3;
	            return fetch(_DomainName2.default.register + 'admin/signup/' + t.url, {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 3:
	            result = _context118.sent;
	            return _context118.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context118.stop();
	        }
	      }
	    }, _callee118, this);
	  }));
	
	  return function signUpApi(_x118) {
	    return _ref118.apply(this, arguments);
	  };
	}();
	
	var partnerApi = function () {
	  var _ref119 = _asyncToGenerator(_regenerator2.default.mark(function _callee119(data) {
	    var t, result;
	    return _regenerator2.default.wrap(function _callee119$(_context119) {
	      while (1) {
	        switch (_context119.prev = _context119.next) {
	          case 0:
	            t = JSON.parse(data);
	            _context119.next = 3;
	            return fetch(_DomainName2.default.register + 'admin/partnerapi/' + t.url, {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 3:
	            result = _context119.sent;
	            return _context119.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context119.stop();
	        }
	      }
	    }, _callee119, this);
	  }));
	
	  return function partnerApi(_x119) {
	    return _ref119.apply(this, arguments);
	  };
	}();
	
	var partnerDocupload = function () {
	  var _ref120 = _asyncToGenerator(_regenerator2.default.mark(function _callee120(data) {
	    var formData, key, result;
	    return _regenerator2.default.wrap(function _callee120$(_context120) {
	      while (1) {
	        switch (_context120.prev = _context120.next) {
	          case 0:
	            formData = new FormData();
	
	            for (key in data) {
	              formData.append(key, data[key]);
	            }
	            _context120.next = 4;
	            return fetch(_DomainName2.default.register + 'admin/partnerapi/updatepDocs', {
	              method: 'POST',
	              mode: 'cors',
	              headers: { 'x-auth-token': token },
	              body: formData
	            });
	
	          case 4:
	            result = _context120.sent;
	
	            console.log('Success');
	            return _context120.abrupt('return', result.json());
	
	          case 7:
	          case 'end':
	            return _context120.stop();
	        }
	      }
	    }, _callee120, this);
	  }));
	
	  return function partnerDocupload(_x120) {
	    return _ref120.apply(this, arguments);
	  };
	}();
	
	var partnerBranch = function () {
	  var _ref121 = _asyncToGenerator(_regenerator2.default.mark(function _callee121(data) {
	    var t, result;
	    return _regenerator2.default.wrap(function _callee121$(_context121) {
	      while (1) {
	        switch (_context121.prev = _context121.next) {
	          case 0:
	            t = JSON.parse(data);
	            _context121.next = 3;
	            return fetch(_DomainName2.default.register + 'partnerbranch/' + t.url, {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 3:
	            result = _context121.sent;
	            return _context121.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context121.stop();
	        }
	      }
	    }, _callee121, this);
	  }));
	
	  return function partnerBranch(_x121) {
	    return _ref121.apply(this, arguments);
	  };
	}();
	
	var getAllverticalData = function () {
	  var _ref122 = _asyncToGenerator(_regenerator2.default.mark(function _callee122(data) {
	    var t, result;
	    return _regenerator2.default.wrap(function _callee122$(_context122) {
	      while (1) {
	        switch (_context122.prev = _context122.next) {
	          case 0:
	            t = JSON.parse(data);
	            _context122.next = 3;
	            return fetch(_DomainName2.default.register + 'admin/partnerapi/' + t.url, {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 3:
	            result = _context122.sent;
	            return _context122.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context122.stop();
	        }
	      }
	    }, _callee122, this);
	  }));
	
	  return function getAllverticalData(_x122) {
	    return _ref122.apply(this, arguments);
	  };
	}();
	
	var getAllcategoryData = function () {
	  var _ref123 = _asyncToGenerator(_regenerator2.default.mark(function _callee123(data) {
	    var t, result;
	    return _regenerator2.default.wrap(function _callee123$(_context123) {
	      while (1) {
	        switch (_context123.prev = _context123.next) {
	          case 0:
	            t = JSON.parse(data);
	            _context123.next = 3;
	            return fetch(_DomainName2.default.register + 'admin/partnerapi/fetchcategoryslugs', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 3:
	            result = _context123.sent;
	            return _context123.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context123.stop();
	        }
	      }
	    }, _callee123, this);
	  }));
	
	  return function getAllcategoryData(_x123) {
	    return _ref123.apply(this, arguments);
	  };
	}();
	
	var bewiseuserExport = function () {
	  var _ref124 = _asyncToGenerator(_regenerator2.default.mark(function _callee124(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee124$(_context124) {
	      while (1) {
	        switch (_context124.prev = _context124.next) {
	          case 0:
	            _context124.next = 2;
	            return fetch(_DomainName2.default.register + 'admin/common/bewiseuserExport', {
	              method: 'GET',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context124.sent;
	
	            console.log('Success');
	            return _context124.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context124.stop();
	        }
	      }
	    }, _callee124, this);
	  }));
	
	  return function bewiseuserExport(_x124) {
	    return _ref124.apply(this, arguments);
	  };
	}();
	
	var userExport = function () {
	  var _ref125 = _asyncToGenerator(_regenerator2.default.mark(function _callee125(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee125$(_context125) {
	      while (1) {
	        switch (_context125.prev = _context125.next) {
	          case 0:
	            _context125.next = 2;
	            return fetch(_DomainName2.default.register + 'admin/common/userExport', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context125.sent;
	
	            console.log('Success');
	            return _context125.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context125.stop();
	        }
	      }
	    }, _callee125, this);
	  }));
	
	  return function userExport(_x125) {
	    return _ref125.apply(this, arguments);
	  };
	}();
	
	var vendorExport = function () {
	  var _ref126 = _asyncToGenerator(_regenerator2.default.mark(function _callee126(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee126$(_context126) {
	      while (1) {
	        switch (_context126.prev = _context126.next) {
	          case 0:
	            _context126.next = 2;
	            return fetch(_DomainName2.default.register + 'admin/common/vendorExport', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context126.sent;
	
	            console.log('Success');
	            return _context126.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context126.stop();
	        }
	      }
	    }, _callee126, this);
	  }));
	
	  return function vendorExport(_x126) {
	    return _ref126.apply(this, arguments);
	  };
	}();
	
	var contactUserExport = function () {
	  var _ref127 = _asyncToGenerator(_regenerator2.default.mark(function _callee127(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee127$(_context127) {
	      while (1) {
	        switch (_context127.prev = _context127.next) {
	          case 0:
	            _context127.next = 2;
	            return fetch(_DomainName2.default.register + 'admin/common/contactUserExport', {
	              method: 'GET',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context127.sent;
	
	            console.log('Success');
	            return _context127.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context127.stop();
	        }
	      }
	    }, _callee127, this);
	  }));
	
	  return function contactUserExport(_x127) {
	    return _ref127.apply(this, arguments);
	  };
	}();
	
	var contactPartnerExport = function () {
	  var _ref128 = _asyncToGenerator(_regenerator2.default.mark(function _callee128(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee128$(_context128) {
	      while (1) {
	        switch (_context128.prev = _context128.next) {
	          case 0:
	            _context128.next = 2;
	            return fetch(_DomainName2.default.register + 'admin/common/contactPartnerExport', {
	              method: 'GET',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context128.sent;
	
	            console.log('Success');
	            return _context128.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context128.stop();
	        }
	      }
	    }, _callee128, this);
	  }));
	
	  return function contactPartnerExport(_x128) {
	    return _ref128.apply(this, arguments);
	  };
	}();
	
	var transactionExport = function () {
	  var _ref129 = _asyncToGenerator(_regenerator2.default.mark(function _callee129(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee129$(_context129) {
	      while (1) {
	        switch (_context129.prev = _context129.next) {
	          case 0:
	            _context129.next = 2;
	            return fetch(_DomainName2.default.register + 'admin/common/transactionExport', {
	              method: 'GET',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context129.sent;
	
	            console.log('Success');
	            return _context129.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context129.stop();
	        }
	      }
	    }, _callee129, this);
	  }));
	
	  return function transactionExport(_x129) {
	    return _ref129.apply(this, arguments);
	  };
	}();
	
	var subExport = function () {
	  var _ref130 = _asyncToGenerator(_regenerator2.default.mark(function _callee130(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee130$(_context130) {
	      while (1) {
	        switch (_context130.prev = _context130.next) {
	          case 0:
	            _context130.next = 2;
	            return fetch(_DomainName2.default.register + 'admin/common/subExport', {
	              method: 'GET',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context130.sent;
	
	            console.log('Success');
	            return _context130.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context130.stop();
	        }
	      }
	    }, _callee130, this);
	  }));
	
	  return function subExport(_x130) {
	    return _ref130.apply(this, arguments);
	  };
	}();
	
	var CSPExport = function () {
	  var _ref131 = _asyncToGenerator(_regenerator2.default.mark(function _callee131(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee131$(_context131) {
	      while (1) {
	        switch (_context131.prev = _context131.next) {
	          case 0:
	            _context131.next = 2;
	            return fetch(_DomainName2.default.register + 'admin/common/CSPExport', {
	              method: 'GET',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context131.sent;
	
	            console.log('Success');
	            return _context131.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context131.stop();
	        }
	      }
	    }, _callee131, this);
	  }));
	
	  return function CSPExport(_x131) {
	    return _ref131.apply(this, arguments);
	  };
	}();
	
	var DAFExport = function () {
	  var _ref132 = _asyncToGenerator(_regenerator2.default.mark(function _callee132(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee132$(_context132) {
	      while (1) {
	        switch (_context132.prev = _context132.next) {
	          case 0:
	            _context132.next = 2;
	            return fetch(_DomainName2.default.register + 'admin/common/DAFExport', {
	              method: 'GET',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context132.sent;
	
	            console.log('Success');
	            return _context132.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context132.stop();
	        }
	      }
	    }, _callee132, this);
	  }));
	
	  return function DAFExport(_x132) {
	    return _ref132.apply(this, arguments);
	  };
	}();
	
	var WishExport = function () {
	  var _ref133 = _asyncToGenerator(_regenerator2.default.mark(function _callee133(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee133$(_context133) {
	      while (1) {
	        switch (_context133.prev = _context133.next) {
	          case 0:
	            _context133.next = 2;
	            return fetch(_DomainName2.default.register + 'admin/common/WishExport', {
	              method: 'GET',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context133.sent;
	
	            console.log('Success');
	            return _context133.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context133.stop();
	        }
	      }
	    }, _callee133, this);
	  }));
	
	  return function WishExport(_x133) {
	    return _ref133.apply(this, arguments);
	  };
	}();
	
	var RatingExport = function () {
	  var _ref134 = _asyncToGenerator(_regenerator2.default.mark(function _callee134(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee134$(_context134) {
	      while (1) {
	        switch (_context134.prev = _context134.next) {
	          case 0:
	            _context134.next = 2;
	            return fetch(_DomainName2.default.register + 'admin/common/RatingExport', {
	              method: 'GET',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context134.sent;
	
	            console.log('Success');
	            return _context134.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context134.stop();
	        }
	      }
	    }, _callee134, this);
	  }));
	
	  return function RatingExport(_x134) {
	    return _ref134.apply(this, arguments);
	  };
	}();
	
	var getVideoListAdmin = function () {
	  var _ref135 = _asyncToGenerator(_regenerator2.default.mark(function _callee135(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee135$(_context135) {
	      while (1) {
	        switch (_context135.prev = _context135.next) {
	          case 0:
	            _context135.next = 2;
	            return fetch(_DomainName2.default.register + 'adminvideo/get_video_list', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context135.sent;
	            return _context135.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context135.stop();
	        }
	      }
	    }, _callee135, this);
	  }));
	
	  return function getVideoListAdmin(_x135) {
	    return _ref135.apply(this, arguments);
	  };
	}();
	
	var getVideoDataAdmin = function () {
	  var _ref136 = _asyncToGenerator(_regenerator2.default.mark(function _callee136(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee136$(_context136) {
	      while (1) {
	        switch (_context136.prev = _context136.next) {
	          case 0:
	            _context136.next = 2;
	            return fetch(_DomainName2.default.register + 'adminvideo/edit_video', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context136.sent;
	            return _context136.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context136.stop();
	        }
	      }
	    }, _callee136, this);
	  }));
	
	  return function getVideoDataAdmin(_x136) {
	    return _ref136.apply(this, arguments);
	  };
	}();
	
	var updateAdminVideo = function () {
	  var _ref137 = _asyncToGenerator(_regenerator2.default.mark(function _callee137(data) {
	    var formData, key, result;
	    return _regenerator2.default.wrap(function _callee137$(_context137) {
	      while (1) {
	        switch (_context137.prev = _context137.next) {
	          case 0:
	            formData = new FormData();
	
	            for (key in data) {
	              formData.append(key, data[key]);
	            }
	            console.log('formData', data, formData);
	            _context137.next = 5;
	            return fetch(_DomainName2.default.register + 'adminvideo/update_video', {
	              method: 'POST',
	              mode: 'cors',
	              headers: { 'x-auth-token': token },
	              body: formData
	            });
	
	          case 5:
	            result = _context137.sent;
	
	            console.log('Success');
	            return _context137.abrupt('return', result.json());
	
	          case 8:
	          case 'end':
	            return _context137.stop();
	        }
	      }
	    }, _callee137, this);
	  }));
	
	  return function updateAdminVideo(_x137) {
	    return _ref137.apply(this, arguments);
	  };
	}();
	
	var getInsightDetail = function () {
	  var _ref138 = _asyncToGenerator(_regenerator2.default.mark(function _callee138(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee138$(_context138) {
	      while (1) {
	        switch (_context138.prev = _context138.next) {
	          case 0:
	            _context138.next = 2;
	            return fetch(_DomainName2.default.register + 'insights/edit_insight', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context138.sent;
	            return _context138.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context138.stop();
	        }
	      }
	    }, _callee138, this);
	  }));
	
	  return function getInsightDetail(_x138) {
	    return _ref138.apply(this, arguments);
	  };
	}();
	
	var getPageDetail = function () {
	  var _ref139 = _asyncToGenerator(_regenerator2.default.mark(function _callee139(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee139$(_context139) {
	      while (1) {
	        switch (_context139.prev = _context139.next) {
	          case 0:
	            _context139.next = 2;
	            return fetch(_DomainName2.default.register + 'cms/get_page', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context139.sent;
	            return _context139.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context139.stop();
	        }
	      }
	    }, _callee139, this);
	  }));
	
	  return function getPageDetail(_x139) {
	    return _ref139.apply(this, arguments);
	  };
	}();
	
	var updatePage = function () {
	  var _ref140 = _asyncToGenerator(_regenerator2.default.mark(function _callee140(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee140$(_context140) {
	      while (1) {
	        switch (_context140.prev = _context140.next) {
	          case 0:
	            _context140.next = 2;
	            return fetch(_DomainName2.default.register + 'cms/update_page', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context140.sent;
	            return _context140.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context140.stop();
	        }
	      }
	    }, _callee140, this);
	  }));
	
	  return function updatePage(_x140) {
	    return _ref140.apply(this, arguments);
	  };
	}();
	
	var approvePage = function () {
	  var _ref141 = _asyncToGenerator(_regenerator2.default.mark(function _callee141(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee141$(_context141) {
	      while (1) {
	        switch (_context141.prev = _context141.next) {
	          case 0:
	            _context141.next = 2;
	            return fetch(_DomainName2.default.register + 'cms/approve_page', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context141.sent;
	            return _context141.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context141.stop();
	        }
	      }
	    }, _callee141, this);
	  }));
	
	  return function approvePage(_x141) {
	    return _ref141.apply(this, arguments);
	  };
	}();
	
	var getAuthorSuggest = function () {
	  var _ref142 = _asyncToGenerator(_regenerator2.default.mark(function _callee142(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee142$(_context142) {
	      while (1) {
	        switch (_context142.prev = _context142.next) {
	          case 0:
	            _context142.next = 2;
	            return fetch(_DomainName2.default.register + 'insights/get_author', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context142.sent;
	            return _context142.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context142.stop();
	        }
	      }
	    }, _callee142, this);
	  }));
	
	  return function getAuthorSuggest(_x142) {
	    return _ref142.apply(this, arguments);
	  };
	}();
	
	var updateInsights = function () {
	  var _ref143 = _asyncToGenerator(_regenerator2.default.mark(function _callee143(data) {
	    var formData, key, result;
	    return _regenerator2.default.wrap(function _callee143$(_context143) {
	      while (1) {
	        switch (_context143.prev = _context143.next) {
	          case 0:
	            formData = new FormData();
	
	            for (key in data) {
	              formData.append(key, data[key]);
	            }
	            console.log('formData', data, formData);
	            _context143.next = 5;
	            return fetch(_DomainName2.default.register + 'insights/update_insight', {
	              method: 'POST',
	              mode: 'cors',
	              headers: { 'x-auth-token': token },
	              body: formData
	            });
	
	          case 5:
	            result = _context143.sent;
	
	            console.log('Success');
	            return _context143.abrupt('return', result.json());
	
	          case 8:
	          case 'end':
	            return _context143.stop();
	        }
	      }
	    }, _callee143, this);
	  }));
	
	  return function updateInsights(_x143) {
	    return _ref143.apply(this, arguments);
	  };
	}();
	
	var uploadArticleImage = function () {
	  var _ref144 = _asyncToGenerator(_regenerator2.default.mark(function _callee144(data) {
	    var formData, key, i, result;
	    return _regenerator2.default.wrap(function _callee144$(_context144) {
	      while (1) {
	        switch (_context144.prev = _context144.next) {
	          case 0:
	            formData = new FormData();
	
	            for (key in data) {
	              if (key == 'article_images') {
	                for (i = 0; i < data[key].length; i++) {
	                  formData.append('article_images', data[key][i]);
	                }
	              } else {
	                formData.append(key, data[key]);
	              }
	            }
	            console.log('formData', data, formData);
	            _context144.next = 5;
	            return fetch(_DomainName2.default.register + 'insights/uploadarticle_image', {
	              method: 'POST',
	              mode: 'cors',
	              headers: { 'x-auth-token': token },
	              body: formData
	            });
	
	          case 5:
	            result = _context144.sent;
	
	            console.log('Success');
	            return _context144.abrupt('return', result.json());
	
	          case 8:
	          case 'end':
	            return _context144.stop();
	        }
	      }
	    }, _callee144, this);
	  }));
	
	  return function uploadArticleImage(_x144) {
	    return _ref144.apply(this, arguments);
	  };
	}();
	
	var uploadArticleImages = function () {
	  var _ref145 = _asyncToGenerator(_regenerator2.default.mark(function _callee145(data) {
	    var formData, key, i, result;
	    return _regenerator2.default.wrap(function _callee145$(_context145) {
	      while (1) {
	        switch (_context145.prev = _context145.next) {
	          case 0:
	            formData = new FormData();
	
	            for (key in data) {
	              if (key == 'article_images') {
	                for (i = 0; i < data[key].length; i++) {
	                  formData.append('article_images', data[key][i]);
	                }
	              } else {
	                formData.append(key, data[key]);
	              }
	            }
	            console.log('formData', data, formData);
	            _context145.next = 5;
	            return fetch(_DomainName2.default.register + 'insights/uploadarticle_images', {
	              method: 'POST',
	              mode: 'cors',
	              headers: { 'x-auth-token': token },
	              body: formData
	            });
	
	          case 5:
	            result = _context145.sent;
	
	            console.log('Success');
	            return _context145.abrupt('return', result.json());
	
	          case 8:
	          case 'end':
	            return _context145.stop();
	        }
	      }
	    }, _callee145, this);
	  }));
	
	  return function uploadArticleImages(_x145) {
	    return _ref145.apply(this, arguments);
	  };
	}();
	
	var removeInsight = function () {
	  var _ref146 = _asyncToGenerator(_regenerator2.default.mark(function _callee146(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee146$(_context146) {
	      while (1) {
	        switch (_context146.prev = _context146.next) {
	          case 0:
	            _context146.next = 2;
	            return fetch(_DomainName2.default.register + 'insights/delete_insight', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context146.sent;
	            return _context146.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context146.stop();
	        }
	      }
	    }, _callee146, this);
	  }));
	
	  return function removeInsight(_x146) {
	    return _ref146.apply(this, arguments);
	  };
	}();
	
	var insightApi = function () {
	  var _ref147 = _asyncToGenerator(_regenerator2.default.mark(function _callee147(data) {
	    var t, result;
	    return _regenerator2.default.wrap(function _callee147$(_context147) {
	      while (1) {
	        switch (_context147.prev = _context147.next) {
	          case 0:
	            t = JSON.parse(data);
	            _context147.next = 3;
	            return fetch(_DomainName2.default.register + 'insights/' + t.url, {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 3:
	            result = _context147.sent;
	            return _context147.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context147.stop();
	        }
	      }
	    }, _callee147, this);
	  }));
	
	  return function insightApi(_x147) {
	    return _ref147.apply(this, arguments);
	  };
	}();
	
	var benchApi = function () {
	  var _ref148 = _asyncToGenerator(_regenerator2.default.mark(function _callee148(data) {
	    var t, result;
	    return _regenerator2.default.wrap(function _callee148$(_context148) {
	      while (1) {
	        switch (_context148.prev = _context148.next) {
	          case 0:
	            t = JSON.parse(data);
	            _context148.next = 3;
	            return fetch(_DomainName2.default.register + 'benchmark/' + t.url, {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 3:
	            result = _context148.sent;
	            return _context148.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context148.stop();
	        }
	      }
	    }, _callee148, this);
	  }));
	
	  return function benchApi(_x148) {
	    return _ref148.apply(this, arguments);
	  };
	}();
	
	var getPackageList = function () {
	  var _ref149 = _asyncToGenerator(_regenerator2.default.mark(function _callee149(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee149$(_context149) {
	      while (1) {
	        switch (_context149.prev = _context149.next) {
	          case 0:
	            _context149.next = 2;
	            return fetch(_DomainName2.default.register + 'packages/get_package_list', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context149.sent;
	            return _context149.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context149.stop();
	        }
	      }
	    }, _callee149, this);
	  }));
	
	  return function getPackageList(_x149) {
	    return _ref149.apply(this, arguments);
	  };
	}();
	
	var removePackage = function () {
	  var _ref150 = _asyncToGenerator(_regenerator2.default.mark(function _callee150(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee150$(_context150) {
	      while (1) {
	        switch (_context150.prev = _context150.next) {
	          case 0:
	            _context150.next = 2;
	            return fetch(_DomainName2.default.register + 'packages/delete_package', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context150.sent;
	            return _context150.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context150.stop();
	        }
	      }
	    }, _callee150, this);
	  }));
	
	  return function removePackage(_x150) {
	    return _ref150.apply(this, arguments);
	  };
	}();
	
	var getPackageDetail = function () {
	  var _ref151 = _asyncToGenerator(_regenerator2.default.mark(function _callee151(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee151$(_context151) {
	      while (1) {
	        switch (_context151.prev = _context151.next) {
	          case 0:
	            _context151.next = 2;
	            return fetch(_DomainName2.default.register + 'packages/package_details', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context151.sent;
	            return _context151.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context151.stop();
	        }
	      }
	    }, _callee151, this);
	  }));
	
	  return function getPackageDetail(_x151) {
	    return _ref151.apply(this, arguments);
	  };
	}();
	
	var updatePackageData = function () {
	  var _ref152 = _asyncToGenerator(_regenerator2.default.mark(function _callee152(data) {
	    var formData, key, result;
	    return _regenerator2.default.wrap(function _callee152$(_context152) {
	      while (1) {
	        switch (_context152.prev = _context152.next) {
	          case 0:
	            formData = new FormData();
	
	            for (key in data) {
	              formData.append(key, data[key]);
	            }
	            console.log('formData', data, formData);
	            _context152.next = 5;
	            return fetch(_DomainName2.default.register + 'packages/update_package', {
	              method: 'POST',
	              mode: 'cors',
	              headers: { 'x-auth-token': token },
	              body: formData
	            });
	
	          case 5:
	            result = _context152.sent;
	
	            console.log('Success');
	            return _context152.abrupt('return', result.json());
	
	          case 8:
	          case 'end':
	            return _context152.stop();
	        }
	      }
	    }, _callee152, this);
	  }));
	
	  return function updatePackageData(_x152) {
	    return _ref152.apply(this, arguments);
	  };
	}();
	
	var getPackageType = function () {
	  var _ref153 = _asyncToGenerator(_regenerator2.default.mark(function _callee153(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee153$(_context153) {
	      while (1) {
	        switch (_context153.prev = _context153.next) {
	          case 0:
	            _context153.next = 2;
	            return fetch(_DomainName2.default.register + 'packages/get_package_type_list', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context153.sent;
	            return _context153.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context153.stop();
	        }
	      }
	    }, _callee153, this);
	  }));
	
	  return function getPackageType(_x153) {
	    return _ref153.apply(this, arguments);
	  };
	}();
	
	var taxdata = function () {
	  var _ref154 = _asyncToGenerator(_regenerator2.default.mark(function _callee154(data) {
	    var t, result;
	    return _regenerator2.default.wrap(function _callee154$(_context154) {
	      while (1) {
	        switch (_context154.prev = _context154.next) {
	          case 0:
	            t = JSON.parse(data);
	            _context154.next = 3;
	            return fetch(_DomainName2.default.register + 'tax/' + t.url, {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 3:
	            result = _context154.sent;
	            return _context154.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context154.stop();
	        }
	      }
	    }, _callee154, this);
	  }));
	
	  return function taxdata(_x154) {
	    return _ref154.apply(this, arguments);
	  };
	}();
	
	var promodata = function () {
	  var _ref155 = _asyncToGenerator(_regenerator2.default.mark(function _callee155(data) {
	    var t, result;
	    return _regenerator2.default.wrap(function _callee155$(_context155) {
	      while (1) {
	        switch (_context155.prev = _context155.next) {
	          case 0:
	            t = JSON.parse(data);
	            _context155.next = 3;
	            return fetch(_DomainName2.default.register + 'promo/' + t.url, {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 3:
	            result = _context155.sent;
	            return _context155.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context155.stop();
	        }
	      }
	    }, _callee155, this);
	  }));
	
	  return function promodata(_x155) {
	    return _ref155.apply(this, arguments);
	  };
	}();
	
	var eventResource = function () {
	  var _ref156 = _asyncToGenerator(_regenerator2.default.mark(function _callee156(data) {
	    var t, result;
	    return _regenerator2.default.wrap(function _callee156$(_context156) {
	      while (1) {
	        switch (_context156.prev = _context156.next) {
	          case 0:
	            t = JSON.parse(data);
	            _context156.next = 3;
	            return fetch(_DomainName2.default.register + 'eventresource/' + t.url, {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 3:
	            result = _context156.sent;
	            return _context156.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context156.stop();
	        }
	      }
	    }, _callee156, this);
	  }));
	
	  return function eventResource(_x156) {
	    return _ref156.apply(this, arguments);
	  };
	}();
	
	var updateResource = function () {
	  var _ref157 = _asyncToGenerator(_regenerator2.default.mark(function _callee157(data) {
	    var formData, key, result;
	    return _regenerator2.default.wrap(function _callee157$(_context157) {
	      while (1) {
	        switch (_context157.prev = _context157.next) {
	          case 0:
	            formData = new FormData();
	
	            for (key in data) {
	              formData.append(key, data[key]);
	            }
	            console.log('formData', data, formData);
	            _context157.next = 5;
	            return fetch(_DomainName2.default.register + 'eventresource/update_resource', {
	              method: 'POST',
	              mode: 'cors',
	              headers: { 'x-auth-token': token },
	              body: formData
	            });
	
	          case 5:
	            result = _context157.sent;
	
	            console.log('Success');
	            return _context157.abrupt('return', result.json());
	
	          case 8:
	          case 'end':
	            return _context157.stop();
	        }
	      }
	    }, _callee157, this);
	  }));
	
	  return function updateResource(_x157) {
	    return _ref157.apply(this, arguments);
	  };
	}();
	
	var exportPreschool = function () {
	  var _ref158 = _asyncToGenerator(_regenerator2.default.mark(function _callee158(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee158$(_context158) {
	      while (1) {
	        switch (_context158.prev = _context158.next) {
	          case 0:
	            _context158.next = 2;
	            return fetch(_DomainName2.default.register + 'import_excel/exportPreschool', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context158.sent;
	
	            console.log('Success');
	            return _context158.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context158.stop();
	        }
	      }
	    }, _callee158, this);
	  }));
	
	  return function exportPreschool(_x158) {
	    return _ref158.apply(this, arguments);
	  };
	}();
	
	var exportSchool = function () {
	  var _ref159 = _asyncToGenerator(_regenerator2.default.mark(function _callee159(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee159$(_context159) {
	      while (1) {
	        switch (_context159.prev = _context159.next) {
	          case 0:
	            _context159.next = 2;
	            return fetch(_DomainName2.default.register + 'import_excel/exportSchool', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context159.sent;
	
	            console.log('Success');
	            return _context159.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context159.stop();
	        }
	      }
	    }, _callee159, this);
	  }));
	
	  return function exportSchool(_x159) {
	    return _ref159.apply(this, arguments);
	  };
	}();
	
	var exportKidsplayArea = function () {
	  var _ref160 = _asyncToGenerator(_regenerator2.default.mark(function _callee160(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee160$(_context160) {
	      while (1) {
	        switch (_context160.prev = _context160.next) {
	          case 0:
	            _context160.next = 2;
	            return fetch(_DomainName2.default.register + 'import_excel/exportKidsplayArea', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context160.sent;
	
	            console.log('Success');
	            return _context160.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context160.stop();
	        }
	      }
	    }, _callee160, this);
	  }));
	
	  return function exportKidsplayArea(_x160) {
	    return _ref160.apply(this, arguments);
	  };
	}();
	
	var exportAfterschool = function () {
	  var _ref161 = _asyncToGenerator(_regenerator2.default.mark(function _callee161(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee161$(_context161) {
	      while (1) {
	        switch (_context161.prev = _context161.next) {
	          case 0:
	            _context161.next = 2;
	            return fetch(_DomainName2.default.register + 'import_excel/exportAfterschool', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context161.sent;
	
	            console.log('Success');
	            return _context161.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context161.stop();
	        }
	      }
	    }, _callee161, this);
	  }));
	
	  return function exportAfterschool(_x161) {
	    return _ref161.apply(this, arguments);
	  };
	}();
	
	var exportTuition = function () {
	  var _ref162 = _asyncToGenerator(_regenerator2.default.mark(function _callee162(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee162$(_context162) {
	      while (1) {
	        switch (_context162.prev = _context162.next) {
	          case 0:
	            _context162.next = 2;
	            return fetch(_DomainName2.default.register + 'import_excel/exportTuition', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context162.sent;
	
	            console.log('Success');
	            return _context162.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context162.stop();
	        }
	      }
	    }, _callee162, this);
	  }));
	
	  return function exportTuition(_x162) {
	    return _ref162.apply(this, arguments);
	  };
	}();
	
	var exportLearningcamps = function () {
	  var _ref163 = _asyncToGenerator(_regenerator2.default.mark(function _callee163(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee163$(_context163) {
	      while (1) {
	        switch (_context163.prev = _context163.next) {
	          case 0:
	            _context163.next = 2;
	            return fetch(_DomainName2.default.register + 'import_excel/exportLearningcamps', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context163.sent;
	
	            console.log('Success');
	            return _context163.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context163.stop();
	        }
	      }
	    }, _callee163, this);
	  }));
	
	  return function exportLearningcamps(_x163) {
	    return _ref163.apply(this, arguments);
	  };
	}();
	
	var exportCommunitysupport = function () {
	  var _ref164 = _asyncToGenerator(_regenerator2.default.mark(function _callee164(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee164$(_context164) {
	      while (1) {
	        switch (_context164.prev = _context164.next) {
	          case 0:
	            _context164.next = 2;
	            return fetch(_DomainName2.default.register + 'import_excel/exportCommunitysupport', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context164.sent;
	
	            console.log('Success');
	            return _context164.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context164.stop();
	        }
	      }
	    }, _callee164, this);
	  }));
	
	  return function exportCommunitysupport(_x164) {
	    return _ref164.apply(this, arguments);
	  };
	}();
	
	var exportBirthdayEvents = function () {
	  var _ref165 = _asyncToGenerator(_regenerator2.default.mark(function _callee165(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee165$(_context165) {
	      while (1) {
	        switch (_context165.prev = _context165.next) {
	          case 0:
	            _context165.next = 2;
	            return fetch(_DomainName2.default.register + 'import_excel/exportBirthdayEvents', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context165.sent;
	
	            console.log('Success');
	            return _context165.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context165.stop();
	        }
	      }
	    }, _callee165, this);
	  }));
	
	  return function exportBirthdayEvents(_x165) {
	    return _ref165.apply(this, arguments);
	  };
	}();
	
	var subPartner = function () {
	  var _ref166 = _asyncToGenerator(_regenerator2.default.mark(function _callee166(data) {
	    var t, result;
	    return _regenerator2.default.wrap(function _callee166$(_context166) {
	      while (1) {
	        switch (_context166.prev = _context166.next) {
	          case 0:
	            t = JSON.parse(data);
	            _context166.next = 3;
	            return fetch(_DomainName2.default.register + 'subpartner/' + t.url, {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 3:
	            result = _context166.sent;
	            return _context166.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context166.stop();
	        }
	      }
	    }, _callee166, this);
	  }));
	
	  return function subPartner(_x166) {
	    return _ref166.apply(this, arguments);
	  };
	}();
	
	var partnerCategory = function () {
	  var _ref167 = _asyncToGenerator(_regenerator2.default.mark(function _callee167(data) {
	    var t, result;
	    return _regenerator2.default.wrap(function _callee167$(_context167) {
	      while (1) {
	        switch (_context167.prev = _context167.next) {
	          case 0:
	            t = JSON.parse(data);
	            _context167.next = 3;
	            return fetch(_DomainName2.default.register + 'partnercategory/' + t.url, {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 3:
	            result = _context167.sent;
	            return _context167.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context167.stop();
	        }
	      }
	    }, _callee167, this);
	  }));
	
	  return function partnerCategory(_x167) {
	    return _ref167.apply(this, arguments);
	  };
	}();
	
	var partnerMainCategory = function () {
	  var _ref168 = _asyncToGenerator(_regenerator2.default.mark(function _callee168(data) {
	    var t, result;
	    return _regenerator2.default.wrap(function _callee168$(_context168) {
	      while (1) {
	        switch (_context168.prev = _context168.next) {
	          case 0:
	            t = JSON.parse(data);
	            _context168.next = 3;
	            return fetch(_DomainName2.default.register + 'partnercategory/' + t.url, {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 3:
	            result = _context168.sent;
	            return _context168.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context168.stop();
	        }
	      }
	    }, _callee168, this);
	  }));
	
	  return function partnerMainCategory(_x168) {
	    return _ref168.apply(this, arguments);
	  };
	}();
	
	var partnerSubCategories = function () {
	  var _ref169 = _asyncToGenerator(_regenerator2.default.mark(function _callee169(data) {
	    var t, result;
	    return _regenerator2.default.wrap(function _callee169$(_context169) {
	      while (1) {
	        switch (_context169.prev = _context169.next) {
	          case 0:
	            t = JSON.parse(data);
	            _context169.next = 3;
	            return fetch(_DomainName2.default.register + 'partnercategory/' + t.url, {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 3:
	            result = _context169.sent;
	            return _context169.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context169.stop();
	        }
	      }
	    }, _callee169, this);
	  }));
	
	  return function partnerSubCategories(_x169) {
	    return _ref169.apply(this, arguments);
	  };
	}();
	
	var partnerAfaCategory = function () {
	  var _ref170 = _asyncToGenerator(_regenerator2.default.mark(function _callee170(data) {
	    var t, result;
	    return _regenerator2.default.wrap(function _callee170$(_context170) {
	      while (1) {
	        switch (_context170.prev = _context170.next) {
	          case 0:
	            t = JSON.parse(data);
	            _context170.next = 3;
	            return fetch(_DomainName2.default.register + 'partnercategory/' + t.url, {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 3:
	            result = _context170.sent;
	            return _context170.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context170.stop();
	        }
	      }
	    }, _callee170, this);
	  }));
	
	  return function partnerAfaCategory(_x170) {
	    return _ref170.apply(this, arguments);
	  };
	}();
	
	var updateRemoveCategory = function () {
	  var _ref171 = _asyncToGenerator(_regenerator2.default.mark(function _callee171(data) {
	    var t, result;
	    return _regenerator2.default.wrap(function _callee171$(_context171) {
	      while (1) {
	        switch (_context171.prev = _context171.next) {
	          case 0:
	            t = JSON.parse(data);
	            _context171.next = 3;
	            return fetch(_DomainName2.default.register + 'partnercategory/' + t.url, {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 3:
	            result = _context171.sent;
	            return _context171.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context171.stop();
	        }
	      }
	    }, _callee171, this);
	  }));
	
	  return function updateRemoveCategory(_x171) {
	    return _ref171.apply(this, arguments);
	  };
	}();
	
	var adminRoles = function () {
	  var _ref172 = _asyncToGenerator(_regenerator2.default.mark(function _callee172(data) {
	    var t, result;
	    return _regenerator2.default.wrap(function _callee172$(_context172) {
	      while (1) {
	        switch (_context172.prev = _context172.next) {
	          case 0:
	            t = JSON.parse(data);
	            _context172.next = 3;
	            return fetch(_DomainName2.default.register + 'roles/' + t.url, {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 3:
	            result = _context172.sent;
	            return _context172.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context172.stop();
	        }
	      }
	    }, _callee172, this);
	  }));
	
	  return function adminRoles(_x172) {
	    return _ref172.apply(this, arguments);
	  };
	}();
	
	var partnerSubscription = function () {
	  var _ref173 = _asyncToGenerator(_regenerator2.default.mark(function _callee173(data) {
	    var t, result;
	    return _regenerator2.default.wrap(function _callee173$(_context173) {
	      while (1) {
	        switch (_context173.prev = _context173.next) {
	          case 0:
	            t = JSON.parse(data);
	            _context173.next = 3;
	            return fetch(_DomainName2.default.register + 'partnersubscription/' + t.url, {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 3:
	            result = _context173.sent;
	            return _context173.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context173.stop();
	        }
	      }
	    }, _callee173, this);
	  }));
	
	  return function partnerSubscription(_x173) {
	    return _ref173.apply(this, arguments);
	  };
	}();
	
	var partnerSubscriptionV1 = function () {
	  var _ref174 = _asyncToGenerator(_regenerator2.default.mark(function _callee174(data) {
	    var t, result;
	    return _regenerator2.default.wrap(function _callee174$(_context174) {
	      while (1) {
	        switch (_context174.prev = _context174.next) {
	          case 0:
	            t = JSON.parse(data);
	            _context174.next = 3;
	            return fetch(_DomainName2.default.register + 'partnersubscription/getcurrentsubscription', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 3:
	            result = _context174.sent;
	            return _context174.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context174.stop();
	        }
	      }
	    }, _callee174, this);
	  }));
	
	  return function partnerSubscriptionV1(_x174) {
	    return _ref174.apply(this, arguments);
	  };
	}();
	
	var getPartnerSubscriptions = function () {
	  var _ref175 = _asyncToGenerator(_regenerator2.default.mark(function _callee175(data) {
	    var t, result;
	    return _regenerator2.default.wrap(function _callee175$(_context175) {
	      while (1) {
	        switch (_context175.prev = _context175.next) {
	          case 0:
	            t = JSON.parse(data);
	            _context175.next = 3;
	            return fetch(_DomainName2.default.register + 'partnersubscription/getallsubscription', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 3:
	            result = _context175.sent;
	            return _context175.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context175.stop();
	        }
	      }
	    }, _callee175, this);
	  }));
	
	  return function getPartnerSubscriptions(_x175) {
	    return _ref175.apply(this, arguments);
	  };
	}();
	
	var adminExclUser = function () {
	  var _ref176 = _asyncToGenerator(_regenerator2.default.mark(function _callee176(data) {
	    var t, result;
	    return _regenerator2.default.wrap(function _callee176$(_context176) {
	      while (1) {
	        switch (_context176.prev = _context176.next) {
	          case 0:
	            t = JSON.parse(data);
	            _context176.next = 3;
	            return fetch(_DomainName2.default.register + 'adminuser/' + t.url, {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 3:
	            result = _context176.sent;
	
	            console.log('Success');
	            return _context176.abrupt('return', result.json());
	
	          case 6:
	          case 'end':
	            return _context176.stop();
	        }
	      }
	    }, _callee176, this);
	  }));
	
	  return function adminExclUser(_x176) {
	    return _ref176.apply(this, arguments);
	  };
	}();
	
	var adminUser = function () {
	  var _ref177 = _asyncToGenerator(_regenerator2.default.mark(function _callee177(data) {
	    var t, result;
	    return _regenerator2.default.wrap(function _callee177$(_context177) {
	      while (1) {
	        switch (_context177.prev = _context177.next) {
	          case 0:
	            t = JSON.parse(data);
	            _context177.next = 3;
	            return fetch(_DomainName2.default.register + 'adminuser/' + t.url, {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 3:
	            result = _context177.sent;
	
	            console.log('Success');
	            return _context177.abrupt('return', result.json());
	
	          case 6:
	          case 'end':
	            return _context177.stop();
	        }
	      }
	    }, _callee177, this);
	  }));
	
	  return function adminUser(_x177) {
	    return _ref177.apply(this, arguments);
	  };
	}();
	
	var adminPriceChart = function () {
	  var _ref178 = _asyncToGenerator(_regenerator2.default.mark(function _callee178(data) {
	    var t, result;
	    return _regenerator2.default.wrap(function _callee178$(_context178) {
	      while (1) {
	        switch (_context178.prev = _context178.next) {
	          case 0:
	            t = JSON.parse(data);
	            _context178.next = 3;
	            return fetch(_DomainName2.default.register + 'adminpricechart/' + t.url, {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 3:
	            result = _context178.sent;
	
	            console.log('Success');
	            return _context178.abrupt('return', result.json());
	
	          case 6:
	          case 'end':
	            return _context178.stop();
	        }
	      }
	    }, _callee178, this);
	  }));
	
	  return function adminPriceChart(_x178) {
	    return _ref178.apply(this, arguments);
	  };
	}();
	
	var pNotification = function () {
	  var _ref179 = _asyncToGenerator(_regenerator2.default.mark(function _callee179(data) {
	    var t, result;
	    return _regenerator2.default.wrap(function _callee179$(_context179) {
	      while (1) {
	        switch (_context179.prev = _context179.next) {
	          case 0:
	            t = JSON.parse(data);
	            _context179.next = 3;
	            return fetch(_DomainName2.default.register + 'pnotification/' + t.url, {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 3:
	            result = _context179.sent;
	
	            console.log('Success');
	            return _context179.abrupt('return', result.json());
	
	          case 6:
	          case 'end':
	            return _context179.stop();
	        }
	      }
	    }, _callee179, this);
	  }));
	
	  return function pNotification(_x179) {
	    return _ref179.apply(this, arguments);
	  };
	}();
	
	var preSclList = function () {
	  var _ref180 = _asyncToGenerator(_regenerator2.default.mark(function _callee180(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee180$(_context180) {
	      while (1) {
	        switch (_context180.prev = _context180.next) {
	          case 0:
	            _context180.next = 2;
	            return fetch(_DomainName2.default.register + 'admin/schools/presclList', {
	
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context180.sent;
	
	            console.log('Success');
	            return _context180.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context180.stop();
	        }
	      }
	    }, _callee180, this);
	  }));
	
	  return function preSclList(_x180) {
	    return _ref180.apply(this, arguments);
	  };
	}();
	
	var getSummerCampList = function () {
	  var _ref181 = _asyncToGenerator(_regenerator2.default.mark(function _callee181(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee181$(_context181) {
	      while (1) {
	        switch (_context181.prev = _context181.next) {
	          case 0:
	            _context181.next = 2;
	            return fetch(_DomainName2.default.register + 'summercamps/getAll', {
	
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context181.sent;
	
	            console.log('Success');
	            return _context181.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context181.stop();
	        }
	      }
	    }, _callee181, this);
	  }));
	
	  return function getSummerCampList(_x181) {
	    return _ref181.apply(this, arguments);
	  };
	}();
	
	var sclList = function () {
	  var _ref182 = _asyncToGenerator(_regenerator2.default.mark(function _callee182(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee182$(_context182) {
	      while (1) {
	        switch (_context182.prev = _context182.next) {
	          case 0:
	            _context182.next = 2;
	            return fetch(_DomainName2.default.register + 'preschool/sclList', {
	
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context182.sent;
	
	            console.log('Success');
	            return _context182.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context182.stop();
	        }
	      }
	    }, _callee182, this);
	  }));
	
	  return function sclList(_x182) {
	    return _ref182.apply(this, arguments);
	  };
	}();
	
	var deleteSummerCamp = function () {
	  var _ref183 = _asyncToGenerator(_regenerator2.default.mark(function _callee183(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee183$(_context183) {
	      while (1) {
	        switch (_context183.prev = _context183.next) {
	          case 0:
	            _context183.next = 2;
	            return fetch(_DomainName2.default.register + 'summercamps/deleteSummerCamp', {
	
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context183.sent;
	
	            console.log('Success');
	            return _context183.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context183.stop();
	        }
	      }
	    }, _callee183, this);
	  }));
	
	  return function deleteSummerCamp(_x183) {
	    return _ref183.apply(this, arguments);
	  };
	}();
	
	var adminReport = function () {
	  var _ref184 = _asyncToGenerator(_regenerator2.default.mark(function _callee184(data) {
	    var t, result;
	    return _regenerator2.default.wrap(function _callee184$(_context184) {
	      while (1) {
	        switch (_context184.prev = _context184.next) {
	          case 0:
	            t = JSON.parse(data);
	            _context184.next = 3;
	            return fetch(_DomainName2.default.register + 'adminreport/' + t.url, {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 3:
	            result = _context184.sent;
	
	            console.log('Success');
	            return _context184.abrupt('return', result.json());
	
	          case 6:
	          case 'end':
	            return _context184.stop();
	        }
	      }
	    }, _callee184, this);
	  }));
	
	  return function adminReport(_x184) {
	    return _ref184.apply(this, arguments);
	  };
	}();
	
	var add_Summer_Camp = function () {
	  var _ref185 = _asyncToGenerator(_regenerator2.default.mark(function _callee185(data) {
	    var formData, key, i, result;
	    return _regenerator2.default.wrap(function _callee185$(_context185) {
	      while (1) {
	        switch (_context185.prev = _context185.next) {
	          case 0:
	            formData = new FormData();
	
	            console.log(data);
	            for (key in data) {
	              if (key == 'photos') {
	                for (i = 0; i < data[key].length; i++) {
	                  formData.append('photos', data[key][i]);
	                }
	              } else {
	                formData.append(key, data[key]);
	              }
	            }
	            console.log(formData);
	            _context185.next = 6;
	            return fetch(_DomainName2.default.register + 'summercamps/add', {
	              method: 'POST',
	              mode: 'cors',
	              headers: { 'x-auth-token': token },
	              body: formData
	            });
	
	          case 6:
	            result = _context185.sent;
	
	            console.log('Success');
	            return _context185.abrupt('return', result.json());
	
	          case 9:
	          case 'end':
	            return _context185.stop();
	        }
	      }
	    }, _callee185, this);
	  }));
	
	  return function add_Summer_Camp(_x185) {
	    return _ref185.apply(this, arguments);
	  };
	}();
	
	var getSearchList = function () {
	  var _ref186 = _asyncToGenerator(_regenerator2.default.mark(function _callee186(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee186$(_context186) {
	      while (1) {
	        switch (_context186.prev = _context186.next) {
	          case 0:
	            _context186.next = 2;
	            return fetch(_DomainName2.default.register + 'admin/common/search', {
	              method: 'POST',
	              'x-auth-token': token,
	              mode: 'cors',
	              headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
	              body: data
	            });
	
	          case 2:
	            result = _context186.sent;
	            return _context186.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context186.stop();
	        }
	      }
	    }, _callee186, this);
	  }));
	
	  return function getSearchList(_x186) {
	    return _ref186.apply(this, arguments);
	  };
	}();
	
	var getCuratedCampList = function () {
	  var _ref187 = _asyncToGenerator(_regenerator2.default.mark(function _callee187(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee187$(_context187) {
	      while (1) {
	        switch (_context187.prev = _context187.next) {
	          case 0:
	            _context187.next = 2;
	            return fetch(_DomainName2.default.register + 'curatedcamps/getlist', {
	              method: 'POST',
	              'x-auth-token': token,
	              mode: 'cors',
	              headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
	              body: data
	            });
	
	          case 2:
	            result = _context187.sent;
	            return _context187.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context187.stop();
	        }
	      }
	    }, _callee187, this);
	  }));
	
	  return function getCuratedCampList(_x187) {
	    return _ref187.apply(this, arguments);
	  };
	}();
	
	var getCuratedCampListAll = function () {
	  var _ref188 = _asyncToGenerator(_regenerator2.default.mark(function _callee188(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee188$(_context188) {
	      while (1) {
	        switch (_context188.prev = _context188.next) {
	          case 0:
	            _context188.next = 2;
	            return fetch(_DomainName2.default.register + 'curatedcamps/getlistall', {
	              method: 'POST',
	              'x-auth-token': token,
	              mode: 'cors',
	              headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
	              body: data
	            });
	
	          case 2:
	            result = _context188.sent;
	            return _context188.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context188.stop();
	        }
	      }
	    }, _callee188, this);
	  }));
	
	  return function getCuratedCampListAll(_x188) {
	    return _ref188.apply(this, arguments);
	  };
	}();
	
	var add_curated_camp = function () {
	  var _ref189 = _asyncToGenerator(_regenerator2.default.mark(function _callee189(data) {
	    var formData, key, i, result;
	    return _regenerator2.default.wrap(function _callee189$(_context189) {
	      while (1) {
	        switch (_context189.prev = _context189.next) {
	          case 0:
	            formData = new FormData();
	
	            console.log(data);
	            for (key in data) {
	              if (key == 'photos') {
	                for (i = 0; i < data[key].length; i++) {
	                  formData.append('photos', data[key][i]);
	                }
	              } else {
	                formData.append(key, data[key]);
	              }
	            }
	            console.log(formData);
	            _context189.next = 6;
	            return fetch(_DomainName2.default.register + 'curatedcamps/create', {
	              method: 'POST',
	              mode: 'cors',
	              headers: { 'x-auth-token': token },
	              body: formData
	            });
	
	          case 6:
	            result = _context189.sent;
	
	            console.log('Success');
	            return _context189.abrupt('return', result.json());
	
	          case 9:
	          case 'end':
	            return _context189.stop();
	        }
	      }
	    }, _callee189, this);
	  }));
	
	  return function add_curated_camp(_x189) {
	    return _ref189.apply(this, arguments);
	  };
	}();
	
	var AddCuratedCamps = function () {
	  var _ref190 = _asyncToGenerator(_regenerator2.default.mark(function _callee190(data) {
	    var formData, key, i, result;
	    return _regenerator2.default.wrap(function _callee190$(_context190) {
	      while (1) {
	        switch (_context190.prev = _context190.next) {
	          case 0:
	            formData = new FormData();
	
	            console.log(data);
	            for (key in data) {
	              if (key == 'photos') {
	                for (i = 0; i < data[key].length; i++) {
	                  formData.append('photos', data[key][i]);
	                }
	              } else {
	                formData.append(key, data[key]);
	              }
	            }
	            console.log(formData);
	            _context190.next = 6;
	            return fetch(_DomainName2.default.register + 'curatedcamps/create', {
	              method: 'POST',
	              mode: 'cors',
	              headers: { 'x-auth-token': token },
	              body: formData
	            });
	
	          case 6:
	            result = _context190.sent;
	
	            console.log('Success');
	            return _context190.abrupt('return', result.json());
	
	          case 9:
	          case 'end':
	            return _context190.stop();
	        }
	      }
	    }, _callee190, this);
	  }));
	
	  return function AddCuratedCamps(_x190) {
	    return _ref190.apply(this, arguments);
	  };
	}();
	
	var UpdateCuratedCamps = function () {
	  var _ref191 = _asyncToGenerator(_regenerator2.default.mark(function _callee191(data) {
	    var formData, key, i, result;
	    return _regenerator2.default.wrap(function _callee191$(_context191) {
	      while (1) {
	        switch (_context191.prev = _context191.next) {
	          case 0:
	            formData = new FormData();
	
	            console.log(data);
	            for (key in data) {
	              if (key == 'photos') {
	                for (i = 0; i < data[key].length; i++) {
	                  formData.append('photos', data[key][i]);
	                }
	              } else {
	                formData.append(key, data[key]);
	              }
	            }
	            console.log(formData);
	            _context191.next = 6;
	            return fetch(_DomainName2.default.register + 'curatedcamps/update', {
	              method: 'POST',
	              mode: 'cors',
	              headers: { 'x-auth-token': token },
	              body: formData
	            });
	
	          case 6:
	            result = _context191.sent;
	
	            console.log('Success');
	            return _context191.abrupt('return', result.json());
	
	          case 9:
	          case 'end':
	            return _context191.stop();
	        }
	      }
	    }, _callee191, this);
	  }));
	
	  return function UpdateCuratedCamps(_x191) {
	    return _ref191.apply(this, arguments);
	  };
	}();
	
	var UpdateCuratedCampsByAdmin = function () {
	  var _ref192 = _asyncToGenerator(_regenerator2.default.mark(function _callee192(data) {
	    var formData, key, i, result;
	    return _regenerator2.default.wrap(function _callee192$(_context192) {
	      while (1) {
	        switch (_context192.prev = _context192.next) {
	          case 0:
	            formData = new FormData();
	
	            console.log(data);
	            for (key in data) {
	              if (key == 'photos') {
	                for (i = 0; i < data[key].length; i++) {
	                  formData.append('photos', data[key][i]);
	                }
	              } else {
	                formData.append(key, data[key]);
	              }
	            }
	            console.log(formData);
	            _context192.next = 6;
	            return fetch(_DomainName2.default.register + 'curatedcamps/updatebyadmin', {
	              method: 'POST',
	              mode: 'cors',
	              headers: { 'x-auth-token': token },
	              body: formData
	            });
	
	          case 6:
	            result = _context192.sent;
	
	            console.log('Success');
	            return _context192.abrupt('return', result.json());
	
	          case 9:
	          case 'end':
	            return _context192.stop();
	        }
	      }
	    }, _callee192, this);
	  }));
	
	  return function UpdateCuratedCampsByAdmin(_x192) {
	    return _ref192.apply(this, arguments);
	  };
	}();
	
	var deleteCamp = function () {
	  var _ref193 = _asyncToGenerator(_regenerator2.default.mark(function _callee193(data) {
	    var formData, key, result;
	    return _regenerator2.default.wrap(function _callee193$(_context193) {
	      while (1) {
	        switch (_context193.prev = _context193.next) {
	          case 0:
	            formData = new FormData();
	
	            for (key in data) {
	              formData.append(key, data[key]);
	            }
	            console.log(formData);
	            _context193.next = 5;
	            return fetch(_DomainName2.default.register + 'curatedcamps/deletecamp', {
	              method: 'POST',
	              mode: 'cors',
	              headers: { 'x-auth-token': token },
	              body: formData
	            });
	
	          case 5:
	            result = _context193.sent;
	
	            console.log('Success');
	            return _context193.abrupt('return', result.json());
	
	          case 8:
	          case 'end':
	            return _context193.stop();
	        }
	      }
	    }, _callee193, this);
	  }));
	
	  return function deleteCamp(_x193) {
	    return _ref193.apply(this, arguments);
	  };
	}();
	
	var ApproveCuratedCamp = function () {
	  var _ref194 = _asyncToGenerator(_regenerator2.default.mark(function _callee194(data) {
	    var formData, key, i, result;
	    return _regenerator2.default.wrap(function _callee194$(_context194) {
	      while (1) {
	        switch (_context194.prev = _context194.next) {
	          case 0:
	            formData = new FormData();
	
	            console.log(data);
	            for (key in data) {
	              if (key == 'photos') {
	                for (i = 0; i < data[key].length; i++) {
	                  formData.append('photos', data[key][i]);
	                }
	              } else {
	                formData.append(key, data[key]);
	              }
	            }
	            console.log(formData);
	            _context194.next = 6;
	            return fetch(_DomainName2.default.register + 'curatedcamps/approve', {
	              method: 'POST',
	              mode: 'cors',
	              headers: { 'x-auth-token': token },
	              body: formData
	            });
	
	          case 6:
	            result = _context194.sent;
	
	            console.log('Success');
	            return _context194.abrupt('return', result.json());
	
	          case 9:
	          case 'end':
	            return _context194.stop();
	        }
	      }
	    }, _callee194, this);
	  }));
	
	  return function ApproveCuratedCamp(_x194) {
	    return _ref194.apply(this, arguments);
	  };
	}();
	
	var DisApproveCuratedCamp = function () {
	  var _ref195 = _asyncToGenerator(_regenerator2.default.mark(function _callee195(data) {
	    var formData, key, result;
	    return _regenerator2.default.wrap(function _callee195$(_context195) {
	      while (1) {
	        switch (_context195.prev = _context195.next) {
	          case 0:
	            formData = new FormData();
	
	            for (key in data) {
	              formData.append(key, data[key]);
	            }
	            console.log(formData);
	            _context195.next = 5;
	            return fetch(_DomainName2.default.register + 'curatedcamps/disapprovecamp', {
	              method: 'POST',
	              mode: 'cors',
	              headers: { 'x-auth-token': token },
	              body: formData
	            });
	
	          case 5:
	            result = _context195.sent;
	
	            console.log('Success');
	            return _context195.abrupt('return', result.json());
	
	          case 8:
	          case 'end':
	            return _context195.stop();
	        }
	      }
	    }, _callee195, this);
	  }));
	
	  return function DisApproveCuratedCamp(_x195) {
	    return _ref195.apply(this, arguments);
	  };
	}();
	
	var getCuratedPaymentList = function () {
	  var _ref196 = _asyncToGenerator(_regenerator2.default.mark(function _callee196(camp_id) {
	    var result;
	    return _regenerator2.default.wrap(function _callee196$(_context196) {
	      while (1) {
	        switch (_context196.prev = _context196.next) {
	          case 0:
	            _context196.next = 2;
	            return fetch(_DomainName2.default.register + 'curatedcamps/paymentsbycampid/' + camp_id, {
	              method: 'GET',
	              mode: 'cors',
	              headers: { 'x-auth-token': token }
	            });
	
	          case 2:
	            result = _context196.sent;
	
	            console.log('Success');
	            return _context196.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context196.stop();
	        }
	      }
	    }, _callee196, this);
	  }));
	
	  return function getCuratedPaymentList(_x196) {
	    return _ref196.apply(this, arguments);
	  };
	}();
	
	var getCuratedRegistrationList = function () {
	  var _ref197 = _asyncToGenerator(_regenerator2.default.mark(function _callee197(camp_id) {
	    var result;
	    return _regenerator2.default.wrap(function _callee197$(_context197) {
	      while (1) {
	        switch (_context197.prev = _context197.next) {
	          case 0:
	            _context197.next = 2;
	            return fetch(_DomainName2.default.register + 'curatedcamps/registrationbycampid/' + camp_id, {
	              method: 'GET',
	              mode: 'cors',
	              headers: { 'x-auth-token': token }
	            });
	
	          case 2:
	            result = _context197.sent;
	
	            console.log('Success');
	            return _context197.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context197.stop();
	        }
	      }
	    }, _callee197, this);
	  }));
	
	  return function getCuratedRegistrationList(_x197) {
	    return _ref197.apply(this, arguments);
	  };
	}();
	
	var sendWelcomeEmailCamp = function () {
	  var _ref198 = _asyncToGenerator(_regenerator2.default.mark(function _callee198(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee198$(_context198) {
	      while (1) {
	        switch (_context198.prev = _context198.next) {
	          case 0:
	            _context198.next = 2;
	            return fetch(_DomainName2.default.register + 'curatedcamps/sendcopycampinfo', {
	              method: 'POST',
	              'x-auth-token': token,
	              mode: 'cors',
	              headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
	              body: data
	            });
	
	          case 2:
	            result = _context198.sent;
	            return _context198.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context198.stop();
	        }
	      }
	    }, _callee198, this);
	  }));
	
	  return function sendWelcomeEmailCamp(_x198) {
	    return _ref198.apply(this, arguments);
	  };
	}();
	
	/* exclusive partnerships */
	
	
	var uploadMedia = function () {
	  var _ref199 = _asyncToGenerator(_regenerator2.default.mark(function _callee199(formData) {
	    var result;
	    return _regenerator2.default.wrap(function _callee199$(_context199) {
	      while (1) {
	        switch (_context199.prev = _context199.next) {
	          case 0:
	            _context199.next = 2;
	            return fetch(_DomainName2.default.register + 'exclusive/common/uploadmedia', {
	              method: 'POST',
	              mode: 'cors',
	              headers: { 'x-auth-token': token },
	              body: formData
	            });
	
	          case 2:
	            result = _context199.sent;
	
	            console.log('Success');
	            return _context199.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context199.stop();
	        }
	      }
	    }, _callee199, this);
	  }));
	
	  return function uploadMedia(_x199) {
	    return _ref199.apply(this, arguments);
	  };
	}();
	
	var sclEdit = function () {
	  var _ref200 = _asyncToGenerator(_regenerator2.default.mark(function _callee200(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee200$(_context200) {
	      while (1) {
	        switch (_context200.prev = _context200.next) {
	          case 0:
	            _context200.next = 2;
	            return fetch(_DomainName2.default.register + 'admin/schools/editdata', {
	
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context200.sent;
	
	            console.log('Success');
	            return _context200.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context200.stop();
	        }
	      }
	    }, _callee200, this);
	  }));
	
	  return function sclEdit(_x200) {
	    return _ref200.apply(this, arguments);
	  };
	}();
	
	var uploadLogo = function () {
	  var _ref201 = _asyncToGenerator(_regenerator2.default.mark(function _callee201(formData) {
	    var result;
	    return _regenerator2.default.wrap(function _callee201$(_context201) {
	      while (1) {
	        switch (_context201.prev = _context201.next) {
	          case 0:
	            _context201.next = 2;
	            return fetch(_DomainName2.default.register + 'exclusive/common/uploadlogo', {
	              method: 'POST',
	              mode: 'cors',
	              headers: { 'x-auth-token': token },
	              body: formData
	            });
	
	          case 2:
	            result = _context201.sent;
	
	            console.log('Success');
	            return _context201.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context201.stop();
	        }
	      }
	    }, _callee201, this);
	  }));
	
	  return function uploadLogo(_x201) {
	    return _ref201.apply(this, arguments);
	  };
	}();
	
	var sclReject = function () {
	  var _ref202 = _asyncToGenerator(_regenerator2.default.mark(function _callee202(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee202$(_context202) {
	      while (1) {
	        switch (_context202.prev = _context202.next) {
	          case 0:
	            _context202.next = 2;
	            return fetch(_DomainName2.default.register + 'admin/schools/reject_data', {
	
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context202.sent;
	
	            console.log('Success');
	            return _context202.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context202.stop();
	        }
	      }
	    }, _callee202, this);
	  }));
	
	  return function sclReject(_x202) {
	    return _ref202.apply(this, arguments);
	  };
	}();
	
	var uploadBannerB2b = function () {
	  var _ref203 = _asyncToGenerator(_regenerator2.default.mark(function _callee203(formData) {
	    var result;
	    return _regenerator2.default.wrap(function _callee203$(_context203) {
	      while (1) {
	        switch (_context203.prev = _context203.next) {
	          case 0:
	            _context203.next = 2;
	            return fetch(_DomainName2.default.register + 'exclusive/common/uploadbannerb2b', {
	              method: 'POST',
	              mode: 'cors',
	              headers: { 'x-auth-token': token },
	              body: formData
	            });
	
	          case 2:
	            result = _context203.sent;
	
	            console.log('Success');
	            return _context203.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context203.stop();
	        }
	      }
	    }, _callee203, this);
	  }));
	
	  return function uploadBannerB2b(_x203) {
	    return _ref203.apply(this, arguments);
	  };
	}();
	
	var uploadBanner = function () {
	  var _ref204 = _asyncToGenerator(_regenerator2.default.mark(function _callee204(formData) {
	    var result;
	    return _regenerator2.default.wrap(function _callee204$(_context204) {
	      while (1) {
	        switch (_context204.prev = _context204.next) {
	          case 0:
	            _context204.next = 2;
	            return fetch(_DomainName2.default.register + 'exclusive/common/uploadbanner', {
	              method: 'POST',
	              mode: 'cors',
	              headers: { 'x-auth-token': token },
	              body: formData
	            });
	
	          case 2:
	            result = _context204.sent;
	
	            console.log('Success');
	            return _context204.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context204.stop();
	        }
	      }
	    }, _callee204, this);
	  }));
	
	  return function uploadBanner(_x204) {
	    return _ref204.apply(this, arguments);
	  };
	}();
	
	var uploadBannerAd = function () {
	  var _ref205 = _asyncToGenerator(_regenerator2.default.mark(function _callee205(formData) {
	    var result;
	    return _regenerator2.default.wrap(function _callee205$(_context205) {
	      while (1) {
	        switch (_context205.prev = _context205.next) {
	          case 0:
	            _context205.next = 2;
	            return fetch(_DomainName2.default.register + 'exclusive/common/uploadbannerad', {
	              method: 'POST',
	              mode: 'cors',
	              headers: { 'x-auth-token': token },
	              body: formData
	            });
	
	          case 2:
	            result = _context205.sent;
	
	            console.log('Success');
	            return _context205.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context205.stop();
	        }
	      }
	    }, _callee205, this);
	  }));
	
	  return function uploadBannerAd(_x205) {
	    return _ref205.apply(this, arguments);
	  };
	}();
	
	var uploadOtherAd = function () {
	  var _ref206 = _asyncToGenerator(_regenerator2.default.mark(function _callee206(formData) {
	    var result;
	    return _regenerator2.default.wrap(function _callee206$(_context206) {
	      while (1) {
	        switch (_context206.prev = _context206.next) {
	          case 0:
	            _context206.next = 2;
	            return fetch(_DomainName2.default.register + 'exclusive/common/uploadotherad', {
	              method: 'POST',
	              mode: 'cors',
	              headers: { 'x-auth-token': token },
	              body: formData
	            });
	
	          case 2:
	            result = _context206.sent;
	
	            console.log('Success');
	            return _context206.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context206.stop();
	        }
	      }
	    }, _callee206, this);
	  }));
	
	  return function uploadOtherAd(_x206) {
	    return _ref206.apply(this, arguments);
	  };
	}();
	
	var uploadBrochure = function () {
	  var _ref207 = _asyncToGenerator(_regenerator2.default.mark(function _callee207(formData) {
	    var result;
	    return _regenerator2.default.wrap(function _callee207$(_context207) {
	      while (1) {
	        switch (_context207.prev = _context207.next) {
	          case 0:
	            _context207.next = 2;
	            return fetch(_DomainName2.default.register + 'exclusive/common/uploadbrochure', {
	              method: 'POST',
	              mode: 'cors',
	              headers: { 'x-auth-token': token },
	              body: formData
	            });
	
	          case 2:
	            result = _context207.sent;
	
	            console.log('Success');
	            return _context207.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context207.stop();
	        }
	      }
	    }, _callee207, this);
	  }));
	
	  return function uploadBrochure(_x207) {
	    return _ref207.apply(this, arguments);
	  };
	}();
	
	var uploadFile2 = function () {
	  var _ref208 = _asyncToGenerator(_regenerator2.default.mark(function _callee208(formData) {
	    var result;
	    return _regenerator2.default.wrap(function _callee208$(_context208) {
	      while (1) {
	        switch (_context208.prev = _context208.next) {
	          case 0:
	            _context208.next = 2;
	            return fetch(_DomainName2.default.register + 'exclusive/common/uploadfile2', {
	              method: 'POST',
	              mode: 'cors',
	              headers: { 'x-auth-token': token },
	              body: formData
	            });
	
	          case 2:
	            result = _context208.sent;
	
	            console.log('Success');
	            return _context208.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context208.stop();
	        }
	      }
	    }, _callee208, this);
	  }));
	
	  return function uploadFile2(_x208) {
	    return _ref208.apply(this, arguments);
	  };
	}();
	
	var uploadFile1 = function () {
	  var _ref209 = _asyncToGenerator(_regenerator2.default.mark(function _callee209(formData) {
	    var result;
	    return _regenerator2.default.wrap(function _callee209$(_context209) {
	      while (1) {
	        switch (_context209.prev = _context209.next) {
	          case 0:
	            _context209.next = 2;
	            return fetch(_DomainName2.default.register + 'exclusive/common/uploadfile1', {
	              method: 'POST',
	              mode: 'cors',
	              headers: { 'x-auth-token': token },
	              body: formData
	            });
	
	          case 2:
	            result = _context209.sent;
	
	            console.log('Success');
	            return _context209.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context209.stop();
	        }
	      }
	    }, _callee209, this);
	  }));
	
	  return function uploadFile1(_x209) {
	    return _ref209.apply(this, arguments);
	  };
	}();
	
	var uploadBrochureNew = function () {
	  var _ref210 = _asyncToGenerator(_regenerator2.default.mark(function _callee210(formData) {
	    var result;
	    return _regenerator2.default.wrap(function _callee210$(_context210) {
	      while (1) {
	        switch (_context210.prev = _context210.next) {
	          case 0:
	            _context210.next = 2;
	            return fetch(_DomainName2.default.register + 'exclusive/common/uploadbrochurenew', {
	              method: 'POST',
	              mode: 'cors',
	              headers: { 'x-auth-token': token },
	              body: formData
	            });
	
	          case 2:
	            result = _context210.sent;
	
	            console.log('Success');
	            return _context210.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context210.stop();
	        }
	      }
	    }, _callee210, this);
	  }));
	
	  return function uploadBrochureNew(_x210) {
	    return _ref210.apply(this, arguments);
	  };
	}();
	
	var uploadThumbNew = function () {
	  var _ref211 = _asyncToGenerator(_regenerator2.default.mark(function _callee211(formData) {
	    var result;
	    return _regenerator2.default.wrap(function _callee211$(_context211) {
	      while (1) {
	        switch (_context211.prev = _context211.next) {
	          case 0:
	            _context211.next = 2;
	            return fetch(_DomainName2.default.register + 'exclusive/common/uploadthumbnew', {
	              method: 'POST',
	              mode: 'cors',
	              headers: { 'x-auth-token': token },
	              body: formData
	            });
	
	          case 2:
	            result = _context211.sent;
	
	            console.log('Success');
	            return _context211.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context211.stop();
	        }
	      }
	    }, _callee211, this);
	  }));
	
	  return function uploadThumbNew(_x211) {
	    return _ref211.apply(this, arguments);
	  };
	}();
	
	var uploadThumb2 = function () {
	  var _ref212 = _asyncToGenerator(_regenerator2.default.mark(function _callee212(formData) {
	    var result;
	    return _regenerator2.default.wrap(function _callee212$(_context212) {
	      while (1) {
	        switch (_context212.prev = _context212.next) {
	          case 0:
	            _context212.next = 2;
	            return fetch(_DomainName2.default.register + 'exclusive/common/uploadthumb2', {
	              method: 'POST',
	              mode: 'cors',
	              headers: { 'x-auth-token': token },
	              body: formData
	            });
	
	          case 2:
	            result = _context212.sent;
	
	            console.log('Success');
	            return _context212.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context212.stop();
	        }
	      }
	    }, _callee212, this);
	  }));
	
	  return function uploadThumb2(_x212) {
	    return _ref212.apply(this, arguments);
	  };
	}();
	
	var uploadThumb1 = function () {
	  var _ref213 = _asyncToGenerator(_regenerator2.default.mark(function _callee213(formData) {
	    var result;
	    return _regenerator2.default.wrap(function _callee213$(_context213) {
	      while (1) {
	        switch (_context213.prev = _context213.next) {
	          case 0:
	            _context213.next = 2;
	            return fetch(_DomainName2.default.register + 'exclusive/common/uploadthumb1', {
	              method: 'POST',
	              mode: 'cors',
	              headers: { 'x-auth-token': token },
	              body: formData
	            });
	
	          case 2:
	            result = _context213.sent;
	
	            console.log('Success');
	            return _context213.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context213.stop();
	        }
	      }
	    }, _callee213, this);
	  }));
	
	  return function uploadThumb1(_x213) {
	    return _ref213.apply(this, arguments);
	  };
	}();
	
	var uploadGallery = function () {
	  var _ref214 = _asyncToGenerator(_regenerator2.default.mark(function _callee214(formData) {
	    var result;
	    return _regenerator2.default.wrap(function _callee214$(_context214) {
	      while (1) {
	        switch (_context214.prev = _context214.next) {
	          case 0:
	            _context214.next = 2;
	            return fetch(_DomainName2.default.register + 'exclusive/common/uploadgallery', {
	              method: 'POST',
	              mode: 'cors',
	              headers: { 'x-auth-token': token },
	              body: formData
	            });
	
	          case 2:
	            result = _context214.sent;
	
	            console.log('Success');
	            return _context214.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context214.stop();
	        }
	      }
	    }, _callee214, this);
	  }));
	
	  return function uploadGallery(_x214) {
	    return _ref214.apply(this, arguments);
	  };
	}();
	
	var presclEdit = function () {
	  var _ref215 = _asyncToGenerator(_regenerator2.default.mark(function _callee215(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee215$(_context215) {
	      while (1) {
	        switch (_context215.prev = _context215.next) {
	          case 0:
	            _context215.next = 2;
	            return fetch(_DomainName2.default.register + 'preschool/editdata', {
	
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context215.sent;
	
	            console.log('Success');
	            return _context215.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context215.stop();
	        }
	      }
	    }, _callee215, this);
	  }));
	
	  return function presclEdit(_x215) {
	    return _ref215.apply(this, arguments);
	  };
	}();
	
	var uploadImage = function () {
	  var _ref216 = _asyncToGenerator(_regenerator2.default.mark(function _callee216(formData) {
	    var result;
	    return _regenerator2.default.wrap(function _callee216$(_context216) {
	      while (1) {
	        switch (_context216.prev = _context216.next) {
	          case 0:
	            _context216.next = 2;
	            return fetch(_DomainName2.default.register + 'exclusive/common/uploadimage', {
	              method: 'POST',
	              mode: 'cors',
	              headers: { 'x-auth-token': token },
	              body: formData
	            });
	
	          case 2:
	            result = _context216.sent;
	
	            console.log('Success');
	            return _context216.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context216.stop();
	        }
	      }
	    }, _callee216, this);
	  }));
	
	  return function uploadImage(_x216) {
	    return _ref216.apply(this, arguments);
	  };
	}();
	
	var uploadVideo = function () {
	  var _ref217 = _asyncToGenerator(_regenerator2.default.mark(function _callee217(formData) {
	    var result;
	    return _regenerator2.default.wrap(function _callee217$(_context217) {
	      while (1) {
	        switch (_context217.prev = _context217.next) {
	          case 0:
	            _context217.next = 2;
	            return fetch(_DomainName2.default.register + 'exclusive/common/uploadvideo', {
	              method: 'POST',
	              mode: 'cors',
	              headers: { 'x-auth-token': token },
	              body: formData
	            });
	
	          case 2:
	            result = _context217.sent;
	
	            console.log('Success');
	            return _context217.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context217.stop();
	        }
	      }
	    }, _callee217, this);
	  }));
	
	  return function uploadVideo(_x217) {
	    return _ref217.apply(this, arguments);
	  };
	}();
	
	var presclReject = function () {
	  var _ref218 = _asyncToGenerator(_regenerator2.default.mark(function _callee218(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee218$(_context218) {
	      while (1) {
	        switch (_context218.prev = _context218.next) {
	          case 0:
	            _context218.next = 2;
	            return fetch(_DomainName2.default.register + 'preschool/reject_data', {
	
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	
	            });
	
	          case 2:
	            result = _context218.sent;
	
	            console.log('Success');
	            return _context218.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context218.stop();
	        }
	      }
	    }, _callee218, this);
	  }));
	
	  return function presclReject(_x218) {
	    return _ref218.apply(this, arguments);
	  };
	}();
	
	var removeExclPtnrsEntry = function () {
	  var _ref219 = _asyncToGenerator(_regenerator2.default.mark(function _callee219(data) {
	    var t, result;
	    return _regenerator2.default.wrap(function _callee219$(_context219) {
	      while (1) {
	        switch (_context219.prev = _context219.next) {
	          case 0:
	            t = JSON.parse(data);
	            _context219.next = 3;
	            return fetch(_DomainName2.default.register + 'exclusive/common/removeentry', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 3:
	            result = _context219.sent;
	            return _context219.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context219.stop();
	        }
	      }
	    }, _callee219, this);
	  }));
	
	  return function removeExclPtnrsEntry(_x219) {
	    return _ref219.apply(this, arguments);
	  };
	}();
	
	var playareaEdit = function () {
	  var _ref220 = _asyncToGenerator(_regenerator2.default.mark(function _callee220(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee220$(_context220) {
	      while (1) {
	        switch (_context220.prev = _context220.next) {
	          case 0:
	            _context220.next = 2;
	            return fetch(_DomainName2.default.register + 'playarea/editdata', {
	
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context220.sent;
	            return _context220.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context220.stop();
	        }
	      }
	    }, _callee220, this);
	  }));
	
	  return function playareaEdit(_x220) {
	    return _ref220.apply(this, arguments);
	  };
	}();
	
	var updateEntry = function () {
	  var _ref221 = _asyncToGenerator(_regenerator2.default.mark(function _callee221(data) {
	    var t, result;
	    return _regenerator2.default.wrap(function _callee221$(_context221) {
	      while (1) {
	        switch (_context221.prev = _context221.next) {
	          case 0:
	            t = JSON.parse(data);
	            _context221.next = 3;
	            return fetch(_DomainName2.default.register + 'exclusive/common/updateentry', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 3:
	            result = _context221.sent;
	            return _context221.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context221.stop();
	        }
	      }
	    }, _callee221, this);
	  }));
	
	  return function updateEntry(_x221) {
	    return _ref221.apply(this, arguments);
	  };
	}();
	
	var saveEntry = function () {
	  var _ref222 = _asyncToGenerator(_regenerator2.default.mark(function _callee222(data) {
	    var t, result;
	    return _regenerator2.default.wrap(function _callee222$(_context222) {
	      while (1) {
	        switch (_context222.prev = _context222.next) {
	          case 0:
	            t = JSON.parse(data);
	            _context222.next = 3;
	            return fetch(_DomainName2.default.register + 'exclusive/common/saveentry', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 3:
	            result = _context222.sent;
	            return _context222.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context222.stop();
	        }
	      }
	    }, _callee222, this);
	  }));
	
	  return function saveEntry(_x222) {
	    return _ref222.apply(this, arguments);
	  };
	}();
	
	var removalItemBigBanner = function () {
	  var _ref223 = _asyncToGenerator(_regenerator2.default.mark(function _callee223(data) {
	    var t, result;
	    return _regenerator2.default.wrap(function _callee223$(_context223) {
	      while (1) {
	        switch (_context223.prev = _context223.next) {
	          case 0:
	            t = JSON.parse(data);
	            _context223.next = 3;
	            return fetch(_DomainName2.default.register + 'exclusive/common/removebigbanner', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 3:
	            result = _context223.sent;
	            return _context223.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context223.stop();
	        }
	      }
	    }, _callee223, this);
	  }));
	
	  return function removalItemBigBanner(_x223) {
	    return _ref223.apply(this, arguments);
	  };
	}();
	
	var removalItemExclusiveBanner1 = function () {
	  var _ref224 = _asyncToGenerator(_regenerator2.default.mark(function _callee224(data) {
	    var t, result;
	    return _regenerator2.default.wrap(function _callee224$(_context224) {
	      while (1) {
	        switch (_context224.prev = _context224.next) {
	          case 0:
	            t = JSON.parse(data);
	            _context224.next = 3;
	            return fetch(_DomainName2.default.register + 'exclusive/common/removeexclusivebanner1', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 3:
	            result = _context224.sent;
	            return _context224.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context224.stop();
	        }
	      }
	    }, _callee224, this);
	  }));
	
	  return function removalItemExclusiveBanner1(_x224) {
	    return _ref224.apply(this, arguments);
	  };
	}();
	
	var removalItemExclusiveBanner2 = function () {
	  var _ref225 = _asyncToGenerator(_regenerator2.default.mark(function _callee225(data) {
	    var t, result;
	    return _regenerator2.default.wrap(function _callee225$(_context225) {
	      while (1) {
	        switch (_context225.prev = _context225.next) {
	          case 0:
	            t = JSON.parse(data);
	            _context225.next = 3;
	            return fetch(_DomainName2.default.register + 'exclusive/common/removeexclusivebanner2', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 3:
	            result = _context225.sent;
	            return _context225.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context225.stop();
	        }
	      }
	    }, _callee225, this);
	  }));
	
	  return function removalItemExclusiveBanner2(_x225) {
	    return _ref225.apply(this, arguments);
	  };
	}();
	
	var playareaReject = function () {
	  var _ref226 = _asyncToGenerator(_regenerator2.default.mark(function _callee226(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee226$(_context226) {
	      while (1) {
	        switch (_context226.prev = _context226.next) {
	          case 0:
	            _context226.next = 2;
	            return fetch(_DomainName2.default.register + 'playarea/reject_data', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context226.sent;
	            return _context226.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context226.stop();
	        }
	      }
	    }, _callee226, this);
	  }));
	
	  return function playareaReject(_x226) {
	    return _ref226.apply(this, arguments);
	  };
	}();
	
	var submitEntry = function () {
	  var _ref227 = _asyncToGenerator(_regenerator2.default.mark(function _callee227(data) {
	    var t, result;
	    return _regenerator2.default.wrap(function _callee227$(_context227) {
	      while (1) {
	        switch (_context227.prev = _context227.next) {
	          case 0:
	            t = JSON.parse(data);
	            _context227.next = 3;
	            return fetch(_DomainName2.default.register + 'exclusive/common/submitentry', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 3:
	            result = _context227.sent;
	            return _context227.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context227.stop();
	        }
	      }
	    }, _callee227, this);
	  }));
	
	  return function submitEntry(_x227) {
	    return _ref227.apply(this, arguments);
	  };
	}();
	
	var submitAdsEntry = function () {
	  var _ref228 = _asyncToGenerator(_regenerator2.default.mark(function _callee228(data) {
	    var t, result;
	    return _regenerator2.default.wrap(function _callee228$(_context228) {
	      while (1) {
	        switch (_context228.prev = _context228.next) {
	          case 0:
	            t = JSON.parse(data);
	            _context228.next = 3;
	            return fetch(_DomainName2.default.register + 'exclusive/common/submitadsentry', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 3:
	            result = _context228.sent;
	            return _context228.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context228.stop();
	        }
	      }
	    }, _callee228, this);
	  }));
	
	  return function submitAdsEntry(_x228) {
	    return _ref228.apply(this, arguments);
	  };
	}();
	
	var submitAdsEntryOther = function () {
	  var _ref229 = _asyncToGenerator(_regenerator2.default.mark(function _callee229(data) {
	    var t, result;
	    return _regenerator2.default.wrap(function _callee229$(_context229) {
	      while (1) {
	        switch (_context229.prev = _context229.next) {
	          case 0:
	            t = JSON.parse(data);
	            _context229.next = 3;
	            return fetch(_DomainName2.default.register + 'exclusive/common/submitadsentryother', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 3:
	            result = _context229.sent;
	            return _context229.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context229.stop();
	        }
	      }
	    }, _callee229, this);
	  }));
	
	  return function submitAdsEntryOther(_x229) {
	    return _ref229.apply(this, arguments);
	  };
	}();
	
	var deleteAdEntry = function () {
	  var _ref230 = _asyncToGenerator(_regenerator2.default.mark(function _callee230(data) {
	    var t, result;
	    return _regenerator2.default.wrap(function _callee230$(_context230) {
	      while (1) {
	        switch (_context230.prev = _context230.next) {
	          case 0:
	            t = JSON.parse(data);
	            _context230.next = 3;
	            return fetch(_DomainName2.default.register + 'exclusive/common/delete_ad', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 3:
	            result = _context230.sent;
	            return _context230.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context230.stop();
	        }
	      }
	    }, _callee230, this);
	  }));
	
	  return function deleteAdEntry(_x230) {
	    return _ref230.apply(this, arguments);
	  };
	}();
	
	var hobbiesEdit = function () {
	  var _ref231 = _asyncToGenerator(_regenerator2.default.mark(function _callee231(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee231$(_context231) {
	      while (1) {
	        switch (_context231.prev = _context231.next) {
	          case 0:
	            _context231.next = 2;
	            return fetch(_DomainName2.default.register + 'admin/hobbies_intrest/editdata', {
	
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context231.sent;
	            return _context231.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context231.stop();
	        }
	      }
	    }, _callee231, this);
	  }));
	
	  return function hobbiesEdit(_x231) {
	    return _ref231.apply(this, arguments);
	  };
	}();
	
	var getExclPtnrsEntry = function () {
	  var _ref232 = _asyncToGenerator(_regenerator2.default.mark(function _callee232(data) {
	    var t, result;
	    return _regenerator2.default.wrap(function _callee232$(_context232) {
	      while (1) {
	        switch (_context232.prev = _context232.next) {
	          case 0:
	            t = JSON.parse(data);
	            _context232.next = 3;
	            return fetch(_DomainName2.default.register + 'exclusive/common/getEntry', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 3:
	            result = _context232.sent;
	            return _context232.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context232.stop();
	        }
	      }
	    }, _callee232, this);
	  }));
	
	  return function getExclPtnrsEntry(_x232) {
	    return _ref232.apply(this, arguments);
	  };
	}();
	
	var getExclPtnrsEntryB2B = function () {
	  var _ref233 = _asyncToGenerator(_regenerator2.default.mark(function _callee233(data) {
	    var t, result;
	    return _regenerator2.default.wrap(function _callee233$(_context233) {
	      while (1) {
	        switch (_context233.prev = _context233.next) {
	          case 0:
	            t = JSON.parse(data);
	            _context233.next = 3;
	            return fetch(_DomainName2.default.register + 'exclusive/common/getEntryB2b', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 3:
	            result = _context233.sent;
	            return _context233.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context233.stop();
	        }
	      }
	    }, _callee233, this);
	  }));
	
	  return function getExclPtnrsEntryB2B(_x233) {
	    return _ref233.apply(this, arguments);
	  };
	}();
	
	var hobbiesReject = function () {
	  var _ref234 = _asyncToGenerator(_regenerator2.default.mark(function _callee234(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee234$(_context234) {
	      while (1) {
	        switch (_context234.prev = _context234.next) {
	          case 0:
	            _context234.next = 2;
	            return fetch(_DomainName2.default.register + 'admin/hobbies_intrest/reject_data', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context234.sent;
	            return _context234.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context234.stop();
	        }
	      }
	    }, _callee234, this);
	  }));
	
	  return function hobbiesReject(_x234) {
	    return _ref234.apply(this, arguments);
	  };
	}();
	
	var getExclPtnrsEntryById = function () {
	  var _ref235 = _asyncToGenerator(_regenerator2.default.mark(function _callee235(data) {
	    var t, result;
	    return _regenerator2.default.wrap(function _callee235$(_context235) {
	      while (1) {
	        switch (_context235.prev = _context235.next) {
	          case 0:
	            t = JSON.parse(data);
	            _context235.next = 3;
	            return fetch(_DomainName2.default.register + 'exclusive/common/getEntryById', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 3:
	            result = _context235.sent;
	            return _context235.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context235.stop();
	        }
	      }
	    }, _callee235, this);
	  }));
	
	  return function getExclPtnrsEntryById(_x235) {
	    return _ref235.apply(this, arguments);
	  };
	}();
	
	var tuitionEdit = function () {
	  var _ref236 = _asyncToGenerator(_regenerator2.default.mark(function _callee236(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee236$(_context236) {
	      while (1) {
	        switch (_context236.prev = _context236.next) {
	          case 0:
	            _context236.next = 2;
	            return fetch(_DomainName2.default.register + 'tution/editdata', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context236.sent;
	            return _context236.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context236.stop();
	        }
	      }
	    }, _callee236, this);
	  }));
	
	  return function tuitionEdit(_x236) {
	    return _ref236.apply(this, arguments);
	  };
	}();
	
	var getExclusiveList = function () {
	  var _ref237 = _asyncToGenerator(_regenerator2.default.mark(function _callee237() {
	    var result;
	    return _regenerator2.default.wrap(function _callee237$(_context237) {
	      while (1) {
	        switch (_context237.prev = _context237.next) {
	          case 0:
	            _context237.next = 2;
	            return fetch(_DomainName2.default.register + 'exclusive/common/getListAdmin', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              }
	            });
	
	          case 2:
	            result = _context237.sent;
	            return _context237.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context237.stop();
	        }
	      }
	    }, _callee237, this);
	  }));
	
	  return function getExclusiveList() {
	    return _ref237.apply(this, arguments);
	  };
	}();
	
	var tuitionReject = function () {
	  var _ref238 = _asyncToGenerator(_regenerator2.default.mark(function _callee238(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee238$(_context238) {
	      while (1) {
	        switch (_context238.prev = _context238.next) {
	          case 0:
	            _context238.next = 2;
	            return fetch(_DomainName2.default.register + 'tution/reject_data', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context238.sent;
	            return _context238.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context238.stop();
	        }
	      }
	    }, _callee238, this);
	  }));
	
	  return function tuitionReject(_x237) {
	    return _ref238.apply(this, arguments);
	  };
	}();
	
	var deleteExclPartnership = function () {
	  var _ref239 = _asyncToGenerator(_regenerator2.default.mark(function _callee239(data) {
	    var t, result;
	    return _regenerator2.default.wrap(function _callee239$(_context239) {
	      while (1) {
	        switch (_context239.prev = _context239.next) {
	          case 0:
	            t = JSON.parse(data);
	            _context239.next = 3;
	            return fetch(_DomainName2.default.register + 'exclusive/common/removeentry', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 3:
	            result = _context239.sent;
	            return _context239.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context239.stop();
	        }
	      }
	    }, _callee239, this);
	  }));
	
	  return function deleteExclPartnership(_x238) {
	    return _ref239.apply(this, arguments);
	  };
	}();
	
	var communityEdit = function () {
	  var _ref240 = _asyncToGenerator(_regenerator2.default.mark(function _callee240(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee240$(_context240) {
	      while (1) {
	        switch (_context240.prev = _context240.next) {
	          case 0:
	            _context240.next = 2;
	            return fetch(_DomainName2.default.register + 'admin/advice/editdata', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context240.sent;
	            return _context240.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context240.stop();
	        }
	      }
	    }, _callee240, this);
	  }));
	
	  return function communityEdit(_x239) {
	    return _ref240.apply(this, arguments);
	  };
	}();
	
	var getUnseenEntries = function () {
	  var _ref241 = _asyncToGenerator(_regenerator2.default.mark(function _callee241() {
	    var result;
	    return _regenerator2.default.wrap(function _callee241$(_context241) {
	      while (1) {
	        switch (_context241.prev = _context241.next) {
	          case 0:
	            _context241.next = 2;
	            return fetch(_DomainName2.default.register + 'exclusive/common/getUnSeenEntries', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              }
	            });
	
	          case 2:
	            result = _context241.sent;
	            return _context241.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context241.stop();
	        }
	      }
	    }, _callee241, this);
	  }));
	
	  return function getUnseenEntries() {
	    return _ref241.apply(this, arguments);
	  };
	}();
	
	var communityReject = function () {
	  var _ref242 = _asyncToGenerator(_regenerator2.default.mark(function _callee242(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee242$(_context242) {
	      while (1) {
	        switch (_context242.prev = _context242.next) {
	          case 0:
	            _context242.next = 2;
	            return fetch(_DomainName2.default.register + 'admin/advice/reject_data', {
	
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context242.sent;
	            return _context242.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context242.stop();
	        }
	      }
	    }, _callee242, this);
	  }));
	
	  return function communityReject(_x240) {
	    return _ref242.apply(this, arguments);
	  };
	}();
	
	var sendAdminMessage = function () {
	  var _ref243 = _asyncToGenerator(_regenerator2.default.mark(function _callee243(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee243$(_context243) {
	      while (1) {
	        switch (_context243.prev = _context243.next) {
	          case 0:
	            _context243.next = 2;
	            return fetch(_DomainName2.default.register + 'exclusive/common/sendamessage', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context243.sent;
	            return _context243.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context243.stop();
	        }
	      }
	    }, _callee243, this);
	  }));
	
	  return function sendAdminMessage(_x241) {
	    return _ref243.apply(this, arguments);
	  };
	}();
	
	var learningEdit = function () {
	  var _ref244 = _asyncToGenerator(_regenerator2.default.mark(function _callee244(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee244$(_context244) {
	      while (1) {
	        switch (_context244.prev = _context244.next) {
	          case 0:
	            _context244.next = 2;
	            return fetch(_DomainName2.default.register + 'camps/editdata', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context244.sent;
	            return _context244.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context244.stop();
	        }
	      }
	    }, _callee244, this);
	  }));
	
	  return function learningEdit(_x242) {
	    return _ref244.apply(this, arguments);
	  };
	}();
	
	var changeStatusExclPart = function () {
	  var _ref245 = _asyncToGenerator(_regenerator2.default.mark(function _callee245(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee245$(_context245) {
	      while (1) {
	        switch (_context245.prev = _context245.next) {
	          case 0:
	            _context245.next = 2;
	            return fetch(_DomainName2.default.register + 'exclusive/common/changestatus', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context245.sent;
	            return _context245.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context245.stop();
	        }
	      }
	    }, _callee245, this);
	  }));
	
	  return function changeStatusExclPart(_x243) {
	    return _ref245.apply(this, arguments);
	  };
	}();
	
	var learningReject = function () {
	  var _ref246 = _asyncToGenerator(_regenerator2.default.mark(function _callee246(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee246$(_context246) {
	      while (1) {
	        switch (_context246.prev = _context246.next) {
	          case 0:
	            _context246.next = 2;
	            return fetch(_DomainName2.default.register + 'camps/reject_data', {
	
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context246.sent;
	            return _context246.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context246.stop();
	        }
	      }
	    }, _callee246, this);
	  }));
	
	  return function learningReject(_x244) {
	    return _ref246.apply(this, arguments);
	  };
	}();
	
	var makeMessageRead = function () {
	  var _ref247 = _asyncToGenerator(_regenerator2.default.mark(function _callee247(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee247$(_context247) {
	      while (1) {
	        switch (_context247.prev = _context247.next) {
	          case 0:
	            _context247.next = 2;
	            return fetch(_DomainName2.default.register + 'exclusive/common/makeamessageread', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context247.sent;
	            return _context247.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context247.stop();
	        }
	      }
	    }, _callee247, this);
	  }));
	
	  return function makeMessageRead(_x245) {
	    return _ref247.apply(this, arguments);
	  };
	}();
	
	var eventEdit = function () {
	  var _ref248 = _asyncToGenerator(_regenerator2.default.mark(function _callee248(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee248$(_context248) {
	      while (1) {
	        switch (_context248.prev = _context248.next) {
	          case 0:
	            _context248.next = 2;
	            return fetch(_DomainName2.default.register + 'admin/events/editdata', {
	
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context248.sent;
	
	            console.log('Success');
	            return _context248.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context248.stop();
	        }
	      }
	    }, _callee248, this);
	  }));
	
	  return function eventEdit(_x246) {
	    return _ref248.apply(this, arguments);
	  };
	}();
	
	var eventReject = function () {
	  var _ref249 = _asyncToGenerator(_regenerator2.default.mark(function _callee249(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee249$(_context249) {
	      while (1) {
	        switch (_context249.prev = _context249.next) {
	          case 0:
	            _context249.next = 2;
	            return fetch(_DomainName2.default.register + 'admin/events/reject_data', {
	
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context249.sent;
	
	            console.log('Success');
	            return _context249.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context249.stop();
	        }
	      }
	    }, _callee249, this);
	  }));
	
	  return function eventReject(_x247) {
	    return _ref249.apply(this, arguments);
	  };
	}();
	
	var retailerAPI = function () {
	  var _ref250 = _asyncToGenerator(_regenerator2.default.mark(function _callee250(data) {
	    var t, result;
	    return _regenerator2.default.wrap(function _callee250$(_context250) {
	      while (1) {
	        switch (_context250.prev = _context250.next) {
	          case 0:
	            t = JSON.parse(data);
	            _context250.next = 3;
	            return fetch(_DomainName2.default.register + 'retailer/' + t.url, {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 3:
	            result = _context250.sent;
	
	            console.log('Success');
	            return _context250.abrupt('return', result.json());
	
	          case 6:
	          case 'end':
	            return _context250.stop();
	        }
	      }
	    }, _callee250, this);
	  }));
	
	  return function retailerAPI(_x248) {
	    return _ref250.apply(this, arguments);
	  };
	}();
	
	var retailerUpdate = function () {
	  var _ref251 = _asyncToGenerator(_regenerator2.default.mark(function _callee251(data) {
	    var formData, key, result;
	    return _regenerator2.default.wrap(function _callee251$(_context251) {
	      while (1) {
	        switch (_context251.prev = _context251.next) {
	          case 0:
	            formData = new FormData();
	
	            for (key in data) {
	              formData.append(key, data[key]);
	            }
	            _context251.next = 4;
	            return fetch(_DomainName2.default.register + 'retailer/retailer_update', {
	              method: 'POST',
	              mode: 'cors',
	              headers: { 'x-auth-token': token },
	              body: formData
	            });
	
	          case 4:
	            result = _context251.sent;
	
	            console.log('Success');
	            return _context251.abrupt('return', result.json());
	
	          case 7:
	          case 'end':
	            return _context251.stop();
	        }
	      }
	    }, _callee251, this);
	  }));
	
	  return function retailerUpdate(_x249) {
	    return _ref251.apply(this, arguments);
	  };
	}();
	
	var importRetailer = function () {
	  var _ref252 = _asyncToGenerator(_regenerator2.default.mark(function _callee252(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee252$(_context252) {
	      while (1) {
	        switch (_context252.prev = _context252.next) {
	          case 0:
	            _context252.next = 2;
	            return fetch(_DomainName2.default.register + 'retailer/import', {
	              method: 'POST',
	              mode: 'cors',
	              headers: { 'x-auth-token': token },
	              body: data
	            });
	
	          case 2:
	            result = _context252.sent;
	
	            console.log('Success');
	            return _context252.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context252.stop();
	        }
	      }
	    }, _callee252, this);
	  }));
	
	  return function importRetailer(_x250) {
	    return _ref252.apply(this, arguments);
	  };
	}();
	
	var updateSplEvent = function () {
	  var _ref253 = _asyncToGenerator(_regenerator2.default.mark(function _callee253(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee253$(_context253) {
	      while (1) {
	        switch (_context253.prev = _context253.next) {
	          case 0:
	            _context253.next = 2;
	            return fetch(_DomainName2.default.register + 'event_module/event_update', {
	              method: 'POST',
	              mode: 'cors',
	              headers: { 'x-auth-token': token },
	              body: data
	            });
	
	          case 2:
	            result = _context253.sent;
	
	            console.log('Success');
	            return _context253.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context253.stop();
	        }
	      }
	    }, _callee253, this);
	  }));
	
	  return function updateSplEvent(_x251) {
	    return _ref253.apply(this, arguments);
	  };
	}();
	
	var splEvent = function () {
	  var _ref254 = _asyncToGenerator(_regenerator2.default.mark(function _callee254(data) {
	    var t, result;
	    return _regenerator2.default.wrap(function _callee254$(_context254) {
	      while (1) {
	        switch (_context254.prev = _context254.next) {
	          case 0:
	            t = JSON.parse(data);
	            _context254.next = 3;
	            return fetch(_DomainName2.default.register + 'event_module/' + t.url, {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 3:
	            result = _context254.sent;
	            return _context254.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context254.stop();
	        }
	      }
	    }, _callee254, this);
	  }));
	
	  return function splEvent(_x252) {
	    return _ref254.apply(this, arguments);
	  };
	}();
	
	/* end exclpartnerships */
	
	var packageAPI = function () {
	  var _ref255 = _asyncToGenerator(_regenerator2.default.mark(function _callee255(data) {
	    var t, result;
	    return _regenerator2.default.wrap(function _callee255$(_context255) {
	      while (1) {
	        switch (_context255.prev = _context255.next) {
	          case 0:
	            t = JSON.parse(data);
	            _context255.next = 3;
	            return fetch(_DomainName2.default.register + 'packages/' + t.url, {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 3:
	            result = _context255.sent;
	            return _context255.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context255.stop();
	        }
	      }
	    }, _callee255, this);
	  }));
	
	  return function packageAPI(_x253) {
	    return _ref255.apply(this, arguments);
	  };
	}();
	
	var partnerReportV1 = function () {
	  var _ref256 = _asyncToGenerator(_regenerator2.default.mark(function _callee256(data) {
	    var t, result;
	    return _regenerator2.default.wrap(function _callee256$(_context256) {
	      while (1) {
	        switch (_context256.prev = _context256.next) {
	          case 0:
	            t = JSON.parse(data);
	            _context256.next = 3;
	            return fetch(_DomainName2.default.register + 'partner_reportV1/' + t.url, {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 3:
	            result = _context256.sent;
	
	            console.log('Success');
	            return _context256.abrupt('return', result.json());
	
	          case 6:
	          case 'end':
	            return _context256.stop();
	        }
	      }
	    }, _callee256, this);
	  }));
	
	  return function partnerReportV1(_x254) {
	    return _ref256.apply(this, arguments);
	  };
	}();
	
	var getLeadsByPartner = function () {
	  var _ref257 = _asyncToGenerator(_regenerator2.default.mark(function _callee257(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee257$(_context257) {
	      while (1) {
	        switch (_context257.prev = _context257.next) {
	          case 0:
	            _context257.next = 2;
	            return fetch(_DomainName2.default.register + 'leads/processlead/getLeadsByPartner', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context257.sent;
	            return _context257.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context257.stop();
	        }
	      }
	    }, _callee257, this);
	  }));
	
	  return function getLeadsByPartner(_x255) {
	    return _ref257.apply(this, arguments);
	  };
	}();
	
	var ParterSeenLead = function () {
	  var _ref258 = _asyncToGenerator(_regenerator2.default.mark(function _callee258(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee258$(_context258) {
	      while (1) {
	        switch (_context258.prev = _context258.next) {
	          case 0:
	            _context258.next = 2;
	            return fetch(_DomainName2.default.register + 'leads/processlead/saveseen', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context258.sent;
	            return _context258.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context258.stop();
	        }
	      }
	    }, _callee258, this);
	  }));
	
	  return function ParterSeenLead(_x256) {
	    return _ref258.apply(this, arguments);
	  };
	}();
	
	var checkPaidOrNot = function () {
	  var _ref259 = _asyncToGenerator(_regenerator2.default.mark(function _callee259(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee259$(_context259) {
	      while (1) {
	        switch (_context259.prev = _context259.next) {
	          case 0:
	            _context259.next = 2;
	            return fetch(_DomainName2.default.register + 'leads/processlead/checkpaidpartners', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context259.sent;
	            return _context259.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context259.stop();
	        }
	      }
	    }, _callee259, this);
	  }));
	
	  return function checkPaidOrNot(_x257) {
	    return _ref259.apply(this, arguments);
	  };
	}();
	
	var updateLeadAction = function () {
	  var _ref260 = _asyncToGenerator(_regenerator2.default.mark(function _callee260(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee260$(_context260) {
	      while (1) {
	        switch (_context260.prev = _context260.next) {
	          case 0:
	            _context260.next = 2;
	            return fetch(_DomainName2.default.register + 'leads/processlead/updateleadaction', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context260.sent;
	            return _context260.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context260.stop();
	        }
	      }
	    }, _callee260, this);
	  }));
	
	  return function updateLeadAction(_x258) {
	    return _ref260.apply(this, arguments);
	  };
	}();
	
	var getPartnerLeadNew = function () {
	  var _ref261 = _asyncToGenerator(_regenerator2.default.mark(function _callee261(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee261$(_context261) {
	      while (1) {
	        switch (_context261.prev = _context261.next) {
	          case 0:
	            _context261.next = 2;
	            return fetch(_DomainName2.default.register + 'leads/processlead/getunseenleads', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context261.sent;
	            return _context261.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context261.stop();
	        }
	      }
	    }, _callee261, this);
	  }));
	
	  return function getPartnerLeadNew(_x259) {
	    return _ref261.apply(this, arguments);
	  };
	}();
	
	var getPartnerLeadInfo = function () {
	  var _ref262 = _asyncToGenerator(_regenerator2.default.mark(function _callee262(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee262$(_context262) {
	      while (1) {
	        switch (_context262.prev = _context262.next) {
	          case 0:
	            _context262.next = 2;
	            return fetch(_DomainName2.default.register + 'leads/processlead/getpartnersleadinfo', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context262.sent;
	            return _context262.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context262.stop();
	        }
	      }
	    }, _callee262, this);
	  }));
	
	  return function getPartnerLeadInfo(_x260) {
	    return _ref262.apply(this, arguments);
	  };
	}();
	
	var getPartnerAds = function () {
	  var _ref263 = _asyncToGenerator(_regenerator2.default.mark(function _callee263() {
	    var result;
	    return _regenerator2.default.wrap(function _callee263$(_context263) {
	      while (1) {
	        switch (_context263.prev = _context263.next) {
	          case 0:
	            _context263.next = 2;
	            return fetch(_DomainName2.default.register + 'leads/processlead/getPartnerads', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              }
	            });
	
	          case 2:
	            result = _context263.sent;
	            return _context263.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context263.stop();
	        }
	      }
	    }, _callee263, this);
	  }));
	
	  return function getPartnerAds() {
	    return _ref263.apply(this, arguments);
	  };
	}();
	
	var getAllAds = function () {
	  var _ref264 = _asyncToGenerator(_regenerator2.default.mark(function _callee264() {
	    var result;
	    return _regenerator2.default.wrap(function _callee264$(_context264) {
	      while (1) {
	        switch (_context264.prev = _context264.next) {
	          case 0:
	            _context264.next = 2;
	            return fetch(_DomainName2.default.register + 'leads/processlead/getAllads', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              }
	            });
	
	          case 2:
	            result = _context264.sent;
	            return _context264.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context264.stop();
	        }
	      }
	    }, _callee264, this);
	  }));
	
	  return function getAllAds() {
	    return _ref264.apply(this, arguments);
	  };
	}();
	
	var getOtherAds = function () {
	  var _ref265 = _asyncToGenerator(_regenerator2.default.mark(function _callee265() {
	    var result;
	    return _regenerator2.default.wrap(function _callee265$(_context265) {
	      while (1) {
	        switch (_context265.prev = _context265.next) {
	          case 0:
	            _context265.next = 2;
	            return fetch(_DomainName2.default.register + 'leads/processlead/getOtherads', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              }
	            });
	
	          case 2:
	            result = _context265.sent;
	            return _context265.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context265.stop();
	        }
	      }
	    }, _callee265, this);
	  }));
	
	  return function getOtherAds() {
	    return _ref265.apply(this, arguments);
	  };
	}();
	
	var getSEOContents = function () {
	  var _ref266 = _asyncToGenerator(_regenerator2.default.mark(function _callee266() {
	    var result;
	    return _regenerator2.default.wrap(function _callee266$(_context266) {
	      while (1) {
	        switch (_context266.prev = _context266.next) {
	          case 0:
	            _context266.next = 2;
	            return fetch(_DomainName2.default.register + 'cms/vertical/getlist', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              }
	            });
	
	          case 2:
	            result = _context266.sent;
	            return _context266.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context266.stop();
	        }
	      }
	    }, _callee266, this);
	  }));
	
	  return function getSEOContents() {
	    return _ref266.apply(this, arguments);
	  };
	}();
	
	var deleteContent = function () {
	  var _ref267 = _asyncToGenerator(_regenerator2.default.mark(function _callee267(data) {
	    var t, result;
	    return _regenerator2.default.wrap(function _callee267$(_context267) {
	      while (1) {
	        switch (_context267.prev = _context267.next) {
	          case 0:
	            t = JSON.parse(data);
	            _context267.next = 3;
	            return fetch(_DomainName2.default.register + 'cms/vertical/delete', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 3:
	            result = _context267.sent;
	            return _context267.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context267.stop();
	        }
	      }
	    }, _callee267, this);
	  }));
	
	  return function deleteContent(_x261) {
	    return _ref267.apply(this, arguments);
	  };
	}();
	
	var getSuggest = function () {
	  var _ref268 = _asyncToGenerator(_regenerator2.default.mark(function _callee268(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee268$(_context268) {
	      while (1) {
	        switch (_context268.prev = _context268.next) {
	          case 0:
	            _context268.next = 2;
	            return fetch(_DomainName2.default.register + 'leads/processlead/get_suggest', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context268.sent;
	            return _context268.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context268.stop();
	        }
	      }
	    }, _callee268, this);
	  }));
	
	  return function getSuggest(_x262) {
	    return _ref268.apply(this, arguments);
	  };
	}();
	
	var updatePremiumList = function () {
	  var _ref269 = _asyncToGenerator(_regenerator2.default.mark(function _callee269(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee269$(_context269) {
	      while (1) {
	        switch (_context269.prev = _context269.next) {
	          case 0:
	            _context269.next = 2;
	            return fetch(_DomainName2.default.register + 'leads/processlead/savepremiumentry', {
	              method: 'post',
	              mode: 'cors',
	              'x-auth-token': token,
	              headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
	              body: data
	            });
	
	          case 2:
	            result = _context269.sent;
	            return _context269.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context269.stop();
	        }
	      }
	    }, _callee269, this);
	  }));
	
	  return function updatePremiumList(_x263) {
	    return _ref269.apply(this, arguments);
	  };
	}();
	
	var exclprtshipsListPartners = function () {
	  var _ref270 = _asyncToGenerator(_regenerator2.default.mark(function _callee270(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee270$(_context270) {
	      while (1) {
	        switch (_context270.prev = _context270.next) {
	          case 0:
	            _context270.next = 2;
	            return fetch(_DomainName2.default.register + 'exclusive/common/get_list_front_partners', {
	              method: 'post',
	              mode: 'cors',
	              'x-auth-token': token,
	              headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
	              body: data
	            });
	
	          case 2:
	            result = _context270.sent;
	            return _context270.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context270.stop();
	        }
	      }
	    }, _callee270, this);
	  }));
	
	  return function exclprtshipsListPartners(_x264) {
	    return _ref270.apply(this, arguments);
	  };
	}();
	
	var exclprtshipsList = function () {
	  var _ref271 = _asyncToGenerator(_regenerator2.default.mark(function _callee271(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee271$(_context271) {
	      while (1) {
	        switch (_context271.prev = _context271.next) {
	          case 0:
	            _context271.next = 2;
	            return fetch(_DomainName2.default.register + 'exclusive/common/get_list_front', {
	              method: 'post',
	              mode: 'cors',
	              'x-auth-token': token,
	              headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
	              body: data
	            });
	
	          case 2:
	            result = _context271.sent;
	            return _context271.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context271.stop();
	        }
	      }
	    }, _callee271, this);
	  }));
	
	  return function exclprtshipsList(_x265) {
	    return _ref271.apply(this, arguments);
	  };
	}();
	
	var getPremiumList = function () {
	  var _ref272 = _asyncToGenerator(_regenerator2.default.mark(function _callee272(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee272$(_context272) {
	      while (1) {
	        switch (_context272.prev = _context272.next) {
	          case 0:
	            _context272.next = 2;
	            return fetch(_DomainName2.default.register + 'leads/processlead/getpremiumlist', {
	              method: 'post',
	              mode: 'cors',
	              'x-auth-token': token,
	              headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
	              body: data
	            });
	
	          case 2:
	            result = _context272.sent;
	            return _context272.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context272.stop();
	        }
	      }
	    }, _callee272, this);
	  }));
	
	  return function getPremiumList(_x266) {
	    return _ref272.apply(this, arguments);
	  };
	}();
	
	var removeTopFiveEntry = function () {
	  var _ref273 = _asyncToGenerator(_regenerator2.default.mark(function _callee273(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee273$(_context273) {
	      while (1) {
	        switch (_context273.prev = _context273.next) {
	          case 0:
	            _context273.next = 2;
	            return fetch(_DomainName2.default.register + 'leads/processlead/removepremiumlist', {
	              method: 'post',
	              mode: 'cors',
	              'x-auth-token': token,
	              headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
	              body: data
	            });
	
	          case 2:
	            result = _context273.sent;
	            return _context273.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context273.stop();
	        }
	      }
	    }, _callee273, this);
	  }));
	
	  return function removeTopFiveEntry(_x267) {
	    return _ref273.apply(this, arguments);
	  };
	}();
	
	var removelead = function () {
	  var _ref274 = _asyncToGenerator(_regenerator2.default.mark(function _callee274(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee274$(_context274) {
	      while (1) {
	        switch (_context274.prev = _context274.next) {
	          case 0:
	            _context274.next = 2;
	            return fetch(_DomainName2.default.register + 'leads/processlead/removelead', {
	              method: 'post',
	              mode: 'cors',
	              'x-auth-token': token,
	              headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
	              body: data
	            });
	
	          case 2:
	            result = _context274.sent;
	            return _context274.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context274.stop();
	        }
	      }
	    }, _callee274, this);
	  }));
	
	  return function removelead(_x268) {
	    return _ref274.apply(this, arguments);
	  };
	}();
	
	var stampSchool = function () {
	  var _ref275 = _asyncToGenerator(_regenerator2.default.mark(function _callee275(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee275$(_context275) {
	      while (1) {
	        switch (_context275.prev = _context275.next) {
	          case 0:
	            _context275.next = 2;
	            return fetch(_DomainName2.default.register + 'leads/processlead/stampunstamp', {
	              method: 'post',
	              mode: 'cors',
	              'x-auth-token': token,
	              headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
	              body: data
	            });
	
	          case 2:
	            result = _context275.sent;
	            return _context275.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context275.stop();
	        }
	      }
	    }, _callee275, this);
	  }));
	
	  return function stampSchool(_x269) {
	    return _ref275.apply(this, arguments);
	  };
	}();
	
	var checkifEligibleForStamping = function () {
	  var _ref276 = _asyncToGenerator(_regenerator2.default.mark(function _callee276(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee276$(_context276) {
	      while (1) {
	        switch (_context276.prev = _context276.next) {
	          case 0:
	            _context276.next = 2;
	            return fetch(_DomainName2.default.register + 'leads/processlead/checkifvendorexist', {
	              method: 'post',
	              mode: 'cors',
	              'x-auth-token': token,
	              headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
	              body: data
	            });
	
	          case 2:
	            result = _context276.sent;
	            return _context276.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context276.stop();
	        }
	      }
	    }, _callee276, this);
	  }));
	
	  return function checkifEligibleForStamping(_x270) {
	    return _ref276.apply(this, arguments);
	  };
	}();
	
	var checkiffeatured = function () {
	  var _ref277 = _asyncToGenerator(_regenerator2.default.mark(function _callee277(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee277$(_context277) {
	      while (1) {
	        switch (_context277.prev = _context277.next) {
	          case 0:
	            _context277.next = 2;
	            return fetch(_DomainName2.default.register + 'featured/act/checkiffeatured', {
	              method: 'post',
	              mode: 'cors',
	              'x-auth-token': token,
	              headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
	              body: data
	            });
	
	          case 2:
	            result = _context277.sent;
	            return _context277.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context277.stop();
	        }
	      }
	    }, _callee277, this);
	  }));
	
	  return function checkiffeatured(_x271) {
	    return _ref277.apply(this, arguments);
	  };
	}();
	
	var checkDiscountInfo = function () {
	  var _ref278 = _asyncToGenerator(_regenerator2.default.mark(function _callee278(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee278$(_context278) {
	      while (1) {
	        switch (_context278.prev = _context278.next) {
	          case 0:
	            _context278.next = 2;
	            return fetch(_DomainName2.default.register + 'discount/act/checkdiscountexist', {
	              method: 'post',
	              mode: 'cors',
	              'x-auth-token': token,
	              headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
	              body: data
	            });
	
	          case 2:
	            result = _context278.sent;
	            return _context278.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context278.stop();
	        }
	      }
	    }, _callee278, this);
	  }));
	
	  return function checkDiscountInfo(_x272) {
	    return _ref278.apply(this, arguments);
	  };
	}();
	
	var discount_update = function () {
	  var _ref279 = _asyncToGenerator(_regenerator2.default.mark(function _callee279(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee279$(_context279) {
	      while (1) {
	        switch (_context279.prev = _context279.next) {
	          case 0:
	            _context279.next = 2;
	            return fetch(_DomainName2.default.register + 'discount/act/discount_update', {
	              method: 'post',
	              mode: 'cors',
	              'x-auth-token': token,
	              headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
	              body: data
	            });
	
	          case 2:
	            result = _context279.sent;
	            return _context279.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context279.stop();
	        }
	      }
	    }, _callee279, this);
	  }));
	
	  return function discount_update(_x273) {
	    return _ref279.apply(this, arguments);
	  };
	}();
	
	var creatediscount = function () {
	  var _ref280 = _asyncToGenerator(_regenerator2.default.mark(function _callee280(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee280$(_context280) {
	      while (1) {
	        switch (_context280.prev = _context280.next) {
	          case 0:
	            _context280.next = 2;
	            return fetch(_DomainName2.default.register + 'discount/act/create', {
	              method: 'post',
	              mode: 'cors',
	              'x-auth-token': token,
	              headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
	              body: data
	            });
	
	          case 2:
	            result = _context280.sent;
	            return _context280.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context280.stop();
	        }
	      }
	    }, _callee280, this);
	  }));
	
	  return function creatediscount(_x274) {
	    return _ref280.apply(this, arguments);
	  };
	}();
	
	var removediscount = function () {
	  var _ref281 = _asyncToGenerator(_regenerator2.default.mark(function _callee281(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee281$(_context281) {
	      while (1) {
	        switch (_context281.prev = _context281.next) {
	          case 0:
	            _context281.next = 2;
	            return fetch(_DomainName2.default.register + 'discount/act/remove', {
	              method: 'post',
	              mode: 'cors',
	              'x-auth-token': token,
	              headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
	              body: data
	            });
	
	          case 2:
	            result = _context281.sent;
	            return _context281.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context281.stop();
	        }
	      }
	    }, _callee281, this);
	  }));
	
	  return function removediscount(_x275) {
	    return _ref281.apply(this, arguments);
	  };
	}();
	
	var moveup_update = function () {
	  var _ref282 = _asyncToGenerator(_regenerator2.default.mark(function _callee282(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee282$(_context282) {
	      while (1) {
	        switch (_context282.prev = _context282.next) {
	          case 0:
	            _context282.next = 2;
	            return fetch(_DomainName2.default.register + 'featured/act/moveup_update', {
	              method: 'post',
	              mode: 'cors',
	              'x-auth-token': token,
	              headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
	              body: data
	            });
	
	          case 2:
	            result = _context282.sent;
	            return _context282.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context282.stop();
	        }
	      }
	    }, _callee282, this);
	  }));
	
	  return function moveup_update(_x276) {
	    return _ref282.apply(this, arguments);
	  };
	}();
	
	var moveup = function () {
	  var _ref283 = _asyncToGenerator(_regenerator2.default.mark(function _callee283(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee283$(_context283) {
	      while (1) {
	        switch (_context283.prev = _context283.next) {
	          case 0:
	            _context283.next = 2;
	            return fetch(_DomainName2.default.register + 'featured/act/moveup', {
	              method: 'post',
	              mode: 'cors',
	              'x-auth-token': token,
	              headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
	              body: data
	            });
	
	          case 2:
	            result = _context283.sent;
	            return _context283.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context283.stop();
	        }
	      }
	    }, _callee283, this);
	  }));
	
	  return function moveup(_x277) {
	    return _ref283.apply(this, arguments);
	  };
	}();
	
	var removefeatured = function () {
	  var _ref284 = _asyncToGenerator(_regenerator2.default.mark(function _callee284(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee284$(_context284) {
	      while (1) {
	        switch (_context284.prev = _context284.next) {
	          case 0:
	            _context284.next = 2;
	            return fetch(_DomainName2.default.register + 'featured/act/remove', {
	              method: 'post',
	              mode: 'cors',
	              'x-auth-token': token,
	              headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
	              body: data
	            });
	
	          case 2:
	            result = _context284.sent;
	            return _context284.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context284.stop();
	        }
	      }
	    }, _callee284, this);
	  }));
	
	  return function removefeatured(_x278) {
	    return _ref284.apply(this, arguments);
	  };
	}();
	
	var confirmLead = function () {
	  var _ref285 = _asyncToGenerator(_regenerator2.default.mark(function _callee285(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee285$(_context285) {
	      while (1) {
	        switch (_context285.prev = _context285.next) {
	          case 0:
	            _context285.next = 2;
	            return fetch(_DomainName2.default.register + 'leads/processlead/checkpushLeadV1', {
	              method: 'post',
	              mode: 'cors',
	              'x-auth-token': token,
	              headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
	              body: data
	            });
	
	          case 2:
	            result = _context285.sent;
	            return _context285.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context285.stop();
	        }
	      }
	    }, _callee285, this);
	  }));
	
	  return function confirmLead(_x279) {
	    return _ref285.apply(this, arguments);
	  };
	}();
	
	var checkpushLead = function () {
	  var _ref286 = _asyncToGenerator(_regenerator2.default.mark(function _callee286(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee286$(_context286) {
	      while (1) {
	        switch (_context286.prev = _context286.next) {
	          case 0:
	            _context286.next = 2;
	            return fetch(_DomainName2.default.register + 'leads/processlead/checkpushLeadV1', {
	              method: 'post',
	              mode: 'cors',
	              'x-auth-token': token,
	              headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
	              body: data
	            });
	
	          case 2:
	            result = _context286.sent;
	            return _context286.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context286.stop();
	        }
	      }
	    }, _callee286, this);
	  }));
	
	  return function checkpushLead(_x280) {
	    return _ref286.apply(this, arguments);
	  };
	}();
	
	var createLead = function () {
	  var _ref287 = _asyncToGenerator(_regenerator2.default.mark(function _callee287(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee287$(_context287) {
	      while (1) {
	        switch (_context287.prev = _context287.next) {
	          case 0:
	            _context287.next = 2;
	            return fetch(_DomainName2.default.register + 'leads/processlead/createlead', {
	              method: 'post',
	              mode: 'cors',
	              'x-auth-token': token,
	              headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
	              body: data
	            });
	
	          case 2:
	            result = _context287.sent;
	            return _context287.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context287.stop();
	        }
	      }
	    }, _callee287, this);
	  }));
	
	  return function createLead(_x281) {
	    return _ref287.apply(this, arguments);
	  };
	}();
	
	var getLead_Stats = function () {
	  var _ref288 = _asyncToGenerator(_regenerator2.default.mark(function _callee288(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee288$(_context288) {
	      while (1) {
	        switch (_context288.prev = _context288.next) {
	          case 0:
	            _context288.next = 2;
	            return fetch(_DomainName2.default.register + 'leads/processlead/getleads_stat', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context288.sent;
	            return _context288.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context288.stop();
	        }
	      }
	    }, _callee288, this);
	  }));
	
	  return function getLead_Stats(_x282) {
	    return _ref288.apply(this, arguments);
	  };
	}();
	
	var getMailInfo = function () {
	  var _ref289 = _asyncToGenerator(_regenerator2.default.mark(function _callee289(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee289$(_context289) {
	      while (1) {
	        switch (_context289.prev = _context289.next) {
	          case 0:
	            _context289.next = 2;
	            return fetch(_DomainName2.default.register + 'leads/processlead/getmailinfo', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context289.sent;
	            return _context289.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context289.stop();
	        }
	      }
	    }, _callee289, this);
	  }));
	
	  return function getMailInfo(_x283) {
	    return _ref289.apply(this, arguments);
	  };
	}();
	
	var getPayLink = function () {
	  var _ref290 = _asyncToGenerator(_regenerator2.default.mark(function _callee290(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee290$(_context290) {
	      while (1) {
	        switch (_context290.prev = _context290.next) {
	          case 0:
	            _context290.next = 2;
	            return fetch(_DomainName2.default.register + 'razorpay/common/generatelink', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context290.sent;
	            return _context290.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context290.stop();
	        }
	      }
	    }, _callee290, this);
	  }));
	
	  return function getPayLink(_x284) {
	    return _ref290.apply(this, arguments);
	  };
	}();
	
	var sendMailPayLink = function () {
	  var _ref291 = _asyncToGenerator(_regenerator2.default.mark(function _callee291(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee291$(_context291) {
	      while (1) {
	        switch (_context291.prev = _context291.next) {
	          case 0:
	            _context291.next = 2;
	            return fetch(_DomainName2.default.register + 'razorpay/common/sendlinktomail', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context291.sent;
	            return _context291.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context291.stop();
	        }
	      }
	    }, _callee291, this);
	  }));
	
	  return function sendMailPayLink(_x285) {
	    return _ref291.apply(this, arguments);
	  };
	}();
	
	var getDiscountNew = function () {
	  var _ref292 = _asyncToGenerator(_regenerator2.default.mark(function _callee292(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee292$(_context292) {
	      while (1) {
	        switch (_context292.prev = _context292.next) {
	          case 0:
	            _context292.next = 2;
	            return fetch(_DomainName2.default.register + 'razorpay/common/getDiscountNew', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context292.sent;
	            return _context292.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context292.stop();
	        }
	      }
	    }, _callee292, this);
	  }));
	
	  return function getDiscountNew(_x286) {
	    return _ref292.apply(this, arguments);
	  };
	}();
	
	var getPaymentLinkInfo = function () {
	  var _ref293 = _asyncToGenerator(_regenerator2.default.mark(function _callee293(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee293$(_context293) {
	      while (1) {
	        switch (_context293.prev = _context293.next) {
	          case 0:
	            _context293.next = 2;
	            return fetch(_DomainName2.default.register + 'razorpay/common/getPaymentLinkInfo', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context293.sent;
	            return _context293.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context293.stop();
	        }
	      }
	    }, _callee293, this);
	  }));
	
	  return function getPaymentLinkInfo(_x287) {
	    return _ref293.apply(this, arguments);
	  };
	}();
	
	var updatePaymentInfo = function () {
	  var _ref294 = _asyncToGenerator(_regenerator2.default.mark(function _callee294(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee294$(_context294) {
	      while (1) {
	        switch (_context294.prev = _context294.next) {
	          case 0:
	            _context294.next = 2;
	            return fetch(_DomainName2.default.register + 'razorpay/common/updatePaymentInfo', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context294.sent;
	            return _context294.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context294.stop();
	        }
	      }
	    }, _callee294, this);
	  }));
	
	  return function updatePaymentInfo(_x288) {
	    return _ref294.apply(this, arguments);
	  };
	}();
	
	var getRazorPayTransactionList = function () {
	  var _ref295 = _asyncToGenerator(_regenerator2.default.mark(function _callee295(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee295$(_context295) {
	      while (1) {
	        switch (_context295.prev = _context295.next) {
	          case 0:
	            _context295.next = 2;
	            return fetch(_DomainName2.default.register + 'razorpay/common/getRazorPayTransactionList', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context295.sent;
	
	            console.log('Success');
	            return _context295.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context295.stop();
	        }
	      }
	    }, _callee295, this);
	  }));
	
	  return function getRazorPayTransactionList(_x289) {
	    return _ref295.apply(this, arguments);
	  };
	}();
	
	var getPaymentLinkInfoDetail = function () {
	  var _ref296 = _asyncToGenerator(_regenerator2.default.mark(function _callee296(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee296$(_context296) {
	      while (1) {
	        switch (_context296.prev = _context296.next) {
	          case 0:
	            _context296.next = 2;
	            return fetch(_DomainName2.default.register + 'razorpay/common/getRazorPayDetail', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context296.sent;
	
	            console.log('Success');
	            return _context296.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context296.stop();
	        }
	      }
	    }, _callee296, this);
	  }));
	
	  return function getPaymentLinkInfoDetail(_x290) {
	    return _ref296.apply(this, arguments);
	  };
	}();
	
	var partnerSubscriptionAfterRazorPayLinks = function () {
	  var _ref297 = _asyncToGenerator(_regenerator2.default.mark(function _callee297(data) {
	    var t, result;
	    return _regenerator2.default.wrap(function _callee297$(_context297) {
	      while (1) {
	        switch (_context297.prev = _context297.next) {
	          case 0:
	            t = JSON.parse(data);
	            _context297.next = 3;
	            return fetch(_DomainName2.default.register + 'razorpay/common/' + t.url, {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 3:
	            result = _context297.sent;
	            return _context297.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context297.stop();
	        }
	      }
	    }, _callee297, this);
	  }));
	
	  return function partnerSubscriptionAfterRazorPayLinks(_x291) {
	    return _ref297.apply(this, arguments);
	  };
	}();
	
	var getVerticalUserCount = function () {
	  var _ref298 = _asyncToGenerator(_regenerator2.default.mark(function _callee298(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee298$(_context298) {
	      while (1) {
	        switch (_context298.prev = _context298.next) {
	          case 0:
	            _context298.next = 2;
	            return fetch(_DomainName2.default.register + 'razorpay/common/getVerticalUserCount', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context298.sent;
	
	            console.log('Success');
	            return _context298.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context298.stop();
	        }
	      }
	    }, _callee298, this);
	  }));
	
	  return function getVerticalUserCount(_x292) {
	    return _ref298.apply(this, arguments);
	  };
	}();
	
	var getSchoolNoOfRegistered = function () {
	  var _ref299 = _asyncToGenerator(_regenerator2.default.mark(function _callee299(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee299$(_context299) {
	      while (1) {
	        switch (_context299.prev = _context299.next) {
	          case 0:
	            _context299.next = 2;
	            return fetch(_DomainName2.default.register + 'bewiseapi/school/noofregistered', {
	              method: 'GET',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context299.sent;
	
	            console.log('Success');
	            return _context299.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context299.stop();
	        }
	      }
	    }, _callee299, this);
	  }));
	
	  return function getSchoolNoOfRegistered(_x293) {
	    return _ref299.apply(this, arguments);
	  };
	}();
	
	var getSchoolNoOfUnRegistered = function () {
	  var _ref300 = _asyncToGenerator(_regenerator2.default.mark(function _callee300(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee300$(_context300) {
	      while (1) {
	        switch (_context300.prev = _context300.next) {
	          case 0:
	            _context300.next = 2;
	            return fetch(_DomainName2.default.register + 'bewiseapi/school/noofunregistered', {
	              method: 'GET',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context300.sent;
	
	            console.log('Success');
	            return _context300.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context300.stop();
	        }
	      }
	    }, _callee300, this);
	  }));
	
	  return function getSchoolNoOfUnRegistered(_x294) {
	    return _ref300.apply(this, arguments);
	  };
	}();
	
	var getMailList = function () {
	  var _ref301 = _asyncToGenerator(_regenerator2.default.mark(function _callee301(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee301$(_context301) {
	      while (1) {
	        switch (_context301.prev = _context301.next) {
	          case 0:
	            _context301.next = 2;
	            return fetch(_DomainName2.default.register + 'bewiseapi/cms/mails', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context301.sent;
	
	            console.log('Success');
	            return _context301.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context301.stop();
	        }
	      }
	    }, _callee301, this);
	  }));
	
	  return function getMailList(_x295) {
	    return _ref301.apply(this, arguments);
	  };
	}();
	
	var getCMSSiteList = function () {
	  var _ref302 = _asyncToGenerator(_regenerator2.default.mark(function _callee302(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee302$(_context302) {
	      while (1) {
	        switch (_context302.prev = _context302.next) {
	          case 0:
	            _context302.next = 2;
	            return fetch(_DomainName2.default.register + 'bewiseapi/cms/sitecontent', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context302.sent;
	
	            console.log('Success');
	            return _context302.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context302.stop();
	        }
	      }
	    }, _callee302, this);
	  }));
	
	  return function getCMSSiteList(_x296) {
	    return _ref302.apply(this, arguments);
	  };
	}();
	
	var getImagesList = function () {
	  var _ref303 = _asyncToGenerator(_regenerator2.default.mark(function _callee303(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee303$(_context303) {
	      while (1) {
	        switch (_context303.prev = _context303.next) {
	          case 0:
	            _context303.next = 2;
	            return fetch(_DomainName2.default.register + 'bewiseapi/general/imagelist', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context303.sent;
	
	            console.log('Success');
	            return _context303.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context303.stop();
	        }
	      }
	    }, _callee303, this);
	  }));
	
	  return function getImagesList(_x297) {
	    return _ref303.apply(this, arguments);
	  };
	}();
	
	var getMail = function () {
	  var _ref304 = _asyncToGenerator(_regenerator2.default.mark(function _callee304(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee304$(_context304) {
	      while (1) {
	        switch (_context304.prev = _context304.next) {
	          case 0:
	            _context304.next = 2;
	            return fetch(_DomainName2.default.register + 'bewiseapi/cms/mail', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context304.sent;
	
	            console.log('Success');
	            return _context304.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context304.stop();
	        }
	      }
	    }, _callee304, this);
	  }));
	
	  return function getMail(_x298) {
	    return _ref304.apply(this, arguments);
	  };
	}();
	
	var getSchoolDetail = function () {
	  var _ref305 = _asyncToGenerator(_regenerator2.default.mark(function _callee305(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee305$(_context305) {
	      while (1) {
	        switch (_context305.prev = _context305.next) {
	          case 0:
	            _context305.next = 2;
	            return fetch(_DomainName2.default.register + 'bewiseapi/school/editdata', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context305.sent;
	
	            console.log('Success');
	            return _context305.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context305.stop();
	        }
	      }
	    }, _callee305, this);
	  }));
	
	  return function getSchoolDetail(_x299) {
	    return _ref305.apply(this, arguments);
	  };
	}();
	
	var uploadEditorImage = function () {
	  var _ref306 = _asyncToGenerator(_regenerator2.default.mark(function _callee306(formData) {
	    var result;
	    return _regenerator2.default.wrap(function _callee306$(_context306) {
	      while (1) {
	        switch (_context306.prev = _context306.next) {
	          case 0:
	            _context306.next = 2;
	            return fetch(_DomainName2.default.register + 'campaign/mail/uploadeditorimage', {
	              method: 'POST',
	              mode: 'cors',
	              headers: { 'x-auth-token': token },
	              body: formData
	            });
	
	          case 2:
	            result = _context306.sent;
	
	            console.log('Success');
	            return _context306.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context306.stop();
	        }
	      }
	    }, _callee306, this);
	  }));
	
	  return function uploadEditorImage(_x300) {
	    return _ref306.apply(this, arguments);
	  };
	}();
	
	var getAreaNamesListV2 = function () {
	  var _ref307 = _asyncToGenerator(_regenerator2.default.mark(function _callee307() {
	    var result;
	    return _regenerator2.default.wrap(function _callee307$(_context307) {
	      while (1) {
	        switch (_context307.prev = _context307.next) {
	          case 0:
	            _context307.next = 2;
	            return fetch(_DomainName2.default.register + 'bewiseapi/general/getAreaList', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              }
	            });
	
	          case 2:
	            result = _context307.sent;
	            return _context307.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context307.stop();
	        }
	      }
	    }, _callee307, this);
	  }));
	
	  return function getAreaNamesListV2() {
	    return _ref307.apply(this, arguments);
	  };
	}();
	
	var getCityList = function () {
	  var _ref308 = _asyncToGenerator(_regenerator2.default.mark(function _callee308() {
	    var result;
	    return _regenerator2.default.wrap(function _callee308$(_context308) {
	      while (1) {
	        switch (_context308.prev = _context308.next) {
	          case 0:
	            _context308.next = 2;
	            return fetch(_DomainName2.default.register + 'bewiseapi/general/getCityList', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              }
	            });
	
	          case 2:
	            result = _context308.sent;
	            return _context308.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context308.stop();
	        }
	      }
	    }, _callee308, this);
	  }));
	
	  return function getCityList() {
	    return _ref308.apply(this, arguments);
	  };
	}();
	
	var getContacts = function () {
	  var _ref309 = _asyncToGenerator(_regenerator2.default.mark(function _callee309() {
	    var result;
	    return _regenerator2.default.wrap(function _callee309$(_context309) {
	      while (1) {
	        switch (_context309.prev = _context309.next) {
	          case 0:
	            _context309.next = 2;
	            return fetch(_DomainName2.default.register + 'bewiseapi/general/getContacts', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              }
	            });
	
	          case 2:
	            result = _context309.sent;
	            return _context309.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context309.stop();
	        }
	      }
	    }, _callee309, this);
	  }));
	
	  return function getContacts() {
	    return _ref309.apply(this, arguments);
	  };
	}();
	
	var saveCity = function () {
	  var _ref310 = _asyncToGenerator(_regenerator2.default.mark(function _callee310(formData) {
	    var result;
	    return _regenerator2.default.wrap(function _callee310$(_context310) {
	      while (1) {
	        switch (_context310.prev = _context310.next) {
	          case 0:
	            _context310.next = 2;
	            return fetch(_DomainName2.default.register + 'bewiseapi/general/saveCity', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: formData
	            });
	
	          case 2:
	            result = _context310.sent;
	            return _context310.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context310.stop();
	        }
	      }
	    }, _callee310, this);
	  }));
	
	  return function saveCity(_x301) {
	    return _ref310.apply(this, arguments);
	  };
	}();
	
	var getRoleListV1 = function () {
	  var _ref311 = _asyncToGenerator(_regenerator2.default.mark(function _callee311(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee311$(_context311) {
	      while (1) {
	        switch (_context311.prev = _context311.next) {
	          case 0:
	            _context311.next = 2;
	            return fetch(_DomainName2.default.register + 'bewiseapi/admin/getRolelist', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context311.sent;
	
	            console.log('Success');
	            return _context311.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context311.stop();
	        }
	      }
	    }, _callee311, this);
	  }));
	
	  return function getRoleListV1(_x302) {
	    return _ref311.apply(this, arguments);
	  };
	}();
	
	var getRoleMenus = function () {
	  var _ref312 = _asyncToGenerator(_regenerator2.default.mark(function _callee312(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee312$(_context312) {
	      while (1) {
	        switch (_context312.prev = _context312.next) {
	          case 0:
	            _context312.next = 2;
	            return fetch(_DomainName2.default.register + 'bewiseapi/admin/getAdminRoleMenu', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context312.sent;
	            return _context312.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context312.stop();
	        }
	      }
	    }, _callee312, this);
	  }));
	
	  return function getRoleMenus(_x303) {
	    return _ref312.apply(this, arguments);
	  };
	}();
	
	var saveRole = function () {
	  var _ref313 = _asyncToGenerator(_regenerator2.default.mark(function _callee313(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee313$(_context313) {
	      while (1) {
	        switch (_context313.prev = _context313.next) {
	          case 0:
	            _context313.next = 2;
	            return fetch(_DomainName2.default.register + 'bewiseapi/admin/saverole', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context313.sent;
	            return _context313.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context313.stop();
	        }
	      }
	    }, _callee313, this);
	  }));
	
	  return function saveRole(_x304) {
	    return _ref313.apply(this, arguments);
	  };
	}();
	
	var getGST = function () {
	  var _ref314 = _asyncToGenerator(_regenerator2.default.mark(function _callee314(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee314$(_context314) {
	      while (1) {
	        switch (_context314.prev = _context314.next) {
	          case 0:
	            _context314.next = 2;
	            return fetch(_DomainName2.default.register + 'bewiseapi/admin/getGST', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context314.sent;
	            return _context314.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context314.stop();
	        }
	      }
	    }, _callee314, this);
	  }));
	
	  return function getGST(_x305) {
	    return _ref314.apply(this, arguments);
	  };
	}();
	
	var saveGST = function () {
	  var _ref315 = _asyncToGenerator(_regenerator2.default.mark(function _callee315(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee315$(_context315) {
	      while (1) {
	        switch (_context315.prev = _context315.next) {
	          case 0:
	            _context315.next = 2;
	            return fetch(_DomainName2.default.register + 'bewiseapi/admin/saveGST', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context315.sent;
	            return _context315.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context315.stop();
	        }
	      }
	    }, _callee315, this);
	  }));
	
	  return function saveGST(_x306) {
	    return _ref315.apply(this, arguments);
	  };
	}();
	
	var getPlanList = function () {
	  var _ref316 = _asyncToGenerator(_regenerator2.default.mark(function _callee316(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee316$(_context316) {
	      while (1) {
	        switch (_context316.prev = _context316.next) {
	          case 0:
	            _context316.next = 2;
	            return fetch(_DomainName2.default.register + 'bewiseapi/admin/get_package_list', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context316.sent;
	            return _context316.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context316.stop();
	        }
	      }
	    }, _callee316, this);
	  }));
	
	  return function getPlanList(_x307) {
	    return _ref316.apply(this, arguments);
	  };
	}();
	
	var getRazorPayTransactionListV1 = function () {
	  var _ref317 = _asyncToGenerator(_regenerator2.default.mark(function _callee317(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee317$(_context317) {
	      while (1) {
	        switch (_context317.prev = _context317.next) {
	          case 0:
	            _context317.next = 2;
	            return fetch(_DomainName2.default.register + 'bewiseapi/payments/getRazorPayTransactionList', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context317.sent;
	
	            console.log('Success');
	            return _context317.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context317.stop();
	        }
	      }
	    }, _callee317, this);
	  }));
	
	  return function getRazorPayTransactionListV1(_x308) {
	    return _ref317.apply(this, arguments);
	  };
	}();
	
	var getTransactionListV1 = function () {
	  var _ref318 = _asyncToGenerator(_regenerator2.default.mark(function _callee318(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee318$(_context318) {
	      while (1) {
	        switch (_context318.prev = _context318.next) {
	          case 0:
	            _context318.next = 2;
	            return fetch(_DomainName2.default.register + 'bewiseapi/payments/getTransactionList', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context318.sent;
	
	            console.log('Success');
	            return _context318.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context318.stop();
	        }
	      }
	    }, _callee318, this);
	  }));
	
	  return function getTransactionListV1(_x309) {
	    return _ref318.apply(this, arguments);
	  };
	}();
	
	var saveSiteContent = function () {
	  var _ref319 = _asyncToGenerator(_regenerator2.default.mark(function _callee319(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee319$(_context319) {
	      while (1) {
	        switch (_context319.prev = _context319.next) {
	          case 0:
	            _context319.next = 2;
	            return fetch(_DomainName2.default.register + 'bewiseapi/cms/saveSiteContent', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context319.sent;
	            return _context319.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context319.stop();
	        }
	      }
	    }, _callee319, this);
	  }));
	
	  return function saveSiteContent(_x310) {
	    return _ref319.apply(this, arguments);
	  };
	}();
	
	var removeCMSSiteContent = function () {
	  var _ref320 = _asyncToGenerator(_regenerator2.default.mark(function _callee320(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee320$(_context320) {
	      while (1) {
	        switch (_context320.prev = _context320.next) {
	          case 0:
	            _context320.next = 2;
	            return fetch(_DomainName2.default.register + 'bewiseapi/cms/removeSiteContent', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context320.sent;
	            return _context320.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context320.stop();
	        }
	      }
	    }, _callee320, this);
	  }));
	
	  return function removeCMSSiteContent(_x311) {
	    return _ref320.apply(this, arguments);
	  };
	}();
	
	var saveMail = function () {
	  var _ref321 = _asyncToGenerator(_regenerator2.default.mark(function _callee321(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee321$(_context321) {
	      while (1) {
	        switch (_context321.prev = _context321.next) {
	          case 0:
	            _context321.next = 2;
	            return fetch(_DomainName2.default.register + 'bewiseapi/cms/saveMail', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context321.sent;
	            return _context321.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context321.stop();
	        }
	      }
	    }, _callee321, this);
	  }));
	
	  return function saveMail(_x312) {
	    return _ref321.apply(this, arguments);
	  };
	}();
	
	var getParentsPaged = function () {
	  var _ref322 = _asyncToGenerator(_regenerator2.default.mark(function _callee322(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee322$(_context322) {
	      while (1) {
	        switch (_context322.prev = _context322.next) {
	          case 0:
	            _context322.next = 2;
	            return fetch(_DomainName2.default.register + 'bewiseapi/users/parentpaged', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context322.sent;
	            return _context322.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context322.stop();
	        }
	      }
	    }, _callee322, this);
	  }));
	
	  return function getParentsPaged(_x313) {
	    return _ref322.apply(this, arguments);
	  };
	}();
	
	var getExclusivePartnersPaged = function () {
	  var _ref323 = _asyncToGenerator(_regenerator2.default.mark(function _callee323(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee323$(_context323) {
	      while (1) {
	        switch (_context323.prev = _context323.next) {
	          case 0:
	            _context323.next = 2;
	            return fetch(_DomainName2.default.register + 'bewiseapi/users/exclusivepartnerspaged', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context323.sent;
	            return _context323.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context323.stop();
	        }
	      }
	    }, _callee323, this);
	  }));
	
	  return function getExclusivePartnersPaged(_x314) {
	    return _ref323.apply(this, arguments);
	  };
	}();
	
	var getPartnerPaged = function () {
	  var _ref324 = _asyncToGenerator(_regenerator2.default.mark(function _callee324(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee324$(_context324) {
	      while (1) {
	        switch (_context324.prev = _context324.next) {
	          case 0:
	            _context324.next = 2;
	            return fetch(_DomainName2.default.register + 'bewiseapi/users/partnerspaged', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context324.sent;
	            return _context324.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context324.stop();
	        }
	      }
	    }, _callee324, this);
	  }));
	
	  return function getPartnerPaged(_x315) {
	    return _ref324.apply(this, arguments);
	  };
	}();
	
	var getPartnerPagedTrashed = function () {
	  var _ref325 = _asyncToGenerator(_regenerator2.default.mark(function _callee325(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee325$(_context325) {
	      while (1) {
	        switch (_context325.prev = _context325.next) {
	          case 0:
	            _context325.next = 2;
	            return fetch(_DomainName2.default.register + 'bewiseapi/users/partnerspagedtrashed', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context325.sent;
	            return _context325.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context325.stop();
	        }
	      }
	    }, _callee325, this);
	  }));
	
	  return function getPartnerPagedTrashed(_x316) {
	    return _ref325.apply(this, arguments);
	  };
	}();
	
	var getBewiseUsersPaged = function () {
	  var _ref326 = _asyncToGenerator(_regenerator2.default.mark(function _callee326(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee326$(_context326) {
	      while (1) {
	        switch (_context326.prev = _context326.next) {
	          case 0:
	            _context326.next = 2;
	            return fetch(_DomainName2.default.register + 'bewiseapi/users/bewiseuserspaged', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context326.sent;
	            return _context326.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context326.stop();
	        }
	      }
	    }, _callee326, this);
	  }));
	
	  return function getBewiseUsersPaged(_x317) {
	    return _ref326.apply(this, arguments);
	  };
	}();
	
	var getPromoCodeList = function () {
	  var _ref327 = _asyncToGenerator(_regenerator2.default.mark(function _callee327(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee327$(_context327) {
	      while (1) {
	        switch (_context327.prev = _context327.next) {
	          case 0:
	            _context327.next = 2;
	            return fetch(_DomainName2.default.register + 'bewiseapi/admin/getPromoCodes', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context327.sent;
	            return _context327.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context327.stop();
	        }
	      }
	    }, _callee327, this);
	  }));
	
	  return function getPromoCodeList(_x318) {
	    return _ref327.apply(this, arguments);
	  };
	}();
	
	var getResourceList = function () {
	  var _ref328 = _asyncToGenerator(_regenerator2.default.mark(function _callee328(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee328$(_context328) {
	      while (1) {
	        switch (_context328.prev = _context328.next) {
	          case 0:
	            _context328.next = 2;
	            return fetch(_DomainName2.default.register + 'bewiseapi/admin/get_resource_list', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context328.sent;
	            return _context328.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context328.stop();
	        }
	      }
	    }, _callee328, this);
	  }));
	
	  return function getResourceList(_x319) {
	    return _ref328.apply(this, arguments);
	  };
	}();
	
	var getBeWiseCuratedCampList = function () {
	  var _ref329 = _asyncToGenerator(_regenerator2.default.mark(function _callee329(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee329$(_context329) {
	      while (1) {
	        switch (_context329.prev = _context329.next) {
	          case 0:
	            _context329.next = 2;
	            return fetch(_DomainName2.default.register + 'bewiseapi/admin/get_bewise_curated_camps', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context329.sent;
	            return _context329.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context329.stop();
	        }
	      }
	    }, _callee329, this);
	  }));
	
	  return function getBeWiseCuratedCampList(_x320) {
	    return _ref329.apply(this, arguments);
	  };
	}();
	
	var getNewsList = function () {
	  var _ref330 = _asyncToGenerator(_regenerator2.default.mark(function _callee330(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee330$(_context330) {
	      while (1) {
	        switch (_context330.prev = _context330.next) {
	          case 0:
	            _context330.next = 2;
	            return fetch(_DomainName2.default.register + 'bewiseapi/cms/get_news', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context330.sent;
	            return _context330.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context330.stop();
	        }
	      }
	    }, _callee330, this);
	  }));
	
	  return function getNewsList(_x321) {
	    return _ref330.apply(this, arguments);
	  };
	}();
	
	var getSpecialPageList = function () {
	  var _ref331 = _asyncToGenerator(_regenerator2.default.mark(function _callee331(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee331$(_context331) {
	      while (1) {
	        switch (_context331.prev = _context331.next) {
	          case 0:
	            _context331.next = 2;
	            return fetch(_DomainName2.default.register + 'bewiseapi/cms/get_pages', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context331.sent;
	            return _context331.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context331.stop();
	        }
	      }
	    }, _callee331, this);
	  }));
	
	  return function getSpecialPageList(_x322) {
	    return _ref331.apply(this, arguments);
	  };
	}();
	
	var getNews = function () {
	  var _ref332 = _asyncToGenerator(_regenerator2.default.mark(function _callee332(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee332$(_context332) {
	      while (1) {
	        switch (_context332.prev = _context332.next) {
	          case 0:
	            _context332.next = 2;
	            return fetch(_DomainName2.default.register + 'bewiseapi/cms/get_news_single', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context332.sent;
	            return _context332.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context332.stop();
	        }
	      }
	    }, _callee332, this);
	  }));
	
	  return function getNews(_x323) {
	    return _ref332.apply(this, arguments);
	  };
	}();
	
	var saveNews = function () {
	  var _ref333 = _asyncToGenerator(_regenerator2.default.mark(function _callee333(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee333$(_context333) {
	      while (1) {
	        switch (_context333.prev = _context333.next) {
	          case 0:
	            _context333.next = 2;
	            return fetch(_DomainName2.default.register + 'bewiseapi/cms/saveNews', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context333.sent;
	            return _context333.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context333.stop();
	        }
	      }
	    }, _callee333, this);
	  }));
	
	  return function saveNews(_x324) {
	    return _ref333.apply(this, arguments);
	  };
	}();
	
	var getArticleDetail = function () {
	  var _ref334 = _asyncToGenerator(_regenerator2.default.mark(function _callee334(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee334$(_context334) {
	      while (1) {
	        switch (_context334.prev = _context334.next) {
	          case 0:
	            _context334.next = 2;
	            return fetch(_DomainName2.default.register + 'bewiseapi/insights/getBlogDetail', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context334.sent;
	            return _context334.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context334.stop();
	        }
	      }
	    }, _callee334, this);
	  }));
	
	  return function getArticleDetail(_x325) {
	    return _ref334.apply(this, arguments);
	  };
	}();
	
	var getWebsiteAds = function () {
	  var _ref335 = _asyncToGenerator(_regenerator2.default.mark(function _callee335() {
	    var result;
	    return _regenerator2.default.wrap(function _callee335$(_context335) {
	      while (1) {
	        switch (_context335.prev = _context335.next) {
	          case 0:
	            _context335.next = 2;
	            return fetch(_DomainName2.default.register + 'bewiseapi/cms/getOtherads', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              }
	            });
	
	          case 2:
	            result = _context335.sent;
	            return _context335.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context335.stop();
	        }
	      }
	    }, _callee335, this);
	  }));
	
	  return function getWebsiteAds() {
	    return _ref335.apply(this, arguments);
	  };
	}();
	
	var getRoleDetail = function () {
	  var _ref336 = _asyncToGenerator(_regenerator2.default.mark(function _callee336(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee336$(_context336) {
	      while (1) {
	        switch (_context336.prev = _context336.next) {
	          case 0:
	            _context336.next = 2;
	            return fetch(_DomainName2.default.register + 'bewiseapi/admin/getRoleDetail', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context336.sent;
	            return _context336.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context336.stop();
	        }
	      }
	    }, _callee336, this);
	  }));
	
	  return function getRoleDetail(_x326) {
	    return _ref336.apply(this, arguments);
	  };
	}();
	
	var getMailCampaignList = function () {
	  var _ref337 = _asyncToGenerator(_regenerator2.default.mark(function _callee337(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee337$(_context337) {
	      while (1) {
	        switch (_context337.prev = _context337.next) {
	          case 0:
	            _context337.next = 2;
	            return fetch(_DomainName2.default.register + 'campaign/mail/getlist', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context337.sent;
	
	            console.log('Success');
	            return _context337.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context337.stop();
	        }
	      }
	    }, _callee337, this);
	  }));
	
	  return function getMailCampaignList(_x327) {
	    return _ref337.apply(this, arguments);
	  };
	}();
	
	var uploadEmailImage = function () {
	  var _ref338 = _asyncToGenerator(_regenerator2.default.mark(function _callee338(formData) {
	    var result;
	    return _regenerator2.default.wrap(function _callee338$(_context338) {
	      while (1) {
	        switch (_context338.prev = _context338.next) {
	          case 0:
	            _context338.next = 2;
	            return fetch(_DomainName2.default.register + 'campaign/mail/uploadimage', {
	              method: 'POST',
	              mode: 'cors',
	              headers: { 'x-auth-token': token },
	              body: formData
	            });
	
	          case 2:
	            result = _context338.sent;
	
	            console.log('Success');
	            return _context338.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context338.stop();
	        }
	      }
	    }, _callee338, this);
	  }));
	
	  return function uploadEmailImage(_x328) {
	    return _ref338.apply(this, arguments);
	  };
	}();
	
	var saveEmailCampaign = function () {
	  var _ref339 = _asyncToGenerator(_regenerator2.default.mark(function _callee339(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee339$(_context339) {
	      while (1) {
	        switch (_context339.prev = _context339.next) {
	          case 0:
	            _context339.next = 2;
	            return fetch(_DomainName2.default.register + 'campaign/mail/savecampaign', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context339.sent;
	            return _context339.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context339.stop();
	        }
	      }
	    }, _callee339, this);
	  }));
	
	  return function saveEmailCampaign(_x329) {
	    return _ref339.apply(this, arguments);
	  };
	}();
	
	var updateEmailCampaign = function () {
	  var _ref340 = _asyncToGenerator(_regenerator2.default.mark(function _callee340(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee340$(_context340) {
	      while (1) {
	        switch (_context340.prev = _context340.next) {
	          case 0:
	            _context340.next = 2;
	            return fetch(_DomainName2.default.register + 'campaign/mail/updatecampaign', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context340.sent;
	            return _context340.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context340.stop();
	        }
	      }
	    }, _callee340, this);
	  }));
	
	  return function updateEmailCampaign(_x330) {
	    return _ref340.apply(this, arguments);
	  };
	}();
	
	var startEmailCampaign = function () {
	  var _ref341 = _asyncToGenerator(_regenerator2.default.mark(function _callee341(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee341$(_context341) {
	      while (1) {
	        switch (_context341.prev = _context341.next) {
	          case 0:
	            _context341.next = 2;
	            return fetch(_DomainName2.default.register + 'campaign/mail/savestartcampaign', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context341.sent;
	            return _context341.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context341.stop();
	        }
	      }
	    }, _callee341, this);
	  }));
	
	  return function startEmailCampaign(_x331) {
	    return _ref341.apply(this, arguments);
	  };
	}();
	
	var getEmailCampaign = function () {
	  var _ref342 = _asyncToGenerator(_regenerator2.default.mark(function _callee342(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee342$(_context342) {
	      while (1) {
	        switch (_context342.prev = _context342.next) {
	          case 0:
	            _context342.next = 2;
	            return fetch(_DomainName2.default.register + 'campaign/mail/getDetail', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context342.sent;
	
	            console.log('Success');
	            return _context342.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context342.stop();
	        }
	      }
	    }, _callee342, this);
	  }));
	
	  return function getEmailCampaign(_x332) {
	    return _ref342.apply(this, arguments);
	  };
	}();
	
	var getCampaignMailInfo = function () {
	  var _ref343 = _asyncToGenerator(_regenerator2.default.mark(function _callee343(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee343$(_context343) {
	      while (1) {
	        switch (_context343.prev = _context343.next) {
	          case 0:
	            _context343.next = 2;
	            return fetch(_DomainName2.default.register + 'campaign/mail/getmailinfo', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context343.sent;
	            return _context343.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context343.stop();
	        }
	      }
	    }, _callee343, this);
	  }));
	
	  return function getCampaignMailInfo(_x333) {
	    return _ref343.apply(this, arguments);
	  };
	}();
	
	var cancelCampaign = function () {
	  var _ref344 = _asyncToGenerator(_regenerator2.default.mark(function _callee344(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee344$(_context344) {
	      while (1) {
	        switch (_context344.prev = _context344.next) {
	          case 0:
	            _context344.next = 2;
	            return fetch(_DomainName2.default.register + 'campaign/mail/canceljob', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context344.sent;
	            return _context344.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context344.stop();
	        }
	      }
	    }, _callee344, this);
	  }));
	
	  return function cancelCampaign(_x334) {
	    return _ref344.apply(this, arguments);
	  };
	}();
	
	var savePayLink = function () {
	  var _ref345 = _asyncToGenerator(_regenerator2.default.mark(function _callee345(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee345$(_context345) {
	      while (1) {
	        switch (_context345.prev = _context345.next) {
	          case 0:
	            _context345.next = 2;
	            return fetch(_DomainName2.default.register + 'razorpay/common/savegeneratedlink', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context345.sent;
	            return _context345.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context345.stop();
	        }
	      }
	    }, _callee345, this);
	  }));
	
	  return function savePayLink(_x335) {
	    return _ref345.apply(this, arguments);
	  };
	}();
	
	var cancelRemoveCampaign = function () {
	  var _ref346 = _asyncToGenerator(_regenerator2.default.mark(function _callee346(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee346$(_context346) {
	      while (1) {
	        switch (_context346.prev = _context346.next) {
	          case 0:
	            _context346.next = 2;
	            return fetch(_DomainName2.default.register + 'campaign/mail/cancelremovejob', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context346.sent;
	            return _context346.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context346.stop();
	        }
	      }
	    }, _callee346, this);
	  }));
	
	  return function cancelRemoveCampaign(_x336) {
	    return _ref346.apply(this, arguments);
	  };
	}();
	
	var getCampaignBatches = function () {
	  var _ref347 = _asyncToGenerator(_regenerator2.default.mark(function _callee347(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee347$(_context347) {
	      while (1) {
	        switch (_context347.prev = _context347.next) {
	          case 0:
	            _context347.next = 2;
	            return fetch(_DomainName2.default.register + 'campaign/mail/getCampaignBatch', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context347.sent;
	            return _context347.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context347.stop();
	        }
	      }
	    }, _callee347, this);
	  }));
	
	  return function getCampaignBatches(_x337) {
	    return _ref347.apply(this, arguments);
	  };
	}();
	
	var getAllUnpaidUsers = function () {
	  var _ref348 = _asyncToGenerator(_regenerator2.default.mark(function _callee348(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee348$(_context348) {
	      while (1) {
	        switch (_context348.prev = _context348.next) {
	          case 0:
	            _context348.next = 2;
	            return fetch(_DomainName2.default.register + 'campaign/mail/getAllUnpaidUsers', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context348.sent;
	            return _context348.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context348.stop();
	        }
	      }
	    }, _callee348, this);
	  }));
	
	  return function getAllUnpaidUsers(_x338) {
	    return _ref348.apply(this, arguments);
	  };
	}();
	
	var updateOpt = function () {
	  var _ref349 = _asyncToGenerator(_regenerator2.default.mark(function _callee349(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee349$(_context349) {
	      while (1) {
	        switch (_context349.prev = _context349.next) {
	          case 0:
	            _context349.next = 2;
	            return fetch(_DomainName2.default.register + 'campaign/mail/updateOpt', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context349.sent;
	            return _context349.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context349.stop();
	        }
	      }
	    }, _callee349, this);
	  }));
	
	  return function updateOpt(_x339) {
	    return _ref349.apply(this, arguments);
	  };
	}();
	
	var getJobs = function () {
	  var _ref350 = _asyncToGenerator(_regenerator2.default.mark(function _callee350(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee350$(_context350) {
	      while (1) {
	        switch (_context350.prev = _context350.next) {
	          case 0:
	            _context350.next = 2;
	            return fetch(_DomainName2.default.register + 'campaign/mail/getJobs', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context350.sent;
	            return _context350.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context350.stop();
	        }
	      }
	    }, _callee350, this);
	  }));
	
	  return function getJobs(_x340) {
	    return _ref350.apply(this, arguments);
	  };
	}();
	
	var getIncompleteLeads = function () {
	  var _ref351 = _asyncToGenerator(_regenerator2.default.mark(function _callee351() {
	    var result;
	    return _regenerator2.default.wrap(function _callee351$(_context351) {
	      while (1) {
	        switch (_context351.prev = _context351.next) {
	          case 0:
	            _context351.next = 2;
	            return fetch(_DomainName2.default.register + 'leads/processlead/getIncompleteLeads', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              }
	            });
	
	          case 2:
	            result = _context351.sent;
	            return _context351.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context351.stop();
	        }
	      }
	    }, _callee351, this);
	  }));
	
	  return function getIncompleteLeads() {
	    return _ref351.apply(this, arguments);
	  };
	}();
	
	var CheckCreatePartner = function () {
	  var _ref352 = _asyncToGenerator(_regenerator2.default.mark(function _callee352(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee352$(_context352) {
	      while (1) {
	        switch (_context352.prev = _context352.next) {
	          case 0:
	            _context352.next = 2;
	            return fetch(_DomainName2.default.register + 'razorpay/common/register_partner_by_admin', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context352.sent;
	            return _context352.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context352.stop();
	        }
	      }
	    }, _callee352, this);
	  }));
	
	  return function CheckCreatePartner(_x341) {
	    return _ref352.apply(this, arguments);
	  };
	}();
	
	var getJobsList = function () {
	  var _ref353 = _asyncToGenerator(_regenerator2.default.mark(function _callee353() {
	    var result;
	    return _regenerator2.default.wrap(function _callee353$(_context353) {
	      while (1) {
	        switch (_context353.prev = _context353.next) {
	          case 0:
	            _context353.next = 2;
	            return fetch(_DomainName2.default.register + 'jobs/getJobsList', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              }
	            });
	
	          case 2:
	            result = _context353.sent;
	            return _context353.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context353.stop();
	        }
	      }
	    }, _callee353, this);
	  }));
	
	  return function getJobsList() {
	    return _ref353.apply(this, arguments);
	  };
	}();
	
	var getAreaNamesList = function () {
	  var _ref354 = _asyncToGenerator(_regenerator2.default.mark(function _callee354() {
	    var result;
	    return _regenerator2.default.wrap(function _callee354$(_context354) {
	      while (1) {
	        switch (_context354.prev = _context354.next) {
	          case 0:
	            _context354.next = 2;
	            return fetch(_DomainName2.default.register + 'admin/common/getAreaList', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              }
	            });
	
	          case 2:
	            result = _context354.sent;
	            return _context354.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context354.stop();
	        }
	      }
	    }, _callee354, this);
	  }));
	
	  return function getAreaNamesList() {
	    return _ref354.apply(this, arguments);
	  };
	}();
	
	var saveArea = function () {
	  var _ref355 = _asyncToGenerator(_regenerator2.default.mark(function _callee355(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee355$(_context355) {
	      while (1) {
	        switch (_context355.prev = _context355.next) {
	          case 0:
	            _context355.next = 2;
	            return fetch(_DomainName2.default.register + 'admin/common/saveareaname', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context355.sent;
	            return _context355.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context355.stop();
	        }
	      }
	    }, _callee355, this);
	  }));
	
	  return function saveArea(_x342) {
	    return _ref355.apply(this, arguments);
	  };
	}();
	
	var verifyVendor = function () {
	  var _ref356 = _asyncToGenerator(_regenerator2.default.mark(function _callee356(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee356$(_context356) {
	      while (1) {
	        switch (_context356.prev = _context356.next) {
	          case 0:
	            _context356.next = 2;
	            return fetch(_DomainName2.default.register + 'login/verifyOTP', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context356.sent;
	
	            console.log('Success');
	            return _context356.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context356.stop();
	        }
	      }
	    }, _callee356, this);
	  }));
	
	  return function verifyVendor(_x343) {
	    return _ref356.apply(this, arguments);
	  };
	}();
	
	var findpartnersendotplink = function () {
	  var _ref357 = _asyncToGenerator(_regenerator2.default.mark(function _callee357(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee357$(_context357) {
	      while (1) {
	        switch (_context357.prev = _context357.next) {
	          case 0:
	            _context357.next = 2;
	            return fetch(_DomainName2.default.register + 'user/auth/sendOTPlink', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context357.sent;
	
	            console.log('Success');
	            return _context357.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context357.stop();
	        }
	      }
	    }, _callee357, this);
	  }));
	
	  return function findpartnersendotplink(_x344) {
	    return _ref357.apply(this, arguments);
	  };
	}();
	
	var deleteOtherAdEntry = function () {
	  var _ref358 = _asyncToGenerator(_regenerator2.default.mark(function _callee358(data) {
	    var t, result;
	    return _regenerator2.default.wrap(function _callee358$(_context358) {
	      while (1) {
	        switch (_context358.prev = _context358.next) {
	          case 0:
	            t = JSON.parse(data);
	            _context358.next = 3;
	            return fetch(_DomainName2.default.register + 'exclusive/common/delete_ad_other', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 3:
	            result = _context358.sent;
	            return _context358.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context358.stop();
	        }
	      }
	    }, _callee358, this);
	  }));
	
	  return function deleteOtherAdEntry(_x345) {
	    return _ref358.apply(this, arguments);
	  };
	}();
	
	var getInsightListPaged = function () {
	  var _ref359 = _asyncToGenerator(_regenerator2.default.mark(function _callee359(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee359$(_context359) {
	      while (1) {
	        switch (_context359.prev = _context359.next) {
	          case 0:
	            _context359.next = 2;
	            return fetch(_DomainName2.default.register + 'bewiseapi/insights/insightspaged', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context359.sent;
	            return _context359.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context359.stop();
	        }
	      }
	    }, _callee359, this);
	  }));
	
	  return function getInsightListPaged(_x346) {
	    return _ref359.apply(this, arguments);
	  };
	}();
	
	var getInsightListTotal = function () {
	  var _ref360 = _asyncToGenerator(_regenerator2.default.mark(function _callee360(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee360$(_context360) {
	      while (1) {
	        switch (_context360.prev = _context360.next) {
	          case 0:
	            _context360.next = 2;
	            return fetch(_DomainName2.default.register + 'bewiseapi/insights/insightstotal', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context360.sent;
	            return _context360.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context360.stop();
	        }
	      }
	    }, _callee360, this);
	  }));
	
	  return function getInsightListTotal(_x347) {
	    return _ref360.apply(this, arguments);
	  };
	}();
	
	var getTotalUsers = function () {
	  var _ref361 = _asyncToGenerator(_regenerator2.default.mark(function _callee361() {
	    var result;
	    return _regenerator2.default.wrap(function _callee361$(_context361) {
	      while (1) {
	        switch (_context361.prev = _context361.next) {
	          case 0:
	            _context361.next = 2;
	            return fetch(_DomainName2.default.register + 'bewiseapi/users/getTotalUsers', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              }
	            });
	
	          case 2:
	            result = _context361.sent;
	            return _context361.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context361.stop();
	        }
	      }
	    }, _callee361, this);
	  }));
	
	  return function getTotalUsers() {
	    return _ref361.apply(this, arguments);
	  };
	}();
	
	var LoginBeWise = function () {
	  var _ref362 = _asyncToGenerator(_regenerator2.default.mark(function _callee362(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee362$(_context362) {
	      while (1) {
	        switch (_context362.prev = _context362.next) {
	          case 0:
	            _context362.next = 2;
	            return fetch(_DomainName2.default.register + 'bewiseapi/login', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context362.sent;
	
	            console.log('Success');
	            return _context362.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context362.stop();
	        }
	      }
	    }, _callee362, this);
	  }));
	
	  return function LoginBeWise(_x348) {
	    return _ref362.apply(this, arguments);
	  };
	}();
	
	var getLatestNews = function () {
	  var _ref363 = _asyncToGenerator(_regenerator2.default.mark(function _callee363() {
	    var result;
	    return _regenerator2.default.wrap(function _callee363$(_context363) {
	      while (1) {
	        switch (_context363.prev = _context363.next) {
	          case 0:
	            _context363.next = 2;
	            return fetch(_DomainName2.default.register + 'bewiseapi/users/getLatestNews', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              }
	            });
	
	          case 2:
	            result = _context363.sent;
	            return _context363.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context363.stop();
	        }
	      }
	    }, _callee363, this);
	  }));
	
	  return function getLatestNews() {
	    return _ref363.apply(this, arguments);
	  };
	}();
	
	var getCuratedCampListV2 = function () {
	  var _ref364 = _asyncToGenerator(_regenerator2.default.mark(function _callee364(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee364$(_context364) {
	      while (1) {
	        switch (_context364.prev = _context364.next) {
	          case 0:
	            _context364.next = 2;
	            return fetch(_DomainName2.default.register + 'curatedcamps/getlistV2', {
	              method: 'POST',
	              'x-auth-token': token,
	              mode: 'cors',
	              headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
	              body: data
	            });
	
	          case 2:
	            result = _context364.sent;
	            return _context364.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context364.stop();
	        }
	      }
	    }, _callee364, this);
	  }));
	
	  return function getCuratedCampListV2(_x349) {
	    return _ref364.apply(this, arguments);
	  };
	}();
	
	var partnerArticles = function () {
	  var _ref365 = _asyncToGenerator(_regenerator2.default.mark(function _callee365(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee365$(_context365) {
	      while (1) {
	        switch (_context365.prev = _context365.next) {
	          case 0:
	            _context365.next = 2;
	            return fetch(_DomainName2.default.register + 'bewiseapi/insights/getArticlesByPartner', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context365.sent;
	            return _context365.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context365.stop();
	        }
	      }
	    }, _callee365, this);
	  }));
	
	  return function partnerArticles(_x350) {
	    return _ref365.apply(this, arguments);
	  };
	}();
	
	var beWiseArticles = function () {
	  var _ref366 = _asyncToGenerator(_regenerator2.default.mark(function _callee366() {
	    var result;
	    return _regenerator2.default.wrap(function _callee366$(_context366) {
	      while (1) {
	        switch (_context366.prev = _context366.next) {
	          case 0:
	            _context366.next = 2;
	            return fetch(_DomainName2.default.register + 'bewiseapi/insights/beWiseArticles', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              }
	            });
	
	          case 2:
	            result = _context366.sent;
	            return _context366.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context366.stop();
	        }
	      }
	    }, _callee366, this);
	  }));
	
	  return function beWiseArticles() {
	    return _ref366.apply(this, arguments);
	  };
	}();
	
	var schoolCount = function () {
	  var _ref367 = _asyncToGenerator(_regenerator2.default.mark(function _callee367() {
	    var result;
	    return _regenerator2.default.wrap(function _callee367$(_context367) {
	      while (1) {
	        switch (_context367.prev = _context367.next) {
	          case 0:
	            _context367.next = 2;
	            return fetch(_DomainName2.default.register + 'bewiseapi/school/totalcount', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              }
	            });
	
	          case 2:
	            result = _context367.sent;
	            return _context367.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context367.stop();
	        }
	      }
	    }, _callee367, this);
	  }));
	
	  return function schoolCount() {
	    return _ref367.apply(this, arguments);
	  };
	}();
	
	var tuitionCount = function () {
	  var _ref368 = _asyncToGenerator(_regenerator2.default.mark(function _callee368() {
	    var result;
	    return _regenerator2.default.wrap(function _callee368$(_context368) {
	      while (1) {
	        switch (_context368.prev = _context368.next) {
	          case 0:
	            _context368.next = 2;
	            return fetch(_DomainName2.default.register + 'bewiseapi/tuition/totalcount', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              }
	            });
	
	          case 2:
	            result = _context368.sent;
	            return _context368.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context368.stop();
	        }
	      }
	    }, _callee368, this);
	  }));
	
	  return function tuitionCount() {
	    return _ref368.apply(this, arguments);
	  };
	}();
	
	var preschoolCount = function () {
	  var _ref369 = _asyncToGenerator(_regenerator2.default.mark(function _callee369() {
	    var result;
	    return _regenerator2.default.wrap(function _callee369$(_context369) {
	      while (1) {
	        switch (_context369.prev = _context369.next) {
	          case 0:
	            _context369.next = 2;
	            return fetch(_DomainName2.default.register + 'bewiseapi/preschool/totalcount', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              }
	            });
	
	          case 2:
	            result = _context369.sent;
	            return _context369.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context369.stop();
	        }
	      }
	    }, _callee369, this);
	  }));
	
	  return function preschoolCount() {
	    return _ref369.apply(this, arguments);
	  };
	}();
	
	var afaCount = function () {
	  var _ref370 = _asyncToGenerator(_regenerator2.default.mark(function _callee370() {
	    var result;
	    return _regenerator2.default.wrap(function _callee370$(_context370) {
	      while (1) {
	        switch (_context370.prev = _context370.next) {
	          case 0:
	            _context370.next = 2;
	            return fetch(_DomainName2.default.register + 'bewiseapi/afa/totalcount', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              }
	            });
	
	          case 2:
	            result = _context370.sent;
	            return _context370.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context370.stop();
	        }
	      }
	    }, _callee370, this);
	  }));
	
	  return function afaCount() {
	    return _ref370.apply(this, arguments);
	  };
	}();
	
	var learningcampCount = function () {
	  var _ref371 = _asyncToGenerator(_regenerator2.default.mark(function _callee371() {
	    var result;
	    return _regenerator2.default.wrap(function _callee371$(_context371) {
	      while (1) {
	        switch (_context371.prev = _context371.next) {
	          case 0:
	            _context371.next = 2;
	            return fetch(_DomainName2.default.register + 'bewiseapi/camps/totalcount', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              }
	            });
	
	          case 2:
	            result = _context371.sent;
	            return _context371.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context371.stop();
	        }
	      }
	    }, _callee371, this);
	  }));
	
	  return function learningcampCount() {
	    return _ref371.apply(this, arguments);
	  };
	}();
	
	var eventsCount = function () {
	  var _ref372 = _asyncToGenerator(_regenerator2.default.mark(function _callee372() {
	    var result;
	    return _regenerator2.default.wrap(function _callee372$(_context372) {
	      while (1) {
	        switch (_context372.prev = _context372.next) {
	          case 0:
	            _context372.next = 2;
	            return fetch(_DomainName2.default.register + 'bewiseapi/events/totalcount', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              }
	            });
	
	          case 2:
	            result = _context372.sent;
	            return _context372.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context372.stop();
	        }
	      }
	    }, _callee372, this);
	  }));
	
	  return function eventsCount() {
	    return _ref372.apply(this, arguments);
	  };
	}();
	
	var removethisItem = function () {
	  var _ref373 = _asyncToGenerator(_regenerator2.default.mark(function _callee373(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee373$(_context373) {
	      while (1) {
	        switch (_context373.prev = _context373.next) {
	          case 0:
	            _context373.next = 2;
	            return fetch(_DomainName2.default.register + 'bewiseapi/general/removethisItem', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context373.sent;
	            return _context373.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context373.stop();
	        }
	      }
	    }, _callee373, this);
	  }));
	
	  return function removethisItem(_x351) {
	    return _ref373.apply(this, arguments);
	  };
	}();
	
	var removeExclUser = function () {
	  var _ref374 = _asyncToGenerator(_regenerator2.default.mark(function _callee374(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee374$(_context374) {
	      while (1) {
	        switch (_context374.prev = _context374.next) {
	          case 0:
	            _context374.next = 2;
	            return fetch(_DomainName2.default.register + 'bewiseapi/general/removeexclusiveuser', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context374.sent;
	            return _context374.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context374.stop();
	        }
	      }
	    }, _callee374, this);
	  }));
	
	  return function removeExclUser(_x352) {
	    return _ref374.apply(this, arguments);
	  };
	}();
	
	var movetoTrash = function () {
	  var _ref375 = _asyncToGenerator(_regenerator2.default.mark(function _callee375(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee375$(_context375) {
	      while (1) {
	        switch (_context375.prev = _context375.next) {
	          case 0:
	            _context375.next = 2;
	            return fetch(_DomainName2.default.register + 'bewiseapi/general/movetotrash', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context375.sent;
	            return _context375.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context375.stop();
	        }
	      }
	    }, _callee375, this);
	  }));
	
	  return function movetoTrash(_x353) {
	    return _ref375.apply(this, arguments);
	  };
	}();
	
	var activatePartner = function () {
	  var _ref376 = _asyncToGenerator(_regenerator2.default.mark(function _callee376(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee376$(_context376) {
	      while (1) {
	        switch (_context376.prev = _context376.next) {
	          case 0:
	            _context376.next = 2;
	            return fetch(_DomainName2.default.register + 'bewiseapi/general/activatepartner', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context376.sent;
	            return _context376.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context376.stop();
	        }
	      }
	    }, _callee376, this);
	  }));
	
	  return function activatePartner(_x354) {
	    return _ref376.apply(this, arguments);
	  };
	}();
	
	var deActivatePartner = function () {
	  var _ref377 = _asyncToGenerator(_regenerator2.default.mark(function _callee377(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee377$(_context377) {
	      while (1) {
	        switch (_context377.prev = _context377.next) {
	          case 0:
	            _context377.next = 2;
	            return fetch(_DomainName2.default.register + 'bewiseapi/general/deactivatepartner', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context377.sent;
	            return _context377.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context377.stop();
	        }
	      }
	    }, _callee377, this);
	  }));
	
	  return function deActivatePartner(_x355) {
	    return _ref377.apply(this, arguments);
	  };
	}();
	
	var getTotal = function () {
	  var _ref378 = _asyncToGenerator(_regenerator2.default.mark(function _callee378(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee378$(_context378) {
	      while (1) {
	        switch (_context378.prev = _context378.next) {
	          case 0:
	            _context378.next = 2;
	            return fetch(_DomainName2.default.register + 'bewiseapi/general/getTotal', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context378.sent;
	            return _context378.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context378.stop();
	        }
	      }
	    }, _callee378, this);
	  }));
	
	  return function getTotal(_x356) {
	    return _ref378.apply(this, arguments);
	  };
	}();
	
	var getTotalPartners = function () {
	  var _ref379 = _asyncToGenerator(_regenerator2.default.mark(function _callee379(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee379$(_context379) {
	      while (1) {
	        switch (_context379.prev = _context379.next) {
	          case 0:
	            _context379.next = 2;
	            return fetch(_DomainName2.default.register + 'bewiseapi/users/partnertotal', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context379.sent;
	            return _context379.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context379.stop();
	        }
	      }
	    }, _callee379, this);
	  }));
	
	  return function getTotalPartners(_x357) {
	    return _ref379.apply(this, arguments);
	  };
	}();
	
	var getTotalPartnersTrashed = function () {
	  var _ref380 = _asyncToGenerator(_regenerator2.default.mark(function _callee380(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee380$(_context380) {
	      while (1) {
	        switch (_context380.prev = _context380.next) {
	          case 0:
	            _context380.next = 2;
	            return fetch(_DomainName2.default.register + 'bewiseapi/users/partnertotaltrashed', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context380.sent;
	            return _context380.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context380.stop();
	        }
	      }
	    }, _callee380, this);
	  }));
	
	  return function getTotalPartnersTrashed(_x358) {
	    return _ref380.apply(this, arguments);
	  };
	}();
	
	var getTotalParents = function () {
	  var _ref381 = _asyncToGenerator(_regenerator2.default.mark(function _callee381(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee381$(_context381) {
	      while (1) {
	        switch (_context381.prev = _context381.next) {
	          case 0:
	            _context381.next = 2;
	            return fetch(_DomainName2.default.register + 'bewiseapi/users/parentstotal', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context381.sent;
	            return _context381.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context381.stop();
	        }
	      }
	    }, _callee381, this);
	  }));
	
	  return function getTotalParents(_x359) {
	    return _ref381.apply(this, arguments);
	  };
	}();
	
	var getTotalBewiseUsers = function () {
	  var _ref382 = _asyncToGenerator(_regenerator2.default.mark(function _callee382(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee382$(_context382) {
	      while (1) {
	        switch (_context382.prev = _context382.next) {
	          case 0:
	            _context382.next = 2;
	            return fetch(_DomainName2.default.register + 'bewiseapi/users/bewiseuserstotal', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context382.sent;
	            return _context382.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context382.stop();
	        }
	      }
	    }, _callee382, this);
	  }));
	
	  return function getTotalBewiseUsers(_x360) {
	    return _ref382.apply(this, arguments);
	  };
	}();
	
	var getTotalTransactions = function () {
	  var _ref383 = _asyncToGenerator(_regenerator2.default.mark(function _callee383(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee383$(_context383) {
	      while (1) {
	        switch (_context383.prev = _context383.next) {
	          case 0:
	            _context383.next = 2;
	            return fetch(_DomainName2.default.register + 'bewiseapi/payments/gettotaltransactions', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context383.sent;
	            return _context383.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context383.stop();
	        }
	      }
	    }, _callee383, this);
	  }));
	
	  return function getTotalTransactions(_x361) {
	    return _ref383.apply(this, arguments);
	  };
	}();
	
	var getLeads = function () {
	  var _ref384 = _asyncToGenerator(_regenerator2.default.mark(function _callee384(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee384$(_context384) {
	      while (1) {
	        switch (_context384.prev = _context384.next) {
	          case 0:
	            _context384.next = 2;
	            return fetch(_DomainName2.default.register + 'leads/processlead/getLeadsAdmin', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context384.sent;
	            return _context384.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context384.stop();
	        }
	      }
	    }, _callee384, this);
	  }));
	
	  return function getLeads(_x362) {
	    return _ref384.apply(this, arguments);
	  };
	}();
	
	var getTotalLeads = function () {
	  var _ref385 = _asyncToGenerator(_regenerator2.default.mark(function _callee385(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee385$(_context385) {
	      while (1) {
	        switch (_context385.prev = _context385.next) {
	          case 0:
	            _context385.next = 2;
	            return fetch(_DomainName2.default.register + 'leads/processlead/getTotalLeads', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context385.sent;
	            return _context385.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context385.stop();
	        }
	      }
	    }, _callee385, this);
	  }));
	
	  return function getTotalLeads(_x363) {
	    return _ref385.apply(this, arguments);
	  };
	}();
	
	var findTeachers = function () {
	  var _ref386 = _asyncToGenerator(_regenerator2.default.mark(function _callee386(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee386$(_context386) {
	      while (1) {
	        switch (_context386.prev = _context386.next) {
	          case 0:
	            _context386.next = 2;
	            return fetch(_DomainName2.default.register + 'bewiseapi/wiseconnect/find', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context386.sent;
	            return _context386.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context386.stop();
	        }
	      }
	    }, _callee386, this);
	  }));
	
	  return function findTeachers(_x364) {
	    return _ref386.apply(this, arguments);
	  };
	}();
	
	var checkifduplicateExist = function () {
	  var _ref387 = _asyncToGenerator(_regenerator2.default.mark(function _callee387(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee387$(_context387) {
	      while (1) {
	        switch (_context387.prev = _context387.next) {
	          case 0:
	            _context387.next = 2;
	            return fetch(_DomainName2.default.register + 'bewiseapi/general/checkifduplicateExist', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context387.sent;
	            return _context387.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context387.stop();
	        }
	      }
	    }, _callee387, this);
	  }));
	
	  return function checkifduplicateExist(_x365) {
	    return _ref387.apply(this, arguments);
	  };
	}();
	
	var checkDuplicateUrl = function () {
	  var _ref388 = _asyncToGenerator(_regenerator2.default.mark(function _callee388(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee388$(_context388) {
	      while (1) {
	        switch (_context388.prev = _context388.next) {
	          case 0:
	            _context388.next = 2;
	            return fetch(_DomainName2.default.register + 'bewiseapi/general/checkDuplicateUrl', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context388.sent;
	            return _context388.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context388.stop();
	        }
	      }
	    }, _callee388, this);
	  }));
	
	  return function checkDuplicateUrl(_x366) {
	    return _ref388.apply(this, arguments);
	  };
	}();
	
	var getTotalSubscribers = function () {
	  var _ref389 = _asyncToGenerator(_regenerator2.default.mark(function _callee389(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee389$(_context389) {
	      while (1) {
	        switch (_context389.prev = _context389.next) {
	          case 0:
	            _context389.next = 2;
	            return fetch(_DomainName2.default.register + 'bewiseapi/wiseconnect/getTotalSubscribers', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context389.sent;
	            return _context389.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context389.stop();
	        }
	      }
	    }, _callee389, this);
	  }));
	
	  return function getTotalSubscribers(_x367) {
	    return _ref389.apply(this, arguments);
	  };
	}();
	
	var getSubscribersListPaged = function () {
	  var _ref390 = _asyncToGenerator(_regenerator2.default.mark(function _callee390(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee390$(_context390) {
	      while (1) {
	        switch (_context390.prev = _context390.next) {
	          case 0:
	            _context390.next = 2;
	            return fetch(_DomainName2.default.register + 'bewiseapi/wiseconnect/getsubscriberspaged', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context390.sent;
	            return _context390.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context390.stop();
	        }
	      }
	    }, _callee390, this);
	  }));
	
	  return function getSubscribersListPaged(_x368) {
	    return _ref390.apply(this, arguments);
	  };
	}();
	
	var getTotalRegistered = function () {
	  var _ref391 = _asyncToGenerator(_regenerator2.default.mark(function _callee391(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee391$(_context391) {
	      while (1) {
	        switch (_context391.prev = _context391.next) {
	          case 0:
	            _context391.next = 2;
	            return fetch(_DomainName2.default.register + 'bewiseapi/wiseconnect/getTotalRegistered', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context391.sent;
	            return _context391.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context391.stop();
	        }
	      }
	    }, _callee391, this);
	  }));
	
	  return function getTotalRegistered(_x369) {
	    return _ref391.apply(this, arguments);
	  };
	}();
	
	var getRegisteredListPaged = function () {
	  var _ref392 = _asyncToGenerator(_regenerator2.default.mark(function _callee392(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee392$(_context392) {
	      while (1) {
	        switch (_context392.prev = _context392.next) {
	          case 0:
	            _context392.next = 2;
	            return fetch(_DomainName2.default.register + 'bewiseapi/wiseconnect/getregisteredpaged', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context392.sent;
	            return _context392.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context392.stop();
	        }
	      }
	    }, _callee392, this);
	  }));
	
	  return function getRegisteredListPaged(_x370) {
	    return _ref392.apply(this, arguments);
	  };
	}();
	
	var getTotalNewsLetterSubscribers = function () {
	  var _ref393 = _asyncToGenerator(_regenerator2.default.mark(function _callee393(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee393$(_context393) {
	      while (1) {
	        switch (_context393.prev = _context393.next) {
	          case 0:
	            _context393.next = 2;
	            return fetch(_DomainName2.default.register + 'bewiseapi/wiseconnect/getTotalNewsLetterSubscribers', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context393.sent;
	            return _context393.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context393.stop();
	        }
	      }
	    }, _callee393, this);
	  }));
	
	  return function getTotalNewsLetterSubscribers(_x371) {
	    return _ref393.apply(this, arguments);
	  };
	}();
	
	var getNewsLetterSubscribersListPaged = function () {
	  var _ref394 = _asyncToGenerator(_regenerator2.default.mark(function _callee394(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee394$(_context394) {
	      while (1) {
	        switch (_context394.prev = _context394.next) {
	          case 0:
	            _context394.next = 2;
	            return fetch(_DomainName2.default.register + 'bewiseapi/wiseconnect/getnewslettersubscriberspaged', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context394.sent;
	            return _context394.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context394.stop();
	        }
	      }
	    }, _callee394, this);
	  }));
	
	  return function getNewsLetterSubscribersListPaged(_x372) {
	    return _ref394.apply(this, arguments);
	  };
	}();
	
	var exportWcSubscribers = function () {
	  var _ref395 = _asyncToGenerator(_regenerator2.default.mark(function _callee395(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee395$(_context395) {
	      while (1) {
	        switch (_context395.prev = _context395.next) {
	          case 0:
	            _context395.next = 2;
	            return fetch(_DomainName2.default.register + 'import_excel/exportWcSubscribers', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context395.sent;
	
	            console.log('Success');
	            return _context395.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context395.stop();
	        }
	      }
	    }, _callee395, this);
	  }));
	
	  return function exportWcSubscribers(_x373) {
	    return _ref395.apply(this, arguments);
	  };
	}();
	
	var getKidsPlayAreaPaged = function () {
	  var _ref396 = _asyncToGenerator(_regenerator2.default.mark(function _callee396(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee396$(_context396) {
	      while (1) {
	        switch (_context396.prev = _context396.next) {
	          case 0:
	            _context396.next = 2;
	            return fetch(_DomainName2.default.register + 'bewiseapi/kidsplayarea/kidsplayareapaged', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context396.sent;
	            return _context396.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context396.stop();
	        }
	      }
	    }, _callee396, this);
	  }));
	
	  return function getKidsPlayAreaPaged(_x374) {
	    return _ref396.apply(this, arguments);
	  };
	}();
	
	var createLeadManual = function () {
	  var _ref397 = _asyncToGenerator(_regenerator2.default.mark(function _callee397(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee397$(_context397) {
	      while (1) {
	        switch (_context397.prev = _context397.next) {
	          case 0:
	            _context397.next = 2;
	            return fetch(_DomainName2.default.register + 'leads/processlead/createLeadManual', {
	              method: 'post',
	              mode: 'cors',
	              'x-auth-token': token,
	              headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
	              body: data
	            });
	
	          case 2:
	            result = _context397.sent;
	            return _context397.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context397.stop();
	        }
	      }
	    }, _callee397, this);
	  }));
	
	  return function createLeadManual(_x375) {
	    return _ref397.apply(this, arguments);
	  };
	}();
	
	var getDuplicatesPaged = function () {
	  var _ref398 = _asyncToGenerator(_regenerator2.default.mark(function _callee398(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee398$(_context398) {
	      while (1) {
	        switch (_context398.prev = _context398.next) {
	          case 0:
	            _context398.next = 2;
	            return fetch(_DomainName2.default.register + 'bewiseapi/general/findduplicates', {
	              method: 'post',
	              mode: 'cors',
	              'x-auth-token': token,
	              headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
	              body: data
	            });
	
	          case 2:
	            result = _context398.sent;
	            return _context398.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context398.stop();
	        }
	      }
	    }, _callee398, this);
	  }));
	
	  return function getDuplicatesPaged(_x376) {
	    return _ref398.apply(this, arguments);
	  };
	}();
	
	var getTotalDuplicates = function () {
	  var _ref399 = _asyncToGenerator(_regenerator2.default.mark(function _callee399(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee399$(_context399) {
	      while (1) {
	        switch (_context399.prev = _context399.next) {
	          case 0:
	            _context399.next = 2;
	            return fetch(_DomainName2.default.register + 'bewiseapi/general/getTotalDuplicates', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context399.sent;
	            return _context399.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context399.stop();
	        }
	      }
	    }, _callee399, this);
	  }));
	
	  return function getTotalDuplicates(_x377) {
	    return _ref399.apply(this, arguments);
	  };
	}();
	
	var restoreTrash = function () {
	  var _ref400 = _asyncToGenerator(_regenerator2.default.mark(function _callee400(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee400$(_context400) {
	      while (1) {
	        switch (_context400.prev = _context400.next) {
	          case 0:
	            _context400.next = 2;
	            return fetch(_DomainName2.default.register + 'bewiseapi/general/restoretrash', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context400.sent;
	            return _context400.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context400.stop();
	        }
	      }
	    }, _callee400, this);
	  }));
	
	  return function restoreTrash(_x378) {
	    return _ref400.apply(this, arguments);
	  };
	}();
	
	var approveBulk = function () {
	  var _ref401 = _asyncToGenerator(_regenerator2.default.mark(function _callee401(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee401$(_context401) {
	      while (1) {
	        switch (_context401.prev = _context401.next) {
	          case 0:
	            _context401.next = 2;
	            return fetch(_DomainName2.default.register + 'bewiseapi/general/approveBulk', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context401.sent;
	            return _context401.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context401.stop();
	        }
	      }
	    }, _callee401, this);
	  }));
	
	  return function approveBulk(_x379) {
	    return _ref401.apply(this, arguments);
	  };
	}();
	
	var approveInsight = function () {
	  var _ref402 = _asyncToGenerator(_regenerator2.default.mark(function _callee402(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee402$(_context402) {
	      while (1) {
	        switch (_context402.prev = _context402.next) {
	          case 0:
	            _context402.next = 2;
	            return fetch(_DomainName2.default.register + 'insights/approveInsight', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context402.sent;
	            return _context402.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context402.stop();
	        }
	      }
	    }, _callee402, this);
	  }));
	
	  return function approveInsight(_x380) {
	    return _ref402.apply(this, arguments);
	  };
	}();
	
	var postajob = function () {
	  var _ref403 = _asyncToGenerator(_regenerator2.default.mark(function _callee403(data) {
	    var formData, key, result;
	    return _regenerator2.default.wrap(function _callee403$(_context403) {
	      while (1) {
	        switch (_context403.prev = _context403.next) {
	          case 0:
	            formData = new FormData();
	
	            for (key in data) {
	              formData.append(key, data[key]);
	            }
	            console.log('formData', data, formData);
	            _context403.next = 5;
	            return fetch(_DomainName2.default.register + 'wc/postajob', {
	              method: 'POST',
	              mode: 'cors',
	              headers: { 'x-auth-token': token },
	              body: formData
	            });
	
	          case 5:
	            result = _context403.sent;
	
	            console.log('Success');
	            return _context403.abrupt('return', result.json());
	
	          case 8:
	          case 'end':
	            return _context403.stop();
	        }
	      }
	    }, _callee403, this);
	  }));
	
	  return function postajob(_x381) {
	    return _ref403.apply(this, arguments);
	  };
	}();
	
	var getjobs = function () {
	  var _ref404 = _asyncToGenerator(_regenerator2.default.mark(function _callee404(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee404$(_context404) {
	      while (1) {
	        switch (_context404.prev = _context404.next) {
	          case 0:
	            _context404.next = 2;
	            return fetch(_DomainName2.default.register + 'wc/getjobsbyins', {
	              method: 'POST',
	              'x-auth-token': token,
	              mode: 'cors',
	              headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
	              body: data
	            });
	
	          case 2:
	            result = _context404.sent;
	            return _context404.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context404.stop();
	        }
	      }
	    }, _callee404, this);
	  }));
	
	  return function getjobs(_x382) {
	    return _ref404.apply(this, arguments);
	  };
	}();
	
	var getJobDetailTeacher = function () {
	  var _ref405 = _asyncToGenerator(_regenerator2.default.mark(function _callee405(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee405$(_context405) {
	      while (1) {
	        switch (_context405.prev = _context405.next) {
	          case 0:
	            _context405.next = 2;
	            return fetch(_DomainName2.default.register + 'wc/getjobdetail_teacher', {
	              method: 'POST',
	              'x-auth-token': token,
	              mode: 'cors',
	              headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
	              body: data
	            });
	
	          case 2:
	            result = _context405.sent;
	            return _context405.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context405.stop();
	        }
	      }
	    }, _callee405, this);
	  }));
	
	  return function getJobDetailTeacher(_x383) {
	    return _ref405.apply(this, arguments);
	  };
	}();
	
	var getProfileDetail = function () {
	  var _ref406 = _asyncToGenerator(_regenerator2.default.mark(function _callee406(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee406$(_context406) {
	      while (1) {
	        switch (_context406.prev = _context406.next) {
	          case 0:
	            _context406.next = 2;
	            return fetch(_DomainName2.default.register + 'wc/getProfileData', {
	              method: 'POST',
	              'x-auth-token': token,
	              mode: 'cors',
	              headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
	              body: data
	            });
	
	          case 2:
	            result = _context406.sent;
	            return _context406.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context406.stop();
	        }
	      }
	    }, _callee406, this);
	  }));
	
	  return function getProfileDetail(_x384) {
	    return _ref406.apply(this, arguments);
	  };
	}();
	
	var getEducations = function () {
	  var _ref407 = _asyncToGenerator(_regenerator2.default.mark(function _callee407(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee407$(_context407) {
	      while (1) {
	        switch (_context407.prev = _context407.next) {
	          case 0:
	            _context407.next = 2;
	            return fetch(_DomainName2.default.register + 'wc/geteducations', {
	              method: 'POST',
	              'x-auth-token': token,
	              mode: 'cors',
	              headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
	              body: data
	            });
	
	          case 2:
	            result = _context407.sent;
	            return _context407.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context407.stop();
	        }
	      }
	    }, _callee407, this);
	  }));
	
	  return function getEducations(_x385) {
	    return _ref407.apply(this, arguments);
	  };
	}();
	
	var getExperiences = function () {
	  var _ref408 = _asyncToGenerator(_regenerator2.default.mark(function _callee408(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee408$(_context408) {
	      while (1) {
	        switch (_context408.prev = _context408.next) {
	          case 0:
	            _context408.next = 2;
	            return fetch(_DomainName2.default.register + 'wc/getexperiences', {
	              method: 'POST',
	              'x-auth-token': token,
	              mode: 'cors',
	              headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
	              body: data
	            });
	
	          case 2:
	            result = _context408.sent;
	            return _context408.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context408.stop();
	        }
	      }
	    }, _callee408, this);
	  }));
	
	  return function getExperiences(_x386) {
	    return _ref408.apply(this, arguments);
	  };
	}();
	
	var getJobDetail = function () {
	  var _ref409 = _asyncToGenerator(_regenerator2.default.mark(function _callee409(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee409$(_context409) {
	      while (1) {
	        switch (_context409.prev = _context409.next) {
	          case 0:
	            _context409.next = 2;
	            return fetch(_DomainName2.default.register + 'wc/getjobdetail', {
	              method: 'POST',
	              'x-auth-token': token,
	              mode: 'cors',
	              headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
	              body: data
	            });
	
	          case 2:
	            result = _context409.sent;
	            return _context409.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context409.stop();
	        }
	      }
	    }, _callee409, this);
	  }));
	
	  return function getJobDetail(_x387) {
	    return _ref409.apply(this, arguments);
	  };
	}();
	
	var getApplicants = function () {
	  var _ref410 = _asyncToGenerator(_regenerator2.default.mark(function _callee410(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee410$(_context410) {
	      while (1) {
	        switch (_context410.prev = _context410.next) {
	          case 0:
	            _context410.next = 2;
	            return fetch(_DomainName2.default.register + 'wc/getApplicants', {
	              method: 'POST',
	              'x-auth-token': token,
	              mode: 'cors',
	              headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
	              body: data
	            });
	
	          case 2:
	            result = _context410.sent;
	            return _context410.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context410.stop();
	        }
	      }
	    }, _callee410, this);
	  }));
	
	  return function getApplicants(_x388) {
	    return _ref410.apply(this, arguments);
	  };
	}();
	
	var updatejob = function () {
	  var _ref411 = _asyncToGenerator(_regenerator2.default.mark(function _callee411(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee411$(_context411) {
	      while (1) {
	        switch (_context411.prev = _context411.next) {
	          case 0:
	            _context411.next = 2;
	            return fetch(_DomainName2.default.register + 'wc/updatejob', {
	              method: 'POST',
	              'x-auth-token': token,
	              mode: 'cors',
	              headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
	              body: data
	            });
	
	          case 2:
	            result = _context411.sent;
	            return _context411.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context411.stop();
	        }
	      }
	    }, _callee411, this);
	  }));
	
	  return function updatejob(_x389) {
	    return _ref411.apply(this, arguments);
	  };
	}();
	
	var getTotalApplicants = function () {
	  var _ref412 = _asyncToGenerator(_regenerator2.default.mark(function _callee412(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee412$(_context412) {
	      while (1) {
	        switch (_context412.prev = _context412.next) {
	          case 0:
	            _context412.next = 2;
	            return fetch(_DomainName2.default.register + 'wc/gettotalapplicants', {
	              method: 'POST',
	              'x-auth-token': token,
	              mode: 'cors',
	              headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
	              body: data
	            });
	
	          case 2:
	            result = _context412.sent;
	            return _context412.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context412.stop();
	        }
	      }
	    }, _callee412, this);
	  }));
	
	  return function getTotalApplicants(_x390) {
	    return _ref412.apply(this, arguments);
	  };
	}();
	
	var saveJobStatus = function () {
	  var _ref413 = _asyncToGenerator(_regenerator2.default.mark(function _callee413(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee413$(_context413) {
	      while (1) {
	        switch (_context413.prev = _context413.next) {
	          case 0:
	            _context413.next = 2;
	            return fetch(_DomainName2.default.register + 'wc/savejobstatus', {
	              method: 'POST',
	              'x-auth-token': token,
	              mode: 'cors',
	              headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
	              body: data
	            });
	
	          case 2:
	            result = _context413.sent;
	            return _context413.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context413.stop();
	        }
	      }
	    }, _callee413, this);
	  }));
	
	  return function saveJobStatus(_x391) {
	    return _ref413.apply(this, arguments);
	  };
	}();
	
	var getTalents = function () {
	  var _ref414 = _asyncToGenerator(_regenerator2.default.mark(function _callee414(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee414$(_context414) {
	      while (1) {
	        switch (_context414.prev = _context414.next) {
	          case 0:
	            _context414.next = 2;
	            return fetch(_DomainName2.default.register + 'wc/gettalent', {
	              method: 'POST',
	              'x-auth-token': token,
	              mode: 'cors',
	              headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
	              body: data
	            });
	
	          case 2:
	            result = _context414.sent;
	            return _context414.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context414.stop();
	        }
	      }
	    }, _callee414, this);
	  }));
	
	  return function getTalents(_x392) {
	    return _ref414.apply(this, arguments);
	  };
	}();
	
	var getOtherCoursesListPaged = function () {
	  var _ref415 = _asyncToGenerator(_regenerator2.default.mark(function _callee415(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee415$(_context415) {
	      while (1) {
	        switch (_context415.prev = _context415.next) {
	          case 0:
	            _context415.next = 2;
	            return fetch(_DomainName2.default.register + 'wc/getothercoursespaged', {
	              method: 'POST',
	              'x-auth-token': token,
	              mode: 'cors',
	              headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
	              body: data
	            });
	
	          case 2:
	            result = _context415.sent;
	            return _context415.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context415.stop();
	        }
	      }
	    }, _callee415, this);
	  }));
	
	  return function getOtherCoursesListPaged(_x393) {
	    return _ref415.apply(this, arguments);
	  };
	}();
	
	var getCoursesListPaged = function () {
	  var _ref416 = _asyncToGenerator(_regenerator2.default.mark(function _callee416(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee416$(_context416) {
	      while (1) {
	        switch (_context416.prev = _context416.next) {
	          case 0:
	            _context416.next = 2;
	            return fetch(_DomainName2.default.register + 'wc/getcoursespaged', {
	              method: 'POST',
	              'x-auth-token': token,
	              mode: 'cors',
	              headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
	              body: data
	            });
	
	          case 2:
	            result = _context416.sent;
	            return _context416.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context416.stop();
	        }
	      }
	    }, _callee416, this);
	  }));
	
	  return function getCoursesListPaged(_x394) {
	    return _ref416.apply(this, arguments);
	  };
	}();
	
	var LoginCourse = function () {
	  var _ref417 = _asyncToGenerator(_regenerator2.default.mark(function _callee417(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee417$(_context417) {
	      while (1) {
	        switch (_context417.prev = _context417.next) {
	          case 0:
	            _context417.next = 2;
	            return fetch(_DomainName2.default.register + 'wc/logincourse', {
	              method: 'POST',
	              'x-auth-token': token,
	              mode: 'cors',
	              headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
	              body: data
	            });
	
	          case 2:
	            result = _context417.sent;
	            return _context417.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context417.stop();
	        }
	      }
	    }, _callee417, this);
	  }));
	
	  return function LoginCourse(_x395) {
	    return _ref417.apply(this, arguments);
	  };
	}();
	
	var saveCourse = function () {
	  var _ref418 = _asyncToGenerator(_regenerator2.default.mark(function _callee418(data) {
	    var formData, key, result;
	    return _regenerator2.default.wrap(function _callee418$(_context418) {
	      while (1) {
	        switch (_context418.prev = _context418.next) {
	          case 0:
	            formData = new FormData();
	
	            for (key in data) {
	              formData.append(key, data[key]);
	            }
	            console.log('formData', data, formData);
	            _context418.next = 5;
	            return fetch(_DomainName2.default.register + 'wc/savecourse', {
	              method: 'POST',
	              mode: 'cors',
	              headers: { 'x-auth-token': token },
	              body: formData
	            });
	
	          case 5:
	            result = _context418.sent;
	
	            console.log('Success');
	            return _context418.abrupt('return', result.json());
	
	          case 8:
	          case 'end':
	            return _context418.stop();
	        }
	      }
	    }, _callee418, this);
	  }));
	
	  return function saveCourse(_x396) {
	    return _ref418.apply(this, arguments);
	  };
	}();
	
	var getCoursesbyUser = function () {
	  var _ref419 = _asyncToGenerator(_regenerator2.default.mark(function _callee419(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee419$(_context419) {
	      while (1) {
	        switch (_context419.prev = _context419.next) {
	          case 0:
	            _context419.next = 2;
	            return fetch(_DomainName2.default.register + 'wc/getcoursesbyuser', {
	              method: 'POST',
	              'x-auth-token': token,
	              mode: 'cors',
	              headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
	              body: data
	            });
	
	          case 2:
	            result = _context419.sent;
	            return _context419.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context419.stop();
	        }
	      }
	    }, _callee419, this);
	  }));
	
	  return function getCoursesbyUser(_x397) {
	    return _ref419.apply(this, arguments);
	  };
	}();
	
	var getCourseById = function () {
	  var _ref420 = _asyncToGenerator(_regenerator2.default.mark(function _callee420(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee420$(_context420) {
	      while (1) {
	        switch (_context420.prev = _context420.next) {
	          case 0:
	            _context420.next = 2;
	            return fetch(_DomainName2.default.register + 'wc/getcoursebyid', {
	              method: 'POST',
	              'x-auth-token': token,
	              mode: 'cors',
	              headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
	              body: data
	            });
	
	          case 2:
	            result = _context420.sent;
	            return _context420.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context420.stop();
	        }
	      }
	    }, _callee420, this);
	  }));
	
	  return function getCourseById(_x398) {
	    return _ref420.apply(this, arguments);
	  };
	}();
	
	var updateCourse = function () {
	  var _ref421 = _asyncToGenerator(_regenerator2.default.mark(function _callee421(data) {
	    var formData, key, result;
	    return _regenerator2.default.wrap(function _callee421$(_context421) {
	      while (1) {
	        switch (_context421.prev = _context421.next) {
	          case 0:
	            formData = new FormData();
	
	            for (key in data) {
	              formData.append(key, data[key]);
	            }
	            console.log('formData', data, formData);
	            _context421.next = 5;
	            return fetch(_DomainName2.default.register + 'wc/updatecourse', {
	              method: 'POST',
	              mode: 'cors',
	              headers: { 'x-auth-token': token },
	              body: formData
	            });
	
	          case 5:
	            result = _context421.sent;
	
	            console.log('Success');
	            return _context421.abrupt('return', result.json());
	
	          case 8:
	          case 'end':
	            return _context421.stop();
	        }
	      }
	    }, _callee421, this);
	  }));
	
	  return function updateCourse(_x399) {
	    return _ref421.apply(this, arguments);
	  };
	}();
	
	var approvecourse = function () {
	  var _ref422 = _asyncToGenerator(_regenerator2.default.mark(function _callee422(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee422$(_context422) {
	      while (1) {
	        switch (_context422.prev = _context422.next) {
	          case 0:
	            _context422.next = 2;
	            return fetch(_DomainName2.default.register + 'wc/approvecourse', {
	              method: 'POST',
	              'x-auth-token': token,
	              mode: 'cors',
	              headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
	              body: data
	            });
	
	          case 2:
	            result = _context422.sent;
	            return _context422.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context422.stop();
	        }
	      }
	    }, _callee422, this);
	  }));
	
	  return function approvecourse(_x400) {
	    return _ref422.apply(this, arguments);
	  };
	}();
	
	var createprovider = function () {
	  var _ref423 = _asyncToGenerator(_regenerator2.default.mark(function _callee423(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee423$(_context423) {
	      while (1) {
	        switch (_context423.prev = _context423.next) {
	          case 0:
	            _context423.next = 2;
	            return fetch(_DomainName2.default.register + 'wc/createprovider', {
	              method: 'POST',
	              'x-auth-token': token,
	              mode: 'cors',
	              headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
	              body: data
	            });
	
	          case 2:
	            result = _context423.sent;
	            return _context423.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context423.stop();
	        }
	      }
	    }, _callee423, this);
	  }));
	
	  return function createprovider(_x401) {
	    return _ref423.apply(this, arguments);
	  };
	}();
	
	var addjobimporting = function () {
	  var _ref424 = _asyncToGenerator(_regenerator2.default.mark(function _callee424(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee424$(_context424) {
	      while (1) {
	        switch (_context424.prev = _context424.next) {
	          case 0:
	            _context424.next = 2;
	            return fetch(_DomainName2.default.register + 'wc/importjobadd', {
	              method: 'POST',
	              'x-auth-token': token,
	              mode: 'cors',
	              headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
	              body: data
	            });
	
	          case 2:
	            result = _context424.sent;
	            return _context424.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context424.stop();
	        }
	      }
	    }, _callee424, this);
	  }));
	
	  return function addjobimporting(_x402) {
	    return _ref424.apply(this, arguments);
	  };
	}();
	
	var getBlogCategory = function () {
	  var _ref425 = _asyncToGenerator(_regenerator2.default.mark(function _callee425(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee425$(_context425) {
	      while (1) {
	        switch (_context425.prev = _context425.next) {
	          case 0:
	            _context425.next = 2;
	            return fetch(_DomainName2.default.register + 'insights/getcategory', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context425.sent;
	            return _context425.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context425.stop();
	        }
	      }
	    }, _callee425, this);
	  }));
	
	  return function getBlogCategory(_x403) {
	    return _ref425.apply(this, arguments);
	  };
	}();
	
	var getTotalAuroSubscribers = function () {
	  var _ref426 = _asyncToGenerator(_regenerator2.default.mark(function _callee426() {
	    var result;
	    return _regenerator2.default.wrap(function _callee426$(_context426) {
	      while (1) {
	        switch (_context426.prev = _context426.next) {
	          case 0:
	            _context426.next = 2;
	            return fetch(_DomainName2.default.register + 'exclsignups/gettotal', {
	              method: 'POST',
	              'x-auth-token': token,
	              mode: 'cors',
	              headers: { 'Content-Type': 'application/json', 'x-auth-token': token }
	
	            });
	
	          case 2:
	            result = _context426.sent;
	            return _context426.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context426.stop();
	        }
	      }
	    }, _callee426, this);
	  }));
	
	  return function getTotalAuroSubscribers() {
	    return _ref426.apply(this, arguments);
	  };
	}();
	
	var getAuroScholarPaged = function () {
	  var _ref427 = _asyncToGenerator(_regenerator2.default.mark(function _callee427(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee427$(_context427) {
	      while (1) {
	        switch (_context427.prev = _context427.next) {
	          case 0:
	            _context427.next = 2;
	            return fetch(_DomainName2.default.register + 'exclsignups/getsignupspaged', {
	              method: 'POST',
	              'x-auth-token': token,
	              mode: 'cors',
	              headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
	              body: data
	            });
	
	          case 2:
	            result = _context427.sent;
	            return _context427.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context427.stop();
	        }
	      }
	    }, _callee427, this);
	  }));
	
	  return function getAuroScholarPaged(_x404) {
	    return _ref427.apply(this, arguments);
	  };
	}();
	
	var checkAndsubscribeWiseConnect = function () {
	  var _ref428 = _asyncToGenerator(_regenerator2.default.mark(function _callee428(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee428$(_context428) {
	      while (1) {
	        switch (_context428.prev = _context428.next) {
	          case 0:
	            _context428.next = 2;
	            return fetch(_DomainName2.default.register + 'wc/partnersignup', {
	              method: 'POST',
	              'x-auth-token': token,
	              mode: 'cors',
	              headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
	              body: data
	            });
	
	          case 2:
	            result = _context428.sent;
	            return _context428.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context428.stop();
	        }
	      }
	    }, _callee428, this);
	  }));
	
	  return function checkAndsubscribeWiseConnect(_x405) {
	    return _ref428.apply(this, arguments);
	  };
	}();
	
	var checkifWcSubscribedTrial = function () {
	  var _ref429 = _asyncToGenerator(_regenerator2.default.mark(function _callee429(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee429$(_context429) {
	      while (1) {
	        switch (_context429.prev = _context429.next) {
	          case 0:
	            _context429.next = 2;
	            return fetch(_DomainName2.default.register + 'wc/checkifWcSubscribedTrial', {
	              method: 'POST',
	              'x-auth-token': token,
	              mode: 'cors',
	              headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
	              body: data
	            });
	
	          case 2:
	            result = _context429.sent;
	            return _context429.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context429.stop();
	        }
	      }
	    }, _callee429, this);
	  }));
	
	  return function checkifWcSubscribedTrial(_x406) {
	    return _ref429.apply(this, arguments);
	  };
	}();
	
	var getExclPartnerShipDetailById = function () {
	  var _ref430 = _asyncToGenerator(_regenerator2.default.mark(function _callee430(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee430$(_context430) {
	      while (1) {
	        switch (_context430.prev = _context430.next) {
	          case 0:
	            _context430.next = 2;
	            return fetch(_DomainName2.default.register + 'exclusive/common/detail_by_id', {
	              method: 'POST',
	              'x-auth-token': token,
	              mode: 'cors',
	              headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
	              body: data
	            });
	
	          case 2:
	            result = _context430.sent;
	            return _context430.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context430.stop();
	        }
	      }
	    }, _callee430, this);
	  }));
	
	  return function getExclPartnerShipDetailById(_x407) {
	    return _ref430.apply(this, arguments);
	  };
	}();
	
	var getJobsListPaged = function () {
	  var _ref431 = _asyncToGenerator(_regenerator2.default.mark(function _callee431(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee431$(_context431) {
	      while (1) {
	        switch (_context431.prev = _context431.next) {
	          case 0:
	            _context431.next = 2;
	            return fetch(_DomainName2.default.register + 'wc/jobspaged', {
	              method: 'POST',
	              'x-auth-token': token,
	              mode: 'cors',
	              headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
	              body: data
	            });
	
	          case 2:
	            result = _context431.sent;
	            return _context431.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context431.stop();
	        }
	      }
	    }, _callee431, this);
	  }));
	
	  return function getJobsListPaged(_x408) {
	    return _ref431.apply(this, arguments);
	  };
	}();
	
	var getTotalJobs = function () {
	  var _ref432 = _asyncToGenerator(_regenerator2.default.mark(function _callee432(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee432$(_context432) {
	      while (1) {
	        switch (_context432.prev = _context432.next) {
	          case 0:
	            _context432.next = 2;
	            return fetch(_DomainName2.default.register + 'wc/jobstotal', {
	              method: 'POST',
	              'x-auth-token': token,
	              mode: 'cors',
	              headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
	              body: data
	            });
	
	          case 2:
	            result = _context432.sent;
	            return _context432.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context432.stop();
	        }
	      }
	    }, _callee432, this);
	  }));
	
	  return function getTotalJobs(_x409) {
	    return _ref432.apply(this, arguments);
	  };
	}();
	
	var getBlogsListPaged = function () {
	  var _ref433 = _asyncToGenerator(_regenerator2.default.mark(function _callee433(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee433$(_context433) {
	      while (1) {
	        switch (_context433.prev = _context433.next) {
	          case 0:
	            _context433.next = 2;
	            return fetch(_DomainName2.default.register + 'wc/blogspaged', {
	              method: 'POST',
	              'x-auth-token': token,
	              mode: 'cors',
	              headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
	              body: data
	            });
	
	          case 2:
	            result = _context433.sent;
	            return _context433.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context433.stop();
	        }
	      }
	    }, _callee433, this);
	  }));
	
	  return function getBlogsListPaged(_x410) {
	    return _ref433.apply(this, arguments);
	  };
	}();
	
	var getTotalBlogs = function () {
	  var _ref434 = _asyncToGenerator(_regenerator2.default.mark(function _callee434(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee434$(_context434) {
	      while (1) {
	        switch (_context434.prev = _context434.next) {
	          case 0:
	            _context434.next = 2;
	            return fetch(_DomainName2.default.register + 'wc/blogstotal', {
	              method: 'POST',
	              'x-auth-token': token,
	              mode: 'cors',
	              headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
	              body: data
	            });
	
	          case 2:
	            result = _context434.sent;
	            return _context434.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context434.stop();
	        }
	      }
	    }, _callee434, this);
	  }));
	
	  return function getTotalBlogs(_x411) {
	    return _ref434.apply(this, arguments);
	  };
	}();
	
	var postanextblog = function () {
	  var _ref435 = _asyncToGenerator(_regenerator2.default.mark(function _callee435(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee435$(_context435) {
	      while (1) {
	        switch (_context435.prev = _context435.next) {
	          case 0:
	            _context435.next = 2;
	            return fetch(_DomainName2.default.register + 'wc/postablog', {
	              method: 'POST',
	              'x-auth-token': token,
	              mode: 'cors',
	              headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
	              body: data
	            });
	
	          case 2:
	            result = _context435.sent;
	            return _context435.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context435.stop();
	        }
	      }
	    }, _callee435, this);
	  }));
	
	  return function postanextblog(_x412) {
	    return _ref435.apply(this, arguments);
	  };
	}();
	
	var updateablog = function () {
	  var _ref436 = _asyncToGenerator(_regenerator2.default.mark(function _callee436(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee436$(_context436) {
	      while (1) {
	        switch (_context436.prev = _context436.next) {
	          case 0:
	            _context436.next = 2;
	            return fetch(_DomainName2.default.register + 'wc/updateablog', {
	              method: 'POST',
	              'x-auth-token': token,
	              mode: 'cors',
	              headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
	              body: data
	            });
	
	          case 2:
	            result = _context436.sent;
	            return _context436.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context436.stop();
	        }
	      }
	    }, _callee436, this);
	  }));
	
	  return function updateablog(_x413) {
	    return _ref436.apply(this, arguments);
	  };
	}();
	
	var getExtBlogById = function () {
	  var _ref437 = _asyncToGenerator(_regenerator2.default.mark(function _callee437(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee437$(_context437) {
	      while (1) {
	        switch (_context437.prev = _context437.next) {
	          case 0:
	            _context437.next = 2;
	            return fetch(_DomainName2.default.register + 'wc/getextblog', {
	              method: 'POST',
	              'x-auth-token': token,
	              mode: 'cors',
	              headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
	              body: data
	            });
	
	          case 2:
	            result = _context437.sent;
	            return _context437.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context437.stop();
	        }
	      }
	    }, _callee437, this);
	  }));
	
	  return function getExtBlogById(_x414) {
	    return _ref437.apply(this, arguments);
	  };
	}();
	
	var processReminderMail = function () {
	  var _ref438 = _asyncToGenerator(_regenerator2.default.mark(function _callee438(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee438$(_context438) {
	      while (1) {
	        switch (_context438.prev = _context438.next) {
	          case 0:
	            _context438.next = 2;
	            return fetch(_DomainName2.default.register + 'exclusive/common/sendingmail', {
	              method: 'POST',
	              'x-auth-token': token,
	              mode: 'cors',
	              headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
	              body: data
	            });
	
	          case 2:
	            result = _context438.sent;
	            return _context438.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context438.stop();
	        }
	      }
	    }, _callee438, this);
	  }));
	
	  return function processReminderMail(_x415) {
	    return _ref438.apply(this, arguments);
	  };
	}();
	
	var sendCustomMail = function () {
	  var _ref439 = _asyncToGenerator(_regenerator2.default.mark(function _callee439(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee439$(_context439) {
	      while (1) {
	        switch (_context439.prev = _context439.next) {
	          case 0:
	            _context439.next = 2;
	            return fetch(_DomainName2.default.register + 'exclusive/common/sendingcustommail', {
	              method: 'POST',
	              'x-auth-token': token,
	              mode: 'cors',
	              headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
	              body: data
	            });
	
	          case 2:
	            result = _context439.sent;
	            return _context439.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context439.stop();
	        }
	      }
	    }, _callee439, this);
	  }));
	
	  return function sendCustomMail(_x416) {
	    return _ref439.apply(this, arguments);
	  };
	}();
	
	var generatePdfHtml = function () {
	  var _ref440 = _asyncToGenerator(_regenerator2.default.mark(function _callee440(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee440$(_context440) {
	      while (1) {
	        switch (_context440.prev = _context440.next) {
	          case 0:
	            _context440.next = 2;
	            return fetch(_DomainName2.default.register + 'wc/generatePdfHtml', {
	              method: 'POST',
	              'x-auth-token': token,
	              mode: 'cors',
	              headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
	              body: data
	            });
	
	          case 2:
	            result = _context440.sent;
	            return _context440.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context440.stop();
	        }
	      }
	    }, _callee440, this);
	  }));
	
	  return function generatePdfHtml(_x417) {
	    return _ref440.apply(this, arguments);
	  };
	}();
	
	var partnerAddBranch = function () {
	  var _ref441 = _asyncToGenerator(_regenerator2.default.mark(function _callee441(data) {
	    var t, result;
	    return _regenerator2.default.wrap(function _callee441$(_context441) {
	      while (1) {
	        switch (_context441.prev = _context441.next) {
	          case 0:
	            t = JSON.parse(data);
	            _context441.next = 3;
	            return fetch(_DomainName2.default.register + 'wc/partneraddbranch', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 3:
	            result = _context441.sent;
	            return _context441.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context441.stop();
	        }
	      }
	    }, _callee441, this);
	  }));
	
	  return function partnerAddBranch(_x418) {
	    return _ref441.apply(this, arguments);
	  };
	}();
	
	var getAddonList = function () {
	  var _ref442 = _asyncToGenerator(_regenerator2.default.mark(function _callee442(data) {
	    var t, result;
	    return _regenerator2.default.wrap(function _callee442$(_context442) {
	      while (1) {
	        switch (_context442.prev = _context442.next) {
	          case 0:
	            t = JSON.parse(data);
	            _context442.next = 3;
	            return fetch(_DomainName2.default.register + 'wc/getAddonList', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 3:
	            result = _context442.sent;
	            return _context442.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context442.stop();
	        }
	      }
	    }, _callee442, this);
	  }));
	
	  return function getAddonList(_x419) {
	    return _ref442.apply(this, arguments);
	  };
	}();
	
	var getSpecialDiscount = function () {
	  var _ref443 = _asyncToGenerator(_regenerator2.default.mark(function _callee443(data) {
	    var t, result;
	    return _regenerator2.default.wrap(function _callee443$(_context443) {
	      while (1) {
	        switch (_context443.prev = _context443.next) {
	          case 0:
	            t = JSON.parse(data);
	            _context443.next = 3;
	            return fetch(_DomainName2.default.register + 'wc/getSpecialDiscount', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 3:
	            result = _context443.sent;
	            return _context443.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context443.stop();
	        }
	      }
	    }, _callee443, this);
	  }));
	
	  return function getSpecialDiscount(_x420) {
	    return _ref443.apply(this, arguments);
	  };
	}();
	
	var blockThisUser = function () {
	  var _ref444 = _asyncToGenerator(_regenerator2.default.mark(function _callee444(data) {
	    var t, result;
	    return _regenerator2.default.wrap(function _callee444$(_context444) {
	      while (1) {
	        switch (_context444.prev = _context444.next) {
	          case 0:
	            t = JSON.parse(data);
	            _context444.next = 3;
	            return fetch(_DomainName2.default.register + 'wc/blockThisUser', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 3:
	            result = _context444.sent;
	            return _context444.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context444.stop();
	        }
	      }
	    }, _callee444, this);
	  }));
	
	  return function blockThisUser(_x421) {
	    return _ref444.apply(this, arguments);
	  };
	}();
	
	var unBlockThisUser = function () {
	  var _ref445 = _asyncToGenerator(_regenerator2.default.mark(function _callee445(data) {
	    var t, result;
	    return _regenerator2.default.wrap(function _callee445$(_context445) {
	      while (1) {
	        switch (_context445.prev = _context445.next) {
	          case 0:
	            t = JSON.parse(data);
	            _context445.next = 3;
	            return fetch(_DomainName2.default.register + 'wc/unBlockThisUser', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 3:
	            result = _context445.sent;
	            return _context445.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context445.stop();
	        }
	      }
	    }, _callee445, this);
	  }));
	
	  return function unBlockThisUser(_x422) {
	    return _ref445.apply(this, arguments);
	  };
	}();
	
	var getCitiesByKeyWord = function () {
	  var _ref446 = _asyncToGenerator(_regenerator2.default.mark(function _callee446(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee446$(_context446) {
	      while (1) {
	        switch (_context446.prev = _context446.next) {
	          case 0:
	            _context446.next = 2;
	            return fetch(_DomainName2.default.register + 'wc/getcitiesbykeyword', {
	              method: 'POST',
	              'x-auth-token': token,
	              mode: 'cors',
	              headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
	              body: data
	            });
	
	          case 2:
	            result = _context446.sent;
	            return _context446.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context446.stop();
	        }
	      }
	    }, _callee446, this);
	  }));
	
	  return function getCitiesByKeyWord(_x423) {
	    return _ref446.apply(this, arguments);
	  };
	}();
	
	var sendProComFollowUp = function () {
	  var _ref447 = _asyncToGenerator(_regenerator2.default.mark(function _callee447(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee447$(_context447) {
	      while (1) {
	        switch (_context447.prev = _context447.next) {
	          case 0:
	            _context447.next = 2;
	            return fetch(_DomainName2.default.register + 'wc/sendmailprofilecompletion', {
	              method: 'POST',
	              'x-auth-token': token,
	              mode: 'cors',
	              headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
	              body: data
	            });
	
	          case 2:
	            result = _context447.sent;
	            return _context447.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context447.stop();
	        }
	      }
	    }, _callee447, this);
	  }));
	
	  return function sendProComFollowUp(_x424) {
	    return _ref447.apply(this, arguments);
	  };
	}();
	
	var getEnquiries = function () {
	  var _ref448 = _asyncToGenerator(_regenerator2.default.mark(function _callee448(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee448$(_context448) {
	      while (1) {
	        switch (_context448.prev = _context448.next) {
	          case 0:
	            _context448.next = 2;
	            return fetch(_DomainName2.default.register + 'bewiseapi/general/getEnquiries', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context448.sent;
	            return _context448.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context448.stop();
	        }
	      }
	    }, _callee448, this);
	  }));
	
	  return function getEnquiries(_x425) {
	    return _ref448.apply(this, arguments);
	  };
	}();
	
	var getTotalEnquiries = function () {
	  var _ref449 = _asyncToGenerator(_regenerator2.default.mark(function _callee449(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee449$(_context449) {
	      while (1) {
	        switch (_context449.prev = _context449.next) {
	          case 0:
	            _context449.next = 2;
	            return fetch(_DomainName2.default.register + 'bewiseapi/general/getTotalEnquiries', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context449.sent;
	            return _context449.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context449.stop();
	        }
	      }
	    }, _callee449, this);
	  }));
	
	  return function getTotalEnquiries(_x426) {
	    return _ref449.apply(this, arguments);
	  };
	}();
	
	var getPaymentInfo = function () {
	  var _ref450 = _asyncToGenerator(_regenerator2.default.mark(function _callee450(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee450$(_context450) {
	      while (1) {
	        switch (_context450.prev = _context450.next) {
	          case 0:
	            _context450.next = 2;
	            return fetch(_DomainName2.default.register + 'razorpay/common/getPaymentInfo', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context450.sent;
	            return _context450.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context450.stop();
	        }
	      }
	    }, _callee450, this);
	  }));
	
	  return function getPaymentInfo(_x427) {
	    return _ref450.apply(this, arguments);
	  };
	}();
	
	var sendRegretNoData = function () {
	  var _ref451 = _asyncToGenerator(_regenerator2.default.mark(function _callee451(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee451$(_context451) {
	      while (1) {
	        switch (_context451.prev = _context451.next) {
	          case 0:
	            _context451.next = 2;
	            return fetch(_DomainName2.default.register + 'bewiseapi/general/sendRegretNoDataMail', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context451.sent;
	            return _context451.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context451.stop();
	        }
	      }
	    }, _callee451, this);
	  }));
	
	  return function sendRegretNoData(_x428) {
	    return _ref451.apply(this, arguments);
	  };
	}();
	
	var bringNoDateMail = function () {
	  var _ref452 = _asyncToGenerator(_regenerator2.default.mark(function _callee452(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee452$(_context452) {
	      while (1) {
	        switch (_context452.prev = _context452.next) {
	          case 0:
	            _context452.next = 2;
	            return fetch(_DomainName2.default.register + 'bewiseapi/general/getBringNoDataMail', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context452.sent;
	            return _context452.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context452.stop();
	        }
	      }
	    }, _callee452, this);
	  }));
	
	  return function bringNoDateMail(_x429) {
	    return _ref452.apply(this, arguments);
	  };
	}();
	
	var saveExclEnqLead = function () {
	  var _ref453 = _asyncToGenerator(_regenerator2.default.mark(function _callee453(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee453$(_context453) {
	      while (1) {
	        switch (_context453.prev = _context453.next) {
	          case 0:
	            _context453.next = 2;
	            return fetch(_DomainName2.default.register + 'wc/saveexclenqlead', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context453.sent;
	
	            console.log('Success');
	            return _context453.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context453.stop();
	        }
	      }
	    }, _callee453, this);
	  }));
	
	  return function saveExclEnqLead(_x430) {
	    return _ref453.apply(this, arguments);
	  };
	}();
	
	var generateThumbnails = function () {
	  var _ref454 = _asyncToGenerator(_regenerator2.default.mark(function _callee454() {
	    var result;
	    return _regenerator2.default.wrap(function _callee454$(_context454) {
	      while (1) {
	        switch (_context454.prev = _context454.next) {
	          case 0:
	            _context454.next = 2;
	            return fetch(_DomainName2.default.register + 'wc/generatewebp_blogs', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              }
	            });
	
	          case 2:
	            result = _context454.sent;
	
	            console.log('Success');
	            return _context454.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context454.stop();
	        }
	      }
	    }, _callee454, this);
	  }));
	
	  return function generateThumbnails() {
	    return _ref454.apply(this, arguments);
	  };
	}();
	
	var generateDataGraph = function () {
	  var _ref455 = _asyncToGenerator(_regenerator2.default.mark(function _callee455(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee455$(_context455) {
	      while (1) {
	        switch (_context455.prev = _context455.next) {
	          case 0:
	            _context455.next = 2;
	            return fetch(_DomainName2.default.register + 'wc/graphs_gen', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context455.sent;
	
	            console.log('Success');
	            return _context455.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context455.stop();
	        }
	      }
	    }, _callee455, this);
	  }));
	
	  return function generateDataGraph(_x431) {
	    return _ref455.apply(this, arguments);
	  };
	}();
	
	var showresultssearch = function () {
	  var _ref456 = _asyncToGenerator(_regenerator2.default.mark(function _callee456(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee456$(_context456) {
	      while (1) {
	        switch (_context456.prev = _context456.next) {
	          case 0:
	            _context456.next = 2;
	            return fetch(_DomainName2.default.register + 'wc/showresultssearch', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context456.sent;
	
	            console.log('Success');
	            return _context456.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context456.stop();
	        }
	      }
	    }, _callee456, this);
	  }));
	
	  return function showresultssearch(_x432) {
	    return _ref456.apply(this, arguments);
	  };
	}();
	
	var checkifLeadsReceived = function () {
	  var _ref457 = _asyncToGenerator(_regenerator2.default.mark(function _callee457(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee457$(_context457) {
	      while (1) {
	        switch (_context457.prev = _context457.next) {
	          case 0:
	            _context457.next = 2;
	            return fetch(_DomainName2.default.register + 'wc/checkifleadsreceived', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context457.sent;
	
	            console.log('Success');
	            return _context457.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context457.stop();
	        }
	      }
	    }, _callee457, this);
	  }));
	
	  return function checkifLeadsReceived(_x433) {
	    return _ref457.apply(this, arguments);
	  };
	}();
	
	var resetPasswordSend = function () {
	  var _ref458 = _asyncToGenerator(_regenerator2.default.mark(function _callee458(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee458$(_context458) {
	      while (1) {
	        switch (_context458.prev = _context458.next) {
	          case 0:
	            _context458.next = 2;
	            return fetch(_DomainName2.default.register + 'wc/resetpasswordsend', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context458.sent;
	
	            console.log('Success');
	            return _context458.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context458.stop();
	        }
	      }
	    }, _callee458, this);
	  }));
	
	  return function resetPasswordSend(_x434) {
	    return _ref458.apply(this, arguments);
	  };
	}();
	
	var saveAbout = function () {
	  var _ref459 = _asyncToGenerator(_regenerator2.default.mark(function _callee459(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee459$(_context459) {
	      while (1) {
	        switch (_context459.prev = _context459.next) {
	          case 0:
	            _context459.next = 2;
	            return fetch(_DomainName2.default.register + 'bewiseapi/users/saveAbout', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context459.sent;
	
	            console.log('Success');
	            return _context459.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context459.stop();
	        }
	      }
	    }, _callee459, this);
	  }));
	
	  return function saveAbout(_x435) {
	    return _ref459.apply(this, arguments);
	  };
	}();
	
	var leadCharts = function () {
	  var _ref460 = _asyncToGenerator(_regenerator2.default.mark(function _callee460(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee460$(_context460) {
	      while (1) {
	        switch (_context460.prev = _context460.next) {
	          case 0:
	            _context460.next = 2;
	            return fetch(_DomainName2.default.register + 'wc/leadcharts', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context460.sent;
	
	            console.log('Success');
	            return _context460.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context460.stop();
	        }
	      }
	    }, _callee460, this);
	  }));
	
	  return function leadCharts(_x436) {
	    return _ref460.apply(this, arguments);
	  };
	}();
	
	var leadreportstext = function () {
	  var _ref461 = _asyncToGenerator(_regenerator2.default.mark(function _callee461(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee461$(_context461) {
	      while (1) {
	        switch (_context461.prev = _context461.next) {
	          case 0:
	            _context461.next = 2;
	            return fetch(_DomainName2.default.register + 'wc/leadreportstext', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context461.sent;
	
	            console.log('Success');
	            return _context461.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context461.stop();
	        }
	      }
	    }, _callee461, this);
	  }));
	
	  return function leadreportstext(_x437) {
	    return _ref461.apply(this, arguments);
	  };
	}();
	
	var getcuratedviews = function () {
	  var _ref462 = _asyncToGenerator(_regenerator2.default.mark(function _callee462(data) {
	    var result;
	    return _regenerator2.default.wrap(function _callee462$(_context462) {
	      while (1) {
	        switch (_context462.prev = _context462.next) {
	          case 0:
	            _context462.next = 2;
	            return fetch(_DomainName2.default.register + 'wc/getcuratedviews', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 2:
	            result = _context462.sent;
	
	            console.log('Success');
	            return _context462.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context462.stop();
	        }
	      }
	    }, _callee462, this);
	  }));
	
	  return function getcuratedviews(_x438) {
	    return _ref462.apply(this, arguments);
	  };
	}();
	
	var fetch_category_by_ids = function () {
	  var _ref463 = _asyncToGenerator(_regenerator2.default.mark(function _callee463(data) {
	    var t, result;
	    return _regenerator2.default.wrap(function _callee463$(_context463) {
	      while (1) {
	        switch (_context463.prev = _context463.next) {
	          case 0:
	            t = JSON.parse(data);
	            _context463.next = 3;
	            return fetch(_DomainName2.default.register + 'partnercategory/fetch_category_by_ids', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 3:
	            result = _context463.sent;
	            return _context463.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context463.stop();
	        }
	      }
	    }, _callee463, this);
	  }));
	
	  return function fetch_category_by_ids(_x439) {
	    return _ref463.apply(this, arguments);
	  };
	}();
	
	var getBlobList = function () {
	  var _ref464 = _asyncToGenerator(_regenerator2.default.mark(function _callee464(data) {
	    var t, result;
	    return _regenerator2.default.wrap(function _callee464$(_context464) {
	      while (1) {
	        switch (_context464.prev = _context464.next) {
	          case 0:
	            t = JSON.parse(data);
	            _context464.next = 3;
	            return fetch(_DomainName2.default.register + 'az/getcontainerlist', {
	              method: 'POST',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              },
	              body: data
	            });
	
	          case 3:
	            result = _context464.sent;
	            return _context464.abrupt('return', result.json());
	
	          case 5:
	          case 'end':
	            return _context464.stop();
	        }
	      }
	    }, _callee464, this);
	  }));
	
	  return function getBlobList(_x440) {
	    return _ref464.apply(this, arguments);
	  };
	}();
	
	var _react = __webpack_require__(1);
	
	var _DomainName = __webpack_require__(119);
	
	var _DomainName2 = _interopRequireDefault(_DomainName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import { conditionalExpression } from '@babel/types';
	// var FormData = require('form-data');
	
	var token = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ2ZW5kZXIiOnsiaWQiOiI1ZWJkMTMyOTQwMjJhMjNlMmM1YzA4MzkifSwiaWF0IjoxNTkxMTgwOTA3LCJleHAiOjM2MDAwMDAwMDAxNTkxMTgwMDAwfQ.TKBUep0bss3gqQBK8CkbUuRlO3jRLHEvGTGgm90gLRE";
	
	var FetchCall = function (_Component) {
	  _inherits(FetchCall, _Component);
	
	  function FetchCall() {
	    _classCallCheck(this, FetchCall);
	
	    return _possibleConstructorReturn(this, (FetchCall.__proto__ || Object.getPrototypeOf(FetchCall)).apply(this, arguments));
	  }
	
	  return FetchCall;
	}(_react.Component);
	
	FetchCall.getSchoolListDatas = function () {
	  var _ref465 = _asyncToGenerator(_regenerator2.default.mark(function _callee465(id) {
	    var result;
	    return _regenerator2.default.wrap(function _callee465$(_context465) {
	      while (1) {
	        switch (_context465.prev = _context465.next) {
	          case 0:
	            _context465.next = 2;
	            return fetch(_DomainName2.default.register + 'admin/common/get_drop_down/' + id, {
	              method: 'GET',
	              mode: 'cors',
	              headers: { 'Content-Type': 'application/json' }
	            });
	
	          case 2:
	            result = _context465.sent;
	            return _context465.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context465.stop();
	        }
	      }
	    }, _callee465, undefined);
	  }));
	
	  return function (_x441) {
	    return _ref465.apply(this, arguments);
	  };
	}();
	
	FetchCall.getEnqDetail = function () {
	  var _ref466 = _asyncToGenerator(_regenerator2.default.mark(function _callee466(id) {
	    var result;
	    return _regenerator2.default.wrap(function _callee466$(_context466) {
	      while (1) {
	        switch (_context466.prev = _context466.next) {
	          case 0:
	            _context466.next = 2;
	            return fetch(_DomainName2.default.register + 'admin/common/enquiry/' + id, {
	              method: 'GET',
	              mode: 'cors',
	              headers: { 'Content-Type': 'application/json' }
	            });
	
	          case 2:
	            result = _context466.sent;
	            return _context466.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context466.stop();
	        }
	      }
	    }, _callee466, undefined);
	  }));
	
	  return function (_x442) {
	    return _ref466.apply(this, arguments);
	  };
	}();
	
	FetchCall.getCategoryDetail = function () {
	  var _ref467 = _asyncToGenerator(_regenerator2.default.mark(function _callee467(id) {
	    var result;
	    return _regenerator2.default.wrap(function _callee467$(_context467) {
	      while (1) {
	        switch (_context467.prev = _context467.next) {
	          case 0:
	            _context467.next = 2;
	            return fetch(_DomainName2.default.register + 'admin/common/getcategorydetail/' + id, {
	              method: 'GET',
	              mode: 'cors',
	              headers: { 'Content-Type': 'application/json' }
	            });
	
	          case 2:
	            result = _context467.sent;
	            return _context467.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context467.stop();
	        }
	      }
	    }, _callee467, undefined);
	  }));
	
	  return function (_x443) {
	    return _ref467.apply(this, arguments);
	  };
	}();
	
	FetchCall.getSubCategory = function () {
	  var _ref468 = _asyncToGenerator(_regenerator2.default.mark(function _callee468(id) {
	    var result;
	    return _regenerator2.default.wrap(function _callee468$(_context468) {
	      while (1) {
	        switch (_context468.prev = _context468.next) {
	          case 0:
	            _context468.next = 2;
	            return fetch(_DomainName2.default.register + 'admin/common/getcategory/' + id, {
	              method: 'GET',
	              mode: 'cors',
	              headers: { 'Content-Type': 'application/json' }
	            });
	
	          case 2:
	            result = _context468.sent;
	            return _context468.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context468.stop();
	        }
	      }
	    }, _callee468, undefined);
	  }));
	
	  return function (_x444) {
	    return _ref468.apply(this, arguments);
	  };
	}();
	
	FetchCall.getNanniesList = function () {
	  var _ref469 = _asyncToGenerator(_regenerator2.default.mark(function _callee469(id) {
	    var result;
	    return _regenerator2.default.wrap(function _callee469$(_context469) {
	      while (1) {
	        switch (_context469.prev = _context469.next) {
	          case 0:
	            _context469.next = 2;
	            return fetch(_DomainName2.default.register + 'admin/common/get_drop_downs/' + id, {
	              method: 'GET',
	              mode: 'cors',
	              headers: { 'Content-Type': 'application/json' }
	            });
	
	          case 2:
	            result = _context469.sent;
	            return _context469.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context469.stop();
	        }
	      }
	    }, _callee469, undefined);
	  }));
	
	  return function (_x445) {
	    return _ref469.apply(this, arguments);
	  };
	}();
	
	FetchCall.getSchoolDetails = function () {
	  var _ref470 = _asyncToGenerator(_regenerator2.default.mark(function _callee470(id) {
	    var result;
	    return _regenerator2.default.wrap(function _callee470$(_context470) {
	      while (1) {
	        switch (_context470.prev = _context470.next) {
	          case 0:
	            _context470.next = 2;
	            return fetch(_DomainName2.default.register + 'school/vender/' + id, {
	              method: 'GET',
	              mode: 'cors',
	              headers: { 'Content-Type': 'application/json' }
	            });
	
	          case 2:
	            result = _context470.sent;
	            return _context470.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context470.stop();
	        }
	      }
	    }, _callee470, undefined);
	  }));
	
	  return function (_x446) {
	    return _ref470.apply(this, arguments);
	  };
	}();
	
	FetchCall.getPreSchoolDetails = function () {
	  var _ref471 = _asyncToGenerator(_regenerator2.default.mark(function _callee471(id) {
	    var result;
	    return _regenerator2.default.wrap(function _callee471$(_context471) {
	      while (1) {
	        switch (_context471.prev = _context471.next) {
	          case 0:
	            _context471.next = 2;
	            return fetch(_DomainName2.default.register + 'preschool/vender/' + id, {
	              method: 'GET',
	              mode: 'cors',
	              headers: { 'Content-Type': 'application/json' }
	            });
	
	          case 2:
	            result = _context471.sent;
	            return _context471.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context471.stop();
	        }
	      }
	    }, _callee471, undefined);
	  }));
	
	  return function (_x447) {
	    return _ref471.apply(this, arguments);
	  };
	}();
	
	FetchCall.getPlayAreaDetails = function () {
	  var _ref472 = _asyncToGenerator(_regenerator2.default.mark(function _callee472(id) {
	    var result;
	    return _regenerator2.default.wrap(function _callee472$(_context472) {
	      while (1) {
	        switch (_context472.prev = _context472.next) {
	          case 0:
	            _context472.next = 2;
	            return fetch(_DomainName2.default.register + 'playarea/vender/' + id, {
	              method: 'GET',
	              mode: 'cors',
	              headers: { 'Content-Type': 'application/json' }
	            });
	
	          case 2:
	            result = _context472.sent;
	            return _context472.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context472.stop();
	        }
	      }
	    }, _callee472, undefined);
	  }));
	
	  return function (_x448) {
	    return _ref472.apply(this, arguments);
	  };
	}();
	
	FetchCall.grtPartyHallInfo = function () {
	  var _ref473 = _asyncToGenerator(_regenerator2.default.mark(function _callee473(id) {
	    var result;
	    return _regenerator2.default.wrap(function _callee473$(_context473) {
	      while (1) {
	        switch (_context473.prev = _context473.next) {
	          case 0:
	            _context473.next = 2;
	            return fetch(_DomainName2.default.register + 'partyhall/vender/' + id, {
	              method: 'GET',
	              mode: 'cors',
	              headers: { 'Content-Type': 'application/json' }
	            });
	
	          case 2:
	            result = _context473.sent;
	            return _context473.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context473.stop();
	        }
	      }
	    }, _callee473, undefined);
	  }));
	
	  return function (_x449) {
	    return _ref473.apply(this, arguments);
	  };
	}();
	
	FetchCall.getEventsInfo = function () {
	  var _ref474 = _asyncToGenerator(_regenerator2.default.mark(function _callee474(id, type) {
	    var result;
	    return _regenerator2.default.wrap(function _callee474$(_context474) {
	      while (1) {
	        switch (_context474.prev = _context474.next) {
	          case 0:
	            _context474.next = 2;
	            return fetch(_DomainName2.default.register + 'admin/events/vender/' + id, {
	              method: 'GET',
	              mode: 'cors',
	              headers: { 'Content-Type': 'application/json' }
	            });
	
	          case 2:
	            result = _context474.sent;
	            return _context474.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context474.stop();
	        }
	      }
	    }, _callee474, undefined);
	  }));
	
	  return function (_x450, _x451) {
	    return _ref474.apply(this, arguments);
	  };
	}();
	
	FetchCall.sportsDetails = function () {
	  var _ref475 = _asyncToGenerator(_regenerator2.default.mark(function _callee475(id) {
	    var result;
	    return _regenerator2.default.wrap(function _callee475$(_context475) {
	      while (1) {
	        switch (_context475.prev = _context475.next) {
	          case 0:
	            _context475.next = 2;
	            return fetch(_DomainName2.default.register + 'sports/vender/' + id, {
	              method: 'GET',
	              mode: 'cors',
	              headers: { 'Content-Type': 'application/json' }
	            });
	
	          case 2:
	            result = _context475.sent;
	            return _context475.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context475.stop();
	        }
	      }
	    }, _callee475, undefined);
	  }));
	
	  return function (_x452) {
	    return _ref475.apply(this, arguments);
	  };
	}();
	
	FetchCall.TutionsInfo = function () {
	  var _ref476 = _asyncToGenerator(_regenerator2.default.mark(function _callee476(id) {
	    var result;
	    return _regenerator2.default.wrap(function _callee476$(_context476) {
	      while (1) {
	        switch (_context476.prev = _context476.next) {
	          case 0:
	            _context476.next = 2;
	            return fetch(_DomainName2.default.register + 'tution/vender/' + id, {
	              method: 'GET',
	              mode: 'cors',
	              headers: { 'Content-Type': 'application/json' }
	            });
	
	          case 2:
	            result = _context476.sent;
	            return _context476.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context476.stop();
	        }
	      }
	    }, _callee476, undefined);
	  }));
	
	  return function (_x453) {
	    return _ref476.apply(this, arguments);
	  };
	}();
	
	FetchCall.getCreativeActivitiesInfo = function () {
	  var _ref477 = _asyncToGenerator(_regenerator2.default.mark(function _callee477(id) {
	    var result;
	    return _regenerator2.default.wrap(function _callee477$(_context477) {
	      while (1) {
	        switch (_context477.prev = _context477.next) {
	          case 0:
	            _context477.next = 2;
	            return fetch(_DomainName2.default.register + 'admin/hobbies_intrest/vender/' + id, {
	              method: 'GET',
	              mode: 'cors',
	              headers: { 'Content-Type': 'application/json' }
	            });
	
	          case 2:
	            result = _context477.sent;
	            return _context477.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context477.stop();
	        }
	      }
	    }, _callee477, undefined);
	  }));
	
	  return function (_x454) {
	    return _ref477.apply(this, arguments);
	  };
	}();
	
	FetchCall.getTutionsInfo = function () {
	  var _ref478 = _asyncToGenerator(_regenerator2.default.mark(function _callee478(id) {
	    var result;
	    return _regenerator2.default.wrap(function _callee478$(_context478) {
	      while (1) {
	        switch (_context478.prev = _context478.next) {
	          case 0:
	            _context478.next = 2;
	            return fetch(_DomainName2.default.register + 'tution/vender/' + id, {
	              method: 'GET',
	              mode: 'cors',
	              headers: { 'Content-Type': 'application/json' }
	            });
	
	          case 2:
	            result = _context478.sent;
	            return _context478.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context478.stop();
	        }
	      }
	    }, _callee478, undefined);
	  }));
	
	  return function (_x455) {
	    return _ref478.apply(this, arguments);
	  };
	}();
	
	FetchCall.getCampInfo = function () {
	  var _ref479 = _asyncToGenerator(_regenerator2.default.mark(function _callee479(id) {
	    var result;
	    return _regenerator2.default.wrap(function _callee479$(_context479) {
	      while (1) {
	        switch (_context479.prev = _context479.next) {
	          case 0:
	            _context479.next = 2;
	            return fetch(_DomainName2.default.register + 'camps/vender/' + id, {
	              method: 'GET',
	              mode: 'cors',
	              headers: { 'Content-Type': 'application/json' }
	            });
	
	          case 2:
	            result = _context479.sent;
	            return _context479.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context479.stop();
	        }
	      }
	    }, _callee479, undefined);
	  }));
	
	  return function (_x456) {
	    return _ref479.apply(this, arguments);
	  };
	}();
	
	FetchCall.getSummerCampInfo = function () {
	  var _ref480 = _asyncToGenerator(_regenerator2.default.mark(function _callee480(id) {
	    var result;
	    return _regenerator2.default.wrap(function _callee480$(_context480) {
	      while (1) {
	        switch (_context480.prev = _context480.next) {
	          case 0:
	            _context480.next = 2;
	            return fetch(_DomainName2.default.register + 'summercamps/getsummercampbyvendor/' + id, {
	              method: 'POST',
	              mode: 'cors',
	              headers: { 'Content-Type': 'application/json' }
	            });
	
	          case 2:
	            result = _context480.sent;
	            return _context480.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context480.stop();
	        }
	      }
	    }, _callee480, undefined);
	  }));
	
	  return function (_x457) {
	    return _ref480.apply(this, arguments);
	  };
	}();
	
	FetchCall.getAdviceInfo = function () {
	  var _ref481 = _asyncToGenerator(_regenerator2.default.mark(function _callee481(id, type) {
	    var result;
	    return _regenerator2.default.wrap(function _callee481$(_context481) {
	      while (1) {
	        switch (_context481.prev = _context481.next) {
	          case 0:
	            _context481.next = 2;
	            return fetch(_DomainName2.default.register + 'admin/advice/vender/' + id, {
	              method: 'GET',
	              mode: 'cors',
	              headers: { 'Content-Type': 'application/json' }
	            });
	
	          case 2:
	            result = _context481.sent;
	            return _context481.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context481.stop();
	        }
	      }
	    }, _callee481, undefined);
	  }));
	
	  return function (_x458, _x459) {
	    return _ref481.apply(this, arguments);
	  };
	}();
	
	FetchCall.getCuratedCampInfo = function () {
	  var _ref482 = _asyncToGenerator(_regenerator2.default.mark(function _callee482(id) {
	    var result;
	    return _regenerator2.default.wrap(function _callee482$(_context482) {
	      while (1) {
	        switch (_context482.prev = _context482.next) {
	          case 0:
	            _context482.next = 2;
	            return fetch(_DomainName2.default.register + 'curatedcamps/getcampinfo/' + id, {
	              method: 'GET',
	              mode: 'cors',
	              headers: { 'Content-Type': 'application/json' }
	            });
	
	          case 2:
	            result = _context482.sent;
	            return _context482.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context482.stop();
	        }
	      }
	    }, _callee482, undefined);
	  }));
	
	  return function (_x460) {
	    return _ref482.apply(this, arguments);
	  };
	}();
	
	FetchCall.getLeadDetail = function () {
	  var _ref483 = _asyncToGenerator(_regenerator2.default.mark(function _callee483(lead_id) {
	    var result;
	    return _regenerator2.default.wrap(function _callee483$(_context483) {
	      while (1) {
	        switch (_context483.prev = _context483.next) {
	          case 0:
	            _context483.next = 2;
	            return fetch(_DomainName2.default.register + 'leads/processlead/getDetailLeadAdmin/' + lead_id, {
	              method: 'GET',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              }
	            });
	
	          case 2:
	            result = _context483.sent;
	            return _context483.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context483.stop();
	        }
	      }
	    }, _callee483, undefined);
	  }));
	
	  return function (_x461) {
	    return _ref483.apply(this, arguments);
	  };
	}();
	
	FetchCall.getLeadDetailPartner = function () {
	  var _ref484 = _asyncToGenerator(_regenerator2.default.mark(function _callee484(lead_id, partner_id) {
	    var result;
	    return _regenerator2.default.wrap(function _callee484$(_context484) {
	      while (1) {
	        switch (_context484.prev = _context484.next) {
	          case 0:
	            _context484.next = 2;
	            return fetch(_DomainName2.default.register + 'leads/processlead/getDetailLeadPartner/' + lead_id + '/' + partner_id, {
	              method: 'GET',
	              mode: 'cors',
	              headers: {
	                'x-auth-token': token,
	                'Content-Type': 'application/json; charset=UTF-8'
	              }
	            });
	
	          case 2:
	            result = _context484.sent;
	            return _context484.abrupt('return', result.json());
	
	          case 4:
	          case 'end':
	            return _context484.stop();
	        }
	      }
	    }, _callee484, undefined);
	  }));
	
	  return function (_x462, _x463) {
	    return _ref484.apply(this, arguments);
	  };
	}();
	
	exports.getBlobList = getBlobList;
	exports.fetch_category_by_ids = fetch_category_by_ids;
	exports.activatePartner = activatePartner;
	exports.getcuratedviews = getcuratedviews;
	exports.leadreportstext = leadreportstext;
	exports.leadCharts = leadCharts;
	exports.saveAbout = saveAbout;
	exports.resetPasswordSend = resetPasswordSend;
	exports.checkifLeadsReceived = checkifLeadsReceived;
	exports.registerVendorNew = registerVendorNew;
	exports.showresultssearch = showresultssearch;
	exports.generateDataGraph = generateDataGraph;
	exports.generateThumbnails = generateThumbnails;
	exports.exclprtshipsListPartners = exclprtshipsListPartners;
	exports.saveExclEnqLead = saveExclEnqLead;
	exports.uploadBannerB2b = uploadBannerB2b;
	exports.bringNoDateMail = bringNoDateMail;
	exports.sendRegretNoData = sendRegretNoData;
	exports.getPageDetail = getPageDetail;
	exports.updatePage = updatePage;
	exports.approvePage = approvePage;
	exports.getSpecialPageList = getSpecialPageList;
	exports.getPaymentInfo = getPaymentInfo;
	exports.getEnquiries = getEnquiries;
	exports.getTotalEnquiries = getTotalEnquiries;
	exports.sendProComFollowUp = sendProComFollowUp;
	exports.getCitiesByKeyWord = getCitiesByKeyWord;
	exports.unBlockThisUser = unBlockThisUser;
	exports.blockThisUser = blockThisUser;
	exports.getSpecialDiscount = getSpecialDiscount;
	exports.getAddonList = getAddonList;
	exports.partnerAddBranch = partnerAddBranch;
	exports.generatePdfHtml = generatePdfHtml;
	exports.getEducations = getEducations;
	exports.getExperiences = getExperiences;
	exports.getProfileDetail = getProfileDetail;
	exports.getTotalRegistered = getTotalRegistered;
	exports.getRegisteredListPaged = getRegisteredListPaged;
	exports.getTotalNewsLetterSubscribers = getTotalNewsLetterSubscribers;
	exports.getNewsLetterSubscribersListPaged = getNewsLetterSubscribersListPaged;
	exports.sendCustomMail = sendCustomMail;
	exports.processReminderMail = processReminderMail;
	exports.getExtBlogById = getExtBlogById;
	exports.updateablog = updateablog;
	exports.postanextblog = postanextblog;
	exports.getBlogsListPaged = getBlogsListPaged;
	exports.getTotalBlogs = getTotalBlogs;
	exports.getTotalJobs = getTotalJobs;
	exports.getJobsListPaged = getJobsListPaged;
	exports.getExclPartnerShipDetailById = getExclPartnerShipDetailById;
	exports.checkifWcSubscribedTrial = checkifWcSubscribedTrial;
	exports.checkAndsubscribeWiseConnect = checkAndsubscribeWiseConnect;
	exports.getTotalAuroSubscribers = getTotalAuroSubscribers;
	exports.getAuroScholarPaged = getAuroScholarPaged;
	exports.getPartnerSubscriptions = getPartnerSubscriptions;
	exports.partnerSubscriptionV1 = partnerSubscriptionV1;
	exports.getBlogCategory = getBlogCategory;
	exports.getJobDetail = getJobDetail;
	exports.addjobimporting = addjobimporting;
	exports.createprovider = createprovider;
	exports.approvecourse = approvecourse;
	exports.updateCourse = updateCourse;
	exports.getCourseById = getCourseById;
	exports.getCoursesbyUser = getCoursesbyUser;
	exports.saveCourse = saveCourse;
	exports.LoginCourse = LoginCourse;
	exports.getCoursesListPaged = getCoursesListPaged;
	exports.getOtherCoursesListPaged = getOtherCoursesListPaged;
	exports.getTalents = getTalents;
	exports.getApplicants = getApplicants;
	exports.saveJobStatus = saveJobStatus;
	exports.getTotalApplicants = getTotalApplicants;
	exports.postajob = postajob;
	exports.getJobDetailTeacher = getJobDetailTeacher;
	exports.updatejob = updatejob;
	exports.getjobs = getjobs;
	exports.approveInsight = approveInsight;
	exports.approveBulk = approveBulk;
	exports.getTotalPartnersTrashed = getTotalPartnersTrashed;
	exports.getPartnerPagedTrashed = getPartnerPagedTrashed;
	exports.movetoTrash = movetoTrash;
	exports.restoreTrash = restoreTrash;
	exports.deActivatePartner = deActivatePartner;
	exports.removeExclUser = removeExclUser;
	exports.editExclUser = editExclUser;
	exports.checkDuplicateUrl = checkDuplicateUrl;
	exports.getTotalDuplicates = getTotalDuplicates;
	exports.getDuplicatesPaged = getDuplicatesPaged;
	exports.updateEntry = updateEntry;
	exports.createLeadManual = createLeadManual;
	exports.confirmLead = confirmLead;
	exports.getKidsPlayAreaPaged = getKidsPlayAreaPaged;
	exports.exportWcSubscribers = exportWcSubscribers;
	exports.getSubscribersListPaged = getSubscribersListPaged;
	exports.getTotalSubscribers = getTotalSubscribers;
	exports.checkifduplicateExist = checkifduplicateExist;
	exports.findTeachers = findTeachers;
	exports.getTotalLeads = getTotalLeads;
	exports.getTotalTransactions = getTotalTransactions;
	exports.getTotalBewiseUsers = getTotalBewiseUsers;
	exports.getTotalParents = getTotalParents;
	exports.getEventsPaged = getEventsPaged;
	exports.getTotalPartners = getTotalPartners;
	exports.eventsCount = eventsCount;
	exports.getTotal = getTotal;
	exports.removethisItem = removethisItem;
	exports.schoolCount = schoolCount;
	exports.preschoolCount = preschoolCount;
	exports.afaCount = afaCount;
	exports.learningcampCount = learningcampCount;
	exports.tuitionCount = tuitionCount;
	exports.beWiseArticles = beWiseArticles;
	exports.partnerArticles = partnerArticles;
	exports.getCuratedCampListV2 = getCuratedCampListV2;
	exports.getLatestNews = getLatestNews;
	exports.getTotalUsers = getTotalUsers;
	exports.getInsightListPaged = getInsightListPaged;
	exports.getInsightListTotal = getInsightListTotal;
	exports.LoginBeWise = LoginBeWise;
	exports.getRoleDetail = getRoleDetail;
	exports.getWebsiteAds = getWebsiteAds;
	exports.getArticleDetail = getArticleDetail;
	exports.getNews = getNews;
	exports.saveNews = saveNews;
	exports.getNewsList = getNewsList;
	exports.getBeWiseCuratedCampList = getBeWiseCuratedCampList;
	exports.getResourceList = getResourceList;
	exports.getPromoCodeList = getPromoCodeList;
	exports.getBewiseUsersPaged = getBewiseUsersPaged;
	exports.getExclusivePartnersPaged = getExclusivePartnersPaged;
	exports.getPartnerPaged = getPartnerPaged;
	exports.saveRole = saveRole;
	exports.getGST = getGST;
	exports.saveGST = saveGST;
	exports.getPlanList = getPlanList;
	exports.getRazorPayTransactionListV1 = getRazorPayTransactionListV1;
	exports.getTransactionListV1 = getTransactionListV1;
	exports.saveSiteContent = saveSiteContent;
	exports.removeCMSSiteContent = removeCMSSiteContent;
	exports.saveMail = saveMail;
	exports.getSchools = getSchools;
	exports.getPreSchools = getPreSchools;
	exports.getAfterSchools = getAfterSchools;
	exports.getTutionList = getTutionList;
	exports.getEvents = getEvents;
	exports.getSeasonalCampList = getSeasonalCampList;
	exports.getCommunitySupport = getCommunitySupport;
	exports.ForgotPass = ForgotPass;
	exports.ResetPass = ResetPass;
	exports.changePass = changePass;
	exports.SentOtp = SentOtp;
	exports.checkOTP = checkOTP;
	exports.getCatDrop = getCatDrop;
	exports.preSclList = preSclList;
	exports.sclList = sclList;
	exports.adviceDel = adviceDel;
	exports.deleteSesCamp = deleteSesCamp;
	exports.deletePlayArea = deletePlayArea;
	exports.deleteSchl = deleteSchl;
	exports.LoginAdmin = LoginAdmin;
	exports.registerVendor = registerVendor;
	exports.deleteHobby = deleteHobby;
	exports.eventsDel = eventsDel;
	exports.tutionDel = tutionDel;
	exports.preschoolDel = preschoolDel;
	exports.getAdvicelists = getAdvicelists;
	exports.AddNannier = AddNannier;
	exports.AddCounselors = AddCounselors;
	exports.getSchoolListData = getSchoolListData;
	exports.AddSuppliers = AddSuppliers;
	exports.AddVenues = AddVenues;
	exports.AddEntertainers = AddEntertainers;
	exports.AddCakeShop = AddCakeShop;
	exports.AddCamps = AddCamps;
	exports.createSchool = createSchool;
	exports.AddTutions = AddTutions;
	exports.AddSports = AddSports;
	exports.AddPartyHall = AddPartyHall;
	exports.addPreschool = addPreschool;
	exports.addPlayArea = addPlayArea;
	exports.getAllPlayareas = getAllPlayareas;
	exports.addDance = addDance;
	exports.addDrawing = addDrawing;
	exports.addMusic = addMusic;
	exports.addYoga = addYoga;
	exports.ImportExcelSchool = ImportExcelSchool;
	exports.ImportExcelPreSchool = ImportExcelPreSchool;
	exports.ImportExcelPlayarea = ImportExcelPlayarea;
	exports.ImportExcelHobbies = ImportExcelHobbies;
	exports.ImportExcelTutions = ImportExcelTutions;
	exports.ImportExcelEvents = ImportExcelEvents;
	exports.ImportExcelCamp = ImportExcelCamp;
	exports.ImportExcelCommunity = ImportExcelCommunity;
	exports.SubscribeData = SubscribeData;
	exports.ContactData = ContactData;
	exports.getUserList = getUserList;
	exports.getUserInfo = getUserInfo;
	exports.getLocationList = getLocationList;
	exports.deletePreSchl = deletePreSchl;
	exports.getVendorList = getVendorList;
	exports.getVendorInfo = getVendorInfo;
	exports.getMenu = getMenu;
	exports.AddRole = AddRole;
	exports.getRoles = getRoles;
	exports.deleteRole = deleteRole;
	exports.EditRoleData = EditRoleData;
	exports.getSubuser = getSubuser;
	exports.deleteUser = deleteUser;
	exports.AddUserData = AddUserData;
	exports.EditSubuserData = EditSubuserData;
	exports.verifyLogin = verifyLogin;
	exports.getPlan = getPlan;
	exports.CreatePay = CreatePay;
	exports.ProfileUpdate = ProfileUpdate;
	exports.getTransactionList = getTransactionList;
	exports.getInvoiceInfo = getInvoiceInfo;
	exports.getPartnerDetails = getPartnerDetails;
	exports.getCatList = getCatList;
	exports.approveVendorInfo = approveVendorInfo;
	exports.vendorDashboard = vendorDashboard;
	exports.adminDashboard = adminDashboard;
	exports.emailExist = emailExist;
	exports.getCommentList = getCommentList;
	exports.registerPartnerInd = registerPartnerInd;
	exports.indResponse = indResponse;
	exports.indVerifyLink = indVerifyLink;
	exports.indComSignup = indComSignup;
	exports.getEnquiriesList = getEnquiriesList;
	exports.getRatingList = getRatingList;
	exports.rejectVendorInfo = rejectVendorInfo;
	exports.getDiscount = getDiscount;
	exports.EditDiscountData = EditDiscountData;
	exports.AddDiscount = AddDiscount;
	exports.getContactServiceList = getContactServiceList;
	exports.getDeviceAccess = getDeviceAccess;
	exports.getWishList = getWishList;
	exports.commonAPI = commonAPI;
	exports.UpdateVendorPlan = UpdateVendorPlan;
	exports.updategallery = updategallery;
	exports.signUpApi = signUpApi;
	exports.partnerApi = partnerApi;
	exports.bewiseuserExport = bewiseuserExport;
	exports.userExport = userExport;
	exports.vendorExport = vendorExport;
	exports.partnerDocupload = partnerDocupload;
	exports.contactUserExport = contactUserExport;
	exports.contactPartnerExport = contactPartnerExport;
	exports.transactionExport = transactionExport;
	exports.subExport = subExport;
	exports.CSPExport = CSPExport;
	exports.DAFExport = DAFExport;
	exports.WishExport = WishExport;
	exports.RatingExport = RatingExport;
	exports.getVideoListAdmin = getVideoListAdmin;
	exports.getVideoDataAdmin = getVideoDataAdmin;
	exports.updateAdminVideo = updateAdminVideo;
	exports.updateVideo = updateVideo;
	exports.removeInsight = removeInsight;
	exports.getInsightDetail = getInsightDetail;
	exports.getAuthorSuggest = getAuthorSuggest;
	exports.updateInsights = updateInsights;
	exports.getPackageList = getPackageList;
	exports.removePackage = removePackage;
	exports.getPackageDetail = getPackageDetail;
	exports.getPackageType = getPackageType;
	exports.updatePackageData = updatePackageData;
	exports.emailExist_check = emailExist_check;
	exports.taxdata = taxdata;
	exports.promodata = promodata;
	exports.deactivateUser = deactivateUser;
	exports.exportPreschool = exportPreschool;
	exports.exportSchool = exportSchool;
	exports.exportKidsplayArea = exportKidsplayArea;
	exports.exportAfterschool = exportAfterschool;
	exports.exportTuition = exportTuition;
	exports.exportLearningcamps = exportLearningcamps;
	exports.exportCommunitysupport = exportCommunitysupport;
	exports.exportBirthdayEvents = exportBirthdayEvents;
	exports.eventResource = eventResource;
	exports.updateResource = updateResource;
	exports.activateUser = activateUser;
	exports.getAllverticalData = getAllverticalData;
	exports.getAllcategoryData = getAllcategoryData;
	exports.subPartner = subPartner;
	exports.partnerCategory = partnerCategory;
	exports.partnerAfaCategory = partnerAfaCategory;
	exports.partnerSubscription = partnerSubscription;
	exports.getLocation = getLocation;
	exports.updateRemoveCategory = updateRemoveCategory;
	exports.partnerBranch = partnerBranch;
	exports.insightApi = insightApi;
	exports.benchApi = benchApi;
	exports.adminRoles = adminRoles;
	exports.adminUser = adminUser;
	exports.indUploadDocs = indUploadDocs;
	exports.uploadArticleImage = uploadArticleImage;
	exports.adminPriceChart = adminPriceChart;
	exports.pNotification = pNotification;
	exports.adminReport = adminReport;
	exports.getSummerCampList = getSummerCampList;
	exports.deleteSummerCamp = deleteSummerCamp;
	exports.add_Summer_Camp = add_Summer_Camp;
	exports.getSearchList = getSearchList;
	exports.getCuratedCampList = getCuratedCampList;
	exports.getCuratedCampListAll = getCuratedCampListAll;
	exports.approveVendorInfoCurated = approveVendorInfoCurated;
	exports.add_curated_camp = add_curated_camp;
	exports.partnerMainCategory = partnerMainCategory;
	exports.partnerSubCategories = partnerSubCategories;
	exports.AddCuratedCamps = AddCuratedCamps;
	exports.UpdateCuratedCamps = UpdateCuratedCamps;
	exports.ApproveCuratedCamp = ApproveCuratedCamp;
	exports.UpdateCuratedCampsByAdmin = UpdateCuratedCampsByAdmin;
	exports.getCuratedPaymentList = getCuratedPaymentList;
	exports.getCuratedRegistrationList = getCuratedRegistrationList;
	exports.sendWelcomeEmailCamp = sendWelcomeEmailCamp;
	exports.uploadMedia = uploadMedia;
	exports.uploadLogo = uploadLogo;
	exports.uploadBanner = uploadBanner;
	exports.uploadBannerAd = uploadBannerAd;
	exports.uploadOtherAd = uploadOtherAd;
	exports.uploadImage = uploadImage;
	exports.uploadVideo = uploadVideo;
	exports.saveEntry = saveEntry;
	exports.submitEntry = submitEntry;
	exports.removeExclPtnrsEntry = removeExclPtnrsEntry;
	exports.getExclPtnrsEntry = getExclPtnrsEntry;
	exports.getExclPtnrsEntryB2B = getExclPtnrsEntryB2B;
	exports.getExclPtnrsEntryById = getExclPtnrsEntryById;
	exports.getExclusiveList = getExclusiveList;
	exports.deleteExclPartnership = deleteExclPartnership;
	exports.getUnseenEntries = getUnseenEntries;
	exports.sendAdminMessage = sendAdminMessage;
	exports.changeStatusExclPart = changeStatusExclPart;
	exports.makeMessageRead = makeMessageRead;
	exports.adminExclUser = adminExclUser;
	exports.AddExclUserData = AddExclUserData;
	exports.sclEdit = sclEdit;
	exports.presclEdit = presclEdit;
	exports.playareaEdit = playareaEdit;
	exports.hobbiesEdit = hobbiesEdit;
	exports.tuitionEdit = tuitionEdit;
	exports.communityEdit = communityEdit;
	exports.learningEdit = learningEdit;
	exports.eventEdit = eventEdit;
	exports.sclReject = sclReject;
	exports.presclReject = presclReject;
	exports.playareaReject = playareaReject;
	exports.hobbiesReject = hobbiesReject;
	exports.tuitionReject = tuitionReject;
	exports.learningReject = learningReject;
	exports.communityReject = communityReject;
	exports.eventReject = eventReject;
	exports.retailerAPI = retailerAPI;
	exports.retailerUpdate = retailerUpdate;
	exports.importRetailer = importRetailer;
	exports.updateSplEvent = updateSplEvent;
	exports.splEvent = splEvent;
	exports.packageAPI = packageAPI;
	exports.partnerReportV1 = partnerReportV1;
	exports.getLeads = getLeads;
	exports.getLeadsByPartner = getLeadsByPartner;
	exports.ParterSeenLead = ParterSeenLead;
	exports.checkPaidOrNot = checkPaidOrNot;
	exports.updateLeadAction = updateLeadAction;
	exports.getPartnerLeadInfo = getPartnerLeadInfo;
	exports.getPartnerAds = getPartnerAds;
	exports.getAllAds = getAllAds;
	exports.getOtherAds = getOtherAds;
	exports.uploadBrochure = uploadBrochure;
	exports.exclprtshipsList = exclprtshipsList;
	exports.uploadGallery = uploadGallery;
	exports.submitAdsEntry = submitAdsEntry;
	exports.submitAdsEntryOther = submitAdsEntryOther;
	exports.deleteAdEntry = deleteAdEntry;
	exports.uploadFile1 = uploadFile1;
	exports.uploadFile2 = uploadFile2;
	exports.uploadThumb1 = uploadThumb1;
	exports.uploadThumb2 = uploadThumb2;
	exports.getSuggest = getSuggest;
	exports.updatePremiumList = updatePremiumList;
	exports.getPremiumList = getPremiumList;
	exports.removeTopFiveEntry = removeTopFiveEntry;
	exports.getSEOContents = getSEOContents;
	exports.stampSchool = stampSchool;
	exports.getPartnerLeadNew = getPartnerLeadNew;
	exports.checkifEligibleForStamping = checkifEligibleForStamping;
	exports.getStamps = getStamps;
	exports.createLead = createLead;
	exports.getLead_Stats = getLead_Stats;
	exports.checkiffeatured = checkiffeatured;
	exports.checkDiscountInfo = checkDiscountInfo;
	exports.moveup = moveup;
	exports.creatediscount = creatediscount;
	exports.removefeatured = removefeatured;
	exports.removelead = removelead;
	exports.moveup_update = moveup_update;
	exports.getMailInfo = getMailInfo;
	exports.getPayLink = getPayLink;
	exports.sendMailPayLink = sendMailPayLink;
	exports.getDiscountNew = getDiscountNew;
	exports.getPaymentLinkInfo = getPaymentLinkInfo;
	exports.updatePaymentInfo = updatePaymentInfo;
	exports.getRazorPayTransactionList = getRazorPayTransactionList;
	exports.getPaymentLinkInfoDetail = getPaymentLinkInfoDetail;
	exports.partnerSubscriptionAfterRazorPayLinks = partnerSubscriptionAfterRazorPayLinks;
	exports.getMailCampaignList = getMailCampaignList;
	exports.uploadEmailImage = uploadEmailImage;
	exports.saveEmailCampaign = saveEmailCampaign;
	exports.startEmailCampaign = startEmailCampaign;
	exports.getEmailCampaign = getEmailCampaign;
	exports.updateEmailCampaign = updateEmailCampaign;
	exports.getCampaignMailInfo = getCampaignMailInfo;
	exports.cancelCampaign = cancelCampaign;
	exports.cancelRemoveCampaign = cancelRemoveCampaign;
	exports.deleteOtherAdEntry = deleteOtherAdEntry;
	exports.getAllUnpaidUsers = getAllUnpaidUsers;
	exports.getCampaignBatches = getCampaignBatches;
	exports.updateOpt = updateOpt;
	exports.getJobs = getJobs;
	exports.discount_update = discount_update;
	exports.savePayLink = savePayLink;
	exports.getIncompleteLeads = getIncompleteLeads;
	exports.CheckCreatePartner = CheckCreatePartner;
	exports.checkpushLead = checkpushLead;
	exports.getJobsList = getJobsList;
	exports.getAreaNamesList = getAreaNamesList;
	exports.saveArea = saveArea;
	exports.verifyVendor = verifyVendor;
	exports.findpartnersendotplink = findpartnersendotplink;
	exports.getSchoolsPaged = getSchoolsPaged;
	exports.getParentsPaged = getParentsPaged;
	exports.getPreSchoolsPaged = getPreSchoolsPaged;
	exports.getVerticalUserCount = getVerticalUserCount;
	exports.getSchoolNoOfRegistered = getSchoolNoOfRegistered;
	exports.getSchoolNoOfUnRegistered = getSchoolNoOfUnRegistered;
	exports.getMailList = getMailList;
	exports.getMail = getMail;
	exports.uploadEditorImage = uploadEditorImage;
	exports.getTuitionsPaged = getTuitionsPaged;
	exports.getAFAPaged = getAFAPaged;
	exports.getCampsPaged = getCampsPaged;
	exports.getCommunityPaged = getCommunityPaged;
	exports.getInsightList = getInsightList;
	exports.getCMSSiteList = getCMSSiteList;
	exports.getImagesList = getImagesList;
	exports.getSchoolDetail = getSchoolDetail;
	exports.getAreaNamesListV2 = getAreaNamesListV2;
	exports.getCityList = getCityList;
	exports.getContacts = getContacts;
	exports.saveCity = saveCity;
	exports.getRoleListV1 = getRoleListV1;
	exports.getRoleMenus = getRoleMenus;
	exports.uploadThumbNew = uploadThumbNew;
	exports.uploadBrochureNew = uploadBrochureNew;
	exports.removalItemBigBanner = removalItemBigBanner;
	exports.removalItemExclusiveBanner1 = removalItemExclusiveBanner1;
	exports.removalItemExclusiveBanner2 = removalItemExclusiveBanner2;
	exports.default = FetchCall;

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery JavaScript Library v3.7.1
	 * https://jquery.com/
	 *
	 * Copyright OpenJS Foundation and other contributors
	 * Released under the MIT license
	 * https://jquery.org/license
	 *
	 * Date: 2023-08-28T13:37Z
	 */
	( function( global, factory ) {
	
		"use strict";
	
		if ( typeof module === "object" && typeof module.exports === "object" ) {
	
			// For CommonJS and CommonJS-like environments where a proper `window`
			// is present, execute the factory and get jQuery.
			// For environments that do not have a `window` with a `document`
			// (such as Node.js), expose a factory as module.exports.
			// This accentuates the need for the creation of a real `window`.
			// e.g. var jQuery = require("jquery")(window);
			// See ticket trac-14549 for more info.
			module.exports = global.document ?
				factory( global, true ) :
				function( w ) {
					if ( !w.document ) {
						throw new Error( "jQuery requires a window with a document" );
					}
					return factory( w );
				};
		} else {
			factory( global );
		}
	
	// Pass this if window is not defined yet
	} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {
	
	// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
	// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
	// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
	// enough that all such attempts are guarded in a try block.
	"use strict";
	
	var arr = [];
	
	var getProto = Object.getPrototypeOf;
	
	var slice = arr.slice;
	
	var flat = arr.flat ? function( array ) {
		return arr.flat.call( array );
	} : function( array ) {
		return arr.concat.apply( [], array );
	};
	
	
	var push = arr.push;
	
	var indexOf = arr.indexOf;
	
	var class2type = {};
	
	var toString = class2type.toString;
	
	var hasOwn = class2type.hasOwnProperty;
	
	var fnToString = hasOwn.toString;
	
	var ObjectFunctionString = fnToString.call( Object );
	
	var support = {};
	
	var isFunction = function isFunction( obj ) {
	
			// Support: Chrome <=57, Firefox <=52
			// In some browsers, typeof returns "function" for HTML <object> elements
			// (i.e., `typeof document.createElement( "object" ) === "function"`).
			// We don't want to classify *any* DOM node as a function.
			// Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
			// Plus for old WebKit, typeof returns "function" for HTML collections
			// (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
			return typeof obj === "function" && typeof obj.nodeType !== "number" &&
				typeof obj.item !== "function";
		};
	
	
	var isWindow = function isWindow( obj ) {
			return obj != null && obj === obj.window;
		};
	
	
	var document = window.document;
	
	
	
		var preservedScriptAttributes = {
			type: true,
			src: true,
			nonce: true,
			noModule: true
		};
	
		function DOMEval( code, node, doc ) {
			doc = doc || document;
	
			var i, val,
				script = doc.createElement( "script" );
	
			script.text = code;
			if ( node ) {
				for ( i in preservedScriptAttributes ) {
	
					// Support: Firefox 64+, Edge 18+
					// Some browsers don't support the "nonce" property on scripts.
					// On the other hand, just using `getAttribute` is not enough as
					// the `nonce` attribute is reset to an empty string whenever it
					// becomes browsing-context connected.
					// See https://github.com/whatwg/html/issues/2369
					// See https://html.spec.whatwg.org/#nonce-attributes
					// The `node.getAttribute` check was added for the sake of
					// `jQuery.globalEval` so that it can fake a nonce-containing node
					// via an object.
					val = node[ i ] || node.getAttribute && node.getAttribute( i );
					if ( val ) {
						script.setAttribute( i, val );
					}
				}
			}
			doc.head.appendChild( script ).parentNode.removeChild( script );
		}
	
	
	function toType( obj ) {
		if ( obj == null ) {
			return obj + "";
		}
	
		// Support: Android <=2.3 only (functionish RegExp)
		return typeof obj === "object" || typeof obj === "function" ?
			class2type[ toString.call( obj ) ] || "object" :
			typeof obj;
	}
	/* global Symbol */
	// Defining this global in .eslintrc.json would create a danger of using the global
	// unguarded in another place, it seems safer to define global only for this module
	
	
	
	var version = "3.7.1",
	
		rhtmlSuffix = /HTML$/i,
	
		// Define a local copy of jQuery
		jQuery = function( selector, context ) {
	
			// The jQuery object is actually just the init constructor 'enhanced'
			// Need init if jQuery is called (just allow error to be thrown if not included)
			return new jQuery.fn.init( selector, context );
		};
	
	jQuery.fn = jQuery.prototype = {
	
		// The current version of jQuery being used
		jquery: version,
	
		constructor: jQuery,
	
		// The default length of a jQuery object is 0
		length: 0,
	
		toArray: function() {
			return slice.call( this );
		},
	
		// Get the Nth element in the matched element set OR
		// Get the whole matched element set as a clean array
		get: function( num ) {
	
			// Return all the elements in a clean array
			if ( num == null ) {
				return slice.call( this );
			}
	
			// Return just the one element from the set
			return num < 0 ? this[ num + this.length ] : this[ num ];
		},
	
		// Take an array of elements and push it onto the stack
		// (returning the new matched element set)
		pushStack: function( elems ) {
	
			// Build a new jQuery matched element set
			var ret = jQuery.merge( this.constructor(), elems );
	
			// Add the old object onto the stack (as a reference)
			ret.prevObject = this;
	
			// Return the newly-formed element set
			return ret;
		},
	
		// Execute a callback for every element in the matched set.
		each: function( callback ) {
			return jQuery.each( this, callback );
		},
	
		map: function( callback ) {
			return this.pushStack( jQuery.map( this, function( elem, i ) {
				return callback.call( elem, i, elem );
			} ) );
		},
	
		slice: function() {
			return this.pushStack( slice.apply( this, arguments ) );
		},
	
		first: function() {
			return this.eq( 0 );
		},
	
		last: function() {
			return this.eq( -1 );
		},
	
		even: function() {
			return this.pushStack( jQuery.grep( this, function( _elem, i ) {
				return ( i + 1 ) % 2;
			} ) );
		},
	
		odd: function() {
			return this.pushStack( jQuery.grep( this, function( _elem, i ) {
				return i % 2;
			} ) );
		},
	
		eq: function( i ) {
			var len = this.length,
				j = +i + ( i < 0 ? len : 0 );
			return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
		},
	
		end: function() {
			return this.prevObject || this.constructor();
		},
	
		// For internal use only.
		// Behaves like an Array's method, not like a jQuery method.
		push: push,
		sort: arr.sort,
		splice: arr.splice
	};
	
	jQuery.extend = jQuery.fn.extend = function() {
		var options, name, src, copy, copyIsArray, clone,
			target = arguments[ 0 ] || {},
			i = 1,
			length = arguments.length,
			deep = false;
	
		// Handle a deep copy situation
		if ( typeof target === "boolean" ) {
			deep = target;
	
			// Skip the boolean and the target
			target = arguments[ i ] || {};
			i++;
		}
	
		// Handle case when target is a string or something (possible in deep copy)
		if ( typeof target !== "object" && !isFunction( target ) ) {
			target = {};
		}
	
		// Extend jQuery itself if only one argument is passed
		if ( i === length ) {
			target = this;
			i--;
		}
	
		for ( ; i < length; i++ ) {
	
			// Only deal with non-null/undefined values
			if ( ( options = arguments[ i ] ) != null ) {
	
				// Extend the base object
				for ( name in options ) {
					copy = options[ name ];
	
					// Prevent Object.prototype pollution
					// Prevent never-ending loop
					if ( name === "__proto__" || target === copy ) {
						continue;
					}
	
					// Recurse if we're merging plain objects or arrays
					if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
						( copyIsArray = Array.isArray( copy ) ) ) ) {
						src = target[ name ];
	
						// Ensure proper type for the source value
						if ( copyIsArray && !Array.isArray( src ) ) {
							clone = [];
						} else if ( !copyIsArray && !jQuery.isPlainObject( src ) ) {
							clone = {};
						} else {
							clone = src;
						}
						copyIsArray = false;
	
						// Never move original objects, clone them
						target[ name ] = jQuery.extend( deep, clone, copy );
	
					// Don't bring in undefined values
					} else if ( copy !== undefined ) {
						target[ name ] = copy;
					}
				}
			}
		}
	
		// Return the modified object
		return target;
	};
	
	jQuery.extend( {
	
		// Unique for each copy of jQuery on the page
		expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),
	
		// Assume jQuery is ready without the ready module
		isReady: true,
	
		error: function( msg ) {
			throw new Error( msg );
		},
	
		noop: function() {},
	
		isPlainObject: function( obj ) {
			var proto, Ctor;
	
			// Detect obvious negatives
			// Use toString instead of jQuery.type to catch host objects
			if ( !obj || toString.call( obj ) !== "[object Object]" ) {
				return false;
			}
	
			proto = getProto( obj );
	
			// Objects with no prototype (e.g., `Object.create( null )`) are plain
			if ( !proto ) {
				return true;
			}
	
			// Objects with prototype are plain iff they were constructed by a global Object function
			Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
			return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
		},
	
		isEmptyObject: function( obj ) {
			var name;
	
			for ( name in obj ) {
				return false;
			}
			return true;
		},
	
		// Evaluates a script in a provided context; falls back to the global one
		// if not specified.
		globalEval: function( code, options, doc ) {
			DOMEval( code, { nonce: options && options.nonce }, doc );
		},
	
		each: function( obj, callback ) {
			var length, i = 0;
	
			if ( isArrayLike( obj ) ) {
				length = obj.length;
				for ( ; i < length; i++ ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			} else {
				for ( i in obj ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			}
	
			return obj;
		},
	
	
		// Retrieve the text value of an array of DOM nodes
		text: function( elem ) {
			var node,
				ret = "",
				i = 0,
				nodeType = elem.nodeType;
	
			if ( !nodeType ) {
	
				// If no nodeType, this is expected to be an array
				while ( ( node = elem[ i++ ] ) ) {
	
					// Do not traverse comment nodes
					ret += jQuery.text( node );
				}
			}
			if ( nodeType === 1 || nodeType === 11 ) {
				return elem.textContent;
			}
			if ( nodeType === 9 ) {
				return elem.documentElement.textContent;
			}
			if ( nodeType === 3 || nodeType === 4 ) {
				return elem.nodeValue;
			}
	
			// Do not include comment or processing instruction nodes
	
			return ret;
		},
	
		// results is for internal usage only
		makeArray: function( arr, results ) {
			var ret = results || [];
	
			if ( arr != null ) {
				if ( isArrayLike( Object( arr ) ) ) {
					jQuery.merge( ret,
						typeof arr === "string" ?
							[ arr ] : arr
					);
				} else {
					push.call( ret, arr );
				}
			}
	
			return ret;
		},
	
		inArray: function( elem, arr, i ) {
			return arr == null ? -1 : indexOf.call( arr, elem, i );
		},
	
		isXMLDoc: function( elem ) {
			var namespace = elem && elem.namespaceURI,
				docElem = elem && ( elem.ownerDocument || elem ).documentElement;
	
			// Assume HTML when documentElement doesn't yet exist, such as inside
			// document fragments.
			return !rhtmlSuffix.test( namespace || docElem && docElem.nodeName || "HTML" );
		},
	
		// Support: Android <=4.0 only, PhantomJS 1 only
		// push.apply(_, arraylike) throws on ancient WebKit
		merge: function( first, second ) {
			var len = +second.length,
				j = 0,
				i = first.length;
	
			for ( ; j < len; j++ ) {
				first[ i++ ] = second[ j ];
			}
	
			first.length = i;
	
			return first;
		},
	
		grep: function( elems, callback, invert ) {
			var callbackInverse,
				matches = [],
				i = 0,
				length = elems.length,
				callbackExpect = !invert;
	
			// Go through the array, only saving the items
			// that pass the validator function
			for ( ; i < length; i++ ) {
				callbackInverse = !callback( elems[ i ], i );
				if ( callbackInverse !== callbackExpect ) {
					matches.push( elems[ i ] );
				}
			}
	
			return matches;
		},
	
		// arg is for internal usage only
		map: function( elems, callback, arg ) {
			var length, value,
				i = 0,
				ret = [];
	
			// Go through the array, translating each of the items to their new values
			if ( isArrayLike( elems ) ) {
				length = elems.length;
				for ( ; i < length; i++ ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
	
			// Go through every key on the object,
			} else {
				for ( i in elems ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
			}
	
			// Flatten any nested arrays
			return flat( ret );
		},
	
		// A global GUID counter for objects
		guid: 1,
	
		// jQuery.support is not used in Core but other projects attach their
		// properties to it so it needs to exist.
		support: support
	} );
	
	if ( typeof Symbol === "function" ) {
		jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
	}
	
	// Populate the class2type map
	jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
		function( _i, name ) {
			class2type[ "[object " + name + "]" ] = name.toLowerCase();
		} );
	
	function isArrayLike( obj ) {
	
		// Support: real iOS 8.2 only (not reproducible in simulator)
		// `in` check used to prevent JIT error (gh-2145)
		// hasOwn isn't used here due to false negatives
		// regarding Nodelist length in IE
		var length = !!obj && "length" in obj && obj.length,
			type = toType( obj );
	
		if ( isFunction( obj ) || isWindow( obj ) ) {
			return false;
		}
	
		return type === "array" || length === 0 ||
			typeof length === "number" && length > 0 && ( length - 1 ) in obj;
	}
	
	
	function nodeName( elem, name ) {
	
		return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
	
	}
	var pop = arr.pop;
	
	
	var sort = arr.sort;
	
	
	var splice = arr.splice;
	
	
	var whitespace = "[\\x20\\t\\r\\n\\f]";
	
	
	var rtrimCSS = new RegExp(
		"^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$",
		"g"
	);
	
	
	
	
	// Note: an element does not contain itself
	jQuery.contains = function( a, b ) {
		var bup = b && b.parentNode;
	
		return a === bup || !!( bup && bup.nodeType === 1 && (
	
			// Support: IE 9 - 11+
			// IE doesn't have `contains` on SVG.
			a.contains ?
				a.contains( bup ) :
				a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
		) );
	};
	
	
	
	
	// CSS string/identifier serialization
	// https://drafts.csswg.org/cssom/#common-serializing-idioms
	var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
	
	function fcssescape( ch, asCodePoint ) {
		if ( asCodePoint ) {
	
			// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
			if ( ch === "\0" ) {
				return "\uFFFD";
			}
	
			// Control characters and (dependent upon position) numbers get escaped as code points
			return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
		}
	
		// Other potentially-special ASCII characters get backslash-escaped
		return "\\" + ch;
	}
	
	jQuery.escapeSelector = function( sel ) {
		return ( sel + "" ).replace( rcssescape, fcssescape );
	};
	
	
	
	
	var preferredDoc = document,
		pushNative = push;
	
	( function() {
	
	var i,
		Expr,
		outermostContext,
		sortInput,
		hasDuplicate,
		push = pushNative,
	
		// Local document vars
		document,
		documentElement,
		documentIsHTML,
		rbuggyQSA,
		matches,
	
		// Instance-specific data
		expando = jQuery.expando,
		dirruns = 0,
		done = 0,
		classCache = createCache(),
		tokenCache = createCache(),
		compilerCache = createCache(),
		nonnativeSelectorCache = createCache(),
		sortOrder = function( a, b ) {
			if ( a === b ) {
				hasDuplicate = true;
			}
			return 0;
		},
	
		booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|" +
			"loop|multiple|open|readonly|required|scoped",
	
		// Regular expressions
	
		// https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
		identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace +
			"?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",
	
		// Attribute selectors: https://www.w3.org/TR/selectors/#attribute-selectors
		attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
	
			// Operator (capture 2)
			"*([*^$|!~]?=)" + whitespace +
	
			// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
			"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" +
			whitespace + "*\\]",
	
		pseudos = ":(" + identifier + ")(?:\\((" +
	
			// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
			// 1. quoted (capture 3; capture 4 or capture 5)
			"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
	
			// 2. simple (capture 6)
			"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
	
			// 3. anything else (capture 2)
			".*" +
			")\\)|)",
	
		// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
		rwhitespace = new RegExp( whitespace + "+", "g" ),
	
		rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
		rleadingCombinator = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" +
			whitespace + "*" ),
		rdescend = new RegExp( whitespace + "|>" ),
	
		rpseudo = new RegExp( pseudos ),
		ridentifier = new RegExp( "^" + identifier + "$" ),
	
		matchExpr = {
			ID: new RegExp( "^#(" + identifier + ")" ),
			CLASS: new RegExp( "^\\.(" + identifier + ")" ),
			TAG: new RegExp( "^(" + identifier + "|[*])" ),
			ATTR: new RegExp( "^" + attributes ),
			PSEUDO: new RegExp( "^" + pseudos ),
			CHILD: new RegExp(
				"^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
					whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" +
					whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
			bool: new RegExp( "^(?:" + booleans + ")$", "i" ),
	
			// For use in libraries implementing .is()
			// We use this for POS matching in `select`
			needsContext: new RegExp( "^" + whitespace +
				"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace +
				"*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
		},
	
		rinputs = /^(?:input|select|textarea|button)$/i,
		rheader = /^h\d$/i,
	
		// Easily-parseable/retrievable ID or TAG or CLASS selectors
		rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
	
		rsibling = /[+~]/,
	
		// CSS escapes
		// https://www.w3.org/TR/CSS21/syndata.html#escaped-characters
		runescape = new RegExp( "\\\\[\\da-fA-F]{1,6}" + whitespace +
			"?|\\\\([^\\r\\n\\f])", "g" ),
		funescape = function( escape, nonHex ) {
			var high = "0x" + escape.slice( 1 ) - 0x10000;
	
			if ( nonHex ) {
	
				// Strip the backslash prefix from a non-hex escape sequence
				return nonHex;
			}
	
			// Replace a hexadecimal escape sequence with the encoded Unicode code point
			// Support: IE <=11+
			// For values outside the Basic Multilingual Plane (BMP), manually construct a
			// surrogate pair
			return high < 0 ?
				String.fromCharCode( high + 0x10000 ) :
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
		},
	
		// Used for iframes; see `setDocument`.
		// Support: IE 9 - 11+, Edge 12 - 18+
		// Removing the function wrapper causes a "Permission Denied"
		// error in IE/Edge.
		unloadHandler = function() {
			setDocument();
		},
	
		inDisabledFieldset = addCombinator(
			function( elem ) {
				return elem.disabled === true && nodeName( elem, "fieldset" );
			},
			{ dir: "parentNode", next: "legend" }
		);
	
	// Support: IE <=9 only
	// Accessing document.activeElement can throw unexpectedly
	// https://bugs.jquery.com/ticket/13393
	function safeActiveElement() {
		try {
			return document.activeElement;
		} catch ( err ) { }
	}
	
	// Optimize for push.apply( _, NodeList )
	try {
		push.apply(
			( arr = slice.call( preferredDoc.childNodes ) ),
			preferredDoc.childNodes
		);
	
		// Support: Android <=4.0
		// Detect silently failing push.apply
		// eslint-disable-next-line no-unused-expressions
		arr[ preferredDoc.childNodes.length ].nodeType;
	} catch ( e ) {
		push = {
			apply: function( target, els ) {
				pushNative.apply( target, slice.call( els ) );
			},
			call: function( target ) {
				pushNative.apply( target, slice.call( arguments, 1 ) );
			}
		};
	}
	
	function find( selector, context, results, seed ) {
		var m, i, elem, nid, match, groups, newSelector,
			newContext = context && context.ownerDocument,
	
			// nodeType defaults to 9, since context defaults to document
			nodeType = context ? context.nodeType : 9;
	
		results = results || [];
	
		// Return early from calls with invalid selector or context
		if ( typeof selector !== "string" || !selector ||
			nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {
	
			return results;
		}
	
		// Try to shortcut find operations (as opposed to filters) in HTML documents
		if ( !seed ) {
			setDocument( context );
			context = context || document;
	
			if ( documentIsHTML ) {
	
				// If the selector is sufficiently simple, try using a "get*By*" DOM method
				// (excepting DocumentFragment context, where the methods don't exist)
				if ( nodeType !== 11 && ( match = rquickExpr.exec( selector ) ) ) {
	
					// ID selector
					if ( ( m = match[ 1 ] ) ) {
	
						// Document context
						if ( nodeType === 9 ) {
							if ( ( elem = context.getElementById( m ) ) ) {
	
								// Support: IE 9 only
								// getElementById can match elements by name instead of ID
								if ( elem.id === m ) {
									push.call( results, elem );
									return results;
								}
							} else {
								return results;
							}
	
						// Element context
						} else {
	
							// Support: IE 9 only
							// getElementById can match elements by name instead of ID
							if ( newContext && ( elem = newContext.getElementById( m ) ) &&
								find.contains( context, elem ) &&
								elem.id === m ) {
	
								push.call( results, elem );
								return results;
							}
						}
	
					// Type selector
					} else if ( match[ 2 ] ) {
						push.apply( results, context.getElementsByTagName( selector ) );
						return results;
	
					// Class selector
					} else if ( ( m = match[ 3 ] ) && context.getElementsByClassName ) {
						push.apply( results, context.getElementsByClassName( m ) );
						return results;
					}
				}
	
				// Take advantage of querySelectorAll
				if ( !nonnativeSelectorCache[ selector + " " ] &&
					( !rbuggyQSA || !rbuggyQSA.test( selector ) ) ) {
	
					newSelector = selector;
					newContext = context;
	
					// qSA considers elements outside a scoping root when evaluating child or
					// descendant combinators, which is not what we want.
					// In such cases, we work around the behavior by prefixing every selector in the
					// list with an ID selector referencing the scope context.
					// The technique has to be used as well when a leading combinator is used
					// as such selectors are not recognized by querySelectorAll.
					// Thanks to Andrew Dupont for this technique.
					if ( nodeType === 1 &&
						( rdescend.test( selector ) || rleadingCombinator.test( selector ) ) ) {
	
						// Expand context for sibling selectors
						newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
							context;
	
						// We can use :scope instead of the ID hack if the browser
						// supports it & if we're not changing the context.
						// Support: IE 11+, Edge 17 - 18+
						// IE/Edge sometimes throw a "Permission denied" error when
						// strict-comparing two documents; shallow comparisons work.
						// eslint-disable-next-line eqeqeq
						if ( newContext != context || !support.scope ) {
	
							// Capture the context ID, setting it first if necessary
							if ( ( nid = context.getAttribute( "id" ) ) ) {
								nid = jQuery.escapeSelector( nid );
							} else {
								context.setAttribute( "id", ( nid = expando ) );
							}
						}
	
						// Prefix every selector in the list
						groups = tokenize( selector );
						i = groups.length;
						while ( i-- ) {
							groups[ i ] = ( nid ? "#" + nid : ":scope" ) + " " +
								toSelector( groups[ i ] );
						}
						newSelector = groups.join( "," );
					}
	
					try {
						push.apply( results,
							newContext.querySelectorAll( newSelector )
						);
						return results;
					} catch ( qsaError ) {
						nonnativeSelectorCache( selector, true );
					} finally {
						if ( nid === expando ) {
							context.removeAttribute( "id" );
						}
					}
				}
			}
		}
	
		// All others
		return select( selector.replace( rtrimCSS, "$1" ), context, results, seed );
	}
	
	/**
	 * Create key-value caches of limited size
	 * @returns {function(string, object)} Returns the Object data after storing it on itself with
	 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
	 *	deleting the oldest entry
	 */
	function createCache() {
		var keys = [];
	
		function cache( key, value ) {
	
			// Use (key + " ") to avoid collision with native prototype properties
			// (see https://github.com/jquery/sizzle/issues/157)
			if ( keys.push( key + " " ) > Expr.cacheLength ) {
	
				// Only keep the most recent entries
				delete cache[ keys.shift() ];
			}
			return ( cache[ key + " " ] = value );
		}
		return cache;
	}
	
	/**
	 * Mark a function for special use by jQuery selector module
	 * @param {Function} fn The function to mark
	 */
	function markFunction( fn ) {
		fn[ expando ] = true;
		return fn;
	}
	
	/**
	 * Support testing using an element
	 * @param {Function} fn Passed the created element and returns a boolean result
	 */
	function assert( fn ) {
		var el = document.createElement( "fieldset" );
	
		try {
			return !!fn( el );
		} catch ( e ) {
			return false;
		} finally {
	
			// Remove from its parent by default
			if ( el.parentNode ) {
				el.parentNode.removeChild( el );
			}
	
			// release memory in IE
			el = null;
		}
	}
	
	/**
	 * Returns a function to use in pseudos for input types
	 * @param {String} type
	 */
	function createInputPseudo( type ) {
		return function( elem ) {
			return nodeName( elem, "input" ) && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for buttons
	 * @param {String} type
	 */
	function createButtonPseudo( type ) {
		return function( elem ) {
			return ( nodeName( elem, "input" ) || nodeName( elem, "button" ) ) &&
				elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for :enabled/:disabled
	 * @param {Boolean} disabled true for :disabled; false for :enabled
	 */
	function createDisabledPseudo( disabled ) {
	
		// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
		return function( elem ) {
	
			// Only certain elements can match :enabled or :disabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
			if ( "form" in elem ) {
	
				// Check for inherited disabledness on relevant non-disabled elements:
				// * listed form-associated elements in a disabled fieldset
				//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
				// * option elements in a disabled optgroup
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
				// All such elements have a "form" property.
				if ( elem.parentNode && elem.disabled === false ) {
	
					// Option elements defer to a parent optgroup if present
					if ( "label" in elem ) {
						if ( "label" in elem.parentNode ) {
							return elem.parentNode.disabled === disabled;
						} else {
							return elem.disabled === disabled;
						}
					}
	
					// Support: IE 6 - 11+
					// Use the isDisabled shortcut property to check for disabled fieldset ancestors
					return elem.isDisabled === disabled ||
	
						// Where there is no isDisabled, check manually
						elem.isDisabled !== !disabled &&
							inDisabledFieldset( elem ) === disabled;
				}
	
				return elem.disabled === disabled;
	
			// Try to winnow out elements that can't be disabled before trusting the disabled property.
			// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
			// even exist on them, let alone have a boolean value.
			} else if ( "label" in elem ) {
				return elem.disabled === disabled;
			}
	
			// Remaining elements are neither :enabled nor :disabled
			return false;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for positionals
	 * @param {Function} fn
	 */
	function createPositionalPseudo( fn ) {
		return markFunction( function( argument ) {
			argument = +argument;
			return markFunction( function( seed, matches ) {
				var j,
					matchIndexes = fn( [], seed.length, argument ),
					i = matchIndexes.length;
	
				// Match elements found at the specified indexes
				while ( i-- ) {
					if ( seed[ ( j = matchIndexes[ i ] ) ] ) {
						seed[ j ] = !( matches[ j ] = seed[ j ] );
					}
				}
			} );
		} );
	}
	
	/**
	 * Checks a node for validity as a jQuery selector context
	 * @param {Element|Object=} context
	 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
	 */
	function testContext( context ) {
		return context && typeof context.getElementsByTagName !== "undefined" && context;
	}
	
	/**
	 * Sets document-related variables once based on the current document
	 * @param {Element|Object} [node] An element or document object to use to set the document
	 * @returns {Object} Returns the current document
	 */
	function setDocument( node ) {
		var subWindow,
			doc = node ? node.ownerDocument || node : preferredDoc;
	
		// Return early if doc is invalid or already selected
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		if ( doc == document || doc.nodeType !== 9 || !doc.documentElement ) {
			return document;
		}
	
		// Update global variables
		document = doc;
		documentElement = document.documentElement;
		documentIsHTML = !jQuery.isXMLDoc( document );
	
		// Support: iOS 7 only, IE 9 - 11+
		// Older browsers didn't support unprefixed `matches`.
		matches = documentElement.matches ||
			documentElement.webkitMatchesSelector ||
			documentElement.msMatchesSelector;
	
		// Support: IE 9 - 11+, Edge 12 - 18+
		// Accessing iframe documents after unload throws "permission denied" errors
		// (see trac-13936).
		// Limit the fix to IE & Edge Legacy; despite Edge 15+ implementing `matches`,
		// all IE 9+ and Edge Legacy versions implement `msMatchesSelector` as well.
		if ( documentElement.msMatchesSelector &&
	
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			preferredDoc != document &&
			( subWindow = document.defaultView ) && subWindow.top !== subWindow ) {
	
			// Support: IE 9 - 11+, Edge 12 - 18+
			subWindow.addEventListener( "unload", unloadHandler );
		}
	
		// Support: IE <10
		// Check if getElementById returns elements by name
		// The broken getElementById methods don't pick up programmatically-set names,
		// so use a roundabout getElementsByName test
		support.getById = assert( function( el ) {
			documentElement.appendChild( el ).id = jQuery.expando;
			return !document.getElementsByName ||
				!document.getElementsByName( jQuery.expando ).length;
		} );
	
		// Support: IE 9 only
		// Check to see if it's possible to do matchesSelector
		// on a disconnected node.
		support.disconnectedMatch = assert( function( el ) {
			return matches.call( el, "*" );
		} );
	
		// Support: IE 9 - 11+, Edge 12 - 18+
		// IE/Edge don't support the :scope pseudo-class.
		support.scope = assert( function() {
			return document.querySelectorAll( ":scope" );
		} );
	
		// Support: Chrome 105 - 111 only, Safari 15.4 - 16.3 only
		// Make sure the `:has()` argument is parsed unforgivingly.
		// We include `*` in the test to detect buggy implementations that are
		// _selectively_ forgiving (specifically when the list includes at least
		// one valid selector).
		// Note that we treat complete lack of support for `:has()` as if it were
		// spec-compliant support, which is fine because use of `:has()` in such
		// environments will fail in the qSA path and fall back to jQuery traversal
		// anyway.
		support.cssHas = assert( function() {
			try {
				document.querySelector( ":has(*,:jqfake)" );
				return false;
			} catch ( e ) {
				return true;
			}
		} );
	
		// ID filter and find
		if ( support.getById ) {
			Expr.filter.ID = function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					return elem.getAttribute( "id" ) === attrId;
				};
			};
			Expr.find.ID = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var elem = context.getElementById( id );
					return elem ? [ elem ] : [];
				}
			};
		} else {
			Expr.filter.ID =  function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					var node = typeof elem.getAttributeNode !== "undefined" &&
						elem.getAttributeNode( "id" );
					return node && node.value === attrId;
				};
			};
	
			// Support: IE 6 - 7 only
			// getElementById is not reliable as a find shortcut
			Expr.find.ID = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var node, i, elems,
						elem = context.getElementById( id );
	
					if ( elem ) {
	
						// Verify the id attribute
						node = elem.getAttributeNode( "id" );
						if ( node && node.value === id ) {
							return [ elem ];
						}
	
						// Fall back on getElementsByName
						elems = context.getElementsByName( id );
						i = 0;
						while ( ( elem = elems[ i++ ] ) ) {
							node = elem.getAttributeNode( "id" );
							if ( node && node.value === id ) {
								return [ elem ];
							}
						}
					}
	
					return [];
				}
			};
		}
	
		// Tag
		Expr.find.TAG = function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );
	
			// DocumentFragment nodes don't have gEBTN
			} else {
				return context.querySelectorAll( tag );
			}
		};
	
		// Class
		Expr.find.CLASS = function( className, context ) {
			if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
				return context.getElementsByClassName( className );
			}
		};
	
		/* QSA/matchesSelector
		---------------------------------------------------------------------- */
	
		// QSA and matchesSelector support
	
		rbuggyQSA = [];
	
		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert( function( el ) {
	
			var input;
	
			documentElement.appendChild( el ).innerHTML =
				"<a id='" + expando + "' href='' disabled='disabled'></a>" +
				"<select id='" + expando + "-\r\\' disabled='disabled'>" +
				"<option selected=''></option></select>";
	
			// Support: iOS <=7 - 8 only
			// Boolean attributes and "value" are not treated correctly in some XML documents
			if ( !el.querySelectorAll( "[selected]" ).length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}
	
			// Support: iOS <=7 - 8 only
			if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push( "~=" );
			}
	
			// Support: iOS 8 only
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibling-combinator selector` fails
			if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push( ".#.+[+~]" );
			}
	
			// Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
			// In some of the document kinds, these selectors wouldn't work natively.
			// This is probably OK but for backwards compatibility we want to maintain
			// handling them through jQuery traversal in jQuery 3.x.
			if ( !el.querySelectorAll( ":checked" ).length ) {
				rbuggyQSA.push( ":checked" );
			}
	
			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			input = document.createElement( "input" );
			input.setAttribute( "type", "hidden" );
			el.appendChild( input ).setAttribute( "name", "D" );
	
			// Support: IE 9 - 11+
			// IE's :disabled selector does not pick up the children of disabled fieldsets
			// Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
			// In some of the document kinds, these selectors wouldn't work natively.
			// This is probably OK but for backwards compatibility we want to maintain
			// handling them through jQuery traversal in jQuery 3.x.
			documentElement.appendChild( el ).disabled = true;
			if ( el.querySelectorAll( ":disabled" ).length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}
	
			// Support: IE 11+, Edge 15 - 18+
			// IE 11/Edge don't find elements on a `[name='']` query in some cases.
			// Adding a temporary attribute to the document before the selection works
			// around the issue.
			// Interestingly, IE 10 & older don't seem to have the issue.
			input = document.createElement( "input" );
			input.setAttribute( "name", "" );
			el.appendChild( input );
			if ( !el.querySelectorAll( "[name='']" ).length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*name" + whitespace + "*=" +
					whitespace + "*(?:''|\"\")" );
			}
		} );
	
		if ( !support.cssHas ) {
	
			// Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
			// Our regular `try-catch` mechanism fails to detect natively-unsupported
			// pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
			// in browsers that parse the `:has()` argument as a forgiving selector list.
			// https://drafts.csswg.org/selectors/#relational now requires the argument
			// to be parsed unforgivingly, but browsers have not yet fully adjusted.
			rbuggyQSA.push( ":has" );
		}
	
		rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join( "|" ) );
	
		/* Sorting
		---------------------------------------------------------------------- */
	
		// Document order sorting
		sortOrder = function( a, b ) {
	
			// Flag for duplicate removal
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			// Sort on method existence if only one input has compareDocumentPosition
			var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
			if ( compare ) {
				return compare;
			}
	
			// Calculate position if both inputs belong to the same document
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			compare = ( a.ownerDocument || a ) == ( b.ownerDocument || b ) ?
				a.compareDocumentPosition( b ) :
	
				// Otherwise we know they are disconnected
				1;
	
			// Disconnected nodes
			if ( compare & 1 ||
				( !support.sortDetached && b.compareDocumentPosition( a ) === compare ) ) {
	
				// Choose the first element that is related to our preferred document
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				if ( a === document || a.ownerDocument == preferredDoc &&
					find.contains( preferredDoc, a ) ) {
					return -1;
				}
	
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				if ( b === document || b.ownerDocument == preferredDoc &&
					find.contains( preferredDoc, b ) ) {
					return 1;
				}
	
				// Maintain original order
				return sortInput ?
					( indexOf.call( sortInput, a ) - indexOf.call( sortInput, b ) ) :
					0;
			}
	
			return compare & 4 ? -1 : 1;
		};
	
		return document;
	}
	
	find.matches = function( expr, elements ) {
		return find( expr, null, null, elements );
	};
	
	find.matchesSelector = function( elem, expr ) {
		setDocument( elem );
	
		if ( documentIsHTML &&
			!nonnativeSelectorCache[ expr + " " ] &&
			( !rbuggyQSA || !rbuggyQSA.test( expr ) ) ) {
	
			try {
				var ret = matches.call( elem, expr );
	
				// IE 9's matchesSelector returns false on disconnected nodes
				if ( ret || support.disconnectedMatch ||
	
						// As well, disconnected nodes are said to be in a document
						// fragment in IE 9
						elem.document && elem.document.nodeType !== 11 ) {
					return ret;
				}
			} catch ( e ) {
				nonnativeSelectorCache( expr, true );
			}
		}
	
		return find( expr, document, null, [ elem ] ).length > 0;
	};
	
	find.contains = function( context, elem ) {
	
		// Set document vars if needed
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		if ( ( context.ownerDocument || context ) != document ) {
			setDocument( context );
		}
		return jQuery.contains( context, elem );
	};
	
	
	find.attr = function( elem, name ) {
	
		// Set document vars if needed
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		if ( ( elem.ownerDocument || elem ) != document ) {
			setDocument( elem );
		}
	
		var fn = Expr.attrHandle[ name.toLowerCase() ],
	
			// Don't get fooled by Object.prototype properties (see trac-13807)
			val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
				fn( elem, name, !documentIsHTML ) :
				undefined;
	
		if ( val !== undefined ) {
			return val;
		}
	
		return elem.getAttribute( name );
	};
	
	find.error = function( msg ) {
		throw new Error( "Syntax error, unrecognized expression: " + msg );
	};
	
	/**
	 * Document sorting and removing duplicates
	 * @param {ArrayLike} results
	 */
	jQuery.uniqueSort = function( results ) {
		var elem,
			duplicates = [],
			j = 0,
			i = 0;
	
		// Unless we *know* we can detect duplicates, assume their presence
		//
		// Support: Android <=4.0+
		// Testing for detecting duplicates is unpredictable so instead assume we can't
		// depend on duplicate detection in all browsers without a stable sort.
		hasDuplicate = !support.sortStable;
		sortInput = !support.sortStable && slice.call( results, 0 );
		sort.call( results, sortOrder );
	
		if ( hasDuplicate ) {
			while ( ( elem = results[ i++ ] ) ) {
				if ( elem === results[ i ] ) {
					j = duplicates.push( i );
				}
			}
			while ( j-- ) {
				splice.call( results, duplicates[ j ], 1 );
			}
		}
	
		// Clear input after sorting to release objects
		// See https://github.com/jquery/sizzle/pull/225
		sortInput = null;
	
		return results;
	};
	
	jQuery.fn.uniqueSort = function() {
		return this.pushStack( jQuery.uniqueSort( slice.apply( this ) ) );
	};
	
	Expr = jQuery.expr = {
	
		// Can be adjusted by the user
		cacheLength: 50,
	
		createPseudo: markFunction,
	
		match: matchExpr,
	
		attrHandle: {},
	
		find: {},
	
		relative: {
			">": { dir: "parentNode", first: true },
			" ": { dir: "parentNode" },
			"+": { dir: "previousSibling", first: true },
			"~": { dir: "previousSibling" }
		},
	
		preFilter: {
			ATTR: function( match ) {
				match[ 1 ] = match[ 1 ].replace( runescape, funescape );
	
				// Move the given value to match[3] whether quoted or unquoted
				match[ 3 ] = ( match[ 3 ] || match[ 4 ] || match[ 5 ] || "" )
					.replace( runescape, funescape );
	
				if ( match[ 2 ] === "~=" ) {
					match[ 3 ] = " " + match[ 3 ] + " ";
				}
	
				return match.slice( 0, 4 );
			},
	
			CHILD: function( match ) {
	
				/* matches from matchExpr["CHILD"]
					1 type (only|nth|...)
					2 what (child|of-type)
					3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
					4 xn-component of xn+y argument ([+-]?\d*n|)
					5 sign of xn-component
					6 x of xn-component
					7 sign of y-component
					8 y of y-component
				*/
				match[ 1 ] = match[ 1 ].toLowerCase();
	
				if ( match[ 1 ].slice( 0, 3 ) === "nth" ) {
	
					// nth-* requires argument
					if ( !match[ 3 ] ) {
						find.error( match[ 0 ] );
					}
	
					// numeric x and y parameters for Expr.filter.CHILD
					// remember that false/true cast respectively to 0/1
					match[ 4 ] = +( match[ 4 ] ?
						match[ 5 ] + ( match[ 6 ] || 1 ) :
						2 * ( match[ 3 ] === "even" || match[ 3 ] === "odd" )
					);
					match[ 5 ] = +( ( match[ 7 ] + match[ 8 ] ) || match[ 3 ] === "odd" );
	
				// other types prohibit arguments
				} else if ( match[ 3 ] ) {
					find.error( match[ 0 ] );
				}
	
				return match;
			},
	
			PSEUDO: function( match ) {
				var excess,
					unquoted = !match[ 6 ] && match[ 2 ];
	
				if ( matchExpr.CHILD.test( match[ 0 ] ) ) {
					return null;
				}
	
				// Accept quoted arguments as-is
				if ( match[ 3 ] ) {
					match[ 2 ] = match[ 4 ] || match[ 5 ] || "";
	
				// Strip excess characters from unquoted arguments
				} else if ( unquoted && rpseudo.test( unquoted ) &&
	
					// Get excess from tokenize (recursively)
					( excess = tokenize( unquoted, true ) ) &&
	
					// advance to the next closing parenthesis
					( excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length ) ) {
	
					// excess is a negative index
					match[ 0 ] = match[ 0 ].slice( 0, excess );
					match[ 2 ] = unquoted.slice( 0, excess );
				}
	
				// Return only captures needed by the pseudo filter method (type and argument)
				return match.slice( 0, 3 );
			}
		},
	
		filter: {
	
			TAG: function( nodeNameSelector ) {
				var expectedNodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
				return nodeNameSelector === "*" ?
					function() {
						return true;
					} :
					function( elem ) {
						return nodeName( elem, expectedNodeName );
					};
			},
	
			CLASS: function( className ) {
				var pattern = classCache[ className + " " ];
	
				return pattern ||
					( pattern = new RegExp( "(^|" + whitespace + ")" + className +
						"(" + whitespace + "|$)" ) ) &&
					classCache( className, function( elem ) {
						return pattern.test(
							typeof elem.className === "string" && elem.className ||
								typeof elem.getAttribute !== "undefined" &&
									elem.getAttribute( "class" ) ||
								""
						);
					} );
			},
	
			ATTR: function( name, operator, check ) {
				return function( elem ) {
					var result = find.attr( elem, name );
	
					if ( result == null ) {
						return operator === "!=";
					}
					if ( !operator ) {
						return true;
					}
	
					result += "";
	
					if ( operator === "=" ) {
						return result === check;
					}
					if ( operator === "!=" ) {
						return result !== check;
					}
					if ( operator === "^=" ) {
						return check && result.indexOf( check ) === 0;
					}
					if ( operator === "*=" ) {
						return check && result.indexOf( check ) > -1;
					}
					if ( operator === "$=" ) {
						return check && result.slice( -check.length ) === check;
					}
					if ( operator === "~=" ) {
						return ( " " + result.replace( rwhitespace, " " ) + " " )
							.indexOf( check ) > -1;
					}
					if ( operator === "|=" ) {
						return result === check || result.slice( 0, check.length + 1 ) === check + "-";
					}
	
					return false;
				};
			},
	
			CHILD: function( type, what, _argument, first, last ) {
				var simple = type.slice( 0, 3 ) !== "nth",
					forward = type.slice( -4 ) !== "last",
					ofType = what === "of-type";
	
				return first === 1 && last === 0 ?
	
					// Shortcut for :nth-*(n)
					function( elem ) {
						return !!elem.parentNode;
					} :
	
					function( elem, _context, xml ) {
						var cache, outerCache, node, nodeIndex, start,
							dir = simple !== forward ? "nextSibling" : "previousSibling",
							parent = elem.parentNode,
							name = ofType && elem.nodeName.toLowerCase(),
							useCache = !xml && !ofType,
							diff = false;
	
						if ( parent ) {
	
							// :(first|last|only)-(child|of-type)
							if ( simple ) {
								while ( dir ) {
									node = elem;
									while ( ( node = node[ dir ] ) ) {
										if ( ofType ?
											nodeName( node, name ) :
											node.nodeType === 1 ) {
	
											return false;
										}
									}
	
									// Reverse direction for :only-* (if we haven't yet done so)
									start = dir = type === "only" && !start && "nextSibling";
								}
								return true;
							}
	
							start = [ forward ? parent.firstChild : parent.lastChild ];
	
							// non-xml :nth-child(...) stores cache data on `parent`
							if ( forward && useCache ) {
	
								// Seek `elem` from a previously-cached index
								outerCache = parent[ expando ] || ( parent[ expando ] = {} );
								cache = outerCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex && cache[ 2 ];
								node = nodeIndex && parent.childNodes[ nodeIndex ];
	
								while ( ( node = ++nodeIndex && node && node[ dir ] ||
	
									// Fallback to seeking `elem` from the start
									( diff = nodeIndex = 0 ) || start.pop() ) ) {
	
									// When found, cache indexes on `parent` and break
									if ( node.nodeType === 1 && ++diff && node === elem ) {
										outerCache[ type ] = [ dirruns, nodeIndex, diff ];
										break;
									}
								}
	
							} else {
	
								// Use previously-cached element index if available
								if ( useCache ) {
									outerCache = elem[ expando ] || ( elem[ expando ] = {} );
									cache = outerCache[ type ] || [];
									nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
									diff = nodeIndex;
								}
	
								// xml :nth-child(...)
								// or :nth-last-child(...) or :nth(-last)?-of-type(...)
								if ( diff === false ) {
	
									// Use the same loop as above to seek `elem` from the start
									while ( ( node = ++nodeIndex && node && node[ dir ] ||
										( diff = nodeIndex = 0 ) || start.pop() ) ) {
	
										if ( ( ofType ?
											nodeName( node, name ) :
											node.nodeType === 1 ) &&
											++diff ) {
	
											// Cache the index of each encountered element
											if ( useCache ) {
												outerCache = node[ expando ] ||
													( node[ expando ] = {} );
												outerCache[ type ] = [ dirruns, diff ];
											}
	
											if ( node === elem ) {
												break;
											}
										}
									}
								}
							}
	
							// Incorporate the offset, then check against cycle size
							diff -= last;
							return diff === first || ( diff % first === 0 && diff / first >= 0 );
						}
					};
			},
	
			PSEUDO: function( pseudo, argument ) {
	
				// pseudo-class names are case-insensitive
				// https://www.w3.org/TR/selectors/#pseudo-classes
				// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
				// Remember that setFilters inherits from pseudos
				var args,
					fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
						find.error( "unsupported pseudo: " + pseudo );
	
				// The user may use createPseudo to indicate that
				// arguments are needed to create the filter function
				// just as jQuery does
				if ( fn[ expando ] ) {
					return fn( argument );
				}
	
				// But maintain support for old signatures
				if ( fn.length > 1 ) {
					args = [ pseudo, pseudo, "", argument ];
					return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
						markFunction( function( seed, matches ) {
							var idx,
								matched = fn( seed, argument ),
								i = matched.length;
							while ( i-- ) {
								idx = indexOf.call( seed, matched[ i ] );
								seed[ idx ] = !( matches[ idx ] = matched[ i ] );
							}
						} ) :
						function( elem ) {
							return fn( elem, 0, args );
						};
				}
	
				return fn;
			}
		},
	
		pseudos: {
	
			// Potentially complex pseudos
			not: markFunction( function( selector ) {
	
				// Trim the selector passed to compile
				// to avoid treating leading and trailing
				// spaces as combinators
				var input = [],
					results = [],
					matcher = compile( selector.replace( rtrimCSS, "$1" ) );
	
				return matcher[ expando ] ?
					markFunction( function( seed, matches, _context, xml ) {
						var elem,
							unmatched = matcher( seed, null, xml, [] ),
							i = seed.length;
	
						// Match elements unmatched by `matcher`
						while ( i-- ) {
							if ( ( elem = unmatched[ i ] ) ) {
								seed[ i ] = !( matches[ i ] = elem );
							}
						}
					} ) :
					function( elem, _context, xml ) {
						input[ 0 ] = elem;
						matcher( input, null, xml, results );
	
						// Don't keep the element
						// (see https://github.com/jquery/sizzle/issues/299)
						input[ 0 ] = null;
						return !results.pop();
					};
			} ),
	
			has: markFunction( function( selector ) {
				return function( elem ) {
					return find( selector, elem ).length > 0;
				};
			} ),
	
			contains: markFunction( function( text ) {
				text = text.replace( runescape, funescape );
				return function( elem ) {
					return ( elem.textContent || jQuery.text( elem ) ).indexOf( text ) > -1;
				};
			} ),
	
			// "Whether an element is represented by a :lang() selector
			// is based solely on the element's language value
			// being equal to the identifier C,
			// or beginning with the identifier C immediately followed by "-".
			// The matching of C against the element's language value is performed case-insensitively.
			// The identifier C does not have to be a valid language name."
			// https://www.w3.org/TR/selectors/#lang-pseudo
			lang: markFunction( function( lang ) {
	
				// lang value must be a valid identifier
				if ( !ridentifier.test( lang || "" ) ) {
					find.error( "unsupported lang: " + lang );
				}
				lang = lang.replace( runescape, funescape ).toLowerCase();
				return function( elem ) {
					var elemLang;
					do {
						if ( ( elemLang = documentIsHTML ?
							elem.lang :
							elem.getAttribute( "xml:lang" ) || elem.getAttribute( "lang" ) ) ) {
	
							elemLang = elemLang.toLowerCase();
							return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
						}
					} while ( ( elem = elem.parentNode ) && elem.nodeType === 1 );
					return false;
				};
			} ),
	
			// Miscellaneous
			target: function( elem ) {
				var hash = window.location && window.location.hash;
				return hash && hash.slice( 1 ) === elem.id;
			},
	
			root: function( elem ) {
				return elem === documentElement;
			},
	
			focus: function( elem ) {
				return elem === safeActiveElement() &&
					document.hasFocus() &&
					!!( elem.type || elem.href || ~elem.tabIndex );
			},
	
			// Boolean properties
			enabled: createDisabledPseudo( false ),
			disabled: createDisabledPseudo( true ),
	
			checked: function( elem ) {
	
				// In CSS3, :checked should return both checked and selected elements
				// https://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				return ( nodeName( elem, "input" ) && !!elem.checked ) ||
					( nodeName( elem, "option" ) && !!elem.selected );
			},
	
			selected: function( elem ) {
	
				// Support: IE <=11+
				// Accessing the selectedIndex property
				// forces the browser to treat the default option as
				// selected when in an optgroup.
				if ( elem.parentNode ) {
					// eslint-disable-next-line no-unused-expressions
					elem.parentNode.selectedIndex;
				}
	
				return elem.selected === true;
			},
	
			// Contents
			empty: function( elem ) {
	
				// https://www.w3.org/TR/selectors/#empty-pseudo
				// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
				//   but not by others (comment: 8; processing instruction: 7; etc.)
				// nodeType < 6 works because attributes (2) do not appear as children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					if ( elem.nodeType < 6 ) {
						return false;
					}
				}
				return true;
			},
	
			parent: function( elem ) {
				return !Expr.pseudos.empty( elem );
			},
	
			// Element/input types
			header: function( elem ) {
				return rheader.test( elem.nodeName );
			},
	
			input: function( elem ) {
				return rinputs.test( elem.nodeName );
			},
	
			button: function( elem ) {
				return nodeName( elem, "input" ) && elem.type === "button" ||
					nodeName( elem, "button" );
			},
	
			text: function( elem ) {
				var attr;
				return nodeName( elem, "input" ) && elem.type === "text" &&
	
					// Support: IE <10 only
					// New HTML5 attribute values (e.g., "search") appear
					// with elem.type === "text"
					( ( attr = elem.getAttribute( "type" ) ) == null ||
						attr.toLowerCase() === "text" );
			},
	
			// Position-in-collection
			first: createPositionalPseudo( function() {
				return [ 0 ];
			} ),
	
			last: createPositionalPseudo( function( _matchIndexes, length ) {
				return [ length - 1 ];
			} ),
	
			eq: createPositionalPseudo( function( _matchIndexes, length, argument ) {
				return [ argument < 0 ? argument + length : argument ];
			} ),
	
			even: createPositionalPseudo( function( matchIndexes, length ) {
				var i = 0;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} ),
	
			odd: createPositionalPseudo( function( matchIndexes, length ) {
				var i = 1;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} ),
	
			lt: createPositionalPseudo( function( matchIndexes, length, argument ) {
				var i;
	
				if ( argument < 0 ) {
					i = argument + length;
				} else if ( argument > length ) {
					i = length;
				} else {
					i = argument;
				}
	
				for ( ; --i >= 0; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} ),
	
			gt: createPositionalPseudo( function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; ++i < length; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} )
		}
	};
	
	Expr.pseudos.nth = Expr.pseudos.eq;
	
	// Add button/input type pseudos
	for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
		Expr.pseudos[ i ] = createInputPseudo( i );
	}
	for ( i in { submit: true, reset: true } ) {
		Expr.pseudos[ i ] = createButtonPseudo( i );
	}
	
	// Easy API for creating new setFilters
	function setFilters() {}
	setFilters.prototype = Expr.filters = Expr.pseudos;
	Expr.setFilters = new setFilters();
	
	function tokenize( selector, parseOnly ) {
		var matched, match, tokens, type,
			soFar, groups, preFilters,
			cached = tokenCache[ selector + " " ];
	
		if ( cached ) {
			return parseOnly ? 0 : cached.slice( 0 );
		}
	
		soFar = selector;
		groups = [];
		preFilters = Expr.preFilter;
	
		while ( soFar ) {
	
			// Comma and first run
			if ( !matched || ( match = rcomma.exec( soFar ) ) ) {
				if ( match ) {
	
					// Don't consume trailing commas as valid
					soFar = soFar.slice( match[ 0 ].length ) || soFar;
				}
				groups.push( ( tokens = [] ) );
			}
	
			matched = false;
	
			// Combinators
			if ( ( match = rleadingCombinator.exec( soFar ) ) ) {
				matched = match.shift();
				tokens.push( {
					value: matched,
	
					// Cast descendant combinators to space
					type: match[ 0 ].replace( rtrimCSS, " " )
				} );
				soFar = soFar.slice( matched.length );
			}
	
			// Filters
			for ( type in Expr.filter ) {
				if ( ( match = matchExpr[ type ].exec( soFar ) ) && ( !preFilters[ type ] ||
					( match = preFilters[ type ]( match ) ) ) ) {
					matched = match.shift();
					tokens.push( {
						value: matched,
						type: type,
						matches: match
					} );
					soFar = soFar.slice( matched.length );
				}
			}
	
			if ( !matched ) {
				break;
			}
		}
	
		// Return the length of the invalid excess
		// if we're just parsing
		// Otherwise, throw an error or return tokens
		if ( parseOnly ) {
			return soFar.length;
		}
	
		return soFar ?
			find.error( selector ) :
	
			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
	}
	
	function toSelector( tokens ) {
		var i = 0,
			len = tokens.length,
			selector = "";
		for ( ; i < len; i++ ) {
			selector += tokens[ i ].value;
		}
		return selector;
	}
	
	function addCombinator( matcher, combinator, base ) {
		var dir = combinator.dir,
			skip = combinator.next,
			key = skip || dir,
			checkNonElements = base && key === "parentNode",
			doneName = done++;
	
		return combinator.first ?
	
			// Check against closest ancestor/preceding element
			function( elem, context, xml ) {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						return matcher( elem, context, xml );
					}
				}
				return false;
			} :
	
			// Check against all ancestor/preceding elements
			function( elem, context, xml ) {
				var oldCache, outerCache,
					newCache = [ dirruns, doneName ];
	
				// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
				if ( xml ) {
					while ( ( elem = elem[ dir ] ) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							if ( matcher( elem, context, xml ) ) {
								return true;
							}
						}
					}
				} else {
					while ( ( elem = elem[ dir ] ) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							outerCache = elem[ expando ] || ( elem[ expando ] = {} );
	
							if ( skip && nodeName( elem, skip ) ) {
								elem = elem[ dir ] || elem;
							} else if ( ( oldCache = outerCache[ key ] ) &&
								oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {
	
								// Assign to newCache so results back-propagate to previous elements
								return ( newCache[ 2 ] = oldCache[ 2 ] );
							} else {
	
								// Reuse newcache so results back-propagate to previous elements
								outerCache[ key ] = newCache;
	
								// A match means we're done; a fail means we have to keep checking
								if ( ( newCache[ 2 ] = matcher( elem, context, xml ) ) ) {
									return true;
								}
							}
						}
					}
				}
				return false;
			};
	}
	
	function elementMatcher( matchers ) {
		return matchers.length > 1 ?
			function( elem, context, xml ) {
				var i = matchers.length;
				while ( i-- ) {
					if ( !matchers[ i ]( elem, context, xml ) ) {
						return false;
					}
				}
				return true;
			} :
			matchers[ 0 ];
	}
	
	function multipleContexts( selector, contexts, results ) {
		var i = 0,
			len = contexts.length;
		for ( ; i < len; i++ ) {
			find( selector, contexts[ i ], results );
		}
		return results;
	}
	
	function condense( unmatched, map, filter, context, xml ) {
		var elem,
			newUnmatched = [],
			i = 0,
			len = unmatched.length,
			mapped = map != null;
	
		for ( ; i < len; i++ ) {
			if ( ( elem = unmatched[ i ] ) ) {
				if ( !filter || filter( elem, context, xml ) ) {
					newUnmatched.push( elem );
					if ( mapped ) {
						map.push( i );
					}
				}
			}
		}
	
		return newUnmatched;
	}
	
	function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
		if ( postFilter && !postFilter[ expando ] ) {
			postFilter = setMatcher( postFilter );
		}
		if ( postFinder && !postFinder[ expando ] ) {
			postFinder = setMatcher( postFinder, postSelector );
		}
		return markFunction( function( seed, results, context, xml ) {
			var temp, i, elem, matcherOut,
				preMap = [],
				postMap = [],
				preexisting = results.length,
	
				// Get initial elements from seed or context
				elems = seed ||
					multipleContexts( selector || "*",
						context.nodeType ? [ context ] : context, [] ),
	
				// Prefilter to get matcher input, preserving a map for seed-results synchronization
				matcherIn = preFilter && ( seed || !selector ) ?
					condense( elems, preMap, preFilter, context, xml ) :
					elems;
	
			if ( matcher ) {
	
				// If we have a postFinder, or filtered seed, or non-seed postFilter
				// or preexisting results,
				matcherOut = postFinder || ( seed ? preFilter : preexisting || postFilter ) ?
	
					// ...intermediate processing is necessary
					[] :
	
					// ...otherwise use results directly
					results;
	
				// Find primary matches
				matcher( matcherIn, matcherOut, context, xml );
			} else {
				matcherOut = matcherIn;
			}
	
			// Apply postFilter
			if ( postFilter ) {
				temp = condense( matcherOut, postMap );
				postFilter( temp, [], context, xml );
	
				// Un-match failing elements by moving them back to matcherIn
				i = temp.length;
				while ( i-- ) {
					if ( ( elem = temp[ i ] ) ) {
						matcherOut[ postMap[ i ] ] = !( matcherIn[ postMap[ i ] ] = elem );
					}
				}
			}
	
			if ( seed ) {
				if ( postFinder || preFilter ) {
					if ( postFinder ) {
	
						// Get the final matcherOut by condensing this intermediate into postFinder contexts
						temp = [];
						i = matcherOut.length;
						while ( i-- ) {
							if ( ( elem = matcherOut[ i ] ) ) {
	
								// Restore matcherIn since elem is not yet a final match
								temp.push( ( matcherIn[ i ] = elem ) );
							}
						}
						postFinder( null, ( matcherOut = [] ), temp, xml );
					}
	
					// Move matched elements from seed to results to keep them synchronized
					i = matcherOut.length;
					while ( i-- ) {
						if ( ( elem = matcherOut[ i ] ) &&
							( temp = postFinder ? indexOf.call( seed, elem ) : preMap[ i ] ) > -1 ) {
	
							seed[ temp ] = !( results[ temp ] = elem );
						}
					}
				}
	
			// Add elements to results, through postFinder if defined
			} else {
				matcherOut = condense(
					matcherOut === results ?
						matcherOut.splice( preexisting, matcherOut.length ) :
						matcherOut
				);
				if ( postFinder ) {
					postFinder( null, results, matcherOut, xml );
				} else {
					push.apply( results, matcherOut );
				}
			}
		} );
	}
	
	function matcherFromTokens( tokens ) {
		var checkContext, matcher, j,
			len = tokens.length,
			leadingRelative = Expr.relative[ tokens[ 0 ].type ],
			implicitRelative = leadingRelative || Expr.relative[ " " ],
			i = leadingRelative ? 1 : 0,
	
			// The foundational matcher ensures that elements are reachable from top-level context(s)
			matchContext = addCombinator( function( elem ) {
				return elem === checkContext;
			}, implicitRelative, true ),
			matchAnyContext = addCombinator( function( elem ) {
				return indexOf.call( checkContext, elem ) > -1;
			}, implicitRelative, true ),
			matchers = [ function( elem, context, xml ) {
	
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				var ret = ( !leadingRelative && ( xml || context != outermostContext ) ) || (
					( checkContext = context ).nodeType ?
						matchContext( elem, context, xml ) :
						matchAnyContext( elem, context, xml ) );
	
				// Avoid hanging onto element
				// (see https://github.com/jquery/sizzle/issues/299)
				checkContext = null;
				return ret;
			} ];
	
		for ( ; i < len; i++ ) {
			if ( ( matcher = Expr.relative[ tokens[ i ].type ] ) ) {
				matchers = [ addCombinator( elementMatcher( matchers ), matcher ) ];
			} else {
				matcher = Expr.filter[ tokens[ i ].type ].apply( null, tokens[ i ].matches );
	
				// Return special upon seeing a positional matcher
				if ( matcher[ expando ] ) {
	
					// Find the next relative operator (if any) for proper handling
					j = ++i;
					for ( ; j < len; j++ ) {
						if ( Expr.relative[ tokens[ j ].type ] ) {
							break;
						}
					}
					return setMatcher(
						i > 1 && elementMatcher( matchers ),
						i > 1 && toSelector(
	
							// If the preceding token was a descendant combinator, insert an implicit any-element `*`
							tokens.slice( 0, i - 1 )
								.concat( { value: tokens[ i - 2 ].type === " " ? "*" : "" } )
						).replace( rtrimCSS, "$1" ),
						matcher,
						i < j && matcherFromTokens( tokens.slice( i, j ) ),
						j < len && matcherFromTokens( ( tokens = tokens.slice( j ) ) ),
						j < len && toSelector( tokens )
					);
				}
				matchers.push( matcher );
			}
		}
	
		return elementMatcher( matchers );
	}
	
	function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
		var bySet = setMatchers.length > 0,
			byElement = elementMatchers.length > 0,
			superMatcher = function( seed, context, xml, results, outermost ) {
				var elem, j, matcher,
					matchedCount = 0,
					i = "0",
					unmatched = seed && [],
					setMatched = [],
					contextBackup = outermostContext,
	
					// We must always have either seed elements or outermost context
					elems = seed || byElement && Expr.find.TAG( "*", outermost ),
	
					// Use integer dirruns iff this is the outermost matcher
					dirrunsUnique = ( dirruns += contextBackup == null ? 1 : Math.random() || 0.1 ),
					len = elems.length;
	
				if ( outermost ) {
	
					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
					// two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					outermostContext = context == document || context || outermost;
				}
	
				// Add elements passing elementMatchers directly to results
				// Support: iOS <=7 - 9 only
				// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching
				// elements by id. (see trac-14142)
				for ( ; i !== len && ( elem = elems[ i ] ) != null; i++ ) {
					if ( byElement && elem ) {
						j = 0;
	
						// Support: IE 11+, Edge 17 - 18+
						// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
						// two documents; shallow comparisons work.
						// eslint-disable-next-line eqeqeq
						if ( !context && elem.ownerDocument != document ) {
							setDocument( elem );
							xml = !documentIsHTML;
						}
						while ( ( matcher = elementMatchers[ j++ ] ) ) {
							if ( matcher( elem, context || document, xml ) ) {
								push.call( results, elem );
								break;
							}
						}
						if ( outermost ) {
							dirruns = dirrunsUnique;
						}
					}
	
					// Track unmatched elements for set filters
					if ( bySet ) {
	
						// They will have gone through all possible matchers
						if ( ( elem = !matcher && elem ) ) {
							matchedCount--;
						}
	
						// Lengthen the array for every element, matched or not
						if ( seed ) {
							unmatched.push( elem );
						}
					}
				}
	
				// `i` is now the count of elements visited above, and adding it to `matchedCount`
				// makes the latter nonnegative.
				matchedCount += i;
	
				// Apply set filters to unmatched elements
				// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
				// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
				// no element matchers and no seed.
				// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
				// case, which will result in a "00" `matchedCount` that differs from `i` but is also
				// numerically zero.
				if ( bySet && i !== matchedCount ) {
					j = 0;
					while ( ( matcher = setMatchers[ j++ ] ) ) {
						matcher( unmatched, setMatched, context, xml );
					}
	
					if ( seed ) {
	
						// Reintegrate element matches to eliminate the need for sorting
						if ( matchedCount > 0 ) {
							while ( i-- ) {
								if ( !( unmatched[ i ] || setMatched[ i ] ) ) {
									setMatched[ i ] = pop.call( results );
								}
							}
						}
	
						// Discard index placeholder values to get only actual matches
						setMatched = condense( setMatched );
					}
	
					// Add matches to results
					push.apply( results, setMatched );
	
					// Seedless set matches succeeding multiple successful matchers stipulate sorting
					if ( outermost && !seed && setMatched.length > 0 &&
						( matchedCount + setMatchers.length ) > 1 ) {
	
						jQuery.uniqueSort( results );
					}
				}
	
				// Override manipulation of globals by nested matchers
				if ( outermost ) {
					dirruns = dirrunsUnique;
					outermostContext = contextBackup;
				}
	
				return unmatched;
			};
	
		return bySet ?
			markFunction( superMatcher ) :
			superMatcher;
	}
	
	function compile( selector, match /* Internal Use Only */ ) {
		var i,
			setMatchers = [],
			elementMatchers = [],
			cached = compilerCache[ selector + " " ];
	
		if ( !cached ) {
	
			// Generate a function of recursive functions that can be used to check each element
			if ( !match ) {
				match = tokenize( selector );
			}
			i = match.length;
			while ( i-- ) {
				cached = matcherFromTokens( match[ i ] );
				if ( cached[ expando ] ) {
					setMatchers.push( cached );
				} else {
					elementMatchers.push( cached );
				}
			}
	
			// Cache the compiled function
			cached = compilerCache( selector,
				matcherFromGroupMatchers( elementMatchers, setMatchers ) );
	
			// Save selector and tokenization
			cached.selector = selector;
		}
		return cached;
	}
	
	/**
	 * A low-level selection function that works with jQuery's compiled
	 *  selector functions
	 * @param {String|Function} selector A selector or a pre-compiled
	 *  selector function built with jQuery selector compile
	 * @param {Element} context
	 * @param {Array} [results]
	 * @param {Array} [seed] A set of elements to match against
	 */
	function select( selector, context, results, seed ) {
		var i, tokens, token, type, find,
			compiled = typeof selector === "function" && selector,
			match = !seed && tokenize( ( selector = compiled.selector || selector ) );
	
		results = results || [];
	
		// Try to minimize operations if there is only one selector in the list and no seed
		// (the latter of which guarantees us context)
		if ( match.length === 1 ) {
	
			// Reduce context if the leading compound selector is an ID
			tokens = match[ 0 ] = match[ 0 ].slice( 0 );
			if ( tokens.length > 2 && ( token = tokens[ 0 ] ).type === "ID" &&
					context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[ 1 ].type ] ) {
	
				context = ( Expr.find.ID(
					token.matches[ 0 ].replace( runescape, funescape ),
					context
				) || [] )[ 0 ];
				if ( !context ) {
					return results;
	
				// Precompiled matchers will still verify ancestry, so step up a level
				} else if ( compiled ) {
					context = context.parentNode;
				}
	
				selector = selector.slice( tokens.shift().value.length );
			}
	
			// Fetch a seed set for right-to-left matching
			i = matchExpr.needsContext.test( selector ) ? 0 : tokens.length;
			while ( i-- ) {
				token = tokens[ i ];
	
				// Abort if we hit a combinator
				if ( Expr.relative[ ( type = token.type ) ] ) {
					break;
				}
				if ( ( find = Expr.find[ type ] ) ) {
	
					// Search, expanding context for leading sibling combinators
					if ( ( seed = find(
						token.matches[ 0 ].replace( runescape, funescape ),
						rsibling.test( tokens[ 0 ].type ) &&
							testContext( context.parentNode ) || context
					) ) ) {
	
						// If seed is empty or no tokens remain, we can return early
						tokens.splice( i, 1 );
						selector = seed.length && toSelector( tokens );
						if ( !selector ) {
							push.apply( results, seed );
							return results;
						}
	
						break;
					}
				}
			}
		}
	
		// Compile and execute a filtering function if one is not provided
		// Provide `match` to avoid retokenization if we modified the selector above
		( compiled || compile( selector, match ) )(
			seed,
			context,
			!documentIsHTML,
			results,
			!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
		);
		return results;
	}
	
	// One-time assignments
	
	// Support: Android <=4.0 - 4.1+
	// Sort stability
	support.sortStable = expando.split( "" ).sort( sortOrder ).join( "" ) === expando;
	
	// Initialize against the default document
	setDocument();
	
	// Support: Android <=4.0 - 4.1+
	// Detached nodes confoundingly follow *each other*
	support.sortDetached = assert( function( el ) {
	
		// Should return 1, but returns 4 (following)
		return el.compareDocumentPosition( document.createElement( "fieldset" ) ) & 1;
	} );
	
	jQuery.find = find;
	
	// Deprecated
	jQuery.expr[ ":" ] = jQuery.expr.pseudos;
	jQuery.unique = jQuery.uniqueSort;
	
	// These have always been private, but they used to be documented as part of
	// Sizzle so let's maintain them for now for backwards compatibility purposes.
	find.compile = compile;
	find.select = select;
	find.setDocument = setDocument;
	find.tokenize = tokenize;
	
	find.escape = jQuery.escapeSelector;
	find.getText = jQuery.text;
	find.isXML = jQuery.isXMLDoc;
	find.selectors = jQuery.expr;
	find.support = jQuery.support;
	find.uniqueSort = jQuery.uniqueSort;
	
		/* eslint-enable */
	
	} )();
	
	
	var dir = function( elem, dir, until ) {
		var matched = [],
			truncate = until !== undefined;
	
		while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
			if ( elem.nodeType === 1 ) {
				if ( truncate && jQuery( elem ).is( until ) ) {
					break;
				}
				matched.push( elem );
			}
		}
		return matched;
	};
	
	
	var siblings = function( n, elem ) {
		var matched = [];
	
		for ( ; n; n = n.nextSibling ) {
			if ( n.nodeType === 1 && n !== elem ) {
				matched.push( n );
			}
		}
	
		return matched;
	};
	
	
	var rneedsContext = jQuery.expr.match.needsContext;
	
	var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );
	
	
	
	// Implement the identical functionality for filter and not
	function winnow( elements, qualifier, not ) {
		if ( isFunction( qualifier ) ) {
			return jQuery.grep( elements, function( elem, i ) {
				return !!qualifier.call( elem, i, elem ) !== not;
			} );
		}
	
		// Single element
		if ( qualifier.nodeType ) {
			return jQuery.grep( elements, function( elem ) {
				return ( elem === qualifier ) !== not;
			} );
		}
	
		// Arraylike of elements (jQuery, arguments, Array)
		if ( typeof qualifier !== "string" ) {
			return jQuery.grep( elements, function( elem ) {
				return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
			} );
		}
	
		// Filtered directly for both simple and complex selectors
		return jQuery.filter( qualifier, elements, not );
	}
	
	jQuery.filter = function( expr, elems, not ) {
		var elem = elems[ 0 ];
	
		if ( not ) {
			expr = ":not(" + expr + ")";
		}
	
		if ( elems.length === 1 && elem.nodeType === 1 ) {
			return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
		}
	
		return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
			return elem.nodeType === 1;
		} ) );
	};
	
	jQuery.fn.extend( {
		find: function( selector ) {
			var i, ret,
				len = this.length,
				self = this;
	
			if ( typeof selector !== "string" ) {
				return this.pushStack( jQuery( selector ).filter( function() {
					for ( i = 0; i < len; i++ ) {
						if ( jQuery.contains( self[ i ], this ) ) {
							return true;
						}
					}
				} ) );
			}
	
			ret = this.pushStack( [] );
	
			for ( i = 0; i < len; i++ ) {
				jQuery.find( selector, self[ i ], ret );
			}
	
			return len > 1 ? jQuery.uniqueSort( ret ) : ret;
		},
		filter: function( selector ) {
			return this.pushStack( winnow( this, selector || [], false ) );
		},
		not: function( selector ) {
			return this.pushStack( winnow( this, selector || [], true ) );
		},
		is: function( selector ) {
			return !!winnow(
				this,
	
				// If this is a positional/relative selector, check membership in the returned set
				// so $("p:first").is("p:last") won't return true for a doc with two "p".
				typeof selector === "string" && rneedsContext.test( selector ) ?
					jQuery( selector ) :
					selector || [],
				false
			).length;
		}
	} );
	
	
	// Initialize a jQuery object
	
	
	// A central reference to the root jQuery(document)
	var rootjQuery,
	
		// A simple way to check for HTML strings
		// Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
		// Strict HTML recognition (trac-11290: must start with <)
		// Shortcut simple #id case for speed
		rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,
	
		init = jQuery.fn.init = function( selector, context, root ) {
			var match, elem;
	
			// HANDLE: $(""), $(null), $(undefined), $(false)
			if ( !selector ) {
				return this;
			}
	
			// Method init() accepts an alternate rootjQuery
			// so migrate can support jQuery.sub (gh-2101)
			root = root || rootjQuery;
	
			// Handle HTML strings
			if ( typeof selector === "string" ) {
				if ( selector[ 0 ] === "<" &&
					selector[ selector.length - 1 ] === ">" &&
					selector.length >= 3 ) {
	
					// Assume that strings that start and end with <> are HTML and skip the regex check
					match = [ null, selector, null ];
	
				} else {
					match = rquickExpr.exec( selector );
				}
	
				// Match html or make sure no context is specified for #id
				if ( match && ( match[ 1 ] || !context ) ) {
	
					// HANDLE: $(html) -> $(array)
					if ( match[ 1 ] ) {
						context = context instanceof jQuery ? context[ 0 ] : context;
	
						// Option to run scripts is true for back-compat
						// Intentionally let the error be thrown if parseHTML is not present
						jQuery.merge( this, jQuery.parseHTML(
							match[ 1 ],
							context && context.nodeType ? context.ownerDocument || context : document,
							true
						) );
	
						// HANDLE: $(html, props)
						if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
							for ( match in context ) {
	
								// Properties of context are called as methods if possible
								if ( isFunction( this[ match ] ) ) {
									this[ match ]( context[ match ] );
	
								// ...and otherwise set as attributes
								} else {
									this.attr( match, context[ match ] );
								}
							}
						}
	
						return this;
	
					// HANDLE: $(#id)
					} else {
						elem = document.getElementById( match[ 2 ] );
	
						if ( elem ) {
	
							// Inject the element directly into the jQuery object
							this[ 0 ] = elem;
							this.length = 1;
						}
						return this;
					}
	
				// HANDLE: $(expr, $(...))
				} else if ( !context || context.jquery ) {
					return ( context || root ).find( selector );
	
				// HANDLE: $(expr, context)
				// (which is just equivalent to: $(context).find(expr)
				} else {
					return this.constructor( context ).find( selector );
				}
	
			// HANDLE: $(DOMElement)
			} else if ( selector.nodeType ) {
				this[ 0 ] = selector;
				this.length = 1;
				return this;
	
			// HANDLE: $(function)
			// Shortcut for document ready
			} else if ( isFunction( selector ) ) {
				return root.ready !== undefined ?
					root.ready( selector ) :
	
					// Execute immediately if ready is not present
					selector( jQuery );
			}
	
			return jQuery.makeArray( selector, this );
		};
	
	// Give the init function the jQuery prototype for later instantiation
	init.prototype = jQuery.fn;
	
	// Initialize central reference
	rootjQuery = jQuery( document );
	
	
	var rparentsprev = /^(?:parents|prev(?:Until|All))/,
	
		// Methods guaranteed to produce a unique set when starting from a unique set
		guaranteedUnique = {
			children: true,
			contents: true,
			next: true,
			prev: true
		};
	
	jQuery.fn.extend( {
		has: function( target ) {
			var targets = jQuery( target, this ),
				l = targets.length;
	
			return this.filter( function() {
				var i = 0;
				for ( ; i < l; i++ ) {
					if ( jQuery.contains( this, targets[ i ] ) ) {
						return true;
					}
				}
			} );
		},
	
		closest: function( selectors, context ) {
			var cur,
				i = 0,
				l = this.length,
				matched = [],
				targets = typeof selectors !== "string" && jQuery( selectors );
	
			// Positional selectors never match, since there's no _selection_ context
			if ( !rneedsContext.test( selectors ) ) {
				for ( ; i < l; i++ ) {
					for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {
	
						// Always skip document fragments
						if ( cur.nodeType < 11 && ( targets ?
							targets.index( cur ) > -1 :
	
							// Don't pass non-elements to jQuery#find
							cur.nodeType === 1 &&
								jQuery.find.matchesSelector( cur, selectors ) ) ) {
	
							matched.push( cur );
							break;
						}
					}
				}
			}
	
			return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
		},
	
		// Determine the position of an element within the set
		index: function( elem ) {
	
			// No argument, return index in parent
			if ( !elem ) {
				return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
			}
	
			// Index in selector
			if ( typeof elem === "string" ) {
				return indexOf.call( jQuery( elem ), this[ 0 ] );
			}
	
			// Locate the position of the desired element
			return indexOf.call( this,
	
				// If it receives a jQuery object, the first element is used
				elem.jquery ? elem[ 0 ] : elem
			);
		},
	
		add: function( selector, context ) {
			return this.pushStack(
				jQuery.uniqueSort(
					jQuery.merge( this.get(), jQuery( selector, context ) )
				)
			);
		},
	
		addBack: function( selector ) {
			return this.add( selector == null ?
				this.prevObject : this.prevObject.filter( selector )
			);
		}
	} );
	
	function sibling( cur, dir ) {
		while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
		return cur;
	}
	
	jQuery.each( {
		parent: function( elem ) {
			var parent = elem.parentNode;
			return parent && parent.nodeType !== 11 ? parent : null;
		},
		parents: function( elem ) {
			return dir( elem, "parentNode" );
		},
		parentsUntil: function( elem, _i, until ) {
			return dir( elem, "parentNode", until );
		},
		next: function( elem ) {
			return sibling( elem, "nextSibling" );
		},
		prev: function( elem ) {
			return sibling( elem, "previousSibling" );
		},
		nextAll: function( elem ) {
			return dir( elem, "nextSibling" );
		},
		prevAll: function( elem ) {
			return dir( elem, "previousSibling" );
		},
		nextUntil: function( elem, _i, until ) {
			return dir( elem, "nextSibling", until );
		},
		prevUntil: function( elem, _i, until ) {
			return dir( elem, "previousSibling", until );
		},
		siblings: function( elem ) {
			return siblings( ( elem.parentNode || {} ).firstChild, elem );
		},
		children: function( elem ) {
			return siblings( elem.firstChild );
		},
		contents: function( elem ) {
			if ( elem.contentDocument != null &&
	
				// Support: IE 11+
				// <object> elements with no `data` attribute has an object
				// `contentDocument` with a `null` prototype.
				getProto( elem.contentDocument ) ) {
	
				return elem.contentDocument;
			}
	
			// Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
			// Treat the template element as a regular one in browsers that
			// don't support it.
			if ( nodeName( elem, "template" ) ) {
				elem = elem.content || elem;
			}
	
			return jQuery.merge( [], elem.childNodes );
		}
	}, function( name, fn ) {
		jQuery.fn[ name ] = function( until, selector ) {
			var matched = jQuery.map( this, fn, until );
	
			if ( name.slice( -5 ) !== "Until" ) {
				selector = until;
			}
	
			if ( selector && typeof selector === "string" ) {
				matched = jQuery.filter( selector, matched );
			}
	
			if ( this.length > 1 ) {
	
				// Remove duplicates
				if ( !guaranteedUnique[ name ] ) {
					jQuery.uniqueSort( matched );
				}
	
				// Reverse order for parents* and prev-derivatives
				if ( rparentsprev.test( name ) ) {
					matched.reverse();
				}
			}
	
			return this.pushStack( matched );
		};
	} );
	var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );
	
	
	
	// Convert String-formatted options into Object-formatted ones
	function createOptions( options ) {
		var object = {};
		jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
			object[ flag ] = true;
		} );
		return object;
	}
	
	/*
	 * Create a callback list using the following parameters:
	 *
	 *	options: an optional list of space-separated options that will change how
	 *			the callback list behaves or a more traditional option object
	 *
	 * By default a callback list will act like an event callback list and can be
	 * "fired" multiple times.
	 *
	 * Possible options:
	 *
	 *	once:			will ensure the callback list can only be fired once (like a Deferred)
	 *
	 *	memory:			will keep track of previous values and will call any callback added
	 *					after the list has been fired right away with the latest "memorized"
	 *					values (like a Deferred)
	 *
	 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
	 *
	 *	stopOnFalse:	interrupt callings when a callback returns false
	 *
	 */
	jQuery.Callbacks = function( options ) {
	
		// Convert options from String-formatted to Object-formatted if needed
		// (we check in cache first)
		options = typeof options === "string" ?
			createOptions( options ) :
			jQuery.extend( {}, options );
	
		var // Flag to know if list is currently firing
			firing,
	
			// Last fire value for non-forgettable lists
			memory,
	
			// Flag to know if list was already fired
			fired,
	
			// Flag to prevent firing
			locked,
	
			// Actual callback list
			list = [],
	
			// Queue of execution data for repeatable lists
			queue = [],
	
			// Index of currently firing callback (modified by add/remove as needed)
			firingIndex = -1,
	
			// Fire callbacks
			fire = function() {
	
				// Enforce single-firing
				locked = locked || options.once;
	
				// Execute callbacks for all pending executions,
				// respecting firingIndex overrides and runtime changes
				fired = firing = true;
				for ( ; queue.length; firingIndex = -1 ) {
					memory = queue.shift();
					while ( ++firingIndex < list.length ) {
	
						// Run callback and check for early termination
						if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
							options.stopOnFalse ) {
	
							// Jump to end and forget the data so .add doesn't re-fire
							firingIndex = list.length;
							memory = false;
						}
					}
				}
	
				// Forget the data if we're done with it
				if ( !options.memory ) {
					memory = false;
				}
	
				firing = false;
	
				// Clean up if we're done firing for good
				if ( locked ) {
	
					// Keep an empty list if we have data for future add calls
					if ( memory ) {
						list = [];
	
					// Otherwise, this object is spent
					} else {
						list = "";
					}
				}
			},
	
			// Actual Callbacks object
			self = {
	
				// Add a callback or a collection of callbacks to the list
				add: function() {
					if ( list ) {
	
						// If we have memory from a past run, we should fire after adding
						if ( memory && !firing ) {
							firingIndex = list.length - 1;
							queue.push( memory );
						}
	
						( function add( args ) {
							jQuery.each( args, function( _, arg ) {
								if ( isFunction( arg ) ) {
									if ( !options.unique || !self.has( arg ) ) {
										list.push( arg );
									}
								} else if ( arg && arg.length && toType( arg ) !== "string" ) {
	
									// Inspect recursively
									add( arg );
								}
							} );
						} )( arguments );
	
						if ( memory && !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Remove a callback from the list
				remove: function() {
					jQuery.each( arguments, function( _, arg ) {
						var index;
						while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
							list.splice( index, 1 );
	
							// Handle firing indexes
							if ( index <= firingIndex ) {
								firingIndex--;
							}
						}
					} );
					return this;
				},
	
				// Check if a given callback is in the list.
				// If no argument is given, return whether or not list has callbacks attached.
				has: function( fn ) {
					return fn ?
						jQuery.inArray( fn, list ) > -1 :
						list.length > 0;
				},
	
				// Remove all callbacks from the list
				empty: function() {
					if ( list ) {
						list = [];
					}
					return this;
				},
	
				// Disable .fire and .add
				// Abort any current/pending executions
				// Clear all callbacks and values
				disable: function() {
					locked = queue = [];
					list = memory = "";
					return this;
				},
				disabled: function() {
					return !list;
				},
	
				// Disable .fire
				// Also disable .add unless we have memory (since it would have no effect)
				// Abort any pending executions
				lock: function() {
					locked = queue = [];
					if ( !memory && !firing ) {
						list = memory = "";
					}
					return this;
				},
				locked: function() {
					return !!locked;
				},
	
				// Call all callbacks with the given context and arguments
				fireWith: function( context, args ) {
					if ( !locked ) {
						args = args || [];
						args = [ context, args.slice ? args.slice() : args ];
						queue.push( args );
						if ( !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Call all the callbacks with the given arguments
				fire: function() {
					self.fireWith( this, arguments );
					return this;
				},
	
				// To know if the callbacks have already been called at least once
				fired: function() {
					return !!fired;
				}
			};
	
		return self;
	};
	
	
	function Identity( v ) {
		return v;
	}
	function Thrower( ex ) {
		throw ex;
	}
	
	function adoptValue( value, resolve, reject, noValue ) {
		var method;
	
		try {
	
			// Check for promise aspect first to privilege synchronous behavior
			if ( value && isFunction( ( method = value.promise ) ) ) {
				method.call( value ).done( resolve ).fail( reject );
	
			// Other thenables
			} else if ( value && isFunction( ( method = value.then ) ) ) {
				method.call( value, resolve, reject );
	
			// Other non-thenables
			} else {
	
				// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
				// * false: [ value ].slice( 0 ) => resolve( value )
				// * true: [ value ].slice( 1 ) => resolve()
				resolve.apply( undefined, [ value ].slice( noValue ) );
			}
	
		// For Promises/A+, convert exceptions into rejections
		// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
		// Deferred#then to conditionally suppress rejection.
		} catch ( value ) {
	
			// Support: Android 4.0 only
			// Strict mode functions invoked without .call/.apply get global-object context
			reject.apply( undefined, [ value ] );
		}
	}
	
	jQuery.extend( {
	
		Deferred: function( func ) {
			var tuples = [
	
					// action, add listener, callbacks,
					// ... .then handlers, argument index, [final state]
					[ "notify", "progress", jQuery.Callbacks( "memory" ),
						jQuery.Callbacks( "memory" ), 2 ],
					[ "resolve", "done", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 0, "resolved" ],
					[ "reject", "fail", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 1, "rejected" ]
				],
				state = "pending",
				promise = {
					state: function() {
						return state;
					},
					always: function() {
						deferred.done( arguments ).fail( arguments );
						return this;
					},
					"catch": function( fn ) {
						return promise.then( null, fn );
					},
	
					// Keep pipe for back-compat
					pipe: function( /* fnDone, fnFail, fnProgress */ ) {
						var fns = arguments;
	
						return jQuery.Deferred( function( newDefer ) {
							jQuery.each( tuples, function( _i, tuple ) {
	
								// Map tuples (progress, done, fail) to arguments (done, fail, progress)
								var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];
	
								// deferred.progress(function() { bind to newDefer or newDefer.notify })
								// deferred.done(function() { bind to newDefer or newDefer.resolve })
								// deferred.fail(function() { bind to newDefer or newDefer.reject })
								deferred[ tuple[ 1 ] ]( function() {
									var returned = fn && fn.apply( this, arguments );
									if ( returned && isFunction( returned.promise ) ) {
										returned.promise()
											.progress( newDefer.notify )
											.done( newDefer.resolve )
											.fail( newDefer.reject );
									} else {
										newDefer[ tuple[ 0 ] + "With" ](
											this,
											fn ? [ returned ] : arguments
										);
									}
								} );
							} );
							fns = null;
						} ).promise();
					},
					then: function( onFulfilled, onRejected, onProgress ) {
						var maxDepth = 0;
						function resolve( depth, deferred, handler, special ) {
							return function() {
								var that = this,
									args = arguments,
									mightThrow = function() {
										var returned, then;
	
										// Support: Promises/A+ section 2.3.3.3.3
										// https://promisesaplus.com/#point-59
										// Ignore double-resolution attempts
										if ( depth < maxDepth ) {
											return;
										}
	
										returned = handler.apply( that, args );
	
										// Support: Promises/A+ section 2.3.1
										// https://promisesaplus.com/#point-48
										if ( returned === deferred.promise() ) {
											throw new TypeError( "Thenable self-resolution" );
										}
	
										// Support: Promises/A+ sections 2.3.3.1, 3.5
										// https://promisesaplus.com/#point-54
										// https://promisesaplus.com/#point-75
										// Retrieve `then` only once
										then = returned &&
	
											// Support: Promises/A+ section 2.3.4
											// https://promisesaplus.com/#point-64
											// Only check objects and functions for thenability
											( typeof returned === "object" ||
												typeof returned === "function" ) &&
											returned.then;
	
										// Handle a returned thenable
										if ( isFunction( then ) ) {
	
											// Special processors (notify) just wait for resolution
											if ( special ) {
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special )
												);
	
											// Normal processors (resolve) also hook into progress
											} else {
	
												// ...and disregard older resolution values
												maxDepth++;
	
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special ),
													resolve( maxDepth, deferred, Identity,
														deferred.notifyWith )
												);
											}
	
										// Handle all other returned values
										} else {
	
											// Only substitute handlers pass on context
											// and multiple values (non-spec behavior)
											if ( handler !== Identity ) {
												that = undefined;
												args = [ returned ];
											}
	
											// Process the value(s)
											// Default process is resolve
											( special || deferred.resolveWith )( that, args );
										}
									},
	
									// Only normal processors (resolve) catch and reject exceptions
									process = special ?
										mightThrow :
										function() {
											try {
												mightThrow();
											} catch ( e ) {
	
												if ( jQuery.Deferred.exceptionHook ) {
													jQuery.Deferred.exceptionHook( e,
														process.error );
												}
	
												// Support: Promises/A+ section 2.3.3.3.4.1
												// https://promisesaplus.com/#point-61
												// Ignore post-resolution exceptions
												if ( depth + 1 >= maxDepth ) {
	
													// Only substitute handlers pass on context
													// and multiple values (non-spec behavior)
													if ( handler !== Thrower ) {
														that = undefined;
														args = [ e ];
													}
	
													deferred.rejectWith( that, args );
												}
											}
										};
	
								// Support: Promises/A+ section 2.3.3.3.1
								// https://promisesaplus.com/#point-57
								// Re-resolve promises immediately to dodge false rejection from
								// subsequent errors
								if ( depth ) {
									process();
								} else {
	
									// Call an optional hook to record the error, in case of exception
									// since it's otherwise lost when execution goes async
									if ( jQuery.Deferred.getErrorHook ) {
										process.error = jQuery.Deferred.getErrorHook();
	
									// The deprecated alias of the above. While the name suggests
									// returning the stack, not an error instance, jQuery just passes
									// it directly to `console.warn` so both will work; an instance
									// just better cooperates with source maps.
									} else if ( jQuery.Deferred.getStackHook ) {
										process.error = jQuery.Deferred.getStackHook();
									}
									window.setTimeout( process );
								}
							};
						}
	
						return jQuery.Deferred( function( newDefer ) {
	
							// progress_handlers.add( ... )
							tuples[ 0 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onProgress ) ?
										onProgress :
										Identity,
									newDefer.notifyWith
								)
							);
	
							// fulfilled_handlers.add( ... )
							tuples[ 1 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onFulfilled ) ?
										onFulfilled :
										Identity
								)
							);
	
							// rejected_handlers.add( ... )
							tuples[ 2 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onRejected ) ?
										onRejected :
										Thrower
								)
							);
						} ).promise();
					},
	
					// Get a promise for this deferred
					// If obj is provided, the promise aspect is added to the object
					promise: function( obj ) {
						return obj != null ? jQuery.extend( obj, promise ) : promise;
					}
				},
				deferred = {};
	
			// Add list-specific methods
			jQuery.each( tuples, function( i, tuple ) {
				var list = tuple[ 2 ],
					stateString = tuple[ 5 ];
	
				// promise.progress = list.add
				// promise.done = list.add
				// promise.fail = list.add
				promise[ tuple[ 1 ] ] = list.add;
	
				// Handle state
				if ( stateString ) {
					list.add(
						function() {
	
							// state = "resolved" (i.e., fulfilled)
							// state = "rejected"
							state = stateString;
						},
	
						// rejected_callbacks.disable
						// fulfilled_callbacks.disable
						tuples[ 3 - i ][ 2 ].disable,
	
						// rejected_handlers.disable
						// fulfilled_handlers.disable
						tuples[ 3 - i ][ 3 ].disable,
	
						// progress_callbacks.lock
						tuples[ 0 ][ 2 ].lock,
	
						// progress_handlers.lock
						tuples[ 0 ][ 3 ].lock
					);
				}
	
				// progress_handlers.fire
				// fulfilled_handlers.fire
				// rejected_handlers.fire
				list.add( tuple[ 3 ].fire );
	
				// deferred.notify = function() { deferred.notifyWith(...) }
				// deferred.resolve = function() { deferred.resolveWith(...) }
				// deferred.reject = function() { deferred.rejectWith(...) }
				deferred[ tuple[ 0 ] ] = function() {
					deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
					return this;
				};
	
				// deferred.notifyWith = list.fireWith
				// deferred.resolveWith = list.fireWith
				// deferred.rejectWith = list.fireWith
				deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
			} );
	
			// Make the deferred a promise
			promise.promise( deferred );
	
			// Call given func if any
			if ( func ) {
				func.call( deferred, deferred );
			}
	
			// All done!
			return deferred;
		},
	
		// Deferred helper
		when: function( singleValue ) {
			var
	
				// count of uncompleted subordinates
				remaining = arguments.length,
	
				// count of unprocessed arguments
				i = remaining,
	
				// subordinate fulfillment data
				resolveContexts = Array( i ),
				resolveValues = slice.call( arguments ),
	
				// the primary Deferred
				primary = jQuery.Deferred(),
	
				// subordinate callback factory
				updateFunc = function( i ) {
					return function( value ) {
						resolveContexts[ i ] = this;
						resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
						if ( !( --remaining ) ) {
							primary.resolveWith( resolveContexts, resolveValues );
						}
					};
				};
	
			// Single- and empty arguments are adopted like Promise.resolve
			if ( remaining <= 1 ) {
				adoptValue( singleValue, primary.done( updateFunc( i ) ).resolve, primary.reject,
					!remaining );
	
				// Use .then() to unwrap secondary thenables (cf. gh-3000)
				if ( primary.state() === "pending" ||
					isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {
	
					return primary.then();
				}
			}
	
			// Multiple arguments are aggregated like Promise.all array elements
			while ( i-- ) {
				adoptValue( resolveValues[ i ], updateFunc( i ), primary.reject );
			}
	
			return primary.promise();
		}
	} );
	
	
	// These usually indicate a programmer mistake during development,
	// warn about them ASAP rather than swallowing them by default.
	var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
	
	// If `jQuery.Deferred.getErrorHook` is defined, `asyncError` is an error
	// captured before the async barrier to get the original error cause
	// which may otherwise be hidden.
	jQuery.Deferred.exceptionHook = function( error, asyncError ) {
	
		// Support: IE 8 - 9 only
		// Console exists when dev tools are open, which can happen at any time
		if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
			window.console.warn( "jQuery.Deferred exception: " + error.message,
				error.stack, asyncError );
		}
	};
	
	
	
	
	jQuery.readyException = function( error ) {
		window.setTimeout( function() {
			throw error;
		} );
	};
	
	
	
	
	// The deferred used on DOM ready
	var readyList = jQuery.Deferred();
	
	jQuery.fn.ready = function( fn ) {
	
		readyList
			.then( fn )
	
			// Wrap jQuery.readyException in a function so that the lookup
			// happens at the time of error handling instead of callback
			// registration.
			.catch( function( error ) {
				jQuery.readyException( error );
			} );
	
		return this;
	};
	
	jQuery.extend( {
	
		// Is the DOM ready to be used? Set to true once it occurs.
		isReady: false,
	
		// A counter to track how many items to wait for before
		// the ready event fires. See trac-6781
		readyWait: 1,
	
		// Handle when the DOM is ready
		ready: function( wait ) {
	
			// Abort if there are pending holds or we're already ready
			if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
				return;
			}
	
			// Remember that the DOM is ready
			jQuery.isReady = true;
	
			// If a normal DOM Ready event fired, decrement, and wait if need be
			if ( wait !== true && --jQuery.readyWait > 0 ) {
				return;
			}
	
			// If there are functions bound, to execute
			readyList.resolveWith( document, [ jQuery ] );
		}
	} );
	
	jQuery.ready.then = readyList.then;
	
	// The ready event handler and self cleanup method
	function completed() {
		document.removeEventListener( "DOMContentLoaded", completed );
		window.removeEventListener( "load", completed );
		jQuery.ready();
	}
	
	// Catch cases where $(document).ready() is called
	// after the browser event has already occurred.
	// Support: IE <=9 - 10 only
	// Older IE sometimes signals "interactive" too soon
	if ( document.readyState === "complete" ||
		( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {
	
		// Handle it asynchronously to allow scripts the opportunity to delay ready
		window.setTimeout( jQuery.ready );
	
	} else {
	
		// Use the handy event callback
		document.addEventListener( "DOMContentLoaded", completed );
	
		// A fallback to window.onload, that will always work
		window.addEventListener( "load", completed );
	}
	
	
	
	
	// Multifunctional method to get and set values of a collection
	// The value/s can optionally be executed if it's a function
	var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
		var i = 0,
			len = elems.length,
			bulk = key == null;
	
		// Sets many values
		if ( toType( key ) === "object" ) {
			chainable = true;
			for ( i in key ) {
				access( elems, fn, i, key[ i ], true, emptyGet, raw );
			}
	
		// Sets one value
		} else if ( value !== undefined ) {
			chainable = true;
	
			if ( !isFunction( value ) ) {
				raw = true;
			}
	
			if ( bulk ) {
	
				// Bulk operations run against the entire set
				if ( raw ) {
					fn.call( elems, value );
					fn = null;
	
				// ...except when executing function values
				} else {
					bulk = fn;
					fn = function( elem, _key, value ) {
						return bulk.call( jQuery( elem ), value );
					};
				}
			}
	
			if ( fn ) {
				for ( ; i < len; i++ ) {
					fn(
						elems[ i ], key, raw ?
							value :
							value.call( elems[ i ], i, fn( elems[ i ], key ) )
					);
				}
			}
		}
	
		if ( chainable ) {
			return elems;
		}
	
		// Gets
		if ( bulk ) {
			return fn.call( elems );
		}
	
		return len ? fn( elems[ 0 ], key ) : emptyGet;
	};
	
	
	// Matches dashed string for camelizing
	var rmsPrefix = /^-ms-/,
		rdashAlpha = /-([a-z])/g;
	
	// Used by camelCase as callback to replace()
	function fcamelCase( _all, letter ) {
		return letter.toUpperCase();
	}
	
	// Convert dashed to camelCase; used by the css and data modules
	// Support: IE <=9 - 11, Edge 12 - 15
	// Microsoft forgot to hump their vendor prefix (trac-9572)
	function camelCase( string ) {
		return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
	}
	var acceptData = function( owner ) {
	
		// Accepts only:
		//  - Node
		//    - Node.ELEMENT_NODE
		//    - Node.DOCUMENT_NODE
		//  - Object
		//    - Any
		return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
	};
	
	
	
	
	function Data() {
		this.expando = jQuery.expando + Data.uid++;
	}
	
	Data.uid = 1;
	
	Data.prototype = {
	
		cache: function( owner ) {
	
			// Check if the owner object already has a cache
			var value = owner[ this.expando ];
	
			// If not, create one
			if ( !value ) {
				value = {};
	
				// We can accept data for non-element nodes in modern browsers,
				// but we should not, see trac-8335.
				// Always return an empty object.
				if ( acceptData( owner ) ) {
	
					// If it is a node unlikely to be stringify-ed or looped over
					// use plain assignment
					if ( owner.nodeType ) {
						owner[ this.expando ] = value;
	
					// Otherwise secure it in a non-enumerable property
					// configurable must be true to allow the property to be
					// deleted when data is removed
					} else {
						Object.defineProperty( owner, this.expando, {
							value: value,
							configurable: true
						} );
					}
				}
			}
	
			return value;
		},
		set: function( owner, data, value ) {
			var prop,
				cache = this.cache( owner );
	
			// Handle: [ owner, key, value ] args
			// Always use camelCase key (gh-2257)
			if ( typeof data === "string" ) {
				cache[ camelCase( data ) ] = value;
	
			// Handle: [ owner, { properties } ] args
			} else {
	
				// Copy the properties one-by-one to the cache object
				for ( prop in data ) {
					cache[ camelCase( prop ) ] = data[ prop ];
				}
			}
			return cache;
		},
		get: function( owner, key ) {
			return key === undefined ?
				this.cache( owner ) :
	
				// Always use camelCase key (gh-2257)
				owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
		},
		access: function( owner, key, value ) {
	
			// In cases where either:
			//
			//   1. No key was specified
			//   2. A string key was specified, but no value provided
			//
			// Take the "read" path and allow the get method to determine
			// which value to return, respectively either:
			//
			//   1. The entire cache object
			//   2. The data stored at the key
			//
			if ( key === undefined ||
					( ( key && typeof key === "string" ) && value === undefined ) ) {
	
				return this.get( owner, key );
			}
	
			// When the key is not a string, or both a key and value
			// are specified, set or extend (existing objects) with either:
			//
			//   1. An object of properties
			//   2. A key and value
			//
			this.set( owner, key, value );
	
			// Since the "set" path can have two possible entry points
			// return the expected data based on which path was taken[*]
			return value !== undefined ? value : key;
		},
		remove: function( owner, key ) {
			var i,
				cache = owner[ this.expando ];
	
			if ( cache === undefined ) {
				return;
			}
	
			if ( key !== undefined ) {
	
				// Support array or space separated string of keys
				if ( Array.isArray( key ) ) {
	
					// If key is an array of keys...
					// We always set camelCase keys, so remove that.
					key = key.map( camelCase );
				} else {
					key = camelCase( key );
	
					// If a key with the spaces exists, use it.
					// Otherwise, create an array by matching non-whitespace
					key = key in cache ?
						[ key ] :
						( key.match( rnothtmlwhite ) || [] );
				}
	
				i = key.length;
	
				while ( i-- ) {
					delete cache[ key[ i ] ];
				}
			}
	
			// Remove the expando if there's no more data
			if ( key === undefined || jQuery.isEmptyObject( cache ) ) {
	
				// Support: Chrome <=35 - 45
				// Webkit & Blink performance suffers when deleting properties
				// from DOM nodes, so set to undefined instead
				// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
				if ( owner.nodeType ) {
					owner[ this.expando ] = undefined;
				} else {
					delete owner[ this.expando ];
				}
			}
		},
		hasData: function( owner ) {
			var cache = owner[ this.expando ];
			return cache !== undefined && !jQuery.isEmptyObject( cache );
		}
	};
	var dataPriv = new Data();
	
	var dataUser = new Data();
	
	
	
	//	Implementation Summary
	//
	//	1. Enforce API surface and semantic compatibility with 1.9.x branch
	//	2. Improve the module's maintainability by reducing the storage
	//		paths to a single mechanism.
	//	3. Use the same single mechanism to support "private" and "user" data.
	//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
	//	5. Avoid exposing implementation details on user objects (eg. expando properties)
	//	6. Provide a clear path for implementation upgrade to WeakMap in 2014
	
	var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
		rmultiDash = /[A-Z]/g;
	
	function getData( data ) {
		if ( data === "true" ) {
			return true;
		}
	
		if ( data === "false" ) {
			return false;
		}
	
		if ( data === "null" ) {
			return null;
		}
	
		// Only convert to a number if it doesn't change the string
		if ( data === +data + "" ) {
			return +data;
		}
	
		if ( rbrace.test( data ) ) {
			return JSON.parse( data );
		}
	
		return data;
	}
	
	function dataAttr( elem, key, data ) {
		var name;
	
		// If nothing was found internally, try to fetch any
		// data from the HTML5 data-* attribute
		if ( data === undefined && elem.nodeType === 1 ) {
			name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
			data = elem.getAttribute( name );
	
			if ( typeof data === "string" ) {
				try {
					data = getData( data );
				} catch ( e ) {}
	
				// Make sure we set the data so it isn't changed later
				dataUser.set( elem, key, data );
			} else {
				data = undefined;
			}
		}
		return data;
	}
	
	jQuery.extend( {
		hasData: function( elem ) {
			return dataUser.hasData( elem ) || dataPriv.hasData( elem );
		},
	
		data: function( elem, name, data ) {
			return dataUser.access( elem, name, data );
		},
	
		removeData: function( elem, name ) {
			dataUser.remove( elem, name );
		},
	
		// TODO: Now that all calls to _data and _removeData have been replaced
		// with direct calls to dataPriv methods, these can be deprecated.
		_data: function( elem, name, data ) {
			return dataPriv.access( elem, name, data );
		},
	
		_removeData: function( elem, name ) {
			dataPriv.remove( elem, name );
		}
	} );
	
	jQuery.fn.extend( {
		data: function( key, value ) {
			var i, name, data,
				elem = this[ 0 ],
				attrs = elem && elem.attributes;
	
			// Gets all values
			if ( key === undefined ) {
				if ( this.length ) {
					data = dataUser.get( elem );
	
					if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
						i = attrs.length;
						while ( i-- ) {
	
							// Support: IE 11 only
							// The attrs elements can be null (trac-14894)
							if ( attrs[ i ] ) {
								name = attrs[ i ].name;
								if ( name.indexOf( "data-" ) === 0 ) {
									name = camelCase( name.slice( 5 ) );
									dataAttr( elem, name, data[ name ] );
								}
							}
						}
						dataPriv.set( elem, "hasDataAttrs", true );
					}
				}
	
				return data;
			}
	
			// Sets multiple values
			if ( typeof key === "object" ) {
				return this.each( function() {
					dataUser.set( this, key );
				} );
			}
	
			return access( this, function( value ) {
				var data;
	
				// The calling jQuery object (element matches) is not empty
				// (and therefore has an element appears at this[ 0 ]) and the
				// `value` parameter was not undefined. An empty jQuery object
				// will result in `undefined` for elem = this[ 0 ] which will
				// throw an exception if an attempt to read a data cache is made.
				if ( elem && value === undefined ) {
	
					// Attempt to get data from the cache
					// The key will always be camelCased in Data
					data = dataUser.get( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// Attempt to "discover" the data in
					// HTML5 custom data-* attrs
					data = dataAttr( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// We tried really hard, but the data doesn't exist.
					return;
				}
	
				// Set the data...
				this.each( function() {
	
					// We always store the camelCased key
					dataUser.set( this, key, value );
				} );
			}, null, value, arguments.length > 1, null, true );
		},
	
		removeData: function( key ) {
			return this.each( function() {
				dataUser.remove( this, key );
			} );
		}
	} );
	
	
	jQuery.extend( {
		queue: function( elem, type, data ) {
			var queue;
	
			if ( elem ) {
				type = ( type || "fx" ) + "queue";
				queue = dataPriv.get( elem, type );
	
				// Speed up dequeue by getting out quickly if this is just a lookup
				if ( data ) {
					if ( !queue || Array.isArray( data ) ) {
						queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
					} else {
						queue.push( data );
					}
				}
				return queue || [];
			}
		},
	
		dequeue: function( elem, type ) {
			type = type || "fx";
	
			var queue = jQuery.queue( elem, type ),
				startLength = queue.length,
				fn = queue.shift(),
				hooks = jQuery._queueHooks( elem, type ),
				next = function() {
					jQuery.dequeue( elem, type );
				};
	
			// If the fx queue is dequeued, always remove the progress sentinel
			if ( fn === "inprogress" ) {
				fn = queue.shift();
				startLength--;
			}
	
			if ( fn ) {
	
				// Add a progress sentinel to prevent the fx queue from being
				// automatically dequeued
				if ( type === "fx" ) {
					queue.unshift( "inprogress" );
				}
	
				// Clear up the last queue stop function
				delete hooks.stop;
				fn.call( elem, next, hooks );
			}
	
			if ( !startLength && hooks ) {
				hooks.empty.fire();
			}
		},
	
		// Not public - generate a queueHooks object, or return the current one
		_queueHooks: function( elem, type ) {
			var key = type + "queueHooks";
			return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
				empty: jQuery.Callbacks( "once memory" ).add( function() {
					dataPriv.remove( elem, [ type + "queue", key ] );
				} )
			} );
		}
	} );
	
	jQuery.fn.extend( {
		queue: function( type, data ) {
			var setter = 2;
	
			if ( typeof type !== "string" ) {
				data = type;
				type = "fx";
				setter--;
			}
	
			if ( arguments.length < setter ) {
				return jQuery.queue( this[ 0 ], type );
			}
	
			return data === undefined ?
				this :
				this.each( function() {
					var queue = jQuery.queue( this, type, data );
	
					// Ensure a hooks for this queue
					jQuery._queueHooks( this, type );
	
					if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
						jQuery.dequeue( this, type );
					}
				} );
		},
		dequeue: function( type ) {
			return this.each( function() {
				jQuery.dequeue( this, type );
			} );
		},
		clearQueue: function( type ) {
			return this.queue( type || "fx", [] );
		},
	
		// Get a promise resolved when queues of a certain type
		// are emptied (fx is the type by default)
		promise: function( type, obj ) {
			var tmp,
				count = 1,
				defer = jQuery.Deferred(),
				elements = this,
				i = this.length,
				resolve = function() {
					if ( !( --count ) ) {
						defer.resolveWith( elements, [ elements ] );
					}
				};
	
			if ( typeof type !== "string" ) {
				obj = type;
				type = undefined;
			}
			type = type || "fx";
	
			while ( i-- ) {
				tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
				if ( tmp && tmp.empty ) {
					count++;
					tmp.empty.add( resolve );
				}
			}
			resolve();
			return defer.promise( obj );
		}
	} );
	var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;
	
	var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );
	
	
	var cssExpand = [ "Top", "Right", "Bottom", "Left" ];
	
	var documentElement = document.documentElement;
	
	
	
		var isAttached = function( elem ) {
				return jQuery.contains( elem.ownerDocument, elem );
			},
			composed = { composed: true };
	
		// Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
		// Check attachment across shadow DOM boundaries when possible (gh-3504)
		// Support: iOS 10.0-10.2 only
		// Early iOS 10 versions support `attachShadow` but not `getRootNode`,
		// leading to errors. We need to check for `getRootNode`.
		if ( documentElement.getRootNode ) {
			isAttached = function( elem ) {
				return jQuery.contains( elem.ownerDocument, elem ) ||
					elem.getRootNode( composed ) === elem.ownerDocument;
			};
		}
	var isHiddenWithinTree = function( elem, el ) {
	
			// isHiddenWithinTree might be called from jQuery#filter function;
			// in that case, element will be second argument
			elem = el || elem;
	
			// Inline style trumps all
			return elem.style.display === "none" ||
				elem.style.display === "" &&
	
				// Otherwise, check computed style
				// Support: Firefox <=43 - 45
				// Disconnected elements can have computed display: none, so first confirm that elem is
				// in the document.
				isAttached( elem ) &&
	
				jQuery.css( elem, "display" ) === "none";
		};
	
	
	
	function adjustCSS( elem, prop, valueParts, tween ) {
		var adjusted, scale,
			maxIterations = 20,
			currentValue = tween ?
				function() {
					return tween.cur();
				} :
				function() {
					return jQuery.css( elem, prop, "" );
				},
			initial = currentValue(),
			unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),
	
			// Starting value computation is required for potential unit mismatches
			initialInUnit = elem.nodeType &&
				( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
				rcssNum.exec( jQuery.css( elem, prop ) );
	
		if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {
	
			// Support: Firefox <=54
			// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
			initial = initial / 2;
	
			// Trust units reported by jQuery.css
			unit = unit || initialInUnit[ 3 ];
	
			// Iteratively approximate from a nonzero starting point
			initialInUnit = +initial || 1;
	
			while ( maxIterations-- ) {
	
				// Evaluate and update our best guess (doubling guesses that zero out).
				// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
				jQuery.style( elem, prop, initialInUnit + unit );
				if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
					maxIterations = 0;
				}
				initialInUnit = initialInUnit / scale;
	
			}
	
			initialInUnit = initialInUnit * 2;
			jQuery.style( elem, prop, initialInUnit + unit );
	
			// Make sure we update the tween properties later on
			valueParts = valueParts || [];
		}
	
		if ( valueParts ) {
			initialInUnit = +initialInUnit || +initial || 0;
	
			// Apply relative offset (+=/-=) if specified
			adjusted = valueParts[ 1 ] ?
				initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
				+valueParts[ 2 ];
			if ( tween ) {
				tween.unit = unit;
				tween.start = initialInUnit;
				tween.end = adjusted;
			}
		}
		return adjusted;
	}
	
	
	var defaultDisplayMap = {};
	
	function getDefaultDisplay( elem ) {
		var temp,
			doc = elem.ownerDocument,
			nodeName = elem.nodeName,
			display = defaultDisplayMap[ nodeName ];
	
		if ( display ) {
			return display;
		}
	
		temp = doc.body.appendChild( doc.createElement( nodeName ) );
		display = jQuery.css( temp, "display" );
	
		temp.parentNode.removeChild( temp );
	
		if ( display === "none" ) {
			display = "block";
		}
		defaultDisplayMap[ nodeName ] = display;
	
		return display;
	}
	
	function showHide( elements, show ) {
		var display, elem,
			values = [],
			index = 0,
			length = elements.length;
	
		// Determine new display value for elements that need to change
		for ( ; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
	
			display = elem.style.display;
			if ( show ) {
	
				// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
				// check is required in this first loop unless we have a nonempty display value (either
				// inline or about-to-be-restored)
				if ( display === "none" ) {
					values[ index ] = dataPriv.get( elem, "display" ) || null;
					if ( !values[ index ] ) {
						elem.style.display = "";
					}
				}
				if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
					values[ index ] = getDefaultDisplay( elem );
				}
			} else {
				if ( display !== "none" ) {
					values[ index ] = "none";
	
					// Remember what we're overwriting
					dataPriv.set( elem, "display", display );
				}
			}
		}
	
		// Set the display of the elements in a second loop to avoid constant reflow
		for ( index = 0; index < length; index++ ) {
			if ( values[ index ] != null ) {
				elements[ index ].style.display = values[ index ];
			}
		}
	
		return elements;
	}
	
	jQuery.fn.extend( {
		show: function() {
			return showHide( this, true );
		},
		hide: function() {
			return showHide( this );
		},
		toggle: function( state ) {
			if ( typeof state === "boolean" ) {
				return state ? this.show() : this.hide();
			}
	
			return this.each( function() {
				if ( isHiddenWithinTree( this ) ) {
					jQuery( this ).show();
				} else {
					jQuery( this ).hide();
				}
			} );
		}
	} );
	var rcheckableType = ( /^(?:checkbox|radio)$/i );
	
	var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]*)/i );
	
	var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );
	
	
	
	( function() {
		var fragment = document.createDocumentFragment(),
			div = fragment.appendChild( document.createElement( "div" ) ),
			input = document.createElement( "input" );
	
		// Support: Android 4.0 - 4.3 only
		// Check state lost if the name is set (trac-11217)
		// Support: Windows Web Apps (WWA)
		// `name` and `type` must use .setAttribute for WWA (trac-14901)
		input.setAttribute( "type", "radio" );
		input.setAttribute( "checked", "checked" );
		input.setAttribute( "name", "t" );
	
		div.appendChild( input );
	
		// Support: Android <=4.1 only
		// Older WebKit doesn't clone checked state correctly in fragments
		support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;
	
		// Support: IE <=11 only
		// Make sure textarea (and checkbox) defaultValue is properly cloned
		div.innerHTML = "<textarea>x</textarea>";
		support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
	
		// Support: IE <=9 only
		// IE <=9 replaces <option> tags with their contents when inserted outside of
		// the select element.
		div.innerHTML = "<option></option>";
		support.option = !!div.lastChild;
	} )();
	
	
	// We have to close these tags to support XHTML (trac-13200)
	var wrapMap = {
	
		// XHTML parsers do not magically insert elements in the
		// same way that tag soup parsers do. So we cannot shorten
		// this by omitting <tbody> or other required elements.
		thead: [ 1, "<table>", "</table>" ],
		col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
		tr: [ 2, "<table><tbody>", "</tbody></table>" ],
		td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],
	
		_default: [ 0, "", "" ]
	};
	
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	// Support: IE <=9 only
	if ( !support.option ) {
		wrapMap.optgroup = wrapMap.option = [ 1, "<select multiple='multiple'>", "</select>" ];
	}
	
	
	function getAll( context, tag ) {
	
		// Support: IE <=9 - 11 only
		// Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
		var ret;
	
		if ( typeof context.getElementsByTagName !== "undefined" ) {
			ret = context.getElementsByTagName( tag || "*" );
	
		} else if ( typeof context.querySelectorAll !== "undefined" ) {
			ret = context.querySelectorAll( tag || "*" );
	
		} else {
			ret = [];
		}
	
		if ( tag === undefined || tag && nodeName( context, tag ) ) {
			return jQuery.merge( [ context ], ret );
		}
	
		return ret;
	}
	
	
	// Mark scripts as having already been evaluated
	function setGlobalEval( elems, refElements ) {
		var i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			dataPriv.set(
				elems[ i ],
				"globalEval",
				!refElements || dataPriv.get( refElements[ i ], "globalEval" )
			);
		}
	}
	
	
	var rhtml = /<|&#?\w+;/;
	
	function buildFragment( elems, context, scripts, selection, ignored ) {
		var elem, tmp, tag, wrap, attached, j,
			fragment = context.createDocumentFragment(),
			nodes = [],
			i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			elem = elems[ i ];
	
			if ( elem || elem === 0 ) {
	
				// Add nodes directly
				if ( toType( elem ) === "object" ) {
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );
	
				// Convert non-html into a text node
				} else if ( !rhtml.test( elem ) ) {
					nodes.push( context.createTextNode( elem ) );
	
				// Convert html into DOM nodes
				} else {
					tmp = tmp || fragment.appendChild( context.createElement( "div" ) );
	
					// Deserialize a standard representation
					tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
					wrap = wrapMap[ tag ] || wrapMap._default;
					tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];
	
					// Descend through wrappers to the right content
					j = wrap[ 0 ];
					while ( j-- ) {
						tmp = tmp.lastChild;
					}
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, tmp.childNodes );
	
					// Remember the top-level container
					tmp = fragment.firstChild;
	
					// Ensure the created nodes are orphaned (trac-12392)
					tmp.textContent = "";
				}
			}
		}
	
		// Remove wrapper from fragment
		fragment.textContent = "";
	
		i = 0;
		while ( ( elem = nodes[ i++ ] ) ) {
	
			// Skip elements already in the context collection (trac-4087)
			if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
				if ( ignored ) {
					ignored.push( elem );
				}
				continue;
			}
	
			attached = isAttached( elem );
	
			// Append to fragment
			tmp = getAll( fragment.appendChild( elem ), "script" );
	
			// Preserve script evaluation history
			if ( attached ) {
				setGlobalEval( tmp );
			}
	
			// Capture executables
			if ( scripts ) {
				j = 0;
				while ( ( elem = tmp[ j++ ] ) ) {
					if ( rscriptType.test( elem.type || "" ) ) {
						scripts.push( elem );
					}
				}
			}
		}
	
		return fragment;
	}
	
	
	var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
	
	function returnTrue() {
		return true;
	}
	
	function returnFalse() {
		return false;
	}
	
	function on( elem, types, selector, data, fn, one ) {
		var origFn, type;
	
		// Types can be a map of types/handlers
		if ( typeof types === "object" ) {
	
			// ( types-Object, selector, data )
			if ( typeof selector !== "string" ) {
	
				// ( types-Object, data )
				data = data || selector;
				selector = undefined;
			}
			for ( type in types ) {
				on( elem, type, selector, data, types[ type ], one );
			}
			return elem;
		}
	
		if ( data == null && fn == null ) {
	
			// ( types, fn )
			fn = selector;
			data = selector = undefined;
		} else if ( fn == null ) {
			if ( typeof selector === "string" ) {
	
				// ( types, selector, fn )
				fn = data;
				data = undefined;
			} else {
	
				// ( types, data, fn )
				fn = data;
				data = selector;
				selector = undefined;
			}
		}
		if ( fn === false ) {
			fn = returnFalse;
		} else if ( !fn ) {
			return elem;
		}
	
		if ( one === 1 ) {
			origFn = fn;
			fn = function( event ) {
	
				// Can use an empty set, since event contains the info
				jQuery().off( event );
				return origFn.apply( this, arguments );
			};
	
			// Use same guid so caller can remove using origFn
			fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
		}
		return elem.each( function() {
			jQuery.event.add( this, types, fn, data, selector );
		} );
	}
	
	/*
	 * Helper functions for managing events -- not part of the public interface.
	 * Props to Dean Edwards' addEvent library for many of the ideas.
	 */
	jQuery.event = {
	
		global: {},
	
		add: function( elem, types, handler, data, selector ) {
	
			var handleObjIn, eventHandle, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.get( elem );
	
			// Only attach events to objects that accept data
			if ( !acceptData( elem ) ) {
				return;
			}
	
			// Caller can pass in an object of custom data in lieu of the handler
			if ( handler.handler ) {
				handleObjIn = handler;
				handler = handleObjIn.handler;
				selector = handleObjIn.selector;
			}
	
			// Ensure that invalid selectors throw exceptions at attach time
			// Evaluate against documentElement in case elem is a non-element node (e.g., document)
			if ( selector ) {
				jQuery.find.matchesSelector( documentElement, selector );
			}
	
			// Make sure that the handler has a unique ID, used to find/remove it later
			if ( !handler.guid ) {
				handler.guid = jQuery.guid++;
			}
	
			// Init the element's event structure and main handler, if this is the first
			if ( !( events = elemData.events ) ) {
				events = elemData.events = Object.create( null );
			}
			if ( !( eventHandle = elemData.handle ) ) {
				eventHandle = elemData.handle = function( e ) {
	
					// Discard the second event of a jQuery.event.trigger() and
					// when an event is called after a page has unloaded
					return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
						jQuery.event.dispatch.apply( elem, arguments ) : undefined;
				};
			}
	
			// Handle multiple events separated by a space
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// There *must* be a type, no attaching namespace-only handlers
				if ( !type ) {
					continue;
				}
	
				// If event changes its type, use the special event handlers for the changed type
				special = jQuery.event.special[ type ] || {};
	
				// If selector defined, determine special event api type, otherwise given type
				type = ( selector ? special.delegateType : special.bindType ) || type;
	
				// Update special based on newly reset type
				special = jQuery.event.special[ type ] || {};
	
				// handleObj is passed to all event handlers
				handleObj = jQuery.extend( {
					type: type,
					origType: origType,
					data: data,
					handler: handler,
					guid: handler.guid,
					selector: selector,
					needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
					namespace: namespaces.join( "." )
				}, handleObjIn );
	
				// Init the event handler queue if we're the first
				if ( !( handlers = events[ type ] ) ) {
					handlers = events[ type ] = [];
					handlers.delegateCount = 0;
	
					// Only use addEventListener if the special events handler returns false
					if ( !special.setup ||
						special.setup.call( elem, data, namespaces, eventHandle ) === false ) {
	
						if ( elem.addEventListener ) {
							elem.addEventListener( type, eventHandle );
						}
					}
				}
	
				if ( special.add ) {
					special.add.call( elem, handleObj );
	
					if ( !handleObj.handler.guid ) {
						handleObj.handler.guid = handler.guid;
					}
				}
	
				// Add to the element's handler list, delegates in front
				if ( selector ) {
					handlers.splice( handlers.delegateCount++, 0, handleObj );
				} else {
					handlers.push( handleObj );
				}
	
				// Keep track of which events have ever been used, for event optimization
				jQuery.event.global[ type ] = true;
			}
	
		},
	
		// Detach an event or set of events from an element
		remove: function( elem, types, handler, selector, mappedTypes ) {
	
			var j, origCount, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );
	
			if ( !elemData || !( events = elemData.events ) ) {
				return;
			}
	
			// Once for each type.namespace in types; type may be omitted
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// Unbind all events (on this namespace, if provided) for the element
				if ( !type ) {
					for ( type in events ) {
						jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
					}
					continue;
				}
	
				special = jQuery.event.special[ type ] || {};
				type = ( selector ? special.delegateType : special.bindType ) || type;
				handlers = events[ type ] || [];
				tmp = tmp[ 2 ] &&
					new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );
	
				// Remove matching events
				origCount = j = handlers.length;
				while ( j-- ) {
					handleObj = handlers[ j ];
	
					if ( ( mappedTypes || origType === handleObj.origType ) &&
						( !handler || handler.guid === handleObj.guid ) &&
						( !tmp || tmp.test( handleObj.namespace ) ) &&
						( !selector || selector === handleObj.selector ||
							selector === "**" && handleObj.selector ) ) {
						handlers.splice( j, 1 );
	
						if ( handleObj.selector ) {
							handlers.delegateCount--;
						}
						if ( special.remove ) {
							special.remove.call( elem, handleObj );
						}
					}
				}
	
				// Remove generic event handler if we removed something and no more handlers exist
				// (avoids potential for endless recursion during removal of special event handlers)
				if ( origCount && !handlers.length ) {
					if ( !special.teardown ||
						special.teardown.call( elem, namespaces, elemData.handle ) === false ) {
	
						jQuery.removeEvent( elem, type, elemData.handle );
					}
	
					delete events[ type ];
				}
			}
	
			// Remove data and the expando if it's no longer used
			if ( jQuery.isEmptyObject( events ) ) {
				dataPriv.remove( elem, "handle events" );
			}
		},
	
		dispatch: function( nativeEvent ) {
	
			var i, j, ret, matched, handleObj, handlerQueue,
				args = new Array( arguments.length ),
	
				// Make a writable jQuery.Event from the native event object
				event = jQuery.event.fix( nativeEvent ),
	
				handlers = (
					dataPriv.get( this, "events" ) || Object.create( null )
				)[ event.type ] || [],
				special = jQuery.event.special[ event.type ] || {};
	
			// Use the fix-ed jQuery.Event rather than the (read-only) native event
			args[ 0 ] = event;
	
			for ( i = 1; i < arguments.length; i++ ) {
				args[ i ] = arguments[ i ];
			}
	
			event.delegateTarget = this;
	
			// Call the preDispatch hook for the mapped type, and let it bail if desired
			if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
				return;
			}
	
			// Determine handlers
			handlerQueue = jQuery.event.handlers.call( this, event, handlers );
	
			// Run delegates first; they may want to stop propagation beneath us
			i = 0;
			while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
				event.currentTarget = matched.elem;
	
				j = 0;
				while ( ( handleObj = matched.handlers[ j++ ] ) &&
					!event.isImmediatePropagationStopped() ) {
	
					// If the event is namespaced, then each handler is only invoked if it is
					// specially universal or its namespaces are a superset of the event's.
					if ( !event.rnamespace || handleObj.namespace === false ||
						event.rnamespace.test( handleObj.namespace ) ) {
	
						event.handleObj = handleObj;
						event.data = handleObj.data;
	
						ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
							handleObj.handler ).apply( matched.elem, args );
	
						if ( ret !== undefined ) {
							if ( ( event.result = ret ) === false ) {
								event.preventDefault();
								event.stopPropagation();
							}
						}
					}
				}
			}
	
			// Call the postDispatch hook for the mapped type
			if ( special.postDispatch ) {
				special.postDispatch.call( this, event );
			}
	
			return event.result;
		},
	
		handlers: function( event, handlers ) {
			var i, handleObj, sel, matchedHandlers, matchedSelectors,
				handlerQueue = [],
				delegateCount = handlers.delegateCount,
				cur = event.target;
	
			// Find delegate handlers
			if ( delegateCount &&
	
				// Support: IE <=9
				// Black-hole SVG <use> instance trees (trac-13180)
				cur.nodeType &&
	
				// Support: Firefox <=42
				// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
				// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
				// Support: IE 11 only
				// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
				!( event.type === "click" && event.button >= 1 ) ) {
	
				for ( ; cur !== this; cur = cur.parentNode || this ) {
	
					// Don't check non-elements (trac-13208)
					// Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
					if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
						matchedHandlers = [];
						matchedSelectors = {};
						for ( i = 0; i < delegateCount; i++ ) {
							handleObj = handlers[ i ];
	
							// Don't conflict with Object.prototype properties (trac-13203)
							sel = handleObj.selector + " ";
	
							if ( matchedSelectors[ sel ] === undefined ) {
								matchedSelectors[ sel ] = handleObj.needsContext ?
									jQuery( sel, this ).index( cur ) > -1 :
									jQuery.find( sel, this, null, [ cur ] ).length;
							}
							if ( matchedSelectors[ sel ] ) {
								matchedHandlers.push( handleObj );
							}
						}
						if ( matchedHandlers.length ) {
							handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
						}
					}
				}
			}
	
			// Add the remaining (directly-bound) handlers
			cur = this;
			if ( delegateCount < handlers.length ) {
				handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
			}
	
			return handlerQueue;
		},
	
		addProp: function( name, hook ) {
			Object.defineProperty( jQuery.Event.prototype, name, {
				enumerable: true,
				configurable: true,
	
				get: isFunction( hook ) ?
					function() {
						if ( this.originalEvent ) {
							return hook( this.originalEvent );
						}
					} :
					function() {
						if ( this.originalEvent ) {
							return this.originalEvent[ name ];
						}
					},
	
				set: function( value ) {
					Object.defineProperty( this, name, {
						enumerable: true,
						configurable: true,
						writable: true,
						value: value
					} );
				}
			} );
		},
	
		fix: function( originalEvent ) {
			return originalEvent[ jQuery.expando ] ?
				originalEvent :
				new jQuery.Event( originalEvent );
		},
	
		special: {
			load: {
	
				// Prevent triggered image.load events from bubbling to window.load
				noBubble: true
			},
			click: {
	
				// Utilize native event to ensure correct state for checkable inputs
				setup: function( data ) {
	
					// For mutual compressibility with _default, replace `this` access with a local var.
					// `|| data` is dead code meant only to preserve the variable through minification.
					var el = this || data;
	
					// Claim the first handler
					if ( rcheckableType.test( el.type ) &&
						el.click && nodeName( el, "input" ) ) {
	
						// dataPriv.set( el, "click", ... )
						leverageNative( el, "click", true );
					}
	
					// Return false to allow normal processing in the caller
					return false;
				},
				trigger: function( data ) {
	
					// For mutual compressibility with _default, replace `this` access with a local var.
					// `|| data` is dead code meant only to preserve the variable through minification.
					var el = this || data;
	
					// Force setup before triggering a click
					if ( rcheckableType.test( el.type ) &&
						el.click && nodeName( el, "input" ) ) {
	
						leverageNative( el, "click" );
					}
	
					// Return non-false to allow normal event-path propagation
					return true;
				},
	
				// For cross-browser consistency, suppress native .click() on links
				// Also prevent it if we're currently inside a leveraged native-event stack
				_default: function( event ) {
					var target = event.target;
					return rcheckableType.test( target.type ) &&
						target.click && nodeName( target, "input" ) &&
						dataPriv.get( target, "click" ) ||
						nodeName( target, "a" );
				}
			},
	
			beforeunload: {
				postDispatch: function( event ) {
	
					// Support: Firefox 20+
					// Firefox doesn't alert if the returnValue field is not set.
					if ( event.result !== undefined && event.originalEvent ) {
						event.originalEvent.returnValue = event.result;
					}
				}
			}
		}
	};
	
	// Ensure the presence of an event listener that handles manually-triggered
	// synthetic events by interrupting progress until reinvoked in response to
	// *native* events that it fires directly, ensuring that state changes have
	// already occurred before other listeners are invoked.
	function leverageNative( el, type, isSetup ) {
	
		// Missing `isSetup` indicates a trigger call, which must force setup through jQuery.event.add
		if ( !isSetup ) {
			if ( dataPriv.get( el, type ) === undefined ) {
				jQuery.event.add( el, type, returnTrue );
			}
			return;
		}
	
		// Register the controller as a special universal handler for all event namespaces
		dataPriv.set( el, type, false );
		jQuery.event.add( el, type, {
			namespace: false,
			handler: function( event ) {
				var result,
					saved = dataPriv.get( this, type );
	
				if ( ( event.isTrigger & 1 ) && this[ type ] ) {
	
					// Interrupt processing of the outer synthetic .trigger()ed event
					if ( !saved ) {
	
						// Store arguments for use when handling the inner native event
						// There will always be at least one argument (an event object), so this array
						// will not be confused with a leftover capture object.
						saved = slice.call( arguments );
						dataPriv.set( this, type, saved );
	
						// Trigger the native event and capture its result
						this[ type ]();
						result = dataPriv.get( this, type );
						dataPriv.set( this, type, false );
	
						if ( saved !== result ) {
	
							// Cancel the outer synthetic event
							event.stopImmediatePropagation();
							event.preventDefault();
	
							return result;
						}
	
					// If this is an inner synthetic event for an event with a bubbling surrogate
					// (focus or blur), assume that the surrogate already propagated from triggering
					// the native event and prevent that from happening again here.
					// This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
					// bubbling surrogate propagates *after* the non-bubbling base), but that seems
					// less bad than duplication.
					} else if ( ( jQuery.event.special[ type ] || {} ).delegateType ) {
						event.stopPropagation();
					}
	
				// If this is a native event triggered above, everything is now in order
				// Fire an inner synthetic event with the original arguments
				} else if ( saved ) {
	
					// ...and capture the result
					dataPriv.set( this, type, jQuery.event.trigger(
						saved[ 0 ],
						saved.slice( 1 ),
						this
					) );
	
					// Abort handling of the native event by all jQuery handlers while allowing
					// native handlers on the same element to run. On target, this is achieved
					// by stopping immediate propagation just on the jQuery event. However,
					// the native event is re-wrapped by a jQuery one on each level of the
					// propagation so the only way to stop it for jQuery is to stop it for
					// everyone via native `stopPropagation()`. This is not a problem for
					// focus/blur which don't bubble, but it does also stop click on checkboxes
					// and radios. We accept this limitation.
					event.stopPropagation();
					event.isImmediatePropagationStopped = returnTrue;
				}
			}
		} );
	}
	
	jQuery.removeEvent = function( elem, type, handle ) {
	
		// This "if" is needed for plain objects
		if ( elem.removeEventListener ) {
			elem.removeEventListener( type, handle );
		}
	};
	
	jQuery.Event = function( src, props ) {
	
		// Allow instantiation without the 'new' keyword
		if ( !( this instanceof jQuery.Event ) ) {
			return new jQuery.Event( src, props );
		}
	
		// Event object
		if ( src && src.type ) {
			this.originalEvent = src;
			this.type = src.type;
	
			// Events bubbling up the document may have been marked as prevented
			// by a handler lower down the tree; reflect the correct value.
			this.isDefaultPrevented = src.defaultPrevented ||
					src.defaultPrevented === undefined &&
	
					// Support: Android <=2.3 only
					src.returnValue === false ?
				returnTrue :
				returnFalse;
	
			// Create target properties
			// Support: Safari <=6 - 7 only
			// Target should not be a text node (trac-504, trac-13143)
			this.target = ( src.target && src.target.nodeType === 3 ) ?
				src.target.parentNode :
				src.target;
	
			this.currentTarget = src.currentTarget;
			this.relatedTarget = src.relatedTarget;
	
		// Event type
		} else {
			this.type = src;
		}
	
		// Put explicitly provided properties onto the event object
		if ( props ) {
			jQuery.extend( this, props );
		}
	
		// Create a timestamp if incoming event doesn't have one
		this.timeStamp = src && src.timeStamp || Date.now();
	
		// Mark it as fixed
		this[ jQuery.expando ] = true;
	};
	
	// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
	// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
	jQuery.Event.prototype = {
		constructor: jQuery.Event,
		isDefaultPrevented: returnFalse,
		isPropagationStopped: returnFalse,
		isImmediatePropagationStopped: returnFalse,
		isSimulated: false,
	
		preventDefault: function() {
			var e = this.originalEvent;
	
			this.isDefaultPrevented = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.preventDefault();
			}
		},
		stopPropagation: function() {
			var e = this.originalEvent;
	
			this.isPropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopPropagation();
			}
		},
		stopImmediatePropagation: function() {
			var e = this.originalEvent;
	
			this.isImmediatePropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopImmediatePropagation();
			}
	
			this.stopPropagation();
		}
	};
	
	// Includes all common event props including KeyEvent and MouseEvent specific props
	jQuery.each( {
		altKey: true,
		bubbles: true,
		cancelable: true,
		changedTouches: true,
		ctrlKey: true,
		detail: true,
		eventPhase: true,
		metaKey: true,
		pageX: true,
		pageY: true,
		shiftKey: true,
		view: true,
		"char": true,
		code: true,
		charCode: true,
		key: true,
		keyCode: true,
		button: true,
		buttons: true,
		clientX: true,
		clientY: true,
		offsetX: true,
		offsetY: true,
		pointerId: true,
		pointerType: true,
		screenX: true,
		screenY: true,
		targetTouches: true,
		toElement: true,
		touches: true,
		which: true
	}, jQuery.event.addProp );
	
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( type, delegateType ) {
	
		function focusMappedHandler( nativeEvent ) {
			if ( document.documentMode ) {
	
				// Support: IE 11+
				// Attach a single focusin/focusout handler on the document while someone wants
				// focus/blur. This is because the former are synchronous in IE while the latter
				// are async. In other browsers, all those handlers are invoked synchronously.
	
				// `handle` from private data would already wrap the event, but we need
				// to change the `type` here.
				var handle = dataPriv.get( this, "handle" ),
					event = jQuery.event.fix( nativeEvent );
				event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
				event.isSimulated = true;
	
				// First, handle focusin/focusout
				handle( nativeEvent );
	
				// ...then, handle focus/blur
				//
				// focus/blur don't bubble while focusin/focusout do; simulate the former by only
				// invoking the handler at the lower level.
				if ( event.target === event.currentTarget ) {
	
					// The setup part calls `leverageNative`, which, in turn, calls
					// `jQuery.event.add`, so event handle will already have been set
					// by this point.
					handle( event );
				}
			} else {
	
				// For non-IE browsers, attach a single capturing handler on the document
				// while someone wants focusin/focusout.
				jQuery.event.simulate( delegateType, nativeEvent.target,
					jQuery.event.fix( nativeEvent ) );
			}
		}
	
		jQuery.event.special[ type ] = {
	
			// Utilize native event if possible so blur/focus sequence is correct
			setup: function() {
	
				var attaches;
	
				// Claim the first handler
				// dataPriv.set( this, "focus", ... )
				// dataPriv.set( this, "blur", ... )
				leverageNative( this, type, true );
	
				if ( document.documentMode ) {
	
					// Support: IE 9 - 11+
					// We use the same native handler for focusin & focus (and focusout & blur)
					// so we need to coordinate setup & teardown parts between those events.
					// Use `delegateType` as the key as `type` is already used by `leverageNative`.
					attaches = dataPriv.get( this, delegateType );
					if ( !attaches ) {
						this.addEventListener( delegateType, focusMappedHandler );
					}
					dataPriv.set( this, delegateType, ( attaches || 0 ) + 1 );
				} else {
	
					// Return false to allow normal processing in the caller
					return false;
				}
			},
			trigger: function() {
	
				// Force setup before trigger
				leverageNative( this, type );
	
				// Return non-false to allow normal event-path propagation
				return true;
			},
	
			teardown: function() {
				var attaches;
	
				if ( document.documentMode ) {
					attaches = dataPriv.get( this, delegateType ) - 1;
					if ( !attaches ) {
						this.removeEventListener( delegateType, focusMappedHandler );
						dataPriv.remove( this, delegateType );
					} else {
						dataPriv.set( this, delegateType, attaches );
					}
				} else {
	
					// Return false to indicate standard teardown should be applied
					return false;
				}
			},
	
			// Suppress native focus or blur if we're currently inside
			// a leveraged native-event stack
			_default: function( event ) {
				return dataPriv.get( event.target, type );
			},
	
			delegateType: delegateType
		};
	
		// Support: Firefox <=44
		// Firefox doesn't have focus(in | out) events
		// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
		//
		// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
		// focus(in | out) events fire after focus & blur events,
		// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
		// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
		//
		// Support: IE 9 - 11+
		// To preserve relative focusin/focus & focusout/blur event order guaranteed on the 3.x branch,
		// attach a single handler for both events in IE.
		jQuery.event.special[ delegateType ] = {
			setup: function() {
	
				// Handle: regular nodes (via `this.ownerDocument`), window
				// (via `this.document`) & document (via `this`).
				var doc = this.ownerDocument || this.document || this,
					dataHolder = document.documentMode ? this : doc,
					attaches = dataPriv.get( dataHolder, delegateType );
	
				// Support: IE 9 - 11+
				// We use the same native handler for focusin & focus (and focusout & blur)
				// so we need to coordinate setup & teardown parts between those events.
				// Use `delegateType` as the key as `type` is already used by `leverageNative`.
				if ( !attaches ) {
					if ( document.documentMode ) {
						this.addEventListener( delegateType, focusMappedHandler );
					} else {
						doc.addEventListener( type, focusMappedHandler, true );
					}
				}
				dataPriv.set( dataHolder, delegateType, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this.document || this,
					dataHolder = document.documentMode ? this : doc,
					attaches = dataPriv.get( dataHolder, delegateType ) - 1;
	
				if ( !attaches ) {
					if ( document.documentMode ) {
						this.removeEventListener( delegateType, focusMappedHandler );
					} else {
						doc.removeEventListener( type, focusMappedHandler, true );
					}
					dataPriv.remove( dataHolder, delegateType );
				} else {
					dataPriv.set( dataHolder, delegateType, attaches );
				}
			}
		};
	} );
	
	// Create mouseenter/leave events using mouseover/out and event-time checks
	// so that event delegation works in jQuery.
	// Do the same for pointerenter/pointerleave and pointerover/pointerout
	//
	// Support: Safari 7 only
	// Safari sends mouseenter too often; see:
	// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
	// for the description of the bug (it existed in older Chrome versions as well).
	jQuery.each( {
		mouseenter: "mouseover",
		mouseleave: "mouseout",
		pointerenter: "pointerover",
		pointerleave: "pointerout"
	}, function( orig, fix ) {
		jQuery.event.special[ orig ] = {
			delegateType: fix,
			bindType: fix,
	
			handle: function( event ) {
				var ret,
					target = this,
					related = event.relatedTarget,
					handleObj = event.handleObj;
	
				// For mouseenter/leave call the handler if related is outside the target.
				// NB: No relatedTarget if the mouse left/entered the browser window
				if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
					event.type = handleObj.origType;
					ret = handleObj.handler.apply( this, arguments );
					event.type = fix;
				}
				return ret;
			}
		};
	} );
	
	jQuery.fn.extend( {
	
		on: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn );
		},
		one: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn, 1 );
		},
		off: function( types, selector, fn ) {
			var handleObj, type;
			if ( types && types.preventDefault && types.handleObj ) {
	
				// ( event )  dispatched jQuery.Event
				handleObj = types.handleObj;
				jQuery( types.delegateTarget ).off(
					handleObj.namespace ?
						handleObj.origType + "." + handleObj.namespace :
						handleObj.origType,
					handleObj.selector,
					handleObj.handler
				);
				return this;
			}
			if ( typeof types === "object" ) {
	
				// ( types-object [, selector] )
				for ( type in types ) {
					this.off( type, selector, types[ type ] );
				}
				return this;
			}
			if ( selector === false || typeof selector === "function" ) {
	
				// ( types [, fn] )
				fn = selector;
				selector = undefined;
			}
			if ( fn === false ) {
				fn = returnFalse;
			}
			return this.each( function() {
				jQuery.event.remove( this, types, fn, selector );
			} );
		}
	} );
	
	
	var
	
		// Support: IE <=10 - 11, Edge 12 - 13 only
		// In IE/Edge using regex groups here causes severe slowdowns.
		// See https://connect.microsoft.com/IE/feedback/details/1736512/
		rnoInnerhtml = /<script|<style|<link/i,
	
		// checked="checked" or checked
		rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	
		rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;
	
	// Prefer a tbody over its parent table for containing new rows
	function manipulationTarget( elem, content ) {
		if ( nodeName( elem, "table" ) &&
			nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {
	
			return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
		}
	
		return elem;
	}
	
	// Replace/restore the type attribute of script elements for safe DOM manipulation
	function disableScript( elem ) {
		elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
		return elem;
	}
	function restoreScript( elem ) {
		if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
			elem.type = elem.type.slice( 5 );
		} else {
			elem.removeAttribute( "type" );
		}
	
		return elem;
	}
	
	function cloneCopyEvent( src, dest ) {
		var i, l, type, pdataOld, udataOld, udataCur, events;
	
		if ( dest.nodeType !== 1 ) {
			return;
		}
	
		// 1. Copy private data: events, handlers, etc.
		if ( dataPriv.hasData( src ) ) {
			pdataOld = dataPriv.get( src );
			events = pdataOld.events;
	
			if ( events ) {
				dataPriv.remove( dest, "handle events" );
	
				for ( type in events ) {
					for ( i = 0, l = events[ type ].length; i < l; i++ ) {
						jQuery.event.add( dest, type, events[ type ][ i ] );
					}
				}
			}
		}
	
		// 2. Copy user data
		if ( dataUser.hasData( src ) ) {
			udataOld = dataUser.access( src );
			udataCur = jQuery.extend( {}, udataOld );
	
			dataUser.set( dest, udataCur );
		}
	}
	
	// Fix IE bugs, see support tests
	function fixInput( src, dest ) {
		var nodeName = dest.nodeName.toLowerCase();
	
		// Fails to persist the checked state of a cloned checkbox or radio button.
		if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
			dest.checked = src.checked;
	
		// Fails to return the selected option to the default selected state when cloning options
		} else if ( nodeName === "input" || nodeName === "textarea" ) {
			dest.defaultValue = src.defaultValue;
		}
	}
	
	function domManip( collection, args, callback, ignored ) {
	
		// Flatten any nested arrays
		args = flat( args );
	
		var fragment, first, scripts, hasScripts, node, doc,
			i = 0,
			l = collection.length,
			iNoClone = l - 1,
			value = args[ 0 ],
			valueIsFunction = isFunction( value );
	
		// We can't cloneNode fragments that contain checked, in WebKit
		if ( valueIsFunction ||
				( l > 1 && typeof value === "string" &&
					!support.checkClone && rchecked.test( value ) ) ) {
			return collection.each( function( index ) {
				var self = collection.eq( index );
				if ( valueIsFunction ) {
					args[ 0 ] = value.call( this, index, self.html() );
				}
				domManip( self, args, callback, ignored );
			} );
		}
	
		if ( l ) {
			fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
			first = fragment.firstChild;
	
			if ( fragment.childNodes.length === 1 ) {
				fragment = first;
			}
	
			// Require either new content or an interest in ignored elements to invoke the callback
			if ( first || ignored ) {
				scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
				hasScripts = scripts.length;
	
				// Use the original fragment for the last item
				// instead of the first because it can end up
				// being emptied incorrectly in certain situations (trac-8070).
				for ( ; i < l; i++ ) {
					node = fragment;
	
					if ( i !== iNoClone ) {
						node = jQuery.clone( node, true, true );
	
						// Keep references to cloned scripts for later restoration
						if ( hasScripts ) {
	
							// Support: Android <=4.0 only, PhantomJS 1 only
							// push.apply(_, arraylike) throws on ancient WebKit
							jQuery.merge( scripts, getAll( node, "script" ) );
						}
					}
	
					callback.call( collection[ i ], node, i );
				}
	
				if ( hasScripts ) {
					doc = scripts[ scripts.length - 1 ].ownerDocument;
	
					// Re-enable scripts
					jQuery.map( scripts, restoreScript );
	
					// Evaluate executable scripts on first document insertion
					for ( i = 0; i < hasScripts; i++ ) {
						node = scripts[ i ];
						if ( rscriptType.test( node.type || "" ) &&
							!dataPriv.access( node, "globalEval" ) &&
							jQuery.contains( doc, node ) ) {
	
							if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {
	
								// Optional AJAX dependency, but won't run scripts if not present
								if ( jQuery._evalUrl && !node.noModule ) {
									jQuery._evalUrl( node.src, {
										nonce: node.nonce || node.getAttribute( "nonce" )
									}, doc );
								}
							} else {
	
								// Unwrap a CDATA section containing script contents. This shouldn't be
								// needed as in XML documents they're already not visible when
								// inspecting element contents and in HTML documents they have no
								// meaning but we're preserving that logic for backwards compatibility.
								// This will be removed completely in 4.0. See gh-4904.
								DOMEval( node.textContent.replace( rcleanScript, "" ), node, doc );
							}
						}
					}
				}
			}
		}
	
		return collection;
	}
	
	function remove( elem, selector, keepData ) {
		var node,
			nodes = selector ? jQuery.filter( selector, elem ) : elem,
			i = 0;
	
		for ( ; ( node = nodes[ i ] ) != null; i++ ) {
			if ( !keepData && node.nodeType === 1 ) {
				jQuery.cleanData( getAll( node ) );
			}
	
			if ( node.parentNode ) {
				if ( keepData && isAttached( node ) ) {
					setGlobalEval( getAll( node, "script" ) );
				}
				node.parentNode.removeChild( node );
			}
		}
	
		return elem;
	}
	
	jQuery.extend( {
		htmlPrefilter: function( html ) {
			return html;
		},
	
		clone: function( elem, dataAndEvents, deepDataAndEvents ) {
			var i, l, srcElements, destElements,
				clone = elem.cloneNode( true ),
				inPage = isAttached( elem );
	
			// Fix IE cloning issues
			if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
					!jQuery.isXMLDoc( elem ) ) {
	
				// We eschew jQuery#find here for performance reasons:
				// https://jsperf.com/getall-vs-sizzle/2
				destElements = getAll( clone );
				srcElements = getAll( elem );
	
				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					fixInput( srcElements[ i ], destElements[ i ] );
				}
			}
	
			// Copy the events from the original to the clone
			if ( dataAndEvents ) {
				if ( deepDataAndEvents ) {
					srcElements = srcElements || getAll( elem );
					destElements = destElements || getAll( clone );
	
					for ( i = 0, l = srcElements.length; i < l; i++ ) {
						cloneCopyEvent( srcElements[ i ], destElements[ i ] );
					}
				} else {
					cloneCopyEvent( elem, clone );
				}
			}
	
			// Preserve script evaluation history
			destElements = getAll( clone, "script" );
			if ( destElements.length > 0 ) {
				setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
			}
	
			// Return the cloned set
			return clone;
		},
	
		cleanData: function( elems ) {
			var data, elem, type,
				special = jQuery.event.special,
				i = 0;
	
			for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
				if ( acceptData( elem ) ) {
					if ( ( data = elem[ dataPriv.expando ] ) ) {
						if ( data.events ) {
							for ( type in data.events ) {
								if ( special[ type ] ) {
									jQuery.event.remove( elem, type );
	
								// This is a shortcut to avoid jQuery.event.remove's overhead
								} else {
									jQuery.removeEvent( elem, type, data.handle );
								}
							}
						}
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataPriv.expando ] = undefined;
					}
					if ( elem[ dataUser.expando ] ) {
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataUser.expando ] = undefined;
					}
				}
			}
		}
	} );
	
	jQuery.fn.extend( {
		detach: function( selector ) {
			return remove( this, selector, true );
		},
	
		remove: function( selector ) {
			return remove( this, selector );
		},
	
		text: function( value ) {
			return access( this, function( value ) {
				return value === undefined ?
					jQuery.text( this ) :
					this.empty().each( function() {
						if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
							this.textContent = value;
						}
					} );
			}, null, value, arguments.length );
		},
	
		append: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.appendChild( elem );
				}
			} );
		},
	
		prepend: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.insertBefore( elem, target.firstChild );
				}
			} );
		},
	
		before: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this );
				}
			} );
		},
	
		after: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this.nextSibling );
				}
			} );
		},
	
		empty: function() {
			var elem,
				i = 0;
	
			for ( ; ( elem = this[ i ] ) != null; i++ ) {
				if ( elem.nodeType === 1 ) {
	
					// Prevent memory leaks
					jQuery.cleanData( getAll( elem, false ) );
	
					// Remove any remaining nodes
					elem.textContent = "";
				}
			}
	
			return this;
		},
	
		clone: function( dataAndEvents, deepDataAndEvents ) {
			dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
			deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
	
			return this.map( function() {
				return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
			} );
		},
	
		html: function( value ) {
			return access( this, function( value ) {
				var elem = this[ 0 ] || {},
					i = 0,
					l = this.length;
	
				if ( value === undefined && elem.nodeType === 1 ) {
					return elem.innerHTML;
				}
	
				// See if we can take a shortcut and just use innerHTML
				if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
					!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {
	
					value = jQuery.htmlPrefilter( value );
	
					try {
						for ( ; i < l; i++ ) {
							elem = this[ i ] || {};
	
							// Remove element nodes and prevent memory leaks
							if ( elem.nodeType === 1 ) {
								jQuery.cleanData( getAll( elem, false ) );
								elem.innerHTML = value;
							}
						}
	
						elem = 0;
	
					// If using innerHTML throws an exception, use the fallback method
					} catch ( e ) {}
				}
	
				if ( elem ) {
					this.empty().append( value );
				}
			}, null, value, arguments.length );
		},
	
		replaceWith: function() {
			var ignored = [];
	
			// Make the changes, replacing each non-ignored context element with the new content
			return domManip( this, arguments, function( elem ) {
				var parent = this.parentNode;
	
				if ( jQuery.inArray( this, ignored ) < 0 ) {
					jQuery.cleanData( getAll( this ) );
					if ( parent ) {
						parent.replaceChild( elem, this );
					}
				}
	
			// Force callback invocation
			}, ignored );
		}
	} );
	
	jQuery.each( {
		appendTo: "append",
		prependTo: "prepend",
		insertBefore: "before",
		insertAfter: "after",
		replaceAll: "replaceWith"
	}, function( name, original ) {
		jQuery.fn[ name ] = function( selector ) {
			var elems,
				ret = [],
				insert = jQuery( selector ),
				last = insert.length - 1,
				i = 0;
	
			for ( ; i <= last; i++ ) {
				elems = i === last ? this : this.clone( true );
				jQuery( insert[ i ] )[ original ]( elems );
	
				// Support: Android <=4.0 only, PhantomJS 1 only
				// .get() because push.apply(_, arraylike) throws on ancient WebKit
				push.apply( ret, elems.get() );
			}
	
			return this.pushStack( ret );
		};
	} );
	var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );
	
	var rcustomProp = /^--/;
	
	
	var getStyles = function( elem ) {
	
			// Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
			// IE throws on elements created in popups
			// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
			var view = elem.ownerDocument.defaultView;
	
			if ( !view || !view.opener ) {
				view = window;
			}
	
			return view.getComputedStyle( elem );
		};
	
	var swap = function( elem, options, callback ) {
		var ret, name,
			old = {};
	
		// Remember the old values, and insert the new ones
		for ( name in options ) {
			old[ name ] = elem.style[ name ];
			elem.style[ name ] = options[ name ];
		}
	
		ret = callback.call( elem );
	
		// Revert the old values
		for ( name in options ) {
			elem.style[ name ] = old[ name ];
		}
	
		return ret;
	};
	
	
	var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );
	
	
	
	( function() {
	
		// Executing both pixelPosition & boxSizingReliable tests require only one layout
		// so they're executed at the same time to save the second computation.
		function computeStyleTests() {
	
			// This is a singleton, we need to execute it only once
			if ( !div ) {
				return;
			}
	
			container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
				"margin-top:1px;padding:0;border:0";
			div.style.cssText =
				"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
				"margin:auto;border:1px;padding:1px;" +
				"width:60%;top:1%";
			documentElement.appendChild( container ).appendChild( div );
	
			var divStyle = window.getComputedStyle( div );
			pixelPositionVal = divStyle.top !== "1%";
	
			// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
			reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;
	
			// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
			// Some styles come back with percentage values, even though they shouldn't
			div.style.right = "60%";
			pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;
	
			// Support: IE 9 - 11 only
			// Detect misreporting of content dimensions for box-sizing:border-box elements
			boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;
	
			// Support: IE 9 only
			// Detect overflow:scroll screwiness (gh-3699)
			// Support: Chrome <=64
			// Don't get tricked when zoom affects offsetWidth (gh-4029)
			div.style.position = "absolute";
			scrollboxSizeVal = roundPixelMeasures( div.offsetWidth / 3 ) === 12;
	
			documentElement.removeChild( container );
	
			// Nullify the div so it wouldn't be stored in the memory and
			// it will also be a sign that checks already performed
			div = null;
		}
	
		function roundPixelMeasures( measure ) {
			return Math.round( parseFloat( measure ) );
		}
	
		var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
			reliableTrDimensionsVal, reliableMarginLeftVal,
			container = document.createElement( "div" ),
			div = document.createElement( "div" );
	
		// Finish early in limited (non-browser) environments
		if ( !div.style ) {
			return;
		}
	
		// Support: IE <=9 - 11 only
		// Style of cloned element affects source element cloned (trac-8908)
		div.style.backgroundClip = "content-box";
		div.cloneNode( true ).style.backgroundClip = "";
		support.clearCloneStyle = div.style.backgroundClip === "content-box";
	
		jQuery.extend( support, {
			boxSizingReliable: function() {
				computeStyleTests();
				return boxSizingReliableVal;
			},
			pixelBoxStyles: function() {
				computeStyleTests();
				return pixelBoxStylesVal;
			},
			pixelPosition: function() {
				computeStyleTests();
				return pixelPositionVal;
			},
			reliableMarginLeft: function() {
				computeStyleTests();
				return reliableMarginLeftVal;
			},
			scrollboxSize: function() {
				computeStyleTests();
				return scrollboxSizeVal;
			},
	
			// Support: IE 9 - 11+, Edge 15 - 18+
			// IE/Edge misreport `getComputedStyle` of table rows with width/height
			// set in CSS while `offset*` properties report correct values.
			// Behavior in IE 9 is more subtle than in newer versions & it passes
			// some versions of this test; make sure not to make it pass there!
			//
			// Support: Firefox 70+
			// Only Firefox includes border widths
			// in computed dimensions. (gh-4529)
			reliableTrDimensions: function() {
				var table, tr, trChild, trStyle;
				if ( reliableTrDimensionsVal == null ) {
					table = document.createElement( "table" );
					tr = document.createElement( "tr" );
					trChild = document.createElement( "div" );
	
					table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
					tr.style.cssText = "box-sizing:content-box;border:1px solid";
	
					// Support: Chrome 86+
					// Height set through cssText does not get applied.
					// Computed height then comes back as 0.
					tr.style.height = "1px";
					trChild.style.height = "9px";
	
					// Support: Android 8 Chrome 86+
					// In our bodyBackground.html iframe,
					// display for all div elements is set to "inline",
					// which causes a problem only in Android 8 Chrome 86.
					// Ensuring the div is `display: block`
					// gets around this issue.
					trChild.style.display = "block";
	
					documentElement
						.appendChild( table )
						.appendChild( tr )
						.appendChild( trChild );
	
					trStyle = window.getComputedStyle( tr );
					reliableTrDimensionsVal = ( parseInt( trStyle.height, 10 ) +
						parseInt( trStyle.borderTopWidth, 10 ) +
						parseInt( trStyle.borderBottomWidth, 10 ) ) === tr.offsetHeight;
	
					documentElement.removeChild( table );
				}
				return reliableTrDimensionsVal;
			}
		} );
	} )();
	
	
	function curCSS( elem, name, computed ) {
		var width, minWidth, maxWidth, ret,
			isCustomProp = rcustomProp.test( name ),
	
			// Support: Firefox 51+
			// Retrieving style before computed somehow
			// fixes an issue with getting wrong values
			// on detached elements
			style = elem.style;
	
		computed = computed || getStyles( elem );
	
		// getPropertyValue is needed for:
		//   .css('filter') (IE 9 only, trac-12537)
		//   .css('--customProperty) (gh-3144)
		if ( computed ) {
	
			// Support: IE <=9 - 11+
			// IE only supports `"float"` in `getPropertyValue`; in computed styles
			// it's only available as `"cssFloat"`. We no longer modify properties
			// sent to `.css()` apart from camelCasing, so we need to check both.
			// Normally, this would create difference in behavior: if
			// `getPropertyValue` returns an empty string, the value returned
			// by `.css()` would be `undefined`. This is usually the case for
			// disconnected elements. However, in IE even disconnected elements
			// with no styles return `"none"` for `getPropertyValue( "float" )`
			ret = computed.getPropertyValue( name ) || computed[ name ];
	
			if ( isCustomProp && ret ) {
	
				// Support: Firefox 105+, Chrome <=105+
				// Spec requires trimming whitespace for custom properties (gh-4926).
				// Firefox only trims leading whitespace. Chrome just collapses
				// both leading & trailing whitespace to a single space.
				//
				// Fall back to `undefined` if empty string returned.
				// This collapses a missing definition with property defined
				// and set to an empty string but there's no standard API
				// allowing us to differentiate them without a performance penalty
				// and returning `undefined` aligns with older jQuery.
				//
				// rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
				// as whitespace while CSS does not, but this is not a problem
				// because CSS preprocessing replaces them with U+000A LINE FEED
				// (which *is* CSS whitespace)
				// https://www.w3.org/TR/css-syntax-3/#input-preprocessing
				ret = ret.replace( rtrimCSS, "$1" ) || undefined;
			}
	
			if ( ret === "" && !isAttached( elem ) ) {
				ret = jQuery.style( elem, name );
			}
	
			// A tribute to the "awesome hack by Dean Edwards"
			// Android Browser returns percentage for some values,
			// but width seems to be reliably pixels.
			// This is against the CSSOM draft spec:
			// https://drafts.csswg.org/cssom/#resolved-values
			if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {
	
				// Remember the original values
				width = style.width;
				minWidth = style.minWidth;
				maxWidth = style.maxWidth;
	
				// Put in the new values to get a computed value out
				style.minWidth = style.maxWidth = style.width = ret;
				ret = computed.width;
	
				// Revert the changed values
				style.width = width;
				style.minWidth = minWidth;
				style.maxWidth = maxWidth;
			}
		}
	
		return ret !== undefined ?
	
			// Support: IE <=9 - 11 only
			// IE returns zIndex value as an integer.
			ret + "" :
			ret;
	}
	
	
	function addGetHookIf( conditionFn, hookFn ) {
	
		// Define the hook, we'll check on the first run if it's really needed.
		return {
			get: function() {
				if ( conditionFn() ) {
	
					// Hook not needed (or it's not possible to use it due
					// to missing dependency), remove it.
					delete this.get;
					return;
				}
	
				// Hook needed; redefine it so that the support test is not executed again.
				return ( this.get = hookFn ).apply( this, arguments );
			}
		};
	}
	
	
	var cssPrefixes = [ "Webkit", "Moz", "ms" ],
		emptyStyle = document.createElement( "div" ).style,
		vendorProps = {};
	
	// Return a vendor-prefixed property or undefined
	function vendorPropName( name ) {
	
		// Check for vendor prefixed names
		var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
			i = cssPrefixes.length;
	
		while ( i-- ) {
			name = cssPrefixes[ i ] + capName;
			if ( name in emptyStyle ) {
				return name;
			}
		}
	}
	
	// Return a potentially-mapped jQuery.cssProps or vendor prefixed property
	function finalPropName( name ) {
		var final = jQuery.cssProps[ name ] || vendorProps[ name ];
	
		if ( final ) {
			return final;
		}
		if ( name in emptyStyle ) {
			return name;
		}
		return vendorProps[ name ] = vendorPropName( name ) || name;
	}
	
	
	var
	
		// Swappable if display is none or starts with table
		// except "table", "table-cell", or "table-caption"
		// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
		rdisplayswap = /^(none|table(?!-c[ea]).+)/,
		cssShow = { position: "absolute", visibility: "hidden", display: "block" },
		cssNormalTransform = {
			letterSpacing: "0",
			fontWeight: "400"
		};
	
	function setPositiveNumber( _elem, value, subtract ) {
	
		// Any relative (+/-) values have already been
		// normalized at this point
		var matches = rcssNum.exec( value );
		return matches ?
	
			// Guard against undefined "subtract", e.g., when used as in cssHooks
			Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
			value;
	}
	
	function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
		var i = dimension === "width" ? 1 : 0,
			extra = 0,
			delta = 0,
			marginDelta = 0;
	
		// Adjustment may not be necessary
		if ( box === ( isBorderBox ? "border" : "content" ) ) {
			return 0;
		}
	
		for ( ; i < 4; i += 2 ) {
	
			// Both box models exclude margin
			// Count margin delta separately to only add it after scroll gutter adjustment.
			// This is needed to make negative margins work with `outerHeight( true )` (gh-3982).
			if ( box === "margin" ) {
				marginDelta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
			}
	
			// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
			if ( !isBorderBox ) {
	
				// Add padding
				delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
	
				// For "border" or "margin", add border
				if ( box !== "padding" ) {
					delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
	
				// But still keep track of it otherwise
				} else {
					extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
	
			// If we get here with a border-box (content + padding + border), we're seeking "content" or
			// "padding" or "margin"
			} else {
	
				// For "content", subtract padding
				if ( box === "content" ) {
					delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
				}
	
				// For "content" or "padding", subtract border
				if ( box !== "margin" ) {
					delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			}
		}
	
		// Account for positive content-box scroll gutter when requested by providing computedVal
		if ( !isBorderBox && computedVal >= 0 ) {
	
			// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
			// Assuming integer scroll gutter, subtract the rest and round down
			delta += Math.max( 0, Math.ceil(
				elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
				computedVal -
				delta -
				extra -
				0.5
	
			// If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
			// Use an explicit zero to avoid NaN (gh-3964)
			) ) || 0;
		}
	
		return delta + marginDelta;
	}
	
	function getWidthOrHeight( elem, dimension, extra ) {
	
		// Start with computed style
		var styles = getStyles( elem ),
	
			// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
			// Fake content-box until we know it's needed to know the true value.
			boxSizingNeeded = !support.boxSizingReliable() || extra,
			isBorderBox = boxSizingNeeded &&
				jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
			valueIsBorderBox = isBorderBox,
	
			val = curCSS( elem, dimension, styles ),
			offsetProp = "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 );
	
		// Support: Firefox <=54
		// Return a confounding non-pixel value or feign ignorance, as appropriate.
		if ( rnumnonpx.test( val ) ) {
			if ( !extra ) {
				return val;
			}
			val = "auto";
		}
	
	
		// Support: IE 9 - 11 only
		// Use offsetWidth/offsetHeight for when box sizing is unreliable.
		// In those cases, the computed value can be trusted to be border-box.
		if ( ( !support.boxSizingReliable() && isBorderBox ||
	
			// Support: IE 10 - 11+, Edge 15 - 18+
			// IE/Edge misreport `getComputedStyle` of table rows with width/height
			// set in CSS while `offset*` properties report correct values.
			// Interestingly, in some cases IE 9 doesn't suffer from this issue.
			!support.reliableTrDimensions() && nodeName( elem, "tr" ) ||
	
			// Fall back to offsetWidth/offsetHeight when value is "auto"
			// This happens for inline elements with no explicit setting (gh-3571)
			val === "auto" ||
	
			// Support: Android <=4.1 - 4.3 only
			// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
			!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) &&
	
			// Make sure the element is visible & connected
			elem.getClientRects().length ) {
	
			isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";
	
			// Where available, offsetWidth/offsetHeight approximate border box dimensions.
			// Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
			// retrieved value as a content box dimension.
			valueIsBorderBox = offsetProp in elem;
			if ( valueIsBorderBox ) {
				val = elem[ offsetProp ];
			}
		}
	
		// Normalize "" and auto
		val = parseFloat( val ) || 0;
	
		// Adjust for the element's box model
		return ( val +
			boxModelAdjustment(
				elem,
				dimension,
				extra || ( isBorderBox ? "border" : "content" ),
				valueIsBorderBox,
				styles,
	
				// Provide the current computed size to request scroll gutter calculation (gh-3589)
				val
			)
		) + "px";
	}
	
	jQuery.extend( {
	
		// Add in style property hooks for overriding the default
		// behavior of getting and setting a style property
		cssHooks: {
			opacity: {
				get: function( elem, computed ) {
					if ( computed ) {
	
						// We should always get a number back from opacity
						var ret = curCSS( elem, "opacity" );
						return ret === "" ? "1" : ret;
					}
				}
			}
		},
	
		// Don't automatically add "px" to these possibly-unitless properties
		cssNumber: {
			animationIterationCount: true,
			aspectRatio: true,
			borderImageSlice: true,
			columnCount: true,
			flexGrow: true,
			flexShrink: true,
			fontWeight: true,
			gridArea: true,
			gridColumn: true,
			gridColumnEnd: true,
			gridColumnStart: true,
			gridRow: true,
			gridRowEnd: true,
			gridRowStart: true,
			lineHeight: true,
			opacity: true,
			order: true,
			orphans: true,
			scale: true,
			widows: true,
			zIndex: true,
			zoom: true,
	
			// SVG-related
			fillOpacity: true,
			floodOpacity: true,
			stopOpacity: true,
			strokeMiterlimit: true,
			strokeOpacity: true
		},
	
		// Add in properties whose names you wish to fix before
		// setting or getting the value
		cssProps: {},
	
		// Get and set the style property on a DOM Node
		style: function( elem, name, value, extra ) {
	
			// Don't set styles on text and comment nodes
			if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
				return;
			}
	
			// Make sure that we're working with the right name
			var ret, type, hooks,
				origName = camelCase( name ),
				isCustomProp = rcustomProp.test( name ),
				style = elem.style;
	
			// Make sure that we're working with the right name. We don't
			// want to query the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}
	
			// Gets hook for the prefixed version, then unprefixed version
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// Check if we're setting a value
			if ( value !== undefined ) {
				type = typeof value;
	
				// Convert "+=" or "-=" to relative numbers (trac-7345)
				if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
					value = adjustCSS( elem, name, ret );
	
					// Fixes bug trac-9237
					type = "number";
				}
	
				// Make sure that null and NaN values aren't set (trac-7116)
				if ( value == null || value !== value ) {
					return;
				}
	
				// If a number was passed in, add the unit (except for certain CSS properties)
				// The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
				// "px" to a few hardcoded values.
				if ( type === "number" && !isCustomProp ) {
					value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
				}
	
				// background-* props affect original clone's values
				if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
					style[ name ] = "inherit";
				}
	
				// If a hook was provided, use that value, otherwise just set the specified value
				if ( !hooks || !( "set" in hooks ) ||
					( value = hooks.set( elem, value, extra ) ) !== undefined ) {
	
					if ( isCustomProp ) {
						style.setProperty( name, value );
					} else {
						style[ name ] = value;
					}
				}
	
			} else {
	
				// If a hook was provided get the non-computed value from there
				if ( hooks && "get" in hooks &&
					( ret = hooks.get( elem, false, extra ) ) !== undefined ) {
	
					return ret;
				}
	
				// Otherwise just get the value from the style object
				return style[ name ];
			}
		},
	
		css: function( elem, name, extra, styles ) {
			var val, num, hooks,
				origName = camelCase( name ),
				isCustomProp = rcustomProp.test( name );
	
			// Make sure that we're working with the right name. We don't
			// want to modify the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}
	
			// Try prefixed name followed by the unprefixed name
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// If a hook was provided get the computed value from there
			if ( hooks && "get" in hooks ) {
				val = hooks.get( elem, true, extra );
			}
	
			// Otherwise, if a way to get the computed value exists, use that
			if ( val === undefined ) {
				val = curCSS( elem, name, styles );
			}
	
			// Convert "normal" to computed value
			if ( val === "normal" && name in cssNormalTransform ) {
				val = cssNormalTransform[ name ];
			}
	
			// Make numeric if forced or a qualifier was provided and val looks numeric
			if ( extra === "" || extra ) {
				num = parseFloat( val );
				return extra === true || isFinite( num ) ? num || 0 : val;
			}
	
			return val;
		}
	} );
	
	jQuery.each( [ "height", "width" ], function( _i, dimension ) {
		jQuery.cssHooks[ dimension ] = {
			get: function( elem, computed, extra ) {
				if ( computed ) {
	
					// Certain elements can have dimension info if we invisibly show them
					// but it must have a current display style that would benefit
					return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&
	
						// Support: Safari 8+
						// Table columns in Safari have non-zero offsetWidth & zero
						// getBoundingClientRect().width unless display is changed.
						// Support: IE <=11 only
						// Running getBoundingClientRect on a disconnected node
						// in IE throws an error.
						( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
						swap( elem, cssShow, function() {
							return getWidthOrHeight( elem, dimension, extra );
						} ) :
						getWidthOrHeight( elem, dimension, extra );
				}
			},
	
			set: function( elem, value, extra ) {
				var matches,
					styles = getStyles( elem ),
	
					// Only read styles.position if the test has a chance to fail
					// to avoid forcing a reflow.
					scrollboxSizeBuggy = !support.scrollboxSize() &&
						styles.position === "absolute",
	
					// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
					boxSizingNeeded = scrollboxSizeBuggy || extra,
					isBorderBox = boxSizingNeeded &&
						jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
					subtract = extra ?
						boxModelAdjustment(
							elem,
							dimension,
							extra,
							isBorderBox,
							styles
						) :
						0;
	
				// Account for unreliable border-box dimensions by comparing offset* to computed and
				// faking a content-box to get border and padding (gh-3699)
				if ( isBorderBox && scrollboxSizeBuggy ) {
					subtract -= Math.ceil(
						elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
						parseFloat( styles[ dimension ] ) -
						boxModelAdjustment( elem, dimension, "border", false, styles ) -
						0.5
					);
				}
	
				// Convert to pixels if value adjustment is needed
				if ( subtract && ( matches = rcssNum.exec( value ) ) &&
					( matches[ 3 ] || "px" ) !== "px" ) {
	
					elem.style[ dimension ] = value;
					value = jQuery.css( elem, dimension );
				}
	
				return setPositiveNumber( elem, value, subtract );
			}
		};
	} );
	
	jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
		function( elem, computed ) {
			if ( computed ) {
				return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
					elem.getBoundingClientRect().left -
						swap( elem, { marginLeft: 0 }, function() {
							return elem.getBoundingClientRect().left;
						} )
				) + "px";
			}
		}
	);
	
	// These hooks are used by animate to expand properties
	jQuery.each( {
		margin: "",
		padding: "",
		border: "Width"
	}, function( prefix, suffix ) {
		jQuery.cssHooks[ prefix + suffix ] = {
			expand: function( value ) {
				var i = 0,
					expanded = {},
	
					// Assumes a single number if not a string
					parts = typeof value === "string" ? value.split( " " ) : [ value ];
	
				for ( ; i < 4; i++ ) {
					expanded[ prefix + cssExpand[ i ] + suffix ] =
						parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
				}
	
				return expanded;
			}
		};
	
		if ( prefix !== "margin" ) {
			jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
		}
	} );
	
	jQuery.fn.extend( {
		css: function( name, value ) {
			return access( this, function( elem, name, value ) {
				var styles, len,
					map = {},
					i = 0;
	
				if ( Array.isArray( name ) ) {
					styles = getStyles( elem );
					len = name.length;
	
					for ( ; i < len; i++ ) {
						map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
					}
	
					return map;
				}
	
				return value !== undefined ?
					jQuery.style( elem, name, value ) :
					jQuery.css( elem, name );
			}, name, value, arguments.length > 1 );
		}
	} );
	
	
	function Tween( elem, options, prop, end, easing ) {
		return new Tween.prototype.init( elem, options, prop, end, easing );
	}
	jQuery.Tween = Tween;
	
	Tween.prototype = {
		constructor: Tween,
		init: function( elem, options, prop, end, easing, unit ) {
			this.elem = elem;
			this.prop = prop;
			this.easing = easing || jQuery.easing._default;
			this.options = options;
			this.start = this.now = this.cur();
			this.end = end;
			this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
		},
		cur: function() {
			var hooks = Tween.propHooks[ this.prop ];
	
			return hooks && hooks.get ?
				hooks.get( this ) :
				Tween.propHooks._default.get( this );
		},
		run: function( percent ) {
			var eased,
				hooks = Tween.propHooks[ this.prop ];
	
			if ( this.options.duration ) {
				this.pos = eased = jQuery.easing[ this.easing ](
					percent, this.options.duration * percent, 0, 1, this.options.duration
				);
			} else {
				this.pos = eased = percent;
			}
			this.now = ( this.end - this.start ) * eased + this.start;
	
			if ( this.options.step ) {
				this.options.step.call( this.elem, this.now, this );
			}
	
			if ( hooks && hooks.set ) {
				hooks.set( this );
			} else {
				Tween.propHooks._default.set( this );
			}
			return this;
		}
	};
	
	Tween.prototype.init.prototype = Tween.prototype;
	
	Tween.propHooks = {
		_default: {
			get: function( tween ) {
				var result;
	
				// Use a property on the element directly when it is not a DOM element,
				// or when there is no matching style property that exists.
				if ( tween.elem.nodeType !== 1 ||
					tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
					return tween.elem[ tween.prop ];
				}
	
				// Passing an empty string as a 3rd parameter to .css will automatically
				// attempt a parseFloat and fallback to a string if the parse fails.
				// Simple values such as "10px" are parsed to Float;
				// complex values such as "rotate(1rad)" are returned as-is.
				result = jQuery.css( tween.elem, tween.prop, "" );
	
				// Empty strings, null, undefined and "auto" are converted to 0.
				return !result || result === "auto" ? 0 : result;
			},
			set: function( tween ) {
	
				// Use step hook for back compat.
				// Use cssHook if its there.
				// Use .style if available and use plain properties where available.
				if ( jQuery.fx.step[ tween.prop ] ) {
					jQuery.fx.step[ tween.prop ]( tween );
				} else if ( tween.elem.nodeType === 1 && (
					jQuery.cssHooks[ tween.prop ] ||
						tween.elem.style[ finalPropName( tween.prop ) ] != null ) ) {
					jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
				} else {
					tween.elem[ tween.prop ] = tween.now;
				}
			}
		}
	};
	
	// Support: IE <=9 only
	// Panic based approach to setting things on disconnected nodes
	Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
		set: function( tween ) {
			if ( tween.elem.nodeType && tween.elem.parentNode ) {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	};
	
	jQuery.easing = {
		linear: function( p ) {
			return p;
		},
		swing: function( p ) {
			return 0.5 - Math.cos( p * Math.PI ) / 2;
		},
		_default: "swing"
	};
	
	jQuery.fx = Tween.prototype.init;
	
	// Back compat <1.8 extension point
	jQuery.fx.step = {};
	
	
	
	
	var
		fxNow, inProgress,
		rfxtypes = /^(?:toggle|show|hide)$/,
		rrun = /queueHooks$/;
	
	function schedule() {
		if ( inProgress ) {
			if ( document.hidden === false && window.requestAnimationFrame ) {
				window.requestAnimationFrame( schedule );
			} else {
				window.setTimeout( schedule, jQuery.fx.interval );
			}
	
			jQuery.fx.tick();
		}
	}
	
	// Animations created synchronously will run synchronously
	function createFxNow() {
		window.setTimeout( function() {
			fxNow = undefined;
		} );
		return ( fxNow = Date.now() );
	}
	
	// Generate parameters to create a standard animation
	function genFx( type, includeWidth ) {
		var which,
			i = 0,
			attrs = { height: type };
	
		// If we include width, step value is 1 to do all cssExpand values,
		// otherwise step value is 2 to skip over Left and Right
		includeWidth = includeWidth ? 1 : 0;
		for ( ; i < 4; i += 2 - includeWidth ) {
			which = cssExpand[ i ];
			attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
		}
	
		if ( includeWidth ) {
			attrs.opacity = attrs.width = type;
		}
	
		return attrs;
	}
	
	function createTween( value, prop, animation ) {
		var tween,
			collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
			index = 0,
			length = collection.length;
		for ( ; index < length; index++ ) {
			if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {
	
				// We're done with this property
				return tween;
			}
		}
	}
	
	function defaultPrefilter( elem, props, opts ) {
		var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
			isBox = "width" in props || "height" in props,
			anim = this,
			orig = {},
			style = elem.style,
			hidden = elem.nodeType && isHiddenWithinTree( elem ),
			dataShow = dataPriv.get( elem, "fxshow" );
	
		// Queue-skipping animations hijack the fx hooks
		if ( !opts.queue ) {
			hooks = jQuery._queueHooks( elem, "fx" );
			if ( hooks.unqueued == null ) {
				hooks.unqueued = 0;
				oldfire = hooks.empty.fire;
				hooks.empty.fire = function() {
					if ( !hooks.unqueued ) {
						oldfire();
					}
				};
			}
			hooks.unqueued++;
	
			anim.always( function() {
	
				// Ensure the complete handler is called before this completes
				anim.always( function() {
					hooks.unqueued--;
					if ( !jQuery.queue( elem, "fx" ).length ) {
						hooks.empty.fire();
					}
				} );
			} );
		}
	
		// Detect show/hide animations
		for ( prop in props ) {
			value = props[ prop ];
			if ( rfxtypes.test( value ) ) {
				delete props[ prop ];
				toggle = toggle || value === "toggle";
				if ( value === ( hidden ? "hide" : "show" ) ) {
	
					// Pretend to be hidden if this is a "show" and
					// there is still data from a stopped show/hide
					if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
						hidden = true;
	
					// Ignore all other no-op show/hide data
					} else {
						continue;
					}
				}
				orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
			}
		}
	
		// Bail out if this is a no-op like .hide().hide()
		propTween = !jQuery.isEmptyObject( props );
		if ( !propTween && jQuery.isEmptyObject( orig ) ) {
			return;
		}
	
		// Restrict "overflow" and "display" styles during box animations
		if ( isBox && elem.nodeType === 1 ) {
	
			// Support: IE <=9 - 11, Edge 12 - 15
			// Record all 3 overflow attributes because IE does not infer the shorthand
			// from identically-valued overflowX and overflowY and Edge just mirrors
			// the overflowX value there.
			opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];
	
			// Identify a display type, preferring old show/hide data over the CSS cascade
			restoreDisplay = dataShow && dataShow.display;
			if ( restoreDisplay == null ) {
				restoreDisplay = dataPriv.get( elem, "display" );
			}
			display = jQuery.css( elem, "display" );
			if ( display === "none" ) {
				if ( restoreDisplay ) {
					display = restoreDisplay;
				} else {
	
					// Get nonempty value(s) by temporarily forcing visibility
					showHide( [ elem ], true );
					restoreDisplay = elem.style.display || restoreDisplay;
					display = jQuery.css( elem, "display" );
					showHide( [ elem ] );
				}
			}
	
			// Animate inline elements as inline-block
			if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
				if ( jQuery.css( elem, "float" ) === "none" ) {
	
					// Restore the original display value at the end of pure show/hide animations
					if ( !propTween ) {
						anim.done( function() {
							style.display = restoreDisplay;
						} );
						if ( restoreDisplay == null ) {
							display = style.display;
							restoreDisplay = display === "none" ? "" : display;
						}
					}
					style.display = "inline-block";
				}
			}
		}
	
		if ( opts.overflow ) {
			style.overflow = "hidden";
			anim.always( function() {
				style.overflow = opts.overflow[ 0 ];
				style.overflowX = opts.overflow[ 1 ];
				style.overflowY = opts.overflow[ 2 ];
			} );
		}
	
		// Implement show/hide animations
		propTween = false;
		for ( prop in orig ) {
	
			// General show/hide setup for this element animation
			if ( !propTween ) {
				if ( dataShow ) {
					if ( "hidden" in dataShow ) {
						hidden = dataShow.hidden;
					}
				} else {
					dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
				}
	
				// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
				if ( toggle ) {
					dataShow.hidden = !hidden;
				}
	
				// Show elements before animating them
				if ( hidden ) {
					showHide( [ elem ], true );
				}
	
				/* eslint-disable no-loop-func */
	
				anim.done( function() {
	
					/* eslint-enable no-loop-func */
	
					// The final step of a "hide" animation is actually hiding the element
					if ( !hidden ) {
						showHide( [ elem ] );
					}
					dataPriv.remove( elem, "fxshow" );
					for ( prop in orig ) {
						jQuery.style( elem, prop, orig[ prop ] );
					}
				} );
			}
	
			// Per-property setup
			propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
			if ( !( prop in dataShow ) ) {
				dataShow[ prop ] = propTween.start;
				if ( hidden ) {
					propTween.end = propTween.start;
					propTween.start = 0;
				}
			}
		}
	}
	
	function propFilter( props, specialEasing ) {
		var index, name, easing, value, hooks;
	
		// camelCase, specialEasing and expand cssHook pass
		for ( index in props ) {
			name = camelCase( index );
			easing = specialEasing[ name ];
			value = props[ index ];
			if ( Array.isArray( value ) ) {
				easing = value[ 1 ];
				value = props[ index ] = value[ 0 ];
			}
	
			if ( index !== name ) {
				props[ name ] = value;
				delete props[ index ];
			}
	
			hooks = jQuery.cssHooks[ name ];
			if ( hooks && "expand" in hooks ) {
				value = hooks.expand( value );
				delete props[ name ];
	
				// Not quite $.extend, this won't overwrite existing keys.
				// Reusing 'index' because we have the correct "name"
				for ( index in value ) {
					if ( !( index in props ) ) {
						props[ index ] = value[ index ];
						specialEasing[ index ] = easing;
					}
				}
			} else {
				specialEasing[ name ] = easing;
			}
		}
	}
	
	function Animation( elem, properties, options ) {
		var result,
			stopped,
			index = 0,
			length = Animation.prefilters.length,
			deferred = jQuery.Deferred().always( function() {
	
				// Don't match elem in the :animated selector
				delete tick.elem;
			} ),
			tick = function() {
				if ( stopped ) {
					return false;
				}
				var currentTime = fxNow || createFxNow(),
					remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),
	
					// Support: Android 2.3 only
					// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
					temp = remaining / animation.duration || 0,
					percent = 1 - temp,
					index = 0,
					length = animation.tweens.length;
	
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( percent );
				}
	
				deferred.notifyWith( elem, [ animation, percent, remaining ] );
	
				// If there's more to do, yield
				if ( percent < 1 && length ) {
					return remaining;
				}
	
				// If this was an empty animation, synthesize a final progress notification
				if ( !length ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
				}
	
				// Resolve the animation and report its conclusion
				deferred.resolveWith( elem, [ animation ] );
				return false;
			},
			animation = deferred.promise( {
				elem: elem,
				props: jQuery.extend( {}, properties ),
				opts: jQuery.extend( true, {
					specialEasing: {},
					easing: jQuery.easing._default
				}, options ),
				originalProperties: properties,
				originalOptions: options,
				startTime: fxNow || createFxNow(),
				duration: options.duration,
				tweens: [],
				createTween: function( prop, end ) {
					var tween = jQuery.Tween( elem, animation.opts, prop, end,
						animation.opts.specialEasing[ prop ] || animation.opts.easing );
					animation.tweens.push( tween );
					return tween;
				},
				stop: function( gotoEnd ) {
					var index = 0,
	
						// If we are going to the end, we want to run all the tweens
						// otherwise we skip this part
						length = gotoEnd ? animation.tweens.length : 0;
					if ( stopped ) {
						return this;
					}
					stopped = true;
					for ( ; index < length; index++ ) {
						animation.tweens[ index ].run( 1 );
					}
	
					// Resolve when we played the last frame; otherwise, reject
					if ( gotoEnd ) {
						deferred.notifyWith( elem, [ animation, 1, 0 ] );
						deferred.resolveWith( elem, [ animation, gotoEnd ] );
					} else {
						deferred.rejectWith( elem, [ animation, gotoEnd ] );
					}
					return this;
				}
			} ),
			props = animation.props;
	
		propFilter( props, animation.opts.specialEasing );
	
		for ( ; index < length; index++ ) {
			result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
			if ( result ) {
				if ( isFunction( result.stop ) ) {
					jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
						result.stop.bind( result );
				}
				return result;
			}
		}
	
		jQuery.map( props, createTween, animation );
	
		if ( isFunction( animation.opts.start ) ) {
			animation.opts.start.call( elem, animation );
		}
	
		// Attach callbacks from options
		animation
			.progress( animation.opts.progress )
			.done( animation.opts.done, animation.opts.complete )
			.fail( animation.opts.fail )
			.always( animation.opts.always );
	
		jQuery.fx.timer(
			jQuery.extend( tick, {
				elem: elem,
				anim: animation,
				queue: animation.opts.queue
			} )
		);
	
		return animation;
	}
	
	jQuery.Animation = jQuery.extend( Animation, {
	
		tweeners: {
			"*": [ function( prop, value ) {
				var tween = this.createTween( prop, value );
				adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
				return tween;
			} ]
		},
	
		tweener: function( props, callback ) {
			if ( isFunction( props ) ) {
				callback = props;
				props = [ "*" ];
			} else {
				props = props.match( rnothtmlwhite );
			}
	
			var prop,
				index = 0,
				length = props.length;
	
			for ( ; index < length; index++ ) {
				prop = props[ index ];
				Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
				Animation.tweeners[ prop ].unshift( callback );
			}
		},
	
		prefilters: [ defaultPrefilter ],
	
		prefilter: function( callback, prepend ) {
			if ( prepend ) {
				Animation.prefilters.unshift( callback );
			} else {
				Animation.prefilters.push( callback );
			}
		}
	} );
	
	jQuery.speed = function( speed, easing, fn ) {
		var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
			complete: fn || !fn && easing ||
				isFunction( speed ) && speed,
			duration: speed,
			easing: fn && easing || easing && !isFunction( easing ) && easing
		};
	
		// Go to the end state if fx are off
		if ( jQuery.fx.off ) {
			opt.duration = 0;
	
		} else {
			if ( typeof opt.duration !== "number" ) {
				if ( opt.duration in jQuery.fx.speeds ) {
					opt.duration = jQuery.fx.speeds[ opt.duration ];
	
				} else {
					opt.duration = jQuery.fx.speeds._default;
				}
			}
		}
	
		// Normalize opt.queue - true/undefined/null -> "fx"
		if ( opt.queue == null || opt.queue === true ) {
			opt.queue = "fx";
		}
	
		// Queueing
		opt.old = opt.complete;
	
		opt.complete = function() {
			if ( isFunction( opt.old ) ) {
				opt.old.call( this );
			}
	
			if ( opt.queue ) {
				jQuery.dequeue( this, opt.queue );
			}
		};
	
		return opt;
	};
	
	jQuery.fn.extend( {
		fadeTo: function( speed, to, easing, callback ) {
	
			// Show any hidden elements after setting opacity to 0
			return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()
	
				// Animate to the value specified
				.end().animate( { opacity: to }, speed, easing, callback );
		},
		animate: function( prop, speed, easing, callback ) {
			var empty = jQuery.isEmptyObject( prop ),
				optall = jQuery.speed( speed, easing, callback ),
				doAnimation = function() {
	
					// Operate on a copy of prop so per-property easing won't be lost
					var anim = Animation( this, jQuery.extend( {}, prop ), optall );
	
					// Empty animations, or finishing resolves immediately
					if ( empty || dataPriv.get( this, "finish" ) ) {
						anim.stop( true );
					}
				};
	
			doAnimation.finish = doAnimation;
	
			return empty || optall.queue === false ?
				this.each( doAnimation ) :
				this.queue( optall.queue, doAnimation );
		},
		stop: function( type, clearQueue, gotoEnd ) {
			var stopQueue = function( hooks ) {
				var stop = hooks.stop;
				delete hooks.stop;
				stop( gotoEnd );
			};
	
			if ( typeof type !== "string" ) {
				gotoEnd = clearQueue;
				clearQueue = type;
				type = undefined;
			}
			if ( clearQueue ) {
				this.queue( type || "fx", [] );
			}
	
			return this.each( function() {
				var dequeue = true,
					index = type != null && type + "queueHooks",
					timers = jQuery.timers,
					data = dataPriv.get( this );
	
				if ( index ) {
					if ( data[ index ] && data[ index ].stop ) {
						stopQueue( data[ index ] );
					}
				} else {
					for ( index in data ) {
						if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
							stopQueue( data[ index ] );
						}
					}
				}
	
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this &&
						( type == null || timers[ index ].queue === type ) ) {
	
						timers[ index ].anim.stop( gotoEnd );
						dequeue = false;
						timers.splice( index, 1 );
					}
				}
	
				// Start the next in the queue if the last step wasn't forced.
				// Timers currently will call their complete callbacks, which
				// will dequeue but only if they were gotoEnd.
				if ( dequeue || !gotoEnd ) {
					jQuery.dequeue( this, type );
				}
			} );
		},
		finish: function( type ) {
			if ( type !== false ) {
				type = type || "fx";
			}
			return this.each( function() {
				var index,
					data = dataPriv.get( this ),
					queue = data[ type + "queue" ],
					hooks = data[ type + "queueHooks" ],
					timers = jQuery.timers,
					length = queue ? queue.length : 0;
	
				// Enable finishing flag on private data
				data.finish = true;
	
				// Empty the queue first
				jQuery.queue( this, type, [] );
	
				if ( hooks && hooks.stop ) {
					hooks.stop.call( this, true );
				}
	
				// Look for any active animations, and finish them
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
						timers[ index ].anim.stop( true );
						timers.splice( index, 1 );
					}
				}
	
				// Look for any animations in the old queue and finish them
				for ( index = 0; index < length; index++ ) {
					if ( queue[ index ] && queue[ index ].finish ) {
						queue[ index ].finish.call( this );
					}
				}
	
				// Turn off finishing flag
				delete data.finish;
			} );
		}
	} );
	
	jQuery.each( [ "toggle", "show", "hide" ], function( _i, name ) {
		var cssFn = jQuery.fn[ name ];
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return speed == null || typeof speed === "boolean" ?
				cssFn.apply( this, arguments ) :
				this.animate( genFx( name, true ), speed, easing, callback );
		};
	} );
	
	// Generate shortcuts for custom animations
	jQuery.each( {
		slideDown: genFx( "show" ),
		slideUp: genFx( "hide" ),
		slideToggle: genFx( "toggle" ),
		fadeIn: { opacity: "show" },
		fadeOut: { opacity: "hide" },
		fadeToggle: { opacity: "toggle" }
	}, function( name, props ) {
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return this.animate( props, speed, easing, callback );
		};
	} );
	
	jQuery.timers = [];
	jQuery.fx.tick = function() {
		var timer,
			i = 0,
			timers = jQuery.timers;
	
		fxNow = Date.now();
	
		for ( ; i < timers.length; i++ ) {
			timer = timers[ i ];
	
			// Run the timer and safely remove it when done (allowing for external removal)
			if ( !timer() && timers[ i ] === timer ) {
				timers.splice( i--, 1 );
			}
		}
	
		if ( !timers.length ) {
			jQuery.fx.stop();
		}
		fxNow = undefined;
	};
	
	jQuery.fx.timer = function( timer ) {
		jQuery.timers.push( timer );
		jQuery.fx.start();
	};
	
	jQuery.fx.interval = 13;
	jQuery.fx.start = function() {
		if ( inProgress ) {
			return;
		}
	
		inProgress = true;
		schedule();
	};
	
	jQuery.fx.stop = function() {
		inProgress = null;
	};
	
	jQuery.fx.speeds = {
		slow: 600,
		fast: 200,
	
		// Default speed
		_default: 400
	};
	
	
	// Based off of the plugin by Clint Helfers, with permission.
	jQuery.fn.delay = function( time, type ) {
		time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
		type = type || "fx";
	
		return this.queue( type, function( next, hooks ) {
			var timeout = window.setTimeout( next, time );
			hooks.stop = function() {
				window.clearTimeout( timeout );
			};
		} );
	};
	
	
	( function() {
		var input = document.createElement( "input" ),
			select = document.createElement( "select" ),
			opt = select.appendChild( document.createElement( "option" ) );
	
		input.type = "checkbox";
	
		// Support: Android <=4.3 only
		// Default value for a checkbox should be "on"
		support.checkOn = input.value !== "";
	
		// Support: IE <=11 only
		// Must access selectedIndex to make default options select
		support.optSelected = opt.selected;
	
		// Support: IE <=11 only
		// An input loses its value after becoming a radio
		input = document.createElement( "input" );
		input.value = "t";
		input.type = "radio";
		support.radioValue = input.value === "t";
	} )();
	
	
	var boolHook,
		attrHandle = jQuery.expr.attrHandle;
	
	jQuery.fn.extend( {
		attr: function( name, value ) {
			return access( this, jQuery.attr, name, value, arguments.length > 1 );
		},
	
		removeAttr: function( name ) {
			return this.each( function() {
				jQuery.removeAttr( this, name );
			} );
		}
	} );
	
	jQuery.extend( {
		attr: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set attributes on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			// Fallback to prop when attributes are not supported
			if ( typeof elem.getAttribute === "undefined" ) {
				return jQuery.prop( elem, name, value );
			}
	
			// Attribute hooks are determined by the lowercase version
			// Grab necessary hook if one is defined
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
				hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
					( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
			}
	
			if ( value !== undefined ) {
				if ( value === null ) {
					jQuery.removeAttr( elem, name );
					return;
				}
	
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				elem.setAttribute( name, value + "" );
				return value;
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			ret = jQuery.find.attr( elem, name );
	
			// Non-existent attributes return null, we normalize to undefined
			return ret == null ? undefined : ret;
		},
	
		attrHooks: {
			type: {
				set: function( elem, value ) {
					if ( !support.radioValue && value === "radio" &&
						nodeName( elem, "input" ) ) {
						var val = elem.value;
						elem.setAttribute( "type", value );
						if ( val ) {
							elem.value = val;
						}
						return value;
					}
				}
			}
		},
	
		removeAttr: function( elem, value ) {
			var name,
				i = 0,
	
				// Attribute names can contain non-HTML whitespace characters
				// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
				attrNames = value && value.match( rnothtmlwhite );
	
			if ( attrNames && elem.nodeType === 1 ) {
				while ( ( name = attrNames[ i++ ] ) ) {
					elem.removeAttribute( name );
				}
			}
		}
	} );
	
	// Hooks for boolean attributes
	boolHook = {
		set: function( elem, value, name ) {
			if ( value === false ) {
	
				// Remove boolean attributes when set to false
				jQuery.removeAttr( elem, name );
			} else {
				elem.setAttribute( name, name );
			}
			return name;
		}
	};
	
	jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( _i, name ) {
		var getter = attrHandle[ name ] || jQuery.find.attr;
	
		attrHandle[ name ] = function( elem, name, isXML ) {
			var ret, handle,
				lowercaseName = name.toLowerCase();
	
			if ( !isXML ) {
	
				// Avoid an infinite loop by temporarily removing this function from the getter
				handle = attrHandle[ lowercaseName ];
				attrHandle[ lowercaseName ] = ret;
				ret = getter( elem, name, isXML ) != null ?
					lowercaseName :
					null;
				attrHandle[ lowercaseName ] = handle;
			}
			return ret;
		};
	} );
	
	
	
	
	var rfocusable = /^(?:input|select|textarea|button)$/i,
		rclickable = /^(?:a|area)$/i;
	
	jQuery.fn.extend( {
		prop: function( name, value ) {
			return access( this, jQuery.prop, name, value, arguments.length > 1 );
		},
	
		removeProp: function( name ) {
			return this.each( function() {
				delete this[ jQuery.propFix[ name ] || name ];
			} );
		}
	} );
	
	jQuery.extend( {
		prop: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set properties on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
	
				// Fix name and attach hooks
				name = jQuery.propFix[ name ] || name;
				hooks = jQuery.propHooks[ name ];
			}
	
			if ( value !== undefined ) {
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				return ( elem[ name ] = value );
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			return elem[ name ];
		},
	
		propHooks: {
			tabIndex: {
				get: function( elem ) {
	
					// Support: IE <=9 - 11 only
					// elem.tabIndex doesn't always return the
					// correct value when it hasn't been explicitly set
					// Use proper attribute retrieval (trac-12072)
					var tabindex = jQuery.find.attr( elem, "tabindex" );
	
					if ( tabindex ) {
						return parseInt( tabindex, 10 );
					}
	
					if (
						rfocusable.test( elem.nodeName ) ||
						rclickable.test( elem.nodeName ) &&
						elem.href
					) {
						return 0;
					}
	
					return -1;
				}
			}
		},
	
		propFix: {
			"for": "htmlFor",
			"class": "className"
		}
	} );
	
	// Support: IE <=11 only
	// Accessing the selectedIndex property
	// forces the browser to respect setting selected
	// on the option
	// The getter ensures a default option is selected
	// when in an optgroup
	// eslint rule "no-unused-expressions" is disabled for this code
	// since it considers such accessions noop
	if ( !support.optSelected ) {
		jQuery.propHooks.selected = {
			get: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent && parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
				return null;
			},
			set: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent ) {
					parent.selectedIndex;
	
					if ( parent.parentNode ) {
						parent.parentNode.selectedIndex;
					}
				}
			}
		};
	}
	
	jQuery.each( [
		"tabIndex",
		"readOnly",
		"maxLength",
		"cellSpacing",
		"cellPadding",
		"rowSpan",
		"colSpan",
		"useMap",
		"frameBorder",
		"contentEditable"
	], function() {
		jQuery.propFix[ this.toLowerCase() ] = this;
	} );
	
	
	
	
		// Strip and collapse whitespace according to HTML spec
		// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
		function stripAndCollapse( value ) {
			var tokens = value.match( rnothtmlwhite ) || [];
			return tokens.join( " " );
		}
	
	
	function getClass( elem ) {
		return elem.getAttribute && elem.getAttribute( "class" ) || "";
	}
	
	function classesToArray( value ) {
		if ( Array.isArray( value ) ) {
			return value;
		}
		if ( typeof value === "string" ) {
			return value.match( rnothtmlwhite ) || [];
		}
		return [];
	}
	
	jQuery.fn.extend( {
		addClass: function( value ) {
			var classNames, cur, curValue, className, i, finalValue;
	
			if ( isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			classNames = classesToArray( value );
	
			if ( classNames.length ) {
				return this.each( function() {
					curValue = getClass( this );
					cur = this.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						for ( i = 0; i < classNames.length; i++ ) {
							className = classNames[ i ];
							if ( cur.indexOf( " " + className + " " ) < 0 ) {
								cur += className + " ";
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							this.setAttribute( "class", finalValue );
						}
					}
				} );
			}
	
			return this;
		},
	
		removeClass: function( value ) {
			var classNames, cur, curValue, className, i, finalValue;
	
			if ( isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( !arguments.length ) {
				return this.attr( "class", "" );
			}
	
			classNames = classesToArray( value );
	
			if ( classNames.length ) {
				return this.each( function() {
					curValue = getClass( this );
	
					// This expression is here for better compressibility (see addClass)
					cur = this.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						for ( i = 0; i < classNames.length; i++ ) {
							className = classNames[ i ];
	
							// Remove *all* instances
							while ( cur.indexOf( " " + className + " " ) > -1 ) {
								cur = cur.replace( " " + className + " ", " " );
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							this.setAttribute( "class", finalValue );
						}
					}
				} );
			}
	
			return this;
		},
	
		toggleClass: function( value, stateVal ) {
			var classNames, className, i, self,
				type = typeof value,
				isValidValue = type === "string" || Array.isArray( value );
	
			if ( isFunction( value ) ) {
				return this.each( function( i ) {
					jQuery( this ).toggleClass(
						value.call( this, i, getClass( this ), stateVal ),
						stateVal
					);
				} );
			}
	
			if ( typeof stateVal === "boolean" && isValidValue ) {
				return stateVal ? this.addClass( value ) : this.removeClass( value );
			}
	
			classNames = classesToArray( value );
	
			return this.each( function() {
				if ( isValidValue ) {
	
					// Toggle individual class names
					self = jQuery( this );
	
					for ( i = 0; i < classNames.length; i++ ) {
						className = classNames[ i ];
	
						// Check each className given, space separated list
						if ( self.hasClass( className ) ) {
							self.removeClass( className );
						} else {
							self.addClass( className );
						}
					}
	
				// Toggle whole class name
				} else if ( value === undefined || type === "boolean" ) {
					className = getClass( this );
					if ( className ) {
	
						// Store className if set
						dataPriv.set( this, "__className__", className );
					}
	
					// If the element has a class name or if we're passed `false`,
					// then remove the whole classname (if there was one, the above saved it).
					// Otherwise bring back whatever was previously saved (if anything),
					// falling back to the empty string if nothing was stored.
					if ( this.setAttribute ) {
						this.setAttribute( "class",
							className || value === false ?
								"" :
								dataPriv.get( this, "__className__" ) || ""
						);
					}
				}
			} );
		},
	
		hasClass: function( selector ) {
			var className, elem,
				i = 0;
	
			className = " " + selector + " ";
			while ( ( elem = this[ i++ ] ) ) {
				if ( elem.nodeType === 1 &&
					( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
					return true;
				}
			}
	
			return false;
		}
	} );
	
	
	
	
	var rreturn = /\r/g;
	
	jQuery.fn.extend( {
		val: function( value ) {
			var hooks, ret, valueIsFunction,
				elem = this[ 0 ];
	
			if ( !arguments.length ) {
				if ( elem ) {
					hooks = jQuery.valHooks[ elem.type ] ||
						jQuery.valHooks[ elem.nodeName.toLowerCase() ];
	
					if ( hooks &&
						"get" in hooks &&
						( ret = hooks.get( elem, "value" ) ) !== undefined
					) {
						return ret;
					}
	
					ret = elem.value;
	
					// Handle most common string cases
					if ( typeof ret === "string" ) {
						return ret.replace( rreturn, "" );
					}
	
					// Handle cases where value is null/undef or number
					return ret == null ? "" : ret;
				}
	
				return;
			}
	
			valueIsFunction = isFunction( value );
	
			return this.each( function( i ) {
				var val;
	
				if ( this.nodeType !== 1 ) {
					return;
				}
	
				if ( valueIsFunction ) {
					val = value.call( this, i, jQuery( this ).val() );
				} else {
					val = value;
				}
	
				// Treat null/undefined as ""; convert numbers to string
				if ( val == null ) {
					val = "";
	
				} else if ( typeof val === "number" ) {
					val += "";
	
				} else if ( Array.isArray( val ) ) {
					val = jQuery.map( val, function( value ) {
						return value == null ? "" : value + "";
					} );
				}
	
				hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];
	
				// If set returns undefined, fall back to normal setting
				if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
					this.value = val;
				}
			} );
		}
	} );
	
	jQuery.extend( {
		valHooks: {
			option: {
				get: function( elem ) {
	
					var val = jQuery.find.attr( elem, "value" );
					return val != null ?
						val :
	
						// Support: IE <=10 - 11 only
						// option.text throws exceptions (trac-14686, trac-14858)
						// Strip and collapse whitespace
						// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
						stripAndCollapse( jQuery.text( elem ) );
				}
			},
			select: {
				get: function( elem ) {
					var value, option, i,
						options = elem.options,
						index = elem.selectedIndex,
						one = elem.type === "select-one",
						values = one ? null : [],
						max = one ? index + 1 : options.length;
	
					if ( index < 0 ) {
						i = max;
	
					} else {
						i = one ? index : 0;
					}
	
					// Loop through all the selected options
					for ( ; i < max; i++ ) {
						option = options[ i ];
	
						// Support: IE <=9 only
						// IE8-9 doesn't update selected after form reset (trac-2551)
						if ( ( option.selected || i === index ) &&
	
								// Don't return options that are disabled or in a disabled optgroup
								!option.disabled &&
								( !option.parentNode.disabled ||
									!nodeName( option.parentNode, "optgroup" ) ) ) {
	
							// Get the specific value for the option
							value = jQuery( option ).val();
	
							// We don't need an array for one selects
							if ( one ) {
								return value;
							}
	
							// Multi-Selects return an array
							values.push( value );
						}
					}
	
					return values;
				},
	
				set: function( elem, value ) {
					var optionSet, option,
						options = elem.options,
						values = jQuery.makeArray( value ),
						i = options.length;
	
					while ( i-- ) {
						option = options[ i ];
	
						/* eslint-disable no-cond-assign */
	
						if ( option.selected =
							jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
						) {
							optionSet = true;
						}
	
						/* eslint-enable no-cond-assign */
					}
	
					// Force browsers to behave consistently when non-matching value is set
					if ( !optionSet ) {
						elem.selectedIndex = -1;
					}
					return values;
				}
			}
		}
	} );
	
	// Radios and checkboxes getter/setter
	jQuery.each( [ "radio", "checkbox" ], function() {
		jQuery.valHooks[ this ] = {
			set: function( elem, value ) {
				if ( Array.isArray( value ) ) {
					return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
				}
			}
		};
		if ( !support.checkOn ) {
			jQuery.valHooks[ this ].get = function( elem ) {
				return elem.getAttribute( "value" ) === null ? "on" : elem.value;
			};
		}
	} );
	
	
	
	
	// Return jQuery for attributes-only inclusion
	var location = window.location;
	
	var nonce = { guid: Date.now() };
	
	var rquery = ( /\?/ );
	
	
	
	// Cross-browser xml parsing
	jQuery.parseXML = function( data ) {
		var xml, parserErrorElem;
		if ( !data || typeof data !== "string" ) {
			return null;
		}
	
		// Support: IE 9 - 11 only
		// IE throws on parseFromString with invalid input.
		try {
			xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
		} catch ( e ) {}
	
		parserErrorElem = xml && xml.getElementsByTagName( "parsererror" )[ 0 ];
		if ( !xml || parserErrorElem ) {
			jQuery.error( "Invalid XML: " + (
				parserErrorElem ?
					jQuery.map( parserErrorElem.childNodes, function( el ) {
						return el.textContent;
					} ).join( "\n" ) :
					data
			) );
		}
		return xml;
	};
	
	
	var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
		stopPropagationCallback = function( e ) {
			e.stopPropagation();
		};
	
	jQuery.extend( jQuery.event, {
	
		trigger: function( event, data, elem, onlyHandlers ) {
	
			var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
				eventPath = [ elem || document ],
				type = hasOwn.call( event, "type" ) ? event.type : event,
				namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];
	
			cur = lastElement = tmp = elem = elem || document;
	
			// Don't do events on text and comment nodes
			if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
				return;
			}
	
			// focus/blur morphs to focusin/out; ensure we're not firing them right now
			if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
				return;
			}
	
			if ( type.indexOf( "." ) > -1 ) {
	
				// Namespaced trigger; create a regexp to match event type in handle()
				namespaces = type.split( "." );
				type = namespaces.shift();
				namespaces.sort();
			}
			ontype = type.indexOf( ":" ) < 0 && "on" + type;
	
			// Caller can pass in a jQuery.Event object, Object, or just an event type string
			event = event[ jQuery.expando ] ?
				event :
				new jQuery.Event( type, typeof event === "object" && event );
	
			// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
			event.isTrigger = onlyHandlers ? 2 : 3;
			event.namespace = namespaces.join( "." );
			event.rnamespace = event.namespace ?
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
				null;
	
			// Clean up the event in case it is being reused
			event.result = undefined;
			if ( !event.target ) {
				event.target = elem;
			}
	
			// Clone any incoming data and prepend the event, creating the handler arg list
			data = data == null ?
				[ event ] :
				jQuery.makeArray( data, [ event ] );
	
			// Allow special events to draw outside the lines
			special = jQuery.event.special[ type ] || {};
			if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
				return;
			}
	
			// Determine event propagation path in advance, per W3C events spec (trac-9951)
			// Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
			if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {
	
				bubbleType = special.delegateType || type;
				if ( !rfocusMorph.test( bubbleType + type ) ) {
					cur = cur.parentNode;
				}
				for ( ; cur; cur = cur.parentNode ) {
					eventPath.push( cur );
					tmp = cur;
				}
	
				// Only add window if we got to document (e.g., not plain obj or detached DOM)
				if ( tmp === ( elem.ownerDocument || document ) ) {
					eventPath.push( tmp.defaultView || tmp.parentWindow || window );
				}
			}
	
			// Fire handlers on the event path
			i = 0;
			while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
				lastElement = cur;
				event.type = i > 1 ?
					bubbleType :
					special.bindType || type;
	
				// jQuery handler
				handle = ( dataPriv.get( cur, "events" ) || Object.create( null ) )[ event.type ] &&
					dataPriv.get( cur, "handle" );
				if ( handle ) {
					handle.apply( cur, data );
				}
	
				// Native handler
				handle = ontype && cur[ ontype ];
				if ( handle && handle.apply && acceptData( cur ) ) {
					event.result = handle.apply( cur, data );
					if ( event.result === false ) {
						event.preventDefault();
					}
				}
			}
			event.type = type;
	
			// If nobody prevented the default action, do it now
			if ( !onlyHandlers && !event.isDefaultPrevented() ) {
	
				if ( ( !special._default ||
					special._default.apply( eventPath.pop(), data ) === false ) &&
					acceptData( elem ) ) {
	
					// Call a native DOM method on the target with the same name as the event.
					// Don't do default actions on window, that's where global variables be (trac-6170)
					if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {
	
						// Don't re-trigger an onFOO event when we call its FOO() method
						tmp = elem[ ontype ];
	
						if ( tmp ) {
							elem[ ontype ] = null;
						}
	
						// Prevent re-triggering of the same event, since we already bubbled it above
						jQuery.event.triggered = type;
	
						if ( event.isPropagationStopped() ) {
							lastElement.addEventListener( type, stopPropagationCallback );
						}
	
						elem[ type ]();
	
						if ( event.isPropagationStopped() ) {
							lastElement.removeEventListener( type, stopPropagationCallback );
						}
	
						jQuery.event.triggered = undefined;
	
						if ( tmp ) {
							elem[ ontype ] = tmp;
						}
					}
				}
			}
	
			return event.result;
		},
	
		// Piggyback on a donor event to simulate a different one
		// Used only for `focus(in | out)` events
		simulate: function( type, elem, event ) {
			var e = jQuery.extend(
				new jQuery.Event(),
				event,
				{
					type: type,
					isSimulated: true
				}
			);
	
			jQuery.event.trigger( e, null, elem );
		}
	
	} );
	
	jQuery.fn.extend( {
	
		trigger: function( type, data ) {
			return this.each( function() {
				jQuery.event.trigger( type, data, this );
			} );
		},
		triggerHandler: function( type, data ) {
			var elem = this[ 0 ];
			if ( elem ) {
				return jQuery.event.trigger( type, data, elem, true );
			}
		}
	} );
	
	
	var
		rbracket = /\[\]$/,
		rCRLF = /\r?\n/g,
		rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
		rsubmittable = /^(?:input|select|textarea|keygen)/i;
	
	function buildParams( prefix, obj, traditional, add ) {
		var name;
	
		if ( Array.isArray( obj ) ) {
	
			// Serialize array item.
			jQuery.each( obj, function( i, v ) {
				if ( traditional || rbracket.test( prefix ) ) {
	
					// Treat each array item as a scalar.
					add( prefix, v );
	
				} else {
	
					// Item is non-scalar (array or object), encode its numeric index.
					buildParams(
						prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
						v,
						traditional,
						add
					);
				}
			} );
	
		} else if ( !traditional && toType( obj ) === "object" ) {
	
			// Serialize object item.
			for ( name in obj ) {
				buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
			}
	
		} else {
	
			// Serialize scalar item.
			add( prefix, obj );
		}
	}
	
	// Serialize an array of form elements or a set of
	// key/values into a query string
	jQuery.param = function( a, traditional ) {
		var prefix,
			s = [],
			add = function( key, valueOrFunction ) {
	
				// If value is a function, invoke it and use its return value
				var value = isFunction( valueOrFunction ) ?
					valueOrFunction() :
					valueOrFunction;
	
				s[ s.length ] = encodeURIComponent( key ) + "=" +
					encodeURIComponent( value == null ? "" : value );
			};
	
		if ( a == null ) {
			return "";
		}
	
		// If an array was passed in, assume that it is an array of form elements.
		if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {
	
			// Serialize the form elements
			jQuery.each( a, function() {
				add( this.name, this.value );
			} );
	
		} else {
	
			// If traditional, encode the "old" way (the way 1.3.2 or older
			// did it), otherwise encode params recursively.
			for ( prefix in a ) {
				buildParams( prefix, a[ prefix ], traditional, add );
			}
		}
	
		// Return the resulting serialization
		return s.join( "&" );
	};
	
	jQuery.fn.extend( {
		serialize: function() {
			return jQuery.param( this.serializeArray() );
		},
		serializeArray: function() {
			return this.map( function() {
	
				// Can add propHook for "elements" to filter or add form elements
				var elements = jQuery.prop( this, "elements" );
				return elements ? jQuery.makeArray( elements ) : this;
			} ).filter( function() {
				var type = this.type;
	
				// Use .is( ":disabled" ) so that fieldset[disabled] works
				return this.name && !jQuery( this ).is( ":disabled" ) &&
					rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
					( this.checked || !rcheckableType.test( type ) );
			} ).map( function( _i, elem ) {
				var val = jQuery( this ).val();
	
				if ( val == null ) {
					return null;
				}
	
				if ( Array.isArray( val ) ) {
					return jQuery.map( val, function( val ) {
						return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
					} );
				}
	
				return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
			} ).get();
		}
	} );
	
	
	var
		r20 = /%20/g,
		rhash = /#.*$/,
		rantiCache = /([?&])_=[^&]*/,
		rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,
	
		// trac-7653, trac-8125, trac-8152: local protocol detection
		rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
		rnoContent = /^(?:GET|HEAD)$/,
		rprotocol = /^\/\//,
	
		/* Prefilters
		 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
		 * 2) These are called:
		 *    - BEFORE asking for a transport
		 *    - AFTER param serialization (s.data is a string if s.processData is true)
		 * 3) key is the dataType
		 * 4) the catchall symbol "*" can be used
		 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
		 */
		prefilters = {},
	
		/* Transports bindings
		 * 1) key is the dataType
		 * 2) the catchall symbol "*" can be used
		 * 3) selection will start with transport dataType and THEN go to "*" if needed
		 */
		transports = {},
	
		// Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
		allTypes = "*/".concat( "*" ),
	
		// Anchor tag for parsing the document origin
		originAnchor = document.createElement( "a" );
	
	originAnchor.href = location.href;
	
	// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
	function addToPrefiltersOrTransports( structure ) {
	
		// dataTypeExpression is optional and defaults to "*"
		return function( dataTypeExpression, func ) {
	
			if ( typeof dataTypeExpression !== "string" ) {
				func = dataTypeExpression;
				dataTypeExpression = "*";
			}
	
			var dataType,
				i = 0,
				dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];
	
			if ( isFunction( func ) ) {
	
				// For each dataType in the dataTypeExpression
				while ( ( dataType = dataTypes[ i++ ] ) ) {
	
					// Prepend if requested
					if ( dataType[ 0 ] === "+" ) {
						dataType = dataType.slice( 1 ) || "*";
						( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );
	
					// Otherwise append
					} else {
						( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
					}
				}
			}
		};
	}
	
	// Base inspection function for prefilters and transports
	function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {
	
		var inspected = {},
			seekingTransport = ( structure === transports );
	
		function inspect( dataType ) {
			var selected;
			inspected[ dataType ] = true;
			jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
				var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
				if ( typeof dataTypeOrTransport === "string" &&
					!seekingTransport && !inspected[ dataTypeOrTransport ] ) {
	
					options.dataTypes.unshift( dataTypeOrTransport );
					inspect( dataTypeOrTransport );
					return false;
				} else if ( seekingTransport ) {
					return !( selected = dataTypeOrTransport );
				}
			} );
			return selected;
		}
	
		return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
	}
	
	// A special extend for ajax options
	// that takes "flat" options (not to be deep extended)
	// Fixes trac-9887
	function ajaxExtend( target, src ) {
		var key, deep,
			flatOptions = jQuery.ajaxSettings.flatOptions || {};
	
		for ( key in src ) {
			if ( src[ key ] !== undefined ) {
				( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
			}
		}
		if ( deep ) {
			jQuery.extend( true, target, deep );
		}
	
		return target;
	}
	
	/* Handles responses to an ajax request:
	 * - finds the right dataType (mediates between content-type and expected dataType)
	 * - returns the corresponding response
	 */
	function ajaxHandleResponses( s, jqXHR, responses ) {
	
		var ct, type, finalDataType, firstDataType,
			contents = s.contents,
			dataTypes = s.dataTypes;
	
		// Remove auto dataType and get content-type in the process
		while ( dataTypes[ 0 ] === "*" ) {
			dataTypes.shift();
			if ( ct === undefined ) {
				ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
			}
		}
	
		// Check if we're dealing with a known content-type
		if ( ct ) {
			for ( type in contents ) {
				if ( contents[ type ] && contents[ type ].test( ct ) ) {
					dataTypes.unshift( type );
					break;
				}
			}
		}
	
		// Check to see if we have a response for the expected dataType
		if ( dataTypes[ 0 ] in responses ) {
			finalDataType = dataTypes[ 0 ];
		} else {
	
			// Try convertible dataTypes
			for ( type in responses ) {
				if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
					finalDataType = type;
					break;
				}
				if ( !firstDataType ) {
					firstDataType = type;
				}
			}
	
			// Or just use first one
			finalDataType = finalDataType || firstDataType;
		}
	
		// If we found a dataType
		// We add the dataType to the list if needed
		// and return the corresponding response
		if ( finalDataType ) {
			if ( finalDataType !== dataTypes[ 0 ] ) {
				dataTypes.unshift( finalDataType );
			}
			return responses[ finalDataType ];
		}
	}
	
	/* Chain conversions given the request and the original response
	 * Also sets the responseXXX fields on the jqXHR instance
	 */
	function ajaxConvert( s, response, jqXHR, isSuccess ) {
		var conv2, current, conv, tmp, prev,
			converters = {},
	
			// Work with a copy of dataTypes in case we need to modify it for conversion
			dataTypes = s.dataTypes.slice();
	
		// Create converters map with lowercased keys
		if ( dataTypes[ 1 ] ) {
			for ( conv in s.converters ) {
				converters[ conv.toLowerCase() ] = s.converters[ conv ];
			}
		}
	
		current = dataTypes.shift();
	
		// Convert to each sequential dataType
		while ( current ) {
	
			if ( s.responseFields[ current ] ) {
				jqXHR[ s.responseFields[ current ] ] = response;
			}
	
			// Apply the dataFilter if provided
			if ( !prev && isSuccess && s.dataFilter ) {
				response = s.dataFilter( response, s.dataType );
			}
	
			prev = current;
			current = dataTypes.shift();
	
			if ( current ) {
	
				// There's only work to do if current dataType is non-auto
				if ( current === "*" ) {
	
					current = prev;
	
				// Convert response if prev dataType is non-auto and differs from current
				} else if ( prev !== "*" && prev !== current ) {
	
					// Seek a direct converter
					conv = converters[ prev + " " + current ] || converters[ "* " + current ];
	
					// If none found, seek a pair
					if ( !conv ) {
						for ( conv2 in converters ) {
	
							// If conv2 outputs current
							tmp = conv2.split( " " );
							if ( tmp[ 1 ] === current ) {
	
								// If prev can be converted to accepted input
								conv = converters[ prev + " " + tmp[ 0 ] ] ||
									converters[ "* " + tmp[ 0 ] ];
								if ( conv ) {
	
									// Condense equivalence converters
									if ( conv === true ) {
										conv = converters[ conv2 ];
	
									// Otherwise, insert the intermediate dataType
									} else if ( converters[ conv2 ] !== true ) {
										current = tmp[ 0 ];
										dataTypes.unshift( tmp[ 1 ] );
									}
									break;
								}
							}
						}
					}
	
					// Apply converter (if not an equivalence)
					if ( conv !== true ) {
	
						// Unless errors are allowed to bubble, catch and return them
						if ( conv && s.throws ) {
							response = conv( response );
						} else {
							try {
								response = conv( response );
							} catch ( e ) {
								return {
									state: "parsererror",
									error: conv ? e : "No conversion from " + prev + " to " + current
								};
							}
						}
					}
				}
			}
		}
	
		return { state: "success", data: response };
	}
	
	jQuery.extend( {
	
		// Counter for holding the number of active queries
		active: 0,
	
		// Last-Modified header cache for next request
		lastModified: {},
		etag: {},
	
		ajaxSettings: {
			url: location.href,
			type: "GET",
			isLocal: rlocalProtocol.test( location.protocol ),
			global: true,
			processData: true,
			async: true,
			contentType: "application/x-www-form-urlencoded; charset=UTF-8",
	
			/*
			timeout: 0,
			data: null,
			dataType: null,
			username: null,
			password: null,
			cache: null,
			throws: false,
			traditional: false,
			headers: {},
			*/
	
			accepts: {
				"*": allTypes,
				text: "text/plain",
				html: "text/html",
				xml: "application/xml, text/xml",
				json: "application/json, text/javascript"
			},
	
			contents: {
				xml: /\bxml\b/,
				html: /\bhtml/,
				json: /\bjson\b/
			},
	
			responseFields: {
				xml: "responseXML",
				text: "responseText",
				json: "responseJSON"
			},
	
			// Data converters
			// Keys separate source (or catchall "*") and destination types with a single space
			converters: {
	
				// Convert anything to text
				"* text": String,
	
				// Text to html (true = no transformation)
				"text html": true,
	
				// Evaluate text as a json expression
				"text json": JSON.parse,
	
				// Parse text as xml
				"text xml": jQuery.parseXML
			},
	
			// For options that shouldn't be deep extended:
			// you can add your own custom options here if
			// and when you create one that shouldn't be
			// deep extended (see ajaxExtend)
			flatOptions: {
				url: true,
				context: true
			}
		},
	
		// Creates a full fledged settings object into target
		// with both ajaxSettings and settings fields.
		// If target is omitted, writes into ajaxSettings.
		ajaxSetup: function( target, settings ) {
			return settings ?
	
				// Building a settings object
				ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :
	
				// Extending ajaxSettings
				ajaxExtend( jQuery.ajaxSettings, target );
		},
	
		ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
		ajaxTransport: addToPrefiltersOrTransports( transports ),
	
		// Main method
		ajax: function( url, options ) {
	
			// If url is an object, simulate pre-1.5 signature
			if ( typeof url === "object" ) {
				options = url;
				url = undefined;
			}
	
			// Force options to be an object
			options = options || {};
	
			var transport,
	
				// URL without anti-cache param
				cacheURL,
	
				// Response headers
				responseHeadersString,
				responseHeaders,
	
				// timeout handle
				timeoutTimer,
	
				// Url cleanup var
				urlAnchor,
	
				// Request state (becomes false upon send and true upon completion)
				completed,
	
				// To know if global events are to be dispatched
				fireGlobals,
	
				// Loop variable
				i,
	
				// uncached part of the url
				uncached,
	
				// Create the final options object
				s = jQuery.ajaxSetup( {}, options ),
	
				// Callbacks context
				callbackContext = s.context || s,
	
				// Context for global events is callbackContext if it is a DOM node or jQuery collection
				globalEventContext = s.context &&
					( callbackContext.nodeType || callbackContext.jquery ) ?
					jQuery( callbackContext ) :
					jQuery.event,
	
				// Deferreds
				deferred = jQuery.Deferred(),
				completeDeferred = jQuery.Callbacks( "once memory" ),
	
				// Status-dependent callbacks
				statusCode = s.statusCode || {},
	
				// Headers (they are sent all at once)
				requestHeaders = {},
				requestHeadersNames = {},
	
				// Default abort message
				strAbort = "canceled",
	
				// Fake xhr
				jqXHR = {
					readyState: 0,
	
					// Builds headers hashtable if needed
					getResponseHeader: function( key ) {
						var match;
						if ( completed ) {
							if ( !responseHeaders ) {
								responseHeaders = {};
								while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
									responseHeaders[ match[ 1 ].toLowerCase() + " " ] =
										( responseHeaders[ match[ 1 ].toLowerCase() + " " ] || [] )
											.concat( match[ 2 ] );
								}
							}
							match = responseHeaders[ key.toLowerCase() + " " ];
						}
						return match == null ? null : match.join( ", " );
					},
	
					// Raw string
					getAllResponseHeaders: function() {
						return completed ? responseHeadersString : null;
					},
	
					// Caches the header
					setRequestHeader: function( name, value ) {
						if ( completed == null ) {
							name = requestHeadersNames[ name.toLowerCase() ] =
								requestHeadersNames[ name.toLowerCase() ] || name;
							requestHeaders[ name ] = value;
						}
						return this;
					},
	
					// Overrides response content-type header
					overrideMimeType: function( type ) {
						if ( completed == null ) {
							s.mimeType = type;
						}
						return this;
					},
	
					// Status-dependent callbacks
					statusCode: function( map ) {
						var code;
						if ( map ) {
							if ( completed ) {
	
								// Execute the appropriate callbacks
								jqXHR.always( map[ jqXHR.status ] );
							} else {
	
								// Lazy-add the new callbacks in a way that preserves old ones
								for ( code in map ) {
									statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
								}
							}
						}
						return this;
					},
	
					// Cancel the request
					abort: function( statusText ) {
						var finalText = statusText || strAbort;
						if ( transport ) {
							transport.abort( finalText );
						}
						done( 0, finalText );
						return this;
					}
				};
	
			// Attach deferreds
			deferred.promise( jqXHR );
	
			// Add protocol if not provided (prefilters might expect it)
			// Handle falsy url in the settings object (trac-10093: consistency with old signature)
			// We also use the url parameter if available
			s.url = ( ( url || s.url || location.href ) + "" )
				.replace( rprotocol, location.protocol + "//" );
	
			// Alias method option to type as per ticket trac-12004
			s.type = options.method || options.type || s.method || s.type;
	
			// Extract dataTypes list
			s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];
	
			// A cross-domain request is in order when the origin doesn't match the current origin.
			if ( s.crossDomain == null ) {
				urlAnchor = document.createElement( "a" );
	
				// Support: IE <=8 - 11, Edge 12 - 15
				// IE throws exception on accessing the href property if url is malformed,
				// e.g. http://example.com:80x/
				try {
					urlAnchor.href = s.url;
	
					// Support: IE <=8 - 11 only
					// Anchor's host property isn't correctly set when s.url is relative
					urlAnchor.href = urlAnchor.href;
					s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
						urlAnchor.protocol + "//" + urlAnchor.host;
				} catch ( e ) {
	
					// If there is an error parsing the URL, assume it is crossDomain,
					// it can be rejected by the transport if it is invalid
					s.crossDomain = true;
				}
			}
	
			// Convert data if not already a string
			if ( s.data && s.processData && typeof s.data !== "string" ) {
				s.data = jQuery.param( s.data, s.traditional );
			}
	
			// Apply prefilters
			inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );
	
			// If request was aborted inside a prefilter, stop there
			if ( completed ) {
				return jqXHR;
			}
	
			// We can fire global events as of now if asked to
			// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
			fireGlobals = jQuery.event && s.global;
	
			// Watch for a new set of requests
			if ( fireGlobals && jQuery.active++ === 0 ) {
				jQuery.event.trigger( "ajaxStart" );
			}
	
			// Uppercase the type
			s.type = s.type.toUpperCase();
	
			// Determine if request has content
			s.hasContent = !rnoContent.test( s.type );
	
			// Save the URL in case we're toying with the If-Modified-Since
			// and/or If-None-Match header later on
			// Remove hash to simplify url manipulation
			cacheURL = s.url.replace( rhash, "" );
	
			// More options handling for requests with no content
			if ( !s.hasContent ) {
	
				// Remember the hash so we can put it back
				uncached = s.url.slice( cacheURL.length );
	
				// If data is available and should be processed, append data to url
				if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
					cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;
	
					// trac-9682: remove data so that it's not used in an eventual retry
					delete s.data;
				}
	
				// Add or update anti-cache param if needed
				if ( s.cache === false ) {
					cacheURL = cacheURL.replace( rantiCache, "$1" );
					uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce.guid++ ) +
						uncached;
				}
	
				// Put hash and anti-cache on the URL that will be requested (gh-1732)
				s.url = cacheURL + uncached;
	
			// Change '%20' to '+' if this is encoded form body content (gh-2658)
			} else if ( s.data && s.processData &&
				( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
				s.data = s.data.replace( r20, "+" );
			}
	
			// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
			if ( s.ifModified ) {
				if ( jQuery.lastModified[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
				}
				if ( jQuery.etag[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
				}
			}
	
			// Set the correct header, if data is being sent
			if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
				jqXHR.setRequestHeader( "Content-Type", s.contentType );
			}
	
			// Set the Accepts header for the server, depending on the dataType
			jqXHR.setRequestHeader(
				"Accept",
				s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
					s.accepts[ s.dataTypes[ 0 ] ] +
						( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
					s.accepts[ "*" ]
			);
	
			// Check for headers option
			for ( i in s.headers ) {
				jqXHR.setRequestHeader( i, s.headers[ i ] );
			}
	
			// Allow custom headers/mimetypes and early abort
			if ( s.beforeSend &&
				( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {
	
				// Abort if not done already and return
				return jqXHR.abort();
			}
	
			// Aborting is no longer a cancellation
			strAbort = "abort";
	
			// Install callbacks on deferreds
			completeDeferred.add( s.complete );
			jqXHR.done( s.success );
			jqXHR.fail( s.error );
	
			// Get transport
			transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );
	
			// If no transport, we auto-abort
			if ( !transport ) {
				done( -1, "No Transport" );
			} else {
				jqXHR.readyState = 1;
	
				// Send global event
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
				}
	
				// If request was aborted inside ajaxSend, stop there
				if ( completed ) {
					return jqXHR;
				}
	
				// Timeout
				if ( s.async && s.timeout > 0 ) {
					timeoutTimer = window.setTimeout( function() {
						jqXHR.abort( "timeout" );
					}, s.timeout );
				}
	
				try {
					completed = false;
					transport.send( requestHeaders, done );
				} catch ( e ) {
	
					// Rethrow post-completion exceptions
					if ( completed ) {
						throw e;
					}
	
					// Propagate others as results
					done( -1, e );
				}
			}
	
			// Callback for when everything is done
			function done( status, nativeStatusText, responses, headers ) {
				var isSuccess, success, error, response, modified,
					statusText = nativeStatusText;
	
				// Ignore repeat invocations
				if ( completed ) {
					return;
				}
	
				completed = true;
	
				// Clear timeout if it exists
				if ( timeoutTimer ) {
					window.clearTimeout( timeoutTimer );
				}
	
				// Dereference transport for early garbage collection
				// (no matter how long the jqXHR object will be used)
				transport = undefined;
	
				// Cache response headers
				responseHeadersString = headers || "";
	
				// Set readyState
				jqXHR.readyState = status > 0 ? 4 : 0;
	
				// Determine if successful
				isSuccess = status >= 200 && status < 300 || status === 304;
	
				// Get response data
				if ( responses ) {
					response = ajaxHandleResponses( s, jqXHR, responses );
				}
	
				// Use a noop converter for missing script but not if jsonp
				if ( !isSuccess &&
					jQuery.inArray( "script", s.dataTypes ) > -1 &&
					jQuery.inArray( "json", s.dataTypes ) < 0 ) {
					s.converters[ "text script" ] = function() {};
				}
	
				// Convert no matter what (that way responseXXX fields are always set)
				response = ajaxConvert( s, response, jqXHR, isSuccess );
	
				// If successful, handle type chaining
				if ( isSuccess ) {
	
					// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
					if ( s.ifModified ) {
						modified = jqXHR.getResponseHeader( "Last-Modified" );
						if ( modified ) {
							jQuery.lastModified[ cacheURL ] = modified;
						}
						modified = jqXHR.getResponseHeader( "etag" );
						if ( modified ) {
							jQuery.etag[ cacheURL ] = modified;
						}
					}
	
					// if no content
					if ( status === 204 || s.type === "HEAD" ) {
						statusText = "nocontent";
	
					// if not modified
					} else if ( status === 304 ) {
						statusText = "notmodified";
	
					// If we have data, let's convert it
					} else {
						statusText = response.state;
						success = response.data;
						error = response.error;
						isSuccess = !error;
					}
				} else {
	
					// Extract error from statusText and normalize for non-aborts
					error = statusText;
					if ( status || !statusText ) {
						statusText = "error";
						if ( status < 0 ) {
							status = 0;
						}
					}
				}
	
				// Set data for the fake xhr object
				jqXHR.status = status;
				jqXHR.statusText = ( nativeStatusText || statusText ) + "";
	
				// Success/Error
				if ( isSuccess ) {
					deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
				} else {
					deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
				}
	
				// Status-dependent callbacks
				jqXHR.statusCode( statusCode );
				statusCode = undefined;
	
				if ( fireGlobals ) {
					globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
						[ jqXHR, s, isSuccess ? success : error ] );
				}
	
				// Complete
				completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );
	
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );
	
					// Handle the global AJAX counter
					if ( !( --jQuery.active ) ) {
						jQuery.event.trigger( "ajaxStop" );
					}
				}
			}
	
			return jqXHR;
		},
	
		getJSON: function( url, data, callback ) {
			return jQuery.get( url, data, callback, "json" );
		},
	
		getScript: function( url, callback ) {
			return jQuery.get( url, undefined, callback, "script" );
		}
	} );
	
	jQuery.each( [ "get", "post" ], function( _i, method ) {
		jQuery[ method ] = function( url, data, callback, type ) {
	
			// Shift arguments if data argument was omitted
			if ( isFunction( data ) ) {
				type = type || callback;
				callback = data;
				data = undefined;
			}
	
			// The url can be an options object (which then must have .url)
			return jQuery.ajax( jQuery.extend( {
				url: url,
				type: method,
				dataType: type,
				data: data,
				success: callback
			}, jQuery.isPlainObject( url ) && url ) );
		};
	} );
	
	jQuery.ajaxPrefilter( function( s ) {
		var i;
		for ( i in s.headers ) {
			if ( i.toLowerCase() === "content-type" ) {
				s.contentType = s.headers[ i ] || "";
			}
		}
	} );
	
	
	jQuery._evalUrl = function( url, options, doc ) {
		return jQuery.ajax( {
			url: url,
	
			// Make this explicit, since user can override this through ajaxSetup (trac-11264)
			type: "GET",
			dataType: "script",
			cache: true,
			async: false,
			global: false,
	
			// Only evaluate the response if it is successful (gh-4126)
			// dataFilter is not invoked for failure responses, so using it instead
			// of the default converter is kludgy but it works.
			converters: {
				"text script": function() {}
			},
			dataFilter: function( response ) {
				jQuery.globalEval( response, options, doc );
			}
		} );
	};
	
	
	jQuery.fn.extend( {
		wrapAll: function( html ) {
			var wrap;
	
			if ( this[ 0 ] ) {
				if ( isFunction( html ) ) {
					html = html.call( this[ 0 ] );
				}
	
				// The elements to wrap the target around
				wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );
	
				if ( this[ 0 ].parentNode ) {
					wrap.insertBefore( this[ 0 ] );
				}
	
				wrap.map( function() {
					var elem = this;
	
					while ( elem.firstElementChild ) {
						elem = elem.firstElementChild;
					}
	
					return elem;
				} ).append( this );
			}
	
			return this;
		},
	
		wrapInner: function( html ) {
			if ( isFunction( html ) ) {
				return this.each( function( i ) {
					jQuery( this ).wrapInner( html.call( this, i ) );
				} );
			}
	
			return this.each( function() {
				var self = jQuery( this ),
					contents = self.contents();
	
				if ( contents.length ) {
					contents.wrapAll( html );
	
				} else {
					self.append( html );
				}
			} );
		},
	
		wrap: function( html ) {
			var htmlIsFunction = isFunction( html );
	
			return this.each( function( i ) {
				jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
			} );
		},
	
		unwrap: function( selector ) {
			this.parent( selector ).not( "body" ).each( function() {
				jQuery( this ).replaceWith( this.childNodes );
			} );
			return this;
		}
	} );
	
	
	jQuery.expr.pseudos.hidden = function( elem ) {
		return !jQuery.expr.pseudos.visible( elem );
	};
	jQuery.expr.pseudos.visible = function( elem ) {
		return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
	};
	
	
	
	
	jQuery.ajaxSettings.xhr = function() {
		try {
			return new window.XMLHttpRequest();
		} catch ( e ) {}
	};
	
	var xhrSuccessStatus = {
	
			// File protocol always yields status code 0, assume 200
			0: 200,
	
			// Support: IE <=9 only
			// trac-1450: sometimes IE returns 1223 when it should be 204
			1223: 204
		},
		xhrSupported = jQuery.ajaxSettings.xhr();
	
	support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
	support.ajax = xhrSupported = !!xhrSupported;
	
	jQuery.ajaxTransport( function( options ) {
		var callback, errorCallback;
	
		// Cross domain only allowed if supported through XMLHttpRequest
		if ( support.cors || xhrSupported && !options.crossDomain ) {
			return {
				send: function( headers, complete ) {
					var i,
						xhr = options.xhr();
	
					xhr.open(
						options.type,
						options.url,
						options.async,
						options.username,
						options.password
					);
	
					// Apply custom fields if provided
					if ( options.xhrFields ) {
						for ( i in options.xhrFields ) {
							xhr[ i ] = options.xhrFields[ i ];
						}
					}
	
					// Override mime type if needed
					if ( options.mimeType && xhr.overrideMimeType ) {
						xhr.overrideMimeType( options.mimeType );
					}
	
					// X-Requested-With header
					// For cross-domain requests, seeing as conditions for a preflight are
					// akin to a jigsaw puzzle, we simply never set it to be sure.
					// (it can always be set on a per-request basis or even using ajaxSetup)
					// For same-domain requests, won't change header if already provided.
					if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
						headers[ "X-Requested-With" ] = "XMLHttpRequest";
					}
	
					// Set headers
					for ( i in headers ) {
						xhr.setRequestHeader( i, headers[ i ] );
					}
	
					// Callback
					callback = function( type ) {
						return function() {
							if ( callback ) {
								callback = errorCallback = xhr.onload =
									xhr.onerror = xhr.onabort = xhr.ontimeout =
										xhr.onreadystatechange = null;
	
								if ( type === "abort" ) {
									xhr.abort();
								} else if ( type === "error" ) {
	
									// Support: IE <=9 only
									// On a manual native abort, IE9 throws
									// errors on any property access that is not readyState
									if ( typeof xhr.status !== "number" ) {
										complete( 0, "error" );
									} else {
										complete(
	
											// File: protocol always yields status 0; see trac-8605, trac-14207
											xhr.status,
											xhr.statusText
										);
									}
								} else {
									complete(
										xhrSuccessStatus[ xhr.status ] || xhr.status,
										xhr.statusText,
	
										// Support: IE <=9 only
										// IE9 has no XHR2 but throws on binary (trac-11426)
										// For XHR2 non-text, let the caller handle it (gh-2498)
										( xhr.responseType || "text" ) !== "text"  ||
										typeof xhr.responseText !== "string" ?
											{ binary: xhr.response } :
											{ text: xhr.responseText },
										xhr.getAllResponseHeaders()
									);
								}
							}
						};
					};
	
					// Listen to events
					xhr.onload = callback();
					errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );
	
					// Support: IE 9 only
					// Use onreadystatechange to replace onabort
					// to handle uncaught aborts
					if ( xhr.onabort !== undefined ) {
						xhr.onabort = errorCallback;
					} else {
						xhr.onreadystatechange = function() {
	
							// Check readyState before timeout as it changes
							if ( xhr.readyState === 4 ) {
	
								// Allow onerror to be called first,
								// but that will not handle a native abort
								// Also, save errorCallback to a variable
								// as xhr.onerror cannot be accessed
								window.setTimeout( function() {
									if ( callback ) {
										errorCallback();
									}
								} );
							}
						};
					}
	
					// Create the abort callback
					callback = callback( "abort" );
	
					try {
	
						// Do send the request (this may raise an exception)
						xhr.send( options.hasContent && options.data || null );
					} catch ( e ) {
	
						// trac-14683: Only rethrow if this hasn't been notified as an error yet
						if ( callback ) {
							throw e;
						}
					}
				},
	
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
	jQuery.ajaxPrefilter( function( s ) {
		if ( s.crossDomain ) {
			s.contents.script = false;
		}
	} );
	
	// Install script dataType
	jQuery.ajaxSetup( {
		accepts: {
			script: "text/javascript, application/javascript, " +
				"application/ecmascript, application/x-ecmascript"
		},
		contents: {
			script: /\b(?:java|ecma)script\b/
		},
		converters: {
			"text script": function( text ) {
				jQuery.globalEval( text );
				return text;
			}
		}
	} );
	
	// Handle cache's special case and crossDomain
	jQuery.ajaxPrefilter( "script", function( s ) {
		if ( s.cache === undefined ) {
			s.cache = false;
		}
		if ( s.crossDomain ) {
			s.type = "GET";
		}
	} );
	
	// Bind script tag hack transport
	jQuery.ajaxTransport( "script", function( s ) {
	
		// This transport only deals with cross domain or forced-by-attrs requests
		if ( s.crossDomain || s.scriptAttrs ) {
			var script, callback;
			return {
				send: function( _, complete ) {
					script = jQuery( "<script>" )
						.attr( s.scriptAttrs || {} )
						.prop( { charset: s.scriptCharset, src: s.url } )
						.on( "load error", callback = function( evt ) {
							script.remove();
							callback = null;
							if ( evt ) {
								complete( evt.type === "error" ? 404 : 200, evt.type );
							}
						} );
	
					// Use native DOM manipulation to avoid our domManip AJAX trickery
					document.head.appendChild( script[ 0 ] );
				},
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	var oldCallbacks = [],
		rjsonp = /(=)\?(?=&|$)|\?\?/;
	
	// Default jsonp settings
	jQuery.ajaxSetup( {
		jsonp: "callback",
		jsonpCallback: function() {
			var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce.guid++ ) );
			this[ callback ] = true;
			return callback;
		}
	} );
	
	// Detect, normalize options and install callbacks for jsonp requests
	jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {
	
		var callbackName, overwritten, responseContainer,
			jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
				"url" :
				typeof s.data === "string" &&
					( s.contentType || "" )
						.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
					rjsonp.test( s.data ) && "data"
			);
	
		// Handle iff the expected data type is "jsonp" or we have a parameter to set
		if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {
	
			// Get callback name, remembering preexisting value associated with it
			callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
				s.jsonpCallback() :
				s.jsonpCallback;
	
			// Insert callback into url or form data
			if ( jsonProp ) {
				s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
			} else if ( s.jsonp !== false ) {
				s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
			}
	
			// Use data converter to retrieve json after script execution
			s.converters[ "script json" ] = function() {
				if ( !responseContainer ) {
					jQuery.error( callbackName + " was not called" );
				}
				return responseContainer[ 0 ];
			};
	
			// Force json dataType
			s.dataTypes[ 0 ] = "json";
	
			// Install callback
			overwritten = window[ callbackName ];
			window[ callbackName ] = function() {
				responseContainer = arguments;
			};
	
			// Clean-up function (fires after converters)
			jqXHR.always( function() {
	
				// If previous value didn't exist - remove it
				if ( overwritten === undefined ) {
					jQuery( window ).removeProp( callbackName );
	
				// Otherwise restore preexisting value
				} else {
					window[ callbackName ] = overwritten;
				}
	
				// Save back as free
				if ( s[ callbackName ] ) {
	
					// Make sure that re-using the options doesn't screw things around
					s.jsonpCallback = originalSettings.jsonpCallback;
	
					// Save the callback name for future use
					oldCallbacks.push( callbackName );
				}
	
				// Call if it was a function and we have a response
				if ( responseContainer && isFunction( overwritten ) ) {
					overwritten( responseContainer[ 0 ] );
				}
	
				responseContainer = overwritten = undefined;
			} );
	
			// Delegate to script
			return "script";
		}
	} );
	
	
	
	
	// Support: Safari 8 only
	// In Safari 8 documents created via document.implementation.createHTMLDocument
	// collapse sibling forms: the second one becomes a child of the first one.
	// Because of that, this security measure has to be disabled in Safari 8.
	// https://bugs.webkit.org/show_bug.cgi?id=137337
	support.createHTMLDocument = ( function() {
		var body = document.implementation.createHTMLDocument( "" ).body;
		body.innerHTML = "<form></form><form></form>";
		return body.childNodes.length === 2;
	} )();
	
	
	// Argument "data" should be string of html
	// context (optional): If specified, the fragment will be created in this context,
	// defaults to document
	// keepScripts (optional): If true, will include scripts passed in the html string
	jQuery.parseHTML = function( data, context, keepScripts ) {
		if ( typeof data !== "string" ) {
			return [];
		}
		if ( typeof context === "boolean" ) {
			keepScripts = context;
			context = false;
		}
	
		var base, parsed, scripts;
	
		if ( !context ) {
	
			// Stop scripts or inline event handlers from being executed immediately
			// by using document.implementation
			if ( support.createHTMLDocument ) {
				context = document.implementation.createHTMLDocument( "" );
	
				// Set the base href for the created document
				// so any parsed elements with URLs
				// are based on the document's URL (gh-2965)
				base = context.createElement( "base" );
				base.href = document.location.href;
				context.head.appendChild( base );
			} else {
				context = document;
			}
		}
	
		parsed = rsingleTag.exec( data );
		scripts = !keepScripts && [];
	
		// Single tag
		if ( parsed ) {
			return [ context.createElement( parsed[ 1 ] ) ];
		}
	
		parsed = buildFragment( [ data ], context, scripts );
	
		if ( scripts && scripts.length ) {
			jQuery( scripts ).remove();
		}
	
		return jQuery.merge( [], parsed.childNodes );
	};
	
	
	/**
	 * Load a url into a page
	 */
	jQuery.fn.load = function( url, params, callback ) {
		var selector, type, response,
			self = this,
			off = url.indexOf( " " );
	
		if ( off > -1 ) {
			selector = stripAndCollapse( url.slice( off ) );
			url = url.slice( 0, off );
		}
	
		// If it's a function
		if ( isFunction( params ) ) {
	
			// We assume that it's the callback
			callback = params;
			params = undefined;
	
		// Otherwise, build a param string
		} else if ( params && typeof params === "object" ) {
			type = "POST";
		}
	
		// If we have elements to modify, make the request
		if ( self.length > 0 ) {
			jQuery.ajax( {
				url: url,
	
				// If "type" variable is undefined, then "GET" method will be used.
				// Make value of this field explicit since
				// user can override it through ajaxSetup method
				type: type || "GET",
				dataType: "html",
				data: params
			} ).done( function( responseText ) {
	
				// Save response for use in complete callback
				response = arguments;
	
				self.html( selector ?
	
					// If a selector was specified, locate the right elements in a dummy div
					// Exclude scripts to avoid IE 'Permission Denied' errors
					jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :
	
					// Otherwise use the full result
					responseText );
	
			// If the request succeeds, this function gets "data", "status", "jqXHR"
			// but they are ignored because response was set above.
			// If it fails, this function gets "jqXHR", "status", "error"
			} ).always( callback && function( jqXHR, status ) {
				self.each( function() {
					callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
				} );
			} );
		}
	
		return this;
	};
	
	
	
	
	jQuery.expr.pseudos.animated = function( elem ) {
		return jQuery.grep( jQuery.timers, function( fn ) {
			return elem === fn.elem;
		} ).length;
	};
	
	
	
	
	jQuery.offset = {
		setOffset: function( elem, options, i ) {
			var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
				position = jQuery.css( elem, "position" ),
				curElem = jQuery( elem ),
				props = {};
	
			// Set position first, in-case top/left are set even on static elem
			if ( position === "static" ) {
				elem.style.position = "relative";
			}
	
			curOffset = curElem.offset();
			curCSSTop = jQuery.css( elem, "top" );
			curCSSLeft = jQuery.css( elem, "left" );
			calculatePosition = ( position === "absolute" || position === "fixed" ) &&
				( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;
	
			// Need to be able to calculate position if either
			// top or left is auto and position is either absolute or fixed
			if ( calculatePosition ) {
				curPosition = curElem.position();
				curTop = curPosition.top;
				curLeft = curPosition.left;
	
			} else {
				curTop = parseFloat( curCSSTop ) || 0;
				curLeft = parseFloat( curCSSLeft ) || 0;
			}
	
			if ( isFunction( options ) ) {
	
				// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
				options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
			}
	
			if ( options.top != null ) {
				props.top = ( options.top - curOffset.top ) + curTop;
			}
			if ( options.left != null ) {
				props.left = ( options.left - curOffset.left ) + curLeft;
			}
	
			if ( "using" in options ) {
				options.using.call( elem, props );
	
			} else {
				curElem.css( props );
			}
		}
	};
	
	jQuery.fn.extend( {
	
		// offset() relates an element's border box to the document origin
		offset: function( options ) {
	
			// Preserve chaining for setter
			if ( arguments.length ) {
				return options === undefined ?
					this :
					this.each( function( i ) {
						jQuery.offset.setOffset( this, options, i );
					} );
			}
	
			var rect, win,
				elem = this[ 0 ];
	
			if ( !elem ) {
				return;
			}
	
			// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
			// Support: IE <=11 only
			// Running getBoundingClientRect on a
			// disconnected node in IE throws an error
			if ( !elem.getClientRects().length ) {
				return { top: 0, left: 0 };
			}
	
			// Get document-relative position by adding viewport scroll to viewport-relative gBCR
			rect = elem.getBoundingClientRect();
			win = elem.ownerDocument.defaultView;
			return {
				top: rect.top + win.pageYOffset,
				left: rect.left + win.pageXOffset
			};
		},
	
		// position() relates an element's margin box to its offset parent's padding box
		// This corresponds to the behavior of CSS absolute positioning
		position: function() {
			if ( !this[ 0 ] ) {
				return;
			}
	
			var offsetParent, offset, doc,
				elem = this[ 0 ],
				parentOffset = { top: 0, left: 0 };
	
			// position:fixed elements are offset from the viewport, which itself always has zero offset
			if ( jQuery.css( elem, "position" ) === "fixed" ) {
	
				// Assume position:fixed implies availability of getBoundingClientRect
				offset = elem.getBoundingClientRect();
	
			} else {
				offset = this.offset();
	
				// Account for the *real* offset parent, which can be the document or its root element
				// when a statically positioned element is identified
				doc = elem.ownerDocument;
				offsetParent = elem.offsetParent || doc.documentElement;
				while ( offsetParent &&
					( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
					jQuery.css( offsetParent, "position" ) === "static" ) {
	
					offsetParent = offsetParent.parentNode;
				}
				if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {
	
					// Incorporate borders into its offset, since they are outside its content origin
					parentOffset = jQuery( offsetParent ).offset();
					parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
					parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
				}
			}
	
			// Subtract parent offsets and element margins
			return {
				top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
				left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
			};
		},
	
		// This method will return documentElement in the following cases:
		// 1) For the element inside the iframe without offsetParent, this method will return
		//    documentElement of the parent window
		// 2) For the hidden or detached element
		// 3) For body or html element, i.e. in case of the html node - it will return itself
		//
		// but those exceptions were never presented as a real life use-cases
		// and might be considered as more preferable results.
		//
		// This logic, however, is not guaranteed and can change at any point in the future
		offsetParent: function() {
			return this.map( function() {
				var offsetParent = this.offsetParent;
	
				while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
					offsetParent = offsetParent.offsetParent;
				}
	
				return offsetParent || documentElement;
			} );
		}
	} );
	
	// Create scrollLeft and scrollTop methods
	jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
		var top = "pageYOffset" === prop;
	
		jQuery.fn[ method ] = function( val ) {
			return access( this, function( elem, method, val ) {
	
				// Coalesce documents and windows
				var win;
				if ( isWindow( elem ) ) {
					win = elem;
				} else if ( elem.nodeType === 9 ) {
					win = elem.defaultView;
				}
	
				if ( val === undefined ) {
					return win ? win[ prop ] : elem[ method ];
				}
	
				if ( win ) {
					win.scrollTo(
						!top ? val : win.pageXOffset,
						top ? val : win.pageYOffset
					);
	
				} else {
					elem[ method ] = val;
				}
			}, method, val, arguments.length );
		};
	} );
	
	// Support: Safari <=7 - 9.1, Chrome <=37 - 49
	// Add the top/left cssHooks using jQuery.fn.position
	// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
	// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
	// getComputedStyle returns percent when specified for top/left/bottom/right;
	// rather than make the css module depend on the offset module, just check for it here
	jQuery.each( [ "top", "left" ], function( _i, prop ) {
		jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
			function( elem, computed ) {
				if ( computed ) {
					computed = curCSS( elem, prop );
	
					// If curCSS returns percentage, fallback to offset
					return rnumnonpx.test( computed ) ?
						jQuery( elem ).position()[ prop ] + "px" :
						computed;
				}
			}
		);
	} );
	
	
	// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
	jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
		jQuery.each( {
			padding: "inner" + name,
			content: type,
			"": "outer" + name
		}, function( defaultExtra, funcName ) {
	
			// Margin is only for outerHeight, outerWidth
			jQuery.fn[ funcName ] = function( margin, value ) {
				var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
					extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );
	
				return access( this, function( elem, type, value ) {
					var doc;
	
					if ( isWindow( elem ) ) {
	
						// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
						return funcName.indexOf( "outer" ) === 0 ?
							elem[ "inner" + name ] :
							elem.document.documentElement[ "client" + name ];
					}
	
					// Get document width or height
					if ( elem.nodeType === 9 ) {
						doc = elem.documentElement;
	
						// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
						// whichever is greatest
						return Math.max(
							elem.body[ "scroll" + name ], doc[ "scroll" + name ],
							elem.body[ "offset" + name ], doc[ "offset" + name ],
							doc[ "client" + name ]
						);
					}
	
					return value === undefined ?
	
						// Get width or height on the element, requesting but not forcing parseFloat
						jQuery.css( elem, type, extra ) :
	
						// Set width or height on the element
						jQuery.style( elem, type, value, extra );
				}, type, chainable ? margin : undefined, chainable );
			};
		} );
	} );
	
	
	jQuery.each( [
		"ajaxStart",
		"ajaxStop",
		"ajaxComplete",
		"ajaxError",
		"ajaxSuccess",
		"ajaxSend"
	], function( _i, type ) {
		jQuery.fn[ type ] = function( fn ) {
			return this.on( type, fn );
		};
	} );
	
	
	
	
	jQuery.fn.extend( {
	
		bind: function( types, data, fn ) {
			return this.on( types, null, data, fn );
		},
		unbind: function( types, fn ) {
			return this.off( types, null, fn );
		},
	
		delegate: function( selector, types, data, fn ) {
			return this.on( types, selector, data, fn );
		},
		undelegate: function( selector, types, fn ) {
	
			// ( namespace ) or ( selector, types [, fn] )
			return arguments.length === 1 ?
				this.off( selector, "**" ) :
				this.off( types, selector || "**", fn );
		},
	
		hover: function( fnOver, fnOut ) {
			return this
				.on( "mouseenter", fnOver )
				.on( "mouseleave", fnOut || fnOver );
		}
	} );
	
	jQuery.each(
		( "blur focus focusin focusout resize scroll click dblclick " +
		"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
		"change select submit keydown keypress keyup contextmenu" ).split( " " ),
		function( _i, name ) {
	
			// Handle event binding
			jQuery.fn[ name ] = function( data, fn ) {
				return arguments.length > 0 ?
					this.on( name, null, data, fn ) :
					this.trigger( name );
			};
		}
	);
	
	
	
	
	// Support: Android <=4.0 only
	// Make sure we trim BOM and NBSP
	// Require that the "whitespace run" starts from a non-whitespace
	// to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
	var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
	
	// Bind a function to a context, optionally partially applying any
	// arguments.
	// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
	// However, it is not slated for removal any time soon
	jQuery.proxy = function( fn, context ) {
		var tmp, args, proxy;
	
		if ( typeof context === "string" ) {
			tmp = fn[ context ];
			context = fn;
			fn = tmp;
		}
	
		// Quick check to determine if target is callable, in the spec
		// this throws a TypeError, but we will just return undefined.
		if ( !isFunction( fn ) ) {
			return undefined;
		}
	
		// Simulated bind
		args = slice.call( arguments, 2 );
		proxy = function() {
			return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
		};
	
		// Set the guid of unique handler to the same of original handler, so it can be removed
		proxy.guid = fn.guid = fn.guid || jQuery.guid++;
	
		return proxy;
	};
	
	jQuery.holdReady = function( hold ) {
		if ( hold ) {
			jQuery.readyWait++;
		} else {
			jQuery.ready( true );
		}
	};
	jQuery.isArray = Array.isArray;
	jQuery.parseJSON = JSON.parse;
	jQuery.nodeName = nodeName;
	jQuery.isFunction = isFunction;
	jQuery.isWindow = isWindow;
	jQuery.camelCase = camelCase;
	jQuery.type = toType;
	
	jQuery.now = Date.now;
	
	jQuery.isNumeric = function( obj ) {
	
		// As of jQuery 3.0, isNumeric is limited to
		// strings and numbers (primitives or objects)
		// that can be coerced to finite numbers (gh-2662)
		var type = jQuery.type( obj );
		return ( type === "number" || type === "string" ) &&
	
			// parseFloat NaNs numeric-cast false positives ("")
			// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
			// subtraction forces infinities to NaN
			!isNaN( obj - parseFloat( obj ) );
	};
	
	jQuery.trim = function( text ) {
		return text == null ?
			"" :
			( text + "" ).replace( rtrim, "$1" );
	};
	
	
	
	// Register as a named AMD module, since jQuery can be concatenated with other
	// files that may use define, but not via a proper concatenation script that
	// understands anonymous AMD modules. A named AMD is safest and most robust
	// way to register. Lowercase jquery is used because AMD module names are
	// derived from file names, and jQuery is normally delivered in a lowercase
	// file name. Do this after creating the global so that if an AMD module wants
	// to call noConflict to hide this version of jQuery, it will work.
	
	// Note that for maximum portability, libraries that are not jQuery should
	// declare themselves as anonymous modules, and avoid setting a global if an
	// AMD loader is present. jQuery is a special case. For more information, see
	// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
	
	if ( true ) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return jQuery;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	
	
	
	
	var
	
		// Map over jQuery in case of overwrite
		_jQuery = window.jQuery,
	
		// Map over the $ in case of overwrite
		_$ = window.$;
	
	jQuery.noConflict = function( deep ) {
		if ( window.$ === jQuery ) {
			window.$ = _$;
		}
	
		if ( deep && window.jQuery === jQuery ) {
			window.jQuery = _jQuery;
		}
	
		return jQuery;
	};
	
	// Expose jQuery and $ identifiers, even in AMD
	// (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
	// and CommonJS for browser emulators (trac-13566)
	if ( typeof noGlobal === "undefined" ) {
		window.jQuery = window.$ = jQuery;
	}
	
	
	
	
	return jQuery;
	} );


/***/ },
/* 6 */
/***/ function(module, exports) {

	function _extends() {
	  return (module.exports = _extends = Object.assign ? Object.assign.bind() : function (n) {
	    for (var e = 1; e < arguments.length; e++) {
	      var t = arguments[e];
	      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
	    }
	    return n;
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _extends.apply(null, arguments);
	}
	module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	//! version : 2.30.1
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	    var hookCallback;
	
	    function hooks() {
	        return hookCallback.apply(null, arguments);
	    }
	
	    // This is done to register the method called with moment()
	    // without creating circular dependencies.
	    function setHookCallback(callback) {
	        hookCallback = callback;
	    }
	
	    function isArray(input) {
	        return (
	            input instanceof Array ||
	            Object.prototype.toString.call(input) === '[object Array]'
	        );
	    }
	
	    function isObject(input) {
	        // IE8 will treat undefined and null as object if it wasn't for
	        // input != null
	        return (
	            input != null &&
	            Object.prototype.toString.call(input) === '[object Object]'
	        );
	    }
	
	    function hasOwnProp(a, b) {
	        return Object.prototype.hasOwnProperty.call(a, b);
	    }
	
	    function isObjectEmpty(obj) {
	        if (Object.getOwnPropertyNames) {
	            return Object.getOwnPropertyNames(obj).length === 0;
	        } else {
	            var k;
	            for (k in obj) {
	                if (hasOwnProp(obj, k)) {
	                    return false;
	                }
	            }
	            return true;
	        }
	    }
	
	    function isUndefined(input) {
	        return input === void 0;
	    }
	
	    function isNumber(input) {
	        return (
	            typeof input === 'number' ||
	            Object.prototype.toString.call(input) === '[object Number]'
	        );
	    }
	
	    function isDate(input) {
	        return (
	            input instanceof Date ||
	            Object.prototype.toString.call(input) === '[object Date]'
	        );
	    }
	
	    function map(arr, fn) {
	        var res = [],
	            i,
	            arrLen = arr.length;
	        for (i = 0; i < arrLen; ++i) {
	            res.push(fn(arr[i], i));
	        }
	        return res;
	    }
	
	    function extend(a, b) {
	        for (var i in b) {
	            if (hasOwnProp(b, i)) {
	                a[i] = b[i];
	            }
	        }
	
	        if (hasOwnProp(b, 'toString')) {
	            a.toString = b.toString;
	        }
	
	        if (hasOwnProp(b, 'valueOf')) {
	            a.valueOf = b.valueOf;
	        }
	
	        return a;
	    }
	
	    function createUTC(input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, true).utc();
	    }
	
	    function defaultParsingFlags() {
	        // We need to deep clone this object.
	        return {
	            empty: false,
	            unusedTokens: [],
	            unusedInput: [],
	            overflow: -2,
	            charsLeftOver: 0,
	            nullInput: false,
	            invalidEra: null,
	            invalidMonth: null,
	            invalidFormat: false,
	            userInvalidated: false,
	            iso: false,
	            parsedDateParts: [],
	            era: null,
	            meridiem: null,
	            rfc2822: false,
	            weekdayMismatch: false,
	        };
	    }
	
	    function getParsingFlags(m) {
	        if (m._pf == null) {
	            m._pf = defaultParsingFlags();
	        }
	        return m._pf;
	    }
	
	    var some;
	    if (Array.prototype.some) {
	        some = Array.prototype.some;
	    } else {
	        some = function (fun) {
	            var t = Object(this),
	                len = t.length >>> 0,
	                i;
	
	            for (i = 0; i < len; i++) {
	                if (i in t && fun.call(this, t[i], i, t)) {
	                    return true;
	                }
	            }
	
	            return false;
	        };
	    }
	
	    function isValid(m) {
	        var flags = null,
	            parsedParts = false,
	            isNowValid = m._d && !isNaN(m._d.getTime());
	        if (isNowValid) {
	            flags = getParsingFlags(m);
	            parsedParts = some.call(flags.parsedDateParts, function (i) {
	                return i != null;
	            });
	            isNowValid =
	                flags.overflow < 0 &&
	                !flags.empty &&
	                !flags.invalidEra &&
	                !flags.invalidMonth &&
	                !flags.invalidWeekday &&
	                !flags.weekdayMismatch &&
	                !flags.nullInput &&
	                !flags.invalidFormat &&
	                !flags.userInvalidated &&
	                (!flags.meridiem || (flags.meridiem && parsedParts));
	            if (m._strict) {
	                isNowValid =
	                    isNowValid &&
	                    flags.charsLeftOver === 0 &&
	                    flags.unusedTokens.length === 0 &&
	                    flags.bigHour === undefined;
	            }
	        }
	        if (Object.isFrozen == null || !Object.isFrozen(m)) {
	            m._isValid = isNowValid;
	        } else {
	            return isNowValid;
	        }
	        return m._isValid;
	    }
	
	    function createInvalid(flags) {
	        var m = createUTC(NaN);
	        if (flags != null) {
	            extend(getParsingFlags(m), flags);
	        } else {
	            getParsingFlags(m).userInvalidated = true;
	        }
	
	        return m;
	    }
	
	    // Plugins that add properties should also add the key here (null value),
	    // so we can properly clone ourselves.
	    var momentProperties = (hooks.momentProperties = []),
	        updateInProgress = false;
	
	    function copyConfig(to, from) {
	        var i,
	            prop,
	            val,
	            momentPropertiesLen = momentProperties.length;
	
	        if (!isUndefined(from._isAMomentObject)) {
	            to._isAMomentObject = from._isAMomentObject;
	        }
	        if (!isUndefined(from._i)) {
	            to._i = from._i;
	        }
	        if (!isUndefined(from._f)) {
	            to._f = from._f;
	        }
	        if (!isUndefined(from._l)) {
	            to._l = from._l;
	        }
	        if (!isUndefined(from._strict)) {
	            to._strict = from._strict;
	        }
	        if (!isUndefined(from._tzm)) {
	            to._tzm = from._tzm;
	        }
	        if (!isUndefined(from._isUTC)) {
	            to._isUTC = from._isUTC;
	        }
	        if (!isUndefined(from._offset)) {
	            to._offset = from._offset;
	        }
	        if (!isUndefined(from._pf)) {
	            to._pf = getParsingFlags(from);
	        }
	        if (!isUndefined(from._locale)) {
	            to._locale = from._locale;
	        }
	
	        if (momentPropertiesLen > 0) {
	            for (i = 0; i < momentPropertiesLen; i++) {
	                prop = momentProperties[i];
	                val = from[prop];
	                if (!isUndefined(val)) {
	                    to[prop] = val;
	                }
	            }
	        }
	
	        return to;
	    }
	
	    // Moment prototype object
	    function Moment(config) {
	        copyConfig(this, config);
	        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	        if (!this.isValid()) {
	            this._d = new Date(NaN);
	        }
	        // Prevent infinite loop in case updateOffset creates new moment
	        // objects.
	        if (updateInProgress === false) {
	            updateInProgress = true;
	            hooks.updateOffset(this);
	            updateInProgress = false;
	        }
	    }
	
	    function isMoment(obj) {
	        return (
	            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
	        );
	    }
	
	    function warn(msg) {
	        if (
	            hooks.suppressDeprecationWarnings === false &&
	            typeof console !== 'undefined' &&
	            console.warn
	        ) {
	            console.warn('Deprecation warning: ' + msg);
	        }
	    }
	
	    function deprecate(msg, fn) {
	        var firstTime = true;
	
	        return extend(function () {
	            if (hooks.deprecationHandler != null) {
	                hooks.deprecationHandler(null, msg);
	            }
	            if (firstTime) {
	                var args = [],
	                    arg,
	                    i,
	                    key,
	                    argLen = arguments.length;
	                for (i = 0; i < argLen; i++) {
	                    arg = '';
	                    if (typeof arguments[i] === 'object') {
	                        arg += '\n[' + i + '] ';
	                        for (key in arguments[0]) {
	                            if (hasOwnProp(arguments[0], key)) {
	                                arg += key + ': ' + arguments[0][key] + ', ';
	                            }
	                        }
	                        arg = arg.slice(0, -2); // Remove trailing comma and space
	                    } else {
	                        arg = arguments[i];
	                    }
	                    args.push(arg);
	                }
	                warn(
	                    msg +
	                        '\nArguments: ' +
	                        Array.prototype.slice.call(args).join('') +
	                        '\n' +
	                        new Error().stack
	                );
	                firstTime = false;
	            }
	            return fn.apply(this, arguments);
	        }, fn);
	    }
	
	    var deprecations = {};
	
	    function deprecateSimple(name, msg) {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(name, msg);
	        }
	        if (!deprecations[name]) {
	            warn(msg);
	            deprecations[name] = true;
	        }
	    }
	
	    hooks.suppressDeprecationWarnings = false;
	    hooks.deprecationHandler = null;
	
	    function isFunction(input) {
	        return (
	            (typeof Function !== 'undefined' && input instanceof Function) ||
	            Object.prototype.toString.call(input) === '[object Function]'
	        );
	    }
	
	    function set(config) {
	        var prop, i;
	        for (i in config) {
	            if (hasOwnProp(config, i)) {
	                prop = config[i];
	                if (isFunction(prop)) {
	                    this[i] = prop;
	                } else {
	                    this['_' + i] = prop;
	                }
	            }
	        }
	        this._config = config;
	        // Lenient ordinal parsing accepts just a number in addition to
	        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        this._dayOfMonthOrdinalParseLenient = new RegExp(
	            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	                '|' +
	                /\d{1,2}/.source
	        );
	    }
	
	    function mergeConfigs(parentConfig, childConfig) {
	        var res = extend({}, parentConfig),
	            prop;
	        for (prop in childConfig) {
	            if (hasOwnProp(childConfig, prop)) {
	                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                    res[prop] = {};
	                    extend(res[prop], parentConfig[prop]);
	                    extend(res[prop], childConfig[prop]);
	                } else if (childConfig[prop] != null) {
	                    res[prop] = childConfig[prop];
	                } else {
	                    delete res[prop];
	                }
	            }
	        }
	        for (prop in parentConfig) {
	            if (
	                hasOwnProp(parentConfig, prop) &&
	                !hasOwnProp(childConfig, prop) &&
	                isObject(parentConfig[prop])
	            ) {
	                // make sure changes to properties don't modify parent config
	                res[prop] = extend({}, res[prop]);
	            }
	        }
	        return res;
	    }
	
	    function Locale(config) {
	        if (config != null) {
	            this.set(config);
	        }
	    }
	
	    var keys;
	
	    if (Object.keys) {
	        keys = Object.keys;
	    } else {
	        keys = function (obj) {
	            var i,
	                res = [];
	            for (i in obj) {
	                if (hasOwnProp(obj, i)) {
	                    res.push(i);
	                }
	            }
	            return res;
	        };
	    }
	
	    var defaultCalendar = {
	        sameDay: '[Today at] LT',
	        nextDay: '[Tomorrow at] LT',
	        nextWeek: 'dddd [at] LT',
	        lastDay: '[Yesterday at] LT',
	        lastWeek: '[Last] dddd [at] LT',
	        sameElse: 'L',
	    };
	
	    function calendar(key, mom, now) {
	        var output = this._calendar[key] || this._calendar['sameElse'];
	        return isFunction(output) ? output.call(mom, now) : output;
	    }
	
	    function zeroFill(number, targetLength, forceSign) {
	        var absNumber = '' + Math.abs(number),
	            zerosToFill = targetLength - absNumber.length,
	            sign = number >= 0;
	        return (
	            (sign ? (forceSign ? '+' : '') : '-') +
	            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
	            absNumber
	        );
	    }
	
	    var formattingTokens =
	            /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
	        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
	        formatFunctions = {},
	        formatTokenFunctions = {};
	
	    // token:    'M'
	    // padded:   ['MM', 2]
	    // ordinal:  'Mo'
	    // callback: function () { this.month() + 1 }
	    function addFormatToken(token, padded, ordinal, callback) {
	        var func = callback;
	        if (typeof callback === 'string') {
	            func = function () {
	                return this[callback]();
	            };
	        }
	        if (token) {
	            formatTokenFunctions[token] = func;
	        }
	        if (padded) {
	            formatTokenFunctions[padded[0]] = function () {
	                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	            };
	        }
	        if (ordinal) {
	            formatTokenFunctions[ordinal] = function () {
	                return this.localeData().ordinal(
	                    func.apply(this, arguments),
	                    token
	                );
	            };
	        }
	    }
	
	    function removeFormattingTokens(input) {
	        if (input.match(/\[[\s\S]/)) {
	            return input.replace(/^\[|\]$/g, '');
	        }
	        return input.replace(/\\/g, '');
	    }
	
	    function makeFormatFunction(format) {
	        var array = format.match(formattingTokens),
	            i,
	            length;
	
	        for (i = 0, length = array.length; i < length; i++) {
	            if (formatTokenFunctions[array[i]]) {
	                array[i] = formatTokenFunctions[array[i]];
	            } else {
	                array[i] = removeFormattingTokens(array[i]);
	            }
	        }
	
	        return function (mom) {
	            var output = '',
	                i;
	            for (i = 0; i < length; i++) {
	                output += isFunction(array[i])
	                    ? array[i].call(mom, format)
	                    : array[i];
	            }
	            return output;
	        };
	    }
	
	    // format date using native date object
	    function formatMoment(m, format) {
	        if (!m.isValid()) {
	            return m.localeData().invalidDate();
	        }
	
	        format = expandFormat(format, m.localeData());
	        formatFunctions[format] =
	            formatFunctions[format] || makeFormatFunction(format);
	
	        return formatFunctions[format](m);
	    }
	
	    function expandFormat(format, locale) {
	        var i = 5;
	
	        function replaceLongDateFormatTokens(input) {
	            return locale.longDateFormat(input) || input;
	        }
	
	        localFormattingTokens.lastIndex = 0;
	        while (i >= 0 && localFormattingTokens.test(format)) {
	            format = format.replace(
	                localFormattingTokens,
	                replaceLongDateFormatTokens
	            );
	            localFormattingTokens.lastIndex = 0;
	            i -= 1;
	        }
	
	        return format;
	    }
	
	    var defaultLongDateFormat = {
	        LTS: 'h:mm:ss A',
	        LT: 'h:mm A',
	        L: 'MM/DD/YYYY',
	        LL: 'MMMM D, YYYY',
	        LLL: 'MMMM D, YYYY h:mm A',
	        LLLL: 'dddd, MMMM D, YYYY h:mm A',
	    };
	
	    function longDateFormat(key) {
	        var format = this._longDateFormat[key],
	            formatUpper = this._longDateFormat[key.toUpperCase()];
	
	        if (format || !formatUpper) {
	            return format;
	        }
	
	        this._longDateFormat[key] = formatUpper
	            .match(formattingTokens)
	            .map(function (tok) {
	                if (
	                    tok === 'MMMM' ||
	                    tok === 'MM' ||
	                    tok === 'DD' ||
	                    tok === 'dddd'
	                ) {
	                    return tok.slice(1);
	                }
	                return tok;
	            })
	            .join('');
	
	        return this._longDateFormat[key];
	    }
	
	    var defaultInvalidDate = 'Invalid date';
	
	    function invalidDate() {
	        return this._invalidDate;
	    }
	
	    var defaultOrdinal = '%d',
	        defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	    function ordinal(number) {
	        return this._ordinal.replace('%d', number);
	    }
	
	    var defaultRelativeTime = {
	        future: 'in %s',
	        past: '%s ago',
	        s: 'a few seconds',
	        ss: '%d seconds',
	        m: 'a minute',
	        mm: '%d minutes',
	        h: 'an hour',
	        hh: '%d hours',
	        d: 'a day',
	        dd: '%d days',
	        w: 'a week',
	        ww: '%d weeks',
	        M: 'a month',
	        MM: '%d months',
	        y: 'a year',
	        yy: '%d years',
	    };
	
	    function relativeTime(number, withoutSuffix, string, isFuture) {
	        var output = this._relativeTime[string];
	        return isFunction(output)
	            ? output(number, withoutSuffix, string, isFuture)
	            : output.replace(/%d/i, number);
	    }
	
	    function pastFuture(diff, output) {
	        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	    }
	
	    var aliases = {
	        D: 'date',
	        dates: 'date',
	        date: 'date',
	        d: 'day',
	        days: 'day',
	        day: 'day',
	        e: 'weekday',
	        weekdays: 'weekday',
	        weekday: 'weekday',
	        E: 'isoWeekday',
	        isoweekdays: 'isoWeekday',
	        isoweekday: 'isoWeekday',
	        DDD: 'dayOfYear',
	        dayofyears: 'dayOfYear',
	        dayofyear: 'dayOfYear',
	        h: 'hour',
	        hours: 'hour',
	        hour: 'hour',
	        ms: 'millisecond',
	        milliseconds: 'millisecond',
	        millisecond: 'millisecond',
	        m: 'minute',
	        minutes: 'minute',
	        minute: 'minute',
	        M: 'month',
	        months: 'month',
	        month: 'month',
	        Q: 'quarter',
	        quarters: 'quarter',
	        quarter: 'quarter',
	        s: 'second',
	        seconds: 'second',
	        second: 'second',
	        gg: 'weekYear',
	        weekyears: 'weekYear',
	        weekyear: 'weekYear',
	        GG: 'isoWeekYear',
	        isoweekyears: 'isoWeekYear',
	        isoweekyear: 'isoWeekYear',
	        w: 'week',
	        weeks: 'week',
	        week: 'week',
	        W: 'isoWeek',
	        isoweeks: 'isoWeek',
	        isoweek: 'isoWeek',
	        y: 'year',
	        years: 'year',
	        year: 'year',
	    };
	
	    function normalizeUnits(units) {
	        return typeof units === 'string'
	            ? aliases[units] || aliases[units.toLowerCase()]
	            : undefined;
	    }
	
	    function normalizeObjectUnits(inputObject) {
	        var normalizedInput = {},
	            normalizedProp,
	            prop;
	
	        for (prop in inputObject) {
	            if (hasOwnProp(inputObject, prop)) {
	                normalizedProp = normalizeUnits(prop);
	                if (normalizedProp) {
	                    normalizedInput[normalizedProp] = inputObject[prop];
	                }
	            }
	        }
	
	        return normalizedInput;
	    }
	
	    var priorities = {
	        date: 9,
	        day: 11,
	        weekday: 11,
	        isoWeekday: 11,
	        dayOfYear: 4,
	        hour: 13,
	        millisecond: 16,
	        minute: 14,
	        month: 8,
	        quarter: 7,
	        second: 15,
	        weekYear: 1,
	        isoWeekYear: 1,
	        week: 5,
	        isoWeek: 5,
	        year: 1,
	    };
	
	    function getPrioritizedUnits(unitsObj) {
	        var units = [],
	            u;
	        for (u in unitsObj) {
	            if (hasOwnProp(unitsObj, u)) {
	                units.push({ unit: u, priority: priorities[u] });
	            }
	        }
	        units.sort(function (a, b) {
	            return a.priority - b.priority;
	        });
	        return units;
	    }
	
	    var match1 = /\d/, //       0 - 9
	        match2 = /\d\d/, //      00 - 99
	        match3 = /\d{3}/, //     000 - 999
	        match4 = /\d{4}/, //    0000 - 9999
	        match6 = /[+-]?\d{6}/, // -999999 - 999999
	        match1to2 = /\d\d?/, //       0 - 99
	        match3to4 = /\d\d\d\d?/, //     999 - 9999
	        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
	        match1to3 = /\d{1,3}/, //       0 - 999
	        match1to4 = /\d{1,4}/, //       0 - 9999
	        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
	        matchUnsigned = /\d+/, //       0 - inf
	        matchSigned = /[+-]?\d+/, //    -inf - inf
	        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
	        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
	        // any word (or two) characters or numbers including two/three word month in arabic.
	        // includes scottish gaelic two word and hyphenated months
	        matchWord =
	            /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
	        match1to2NoLeadingZero = /^[1-9]\d?/, //         1-99
	        match1to2HasZero = /^([1-9]\d|\d)/, //           0-99
	        regexes;
	
	    regexes = {};
	
	    function addRegexToken(token, regex, strictRegex) {
	        regexes[token] = isFunction(regex)
	            ? regex
	            : function (isStrict, localeData) {
	                  return isStrict && strictRegex ? strictRegex : regex;
	              };
	    }
	
	    function getParseRegexForToken(token, config) {
	        if (!hasOwnProp(regexes, token)) {
	            return new RegExp(unescapeFormat(token));
	        }
	
	        return regexes[token](config._strict, config._locale);
	    }
	
	    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	    function unescapeFormat(s) {
	        return regexEscape(
	            s
	                .replace('\\', '')
	                .replace(
	                    /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
	                    function (matched, p1, p2, p3, p4) {
	                        return p1 || p2 || p3 || p4;
	                    }
	                )
	        );
	    }
	
	    function regexEscape(s) {
	        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	    }
	
	    function absFloor(number) {
	        if (number < 0) {
	            // -0 -> 0
	            return Math.ceil(number) || 0;
	        } else {
	            return Math.floor(number);
	        }
	    }
	
	    function toInt(argumentForCoercion) {
	        var coercedNumber = +argumentForCoercion,
	            value = 0;
	
	        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	            value = absFloor(coercedNumber);
	        }
	
	        return value;
	    }
	
	    var tokens = {};
	
	    function addParseToken(token, callback) {
	        var i,
	            func = callback,
	            tokenLen;
	        if (typeof token === 'string') {
	            token = [token];
	        }
	        if (isNumber(callback)) {
	            func = function (input, array) {
	                array[callback] = toInt(input);
	            };
	        }
	        tokenLen = token.length;
	        for (i = 0; i < tokenLen; i++) {
	            tokens[token[i]] = func;
	        }
	    }
	
	    function addWeekParseToken(token, callback) {
	        addParseToken(token, function (input, array, config, token) {
	            config._w = config._w || {};
	            callback(input, config._w, config, token);
	        });
	    }
	
	    function addTimeToArrayFromToken(token, input, config) {
	        if (input != null && hasOwnProp(tokens, token)) {
	            tokens[token](input, config._a, config, token);
	        }
	    }
	
	    function isLeapYear(year) {
	        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	    }
	
	    var YEAR = 0,
	        MONTH = 1,
	        DATE = 2,
	        HOUR = 3,
	        MINUTE = 4,
	        SECOND = 5,
	        MILLISECOND = 6,
	        WEEK = 7,
	        WEEKDAY = 8;
	
	    // FORMATTING
	
	    addFormatToken('Y', 0, 0, function () {
	        var y = this.year();
	        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
	    });
	
	    addFormatToken(0, ['YY', 2], 0, function () {
	        return this.year() % 100;
	    });
	
	    addFormatToken(0, ['YYYY', 4], 0, 'year');
	    addFormatToken(0, ['YYYYY', 5], 0, 'year');
	    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	    // PARSING
	
	    addRegexToken('Y', matchSigned);
	    addRegexToken('YY', match1to2, match2);
	    addRegexToken('YYYY', match1to4, match4);
	    addRegexToken('YYYYY', match1to6, match6);
	    addRegexToken('YYYYYY', match1to6, match6);
	
	    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	    addParseToken('YYYY', function (input, array) {
	        array[YEAR] =
	            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	    });
	    addParseToken('YY', function (input, array) {
	        array[YEAR] = hooks.parseTwoDigitYear(input);
	    });
	    addParseToken('Y', function (input, array) {
	        array[YEAR] = parseInt(input, 10);
	    });
	
	    // HELPERS
	
	    function daysInYear(year) {
	        return isLeapYear(year) ? 366 : 365;
	    }
	
	    // HOOKS
	
	    hooks.parseTwoDigitYear = function (input) {
	        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	    };
	
	    // MOMENTS
	
	    var getSetYear = makeGetSet('FullYear', true);
	
	    function getIsLeapYear() {
	        return isLeapYear(this.year());
	    }
	
	    function makeGetSet(unit, keepTime) {
	        return function (value) {
	            if (value != null) {
	                set$1(this, unit, value);
	                hooks.updateOffset(this, keepTime);
	                return this;
	            } else {
	                return get(this, unit);
	            }
	        };
	    }
	
	    function get(mom, unit) {
	        if (!mom.isValid()) {
	            return NaN;
	        }
	
	        var d = mom._d,
	            isUTC = mom._isUTC;
	
	        switch (unit) {
	            case 'Milliseconds':
	                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
	            case 'Seconds':
	                return isUTC ? d.getUTCSeconds() : d.getSeconds();
	            case 'Minutes':
	                return isUTC ? d.getUTCMinutes() : d.getMinutes();
	            case 'Hours':
	                return isUTC ? d.getUTCHours() : d.getHours();
	            case 'Date':
	                return isUTC ? d.getUTCDate() : d.getDate();
	            case 'Day':
	                return isUTC ? d.getUTCDay() : d.getDay();
	            case 'Month':
	                return isUTC ? d.getUTCMonth() : d.getMonth();
	            case 'FullYear':
	                return isUTC ? d.getUTCFullYear() : d.getFullYear();
	            default:
	                return NaN; // Just in case
	        }
	    }
	
	    function set$1(mom, unit, value) {
	        var d, isUTC, year, month, date;
	
	        if (!mom.isValid() || isNaN(value)) {
	            return;
	        }
	
	        d = mom._d;
	        isUTC = mom._isUTC;
	
	        switch (unit) {
	            case 'Milliseconds':
	                return void (isUTC
	                    ? d.setUTCMilliseconds(value)
	                    : d.setMilliseconds(value));
	            case 'Seconds':
	                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
	            case 'Minutes':
	                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
	            case 'Hours':
	                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
	            case 'Date':
	                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
	            // case 'Day': // Not real
	            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
	            // case 'Month': // Not used because we need to pass two variables
	            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
	            case 'FullYear':
	                break; // See below ...
	            default:
	                return; // Just in case
	        }
	
	        year = value;
	        month = mom.month();
	        date = mom.date();
	        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
	        void (isUTC
	            ? d.setUTCFullYear(year, month, date)
	            : d.setFullYear(year, month, date));
	    }
	
	    // MOMENTS
	
	    function stringGet(units) {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units]();
	        }
	        return this;
	    }
	
	    function stringSet(units, value) {
	        if (typeof units === 'object') {
	            units = normalizeObjectUnits(units);
	            var prioritized = getPrioritizedUnits(units),
	                i,
	                prioritizedLen = prioritized.length;
	            for (i = 0; i < prioritizedLen; i++) {
	                this[prioritized[i].unit](units[prioritized[i].unit]);
	            }
	        } else {
	            units = normalizeUnits(units);
	            if (isFunction(this[units])) {
	                return this[units](value);
	            }
	        }
	        return this;
	    }
	
	    function mod(n, x) {
	        return ((n % x) + x) % x;
	    }
	
	    var indexOf;
	
	    if (Array.prototype.indexOf) {
	        indexOf = Array.prototype.indexOf;
	    } else {
	        indexOf = function (o) {
	            // I know
	            var i;
	            for (i = 0; i < this.length; ++i) {
	                if (this[i] === o) {
	                    return i;
	                }
	            }
	            return -1;
	        };
	    }
	
	    function daysInMonth(year, month) {
	        if (isNaN(year) || isNaN(month)) {
	            return NaN;
	        }
	        var modMonth = mod(month, 12);
	        year += (month - modMonth) / 12;
	        return modMonth === 1
	            ? isLeapYear(year)
	                ? 29
	                : 28
	            : 31 - ((modMonth % 7) % 2);
	    }
	
	    // FORMATTING
	
	    addFormatToken('M', ['MM', 2], 'Mo', function () {
	        return this.month() + 1;
	    });
	
	    addFormatToken('MMM', 0, 0, function (format) {
	        return this.localeData().monthsShort(this, format);
	    });
	
	    addFormatToken('MMMM', 0, 0, function (format) {
	        return this.localeData().months(this, format);
	    });
	
	    // PARSING
	
	    addRegexToken('M', match1to2, match1to2NoLeadingZero);
	    addRegexToken('MM', match1to2, match2);
	    addRegexToken('MMM', function (isStrict, locale) {
	        return locale.monthsShortRegex(isStrict);
	    });
	    addRegexToken('MMMM', function (isStrict, locale) {
	        return locale.monthsRegex(isStrict);
	    });
	
	    addParseToken(['M', 'MM'], function (input, array) {
	        array[MONTH] = toInt(input) - 1;
	    });
	
	    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	        var month = config._locale.monthsParse(input, token, config._strict);
	        // if we didn't find a month name, mark the date as invalid.
	        if (month != null) {
	            array[MONTH] = month;
	        } else {
	            getParsingFlags(config).invalidMonth = input;
	        }
	    });
	
	    // LOCALES
	
	    var defaultLocaleMonths =
	            'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	                '_'
	            ),
	        defaultLocaleMonthsShort =
	            'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
	        defaultMonthsShortRegex = matchWord,
	        defaultMonthsRegex = matchWord;
	
	    function localeMonths(m, format) {
	        if (!m) {
	            return isArray(this._months)
	                ? this._months
	                : this._months['standalone'];
	        }
	        return isArray(this._months)
	            ? this._months[m.month()]
	            : this._months[
	                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
	                      ? 'format'
	                      : 'standalone'
	              ][m.month()];
	    }
	
	    function localeMonthsShort(m, format) {
	        if (!m) {
	            return isArray(this._monthsShort)
	                ? this._monthsShort
	                : this._monthsShort['standalone'];
	        }
	        return isArray(this._monthsShort)
	            ? this._monthsShort[m.month()]
	            : this._monthsShort[
	                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
	              ][m.month()];
	    }
	
	    function handleStrictParse(monthName, format, strict) {
	        var i,
	            ii,
	            mom,
	            llc = monthName.toLocaleLowerCase();
	        if (!this._monthsParse) {
	            // this is not used
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	            for (i = 0; i < 12; ++i) {
	                mom = createUTC([2000, i]);
	                this._shortMonthsParse[i] = this.monthsShort(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeMonthsParse(monthName, format, strict) {
	        var i, mom, regex;
	
	        if (this._monthsParseExact) {
	            return handleStrictParse.call(this, monthName, format, strict);
	        }
	
	        if (!this._monthsParse) {
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	        }
	
	        // TODO: add sorting
	        // Sorting makes sure if one month (or abbr) is a prefix of another
	        // see sorting in computeMonthsParse
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            if (strict && !this._longMonthsParse[i]) {
	                this._longMonthsParse[i] = new RegExp(
	                    '^' + this.months(mom, '').replace('.', '') + '$',
	                    'i'
	                );
	                this._shortMonthsParse[i] = new RegExp(
	                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
	                    'i'
	                );
	            }
	            if (!strict && !this._monthsParse[i]) {
	                regex =
	                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (
	                strict &&
	                format === 'MMMM' &&
	                this._longMonthsParse[i].test(monthName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'MMM' &&
	                this._shortMonthsParse[i].test(monthName)
	            ) {
	                return i;
	            } else if (!strict && this._monthsParse[i].test(monthName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function setMonth(mom, value) {
	        if (!mom.isValid()) {
	            // No op
	            return mom;
	        }
	
	        if (typeof value === 'string') {
	            if (/^\d+$/.test(value)) {
	                value = toInt(value);
	            } else {
	                value = mom.localeData().monthsParse(value);
	                // TODO: Another silent failure?
	                if (!isNumber(value)) {
	                    return mom;
	                }
	            }
	        }
	
	        var month = value,
	            date = mom.date();
	
	        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
	        void (mom._isUTC
	            ? mom._d.setUTCMonth(month, date)
	            : mom._d.setMonth(month, date));
	        return mom;
	    }
	
	    function getSetMonth(value) {
	        if (value != null) {
	            setMonth(this, value);
	            hooks.updateOffset(this, true);
	            return this;
	        } else {
	            return get(this, 'Month');
	        }
	    }
	
	    function getDaysInMonth() {
	        return daysInMonth(this.year(), this.month());
	    }
	
	    function monthsShortRegex(isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsShortStrictRegex;
	            } else {
	                return this._monthsShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsShortRegex')) {
	                this._monthsShortRegex = defaultMonthsShortRegex;
	            }
	            return this._monthsShortStrictRegex && isStrict
	                ? this._monthsShortStrictRegex
	                : this._monthsShortRegex;
	        }
	    }
	
	    function monthsRegex(isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsStrictRegex;
	            } else {
	                return this._monthsRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                this._monthsRegex = defaultMonthsRegex;
	            }
	            return this._monthsStrictRegex && isStrict
	                ? this._monthsStrictRegex
	                : this._monthsRegex;
	        }
	    }
	
	    function computeMonthsParse() {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var shortPieces = [],
	            longPieces = [],
	            mixedPieces = [],
	            i,
	            mom,
	            shortP,
	            longP;
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            shortP = regexEscape(this.monthsShort(mom, ''));
	            longP = regexEscape(this.months(mom, ''));
	            shortPieces.push(shortP);
	            longPieces.push(longP);
	            mixedPieces.push(longP);
	            mixedPieces.push(shortP);
	        }
	        // Sorting makes sure if one month (or abbr) is a prefix of another it
	        // will match the longer piece.
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	
	        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._monthsShortRegex = this._monthsRegex;
	        this._monthsStrictRegex = new RegExp(
	            '^(' + longPieces.join('|') + ')',
	            'i'
	        );
	        this._monthsShortStrictRegex = new RegExp(
	            '^(' + shortPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    function createDate(y, m, d, h, M, s, ms) {
	        // can't just apply() to create a date:
	        // https://stackoverflow.com/q/181348
	        var date;
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            date = new Date(y + 400, m, d, h, M, s, ms);
	            if (isFinite(date.getFullYear())) {
	                date.setFullYear(y);
	            }
	        } else {
	            date = new Date(y, m, d, h, M, s, ms);
	        }
	
	        return date;
	    }
	
	    function createUTCDate(y) {
	        var date, args;
	        // the Date.UTC function remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            args = Array.prototype.slice.call(arguments);
	            // preserve leap years using a full 400 year cycle, then reset
	            args[0] = y + 400;
	            date = new Date(Date.UTC.apply(null, args));
	            if (isFinite(date.getUTCFullYear())) {
	                date.setUTCFullYear(y);
	            }
	        } else {
	            date = new Date(Date.UTC.apply(null, arguments));
	        }
	
	        return date;
	    }
	
	    // start-of-first-week - start-of-year
	    function firstWeekOffset(year, dow, doy) {
	        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	            fwd = 7 + dow - doy,
	            // first-week day local weekday -- which local weekday is fwd
	            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	        return -fwdlw + fwd - 1;
	    }
	
	    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	        var localWeekday = (7 + weekday - dow) % 7,
	            weekOffset = firstWeekOffset(year, dow, doy),
	            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	            resYear,
	            resDayOfYear;
	
	        if (dayOfYear <= 0) {
	            resYear = year - 1;
	            resDayOfYear = daysInYear(resYear) + dayOfYear;
	        } else if (dayOfYear > daysInYear(year)) {
	            resYear = year + 1;
	            resDayOfYear = dayOfYear - daysInYear(year);
	        } else {
	            resYear = year;
	            resDayOfYear = dayOfYear;
	        }
	
	        return {
	            year: resYear,
	            dayOfYear: resDayOfYear,
	        };
	    }
	
	    function weekOfYear(mom, dow, doy) {
	        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	            resWeek,
	            resYear;
	
	        if (week < 1) {
	            resYear = mom.year() - 1;
	            resWeek = week + weeksInYear(resYear, dow, doy);
	        } else if (week > weeksInYear(mom.year(), dow, doy)) {
	            resWeek = week - weeksInYear(mom.year(), dow, doy);
	            resYear = mom.year() + 1;
	        } else {
	            resYear = mom.year();
	            resWeek = week;
	        }
	
	        return {
	            week: resWeek,
	            year: resYear,
	        };
	    }
	
	    function weeksInYear(year, dow, doy) {
	        var weekOffset = firstWeekOffset(year, dow, doy),
	            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	    }
	
	    // FORMATTING
	
	    addFormatToken('w', ['ww', 2], 'wo', 'week');
	    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	    // PARSING
	
	    addRegexToken('w', match1to2, match1to2NoLeadingZero);
	    addRegexToken('ww', match1to2, match2);
	    addRegexToken('W', match1to2, match1to2NoLeadingZero);
	    addRegexToken('WW', match1to2, match2);
	
	    addWeekParseToken(
	        ['w', 'ww', 'W', 'WW'],
	        function (input, week, config, token) {
	            week[token.substr(0, 1)] = toInt(input);
	        }
	    );
	
	    // HELPERS
	
	    // LOCALES
	
	    function localeWeek(mom) {
	        return weekOfYear(mom, this._week.dow, this._week.doy).week;
	    }
	
	    var defaultLocaleWeek = {
	        dow: 0, // Sunday is the first day of the week.
	        doy: 6, // The week that contains Jan 6th is the first week of the year.
	    };
	
	    function localeFirstDayOfWeek() {
	        return this._week.dow;
	    }
	
	    function localeFirstDayOfYear() {
	        return this._week.doy;
	    }
	
	    // MOMENTS
	
	    function getSetWeek(input) {
	        var week = this.localeData().week(this);
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    function getSetISOWeek(input) {
	        var week = weekOfYear(this, 1, 4).week;
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('d', 0, 'do', 'day');
	
	    addFormatToken('dd', 0, 0, function (format) {
	        return this.localeData().weekdaysMin(this, format);
	    });
	
	    addFormatToken('ddd', 0, 0, function (format) {
	        return this.localeData().weekdaysShort(this, format);
	    });
	
	    addFormatToken('dddd', 0, 0, function (format) {
	        return this.localeData().weekdays(this, format);
	    });
	
	    addFormatToken('e', 0, 0, 'weekday');
	    addFormatToken('E', 0, 0, 'isoWeekday');
	
	    // PARSING
	
	    addRegexToken('d', match1to2);
	    addRegexToken('e', match1to2);
	    addRegexToken('E', match1to2);
	    addRegexToken('dd', function (isStrict, locale) {
	        return locale.weekdaysMinRegex(isStrict);
	    });
	    addRegexToken('ddd', function (isStrict, locale) {
	        return locale.weekdaysShortRegex(isStrict);
	    });
	    addRegexToken('dddd', function (isStrict, locale) {
	        return locale.weekdaysRegex(isStrict);
	    });
	
	    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	        var weekday = config._locale.weekdaysParse(input, token, config._strict);
	        // if we didn't get a weekday name, mark the date as invalid
	        if (weekday != null) {
	            week.d = weekday;
	        } else {
	            getParsingFlags(config).invalidWeekday = input;
	        }
	    });
	
	    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	        week[token] = toInt(input);
	    });
	
	    // HELPERS
	
	    function parseWeekday(input, locale) {
	        if (typeof input !== 'string') {
	            return input;
	        }
	
	        if (!isNaN(input)) {
	            return parseInt(input, 10);
	        }
	
	        input = locale.weekdaysParse(input);
	        if (typeof input === 'number') {
	            return input;
	        }
	
	        return null;
	    }
	
	    function parseIsoWeekday(input, locale) {
	        if (typeof input === 'string') {
	            return locale.weekdaysParse(input) % 7 || 7;
	        }
	        return isNaN(input) ? null : input;
	    }
	
	    // LOCALES
	    function shiftWeekdays(ws, n) {
	        return ws.slice(n, 7).concat(ws.slice(0, n));
	    }
	
	    var defaultLocaleWeekdays =
	            'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        defaultWeekdaysRegex = matchWord,
	        defaultWeekdaysShortRegex = matchWord,
	        defaultWeekdaysMinRegex = matchWord;
	
	    function localeWeekdays(m, format) {
	        var weekdays = isArray(this._weekdays)
	            ? this._weekdays
	            : this._weekdays[
	                  m && m !== true && this._weekdays.isFormat.test(format)
	                      ? 'format'
	                      : 'standalone'
	              ];
	        return m === true
	            ? shiftWeekdays(weekdays, this._week.dow)
	            : m
	              ? weekdays[m.day()]
	              : weekdays;
	    }
	
	    function localeWeekdaysShort(m) {
	        return m === true
	            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
	            : m
	              ? this._weekdaysShort[m.day()]
	              : this._weekdaysShort;
	    }
	
	    function localeWeekdaysMin(m) {
	        return m === true
	            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
	            : m
	              ? this._weekdaysMin[m.day()]
	              : this._weekdaysMin;
	    }
	
	    function handleStrictParse$1(weekdayName, format, strict) {
	        var i,
	            ii,
	            mom,
	            llc = weekdayName.toLocaleLowerCase();
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._minWeekdaysParse = [];
	
	            for (i = 0; i < 7; ++i) {
	                mom = createUTC([2000, 1]).day(i);
	                this._minWeekdaysParse[i] = this.weekdaysMin(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._shortWeekdaysParse[i] = this.weekdaysShort(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeWeekdaysParse(weekdayName, format, strict) {
	        var i, mom, regex;
	
	        if (this._weekdaysParseExact) {
	            return handleStrictParse$1.call(this, weekdayName, format, strict);
	        }
	
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._minWeekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._fullWeekdaysParse = [];
	        }
	
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	
	            mom = createUTC([2000, 1]).day(i);
	            if (strict && !this._fullWeekdaysParse[i]) {
	                this._fullWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	                this._shortWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	                this._minWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	            }
	            if (!this._weekdaysParse[i]) {
	                regex =
	                    '^' +
	                    this.weekdays(mom, '') +
	                    '|^' +
	                    this.weekdaysShort(mom, '') +
	                    '|^' +
	                    this.weekdaysMin(mom, '');
	                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (
	                strict &&
	                format === 'dddd' &&
	                this._fullWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'ddd' &&
	                this._shortWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'dd' &&
	                this._minWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function getSetDayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	
	        var day = get(this, 'Day');
	        if (input != null) {
	            input = parseWeekday(input, this.localeData());
	            return this.add(input - day, 'd');
	        } else {
	            return day;
	        }
	    }
	
	    function getSetLocaleDayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	        return input == null ? weekday : this.add(input - weekday, 'd');
	    }
	
	    function getSetISODayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	
	        // behaves the same as moment#day except
	        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	        // as a setter, sunday should belong to the previous week.
	
	        if (input != null) {
	            var weekday = parseIsoWeekday(input, this.localeData());
	            return this.day(this.day() % 7 ? weekday : weekday - 7);
	        } else {
	            return this.day() || 7;
	        }
	    }
	
	    function weekdaysRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysStrictRegex;
	            } else {
	                return this._weekdaysRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                this._weekdaysRegex = defaultWeekdaysRegex;
	            }
	            return this._weekdaysStrictRegex && isStrict
	                ? this._weekdaysStrictRegex
	                : this._weekdaysRegex;
	        }
	    }
	
	    function weekdaysShortRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysShortStrictRegex;
	            } else {
	                return this._weekdaysShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	            }
	            return this._weekdaysShortStrictRegex && isStrict
	                ? this._weekdaysShortStrictRegex
	                : this._weekdaysShortRegex;
	        }
	    }
	
	    function weekdaysMinRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysMinStrictRegex;
	            } else {
	                return this._weekdaysMinRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	            }
	            return this._weekdaysMinStrictRegex && isStrict
	                ? this._weekdaysMinStrictRegex
	                : this._weekdaysMinRegex;
	        }
	    }
	
	    function computeWeekdaysParse() {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var minPieces = [],
	            shortPieces = [],
	            longPieces = [],
	            mixedPieces = [],
	            i,
	            mom,
	            minp,
	            shortp,
	            longp;
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, 1]).day(i);
	            minp = regexEscape(this.weekdaysMin(mom, ''));
	            shortp = regexEscape(this.weekdaysShort(mom, ''));
	            longp = regexEscape(this.weekdays(mom, ''));
	            minPieces.push(minp);
	            shortPieces.push(shortp);
	            longPieces.push(longp);
	            mixedPieces.push(minp);
	            mixedPieces.push(shortp);
	            mixedPieces.push(longp);
	        }
	        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	        // will match the longer piece.
	        minPieces.sort(cmpLenRev);
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	
	        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._weekdaysShortRegex = this._weekdaysRegex;
	        this._weekdaysMinRegex = this._weekdaysRegex;
	
	        this._weekdaysStrictRegex = new RegExp(
	            '^(' + longPieces.join('|') + ')',
	            'i'
	        );
	        this._weekdaysShortStrictRegex = new RegExp(
	            '^(' + shortPieces.join('|') + ')',
	            'i'
	        );
	        this._weekdaysMinStrictRegex = new RegExp(
	            '^(' + minPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    function hFormat() {
	        return this.hours() % 12 || 12;
	    }
	
	    function kFormat() {
	        return this.hours() || 24;
	    }
	
	    addFormatToken('H', ['HH', 2], 0, 'hour');
	    addFormatToken('h', ['hh', 2], 0, hFormat);
	    addFormatToken('k', ['kk', 2], 0, kFormat);
	
	    addFormatToken('hmm', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('hmmss', 0, 0, function () {
	        return (
	            '' +
	            hFormat.apply(this) +
	            zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2)
	        );
	    });
	
	    addFormatToken('Hmm', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('Hmmss', 0, 0, function () {
	        return (
	            '' +
	            this.hours() +
	            zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2)
	        );
	    });
	
	    function meridiem(token, lowercase) {
	        addFormatToken(token, 0, 0, function () {
	            return this.localeData().meridiem(
	                this.hours(),
	                this.minutes(),
	                lowercase
	            );
	        });
	    }
	
	    meridiem('a', true);
	    meridiem('A', false);
	
	    // PARSING
	
	    function matchMeridiem(isStrict, locale) {
	        return locale._meridiemParse;
	    }
	
	    addRegexToken('a', matchMeridiem);
	    addRegexToken('A', matchMeridiem);
	    addRegexToken('H', match1to2, match1to2HasZero);
	    addRegexToken('h', match1to2, match1to2NoLeadingZero);
	    addRegexToken('k', match1to2, match1to2NoLeadingZero);
	    addRegexToken('HH', match1to2, match2);
	    addRegexToken('hh', match1to2, match2);
	    addRegexToken('kk', match1to2, match2);
	
	    addRegexToken('hmm', match3to4);
	    addRegexToken('hmmss', match5to6);
	    addRegexToken('Hmm', match3to4);
	    addRegexToken('Hmmss', match5to6);
	
	    addParseToken(['H', 'HH'], HOUR);
	    addParseToken(['k', 'kk'], function (input, array, config) {
	        var kInput = toInt(input);
	        array[HOUR] = kInput === 24 ? 0 : kInput;
	    });
	    addParseToken(['a', 'A'], function (input, array, config) {
	        config._isPm = config._locale.isPM(input);
	        config._meridiem = input;
	    });
	    addParseToken(['h', 'hh'], function (input, array, config) {
	        array[HOUR] = toInt(input);
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmmss', function (input, array, config) {
	        var pos1 = input.length - 4,
	            pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('Hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	    });
	    addParseToken('Hmmss', function (input, array, config) {
	        var pos1 = input.length - 4,
	            pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	    });
	
	    // LOCALES
	
	    function localeIsPM(input) {
	        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	        // Using charAt should be more compatible.
	        return (input + '').toLowerCase().charAt(0) === 'p';
	    }
	
	    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
	        // Setting the hour should keep the time, because the user explicitly
	        // specified which hour they want. So trying to maintain the same hour (in
	        // a new timezone) makes sense. Adding/subtracting hours does not follow
	        // this rule.
	        getSetHour = makeGetSet('Hours', true);
	
	    function localeMeridiem(hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'pm' : 'PM';
	        } else {
	            return isLower ? 'am' : 'AM';
	        }
	    }
	
	    var baseConfig = {
	        calendar: defaultCalendar,
	        longDateFormat: defaultLongDateFormat,
	        invalidDate: defaultInvalidDate,
	        ordinal: defaultOrdinal,
	        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	        relativeTime: defaultRelativeTime,
	
	        months: defaultLocaleMonths,
	        monthsShort: defaultLocaleMonthsShort,
	
	        week: defaultLocaleWeek,
	
	        weekdays: defaultLocaleWeekdays,
	        weekdaysMin: defaultLocaleWeekdaysMin,
	        weekdaysShort: defaultLocaleWeekdaysShort,
	
	        meridiemParse: defaultLocaleMeridiemParse,
	    };
	
	    // internal storage for locale config files
	    var locales = {},
	        localeFamilies = {},
	        globalLocale;
	
	    function commonPrefix(arr1, arr2) {
	        var i,
	            minl = Math.min(arr1.length, arr2.length);
	        for (i = 0; i < minl; i += 1) {
	            if (arr1[i] !== arr2[i]) {
	                return i;
	            }
	        }
	        return minl;
	    }
	
	    function normalizeLocale(key) {
	        return key ? key.toLowerCase().replace('_', '-') : key;
	    }
	
	    // pick the locale from the array
	    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	    function chooseLocale(names) {
	        var i = 0,
	            j,
	            next,
	            locale,
	            split;
	
	        while (i < names.length) {
	            split = normalizeLocale(names[i]).split('-');
	            j = split.length;
	            next = normalizeLocale(names[i + 1]);
	            next = next ? next.split('-') : null;
	            while (j > 0) {
	                locale = loadLocale(split.slice(0, j).join('-'));
	                if (locale) {
	                    return locale;
	                }
	                if (
	                    next &&
	                    next.length >= j &&
	                    commonPrefix(split, next) >= j - 1
	                ) {
	                    //the next array item is better than a shallower substring of this one
	                    break;
	                }
	                j--;
	            }
	            i++;
	        }
	        return globalLocale;
	    }
	
	    function isLocaleNameSane(name) {
	        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
	        // Ensure name is available and function returns boolean
	        return !!(name && name.match('^[^/\\\\]*$'));
	    }
	
	    function loadLocale(name) {
	        var oldLocale = null,
	            aliasedRequire;
	        // TODO: Find a better way to register and load all the locales in Node
	        if (
	            locales[name] === undefined &&
	            typeof module !== 'undefined' &&
	            module &&
	            module.exports &&
	            isLocaleNameSane(name)
	        ) {
	            try {
	                oldLocale = globalLocale._abbr;
	                aliasedRequire = require;
	                __webpack_require__(1347)("./" + name);
	                getSetGlobalLocale(oldLocale);
	            } catch (e) {
	                // mark as not found to avoid repeating expensive file require call causing high CPU
	                // when trying to find en-US, en_US, en-us for every format call
	                locales[name] = null; // null means not found
	            }
	        }
	        return locales[name];
	    }
	
	    // This function will load locale and then set the global locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    function getSetGlobalLocale(key, values) {
	        var data;
	        if (key) {
	            if (isUndefined(values)) {
	                data = getLocale(key);
	            } else {
	                data = defineLocale(key, values);
	            }
	
	            if (data) {
	                // moment.duration._locale = moment._locale = data;
	                globalLocale = data;
	            } else {
	                if (typeof console !== 'undefined' && console.warn) {
	                    //warn user if arguments are passed but the locale could not be set
	                    console.warn(
	                        'Locale ' + key + ' not found. Did you forget to load it?'
	                    );
	                }
	            }
	        }
	
	        return globalLocale._abbr;
	    }
	
	    function defineLocale(name, config) {
	        if (config !== null) {
	            var locale,
	                parentConfig = baseConfig;
	            config.abbr = name;
	            if (locales[name] != null) {
	                deprecateSimple(
	                    'defineLocaleOverride',
	                    'use moment.updateLocale(localeName, config) to change ' +
	                        'an existing locale. moment.defineLocale(localeName, ' +
	                        'config) should only be used for creating a new locale ' +
	                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
	                );
	                parentConfig = locales[name]._config;
	            } else if (config.parentLocale != null) {
	                if (locales[config.parentLocale] != null) {
	                    parentConfig = locales[config.parentLocale]._config;
	                } else {
	                    locale = loadLocale(config.parentLocale);
	                    if (locale != null) {
	                        parentConfig = locale._config;
	                    } else {
	                        if (!localeFamilies[config.parentLocale]) {
	                            localeFamilies[config.parentLocale] = [];
	                        }
	                        localeFamilies[config.parentLocale].push({
	                            name: name,
	                            config: config,
	                        });
	                        return null;
	                    }
	                }
	            }
	            locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	            if (localeFamilies[name]) {
	                localeFamilies[name].forEach(function (x) {
	                    defineLocale(x.name, x.config);
	                });
	            }
	
	            // backwards compat for now: also set the locale
	            // make sure we set the locale AFTER all child locales have been
	            // created, so we won't end up with the child locale set.
	            getSetGlobalLocale(name);
	
	            return locales[name];
	        } else {
	            // useful for testing
	            delete locales[name];
	            return null;
	        }
	    }
	
	    function updateLocale(name, config) {
	        if (config != null) {
	            var locale,
	                tmpLocale,
	                parentConfig = baseConfig;
	
	            if (locales[name] != null && locales[name].parentLocale != null) {
	                // Update existing child locale in-place to avoid memory-leaks
	                locales[name].set(mergeConfigs(locales[name]._config, config));
	            } else {
	                // MERGE
	                tmpLocale = loadLocale(name);
	                if (tmpLocale != null) {
	                    parentConfig = tmpLocale._config;
	                }
	                config = mergeConfigs(parentConfig, config);
	                if (tmpLocale == null) {
	                    // updateLocale is called for creating a new locale
	                    // Set abbr so it will have a name (getters return
	                    // undefined otherwise).
	                    config.abbr = name;
	                }
	                locale = new Locale(config);
	                locale.parentLocale = locales[name];
	                locales[name] = locale;
	            }
	
	            // backwards compat for now: also set the locale
	            getSetGlobalLocale(name);
	        } else {
	            // pass null for config to unupdate, useful for tests
	            if (locales[name] != null) {
	                if (locales[name].parentLocale != null) {
	                    locales[name] = locales[name].parentLocale;
	                    if (name === getSetGlobalLocale()) {
	                        getSetGlobalLocale(name);
	                    }
	                } else if (locales[name] != null) {
	                    delete locales[name];
	                }
	            }
	        }
	        return locales[name];
	    }
	
	    // returns locale data
	    function getLocale(key) {
	        var locale;
	
	        if (key && key._locale && key._locale._abbr) {
	            key = key._locale._abbr;
	        }
	
	        if (!key) {
	            return globalLocale;
	        }
	
	        if (!isArray(key)) {
	            //short-circuit everything else
	            locale = loadLocale(key);
	            if (locale) {
	                return locale;
	            }
	            key = [key];
	        }
	
	        return chooseLocale(key);
	    }
	
	    function listLocales() {
	        return keys(locales);
	    }
	
	    function checkOverflow(m) {
	        var overflow,
	            a = m._a;
	
	        if (a && getParsingFlags(m).overflow === -2) {
	            overflow =
	                a[MONTH] < 0 || a[MONTH] > 11
	                    ? MONTH
	                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
	                      ? DATE
	                      : a[HOUR] < 0 ||
	                          a[HOUR] > 24 ||
	                          (a[HOUR] === 24 &&
	                              (a[MINUTE] !== 0 ||
	                                  a[SECOND] !== 0 ||
	                                  a[MILLISECOND] !== 0))
	                        ? HOUR
	                        : a[MINUTE] < 0 || a[MINUTE] > 59
	                          ? MINUTE
	                          : a[SECOND] < 0 || a[SECOND] > 59
	                            ? SECOND
	                            : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
	                              ? MILLISECOND
	                              : -1;
	
	            if (
	                getParsingFlags(m)._overflowDayOfYear &&
	                (overflow < YEAR || overflow > DATE)
	            ) {
	                overflow = DATE;
	            }
	            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	                overflow = WEEK;
	            }
	            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	                overflow = WEEKDAY;
	            }
	
	            getParsingFlags(m).overflow = overflow;
	        }
	
	        return m;
	    }
	
	    // iso 8601 regex
	    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	    var extendedIsoRegex =
	            /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
	        basicIsoRegex =
	            /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
	        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
	        isoDates = [
	            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	            ['YYYY-DDD', /\d{4}-\d{3}/],
	            ['YYYY-MM', /\d{4}-\d\d/, false],
	            ['YYYYYYMMDD', /[+-]\d{10}/],
	            ['YYYYMMDD', /\d{8}/],
	            ['GGGG[W]WWE', /\d{4}W\d{3}/],
	            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	            ['YYYYDDD', /\d{7}/],
	            ['YYYYMM', /\d{6}/, false],
	            ['YYYY', /\d{4}/, false],
	        ],
	        // iso time formats and regexes
	        isoTimes = [
	            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	            ['HH:mm', /\d\d:\d\d/],
	            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	            ['HHmmss', /\d\d\d\d\d\d/],
	            ['HHmm', /\d\d\d\d/],
	            ['HH', /\d\d/],
	        ],
	        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
	        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	        rfc2822 =
	            /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
	        obsOffsets = {
	            UT: 0,
	            GMT: 0,
	            EDT: -4 * 60,
	            EST: -5 * 60,
	            CDT: -5 * 60,
	            CST: -6 * 60,
	            MDT: -6 * 60,
	            MST: -7 * 60,
	            PDT: -7 * 60,
	            PST: -8 * 60,
	        };
	
	    // date from iso format
	    function configFromISO(config) {
	        var i,
	            l,
	            string = config._i,
	            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	            allowTime,
	            dateFormat,
	            timeFormat,
	            tzFormat,
	            isoDatesLen = isoDates.length,
	            isoTimesLen = isoTimes.length;
	
	        if (match) {
	            getParsingFlags(config).iso = true;
	            for (i = 0, l = isoDatesLen; i < l; i++) {
	                if (isoDates[i][1].exec(match[1])) {
	                    dateFormat = isoDates[i][0];
	                    allowTime = isoDates[i][2] !== false;
	                    break;
	                }
	            }
	            if (dateFormat == null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[3]) {
	                for (i = 0, l = isoTimesLen; i < l; i++) {
	                    if (isoTimes[i][1].exec(match[3])) {
	                        // match[2] should be 'T' or space
	                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                        break;
	                    }
	                }
	                if (timeFormat == null) {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            if (!allowTime && timeFormat != null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[4]) {
	                if (tzRegex.exec(match[4])) {
	                    tzFormat = 'Z';
	                } else {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	            configFromStringAndFormat(config);
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    function extractFromRFC2822Strings(
	        yearStr,
	        monthStr,
	        dayStr,
	        hourStr,
	        minuteStr,
	        secondStr
	    ) {
	        var result = [
	            untruncateYear(yearStr),
	            defaultLocaleMonthsShort.indexOf(monthStr),
	            parseInt(dayStr, 10),
	            parseInt(hourStr, 10),
	            parseInt(minuteStr, 10),
	        ];
	
	        if (secondStr) {
	            result.push(parseInt(secondStr, 10));
	        }
	
	        return result;
	    }
	
	    function untruncateYear(yearStr) {
	        var year = parseInt(yearStr, 10);
	        if (year <= 49) {
	            return 2000 + year;
	        } else if (year <= 999) {
	            return 1900 + year;
	        }
	        return year;
	    }
	
	    function preprocessRFC2822(s) {
	        // Remove comments and folding whitespace and replace multiple-spaces with a single space
	        return s
	            .replace(/\([^()]*\)|[\n\t]/g, ' ')
	            .replace(/(\s\s+)/g, ' ')
	            .replace(/^\s\s*/, '')
	            .replace(/\s\s*$/, '');
	    }
	
	    function checkWeekday(weekdayStr, parsedInput, config) {
	        if (weekdayStr) {
	            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
	            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
	                weekdayActual = new Date(
	                    parsedInput[0],
	                    parsedInput[1],
	                    parsedInput[2]
	                ).getDay();
	            if (weekdayProvided !== weekdayActual) {
	                getParsingFlags(config).weekdayMismatch = true;
	                config._isValid = false;
	                return false;
	            }
	        }
	        return true;
	    }
	
	    function calculateOffset(obsOffset, militaryOffset, numOffset) {
	        if (obsOffset) {
	            return obsOffsets[obsOffset];
	        } else if (militaryOffset) {
	            // the only allowed military tz is Z
	            return 0;
	        } else {
	            var hm = parseInt(numOffset, 10),
	                m = hm % 100,
	                h = (hm - m) / 100;
	            return h * 60 + m;
	        }
	    }
	
	    // date and time from ref 2822 format
	    function configFromRFC2822(config) {
	        var match = rfc2822.exec(preprocessRFC2822(config._i)),
	            parsedArray;
	        if (match) {
	            parsedArray = extractFromRFC2822Strings(
	                match[4],
	                match[3],
	                match[2],
	                match[5],
	                match[6],
	                match[7]
	            );
	            if (!checkWeekday(match[1], parsedArray, config)) {
	                return;
	            }
	
	            config._a = parsedArray;
	            config._tzm = calculateOffset(match[8], match[9], match[10]);
	
	            config._d = createUTCDate.apply(null, config._a);
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	
	            getParsingFlags(config).rfc2822 = true;
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
	    function configFromString(config) {
	        var matched = aspNetJsonRegex.exec(config._i);
	        if (matched !== null) {
	            config._d = new Date(+matched[1]);
	            return;
	        }
	
	        configFromISO(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        configFromRFC2822(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        if (config._strict) {
	            config._isValid = false;
	        } else {
	            // Final attempt, use Input Fallback
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    hooks.createFromInputFallback = deprecate(
	        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	        function (config) {
	            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	        }
	    );
	
	    // Pick the first defined of two or three arguments.
	    function defaults(a, b, c) {
	        if (a != null) {
	            return a;
	        }
	        if (b != null) {
	            return b;
	        }
	        return c;
	    }
	
	    function currentDateArray(config) {
	        // hooks is actually the exported moment object
	        var nowValue = new Date(hooks.now());
	        if (config._useUTC) {
	            return [
	                nowValue.getUTCFullYear(),
	                nowValue.getUTCMonth(),
	                nowValue.getUTCDate(),
	            ];
	        }
	        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	    }
	
	    // convert an array to a date.
	    // the array should mirror the parameters below
	    // note: all values past the year are optional and will default to the lowest possible value.
	    // [year, month, day , hour, minute, second, millisecond]
	    function configFromArray(config) {
	        var i,
	            date,
	            input = [],
	            currentDate,
	            expectedWeekday,
	            yearToUse;
	
	        if (config._d) {
	            return;
	        }
	
	        currentDate = currentDateArray(config);
	
	        //compute day of the year from weeks and weekdays
	        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	            dayOfYearFromWeekInfo(config);
	        }
	
	        //if the day of the year is set, figure out what it is
	        if (config._dayOfYear != null) {
	            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	            if (
	                config._dayOfYear > daysInYear(yearToUse) ||
	                config._dayOfYear === 0
	            ) {
	                getParsingFlags(config)._overflowDayOfYear = true;
	            }
	
	            date = createUTCDate(yearToUse, 0, config._dayOfYear);
	            config._a[MONTH] = date.getUTCMonth();
	            config._a[DATE] = date.getUTCDate();
	        }
	
	        // Default to current date.
	        // * if no year, month, day of month are given, default to today
	        // * if day of month is given, default month and year
	        // * if month is given, default only year
	        // * if year is given, don't default anything
	        for (i = 0; i < 3 && config._a[i] == null; ++i) {
	            config._a[i] = input[i] = currentDate[i];
	        }
	
	        // Zero out whatever was not defaulted, including time
	        for (; i < 7; i++) {
	            config._a[i] = input[i] =
	                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
	        }
	
	        // Check for 24:00:00.000
	        if (
	            config._a[HOUR] === 24 &&
	            config._a[MINUTE] === 0 &&
	            config._a[SECOND] === 0 &&
	            config._a[MILLISECOND] === 0
	        ) {
	            config._nextDay = true;
	            config._a[HOUR] = 0;
	        }
	
	        config._d = (config._useUTC ? createUTCDate : createDate).apply(
	            null,
	            input
	        );
	        expectedWeekday = config._useUTC
	            ? config._d.getUTCDay()
	            : config._d.getDay();
	
	        // Apply timezone offset from input. The actual utcOffset can be changed
	        // with parseZone.
	        if (config._tzm != null) {
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	        }
	
	        if (config._nextDay) {
	            config._a[HOUR] = 24;
	        }
	
	        // check for mismatching day of week
	        if (
	            config._w &&
	            typeof config._w.d !== 'undefined' &&
	            config._w.d !== expectedWeekday
	        ) {
	            getParsingFlags(config).weekdayMismatch = true;
	        }
	    }
	
	    function dayOfYearFromWeekInfo(config) {
	        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
	
	        w = config._w;
	        if (w.GG != null || w.W != null || w.E != null) {
	            dow = 1;
	            doy = 4;
	
	            // TODO: We need to take the current isoWeekYear, but that depends on
	            // how we interpret now (local, utc, fixed offset). So create
	            // a now version of current config (take local/utc/offset flags, and
	            // create now).
	            weekYear = defaults(
	                w.GG,
	                config._a[YEAR],
	                weekOfYear(createLocal(), 1, 4).year
	            );
	            week = defaults(w.W, 1);
	            weekday = defaults(w.E, 1);
	            if (weekday < 1 || weekday > 7) {
	                weekdayOverflow = true;
	            }
	        } else {
	            dow = config._locale._week.dow;
	            doy = config._locale._week.doy;
	
	            curWeek = weekOfYear(createLocal(), dow, doy);
	
	            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	            // Default to current week.
	            week = defaults(w.w, curWeek.week);
	
	            if (w.d != null) {
	                // weekday -- low day numbers are considered next week
	                weekday = w.d;
	                if (weekday < 0 || weekday > 6) {
	                    weekdayOverflow = true;
	                }
	            } else if (w.e != null) {
	                // local weekday -- counting starts from beginning of week
	                weekday = w.e + dow;
	                if (w.e < 0 || w.e > 6) {
	                    weekdayOverflow = true;
	                }
	            } else {
	                // default to beginning of week
	                weekday = dow;
	            }
	        }
	        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	            getParsingFlags(config)._overflowWeeks = true;
	        } else if (weekdayOverflow != null) {
	            getParsingFlags(config)._overflowWeekday = true;
	        } else {
	            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	            config._a[YEAR] = temp.year;
	            config._dayOfYear = temp.dayOfYear;
	        }
	    }
	
	    // constant that refers to the ISO standard
	    hooks.ISO_8601 = function () {};
	
	    // constant that refers to the RFC 2822 form
	    hooks.RFC_2822 = function () {};
	
	    // date from string and format string
	    function configFromStringAndFormat(config) {
	        // TODO: Move this to another part of the creation flow to prevent circular deps
	        if (config._f === hooks.ISO_8601) {
	            configFromISO(config);
	            return;
	        }
	        if (config._f === hooks.RFC_2822) {
	            configFromRFC2822(config);
	            return;
	        }
	        config._a = [];
	        getParsingFlags(config).empty = true;
	
	        // This array is used to make a Date, either with `new Date` or `Date.UTC`
	        var string = '' + config._i,
	            i,
	            parsedInput,
	            tokens,
	            token,
	            skipped,
	            stringLength = string.length,
	            totalParsedInputLength = 0,
	            era,
	            tokenLen;
	
	        tokens =
	            expandFormat(config._f, config._locale).match(formattingTokens) || [];
	        tokenLen = tokens.length;
	        for (i = 0; i < tokenLen; i++) {
	            token = tokens[i];
	            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
	                [])[0];
	            if (parsedInput) {
	                skipped = string.substr(0, string.indexOf(parsedInput));
	                if (skipped.length > 0) {
	                    getParsingFlags(config).unusedInput.push(skipped);
	                }
	                string = string.slice(
	                    string.indexOf(parsedInput) + parsedInput.length
	                );
	                totalParsedInputLength += parsedInput.length;
	            }
	            // don't parse if it's not a known token
	            if (formatTokenFunctions[token]) {
	                if (parsedInput) {
	                    getParsingFlags(config).empty = false;
	                } else {
	                    getParsingFlags(config).unusedTokens.push(token);
	                }
	                addTimeToArrayFromToken(token, parsedInput, config);
	            } else if (config._strict && !parsedInput) {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	        }
	
	        // add remaining unparsed input length to the string
	        getParsingFlags(config).charsLeftOver =
	            stringLength - totalParsedInputLength;
	        if (string.length > 0) {
	            getParsingFlags(config).unusedInput.push(string);
	        }
	
	        // clear _12h flag if hour is <= 12
	        if (
	            config._a[HOUR] <= 12 &&
	            getParsingFlags(config).bigHour === true &&
	            config._a[HOUR] > 0
	        ) {
	            getParsingFlags(config).bigHour = undefined;
	        }
	
	        getParsingFlags(config).parsedDateParts = config._a.slice(0);
	        getParsingFlags(config).meridiem = config._meridiem;
	        // handle meridiem
	        config._a[HOUR] = meridiemFixWrap(
	            config._locale,
	            config._a[HOUR],
	            config._meridiem
	        );
	
	        // handle era
	        era = getParsingFlags(config).era;
	        if (era !== null) {
	            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
	        }
	
	        configFromArray(config);
	        checkOverflow(config);
	    }
	
	    function meridiemFixWrap(locale, hour, meridiem) {
	        var isPm;
	
	        if (meridiem == null) {
	            // nothing to do
	            return hour;
	        }
	        if (locale.meridiemHour != null) {
	            return locale.meridiemHour(hour, meridiem);
	        } else if (locale.isPM != null) {
	            // Fallback
	            isPm = locale.isPM(meridiem);
	            if (isPm && hour < 12) {
	                hour += 12;
	            }
	            if (!isPm && hour === 12) {
	                hour = 0;
	            }
	            return hour;
	        } else {
	            // this is not supposed to happen
	            return hour;
	        }
	    }
	
	    // date from string and array of format strings
	    function configFromStringAndArray(config) {
	        var tempConfig,
	            bestMoment,
	            scoreToBeat,
	            i,
	            currentScore,
	            validFormatFound,
	            bestFormatIsValid = false,
	            configfLen = config._f.length;
	
	        if (configfLen === 0) {
	            getParsingFlags(config).invalidFormat = true;
	            config._d = new Date(NaN);
	            return;
	        }
	
	        for (i = 0; i < configfLen; i++) {
	            currentScore = 0;
	            validFormatFound = false;
	            tempConfig = copyConfig({}, config);
	            if (config._useUTC != null) {
	                tempConfig._useUTC = config._useUTC;
	            }
	            tempConfig._f = config._f[i];
	            configFromStringAndFormat(tempConfig);
	
	            if (isValid(tempConfig)) {
	                validFormatFound = true;
	            }
	
	            // if there is any input that was not parsed add a penalty for that format
	            currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	            //or tokens
	            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	            getParsingFlags(tempConfig).score = currentScore;
	
	            if (!bestFormatIsValid) {
	                if (
	                    scoreToBeat == null ||
	                    currentScore < scoreToBeat ||
	                    validFormatFound
	                ) {
	                    scoreToBeat = currentScore;
	                    bestMoment = tempConfig;
	                    if (validFormatFound) {
	                        bestFormatIsValid = true;
	                    }
	                }
	            } else {
	                if (currentScore < scoreToBeat) {
	                    scoreToBeat = currentScore;
	                    bestMoment = tempConfig;
	                }
	            }
	        }
	
	        extend(config, bestMoment || tempConfig);
	    }
	
	    function configFromObject(config) {
	        if (config._d) {
	            return;
	        }
	
	        var i = normalizeObjectUnits(config._i),
	            dayOrDate = i.day === undefined ? i.date : i.day;
	        config._a = map(
	            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
	            function (obj) {
	                return obj && parseInt(obj, 10);
	            }
	        );
	
	        configFromArray(config);
	    }
	
	    function createFromConfig(config) {
	        var res = new Moment(checkOverflow(prepareConfig(config)));
	        if (res._nextDay) {
	            // Adding is smart enough around DST
	            res.add(1, 'd');
	            res._nextDay = undefined;
	        }
	
	        return res;
	    }
	
	    function prepareConfig(config) {
	        var input = config._i,
	            format = config._f;
	
	        config._locale = config._locale || getLocale(config._l);
	
	        if (input === null || (format === undefined && input === '')) {
	            return createInvalid({ nullInput: true });
	        }
	
	        if (typeof input === 'string') {
	            config._i = input = config._locale.preparse(input);
	        }
	
	        if (isMoment(input)) {
	            return new Moment(checkOverflow(input));
	        } else if (isDate(input)) {
	            config._d = input;
	        } else if (isArray(format)) {
	            configFromStringAndArray(config);
	        } else if (format) {
	            configFromStringAndFormat(config);
	        } else {
	            configFromInput(config);
	        }
	
	        if (!isValid(config)) {
	            config._d = null;
	        }
	
	        return config;
	    }
	
	    function configFromInput(config) {
	        var input = config._i;
	        if (isUndefined(input)) {
	            config._d = new Date(hooks.now());
	        } else if (isDate(input)) {
	            config._d = new Date(input.valueOf());
	        } else if (typeof input === 'string') {
	            configFromString(config);
	        } else if (isArray(input)) {
	            config._a = map(input.slice(0), function (obj) {
	                return parseInt(obj, 10);
	            });
	            configFromArray(config);
	        } else if (isObject(input)) {
	            configFromObject(config);
	        } else if (isNumber(input)) {
	            // from milliseconds
	            config._d = new Date(input);
	        } else {
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    function createLocalOrUTC(input, format, locale, strict, isUTC) {
	        var c = {};
	
	        if (format === true || format === false) {
	            strict = format;
	            format = undefined;
	        }
	
	        if (locale === true || locale === false) {
	            strict = locale;
	            locale = undefined;
	        }
	
	        if (
	            (isObject(input) && isObjectEmpty(input)) ||
	            (isArray(input) && input.length === 0)
	        ) {
	            input = undefined;
	        }
	        // object construction must be done this way.
	        // https://github.com/moment/moment/issues/1423
	        c._isAMomentObject = true;
	        c._useUTC = c._isUTC = isUTC;
	        c._l = locale;
	        c._i = input;
	        c._f = format;
	        c._strict = strict;
	
	        return createFromConfig(c);
	    }
	
	    function createLocal(input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, false);
	    }
	
	    var prototypeMin = deprecate(
	            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	            function () {
	                var other = createLocal.apply(null, arguments);
	                if (this.isValid() && other.isValid()) {
	                    return other < this ? this : other;
	                } else {
	                    return createInvalid();
	                }
	            }
	        ),
	        prototypeMax = deprecate(
	            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	            function () {
	                var other = createLocal.apply(null, arguments);
	                if (this.isValid() && other.isValid()) {
	                    return other > this ? this : other;
	                } else {
	                    return createInvalid();
	                }
	            }
	        );
	
	    // Pick a moment m from moments so that m[fn](other) is true for all
	    // other. This relies on the function fn to be transitive.
	    //
	    // moments should either be an array of moment objects or an array, whose
	    // first element is an array of moment objects.
	    function pickBy(fn, moments) {
	        var res, i;
	        if (moments.length === 1 && isArray(moments[0])) {
	            moments = moments[0];
	        }
	        if (!moments.length) {
	            return createLocal();
	        }
	        res = moments[0];
	        for (i = 1; i < moments.length; ++i) {
	            if (!moments[i].isValid() || moments[i][fn](res)) {
	                res = moments[i];
	            }
	        }
	        return res;
	    }
	
	    // TODO: Use [].sort instead?
	    function min() {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isBefore', args);
	    }
	
	    function max() {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isAfter', args);
	    }
	
	    var now = function () {
	        return Date.now ? Date.now() : +new Date();
	    };
	
	    var ordering = [
	        'year',
	        'quarter',
	        'month',
	        'week',
	        'day',
	        'hour',
	        'minute',
	        'second',
	        'millisecond',
	    ];
	
	    function isDurationValid(m) {
	        var key,
	            unitHasDecimal = false,
	            i,
	            orderLen = ordering.length;
	        for (key in m) {
	            if (
	                hasOwnProp(m, key) &&
	                !(
	                    indexOf.call(ordering, key) !== -1 &&
	                    (m[key] == null || !isNaN(m[key]))
	                )
	            ) {
	                return false;
	            }
	        }
	
	        for (i = 0; i < orderLen; ++i) {
	            if (m[ordering[i]]) {
	                if (unitHasDecimal) {
	                    return false; // only allow non-integers for smallest unit
	                }
	                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                    unitHasDecimal = true;
	                }
	            }
	        }
	
	        return true;
	    }
	
	    function isValid$1() {
	        return this._isValid;
	    }
	
	    function createInvalid$1() {
	        return createDuration(NaN);
	    }
	
	    function Duration(duration) {
	        var normalizedInput = normalizeObjectUnits(duration),
	            years = normalizedInput.year || 0,
	            quarters = normalizedInput.quarter || 0,
	            months = normalizedInput.month || 0,
	            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
	            days = normalizedInput.day || 0,
	            hours = normalizedInput.hour || 0,
	            minutes = normalizedInput.minute || 0,
	            seconds = normalizedInput.second || 0,
	            milliseconds = normalizedInput.millisecond || 0;
	
	        this._isValid = isDurationValid(normalizedInput);
	
	        // representation for dateAddRemove
	        this._milliseconds =
	            +milliseconds +
	            seconds * 1e3 + // 1000
	            minutes * 6e4 + // 1000 * 60
	            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	        // Because of dateAddRemove treats 24 hours as different from a
	        // day when working around DST, we need to store them separately
	        this._days = +days + weeks * 7;
	        // It is impossible to translate months into days without knowing
	        // which months you are are talking about, so we have to store
	        // it separately.
	        this._months = +months + quarters * 3 + years * 12;
	
	        this._data = {};
	
	        this._locale = getLocale();
	
	        this._bubble();
	    }
	
	    function isDuration(obj) {
	        return obj instanceof Duration;
	    }
	
	    function absRound(number) {
	        if (number < 0) {
	            return Math.round(-1 * number) * -1;
	        } else {
	            return Math.round(number);
	        }
	    }
	
	    // compare two arrays, return the number of differences
	    function compareArrays(array1, array2, dontConvert) {
	        var len = Math.min(array1.length, array2.length),
	            lengthDiff = Math.abs(array1.length - array2.length),
	            diffs = 0,
	            i;
	        for (i = 0; i < len; i++) {
	            if (
	                (dontConvert && array1[i] !== array2[i]) ||
	                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
	            ) {
	                diffs++;
	            }
	        }
	        return diffs + lengthDiff;
	    }
	
	    // FORMATTING
	
	    function offset(token, separator) {
	        addFormatToken(token, 0, 0, function () {
	            var offset = this.utcOffset(),
	                sign = '+';
	            if (offset < 0) {
	                offset = -offset;
	                sign = '-';
	            }
	            return (
	                sign +
	                zeroFill(~~(offset / 60), 2) +
	                separator +
	                zeroFill(~~offset % 60, 2)
	            );
	        });
	    }
	
	    offset('Z', ':');
	    offset('ZZ', '');
	
	    // PARSING
	
	    addRegexToken('Z', matchShortOffset);
	    addRegexToken('ZZ', matchShortOffset);
	    addParseToken(['Z', 'ZZ'], function (input, array, config) {
	        config._useUTC = true;
	        config._tzm = offsetFromString(matchShortOffset, input);
	    });
	
	    // HELPERS
	
	    // timezone chunker
	    // '+10:00' > ['10',  '00']
	    // '-1530'  > ['-15', '30']
	    var chunkOffset = /([\+\-]|\d\d)/gi;
	
	    function offsetFromString(matcher, string) {
	        var matches = (string || '').match(matcher),
	            chunk,
	            parts,
	            minutes;
	
	        if (matches === null) {
	            return null;
	        }
	
	        chunk = matches[matches.length - 1] || [];
	        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	        minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
	    }
	
	    // Return a moment from input, that is local/utc/zone equivalent to model.
	    function cloneWithOffset(input, model) {
	        var res, diff;
	        if (model._isUTC) {
	            res = model.clone();
	            diff =
	                (isMoment(input) || isDate(input)
	                    ? input.valueOf()
	                    : createLocal(input).valueOf()) - res.valueOf();
	            // Use low-level api, because this fn is low-level api.
	            res._d.setTime(res._d.valueOf() + diff);
	            hooks.updateOffset(res, false);
	            return res;
	        } else {
	            return createLocal(input).local();
	        }
	    }
	
	    function getDateOffset(m) {
	        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	        // https://github.com/moment/moment/pull/1871
	        return -Math.round(m._d.getTimezoneOffset());
	    }
	
	    // HOOKS
	
	    // This function will be called whenever a moment is mutated.
	    // It is intended to keep the offset in sync with the timezone.
	    hooks.updateOffset = function () {};
	
	    // MOMENTS
	
	    // keepLocalTime = true means only change the timezone, without
	    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	    // +0200, so we adjust the time as needed, to be valid.
	    //
	    // Keeping the time actually adds/subtracts (one hour)
	    // from the actual represented time. That is why we call updateOffset
	    // a second time. In case it wants us to change the offset again
	    // _changeInProgress == true case, then we have to adjust, because
	    // there is no such time in the given timezone.
	    function getSetOffset(input, keepLocalTime, keepMinutes) {
	        var offset = this._offset || 0,
	            localAdjust;
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        if (input != null) {
	            if (typeof input === 'string') {
	                input = offsetFromString(matchShortOffset, input);
	                if (input === null) {
	                    return this;
	                }
	            } else if (Math.abs(input) < 16 && !keepMinutes) {
	                input = input * 60;
	            }
	            if (!this._isUTC && keepLocalTime) {
	                localAdjust = getDateOffset(this);
	            }
	            this._offset = input;
	            this._isUTC = true;
	            if (localAdjust != null) {
	                this.add(localAdjust, 'm');
	            }
	            if (offset !== input) {
	                if (!keepLocalTime || this._changeInProgress) {
	                    addSubtract(
	                        this,
	                        createDuration(input - offset, 'm'),
	                        1,
	                        false
	                    );
	                } else if (!this._changeInProgress) {
	                    this._changeInProgress = true;
	                    hooks.updateOffset(this, true);
	                    this._changeInProgress = null;
	                }
	            }
	            return this;
	        } else {
	            return this._isUTC ? offset : getDateOffset(this);
	        }
	    }
	
	    function getSetZone(input, keepLocalTime) {
	        if (input != null) {
	            if (typeof input !== 'string') {
	                input = -input;
	            }
	
	            this.utcOffset(input, keepLocalTime);
	
	            return this;
	        } else {
	            return -this.utcOffset();
	        }
	    }
	
	    function setOffsetToUTC(keepLocalTime) {
	        return this.utcOffset(0, keepLocalTime);
	    }
	
	    function setOffsetToLocal(keepLocalTime) {
	        if (this._isUTC) {
	            this.utcOffset(0, keepLocalTime);
	            this._isUTC = false;
	
	            if (keepLocalTime) {
	                this.subtract(getDateOffset(this), 'm');
	            }
	        }
	        return this;
	    }
	
	    function setOffsetToParsedOffset() {
	        if (this._tzm != null) {
	            this.utcOffset(this._tzm, false, true);
	        } else if (typeof this._i === 'string') {
	            var tZone = offsetFromString(matchOffset, this._i);
	            if (tZone != null) {
	                this.utcOffset(tZone);
	            } else {
	                this.utcOffset(0, true);
	            }
	        }
	        return this;
	    }
	
	    function hasAlignedHourOffset(input) {
	        if (!this.isValid()) {
	            return false;
	        }
	        input = input ? createLocal(input).utcOffset() : 0;
	
	        return (this.utcOffset() - input) % 60 === 0;
	    }
	
	    function isDaylightSavingTime() {
	        return (
	            this.utcOffset() > this.clone().month(0).utcOffset() ||
	            this.utcOffset() > this.clone().month(5).utcOffset()
	        );
	    }
	
	    function isDaylightSavingTimeShifted() {
	        if (!isUndefined(this._isDSTShifted)) {
	            return this._isDSTShifted;
	        }
	
	        var c = {},
	            other;
	
	        copyConfig(c, this);
	        c = prepareConfig(c);
	
	        if (c._a) {
	            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	            this._isDSTShifted =
	                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
	        } else {
	            this._isDSTShifted = false;
	        }
	
	        return this._isDSTShifted;
	    }
	
	    function isLocal() {
	        return this.isValid() ? !this._isUTC : false;
	    }
	
	    function isUtcOffset() {
	        return this.isValid() ? this._isUTC : false;
	    }
	
	    function isUtc() {
	        return this.isValid() ? this._isUTC && this._offset === 0 : false;
	    }
	
	    // ASP.NET json date format regex
	    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
	        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	        // and further modified to allow for strings containing both week and day
	        isoRegex =
	            /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
	
	    function createDuration(input, key) {
	        var duration = input,
	            // matching against regexp is expensive, do it on demand
	            match = null,
	            sign,
	            ret,
	            diffRes;
	
	        if (isDuration(input)) {
	            duration = {
	                ms: input._milliseconds,
	                d: input._days,
	                M: input._months,
	            };
	        } else if (isNumber(input) || !isNaN(+input)) {
	            duration = {};
	            if (key) {
	                duration[key] = +input;
	            } else {
	                duration.milliseconds = +input;
	            }
	        } else if ((match = aspNetRegex.exec(input))) {
	            sign = match[1] === '-' ? -1 : 1;
	            duration = {
	                y: 0,
	                d: toInt(match[DATE]) * sign,
	                h: toInt(match[HOUR]) * sign,
	                m: toInt(match[MINUTE]) * sign,
	                s: toInt(match[SECOND]) * sign,
	                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
	            };
	        } else if ((match = isoRegex.exec(input))) {
	            sign = match[1] === '-' ? -1 : 1;
	            duration = {
	                y: parseIso(match[2], sign),
	                M: parseIso(match[3], sign),
	                w: parseIso(match[4], sign),
	                d: parseIso(match[5], sign),
	                h: parseIso(match[6], sign),
	                m: parseIso(match[7], sign),
	                s: parseIso(match[8], sign),
	            };
	        } else if (duration == null) {
	            // checks for null or undefined
	            duration = {};
	        } else if (
	            typeof duration === 'object' &&
	            ('from' in duration || 'to' in duration)
	        ) {
	            diffRes = momentsDifference(
	                createLocal(duration.from),
	                createLocal(duration.to)
	            );
	
	            duration = {};
	            duration.ms = diffRes.milliseconds;
	            duration.M = diffRes.months;
	        }
	
	        ret = new Duration(duration);
	
	        if (isDuration(input) && hasOwnProp(input, '_locale')) {
	            ret._locale = input._locale;
	        }
	
	        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
	            ret._isValid = input._isValid;
	        }
	
	        return ret;
	    }
	
	    createDuration.fn = Duration.prototype;
	    createDuration.invalid = createInvalid$1;
	
	    function parseIso(inp, sign) {
	        // We'd normally use ~~inp for this, but unfortunately it also
	        // converts floats to ints.
	        // inp may be undefined, so careful calling replace on it.
	        var res = inp && parseFloat(inp.replace(',', '.'));
	        // apply sign while we're at it
	        return (isNaN(res) ? 0 : res) * sign;
	    }
	
	    function positiveMomentsDifference(base, other) {
	        var res = {};
	
	        res.months =
	            other.month() - base.month() + (other.year() - base.year()) * 12;
	        if (base.clone().add(res.months, 'M').isAfter(other)) {
	            --res.months;
	        }
	
	        res.milliseconds = +other - +base.clone().add(res.months, 'M');
	
	        return res;
	    }
	
	    function momentsDifference(base, other) {
	        var res;
	        if (!(base.isValid() && other.isValid())) {
	            return { milliseconds: 0, months: 0 };
	        }
	
	        other = cloneWithOffset(other, base);
	        if (base.isBefore(other)) {
	            res = positiveMomentsDifference(base, other);
	        } else {
	            res = positiveMomentsDifference(other, base);
	            res.milliseconds = -res.milliseconds;
	            res.months = -res.months;
	        }
	
	        return res;
	    }
	
	    // TODO: remove 'name' arg after deprecation is removed
	    function createAdder(direction, name) {
	        return function (val, period) {
	            var dur, tmp;
	            //invert the arguments, but complain about it
	            if (period !== null && !isNaN(+period)) {
	                deprecateSimple(
	                    name,
	                    'moment().' +
	                        name +
	                        '(period, number) is deprecated. Please use moment().' +
	                        name +
	                        '(number, period). ' +
	                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
	                );
	                tmp = val;
	                val = period;
	                period = tmp;
	            }
	
	            dur = createDuration(val, period);
	            addSubtract(this, dur, direction);
	            return this;
	        };
	    }
	
	    function addSubtract(mom, duration, isAdding, updateOffset) {
	        var milliseconds = duration._milliseconds,
	            days = absRound(duration._days),
	            months = absRound(duration._months);
	
	        if (!mom.isValid()) {
	            // No op
	            return;
	        }
	
	        updateOffset = updateOffset == null ? true : updateOffset;
	
	        if (months) {
	            setMonth(mom, get(mom, 'Month') + months * isAdding);
	        }
	        if (days) {
	            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	        }
	        if (milliseconds) {
	            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	        }
	        if (updateOffset) {
	            hooks.updateOffset(mom, days || months);
	        }
	    }
	
	    var add = createAdder(1, 'add'),
	        subtract = createAdder(-1, 'subtract');
	
	    function isString(input) {
	        return typeof input === 'string' || input instanceof String;
	    }
	
	    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
	    function isMomentInput(input) {
	        return (
	            isMoment(input) ||
	            isDate(input) ||
	            isString(input) ||
	            isNumber(input) ||
	            isNumberOrStringArray(input) ||
	            isMomentInputObject(input) ||
	            input === null ||
	            input === undefined
	        );
	    }
	
	    function isMomentInputObject(input) {
	        var objectTest = isObject(input) && !isObjectEmpty(input),
	            propertyTest = false,
	            properties = [
	                'years',
	                'year',
	                'y',
	                'months',
	                'month',
	                'M',
	                'days',
	                'day',
	                'd',
	                'dates',
	                'date',
	                'D',
	                'hours',
	                'hour',
	                'h',
	                'minutes',
	                'minute',
	                'm',
	                'seconds',
	                'second',
	                's',
	                'milliseconds',
	                'millisecond',
	                'ms',
	            ],
	            i,
	            property,
	            propertyLen = properties.length;
	
	        for (i = 0; i < propertyLen; i += 1) {
	            property = properties[i];
	            propertyTest = propertyTest || hasOwnProp(input, property);
	        }
	
	        return objectTest && propertyTest;
	    }
	
	    function isNumberOrStringArray(input) {
	        var arrayTest = isArray(input),
	            dataTypeTest = false;
	        if (arrayTest) {
	            dataTypeTest =
	                input.filter(function (item) {
	                    return !isNumber(item) && isString(input);
	                }).length === 0;
	        }
	        return arrayTest && dataTypeTest;
	    }
	
	    function isCalendarSpec(input) {
	        var objectTest = isObject(input) && !isObjectEmpty(input),
	            propertyTest = false,
	            properties = [
	                'sameDay',
	                'nextDay',
	                'lastDay',
	                'nextWeek',
	                'lastWeek',
	                'sameElse',
	            ],
	            i,
	            property;
	
	        for (i = 0; i < properties.length; i += 1) {
	            property = properties[i];
	            propertyTest = propertyTest || hasOwnProp(input, property);
	        }
	
	        return objectTest && propertyTest;
	    }
	
	    function getCalendarFormat(myMoment, now) {
	        var diff = myMoment.diff(now, 'days', true);
	        return diff < -6
	            ? 'sameElse'
	            : diff < -1
	              ? 'lastWeek'
	              : diff < 0
	                ? 'lastDay'
	                : diff < 1
	                  ? 'sameDay'
	                  : diff < 2
	                    ? 'nextDay'
	                    : diff < 7
	                      ? 'nextWeek'
	                      : 'sameElse';
	    }
	
	    function calendar$1(time, formats) {
	        // Support for single parameter, formats only overload to the calendar function
	        if (arguments.length === 1) {
	            if (!arguments[0]) {
	                time = undefined;
	                formats = undefined;
	            } else if (isMomentInput(arguments[0])) {
	                time = arguments[0];
	                formats = undefined;
	            } else if (isCalendarSpec(arguments[0])) {
	                formats = arguments[0];
	                time = undefined;
	            }
	        }
	        // We want to compare the start of today, vs this.
	        // Getting start-of-today depends on whether we're local/utc/offset or not.
	        var now = time || createLocal(),
	            sod = cloneWithOffset(now, this).startOf('day'),
	            format = hooks.calendarFormat(this, sod) || 'sameElse',
	            output =
	                formats &&
	                (isFunction(formats[format])
	                    ? formats[format].call(this, now)
	                    : formats[format]);
	
	        return this.format(
	            output || this.localeData().calendar(format, this, createLocal(now))
	        );
	    }
	
	    function clone() {
	        return new Moment(this);
	    }
	
	    function isAfter(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() > localInput.valueOf();
	        } else {
	            return localInput.valueOf() < this.clone().startOf(units).valueOf();
	        }
	    }
	
	    function isBefore(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() < localInput.valueOf();
	        } else {
	            return this.clone().endOf(units).valueOf() < localInput.valueOf();
	        }
	    }
	
	    function isBetween(from, to, units, inclusivity) {
	        var localFrom = isMoment(from) ? from : createLocal(from),
	            localTo = isMoment(to) ? to : createLocal(to);
	        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
	            return false;
	        }
	        inclusivity = inclusivity || '()';
	        return (
	            (inclusivity[0] === '('
	                ? this.isAfter(localFrom, units)
	                : !this.isBefore(localFrom, units)) &&
	            (inclusivity[1] === ')'
	                ? this.isBefore(localTo, units)
	                : !this.isAfter(localTo, units))
	        );
	    }
	
	    function isSame(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input),
	            inputMs;
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() === localInput.valueOf();
	        } else {
	            inputMs = localInput.valueOf();
	            return (
	                this.clone().startOf(units).valueOf() <= inputMs &&
	                inputMs <= this.clone().endOf(units).valueOf()
	            );
	        }
	    }
	
	    function isSameOrAfter(input, units) {
	        return this.isSame(input, units) || this.isAfter(input, units);
	    }
	
	    function isSameOrBefore(input, units) {
	        return this.isSame(input, units) || this.isBefore(input, units);
	    }
	
	    function diff(input, units, asFloat) {
	        var that, zoneDelta, output;
	
	        if (!this.isValid()) {
	            return NaN;
	        }
	
	        that = cloneWithOffset(input, this);
	
	        if (!that.isValid()) {
	            return NaN;
	        }
	
	        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	        units = normalizeUnits(units);
	
	        switch (units) {
	            case 'year':
	                output = monthDiff(this, that) / 12;
	                break;
	            case 'month':
	                output = monthDiff(this, that);
	                break;
	            case 'quarter':
	                output = monthDiff(this, that) / 3;
	                break;
	            case 'second':
	                output = (this - that) / 1e3;
	                break; // 1000
	            case 'minute':
	                output = (this - that) / 6e4;
	                break; // 1000 * 60
	            case 'hour':
	                output = (this - that) / 36e5;
	                break; // 1000 * 60 * 60
	            case 'day':
	                output = (this - that - zoneDelta) / 864e5;
	                break; // 1000 * 60 * 60 * 24, negate dst
	            case 'week':
	                output = (this - that - zoneDelta) / 6048e5;
	                break; // 1000 * 60 * 60 * 24 * 7, negate dst
	            default:
	                output = this - that;
	        }
	
	        return asFloat ? output : absFloor(output);
	    }
	
	    function monthDiff(a, b) {
	        if (a.date() < b.date()) {
	            // end-of-month calculations work correct when the start month has more
	            // days than the end month.
	            return -monthDiff(b, a);
	        }
	        // difference in months
	        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
	            // b is in (anchor - 1 month, anchor + 1 month)
	            anchor = a.clone().add(wholeMonthDiff, 'months'),
	            anchor2,
	            adjust;
	
	        if (b - anchor < 0) {
	            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor - anchor2);
	        } else {
	            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor2 - anchor);
	        }
	
	        //check for negative zero, return zero if negative zero
	        return -(wholeMonthDiff + adjust) || 0;
	    }
	
	    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	    function toString() {
	        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	    }
	
	    function toISOString(keepOffset) {
	        if (!this.isValid()) {
	            return null;
	        }
	        var utc = keepOffset !== true,
	            m = utc ? this.clone().utc() : this;
	        if (m.year() < 0 || m.year() > 9999) {
	            return formatMoment(
	                m,
	                utc
	                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
	                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
	            );
	        }
	        if (isFunction(Date.prototype.toISOString)) {
	            // native implementation is ~50x faster, use it when we can
	            if (utc) {
	                return this.toDate().toISOString();
	            } else {
	                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
	                    .toISOString()
	                    .replace('Z', formatMoment(m, 'Z'));
	            }
	        }
	        return formatMoment(
	            m,
	            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
	        );
	    }
	
	    /**
	     * Return a human readable representation of a moment that can
	     * also be evaluated to get a new moment which is the same
	     *
	     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	     */
	    function inspect() {
	        if (!this.isValid()) {
	            return 'moment.invalid(/* ' + this._i + ' */)';
	        }
	        var func = 'moment',
	            zone = '',
	            prefix,
	            year,
	            datetime,
	            suffix;
	        if (!this.isLocal()) {
	            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	            zone = 'Z';
	        }
	        prefix = '[' + func + '("]';
	        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
	        datetime = '-MM-DD[T]HH:mm:ss.SSS';
	        suffix = zone + '[")]';
	
	        return this.format(prefix + year + datetime + suffix);
	    }
	
	    function format(inputString) {
	        if (!inputString) {
	            inputString = this.isUtc()
	                ? hooks.defaultFormatUtc
	                : hooks.defaultFormat;
	        }
	        var output = formatMoment(this, inputString);
	        return this.localeData().postformat(output);
	    }
	
	    function from(time, withoutSuffix) {
	        if (
	            this.isValid() &&
	            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
	        ) {
	            return createDuration({ to: this, from: time })
	                .locale(this.locale())
	                .humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function fromNow(withoutSuffix) {
	        return this.from(createLocal(), withoutSuffix);
	    }
	
	    function to(time, withoutSuffix) {
	        if (
	            this.isValid() &&
	            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
	        ) {
	            return createDuration({ from: this, to: time })
	                .locale(this.locale())
	                .humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function toNow(withoutSuffix) {
	        return this.to(createLocal(), withoutSuffix);
	    }
	
	    // If passed a locale key, it will set the locale for this
	    // instance.  Otherwise, it will return the locale configuration
	    // variables for this instance.
	    function locale(key) {
	        var newLocaleData;
	
	        if (key === undefined) {
	            return this._locale._abbr;
	        } else {
	            newLocaleData = getLocale(key);
	            if (newLocaleData != null) {
	                this._locale = newLocaleData;
	            }
	            return this;
	        }
	    }
	
	    var lang = deprecate(
	        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	        function (key) {
	            if (key === undefined) {
	                return this.localeData();
	            } else {
	                return this.locale(key);
	            }
	        }
	    );
	
	    function localeData() {
	        return this._locale;
	    }
	
	    var MS_PER_SECOND = 1000,
	        MS_PER_MINUTE = 60 * MS_PER_SECOND,
	        MS_PER_HOUR = 60 * MS_PER_MINUTE,
	        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;
	
	    // actual modulo - handles negative numbers (for dates before 1970):
	    function mod$1(dividend, divisor) {
	        return ((dividend % divisor) + divisor) % divisor;
	    }
	
	    function localStartOfDate(y, m, d) {
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return new Date(y, m, d).valueOf();
	        }
	    }
	
	    function utcStartOfDate(y, m, d) {
	        // Date.UTC remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return Date.UTC(y, m, d);
	        }
	    }
	
	    function startOf(units) {
	        var time, startOfDate;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year(), 0, 1);
	                break;
	            case 'quarter':
	                time = startOfDate(
	                    this.year(),
	                    this.month() - (this.month() % 3),
	                    1
	                );
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month(), 1);
	                break;
	            case 'week':
	                time = startOfDate(
	                    this.year(),
	                    this.month(),
	                    this.date() - this.weekday()
	                );
	                break;
	            case 'isoWeek':
	                time = startOfDate(
	                    this.year(),
	                    this.month(),
	                    this.date() - (this.isoWeekday() - 1)
	                );
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date());
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time -= mod$1(
	                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
	                    MS_PER_HOUR
	                );
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_MINUTE);
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_SECOND);
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function endOf(units) {
	        var time, startOfDate;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year() + 1, 0, 1) - 1;
	                break;
	            case 'quarter':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month() - (this.month() % 3) + 3,
	                        1
	                    ) - 1;
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
	                break;
	            case 'week':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month(),
	                        this.date() - this.weekday() + 7
	                    ) - 1;
	                break;
	            case 'isoWeek':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month(),
	                        this.date() - (this.isoWeekday() - 1) + 7
	                    ) - 1;
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time +=
	                    MS_PER_HOUR -
	                    mod$1(
	                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
	                        MS_PER_HOUR
	                    ) -
	                    1;
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function valueOf() {
	        return this._d.valueOf() - (this._offset || 0) * 60000;
	    }
	
	    function unix() {
	        return Math.floor(this.valueOf() / 1000);
	    }
	
	    function toDate() {
	        return new Date(this.valueOf());
	    }
	
	    function toArray() {
	        var m = this;
	        return [
	            m.year(),
	            m.month(),
	            m.date(),
	            m.hour(),
	            m.minute(),
	            m.second(),
	            m.millisecond(),
	        ];
	    }
	
	    function toObject() {
	        var m = this;
	        return {
	            years: m.year(),
	            months: m.month(),
	            date: m.date(),
	            hours: m.hours(),
	            minutes: m.minutes(),
	            seconds: m.seconds(),
	            milliseconds: m.milliseconds(),
	        };
	    }
	
	    function toJSON() {
	        // new Date(NaN).toJSON() === null
	        return this.isValid() ? this.toISOString() : null;
	    }
	
	    function isValid$2() {
	        return isValid(this);
	    }
	
	    function parsingFlags() {
	        return extend({}, getParsingFlags(this));
	    }
	
	    function invalidAt() {
	        return getParsingFlags(this).overflow;
	    }
	
	    function creationData() {
	        return {
	            input: this._i,
	            format: this._f,
	            locale: this._locale,
	            isUTC: this._isUTC,
	            strict: this._strict,
	        };
	    }
	
	    addFormatToken('N', 0, 0, 'eraAbbr');
	    addFormatToken('NN', 0, 0, 'eraAbbr');
	    addFormatToken('NNN', 0, 0, 'eraAbbr');
	    addFormatToken('NNNN', 0, 0, 'eraName');
	    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
	
	    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
	    addFormatToken('y', ['yy', 2], 0, 'eraYear');
	    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
	    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');
	
	    addRegexToken('N', matchEraAbbr);
	    addRegexToken('NN', matchEraAbbr);
	    addRegexToken('NNN', matchEraAbbr);
	    addRegexToken('NNNN', matchEraName);
	    addRegexToken('NNNNN', matchEraNarrow);
	
	    addParseToken(
	        ['N', 'NN', 'NNN', 'NNNN', 'NNNNN'],
	        function (input, array, config, token) {
	            var era = config._locale.erasParse(input, token, config._strict);
	            if (era) {
	                getParsingFlags(config).era = era;
	            } else {
	                getParsingFlags(config).invalidEra = input;
	            }
	        }
	    );
	
	    addRegexToken('y', matchUnsigned);
	    addRegexToken('yy', matchUnsigned);
	    addRegexToken('yyy', matchUnsigned);
	    addRegexToken('yyyy', matchUnsigned);
	    addRegexToken('yo', matchEraYearOrdinal);
	
	    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
	    addParseToken(['yo'], function (input, array, config, token) {
	        var match;
	        if (config._locale._eraYearOrdinalRegex) {
	            match = input.match(config._locale._eraYearOrdinalRegex);
	        }
	
	        if (config._locale.eraYearOrdinalParse) {
	            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
	        } else {
	            array[YEAR] = parseInt(input, 10);
	        }
	    });
	
	    function localeEras(m, format) {
	        var i,
	            l,
	            date,
	            eras = this._eras || getLocale('en')._eras;
	        for (i = 0, l = eras.length; i < l; ++i) {
	            switch (typeof eras[i].since) {
	                case 'string':
	                    // truncate time
	                    date = hooks(eras[i].since).startOf('day');
	                    eras[i].since = date.valueOf();
	                    break;
	            }
	
	            switch (typeof eras[i].until) {
	                case 'undefined':
	                    eras[i].until = +Infinity;
	                    break;
	                case 'string':
	                    // truncate time
	                    date = hooks(eras[i].until).startOf('day').valueOf();
	                    eras[i].until = date.valueOf();
	                    break;
	            }
	        }
	        return eras;
	    }
	
	    function localeErasParse(eraName, format, strict) {
	        var i,
	            l,
	            eras = this.eras(),
	            name,
	            abbr,
	            narrow;
	        eraName = eraName.toUpperCase();
	
	        for (i = 0, l = eras.length; i < l; ++i) {
	            name = eras[i].name.toUpperCase();
	            abbr = eras[i].abbr.toUpperCase();
	            narrow = eras[i].narrow.toUpperCase();
	
	            if (strict) {
	                switch (format) {
	                    case 'N':
	                    case 'NN':
	                    case 'NNN':
	                        if (abbr === eraName) {
	                            return eras[i];
	                        }
	                        break;
	
	                    case 'NNNN':
	                        if (name === eraName) {
	                            return eras[i];
	                        }
	                        break;
	
	                    case 'NNNNN':
	                        if (narrow === eraName) {
	                            return eras[i];
	                        }
	                        break;
	                }
	            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
	                return eras[i];
	            }
	        }
	    }
	
	    function localeErasConvertYear(era, year) {
	        var dir = era.since <= era.until ? +1 : -1;
	        if (year === undefined) {
	            return hooks(era.since).year();
	        } else {
	            return hooks(era.since).year() + (year - era.offset) * dir;
	        }
	    }
	
	    function getEraName() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].name;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].name;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraNarrow() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].narrow;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].narrow;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraAbbr() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].abbr;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].abbr;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraYear() {
	        var i,
	            l,
	            dir,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            dir = eras[i].since <= eras[i].until ? +1 : -1;
	
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (
	                (eras[i].since <= val && val <= eras[i].until) ||
	                (eras[i].until <= val && val <= eras[i].since)
	            ) {
	                return (
	                    (this.year() - hooks(eras[i].since).year()) * dir +
	                    eras[i].offset
	                );
	            }
	        }
	
	        return this.year();
	    }
	
	    function erasNameRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasNameRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasNameRegex : this._erasRegex;
	    }
	
	    function erasAbbrRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasAbbrRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasAbbrRegex : this._erasRegex;
	    }
	
	    function erasNarrowRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasNarrowRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasNarrowRegex : this._erasRegex;
	    }
	
	    function matchEraAbbr(isStrict, locale) {
	        return locale.erasAbbrRegex(isStrict);
	    }
	
	    function matchEraName(isStrict, locale) {
	        return locale.erasNameRegex(isStrict);
	    }
	
	    function matchEraNarrow(isStrict, locale) {
	        return locale.erasNarrowRegex(isStrict);
	    }
	
	    function matchEraYearOrdinal(isStrict, locale) {
	        return locale._eraYearOrdinalRegex || matchUnsigned;
	    }
	
	    function computeErasParse() {
	        var abbrPieces = [],
	            namePieces = [],
	            narrowPieces = [],
	            mixedPieces = [],
	            i,
	            l,
	            erasName,
	            erasAbbr,
	            erasNarrow,
	            eras = this.eras();
	
	        for (i = 0, l = eras.length; i < l; ++i) {
	            erasName = regexEscape(eras[i].name);
	            erasAbbr = regexEscape(eras[i].abbr);
	            erasNarrow = regexEscape(eras[i].narrow);
	
	            namePieces.push(erasName);
	            abbrPieces.push(erasAbbr);
	            narrowPieces.push(erasNarrow);
	            mixedPieces.push(erasName);
	            mixedPieces.push(erasAbbr);
	            mixedPieces.push(erasNarrow);
	        }
	
	        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
	        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
	        this._erasNarrowRegex = new RegExp(
	            '^(' + narrowPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    addFormatToken(0, ['gg', 2], 0, function () {
	        return this.weekYear() % 100;
	    });
	
	    addFormatToken(0, ['GG', 2], 0, function () {
	        return this.isoWeekYear() % 100;
	    });
	
	    function addWeekYearFormatToken(token, getter) {
	        addFormatToken(0, [token, token.length], 0, getter);
	    }
	
	    addWeekYearFormatToken('gggg', 'weekYear');
	    addWeekYearFormatToken('ggggg', 'weekYear');
	    addWeekYearFormatToken('GGGG', 'isoWeekYear');
	    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	    // ALIASES
	
	    // PARSING
	
	    addRegexToken('G', matchSigned);
	    addRegexToken('g', matchSigned);
	    addRegexToken('GG', match1to2, match2);
	    addRegexToken('gg', match1to2, match2);
	    addRegexToken('GGGG', match1to4, match4);
	    addRegexToken('gggg', match1to4, match4);
	    addRegexToken('GGGGG', match1to6, match6);
	    addRegexToken('ggggg', match1to6, match6);
	
	    addWeekParseToken(
	        ['gggg', 'ggggg', 'GGGG', 'GGGGG'],
	        function (input, week, config, token) {
	            week[token.substr(0, 2)] = toInt(input);
	        }
	    );
	
	    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	        week[token] = hooks.parseTwoDigitYear(input);
	    });
	
	    // MOMENTS
	
	    function getSetWeekYear(input) {
	        return getSetWeekYearHelper.call(
	            this,
	            input,
	            this.week(),
	            this.weekday() + this.localeData()._week.dow,
	            this.localeData()._week.dow,
	            this.localeData()._week.doy
	        );
	    }
	
	    function getSetISOWeekYear(input) {
	        return getSetWeekYearHelper.call(
	            this,
	            input,
	            this.isoWeek(),
	            this.isoWeekday(),
	            1,
	            4
	        );
	    }
	
	    function getISOWeeksInYear() {
	        return weeksInYear(this.year(), 1, 4);
	    }
	
	    function getISOWeeksInISOWeekYear() {
	        return weeksInYear(this.isoWeekYear(), 1, 4);
	    }
	
	    function getWeeksInYear() {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getWeeksInWeekYear() {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	        var weeksTarget;
	        if (input == null) {
	            return weekOfYear(this, dow, doy).year;
	        } else {
	            weeksTarget = weeksInYear(input, dow, doy);
	            if (week > weeksTarget) {
	                week = weeksTarget;
	            }
	            return setWeekAll.call(this, input, week, weekday, dow, doy);
	        }
	    }
	
	    function setWeekAll(weekYear, week, weekday, dow, doy) {
	        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	        this.year(date.getUTCFullYear());
	        this.month(date.getUTCMonth());
	        this.date(date.getUTCDate());
	        return this;
	    }
	
	    // FORMATTING
	
	    addFormatToken('Q', 0, 'Qo', 'quarter');
	
	    // PARSING
	
	    addRegexToken('Q', match1);
	    addParseToken('Q', function (input, array) {
	        array[MONTH] = (toInt(input) - 1) * 3;
	    });
	
	    // MOMENTS
	
	    function getSetQuarter(input) {
	        return input == null
	            ? Math.ceil((this.month() + 1) / 3)
	            : this.month((input - 1) * 3 + (this.month() % 3));
	    }
	
	    // FORMATTING
	
	    addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	    // PARSING
	
	    addRegexToken('D', match1to2, match1to2NoLeadingZero);
	    addRegexToken('DD', match1to2, match2);
	    addRegexToken('Do', function (isStrict, locale) {
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        return isStrict
	            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
	            : locale._dayOfMonthOrdinalParseLenient;
	    });
	
	    addParseToken(['D', 'DD'], DATE);
	    addParseToken('Do', function (input, array) {
	        array[DATE] = toInt(input.match(match1to2)[0]);
	    });
	
	    // MOMENTS
	
	    var getSetDayOfMonth = makeGetSet('Date', true);
	
	    // FORMATTING
	
	    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	    // PARSING
	
	    addRegexToken('DDD', match1to3);
	    addRegexToken('DDDD', match3);
	    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	        config._dayOfYear = toInt(input);
	    });
	
	    // HELPERS
	
	    // MOMENTS
	
	    function getSetDayOfYear(input) {
	        var dayOfYear =
	            Math.round(
	                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
	            ) + 1;
	        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('m', ['mm', 2], 0, 'minute');
	
	    // PARSING
	
	    addRegexToken('m', match1to2, match1to2HasZero);
	    addRegexToken('mm', match1to2, match2);
	    addParseToken(['m', 'mm'], MINUTE);
	
	    // MOMENTS
	
	    var getSetMinute = makeGetSet('Minutes', false);
	
	    // FORMATTING
	
	    addFormatToken('s', ['ss', 2], 0, 'second');
	
	    // PARSING
	
	    addRegexToken('s', match1to2, match1to2HasZero);
	    addRegexToken('ss', match1to2, match2);
	    addParseToken(['s', 'ss'], SECOND);
	
	    // MOMENTS
	
	    var getSetSecond = makeGetSet('Seconds', false);
	
	    // FORMATTING
	
	    addFormatToken('S', 0, 0, function () {
	        return ~~(this.millisecond() / 100);
	    });
	
	    addFormatToken(0, ['SS', 2], 0, function () {
	        return ~~(this.millisecond() / 10);
	    });
	
	    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	    addFormatToken(0, ['SSSS', 4], 0, function () {
	        return this.millisecond() * 10;
	    });
	    addFormatToken(0, ['SSSSS', 5], 0, function () {
	        return this.millisecond() * 100;
	    });
	    addFormatToken(0, ['SSSSSS', 6], 0, function () {
	        return this.millisecond() * 1000;
	    });
	    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	        return this.millisecond() * 10000;
	    });
	    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	        return this.millisecond() * 100000;
	    });
	    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	        return this.millisecond() * 1000000;
	    });
	
	    // PARSING
	
	    addRegexToken('S', match1to3, match1);
	    addRegexToken('SS', match1to3, match2);
	    addRegexToken('SSS', match1to3, match3);
	
	    var token, getSetMillisecond;
	    for (token = 'SSSS'; token.length <= 9; token += 'S') {
	        addRegexToken(token, matchUnsigned);
	    }
	
	    function parseMs(input, array) {
	        array[MILLISECOND] = toInt(('0.' + input) * 1000);
	    }
	
	    for (token = 'S'; token.length <= 9; token += 'S') {
	        addParseToken(token, parseMs);
	    }
	
	    getSetMillisecond = makeGetSet('Milliseconds', false);
	
	    // FORMATTING
	
	    addFormatToken('z', 0, 0, 'zoneAbbr');
	    addFormatToken('zz', 0, 0, 'zoneName');
	
	    // MOMENTS
	
	    function getZoneAbbr() {
	        return this._isUTC ? 'UTC' : '';
	    }
	
	    function getZoneName() {
	        return this._isUTC ? 'Coordinated Universal Time' : '';
	    }
	
	    var proto = Moment.prototype;
	
	    proto.add = add;
	    proto.calendar = calendar$1;
	    proto.clone = clone;
	    proto.diff = diff;
	    proto.endOf = endOf;
	    proto.format = format;
	    proto.from = from;
	    proto.fromNow = fromNow;
	    proto.to = to;
	    proto.toNow = toNow;
	    proto.get = stringGet;
	    proto.invalidAt = invalidAt;
	    proto.isAfter = isAfter;
	    proto.isBefore = isBefore;
	    proto.isBetween = isBetween;
	    proto.isSame = isSame;
	    proto.isSameOrAfter = isSameOrAfter;
	    proto.isSameOrBefore = isSameOrBefore;
	    proto.isValid = isValid$2;
	    proto.lang = lang;
	    proto.locale = locale;
	    proto.localeData = localeData;
	    proto.max = prototypeMax;
	    proto.min = prototypeMin;
	    proto.parsingFlags = parsingFlags;
	    proto.set = stringSet;
	    proto.startOf = startOf;
	    proto.subtract = subtract;
	    proto.toArray = toArray;
	    proto.toObject = toObject;
	    proto.toDate = toDate;
	    proto.toISOString = toISOString;
	    proto.inspect = inspect;
	    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
	        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
	            return 'Moment<' + this.format() + '>';
	        };
	    }
	    proto.toJSON = toJSON;
	    proto.toString = toString;
	    proto.unix = unix;
	    proto.valueOf = valueOf;
	    proto.creationData = creationData;
	    proto.eraName = getEraName;
	    proto.eraNarrow = getEraNarrow;
	    proto.eraAbbr = getEraAbbr;
	    proto.eraYear = getEraYear;
	    proto.year = getSetYear;
	    proto.isLeapYear = getIsLeapYear;
	    proto.weekYear = getSetWeekYear;
	    proto.isoWeekYear = getSetISOWeekYear;
	    proto.quarter = proto.quarters = getSetQuarter;
	    proto.month = getSetMonth;
	    proto.daysInMonth = getDaysInMonth;
	    proto.week = proto.weeks = getSetWeek;
	    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
	    proto.weeksInYear = getWeeksInYear;
	    proto.weeksInWeekYear = getWeeksInWeekYear;
	    proto.isoWeeksInYear = getISOWeeksInYear;
	    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
	    proto.date = getSetDayOfMonth;
	    proto.day = proto.days = getSetDayOfWeek;
	    proto.weekday = getSetLocaleDayOfWeek;
	    proto.isoWeekday = getSetISODayOfWeek;
	    proto.dayOfYear = getSetDayOfYear;
	    proto.hour = proto.hours = getSetHour;
	    proto.minute = proto.minutes = getSetMinute;
	    proto.second = proto.seconds = getSetSecond;
	    proto.millisecond = proto.milliseconds = getSetMillisecond;
	    proto.utcOffset = getSetOffset;
	    proto.utc = setOffsetToUTC;
	    proto.local = setOffsetToLocal;
	    proto.parseZone = setOffsetToParsedOffset;
	    proto.hasAlignedHourOffset = hasAlignedHourOffset;
	    proto.isDST = isDaylightSavingTime;
	    proto.isLocal = isLocal;
	    proto.isUtcOffset = isUtcOffset;
	    proto.isUtc = isUtc;
	    proto.isUTC = isUtc;
	    proto.zoneAbbr = getZoneAbbr;
	    proto.zoneName = getZoneName;
	    proto.dates = deprecate(
	        'dates accessor is deprecated. Use date instead.',
	        getSetDayOfMonth
	    );
	    proto.months = deprecate(
	        'months accessor is deprecated. Use month instead',
	        getSetMonth
	    );
	    proto.years = deprecate(
	        'years accessor is deprecated. Use year instead',
	        getSetYear
	    );
	    proto.zone = deprecate(
	        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
	        getSetZone
	    );
	    proto.isDSTShifted = deprecate(
	        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
	        isDaylightSavingTimeShifted
	    );
	
	    function createUnix(input) {
	        return createLocal(input * 1000);
	    }
	
	    function createInZone() {
	        return createLocal.apply(null, arguments).parseZone();
	    }
	
	    function preParsePostFormat(string) {
	        return string;
	    }
	
	    var proto$1 = Locale.prototype;
	
	    proto$1.calendar = calendar;
	    proto$1.longDateFormat = longDateFormat;
	    proto$1.invalidDate = invalidDate;
	    proto$1.ordinal = ordinal;
	    proto$1.preparse = preParsePostFormat;
	    proto$1.postformat = preParsePostFormat;
	    proto$1.relativeTime = relativeTime;
	    proto$1.pastFuture = pastFuture;
	    proto$1.set = set;
	    proto$1.eras = localeEras;
	    proto$1.erasParse = localeErasParse;
	    proto$1.erasConvertYear = localeErasConvertYear;
	    proto$1.erasAbbrRegex = erasAbbrRegex;
	    proto$1.erasNameRegex = erasNameRegex;
	    proto$1.erasNarrowRegex = erasNarrowRegex;
	
	    proto$1.months = localeMonths;
	    proto$1.monthsShort = localeMonthsShort;
	    proto$1.monthsParse = localeMonthsParse;
	    proto$1.monthsRegex = monthsRegex;
	    proto$1.monthsShortRegex = monthsShortRegex;
	    proto$1.week = localeWeek;
	    proto$1.firstDayOfYear = localeFirstDayOfYear;
	    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	    proto$1.weekdays = localeWeekdays;
	    proto$1.weekdaysMin = localeWeekdaysMin;
	    proto$1.weekdaysShort = localeWeekdaysShort;
	    proto$1.weekdaysParse = localeWeekdaysParse;
	
	    proto$1.weekdaysRegex = weekdaysRegex;
	    proto$1.weekdaysShortRegex = weekdaysShortRegex;
	    proto$1.weekdaysMinRegex = weekdaysMinRegex;
	
	    proto$1.isPM = localeIsPM;
	    proto$1.meridiem = localeMeridiem;
	
	    function get$1(format, index, field, setter) {
	        var locale = getLocale(),
	            utc = createUTC().set(setter, index);
	        return locale[field](utc, format);
	    }
	
	    function listMonthsImpl(format, index, field) {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	
	        if (index != null) {
	            return get$1(format, index, field, 'month');
	        }
	
	        var i,
	            out = [];
	        for (i = 0; i < 12; i++) {
	            out[i] = get$1(format, i, field, 'month');
	        }
	        return out;
	    }
	
	    // ()
	    // (5)
	    // (fmt, 5)
	    // (fmt)
	    // (true)
	    // (true, 5)
	    // (true, fmt, 5)
	    // (true, fmt)
	    function listWeekdaysImpl(localeSorted, format, index, field) {
	        if (typeof localeSorted === 'boolean') {
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        } else {
	            format = localeSorted;
	            index = format;
	            localeSorted = false;
	
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        }
	
	        var locale = getLocale(),
	            shift = localeSorted ? locale._week.dow : 0,
	            i,
	            out = [];
	
	        if (index != null) {
	            return get$1(format, (index + shift) % 7, field, 'day');
	        }
	
	        for (i = 0; i < 7; i++) {
	            out[i] = get$1(format, (i + shift) % 7, field, 'day');
	        }
	        return out;
	    }
	
	    function listMonths(format, index) {
	        return listMonthsImpl(format, index, 'months');
	    }
	
	    function listMonthsShort(format, index) {
	        return listMonthsImpl(format, index, 'monthsShort');
	    }
	
	    function listWeekdays(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	    }
	
	    function listWeekdaysShort(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	    }
	
	    function listWeekdaysMin(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	    }
	
	    getSetGlobalLocale('en', {
	        eras: [
	            {
	                since: '0001-01-01',
	                until: +Infinity,
	                offset: 1,
	                name: 'Anno Domini',
	                narrow: 'AD',
	                abbr: 'AD',
	            },
	            {
	                since: '0000-12-31',
	                until: -Infinity,
	                offset: 1,
	                name: 'Before Christ',
	                narrow: 'BC',
	                abbr: 'BC',
	            },
	        ],
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    toInt((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                          ? 'st'
	                          : b === 2
	                            ? 'nd'
	                            : b === 3
	                              ? 'rd'
	                              : 'th';
	            return number + output;
	        },
	    });
	
	    // Side effect imports
	
	    hooks.lang = deprecate(
	        'moment.lang is deprecated. Use moment.locale instead.',
	        getSetGlobalLocale
	    );
	    hooks.langData = deprecate(
	        'moment.langData is deprecated. Use moment.localeData instead.',
	        getLocale
	    );
	
	    var mathAbs = Math.abs;
	
	    function abs() {
	        var data = this._data;
	
	        this._milliseconds = mathAbs(this._milliseconds);
	        this._days = mathAbs(this._days);
	        this._months = mathAbs(this._months);
	
	        data.milliseconds = mathAbs(data.milliseconds);
	        data.seconds = mathAbs(data.seconds);
	        data.minutes = mathAbs(data.minutes);
	        data.hours = mathAbs(data.hours);
	        data.months = mathAbs(data.months);
	        data.years = mathAbs(data.years);
	
	        return this;
	    }
	
	    function addSubtract$1(duration, input, value, direction) {
	        var other = createDuration(input, value);
	
	        duration._milliseconds += direction * other._milliseconds;
	        duration._days += direction * other._days;
	        duration._months += direction * other._months;
	
	        return duration._bubble();
	    }
	
	    // supports only 2.0-style add(1, 's') or add(duration)
	    function add$1(input, value) {
	        return addSubtract$1(this, input, value, 1);
	    }
	
	    // supports only 2.0-style subtract(1, 's') or subtract(duration)
	    function subtract$1(input, value) {
	        return addSubtract$1(this, input, value, -1);
	    }
	
	    function absCeil(number) {
	        if (number < 0) {
	            return Math.floor(number);
	        } else {
	            return Math.ceil(number);
	        }
	    }
	
	    function bubble() {
	        var milliseconds = this._milliseconds,
	            days = this._days,
	            months = this._months,
	            data = this._data,
	            seconds,
	            minutes,
	            hours,
	            years,
	            monthsFromDays;
	
	        // if we have a mix of positive and negative values, bubble down first
	        // check: https://github.com/moment/moment/issues/2166
	        if (
	            !(
	                (milliseconds >= 0 && days >= 0 && months >= 0) ||
	                (milliseconds <= 0 && days <= 0 && months <= 0)
	            )
	        ) {
	            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	            days = 0;
	            months = 0;
	        }
	
	        // The following code bubbles up values, see the tests for
	        // examples of what that means.
	        data.milliseconds = milliseconds % 1000;
	
	        seconds = absFloor(milliseconds / 1000);
	        data.seconds = seconds % 60;
	
	        minutes = absFloor(seconds / 60);
	        data.minutes = minutes % 60;
	
	        hours = absFloor(minutes / 60);
	        data.hours = hours % 24;
	
	        days += absFloor(hours / 24);
	
	        // convert days to months
	        monthsFromDays = absFloor(daysToMonths(days));
	        months += monthsFromDays;
	        days -= absCeil(monthsToDays(monthsFromDays));
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        data.days = days;
	        data.months = months;
	        data.years = years;
	
	        return this;
	    }
	
	    function daysToMonths(days) {
	        // 400 years have 146097 days (taking into account leap year rules)
	        // 400 years have 12 months === 4800
	        return (days * 4800) / 146097;
	    }
	
	    function monthsToDays(months) {
	        // the reverse of daysToMonths
	        return (months * 146097) / 4800;
	    }
	
	    function as(units) {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        var days,
	            months,
	            milliseconds = this._milliseconds;
	
	        units = normalizeUnits(units);
	
	        if (units === 'month' || units === 'quarter' || units === 'year') {
	            days = this._days + milliseconds / 864e5;
	            months = this._months + daysToMonths(days);
	            switch (units) {
	                case 'month':
	                    return months;
	                case 'quarter':
	                    return months / 3;
	                case 'year':
	                    return months / 12;
	            }
	        } else {
	            // handle milliseconds separately because of floating point math errors (issue #1867)
	            days = this._days + Math.round(monthsToDays(this._months));
	            switch (units) {
	                case 'week':
	                    return days / 7 + milliseconds / 6048e5;
	                case 'day':
	                    return days + milliseconds / 864e5;
	                case 'hour':
	                    return days * 24 + milliseconds / 36e5;
	                case 'minute':
	                    return days * 1440 + milliseconds / 6e4;
	                case 'second':
	                    return days * 86400 + milliseconds / 1000;
	                // Math.floor prevents floating point math errors here
	                case 'millisecond':
	                    return Math.floor(days * 864e5) + milliseconds;
	                default:
	                    throw new Error('Unknown unit ' + units);
	            }
	        }
	    }
	
	    function makeAs(alias) {
	        return function () {
	            return this.as(alias);
	        };
	    }
	
	    var asMilliseconds = makeAs('ms'),
	        asSeconds = makeAs('s'),
	        asMinutes = makeAs('m'),
	        asHours = makeAs('h'),
	        asDays = makeAs('d'),
	        asWeeks = makeAs('w'),
	        asMonths = makeAs('M'),
	        asQuarters = makeAs('Q'),
	        asYears = makeAs('y'),
	        valueOf$1 = asMilliseconds;
	
	    function clone$1() {
	        return createDuration(this);
	    }
	
	    function get$2(units) {
	        units = normalizeUnits(units);
	        return this.isValid() ? this[units + 's']() : NaN;
	    }
	
	    function makeGetter(name) {
	        return function () {
	            return this.isValid() ? this._data[name] : NaN;
	        };
	    }
	
	    var milliseconds = makeGetter('milliseconds'),
	        seconds = makeGetter('seconds'),
	        minutes = makeGetter('minutes'),
	        hours = makeGetter('hours'),
	        days = makeGetter('days'),
	        months = makeGetter('months'),
	        years = makeGetter('years');
	
	    function weeks() {
	        return absFloor(this.days() / 7);
	    }
	
	    var round = Math.round,
	        thresholds = {
	            ss: 44, // a few seconds to seconds
	            s: 45, // seconds to minute
	            m: 45, // minutes to hour
	            h: 22, // hours to day
	            d: 26, // days to month/week
	            w: null, // weeks to month
	            M: 11, // months to year
	        };
	
	    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	    }
	
	    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
	        var duration = createDuration(posNegDuration).abs(),
	            seconds = round(duration.as('s')),
	            minutes = round(duration.as('m')),
	            hours = round(duration.as('h')),
	            days = round(duration.as('d')),
	            months = round(duration.as('M')),
	            weeks = round(duration.as('w')),
	            years = round(duration.as('y')),
	            a =
	                (seconds <= thresholds.ss && ['s', seconds]) ||
	                (seconds < thresholds.s && ['ss', seconds]) ||
	                (minutes <= 1 && ['m']) ||
	                (minutes < thresholds.m && ['mm', minutes]) ||
	                (hours <= 1 && ['h']) ||
	                (hours < thresholds.h && ['hh', hours]) ||
	                (days <= 1 && ['d']) ||
	                (days < thresholds.d && ['dd', days]);
	
	        if (thresholds.w != null) {
	            a =
	                a ||
	                (weeks <= 1 && ['w']) ||
	                (weeks < thresholds.w && ['ww', weeks]);
	        }
	        a = a ||
	            (months <= 1 && ['M']) ||
	            (months < thresholds.M && ['MM', months]) ||
	            (years <= 1 && ['y']) || ['yy', years];
	
	        a[2] = withoutSuffix;
	        a[3] = +posNegDuration > 0;
	        a[4] = locale;
	        return substituteTimeAgo.apply(null, a);
	    }
	
	    // This function allows you to set the rounding function for relative time strings
	    function getSetRelativeTimeRounding(roundingFunction) {
	        if (roundingFunction === undefined) {
	            return round;
	        }
	        if (typeof roundingFunction === 'function') {
	            round = roundingFunction;
	            return true;
	        }
	        return false;
	    }
	
	    // This function allows you to set a threshold for relative time strings
	    function getSetRelativeTimeThreshold(threshold, limit) {
	        if (thresholds[threshold] === undefined) {
	            return false;
	        }
	        if (limit === undefined) {
	            return thresholds[threshold];
	        }
	        thresholds[threshold] = limit;
	        if (threshold === 's') {
	            thresholds.ss = limit - 1;
	        }
	        return true;
	    }
	
	    function humanize(argWithSuffix, argThresholds) {
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var withSuffix = false,
	            th = thresholds,
	            locale,
	            output;
	
	        if (typeof argWithSuffix === 'object') {
	            argThresholds = argWithSuffix;
	            argWithSuffix = false;
	        }
	        if (typeof argWithSuffix === 'boolean') {
	            withSuffix = argWithSuffix;
	        }
	        if (typeof argThresholds === 'object') {
	            th = Object.assign({}, thresholds, argThresholds);
	            if (argThresholds.s != null && argThresholds.ss == null) {
	                th.ss = argThresholds.s - 1;
	            }
	        }
	
	        locale = this.localeData();
	        output = relativeTime$1(this, !withSuffix, th, locale);
	
	        if (withSuffix) {
	            output = locale.pastFuture(+this, output);
	        }
	
	        return locale.postformat(output);
	    }
	
	    var abs$1 = Math.abs;
	
	    function sign(x) {
	        return (x > 0) - (x < 0) || +x;
	    }
	
	    function toISOString$1() {
	        // for ISO strings we do not use the normal bubbling rules:
	        //  * milliseconds bubble up until they become hours
	        //  * days do not bubble at all
	        //  * months bubble up until they become years
	        // This is because there is no context-free conversion between hours and days
	        // (think of clock changes)
	        // and also not between days and months (28-31 days per month)
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var seconds = abs$1(this._milliseconds) / 1000,
	            days = abs$1(this._days),
	            months = abs$1(this._months),
	            minutes,
	            hours,
	            years,
	            s,
	            total = this.asSeconds(),
	            totalSign,
	            ymSign,
	            daysSign,
	            hmsSign;
	
	        if (!total) {
	            // this is the same as C#'s (Noda) and python (isodate)...
	            // but not other JS (goog.date)
	            return 'P0D';
	        }
	
	        // 3600 seconds -> 60 minutes -> 1 hour
	        minutes = absFloor(seconds / 60);
	        hours = absFloor(minutes / 60);
	        seconds %= 60;
	        minutes %= 60;
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
	
	        totalSign = total < 0 ? '-' : '';
	        ymSign = sign(this._months) !== sign(total) ? '-' : '';
	        daysSign = sign(this._days) !== sign(total) ? '-' : '';
	        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
	
	        return (
	            totalSign +
	            'P' +
	            (years ? ymSign + years + 'Y' : '') +
	            (months ? ymSign + months + 'M' : '') +
	            (days ? daysSign + days + 'D' : '') +
	            (hours || minutes || seconds ? 'T' : '') +
	            (hours ? hmsSign + hours + 'H' : '') +
	            (minutes ? hmsSign + minutes + 'M' : '') +
	            (seconds ? hmsSign + s + 'S' : '')
	        );
	    }
	
	    var proto$2 = Duration.prototype;
	
	    proto$2.isValid = isValid$1;
	    proto$2.abs = abs;
	    proto$2.add = add$1;
	    proto$2.subtract = subtract$1;
	    proto$2.as = as;
	    proto$2.asMilliseconds = asMilliseconds;
	    proto$2.asSeconds = asSeconds;
	    proto$2.asMinutes = asMinutes;
	    proto$2.asHours = asHours;
	    proto$2.asDays = asDays;
	    proto$2.asWeeks = asWeeks;
	    proto$2.asMonths = asMonths;
	    proto$2.asQuarters = asQuarters;
	    proto$2.asYears = asYears;
	    proto$2.valueOf = valueOf$1;
	    proto$2._bubble = bubble;
	    proto$2.clone = clone$1;
	    proto$2.get = get$2;
	    proto$2.milliseconds = milliseconds;
	    proto$2.seconds = seconds;
	    proto$2.minutes = minutes;
	    proto$2.hours = hours;
	    proto$2.days = days;
	    proto$2.weeks = weeks;
	    proto$2.months = months;
	    proto$2.years = years;
	    proto$2.humanize = humanize;
	    proto$2.toISOString = toISOString$1;
	    proto$2.toString = toISOString$1;
	    proto$2.toJSON = toISOString$1;
	    proto$2.locale = locale;
	    proto$2.localeData = localeData;
	
	    proto$2.toIsoString = deprecate(
	        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
	        toISOString$1
	    );
	    proto$2.lang = lang;
	
	    // FORMATTING
	
	    addFormatToken('X', 0, 0, 'unix');
	    addFormatToken('x', 0, 0, 'valueOf');
	
	    // PARSING
	
	    addRegexToken('x', matchSigned);
	    addRegexToken('X', matchTimestamp);
	    addParseToken('X', function (input, array, config) {
	        config._d = new Date(parseFloat(input) * 1000);
	    });
	    addParseToken('x', function (input, array, config) {
	        config._d = new Date(toInt(input));
	    });
	
	    //! moment.js
	
	    hooks.version = '2.30.1';
	
	    setHookCallback(createLocal);
	
	    hooks.fn = proto;
	    hooks.min = min;
	    hooks.max = max;
	    hooks.now = now;
	    hooks.utc = createUTC;
	    hooks.unix = createUnix;
	    hooks.months = listMonths;
	    hooks.isDate = isDate;
	    hooks.locale = getSetGlobalLocale;
	    hooks.invalid = createInvalid;
	    hooks.duration = createDuration;
	    hooks.isMoment = isMoment;
	    hooks.weekdays = listWeekdays;
	    hooks.parseZone = createInZone;
	    hooks.localeData = getLocale;
	    hooks.isDuration = isDuration;
	    hooks.monthsShort = listMonthsShort;
	    hooks.weekdaysMin = listWeekdaysMin;
	    hooks.defineLocale = defineLocale;
	    hooks.updateLocale = updateLocale;
	    hooks.locales = listLocales;
	    hooks.weekdaysShort = listWeekdaysShort;
	    hooks.normalizeUnits = normalizeUnits;
	    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
	    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	    hooks.calendarFormat = getCalendarFormat;
	    hooks.prototype = proto;
	
	    // currently HTML5 input type only supports 24-hour formats
	    hooks.HTML5_FMT = {
	        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
	        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
	        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
	        DATE: 'YYYY-MM-DD', // <input type="date" />
	        TIME: 'HH:mm', // <input type="time" />
	        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
	        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
	        WEEK: 'GGGG-[W]WW', // <input type="week" />
	        MONTH: 'YYYY-MM', // <input type="month" />
	    };
	
	    return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1660)(module)))

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _header = __webpack_require__(361);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _footer = __webpack_require__(360);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _sideBar = __webpack_require__(1014);
	
	var _sideBar2 = _interopRequireDefault(_sideBar);
	
	var _reactHelmet = __webpack_require__(77);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AdminLayout = function (_Component) {
		_inherits(AdminLayout, _Component);
	
		function AdminLayout(props) {
			_classCallCheck(this, AdminLayout);
	
			var _this = _possibleConstructorReturn(this, (AdminLayout.__proto__ || Object.getPrototypeOf(AdminLayout)).call(this, props));
	
			_this.state = {
				auth_data: JSON.parse(localStorage.getItem("user_data"))
			};
			return _this;
		}
	
		_createClass(AdminLayout, [{
			key: 'render',
			value: function render() {
	
				return _react2.default.createElement(
					'div',
					{ className: 'App container-scroller bewiseui' },
					this.state.auth_data.role == 3 && _react2.default.createElement(
						_reactHelmet.Helmet,
						null,
						_react2.default.createElement(
							'title',
							null,
							'BeWise Partner - Dashboard'
						),
						_react2.default.createElement('meta', { name: 'description', content: 'BeWise partners with educators to enhance education. Learn more about our collaborative efforts and programs by visiting our website.' })
					),
					_react2.default.createElement(_header2.default, null),
					_react2.default.createElement(
						'div',
						{ 'class': 'container-fluid page-body-wrapper' },
						_react2.default.createElement(_sideBar2.default, null),
						_react2.default.createElement(
							'div',
							{ 'class': 'main-panel' },
							_react2.default.createElement(
								'div',
								{ 'class': 'content-wrapper' },
								this.props.children
							),
							_react2.default.createElement(_footer2.default, null)
						)
					)
				);
			}
		}]);
	
		return AdminLayout;
	}(_react.Component);
	
	exports.default = AdminLayout;

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
		Copyright (c) 2018 Jed Watson.
		Licensed under the MIT License (MIT), see
		http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = '';
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (arg) {
					classes = appendClass(classes, parseValue(arg));
				}
			}
	
			return classes;
		}
	
		function parseValue (arg) {
			if (typeof arg === 'string' || typeof arg === 'number') {
				return arg;
			}
	
			if (typeof arg !== 'object') {
				return '';
			}
	
			if (Array.isArray(arg)) {
				return classNames.apply(null, arg);
			}
	
			if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
				return arg.toString();
			}
	
			var classes = '';
	
			for (var key in arg) {
				if (hasOwn.call(arg, key) && arg[key]) {
					classes = appendClass(classes, key);
				}
			}
	
			return classes;
		}
	
		function appendClass (value, newClass) {
			if (!newClass) {
				return value;
			}
		
			if (value) {
				return value + ' ' + newClass;
			}
		
			return value + newClass;
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	var _typeof = __webpack_require__(56)["default"];
	function _getRequireWildcardCache(e) {
	  if ("function" != typeof WeakMap) return null;
	  var r = new WeakMap(),
	    t = new WeakMap();
	  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
	    return e ? t : r;
	  })(e);
	}
	function _interopRequireWildcard(e, r) {
	  if (!r && e && e.__esModule) return e;
	  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
	    "default": e
	  };
	  var t = _getRequireWildcardCache(r);
	  if (t && t.has(e)) return t.get(e);
	  var n = {
	      __proto__: null
	    },
	    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
	  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
	    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
	    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
	  }
	  return n["default"] = e, t && t.set(e, n), n;
	}
	module.exports = _interopRequireWildcard, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.getScrollbarWidth = getScrollbarWidth;
	exports.setScrollbarWidth = setScrollbarWidth;
	exports.isBodyOverflowing = isBodyOverflowing;
	exports.getOriginalBodyPadding = getOriginalBodyPadding;
	exports.conditionallyUpdateScrollbar = conditionallyUpdateScrollbar;
	exports.setGlobalCssModule = setGlobalCssModule;
	exports.mapToCssModules = mapToCssModules;
	exports.omit = omit;
	exports.pick = pick;
	exports.warnOnce = warnOnce;
	exports.deprecated = deprecated;
	exports.DOMElement = DOMElement;
	exports.isReactRefObj = isReactRefObj;
	exports.toNumber = toNumber;
	exports.isObject = isObject;
	exports.isFunction = isFunction;
	exports.findDOMElements = findDOMElements;
	exports.isArrayOrNodeList = isArrayOrNodeList;
	exports.getTarget = getTarget;
	exports.addMultipleEventListeners = addMultipleEventListeners;
	exports.focusableElements = exports.defaultToggleEvents = exports.canUseDOM = exports.PopperPlacements = exports.keyCodes = exports.TransitionStatuses = exports.TransitionPropTypeKeys = exports.TransitionTimeouts = exports.tagPropType = exports.targetPropType = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	// https://github.com/twbs/bootstrap/blob/v4.0.0-alpha.4/js/src/modal.js#L436-L443
	function getScrollbarWidth() {
	  var scrollDiv = document.createElement('div'); // .modal-scrollbar-measure styles // https://github.com/twbs/bootstrap/blob/v4.0.0-alpha.4/scss/_modal.scss#L106-L113
	
	  scrollDiv.style.position = 'absolute';
	  scrollDiv.style.top = '-9999px';
	  scrollDiv.style.width = '50px';
	  scrollDiv.style.height = '50px';
	  scrollDiv.style.overflow = 'scroll';
	  document.body.appendChild(scrollDiv);
	  var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
	  document.body.removeChild(scrollDiv);
	  return scrollbarWidth;
	}
	
	function setScrollbarWidth(padding) {
	  document.body.style.paddingRight = padding > 0 ? padding + "px" : null;
	}
	
	function isBodyOverflowing() {
	  return document.body.clientWidth < window.innerWidth;
	}
	
	function getOriginalBodyPadding() {
	  var style = window.getComputedStyle(document.body, null);
	  return parseInt(style && style.getPropertyValue('padding-right') || 0, 10);
	}
	
	function conditionallyUpdateScrollbar() {
	  var scrollbarWidth = getScrollbarWidth(); // https://github.com/twbs/bootstrap/blob/v4.0.0-alpha.6/js/src/modal.js#L433
	
	  var fixedContent = document.querySelectorAll('.fixed-top, .fixed-bottom, .is-fixed, .sticky-top')[0];
	  var bodyPadding = fixedContent ? parseInt(fixedContent.style.paddingRight || 0, 10) : 0;
	
	  if (isBodyOverflowing()) {
	    setScrollbarWidth(bodyPadding + scrollbarWidth);
	  }
	}
	
	var globalCssModule;
	
	function setGlobalCssModule(cssModule) {
	  globalCssModule = cssModule;
	}
	
	function mapToCssModules(className, cssModule) {
	  if (className === void 0) {
	    className = '';
	  }
	
	  if (cssModule === void 0) {
	    cssModule = globalCssModule;
	  }
	
	  if (!cssModule) return className;
	  return className.split(' ').map(function (c) {
	    return cssModule[c] || c;
	  }).join(' ');
	}
	/**
	 * Returns a new object with the key/value pairs from `obj` that are not in the array `omitKeys`.
	 */
	
	
	function omit(obj, omitKeys) {
	  var result = {};
	  Object.keys(obj).forEach(function (key) {
	    if (omitKeys.indexOf(key) === -1) {
	      result[key] = obj[key];
	    }
	  });
	  return result;
	}
	/**
	 * Returns a filtered copy of an object with only the specified keys.
	 */
	
	
	function pick(obj, keys) {
	  var pickKeys = Array.isArray(keys) ? keys : [keys];
	  var length = pickKeys.length;
	  var key;
	  var result = {};
	
	  while (length > 0) {
	    length -= 1;
	    key = pickKeys[length];
	    result[key] = obj[key];
	  }
	
	  return result;
	}
	
	var warned = {};
	
	function warnOnce(message) {
	  if (!warned[message]) {
	    /* istanbul ignore else */
	    if (typeof console !== 'undefined') {
	      console.error(message); // eslint-disable-line no-console
	    }
	
	    warned[message] = true;
	  }
	}
	
	function deprecated(propType, explanation) {
	  return function validate(props, propName, componentName) {
	    if (props[propName] !== null && typeof props[propName] !== 'undefined') {
	      warnOnce("\"" + propName + "\" property of \"" + componentName + "\" has been deprecated.\n" + explanation);
	    }
	
	    for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
	      rest[_key - 3] = arguments[_key];
	    }
	
	    return propType.apply(void 0, [props, propName, componentName].concat(rest));
	  };
	} // Shim Element if needed (e.g. in Node environment)
	
	
	var Element = typeof window === 'object' && window.Element || function () {};
	
	function DOMElement(props, propName, componentName) {
	  if (!(props[propName] instanceof Element)) {
	    return new Error('Invalid prop `' + propName + '` supplied to `' + componentName + '`. Expected prop to be an instance of Element. Validation failed.');
	  }
	}
	
	var targetPropType = _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, DOMElement, _propTypes.default.shape({
	  current: _propTypes.default.any
	})]);
	
	exports.targetPropType = targetPropType;
	
	var tagPropType = _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.string, _propTypes.default.shape({
	  $$typeof: _propTypes.default.symbol,
	  render: _propTypes.default.func
	}), _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.string, _propTypes.default.shape({
	  $$typeof: _propTypes.default.symbol,
	  render: _propTypes.default.func
	})]))]);
	/* eslint key-spacing: ["error", { afterColon: true, align: "value" }] */
	// These are all setup to match what is in the bootstrap _variables.scss
	// https://github.com/twbs/bootstrap/blob/v4-dev/scss/_variables.scss
	
	
	exports.tagPropType = tagPropType;
	var TransitionTimeouts = {
	  Fade: 150,
	  // $transition-fade
	  Collapse: 350,
	  // $transition-collapse
	  Modal: 300,
	  // $modal-transition
	  Carousel: 600 // $carousel-transition
	
	}; // Duplicated Transition.propType keys to ensure that Reactstrap builds
	// for distribution properly exclude these keys for nested child HTML attributes
	// since `react-transition-group` removes propTypes in production builds.
	
	exports.TransitionTimeouts = TransitionTimeouts;
	var TransitionPropTypeKeys = ['in', 'mountOnEnter', 'unmountOnExit', 'appear', 'enter', 'exit', 'timeout', 'onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited'];
	exports.TransitionPropTypeKeys = TransitionPropTypeKeys;
	var TransitionStatuses = {
	  ENTERING: 'entering',
	  ENTERED: 'entered',
	  EXITING: 'exiting',
	  EXITED: 'exited'
	};
	exports.TransitionStatuses = TransitionStatuses;
	var keyCodes = {
	  esc: 27,
	  space: 32,
	  enter: 13,
	  tab: 9,
	  up: 38,
	  down: 40,
	  home: 36,
	  end: 35,
	  n: 78,
	  p: 80
	};
	exports.keyCodes = keyCodes;
	var PopperPlacements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];
	exports.PopperPlacements = PopperPlacements;
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	exports.canUseDOM = canUseDOM;
	
	function isReactRefObj(target) {
	  if (target && typeof target === 'object') {
	    return 'current' in target;
	  }
	
	  return false;
	}
	
	function getTag(value) {
	  if (value == null) {
	    return value === undefined ? '[object Undefined]' : '[object Null]';
	  }
	
	  return Object.prototype.toString.call(value);
	}
	
	function toNumber(value) {
	  var type = typeof value;
	  var NAN = 0 / 0;
	
	  if (type === 'number') {
	    return value;
	  }
	
	  if (type === 'symbol' || type === 'object' && getTag(value) === '[object Symbol]') {
	    return NAN;
	  }
	
	  if (isObject(value)) {
	    var other = typeof value.valueOf === 'function' ? value.valueOf() : value;
	    value = isObject(other) ? "" + other : other;
	  }
	
	  if (type !== 'string') {
	    return value === 0 ? value : +value;
	  }
	
	  value = value.replace(/^\s+|\s+$/g, '');
	  var isBinary = /^0b[01]+$/i.test(value);
	  return isBinary || /^0o[0-7]+$/i.test(value) ? parseInt(value.slice(2), isBinary ? 2 : 8) : /^[-+]0x[0-9a-f]+$/i.test(value) ? NAN : +value;
	}
	
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type === 'object' || type === 'function');
	}
	
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	
	  var tag = getTag(value);
	  return tag === '[object Function]' || tag === '[object AsyncFunction]' || tag === '[object GeneratorFunction]' || tag === '[object Proxy]';
	}
	
	function findDOMElements(target) {
	  if (isReactRefObj(target)) {
	    return target.current;
	  }
	
	  if (isFunction(target)) {
	    return target();
	  }
	
	  if (typeof target === 'string' && canUseDOM) {
	    var selection = document.querySelectorAll(target);
	
	    if (!selection.length) {
	      selection = document.querySelectorAll("#" + target);
	    }
	
	    if (!selection.length) {
	      throw new Error("The target '" + target + "' could not be identified in the dom, tip: check spelling");
	    }
	
	    return selection;
	  }
	
	  return target;
	}
	
	function isArrayOrNodeList(els) {
	  if (els === null) {
	    return false;
	  }
	
	  return Array.isArray(els) || canUseDOM && typeof els.length === 'number';
	}
	
	function getTarget(target, allElements) {
	  var els = findDOMElements(target);
	
	  if (allElements) {
	    if (isArrayOrNodeList(els)) {
	      return els;
	    }
	
	    if (els === null) {
	      return [];
	    }
	
	    return [els];
	  } else {
	    if (isArrayOrNodeList(els)) {
	      return els[0];
	    }
	
	    return els;
	  }
	}
	
	var defaultToggleEvents = ['touchstart', 'click'];
	exports.defaultToggleEvents = defaultToggleEvents;
	
	function addMultipleEventListeners(_els, handler, _events, useCapture) {
	  var els = _els;
	
	  if (!isArrayOrNodeList(els)) {
	    els = [els];
	  }
	
	  var events = _events;
	
	  if (typeof events === 'string') {
	    events = events.split(/\s+/);
	  }
	
	  if (!isArrayOrNodeList(els) || typeof handler !== 'function' || !Array.isArray(events)) {
	    throw new Error("\n      The first argument of this function must be DOM node or an array on DOM nodes or NodeList.\n      The second must be a function.\n      The third is a string or an array of strings that represents DOM events\n    ");
	  }
	
	  Array.prototype.forEach.call(events, function (event) {
	    Array.prototype.forEach.call(els, function (el) {
	      el.addEventListener(event, handler, useCapture);
	    });
	  });
	  return function removeEvents() {
	    Array.prototype.forEach.call(events, function (event) {
	      Array.prototype.forEach.call(els, function (el) {
	        el.removeEventListener(event, handler, useCapture);
	      });
	    });
	  };
	}
	
	var focusableElements = ['a[href]', 'area[href]', 'input:not([disabled]):not([type=hidden])', 'select:not([disabled])', 'textarea:not([disabled])', 'button:not([disabled])', 'object', 'embed', '[tabindex]:not(.modal)', 'audio[controls]', 'video[controls]', '[contenteditable]:not([contenteditable="false"])'];
	exports.focusableElements = focusableElements;

/***/ },
/* 12 */
/***/ function(module, exports) {

	function _assertThisInitialized(e) {
	  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  return e;
	}
	module.exports = _assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 13 */
/***/ function(module, exports) {

	function _objectWithoutPropertiesLoose(r, e) {
	  if (null == r) return {};
	  var t = {};
	  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
	    if (e.includes(n)) continue;
	    t[n] = r[n];
	  }
	  return t;
	}
	module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 14 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = requiredArgs;
	function requiredArgs(required, args) {
	  if (args.length < required) {
	    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
	  }
	}
	module.exports = exports.default;

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1068);


/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "NotificationContainer", {
	  enumerable: true,
	  get: function get() {
	    return _NotificationContainer.default;
	  }
	});
	Object.defineProperty(exports, "NotificationManager", {
	  enumerable: true,
	  get: function get() {
	    return _NotificationManager.default;
	  }
	});
	Object.defineProperty(exports, "Notifications", {
	  enumerable: true,
	  get: function get() {
	    return _Notifications.default;
	  }
	});
	exports.default = void 0;
	
	var _Notifications = _interopRequireDefault(__webpack_require__(630));
	
	var _NotificationContainer = _interopRequireDefault(__webpack_require__(1441));
	
	var _NotificationManager = _interopRequireDefault(__webpack_require__(629));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _default = _Notifications.default;
	exports.default = _default;

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.Util = exports.DropdownContext = void 0;
	
	var _Container2 = _interopRequireDefault(__webpack_require__(1544));
	
	exports.Container = _Container2.default;
	
	var _Row2 = _interopRequireDefault(__webpack_require__(1582));
	
	exports.Row = _Row2.default;
	
	var _Col2 = _interopRequireDefault(__webpack_require__(1543));
	
	exports.Col = _Col2.default;
	
	var _Navbar2 = _interopRequireDefault(__webpack_require__(1570));
	
	exports.Navbar = _Navbar2.default;
	
	var _NavbarBrand2 = _interopRequireDefault(__webpack_require__(1571));
	
	exports.NavbarBrand = _NavbarBrand2.default;
	
	var _NavbarText2 = _interopRequireDefault(__webpack_require__(1572));
	
	exports.NavbarText = _NavbarText2.default;
	
	var _NavbarToggler2 = _interopRequireDefault(__webpack_require__(1573));
	
	exports.NavbarToggler = _NavbarToggler2.default;
	
	var _Nav2 = _interopRequireDefault(__webpack_require__(1567));
	
	exports.Nav = _Nav2.default;
	
	var _NavItem2 = _interopRequireDefault(__webpack_require__(1568));
	
	exports.NavItem = _NavItem2.default;
	
	var _NavLink2 = _interopRequireDefault(__webpack_require__(1569));
	
	exports.NavLink = _NavLink2.default;
	
	var _Breadcrumb2 = _interopRequireDefault(__webpack_require__(1525));
	
	exports.Breadcrumb = _Breadcrumb2.default;
	
	var _BreadcrumbItem2 = _interopRequireDefault(__webpack_require__(1526));
	
	exports.BreadcrumbItem = _BreadcrumbItem2.default;
	
	var _Button2 = _interopRequireDefault(__webpack_require__(301));
	
	exports.Button = _Button2.default;
	
	var _ButtonToggle2 = _interopRequireDefault(__webpack_require__(1528));
	
	exports.ButtonToggle = _ButtonToggle2.default;
	
	var _ButtonDropdown2 = _interopRequireDefault(__webpack_require__(638));
	
	exports.ButtonDropdown = _ButtonDropdown2.default;
	
	var _ButtonGroup2 = _interopRequireDefault(__webpack_require__(1527));
	
	exports.ButtonGroup = _ButtonGroup2.default;
	
	var _ButtonToolbar2 = _interopRequireDefault(__webpack_require__(1529));
	
	exports.ButtonToolbar = _ButtonToolbar2.default;
	
	var _Dropdown2 = _interopRequireDefault(__webpack_require__(212));
	
	exports.Dropdown = _Dropdown2.default;
	
	var _DropdownItem2 = _interopRequireDefault(__webpack_require__(1546));
	
	exports.DropdownItem = _DropdownItem2.default;
	
	var _DropdownMenu2 = _interopRequireDefault(__webpack_require__(1547));
	
	exports.DropdownMenu = _DropdownMenu2.default;
	
	var _DropdownToggle2 = _interopRequireDefault(__webpack_require__(1548));
	
	exports.DropdownToggle = _DropdownToggle2.default;
	
	var _DropdownContext = __webpack_require__(172);
	
	exports.DropdownContext = _DropdownContext.DropdownContext;
	
	var _Fade2 = _interopRequireDefault(__webpack_require__(173));
	
	exports.Fade = _Fade2.default;
	
	var _Badge2 = _interopRequireDefault(__webpack_require__(1524));
	
	exports.Badge = _Badge2.default;
	
	var _Card2 = _interopRequireDefault(__webpack_require__(1530));
	
	exports.Card = _Card2.default;
	
	var _CardGroup2 = _interopRequireDefault(__webpack_require__(1535));
	
	exports.CardGroup = _CardGroup2.default;
	
	var _CardDeck2 = _interopRequireDefault(__webpack_require__(1533));
	
	exports.CardDeck = _CardDeck2.default;
	
	var _CardColumns2 = _interopRequireDefault(__webpack_require__(1532));
	
	exports.CardColumns = _CardColumns2.default;
	
	var _CardBody2 = _interopRequireDefault(__webpack_require__(1531));
	
	exports.CardBody = _CardBody2.default;
	
	var _CardLink2 = _interopRequireDefault(__webpack_require__(1539));
	
	exports.CardLink = _CardLink2.default;
	
	var _CardFooter2 = _interopRequireDefault(__webpack_require__(1534));
	
	exports.CardFooter = _CardFooter2.default;
	
	var _CardHeader2 = _interopRequireDefault(__webpack_require__(1536));
	
	exports.CardHeader = _CardHeader2.default;
	
	var _CardImg2 = _interopRequireDefault(__webpack_require__(1537));
	
	exports.CardImg = _CardImg2.default;
	
	var _CardImgOverlay2 = _interopRequireDefault(__webpack_require__(1538));
	
	exports.CardImgOverlay = _CardImgOverlay2.default;
	
	var _Carousel2 = _interopRequireDefault(__webpack_require__(639));
	
	exports.Carousel = _Carousel2.default;
	
	var _UncontrolledCarousel2 = _interopRequireDefault(__webpack_require__(1592));
	
	exports.UncontrolledCarousel = _UncontrolledCarousel2.default;
	
	var _CarouselControl2 = _interopRequireDefault(__webpack_require__(641));
	
	exports.CarouselControl = _CarouselControl2.default;
	
	var _CarouselItem2 = _interopRequireDefault(__webpack_require__(302));
	
	exports.CarouselItem = _CarouselItem2.default;
	
	var _CarouselIndicators2 = _interopRequireDefault(__webpack_require__(642));
	
	exports.CarouselIndicators = _CarouselIndicators2.default;
	
	var _CarouselCaption2 = _interopRequireDefault(__webpack_require__(640));
	
	exports.CarouselCaption = _CarouselCaption2.default;
	
	var _CardSubtitle2 = _interopRequireDefault(__webpack_require__(1540));
	
	exports.CardSubtitle = _CardSubtitle2.default;
	
	var _CardText2 = _interopRequireDefault(__webpack_require__(1541));
	
	exports.CardText = _CardText2.default;
	
	var _CardTitle2 = _interopRequireDefault(__webpack_require__(1542));
	
	exports.CardTitle = _CardTitle2.default;
	
	var _CustomFileInput2 = _interopRequireDefault(__webpack_require__(644));
	
	exports.CustomFileInput = _CustomFileInput2.default;
	
	var _CustomInput2 = _interopRequireDefault(__webpack_require__(1545));
	
	exports.CustomInput = _CustomInput2.default;
	
	var _PopperContent2 = _interopRequireDefault(__webpack_require__(647));
	
	exports.PopperContent = _PopperContent2.default;
	
	var _PopperTargetHelper2 = _interopRequireDefault(__webpack_require__(1579));
	
	exports.PopperTargetHelper = _PopperTargetHelper2.default;
	
	var _Popover2 = _interopRequireDefault(__webpack_require__(646));
	
	exports.Popover = _Popover2.default;
	
	var _UncontrolledPopover2 = _interopRequireDefault(__webpack_require__(1595));
	
	exports.UncontrolledPopover = _UncontrolledPopover2.default;
	
	var _PopoverHeader2 = _interopRequireDefault(__webpack_require__(1578));
	
	exports.PopoverHeader = _PopoverHeader2.default;
	
	var _PopoverBody2 = _interopRequireDefault(__webpack_require__(1577));
	
	exports.PopoverBody = _PopoverBody2.default;
	
	var _Progress2 = _interopRequireDefault(__webpack_require__(1581));
	
	exports.Progress = _Progress2.default;
	
	var _Modal2 = _interopRequireDefault(__webpack_require__(1564));
	
	exports.Modal = _Modal2.default;
	
	var _ModalHeader2 = _interopRequireDefault(__webpack_require__(102));
	
	exports.ModalHeader = _ModalHeader2.default;
	
	var _ModalBody2 = _interopRequireDefault(__webpack_require__(1565));
	
	exports.ModalBody = _ModalBody2.default;
	
	var _ModalFooter2 = _interopRequireDefault(__webpack_require__(1566));
	
	exports.ModalFooter = _ModalFooter2.default;
	
	var _Tooltip2 = _interopRequireDefault(__webpack_require__(649));
	
	exports.Tooltip = _Tooltip2.default;
	
	var _Table2 = _interopRequireDefault(__webpack_require__(1586));
	
	exports.Table = _Table2.default;
	
	var _ListGroup2 = _interopRequireDefault(__webpack_require__(1559));
	
	exports.ListGroup = _ListGroup2.default;
	
	var _Form2 = _interopRequireDefault(__webpack_require__(1549));
	
	exports.Form = _Form2.default;
	
	var _FormFeedback2 = _interopRequireDefault(__webpack_require__(1550));
	
	exports.FormFeedback = _FormFeedback2.default;
	
	var _FormGroup2 = _interopRequireDefault(__webpack_require__(1551));
	
	exports.FormGroup = _FormGroup2.default;
	
	var _FormText2 = _interopRequireDefault(__webpack_require__(1552));
	
	exports.FormText = _FormText2.default;
	
	var _Input2 = _interopRequireDefault(__webpack_require__(1553));
	
	exports.Input = _Input2.default;
	
	var _InputGroup2 = _interopRequireDefault(__webpack_require__(1554));
	
	exports.InputGroup = _InputGroup2.default;
	
	var _InputGroupAddon2 = _interopRequireDefault(__webpack_require__(1555));
	
	exports.InputGroupAddon = _InputGroupAddon2.default;
	
	var _InputGroupButtonDropdown2 = _interopRequireDefault(__webpack_require__(1556));
	
	exports.InputGroupButtonDropdown = _InputGroupButtonDropdown2.default;
	
	var _InputGroupText2 = _interopRequireDefault(__webpack_require__(645));
	
	exports.InputGroupText = _InputGroupText2.default;
	
	var _Label2 = _interopRequireDefault(__webpack_require__(1558));
	
	exports.Label = _Label2.default;
	
	var _Media2 = _interopRequireDefault(__webpack_require__(1563));
	
	exports.Media = _Media2.default;
	
	var _Pagination2 = _interopRequireDefault(__webpack_require__(1574));
	
	exports.Pagination = _Pagination2.default;
	
	var _PaginationItem2 = _interopRequireDefault(__webpack_require__(1575));
	
	exports.PaginationItem = _PaginationItem2.default;
	
	var _PaginationLink2 = _interopRequireDefault(__webpack_require__(1576));
	
	exports.PaginationLink = _PaginationLink2.default;
	
	var _TabContent2 = _interopRequireDefault(__webpack_require__(1584));
	
	exports.TabContent = _TabContent2.default;
	
	var _TabPane2 = _interopRequireDefault(__webpack_require__(1585));
	
	exports.TabPane = _TabPane2.default;
	
	var _Jumbotron2 = _interopRequireDefault(__webpack_require__(1557));
	
	exports.Jumbotron = _Jumbotron2.default;
	
	var _Alert2 = _interopRequireDefault(__webpack_require__(637));
	
	exports.Alert = _Alert2.default;
	
	var _Toast2 = _interopRequireDefault(__webpack_require__(1587));
	
	exports.Toast = _Toast2.default;
	
	var _ToastBody2 = _interopRequireDefault(__webpack_require__(1588));
	
	exports.ToastBody = _ToastBody2.default;
	
	var _ToastHeader2 = _interopRequireDefault(__webpack_require__(1589));
	
	exports.ToastHeader = _ToastHeader2.default;
	
	var _Collapse2 = _interopRequireDefault(__webpack_require__(643));
	
	exports.Collapse = _Collapse2.default;
	
	var _ListGroupItem2 = _interopRequireDefault(__webpack_require__(1560));
	
	exports.ListGroupItem = _ListGroupItem2.default;
	
	var _ListGroupItemHeading2 = _interopRequireDefault(__webpack_require__(1561));
	
	exports.ListGroupItemHeading = _ListGroupItemHeading2.default;
	
	var _ListGroupItemText2 = _interopRequireDefault(__webpack_require__(1562));
	
	exports.ListGroupItemText = _ListGroupItemText2.default;
	
	var _UncontrolledAlert2 = _interopRequireDefault(__webpack_require__(1590));
	
	exports.UncontrolledAlert = _UncontrolledAlert2.default;
	
	var _UncontrolledButtonDropdown2 = _interopRequireDefault(__webpack_require__(1591));
	
	exports.UncontrolledButtonDropdown = _UncontrolledButtonDropdown2.default;
	
	var _UncontrolledCollapse2 = _interopRequireDefault(__webpack_require__(1593));
	
	exports.UncontrolledCollapse = _UncontrolledCollapse2.default;
	
	var _UncontrolledDropdown2 = _interopRequireDefault(__webpack_require__(1594));
	
	exports.UncontrolledDropdown = _UncontrolledDropdown2.default;
	
	var _UncontrolledTooltip2 = _interopRequireDefault(__webpack_require__(1596));
	
	exports.UncontrolledTooltip = _UncontrolledTooltip2.default;
	
	var _Spinner2 = _interopRequireDefault(__webpack_require__(1583));
	
	exports.Spinner = _Spinner2.default;
	
	var _Util = _interopRequireWildcard(__webpack_require__(11));
	
	exports.Util = _Util;

/***/ },
/* 18 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	var toPropertyKey = __webpack_require__(318);
	function _defineProperties(e, r) {
	  for (var t = 0; t < r.length; t++) {
	    var o = r[t];
	    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, toPropertyKey(o.key), o);
	  }
	}
	function _createClass(e, r, t) {
	  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
	    writable: !1
	  }), e;
	}
	module.exports = _createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 20 */
/***/ function(module, exports) {

	function _classCallCheck(a, n) {
	  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
	}
	module.exports = _classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var protocol = window.location.protocol + '//' + window.location.hostname + '/';
	var url = location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '') + '/';
	//require('dotenv').load();
	var BASEURL = exports.BASEURL = url;
	var IMGBASEURL = exports.IMGBASEURL = 'https://api.bewise.in/';
	//export const IMGBASEURL = 'http://localhost:5005/';
	var USERURL = exports.USERURL = ("https://www.bewise.in/");
	var RAZORPAY_LIVE = exports.RAZORPAY_LIVE = ("rzp_live_B1Rc514TPFi72L");
	var RAZORPAY_TEST = exports.RAZORPAY_TEST = ("rzp_live_B1Rc514TPFi72L");
	var GOOGLE_CAPTCHA_SITE_KEY = exports.GOOGLE_CAPTCHA_SITE_KEY = ("6Le5HyAqAAAAAPcf0Em_niWQ8eWnVwTIbQdwU0pW");
	var GOOGLE_CAPTCHA_SECRET_KEY = exports.GOOGLE_CAPTCHA_SECRET_KEY = ("6Le5HyAqAAAAADaxdwTC-cyLAsOI27illPepM6Wu");
	var REACT_APP_API_PATH = exports.REACT_APP_API_PATH = ("https://api.bewise.in/api/");
	var TINY_EDITOR = exports.TINY_EDITOR = ("te4wakzk2tutx8pwzcbikp01f6cqsemlyubqa6juufgdrwmm");
	var AZ_ASSET_PATH = exports.AZ_ASSET_PATH = ("https://bewiseblobprod.blob.core.windows.net/assets/bewise/uploads/");
	
	console.log("env", ({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_USERURL":"https://www.bewise.in/","REACT_APP_TINY_EDITOR":"te4wakzk2tutx8pwzcbikp01f6cqsemlyubqa6juufgdrwmm","REACT_APP_RAZORPAY_LIVE":"rzp_live_B1Rc514TPFi72L","REACT_APP_GOOGLE_CAPTCHA_SITE_KEY":"6Le5HyAqAAAAAPcf0Em_niWQ8eWnVwTIbQdwU0pW","REACT_APP_API_PATH":"https://api.bewise.in/api/","REACT_APP_RAZORPAY_TEST":"rzp_live_B1Rc514TPFi72L","REACT_APP_ASSET_PATH":"https://bewiseblobprod.blob.core.windows.net/assets/bewise/uploads/","REACT_APP_GOOGLE_CAPTCHA_SECRET_KEY":"6Le5HyAqAAAAADaxdwTC-cyLAsOI27illPepM6Wu"}));
	
	var MOBILE_REGEX = exports.MOBILE_REGEX = {
	    message: 'The :attribute may be invalid.',
	    rule: function rule(val, params, validator) {
	        return validator.helpers.testRegex(val, /^[0-9\-,+\s]+$/);
	    },
	    messageReplace: function messageReplace(message, params) {
	        return message.replace(':values', undefined.helpers.toSentence(params));
	    }, // optional
	    required: true // optional
	};
	var URL_REGEX = exports.URL_REGEX = { // name the rule
	    message: 'The :attribute may be invalid.',
	    rule: function rule(val, params, validator) {
	        if (val) return validator.helpers.testRegex(val, /^[a-zA-Z_0-9\-.:,@/\s]+$/);
	    },
	    messageReplace: function messageReplace(message, params) {
	        return message.replace(':values', undefined.helpers.toSentence(params));
	    }, // optional
	    required: true // optional
	};
	
	var CITIES = exports.CITIES = [{ "id": 27, "location": "Hosur", "latitude": "12.7409", "longitude": "77.8253", "status": 1, "sort_order": 4 }, { "id": 1, "location": "Bengaluru", "latitude": "12.9716", "longitude": "77.5946", "status": 1, "sort_order": 1 }, { "id": 12, "location": "Chennai", "latitude": "13.0569", "longitude": "80.2425", "status": 1, "sort_order": 2 }, { "id": 11, "location": "Coimbatore", "latitude": "11.0168", "longitude": "76.9558", "status": 1, "sort_order": 3 }, { "id": 2, "location": "Hyderabad", "latitude": "17.3850", "longitude": "78.4867", "status": 1, "sort_order": 4 }, { "id": 24, "location": "Madurai", "latitude": "9.9252", "longitude": "78.1198", "status": 1, "sort_order": 5 }, { "id": 13, "location": "Mumbai", "latitude": "19.0760", "longitude": "72.8777", "status": 1, "sort_order": 7 }, { "id": 15, "location": "Kolkata", "latitude": "22.5726", "longitude": "88.3639", "status": 1, "sort_order": 8 }, { "id": 16, "location": "New Delhi", "latitude": "28.6139", "longitude": "77.2090", "status": 1, "sort_order": 9 }, { "id": 17, "location": "Jaipur", "latitude": "26.9124", "longitude": "75.7873", "status": 1, "sort_order": 10 }, { "id": 18, "location": "Chandigarh", "latitude": "30.7333", "longitude": "76.7794", "status": 1, "sort_order": 11 }, { "id": 19, "location": "Pune", "latitude": "18.5204", "longitude": "73.8567", "status": 1, "sort_order": 12 }, { "id": 20, "location": "Kochi", "latitude": "9.9312", "longitude": "76.2673", "status": 1, "sort_order": 13 }, { "id": 21, "location": "Noida", "latitude": "28.5355", "longitude": "77.3910", "status": 1, "sort_order": 14 }, { "id": 22, "location": "Agra", "latitude": "27.1767", "longitude": "78.0081", "status": 1, "sort_order": 15 }, { "id": 23, "location": "Puducherry", "latitude": "11.9416", "longitude": "79.8083", "status": 1, "sort_order": 16 }, { "id": 25, "location": "Tiruchirappalli", "latitude": "10.7905", "longitude": "78.7047", "status": 1, "sort_order": 17 }];

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	var setPrototypeOf = __webpack_require__(317);
	function _inherits(t, e) {
	  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
	  t.prototype = Object.create(e && e.prototype, {
	    constructor: {
	      value: t,
	      writable: !0,
	      configurable: !0
	    }
	  }), Object.defineProperty(t, "prototype", {
	    writable: !1
	  }), e && setPrototypeOf(t, e);
	}
	module.exports = _inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = toDate;
	var _typeof2 = _interopRequireDefault(__webpack_require__(56));
	var _index = _interopRequireDefault(__webpack_require__(14));
	/**
	 * @name toDate
	 * @category Common Helpers
	 * @summary Convert the given argument to an instance of Date.
	 *
	 * @description
	 * Convert the given argument to an instance of Date.
	 *
	 * If the argument is an instance of Date, the function returns its clone.
	 *
	 * If the argument is a number, it is treated as a timestamp.
	 *
	 * If the argument is none of the above, the function returns Invalid Date.
	 *
	 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
	 *
	 * @param {Date|Number} argument - the value to convert
	 * @returns {Date} the parsed date in the local time zone
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Clone the date:
	 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
	 * //=> Tue Feb 11 2014 11:30:30
	 *
	 * @example
	 * // Convert the timestamp to date:
	 * const result = toDate(1392098430000)
	 * //=> Tue Feb 11 2014 11:30:30
	 */
	function toDate(argument) {
	  (0, _index.default)(1, arguments);
	  var argStr = Object.prototype.toString.call(argument);
	
	  // Clone the date
	  if (argument instanceof Date || (0, _typeof2.default)(argument) === 'object' && argStr === '[object Date]') {
	    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
	    return new Date(argument.getTime());
	  } else if (typeof argument === 'number' || argStr === '[object Number]') {
	    return new Date(argument);
	  } else {
	    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
	      // eslint-disable-next-line no-console
	      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
	      // eslint-disable-next-line no-console
	      console.warn(new Error().stack);
	    }
	    return new Date(NaN);
	  }
	}
	module.exports = exports.default;

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	var toPropertyKey = __webpack_require__(318);
	function _defineProperty(e, r, t) {
	  return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
	    value: t,
	    enumerable: !0,
	    configurable: !0,
	    writable: !0
	  }) : e[r] = t, e;
	}
	module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	var objectWithoutPropertiesLoose = __webpack_require__(13);
	function _objectWithoutProperties(e, t) {
	  if (null == e) return {};
	  var o,
	    r,
	    i = objectWithoutPropertiesLoose(e, t);
	  if (Object.getOwnPropertySymbols) {
	    var s = Object.getOwnPropertySymbols(e);
	    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
	  }
	  return i;
	}
	module.exports = _objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	/** @license Material-UI v4.11.3
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "chainPropTypes", {
	  enumerable: true,
	  get: function get() {
	    return _chainPropTypes.default;
	  }
	});
	Object.defineProperty(exports, "deepmerge", {
	  enumerable: true,
	  get: function get() {
	    return _deepmerge.default;
	  }
	});
	Object.defineProperty(exports, "elementAcceptingRef", {
	  enumerable: true,
	  get: function get() {
	    return _elementAcceptingRef.default;
	  }
	});
	Object.defineProperty(exports, "elementTypeAcceptingRef", {
	  enumerable: true,
	  get: function get() {
	    return _elementTypeAcceptingRef.default;
	  }
	});
	Object.defineProperty(exports, "exactProp", {
	  enumerable: true,
	  get: function get() {
	    return _exactProp.default;
	  }
	});
	Object.defineProperty(exports, "formatMuiErrorMessage", {
	  enumerable: true,
	  get: function get() {
	    return _formatMuiErrorMessage.default;
	  }
	});
	Object.defineProperty(exports, "getDisplayName", {
	  enumerable: true,
	  get: function get() {
	    return _getDisplayName.default;
	  }
	});
	Object.defineProperty(exports, "HTMLElementType", {
	  enumerable: true,
	  get: function get() {
	    return _HTMLElementType.default;
	  }
	});
	Object.defineProperty(exports, "ponyfillGlobal", {
	  enumerable: true,
	  get: function get() {
	    return _ponyfillGlobal.default;
	  }
	});
	Object.defineProperty(exports, "refType", {
	  enumerable: true,
	  get: function get() {
	    return _refType.default;
	  }
	});
	
	var _chainPropTypes = _interopRequireDefault(__webpack_require__(243));
	
	var _deepmerge = _interopRequireDefault(__webpack_require__(826));
	
	var _elementAcceptingRef = _interopRequireDefault(__webpack_require__(827));
	
	var _elementTypeAcceptingRef = _interopRequireDefault(__webpack_require__(828));
	
	var _exactProp = _interopRequireDefault(__webpack_require__(829));
	
	var _formatMuiErrorMessage = _interopRequireDefault(__webpack_require__(830));
	
	var _getDisplayName = _interopRequireDefault(__webpack_require__(831));
	
	var _HTMLElementType = _interopRequireDefault(__webpack_require__(825));
	
	var _ponyfillGlobal = _interopRequireDefault(__webpack_require__(832));
	
	var _refType = _interopRequireDefault(__webpack_require__(833));

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 *  Copyright (c) 2014-2015, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	(function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define(factory) :
	  global.Immutable = factory();
	}(this, function () { 'use strict';var SLICE$0 = Array.prototype.slice;
	
	  function createClass(ctor, superClass) {
	    if (superClass) {
	      ctor.prototype = Object.create(superClass.prototype);
	    }
	    ctor.prototype.constructor = ctor;
	  }
	
	  function Iterable(value) {
	      return isIterable(value) ? value : Seq(value);
	    }
	
	
	  createClass(KeyedIterable, Iterable);
	    function KeyedIterable(value) {
	      return isKeyed(value) ? value : KeyedSeq(value);
	    }
	
	
	  createClass(IndexedIterable, Iterable);
	    function IndexedIterable(value) {
	      return isIndexed(value) ? value : IndexedSeq(value);
	    }
	
	
	  createClass(SetIterable, Iterable);
	    function SetIterable(value) {
	      return isIterable(value) && !isAssociative(value) ? value : SetSeq(value);
	    }
	
	
	
	  function isIterable(maybeIterable) {
	    return !!(maybeIterable && maybeIterable[IS_ITERABLE_SENTINEL]);
	  }
	
	  function isKeyed(maybeKeyed) {
	    return !!(maybeKeyed && maybeKeyed[IS_KEYED_SENTINEL]);
	  }
	
	  function isIndexed(maybeIndexed) {
	    return !!(maybeIndexed && maybeIndexed[IS_INDEXED_SENTINEL]);
	  }
	
	  function isAssociative(maybeAssociative) {
	    return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
	  }
	
	  function isOrdered(maybeOrdered) {
	    return !!(maybeOrdered && maybeOrdered[IS_ORDERED_SENTINEL]);
	  }
	
	  Iterable.isIterable = isIterable;
	  Iterable.isKeyed = isKeyed;
	  Iterable.isIndexed = isIndexed;
	  Iterable.isAssociative = isAssociative;
	  Iterable.isOrdered = isOrdered;
	
	  Iterable.Keyed = KeyedIterable;
	  Iterable.Indexed = IndexedIterable;
	  Iterable.Set = SetIterable;
	
	
	  var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
	  var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
	  var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
	  var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
	
	  // Used for setting prototype methods that IE8 chokes on.
	  var DELETE = 'delete';
	
	  // Constants describing the size of trie nodes.
	  var SHIFT = 5; // Resulted in best performance after ______?
	  var SIZE = 1 << SHIFT;
	  var MASK = SIZE - 1;
	
	  // A consistent shared value representing "not set" which equals nothing other
	  // than itself, and nothing that could be provided externally.
	  var NOT_SET = {};
	
	  // Boolean references, Rough equivalent of `bool &`.
	  var CHANGE_LENGTH = { value: false };
	  var DID_ALTER = { value: false };
	
	  function MakeRef(ref) {
	    ref.value = false;
	    return ref;
	  }
	
	  function SetRef(ref) {
	    ref && (ref.value = true);
	  }
	
	  // A function which returns a value representing an "owner" for transient writes
	  // to tries. The return value will only ever equal itself, and will not equal
	  // the return of any subsequent call of this function.
	  function OwnerID() {}
	
	  // http://jsperf.com/copy-array-inline
	  function arrCopy(arr, offset) {
	    offset = offset || 0;
	    var len = Math.max(0, arr.length - offset);
	    var newArr = new Array(len);
	    for (var ii = 0; ii < len; ii++) {
	      newArr[ii] = arr[ii + offset];
	    }
	    return newArr;
	  }
	
	  function ensureSize(iter) {
	    if (iter.size === undefined) {
	      iter.size = iter.__iterate(returnTrue);
	    }
	    return iter.size;
	  }
	
	  function wrapIndex(iter, index) {
	    // This implements "is array index" which the ECMAString spec defines as:
	    //
	    //     A String property name P is an array index if and only if
	    //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
	    //     to 2^32−1.
	    //
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
	    if (typeof index !== 'number') {
	      var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
	      if ('' + uint32Index !== index || uint32Index === 4294967295) {
	        return NaN;
	      }
	      index = uint32Index;
	    }
	    return index < 0 ? ensureSize(iter) + index : index;
	  }
	
	  function returnTrue() {
	    return true;
	  }
	
	  function wholeSlice(begin, end, size) {
	    return (begin === 0 || (size !== undefined && begin <= -size)) &&
	      (end === undefined || (size !== undefined && end >= size));
	  }
	
	  function resolveBegin(begin, size) {
	    return resolveIndex(begin, size, 0);
	  }
	
	  function resolveEnd(end, size) {
	    return resolveIndex(end, size, size);
	  }
	
	  function resolveIndex(index, size, defaultIndex) {
	    return index === undefined ?
	      defaultIndex :
	      index < 0 ?
	        Math.max(0, size + index) :
	        size === undefined ?
	          index :
	          Math.min(size, index);
	  }
	
	  /* global Symbol */
	
	  var ITERATE_KEYS = 0;
	  var ITERATE_VALUES = 1;
	  var ITERATE_ENTRIES = 2;
	
	  var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator';
	
	  var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;
	
	
	  function Iterator(next) {
	      this.next = next;
	    }
	
	    Iterator.prototype.toString = function() {
	      return '[Iterator]';
	    };
	
	
	  Iterator.KEYS = ITERATE_KEYS;
	  Iterator.VALUES = ITERATE_VALUES;
	  Iterator.ENTRIES = ITERATE_ENTRIES;
	
	  Iterator.prototype.inspect =
	  Iterator.prototype.toSource = function () { return this.toString(); }
	  Iterator.prototype[ITERATOR_SYMBOL] = function () {
	    return this;
	  };
	
	
	  function iteratorValue(type, k, v, iteratorResult) {
	    var value = type === 0 ? k : type === 1 ? v : [k, v];
	    iteratorResult ? (iteratorResult.value = value) : (iteratorResult = {
	      value: value, done: false
	    });
	    return iteratorResult;
	  }
	
	  function iteratorDone() {
	    return { value: undefined, done: true };
	  }
	
	  function hasIterator(maybeIterable) {
	    return !!getIteratorFn(maybeIterable);
	  }
	
	  function isIterator(maybeIterator) {
	    return maybeIterator && typeof maybeIterator.next === 'function';
	  }
	
	  function getIterator(iterable) {
	    var iteratorFn = getIteratorFn(iterable);
	    return iteratorFn && iteratorFn.call(iterable);
	  }
	
	  function getIteratorFn(iterable) {
	    var iteratorFn = iterable && (
	      (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL]) ||
	      iterable[FAUX_ITERATOR_SYMBOL]
	    );
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  function isArrayLike(value) {
	    return value && typeof value.length === 'number';
	  }
	
	  createClass(Seq, Iterable);
	    function Seq(value) {
	      return value === null || value === undefined ? emptySequence() :
	        isIterable(value) ? value.toSeq() : seqFromValue(value);
	    }
	
	    Seq.of = function(/*...values*/) {
	      return Seq(arguments);
	    };
	
	    Seq.prototype.toSeq = function() {
	      return this;
	    };
	
	    Seq.prototype.toString = function() {
	      return this.__toString('Seq {', '}');
	    };
	
	    Seq.prototype.cacheResult = function() {
	      if (!this._cache && this.__iterateUncached) {
	        this._cache = this.entrySeq().toArray();
	        this.size = this._cache.length;
	      }
	      return this;
	    };
	
	    // abstract __iterateUncached(fn, reverse)
	
	    Seq.prototype.__iterate = function(fn, reverse) {
	      return seqIterate(this, fn, reverse, true);
	    };
	
	    // abstract __iteratorUncached(type, reverse)
	
	    Seq.prototype.__iterator = function(type, reverse) {
	      return seqIterator(this, type, reverse, true);
	    };
	
	
	
	  createClass(KeyedSeq, Seq);
	    function KeyedSeq(value) {
	      return value === null || value === undefined ?
	        emptySequence().toKeyedSeq() :
	        isIterable(value) ?
	          (isKeyed(value) ? value.toSeq() : value.fromEntrySeq()) :
	          keyedSeqFromValue(value);
	    }
	
	    KeyedSeq.prototype.toKeyedSeq = function() {
	      return this;
	    };
	
	
	
	  createClass(IndexedSeq, Seq);
	    function IndexedSeq(value) {
	      return value === null || value === undefined ? emptySequence() :
	        !isIterable(value) ? indexedSeqFromValue(value) :
	        isKeyed(value) ? value.entrySeq() : value.toIndexedSeq();
	    }
	
	    IndexedSeq.of = function(/*...values*/) {
	      return IndexedSeq(arguments);
	    };
	
	    IndexedSeq.prototype.toIndexedSeq = function() {
	      return this;
	    };
	
	    IndexedSeq.prototype.toString = function() {
	      return this.__toString('Seq [', ']');
	    };
	
	    IndexedSeq.prototype.__iterate = function(fn, reverse) {
	      return seqIterate(this, fn, reverse, false);
	    };
	
	    IndexedSeq.prototype.__iterator = function(type, reverse) {
	      return seqIterator(this, type, reverse, false);
	    };
	
	
	
	  createClass(SetSeq, Seq);
	    function SetSeq(value) {
	      return (
	        value === null || value === undefined ? emptySequence() :
	        !isIterable(value) ? indexedSeqFromValue(value) :
	        isKeyed(value) ? value.entrySeq() : value
	      ).toSetSeq();
	    }
	
	    SetSeq.of = function(/*...values*/) {
	      return SetSeq(arguments);
	    };
	
	    SetSeq.prototype.toSetSeq = function() {
	      return this;
	    };
	
	
	
	  Seq.isSeq = isSeq;
	  Seq.Keyed = KeyedSeq;
	  Seq.Set = SetSeq;
	  Seq.Indexed = IndexedSeq;
	
	  var IS_SEQ_SENTINEL = '@@__IMMUTABLE_SEQ__@@';
	
	  Seq.prototype[IS_SEQ_SENTINEL] = true;
	
	
	
	  createClass(ArraySeq, IndexedSeq);
	    function ArraySeq(array) {
	      this._array = array;
	      this.size = array.length;
	    }
	
	    ArraySeq.prototype.get = function(index, notSetValue) {
	      return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
	    };
	
	    ArraySeq.prototype.__iterate = function(fn, reverse) {
	      var array = this._array;
	      var maxIndex = array.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        if (fn(array[reverse ? maxIndex - ii : ii], ii, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    ArraySeq.prototype.__iterator = function(type, reverse) {
	      var array = this._array;
	      var maxIndex = array.length - 1;
	      var ii = 0;
	      return new Iterator(function() 
	        {return ii > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, ii, array[reverse ? maxIndex - ii++ : ii++])}
	      );
	    };
	
	
	
	  createClass(ObjectSeq, KeyedSeq);
	    function ObjectSeq(object) {
	      var keys = Object.keys(object);
	      this._object = object;
	      this._keys = keys;
	      this.size = keys.length;
	    }
	
	    ObjectSeq.prototype.get = function(key, notSetValue) {
	      if (notSetValue !== undefined && !this.has(key)) {
	        return notSetValue;
	      }
	      return this._object[key];
	    };
	
	    ObjectSeq.prototype.has = function(key) {
	      return this._object.hasOwnProperty(key);
	    };
	
	    ObjectSeq.prototype.__iterate = function(fn, reverse) {
	      var object = this._object;
	      var keys = this._keys;
	      var maxIndex = keys.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        var key = keys[reverse ? maxIndex - ii : ii];
	        if (fn(object[key], key, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    ObjectSeq.prototype.__iterator = function(type, reverse) {
	      var object = this._object;
	      var keys = this._keys;
	      var maxIndex = keys.length - 1;
	      var ii = 0;
	      return new Iterator(function()  {
	        var key = keys[reverse ? maxIndex - ii : ii];
	        return ii++ > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, key, object[key]);
	      });
	    };
	
	  ObjectSeq.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	  createClass(IterableSeq, IndexedSeq);
	    function IterableSeq(iterable) {
	      this._iterable = iterable;
	      this.size = iterable.length || iterable.size;
	    }
	
	    IterableSeq.prototype.__iterateUncached = function(fn, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterable = this._iterable;
	      var iterator = getIterator(iterable);
	      var iterations = 0;
	      if (isIterator(iterator)) {
	        var step;
	        while (!(step = iterator.next()).done) {
	          if (fn(step.value, iterations++, this) === false) {
	            break;
	          }
	        }
	      }
	      return iterations;
	    };
	
	    IterableSeq.prototype.__iteratorUncached = function(type, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterable = this._iterable;
	      var iterator = getIterator(iterable);
	      if (!isIterator(iterator)) {
	        return new Iterator(iteratorDone);
	      }
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step : iteratorValue(type, iterations++, step.value);
	      });
	    };
	
	
	
	  createClass(IteratorSeq, IndexedSeq);
	    function IteratorSeq(iterator) {
	      this._iterator = iterator;
	      this._iteratorCache = [];
	    }
	
	    IteratorSeq.prototype.__iterateUncached = function(fn, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterator = this._iterator;
	      var cache = this._iteratorCache;
	      var iterations = 0;
	      while (iterations < cache.length) {
	        if (fn(cache[iterations], iterations++, this) === false) {
	          return iterations;
	        }
	      }
	      var step;
	      while (!(step = iterator.next()).done) {
	        var val = step.value;
	        cache[iterations] = val;
	        if (fn(val, iterations++, this) === false) {
	          break;
	        }
	      }
	      return iterations;
	    };
	
	    IteratorSeq.prototype.__iteratorUncached = function(type, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = this._iterator;
	      var cache = this._iteratorCache;
	      var iterations = 0;
	      return new Iterator(function()  {
	        if (iterations >= cache.length) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          cache[iterations] = step.value;
	        }
	        return iteratorValue(type, iterations, cache[iterations++]);
	      });
	    };
	
	
	
	
	  // # pragma Helper functions
	
	  function isSeq(maybeSeq) {
	    return !!(maybeSeq && maybeSeq[IS_SEQ_SENTINEL]);
	  }
	
	  var EMPTY_SEQ;
	
	  function emptySequence() {
	    return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
	  }
	
	  function keyedSeqFromValue(value) {
	    var seq =
	      Array.isArray(value) ? new ArraySeq(value).fromEntrySeq() :
	      isIterator(value) ? new IteratorSeq(value).fromEntrySeq() :
	      hasIterator(value) ? new IterableSeq(value).fromEntrySeq() :
	      typeof value === 'object' ? new ObjectSeq(value) :
	      undefined;
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of [k, v] entries, '+
	        'or keyed object: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function indexedSeqFromValue(value) {
	    var seq = maybeIndexedSeqFromValue(value);
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of values: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function seqFromValue(value) {
	    var seq = maybeIndexedSeqFromValue(value) ||
	      (typeof value === 'object' && new ObjectSeq(value));
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of values, or keyed object: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function maybeIndexedSeqFromValue(value) {
	    return (
	      isArrayLike(value) ? new ArraySeq(value) :
	      isIterator(value) ? new IteratorSeq(value) :
	      hasIterator(value) ? new IterableSeq(value) :
	      undefined
	    );
	  }
	
	  function seqIterate(seq, fn, reverse, useKeys) {
	    var cache = seq._cache;
	    if (cache) {
	      var maxIndex = cache.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        var entry = cache[reverse ? maxIndex - ii : ii];
	        if (fn(entry[1], useKeys ? entry[0] : ii, seq) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    }
	    return seq.__iterateUncached(fn, reverse);
	  }
	
	  function seqIterator(seq, type, reverse, useKeys) {
	    var cache = seq._cache;
	    if (cache) {
	      var maxIndex = cache.length - 1;
	      var ii = 0;
	      return new Iterator(function()  {
	        var entry = cache[reverse ? maxIndex - ii : ii];
	        return ii++ > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, useKeys ? entry[0] : ii - 1, entry[1]);
	      });
	    }
	    return seq.__iteratorUncached(type, reverse);
	  }
	
	  function fromJS(json, converter) {
	    return converter ?
	      fromJSWith(converter, json, '', {'': json}) :
	      fromJSDefault(json);
	  }
	
	  function fromJSWith(converter, json, key, parentJSON) {
	    if (Array.isArray(json)) {
	      return converter.call(parentJSON, key, IndexedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
	    }
	    if (isPlainObj(json)) {
	      return converter.call(parentJSON, key, KeyedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
	    }
	    return json;
	  }
	
	  function fromJSDefault(json) {
	    if (Array.isArray(json)) {
	      return IndexedSeq(json).map(fromJSDefault).toList();
	    }
	    if (isPlainObj(json)) {
	      return KeyedSeq(json).map(fromJSDefault).toMap();
	    }
	    return json;
	  }
	
	  function isPlainObj(value) {
	    return value && (value.constructor === Object || value.constructor === undefined);
	  }
	
	  /**
	   * An extension of the "same-value" algorithm as [described for use by ES6 Map
	   * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
	   *
	   * NaN is considered the same as NaN, however -0 and 0 are considered the same
	   * value, which is different from the algorithm described by
	   * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
	   *
	   * This is extended further to allow Objects to describe the values they
	   * represent, by way of `valueOf` or `equals` (and `hashCode`).
	   *
	   * Note: because of this extension, the key equality of Immutable.Map and the
	   * value equality of Immutable.Set will differ from ES6 Map and Set.
	   *
	   * ### Defining custom values
	   *
	   * The easiest way to describe the value an object represents is by implementing
	   * `valueOf`. For example, `Date` represents a value by returning a unix
	   * timestamp for `valueOf`:
	   *
	   *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
	   *     var date2 = new Date(1234567890000);
	   *     date1.valueOf(); // 1234567890000
	   *     assert( date1 !== date2 );
	   *     assert( Immutable.is( date1, date2 ) );
	   *
	   * Note: overriding `valueOf` may have other implications if you use this object
	   * where JavaScript expects a primitive, such as implicit string coercion.
	   *
	   * For more complex types, especially collections, implementing `valueOf` may
	   * not be performant. An alternative is to implement `equals` and `hashCode`.
	   *
	   * `equals` takes another object, presumably of similar type, and returns true
	   * if the it is equal. Equality is symmetrical, so the same result should be
	   * returned if this and the argument are flipped.
	   *
	   *     assert( a.equals(b) === b.equals(a) );
	   *
	   * `hashCode` returns a 32bit integer number representing the object which will
	   * be used to determine how to store the value object in a Map or Set. You must
	   * provide both or neither methods, one must not exist without the other.
	   *
	   * Also, an important relationship between these methods must be upheld: if two
	   * values are equal, they *must* return the same hashCode. If the values are not
	   * equal, they might have the same hashCode; this is called a hash collision,
	   * and while undesirable for performance reasons, it is acceptable.
	   *
	   *     if (a.equals(b)) {
	   *       assert( a.hashCode() === b.hashCode() );
	   *     }
	   *
	   * All Immutable collections implement `equals` and `hashCode`.
	   *
	   */
	  function is(valueA, valueB) {
	    if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
	      return true;
	    }
	    if (!valueA || !valueB) {
	      return false;
	    }
	    if (typeof valueA.valueOf === 'function' &&
	        typeof valueB.valueOf === 'function') {
	      valueA = valueA.valueOf();
	      valueB = valueB.valueOf();
	      if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
	        return true;
	      }
	      if (!valueA || !valueB) {
	        return false;
	      }
	    }
	    if (typeof valueA.equals === 'function' &&
	        typeof valueB.equals === 'function' &&
	        valueA.equals(valueB)) {
	      return true;
	    }
	    return false;
	  }
	
	  function deepEqual(a, b) {
	    if (a === b) {
	      return true;
	    }
	
	    if (
	      !isIterable(b) ||
	      a.size !== undefined && b.size !== undefined && a.size !== b.size ||
	      a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash ||
	      isKeyed(a) !== isKeyed(b) ||
	      isIndexed(a) !== isIndexed(b) ||
	      isOrdered(a) !== isOrdered(b)
	    ) {
	      return false;
	    }
	
	    if (a.size === 0 && b.size === 0) {
	      return true;
	    }
	
	    var notAssociative = !isAssociative(a);
	
	    if (isOrdered(a)) {
	      var entries = a.entries();
	      return b.every(function(v, k)  {
	        var entry = entries.next().value;
	        return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
	      }) && entries.next().done;
	    }
	
	    var flipped = false;
	
	    if (a.size === undefined) {
	      if (b.size === undefined) {
	        if (typeof a.cacheResult === 'function') {
	          a.cacheResult();
	        }
	      } else {
	        flipped = true;
	        var _ = a;
	        a = b;
	        b = _;
	      }
	    }
	
	    var allEqual = true;
	    var bSize = b.__iterate(function(v, k)  {
	      if (notAssociative ? !a.has(v) :
	          flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
	        allEqual = false;
	        return false;
	      }
	    });
	
	    return allEqual && a.size === bSize;
	  }
	
	  createClass(Repeat, IndexedSeq);
	
	    function Repeat(value, times) {
	      if (!(this instanceof Repeat)) {
	        return new Repeat(value, times);
	      }
	      this._value = value;
	      this.size = times === undefined ? Infinity : Math.max(0, times);
	      if (this.size === 0) {
	        if (EMPTY_REPEAT) {
	          return EMPTY_REPEAT;
	        }
	        EMPTY_REPEAT = this;
	      }
	    }
	
	    Repeat.prototype.toString = function() {
	      if (this.size === 0) {
	        return 'Repeat []';
	      }
	      return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
	    };
	
	    Repeat.prototype.get = function(index, notSetValue) {
	      return this.has(index) ? this._value : notSetValue;
	    };
	
	    Repeat.prototype.includes = function(searchValue) {
	      return is(this._value, searchValue);
	    };
	
	    Repeat.prototype.slice = function(begin, end) {
	      var size = this.size;
	      return wholeSlice(begin, end, size) ? this :
	        new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
	    };
	
	    Repeat.prototype.reverse = function() {
	      return this;
	    };
	
	    Repeat.prototype.indexOf = function(searchValue) {
	      if (is(this._value, searchValue)) {
	        return 0;
	      }
	      return -1;
	    };
	
	    Repeat.prototype.lastIndexOf = function(searchValue) {
	      if (is(this._value, searchValue)) {
	        return this.size;
	      }
	      return -1;
	    };
	
	    Repeat.prototype.__iterate = function(fn, reverse) {
	      for (var ii = 0; ii < this.size; ii++) {
	        if (fn(this._value, ii, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    Repeat.prototype.__iterator = function(type, reverse) {var this$0 = this;
	      var ii = 0;
	      return new Iterator(function() 
	        {return ii < this$0.size ? iteratorValue(type, ii++, this$0._value) : iteratorDone()}
	      );
	    };
	
	    Repeat.prototype.equals = function(other) {
	      return other instanceof Repeat ?
	        is(this._value, other._value) :
	        deepEqual(other);
	    };
	
	
	  var EMPTY_REPEAT;
	
	  function invariant(condition, error) {
	    if (!condition) throw new Error(error);
	  }
	
	  createClass(Range, IndexedSeq);
	
	    function Range(start, end, step) {
	      if (!(this instanceof Range)) {
	        return new Range(start, end, step);
	      }
	      invariant(step !== 0, 'Cannot step a Range by 0');
	      start = start || 0;
	      if (end === undefined) {
	        end = Infinity;
	      }
	      step = step === undefined ? 1 : Math.abs(step);
	      if (end < start) {
	        step = -step;
	      }
	      this._start = start;
	      this._end = end;
	      this._step = step;
	      this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
	      if (this.size === 0) {
	        if (EMPTY_RANGE) {
	          return EMPTY_RANGE;
	        }
	        EMPTY_RANGE = this;
	      }
	    }
	
	    Range.prototype.toString = function() {
	      if (this.size === 0) {
	        return 'Range []';
	      }
	      return 'Range [ ' +
	        this._start + '...' + this._end +
	        (this._step > 1 ? ' by ' + this._step : '') +
	      ' ]';
	    };
	
	    Range.prototype.get = function(index, notSetValue) {
	      return this.has(index) ?
	        this._start + wrapIndex(this, index) * this._step :
	        notSetValue;
	    };
	
	    Range.prototype.includes = function(searchValue) {
	      var possibleIndex = (searchValue - this._start) / this._step;
	      return possibleIndex >= 0 &&
	        possibleIndex < this.size &&
	        possibleIndex === Math.floor(possibleIndex);
	    };
	
	    Range.prototype.slice = function(begin, end) {
	      if (wholeSlice(begin, end, this.size)) {
	        return this;
	      }
	      begin = resolveBegin(begin, this.size);
	      end = resolveEnd(end, this.size);
	      if (end <= begin) {
	        return new Range(0, 0);
	      }
	      return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
	    };
	
	    Range.prototype.indexOf = function(searchValue) {
	      var offsetValue = searchValue - this._start;
	      if (offsetValue % this._step === 0) {
	        var index = offsetValue / this._step;
	        if (index >= 0 && index < this.size) {
	          return index
	        }
	      }
	      return -1;
	    };
	
	    Range.prototype.lastIndexOf = function(searchValue) {
	      return this.indexOf(searchValue);
	    };
	
	    Range.prototype.__iterate = function(fn, reverse) {
	      var maxIndex = this.size - 1;
	      var step = this._step;
	      var value = reverse ? this._start + maxIndex * step : this._start;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        if (fn(value, ii, this) === false) {
	          return ii + 1;
	        }
	        value += reverse ? -step : step;
	      }
	      return ii;
	    };
	
	    Range.prototype.__iterator = function(type, reverse) {
	      var maxIndex = this.size - 1;
	      var step = this._step;
	      var value = reverse ? this._start + maxIndex * step : this._start;
	      var ii = 0;
	      return new Iterator(function()  {
	        var v = value;
	        value += reverse ? -step : step;
	        return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii++, v);
	      });
	    };
	
	    Range.prototype.equals = function(other) {
	      return other instanceof Range ?
	        this._start === other._start &&
	        this._end === other._end &&
	        this._step === other._step :
	        deepEqual(this, other);
	    };
	
	
	  var EMPTY_RANGE;
	
	  createClass(Collection, Iterable);
	    function Collection() {
	      throw TypeError('Abstract');
	    }
	
	
	  createClass(KeyedCollection, Collection);function KeyedCollection() {}
	
	  createClass(IndexedCollection, Collection);function IndexedCollection() {}
	
	  createClass(SetCollection, Collection);function SetCollection() {}
	
	
	  Collection.Keyed = KeyedCollection;
	  Collection.Indexed = IndexedCollection;
	  Collection.Set = SetCollection;
	
	  var imul =
	    typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2 ?
	    Math.imul :
	    function imul(a, b) {
	      a = a | 0; // int
	      b = b | 0; // int
	      var c = a & 0xffff;
	      var d = b & 0xffff;
	      // Shift by 0 fixes the sign on the high part.
	      return (c * d) + ((((a >>> 16) * d + c * (b >>> 16)) << 16) >>> 0) | 0; // int
	    };
	
	  // v8 has an optimization for storing 31-bit signed numbers.
	  // Values which have either 00 or 11 as the high order bits qualify.
	  // This function drops the highest order bit in a signed number, maintaining
	  // the sign bit.
	  function smi(i32) {
	    return ((i32 >>> 1) & 0x40000000) | (i32 & 0xBFFFFFFF);
	  }
	
	  function hash(o) {
	    if (o === false || o === null || o === undefined) {
	      return 0;
	    }
	    if (typeof o.valueOf === 'function') {
	      o = o.valueOf();
	      if (o === false || o === null || o === undefined) {
	        return 0;
	      }
	    }
	    if (o === true) {
	      return 1;
	    }
	    var type = typeof o;
	    if (type === 'number') {
	      var h = o | 0;
	      if (h !== o) {
	        h ^= o * 0xFFFFFFFF;
	      }
	      while (o > 0xFFFFFFFF) {
	        o /= 0xFFFFFFFF;
	        h ^= o;
	      }
	      return smi(h);
	    }
	    if (type === 'string') {
	      return o.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(o) : hashString(o);
	    }
	    if (typeof o.hashCode === 'function') {
	      return o.hashCode();
	    }
	    if (type === 'object') {
	      return hashJSObj(o);
	    }
	    if (typeof o.toString === 'function') {
	      return hashString(o.toString());
	    }
	    throw new Error('Value type ' + type + ' cannot be hashed.');
	  }
	
	  function cachedHashString(string) {
	    var hash = stringHashCache[string];
	    if (hash === undefined) {
	      hash = hashString(string);
	      if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
	        STRING_HASH_CACHE_SIZE = 0;
	        stringHashCache = {};
	      }
	      STRING_HASH_CACHE_SIZE++;
	      stringHashCache[string] = hash;
	    }
	    return hash;
	  }
	
	  // http://jsperf.com/hashing-strings
	  function hashString(string) {
	    // This is the hash from JVM
	    // The hash code for a string is computed as
	    // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
	    // where s[i] is the ith character of the string and n is the length of
	    // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
	    // (exclusive) by dropping high bits.
	    var hash = 0;
	    for (var ii = 0; ii < string.length; ii++) {
	      hash = 31 * hash + string.charCodeAt(ii) | 0;
	    }
	    return smi(hash);
	  }
	
	  function hashJSObj(obj) {
	    var hash;
	    if (usingWeakMap) {
	      hash = weakMap.get(obj);
	      if (hash !== undefined) {
	        return hash;
	      }
	    }
	
	    hash = obj[UID_HASH_KEY];
	    if (hash !== undefined) {
	      return hash;
	    }
	
	    if (!canDefineProperty) {
	      hash = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
	      if (hash !== undefined) {
	        return hash;
	      }
	
	      hash = getIENodeHash(obj);
	      if (hash !== undefined) {
	        return hash;
	      }
	    }
	
	    hash = ++objHashUID;
	    if (objHashUID & 0x40000000) {
	      objHashUID = 0;
	    }
	
	    if (usingWeakMap) {
	      weakMap.set(obj, hash);
	    } else if (isExtensible !== undefined && isExtensible(obj) === false) {
	      throw new Error('Non-extensible objects are not allowed as keys.');
	    } else if (canDefineProperty) {
	      Object.defineProperty(obj, UID_HASH_KEY, {
	        'enumerable': false,
	        'configurable': false,
	        'writable': false,
	        'value': hash
	      });
	    } else if (obj.propertyIsEnumerable !== undefined &&
	               obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
	      // Since we can't define a non-enumerable property on the object
	      // we'll hijack one of the less-used non-enumerable properties to
	      // save our hash on it. Since this is a function it will not show up in
	      // `JSON.stringify` which is what we want.
	      obj.propertyIsEnumerable = function() {
	        return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
	      };
	      obj.propertyIsEnumerable[UID_HASH_KEY] = hash;
	    } else if (obj.nodeType !== undefined) {
	      // At this point we couldn't get the IE `uniqueID` to use as a hash
	      // and we couldn't use a non-enumerable property to exploit the
	      // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
	      // itself.
	      obj[UID_HASH_KEY] = hash;
	    } else {
	      throw new Error('Unable to set a non-enumerable property on object.');
	    }
	
	    return hash;
	  }
	
	  // Get references to ES5 object methods.
	  var isExtensible = Object.isExtensible;
	
	  // True if Object.defineProperty works as expected. IE8 fails this test.
	  var canDefineProperty = (function() {
	    try {
	      Object.defineProperty({}, '@', {});
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }());
	
	  // IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
	  // and avoid memory leaks from the IE cloneNode bug.
	  function getIENodeHash(node) {
	    if (node && node.nodeType > 0) {
	      switch (node.nodeType) {
	        case 1: // Element
	          return node.uniqueID;
	        case 9: // Document
	          return node.documentElement && node.documentElement.uniqueID;
	      }
	    }
	  }
	
	  // If possible, use a WeakMap.
	  var usingWeakMap = typeof WeakMap === 'function';
	  var weakMap;
	  if (usingWeakMap) {
	    weakMap = new WeakMap();
	  }
	
	  var objHashUID = 0;
	
	  var UID_HASH_KEY = '__immutablehash__';
	  if (typeof Symbol === 'function') {
	    UID_HASH_KEY = Symbol(UID_HASH_KEY);
	  }
	
	  var STRING_HASH_CACHE_MIN_STRLEN = 16;
	  var STRING_HASH_CACHE_MAX_SIZE = 255;
	  var STRING_HASH_CACHE_SIZE = 0;
	  var stringHashCache = {};
	
	  function assertNotInfinite(size) {
	    invariant(
	      size !== Infinity,
	      'Cannot perform this action with an infinite size.'
	    );
	  }
	
	  createClass(Map, KeyedCollection);
	
	    // @pragma Construction
	
	    function Map(value) {
	      return value === null || value === undefined ? emptyMap() :
	        isMap(value) && !isOrdered(value) ? value :
	        emptyMap().withMutations(function(map ) {
	          var iter = KeyedIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v, k)  {return map.set(k, v)});
	        });
	    }
	
	    Map.prototype.toString = function() {
	      return this.__toString('Map {', '}');
	    };
	
	    // @pragma Access
	
	    Map.prototype.get = function(k, notSetValue) {
	      return this._root ?
	        this._root.get(0, undefined, k, notSetValue) :
	        notSetValue;
	    };
	
	    // @pragma Modification
	
	    Map.prototype.set = function(k, v) {
	      return updateMap(this, k, v);
	    };
	
	    Map.prototype.setIn = function(keyPath, v) {
	      return this.updateIn(keyPath, NOT_SET, function()  {return v});
	    };
	
	    Map.prototype.remove = function(k) {
	      return updateMap(this, k, NOT_SET);
	    };
	
	    Map.prototype.deleteIn = function(keyPath) {
	      return this.updateIn(keyPath, function()  {return NOT_SET});
	    };
	
	    Map.prototype.update = function(k, notSetValue, updater) {
	      return arguments.length === 1 ?
	        k(this) :
	        this.updateIn([k], notSetValue, updater);
	    };
	
	    Map.prototype.updateIn = function(keyPath, notSetValue, updater) {
	      if (!updater) {
	        updater = notSetValue;
	        notSetValue = undefined;
	      }
	      var updatedValue = updateInDeepMap(
	        this,
	        forceIterator(keyPath),
	        notSetValue,
	        updater
	      );
	      return updatedValue === NOT_SET ? undefined : updatedValue;
	    };
	
	    Map.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._root = null;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyMap();
	    };
	
	    // @pragma Composition
	
	    Map.prototype.merge = function(/*...iters*/) {
	      return mergeIntoMapWith(this, undefined, arguments);
	    };
	
	    Map.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoMapWith(this, merger, iters);
	    };
	
	    Map.prototype.mergeIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
	      return this.updateIn(
	        keyPath,
	        emptyMap(),
	        function(m ) {return typeof m.merge === 'function' ?
	          m.merge.apply(m, iters) :
	          iters[iters.length - 1]}
	      );
	    };
	
	    Map.prototype.mergeDeep = function(/*...iters*/) {
	      return mergeIntoMapWith(this, deepMerger, arguments);
	    };
	
	    Map.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoMapWith(this, deepMergerWith(merger), iters);
	    };
	
	    Map.prototype.mergeDeepIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
	      return this.updateIn(
	        keyPath,
	        emptyMap(),
	        function(m ) {return typeof m.mergeDeep === 'function' ?
	          m.mergeDeep.apply(m, iters) :
	          iters[iters.length - 1]}
	      );
	    };
	
	    Map.prototype.sort = function(comparator) {
	      // Late binding
	      return OrderedMap(sortFactory(this, comparator));
	    };
	
	    Map.prototype.sortBy = function(mapper, comparator) {
	      // Late binding
	      return OrderedMap(sortFactory(this, comparator, mapper));
	    };
	
	    // @pragma Mutability
	
	    Map.prototype.withMutations = function(fn) {
	      var mutable = this.asMutable();
	      fn(mutable);
	      return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
	    };
	
	    Map.prototype.asMutable = function() {
	      return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
	    };
	
	    Map.prototype.asImmutable = function() {
	      return this.__ensureOwner();
	    };
	
	    Map.prototype.wasAltered = function() {
	      return this.__altered;
	    };
	
	    Map.prototype.__iterator = function(type, reverse) {
	      return new MapIterator(this, type, reverse);
	    };
	
	    Map.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      this._root && this._root.iterate(function(entry ) {
	        iterations++;
	        return fn(entry[1], entry[0], this$0);
	      }, reverse);
	      return iterations;
	    };
	
	    Map.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this.__altered = false;
	        return this;
	      }
	      return makeMap(this.size, this._root, ownerID, this.__hash);
	    };
	
	
	  function isMap(maybeMap) {
	    return !!(maybeMap && maybeMap[IS_MAP_SENTINEL]);
	  }
	
	  Map.isMap = isMap;
	
	  var IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';
	
	  var MapPrototype = Map.prototype;
	  MapPrototype[IS_MAP_SENTINEL] = true;
	  MapPrototype[DELETE] = MapPrototype.remove;
	  MapPrototype.removeIn = MapPrototype.deleteIn;
	
	
	  // #pragma Trie Nodes
	
	
	
	    function ArrayMapNode(ownerID, entries) {
	      this.ownerID = ownerID;
	      this.entries = entries;
	    }
	
	    ArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      var entries = this.entries;
	      for (var ii = 0, len = entries.length; ii < len; ii++) {
	        if (is(key, entries[ii][0])) {
	          return entries[ii][1];
	        }
	      }
	      return notSetValue;
	    };
	
	    ArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      var removed = value === NOT_SET;
	
	      var entries = this.entries;
	      var idx = 0;
	      for (var len = entries.length; idx < len; idx++) {
	        if (is(key, entries[idx][0])) {
	          break;
	        }
	      }
	      var exists = idx < len;
	
	      if (exists ? entries[idx][1] === value : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	      (removed || !exists) && SetRef(didChangeSize);
	
	      if (removed && entries.length === 1) {
	        return; // undefined
	      }
	
	      if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) {
	        return createNodes(ownerID, entries, key, value);
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newEntries = isEditable ? entries : arrCopy(entries);
	
	      if (exists) {
	        if (removed) {
	          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
	        } else {
	          newEntries[idx] = [key, value];
	        }
	      } else {
	        newEntries.push([key, value]);
	      }
	
	      if (isEditable) {
	        this.entries = newEntries;
	        return this;
	      }
	
	      return new ArrayMapNode(ownerID, newEntries);
	    };
	
	
	
	
	    function BitmapIndexedNode(ownerID, bitmap, nodes) {
	      this.ownerID = ownerID;
	      this.bitmap = bitmap;
	      this.nodes = nodes;
	    }
	
	    BitmapIndexedNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var bit = (1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK));
	      var bitmap = this.bitmap;
	      return (bitmap & bit) === 0 ? notSetValue :
	        this.nodes[popCount(bitmap & (bit - 1))].get(shift + SHIFT, keyHash, key, notSetValue);
	    };
	
	    BitmapIndexedNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var bit = 1 << keyHashFrag;
	      var bitmap = this.bitmap;
	      var exists = (bitmap & bit) !== 0;
	
	      if (!exists && value === NOT_SET) {
	        return this;
	      }
	
	      var idx = popCount(bitmap & (bit - 1));
	      var nodes = this.nodes;
	      var node = exists ? nodes[idx] : undefined;
	      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
	
	      if (newNode === node) {
	        return this;
	      }
	
	      if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) {
	        return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
	      }
	
	      if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) {
	        return nodes[idx ^ 1];
	      }
	
	      if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) {
	        return newNode;
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
	      var newNodes = exists ? newNode ?
	        setIn(nodes, idx, newNode, isEditable) :
	        spliceOut(nodes, idx, isEditable) :
	        spliceIn(nodes, idx, newNode, isEditable);
	
	      if (isEditable) {
	        this.bitmap = newBitmap;
	        this.nodes = newNodes;
	        return this;
	      }
	
	      return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
	    };
	
	
	
	
	    function HashArrayMapNode(ownerID, count, nodes) {
	      this.ownerID = ownerID;
	      this.count = count;
	      this.nodes = nodes;
	    }
	
	    HashArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var node = this.nodes[idx];
	      return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
	    };
	
	    HashArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var removed = value === NOT_SET;
	      var nodes = this.nodes;
	      var node = nodes[idx];
	
	      if (removed && !node) {
	        return this;
	      }
	
	      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
	      if (newNode === node) {
	        return this;
	      }
	
	      var newCount = this.count;
	      if (!node) {
	        newCount++;
	      } else if (!newNode) {
	        newCount--;
	        if (newCount < MIN_HASH_ARRAY_MAP_SIZE) {
	          return packNodes(ownerID, nodes, newCount, idx);
	        }
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newNodes = setIn(nodes, idx, newNode, isEditable);
	
	      if (isEditable) {
	        this.count = newCount;
	        this.nodes = newNodes;
	        return this;
	      }
	
	      return new HashArrayMapNode(ownerID, newCount, newNodes);
	    };
	
	
	
	
	    function HashCollisionNode(ownerID, keyHash, entries) {
	      this.ownerID = ownerID;
	      this.keyHash = keyHash;
	      this.entries = entries;
	    }
	
	    HashCollisionNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      var entries = this.entries;
	      for (var ii = 0, len = entries.length; ii < len; ii++) {
	        if (is(key, entries[ii][0])) {
	          return entries[ii][1];
	        }
	      }
	      return notSetValue;
	    };
	
	    HashCollisionNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	
	      var removed = value === NOT_SET;
	
	      if (keyHash !== this.keyHash) {
	        if (removed) {
	          return this;
	        }
	        SetRef(didAlter);
	        SetRef(didChangeSize);
	        return mergeIntoNode(this, ownerID, shift, keyHash, [key, value]);
	      }
	
	      var entries = this.entries;
	      var idx = 0;
	      for (var len = entries.length; idx < len; idx++) {
	        if (is(key, entries[idx][0])) {
	          break;
	        }
	      }
	      var exists = idx < len;
	
	      if (exists ? entries[idx][1] === value : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	      (removed || !exists) && SetRef(didChangeSize);
	
	      if (removed && len === 2) {
	        return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newEntries = isEditable ? entries : arrCopy(entries);
	
	      if (exists) {
	        if (removed) {
	          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
	        } else {
	          newEntries[idx] = [key, value];
	        }
	      } else {
	        newEntries.push([key, value]);
	      }
	
	      if (isEditable) {
	        this.entries = newEntries;
	        return this;
	      }
	
	      return new HashCollisionNode(ownerID, this.keyHash, newEntries);
	    };
	
	
	
	
	    function ValueNode(ownerID, keyHash, entry) {
	      this.ownerID = ownerID;
	      this.keyHash = keyHash;
	      this.entry = entry;
	    }
	
	    ValueNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
	    };
	
	    ValueNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      var removed = value === NOT_SET;
	      var keyMatch = is(key, this.entry[0]);
	      if (keyMatch ? value === this.entry[1] : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	
	      if (removed) {
	        SetRef(didChangeSize);
	        return; // undefined
	      }
	
	      if (keyMatch) {
	        if (ownerID && ownerID === this.ownerID) {
	          this.entry[1] = value;
	          return this;
	        }
	        return new ValueNode(ownerID, this.keyHash, [key, value]);
	      }
	
	      SetRef(didChangeSize);
	      return mergeIntoNode(this, ownerID, shift, hash(key), [key, value]);
	    };
	
	
	
	  // #pragma Iterators
	
	  ArrayMapNode.prototype.iterate =
	  HashCollisionNode.prototype.iterate = function (fn, reverse) {
	    var entries = this.entries;
	    for (var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++) {
	      if (fn(entries[reverse ? maxIndex - ii : ii]) === false) {
	        return false;
	      }
	    }
	  }
	
	  BitmapIndexedNode.prototype.iterate =
	  HashArrayMapNode.prototype.iterate = function (fn, reverse) {
	    var nodes = this.nodes;
	    for (var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++) {
	      var node = nodes[reverse ? maxIndex - ii : ii];
	      if (node && node.iterate(fn, reverse) === false) {
	        return false;
	      }
	    }
	  }
	
	  ValueNode.prototype.iterate = function (fn, reverse) {
	    return fn(this.entry);
	  }
	
	  createClass(MapIterator, Iterator);
	
	    function MapIterator(map, type, reverse) {
	      this._type = type;
	      this._reverse = reverse;
	      this._stack = map._root && mapIteratorFrame(map._root);
	    }
	
	    MapIterator.prototype.next = function() {
	      var type = this._type;
	      var stack = this._stack;
	      while (stack) {
	        var node = stack.node;
	        var index = stack.index++;
	        var maxIndex;
	        if (node.entry) {
	          if (index === 0) {
	            return mapIteratorValue(type, node.entry);
	          }
	        } else if (node.entries) {
	          maxIndex = node.entries.length - 1;
	          if (index <= maxIndex) {
	            return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
	          }
	        } else {
	          maxIndex = node.nodes.length - 1;
	          if (index <= maxIndex) {
	            var subNode = node.nodes[this._reverse ? maxIndex - index : index];
	            if (subNode) {
	              if (subNode.entry) {
	                return mapIteratorValue(type, subNode.entry);
	              }
	              stack = this._stack = mapIteratorFrame(subNode, stack);
	            }
	            continue;
	          }
	        }
	        stack = this._stack = this._stack.__prev;
	      }
	      return iteratorDone();
	    };
	
	
	  function mapIteratorValue(type, entry) {
	    return iteratorValue(type, entry[0], entry[1]);
	  }
	
	  function mapIteratorFrame(node, prev) {
	    return {
	      node: node,
	      index: 0,
	      __prev: prev
	    };
	  }
	
	  function makeMap(size, root, ownerID, hash) {
	    var map = Object.create(MapPrototype);
	    map.size = size;
	    map._root = root;
	    map.__ownerID = ownerID;
	    map.__hash = hash;
	    map.__altered = false;
	    return map;
	  }
	
	  var EMPTY_MAP;
	  function emptyMap() {
	    return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
	  }
	
	  function updateMap(map, k, v) {
	    var newRoot;
	    var newSize;
	    if (!map._root) {
	      if (v === NOT_SET) {
	        return map;
	      }
	      newSize = 1;
	      newRoot = new ArrayMapNode(map.__ownerID, [[k, v]]);
	    } else {
	      var didChangeSize = MakeRef(CHANGE_LENGTH);
	      var didAlter = MakeRef(DID_ALTER);
	      newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);
	      if (!didAlter.value) {
	        return map;
	      }
	      newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
	    }
	    if (map.__ownerID) {
	      map.size = newSize;
	      map._root = newRoot;
	      map.__hash = undefined;
	      map.__altered = true;
	      return map;
	    }
	    return newRoot ? makeMap(newSize, newRoot) : emptyMap();
	  }
	
	  function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	    if (!node) {
	      if (value === NOT_SET) {
	        return node;
	      }
	      SetRef(didAlter);
	      SetRef(didChangeSize);
	      return new ValueNode(ownerID, keyHash, [key, value]);
	    }
	    return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
	  }
	
	  function isLeafNode(node) {
	    return node.constructor === ValueNode || node.constructor === HashCollisionNode;
	  }
	
	  function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
	    if (node.keyHash === keyHash) {
	      return new HashCollisionNode(ownerID, keyHash, [node.entry, entry]);
	    }
	
	    var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
	    var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	
	    var newNode;
	    var nodes = idx1 === idx2 ?
	      [mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)] :
	      ((newNode = new ValueNode(ownerID, keyHash, entry)), idx1 < idx2 ? [node, newNode] : [newNode, node]);
	
	    return new BitmapIndexedNode(ownerID, (1 << idx1) | (1 << idx2), nodes);
	  }
	
	  function createNodes(ownerID, entries, key, value) {
	    if (!ownerID) {
	      ownerID = new OwnerID();
	    }
	    var node = new ValueNode(ownerID, hash(key), [key, value]);
	    for (var ii = 0; ii < entries.length; ii++) {
	      var entry = entries[ii];
	      node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
	    }
	    return node;
	  }
	
	  function packNodes(ownerID, nodes, count, excluding) {
	    var bitmap = 0;
	    var packedII = 0;
	    var packedNodes = new Array(count);
	    for (var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1) {
	      var node = nodes[ii];
	      if (node !== undefined && ii !== excluding) {
	        bitmap |= bit;
	        packedNodes[packedII++] = node;
	      }
	    }
	    return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
	  }
	
	  function expandNodes(ownerID, nodes, bitmap, including, node) {
	    var count = 0;
	    var expandedNodes = new Array(SIZE);
	    for (var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1) {
	      expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
	    }
	    expandedNodes[including] = node;
	    return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
	  }
	
	  function mergeIntoMapWith(map, merger, iterables) {
	    var iters = [];
	    for (var ii = 0; ii < iterables.length; ii++) {
	      var value = iterables[ii];
	      var iter = KeyedIterable(value);
	      if (!isIterable(value)) {
	        iter = iter.map(function(v ) {return fromJS(v)});
	      }
	      iters.push(iter);
	    }
	    return mergeIntoCollectionWith(map, merger, iters);
	  }
	
	  function deepMerger(existing, value, key) {
	    return existing && existing.mergeDeep && isIterable(value) ?
	      existing.mergeDeep(value) :
	      is(existing, value) ? existing : value;
	  }
	
	  function deepMergerWith(merger) {
	    return function(existing, value, key)  {
	      if (existing && existing.mergeDeepWith && isIterable(value)) {
	        return existing.mergeDeepWith(merger, value);
	      }
	      var nextValue = merger(existing, value, key);
	      return is(existing, nextValue) ? existing : nextValue;
	    };
	  }
	
	  function mergeIntoCollectionWith(collection, merger, iters) {
	    iters = iters.filter(function(x ) {return x.size !== 0});
	    if (iters.length === 0) {
	      return collection;
	    }
	    if (collection.size === 0 && !collection.__ownerID && iters.length === 1) {
	      return collection.constructor(iters[0]);
	    }
	    return collection.withMutations(function(collection ) {
	      var mergeIntoMap = merger ?
	        function(value, key)  {
	          collection.update(key, NOT_SET, function(existing )
	            {return existing === NOT_SET ? value : merger(existing, value, key)}
	          );
	        } :
	        function(value, key)  {
	          collection.set(key, value);
	        }
	      for (var ii = 0; ii < iters.length; ii++) {
	        iters[ii].forEach(mergeIntoMap);
	      }
	    });
	  }
	
	  function updateInDeepMap(existing, keyPathIter, notSetValue, updater) {
	    var isNotSet = existing === NOT_SET;
	    var step = keyPathIter.next();
	    if (step.done) {
	      var existingValue = isNotSet ? notSetValue : existing;
	      var newValue = updater(existingValue);
	      return newValue === existingValue ? existing : newValue;
	    }
	    invariant(
	      isNotSet || (existing && existing.set),
	      'invalid keyPath'
	    );
	    var key = step.value;
	    var nextExisting = isNotSet ? NOT_SET : existing.get(key, NOT_SET);
	    var nextUpdated = updateInDeepMap(
	      nextExisting,
	      keyPathIter,
	      notSetValue,
	      updater
	    );
	    return nextUpdated === nextExisting ? existing :
	      nextUpdated === NOT_SET ? existing.remove(key) :
	      (isNotSet ? emptyMap() : existing).set(key, nextUpdated);
	  }
	
	  function popCount(x) {
	    x = x - ((x >> 1) & 0x55555555);
	    x = (x & 0x33333333) + ((x >> 2) & 0x33333333);
	    x = (x + (x >> 4)) & 0x0f0f0f0f;
	    x = x + (x >> 8);
	    x = x + (x >> 16);
	    return x & 0x7f;
	  }
	
	  function setIn(array, idx, val, canEdit) {
	    var newArray = canEdit ? array : arrCopy(array);
	    newArray[idx] = val;
	    return newArray;
	  }
	
	  function spliceIn(array, idx, val, canEdit) {
	    var newLen = array.length + 1;
	    if (canEdit && idx + 1 === newLen) {
	      array[idx] = val;
	      return array;
	    }
	    var newArray = new Array(newLen);
	    var after = 0;
	    for (var ii = 0; ii < newLen; ii++) {
	      if (ii === idx) {
	        newArray[ii] = val;
	        after = -1;
	      } else {
	        newArray[ii] = array[ii + after];
	      }
	    }
	    return newArray;
	  }
	
	  function spliceOut(array, idx, canEdit) {
	    var newLen = array.length - 1;
	    if (canEdit && idx === newLen) {
	      array.pop();
	      return array;
	    }
	    var newArray = new Array(newLen);
	    var after = 0;
	    for (var ii = 0; ii < newLen; ii++) {
	      if (ii === idx) {
	        after = 1;
	      }
	      newArray[ii] = array[ii + after];
	    }
	    return newArray;
	  }
	
	  var MAX_ARRAY_MAP_SIZE = SIZE / 4;
	  var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
	  var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;
	
	  createClass(List, IndexedCollection);
	
	    // @pragma Construction
	
	    function List(value) {
	      var empty = emptyList();
	      if (value === null || value === undefined) {
	        return empty;
	      }
	      if (isList(value)) {
	        return value;
	      }
	      var iter = IndexedIterable(value);
	      var size = iter.size;
	      if (size === 0) {
	        return empty;
	      }
	      assertNotInfinite(size);
	      if (size > 0 && size < SIZE) {
	        return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
	      }
	      return empty.withMutations(function(list ) {
	        list.setSize(size);
	        iter.forEach(function(v, i)  {return list.set(i, v)});
	      });
	    }
	
	    List.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    List.prototype.toString = function() {
	      return this.__toString('List [', ']');
	    };
	
	    // @pragma Access
	
	    List.prototype.get = function(index, notSetValue) {
	      index = wrapIndex(this, index);
	      if (index >= 0 && index < this.size) {
	        index += this._origin;
	        var node = listNodeFor(this, index);
	        return node && node.array[index & MASK];
	      }
	      return notSetValue;
	    };
	
	    // @pragma Modification
	
	    List.prototype.set = function(index, value) {
	      return updateList(this, index, value);
	    };
	
	    List.prototype.remove = function(index) {
	      return !this.has(index) ? this :
	        index === 0 ? this.shift() :
	        index === this.size - 1 ? this.pop() :
	        this.splice(index, 1);
	    };
	
	    List.prototype.insert = function(index, value) {
	      return this.splice(index, 0, value);
	    };
	
	    List.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = this._origin = this._capacity = 0;
	        this._level = SHIFT;
	        this._root = this._tail = null;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyList();
	    };
	
	    List.prototype.push = function(/*...values*/) {
	      var values = arguments;
	      var oldSize = this.size;
	      return this.withMutations(function(list ) {
	        setListBounds(list, 0, oldSize + values.length);
	        for (var ii = 0; ii < values.length; ii++) {
	          list.set(oldSize + ii, values[ii]);
	        }
	      });
	    };
	
	    List.prototype.pop = function() {
	      return setListBounds(this, 0, -1);
	    };
	
	    List.prototype.unshift = function(/*...values*/) {
	      var values = arguments;
	      return this.withMutations(function(list ) {
	        setListBounds(list, -values.length);
	        for (var ii = 0; ii < values.length; ii++) {
	          list.set(ii, values[ii]);
	        }
	      });
	    };
	
	    List.prototype.shift = function() {
	      return setListBounds(this, 1);
	    };
	
	    // @pragma Composition
	
	    List.prototype.merge = function(/*...iters*/) {
	      return mergeIntoListWith(this, undefined, arguments);
	    };
	
	    List.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoListWith(this, merger, iters);
	    };
	
	    List.prototype.mergeDeep = function(/*...iters*/) {
	      return mergeIntoListWith(this, deepMerger, arguments);
	    };
	
	    List.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoListWith(this, deepMergerWith(merger), iters);
	    };
	
	    List.prototype.setSize = function(size) {
	      return setListBounds(this, 0, size);
	    };
	
	    // @pragma Iteration
	
	    List.prototype.slice = function(begin, end) {
	      var size = this.size;
	      if (wholeSlice(begin, end, size)) {
	        return this;
	      }
	      return setListBounds(
	        this,
	        resolveBegin(begin, size),
	        resolveEnd(end, size)
	      );
	    };
	
	    List.prototype.__iterator = function(type, reverse) {
	      var index = 0;
	      var values = iterateList(this, reverse);
	      return new Iterator(function()  {
	        var value = values();
	        return value === DONE ?
	          iteratorDone() :
	          iteratorValue(type, index++, value);
	      });
	    };
	
	    List.prototype.__iterate = function(fn, reverse) {
	      var index = 0;
	      var values = iterateList(this, reverse);
	      var value;
	      while ((value = values()) !== DONE) {
	        if (fn(value, index++, this) === false) {
	          break;
	        }
	      }
	      return index;
	    };
	
	    List.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        return this;
	      }
	      return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
	    };
	
	
	  function isList(maybeList) {
	    return !!(maybeList && maybeList[IS_LIST_SENTINEL]);
	  }
	
	  List.isList = isList;
	
	  var IS_LIST_SENTINEL = '@@__IMMUTABLE_LIST__@@';
	
	  var ListPrototype = List.prototype;
	  ListPrototype[IS_LIST_SENTINEL] = true;
	  ListPrototype[DELETE] = ListPrototype.remove;
	  ListPrototype.setIn = MapPrototype.setIn;
	  ListPrototype.deleteIn =
	  ListPrototype.removeIn = MapPrototype.removeIn;
	  ListPrototype.update = MapPrototype.update;
	  ListPrototype.updateIn = MapPrototype.updateIn;
	  ListPrototype.mergeIn = MapPrototype.mergeIn;
	  ListPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
	  ListPrototype.withMutations = MapPrototype.withMutations;
	  ListPrototype.asMutable = MapPrototype.asMutable;
	  ListPrototype.asImmutable = MapPrototype.asImmutable;
	  ListPrototype.wasAltered = MapPrototype.wasAltered;
	
	
	
	    function VNode(array, ownerID) {
	      this.array = array;
	      this.ownerID = ownerID;
	    }
	
	    // TODO: seems like these methods are very similar
	
	    VNode.prototype.removeBefore = function(ownerID, level, index) {
	      if (index === level ? 1 << level : 0 || this.array.length === 0) {
	        return this;
	      }
	      var originIndex = (index >>> level) & MASK;
	      if (originIndex >= this.array.length) {
	        return new VNode([], ownerID);
	      }
	      var removingFirst = originIndex === 0;
	      var newChild;
	      if (level > 0) {
	        var oldChild = this.array[originIndex];
	        newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
	        if (newChild === oldChild && removingFirst) {
	          return this;
	        }
	      }
	      if (removingFirst && !newChild) {
	        return this;
	      }
	      var editable = editableVNode(this, ownerID);
	      if (!removingFirst) {
	        for (var ii = 0; ii < originIndex; ii++) {
	          editable.array[ii] = undefined;
	        }
	      }
	      if (newChild) {
	        editable.array[originIndex] = newChild;
	      }
	      return editable;
	    };
	
	    VNode.prototype.removeAfter = function(ownerID, level, index) {
	      if (index === (level ? 1 << level : 0) || this.array.length === 0) {
	        return this;
	      }
	      var sizeIndex = ((index - 1) >>> level) & MASK;
	      if (sizeIndex >= this.array.length) {
	        return this;
	      }
	
	      var newChild;
	      if (level > 0) {
	        var oldChild = this.array[sizeIndex];
	        newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
	        if (newChild === oldChild && sizeIndex === this.array.length - 1) {
	          return this;
	        }
	      }
	
	      var editable = editableVNode(this, ownerID);
	      editable.array.splice(sizeIndex + 1);
	      if (newChild) {
	        editable.array[sizeIndex] = newChild;
	      }
	      return editable;
	    };
	
	
	
	  var DONE = {};
	
	  function iterateList(list, reverse) {
	    var left = list._origin;
	    var right = list._capacity;
	    var tailPos = getTailOffset(right);
	    var tail = list._tail;
	
	    return iterateNodeOrLeaf(list._root, list._level, 0);
	
	    function iterateNodeOrLeaf(node, level, offset) {
	      return level === 0 ?
	        iterateLeaf(node, offset) :
	        iterateNode(node, level, offset);
	    }
	
	    function iterateLeaf(node, offset) {
	      var array = offset === tailPos ? tail && tail.array : node && node.array;
	      var from = offset > left ? 0 : left - offset;
	      var to = right - offset;
	      if (to > SIZE) {
	        to = SIZE;
	      }
	      return function()  {
	        if (from === to) {
	          return DONE;
	        }
	        var idx = reverse ? --to : from++;
	        return array && array[idx];
	      };
	    }
	
	    function iterateNode(node, level, offset) {
	      var values;
	      var array = node && node.array;
	      var from = offset > left ? 0 : (left - offset) >> level;
	      var to = ((right - offset) >> level) + 1;
	      if (to > SIZE) {
	        to = SIZE;
	      }
	      return function()  {
	        do {
	          if (values) {
	            var value = values();
	            if (value !== DONE) {
	              return value;
	            }
	            values = null;
	          }
	          if (from === to) {
	            return DONE;
	          }
	          var idx = reverse ? --to : from++;
	          values = iterateNodeOrLeaf(
	            array && array[idx], level - SHIFT, offset + (idx << level)
	          );
	        } while (true);
	      };
	    }
	  }
	
	  function makeList(origin, capacity, level, root, tail, ownerID, hash) {
	    var list = Object.create(ListPrototype);
	    list.size = capacity - origin;
	    list._origin = origin;
	    list._capacity = capacity;
	    list._level = level;
	    list._root = root;
	    list._tail = tail;
	    list.__ownerID = ownerID;
	    list.__hash = hash;
	    list.__altered = false;
	    return list;
	  }
	
	  var EMPTY_LIST;
	  function emptyList() {
	    return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
	  }
	
	  function updateList(list, index, value) {
	    index = wrapIndex(list, index);
	
	    if (index !== index) {
	      return list;
	    }
	
	    if (index >= list.size || index < 0) {
	      return list.withMutations(function(list ) {
	        index < 0 ?
	          setListBounds(list, index).set(0, value) :
	          setListBounds(list, 0, index + 1).set(index, value)
	      });
	    }
	
	    index += list._origin;
	
	    var newTail = list._tail;
	    var newRoot = list._root;
	    var didAlter = MakeRef(DID_ALTER);
	    if (index >= getTailOffset(list._capacity)) {
	      newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
	    } else {
	      newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
	    }
	
	    if (!didAlter.value) {
	      return list;
	    }
	
	    if (list.__ownerID) {
	      list._root = newRoot;
	      list._tail = newTail;
	      list.__hash = undefined;
	      list.__altered = true;
	      return list;
	    }
	    return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
	  }
	
	  function updateVNode(node, ownerID, level, index, value, didAlter) {
	    var idx = (index >>> level) & MASK;
	    var nodeHas = node && idx < node.array.length;
	    if (!nodeHas && value === undefined) {
	      return node;
	    }
	
	    var newNode;
	
	    if (level > 0) {
	      var lowerNode = node && node.array[idx];
	      var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
	      if (newLowerNode === lowerNode) {
	        return node;
	      }
	      newNode = editableVNode(node, ownerID);
	      newNode.array[idx] = newLowerNode;
	      return newNode;
	    }
	
	    if (nodeHas && node.array[idx] === value) {
	      return node;
	    }
	
	    SetRef(didAlter);
	
	    newNode = editableVNode(node, ownerID);
	    if (value === undefined && idx === newNode.array.length - 1) {
	      newNode.array.pop();
	    } else {
	      newNode.array[idx] = value;
	    }
	    return newNode;
	  }
	
	  function editableVNode(node, ownerID) {
	    if (ownerID && node && ownerID === node.ownerID) {
	      return node;
	    }
	    return new VNode(node ? node.array.slice() : [], ownerID);
	  }
	
	  function listNodeFor(list, rawIndex) {
	    if (rawIndex >= getTailOffset(list._capacity)) {
	      return list._tail;
	    }
	    if (rawIndex < 1 << (list._level + SHIFT)) {
	      var node = list._root;
	      var level = list._level;
	      while (node && level > 0) {
	        node = node.array[(rawIndex >>> level) & MASK];
	        level -= SHIFT;
	      }
	      return node;
	    }
	  }
	
	  function setListBounds(list, begin, end) {
	    // Sanitize begin & end using this shorthand for ToInt32(argument)
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
	    if (begin !== undefined) {
	      begin = begin | 0;
	    }
	    if (end !== undefined) {
	      end = end | 0;
	    }
	    var owner = list.__ownerID || new OwnerID();
	    var oldOrigin = list._origin;
	    var oldCapacity = list._capacity;
	    var newOrigin = oldOrigin + begin;
	    var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
	    if (newOrigin === oldOrigin && newCapacity === oldCapacity) {
	      return list;
	    }
	
	    // If it's going to end after it starts, it's empty.
	    if (newOrigin >= newCapacity) {
	      return list.clear();
	    }
	
	    var newLevel = list._level;
	    var newRoot = list._root;
	
	    // New origin might need creating a higher root.
	    var offsetShift = 0;
	    while (newOrigin + offsetShift < 0) {
	      newRoot = new VNode(newRoot && newRoot.array.length ? [undefined, newRoot] : [], owner);
	      newLevel += SHIFT;
	      offsetShift += 1 << newLevel;
	    }
	    if (offsetShift) {
	      newOrigin += offsetShift;
	      oldOrigin += offsetShift;
	      newCapacity += offsetShift;
	      oldCapacity += offsetShift;
	    }
	
	    var oldTailOffset = getTailOffset(oldCapacity);
	    var newTailOffset = getTailOffset(newCapacity);
	
	    // New size might need creating a higher root.
	    while (newTailOffset >= 1 << (newLevel + SHIFT)) {
	      newRoot = new VNode(newRoot && newRoot.array.length ? [newRoot] : [], owner);
	      newLevel += SHIFT;
	    }
	
	    // Locate or create the new tail.
	    var oldTail = list._tail;
	    var newTail = newTailOffset < oldTailOffset ?
	      listNodeFor(list, newCapacity - 1) :
	      newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;
	
	    // Merge Tail into tree.
	    if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
	      newRoot = editableVNode(newRoot, owner);
	      var node = newRoot;
	      for (var level = newLevel; level > SHIFT; level -= SHIFT) {
	        var idx = (oldTailOffset >>> level) & MASK;
	        node = node.array[idx] = editableVNode(node.array[idx], owner);
	      }
	      node.array[(oldTailOffset >>> SHIFT) & MASK] = oldTail;
	    }
	
	    // If the size has been reduced, there's a chance the tail needs to be trimmed.
	    if (newCapacity < oldCapacity) {
	      newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
	    }
	
	    // If the new origin is within the tail, then we do not need a root.
	    if (newOrigin >= newTailOffset) {
	      newOrigin -= newTailOffset;
	      newCapacity -= newTailOffset;
	      newLevel = SHIFT;
	      newRoot = null;
	      newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);
	
	    // Otherwise, if the root has been trimmed, garbage collect.
	    } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
	      offsetShift = 0;
	
	      // Identify the new top root node of the subtree of the old root.
	      while (newRoot) {
	        var beginIndex = (newOrigin >>> newLevel) & MASK;
	        if (beginIndex !== (newTailOffset >>> newLevel) & MASK) {
	          break;
	        }
	        if (beginIndex) {
	          offsetShift += (1 << newLevel) * beginIndex;
	        }
	        newLevel -= SHIFT;
	        newRoot = newRoot.array[beginIndex];
	      }
	
	      // Trim the new sides of the new root.
	      if (newRoot && newOrigin > oldOrigin) {
	        newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
	      }
	      if (newRoot && newTailOffset < oldTailOffset) {
	        newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
	      }
	      if (offsetShift) {
	        newOrigin -= offsetShift;
	        newCapacity -= offsetShift;
	      }
	    }
	
	    if (list.__ownerID) {
	      list.size = newCapacity - newOrigin;
	      list._origin = newOrigin;
	      list._capacity = newCapacity;
	      list._level = newLevel;
	      list._root = newRoot;
	      list._tail = newTail;
	      list.__hash = undefined;
	      list.__altered = true;
	      return list;
	    }
	    return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
	  }
	
	  function mergeIntoListWith(list, merger, iterables) {
	    var iters = [];
	    var maxSize = 0;
	    for (var ii = 0; ii < iterables.length; ii++) {
	      var value = iterables[ii];
	      var iter = IndexedIterable(value);
	      if (iter.size > maxSize) {
	        maxSize = iter.size;
	      }
	      if (!isIterable(value)) {
	        iter = iter.map(function(v ) {return fromJS(v)});
	      }
	      iters.push(iter);
	    }
	    if (maxSize > list.size) {
	      list = list.setSize(maxSize);
	    }
	    return mergeIntoCollectionWith(list, merger, iters);
	  }
	
	  function getTailOffset(size) {
	    return size < SIZE ? 0 : (((size - 1) >>> SHIFT) << SHIFT);
	  }
	
	  createClass(OrderedMap, Map);
	
	    // @pragma Construction
	
	    function OrderedMap(value) {
	      return value === null || value === undefined ? emptyOrderedMap() :
	        isOrderedMap(value) ? value :
	        emptyOrderedMap().withMutations(function(map ) {
	          var iter = KeyedIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v, k)  {return map.set(k, v)});
	        });
	    }
	
	    OrderedMap.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    OrderedMap.prototype.toString = function() {
	      return this.__toString('OrderedMap {', '}');
	    };
	
	    // @pragma Access
	
	    OrderedMap.prototype.get = function(k, notSetValue) {
	      var index = this._map.get(k);
	      return index !== undefined ? this._list.get(index)[1] : notSetValue;
	    };
	
	    // @pragma Modification
	
	    OrderedMap.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._map.clear();
	        this._list.clear();
	        return this;
	      }
	      return emptyOrderedMap();
	    };
	
	    OrderedMap.prototype.set = function(k, v) {
	      return updateOrderedMap(this, k, v);
	    };
	
	    OrderedMap.prototype.remove = function(k) {
	      return updateOrderedMap(this, k, NOT_SET);
	    };
	
	    OrderedMap.prototype.wasAltered = function() {
	      return this._map.wasAltered() || this._list.wasAltered();
	    };
	
	    OrderedMap.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._list.__iterate(
	        function(entry ) {return entry && fn(entry[1], entry[0], this$0)},
	        reverse
	      );
	    };
	
	    OrderedMap.prototype.__iterator = function(type, reverse) {
	      return this._list.fromEntrySeq().__iterator(type, reverse);
	    };
	
	    OrderedMap.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map.__ensureOwner(ownerID);
	      var newList = this._list.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        this._list = newList;
	        return this;
	      }
	      return makeOrderedMap(newMap, newList, ownerID, this.__hash);
	    };
	
	
	  function isOrderedMap(maybeOrderedMap) {
	    return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
	  }
	
	  OrderedMap.isOrderedMap = isOrderedMap;
	
	  OrderedMap.prototype[IS_ORDERED_SENTINEL] = true;
	  OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;
	
	
	
	  function makeOrderedMap(map, list, ownerID, hash) {
	    var omap = Object.create(OrderedMap.prototype);
	    omap.size = map ? map.size : 0;
	    omap._map = map;
	    omap._list = list;
	    omap.__ownerID = ownerID;
	    omap.__hash = hash;
	    return omap;
	  }
	
	  var EMPTY_ORDERED_MAP;
	  function emptyOrderedMap() {
	    return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
	  }
	
	  function updateOrderedMap(omap, k, v) {
	    var map = omap._map;
	    var list = omap._list;
	    var i = map.get(k);
	    var has = i !== undefined;
	    var newMap;
	    var newList;
	    if (v === NOT_SET) { // removed
	      if (!has) {
	        return omap;
	      }
	      if (list.size >= SIZE && list.size >= map.size * 2) {
	        newList = list.filter(function(entry, idx)  {return entry !== undefined && i !== idx});
	        newMap = newList.toKeyedSeq().map(function(entry ) {return entry[0]}).flip().toMap();
	        if (omap.__ownerID) {
	          newMap.__ownerID = newList.__ownerID = omap.__ownerID;
	        }
	      } else {
	        newMap = map.remove(k);
	        newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
	      }
	    } else {
	      if (has) {
	        if (v === list.get(i)[1]) {
	          return omap;
	        }
	        newMap = map;
	        newList = list.set(i, [k, v]);
	      } else {
	        newMap = map.set(k, list.size);
	        newList = list.set(list.size, [k, v]);
	      }
	    }
	    if (omap.__ownerID) {
	      omap.size = newMap.size;
	      omap._map = newMap;
	      omap._list = newList;
	      omap.__hash = undefined;
	      return omap;
	    }
	    return makeOrderedMap(newMap, newList);
	  }
	
	  createClass(ToKeyedSequence, KeyedSeq);
	    function ToKeyedSequence(indexed, useKeys) {
	      this._iter = indexed;
	      this._useKeys = useKeys;
	      this.size = indexed.size;
	    }
	
	    ToKeyedSequence.prototype.get = function(key, notSetValue) {
	      return this._iter.get(key, notSetValue);
	    };
	
	    ToKeyedSequence.prototype.has = function(key) {
	      return this._iter.has(key);
	    };
	
	    ToKeyedSequence.prototype.valueSeq = function() {
	      return this._iter.valueSeq();
	    };
	
	    ToKeyedSequence.prototype.reverse = function() {var this$0 = this;
	      var reversedSequence = reverseFactory(this, true);
	      if (!this._useKeys) {
	        reversedSequence.valueSeq = function()  {return this$0._iter.toSeq().reverse()};
	      }
	      return reversedSequence;
	    };
	
	    ToKeyedSequence.prototype.map = function(mapper, context) {var this$0 = this;
	      var mappedSequence = mapFactory(this, mapper, context);
	      if (!this._useKeys) {
	        mappedSequence.valueSeq = function()  {return this$0._iter.toSeq().map(mapper, context)};
	      }
	      return mappedSequence;
	    };
	
	    ToKeyedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var ii;
	      return this._iter.__iterate(
	        this._useKeys ?
	          function(v, k)  {return fn(v, k, this$0)} :
	          ((ii = reverse ? resolveSize(this) : 0),
	            function(v ) {return fn(v, reverse ? --ii : ii++, this$0)}),
	        reverse
	      );
	    };
	
	    ToKeyedSequence.prototype.__iterator = function(type, reverse) {
	      if (this._useKeys) {
	        return this._iter.__iterator(type, reverse);
	      }
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      var ii = reverse ? resolveSize(this) : 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, reverse ? --ii : ii++, step.value, step);
	      });
	    };
	
	  ToKeyedSequence.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	  createClass(ToIndexedSequence, IndexedSeq);
	    function ToIndexedSequence(iter) {
	      this._iter = iter;
	      this.size = iter.size;
	    }
	
	    ToIndexedSequence.prototype.includes = function(value) {
	      return this._iter.includes(value);
	    };
	
	    ToIndexedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      return this._iter.__iterate(function(v ) {return fn(v, iterations++, this$0)}, reverse);
	    };
	
	    ToIndexedSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, iterations++, step.value, step)
	      });
	    };
	
	
	
	  createClass(ToSetSequence, SetSeq);
	    function ToSetSequence(iter) {
	      this._iter = iter;
	      this.size = iter.size;
	    }
	
	    ToSetSequence.prototype.has = function(key) {
	      return this._iter.includes(key);
	    };
	
	    ToSetSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._iter.__iterate(function(v ) {return fn(v, v, this$0)}, reverse);
	    };
	
	    ToSetSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, step.value, step.value, step);
	      });
	    };
	
	
	
	  createClass(FromEntriesSequence, KeyedSeq);
	    function FromEntriesSequence(entries) {
	      this._iter = entries;
	      this.size = entries.size;
	    }
	
	    FromEntriesSequence.prototype.entrySeq = function() {
	      return this._iter.toSeq();
	    };
	
	    FromEntriesSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._iter.__iterate(function(entry ) {
	        // Check if entry exists first so array access doesn't throw for holes
	        // in the parent iteration.
	        if (entry) {
	          validateEntry(entry);
	          var indexedIterable = isIterable(entry);
	          return fn(
	            indexedIterable ? entry.get(1) : entry[1],
	            indexedIterable ? entry.get(0) : entry[0],
	            this$0
	          );
	        }
	      }, reverse);
	    };
	
	    FromEntriesSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      return new Iterator(function()  {
	        while (true) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          var entry = step.value;
	          // Check if entry exists first so array access doesn't throw for holes
	          // in the parent iteration.
	          if (entry) {
	            validateEntry(entry);
	            var indexedIterable = isIterable(entry);
	            return iteratorValue(
	              type,
	              indexedIterable ? entry.get(0) : entry[0],
	              indexedIterable ? entry.get(1) : entry[1],
	              step
	            );
	          }
	        }
	      });
	    };
	
	
	  ToIndexedSequence.prototype.cacheResult =
	  ToKeyedSequence.prototype.cacheResult =
	  ToSetSequence.prototype.cacheResult =
	  FromEntriesSequence.prototype.cacheResult =
	    cacheResultThrough;
	
	
	  function flipFactory(iterable) {
	    var flipSequence = makeSequence(iterable);
	    flipSequence._iter = iterable;
	    flipSequence.size = iterable.size;
	    flipSequence.flip = function()  {return iterable};
	    flipSequence.reverse = function () {
	      var reversedSequence = iterable.reverse.apply(this); // super.reverse()
	      reversedSequence.flip = function()  {return iterable.reverse()};
	      return reversedSequence;
	    };
	    flipSequence.has = function(key ) {return iterable.includes(key)};
	    flipSequence.includes = function(key ) {return iterable.has(key)};
	    flipSequence.cacheResult = cacheResultThrough;
	    flipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(function(v, k)  {return fn(k, v, this$0) !== false}, reverse);
	    }
	    flipSequence.__iteratorUncached = function(type, reverse) {
	      if (type === ITERATE_ENTRIES) {
	        var iterator = iterable.__iterator(type, reverse);
	        return new Iterator(function()  {
	          var step = iterator.next();
	          if (!step.done) {
	            var k = step.value[0];
	            step.value[0] = step.value[1];
	            step.value[1] = k;
	          }
	          return step;
	        });
	      }
	      return iterable.__iterator(
	        type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES,
	        reverse
	      );
	    }
	    return flipSequence;
	  }
	
	
	  function mapFactory(iterable, mapper, context) {
	    var mappedSequence = makeSequence(iterable);
	    mappedSequence.size = iterable.size;
	    mappedSequence.has = function(key ) {return iterable.has(key)};
	    mappedSequence.get = function(key, notSetValue)  {
	      var v = iterable.get(key, NOT_SET);
	      return v === NOT_SET ?
	        notSetValue :
	        mapper.call(context, v, key, iterable);
	    };
	    mappedSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(
	        function(v, k, c)  {return fn(mapper.call(context, v, k, c), k, this$0) !== false},
	        reverse
	      );
	    }
	    mappedSequence.__iteratorUncached = function (type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      return new Iterator(function()  {
	        var step = iterator.next();
	        if (step.done) {
	          return step;
	        }
	        var entry = step.value;
	        var key = entry[0];
	        return iteratorValue(
	          type,
	          key,
	          mapper.call(context, entry[1], key, iterable),
	          step
	        );
	      });
	    }
	    return mappedSequence;
	  }
	
	
	  function reverseFactory(iterable, useKeys) {
	    var reversedSequence = makeSequence(iterable);
	    reversedSequence._iter = iterable;
	    reversedSequence.size = iterable.size;
	    reversedSequence.reverse = function()  {return iterable};
	    if (iterable.flip) {
	      reversedSequence.flip = function () {
	        var flipSequence = flipFactory(iterable);
	        flipSequence.reverse = function()  {return iterable.flip()};
	        return flipSequence;
	      };
	    }
	    reversedSequence.get = function(key, notSetValue) 
	      {return iterable.get(useKeys ? key : -1 - key, notSetValue)};
	    reversedSequence.has = function(key )
	      {return iterable.has(useKeys ? key : -1 - key)};
	    reversedSequence.includes = function(value ) {return iterable.includes(value)};
	    reversedSequence.cacheResult = cacheResultThrough;
	    reversedSequence.__iterate = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(function(v, k)  {return fn(v, k, this$0)}, !reverse);
	    };
	    reversedSequence.__iterator =
	      function(type, reverse)  {return iterable.__iterator(type, !reverse)};
	    return reversedSequence;
	  }
	
	
	  function filterFactory(iterable, predicate, context, useKeys) {
	    var filterSequence = makeSequence(iterable);
	    if (useKeys) {
	      filterSequence.has = function(key ) {
	        var v = iterable.get(key, NOT_SET);
	        return v !== NOT_SET && !!predicate.call(context, v, key, iterable);
	      };
	      filterSequence.get = function(key, notSetValue)  {
	        var v = iterable.get(key, NOT_SET);
	        return v !== NOT_SET && predicate.call(context, v, key, iterable) ?
	          v : notSetValue;
	      };
	    }
	    filterSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c)  {
	        if (predicate.call(context, v, k, c)) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0);
	        }
	      }, reverse);
	      return iterations;
	    };
	    filterSequence.__iteratorUncached = function (type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (true) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          var entry = step.value;
	          var key = entry[0];
	          var value = entry[1];
	          if (predicate.call(context, value, key, iterable)) {
	            return iteratorValue(type, useKeys ? key : iterations++, value, step);
	          }
	        }
	      });
	    }
	    return filterSequence;
	  }
	
	
	  function countByFactory(iterable, grouper, context) {
	    var groups = Map().asMutable();
	    iterable.__iterate(function(v, k)  {
	      groups.update(
	        grouper.call(context, v, k, iterable),
	        0,
	        function(a ) {return a + 1}
	      );
	    });
	    return groups.asImmutable();
	  }
	
	
	  function groupByFactory(iterable, grouper, context) {
	    var isKeyedIter = isKeyed(iterable);
	    var groups = (isOrdered(iterable) ? OrderedMap() : Map()).asMutable();
	    iterable.__iterate(function(v, k)  {
	      groups.update(
	        grouper.call(context, v, k, iterable),
	        function(a ) {return (a = a || [], a.push(isKeyedIter ? [k, v] : v), a)}
	      );
	    });
	    var coerce = iterableClass(iterable);
	    return groups.map(function(arr ) {return reify(iterable, coerce(arr))});
	  }
	
	
	  function sliceFactory(iterable, begin, end, useKeys) {
	    var originalSize = iterable.size;
	
	    // Sanitize begin & end using this shorthand for ToInt32(argument)
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
	    if (begin !== undefined) {
	      begin = begin | 0;
	    }
	    if (end !== undefined) {
	      end = end | 0;
	    }
	
	    if (wholeSlice(begin, end, originalSize)) {
	      return iterable;
	    }
	
	    var resolvedBegin = resolveBegin(begin, originalSize);
	    var resolvedEnd = resolveEnd(end, originalSize);
	
	    // begin or end will be NaN if they were provided as negative numbers and
	    // this iterable's size is unknown. In that case, cache first so there is
	    // a known size and these do not resolve to NaN.
	    if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) {
	      return sliceFactory(iterable.toSeq().cacheResult(), begin, end, useKeys);
	    }
	
	    // Note: resolvedEnd is undefined when the original sequence's length is
	    // unknown and this slice did not supply an end and should contain all
	    // elements after resolvedBegin.
	    // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
	    var resolvedSize = resolvedEnd - resolvedBegin;
	    var sliceSize;
	    if (resolvedSize === resolvedSize) {
	      sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
	    }
	
	    var sliceSeq = makeSequence(iterable);
	
	    // If iterable.size is undefined, the size of the realized sliceSeq is
	    // unknown at this point unless the number of items to slice is 0
	    sliceSeq.size = sliceSize === 0 ? sliceSize : iterable.size && sliceSize || undefined;
	
	    if (!useKeys && isSeq(iterable) && sliceSize >= 0) {
	      sliceSeq.get = function (index, notSetValue) {
	        index = wrapIndex(this, index);
	        return index >= 0 && index < sliceSize ?
	          iterable.get(index + resolvedBegin, notSetValue) :
	          notSetValue;
	      }
	    }
	
	    sliceSeq.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      if (sliceSize === 0) {
	        return 0;
	      }
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var skipped = 0;
	      var isSkipping = true;
	      var iterations = 0;
	      iterable.__iterate(function(v, k)  {
	        if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0) !== false &&
	                 iterations !== sliceSize;
	        }
	      });
	      return iterations;
	    };
	
	    sliceSeq.__iteratorUncached = function(type, reverse) {
	      if (sliceSize !== 0 && reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      // Don't bother instantiating parent iterator if taking 0.
	      var iterator = sliceSize !== 0 && iterable.__iterator(type, reverse);
	      var skipped = 0;
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (skipped++ < resolvedBegin) {
	          iterator.next();
	        }
	        if (++iterations > sliceSize) {
	          return iteratorDone();
	        }
	        var step = iterator.next();
	        if (useKeys || type === ITERATE_VALUES) {
	          return step;
	        } else if (type === ITERATE_KEYS) {
	          return iteratorValue(type, iterations - 1, undefined, step);
	        } else {
	          return iteratorValue(type, iterations - 1, step.value[1], step);
	        }
	      });
	    }
	
	    return sliceSeq;
	  }
	
	
	  function takeWhileFactory(iterable, predicate, context) {
	    var takeSequence = makeSequence(iterable);
	    takeSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c) 
	        {return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$0)}
	      );
	      return iterations;
	    };
	    takeSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var iterating = true;
	      return new Iterator(function()  {
	        if (!iterating) {
	          return iteratorDone();
	        }
	        var step = iterator.next();
	        if (step.done) {
	          return step;
	        }
	        var entry = step.value;
	        var k = entry[0];
	        var v = entry[1];
	        if (!predicate.call(context, v, k, this$0)) {
	          iterating = false;
	          return iteratorDone();
	        }
	        return type === ITERATE_ENTRIES ? step :
	          iteratorValue(type, k, v, step);
	      });
	    };
	    return takeSequence;
	  }
	
	
	  function skipWhileFactory(iterable, predicate, context, useKeys) {
	    var skipSequence = makeSequence(iterable);
	    skipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var isSkipping = true;
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c)  {
	        if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0);
	        }
	      });
	      return iterations;
	    };
	    skipSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var skipping = true;
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step, k, v;
	        do {
	          step = iterator.next();
	          if (step.done) {
	            if (useKeys || type === ITERATE_VALUES) {
	              return step;
	            } else if (type === ITERATE_KEYS) {
	              return iteratorValue(type, iterations++, undefined, step);
	            } else {
	              return iteratorValue(type, iterations++, step.value[1], step);
	            }
	          }
	          var entry = step.value;
	          k = entry[0];
	          v = entry[1];
	          skipping && (skipping = predicate.call(context, v, k, this$0));
	        } while (skipping);
	        return type === ITERATE_ENTRIES ? step :
	          iteratorValue(type, k, v, step);
	      });
	    };
	    return skipSequence;
	  }
	
	
	  function concatFactory(iterable, values) {
	    var isKeyedIterable = isKeyed(iterable);
	    var iters = [iterable].concat(values).map(function(v ) {
	      if (!isIterable(v)) {
	        v = isKeyedIterable ?
	          keyedSeqFromValue(v) :
	          indexedSeqFromValue(Array.isArray(v) ? v : [v]);
	      } else if (isKeyedIterable) {
	        v = KeyedIterable(v);
	      }
	      return v;
	    }).filter(function(v ) {return v.size !== 0});
	
	    if (iters.length === 0) {
	      return iterable;
	    }
	
	    if (iters.length === 1) {
	      var singleton = iters[0];
	      if (singleton === iterable ||
	          isKeyedIterable && isKeyed(singleton) ||
	          isIndexed(iterable) && isIndexed(singleton)) {
	        return singleton;
	      }
	    }
	
	    var concatSeq = new ArraySeq(iters);
	    if (isKeyedIterable) {
	      concatSeq = concatSeq.toKeyedSeq();
	    } else if (!isIndexed(iterable)) {
	      concatSeq = concatSeq.toSetSeq();
	    }
	    concatSeq = concatSeq.flatten(true);
	    concatSeq.size = iters.reduce(
	      function(sum, seq)  {
	        if (sum !== undefined) {
	          var size = seq.size;
	          if (size !== undefined) {
	            return sum + size;
	          }
	        }
	      },
	      0
	    );
	    return concatSeq;
	  }
	
	
	  function flattenFactory(iterable, depth, useKeys) {
	    var flatSequence = makeSequence(iterable);
	    flatSequence.__iterateUncached = function(fn, reverse) {
	      var iterations = 0;
	      var stopped = false;
	      function flatDeep(iter, currentDepth) {var this$0 = this;
	        iter.__iterate(function(v, k)  {
	          if ((!depth || currentDepth < depth) && isIterable(v)) {
	            flatDeep(v, currentDepth + 1);
	          } else if (fn(v, useKeys ? k : iterations++, this$0) === false) {
	            stopped = true;
	          }
	          return !stopped;
	        }, reverse);
	      }
	      flatDeep(iterable, 0);
	      return iterations;
	    }
	    flatSequence.__iteratorUncached = function(type, reverse) {
	      var iterator = iterable.__iterator(type, reverse);
	      var stack = [];
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (iterator) {
	          var step = iterator.next();
	          if (step.done !== false) {
	            iterator = stack.pop();
	            continue;
	          }
	          var v = step.value;
	          if (type === ITERATE_ENTRIES) {
	            v = v[1];
	          }
	          if ((!depth || stack.length < depth) && isIterable(v)) {
	            stack.push(iterator);
	            iterator = v.__iterator(type, reverse);
	          } else {
	            return useKeys ? step : iteratorValue(type, iterations++, v, step);
	          }
	        }
	        return iteratorDone();
	      });
	    }
	    return flatSequence;
	  }
	
	
	  function flatMapFactory(iterable, mapper, context) {
	    var coerce = iterableClass(iterable);
	    return iterable.toSeq().map(
	      function(v, k)  {return coerce(mapper.call(context, v, k, iterable))}
	    ).flatten(true);
	  }
	
	
	  function interposeFactory(iterable, separator) {
	    var interposedSequence = makeSequence(iterable);
	    interposedSequence.size = iterable.size && iterable.size * 2 -1;
	    interposedSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      iterable.__iterate(function(v, k) 
	        {return (!iterations || fn(separator, iterations++, this$0) !== false) &&
	        fn(v, iterations++, this$0) !== false},
	        reverse
	      );
	      return iterations;
	    };
	    interposedSequence.__iteratorUncached = function(type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_VALUES, reverse);
	      var iterations = 0;
	      var step;
	      return new Iterator(function()  {
	        if (!step || iterations % 2) {
	          step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	        }
	        return iterations % 2 ?
	          iteratorValue(type, iterations++, separator) :
	          iteratorValue(type, iterations++, step.value, step);
	      });
	    };
	    return interposedSequence;
	  }
	
	
	  function sortFactory(iterable, comparator, mapper) {
	    if (!comparator) {
	      comparator = defaultComparator;
	    }
	    var isKeyedIterable = isKeyed(iterable);
	    var index = 0;
	    var entries = iterable.toSeq().map(
	      function(v, k)  {return [k, v, index++, mapper ? mapper(v, k, iterable) : v]}
	    ).toArray();
	    entries.sort(function(a, b)  {return comparator(a[3], b[3]) || a[2] - b[2]}).forEach(
	      isKeyedIterable ?
	      function(v, i)  { entries[i].length = 2; } :
	      function(v, i)  { entries[i] = v[1]; }
	    );
	    return isKeyedIterable ? KeyedSeq(entries) :
	      isIndexed(iterable) ? IndexedSeq(entries) :
	      SetSeq(entries);
	  }
	
	
	  function maxFactory(iterable, comparator, mapper) {
	    if (!comparator) {
	      comparator = defaultComparator;
	    }
	    if (mapper) {
	      var entry = iterable.toSeq()
	        .map(function(v, k)  {return [v, mapper(v, k, iterable)]})
	        .reduce(function(a, b)  {return maxCompare(comparator, a[1], b[1]) ? b : a});
	      return entry && entry[0];
	    } else {
	      return iterable.reduce(function(a, b)  {return maxCompare(comparator, a, b) ? b : a});
	    }
	  }
	
	  function maxCompare(comparator, a, b) {
	    var comp = comparator(b, a);
	    // b is considered the new max if the comparator declares them equal, but
	    // they are not equal and b is in fact a nullish value.
	    return (comp === 0 && b !== a && (b === undefined || b === null || b !== b)) || comp > 0;
	  }
	
	
	  function zipWithFactory(keyIter, zipper, iters) {
	    var zipSequence = makeSequence(keyIter);
	    zipSequence.size = new ArraySeq(iters).map(function(i ) {return i.size}).min();
	    // Note: this a generic base implementation of __iterate in terms of
	    // __iterator which may be more generically useful in the future.
	    zipSequence.__iterate = function(fn, reverse) {
	      /* generic:
	      var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
	      var step;
	      var iterations = 0;
	      while (!(step = iterator.next()).done) {
	        iterations++;
	        if (fn(step.value[1], step.value[0], this) === false) {
	          break;
	        }
	      }
	      return iterations;
	      */
	      // indexed:
	      var iterator = this.__iterator(ITERATE_VALUES, reverse);
	      var step;
	      var iterations = 0;
	      while (!(step = iterator.next()).done) {
	        if (fn(step.value, iterations++, this) === false) {
	          break;
	        }
	      }
	      return iterations;
	    };
	    zipSequence.__iteratorUncached = function(type, reverse) {
	      var iterators = iters.map(function(i )
	        {return (i = Iterable(i), getIterator(reverse ? i.reverse() : i))}
	      );
	      var iterations = 0;
	      var isDone = false;
	      return new Iterator(function()  {
	        var steps;
	        if (!isDone) {
	          steps = iterators.map(function(i ) {return i.next()});
	          isDone = steps.some(function(s ) {return s.done});
	        }
	        if (isDone) {
	          return iteratorDone();
	        }
	        return iteratorValue(
	          type,
	          iterations++,
	          zipper.apply(null, steps.map(function(s ) {return s.value}))
	        );
	      });
	    };
	    return zipSequence
	  }
	
	
	  // #pragma Helper Functions
	
	  function reify(iter, seq) {
	    return isSeq(iter) ? seq : iter.constructor(seq);
	  }
	
	  function validateEntry(entry) {
	    if (entry !== Object(entry)) {
	      throw new TypeError('Expected [K, V] tuple: ' + entry);
	    }
	  }
	
	  function resolveSize(iter) {
	    assertNotInfinite(iter.size);
	    return ensureSize(iter);
	  }
	
	  function iterableClass(iterable) {
	    return isKeyed(iterable) ? KeyedIterable :
	      isIndexed(iterable) ? IndexedIterable :
	      SetIterable;
	  }
	
	  function makeSequence(iterable) {
	    return Object.create(
	      (
	        isKeyed(iterable) ? KeyedSeq :
	        isIndexed(iterable) ? IndexedSeq :
	        SetSeq
	      ).prototype
	    );
	  }
	
	  function cacheResultThrough() {
	    if (this._iter.cacheResult) {
	      this._iter.cacheResult();
	      this.size = this._iter.size;
	      return this;
	    } else {
	      return Seq.prototype.cacheResult.call(this);
	    }
	  }
	
	  function defaultComparator(a, b) {
	    return a > b ? 1 : a < b ? -1 : 0;
	  }
	
	  function forceIterator(keyPath) {
	    var iter = getIterator(keyPath);
	    if (!iter) {
	      // Array might not be iterable in this environment, so we need a fallback
	      // to our wrapped type.
	      if (!isArrayLike(keyPath)) {
	        throw new TypeError('Expected iterable or array-like: ' + keyPath);
	      }
	      iter = getIterator(Iterable(keyPath));
	    }
	    return iter;
	  }
	
	  createClass(Record, KeyedCollection);
	
	    function Record(defaultValues, name) {
	      var hasInitialized;
	
	      var RecordType = function Record(values) {
	        if (values instanceof RecordType) {
	          return values;
	        }
	        if (!(this instanceof RecordType)) {
	          return new RecordType(values);
	        }
	        if (!hasInitialized) {
	          hasInitialized = true;
	          var keys = Object.keys(defaultValues);
	          setProps(RecordTypePrototype, keys);
	          RecordTypePrototype.size = keys.length;
	          RecordTypePrototype._name = name;
	          RecordTypePrototype._keys = keys;
	          RecordTypePrototype._defaultValues = defaultValues;
	        }
	        this._map = Map(values);
	      };
	
	      var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
	      RecordTypePrototype.constructor = RecordType;
	
	      return RecordType;
	    }
	
	    Record.prototype.toString = function() {
	      return this.__toString(recordName(this) + ' {', '}');
	    };
	
	    // @pragma Access
	
	    Record.prototype.has = function(k) {
	      return this._defaultValues.hasOwnProperty(k);
	    };
	
	    Record.prototype.get = function(k, notSetValue) {
	      if (!this.has(k)) {
	        return notSetValue;
	      }
	      var defaultVal = this._defaultValues[k];
	      return this._map ? this._map.get(k, defaultVal) : defaultVal;
	    };
	
	    // @pragma Modification
	
	    Record.prototype.clear = function() {
	      if (this.__ownerID) {
	        this._map && this._map.clear();
	        return this;
	      }
	      var RecordType = this.constructor;
	      return RecordType._empty || (RecordType._empty = makeRecord(this, emptyMap()));
	    };
	
	    Record.prototype.set = function(k, v) {
	      if (!this.has(k)) {
	        throw new Error('Cannot set unknown key "' + k + '" on ' + recordName(this));
	      }
	      var newMap = this._map && this._map.set(k, v);
	      if (this.__ownerID || newMap === this._map) {
	        return this;
	      }
	      return makeRecord(this, newMap);
	    };
	
	    Record.prototype.remove = function(k) {
	      if (!this.has(k)) {
	        return this;
	      }
	      var newMap = this._map && this._map.remove(k);
	      if (this.__ownerID || newMap === this._map) {
	        return this;
	      }
	      return makeRecord(this, newMap);
	    };
	
	    Record.prototype.wasAltered = function() {
	      return this._map.wasAltered();
	    };
	
	    Record.prototype.__iterator = function(type, reverse) {var this$0 = this;
	      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterator(type, reverse);
	    };
	
	    Record.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterate(fn, reverse);
	    };
	
	    Record.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map && this._map.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        return this;
	      }
	      return makeRecord(this, newMap, ownerID);
	    };
	
	
	  var RecordPrototype = Record.prototype;
	  RecordPrototype[DELETE] = RecordPrototype.remove;
	  RecordPrototype.deleteIn =
	  RecordPrototype.removeIn = MapPrototype.removeIn;
	  RecordPrototype.merge = MapPrototype.merge;
	  RecordPrototype.mergeWith = MapPrototype.mergeWith;
	  RecordPrototype.mergeIn = MapPrototype.mergeIn;
	  RecordPrototype.mergeDeep = MapPrototype.mergeDeep;
	  RecordPrototype.mergeDeepWith = MapPrototype.mergeDeepWith;
	  RecordPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
	  RecordPrototype.setIn = MapPrototype.setIn;
	  RecordPrototype.update = MapPrototype.update;
	  RecordPrototype.updateIn = MapPrototype.updateIn;
	  RecordPrototype.withMutations = MapPrototype.withMutations;
	  RecordPrototype.asMutable = MapPrototype.asMutable;
	  RecordPrototype.asImmutable = MapPrototype.asImmutable;
	
	
	  function makeRecord(likeRecord, map, ownerID) {
	    var record = Object.create(Object.getPrototypeOf(likeRecord));
	    record._map = map;
	    record.__ownerID = ownerID;
	    return record;
	  }
	
	  function recordName(record) {
	    return record._name || record.constructor.name || 'Record';
	  }
	
	  function setProps(prototype, names) {
	    try {
	      names.forEach(setProp.bind(undefined, prototype));
	    } catch (error) {
	      // Object.defineProperty failed. Probably IE8.
	    }
	  }
	
	  function setProp(prototype, name) {
	    Object.defineProperty(prototype, name, {
	      get: function() {
	        return this.get(name);
	      },
	      set: function(value) {
	        invariant(this.__ownerID, 'Cannot set on an immutable record.');
	        this.set(name, value);
	      }
	    });
	  }
	
	  createClass(Set, SetCollection);
	
	    // @pragma Construction
	
	    function Set(value) {
	      return value === null || value === undefined ? emptySet() :
	        isSet(value) && !isOrdered(value) ? value :
	        emptySet().withMutations(function(set ) {
	          var iter = SetIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v ) {return set.add(v)});
	        });
	    }
	
	    Set.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    Set.fromKeys = function(value) {
	      return this(KeyedIterable(value).keySeq());
	    };
	
	    Set.prototype.toString = function() {
	      return this.__toString('Set {', '}');
	    };
	
	    // @pragma Access
	
	    Set.prototype.has = function(value) {
	      return this._map.has(value);
	    };
	
	    // @pragma Modification
	
	    Set.prototype.add = function(value) {
	      return updateSet(this, this._map.set(value, true));
	    };
	
	    Set.prototype.remove = function(value) {
	      return updateSet(this, this._map.remove(value));
	    };
	
	    Set.prototype.clear = function() {
	      return updateSet(this, this._map.clear());
	    };
	
	    // @pragma Composition
	
	    Set.prototype.union = function() {var iters = SLICE$0.call(arguments, 0);
	      iters = iters.filter(function(x ) {return x.size !== 0});
	      if (iters.length === 0) {
	        return this;
	      }
	      if (this.size === 0 && !this.__ownerID && iters.length === 1) {
	        return this.constructor(iters[0]);
	      }
	      return this.withMutations(function(set ) {
	        for (var ii = 0; ii < iters.length; ii++) {
	          SetIterable(iters[ii]).forEach(function(value ) {return set.add(value)});
	        }
	      });
	    };
	
	    Set.prototype.intersect = function() {var iters = SLICE$0.call(arguments, 0);
	      if (iters.length === 0) {
	        return this;
	      }
	      iters = iters.map(function(iter ) {return SetIterable(iter)});
	      var originalSet = this;
	      return this.withMutations(function(set ) {
	        originalSet.forEach(function(value ) {
	          if (!iters.every(function(iter ) {return iter.includes(value)})) {
	            set.remove(value);
	          }
	        });
	      });
	    };
	
	    Set.prototype.subtract = function() {var iters = SLICE$0.call(arguments, 0);
	      if (iters.length === 0) {
	        return this;
	      }
	      iters = iters.map(function(iter ) {return SetIterable(iter)});
	      var originalSet = this;
	      return this.withMutations(function(set ) {
	        originalSet.forEach(function(value ) {
	          if (iters.some(function(iter ) {return iter.includes(value)})) {
	            set.remove(value);
	          }
	        });
	      });
	    };
	
	    Set.prototype.merge = function() {
	      return this.union.apply(this, arguments);
	    };
	
	    Set.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return this.union.apply(this, iters);
	    };
	
	    Set.prototype.sort = function(comparator) {
	      // Late binding
	      return OrderedSet(sortFactory(this, comparator));
	    };
	
	    Set.prototype.sortBy = function(mapper, comparator) {
	      // Late binding
	      return OrderedSet(sortFactory(this, comparator, mapper));
	    };
	
	    Set.prototype.wasAltered = function() {
	      return this._map.wasAltered();
	    };
	
	    Set.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._map.__iterate(function(_, k)  {return fn(k, k, this$0)}, reverse);
	    };
	
	    Set.prototype.__iterator = function(type, reverse) {
	      return this._map.map(function(_, k)  {return k}).__iterator(type, reverse);
	    };
	
	    Set.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        return this;
	      }
	      return this.__make(newMap, ownerID);
	    };
	
	
	  function isSet(maybeSet) {
	    return !!(maybeSet && maybeSet[IS_SET_SENTINEL]);
	  }
	
	  Set.isSet = isSet;
	
	  var IS_SET_SENTINEL = '@@__IMMUTABLE_SET__@@';
	
	  var SetPrototype = Set.prototype;
	  SetPrototype[IS_SET_SENTINEL] = true;
	  SetPrototype[DELETE] = SetPrototype.remove;
	  SetPrototype.mergeDeep = SetPrototype.merge;
	  SetPrototype.mergeDeepWith = SetPrototype.mergeWith;
	  SetPrototype.withMutations = MapPrototype.withMutations;
	  SetPrototype.asMutable = MapPrototype.asMutable;
	  SetPrototype.asImmutable = MapPrototype.asImmutable;
	
	  SetPrototype.__empty = emptySet;
	  SetPrototype.__make = makeSet;
	
	  function updateSet(set, newMap) {
	    if (set.__ownerID) {
	      set.size = newMap.size;
	      set._map = newMap;
	      return set;
	    }
	    return newMap === set._map ? set :
	      newMap.size === 0 ? set.__empty() :
	      set.__make(newMap);
	  }
	
	  function makeSet(map, ownerID) {
	    var set = Object.create(SetPrototype);
	    set.size = map ? map.size : 0;
	    set._map = map;
	    set.__ownerID = ownerID;
	    return set;
	  }
	
	  var EMPTY_SET;
	  function emptySet() {
	    return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
	  }
	
	  createClass(OrderedSet, Set);
	
	    // @pragma Construction
	
	    function OrderedSet(value) {
	      return value === null || value === undefined ? emptyOrderedSet() :
	        isOrderedSet(value) ? value :
	        emptyOrderedSet().withMutations(function(set ) {
	          var iter = SetIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v ) {return set.add(v)});
	        });
	    }
	
	    OrderedSet.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    OrderedSet.fromKeys = function(value) {
	      return this(KeyedIterable(value).keySeq());
	    };
	
	    OrderedSet.prototype.toString = function() {
	      return this.__toString('OrderedSet {', '}');
	    };
	
	
	  function isOrderedSet(maybeOrderedSet) {
	    return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
	  }
	
	  OrderedSet.isOrderedSet = isOrderedSet;
	
	  var OrderedSetPrototype = OrderedSet.prototype;
	  OrderedSetPrototype[IS_ORDERED_SENTINEL] = true;
	
	  OrderedSetPrototype.__empty = emptyOrderedSet;
	  OrderedSetPrototype.__make = makeOrderedSet;
	
	  function makeOrderedSet(map, ownerID) {
	    var set = Object.create(OrderedSetPrototype);
	    set.size = map ? map.size : 0;
	    set._map = map;
	    set.__ownerID = ownerID;
	    return set;
	  }
	
	  var EMPTY_ORDERED_SET;
	  function emptyOrderedSet() {
	    return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
	  }
	
	  createClass(Stack, IndexedCollection);
	
	    // @pragma Construction
	
	    function Stack(value) {
	      return value === null || value === undefined ? emptyStack() :
	        isStack(value) ? value :
	        emptyStack().unshiftAll(value);
	    }
	
	    Stack.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    Stack.prototype.toString = function() {
	      return this.__toString('Stack [', ']');
	    };
	
	    // @pragma Access
	
	    Stack.prototype.get = function(index, notSetValue) {
	      var head = this._head;
	      index = wrapIndex(this, index);
	      while (head && index--) {
	        head = head.next;
	      }
	      return head ? head.value : notSetValue;
	    };
	
	    Stack.prototype.peek = function() {
	      return this._head && this._head.value;
	    };
	
	    // @pragma Modification
	
	    Stack.prototype.push = function(/*...values*/) {
	      if (arguments.length === 0) {
	        return this;
	      }
	      var newSize = this.size + arguments.length;
	      var head = this._head;
	      for (var ii = arguments.length - 1; ii >= 0; ii--) {
	        head = {
	          value: arguments[ii],
	          next: head
	        };
	      }
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    Stack.prototype.pushAll = function(iter) {
	      iter = IndexedIterable(iter);
	      if (iter.size === 0) {
	        return this;
	      }
	      assertNotInfinite(iter.size);
	      var newSize = this.size;
	      var head = this._head;
	      iter.reverse().forEach(function(value ) {
	        newSize++;
	        head = {
	          value: value,
	          next: head
	        };
	      });
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    Stack.prototype.pop = function() {
	      return this.slice(1);
	    };
	
	    Stack.prototype.unshift = function(/*...values*/) {
	      return this.push.apply(this, arguments);
	    };
	
	    Stack.prototype.unshiftAll = function(iter) {
	      return this.pushAll(iter);
	    };
	
	    Stack.prototype.shift = function() {
	      return this.pop.apply(this, arguments);
	    };
	
	    Stack.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._head = undefined;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyStack();
	    };
	
	    Stack.prototype.slice = function(begin, end) {
	      if (wholeSlice(begin, end, this.size)) {
	        return this;
	      }
	      var resolvedBegin = resolveBegin(begin, this.size);
	      var resolvedEnd = resolveEnd(end, this.size);
	      if (resolvedEnd !== this.size) {
	        // super.slice(begin, end);
	        return IndexedCollection.prototype.slice.call(this, begin, end);
	      }
	      var newSize = this.size - resolvedBegin;
	      var head = this._head;
	      while (resolvedBegin--) {
	        head = head.next;
	      }
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    // @pragma Mutability
	
	    Stack.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this.__altered = false;
	        return this;
	      }
	      return makeStack(this.size, this._head, ownerID, this.__hash);
	    };
	
	    // @pragma Iteration
	
	    Stack.prototype.__iterate = function(fn, reverse) {
	      if (reverse) {
	        return this.reverse().__iterate(fn);
	      }
	      var iterations = 0;
	      var node = this._head;
	      while (node) {
	        if (fn(node.value, iterations++, this) === false) {
	          break;
	        }
	        node = node.next;
	      }
	      return iterations;
	    };
	
	    Stack.prototype.__iterator = function(type, reverse) {
	      if (reverse) {
	        return this.reverse().__iterator(type);
	      }
	      var iterations = 0;
	      var node = this._head;
	      return new Iterator(function()  {
	        if (node) {
	          var value = node.value;
	          node = node.next;
	          return iteratorValue(type, iterations++, value);
	        }
	        return iteratorDone();
	      });
	    };
	
	
	  function isStack(maybeStack) {
	    return !!(maybeStack && maybeStack[IS_STACK_SENTINEL]);
	  }
	
	  Stack.isStack = isStack;
	
	  var IS_STACK_SENTINEL = '@@__IMMUTABLE_STACK__@@';
	
	  var StackPrototype = Stack.prototype;
	  StackPrototype[IS_STACK_SENTINEL] = true;
	  StackPrototype.withMutations = MapPrototype.withMutations;
	  StackPrototype.asMutable = MapPrototype.asMutable;
	  StackPrototype.asImmutable = MapPrototype.asImmutable;
	  StackPrototype.wasAltered = MapPrototype.wasAltered;
	
	
	  function makeStack(size, head, ownerID, hash) {
	    var map = Object.create(StackPrototype);
	    map.size = size;
	    map._head = head;
	    map.__ownerID = ownerID;
	    map.__hash = hash;
	    map.__altered = false;
	    return map;
	  }
	
	  var EMPTY_STACK;
	  function emptyStack() {
	    return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
	  }
	
	  /**
	   * Contributes additional methods to a constructor
	   */
	  function mixin(ctor, methods) {
	    var keyCopier = function(key ) { ctor.prototype[key] = methods[key]; };
	    Object.keys(methods).forEach(keyCopier);
	    Object.getOwnPropertySymbols &&
	      Object.getOwnPropertySymbols(methods).forEach(keyCopier);
	    return ctor;
	  }
	
	  Iterable.Iterator = Iterator;
	
	  mixin(Iterable, {
	
	    // ### Conversion to other types
	
	    toArray: function() {
	      assertNotInfinite(this.size);
	      var array = new Array(this.size || 0);
	      this.valueSeq().__iterate(function(v, i)  { array[i] = v; });
	      return array;
	    },
	
	    toIndexedSeq: function() {
	      return new ToIndexedSequence(this);
	    },
	
	    toJS: function() {
	      return this.toSeq().map(
	        function(value ) {return value && typeof value.toJS === 'function' ? value.toJS() : value}
	      ).__toJS();
	    },
	
	    toJSON: function() {
	      return this.toSeq().map(
	        function(value ) {return value && typeof value.toJSON === 'function' ? value.toJSON() : value}
	      ).__toJS();
	    },
	
	    toKeyedSeq: function() {
	      return new ToKeyedSequence(this, true);
	    },
	
	    toMap: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Map(this.toKeyedSeq());
	    },
	
	    toObject: function() {
	      assertNotInfinite(this.size);
	      var object = {};
	      this.__iterate(function(v, k)  { object[k] = v; });
	      return object;
	    },
	
	    toOrderedMap: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return OrderedMap(this.toKeyedSeq());
	    },
	
	    toOrderedSet: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toSet: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Set(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toSetSeq: function() {
	      return new ToSetSequence(this);
	    },
	
	    toSeq: function() {
	      return isIndexed(this) ? this.toIndexedSeq() :
	        isKeyed(this) ? this.toKeyedSeq() :
	        this.toSetSeq();
	    },
	
	    toStack: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Stack(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toList: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return List(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	
	    // ### Common JavaScript methods and properties
	
	    toString: function() {
	      return '[Iterable]';
	    },
	
	    __toString: function(head, tail) {
	      if (this.size === 0) {
	        return head + tail;
	      }
	      return head + ' ' + this.toSeq().map(this.__toStringMapper).join(', ') + ' ' + tail;
	    },
	
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    concat: function() {var values = SLICE$0.call(arguments, 0);
	      return reify(this, concatFactory(this, values));
	    },
	
	    includes: function(searchValue) {
	      return this.some(function(value ) {return is(value, searchValue)});
	    },
	
	    entries: function() {
	      return this.__iterator(ITERATE_ENTRIES);
	    },
	
	    every: function(predicate, context) {
	      assertNotInfinite(this.size);
	      var returnValue = true;
	      this.__iterate(function(v, k, c)  {
	        if (!predicate.call(context, v, k, c)) {
	          returnValue = false;
	          return false;
	        }
	      });
	      return returnValue;
	    },
	
	    filter: function(predicate, context) {
	      return reify(this, filterFactory(this, predicate, context, true));
	    },
	
	    find: function(predicate, context, notSetValue) {
	      var entry = this.findEntry(predicate, context);
	      return entry ? entry[1] : notSetValue;
	    },
	
	    findEntry: function(predicate, context) {
	      var found;
	      this.__iterate(function(v, k, c)  {
	        if (predicate.call(context, v, k, c)) {
	          found = [k, v];
	          return false;
	        }
	      });
	      return found;
	    },
	
	    findLastEntry: function(predicate, context) {
	      return this.toSeq().reverse().findEntry(predicate, context);
	    },
	
	    forEach: function(sideEffect, context) {
	      assertNotInfinite(this.size);
	      return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
	    },
	
	    join: function(separator) {
	      assertNotInfinite(this.size);
	      separator = separator !== undefined ? '' + separator : ',';
	      var joined = '';
	      var isFirst = true;
	      this.__iterate(function(v ) {
	        isFirst ? (isFirst = false) : (joined += separator);
	        joined += v !== null && v !== undefined ? v.toString() : '';
	      });
	      return joined;
	    },
	
	    keys: function() {
	      return this.__iterator(ITERATE_KEYS);
	    },
	
	    map: function(mapper, context) {
	      return reify(this, mapFactory(this, mapper, context));
	    },
	
	    reduce: function(reducer, initialReduction, context) {
	      assertNotInfinite(this.size);
	      var reduction;
	      var useFirst;
	      if (arguments.length < 2) {
	        useFirst = true;
	      } else {
	        reduction = initialReduction;
	      }
	      this.__iterate(function(v, k, c)  {
	        if (useFirst) {
	          useFirst = false;
	          reduction = v;
	        } else {
	          reduction = reducer.call(context, reduction, v, k, c);
	        }
	      });
	      return reduction;
	    },
	
	    reduceRight: function(reducer, initialReduction, context) {
	      var reversed = this.toKeyedSeq().reverse();
	      return reversed.reduce.apply(reversed, arguments);
	    },
	
	    reverse: function() {
	      return reify(this, reverseFactory(this, true));
	    },
	
	    slice: function(begin, end) {
	      return reify(this, sliceFactory(this, begin, end, true));
	    },
	
	    some: function(predicate, context) {
	      return !this.every(not(predicate), context);
	    },
	
	    sort: function(comparator) {
	      return reify(this, sortFactory(this, comparator));
	    },
	
	    values: function() {
	      return this.__iterator(ITERATE_VALUES);
	    },
	
	
	    // ### More sequential methods
	
	    butLast: function() {
	      return this.slice(0, -1);
	    },
	
	    isEmpty: function() {
	      return this.size !== undefined ? this.size === 0 : !this.some(function()  {return true});
	    },
	
	    count: function(predicate, context) {
	      return ensureSize(
	        predicate ? this.toSeq().filter(predicate, context) : this
	      );
	    },
	
	    countBy: function(grouper, context) {
	      return countByFactory(this, grouper, context);
	    },
	
	    equals: function(other) {
	      return deepEqual(this, other);
	    },
	
	    entrySeq: function() {
	      var iterable = this;
	      if (iterable._cache) {
	        // We cache as an entries array, so we can just return the cache!
	        return new ArraySeq(iterable._cache);
	      }
	      var entriesSequence = iterable.toSeq().map(entryMapper).toIndexedSeq();
	      entriesSequence.fromEntrySeq = function()  {return iterable.toSeq()};
	      return entriesSequence;
	    },
	
	    filterNot: function(predicate, context) {
	      return this.filter(not(predicate), context);
	    },
	
	    findLast: function(predicate, context, notSetValue) {
	      return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
	    },
	
	    first: function() {
	      return this.find(returnTrue);
	    },
	
	    flatMap: function(mapper, context) {
	      return reify(this, flatMapFactory(this, mapper, context));
	    },
	
	    flatten: function(depth) {
	      return reify(this, flattenFactory(this, depth, true));
	    },
	
	    fromEntrySeq: function() {
	      return new FromEntriesSequence(this);
	    },
	
	    get: function(searchKey, notSetValue) {
	      return this.find(function(_, key)  {return is(key, searchKey)}, undefined, notSetValue);
	    },
	
	    getIn: function(searchKeyPath, notSetValue) {
	      var nested = this;
	      // Note: in an ES6 environment, we would prefer:
	      // for (var key of searchKeyPath) {
	      var iter = forceIterator(searchKeyPath);
	      var step;
	      while (!(step = iter.next()).done) {
	        var key = step.value;
	        nested = nested && nested.get ? nested.get(key, NOT_SET) : NOT_SET;
	        if (nested === NOT_SET) {
	          return notSetValue;
	        }
	      }
	      return nested;
	    },
	
	    groupBy: function(grouper, context) {
	      return groupByFactory(this, grouper, context);
	    },
	
	    has: function(searchKey) {
	      return this.get(searchKey, NOT_SET) !== NOT_SET;
	    },
	
	    hasIn: function(searchKeyPath) {
	      return this.getIn(searchKeyPath, NOT_SET) !== NOT_SET;
	    },
	
	    isSubset: function(iter) {
	      iter = typeof iter.includes === 'function' ? iter : Iterable(iter);
	      return this.every(function(value ) {return iter.includes(value)});
	    },
	
	    isSuperset: function(iter) {
	      iter = typeof iter.isSubset === 'function' ? iter : Iterable(iter);
	      return iter.isSubset(this);
	    },
	
	    keySeq: function() {
	      return this.toSeq().map(keyMapper).toIndexedSeq();
	    },
	
	    last: function() {
	      return this.toSeq().reverse().first();
	    },
	
	    max: function(comparator) {
	      return maxFactory(this, comparator);
	    },
	
	    maxBy: function(mapper, comparator) {
	      return maxFactory(this, comparator, mapper);
	    },
	
	    min: function(comparator) {
	      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
	    },
	
	    minBy: function(mapper, comparator) {
	      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
	    },
	
	    rest: function() {
	      return this.slice(1);
	    },
	
	    skip: function(amount) {
	      return this.slice(Math.max(0, amount));
	    },
	
	    skipLast: function(amount) {
	      return reify(this, this.toSeq().reverse().skip(amount).reverse());
	    },
	
	    skipWhile: function(predicate, context) {
	      return reify(this, skipWhileFactory(this, predicate, context, true));
	    },
	
	    skipUntil: function(predicate, context) {
	      return this.skipWhile(not(predicate), context);
	    },
	
	    sortBy: function(mapper, comparator) {
	      return reify(this, sortFactory(this, comparator, mapper));
	    },
	
	    take: function(amount) {
	      return this.slice(0, Math.max(0, amount));
	    },
	
	    takeLast: function(amount) {
	      return reify(this, this.toSeq().reverse().take(amount).reverse());
	    },
	
	    takeWhile: function(predicate, context) {
	      return reify(this, takeWhileFactory(this, predicate, context));
	    },
	
	    takeUntil: function(predicate, context) {
	      return this.takeWhile(not(predicate), context);
	    },
	
	    valueSeq: function() {
	      return this.toIndexedSeq();
	    },
	
	
	    // ### Hashable Object
	
	    hashCode: function() {
	      return this.__hash || (this.__hash = hashIterable(this));
	    }
	
	
	    // ### Internal
	
	    // abstract __iterate(fn, reverse)
	
	    // abstract __iterator(type, reverse)
	  });
	
	  // var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
	  // var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
	  // var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
	  // var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
	
	  var IterablePrototype = Iterable.prototype;
	  IterablePrototype[IS_ITERABLE_SENTINEL] = true;
	  IterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.values;
	  IterablePrototype.__toJS = IterablePrototype.toArray;
	  IterablePrototype.__toStringMapper = quoteString;
	  IterablePrototype.inspect =
	  IterablePrototype.toSource = function() { return this.toString(); };
	  IterablePrototype.chain = IterablePrototype.flatMap;
	  IterablePrototype.contains = IterablePrototype.includes;
	
	  // Temporary warning about using length
	  (function () {
	    try {
	      Object.defineProperty(IterablePrototype, 'length', {
	        get: function () {
	          if (!Iterable.noLengthWarning) {
	            var stack;
	            try {
	              throw new Error();
	            } catch (error) {
	              stack = error.stack;
	            }
	            if (stack.indexOf('_wrapObject') === -1) {
	              console && console.warn && console.warn(
	                'iterable.length has been deprecated, '+
	                'use iterable.size or iterable.count(). '+
	                'This warning will become a silent error in a future version. ' +
	                stack
	              );
	              return this.size;
	            }
	          }
	        }
	      });
	    } catch (e) {}
	  })();
	
	
	
	  mixin(KeyedIterable, {
	
	    // ### More sequential methods
	
	    flip: function() {
	      return reify(this, flipFactory(this));
	    },
	
	    findKey: function(predicate, context) {
	      var entry = this.findEntry(predicate, context);
	      return entry && entry[0];
	    },
	
	    findLastKey: function(predicate, context) {
	      return this.toSeq().reverse().findKey(predicate, context);
	    },
	
	    keyOf: function(searchValue) {
	      return this.findKey(function(value ) {return is(value, searchValue)});
	    },
	
	    lastKeyOf: function(searchValue) {
	      return this.findLastKey(function(value ) {return is(value, searchValue)});
	    },
	
	    mapEntries: function(mapper, context) {var this$0 = this;
	      var iterations = 0;
	      return reify(this,
	        this.toSeq().map(
	          function(v, k)  {return mapper.call(context, [k, v], iterations++, this$0)}
	        ).fromEntrySeq()
	      );
	    },
	
	    mapKeys: function(mapper, context) {var this$0 = this;
	      return reify(this,
	        this.toSeq().flip().map(
	          function(k, v)  {return mapper.call(context, k, v, this$0)}
	        ).flip()
	      );
	    }
	
	  });
	
	  var KeyedIterablePrototype = KeyedIterable.prototype;
	  KeyedIterablePrototype[IS_KEYED_SENTINEL] = true;
	  KeyedIterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.entries;
	  KeyedIterablePrototype.__toJS = IterablePrototype.toObject;
	  KeyedIterablePrototype.__toStringMapper = function(v, k)  {return JSON.stringify(k) + ': ' + quoteString(v)};
	
	
	
	  mixin(IndexedIterable, {
	
	    // ### Conversion to other types
	
	    toKeyedSeq: function() {
	      return new ToKeyedSequence(this, false);
	    },
	
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    filter: function(predicate, context) {
	      return reify(this, filterFactory(this, predicate, context, false));
	    },
	
	    findIndex: function(predicate, context) {
	      var entry = this.findEntry(predicate, context);
	      return entry ? entry[0] : -1;
	    },
	
	    indexOf: function(searchValue) {
	      var key = this.toKeyedSeq().keyOf(searchValue);
	      return key === undefined ? -1 : key;
	    },
	
	    lastIndexOf: function(searchValue) {
	      var key = this.toKeyedSeq().reverse().keyOf(searchValue);
	      return key === undefined ? -1 : key;
	
	      // var index =
	      // return this.toSeq().reverse().indexOf(searchValue);
	    },
	
	    reverse: function() {
	      return reify(this, reverseFactory(this, false));
	    },
	
	    slice: function(begin, end) {
	      return reify(this, sliceFactory(this, begin, end, false));
	    },
	
	    splice: function(index, removeNum /*, ...values*/) {
	      var numArgs = arguments.length;
	      removeNum = Math.max(removeNum | 0, 0);
	      if (numArgs === 0 || (numArgs === 2 && !removeNum)) {
	        return this;
	      }
	      // If index is negative, it should resolve relative to the size of the
	      // collection. However size may be expensive to compute if not cached, so
	      // only call count() if the number is in fact negative.
	      index = resolveBegin(index, index < 0 ? this.count() : this.size);
	      var spliced = this.slice(0, index);
	      return reify(
	        this,
	        numArgs === 1 ?
	          spliced :
	          spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum))
	      );
	    },
	
	
	    // ### More collection methods
	
	    findLastIndex: function(predicate, context) {
	      var key = this.toKeyedSeq().findLastKey(predicate, context);
	      return key === undefined ? -1 : key;
	    },
	
	    first: function() {
	      return this.get(0);
	    },
	
	    flatten: function(depth) {
	      return reify(this, flattenFactory(this, depth, false));
	    },
	
	    get: function(index, notSetValue) {
	      index = wrapIndex(this, index);
	      return (index < 0 || (this.size === Infinity ||
	          (this.size !== undefined && index > this.size))) ?
	        notSetValue :
	        this.find(function(_, key)  {return key === index}, undefined, notSetValue);
	    },
	
	    has: function(index) {
	      index = wrapIndex(this, index);
	      return index >= 0 && (this.size !== undefined ?
	        this.size === Infinity || index < this.size :
	        this.indexOf(index) !== -1
	      );
	    },
	
	    interpose: function(separator) {
	      return reify(this, interposeFactory(this, separator));
	    },
	
	    interleave: function(/*...iterables*/) {
	      var iterables = [this].concat(arrCopy(arguments));
	      var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, iterables);
	      var interleaved = zipped.flatten(true);
	      if (zipped.size) {
	        interleaved.size = zipped.size * iterables.length;
	      }
	      return reify(this, interleaved);
	    },
	
	    last: function() {
	      return this.get(-1);
	    },
	
	    skipWhile: function(predicate, context) {
	      return reify(this, skipWhileFactory(this, predicate, context, false));
	    },
	
	    zip: function(/*, ...iterables */) {
	      var iterables = [this].concat(arrCopy(arguments));
	      return reify(this, zipWithFactory(this, defaultZipper, iterables));
	    },
	
	    zipWith: function(zipper/*, ...iterables */) {
	      var iterables = arrCopy(arguments);
	      iterables[0] = this;
	      return reify(this, zipWithFactory(this, zipper, iterables));
	    }
	
	  });
	
	  IndexedIterable.prototype[IS_INDEXED_SENTINEL] = true;
	  IndexedIterable.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	
	  mixin(SetIterable, {
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    get: function(value, notSetValue) {
	      return this.has(value) ? value : notSetValue;
	    },
	
	    includes: function(value) {
	      return this.has(value);
	    },
	
	
	    // ### More sequential methods
	
	    keySeq: function() {
	      return this.valueSeq();
	    }
	
	  });
	
	  SetIterable.prototype.has = IterablePrototype.includes;
	
	
	  // Mixin subclasses
	
	  mixin(KeyedSeq, KeyedIterable.prototype);
	  mixin(IndexedSeq, IndexedIterable.prototype);
	  mixin(SetSeq, SetIterable.prototype);
	
	  mixin(KeyedCollection, KeyedIterable.prototype);
	  mixin(IndexedCollection, IndexedIterable.prototype);
	  mixin(SetCollection, SetIterable.prototype);
	
	
	  // #pragma Helper functions
	
	  function keyMapper(v, k) {
	    return k;
	  }
	
	  function entryMapper(v, k) {
	    return [k, v];
	  }
	
	  function not(predicate) {
	    return function() {
	      return !predicate.apply(this, arguments);
	    }
	  }
	
	  function neg(predicate) {
	    return function() {
	      return -predicate.apply(this, arguments);
	    }
	  }
	
	  function quoteString(value) {
	    return typeof value === 'string' ? JSON.stringify(value) : value;
	  }
	
	  function defaultZipper() {
	    return arrCopy(arguments);
	  }
	
	  function defaultNegComparator(a, b) {
	    return a < b ? 1 : a > b ? -1 : 0;
	  }
	
	  function hashIterable(iterable) {
	    if (iterable.size === Infinity) {
	      return 0;
	    }
	    var ordered = isOrdered(iterable);
	    var keyed = isKeyed(iterable);
	    var h = ordered ? 1 : 0;
	    var size = iterable.__iterate(
	      keyed ?
	        ordered ?
	          function(v, k)  { h = 31 * h + hashMerge(hash(v), hash(k)) | 0; } :
	          function(v, k)  { h = h + hashMerge(hash(v), hash(k)) | 0; } :
	        ordered ?
	          function(v ) { h = 31 * h + hash(v) | 0; } :
	          function(v ) { h = h + hash(v) | 0; }
	    );
	    return murmurHashOfSize(size, h);
	  }
	
	  function murmurHashOfSize(size, h) {
	    h = imul(h, 0xCC9E2D51);
	    h = imul(h << 15 | h >>> -15, 0x1B873593);
	    h = imul(h << 13 | h >>> -13, 5);
	    h = (h + 0xE6546B64 | 0) ^ size;
	    h = imul(h ^ h >>> 16, 0x85EBCA6B);
	    h = imul(h ^ h >>> 13, 0xC2B2AE35);
	    h = smi(h ^ h >>> 16);
	    return h;
	  }
	
	  function hashMerge(a, b) {
	    return a ^ b + 0x9E3779B9 + (a << 6) + (a >> 2) | 0; // int
	  }
	
	  var Immutable = {
	
	    Iterable: Iterable,
	
	    Seq: Seq,
	    Collection: Collection,
	    Map: Map,
	    OrderedMap: OrderedMap,
	    List: List,
	    Stack: Stack,
	    Set: Set,
	    OrderedSet: OrderedSet,
	
	    Record: Record,
	    Range: Range,
	    Repeat: Repeat,
	
	    is: is,
	    fromJS: fromJS
	
	  };
	
	  return Immutable;
	
	}));

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// Simple React Validator v1.6.2 | Created By Dockwa | MIT License | 2017 - Present
	!function(e,t){ true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (t), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"object"==typeof exports?module.exports=t(require("react")):e.SimpleReactValidator=t(e.React)}(this,function(s){"use strict";function f(e,t){return function(e){if(Array.isArray(e))return e}(e)||function(e,t){var r=null==e?null:"undefined"!=typeof Symbol&&e[Symbol.iterator]||e["@@iterator"];if(null==r)return;var n,s,a=[],i=!0,u=!1;try{for(r=r.call(e);!(i=(n=r.next()).done)&&(a.push(n.value),!t||a.length!==t);i=!0);}catch(e){u=!0,s=e}finally{try{i||null==r.return||r.return()}finally{if(u)throw s}}return a}(e,t)||l(e,t)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function p(e,t){var r="undefined"!=typeof Symbol&&e[Symbol.iterator]||e["@@iterator"];if(!r){if(Array.isArray(e)||(r=l(e))||t&&e&&"number"==typeof e.length){r&&(e=r);var n=0,s=function(){};return{s:s,n:function(){return n>=e.length?{done:!0}:{done:!1,value:e[n++]}},e:function(e){throw e},f:s}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}var a,i=!0,u=!1;return{s:function(){r=r.call(e)},n:function(){var e=r.next();return i=e.done,e},e:function(e){u=!0,a=e},f:function(){try{i||null==r.return||r.return()}finally{if(u)throw a}}}}function l(e,t){if(e){if("string"==typeof e)return n(e,t);var r=Object.prototype.toString.call(e).slice(8,-1);return"Object"===r&&e.constructor&&(r=e.constructor.name),"Map"===r||"Set"===r?Array.from(e):"Arguments"===r||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)?n(e,t):void 0}}function n(e,t){(null==t||t>e.length)&&(t=e.length);for(var r=0,n=new Array(t);r<t;r++)n[r]=e[r];return n}function a(e){return(a="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function i(t,e){var r=Object.keys(t);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(t);e&&(n=n.filter(function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable})),r.push.apply(r,n)}return r}function d(t){for(var e=1;e<arguments.length;e++){var r=null!=arguments[e]?arguments[e]:{};e%2?i(Object(r),!0).forEach(function(e){o(t,e,r[e])}):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(r)):i(Object(r)).forEach(function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(r,e))})}return t}function u(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}function o(e,t,r){return t in e?Object.defineProperty(e,t,{value:r,enumerable:!0,configurable:!0,writable:!0}):e[t]=r,e}var e=function(){function n(){var r=this,e=0<arguments.length&&void 0!==arguments[0]?arguments[0]:{};!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,n),o(this,"showMessageFor",function(e){r.visibleFields.includes(e)||r.visibleFields.push(e),r.helpers.forceUpdateIfNeeded()}),o(this,"hideMessageFor",function(e){var t=r.visibleFields.indexOf(e);-1<t&&r.visibleFields.splice(t,1),r.helpers.forceUpdateIfNeeded()}),o(this,"helpers",{parent:this,passes:function(e,t,r,n){return n.hasOwnProperty(e)?!(this.isRequired(e,n)||!this.isBlank(t))||!1!==n[e].rule(t,r,this.parent):(console.error("Rule Not Found: There is no rule with the name ".concat(e,".")),!0)},isRequired:function(e,t){return t[e].hasOwnProperty("required")&&t[e].required},isBlank:function(e){return null==e||this.testRegex(e,/^[\s]*$/)},normalizeValues:function(e,t){return[this.valueOrEmptyString(e),this.getValidation(t),this.getOptions(t)]},getValidation:function(e){return e===Object(e)&&Object.keys(e).length?Object.keys(e)[0]:e.split(":")[0]},getOptions:function(e){if(e===Object(e)&&Object.values(e).length){var t=Object.values(e)[0];return Array.isArray(t)?t:[t]}return 1<(t=e.split(":")).length?t[1].split(","):[]},valueOrEmptyString:function(e){return null==e?"":e},toSentence:function(e){return e.slice(0,-2).join(", ")+(e.slice(0,-2).length?", ":"")+e.slice(-2).join(2<e.length?", or ":" or ")},testRegex:function(e,t){return null!==e.toString().match(t)},forceUpdateIfNeeded:function(){this.parent.autoForceUpdate&&this.parent.autoForceUpdate.forceUpdate()},message:function(e,t,r,n){r.messages=r.messages||{};var s=r.messages[e]||r.messages.default||this.parent.messages[e]||this.parent.messages.default||n[e].message;return s.replace(":attribute",this.humanizeFieldName(t))},humanizeFieldName:function(e){return e.replace(/([a-z0-9])([A-Z])/g,"$1 $2").replace(/_/g," ").toLowerCase()},element:function(e,t){var r=t.element||this.parent.element;return r(e,t.className)},momentInstalled:function(){return!(!window||!window.moment)||(console.warn("Date validators require using momentjs https://momentjs.com and moment objects."),!1)},size:function(e,t){return"string"===t||void 0===t||"array"===t?e.length:"num"===t?parseFloat(e):void 0},sizeText:function(e){return"string"===e||void 0===e?" characters":"array"===e?" elements":""}}),this.fields={},this.visibleFields=[],this.errorMessages={},this.messagesShown=!1,this.rules=d({accepted:{message:"The :attribute must be accepted.",rule:function(e){return!0===e},required:!0},after:{message:"The :attribute must be after :date.",rule:function(e,t){return r.helpers.momentInstalled()&&moment.isMoment(e)&&e.isAfter(t[0],"day")},messageReplace:function(e,t){return e.replace(":date",t[0].format("MM/DD/YYYY"))}},after_or_equal:{message:"The :attribute must be after or on :date.",rule:function(e,t){return r.helpers.momentInstalled()&&moment.isMoment(e)&&e.isSameOrAfter(t[0],"day")},messageReplace:function(e,t){return e.replace(":date",t[0].format("MM/DD/YYYY"))}},alpha:{message:"The :attribute may only contain letters.",rule:function(e){return r.helpers.testRegex(e,/^[A-Z]*$/i)}},alpha_space:{message:"The :attribute may only contain letters and spaces.",rule:function(e){return r.helpers.testRegex(e,/^[A-Z\s]*$/i)}},alpha_num:{message:"The :attribute may only contain letters and numbers.",rule:function(e){return r.helpers.testRegex(e,/^[A-Z0-9]*$/i)}},alpha_num_space:{message:"The :attribute may only contain letters, numbers, and spaces.",rule:function(e){return r.helpers.testRegex(e,/^[A-Z0-9\s]*$/i)}},alpha_num_dash:{message:"The :attribute may only contain letters, numbers, and dashes.",rule:function(e){return r.helpers.testRegex(e,/^[A-Z0-9_-]*$/i)}},alpha_num_dash_space:{message:"The :attribute may only contain letters, numbers, dashes, and spaces.",rule:function(e){return r.helpers.testRegex(e,/^[A-Z0-9_-\s]*$/i)}},array:{message:"The :attribute must be an array.",rule:function(e){return Array.isArray(e)}},before:{message:"The :attribute must be before :date.",rule:function(e,t){return r.helpers.momentInstalled()&&moment.isMoment(e)&&e.isBefore(t[0],"day")},messageReplace:function(e,t){return e.replace(":date",t[0].format("MM/DD/YYYY"))}},before_or_equal:{message:"The :attribute must be before or on :date.",rule:function(e,t){return r.helpers.momentInstalled()&&moment.isMoment(e)&&e.isSameOrBefore(t[0],"day")},messageReplace:function(e,t){return e.replace(":date",t[0].format("MM/DD/YYYY"))}},between:{message:"The :attribute must be between :min and :max:type.",rule:function(e,t){return r.helpers.size(e,t[2])>=parseFloat(t[0])&&r.helpers.size(e,t[2])<=parseFloat(t[1])},messageReplace:function(e,t){return e.replace(":min",t[0]).replace(":max",t[1]).replace(":type",r.helpers.sizeText(t[2]))}},boolean:{message:"The :attribute must be a boolean.",rule:function(e){return!1===e||!0===e}},card_exp:{message:"The :attribute must be a valid expiration date.",rule:function(e){return r.helpers.testRegex(e,/^(([0]?[1-9]{1})|([1]{1}[0-2]{1}))\s?\/\s?(\d{2}|\d{4})$/)}},card_num:{message:"The :attribute must be a valid credit card number.",rule:function(e){return r.helpers.testRegex(e,/^\d{4}\s?\d{4,6}\s?\d{4,5}\s?\d{0,8}$/)}},currency:{message:"The :attribute must be a valid currency.",rule:function(e){return r.helpers.testRegex(e,/^[\$£€¥]?(\d{1,3})(\,?\d{3})*\.?\d{0,2}$/)}},date:{message:"The :attribute must be a date.",rule:function(e){return r.helpers.momentInstalled()&&moment.isMoment(e)}},date_equals:{message:"The :attribute must be on :date.",rule:function(e,t){return r.helpers.momentInstalled()&&moment.isMoment(e)&&e.isSame(t[0],"day")},messageReplace:function(e,t){return e.replace(":date",t[0].format("MM/DD/YYYY"))}},email:{message:"The :attribute must be a valid email address.",rule:function(e){return r.helpers.testRegex(e,/^[A-Z0-9.!#$%&'*+-/=?^_`{|}~]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i)}},in:{message:"The selected :attribute must be :values.",rule:function(e,t){return t.includes(e)},messageReplace:function(e,t){return e.replace(":values",r.helpers.toSentence(t))}},integer:{message:"The :attribute must be an integer.",rule:function(e){return r.helpers.testRegex(e,/^\-?\d*$/)}},max:{message:"The :attribute may not be greater than :max:type.",rule:function(e,t){return r.helpers.size(e,t[1])<=parseFloat(t[0])},messageReplace:function(e,t){return e.replace(":max",t[0]).replace(":type",r.helpers.sizeText(t[1]))}},min:{message:"The :attribute must be at least :min:type.",rule:function(e,t){return r.helpers.size(e,t[1])>=parseFloat(t[0])},messageReplace:function(e,t){return e.replace(":min",t[0]).replace(":type",r.helpers.sizeText(t[1]))}},not_in:{message:"The selected :attribute must not be :values.",rule:function(e,t){return!t.includes(e)},messageReplace:function(e,t){return e.replace(":values",r.helpers.toSentence(t))}},not_regex:{message:"The :attribute must not match the required pattern.",rule:function(e,t){return!r.helpers.testRegex(e,"string"==typeof t[0]||t[0]instanceof String?new RegExp(t[0]):t[0])}},numeric:{message:"The :attribute must be a number.",rule:function(e){return r.helpers.testRegex(e,/^\-?\d*\.?\d+$/)}},phone:{message:"The :attribute must be a valid phone number.",rule:function(e){return r.helpers.testRegex(e,/^(\+?\d{0,4})?\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{4}\)?)$/)&&!r.helpers.testRegex(e,/^\b(\d)\1{8,}\b$/)}},regex:{message:"The :attribute must match the required pattern.",rule:function(e,t){return r.helpers.testRegex(e,"string"==typeof t[0]||t[0]instanceof String?new RegExp(t[0]):t[0])}},required:{message:"The :attribute field is required.",rule:function(e){return!r.helpers.isBlank(e)},required:!0},size:{message:"The :attribute must be :size:type.",rule:function(e,t){return r.helpers.size(e,t[1])==parseFloat(t[0])},messageReplace:function(e,t){return e.replace(":size",t[0]).replace(":type",r.helpers.sizeText(t[1]))}},string:{message:"The :attribute must be a string.",rule:function(e){return a(e)===a("string")}},typeof:{message:"The :attribute is not the correct type of :type.",rule:function(e,t){return a(e)===a(t[0])},messageReplace:function(e,t){return e.replace(":type",a(t[0]))}},url:{message:"The :attribute must be a url.",rule:function(e){return r.helpers.testRegex(e,/^https?:\/\/[-a-z0-9@:%._\+~#=]{1,256}\.[a-z0-9()]{2,13}\b([-a-z0-9()@:%_\+.~#?&//=]*)$/i)}}},e.validators||{}),e.locale&&!n.locales.hasOwnProperty(e.locale)&&console.warn("Locale not found! Make sure it is spelled correctly and the locale file is loaded.");var t=n.locales[e.locale]||{};Object.keys(this.rules).forEach(function(e){r.rules[e].message=t[e]||r.rules[e].message}),this.messages=e.messages||{},this.className=e.className,this.autoForceUpdate=e.autoForceUpdate||!1,!1===e.element?this.element=function(e){return e}:e.hasOwnProperty("element")?this.element=e.element:"object"===("undefined"==typeof navigator?"undefined":a(navigator))&&"ReactNative"===navigator.product?this.element=function(e){return e}:this.element=function(e,t){return s.createElement("div",{className:t||r.className||"srv-validation-message"},e)}}var e,t,r;return e=n,r=[{key:"addLocale",value:function(e,t){this.locales[e]=t}}],(t=[{key:"getErrorMessages",value:function(){return this.errorMessages}},{key:"showMessages",value:function(){this.messagesShown=!0,this.helpers.forceUpdateIfNeeded()}},{key:"hideMessages",value:function(){this.messagesShown=!1,this.helpers.forceUpdateIfNeeded()}},{key:"allValid",value:function(){for(var e in this.fields)if(!1===this.fieldValid(e))return!1;return!0}},{key:"fieldValid",value:function(e){return this.fields.hasOwnProperty(e)&&!0===this.fields[e]}},{key:"purgeFields",value:function(){this.fields={},this.errorMessages={}}},{key:"messageWhenPresent",value:function(e){var t=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{};if(!this.helpers.isBlank(e)&&this.messagesShown)return this.helpers.element(e,t)}},{key:"messageAlways",value:function(e,t){var r=2<arguments.length&&void 0!==arguments[2]?arguments[2]:{};if(console.warn("The messageAlways() method is deprecated in SimpleReactValidator. Please see the documentation and switch to the messageWhenPresent() method."),t&&this.messagesShown)return this.helpers.element(t,r)}},{key:"check",value:function(e,t){var r=2<arguments.length&&void 0!==arguments[2]?arguments[2]:{};Array.isArray(t)||(t=t.split("|"));var n,s=r.validators?d(d({},this.rules),r.validators):this.rules,a=p(t);try{for(a.s();!(n=a.n()).done;){var i=n.value,u=f(this.helpers.normalizeValues(e,i),3),l=u[0],o=u[1],c=u[2];if(!this.helpers.passes(o,l,c,s))return!1}}catch(e){a.e(e)}finally{a.f()}return!0}},{key:"message",value:function(e,t,r){var n=3<arguments.length&&void 0!==arguments[3]?arguments[3]:{};this.errorMessages[e]=null,this.fields[e]=!0,Array.isArray(r)||(r=r.split("|"));var s,a=n.validators?d(d({},this.rules),n.validators):this.rules,i=p(r);try{for(i.s();!(s=i.n()).done;){var u=s.value,l=f(this.helpers.normalizeValues(t,u),3),o=l[0],c=l[1],m=l[2];if(!this.helpers.passes(c,o,m,a)){this.fields[e]=!1;var h=this.helpers.message(c,e,n,a);if(0<m.length&&a[c].hasOwnProperty("messageReplace")&&(h=a[c].messageReplace(h,m)),this.errorMessages[e]=h,this.messagesShown||this.visibleFields.includes(e))return this.helpers.element(h,n)}}}catch(e){i.e(e)}finally{i.f()}}}])&&u(e.prototype,t),r&&u(e,r),Object.defineProperty(e,"prototype",{writable:!1}),n}();return o(e,"version","1.5.1"),o(e,"locales",{en:{}}),e});

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	var getPrototypeOf = __webpack_require__(39);
	var isNativeReflectConstruct = __webpack_require__(696);
	var possibleConstructorReturn = __webpack_require__(40);
	function _createSuper(t) {
	  var r = isNativeReflectConstruct();
	  return function () {
	    var e,
	      o = getPrototypeOf(t);
	    if (r) {
	      var s = getPrototypeOf(this).constructor;
	      e = Reflect.construct(o, arguments, s);
	    } else e = o.apply(this, arguments);
	    return possibleConstructorReturn(this, e);
	  };
	}
	module.exports = _createSuper, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 30 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = toInteger;
	function toInteger(dirtyNumber) {
	  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
	    return NaN;
	  }
	  var number = Number(dirtyNumber);
	  if (isNaN(number)) {
	    return number;
	  }
	  return number < 0 ? Math.ceil(number) : Math.floor(number);
	}
	module.exports = exports.default;

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Parser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	var _createClass2 = _interopRequireDefault(__webpack_require__(19));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(24));
	var _Setter = __webpack_require__(387);
	var Parser = /*#__PURE__*/function () {
	  function Parser() {
	    (0, _classCallCheck2.default)(this, Parser);
	    (0, _defineProperty2.default)(this, "incompatibleTokens", void 0);
	    (0, _defineProperty2.default)(this, "priority", void 0);
	    (0, _defineProperty2.default)(this, "subPriority", void 0);
	  }
	  (0, _createClass2.default)(Parser, [{
	    key: "run",
	    value: function run(dateString, token, match, options) {
	      var result = this.parse(dateString, token, match, options);
	      if (!result) {
	        return null;
	      }
	      return {
	        setter: new _Setter.ValueSetter(result.value, this.validate, this.set, this.priority, this.subPriority),
	        rest: result.rest
	      };
	    }
	  }, {
	    key: "validate",
	    value: function validate(_utcDate, _value, _options) {
	      return true;
	    }
	  }]);
	  return Parser;
	}();
	exports.Parser = Parser;

/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	'use strict';
	
	var validateFormat =  false ? function (format) {
	  if (format === undefined) {
	    throw new Error('invariant(...): Second argument must be a string.');
	  }
	} : function (format) {};
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments to provide
	 * information about what broke and what you were expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant will
	 * remain to ensure logic does not differ in production.
	 */
	
	function invariant(condition, format) {
	  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return String(args[argIndex++]);
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // Skip invariant's own stack frame.
	
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _paginator = _interopRequireDefault(__webpack_require__(1353));
	
	var _Page = _interopRequireDefault(__webpack_require__(1438));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var Pagination =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(Pagination, _React$Component);
	
	  function Pagination() {
	    _classCallCheck(this, Pagination);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(Pagination).apply(this, arguments));
	  }
	
	  _createClass(Pagination, [{
	    key: "isFirstPageVisible",
	    value: function isFirstPageVisible(has_previous_page) {
	      var _this$props = this.props,
	          hideDisabled = _this$props.hideDisabled,
	          hideNavigation = _this$props.hideNavigation,
	          hideFirstLastPages = _this$props.hideFirstLastPages;
	      if (hideFirstLastPages || hideDisabled && !has_previous_page) return false;
	      return true;
	    }
	  }, {
	    key: "isPrevPageVisible",
	    value: function isPrevPageVisible(has_previous_page) {
	      var _this$props2 = this.props,
	          hideDisabled = _this$props2.hideDisabled,
	          hideNavigation = _this$props2.hideNavigation;
	      if (hideNavigation || hideDisabled && !has_previous_page) return false;
	      return true;
	    }
	  }, {
	    key: "isNextPageVisible",
	    value: function isNextPageVisible(has_next_page) {
	      var _this$props3 = this.props,
	          hideDisabled = _this$props3.hideDisabled,
	          hideNavigation = _this$props3.hideNavigation;
	      if (hideNavigation || hideDisabled && !has_next_page) return false;
	      return true;
	    }
	  }, {
	    key: "isLastPageVisible",
	    value: function isLastPageVisible(has_next_page) {
	      var _this$props4 = this.props,
	          hideDisabled = _this$props4.hideDisabled,
	          hideNavigation = _this$props4.hideNavigation,
	          hideFirstLastPages = _this$props4.hideFirstLastPages;
	      if (hideFirstLastPages || hideDisabled && !has_next_page) return false;
	      return true;
	    }
	  }, {
	    key: "buildPages",
	    value: function buildPages() {
	      var pages = [];
	      var _this$props5 = this.props,
	          itemsCountPerPage = _this$props5.itemsCountPerPage,
	          pageRangeDisplayed = _this$props5.pageRangeDisplayed,
	          activePage = _this$props5.activePage,
	          prevPageText = _this$props5.prevPageText,
	          nextPageText = _this$props5.nextPageText,
	          firstPageText = _this$props5.firstPageText,
	          lastPageText = _this$props5.lastPageText,
	          totalItemsCount = _this$props5.totalItemsCount,
	          onChange = _this$props5.onChange,
	          activeClass = _this$props5.activeClass,
	          itemClass = _this$props5.itemClass,
	          itemClassFirst = _this$props5.itemClassFirst,
	          itemClassPrev = _this$props5.itemClassPrev,
	          itemClassNext = _this$props5.itemClassNext,
	          itemClassLast = _this$props5.itemClassLast,
	          activeLinkClass = _this$props5.activeLinkClass,
	          disabledClass = _this$props5.disabledClass,
	          hideDisabled = _this$props5.hideDisabled,
	          hideNavigation = _this$props5.hideNavigation,
	          linkClass = _this$props5.linkClass,
	          linkClassFirst = _this$props5.linkClassFirst,
	          linkClassPrev = _this$props5.linkClassPrev,
	          linkClassNext = _this$props5.linkClassNext,
	          linkClassLast = _this$props5.linkClassLast,
	          hideFirstLastPages = _this$props5.hideFirstLastPages,
	          getPageUrl = _this$props5.getPageUrl;
	      var paginationInfo = new _paginator["default"](itemsCountPerPage, pageRangeDisplayed).build(totalItemsCount, activePage);
	
	      for (var i = paginationInfo.first_page; i <= paginationInfo.last_page; i++) {
	        pages.push(_react["default"].createElement(_Page["default"], {
	          isActive: i === activePage,
	          key: i,
	          href: getPageUrl(i),
	          pageNumber: i,
	          pageText: i + "",
	          onClick: onChange,
	          itemClass: itemClass,
	          linkClass: linkClass,
	          activeClass: activeClass,
	          activeLinkClass: activeLinkClass,
	          ariaLabel: "Go to page number ".concat(i)
	        }));
	      }
	
	      this.isPrevPageVisible(paginationInfo.has_previous_page) && pages.unshift(_react["default"].createElement(_Page["default"], {
	        key: "prev" + paginationInfo.previous_page,
	        href: getPageUrl(paginationInfo.previous_page),
	        pageNumber: paginationInfo.previous_page,
	        onClick: onChange,
	        pageText: prevPageText,
	        isDisabled: !paginationInfo.has_previous_page,
	        itemClass: (0, _classnames["default"])(itemClass, itemClassPrev),
	        linkClass: (0, _classnames["default"])(linkClass, linkClassPrev),
	        disabledClass: disabledClass,
	        ariaLabel: "Go to previous page"
	      }));
	      this.isFirstPageVisible(paginationInfo.has_previous_page) && pages.unshift(_react["default"].createElement(_Page["default"], {
	        key: "first",
	        href: getPageUrl(1),
	        pageNumber: 1,
	        onClick: onChange,
	        pageText: firstPageText,
	        isDisabled: !paginationInfo.has_previous_page,
	        itemClass: (0, _classnames["default"])(itemClass, itemClassFirst),
	        linkClass: (0, _classnames["default"])(linkClass, linkClassFirst),
	        disabledClass: disabledClass,
	        ariaLabel: "Go to first page"
	      }));
	      this.isNextPageVisible(paginationInfo.has_next_page) && pages.push(_react["default"].createElement(_Page["default"], {
	        key: "next" + paginationInfo.next_page,
	        href: getPageUrl(paginationInfo.next_page),
	        pageNumber: paginationInfo.next_page,
	        onClick: onChange,
	        pageText: nextPageText,
	        isDisabled: !paginationInfo.has_next_page,
	        itemClass: (0, _classnames["default"])(itemClass, itemClassNext),
	        linkClass: (0, _classnames["default"])(linkClass, linkClassNext),
	        disabledClass: disabledClass,
	        ariaLabel: "Go to next page"
	      }));
	      this.isLastPageVisible(paginationInfo.has_next_page) && pages.push(_react["default"].createElement(_Page["default"], {
	        key: "last",
	        href: getPageUrl(paginationInfo.total_pages),
	        pageNumber: paginationInfo.total_pages,
	        onClick: onChange,
	        pageText: lastPageText,
	        isDisabled: paginationInfo.current_page === paginationInfo.total_pages,
	        itemClass: (0, _classnames["default"])(itemClass, itemClassLast),
	        linkClass: (0, _classnames["default"])(linkClass, linkClassLast),
	        disabledClass: disabledClass,
	        ariaLabel: "Go to last page"
	      }));
	      return pages;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var pages = this.buildPages();
	      return _react["default"].createElement("ul", {
	        className: this.props.innerClass
	      }, pages);
	    }
	  }]);
	
	  return Pagination;
	}(_react["default"].Component);
	
	exports["default"] = Pagination;
	
	_defineProperty(Pagination, "propTypes", {
	  totalItemsCount: _propTypes["default"].number.isRequired,
	  onChange: _propTypes["default"].func.isRequired,
	  activePage: _propTypes["default"].number,
	  itemsCountPerPage: _propTypes["default"].number,
	  pageRangeDisplayed: _propTypes["default"].number,
	  prevPageText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].element]),
	  nextPageText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].element]),
	  lastPageText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].element]),
	  firstPageText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].element]),
	  disabledClass: _propTypes["default"].string,
	  hideDisabled: _propTypes["default"].bool,
	  hideNavigation: _propTypes["default"].bool,
	  innerClass: _propTypes["default"].string,
	  itemClass: _propTypes["default"].string,
	  itemClassFirst: _propTypes["default"].string,
	  itemClassPrev: _propTypes["default"].string,
	  itemClassNext: _propTypes["default"].string,
	  itemClassLast: _propTypes["default"].string,
	  linkClass: _propTypes["default"].string,
	  activeClass: _propTypes["default"].string,
	  activeLinkClass: _propTypes["default"].string,
	  linkClassFirst: _propTypes["default"].string,
	  linkClassPrev: _propTypes["default"].string,
	  linkClassNext: _propTypes["default"].string,
	  linkClassLast: _propTypes["default"].string,
	  hideFirstLastPages: _propTypes["default"].bool,
	  getPageUrl: _propTypes["default"].func
	});
	
	_defineProperty(Pagination, "defaultProps", {
	  itemsCountPerPage: 10,
	  pageRangeDisplayed: 5,
	  activePage: 1,
	  prevPageText: "⟨",
	  firstPageText: "«",
	  nextPageText: "⟩",
	  lastPageText: "»",
	  innerClass: "pagination",
	  itemClass: undefined,
	  linkClass: undefined,
	  activeLinkClass: undefined,
	  hideFirstLastPages: false,
	  getPageUrl: function getPageUrl(i) {
	    return "#";
	  }
	});

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	var setPrototypeOf = __webpack_require__(317);
	function _inheritsLoose(t, o) {
	  t.prototype = Object.create(o.prototype), t.prototype.constructor = t, setPrototypeOf(t, o);
	}
	module.exports = _inheritsLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.dayPeriodEnumToHours = dayPeriodEnumToHours;
	exports.isLeapYearIndex = isLeapYearIndex;
	exports.mapValue = mapValue;
	exports.normalizeTwoDigitYear = normalizeTwoDigitYear;
	exports.parseAnyDigitsSigned = parseAnyDigitsSigned;
	exports.parseNDigits = parseNDigits;
	exports.parseNDigitsSigned = parseNDigitsSigned;
	exports.parseNumericPattern = parseNumericPattern;
	exports.parseTimezonePattern = parseTimezonePattern;
	var _index = __webpack_require__(384);
	var _constants = __webpack_require__(57);
	function mapValue(parseFnResult, mapFn) {
	  if (!parseFnResult) {
	    return parseFnResult;
	  }
	  return {
	    value: mapFn(parseFnResult.value),
	    rest: parseFnResult.rest
	  };
	}
	function parseNumericPattern(pattern, dateString) {
	  var matchResult = dateString.match(pattern);
	  if (!matchResult) {
	    return null;
	  }
	  return {
	    value: parseInt(matchResult[0], 10),
	    rest: dateString.slice(matchResult[0].length)
	  };
	}
	function parseTimezonePattern(pattern, dateString) {
	  var matchResult = dateString.match(pattern);
	  if (!matchResult) {
	    return null;
	  }
	
	  // Input is 'Z'
	  if (matchResult[0] === 'Z') {
	    return {
	      value: 0,
	      rest: dateString.slice(1)
	    };
	  }
	  var sign = matchResult[1] === '+' ? 1 : -1;
	  var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
	  var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
	  var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
	  return {
	    value: sign * (hours * _index.millisecondsInHour + minutes * _index.millisecondsInMinute + seconds * _index.millisecondsInSecond),
	    rest: dateString.slice(matchResult[0].length)
	  };
	}
	function parseAnyDigitsSigned(dateString) {
	  return parseNumericPattern(_constants.numericPatterns.anyDigitsSigned, dateString);
	}
	function parseNDigits(n, dateString) {
	  switch (n) {
	    case 1:
	      return parseNumericPattern(_constants.numericPatterns.singleDigit, dateString);
	    case 2:
	      return parseNumericPattern(_constants.numericPatterns.twoDigits, dateString);
	    case 3:
	      return parseNumericPattern(_constants.numericPatterns.threeDigits, dateString);
	    case 4:
	      return parseNumericPattern(_constants.numericPatterns.fourDigits, dateString);
	    default:
	      return parseNumericPattern(new RegExp('^\\d{1,' + n + '}'), dateString);
	  }
	}
	function parseNDigitsSigned(n, dateString) {
	  switch (n) {
	    case 1:
	      return parseNumericPattern(_constants.numericPatterns.singleDigitSigned, dateString);
	    case 2:
	      return parseNumericPattern(_constants.numericPatterns.twoDigitsSigned, dateString);
	    case 3:
	      return parseNumericPattern(_constants.numericPatterns.threeDigitsSigned, dateString);
	    case 4:
	      return parseNumericPattern(_constants.numericPatterns.fourDigitsSigned, dateString);
	    default:
	      return parseNumericPattern(new RegExp('^-?\\d{1,' + n + '}'), dateString);
	  }
	}
	function dayPeriodEnumToHours(dayPeriod) {
	  switch (dayPeriod) {
	    case 'morning':
	      return 4;
	    case 'evening':
	      return 17;
	    case 'pm':
	    case 'noon':
	    case 'afternoon':
	      return 12;
	    case 'am':
	    case 'midnight':
	    case 'night':
	    default:
	      return 0;
	  }
	}
	function normalizeTwoDigitYear(twoDigitYear, currentYear) {
	  var isCommonEra = currentYear > 0;
	  // Absolute number of the current year:
	  // 1 -> 1 AC
	  // 0 -> 1 BC
	  // -1 -> 2 BC
	  var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
	  var result;
	  if (absCurrentYear <= 50) {
	    result = twoDigitYear || 100;
	  } else {
	    var rangeEnd = absCurrentYear + 50;
	    var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
	    var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
	    result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
	  }
	  return isCommonEra ? result : 1 - result;
	}
	function isLeapYearIndex(year) {
	  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
	}

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var BlockTree = __webpack_require__(1182);
	
	var ContentState = __webpack_require__(262);
	
	var EditorBidiService = __webpack_require__(1203);
	
	var SelectionState = __webpack_require__(191);
	
	var Immutable = __webpack_require__(27);
	
	var OrderedSet = Immutable.OrderedSet,
	    Record = Immutable.Record,
	    Stack = Immutable.Stack,
	    OrderedMap = Immutable.OrderedMap,
	    List = Immutable.List; // When configuring an editor, the user can chose to provide or not provide
	// basically all keys. `currentContent` varies, so this type doesn't include it.
	// (See the types defined below.)
	
	var defaultRecord = {
	  allowUndo: true,
	  currentContent: null,
	  decorator: null,
	  directionMap: null,
	  forceSelection: false,
	  inCompositionMode: false,
	  inlineStyleOverride: null,
	  lastChangeType: null,
	  nativelyRenderedContent: null,
	  redoStack: Stack(),
	  selection: null,
	  treeMap: null,
	  undoStack: Stack()
	};
	var EditorStateRecord = Record(defaultRecord);
	
	var EditorState = /*#__PURE__*/function () {
	  EditorState.createEmpty = function createEmpty(decorator) {
	    return this.createWithText('', decorator);
	  };
	
	  EditorState.createWithText = function createWithText(text, decorator) {
	    return EditorState.createWithContent(ContentState.createFromText(text), decorator);
	  };
	
	  EditorState.createWithContent = function createWithContent(contentState, decorator) {
	    if (contentState.getBlockMap().count() === 0) {
	      return EditorState.createEmpty(decorator);
	    }
	
	    var firstKey = contentState.getBlockMap().first().getKey();
	    return EditorState.create({
	      currentContent: contentState,
	      undoStack: Stack(),
	      redoStack: Stack(),
	      decorator: decorator || null,
	      selection: SelectionState.createEmpty(firstKey)
	    });
	  };
	
	  EditorState.create = function create(config) {
	    var currentContent = config.currentContent,
	        decorator = config.decorator;
	
	    var recordConfig = _objectSpread({}, config, {
	      treeMap: generateNewTreeMap(currentContent, decorator),
	      directionMap: EditorBidiService.getDirectionMap(currentContent)
	    });
	
	    return new EditorState(new EditorStateRecord(recordConfig));
	  };
	
	  EditorState.fromJS = function fromJS(config) {
	    return new EditorState(new EditorStateRecord(_objectSpread({}, config, {
	      directionMap: config.directionMap != null ? OrderedMap(config.directionMap) : config.directionMap,
	      inlineStyleOverride: config.inlineStyleOverride != null ? OrderedSet(config.inlineStyleOverride) : config.inlineStyleOverride,
	      nativelyRenderedContent: config.nativelyRenderedContent != null ? ContentState.fromJS(config.nativelyRenderedContent) : config.nativelyRenderedContent,
	      redoStack: config.redoStack != null ? Stack(config.redoStack.map(function (v) {
	        return ContentState.fromJS(v);
	      })) : config.redoStack,
	      selection: config.selection != null ? new SelectionState(config.selection) : config.selection,
	      treeMap: config.treeMap != null ? OrderedMap(config.treeMap).map(function (v) {
	        return List(v).map(function (v) {
	          return BlockTree.fromJS(v);
	        });
	      }) : config.treeMap,
	      undoStack: config.undoStack != null ? Stack(config.undoStack.map(function (v) {
	        return ContentState.fromJS(v);
	      })) : config.undoStack,
	      currentContent: ContentState.fromJS(config.currentContent)
	    })));
	  };
	
	  EditorState.set = function set(editorState, put) {
	    var map = editorState.getImmutable().withMutations(function (state) {
	      var existingDecorator = state.get('decorator');
	      var decorator = existingDecorator;
	
	      if (put.decorator === null) {
	        decorator = null;
	      } else if (put.decorator) {
	        decorator = put.decorator;
	      }
	
	      var newContent = put.currentContent || editorState.getCurrentContent();
	
	      if (decorator !== existingDecorator) {
	        var treeMap = state.get('treeMap');
	        var newTreeMap;
	
	        if (decorator && existingDecorator) {
	          newTreeMap = regenerateTreeForNewDecorator(newContent, newContent.getBlockMap(), treeMap, decorator, existingDecorator);
	        } else {
	          newTreeMap = generateNewTreeMap(newContent, decorator);
	        }
	
	        state.merge({
	          decorator: decorator,
	          treeMap: newTreeMap,
	          nativelyRenderedContent: null
	        });
	        return;
	      }
	
	      var existingContent = editorState.getCurrentContent();
	
	      if (newContent !== existingContent) {
	        state.set('treeMap', regenerateTreeForNewBlocks(editorState, newContent.getBlockMap(), newContent.getEntityMap(), decorator));
	      }
	
	      state.merge(put);
	    });
	    return new EditorState(map);
	  };
	
	  var _proto = EditorState.prototype;
	
	  _proto.toJS = function toJS() {
	    return this.getImmutable().toJS();
	  };
	
	  _proto.getAllowUndo = function getAllowUndo() {
	    return this.getImmutable().get('allowUndo');
	  };
	
	  _proto.getCurrentContent = function getCurrentContent() {
	    return this.getImmutable().get('currentContent');
	  };
	
	  _proto.getUndoStack = function getUndoStack() {
	    return this.getImmutable().get('undoStack');
	  };
	
	  _proto.getRedoStack = function getRedoStack() {
	    return this.getImmutable().get('redoStack');
	  };
	
	  _proto.getSelection = function getSelection() {
	    return this.getImmutable().get('selection');
	  };
	
	  _proto.getDecorator = function getDecorator() {
	    return this.getImmutable().get('decorator');
	  };
	
	  _proto.isInCompositionMode = function isInCompositionMode() {
	    return this.getImmutable().get('inCompositionMode');
	  };
	
	  _proto.mustForceSelection = function mustForceSelection() {
	    return this.getImmutable().get('forceSelection');
	  };
	
	  _proto.getNativelyRenderedContent = function getNativelyRenderedContent() {
	    return this.getImmutable().get('nativelyRenderedContent');
	  };
	
	  _proto.getLastChangeType = function getLastChangeType() {
	    return this.getImmutable().get('lastChangeType');
	  }
	  /**
	   * While editing, the user may apply inline style commands with a collapsed
	   * cursor, intending to type text that adopts the specified style. In this
	   * case, we track the specified style as an "override" that takes precedence
	   * over the inline style of the text adjacent to the cursor.
	   *
	   * If null, there is no override in place.
	   */
	  ;
	
	  _proto.getInlineStyleOverride = function getInlineStyleOverride() {
	    return this.getImmutable().get('inlineStyleOverride');
	  };
	
	  EditorState.setInlineStyleOverride = function setInlineStyleOverride(editorState, inlineStyleOverride) {
	    return EditorState.set(editorState, {
	      inlineStyleOverride: inlineStyleOverride
	    });
	  }
	  /**
	   * Get the appropriate inline style for the editor state. If an
	   * override is in place, use it. Otherwise, the current style is
	   * based on the location of the selection state.
	   */
	  ;
	
	  _proto.getCurrentInlineStyle = function getCurrentInlineStyle() {
	    var override = this.getInlineStyleOverride();
	
	    if (override != null) {
	      return override;
	    }
	
	    var content = this.getCurrentContent();
	    var selection = this.getSelection();
	
	    if (selection.isCollapsed()) {
	      return getInlineStyleForCollapsedSelection(content, selection);
	    }
	
	    return getInlineStyleForNonCollapsedSelection(content, selection);
	  };
	
	  _proto.getBlockTree = function getBlockTree(blockKey) {
	    return this.getImmutable().getIn(['treeMap', blockKey]);
	  };
	
	  _proto.isSelectionAtStartOfContent = function isSelectionAtStartOfContent() {
	    var firstKey = this.getCurrentContent().getBlockMap().first().getKey();
	    return this.getSelection().hasEdgeWithin(firstKey, 0, 0);
	  };
	
	  _proto.isSelectionAtEndOfContent = function isSelectionAtEndOfContent() {
	    var content = this.getCurrentContent();
	    var blockMap = content.getBlockMap();
	    var last = blockMap.last();
	    var end = last.getLength();
	    return this.getSelection().hasEdgeWithin(last.getKey(), end, end);
	  };
	
	  _proto.getDirectionMap = function getDirectionMap() {
	    return this.getImmutable().get('directionMap');
	  }
	  /**
	   * Incorporate native DOM selection changes into the EditorState. This
	   * method can be used when we simply want to accept whatever the DOM
	   * has given us to represent selection, and we do not need to re-render
	   * the editor.
	   *
	   * To forcibly move the DOM selection, see `EditorState.forceSelection`.
	   */
	  ;
	
	  EditorState.acceptSelection = function acceptSelection(editorState, selection) {
	    return updateSelection(editorState, selection, false);
	  }
	  /**
	   * At times, we need to force the DOM selection to be where we
	   * need it to be. This can occur when the anchor or focus nodes
	   * are non-text nodes, for instance. In this case, we want to trigger
	   * a re-render of the editor, which in turn forces selection into
	   * the correct place in the DOM. The `forceSelection` method
	   * accomplishes this.
	   *
	   * This method should be used in cases where you need to explicitly
	   * move the DOM selection from one place to another without a change
	   * in ContentState.
	   */
	  ;
	
	  EditorState.forceSelection = function forceSelection(editorState, selection) {
	    if (!selection.getHasFocus()) {
	      selection = selection.set('hasFocus', true);
	    }
	
	    return updateSelection(editorState, selection, true);
	  }
	  /**
	   * Move selection to the end of the editor without forcing focus.
	   */
	  ;
	
	  EditorState.moveSelectionToEnd = function moveSelectionToEnd(editorState) {
	    var content = editorState.getCurrentContent();
	    var lastBlock = content.getLastBlock();
	    var lastKey = lastBlock.getKey();
	    var length = lastBlock.getLength();
	    return EditorState.acceptSelection(editorState, new SelectionState({
	      anchorKey: lastKey,
	      anchorOffset: length,
	      focusKey: lastKey,
	      focusOffset: length,
	      isBackward: false
	    }));
	  }
	  /**
	   * Force focus to the end of the editor. This is useful in scenarios
	   * where we want to programmatically focus the input and it makes sense
	   * to allow the user to continue working seamlessly.
	   */
	  ;
	
	  EditorState.moveFocusToEnd = function moveFocusToEnd(editorState) {
	    var afterSelectionMove = EditorState.moveSelectionToEnd(editorState);
	    return EditorState.forceSelection(afterSelectionMove, afterSelectionMove.getSelection());
	  }
	  /**
	   * Push the current ContentState onto the undo stack if it should be
	   * considered a boundary state, and set the provided ContentState as the
	   * new current content.
	   */
	  ;
	
	  EditorState.push = function push(editorState, contentState, changeType) {
	    var forceSelection = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
	
	    if (editorState.getCurrentContent() === contentState) {
	      return editorState;
	    }
	
	    var directionMap = EditorBidiService.getDirectionMap(contentState, editorState.getDirectionMap());
	
	    if (!editorState.getAllowUndo()) {
	      return EditorState.set(editorState, {
	        currentContent: contentState,
	        directionMap: directionMap,
	        lastChangeType: changeType,
	        selection: contentState.getSelectionAfter(),
	        forceSelection: forceSelection,
	        inlineStyleOverride: null
	      });
	    }
	
	    var selection = editorState.getSelection();
	    var currentContent = editorState.getCurrentContent();
	    var undoStack = editorState.getUndoStack();
	    var newContent = contentState;
	
	    if (selection !== currentContent.getSelectionAfter() || mustBecomeBoundary(editorState, changeType)) {
	      undoStack = undoStack.push(currentContent);
	      newContent = newContent.set('selectionBefore', selection);
	    } else if (changeType === 'insert-characters' || changeType === 'backspace-character' || changeType === 'delete-character') {
	      // Preserve the previous selection.
	      newContent = newContent.set('selectionBefore', currentContent.getSelectionBefore());
	    }
	
	    var inlineStyleOverride = editorState.getInlineStyleOverride(); // Don't discard inline style overrides for the following change types:
	
	    var overrideChangeTypes = ['adjust-depth', 'change-block-type', 'split-block'];
	
	    if (overrideChangeTypes.indexOf(changeType) === -1) {
	      inlineStyleOverride = null;
	    }
	
	    var editorStateChanges = {
	      currentContent: newContent,
	      directionMap: directionMap,
	      undoStack: undoStack,
	      redoStack: Stack(),
	      lastChangeType: changeType,
	      selection: contentState.getSelectionAfter(),
	      forceSelection: forceSelection,
	      inlineStyleOverride: inlineStyleOverride
	    };
	    return EditorState.set(editorState, editorStateChanges);
	  }
	  /**
	   * Make the top ContentState in the undo stack the new current content and
	   * push the current content onto the redo stack.
	   */
	  ;
	
	  EditorState.undo = function undo(editorState) {
	    if (!editorState.getAllowUndo()) {
	      return editorState;
	    }
	
	    var undoStack = editorState.getUndoStack();
	    var newCurrentContent = undoStack.peek();
	
	    if (!newCurrentContent) {
	      return editorState;
	    }
	
	    var currentContent = editorState.getCurrentContent();
	    var directionMap = EditorBidiService.getDirectionMap(newCurrentContent, editorState.getDirectionMap());
	    return EditorState.set(editorState, {
	      currentContent: newCurrentContent,
	      directionMap: directionMap,
	      undoStack: undoStack.shift(),
	      redoStack: editorState.getRedoStack().push(currentContent),
	      forceSelection: true,
	      inlineStyleOverride: null,
	      lastChangeType: 'undo',
	      nativelyRenderedContent: null,
	      selection: currentContent.getSelectionBefore()
	    });
	  }
	  /**
	   * Make the top ContentState in the redo stack the new current content and
	   * push the current content onto the undo stack.
	   */
	  ;
	
	  EditorState.redo = function redo(editorState) {
	    if (!editorState.getAllowUndo()) {
	      return editorState;
	    }
	
	    var redoStack = editorState.getRedoStack();
	    var newCurrentContent = redoStack.peek();
	
	    if (!newCurrentContent) {
	      return editorState;
	    }
	
	    var currentContent = editorState.getCurrentContent();
	    var directionMap = EditorBidiService.getDirectionMap(newCurrentContent, editorState.getDirectionMap());
	    return EditorState.set(editorState, {
	      currentContent: newCurrentContent,
	      directionMap: directionMap,
	      undoStack: editorState.getUndoStack().push(currentContent),
	      redoStack: redoStack.shift(),
	      forceSelection: true,
	      inlineStyleOverride: null,
	      lastChangeType: 'redo',
	      nativelyRenderedContent: null,
	      selection: newCurrentContent.getSelectionAfter()
	    });
	  }
	  /**
	   * Not for public consumption.
	   */
	  ;
	
	  function EditorState(immutable) {
	    _defineProperty(this, "_immutable", void 0);
	
	    this._immutable = immutable;
	  }
	  /**
	   * Not for public consumption.
	   */
	
	
	  _proto.getImmutable = function getImmutable() {
	    return this._immutable;
	  };
	
	  return EditorState;
	}();
	/**
	 * Set the supplied SelectionState as the new current selection, and set
	 * the `force` flag to trigger manual selection placement by the view.
	 */
	
	
	function updateSelection(editorState, selection, forceSelection) {
	  return EditorState.set(editorState, {
	    selection: selection,
	    forceSelection: forceSelection,
	    nativelyRenderedContent: null,
	    inlineStyleOverride: null
	  });
	}
	/**
	 * Regenerate the entire tree map for a given ContentState and decorator.
	 * Returns an OrderedMap that maps all available ContentBlock objects.
	 */
	
	
	function generateNewTreeMap(contentState, decorator) {
	  return contentState.getBlockMap().map(function (block) {
	    return BlockTree.generate(contentState, block, decorator);
	  }).toOrderedMap();
	}
	/**
	 * Regenerate tree map objects for all ContentBlocks that have changed
	 * between the current editorState and newContent. Returns an OrderedMap
	 * with only changed regenerated tree map objects.
	 */
	
	
	function regenerateTreeForNewBlocks(editorState, newBlockMap, newEntityMap, decorator) {
	  var contentState = editorState.getCurrentContent().set('entityMap', newEntityMap);
	  var prevBlockMap = contentState.getBlockMap();
	  var prevTreeMap = editorState.getImmutable().get('treeMap');
	  return prevTreeMap.merge(newBlockMap.toSeq().filter(function (block, key) {
	    return block !== prevBlockMap.get(key);
	  }).map(function (block) {
	    return BlockTree.generate(contentState, block, decorator);
	  }));
	}
	/**
	 * Generate tree map objects for a new decorator object, preserving any
	 * decorations that are unchanged from the previous decorator.
	 *
	 * Note that in order for this to perform optimally, decoration Lists for
	 * decorators should be preserved when possible to allow for direct immutable
	 * List comparison.
	 */
	
	
	function regenerateTreeForNewDecorator(content, blockMap, previousTreeMap, decorator, existingDecorator) {
	  return previousTreeMap.merge(blockMap.toSeq().filter(function (block) {
	    return decorator.getDecorations(block, content) !== existingDecorator.getDecorations(block, content);
	  }).map(function (block) {
	    return BlockTree.generate(content, block, decorator);
	  }));
	}
	/**
	 * Return whether a change should be considered a boundary state, given
	 * the previous change type. Allows us to discard potential boundary states
	 * during standard typing or deletion behavior.
	 */
	
	
	function mustBecomeBoundary(editorState, changeType) {
	  var lastChangeType = editorState.getLastChangeType();
	  return changeType !== lastChangeType || changeType !== 'insert-characters' && changeType !== 'backspace-character' && changeType !== 'delete-character';
	}
	
	function getInlineStyleForCollapsedSelection(content, selection) {
	  var startKey = selection.getStartKey();
	  var startOffset = selection.getStartOffset();
	  var startBlock = content.getBlockForKey(startKey); // If the cursor is not at the start of the block, look backward to
	  // preserve the style of the preceding character.
	
	  if (startOffset > 0) {
	    return startBlock.getInlineStyleAt(startOffset - 1);
	  } // The caret is at position zero in this block. If the block has any
	  // text at all, use the style of the first character.
	
	
	  if (startBlock.getLength()) {
	    return startBlock.getInlineStyleAt(0);
	  } // Otherwise, look upward in the document to find the closest character.
	
	
	  return lookUpwardForInlineStyle(content, startKey);
	}
	
	function getInlineStyleForNonCollapsedSelection(content, selection) {
	  var startKey = selection.getStartKey();
	  var startOffset = selection.getStartOffset();
	  var startBlock = content.getBlockForKey(startKey); // If there is a character just inside the selection, use its style.
	
	  if (startOffset < startBlock.getLength()) {
	    return startBlock.getInlineStyleAt(startOffset);
	  } // Check if the selection at the end of a non-empty block. Use the last
	  // style in the block.
	
	
	  if (startOffset > 0) {
	    return startBlock.getInlineStyleAt(startOffset - 1);
	  } // Otherwise, look upward in the document to find the closest character.
	
	
	  return lookUpwardForInlineStyle(content, startKey);
	}
	
	function lookUpwardForInlineStyle(content, fromKey) {
	  var lastNonEmpty = content.getBlockMap().reverse().skipUntil(function (_, k) {
	    return k === fromKey;
	  }).skip(1).skipUntil(function (block, _) {
	    return block.getLength();
	  }).first();
	
	  if (lastNonEmpty) {
	    return lastNonEmpty.getInlineStyleAt(lastNonEmpty.getLength() - 1);
	  }
	
	  return OrderedSet();
	}
	
	module.exports = EditorState;

/***/ },
/* 37 */
/***/ function(module, exports) {

	function e(r){var o,t,f="";if("string"==typeof r||"number"==typeof r)f+=r;else if("object"==typeof r)if(Array.isArray(r))for(o=0;o<r.length;o++)r[o]&&(t=e(r[o]))&&(f&&(f+=" "),f+=t);else for(o in r)r[o]&&(f&&(f+=" "),f+=o);return f}function r(){for(var r,o,t=0,f="";t<arguments.length;)(r=arguments[t++])&&(o=e(r))&&(f&&(f+=" "),f+=o);return f}module.exports=r,module.exports.clsx=r;

/***/ },
/* 38 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	function objectToGetParams(object) {
	    var params = Object.entries(object)
	        .filter(function (_a) {
	        var value = _a[1];
	        return value !== undefined && value !== null;
	    })
	        .map(function (_a) {
	        var key = _a[0], value = _a[1];
	        return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(String(value)));
	    });
	    return params.length > 0 ? "?".concat(params.join('&')) : '';
	}
	exports.default = objectToGetParams;


/***/ },
/* 39 */
/***/ function(module, exports) {

	function _getPrototypeOf(t) {
	  return (module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
	    return t.__proto__ || Object.getPrototypeOf(t);
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _getPrototypeOf(t);
	}
	module.exports = _getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	var _typeof = __webpack_require__(56)["default"];
	var assertThisInitialized = __webpack_require__(12);
	function _possibleConstructorReturn(t, e) {
	  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
	  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
	  return assertThisInitialized(t);
	}
	module.exports = _possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _styles = __webpack_require__(80);
	
	var _defaultTheme = _interopRequireDefault(__webpack_require__(142));
	
	function withStyles(stylesOrCreator, options) {
	  return (0, _styles.withStyles)(stylesOrCreator, (0, _extends2.default)({
	    defaultTheme: _defaultTheme.default
	  }, options));
	}
	
	var _default = withStyles;
	exports.default = _default;

/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(setImmediate) {"use strict";
	
	var support = __webpack_require__(98);
	var base64 = __webpack_require__(440);
	var nodejsUtils = __webpack_require__(201);
	var external = __webpack_require__(159);
	__webpack_require__(306);
	
	
	/**
	 * Convert a string that pass as a "binary string": it should represent a byte
	 * array but may have > 255 char codes. Be sure to take only the first byte
	 * and returns the byte array.
	 * @param {String} str the string to transform.
	 * @return {Array|Uint8Array} the string in a binary format.
	 */
	function string2binary(str) {
	    var result = null;
	    if (support.uint8array) {
	        result = new Uint8Array(str.length);
	    } else {
	        result = new Array(str.length);
	    }
	    return stringToArrayLike(str, result);
	}
	
	/**
	 * Create a new blob with the given content and the given type.
	 * @param {String|ArrayBuffer} part the content to put in the blob. DO NOT use
	 * an Uint8Array because the stock browser of android 4 won't accept it (it
	 * will be silently converted to a string, "[object Uint8Array]").
	 *
	 * Use only ONE part to build the blob to avoid a memory leak in IE11 / Edge:
	 * when a large amount of Array is used to create the Blob, the amount of
	 * memory consumed is nearly 100 times the original data amount.
	 *
	 * @param {String} type the mime type of the blob.
	 * @return {Blob} the created blob.
	 */
	exports.newBlob = function(part, type) {
	    exports.checkSupport("blob");
	
	    try {
	        // Blob constructor
	        return new Blob([part], {
	            type: type
	        });
	    }
	    catch (e) {
	
	        try {
	            // deprecated, browser only, old way
	            var Builder = self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder;
	            var builder = new Builder();
	            builder.append(part);
	            return builder.getBlob(type);
	        }
	        catch (e) {
	
	            // well, fuck ?!
	            throw new Error("Bug : can't construct the Blob.");
	        }
	    }
	
	
	};
	/**
	 * The identity function.
	 * @param {Object} input the input.
	 * @return {Object} the same input.
	 */
	function identity(input) {
	    return input;
	}
	
	/**
	 * Fill in an array with a string.
	 * @param {String} str the string to use.
	 * @param {Array|ArrayBuffer|Uint8Array|Buffer} array the array to fill in (will be mutated).
	 * @return {Array|ArrayBuffer|Uint8Array|Buffer} the updated array.
	 */
	function stringToArrayLike(str, array) {
	    for (var i = 0; i < str.length; ++i) {
	        array[i] = str.charCodeAt(i) & 0xFF;
	    }
	    return array;
	}
	
	/**
	 * An helper for the function arrayLikeToString.
	 * This contains static information and functions that
	 * can be optimized by the browser JIT compiler.
	 */
	var arrayToStringHelper = {
	    /**
	     * Transform an array of int into a string, chunk by chunk.
	     * See the performances notes on arrayLikeToString.
	     * @param {Array|ArrayBuffer|Uint8Array|Buffer} array the array to transform.
	     * @param {String} type the type of the array.
	     * @param {Integer} chunk the chunk size.
	     * @return {String} the resulting string.
	     * @throws Error if the chunk is too big for the stack.
	     */
	    stringifyByChunk: function(array, type, chunk) {
	        var result = [], k = 0, len = array.length;
	        // shortcut
	        if (len <= chunk) {
	            return String.fromCharCode.apply(null, array);
	        }
	        while (k < len) {
	            if (type === "array" || type === "nodebuffer") {
	                result.push(String.fromCharCode.apply(null, array.slice(k, Math.min(k + chunk, len))));
	            }
	            else {
	                result.push(String.fromCharCode.apply(null, array.subarray(k, Math.min(k + chunk, len))));
	            }
	            k += chunk;
	        }
	        return result.join("");
	    },
	    /**
	     * Call String.fromCharCode on every item in the array.
	     * This is the naive implementation, which generate A LOT of intermediate string.
	     * This should be used when everything else fail.
	     * @param {Array|ArrayBuffer|Uint8Array|Buffer} array the array to transform.
	     * @return {String} the result.
	     */
	    stringifyByChar: function(array){
	        var resultStr = "";
	        for(var i = 0; i < array.length; i++) {
	            resultStr += String.fromCharCode(array[i]);
	        }
	        return resultStr;
	    },
	    applyCanBeUsed : {
	        /**
	         * true if the browser accepts to use String.fromCharCode on Uint8Array
	         */
	        uint8array : (function () {
	            try {
	                return support.uint8array && String.fromCharCode.apply(null, new Uint8Array(1)).length === 1;
	            } catch (e) {
	                return false;
	            }
	        })(),
	        /**
	         * true if the browser accepts to use String.fromCharCode on nodejs Buffer.
	         */
	        nodebuffer : (function () {
	            try {
	                return support.nodebuffer && String.fromCharCode.apply(null, nodejsUtils.allocBuffer(1)).length === 1;
	            } catch (e) {
	                return false;
	            }
	        })()
	    }
	};
	
	/**
	 * Transform an array-like object to a string.
	 * @param {Array|ArrayBuffer|Uint8Array|Buffer} array the array to transform.
	 * @return {String} the result.
	 */
	function arrayLikeToString(array) {
	    // Performances notes :
	    // --------------------
	    // String.fromCharCode.apply(null, array) is the fastest, see
	    // see http://jsperf.com/converting-a-uint8array-to-a-string/2
	    // but the stack is limited (and we can get huge arrays !).
	    //
	    // result += String.fromCharCode(array[i]); generate too many strings !
	    //
	    // This code is inspired by http://jsperf.com/arraybuffer-to-string-apply-performance/2
	    // TODO : we now have workers that split the work. Do we still need that ?
	    var chunk = 65536,
	        type = exports.getTypeOf(array),
	        canUseApply = true;
	    if (type === "uint8array") {
	        canUseApply = arrayToStringHelper.applyCanBeUsed.uint8array;
	    } else if (type === "nodebuffer") {
	        canUseApply = arrayToStringHelper.applyCanBeUsed.nodebuffer;
	    }
	
	    if (canUseApply) {
	        while (chunk > 1) {
	            try {
	                return arrayToStringHelper.stringifyByChunk(array, type, chunk);
	            } catch (e) {
	                chunk = Math.floor(chunk / 2);
	            }
	        }
	    }
	
	    // no apply or chunk error : slow and painful algorithm
	    // default browser on android 4.*
	    return arrayToStringHelper.stringifyByChar(array);
	}
	
	exports.applyFromCharCode = arrayLikeToString;
	
	
	/**
	 * Copy the data from an array-like to an other array-like.
	 * @param {Array|ArrayBuffer|Uint8Array|Buffer} arrayFrom the origin array.
	 * @param {Array|ArrayBuffer|Uint8Array|Buffer} arrayTo the destination array which will be mutated.
	 * @return {Array|ArrayBuffer|Uint8Array|Buffer} the updated destination array.
	 */
	function arrayLikeToArrayLike(arrayFrom, arrayTo) {
	    for (var i = 0; i < arrayFrom.length; i++) {
	        arrayTo[i] = arrayFrom[i];
	    }
	    return arrayTo;
	}
	
	// a matrix containing functions to transform everything into everything.
	var transform = {};
	
	// string to ?
	transform["string"] = {
	    "string": identity,
	    "array": function(input) {
	        return stringToArrayLike(input, new Array(input.length));
	    },
	    "arraybuffer": function(input) {
	        return transform["string"]["uint8array"](input).buffer;
	    },
	    "uint8array": function(input) {
	        return stringToArrayLike(input, new Uint8Array(input.length));
	    },
	    "nodebuffer": function(input) {
	        return stringToArrayLike(input, nodejsUtils.allocBuffer(input.length));
	    }
	};
	
	// array to ?
	transform["array"] = {
	    "string": arrayLikeToString,
	    "array": identity,
	    "arraybuffer": function(input) {
	        return (new Uint8Array(input)).buffer;
	    },
	    "uint8array": function(input) {
	        return new Uint8Array(input);
	    },
	    "nodebuffer": function(input) {
	        return nodejsUtils.newBufferFrom(input);
	    }
	};
	
	// arraybuffer to ?
	transform["arraybuffer"] = {
	    "string": function(input) {
	        return arrayLikeToString(new Uint8Array(input));
	    },
	    "array": function(input) {
	        return arrayLikeToArrayLike(new Uint8Array(input), new Array(input.byteLength));
	    },
	    "arraybuffer": identity,
	    "uint8array": function(input) {
	        return new Uint8Array(input);
	    },
	    "nodebuffer": function(input) {
	        return nodejsUtils.newBufferFrom(new Uint8Array(input));
	    }
	};
	
	// uint8array to ?
	transform["uint8array"] = {
	    "string": arrayLikeToString,
	    "array": function(input) {
	        return arrayLikeToArrayLike(input, new Array(input.length));
	    },
	    "arraybuffer": function(input) {
	        return input.buffer;
	    },
	    "uint8array": identity,
	    "nodebuffer": function(input) {
	        return nodejsUtils.newBufferFrom(input);
	    }
	};
	
	// nodebuffer to ?
	transform["nodebuffer"] = {
	    "string": arrayLikeToString,
	    "array": function(input) {
	        return arrayLikeToArrayLike(input, new Array(input.length));
	    },
	    "arraybuffer": function(input) {
	        return transform["nodebuffer"]["uint8array"](input).buffer;
	    },
	    "uint8array": function(input) {
	        return arrayLikeToArrayLike(input, new Uint8Array(input.length));
	    },
	    "nodebuffer": identity
	};
	
	/**
	 * Transform an input into any type.
	 * The supported output type are : string, array, uint8array, arraybuffer, nodebuffer.
	 * If no output type is specified, the unmodified input will be returned.
	 * @param {String} outputType the output type.
	 * @param {String|Array|ArrayBuffer|Uint8Array|Buffer} input the input to convert.
	 * @throws {Error} an Error if the browser doesn't support the requested output type.
	 */
	exports.transformTo = function(outputType, input) {
	    if (!input) {
	        // undefined, null, etc
	        // an empty string won't harm.
	        input = "";
	    }
	    if (!outputType) {
	        return input;
	    }
	    exports.checkSupport(outputType);
	    var inputType = exports.getTypeOf(input);
	    var result = transform[inputType][outputType](input);
	    return result;
	};
	
	/**
	 * Resolve all relative path components, "." and "..", in a path. If these relative components
	 * traverse above the root then the resulting path will only contain the final path component.
	 *
	 * All empty components, e.g. "//", are removed.
	 * @param {string} path A path with / or \ separators
	 * @returns {string} The path with all relative path components resolved.
	 */
	exports.resolve = function(path) {
	    var parts = path.split("/");
	    var result = [];
	    for (var index = 0; index < parts.length; index++) {
	        var part = parts[index];
	        // Allow the first and last component to be empty for trailing slashes.
	        if (part === "." || (part === "" && index !== 0 && index !== parts.length - 1)) {
	            continue;
	        } else if (part === "..") {
	            result.pop();
	        } else {
	            result.push(part);
	        }
	    }
	    return result.join("/");
	};
	
	/**
	 * Return the type of the input.
	 * The type will be in a format valid for JSZip.utils.transformTo : string, array, uint8array, arraybuffer.
	 * @param {Object} input the input to identify.
	 * @return {String} the (lowercase) type of the input.
	 */
	exports.getTypeOf = function(input) {
	    if (typeof input === "string") {
	        return "string";
	    }
	    if (Object.prototype.toString.call(input) === "[object Array]") {
	        return "array";
	    }
	    if (support.nodebuffer && nodejsUtils.isBuffer(input)) {
	        return "nodebuffer";
	    }
	    if (support.uint8array && input instanceof Uint8Array) {
	        return "uint8array";
	    }
	    if (support.arraybuffer && input instanceof ArrayBuffer) {
	        return "arraybuffer";
	    }
	};
	
	/**
	 * Throw an exception if the type is not supported.
	 * @param {String} type the type to check.
	 * @throws {Error} an Error if the browser doesn't support the requested type.
	 */
	exports.checkSupport = function(type) {
	    var supported = support[type.toLowerCase()];
	    if (!supported) {
	        throw new Error(type + " is not supported by this platform");
	    }
	};
	
	exports.MAX_VALUE_16BITS = 65535;
	exports.MAX_VALUE_32BITS = -1; // well, "\xFF\xFF\xFF\xFF\xFF\xFF\xFF\xFF" is parsed as -1
	
	/**
	 * Prettify a string read as binary.
	 * @param {string} str the string to prettify.
	 * @return {string} a pretty string.
	 */
	exports.pretty = function(str) {
	    var res = "",
	        code, i;
	    for (i = 0; i < (str || "").length; i++) {
	        code = str.charCodeAt(i);
	        res += "\\x" + (code < 16 ? "0" : "") + code.toString(16).toUpperCase();
	    }
	    return res;
	};
	
	/**
	 * Defer the call of a function.
	 * @param {Function} callback the function to call asynchronously.
	 * @param {Array} args the arguments to give to the callback.
	 */
	exports.delay = function(callback, args, self) {
	    setImmediate(function () {
	        callback.apply(self || null, args || []);
	    });
	};
	
	/**
	 * Extends a prototype with an other, without calling a constructor with
	 * side effects. Inspired by nodejs' `utils.inherits`
	 * @param {Function} ctor the constructor to augment
	 * @param {Function} superCtor the parent constructor to use
	 */
	exports.inherits = function (ctor, superCtor) {
	    var Obj = function() {};
	    Obj.prototype = superCtor.prototype;
	    ctor.prototype = new Obj();
	};
	
	/**
	 * Merge the objects passed as parameters into a new one.
	 * @private
	 * @param {...Object} var_args All objects to merge.
	 * @return {Object} a new object with the data of the others.
	 */
	exports.extend = function() {
	    var result = {}, i, attr;
	    for (i = 0; i < arguments.length; i++) { // arguments is not enumerable in some browsers
	        for (attr in arguments[i]) {
	            if (Object.prototype.hasOwnProperty.call(arguments[i], attr) && typeof result[attr] === "undefined") {
	                result[attr] = arguments[i][attr];
	            }
	        }
	    }
	    return result;
	};
	
	/**
	 * Transform arbitrary content into a Promise.
	 * @param {String} name a name for the content being processed.
	 * @param {Object} inputData the content to process.
	 * @param {Boolean} isBinary true if the content is not an unicode string
	 * @param {Boolean} isOptimizedBinaryString true if the string content only has one byte per character.
	 * @param {Boolean} isBase64 true if the string content is encoded with base64.
	 * @return {Promise} a promise in a format usable by JSZip.
	 */
	exports.prepareContent = function(name, inputData, isBinary, isOptimizedBinaryString, isBase64) {
	
	    // if inputData is already a promise, this flatten it.
	    var promise = external.Promise.resolve(inputData).then(function(data) {
	
	
	        var isBlob = support.blob && (data instanceof Blob || ["[object File]", "[object Blob]"].indexOf(Object.prototype.toString.call(data)) !== -1);
	
	        if (isBlob && typeof FileReader !== "undefined") {
	            return new external.Promise(function (resolve, reject) {
	                var reader = new FileReader();
	
	                reader.onload = function(e) {
	                    resolve(e.target.result);
	                };
	                reader.onerror = function(e) {
	                    reject(e.target.error);
	                };
	                reader.readAsArrayBuffer(data);
	            });
	        } else {
	            return data;
	        }
	    });
	
	    return promise.then(function(data) {
	        var dataType = exports.getTypeOf(data);
	
	        if (!dataType) {
	            return external.Promise.reject(
	                new Error("Can't read the data of '" + name + "'. Is it " +
	                          "in a supported JavaScript type (String, Blob, ArrayBuffer, etc) ?")
	            );
	        }
	        // special case : it's way easier to work with Uint8Array than with ArrayBuffer
	        if (dataType === "arraybuffer") {
	            data = exports.transformTo("uint8array", data);
	        } else if (dataType === "string") {
	            if (isBase64) {
	                data = base64.decode(data);
	            }
	            else if (isBinary) {
	                // optimizedBinaryString === true means that the file has already been filtered with a 0xFF mask
	                if (isOptimizedBinaryString !== true) {
	                    // this is a string, not in a base64 format.
	                    // Be sure that this is a correct "binary string"
	                    data = string2binary(data);
	                }
	            }
	        }
	        return data;
	    });
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(214).setImmediate))

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function checkDCE() {
	  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
	  if (
	    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
	    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
	  ) {
	    return;
	  }
	  if (false) {
	    // This branch is unreachable because this function is only called
	    // in production, but the condition is true only in development.
	    // Therefore if the branch is still here, dead code elimination wasn't
	    // properly applied.
	    // Don't change the message. React DevTools relies on it. Also make sure
	    // this message doesn't occur elsewhere in this function, or it will cause
	    // a false positive.
	    throw new Error('^_^');
	  }
	  try {
	    // Verify that the code above has been dead code eliminated (DCE'd).
	    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
	  } catch (err) {
	    // DevTools shouldn't crash React, no matter what.
	    // We should still report in case we break this code.
	    console.error(err);
	  }
	}
	
	if (true) {
	  // DCE check should happen before ReactDOM bundle executes so that
	  // DevTools can report bad minification during injection.
	  checkDCE();
	  module.exports = __webpack_require__(1376);
	} else {
	  module.exports = require('./cjs/react-dom.development.js');
	}


/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var NATIVE_BIND = __webpack_require__(205);
	
	var FunctionPrototype = Function.prototype;
	var call = FunctionPrototype.call;
	// eslint-disable-next-line es/no-function-prototype-bind -- safe
	var uncurryThisWithBind = NATIVE_BIND && FunctionPrototype.bind.bind(call, call);
	
	module.exports = NATIVE_BIND ? uncurryThisWithBind : function (fn) {
	  return function () {
	    return call.apply(fn, arguments);
	  };
	};


/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	var __rest = (this && this.__rest) || function (s, e) {
	    var t = {};
	    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
	        t[p] = s[p];
	    if (s != null && typeof Object.getOwnPropertySymbols === "function")
	        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
	                t[p[i]] = s[p[i]];
	        }
	    return t;
	};
	var __importDefault = (this && this.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var react_1 = __importDefault(__webpack_require__(1));
	function createIcon(iconConfig) {
	    var Icon = function (_a) {
	        var bgStyle = _a.bgStyle, borderRadius = _a.borderRadius, iconFillColor = _a.iconFillColor, round = _a.round, size = _a.size, rest = __rest(_a, ["bgStyle", "borderRadius", "iconFillColor", "round", "size"]);
	        return (react_1.default.createElement("svg", __assign({ viewBox: "0 0 64 64", width: size, height: size }, rest),
	            round ? (react_1.default.createElement("circle", { cx: "32", cy: "32", r: "31", fill: iconConfig.color, style: bgStyle })) : (react_1.default.createElement("rect", { width: "64", height: "64", rx: borderRadius, ry: borderRadius, fill: iconConfig.color, style: bgStyle })),
	            react_1.default.createElement("path", { d: iconConfig.path, fill: iconFillColor })));
	    };
	    Icon.defaultProps = {
	        bgStyle: {},
	        borderRadius: 0,
	        iconFillColor: 'white',
	        size: 64,
	    };
	    return Icon;
	}
	exports.default = createIcon;


/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (this && this.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __importDefault = (this && this.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var react_1 = __importStar(__webpack_require__(1));
	var ShareButton_1 = __importDefault(__webpack_require__(1490));
	function createShareButton(networkName, link, optsMap, defaultProps) {
	    function CreatedButton(props, ref) {
	        var opts = optsMap(props);
	        var passedProps = __assign({}, props);
	        // remove keys from passed props that are passed as opts
	        var optsKeys = Object.keys(opts);
	        optsKeys.forEach(function (key) {
	            delete passedProps[key];
	        });
	        return (react_1.default.createElement(ShareButton_1.default, __assign({}, defaultProps, passedProps, { forwardedRef: ref, networkName: networkName, networkLink: link, opts: optsMap(props) })));
	    }
	    CreatedButton.displayName = "ShareButton-".concat(networkName);
	    return (0, react_1.forwardRef)(CreatedButton);
	}
	exports.default = createShareButton;


/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	var defineProperty = __webpack_require__(24);
	function _objectSpread(e) {
	  for (var r = 1; r < arguments.length; r++) {
	    var t = null != arguments[r] ? Object(arguments[r]) : {},
	      o = Object.keys(t);
	    "function" == typeof Object.getOwnPropertySymbols && o.push.apply(o, Object.getOwnPropertySymbols(t).filter(function (e) {
	      return Object.getOwnPropertyDescriptor(t, e).enumerable;
	    })), o.forEach(function (r) {
	      defineProperty(e, r, t[r]);
	    });
	  }
	  return e;
	}
	module.exports = _objectSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/bewiseloading.a03e9765.gif";

/***/ },
/* 49 */
/***/ function(module, exports) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        if (typeof b !== "function" && b !== null)
	            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var AssertionError = /** @class */ (function (_super) {
	    __extends(AssertionError, _super);
	    function AssertionError(message) {
	        var _this = _super.call(this, message) || this;
	        _this.name = 'AssertionError';
	        return _this;
	    }
	    return AssertionError;
	}(Error));
	function assert(value, message) {
	    if (!value) {
	        throw new AssertionError(message);
	    }
	}
	exports.default = assert;


/***/ },
/* 50 */
/***/ function(module, exports) {

	'use strict';
	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (error) {
	    return true;
	  }
	};


/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var uncurryThis = __webpack_require__(44);
	var toObject = __webpack_require__(167);
	
	var hasOwnProperty = uncurryThis({}.hasOwnProperty);
	
	// `HasOwnProperty` abstract operation
	// https://tc39.es/ecma262/#sec-hasownproperty
	// eslint-disable-next-line es/no-object-hasown -- safe
	module.exports = Object.hasOwn || function hasOwn(it, key) {
	  return hasOwnProperty(toObject(it), key);
	};


/***/ },
/* 52 */
/***/ function(module, exports) {

	'use strict';
	// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
	var documentAll = typeof document == 'object' && document.all;
	
	// `IsCallable` abstract operation
	// https://tc39.es/ecma262/#sec-iscallable
	// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
	module.exports = typeof documentAll == 'undefined' && documentAll !== undefined ? function (argument) {
	  return typeof argument == 'function' || argument === documentAll;
	} : function (argument) {
	  return typeof argument == 'function';
	};


/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var React=__webpack_require__(1),styled=__webpack_require__(1624);function _interopDefaultLegacy(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var React__default=_interopDefaultLegacy(React),styled__default=_interopDefaultLegacy(styled);function _typeof(e){return(_typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function _defineProperty(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}function _extends(){return(_extends=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n,r=arguments[t];for(n in r)Object.prototype.hasOwnProperty.call(r,n)&&(e[n]=r[n])}return e}).apply(this,arguments)}function ownKeys(t,e){var n,r=Object.keys(t);return Object.getOwnPropertySymbols&&(n=Object.getOwnPropertySymbols(t),e&&(n=n.filter(function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable})),r.push.apply(r,n)),r}function _objectSpread2(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?ownKeys(Object(n),!0).forEach(function(e){_defineProperty(t,e,n[e])}):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):ownKeys(Object(n)).forEach(function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))})}return t}function _taggedTemplateLiteral(e,t){return t=t||e.slice(0),Object.freeze(Object.defineProperties(e,{raw:{value:Object.freeze(t)}}))}function _slicedToArray(e,t){return _arrayWithHoles(e)||_iterableToArrayLimit(e,t)||_unsupportedIterableToArray(e,t)||_nonIterableRest()}function _toConsumableArray(e){return _arrayWithoutHoles(e)||_iterableToArray(e)||_unsupportedIterableToArray(e)||_nonIterableSpread()}function _arrayWithoutHoles(e){if(Array.isArray(e))return _arrayLikeToArray(e)}function _arrayWithHoles(e){if(Array.isArray(e))return e}function _iterableToArray(e){if("undefined"!=typeof Symbol&&Symbol.iterator in Object(e))return Array.from(e)}function _iterableToArrayLimit(e,t){if("undefined"!=typeof Symbol&&Symbol.iterator in Object(e)){var n=[],r=!0,o=!1,a=void 0;try{for(var l,i=e[Symbol.iterator]();!(r=(l=i.next()).done)&&(n.push(l.value),!t||n.length!==t);r=!0);}catch(e){o=!0,a=e}finally{try{r||null==i.return||i.return()}finally{if(o)throw a}}return n}}function _unsupportedIterableToArray(e,t){if(e){if("string"==typeof e)return _arrayLikeToArray(e,t);var n=Object.prototype.toString.call(e).slice(8,-1);return"Object"===n&&e.constructor&&(n=e.constructor.name),"Map"===n||"Set"===n?Array.from(e):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?_arrayLikeToArray(e,t):void 0}}function _arrayLikeToArray(e,t){(null==t||t>e.length)&&(t=e.length);for(var n=0,r=new Array(t);n<t;n++)r[n]=e[n];return r}function _nonIterableSpread(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}function _nonIterableRest(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}var commonjsGlobal="undefined"!=typeof globalThis?globalThis:"undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{};function createCommonjsModule(e,t){return e(t={exports:{}},t.exports),t.exports}var b="function"==typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;function z(o){if("object"==typeof o&&null!==o){var a=o.$$typeof;switch(a){case c:switch(o=o.type){case l:case m:case e:case g:case f:case p:return o;default:switch(o=o&&o.$$typeof){case k:case n:case t:case r:case h:return o;default:return a}}case d:return a}}}function A(e){return z(e)===m}var AsyncMode=l,ConcurrentMode=m,ContextConsumer=k,ContextProvider=h,Element=c,ForwardRef=n,Fragment=e,Lazy=t,Memo=r,Portal=d,Profiler=g,StrictMode=f,Suspense=p,isAsyncMode=function(e){return A(e)||z(e)===l},isConcurrentMode=A,isContextConsumer=function(e){return z(e)===k},isContextProvider=function(e){return z(e)===h},isElement=function(e){return"object"==typeof e&&null!==e&&e.$$typeof===c},isForwardRef=function(e){return z(e)===n},isFragment=function(t){return z(t)===e},isLazy=function(e){return z(e)===t},isMemo=function(e){return z(e)===r},isPortal=function(e){return z(e)===d},isProfiler=function(e){return z(e)===g},isStrictMode=function(e){return z(e)===f},isSuspense=function(e){return z(e)===p},isValidElementType=function(o){return"string"==typeof o||"function"==typeof o||o===e||o===m||o===g||o===f||o===p||o===q||"object"==typeof o&&null!==o&&(o.$$typeof===t||o.$$typeof===r||o.$$typeof===h||o.$$typeof===k||o.$$typeof===n||o.$$typeof===w||o.$$typeof===x||o.$$typeof===y||o.$$typeof===v)},typeOf=z,reactIs_production_min={AsyncMode:l,ConcurrentMode:m,ContextConsumer:k,ContextProvider:h,Element:c,ForwardRef:n,Fragment:e,Lazy:t,Memo:r,Portal:d,Profiler:g,StrictMode:f,Suspense:p,isAsyncMode:isAsyncMode,isConcurrentMode:A,isContextConsumer:isContextConsumer,isContextProvider:isContextProvider,isElement:isElement,isForwardRef:isForwardRef,isFragment:isFragment,isLazy:isLazy,isMemo:isMemo,isPortal:isPortal,isProfiler:isProfiler,isStrictMode:isStrictMode,isSuspense:isSuspense,isValidElementType:isValidElementType,typeOf:z},reactIs_development=createCommonjsModule(function(e,t){function n(e){if("object"==typeof e&&null!==e){var t=e.$$typeof;switch(t){case a:e=e.type;switch(e){case d:case f:case i:case u:case c:case b:return e;default:e=e&&e.$$typeof;switch(e){case p:case y:case _:case g:case s:return e;default:return t}}case l:return t}}}function r(e){return n(e)===f}var o,a,l,i,c,u,s,p,d,f,y,b,m,g,_,h,v,T,w,R,x,O,S,C,j,E,P,$,I,k,A;"production"!==("production")&&(o="function"==typeof Symbol&&Symbol.for,a=o?Symbol.for("react.element"):60103,l=o?Symbol.for("react.portal"):60106,i=o?Symbol.for("react.fragment"):60107,c=o?Symbol.for("react.strict_mode"):60108,u=o?Symbol.for("react.profiler"):60114,s=o?Symbol.for("react.provider"):60109,p=o?Symbol.for("react.context"):60110,d=o?Symbol.for("react.async_mode"):60111,f=o?Symbol.for("react.concurrent_mode"):60111,y=o?Symbol.for("react.forward_ref"):60112,b=o?Symbol.for("react.suspense"):60113,m=o?Symbol.for("react.suspense_list"):60120,g=o?Symbol.for("react.memo"):60115,_=o?Symbol.for("react.lazy"):60116,h=o?Symbol.for("react.block"):60121,v=o?Symbol.for("react.fundamental"):60117,T=o?Symbol.for("react.responder"):60118,w=o?Symbol.for("react.scope"):60119,R=f,x=p,O=s,S=a,C=y,j=i,E=_,P=g,$=l,I=u,k=c,o=b,A=!1,t.AsyncMode=d,t.ConcurrentMode=R,t.ContextConsumer=x,t.ContextProvider=O,t.Element=S,t.ForwardRef=C,t.Fragment=j,t.Lazy=E,t.Memo=P,t.Portal=$,t.Profiler=I,t.StrictMode=k,t.Suspense=o,t.isAsyncMode=function(e){return A||(A=!0,console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")),r(e)||n(e)===d},t.isConcurrentMode=r,t.isContextConsumer=function(e){return n(e)===p},t.isContextProvider=function(e){return n(e)===s},t.isElement=function(e){return"object"==typeof e&&null!==e&&e.$$typeof===a},t.isForwardRef=function(e){return n(e)===y},t.isFragment=function(e){return n(e)===i},t.isLazy=function(e){return n(e)===_},t.isMemo=function(e){return n(e)===g},t.isPortal=function(e){return n(e)===l},t.isProfiler=function(e){return n(e)===u},t.isStrictMode=function(e){return n(e)===c},t.isSuspense=function(e){return n(e)===b},t.isValidElementType=function(e){return"string"==typeof e||"function"==typeof e||e===i||e===f||e===u||e===c||e===b||e===m||"object"==typeof e&&null!==e&&(e.$$typeof===_||e.$$typeof===g||e.$$typeof===s||e.$$typeof===p||e.$$typeof===y||e.$$typeof===v||e.$$typeof===T||e.$$typeof===w||e.$$typeof===h)},t.typeOf=n)}),reactIs_development_1=reactIs_development.AsyncMode,reactIs_development_2=reactIs_development.ConcurrentMode,reactIs_development_3=reactIs_development.ContextConsumer,reactIs_development_4=reactIs_development.ContextProvider,reactIs_development_5=reactIs_development.Element,reactIs_development_6=reactIs_development.ForwardRef,reactIs_development_7=reactIs_development.Fragment,reactIs_development_8=reactIs_development.Lazy,reactIs_development_9=reactIs_development.Memo,reactIs_development_10=reactIs_development.Portal,reactIs_development_11=reactIs_development.Profiler,reactIs_development_12=reactIs_development.StrictMode,reactIs_development_13=reactIs_development.Suspense,reactIs_development_14=reactIs_development.isAsyncMode,reactIs_development_15=reactIs_development.isConcurrentMode,reactIs_development_16=reactIs_development.isContextConsumer,reactIs_development_17=reactIs_development.isContextProvider,reactIs_development_18=reactIs_development.isElement,reactIs_development_19=reactIs_development.isForwardRef,reactIs_development_20=reactIs_development.isFragment,reactIs_development_21=reactIs_development.isLazy,reactIs_development_22=reactIs_development.isMemo,reactIs_development_23=reactIs_development.isPortal,reactIs_development_24=reactIs_development.isProfiler,reactIs_development_25=reactIs_development.isStrictMode,reactIs_development_26=reactIs_development.isSuspense,reactIs_development_27=reactIs_development.isValidElementType,reactIs_development_28=reactIs_development.typeOf,reactIs=createCommonjsModule(function(e){ true?e.exports=reactIs_production_min:e.exports=reactIs_development}),getOwnPropertySymbols=Object.getOwnPropertySymbols,hasOwnProperty=Object.prototype.hasOwnProperty,propIsEnumerable=Object.prototype.propertyIsEnumerable;function toObject(e){if(null==e)throw new TypeError("Object.assign cannot be called with null or undefined");return Object(e)}function shouldUseNative(){try{if(!Object.assign)return!1;var e=new String("abc");if(e[5]="de","5"===Object.getOwnPropertyNames(e)[0])return!1;for(var t={},n=0;n<10;n++)t["_"+String.fromCharCode(n)]=n;if("0123456789"!==Object.getOwnPropertyNames(t).map(function(e){return t[e]}).join(""))return!1;var r={};return"abcdefghijklmnopqrst".split("").forEach(function(e){r[e]=e}),"abcdefghijklmnopqrst"===Object.keys(Object.assign({},r)).join("")}catch(e){return!1}}var ReactPropTypesSecret$1,loggedTypeFailures,has,objectAssign=shouldUseNative()?Object.assign:function(e,t){for(var n,r,o=toObject(e),a=1;a<arguments.length;a++){for(var l in n=Object(arguments[a]))hasOwnProperty.call(n,l)&&(o[l]=n[l]);if(getOwnPropertySymbols){r=getOwnPropertySymbols(n);for(var i=0;i<r.length;i++)propIsEnumerable.call(n,r[i])&&(o[r[i]]=n[r[i]])}}return o},ReactPropTypesSecret="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED",ReactPropTypesSecret_1=ReactPropTypesSecret,printWarning=function(){};function checkPropTypes(e,t,n,r,o){if(false)for(var a in e)if(has(e,a)){var l,i;try{if("function"!=typeof e[a]){var c=Error((r||"React class")+": "+n+" type `"+a+"` is invalid; it must be a function, usually from the `prop-types` package, but received `"+typeof e[a]+"`.");throw c.name="Invariant Violation",c}l=e[a](t,a,r,n,null,ReactPropTypesSecret$1)}catch(e){l=e}!l||l instanceof Error||printWarning((r||"React class")+": type specification of "+n+" `"+a+"` is invalid; the type checker function must return `null` or an `Error` but returned a "+typeof l+". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."),l instanceof Error&&!(l.message in loggedTypeFailures)&&(loggedTypeFailures[l.message]=!0,i=o?o():"",printWarning("Failed "+n+" type: "+l.message+(null!=i?i:"")))}}"production"!==("production")&&(ReactPropTypesSecret$1=ReactPropTypesSecret_1,loggedTypeFailures={},has=Function.call.bind(Object.prototype.hasOwnProperty),printWarning=function(e){var t="Warning: "+e;"undefined"!=typeof console&&console.error(t);try{throw new Error(t)}catch(e){}}),checkPropTypes.resetWarningCache=function(){"production"!==("production")&&(loggedTypeFailures={})};var checkPropTypes_1=checkPropTypes,has$1=Function.call.bind(Object.prototype.hasOwnProperty),printWarning$1=function(){};function emptyFunctionThatReturnsNull(){return null}"production"!==("production")&&(printWarning$1=function(e){var t="Warning: "+e;"undefined"!=typeof console&&console.error(t);try{throw new Error(t)}catch(e){}});var factoryWithTypeCheckers=function(a,p){var l="function"==typeof Symbol&&Symbol.iterator,i="@@iterator";var d="<<anonymous>>",e={array:t("array"),bool:t("boolean"),func:t("function"),number:t("number"),object:t("object"),string:t("string"),symbol:t("symbol"),any:n(emptyFunctionThatReturnsNull),arrayOf:function(c){return n(function(e,t,n,r,o){if("function"!=typeof c)return new f("Property `"+o+"` of component `"+n+"` has invalid PropType notation inside arrayOf.");var a=e[t];if(!Array.isArray(a))return new f("Invalid "+r+" `"+o+"` of type `"+s(a)+"` supplied to `"+n+"`, expected an array.");for(var l=0;l<a.length;l++){var i=c(a,l,n,r,o+"["+l+"]",ReactPropTypesSecret_1);if(i instanceof Error)return i}return null})},element:n(function(e,t,n,r,o){return t=e[t],a(t)?null:new f("Invalid "+r+" `"+o+"` of type `"+s(t)+"` supplied to `"+n+"`, expected a single ReactElement.")}),elementType:n(function(e,t,n,r,o){return t=e[t],reactIs.isValidElementType(t)?null:new f("Invalid "+r+" `"+o+"` of type `"+s(t)+"` supplied to `"+n+"`, expected a single ReactElement type.")}),instanceOf:function(l){return n(function(e,t,n,r,o){if(e[t]instanceof l)return null;var a=l.name||d;return new f("Invalid "+r+" `"+o+"` of type `"+((t=e[t]).constructor&&t.constructor.name?t.constructor.name:d)+"` supplied to `"+n+"`, expected instance of `"+a+"`.")})},node:n(function(e,t,n,r,o){return c(e[t])?null:new f("Invalid "+r+" `"+o+"` supplied to `"+n+"`, expected a ReactNode.")}),objectOf:function(c){return n(function(e,t,n,r,o){if("function"!=typeof c)return new f("Property `"+o+"` of component `"+n+"` has invalid PropType notation inside objectOf.");var a,l=e[t];if("object"!==(t=s(l)))return new f("Invalid "+r+" `"+o+"` of type `"+t+"` supplied to `"+n+"`, expected an object.");for(a in l)if(has$1(l,a)){var i=c(l,a,n,r,o+"."+a,ReactPropTypesSecret_1);if(i instanceof Error)return i}return null})},oneOf:function(i){if(Array.isArray(i))return n(function(e,t,n,r,o){for(var a=e[t],l=0;l<i.length;l++)if(function(e,t){return e===t?0!==e||1/e==1/t:e!=e&&t!=t}(a,i[l]))return null;t=JSON.stringify(i,function(e,t){return"symbol"===u(t)?String(t):t});return new f("Invalid "+r+" `"+o+"` of value `"+String(a)+"` supplied to `"+n+"`, expected one of "+t+".")});"production"!==("production")&&printWarning$1(1<arguments.length?"Invalid arguments supplied to oneOf, expected an array, got "+arguments.length+" arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).":"Invalid argument supplied to oneOf, expected an array.");return emptyFunctionThatReturnsNull},oneOfType:function(l){if(!Array.isArray(l))return"production"!==("production")&&printWarning$1("Invalid argument supplied to oneOfType, expected an instance of array."),emptyFunctionThatReturnsNull;for(var e=0;e<l.length;e++){var t=l[e];if("function"!=typeof t)return printWarning$1("Invalid argument supplied to oneOfType. Expected an array of check functions, but received "+function(e){e=u(e);switch(e){case"array":case"object":return"an "+e;case"boolean":case"date":case"regexp":return"a "+e;default:return e}}(t)+" at index "+e+"."),emptyFunctionThatReturnsNull}return n(function(e,t,n,r,o){for(var a=0;a<l.length;a++)if(null==(0,l[a])(e,t,n,r,o,ReactPropTypesSecret_1))return null;return new f("Invalid "+r+" `"+o+"` supplied to `"+n+"`.")})},shape:function(c){return n(function(e,t,n,r,o){var a,l=e[t];if("object"!==(t=s(l)))return new f("Invalid "+r+" `"+o+"` of type `"+t+"` supplied to `"+n+"`, expected `object`.");for(a in c){var i=c[a];if(i){i=i(l,a,n,r,o+"."+a,ReactPropTypesSecret_1);if(i)return i}}return null})},exact:function(u){return n(function(e,t,n,r,o){var a,l=e[t],i=s(l);if("object"!==i)return new f("Invalid "+r+" `"+o+"` of type `"+i+"` supplied to `"+n+"`, expected `object`.");for(a in objectAssign({},e[t],u)){var c=u[a];if(!c)return new f("Invalid "+r+" `"+o+"` key `"+a+"` supplied to `"+n+"`.\nBad object: "+JSON.stringify(e[t],null,"  ")+"\nValid keys: "+JSON.stringify(Object.keys(u),null,"  "));c=c(l,a,n,r,o+"."+a,ReactPropTypesSecret_1);if(c)return c}return null})}};function f(e){this.message=e,this.stack=""}function n(c){var u,s;function e(e,t,n,r,o,a,l){if(r=r||d,a=a||n,l!==ReactPropTypesSecret_1){if(p){var i=new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");throw i.name="Invariant Violation",i}"production"===("production")||"undefined"==typeof console||!u[i=r+":"+n]&&s<3&&(printWarning$1("You are manually calling a React.PropTypes validation function for the `"+a+"` prop on `"+r+"`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."),u[i]=!0,s++)}return null==t[n]?e?null===t[n]?new f("The "+o+" `"+a+"` is marked as required in `"+r+"`, but its value is `null`."):new f("The "+o+" `"+a+"` is marked as required in `"+r+"`, but its value is `undefined`."):null:c(t,n,r,o,a)}"production"!==("production")&&(u={},s=0);var t=e.bind(null,!1);return t.isRequired=e.bind(null,!0),t}function t(l){return n(function(e,t,n,r,o,a){return s(t=e[t])===l?null:new f("Invalid "+r+" `"+o+"` of type `"+u(t)+"` supplied to `"+n+"`, expected `"+l+"`.")})}function c(e){switch(typeof e){case"number":case"string":case"undefined":return!0;case"boolean":return!e;case"object":if(Array.isArray(e))return e.every(c);if(null===e||a(e))return!0;var t=function(e){if("function"==typeof(e=e&&(l&&e[l]||e[i])))return e}(e);if(!t)return!1;var n,r=t.call(e);if(t!==e.entries){for(;!(n=r.next()).done;)if(!c(n.value))return!1}else for(;!(n=r.next()).done;){var o=n.value;if(o&&!c(o[1]))return!1}return!0;default:return!1}}function s(e){var t=typeof e;return Array.isArray(e)?"array":e instanceof RegExp?"object":(e=e,"symbol"===t||e&&("Symbol"===e["@@toStringTag"]||"function"==typeof Symbol&&e instanceof Symbol)?"symbol":t)}function u(e){if(null==e)return""+e;var t=s(e);if("object"===t){if(e instanceof Date)return"date";if(e instanceof RegExp)return"regexp"}return t}return f.prototype=Error.prototype,e.checkPropTypes=checkPropTypes_1,e.resetWarningCache=checkPropTypes_1.resetWarningCache,e.PropTypes=e};function emptyFunction(){}function emptyFunctionWithReset(){}emptyFunctionWithReset.resetWarningCache=emptyFunction;var factoryWithThrowingShims=function(){function e(e,t,n,r,o,a){if(a!==ReactPropTypesSecret_1){a=new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");throw a.name="Invariant Violation",a}}function t(){return e}var n={array:e.isRequired=e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:t,element:e,elementType:e,instanceOf:t,node:e,objectOf:t,oneOf:t,oneOfType:t,shape:t,exact:t,checkPropTypes:emptyFunctionWithReset,resetWarningCache:emptyFunction};return n.PropTypes=n},propTypes=createCommonjsModule(function(e){ false?e.exports=factoryWithTypeCheckers(reactIs.isElement,!0):e.exports=factoryWithThrowingShims()}),DataTableStateContext=React.createContext(),useTableContext=function(){return React.useContext(DataTableStateContext)},DataTableProvider=function(e){var t=e.children,e=e.initialState;return React__default.default.createElement(DataTableStateContext.Provider,{value:e},t)};DataTableProvider.propTypes={initialState:propTypes.object.isRequired,children:propTypes.oneOfType([propTypes.arrayOf(propTypes.node),propTypes.node]).isRequired};var seed=1;function getNextValue(){return(seed=(9301*seed+49297)%233280)/233280}function setSeed(e){seed=e}var alphabet,previousSeed,shuffled,randomFromSeed={nextValue:getNextValue,seed:setSeed},ORIGINAL="0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ_-";function reset(){shuffled=!1}function setCharacters(e){if(e){if(e!==alphabet){if(e.length!==ORIGINAL.length)throw new Error("Custom alphabet for shortid must be "+ORIGINAL.length+" unique characters. You submitted "+e.length+" characters: "+e);var t=e.split("").filter(function(e,t,n){return t!==n.lastIndexOf(e)});if(t.length)throw new Error("Custom alphabet for shortid must be "+ORIGINAL.length+" unique characters. These characters were not unique: "+t.join(", "));alphabet=e,reset()}}else alphabet!==ORIGINAL&&(alphabet=ORIGINAL,reset())}function characters(e){return setCharacters(e),alphabet}function setSeed$1(e){randomFromSeed.seed(e),previousSeed!==e&&(reset(),previousSeed=e)}function shuffle(){alphabet||setCharacters(ORIGINAL);for(var e,t=alphabet.split(""),n=[],r=randomFromSeed.nextValue();0<t.length;)r=randomFromSeed.nextValue(),e=Math.floor(r*t.length),n.push(t.splice(e,1)[0]);return n.join("")}function getShuffled(){return shuffled=shuffled||shuffle()}function lookup(e){return getShuffled()[e]}function get(){return alphabet||ORIGINAL}var alphabet_1={get:get,characters:characters,seed:setSeed$1,lookup:lookup,shuffled:getShuffled},crypto="object"==typeof window&&(window.crypto||window.msCrypto),randomByte=crypto&&crypto.getRandomValues?function(e){return crypto.getRandomValues(new Uint8Array(e))}:function(e){for(var t=[],n=0;n<e;n++)t.push(Math.floor(256*Math.random()));return t},randomByteBrowser=randomByte,format_browser=function(e,t,n){for(var r=(2<<Math.log(t.length-1)/Math.LN2)-1,o=-~(1.6*r*n/t.length),a="";;)for(var l=e(o),i=o;i--;)if((a+=t[l[i]&r]||"").length===+n)return a};function generate(e){for(var t,n=0,r="";!t;)r+=format_browser(randomByteBrowser,alphabet_1.get(),1),t=e<Math.pow(16,n+1),n++;return r}var counter,previousSeconds,generate_1=generate,REDUCE_TIME=1567752802062,version=7;function build(e){var t="",n=Math.floor(.001*(Date.now()-REDUCE_TIME));return n===previousSeconds?counter++:(counter=0,previousSeconds=n),t+=generate_1(version),t+=generate_1(e),0<counter&&(t+=generate_1(counter)),t+=generate_1(n)}var build_1=build;function isShortId(e){return!(!e||"string"!=typeof e||e.length<6)&&!new RegExp("[^"+alphabet_1.get().replace(/[|\\{}()[\]^$+*?.-]/g,"\\$&")+"]").test(e)}var isValid=isShortId,lib=createCommonjsModule(function(t){var n=0;function e(){return build_1(n)}t.exports=e,t.exports.generate=e,t.exports.seed=function(e){return alphabet_1.seed(e),t.exports},t.exports.worker=function(e){return n=e,t.exports},t.exports.characters=function(e){return void 0!==e&&alphabet_1.characters(e),alphabet_1.shuffled()},t.exports.isValid=isValid}),lib_1=lib.generate,lib_2=lib.seed,lib_3=lib.worker,lib_4=lib.characters,lib_5=lib.isValid,shortid=lib,lodash_orderby=createCommonjsModule(function(e,t){var n="Expected a function",r="__lodash_hash_undefined__",b=1,_=2,a=1/0,o=9007199254740991,p="[object Arguments]",d="[object Array]",f="[object Boolean]",y="[object Date]",m="[object Error]",l="[object Function]",i="[object GeneratorFunction]",g="[object Map]",h="[object Number]",v="[object Object]",c="[object Promise]",T="[object RegExp]",w="[object Set]",R="[object String]",x="[object Symbol]",u="[object WeakMap]",O="[object ArrayBuffer]",S="[object DataView]",s=/\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,C=/^\w*$/,j=/^\./,E=/[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,P=/\\(\\)?/g,$=/^\[object .+?Constructor\]$/,I=/^(?:0|[1-9]\d*)$/,k={};k["[object Float32Array]"]=k["[object Float64Array]"]=k["[object Int8Array]"]=k["[object Int16Array]"]=k["[object Int32Array]"]=k["[object Uint8Array]"]=k["[object Uint8ClampedArray]"]=k["[object Uint16Array]"]=k["[object Uint32Array]"]=!0,k[p]=k[d]=k[O]=k[f]=k[S]=k[y]=k[m]=k[l]=k[g]=k[h]=k[v]=k[T]=k[w]=k[R]=k[u]=!1;var A="object"==typeof commonjsGlobal&&commonjsGlobal&&commonjsGlobal.Object===Object&&commonjsGlobal,L="object"==typeof self&&self&&self.Object===Object&&self,F=A||L||Function("return this")(),M=t&&!t.nodeType&&t,H=M&&e&&!e.nodeType&&e,N=H&&H.exports===M&&A.process,L=function(){try{return N&&N.binding("util")}catch(e){}}(),t=L&&L.isTypedArray;function D(e,t){for(var n=-1,r=e?e.length:0,o=Array(r);++n<r;)o[n]=t(e[n],n,e);return o}function z(t){return function(e){return t(e)}}function W(e){var t=!1;if(null!=e&&"function"!=typeof e.toString)try{t=!!(e+"")}catch(e){}return t}function q(e){var n=-1,r=Array(e.size);return e.forEach(function(e,t){r[++n]=[t,e]}),r}function B(e){var t=-1,n=Array(e.size);return e.forEach(function(e){n[++t]=e}),n}var V,U,H=Array.prototype,M=Function.prototype,G=Object.prototype,A=F["__core-js_shared__"],Y=(L=/[^.]+$/.exec(A&&A.keys&&A.keys.IE_PROTO||""))?"Symbol(src)_1."+L:"",K=M.toString,J=G.hasOwnProperty,Q=G.toString,X=RegExp("^"+K.call(J).replace(/[\\^$.*+?()[\]{}|]/g,"\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,"$1.*?")+"$"),A=F.Symbol,Z=F.Uint8Array,ee=G.propertyIsEnumerable,te=H.splice,ne=(V=Object.keys,U=Object,function(e){return V(U(e))}),L=Ae(F,"DataView"),re=Ae(F,"Map"),M=Ae(F,"Promise"),H=Ae(F,"Set"),F=Ae(F,"WeakMap"),oe=Ae(Object,"create"),ae=We(L),le=We(re),ie=We(M),ce=We(H),ue=We(F),A=A?A.prototype:void 0,se=A?A.valueOf:void 0,pe=A?A.toString:void 0;function de(e){var t=-1,n=e?e.length:0;for(this.clear();++t<n;){var r=e[t];this.set(r[0],r[1])}}function fe(e){var t=-1,n=e?e.length:0;for(this.clear();++t<n;){var r=e[t];this.set(r[0],r[1])}}function ye(e){var t=-1,n=e?e.length:0;for(this.clear();++t<n;){var r=e[t];this.set(r[0],r[1])}}function be(e){var t=-1,n=e?e.length:0;for(this.__data__=new ye;++t<n;)this.add(e[t])}function me(e){this.__data__=new fe(e)}function ge(e,t){var n,r=Ue(e)||Ve(e)?function(e,t){for(var n=-1,r=Array(e);++n<e;)r[n]=t(n);return r}(e.length,String):[],o=r.length,a=!!o;for(n in e)!t&&!J.call(e,n)||a&&("length"==n||Fe(n,o))||r.push(n);return r}function _e(e,t){for(var n=e.length;n--;)if(Be(e[n][0],t))return n;return-1}de.prototype.clear=function(){this.__data__=oe?oe(null):{}},de.prototype.delete=function(e){return this.has(e)&&delete this.__data__[e]},de.prototype.get=function(e){var t=this.__data__;if(oe){var n=t[e];return n===r?void 0:n}return J.call(t,e)?t[e]:void 0},de.prototype.has=function(e){var t=this.__data__;return oe?void 0!==t[e]:J.call(t,e)},de.prototype.set=function(e,t){return this.__data__[e]=oe&&void 0===t?r:t,this},fe.prototype.clear=function(){this.__data__=[]},fe.prototype.delete=function(e){var t=this.__data__;return!((e=_e(t,e))<0)&&(e==t.length-1?t.pop():te.call(t,e,1),!0)},fe.prototype.get=function(e){var t=this.__data__;return(e=_e(t,e))<0?void 0:t[e][1]},fe.prototype.has=function(e){return-1<_e(this.__data__,e)},fe.prototype.set=function(e,t){var n=this.__data__,r=_e(n,e);return r<0?n.push([e,t]):n[r][1]=t,this},ye.prototype.clear=function(){this.__data__={hash:new de,map:new(re||fe),string:new de}},ye.prototype.delete=function(e){return ke(this,e).delete(e)},ye.prototype.get=function(e){return ke(this,e).get(e)},ye.prototype.has=function(e){return ke(this,e).has(e)},ye.prototype.set=function(e,t){return ke(this,e).set(e,t),this},be.prototype.add=be.prototype.push=function(e){return this.__data__.set(e,r),this},be.prototype.has=function(e){return this.__data__.has(e)},me.prototype.clear=function(){this.__data__=new fe},me.prototype.delete=function(e){return this.__data__.delete(e)},me.prototype.get=function(e){return this.__data__.get(e)},me.prototype.has=function(e){return this.__data__.has(e)},me.prototype.set=function(e,t){var n=this.__data__;if(n instanceof fe){var r=n.__data__;if(!re||r.length<199)return r.push([e,t]),this;n=this.__data__=new ye(r)}return n.set(e,t),this};var he,ve,Te,we=(he=function(e,t){return e&&Re(e,t,et)},function(e,t){if(null==e)return e;if(!Ge(e))return he(e,t);for(var n=e.length,r=ve?n:-1,o=Object(e);(ve?r--:++r<n)&&!1!==t(o[r],r,o););return e}),Re=function(e,t,n){for(var r=-1,o=Object(e),a=n(e),l=a.length;l--;){var i=a[Te?l:++r];if(!1===t(o[i],i,o))break}return e};function xe(e,t){for(var n=0,r=(t=Me(t,e)?[t]:$e(t)).length;null!=e&&n<r;)e=e[ze(t[n++])];return n&&n==r?e:void 0}function Oe(e,t){return null!=e&&t in Object(e)}function Se(e,t,n,r,o){return e===t||(null==e||null==t||!Je(e)&&!Qe(t)?e!=e&&t!=t:function(e,t,n,r,o,a){var l=Ue(e),i=Ue(t),c=d,u=d;l||(c=(c=Le(e))==p?v:c);i||(u=(u=Le(t))==p?v:u);var s=c==v&&!W(e),i=u==v&&!W(t),u=c==u;if(u&&!s)return a=a||new me,l||Ze(e)?Ie(e,t,n,r,o,a):function(e,t,n,r,o,a,l){switch(n){case S:if(e.byteLength!=t.byteLength||e.byteOffset!=t.byteOffset)return!1;e=e.buffer,t=t.buffer;case O:return e.byteLength==t.byteLength&&r(new Z(e),new Z(t))?!0:!1;case f:case y:case h:return Be(+e,+t);case m:return e.name==t.name&&e.message==t.message;case T:case R:return e==t+"";case g:var i=q;case w:n=a&_;if(i=i||B,e.size!=t.size&&!n)return!1;n=l.get(e);if(n)return n==t;a|=b,l.set(e,t);a=Ie(i(e),i(t),r,o,a,l);return l.delete(e),a;case x:if(se)return se.call(e)==se.call(t)}return!1}(e,t,c,n,r,o,a);if(!(o&_)){s=s&&J.call(e,"__wrapped__"),i=i&&J.call(t,"__wrapped__");if(s||i){s=s?e.value():e,i=i?t.value():t;return a=a||new me,n(s,i,r,o,a)}}return u&&(a=a||new me,function(e,t,n,r,o,a){var l=o&_,i=et(e),c=i.length,u=et(t).length;if(c!=u&&!l)return!1;var s=c;for(;s--;){var p=i[s];if(!(l?p in t:J.call(t,p)))return!1}var d=a.get(e);if(d&&a.get(t))return d==t;var f=!0;a.set(e,t),a.set(t,e);var y=l;for(;++s<c;){p=i[s];var b,m=e[p],g=t[p];if(r&&(b=l?r(g,m,p,t,e,a):r(m,g,p,e,t,a)),!(void 0===b?m===g||n(m,g,r,o,a):b)){f=!1;break}y=y||"constructor"==p}f&&!y&&(u=e.constructor,d=t.constructor,u!=d&&"constructor"in e&&"constructor"in t&&!("function"==typeof u&&u instanceof u&&"function"==typeof d&&d instanceof d)&&(f=!1));return a.delete(e),a.delete(t),f}(e,t,n,r,o,a))}(e,t,Se,n,r,o))}function Ce(e){var t;return Je(e)&&(t=e,!(Y&&Y in t))&&(Ye(e)||W(e)?X:$).test(We(e))}function je(e){return"function"==typeof e?e:null==e?tt:"object"==typeof e?Ue(e)?function(r,o){if(Me(r)&&He(o))return Ne(ze(r),o);return function(e){var t,n=function(e,t,n){t=null==e?void 0:xe(e,t);return void 0===t?n:t}(e,r);return void 0===n&&n===o?(t=r,null!=(e=e)&&function(e,t,n){t=Me(t,e)?[t]:$e(t);var r,o=-1,a=t.length;for(;++o<a;){var l=ze(t[o]);if(!(r=null!=e&&n(e,l)))break;e=e[l]}if(r)return r;return!!(a=e?e.length:0)&&Ke(a)&&Fe(l,a)&&(Ue(e)||Ve(e))}(e,t,Oe)):Se(o,n,void 0,b|_)}}(e[0],e[1]):function(t){var n=function(e){var t=et(e),n=t.length;for(;n--;){var r=t[n],o=e[r];t[n]=[r,o,He(o)]}return t}(t);if(1==n.length&&n[0][2])return Ne(n[0][0],n[0][1]);return function(e){return e===t||function(e,t,n,r){var o=n.length,a=o,l=!r;if(null==e)return!a;for(e=Object(e);o--;){var i=n[o];if(l&&i[2]?i[1]!==e[i[0]]:!(i[0]in e))return!1}for(;++o<a;){var c=(i=n[o])[0],u=e[c],s=i[1];if(l&&i[2]){if(void 0===u&&!(c in e))return!1}else{var p,d=new me;if(r&&(p=r(u,s,c,e,t,d)),!(void 0===p?Se(s,u,r,b|_,d):p))return!1}}return!0}(e,t,n)}}(e):Me(e=e)?function(t){return function(e){return null==e?void 0:e[t]}}(ze(e)):function(t){return function(e){return xe(e,t)}}(e)}function Ee(e){if(n="function"==typeof(n=(t=e)&&t.constructor)&&n.prototype||G,t!==n)return ne(e);var t,n,r,o=[];for(r in Object(e))J.call(e,r)&&"constructor"!=r&&o.push(r);return o}function Pe(e,r,n){var o,a,l,i=-1;return r=D(r.length?r:[tt],z(je)),function(e,t){var n=e.length;for(e.sort(t);n--;)e[n]=e[n].value;return e}((o=function(t,e,n){return{criteria:D(r,function(e){return e(t)}),index:++i,value:t}},a=-1,l=Ge(e=e)?Array(e.length):[],we(e,function(e,t,n){l[++a]=o(e,t,n)}),l),function(e,t){return function(e,t,n){var r=-1,o=e.criteria,a=t.criteria,l=o.length,i=n.length;for(;++r<l;){var c=function(e,t){if(e!==t){var n=void 0!==e,r=null===e,o=e==e,a=Xe(e),l=void 0!==t,i=null===t,c=t==t,u=Xe(t);if(!i&&!u&&!a&&t<e||a&&l&&c&&!i&&!u||r&&l&&c||!n&&c||!o)return 1;if(!r&&!a&&!u&&e<t||u&&n&&o&&!r&&!a||i&&n&&o||!l&&o||!c)return-1}return 0}(o[r],a[r]);if(c){if(i<=r)return c;var u=n[r];return c*("desc"==u?-1:1)}}return e.index-t.index}(e,t,n)})}function $e(e){return Ue(e)?e:De(e)}function Ie(e,t,n,r,o,a){var l=o&_,i=e.length,c=t.length;if(i!=c&&!(l&&i<c))return!1;c=a.get(e);if(c&&a.get(t))return c==t;var u=-1,s=!0,p=o&b?new be:void 0;for(a.set(e,t),a.set(t,e);++u<i;){var d,f=e[u],y=t[u];if(r&&(d=l?r(y,f,u,t,e,a):r(f,y,u,e,t,a)),void 0!==d){if(d)continue;s=!1;break}if(p){if(!function(e,t){for(var n=-1,r=e?e.length:0;++n<r;)if(t(e[n],n,e))return 1}(t,function(e,t){return!p.has(t)&&(f===e||n(f,e,r,o,a))&&p.add(t)})){s=!1;break}}else if(f!==y&&!n(f,y,r,o,a)){s=!1;break}}return a.delete(e),a.delete(t),s}function ke(e,t){var n,r=e.__data__;return("string"==(e=typeof(n=t))||"number"==e||"symbol"==e||"boolean"==e?"__proto__"!==n:null===n)?r["string"==typeof t?"string":"hash"]:r.map}function Ae(e,t){t=t,t=null==(e=e)?void 0:e[t];return Ce(t)?t:void 0}var Le=function(e){return Q.call(e)};function Fe(e,t){return!!(t=null==t?o:t)&&("number"==typeof e||I.test(e))&&-1<e&&e%1==0&&e<t}function Me(e,t){if(!Ue(e)){var n=typeof e;return"number"==n||"symbol"==n||"boolean"==n||null==e||Xe(e)||(C.test(e)||!s.test(e)||null!=t&&e in Object(t))}}function He(e){return e==e&&!Je(e)}function Ne(t,n){return function(e){return null!=e&&(e[t]===n&&(void 0!==n||t in Object(e)))}}(L&&Le(new L(new ArrayBuffer(1)))!=S||re&&Le(new re)!=g||M&&Le(M.resolve())!=c||H&&Le(new H)!=w||F&&Le(new F)!=u)&&(Le=function(e){var t=Q.call(e),e=t==v?e.constructor:void 0,e=e?We(e):void 0;if(e)switch(e){case ae:return S;case le:return g;case ie:return c;case ce:return w;case ue:return u}return t});var De=qe(function(e){var t;e=null==(t=e)?"":function(e){if("string"==typeof e)return e;if(Xe(e))return pe?pe.call(e):"";var t=e+"";return"0"==t&&1/e==-a?"-0":t}(t);var o=[];return j.test(e)&&o.push(""),e.replace(E,function(e,t,n,r){o.push(n?r.replace(P,"$1"):t||e)}),o});function ze(e){if("string"==typeof e||Xe(e))return e;var t=e+"";return"0"==t&&1/e==-a?"-0":t}function We(e){if(null!=e){try{return K.call(e)}catch(e){}try{return e+""}catch(e){}}return""}function qe(r,o){if("function"!=typeof r||o&&"function"!=typeof o)throw new TypeError(n);var a=function(){var e=arguments,t=o?o.apply(this,e):e[0],n=a.cache;if(n.has(t))return n.get(t);e=r.apply(this,e);return a.cache=n.set(t,e),e};return a.cache=new(qe.Cache||ye),a}function Be(e,t){return e===t||e!=e&&t!=t}function Ve(e){return Qe(t=e)&&Ge(t)&&J.call(e,"callee")&&(!ee.call(e,"callee")||Q.call(e)==p);var t}qe.Cache=ye;var Ue=Array.isArray;function Ge(e){return null!=e&&Ke(e.length)&&!Ye(e)}function Ye(e){e=Je(e)?Q.call(e):"";return e==l||e==i}function Ke(e){return"number"==typeof e&&-1<e&&e%1==0&&e<=o}function Je(e){var t=typeof e;return e&&("object"==t||"function"==t)}function Qe(e){return!!e&&"object"==typeof e}function Xe(e){return"symbol"==typeof e||Qe(e)&&Q.call(e)==x}var Ze=t?z(t):function(e){return Qe(e)&&Ke(e.length)&&!!k[Q.call(e)]};function et(e){return(Ge(e)?ge:Ee)(e)}function tt(e){return e}e.exports=function(e,t,n,r){return null==e?[]:(Ue(t)||(t=null==t?[]:[t]),Ue(n=r?void 0:n)||(n=null==n?[]:[n]),Pe(e,t,n))}}),isEmpty=function(e){e=0<arguments.length&&void 0!==e?e:"";return null==e||0===e.length},sort=function(e,t,n,r){t=1<arguments.length&&void 0!==t?t:"",n=2<arguments.length?n:void 0,r=3<arguments.length?r:void 0;return(r&&"function"==typeof r?r:lodash_orderby)(e,t,n)},getProperty=function(e,t,n,r){if(!t)return null;if("string"!=typeof t&&"function"!=typeof t)throw new Error("selector must be a . delimited string eg (my.property) or function (e.g. row => row.field");return n&&"function"==typeof n?n(e,r):t&&"function"==typeof t?t(e,r):t.split(".").reduce(function(e,t){var n=t.match(/[^\]\\[.]+/g);if(1<n.length){var r=0;if(r<n.length)return e[n[r]][n[r+1]]}return e[t]},e)},insertItem=function(e,t,n){e=0<arguments.length&&void 0!==e?e:[],t=1<arguments.length&&void 0!==t?t:{},n=2<arguments.length&&void 0!==n?n:0;return[].concat(_toConsumableArray(e.slice(0,n)),[t],_toConsumableArray(e.slice(n)))},removeItem=function(e,t,n){var r=1<arguments.length&&void 0!==t?t:{},o=2<arguments.length?n:void 0,e=(0<arguments.length&&void 0!==e?e:[]).slice();return r[o]?e.splice(e.findIndex(function(e){return e[o]===r[o]}),1):e.splice(e.findIndex(function(e){return e===r}),1),e},decorateColumns=function(e){return e.map(function(e){return _objectSpread2(_objectSpread2({id:shortid.generate()},e),{},{sortable:e.sortable||!!e.sortFunction||void 0})})},getSortDirection=function(e){return e?"asc":"desc"},handleFunctionProps=function(r){for(var o,e=arguments.length,a=new Array(1<e?e-1:0),t=1;t<e;t++)a[t-1]=arguments[t];return Object.keys(r).map(function(e){return r[e]}).forEach(function(e,t){var n=r;"function"==typeof e&&(o=_objectSpread2(_objectSpread2({},n),{},_defineProperty({},Object.keys(r)[t],e.apply(void 0,a))),delete n[e])}),o||r},getNumberOfPages=function(e,t){return Math.ceil(e/t)},recalculatePage=function(e,t){return Math.min(e,t)},noop=function(){return null},getConditionalStyle=function(e,t){var n=0<arguments.length&&void 0!==e?e:{},t=1<arguments.length&&void 0!==t?t:[],r={};return t.length&&t.forEach(function(e){if(!e.when||"function"!=typeof e.when)throw new Error('"when" must be defined in the conditional style object and must be function');e.when(n)&&(r=e.style||{},"function"==typeof e.style&&(r=e.style(n)||{}))}),r},isRowSelected=function(e,t,n){var r=0<arguments.length&&void 0!==e?e:{},t=1<arguments.length&&void 0!==t?t:[],o=2<arguments.length&&void 0!==n?n:"id";return r[o]?t.some(function(e){return e[o]===r[o]}):t.some(function(e){return e===r})},detectRTL=function(e){e=0<arguments.length&&void 0!==e?e:"auto";return"auto"!==e?"rtl"===e:!("undefined"==typeof window||!window.document||!window.document.createElement)&&("rtl"===document.getElementsByTagName("BODY")[0]||"rtl"===document.getElementsByTagName("HTML")[0].dir)},isOdd=function(e){return e%2};function tableReducer(t,e){switch(e.type){case"SELECT_ALL_ROWS":var n=e.rows,r=e.rowCount,o=e.mergeSelections,a=e.keyField,l=!t.allSelected;if(o){var i=l?[].concat(_toConsumableArray(t.selectedRows),_toConsumableArray(n.filter(function(e){return!isRowSelected(e,t.selectedRows,a)}))):t.selectedRows.filter(function(e){return!isRowSelected(e,n,a)});return _objectSpread2(_objectSpread2({},t),{},{allSelected:l,selectedCount:i.length,selectedRows:i})}return _objectSpread2(_objectSpread2({},t),{},{allSelected:l,selectedCount:l?r:0,selectedRows:l?n:[]});case"SELECT_SINGLE_ROW":o=e.row,i=e.isSelected,r=e.keyField,l=e.rowCount;return i?_objectSpread2(_objectSpread2({},t),{},{selectedCount:0<t.selectedRows.length?t.selectedRows.length-1:0,allSelected:!1,selectedRows:removeItem(t.selectedRows,o,r)}):_objectSpread2(_objectSpread2({},t),{},{selectedCount:t.selectedRows.length+1,allSelected:t.selectedRows.length+1===l,selectedRows:insertItem(t.selectedRows,o)});case"SELECT_MULTIPLE_ROWS":var c=e.selectedRows,u=e.rows,s=e.mergeSelections,p=e.keyField;if(s){var d=[].concat(_toConsumableArray(t.selectedRows),_toConsumableArray(c.filter(function(e){return!isRowSelected(e,t.selectedRows,p)})));return _objectSpread2(_objectSpread2({},t),{},{selectedCount:d.length,allSelected:!1,selectedRows:d})}return _objectSpread2(_objectSpread2({},t),{},{selectedCount:c.length,allSelected:c.length===u.length,selectedRows:c});case"SORT_CHANGE":var f=e.sortColumn,y=e.sortDirection,s=e.sortServer,b=e.selectedColumn,d=e.pagination,u=e.paginationServer,m=e.visibleOnly,c=e.persistSelectedOnSort,m=d&&u&&!c||s||m;return _objectSpread2(_objectSpread2({},t),{},{sortColumn:f,selectedColumn:b,sortDirection:y,currentPage:1},m&&{allSelected:!1,selectedCount:0,selectedRows:[]});case"CHANGE_PAGE":var f=e.page,b=e.paginationServer,g=e.visibleOnly,y=e.persistSelectedOnPageChange,m=b&&y,g=b&&!y||g;return _objectSpread2(_objectSpread2(_objectSpread2({},t),{},{currentPage:f},m&&{allSelected:!1}),g&&{allSelected:!1,selectedCount:0,selectedRows:[]});case"CHANGE_ROWS_PER_PAGE":var _=e.rowsPerPage,g=e.page;return _objectSpread2(_objectSpread2({},t),{},{currentPage:g,rowsPerPage:_});case"CLEAR_SELECTED_ROWS":_=e.selectedRowsFlag;return _objectSpread2(_objectSpread2({},t),{},{allSelected:!1,selectedCount:0,selectedRows:[],selectedRowsFlag:_});default:throw new Error("Unhandled action type: ".concat(e.type))}}function _templateObject2(){var e=_taggedTemplateLiteral(["\n  position: relative;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  max-width: 100%;\n  ",";\n  ",";\n"]);return _templateObject2=function(){return e},e}function _templateObject(){var e=_taggedTemplateLiteral(["\n  pointer-events: none;\n  opacity: 0.4;\n"]);return _templateObject=function(){return e},e}var disabled=styled.css(_templateObject()),TableStyle=styled__default.default.div(_templateObject2(),function(e){return e.disabled&&disabled},function(e){return e.theme.table.style});function _templateObject$1(){var e=_taggedTemplateLiteral(["\n  display: flex;\n  text-align: left;\n  ",";\n"]);return _templateObject$1=function(){return e},e}var TableHead=styled__default.default.div(_templateObject$1(),function(e){return e.theme.head.style});function _templateObject2$1(){var e=_taggedTemplateLiteral(["\n  display: flex;\n  align-items: stretch;\n  width: 100%;\n  ",";\n  ",";\n  ",";\n"]);return _templateObject2$1=function(){return e},e}function _templateObject$2(){var e=_taggedTemplateLiteral(["\n  pointer-events: none;\n"]);return _templateObject$2=function(){return e},e}var disabled$1=styled.css(_templateObject$2()),TableHeadRow=styled__default.default.div(_templateObject2$1(),function(e){return e.theme.headRow.style},function(e){return e.dense&&e.theme.headRow.denseStyle},function(e){return e.disabled&&disabled$1});function _templateObject4(){var e=_taggedTemplateLiteral(["\n    @media screen and (max-width: ","px) {\n      ","\n    }\n  "]);return _templateObject4=function(){return e},e}function _templateObject3(){var e=_taggedTemplateLiteral(["\n    @media screen and (max-width: ","px) {\n      ","\n    }\n  "]);return _templateObject3=function(){return e},e}function _templateObject2$2(){var e=_taggedTemplateLiteral(["\n    @media screen and (max-width: ","px) {\n      ","\n    }\n  "]);return _templateObject2$2=function(){return e},e}function _templateObject$3(){var e=_taggedTemplateLiteral(["\n    @media screen and (max-width: ","px) {\n      ","\n    }\n  "]);return _templateObject$3=function(){return e},e}var SMALL=599,MEDIUM=959,LARGE=1280,media={sm:function(){return styled.css(_templateObject$3(),SMALL,styled.css.apply(void 0,arguments))},md:function(){return styled.css(_templateObject2$2(),MEDIUM,styled.css.apply(void 0,arguments))},lg:function(){return styled.css(_templateObject3(),LARGE,styled.css.apply(void 0,arguments))},custom:function(e){return function(){return styled.css(_templateObject4(),e,styled.css.apply(void 0,arguments))}}};function _templateObject7(){var e=_taggedTemplateLiteral(["\n    display: none;\n  "]);return _templateObject7=function(){return e},e}function _templateObject6(){var e=_taggedTemplateLiteral(["\n    display: none;\n  "]);return _templateObject6=function(){return e},e}function _templateObject5(){var e=_taggedTemplateLiteral(["\n    display: none;\n  "]);return _templateObject5=function(){return e},e}function _templateObject4$1(){var e=_taggedTemplateLiteral(["\n    display: none;\n  "]);return _templateObject4$1=function(){return e},e}function _templateObject3$1(){var e=_taggedTemplateLiteral(["\n    min-width: ",";\n    max-width: ",";\n  "]);return _templateObject3$1=function(){return e},e}function _templateObject2$3(){var e=_taggedTemplateLiteral(["\n  flex-grow: ",";\n  flex-shrink: 0;\n  flex-basis: 0;\n  max-width: ",";\n  min-width: ",";\n  ",";\n  ",";\n  ",";\n  ",";\n\n  /* handle hiding cells */\n  ",";\n  ",";\n  ",";\n  ",";\n"]);return _templateObject2$3=function(){return e},e}function _templateObject$4(){var e=_taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  align-items: center;\n  box-sizing: border-box;\n  line-height: normal;\n  ",";\n  ",";\n"]);return _templateObject$4=function(){return e},e}var CellBase=styled__default.default.div(_templateObject$4(),function(e){return e.theme[e.head?"headCells":"cells"].style},function(e){return e.noPadding&&"padding: 0"}),Cell=styled__default.default(CellBase)(_templateObject2$3(),function(e){return 0===e.column.grow||e.column.button?0:e.column.grow||1},function(e){return e.column.maxWidth||"100%"},function(e){return e.column.minWidth||"100px"},function(e){return e.column.width&&styled.css(_templateObject3$1(),e.column.width,e.column.width)},function(e){return e.column.right&&"justify-content: flex-end"},function(e){return(e.column.center||e.column.button)&&"justify-content: center"},function(e){return(e.column.compact||e.column.button)&&"padding: 0"},function(e){return e.column.hide&&"sm"===e.column.hide&&media.sm(_templateObject4$1())},function(e){return e.column.hide&&"md"===e.column.hide&&media.md(_templateObject5())},function(e){return e.column.hide&&"lg"===e.column.hide&&media.lg(_templateObject6())},function(e){return e.column.hide&&Number.isInteger(e.column.hide)&&media.custom(e.column.hide)(_templateObject7())}),STOP_PROP_TAG="allowRowEvents";function _templateObject2$4(){var e=_taggedTemplateLiteral(["\n  font-size: ",";\n  font-weight: 400;\n  ",";\n  ",";\n  ",";\n"]);return _templateObject2$4=function(){return e},e}function _templateObject$5(){var e=_taggedTemplateLiteral(["\n  div:first-child {\n    white-space: ",";\n    overflow: ",";\n    text-overflow: ellipsis;\n  }\n"]);return _templateObject$5=function(){return e},e}var overflowCSS=styled.css(_templateObject$5(),function(e){return e.column.wrap?"normal":"nowrap"},function(e){return e.column.allowOverflow?"visible":"hidden"}),TableCellStyle=styled__default.default(Cell)(_templateObject2$4(),function(e){return e.theme.rows.fontSize},function(e){return!e.column.cell&&overflowCSS},function(e){return e.column.style},function(e){return e.extendedCellStyle}),TableCell=React.memo(function(e){var t=e.id,n=e.rowIndex,r=e.column,o=e.row;if(r.omit)return null;var a=r.ignoreRowClick||r.button?null:STOP_PROP_TAG,e=getConditionalStyle(o,r.conditionalCellStyles);return React__default.default.createElement(TableCellStyle,{id:t,role:"gridcell",column:r,"data-tag":a,className:"rdt_TableCell",extendedCellStyle:e},!r.cell&&React__default.default.createElement("div",{"data-tag":a},getProperty(o,r.selector,r.format,n)),r.cell&&r.cell(o,n,r,t))});TableCell.propTypes={id:propTypes.string.isRequired,rowIndex:propTypes.number.isRequired,column:propTypes.object.isRequired,row:propTypes.object.isRequired};var calculateBaseStyle=function(e){return _objectSpread2(_objectSpread2({fontSize:"18px"},!e&&{cursor:"pointer"}),{},{padding:0,marginTop:"1px",verticalAlign:"middle",position:"relative"})},Checkbox=React.memo(function(e){var t=e.component,n=e.componentOptions,r=e.indeterminate,o=e.checked,a=e.name,l=e.onClick,i=e.disabled,c=t,e="input"!==c?n.style:calculateBaseStyle(i),t=React.useMemo(function(){return handleFunctionProps(n,r)},[n,r]);return React__default.default.createElement(c,_extends({type:"checkbox",ref:function(e){e&&(e.indeterminate=r)},style:e,onClick:i?noop:l,name:a,"aria-label":a,checked:o,disabled:i},t,{onChange:noop}))});function _templateObject$6(){var e=_taggedTemplateLiteral(["\n  flex: 0 0 48px;\n  justify-content: center;\n  align-items: center;\n  user-select: none;\n  white-space: nowrap;\n"]);return _templateObject$6=function(){return e},e}Checkbox.propTypes={name:propTypes.string.isRequired,indeterminate:propTypes.bool,component:propTypes.oneOfType([propTypes.string,propTypes.node,propTypes.func,propTypes.object]),componentOptions:propTypes.object,checked:propTypes.bool,disabled:propTypes.bool,onClick:propTypes.func},Checkbox.defaultProps={indeterminate:!1,component:"input",componentOptions:{style:{}},checked:!1,disabled:!1,onClick:null};var TableCellCheckboxStyle=styled__default.default(CellBase)(_templateObject$6()),TableCellCheckbox=function(e){var t=e.name,n=e.row,r=e.selected,o=useTableContext(),a=o.dispatch,l=o.data,i=o.keyField,c=o.selectableRowsComponent,u=o.selectableRowsComponentProps,e=o.selectableRowDisabled,o=e&&e(n),e=React.useCallback(function(){return a({type:"SELECT_SINGLE_ROW",row:n,isSelected:r,keyField:i,rowCount:l.length})},[a,n,r,i,l.length]);return React__default.default.createElement(TableCellCheckboxStyle,{onClick:function(e){return e.stopPropagation()},className:"rdt_TableCell",noPadding:!0},React__default.default.createElement(Checkbox,{name:t,component:c,componentOptions:u,checked:r,"aria-checked":r,onClick:e,disabled:o}))};function _templateObject$7(){var e=_taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  user-select: none;\n  white-space: nowrap;\n  border: none;\n  background-color: transparent;\n  ",";\n"]);return _templateObject$7=function(){return e},e}TableCellCheckbox.propTypes={name:propTypes.string.isRequired,row:propTypes.object.isRequired,selected:propTypes.bool.isRequired};var ButtonStyle=styled__default.default.button(_templateObject$7(),function(e){return e.theme.expanderButton.style}),ExpanderButton=function(e){var t=e.expanded,n=e.row,r=e.onToggled,o=e.disabled,a=useTableContext(),e=a.expandableIcon,a=a.keyField,e=t?e.expanded:e.collapsed;return React__default.default.createElement(ButtonStyle,{"aria-disabled":o,onClick:function(e){return r&&r(n,e)},"data-testid":"expander-button-".concat(n[a]),disabled:o,"aria-label":t?"Collapse Row":"Expand Row",role:"button",type:"button"},e)};function _templateObject$8(){var e=_taggedTemplateLiteral(["\n  white-space: nowrap;\n  font-weight: 400;\n  ",";\n"]);return _templateObject$8=function(){return e},e}ExpanderButton.propTypes={row:propTypes.object.isRequired,expanded:propTypes.bool,onToggled:propTypes.func,disabled:propTypes.bool},ExpanderButton.defaultProps={onToggled:null,expanded:!1,disabled:!1};var TableCellExpanderStyle=styled__default.default(CellBase)(_templateObject$8(),function(e){return e.theme.expanderCell.style}),TableCellExpander=function(e){var t=e.column,n=e.row,r=e.expanded,o=e.onRowExpandToggled,e=e.disabled;return React__default.default.createElement(TableCellExpanderStyle,{column:t,onClick:function(e){return e.stopPropagation()},noPadding:!0},React__default.default.createElement(ExpanderButton,{onToggled:o,row:n,expanded:r,disabled:e}))};function _templateObject$9(){var e=_taggedTemplateLiteral(["\n  width: 100%;\n  box-sizing: border-box;\n  ",";\n  ",";\n"]);return _templateObject$9=function(){return e},e}TableCellExpander.propTypes={column:propTypes.object,row:propTypes.object,expanded:propTypes.bool,onRowExpandToggled:propTypes.func.isRequired,disabled:propTypes.bool},TableCellExpander.defaultProps={column:{},row:{},expanded:!1,disabled:!1};var renderChildren=function(e,t){return React.Children.map(e,function(e){return React.cloneElement(e,{data:t})})},ExpanderRowStyle=styled__default.default.div(_templateObject$9(),function(e){return e.theme.expanderRow.style},function(e){return e.extendedRowStyle}),ExpanderRow=function(e){var t=e.data,n=e.children,e=e.extendedRowStyle;return React__default.default.createElement(ExpanderRowStyle,{className:"rdt_ExpanderRow",extendedRowStyle:e},renderChildren(n,t))};function _templateObject3$2(){var e=_taggedTemplateLiteral(["\n  display: flex;\n  align-items: stretch;\n  align-content: stretch;\n  width: 100%;\n  box-sizing: border-box;\n  ",";\n  ",";\n  ",";\n  ",";\n  ",";\n  ",";\n  ",";\n"]);return _templateObject3$2=function(){return e},e}function _templateObject2$5(){var e=_taggedTemplateLiteral(["\n  &:hover {\n    cursor: pointer;\n  }\n"]);return _templateObject2$5=function(){return e},e}function _templateObject$a(){var e=_taggedTemplateLiteral(["\n  &:hover {\n    ",";\n  }\n"]);return _templateObject$a=function(){return e},e}ExpanderRow.propTypes={data:propTypes.object,children:propTypes.oneOfType([propTypes.arrayOf(propTypes.node),propTypes.node]),extendedRowStyle:propTypes.object},ExpanderRow.defaultProps={data:{},children:null,extendedRowStyle:null};var highlightCSS=styled.css(_templateObject$a(),function(e){return e.highlightOnHover&&e.theme.rows.highlightOnHoverStyle}),pointerCSS=styled.css(_templateObject2$5()),TableRowStyle=styled__default.default.div(_templateObject3$2(),function(e){return e.theme.rows.style},function(e){return e.dense&&e.theme.rows.denseStyle},function(e){return e.striped&&e.theme.rows.stripedStyle},function(e){return e.highlightOnHover&&highlightCSS},function(e){return e.pointerOnHover&&pointerCSS},function(e){return e.selected&&e.theme.rows.selectedHighlightStyle},function(e){return e.extendedRowStyle}),TableRow=React.memo(function(e){var t=e.id,n=e.keyField,r=e.columns,o=e.row,a=e.onRowClicked,l=e.onRowDoubleClicked,i=e.selectableRows,c=e.expandableRows,u=e.striped,s=e.highlightOnHover,p=e.pointerOnHover,d=e.dense,f=e.expandableRowsComponent,y=e.defaultExpanderDisabled,b=e.defaultExpanded,m=e.expandableRowsHideExpander,g=e.expandOnRowClicked,_=e.expandOnRowDoubleClicked,h=e.conditionalRowStyles,v=e.inheritConditionalStyles,T=e.onRowExpandToggled,w=e.selected,R=e.selectableRowsHighlight,x=e.rowIndex,O=_slicedToArray(React.useState(b),2),S=O[0],C=O[1];React.useEffect(function(){C(b)},[b]);var j=React.useCallback(function(){C(!S),T(!S,o)},[S,T,o]),e=p||c&&(g||_),O=React.useCallback(function(e){e.target&&e.target.getAttribute("data-tag")===STOP_PROP_TAG&&(a(o,e),!y&&c&&g&&j())},[y,g,c,j,a,o]),p=React.useCallback(function(e){e.target&&e.target.getAttribute("data-tag")===STOP_PROP_TAG&&(l(o,e),!y&&c&&_&&j())},[y,_,c,j,l,o]),h=getConditionalStyle(o,h),R=R&&w,v=v?h:null,u=u&&isOdd(x);return React__default.default.createElement(React__default.default.Fragment,null,React__default.default.createElement(TableRowStyle,{id:"row-".concat(t),role:"row",striped:u,highlightOnHover:s,pointerOnHover:!y&&e,dense:d,onClick:O,onDoubleClick:p,className:"rdt_TableRow",extendedRowStyle:h,selected:R},i&&React__default.default.createElement(TableCellCheckbox,{name:"select-row-".concat(o[n]),row:o,selected:w}),c&&!m&&React__default.default.createElement(TableCellExpander,{expanded:S,row:o,onRowExpandToggled:j,disabled:y}),r.map(function(e){return React__default.default.createElement(TableCell,{id:"cell-".concat(e.id,"-").concat(o[n]),key:"cell-".concat(e.id,"-").concat(o[n]),column:e,row:o,rowIndex:x})})),c&&S&&React__default.default.createElement(ExpanderRow,{key:"expander--".concat(o[n]),data:o,extendedRowStyle:v},f))});function _templateObject$b(){var e=_taggedTemplateLiteral(["\n  padding: 2px;\n  color: inherit;\n  flex-grow: 0;\n  flex-shrink: 0;\n  ",";\n  ",";\n"]);return _templateObject$b=function(){return e},e}TableRow.propTypes={id:propTypes.any.isRequired,keyField:propTypes.string.isRequired,columns:propTypes.array.isRequired,row:propTypes.object.isRequired,rowIndex:propTypes.number.isRequired,onRowClicked:propTypes.func.isRequired,onRowDoubleClicked:propTypes.func.isRequired,onRowExpandToggled:propTypes.func.isRequired,defaultExpanded:propTypes.bool,defaultExpanderDisabled:propTypes.bool,selectableRows:propTypes.bool.isRequired,expandableRows:propTypes.bool.isRequired,striped:propTypes.bool.isRequired,highlightOnHover:propTypes.bool.isRequired,pointerOnHover:propTypes.bool.isRequired,dense:propTypes.bool.isRequired,expandableRowsComponent:propTypes.oneOfType([propTypes.arrayOf(propTypes.node),propTypes.node,propTypes.func]).isRequired,expandableRowsHideExpander:propTypes.bool.isRequired,expandOnRowClicked:propTypes.bool.isRequired,expandOnRowDoubleClicked:propTypes.bool.isRequired,conditionalRowStyles:propTypes.array.isRequired,inheritConditionalStyles:propTypes.bool.isRequired,selected:propTypes.bool.isRequired,selectableRowsHighlight:propTypes.bool.isRequired},TableRow.defaultProps={defaultExpanded:!1,defaultExpanderDisabled:!1};var Icon=styled__default.default.span(_templateObject$b(),function(e){return e.sortActive?"opacity: 1":"opacity: 0"},function(e){return"desc"===e.sortDirection&&"transform: rotate(180deg)"}),NativeSortIcon=function(e){var t=e.sortActive,n=e.sortDirection,e=e.sortIcon;return React__default.default.createElement(Icon,{sortActive:t,sortDirection:n},e)};function _templateObject2$6(){var e=_taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  height: 100%;\n  line-height: 1;\n  user-select: none;\n  ",";\n\n  span.__rdt_custom_sort_icon__ {\n    i,\n    svg {\n      ",";\n      color: inherit;\n      font-size: 18px !important;\n      height: 18px !important;\n      width: 18px !important;\n      backface-visibility: hidden;\n      transform-style: preserve-3d;\n      transition-duration: 125ms;\n      transition-property: transform;\n    }\n\n    &.asc i,\n    &.asc svg {\n      transform: rotate(180deg);\n    }\n  }\n\n  &:hover {\n    ",";\n    ",";\n\n    span,\n    span.__rdt_custom_sort_icon__ * {\n      ",";\n    }\n  }\n"]);return _templateObject2$6=function(){return e},e}function _templateObject$c(){var e=_taggedTemplateLiteral(["\n  ",";\n"]);return _templateObject$c=function(){return e},e}NativeSortIcon.propTypes={sortDirection:propTypes.string.isRequired,sortActive:propTypes.bool,sortIcon:propTypes.node},NativeSortIcon.defaultProps={sortActive:!1,sortIcon:React__default.default.createElement(React__default.default.Fragment,null,"▲")};var TableColStyle=styled__default.default(Cell)(_templateObject$c(),function(e){return e.column.button&&"text-align: center"}),ColumnSortable=styled__default.default.div(_templateObject2$6(),function(e){return e.sortActive?e.theme.headCells.activeSortStyle:e.theme.headCells.inactiveSortStyle},function(e){return e.sortActive?"opacity: 1":"opacity: 0"},function(e){return e.column.sortable&&"cursor: pointer"},function(e){var t=e.column,e=e.theme;return t.sortable&&e.headCells.activeStyle},function(e){var t=e.sortActive,e=e.column;return!t&&e.sortable&&"opacity: 1"}),TableCol=React.memo(function(e){var t=e.column,n=e.sortIcon,r=useTableContext(),o=r.dispatch,a=r.pagination,l=r.paginationServer,i=r.sortColumn,c=r.sortDirection,u=r.sortServer,s=r.selectableRowsVisibleOnly,p=r.persistSelectedOnSort;if(t.omit)return null;function d(){var e;t.sortable&&(e=c,i===t.selector&&(e="asc"===c?"desc":"asc"),o({type:"SORT_CHANGE",sortDirection:e,sortColumn:t.selector,sortServer:u,selectedColumn:t,pagination:a,paginationServer:l,visibleOnly:s,persistSelectedOnSort:p}))}function f(e){return React__default.default.createElement(NativeSortIcon,{column:t,sortActive:e,sortDirection:c})}function y(){return React__default.default.createElement("span",{className:[c,"__rdt_custom_sort_icon__"].join(" ")},n)}var b=t.sortable&&i===t.selector,m=t.sortable&&!n&&!t.right,g=t.sortable&&!n&&t.right,e=t.sortable&&n&&!t.right,r=t.sortable&&n&&t.right;return React__default.default.createElement(TableColStyle,{className:"rdt_TableCol",column:t,head:!0},t.name&&React__default.default.createElement(ColumnSortable,{id:"column-".concat(t.selector),role:"columnheader",tabIndex:0,className:"rdt_TableCol_Sortable",onClick:d,onKeyPress:function(e){"Enter"===e.key&&d()},sortActive:b,column:t},r&&y(),g&&f(b),React__default.default.createElement("div",null,t.name),e&&y(),m&&f(b)))});function _templateObject$d(){var e=_taggedTemplateLiteral(["\n  flex: 0 0 48px;\n  justify-content: center;\n  align-items: center;\n  user-select: none;\n  white-space: nowrap;\n"]);return _templateObject$d=function(){return e},e}TableCol.propTypes={column:propTypes.object.isRequired,sortIcon:propTypes.oneOfType([propTypes.bool,propTypes.object]).isRequired};var TableColStyle$1=styled__default.default(CellBase)(_templateObject$d()),TableColCheckbox=function(e){var t=e.head,n=useTableContext(),r=n.dispatch,o=n.data,a=n.selectedRows,l=n.allSelected,i=n.selectableRowsComponent,e=n.selectableRowsComponentProps,c=n.selectableRowDisabled,u=n.keyField,s=n.mergeSelections,n=0<a.length&&!l,p=c?o.filter(function(e){return!c(e)}):o,a=0===p.length,d=Math.min(o.length,p.length),o=React.useCallback(function(){return r({type:"SELECT_ALL_ROWS",rows:p,rowCount:d,mergeSelections:s,keyField:u})},[r,u,s,d,p]);return React__default.default.createElement(TableColStyle$1,{className:"rdt_TableCol",head:t,noPadding:!0},React__default.default.createElement(Checkbox,{name:"select-all-rows",component:i,componentOptions:e,onClick:o,checked:l,indeterminate:n,disabled:a}))};function _templateObject3$3(){var e=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  box-sizing: inherit;\n  z-index: 1;\n  align-items: center;\n  justify-content: space-between;\n  display: flex;\n  ",";\n  ",";\n"]);return _templateObject3$3=function(){return e},e}function _templateObject2$7(){var e=_taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  flex-wrap: wrap;\n"]);return _templateObject2$7=function(){return e},e}function _templateObject$e(){var e=_taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  flex: 1 0 auto;\n  height: 100%;\n  color: ",";\n  font-size: ",";\n  font-weight: 400;\n"]);return _templateObject$e=function(){return e},e}TableColCheckbox.propTypes={head:propTypes.bool},TableColCheckbox.defaultProps={head:!0};var Title=styled__default.default.div(_templateObject$e(),function(e){return e.theme.contextMenu.fontColor},function(e){return e.theme.contextMenu.fontSize}),ContextActions=styled__default.default.div(_templateObject2$7()),ContextMenuStyle=styled__default.default.div(_templateObject3$3(),function(e){return e.theme.contextMenu.style},function(e){return e.visible&&e.theme.contextMenu.activeStyle}),generateDefaultContextTitle=function(e,t,n){if(0===t)return null;var r=1===t?e.singular:e.plural;return detectRTL(n)?"".concat(t," ").concat(e.message||""," ").concat(r):"".concat(t," ").concat(r," ").concat(e.message||"")},ContextMenu=function(){var e=useTableContext(),t=e.contextMessage,n=e.contextActions,r=e.contextComponent,o=e.selectedCount,a=e.direction,e=0<o;return r?React__default.default.createElement(ContextMenuStyle,{visible:e},React.cloneElement(r,{selectedCount:o})):React__default.default.createElement(ContextMenuStyle,{visible:e},React__default.default.createElement(Title,null,generateDefaultContextTitle(t,o,a)),React__default.default.createElement(ContextActions,null,n))};function _templateObject3$4(){var e=_taggedTemplateLiteral(["\n  flex: 1 0 auto;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n\n  > * {\n    margin-left: 5px;\n  }\n"]);return _templateObject3$4=function(){return e},e}function _templateObject2$8(){var e=_taggedTemplateLiteral(["\n  flex: 1 0 auto;\n  color: ",";\n  font-size: ",";\n  font-weight: 400;\n"]);return _templateObject2$8=function(){return e},e}function _templateObject$f(){var e=_taggedTemplateLiteral(["\n  position: relative;\n  box-sizing: border-box;\n  overflow: hidden;\n  display: flex;\n  flex: 1 1 auto;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  flex-wrap: wrap;\n  ","\n"]);return _templateObject$f=function(){return e},e}var TableHeaderStyle=styled__default.default.div(_templateObject$f(),function(e){return e.theme.header.style}),Title$1=styled__default.default.div(_templateObject2$8(),function(e){return e.theme.header.fontColor},function(e){return e.theme.header.fontSize}),Actions=styled__default.default.div(_templateObject3$4()),TableHeader=function(e){var t=e.title,n=e.actions,e=e.showMenu;return React__default.default.createElement(TableHeaderStyle,{className:"rdt_TableHeader",role:"heading","aria-level":"1"},React__default.default.createElement(Title$1,null,t),React__default.default.createElement(Actions,null,n),e&&React__default.default.createElement(ContextMenu,null))};function _templateObject$g(){var e=_taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  flex: 1 1 auto;\n  box-sizing: border-box;\n  align-items: center;\n  padding: 4px 16px 4px 24px;\n  width: 100%;\n  justify-content: ",";\n  flex-wrap: ",";\n  ","\n"]);return _templateObject$g=function(){return e},e}TableHeader.propTypes={title:propTypes.oneOfType([propTypes.string,propTypes.node]).isRequired,actions:propTypes.oneOfType([propTypes.arrayOf(propTypes.node),propTypes.node]),showMenu:propTypes.bool},TableHeader.defaultProps={actions:[],showMenu:!0};var alignMap={left:"flex-start",right:"flex-end",center:"center"},SubheaderWrapper=styled__default.default.header(_templateObject$g(),function(e){return alignMap[e.align]},function(e){return e.wrapContent?"wrap":"nowrap"},function(e){return e.theme.subHeader.style}),TableSubheader=function(e){var t=e.align,n=e.wrapContent,e=e.children;return React__default.default.createElement(SubheaderWrapper,{align:t,wrapContent:n},e)};function _templateObject2$9(){var e=_taggedTemplateLiteral(["\n    max-height: ",";\n    overflow-y: auto;\n    -webkit-overflow-scrolling: touch;\n  "]);return _templateObject2$9=function(){return e},e}function _templateObject$h(){var e=_taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  ",";\n"]);return _templateObject$h=function(){return e},e}TableSubheader.propTypes={children:propTypes.oneOfType([propTypes.arrayOf(propTypes.node),propTypes.node,propTypes.string]),align:propTypes.oneOf(["center","left","right"]),wrapContent:propTypes.bool},TableSubheader.defaultProps={children:null,align:"right",wrapContent:!0};var TableBody=styled__default.default.div(_templateObject$h(),function(e){var t=e.fixedHeader,n=e.hasOffset,r=e.offset,e=e.fixedHeaderScrollHeight;return t&&styled.css(_templateObject2$9(),n?"calc(".concat(e," - ").concat(r,")"):e)});function _templateObject3$5(){var e=_taggedTemplateLiteral(["\n    padding-bottom: ",";\n    margin-bottom: -",";\n  "]);return _templateObject3$5=function(){return e},e}function _templateObject2$a(){var e=_taggedTemplateLiteral(["\n    overflow-x: auto;\n\n    // prevents vertical scrolling in firefox\n    overflow-y: hidden;\n    min-height: 0;\n  "]);return _templateObject2$a=function(){return e},e}function _templateObject$i(){var e=_taggedTemplateLiteral(["\n  position: relative;\n  width: 100%;\n  border-radius: inherit;\n  ",";\n  ",";\n"]);return _templateObject$i=function(){return e},e}TableBody.defaultProps={fixedHeaderScrollHeight:"100vh",offset:0};var ResponsiveWrapper=styled__default.default.div(_templateObject$i(),function(e){return e.responsive&&styled.css(_templateObject2$a())},function(e){return e.overflowY&&e.responsive&&e.overflowYOffset&&styled.css(_templateObject3$5(),e.overflowYOffset,e.overflowYOffset)});function _templateObject$j(){var e=_taggedTemplateLiteral(["\n  position: relative;\n  box-sizing: border-box;\n  width: 100%;\n  height: 100%;\n  ",";\n"]);return _templateObject$j=function(){return e},e}var ProgressWrapperStyle=styled__default.default.div(_templateObject$j(),function(e){return e.theme.progress.style}),ProgressWrapper=function(e){e=e.children;return React__default.default.createElement(ProgressWrapperStyle,null,e)};function _templateObject$k(){var e=_taggedTemplateLiteral(["\n  position: relative;\n  width: 100%;\n  ",";\n"]);return _templateObject$k=function(){return e},e}ProgressWrapper.propTypes={children:propTypes.oneOfType([propTypes.string,propTypes.node,propTypes.func]).isRequired};var TableWrapper=styled__default.default.div(_templateObject$k(),function(e){return e.theme.tableWrapper.style});function _templateObject$l(){var e=_taggedTemplateLiteral(["\n  white-space: nowrap;\n  ",";\n"]);return _templateObject$l=function(){return e},e}var TableColExpander=styled__default.default(CellBase)(_templateObject$l(),function(e){return e.theme.expanderCell.style});function _templateObject$m(){var e=_taggedTemplateLiteral(["\n  box-sizing: border-box;\n  width: 100%;\n  height: 100%;\n  ",";\n"]);return _templateObject$m=function(){return e},e}var NoDataWrapperStyle=styled__default.default.div(_templateObject$m(),function(e){return e.theme.noData.style}),NoDataWrapper=function(e){e=e.children;return React__default.default.createElement(NoDataWrapperStyle,null,e)};NoDataWrapper.propTypes={children:propTypes.oneOfType([propTypes.string,propTypes.node]).isRequired};var DropDownIcon=function(){return React__default.default.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",width:"24",height:"24",viewBox:"0 0 24 24"},React__default.default.createElement("path",{d:"M7 10l5 5 5-5z"}),React__default.default.createElement("path",{d:"M0 0h24v24H0z",fill:"none"}))};function _templateObject2$b(){var e=_taggedTemplateLiteral(["\n  position: relative;\n  flex-shrink: 0;\n  font-size: inherit;\n  color: inherit;\n  margin-top: 1px;\n\n  svg {\n    top: 0;\n    right: 0;\n    color: inherit;\n    position: absolute;\n    fill: currentColor;\n    width: 24px;\n    height: 24px;\n    display: inline-block;\n    user-select: none;\n    pointer-events: none;\n  }\n"]);return _templateObject2$b=function(){return e},e}function _templateObject$n(){var e=_taggedTemplateLiteral(["\n  cursor: pointer;\n  height: 24px;\n  min-width: 24px;\n  user-select: none;\n  padding-left: 8px;\n  padding-right: 12px;\n  box-sizing: content-box;\n  font-size: inherit;\n  color: inherit;\n  border: none;\n  background-color: transparent;\n  appearance: none;\n  direction: ltr;\n\n  &::-ms-expand {\n    display: none;\n  }\n\n  &:disabled::-ms-expand {\n    background: #f60;\n  }\n\n  option {\n    color: initial;\n  }\n"]);return _templateObject$n=function(){return e},e}var SelectControl=styled__default.default.select(_templateObject$n()),SelectWrapper=styled__default.default.div(_templateObject2$b()),Select=function(e){return React__default.default.createElement(SelectWrapper,null,React__default.default.createElement(SelectControl,e),React__default.default.createElement(DropDownIcon,null))};function useWindowSize(){var t="object"===("undefined"==typeof window?"undefined":_typeof(window));function n(){return{width:t?window.innerWidth:void 0,height:t?window.innerHeight:void 0}}var e=_slicedToArray(React.useState(n),2),r=e[0],o=e[1];return React.useEffect(function(){return!!t&&(window.addEventListener("resize",e),function(){return window.removeEventListener("resize",e)});function e(){o(n())}},[]),r}function _templateObject7$1(){var e=_taggedTemplateLiteral(["\n  margin: 0 4px;\n"]);return _templateObject7$1=function(){return e},e}function _templateObject6$1(){var e=_taggedTemplateLiteral(["\n  margin: 0 24px;\n"]);return _templateObject6$1=function(){return e},e}function _templateObject5$1(){var e=_taggedTemplateLiteral(["\n  flex-shrink: 1;\n  user-select: none;\n"]);return _templateObject5$1=function(){return e},e}function _templateObject4$2(){var e=_taggedTemplateLiteral(["\n    width: 100%;\n    justify-content: space-around;\n  "]);return _templateObject4$2=function(){return e},e}function _templateObject3$6(){var e=_taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  border-radius: 4px;\n  white-space: nowrap;\n  ",";\n"]);return _templateObject3$6=function(){return e},e}function _templateObject2$c(){var e=_taggedTemplateLiteral(["\n  position: relative;\n  display: block;\n  user-select: none;\n  border: none;\n  ",";\n  ",";\n"]);return _templateObject2$c=function(){return e},e}function _templateObject$o(){var e=_taggedTemplateLiteral(["\n  display: flex;\n  flex: 1 1 auto;\n  justify-content: flex-end;\n  align-items: center;\n  box-sizing: border-box;\n  padding-right: 8px;\n  padding-left: 8px;\n  width: 100%;\n  ",";\n"]);return _templateObject$o=function(){return e},e}var defaultComponentOptions={rowsPerPageText:"Rows per page:",rangeSeparatorText:"of",noRowsPerPage:!1,selectAllRowsItem:!1,selectAllRowsItemText:"All"},PaginationWrapper=styled__default.default.nav(_templateObject$o(),function(e){return e.theme.pagination.style}),Button=styled__default.default.button(_templateObject2$c(),function(e){return e.theme.pagination.pageButtonsStyle},function(e){return e.isRTL&&"transform: scale(-1, -1)"}),PageList=styled__default.default.div(_templateObject3$6(),media.sm(_templateObject4$2())),Span=styled__default.default.span(_templateObject5$1()),Range=styled__default.default(Span)(_templateObject6$1()),RowLabel=styled__default.default(Span)(_templateObject7$1()),Pagination=function(e){var t=e.rowsPerPage,n=e.rowCount,r=e.onChangePage,o=e.onChangeRowsPerPage,a=e.currentPage,l=useTableContext(),i=l.direction,c=l.paginationRowsPerPageOptions,u=l.paginationIconLastPage,s=l.paginationIconFirstPage,p=l.paginationIconNext,d=l.paginationIconPrevious,f=l.paginationComponentOptions,y=useWindowSize().width>SMALL,b=detectRTL(i),m=getNumberOfPages(n,t),g=a*t,_=g-t+1,h=1===a,v=a===m,e=_objectSpread2(_objectSpread2({},defaultComponentOptions),f),l=(a===m?"".concat(_,"-").concat(n," "):"".concat(_,"-").concat(g," ")).concat(e.rangeSeparatorText," ").concat(n),i=React.useCallback(function(){return r(a-1)},[a,r]),f=React.useCallback(function(){return r(a+1)},[a,r]),m=React.useCallback(function(){return r(1)},[r]),_=React.useCallback(function(){return r(getNumberOfPages(n,t))},[r,n,t]),g=React.useCallback(function(e){e=e.target;return o(Number(e.value),a)},[a,o]),c=c.map(function(e){return React__default.default.createElement("option",{key:e,value:e},e)});e.selectAllRowsItem&&c.push(React__default.default.createElement("option",{key:-1,value:n},e.selectAllRowsItemText));c=React__default.default.createElement(Select,{onChange:g,defaultValue:t,"aria-label":e.rowsPerPageText},c);return React__default.default.createElement(PaginationWrapper,{className:"rdt_Pagination"},!e.noRowsPerPage&&y&&React__default.default.createElement(React__default.default.Fragment,null,React__default.default.createElement(RowLabel,null,e.rowsPerPageText),c),y&&React__default.default.createElement(Range,null,l),React__default.default.createElement(PageList,null,React__default.default.createElement(Button,{id:"pagination-first-page",type:"button","aria-label":"First Page","aria-disabled":h,onClick:m,disabled:h,isRTL:b},s),React__default.default.createElement(Button,{id:"pagination-previous-page",type:"button","aria-label":"Previous Page","aria-disabled":h,onClick:i,disabled:h,isRTL:b},d),!y&&c,React__default.default.createElement(Button,{id:"pagination-next-page",type:"button","aria-label":"Next Page","aria-disabled":v,onClick:f,disabled:v,isRTL:b},p),React__default.default.createElement(Button,{id:"pagination-last-page",type:"button","aria-label":"Last Page","aria-disabled":v,onClick:_,disabled:v,isRTL:b},u)))};function useFirstUpdate(e,t){var n=React.useRef(!0);React.useEffect(function(){n.current?n.current=!1:e()},t)}Pagination.propTypes={rowsPerPage:propTypes.number.isRequired,rowCount:propTypes.number.isRequired,onChangePage:propTypes.func.isRequired,onChangeRowsPerPage:propTypes.func.isRequired,currentPage:propTypes.number.isRequired};var FirstPageIcon=function(){return React__default.default.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",width:"24",height:"24",viewBox:"0 0 24 24","aria-hidden":"true",role:"presentation"},React__default.default.createElement("path",{d:"M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"}),React__default.default.createElement("path",{fill:"none",d:"M24 24H0V0h24v24z"}))},LastPageIcon=function(){return React__default.default.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",width:"24",height:"24",viewBox:"0 0 24 24","aria-hidden":"true",role:"presentation"},React__default.default.createElement("path",{d:"M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"}),React__default.default.createElement("path",{fill:"none",d:"M0 0h24v24H0V0z"}))},LeftIcon=function(){return React__default.default.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",width:"24",height:"24",viewBox:"0 0 24 24","aria-hidden":"true",role:"presentation"},React__default.default.createElement("path",{d:"M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"}),React__default.default.createElement("path",{d:"M0 0h24v24H0z",fill:"none"}))},RightIcon=function(){return React__default.default.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",width:"24",height:"24",viewBox:"0 0 24 24","aria-hidden":"true",role:"presentation"},React__default.default.createElement("path",{d:"M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"}),React__default.default.createElement("path",{d:"M0 0h24v24H0z",fill:"none"}))},ExpanderCollapsedIcon=function(){return React__default.default.createElement("svg",{fill:"currentColor",height:"24",viewBox:"0 0 24 24",width:"24",xmlns:"http://www.w3.org/2000/svg"},React__default.default.createElement("path",{d:"M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"}),React__default.default.createElement("path",{d:"M0-.25h24v24H0z",fill:"none"}))},ExpanderExpandedIcon=function(){return React__default.default.createElement("svg",{fill:"currentColor",height:"24",viewBox:"0 0 24 24",width:"24",xmlns:"http://www.w3.org/2000/svg"},React__default.default.createElement("path",{d:"M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z"}),React__default.default.createElement("path",{d:"M0-.75h24v24H0z",fill:"none"}))},propTypes$1={title:propTypes.oneOfType([propTypes.string,propTypes.node]),selectableRows:propTypes.bool,selectableRowsHighlight:propTypes.bool,selectableRowsVisibleOnly:propTypes.bool,selectableRowsNoSelectAll:propTypes.bool,selectableRowSelected:propTypes.func,selectableRowDisabled:propTypes.func,selectableRowsComponent:propTypes.oneOfType([propTypes.string,propTypes.node,propTypes.func,propTypes.object]),selectableRowsComponentProps:propTypes.object,onRowsSelectedUpdate:propTypes.func,clearSelectedRows:propTypes.bool,expandableRows:propTypes.bool,expandableRowDisabled:propTypes.func,expandableRowExpanded:propTypes.func,expandOnRowClicked:propTypes.bool,expandableRowsHideExpander:propTypes.bool,expandOnRowDoubleClicked:propTypes.bool,onRowExpandToggled:propTypes.func,expandableInheritConditionalStyles:propTypes.bool,keyField:propTypes.string,progressPending:propTypes.bool,progressComponent:propTypes.oneOfType([propTypes.string,propTypes.node,propTypes.func]),persistTableHead:propTypes.bool,expandableRowsComponent:propTypes.oneOfType([propTypes.arrayOf(propTypes.node),propTypes.node,propTypes.func]),expandableIcon:propTypes.shape({collapsed:propTypes.oneOfType([propTypes.string,propTypes.node,propTypes.func]),expanded:propTypes.oneOfType([propTypes.string,propTypes.node,propTypes.func])}),sortIcon:propTypes.oneOfType([propTypes.bool,propTypes.node]),sortFunction:propTypes.func,sortServer:propTypes.bool,onSort:propTypes.func,striped:propTypes.bool,highlightOnHover:propTypes.bool,pointerOnHover:propTypes.bool,actions:propTypes.oneOfType([propTypes.arrayOf(propTypes.node),propTypes.node]),noContextMenu:propTypes.bool,contextMessage:propTypes.shape({singular:propTypes.string.isRequired,plural:propTypes.string.isRequired,message:propTypes.string}),contextActions:propTypes.oneOfType([propTypes.arrayOf(propTypes.node),propTypes.node]),contextComponent:propTypes.oneOfType([propTypes.node,propTypes.func]),defaultSortField:propTypes.string,defaultSortAsc:propTypes.bool,columns:propTypes.array,data:propTypes.array,className:propTypes.string,style:propTypes.object,responsive:propTypes.bool,overflowY:propTypes.bool,overflowYOffset:propTypes.string,noDataComponent:propTypes.oneOfType([propTypes.string,propTypes.node,propTypes.func]),disabled:propTypes.bool,noTableHead:propTypes.bool,noHeader:propTypes.bool,subHeader:propTypes.bool,subHeaderAlign:propTypes.string,subHeaderWrap:propTypes.bool,subHeaderComponent:propTypes.oneOfType([propTypes.arrayOf(propTypes.node),propTypes.node,propTypes.string]),onRowClicked:propTypes.func,onRowDoubleClicked:propTypes.func,fixedHeader:propTypes.bool,fixedHeaderScrollHeight:propTypes.string,pagination:propTypes.bool,paginationServer:propTypes.bool,paginationServerOptions:propTypes.shape({persistSelectedOnSort:propTypes.bool,persistSelectedOnPageChange:propTypes.bool}),paginationDefaultPage:propTypes.number,paginationResetDefaultPage:propTypes.bool,paginationTotalRows:propTypes.number,paginationPerPage:propTypes.number,paginationRowsPerPageOptions:propTypes.array,onChangePage:propTypes.func,onChangeRowsPerPage:propTypes.func,paginationComponent:propTypes.oneOfType([propTypes.arrayOf(propTypes.node),propTypes.node,propTypes.func]),paginationComponentOptions:propTypes.object,paginationIconFirstPage:propTypes.oneOfType([propTypes.string,propTypes.node,propTypes.func]),paginationIconLastPage:propTypes.oneOfType([propTypes.string,propTypes.node,propTypes.func]),paginationIconNext:propTypes.oneOfType([propTypes.string,propTypes.node,propTypes.func]),paginationIconPrevious:propTypes.oneOfType([propTypes.string,propTypes.node,propTypes.func]),dense:propTypes.bool,conditionalRowStyles:propTypes.arrayOf(propTypes.shape({when:propTypes.func.isRequired,style:propTypes.object.isRequired})),theme:propTypes.string,customStyles:propTypes.object,direction:propTypes.oneOf(["ltr","rtl","auto"])},defaultProps={title:"",keyField:"id",selectableRows:!1,selectableRowsHighlight:!1,selectableRowsNoSelectAll:!1,selectableRowSelected:null,selectableRowDisabled:null,selectableRowsComponent:"input",selectableRowsComponentProps:{},onSelectedRowsChange:function(){return null},clearSelectedRows:!1,expandableRows:!1,expandableRowDisabled:null,expandableRowExpanded:null,expandOnRowClicked:!1,expandableRowsHideExpander:!1,expandOnRowDoubleClicked:!1,expandableInheritConditionalStyles:!1,onRowExpandToggled:function(){return null},progressPending:!1,progressComponent:React__default.default.createElement("div",{style:{fontSize:"24px",fontWeight:700,padding:"24px"}},"Loading..."),persistTableHead:!1,expandableRowsComponent:React__default.default.createElement("div",{style:{padding:"24px"}},"Add a custom expander component. Use props.data for row data"),expandableIcon:{collapsed:React__default.default.createElement(ExpanderCollapsedIcon,null),expanded:React__default.default.createElement(ExpanderExpandedIcon,null)},sortIcon:!1,sortFunction:null,sortServer:!1,onSort:function(){return null},striped:!1,highlightOnHover:!1,pointerOnHover:!1,noContextMenu:!1,contextMessage:{singular:"item",plural:"items",message:"selected"},contextActions:[],contextComponent:null,defaultSortField:null,defaultSortAsc:!0,columns:[],data:[],className:null,style:{},responsive:!0,overflowY:!1,overflowYOffset:"250px",noDataComponent:React__default.default.createElement("div",{style:{padding:"24px"}},"There are no records to display"),disabled:!1,noTableHead:!1,noHeader:!1,subHeader:!1,subHeaderAlign:"right",subHeaderWrap:!0,subHeaderComponent:[],onRowClicked:function(){return null},onRowDoubleClicked:function(){return null},fixedHeader:!1,fixedHeaderScrollHeight:"100vh",pagination:!1,paginationServer:!1,paginationServerOptions:{persistSelectedOnSort:!1,persistSelectedOnPageChange:!1},paginationDefaultPage:1,paginationResetDefaultPage:!1,paginationTotalRows:0,paginationPerPage:10,paginationRowsPerPageOptions:[10,15,20,25,30],onChangePage:function(){return null},onChangeRowsPerPage:function(){return null},paginationComponent:null,paginationComponentOptions:{},paginationIconFirstPage:React__default.default.createElement(FirstPageIcon,null),paginationIconLastPage:React__default.default.createElement(LastPageIcon,null),paginationIconNext:React__default.default.createElement(RightIcon,null),paginationIconPrevious:React__default.default.createElement(LeftIcon,null),dense:!1,conditionalRowStyles:[],theme:"default",customStyles:{},direction:"auto"},isMergeableObject=function(e){return isNonNullObject(e)&&!isSpecial(e)};function isNonNullObject(e){return!!e&&"object"==typeof e}function isSpecial(e){var t=Object.prototype.toString.call(e);return"[object RegExp]"===t||"[object Date]"===t||isReactElement(e)}var canUseSymbol="function"==typeof Symbol&&Symbol.for,REACT_ELEMENT_TYPE=canUseSymbol?Symbol.for("react.element"):60103;function isReactElement(e){return e.$$typeof===REACT_ELEMENT_TYPE}function emptyTarget(e){return Array.isArray(e)?[]:{}}function cloneUnlessOtherwiseSpecified(e,t){return!1!==t.clone&&t.isMergeableObject(e)?deepmerge(emptyTarget(e),e,t):e}function defaultArrayMerge(e,t,n){return e.concat(t).map(function(e){return cloneUnlessOtherwiseSpecified(e,n)})}function getMergeFunction(e,t){if(!t.customMerge)return deepmerge;e=t.customMerge(e);return"function"==typeof e?e:deepmerge}function getEnumerableOwnPropertySymbols(t){return Object.getOwnPropertySymbols?Object.getOwnPropertySymbols(t).filter(function(e){return t.propertyIsEnumerable(e)}):[]}function getKeys(e){return Object.keys(e).concat(getEnumerableOwnPropertySymbols(e))}function propertyIsOnObject(e,t){try{return t in e}catch(e){return!1}}function propertyIsUnsafe(e,t){return propertyIsOnObject(e,t)&&!(Object.hasOwnProperty.call(e,t)&&Object.propertyIsEnumerable.call(e,t))}function mergeObject(t,n,r){var o={};return r.isMergeableObject(t)&&getKeys(t).forEach(function(e){o[e]=cloneUnlessOtherwiseSpecified(t[e],r)}),getKeys(n).forEach(function(e){propertyIsUnsafe(t,e)||(propertyIsOnObject(t,e)&&r.isMergeableObject(n[e])?o[e]=getMergeFunction(e,r)(t[e],n[e],r):o[e]=cloneUnlessOtherwiseSpecified(n[e],r))}),o}function deepmerge(e,t,n){(n=n||{}).arrayMerge=n.arrayMerge||defaultArrayMerge,n.isMergeableObject=n.isMergeableObject||isMergeableObject,n.cloneUnlessOtherwiseSpecified=cloneUnlessOtherwiseSpecified;var r=Array.isArray(t);return r===Array.isArray(e)?r?n.arrayMerge(e,t,n):mergeObject(e,t,n):cloneUnlessOtherwiseSpecified(t,n)}deepmerge.all=function(e,n){if(!Array.isArray(e))throw new Error("first argument should be an array");return e.reduce(function(e,t){return deepmerge(e,t,n)},{})};var deepmerge_1=deepmerge,cjs=deepmerge,defaultThemes={default:{text:{primary:"rgba(0, 0, 0, 0.87)",secondary:"rgba(0, 0, 0, 0.54)",disabled:"rgba(0, 0, 0, 0.38)"},background:{default:"#FFFFFF"},context:{background:"#e3f2fd",text:"rgba(0, 0, 0, 0.87)"},divider:{default:"rgba(0,0,0,.12)"},button:{default:"rgba(0,0,0,.54)",focus:"rgba(0,0,0,.12)",hover:"rgba(0,0,0,.12)",disabled:"rgba(0, 0, 0, .18)"},sortFocus:{default:"rgba(0, 0, 0, .54)"},selected:{default:"#e3f2fd",text:"rgba(0, 0, 0, 0.87)"},highlightOnHover:{default:"#EEEEEE",text:"rgba(0, 0, 0, 0.87)"},striped:{default:"#FAFAFA",text:"rgba(0, 0, 0, 0.87)"}},dark:{text:{primary:"#FFFFFF",secondary:"rgba(255, 255, 255, 0.7)",disabled:"rgba(0,0,0,.12)"},background:{default:"#424242"},context:{background:"#E91E63",text:"#FFFFFF"},divider:{default:"rgba(81, 81, 81, 1)"},button:{default:"#FFFFFF",focus:"rgba(255, 255, 255, .54)",hover:"rgba(255, 255, 255, .12)",disabled:"rgba(255, 255, 255, .18)"},sortFocus:{default:"rgba(255, 255, 255, .54)"},selected:{default:"rgba(0, 0, 0, .7)",text:"#FFFFFF"},highlightOnHover:{default:"rgba(0, 0, 0, .7)",text:"#FFFFFF"},striped:{default:"rgba(0, 0, 0, .87)",text:"#FFFFFF"}}},createTheme=function(e,t){t=1<arguments.length&&void 0!==t?t:{};return defaultThemes[e]=cjs(defaultThemes.default,t),defaultThemes[e]},defaultStyles=function(e){return{table:{style:{color:e.text.primary,backgroundColor:e.background.default}},tableWrapper:{style:{display:"table"}},header:{style:{fontSize:"22px",color:e.text.primary,backgroundColor:e.background.default,minHeight:"56px",paddingLeft:"16px",paddingRight:"8px"}},subHeader:{style:{backgroundColor:e.background.default,minHeight:"52px"}},head:{style:{}},headRow:{style:{backgroundColor:e.background.default,minHeight:"56px",borderBottomWidth:"1px",borderBottomColor:e.divider.default,borderBottomStyle:"solid"},denseStyle:{minHeight:"32px"}},headCells:{style:{fontSize:"12px",fontWeight:500,color:e.text.primary,paddingLeft:"16px",paddingRight:"16px"},activeSortStyle:{color:e.text.primary,"&:focus":{outline:"none"},"&:hover:not(:focus)":{color:e.sortFocus.default}},inactiveSortStyle:{"&:focus":{outline:"none",color:e.sortFocus.default},"&:hover":{color:e.sortFocus.default}}},contextMenu:{style:{backgroundColor:e.context.background,fontSize:"18px",fontWeight:400,color:e.context.text,paddingLeft:"16px",paddingRight:"8px",transform:"translate3d(0, -100%, 0)",transitionDuration:"125ms",transitionTimingFunction:"cubic-bezier(0, 0, 0.2, 1)",willChange:"transform"},activeStyle:{transform:"translate3d(0, 0, 0)"}},cells:{style:{paddingLeft:"16px",paddingRight:"16px",wordBreak:"break-word"}},rows:{style:{fontSize:"13px",color:e.text.primary,backgroundColor:e.background.default,minHeight:"48px","&:not(:last-of-type)":{borderBottomStyle:"solid",borderBottomWidth:"1px",borderBottomColor:e.divider.default}},denseStyle:{minHeight:"32px"},selectedHighlightStyle:{"&:nth-of-type(n)":{color:e.selected.text,backgroundColor:e.selected.default,borderBottomColor:e.background.default}},highlightOnHoverStyle:{color:e.highlightOnHover.text,backgroundColor:e.highlightOnHover.default,transitionDuration:"0.15s",transitionProperty:"background-color",borderBottomColor:e.background.default,outlineStyle:"solid",outlineWidth:"1px",outlineColor:e.background.default},stripedStyle:{color:e.striped.text,backgroundColor:e.striped.default}},expanderRow:{style:{color:e.text.primary,backgroundColor:e.background.default}},expanderCell:{style:{flex:"0 0 48px"}},expanderButton:{style:{color:e.button.default,fill:e.button.default,backgroundColor:"transparent",borderRadius:"2px",transition:"0.25s",height:"100%",width:"100%","&:hover:enabled":{cursor:"pointer"},"&:disabled":{color:e.button.disabled},"&:hover:not(:disabled)":{cursor:"pointer",backgroundColor:e.button.hover},"&:focus":{outline:"none",backgroundColor:e.button.focus},svg:{margin:"auto"}}},pagination:{style:{color:e.text.secondary,fontSize:"13px",minHeight:"56px",backgroundColor:e.background.default,borderTopStyle:"solid",borderTopWidth:"1px",borderTopColor:e.divider.default},pageButtonsStyle:{borderRadius:"50%",height:"40px",width:"40px",padding:"8px",margin:"px",cursor:"pointer",transition:"0.4s",color:e.button.default,fill:e.button.default,backgroundColor:"transparent","&:disabled":{cursor:"unset",color:e.button.disabled,fill:e.button.disabled},"&:hover:not(:disabled)":{backgroundColor:e.button.hover},"&:focus":{outline:"none",backgroundColor:e.button.focus}}},noData:{style:{display:"flex",alignItems:"center",justifyContent:"center",color:e.text.primary,backgroundColor:e.background.default}},progress:{style:{display:"flex",alignItems:"center",justifyContent:"center",color:e.text.primary,backgroundColor:e.background.default}}}},createStyles=function(e,t){e=0<arguments.length&&void 0!==e?e:{},t=1<arguments.length&&void 0!==t?t:"default",t=defaultThemes[t]?t:"default";return cjs(defaultStyles(defaultThemes[t]),e)},DataTable=React.memo(function(e){function n(e){return Le({type:"CHANGE_PAGE",page:e,paginationServer:x,visibleOnly:y,persistSelectedOnPageChange:Fe})}var t=e.data,r=e.columns,o=e.title,a=e.actions,l=e.keyField,i=e.striped,c=e.highlightOnHover,u=e.pointerOnHover,s=e.dense,p=e.selectableRows,d=e.selectableRowsHighlight,f=e.selectableRowsNoSelectAll,y=e.selectableRowsVisibleOnly,b=e.selectableRowSelected,m=e.selectableRowDisabled,g=e.selectableRowsComponent,_=e.selectableRowsComponentProps,h=e.onRowExpandToggled,v=e.onSelectedRowsChange,T=e.expandableIcon,w=e.onChangeRowsPerPage,R=e.onChangePage,x=e.paginationServer,O=e.paginationServerOptions,S=e.paginationTotalRows,C=e.paginationDefaultPage,j=e.paginationResetDefaultPage,E=e.paginationPerPage,P=e.paginationRowsPerPageOptions,$=e.paginationIconLastPage,I=e.paginationIconFirstPage,k=e.paginationIconNext,A=e.paginationIconPrevious,L=e.paginationComponent,F=e.paginationComponentOptions,M=e.className,H=e.style,N=e.responsive,D=e.overflowY,z=e.overflowYOffset,W=e.progressPending,q=e.progressComponent,B=e.persistTableHead,V=e.noDataComponent,U=e.disabled,G=e.noTableHead,Y=e.noHeader,K=e.fixedHeader,J=e.fixedHeaderScrollHeight,Q=e.pagination,X=e.subHeader,Z=e.subHeaderAlign,ee=e.subHeaderWrap,te=e.subHeaderComponent,ne=e.noContextMenu,re=e.contextMessage,oe=e.contextActions,ae=e.contextComponent,le=e.expandableRows,ie=e.onRowClicked,ce=e.onRowDoubleClicked,ue=e.sortIcon,se=e.onSort,pe=e.sortFunction,de=e.sortServer,fe=e.expandableRowsComponent,ye=e.expandableRowDisabled,be=e.expandableRowsHideExpander,me=e.expandOnRowClicked,ge=e.expandOnRowDoubleClicked,_e=e.expandableRowExpanded,he=e.expandableInheritConditionalStyles,ve=e.defaultSortField,Te=e.defaultSortAsc,we=e.clearSelectedRows,Re=e.conditionalRowStyles,xe=e.theme,Oe=e.customStyles,Se=e.direction,e={allSelected:!1,selectedCount:0,selectedRows:[],sortColumn:ve,selectedColumn:{},sortDirection:getSortDirection(Te),currentPage:C,rowsPerPage:E},ve=_slicedToArray(React.useReducer(tableReducer,e),2),Te=ve[0],Ce=Te.rowsPerPage,je=Te.currentPage,Ee=Te.selectedRows,Pe=Te.allSelected,$e=Te.selectedCount,Ie=Te.sortColumn,ke=Te.selectedColumn,Ae=Te.sortDirection,Le=ve[1],E=O.persistSelectedOnSort,Fe=O.persistSelectedOnPageChange,Me=x&&(Fe||E),e=Q&&!W&&0<t.length,Te=L||Pagination,He=React.useMemo(function(){return decorateColumns(r)},[r]),ve=React.useMemo(function(){return createStyles(Oe,xe)},[Oe,xe]),Ne=React.useMemo(function(){return fe},[fe]),L=React.useMemo(function(){return _objectSpread2({},"auto"!==Se&&{dir:Se})},[Se]),De=React.useCallback(function(e,t){return ie(e,t)},[ie]),ze=React.useCallback(function(e,t){return ce(e,t)},[ce]);useFirstUpdate(function(){v({allSelected:Pe,selectedCount:$e,selectedRows:Ee})},[$e]),useFirstUpdate(function(){R(je,S||t.length)},[je]),useFirstUpdate(function(){w(Ce,je)},[Ce]),useFirstUpdate(function(){se(ke,Ae)},[Ie,Ae]),React.useEffect(function(){Le({type:"CLEAR_SELECTED_ROWS",selectedRowsFlag:we})},[we]),useFirstUpdate(function(){n(C)},[C,j]),React.useEffect(function(){var e;b&&(e=t.filter(function(e){return b(e)}),Le({type:"SELECT_MULTIPLE_ROWS",selectedRows:e,rows:t,mergeSelections:Me}))},[t]),useFirstUpdate(function(){var e;Q&&x&&0<S&&(e=getNumberOfPages(S,Ce),e=recalculatePage(je,e),je!==e&&n(e))},[S]);var We=React.useMemo(function(){return r.reduce(function(e,t){return _objectSpread2(_objectSpread2({},e),{},_defineProperty({},t.selector,t))},{})},[r]),qe=React.useMemo(function(){if(de)return t;var n=Ie&&We[Ie];if(!n||!n.sortFunction)return sort(t,Ie,Ae,pe);var e="asc"===Ae?n.sortFunction:function(e,t){return-1*n.sortFunction(e,t)};return _toConsumableArray(t).sort(e)},[de,Ie,We,Ae,t,pe]),Be=React.useMemo(function(){if(!Q||x)return qe;var e=je*Ce,t=e-Ce;return qe.slice(t,e)},[je,Q,x,Ce,qe]);Q&&!x&&0<t.length&&0===Be.length&&(j=getNumberOfPages(t.length,Ce),j=recalculatePage(je,j),n(j));F={dispatch:Le,data:y?Be:t,allSelected:Pe,selectedRows:Ee,selectedCount:$e,sortColumn:Ie,sortDirection:Ae,keyField:l,contextMessage:re,contextActions:oe,contextComponent:ae,sortServer:de,selectableRowsVisibleOnly:y,selectableRowSelected:b,selectableRowDisabled:m,selectableRowsComponent:g,selectableRowsComponentProps:_,persistSelectedOnSort:E,expandableIcon:T,pagination:Q,paginationServer:x,paginationServerOptions:O,paginationTotalRows:S,paginationRowsPerPageOptions:P,paginationIconLastPage:$,paginationIconFirstPage:I,paginationIconNext:k,paginationIconPrevious:A,paginationComponentOptions:F,direction:Se,mergeSelections:Me},f=Fe||f;return React__default.default.createElement(styled.ThemeProvider,{theme:ve},React__default.default.createElement(DataTableProvider,{initialState:F},!Y&&React__default.default.createElement(TableHeader,{title:o,actions:a,showMenu:!ne}),X&&React__default.default.createElement(TableSubheader,{align:Z,wrapContent:ee},te),React__default.default.createElement(ResponsiveWrapper,_extends({responsive:N,className:M,style:H,overflowYOffset:z,overflowY:D},L),React__default.default.createElement(TableWrapper,null,W&&!B&&React__default.default.createElement(ProgressWrapper,null,q),React__default.default.createElement(TableStyle,{disabled:U,className:"rdt_Table",role:"table"},!G&&(!!B||0<t.length&&!W)&&React__default.default.createElement(TableHead,{className:"rdt_TableHead",role:"rowgroup"},React__default.default.createElement(TableHeadRow,{className:"rdt_TableHeadRow",role:"row",dense:s,disabled:W||0===t.length},p&&(f?React__default.default.createElement(CellBase,{style:{flex:"0 0 48px"}}):React__default.default.createElement(TableColCheckbox,null)),le&&!be&&React__default.default.createElement(TableColExpander,null),He.map(function(e){return React__default.default.createElement(TableCol,{key:e.id,column:e,sortIcon:ue})}))),0<!t.length&&!W&&React__default.default.createElement(NoDataWrapper,null,V),W&&B&&React__default.default.createElement(ProgressWrapper,null,q),!W&&0<t.length&&React__default.default.createElement(TableBody,{fixedHeader:K,fixedHeaderScrollHeight:J,hasOffset:D,offset:z,className:"rdt_TableBody",role:"rowgroup"},Be.map(function(e,t){var n=isEmpty(e[l])?t:e[l],r=isRowSelected(e,Ee,l),o=le&&_e&&_e(e),a=le&&ye&&ye(e);return React__default.default.createElement(TableRow,{id:n,key:n,keyField:l,row:e,columns:He,selectableRows:p,expandableRows:le,striped:i,highlightOnHover:c,pointerOnHover:u,dense:s,expandOnRowClicked:me,expandOnRowDoubleClicked:ge,expandableRowsComponent:Ne,expandableRowsHideExpander:be,onRowExpandToggled:h,defaultExpanderDisabled:a,defaultExpanded:o,inheritConditionalStyles:he,onRowClicked:De,onRowDoubleClicked:ze,conditionalRowStyles:Re,selected:r,selectableRowsHighlight:d,rowIndex:t})}))))),e&&React__default.default.createElement("div",null,React__default.default.createElement(Te,{onChangePage:n,onChangeRowsPerPage:function(e){var t=S||Be.length,t=getNumberOfPages(t,e),t=recalculatePage(je,t);x||n(t),Le({type:"CHANGE_ROWS_PER_PAGE",page:t,rowsPerPage:e})},rowCount:S||t.length,currentPage:je,rowsPerPage:Ce}))))});DataTable.propTypes=propTypes$1,DataTable.defaultProps=defaultProps,exports.createTheme=createTheme,exports.default=DataTable,exports.defaultThemes=defaultThemes;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 54 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	var check = function (it) {
	  return it && it.Math === Math && it;
	};
	
	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	module.exports =
	  // eslint-disable-next-line es/no-global-this -- safe
	  check(typeof globalThis == 'object' && globalThis) ||
	  check(typeof window == 'object' && window) ||
	  // eslint-disable-next-line no-restricted-globals -- safe
	  check(typeof self == 'object' && self) ||
	  check(typeof global == 'object' && global) ||
	  check(typeof this == 'object' && this) ||
	  // eslint-disable-next-line no-new-func -- fallback
	  (function () { return this; })() || Function('return this')();
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";var regeneratorRuntime = __webpack_require__(1436);function asyncGeneratorStep(e,r,n,t,o,a,c){try{var s=e[a](c),u=s.value}catch(e){return void n(e)}s.done?r(u):Promise.resolve(u).then(t,o)}function _asyncToGenerator(e){return function(){var r=this,n=arguments;return new Promise(function(t,o){var a=e.apply(r,n);function c(e){asyncGeneratorStep(a,t,o,c,s,"next",e)}function s(e){asyncGeneratorStep(a,t,o,c,s,"throw",e)}c(void 0)})}}Object.defineProperty(exports,"__esModule",{value:!0}),exports.default=void 0;var DEBUG=!1,API_KEY=null,LANGUAGE="en",REGION=null,LOCATION_TYPE=null,GOOGLE_API="https://maps.googleapis.com/maps/api/geocode/json";function log(e){var r=arguments.length>1&&void 0!==arguments[1]&&arguments[1];DEBUG&&(r?console.warn(e):console.log(e))}function handleUrl(e){return _handleUrl.apply(this,arguments)}function _handleUrl(){return(_handleUrl=_asyncToGenerator(regeneratorRuntime.mark(function e(r){var n,t;return regeneratorRuntime.wrap(function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,fetch(r).catch(function(){return Promise.reject(new Error("Error fetching data"))});case 2:return n=e.sent,e.next=5,n.json().catch(function(){return log("Error parsing server response"),Promise.reject(new Error("Error parsing server response"))});case 5:if("OK"!==(t=e.sent).status){e.next=9;break}return log(t),e.abrupt("return",t);case 9:return log("".concat(t.error_message,".\nServer returned status code ").concat(t.status),!0),e.abrupt("return",Promise.reject(new Error("".concat(t.error_message,".\nServer returned status code ").concat(t.status))));case 11:case"end":return e.stop()}},e)}))).apply(this,arguments)}var _default={setApiKey:function(apiKey){API_KEY=apiKey},setLanguage:function(language){LANGUAGE=language},setRegion:function(region){REGION=region},setLocationType:function(locationType){LOCATION_TYPE=locationType},enableDebug:function(){var e=!(arguments.length>0&&void 0!==arguments[0])||arguments[0];DEBUG=e},fromLatLng:function(lat,lng,apiKey,language,region,locationType){return _asyncToGenerator(regeneratorRuntime.mark(function a(){var c,s;return regeneratorRuntime.wrap(function(a){for(;;)switch(a.prev=a.next){case 0:if(lat&&lng){a.next=3;break}return log("Provided coordinates are invalid",!0),a.abrupt("return",Promise.reject(new Error("Provided coordinates are invalid")));case 3:return c="".concat(lat,",").concat(lng),s="".concat(GOOGLE_API,"?latlng=").concat(encodeURIComponent(c)),(apiKey||API_KEY)&&(s+="&key=".concat(API_KEY=apiKey||API_KEY)),(language||LANGUAGE)&&(s+="&language=".concat(LANGUAGE=language||LANGUAGE)),(region||REGION)&&(REGION=region||REGION,s+="&region=".concat(encodeURIComponent(REGION))),(locationType||LOCATION_TYPE)&&(LOCATION_TYPE=locationType||LOCATION_TYPE,s+="&location_type=".concat(encodeURIComponent(LOCATION_TYPE))),a.abrupt("return",handleUrl(s));case 9:case"end":return a.stop()}},a)}))()},fromAddress:function(address,apiKey,language,region){return _asyncToGenerator(regeneratorRuntime.mark(function o(){var a;return regeneratorRuntime.wrap(function(o){for(;;)switch(o.prev=o.next){case 0:if(address){o.next=3;break}return log("Provided address is invalid",!0),o.abrupt("return",Promise.reject(new Error("Provided address is invalid")));case 3:return a="".concat(GOOGLE_API,"?address=").concat(encodeURIComponent(address)),(apiKey||API_KEY)&&(a+="&key=".concat(API_KEY=apiKey||API_KEY)),(language||LANGUAGE)&&(a+="&language=".concat(LANGUAGE=language||LANGUAGE)),(region||REGION)&&(REGION=region||REGION,a+="&region=".concat(encodeURIComponent(REGION))),o.abrupt("return",handleUrl(a));case 8:case"end":return o.stop()}},o)}))()}};exports.default=_default;

/***/ },
/* 56 */
/***/ function(module, exports) {

	function _typeof(o) {
	  "@babel/helpers - typeof";
	
	  return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
	    return typeof o;
	  } : function (o) {
	    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(o);
	}
	module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 57 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.timezonePatterns = exports.numericPatterns = void 0;
	var numericPatterns = {
	  month: /^(1[0-2]|0?\d)/,
	  // 0 to 12
	  date: /^(3[0-1]|[0-2]?\d)/,
	  // 0 to 31
	  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
	  // 0 to 366
	  week: /^(5[0-3]|[0-4]?\d)/,
	  // 0 to 53
	  hour23h: /^(2[0-3]|[0-1]?\d)/,
	  // 0 to 23
	  hour24h: /^(2[0-4]|[0-1]?\d)/,
	  // 0 to 24
	  hour11h: /^(1[0-1]|0?\d)/,
	  // 0 to 11
	  hour12h: /^(1[0-2]|0?\d)/,
	  // 0 to 12
	  minute: /^[0-5]?\d/,
	  // 0 to 59
	  second: /^[0-5]?\d/,
	  // 0 to 59
	
	  singleDigit: /^\d/,
	  // 0 to 9
	  twoDigits: /^\d{1,2}/,
	  // 0 to 99
	  threeDigits: /^\d{1,3}/,
	  // 0 to 999
	  fourDigits: /^\d{1,4}/,
	  // 0 to 9999
	
	  anyDigitsSigned: /^-?\d+/,
	  singleDigitSigned: /^-?\d/,
	  // 0 to 9, -0 to -9
	  twoDigitsSigned: /^-?\d{1,2}/,
	  // 0 to 99, -0 to -99
	  threeDigitsSigned: /^-?\d{1,3}/,
	  // 0 to 999, -0 to -999
	  fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999
	};
	exports.numericPatterns = numericPatterns;
	var timezonePatterns = {
	  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
	  basic: /^([+-])(\d{2})(\d{2})|Z/,
	  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
	  extended: /^([+-])(\d{2}):(\d{2})|Z/,
	  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
	};
	exports.timezonePatterns = timezonePatterns;

/***/ },
/* 58 */
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	var CharacterMetadata = __webpack_require__(70);
	
	var ContentStateInlineStyle = __webpack_require__(1184);
	
	var applyEntityToContentState = __webpack_require__(1208);
	
	var getCharacterRemovalRange = __webpack_require__(1228);
	
	var getContentStateFragment = __webpack_require__(193);
	
	var Immutable = __webpack_require__(27);
	
	var insertFragmentIntoContentState = __webpack_require__(1232);
	
	var insertTextIntoContentState = __webpack_require__(1233);
	
	var invariant = __webpack_require__(32);
	
	var modifyBlockForContentState = __webpack_require__(419);
	
	var removeEntitiesAtEdges = __webpack_require__(422);
	
	var removeRangeFromContentState = __webpack_require__(1249);
	
	var splitBlockInContentState = __webpack_require__(1251);
	
	var OrderedSet = Immutable.OrderedSet;
	/**
	 * `DraftModifier` provides a set of convenience methods that apply
	 * modifications to a `ContentState` object based on a target `SelectionState`.
	 *
	 * Any change to a `ContentState` should be decomposable into a series of
	 * transaction functions that apply the required changes and return output
	 * `ContentState` objects.
	 *
	 * These functions encapsulate some of the most common transaction sequences.
	 */
	
	var DraftModifier = {
	  replaceText: function replaceText(contentState, rangeToReplace, text, inlineStyle, entityKey) {
	    var withoutEntities = removeEntitiesAtEdges(contentState, rangeToReplace);
	    var withoutText = removeRangeFromContentState(withoutEntities, rangeToReplace);
	    var character = CharacterMetadata.create({
	      style: inlineStyle || OrderedSet(),
	      entity: entityKey || null
	    });
	    return insertTextIntoContentState(withoutText, withoutText.getSelectionAfter(), text, character);
	  },
	  insertText: function insertText(contentState, targetRange, text, inlineStyle, entityKey) {
	    !targetRange.isCollapsed() ?  false ? invariant(false, 'Target range must be collapsed for `insertText`.') : invariant(false) : void 0;
	    return DraftModifier.replaceText(contentState, targetRange, text, inlineStyle, entityKey);
	  },
	  moveText: function moveText(contentState, removalRange, targetRange) {
	    var movedFragment = getContentStateFragment(contentState, removalRange);
	    var afterRemoval = DraftModifier.removeRange(contentState, removalRange, 'backward');
	    return DraftModifier.replaceWithFragment(afterRemoval, targetRange, movedFragment);
	  },
	  replaceWithFragment: function replaceWithFragment(contentState, targetRange, fragment) {
	    var mergeBlockData = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'REPLACE_WITH_NEW_DATA';
	    var withoutEntities = removeEntitiesAtEdges(contentState, targetRange);
	    var withoutText = removeRangeFromContentState(withoutEntities, targetRange);
	    return insertFragmentIntoContentState(withoutText, withoutText.getSelectionAfter(), fragment, mergeBlockData);
	  },
	  removeRange: function removeRange(contentState, rangeToRemove, removalDirection) {
	    var startKey, endKey, startBlock, endBlock;
	
	    if (rangeToRemove.getIsBackward()) {
	      rangeToRemove = rangeToRemove.merge({
	        anchorKey: rangeToRemove.getFocusKey(),
	        anchorOffset: rangeToRemove.getFocusOffset(),
	        focusKey: rangeToRemove.getAnchorKey(),
	        focusOffset: rangeToRemove.getAnchorOffset(),
	        isBackward: false
	      });
	    }
	
	    startKey = rangeToRemove.getAnchorKey();
	    endKey = rangeToRemove.getFocusKey();
	    startBlock = contentState.getBlockForKey(startKey);
	    endBlock = contentState.getBlockForKey(endKey);
	    var startOffset = rangeToRemove.getStartOffset();
	    var endOffset = rangeToRemove.getEndOffset();
	    var startEntityKey = startBlock.getEntityAt(startOffset);
	    var endEntityKey = endBlock.getEntityAt(endOffset - 1); // Check whether the selection state overlaps with a single entity.
	    // If so, try to remove the appropriate substring of the entity text.
	
	    if (startKey === endKey) {
	      if (startEntityKey && startEntityKey === endEntityKey) {
	        var adjustedRemovalRange = getCharacterRemovalRange(contentState.getEntityMap(), startBlock, endBlock, rangeToRemove, removalDirection);
	        return removeRangeFromContentState(contentState, adjustedRemovalRange);
	      }
	    }
	
	    var withoutEntities = removeEntitiesAtEdges(contentState, rangeToRemove);
	    return removeRangeFromContentState(withoutEntities, rangeToRemove);
	  },
	  splitBlock: function splitBlock(contentState, selectionState) {
	    var withoutEntities = removeEntitiesAtEdges(contentState, selectionState);
	    var withoutText = removeRangeFromContentState(withoutEntities, selectionState);
	    return splitBlockInContentState(withoutText, withoutText.getSelectionAfter());
	  },
	  applyInlineStyle: function applyInlineStyle(contentState, selectionState, inlineStyle) {
	    return ContentStateInlineStyle.add(contentState, selectionState, inlineStyle);
	  },
	  removeInlineStyle: function removeInlineStyle(contentState, selectionState, inlineStyle) {
	    return ContentStateInlineStyle.remove(contentState, selectionState, inlineStyle);
	  },
	  setBlockType: function setBlockType(contentState, selectionState, blockType) {
	    return modifyBlockForContentState(contentState, selectionState, function (block) {
	      return block.merge({
	        type: blockType,
	        depth: 0
	      });
	    });
	  },
	  setBlockData: function setBlockData(contentState, selectionState, blockData) {
	    return modifyBlockForContentState(contentState, selectionState, function (block) {
	      return block.merge({
	        data: blockData
	      });
	    });
	  },
	  mergeBlockData: function mergeBlockData(contentState, selectionState, blockData) {
	    return modifyBlockForContentState(contentState, selectionState, function (block) {
	      return block.merge({
	        data: block.getData().merge(blockData)
	      });
	    });
	  },
	  applyEntity: function applyEntity(contentState, selectionState, entityKey) {
	    var withoutEntities = removeEntitiesAtEdges(contentState, selectionState);
	    return applyEntityToContentState(withoutEntities, selectionState, entityKey);
	  }
	};
	module.exports = DraftModifier;

/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	'use strict';
	
	var UserAgentData = __webpack_require__(1276);
	
	var VersionRange = __webpack_require__(1277);
	
	var mapObject = __webpack_require__(1288);
	
	var memoizeStringOnly = __webpack_require__(1289);
	/**
	 * Checks to see whether `name` and `version` satisfy `query`.
	 *
	 * @param {string} name Name of the browser, device, engine or platform
	 * @param {?string} version Version of the browser, engine or platform
	 * @param {string} query Query of form "Name [range expression]"
	 * @param {?function} normalizer Optional pre-processor for range expression
	 * @return {boolean}
	 */
	
	
	function compare(name, version, query, normalizer) {
	  // check for exact match with no version
	  if (name === query) {
	    return true;
	  } // check for non-matching names
	
	
	  if (!query.startsWith(name)) {
	    return false;
	  } // full comparison with version
	
	
	  var range = query.slice(name.length);
	
	  if (version) {
	    range = normalizer ? normalizer(range) : range;
	    return VersionRange.contains(range, version);
	  }
	
	  return false;
	}
	/**
	 * Normalizes `version` by stripping any "NT" prefix, but only on the Windows
	 * platform.
	 *
	 * Mimics the stripping performed by the `UserAgentWindowsPlatform` PHP class.
	 *
	 * @param {string} version
	 * @return {string}
	 */
	
	
	function normalizePlatformVersion(version) {
	  if (UserAgentData.platformName === 'Windows') {
	    return version.replace(/^\s*NT/, '');
	  }
	
	  return version;
	}
	/**
	 * Provides client-side access to the authoritative PHP-generated User Agent
	 * information supplied by the server.
	 */
	
	
	var UserAgent = {
	  /**
	   * Check if the User Agent browser matches `query`.
	   *
	   * `query` should be a string like "Chrome" or "Chrome > 33".
	   *
	   * Valid browser names include:
	   *
	   * - ACCESS NetFront
	   * - AOL
	   * - Amazon Silk
	   * - Android
	   * - BlackBerry
	   * - BlackBerry PlayBook
	   * - Chrome
	   * - Chrome for iOS
	   * - Chrome frame
	   * - Facebook PHP SDK
	   * - Facebook for iOS
	   * - Firefox
	   * - IE
	   * - IE Mobile
	   * - Mobile Safari
	   * - Motorola Internet Browser
	   * - Nokia
	   * - Openwave Mobile Browser
	   * - Opera
	   * - Opera Mini
	   * - Opera Mobile
	   * - Safari
	   * - UIWebView
	   * - Unknown
	   * - webOS
	   * - etc...
	   *
	   * An authoritative list can be found in the PHP `BrowserDetector` class and
	   * related classes in the same file (see calls to `new UserAgentBrowser` here:
	   * https://fburl.com/50728104).
	   *
	   * @note Function results are memoized
	   *
	   * @param {string} query Query of the form "Name [range expression]"
	   * @return {boolean}
	   */
	  isBrowser: function isBrowser(query) {
	    return compare(UserAgentData.browserName, UserAgentData.browserFullVersion, query);
	  },
	
	  /**
	   * Check if the User Agent browser uses a 32 or 64 bit architecture.
	   *
	   * @note Function results are memoized
	   *
	   * @param {string} query Query of the form "32" or "64".
	   * @return {boolean}
	   */
	  isBrowserArchitecture: function isBrowserArchitecture(query) {
	    return compare(UserAgentData.browserArchitecture, null, query);
	  },
	
	  /**
	   * Check if the User Agent device matches `query`.
	   *
	   * `query` should be a string like "iPhone" or "iPad".
	   *
	   * Valid device names include:
	   *
	   * - Kindle
	   * - Kindle Fire
	   * - Unknown
	   * - iPad
	   * - iPhone
	   * - iPod
	   * - etc...
	   *
	   * An authoritative list can be found in the PHP `DeviceDetector` class and
	   * related classes in the same file (see calls to `new UserAgentDevice` here:
	   * https://fburl.com/50728332).
	   *
	   * @note Function results are memoized
	   *
	   * @param {string} query Query of the form "Name"
	   * @return {boolean}
	   */
	  isDevice: function isDevice(query) {
	    return compare(UserAgentData.deviceName, null, query);
	  },
	
	  /**
	   * Check if the User Agent rendering engine matches `query`.
	   *
	   * `query` should be a string like "WebKit" or "WebKit >= 537".
	   *
	   * Valid engine names include:
	   *
	   * - Gecko
	   * - Presto
	   * - Trident
	   * - WebKit
	   * - etc...
	   *
	   * An authoritative list can be found in the PHP `RenderingEngineDetector`
	   * class related classes in the same file (see calls to `new
	   * UserAgentRenderingEngine` here: https://fburl.com/50728617).
	   *
	   * @note Function results are memoized
	   *
	   * @param {string} query Query of the form "Name [range expression]"
	   * @return {boolean}
	   */
	  isEngine: function isEngine(query) {
	    return compare(UserAgentData.engineName, UserAgentData.engineVersion, query);
	  },
	
	  /**
	   * Check if the User Agent platform matches `query`.
	   *
	   * `query` should be a string like "Windows" or "iOS 5 - 6".
	   *
	   * Valid platform names include:
	   *
	   * - Android
	   * - BlackBerry OS
	   * - Java ME
	   * - Linux
	   * - Mac OS X
	   * - Mac OS X Calendar
	   * - Mac OS X Internet Account
	   * - Symbian
	   * - SymbianOS
	   * - Windows
	   * - Windows Mobile
	   * - Windows Phone
	   * - iOS
	   * - iOS Facebook Integration Account
	   * - iOS Facebook Social Sharing UI
	   * - webOS
	   * - Chrome OS
	   * - etc...
	   *
	   * An authoritative list can be found in the PHP `PlatformDetector` class and
	   * related classes in the same file (see calls to `new UserAgentPlatform`
	   * here: https://fburl.com/50729226).
	   *
	   * @note Function results are memoized
	   *
	   * @param {string} query Query of the form "Name [range expression]"
	   * @return {boolean}
	   */
	  isPlatform: function isPlatform(query) {
	    return compare(UserAgentData.platformName, UserAgentData.platformFullVersion, query, normalizePlatformVersion);
	  },
	
	  /**
	   * Check if the User Agent platform is a 32 or 64 bit architecture.
	   *
	   * @note Function results are memoized
	   *
	   * @param {string} query Query of the form "32" or "64".
	   * @return {boolean}
	   */
	  isPlatformArchitecture: function isPlatformArchitecture(query) {
	    return compare(UserAgentData.platformArchitecture, null, query);
	  }
	};
	module.exports = mapObject(UserAgent, memoizeStringOnly);

/***/ },
/* 61 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	var nullthrows = function nullthrows(x) {
	  if (x != null) {
	    return x;
	  }
	
	  throw new Error("Got unexpected null or undefined");
	};
	
	module.exports = nullthrows;

/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var fails = __webpack_require__(50);
	
	// Detect IE8's incomplete defineProperty implementation
	module.exports = !fails(function () {
	  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
	  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] !== 7;
	});


/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(355);
	
	// utils is a library of generic helper functions non-specific to axios
	
	var toString = Object.prototype.toString;
	
	/**
	 * Determine if a value is an Array
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Array, otherwise false
	 */
	function isArray(val) {
	  return toString.call(val) === '[object Array]';
	}
	
	/**
	 * Determine if a value is undefined
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if the value is undefined, otherwise false
	 */
	function isUndefined(val) {
	  return typeof val === 'undefined';
	}
	
	/**
	 * Determine if a value is a Buffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Buffer, otherwise false
	 */
	function isBuffer(val) {
	  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
	    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
	}
	
	/**
	 * Determine if a value is an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
	 */
	function isArrayBuffer(val) {
	  return toString.call(val) === '[object ArrayBuffer]';
	}
	
	/**
	 * Determine if a value is a FormData
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an FormData, otherwise false
	 */
	function isFormData(val) {
	  return (typeof FormData !== 'undefined') && (val instanceof FormData);
	}
	
	/**
	 * Determine if a value is a view on an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
	 */
	function isArrayBufferView(val) {
	  var result;
	  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
	    result = ArrayBuffer.isView(val);
	  } else {
	    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
	  }
	  return result;
	}
	
	/**
	 * Determine if a value is a String
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a String, otherwise false
	 */
	function isString(val) {
	  return typeof val === 'string';
	}
	
	/**
	 * Determine if a value is a Number
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Number, otherwise false
	 */
	function isNumber(val) {
	  return typeof val === 'number';
	}
	
	/**
	 * Determine if a value is an Object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Object, otherwise false
	 */
	function isObject(val) {
	  return val !== null && typeof val === 'object';
	}
	
	/**
	 * Determine if a value is a plain Object
	 *
	 * @param {Object} val The value to test
	 * @return {boolean} True if value is a plain Object, otherwise false
	 */
	function isPlainObject(val) {
	  if (toString.call(val) !== '[object Object]') {
	    return false;
	  }
	
	  var prototype = Object.getPrototypeOf(val);
	  return prototype === null || prototype === Object.prototype;
	}
	
	/**
	 * Determine if a value is a Date
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Date, otherwise false
	 */
	function isDate(val) {
	  return toString.call(val) === '[object Date]';
	}
	
	/**
	 * Determine if a value is a File
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a File, otherwise false
	 */
	function isFile(val) {
	  return toString.call(val) === '[object File]';
	}
	
	/**
	 * Determine if a value is a Blob
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Blob, otherwise false
	 */
	function isBlob(val) {
	  return toString.call(val) === '[object Blob]';
	}
	
	/**
	 * Determine if a value is a Function
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Function, otherwise false
	 */
	function isFunction(val) {
	  return toString.call(val) === '[object Function]';
	}
	
	/**
	 * Determine if a value is a Stream
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Stream, otherwise false
	 */
	function isStream(val) {
	  return isObject(val) && isFunction(val.pipe);
	}
	
	/**
	 * Determine if a value is a URLSearchParams object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
	 */
	function isURLSearchParams(val) {
	  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
	}
	
	/**
	 * Trim excess whitespace off the beginning and end of a string
	 *
	 * @param {String} str The String to trim
	 * @returns {String} The String freed of excess whitespace
	 */
	function trim(str) {
	  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
	}
	
	/**
	 * Determine if we're running in a standard browser environment
	 *
	 * This allows axios to run in a web worker, and react-native.
	 * Both environments support XMLHttpRequest, but not fully standard globals.
	 *
	 * web workers:
	 *  typeof window -> undefined
	 *  typeof document -> undefined
	 *
	 * react-native:
	 *  navigator.product -> 'ReactNative'
	 * nativescript
	 *  navigator.product -> 'NativeScript' or 'NS'
	 */
	function isStandardBrowserEnv() {
	  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
	                                           navigator.product === 'NativeScript' ||
	                                           navigator.product === 'NS')) {
	    return false;
	  }
	  return (
	    typeof window !== 'undefined' &&
	    typeof document !== 'undefined'
	  );
	}
	
	/**
	 * Iterate over an Array or an Object invoking a function for each item.
	 *
	 * If `obj` is an Array callback will be called passing
	 * the value, index, and complete array for each item.
	 *
	 * If 'obj' is an Object callback will be called passing
	 * the value, key, and complete object for each property.
	 *
	 * @param {Object|Array} obj The object to iterate
	 * @param {Function} fn The callback to invoke for each item
	 */
	function forEach(obj, fn) {
	  // Don't bother if no value provided
	  if (obj === null || typeof obj === 'undefined') {
	    return;
	  }
	
	  // Force an array if not already something iterable
	  if (typeof obj !== 'object') {
	    /*eslint no-param-reassign:0*/
	    obj = [obj];
	  }
	
	  if (isArray(obj)) {
	    // Iterate over array values
	    for (var i = 0, l = obj.length; i < l; i++) {
	      fn.call(null, obj[i], i, obj);
	    }
	  } else {
	    // Iterate over object keys
	    for (var key in obj) {
	      if (Object.prototype.hasOwnProperty.call(obj, key)) {
	        fn.call(null, obj[key], key, obj);
	      }
	    }
	  }
	}
	
	/**
	 * Accepts varargs expecting each argument to be an object, then
	 * immutably merges the properties of each object and returns result.
	 *
	 * When multiple objects contain the same key the later object in
	 * the arguments list will take precedence.
	 *
	 * Example:
	 *
	 * ```js
	 * var result = merge({foo: 123}, {foo: 456});
	 * console.log(result.foo); // outputs 456
	 * ```
	 *
	 * @param {Object} obj1 Object to merge
	 * @returns {Object} Result of all merge properties
	 */
	function merge(/* obj1, obj2, obj3, ... */) {
	  var result = {};
	  function assignValue(val, key) {
	    if (isPlainObject(result[key]) && isPlainObject(val)) {
	      result[key] = merge(result[key], val);
	    } else if (isPlainObject(val)) {
	      result[key] = merge({}, val);
	    } else if (isArray(val)) {
	      result[key] = val.slice();
	    } else {
	      result[key] = val;
	    }
	  }
	
	  for (var i = 0, l = arguments.length; i < l; i++) {
	    forEach(arguments[i], assignValue);
	  }
	  return result;
	}
	
	/**
	 * Extends object a by mutably adding to it the properties of object b.
	 *
	 * @param {Object} a The object to be extended
	 * @param {Object} b The object to copy properties from
	 * @param {Object} thisArg The object to bind function to
	 * @return {Object} The resulting value of object a
	 */
	function extend(a, b, thisArg) {
	  forEach(b, function assignValue(val, key) {
	    if (thisArg && typeof val === 'function') {
	      a[key] = bind(val, thisArg);
	    } else {
	      a[key] = val;
	    }
	  });
	  return a;
	}
	
	/**
	 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
	 *
	 * @param {string} content with BOM
	 * @return {string} content value without BOM
	 */
	function stripBOM(content) {
	  if (content.charCodeAt(0) === 0xFEFF) {
	    content = content.slice(1);
	  }
	  return content;
	}
	
	module.exports = {
	  isArray: isArray,
	  isArrayBuffer: isArrayBuffer,
	  isBuffer: isBuffer,
	  isFormData: isFormData,
	  isArrayBufferView: isArrayBufferView,
	  isString: isString,
	  isNumber: isNumber,
	  isObject: isObject,
	  isPlainObject: isPlainObject,
	  isUndefined: isUndefined,
	  isDate: isDate,
	  isFile: isFile,
	  isBlob: isBlob,
	  isFunction: isFunction,
	  isStream: isStream,
	  isURLSearchParams: isURLSearchParams,
	  isStandardBrowserEnv: isStandardBrowserEnv,
	  forEach: forEach,
	  merge: merge,
	  extend: extend,
	  trim: trim,
	  stripBOM: stripBOM
	};


/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function TabsPane(_ref) {
	  var className = _ref.className,
	      id = _ref.id,
	      style = _ref.style,
	      children = _ref.children,
	      restProps = _objectWithoutProperties(_ref, ["className", "id", "style", "children"]);
	
	  return _react2.default.createElement(
	    "div",
	    Object.assign({ className: "tab-panel " + className, style: style, name: id }, restProps),
	    children
	  );
	}
	
	exports.default = TabsPane;

/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactFeather = __webpack_require__(1379);
	
	var ReactFeather = _interopRequireWildcard(_reactFeather);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _easyConst = __webpack_require__(886);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Tabs(_ref) {
	  var childTabs = _ref.childTabs,
	      tabsetName = _ref.tabsetName,
	      onTabChange = _ref.onTabChange,
	      children = _ref.children;
	
	  var onChange = onTabChange ? function (e) {
	    return onTabChange(e.target.id);
	  } : _easyConst.noop;
	  return _react2.default.createElement(
	    "div",
	    { className: "tabset " },
	    childTabs.map(function (eachTab, i) {
	      var eachTabIcon = eachTab["icon"];
	      var Icon = ReactFeather[eachTabIcon];
	      var labelStyle = eachTab["disabled"] ? {
	        textTransform: "capitalize",
	        color: "#475668",
	        border: "0px #d8d8d8",
	        cursor: "not-allowed",
	        pointerEvents: "none",
	        opacity: "0.2"
	      } : { textTransform: "capitalize" };
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        { key: i },
	        _react2.default.createElement("input", Object.assign({ type: "radio" }, eachTab, { name: tabsetName, onChange: onChange })),
	        _react2.default.createElement(
	          "label",
	          { style: labelStyle, htmlFor: eachTab.id },
	          eachTabIcon && _react2.default.createElement(Icon, null),
	          _react2.default.createElement("span", { dangerouslySetInnerHTML: { __html: eachTab.name } })
	        )
	      );
	    }),
	    _react2.default.createElement(
	      "div",
	      { className: "tab-panels" },
	      children
	    )
	  );
	}
	Tabs.propTypes = _propTypes2.default.shape({
	  childTabs: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    name: _propTypes2.default.string,
	    id: _propTypes2.default.string,
	    defaultChecked: _propTypes2.default.bool,
	    disabled: _propTypes2.default.bool
	  })),
	  tabsetName: _propTypes2.default.string,
	  onTabChange: _propTypes2.default.func
	});
	/*        
	  children:
	    <Tabs {...PropsToPass}>
	      <TabsPane id="myProfile" className="optional-classname" >
	            // Tab Element
	      </TabsPane>
	    </Tabs>              
	*/
	
	exports.default = Tabs;

/***/ },
/* 66 */
18,
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var globalThis = __webpack_require__(54);
	var getOwnPropertyDescriptor = __webpack_require__(285).f;
	var createNonEnumerableProperty = __webpack_require__(204);
	var defineBuiltIn = __webpack_require__(129);
	var defineGlobalProperty = __webpack_require__(281);
	var copyConstructorProperties = __webpack_require__(601);
	var isForced = __webpack_require__(1399);
	
	/*
	  options.target         - name of the target object
	  options.global         - target is the global object
	  options.stat           - export as static methods of target
	  options.proto          - export as prototype methods of target
	  options.real           - real prototype method for the `pure` version
	  options.forced         - export even if the native feature is available
	  options.bind           - bind methods to the target, required for the `pure` version
	  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
	  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
	  options.sham           - add a flag to not completely full polyfills
	  options.enumerable     - export as enumerable property
	  options.dontCallGetSet - prevent calling a getter on target
	  options.name           - the .name of the function if it does not match the key
	*/
	module.exports = function (options, source) {
	  var TARGET = options.target;
	  var GLOBAL = options.global;
	  var STATIC = options.stat;
	  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
	  if (GLOBAL) {
	    target = globalThis;
	  } else if (STATIC) {
	    target = globalThis[TARGET] || defineGlobalProperty(TARGET, {});
	  } else {
	    target = globalThis[TARGET] && globalThis[TARGET].prototype;
	  }
	  if (target) for (key in source) {
	    sourceProperty = source[key];
	    if (options.dontCallGetSet) {
	      descriptor = getOwnPropertyDescriptor(target, key);
	      targetProperty = descriptor && descriptor.value;
	    } else targetProperty = target[key];
	    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
	    // contained in target
	    if (!FORCED && targetProperty !== undefined) {
	      if (typeof sourceProperty == typeof targetProperty) continue;
	      copyConstructorProperties(sourceProperty, targetProperty);
	    }
	    // add a flag to not completely full polyfills
	    if (options.sham || (targetProperty && targetProperty.sham)) {
	      createNonEnumerableProperty(sourceProperty, 'sham', true);
	    }
	    defineBuiltIn(target, key, sourceProperty, options);
	  }
	};


/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = useForkRef;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _setRef = _interopRequireDefault(__webpack_require__(143));
	
	function useForkRef(refA, refB) {
	  /**
	   * This will create a new function if the ref props change and are defined.
	   * This means react will call the old forkRef with `null` and the new forkRef
	   * with the ref. Cleanup naturally emerges from this behavior
	   */
	  return React.useMemo(function () {
	    if (refA == null && refB == null) {
	      return null;
	    }
	
	    return function (refValue) {
	      (0, _setRef.default)(refA, refValue);
	      (0, _setRef.default)(refB, refValue);
	    };
	  }, [refA, refB]);
	}

/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright (c) 2017-present, Ephox, Inc.
	 *
	 * This source code is licensed under the Apache 2 license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.Editor = void 0;
	var Editor_1 = __webpack_require__(846);
	Object.defineProperty(exports, "Editor", { enumerable: true, get: function () { return Editor_1.Editor; } });


/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	var _require = __webpack_require__(27),
	    Map = _require.Map,
	    OrderedSet = _require.OrderedSet,
	    Record = _require.Record; // Immutable.map is typed such that the value for every key in the map
	// must be the same type
	
	
	var EMPTY_SET = OrderedSet();
	var defaultRecord = {
	  style: EMPTY_SET,
	  entity: null
	};
	var CharacterMetadataRecord = Record(defaultRecord);
	
	var CharacterMetadata = /*#__PURE__*/function (_CharacterMetadataRec) {
	  _inheritsLoose(CharacterMetadata, _CharacterMetadataRec);
	
	  function CharacterMetadata() {
	    return _CharacterMetadataRec.apply(this, arguments) || this;
	  }
	
	  var _proto = CharacterMetadata.prototype;
	
	  _proto.getStyle = function getStyle() {
	    return this.get('style');
	  };
	
	  _proto.getEntity = function getEntity() {
	    return this.get('entity');
	  };
	
	  _proto.hasStyle = function hasStyle(style) {
	    return this.getStyle().includes(style);
	  };
	
	  CharacterMetadata.applyStyle = function applyStyle(record, style) {
	    var withStyle = record.set('style', record.getStyle().add(style));
	    return CharacterMetadata.create(withStyle);
	  };
	
	  CharacterMetadata.removeStyle = function removeStyle(record, style) {
	    var withoutStyle = record.set('style', record.getStyle().remove(style));
	    return CharacterMetadata.create(withoutStyle);
	  };
	
	  CharacterMetadata.applyEntity = function applyEntity(record, entityKey) {
	    var withEntity = record.getEntity() === entityKey ? record : record.set('entity', entityKey);
	    return CharacterMetadata.create(withEntity);
	  }
	  /**
	   * Use this function instead of the `CharacterMetadata` constructor.
	   * Since most content generally uses only a very small number of
	   * style/entity permutations, we can reuse these objects as often as
	   * possible.
	   */
	  ;
	
	  CharacterMetadata.create = function create(config) {
	    if (!config) {
	      return EMPTY;
	    }
	
	    var defaultConfig = {
	      style: EMPTY_SET,
	      entity: null
	    }; // Fill in unspecified properties, if necessary.
	
	    var configMap = Map(defaultConfig).merge(config);
	    var existing = pool.get(configMap);
	
	    if (existing) {
	      return existing;
	    }
	
	    var newCharacter = new CharacterMetadata(configMap);
	    pool = pool.set(configMap, newCharacter);
	    return newCharacter;
	  };
	
	  CharacterMetadata.fromJS = function fromJS(_ref) {
	    var style = _ref.style,
	        entity = _ref.entity;
	    return new CharacterMetadata({
	      style: Array.isArray(style) ? OrderedSet(style) : style,
	      entity: Array.isArray(entity) ? OrderedSet(entity) : entity
	    });
	  };
	
	  return CharacterMetadata;
	}(CharacterMetadataRecord);
	
	var EMPTY = new CharacterMetadata();
	var pool = Map([[Map(defaultRecord), EMPTY]]);
	CharacterMetadata.EMPTY = EMPTY;
	module.exports = CharacterMetadata;

/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 *
	 * This file is a fork of ContentBlock adding support for nesting references by
	 * providing links to children, parent, prevSibling, and nextSibling.
	 *
	 * This is unstable and not part of the public API and should not be used by
	 * production systems. This file may be update/removed without notice.
	 */
	'use strict';
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	var CharacterMetadata = __webpack_require__(70);
	
	var findRangesImmutable = __webpack_require__(152);
	
	var Immutable = __webpack_require__(27);
	
	var List = Immutable.List,
	    Map = Immutable.Map,
	    OrderedSet = Immutable.OrderedSet,
	    Record = Immutable.Record,
	    Repeat = Immutable.Repeat;
	var EMPTY_SET = OrderedSet();
	var defaultRecord = {
	  parent: null,
	  characterList: List(),
	  data: Map(),
	  depth: 0,
	  key: '',
	  text: '',
	  type: 'unstyled',
	  children: List(),
	  prevSibling: null,
	  nextSibling: null
	};
	
	var haveEqualStyle = function haveEqualStyle(charA, charB) {
	  return charA.getStyle() === charB.getStyle();
	};
	
	var haveEqualEntity = function haveEqualEntity(charA, charB) {
	  return charA.getEntity() === charB.getEntity();
	};
	
	var decorateCharacterList = function decorateCharacterList(config) {
	  if (!config) {
	    return config;
	  }
	
	  var characterList = config.characterList,
	      text = config.text;
	
	  if (text && !characterList) {
	    config.characterList = List(Repeat(CharacterMetadata.EMPTY, text.length));
	  }
	
	  return config;
	};
	
	var ContentBlockNode = /*#__PURE__*/function (_ref) {
	  _inheritsLoose(ContentBlockNode, _ref);
	
	  function ContentBlockNode() {
	    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultRecord;
	
	    /* eslint-disable-next-line constructor-super */
	    return _ref.call(this, decorateCharacterList(props)) || this;
	  }
	
	  var _proto = ContentBlockNode.prototype;
	
	  _proto.getKey = function getKey() {
	    return this.get('key');
	  };
	
	  _proto.getType = function getType() {
	    return this.get('type');
	  };
	
	  _proto.getText = function getText() {
	    return this.get('text');
	  };
	
	  _proto.getCharacterList = function getCharacterList() {
	    return this.get('characterList');
	  };
	
	  _proto.getLength = function getLength() {
	    return this.getText().length;
	  };
	
	  _proto.getDepth = function getDepth() {
	    return this.get('depth');
	  };
	
	  _proto.getData = function getData() {
	    return this.get('data');
	  };
	
	  _proto.getInlineStyleAt = function getInlineStyleAt(offset) {
	    var character = this.getCharacterList().get(offset);
	    return character ? character.getStyle() : EMPTY_SET;
	  };
	
	  _proto.getEntityAt = function getEntityAt(offset) {
	    var character = this.getCharacterList().get(offset);
	    return character ? character.getEntity() : null;
	  };
	
	  _proto.getChildKeys = function getChildKeys() {
	    return this.get('children');
	  };
	
	  _proto.getParentKey = function getParentKey() {
	    return this.get('parent');
	  };
	
	  _proto.getPrevSiblingKey = function getPrevSiblingKey() {
	    return this.get('prevSibling');
	  };
	
	  _proto.getNextSiblingKey = function getNextSiblingKey() {
	    return this.get('nextSibling');
	  };
	
	  _proto.findStyleRanges = function findStyleRanges(filterFn, callback) {
	    findRangesImmutable(this.getCharacterList(), haveEqualStyle, filterFn, callback);
	  };
	
	  _proto.findEntityRanges = function findEntityRanges(filterFn, callback) {
	    findRangesImmutable(this.getCharacterList(), haveEqualEntity, filterFn, callback);
	  };
	
	  return ContentBlockNode;
	}(Record(defaultRecord));
	
	module.exports = ContentBlockNode;

/***/ },
/* 72 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * A worker that does nothing but passing chunks to the next one. This is like
	 * a nodejs stream but with some differences. On the good side :
	 * - it works on IE 6-9 without any issue / polyfill
	 * - it weights less than the full dependencies bundled with browserify
	 * - it forwards errors (no need to declare an error handler EVERYWHERE)
	 *
	 * A chunk is an object with 2 attributes : `meta` and `data`. The former is an
	 * object containing anything (`percent` for example), see each worker for more
	 * details. The latter is the real data (String, Uint8Array, etc).
	 *
	 * @constructor
	 * @param {String} name the name of the stream (mainly used for debugging purposes)
	 */
	function GenericWorker(name) {
	    // the name of the worker
	    this.name = name || "default";
	    // an object containing metadata about the workers chain
	    this.streamInfo = {};
	    // an error which happened when the worker was paused
	    this.generatedError = null;
	    // an object containing metadata to be merged by this worker into the general metadata
	    this.extraStreamInfo = {};
	    // true if the stream is paused (and should not do anything), false otherwise
	    this.isPaused = true;
	    // true if the stream is finished (and should not do anything), false otherwise
	    this.isFinished = false;
	    // true if the stream is locked to prevent further structure updates (pipe), false otherwise
	    this.isLocked = false;
	    // the event listeners
	    this._listeners = {
	        "data":[],
	        "end":[],
	        "error":[]
	    };
	    // the previous worker, if any
	    this.previous = null;
	}
	
	GenericWorker.prototype = {
	    /**
	     * Push a chunk to the next workers.
	     * @param {Object} chunk the chunk to push
	     */
	    push : function (chunk) {
	        this.emit("data", chunk);
	    },
	    /**
	     * End the stream.
	     * @return {Boolean} true if this call ended the worker, false otherwise.
	     */
	    end : function () {
	        if (this.isFinished) {
	            return false;
	        }
	
	        this.flush();
	        try {
	            this.emit("end");
	            this.cleanUp();
	            this.isFinished = true;
	        } catch (e) {
	            this.emit("error", e);
	        }
	        return true;
	    },
	    /**
	     * End the stream with an error.
	     * @param {Error} e the error which caused the premature end.
	     * @return {Boolean} true if this call ended the worker with an error, false otherwise.
	     */
	    error : function (e) {
	        if (this.isFinished) {
	            return false;
	        }
	
	        if(this.isPaused) {
	            this.generatedError = e;
	        } else {
	            this.isFinished = true;
	
	            this.emit("error", e);
	
	            // in the workers chain exploded in the middle of the chain,
	            // the error event will go downward but we also need to notify
	            // workers upward that there has been an error.
	            if(this.previous) {
	                this.previous.error(e);
	            }
	
	            this.cleanUp();
	        }
	        return true;
	    },
	    /**
	     * Add a callback on an event.
	     * @param {String} name the name of the event (data, end, error)
	     * @param {Function} listener the function to call when the event is triggered
	     * @return {GenericWorker} the current object for chainability
	     */
	    on : function (name, listener) {
	        this._listeners[name].push(listener);
	        return this;
	    },
	    /**
	     * Clean any references when a worker is ending.
	     */
	    cleanUp : function () {
	        this.streamInfo = this.generatedError = this.extraStreamInfo = null;
	        this._listeners = [];
	    },
	    /**
	     * Trigger an event. This will call registered callback with the provided arg.
	     * @param {String} name the name of the event (data, end, error)
	     * @param {Object} arg the argument to call the callback with.
	     */
	    emit : function (name, arg) {
	        if (this._listeners[name]) {
	            for(var i = 0; i < this._listeners[name].length; i++) {
	                this._listeners[name][i].call(this, arg);
	            }
	        }
	    },
	    /**
	     * Chain a worker with an other.
	     * @param {Worker} next the worker receiving events from the current one.
	     * @return {worker} the next worker for chainability
	     */
	    pipe : function (next) {
	        return next.registerPrevious(this);
	    },
	    /**
	     * Same as `pipe` in the other direction.
	     * Using an API with `pipe(next)` is very easy.
	     * Implementing the API with the point of view of the next one registering
	     * a source is easier, see the ZipFileWorker.
	     * @param {Worker} previous the previous worker, sending events to this one
	     * @return {Worker} the current worker for chainability
	     */
	    registerPrevious : function (previous) {
	        if (this.isLocked) {
	            throw new Error("The stream '" + this + "' has already been used.");
	        }
	
	        // sharing the streamInfo...
	        this.streamInfo = previous.streamInfo;
	        // ... and adding our own bits
	        this.mergeStreamInfo();
	        this.previous =  previous;
	        var self = this;
	        previous.on("data", function (chunk) {
	            self.processChunk(chunk);
	        });
	        previous.on("end", function () {
	            self.end();
	        });
	        previous.on("error", function (e) {
	            self.error(e);
	        });
	        return this;
	    },
	    /**
	     * Pause the stream so it doesn't send events anymore.
	     * @return {Boolean} true if this call paused the worker, false otherwise.
	     */
	    pause : function () {
	        if(this.isPaused || this.isFinished) {
	            return false;
	        }
	        this.isPaused = true;
	
	        if(this.previous) {
	            this.previous.pause();
	        }
	        return true;
	    },
	    /**
	     * Resume a paused stream.
	     * @return {Boolean} true if this call resumed the worker, false otherwise.
	     */
	    resume : function () {
	        if(!this.isPaused || this.isFinished) {
	            return false;
	        }
	        this.isPaused = false;
	
	        // if true, the worker tried to resume but failed
	        var withError = false;
	        if(this.generatedError) {
	            this.error(this.generatedError);
	            withError = true;
	        }
	        if(this.previous) {
	            this.previous.resume();
	        }
	
	        return !withError;
	    },
	    /**
	     * Flush any remaining bytes as the stream is ending.
	     */
	    flush : function () {},
	    /**
	     * Process a chunk. This is usually the method overridden.
	     * @param {Object} chunk the chunk to process.
	     */
	    processChunk : function(chunk) {
	        this.push(chunk);
	    },
	    /**
	     * Add a key/value to be added in the workers chain streamInfo once activated.
	     * @param {String} key the key to use
	     * @param {Object} value the associated value
	     * @return {Worker} the current worker for chainability
	     */
	    withStreamInfo : function (key, value) {
	        this.extraStreamInfo[key] = value;
	        this.mergeStreamInfo();
	        return this;
	    },
	    /**
	     * Merge this worker's streamInfo into the chain's streamInfo.
	     */
	    mergeStreamInfo : function () {
	        for(var key in this.extraStreamInfo) {
	            if (!Object.prototype.hasOwnProperty.call(this.extraStreamInfo, key)) {
	                continue;
	            }
	            this.streamInfo[key] = this.extraStreamInfo[key];
	        }
	    },
	
	    /**
	     * Lock the stream to prevent further updates on the workers chain.
	     * After calling this method, all calls to pipe will fail.
	     */
	    lock: function () {
	        if (this.isLocked) {
	            throw new Error("The stream '" + this + "' has already been used.");
	        }
	        this.isLocked = true;
	        if (this.previous) {
	            this.previous.lock();
	        }
	    },
	
	    /**
	     *
	     * Pretty print the workers chain.
	     */
	    toString : function () {
	        var me = "Worker " + this.name;
	        if (this.previous) {
	            return this.previous + " -> " + me;
	        } else {
	            return me;
	        }
	    }
	};
	
	module.exports = GenericWorker;


/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	
	'use strict'
	
	if (true) {
	  module.exports = __webpack_require__(1349)
	} else {
	  module.exports = require('./multiselect-react-dropdown.cjs.development.js')
	}


/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var isCallable = __webpack_require__(52);
	
	module.exports = function (it) {
	  return typeof it == 'object' ? it !== null : isCallable(it);
	};


/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var DESCRIPTORS = __webpack_require__(62);
	var IE8_DOM_DEFINE = __webpack_require__(606);
	var V8_PROTOTYPE_DEFINE_BUG = __webpack_require__(623);
	var anObject = __webpack_require__(161);
	var toPropertyKey = __webpack_require__(292);
	
	var $TypeError = TypeError;
	// eslint-disable-next-line es/no-object-defineproperty -- safe
	var $defineProperty = Object.defineProperty;
	// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
	var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var ENUMERABLE = 'enumerable';
	var CONFIGURABLE = 'configurable';
	var WRITABLE = 'writable';
	
	// `Object.defineProperty` method
	// https://tc39.es/ecma262/#sec-object.defineproperty
	exports.f = DESCRIPTORS ? V8_PROTOTYPE_DEFINE_BUG ? function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPropertyKey(P);
	  anObject(Attributes);
	  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
	    var current = $getOwnPropertyDescriptor(O, P);
	    if (current && current[WRITABLE]) {
	      O[P] = Attributes.value;
	      Attributes = {
	        configurable: CONFIGURABLE in Attributes ? Attributes[CONFIGURABLE] : current[CONFIGURABLE],
	        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
	        writable: false
	      };
	    }
	  } return $defineProperty(O, P, Attributes);
	} : $defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPropertyKey(P);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return $defineProperty(O, P, Attributes);
	  } catch (error) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw new $TypeError('Accessors not supported');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var globalThis = __webpack_require__(54);
	var shared = __webpack_require__(166);
	var hasOwn = __webpack_require__(51);
	var uid = __webpack_require__(210);
	var NATIVE_SYMBOL = __webpack_require__(131);
	var USE_SYMBOL_AS_UID = __webpack_require__(622);
	
	var Symbol = globalThis.Symbol;
	var WellKnownSymbolsStore = shared('wks');
	var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol['for'] || Symbol : Symbol && Symbol.withoutSetter || uid;
	
	module.exports = function (name) {
	  if (!hasOwn(WellKnownSymbolsStore, name)) {
	    WellKnownSymbolsStore[name] = NATIVE_SYMBOL && hasOwn(Symbol, name)
	      ? Symbol[name]
	      : createWellKnownSymbol('Symbol.' + name);
	  } return WellKnownSymbolsStore[name];
	};


/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var PropTypes = _interopDefault(__webpack_require__(3));
	var withSideEffect = _interopDefault(__webpack_require__(1509));
	var isEqual = _interopDefault(__webpack_require__(1378));
	var React = _interopDefault(__webpack_require__(1));
	var objectAssign = _interopDefault(__webpack_require__(58));
	
	var ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src",
	    TARGET: "target"
	};
	
	var REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = "data-react-helmet";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	  return typeof obj;
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	};
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	var inherits = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	var objectWithoutProperties = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};
	
	var possibleConstructorReturn = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	};
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return Array.isArray(innermostTitle) ? innermostTitle.join("") : innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === TAG_PROPERTIES.INNER_HTML || attributeKey === TAG_PROPERTIES.CSS_TEXT || attributeKey === TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = objectAssign({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([TAG_PROPERTIES.HREF, TAG_PROPERTIES.TARGET], propsList),
	        bodyAttributes: getAttributesFromPropsList(ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(TAG_NAMES.LINK, [TAG_PROPERTIES.REL, TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(TAG_NAMES.META, [TAG_PROPERTIES.NAME, TAG_PROPERTIES.CHARSET, TAG_PROPERTIES.HTTPEQUIV, TAG_PROPERTIES.PROPERTY, TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(TAG_NAMES.NOSCRIPT, [TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(TAG_NAMES.SCRIPT, [TAG_PROPERTIES.SRC, TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(TAG_NAMES.STYLE, [TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame && window.requestAnimationFrame.bind(window) || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === TAG_PROPERTIES.INNER_HTML || attribute === TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [React.createElement(TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === TAG_PROPERTIES.INNER_HTML || mappedAttribute === TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return React.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case ATTRIBUTE_NAMES.BODY:
	        case ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            classCallCheck(this, HelmetWrapper);
	            return possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !isEqual(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case TAG_NAMES.SCRIPT:
	                case TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _babelHelpers$extends;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_babelHelpers$extends = {}, _babelHelpers$extends[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _babelHelpers$extends));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _babelHelpers$extends2, _babelHelpers$extends3;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_babelHelpers$extends2 = {}, _babelHelpers$extends2[child.type] = nestedChildren, _babelHelpers$extends2.titleAttributes = _extends({}, newChildProps), _babelHelpers$extends2));
	
	                case TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_babelHelpers$extends3 = {}, _babelHelpers$extends3[child.type] = _extends({}, newChildProps), _babelHelpers$extends3));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _babelHelpers$extends4;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_babelHelpers$extends4 = {}, _babelHelpers$extends4[arrayChildName] = arrayTypeChildren[arrayChildName], _babelHelpers$extends4));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return warn("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return warn("Only elements types " + VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            React.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = convertReactPropstoHtmlAttributes(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case TAG_NAMES.LINK:
	                    case TAG_NAMES.META:
	                    case TAG_NAMES.NOSCRIPT:
	                    case TAG_NAMES.SCRIPT:
	                    case TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return React.createElement(Component, newProps);
	        };
	
	        createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	             * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	             * @param {Object} bodyAttributes: {"className": "root"}
	             * @param {String} defaultTitle: "Default Title"
	             * @param {Boolean} defer: true
	             * @param {Boolean} encodeSpecialCharacters: true
	             * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	             * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	             * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	             * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	             * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	             * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	             * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	             * @param {String} title: "Title"
	             * @param {Object} titleAttributes: {"itemprop": "name"}
	             * @param {String} titleTemplate: "MySite.com - %s"
	             */
	            set: function set$$1(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	        return HelmetWrapper;
	    }(React.Component), _class.propTypes = {
	        base: PropTypes.object,
	        bodyAttributes: PropTypes.object,
	        children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
	        defaultTitle: PropTypes.string,
	        defer: PropTypes.bool,
	        encodeSpecialCharacters: PropTypes.bool,
	        htmlAttributes: PropTypes.object,
	        link: PropTypes.arrayOf(PropTypes.object),
	        meta: PropTypes.arrayOf(PropTypes.object),
	        noscript: PropTypes.arrayOf(PropTypes.object),
	        onChangeClientState: PropTypes.func,
	        script: PropTypes.arrayOf(PropTypes.object),
	        style: PropTypes.arrayOf(PropTypes.object),
	        title: PropTypes.string,
	        titleAttributes: PropTypes.object,
	        titleTemplate: PropTypes.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = mapStateOnServer({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = withSideEffect(reducePropsToState, handleClientStateChange, mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = capitalize;
	
	var _utils = __webpack_require__(26);
	
	// It should to be noted that this function isn't equivalent to `text-transform: capitalize`.
	//
	// A strict capitalization should uppercase the first letter of each word a the sentence.
	// We only handle the first word.
	function capitalize(string) {
	  if (typeof string !== 'string') {
	    throw new Error( false ? "Material-UI: capitalize(string) expects a string argument." : (0, _utils.formatMuiErrorMessage)(7));
	  }
	
	  return string.charAt(0).toUpperCase() + string.slice(1);
	}

/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Rangeslider = __webpack_require__(1449);
	
	var _Rangeslider2 = _interopRequireDefault(_Rangeslider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Rangeslider2.default;

/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	/** @license Material-UI v4.11.5
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var _exportNames = {
	  createGenerateClassName: true,
	  createStyles: true,
	  getThemeProps: true,
	  jssPreset: true,
	  makeStyles: true,
	  mergeClasses: true,
	  ServerStyleSheets: true,
	  styled: true,
	  StylesProvider: true,
	  ThemeProvider: true,
	  useTheme: true,
	  withStyles: true,
	  withTheme: true
	};
	Object.defineProperty(exports, "createGenerateClassName", {
	  enumerable: true,
	  get: function get() {
	    return _createGenerateClassName.default;
	  }
	});
	Object.defineProperty(exports, "createStyles", {
	  enumerable: true,
	  get: function get() {
	    return _createStyles.default;
	  }
	});
	Object.defineProperty(exports, "getThemeProps", {
	  enumerable: true,
	  get: function get() {
	    return _getThemeProps.default;
	  }
	});
	Object.defineProperty(exports, "jssPreset", {
	  enumerable: true,
	  get: function get() {
	    return _jssPreset.default;
	  }
	});
	Object.defineProperty(exports, "makeStyles", {
	  enumerable: true,
	  get: function get() {
	    return _makeStyles.default;
	  }
	});
	Object.defineProperty(exports, "mergeClasses", {
	  enumerable: true,
	  get: function get() {
	    return _mergeClasses.default;
	  }
	});
	Object.defineProperty(exports, "ServerStyleSheets", {
	  enumerable: true,
	  get: function get() {
	    return _ServerStyleSheets.default;
	  }
	});
	Object.defineProperty(exports, "styled", {
	  enumerable: true,
	  get: function get() {
	    return _styled.default;
	  }
	});
	Object.defineProperty(exports, "StylesProvider", {
	  enumerable: true,
	  get: function get() {
	    return _StylesProvider.default;
	  }
	});
	Object.defineProperty(exports, "ThemeProvider", {
	  enumerable: true,
	  get: function get() {
	    return _ThemeProvider.default;
	  }
	});
	Object.defineProperty(exports, "useTheme", {
	  enumerable: true,
	  get: function get() {
	    return _useTheme.default;
	  }
	});
	Object.defineProperty(exports, "withStyles", {
	  enumerable: true,
	  get: function get() {
	    return _withStyles.default;
	  }
	});
	Object.defineProperty(exports, "withTheme", {
	  enumerable: true,
	  get: function get() {
	    return _withTheme.default;
	  }
	});
	
	var _utils = __webpack_require__(26);
	
	var _createGenerateClassName = _interopRequireWildcard(__webpack_require__(240));
	
	Object.keys(_createGenerateClassName).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _createGenerateClassName[key];
	    }
	  });
	});
	
	var _createStyles = _interopRequireWildcard(__webpack_require__(796));
	
	Object.keys(_createStyles).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _createStyles[key];
	    }
	  });
	});
	
	var _getThemeProps = _interopRequireWildcard(__webpack_require__(336));
	
	Object.keys(_getThemeProps).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _getThemeProps[key];
	    }
	  });
	});
	
	var _jssPreset = _interopRequireWildcard(__webpack_require__(337));
	
	Object.keys(_jssPreset).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _jssPreset[key];
	    }
	  });
	});
	
	var _makeStyles = _interopRequireWildcard(__webpack_require__(241));
	
	Object.keys(_makeStyles).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _makeStyles[key];
	    }
	  });
	});
	
	var _mergeClasses = _interopRequireWildcard(__webpack_require__(338));
	
	Object.keys(_mergeClasses).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _mergeClasses[key];
	    }
	  });
	});
	
	var _ServerStyleSheets = _interopRequireWildcard(__webpack_require__(790));
	
	Object.keys(_ServerStyleSheets).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _ServerStyleSheets[key];
	    }
	  });
	});
	
	var _styled = _interopRequireWildcard(__webpack_require__(805));
	
	Object.keys(_styled).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _styled[key];
	    }
	  });
	});
	
	var _StylesProvider = _interopRequireWildcard(__webpack_require__(239));
	
	Object.keys(_StylesProvider).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _StylesProvider[key];
	    }
	  });
	});
	
	var _ThemeProvider = _interopRequireWildcard(__webpack_require__(793));
	
	Object.keys(_ThemeProvider).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _ThemeProvider[key];
	    }
	  });
	});
	
	var _useTheme = _interopRequireWildcard(__webpack_require__(144));
	
	Object.keys(_useTheme).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _useTheme[key];
	    }
	  });
	});
	
	var _withStyles = _interopRequireWildcard(__webpack_require__(808));
	
	Object.keys(_withStyles).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _withStyles[key];
	    }
	  });
	});
	
	var _withTheme = _interopRequireWildcard(__webpack_require__(810));
	
	Object.keys(_withTheme).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _withTheme[key];
	    }
	  });
	});
	
	/* eslint-disable import/export */
	
	/* Warning if there are several instances of @material-ui/styles */
	if (false) {
	  _utils.ponyfillGlobal['__@material-ui/styles-init__'] = _utils.ponyfillGlobal['__@material-ui/styles-init__'] || 0;
	
	  if (_utils.ponyfillGlobal['__@material-ui/styles-init__'] === 1) {
	    console.warn(['It looks like there are several instances of `@material-ui/styles` initialized in this application.', 'This may cause theme propagation issues, broken class names, ' + 'specificity issues, and makes your application bigger without a good reason.', '', 'See https://mui.com/r/styles-instance-warning for more info.'].join('\n'));
	  }
	
	  _utils.ponyfillGlobal['__@material-ui/styles-init__'] += 1;
	}

/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(24));
	
	var _responsivePropType = _interopRequireDefault(__webpack_require__(340));
	
	var _breakpoints = __webpack_require__(242);
	
	function getPath(obj, path) {
	  if (!path || typeof path !== 'string') {
	    return null;
	  }
	
	  return path.split('.').reduce(function (acc, item) {
	    return acc && acc[item] ? acc[item] : null;
	  }, obj);
	}
	
	function style(options) {
	  var prop = options.prop,
	      _options$cssProperty = options.cssProperty,
	      cssProperty = _options$cssProperty === void 0 ? options.prop : _options$cssProperty,
	      themeKey = options.themeKey,
	      transform = options.transform;
	
	  var fn = function fn(props) {
	    if (props[prop] == null) {
	      return null;
	    }
	
	    var propValue = props[prop];
	    var theme = props.theme;
	    var themeMapping = getPath(theme, themeKey) || {};
	
	    var styleFromPropValue = function styleFromPropValue(propValueFinal) {
	      var value;
	
	      if (typeof themeMapping === 'function') {
	        value = themeMapping(propValueFinal);
	      } else if (Array.isArray(themeMapping)) {
	        value = themeMapping[propValueFinal] || propValueFinal;
	      } else {
	        value = getPath(themeMapping, propValueFinal) || propValueFinal;
	
	        if (transform) {
	          value = transform(value);
	        }
	      }
	
	      if (cssProperty === false) {
	        return value;
	      }
	
	      return (0, _defineProperty2.default)({}, cssProperty, value);
	    };
	
	    return (0, _breakpoints.handleBreakpoints)(props, propValue, styleFromPropValue);
	  };
	
	  fn.propTypes =  false ? (0, _defineProperty2.default)({}, prop, _responsivePropType.default) : {};
	  fn.filterProps = [prop];
	  return fn;
	}
	
	var _default = style;
	exports.default = _default;

/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1265);
	
	var _reactStarRatingComponent = __webpack_require__(297);
	
	var _reactStarRatingComponent2 = _interopRequireDefault(_reactStarRatingComponent);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _DomainName = __webpack_require__(119);
	
	var _DomainName2 = _interopRequireDefault(_DomainName);
	
	var _constant = __webpack_require__(21);
	
	var _facebook = __webpack_require__(1291);
	
	var _facebook2 = _interopRequireDefault(_facebook);
	
	var _instagram = __webpack_require__(1292);
	
	var _instagram2 = _interopRequireDefault(_instagram);
	
	var _linkedin = __webpack_require__(1293);
	
	var _linkedin2 = _interopRequireDefault(_linkedin);
	
	var _twitter = __webpack_require__(1294);
	
	var _twitter2 = _interopRequireDefault(_twitter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Footer = function (_Component) {
	  _inherits(Footer, _Component);
	
	  function Footer(props) {
	    _classCallCheck(this, Footer);
	
	    var _this = _possibleConstructorReturn(this, (Footer.__proto__ || Object.getPrototypeOf(Footer)).call(this, props));
	
	    _this.handleSubscribe = function () {
	
	      if (_this.state.email_id != '') {
	        var subscribe = JSON.stringify({
	          email_id: _this.state.email_id,
	          type: 1
	        });
	        var result = fetch(_DomainName2.default.register + 'user/auth/subscribe', {
	          method: 'POST',
	          mode: 'cors',
	          headers: {
	            'Content-Type': 'application/json; charset=UTF-8'
	          },
	          body: subscribe
	        });
	        //let toastr = '';
	        //toastr = window.toastr.success;
	        /*
	        toastr('', 'Thank You for your subscription!..', {
	          positionClass: "toast-bottom-center",
	          containerId: "toast-bottom-center"
	        });
	        */
	        _this.setState({
	          email_id: "", subscribederror: '', subscribedsuccess: 'Thank You for your subscription!'
	        });
	      } else {
	        //let toastr = '';
	        //toastr = window.toastr.error;
	        _this.setState({ subscribedsuccess: '', subscribederror: 'Enter Email Id' });
	        /*
	        toastr('', 'Enter Email Id', {
	          positionClass: "toast-bottom-center",
	          containerId: "toast-bottom-center"
	        });
	        */
	      }
	    };
	
	    _this.handleQueryfeedback = function (e) {
	      e.preventDefault();
	      var emailtext = JSON.stringify({
	        rating: _this.state.rating,
	        rating1: _this.state.rating1,
	        feature: _this.state.feature,
	        decision: _this.state.decision,
	        verticals: _this.state.verticals,
	        suggession: _this.state.suggession,
	        message: _this.state.message
	      });
	      //console.log("email text",emailtext)
	      var result = fetch(_DomainName2.default.register + 'user/auth/sendfeedback', {
	        method: 'POST',
	        mode: 'cors',
	        headers: {
	          'Content-Type': 'application/json; charset=UTF-8'
	        },
	        body: emailtext
	      });
	      //let toastr = '';
	      //toastr = window.toastr.success;
	
	
	      window.$('#feedBackModal').modal('hide');
	
	      alert('Thanks for your Feedback!..');
	
	      (0, _jquery2.default)('.modal-backdrop').removeClass("show");
	      setTimeout(function () {
	        window.location.reload();
	      }, 1000);
	    };
	
	    _this.handleChangefeedback = function (e) {
	      _this.setState(_defineProperty({}, e.target.name, e.target.value));
	      //console.log(e.target.name,e.target.value)
	    };
	
	    _this.handleChange = function (e) {
	      _this.setState(_defineProperty({}, e.target.name, e.target.value));
	    };
	
	    _this.state = {
	      email_id: '',
	      subscribed: '',
	      subscribederror: '',
	      current_path: window.location.pathname
	    };
	    _this.handleSubscribe = _this.handleSubscribe.bind(_this);
	    return _this;
	  }
	
	  _createClass(Footer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      console.log('window.location.pathname', window.location.pathname);
	    }
	  }, {
	    key: 'onStarClickfeedback',
	    value: function onStarClickfeedback(nextValue, prevValue, name) {
	      this.setState({ rating: nextValue });
	    }
	  }, {
	    key: 'onStarClick1feedback',
	    value: function onStarClick1feedback(nextValue, prevValue, name) {
	      this.setState({ rating1: nextValue });
	    }
	  }, {
	    key: 'onStarClickfeedback1',
	    value: function onStarClickfeedback1(nextValue, prevValue, name) {
	      this.setState({ rating1: nextValue });
	    }
	  }, {
	    key: 'onStarClickfeedback2',
	    value: function onStarClickfeedback2(nextValue, prevValue, name) {
	      this.setState({ rating2: nextValue });
	    }
	  }, {
	    key: 'onStarClickfeedback3',
	    value: function onStarClickfeedback3(nextValue, prevValue, name) {
	      this.setState({ rating3: nextValue });
	    }
	  }, {
	    key: 'onStarClickfeedback4',
	    value: function onStarClickfeedback4(nextValue, prevValue, name) {
	      this.setState({ rating4: nextValue });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          rating = _state.rating,
	          rating1 = _state.rating1,
	          rating2 = _state.rating2,
	          rating3 = _state.rating3,
	          rating4 = _state.rating4;
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          'footer',
	          { className: ' footer-color pt-5', id: 'footera' },
	          _react2.default.createElement(
	            'div',
	            { className: 'container' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12 col-sm-5 col-md-5' },
	                _react2.default.createElement(
	                  'h4',
	                  { className: 'mb-4' },
	                  'Stay updated!'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'successmessage' },
	                  this.state.subscribedsuccess
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'errormessage' },
	                  this.state.subscribederror
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'd-flex mb-4' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'form-group mr-3 foot-input' },
	                    _react2.default.createElement('input', {
	                      className: 'form-control',
	                      placeholder: 'Enter email address',
	                      type: 'email',
	                      name: 'email_id',
	                      value: this.state.email_id,
	                      onChange: this.handleChange,
	                      title: 'Subscribe'
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'button',
	                    { style: { fontSize: '12px' }, className: 'btn blue-btn', onClick: this.handleSubscribe },
	                    'Subscribe'
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-item mb-4' },
	                  _react2.default.createElement(
	                    'a',
	                    { href: 'https://www.facebook.com/profile.php?id=100069862643218', target: '_blank' },
	                    _react2.default.createElement('img', { src: _facebook2.default, className: 'social-icons' })
	                  ),
	                  _react2.default.createElement(
	                    'a',
	                    { href: 'https://www.linkedin.com/company/bewise-in', target: '_blank' },
	                    _react2.default.createElement('img', { src: _linkedin2.default, className: 'social-icons' })
	                  ),
	                  _react2.default.createElement(
	                    'a',
	                    { href: 'https://www.instagram.com/bewise_in/', target: '_blank' },
	                    _react2.default.createElement('img', { src: _instagram2.default, className: 'social-icons' })
	                  ),
	                  _react2.default.createElement(
	                    'a',
	                    { href: 'https://twitter.com/BewiseIn', target: '_blank' },
	                    _react2.default.createElement('img', { src: _twitter2.default, className: 'social-icons' })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12 col-sm-7 col-md-7' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row' },
	                  _react2.default.createElement('div', { className: 'col-md-12' }),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-xs-12 col-sm-6 col-md-6' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'company-subhead' },
	                      _react2.default.createElement(
	                        'a',
	                        { href: '/about' },
	                        'About BeWise '
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'company-subhead' },
	                      _react2.default.createElement(
	                        'a',
	                        { href: _constant.USERURL, target: '_blank' },
	                        'BeWise Parent Portal'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'company-subhead' },
	                      _react2.default.createElement(
	                        'a',
	                        { href: _constant.BASEURL + 'bewisepartnerplans', target: '_blank' },
	                        'Partner Program'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'company-subhead' },
	                      _react2.default.createElement(
	                        'a',
	                        { href: 'mailto:contact@bewise.in' },
	                        'Work for BeWise'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'company-subhead' },
	                      _react2.default.createElement(
	                        'a',
	                        { href: 'https://collegecampus.bewise.in/', target: '_blank' },
	                        'College Connect'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-xs-12 col-sm-6 col-md-6' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'company-subhead' },
	                      _react2.default.createElement(
	                        'a',
	                        { href: 'mailto:contact@bewise.in' },
	                        'Contact Us'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'company-subhead' },
	                      _react2.default.createElement(
	                        'a',
	                        { href: '/faq' },
	                        'FAQs'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'company-subhead', 'data-toggle': 'modal', 'data-target': '#termsConditions' },
	                      _react2.default.createElement(
	                        'a',
	                        null,
	                        'Terms & Conditions'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'company-subhead', 'data-toggle': 'modal', 'data-target': '#privacy_policy' },
	                      _react2.default.createElement(
	                        'a',
	                        null,
	                        'Privacy Policy'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'company-subhead', 'data-toggle': 'modal', 'data-target': '#feedBackModal' },
	                      _react2.default.createElement(
	                        'a',
	                        { href: 'javascript:;' },
	                        'Give us Feedback'
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            {
	              className: 'modal fade review-modal',
	              id: 'feedBackModal'
	            },
	            _react2.default.createElement(
	              'div',
	              { className: 'modal-dialog model-box modal-md' },
	              _react2.default.createElement(
	                'div',
	                { className: 'modal-content' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'modal-header' },
	                  _react2.default.createElement(
	                    'h3',
	                    { className: 'modal-title r-text' },
	                    'Feedback'
	                  ),
	                  _react2.default.createElement(
	                    'button',
	                    {
	                      type: 'button',
	                      className: 'close',
	                      'data-dismiss': 'modal',
	                      'aria-label': 'Close'
	                    },
	                    _react2.default.createElement(
	                      'span',
	                      { 'aria-hidden': 'true' },
	                      '\xD7'
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'form',
	                  { method: 'post',
	                    autoComplete: 'off',
	                    onSubmit: this.handleQueryfeedback },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'modal-body' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'rating-box ' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-md-12' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'col' },
	                            _react2.default.createElement(
	                              'p',
	                              { className: 'rating r-text' },
	                              'How easy was it to onboard BeWise?'
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'col' },
	                            _react2.default.createElement(_reactStarRatingComponent2.default, {
	                              name: 'rating1',
	                              value: rating1,
	                              onStarClick: this.onStarClickfeedback1.bind(this),
	                              starCount: 5
	                            })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-md-12' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'col' },
	                            _react2.default.createElement(
	                              'p',
	                              { className: 'rating r-text' },
	                              'Incase you were working with BeWise team - were they helpful and supportive in your onboarding?'
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'col' },
	                            _react2.default.createElement(_reactStarRatingComponent2.default, {
	                              name: 'rating2',
	                              value: rating2,
	                              onStarClick: this.onStarClickfeedback2.bind(this),
	                              starCount: 5
	                            })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-md-12' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'col' },
	                            _react2.default.createElement(
	                              'p',
	                              { className: 'rating r-text' },
	                              'How easy was it to navigate our page ? Flow / Categories / Layout /'
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'col' },
	                            _react2.default.createElement(_reactStarRatingComponent2.default, {
	                              name: 'rating3',
	                              value: rating3,
	                              onStarClick: this.onStarClickfeedback3.bind(this),
	                              starCount: 5
	                            })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-md-12' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'col' },
	                            _react2.default.createElement(
	                              'p',
	                              { className: 'rating r-text' },
	                              'Was all content & titles very clear for you to understand?'
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'col' },
	                            _react2.default.createElement(_reactStarRatingComponent2.default, {
	                              name: 'rating4',
	                              value: rating4,
	                              onStarClick: this.onStarClickfeedback4.bind(this),
	                              starCount: 5
	                            })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-md-12' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'form-group' },
	                            _react2.default.createElement(
	                              'label',
	                              { className: 'login-label r-text' },
	                              'What other product features will support you even better?                     '
	                            ),
	                            _react2.default.createElement('input', {
	                              required: true,
	                              onChange: function onChange(e) {
	                                return _this2.handleChangefeedback(e);
	                              },
	                              name: 'feature', className: 'form-control',
	                              type: 'text' })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-md-12' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'form-group' },
	                            _react2.default.createElement(
	                              'label',
	                              { className: 'login-label r-text' },
	                              'What more should we include to help your growth?                     '
	                            ),
	                            _react2.default.createElement('input', {
	                              required: true,
	                              onChange: function onChange(e) {
	                                return _this2.handleChangefeedback(e);
	                              },
	                              name: 'feature', className: 'form-control',
	                              type: 'text' })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-md-12' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'form-group' },
	                            _react2.default.createElement(
	                              'label',
	                              { className: 'login-label r-text' },
	                              'What is the one suggestion you will give for founders of BeWise?                     '
	                            ),
	                            _react2.default.createElement('input', {
	                              required: true,
	                              onChange: function onChange(e) {
	                                return _this2.handleChangefeedback(e);
	                              },
	                              name: 'feature', className: 'form-control',
	                              type: 'text' })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-md-12' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'form-group' },
	                            _react2.default.createElement(
	                              'label',
	                              { className: 'login-label r-text' },
	                              'What other verticals / Needs we should add ?               '
	                            ),
	                            _react2.default.createElement('input', {
	                              required: true,
	                              name: 'verticals', onChange: function onChange(e) {
	                                return _this2.handleChangefeedback(e);
	                              },
	                              className: 'form-control', type: 'text' })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-md-12' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'form-group' },
	                            _react2.default.createElement(
	                              'label',
	                              { className: 'r-text ' },
	                              'What other topics would you like us add in "reviews" of parents to help you even better?  '
	                            ),
	                            _react2.default.createElement('textarea', {
	                              required: true,
	                              className: 'form-control',
	                              id: 'message',
	                              rows: '4',
	                              cols: '50',
	                              name: 'message',
	                              onChange: function onChange(e) {
	                                return _this2.handleChangefeedback(e);
	                              }
	
	                            })
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'modal-footer', style: { border: 'none' } },
	                    _react2.default.createElement(
	                      'button',
	                      { type: 'button', className: 'btn  btn-default', 'data-dismiss': 'modal', 'aria-label': 'Close' },
	                      'Cancel '
	                    ),
	                    _react2.default.createElement('input', {
	                      type: 'submit',
	                      name: 'submit',
	                      value: 'Submit',
	                      className: 'btn btn-primary'
	                    })
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'modal fade ', id: 'termsConditions' },
	            _react2.default.createElement(
	              'div',
	              { className: 'modal-dialog model-box modal-lg' },
	              _react2.default.createElement(
	                'div',
	                { className: 'modal-content' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'modal-header heading_colour' },
	                  _react2.default.createElement(
	                    'h3',
	                    { className: 'modal-title r-text' },
	                    'Terms & Conditions'
	                  ),
	                  _react2.default.createElement(
	                    'button',
	                    { type: 'button', className: 'close', 'data-dismiss': 'modal', 'aria-label': 'Close' },
	                    _react2.default.createElement(
	                      'span',
	                      { 'aria-hidden': 'true' },
	                      '\xD7'
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'modal-body termscond_body' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-md-12' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'privacy-page' },
	                        _react2.default.createElement(
	                          'h5',
	                          null,
	                          ' General'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          _react2.default.createElement(
	                            'a',
	                            { href: 'https://www.bewise.in' },
	                            'www.BeWise.in'
	                          ),
	                          ' is an online platform and BEWISE App (\u201CApp\u201D) is the mobile application, owned by Wisdom Tech Solutions Private Limited, a private limited company incorporated under the Companies Act, 2013, having its registered office at Karnataka (\u201CCompany\u201D), represented by its members, where such expression shall, unless repugnant to the context thereof, be deemed to include its respective legal heirs, representatives, administrators, permitted successors and assigns.'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'This website/App is an online platform/mobile application that is engaged in the business of providing and facilitating parents make choice around their child\u2019s \u201Ceducation and development\u201D by discovering preschool/daycare/ after school/events/ activity class for their child in and around them. We ensure we provide details of relevant partners and constantly provide you updates on them. On the other side, if you are an institution or an individual supporting this \u201Cholistic education\u201D, we also understand the pressures of growth and ability to effectively reach target audience, benchmarking, and continuous improvement with feedback which are critical for a sustainable future in a fast-paced digital economy. Hence, we provide them this platform to overcome their problem of right audience through our website and App.'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'For the purpose of these Terms and Conditions, wherever the context so requires, the term "you" or "user" shall mean any natural or legal person or entity including accessing or using the services provided on this website/App. The terms \u201Cwe\u201D, \u201Cus\u201D and \u201Cour\u201D shall mean BeWise and the terms \u2018site\u2019 or \u2018website\u2019 refers to ',
	                          _react2.default.createElement(
	                            'a',
	                            { href: 'https://www.bewise.in' },
	                            'www.BeWise.in'
	                          ),
	                          '.'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'The headings of each section in this Agreement (as defined below) are only for the purpose of organizing the various provisions under this Agreement in an orderly manner. These headings shall not be used by either party to interpret the provisions contained with them in any manner. Further, the headings have no legal or contractual value.'
	                        ),
	                        _react2.default.createElement(
	                          'h5',
	                          null,
	                          ' Acceptance of our Terms'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'By visiting this website/App, viewing, accessing or otherwise using any of the services or information created, collected, compiled or submitted to BeWise, you agree to be bound by the Terms and Conditions (',
	                          _react2.default.createElement(
	                            'b',
	                            null,
	                            '\u2018Terms\u2019'
	                          ),
	                          ') mentioned hereunder.'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'If you do not want to be bound by our Terms your only option is not to visit, view or otherwise use the services of BeWise. You understand, agree and acknowledge that these Terms and the Privacy Policy (please refer to the ',
	                          _react2.default.createElement(
	                            'b',
	                            null,
	                            'Privacy Policy'
	                          ),
	                          ' section of the website/App for more information) of BeWise, collectively, constitute a legally binding agreement between you and BeWise and that your use of BeWise shall indicate your conclusive acceptance of this agreement (\u2018',
	                          _react2.default.createElement(
	                            'b',
	                            null,
	                            'Agreement'
	                          ),
	                          '\u2019). You are advised to read the Terms and the Privacy Policy carefully before you use the services of this site/App.'
	                        ),
	                        _react2.default.createElement(
	                          'h5',
	                          null,
	                          'Eligibility'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'Use of this site/App is available only to persons who can form legally binding contracts under applicable law. Persons who are \u2018incompetent to contract\u2019 within the meaning of the laws applicable to them in their respective jurisdiction are not eligible to use this site/App. You may use this site/App only if your age is over 18 years and you are capable of forming binding contracts under applicable law.'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'BeWise reserves the right to freeze your account and refuse to provide you with access to this site/App if BeWise discovers that you are under the age of 18 years or otherwise not capable of forming binding contracts. In case of a business entity, you represent that you have the necessary authority to bind the entity to this Agreement.'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'Unless otherwise specified, the materials on this website/App are directed solely at those who access this website/App from India. BeWise makes no representation that any content referred to in the materials on this website/App are appropriate for use, or available outside India. Those who choose to access this site/App from outside India are responsible for compliance with local laws if and to the extent local laws are applicable.'
	                        ),
	                        _react2.default.createElement(
	                          'h5',
	                          null,
	                          'User\u2019s Account'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'You are required to create an account on the website/App in order to use some of the features and services offered by BeWise, including, without limitation to, booking for services, reviewing a partner and availing offers and discounts. The use of any information you share with us to create your account is governed by our Privacy Policy.'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'It is the user\u2019s responsibility to keep the details of the account and password confidential and you agree to accept responsibility for all activities that occur under your account or password. BeWise shall not be liable to any person for any loss or damage which may arise as a result of any failure by the user to protect the account details or the password. In case of any suspected breach, please contact us immediately. If BeWise has reason to believe that there is likely to be a breach of security or misuse of this site/App, we may require you to change your password or we may permanently suspend your account without any liability to BeWise.'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'You also agree to:'
	                        ),
	                        _react2.default.createElement(
	                          'ul',
	                          null,
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            ' provide true, accurate, current and complete information about yourself as prompted by BeWise while signing up on this website/App.'
	                          ),
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            ' maintain and promptly update the account related information to keep it true, accurate, current and complete. If you provide any information that is untrue, inaccurate, incomplete, or not current or if BeWise has reasonable grounds to suspect that such information is untrue, inaccurate, not current or not in accordance with this Agreement, or if in the opinion of BeWise, your use of this website/App breaches the terms of the applicable law, or the rights of any person, or is detrimental in any way to BeWise, we will have the right to indefinitely suspend or discontinue your account and refuse to provide you with access to this site/App.'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'Further, you may be able to log into the website/App by linking a social media account such as Facebook, Instagram, LinkedIn, twitter or Google accounts. You confirm that you are the owner of any social media account you log in with and that you are entitled to disclose your social media account information to us. Further, you give us permission to collect your authentication information, and other information that may be available on or through your social media account consistent with your applicable settings and instructions.'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'You are solely responsible for all activities that occur in your account. You agree to notify us immediately of any unauthorized use of your account in order to enable us to take necessary corrective action. You also agree that you will not allow any third party to use your account for the purpose of transacting in your name on our website/App.'
	                        ),
	                        _react2.default.createElement(
	                          'h5',
	                          null,
	                          'User\u2019s obligations'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'You are a restricted user of this website/App.'
	                        ),
	                        _react2.default.createElement(
	                          'ul',
	                          null,
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            'You are bound not to cut, copy, distribute, modify, recreate, reverse engineer, distribute, disseminate, post, publish or create derivative works from, transfer, or sell any information or software obtained from the website/App. With our prior permission, limited use may be allowed. For the removal of doubt, it is clarified that unlimited or wholesale reproduction, copying of the content for commercial or non-commercial purposes and unwarranted modification of data and information within the content of the website/App is not permitted.'
	                          ),
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            'You agree not to access (or attempt to access) the website/App and/or the materials or services by any means other than through the interface that is provided by the website/App. The use of deep-link, robot, spider or other automatic device, program, algorithm or methodology, or any similar or equivalent manual process, to access, acquire, copy or monitor any portion of the website/App or content, or in any way reproduce or circumvent the navigational structure or presentation of the website/App, materials or any content, to obtain or attempt to obtain any materials, documents or information through any means not specifically made available through the website/App.'
	                          ),
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            'In places where this website/App allows you to post or upload data/information, you undertake to ensure that such material is not offensive and in accordance with applicable laws.'
	                          ),
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            'You shall not impersonate any other party, create or use an account for anyone other than yourself, provide an email address other than your own, create multiple accounts, except as otherwise authorized by us, or provide or use false information of any kind.'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'We can (and you hereby expressly authorize us to) disclose any information about you to law enforcement or other government officials, as we, in our sole discretion, believe necessary or appropriate in connection with the investigation and/or resolution of possible crimes, especially those that may involve personal injury.'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'You understand that we have the right at all times to disclose any information (including the identity of the persons providing information or materials on the website/App) as necessary to satisfy any law, regulation or valid governmental request. This may include, without limitation, disclosure of the information in connection with investigation of alleged illegal activity or solicitation of illegal activity or in response to a lawful court order.'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'We have no obligation to monitor the materials posted on the website/App. We shall have the right to remove or edit any content that, in our sole discretion, violates, or is alleged to violate, any applicable law or either the spirit or letter of these Terms or for any other reason or no reason if we consider it to be objectionable, in violation of the Terms or otherwise harmful to the website/App or other users. Subject to the requirements of applicable law, we are not obligated to return any of your content to you under any circumstances. Any review, which is derogatory, defamatory or hateful and without any substantial evidence (e.g. photograph or video) may be taken down at our sole discretion. Notwithstanding this right, YOU REMAIN SOLELY RESPONSIBLE FOR THE CONTENT OF THE MATERIALS YOU POST ON THE WEBSITE/APP. In no event shall we assume or have any responsibility or liability for any content posted or for any claims, damages or losses resulting from use of content and/or appearance of content on the website/App. You hereby represent and warrant that you have all necessary rights in and to all content which you provide and all information it contains and that such content shall not infringe any proprietary or other rights of third parties or contain any libelous, tortuous, or otherwise unlawful information.'
	                        ),
	                        _react2.default.createElement(
	                          'h5',
	                          null,
	                          ' Contents and submissions'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'We welcome your suggestions, comments and reviews regarding your experience using our website/App. Any comments, ideas, suggestions, initiation, or any other content you contribute to this site/App (including the name you submit with any content) will be deemed to include a royalty-free, perpetual, irrevocable, nonexclusive right and license for BeWise to adopt, publish, reproduce, disseminate, transmit, distribute, copy, use, create derivative works, display worldwide, or act on such content, without additional approval or consideration, in any, media, or technology now known or later developed for the full term of any rights that may exist in such content, and you waive any claim to the contrary.'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'The user acknowledges that all reviews and ratings that users submit to this website, for whatever purpose, is public and not private/confidential information. BeWise specifically disclaims any liability concerning such information and any actions resulting from the user\u2019s participation in such content, including any objectionable content.'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'You represent and warrant that you own or otherwise control all of the rights to the content that you contribute to this site/App and that use of your content by BeWise will not infringe upon or violate the rights of any third party.'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'You further represent that your content is truthful and accurate; and your content does not violate these Terms or any applicable laws. If your content is a review, you represent and warrant that you are the sole author of that review; the review reflects that you had no financial, competitive, or other personal incentive to author or post a review that was not a fair expression of your honest opinion.'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'You assume all risks associated with your content, including anyone\'s reliance on its quality, accuracy, or reliability, or any disclosure by you of information in your content that makes you personally identifiable. While we reserve the right to remove content, we do not control actions or content posted by our users and do not guarantee the accuracy, integrity or quality of any content. You acknowledge and agree that content posted by users and any and all liability arising from such content is the sole responsibility of the user who posted the content, and not us.'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'Any review posted by a user does not reflect our opinion in any way. Each and every review posted on the website/App is the personal opinion of the user only. We are a neutral platform and solely provide a means of communication between users. Any advertisements on the website/App are published on an independent basis and there is no relation between the reviews of advertisers those who have advertised on the website/App. If the business user believes that any particular user\u2019s review violates these Terms and our policies, the user can flag the review to our attention. We may remove the review in our sole discretion.'
	                        ),
	                        _react2.default.createElement(
	                          'h5',
	                          null,
	                          ' Services by Partners'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'BeWise is not liable for the information provided by the individual and institutional partners (',
	                          _react2.default.createElement(
	                            'b',
	                            null,
	                            '\u2018Partners\u2019'
	                          ),
	                          ') listed on this website/App. The user understands that the information provided by the Partners may or may not have been verified by BeWise, therefore, the user shall exercise his/her own independent judgment while choosing from the options of Partners listed on this website/App.'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'The information provided by the Partners is tentative and subject to change at any time at their sole discretion and BeWise is not liable for any such change or modification in the information provided by the Partners.'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'This website/App allows the user to access the information provided by the Partners and contact them directly through call, text message or via e-mail. BeWise is not liable for transmission of user\u2019s phone number or such other information which may be shared by the user with the Partners directly or indirectly through such means.'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'The user may avail services including the in-person services (such as availing services of nannies, home tutors, etc.) for their ward from the Partners listed on this website/App at their own risk. BeWise does not conduct any police verification or KYC of any of the Partners listed on the website/App in any case, therefore, the user shall be solely responsible to conduct independent verifications and choose from the listed options at its sole discretion. BeWise shall not be liable upon occurrence of any undesirable event, whatsoever, arising out of non-verification on part of the user or BeWise of such Partners.'
	                        ),
	                        _react2.default.createElement(
	                          'h5',
	                          null,
	                          ' Communications'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'By using this website/App, it is deemed that you have consented to receiving calls, autodialed and/or pre-recorded message calls, e-mails and SMSs from us at any time with the use of the contact information that has been provided by you for the use of this website/App which is subject to the Privacy Policy. This includes contacting you through information received through other parties. This consent to be contacted is for purposes that include and are not limited to clarification, marketing and promotional calls, e-mails and messages. In case you wish to stop being contacted by us for the same, you may send us an e-mail to that effect at ',
	                          _react2.default.createElement(
	                            'a',
	                            { href: 'mailto:contact@bewise.in.' },
	                            'contact@bewise.in.'
	                          ),
	                          '  '
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'You may also be contacted by the Partners with whom we have entered into a contract in furtherance of our rights, duties and obligations under this document and all other policies followed by us. Such contact will be made only in pursuance of such objectives, and no other calls will be made.'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'The sharing of the information provided by you will be governed by BeWise\u2019s Privacy Policy and we will not give out your contact information to third parties not connected with this website/App.'
	                        ),
	                        _react2.default.createElement(
	                          'h5',
	                          null,
	                          ' Permissions'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'We or our affiliates responsible for making the software available, may design our website or App in such a manner as to automatically check for updates. Unless your device or any settings do not permit automatic transmission, upgrades or updates, you agree that we, or the applicable software affiliate, may provide notice to you of the availability of such upgrades or updates and automatically push such upgrade or update to your device or computer from time-to-time. You may be required to install certain upgrades or updates to the software in order to continue to access or use the services, or portions thereof (including upgrades or updates designed to correct issues with the services). Any updates or upgrades provided to you by us under these Terms shall be considered part of the services.'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'BeWise has the right, but not the obligation to monitor and edit or remove any content posted by you as your communication. We cannot review all communications made on the site/App. However, we reserve the right, but has no obligation, to monitor and edit, modify or delete any communications (or portions thereof) which we, on our sole discretion, deem inappropriate, offensive or contrary to any of our policy, or that violate theses terms.'
	                        ),
	                        _react2.default.createElement(
	                          'h5',
	                          null,
	                          ' Deals and offers'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          ' BeWise provides an opportunity to users to avail offers/value deals from the Partners listed on the website/App. BeWise allows users to book from amongst the services with offers listed on them on the website or App. The user is aware that the term "Deal (Discount)" here means the limited promotional offer, which is valid for the Promotional Period (as defined below) only, made by the company, in terms of which the company offers to supply certain products and services at a discounted rate and the term "Promotional Period" means the period of time during which a Deal can be availed for the products and services offered on the website/App. Each deal is limited and accordingly, will be sold on case-by-case basis on individual services offered on the website/App\u2019s promotional page. Each Deal has certain specific terms associated with the Deal, which will be presented to the user before the user commits to purchase the particular product or service. Deal specific terms supersede any inconsistent terms in this Agreement, except to the extent such terms are prohibited by applicable law. The Promotional Period (including, but not limited to, any discounts provided by the website/App) expires on a specific date specified on the website/App. After the expiry date of the Promotional Period, such deals or offers become invalid.'
	                        ),
	                        _react2.default.createElement(
	                          'h5',
	                          null,
	                          ' Charges'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'The membership of this website/App for the user is free of cost. You only have to pay for the services purchased. However, we reserve the right to amend this no-fee policy and charge for any or all services rendered.'
	                        ),
	                        _react2.default.createElement(
	                          'h5',
	                          null,
	                          'Mode of payment'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'The following payment options are or will be made available on the Website/App in the future:'
	                        ),
	                        _react2.default.createElement(
	                          'ul',
	                          null,
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            'Domestic and international credit cards issued by banks and institutions that are part of the Visa, Master card & Amex Card;'
	                          ),
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            'Visa Debit cards;'
	                          ),
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            'Netbanking/Direct Debit payments from select banks in India. A list of banks is available at the time of \u2018checkout\u2019;'
	                          ),
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            'Payment processing apps like Paytm, Gpay, Razorpay, BHIM, Phonepe, Mobikwik, Yono, Payzapp, Amazon pay etc.'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'As prescribed by the financial institutions issuing the credit or debit cards affiliated with Visa and MasterCard you will be required to submit your 16-digit credit card number, card expiry date and 3-digit CVV number (usually on the reverse of the card) when you make your online transaction using your credit or debit card. You should also have enrolled your credit card with VBV (Verified by Visa) or MSC (MasterCard Secure Code) to complete the transaction. Your credit card or debit card statements will reflect Wisdom Tech Solutions Pvt Ltd. In case of third-party statements including bank and credit card statements the company name may appear in an abbreviated format. This may or may not be assisted with a phone call with the customer service representative. By placing an order on the website/App, you are agreeing to the terms and conditions and payment policy published in the appropriate section of the website/App or affiliated websites where specifically referred to such affiliated websites.'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'Once payment has been made to the Partner, they will receive the SMS or mail with booking details along with Service/Transaction ID, Login ID, One Time code.'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'Transactions on this website/App are secure and protected. Credit card and debit card information is not stored by us and is not taken by us. This information is taken directly by the payment gateway provided who is authorized and is compliant with the regulations and requirements of various banks and institutions and payment franchisees that it is associated with.'
	                        ),
	                        _react2.default.createElement(
	                          'h5',
	                          null,
	                          'Intellectual Property Rights'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'This entire BeWise website/App has all rights reserved. The original contents of this website/App are copyrighted materials and are subject to the restrictions and protections set forth in the Copyright Act, 1957.'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'Unless we have otherwise agreed, nothing herein gives the user, a right to use any of the website/App\u2019s trade names, trademarks, service marks, logos, domain names, information, questions, answers, solutions, reports and other distinctive brand features, save according to the provisions of this Agreement.'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'All content, except if it relates to the individual and institutional partners, present on this site/App is the exclusive property of BeWise. The software, text, images and graphics used on this site/App belong to BeWise. The material present on this website/App may be downloaded to file or printer for personal use only. Where this material is being issued to others, the source including the URL and copyright status must be acknowledged.'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'The permission to reproduce such copyright material does not extend to any material on this site/App, which may be the property of a third party. This site/App may contain words and phrases, which are copyrighted, trademarked, or registered trademarks; they are the copyright, trademark, or registered trademark of their respective holder(s). Authorization to reproduce such material must be obtained from the respective holders concerned.'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'BeWise does not allow the user to directly or indirectly, modify, adapt, alter, reverse engineer any of the intellectual property of this website/App.'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          'The Logo is the property of BeWise and may not be used by third parties in any manner that implies that the user is acting on behalf of BeWise when they are not, or where it is linked to aims and activities incompatible with the role and responsibilities of BeWise.'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'BeWise\u2019s logo may be used for events/ programmes/ projects that are funded wholly or in part by BeWise. BeWise\u2019s logo may be used by a third party only with the prior written permission from BeWise, which may be granted only at the sole discretion of BeWise. All rights not expressly granted herein are reserved. Unauthorized use of the materials appearing on this site/App may violate copyright, trademark and other applicable laws, and could result in criminal and/or civil penalties.'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'You may not use any of our intellectual property in any manner that is likely to cause confusion among customers, or in any manner that disparages or discredits us in any way. You further acknowledge that the website/App or services may contain information which is designated as confidential by us and that you shall not disclose such information without our prior written consent.'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'We do not warrant or represent that your use of any content or materials displayed on the website will not infringe rights of third parties not affiliated with us. You agree to immediately notify us upon becoming aware of any claim that any content on the website/App or any services infringe upon any intellectual property of any party including, but not limited to, copyright, trademark, or other contractual, statutory, or common law rights.'
	                        ),
	                        _react2.default.createElement(
	                          'h5',
	                          null,
	                          'Lawful usage'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          'You agree and confirm that you will use the services provided by BeWise for lawful purposes only and comply with all applicable laws and regulations while using this site/App. The user agrees to provide true, accurate, complete and current information in all instances where such information is requested.'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'BeWise reserves the right to confirm and validate the information and other details provided by you at any point of time. If upon confirmation your details are found not to be true (wholly or partly), BeWise has the right in its sole discretion to reject the registration and debar you from using the services of BeWise without prior intimation whatsoever.'
	                        ),
	                        _react2.default.createElement(
	                          'h5',
	                          null,
	                          ' Prohibited usage'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'The user shall not use this site/App while, including, but not limited to, rating a Partners or posting a review, for any of the following purposes:'
	                        ),
	                        _react2.default.createElement(
	                          'ul',
	                          null,
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            ' Disseminating any unlawful, harassing, abusive, threatening, harmful, vulgar, obscene, or otherwise objectionable material.'
	                          ),
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            ' Transmitting material that encourages conduct that results in civil liability or otherwise breaches any relevant laws, regulations or code of practice or constitutes a criminal offence.'
	                          ),
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            ' Gaining unauthorized access to other computer systems.'
	                          ),
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            ' Interfering with any other person\u2019s use or enjoyment of this site/App.'
	                          ),
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            ' Breaching any applicable laws.'
	                          ),
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            ' Interfering or disrupting networks or websites connected to this site/App.'
	                          ),
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            ' Making, transmitting or storing electronic copies of materials protected by copyright without the permission of the respective owner.'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'h5',
	                          null,
	                          ' Limitation of Liability and warranty disclaimers'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'BeWise will not be liable for indirect, special, or consequential damages (or any loss of revenue, profits, or data) arising in connection with this Agreement.'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'BeWise is not liable for any loss resulting from any action taken or reliance made by you on any information or material posted on this website/App (including, without limitation, Partner and other third party information).'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'BeWise discounts/offers are promotional offers and shall be subject to the standard terms and conditions and specific terms and conditions. BeWise discounts/offers are issued by the institutions/individual partner and only such institutions shall be responsible for, damages, charges, expenses, claims, liabilities and costs suffered by or in respect of a user, caused in whole or in part by the institutions or which arises out of the goods and/or services provided.'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'BeWise is not responsible for lost or stolen vouchers or the reference number mentioned on it. These vouchers cannot be combined with any other gift vouchers, third party vouchers, or promotions, unless otherwise specified by the Institution.'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'In respect of Individual Partner who offer their services listed on our platform through a medium (online or otherwise) outside of the host country (in this case outside India), the legal requirement along with taxation implications of the same would be borne by the user and the respective Partner. The company is not responsible for any such implications arising from the transaction between both user and Partner.'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'In no event will BeWise be liable for damages of any kind, including without limitation, direct, incidental or consequential damages (including, but not limited to, damages for lost profits, business interruption and loss of programs or information) arising out of the use of or inability to use BeWise\'s website/App, or any information provided on the website/App, or any claim attributable to errors, omissions or other inaccuracies in the content or interpretations thereof.'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'THIS SITE/APP, AND ALL CONTENT, MATERIALS, INFORMATION, SOFTWARE AND SERVICES PROVIDED ON THIS SITE/APP, ARE PROVIDED ON AN "AS IS" AND "AS AVAILABLE" BASIS. BEWISE EXPRESSLY DISCLAIMS ALL WARRANTIES OF ANY KIND, WHETHER EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NON- INFRINGEMENT.'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'THE INFORMATION CONTAINED IN THIS SITE/APP HAS BEEN OBTAINED FROM INDIVIDUAL & INSTITUTIONAL PARTNERS AND OTHER SOURCES BELIEVED TO BE RELIABLE. BEWISE DISCLAIMS ALL WARRANTIES AS TO THE ACCURACY, COMPLETENESS OR ADEQUACY OF SUCH INFORMATION.'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'You agree that institutions will have their own applicable terms and conditions, in relation to their own supply of their goods and services, and also agree to, and shall abide by those terms and conditions. The responsibility to do so is yours alone.'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'BeWise makes no warranty that: (a) this site/App will meet your requirements; (b) this site/App will be available on an uninterrupted, timely, secure, or error-free basis; (c) the results that may be obtained from the use of this site/App or any services offered through this site/App will be accurate or reliable.'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'The limitations and exclusions in this section apply to the maximum extent permitted by applicable law.'
	                        ),
	                        _react2.default.createElement(
	                          'h5',
	                          null,
	                          'Indemnity'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'You agree to defend, indemnify and hold harmless BeWise, its affiliates, employees, directors, officers, agents and their successors and assigns from and against any and all claims, liabilities, damages, losses, costs and expenses, including attorney\u2019s fees, caused by or arising out of claims based upon your actions or inactions, which may result in any loss or liability to us or any third party including, but not limited to, posting of obscene or inappropriate content while reviewing any Partner listed on this website/App, providing misleading information while registering on this website/App, breach of any warranties, representations or undertakings or in relation to the non-fulfillment of any of your obligations under this Agreement or arising out of the violation of any applicable laws, regulations including, but not limited to, intellectual property rights, defamation, violation of rights of privacy or publicity or other rights. Your obligations under this part of this Agreement shall survive the expiry or cessation of this Agreement.'
	                        ),
	                        _react2.default.createElement(
	                          'h5',
	                          null,
	                          'Links to external sites'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'Information on our website/App may occasionally include some links which may lead to other websites, including those operated and maintained by third parties or such other third-party sites that might be directly or indirectly related to the individual or institutional partners listed on our website/App. BeWise includes these links solely as a convenience to you and the presence of such a link does not imply a responsibility on BeWise for the linked site or an endorsement of the linked site, its operator, or its contents.'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'Please be aware that once you click on the link to one of these sites, you will be subject to that site\'s privacy policy and not to ours. We recommend that you examine each website\'s/App\u2019s Privacy Policy separately.'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'BeWise also uses social networking services such as Facebook, Twitter, LinkedIn and Instagram to connect with the users and the public. When you connect with us using these services, we may collect your personal information to communicate with you. The social networking service will also handle your personal information for its own purposes. These social networking services have their own privacy policies. You can access the privacy policies for these social networking services on their websites.'
	                        ),
	                        _react2.default.createElement(
	                          'h5',
	                          null,
	                          ' Privacy'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'The user\'s right to privacy is of paramount importance to BeWise, which is why we\'ve created a separate Privacy Policy in order to explain in detail how we collect, manage, process, secure, and store your personal information. To read our privacy policy in its entirety, go to the ',
	                          _react2.default.createElement(
	                            'b',
	                            null,
	                            'Privacy Policy'
	                          ),
	                          ' section of this website/App.'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'By using this website/App, you agree to acceptance of BeWise\u2019s ',
	                          _react2.default.createElement(
	                            'b',
	                            null,
	                            'Privacy Policy'
	                          ),
	                          '.'
	                        ),
	                        _react2.default.createElement(
	                          'h5',
	                          null,
	                          ' Modifications'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'We reserve the right at all times to discontinue or modify the Terms and/or our Privacy Policy as and when we deem necessary or desirable. Upon such discontinuance or modification of the Terms and/or our Privacy Policy, the user registered on this website/App as a member shall be notified via their registered email. Your continued use of this site/App after such modifications being notified to you will constitute acknowledgment and agreement of the modified Terms and/or our Privacy Policy.'
	                        ),
	                        _react2.default.createElement(
	                          'h5',
	                          null,
	                          ' Miscellaneous terms'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'While BeWise makes every effort to ensure that the material on this website/App is accurate and up-to-date, you should exercise your own independent skill and judgement before you rely on it. This website/App is not a substitute for independent professional advice and users should obtain any appropriate professional advice relevant to their particular circumstances.'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'You obtain access to this website/App at your own risk and BeWise accepts no responsibility for any interference, loss, damage or disruption to your own computer system which arises in connection with your use of this website/App or any linked website. You must take your own precautions to ensure that the process which you employ to obtain access to this website/App does not expose you to the risk of viruses, malicious computer code or other forms of interference which may damage your own computer system.'
	                        ),
	                        _react2.default.createElement(
	                          'h5',
	                          null,
	                          ' Cessation'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'Without limiting the foregoing, we shall have the right to freeze/ discontinue/ delete the account of the user in the event of any conduct by the user, including, but not limited to prohibited acts as listed under the part \u2018Prohibited usage\u2019 in this Agreement, which we, in our sole discretion, consider to be unacceptable, or in the event of any breach by the user of this Agreement. Any such cessation of this Agreement shall not cancel your obligation or affect any liability that may have arisen under this Agreement.'
	                        ),
	                        _react2.default.createElement(
	                          'h5',
	                          null,
	                          'Severability'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'If any part of the Terms and/or Privacy Policy are determined to be invalid or unenforceable pursuant to applicable laws of India, including, but not limited to, the liability limitations and warranty disclaimers set forth above, then the invalid or unenforceable provision will be deemed to be superseded by a valid, enforceable provision that most closely matches the intent of the original provision and the remainder of the Terms and/or Privacy Policy shall continue to be in effect.'
	                        ),
	                        _react2.default.createElement(
	                          'h5',
	                          null,
	                          ' Entire Agreement'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'Unless otherwise specified herein, this Agreement constitutes the entire agreement between you and BeWise and supersedes all previous written and oral agreements between you and BeWise, if any. BeWise\u2019s failure to act with respect to a breach by you or others does not waive its right to act with respect to subsequent or similar breaches.'
	                        ),
	                        _react2.default.createElement(
	                          'h5',
	                          null,
	                          ' Dispute resolution and jurisdiction'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'If you choose to visit this website/App, your visit and any dispute over data privacy is subject to this Agreement. In addition to the foregoing, any disputes arising under these Terms shall be governed by the laws of India and the courts of Karnataka shall have exclusive jurisdiction in determining such dispute.'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'In case of a dispute, the matter will first be attempted to be resolved by way of mediation by a sole mediator who is a neutral third party and will be selected at the mutual acceptance of a proposed mediator by both parties. Both parties may raise a name for sole mediator and in the case both parties accept the proposed name, the said person shall be appointed sole mediator. In case the parties are not able to reach a consensus within two proposed mediators, the Company reserves the right to decide who the final mediator is. The parties in good faith will attempt to bind by the decision.'
	                        ),
	                        _react2.default.createElement(
	                          'h5',
	                          null,
	                          ' Contact Information'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'Questions about the Terms should be sent to us at ',
	                          _react2.default.createElement(
	                            'a',
	                            { href: 'mailto:contact@bewise.in' },
	                            'contact@bewise.in'
	                          ),
	                          '.'
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'modal fade ', id: 'privacy_policy' },
	            _react2.default.createElement(
	              'div',
	              { className: 'modal-dialog model-box modal-lg' },
	              _react2.default.createElement(
	                'div',
	                { className: 'modal-content' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'modal-header heading_colour' },
	                  _react2.default.createElement(
	                    'h3',
	                    { className: 'modal-title r-text' },
	                    'Privacy Policy'
	                  ),
	                  _react2.default.createElement(
	                    'button',
	                    { type: 'button', className: 'close', 'data-dismiss': 'modal', 'aria-label': 'Close' },
	                    _react2.default.createElement(
	                      'span',
	                      { 'aria-hidden': 'true' },
	                      '\xD7'
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'modal-body termscond_body' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-md-12' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'privacy-page' },
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'BeWise recognizes the importance of maintaining your privacy. We value your privacy and appreciate your trust in us. This privacy policy is being published in accordance with the provisions of the applicable provisions of laws in India.'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'This policy describes how we treat user information we collect on the Device Support Application (\u201CApp\u201D)/ website (named BeWise.in). This Privacy Policy applies to current and former visitors to our App/ website. By visiting and/or using our App/ website, you agree to this Privacy Policy.'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'This privacy policy was updated in September, 2020.'
	                        ),
	                        _react2.default.createElement(
	                          'h5',
	                          null,
	                          '1. General'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'For the purpose of this Privacy Policy, wherever the context so requires, \u2018you\u2019 or \u2018user\u2019 shall mean any natural or legal person who uses our App/website, browses our website or becomes a member of our website by signing up on BeWise as a user. BeWise allows the user to surf this website without signing up on this website. The term \u201Cwe\u201D, \u201Cus\u201D, \u201Cour\u201D shall mean BeWise and the term \u2018site\u2019 or \u2018website\u2019 refers to',
	                          " ",
	                          _react2.default.createElement(
	                            'a',
	                            { href: 'www.bewise.in' },
	                            'www.BeWise.in'
	                          ),
	                          '.'
	                        ),
	                        _react2.default.createElement(
	                          'h5',
	                          null,
	                          '2. Information we collect'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'Depending on your interaction with us (meaning, if you are just browsing our website, or if you have signed up on this website, etc.), we may collect two types of information from you, i.e. \u2018Personal Information\u2019 and \u2018Non-Personal Information\u2019.'
	                        ),
	                        _react2.default.createElement(
	                          'h6',
	                          null,
	                          'a) Personal Information'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'Personal Information is the information that identifies a specific \u2018End User\u2019. When you engage in certain activities on this website/App, such as signing up, posting a review, rating a partner or any other third party listed on our website/App, requesting information about our services or the services of the third party partners listed on our website/App (collectively, \u201CActivities\u201D), we may ask you to provide certain information about yourself or your ward. It is optional for you to engage in an Activity. If you elect to engage in an Activity, we may ask you to provide us with certain personal information about yourself, such as your first and last name, email address, telephone number, child\u2019s name, age, etc. BeWise allows the user to sign up on this website using social networking sites such as Facebook, Instagram, Google accounts and LinkedIn, whereby, the user\u2019s data may be shared by such social networking sites with us.'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'Depending on the activity, some of the information we ask you to provide is identified as mandatory and some is identified as voluntary. If you do not provide the mandatory information for a particular activity that requires it, you will not be permitted to engage in that activity.'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'We use Personal Information to enhance the operation of this website/App, improve our marketing and promotional efforts, analyze website/App use, improve our listings on the website/App, to personalize your experience and to understand how our users, as a whole, use the services and resources provided on our site/App and to provide you a better experience.'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'In addition to this, your Personal Information may be used to troubleshoot, resolve disputes, accomplish administrative tasks, contact you, enforce our agreements with you, including our website Terms and Conditions and this Privacy Policy, comply with applicable law, and cooperate with law enforcement activities.'
	                        ),
	                        _react2.default.createElement(
	                          'h6',
	                          null,
	                          'b) Non-Personal Information'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'Non-Personal Information is the information that does not identify a specific End User. This type of information may include things like the Uniform Resource Locator (\u201CURL\u201D) of the website you visited before coming to our website, the URL of the website you visit after leaving our website, the type of browser you are using and your Internet Protocol (\u201CIP\u201D) address.'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'We use Non-Personal Information to troubleshoot, administer this website/App, analyze trends, gather demographic information, comply with applicable law, and cooperate with law enforcement activities.'
	                        ),
	                        _react2.default.createElement(
	                          'h6',
	                          null,
	                          '3. Utilising user\u2019s information'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'The information/data collected is used for the purposes of understanding the user along with the location the user is from through geolocation platform, to analyse our audience. Collecting this data helps us understand what you are looking from the company, enabling us to deliver improved services.'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'We may use your data for the following general purposes:'
	                        ),
	                        _react2.default.createElement(
	                          'ul',
	                          null,
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            ' To contact you in response to a specific enquiry'
	                          ),
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            ' To improve the services that we provide'
	                          ),
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            ' To customise the website/App for you'
	                          ),
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            ' For our internal records'
	                          ),
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            'To send you promotional emails about products, services, offers and other things we think might be relevant to you.'
	                          ),
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            'To contact you via email, telephone or mail for market research reasons.'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'h5',
	                          null,
	                          '4. Release of user\u2019s information'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'We may disclose your information to other entities within BeWise\u2019s company group and its partners, for legitimate business purposes (including operating the services, and providing services to you), in accordance with applicable law. We may also disclose your information to any relevant third-party partners listed on our website/App such as /preschools/ after school activity centers/schools/tuition centres/community support centres, etc. for the purpose of providing appropriate services to you as per your request.'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'We will not sell, trade, distribute or lease your personal information to third parties unless we have your permission or if required to do so by law or in the good faith belief that such disclosure is reasonably necessary to respond to court orders or other legal process.'
	                        ),
	                        _react2.default.createElement(
	                          'h5',
	                          null,
	                          '5. Security'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'We are committed to ensuring that your information is secure, but please note that no method of transmission over the internet, or method of electronic storage, is 100% secure. However, we will always hold your information securely and prevent unauthorised disclosure or access to your information. Further, by providing your information you allow us to share your information with our partner brands/partners for their promotional purposes.'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'For general web browsing, no Personal Information is revealed to us, although certain statistical information is available to us via our internet service provider. This information may include the logical address of the server you are using, the top level domain name from which you access the internet (for example, .com, .in, etc.), the type of browser you are using, the date and time you access our site and the internet address used to link to our site.'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'Some of the above information is used to create summary statistics, which allow us to assess the number of visitors to our site and to identify what pages of our site are accessed most frequently. We use these statistics to help us make our site more user friendly.'
	                        ),
	                        _react2.default.createElement(
	                          'h5',
	                          null,
	                          '6. Miscellaneous Privacy Issues'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'This website/App is not meant to be used directly by children/minors under the age of 18, and/or any person who is not capable of entering into a binding contract. We do not collect or maintain information from anyone known to be under the age of 18, unless such information has been lawfully provided by the parents or guardians of the children and no part of this website/App is designed to directly attract anyone under the age of 18 and/or any person who is not capable of entering into a binding contract. If you are under 18, or are not capable of entering into a binding contract, and still want to use this website/App, you may use BeWise only with the involvement of a parent or guardian.'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'We do not share, transfer, sell or trade children\'s information.'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'We may provide areas on our website/App where you can publicly post information about yourself and provide reviews and ratings for the individual and institutional partners listed on our website/App. This information may be accessible by other users and may appear on other websites or web searches, and therefore this information is not confidential and could be read, collected, and used by others.'
	                        ),
	                        _react2.default.createElement(
	                          'h5',
	                          null,
	                          '7. Links to external sites'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'Information on our website/App may include some links which may lead to other websites, including those operated and maintained by third parties or such other third-party sites that might be directly or indirectly related to the individual or institutional partners listed on our website/App. BeWise includes these links solely as a convenience to you and the presence of such a link does not imply a responsibility on BeWise for the linked site or an endorsement of the linked site, its operator, or its contents.'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'Please be aware that once you click on the link to one of these sites, you will be subject to that site\'s privacy policy and not to ours. We recommend that you examine each website\'s Privacy Policy separately.'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'Apart from this website/App, the users may contact/ connect with BeWise using social networking services such as Facebook, Twitter, LinkedIn and Instagram. When you connect with us using these services, we may collect your personal information to communicate with you. The social networking service will also handle your personal information for its own purposes. These social networking services have their own privacy policies. You can access the privacy policies for these social networking services on their respective websites.'
	                        ),
	                        _react2.default.createElement(
	                          'h5',
	                          null,
	                          '8. Cookies'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'This website uses \u201Ccookie\u201D technology. A cookie is a small piece of data or a small text file stored by the browser on your computer, at the request of our server. We may use cookies to deliver content specific to your interests and to save your personal preferences so you do not have to re- enter them each time you connect to our website \u2013 our cookies are not available to other websites. In particular cookies enable us:'
	                        ),
	                        _react2.default.createElement(
	                          'ul',
	                          { className: 'list-dot' },
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            'to measure visitor traffic to our website and their usage patterns'
	                          ),
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            'to identify whether you are signed in to our website'
	                          ),
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            'to test content on our website and pattern of a user on the website. For instance, 50% of our users might see one piece of content, the other 50% a different piece of content.'
	                          ),
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            'to store information about your preferences and so allow us to customize our website according to your individual interests'
	                          ),
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            'to speed up your searches'
	                          ),
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            'to recognize you when you return to our website'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'You are always free to decline such cookies, if your browser permits, or to ask your browser to indicate when a cookie is being sent. You can also delete cookie files from your computer at your discretion. However, please note that doing this may affect how our website functions. Some pages and services may become unavailable to you.'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'To learn more about cookies and how they are used, visit',
	                          " ",
	                          _react2.default.createElement(
	                            'a',
	                            { href: 'http://www.allaboutcookies.org/' },
	                            'http://www.allaboutcookies.org/'
	                          ),
	                          '.'
	                        ),
	                        _react2.default.createElement(
	                          'h5',
	                          null,
	                          '9. Advertising cookies'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'Some of the advertisements you see on BeWise are provided by other organizations. These organizations can use their own anonymous cookies to track how many people have seen a particular ad, or to track how many people have seen it more than once.'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'The entities that generate these cookies have their own privacy policies, and we have no access to read or write these cookies. These organizations may use their cookies to anonymously target advertising to you on other websites, based on your visit to BeWise.'
	                        ),
	                        _react2.default.createElement(
	                          'h5',
	                          null,
	                          '10. Electronic communication'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'There are inherent risks associated with the transmission of information over the internet, including via email. You should be aware of this when sending your personal information to us via email or via our website/App or social media platforms. If this is of concern to you then you may use other methods of communication with us, such as post or telephone (although these also have risks associated with them).'
	                        ),
	                        _react2.default.createElement(
	                          'h5',
	                          null,
	                          '11. Changes to this privacy policy'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'Please note that the privacy policy may change from time to time. BeWise reserves the right to change this policy at any time. The users registered on this website/App as a member shall be notified of the changes or modifications, if any, done on this policy via their registered email by BeWise.'
	                        ),
	                        _react2.default.createElement(
	                          'h5',
	                          null,
	                          '12. Your Acceptance of these terms'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'By using this website/App, you signify your acceptance of our privacy policy. If you do not agree to this policy, please do not use our website/App. Your continued use of this website/App following the posting of changes to this policy, as and when notified to you, will be deemed your acceptance of those changes.'
	                        ),
	                        _react2.default.createElement(
	                          'h5',
	                          null,
	                          '13. Jurisdiction'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'If you choose to visit this website/App, your visit and any dispute over data privacy is subject to this policy and the terms and conditions of this website/App. In addition to the foregoing, any disputes arising under this policy shall be governed by the laws of India and the courts of Karnataka shall have exclusive jurisdiction in determining such dispute.'
	                        ),
	                        _react2.default.createElement(
	                          'h5',
	                          null,
	                          '14. Complaints'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          'If you think BeWise may have breached your privacy, you may contact us to make a complaint and rectify our actions. In order to ensure that we fully understand the nature of your complaint and the outcome you are seeking, we prefer that you make your complaint in writing via email to the below mentioned email address.'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'Further, in accordance with Information Technology Act, 2000 and rules made thereunder, the name and contact details of the grievance officer who can be contacted with respect to any complaints or concerns including those pertaining to breach of BeWise\u2019s Terms & Conditions, and other polices or questions are published as under:'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'termscond_para' },
	                          'Name: Sethuraman',
	                          _react2.default.createElement('br', null),
	                          'Email Address: ',
	                          _react2.default.createElement(
	                            'a',
	                            { href: 'mailto:contact@bewise.in' },
	                            'contact@bewise.in'
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            {
	              className: 'copyright',
	              style: { padding: "15px" }
	            },
	            _react2.default.createElement(
	              'p',
	              null,
	              '\xA9 Copyright 2025 ',
	              _react2.default.createElement(
	                'strong',
	                null,
	                'BeWise'
	              ),
	              '.\xA0All Rights Reserved'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Footer;
	}(_react.Component);
	
	exports.default = Footer;

/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	 * Chart.js v2.9.4
	 * https://www.chartjs.org
	 * (c) 2020 Chart.js Contributors
	 * Released under the MIT License
	 */
	(function (global, factory) {
	 true ? module.exports = factory(function() { try { return __webpack_require__(7); } catch(e) { } }()) :
	typeof define === 'function' && define.amd ? define(['require'], function(require) { return factory(function() { try { return require('moment'); } catch(e) { } }()); }) :
	(global = global || self, global.Chart = factory(global.moment));
	}(this, (function (moment) { 'use strict';
	
	moment = moment && moment.hasOwnProperty('default') ? moment['default'] : moment;
	
	function createCommonjsModule(fn, module) {
		return module = { exports: {} }, fn(module, module.exports), module.exports;
	}
	
	function getCjsExportFromNamespace (n) {
		return n && n['default'] || n;
	}
	
	var colorName = {
		"aliceblue": [240, 248, 255],
		"antiquewhite": [250, 235, 215],
		"aqua": [0, 255, 255],
		"aquamarine": [127, 255, 212],
		"azure": [240, 255, 255],
		"beige": [245, 245, 220],
		"bisque": [255, 228, 196],
		"black": [0, 0, 0],
		"blanchedalmond": [255, 235, 205],
		"blue": [0, 0, 255],
		"blueviolet": [138, 43, 226],
		"brown": [165, 42, 42],
		"burlywood": [222, 184, 135],
		"cadetblue": [95, 158, 160],
		"chartreuse": [127, 255, 0],
		"chocolate": [210, 105, 30],
		"coral": [255, 127, 80],
		"cornflowerblue": [100, 149, 237],
		"cornsilk": [255, 248, 220],
		"crimson": [220, 20, 60],
		"cyan": [0, 255, 255],
		"darkblue": [0, 0, 139],
		"darkcyan": [0, 139, 139],
		"darkgoldenrod": [184, 134, 11],
		"darkgray": [169, 169, 169],
		"darkgreen": [0, 100, 0],
		"darkgrey": [169, 169, 169],
		"darkkhaki": [189, 183, 107],
		"darkmagenta": [139, 0, 139],
		"darkolivegreen": [85, 107, 47],
		"darkorange": [255, 140, 0],
		"darkorchid": [153, 50, 204],
		"darkred": [139, 0, 0],
		"darksalmon": [233, 150, 122],
		"darkseagreen": [143, 188, 143],
		"darkslateblue": [72, 61, 139],
		"darkslategray": [47, 79, 79],
		"darkslategrey": [47, 79, 79],
		"darkturquoise": [0, 206, 209],
		"darkviolet": [148, 0, 211],
		"deeppink": [255, 20, 147],
		"deepskyblue": [0, 191, 255],
		"dimgray": [105, 105, 105],
		"dimgrey": [105, 105, 105],
		"dodgerblue": [30, 144, 255],
		"firebrick": [178, 34, 34],
		"floralwhite": [255, 250, 240],
		"forestgreen": [34, 139, 34],
		"fuchsia": [255, 0, 255],
		"gainsboro": [220, 220, 220],
		"ghostwhite": [248, 248, 255],
		"gold": [255, 215, 0],
		"goldenrod": [218, 165, 32],
		"gray": [128, 128, 128],
		"green": [0, 128, 0],
		"greenyellow": [173, 255, 47],
		"grey": [128, 128, 128],
		"honeydew": [240, 255, 240],
		"hotpink": [255, 105, 180],
		"indianred": [205, 92, 92],
		"indigo": [75, 0, 130],
		"ivory": [255, 255, 240],
		"khaki": [240, 230, 140],
		"lavender": [230, 230, 250],
		"lavenderblush": [255, 240, 245],
		"lawngreen": [124, 252, 0],
		"lemonchiffon": [255, 250, 205],
		"lightblue": [173, 216, 230],
		"lightcoral": [240, 128, 128],
		"lightcyan": [224, 255, 255],
		"lightgoldenrodyellow": [250, 250, 210],
		"lightgray": [211, 211, 211],
		"lightgreen": [144, 238, 144],
		"lightgrey": [211, 211, 211],
		"lightpink": [255, 182, 193],
		"lightsalmon": [255, 160, 122],
		"lightseagreen": [32, 178, 170],
		"lightskyblue": [135, 206, 250],
		"lightslategray": [119, 136, 153],
		"lightslategrey": [119, 136, 153],
		"lightsteelblue": [176, 196, 222],
		"lightyellow": [255, 255, 224],
		"lime": [0, 255, 0],
		"limegreen": [50, 205, 50],
		"linen": [250, 240, 230],
		"magenta": [255, 0, 255],
		"maroon": [128, 0, 0],
		"mediumaquamarine": [102, 205, 170],
		"mediumblue": [0, 0, 205],
		"mediumorchid": [186, 85, 211],
		"mediumpurple": [147, 112, 219],
		"mediumseagreen": [60, 179, 113],
		"mediumslateblue": [123, 104, 238],
		"mediumspringgreen": [0, 250, 154],
		"mediumturquoise": [72, 209, 204],
		"mediumvioletred": [199, 21, 133],
		"midnightblue": [25, 25, 112],
		"mintcream": [245, 255, 250],
		"mistyrose": [255, 228, 225],
		"moccasin": [255, 228, 181],
		"navajowhite": [255, 222, 173],
		"navy": [0, 0, 128],
		"oldlace": [253, 245, 230],
		"olive": [128, 128, 0],
		"olivedrab": [107, 142, 35],
		"orange": [255, 165, 0],
		"orangered": [255, 69, 0],
		"orchid": [218, 112, 214],
		"palegoldenrod": [238, 232, 170],
		"palegreen": [152, 251, 152],
		"paleturquoise": [175, 238, 238],
		"palevioletred": [219, 112, 147],
		"papayawhip": [255, 239, 213],
		"peachpuff": [255, 218, 185],
		"peru": [205, 133, 63],
		"pink": [255, 192, 203],
		"plum": [221, 160, 221],
		"powderblue": [176, 224, 230],
		"purple": [128, 0, 128],
		"rebeccapurple": [102, 51, 153],
		"red": [255, 0, 0],
		"rosybrown": [188, 143, 143],
		"royalblue": [65, 105, 225],
		"saddlebrown": [139, 69, 19],
		"salmon": [250, 128, 114],
		"sandybrown": [244, 164, 96],
		"seagreen": [46, 139, 87],
		"seashell": [255, 245, 238],
		"sienna": [160, 82, 45],
		"silver": [192, 192, 192],
		"skyblue": [135, 206, 235],
		"slateblue": [106, 90, 205],
		"slategray": [112, 128, 144],
		"slategrey": [112, 128, 144],
		"snow": [255, 250, 250],
		"springgreen": [0, 255, 127],
		"steelblue": [70, 130, 180],
		"tan": [210, 180, 140],
		"teal": [0, 128, 128],
		"thistle": [216, 191, 216],
		"tomato": [255, 99, 71],
		"turquoise": [64, 224, 208],
		"violet": [238, 130, 238],
		"wheat": [245, 222, 179],
		"white": [255, 255, 255],
		"whitesmoke": [245, 245, 245],
		"yellow": [255, 255, 0],
		"yellowgreen": [154, 205, 50]
	};
	
	var conversions = createCommonjsModule(function (module) {
	/* MIT license */
	
	
	// NOTE: conversions should only return primitive values (i.e. arrays, or
	//       values that give correct `typeof` results).
	//       do not use box values types (i.e. Number(), String(), etc.)
	
	var reverseKeywords = {};
	for (var key in colorName) {
		if (colorName.hasOwnProperty(key)) {
			reverseKeywords[colorName[key]] = key;
		}
	}
	
	var convert = module.exports = {
		rgb: {channels: 3, labels: 'rgb'},
		hsl: {channels: 3, labels: 'hsl'},
		hsv: {channels: 3, labels: 'hsv'},
		hwb: {channels: 3, labels: 'hwb'},
		cmyk: {channels: 4, labels: 'cmyk'},
		xyz: {channels: 3, labels: 'xyz'},
		lab: {channels: 3, labels: 'lab'},
		lch: {channels: 3, labels: 'lch'},
		hex: {channels: 1, labels: ['hex']},
		keyword: {channels: 1, labels: ['keyword']},
		ansi16: {channels: 1, labels: ['ansi16']},
		ansi256: {channels: 1, labels: ['ansi256']},
		hcg: {channels: 3, labels: ['h', 'c', 'g']},
		apple: {channels: 3, labels: ['r16', 'g16', 'b16']},
		gray: {channels: 1, labels: ['gray']}
	};
	
	// hide .channels and .labels properties
	for (var model in convert) {
		if (convert.hasOwnProperty(model)) {
			if (!('channels' in convert[model])) {
				throw new Error('missing channels property: ' + model);
			}
	
			if (!('labels' in convert[model])) {
				throw new Error('missing channel labels property: ' + model);
			}
	
			if (convert[model].labels.length !== convert[model].channels) {
				throw new Error('channel and label counts mismatch: ' + model);
			}
	
			var channels = convert[model].channels;
			var labels = convert[model].labels;
			delete convert[model].channels;
			delete convert[model].labels;
			Object.defineProperty(convert[model], 'channels', {value: channels});
			Object.defineProperty(convert[model], 'labels', {value: labels});
		}
	}
	
	convert.rgb.hsl = function (rgb) {
		var r = rgb[0] / 255;
		var g = rgb[1] / 255;
		var b = rgb[2] / 255;
		var min = Math.min(r, g, b);
		var max = Math.max(r, g, b);
		var delta = max - min;
		var h;
		var s;
		var l;
	
		if (max === min) {
			h = 0;
		} else if (r === max) {
			h = (g - b) / delta;
		} else if (g === max) {
			h = 2 + (b - r) / delta;
		} else if (b === max) {
			h = 4 + (r - g) / delta;
		}
	
		h = Math.min(h * 60, 360);
	
		if (h < 0) {
			h += 360;
		}
	
		l = (min + max) / 2;
	
		if (max === min) {
			s = 0;
		} else if (l <= 0.5) {
			s = delta / (max + min);
		} else {
			s = delta / (2 - max - min);
		}
	
		return [h, s * 100, l * 100];
	};
	
	convert.rgb.hsv = function (rgb) {
		var rdif;
		var gdif;
		var bdif;
		var h;
		var s;
	
		var r = rgb[0] / 255;
		var g = rgb[1] / 255;
		var b = rgb[2] / 255;
		var v = Math.max(r, g, b);
		var diff = v - Math.min(r, g, b);
		var diffc = function (c) {
			return (v - c) / 6 / diff + 1 / 2;
		};
	
		if (diff === 0) {
			h = s = 0;
		} else {
			s = diff / v;
			rdif = diffc(r);
			gdif = diffc(g);
			bdif = diffc(b);
	
			if (r === v) {
				h = bdif - gdif;
			} else if (g === v) {
				h = (1 / 3) + rdif - bdif;
			} else if (b === v) {
				h = (2 / 3) + gdif - rdif;
			}
			if (h < 0) {
				h += 1;
			} else if (h > 1) {
				h -= 1;
			}
		}
	
		return [
			h * 360,
			s * 100,
			v * 100
		];
	};
	
	convert.rgb.hwb = function (rgb) {
		var r = rgb[0];
		var g = rgb[1];
		var b = rgb[2];
		var h = convert.rgb.hsl(rgb)[0];
		var w = 1 / 255 * Math.min(r, Math.min(g, b));
	
		b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));
	
		return [h, w * 100, b * 100];
	};
	
	convert.rgb.cmyk = function (rgb) {
		var r = rgb[0] / 255;
		var g = rgb[1] / 255;
		var b = rgb[2] / 255;
		var c;
		var m;
		var y;
		var k;
	
		k = Math.min(1 - r, 1 - g, 1 - b);
		c = (1 - r - k) / (1 - k) || 0;
		m = (1 - g - k) / (1 - k) || 0;
		y = (1 - b - k) / (1 - k) || 0;
	
		return [c * 100, m * 100, y * 100, k * 100];
	};
	
	/**
	 * See https://en.m.wikipedia.org/wiki/Euclidean_distance#Squared_Euclidean_distance
	 * */
	function comparativeDistance(x, y) {
		return (
			Math.pow(x[0] - y[0], 2) +
			Math.pow(x[1] - y[1], 2) +
			Math.pow(x[2] - y[2], 2)
		);
	}
	
	convert.rgb.keyword = function (rgb) {
		var reversed = reverseKeywords[rgb];
		if (reversed) {
			return reversed;
		}
	
		var currentClosestDistance = Infinity;
		var currentClosestKeyword;
	
		for (var keyword in colorName) {
			if (colorName.hasOwnProperty(keyword)) {
				var value = colorName[keyword];
	
				// Compute comparative distance
				var distance = comparativeDistance(rgb, value);
	
				// Check if its less, if so set as closest
				if (distance < currentClosestDistance) {
					currentClosestDistance = distance;
					currentClosestKeyword = keyword;
				}
			}
		}
	
		return currentClosestKeyword;
	};
	
	convert.keyword.rgb = function (keyword) {
		return colorName[keyword];
	};
	
	convert.rgb.xyz = function (rgb) {
		var r = rgb[0] / 255;
		var g = rgb[1] / 255;
		var b = rgb[2] / 255;
	
		// assume sRGB
		r = r > 0.04045 ? Math.pow(((r + 0.055) / 1.055), 2.4) : (r / 12.92);
		g = g > 0.04045 ? Math.pow(((g + 0.055) / 1.055), 2.4) : (g / 12.92);
		b = b > 0.04045 ? Math.pow(((b + 0.055) / 1.055), 2.4) : (b / 12.92);
	
		var x = (r * 0.4124) + (g * 0.3576) + (b * 0.1805);
		var y = (r * 0.2126) + (g * 0.7152) + (b * 0.0722);
		var z = (r * 0.0193) + (g * 0.1192) + (b * 0.9505);
	
		return [x * 100, y * 100, z * 100];
	};
	
	convert.rgb.lab = function (rgb) {
		var xyz = convert.rgb.xyz(rgb);
		var x = xyz[0];
		var y = xyz[1];
		var z = xyz[2];
		var l;
		var a;
		var b;
	
		x /= 95.047;
		y /= 100;
		z /= 108.883;
	
		x = x > 0.008856 ? Math.pow(x, 1 / 3) : (7.787 * x) + (16 / 116);
		y = y > 0.008856 ? Math.pow(y, 1 / 3) : (7.787 * y) + (16 / 116);
		z = z > 0.008856 ? Math.pow(z, 1 / 3) : (7.787 * z) + (16 / 116);
	
		l = (116 * y) - 16;
		a = 500 * (x - y);
		b = 200 * (y - z);
	
		return [l, a, b];
	};
	
	convert.hsl.rgb = function (hsl) {
		var h = hsl[0] / 360;
		var s = hsl[1] / 100;
		var l = hsl[2] / 100;
		var t1;
		var t2;
		var t3;
		var rgb;
		var val;
	
		if (s === 0) {
			val = l * 255;
			return [val, val, val];
		}
	
		if (l < 0.5) {
			t2 = l * (1 + s);
		} else {
			t2 = l + s - l * s;
		}
	
		t1 = 2 * l - t2;
	
		rgb = [0, 0, 0];
		for (var i = 0; i < 3; i++) {
			t3 = h + 1 / 3 * -(i - 1);
			if (t3 < 0) {
				t3++;
			}
			if (t3 > 1) {
				t3--;
			}
	
			if (6 * t3 < 1) {
				val = t1 + (t2 - t1) * 6 * t3;
			} else if (2 * t3 < 1) {
				val = t2;
			} else if (3 * t3 < 2) {
				val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
			} else {
				val = t1;
			}
	
			rgb[i] = val * 255;
		}
	
		return rgb;
	};
	
	convert.hsl.hsv = function (hsl) {
		var h = hsl[0];
		var s = hsl[1] / 100;
		var l = hsl[2] / 100;
		var smin = s;
		var lmin = Math.max(l, 0.01);
		var sv;
		var v;
	
		l *= 2;
		s *= (l <= 1) ? l : 2 - l;
		smin *= lmin <= 1 ? lmin : 2 - lmin;
		v = (l + s) / 2;
		sv = l === 0 ? (2 * smin) / (lmin + smin) : (2 * s) / (l + s);
	
		return [h, sv * 100, v * 100];
	};
	
	convert.hsv.rgb = function (hsv) {
		var h = hsv[0] / 60;
		var s = hsv[1] / 100;
		var v = hsv[2] / 100;
		var hi = Math.floor(h) % 6;
	
		var f = h - Math.floor(h);
		var p = 255 * v * (1 - s);
		var q = 255 * v * (1 - (s * f));
		var t = 255 * v * (1 - (s * (1 - f)));
		v *= 255;
	
		switch (hi) {
			case 0:
				return [v, t, p];
			case 1:
				return [q, v, p];
			case 2:
				return [p, v, t];
			case 3:
				return [p, q, v];
			case 4:
				return [t, p, v];
			case 5:
				return [v, p, q];
		}
	};
	
	convert.hsv.hsl = function (hsv) {
		var h = hsv[0];
		var s = hsv[1] / 100;
		var v = hsv[2] / 100;
		var vmin = Math.max(v, 0.01);
		var lmin;
		var sl;
		var l;
	
		l = (2 - s) * v;
		lmin = (2 - s) * vmin;
		sl = s * vmin;
		sl /= (lmin <= 1) ? lmin : 2 - lmin;
		sl = sl || 0;
		l /= 2;
	
		return [h, sl * 100, l * 100];
	};
	
	// http://dev.w3.org/csswg/css-color/#hwb-to-rgb
	convert.hwb.rgb = function (hwb) {
		var h = hwb[0] / 360;
		var wh = hwb[1] / 100;
		var bl = hwb[2] / 100;
		var ratio = wh + bl;
		var i;
		var v;
		var f;
		var n;
	
		// wh + bl cant be > 1
		if (ratio > 1) {
			wh /= ratio;
			bl /= ratio;
		}
	
		i = Math.floor(6 * h);
		v = 1 - bl;
		f = 6 * h - i;
	
		if ((i & 0x01) !== 0) {
			f = 1 - f;
		}
	
		n = wh + f * (v - wh); // linear interpolation
	
		var r;
		var g;
		var b;
		switch (i) {
			default:
			case 6:
			case 0: r = v; g = n; b = wh; break;
			case 1: r = n; g = v; b = wh; break;
			case 2: r = wh; g = v; b = n; break;
			case 3: r = wh; g = n; b = v; break;
			case 4: r = n; g = wh; b = v; break;
			case 5: r = v; g = wh; b = n; break;
		}
	
		return [r * 255, g * 255, b * 255];
	};
	
	convert.cmyk.rgb = function (cmyk) {
		var c = cmyk[0] / 100;
		var m = cmyk[1] / 100;
		var y = cmyk[2] / 100;
		var k = cmyk[3] / 100;
		var r;
		var g;
		var b;
	
		r = 1 - Math.min(1, c * (1 - k) + k);
		g = 1 - Math.min(1, m * (1 - k) + k);
		b = 1 - Math.min(1, y * (1 - k) + k);
	
		return [r * 255, g * 255, b * 255];
	};
	
	convert.xyz.rgb = function (xyz) {
		var x = xyz[0] / 100;
		var y = xyz[1] / 100;
		var z = xyz[2] / 100;
		var r;
		var g;
		var b;
	
		r = (x * 3.2406) + (y * -1.5372) + (z * -0.4986);
		g = (x * -0.9689) + (y * 1.8758) + (z * 0.0415);
		b = (x * 0.0557) + (y * -0.2040) + (z * 1.0570);
	
		// assume sRGB
		r = r > 0.0031308
			? ((1.055 * Math.pow(r, 1.0 / 2.4)) - 0.055)
			: r * 12.92;
	
		g = g > 0.0031308
			? ((1.055 * Math.pow(g, 1.0 / 2.4)) - 0.055)
			: g * 12.92;
	
		b = b > 0.0031308
			? ((1.055 * Math.pow(b, 1.0 / 2.4)) - 0.055)
			: b * 12.92;
	
		r = Math.min(Math.max(0, r), 1);
		g = Math.min(Math.max(0, g), 1);
		b = Math.min(Math.max(0, b), 1);
	
		return [r * 255, g * 255, b * 255];
	};
	
	convert.xyz.lab = function (xyz) {
		var x = xyz[0];
		var y = xyz[1];
		var z = xyz[2];
		var l;
		var a;
		var b;
	
		x /= 95.047;
		y /= 100;
		z /= 108.883;
	
		x = x > 0.008856 ? Math.pow(x, 1 / 3) : (7.787 * x) + (16 / 116);
		y = y > 0.008856 ? Math.pow(y, 1 / 3) : (7.787 * y) + (16 / 116);
		z = z > 0.008856 ? Math.pow(z, 1 / 3) : (7.787 * z) + (16 / 116);
	
		l = (116 * y) - 16;
		a = 500 * (x - y);
		b = 200 * (y - z);
	
		return [l, a, b];
	};
	
	convert.lab.xyz = function (lab) {
		var l = lab[0];
		var a = lab[1];
		var b = lab[2];
		var x;
		var y;
		var z;
	
		y = (l + 16) / 116;
		x = a / 500 + y;
		z = y - b / 200;
	
		var y2 = Math.pow(y, 3);
		var x2 = Math.pow(x, 3);
		var z2 = Math.pow(z, 3);
		y = y2 > 0.008856 ? y2 : (y - 16 / 116) / 7.787;
		x = x2 > 0.008856 ? x2 : (x - 16 / 116) / 7.787;
		z = z2 > 0.008856 ? z2 : (z - 16 / 116) / 7.787;
	
		x *= 95.047;
		y *= 100;
		z *= 108.883;
	
		return [x, y, z];
	};
	
	convert.lab.lch = function (lab) {
		var l = lab[0];
		var a = lab[1];
		var b = lab[2];
		var hr;
		var h;
		var c;
	
		hr = Math.atan2(b, a);
		h = hr * 360 / 2 / Math.PI;
	
		if (h < 0) {
			h += 360;
		}
	
		c = Math.sqrt(a * a + b * b);
	
		return [l, c, h];
	};
	
	convert.lch.lab = function (lch) {
		var l = lch[0];
		var c = lch[1];
		var h = lch[2];
		var a;
		var b;
		var hr;
	
		hr = h / 360 * 2 * Math.PI;
		a = c * Math.cos(hr);
		b = c * Math.sin(hr);
	
		return [l, a, b];
	};
	
	convert.rgb.ansi16 = function (args) {
		var r = args[0];
		var g = args[1];
		var b = args[2];
		var value = 1 in arguments ? arguments[1] : convert.rgb.hsv(args)[2]; // hsv -> ansi16 optimization
	
		value = Math.round(value / 50);
	
		if (value === 0) {
			return 30;
		}
	
		var ansi = 30
			+ ((Math.round(b / 255) << 2)
			| (Math.round(g / 255) << 1)
			| Math.round(r / 255));
	
		if (value === 2) {
			ansi += 60;
		}
	
		return ansi;
	};
	
	convert.hsv.ansi16 = function (args) {
		// optimization here; we already know the value and don't need to get
		// it converted for us.
		return convert.rgb.ansi16(convert.hsv.rgb(args), args[2]);
	};
	
	convert.rgb.ansi256 = function (args) {
		var r = args[0];
		var g = args[1];
		var b = args[2];
	
		// we use the extended greyscale palette here, with the exception of
		// black and white. normal palette only has 4 greyscale shades.
		if (r === g && g === b) {
			if (r < 8) {
				return 16;
			}
	
			if (r > 248) {
				return 231;
			}
	
			return Math.round(((r - 8) / 247) * 24) + 232;
		}
	
		var ansi = 16
			+ (36 * Math.round(r / 255 * 5))
			+ (6 * Math.round(g / 255 * 5))
			+ Math.round(b / 255 * 5);
	
		return ansi;
	};
	
	convert.ansi16.rgb = function (args) {
		var color = args % 10;
	
		// handle greyscale
		if (color === 0 || color === 7) {
			if (args > 50) {
				color += 3.5;
			}
	
			color = color / 10.5 * 255;
	
			return [color, color, color];
		}
	
		var mult = (~~(args > 50) + 1) * 0.5;
		var r = ((color & 1) * mult) * 255;
		var g = (((color >> 1) & 1) * mult) * 255;
		var b = (((color >> 2) & 1) * mult) * 255;
	
		return [r, g, b];
	};
	
	convert.ansi256.rgb = function (args) {
		// handle greyscale
		if (args >= 232) {
			var c = (args - 232) * 10 + 8;
			return [c, c, c];
		}
	
		args -= 16;
	
		var rem;
		var r = Math.floor(args / 36) / 5 * 255;
		var g = Math.floor((rem = args % 36) / 6) / 5 * 255;
		var b = (rem % 6) / 5 * 255;
	
		return [r, g, b];
	};
	
	convert.rgb.hex = function (args) {
		var integer = ((Math.round(args[0]) & 0xFF) << 16)
			+ ((Math.round(args[1]) & 0xFF) << 8)
			+ (Math.round(args[2]) & 0xFF);
	
		var string = integer.toString(16).toUpperCase();
		return '000000'.substring(string.length) + string;
	};
	
	convert.hex.rgb = function (args) {
		var match = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
		if (!match) {
			return [0, 0, 0];
		}
	
		var colorString = match[0];
	
		if (match[0].length === 3) {
			colorString = colorString.split('').map(function (char) {
				return char + char;
			}).join('');
		}
	
		var integer = parseInt(colorString, 16);
		var r = (integer >> 16) & 0xFF;
		var g = (integer >> 8) & 0xFF;
		var b = integer & 0xFF;
	
		return [r, g, b];
	};
	
	convert.rgb.hcg = function (rgb) {
		var r = rgb[0] / 255;
		var g = rgb[1] / 255;
		var b = rgb[2] / 255;
		var max = Math.max(Math.max(r, g), b);
		var min = Math.min(Math.min(r, g), b);
		var chroma = (max - min);
		var grayscale;
		var hue;
	
		if (chroma < 1) {
			grayscale = min / (1 - chroma);
		} else {
			grayscale = 0;
		}
	
		if (chroma <= 0) {
			hue = 0;
		} else
		if (max === r) {
			hue = ((g - b) / chroma) % 6;
		} else
		if (max === g) {
			hue = 2 + (b - r) / chroma;
		} else {
			hue = 4 + (r - g) / chroma + 4;
		}
	
		hue /= 6;
		hue %= 1;
	
		return [hue * 360, chroma * 100, grayscale * 100];
	};
	
	convert.hsl.hcg = function (hsl) {
		var s = hsl[1] / 100;
		var l = hsl[2] / 100;
		var c = 1;
		var f = 0;
	
		if (l < 0.5) {
			c = 2.0 * s * l;
		} else {
			c = 2.0 * s * (1.0 - l);
		}
	
		if (c < 1.0) {
			f = (l - 0.5 * c) / (1.0 - c);
		}
	
		return [hsl[0], c * 100, f * 100];
	};
	
	convert.hsv.hcg = function (hsv) {
		var s = hsv[1] / 100;
		var v = hsv[2] / 100;
	
		var c = s * v;
		var f = 0;
	
		if (c < 1.0) {
			f = (v - c) / (1 - c);
		}
	
		return [hsv[0], c * 100, f * 100];
	};
	
	convert.hcg.rgb = function (hcg) {
		var h = hcg[0] / 360;
		var c = hcg[1] / 100;
		var g = hcg[2] / 100;
	
		if (c === 0.0) {
			return [g * 255, g * 255, g * 255];
		}
	
		var pure = [0, 0, 0];
		var hi = (h % 1) * 6;
		var v = hi % 1;
		var w = 1 - v;
		var mg = 0;
	
		switch (Math.floor(hi)) {
			case 0:
				pure[0] = 1; pure[1] = v; pure[2] = 0; break;
			case 1:
				pure[0] = w; pure[1] = 1; pure[2] = 0; break;
			case 2:
				pure[0] = 0; pure[1] = 1; pure[2] = v; break;
			case 3:
				pure[0] = 0; pure[1] = w; pure[2] = 1; break;
			case 4:
				pure[0] = v; pure[1] = 0; pure[2] = 1; break;
			default:
				pure[0] = 1; pure[1] = 0; pure[2] = w;
		}
	
		mg = (1.0 - c) * g;
	
		return [
			(c * pure[0] + mg) * 255,
			(c * pure[1] + mg) * 255,
			(c * pure[2] + mg) * 255
		];
	};
	
	convert.hcg.hsv = function (hcg) {
		var c = hcg[1] / 100;
		var g = hcg[2] / 100;
	
		var v = c + g * (1.0 - c);
		var f = 0;
	
		if (v > 0.0) {
			f = c / v;
		}
	
		return [hcg[0], f * 100, v * 100];
	};
	
	convert.hcg.hsl = function (hcg) {
		var c = hcg[1] / 100;
		var g = hcg[2] / 100;
	
		var l = g * (1.0 - c) + 0.5 * c;
		var s = 0;
	
		if (l > 0.0 && l < 0.5) {
			s = c / (2 * l);
		} else
		if (l >= 0.5 && l < 1.0) {
			s = c / (2 * (1 - l));
		}
	
		return [hcg[0], s * 100, l * 100];
	};
	
	convert.hcg.hwb = function (hcg) {
		var c = hcg[1] / 100;
		var g = hcg[2] / 100;
		var v = c + g * (1.0 - c);
		return [hcg[0], (v - c) * 100, (1 - v) * 100];
	};
	
	convert.hwb.hcg = function (hwb) {
		var w = hwb[1] / 100;
		var b = hwb[2] / 100;
		var v = 1 - b;
		var c = v - w;
		var g = 0;
	
		if (c < 1) {
			g = (v - c) / (1 - c);
		}
	
		return [hwb[0], c * 100, g * 100];
	};
	
	convert.apple.rgb = function (apple) {
		return [(apple[0] / 65535) * 255, (apple[1] / 65535) * 255, (apple[2] / 65535) * 255];
	};
	
	convert.rgb.apple = function (rgb) {
		return [(rgb[0] / 255) * 65535, (rgb[1] / 255) * 65535, (rgb[2] / 255) * 65535];
	};
	
	convert.gray.rgb = function (args) {
		return [args[0] / 100 * 255, args[0] / 100 * 255, args[0] / 100 * 255];
	};
	
	convert.gray.hsl = convert.gray.hsv = function (args) {
		return [0, 0, args[0]];
	};
	
	convert.gray.hwb = function (gray) {
		return [0, 100, gray[0]];
	};
	
	convert.gray.cmyk = function (gray) {
		return [0, 0, 0, gray[0]];
	};
	
	convert.gray.lab = function (gray) {
		return [gray[0], 0, 0];
	};
	
	convert.gray.hex = function (gray) {
		var val = Math.round(gray[0] / 100 * 255) & 0xFF;
		var integer = (val << 16) + (val << 8) + val;
	
		var string = integer.toString(16).toUpperCase();
		return '000000'.substring(string.length) + string;
	};
	
	convert.rgb.gray = function (rgb) {
		var val = (rgb[0] + rgb[1] + rgb[2]) / 3;
		return [val / 255 * 100];
	};
	});
	var conversions_1 = conversions.rgb;
	var conversions_2 = conversions.hsl;
	var conversions_3 = conversions.hsv;
	var conversions_4 = conversions.hwb;
	var conversions_5 = conversions.cmyk;
	var conversions_6 = conversions.xyz;
	var conversions_7 = conversions.lab;
	var conversions_8 = conversions.lch;
	var conversions_9 = conversions.hex;
	var conversions_10 = conversions.keyword;
	var conversions_11 = conversions.ansi16;
	var conversions_12 = conversions.ansi256;
	var conversions_13 = conversions.hcg;
	var conversions_14 = conversions.apple;
	var conversions_15 = conversions.gray;
	
	/*
		this function routes a model to all other models.
	
		all functions that are routed have a property `.conversion` attached
		to the returned synthetic function. This property is an array
		of strings, each with the steps in between the 'from' and 'to'
		color models (inclusive).
	
		conversions that are not possible simply are not included.
	*/
	
	function buildGraph() {
		var graph = {};
		// https://jsperf.com/object-keys-vs-for-in-with-closure/3
		var models = Object.keys(conversions);
	
		for (var len = models.length, i = 0; i < len; i++) {
			graph[models[i]] = {
				// http://jsperf.com/1-vs-infinity
				// micro-opt, but this is simple.
				distance: -1,
				parent: null
			};
		}
	
		return graph;
	}
	
	// https://en.wikipedia.org/wiki/Breadth-first_search
	function deriveBFS(fromModel) {
		var graph = buildGraph();
		var queue = [fromModel]; // unshift -> queue -> pop
	
		graph[fromModel].distance = 0;
	
		while (queue.length) {
			var current = queue.pop();
			var adjacents = Object.keys(conversions[current]);
	
			for (var len = adjacents.length, i = 0; i < len; i++) {
				var adjacent = adjacents[i];
				var node = graph[adjacent];
	
				if (node.distance === -1) {
					node.distance = graph[current].distance + 1;
					node.parent = current;
					queue.unshift(adjacent);
				}
			}
		}
	
		return graph;
	}
	
	function link(from, to) {
		return function (args) {
			return to(from(args));
		};
	}
	
	function wrapConversion(toModel, graph) {
		var path = [graph[toModel].parent, toModel];
		var fn = conversions[graph[toModel].parent][toModel];
	
		var cur = graph[toModel].parent;
		while (graph[cur].parent) {
			path.unshift(graph[cur].parent);
			fn = link(conversions[graph[cur].parent][cur], fn);
			cur = graph[cur].parent;
		}
	
		fn.conversion = path;
		return fn;
	}
	
	var route = function (fromModel) {
		var graph = deriveBFS(fromModel);
		var conversion = {};
	
		var models = Object.keys(graph);
		for (var len = models.length, i = 0; i < len; i++) {
			var toModel = models[i];
			var node = graph[toModel];
	
			if (node.parent === null) {
				// no possible conversion, or this node is the source model.
				continue;
			}
	
			conversion[toModel] = wrapConversion(toModel, graph);
		}
	
		return conversion;
	};
	
	var convert = {};
	
	var models = Object.keys(conversions);
	
	function wrapRaw(fn) {
		var wrappedFn = function (args) {
			if (args === undefined || args === null) {
				return args;
			}
	
			if (arguments.length > 1) {
				args = Array.prototype.slice.call(arguments);
			}
	
			return fn(args);
		};
	
		// preserve .conversion property if there is one
		if ('conversion' in fn) {
			wrappedFn.conversion = fn.conversion;
		}
	
		return wrappedFn;
	}
	
	function wrapRounded(fn) {
		var wrappedFn = function (args) {
			if (args === undefined || args === null) {
				return args;
			}
	
			if (arguments.length > 1) {
				args = Array.prototype.slice.call(arguments);
			}
	
			var result = fn(args);
	
			// we're assuming the result is an array here.
			// see notice in conversions.js; don't use box types
			// in conversion functions.
			if (typeof result === 'object') {
				for (var len = result.length, i = 0; i < len; i++) {
					result[i] = Math.round(result[i]);
				}
			}
	
			return result;
		};
	
		// preserve .conversion property if there is one
		if ('conversion' in fn) {
			wrappedFn.conversion = fn.conversion;
		}
	
		return wrappedFn;
	}
	
	models.forEach(function (fromModel) {
		convert[fromModel] = {};
	
		Object.defineProperty(convert[fromModel], 'channels', {value: conversions[fromModel].channels});
		Object.defineProperty(convert[fromModel], 'labels', {value: conversions[fromModel].labels});
	
		var routes = route(fromModel);
		var routeModels = Object.keys(routes);
	
		routeModels.forEach(function (toModel) {
			var fn = routes[toModel];
	
			convert[fromModel][toModel] = wrapRounded(fn);
			convert[fromModel][toModel].raw = wrapRaw(fn);
		});
	});
	
	var colorConvert = convert;
	
	var colorName$1 = {
		"aliceblue": [240, 248, 255],
		"antiquewhite": [250, 235, 215],
		"aqua": [0, 255, 255],
		"aquamarine": [127, 255, 212],
		"azure": [240, 255, 255],
		"beige": [245, 245, 220],
		"bisque": [255, 228, 196],
		"black": [0, 0, 0],
		"blanchedalmond": [255, 235, 205],
		"blue": [0, 0, 255],
		"blueviolet": [138, 43, 226],
		"brown": [165, 42, 42],
		"burlywood": [222, 184, 135],
		"cadetblue": [95, 158, 160],
		"chartreuse": [127, 255, 0],
		"chocolate": [210, 105, 30],
		"coral": [255, 127, 80],
		"cornflowerblue": [100, 149, 237],
		"cornsilk": [255, 248, 220],
		"crimson": [220, 20, 60],
		"cyan": [0, 255, 255],
		"darkblue": [0, 0, 139],
		"darkcyan": [0, 139, 139],
		"darkgoldenrod": [184, 134, 11],
		"darkgray": [169, 169, 169],
		"darkgreen": [0, 100, 0],
		"darkgrey": [169, 169, 169],
		"darkkhaki": [189, 183, 107],
		"darkmagenta": [139, 0, 139],
		"darkolivegreen": [85, 107, 47],
		"darkorange": [255, 140, 0],
		"darkorchid": [153, 50, 204],
		"darkred": [139, 0, 0],
		"darksalmon": [233, 150, 122],
		"darkseagreen": [143, 188, 143],
		"darkslateblue": [72, 61, 139],
		"darkslategray": [47, 79, 79],
		"darkslategrey": [47, 79, 79],
		"darkturquoise": [0, 206, 209],
		"darkviolet": [148, 0, 211],
		"deeppink": [255, 20, 147],
		"deepskyblue": [0, 191, 255],
		"dimgray": [105, 105, 105],
		"dimgrey": [105, 105, 105],
		"dodgerblue": [30, 144, 255],
		"firebrick": [178, 34, 34],
		"floralwhite": [255, 250, 240],
		"forestgreen": [34, 139, 34],
		"fuchsia": [255, 0, 255],
		"gainsboro": [220, 220, 220],
		"ghostwhite": [248, 248, 255],
		"gold": [255, 215, 0],
		"goldenrod": [218, 165, 32],
		"gray": [128, 128, 128],
		"green": [0, 128, 0],
		"greenyellow": [173, 255, 47],
		"grey": [128, 128, 128],
		"honeydew": [240, 255, 240],
		"hotpink": [255, 105, 180],
		"indianred": [205, 92, 92],
		"indigo": [75, 0, 130],
		"ivory": [255, 255, 240],
		"khaki": [240, 230, 140],
		"lavender": [230, 230, 250],
		"lavenderblush": [255, 240, 245],
		"lawngreen": [124, 252, 0],
		"lemonchiffon": [255, 250, 205],
		"lightblue": [173, 216, 230],
		"lightcoral": [240, 128, 128],
		"lightcyan": [224, 255, 255],
		"lightgoldenrodyellow": [250, 250, 210],
		"lightgray": [211, 211, 211],
		"lightgreen": [144, 238, 144],
		"lightgrey": [211, 211, 211],
		"lightpink": [255, 182, 193],
		"lightsalmon": [255, 160, 122],
		"lightseagreen": [32, 178, 170],
		"lightskyblue": [135, 206, 250],
		"lightslategray": [119, 136, 153],
		"lightslategrey": [119, 136, 153],
		"lightsteelblue": [176, 196, 222],
		"lightyellow": [255, 255, 224],
		"lime": [0, 255, 0],
		"limegreen": [50, 205, 50],
		"linen": [250, 240, 230],
		"magenta": [255, 0, 255],
		"maroon": [128, 0, 0],
		"mediumaquamarine": [102, 205, 170],
		"mediumblue": [0, 0, 205],
		"mediumorchid": [186, 85, 211],
		"mediumpurple": [147, 112, 219],
		"mediumseagreen": [60, 179, 113],
		"mediumslateblue": [123, 104, 238],
		"mediumspringgreen": [0, 250, 154],
		"mediumturquoise": [72, 209, 204],
		"mediumvioletred": [199, 21, 133],
		"midnightblue": [25, 25, 112],
		"mintcream": [245, 255, 250],
		"mistyrose": [255, 228, 225],
		"moccasin": [255, 228, 181],
		"navajowhite": [255, 222, 173],
		"navy": [0, 0, 128],
		"oldlace": [253, 245, 230],
		"olive": [128, 128, 0],
		"olivedrab": [107, 142, 35],
		"orange": [255, 165, 0],
		"orangered": [255, 69, 0],
		"orchid": [218, 112, 214],
		"palegoldenrod": [238, 232, 170],
		"palegreen": [152, 251, 152],
		"paleturquoise": [175, 238, 238],
		"palevioletred": [219, 112, 147],
		"papayawhip": [255, 239, 213],
		"peachpuff": [255, 218, 185],
		"peru": [205, 133, 63],
		"pink": [255, 192, 203],
		"plum": [221, 160, 221],
		"powderblue": [176, 224, 230],
		"purple": [128, 0, 128],
		"rebeccapurple": [102, 51, 153],
		"red": [255, 0, 0],
		"rosybrown": [188, 143, 143],
		"royalblue": [65, 105, 225],
		"saddlebrown": [139, 69, 19],
		"salmon": [250, 128, 114],
		"sandybrown": [244, 164, 96],
		"seagreen": [46, 139, 87],
		"seashell": [255, 245, 238],
		"sienna": [160, 82, 45],
		"silver": [192, 192, 192],
		"skyblue": [135, 206, 235],
		"slateblue": [106, 90, 205],
		"slategray": [112, 128, 144],
		"slategrey": [112, 128, 144],
		"snow": [255, 250, 250],
		"springgreen": [0, 255, 127],
		"steelblue": [70, 130, 180],
		"tan": [210, 180, 140],
		"teal": [0, 128, 128],
		"thistle": [216, 191, 216],
		"tomato": [255, 99, 71],
		"turquoise": [64, 224, 208],
		"violet": [238, 130, 238],
		"wheat": [245, 222, 179],
		"white": [255, 255, 255],
		"whitesmoke": [245, 245, 245],
		"yellow": [255, 255, 0],
		"yellowgreen": [154, 205, 50]
	};
	
	/* MIT license */
	
	
	var colorString = {
	   getRgba: getRgba,
	   getHsla: getHsla,
	   getRgb: getRgb,
	   getHsl: getHsl,
	   getHwb: getHwb,
	   getAlpha: getAlpha,
	
	   hexString: hexString,
	   rgbString: rgbString,
	   rgbaString: rgbaString,
	   percentString: percentString,
	   percentaString: percentaString,
	   hslString: hslString,
	   hslaString: hslaString,
	   hwbString: hwbString,
	   keyword: keyword
	};
	
	function getRgba(string) {
	   if (!string) {
	      return;
	   }
	   var abbr =  /^#([a-fA-F0-9]{3,4})$/i,
	       hex =  /^#([a-fA-F0-9]{6}([a-fA-F0-9]{2})?)$/i,
	       rgba = /^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
	       per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
	       keyword = /(\w+)/;
	
	   var rgb = [0, 0, 0],
	       a = 1,
	       match = string.match(abbr),
	       hexAlpha = "";
	   if (match) {
	      match = match[1];
	      hexAlpha = match[3];
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = parseInt(match[i] + match[i], 16);
	      }
	      if (hexAlpha) {
	         a = Math.round((parseInt(hexAlpha + hexAlpha, 16) / 255) * 100) / 100;
	      }
	   }
	   else if (match = string.match(hex)) {
	      hexAlpha = match[2];
	      match = match[1];
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = parseInt(match.slice(i * 2, i * 2 + 2), 16);
	      }
	      if (hexAlpha) {
	         a = Math.round((parseInt(hexAlpha, 16) / 255) * 100) / 100;
	      }
	   }
	   else if (match = string.match(rgba)) {
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = parseInt(match[i + 1]);
	      }
	      a = parseFloat(match[4]);
	   }
	   else if (match = string.match(per)) {
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
	      }
	      a = parseFloat(match[4]);
	   }
	   else if (match = string.match(keyword)) {
	      if (match[1] == "transparent") {
	         return [0, 0, 0, 0];
	      }
	      rgb = colorName$1[match[1]];
	      if (!rgb) {
	         return;
	      }
	   }
	
	   for (var i = 0; i < rgb.length; i++) {
	      rgb[i] = scale(rgb[i], 0, 255);
	   }
	   if (!a && a != 0) {
	      a = 1;
	   }
	   else {
	      a = scale(a, 0, 1);
	   }
	   rgb[3] = a;
	   return rgb;
	}
	
	function getHsla(string) {
	   if (!string) {
	      return;
	   }
	   var hsl = /^hsla?\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
	   var match = string.match(hsl);
	   if (match) {
	      var alpha = parseFloat(match[4]);
	      var h = scale(parseInt(match[1]), 0, 360),
	          s = scale(parseFloat(match[2]), 0, 100),
	          l = scale(parseFloat(match[3]), 0, 100),
	          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
	      return [h, s, l, a];
	   }
	}
	
	function getHwb(string) {
	   if (!string) {
	      return;
	   }
	   var hwb = /^hwb\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
	   var match = string.match(hwb);
	   if (match) {
	    var alpha = parseFloat(match[4]);
	      var h = scale(parseInt(match[1]), 0, 360),
	          w = scale(parseFloat(match[2]), 0, 100),
	          b = scale(parseFloat(match[3]), 0, 100),
	          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
	      return [h, w, b, a];
	   }
	}
	
	function getRgb(string) {
	   var rgba = getRgba(string);
	   return rgba && rgba.slice(0, 3);
	}
	
	function getHsl(string) {
	  var hsla = getHsla(string);
	  return hsla && hsla.slice(0, 3);
	}
	
	function getAlpha(string) {
	   var vals = getRgba(string);
	   if (vals) {
	      return vals[3];
	   }
	   else if (vals = getHsla(string)) {
	      return vals[3];
	   }
	   else if (vals = getHwb(string)) {
	      return vals[3];
	   }
	}
	
	// generators
	function hexString(rgba, a) {
	   var a = (a !== undefined && rgba.length === 3) ? a : rgba[3];
	   return "#" + hexDouble(rgba[0]) 
	              + hexDouble(rgba[1])
	              + hexDouble(rgba[2])
	              + (
	                 (a >= 0 && a < 1)
	                 ? hexDouble(Math.round(a * 255))
	                 : ""
	              );
	}
	
	function rgbString(rgba, alpha) {
	   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
	      return rgbaString(rgba, alpha);
	   }
	   return "rgb(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2] + ")";
	}
	
	function rgbaString(rgba, alpha) {
	   if (alpha === undefined) {
	      alpha = (rgba[3] !== undefined ? rgba[3] : 1);
	   }
	   return "rgba(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2]
	           + ", " + alpha + ")";
	}
	
	function percentString(rgba, alpha) {
	   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
	      return percentaString(rgba, alpha);
	   }
	   var r = Math.round(rgba[0]/255 * 100),
	       g = Math.round(rgba[1]/255 * 100),
	       b = Math.round(rgba[2]/255 * 100);
	
	   return "rgb(" + r + "%, " + g + "%, " + b + "%)";
	}
	
	function percentaString(rgba, alpha) {
	   var r = Math.round(rgba[0]/255 * 100),
	       g = Math.round(rgba[1]/255 * 100),
	       b = Math.round(rgba[2]/255 * 100);
	   return "rgba(" + r + "%, " + g + "%, " + b + "%, " + (alpha || rgba[3] || 1) + ")";
	}
	
	function hslString(hsla, alpha) {
	   if (alpha < 1 || (hsla[3] && hsla[3] < 1)) {
	      return hslaString(hsla, alpha);
	   }
	   return "hsl(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%)";
	}
	
	function hslaString(hsla, alpha) {
	   if (alpha === undefined) {
	      alpha = (hsla[3] !== undefined ? hsla[3] : 1);
	   }
	   return "hsla(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%, "
	           + alpha + ")";
	}
	
	// hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
	// (hwb have alpha optional & 1 is default value)
	function hwbString(hwb, alpha) {
	   if (alpha === undefined) {
	      alpha = (hwb[3] !== undefined ? hwb[3] : 1);
	   }
	   return "hwb(" + hwb[0] + ", " + hwb[1] + "%, " + hwb[2] + "%"
	           + (alpha !== undefined && alpha !== 1 ? ", " + alpha : "") + ")";
	}
	
	function keyword(rgb) {
	  return reverseNames[rgb.slice(0, 3)];
	}
	
	// helpers
	function scale(num, min, max) {
	   return Math.min(Math.max(min, num), max);
	}
	
	function hexDouble(num) {
	  var str = num.toString(16).toUpperCase();
	  return (str.length < 2) ? "0" + str : str;
	}
	
	
	//create a list of reverse color names
	var reverseNames = {};
	for (var name in colorName$1) {
	   reverseNames[colorName$1[name]] = name;
	}
	
	/* MIT license */
	
	
	
	var Color = function (obj) {
		if (obj instanceof Color) {
			return obj;
		}
		if (!(this instanceof Color)) {
			return new Color(obj);
		}
	
		this.valid = false;
		this.values = {
			rgb: [0, 0, 0],
			hsl: [0, 0, 0],
			hsv: [0, 0, 0],
			hwb: [0, 0, 0],
			cmyk: [0, 0, 0, 0],
			alpha: 1
		};
	
		// parse Color() argument
		var vals;
		if (typeof obj === 'string') {
			vals = colorString.getRgba(obj);
			if (vals) {
				this.setValues('rgb', vals);
			} else if (vals = colorString.getHsla(obj)) {
				this.setValues('hsl', vals);
			} else if (vals = colorString.getHwb(obj)) {
				this.setValues('hwb', vals);
			}
		} else if (typeof obj === 'object') {
			vals = obj;
			if (vals.r !== undefined || vals.red !== undefined) {
				this.setValues('rgb', vals);
			} else if (vals.l !== undefined || vals.lightness !== undefined) {
				this.setValues('hsl', vals);
			} else if (vals.v !== undefined || vals.value !== undefined) {
				this.setValues('hsv', vals);
			} else if (vals.w !== undefined || vals.whiteness !== undefined) {
				this.setValues('hwb', vals);
			} else if (vals.c !== undefined || vals.cyan !== undefined) {
				this.setValues('cmyk', vals);
			}
		}
	};
	
	Color.prototype = {
		isValid: function () {
			return this.valid;
		},
		rgb: function () {
			return this.setSpace('rgb', arguments);
		},
		hsl: function () {
			return this.setSpace('hsl', arguments);
		},
		hsv: function () {
			return this.setSpace('hsv', arguments);
		},
		hwb: function () {
			return this.setSpace('hwb', arguments);
		},
		cmyk: function () {
			return this.setSpace('cmyk', arguments);
		},
	
		rgbArray: function () {
			return this.values.rgb;
		},
		hslArray: function () {
			return this.values.hsl;
		},
		hsvArray: function () {
			return this.values.hsv;
		},
		hwbArray: function () {
			var values = this.values;
			if (values.alpha !== 1) {
				return values.hwb.concat([values.alpha]);
			}
			return values.hwb;
		},
		cmykArray: function () {
			return this.values.cmyk;
		},
		rgbaArray: function () {
			var values = this.values;
			return values.rgb.concat([values.alpha]);
		},
		hslaArray: function () {
			var values = this.values;
			return values.hsl.concat([values.alpha]);
		},
		alpha: function (val) {
			if (val === undefined) {
				return this.values.alpha;
			}
			this.setValues('alpha', val);
			return this;
		},
	
		red: function (val) {
			return this.setChannel('rgb', 0, val);
		},
		green: function (val) {
			return this.setChannel('rgb', 1, val);
		},
		blue: function (val) {
			return this.setChannel('rgb', 2, val);
		},
		hue: function (val) {
			if (val) {
				val %= 360;
				val = val < 0 ? 360 + val : val;
			}
			return this.setChannel('hsl', 0, val);
		},
		saturation: function (val) {
			return this.setChannel('hsl', 1, val);
		},
		lightness: function (val) {
			return this.setChannel('hsl', 2, val);
		},
		saturationv: function (val) {
			return this.setChannel('hsv', 1, val);
		},
		whiteness: function (val) {
			return this.setChannel('hwb', 1, val);
		},
		blackness: function (val) {
			return this.setChannel('hwb', 2, val);
		},
		value: function (val) {
			return this.setChannel('hsv', 2, val);
		},
		cyan: function (val) {
			return this.setChannel('cmyk', 0, val);
		},
		magenta: function (val) {
			return this.setChannel('cmyk', 1, val);
		},
		yellow: function (val) {
			return this.setChannel('cmyk', 2, val);
		},
		black: function (val) {
			return this.setChannel('cmyk', 3, val);
		},
	
		hexString: function () {
			return colorString.hexString(this.values.rgb);
		},
		rgbString: function () {
			return colorString.rgbString(this.values.rgb, this.values.alpha);
		},
		rgbaString: function () {
			return colorString.rgbaString(this.values.rgb, this.values.alpha);
		},
		percentString: function () {
			return colorString.percentString(this.values.rgb, this.values.alpha);
		},
		hslString: function () {
			return colorString.hslString(this.values.hsl, this.values.alpha);
		},
		hslaString: function () {
			return colorString.hslaString(this.values.hsl, this.values.alpha);
		},
		hwbString: function () {
			return colorString.hwbString(this.values.hwb, this.values.alpha);
		},
		keyword: function () {
			return colorString.keyword(this.values.rgb, this.values.alpha);
		},
	
		rgbNumber: function () {
			var rgb = this.values.rgb;
			return (rgb[0] << 16) | (rgb[1] << 8) | rgb[2];
		},
	
		luminosity: function () {
			// http://www.w3.org/TR/WCAG20/#relativeluminancedef
			var rgb = this.values.rgb;
			var lum = [];
			for (var i = 0; i < rgb.length; i++) {
				var chan = rgb[i] / 255;
				lum[i] = (chan <= 0.03928) ? chan / 12.92 : Math.pow(((chan + 0.055) / 1.055), 2.4);
			}
			return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
		},
	
		contrast: function (color2) {
			// http://www.w3.org/TR/WCAG20/#contrast-ratiodef
			var lum1 = this.luminosity();
			var lum2 = color2.luminosity();
			if (lum1 > lum2) {
				return (lum1 + 0.05) / (lum2 + 0.05);
			}
			return (lum2 + 0.05) / (lum1 + 0.05);
		},
	
		level: function (color2) {
			var contrastRatio = this.contrast(color2);
			if (contrastRatio >= 7.1) {
				return 'AAA';
			}
	
			return (contrastRatio >= 4.5) ? 'AA' : '';
		},
	
		dark: function () {
			// YIQ equation from http://24ways.org/2010/calculating-color-contrast
			var rgb = this.values.rgb;
			var yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
			return yiq < 128;
		},
	
		light: function () {
			return !this.dark();
		},
	
		negate: function () {
			var rgb = [];
			for (var i = 0; i < 3; i++) {
				rgb[i] = 255 - this.values.rgb[i];
			}
			this.setValues('rgb', rgb);
			return this;
		},
	
		lighten: function (ratio) {
			var hsl = this.values.hsl;
			hsl[2] += hsl[2] * ratio;
			this.setValues('hsl', hsl);
			return this;
		},
	
		darken: function (ratio) {
			var hsl = this.values.hsl;
			hsl[2] -= hsl[2] * ratio;
			this.setValues('hsl', hsl);
			return this;
		},
	
		saturate: function (ratio) {
			var hsl = this.values.hsl;
			hsl[1] += hsl[1] * ratio;
			this.setValues('hsl', hsl);
			return this;
		},
	
		desaturate: function (ratio) {
			var hsl = this.values.hsl;
			hsl[1] -= hsl[1] * ratio;
			this.setValues('hsl', hsl);
			return this;
		},
	
		whiten: function (ratio) {
			var hwb = this.values.hwb;
			hwb[1] += hwb[1] * ratio;
			this.setValues('hwb', hwb);
			return this;
		},
	
		blacken: function (ratio) {
			var hwb = this.values.hwb;
			hwb[2] += hwb[2] * ratio;
			this.setValues('hwb', hwb);
			return this;
		},
	
		greyscale: function () {
			var rgb = this.values.rgb;
			// http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
			var val = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
			this.setValues('rgb', [val, val, val]);
			return this;
		},
	
		clearer: function (ratio) {
			var alpha = this.values.alpha;
			this.setValues('alpha', alpha - (alpha * ratio));
			return this;
		},
	
		opaquer: function (ratio) {
			var alpha = this.values.alpha;
			this.setValues('alpha', alpha + (alpha * ratio));
			return this;
		},
	
		rotate: function (degrees) {
			var hsl = this.values.hsl;
			var hue = (hsl[0] + degrees) % 360;
			hsl[0] = hue < 0 ? 360 + hue : hue;
			this.setValues('hsl', hsl);
			return this;
		},
	
		/**
		 * Ported from sass implementation in C
		 * https://github.com/sass/libsass/blob/0e6b4a2850092356aa3ece07c6b249f0221caced/functions.cpp#L209
		 */
		mix: function (mixinColor, weight) {
			var color1 = this;
			var color2 = mixinColor;
			var p = weight === undefined ? 0.5 : weight;
	
			var w = 2 * p - 1;
			var a = color1.alpha() - color2.alpha();
	
			var w1 = (((w * a === -1) ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
			var w2 = 1 - w1;
	
			return this
				.rgb(
					w1 * color1.red() + w2 * color2.red(),
					w1 * color1.green() + w2 * color2.green(),
					w1 * color1.blue() + w2 * color2.blue()
				)
				.alpha(color1.alpha() * p + color2.alpha() * (1 - p));
		},
	
		toJSON: function () {
			return this.rgb();
		},
	
		clone: function () {
			// NOTE(SB): using node-clone creates a dependency to Buffer when using browserify,
			// making the final build way to big to embed in Chart.js. So let's do it manually,
			// assuming that values to clone are 1 dimension arrays containing only numbers,
			// except 'alpha' which is a number.
			var result = new Color();
			var source = this.values;
			var target = result.values;
			var value, type;
	
			for (var prop in source) {
				if (source.hasOwnProperty(prop)) {
					value = source[prop];
					type = ({}).toString.call(value);
					if (type === '[object Array]') {
						target[prop] = value.slice(0);
					} else if (type === '[object Number]') {
						target[prop] = value;
					} else {
						console.error('unexpected color value:', value);
					}
				}
			}
	
			return result;
		}
	};
	
	Color.prototype.spaces = {
		rgb: ['red', 'green', 'blue'],
		hsl: ['hue', 'saturation', 'lightness'],
		hsv: ['hue', 'saturation', 'value'],
		hwb: ['hue', 'whiteness', 'blackness'],
		cmyk: ['cyan', 'magenta', 'yellow', 'black']
	};
	
	Color.prototype.maxes = {
		rgb: [255, 255, 255],
		hsl: [360, 100, 100],
		hsv: [360, 100, 100],
		hwb: [360, 100, 100],
		cmyk: [100, 100, 100, 100]
	};
	
	Color.prototype.getValues = function (space) {
		var values = this.values;
		var vals = {};
	
		for (var i = 0; i < space.length; i++) {
			vals[space.charAt(i)] = values[space][i];
		}
	
		if (values.alpha !== 1) {
			vals.a = values.alpha;
		}
	
		// {r: 255, g: 255, b: 255, a: 0.4}
		return vals;
	};
	
	Color.prototype.setValues = function (space, vals) {
		var values = this.values;
		var spaces = this.spaces;
		var maxes = this.maxes;
		var alpha = 1;
		var i;
	
		this.valid = true;
	
		if (space === 'alpha') {
			alpha = vals;
		} else if (vals.length) {
			// [10, 10, 10]
			values[space] = vals.slice(0, space.length);
			alpha = vals[space.length];
		} else if (vals[space.charAt(0)] !== undefined) {
			// {r: 10, g: 10, b: 10}
			for (i = 0; i < space.length; i++) {
				values[space][i] = vals[space.charAt(i)];
			}
	
			alpha = vals.a;
		} else if (vals[spaces[space][0]] !== undefined) {
			// {red: 10, green: 10, blue: 10}
			var chans = spaces[space];
	
			for (i = 0; i < space.length; i++) {
				values[space][i] = vals[chans[i]];
			}
	
			alpha = vals.alpha;
		}
	
		values.alpha = Math.max(0, Math.min(1, (alpha === undefined ? values.alpha : alpha)));
	
		if (space === 'alpha') {
			return false;
		}
	
		var capped;
	
		// cap values of the space prior converting all values
		for (i = 0; i < space.length; i++) {
			capped = Math.max(0, Math.min(maxes[space][i], values[space][i]));
			values[space][i] = Math.round(capped);
		}
	
		// convert to all the other color spaces
		for (var sname in spaces) {
			if (sname !== space) {
				values[sname] = colorConvert[space][sname](values[space]);
			}
		}
	
		return true;
	};
	
	Color.prototype.setSpace = function (space, args) {
		var vals = args[0];
	
		if (vals === undefined) {
			// color.rgb()
			return this.getValues(space);
		}
	
		// color.rgb(10, 10, 10)
		if (typeof vals === 'number') {
			vals = Array.prototype.slice.call(args);
		}
	
		this.setValues(space, vals);
		return this;
	};
	
	Color.prototype.setChannel = function (space, index, val) {
		var svalues = this.values[space];
		if (val === undefined) {
			// color.red()
			return svalues[index];
		} else if (val === svalues[index]) {
			// color.red(color.red())
			return this;
		}
	
		// color.red(100)
		svalues[index] = val;
		this.setValues(space, svalues);
	
		return this;
	};
	
	if (typeof window !== 'undefined') {
		window.Color = Color;
	}
	
	var chartjsColor = Color;
	
	function isValidKey(key) {
		return ['__proto__', 'prototype', 'constructor'].indexOf(key) === -1;
	}
	
	/**
	 * @namespace Chart.helpers
	 */
	var helpers = {
		/**
		 * An empty function that can be used, for example, for optional callback.
		 */
		noop: function() {},
	
		/**
		 * Returns a unique id, sequentially generated from a global variable.
		 * @returns {number}
		 * @function
		 */
		uid: (function() {
			var id = 0;
			return function() {
				return id++;
			};
		}()),
	
		/**
		 * Returns true if `value` is neither null nor undefined, else returns false.
		 * @param {*} value - The value to test.
		 * @returns {boolean}
		 * @since 2.7.0
		 */
		isNullOrUndef: function(value) {
			return value === null || typeof value === 'undefined';
		},
	
		/**
		 * Returns true if `value` is an array (including typed arrays), else returns false.
		 * @param {*} value - The value to test.
		 * @returns {boolean}
		 * @function
		 */
		isArray: function(value) {
			if (Array.isArray && Array.isArray(value)) {
				return true;
			}
			var type = Object.prototype.toString.call(value);
			if (type.substr(0, 7) === '[object' && type.substr(-6) === 'Array]') {
				return true;
			}
			return false;
		},
	
		/**
		 * Returns true if `value` is an object (excluding null), else returns false.
		 * @param {*} value - The value to test.
		 * @returns {boolean}
		 * @since 2.7.0
		 */
		isObject: function(value) {
			return value !== null && Object.prototype.toString.call(value) === '[object Object]';
		},
	
		/**
		 * Returns true if `value` is a finite number, else returns false
		 * @param {*} value  - The value to test.
		 * @returns {boolean}
		 */
		isFinite: function(value) {
			return (typeof value === 'number' || value instanceof Number) && isFinite(value);
		},
	
		/**
		 * Returns `value` if defined, else returns `defaultValue`.
		 * @param {*} value - The value to return if defined.
		 * @param {*} defaultValue - The value to return if `value` is undefined.
		 * @returns {*}
		 */
		valueOrDefault: function(value, defaultValue) {
			return typeof value === 'undefined' ? defaultValue : value;
		},
	
		/**
		 * Returns value at the given `index` in array if defined, else returns `defaultValue`.
		 * @param {Array} value - The array to lookup for value at `index`.
		 * @param {number} index - The index in `value` to lookup for value.
		 * @param {*} defaultValue - The value to return if `value[index]` is undefined.
		 * @returns {*}
		 */
		valueAtIndexOrDefault: function(value, index, defaultValue) {
			return helpers.valueOrDefault(helpers.isArray(value) ? value[index] : value, defaultValue);
		},
	
		/**
		 * Calls `fn` with the given `args` in the scope defined by `thisArg` and returns the
		 * value returned by `fn`. If `fn` is not a function, this method returns undefined.
		 * @param {function} fn - The function to call.
		 * @param {Array|undefined|null} args - The arguments with which `fn` should be called.
		 * @param {object} [thisArg] - The value of `this` provided for the call to `fn`.
		 * @returns {*}
		 */
		callback: function(fn, args, thisArg) {
			if (fn && typeof fn.call === 'function') {
				return fn.apply(thisArg, args);
			}
		},
	
		/**
		 * Note(SB) for performance sake, this method should only be used when loopable type
		 * is unknown or in none intensive code (not called often and small loopable). Else
		 * it's preferable to use a regular for() loop and save extra function calls.
		 * @param {object|Array} loopable - The object or array to be iterated.
		 * @param {function} fn - The function to call for each item.
		 * @param {object} [thisArg] - The value of `this` provided for the call to `fn`.
		 * @param {boolean} [reverse] - If true, iterates backward on the loopable.
		 */
		each: function(loopable, fn, thisArg, reverse) {
			var i, len, keys;
			if (helpers.isArray(loopable)) {
				len = loopable.length;
				if (reverse) {
					for (i = len - 1; i >= 0; i--) {
						fn.call(thisArg, loopable[i], i);
					}
				} else {
					for (i = 0; i < len; i++) {
						fn.call(thisArg, loopable[i], i);
					}
				}
			} else if (helpers.isObject(loopable)) {
				keys = Object.keys(loopable);
				len = keys.length;
				for (i = 0; i < len; i++) {
					fn.call(thisArg, loopable[keys[i]], keys[i]);
				}
			}
		},
	
		/**
		 * Returns true if the `a0` and `a1` arrays have the same content, else returns false.
		 * @see https://stackoverflow.com/a/14853974
		 * @param {Array} a0 - The array to compare
		 * @param {Array} a1 - The array to compare
		 * @returns {boolean}
		 */
		arrayEquals: function(a0, a1) {
			var i, ilen, v0, v1;
	
			if (!a0 || !a1 || a0.length !== a1.length) {
				return false;
			}
	
			for (i = 0, ilen = a0.length; i < ilen; ++i) {
				v0 = a0[i];
				v1 = a1[i];
	
				if (v0 instanceof Array && v1 instanceof Array) {
					if (!helpers.arrayEquals(v0, v1)) {
						return false;
					}
				} else if (v0 !== v1) {
					// NOTE: two different object instances will never be equal: {x:20} != {x:20}
					return false;
				}
			}
	
			return true;
		},
	
		/**
		 * Returns a deep copy of `source` without keeping references on objects and arrays.
		 * @param {*} source - The value to clone.
		 * @returns {*}
		 */
		clone: function(source) {
			if (helpers.isArray(source)) {
				return source.map(helpers.clone);
			}
	
			if (helpers.isObject(source)) {
				var target = Object.create(source);
				var keys = Object.keys(source);
				var klen = keys.length;
				var k = 0;
	
				for (; k < klen; ++k) {
					target[keys[k]] = helpers.clone(source[keys[k]]);
				}
	
				return target;
			}
	
			return source;
		},
	
		/**
		 * The default merger when Chart.helpers.merge is called without merger option.
		 * Note(SB): also used by mergeConfig and mergeScaleConfig as fallback.
		 * @private
		 */
		_merger: function(key, target, source, options) {
			if (!isValidKey(key)) {
				// We want to ensure we do not copy prototypes over
				// as this can pollute global namespaces
				return;
			}
	
			var tval = target[key];
			var sval = source[key];
	
			if (helpers.isObject(tval) && helpers.isObject(sval)) {
				helpers.merge(tval, sval, options);
			} else {
				target[key] = helpers.clone(sval);
			}
		},
	
		/**
		 * Merges source[key] in target[key] only if target[key] is undefined.
		 * @private
		 */
		_mergerIf: function(key, target, source) {
			if (!isValidKey(key)) {
				// We want to ensure we do not copy prototypes over
				// as this can pollute global namespaces
				return;
			}
	
			var tval = target[key];
			var sval = source[key];
	
			if (helpers.isObject(tval) && helpers.isObject(sval)) {
				helpers.mergeIf(tval, sval);
			} else if (!target.hasOwnProperty(key)) {
				target[key] = helpers.clone(sval);
			}
		},
	
		/**
		 * Recursively deep copies `source` properties into `target` with the given `options`.
		 * IMPORTANT: `target` is not cloned and will be updated with `source` properties.
		 * @param {object} target - The target object in which all sources are merged into.
		 * @param {object|object[]} source - Object(s) to merge into `target`.
		 * @param {object} [options] - Merging options:
		 * @param {function} [options.merger] - The merge method (key, target, source, options)
		 * @returns {object} The `target` object.
		 */
		merge: function(target, source, options) {
			var sources = helpers.isArray(source) ? source : [source];
			var ilen = sources.length;
			var merge, i, keys, klen, k;
	
			if (!helpers.isObject(target)) {
				return target;
			}
	
			options = options || {};
			merge = options.merger || helpers._merger;
	
			for (i = 0; i < ilen; ++i) {
				source = sources[i];
				if (!helpers.isObject(source)) {
					continue;
				}
	
				keys = Object.keys(source);
				for (k = 0, klen = keys.length; k < klen; ++k) {
					merge(keys[k], target, source, options);
				}
			}
	
			return target;
		},
	
		/**
		 * Recursively deep copies `source` properties into `target` *only* if not defined in target.
		 * IMPORTANT: `target` is not cloned and will be updated with `source` properties.
		 * @param {object} target - The target object in which all sources are merged into.
		 * @param {object|object[]} source - Object(s) to merge into `target`.
		 * @returns {object} The `target` object.
		 */
		mergeIf: function(target, source) {
			return helpers.merge(target, source, {merger: helpers._mergerIf});
		},
	
		/**
		 * Applies the contents of two or more objects together into the first object.
		 * @param {object} target - The target object in which all objects are merged into.
		 * @param {object} arg1 - Object containing additional properties to merge in target.
		 * @param {object} argN - Additional objects containing properties to merge in target.
		 * @returns {object} The `target` object.
		 */
		extend: Object.assign || function(target) {
			return helpers.merge(target, [].slice.call(arguments, 1), {
				merger: function(key, dst, src) {
					dst[key] = src[key];
				}
			});
		},
	
		/**
		 * Basic javascript inheritance based on the model created in Backbone.js
		 */
		inherits: function(extensions) {
			var me = this;
			var ChartElement = (extensions && extensions.hasOwnProperty('constructor')) ? extensions.constructor : function() {
				return me.apply(this, arguments);
			};
	
			var Surrogate = function() {
				this.constructor = ChartElement;
			};
	
			Surrogate.prototype = me.prototype;
			ChartElement.prototype = new Surrogate();
			ChartElement.extend = helpers.inherits;
	
			if (extensions) {
				helpers.extend(ChartElement.prototype, extensions);
			}
	
			ChartElement.__super__ = me.prototype;
			return ChartElement;
		},
	
		_deprecated: function(scope, value, previous, current) {
			if (value !== undefined) {
				console.warn(scope + ': "' + previous +
					'" is deprecated. Please use "' + current + '" instead');
			}
		}
	};
	
	var helpers_core = helpers;
	
	// DEPRECATIONS
	
	/**
	 * Provided for backward compatibility, use Chart.helpers.callback instead.
	 * @function Chart.helpers.callCallback
	 * @deprecated since version 2.6.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers.callCallback = helpers.callback;
	
	/**
	 * Provided for backward compatibility, use Array.prototype.indexOf instead.
	 * Array.prototype.indexOf compatibility: Chrome, Opera, Safari, FF1.5+, IE9+
	 * @function Chart.helpers.indexOf
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers.indexOf = function(array, item, fromIndex) {
		return Array.prototype.indexOf.call(array, item, fromIndex);
	};
	
	/**
	 * Provided for backward compatibility, use Chart.helpers.valueOrDefault instead.
	 * @function Chart.helpers.getValueOrDefault
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers.getValueOrDefault = helpers.valueOrDefault;
	
	/**
	 * Provided for backward compatibility, use Chart.helpers.valueAtIndexOrDefault instead.
	 * @function Chart.helpers.getValueAtIndexOrDefault
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers.getValueAtIndexOrDefault = helpers.valueAtIndexOrDefault;
	
	/**
	 * Easing functions adapted from Robert Penner's easing equations.
	 * @namespace Chart.helpers.easingEffects
	 * @see http://www.robertpenner.com/easing/
	 */
	var effects = {
		linear: function(t) {
			return t;
		},
	
		easeInQuad: function(t) {
			return t * t;
		},
	
		easeOutQuad: function(t) {
			return -t * (t - 2);
		},
	
		easeInOutQuad: function(t) {
			if ((t /= 0.5) < 1) {
				return 0.5 * t * t;
			}
			return -0.5 * ((--t) * (t - 2) - 1);
		},
	
		easeInCubic: function(t) {
			return t * t * t;
		},
	
		easeOutCubic: function(t) {
			return (t = t - 1) * t * t + 1;
		},
	
		easeInOutCubic: function(t) {
			if ((t /= 0.5) < 1) {
				return 0.5 * t * t * t;
			}
			return 0.5 * ((t -= 2) * t * t + 2);
		},
	
		easeInQuart: function(t) {
			return t * t * t * t;
		},
	
		easeOutQuart: function(t) {
			return -((t = t - 1) * t * t * t - 1);
		},
	
		easeInOutQuart: function(t) {
			if ((t /= 0.5) < 1) {
				return 0.5 * t * t * t * t;
			}
			return -0.5 * ((t -= 2) * t * t * t - 2);
		},
	
		easeInQuint: function(t) {
			return t * t * t * t * t;
		},
	
		easeOutQuint: function(t) {
			return (t = t - 1) * t * t * t * t + 1;
		},
	
		easeInOutQuint: function(t) {
			if ((t /= 0.5) < 1) {
				return 0.5 * t * t * t * t * t;
			}
			return 0.5 * ((t -= 2) * t * t * t * t + 2);
		},
	
		easeInSine: function(t) {
			return -Math.cos(t * (Math.PI / 2)) + 1;
		},
	
		easeOutSine: function(t) {
			return Math.sin(t * (Math.PI / 2));
		},
	
		easeInOutSine: function(t) {
			return -0.5 * (Math.cos(Math.PI * t) - 1);
		},
	
		easeInExpo: function(t) {
			return (t === 0) ? 0 : Math.pow(2, 10 * (t - 1));
		},
	
		easeOutExpo: function(t) {
			return (t === 1) ? 1 : -Math.pow(2, -10 * t) + 1;
		},
	
		easeInOutExpo: function(t) {
			if (t === 0) {
				return 0;
			}
			if (t === 1) {
				return 1;
			}
			if ((t /= 0.5) < 1) {
				return 0.5 * Math.pow(2, 10 * (t - 1));
			}
			return 0.5 * (-Math.pow(2, -10 * --t) + 2);
		},
	
		easeInCirc: function(t) {
			if (t >= 1) {
				return t;
			}
			return -(Math.sqrt(1 - t * t) - 1);
		},
	
		easeOutCirc: function(t) {
			return Math.sqrt(1 - (t = t - 1) * t);
		},
	
		easeInOutCirc: function(t) {
			if ((t /= 0.5) < 1) {
				return -0.5 * (Math.sqrt(1 - t * t) - 1);
			}
			return 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1);
		},
	
		easeInElastic: function(t) {
			var s = 1.70158;
			var p = 0;
			var a = 1;
			if (t === 0) {
				return 0;
			}
			if (t === 1) {
				return 1;
			}
			if (!p) {
				p = 0.3;
			}
			if (a < 1) {
				a = 1;
				s = p / 4;
			} else {
				s = p / (2 * Math.PI) * Math.asin(1 / a);
			}
			return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
		},
	
		easeOutElastic: function(t) {
			var s = 1.70158;
			var p = 0;
			var a = 1;
			if (t === 0) {
				return 0;
			}
			if (t === 1) {
				return 1;
			}
			if (!p) {
				p = 0.3;
			}
			if (a < 1) {
				a = 1;
				s = p / 4;
			} else {
				s = p / (2 * Math.PI) * Math.asin(1 / a);
			}
			return a * Math.pow(2, -10 * t) * Math.sin((t - s) * (2 * Math.PI) / p) + 1;
		},
	
		easeInOutElastic: function(t) {
			var s = 1.70158;
			var p = 0;
			var a = 1;
			if (t === 0) {
				return 0;
			}
			if ((t /= 0.5) === 2) {
				return 1;
			}
			if (!p) {
				p = 0.45;
			}
			if (a < 1) {
				a = 1;
				s = p / 4;
			} else {
				s = p / (2 * Math.PI) * Math.asin(1 / a);
			}
			if (t < 1) {
				return -0.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
			}
			return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p) * 0.5 + 1;
		},
		easeInBack: function(t) {
			var s = 1.70158;
			return t * t * ((s + 1) * t - s);
		},
	
		easeOutBack: function(t) {
			var s = 1.70158;
			return (t = t - 1) * t * ((s + 1) * t + s) + 1;
		},
	
		easeInOutBack: function(t) {
			var s = 1.70158;
			if ((t /= 0.5) < 1) {
				return 0.5 * (t * t * (((s *= (1.525)) + 1) * t - s));
			}
			return 0.5 * ((t -= 2) * t * (((s *= (1.525)) + 1) * t + s) + 2);
		},
	
		easeInBounce: function(t) {
			return 1 - effects.easeOutBounce(1 - t);
		},
	
		easeOutBounce: function(t) {
			if (t < (1 / 2.75)) {
				return 7.5625 * t * t;
			}
			if (t < (2 / 2.75)) {
				return 7.5625 * (t -= (1.5 / 2.75)) * t + 0.75;
			}
			if (t < (2.5 / 2.75)) {
				return 7.5625 * (t -= (2.25 / 2.75)) * t + 0.9375;
			}
			return 7.5625 * (t -= (2.625 / 2.75)) * t + 0.984375;
		},
	
		easeInOutBounce: function(t) {
			if (t < 0.5) {
				return effects.easeInBounce(t * 2) * 0.5;
			}
			return effects.easeOutBounce(t * 2 - 1) * 0.5 + 0.5;
		}
	};
	
	var helpers_easing = {
		effects: effects
	};
	
	// DEPRECATIONS
	
	/**
	 * Provided for backward compatibility, use Chart.helpers.easing.effects instead.
	 * @function Chart.helpers.easingEffects
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers_core.easingEffects = effects;
	
	var PI = Math.PI;
	var RAD_PER_DEG = PI / 180;
	var DOUBLE_PI = PI * 2;
	var HALF_PI = PI / 2;
	var QUARTER_PI = PI / 4;
	var TWO_THIRDS_PI = PI * 2 / 3;
	
	/**
	 * @namespace Chart.helpers.canvas
	 */
	var exports$1 = {
		/**
		 * Clears the entire canvas associated to the given `chart`.
		 * @param {Chart} chart - The chart for which to clear the canvas.
		 */
		clear: function(chart) {
			chart.ctx.clearRect(0, 0, chart.width, chart.height);
		},
	
		/**
		 * Creates a "path" for a rectangle with rounded corners at position (x, y) with a
		 * given size (width, height) and the same `radius` for all corners.
		 * @param {CanvasRenderingContext2D} ctx - The canvas 2D Context.
		 * @param {number} x - The x axis of the coordinate for the rectangle starting point.
		 * @param {number} y - The y axis of the coordinate for the rectangle starting point.
		 * @param {number} width - The rectangle's width.
		 * @param {number} height - The rectangle's height.
		 * @param {number} radius - The rounded amount (in pixels) for the four corners.
		 * @todo handle `radius` as top-left, top-right, bottom-right, bottom-left array/object?
		 */
		roundedRect: function(ctx, x, y, width, height, radius) {
			if (radius) {
				var r = Math.min(radius, height / 2, width / 2);
				var left = x + r;
				var top = y + r;
				var right = x + width - r;
				var bottom = y + height - r;
	
				ctx.moveTo(x, top);
				if (left < right && top < bottom) {
					ctx.arc(left, top, r, -PI, -HALF_PI);
					ctx.arc(right, top, r, -HALF_PI, 0);
					ctx.arc(right, bottom, r, 0, HALF_PI);
					ctx.arc(left, bottom, r, HALF_PI, PI);
				} else if (left < right) {
					ctx.moveTo(left, y);
					ctx.arc(right, top, r, -HALF_PI, HALF_PI);
					ctx.arc(left, top, r, HALF_PI, PI + HALF_PI);
				} else if (top < bottom) {
					ctx.arc(left, top, r, -PI, 0);
					ctx.arc(left, bottom, r, 0, PI);
				} else {
					ctx.arc(left, top, r, -PI, PI);
				}
				ctx.closePath();
				ctx.moveTo(x, y);
			} else {
				ctx.rect(x, y, width, height);
			}
		},
	
		drawPoint: function(ctx, style, radius, x, y, rotation) {
			var type, xOffset, yOffset, size, cornerRadius;
			var rad = (rotation || 0) * RAD_PER_DEG;
	
			if (style && typeof style === 'object') {
				type = style.toString();
				if (type === '[object HTMLImageElement]' || type === '[object HTMLCanvasElement]') {
					ctx.save();
					ctx.translate(x, y);
					ctx.rotate(rad);
					ctx.drawImage(style, -style.width / 2, -style.height / 2, style.width, style.height);
					ctx.restore();
					return;
				}
			}
	
			if (isNaN(radius) || radius <= 0) {
				return;
			}
	
			ctx.beginPath();
	
			switch (style) {
			// Default includes circle
			default:
				ctx.arc(x, y, radius, 0, DOUBLE_PI);
				ctx.closePath();
				break;
			case 'triangle':
				ctx.moveTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
				rad += TWO_THIRDS_PI;
				ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
				rad += TWO_THIRDS_PI;
				ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
				ctx.closePath();
				break;
			case 'rectRounded':
				// NOTE: the rounded rect implementation changed to use `arc` instead of
				// `quadraticCurveTo` since it generates better results when rect is
				// almost a circle. 0.516 (instead of 0.5) produces results with visually
				// closer proportion to the previous impl and it is inscribed in the
				// circle with `radius`. For more details, see the following PRs:
				// https://github.com/chartjs/Chart.js/issues/5597
				// https://github.com/chartjs/Chart.js/issues/5858
				cornerRadius = radius * 0.516;
				size = radius - cornerRadius;
				xOffset = Math.cos(rad + QUARTER_PI) * size;
				yOffset = Math.sin(rad + QUARTER_PI) * size;
				ctx.arc(x - xOffset, y - yOffset, cornerRadius, rad - PI, rad - HALF_PI);
				ctx.arc(x + yOffset, y - xOffset, cornerRadius, rad - HALF_PI, rad);
				ctx.arc(x + xOffset, y + yOffset, cornerRadius, rad, rad + HALF_PI);
				ctx.arc(x - yOffset, y + xOffset, cornerRadius, rad + HALF_PI, rad + PI);
				ctx.closePath();
				break;
			case 'rect':
				if (!rotation) {
					size = Math.SQRT1_2 * radius;
					ctx.rect(x - size, y - size, 2 * size, 2 * size);
					break;
				}
				rad += QUARTER_PI;
				/* falls through */
			case 'rectRot':
				xOffset = Math.cos(rad) * radius;
				yOffset = Math.sin(rad) * radius;
				ctx.moveTo(x - xOffset, y - yOffset);
				ctx.lineTo(x + yOffset, y - xOffset);
				ctx.lineTo(x + xOffset, y + yOffset);
				ctx.lineTo(x - yOffset, y + xOffset);
				ctx.closePath();
				break;
			case 'crossRot':
				rad += QUARTER_PI;
				/* falls through */
			case 'cross':
				xOffset = Math.cos(rad) * radius;
				yOffset = Math.sin(rad) * radius;
				ctx.moveTo(x - xOffset, y - yOffset);
				ctx.lineTo(x + xOffset, y + yOffset);
				ctx.moveTo(x + yOffset, y - xOffset);
				ctx.lineTo(x - yOffset, y + xOffset);
				break;
			case 'star':
				xOffset = Math.cos(rad) * radius;
				yOffset = Math.sin(rad) * radius;
				ctx.moveTo(x - xOffset, y - yOffset);
				ctx.lineTo(x + xOffset, y + yOffset);
				ctx.moveTo(x + yOffset, y - xOffset);
				ctx.lineTo(x - yOffset, y + xOffset);
				rad += QUARTER_PI;
				xOffset = Math.cos(rad) * radius;
				yOffset = Math.sin(rad) * radius;
				ctx.moveTo(x - xOffset, y - yOffset);
				ctx.lineTo(x + xOffset, y + yOffset);
				ctx.moveTo(x + yOffset, y - xOffset);
				ctx.lineTo(x - yOffset, y + xOffset);
				break;
			case 'line':
				xOffset = Math.cos(rad) * radius;
				yOffset = Math.sin(rad) * radius;
				ctx.moveTo(x - xOffset, y - yOffset);
				ctx.lineTo(x + xOffset, y + yOffset);
				break;
			case 'dash':
				ctx.moveTo(x, y);
				ctx.lineTo(x + Math.cos(rad) * radius, y + Math.sin(rad) * radius);
				break;
			}
	
			ctx.fill();
			ctx.stroke();
		},
	
		/**
		 * Returns true if the point is inside the rectangle
		 * @param {object} point - The point to test
		 * @param {object} area - The rectangle
		 * @returns {boolean}
		 * @private
		 */
		_isPointInArea: function(point, area) {
			var epsilon = 1e-6; // 1e-6 is margin in pixels for accumulated error.
	
			return point.x > area.left - epsilon && point.x < area.right + epsilon &&
				point.y > area.top - epsilon && point.y < area.bottom + epsilon;
		},
	
		clipArea: function(ctx, area) {
			ctx.save();
			ctx.beginPath();
			ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
			ctx.clip();
		},
	
		unclipArea: function(ctx) {
			ctx.restore();
		},
	
		lineTo: function(ctx, previous, target, flip) {
			var stepped = target.steppedLine;
			if (stepped) {
				if (stepped === 'middle') {
					var midpoint = (previous.x + target.x) / 2.0;
					ctx.lineTo(midpoint, flip ? target.y : previous.y);
					ctx.lineTo(midpoint, flip ? previous.y : target.y);
				} else if ((stepped === 'after' && !flip) || (stepped !== 'after' && flip)) {
					ctx.lineTo(previous.x, target.y);
				} else {
					ctx.lineTo(target.x, previous.y);
				}
				ctx.lineTo(target.x, target.y);
				return;
			}
	
			if (!target.tension) {
				ctx.lineTo(target.x, target.y);
				return;
			}
	
			ctx.bezierCurveTo(
				flip ? previous.controlPointPreviousX : previous.controlPointNextX,
				flip ? previous.controlPointPreviousY : previous.controlPointNextY,
				flip ? target.controlPointNextX : target.controlPointPreviousX,
				flip ? target.controlPointNextY : target.controlPointPreviousY,
				target.x,
				target.y);
		}
	};
	
	var helpers_canvas = exports$1;
	
	// DEPRECATIONS
	
	/**
	 * Provided for backward compatibility, use Chart.helpers.canvas.clear instead.
	 * @namespace Chart.helpers.clear
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers_core.clear = exports$1.clear;
	
	/**
	 * Provided for backward compatibility, use Chart.helpers.canvas.roundedRect instead.
	 * @namespace Chart.helpers.drawRoundedRectangle
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers_core.drawRoundedRectangle = function(ctx) {
		ctx.beginPath();
		exports$1.roundedRect.apply(exports$1, arguments);
	};
	
	var defaults = {
		/**
		 * @private
		 */
		_set: function(scope, values) {
			return helpers_core.merge(this[scope] || (this[scope] = {}), values);
		}
	};
	
	// TODO(v3): remove 'global' from namespace.  all default are global and
	// there's inconsistency around which options are under 'global'
	defaults._set('global', {
		defaultColor: 'rgba(0,0,0,0.1)',
		defaultFontColor: '#666',
		defaultFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
		defaultFontSize: 12,
		defaultFontStyle: 'normal',
		defaultLineHeight: 1.2,
		showLines: true
	});
	
	var core_defaults = defaults;
	
	var valueOrDefault = helpers_core.valueOrDefault;
	
	/**
	 * Converts the given font object into a CSS font string.
	 * @param {object} font - A font object.
	 * @return {string} The CSS font string. See https://developer.mozilla.org/en-US/docs/Web/CSS/font
	 * @private
	 */
	function toFontString(font) {
		if (!font || helpers_core.isNullOrUndef(font.size) || helpers_core.isNullOrUndef(font.family)) {
			return null;
		}
	
		return (font.style ? font.style + ' ' : '')
			+ (font.weight ? font.weight + ' ' : '')
			+ font.size + 'px '
			+ font.family;
	}
	
	/**
	 * @alias Chart.helpers.options
	 * @namespace
	 */
	var helpers_options = {
		/**
		 * Converts the given line height `value` in pixels for a specific font `size`.
		 * @param {number|string} value - The lineHeight to parse (eg. 1.6, '14px', '75%', '1.6em').
		 * @param {number} size - The font size (in pixels) used to resolve relative `value`.
		 * @returns {number} The effective line height in pixels (size * 1.2 if value is invalid).
		 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/line-height
		 * @since 2.7.0
		 */
		toLineHeight: function(value, size) {
			var matches = ('' + value).match(/^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/);
			if (!matches || matches[1] === 'normal') {
				return size * 1.2;
			}
	
			value = +matches[2];
	
			switch (matches[3]) {
			case 'px':
				return value;
			case '%':
				value /= 100;
				break;
			}
	
			return size * value;
		},
	
		/**
		 * Converts the given value into a padding object with pre-computed width/height.
		 * @param {number|object} value - If a number, set the value to all TRBL component,
		 *  else, if and object, use defined properties and sets undefined ones to 0.
		 * @returns {object} The padding values (top, right, bottom, left, width, height)
		 * @since 2.7.0
		 */
		toPadding: function(value) {
			var t, r, b, l;
	
			if (helpers_core.isObject(value)) {
				t = +value.top || 0;
				r = +value.right || 0;
				b = +value.bottom || 0;
				l = +value.left || 0;
			} else {
				t = r = b = l = +value || 0;
			}
	
			return {
				top: t,
				right: r,
				bottom: b,
				left: l,
				height: t + b,
				width: l + r
			};
		},
	
		/**
		 * Parses font options and returns the font object.
		 * @param {object} options - A object that contains font options to be parsed.
		 * @return {object} The font object.
		 * @todo Support font.* options and renamed to toFont().
		 * @private
		 */
		_parseFont: function(options) {
			var globalDefaults = core_defaults.global;
			var size = valueOrDefault(options.fontSize, globalDefaults.defaultFontSize);
			var font = {
				family: valueOrDefault(options.fontFamily, globalDefaults.defaultFontFamily),
				lineHeight: helpers_core.options.toLineHeight(valueOrDefault(options.lineHeight, globalDefaults.defaultLineHeight), size),
				size: size,
				style: valueOrDefault(options.fontStyle, globalDefaults.defaultFontStyle),
				weight: null,
				string: ''
			};
	
			font.string = toFontString(font);
			return font;
		},
	
		/**
		 * Evaluates the given `inputs` sequentially and returns the first defined value.
		 * @param {Array} inputs - An array of values, falling back to the last value.
		 * @param {object} [context] - If defined and the current value is a function, the value
		 * is called with `context` as first argument and the result becomes the new input.
		 * @param {number} [index] - If defined and the current value is an array, the value
		 * at `index` become the new input.
		 * @param {object} [info] - object to return information about resolution in
		 * @param {boolean} [info.cacheable] - Will be set to `false` if option is not cacheable.
		 * @since 2.7.0
		 */
		resolve: function(inputs, context, index, info) {
			var cacheable = true;
			var i, ilen, value;
	
			for (i = 0, ilen = inputs.length; i < ilen; ++i) {
				value = inputs[i];
				if (value === undefined) {
					continue;
				}
				if (context !== undefined && typeof value === 'function') {
					value = value(context);
					cacheable = false;
				}
				if (index !== undefined && helpers_core.isArray(value)) {
					value = value[index];
					cacheable = false;
				}
				if (value !== undefined) {
					if (info && !cacheable) {
						info.cacheable = false;
					}
					return value;
				}
			}
		}
	};
	
	/**
	 * @alias Chart.helpers.math
	 * @namespace
	 */
	var exports$2 = {
		/**
		 * Returns an array of factors sorted from 1 to sqrt(value)
		 * @private
		 */
		_factorize: function(value) {
			var result = [];
			var sqrt = Math.sqrt(value);
			var i;
	
			for (i = 1; i < sqrt; i++) {
				if (value % i === 0) {
					result.push(i);
					result.push(value / i);
				}
			}
			if (sqrt === (sqrt | 0)) { // if value is a square number
				result.push(sqrt);
			}
	
			result.sort(function(a, b) {
				return a - b;
			}).pop();
			return result;
		},
	
		log10: Math.log10 || function(x) {
			var exponent = Math.log(x) * Math.LOG10E; // Math.LOG10E = 1 / Math.LN10.
			// Check for whole powers of 10,
			// which due to floating point rounding error should be corrected.
			var powerOf10 = Math.round(exponent);
			var isPowerOf10 = x === Math.pow(10, powerOf10);
	
			return isPowerOf10 ? powerOf10 : exponent;
		}
	};
	
	var helpers_math = exports$2;
	
	// DEPRECATIONS
	
	/**
	 * Provided for backward compatibility, use Chart.helpers.math.log10 instead.
	 * @namespace Chart.helpers.log10
	 * @deprecated since version 2.9.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers_core.log10 = exports$2.log10;
	
	var getRtlAdapter = function(rectX, width) {
		return {
			x: function(x) {
				return rectX + rectX + width - x;
			},
			setWidth: function(w) {
				width = w;
			},
			textAlign: function(align) {
				if (align === 'center') {
					return align;
				}
				return align === 'right' ? 'left' : 'right';
			},
			xPlus: function(x, value) {
				return x - value;
			},
			leftForLtr: function(x, itemWidth) {
				return x - itemWidth;
			},
		};
	};
	
	var getLtrAdapter = function() {
		return {
			x: function(x) {
				return x;
			},
			setWidth: function(w) { // eslint-disable-line no-unused-vars
			},
			textAlign: function(align) {
				return align;
			},
			xPlus: function(x, value) {
				return x + value;
			},
			leftForLtr: function(x, _itemWidth) { // eslint-disable-line no-unused-vars
				return x;
			},
		};
	};
	
	var getAdapter = function(rtl, rectX, width) {
		return rtl ? getRtlAdapter(rectX, width) : getLtrAdapter();
	};
	
	var overrideTextDirection = function(ctx, direction) {
		var style, original;
		if (direction === 'ltr' || direction === 'rtl') {
			style = ctx.canvas.style;
			original = [
				style.getPropertyValue('direction'),
				style.getPropertyPriority('direction'),
			];
	
			style.setProperty('direction', direction, 'important');
			ctx.prevTextDirection = original;
		}
	};
	
	var restoreTextDirection = function(ctx) {
		var original = ctx.prevTextDirection;
		if (original !== undefined) {
			delete ctx.prevTextDirection;
			ctx.canvas.style.setProperty('direction', original[0], original[1]);
		}
	};
	
	var helpers_rtl = {
		getRtlAdapter: getAdapter,
		overrideTextDirection: overrideTextDirection,
		restoreTextDirection: restoreTextDirection,
	};
	
	var helpers$1 = helpers_core;
	var easing = helpers_easing;
	var canvas = helpers_canvas;
	var options = helpers_options;
	var math = helpers_math;
	var rtl = helpers_rtl;
	helpers$1.easing = easing;
	helpers$1.canvas = canvas;
	helpers$1.options = options;
	helpers$1.math = math;
	helpers$1.rtl = rtl;
	
	function interpolate(start, view, model, ease) {
		var keys = Object.keys(model);
		var i, ilen, key, actual, origin, target, type, c0, c1;
	
		for (i = 0, ilen = keys.length; i < ilen; ++i) {
			key = keys[i];
	
			target = model[key];
	
			// if a value is added to the model after pivot() has been called, the view
			// doesn't contain it, so let's initialize the view to the target value.
			if (!view.hasOwnProperty(key)) {
				view[key] = target;
			}
	
			actual = view[key];
	
			if (actual === target || key[0] === '_') {
				continue;
			}
	
			if (!start.hasOwnProperty(key)) {
				start[key] = actual;
			}
	
			origin = start[key];
	
			type = typeof target;
	
			if (type === typeof origin) {
				if (type === 'string') {
					c0 = chartjsColor(origin);
					if (c0.valid) {
						c1 = chartjsColor(target);
						if (c1.valid) {
							view[key] = c1.mix(c0, ease).rgbString();
							continue;
						}
					}
				} else if (helpers$1.isFinite(origin) && helpers$1.isFinite(target)) {
					view[key] = origin + (target - origin) * ease;
					continue;
				}
			}
	
			view[key] = target;
		}
	}
	
	var Element = function(configuration) {
		helpers$1.extend(this, configuration);
		this.initialize.apply(this, arguments);
	};
	
	helpers$1.extend(Element.prototype, {
		_type: undefined,
	
		initialize: function() {
			this.hidden = false;
		},
	
		pivot: function() {
			var me = this;
			if (!me._view) {
				me._view = helpers$1.extend({}, me._model);
			}
			me._start = {};
			return me;
		},
	
		transition: function(ease) {
			var me = this;
			var model = me._model;
			var start = me._start;
			var view = me._view;
	
			// No animation -> No Transition
			if (!model || ease === 1) {
				me._view = helpers$1.extend({}, model);
				me._start = null;
				return me;
			}
	
			if (!view) {
				view = me._view = {};
			}
	
			if (!start) {
				start = me._start = {};
			}
	
			interpolate(start, view, model, ease);
	
			return me;
		},
	
		tooltipPosition: function() {
			return {
				x: this._model.x,
				y: this._model.y
			};
		},
	
		hasValue: function() {
			return helpers$1.isNumber(this._model.x) && helpers$1.isNumber(this._model.y);
		}
	});
	
	Element.extend = helpers$1.inherits;
	
	var core_element = Element;
	
	var exports$3 = core_element.extend({
		chart: null, // the animation associated chart instance
		currentStep: 0, // the current animation step
		numSteps: 60, // default number of steps
		easing: '', // the easing to use for this animation
		render: null, // render function used by the animation service
	
		onAnimationProgress: null, // user specified callback to fire on each step of the animation
		onAnimationComplete: null, // user specified callback to fire when the animation finishes
	});
	
	var core_animation = exports$3;
	
	// DEPRECATIONS
	
	/**
	 * Provided for backward compatibility, use Chart.Animation instead
	 * @prop Chart.Animation#animationObject
	 * @deprecated since version 2.6.0
	 * @todo remove at version 3
	 */
	Object.defineProperty(exports$3.prototype, 'animationObject', {
		get: function() {
			return this;
		}
	});
	
	/**
	 * Provided for backward compatibility, use Chart.Animation#chart instead
	 * @prop Chart.Animation#chartInstance
	 * @deprecated since version 2.6.0
	 * @todo remove at version 3
	 */
	Object.defineProperty(exports$3.prototype, 'chartInstance', {
		get: function() {
			return this.chart;
		},
		set: function(value) {
			this.chart = value;
		}
	});
	
	core_defaults._set('global', {
		animation: {
			duration: 1000,
			easing: 'easeOutQuart',
			onProgress: helpers$1.noop,
			onComplete: helpers$1.noop
		}
	});
	
	var core_animations = {
		animations: [],
		request: null,
	
		/**
		 * @param {Chart} chart - The chart to animate.
		 * @param {Chart.Animation} animation - The animation that we will animate.
		 * @param {number} duration - The animation duration in ms.
		 * @param {boolean} lazy - if true, the chart is not marked as animating to enable more responsive interactions
		 */
		addAnimation: function(chart, animation, duration, lazy) {
			var animations = this.animations;
			var i, ilen;
	
			animation.chart = chart;
			animation.startTime = Date.now();
			animation.duration = duration;
	
			if (!lazy) {
				chart.animating = true;
			}
	
			for (i = 0, ilen = animations.length; i < ilen; ++i) {
				if (animations[i].chart === chart) {
					animations[i] = animation;
					return;
				}
			}
	
			animations.push(animation);
	
			// If there are no animations queued, manually kickstart a digest, for lack of a better word
			if (animations.length === 1) {
				this.requestAnimationFrame();
			}
		},
	
		cancelAnimation: function(chart) {
			var index = helpers$1.findIndex(this.animations, function(animation) {
				return animation.chart === chart;
			});
	
			if (index !== -1) {
				this.animations.splice(index, 1);
				chart.animating = false;
			}
		},
	
		requestAnimationFrame: function() {
			var me = this;
			if (me.request === null) {
				// Skip animation frame requests until the active one is executed.
				// This can happen when processing mouse events, e.g. 'mousemove'
				// and 'mouseout' events will trigger multiple renders.
				me.request = helpers$1.requestAnimFrame.call(window, function() {
					me.request = null;
					me.startDigest();
				});
			}
		},
	
		/**
		 * @private
		 */
		startDigest: function() {
			var me = this;
	
			me.advance();
	
			// Do we have more stuff to animate?
			if (me.animations.length > 0) {
				me.requestAnimationFrame();
			}
		},
	
		/**
		 * @private
		 */
		advance: function() {
			var animations = this.animations;
			var animation, chart, numSteps, nextStep;
			var i = 0;
	
			// 1 animation per chart, so we are looping charts here
			while (i < animations.length) {
				animation = animations[i];
				chart = animation.chart;
				numSteps = animation.numSteps;
	
				// Make sure that currentStep starts at 1
				// https://github.com/chartjs/Chart.js/issues/6104
				nextStep = Math.floor((Date.now() - animation.startTime) / animation.duration * numSteps) + 1;
				animation.currentStep = Math.min(nextStep, numSteps);
	
				helpers$1.callback(animation.render, [chart, animation], chart);
				helpers$1.callback(animation.onAnimationProgress, [animation], chart);
	
				if (animation.currentStep >= numSteps) {
					helpers$1.callback(animation.onAnimationComplete, [animation], chart);
					chart.animating = false;
					animations.splice(i, 1);
				} else {
					++i;
				}
			}
		}
	};
	
	var resolve = helpers$1.options.resolve;
	
	var arrayEvents = ['push', 'pop', 'shift', 'splice', 'unshift'];
	
	/**
	 * Hooks the array methods that add or remove values ('push', pop', 'shift', 'splice',
	 * 'unshift') and notify the listener AFTER the array has been altered. Listeners are
	 * called on the 'onData*' callbacks (e.g. onDataPush, etc.) with same arguments.
	 */
	function listenArrayEvents(array, listener) {
		if (array._chartjs) {
			array._chartjs.listeners.push(listener);
			return;
		}
	
		Object.defineProperty(array, '_chartjs', {
			configurable: true,
			enumerable: false,
			value: {
				listeners: [listener]
			}
		});
	
		arrayEvents.forEach(function(key) {
			var method = 'onData' + key.charAt(0).toUpperCase() + key.slice(1);
			var base = array[key];
	
			Object.defineProperty(array, key, {
				configurable: true,
				enumerable: false,
				value: function() {
					var args = Array.prototype.slice.call(arguments);
					var res = base.apply(this, args);
	
					helpers$1.each(array._chartjs.listeners, function(object) {
						if (typeof object[method] === 'function') {
							object[method].apply(object, args);
						}
					});
	
					return res;
				}
			});
		});
	}
	
	/**
	 * Removes the given array event listener and cleanup extra attached properties (such as
	 * the _chartjs stub and overridden methods) if array doesn't have any more listeners.
	 */
	function unlistenArrayEvents(array, listener) {
		var stub = array._chartjs;
		if (!stub) {
			return;
		}
	
		var listeners = stub.listeners;
		var index = listeners.indexOf(listener);
		if (index !== -1) {
			listeners.splice(index, 1);
		}
	
		if (listeners.length > 0) {
			return;
		}
	
		arrayEvents.forEach(function(key) {
			delete array[key];
		});
	
		delete array._chartjs;
	}
	
	// Base class for all dataset controllers (line, bar, etc)
	var DatasetController = function(chart, datasetIndex) {
		this.initialize(chart, datasetIndex);
	};
	
	helpers$1.extend(DatasetController.prototype, {
	
		/**
		 * Element type used to generate a meta dataset (e.g. Chart.element.Line).
		 * @type {Chart.core.element}
		 */
		datasetElementType: null,
	
		/**
		 * Element type used to generate a meta data (e.g. Chart.element.Point).
		 * @type {Chart.core.element}
		 */
		dataElementType: null,
	
		/**
		 * Dataset element option keys to be resolved in _resolveDatasetElementOptions.
		 * A derived controller may override this to resolve controller-specific options.
		 * The keys defined here are for backward compatibility for legend styles.
		 * @private
		 */
		_datasetElementOptions: [
			'backgroundColor',
			'borderCapStyle',
			'borderColor',
			'borderDash',
			'borderDashOffset',
			'borderJoinStyle',
			'borderWidth'
		],
	
		/**
		 * Data element option keys to be resolved in _resolveDataElementOptions.
		 * A derived controller may override this to resolve controller-specific options.
		 * The keys defined here are for backward compatibility for legend styles.
		 * @private
		 */
		_dataElementOptions: [
			'backgroundColor',
			'borderColor',
			'borderWidth',
			'pointStyle'
		],
	
		initialize: function(chart, datasetIndex) {
			var me = this;
			me.chart = chart;
			me.index = datasetIndex;
			me.linkScales();
			me.addElements();
			me._type = me.getMeta().type;
		},
	
		updateIndex: function(datasetIndex) {
			this.index = datasetIndex;
		},
	
		linkScales: function() {
			var me = this;
			var meta = me.getMeta();
			var chart = me.chart;
			var scales = chart.scales;
			var dataset = me.getDataset();
			var scalesOpts = chart.options.scales;
	
			if (meta.xAxisID === null || !(meta.xAxisID in scales) || dataset.xAxisID) {
				meta.xAxisID = dataset.xAxisID || scalesOpts.xAxes[0].id;
			}
			if (meta.yAxisID === null || !(meta.yAxisID in scales) || dataset.yAxisID) {
				meta.yAxisID = dataset.yAxisID || scalesOpts.yAxes[0].id;
			}
		},
	
		getDataset: function() {
			return this.chart.data.datasets[this.index];
		},
	
		getMeta: function() {
			return this.chart.getDatasetMeta(this.index);
		},
	
		getScaleForId: function(scaleID) {
			return this.chart.scales[scaleID];
		},
	
		/**
		 * @private
		 */
		_getValueScaleId: function() {
			return this.getMeta().yAxisID;
		},
	
		/**
		 * @private
		 */
		_getIndexScaleId: function() {
			return this.getMeta().xAxisID;
		},
	
		/**
		 * @private
		 */
		_getValueScale: function() {
			return this.getScaleForId(this._getValueScaleId());
		},
	
		/**
		 * @private
		 */
		_getIndexScale: function() {
			return this.getScaleForId(this._getIndexScaleId());
		},
	
		reset: function() {
			this._update(true);
		},
	
		/**
		 * @private
		 */
		destroy: function() {
			if (this._data) {
				unlistenArrayEvents(this._data, this);
			}
		},
	
		createMetaDataset: function() {
			var me = this;
			var type = me.datasetElementType;
			return type && new type({
				_chart: me.chart,
				_datasetIndex: me.index
			});
		},
	
		createMetaData: function(index) {
			var me = this;
			var type = me.dataElementType;
			return type && new type({
				_chart: me.chart,
				_datasetIndex: me.index,
				_index: index
			});
		},
	
		addElements: function() {
			var me = this;
			var meta = me.getMeta();
			var data = me.getDataset().data || [];
			var metaData = meta.data;
			var i, ilen;
	
			for (i = 0, ilen = data.length; i < ilen; ++i) {
				metaData[i] = metaData[i] || me.createMetaData(i);
			}
	
			meta.dataset = meta.dataset || me.createMetaDataset();
		},
	
		addElementAndReset: function(index) {
			var element = this.createMetaData(index);
			this.getMeta().data.splice(index, 0, element);
			this.updateElement(element, index, true);
		},
	
		buildOrUpdateElements: function() {
			var me = this;
			var dataset = me.getDataset();
			var data = dataset.data || (dataset.data = []);
	
			// In order to correctly handle data addition/deletion animation (an thus simulate
			// real-time charts), we need to monitor these data modifications and synchronize
			// the internal meta data accordingly.
			if (me._data !== data) {
				if (me._data) {
					// This case happens when the user replaced the data array instance.
					unlistenArrayEvents(me._data, me);
				}
	
				if (data && Object.isExtensible(data)) {
					listenArrayEvents(data, me);
				}
				me._data = data;
			}
	
			// Re-sync meta data in case the user replaced the data array or if we missed
			// any updates and so make sure that we handle number of datapoints changing.
			me.resyncElements();
		},
	
		/**
		 * Returns the merged user-supplied and default dataset-level options
		 * @private
		 */
		_configure: function() {
			var me = this;
			me._config = helpers$1.merge(Object.create(null), [
				me.chart.options.datasets[me._type],
				me.getDataset(),
			], {
				merger: function(key, target, source) {
					if (key !== '_meta' && key !== 'data') {
						helpers$1._merger(key, target, source);
					}
				}
			});
		},
	
		_update: function(reset) {
			var me = this;
			me._configure();
			me._cachedDataOpts = null;
			me.update(reset);
		},
	
		update: helpers$1.noop,
	
		transition: function(easingValue) {
			var meta = this.getMeta();
			var elements = meta.data || [];
			var ilen = elements.length;
			var i = 0;
	
			for (; i < ilen; ++i) {
				elements[i].transition(easingValue);
			}
	
			if (meta.dataset) {
				meta.dataset.transition(easingValue);
			}
		},
	
		draw: function() {
			var meta = this.getMeta();
			var elements = meta.data || [];
			var ilen = elements.length;
			var i = 0;
	
			if (meta.dataset) {
				meta.dataset.draw();
			}
	
			for (; i < ilen; ++i) {
				elements[i].draw();
			}
		},
	
		/**
		 * Returns a set of predefined style properties that should be used to represent the dataset
		 * or the data if the index is specified
		 * @param {number} index - data index
		 * @return {IStyleInterface} style object
		 */
		getStyle: function(index) {
			var me = this;
			var meta = me.getMeta();
			var dataset = meta.dataset;
			var style;
	
			me._configure();
			if (dataset && index === undefined) {
				style = me._resolveDatasetElementOptions(dataset || {});
			} else {
				index = index || 0;
				style = me._resolveDataElementOptions(meta.data[index] || {}, index);
			}
	
			if (style.fill === false || style.fill === null) {
				style.backgroundColor = style.borderColor;
			}
	
			return style;
		},
	
		/**
		 * @private
		 */
		_resolveDatasetElementOptions: function(element, hover) {
			var me = this;
			var chart = me.chart;
			var datasetOpts = me._config;
			var custom = element.custom || {};
			var options = chart.options.elements[me.datasetElementType.prototype._type] || {};
			var elementOptions = me._datasetElementOptions;
			var values = {};
			var i, ilen, key, readKey;
	
			// Scriptable options
			var context = {
				chart: chart,
				dataset: me.getDataset(),
				datasetIndex: me.index,
				hover: hover
			};
	
			for (i = 0, ilen = elementOptions.length; i < ilen; ++i) {
				key = elementOptions[i];
				readKey = hover ? 'hover' + key.charAt(0).toUpperCase() + key.slice(1) : key;
				values[key] = resolve([
					custom[readKey],
					datasetOpts[readKey],
					options[readKey]
				], context);
			}
	
			return values;
		},
	
		/**
		 * @private
		 */
		_resolveDataElementOptions: function(element, index) {
			var me = this;
			var custom = element && element.custom;
			var cached = me._cachedDataOpts;
			if (cached && !custom) {
				return cached;
			}
			var chart = me.chart;
			var datasetOpts = me._config;
			var options = chart.options.elements[me.dataElementType.prototype._type] || {};
			var elementOptions = me._dataElementOptions;
			var values = {};
	
			// Scriptable options
			var context = {
				chart: chart,
				dataIndex: index,
				dataset: me.getDataset(),
				datasetIndex: me.index
			};
	
			// `resolve` sets cacheable to `false` if any option is indexed or scripted
			var info = {cacheable: !custom};
	
			var keys, i, ilen, key;
	
			custom = custom || {};
	
			if (helpers$1.isArray(elementOptions)) {
				for (i = 0, ilen = elementOptions.length; i < ilen; ++i) {
					key = elementOptions[i];
					values[key] = resolve([
						custom[key],
						datasetOpts[key],
						options[key]
					], context, index, info);
				}
			} else {
				keys = Object.keys(elementOptions);
				for (i = 0, ilen = keys.length; i < ilen; ++i) {
					key = keys[i];
					values[key] = resolve([
						custom[key],
						datasetOpts[elementOptions[key]],
						datasetOpts[key],
						options[key]
					], context, index, info);
				}
			}
	
			if (info.cacheable) {
				me._cachedDataOpts = Object.freeze(values);
			}
	
			return values;
		},
	
		removeHoverStyle: function(element) {
			helpers$1.merge(element._model, element.$previousStyle || {});
			delete element.$previousStyle;
		},
	
		setHoverStyle: function(element) {
			var dataset = this.chart.data.datasets[element._datasetIndex];
			var index = element._index;
			var custom = element.custom || {};
			var model = element._model;
			var getHoverColor = helpers$1.getHoverColor;
	
			element.$previousStyle = {
				backgroundColor: model.backgroundColor,
				borderColor: model.borderColor,
				borderWidth: model.borderWidth
			};
	
			model.backgroundColor = resolve([custom.hoverBackgroundColor, dataset.hoverBackgroundColor, getHoverColor(model.backgroundColor)], undefined, index);
			model.borderColor = resolve([custom.hoverBorderColor, dataset.hoverBorderColor, getHoverColor(model.borderColor)], undefined, index);
			model.borderWidth = resolve([custom.hoverBorderWidth, dataset.hoverBorderWidth, model.borderWidth], undefined, index);
		},
	
		/**
		 * @private
		 */
		_removeDatasetHoverStyle: function() {
			var element = this.getMeta().dataset;
	
			if (element) {
				this.removeHoverStyle(element);
			}
		},
	
		/**
		 * @private
		 */
		_setDatasetHoverStyle: function() {
			var element = this.getMeta().dataset;
			var prev = {};
			var i, ilen, key, keys, hoverOptions, model;
	
			if (!element) {
				return;
			}
	
			model = element._model;
			hoverOptions = this._resolveDatasetElementOptions(element, true);
	
			keys = Object.keys(hoverOptions);
			for (i = 0, ilen = keys.length; i < ilen; ++i) {
				key = keys[i];
				prev[key] = model[key];
				model[key] = hoverOptions[key];
			}
	
			element.$previousStyle = prev;
		},
	
		/**
		 * @private
		 */
		resyncElements: function() {
			var me = this;
			var meta = me.getMeta();
			var data = me.getDataset().data;
			var numMeta = meta.data.length;
			var numData = data.length;
	
			if (numData < numMeta) {
				meta.data.splice(numData, numMeta - numData);
			} else if (numData > numMeta) {
				me.insertElements(numMeta, numData - numMeta);
			}
		},
	
		/**
		 * @private
		 */
		insertElements: function(start, count) {
			for (var i = 0; i < count; ++i) {
				this.addElementAndReset(start + i);
			}
		},
	
		/**
		 * @private
		 */
		onDataPush: function() {
			var count = arguments.length;
			this.insertElements(this.getDataset().data.length - count, count);
		},
	
		/**
		 * @private
		 */
		onDataPop: function() {
			this.getMeta().data.pop();
		},
	
		/**
		 * @private
		 */
		onDataShift: function() {
			this.getMeta().data.shift();
		},
	
		/**
		 * @private
		 */
		onDataSplice: function(start, count) {
			this.getMeta().data.splice(start, count);
			this.insertElements(start, arguments.length - 2);
		},
	
		/**
		 * @private
		 */
		onDataUnshift: function() {
			this.insertElements(0, arguments.length);
		}
	});
	
	DatasetController.extend = helpers$1.inherits;
	
	var core_datasetController = DatasetController;
	
	var TAU = Math.PI * 2;
	
	core_defaults._set('global', {
		elements: {
			arc: {
				backgroundColor: core_defaults.global.defaultColor,
				borderColor: '#fff',
				borderWidth: 2,
				borderAlign: 'center'
			}
		}
	});
	
	function clipArc(ctx, arc) {
		var startAngle = arc.startAngle;
		var endAngle = arc.endAngle;
		var pixelMargin = arc.pixelMargin;
		var angleMargin = pixelMargin / arc.outerRadius;
		var x = arc.x;
		var y = arc.y;
	
		// Draw an inner border by cliping the arc and drawing a double-width border
		// Enlarge the clipping arc by 0.33 pixels to eliminate glitches between borders
		ctx.beginPath();
		ctx.arc(x, y, arc.outerRadius, startAngle - angleMargin, endAngle + angleMargin);
		if (arc.innerRadius > pixelMargin) {
			angleMargin = pixelMargin / arc.innerRadius;
			ctx.arc(x, y, arc.innerRadius - pixelMargin, endAngle + angleMargin, startAngle - angleMargin, true);
		} else {
			ctx.arc(x, y, pixelMargin, endAngle + Math.PI / 2, startAngle - Math.PI / 2);
		}
		ctx.closePath();
		ctx.clip();
	}
	
	function drawFullCircleBorders(ctx, vm, arc, inner) {
		var endAngle = arc.endAngle;
		var i;
	
		if (inner) {
			arc.endAngle = arc.startAngle + TAU;
			clipArc(ctx, arc);
			arc.endAngle = endAngle;
			if (arc.endAngle === arc.startAngle && arc.fullCircles) {
				arc.endAngle += TAU;
				arc.fullCircles--;
			}
		}
	
		ctx.beginPath();
		ctx.arc(arc.x, arc.y, arc.innerRadius, arc.startAngle + TAU, arc.startAngle, true);
		for (i = 0; i < arc.fullCircles; ++i) {
			ctx.stroke();
		}
	
		ctx.beginPath();
		ctx.arc(arc.x, arc.y, vm.outerRadius, arc.startAngle, arc.startAngle + TAU);
		for (i = 0; i < arc.fullCircles; ++i) {
			ctx.stroke();
		}
	}
	
	function drawBorder(ctx, vm, arc) {
		var inner = vm.borderAlign === 'inner';
	
		if (inner) {
			ctx.lineWidth = vm.borderWidth * 2;
			ctx.lineJoin = 'round';
		} else {
			ctx.lineWidth = vm.borderWidth;
			ctx.lineJoin = 'bevel';
		}
	
		if (arc.fullCircles) {
			drawFullCircleBorders(ctx, vm, arc, inner);
		}
	
		if (inner) {
			clipArc(ctx, arc);
		}
	
		ctx.beginPath();
		ctx.arc(arc.x, arc.y, vm.outerRadius, arc.startAngle, arc.endAngle);
		ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
		ctx.closePath();
		ctx.stroke();
	}
	
	var element_arc = core_element.extend({
		_type: 'arc',
	
		inLabelRange: function(mouseX) {
			var vm = this._view;
	
			if (vm) {
				return (Math.pow(mouseX - vm.x, 2) < Math.pow(vm.radius + vm.hoverRadius, 2));
			}
			return false;
		},
	
		inRange: function(chartX, chartY) {
			var vm = this._view;
	
			if (vm) {
				var pointRelativePosition = helpers$1.getAngleFromPoint(vm, {x: chartX, y: chartY});
				var angle = pointRelativePosition.angle;
				var distance = pointRelativePosition.distance;
	
				// Sanitise angle range
				var startAngle = vm.startAngle;
				var endAngle = vm.endAngle;
				while (endAngle < startAngle) {
					endAngle += TAU;
				}
				while (angle > endAngle) {
					angle -= TAU;
				}
				while (angle < startAngle) {
					angle += TAU;
				}
	
				// Check if within the range of the open/close angle
				var betweenAngles = (angle >= startAngle && angle <= endAngle);
				var withinRadius = (distance >= vm.innerRadius && distance <= vm.outerRadius);
	
				return (betweenAngles && withinRadius);
			}
			return false;
		},
	
		getCenterPoint: function() {
			var vm = this._view;
			var halfAngle = (vm.startAngle + vm.endAngle) / 2;
			var halfRadius = (vm.innerRadius + vm.outerRadius) / 2;
			return {
				x: vm.x + Math.cos(halfAngle) * halfRadius,
				y: vm.y + Math.sin(halfAngle) * halfRadius
			};
		},
	
		getArea: function() {
			var vm = this._view;
			return Math.PI * ((vm.endAngle - vm.startAngle) / (2 * Math.PI)) * (Math.pow(vm.outerRadius, 2) - Math.pow(vm.innerRadius, 2));
		},
	
		tooltipPosition: function() {
			var vm = this._view;
			var centreAngle = vm.startAngle + ((vm.endAngle - vm.startAngle) / 2);
			var rangeFromCentre = (vm.outerRadius - vm.innerRadius) / 2 + vm.innerRadius;
	
			return {
				x: vm.x + (Math.cos(centreAngle) * rangeFromCentre),
				y: vm.y + (Math.sin(centreAngle) * rangeFromCentre)
			};
		},
	
		draw: function() {
			var ctx = this._chart.ctx;
			var vm = this._view;
			var pixelMargin = (vm.borderAlign === 'inner') ? 0.33 : 0;
			var arc = {
				x: vm.x,
				y: vm.y,
				innerRadius: vm.innerRadius,
				outerRadius: Math.max(vm.outerRadius - pixelMargin, 0),
				pixelMargin: pixelMargin,
				startAngle: vm.startAngle,
				endAngle: vm.endAngle,
				fullCircles: Math.floor(vm.circumference / TAU)
			};
			var i;
	
			ctx.save();
	
			ctx.fillStyle = vm.backgroundColor;
			ctx.strokeStyle = vm.borderColor;
	
			if (arc.fullCircles) {
				arc.endAngle = arc.startAngle + TAU;
				ctx.beginPath();
				ctx.arc(arc.x, arc.y, arc.outerRadius, arc.startAngle, arc.endAngle);
				ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
				ctx.closePath();
				for (i = 0; i < arc.fullCircles; ++i) {
					ctx.fill();
				}
				arc.endAngle = arc.startAngle + vm.circumference % TAU;
			}
	
			ctx.beginPath();
			ctx.arc(arc.x, arc.y, arc.outerRadius, arc.startAngle, arc.endAngle);
			ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
			ctx.closePath();
			ctx.fill();
	
			if (vm.borderWidth) {
				drawBorder(ctx, vm, arc);
			}
	
			ctx.restore();
		}
	});
	
	var valueOrDefault$1 = helpers$1.valueOrDefault;
	
	var defaultColor = core_defaults.global.defaultColor;
	
	core_defaults._set('global', {
		elements: {
			line: {
				tension: 0.4,
				backgroundColor: defaultColor,
				borderWidth: 3,
				borderColor: defaultColor,
				borderCapStyle: 'butt',
				borderDash: [],
				borderDashOffset: 0.0,
				borderJoinStyle: 'miter',
				capBezierPoints: true,
				fill: true, // do we fill in the area between the line and its base axis
			}
		}
	});
	
	var element_line = core_element.extend({
		_type: 'line',
	
		draw: function() {
			var me = this;
			var vm = me._view;
			var ctx = me._chart.ctx;
			var spanGaps = vm.spanGaps;
			var points = me._children.slice(); // clone array
			var globalDefaults = core_defaults.global;
			var globalOptionLineElements = globalDefaults.elements.line;
			var lastDrawnIndex = -1;
			var closePath = me._loop;
			var index, previous, currentVM;
	
			if (!points.length) {
				return;
			}
	
			if (me._loop) {
				for (index = 0; index < points.length; ++index) {
					previous = helpers$1.previousItem(points, index);
					// If the line has an open path, shift the point array
					if (!points[index]._view.skip && previous._view.skip) {
						points = points.slice(index).concat(points.slice(0, index));
						closePath = spanGaps;
						break;
					}
				}
				// If the line has a close path, add the first point again
				if (closePath) {
					points.push(points[0]);
				}
			}
	
			ctx.save();
	
			// Stroke Line Options
			ctx.lineCap = vm.borderCapStyle || globalOptionLineElements.borderCapStyle;
	
			// IE 9 and 10 do not support line dash
			if (ctx.setLineDash) {
				ctx.setLineDash(vm.borderDash || globalOptionLineElements.borderDash);
			}
	
			ctx.lineDashOffset = valueOrDefault$1(vm.borderDashOffset, globalOptionLineElements.borderDashOffset);
			ctx.lineJoin = vm.borderJoinStyle || globalOptionLineElements.borderJoinStyle;
			ctx.lineWidth = valueOrDefault$1(vm.borderWidth, globalOptionLineElements.borderWidth);
			ctx.strokeStyle = vm.borderColor || globalDefaults.defaultColor;
	
			// Stroke Line
			ctx.beginPath();
	
			// First point moves to it's starting position no matter what
			currentVM = points[0]._view;
			if (!currentVM.skip) {
				ctx.moveTo(currentVM.x, currentVM.y);
				lastDrawnIndex = 0;
			}
	
			for (index = 1; index < points.length; ++index) {
				currentVM = points[index]._view;
				previous = lastDrawnIndex === -1 ? helpers$1.previousItem(points, index) : points[lastDrawnIndex];
	
				if (!currentVM.skip) {
					if ((lastDrawnIndex !== (index - 1) && !spanGaps) || lastDrawnIndex === -1) {
						// There was a gap and this is the first point after the gap
						ctx.moveTo(currentVM.x, currentVM.y);
					} else {
						// Line to next point
						helpers$1.canvas.lineTo(ctx, previous._view, currentVM);
					}
					lastDrawnIndex = index;
				}
			}
	
			if (closePath) {
				ctx.closePath();
			}
	
			ctx.stroke();
			ctx.restore();
		}
	});
	
	var valueOrDefault$2 = helpers$1.valueOrDefault;
	
	var defaultColor$1 = core_defaults.global.defaultColor;
	
	core_defaults._set('global', {
		elements: {
			point: {
				radius: 3,
				pointStyle: 'circle',
				backgroundColor: defaultColor$1,
				borderColor: defaultColor$1,
				borderWidth: 1,
				// Hover
				hitRadius: 1,
				hoverRadius: 4,
				hoverBorderWidth: 1
			}
		}
	});
	
	function xRange(mouseX) {
		var vm = this._view;
		return vm ? (Math.abs(mouseX - vm.x) < vm.radius + vm.hitRadius) : false;
	}
	
	function yRange(mouseY) {
		var vm = this._view;
		return vm ? (Math.abs(mouseY - vm.y) < vm.radius + vm.hitRadius) : false;
	}
	
	var element_point = core_element.extend({
		_type: 'point',
	
		inRange: function(mouseX, mouseY) {
			var vm = this._view;
			return vm ? ((Math.pow(mouseX - vm.x, 2) + Math.pow(mouseY - vm.y, 2)) < Math.pow(vm.hitRadius + vm.radius, 2)) : false;
		},
	
		inLabelRange: xRange,
		inXRange: xRange,
		inYRange: yRange,
	
		getCenterPoint: function() {
			var vm = this._view;
			return {
				x: vm.x,
				y: vm.y
			};
		},
	
		getArea: function() {
			return Math.PI * Math.pow(this._view.radius, 2);
		},
	
		tooltipPosition: function() {
			var vm = this._view;
			return {
				x: vm.x,
				y: vm.y,
				padding: vm.radius + vm.borderWidth
			};
		},
	
		draw: function(chartArea) {
			var vm = this._view;
			var ctx = this._chart.ctx;
			var pointStyle = vm.pointStyle;
			var rotation = vm.rotation;
			var radius = vm.radius;
			var x = vm.x;
			var y = vm.y;
			var globalDefaults = core_defaults.global;
			var defaultColor = globalDefaults.defaultColor; // eslint-disable-line no-shadow
	
			if (vm.skip) {
				return;
			}
	
			// Clipping for Points.
			if (chartArea === undefined || helpers$1.canvas._isPointInArea(vm, chartArea)) {
				ctx.strokeStyle = vm.borderColor || defaultColor;
				ctx.lineWidth = valueOrDefault$2(vm.borderWidth, globalDefaults.elements.point.borderWidth);
				ctx.fillStyle = vm.backgroundColor || defaultColor;
				helpers$1.canvas.drawPoint(ctx, pointStyle, radius, x, y, rotation);
			}
		}
	});
	
	var defaultColor$2 = core_defaults.global.defaultColor;
	
	core_defaults._set('global', {
		elements: {
			rectangle: {
				backgroundColor: defaultColor$2,
				borderColor: defaultColor$2,
				borderSkipped: 'bottom',
				borderWidth: 0
			}
		}
	});
	
	function isVertical(vm) {
		return vm && vm.width !== undefined;
	}
	
	/**
	 * Helper function to get the bounds of the bar regardless of the orientation
	 * @param bar {Chart.Element.Rectangle} the bar
	 * @return {Bounds} bounds of the bar
	 * @private
	 */
	function getBarBounds(vm) {
		var x1, x2, y1, y2, half;
	
		if (isVertical(vm)) {
			half = vm.width / 2;
			x1 = vm.x - half;
			x2 = vm.x + half;
			y1 = Math.min(vm.y, vm.base);
			y2 = Math.max(vm.y, vm.base);
		} else {
			half = vm.height / 2;
			x1 = Math.min(vm.x, vm.base);
			x2 = Math.max(vm.x, vm.base);
			y1 = vm.y - half;
			y2 = vm.y + half;
		}
	
		return {
			left: x1,
			top: y1,
			right: x2,
			bottom: y2
		};
	}
	
	function swap(orig, v1, v2) {
		return orig === v1 ? v2 : orig === v2 ? v1 : orig;
	}
	
	function parseBorderSkipped(vm) {
		var edge = vm.borderSkipped;
		var res = {};
	
		if (!edge) {
			return res;
		}
	
		if (vm.horizontal) {
			if (vm.base > vm.x) {
				edge = swap(edge, 'left', 'right');
			}
		} else if (vm.base < vm.y) {
			edge = swap(edge, 'bottom', 'top');
		}
	
		res[edge] = true;
		return res;
	}
	
	function parseBorderWidth(vm, maxW, maxH) {
		var value = vm.borderWidth;
		var skip = parseBorderSkipped(vm);
		var t, r, b, l;
	
		if (helpers$1.isObject(value)) {
			t = +value.top || 0;
			r = +value.right || 0;
			b = +value.bottom || 0;
			l = +value.left || 0;
		} else {
			t = r = b = l = +value || 0;
		}
	
		return {
			t: skip.top || (t < 0) ? 0 : t > maxH ? maxH : t,
			r: skip.right || (r < 0) ? 0 : r > maxW ? maxW : r,
			b: skip.bottom || (b < 0) ? 0 : b > maxH ? maxH : b,
			l: skip.left || (l < 0) ? 0 : l > maxW ? maxW : l
		};
	}
	
	function boundingRects(vm) {
		var bounds = getBarBounds(vm);
		var width = bounds.right - bounds.left;
		var height = bounds.bottom - bounds.top;
		var border = parseBorderWidth(vm, width / 2, height / 2);
	
		return {
			outer: {
				x: bounds.left,
				y: bounds.top,
				w: width,
				h: height
			},
			inner: {
				x: bounds.left + border.l,
				y: bounds.top + border.t,
				w: width - border.l - border.r,
				h: height - border.t - border.b
			}
		};
	}
	
	function inRange(vm, x, y) {
		var skipX = x === null;
		var skipY = y === null;
		var bounds = !vm || (skipX && skipY) ? false : getBarBounds(vm);
	
		return bounds
			&& (skipX || x >= bounds.left && x <= bounds.right)
			&& (skipY || y >= bounds.top && y <= bounds.bottom);
	}
	
	var element_rectangle = core_element.extend({
		_type: 'rectangle',
	
		draw: function() {
			var ctx = this._chart.ctx;
			var vm = this._view;
			var rects = boundingRects(vm);
			var outer = rects.outer;
			var inner = rects.inner;
	
			ctx.fillStyle = vm.backgroundColor;
			ctx.fillRect(outer.x, outer.y, outer.w, outer.h);
	
			if (outer.w === inner.w && outer.h === inner.h) {
				return;
			}
	
			ctx.save();
			ctx.beginPath();
			ctx.rect(outer.x, outer.y, outer.w, outer.h);
			ctx.clip();
			ctx.fillStyle = vm.borderColor;
			ctx.rect(inner.x, inner.y, inner.w, inner.h);
			ctx.fill('evenodd');
			ctx.restore();
		},
	
		height: function() {
			var vm = this._view;
			return vm.base - vm.y;
		},
	
		inRange: function(mouseX, mouseY) {
			return inRange(this._view, mouseX, mouseY);
		},
	
		inLabelRange: function(mouseX, mouseY) {
			var vm = this._view;
			return isVertical(vm)
				? inRange(vm, mouseX, null)
				: inRange(vm, null, mouseY);
		},
	
		inXRange: function(mouseX) {
			return inRange(this._view, mouseX, null);
		},
	
		inYRange: function(mouseY) {
			return inRange(this._view, null, mouseY);
		},
	
		getCenterPoint: function() {
			var vm = this._view;
			var x, y;
			if (isVertical(vm)) {
				x = vm.x;
				y = (vm.y + vm.base) / 2;
			} else {
				x = (vm.x + vm.base) / 2;
				y = vm.y;
			}
	
			return {x: x, y: y};
		},
	
		getArea: function() {
			var vm = this._view;
	
			return isVertical(vm)
				? vm.width * Math.abs(vm.y - vm.base)
				: vm.height * Math.abs(vm.x - vm.base);
		},
	
		tooltipPosition: function() {
			var vm = this._view;
			return {
				x: vm.x,
				y: vm.y
			};
		}
	});
	
	var elements = {};
	var Arc = element_arc;
	var Line = element_line;
	var Point = element_point;
	var Rectangle = element_rectangle;
	elements.Arc = Arc;
	elements.Line = Line;
	elements.Point = Point;
	elements.Rectangle = Rectangle;
	
	var deprecated = helpers$1._deprecated;
	var valueOrDefault$3 = helpers$1.valueOrDefault;
	
	core_defaults._set('bar', {
		hover: {
			mode: 'label'
		},
	
		scales: {
			xAxes: [{
				type: 'category',
				offset: true,
				gridLines: {
					offsetGridLines: true
				}
			}],
	
			yAxes: [{
				type: 'linear'
			}]
		}
	});
	
	core_defaults._set('global', {
		datasets: {
			bar: {
				categoryPercentage: 0.8,
				barPercentage: 0.9
			}
		}
	});
	
	/**
	 * Computes the "optimal" sample size to maintain bars equally sized while preventing overlap.
	 * @private
	 */
	function computeMinSampleSize(scale, pixels) {
		var min = scale._length;
		var prev, curr, i, ilen;
	
		for (i = 1, ilen = pixels.length; i < ilen; ++i) {
			min = Math.min(min, Math.abs(pixels[i] - pixels[i - 1]));
		}
	
		for (i = 0, ilen = scale.getTicks().length; i < ilen; ++i) {
			curr = scale.getPixelForTick(i);
			min = i > 0 ? Math.min(min, Math.abs(curr - prev)) : min;
			prev = curr;
		}
	
		return min;
	}
	
	/**
	 * Computes an "ideal" category based on the absolute bar thickness or, if undefined or null,
	 * uses the smallest interval (see computeMinSampleSize) that prevents bar overlapping. This
	 * mode currently always generates bars equally sized (until we introduce scriptable options?).
	 * @private
	 */
	function computeFitCategoryTraits(index, ruler, options) {
		var thickness = options.barThickness;
		var count = ruler.stackCount;
		var curr = ruler.pixels[index];
		var min = helpers$1.isNullOrUndef(thickness)
			? computeMinSampleSize(ruler.scale, ruler.pixels)
			: -1;
		var size, ratio;
	
		if (helpers$1.isNullOrUndef(thickness)) {
			size = min * options.categoryPercentage;
			ratio = options.barPercentage;
		} else {
			// When bar thickness is enforced, category and bar percentages are ignored.
			// Note(SB): we could add support for relative bar thickness (e.g. barThickness: '50%')
			// and deprecate barPercentage since this value is ignored when thickness is absolute.
			size = thickness * count;
			ratio = 1;
		}
	
		return {
			chunk: size / count,
			ratio: ratio,
			start: curr - (size / 2)
		};
	}
	
	/**
	 * Computes an "optimal" category that globally arranges bars side by side (no gap when
	 * percentage options are 1), based on the previous and following categories. This mode
	 * generates bars with different widths when data are not evenly spaced.
	 * @private
	 */
	function computeFlexCategoryTraits(index, ruler, options) {
		var pixels = ruler.pixels;
		var curr = pixels[index];
		var prev = index > 0 ? pixels[index - 1] : null;
		var next = index < pixels.length - 1 ? pixels[index + 1] : null;
		var percent = options.categoryPercentage;
		var start, size;
	
		if (prev === null) {
			// first data: its size is double based on the next point or,
			// if it's also the last data, we use the scale size.
			prev = curr - (next === null ? ruler.end - ruler.start : next - curr);
		}
	
		if (next === null) {
			// last data: its size is also double based on the previous point.
			next = curr + curr - prev;
		}
	
		start = curr - (curr - Math.min(prev, next)) / 2 * percent;
		size = Math.abs(next - prev) / 2 * percent;
	
		return {
			chunk: size / ruler.stackCount,
			ratio: options.barPercentage,
			start: start
		};
	}
	
	var controller_bar = core_datasetController.extend({
	
		dataElementType: elements.Rectangle,
	
		/**
		 * @private
		 */
		_dataElementOptions: [
			'backgroundColor',
			'borderColor',
			'borderSkipped',
			'borderWidth',
			'barPercentage',
			'barThickness',
			'categoryPercentage',
			'maxBarThickness',
			'minBarLength'
		],
	
		initialize: function() {
			var me = this;
			var meta, scaleOpts;
	
			core_datasetController.prototype.initialize.apply(me, arguments);
	
			meta = me.getMeta();
			meta.stack = me.getDataset().stack;
			meta.bar = true;
	
			scaleOpts = me._getIndexScale().options;
			deprecated('bar chart', scaleOpts.barPercentage, 'scales.[x/y]Axes.barPercentage', 'dataset.barPercentage');
			deprecated('bar chart', scaleOpts.barThickness, 'scales.[x/y]Axes.barThickness', 'dataset.barThickness');
			deprecated('bar chart', scaleOpts.categoryPercentage, 'scales.[x/y]Axes.categoryPercentage', 'dataset.categoryPercentage');
			deprecated('bar chart', me._getValueScale().options.minBarLength, 'scales.[x/y]Axes.minBarLength', 'dataset.minBarLength');
			deprecated('bar chart', scaleOpts.maxBarThickness, 'scales.[x/y]Axes.maxBarThickness', 'dataset.maxBarThickness');
		},
	
		update: function(reset) {
			var me = this;
			var rects = me.getMeta().data;
			var i, ilen;
	
			me._ruler = me.getRuler();
	
			for (i = 0, ilen = rects.length; i < ilen; ++i) {
				me.updateElement(rects[i], i, reset);
			}
		},
	
		updateElement: function(rectangle, index, reset) {
			var me = this;
			var meta = me.getMeta();
			var dataset = me.getDataset();
			var options = me._resolveDataElementOptions(rectangle, index);
	
			rectangle._xScale = me.getScaleForId(meta.xAxisID);
			rectangle._yScale = me.getScaleForId(meta.yAxisID);
			rectangle._datasetIndex = me.index;
			rectangle._index = index;
			rectangle._model = {
				backgroundColor: options.backgroundColor,
				borderColor: options.borderColor,
				borderSkipped: options.borderSkipped,
				borderWidth: options.borderWidth,
				datasetLabel: dataset.label,
				label: me.chart.data.labels[index]
			};
	
			if (helpers$1.isArray(dataset.data[index])) {
				rectangle._model.borderSkipped = null;
			}
	
			me._updateElementGeometry(rectangle, index, reset, options);
	
			rectangle.pivot();
		},
	
		/**
		 * @private
		 */
		_updateElementGeometry: function(rectangle, index, reset, options) {
			var me = this;
			var model = rectangle._model;
			var vscale = me._getValueScale();
			var base = vscale.getBasePixel();
			var horizontal = vscale.isHorizontal();
			var ruler = me._ruler || me.getRuler();
			var vpixels = me.calculateBarValuePixels(me.index, index, options);
			var ipixels = me.calculateBarIndexPixels(me.index, index, ruler, options);
	
			model.horizontal = horizontal;
			model.base = reset ? base : vpixels.base;
			model.x = horizontal ? reset ? base : vpixels.head : ipixels.center;
			model.y = horizontal ? ipixels.center : reset ? base : vpixels.head;
			model.height = horizontal ? ipixels.size : undefined;
			model.width = horizontal ? undefined : ipixels.size;
		},
	
		/**
		 * Returns the stacks based on groups and bar visibility.
		 * @param {number} [last] - The dataset index
		 * @returns {string[]} The list of stack IDs
		 * @private
		 */
		_getStacks: function(last) {
			var me = this;
			var scale = me._getIndexScale();
			var metasets = scale._getMatchingVisibleMetas(me._type);
			var stacked = scale.options.stacked;
			var ilen = metasets.length;
			var stacks = [];
			var i, meta;
	
			for (i = 0; i < ilen; ++i) {
				meta = metasets[i];
				// stacked   | meta.stack
				//           | found | not found | undefined
				// false     |   x   |     x     |     x
				// true      |       |     x     |
				// undefined |       |     x     |     x
				if (stacked === false || stacks.indexOf(meta.stack) === -1 ||
					(stacked === undefined && meta.stack === undefined)) {
					stacks.push(meta.stack);
				}
				if (meta.index === last) {
					break;
				}
			}
	
			return stacks;
		},
	
		/**
		 * Returns the effective number of stacks based on groups and bar visibility.
		 * @private
		 */
		getStackCount: function() {
			return this._getStacks().length;
		},
	
		/**
		 * Returns the stack index for the given dataset based on groups and bar visibility.
		 * @param {number} [datasetIndex] - The dataset index
		 * @param {string} [name] - The stack name to find
		 * @returns {number} The stack index
		 * @private
		 */
		getStackIndex: function(datasetIndex, name) {
			var stacks = this._getStacks(datasetIndex);
			var index = (name !== undefined)
				? stacks.indexOf(name)
				: -1; // indexOf returns -1 if element is not present
	
			return (index === -1)
				? stacks.length - 1
				: index;
		},
	
		/**
		 * @private
		 */
		getRuler: function() {
			var me = this;
			var scale = me._getIndexScale();
			var pixels = [];
			var i, ilen;
	
			for (i = 0, ilen = me.getMeta().data.length; i < ilen; ++i) {
				pixels.push(scale.getPixelForValue(null, i, me.index));
			}
	
			return {
				pixels: pixels,
				start: scale._startPixel,
				end: scale._endPixel,
				stackCount: me.getStackCount(),
				scale: scale
			};
		},
	
		/**
		 * Note: pixel values are not clamped to the scale area.
		 * @private
		 */
		calculateBarValuePixels: function(datasetIndex, index, options) {
			var me = this;
			var chart = me.chart;
			var scale = me._getValueScale();
			var isHorizontal = scale.isHorizontal();
			var datasets = chart.data.datasets;
			var metasets = scale._getMatchingVisibleMetas(me._type);
			var value = scale._parseValue(datasets[datasetIndex].data[index]);
			var minBarLength = options.minBarLength;
			var stacked = scale.options.stacked;
			var stack = me.getMeta().stack;
			var start = value.start === undefined ? 0 : value.max >= 0 && value.min >= 0 ? value.min : value.max;
			var length = value.start === undefined ? value.end : value.max >= 0 && value.min >= 0 ? value.max - value.min : value.min - value.max;
			var ilen = metasets.length;
			var i, imeta, ivalue, base, head, size, stackLength;
	
			if (stacked || (stacked === undefined && stack !== undefined)) {
				for (i = 0; i < ilen; ++i) {
					imeta = metasets[i];
	
					if (imeta.index === datasetIndex) {
						break;
					}
	
					if (imeta.stack === stack) {
						stackLength = scale._parseValue(datasets[imeta.index].data[index]);
						ivalue = stackLength.start === undefined ? stackLength.end : stackLength.min >= 0 && stackLength.max >= 0 ? stackLength.max : stackLength.min;
	
						if ((value.min < 0 && ivalue < 0) || (value.max >= 0 && ivalue > 0)) {
							start += ivalue;
						}
					}
				}
			}
	
			base = scale.getPixelForValue(start);
			head = scale.getPixelForValue(start + length);
			size = head - base;
	
			if (minBarLength !== undefined && Math.abs(size) < minBarLength) {
				size = minBarLength;
				if (length >= 0 && !isHorizontal || length < 0 && isHorizontal) {
					head = base - minBarLength;
				} else {
					head = base + minBarLength;
				}
			}
	
			return {
				size: size,
				base: base,
				head: head,
				center: head + size / 2
			};
		},
	
		/**
		 * @private
		 */
		calculateBarIndexPixels: function(datasetIndex, index, ruler, options) {
			var me = this;
			var range = options.barThickness === 'flex'
				? computeFlexCategoryTraits(index, ruler, options)
				: computeFitCategoryTraits(index, ruler, options);
	
			var stackIndex = me.getStackIndex(datasetIndex, me.getMeta().stack);
			var center = range.start + (range.chunk * stackIndex) + (range.chunk / 2);
			var size = Math.min(
				valueOrDefault$3(options.maxBarThickness, Infinity),
				range.chunk * range.ratio);
	
			return {
				base: center - size / 2,
				head: center + size / 2,
				center: center,
				size: size
			};
		},
	
		draw: function() {
			var me = this;
			var chart = me.chart;
			var scale = me._getValueScale();
			var rects = me.getMeta().data;
			var dataset = me.getDataset();
			var ilen = rects.length;
			var i = 0;
	
			helpers$1.canvas.clipArea(chart.ctx, chart.chartArea);
	
			for (; i < ilen; ++i) {
				var val = scale._parseValue(dataset.data[i]);
				if (!isNaN(val.min) && !isNaN(val.max)) {
					rects[i].draw();
				}
			}
	
			helpers$1.canvas.unclipArea(chart.ctx);
		},
	
		/**
		 * @private
		 */
		_resolveDataElementOptions: function() {
			var me = this;
			var values = helpers$1.extend({}, core_datasetController.prototype._resolveDataElementOptions.apply(me, arguments));
			var indexOpts = me._getIndexScale().options;
			var valueOpts = me._getValueScale().options;
	
			values.barPercentage = valueOrDefault$3(indexOpts.barPercentage, values.barPercentage);
			values.barThickness = valueOrDefault$3(indexOpts.barThickness, values.barThickness);
			values.categoryPercentage = valueOrDefault$3(indexOpts.categoryPercentage, values.categoryPercentage);
			values.maxBarThickness = valueOrDefault$3(indexOpts.maxBarThickness, values.maxBarThickness);
			values.minBarLength = valueOrDefault$3(valueOpts.minBarLength, values.minBarLength);
	
			return values;
		}
	
	});
	
	var valueOrDefault$4 = helpers$1.valueOrDefault;
	var resolve$1 = helpers$1.options.resolve;
	
	core_defaults._set('bubble', {
		hover: {
			mode: 'single'
		},
	
		scales: {
			xAxes: [{
				type: 'linear', // bubble should probably use a linear scale by default
				position: 'bottom',
				id: 'x-axis-0' // need an ID so datasets can reference the scale
			}],
			yAxes: [{
				type: 'linear',
				position: 'left',
				id: 'y-axis-0'
			}]
		},
	
		tooltips: {
			callbacks: {
				title: function() {
					// Title doesn't make sense for scatter since we format the data as a point
					return '';
				},
				label: function(item, data) {
					var datasetLabel = data.datasets[item.datasetIndex].label || '';
					var dataPoint = data.datasets[item.datasetIndex].data[item.index];
					return datasetLabel + ': (' + item.xLabel + ', ' + item.yLabel + ', ' + dataPoint.r + ')';
				}
			}
		}
	});
	
	var controller_bubble = core_datasetController.extend({
		/**
		 * @protected
		 */
		dataElementType: elements.Point,
	
		/**
		 * @private
		 */
		_dataElementOptions: [
			'backgroundColor',
			'borderColor',
			'borderWidth',
			'hoverBackgroundColor',
			'hoverBorderColor',
			'hoverBorderWidth',
			'hoverRadius',
			'hitRadius',
			'pointStyle',
			'rotation'
		],
	
		/**
		 * @protected
		 */
		update: function(reset) {
			var me = this;
			var meta = me.getMeta();
			var points = meta.data;
	
			// Update Points
			helpers$1.each(points, function(point, index) {
				me.updateElement(point, index, reset);
			});
		},
	
		/**
		 * @protected
		 */
		updateElement: function(point, index, reset) {
			var me = this;
			var meta = me.getMeta();
			var custom = point.custom || {};
			var xScale = me.getScaleForId(meta.xAxisID);
			var yScale = me.getScaleForId(meta.yAxisID);
			var options = me._resolveDataElementOptions(point, index);
			var data = me.getDataset().data[index];
			var dsIndex = me.index;
	
			var x = reset ? xScale.getPixelForDecimal(0.5) : xScale.getPixelForValue(typeof data === 'object' ? data : NaN, index, dsIndex);
			var y = reset ? yScale.getBasePixel() : yScale.getPixelForValue(data, index, dsIndex);
	
			point._xScale = xScale;
			point._yScale = yScale;
			point._options = options;
			point._datasetIndex = dsIndex;
			point._index = index;
			point._model = {
				backgroundColor: options.backgroundColor,
				borderColor: options.borderColor,
				borderWidth: options.borderWidth,
				hitRadius: options.hitRadius,
				pointStyle: options.pointStyle,
				rotation: options.rotation,
				radius: reset ? 0 : options.radius,
				skip: custom.skip || isNaN(x) || isNaN(y),
				x: x,
				y: y,
			};
	
			point.pivot();
		},
	
		/**
		 * @protected
		 */
		setHoverStyle: function(point) {
			var model = point._model;
			var options = point._options;
			var getHoverColor = helpers$1.getHoverColor;
	
			point.$previousStyle = {
				backgroundColor: model.backgroundColor,
				borderColor: model.borderColor,
				borderWidth: model.borderWidth,
				radius: model.radius
			};
	
			model.backgroundColor = valueOrDefault$4(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
			model.borderColor = valueOrDefault$4(options.hoverBorderColor, getHoverColor(options.borderColor));
			model.borderWidth = valueOrDefault$4(options.hoverBorderWidth, options.borderWidth);
			model.radius = options.radius + options.hoverRadius;
		},
	
		/**
		 * @private
		 */
		_resolveDataElementOptions: function(point, index) {
			var me = this;
			var chart = me.chart;
			var dataset = me.getDataset();
			var custom = point.custom || {};
			var data = dataset.data[index] || {};
			var values = core_datasetController.prototype._resolveDataElementOptions.apply(me, arguments);
	
			// Scriptable options
			var context = {
				chart: chart,
				dataIndex: index,
				dataset: dataset,
				datasetIndex: me.index
			};
	
			// In case values were cached (and thus frozen), we need to clone the values
			if (me._cachedDataOpts === values) {
				values = helpers$1.extend({}, values);
			}
	
			// Custom radius resolution
			values.radius = resolve$1([
				custom.radius,
				data.r,
				me._config.radius,
				chart.options.elements.point.radius
			], context, index);
	
			return values;
		}
	});
	
	var valueOrDefault$5 = helpers$1.valueOrDefault;
	
	var PI$1 = Math.PI;
	var DOUBLE_PI$1 = PI$1 * 2;
	var HALF_PI$1 = PI$1 / 2;
	
	core_defaults._set('doughnut', {
		animation: {
			// Boolean - Whether we animate the rotation of the Doughnut
			animateRotate: true,
			// Boolean - Whether we animate scaling the Doughnut from the centre
			animateScale: false
		},
		hover: {
			mode: 'single'
		},
		legendCallback: function(chart) {
			var list = document.createElement('ul');
			var data = chart.data;
			var datasets = data.datasets;
			var labels = data.labels;
			var i, ilen, listItem, listItemSpan;
	
			list.setAttribute('class', chart.id + '-legend');
			if (datasets.length) {
				for (i = 0, ilen = datasets[0].data.length; i < ilen; ++i) {
					listItem = list.appendChild(document.createElement('li'));
					listItemSpan = listItem.appendChild(document.createElement('span'));
					listItemSpan.style.backgroundColor = datasets[0].backgroundColor[i];
					if (labels[i]) {
						listItem.appendChild(document.createTextNode(labels[i]));
					}
				}
			}
	
			return list.outerHTML;
		},
		legend: {
			labels: {
				generateLabels: function(chart) {
					var data = chart.data;
					if (data.labels.length && data.datasets.length) {
						return data.labels.map(function(label, i) {
							var meta = chart.getDatasetMeta(0);
							var style = meta.controller.getStyle(i);
	
							return {
								text: label,
								fillStyle: style.backgroundColor,
								strokeStyle: style.borderColor,
								lineWidth: style.borderWidth,
								hidden: isNaN(data.datasets[0].data[i]) || meta.data[i].hidden,
	
								// Extra data used for toggling the correct item
								index: i
							};
						});
					}
					return [];
				}
			},
	
			onClick: function(e, legendItem) {
				var index = legendItem.index;
				var chart = this.chart;
				var i, ilen, meta;
	
				for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
					meta = chart.getDatasetMeta(i);
					// toggle visibility of index if exists
					if (meta.data[index]) {
						meta.data[index].hidden = !meta.data[index].hidden;
					}
				}
	
				chart.update();
			}
		},
	
		// The percentage of the chart that we cut out of the middle.
		cutoutPercentage: 50,
	
		// The rotation of the chart, where the first data arc begins.
		rotation: -HALF_PI$1,
	
		// The total circumference of the chart.
		circumference: DOUBLE_PI$1,
	
		// Need to override these to give a nice default
		tooltips: {
			callbacks: {
				title: function() {
					return '';
				},
				label: function(tooltipItem, data) {
					var dataLabel = data.labels[tooltipItem.index];
					var value = ': ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
	
					if (helpers$1.isArray(dataLabel)) {
						// show value on first line of multiline label
						// need to clone because we are changing the value
						dataLabel = dataLabel.slice();
						dataLabel[0] += value;
					} else {
						dataLabel += value;
					}
	
					return dataLabel;
				}
			}
		}
	});
	
	var controller_doughnut = core_datasetController.extend({
	
		dataElementType: elements.Arc,
	
		linkScales: helpers$1.noop,
	
		/**
		 * @private
		 */
		_dataElementOptions: [
			'backgroundColor',
			'borderColor',
			'borderWidth',
			'borderAlign',
			'hoverBackgroundColor',
			'hoverBorderColor',
			'hoverBorderWidth',
		],
	
		// Get index of the dataset in relation to the visible datasets. This allows determining the inner and outer radius correctly
		getRingIndex: function(datasetIndex) {
			var ringIndex = 0;
	
			for (var j = 0; j < datasetIndex; ++j) {
				if (this.chart.isDatasetVisible(j)) {
					++ringIndex;
				}
			}
	
			return ringIndex;
		},
	
		update: function(reset) {
			var me = this;
			var chart = me.chart;
			var chartArea = chart.chartArea;
			var opts = chart.options;
			var ratioX = 1;
			var ratioY = 1;
			var offsetX = 0;
			var offsetY = 0;
			var meta = me.getMeta();
			var arcs = meta.data;
			var cutout = opts.cutoutPercentage / 100 || 0;
			var circumference = opts.circumference;
			var chartWeight = me._getRingWeight(me.index);
			var maxWidth, maxHeight, i, ilen;
	
			// If the chart's circumference isn't a full circle, calculate size as a ratio of the width/height of the arc
			if (circumference < DOUBLE_PI$1) {
				var startAngle = opts.rotation % DOUBLE_PI$1;
				startAngle += startAngle >= PI$1 ? -DOUBLE_PI$1 : startAngle < -PI$1 ? DOUBLE_PI$1 : 0;
				var endAngle = startAngle + circumference;
				var startX = Math.cos(startAngle);
				var startY = Math.sin(startAngle);
				var endX = Math.cos(endAngle);
				var endY = Math.sin(endAngle);
				var contains0 = (startAngle <= 0 && endAngle >= 0) || endAngle >= DOUBLE_PI$1;
				var contains90 = (startAngle <= HALF_PI$1 && endAngle >= HALF_PI$1) || endAngle >= DOUBLE_PI$1 + HALF_PI$1;
				var contains180 = startAngle === -PI$1 || endAngle >= PI$1;
				var contains270 = (startAngle <= -HALF_PI$1 && endAngle >= -HALF_PI$1) || endAngle >= PI$1 + HALF_PI$1;
				var minX = contains180 ? -1 : Math.min(startX, startX * cutout, endX, endX * cutout);
				var minY = contains270 ? -1 : Math.min(startY, startY * cutout, endY, endY * cutout);
				var maxX = contains0 ? 1 : Math.max(startX, startX * cutout, endX, endX * cutout);
				var maxY = contains90 ? 1 : Math.max(startY, startY * cutout, endY, endY * cutout);
				ratioX = (maxX - minX) / 2;
				ratioY = (maxY - minY) / 2;
				offsetX = -(maxX + minX) / 2;
				offsetY = -(maxY + minY) / 2;
			}
	
			for (i = 0, ilen = arcs.length; i < ilen; ++i) {
				arcs[i]._options = me._resolveDataElementOptions(arcs[i], i);
			}
	
			chart.borderWidth = me.getMaxBorderWidth();
			maxWidth = (chartArea.right - chartArea.left - chart.borderWidth) / ratioX;
			maxHeight = (chartArea.bottom - chartArea.top - chart.borderWidth) / ratioY;
			chart.outerRadius = Math.max(Math.min(maxWidth, maxHeight) / 2, 0);
			chart.innerRadius = Math.max(chart.outerRadius * cutout, 0);
			chart.radiusLength = (chart.outerRadius - chart.innerRadius) / (me._getVisibleDatasetWeightTotal() || 1);
			chart.offsetX = offsetX * chart.outerRadius;
			chart.offsetY = offsetY * chart.outerRadius;
	
			meta.total = me.calculateTotal();
	
			me.outerRadius = chart.outerRadius - chart.radiusLength * me._getRingWeightOffset(me.index);
			me.innerRadius = Math.max(me.outerRadius - chart.radiusLength * chartWeight, 0);
	
			for (i = 0, ilen = arcs.length; i < ilen; ++i) {
				me.updateElement(arcs[i], i, reset);
			}
		},
	
		updateElement: function(arc, index, reset) {
			var me = this;
			var chart = me.chart;
			var chartArea = chart.chartArea;
			var opts = chart.options;
			var animationOpts = opts.animation;
			var centerX = (chartArea.left + chartArea.right) / 2;
			var centerY = (chartArea.top + chartArea.bottom) / 2;
			var startAngle = opts.rotation; // non reset case handled later
			var endAngle = opts.rotation; // non reset case handled later
			var dataset = me.getDataset();
			var circumference = reset && animationOpts.animateRotate ? 0 : arc.hidden ? 0 : me.calculateCircumference(dataset.data[index]) * (opts.circumference / DOUBLE_PI$1);
			var innerRadius = reset && animationOpts.animateScale ? 0 : me.innerRadius;
			var outerRadius = reset && animationOpts.animateScale ? 0 : me.outerRadius;
			var options = arc._options || {};
	
			helpers$1.extend(arc, {
				// Utility
				_datasetIndex: me.index,
				_index: index,
	
				// Desired view properties
				_model: {
					backgroundColor: options.backgroundColor,
					borderColor: options.borderColor,
					borderWidth: options.borderWidth,
					borderAlign: options.borderAlign,
					x: centerX + chart.offsetX,
					y: centerY + chart.offsetY,
					startAngle: startAngle,
					endAngle: endAngle,
					circumference: circumference,
					outerRadius: outerRadius,
					innerRadius: innerRadius,
					label: helpers$1.valueAtIndexOrDefault(dataset.label, index, chart.data.labels[index])
				}
			});
	
			var model = arc._model;
	
			// Set correct angles if not resetting
			if (!reset || !animationOpts.animateRotate) {
				if (index === 0) {
					model.startAngle = opts.rotation;
				} else {
					model.startAngle = me.getMeta().data[index - 1]._model.endAngle;
				}
	
				model.endAngle = model.startAngle + model.circumference;
			}
	
			arc.pivot();
		},
	
		calculateTotal: function() {
			var dataset = this.getDataset();
			var meta = this.getMeta();
			var total = 0;
			var value;
	
			helpers$1.each(meta.data, function(element, index) {
				value = dataset.data[index];
				if (!isNaN(value) && !element.hidden) {
					total += Math.abs(value);
				}
			});
	
			/* if (total === 0) {
				total = NaN;
			}*/
	
			return total;
		},
	
		calculateCircumference: function(value) {
			var total = this.getMeta().total;
			if (total > 0 && !isNaN(value)) {
				return DOUBLE_PI$1 * (Math.abs(value) / total);
			}
			return 0;
		},
	
		// gets the max border or hover width to properly scale pie charts
		getMaxBorderWidth: function(arcs) {
			var me = this;
			var max = 0;
			var chart = me.chart;
			var i, ilen, meta, arc, controller, options, borderWidth, hoverWidth;
	
			if (!arcs) {
				// Find the outmost visible dataset
				for (i = 0, ilen = chart.data.datasets.length; i < ilen; ++i) {
					if (chart.isDatasetVisible(i)) {
						meta = chart.getDatasetMeta(i);
						arcs = meta.data;
						if (i !== me.index) {
							controller = meta.controller;
						}
						break;
					}
				}
			}
	
			if (!arcs) {
				return 0;
			}
	
			for (i = 0, ilen = arcs.length; i < ilen; ++i) {
				arc = arcs[i];
				if (controller) {
					controller._configure();
					options = controller._resolveDataElementOptions(arc, i);
				} else {
					options = arc._options;
				}
				if (options.borderAlign !== 'inner') {
					borderWidth = options.borderWidth;
					hoverWidth = options.hoverBorderWidth;
	
					max = borderWidth > max ? borderWidth : max;
					max = hoverWidth > max ? hoverWidth : max;
				}
			}
			return max;
		},
	
		/**
		 * @protected
		 */
		setHoverStyle: function(arc) {
			var model = arc._model;
			var options = arc._options;
			var getHoverColor = helpers$1.getHoverColor;
	
			arc.$previousStyle = {
				backgroundColor: model.backgroundColor,
				borderColor: model.borderColor,
				borderWidth: model.borderWidth,
			};
	
			model.backgroundColor = valueOrDefault$5(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
			model.borderColor = valueOrDefault$5(options.hoverBorderColor, getHoverColor(options.borderColor));
			model.borderWidth = valueOrDefault$5(options.hoverBorderWidth, options.borderWidth);
		},
	
		/**
		 * Get radius length offset of the dataset in relation to the visible datasets weights. This allows determining the inner and outer radius correctly
		 * @private
		 */
		_getRingWeightOffset: function(datasetIndex) {
			var ringWeightOffset = 0;
	
			for (var i = 0; i < datasetIndex; ++i) {
				if (this.chart.isDatasetVisible(i)) {
					ringWeightOffset += this._getRingWeight(i);
				}
			}
	
			return ringWeightOffset;
		},
	
		/**
		 * @private
		 */
		_getRingWeight: function(dataSetIndex) {
			return Math.max(valueOrDefault$5(this.chart.data.datasets[dataSetIndex].weight, 1), 0);
		},
	
		/**
		 * Returns the sum of all visibile data set weights.  This value can be 0.
		 * @private
		 */
		_getVisibleDatasetWeightTotal: function() {
			return this._getRingWeightOffset(this.chart.data.datasets.length);
		}
	});
	
	core_defaults._set('horizontalBar', {
		hover: {
			mode: 'index',
			axis: 'y'
		},
	
		scales: {
			xAxes: [{
				type: 'linear',
				position: 'bottom'
			}],
	
			yAxes: [{
				type: 'category',
				position: 'left',
				offset: true,
				gridLines: {
					offsetGridLines: true
				}
			}]
		},
	
		elements: {
			rectangle: {
				borderSkipped: 'left'
			}
		},
	
		tooltips: {
			mode: 'index',
			axis: 'y'
		}
	});
	
	core_defaults._set('global', {
		datasets: {
			horizontalBar: {
				categoryPercentage: 0.8,
				barPercentage: 0.9
			}
		}
	});
	
	var controller_horizontalBar = controller_bar.extend({
		/**
		 * @private
		 */
		_getValueScaleId: function() {
			return this.getMeta().xAxisID;
		},
	
		/**
		 * @private
		 */
		_getIndexScaleId: function() {
			return this.getMeta().yAxisID;
		}
	});
	
	var valueOrDefault$6 = helpers$1.valueOrDefault;
	var resolve$2 = helpers$1.options.resolve;
	var isPointInArea = helpers$1.canvas._isPointInArea;
	
	core_defaults._set('line', {
		showLines: true,
		spanGaps: false,
	
		hover: {
			mode: 'label'
		},
	
		scales: {
			xAxes: [{
				type: 'category',
				id: 'x-axis-0'
			}],
			yAxes: [{
				type: 'linear',
				id: 'y-axis-0'
			}]
		}
	});
	
	function scaleClip(scale, halfBorderWidth) {
		var tickOpts = scale && scale.options.ticks || {};
		var reverse = tickOpts.reverse;
		var min = tickOpts.min === undefined ? halfBorderWidth : 0;
		var max = tickOpts.max === undefined ? halfBorderWidth : 0;
		return {
			start: reverse ? max : min,
			end: reverse ? min : max
		};
	}
	
	function defaultClip(xScale, yScale, borderWidth) {
		var halfBorderWidth = borderWidth / 2;
		var x = scaleClip(xScale, halfBorderWidth);
		var y = scaleClip(yScale, halfBorderWidth);
	
		return {
			top: y.end,
			right: x.end,
			bottom: y.start,
			left: x.start
		};
	}
	
	function toClip(value) {
		var t, r, b, l;
	
		if (helpers$1.isObject(value)) {
			t = value.top;
			r = value.right;
			b = value.bottom;
			l = value.left;
		} else {
			t = r = b = l = value;
		}
	
		return {
			top: t,
			right: r,
			bottom: b,
			left: l
		};
	}
	
	
	var controller_line = core_datasetController.extend({
	
		datasetElementType: elements.Line,
	
		dataElementType: elements.Point,
	
		/**
		 * @private
		 */
		_datasetElementOptions: [
			'backgroundColor',
			'borderCapStyle',
			'borderColor',
			'borderDash',
			'borderDashOffset',
			'borderJoinStyle',
			'borderWidth',
			'cubicInterpolationMode',
			'fill'
		],
	
		/**
		 * @private
		 */
		_dataElementOptions: {
			backgroundColor: 'pointBackgroundColor',
			borderColor: 'pointBorderColor',
			borderWidth: 'pointBorderWidth',
			hitRadius: 'pointHitRadius',
			hoverBackgroundColor: 'pointHoverBackgroundColor',
			hoverBorderColor: 'pointHoverBorderColor',
			hoverBorderWidth: 'pointHoverBorderWidth',
			hoverRadius: 'pointHoverRadius',
			pointStyle: 'pointStyle',
			radius: 'pointRadius',
			rotation: 'pointRotation'
		},
	
		update: function(reset) {
			var me = this;
			var meta = me.getMeta();
			var line = meta.dataset;
			var points = meta.data || [];
			var options = me.chart.options;
			var config = me._config;
			var showLine = me._showLine = valueOrDefault$6(config.showLine, options.showLines);
			var i, ilen;
	
			me._xScale = me.getScaleForId(meta.xAxisID);
			me._yScale = me.getScaleForId(meta.yAxisID);
	
			// Update Line
			if (showLine) {
				// Compatibility: If the properties are defined with only the old name, use those values
				if (config.tension !== undefined && config.lineTension === undefined) {
					config.lineTension = config.tension;
				}
	
				// Utility
				line._scale = me._yScale;
				line._datasetIndex = me.index;
				// Data
				line._children = points;
				// Model
				line._model = me._resolveDatasetElementOptions(line);
	
				line.pivot();
			}
	
			// Update Points
			for (i = 0, ilen = points.length; i < ilen; ++i) {
				me.updateElement(points[i], i, reset);
			}
	
			if (showLine && line._model.tension !== 0) {
				me.updateBezierControlPoints();
			}
	
			// Now pivot the point for animation
			for (i = 0, ilen = points.length; i < ilen; ++i) {
				points[i].pivot();
			}
		},
	
		updateElement: function(point, index, reset) {
			var me = this;
			var meta = me.getMeta();
			var custom = point.custom || {};
			var dataset = me.getDataset();
			var datasetIndex = me.index;
			var value = dataset.data[index];
			var xScale = me._xScale;
			var yScale = me._yScale;
			var lineModel = meta.dataset._model;
			var x, y;
	
			var options = me._resolveDataElementOptions(point, index);
	
			x = xScale.getPixelForValue(typeof value === 'object' ? value : NaN, index, datasetIndex);
			y = reset ? yScale.getBasePixel() : me.calculatePointY(value, index, datasetIndex);
	
			// Utility
			point._xScale = xScale;
			point._yScale = yScale;
			point._options = options;
			point._datasetIndex = datasetIndex;
			point._index = index;
	
			// Desired view properties
			point._model = {
				x: x,
				y: y,
				skip: custom.skip || isNaN(x) || isNaN(y),
				// Appearance
				radius: options.radius,
				pointStyle: options.pointStyle,
				rotation: options.rotation,
				backgroundColor: options.backgroundColor,
				borderColor: options.borderColor,
				borderWidth: options.borderWidth,
				tension: valueOrDefault$6(custom.tension, lineModel ? lineModel.tension : 0),
				steppedLine: lineModel ? lineModel.steppedLine : false,
				// Tooltip
				hitRadius: options.hitRadius
			};
		},
	
		/**
		 * @private
		 */
		_resolveDatasetElementOptions: function(element) {
			var me = this;
			var config = me._config;
			var custom = element.custom || {};
			var options = me.chart.options;
			var lineOptions = options.elements.line;
			var values = core_datasetController.prototype._resolveDatasetElementOptions.apply(me, arguments);
	
			// The default behavior of lines is to break at null values, according
			// to https://github.com/chartjs/Chart.js/issues/2435#issuecomment-216718158
			// This option gives lines the ability to span gaps
			values.spanGaps = valueOrDefault$6(config.spanGaps, options.spanGaps);
			values.tension = valueOrDefault$6(config.lineTension, lineOptions.tension);
			values.steppedLine = resolve$2([custom.steppedLine, config.steppedLine, lineOptions.stepped]);
			values.clip = toClip(valueOrDefault$6(config.clip, defaultClip(me._xScale, me._yScale, values.borderWidth)));
	
			return values;
		},
	
		calculatePointY: function(value, index, datasetIndex) {
			var me = this;
			var chart = me.chart;
			var yScale = me._yScale;
			var sumPos = 0;
			var sumNeg = 0;
			var i, ds, dsMeta, stackedRightValue, rightValue, metasets, ilen;
	
			if (yScale.options.stacked) {
				rightValue = +yScale.getRightValue(value);
				metasets = chart._getSortedVisibleDatasetMetas();
				ilen = metasets.length;
	
				for (i = 0; i < ilen; ++i) {
					dsMeta = metasets[i];
					if (dsMeta.index === datasetIndex) {
						break;
					}
	
					ds = chart.data.datasets[dsMeta.index];
					if (dsMeta.type === 'line' && dsMeta.yAxisID === yScale.id) {
						stackedRightValue = +yScale.getRightValue(ds.data[index]);
						if (stackedRightValue < 0) {
							sumNeg += stackedRightValue || 0;
						} else {
							sumPos += stackedRightValue || 0;
						}
					}
				}
	
				if (rightValue < 0) {
					return yScale.getPixelForValue(sumNeg + rightValue);
				}
				return yScale.getPixelForValue(sumPos + rightValue);
			}
			return yScale.getPixelForValue(value);
		},
	
		updateBezierControlPoints: function() {
			var me = this;
			var chart = me.chart;
			var meta = me.getMeta();
			var lineModel = meta.dataset._model;
			var area = chart.chartArea;
			var points = meta.data || [];
			var i, ilen, model, controlPoints;
	
			// Only consider points that are drawn in case the spanGaps option is used
			if (lineModel.spanGaps) {
				points = points.filter(function(pt) {
					return !pt._model.skip;
				});
			}
	
			function capControlPoint(pt, min, max) {
				return Math.max(Math.min(pt, max), min);
			}
	
			if (lineModel.cubicInterpolationMode === 'monotone') {
				helpers$1.splineCurveMonotone(points);
			} else {
				for (i = 0, ilen = points.length; i < ilen; ++i) {
					model = points[i]._model;
					controlPoints = helpers$1.splineCurve(
						helpers$1.previousItem(points, i)._model,
						model,
						helpers$1.nextItem(points, i)._model,
						lineModel.tension
					);
					model.controlPointPreviousX = controlPoints.previous.x;
					model.controlPointPreviousY = controlPoints.previous.y;
					model.controlPointNextX = controlPoints.next.x;
					model.controlPointNextY = controlPoints.next.y;
				}
			}
	
			if (chart.options.elements.line.capBezierPoints) {
				for (i = 0, ilen = points.length; i < ilen; ++i) {
					model = points[i]._model;
					if (isPointInArea(model, area)) {
						if (i > 0 && isPointInArea(points[i - 1]._model, area)) {
							model.controlPointPreviousX = capControlPoint(model.controlPointPreviousX, area.left, area.right);
							model.controlPointPreviousY = capControlPoint(model.controlPointPreviousY, area.top, area.bottom);
						}
						if (i < points.length - 1 && isPointInArea(points[i + 1]._model, area)) {
							model.controlPointNextX = capControlPoint(model.controlPointNextX, area.left, area.right);
							model.controlPointNextY = capControlPoint(model.controlPointNextY, area.top, area.bottom);
						}
					}
				}
			}
		},
	
		draw: function() {
			var me = this;
			var chart = me.chart;
			var meta = me.getMeta();
			var points = meta.data || [];
			var area = chart.chartArea;
			var canvas = chart.canvas;
			var i = 0;
			var ilen = points.length;
			var clip;
	
			if (me._showLine) {
				clip = meta.dataset._model.clip;
	
				helpers$1.canvas.clipArea(chart.ctx, {
					left: clip.left === false ? 0 : area.left - clip.left,
					right: clip.right === false ? canvas.width : area.right + clip.right,
					top: clip.top === false ? 0 : area.top - clip.top,
					bottom: clip.bottom === false ? canvas.height : area.bottom + clip.bottom
				});
	
				meta.dataset.draw();
	
				helpers$1.canvas.unclipArea(chart.ctx);
			}
	
			// Draw the points
			for (; i < ilen; ++i) {
				points[i].draw(area);
			}
		},
	
		/**
		 * @protected
		 */
		setHoverStyle: function(point) {
			var model = point._model;
			var options = point._options;
			var getHoverColor = helpers$1.getHoverColor;
	
			point.$previousStyle = {
				backgroundColor: model.backgroundColor,
				borderColor: model.borderColor,
				borderWidth: model.borderWidth,
				radius: model.radius
			};
	
			model.backgroundColor = valueOrDefault$6(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
			model.borderColor = valueOrDefault$6(options.hoverBorderColor, getHoverColor(options.borderColor));
			model.borderWidth = valueOrDefault$6(options.hoverBorderWidth, options.borderWidth);
			model.radius = valueOrDefault$6(options.hoverRadius, options.radius);
		},
	});
	
	var resolve$3 = helpers$1.options.resolve;
	
	core_defaults._set('polarArea', {
		scale: {
			type: 'radialLinear',
			angleLines: {
				display: false
			},
			gridLines: {
				circular: true
			},
			pointLabels: {
				display: false
			},
			ticks: {
				beginAtZero: true
			}
		},
	
		// Boolean - Whether to animate the rotation of the chart
		animation: {
			animateRotate: true,
			animateScale: true
		},
	
		startAngle: -0.5 * Math.PI,
		legendCallback: function(chart) {
			var list = document.createElement('ul');
			var data = chart.data;
			var datasets = data.datasets;
			var labels = data.labels;
			var i, ilen, listItem, listItemSpan;
	
			list.setAttribute('class', chart.id + '-legend');
			if (datasets.length) {
				for (i = 0, ilen = datasets[0].data.length; i < ilen; ++i) {
					listItem = list.appendChild(document.createElement('li'));
					listItemSpan = listItem.appendChild(document.createElement('span'));
					listItemSpan.style.backgroundColor = datasets[0].backgroundColor[i];
					if (labels[i]) {
						listItem.appendChild(document.createTextNode(labels[i]));
					}
				}
			}
	
			return list.outerHTML;
		},
		legend: {
			labels: {
				generateLabels: function(chart) {
					var data = chart.data;
					if (data.labels.length && data.datasets.length) {
						return data.labels.map(function(label, i) {
							var meta = chart.getDatasetMeta(0);
							var style = meta.controller.getStyle(i);
	
							return {
								text: label,
								fillStyle: style.backgroundColor,
								strokeStyle: style.borderColor,
								lineWidth: style.borderWidth,
								hidden: isNaN(data.datasets[0].data[i]) || meta.data[i].hidden,
	
								// Extra data used for toggling the correct item
								index: i
							};
						});
					}
					return [];
				}
			},
	
			onClick: function(e, legendItem) {
				var index = legendItem.index;
				var chart = this.chart;
				var i, ilen, meta;
	
				for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
					meta = chart.getDatasetMeta(i);
					meta.data[index].hidden = !meta.data[index].hidden;
				}
	
				chart.update();
			}
		},
	
		// Need to override these to give a nice default
		tooltips: {
			callbacks: {
				title: function() {
					return '';
				},
				label: function(item, data) {
					return data.labels[item.index] + ': ' + item.yLabel;
				}
			}
		}
	});
	
	var controller_polarArea = core_datasetController.extend({
	
		dataElementType: elements.Arc,
	
		linkScales: helpers$1.noop,
	
		/**
		 * @private
		 */
		_dataElementOptions: [
			'backgroundColor',
			'borderColor',
			'borderWidth',
			'borderAlign',
			'hoverBackgroundColor',
			'hoverBorderColor',
			'hoverBorderWidth',
		],
	
		/**
		 * @private
		 */
		_getIndexScaleId: function() {
			return this.chart.scale.id;
		},
	
		/**
		 * @private
		 */
		_getValueScaleId: function() {
			return this.chart.scale.id;
		},
	
		update: function(reset) {
			var me = this;
			var dataset = me.getDataset();
			var meta = me.getMeta();
			var start = me.chart.options.startAngle || 0;
			var starts = me._starts = [];
			var angles = me._angles = [];
			var arcs = meta.data;
			var i, ilen, angle;
	
			me._updateRadius();
	
			meta.count = me.countVisibleElements();
	
			for (i = 0, ilen = dataset.data.length; i < ilen; i++) {
				starts[i] = start;
				angle = me._computeAngle(i);
				angles[i] = angle;
				start += angle;
			}
	
			for (i = 0, ilen = arcs.length; i < ilen; ++i) {
				arcs[i]._options = me._resolveDataElementOptions(arcs[i], i);
				me.updateElement(arcs[i], i, reset);
			}
		},
	
		/**
		 * @private
		 */
		_updateRadius: function() {
			var me = this;
			var chart = me.chart;
			var chartArea = chart.chartArea;
			var opts = chart.options;
			var minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
	
			chart.outerRadius = Math.max(minSize / 2, 0);
			chart.innerRadius = Math.max(opts.cutoutPercentage ? (chart.outerRadius / 100) * (opts.cutoutPercentage) : 1, 0);
			chart.radiusLength = (chart.outerRadius - chart.innerRadius) / chart.getVisibleDatasetCount();
	
			me.outerRadius = chart.outerRadius - (chart.radiusLength * me.index);
			me.innerRadius = me.outerRadius - chart.radiusLength;
		},
	
		updateElement: function(arc, index, reset) {
			var me = this;
			var chart = me.chart;
			var dataset = me.getDataset();
			var opts = chart.options;
			var animationOpts = opts.animation;
			var scale = chart.scale;
			var labels = chart.data.labels;
	
			var centerX = scale.xCenter;
			var centerY = scale.yCenter;
	
			// var negHalfPI = -0.5 * Math.PI;
			var datasetStartAngle = opts.startAngle;
			var distance = arc.hidden ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
			var startAngle = me._starts[index];
			var endAngle = startAngle + (arc.hidden ? 0 : me._angles[index]);
	
			var resetRadius = animationOpts.animateScale ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
			var options = arc._options || {};
	
			helpers$1.extend(arc, {
				// Utility
				_datasetIndex: me.index,
				_index: index,
				_scale: scale,
	
				// Desired view properties
				_model: {
					backgroundColor: options.backgroundColor,
					borderColor: options.borderColor,
					borderWidth: options.borderWidth,
					borderAlign: options.borderAlign,
					x: centerX,
					y: centerY,
					innerRadius: 0,
					outerRadius: reset ? resetRadius : distance,
					startAngle: reset && animationOpts.animateRotate ? datasetStartAngle : startAngle,
					endAngle: reset && animationOpts.animateRotate ? datasetStartAngle : endAngle,
					label: helpers$1.valueAtIndexOrDefault(labels, index, labels[index])
				}
			});
	
			arc.pivot();
		},
	
		countVisibleElements: function() {
			var dataset = this.getDataset();
			var meta = this.getMeta();
			var count = 0;
	
			helpers$1.each(meta.data, function(element, index) {
				if (!isNaN(dataset.data[index]) && !element.hidden) {
					count++;
				}
			});
	
			return count;
		},
	
		/**
		 * @protected
		 */
		setHoverStyle: function(arc) {
			var model = arc._model;
			var options = arc._options;
			var getHoverColor = helpers$1.getHoverColor;
			var valueOrDefault = helpers$1.valueOrDefault;
	
			arc.$previousStyle = {
				backgroundColor: model.backgroundColor,
				borderColor: model.borderColor,
				borderWidth: model.borderWidth,
			};
	
			model.backgroundColor = valueOrDefault(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
			model.borderColor = valueOrDefault(options.hoverBorderColor, getHoverColor(options.borderColor));
			model.borderWidth = valueOrDefault(options.hoverBorderWidth, options.borderWidth);
		},
	
		/**
		 * @private
		 */
		_computeAngle: function(index) {
			var me = this;
			var count = this.getMeta().count;
			var dataset = me.getDataset();
			var meta = me.getMeta();
	
			if (isNaN(dataset.data[index]) || meta.data[index].hidden) {
				return 0;
			}
	
			// Scriptable options
			var context = {
				chart: me.chart,
				dataIndex: index,
				dataset: dataset,
				datasetIndex: me.index
			};
	
			return resolve$3([
				me.chart.options.elements.arc.angle,
				(2 * Math.PI) / count
			], context, index);
		}
	});
	
	core_defaults._set('pie', helpers$1.clone(core_defaults.doughnut));
	core_defaults._set('pie', {
		cutoutPercentage: 0
	});
	
	// Pie charts are Doughnut chart with different defaults
	var controller_pie = controller_doughnut;
	
	var valueOrDefault$7 = helpers$1.valueOrDefault;
	
	core_defaults._set('radar', {
		spanGaps: false,
		scale: {
			type: 'radialLinear'
		},
		elements: {
			line: {
				fill: 'start',
				tension: 0 // no bezier in radar
			}
		}
	});
	
	var controller_radar = core_datasetController.extend({
		datasetElementType: elements.Line,
	
		dataElementType: elements.Point,
	
		linkScales: helpers$1.noop,
	
		/**
		 * @private
		 */
		_datasetElementOptions: [
			'backgroundColor',
			'borderWidth',
			'borderColor',
			'borderCapStyle',
			'borderDash',
			'borderDashOffset',
			'borderJoinStyle',
			'fill'
		],
	
		/**
		 * @private
		 */
		_dataElementOptions: {
			backgroundColor: 'pointBackgroundColor',
			borderColor: 'pointBorderColor',
			borderWidth: 'pointBorderWidth',
			hitRadius: 'pointHitRadius',
			hoverBackgroundColor: 'pointHoverBackgroundColor',
			hoverBorderColor: 'pointHoverBorderColor',
			hoverBorderWidth: 'pointHoverBorderWidth',
			hoverRadius: 'pointHoverRadius',
			pointStyle: 'pointStyle',
			radius: 'pointRadius',
			rotation: 'pointRotation'
		},
	
		/**
		 * @private
		 */
		_getIndexScaleId: function() {
			return this.chart.scale.id;
		},
	
		/**
		 * @private
		 */
		_getValueScaleId: function() {
			return this.chart.scale.id;
		},
	
		update: function(reset) {
			var me = this;
			var meta = me.getMeta();
			var line = meta.dataset;
			var points = meta.data || [];
			var scale = me.chart.scale;
			var config = me._config;
			var i, ilen;
	
			// Compatibility: If the properties are defined with only the old name, use those values
			if (config.tension !== undefined && config.lineTension === undefined) {
				config.lineTension = config.tension;
			}
	
			// Utility
			line._scale = scale;
			line._datasetIndex = me.index;
			// Data
			line._children = points;
			line._loop = true;
			// Model
			line._model = me._resolveDatasetElementOptions(line);
	
			line.pivot();
	
			// Update Points
			for (i = 0, ilen = points.length; i < ilen; ++i) {
				me.updateElement(points[i], i, reset);
			}
	
			// Update bezier control points
			me.updateBezierControlPoints();
	
			// Now pivot the point for animation
			for (i = 0, ilen = points.length; i < ilen; ++i) {
				points[i].pivot();
			}
		},
	
		updateElement: function(point, index, reset) {
			var me = this;
			var custom = point.custom || {};
			var dataset = me.getDataset();
			var scale = me.chart.scale;
			var pointPosition = scale.getPointPositionForValue(index, dataset.data[index]);
			var options = me._resolveDataElementOptions(point, index);
			var lineModel = me.getMeta().dataset._model;
			var x = reset ? scale.xCenter : pointPosition.x;
			var y = reset ? scale.yCenter : pointPosition.y;
	
			// Utility
			point._scale = scale;
			point._options = options;
			point._datasetIndex = me.index;
			point._index = index;
	
			// Desired view properties
			point._model = {
				x: x, // value not used in dataset scale, but we want a consistent API between scales
				y: y,
				skip: custom.skip || isNaN(x) || isNaN(y),
				// Appearance
				radius: options.radius,
				pointStyle: options.pointStyle,
				rotation: options.rotation,
				backgroundColor: options.backgroundColor,
				borderColor: options.borderColor,
				borderWidth: options.borderWidth,
				tension: valueOrDefault$7(custom.tension, lineModel ? lineModel.tension : 0),
	
				// Tooltip
				hitRadius: options.hitRadius
			};
		},
	
		/**
		 * @private
		 */
		_resolveDatasetElementOptions: function() {
			var me = this;
			var config = me._config;
			var options = me.chart.options;
			var values = core_datasetController.prototype._resolveDatasetElementOptions.apply(me, arguments);
	
			values.spanGaps = valueOrDefault$7(config.spanGaps, options.spanGaps);
			values.tension = valueOrDefault$7(config.lineTension, options.elements.line.tension);
	
			return values;
		},
	
		updateBezierControlPoints: function() {
			var me = this;
			var meta = me.getMeta();
			var area = me.chart.chartArea;
			var points = meta.data || [];
			var i, ilen, model, controlPoints;
	
			// Only consider points that are drawn in case the spanGaps option is used
			if (meta.dataset._model.spanGaps) {
				points = points.filter(function(pt) {
					return !pt._model.skip;
				});
			}
	
			function capControlPoint(pt, min, max) {
				return Math.max(Math.min(pt, max), min);
			}
	
			for (i = 0, ilen = points.length; i < ilen; ++i) {
				model = points[i]._model;
				controlPoints = helpers$1.splineCurve(
					helpers$1.previousItem(points, i, true)._model,
					model,
					helpers$1.nextItem(points, i, true)._model,
					model.tension
				);
	
				// Prevent the bezier going outside of the bounds of the graph
				model.controlPointPreviousX = capControlPoint(controlPoints.previous.x, area.left, area.right);
				model.controlPointPreviousY = capControlPoint(controlPoints.previous.y, area.top, area.bottom);
				model.controlPointNextX = capControlPoint(controlPoints.next.x, area.left, area.right);
				model.controlPointNextY = capControlPoint(controlPoints.next.y, area.top, area.bottom);
			}
		},
	
		setHoverStyle: function(point) {
			var model = point._model;
			var options = point._options;
			var getHoverColor = helpers$1.getHoverColor;
	
			point.$previousStyle = {
				backgroundColor: model.backgroundColor,
				borderColor: model.borderColor,
				borderWidth: model.borderWidth,
				radius: model.radius
			};
	
			model.backgroundColor = valueOrDefault$7(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
			model.borderColor = valueOrDefault$7(options.hoverBorderColor, getHoverColor(options.borderColor));
			model.borderWidth = valueOrDefault$7(options.hoverBorderWidth, options.borderWidth);
			model.radius = valueOrDefault$7(options.hoverRadius, options.radius);
		}
	});
	
	core_defaults._set('scatter', {
		hover: {
			mode: 'single'
		},
	
		scales: {
			xAxes: [{
				id: 'x-axis-1',    // need an ID so datasets can reference the scale
				type: 'linear',    // scatter should not use a category axis
				position: 'bottom'
			}],
			yAxes: [{
				id: 'y-axis-1',
				type: 'linear',
				position: 'left'
			}]
		},
	
		tooltips: {
			callbacks: {
				title: function() {
					return '';     // doesn't make sense for scatter since data are formatted as a point
				},
				label: function(item) {
					return '(' + item.xLabel + ', ' + item.yLabel + ')';
				}
			}
		}
	});
	
	core_defaults._set('global', {
		datasets: {
			scatter: {
				showLine: false
			}
		}
	});
	
	// Scatter charts use line controllers
	var controller_scatter = controller_line;
	
	// NOTE export a map in which the key represents the controller type, not
	// the class, and so must be CamelCase in order to be correctly retrieved
	// by the controller in core.controller.js (`controllers[meta.type]`).
	
	var controllers = {
		bar: controller_bar,
		bubble: controller_bubble,
		doughnut: controller_doughnut,
		horizontalBar: controller_horizontalBar,
		line: controller_line,
		polarArea: controller_polarArea,
		pie: controller_pie,
		radar: controller_radar,
		scatter: controller_scatter
	};
	
	/**
	 * Helper function to get relative position for an event
	 * @param {Event|IEvent} event - The event to get the position for
	 * @param {Chart} chart - The chart
	 * @returns {object} the event position
	 */
	function getRelativePosition(e, chart) {
		if (e.native) {
			return {
				x: e.x,
				y: e.y
			};
		}
	
		return helpers$1.getRelativePosition(e, chart);
	}
	
	/**
	 * Helper function to traverse all of the visible elements in the chart
	 * @param {Chart} chart - the chart
	 * @param {function} handler - the callback to execute for each visible item
	 */
	function parseVisibleItems(chart, handler) {
		var metasets = chart._getSortedVisibleDatasetMetas();
		var metadata, i, j, ilen, jlen, element;
	
		for (i = 0, ilen = metasets.length; i < ilen; ++i) {
			metadata = metasets[i].data;
			for (j = 0, jlen = metadata.length; j < jlen; ++j) {
				element = metadata[j];
				if (!element._view.skip) {
					handler(element);
				}
			}
		}
	}
	
	/**
	 * Helper function to get the items that intersect the event position
	 * @param {ChartElement[]} items - elements to filter
	 * @param {object} position - the point to be nearest to
	 * @return {ChartElement[]} the nearest items
	 */
	function getIntersectItems(chart, position) {
		var elements = [];
	
		parseVisibleItems(chart, function(element) {
			if (element.inRange(position.x, position.y)) {
				elements.push(element);
			}
		});
	
		return elements;
	}
	
	/**
	 * Helper function to get the items nearest to the event position considering all visible items in teh chart
	 * @param {Chart} chart - the chart to look at elements from
	 * @param {object} position - the point to be nearest to
	 * @param {boolean} intersect - if true, only consider items that intersect the position
	 * @param {function} distanceMetric - function to provide the distance between points
	 * @return {ChartElement[]} the nearest items
	 */
	function getNearestItems(chart, position, intersect, distanceMetric) {
		var minDistance = Number.POSITIVE_INFINITY;
		var nearestItems = [];
	
		parseVisibleItems(chart, function(element) {
			if (intersect && !element.inRange(position.x, position.y)) {
				return;
			}
	
			var center = element.getCenterPoint();
			var distance = distanceMetric(position, center);
			if (distance < minDistance) {
				nearestItems = [element];
				minDistance = distance;
			} else if (distance === minDistance) {
				// Can have multiple items at the same distance in which case we sort by size
				nearestItems.push(element);
			}
		});
	
		return nearestItems;
	}
	
	/**
	 * Get a distance metric function for two points based on the
	 * axis mode setting
	 * @param {string} axis - the axis mode. x|y|xy
	 */
	function getDistanceMetricForAxis(axis) {
		var useX = axis.indexOf('x') !== -1;
		var useY = axis.indexOf('y') !== -1;
	
		return function(pt1, pt2) {
			var deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
			var deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
			return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
		};
	}
	
	function indexMode(chart, e, options) {
		var position = getRelativePosition(e, chart);
		// Default axis for index mode is 'x' to match old behaviour
		options.axis = options.axis || 'x';
		var distanceMetric = getDistanceMetricForAxis(options.axis);
		var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);
		var elements = [];
	
		if (!items.length) {
			return [];
		}
	
		chart._getSortedVisibleDatasetMetas().forEach(function(meta) {
			var element = meta.data[items[0]._index];
	
			// don't count items that are skipped (null data)
			if (element && !element._view.skip) {
				elements.push(element);
			}
		});
	
		return elements;
	}
	
	/**
	 * @interface IInteractionOptions
	 */
	/**
	 * If true, only consider items that intersect the point
	 * @name IInterfaceOptions#boolean
	 * @type Boolean
	 */
	
	/**
	 * Contains interaction related functions
	 * @namespace Chart.Interaction
	 */
	var core_interaction = {
		// Helper function for different modes
		modes: {
			single: function(chart, e) {
				var position = getRelativePosition(e, chart);
				var elements = [];
	
				parseVisibleItems(chart, function(element) {
					if (element.inRange(position.x, position.y)) {
						elements.push(element);
						return elements;
					}
				});
	
				return elements.slice(0, 1);
			},
	
			/**
			 * @function Chart.Interaction.modes.label
			 * @deprecated since version 2.4.0
			 * @todo remove at version 3
			 * @private
			 */
			label: indexMode,
	
			/**
			 * Returns items at the same index. If the options.intersect parameter is true, we only return items if we intersect something
			 * If the options.intersect mode is false, we find the nearest item and return the items at the same index as that item
			 * @function Chart.Interaction.modes.index
			 * @since v2.4.0
			 * @param {Chart} chart - the chart we are returning items from
			 * @param {Event} e - the event we are find things at
			 * @param {IInteractionOptions} options - options to use during interaction
			 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
			 */
			index: indexMode,
	
			/**
			 * Returns items in the same dataset. If the options.intersect parameter is true, we only return items if we intersect something
			 * If the options.intersect is false, we find the nearest item and return the items in that dataset
			 * @function Chart.Interaction.modes.dataset
			 * @param {Chart} chart - the chart we are returning items from
			 * @param {Event} e - the event we are find things at
			 * @param {IInteractionOptions} options - options to use during interaction
			 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
			 */
			dataset: function(chart, e, options) {
				var position = getRelativePosition(e, chart);
				options.axis = options.axis || 'xy';
				var distanceMetric = getDistanceMetricForAxis(options.axis);
				var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);
	
				if (items.length > 0) {
					items = chart.getDatasetMeta(items[0]._datasetIndex).data;
				}
	
				return items;
			},
	
			/**
			 * @function Chart.Interaction.modes.x-axis
			 * @deprecated since version 2.4.0. Use index mode and intersect == true
			 * @todo remove at version 3
			 * @private
			 */
			'x-axis': function(chart, e) {
				return indexMode(chart, e, {intersect: false});
			},
	
			/**
			 * Point mode returns all elements that hit test based on the event position
			 * of the event
			 * @function Chart.Interaction.modes.intersect
			 * @param {Chart} chart - the chart we are returning items from
			 * @param {Event} e - the event we are find things at
			 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
			 */
			point: function(chart, e) {
				var position = getRelativePosition(e, chart);
				return getIntersectItems(chart, position);
			},
	
			/**
			 * nearest mode returns the element closest to the point
			 * @function Chart.Interaction.modes.intersect
			 * @param {Chart} chart - the chart we are returning items from
			 * @param {Event} e - the event we are find things at
			 * @param {IInteractionOptions} options - options to use
			 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
			 */
			nearest: function(chart, e, options) {
				var position = getRelativePosition(e, chart);
				options.axis = options.axis || 'xy';
				var distanceMetric = getDistanceMetricForAxis(options.axis);
				return getNearestItems(chart, position, options.intersect, distanceMetric);
			},
	
			/**
			 * x mode returns the elements that hit-test at the current x coordinate
			 * @function Chart.Interaction.modes.x
			 * @param {Chart} chart - the chart we are returning items from
			 * @param {Event} e - the event we are find things at
			 * @param {IInteractionOptions} options - options to use
			 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
			 */
			x: function(chart, e, options) {
				var position = getRelativePosition(e, chart);
				var items = [];
				var intersectsItem = false;
	
				parseVisibleItems(chart, function(element) {
					if (element.inXRange(position.x)) {
						items.push(element);
					}
	
					if (element.inRange(position.x, position.y)) {
						intersectsItem = true;
					}
				});
	
				// If we want to trigger on an intersect and we don't have any items
				// that intersect the position, return nothing
				if (options.intersect && !intersectsItem) {
					items = [];
				}
				return items;
			},
	
			/**
			 * y mode returns the elements that hit-test at the current y coordinate
			 * @function Chart.Interaction.modes.y
			 * @param {Chart} chart - the chart we are returning items from
			 * @param {Event} e - the event we are find things at
			 * @param {IInteractionOptions} options - options to use
			 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
			 */
			y: function(chart, e, options) {
				var position = getRelativePosition(e, chart);
				var items = [];
				var intersectsItem = false;
	
				parseVisibleItems(chart, function(element) {
					if (element.inYRange(position.y)) {
						items.push(element);
					}
	
					if (element.inRange(position.x, position.y)) {
						intersectsItem = true;
					}
				});
	
				// If we want to trigger on an intersect and we don't have any items
				// that intersect the position, return nothing
				if (options.intersect && !intersectsItem) {
					items = [];
				}
				return items;
			}
		}
	};
	
	var extend = helpers$1.extend;
	
	function filterByPosition(array, position) {
		return helpers$1.where(array, function(v) {
			return v.pos === position;
		});
	}
	
	function sortByWeight(array, reverse) {
		return array.sort(function(a, b) {
			var v0 = reverse ? b : a;
			var v1 = reverse ? a : b;
			return v0.weight === v1.weight ?
				v0.index - v1.index :
				v0.weight - v1.weight;
		});
	}
	
	function wrapBoxes(boxes) {
		var layoutBoxes = [];
		var i, ilen, box;
	
		for (i = 0, ilen = (boxes || []).length; i < ilen; ++i) {
			box = boxes[i];
			layoutBoxes.push({
				index: i,
				box: box,
				pos: box.position,
				horizontal: box.isHorizontal(),
				weight: box.weight
			});
		}
		return layoutBoxes;
	}
	
	function setLayoutDims(layouts, params) {
		var i, ilen, layout;
		for (i = 0, ilen = layouts.length; i < ilen; ++i) {
			layout = layouts[i];
			// store width used instead of chartArea.w in fitBoxes
			layout.width = layout.horizontal
				? layout.box.fullWidth && params.availableWidth
				: params.vBoxMaxWidth;
			// store height used instead of chartArea.h in fitBoxes
			layout.height = layout.horizontal && params.hBoxMaxHeight;
		}
	}
	
	function buildLayoutBoxes(boxes) {
		var layoutBoxes = wrapBoxes(boxes);
		var left = sortByWeight(filterByPosition(layoutBoxes, 'left'), true);
		var right = sortByWeight(filterByPosition(layoutBoxes, 'right'));
		var top = sortByWeight(filterByPosition(layoutBoxes, 'top'), true);
		var bottom = sortByWeight(filterByPosition(layoutBoxes, 'bottom'));
	
		return {
			leftAndTop: left.concat(top),
			rightAndBottom: right.concat(bottom),
			chartArea: filterByPosition(layoutBoxes, 'chartArea'),
			vertical: left.concat(right),
			horizontal: top.concat(bottom)
		};
	}
	
	function getCombinedMax(maxPadding, chartArea, a, b) {
		return Math.max(maxPadding[a], chartArea[a]) + Math.max(maxPadding[b], chartArea[b]);
	}
	
	function updateDims(chartArea, params, layout) {
		var box = layout.box;
		var maxPadding = chartArea.maxPadding;
		var newWidth, newHeight;
	
		if (layout.size) {
			// this layout was already counted for, lets first reduce old size
			chartArea[layout.pos] -= layout.size;
		}
		layout.size = layout.horizontal ? box.height : box.width;
		chartArea[layout.pos] += layout.size;
	
		if (box.getPadding) {
			var boxPadding = box.getPadding();
			maxPadding.top = Math.max(maxPadding.top, boxPadding.top);
			maxPadding.left = Math.max(maxPadding.left, boxPadding.left);
			maxPadding.bottom = Math.max(maxPadding.bottom, boxPadding.bottom);
			maxPadding.right = Math.max(maxPadding.right, boxPadding.right);
		}
	
		newWidth = params.outerWidth - getCombinedMax(maxPadding, chartArea, 'left', 'right');
		newHeight = params.outerHeight - getCombinedMax(maxPadding, chartArea, 'top', 'bottom');
	
		if (newWidth !== chartArea.w || newHeight !== chartArea.h) {
			chartArea.w = newWidth;
			chartArea.h = newHeight;
	
			// return true if chart area changed in layout's direction
			var sizes = layout.horizontal ? [newWidth, chartArea.w] : [newHeight, chartArea.h];
			return sizes[0] !== sizes[1] && (!isNaN(sizes[0]) || !isNaN(sizes[1]));
		}
	}
	
	function handleMaxPadding(chartArea) {
		var maxPadding = chartArea.maxPadding;
	
		function updatePos(pos) {
			var change = Math.max(maxPadding[pos] - chartArea[pos], 0);
			chartArea[pos] += change;
			return change;
		}
		chartArea.y += updatePos('top');
		chartArea.x += updatePos('left');
		updatePos('right');
		updatePos('bottom');
	}
	
	function getMargins(horizontal, chartArea) {
		var maxPadding = chartArea.maxPadding;
	
		function marginForPositions(positions) {
			var margin = {left: 0, top: 0, right: 0, bottom: 0};
			positions.forEach(function(pos) {
				margin[pos] = Math.max(chartArea[pos], maxPadding[pos]);
			});
			return margin;
		}
	
		return horizontal
			? marginForPositions(['left', 'right'])
			: marginForPositions(['top', 'bottom']);
	}
	
	function fitBoxes(boxes, chartArea, params) {
		var refitBoxes = [];
		var i, ilen, layout, box, refit, changed;
	
		for (i = 0, ilen = boxes.length; i < ilen; ++i) {
			layout = boxes[i];
			box = layout.box;
	
			box.update(
				layout.width || chartArea.w,
				layout.height || chartArea.h,
				getMargins(layout.horizontal, chartArea)
			);
			if (updateDims(chartArea, params, layout)) {
				changed = true;
				if (refitBoxes.length) {
					// Dimensions changed and there were non full width boxes before this
					// -> we have to refit those
					refit = true;
				}
			}
			if (!box.fullWidth) { // fullWidth boxes don't need to be re-fitted in any case
				refitBoxes.push(layout);
			}
		}
	
		return refit ? fitBoxes(refitBoxes, chartArea, params) || changed : changed;
	}
	
	function placeBoxes(boxes, chartArea, params) {
		var userPadding = params.padding;
		var x = chartArea.x;
		var y = chartArea.y;
		var i, ilen, layout, box;
	
		for (i = 0, ilen = boxes.length; i < ilen; ++i) {
			layout = boxes[i];
			box = layout.box;
			if (layout.horizontal) {
				box.left = box.fullWidth ? userPadding.left : chartArea.left;
				box.right = box.fullWidth ? params.outerWidth - userPadding.right : chartArea.left + chartArea.w;
				box.top = y;
				box.bottom = y + box.height;
				box.width = box.right - box.left;
				y = box.bottom;
			} else {
				box.left = x;
				box.right = x + box.width;
				box.top = chartArea.top;
				box.bottom = chartArea.top + chartArea.h;
				box.height = box.bottom - box.top;
				x = box.right;
			}
		}
	
		chartArea.x = x;
		chartArea.y = y;
	}
	
	core_defaults._set('global', {
		layout: {
			padding: {
				top: 0,
				right: 0,
				bottom: 0,
				left: 0
			}
		}
	});
	
	/**
	 * @interface ILayoutItem
	 * @prop {string} position - The position of the item in the chart layout. Possible values are
	 * 'left', 'top', 'right', 'bottom', and 'chartArea'
	 * @prop {number} weight - The weight used to sort the item. Higher weights are further away from the chart area
	 * @prop {boolean} fullWidth - if true, and the item is horizontal, then push vertical boxes down
	 * @prop {function} isHorizontal - returns true if the layout item is horizontal (ie. top or bottom)
	 * @prop {function} update - Takes two parameters: width and height. Returns size of item
	 * @prop {function} getPadding -  Returns an object with padding on the edges
	 * @prop {number} width - Width of item. Must be valid after update()
	 * @prop {number} height - Height of item. Must be valid after update()
	 * @prop {number} left - Left edge of the item. Set by layout system and cannot be used in update
	 * @prop {number} top - Top edge of the item. Set by layout system and cannot be used in update
	 * @prop {number} right - Right edge of the item. Set by layout system and cannot be used in update
	 * @prop {number} bottom - Bottom edge of the item. Set by layout system and cannot be used in update
	 */
	
	// The layout service is very self explanatory.  It's responsible for the layout within a chart.
	// Scales, Legends and Plugins all rely on the layout service and can easily register to be placed anywhere they need
	// It is this service's responsibility of carrying out that layout.
	var core_layouts = {
		defaults: {},
	
		/**
		 * Register a box to a chart.
		 * A box is simply a reference to an object that requires layout. eg. Scales, Legend, Title.
		 * @param {Chart} chart - the chart to use
		 * @param {ILayoutItem} item - the item to add to be layed out
		 */
		addBox: function(chart, item) {
			if (!chart.boxes) {
				chart.boxes = [];
			}
	
			// initialize item with default values
			item.fullWidth = item.fullWidth || false;
			item.position = item.position || 'top';
			item.weight = item.weight || 0;
			item._layers = item._layers || function() {
				return [{
					z: 0,
					draw: function() {
						item.draw.apply(item, arguments);
					}
				}];
			};
	
			chart.boxes.push(item);
		},
	
		/**
		 * Remove a layoutItem from a chart
		 * @param {Chart} chart - the chart to remove the box from
		 * @param {ILayoutItem} layoutItem - the item to remove from the layout
		 */
		removeBox: function(chart, layoutItem) {
			var index = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
			if (index !== -1) {
				chart.boxes.splice(index, 1);
			}
		},
	
		/**
		 * Sets (or updates) options on the given `item`.
		 * @param {Chart} chart - the chart in which the item lives (or will be added to)
		 * @param {ILayoutItem} item - the item to configure with the given options
		 * @param {object} options - the new item options.
		 */
		configure: function(chart, item, options) {
			var props = ['fullWidth', 'position', 'weight'];
			var ilen = props.length;
			var i = 0;
			var prop;
	
			for (; i < ilen; ++i) {
				prop = props[i];
				if (options.hasOwnProperty(prop)) {
					item[prop] = options[prop];
				}
			}
		},
	
		/**
		 * Fits boxes of the given chart into the given size by having each box measure itself
		 * then running a fitting algorithm
		 * @param {Chart} chart - the chart
		 * @param {number} width - the width to fit into
		 * @param {number} height - the height to fit into
		 */
		update: function(chart, width, height) {
			if (!chart) {
				return;
			}
	
			var layoutOptions = chart.options.layout || {};
			var padding = helpers$1.options.toPadding(layoutOptions.padding);
	
			var availableWidth = width - padding.width;
			var availableHeight = height - padding.height;
			var boxes = buildLayoutBoxes(chart.boxes);
			var verticalBoxes = boxes.vertical;
			var horizontalBoxes = boxes.horizontal;
	
			// Essentially we now have any number of boxes on each of the 4 sides.
			// Our canvas looks like the following.
			// The areas L1 and L2 are the left axes. R1 is the right axis, T1 is the top axis and
			// B1 is the bottom axis
			// There are also 4 quadrant-like locations (left to right instead of clockwise) reserved for chart overlays
			// These locations are single-box locations only, when trying to register a chartArea location that is already taken,
			// an error will be thrown.
			//
			// |----------------------------------------------------|
			// |                  T1 (Full Width)                   |
			// |----------------------------------------------------|
			// |    |    |                 T2                  |    |
			// |    |----|-------------------------------------|----|
			// |    |    | C1 |                           | C2 |    |
			// |    |    |----|                           |----|    |
			// |    |    |                                     |    |
			// | L1 | L2 |           ChartArea (C0)            | R1 |
			// |    |    |                                     |    |
			// |    |    |----|                           |----|    |
			// |    |    | C3 |                           | C4 |    |
			// |    |----|-------------------------------------|----|
			// |    |    |                 B1                  |    |
			// |----------------------------------------------------|
			// |                  B2 (Full Width)                   |
			// |----------------------------------------------------|
			//
	
			var params = Object.freeze({
				outerWidth: width,
				outerHeight: height,
				padding: padding,
				availableWidth: availableWidth,
				vBoxMaxWidth: availableWidth / 2 / verticalBoxes.length,
				hBoxMaxHeight: availableHeight / 2
			});
			var chartArea = extend({
				maxPadding: extend({}, padding),
				w: availableWidth,
				h: availableHeight,
				x: padding.left,
				y: padding.top
			}, padding);
	
			setLayoutDims(verticalBoxes.concat(horizontalBoxes), params);
	
			// First fit vertical boxes
			fitBoxes(verticalBoxes, chartArea, params);
	
			// Then fit horizontal boxes
			if (fitBoxes(horizontalBoxes, chartArea, params)) {
				// if the area changed, re-fit vertical boxes
				fitBoxes(verticalBoxes, chartArea, params);
			}
	
			handleMaxPadding(chartArea);
	
			// Finally place the boxes to correct coordinates
			placeBoxes(boxes.leftAndTop, chartArea, params);
	
			// Move to opposite side of chart
			chartArea.x += chartArea.w;
			chartArea.y += chartArea.h;
	
			placeBoxes(boxes.rightAndBottom, chartArea, params);
	
			chart.chartArea = {
				left: chartArea.left,
				top: chartArea.top,
				right: chartArea.left + chartArea.w,
				bottom: chartArea.top + chartArea.h
			};
	
			// Finally update boxes in chartArea (radial scale for example)
			helpers$1.each(boxes.chartArea, function(layout) {
				var box = layout.box;
				extend(box, chart.chartArea);
				box.update(chartArea.w, chartArea.h);
			});
		}
	};
	
	/**
	 * Platform fallback implementation (minimal).
	 * @see https://github.com/chartjs/Chart.js/pull/4591#issuecomment-319575939
	 */
	
	var platform_basic = {
		acquireContext: function(item) {
			if (item && item.canvas) {
				// Support for any object associated to a canvas (including a context2d)
				item = item.canvas;
			}
	
			return item && item.getContext('2d') || null;
		}
	};
	
	var platform_dom = "/*\r\n * DOM element rendering detection\r\n * https://davidwalsh.name/detect-node-insertion\r\n */\r\n@keyframes chartjs-render-animation {\r\n\tfrom { opacity: 0.99; }\r\n\tto { opacity: 1; }\r\n}\r\n\r\n.chartjs-render-monitor {\r\n\tanimation: chartjs-render-animation 0.001s;\r\n}\r\n\r\n/*\r\n * DOM element resizing detection\r\n * https://github.com/marcj/css-element-queries\r\n */\r\n.chartjs-size-monitor,\r\n.chartjs-size-monitor-expand,\r\n.chartjs-size-monitor-shrink {\r\n\tposition: absolute;\r\n\tdirection: ltr;\r\n\tleft: 0;\r\n\ttop: 0;\r\n\tright: 0;\r\n\tbottom: 0;\r\n\toverflow: hidden;\r\n\tpointer-events: none;\r\n\tvisibility: hidden;\r\n\tz-index: -1;\r\n}\r\n\r\n.chartjs-size-monitor-expand > div {\r\n\tposition: absolute;\r\n\twidth: 1000000px;\r\n\theight: 1000000px;\r\n\tleft: 0;\r\n\ttop: 0;\r\n}\r\n\r\n.chartjs-size-monitor-shrink > div {\r\n\tposition: absolute;\r\n\twidth: 200%;\r\n\theight: 200%;\r\n\tleft: 0;\r\n\ttop: 0;\r\n}\r\n";
	
	var platform_dom$1 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	'default': platform_dom
	});
	
	var stylesheet = getCjsExportFromNamespace(platform_dom$1);
	
	var EXPANDO_KEY = '$chartjs';
	var CSS_PREFIX = 'chartjs-';
	var CSS_SIZE_MONITOR = CSS_PREFIX + 'size-monitor';
	var CSS_RENDER_MONITOR = CSS_PREFIX + 'render-monitor';
	var CSS_RENDER_ANIMATION = CSS_PREFIX + 'render-animation';
	var ANIMATION_START_EVENTS = ['animationstart', 'webkitAnimationStart'];
	
	/**
	 * DOM event types -> Chart.js event types.
	 * Note: only events with different types are mapped.
	 * @see https://developer.mozilla.org/en-US/docs/Web/Events
	 */
	var EVENT_TYPES = {
		touchstart: 'mousedown',
		touchmove: 'mousemove',
		touchend: 'mouseup',
		pointerenter: 'mouseenter',
		pointerdown: 'mousedown',
		pointermove: 'mousemove',
		pointerup: 'mouseup',
		pointerleave: 'mouseout',
		pointerout: 'mouseout'
	};
	
	/**
	 * The "used" size is the final value of a dimension property after all calculations have
	 * been performed. This method uses the computed style of `element` but returns undefined
	 * if the computed style is not expressed in pixels. That can happen in some cases where
	 * `element` has a size relative to its parent and this last one is not yet displayed,
	 * for example because of `display: none` on a parent node.
	 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/used_value
	 * @returns {number} Size in pixels or undefined if unknown.
	 */
	function readUsedSize(element, property) {
		var value = helpers$1.getStyle(element, property);
		var matches = value && value.match(/^(\d+)(\.\d+)?px$/);
		return matches ? Number(matches[1]) : undefined;
	}
	
	/**
	 * Initializes the canvas style and render size without modifying the canvas display size,
	 * since responsiveness is handled by the controller.resize() method. The config is used
	 * to determine the aspect ratio to apply in case no explicit height has been specified.
	 */
	function initCanvas(canvas, config) {
		var style = canvas.style;
	
		// NOTE(SB) canvas.getAttribute('width') !== canvas.width: in the first case it
		// returns null or '' if no explicit value has been set to the canvas attribute.
		var renderHeight = canvas.getAttribute('height');
		var renderWidth = canvas.getAttribute('width');
	
		// Chart.js modifies some canvas values that we want to restore on destroy
		canvas[EXPANDO_KEY] = {
			initial: {
				height: renderHeight,
				width: renderWidth,
				style: {
					display: style.display,
					height: style.height,
					width: style.width
				}
			}
		};
	
		// Force canvas to display as block to avoid extra space caused by inline
		// elements, which would interfere with the responsive resize process.
		// https://github.com/chartjs/Chart.js/issues/2538
		style.display = style.display || 'block';
	
		if (renderWidth === null || renderWidth === '') {
			var displayWidth = readUsedSize(canvas, 'width');
			if (displayWidth !== undefined) {
				canvas.width = displayWidth;
			}
		}
	
		if (renderHeight === null || renderHeight === '') {
			if (canvas.style.height === '') {
				// If no explicit render height and style height, let's apply the aspect ratio,
				// which one can be specified by the user but also by charts as default option
				// (i.e. options.aspectRatio). If not specified, use canvas aspect ratio of 2.
				canvas.height = canvas.width / (config.options.aspectRatio || 2);
			} else {
				var displayHeight = readUsedSize(canvas, 'height');
				if (displayWidth !== undefined) {
					canvas.height = displayHeight;
				}
			}
		}
	
		return canvas;
	}
	
	/**
	 * Detects support for options object argument in addEventListener.
	 * https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
	 * @private
	 */
	var supportsEventListenerOptions = (function() {
		var supports = false;
		try {
			var options = Object.defineProperty({}, 'passive', {
				// eslint-disable-next-line getter-return
				get: function() {
					supports = true;
				}
			});
			window.addEventListener('e', null, options);
		} catch (e) {
			// continue regardless of error
		}
		return supports;
	}());
	
	// Default passive to true as expected by Chrome for 'touchstart' and 'touchend' events.
	// https://github.com/chartjs/Chart.js/issues/4287
	var eventListenerOptions = supportsEventListenerOptions ? {passive: true} : false;
	
	function addListener(node, type, listener) {
		node.addEventListener(type, listener, eventListenerOptions);
	}
	
	function removeListener(node, type, listener) {
		node.removeEventListener(type, listener, eventListenerOptions);
	}
	
	function createEvent(type, chart, x, y, nativeEvent) {
		return {
			type: type,
			chart: chart,
			native: nativeEvent || null,
			x: x !== undefined ? x : null,
			y: y !== undefined ? y : null,
		};
	}
	
	function fromNativeEvent(event, chart) {
		var type = EVENT_TYPES[event.type] || event.type;
		var pos = helpers$1.getRelativePosition(event, chart);
		return createEvent(type, chart, pos.x, pos.y, event);
	}
	
	function throttled(fn, thisArg) {
		var ticking = false;
		var args = [];
	
		return function() {
			args = Array.prototype.slice.call(arguments);
			thisArg = thisArg || this;
	
			if (!ticking) {
				ticking = true;
				helpers$1.requestAnimFrame.call(window, function() {
					ticking = false;
					fn.apply(thisArg, args);
				});
			}
		};
	}
	
	function createDiv(cls) {
		var el = document.createElement('div');
		el.className = cls || '';
		return el;
	}
	
	// Implementation based on https://github.com/marcj/css-element-queries
	function createResizer(handler) {
		var maxSize = 1000000;
	
		// NOTE(SB) Don't use innerHTML because it could be considered unsafe.
		// https://github.com/chartjs/Chart.js/issues/5902
		var resizer = createDiv(CSS_SIZE_MONITOR);
		var expand = createDiv(CSS_SIZE_MONITOR + '-expand');
		var shrink = createDiv(CSS_SIZE_MONITOR + '-shrink');
	
		expand.appendChild(createDiv());
		shrink.appendChild(createDiv());
	
		resizer.appendChild(expand);
		resizer.appendChild(shrink);
		resizer._reset = function() {
			expand.scrollLeft = maxSize;
			expand.scrollTop = maxSize;
			shrink.scrollLeft = maxSize;
			shrink.scrollTop = maxSize;
		};
	
		var onScroll = function() {
			resizer._reset();
			handler();
		};
	
		addListener(expand, 'scroll', onScroll.bind(expand, 'expand'));
		addListener(shrink, 'scroll', onScroll.bind(shrink, 'shrink'));
	
		return resizer;
	}
	
	// https://davidwalsh.name/detect-node-insertion
	function watchForRender(node, handler) {
		var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});
		var proxy = expando.renderProxy = function(e) {
			if (e.animationName === CSS_RENDER_ANIMATION) {
				handler();
			}
		};
	
		helpers$1.each(ANIMATION_START_EVENTS, function(type) {
			addListener(node, type, proxy);
		});
	
		// #4737: Chrome might skip the CSS animation when the CSS_RENDER_MONITOR class
		// is removed then added back immediately (same animation frame?). Accessing the
		// `offsetParent` property will force a reflow and re-evaluate the CSS animation.
		// https://gist.github.com/paulirish/5d52fb081b3570c81e3a#box-metrics
		// https://github.com/chartjs/Chart.js/issues/4737
		expando.reflow = !!node.offsetParent;
	
		node.classList.add(CSS_RENDER_MONITOR);
	}
	
	function unwatchForRender(node) {
		var expando = node[EXPANDO_KEY] || {};
		var proxy = expando.renderProxy;
	
		if (proxy) {
			helpers$1.each(ANIMATION_START_EVENTS, function(type) {
				removeListener(node, type, proxy);
			});
	
			delete expando.renderProxy;
		}
	
		node.classList.remove(CSS_RENDER_MONITOR);
	}
	
	function addResizeListener(node, listener, chart) {
		var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});
	
		// Let's keep track of this added resizer and thus avoid DOM query when removing it.
		var resizer = expando.resizer = createResizer(throttled(function() {
			if (expando.resizer) {
				var container = chart.options.maintainAspectRatio && node.parentNode;
				var w = container ? container.clientWidth : 0;
				listener(createEvent('resize', chart));
				if (container && container.clientWidth < w && chart.canvas) {
					// If the container size shrank during chart resize, let's assume
					// scrollbar appeared. So we resize again with the scrollbar visible -
					// effectively making chart smaller and the scrollbar hidden again.
					// Because we are inside `throttled`, and currently `ticking`, scroll
					// events are ignored during this whole 2 resize process.
					// If we assumed wrong and something else happened, we are resizing
					// twice in a frame (potential performance issue)
					listener(createEvent('resize', chart));
				}
			}
		}));
	
		// The resizer needs to be attached to the node parent, so we first need to be
		// sure that `node` is attached to the DOM before injecting the resizer element.
		watchForRender(node, function() {
			if (expando.resizer) {
				var container = node.parentNode;
				if (container && container !== resizer.parentNode) {
					container.insertBefore(resizer, container.firstChild);
				}
	
				// The container size might have changed, let's reset the resizer state.
				resizer._reset();
			}
		});
	}
	
	function removeResizeListener(node) {
		var expando = node[EXPANDO_KEY] || {};
		var resizer = expando.resizer;
	
		delete expando.resizer;
		unwatchForRender(node);
	
		if (resizer && resizer.parentNode) {
			resizer.parentNode.removeChild(resizer);
		}
	}
	
	/**
	 * Injects CSS styles inline if the styles are not already present.
	 * @param {HTMLDocument|ShadowRoot} rootNode - the node to contain the <style>.
	 * @param {string} css - the CSS to be injected.
	 */
	function injectCSS(rootNode, css) {
		// https://stackoverflow.com/q/3922139
		var expando = rootNode[EXPANDO_KEY] || (rootNode[EXPANDO_KEY] = {});
		if (!expando.containsStyles) {
			expando.containsStyles = true;
			css = '/* Chart.js */\n' + css;
			var style = document.createElement('style');
			style.setAttribute('type', 'text/css');
			style.appendChild(document.createTextNode(css));
			rootNode.appendChild(style);
		}
	}
	
	var platform_dom$2 = {
		/**
		 * When `true`, prevents the automatic injection of the stylesheet required to
		 * correctly detect when the chart is added to the DOM and then resized. This
		 * switch has been added to allow external stylesheet (`dist/Chart(.min)?.js`)
		 * to be manually imported to make this library compatible with any CSP.
		 * See https://github.com/chartjs/Chart.js/issues/5208
		 */
		disableCSSInjection: false,
	
		/**
		 * This property holds whether this platform is enabled for the current environment.
		 * Currently used by platform.js to select the proper implementation.
		 * @private
		 */
		_enabled: typeof window !== 'undefined' && typeof document !== 'undefined',
	
		/**
		 * Initializes resources that depend on platform options.
		 * @param {HTMLCanvasElement} canvas - The Canvas element.
		 * @private
		 */
		_ensureLoaded: function(canvas) {
			if (!this.disableCSSInjection) {
				// If the canvas is in a shadow DOM, then the styles must also be inserted
				// into the same shadow DOM.
				// https://github.com/chartjs/Chart.js/issues/5763
				var root = canvas.getRootNode ? canvas.getRootNode() : document;
				var targetNode = root.host ? root : document.head;
				injectCSS(targetNode, stylesheet);
			}
		},
	
		acquireContext: function(item, config) {
			if (typeof item === 'string') {
				item = document.getElementById(item);
			} else if (item.length) {
				// Support for array based queries (such as jQuery)
				item = item[0];
			}
	
			if (item && item.canvas) {
				// Support for any object associated to a canvas (including a context2d)
				item = item.canvas;
			}
	
			// To prevent canvas fingerprinting, some add-ons undefine the getContext
			// method, for example: https://github.com/kkapsner/CanvasBlocker
			// https://github.com/chartjs/Chart.js/issues/2807
			var context = item && item.getContext && item.getContext('2d');
	
			// `instanceof HTMLCanvasElement/CanvasRenderingContext2D` fails when the item is
			// inside an iframe or when running in a protected environment. We could guess the
			// types from their toString() value but let's keep things flexible and assume it's
			// a sufficient condition if the item has a context2D which has item as `canvas`.
			// https://github.com/chartjs/Chart.js/issues/3887
			// https://github.com/chartjs/Chart.js/issues/4102
			// https://github.com/chartjs/Chart.js/issues/4152
			if (context && context.canvas === item) {
				// Load platform resources on first chart creation, to make it possible to
				// import the library before setting platform options.
				this._ensureLoaded(item);
				initCanvas(item, config);
				return context;
			}
	
			return null;
		},
	
		releaseContext: function(context) {
			var canvas = context.canvas;
			if (!canvas[EXPANDO_KEY]) {
				return;
			}
	
			var initial = canvas[EXPANDO_KEY].initial;
			['height', 'width'].forEach(function(prop) {
				var value = initial[prop];
				if (helpers$1.isNullOrUndef(value)) {
					canvas.removeAttribute(prop);
				} else {
					canvas.setAttribute(prop, value);
				}
			});
	
			helpers$1.each(initial.style || {}, function(value, key) {
				canvas.style[key] = value;
			});
	
			// The canvas render size might have been changed (and thus the state stack discarded),
			// we can't use save() and restore() to restore the initial state. So make sure that at
			// least the canvas context is reset to the default state by setting the canvas width.
			// https://www.w3.org/TR/2011/WD-html5-20110525/the-canvas-element.html
			// eslint-disable-next-line no-self-assign
			canvas.width = canvas.width;
	
			delete canvas[EXPANDO_KEY];
		},
	
		addEventListener: function(chart, type, listener) {
			var canvas = chart.canvas;
			if (type === 'resize') {
				// Note: the resize event is not supported on all browsers.
				addResizeListener(canvas, listener, chart);
				return;
			}
	
			var expando = listener[EXPANDO_KEY] || (listener[EXPANDO_KEY] = {});
			var proxies = expando.proxies || (expando.proxies = {});
			var proxy = proxies[chart.id + '_' + type] = function(event) {
				listener(fromNativeEvent(event, chart));
			};
	
			addListener(canvas, type, proxy);
		},
	
		removeEventListener: function(chart, type, listener) {
			var canvas = chart.canvas;
			if (type === 'resize') {
				// Note: the resize event is not supported on all browsers.
				removeResizeListener(canvas);
				return;
			}
	
			var expando = listener[EXPANDO_KEY] || {};
			var proxies = expando.proxies || {};
			var proxy = proxies[chart.id + '_' + type];
			if (!proxy) {
				return;
			}
	
			removeListener(canvas, type, proxy);
		}
	};
	
	// DEPRECATIONS
	
	/**
	 * Provided for backward compatibility, use EventTarget.addEventListener instead.
	 * EventTarget.addEventListener compatibility: Chrome, Opera 7, Safari, FF1.5+, IE9+
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener
	 * @function Chart.helpers.addEvent
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers$1.addEvent = addListener;
	
	/**
	 * Provided for backward compatibility, use EventTarget.removeEventListener instead.
	 * EventTarget.removeEventListener compatibility: Chrome, Opera 7, Safari, FF1.5+, IE9+
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/removeEventListener
	 * @function Chart.helpers.removeEvent
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers$1.removeEvent = removeListener;
	
	// @TODO Make possible to select another platform at build time.
	var implementation = platform_dom$2._enabled ? platform_dom$2 : platform_basic;
	
	/**
	 * @namespace Chart.platform
	 * @see https://chartjs.gitbooks.io/proposals/content/Platform.html
	 * @since 2.4.0
	 */
	var platform = helpers$1.extend({
		/**
		 * @since 2.7.0
		 */
		initialize: function() {},
	
		/**
		 * Called at chart construction time, returns a context2d instance implementing
		 * the [W3C Canvas 2D Context API standard]{@link https://www.w3.org/TR/2dcontext/}.
		 * @param {*} item - The native item from which to acquire context (platform specific)
		 * @param {object} options - The chart options
		 * @returns {CanvasRenderingContext2D} context2d instance
		 */
		acquireContext: function() {},
	
		/**
		 * Called at chart destruction time, releases any resources associated to the context
		 * previously returned by the acquireContext() method.
		 * @param {CanvasRenderingContext2D} context - The context2d instance
		 * @returns {boolean} true if the method succeeded, else false
		 */
		releaseContext: function() {},
	
		/**
		 * Registers the specified listener on the given chart.
		 * @param {Chart} chart - Chart from which to listen for event
		 * @param {string} type - The ({@link IEvent}) type to listen for
		 * @param {function} listener - Receives a notification (an object that implements
		 * the {@link IEvent} interface) when an event of the specified type occurs.
		 */
		addEventListener: function() {},
	
		/**
		 * Removes the specified listener previously registered with addEventListener.
		 * @param {Chart} chart - Chart from which to remove the listener
		 * @param {string} type - The ({@link IEvent}) type to remove
		 * @param {function} listener - The listener function to remove from the event target.
		 */
		removeEventListener: function() {}
	
	}, implementation);
	
	core_defaults._set('global', {
		plugins: {}
	});
	
	/**
	 * The plugin service singleton
	 * @namespace Chart.plugins
	 * @since 2.1.0
	 */
	var core_plugins = {
		/**
		 * Globally registered plugins.
		 * @private
		 */
		_plugins: [],
	
		/**
		 * This identifier is used to invalidate the descriptors cache attached to each chart
		 * when a global plugin is registered or unregistered. In this case, the cache ID is
		 * incremented and descriptors are regenerated during following API calls.
		 * @private
		 */
		_cacheId: 0,
	
		/**
		 * Registers the given plugin(s) if not already registered.
		 * @param {IPlugin[]|IPlugin} plugins plugin instance(s).
		 */
		register: function(plugins) {
			var p = this._plugins;
			([]).concat(plugins).forEach(function(plugin) {
				if (p.indexOf(plugin) === -1) {
					p.push(plugin);
				}
			});
	
			this._cacheId++;
		},
	
		/**
		 * Unregisters the given plugin(s) only if registered.
		 * @param {IPlugin[]|IPlugin} plugins plugin instance(s).
		 */
		unregister: function(plugins) {
			var p = this._plugins;
			([]).concat(plugins).forEach(function(plugin) {
				var idx = p.indexOf(plugin);
				if (idx !== -1) {
					p.splice(idx, 1);
				}
			});
	
			this._cacheId++;
		},
	
		/**
		 * Remove all registered plugins.
		 * @since 2.1.5
		 */
		clear: function() {
			this._plugins = [];
			this._cacheId++;
		},
	
		/**
		 * Returns the number of registered plugins?
		 * @returns {number}
		 * @since 2.1.5
		 */
		count: function() {
			return this._plugins.length;
		},
	
		/**
		 * Returns all registered plugin instances.
		 * @returns {IPlugin[]} array of plugin objects.
		 * @since 2.1.5
		 */
		getAll: function() {
			return this._plugins;
		},
	
		/**
		 * Calls enabled plugins for `chart` on the specified hook and with the given args.
		 * This method immediately returns as soon as a plugin explicitly returns false. The
		 * returned value can be used, for instance, to interrupt the current action.
		 * @param {Chart} chart - The chart instance for which plugins should be called.
		 * @param {string} hook - The name of the plugin method to call (e.g. 'beforeUpdate').
		 * @param {Array} [args] - Extra arguments to apply to the hook call.
		 * @returns {boolean} false if any of the plugins return false, else returns true.
		 */
		notify: function(chart, hook, args) {
			var descriptors = this.descriptors(chart);
			var ilen = descriptors.length;
			var i, descriptor, plugin, params, method;
	
			for (i = 0; i < ilen; ++i) {
				descriptor = descriptors[i];
				plugin = descriptor.plugin;
				method = plugin[hook];
				if (typeof method === 'function') {
					params = [chart].concat(args || []);
					params.push(descriptor.options);
					if (method.apply(plugin, params) === false) {
						return false;
					}
				}
			}
	
			return true;
		},
	
		/**
		 * Returns descriptors of enabled plugins for the given chart.
		 * @returns {object[]} [{ plugin, options }]
		 * @private
		 */
		descriptors: function(chart) {
			var cache = chart.$plugins || (chart.$plugins = {});
			if (cache.id === this._cacheId) {
				return cache.descriptors;
			}
	
			var plugins = [];
			var descriptors = [];
			var config = (chart && chart.config) || {};
			var options = (config.options && config.options.plugins) || {};
	
			this._plugins.concat(config.plugins || []).forEach(function(plugin) {
				var idx = plugins.indexOf(plugin);
				if (idx !== -1) {
					return;
				}
	
				var id = plugin.id;
				var opts = options[id];
				if (opts === false) {
					return;
				}
	
				if (opts === true) {
					opts = helpers$1.clone(core_defaults.global.plugins[id]);
				}
	
				plugins.push(plugin);
				descriptors.push({
					plugin: plugin,
					options: opts || {}
				});
			});
	
			cache.descriptors = descriptors;
			cache.id = this._cacheId;
			return descriptors;
		},
	
		/**
		 * Invalidates cache for the given chart: descriptors hold a reference on plugin option,
		 * but in some cases, this reference can be changed by the user when updating options.
		 * https://github.com/chartjs/Chart.js/issues/5111#issuecomment-355934167
		 * @private
		 */
		_invalidate: function(chart) {
			delete chart.$plugins;
		}
	};
	
	var core_scaleService = {
		// Scale registration object. Extensions can register new scale types (such as log or DB scales) and then
		// use the new chart options to grab the correct scale
		constructors: {},
		// Use a registration function so that we can move to an ES6 map when we no longer need to support
		// old browsers
	
		// Scale config defaults
		defaults: {},
		registerScaleType: function(type, scaleConstructor, scaleDefaults) {
			this.constructors[type] = scaleConstructor;
			this.defaults[type] = helpers$1.clone(scaleDefaults);
		},
		getScaleConstructor: function(type) {
			return this.constructors.hasOwnProperty(type) ? this.constructors[type] : undefined;
		},
		getScaleDefaults: function(type) {
			// Return the scale defaults merged with the global settings so that we always use the latest ones
			return this.defaults.hasOwnProperty(type) ? helpers$1.merge(Object.create(null), [core_defaults.scale, this.defaults[type]]) : {};
		},
		updateScaleDefaults: function(type, additions) {
			var me = this;
			if (me.defaults.hasOwnProperty(type)) {
				me.defaults[type] = helpers$1.extend(me.defaults[type], additions);
			}
		},
		addScalesToLayout: function(chart) {
			// Adds each scale to the chart.boxes array to be sized accordingly
			helpers$1.each(chart.scales, function(scale) {
				// Set ILayoutItem parameters for backwards compatibility
				scale.fullWidth = scale.options.fullWidth;
				scale.position = scale.options.position;
				scale.weight = scale.options.weight;
				core_layouts.addBox(chart, scale);
			});
		}
	};
	
	var valueOrDefault$8 = helpers$1.valueOrDefault;
	var getRtlHelper = helpers$1.rtl.getRtlAdapter;
	
	core_defaults._set('global', {
		tooltips: {
			enabled: true,
			custom: null,
			mode: 'nearest',
			position: 'average',
			intersect: true,
			backgroundColor: 'rgba(0,0,0,0.8)',
			titleFontStyle: 'bold',
			titleSpacing: 2,
			titleMarginBottom: 6,
			titleFontColor: '#fff',
			titleAlign: 'left',
			bodySpacing: 2,
			bodyFontColor: '#fff',
			bodyAlign: 'left',
			footerFontStyle: 'bold',
			footerSpacing: 2,
			footerMarginTop: 6,
			footerFontColor: '#fff',
			footerAlign: 'left',
			yPadding: 6,
			xPadding: 6,
			caretPadding: 2,
			caretSize: 5,
			cornerRadius: 6,
			multiKeyBackground: '#fff',
			displayColors: true,
			borderColor: 'rgba(0,0,0,0)',
			borderWidth: 0,
			callbacks: {
				// Args are: (tooltipItems, data)
				beforeTitle: helpers$1.noop,
				title: function(tooltipItems, data) {
					var title = '';
					var labels = data.labels;
					var labelCount = labels ? labels.length : 0;
	
					if (tooltipItems.length > 0) {
						var item = tooltipItems[0];
						if (item.label) {
							title = item.label;
						} else if (item.xLabel) {
							title = item.xLabel;
						} else if (labelCount > 0 && item.index < labelCount) {
							title = labels[item.index];
						}
					}
	
					return title;
				},
				afterTitle: helpers$1.noop,
	
				// Args are: (tooltipItems, data)
				beforeBody: helpers$1.noop,
	
				// Args are: (tooltipItem, data)
				beforeLabel: helpers$1.noop,
				label: function(tooltipItem, data) {
					var label = data.datasets[tooltipItem.datasetIndex].label || '';
	
					if (label) {
						label += ': ';
					}
					if (!helpers$1.isNullOrUndef(tooltipItem.value)) {
						label += tooltipItem.value;
					} else {
						label += tooltipItem.yLabel;
					}
					return label;
				},
				labelColor: function(tooltipItem, chart) {
					var meta = chart.getDatasetMeta(tooltipItem.datasetIndex);
					var activeElement = meta.data[tooltipItem.index];
					var view = activeElement._view;
					return {
						borderColor: view.borderColor,
						backgroundColor: view.backgroundColor
					};
				},
				labelTextColor: function() {
					return this._options.bodyFontColor;
				},
				afterLabel: helpers$1.noop,
	
				// Args are: (tooltipItems, data)
				afterBody: helpers$1.noop,
	
				// Args are: (tooltipItems, data)
				beforeFooter: helpers$1.noop,
				footer: helpers$1.noop,
				afterFooter: helpers$1.noop
			}
		}
	});
	
	var positioners = {
		/**
		 * Average mode places the tooltip at the average position of the elements shown
		 * @function Chart.Tooltip.positioners.average
		 * @param elements {ChartElement[]} the elements being displayed in the tooltip
		 * @returns {object} tooltip position
		 */
		average: function(elements) {
			if (!elements.length) {
				return false;
			}
	
			var i, len;
			var x = 0;
			var y = 0;
			var count = 0;
	
			for (i = 0, len = elements.length; i < len; ++i) {
				var el = elements[i];
				if (el && el.hasValue()) {
					var pos = el.tooltipPosition();
					x += pos.x;
					y += pos.y;
					++count;
				}
			}
	
			return {
				x: x / count,
				y: y / count
			};
		},
	
		/**
		 * Gets the tooltip position nearest of the item nearest to the event position
		 * @function Chart.Tooltip.positioners.nearest
		 * @param elements {Chart.Element[]} the tooltip elements
		 * @param eventPosition {object} the position of the event in canvas coordinates
		 * @returns {object} the tooltip position
		 */
		nearest: function(elements, eventPosition) {
			var x = eventPosition.x;
			var y = eventPosition.y;
			var minDistance = Number.POSITIVE_INFINITY;
			var i, len, nearestElement;
	
			for (i = 0, len = elements.length; i < len; ++i) {
				var el = elements[i];
				if (el && el.hasValue()) {
					var center = el.getCenterPoint();
					var d = helpers$1.distanceBetweenPoints(eventPosition, center);
	
					if (d < minDistance) {
						minDistance = d;
						nearestElement = el;
					}
				}
			}
	
			if (nearestElement) {
				var tp = nearestElement.tooltipPosition();
				x = tp.x;
				y = tp.y;
			}
	
			return {
				x: x,
				y: y
			};
		}
	};
	
	// Helper to push or concat based on if the 2nd parameter is an array or not
	function pushOrConcat(base, toPush) {
		if (toPush) {
			if (helpers$1.isArray(toPush)) {
				// base = base.concat(toPush);
				Array.prototype.push.apply(base, toPush);
			} else {
				base.push(toPush);
			}
		}
	
		return base;
	}
	
	/**
	 * Returns array of strings split by newline
	 * @param {string} value - The value to split by newline.
	 * @returns {string[]} value if newline present - Returned from String split() method
	 * @function
	 */
	function splitNewlines(str) {
		if ((typeof str === 'string' || str instanceof String) && str.indexOf('\n') > -1) {
			return str.split('\n');
		}
		return str;
	}
	
	
	/**
	 * Private helper to create a tooltip item model
	 * @param element - the chart element (point, arc, bar) to create the tooltip item for
	 * @return new tooltip item
	 */
	function createTooltipItem(element) {
		var xScale = element._xScale;
		var yScale = element._yScale || element._scale; // handle radar || polarArea charts
		var index = element._index;
		var datasetIndex = element._datasetIndex;
		var controller = element._chart.getDatasetMeta(datasetIndex).controller;
		var indexScale = controller._getIndexScale();
		var valueScale = controller._getValueScale();
	
		return {
			xLabel: xScale ? xScale.getLabelForIndex(index, datasetIndex) : '',
			yLabel: yScale ? yScale.getLabelForIndex(index, datasetIndex) : '',
			label: indexScale ? '' + indexScale.getLabelForIndex(index, datasetIndex) : '',
			value: valueScale ? '' + valueScale.getLabelForIndex(index, datasetIndex) : '',
			index: index,
			datasetIndex: datasetIndex,
			x: element._model.x,
			y: element._model.y
		};
	}
	
	/**
	 * Helper to get the reset model for the tooltip
	 * @param tooltipOpts {object} the tooltip options
	 */
	function getBaseModel(tooltipOpts) {
		var globalDefaults = core_defaults.global;
	
		return {
			// Positioning
			xPadding: tooltipOpts.xPadding,
			yPadding: tooltipOpts.yPadding,
			xAlign: tooltipOpts.xAlign,
			yAlign: tooltipOpts.yAlign,
	
			// Drawing direction and text direction
			rtl: tooltipOpts.rtl,
			textDirection: tooltipOpts.textDirection,
	
			// Body
			bodyFontColor: tooltipOpts.bodyFontColor,
			_bodyFontFamily: valueOrDefault$8(tooltipOpts.bodyFontFamily, globalDefaults.defaultFontFamily),
			_bodyFontStyle: valueOrDefault$8(tooltipOpts.bodyFontStyle, globalDefaults.defaultFontStyle),
			_bodyAlign: tooltipOpts.bodyAlign,
			bodyFontSize: valueOrDefault$8(tooltipOpts.bodyFontSize, globalDefaults.defaultFontSize),
			bodySpacing: tooltipOpts.bodySpacing,
	
			// Title
			titleFontColor: tooltipOpts.titleFontColor,
			_titleFontFamily: valueOrDefault$8(tooltipOpts.titleFontFamily, globalDefaults.defaultFontFamily),
			_titleFontStyle: valueOrDefault$8(tooltipOpts.titleFontStyle, globalDefaults.defaultFontStyle),
			titleFontSize: valueOrDefault$8(tooltipOpts.titleFontSize, globalDefaults.defaultFontSize),
			_titleAlign: tooltipOpts.titleAlign,
			titleSpacing: tooltipOpts.titleSpacing,
			titleMarginBottom: tooltipOpts.titleMarginBottom,
	
			// Footer
			footerFontColor: tooltipOpts.footerFontColor,
			_footerFontFamily: valueOrDefault$8(tooltipOpts.footerFontFamily, globalDefaults.defaultFontFamily),
			_footerFontStyle: valueOrDefault$8(tooltipOpts.footerFontStyle, globalDefaults.defaultFontStyle),
			footerFontSize: valueOrDefault$8(tooltipOpts.footerFontSize, globalDefaults.defaultFontSize),
			_footerAlign: tooltipOpts.footerAlign,
			footerSpacing: tooltipOpts.footerSpacing,
			footerMarginTop: tooltipOpts.footerMarginTop,
	
			// Appearance
			caretSize: tooltipOpts.caretSize,
			cornerRadius: tooltipOpts.cornerRadius,
			backgroundColor: tooltipOpts.backgroundColor,
			opacity: 0,
			legendColorBackground: tooltipOpts.multiKeyBackground,
			displayColors: tooltipOpts.displayColors,
			borderColor: tooltipOpts.borderColor,
			borderWidth: tooltipOpts.borderWidth
		};
	}
	
	/**
	 * Get the size of the tooltip
	 */
	function getTooltipSize(tooltip, model) {
		var ctx = tooltip._chart.ctx;
	
		var height = model.yPadding * 2; // Tooltip Padding
		var width = 0;
	
		// Count of all lines in the body
		var body = model.body;
		var combinedBodyLength = body.reduce(function(count, bodyItem) {
			return count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length;
		}, 0);
		combinedBodyLength += model.beforeBody.length + model.afterBody.length;
	
		var titleLineCount = model.title.length;
		var footerLineCount = model.footer.length;
		var titleFontSize = model.titleFontSize;
		var bodyFontSize = model.bodyFontSize;
		var footerFontSize = model.footerFontSize;
	
		height += titleLineCount * titleFontSize; // Title Lines
		height += titleLineCount ? (titleLineCount - 1) * model.titleSpacing : 0; // Title Line Spacing
		height += titleLineCount ? model.titleMarginBottom : 0; // Title's bottom Margin
		height += combinedBodyLength * bodyFontSize; // Body Lines
		height += combinedBodyLength ? (combinedBodyLength - 1) * model.bodySpacing : 0; // Body Line Spacing
		height += footerLineCount ? model.footerMarginTop : 0; // Footer Margin
		height += footerLineCount * (footerFontSize); // Footer Lines
		height += footerLineCount ? (footerLineCount - 1) * model.footerSpacing : 0; // Footer Line Spacing
	
		// Title width
		var widthPadding = 0;
		var maxLineWidth = function(line) {
			width = Math.max(width, ctx.measureText(line).width + widthPadding);
		};
	
		ctx.font = helpers$1.fontString(titleFontSize, model._titleFontStyle, model._titleFontFamily);
		helpers$1.each(model.title, maxLineWidth);
	
		// Body width
		ctx.font = helpers$1.fontString(bodyFontSize, model._bodyFontStyle, model._bodyFontFamily);
		helpers$1.each(model.beforeBody.concat(model.afterBody), maxLineWidth);
	
		// Body lines may include some extra width due to the color box
		widthPadding = model.displayColors ? (bodyFontSize + 2) : 0;
		helpers$1.each(body, function(bodyItem) {
			helpers$1.each(bodyItem.before, maxLineWidth);
			helpers$1.each(bodyItem.lines, maxLineWidth);
			helpers$1.each(bodyItem.after, maxLineWidth);
		});
	
		// Reset back to 0
		widthPadding = 0;
	
		// Footer width
		ctx.font = helpers$1.fontString(footerFontSize, model._footerFontStyle, model._footerFontFamily);
		helpers$1.each(model.footer, maxLineWidth);
	
		// Add padding
		width += 2 * model.xPadding;
	
		return {
			width: width,
			height: height
		};
	}
	
	/**
	 * Helper to get the alignment of a tooltip given the size
	 */
	function determineAlignment(tooltip, size) {
		var model = tooltip._model;
		var chart = tooltip._chart;
		var chartArea = tooltip._chart.chartArea;
		var xAlign = 'center';
		var yAlign = 'center';
	
		if (model.y < size.height) {
			yAlign = 'top';
		} else if (model.y > (chart.height - size.height)) {
			yAlign = 'bottom';
		}
	
		var lf, rf; // functions to determine left, right alignment
		var olf, orf; // functions to determine if left/right alignment causes tooltip to go outside chart
		var yf; // function to get the y alignment if the tooltip goes outside of the left or right edges
		var midX = (chartArea.left + chartArea.right) / 2;
		var midY = (chartArea.top + chartArea.bottom) / 2;
	
		if (yAlign === 'center') {
			lf = function(x) {
				return x <= midX;
			};
			rf = function(x) {
				return x > midX;
			};
		} else {
			lf = function(x) {
				return x <= (size.width / 2);
			};
			rf = function(x) {
				return x >= (chart.width - (size.width / 2));
			};
		}
	
		olf = function(x) {
			return x + size.width + model.caretSize + model.caretPadding > chart.width;
		};
		orf = function(x) {
			return x - size.width - model.caretSize - model.caretPadding < 0;
		};
		yf = function(y) {
			return y <= midY ? 'top' : 'bottom';
		};
	
		if (lf(model.x)) {
			xAlign = 'left';
	
			// Is tooltip too wide and goes over the right side of the chart.?
			if (olf(model.x)) {
				xAlign = 'center';
				yAlign = yf(model.y);
			}
		} else if (rf(model.x)) {
			xAlign = 'right';
	
			// Is tooltip too wide and goes outside left edge of canvas?
			if (orf(model.x)) {
				xAlign = 'center';
				yAlign = yf(model.y);
			}
		}
	
		var opts = tooltip._options;
		return {
			xAlign: opts.xAlign ? opts.xAlign : xAlign,
			yAlign: opts.yAlign ? opts.yAlign : yAlign
		};
	}
	
	/**
	 * Helper to get the location a tooltip needs to be placed at given the initial position (via the vm) and the size and alignment
	 */
	function getBackgroundPoint(vm, size, alignment, chart) {
		// Background Position
		var x = vm.x;
		var y = vm.y;
	
		var caretSize = vm.caretSize;
		var caretPadding = vm.caretPadding;
		var cornerRadius = vm.cornerRadius;
		var xAlign = alignment.xAlign;
		var yAlign = alignment.yAlign;
		var paddingAndSize = caretSize + caretPadding;
		var radiusAndPadding = cornerRadius + caretPadding;
	
		if (xAlign === 'right') {
			x -= size.width;
		} else if (xAlign === 'center') {
			x -= (size.width / 2);
			if (x + size.width > chart.width) {
				x = chart.width - size.width;
			}
			if (x < 0) {
				x = 0;
			}
		}
	
		if (yAlign === 'top') {
			y += paddingAndSize;
		} else if (yAlign === 'bottom') {
			y -= size.height + paddingAndSize;
		} else {
			y -= (size.height / 2);
		}
	
		if (yAlign === 'center') {
			if (xAlign === 'left') {
				x += paddingAndSize;
			} else if (xAlign === 'right') {
				x -= paddingAndSize;
			}
		} else if (xAlign === 'left') {
			x -= radiusAndPadding;
		} else if (xAlign === 'right') {
			x += radiusAndPadding;
		}
	
		return {
			x: x,
			y: y
		};
	}
	
	function getAlignedX(vm, align) {
		return align === 'center'
			? vm.x + vm.width / 2
			: align === 'right'
				? vm.x + vm.width - vm.xPadding
				: vm.x + vm.xPadding;
	}
	
	/**
	 * Helper to build before and after body lines
	 */
	function getBeforeAfterBodyLines(callback) {
		return pushOrConcat([], splitNewlines(callback));
	}
	
	var exports$4 = core_element.extend({
		initialize: function() {
			this._model = getBaseModel(this._options);
			this._lastActive = [];
		},
	
		// Get the title
		// Args are: (tooltipItem, data)
		getTitle: function() {
			var me = this;
			var opts = me._options;
			var callbacks = opts.callbacks;
	
			var beforeTitle = callbacks.beforeTitle.apply(me, arguments);
			var title = callbacks.title.apply(me, arguments);
			var afterTitle = callbacks.afterTitle.apply(me, arguments);
	
			var lines = [];
			lines = pushOrConcat(lines, splitNewlines(beforeTitle));
			lines = pushOrConcat(lines, splitNewlines(title));
			lines = pushOrConcat(lines, splitNewlines(afterTitle));
	
			return lines;
		},
	
		// Args are: (tooltipItem, data)
		getBeforeBody: function() {
			return getBeforeAfterBodyLines(this._options.callbacks.beforeBody.apply(this, arguments));
		},
	
		// Args are: (tooltipItem, data)
		getBody: function(tooltipItems, data) {
			var me = this;
			var callbacks = me._options.callbacks;
			var bodyItems = [];
	
			helpers$1.each(tooltipItems, function(tooltipItem) {
				var bodyItem = {
					before: [],
					lines: [],
					after: []
				};
				pushOrConcat(bodyItem.before, splitNewlines(callbacks.beforeLabel.call(me, tooltipItem, data)));
				pushOrConcat(bodyItem.lines, callbacks.label.call(me, tooltipItem, data));
				pushOrConcat(bodyItem.after, splitNewlines(callbacks.afterLabel.call(me, tooltipItem, data)));
	
				bodyItems.push(bodyItem);
			});
	
			return bodyItems;
		},
	
		// Args are: (tooltipItem, data)
		getAfterBody: function() {
			return getBeforeAfterBodyLines(this._options.callbacks.afterBody.apply(this, arguments));
		},
	
		// Get the footer and beforeFooter and afterFooter lines
		// Args are: (tooltipItem, data)
		getFooter: function() {
			var me = this;
			var callbacks = me._options.callbacks;
	
			var beforeFooter = callbacks.beforeFooter.apply(me, arguments);
			var footer = callbacks.footer.apply(me, arguments);
			var afterFooter = callbacks.afterFooter.apply(me, arguments);
	
			var lines = [];
			lines = pushOrConcat(lines, splitNewlines(beforeFooter));
			lines = pushOrConcat(lines, splitNewlines(footer));
			lines = pushOrConcat(lines, splitNewlines(afterFooter));
	
			return lines;
		},
	
		update: function(changed) {
			var me = this;
			var opts = me._options;
	
			// Need to regenerate the model because its faster than using extend and it is necessary due to the optimization in Chart.Element.transition
			// that does _view = _model if ease === 1. This causes the 2nd tooltip update to set properties in both the view and model at the same time
			// which breaks any animations.
			var existingModel = me._model;
			var model = me._model = getBaseModel(opts);
			var active = me._active;
	
			var data = me._data;
	
			// In the case where active.length === 0 we need to keep these at existing values for good animations
			var alignment = {
				xAlign: existingModel.xAlign,
				yAlign: existingModel.yAlign
			};
			var backgroundPoint = {
				x: existingModel.x,
				y: existingModel.y
			};
			var tooltipSize = {
				width: existingModel.width,
				height: existingModel.height
			};
			var tooltipPosition = {
				x: existingModel.caretX,
				y: existingModel.caretY
			};
	
			var i, len;
	
			if (active.length) {
				model.opacity = 1;
	
				var labelColors = [];
				var labelTextColors = [];
				tooltipPosition = positioners[opts.position].call(me, active, me._eventPosition);
	
				var tooltipItems = [];
				for (i = 0, len = active.length; i < len; ++i) {
					tooltipItems.push(createTooltipItem(active[i]));
				}
	
				// If the user provided a filter function, use it to modify the tooltip items
				if (opts.filter) {
					tooltipItems = tooltipItems.filter(function(a) {
						return opts.filter(a, data);
					});
				}
	
				// If the user provided a sorting function, use it to modify the tooltip items
				if (opts.itemSort) {
					tooltipItems = tooltipItems.sort(function(a, b) {
						return opts.itemSort(a, b, data);
					});
				}
	
				// Determine colors for boxes
				helpers$1.each(tooltipItems, function(tooltipItem) {
					labelColors.push(opts.callbacks.labelColor.call(me, tooltipItem, me._chart));
					labelTextColors.push(opts.callbacks.labelTextColor.call(me, tooltipItem, me._chart));
				});
	
	
				// Build the Text Lines
				model.title = me.getTitle(tooltipItems, data);
				model.beforeBody = me.getBeforeBody(tooltipItems, data);
				model.body = me.getBody(tooltipItems, data);
				model.afterBody = me.getAfterBody(tooltipItems, data);
				model.footer = me.getFooter(tooltipItems, data);
	
				// Initial positioning and colors
				model.x = tooltipPosition.x;
				model.y = tooltipPosition.y;
				model.caretPadding = opts.caretPadding;
				model.labelColors = labelColors;
				model.labelTextColors = labelTextColors;
	
				// data points
				model.dataPoints = tooltipItems;
	
				// We need to determine alignment of the tooltip
				tooltipSize = getTooltipSize(this, model);
				alignment = determineAlignment(this, tooltipSize);
				// Final Size and Position
				backgroundPoint = getBackgroundPoint(model, tooltipSize, alignment, me._chart);
			} else {
				model.opacity = 0;
			}
	
			model.xAlign = alignment.xAlign;
			model.yAlign = alignment.yAlign;
			model.x = backgroundPoint.x;
			model.y = backgroundPoint.y;
			model.width = tooltipSize.width;
			model.height = tooltipSize.height;
	
			// Point where the caret on the tooltip points to
			model.caretX = tooltipPosition.x;
			model.caretY = tooltipPosition.y;
	
			me._model = model;
	
			if (changed && opts.custom) {
				opts.custom.call(me, model);
			}
	
			return me;
		},
	
		drawCaret: function(tooltipPoint, size) {
			var ctx = this._chart.ctx;
			var vm = this._view;
			var caretPosition = this.getCaretPosition(tooltipPoint, size, vm);
	
			ctx.lineTo(caretPosition.x1, caretPosition.y1);
			ctx.lineTo(caretPosition.x2, caretPosition.y2);
			ctx.lineTo(caretPosition.x3, caretPosition.y3);
		},
		getCaretPosition: function(tooltipPoint, size, vm) {
			var x1, x2, x3, y1, y2, y3;
			var caretSize = vm.caretSize;
			var cornerRadius = vm.cornerRadius;
			var xAlign = vm.xAlign;
			var yAlign = vm.yAlign;
			var ptX = tooltipPoint.x;
			var ptY = tooltipPoint.y;
			var width = size.width;
			var height = size.height;
	
			if (yAlign === 'center') {
				y2 = ptY + (height / 2);
	
				if (xAlign === 'left') {
					x1 = ptX;
					x2 = x1 - caretSize;
					x3 = x1;
	
					y1 = y2 + caretSize;
					y3 = y2 - caretSize;
				} else {
					x1 = ptX + width;
					x2 = x1 + caretSize;
					x3 = x1;
	
					y1 = y2 - caretSize;
					y3 = y2 + caretSize;
				}
			} else {
				if (xAlign === 'left') {
					x2 = ptX + cornerRadius + (caretSize);
					x1 = x2 - caretSize;
					x3 = x2 + caretSize;
				} else if (xAlign === 'right') {
					x2 = ptX + width - cornerRadius - caretSize;
					x1 = x2 - caretSize;
					x3 = x2 + caretSize;
				} else {
					x2 = vm.caretX;
					x1 = x2 - caretSize;
					x3 = x2 + caretSize;
				}
				if (yAlign === 'top') {
					y1 = ptY;
					y2 = y1 - caretSize;
					y3 = y1;
				} else {
					y1 = ptY + height;
					y2 = y1 + caretSize;
					y3 = y1;
					// invert drawing order
					var tmp = x3;
					x3 = x1;
					x1 = tmp;
				}
			}
			return {x1: x1, x2: x2, x3: x3, y1: y1, y2: y2, y3: y3};
		},
	
		drawTitle: function(pt, vm, ctx) {
			var title = vm.title;
			var length = title.length;
			var titleFontSize, titleSpacing, i;
	
			if (length) {
				var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);
	
				pt.x = getAlignedX(vm, vm._titleAlign);
	
				ctx.textAlign = rtlHelper.textAlign(vm._titleAlign);
				ctx.textBaseline = 'middle';
	
				titleFontSize = vm.titleFontSize;
				titleSpacing = vm.titleSpacing;
	
				ctx.fillStyle = vm.titleFontColor;
				ctx.font = helpers$1.fontString(titleFontSize, vm._titleFontStyle, vm._titleFontFamily);
	
				for (i = 0; i < length; ++i) {
					ctx.fillText(title[i], rtlHelper.x(pt.x), pt.y + titleFontSize / 2);
					pt.y += titleFontSize + titleSpacing; // Line Height and spacing
	
					if (i + 1 === length) {
						pt.y += vm.titleMarginBottom - titleSpacing; // If Last, add margin, remove spacing
					}
				}
			}
		},
	
		drawBody: function(pt, vm, ctx) {
			var bodyFontSize = vm.bodyFontSize;
			var bodySpacing = vm.bodySpacing;
			var bodyAlign = vm._bodyAlign;
			var body = vm.body;
			var drawColorBoxes = vm.displayColors;
			var xLinePadding = 0;
			var colorX = drawColorBoxes ? getAlignedX(vm, 'left') : 0;
	
			var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);
	
			var fillLineOfText = function(line) {
				ctx.fillText(line, rtlHelper.x(pt.x + xLinePadding), pt.y + bodyFontSize / 2);
				pt.y += bodyFontSize + bodySpacing;
			};
	
			var bodyItem, textColor, labelColors, lines, i, j, ilen, jlen;
			var bodyAlignForCalculation = rtlHelper.textAlign(bodyAlign);
	
			ctx.textAlign = bodyAlign;
			ctx.textBaseline = 'middle';
			ctx.font = helpers$1.fontString(bodyFontSize, vm._bodyFontStyle, vm._bodyFontFamily);
	
			pt.x = getAlignedX(vm, bodyAlignForCalculation);
	
			// Before body lines
			ctx.fillStyle = vm.bodyFontColor;
			helpers$1.each(vm.beforeBody, fillLineOfText);
	
			xLinePadding = drawColorBoxes && bodyAlignForCalculation !== 'right'
				? bodyAlign === 'center' ? (bodyFontSize / 2 + 1) : (bodyFontSize + 2)
				: 0;
	
			// Draw body lines now
			for (i = 0, ilen = body.length; i < ilen; ++i) {
				bodyItem = body[i];
				textColor = vm.labelTextColors[i];
				labelColors = vm.labelColors[i];
	
				ctx.fillStyle = textColor;
				helpers$1.each(bodyItem.before, fillLineOfText);
	
				lines = bodyItem.lines;
				for (j = 0, jlen = lines.length; j < jlen; ++j) {
					// Draw Legend-like boxes if needed
					if (drawColorBoxes) {
						var rtlColorX = rtlHelper.x(colorX);
	
						// Fill a white rect so that colours merge nicely if the opacity is < 1
						ctx.fillStyle = vm.legendColorBackground;
						ctx.fillRect(rtlHelper.leftForLtr(rtlColorX, bodyFontSize), pt.y, bodyFontSize, bodyFontSize);
	
						// Border
						ctx.lineWidth = 1;
						ctx.strokeStyle = labelColors.borderColor;
						ctx.strokeRect(rtlHelper.leftForLtr(rtlColorX, bodyFontSize), pt.y, bodyFontSize, bodyFontSize);
	
						// Inner square
						ctx.fillStyle = labelColors.backgroundColor;
						ctx.fillRect(rtlHelper.leftForLtr(rtlHelper.xPlus(rtlColorX, 1), bodyFontSize - 2), pt.y + 1, bodyFontSize - 2, bodyFontSize - 2);
						ctx.fillStyle = textColor;
					}
	
					fillLineOfText(lines[j]);
				}
	
				helpers$1.each(bodyItem.after, fillLineOfText);
			}
	
			// Reset back to 0 for after body
			xLinePadding = 0;
	
			// After body lines
			helpers$1.each(vm.afterBody, fillLineOfText);
			pt.y -= bodySpacing; // Remove last body spacing
		},
	
		drawFooter: function(pt, vm, ctx) {
			var footer = vm.footer;
			var length = footer.length;
			var footerFontSize, i;
	
			if (length) {
				var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);
	
				pt.x = getAlignedX(vm, vm._footerAlign);
				pt.y += vm.footerMarginTop;
	
				ctx.textAlign = rtlHelper.textAlign(vm._footerAlign);
				ctx.textBaseline = 'middle';
	
				footerFontSize = vm.footerFontSize;
	
				ctx.fillStyle = vm.footerFontColor;
				ctx.font = helpers$1.fontString(footerFontSize, vm._footerFontStyle, vm._footerFontFamily);
	
				for (i = 0; i < length; ++i) {
					ctx.fillText(footer[i], rtlHelper.x(pt.x), pt.y + footerFontSize / 2);
					pt.y += footerFontSize + vm.footerSpacing;
				}
			}
		},
	
		drawBackground: function(pt, vm, ctx, tooltipSize) {
			ctx.fillStyle = vm.backgroundColor;
			ctx.strokeStyle = vm.borderColor;
			ctx.lineWidth = vm.borderWidth;
			var xAlign = vm.xAlign;
			var yAlign = vm.yAlign;
			var x = pt.x;
			var y = pt.y;
			var width = tooltipSize.width;
			var height = tooltipSize.height;
			var radius = vm.cornerRadius;
	
			ctx.beginPath();
			ctx.moveTo(x + radius, y);
			if (yAlign === 'top') {
				this.drawCaret(pt, tooltipSize);
			}
			ctx.lineTo(x + width - radius, y);
			ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
			if (yAlign === 'center' && xAlign === 'right') {
				this.drawCaret(pt, tooltipSize);
			}
			ctx.lineTo(x + width, y + height - radius);
			ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
			if (yAlign === 'bottom') {
				this.drawCaret(pt, tooltipSize);
			}
			ctx.lineTo(x + radius, y + height);
			ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
			if (yAlign === 'center' && xAlign === 'left') {
				this.drawCaret(pt, tooltipSize);
			}
			ctx.lineTo(x, y + radius);
			ctx.quadraticCurveTo(x, y, x + radius, y);
			ctx.closePath();
	
			ctx.fill();
	
			if (vm.borderWidth > 0) {
				ctx.stroke();
			}
		},
	
		draw: function() {
			var ctx = this._chart.ctx;
			var vm = this._view;
	
			if (vm.opacity === 0) {
				return;
			}
	
			var tooltipSize = {
				width: vm.width,
				height: vm.height
			};
			var pt = {
				x: vm.x,
				y: vm.y
			};
	
			// IE11/Edge does not like very small opacities, so snap to 0
			var opacity = Math.abs(vm.opacity < 1e-3) ? 0 : vm.opacity;
	
			// Truthy/falsey value for empty tooltip
			var hasTooltipContent = vm.title.length || vm.beforeBody.length || vm.body.length || vm.afterBody.length || vm.footer.length;
	
			if (this._options.enabled && hasTooltipContent) {
				ctx.save();
				ctx.globalAlpha = opacity;
	
				// Draw Background
				this.drawBackground(pt, vm, ctx, tooltipSize);
	
				// Draw Title, Body, and Footer
				pt.y += vm.yPadding;
	
				helpers$1.rtl.overrideTextDirection(ctx, vm.textDirection);
	
				// Titles
				this.drawTitle(pt, vm, ctx);
	
				// Body
				this.drawBody(pt, vm, ctx);
	
				// Footer
				this.drawFooter(pt, vm, ctx);
	
				helpers$1.rtl.restoreTextDirection(ctx, vm.textDirection);
	
				ctx.restore();
			}
		},
	
		/**
		 * Handle an event
		 * @private
		 * @param {IEvent} event - The event to handle
		 * @returns {boolean} true if the tooltip changed
		 */
		handleEvent: function(e) {
			var me = this;
			var options = me._options;
			var changed = false;
	
			me._lastActive = me._lastActive || [];
	
			// Find Active Elements for tooltips
			if (e.type === 'mouseout') {
				me._active = [];
			} else {
				me._active = me._chart.getElementsAtEventForMode(e, options.mode, options);
				if (options.reverse) {
					me._active.reverse();
				}
			}
	
			// Remember Last Actives
			changed = !helpers$1.arrayEquals(me._active, me._lastActive);
	
			// Only handle target event on tooltip change
			if (changed) {
				me._lastActive = me._active;
	
				if (options.enabled || options.custom) {
					me._eventPosition = {
						x: e.x,
						y: e.y
					};
	
					me.update(true);
					me.pivot();
				}
			}
	
			return changed;
		}
	});
	
	/**
	 * @namespace Chart.Tooltip.positioners
	 */
	var positioners_1 = positioners;
	
	var core_tooltip = exports$4;
	core_tooltip.positioners = positioners_1;
	
	var valueOrDefault$9 = helpers$1.valueOrDefault;
	
	core_defaults._set('global', {
		elements: {},
		events: [
			'mousemove',
			'mouseout',
			'click',
			'touchstart',
			'touchmove'
		],
		hover: {
			onHover: null,
			mode: 'nearest',
			intersect: true,
			animationDuration: 400
		},
		onClick: null,
		maintainAspectRatio: true,
		responsive: true,
		responsiveAnimationDuration: 0
	});
	
	/**
	 * Recursively merge the given config objects representing the `scales` option
	 * by incorporating scale defaults in `xAxes` and `yAxes` array items, then
	 * returns a deep copy of the result, thus doesn't alter inputs.
	 */
	function mergeScaleConfig(/* config objects ... */) {
		return helpers$1.merge(Object.create(null), [].slice.call(arguments), {
			merger: function(key, target, source, options) {
				if (key === 'xAxes' || key === 'yAxes') {
					var slen = source[key].length;
					var i, type, scale;
	
					if (!target[key]) {
						target[key] = [];
					}
	
					for (i = 0; i < slen; ++i) {
						scale = source[key][i];
						type = valueOrDefault$9(scale.type, key === 'xAxes' ? 'category' : 'linear');
	
						if (i >= target[key].length) {
							target[key].push({});
						}
	
						if (!target[key][i].type || (scale.type && scale.type !== target[key][i].type)) {
							// new/untyped scale or type changed: let's apply the new defaults
							// then merge source scale to correctly overwrite the defaults.
							helpers$1.merge(target[key][i], [core_scaleService.getScaleDefaults(type), scale]);
						} else {
							// scales type are the same
							helpers$1.merge(target[key][i], scale);
						}
					}
				} else {
					helpers$1._merger(key, target, source, options);
				}
			}
		});
	}
	
	/**
	 * Recursively merge the given config objects as the root options by handling
	 * default scale options for the `scales` and `scale` properties, then returns
	 * a deep copy of the result, thus doesn't alter inputs.
	 */
	function mergeConfig(/* config objects ... */) {
		return helpers$1.merge(Object.create(null), [].slice.call(arguments), {
			merger: function(key, target, source, options) {
				var tval = target[key] || Object.create(null);
				var sval = source[key];
	
				if (key === 'scales') {
					// scale config merging is complex. Add our own function here for that
					target[key] = mergeScaleConfig(tval, sval);
				} else if (key === 'scale') {
					// used in polar area & radar charts since there is only one scale
					target[key] = helpers$1.merge(tval, [core_scaleService.getScaleDefaults(sval.type), sval]);
				} else {
					helpers$1._merger(key, target, source, options);
				}
			}
		});
	}
	
	function initConfig(config) {
		config = config || Object.create(null);
	
		// Do NOT use mergeConfig for the data object because this method merges arrays
		// and so would change references to labels and datasets, preventing data updates.
		var data = config.data = config.data || {};
		data.datasets = data.datasets || [];
		data.labels = data.labels || [];
	
		config.options = mergeConfig(
			core_defaults.global,
			core_defaults[config.type],
			config.options || {});
	
		return config;
	}
	
	function updateConfig(chart) {
		var newOptions = chart.options;
	
		helpers$1.each(chart.scales, function(scale) {
			core_layouts.removeBox(chart, scale);
		});
	
		newOptions = mergeConfig(
			core_defaults.global,
			core_defaults[chart.config.type],
			newOptions);
	
		chart.options = chart.config.options = newOptions;
		chart.ensureScalesHaveIDs();
		chart.buildOrUpdateScales();
	
		// Tooltip
		chart.tooltip._options = newOptions.tooltips;
		chart.tooltip.initialize();
	}
	
	function nextAvailableScaleId(axesOpts, prefix, index) {
		var id;
		var hasId = function(obj) {
			return obj.id === id;
		};
	
		do {
			id = prefix + index++;
		} while (helpers$1.findIndex(axesOpts, hasId) >= 0);
	
		return id;
	}
	
	function positionIsHorizontal(position) {
		return position === 'top' || position === 'bottom';
	}
	
	function compare2Level(l1, l2) {
		return function(a, b) {
			return a[l1] === b[l1]
				? a[l2] - b[l2]
				: a[l1] - b[l1];
		};
	}
	
	var Chart = function(item, config) {
		this.construct(item, config);
		return this;
	};
	
	helpers$1.extend(Chart.prototype, /** @lends Chart */ {
		/**
		 * @private
		 */
		construct: function(item, config) {
			var me = this;
	
			config = initConfig(config);
	
			var context = platform.acquireContext(item, config);
			var canvas = context && context.canvas;
			var height = canvas && canvas.height;
			var width = canvas && canvas.width;
	
			me.id = helpers$1.uid();
			me.ctx = context;
			me.canvas = canvas;
			me.config = config;
			me.width = width;
			me.height = height;
			me.aspectRatio = height ? width / height : null;
			me.options = config.options;
			me._bufferedRender = false;
			me._layers = [];
	
			/**
			 * Provided for backward compatibility, Chart and Chart.Controller have been merged,
			 * the "instance" still need to be defined since it might be called from plugins.
			 * @prop Chart#chart
			 * @deprecated since version 2.6.0
			 * @todo remove at version 3
			 * @private
			 */
			me.chart = me;
			me.controller = me; // chart.chart.controller #inception
	
			// Add the chart instance to the global namespace
			Chart.instances[me.id] = me;
	
			// Define alias to the config data: `chart.data === chart.config.data`
			Object.defineProperty(me, 'data', {
				get: function() {
					return me.config.data;
				},
				set: function(value) {
					me.config.data = value;
				}
			});
	
			if (!context || !canvas) {
				// The given item is not a compatible context2d element, let's return before finalizing
				// the chart initialization but after setting basic chart / controller properties that
				// can help to figure out that the chart is not valid (e.g chart.canvas !== null);
				// https://github.com/chartjs/Chart.js/issues/2807
				console.error("Failed to create chart: can't acquire context from the given item");
				return;
			}
	
			me.initialize();
			me.update();
		},
	
		/**
		 * @private
		 */
		initialize: function() {
			var me = this;
	
			// Before init plugin notification
			core_plugins.notify(me, 'beforeInit');
	
			helpers$1.retinaScale(me, me.options.devicePixelRatio);
	
			me.bindEvents();
	
			if (me.options.responsive) {
				// Initial resize before chart draws (must be silent to preserve initial animations).
				me.resize(true);
			}
	
			me.initToolTip();
	
			// After init plugin notification
			core_plugins.notify(me, 'afterInit');
	
			return me;
		},
	
		clear: function() {
			helpers$1.canvas.clear(this);
			return this;
		},
	
		stop: function() {
			// Stops any current animation loop occurring
			core_animations.cancelAnimation(this);
			return this;
		},
	
		resize: function(silent) {
			var me = this;
			var options = me.options;
			var canvas = me.canvas;
			var aspectRatio = (options.maintainAspectRatio && me.aspectRatio) || null;
	
			// the canvas render width and height will be casted to integers so make sure that
			// the canvas display style uses the same integer values to avoid blurring effect.
	
			// Set to 0 instead of canvas.size because the size defaults to 300x150 if the element is collapsed
			var newWidth = Math.max(0, Math.floor(helpers$1.getMaximumWidth(canvas)));
			var newHeight = Math.max(0, Math.floor(aspectRatio ? newWidth / aspectRatio : helpers$1.getMaximumHeight(canvas)));
	
			if (me.width === newWidth && me.height === newHeight) {
				return;
			}
	
			canvas.width = me.width = newWidth;
			canvas.height = me.height = newHeight;
			canvas.style.width = newWidth + 'px';
			canvas.style.height = newHeight + 'px';
	
			helpers$1.retinaScale(me, options.devicePixelRatio);
	
			if (!silent) {
				// Notify any plugins about the resize
				var newSize = {width: newWidth, height: newHeight};
				core_plugins.notify(me, 'resize', [newSize]);
	
				// Notify of resize
				if (options.onResize) {
					options.onResize(me, newSize);
				}
	
				me.stop();
				me.update({
					duration: options.responsiveAnimationDuration
				});
			}
		},
	
		ensureScalesHaveIDs: function() {
			var options = this.options;
			var scalesOptions = options.scales || {};
			var scaleOptions = options.scale;
	
			helpers$1.each(scalesOptions.xAxes, function(xAxisOptions, index) {
				if (!xAxisOptions.id) {
					xAxisOptions.id = nextAvailableScaleId(scalesOptions.xAxes, 'x-axis-', index);
				}
			});
	
			helpers$1.each(scalesOptions.yAxes, function(yAxisOptions, index) {
				if (!yAxisOptions.id) {
					yAxisOptions.id = nextAvailableScaleId(scalesOptions.yAxes, 'y-axis-', index);
				}
			});
	
			if (scaleOptions) {
				scaleOptions.id = scaleOptions.id || 'scale';
			}
		},
	
		/**
		 * Builds a map of scale ID to scale object for future lookup.
		 */
		buildOrUpdateScales: function() {
			var me = this;
			var options = me.options;
			var scales = me.scales || {};
			var items = [];
			var updated = Object.keys(scales).reduce(function(obj, id) {
				obj[id] = false;
				return obj;
			}, {});
	
			if (options.scales) {
				items = items.concat(
					(options.scales.xAxes || []).map(function(xAxisOptions) {
						return {options: xAxisOptions, dtype: 'category', dposition: 'bottom'};
					}),
					(options.scales.yAxes || []).map(function(yAxisOptions) {
						return {options: yAxisOptions, dtype: 'linear', dposition: 'left'};
					})
				);
			}
	
			if (options.scale) {
				items.push({
					options: options.scale,
					dtype: 'radialLinear',
					isDefault: true,
					dposition: 'chartArea'
				});
			}
	
			helpers$1.each(items, function(item) {
				var scaleOptions = item.options;
				var id = scaleOptions.id;
				var scaleType = valueOrDefault$9(scaleOptions.type, item.dtype);
	
				if (positionIsHorizontal(scaleOptions.position) !== positionIsHorizontal(item.dposition)) {
					scaleOptions.position = item.dposition;
				}
	
				updated[id] = true;
				var scale = null;
				if (id in scales && scales[id].type === scaleType) {
					scale = scales[id];
					scale.options = scaleOptions;
					scale.ctx = me.ctx;
					scale.chart = me;
				} else {
					var scaleClass = core_scaleService.getScaleConstructor(scaleType);
					if (!scaleClass) {
						return;
					}
					scale = new scaleClass({
						id: id,
						type: scaleType,
						options: scaleOptions,
						ctx: me.ctx,
						chart: me
					});
					scales[scale.id] = scale;
				}
	
				scale.mergeTicksOptions();
	
				// TODO(SB): I think we should be able to remove this custom case (options.scale)
				// and consider it as a regular scale part of the "scales"" map only! This would
				// make the logic easier and remove some useless? custom code.
				if (item.isDefault) {
					me.scale = scale;
				}
			});
			// clear up discarded scales
			helpers$1.each(updated, function(hasUpdated, id) {
				if (!hasUpdated) {
					delete scales[id];
				}
			});
	
			me.scales = scales;
	
			core_scaleService.addScalesToLayout(this);
		},
	
		buildOrUpdateControllers: function() {
			var me = this;
			var newControllers = [];
			var datasets = me.data.datasets;
			var i, ilen;
	
			for (i = 0, ilen = datasets.length; i < ilen; i++) {
				var dataset = datasets[i];
				var meta = me.getDatasetMeta(i);
				var type = dataset.type || me.config.type;
	
				if (meta.type && meta.type !== type) {
					me.destroyDatasetMeta(i);
					meta = me.getDatasetMeta(i);
				}
				meta.type = type;
				meta.order = dataset.order || 0;
				meta.index = i;
	
				if (meta.controller) {
					meta.controller.updateIndex(i);
					meta.controller.linkScales();
				} else {
					var ControllerClass = controllers[meta.type];
					if (ControllerClass === undefined) {
						throw new Error('"' + meta.type + '" is not a chart type.');
					}
	
					meta.controller = new ControllerClass(me, i);
					newControllers.push(meta.controller);
				}
			}
	
			return newControllers;
		},
	
		/**
		 * Reset the elements of all datasets
		 * @private
		 */
		resetElements: function() {
			var me = this;
			helpers$1.each(me.data.datasets, function(dataset, datasetIndex) {
				me.getDatasetMeta(datasetIndex).controller.reset();
			}, me);
		},
	
		/**
		* Resets the chart back to it's state before the initial animation
		*/
		reset: function() {
			this.resetElements();
			this.tooltip.initialize();
		},
	
		update: function(config) {
			var me = this;
			var i, ilen;
	
			if (!config || typeof config !== 'object') {
				// backwards compatibility
				config = {
					duration: config,
					lazy: arguments[1]
				};
			}
	
			updateConfig(me);
	
			// plugins options references might have change, let's invalidate the cache
			// https://github.com/chartjs/Chart.js/issues/5111#issuecomment-355934167
			core_plugins._invalidate(me);
	
			if (core_plugins.notify(me, 'beforeUpdate') === false) {
				return;
			}
	
			// In case the entire data object changed
			me.tooltip._data = me.data;
	
			// Make sure dataset controllers are updated and new controllers are reset
			var newControllers = me.buildOrUpdateControllers();
	
			// Make sure all dataset controllers have correct meta data counts
			for (i = 0, ilen = me.data.datasets.length; i < ilen; i++) {
				me.getDatasetMeta(i).controller.buildOrUpdateElements();
			}
	
			me.updateLayout();
	
			// Can only reset the new controllers after the scales have been updated
			if (me.options.animation && me.options.animation.duration) {
				helpers$1.each(newControllers, function(controller) {
					controller.reset();
				});
			}
	
			me.updateDatasets();
	
			// Need to reset tooltip in case it is displayed with elements that are removed
			// after update.
			me.tooltip.initialize();
	
			// Last active contains items that were previously in the tooltip.
			// When we reset the tooltip, we need to clear it
			me.lastActive = [];
	
			// Do this before render so that any plugins that need final scale updates can use it
			core_plugins.notify(me, 'afterUpdate');
	
			me._layers.sort(compare2Level('z', '_idx'));
	
			if (me._bufferedRender) {
				me._bufferedRequest = {
					duration: config.duration,
					easing: config.easing,
					lazy: config.lazy
				};
			} else {
				me.render(config);
			}
		},
	
		/**
		 * Updates the chart layout unless a plugin returns `false` to the `beforeLayout`
		 * hook, in which case, plugins will not be called on `afterLayout`.
		 * @private
		 */
		updateLayout: function() {
			var me = this;
	
			if (core_plugins.notify(me, 'beforeLayout') === false) {
				return;
			}
	
			core_layouts.update(this, this.width, this.height);
	
			me._layers = [];
			helpers$1.each(me.boxes, function(box) {
				// _configure is called twice, once in core.scale.update and once here.
				// Here the boxes are fully updated and at their final positions.
				if (box._configure) {
					box._configure();
				}
				me._layers.push.apply(me._layers, box._layers());
			}, me);
	
			me._layers.forEach(function(item, index) {
				item._idx = index;
			});
	
			/**
			 * Provided for backward compatibility, use `afterLayout` instead.
			 * @method IPlugin#afterScaleUpdate
			 * @deprecated since version 2.5.0
			 * @todo remove at version 3
			 * @private
			 */
			core_plugins.notify(me, 'afterScaleUpdate');
			core_plugins.notify(me, 'afterLayout');
		},
	
		/**
		 * Updates all datasets unless a plugin returns `false` to the `beforeDatasetsUpdate`
		 * hook, in which case, plugins will not be called on `afterDatasetsUpdate`.
		 * @private
		 */
		updateDatasets: function() {
			var me = this;
	
			if (core_plugins.notify(me, 'beforeDatasetsUpdate') === false) {
				return;
			}
	
			for (var i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
				me.updateDataset(i);
			}
	
			core_plugins.notify(me, 'afterDatasetsUpdate');
		},
	
		/**
		 * Updates dataset at index unless a plugin returns `false` to the `beforeDatasetUpdate`
		 * hook, in which case, plugins will not be called on `afterDatasetUpdate`.
		 * @private
		 */
		updateDataset: function(index) {
			var me = this;
			var meta = me.getDatasetMeta(index);
			var args = {
				meta: meta,
				index: index
			};
	
			if (core_plugins.notify(me, 'beforeDatasetUpdate', [args]) === false) {
				return;
			}
	
			meta.controller._update();
	
			core_plugins.notify(me, 'afterDatasetUpdate', [args]);
		},
	
		render: function(config) {
			var me = this;
	
			if (!config || typeof config !== 'object') {
				// backwards compatibility
				config = {
					duration: config,
					lazy: arguments[1]
				};
			}
	
			var animationOptions = me.options.animation;
			var duration = valueOrDefault$9(config.duration, animationOptions && animationOptions.duration);
			var lazy = config.lazy;
	
			if (core_plugins.notify(me, 'beforeRender') === false) {
				return;
			}
	
			var onComplete = function(animation) {
				core_plugins.notify(me, 'afterRender');
				helpers$1.callback(animationOptions && animationOptions.onComplete, [animation], me);
			};
	
			if (animationOptions && duration) {
				var animation = new core_animation({
					numSteps: duration / 16.66, // 60 fps
					easing: config.easing || animationOptions.easing,
	
					render: function(chart, animationObject) {
						var easingFunction = helpers$1.easing.effects[animationObject.easing];
						var currentStep = animationObject.currentStep;
						var stepDecimal = currentStep / animationObject.numSteps;
	
						chart.draw(easingFunction(stepDecimal), stepDecimal, currentStep);
					},
	
					onAnimationProgress: animationOptions.onProgress,
					onAnimationComplete: onComplete
				});
	
				core_animations.addAnimation(me, animation, duration, lazy);
			} else {
				me.draw();
	
				// See https://github.com/chartjs/Chart.js/issues/3781
				onComplete(new core_animation({numSteps: 0, chart: me}));
			}
	
			return me;
		},
	
		draw: function(easingValue) {
			var me = this;
			var i, layers;
	
			me.clear();
	
			if (helpers$1.isNullOrUndef(easingValue)) {
				easingValue = 1;
			}
	
			me.transition(easingValue);
	
			if (me.width <= 0 || me.height <= 0) {
				return;
			}
	
			if (core_plugins.notify(me, 'beforeDraw', [easingValue]) === false) {
				return;
			}
	
			// Because of plugin hooks (before/afterDatasetsDraw), datasets can't
			// currently be part of layers. Instead, we draw
			// layers <= 0 before(default, backward compat), and the rest after
			layers = me._layers;
			for (i = 0; i < layers.length && layers[i].z <= 0; ++i) {
				layers[i].draw(me.chartArea);
			}
	
			me.drawDatasets(easingValue);
	
			// Rest of layers
			for (; i < layers.length; ++i) {
				layers[i].draw(me.chartArea);
			}
	
			me._drawTooltip(easingValue);
	
			core_plugins.notify(me, 'afterDraw', [easingValue]);
		},
	
		/**
		 * @private
		 */
		transition: function(easingValue) {
			var me = this;
	
			for (var i = 0, ilen = (me.data.datasets || []).length; i < ilen; ++i) {
				if (me.isDatasetVisible(i)) {
					me.getDatasetMeta(i).controller.transition(easingValue);
				}
			}
	
			me.tooltip.transition(easingValue);
		},
	
		/**
		 * @private
		 */
		_getSortedDatasetMetas: function(filterVisible) {
			var me = this;
			var datasets = me.data.datasets || [];
			var result = [];
			var i, ilen;
	
			for (i = 0, ilen = datasets.length; i < ilen; ++i) {
				if (!filterVisible || me.isDatasetVisible(i)) {
					result.push(me.getDatasetMeta(i));
				}
			}
	
			result.sort(compare2Level('order', 'index'));
	
			return result;
		},
	
		/**
		 * @private
		 */
		_getSortedVisibleDatasetMetas: function() {
			return this._getSortedDatasetMetas(true);
		},
	
		/**
		 * Draws all datasets unless a plugin returns `false` to the `beforeDatasetsDraw`
		 * hook, in which case, plugins will not be called on `afterDatasetsDraw`.
		 * @private
		 */
		drawDatasets: function(easingValue) {
			var me = this;
			var metasets, i;
	
			if (core_plugins.notify(me, 'beforeDatasetsDraw', [easingValue]) === false) {
				return;
			}
	
			metasets = me._getSortedVisibleDatasetMetas();
			for (i = metasets.length - 1; i >= 0; --i) {
				me.drawDataset(metasets[i], easingValue);
			}
	
			core_plugins.notify(me, 'afterDatasetsDraw', [easingValue]);
		},
	
		/**
		 * Draws dataset at index unless a plugin returns `false` to the `beforeDatasetDraw`
		 * hook, in which case, plugins will not be called on `afterDatasetDraw`.
		 * @private
		 */
		drawDataset: function(meta, easingValue) {
			var me = this;
			var args = {
				meta: meta,
				index: meta.index,
				easingValue: easingValue
			};
	
			if (core_plugins.notify(me, 'beforeDatasetDraw', [args]) === false) {
				return;
			}
	
			meta.controller.draw(easingValue);
	
			core_plugins.notify(me, 'afterDatasetDraw', [args]);
		},
	
		/**
		 * Draws tooltip unless a plugin returns `false` to the `beforeTooltipDraw`
		 * hook, in which case, plugins will not be called on `afterTooltipDraw`.
		 * @private
		 */
		_drawTooltip: function(easingValue) {
			var me = this;
			var tooltip = me.tooltip;
			var args = {
				tooltip: tooltip,
				easingValue: easingValue
			};
	
			if (core_plugins.notify(me, 'beforeTooltipDraw', [args]) === false) {
				return;
			}
	
			tooltip.draw();
	
			core_plugins.notify(me, 'afterTooltipDraw', [args]);
		},
	
		/**
		 * Get the single element that was clicked on
		 * @return An object containing the dataset index and element index of the matching element. Also contains the rectangle that was draw
		 */
		getElementAtEvent: function(e) {
			return core_interaction.modes.single(this, e);
		},
	
		getElementsAtEvent: function(e) {
			return core_interaction.modes.label(this, e, {intersect: true});
		},
	
		getElementsAtXAxis: function(e) {
			return core_interaction.modes['x-axis'](this, e, {intersect: true});
		},
	
		getElementsAtEventForMode: function(e, mode, options) {
			var method = core_interaction.modes[mode];
			if (typeof method === 'function') {
				return method(this, e, options);
			}
	
			return [];
		},
	
		getDatasetAtEvent: function(e) {
			return core_interaction.modes.dataset(this, e, {intersect: true});
		},
	
		getDatasetMeta: function(datasetIndex) {
			var me = this;
			var dataset = me.data.datasets[datasetIndex];
			if (!dataset._meta) {
				dataset._meta = {};
			}
	
			var meta = dataset._meta[me.id];
			if (!meta) {
				meta = dataset._meta[me.id] = {
					type: null,
					data: [],
					dataset: null,
					controller: null,
					hidden: null,			// See isDatasetVisible() comment
					xAxisID: null,
					yAxisID: null,
					order: dataset.order || 0,
					index: datasetIndex
				};
			}
	
			return meta;
		},
	
		getVisibleDatasetCount: function() {
			var count = 0;
			for (var i = 0, ilen = this.data.datasets.length; i < ilen; ++i) {
				if (this.isDatasetVisible(i)) {
					count++;
				}
			}
			return count;
		},
	
		isDatasetVisible: function(datasetIndex) {
			var meta = this.getDatasetMeta(datasetIndex);
	
			// meta.hidden is a per chart dataset hidden flag override with 3 states: if true or false,
			// the dataset.hidden value is ignored, else if null, the dataset hidden state is returned.
			return typeof meta.hidden === 'boolean' ? !meta.hidden : !this.data.datasets[datasetIndex].hidden;
		},
	
		generateLegend: function() {
			return this.options.legendCallback(this);
		},
	
		/**
		 * @private
		 */
		destroyDatasetMeta: function(datasetIndex) {
			var id = this.id;
			var dataset = this.data.datasets[datasetIndex];
			var meta = dataset._meta && dataset._meta[id];
	
			if (meta) {
				meta.controller.destroy();
				delete dataset._meta[id];
			}
		},
	
		destroy: function() {
			var me = this;
			var canvas = me.canvas;
			var i, ilen;
	
			me.stop();
	
			// dataset controllers need to cleanup associated data
			for (i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
				me.destroyDatasetMeta(i);
			}
	
			if (canvas) {
				me.unbindEvents();
				helpers$1.canvas.clear(me);
				platform.releaseContext(me.ctx);
				me.canvas = null;
				me.ctx = null;
			}
	
			core_plugins.notify(me, 'destroy');
	
			delete Chart.instances[me.id];
		},
	
		toBase64Image: function() {
			return this.canvas.toDataURL.apply(this.canvas, arguments);
		},
	
		initToolTip: function() {
			var me = this;
			me.tooltip = new core_tooltip({
				_chart: me,
				_chartInstance: me, // deprecated, backward compatibility
				_data: me.data,
				_options: me.options.tooltips
			}, me);
		},
	
		/**
		 * @private
		 */
		bindEvents: function() {
			var me = this;
			var listeners = me._listeners = {};
			var listener = function() {
				me.eventHandler.apply(me, arguments);
			};
	
			helpers$1.each(me.options.events, function(type) {
				platform.addEventListener(me, type, listener);
				listeners[type] = listener;
			});
	
			// Elements used to detect size change should not be injected for non responsive charts.
			// See https://github.com/chartjs/Chart.js/issues/2210
			if (me.options.responsive) {
				listener = function() {
					me.resize();
				};
	
				platform.addEventListener(me, 'resize', listener);
				listeners.resize = listener;
			}
		},
	
		/**
		 * @private
		 */
		unbindEvents: function() {
			var me = this;
			var listeners = me._listeners;
			if (!listeners) {
				return;
			}
	
			delete me._listeners;
			helpers$1.each(listeners, function(listener, type) {
				platform.removeEventListener(me, type, listener);
			});
		},
	
		updateHoverStyle: function(elements, mode, enabled) {
			var prefix = enabled ? 'set' : 'remove';
			var element, i, ilen;
	
			for (i = 0, ilen = elements.length; i < ilen; ++i) {
				element = elements[i];
				if (element) {
					this.getDatasetMeta(element._datasetIndex).controller[prefix + 'HoverStyle'](element);
				}
			}
	
			if (mode === 'dataset') {
				this.getDatasetMeta(elements[0]._datasetIndex).controller['_' + prefix + 'DatasetHoverStyle']();
			}
		},
	
		/**
		 * @private
		 */
		eventHandler: function(e) {
			var me = this;
			var tooltip = me.tooltip;
	
			if (core_plugins.notify(me, 'beforeEvent', [e]) === false) {
				return;
			}
	
			// Buffer any update calls so that renders do not occur
			me._bufferedRender = true;
			me._bufferedRequest = null;
	
			var changed = me.handleEvent(e);
			// for smooth tooltip animations issue #4989
			// the tooltip should be the source of change
			// Animation check workaround:
			// tooltip._start will be null when tooltip isn't animating
			if (tooltip) {
				changed = tooltip._start
					? tooltip.handleEvent(e)
					: changed | tooltip.handleEvent(e);
			}
	
			core_plugins.notify(me, 'afterEvent', [e]);
	
			var bufferedRequest = me._bufferedRequest;
			if (bufferedRequest) {
				// If we have an update that was triggered, we need to do a normal render
				me.render(bufferedRequest);
			} else if (changed && !me.animating) {
				// If entering, leaving, or changing elements, animate the change via pivot
				me.stop();
	
				// We only need to render at this point. Updating will cause scales to be
				// recomputed generating flicker & using more memory than necessary.
				me.render({
					duration: me.options.hover.animationDuration,
					lazy: true
				});
			}
	
			me._bufferedRender = false;
			me._bufferedRequest = null;
	
			return me;
		},
	
		/**
		 * Handle an event
		 * @private
		 * @param {IEvent} event the event to handle
		 * @return {boolean} true if the chart needs to re-render
		 */
		handleEvent: function(e) {
			var me = this;
			var options = me.options || {};
			var hoverOptions = options.hover;
			var changed = false;
	
			me.lastActive = me.lastActive || [];
	
			// Find Active Elements for hover and tooltips
			if (e.type === 'mouseout') {
				me.active = [];
			} else {
				me.active = me.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions);
			}
	
			// Invoke onHover hook
			// Need to call with native event here to not break backwards compatibility
			helpers$1.callback(options.onHover || options.hover.onHover, [e.native, me.active], me);
	
			if (e.type === 'mouseup' || e.type === 'click') {
				if (options.onClick) {
					// Use e.native here for backwards compatibility
					options.onClick.call(me, e.native, me.active);
				}
			}
	
			// Remove styling for last active (even if it may still be active)
			if (me.lastActive.length) {
				me.updateHoverStyle(me.lastActive, hoverOptions.mode, false);
			}
	
			// Built in hover styling
			if (me.active.length && hoverOptions.mode) {
				me.updateHoverStyle(me.active, hoverOptions.mode, true);
			}
	
			changed = !helpers$1.arrayEquals(me.active, me.lastActive);
	
			// Remember Last Actives
			me.lastActive = me.active;
	
			return changed;
		}
	});
	
	/**
	 * NOTE(SB) We actually don't use this container anymore but we need to keep it
	 * for backward compatibility. Though, it can still be useful for plugins that
	 * would need to work on multiple charts?!
	 */
	Chart.instances = {};
	
	var core_controller = Chart;
	
	// DEPRECATIONS
	
	/**
	 * Provided for backward compatibility, use Chart instead.
	 * @class Chart.Controller
	 * @deprecated since version 2.6
	 * @todo remove at version 3
	 * @private
	 */
	Chart.Controller = Chart;
	
	/**
	 * Provided for backward compatibility, not available anymore.
	 * @namespace Chart
	 * @deprecated since version 2.8
	 * @todo remove at version 3
	 * @private
	 */
	Chart.types = {};
	
	/**
	 * Provided for backward compatibility, not available anymore.
	 * @namespace Chart.helpers.configMerge
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers$1.configMerge = mergeConfig;
	
	/**
	 * Provided for backward compatibility, not available anymore.
	 * @namespace Chart.helpers.scaleMerge
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers$1.scaleMerge = mergeScaleConfig;
	
	var core_helpers = function() {
	
		// -- Basic js utility methods
	
		helpers$1.where = function(collection, filterCallback) {
			if (helpers$1.isArray(collection) && Array.prototype.filter) {
				return collection.filter(filterCallback);
			}
			var filtered = [];
	
			helpers$1.each(collection, function(item) {
				if (filterCallback(item)) {
					filtered.push(item);
				}
			});
	
			return filtered;
		};
		helpers$1.findIndex = Array.prototype.findIndex ?
			function(array, callback, scope) {
				return array.findIndex(callback, scope);
			} :
			function(array, callback, scope) {
				scope = scope === undefined ? array : scope;
				for (var i = 0, ilen = array.length; i < ilen; ++i) {
					if (callback.call(scope, array[i], i, array)) {
						return i;
					}
				}
				return -1;
			};
		helpers$1.findNextWhere = function(arrayToSearch, filterCallback, startIndex) {
			// Default to start of the array
			if (helpers$1.isNullOrUndef(startIndex)) {
				startIndex = -1;
			}
			for (var i = startIndex + 1; i < arrayToSearch.length; i++) {
				var currentItem = arrayToSearch[i];
				if (filterCallback(currentItem)) {
					return currentItem;
				}
			}
		};
		helpers$1.findPreviousWhere = function(arrayToSearch, filterCallback, startIndex) {
			// Default to end of the array
			if (helpers$1.isNullOrUndef(startIndex)) {
				startIndex = arrayToSearch.length;
			}
			for (var i = startIndex - 1; i >= 0; i--) {
				var currentItem = arrayToSearch[i];
				if (filterCallback(currentItem)) {
					return currentItem;
				}
			}
		};
	
		// -- Math methods
		helpers$1.isNumber = function(n) {
			return !isNaN(parseFloat(n)) && isFinite(n);
		};
		helpers$1.almostEquals = function(x, y, epsilon) {
			return Math.abs(x - y) < epsilon;
		};
		helpers$1.almostWhole = function(x, epsilon) {
			var rounded = Math.round(x);
			return ((rounded - epsilon) <= x) && ((rounded + epsilon) >= x);
		};
		helpers$1.max = function(array) {
			return array.reduce(function(max, value) {
				if (!isNaN(value)) {
					return Math.max(max, value);
				}
				return max;
			}, Number.NEGATIVE_INFINITY);
		};
		helpers$1.min = function(array) {
			return array.reduce(function(min, value) {
				if (!isNaN(value)) {
					return Math.min(min, value);
				}
				return min;
			}, Number.POSITIVE_INFINITY);
		};
		helpers$1.sign = Math.sign ?
			function(x) {
				return Math.sign(x);
			} :
			function(x) {
				x = +x; // convert to a number
				if (x === 0 || isNaN(x)) {
					return x;
				}
				return x > 0 ? 1 : -1;
			};
		helpers$1.toRadians = function(degrees) {
			return degrees * (Math.PI / 180);
		};
		helpers$1.toDegrees = function(radians) {
			return radians * (180 / Math.PI);
		};
	
		/**
		 * Returns the number of decimal places
		 * i.e. the number of digits after the decimal point, of the value of this Number.
		 * @param {number} x - A number.
		 * @returns {number} The number of decimal places.
		 * @private
		 */
		helpers$1._decimalPlaces = function(x) {
			if (!helpers$1.isFinite(x)) {
				return;
			}
			var e = 1;
			var p = 0;
			while (Math.round(x * e) / e !== x) {
				e *= 10;
				p++;
			}
			return p;
		};
	
		// Gets the angle from vertical upright to the point about a centre.
		helpers$1.getAngleFromPoint = function(centrePoint, anglePoint) {
			var distanceFromXCenter = anglePoint.x - centrePoint.x;
			var distanceFromYCenter = anglePoint.y - centrePoint.y;
			var radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);
	
			var angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);
	
			if (angle < (-0.5 * Math.PI)) {
				angle += 2.0 * Math.PI; // make sure the returned angle is in the range of (-PI/2, 3PI/2]
			}
	
			return {
				angle: angle,
				distance: radialDistanceFromCenter
			};
		};
		helpers$1.distanceBetweenPoints = function(pt1, pt2) {
			return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
		};
	
		/**
		 * Provided for backward compatibility, not available anymore
		 * @function Chart.helpers.aliasPixel
		 * @deprecated since version 2.8.0
		 * @todo remove at version 3
		 */
		helpers$1.aliasPixel = function(pixelWidth) {
			return (pixelWidth % 2 === 0) ? 0 : 0.5;
		};
	
		/**
		 * Returns the aligned pixel value to avoid anti-aliasing blur
		 * @param {Chart} chart - The chart instance.
		 * @param {number} pixel - A pixel value.
		 * @param {number} width - The width of the element.
		 * @returns {number} The aligned pixel value.
		 * @private
		 */
		helpers$1._alignPixel = function(chart, pixel, width) {
			var devicePixelRatio = chart.currentDevicePixelRatio;
			var halfWidth = width / 2;
			return Math.round((pixel - halfWidth) * devicePixelRatio) / devicePixelRatio + halfWidth;
		};
	
		helpers$1.splineCurve = function(firstPoint, middlePoint, afterPoint, t) {
			// Props to Rob Spencer at scaled innovation for his post on splining between points
			// http://scaledinnovation.com/analytics/splines/aboutSplines.html
	
			// This function must also respect "skipped" points
	
			var previous = firstPoint.skip ? middlePoint : firstPoint;
			var current = middlePoint;
			var next = afterPoint.skip ? middlePoint : afterPoint;
	
			var d01 = Math.sqrt(Math.pow(current.x - previous.x, 2) + Math.pow(current.y - previous.y, 2));
			var d12 = Math.sqrt(Math.pow(next.x - current.x, 2) + Math.pow(next.y - current.y, 2));
	
			var s01 = d01 / (d01 + d12);
			var s12 = d12 / (d01 + d12);
	
			// If all points are the same, s01 & s02 will be inf
			s01 = isNaN(s01) ? 0 : s01;
			s12 = isNaN(s12) ? 0 : s12;
	
			var fa = t * s01; // scaling factor for triangle Ta
			var fb = t * s12;
	
			return {
				previous: {
					x: current.x - fa * (next.x - previous.x),
					y: current.y - fa * (next.y - previous.y)
				},
				next: {
					x: current.x + fb * (next.x - previous.x),
					y: current.y + fb * (next.y - previous.y)
				}
			};
		};
		helpers$1.EPSILON = Number.EPSILON || 1e-14;
		helpers$1.splineCurveMonotone = function(points) {
			// This function calculates Bézier control points in a similar way than |splineCurve|,
			// but preserves monotonicity of the provided data and ensures no local extremums are added
			// between the dataset discrete points due to the interpolation.
			// See : https://en.wikipedia.org/wiki/Monotone_cubic_interpolation
	
			var pointsWithTangents = (points || []).map(function(point) {
				return {
					model: point._model,
					deltaK: 0,
					mK: 0
				};
			});
	
			// Calculate slopes (deltaK) and initialize tangents (mK)
			var pointsLen = pointsWithTangents.length;
			var i, pointBefore, pointCurrent, pointAfter;
			for (i = 0; i < pointsLen; ++i) {
				pointCurrent = pointsWithTangents[i];
				if (pointCurrent.model.skip) {
					continue;
				}
	
				pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
				pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
				if (pointAfter && !pointAfter.model.skip) {
					var slopeDeltaX = (pointAfter.model.x - pointCurrent.model.x);
	
					// In the case of two points that appear at the same x pixel, slopeDeltaX is 0
					pointCurrent.deltaK = slopeDeltaX !== 0 ? (pointAfter.model.y - pointCurrent.model.y) / slopeDeltaX : 0;
				}
	
				if (!pointBefore || pointBefore.model.skip) {
					pointCurrent.mK = pointCurrent.deltaK;
				} else if (!pointAfter || pointAfter.model.skip) {
					pointCurrent.mK = pointBefore.deltaK;
				} else if (this.sign(pointBefore.deltaK) !== this.sign(pointCurrent.deltaK)) {
					pointCurrent.mK = 0;
				} else {
					pointCurrent.mK = (pointBefore.deltaK + pointCurrent.deltaK) / 2;
				}
			}
	
			// Adjust tangents to ensure monotonic properties
			var alphaK, betaK, tauK, squaredMagnitude;
			for (i = 0; i < pointsLen - 1; ++i) {
				pointCurrent = pointsWithTangents[i];
				pointAfter = pointsWithTangents[i + 1];
				if (pointCurrent.model.skip || pointAfter.model.skip) {
					continue;
				}
	
				if (helpers$1.almostEquals(pointCurrent.deltaK, 0, this.EPSILON)) {
					pointCurrent.mK = pointAfter.mK = 0;
					continue;
				}
	
				alphaK = pointCurrent.mK / pointCurrent.deltaK;
				betaK = pointAfter.mK / pointCurrent.deltaK;
				squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
				if (squaredMagnitude <= 9) {
					continue;
				}
	
				tauK = 3 / Math.sqrt(squaredMagnitude);
				pointCurrent.mK = alphaK * tauK * pointCurrent.deltaK;
				pointAfter.mK = betaK * tauK * pointCurrent.deltaK;
			}
	
			// Compute control points
			var deltaX;
			for (i = 0; i < pointsLen; ++i) {
				pointCurrent = pointsWithTangents[i];
				if (pointCurrent.model.skip) {
					continue;
				}
	
				pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
				pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
				if (pointBefore && !pointBefore.model.skip) {
					deltaX = (pointCurrent.model.x - pointBefore.model.x) / 3;
					pointCurrent.model.controlPointPreviousX = pointCurrent.model.x - deltaX;
					pointCurrent.model.controlPointPreviousY = pointCurrent.model.y - deltaX * pointCurrent.mK;
				}
				if (pointAfter && !pointAfter.model.skip) {
					deltaX = (pointAfter.model.x - pointCurrent.model.x) / 3;
					pointCurrent.model.controlPointNextX = pointCurrent.model.x + deltaX;
					pointCurrent.model.controlPointNextY = pointCurrent.model.y + deltaX * pointCurrent.mK;
				}
			}
		};
		helpers$1.nextItem = function(collection, index, loop) {
			if (loop) {
				return index >= collection.length - 1 ? collection[0] : collection[index + 1];
			}
			return index >= collection.length - 1 ? collection[collection.length - 1] : collection[index + 1];
		};
		helpers$1.previousItem = function(collection, index, loop) {
			if (loop) {
				return index <= 0 ? collection[collection.length - 1] : collection[index - 1];
			}
			return index <= 0 ? collection[0] : collection[index - 1];
		};
		// Implementation of the nice number algorithm used in determining where axis labels will go
		helpers$1.niceNum = function(range, round) {
			var exponent = Math.floor(helpers$1.log10(range));
			var fraction = range / Math.pow(10, exponent);
			var niceFraction;
	
			if (round) {
				if (fraction < 1.5) {
					niceFraction = 1;
				} else if (fraction < 3) {
					niceFraction = 2;
				} else if (fraction < 7) {
					niceFraction = 5;
				} else {
					niceFraction = 10;
				}
			} else if (fraction <= 1.0) {
				niceFraction = 1;
			} else if (fraction <= 2) {
				niceFraction = 2;
			} else if (fraction <= 5) {
				niceFraction = 5;
			} else {
				niceFraction = 10;
			}
	
			return niceFraction * Math.pow(10, exponent);
		};
		// Request animation polyfill - https://www.paulirish.com/2011/requestanimationframe-for-smart-animating/
		helpers$1.requestAnimFrame = (function() {
			if (typeof window === 'undefined') {
				return function(callback) {
					callback();
				};
			}
			return window.requestAnimationFrame ||
				window.webkitRequestAnimationFrame ||
				window.mozRequestAnimationFrame ||
				window.oRequestAnimationFrame ||
				window.msRequestAnimationFrame ||
				function(callback) {
					return window.setTimeout(callback, 1000 / 60);
				};
		}());
		// -- DOM methods
		helpers$1.getRelativePosition = function(evt, chart) {
			var mouseX, mouseY;
			var e = evt.originalEvent || evt;
			var canvas = evt.target || evt.srcElement;
			var boundingRect = canvas.getBoundingClientRect();
	
			var touches = e.touches;
			if (touches && touches.length > 0) {
				mouseX = touches[0].clientX;
				mouseY = touches[0].clientY;
	
			} else {
				mouseX = e.clientX;
				mouseY = e.clientY;
			}
	
			// Scale mouse coordinates into canvas coordinates
			// by following the pattern laid out by 'jerryj' in the comments of
			// https://www.html5canvastutorials.com/advanced/html5-canvas-mouse-coordinates/
			var paddingLeft = parseFloat(helpers$1.getStyle(canvas, 'padding-left'));
			var paddingTop = parseFloat(helpers$1.getStyle(canvas, 'padding-top'));
			var paddingRight = parseFloat(helpers$1.getStyle(canvas, 'padding-right'));
			var paddingBottom = parseFloat(helpers$1.getStyle(canvas, 'padding-bottom'));
			var width = boundingRect.right - boundingRect.left - paddingLeft - paddingRight;
			var height = boundingRect.bottom - boundingRect.top - paddingTop - paddingBottom;
	
			// We divide by the current device pixel ratio, because the canvas is scaled up by that amount in each direction. However
			// the backend model is in unscaled coordinates. Since we are going to deal with our model coordinates, we go back here
			mouseX = Math.round((mouseX - boundingRect.left - paddingLeft) / (width) * canvas.width / chart.currentDevicePixelRatio);
			mouseY = Math.round((mouseY - boundingRect.top - paddingTop) / (height) * canvas.height / chart.currentDevicePixelRatio);
	
			return {
				x: mouseX,
				y: mouseY
			};
	
		};
	
		// Private helper function to convert max-width/max-height values that may be percentages into a number
		function parseMaxStyle(styleValue, node, parentProperty) {
			var valueInPixels;
			if (typeof styleValue === 'string') {
				valueInPixels = parseInt(styleValue, 10);
	
				if (styleValue.indexOf('%') !== -1) {
					// percentage * size in dimension
					valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
				}
			} else {
				valueInPixels = styleValue;
			}
	
			return valueInPixels;
		}
	
		/**
		 * Returns if the given value contains an effective constraint.
		 * @private
		 */
		function isConstrainedValue(value) {
			return value !== undefined && value !== null && value !== 'none';
		}
	
		/**
		 * Returns the max width or height of the given DOM node in a cross-browser compatible fashion
		 * @param {HTMLElement} domNode - the node to check the constraint on
		 * @param {string} maxStyle - the style that defines the maximum for the direction we are using ('max-width' / 'max-height')
		 * @param {string} percentageProperty - property of parent to use when calculating width as a percentage
		 * @see {@link https://www.nathanaeljones.com/blog/2013/reading-max-width-cross-browser}
		 */
		function getConstraintDimension(domNode, maxStyle, percentageProperty) {
			var view = document.defaultView;
			var parentNode = helpers$1._getParentNode(domNode);
			var constrainedNode = view.getComputedStyle(domNode)[maxStyle];
			var constrainedContainer = view.getComputedStyle(parentNode)[maxStyle];
			var hasCNode = isConstrainedValue(constrainedNode);
			var hasCContainer = isConstrainedValue(constrainedContainer);
			var infinity = Number.POSITIVE_INFINITY;
	
			if (hasCNode || hasCContainer) {
				return Math.min(
					hasCNode ? parseMaxStyle(constrainedNode, domNode, percentageProperty) : infinity,
					hasCContainer ? parseMaxStyle(constrainedContainer, parentNode, percentageProperty) : infinity);
			}
	
			return 'none';
		}
		// returns Number or undefined if no constraint
		helpers$1.getConstraintWidth = function(domNode) {
			return getConstraintDimension(domNode, 'max-width', 'clientWidth');
		};
		// returns Number or undefined if no constraint
		helpers$1.getConstraintHeight = function(domNode) {
			return getConstraintDimension(domNode, 'max-height', 'clientHeight');
		};
		/**
		 * @private
	 	 */
		helpers$1._calculatePadding = function(container, padding, parentDimension) {
			padding = helpers$1.getStyle(container, padding);
	
			return padding.indexOf('%') > -1 ? parentDimension * parseInt(padding, 10) / 100 : parseInt(padding, 10);
		};
		/**
		 * @private
		 */
		helpers$1._getParentNode = function(domNode) {
			var parent = domNode.parentNode;
			if (parent && parent.toString() === '[object ShadowRoot]') {
				parent = parent.host;
			}
			return parent;
		};
		helpers$1.getMaximumWidth = function(domNode) {
			var container = helpers$1._getParentNode(domNode);
			if (!container) {
				return domNode.clientWidth;
			}
	
			var clientWidth = container.clientWidth;
			var paddingLeft = helpers$1._calculatePadding(container, 'padding-left', clientWidth);
			var paddingRight = helpers$1._calculatePadding(container, 'padding-right', clientWidth);
	
			var w = clientWidth - paddingLeft - paddingRight;
			var cw = helpers$1.getConstraintWidth(domNode);
			return isNaN(cw) ? w : Math.min(w, cw);
		};
		helpers$1.getMaximumHeight = function(domNode) {
			var container = helpers$1._getParentNode(domNode);
			if (!container) {
				return domNode.clientHeight;
			}
	
			var clientHeight = container.clientHeight;
			var paddingTop = helpers$1._calculatePadding(container, 'padding-top', clientHeight);
			var paddingBottom = helpers$1._calculatePadding(container, 'padding-bottom', clientHeight);
	
			var h = clientHeight - paddingTop - paddingBottom;
			var ch = helpers$1.getConstraintHeight(domNode);
			return isNaN(ch) ? h : Math.min(h, ch);
		};
		helpers$1.getStyle = function(el, property) {
			return el.currentStyle ?
				el.currentStyle[property] :
				document.defaultView.getComputedStyle(el, null).getPropertyValue(property);
		};
		helpers$1.retinaScale = function(chart, forceRatio) {
			var pixelRatio = chart.currentDevicePixelRatio = forceRatio || (typeof window !== 'undefined' && window.devicePixelRatio) || 1;
			if (pixelRatio === 1) {
				return;
			}
	
			var canvas = chart.canvas;
			var height = chart.height;
			var width = chart.width;
	
			canvas.height = height * pixelRatio;
			canvas.width = width * pixelRatio;
			chart.ctx.scale(pixelRatio, pixelRatio);
	
			// If no style has been set on the canvas, the render size is used as display size,
			// making the chart visually bigger, so let's enforce it to the "correct" values.
			// See https://github.com/chartjs/Chart.js/issues/3575
			if (!canvas.style.height && !canvas.style.width) {
				canvas.style.height = height + 'px';
				canvas.style.width = width + 'px';
			}
		};
		// -- Canvas methods
		helpers$1.fontString = function(pixelSize, fontStyle, fontFamily) {
			return fontStyle + ' ' + pixelSize + 'px ' + fontFamily;
		};
		helpers$1.longestText = function(ctx, font, arrayOfThings, cache) {
			cache = cache || {};
			var data = cache.data = cache.data || {};
			var gc = cache.garbageCollect = cache.garbageCollect || [];
	
			if (cache.font !== font) {
				data = cache.data = {};
				gc = cache.garbageCollect = [];
				cache.font = font;
			}
	
			ctx.font = font;
			var longest = 0;
			var ilen = arrayOfThings.length;
			var i, j, jlen, thing, nestedThing;
			for (i = 0; i < ilen; i++) {
				thing = arrayOfThings[i];
	
				// Undefined strings and arrays should not be measured
				if (thing !== undefined && thing !== null && helpers$1.isArray(thing) !== true) {
					longest = helpers$1.measureText(ctx, data, gc, longest, thing);
				} else if (helpers$1.isArray(thing)) {
					// if it is an array lets measure each element
					// to do maybe simplify this function a bit so we can do this more recursively?
					for (j = 0, jlen = thing.length; j < jlen; j++) {
						nestedThing = thing[j];
						// Undefined strings and arrays should not be measured
						if (nestedThing !== undefined && nestedThing !== null && !helpers$1.isArray(nestedThing)) {
							longest = helpers$1.measureText(ctx, data, gc, longest, nestedThing);
						}
					}
				}
			}
	
			var gcLen = gc.length / 2;
			if (gcLen > arrayOfThings.length) {
				for (i = 0; i < gcLen; i++) {
					delete data[gc[i]];
				}
				gc.splice(0, gcLen);
			}
			return longest;
		};
		helpers$1.measureText = function(ctx, data, gc, longest, string) {
			var textWidth = data[string];
			if (!textWidth) {
				textWidth = data[string] = ctx.measureText(string).width;
				gc.push(string);
			}
			if (textWidth > longest) {
				longest = textWidth;
			}
			return longest;
		};
	
		/**
		 * @deprecated
		 */
		helpers$1.numberOfLabelLines = function(arrayOfThings) {
			var numberOfLines = 1;
			helpers$1.each(arrayOfThings, function(thing) {
				if (helpers$1.isArray(thing)) {
					if (thing.length > numberOfLines) {
						numberOfLines = thing.length;
					}
				}
			});
			return numberOfLines;
		};
	
		helpers$1.color = !chartjsColor ?
			function(value) {
				console.error('Color.js not found!');
				return value;
			} :
			function(value) {
				/* global CanvasGradient */
				if (value instanceof CanvasGradient) {
					value = core_defaults.global.defaultColor;
				}
	
				return chartjsColor(value);
			};
	
		helpers$1.getHoverColor = function(colorValue) {
			/* global CanvasPattern */
			return (colorValue instanceof CanvasPattern || colorValue instanceof CanvasGradient) ?
				colorValue :
				helpers$1.color(colorValue).saturate(0.5).darken(0.1).rgbString();
		};
	};
	
	function abstract() {
		throw new Error(
			'This method is not implemented: either no adapter can ' +
			'be found or an incomplete integration was provided.'
		);
	}
	
	/**
	 * Date adapter (current used by the time scale)
	 * @namespace Chart._adapters._date
	 * @memberof Chart._adapters
	 * @private
	 */
	
	/**
	 * Currently supported unit string values.
	 * @typedef {('millisecond'|'second'|'minute'|'hour'|'day'|'week'|'month'|'quarter'|'year')}
	 * @memberof Chart._adapters._date
	 * @name Unit
	 */
	
	/**
	 * @class
	 */
	function DateAdapter(options) {
		this.options = options || {};
	}
	
	helpers$1.extend(DateAdapter.prototype, /** @lends DateAdapter */ {
		/**
		 * Returns a map of time formats for the supported formatting units defined
		 * in Unit as well as 'datetime' representing a detailed date/time string.
		 * @returns {{string: string}}
		 */
		formats: abstract,
	
		/**
		 * Parses the given `value` and return the associated timestamp.
		 * @param {any} value - the value to parse (usually comes from the data)
		 * @param {string} [format] - the expected data format
		 * @returns {(number|null)}
		 * @function
		 */
		parse: abstract,
	
		/**
		 * Returns the formatted date in the specified `format` for a given `timestamp`.
		 * @param {number} timestamp - the timestamp to format
		 * @param {string} format - the date/time token
		 * @return {string}
		 * @function
		 */
		format: abstract,
	
		/**
		 * Adds the specified `amount` of `unit` to the given `timestamp`.
		 * @param {number} timestamp - the input timestamp
		 * @param {number} amount - the amount to add
		 * @param {Unit} unit - the unit as string
		 * @return {number}
		 * @function
		 */
		add: abstract,
	
		/**
		 * Returns the number of `unit` between the given timestamps.
		 * @param {number} max - the input timestamp (reference)
		 * @param {number} min - the timestamp to substract
		 * @param {Unit} unit - the unit as string
		 * @return {number}
		 * @function
		 */
		diff: abstract,
	
		/**
		 * Returns start of `unit` for the given `timestamp`.
		 * @param {number} timestamp - the input timestamp
		 * @param {Unit} unit - the unit as string
		 * @param {number} [weekday] - the ISO day of the week with 1 being Monday
		 * and 7 being Sunday (only needed if param *unit* is `isoWeek`).
		 * @function
		 */
		startOf: abstract,
	
		/**
		 * Returns end of `unit` for the given `timestamp`.
		 * @param {number} timestamp - the input timestamp
		 * @param {Unit} unit - the unit as string
		 * @function
		 */
		endOf: abstract,
	
		// DEPRECATIONS
	
		/**
		 * Provided for backward compatibility for scale.getValueForPixel(),
		 * this method should be overridden only by the moment adapter.
		 * @deprecated since version 2.8.0
		 * @todo remove at version 3
		 * @private
		 */
		_create: function(value) {
			return value;
		}
	});
	
	DateAdapter.override = function(members) {
		helpers$1.extend(DateAdapter.prototype, members);
	};
	
	var _date = DateAdapter;
	
	var core_adapters = {
		_date: _date
	};
	
	/**
	 * Namespace to hold static tick generation functions
	 * @namespace Chart.Ticks
	 */
	var core_ticks = {
		/**
		 * Namespace to hold formatters for different types of ticks
		 * @namespace Chart.Ticks.formatters
		 */
		formatters: {
			/**
			 * Formatter for value labels
			 * @method Chart.Ticks.formatters.values
			 * @param value the value to display
			 * @return {string|string[]} the label to display
			 */
			values: function(value) {
				return helpers$1.isArray(value) ? value : '' + value;
			},
	
			/**
			 * Formatter for linear numeric ticks
			 * @method Chart.Ticks.formatters.linear
			 * @param tickValue {number} the value to be formatted
			 * @param index {number} the position of the tickValue parameter in the ticks array
			 * @param ticks {number[]} the list of ticks being converted
			 * @return {string} string representation of the tickValue parameter
			 */
			linear: function(tickValue, index, ticks) {
				// If we have lots of ticks, don't use the ones
				var delta = ticks.length > 3 ? ticks[2] - ticks[1] : ticks[1] - ticks[0];
	
				// If we have a number like 2.5 as the delta, figure out how many decimal places we need
				if (Math.abs(delta) > 1) {
					if (tickValue !== Math.floor(tickValue)) {
						// not an integer
						delta = tickValue - Math.floor(tickValue);
					}
				}
	
				var logDelta = helpers$1.log10(Math.abs(delta));
				var tickString = '';
	
				if (tickValue !== 0) {
					var maxTick = Math.max(Math.abs(ticks[0]), Math.abs(ticks[ticks.length - 1]));
					if (maxTick < 1e-4) { // all ticks are small numbers; use scientific notation
						var logTick = helpers$1.log10(Math.abs(tickValue));
						var numExponential = Math.floor(logTick) - Math.floor(logDelta);
						numExponential = Math.max(Math.min(numExponential, 20), 0);
						tickString = tickValue.toExponential(numExponential);
					} else {
						var numDecimal = -1 * Math.floor(logDelta);
						numDecimal = Math.max(Math.min(numDecimal, 20), 0); // toFixed has a max of 20 decimal places
						tickString = tickValue.toFixed(numDecimal);
					}
				} else {
					tickString = '0'; // never show decimal places for 0
				}
	
				return tickString;
			},
	
			logarithmic: function(tickValue, index, ticks) {
				var remain = tickValue / (Math.pow(10, Math.floor(helpers$1.log10(tickValue))));
	
				if (tickValue === 0) {
					return '0';
				} else if (remain === 1 || remain === 2 || remain === 5 || index === 0 || index === ticks.length - 1) {
					return tickValue.toExponential();
				}
				return '';
			}
		}
	};
	
	var isArray = helpers$1.isArray;
	var isNullOrUndef = helpers$1.isNullOrUndef;
	var valueOrDefault$a = helpers$1.valueOrDefault;
	var valueAtIndexOrDefault = helpers$1.valueAtIndexOrDefault;
	
	core_defaults._set('scale', {
		display: true,
		position: 'left',
		offset: false,
	
		// grid line settings
		gridLines: {
			display: true,
			color: 'rgba(0,0,0,0.1)',
			lineWidth: 1,
			drawBorder: true,
			drawOnChartArea: true,
			drawTicks: true,
			tickMarkLength: 10,
			zeroLineWidth: 1,
			zeroLineColor: 'rgba(0,0,0,0.25)',
			zeroLineBorderDash: [],
			zeroLineBorderDashOffset: 0.0,
			offsetGridLines: false,
			borderDash: [],
			borderDashOffset: 0.0
		},
	
		// scale label
		scaleLabel: {
			// display property
			display: false,
	
			// actual label
			labelString: '',
	
			// top/bottom padding
			padding: {
				top: 4,
				bottom: 4
			}
		},
	
		// label settings
		ticks: {
			beginAtZero: false,
			minRotation: 0,
			maxRotation: 50,
			mirror: false,
			padding: 0,
			reverse: false,
			display: true,
			autoSkip: true,
			autoSkipPadding: 0,
			labelOffset: 0,
			// We pass through arrays to be rendered as multiline labels, we convert Others to strings here.
			callback: core_ticks.formatters.values,
			minor: {},
			major: {}
		}
	});
	
	/** Returns a new array containing numItems from arr */
	function sample(arr, numItems) {
		var result = [];
		var increment = arr.length / numItems;
		var i = 0;
		var len = arr.length;
	
		for (; i < len; i += increment) {
			result.push(arr[Math.floor(i)]);
		}
		return result;
	}
	
	function getPixelForGridLine(scale, index, offsetGridLines) {
		var length = scale.getTicks().length;
		var validIndex = Math.min(index, length - 1);
		var lineValue = scale.getPixelForTick(validIndex);
		var start = scale._startPixel;
		var end = scale._endPixel;
		var epsilon = 1e-6; // 1e-6 is margin in pixels for accumulated error.
		var offset;
	
		if (offsetGridLines) {
			if (length === 1) {
				offset = Math.max(lineValue - start, end - lineValue);
			} else if (index === 0) {
				offset = (scale.getPixelForTick(1) - lineValue) / 2;
			} else {
				offset = (lineValue - scale.getPixelForTick(validIndex - 1)) / 2;
			}
			lineValue += validIndex < index ? offset : -offset;
	
			// Return undefined if the pixel is out of the range
			if (lineValue < start - epsilon || lineValue > end + epsilon) {
				return;
			}
		}
		return lineValue;
	}
	
	function garbageCollect(caches, length) {
		helpers$1.each(caches, function(cache) {
			var gc = cache.gc;
			var gcLen = gc.length / 2;
			var i;
			if (gcLen > length) {
				for (i = 0; i < gcLen; ++i) {
					delete cache.data[gc[i]];
				}
				gc.splice(0, gcLen);
			}
		});
	}
	
	/**
	 * Returns {width, height, offset} objects for the first, last, widest, highest tick
	 * labels where offset indicates the anchor point offset from the top in pixels.
	 */
	function computeLabelSizes(ctx, tickFonts, ticks, caches) {
		var length = ticks.length;
		var widths = [];
		var heights = [];
		var offsets = [];
		var widestLabelSize = 0;
		var highestLabelSize = 0;
		var i, j, jlen, label, tickFont, fontString, cache, lineHeight, width, height, nestedLabel, widest, highest;
	
		for (i = 0; i < length; ++i) {
			label = ticks[i].label;
			tickFont = ticks[i].major ? tickFonts.major : tickFonts.minor;
			ctx.font = fontString = tickFont.string;
			cache = caches[fontString] = caches[fontString] || {data: {}, gc: []};
			lineHeight = tickFont.lineHeight;
			width = height = 0;
			// Undefined labels and arrays should not be measured
			if (!isNullOrUndef(label) && !isArray(label)) {
				width = helpers$1.measureText(ctx, cache.data, cache.gc, width, label);
				height = lineHeight;
			} else if (isArray(label)) {
				// if it is an array let's measure each element
				for (j = 0, jlen = label.length; j < jlen; ++j) {
					nestedLabel = label[j];
					// Undefined labels and arrays should not be measured
					if (!isNullOrUndef(nestedLabel) && !isArray(nestedLabel)) {
						width = helpers$1.measureText(ctx, cache.data, cache.gc, width, nestedLabel);
						height += lineHeight;
					}
				}
			}
			widths.push(width);
			heights.push(height);
			offsets.push(lineHeight / 2);
			widestLabelSize = Math.max(width, widestLabelSize);
			highestLabelSize = Math.max(height, highestLabelSize);
		}
		garbageCollect(caches, length);
	
		widest = widths.indexOf(widestLabelSize);
		highest = heights.indexOf(highestLabelSize);
	
		function valueAt(idx) {
			return {
				width: widths[idx] || 0,
				height: heights[idx] || 0,
				offset: offsets[idx] || 0
			};
		}
	
		return {
			first: valueAt(0),
			last: valueAt(length - 1),
			widest: valueAt(widest),
			highest: valueAt(highest)
		};
	}
	
	function getTickMarkLength(options) {
		return options.drawTicks ? options.tickMarkLength : 0;
	}
	
	function getScaleLabelHeight(options) {
		var font, padding;
	
		if (!options.display) {
			return 0;
		}
	
		font = helpers$1.options._parseFont(options);
		padding = helpers$1.options.toPadding(options.padding);
	
		return font.lineHeight + padding.height;
	}
	
	function parseFontOptions(options, nestedOpts) {
		return helpers$1.extend(helpers$1.options._parseFont({
			fontFamily: valueOrDefault$a(nestedOpts.fontFamily, options.fontFamily),
			fontSize: valueOrDefault$a(nestedOpts.fontSize, options.fontSize),
			fontStyle: valueOrDefault$a(nestedOpts.fontStyle, options.fontStyle),
			lineHeight: valueOrDefault$a(nestedOpts.lineHeight, options.lineHeight)
		}), {
			color: helpers$1.options.resolve([nestedOpts.fontColor, options.fontColor, core_defaults.global.defaultFontColor])
		});
	}
	
	function parseTickFontOptions(options) {
		var minor = parseFontOptions(options, options.minor);
		var major = options.major.enabled ? parseFontOptions(options, options.major) : minor;
	
		return {minor: minor, major: major};
	}
	
	function nonSkipped(ticksToFilter) {
		var filtered = [];
		var item, index, len;
		for (index = 0, len = ticksToFilter.length; index < len; ++index) {
			item = ticksToFilter[index];
			if (typeof item._index !== 'undefined') {
				filtered.push(item);
			}
		}
		return filtered;
	}
	
	function getEvenSpacing(arr) {
		var len = arr.length;
		var i, diff;
	
		if (len < 2) {
			return false;
		}
	
		for (diff = arr[0], i = 1; i < len; ++i) {
			if (arr[i] - arr[i - 1] !== diff) {
				return false;
			}
		}
		return diff;
	}
	
	function calculateSpacing(majorIndices, ticks, axisLength, ticksLimit) {
		var evenMajorSpacing = getEvenSpacing(majorIndices);
		var spacing = (ticks.length - 1) / ticksLimit;
		var factors, factor, i, ilen;
	
		// If the major ticks are evenly spaced apart, place the minor ticks
		// so that they divide the major ticks into even chunks
		if (!evenMajorSpacing) {
			return Math.max(spacing, 1);
		}
	
		factors = helpers$1.math._factorize(evenMajorSpacing);
		for (i = 0, ilen = factors.length - 1; i < ilen; i++) {
			factor = factors[i];
			if (factor > spacing) {
				return factor;
			}
		}
		return Math.max(spacing, 1);
	}
	
	function getMajorIndices(ticks) {
		var result = [];
		var i, ilen;
		for (i = 0, ilen = ticks.length; i < ilen; i++) {
			if (ticks[i].major) {
				result.push(i);
			}
		}
		return result;
	}
	
	function skipMajors(ticks, majorIndices, spacing) {
		var count = 0;
		var next = majorIndices[0];
		var i, tick;
	
		spacing = Math.ceil(spacing);
		for (i = 0; i < ticks.length; i++) {
			tick = ticks[i];
			if (i === next) {
				tick._index = i;
				count++;
				next = majorIndices[count * spacing];
			} else {
				delete tick.label;
			}
		}
	}
	
	function skip(ticks, spacing, majorStart, majorEnd) {
		var start = valueOrDefault$a(majorStart, 0);
		var end = Math.min(valueOrDefault$a(majorEnd, ticks.length), ticks.length);
		var count = 0;
		var length, i, tick, next;
	
		spacing = Math.ceil(spacing);
		if (majorEnd) {
			length = majorEnd - majorStart;
			spacing = length / Math.floor(length / spacing);
		}
	
		next = start;
	
		while (next < 0) {
			count++;
			next = Math.round(start + count * spacing);
		}
	
		for (i = Math.max(start, 0); i < end; i++) {
			tick = ticks[i];
			if (i === next) {
				tick._index = i;
				count++;
				next = Math.round(start + count * spacing);
			} else {
				delete tick.label;
			}
		}
	}
	
	var Scale = core_element.extend({
	
		zeroLineIndex: 0,
	
		/**
		 * Get the padding needed for the scale
		 * @method getPadding
		 * @private
		 * @returns {Padding} the necessary padding
		 */
		getPadding: function() {
			var me = this;
			return {
				left: me.paddingLeft || 0,
				top: me.paddingTop || 0,
				right: me.paddingRight || 0,
				bottom: me.paddingBottom || 0
			};
		},
	
		/**
		 * Returns the scale tick objects ({label, major})
		 * @since 2.7
		 */
		getTicks: function() {
			return this._ticks;
		},
	
		/**
		* @private
		*/
		_getLabels: function() {
			var data = this.chart.data;
			return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels || [];
		},
	
		// These methods are ordered by lifecyle. Utilities then follow.
		// Any function defined here is inherited by all scale types.
		// Any function can be extended by the scale type
	
		/**
		 * Provided for backward compatibility, not available anymore
		 * @function Chart.Scale.mergeTicksOptions
		 * @deprecated since version 2.8.0
		 * @todo remove at version 3
		 */
		mergeTicksOptions: function() {
			// noop
		},
	
		beforeUpdate: function() {
			helpers$1.callback(this.options.beforeUpdate, [this]);
		},
	
		/**
		 * @param {number} maxWidth - the max width in pixels
		 * @param {number} maxHeight - the max height in pixels
		 * @param {object} margins - the space between the edge of the other scales and edge of the chart
		 *   This space comes from two sources:
		 *     - padding - space that's required to show the labels at the edges of the scale
		 *     - thickness of scales or legends in another orientation
		 */
		update: function(maxWidth, maxHeight, margins) {
			var me = this;
			var tickOpts = me.options.ticks;
			var sampleSize = tickOpts.sampleSize;
			var i, ilen, labels, ticks, samplingEnabled;
	
			// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
			me.beforeUpdate();
	
			// Absorb the master measurements
			me.maxWidth = maxWidth;
			me.maxHeight = maxHeight;
			me.margins = helpers$1.extend({
				left: 0,
				right: 0,
				top: 0,
				bottom: 0
			}, margins);
	
			me._ticks = null;
			me.ticks = null;
			me._labelSizes = null;
			me._maxLabelLines = 0;
			me.longestLabelWidth = 0;
			me.longestTextCache = me.longestTextCache || {};
			me._gridLineItems = null;
			me._labelItems = null;
	
			// Dimensions
			me.beforeSetDimensions();
			me.setDimensions();
			me.afterSetDimensions();
	
			// Data min/max
			me.beforeDataLimits();
			me.determineDataLimits();
			me.afterDataLimits();
	
			// Ticks - `this.ticks` is now DEPRECATED!
			// Internal ticks are now stored as objects in the PRIVATE `this._ticks` member
			// and must not be accessed directly from outside this class. `this.ticks` being
			// around for long time and not marked as private, we can't change its structure
			// without unexpected breaking changes. If you need to access the scale ticks,
			// use scale.getTicks() instead.
	
			me.beforeBuildTicks();
	
			// New implementations should return an array of objects but for BACKWARD COMPAT,
			// we still support no return (`this.ticks` internally set by calling this method).
			ticks = me.buildTicks() || [];
	
			// Allow modification of ticks in callback.
			ticks = me.afterBuildTicks(ticks) || ticks;
	
			// Ensure ticks contains ticks in new tick format
			if ((!ticks || !ticks.length) && me.ticks) {
				ticks = [];
				for (i = 0, ilen = me.ticks.length; i < ilen; ++i) {
					ticks.push({
						value: me.ticks[i],
						major: false
					});
				}
			}
	
			me._ticks = ticks;
	
			// Compute tick rotation and fit using a sampled subset of labels
			// We generally don't need to compute the size of every single label for determining scale size
			samplingEnabled = sampleSize < ticks.length;
			labels = me._convertTicksToLabels(samplingEnabled ? sample(ticks, sampleSize) : ticks);
	
			// _configure is called twice, once here, once from core.controller.updateLayout.
			// Here we haven't been positioned yet, but dimensions are correct.
			// Variables set in _configure are needed for calculateTickRotation, and
			// it's ok that coordinates are not correct there, only dimensions matter.
			me._configure();
	
			// Tick Rotation
			me.beforeCalculateTickRotation();
			me.calculateTickRotation();
			me.afterCalculateTickRotation();
	
			me.beforeFit();
			me.fit();
			me.afterFit();
	
			// Auto-skip
			me._ticksToDraw = tickOpts.display && (tickOpts.autoSkip || tickOpts.source === 'auto') ? me._autoSkip(ticks) : ticks;
	
			if (samplingEnabled) {
				// Generate labels using all non-skipped ticks
				labels = me._convertTicksToLabels(me._ticksToDraw);
			}
	
			me.ticks = labels;   // BACKWARD COMPATIBILITY
	
			// IMPORTANT: after this point, we consider that `this.ticks` will NEVER change!
	
			me.afterUpdate();
	
			// TODO(v3): remove minSize as a public property and return value from all layout boxes. It is unused
			// make maxWidth and maxHeight private
			return me.minSize;
		},
	
		/**
		 * @private
		 */
		_configure: function() {
			var me = this;
			var reversePixels = me.options.ticks.reverse;
			var startPixel, endPixel;
	
			if (me.isHorizontal()) {
				startPixel = me.left;
				endPixel = me.right;
			} else {
				startPixel = me.top;
				endPixel = me.bottom;
				// by default vertical scales are from bottom to top, so pixels are reversed
				reversePixels = !reversePixels;
			}
			me._startPixel = startPixel;
			me._endPixel = endPixel;
			me._reversePixels = reversePixels;
			me._length = endPixel - startPixel;
		},
	
		afterUpdate: function() {
			helpers$1.callback(this.options.afterUpdate, [this]);
		},
	
		//
	
		beforeSetDimensions: function() {
			helpers$1.callback(this.options.beforeSetDimensions, [this]);
		},
		setDimensions: function() {
			var me = this;
			// Set the unconstrained dimension before label rotation
			if (me.isHorizontal()) {
				// Reset position before calculating rotation
				me.width = me.maxWidth;
				me.left = 0;
				me.right = me.width;
			} else {
				me.height = me.maxHeight;
	
				// Reset position before calculating rotation
				me.top = 0;
				me.bottom = me.height;
			}
	
			// Reset padding
			me.paddingLeft = 0;
			me.paddingTop = 0;
			me.paddingRight = 0;
			me.paddingBottom = 0;
		},
		afterSetDimensions: function() {
			helpers$1.callback(this.options.afterSetDimensions, [this]);
		},
	
		// Data limits
		beforeDataLimits: function() {
			helpers$1.callback(this.options.beforeDataLimits, [this]);
		},
		determineDataLimits: helpers$1.noop,
		afterDataLimits: function() {
			helpers$1.callback(this.options.afterDataLimits, [this]);
		},
	
		//
		beforeBuildTicks: function() {
			helpers$1.callback(this.options.beforeBuildTicks, [this]);
		},
		buildTicks: helpers$1.noop,
		afterBuildTicks: function(ticks) {
			var me = this;
			// ticks is empty for old axis implementations here
			if (isArray(ticks) && ticks.length) {
				return helpers$1.callback(me.options.afterBuildTicks, [me, ticks]);
			}
			// Support old implementations (that modified `this.ticks` directly in buildTicks)
			me.ticks = helpers$1.callback(me.options.afterBuildTicks, [me, me.ticks]) || me.ticks;
			return ticks;
		},
	
		beforeTickToLabelConversion: function() {
			helpers$1.callback(this.options.beforeTickToLabelConversion, [this]);
		},
		convertTicksToLabels: function() {
			var me = this;
			// Convert ticks to strings
			var tickOpts = me.options.ticks;
			me.ticks = me.ticks.map(tickOpts.userCallback || tickOpts.callback, this);
		},
		afterTickToLabelConversion: function() {
			helpers$1.callback(this.options.afterTickToLabelConversion, [this]);
		},
	
		//
	
		beforeCalculateTickRotation: function() {
			helpers$1.callback(this.options.beforeCalculateTickRotation, [this]);
		},
		calculateTickRotation: function() {
			var me = this;
			var options = me.options;
			var tickOpts = options.ticks;
			var numTicks = me.getTicks().length;
			var minRotation = tickOpts.minRotation || 0;
			var maxRotation = tickOpts.maxRotation;
			var labelRotation = minRotation;
			var labelSizes, maxLabelWidth, maxLabelHeight, maxWidth, tickWidth, maxHeight, maxLabelDiagonal;
	
			if (!me._isVisible() || !tickOpts.display || minRotation >= maxRotation || numTicks <= 1 || !me.isHorizontal()) {
				me.labelRotation = minRotation;
				return;
			}
	
			labelSizes = me._getLabelSizes();
			maxLabelWidth = labelSizes.widest.width;
			maxLabelHeight = labelSizes.highest.height - labelSizes.highest.offset;
	
			// Estimate the width of each grid based on the canvas width, the maximum
			// label width and the number of tick intervals
			maxWidth = Math.min(me.maxWidth, me.chart.width - maxLabelWidth);
			tickWidth = options.offset ? me.maxWidth / numTicks : maxWidth / (numTicks - 1);
	
			// Allow 3 pixels x2 padding either side for label readability
			if (maxLabelWidth + 6 > tickWidth) {
				tickWidth = maxWidth / (numTicks - (options.offset ? 0.5 : 1));
				maxHeight = me.maxHeight - getTickMarkLength(options.gridLines)
					- tickOpts.padding - getScaleLabelHeight(options.scaleLabel);
				maxLabelDiagonal = Math.sqrt(maxLabelWidth * maxLabelWidth + maxLabelHeight * maxLabelHeight);
				labelRotation = helpers$1.toDegrees(Math.min(
					Math.asin(Math.min((labelSizes.highest.height + 6) / tickWidth, 1)),
					Math.asin(Math.min(maxHeight / maxLabelDiagonal, 1)) - Math.asin(maxLabelHeight / maxLabelDiagonal)
				));
				labelRotation = Math.max(minRotation, Math.min(maxRotation, labelRotation));
			}
	
			me.labelRotation = labelRotation;
		},
		afterCalculateTickRotation: function() {
			helpers$1.callback(this.options.afterCalculateTickRotation, [this]);
		},
	
		//
	
		beforeFit: function() {
			helpers$1.callback(this.options.beforeFit, [this]);
		},
		fit: function() {
			var me = this;
			// Reset
			var minSize = me.minSize = {
				width: 0,
				height: 0
			};
	
			var chart = me.chart;
			var opts = me.options;
			var tickOpts = opts.ticks;
			var scaleLabelOpts = opts.scaleLabel;
			var gridLineOpts = opts.gridLines;
			var display = me._isVisible();
			var isBottom = opts.position === 'bottom';
			var isHorizontal = me.isHorizontal();
	
			// Width
			if (isHorizontal) {
				minSize.width = me.maxWidth;
			} else if (display) {
				minSize.width = getTickMarkLength(gridLineOpts) + getScaleLabelHeight(scaleLabelOpts);
			}
	
			// height
			if (!isHorizontal) {
				minSize.height = me.maxHeight; // fill all the height
			} else if (display) {
				minSize.height = getTickMarkLength(gridLineOpts) + getScaleLabelHeight(scaleLabelOpts);
			}
	
			// Don't bother fitting the ticks if we are not showing the labels
			if (tickOpts.display && display) {
				var tickFonts = parseTickFontOptions(tickOpts);
				var labelSizes = me._getLabelSizes();
				var firstLabelSize = labelSizes.first;
				var lastLabelSize = labelSizes.last;
				var widestLabelSize = labelSizes.widest;
				var highestLabelSize = labelSizes.highest;
				var lineSpace = tickFonts.minor.lineHeight * 0.4;
				var tickPadding = tickOpts.padding;
	
				if (isHorizontal) {
					// A horizontal axis is more constrained by the height.
					var isRotated = me.labelRotation !== 0;
					var angleRadians = helpers$1.toRadians(me.labelRotation);
					var cosRotation = Math.cos(angleRadians);
					var sinRotation = Math.sin(angleRadians);
	
					var labelHeight = sinRotation * widestLabelSize.width
						+ cosRotation * (highestLabelSize.height - (isRotated ? highestLabelSize.offset : 0))
						+ (isRotated ? 0 : lineSpace); // padding
	
					minSize.height = Math.min(me.maxHeight, minSize.height + labelHeight + tickPadding);
	
					var offsetLeft = me.getPixelForTick(0) - me.left;
					var offsetRight = me.right - me.getPixelForTick(me.getTicks().length - 1);
					var paddingLeft, paddingRight;
	
					// Ensure that our ticks are always inside the canvas. When rotated, ticks are right aligned
					// which means that the right padding is dominated by the font height
					if (isRotated) {
						paddingLeft = isBottom ?
							cosRotation * firstLabelSize.width + sinRotation * firstLabelSize.offset :
							sinRotation * (firstLabelSize.height - firstLabelSize.offset);
						paddingRight = isBottom ?
							sinRotation * (lastLabelSize.height - lastLabelSize.offset) :
							cosRotation * lastLabelSize.width + sinRotation * lastLabelSize.offset;
					} else {
						paddingLeft = firstLabelSize.width / 2;
						paddingRight = lastLabelSize.width / 2;
					}
	
					// Adjust padding taking into account changes in offsets
					// and add 3 px to move away from canvas edges
					me.paddingLeft = Math.max((paddingLeft - offsetLeft) * me.width / (me.width - offsetLeft), 0) + 3;
					me.paddingRight = Math.max((paddingRight - offsetRight) * me.width / (me.width - offsetRight), 0) + 3;
				} else {
					// A vertical axis is more constrained by the width. Labels are the
					// dominant factor here, so get that length first and account for padding
					var labelWidth = tickOpts.mirror ? 0 :
						// use lineSpace for consistency with horizontal axis
						// tickPadding is not implemented for horizontal
						widestLabelSize.width + tickPadding + lineSpace;
	
					minSize.width = Math.min(me.maxWidth, minSize.width + labelWidth);
	
					me.paddingTop = firstLabelSize.height / 2;
					me.paddingBottom = lastLabelSize.height / 2;
				}
			}
	
			me.handleMargins();
	
			if (isHorizontal) {
				me.width = me._length = chart.width - me.margins.left - me.margins.right;
				me.height = minSize.height;
			} else {
				me.width = minSize.width;
				me.height = me._length = chart.height - me.margins.top - me.margins.bottom;
			}
		},
	
		/**
		 * Handle margins and padding interactions
		 * @private
		 */
		handleMargins: function() {
			var me = this;
			if (me.margins) {
				me.margins.left = Math.max(me.paddingLeft, me.margins.left);
				me.margins.top = Math.max(me.paddingTop, me.margins.top);
				me.margins.right = Math.max(me.paddingRight, me.margins.right);
				me.margins.bottom = Math.max(me.paddingBottom, me.margins.bottom);
			}
		},
	
		afterFit: function() {
			helpers$1.callback(this.options.afterFit, [this]);
		},
	
		// Shared Methods
		isHorizontal: function() {
			var pos = this.options.position;
			return pos === 'top' || pos === 'bottom';
		},
		isFullWidth: function() {
			return this.options.fullWidth;
		},
	
		// Get the correct value. NaN bad inputs, If the value type is object get the x or y based on whether we are horizontal or not
		getRightValue: function(rawValue) {
			// Null and undefined values first
			if (isNullOrUndef(rawValue)) {
				return NaN;
			}
			// isNaN(object) returns true, so make sure NaN is checking for a number; Discard Infinite values
			if ((typeof rawValue === 'number' || rawValue instanceof Number) && !isFinite(rawValue)) {
				return NaN;
			}
	
			// If it is in fact an object, dive in one more level
			if (rawValue) {
				if (this.isHorizontal()) {
					if (rawValue.x !== undefined) {
						return this.getRightValue(rawValue.x);
					}
				} else if (rawValue.y !== undefined) {
					return this.getRightValue(rawValue.y);
				}
			}
	
			// Value is good, return it
			return rawValue;
		},
	
		_convertTicksToLabels: function(ticks) {
			var me = this;
			var labels, i, ilen;
	
			me.ticks = ticks.map(function(tick) {
				return tick.value;
			});
	
			me.beforeTickToLabelConversion();
	
			// New implementations should return the formatted tick labels but for BACKWARD
			// COMPAT, we still support no return (`this.ticks` internally changed by calling
			// this method and supposed to contain only string values).
			labels = me.convertTicksToLabels(ticks) || me.ticks;
	
			me.afterTickToLabelConversion();
	
			// BACKWARD COMPAT: synchronize `_ticks` with labels (so potentially `this.ticks`)
			for (i = 0, ilen = ticks.length; i < ilen; ++i) {
				ticks[i].label = labels[i];
			}
	
			return labels;
		},
	
		/**
		 * @private
		 */
		_getLabelSizes: function() {
			var me = this;
			var labelSizes = me._labelSizes;
	
			if (!labelSizes) {
				me._labelSizes = labelSizes = computeLabelSizes(me.ctx, parseTickFontOptions(me.options.ticks), me.getTicks(), me.longestTextCache);
				me.longestLabelWidth = labelSizes.widest.width;
			}
	
			return labelSizes;
		},
	
		/**
		 * @private
		 */
		_parseValue: function(value) {
			var start, end, min, max;
	
			if (isArray(value)) {
				start = +this.getRightValue(value[0]);
				end = +this.getRightValue(value[1]);
				min = Math.min(start, end);
				max = Math.max(start, end);
			} else {
				value = +this.getRightValue(value);
				start = undefined;
				end = value;
				min = value;
				max = value;
			}
	
			return {
				min: min,
				max: max,
				start: start,
				end: end
			};
		},
	
		/**
		* @private
		*/
		_getScaleLabel: function(rawValue) {
			var v = this._parseValue(rawValue);
			if (v.start !== undefined) {
				return '[' + v.start + ', ' + v.end + ']';
			}
	
			return +this.getRightValue(rawValue);
		},
	
		/**
		 * Used to get the value to display in the tooltip for the data at the given index
		 * @param index
		 * @param datasetIndex
		 */
		getLabelForIndex: helpers$1.noop,
	
		/**
		 * Returns the location of the given data point. Value can either be an index or a numerical value
		 * The coordinate (0, 0) is at the upper-left corner of the canvas
		 * @param value
		 * @param index
		 * @param datasetIndex
		 */
		getPixelForValue: helpers$1.noop,
	
		/**
		 * Used to get the data value from a given pixel. This is the inverse of getPixelForValue
		 * The coordinate (0, 0) is at the upper-left corner of the canvas
		 * @param pixel
		 */
		getValueForPixel: helpers$1.noop,
	
		/**
		 * Returns the location of the tick at the given index
		 * The coordinate (0, 0) is at the upper-left corner of the canvas
		 */
		getPixelForTick: function(index) {
			var me = this;
			var offset = me.options.offset;
			var numTicks = me._ticks.length;
			var tickWidth = 1 / Math.max(numTicks - (offset ? 0 : 1), 1);
	
			return index < 0 || index > numTicks - 1
				? null
				: me.getPixelForDecimal(index * tickWidth + (offset ? tickWidth / 2 : 0));
		},
	
		/**
		 * Utility for getting the pixel location of a percentage of scale
		 * The coordinate (0, 0) is at the upper-left corner of the canvas
		 */
		getPixelForDecimal: function(decimal) {
			var me = this;
	
			if (me._reversePixels) {
				decimal = 1 - decimal;
			}
	
			return me._startPixel + decimal * me._length;
		},
	
		getDecimalForPixel: function(pixel) {
			var decimal = (pixel - this._startPixel) / this._length;
			return this._reversePixels ? 1 - decimal : decimal;
		},
	
		/**
		 * Returns the pixel for the minimum chart value
		 * The coordinate (0, 0) is at the upper-left corner of the canvas
		 */
		getBasePixel: function() {
			return this.getPixelForValue(this.getBaseValue());
		},
	
		getBaseValue: function() {
			var me = this;
			var min = me.min;
			var max = me.max;
	
			return me.beginAtZero ? 0 :
				min < 0 && max < 0 ? max :
				min > 0 && max > 0 ? min :
				0;
		},
	
		/**
		 * Returns a subset of ticks to be plotted to avoid overlapping labels.
		 * @private
		 */
		_autoSkip: function(ticks) {
			var me = this;
			var tickOpts = me.options.ticks;
			var axisLength = me._length;
			var ticksLimit = tickOpts.maxTicksLimit || axisLength / me._tickSize() + 1;
			var majorIndices = tickOpts.major.enabled ? getMajorIndices(ticks) : [];
			var numMajorIndices = majorIndices.length;
			var first = majorIndices[0];
			var last = majorIndices[numMajorIndices - 1];
			var i, ilen, spacing, avgMajorSpacing;
	
			// If there are too many major ticks to display them all
			if (numMajorIndices > ticksLimit) {
				skipMajors(ticks, majorIndices, numMajorIndices / ticksLimit);
				return nonSkipped(ticks);
			}
	
			spacing = calculateSpacing(majorIndices, ticks, axisLength, ticksLimit);
	
			if (numMajorIndices > 0) {
				for (i = 0, ilen = numMajorIndices - 1; i < ilen; i++) {
					skip(ticks, spacing, majorIndices[i], majorIndices[i + 1]);
				}
				avgMajorSpacing = numMajorIndices > 1 ? (last - first) / (numMajorIndices - 1) : null;
				skip(ticks, spacing, helpers$1.isNullOrUndef(avgMajorSpacing) ? 0 : first - avgMajorSpacing, first);
				skip(ticks, spacing, last, helpers$1.isNullOrUndef(avgMajorSpacing) ? ticks.length : last + avgMajorSpacing);
				return nonSkipped(ticks);
			}
			skip(ticks, spacing);
			return nonSkipped(ticks);
		},
	
		/**
		 * @private
		 */
		_tickSize: function() {
			var me = this;
			var optionTicks = me.options.ticks;
	
			// Calculate space needed by label in axis direction.
			var rot = helpers$1.toRadians(me.labelRotation);
			var cos = Math.abs(Math.cos(rot));
			var sin = Math.abs(Math.sin(rot));
	
			var labelSizes = me._getLabelSizes();
			var padding = optionTicks.autoSkipPadding || 0;
			var w = labelSizes ? labelSizes.widest.width + padding : 0;
			var h = labelSizes ? labelSizes.highest.height + padding : 0;
	
			// Calculate space needed for 1 tick in axis direction.
			return me.isHorizontal()
				? h * cos > w * sin ? w / cos : h / sin
				: h * sin < w * cos ? h / cos : w / sin;
		},
	
		/**
		 * @private
		 */
		_isVisible: function() {
			var me = this;
			var chart = me.chart;
			var display = me.options.display;
			var i, ilen, meta;
	
			if (display !== 'auto') {
				return !!display;
			}
	
			// When 'auto', the scale is visible if at least one associated dataset is visible.
			for (i = 0, ilen = chart.data.datasets.length; i < ilen; ++i) {
				if (chart.isDatasetVisible(i)) {
					meta = chart.getDatasetMeta(i);
					if (meta.xAxisID === me.id || meta.yAxisID === me.id) {
						return true;
					}
				}
			}
	
			return false;
		},
	
		/**
		 * @private
		 */
		_computeGridLineItems: function(chartArea) {
			var me = this;
			var chart = me.chart;
			var options = me.options;
			var gridLines = options.gridLines;
			var position = options.position;
			var offsetGridLines = gridLines.offsetGridLines;
			var isHorizontal = me.isHorizontal();
			var ticks = me._ticksToDraw;
			var ticksLength = ticks.length + (offsetGridLines ? 1 : 0);
	
			var tl = getTickMarkLength(gridLines);
			var items = [];
			var axisWidth = gridLines.drawBorder ? valueAtIndexOrDefault(gridLines.lineWidth, 0, 0) : 0;
			var axisHalfWidth = axisWidth / 2;
			var alignPixel = helpers$1._alignPixel;
			var alignBorderValue = function(pixel) {
				return alignPixel(chart, pixel, axisWidth);
			};
			var borderValue, i, tick, lineValue, alignedLineValue;
			var tx1, ty1, tx2, ty2, x1, y1, x2, y2, lineWidth, lineColor, borderDash, borderDashOffset;
	
			if (position === 'top') {
				borderValue = alignBorderValue(me.bottom);
				ty1 = me.bottom - tl;
				ty2 = borderValue - axisHalfWidth;
				y1 = alignBorderValue(chartArea.top) + axisHalfWidth;
				y2 = chartArea.bottom;
			} else if (position === 'bottom') {
				borderValue = alignBorderValue(me.top);
				y1 = chartArea.top;
				y2 = alignBorderValue(chartArea.bottom) - axisHalfWidth;
				ty1 = borderValue + axisHalfWidth;
				ty2 = me.top + tl;
			} else if (position === 'left') {
				borderValue = alignBorderValue(me.right);
				tx1 = me.right - tl;
				tx2 = borderValue - axisHalfWidth;
				x1 = alignBorderValue(chartArea.left) + axisHalfWidth;
				x2 = chartArea.right;
			} else {
				borderValue = alignBorderValue(me.left);
				x1 = chartArea.left;
				x2 = alignBorderValue(chartArea.right) - axisHalfWidth;
				tx1 = borderValue + axisHalfWidth;
				tx2 = me.left + tl;
			}
	
			for (i = 0; i < ticksLength; ++i) {
				tick = ticks[i] || {};
	
				// autoskipper skipped this tick (#4635)
				if (isNullOrUndef(tick.label) && i < ticks.length) {
					continue;
				}
	
				if (i === me.zeroLineIndex && options.offset === offsetGridLines) {
					// Draw the first index specially
					lineWidth = gridLines.zeroLineWidth;
					lineColor = gridLines.zeroLineColor;
					borderDash = gridLines.zeroLineBorderDash || [];
					borderDashOffset = gridLines.zeroLineBorderDashOffset || 0.0;
				} else {
					lineWidth = valueAtIndexOrDefault(gridLines.lineWidth, i, 1);
					lineColor = valueAtIndexOrDefault(gridLines.color, i, 'rgba(0,0,0,0.1)');
					borderDash = gridLines.borderDash || [];
					borderDashOffset = gridLines.borderDashOffset || 0.0;
				}
	
				lineValue = getPixelForGridLine(me, tick._index || i, offsetGridLines);
	
				// Skip if the pixel is out of the range
				if (lineValue === undefined) {
					continue;
				}
	
				alignedLineValue = alignPixel(chart, lineValue, lineWidth);
	
				if (isHorizontal) {
					tx1 = tx2 = x1 = x2 = alignedLineValue;
				} else {
					ty1 = ty2 = y1 = y2 = alignedLineValue;
				}
	
				items.push({
					tx1: tx1,
					ty1: ty1,
					tx2: tx2,
					ty2: ty2,
					x1: x1,
					y1: y1,
					x2: x2,
					y2: y2,
					width: lineWidth,
					color: lineColor,
					borderDash: borderDash,
					borderDashOffset: borderDashOffset,
				});
			}
	
			items.ticksLength = ticksLength;
			items.borderValue = borderValue;
	
			return items;
		},
	
		/**
		 * @private
		 */
		_computeLabelItems: function() {
			var me = this;
			var options = me.options;
			var optionTicks = options.ticks;
			var position = options.position;
			var isMirrored = optionTicks.mirror;
			var isHorizontal = me.isHorizontal();
			var ticks = me._ticksToDraw;
			var fonts = parseTickFontOptions(optionTicks);
			var tickPadding = optionTicks.padding;
			var tl = getTickMarkLength(options.gridLines);
			var rotation = -helpers$1.toRadians(me.labelRotation);
			var items = [];
			var i, ilen, tick, label, x, y, textAlign, pixel, font, lineHeight, lineCount, textOffset;
	
			if (position === 'top') {
				y = me.bottom - tl - tickPadding;
				textAlign = !rotation ? 'center' : 'left';
			} else if (position === 'bottom') {
				y = me.top + tl + tickPadding;
				textAlign = !rotation ? 'center' : 'right';
			} else if (position === 'left') {
				x = me.right - (isMirrored ? 0 : tl) - tickPadding;
				textAlign = isMirrored ? 'left' : 'right';
			} else {
				x = me.left + (isMirrored ? 0 : tl) + tickPadding;
				textAlign = isMirrored ? 'right' : 'left';
			}
	
			for (i = 0, ilen = ticks.length; i < ilen; ++i) {
				tick = ticks[i];
				label = tick.label;
	
				// autoskipper skipped this tick (#4635)
				if (isNullOrUndef(label)) {
					continue;
				}
	
				pixel = me.getPixelForTick(tick._index || i) + optionTicks.labelOffset;
				font = tick.major ? fonts.major : fonts.minor;
				lineHeight = font.lineHeight;
				lineCount = isArray(label) ? label.length : 1;
	
				if (isHorizontal) {
					x = pixel;
					textOffset = position === 'top'
						? ((!rotation ? 0.5 : 1) - lineCount) * lineHeight
						: (!rotation ? 0.5 : 0) * lineHeight;
				} else {
					y = pixel;
					textOffset = (1 - lineCount) * lineHeight / 2;
				}
	
				items.push({
					x: x,
					y: y,
					rotation: rotation,
					label: label,
					font: font,
					textOffset: textOffset,
					textAlign: textAlign
				});
			}
	
			return items;
		},
	
		/**
		 * @private
		 */
		_drawGrid: function(chartArea) {
			var me = this;
			var gridLines = me.options.gridLines;
	
			if (!gridLines.display) {
				return;
			}
	
			var ctx = me.ctx;
			var chart = me.chart;
			var alignPixel = helpers$1._alignPixel;
			var axisWidth = gridLines.drawBorder ? valueAtIndexOrDefault(gridLines.lineWidth, 0, 0) : 0;
			var items = me._gridLineItems || (me._gridLineItems = me._computeGridLineItems(chartArea));
			var width, color, i, ilen, item;
	
			for (i = 0, ilen = items.length; i < ilen; ++i) {
				item = items[i];
				width = item.width;
				color = item.color;
	
				if (width && color) {
					ctx.save();
					ctx.lineWidth = width;
					ctx.strokeStyle = color;
					if (ctx.setLineDash) {
						ctx.setLineDash(item.borderDash);
						ctx.lineDashOffset = item.borderDashOffset;
					}
	
					ctx.beginPath();
	
					if (gridLines.drawTicks) {
						ctx.moveTo(item.tx1, item.ty1);
						ctx.lineTo(item.tx2, item.ty2);
					}
	
					if (gridLines.drawOnChartArea) {
						ctx.moveTo(item.x1, item.y1);
						ctx.lineTo(item.x2, item.y2);
					}
	
					ctx.stroke();
					ctx.restore();
				}
			}
	
			if (axisWidth) {
				// Draw the line at the edge of the axis
				var firstLineWidth = axisWidth;
				var lastLineWidth = valueAtIndexOrDefault(gridLines.lineWidth, items.ticksLength - 1, 1);
				var borderValue = items.borderValue;
				var x1, x2, y1, y2;
	
				if (me.isHorizontal()) {
					x1 = alignPixel(chart, me.left, firstLineWidth) - firstLineWidth / 2;
					x2 = alignPixel(chart, me.right, lastLineWidth) + lastLineWidth / 2;
					y1 = y2 = borderValue;
				} else {
					y1 = alignPixel(chart, me.top, firstLineWidth) - firstLineWidth / 2;
					y2 = alignPixel(chart, me.bottom, lastLineWidth) + lastLineWidth / 2;
					x1 = x2 = borderValue;
				}
	
				ctx.lineWidth = axisWidth;
				ctx.strokeStyle = valueAtIndexOrDefault(gridLines.color, 0);
				ctx.beginPath();
				ctx.moveTo(x1, y1);
				ctx.lineTo(x2, y2);
				ctx.stroke();
			}
		},
	
		/**
		 * @private
		 */
		_drawLabels: function() {
			var me = this;
			var optionTicks = me.options.ticks;
	
			if (!optionTicks.display) {
				return;
			}
	
			var ctx = me.ctx;
			var items = me._labelItems || (me._labelItems = me._computeLabelItems());
			var i, j, ilen, jlen, item, tickFont, label, y;
	
			for (i = 0, ilen = items.length; i < ilen; ++i) {
				item = items[i];
				tickFont = item.font;
	
				// Make sure we draw text in the correct color and font
				ctx.save();
				ctx.translate(item.x, item.y);
				ctx.rotate(item.rotation);
				ctx.font = tickFont.string;
				ctx.fillStyle = tickFont.color;
				ctx.textBaseline = 'middle';
				ctx.textAlign = item.textAlign;
	
				label = item.label;
				y = item.textOffset;
				if (isArray(label)) {
					for (j = 0, jlen = label.length; j < jlen; ++j) {
						// We just make sure the multiline element is a string here..
						ctx.fillText('' + label[j], 0, y);
						y += tickFont.lineHeight;
					}
				} else {
					ctx.fillText(label, 0, y);
				}
				ctx.restore();
			}
		},
	
		/**
		 * @private
		 */
		_drawTitle: function() {
			var me = this;
			var ctx = me.ctx;
			var options = me.options;
			var scaleLabel = options.scaleLabel;
	
			if (!scaleLabel.display) {
				return;
			}
	
			var scaleLabelFontColor = valueOrDefault$a(scaleLabel.fontColor, core_defaults.global.defaultFontColor);
			var scaleLabelFont = helpers$1.options._parseFont(scaleLabel);
			var scaleLabelPadding = helpers$1.options.toPadding(scaleLabel.padding);
			var halfLineHeight = scaleLabelFont.lineHeight / 2;
			var position = options.position;
			var rotation = 0;
			var scaleLabelX, scaleLabelY;
	
			if (me.isHorizontal()) {
				scaleLabelX = me.left + me.width / 2; // midpoint of the width
				scaleLabelY = position === 'bottom'
					? me.bottom - halfLineHeight - scaleLabelPadding.bottom
					: me.top + halfLineHeight + scaleLabelPadding.top;
			} else {
				var isLeft = position === 'left';
				scaleLabelX = isLeft
					? me.left + halfLineHeight + scaleLabelPadding.top
					: me.right - halfLineHeight - scaleLabelPadding.top;
				scaleLabelY = me.top + me.height / 2;
				rotation = isLeft ? -0.5 * Math.PI : 0.5 * Math.PI;
			}
	
			ctx.save();
			ctx.translate(scaleLabelX, scaleLabelY);
			ctx.rotate(rotation);
			ctx.textAlign = 'center';
			ctx.textBaseline = 'middle';
			ctx.fillStyle = scaleLabelFontColor; // render in correct colour
			ctx.font = scaleLabelFont.string;
			ctx.fillText(scaleLabel.labelString, 0, 0);
			ctx.restore();
		},
	
		draw: function(chartArea) {
			var me = this;
	
			if (!me._isVisible()) {
				return;
			}
	
			me._drawGrid(chartArea);
			me._drawTitle();
			me._drawLabels();
		},
	
		/**
		 * @private
		 */
		_layers: function() {
			var me = this;
			var opts = me.options;
			var tz = opts.ticks && opts.ticks.z || 0;
			var gz = opts.gridLines && opts.gridLines.z || 0;
	
			if (!me._isVisible() || tz === gz || me.draw !== me._draw) {
				// backward compatibility: draw has been overridden by custom scale
				return [{
					z: tz,
					draw: function() {
						me.draw.apply(me, arguments);
					}
				}];
			}
	
			return [{
				z: gz,
				draw: function() {
					me._drawGrid.apply(me, arguments);
					me._drawTitle.apply(me, arguments);
				}
			}, {
				z: tz,
				draw: function() {
					me._drawLabels.apply(me, arguments);
				}
			}];
		},
	
		/**
		 * @private
		 */
		_getMatchingVisibleMetas: function(type) {
			var me = this;
			var isHorizontal = me.isHorizontal();
			return me.chart._getSortedVisibleDatasetMetas()
				.filter(function(meta) {
					return (!type || meta.type === type)
						&& (isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id);
				});
		}
	});
	
	Scale.prototype._draw = Scale.prototype.draw;
	
	var core_scale = Scale;
	
	var isNullOrUndef$1 = helpers$1.isNullOrUndef;
	
	var defaultConfig = {
		position: 'bottom'
	};
	
	var scale_category = core_scale.extend({
		determineDataLimits: function() {
			var me = this;
			var labels = me._getLabels();
			var ticksOpts = me.options.ticks;
			var min = ticksOpts.min;
			var max = ticksOpts.max;
			var minIndex = 0;
			var maxIndex = labels.length - 1;
			var findIndex;
	
			if (min !== undefined) {
				// user specified min value
				findIndex = labels.indexOf(min);
				if (findIndex >= 0) {
					minIndex = findIndex;
				}
			}
	
			if (max !== undefined) {
				// user specified max value
				findIndex = labels.indexOf(max);
				if (findIndex >= 0) {
					maxIndex = findIndex;
				}
			}
	
			me.minIndex = minIndex;
			me.maxIndex = maxIndex;
			me.min = labels[minIndex];
			me.max = labels[maxIndex];
		},
	
		buildTicks: function() {
			var me = this;
			var labels = me._getLabels();
			var minIndex = me.minIndex;
			var maxIndex = me.maxIndex;
	
			// If we are viewing some subset of labels, slice the original array
			me.ticks = (minIndex === 0 && maxIndex === labels.length - 1) ? labels : labels.slice(minIndex, maxIndex + 1);
		},
	
		getLabelForIndex: function(index, datasetIndex) {
			var me = this;
			var chart = me.chart;
	
			if (chart.getDatasetMeta(datasetIndex).controller._getValueScaleId() === me.id) {
				return me.getRightValue(chart.data.datasets[datasetIndex].data[index]);
			}
	
			return me._getLabels()[index];
		},
	
		_configure: function() {
			var me = this;
			var offset = me.options.offset;
			var ticks = me.ticks;
	
			core_scale.prototype._configure.call(me);
	
			if (!me.isHorizontal()) {
				// For backward compatibility, vertical category scale reverse is inverted.
				me._reversePixels = !me._reversePixels;
			}
	
			if (!ticks) {
				return;
			}
	
			me._startValue = me.minIndex - (offset ? 0.5 : 0);
			me._valueRange = Math.max(ticks.length - (offset ? 0 : 1), 1);
		},
	
		// Used to get data value locations.  Value can either be an index or a numerical value
		getPixelForValue: function(value, index, datasetIndex) {
			var me = this;
			var valueCategory, labels, idx;
	
			if (!isNullOrUndef$1(index) && !isNullOrUndef$1(datasetIndex)) {
				value = me.chart.data.datasets[datasetIndex].data[index];
			}
	
			// If value is a data object, then index is the index in the data array,
			// not the index of the scale. We need to change that.
			if (!isNullOrUndef$1(value)) {
				valueCategory = me.isHorizontal() ? value.x : value.y;
			}
			if (valueCategory !== undefined || (value !== undefined && isNaN(index))) {
				labels = me._getLabels();
				value = helpers$1.valueOrDefault(valueCategory, value);
				idx = labels.indexOf(value);
				index = idx !== -1 ? idx : index;
				if (isNaN(index)) {
					index = value;
				}
			}
			return me.getPixelForDecimal((index - me._startValue) / me._valueRange);
		},
	
		getPixelForTick: function(index) {
			var ticks = this.ticks;
			return index < 0 || index > ticks.length - 1
				? null
				: this.getPixelForValue(ticks[index], index + this.minIndex);
		},
	
		getValueForPixel: function(pixel) {
			var me = this;
			var value = Math.round(me._startValue + me.getDecimalForPixel(pixel) * me._valueRange);
			return Math.min(Math.max(value, 0), me.ticks.length - 1);
		},
	
		getBasePixel: function() {
			return this.bottom;
		}
	});
	
	// INTERNAL: static default options, registered in src/index.js
	var _defaults = defaultConfig;
	scale_category._defaults = _defaults;
	
	var noop = helpers$1.noop;
	var isNullOrUndef$2 = helpers$1.isNullOrUndef;
	
	/**
	 * Generate a set of linear ticks
	 * @param generationOptions the options used to generate the ticks
	 * @param dataRange the range of the data
	 * @returns {number[]} array of tick values
	 */
	function generateTicks(generationOptions, dataRange) {
		var ticks = [];
		// To get a "nice" value for the tick spacing, we will use the appropriately named
		// "nice number" algorithm. See https://stackoverflow.com/questions/8506881/nice-label-algorithm-for-charts-with-minimum-ticks
		// for details.
	
		var MIN_SPACING = 1e-14;
		var stepSize = generationOptions.stepSize;
		var unit = stepSize || 1;
		var maxNumSpaces = generationOptions.maxTicks - 1;
		var min = generationOptions.min;
		var max = generationOptions.max;
		var precision = generationOptions.precision;
		var rmin = dataRange.min;
		var rmax = dataRange.max;
		var spacing = helpers$1.niceNum((rmax - rmin) / maxNumSpaces / unit) * unit;
		var factor, niceMin, niceMax, numSpaces;
	
		// Beyond MIN_SPACING floating point numbers being to lose precision
		// such that we can't do the math necessary to generate ticks
		if (spacing < MIN_SPACING && isNullOrUndef$2(min) && isNullOrUndef$2(max)) {
			return [rmin, rmax];
		}
	
		numSpaces = Math.ceil(rmax / spacing) - Math.floor(rmin / spacing);
		if (numSpaces > maxNumSpaces) {
			// If the calculated num of spaces exceeds maxNumSpaces, recalculate it
			spacing = helpers$1.niceNum(numSpaces * spacing / maxNumSpaces / unit) * unit;
		}
	
		if (stepSize || isNullOrUndef$2(precision)) {
			// If a precision is not specified, calculate factor based on spacing
			factor = Math.pow(10, helpers$1._decimalPlaces(spacing));
		} else {
			// If the user specified a precision, round to that number of decimal places
			factor = Math.pow(10, precision);
			spacing = Math.ceil(spacing * factor) / factor;
		}
	
		niceMin = Math.floor(rmin / spacing) * spacing;
		niceMax = Math.ceil(rmax / spacing) * spacing;
	
		// If min, max and stepSize is set and they make an evenly spaced scale use it.
		if (stepSize) {
			// If very close to our whole number, use it.
			if (!isNullOrUndef$2(min) && helpers$1.almostWhole(min / spacing, spacing / 1000)) {
				niceMin = min;
			}
			if (!isNullOrUndef$2(max) && helpers$1.almostWhole(max / spacing, spacing / 1000)) {
				niceMax = max;
			}
		}
	
		numSpaces = (niceMax - niceMin) / spacing;
		// If very close to our rounded value, use it.
		if (helpers$1.almostEquals(numSpaces, Math.round(numSpaces), spacing / 1000)) {
			numSpaces = Math.round(numSpaces);
		} else {
			numSpaces = Math.ceil(numSpaces);
		}
	
		niceMin = Math.round(niceMin * factor) / factor;
		niceMax = Math.round(niceMax * factor) / factor;
		ticks.push(isNullOrUndef$2(min) ? niceMin : min);
		for (var j = 1; j < numSpaces; ++j) {
			ticks.push(Math.round((niceMin + j * spacing) * factor) / factor);
		}
		ticks.push(isNullOrUndef$2(max) ? niceMax : max);
	
		return ticks;
	}
	
	var scale_linearbase = core_scale.extend({
		getRightValue: function(value) {
			if (typeof value === 'string') {
				return +value;
			}
			return core_scale.prototype.getRightValue.call(this, value);
		},
	
		handleTickRangeOptions: function() {
			var me = this;
			var opts = me.options;
			var tickOpts = opts.ticks;
	
			// If we are forcing it to begin at 0, but 0 will already be rendered on the chart,
			// do nothing since that would make the chart weird. If the user really wants a weird chart
			// axis, they can manually override it
			if (tickOpts.beginAtZero) {
				var minSign = helpers$1.sign(me.min);
				var maxSign = helpers$1.sign(me.max);
	
				if (minSign < 0 && maxSign < 0) {
					// move the top up to 0
					me.max = 0;
				} else if (minSign > 0 && maxSign > 0) {
					// move the bottom down to 0
					me.min = 0;
				}
			}
	
			var setMin = tickOpts.min !== undefined || tickOpts.suggestedMin !== undefined;
			var setMax = tickOpts.max !== undefined || tickOpts.suggestedMax !== undefined;
	
			if (tickOpts.min !== undefined) {
				me.min = tickOpts.min;
			} else if (tickOpts.suggestedMin !== undefined) {
				if (me.min === null) {
					me.min = tickOpts.suggestedMin;
				} else {
					me.min = Math.min(me.min, tickOpts.suggestedMin);
				}
			}
	
			if (tickOpts.max !== undefined) {
				me.max = tickOpts.max;
			} else if (tickOpts.suggestedMax !== undefined) {
				if (me.max === null) {
					me.max = tickOpts.suggestedMax;
				} else {
					me.max = Math.max(me.max, tickOpts.suggestedMax);
				}
			}
	
			if (setMin !== setMax) {
				// We set the min or the max but not both.
				// So ensure that our range is good
				// Inverted or 0 length range can happen when
				// ticks.min is set, and no datasets are visible
				if (me.min >= me.max) {
					if (setMin) {
						me.max = me.min + 1;
					} else {
						me.min = me.max - 1;
					}
				}
			}
	
			if (me.min === me.max) {
				me.max++;
	
				if (!tickOpts.beginAtZero) {
					me.min--;
				}
			}
		},
	
		getTickLimit: function() {
			var me = this;
			var tickOpts = me.options.ticks;
			var stepSize = tickOpts.stepSize;
			var maxTicksLimit = tickOpts.maxTicksLimit;
			var maxTicks;
	
			if (stepSize) {
				maxTicks = Math.ceil(me.max / stepSize) - Math.floor(me.min / stepSize) + 1;
			} else {
				maxTicks = me._computeTickLimit();
				maxTicksLimit = maxTicksLimit || 11;
			}
	
			if (maxTicksLimit) {
				maxTicks = Math.min(maxTicksLimit, maxTicks);
			}
	
			return maxTicks;
		},
	
		_computeTickLimit: function() {
			return Number.POSITIVE_INFINITY;
		},
	
		handleDirectionalChanges: noop,
	
		buildTicks: function() {
			var me = this;
			var opts = me.options;
			var tickOpts = opts.ticks;
	
			// Figure out what the max number of ticks we can support it is based on the size of
			// the axis area. For now, we say that the minimum tick spacing in pixels must be 40
			// We also limit the maximum number of ticks to 11 which gives a nice 10 squares on
			// the graph. Make sure we always have at least 2 ticks
			var maxTicks = me.getTickLimit();
			maxTicks = Math.max(2, maxTicks);
	
			var numericGeneratorOptions = {
				maxTicks: maxTicks,
				min: tickOpts.min,
				max: tickOpts.max,
				precision: tickOpts.precision,
				stepSize: helpers$1.valueOrDefault(tickOpts.fixedStepSize, tickOpts.stepSize)
			};
			var ticks = me.ticks = generateTicks(numericGeneratorOptions, me);
	
			me.handleDirectionalChanges();
	
			// At this point, we need to update our max and min given the tick values since we have expanded the
			// range of the scale
			me.max = helpers$1.max(ticks);
			me.min = helpers$1.min(ticks);
	
			if (tickOpts.reverse) {
				ticks.reverse();
	
				me.start = me.max;
				me.end = me.min;
			} else {
				me.start = me.min;
				me.end = me.max;
			}
		},
	
		convertTicksToLabels: function() {
			var me = this;
			me.ticksAsNumbers = me.ticks.slice();
			me.zeroLineIndex = me.ticks.indexOf(0);
	
			core_scale.prototype.convertTicksToLabels.call(me);
		},
	
		_configure: function() {
			var me = this;
			var ticks = me.getTicks();
			var start = me.min;
			var end = me.max;
			var offset;
	
			core_scale.prototype._configure.call(me);
	
			if (me.options.offset && ticks.length) {
				offset = (end - start) / Math.max(ticks.length - 1, 1) / 2;
				start -= offset;
				end += offset;
			}
			me._startValue = start;
			me._endValue = end;
			me._valueRange = end - start;
		}
	});
	
	var defaultConfig$1 = {
		position: 'left',
		ticks: {
			callback: core_ticks.formatters.linear
		}
	};
	
	var DEFAULT_MIN = 0;
	var DEFAULT_MAX = 1;
	
	function getOrCreateStack(stacks, stacked, meta) {
		var key = [
			meta.type,
			// we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
			stacked === undefined && meta.stack === undefined ? meta.index : '',
			meta.stack
		].join('.');
	
		if (stacks[key] === undefined) {
			stacks[key] = {
				pos: [],
				neg: []
			};
		}
	
		return stacks[key];
	}
	
	function stackData(scale, stacks, meta, data) {
		var opts = scale.options;
		var stacked = opts.stacked;
		var stack = getOrCreateStack(stacks, stacked, meta);
		var pos = stack.pos;
		var neg = stack.neg;
		var ilen = data.length;
		var i, value;
	
		for (i = 0; i < ilen; ++i) {
			value = scale._parseValue(data[i]);
			if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden) {
				continue;
			}
	
			pos[i] = pos[i] || 0;
			neg[i] = neg[i] || 0;
	
			if (opts.relativePoints) {
				pos[i] = 100;
			} else if (value.min < 0 || value.max < 0) {
				neg[i] += value.min;
			} else {
				pos[i] += value.max;
			}
		}
	}
	
	function updateMinMax(scale, meta, data) {
		var ilen = data.length;
		var i, value;
	
		for (i = 0; i < ilen; ++i) {
			value = scale._parseValue(data[i]);
			if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden) {
				continue;
			}
	
			scale.min = Math.min(scale.min, value.min);
			scale.max = Math.max(scale.max, value.max);
		}
	}
	
	var scale_linear = scale_linearbase.extend({
		determineDataLimits: function() {
			var me = this;
			var opts = me.options;
			var chart = me.chart;
			var datasets = chart.data.datasets;
			var metasets = me._getMatchingVisibleMetas();
			var hasStacks = opts.stacked;
			var stacks = {};
			var ilen = metasets.length;
			var i, meta, data, values;
	
			me.min = Number.POSITIVE_INFINITY;
			me.max = Number.NEGATIVE_INFINITY;
	
			if (hasStacks === undefined) {
				for (i = 0; !hasStacks && i < ilen; ++i) {
					meta = metasets[i];
					hasStacks = meta.stack !== undefined;
				}
			}
	
			for (i = 0; i < ilen; ++i) {
				meta = metasets[i];
				data = datasets[meta.index].data;
				if (hasStacks) {
					stackData(me, stacks, meta, data);
				} else {
					updateMinMax(me, meta, data);
				}
			}
	
			helpers$1.each(stacks, function(stackValues) {
				values = stackValues.pos.concat(stackValues.neg);
				me.min = Math.min(me.min, helpers$1.min(values));
				me.max = Math.max(me.max, helpers$1.max(values));
			});
	
			me.min = helpers$1.isFinite(me.min) && !isNaN(me.min) ? me.min : DEFAULT_MIN;
			me.max = helpers$1.isFinite(me.max) && !isNaN(me.max) ? me.max : DEFAULT_MAX;
	
			// Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
			me.handleTickRangeOptions();
		},
	
		// Returns the maximum number of ticks based on the scale dimension
		_computeTickLimit: function() {
			var me = this;
			var tickFont;
	
			if (me.isHorizontal()) {
				return Math.ceil(me.width / 40);
			}
			tickFont = helpers$1.options._parseFont(me.options.ticks);
			return Math.ceil(me.height / tickFont.lineHeight);
		},
	
		// Called after the ticks are built. We need
		handleDirectionalChanges: function() {
			if (!this.isHorizontal()) {
				// We are in a vertical orientation. The top value is the highest. So reverse the array
				this.ticks.reverse();
			}
		},
	
		getLabelForIndex: function(index, datasetIndex) {
			return this._getScaleLabel(this.chart.data.datasets[datasetIndex].data[index]);
		},
	
		// Utils
		getPixelForValue: function(value) {
			var me = this;
			return me.getPixelForDecimal((+me.getRightValue(value) - me._startValue) / me._valueRange);
		},
	
		getValueForPixel: function(pixel) {
			return this._startValue + this.getDecimalForPixel(pixel) * this._valueRange;
		},
	
		getPixelForTick: function(index) {
			var ticks = this.ticksAsNumbers;
			if (index < 0 || index > ticks.length - 1) {
				return null;
			}
			return this.getPixelForValue(ticks[index]);
		}
	});
	
	// INTERNAL: static default options, registered in src/index.js
	var _defaults$1 = defaultConfig$1;
	scale_linear._defaults = _defaults$1;
	
	var valueOrDefault$b = helpers$1.valueOrDefault;
	var log10 = helpers$1.math.log10;
	
	/**
	 * Generate a set of logarithmic ticks
	 * @param generationOptions the options used to generate the ticks
	 * @param dataRange the range of the data
	 * @returns {number[]} array of tick values
	 */
	function generateTicks$1(generationOptions, dataRange) {
		var ticks = [];
	
		var tickVal = valueOrDefault$b(generationOptions.min, Math.pow(10, Math.floor(log10(dataRange.min))));
	
		var endExp = Math.floor(log10(dataRange.max));
		var endSignificand = Math.ceil(dataRange.max / Math.pow(10, endExp));
		var exp, significand;
	
		if (tickVal === 0) {
			exp = Math.floor(log10(dataRange.minNotZero));
			significand = Math.floor(dataRange.minNotZero / Math.pow(10, exp));
	
			ticks.push(tickVal);
			tickVal = significand * Math.pow(10, exp);
		} else {
			exp = Math.floor(log10(tickVal));
			significand = Math.floor(tickVal / Math.pow(10, exp));
		}
		var precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;
	
		do {
			ticks.push(tickVal);
	
			++significand;
			if (significand === 10) {
				significand = 1;
				++exp;
				precision = exp >= 0 ? 1 : precision;
			}
	
			tickVal = Math.round(significand * Math.pow(10, exp) * precision) / precision;
		} while (exp < endExp || (exp === endExp && significand < endSignificand));
	
		var lastTick = valueOrDefault$b(generationOptions.max, tickVal);
		ticks.push(lastTick);
	
		return ticks;
	}
	
	var defaultConfig$2 = {
		position: 'left',
	
		// label settings
		ticks: {
			callback: core_ticks.formatters.logarithmic
		}
	};
	
	// TODO(v3): change this to positiveOrDefault
	function nonNegativeOrDefault(value, defaultValue) {
		return helpers$1.isFinite(value) && value >= 0 ? value : defaultValue;
	}
	
	var scale_logarithmic = core_scale.extend({
		determineDataLimits: function() {
			var me = this;
			var opts = me.options;
			var chart = me.chart;
			var datasets = chart.data.datasets;
			var isHorizontal = me.isHorizontal();
			function IDMatches(meta) {
				return isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id;
			}
			var datasetIndex, meta, value, data, i, ilen;
	
			// Calculate Range
			me.min = Number.POSITIVE_INFINITY;
			me.max = Number.NEGATIVE_INFINITY;
			me.minNotZero = Number.POSITIVE_INFINITY;
	
			var hasStacks = opts.stacked;
			if (hasStacks === undefined) {
				for (datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++) {
					meta = chart.getDatasetMeta(datasetIndex);
					if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta) &&
						meta.stack !== undefined) {
						hasStacks = true;
						break;
					}
				}
			}
	
			if (opts.stacked || hasStacks) {
				var valuesPerStack = {};
	
				for (datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++) {
					meta = chart.getDatasetMeta(datasetIndex);
					var key = [
						meta.type,
						// we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
						((opts.stacked === undefined && meta.stack === undefined) ? datasetIndex : ''),
						meta.stack
					].join('.');
	
					if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
						if (valuesPerStack[key] === undefined) {
							valuesPerStack[key] = [];
						}
	
						data = datasets[datasetIndex].data;
						for (i = 0, ilen = data.length; i < ilen; i++) {
							var values = valuesPerStack[key];
							value = me._parseValue(data[i]);
							// invalid, hidden and negative values are ignored
							if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden || value.min < 0 || value.max < 0) {
								continue;
							}
							values[i] = values[i] || 0;
							values[i] += value.max;
						}
					}
				}
	
				helpers$1.each(valuesPerStack, function(valuesForType) {
					if (valuesForType.length > 0) {
						var minVal = helpers$1.min(valuesForType);
						var maxVal = helpers$1.max(valuesForType);
						me.min = Math.min(me.min, minVal);
						me.max = Math.max(me.max, maxVal);
					}
				});
	
			} else {
				for (datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++) {
					meta = chart.getDatasetMeta(datasetIndex);
					if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
						data = datasets[datasetIndex].data;
						for (i = 0, ilen = data.length; i < ilen; i++) {
							value = me._parseValue(data[i]);
							// invalid, hidden and negative values are ignored
							if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden || value.min < 0 || value.max < 0) {
								continue;
							}
	
							me.min = Math.min(value.min, me.min);
							me.max = Math.max(value.max, me.max);
	
							if (value.min !== 0) {
								me.minNotZero = Math.min(value.min, me.minNotZero);
							}
						}
					}
				}
			}
	
			me.min = helpers$1.isFinite(me.min) ? me.min : null;
			me.max = helpers$1.isFinite(me.max) ? me.max : null;
			me.minNotZero = helpers$1.isFinite(me.minNotZero) ? me.minNotZero : null;
	
			// Common base implementation to handle ticks.min, ticks.max
			this.handleTickRangeOptions();
		},
	
		handleTickRangeOptions: function() {
			var me = this;
			var tickOpts = me.options.ticks;
			var DEFAULT_MIN = 1;
			var DEFAULT_MAX = 10;
	
			me.min = nonNegativeOrDefault(tickOpts.min, me.min);
			me.max = nonNegativeOrDefault(tickOpts.max, me.max);
	
			if (me.min === me.max) {
				if (me.min !== 0 && me.min !== null) {
					me.min = Math.pow(10, Math.floor(log10(me.min)) - 1);
					me.max = Math.pow(10, Math.floor(log10(me.max)) + 1);
				} else {
					me.min = DEFAULT_MIN;
					me.max = DEFAULT_MAX;
				}
			}
			if (me.min === null) {
				me.min = Math.pow(10, Math.floor(log10(me.max)) - 1);
			}
			if (me.max === null) {
				me.max = me.min !== 0
					? Math.pow(10, Math.floor(log10(me.min)) + 1)
					: DEFAULT_MAX;
			}
			if (me.minNotZero === null) {
				if (me.min > 0) {
					me.minNotZero = me.min;
				} else if (me.max < 1) {
					me.minNotZero = Math.pow(10, Math.floor(log10(me.max)));
				} else {
					me.minNotZero = DEFAULT_MIN;
				}
			}
		},
	
		buildTicks: function() {
			var me = this;
			var tickOpts = me.options.ticks;
			var reverse = !me.isHorizontal();
	
			var generationOptions = {
				min: nonNegativeOrDefault(tickOpts.min),
				max: nonNegativeOrDefault(tickOpts.max)
			};
			var ticks = me.ticks = generateTicks$1(generationOptions, me);
	
			// At this point, we need to update our max and min given the tick values since we have expanded the
			// range of the scale
			me.max = helpers$1.max(ticks);
			me.min = helpers$1.min(ticks);
	
			if (tickOpts.reverse) {
				reverse = !reverse;
				me.start = me.max;
				me.end = me.min;
			} else {
				me.start = me.min;
				me.end = me.max;
			}
			if (reverse) {
				ticks.reverse();
			}
		},
	
		convertTicksToLabels: function() {
			this.tickValues = this.ticks.slice();
	
			core_scale.prototype.convertTicksToLabels.call(this);
		},
	
		// Get the correct tooltip label
		getLabelForIndex: function(index, datasetIndex) {
			return this._getScaleLabel(this.chart.data.datasets[datasetIndex].data[index]);
		},
	
		getPixelForTick: function(index) {
			var ticks = this.tickValues;
			if (index < 0 || index > ticks.length - 1) {
				return null;
			}
			return this.getPixelForValue(ticks[index]);
		},
	
		/**
		 * Returns the value of the first tick.
		 * @param {number} value - The minimum not zero value.
		 * @return {number} The first tick value.
		 * @private
		 */
		_getFirstTickValue: function(value) {
			var exp = Math.floor(log10(value));
			var significand = Math.floor(value / Math.pow(10, exp));
	
			return significand * Math.pow(10, exp);
		},
	
		_configure: function() {
			var me = this;
			var start = me.min;
			var offset = 0;
	
			core_scale.prototype._configure.call(me);
	
			if (start === 0) {
				start = me._getFirstTickValue(me.minNotZero);
				offset = valueOrDefault$b(me.options.ticks.fontSize, core_defaults.global.defaultFontSize) / me._length;
			}
	
			me._startValue = log10(start);
			me._valueOffset = offset;
			me._valueRange = (log10(me.max) - log10(start)) / (1 - offset);
		},
	
		getPixelForValue: function(value) {
			var me = this;
			var decimal = 0;
	
			value = +me.getRightValue(value);
	
			if (value > me.min && value > 0) {
				decimal = (log10(value) - me._startValue) / me._valueRange + me._valueOffset;
			}
			return me.getPixelForDecimal(decimal);
		},
	
		getValueForPixel: function(pixel) {
			var me = this;
			var decimal = me.getDecimalForPixel(pixel);
			return decimal === 0 && me.min === 0
				? 0
				: Math.pow(10, me._startValue + (decimal - me._valueOffset) * me._valueRange);
		}
	});
	
	// INTERNAL: static default options, registered in src/index.js
	var _defaults$2 = defaultConfig$2;
	scale_logarithmic._defaults = _defaults$2;
	
	var valueOrDefault$c = helpers$1.valueOrDefault;
	var valueAtIndexOrDefault$1 = helpers$1.valueAtIndexOrDefault;
	var resolve$4 = helpers$1.options.resolve;
	
	var defaultConfig$3 = {
		display: true,
	
		// Boolean - Whether to animate scaling the chart from the centre
		animate: true,
		position: 'chartArea',
	
		angleLines: {
			display: true,
			color: 'rgba(0,0,0,0.1)',
			lineWidth: 1,
			borderDash: [],
			borderDashOffset: 0.0
		},
	
		gridLines: {
			circular: false
		},
	
		// label settings
		ticks: {
			// Boolean - Show a backdrop to the scale label
			showLabelBackdrop: true,
	
			// String - The colour of the label backdrop
			backdropColor: 'rgba(255,255,255,0.75)',
	
			// Number - The backdrop padding above & below the label in pixels
			backdropPaddingY: 2,
	
			// Number - The backdrop padding to the side of the label in pixels
			backdropPaddingX: 2,
	
			callback: core_ticks.formatters.linear
		},
	
		pointLabels: {
			// Boolean - if true, show point labels
			display: true,
	
			// Number - Point label font size in pixels
			fontSize: 10,
	
			// Function - Used to convert point labels
			callback: function(label) {
				return label;
			}
		}
	};
	
	function getTickBackdropHeight(opts) {
		var tickOpts = opts.ticks;
	
		if (tickOpts.display && opts.display) {
			return valueOrDefault$c(tickOpts.fontSize, core_defaults.global.defaultFontSize) + tickOpts.backdropPaddingY * 2;
		}
		return 0;
	}
	
	function measureLabelSize(ctx, lineHeight, label) {
		if (helpers$1.isArray(label)) {
			return {
				w: helpers$1.longestText(ctx, ctx.font, label),
				h: label.length * lineHeight
			};
		}
	
		return {
			w: ctx.measureText(label).width,
			h: lineHeight
		};
	}
	
	function determineLimits(angle, pos, size, min, max) {
		if (angle === min || angle === max) {
			return {
				start: pos - (size / 2),
				end: pos + (size / 2)
			};
		} else if (angle < min || angle > max) {
			return {
				start: pos - size,
				end: pos
			};
		}
	
		return {
			start: pos,
			end: pos + size
		};
	}
	
	/**
	 * Helper function to fit a radial linear scale with point labels
	 */
	function fitWithPointLabels(scale) {
	
		// Right, this is really confusing and there is a lot of maths going on here
		// The gist of the problem is here: https://gist.github.com/nnnick/696cc9c55f4b0beb8fe9
		//
		// Reaction: https://dl.dropboxusercontent.com/u/34601363/toomuchscience.gif
		//
		// Solution:
		//
		// We assume the radius of the polygon is half the size of the canvas at first
		// at each index we check if the text overlaps.
		//
		// Where it does, we store that angle and that index.
		//
		// After finding the largest index and angle we calculate how much we need to remove
		// from the shape radius to move the point inwards by that x.
		//
		// We average the left and right distances to get the maximum shape radius that can fit in the box
		// along with labels.
		//
		// Once we have that, we can find the centre point for the chart, by taking the x text protrusion
		// on each side, removing that from the size, halving it and adding the left x protrusion width.
		//
		// This will mean we have a shape fitted to the canvas, as large as it can be with the labels
		// and position it in the most space efficient manner
		//
		// https://dl.dropboxusercontent.com/u/34601363/yeahscience.gif
	
		var plFont = helpers$1.options._parseFont(scale.options.pointLabels);
	
		// Get maximum radius of the polygon. Either half the height (minus the text width) or half the width.
		// Use this to calculate the offset + change. - Make sure L/R protrusion is at least 0 to stop issues with centre points
		var furthestLimits = {
			l: 0,
			r: scale.width,
			t: 0,
			b: scale.height - scale.paddingTop
		};
		var furthestAngles = {};
		var i, textSize, pointPosition;
	
		scale.ctx.font = plFont.string;
		scale._pointLabelSizes = [];
	
		var valueCount = scale.chart.data.labels.length;
		for (i = 0; i < valueCount; i++) {
			pointPosition = scale.getPointPosition(i, scale.drawingArea + 5);
			textSize = measureLabelSize(scale.ctx, plFont.lineHeight, scale.pointLabels[i]);
			scale._pointLabelSizes[i] = textSize;
	
			// Add quarter circle to make degree 0 mean top of circle
			var angleRadians = scale.getIndexAngle(i);
			var angle = helpers$1.toDegrees(angleRadians) % 360;
			var hLimits = determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
			var vLimits = determineLimits(angle, pointPosition.y, textSize.h, 90, 270);
	
			if (hLimits.start < furthestLimits.l) {
				furthestLimits.l = hLimits.start;
				furthestAngles.l = angleRadians;
			}
	
			if (hLimits.end > furthestLimits.r) {
				furthestLimits.r = hLimits.end;
				furthestAngles.r = angleRadians;
			}
	
			if (vLimits.start < furthestLimits.t) {
				furthestLimits.t = vLimits.start;
				furthestAngles.t = angleRadians;
			}
	
			if (vLimits.end > furthestLimits.b) {
				furthestLimits.b = vLimits.end;
				furthestAngles.b = angleRadians;
			}
		}
	
		scale.setReductions(scale.drawingArea, furthestLimits, furthestAngles);
	}
	
	function getTextAlignForAngle(angle) {
		if (angle === 0 || angle === 180) {
			return 'center';
		} else if (angle < 180) {
			return 'left';
		}
	
		return 'right';
	}
	
	function fillText(ctx, text, position, lineHeight) {
		var y = position.y + lineHeight / 2;
		var i, ilen;
	
		if (helpers$1.isArray(text)) {
			for (i = 0, ilen = text.length; i < ilen; ++i) {
				ctx.fillText(text[i], position.x, y);
				y += lineHeight;
			}
		} else {
			ctx.fillText(text, position.x, y);
		}
	}
	
	function adjustPointPositionForLabelHeight(angle, textSize, position) {
		if (angle === 90 || angle === 270) {
			position.y -= (textSize.h / 2);
		} else if (angle > 270 || angle < 90) {
			position.y -= textSize.h;
		}
	}
	
	function drawPointLabels(scale) {
		var ctx = scale.ctx;
		var opts = scale.options;
		var pointLabelOpts = opts.pointLabels;
		var tickBackdropHeight = getTickBackdropHeight(opts);
		var outerDistance = scale.getDistanceFromCenterForValue(opts.ticks.reverse ? scale.min : scale.max);
		var plFont = helpers$1.options._parseFont(pointLabelOpts);
	
		ctx.save();
	
		ctx.font = plFont.string;
		ctx.textBaseline = 'middle';
	
		for (var i = scale.chart.data.labels.length - 1; i >= 0; i--) {
			// Extra pixels out for some label spacing
			var extra = (i === 0 ? tickBackdropHeight / 2 : 0);
			var pointLabelPosition = scale.getPointPosition(i, outerDistance + extra + 5);
	
			// Keep this in loop since we may support array properties here
			var pointLabelFontColor = valueAtIndexOrDefault$1(pointLabelOpts.fontColor, i, core_defaults.global.defaultFontColor);
			ctx.fillStyle = pointLabelFontColor;
	
			var angleRadians = scale.getIndexAngle(i);
			var angle = helpers$1.toDegrees(angleRadians);
			ctx.textAlign = getTextAlignForAngle(angle);
			adjustPointPositionForLabelHeight(angle, scale._pointLabelSizes[i], pointLabelPosition);
			fillText(ctx, scale.pointLabels[i], pointLabelPosition, plFont.lineHeight);
		}
		ctx.restore();
	}
	
	function drawRadiusLine(scale, gridLineOpts, radius, index) {
		var ctx = scale.ctx;
		var circular = gridLineOpts.circular;
		var valueCount = scale.chart.data.labels.length;
		var lineColor = valueAtIndexOrDefault$1(gridLineOpts.color, index - 1);
		var lineWidth = valueAtIndexOrDefault$1(gridLineOpts.lineWidth, index - 1);
		var pointPosition;
	
		if ((!circular && !valueCount) || !lineColor || !lineWidth) {
			return;
		}
	
		ctx.save();
		ctx.strokeStyle = lineColor;
		ctx.lineWidth = lineWidth;
		if (ctx.setLineDash) {
			ctx.setLineDash(gridLineOpts.borderDash || []);
			ctx.lineDashOffset = gridLineOpts.borderDashOffset || 0.0;
		}
	
		ctx.beginPath();
		if (circular) {
			// Draw circular arcs between the points
			ctx.arc(scale.xCenter, scale.yCenter, radius, 0, Math.PI * 2);
		} else {
			// Draw straight lines connecting each index
			pointPosition = scale.getPointPosition(0, radius);
			ctx.moveTo(pointPosition.x, pointPosition.y);
	
			for (var i = 1; i < valueCount; i++) {
				pointPosition = scale.getPointPosition(i, radius);
				ctx.lineTo(pointPosition.x, pointPosition.y);
			}
		}
		ctx.closePath();
		ctx.stroke();
		ctx.restore();
	}
	
	function numberOrZero(param) {
		return helpers$1.isNumber(param) ? param : 0;
	}
	
	var scale_radialLinear = scale_linearbase.extend({
		setDimensions: function() {
			var me = this;
	
			// Set the unconstrained dimension before label rotation
			me.width = me.maxWidth;
			me.height = me.maxHeight;
			me.paddingTop = getTickBackdropHeight(me.options) / 2;
			me.xCenter = Math.floor(me.width / 2);
			me.yCenter = Math.floor((me.height - me.paddingTop) / 2);
			me.drawingArea = Math.min(me.height - me.paddingTop, me.width) / 2;
		},
	
		determineDataLimits: function() {
			var me = this;
			var chart = me.chart;
			var min = Number.POSITIVE_INFINITY;
			var max = Number.NEGATIVE_INFINITY;
	
			helpers$1.each(chart.data.datasets, function(dataset, datasetIndex) {
				if (chart.isDatasetVisible(datasetIndex)) {
					var meta = chart.getDatasetMeta(datasetIndex);
	
					helpers$1.each(dataset.data, function(rawValue, index) {
						var value = +me.getRightValue(rawValue);
						if (isNaN(value) || meta.data[index].hidden) {
							return;
						}
	
						min = Math.min(value, min);
						max = Math.max(value, max);
					});
				}
			});
	
			me.min = (min === Number.POSITIVE_INFINITY ? 0 : min);
			me.max = (max === Number.NEGATIVE_INFINITY ? 0 : max);
	
			// Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
			me.handleTickRangeOptions();
		},
	
		// Returns the maximum number of ticks based on the scale dimension
		_computeTickLimit: function() {
			return Math.ceil(this.drawingArea / getTickBackdropHeight(this.options));
		},
	
		convertTicksToLabels: function() {
			var me = this;
	
			scale_linearbase.prototype.convertTicksToLabels.call(me);
	
			// Point labels
			me.pointLabels = me.chart.data.labels.map(function() {
				var label = helpers$1.callback(me.options.pointLabels.callback, arguments, me);
				return label || label === 0 ? label : '';
			});
		},
	
		getLabelForIndex: function(index, datasetIndex) {
			return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
		},
	
		fit: function() {
			var me = this;
			var opts = me.options;
	
			if (opts.display && opts.pointLabels.display) {
				fitWithPointLabels(me);
			} else {
				me.setCenterPoint(0, 0, 0, 0);
			}
		},
	
		/**
		 * Set radius reductions and determine new radius and center point
		 * @private
		 */
		setReductions: function(largestPossibleRadius, furthestLimits, furthestAngles) {
			var me = this;
			var radiusReductionLeft = furthestLimits.l / Math.sin(furthestAngles.l);
			var radiusReductionRight = Math.max(furthestLimits.r - me.width, 0) / Math.sin(furthestAngles.r);
			var radiusReductionTop = -furthestLimits.t / Math.cos(furthestAngles.t);
			var radiusReductionBottom = -Math.max(furthestLimits.b - (me.height - me.paddingTop), 0) / Math.cos(furthestAngles.b);
	
			radiusReductionLeft = numberOrZero(radiusReductionLeft);
			radiusReductionRight = numberOrZero(radiusReductionRight);
			radiusReductionTop = numberOrZero(radiusReductionTop);
			radiusReductionBottom = numberOrZero(radiusReductionBottom);
	
			me.drawingArea = Math.min(
				Math.floor(largestPossibleRadius - (radiusReductionLeft + radiusReductionRight) / 2),
				Math.floor(largestPossibleRadius - (radiusReductionTop + radiusReductionBottom) / 2));
			me.setCenterPoint(radiusReductionLeft, radiusReductionRight, radiusReductionTop, radiusReductionBottom);
		},
	
		setCenterPoint: function(leftMovement, rightMovement, topMovement, bottomMovement) {
			var me = this;
			var maxRight = me.width - rightMovement - me.drawingArea;
			var maxLeft = leftMovement + me.drawingArea;
			var maxTop = topMovement + me.drawingArea;
			var maxBottom = (me.height - me.paddingTop) - bottomMovement - me.drawingArea;
	
			me.xCenter = Math.floor(((maxLeft + maxRight) / 2) + me.left);
			me.yCenter = Math.floor(((maxTop + maxBottom) / 2) + me.top + me.paddingTop);
		},
	
		getIndexAngle: function(index) {
			var chart = this.chart;
			var angleMultiplier = 360 / chart.data.labels.length;
			var options = chart.options || {};
			var startAngle = options.startAngle || 0;
	
			// Start from the top instead of right, so remove a quarter of the circle
			var angle = (index * angleMultiplier + startAngle) % 360;
	
			return (angle < 0 ? angle + 360 : angle) * Math.PI * 2 / 360;
		},
	
		getDistanceFromCenterForValue: function(value) {
			var me = this;
	
			if (helpers$1.isNullOrUndef(value)) {
				return NaN;
			}
	
			// Take into account half font size + the yPadding of the top value
			var scalingFactor = me.drawingArea / (me.max - me.min);
			if (me.options.ticks.reverse) {
				return (me.max - value) * scalingFactor;
			}
			return (value - me.min) * scalingFactor;
		},
	
		getPointPosition: function(index, distanceFromCenter) {
			var me = this;
			var thisAngle = me.getIndexAngle(index) - (Math.PI / 2);
			return {
				x: Math.cos(thisAngle) * distanceFromCenter + me.xCenter,
				y: Math.sin(thisAngle) * distanceFromCenter + me.yCenter
			};
		},
	
		getPointPositionForValue: function(index, value) {
			return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
		},
	
		getBasePosition: function(index) {
			var me = this;
			var min = me.min;
			var max = me.max;
	
			return me.getPointPositionForValue(index || 0,
				me.beginAtZero ? 0 :
				min < 0 && max < 0 ? max :
				min > 0 && max > 0 ? min :
				0);
		},
	
		/**
		 * @private
		 */
		_drawGrid: function() {
			var me = this;
			var ctx = me.ctx;
			var opts = me.options;
			var gridLineOpts = opts.gridLines;
			var angleLineOpts = opts.angleLines;
			var lineWidth = valueOrDefault$c(angleLineOpts.lineWidth, gridLineOpts.lineWidth);
			var lineColor = valueOrDefault$c(angleLineOpts.color, gridLineOpts.color);
			var i, offset, position;
	
			if (opts.pointLabels.display) {
				drawPointLabels(me);
			}
	
			if (gridLineOpts.display) {
				helpers$1.each(me.ticks, function(label, index) {
					if (index !== 0) {
						offset = me.getDistanceFromCenterForValue(me.ticksAsNumbers[index]);
						drawRadiusLine(me, gridLineOpts, offset, index);
					}
				});
			}
	
			if (angleLineOpts.display && lineWidth && lineColor) {
				ctx.save();
				ctx.lineWidth = lineWidth;
				ctx.strokeStyle = lineColor;
				if (ctx.setLineDash) {
					ctx.setLineDash(resolve$4([angleLineOpts.borderDash, gridLineOpts.borderDash, []]));
					ctx.lineDashOffset = resolve$4([angleLineOpts.borderDashOffset, gridLineOpts.borderDashOffset, 0.0]);
				}
	
				for (i = me.chart.data.labels.length - 1; i >= 0; i--) {
					offset = me.getDistanceFromCenterForValue(opts.ticks.reverse ? me.min : me.max);
					position = me.getPointPosition(i, offset);
					ctx.beginPath();
					ctx.moveTo(me.xCenter, me.yCenter);
					ctx.lineTo(position.x, position.y);
					ctx.stroke();
				}
	
				ctx.restore();
			}
		},
	
		/**
		 * @private
		 */
		_drawLabels: function() {
			var me = this;
			var ctx = me.ctx;
			var opts = me.options;
			var tickOpts = opts.ticks;
	
			if (!tickOpts.display) {
				return;
			}
	
			var startAngle = me.getIndexAngle(0);
			var tickFont = helpers$1.options._parseFont(tickOpts);
			var tickFontColor = valueOrDefault$c(tickOpts.fontColor, core_defaults.global.defaultFontColor);
			var offset, width;
	
			ctx.save();
			ctx.font = tickFont.string;
			ctx.translate(me.xCenter, me.yCenter);
			ctx.rotate(startAngle);
			ctx.textAlign = 'center';
			ctx.textBaseline = 'middle';
	
			helpers$1.each(me.ticks, function(label, index) {
				if (index === 0 && !tickOpts.reverse) {
					return;
				}
	
				offset = me.getDistanceFromCenterForValue(me.ticksAsNumbers[index]);
	
				if (tickOpts.showLabelBackdrop) {
					width = ctx.measureText(label).width;
					ctx.fillStyle = tickOpts.backdropColor;
	
					ctx.fillRect(
						-width / 2 - tickOpts.backdropPaddingX,
						-offset - tickFont.size / 2 - tickOpts.backdropPaddingY,
						width + tickOpts.backdropPaddingX * 2,
						tickFont.size + tickOpts.backdropPaddingY * 2
					);
				}
	
				ctx.fillStyle = tickFontColor;
				ctx.fillText(label, 0, -offset);
			});
	
			ctx.restore();
		},
	
		/**
		 * @private
		 */
		_drawTitle: helpers$1.noop
	});
	
	// INTERNAL: static default options, registered in src/index.js
	var _defaults$3 = defaultConfig$3;
	scale_radialLinear._defaults = _defaults$3;
	
	var deprecated$1 = helpers$1._deprecated;
	var resolve$5 = helpers$1.options.resolve;
	var valueOrDefault$d = helpers$1.valueOrDefault;
	
	// Integer constants are from the ES6 spec.
	var MIN_INTEGER = Number.MIN_SAFE_INTEGER || -9007199254740991;
	var MAX_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;
	
	var INTERVALS = {
		millisecond: {
			common: true,
			size: 1,
			steps: 1000
		},
		second: {
			common: true,
			size: 1000,
			steps: 60
		},
		minute: {
			common: true,
			size: 60000,
			steps: 60
		},
		hour: {
			common: true,
			size: 3600000,
			steps: 24
		},
		day: {
			common: true,
			size: 86400000,
			steps: 30
		},
		week: {
			common: false,
			size: 604800000,
			steps: 4
		},
		month: {
			common: true,
			size: 2.628e9,
			steps: 12
		},
		quarter: {
			common: false,
			size: 7.884e9,
			steps: 4
		},
		year: {
			common: true,
			size: 3.154e10
		}
	};
	
	var UNITS = Object.keys(INTERVALS);
	
	function sorter(a, b) {
		return a - b;
	}
	
	function arrayUnique(items) {
		var hash = {};
		var out = [];
		var i, ilen, item;
	
		for (i = 0, ilen = items.length; i < ilen; ++i) {
			item = items[i];
			if (!hash[item]) {
				hash[item] = true;
				out.push(item);
			}
		}
	
		return out;
	}
	
	function getMin(options) {
		return helpers$1.valueOrDefault(options.time.min, options.ticks.min);
	}
	
	function getMax(options) {
		return helpers$1.valueOrDefault(options.time.max, options.ticks.max);
	}
	
	/**
	 * Returns an array of {time, pos} objects used to interpolate a specific `time` or position
	 * (`pos`) on the scale, by searching entries before and after the requested value. `pos` is
	 * a decimal between 0 and 1: 0 being the start of the scale (left or top) and 1 the other
	 * extremity (left + width or top + height). Note that it would be more optimized to directly
	 * store pre-computed pixels, but the scale dimensions are not guaranteed at the time we need
	 * to create the lookup table. The table ALWAYS contains at least two items: min and max.
	 *
	 * @param {number[]} timestamps - timestamps sorted from lowest to highest.
	 * @param {string} distribution - If 'linear', timestamps will be spread linearly along the min
	 * and max range, so basically, the table will contains only two items: {min, 0} and {max, 1}.
	 * If 'series', timestamps will be positioned at the same distance from each other. In this
	 * case, only timestamps that break the time linearity are registered, meaning that in the
	 * best case, all timestamps are linear, the table contains only min and max.
	 */
	function buildLookupTable(timestamps, min, max, distribution) {
		if (distribution === 'linear' || !timestamps.length) {
			return [
				{time: min, pos: 0},
				{time: max, pos: 1}
			];
		}
	
		var table = [];
		var items = [min];
		var i, ilen, prev, curr, next;
	
		for (i = 0, ilen = timestamps.length; i < ilen; ++i) {
			curr = timestamps[i];
			if (curr > min && curr < max) {
				items.push(curr);
			}
		}
	
		items.push(max);
	
		for (i = 0, ilen = items.length; i < ilen; ++i) {
			next = items[i + 1];
			prev = items[i - 1];
			curr = items[i];
	
			// only add points that breaks the scale linearity
			if (prev === undefined || next === undefined || Math.round((next + prev) / 2) !== curr) {
				table.push({time: curr, pos: i / (ilen - 1)});
			}
		}
	
		return table;
	}
	
	// @see adapted from https://www.anujgakhar.com/2014/03/01/binary-search-in-javascript/
	function lookup(table, key, value) {
		var lo = 0;
		var hi = table.length - 1;
		var mid, i0, i1;
	
		while (lo >= 0 && lo <= hi) {
			mid = (lo + hi) >> 1;
			i0 = table[mid - 1] || null;
			i1 = table[mid];
	
			if (!i0) {
				// given value is outside table (before first item)
				return {lo: null, hi: i1};
			} else if (i1[key] < value) {
				lo = mid + 1;
			} else if (i0[key] > value) {
				hi = mid - 1;
			} else {
				return {lo: i0, hi: i1};
			}
		}
	
		// given value is outside table (after last item)
		return {lo: i1, hi: null};
	}
	
	/**
	 * Linearly interpolates the given source `value` using the table items `skey` values and
	 * returns the associated `tkey` value. For example, interpolate(table, 'time', 42, 'pos')
	 * returns the position for a timestamp equal to 42. If value is out of bounds, values at
	 * index [0, 1] or [n - 1, n] are used for the interpolation.
	 */
	function interpolate$1(table, skey, sval, tkey) {
		var range = lookup(table, skey, sval);
	
		// Note: the lookup table ALWAYS contains at least 2 items (min and max)
		var prev = !range.lo ? table[0] : !range.hi ? table[table.length - 2] : range.lo;
		var next = !range.lo ? table[1] : !range.hi ? table[table.length - 1] : range.hi;
	
		var span = next[skey] - prev[skey];
		var ratio = span ? (sval - prev[skey]) / span : 0;
		var offset = (next[tkey] - prev[tkey]) * ratio;
	
		return prev[tkey] + offset;
	}
	
	function toTimestamp(scale, input) {
		var adapter = scale._adapter;
		var options = scale.options.time;
		var parser = options.parser;
		var format = parser || options.format;
		var value = input;
	
		if (typeof parser === 'function') {
			value = parser(value);
		}
	
		// Only parse if its not a timestamp already
		if (!helpers$1.isFinite(value)) {
			value = typeof format === 'string'
				? adapter.parse(value, format)
				: adapter.parse(value);
		}
	
		if (value !== null) {
			return +value;
		}
	
		// Labels are in an incompatible format and no `parser` has been provided.
		// The user might still use the deprecated `format` option for parsing.
		if (!parser && typeof format === 'function') {
			value = format(input);
	
			// `format` could return something else than a timestamp, if so, parse it
			if (!helpers$1.isFinite(value)) {
				value = adapter.parse(value);
			}
		}
	
		return value;
	}
	
	function parse(scale, input) {
		if (helpers$1.isNullOrUndef(input)) {
			return null;
		}
	
		var options = scale.options.time;
		var value = toTimestamp(scale, scale.getRightValue(input));
		if (value === null) {
			return value;
		}
	
		if (options.round) {
			value = +scale._adapter.startOf(value, options.round);
		}
	
		return value;
	}
	
	/**
	 * Figures out what unit results in an appropriate number of auto-generated ticks
	 */
	function determineUnitForAutoTicks(minUnit, min, max, capacity) {
		var ilen = UNITS.length;
		var i, interval, factor;
	
		for (i = UNITS.indexOf(minUnit); i < ilen - 1; ++i) {
			interval = INTERVALS[UNITS[i]];
			factor = interval.steps ? interval.steps : MAX_INTEGER;
	
			if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) {
				return UNITS[i];
			}
		}
	
		return UNITS[ilen - 1];
	}
	
	/**
	 * Figures out what unit to format a set of ticks with
	 */
	function determineUnitForFormatting(scale, numTicks, minUnit, min, max) {
		var i, unit;
	
		for (i = UNITS.length - 1; i >= UNITS.indexOf(minUnit); i--) {
			unit = UNITS[i];
			if (INTERVALS[unit].common && scale._adapter.diff(max, min, unit) >= numTicks - 1) {
				return unit;
			}
		}
	
		return UNITS[minUnit ? UNITS.indexOf(minUnit) : 0];
	}
	
	function determineMajorUnit(unit) {
		for (var i = UNITS.indexOf(unit) + 1, ilen = UNITS.length; i < ilen; ++i) {
			if (INTERVALS[UNITS[i]].common) {
				return UNITS[i];
			}
		}
	}
	
	/**
	 * Generates a maximum of `capacity` timestamps between min and max, rounded to the
	 * `minor` unit using the given scale time `options`.
	 * Important: this method can return ticks outside the min and max range, it's the
	 * responsibility of the calling code to clamp values if needed.
	 */
	function generate(scale, min, max, capacity) {
		var adapter = scale._adapter;
		var options = scale.options;
		var timeOpts = options.time;
		var minor = timeOpts.unit || determineUnitForAutoTicks(timeOpts.minUnit, min, max, capacity);
		var stepSize = resolve$5([timeOpts.stepSize, timeOpts.unitStepSize, 1]);
		var weekday = minor === 'week' ? timeOpts.isoWeekday : false;
		var first = min;
		var ticks = [];
		var time;
	
		// For 'week' unit, handle the first day of week option
		if (weekday) {
			first = +adapter.startOf(first, 'isoWeek', weekday);
		}
	
		// Align first ticks on unit
		first = +adapter.startOf(first, weekday ? 'day' : minor);
	
		// Prevent browser from freezing in case user options request millions of milliseconds
		if (adapter.diff(max, min, minor) > 100000 * stepSize) {
			throw min + ' and ' + max + ' are too far apart with stepSize of ' + stepSize + ' ' + minor;
		}
	
		for (time = first; time < max; time = +adapter.add(time, stepSize, minor)) {
			ticks.push(time);
		}
	
		if (time === max || options.bounds === 'ticks') {
			ticks.push(time);
		}
	
		return ticks;
	}
	
	/**
	 * Returns the start and end offsets from edges in the form of {start, end}
	 * where each value is a relative width to the scale and ranges between 0 and 1.
	 * They add extra margins on the both sides by scaling down the original scale.
	 * Offsets are added when the `offset` option is true.
	 */
	function computeOffsets(table, ticks, min, max, options) {
		var start = 0;
		var end = 0;
		var first, last;
	
		if (options.offset && ticks.length) {
			first = interpolate$1(table, 'time', ticks[0], 'pos');
			if (ticks.length === 1) {
				start = 1 - first;
			} else {
				start = (interpolate$1(table, 'time', ticks[1], 'pos') - first) / 2;
			}
			last = interpolate$1(table, 'time', ticks[ticks.length - 1], 'pos');
			if (ticks.length === 1) {
				end = last;
			} else {
				end = (last - interpolate$1(table, 'time', ticks[ticks.length - 2], 'pos')) / 2;
			}
		}
	
		return {start: start, end: end, factor: 1 / (start + 1 + end)};
	}
	
	function setMajorTicks(scale, ticks, map, majorUnit) {
		var adapter = scale._adapter;
		var first = +adapter.startOf(ticks[0].value, majorUnit);
		var last = ticks[ticks.length - 1].value;
		var major, index;
	
		for (major = first; major <= last; major = +adapter.add(major, 1, majorUnit)) {
			index = map[major];
			if (index >= 0) {
				ticks[index].major = true;
			}
		}
		return ticks;
	}
	
	function ticksFromTimestamps(scale, values, majorUnit) {
		var ticks = [];
		var map = {};
		var ilen = values.length;
		var i, value;
	
		for (i = 0; i < ilen; ++i) {
			value = values[i];
			map[value] = i;
	
			ticks.push({
				value: value,
				major: false
			});
		}
	
		// We set the major ticks separately from the above loop because calling startOf for every tick
		// is expensive when there is a large number of ticks
		return (ilen === 0 || !majorUnit) ? ticks : setMajorTicks(scale, ticks, map, majorUnit);
	}
	
	var defaultConfig$4 = {
		position: 'bottom',
	
		/**
		 * Data distribution along the scale:
		 * - 'linear': data are spread according to their time (distances can vary),
		 * - 'series': data are spread at the same distance from each other.
		 * @see https://github.com/chartjs/Chart.js/pull/4507
		 * @since 2.7.0
		 */
		distribution: 'linear',
	
		/**
		 * Scale boundary strategy (bypassed by min/max time options)
		 * - `data`: make sure data are fully visible, ticks outside are removed
		 * - `ticks`: make sure ticks are fully visible, data outside are truncated
		 * @see https://github.com/chartjs/Chart.js/pull/4556
		 * @since 2.7.0
		 */
		bounds: 'data',
	
		adapters: {},
		time: {
			parser: false, // false == a pattern string from https://momentjs.com/docs/#/parsing/string-format/ or a custom callback that converts its argument to a moment
			unit: false, // false == automatic or override with week, month, year, etc.
			round: false, // none, or override with week, month, year, etc.
			displayFormat: false, // DEPRECATED
			isoWeekday: false, // override week start day - see https://momentjs.com/docs/#/get-set/iso-weekday/
			minUnit: 'millisecond',
			displayFormats: {}
		},
		ticks: {
			autoSkip: false,
	
			/**
			 * Ticks generation input values:
			 * - 'auto': generates "optimal" ticks based on scale size and time options.
			 * - 'data': generates ticks from data (including labels from data {t|x|y} objects).
			 * - 'labels': generates ticks from user given `data.labels` values ONLY.
			 * @see https://github.com/chartjs/Chart.js/pull/4507
			 * @since 2.7.0
			 */
			source: 'auto',
	
			major: {
				enabled: false
			}
		}
	};
	
	var scale_time = core_scale.extend({
		initialize: function() {
			this.mergeTicksOptions();
			core_scale.prototype.initialize.call(this);
		},
	
		update: function() {
			var me = this;
			var options = me.options;
			var time = options.time || (options.time = {});
			var adapter = me._adapter = new core_adapters._date(options.adapters.date);
	
			// DEPRECATIONS: output a message only one time per update
			deprecated$1('time scale', time.format, 'time.format', 'time.parser');
			deprecated$1('time scale', time.min, 'time.min', 'ticks.min');
			deprecated$1('time scale', time.max, 'time.max', 'ticks.max');
	
			// Backward compatibility: before introducing adapter, `displayFormats` was
			// supposed to contain *all* unit/string pairs but this can't be resolved
			// when loading the scale (adapters are loaded afterward), so let's populate
			// missing formats on update
			helpers$1.mergeIf(time.displayFormats, adapter.formats());
	
			return core_scale.prototype.update.apply(me, arguments);
		},
	
		/**
		 * Allows data to be referenced via 't' attribute
		 */
		getRightValue: function(rawValue) {
			if (rawValue && rawValue.t !== undefined) {
				rawValue = rawValue.t;
			}
			return core_scale.prototype.getRightValue.call(this, rawValue);
		},
	
		determineDataLimits: function() {
			var me = this;
			var chart = me.chart;
			var adapter = me._adapter;
			var options = me.options;
			var unit = options.time.unit || 'day';
			var min = MAX_INTEGER;
			var max = MIN_INTEGER;
			var timestamps = [];
			var datasets = [];
			var labels = [];
			var i, j, ilen, jlen, data, timestamp, labelsAdded;
			var dataLabels = me._getLabels();
	
			for (i = 0, ilen = dataLabels.length; i < ilen; ++i) {
				labels.push(parse(me, dataLabels[i]));
			}
	
			for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
				if (chart.isDatasetVisible(i)) {
					data = chart.data.datasets[i].data;
	
					// Let's consider that all data have the same format.
					if (helpers$1.isObject(data[0])) {
						datasets[i] = [];
	
						for (j = 0, jlen = data.length; j < jlen; ++j) {
							timestamp = parse(me, data[j]);
							timestamps.push(timestamp);
							datasets[i][j] = timestamp;
						}
					} else {
						datasets[i] = labels.slice(0);
						if (!labelsAdded) {
							timestamps = timestamps.concat(labels);
							labelsAdded = true;
						}
					}
				} else {
					datasets[i] = [];
				}
			}
	
			if (labels.length) {
				min = Math.min(min, labels[0]);
				max = Math.max(max, labels[labels.length - 1]);
			}
	
			if (timestamps.length) {
				timestamps = ilen > 1 ? arrayUnique(timestamps).sort(sorter) : timestamps.sort(sorter);
				min = Math.min(min, timestamps[0]);
				max = Math.max(max, timestamps[timestamps.length - 1]);
			}
	
			min = parse(me, getMin(options)) || min;
			max = parse(me, getMax(options)) || max;
	
			// In case there is no valid min/max, set limits based on unit time option
			min = min === MAX_INTEGER ? +adapter.startOf(Date.now(), unit) : min;
			max = max === MIN_INTEGER ? +adapter.endOf(Date.now(), unit) + 1 : max;
	
			// Make sure that max is strictly higher than min (required by the lookup table)
			me.min = Math.min(min, max);
			me.max = Math.max(min + 1, max);
	
			// PRIVATE
			me._table = [];
			me._timestamps = {
				data: timestamps,
				datasets: datasets,
				labels: labels
			};
		},
	
		buildTicks: function() {
			var me = this;
			var min = me.min;
			var max = me.max;
			var options = me.options;
			var tickOpts = options.ticks;
			var timeOpts = options.time;
			var timestamps = me._timestamps;
			var ticks = [];
			var capacity = me.getLabelCapacity(min);
			var source = tickOpts.source;
			var distribution = options.distribution;
			var i, ilen, timestamp;
	
			if (source === 'data' || (source === 'auto' && distribution === 'series')) {
				timestamps = timestamps.data;
			} else if (source === 'labels') {
				timestamps = timestamps.labels;
			} else {
				timestamps = generate(me, min, max, capacity);
			}
	
			if (options.bounds === 'ticks' && timestamps.length) {
				min = timestamps[0];
				max = timestamps[timestamps.length - 1];
			}
	
			// Enforce limits with user min/max options
			min = parse(me, getMin(options)) || min;
			max = parse(me, getMax(options)) || max;
	
			// Remove ticks outside the min/max range
			for (i = 0, ilen = timestamps.length; i < ilen; ++i) {
				timestamp = timestamps[i];
				if (timestamp >= min && timestamp <= max) {
					ticks.push(timestamp);
				}
			}
	
			me.min = min;
			me.max = max;
	
			// PRIVATE
			// determineUnitForFormatting relies on the number of ticks so we don't use it when
			// autoSkip is enabled because we don't yet know what the final number of ticks will be
			me._unit = timeOpts.unit || (tickOpts.autoSkip
				? determineUnitForAutoTicks(timeOpts.minUnit, me.min, me.max, capacity)
				: determineUnitForFormatting(me, ticks.length, timeOpts.minUnit, me.min, me.max));
			me._majorUnit = !tickOpts.major.enabled || me._unit === 'year' ? undefined
				: determineMajorUnit(me._unit);
			me._table = buildLookupTable(me._timestamps.data, min, max, distribution);
			me._offsets = computeOffsets(me._table, ticks, min, max, options);
	
			if (tickOpts.reverse) {
				ticks.reverse();
			}
	
			return ticksFromTimestamps(me, ticks, me._majorUnit);
		},
	
		getLabelForIndex: function(index, datasetIndex) {
			var me = this;
			var adapter = me._adapter;
			var data = me.chart.data;
			var timeOpts = me.options.time;
			var label = data.labels && index < data.labels.length ? data.labels[index] : '';
			var value = data.datasets[datasetIndex].data[index];
	
			if (helpers$1.isObject(value)) {
				label = me.getRightValue(value);
			}
			if (timeOpts.tooltipFormat) {
				return adapter.format(toTimestamp(me, label), timeOpts.tooltipFormat);
			}
			if (typeof label === 'string') {
				return label;
			}
			return adapter.format(toTimestamp(me, label), timeOpts.displayFormats.datetime);
		},
	
		/**
		 * Function to format an individual tick mark
		 * @private
		 */
		tickFormatFunction: function(time, index, ticks, format) {
			var me = this;
			var adapter = me._adapter;
			var options = me.options;
			var formats = options.time.displayFormats;
			var minorFormat = formats[me._unit];
			var majorUnit = me._majorUnit;
			var majorFormat = formats[majorUnit];
			var tick = ticks[index];
			var tickOpts = options.ticks;
			var major = majorUnit && majorFormat && tick && tick.major;
			var label = adapter.format(time, format ? format : major ? majorFormat : minorFormat);
			var nestedTickOpts = major ? tickOpts.major : tickOpts.minor;
			var formatter = resolve$5([
				nestedTickOpts.callback,
				nestedTickOpts.userCallback,
				tickOpts.callback,
				tickOpts.userCallback
			]);
	
			return formatter ? formatter(label, index, ticks) : label;
		},
	
		convertTicksToLabels: function(ticks) {
			var labels = [];
			var i, ilen;
	
			for (i = 0, ilen = ticks.length; i < ilen; ++i) {
				labels.push(this.tickFormatFunction(ticks[i].value, i, ticks));
			}
	
			return labels;
		},
	
		/**
		 * @private
		 */
		getPixelForOffset: function(time) {
			var me = this;
			var offsets = me._offsets;
			var pos = interpolate$1(me._table, 'time', time, 'pos');
			return me.getPixelForDecimal((offsets.start + pos) * offsets.factor);
		},
	
		getPixelForValue: function(value, index, datasetIndex) {
			var me = this;
			var time = null;
	
			if (index !== undefined && datasetIndex !== undefined) {
				time = me._timestamps.datasets[datasetIndex][index];
			}
	
			if (time === null) {
				time = parse(me, value);
			}
	
			if (time !== null) {
				return me.getPixelForOffset(time);
			}
		},
	
		getPixelForTick: function(index) {
			var ticks = this.getTicks();
			return index >= 0 && index < ticks.length ?
				this.getPixelForOffset(ticks[index].value) :
				null;
		},
	
		getValueForPixel: function(pixel) {
			var me = this;
			var offsets = me._offsets;
			var pos = me.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
			var time = interpolate$1(me._table, 'pos', pos, 'time');
	
			// DEPRECATION, we should return time directly
			return me._adapter._create(time);
		},
	
		/**
		 * @private
		 */
		_getLabelSize: function(label) {
			var me = this;
			var ticksOpts = me.options.ticks;
			var tickLabelWidth = me.ctx.measureText(label).width;
			var angle = helpers$1.toRadians(me.isHorizontal() ? ticksOpts.maxRotation : ticksOpts.minRotation);
			var cosRotation = Math.cos(angle);
			var sinRotation = Math.sin(angle);
			var tickFontSize = valueOrDefault$d(ticksOpts.fontSize, core_defaults.global.defaultFontSize);
	
			return {
				w: (tickLabelWidth * cosRotation) + (tickFontSize * sinRotation),
				h: (tickLabelWidth * sinRotation) + (tickFontSize * cosRotation)
			};
		},
	
		/**
		 * Crude approximation of what the label width might be
		 * @private
		 */
		getLabelWidth: function(label) {
			return this._getLabelSize(label).w;
		},
	
		/**
		 * @private
		 */
		getLabelCapacity: function(exampleTime) {
			var me = this;
			var timeOpts = me.options.time;
			var displayFormats = timeOpts.displayFormats;
	
			// pick the longest format (milliseconds) for guestimation
			var format = displayFormats[timeOpts.unit] || displayFormats.millisecond;
			var exampleLabel = me.tickFormatFunction(exampleTime, 0, ticksFromTimestamps(me, [exampleTime], me._majorUnit), format);
			var size = me._getLabelSize(exampleLabel);
			var capacity = Math.floor(me.isHorizontal() ? me.width / size.w : me.height / size.h);
	
			if (me.options.offset) {
				capacity--;
			}
	
			return capacity > 0 ? capacity : 1;
		}
	});
	
	// INTERNAL: static default options, registered in src/index.js
	var _defaults$4 = defaultConfig$4;
	scale_time._defaults = _defaults$4;
	
	var scales = {
		category: scale_category,
		linear: scale_linear,
		logarithmic: scale_logarithmic,
		radialLinear: scale_radialLinear,
		time: scale_time
	};
	
	var FORMATS = {
		datetime: 'MMM D, YYYY, h:mm:ss a',
		millisecond: 'h:mm:ss.SSS a',
		second: 'h:mm:ss a',
		minute: 'h:mm a',
		hour: 'hA',
		day: 'MMM D',
		week: 'll',
		month: 'MMM YYYY',
		quarter: '[Q]Q - YYYY',
		year: 'YYYY'
	};
	
	core_adapters._date.override(typeof moment === 'function' ? {
		_id: 'moment', // DEBUG ONLY
	
		formats: function() {
			return FORMATS;
		},
	
		parse: function(value, format) {
			if (typeof value === 'string' && typeof format === 'string') {
				value = moment(value, format);
			} else if (!(value instanceof moment)) {
				value = moment(value);
			}
			return value.isValid() ? value.valueOf() : null;
		},
	
		format: function(time, format) {
			return moment(time).format(format);
		},
	
		add: function(time, amount, unit) {
			return moment(time).add(amount, unit).valueOf();
		},
	
		diff: function(max, min, unit) {
			return moment(max).diff(moment(min), unit);
		},
	
		startOf: function(time, unit, weekday) {
			time = moment(time);
			if (unit === 'isoWeek') {
				return time.isoWeekday(weekday).valueOf();
			}
			return time.startOf(unit).valueOf();
		},
	
		endOf: function(time, unit) {
			return moment(time).endOf(unit).valueOf();
		},
	
		// DEPRECATIONS
	
		/**
		 * Provided for backward compatibility with scale.getValueForPixel().
		 * @deprecated since version 2.8.0
		 * @todo remove at version 3
		 * @private
		 */
		_create: function(time) {
			return moment(time);
		},
	} : {});
	
	core_defaults._set('global', {
		plugins: {
			filler: {
				propagate: true
			}
		}
	});
	
	var mappers = {
		dataset: function(source) {
			var index = source.fill;
			var chart = source.chart;
			var meta = chart.getDatasetMeta(index);
			var visible = meta && chart.isDatasetVisible(index);
			var points = (visible && meta.dataset._children) || [];
			var length = points.length || 0;
	
			return !length ? null : function(point, i) {
				return (i < length && points[i]._view) || null;
			};
		},
	
		boundary: function(source) {
			var boundary = source.boundary;
			var x = boundary ? boundary.x : null;
			var y = boundary ? boundary.y : null;
	
			if (helpers$1.isArray(boundary)) {
				return function(point, i) {
					return boundary[i];
				};
			}
	
			return function(point) {
				return {
					x: x === null ? point.x : x,
					y: y === null ? point.y : y,
				};
			};
		}
	};
	
	// @todo if (fill[0] === '#')
	function decodeFill(el, index, count) {
		var model = el._model || {};
		var fill = model.fill;
		var target;
	
		if (fill === undefined) {
			fill = !!model.backgroundColor;
		}
	
		if (fill === false || fill === null) {
			return false;
		}
	
		if (fill === true) {
			return 'origin';
		}
	
		target = parseFloat(fill, 10);
		if (isFinite(target) && Math.floor(target) === target) {
			if (fill[0] === '-' || fill[0] === '+') {
				target = index + target;
			}
	
			if (target === index || target < 0 || target >= count) {
				return false;
			}
	
			return target;
		}
	
		switch (fill) {
		// compatibility
		case 'bottom':
			return 'start';
		case 'top':
			return 'end';
		case 'zero':
			return 'origin';
		// supported boundaries
		case 'origin':
		case 'start':
		case 'end':
			return fill;
		// invalid fill values
		default:
			return false;
		}
	}
	
	function computeLinearBoundary(source) {
		var model = source.el._model || {};
		var scale = source.el._scale || {};
		var fill = source.fill;
		var target = null;
		var horizontal;
	
		if (isFinite(fill)) {
			return null;
		}
	
		// Backward compatibility: until v3, we still need to support boundary values set on
		// the model (scaleTop, scaleBottom and scaleZero) because some external plugins and
		// controllers might still use it (e.g. the Smith chart).
	
		if (fill === 'start') {
			target = model.scaleBottom === undefined ? scale.bottom : model.scaleBottom;
		} else if (fill === 'end') {
			target = model.scaleTop === undefined ? scale.top : model.scaleTop;
		} else if (model.scaleZero !== undefined) {
			target = model.scaleZero;
		} else if (scale.getBasePixel) {
			target = scale.getBasePixel();
		}
	
		if (target !== undefined && target !== null) {
			if (target.x !== undefined && target.y !== undefined) {
				return target;
			}
	
			if (helpers$1.isFinite(target)) {
				horizontal = scale.isHorizontal();
				return {
					x: horizontal ? target : null,
					y: horizontal ? null : target
				};
			}
		}
	
		return null;
	}
	
	function computeCircularBoundary(source) {
		var scale = source.el._scale;
		var options = scale.options;
		var length = scale.chart.data.labels.length;
		var fill = source.fill;
		var target = [];
		var start, end, center, i, point;
	
		if (!length) {
			return null;
		}
	
		start = options.ticks.reverse ? scale.max : scale.min;
		end = options.ticks.reverse ? scale.min : scale.max;
		center = scale.getPointPositionForValue(0, start);
		for (i = 0; i < length; ++i) {
			point = fill === 'start' || fill === 'end'
				? scale.getPointPositionForValue(i, fill === 'start' ? start : end)
				: scale.getBasePosition(i);
			if (options.gridLines.circular) {
				point.cx = center.x;
				point.cy = center.y;
				point.angle = scale.getIndexAngle(i) - Math.PI / 2;
			}
			target.push(point);
		}
		return target;
	}
	
	function computeBoundary(source) {
		var scale = source.el._scale || {};
	
		if (scale.getPointPositionForValue) {
			return computeCircularBoundary(source);
		}
		return computeLinearBoundary(source);
	}
	
	function resolveTarget(sources, index, propagate) {
		var source = sources[index];
		var fill = source.fill;
		var visited = [index];
		var target;
	
		if (!propagate) {
			return fill;
		}
	
		while (fill !== false && visited.indexOf(fill) === -1) {
			if (!isFinite(fill)) {
				return fill;
			}
	
			target = sources[fill];
			if (!target) {
				return false;
			}
	
			if (target.visible) {
				return fill;
			}
	
			visited.push(fill);
			fill = target.fill;
		}
	
		return false;
	}
	
	function createMapper(source) {
		var fill = source.fill;
		var type = 'dataset';
	
		if (fill === false) {
			return null;
		}
	
		if (!isFinite(fill)) {
			type = 'boundary';
		}
	
		return mappers[type](source);
	}
	
	function isDrawable(point) {
		return point && !point.skip;
	}
	
	function drawArea(ctx, curve0, curve1, len0, len1) {
		var i, cx, cy, r;
	
		if (!len0 || !len1) {
			return;
		}
	
		// building first area curve (normal)
		ctx.moveTo(curve0[0].x, curve0[0].y);
		for (i = 1; i < len0; ++i) {
			helpers$1.canvas.lineTo(ctx, curve0[i - 1], curve0[i]);
		}
	
		if (curve1[0].angle !== undefined) {
			cx = curve1[0].cx;
			cy = curve1[0].cy;
			r = Math.sqrt(Math.pow(curve1[0].x - cx, 2) + Math.pow(curve1[0].y - cy, 2));
			for (i = len1 - 1; i > 0; --i) {
				ctx.arc(cx, cy, r, curve1[i].angle, curve1[i - 1].angle, true);
			}
			return;
		}
	
		// joining the two area curves
		ctx.lineTo(curve1[len1 - 1].x, curve1[len1 - 1].y);
	
		// building opposite area curve (reverse)
		for (i = len1 - 1; i > 0; --i) {
			helpers$1.canvas.lineTo(ctx, curve1[i], curve1[i - 1], true);
		}
	}
	
	function doFill(ctx, points, mapper, view, color, loop) {
		var count = points.length;
		var span = view.spanGaps;
		var curve0 = [];
		var curve1 = [];
		var len0 = 0;
		var len1 = 0;
		var i, ilen, index, p0, p1, d0, d1, loopOffset;
	
		ctx.beginPath();
	
		for (i = 0, ilen = count; i < ilen; ++i) {
			index = i % count;
			p0 = points[index]._view;
			p1 = mapper(p0, index, view);
			d0 = isDrawable(p0);
			d1 = isDrawable(p1);
	
			if (loop && loopOffset === undefined && d0) {
				loopOffset = i + 1;
				ilen = count + loopOffset;
			}
	
			if (d0 && d1) {
				len0 = curve0.push(p0);
				len1 = curve1.push(p1);
			} else if (len0 && len1) {
				if (!span) {
					drawArea(ctx, curve0, curve1, len0, len1);
					len0 = len1 = 0;
					curve0 = [];
					curve1 = [];
				} else {
					if (d0) {
						curve0.push(p0);
					}
					if (d1) {
						curve1.push(p1);
					}
				}
			}
		}
	
		drawArea(ctx, curve0, curve1, len0, len1);
	
		ctx.closePath();
		ctx.fillStyle = color;
		ctx.fill();
	}
	
	var plugin_filler = {
		id: 'filler',
	
		afterDatasetsUpdate: function(chart, options) {
			var count = (chart.data.datasets || []).length;
			var propagate = options.propagate;
			var sources = [];
			var meta, i, el, source;
	
			for (i = 0; i < count; ++i) {
				meta = chart.getDatasetMeta(i);
				el = meta.dataset;
				source = null;
	
				if (el && el._model && el instanceof elements.Line) {
					source = {
						visible: chart.isDatasetVisible(i),
						fill: decodeFill(el, i, count),
						chart: chart,
						el: el
					};
				}
	
				meta.$filler = source;
				sources.push(source);
			}
	
			for (i = 0; i < count; ++i) {
				source = sources[i];
				if (!source) {
					continue;
				}
	
				source.fill = resolveTarget(sources, i, propagate);
				source.boundary = computeBoundary(source);
				source.mapper = createMapper(source);
			}
		},
	
		beforeDatasetsDraw: function(chart) {
			var metasets = chart._getSortedVisibleDatasetMetas();
			var ctx = chart.ctx;
			var meta, i, el, view, points, mapper, color;
	
			for (i = metasets.length - 1; i >= 0; --i) {
				meta = metasets[i].$filler;
	
				if (!meta || !meta.visible) {
					continue;
				}
	
				el = meta.el;
				view = el._view;
				points = el._children || [];
				mapper = meta.mapper;
				color = view.backgroundColor || core_defaults.global.defaultColor;
	
				if (mapper && color && points.length) {
					helpers$1.canvas.clipArea(ctx, chart.chartArea);
					doFill(ctx, points, mapper, view, color, el._loop);
					helpers$1.canvas.unclipArea(ctx);
				}
			}
		}
	};
	
	var getRtlHelper$1 = helpers$1.rtl.getRtlAdapter;
	var noop$1 = helpers$1.noop;
	var valueOrDefault$e = helpers$1.valueOrDefault;
	
	core_defaults._set('global', {
		legend: {
			display: true,
			position: 'top',
			align: 'center',
			fullWidth: true,
			reverse: false,
			weight: 1000,
	
			// a callback that will handle
			onClick: function(e, legendItem) {
				var index = legendItem.datasetIndex;
				var ci = this.chart;
				var meta = ci.getDatasetMeta(index);
	
				// See controller.isDatasetVisible comment
				meta.hidden = meta.hidden === null ? !ci.data.datasets[index].hidden : null;
	
				// We hid a dataset ... rerender the chart
				ci.update();
			},
	
			onHover: null,
			onLeave: null,
	
			labels: {
				boxWidth: 40,
				padding: 10,
				// Generates labels shown in the legend
				// Valid properties to return:
				// text : text to display
				// fillStyle : fill of coloured box
				// strokeStyle: stroke of coloured box
				// hidden : if this legend item refers to a hidden item
				// lineCap : cap style for line
				// lineDash
				// lineDashOffset :
				// lineJoin :
				// lineWidth :
				generateLabels: function(chart) {
					var datasets = chart.data.datasets;
					var options = chart.options.legend || {};
					var usePointStyle = options.labels && options.labels.usePointStyle;
	
					return chart._getSortedDatasetMetas().map(function(meta) {
						var style = meta.controller.getStyle(usePointStyle ? 0 : undefined);
	
						return {
							text: datasets[meta.index].label,
							fillStyle: style.backgroundColor,
							hidden: !chart.isDatasetVisible(meta.index),
							lineCap: style.borderCapStyle,
							lineDash: style.borderDash,
							lineDashOffset: style.borderDashOffset,
							lineJoin: style.borderJoinStyle,
							lineWidth: style.borderWidth,
							strokeStyle: style.borderColor,
							pointStyle: style.pointStyle,
							rotation: style.rotation,
	
							// Below is extra data used for toggling the datasets
							datasetIndex: meta.index
						};
					}, this);
				}
			}
		},
	
		legendCallback: function(chart) {
			var list = document.createElement('ul');
			var datasets = chart.data.datasets;
			var i, ilen, listItem, listItemSpan;
	
			list.setAttribute('class', chart.id + '-legend');
	
			for (i = 0, ilen = datasets.length; i < ilen; i++) {
				listItem = list.appendChild(document.createElement('li'));
				listItemSpan = listItem.appendChild(document.createElement('span'));
				listItemSpan.style.backgroundColor = datasets[i].backgroundColor;
				if (datasets[i].label) {
					listItem.appendChild(document.createTextNode(datasets[i].label));
				}
			}
	
			return list.outerHTML;
		}
	});
	
	/**
	 * Helper function to get the box width based on the usePointStyle option
	 * @param {object} labelopts - the label options on the legend
	 * @param {number} fontSize - the label font size
	 * @return {number} width of the color box area
	 */
	function getBoxWidth(labelOpts, fontSize) {
		return labelOpts.usePointStyle && labelOpts.boxWidth > fontSize ?
			fontSize :
			labelOpts.boxWidth;
	}
	
	/**
	 * IMPORTANT: this class is exposed publicly as Chart.Legend, backward compatibility required!
	 */
	var Legend = core_element.extend({
	
		initialize: function(config) {
			var me = this;
			helpers$1.extend(me, config);
	
			// Contains hit boxes for each dataset (in dataset order)
			me.legendHitBoxes = [];
	
			/**
	 		 * @private
	 		 */
			me._hoveredItem = null;
	
			// Are we in doughnut mode which has a different data type
			me.doughnutMode = false;
		},
	
		// These methods are ordered by lifecycle. Utilities then follow.
		// Any function defined here is inherited by all legend types.
		// Any function can be extended by the legend type
	
		beforeUpdate: noop$1,
		update: function(maxWidth, maxHeight, margins) {
			var me = this;
	
			// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
			me.beforeUpdate();
	
			// Absorb the master measurements
			me.maxWidth = maxWidth;
			me.maxHeight = maxHeight;
			me.margins = margins;
	
			// Dimensions
			me.beforeSetDimensions();
			me.setDimensions();
			me.afterSetDimensions();
			// Labels
			me.beforeBuildLabels();
			me.buildLabels();
			me.afterBuildLabels();
	
			// Fit
			me.beforeFit();
			me.fit();
			me.afterFit();
			//
			me.afterUpdate();
	
			return me.minSize;
		},
		afterUpdate: noop$1,
	
		//
	
		beforeSetDimensions: noop$1,
		setDimensions: function() {
			var me = this;
			// Set the unconstrained dimension before label rotation
			if (me.isHorizontal()) {
				// Reset position before calculating rotation
				me.width = me.maxWidth;
				me.left = 0;
				me.right = me.width;
			} else {
				me.height = me.maxHeight;
	
				// Reset position before calculating rotation
				me.top = 0;
				me.bottom = me.height;
			}
	
			// Reset padding
			me.paddingLeft = 0;
			me.paddingTop = 0;
			me.paddingRight = 0;
			me.paddingBottom = 0;
	
			// Reset minSize
			me.minSize = {
				width: 0,
				height: 0
			};
		},
		afterSetDimensions: noop$1,
	
		//
	
		beforeBuildLabels: noop$1,
		buildLabels: function() {
			var me = this;
			var labelOpts = me.options.labels || {};
			var legendItems = helpers$1.callback(labelOpts.generateLabels, [me.chart], me) || [];
	
			if (labelOpts.filter) {
				legendItems = legendItems.filter(function(item) {
					return labelOpts.filter(item, me.chart.data);
				});
			}
	
			if (me.options.reverse) {
				legendItems.reverse();
			}
	
			me.legendItems = legendItems;
		},
		afterBuildLabels: noop$1,
	
		//
	
		beforeFit: noop$1,
		fit: function() {
			var me = this;
			var opts = me.options;
			var labelOpts = opts.labels;
			var display = opts.display;
	
			var ctx = me.ctx;
	
			var labelFont = helpers$1.options._parseFont(labelOpts);
			var fontSize = labelFont.size;
	
			// Reset hit boxes
			var hitboxes = me.legendHitBoxes = [];
	
			var minSize = me.minSize;
			var isHorizontal = me.isHorizontal();
	
			if (isHorizontal) {
				minSize.width = me.maxWidth; // fill all the width
				minSize.height = display ? 10 : 0;
			} else {
				minSize.width = display ? 10 : 0;
				minSize.height = me.maxHeight; // fill all the height
			}
	
			// Increase sizes here
			if (!display) {
				me.width = minSize.width = me.height = minSize.height = 0;
				return;
			}
			ctx.font = labelFont.string;
	
			if (isHorizontal) {
				// Labels
	
				// Width of each line of legend boxes. Labels wrap onto multiple lines when there are too many to fit on one
				var lineWidths = me.lineWidths = [0];
				var totalHeight = 0;
	
				ctx.textAlign = 'left';
				ctx.textBaseline = 'middle';
	
				helpers$1.each(me.legendItems, function(legendItem, i) {
					var boxWidth = getBoxWidth(labelOpts, fontSize);
					var width = boxWidth + (fontSize / 2) + ctx.measureText(legendItem.text).width;
	
					if (i === 0 || lineWidths[lineWidths.length - 1] + width + 2 * labelOpts.padding > minSize.width) {
						totalHeight += fontSize + labelOpts.padding;
						lineWidths[lineWidths.length - (i > 0 ? 0 : 1)] = 0;
					}
	
					// Store the hitbox width and height here. Final position will be updated in `draw`
					hitboxes[i] = {
						left: 0,
						top: 0,
						width: width,
						height: fontSize
					};
	
					lineWidths[lineWidths.length - 1] += width + labelOpts.padding;
				});
	
				minSize.height += totalHeight;
	
			} else {
				var vPadding = labelOpts.padding;
				var columnWidths = me.columnWidths = [];
				var columnHeights = me.columnHeights = [];
				var totalWidth = labelOpts.padding;
				var currentColWidth = 0;
				var currentColHeight = 0;
	
				helpers$1.each(me.legendItems, function(legendItem, i) {
					var boxWidth = getBoxWidth(labelOpts, fontSize);
					var itemWidth = boxWidth + (fontSize / 2) + ctx.measureText(legendItem.text).width;
	
					// If too tall, go to new column
					if (i > 0 && currentColHeight + fontSize + 2 * vPadding > minSize.height) {
						totalWidth += currentColWidth + labelOpts.padding;
						columnWidths.push(currentColWidth); // previous column width
						columnHeights.push(currentColHeight);
						currentColWidth = 0;
						currentColHeight = 0;
					}
	
					// Get max width
					currentColWidth = Math.max(currentColWidth, itemWidth);
					currentColHeight += fontSize + vPadding;
	
					// Store the hitbox width and height here. Final position will be updated in `draw`
					hitboxes[i] = {
						left: 0,
						top: 0,
						width: itemWidth,
						height: fontSize
					};
				});
	
				totalWidth += currentColWidth;
				columnWidths.push(currentColWidth);
				columnHeights.push(currentColHeight);
				minSize.width += totalWidth;
			}
	
			me.width = minSize.width;
			me.height = minSize.height;
		},
		afterFit: noop$1,
	
		// Shared Methods
		isHorizontal: function() {
			return this.options.position === 'top' || this.options.position === 'bottom';
		},
	
		// Actually draw the legend on the canvas
		draw: function() {
			var me = this;
			var opts = me.options;
			var labelOpts = opts.labels;
			var globalDefaults = core_defaults.global;
			var defaultColor = globalDefaults.defaultColor;
			var lineDefault = globalDefaults.elements.line;
			var legendHeight = me.height;
			var columnHeights = me.columnHeights;
			var legendWidth = me.width;
			var lineWidths = me.lineWidths;
	
			if (!opts.display) {
				return;
			}
	
			var rtlHelper = getRtlHelper$1(opts.rtl, me.left, me.minSize.width);
			var ctx = me.ctx;
			var fontColor = valueOrDefault$e(labelOpts.fontColor, globalDefaults.defaultFontColor);
			var labelFont = helpers$1.options._parseFont(labelOpts);
			var fontSize = labelFont.size;
			var cursor;
	
			// Canvas setup
			ctx.textAlign = rtlHelper.textAlign('left');
			ctx.textBaseline = 'middle';
			ctx.lineWidth = 0.5;
			ctx.strokeStyle = fontColor; // for strikethrough effect
			ctx.fillStyle = fontColor; // render in correct colour
			ctx.font = labelFont.string;
	
			var boxWidth = getBoxWidth(labelOpts, fontSize);
			var hitboxes = me.legendHitBoxes;
	
			// current position
			var drawLegendBox = function(x, y, legendItem) {
				if (isNaN(boxWidth) || boxWidth <= 0) {
					return;
				}
	
				// Set the ctx for the box
				ctx.save();
	
				var lineWidth = valueOrDefault$e(legendItem.lineWidth, lineDefault.borderWidth);
				ctx.fillStyle = valueOrDefault$e(legendItem.fillStyle, defaultColor);
				ctx.lineCap = valueOrDefault$e(legendItem.lineCap, lineDefault.borderCapStyle);
				ctx.lineDashOffset = valueOrDefault$e(legendItem.lineDashOffset, lineDefault.borderDashOffset);
				ctx.lineJoin = valueOrDefault$e(legendItem.lineJoin, lineDefault.borderJoinStyle);
				ctx.lineWidth = lineWidth;
				ctx.strokeStyle = valueOrDefault$e(legendItem.strokeStyle, defaultColor);
	
				if (ctx.setLineDash) {
					// IE 9 and 10 do not support line dash
					ctx.setLineDash(valueOrDefault$e(legendItem.lineDash, lineDefault.borderDash));
				}
	
				if (labelOpts && labelOpts.usePointStyle) {
					// Recalculate x and y for drawPoint() because its expecting
					// x and y to be center of figure (instead of top left)
					var radius = boxWidth * Math.SQRT2 / 2;
					var centerX = rtlHelper.xPlus(x, boxWidth / 2);
					var centerY = y + fontSize / 2;
	
					// Draw pointStyle as legend symbol
					helpers$1.canvas.drawPoint(ctx, legendItem.pointStyle, radius, centerX, centerY, legendItem.rotation);
				} else {
					// Draw box as legend symbol
					ctx.fillRect(rtlHelper.leftForLtr(x, boxWidth), y, boxWidth, fontSize);
					if (lineWidth !== 0) {
						ctx.strokeRect(rtlHelper.leftForLtr(x, boxWidth), y, boxWidth, fontSize);
					}
				}
	
				ctx.restore();
			};
	
			var fillText = function(x, y, legendItem, textWidth) {
				var halfFontSize = fontSize / 2;
				var xLeft = rtlHelper.xPlus(x, boxWidth + halfFontSize);
				var yMiddle = y + halfFontSize;
	
				ctx.fillText(legendItem.text, xLeft, yMiddle);
	
				if (legendItem.hidden) {
					// Strikethrough the text if hidden
					ctx.beginPath();
					ctx.lineWidth = 2;
					ctx.moveTo(xLeft, yMiddle);
					ctx.lineTo(rtlHelper.xPlus(xLeft, textWidth), yMiddle);
					ctx.stroke();
				}
			};
	
			var alignmentOffset = function(dimension, blockSize) {
				switch (opts.align) {
				case 'start':
					return labelOpts.padding;
				case 'end':
					return dimension - blockSize;
				default: // center
					return (dimension - blockSize + labelOpts.padding) / 2;
				}
			};
	
			// Horizontal
			var isHorizontal = me.isHorizontal();
			if (isHorizontal) {
				cursor = {
					x: me.left + alignmentOffset(legendWidth, lineWidths[0]),
					y: me.top + labelOpts.padding,
					line: 0
				};
			} else {
				cursor = {
					x: me.left + labelOpts.padding,
					y: me.top + alignmentOffset(legendHeight, columnHeights[0]),
					line: 0
				};
			}
	
			helpers$1.rtl.overrideTextDirection(me.ctx, opts.textDirection);
	
			var itemHeight = fontSize + labelOpts.padding;
			helpers$1.each(me.legendItems, function(legendItem, i) {
				var textWidth = ctx.measureText(legendItem.text).width;
				var width = boxWidth + (fontSize / 2) + textWidth;
				var x = cursor.x;
				var y = cursor.y;
	
				rtlHelper.setWidth(me.minSize.width);
	
				// Use (me.left + me.minSize.width) and (me.top + me.minSize.height)
				// instead of me.right and me.bottom because me.width and me.height
				// may have been changed since me.minSize was calculated
				if (isHorizontal) {
					if (i > 0 && x + width + labelOpts.padding > me.left + me.minSize.width) {
						y = cursor.y += itemHeight;
						cursor.line++;
						x = cursor.x = me.left + alignmentOffset(legendWidth, lineWidths[cursor.line]);
					}
				} else if (i > 0 && y + itemHeight > me.top + me.minSize.height) {
					x = cursor.x = x + me.columnWidths[cursor.line] + labelOpts.padding;
					cursor.line++;
					y = cursor.y = me.top + alignmentOffset(legendHeight, columnHeights[cursor.line]);
				}
	
				var realX = rtlHelper.x(x);
	
				drawLegendBox(realX, y, legendItem);
	
				hitboxes[i].left = rtlHelper.leftForLtr(realX, hitboxes[i].width);
				hitboxes[i].top = y;
	
				// Fill the actual label
				fillText(realX, y, legendItem, textWidth);
	
				if (isHorizontal) {
					cursor.x += width + labelOpts.padding;
				} else {
					cursor.y += itemHeight;
				}
			});
	
			helpers$1.rtl.restoreTextDirection(me.ctx, opts.textDirection);
		},
	
		/**
		 * @private
		 */
		_getLegendItemAt: function(x, y) {
			var me = this;
			var i, hitBox, lh;
	
			if (x >= me.left && x <= me.right && y >= me.top && y <= me.bottom) {
				// See if we are touching one of the dataset boxes
				lh = me.legendHitBoxes;
				for (i = 0; i < lh.length; ++i) {
					hitBox = lh[i];
	
					if (x >= hitBox.left && x <= hitBox.left + hitBox.width && y >= hitBox.top && y <= hitBox.top + hitBox.height) {
						// Touching an element
						return me.legendItems[i];
					}
				}
			}
	
			return null;
		},
	
		/**
		 * Handle an event
		 * @private
		 * @param {IEvent} event - The event to handle
		 */
		handleEvent: function(e) {
			var me = this;
			var opts = me.options;
			var type = e.type === 'mouseup' ? 'click' : e.type;
			var hoveredItem;
	
			if (type === 'mousemove') {
				if (!opts.onHover && !opts.onLeave) {
					return;
				}
			} else if (type === 'click') {
				if (!opts.onClick) {
					return;
				}
			} else {
				return;
			}
	
			// Chart event already has relative position in it
			hoveredItem = me._getLegendItemAt(e.x, e.y);
	
			if (type === 'click') {
				if (hoveredItem && opts.onClick) {
					// use e.native for backwards compatibility
					opts.onClick.call(me, e.native, hoveredItem);
				}
			} else {
				if (opts.onLeave && hoveredItem !== me._hoveredItem) {
					if (me._hoveredItem) {
						opts.onLeave.call(me, e.native, me._hoveredItem);
					}
					me._hoveredItem = hoveredItem;
				}
	
				if (opts.onHover && hoveredItem) {
					// use e.native for backwards compatibility
					opts.onHover.call(me, e.native, hoveredItem);
				}
			}
		}
	});
	
	function createNewLegendAndAttach(chart, legendOpts) {
		var legend = new Legend({
			ctx: chart.ctx,
			options: legendOpts,
			chart: chart
		});
	
		core_layouts.configure(chart, legend, legendOpts);
		core_layouts.addBox(chart, legend);
		chart.legend = legend;
	}
	
	var plugin_legend = {
		id: 'legend',
	
		/**
		 * Backward compatibility: since 2.1.5, the legend is registered as a plugin, making
		 * Chart.Legend obsolete. To avoid a breaking change, we export the Legend as part of
		 * the plugin, which one will be re-exposed in the chart.js file.
		 * https://github.com/chartjs/Chart.js/pull/2640
		 * @private
		 */
		_element: Legend,
	
		beforeInit: function(chart) {
			var legendOpts = chart.options.legend;
	
			if (legendOpts) {
				createNewLegendAndAttach(chart, legendOpts);
			}
		},
	
		beforeUpdate: function(chart) {
			var legendOpts = chart.options.legend;
			var legend = chart.legend;
	
			if (legendOpts) {
				helpers$1.mergeIf(legendOpts, core_defaults.global.legend);
	
				if (legend) {
					core_layouts.configure(chart, legend, legendOpts);
					legend.options = legendOpts;
				} else {
					createNewLegendAndAttach(chart, legendOpts);
				}
			} else if (legend) {
				core_layouts.removeBox(chart, legend);
				delete chart.legend;
			}
		},
	
		afterEvent: function(chart, e) {
			var legend = chart.legend;
			if (legend) {
				legend.handleEvent(e);
			}
		}
	};
	
	var noop$2 = helpers$1.noop;
	
	core_defaults._set('global', {
		title: {
			display: false,
			fontStyle: 'bold',
			fullWidth: true,
			padding: 10,
			position: 'top',
			text: '',
			weight: 2000         // by default greater than legend (1000) to be above
		}
	});
	
	/**
	 * IMPORTANT: this class is exposed publicly as Chart.Legend, backward compatibility required!
	 */
	var Title = core_element.extend({
		initialize: function(config) {
			var me = this;
			helpers$1.extend(me, config);
	
			// Contains hit boxes for each dataset (in dataset order)
			me.legendHitBoxes = [];
		},
	
		// These methods are ordered by lifecycle. Utilities then follow.
	
		beforeUpdate: noop$2,
		update: function(maxWidth, maxHeight, margins) {
			var me = this;
	
			// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
			me.beforeUpdate();
	
			// Absorb the master measurements
			me.maxWidth = maxWidth;
			me.maxHeight = maxHeight;
			me.margins = margins;
	
			// Dimensions
			me.beforeSetDimensions();
			me.setDimensions();
			me.afterSetDimensions();
			// Labels
			me.beforeBuildLabels();
			me.buildLabels();
			me.afterBuildLabels();
	
			// Fit
			me.beforeFit();
			me.fit();
			me.afterFit();
			//
			me.afterUpdate();
	
			return me.minSize;
	
		},
		afterUpdate: noop$2,
	
		//
	
		beforeSetDimensions: noop$2,
		setDimensions: function() {
			var me = this;
			// Set the unconstrained dimension before label rotation
			if (me.isHorizontal()) {
				// Reset position before calculating rotation
				me.width = me.maxWidth;
				me.left = 0;
				me.right = me.width;
			} else {
				me.height = me.maxHeight;
	
				// Reset position before calculating rotation
				me.top = 0;
				me.bottom = me.height;
			}
	
			// Reset padding
			me.paddingLeft = 0;
			me.paddingTop = 0;
			me.paddingRight = 0;
			me.paddingBottom = 0;
	
			// Reset minSize
			me.minSize = {
				width: 0,
				height: 0
			};
		},
		afterSetDimensions: noop$2,
	
		//
	
		beforeBuildLabels: noop$2,
		buildLabels: noop$2,
		afterBuildLabels: noop$2,
	
		//
	
		beforeFit: noop$2,
		fit: function() {
			var me = this;
			var opts = me.options;
			var minSize = me.minSize = {};
			var isHorizontal = me.isHorizontal();
			var lineCount, textSize;
	
			if (!opts.display) {
				me.width = minSize.width = me.height = minSize.height = 0;
				return;
			}
	
			lineCount = helpers$1.isArray(opts.text) ? opts.text.length : 1;
			textSize = lineCount * helpers$1.options._parseFont(opts).lineHeight + opts.padding * 2;
	
			me.width = minSize.width = isHorizontal ? me.maxWidth : textSize;
			me.height = minSize.height = isHorizontal ? textSize : me.maxHeight;
		},
		afterFit: noop$2,
	
		// Shared Methods
		isHorizontal: function() {
			var pos = this.options.position;
			return pos === 'top' || pos === 'bottom';
		},
	
		// Actually draw the title block on the canvas
		draw: function() {
			var me = this;
			var ctx = me.ctx;
			var opts = me.options;
	
			if (!opts.display) {
				return;
			}
	
			var fontOpts = helpers$1.options._parseFont(opts);
			var lineHeight = fontOpts.lineHeight;
			var offset = lineHeight / 2 + opts.padding;
			var rotation = 0;
			var top = me.top;
			var left = me.left;
			var bottom = me.bottom;
			var right = me.right;
			var maxWidth, titleX, titleY;
	
			ctx.fillStyle = helpers$1.valueOrDefault(opts.fontColor, core_defaults.global.defaultFontColor); // render in correct colour
			ctx.font = fontOpts.string;
	
			// Horizontal
			if (me.isHorizontal()) {
				titleX = left + ((right - left) / 2); // midpoint of the width
				titleY = top + offset;
				maxWidth = right - left;
			} else {
				titleX = opts.position === 'left' ? left + offset : right - offset;
				titleY = top + ((bottom - top) / 2);
				maxWidth = bottom - top;
				rotation = Math.PI * (opts.position === 'left' ? -0.5 : 0.5);
			}
	
			ctx.save();
			ctx.translate(titleX, titleY);
			ctx.rotate(rotation);
			ctx.textAlign = 'center';
			ctx.textBaseline = 'middle';
	
			var text = opts.text;
			if (helpers$1.isArray(text)) {
				var y = 0;
				for (var i = 0; i < text.length; ++i) {
					ctx.fillText(text[i], 0, y, maxWidth);
					y += lineHeight;
				}
			} else {
				ctx.fillText(text, 0, 0, maxWidth);
			}
	
			ctx.restore();
		}
	});
	
	function createNewTitleBlockAndAttach(chart, titleOpts) {
		var title = new Title({
			ctx: chart.ctx,
			options: titleOpts,
			chart: chart
		});
	
		core_layouts.configure(chart, title, titleOpts);
		core_layouts.addBox(chart, title);
		chart.titleBlock = title;
	}
	
	var plugin_title = {
		id: 'title',
	
		/**
		 * Backward compatibility: since 2.1.5, the title is registered as a plugin, making
		 * Chart.Title obsolete. To avoid a breaking change, we export the Title as part of
		 * the plugin, which one will be re-exposed in the chart.js file.
		 * https://github.com/chartjs/Chart.js/pull/2640
		 * @private
		 */
		_element: Title,
	
		beforeInit: function(chart) {
			var titleOpts = chart.options.title;
	
			if (titleOpts) {
				createNewTitleBlockAndAttach(chart, titleOpts);
			}
		},
	
		beforeUpdate: function(chart) {
			var titleOpts = chart.options.title;
			var titleBlock = chart.titleBlock;
	
			if (titleOpts) {
				helpers$1.mergeIf(titleOpts, core_defaults.global.title);
	
				if (titleBlock) {
					core_layouts.configure(chart, titleBlock, titleOpts);
					titleBlock.options = titleOpts;
				} else {
					createNewTitleBlockAndAttach(chart, titleOpts);
				}
			} else if (titleBlock) {
				core_layouts.removeBox(chart, titleBlock);
				delete chart.titleBlock;
			}
		}
	};
	
	var plugins = {};
	var filler = plugin_filler;
	var legend = plugin_legend;
	var title = plugin_title;
	plugins.filler = filler;
	plugins.legend = legend;
	plugins.title = title;
	
	/**
	 * @namespace Chart
	 */
	
	
	core_controller.helpers = helpers$1;
	
	// @todo dispatch these helpers into appropriated helpers/helpers.* file and write unit tests!
	core_helpers();
	
	core_controller._adapters = core_adapters;
	core_controller.Animation = core_animation;
	core_controller.animationService = core_animations;
	core_controller.controllers = controllers;
	core_controller.DatasetController = core_datasetController;
	core_controller.defaults = core_defaults;
	core_controller.Element = core_element;
	core_controller.elements = elements;
	core_controller.Interaction = core_interaction;
	core_controller.layouts = core_layouts;
	core_controller.platform = platform;
	core_controller.plugins = core_plugins;
	core_controller.Scale = core_scale;
	core_controller.scaleService = core_scaleService;
	core_controller.Ticks = core_ticks;
	core_controller.Tooltip = core_tooltip;
	
	// Register built-in scales
	
	core_controller.helpers.each(scales, function(scale, type) {
		core_controller.scaleService.registerScaleType(type, scale, scale._defaults);
	});
	
	// Load to register built-in adapters (as side effects)
	
	
	// Loading built-in plugins
	
	for (var k in plugins) {
		if (plugins.hasOwnProperty(k)) {
			core_controller.plugins.register(plugins[k]);
		}
	}
	
	core_controller.platform.initialize();
	
	var src = core_controller;
	if (typeof window !== 'undefined') {
		window.Chart = core_controller;
	}
	
	// DEPRECATIONS
	
	/**
	 * Provided for backward compatibility, not available anymore
	 * @namespace Chart.Chart
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 * @private
	 */
	core_controller.Chart = core_controller;
	
	/**
	 * Provided for backward compatibility, not available anymore
	 * @namespace Chart.Legend
	 * @deprecated since version 2.1.5
	 * @todo remove at version 3
	 * @private
	 */
	core_controller.Legend = plugins.legend._element;
	
	/**
	 * Provided for backward compatibility, not available anymore
	 * @namespace Chart.Title
	 * @deprecated since version 2.1.5
	 * @todo remove at version 3
	 * @private
	 */
	core_controller.Title = plugins.title._element;
	
	/**
	 * Provided for backward compatibility, use Chart.plugins instead
	 * @namespace Chart.pluginService
	 * @deprecated since version 2.1.5
	 * @todo remove at version 3
	 * @private
	 */
	core_controller.pluginService = core_controller.plugins;
	
	/**
	 * Provided for backward compatibility, inheriting from Chart.PlugingBase has no
	 * effect, instead simply create/register plugins via plain JavaScript objects.
	 * @interface Chart.PluginBase
	 * @deprecated since version 2.5.0
	 * @todo remove at version 3
	 * @private
	 */
	core_controller.PluginBase = core_controller.Element.extend({});
	
	/**
	 * Provided for backward compatibility, use Chart.helpers.canvas instead.
	 * @namespace Chart.canvasHelpers
	 * @deprecated since version 2.6.0
	 * @todo remove at version 3
	 * @private
	 */
	core_controller.canvasHelpers = core_controller.helpers.canvas;
	
	/**
	 * Provided for backward compatibility, use Chart.layouts instead.
	 * @namespace Chart.layoutService
	 * @deprecated since version 2.7.3
	 * @todo remove at version 3
	 * @private
	 */
	core_controller.layoutService = core_controller.layouts;
	
	/**
	 * Provided for backward compatibility, not available anymore.
	 * @namespace Chart.LinearScaleBase
	 * @deprecated since version 2.8
	 * @todo remove at version 3
	 * @private
	 */
	core_controller.LinearScaleBase = scale_linearbase;
	
	/**
	 * Provided for backward compatibility, instead we should create a new Chart
	 * by setting the type in the config (`new Chart(id, {type: '{chart-type}'}`).
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 */
	core_controller.helpers.each(
		[
			'Bar',
			'Bubble',
			'Doughnut',
			'Line',
			'PolarArea',
			'Radar',
			'Scatter'
		],
		function(klass) {
			core_controller[klass] = function(ctx, cfg) {
				return new core_controller(ctx, core_controller.helpers.merge(cfg || {}, {
					type: klass.charAt(0).toLowerCase() + klass.slice(1)
				}));
			};
		}
	);
	
	return src;
	
	})));


/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 */
	'use strict';
	
	var AtomicBlockUtils = __webpack_require__(1181);
	
	var BlockMapBuilder = __webpack_require__(151);
	
	var CharacterMetadata = __webpack_require__(70);
	
	var CompositeDraftDecorator = __webpack_require__(1183);
	
	var ContentBlock = __webpack_require__(104);
	
	var ContentState = __webpack_require__(262);
	
	var DefaultDraftBlockRenderMap = __webpack_require__(263);
	
	var DefaultDraftInlineStyle = __webpack_require__(391);
	
	var DraftEditor = __webpack_require__(1186);
	
	var DraftEditorBlock = __webpack_require__(392);
	
	var DraftEntity = __webpack_require__(190);
	
	var DraftModifier = __webpack_require__(59);
	
	var DraftEntityInstance = __webpack_require__(395);
	
	var EditorState = __webpack_require__(36);
	
	var KeyBindingUtil = __webpack_require__(264);
	
	var RawDraftContentState = __webpack_require__(1204);
	
	var RichTextEditorUtil = __webpack_require__(399);
	
	var SelectionState = __webpack_require__(191);
	
	var convertFromDraftStateToRaw = __webpack_require__(1209);
	
	var convertFromRawToDraftState = __webpack_require__(1210);
	
	var generateRandomKey = __webpack_require__(85);
	
	var getDefaultKeyBinding = __webpack_require__(404);
	
	var getVisibleSelectionRect = __webpack_require__(1231);
	
	var convertFromHTML = __webpack_require__(400);
	
	var DraftPublic = {
	  Editor: DraftEditor,
	  EditorBlock: DraftEditorBlock,
	  EditorState: EditorState,
	  CompositeDecorator: CompositeDraftDecorator,
	  Entity: DraftEntity,
	  EntityInstance: DraftEntityInstance,
	  BlockMapBuilder: BlockMapBuilder,
	  CharacterMetadata: CharacterMetadata,
	  ContentBlock: ContentBlock,
	  ContentState: ContentState,
	  RawDraftContentState: RawDraftContentState,
	  SelectionState: SelectionState,
	  AtomicBlockUtils: AtomicBlockUtils,
	  KeyBindingUtil: KeyBindingUtil,
	  Modifier: DraftModifier,
	  RichUtils: RichTextEditorUtil,
	  DefaultDraftBlockRenderMap: DefaultDraftBlockRenderMap,
	  DefaultDraftInlineStyle: DefaultDraftInlineStyle,
	  convertFromHTML: convertFromHTML,
	  convertFromRaw: convertFromRawToDraftState,
	  convertToRaw: convertFromDraftStateToRaw,
	  genKey: generateRandomKey,
	  getDefaultKeyBinding: getDefaultKeyBinding,
	  getVisibleSelectionRect: getVisibleSelectionRect
	};
	module.exports = DraftPublic;

/***/ },
/* 85 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	var seenKeys = {};
	var MULTIPLIER = Math.pow(2, 24);
	
	function generateRandomKey() {
	  var key;
	
	  while (key === undefined || seenKeys.hasOwnProperty(key) || !isNaN(+key)) {
	    key = Math.floor(Math.random() * MULTIPLIER).toString(32);
	  }
	
	  seenKeys[key] = true;
	  return key;
	}
	
	module.exports = generateRandomKey;

/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	module.exports = __webpack_require__(1368)["default"];

/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.formatTime = formatTime;
	exports.isVideoChild = isVideoChild;
	exports.mergeAndSortChildren = mergeAndSortChildren;
	exports.deprecatedWarning = deprecatedWarning;
	exports.throttle = throttle;
	exports.mediaProperties = void 0;
	
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(103));
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(47));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(25));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	// NaN is the only value in javascript which is not equal to itself.
	// eslint-disable-next-line no-self-compare
	var isNaN = Number.isNaN || function (value) {
	  return value !== value;
	};
	/**
	 * @file format-time.js
	 *
	 * Format seconds as a time string, H:MM:SS or M:SS
	 * Supplying a guide (in seconds) will force a number of leading zeros
	 * to cover the length of the guide
	 *
	 * @param  {Number} seconds Number of seconds to be turned into a string
	 * @param  {Number} guide   Number (in seconds) to model the string after
	 * @return {String}         Time formatted as H:MM:SS or M:SS
	 * @private
	 * @function formatTime
	 */
	
	
	function formatTime() {
	  var seconds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	  var guide = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : seconds;
	  var s = Math.floor(seconds % 60);
	  var m = Math.floor(seconds / 60 % 60);
	  var h = Math.floor(seconds / 3600);
	  var gm = Math.floor(guide / 60 % 60);
	  var gh = Math.floor(guide / 3600); // handle invalid times
	
	  if (isNaN(seconds) || seconds === Infinity) {
	    // '-' is false for all relational operators (e.g. <, >=) so this setting
	    // will add the minimum number of fields specified by the guide
	    h = '-';
	    m = '-';
	    s = '-';
	  } // Check if we need to show hours
	
	
	  h = h > 0 || gh > 0 ? "".concat(h, ":") : ''; // If hours are showing, we may need to add a leading zero.
	  // Always show at least one digit of minutes.
	
	  m = "".concat((h || gm >= 10) && m < 10 ? "0".concat(m) : m, ":"); // Check if leading zero is need for seconds
	
	  s = s < 10 ? "0".concat(s) : s;
	  return h + m + s;
	} // Check if the element belongs to a video element
	// only accept <source />, <track />,
	// <MyComponent isVideoChild />
	// elements
	
	
	function isVideoChild(c) {
	  if (c.props && c.props.isVideoChild) {
	    return true;
	  }
	
	  return c.type === 'source' || c.type === 'track';
	}
	
	var find = function find(elements, func) {
	  return elements.filter(func)[0];
	}; // check if two components are the same type
	
	
	var isTypeEqual = function isTypeEqual(component1, component2) {
	  var type1 = component1.type;
	  var type2 = component2.type;
	
	  if (typeof type1 === 'string' || typeof type2 === 'string') {
	    return type1 === type2;
	  }
	
	  if (typeof type1 === 'function' && typeof type2 === 'function') {
	    return type1.displayName === type2.displayName;
	  }
	
	  return false;
	}; // merge default children
	// sort them by `order` property
	// filter them by `disabled` property
	
	
	function mergeAndSortChildren(defaultChildren, _children, _parentProps) {
	  var defaultOrder = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
	
	  var children = _react["default"].Children.toArray(_children);
	
	  var order = _parentProps.order,
	      parentProps = (0, _objectWithoutProperties2["default"])(_parentProps, ["order"]); // ignore order from parent
	
	  return children.filter(function (e) {
	    return !e.props.disabled;
	  }) // filter the disabled components
	  .concat(defaultChildren.filter(function (c) {
	    return !find(children, function (component) {
	      return isTypeEqual(component, c);
	    });
	  })).map(function (element) {
	    var defaultComponent = find(defaultChildren, function (c) {
	      return isTypeEqual(c, element);
	    });
	    var defaultProps = defaultComponent ? defaultComponent.props : {};
	    var props = (0, _objectSpread2["default"])({}, parentProps, defaultProps, element.props);
	
	    var e = _react["default"].cloneElement(element, props, element.props.children);
	
	    return e;
	  }).sort(function (a, b) {
	    return (a.props.order || defaultOrder) - (b.props.order || defaultOrder);
	  });
	}
	/**
	 * Temporary utility for generating the warnings
	 */
	
	
	function deprecatedWarning(oldMethodCall, newMethodCall) {
	  // eslint-disable-next-line no-console
	  console.warn("WARNING: ".concat(oldMethodCall, " will be deprecated soon! Please use ").concat(newMethodCall, " instead."));
	}
	
	function throttle(callback, limit) {
	  var _arguments = arguments;
	  var wait = false;
	  return function () {
	    if (!wait) {
	      // eslint-disable-next-line prefer-rest-params
	      callback.apply(void 0, (0, _toConsumableArray2["default"])(_arguments));
	      wait = true;
	      setTimeout(function () {
	        wait = false;
	      }, limit);
	    }
	  };
	}
	
	var mediaProperties = ['error', 'src', 'srcObject', 'currentSrc', 'crossOrigin', 'networkState', 'preload', 'buffered', 'readyState', 'seeking', 'currentTime', 'duration', 'paused', 'defaultPlaybackRate', 'playbackRate', 'played', 'seekable', 'ended', 'autoplay', 'loop', 'mediaGroup', 'controller', 'controls', 'volume', 'muted', 'defaultMuted', 'audioTracks', 'videoTracks', 'textTracks', 'width', 'height', 'videoWidth', 'videoHeight', 'poster'];
	exports.mediaProperties = mediaProperties;

/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _merge = _interopRequireDefault(__webpack_require__(182));
	
	function compose() {
	  for (var _len = arguments.length, styles = new Array(_len), _key = 0; _key < _len; _key++) {
	    styles[_key] = arguments[_key];
	  }
	
	  var fn = function fn(props) {
	    return styles.reduce(function (acc, style) {
	      var output = style(props);
	
	      if (output) {
	        return (0, _merge.default)(acc, output);
	      }
	
	      return acc;
	    }, {});
	  }; // Alternative approach that doesn't yield any performance gain.
	  // const handlers = styles.reduce((acc, style) => {
	  //   style.filterProps.forEach(prop => {
	  //     acc[prop] = style;
	  //   });
	  //   return acc;
	  // }, {});
	  // const fn = props => {
	  //   return Object.keys(props).reduce((acc, prop) => {
	  //     if (handlers[prop]) {
	  //       return merge(acc, handlers[prop](props));
	  //     }
	  //     return acc;
	  //   }, {});
	  // };
	
	
	  fn.propTypes =  false ? styles.reduce(function (acc, style) {
	    return (0, _extends2.default)(acc, style.propTypes);
	  }, {}) : {};
	  fn.filterProps = styles.reduce(function (acc, style) {
	    return acc.concat(style.filterProps);
	  }, []);
	  return fn;
	}
	
	var _default = compose;
	exports.default = _default;

/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _kendoReactPdf = __webpack_require__(244);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DocService = function DocService() {
	  _classCallCheck(this, DocService);
	
	  this.createPdf = function (html) {
	
	    (0, _kendoReactPdf.savePDF)(html, {
	      paperSize: 'A2',
	      fileName: 'benchmark.pdf',
	      margin: 30,
	      fontSize: 12
	    });
	  };
	};
	
	var Doc = new DocService();
	exports.default = Doc;

/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  var bodyRef = _react2.default.createRef();
	  var createPdf = function createPdf() {
	    return props.createPdf(bodyRef.current);
	  };
	  return _react2.default.createElement(
	    "section",
	    { className: "pdf-container" },
	    _react2.default.createElement(
	      "section",
	      { className: "pdf-toolbar", style: { 'float': 'right' } },
	      _react2.default.createElement(
	        "button",
	        { onClick: createPdf, className: "btn btn-green dropdown-toggle btn-arrow" },
	        "Download as PDF"
	      )
	    ),
	    _react2.default.createElement(
	      "section",
	      { className: "pdf-body", ref: bodyRef },
	      props.children
	    )
	  );
	};

/***/ },
/* 91 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	var KEY_DELIMITER = '-';
	var DraftOffsetKey = {
	  encode: function encode(blockKey, decoratorKey, leafKey) {
	    return blockKey + KEY_DELIMITER + decoratorKey + KEY_DELIMITER + leafKey;
	  },
	  decode: function decode(offsetKey) {
	    // Extracts the last two parts of offsetKey and captures the rest in blockKeyParts
	    var _offsetKey$split$reve = offsetKey.split(KEY_DELIMITER).reverse(),
	        leafKey = _offsetKey$split$reve[0],
	        decoratorKey = _offsetKey$split$reve[1],
	        blockKeyParts = _offsetKey$split$reve.slice(2);
	
	    return {
	      // Recomposes the parts of blockKey after reversing them
	      blockKey: blockKeyParts.reverse().join(KEY_DELIMITER),
	      decoratorKey: parseInt(decoratorKey, 10),
	      leafKey: parseInt(leafKey, 10)
	    };
	  }
	};
	module.exports = DraftOffsetKey;

/***/ },
/* 92 */
18,
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _slider = _interopRequireDefault(__webpack_require__(1515));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _default = _slider["default"];
	exports["default"] = _default;

/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = deprecatedPropType;
	
	function deprecatedPropType(validator, reason) {
	  if (true) {
	    return function () {
	      return null;
	    };
	  }
	
	  return function (props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	
	    if (typeof props[propName] !== 'undefined') {
	      return new Error("The ".concat(location, " `").concat(propFullNameSafe, "` of ") + "`".concat(componentNameSafe, "` is deprecated. ").concat(reason));
	    }
	
	    return null;
	  };
	}

/***/ },
/* 95 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ownerDocument;
	
	function ownerDocument(node) {
	  return node && node.ownerDocument || document;
	}

/***/ },
/* 96 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getDefaultOptions = getDefaultOptions;
	exports.setDefaultOptions = setDefaultOptions;
	var defaultOptions = {};
	function getDefaultOptions() {
	  return defaultOptions;
	}
	function setDefaultOptions(newOptions) {
	  defaultOptions = newOptions;
	}

/***/ },
/* 97 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 */
	'use strict';
	
	module.exports = function (name) {
	  if (typeof window !== 'undefined' && window.__DRAFT_GKX) {
	    return !!window.__DRAFT_GKX[name];
	  }
	
	  return false;
	};

/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {"use strict";
	
	exports.base64 = true;
	exports.array = true;
	exports.string = true;
	exports.arraybuffer = typeof ArrayBuffer !== "undefined" && typeof Uint8Array !== "undefined";
	exports.nodebuffer = typeof Buffer !== "undefined";
	// contains true if JSZip can read/generate Uint8Array, false otherwise.
	exports.uint8array = typeof Uint8Array !== "undefined";
	
	if (typeof ArrayBuffer === "undefined") {
	    exports.blob = false;
	}
	else {
	    var buffer = new ArrayBuffer(0);
	    try {
	        exports.blob = new Blob([buffer], {
	            type: "application/zip"
	        }).size === 0;
	    }
	    catch (e) {
	        try {
	            var Builder = self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder;
	            var builder = new Builder();
	            builder.append(buffer);
	            exports.blob = builder.getBlob("application/zip").size === 0;
	        }
	        catch (e) {
	            exports.blob = false;
	        }
	    }
	}
	
	try {
	    exports.nodestream = !!__webpack_require__(443).Readable;
	} catch(e) {
	    exports.nodestream = false;
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(146).Buffer))

/***/ },
/* 99 */
/***/ function(module, exports) {

	'use strict';
	
	
	var TYPED_OK =  (typeof Uint8Array !== 'undefined') &&
	                (typeof Uint16Array !== 'undefined') &&
	                (typeof Int32Array !== 'undefined');
	
	function _has(obj, key) {
	  return Object.prototype.hasOwnProperty.call(obj, key);
	}
	
	exports.assign = function (obj /*from1, from2, from3, ...*/) {
	  var sources = Array.prototype.slice.call(arguments, 1);
	  while (sources.length) {
	    var source = sources.shift();
	    if (!source) { continue; }
	
	    if (typeof source !== 'object') {
	      throw new TypeError(source + 'must be non-object');
	    }
	
	    for (var p in source) {
	      if (_has(source, p)) {
	        obj[p] = source[p];
	      }
	    }
	  }
	
	  return obj;
	};
	
	
	// reduce buffer size, avoiding mem copy
	exports.shrinkBuf = function (buf, size) {
	  if (buf.length === size) { return buf; }
	  if (buf.subarray) { return buf.subarray(0, size); }
	  buf.length = size;
	  return buf;
	};
	
	
	var fnTyped = {
	  arraySet: function (dest, src, src_offs, len, dest_offs) {
	    if (src.subarray && dest.subarray) {
	      dest.set(src.subarray(src_offs, src_offs + len), dest_offs);
	      return;
	    }
	    // Fallback to ordinary array
	    for (var i = 0; i < len; i++) {
	      dest[dest_offs + i] = src[src_offs + i];
	    }
	  },
	  // Join array of chunks to single array.
	  flattenChunks: function (chunks) {
	    var i, l, len, pos, chunk, result;
	
	    // calculate data length
	    len = 0;
	    for (i = 0, l = chunks.length; i < l; i++) {
	      len += chunks[i].length;
	    }
	
	    // join chunks
	    result = new Uint8Array(len);
	    pos = 0;
	    for (i = 0, l = chunks.length; i < l; i++) {
	      chunk = chunks[i];
	      result.set(chunk, pos);
	      pos += chunk.length;
	    }
	
	    return result;
	  }
	};
	
	var fnUntyped = {
	  arraySet: function (dest, src, src_offs, len, dest_offs) {
	    for (var i = 0; i < len; i++) {
	      dest[dest_offs + i] = src[src_offs + i];
	    }
	  },
	  // Join array of chunks to single array.
	  flattenChunks: function (chunks) {
	    return [].concat.apply([], chunks);
	  }
	};
	
	
	// Enable/Disable typed arrays use, for testing
	//
	exports.setTyped = function (on) {
	  if (on) {
	    exports.Buf8  = Uint8Array;
	    exports.Buf16 = Uint16Array;
	    exports.Buf32 = Int32Array;
	    exports.assign(exports, fnTyped);
	  } else {
	    exports.Buf8  = Array;
	    exports.Buf16 = Array;
	    exports.Buf32 = Array;
	    exports.assign(exports, fnUntyped);
	  }
	};
	
	exports.setTyped(TYPED_OK);


/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var NATIVE_BIND = __webpack_require__(205);
	
	var call = Function.prototype.call;
	// eslint-disable-next-line es/no-function-prototype-bind -- safe
	module.exports = NATIVE_BIND ? call.bind(call) : function () {
	  return call.apply(call, arguments);
	};


/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var classof = __webpack_require__(280);
	
	var $String = String;
	
	module.exports = function (argument) {
	  if (classof(argument) === 'Symbol') throw new TypeError('Cannot convert a Symbol value to a string');
	  return $String(argument);
	};


/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _utils = __webpack_require__(11);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  wrapTag: _utils.tagPropType,
	  toggle: _propTypes.default.func,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  children: _propTypes.default.node,
	  closeAriaLabel: _propTypes.default.string,
	  charCode: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  close: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'h5',
	  wrapTag: 'div',
	  closeAriaLabel: 'Close',
	  charCode: 215
	};
	
	var ModalHeader = function ModalHeader(props) {
	  var closeButton;
	  var className = props.className,
	      cssModule = props.cssModule,
	      children = props.children,
	      toggle = props.toggle,
	      Tag = props.tag,
	      WrapTag = props.wrapTag,
	      closeAriaLabel = props.closeAriaLabel,
	      charCode = props.charCode,
	      close = props.close,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "children", "toggle", "tag", "wrapTag", "closeAriaLabel", "charCode", "close"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'modal-header'), cssModule);
	
	  if (!close && toggle) {
	    var closeIcon = typeof charCode === 'number' ? String.fromCharCode(charCode) : charCode;
	    closeButton = _react.default.createElement("button", {
	      type: "button",
	      onClick: toggle,
	      className: (0, _utils.mapToCssModules)('close', cssModule),
	      "aria-label": closeAriaLabel
	    }, _react.default.createElement("span", {
	      "aria-hidden": "true"
	    }, closeIcon));
	  }
	
	  return _react.default.createElement(WrapTag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }), _react.default.createElement(Tag, {
	    className: (0, _utils.mapToCssModules)('modal-title', cssModule)
	  }, children), close || closeButton);
	};
	
	ModalHeader.propTypes = propTypes;
	ModalHeader.defaultProps = defaultProps;
	var _default = ModalHeader;
	exports.default = _default;

/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	var arrayWithoutHoles = __webpack_require__(694);
	var iterableToArray = __webpack_require__(697);
	var unsupportedIterableToArray = __webpack_require__(229);
	var nonIterableSpread = __webpack_require__(700);
	function _toConsumableArray(r) {
	  return arrayWithoutHoles(r) || iterableToArray(r) || unsupportedIterableToArray(r) || nonIterableSpread();
	}
	module.exports = _toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	var CharacterMetadata = __webpack_require__(70);
	
	var findRangesImmutable = __webpack_require__(152);
	
	var Immutable = __webpack_require__(27);
	
	var List = Immutable.List,
	    Map = Immutable.Map,
	    OrderedSet = Immutable.OrderedSet,
	    Record = Immutable.Record,
	    Repeat = Immutable.Repeat;
	var EMPTY_SET = OrderedSet();
	var defaultRecord = {
	  key: '',
	  type: 'unstyled',
	  text: '',
	  characterList: List(),
	  depth: 0,
	  data: Map()
	};
	var ContentBlockRecord = Record(defaultRecord);
	
	var decorateCharacterList = function decorateCharacterList(config) {
	  if (!config) {
	    return config;
	  }
	
	  var characterList = config.characterList,
	      text = config.text;
	
	  if (text && !characterList) {
	    config.characterList = List(Repeat(CharacterMetadata.EMPTY, text.length));
	  }
	
	  return config;
	};
	
	var ContentBlock = /*#__PURE__*/function (_ContentBlockRecord) {
	  _inheritsLoose(ContentBlock, _ContentBlockRecord);
	
	  function ContentBlock(config) {
	    return _ContentBlockRecord.call(this, decorateCharacterList(config)) || this;
	  }
	
	  var _proto = ContentBlock.prototype;
	
	  _proto.getKey = function getKey() {
	    return this.get('key');
	  };
	
	  _proto.getType = function getType() {
	    return this.get('type');
	  };
	
	  _proto.getText = function getText() {
	    return this.get('text');
	  };
	
	  _proto.getCharacterList = function getCharacterList() {
	    return this.get('characterList');
	  };
	
	  _proto.getLength = function getLength() {
	    return this.getText().length;
	  };
	
	  _proto.getDepth = function getDepth() {
	    return this.get('depth');
	  };
	
	  _proto.getData = function getData() {
	    return this.get('data');
	  };
	
	  _proto.getInlineStyleAt = function getInlineStyleAt(offset) {
	    var character = this.getCharacterList().get(offset);
	    return character ? character.getStyle() : EMPTY_SET;
	  };
	
	  _proto.getEntityAt = function getEntityAt(offset) {
	    var character = this.getCharacterList().get(offset);
	    return character ? character.getEntity() : null;
	  }
	  /**
	   * Execute a callback for every contiguous range of styles within the block.
	   */
	  ;
	
	  _proto.findStyleRanges = function findStyleRanges(filterFn, callback) {
	    findRangesImmutable(this.getCharacterList(), haveEqualStyle, filterFn, callback);
	  }
	  /**
	   * Execute a callback for every contiguous range of entities within the block.
	   */
	  ;
	
	  _proto.findEntityRanges = function findEntityRanges(filterFn, callback) {
	    findRangesImmutable(this.getCharacterList(), haveEqualEntity, filterFn, callback);
	  };
	
	  return ContentBlock;
	}(ContentBlockRecord);
	
	function haveEqualStyle(charA, charB) {
	  return charA.getStyle() === charB.getStyle();
	}
	
	function haveEqualEntity(charA, charB) {
	  return charA.getEntity() === charB.getEntity();
	}
	
	module.exports = ContentBlock;

/***/ },
/* 105 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	function isElement(node) {
	  if (!node || !node.ownerDocument) {
	    return false;
	  }
	
	  return node.nodeType === Node.ELEMENT_NODE;
	}
	
	module.exports = isElement;

/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	(function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define(factory) :
	  (global = global || self, global.draftjsToHtml = factory());
	}(this, (function () { 'use strict';
	
	  /**
	  * Utility function to execute callback for eack key->value pair.
	  */
	  function forEach(obj, callback) {
	    if (obj) {
	      for (var key in obj) {
	        // eslint-disable-line no-restricted-syntax
	        if ({}.hasOwnProperty.call(obj, key)) {
	          callback(key, obj[key]);
	        }
	      }
	    }
	  }
	  /**
	  * The function returns true if the string passed to it has no content.
	  */
	
	  function isEmptyString(str) {
	    if (str === undefined || str === null || str.length === 0 || str.trim().length === 0) {
	      return true;
	    }
	
	    return false;
	  }
	
	  /**
	  * Mapping block-type to corresponding html tag.
	  */
	
	  var blockTypesMapping = {
	    unstyled: 'p',
	    'header-one': 'h1',
	    'header-two': 'h2',
	    'header-three': 'h3',
	    'header-four': 'h4',
	    'header-five': 'h5',
	    'header-six': 'h6',
	    'unordered-list-item': 'ul',
	    'ordered-list-item': 'ol',
	    blockquote: 'blockquote',
	    code: 'pre'
	  };
	  /**
	  * Function will return HTML tag for a block.
	  */
	
	  function getBlockTag(type) {
	    return type && blockTypesMapping[type];
	  }
	  /**
	  * Function will return style string for a block.
	  */
	
	  function getBlockStyle(data) {
	    var styles = '';
	    forEach(data, function (key, value) {
	      if (value) {
	        styles += "".concat(key, ":").concat(value, ";");
	      }
	    });
	    return styles;
	  }
	  /**
	  * The function returns an array of hashtag-sections in blocks.
	  * These will be areas in block which have hashtags applicable to them.
	  */
	
	  function getHashtagRanges(blockText, hashtagConfig) {
	    var sections = [];
	
	    if (hashtagConfig) {
	      var counter = 0;
	      var startIndex = 0;
	      var text = blockText;
	      var trigger = hashtagConfig.trigger || '#';
	      var separator = hashtagConfig.separator || ' ';
	
	      for (; text.length > 0 && startIndex >= 0;) {
	        if (text[0] === trigger) {
	          startIndex = 0;
	          counter = 0;
	          text = text.substr(trigger.length);
	        } else {
	          startIndex = text.indexOf(separator + trigger);
	
	          if (startIndex >= 0) {
	            text = text.substr(startIndex + (separator + trigger).length);
	            counter += startIndex + separator.length;
	          }
	        }
	
	        if (startIndex >= 0) {
	          var endIndex = text.indexOf(separator) >= 0 ? text.indexOf(separator) : text.length;
	          var hashtag = text.substr(0, endIndex);
	
	          if (hashtag && hashtag.length > 0) {
	            sections.push({
	              offset: counter,
	              length: hashtag.length + trigger.length,
	              type: 'HASHTAG'
	            });
	          }
	
	          counter += trigger.length;
	        }
	      }
	    }
	
	    return sections;
	  }
	  /**
	  * The function returns an array of entity-sections in blocks.
	  * These will be areas in block which have same entity or no entity applicable to them.
	  */
	
	
	  function getSections(block, hashtagConfig) {
	    var sections = [];
	    var lastOffset = 0;
	    var sectionRanges = block.entityRanges.map(function (range) {
	      var offset = range.offset,
	          length = range.length,
	          key = range.key;
	      return {
	        offset: offset,
	        length: length,
	        key: key,
	        type: 'ENTITY'
	      };
	    });
	    sectionRanges = sectionRanges.concat(getHashtagRanges(block.text, hashtagConfig));
	    sectionRanges = sectionRanges.sort(function (s1, s2) {
	      return s1.offset - s2.offset;
	    });
	    sectionRanges.forEach(function (r) {
	      if (r.offset > lastOffset) {
	        sections.push({
	          start: lastOffset,
	          end: r.offset
	        });
	      }
	
	      sections.push({
	        start: r.offset,
	        end: r.offset + r.length,
	        entityKey: r.key,
	        type: r.type
	      });
	      lastOffset = r.offset + r.length;
	    });
	
	    if (lastOffset < block.text.length) {
	      sections.push({
	        start: lastOffset,
	        end: block.text.length
	      });
	    }
	
	    return sections;
	  }
	  /**
	  * Function to check if the block is an atomic entity block.
	  */
	
	
	  function isAtomicEntityBlock(block) {
	    if (block.entityRanges.length > 0 && (isEmptyString(block.text) || block.type === 'atomic')) {
	      return true;
	    }
	
	    return false;
	  }
	  /**
	  * The function will return array of inline styles applicable to the block.
	  */
	
	
	  function getStyleArrayForBlock(block) {
	    var text = block.text,
	        inlineStyleRanges = block.inlineStyleRanges;
	    var inlineStyles = {
	      BOLD: new Array(text.length),
	      ITALIC: new Array(text.length),
	      UNDERLINE: new Array(text.length),
	      STRIKETHROUGH: new Array(text.length),
	      CODE: new Array(text.length),
	      SUPERSCRIPT: new Array(text.length),
	      SUBSCRIPT: new Array(text.length),
	      COLOR: new Array(text.length),
	      BGCOLOR: new Array(text.length),
	      FONTSIZE: new Array(text.length),
	      FONTFAMILY: new Array(text.length),
	      length: text.length
	    };
	
	    if (inlineStyleRanges && inlineStyleRanges.length > 0) {
	      inlineStyleRanges.forEach(function (range) {
	        var offset = range.offset;
	        var length = offset + range.length;
	
	        for (var i = offset; i < length; i += 1) {
	          if (range.style.indexOf('color-') === 0) {
	            inlineStyles.COLOR[i] = range.style.substring(6);
	          } else if (range.style.indexOf('bgcolor-') === 0) {
	            inlineStyles.BGCOLOR[i] = range.style.substring(8);
	          } else if (range.style.indexOf('fontsize-') === 0) {
	            inlineStyles.FONTSIZE[i] = range.style.substring(9);
	          } else if (range.style.indexOf('fontfamily-') === 0) {
	            inlineStyles.FONTFAMILY[i] = range.style.substring(11);
	          } else if (inlineStyles[range.style]) {
	            inlineStyles[range.style][i] = true;
	          }
	        }
	      });
	    }
	
	    return inlineStyles;
	  }
	  /**
	  * The function will return inline style applicable at some offset within a block.
	  */
	
	
	  function getStylesAtOffset(inlineStyles, offset) {
	    var styles = {};
	
	    if (inlineStyles.COLOR[offset]) {
	      styles.COLOR = inlineStyles.COLOR[offset];
	    }
	
	    if (inlineStyles.BGCOLOR[offset]) {
	      styles.BGCOLOR = inlineStyles.BGCOLOR[offset];
	    }
	
	    if (inlineStyles.FONTSIZE[offset]) {
	      styles.FONTSIZE = inlineStyles.FONTSIZE[offset];
	    }
	
	    if (inlineStyles.FONTFAMILY[offset]) {
	      styles.FONTFAMILY = inlineStyles.FONTFAMILY[offset];
	    }
	
	    if (inlineStyles.UNDERLINE[offset]) {
	      styles.UNDERLINE = true;
	    }
	
	    if (inlineStyles.ITALIC[offset]) {
	      styles.ITALIC = true;
	    }
	
	    if (inlineStyles.BOLD[offset]) {
	      styles.BOLD = true;
	    }
	
	    if (inlineStyles.STRIKETHROUGH[offset]) {
	      styles.STRIKETHROUGH = true;
	    }
	
	    if (inlineStyles.CODE[offset]) {
	      styles.CODE = true;
	    }
	
	    if (inlineStyles.SUBSCRIPT[offset]) {
	      styles.SUBSCRIPT = true;
	    }
	
	    if (inlineStyles.SUPERSCRIPT[offset]) {
	      styles.SUPERSCRIPT = true;
	    }
	
	    return styles;
	  }
	  /**
	  * Function returns true for a set of styles if the value of these styles at an offset
	  * are same as that on the previous offset.
	  */
	
	  function sameStyleAsPrevious(inlineStyles, styles, index) {
	    var sameStyled = true;
	
	    if (index > 0 && index < inlineStyles.length) {
	      styles.forEach(function (style) {
	        sameStyled = sameStyled && inlineStyles[style][index] === inlineStyles[style][index - 1];
	      });
	    } else {
	      sameStyled = false;
	    }
	
	    return sameStyled;
	  }
	  /**
	  * Function returns html for text depending on inline style tags applicable to it.
	  */
	
	  function addInlineStyleMarkup(style, content) {
	    if (style === 'BOLD') {
	      return "<strong>".concat(content, "</strong>");
	    }
	
	    if (style === 'ITALIC') {
	      return "<em>".concat(content, "</em>");
	    }
	
	    if (style === 'UNDERLINE') {
	      return "<ins>".concat(content, "</ins>");
	    }
	
	    if (style === 'STRIKETHROUGH') {
	      return "<del>".concat(content, "</del>");
	    }
	
	    if (style === 'CODE') {
	      return "<code>".concat(content, "</code>");
	    }
	
	    if (style === 'SUPERSCRIPT') {
	      return "<sup>".concat(content, "</sup>");
	    }
	
	    if (style === 'SUBSCRIPT') {
	      return "<sub>".concat(content, "</sub>");
	    }
	
	    return content;
	  }
	  /**
	  * The function returns text for given section of block after doing required character replacements.
	  */
	
	  function getSectionText(text) {
	    if (text && text.length > 0) {
	      var chars = text.map(function (ch) {
	        switch (ch) {
	          case '\n':
	            return '<br>';
	
	          case '&':
	            return '&amp;';
	
	          case '<':
	            return '&lt;';
	
	          case '>':
	            return '&gt;';
	
	          default:
	            return ch;
	        }
	      });
	      return chars.join('');
	    }
	
	    return '';
	  }
	  /**
	  * Function returns html for text depending on inline style tags applicable to it.
	  */
	
	
	  function addStylePropertyMarkup(styles, text) {
	    if (styles && (styles.COLOR || styles.BGCOLOR || styles.FONTSIZE || styles.FONTFAMILY)) {
	      var styleString = 'style="';
	
	      if (styles.COLOR) {
	        styleString += "color: ".concat(styles.COLOR, ";");
	      }
	
	      if (styles.BGCOLOR) {
	        styleString += "background-color: ".concat(styles.BGCOLOR, ";");
	      }
	
	      if (styles.FONTSIZE) {
	        styleString += "font-size: ".concat(styles.FONTSIZE).concat(/^\d+$/.test(styles.FONTSIZE) ? 'px' : '', ";");
	      }
	
	      if (styles.FONTFAMILY) {
	        styleString += "font-family: ".concat(styles.FONTFAMILY, ";");
	      }
	
	      styleString += '"';
	      return "<span ".concat(styleString, ">").concat(text, "</span>");
	    }
	
	    return text;
	  }
	  /**
	  * Function will return markup for Entity.
	  */
	
	  function getEntityMarkup(entityMap, entityKey, text, customEntityTransform) {
	    var entity = entityMap[entityKey];
	
	    if (typeof customEntityTransform === 'function') {
	      var html = customEntityTransform(entity, text);
	
	      if (html) {
	        return html;
	      }
	    }
	
	    if (entity.type === 'MENTION') {
	      return "<a href=\"".concat(entity.data.url, "\" class=\"wysiwyg-mention\" data-mention data-value=\"").concat(entity.data.value, "\">").concat(text, "</a>");
	    }
	
	    if (entity.type === 'LINK') {
	      var targetOption = entity.data.targetOption || '_self';
	      return "<a href=\"".concat(entity.data.url, "\" target=\"").concat(targetOption, "\">").concat(text, "</a>");
	    }
	
	    if (entity.type === 'IMAGE') {
	      var alignment = entity.data.alignment;
	
	      if (alignment && alignment.length) {
	        return "<div style=\"text-align:".concat(alignment, ";\"><img src=\"").concat(entity.data.src, "\" alt=\"").concat(entity.data.alt, "\" style=\"height: ").concat(entity.data.height, ";width: ").concat(entity.data.width, "\"/></div>");
	      }
	
	      return "<img src=\"".concat(entity.data.src, "\" alt=\"").concat(entity.data.alt, "\" style=\"height: ").concat(entity.data.height, ";width: ").concat(entity.data.width, "\"/>");
	    }
	
	    if (entity.type === 'EMBEDDED_LINK') {
	      return "<iframe width=\"".concat(entity.data.width, "\" height=\"").concat(entity.data.height, "\" src=\"").concat(entity.data.src, "\" frameBorder=\"0\"></iframe>");
	    }
	
	    return text;
	  }
	  /**
	  * For a given section in a block the function will return a further list of sections,
	  * with similar inline styles applicable to them.
	  */
	
	
	  function getInlineStyleSections(block, styles, start, end) {
	    var styleSections = [];
	    var text = Array.from(block.text);
	
	    if (text.length > 0) {
	      var inlineStyles = getStyleArrayForBlock(block);
	      var section;
	
	      for (var i = start; i < end; i += 1) {
	        if (i !== start && sameStyleAsPrevious(inlineStyles, styles, i)) {
	          section.text.push(text[i]);
	          section.end = i + 1;
	        } else {
	          section = {
	            styles: getStylesAtOffset(inlineStyles, i),
	            text: [text[i]],
	            start: i,
	            end: i + 1
	          };
	          styleSections.push(section);
	        }
	      }
	    }
	
	    return styleSections;
	  }
	  /**
	  * Replace leading blank spaces by &nbsp;
	  */
	
	
	  function trimLeadingZeros(sectionText) {
	    if (sectionText) {
	      var replacedText = sectionText;
	
	      for (var i = 0; i < replacedText.length; i += 1) {
	        if (sectionText[i] === ' ') {
	          replacedText = replacedText.replace(' ', '&nbsp;');
	        } else {
	          break;
	        }
	      }
	
	      return replacedText;
	    }
	
	    return sectionText;
	  }
	  /**
	  * Replace trailing blank spaces by &nbsp;
	  */
	
	  function trimTrailingZeros(sectionText) {
	    if (sectionText) {
	      var replacedText = sectionText;
	
	      for (var i = replacedText.length - 1; i >= 0; i -= 1) {
	        if (replacedText[i] === ' ') {
	          replacedText = "".concat(replacedText.substring(0, i), "&nbsp;").concat(replacedText.substring(i + 1));
	        } else {
	          break;
	        }
	      }
	
	      return replacedText;
	    }
	
	    return sectionText;
	  }
	  /**
	  * The method returns markup for section to which inline styles
	  * like BOLD, ITALIC, UNDERLINE, STRIKETHROUGH, CODE, SUPERSCRIPT, SUBSCRIPT are applicable.
	  */
	
	  function getStyleTagSectionMarkup(styleSection) {
	    var styles = styleSection.styles,
	        text = styleSection.text;
	    var content = getSectionText(text);
	    forEach(styles, function (style, value) {
	      content = addInlineStyleMarkup(style, content);
	    });
	    return content;
	  }
	  /**
	  * The method returns markup for section to which inline styles
	  like color, background-color, font-size are applicable.
	  */
	
	
	  function getInlineStyleSectionMarkup(block, styleSection) {
	    var styleTagSections = getInlineStyleSections(block, ['BOLD', 'ITALIC', 'UNDERLINE', 'STRIKETHROUGH', 'CODE', 'SUPERSCRIPT', 'SUBSCRIPT'], styleSection.start, styleSection.end);
	    var styleSectionText = '';
	    styleTagSections.forEach(function (stylePropertySection) {
	      styleSectionText += getStyleTagSectionMarkup(stylePropertySection);
	    });
	    styleSectionText = addStylePropertyMarkup(styleSection.styles, styleSectionText);
	    return styleSectionText;
	  }
	  /*
	  * The method returns markup for an entity section.
	  * An entity section is a continuous section in a block
	  * to which same entity or no entity is applicable.
	  */
	
	
	  function getSectionMarkup(block, entityMap, section, customEntityTransform) {
	    var entityInlineMarkup = [];
	    var inlineStyleSections = getInlineStyleSections(block, ['COLOR', 'BGCOLOR', 'FONTSIZE', 'FONTFAMILY'], section.start, section.end);
	    inlineStyleSections.forEach(function (styleSection) {
	      entityInlineMarkup.push(getInlineStyleSectionMarkup(block, styleSection));
	    });
	    var sectionText = entityInlineMarkup.join('');
	
	    if (section.type === 'ENTITY') {
	      if (section.entityKey !== undefined && section.entityKey !== null) {
	        sectionText = getEntityMarkup(entityMap, section.entityKey, sectionText, customEntityTransform); // eslint-disable-line max-len
	      }
	    } else if (section.type === 'HASHTAG') {
	      sectionText = "<a href=\"".concat(sectionText, "\" class=\"wysiwyg-hashtag\">").concat(sectionText, "</a>");
	    }
	
	    return sectionText;
	  }
	  /**
	  * Function will return the markup for block preserving the inline styles and
	  * special characters like newlines or blank spaces.
	  */
	
	
	  function getBlockInnerMarkup(block, entityMap, hashtagConfig, customEntityTransform) {
	    var blockMarkup = [];
	    var sections = getSections(block, hashtagConfig);
	    sections.forEach(function (section, index) {
	      var sectionText = getSectionMarkup(block, entityMap, section, customEntityTransform);
	
	      if (index === 0) {
	        sectionText = trimLeadingZeros(sectionText);
	      }
	
	      if (index === sections.length - 1) {
	        sectionText = trimTrailingZeros(sectionText);
	      }
	
	      blockMarkup.push(sectionText);
	    });
	    return blockMarkup.join('');
	  }
	  /**
	  * Function will return html for the block.
	  */
	
	  function getBlockMarkup(block, entityMap, hashtagConfig, directional, customEntityTransform) {
	    var blockHtml = [];
	
	    if (isAtomicEntityBlock(block)) {
	      blockHtml.push(getEntityMarkup(entityMap, block.entityRanges[0].key, undefined, customEntityTransform));
	    } else {
	      var blockTag = getBlockTag(block.type);
	
	      if (blockTag) {
	        blockHtml.push("<".concat(blockTag));
	        var blockStyle = getBlockStyle(block.data);
	
	        if (blockStyle) {
	          blockHtml.push(" style=\"".concat(blockStyle, "\""));
	        }
	
	        if (directional) {
	          blockHtml.push(' dir = "auto"');
	        }
	
	        blockHtml.push('>');
	        blockHtml.push(getBlockInnerMarkup(block, entityMap, hashtagConfig, customEntityTransform));
	        blockHtml.push("</".concat(blockTag, ">"));
	      }
	    }
	
	    blockHtml.push('\n');
	    return blockHtml.join('');
	  }
	
	  /**
	  * Function to check if a block is of type list.
	  */
	
	  function isList(blockType) {
	    return blockType === 'unordered-list-item' || blockType === 'ordered-list-item';
	  }
	  /**
	  * Function will return html markup for a list block.
	  */
	
	  function getListMarkup(listBlocks, entityMap, hashtagConfig, directional, customEntityTransform) {
	    var listHtml = [];
	    var nestedListBlock = [];
	    var previousBlock;
	    listBlocks.forEach(function (block) {
	      var nestedBlock = false;
	
	      if (!previousBlock) {
	        listHtml.push("<".concat(getBlockTag(block.type), ">\n"));
	      } else if (previousBlock.type !== block.type) {
	        listHtml.push("</".concat(getBlockTag(previousBlock.type), ">\n"));
	        listHtml.push("<".concat(getBlockTag(block.type), ">\n"));
	      } else if (previousBlock.depth === block.depth) {
	        if (nestedListBlock && nestedListBlock.length > 0) {
	          listHtml.push(getListMarkup(nestedListBlock, entityMap, hashtagConfig, directional, customEntityTransform));
	          nestedListBlock = [];
	        }
	      } else {
	        nestedBlock = true;
	        nestedListBlock.push(block);
	      }
	
	      if (!nestedBlock) {
	        listHtml.push('<li');
	        var blockStyle = getBlockStyle(block.data);
	
	        if (blockStyle) {
	          listHtml.push(" style=\"".concat(blockStyle, "\""));
	        }
	
	        if (directional) {
	          listHtml.push(' dir = "auto"');
	        }
	
	        listHtml.push('>');
	        listHtml.push(getBlockInnerMarkup(block, entityMap, hashtagConfig, customEntityTransform));
	        listHtml.push('</li>\n');
	        previousBlock = block;
	      }
	    });
	
	    if (nestedListBlock && nestedListBlock.length > 0) {
	      listHtml.push(getListMarkup(nestedListBlock, entityMap, hashtagConfig, directional, customEntityTransform));
	    }
	
	    listHtml.push("</".concat(getBlockTag(previousBlock.type), ">\n"));
	    return listHtml.join('');
	  }
	
	  /**
	  * The function will generate html markup for given draftjs editorContent.
	  */
	
	  function draftToHtml(editorContent, hashtagConfig, directional, customEntityTransform) {
	    var html = [];
	
	    if (editorContent) {
	      var blocks = editorContent.blocks,
	          entityMap = editorContent.entityMap;
	
	      if (blocks && blocks.length > 0) {
	        var listBlocks = [];
	        blocks.forEach(function (block) {
	          if (isList(block.type)) {
	            listBlocks.push(block);
	          } else {
	            if (listBlocks.length > 0) {
	              var listHtml = getListMarkup(listBlocks, entityMap, hashtagConfig, customEntityTransform); // eslint-disable-line max-len
	
	              html.push(listHtml);
	              listBlocks = [];
	            }
	
	            var blockHtml = getBlockMarkup(block, entityMap, hashtagConfig, directional, customEntityTransform);
	            html.push(blockHtml);
	          }
	        });
	
	        if (listBlocks.length > 0) {
	          var listHtml = getListMarkup(listBlocks, entityMap, hashtagConfig, directional, customEntityTransform); // eslint-disable-line max-len
	
	          html.push(listHtml);
	          listBlocks = [];
	        }
	      }
	    }
	
	    return html.join('');
	  }
	
	  return draftToHtml;
	
	})));


/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/**
	 * Unicode-enabled replacesments for basic String functions.
	 *
	 * All the functions in this module assume that the input string is a valid
	 * UTF-16 encoding of a Unicode sequence. If it's not the case, the behavior
	 * will be undefined.
	 *
	 * WARNING: Since this module is typechecks-enforced, you may find new bugs
	 * when replacing normal String functions with ones provided here.
	 */
	'use strict';
	
	var invariant = __webpack_require__(32); // These two ranges are consecutive so anything in [HIGH_START, LOW_END] is a
	// surrogate code unit.
	
	
	var SURROGATE_HIGH_START = 0xD800;
	var SURROGATE_HIGH_END = 0xDBFF;
	var SURROGATE_LOW_START = 0xDC00;
	var SURROGATE_LOW_END = 0xDFFF;
	var SURROGATE_UNITS_REGEX = /[\uD800-\uDFFF]/;
	/**
	 * @param {number} codeUnit   A Unicode code-unit, in range [0, 0x10FFFF]
	 * @return {boolean}          Whether code-unit is in a surrogate (hi/low) range
	 */
	
	function isCodeUnitInSurrogateRange(codeUnit) {
	  return SURROGATE_HIGH_START <= codeUnit && codeUnit <= SURROGATE_LOW_END;
	}
	/**
	 * Returns whether the two characters starting at `index` form a surrogate pair.
	 * For example, given the string s = "\uD83D\uDE0A", (s, 0) returns true and
	 * (s, 1) returns false.
	 *
	 * @param {string} str
	 * @param {number} index
	 * @return {boolean}
	 */
	
	
	function isSurrogatePair(str, index) {
	  !(0 <= index && index < str.length) ?  false ? invariant(false, 'isSurrogatePair: Invalid index %s for string length %s.', index, str.length) : invariant(false) : void 0;
	
	  if (index + 1 === str.length) {
	    return false;
	  }
	
	  var first = str.charCodeAt(index);
	  var second = str.charCodeAt(index + 1);
	  return SURROGATE_HIGH_START <= first && first <= SURROGATE_HIGH_END && SURROGATE_LOW_START <= second && second <= SURROGATE_LOW_END;
	}
	/**
	 * @param {string} str  Non-empty string
	 * @return {boolean}    True if the input includes any surrogate code units
	 */
	
	
	function hasSurrogateUnit(str) {
	  return SURROGATE_UNITS_REGEX.test(str);
	}
	/**
	 * Return the length of the original Unicode character at given position in the
	 * String by looking into the UTF-16 code unit; that is equal to 1 for any
	 * non-surrogate characters in BMP ([U+0000..U+D7FF] and [U+E000, U+FFFF]); and
	 * returns 2 for the hi/low surrogates ([U+D800..U+DFFF]), which are in fact
	 * representing non-BMP characters ([U+10000..U+10FFFF]).
	 *
	 * Examples:
	 * - '\u0020' => 1
	 * - '\u3020' => 1
	 * - '\uD835' => 2
	 * - '\uD835\uDDEF' => 2
	 * - '\uDDEF' => 2
	 *
	 * @param {string} str  Non-empty string
	 * @param {number} pos  Position in the string to look for one code unit
	 * @return {number}      Number 1 or 2
	 */
	
	
	function getUTF16Length(str, pos) {
	  return 1 + isCodeUnitInSurrogateRange(str.charCodeAt(pos));
	}
	/**
	 * Fully Unicode-enabled replacement for String#length
	 *
	 * @param {string} str  Valid Unicode string
	 * @return {number}     The number of Unicode characters in the string
	 */
	
	
	function strlen(str) {
	  // Call the native functions if there's no surrogate char
	  if (!hasSurrogateUnit(str)) {
	    return str.length;
	  }
	
	  var len = 0;
	
	  for (var pos = 0; pos < str.length; pos += getUTF16Length(str, pos)) {
	    len++;
	  }
	
	  return len;
	}
	/**
	 * Fully Unicode-enabled replacement for String#substr()
	 *
	 * @param {string} str      Valid Unicode string
	 * @param {number} start    Location in Unicode sequence to begin extracting
	 * @param {?number} length  The number of Unicode characters to extract
	 *                          (default: to the end of the string)
	 * @return {string}         Extracted sub-string
	 */
	
	
	function substr(str, start, length) {
	  start = start || 0;
	  length = length === undefined ? Infinity : length || 0; // Call the native functions if there's no surrogate char
	
	  if (!hasSurrogateUnit(str)) {
	    return str.substr(start, length);
	  } // Obvious cases
	
	
	  var size = str.length;
	
	  if (size <= 0 || start > size || length <= 0) {
	    return '';
	  } // Find the actual starting position
	
	
	  var posA = 0;
	
	  if (start > 0) {
	    for (; start > 0 && posA < size; start--) {
	      posA += getUTF16Length(str, posA);
	    }
	
	    if (posA >= size) {
	      return '';
	    }
	  } else if (start < 0) {
	    for (posA = size; start < 0 && 0 < posA; start++) {
	      posA -= getUTF16Length(str, posA - 1);
	    }
	
	    if (posA < 0) {
	      posA = 0;
	    }
	  } // Find the actual ending position
	
	
	  var posB = size;
	
	  if (length < size) {
	    for (posB = posA; length > 0 && posB < size; length--) {
	      posB += getUTF16Length(str, posB);
	    }
	  }
	
	  return str.substring(posA, posB);
	}
	/**
	 * Fully Unicode-enabled replacement for String#substring()
	 *
	 * @param {string} str    Valid Unicode string
	 * @param {number} start  Location in Unicode sequence to begin extracting
	 * @param {?number} end   Location in Unicode sequence to end extracting
	 *                        (default: end of the string)
	 * @return {string}       Extracted sub-string
	 */
	
	
	function substring(str, start, end) {
	  start = start || 0;
	  end = end === undefined ? Infinity : end || 0;
	
	  if (start < 0) {
	    start = 0;
	  }
	
	  if (end < 0) {
	    end = 0;
	  }
	
	  var length = Math.abs(end - start);
	  start = start < end ? start : end;
	  return substr(str, start, length);
	}
	/**
	 * Get a list of Unicode code-points from a String
	 *
	 * @param {string} str        Valid Unicode string
	 * @return {array<number>}    A list of code-points in [0..0x10FFFF]
	 */
	
	
	function getCodePoints(str) {
	  var codePoints = [];
	
	  for (var pos = 0; pos < str.length; pos += getUTF16Length(str, pos)) {
	    codePoints.push(str.codePointAt(pos));
	  }
	
	  return codePoints;
	}
	
	var UnicodeUtils = {
	  getCodePoints: getCodePoints,
	  getUTF16Length: getUTF16Length,
	  hasSurrogateUnit: hasSurrogateUnit,
	  isCodeUnitInSurrogateRange: isCodeUnitInSurrogateRange,
	  isSurrogatePair: isSurrogatePair,
	  strlen: strlen,
	  substring: substring,
	  substr: substr
	};
	module.exports = UnicodeUtils;

/***/ },
/* 108 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/**
	 * This function is used to mark string literals representing CSS class names
	 * so that they can be transformed statically. This allows for modularization
	 * and minification of CSS class names.
	 *
	 * In static_upstream, this function is actually implemented, but it should
	 * eventually be replaced with something more descriptive, and the transform
	 * that is used in the main stack should be ported for use elsewhere.
	 *
	 * @param string|object className to modularize, or an object of key/values.
	 *                      In the object case, the values are conditions that
	 *                      determine if the className keys should be included.
	 * @param [string ...]  Variable list of classNames in the string case.
	 * @return string       Renderable space-separated CSS className.
	 */
	function cx(classNames) {
	  if (typeof classNames == 'object') {
	    return Object.keys(classNames).filter(function (className) {
	      return classNames[className];
	    }).map(replace).join(' ');
	  }
	
	  return Array.prototype.map.call(arguments, replace).join(' ');
	}
	
	function replace(str) {
	  return str.replace(/\//g, '-');
	}
	
	module.exports = cx;

/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies
	 */
	
	var debug = __webpack_require__(1175)('jsonp');
	
	/**
	 * Module exports.
	 */
	
	module.exports = jsonp;
	
	/**
	 * Callback index.
	 */
	
	var count = 0;
	
	/**
	 * Noop function.
	 */
	
	function noop(){}
	
	/**
	 * JSONP handler
	 *
	 * Options:
	 *  - param {String} qs parameter (`callback`)
	 *  - prefix {String} qs parameter (`__jp`)
	 *  - name {String} qs parameter (`prefix` + incr)
	 *  - timeout {Number} how long after a timeout error is emitted (`60000`)
	 *
	 * @param {String} url
	 * @param {Object|Function} optional options / callback
	 * @param {Function} optional callback
	 */
	
	function jsonp(url, opts, fn){
	  if ('function' == typeof opts) {
	    fn = opts;
	    opts = {};
	  }
	  if (!opts) opts = {};
	
	  var prefix = opts.prefix || '__jp';
	
	  // use the callback name that was passed if one was provided.
	  // otherwise generate a unique name by incrementing our counter.
	  var id = opts.name || (prefix + (count++));
	
	  var param = opts.param || 'callback';
	  var timeout = null != opts.timeout ? opts.timeout : 60000;
	  var enc = encodeURIComponent;
	  var target = document.getElementsByTagName('script')[0] || document.head;
	  var script;
	  var timer;
	
	
	  if (timeout) {
	    timer = setTimeout(function(){
	      cleanup();
	      if (fn) fn(new Error('Timeout'));
	    }, timeout);
	  }
	
	  function cleanup(){
	    if (script.parentNode) script.parentNode.removeChild(script);
	    window[id] = noop;
	    if (timer) clearTimeout(timer);
	  }
	
	  function cancel(){
	    if (window[id]) {
	      cleanup();
	    }
	  }
	
	  window[id] = function(data){
	    debug('jsonp got', data);
	    cleanup();
	    if (fn) fn(null, data);
	  };
	
	  // add qs component
	  url += (~url.indexOf('?') ? '&' : '?') + param + '=' + enc(id);
	  url = url.replace('?&', '?');
	
	  debug('jsonp req "%s"', url);
	
	  // create script
	  script = document.createElement('script');
	  script.src = url;
	  target.parentNode.insertBefore(script, target);
	
	  return cancel;
	}


/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var _extends = __webpack_require__(6);
	var isInBrowser = __webpack_require__(439);
	var warning = __webpack_require__(134);
	var _createClass = __webpack_require__(19);
	var _inheritsLoose = __webpack_require__(34);
	var _assertThisInitialized = __webpack_require__(12);
	var _objectWithoutPropertiesLoose = __webpack_require__(13);
	
	function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }
	
	var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
	var isInBrowser__default = /*#__PURE__*/_interopDefaultLegacy(isInBrowser);
	var warning__default = /*#__PURE__*/_interopDefaultLegacy(warning);
	var _createClass__default = /*#__PURE__*/_interopDefaultLegacy(_createClass);
	var _inheritsLoose__default = /*#__PURE__*/_interopDefaultLegacy(_inheritsLoose);
	var _assertThisInitialized__default = /*#__PURE__*/_interopDefaultLegacy(_assertThisInitialized);
	var _objectWithoutPropertiesLoose__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutPropertiesLoose);
	
	var plainObjectConstrurctor = {}.constructor;
	function cloneStyle(style) {
	  if (style == null || typeof style !== 'object') return style;
	  if (Array.isArray(style)) return style.map(cloneStyle);
	  if (style.constructor !== plainObjectConstrurctor) return style;
	  var newStyle = {};
	
	  for (var name in style) {
	    newStyle[name] = cloneStyle(style[name]);
	  }
	
	  return newStyle;
	}
	
	/**
	 * Create a rule instance.
	 */
	
	function createRule(name, decl, options) {
	  if (name === void 0) {
	    name = 'unnamed';
	  }
	
	  var jss = options.jss;
	  var declCopy = cloneStyle(decl);
	  var rule = jss.plugins.onCreateRule(name, declCopy, options);
	  if (rule) return rule; // It is an at-rule and it has no instance.
	
	  if (name[0] === '@') {
	     false ? warning__default['default'](false, "[JSS] Unknown rule " + name) : void 0;
	  }
	
	  return null;
	}
	
	var join = function join(value, by) {
	  var result = '';
	
	  for (var i = 0; i < value.length; i++) {
	    // Remove !important from the value, it will be readded later.
	    if (value[i] === '!important') break;
	    if (result) result += by;
	    result += value[i];
	  }
	
	  return result;
	};
	/**
	 * Converts JSS array value to a CSS string.
	 *
	 * `margin: [['5px', '10px']]` > `margin: 5px 10px;`
	 * `border: ['1px', '2px']` > `border: 1px, 2px;`
	 * `margin: [['5px', '10px'], '!important']` > `margin: 5px 10px !important;`
	 * `color: ['red', !important]` > `color: red !important;`
	 */
	
	
	var toCssValue = function toCssValue(value) {
	  if (!Array.isArray(value)) return value;
	  var cssValue = ''; // Support space separated values via `[['5px', '10px']]`.
	
	  if (Array.isArray(value[0])) {
	    for (var i = 0; i < value.length; i++) {
	      if (value[i] === '!important') break;
	      if (cssValue) cssValue += ', ';
	      cssValue += join(value[i], ' ');
	    }
	  } else cssValue = join(value, ', '); // Add !important, because it was ignored.
	
	
	  if (value[value.length - 1] === '!important') {
	    cssValue += ' !important';
	  }
	
	  return cssValue;
	};
	
	function getWhitespaceSymbols(options) {
	  if (options && options.format === false) {
	    return {
	      linebreak: '',
	      space: ''
	    };
	  }
	
	  return {
	    linebreak: '\n',
	    space: ' '
	  };
	}
	
	/**
	 * Indent a string.
	 * http://jsperf.com/array-join-vs-for
	 */
	
	function indentStr(str, indent) {
	  var result = '';
	
	  for (var index = 0; index < indent; index++) {
	    result += '  ';
	  }
	
	  return result + str;
	}
	/**
	 * Converts a Rule to CSS string.
	 */
	
	
	function toCss(selector, style, options) {
	  if (options === void 0) {
	    options = {};
	  }
	
	  var result = '';
	  if (!style) return result;
	  var _options = options,
	      _options$indent = _options.indent,
	      indent = _options$indent === void 0 ? 0 : _options$indent;
	  var fallbacks = style.fallbacks;
	
	  if (options.format === false) {
	    indent = -Infinity;
	  }
	
	  var _getWhitespaceSymbols = getWhitespaceSymbols(options),
	      linebreak = _getWhitespaceSymbols.linebreak,
	      space = _getWhitespaceSymbols.space;
	
	  if (selector) indent++; // Apply fallbacks first.
	
	  if (fallbacks) {
	    // Array syntax {fallbacks: [{prop: value}]}
	    if (Array.isArray(fallbacks)) {
	      for (var index = 0; index < fallbacks.length; index++) {
	        var fallback = fallbacks[index];
	
	        for (var prop in fallback) {
	          var value = fallback[prop];
	
	          if (value != null) {
	            if (result) result += linebreak;
	            result += indentStr(prop + ":" + space + toCssValue(value) + ";", indent);
	          }
	        }
	      }
	    } else {
	      // Object syntax {fallbacks: {prop: value}}
	      for (var _prop in fallbacks) {
	        var _value = fallbacks[_prop];
	
	        if (_value != null) {
	          if (result) result += linebreak;
	          result += indentStr(_prop + ":" + space + toCssValue(_value) + ";", indent);
	        }
	      }
	    }
	  }
	
	  for (var _prop2 in style) {
	    var _value2 = style[_prop2];
	
	    if (_value2 != null && _prop2 !== 'fallbacks') {
	      if (result) result += linebreak;
	      result += indentStr(_prop2 + ":" + space + toCssValue(_value2) + ";", indent);
	    }
	  } // Allow empty style in this case, because properties will be added dynamically.
	
	
	  if (!result && !options.allowEmpty) return result; // When rule is being stringified before selector was defined.
	
	  if (!selector) return result;
	  indent--;
	  if (result) result = "" + linebreak + result + linebreak;
	  return indentStr("" + selector + space + "{" + result, indent) + indentStr('}', indent);
	}
	
	var escapeRegex = /([[\].#*$><+~=|^:(),"'`\s])/g;
	var nativeEscape = typeof CSS !== 'undefined' && CSS.escape;
	var escape = (function (str) {
	  return nativeEscape ? nativeEscape(str) : str.replace(escapeRegex, '\\$1');
	});
	
	var BaseStyleRule =
	/*#__PURE__*/
	function () {
	  function BaseStyleRule(key, style, options) {
	    this.type = 'style';
	    this.isProcessed = false;
	    var sheet = options.sheet,
	        Renderer = options.Renderer;
	    this.key = key;
	    this.options = options;
	    this.style = style;
	    if (sheet) this.renderer = sheet.renderer;else if (Renderer) this.renderer = new Renderer();
	  }
	  /**
	   * Get or set a style property.
	   */
	
	
	  var _proto = BaseStyleRule.prototype;
	
	  _proto.prop = function prop(name, value, options) {
	    // It's a getter.
	    if (value === undefined) return this.style[name]; // Don't do anything if the value has not changed.
	
	    var force = options ? options.force : false;
	    if (!force && this.style[name] === value) return this;
	    var newValue = value;
	
	    if (!options || options.process !== false) {
	      newValue = this.options.jss.plugins.onChangeValue(value, name, this);
	    }
	
	    var isEmpty = newValue == null || newValue === false;
	    var isDefined = name in this.style; // Value is empty and wasn't defined before.
	
	    if (isEmpty && !isDefined && !force) return this; // We are going to remove this value.
	
	    var remove = isEmpty && isDefined;
	    if (remove) delete this.style[name];else this.style[name] = newValue; // Renderable is defined if StyleSheet option `link` is true.
	
	    if (this.renderable && this.renderer) {
	      if (remove) this.renderer.removeProperty(this.renderable, name);else this.renderer.setProperty(this.renderable, name, newValue);
	      return this;
	    }
	
	    var sheet = this.options.sheet;
	
	    if (sheet && sheet.attached) {
	       false ? warning__default['default'](false, '[JSS] Rule is not linked. Missing sheet option "link: true".') : void 0;
	    }
	
	    return this;
	  };
	
	  return BaseStyleRule;
	}();
	var StyleRule =
	/*#__PURE__*/
	function (_BaseStyleRule) {
	  _inheritsLoose__default['default'](StyleRule, _BaseStyleRule);
	
	  function StyleRule(key, style, options) {
	    var _this;
	
	    _this = _BaseStyleRule.call(this, key, style, options) || this;
	    var selector = options.selector,
	        scoped = options.scoped,
	        sheet = options.sheet,
	        generateId = options.generateId;
	
	    if (selector) {
	      _this.selectorText = selector;
	    } else if (scoped !== false) {
	      _this.id = generateId(_assertThisInitialized__default['default'](_assertThisInitialized__default['default'](_this)), sheet);
	      _this.selectorText = "." + escape(_this.id);
	    }
	
	    return _this;
	  }
	  /**
	   * Set selector string.
	   * Attention: use this with caution. Most browsers didn't implement
	   * selectorText setter, so this may result in rerendering of entire Style Sheet.
	   */
	
	
	  var _proto2 = StyleRule.prototype;
	
	  /**
	   * Apply rule to an element inline.
	   */
	  _proto2.applyTo = function applyTo(renderable) {
	    var renderer = this.renderer;
	
	    if (renderer) {
	      var json = this.toJSON();
	
	      for (var prop in json) {
	        renderer.setProperty(renderable, prop, json[prop]);
	      }
	    }
	
	    return this;
	  }
	  /**
	   * Returns JSON representation of the rule.
	   * Fallbacks are not supported.
	   * Useful for inline styles.
	   */
	  ;
	
	  _proto2.toJSON = function toJSON() {
	    var json = {};
	
	    for (var prop in this.style) {
	      var value = this.style[prop];
	      if (typeof value !== 'object') json[prop] = value;else if (Array.isArray(value)) json[prop] = toCssValue(value);
	    }
	
	    return json;
	  }
	  /**
	   * Generates a CSS string.
	   */
	  ;
	
	  _proto2.toString = function toString(options) {
	    var sheet = this.options.sheet;
	    var link = sheet ? sheet.options.link : false;
	    var opts = link ? _extends__default['default']({}, options, {
	      allowEmpty: true
	    }) : options;
	    return toCss(this.selectorText, this.style, opts);
	  };
	
	  _createClass__default['default'](StyleRule, [{
	    key: "selector",
	    set: function set(selector) {
	      if (selector === this.selectorText) return;
	      this.selectorText = selector;
	      var renderer = this.renderer,
	          renderable = this.renderable;
	      if (!renderable || !renderer) return;
	      var hasChanged = renderer.setSelector(renderable, selector); // If selector setter is not implemented, rerender the rule.
	
	      if (!hasChanged) {
	        renderer.replaceRule(renderable, this);
	      }
	    }
	    /**
	     * Get selector string.
	     */
	    ,
	    get: function get() {
	      return this.selectorText;
	    }
	  }]);
	
	  return StyleRule;
	}(BaseStyleRule);
	var pluginStyleRule = {
	  onCreateRule: function onCreateRule(key, style, options) {
	    if (key[0] === '@' || options.parent && options.parent.type === 'keyframes') {
	      return null;
	    }
	
	    return new StyleRule(key, style, options);
	  }
	};
	
	var defaultToStringOptions = {
	  indent: 1,
	  children: true
	};
	var atRegExp = /@([\w-]+)/;
	/**
	 * Conditional rule for @media, @supports
	 */
	
	var ConditionalRule =
	/*#__PURE__*/
	function () {
	  function ConditionalRule(key, styles, options) {
	    this.type = 'conditional';
	    this.isProcessed = false;
	    this.key = key;
	    var atMatch = key.match(atRegExp);
	    this.at = atMatch ? atMatch[1] : 'unknown'; // Key might contain a unique suffix in case the `name` passed by user was duplicate.
	
	    this.query = options.name || "@" + this.at;
	    this.options = options;
	    this.rules = new RuleList(_extends__default['default']({}, options, {
	      parent: this
	    }));
	
	    for (var name in styles) {
	      this.rules.add(name, styles[name]);
	    }
	
	    this.rules.process();
	  }
	  /**
	   * Get a rule.
	   */
	
	
	  var _proto = ConditionalRule.prototype;
	
	  _proto.getRule = function getRule(name) {
	    return this.rules.get(name);
	  }
	  /**
	   * Get index of a rule.
	   */
	  ;
	
	  _proto.indexOf = function indexOf(rule) {
	    return this.rules.indexOf(rule);
	  }
	  /**
	   * Create and register rule, run plugins.
	   */
	  ;
	
	  _proto.addRule = function addRule(name, style, options) {
	    var rule = this.rules.add(name, style, options);
	    if (!rule) return null;
	    this.options.jss.plugins.onProcessRule(rule);
	    return rule;
	  }
	  /**
	   * Replace rule, run plugins.
	   */
	  ;
	
	  _proto.replaceRule = function replaceRule(name, style, options) {
	    var newRule = this.rules.replace(name, style, options);
	    if (newRule) this.options.jss.plugins.onProcessRule(newRule);
	    return newRule;
	  }
	  /**
	   * Generates a CSS string.
	   */
	  ;
	
	  _proto.toString = function toString(options) {
	    if (options === void 0) {
	      options = defaultToStringOptions;
	    }
	
	    var _getWhitespaceSymbols = getWhitespaceSymbols(options),
	        linebreak = _getWhitespaceSymbols.linebreak;
	
	    if (options.indent == null) options.indent = defaultToStringOptions.indent;
	    if (options.children == null) options.children = defaultToStringOptions.children;
	
	    if (options.children === false) {
	      return this.query + " {}";
	    }
	
	    var children = this.rules.toString(options);
	    return children ? this.query + " {" + linebreak + children + linebreak + "}" : '';
	  };
	
	  return ConditionalRule;
	}();
	var keyRegExp = /@container|@media|@supports\s+/;
	var pluginConditionalRule = {
	  onCreateRule: function onCreateRule(key, styles, options) {
	    return keyRegExp.test(key) ? new ConditionalRule(key, styles, options) : null;
	  }
	};
	
	var defaultToStringOptions$1 = {
	  indent: 1,
	  children: true
	};
	var nameRegExp = /@keyframes\s+([\w-]+)/;
	/**
	 * Rule for @keyframes
	 */
	
	var KeyframesRule =
	/*#__PURE__*/
	function () {
	  function KeyframesRule(key, frames, options) {
	    this.type = 'keyframes';
	    this.at = '@keyframes';
	    this.isProcessed = false;
	    var nameMatch = key.match(nameRegExp);
	
	    if (nameMatch && nameMatch[1]) {
	      this.name = nameMatch[1];
	    } else {
	      this.name = 'noname';
	       false ? warning__default['default'](false, "[JSS] Bad keyframes name " + key) : void 0;
	    }
	
	    this.key = this.type + "-" + this.name;
	    this.options = options;
	    var scoped = options.scoped,
	        sheet = options.sheet,
	        generateId = options.generateId;
	    this.id = scoped === false ? this.name : escape(generateId(this, sheet));
	    this.rules = new RuleList(_extends__default['default']({}, options, {
	      parent: this
	    }));
	
	    for (var name in frames) {
	      this.rules.add(name, frames[name], _extends__default['default']({}, options, {
	        parent: this
	      }));
	    }
	
	    this.rules.process();
	  }
	  /**
	   * Generates a CSS string.
	   */
	
	
	  var _proto = KeyframesRule.prototype;
	
	  _proto.toString = function toString(options) {
	    if (options === void 0) {
	      options = defaultToStringOptions$1;
	    }
	
	    var _getWhitespaceSymbols = getWhitespaceSymbols(options),
	        linebreak = _getWhitespaceSymbols.linebreak;
	
	    if (options.indent == null) options.indent = defaultToStringOptions$1.indent;
	    if (options.children == null) options.children = defaultToStringOptions$1.children;
	
	    if (options.children === false) {
	      return this.at + " " + this.id + " {}";
	    }
	
	    var children = this.rules.toString(options);
	    if (children) children = "" + linebreak + children + linebreak;
	    return this.at + " " + this.id + " {" + children + "}";
	  };
	
	  return KeyframesRule;
	}();
	var keyRegExp$1 = /@keyframes\s+/;
	var refRegExp = /\$([\w-]+)/g;
	
	var findReferencedKeyframe = function findReferencedKeyframe(val, keyframes) {
	  if (typeof val === 'string') {
	    return val.replace(refRegExp, function (match, name) {
	      if (name in keyframes) {
	        return keyframes[name];
	      }
	
	       false ? warning__default['default'](false, "[JSS] Referenced keyframes rule \"" + name + "\" is not defined.") : void 0;
	      return match;
	    });
	  }
	
	  return val;
	};
	/**
	 * Replace the reference for a animation name.
	 */
	
	
	var replaceRef = function replaceRef(style, prop, keyframes) {
	  var value = style[prop];
	  var refKeyframe = findReferencedKeyframe(value, keyframes);
	
	  if (refKeyframe !== value) {
	    style[prop] = refKeyframe;
	  }
	};
	
	var pluginKeyframesRule = {
	  onCreateRule: function onCreateRule(key, frames, options) {
	    return typeof key === 'string' && keyRegExp$1.test(key) ? new KeyframesRule(key, frames, options) : null;
	  },
	  // Animation name ref replacer.
	  onProcessStyle: function onProcessStyle(style, rule, sheet) {
	    if (rule.type !== 'style' || !sheet) return style;
	    if ('animation-name' in style) replaceRef(style, 'animation-name', sheet.keyframes);
	    if ('animation' in style) replaceRef(style, 'animation', sheet.keyframes);
	    return style;
	  },
	  onChangeValue: function onChangeValue(val, prop, rule) {
	    var sheet = rule.options.sheet;
	
	    if (!sheet) {
	      return val;
	    }
	
	    switch (prop) {
	      case 'animation':
	        return findReferencedKeyframe(val, sheet.keyframes);
	
	      case 'animation-name':
	        return findReferencedKeyframe(val, sheet.keyframes);
	
	      default:
	        return val;
	    }
	  }
	};
	
	var KeyframeRule =
	/*#__PURE__*/
	function (_BaseStyleRule) {
	  _inheritsLoose__default['default'](KeyframeRule, _BaseStyleRule);
	
	  function KeyframeRule() {
	    return _BaseStyleRule.apply(this, arguments) || this;
	  }
	
	  var _proto = KeyframeRule.prototype;
	
	  /**
	   * Generates a CSS string.
	   */
	  _proto.toString = function toString(options) {
	    var sheet = this.options.sheet;
	    var link = sheet ? sheet.options.link : false;
	    var opts = link ? _extends__default['default']({}, options, {
	      allowEmpty: true
	    }) : options;
	    return toCss(this.key, this.style, opts);
	  };
	
	  return KeyframeRule;
	}(BaseStyleRule);
	var pluginKeyframeRule = {
	  onCreateRule: function onCreateRule(key, style, options) {
	    if (options.parent && options.parent.type === 'keyframes') {
	      return new KeyframeRule(key, style, options);
	    }
	
	    return null;
	  }
	};
	
	var FontFaceRule =
	/*#__PURE__*/
	function () {
	  function FontFaceRule(key, style, options) {
	    this.type = 'font-face';
	    this.at = '@font-face';
	    this.isProcessed = false;
	    this.key = key;
	    this.style = style;
	    this.options = options;
	  }
	  /**
	   * Generates a CSS string.
	   */
	
	
	  var _proto = FontFaceRule.prototype;
	
	  _proto.toString = function toString(options) {
	    var _getWhitespaceSymbols = getWhitespaceSymbols(options),
	        linebreak = _getWhitespaceSymbols.linebreak;
	
	    if (Array.isArray(this.style)) {
	      var str = '';
	
	      for (var index = 0; index < this.style.length; index++) {
	        str += toCss(this.at, this.style[index]);
	        if (this.style[index + 1]) str += linebreak;
	      }
	
	      return str;
	    }
	
	    return toCss(this.at, this.style, options);
	  };
	
	  return FontFaceRule;
	}();
	var keyRegExp$2 = /@font-face/;
	var pluginFontFaceRule = {
	  onCreateRule: function onCreateRule(key, style, options) {
	    return keyRegExp$2.test(key) ? new FontFaceRule(key, style, options) : null;
	  }
	};
	
	var ViewportRule =
	/*#__PURE__*/
	function () {
	  function ViewportRule(key, style, options) {
	    this.type = 'viewport';
	    this.at = '@viewport';
	    this.isProcessed = false;
	    this.key = key;
	    this.style = style;
	    this.options = options;
	  }
	  /**
	   * Generates a CSS string.
	   */
	
	
	  var _proto = ViewportRule.prototype;
	
	  _proto.toString = function toString(options) {
	    return toCss(this.key, this.style, options);
	  };
	
	  return ViewportRule;
	}();
	var pluginViewportRule = {
	  onCreateRule: function onCreateRule(key, style, options) {
	    return key === '@viewport' || key === '@-ms-viewport' ? new ViewportRule(key, style, options) : null;
	  }
	};
	
	var SimpleRule =
	/*#__PURE__*/
	function () {
	  function SimpleRule(key, value, options) {
	    this.type = 'simple';
	    this.isProcessed = false;
	    this.key = key;
	    this.value = value;
	    this.options = options;
	  }
	  /**
	   * Generates a CSS string.
	   */
	  // eslint-disable-next-line no-unused-vars
	
	
	  var _proto = SimpleRule.prototype;
	
	  _proto.toString = function toString(options) {
	    if (Array.isArray(this.value)) {
	      var str = '';
	
	      for (var index = 0; index < this.value.length; index++) {
	        str += this.key + " " + this.value[index] + ";";
	        if (this.value[index + 1]) str += '\n';
	      }
	
	      return str;
	    }
	
	    return this.key + " " + this.value + ";";
	  };
	
	  return SimpleRule;
	}();
	var keysMap = {
	  '@charset': true,
	  '@import': true,
	  '@namespace': true
	};
	var pluginSimpleRule = {
	  onCreateRule: function onCreateRule(key, value, options) {
	    return key in keysMap ? new SimpleRule(key, value, options) : null;
	  }
	};
	
	var plugins = [pluginStyleRule, pluginConditionalRule, pluginKeyframesRule, pluginKeyframeRule, pluginFontFaceRule, pluginViewportRule, pluginSimpleRule];
	
	var defaultUpdateOptions = {
	  process: true
	};
	var forceUpdateOptions = {
	  force: true,
	  process: true
	  /**
	   * Contains rules objects and allows adding/removing etc.
	   * Is used for e.g. by `StyleSheet` or `ConditionalRule`.
	   */
	
	};
	
	var RuleList =
	/*#__PURE__*/
	function () {
	  // Rules registry for access by .get() method.
	  // It contains the same rule registered by name and by selector.
	  // Original styles object.
	  // Used to ensure correct rules order.
	  function RuleList(options) {
	    this.map = {};
	    this.raw = {};
	    this.index = [];
	    this.counter = 0;
	    this.options = options;
	    this.classes = options.classes;
	    this.keyframes = options.keyframes;
	  }
	  /**
	   * Create and register rule.
	   *
	   * Will not render after Style Sheet was rendered the first time.
	   */
	
	
	  var _proto = RuleList.prototype;
	
	  _proto.add = function add(name, decl, ruleOptions) {
	    var _this$options = this.options,
	        parent = _this$options.parent,
	        sheet = _this$options.sheet,
	        jss = _this$options.jss,
	        Renderer = _this$options.Renderer,
	        generateId = _this$options.generateId,
	        scoped = _this$options.scoped;
	
	    var options = _extends__default['default']({
	      classes: this.classes,
	      parent: parent,
	      sheet: sheet,
	      jss: jss,
	      Renderer: Renderer,
	      generateId: generateId,
	      scoped: scoped,
	      name: name,
	      keyframes: this.keyframes,
	      selector: undefined
	    }, ruleOptions); // When user uses .createStyleSheet(), duplicate names are not possible, but
	    // `sheet.addRule()` opens the door for any duplicate rule name. When this happens
	    // we need to make the key unique within this RuleList instance scope.
	
	
	    var key = name;
	
	    if (name in this.raw) {
	      key = name + "-d" + this.counter++;
	    } // We need to save the original decl before creating the rule
	    // because cache plugin needs to use it as a key to return a cached rule.
	
	
	    this.raw[key] = decl;
	
	    if (key in this.classes) {
	      // E.g. rules inside of @media container
	      options.selector = "." + escape(this.classes[key]);
	    }
	
	    var rule = createRule(key, decl, options);
	    if (!rule) return null;
	    this.register(rule);
	    var index = options.index === undefined ? this.index.length : options.index;
	    this.index.splice(index, 0, rule);
	    return rule;
	  }
	  /**
	   * Replace rule.
	   * Create a new rule and remove old one instead of overwriting
	   * because we want to invoke onCreateRule hook to make plugins work.
	   */
	  ;
	
	  _proto.replace = function replace(name, decl, ruleOptions) {
	    var oldRule = this.get(name);
	    var oldIndex = this.index.indexOf(oldRule);
	
	    if (oldRule) {
	      this.remove(oldRule);
	    }
	
	    var options = ruleOptions;
	    if (oldIndex !== -1) options = _extends__default['default']({}, ruleOptions, {
	      index: oldIndex
	    });
	    return this.add(name, decl, options);
	  }
	  /**
	   * Get a rule by name or selector.
	   */
	  ;
	
	  _proto.get = function get(nameOrSelector) {
	    return this.map[nameOrSelector];
	  }
	  /**
	   * Delete a rule.
	   */
	  ;
	
	  _proto.remove = function remove(rule) {
	    this.unregister(rule);
	    delete this.raw[rule.key];
	    this.index.splice(this.index.indexOf(rule), 1);
	  }
	  /**
	   * Get index of a rule.
	   */
	  ;
	
	  _proto.indexOf = function indexOf(rule) {
	    return this.index.indexOf(rule);
	  }
	  /**
	   * Run `onProcessRule()` plugins on every rule.
	   */
	  ;
	
	  _proto.process = function process() {
	    var plugins = this.options.jss.plugins; // We need to clone array because if we modify the index somewhere else during a loop
	    // we end up with very hard-to-track-down side effects.
	
	    this.index.slice(0).forEach(plugins.onProcessRule, plugins);
	  }
	  /**
	   * Register a rule in `.map`, `.classes` and `.keyframes` maps.
	   */
	  ;
	
	  _proto.register = function register(rule) {
	    this.map[rule.key] = rule;
	
	    if (rule instanceof StyleRule) {
	      this.map[rule.selector] = rule;
	      if (rule.id) this.classes[rule.key] = rule.id;
	    } else if (rule instanceof KeyframesRule && this.keyframes) {
	      this.keyframes[rule.name] = rule.id;
	    }
	  }
	  /**
	   * Unregister a rule.
	   */
	  ;
	
	  _proto.unregister = function unregister(rule) {
	    delete this.map[rule.key];
	
	    if (rule instanceof StyleRule) {
	      delete this.map[rule.selector];
	      delete this.classes[rule.key];
	    } else if (rule instanceof KeyframesRule) {
	      delete this.keyframes[rule.name];
	    }
	  }
	  /**
	   * Update the function values with a new data.
	   */
	  ;
	
	  _proto.update = function update() {
	    var name;
	    var data;
	    var options;
	
	    if (typeof (arguments.length <= 0 ? undefined : arguments[0]) === 'string') {
	      name = arguments.length <= 0 ? undefined : arguments[0];
	      data = arguments.length <= 1 ? undefined : arguments[1];
	      options = arguments.length <= 2 ? undefined : arguments[2];
	    } else {
	      data = arguments.length <= 0 ? undefined : arguments[0];
	      options = arguments.length <= 1 ? undefined : arguments[1];
	      name = null;
	    }
	
	    if (name) {
	      this.updateOne(this.get(name), data, options);
	    } else {
	      for (var index = 0; index < this.index.length; index++) {
	        this.updateOne(this.index[index], data, options);
	      }
	    }
	  }
	  /**
	   * Execute plugins, update rule props.
	   */
	  ;
	
	  _proto.updateOne = function updateOne(rule, data, options) {
	    if (options === void 0) {
	      options = defaultUpdateOptions;
	    }
	
	    var _this$options2 = this.options,
	        plugins = _this$options2.jss.plugins,
	        sheet = _this$options2.sheet; // It is a rules container like for e.g. ConditionalRule.
	
	    if (rule.rules instanceof RuleList) {
	      rule.rules.update(data, options);
	      return;
	    }
	
	    var style = rule.style;
	    plugins.onUpdate(data, rule, sheet, options); // We rely on a new `style` ref in case it was mutated during onUpdate hook.
	
	    if (options.process && style && style !== rule.style) {
	      // We need to run the plugins in case new `style` relies on syntax plugins.
	      plugins.onProcessStyle(rule.style, rule, sheet); // Update and add props.
	
	      for (var prop in rule.style) {
	        var nextValue = rule.style[prop];
	        var prevValue = style[prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
	        // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.
	
	        if (nextValue !== prevValue) {
	          rule.prop(prop, nextValue, forceUpdateOptions);
	        }
	      } // Remove props.
	
	
	      for (var _prop in style) {
	        var _nextValue = rule.style[_prop];
	        var _prevValue = style[_prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
	        // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.
	
	        if (_nextValue == null && _nextValue !== _prevValue) {
	          rule.prop(_prop, null, forceUpdateOptions);
	        }
	      }
	    }
	  }
	  /**
	   * Convert rules to a CSS string.
	   */
	  ;
	
	  _proto.toString = function toString(options) {
	    var str = '';
	    var sheet = this.options.sheet;
	    var link = sheet ? sheet.options.link : false;
	
	    var _getWhitespaceSymbols = getWhitespaceSymbols(options),
	        linebreak = _getWhitespaceSymbols.linebreak;
	
	    for (var index = 0; index < this.index.length; index++) {
	      var rule = this.index[index];
	      var css = rule.toString(options); // No need to render an empty rule.
	
	      if (!css && !link) continue;
	      if (str) str += linebreak;
	      str += css;
	    }
	
	    return str;
	  };
	
	  return RuleList;
	}();
	
	var StyleSheet =
	/*#__PURE__*/
	function () {
	  function StyleSheet(styles, options) {
	    this.attached = false;
	    this.deployed = false;
	    this.classes = {};
	    this.keyframes = {};
	    this.options = _extends__default['default']({}, options, {
	      sheet: this,
	      parent: this,
	      classes: this.classes,
	      keyframes: this.keyframes
	    });
	
	    if (options.Renderer) {
	      this.renderer = new options.Renderer(this);
	    }
	
	    this.rules = new RuleList(this.options);
	
	    for (var name in styles) {
	      this.rules.add(name, styles[name]);
	    }
	
	    this.rules.process();
	  }
	  /**
	   * Attach renderable to the render tree.
	   */
	
	
	  var _proto = StyleSheet.prototype;
	
	  _proto.attach = function attach() {
	    if (this.attached) return this;
	    if (this.renderer) this.renderer.attach();
	    this.attached = true; // Order is important, because we can't use insertRule API if style element is not attached.
	
	    if (!this.deployed) this.deploy();
	    return this;
	  }
	  /**
	   * Remove renderable from render tree.
	   */
	  ;
	
	  _proto.detach = function detach() {
	    if (!this.attached) return this;
	    if (this.renderer) this.renderer.detach();
	    this.attached = false;
	    return this;
	  }
	  /**
	   * Add a rule to the current stylesheet.
	   * Will insert a rule also after the stylesheet has been rendered first time.
	   */
	  ;
	
	  _proto.addRule = function addRule(name, decl, options) {
	    var queue = this.queue; // Plugins can create rules.
	    // In order to preserve the right order, we need to queue all `.addRule` calls,
	    // which happen after the first `rules.add()` call.
	
	    if (this.attached && !queue) this.queue = [];
	    var rule = this.rules.add(name, decl, options);
	    if (!rule) return null;
	    this.options.jss.plugins.onProcessRule(rule);
	
	    if (this.attached) {
	      if (!this.deployed) return rule; // Don't insert rule directly if there is no stringified version yet.
	      // It will be inserted all together when .attach is called.
	
	      if (queue) queue.push(rule);else {
	        this.insertRule(rule);
	
	        if (this.queue) {
	          this.queue.forEach(this.insertRule, this);
	          this.queue = undefined;
	        }
	      }
	      return rule;
	    } // We can't add rules to a detached style node.
	    // We will redeploy the sheet once user will attach it.
	
	
	    this.deployed = false;
	    return rule;
	  }
	  /**
	   * Replace a rule in the current stylesheet.
	   */
	  ;
	
	  _proto.replaceRule = function replaceRule(nameOrSelector, decl, options) {
	    var oldRule = this.rules.get(nameOrSelector);
	    if (!oldRule) return this.addRule(nameOrSelector, decl, options);
	    var newRule = this.rules.replace(nameOrSelector, decl, options);
	
	    if (newRule) {
	      this.options.jss.plugins.onProcessRule(newRule);
	    }
	
	    if (this.attached) {
	      if (!this.deployed) return newRule; // Don't replace / delete rule directly if there is no stringified version yet.
	      // It will be inserted all together when .attach is called.
	
	      if (this.renderer) {
	        if (!newRule) {
	          this.renderer.deleteRule(oldRule);
	        } else if (oldRule.renderable) {
	          this.renderer.replaceRule(oldRule.renderable, newRule);
	        }
	      }
	
	      return newRule;
	    } // We can't replace rules to a detached style node.
	    // We will redeploy the sheet once user will attach it.
	
	
	    this.deployed = false;
	    return newRule;
	  }
	  /**
	   * Insert rule into the StyleSheet
	   */
	  ;
	
	  _proto.insertRule = function insertRule(rule) {
	    if (this.renderer) {
	      this.renderer.insertRule(rule);
	    }
	  }
	  /**
	   * Create and add rules.
	   * Will render also after Style Sheet was rendered the first time.
	   */
	  ;
	
	  _proto.addRules = function addRules(styles, options) {
	    var added = [];
	
	    for (var name in styles) {
	      var rule = this.addRule(name, styles[name], options);
	      if (rule) added.push(rule);
	    }
	
	    return added;
	  }
	  /**
	   * Get a rule by name or selector.
	   */
	  ;
	
	  _proto.getRule = function getRule(nameOrSelector) {
	    return this.rules.get(nameOrSelector);
	  }
	  /**
	   * Delete a rule by name.
	   * Returns `true`: if rule has been deleted from the DOM.
	   */
	  ;
	
	  _proto.deleteRule = function deleteRule(name) {
	    var rule = typeof name === 'object' ? name : this.rules.get(name);
	
	    if (!rule || // Style sheet was created without link: true and attached, in this case we
	    // won't be able to remove the CSS rule from the DOM.
	    this.attached && !rule.renderable) {
	      return false;
	    }
	
	    this.rules.remove(rule);
	
	    if (this.attached && rule.renderable && this.renderer) {
	      return this.renderer.deleteRule(rule.renderable);
	    }
	
	    return true;
	  }
	  /**
	   * Get index of a rule.
	   */
	  ;
	
	  _proto.indexOf = function indexOf(rule) {
	    return this.rules.indexOf(rule);
	  }
	  /**
	   * Deploy pure CSS string to a renderable.
	   */
	  ;
	
	  _proto.deploy = function deploy() {
	    if (this.renderer) this.renderer.deploy();
	    this.deployed = true;
	    return this;
	  }
	  /**
	   * Update the function values with a new data.
	   */
	  ;
	
	  _proto.update = function update() {
	    var _this$rules;
	
	    (_this$rules = this.rules).update.apply(_this$rules, arguments);
	
	    return this;
	  }
	  /**
	   * Updates a single rule.
	   */
	  ;
	
	  _proto.updateOne = function updateOne(rule, data, options) {
	    this.rules.updateOne(rule, data, options);
	    return this;
	  }
	  /**
	   * Convert rules to a CSS string.
	   */
	  ;
	
	  _proto.toString = function toString(options) {
	    return this.rules.toString(options);
	  };
	
	  return StyleSheet;
	}();
	
	var PluginsRegistry =
	/*#__PURE__*/
	function () {
	  function PluginsRegistry() {
	    this.plugins = {
	      internal: [],
	      external: []
	    };
	    this.registry = {};
	  }
	
	  var _proto = PluginsRegistry.prototype;
	
	  /**
	   * Call `onCreateRule` hooks and return an object if returned by a hook.
	   */
	  _proto.onCreateRule = function onCreateRule(name, decl, options) {
	    for (var i = 0; i < this.registry.onCreateRule.length; i++) {
	      var rule = this.registry.onCreateRule[i](name, decl, options);
	      if (rule) return rule;
	    }
	
	    return null;
	  }
	  /**
	   * Call `onProcessRule` hooks.
	   */
	  ;
	
	  _proto.onProcessRule = function onProcessRule(rule) {
	    if (rule.isProcessed) return;
	    var sheet = rule.options.sheet;
	
	    for (var i = 0; i < this.registry.onProcessRule.length; i++) {
	      this.registry.onProcessRule[i](rule, sheet);
	    }
	
	    if (rule.style) this.onProcessStyle(rule.style, rule, sheet);
	    rule.isProcessed = true;
	  }
	  /**
	   * Call `onProcessStyle` hooks.
	   */
	  ;
	
	  _proto.onProcessStyle = function onProcessStyle(style, rule, sheet) {
	    for (var i = 0; i < this.registry.onProcessStyle.length; i++) {
	      rule.style = this.registry.onProcessStyle[i](rule.style, rule, sheet);
	    }
	  }
	  /**
	   * Call `onProcessSheet` hooks.
	   */
	  ;
	
	  _proto.onProcessSheet = function onProcessSheet(sheet) {
	    for (var i = 0; i < this.registry.onProcessSheet.length; i++) {
	      this.registry.onProcessSheet[i](sheet);
	    }
	  }
	  /**
	   * Call `onUpdate` hooks.
	   */
	  ;
	
	  _proto.onUpdate = function onUpdate(data, rule, sheet, options) {
	    for (var i = 0; i < this.registry.onUpdate.length; i++) {
	      this.registry.onUpdate[i](data, rule, sheet, options);
	    }
	  }
	  /**
	   * Call `onChangeValue` hooks.
	   */
	  ;
	
	  _proto.onChangeValue = function onChangeValue(value, prop, rule) {
	    var processedValue = value;
	
	    for (var i = 0; i < this.registry.onChangeValue.length; i++) {
	      processedValue = this.registry.onChangeValue[i](processedValue, prop, rule);
	    }
	
	    return processedValue;
	  }
	  /**
	   * Register a plugin.
	   */
	  ;
	
	  _proto.use = function use(newPlugin, options) {
	    if (options === void 0) {
	      options = {
	        queue: 'external'
	      };
	    }
	
	    var plugins = this.plugins[options.queue]; // Avoids applying same plugin twice, at least based on ref.
	
	    if (plugins.indexOf(newPlugin) !== -1) {
	      return;
	    }
	
	    plugins.push(newPlugin);
	    this.registry = [].concat(this.plugins.external, this.plugins.internal).reduce(function (registry, plugin) {
	      for (var name in plugin) {
	        if (name in registry) {
	          registry[name].push(plugin[name]);
	        } else {
	           false ? warning__default['default'](false, "[JSS] Unknown hook \"" + name + "\".") : void 0;
	        }
	      }
	
	      return registry;
	    }, {
	      onCreateRule: [],
	      onProcessRule: [],
	      onProcessStyle: [],
	      onProcessSheet: [],
	      onChangeValue: [],
	      onUpdate: []
	    });
	  };
	
	  return PluginsRegistry;
	}();
	
	/**
	 * Sheets registry to access all instances in one place.
	 */
	
	var SheetsRegistry =
	/*#__PURE__*/
	function () {
	  function SheetsRegistry() {
	    this.registry = [];
	  }
	
	  var _proto = SheetsRegistry.prototype;
	
	  /**
	   * Register a Style Sheet.
	   */
	  _proto.add = function add(sheet) {
	    var registry = this.registry;
	    var index = sheet.options.index;
	    if (registry.indexOf(sheet) !== -1) return;
	
	    if (registry.length === 0 || index >= this.index) {
	      registry.push(sheet);
	      return;
	    } // Find a position.
	
	
	    for (var i = 0; i < registry.length; i++) {
	      if (registry[i].options.index > index) {
	        registry.splice(i, 0, sheet);
	        return;
	      }
	    }
	  }
	  /**
	   * Reset the registry.
	   */
	  ;
	
	  _proto.reset = function reset() {
	    this.registry = [];
	  }
	  /**
	   * Remove a Style Sheet.
	   */
	  ;
	
	  _proto.remove = function remove(sheet) {
	    var index = this.registry.indexOf(sheet);
	    this.registry.splice(index, 1);
	  }
	  /**
	   * Convert all attached sheets to a CSS string.
	   */
	  ;
	
	  _proto.toString = function toString(_temp) {
	    var _ref = _temp === void 0 ? {} : _temp,
	        attached = _ref.attached,
	        options = _objectWithoutPropertiesLoose__default['default'](_ref, ["attached"]);
	
	    var _getWhitespaceSymbols = getWhitespaceSymbols(options),
	        linebreak = _getWhitespaceSymbols.linebreak;
	
	    var css = '';
	
	    for (var i = 0; i < this.registry.length; i++) {
	      var sheet = this.registry[i];
	
	      if (attached != null && sheet.attached !== attached) {
	        continue;
	      }
	
	      if (css) css += linebreak;
	      css += sheet.toString(options);
	    }
	
	    return css;
	  };
	
	  _createClass__default['default'](SheetsRegistry, [{
	    key: "index",
	
	    /**
	     * Current highest index number.
	     */
	    get: function get() {
	      return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
	    }
	  }]);
	
	  return SheetsRegistry;
	}();
	
	/**
	 * This is a global sheets registry. Only DomRenderer will add sheets to it.
	 * On the server one should use an own SheetsRegistry instance and add the
	 * sheets to it, because you need to make sure to create a new registry for
	 * each request in order to not leak sheets across requests.
	 */
	
	var sheets = new SheetsRegistry();
	
	/* eslint-disable */
	
	/**
	 * Now that `globalThis` is available on most platforms
	 * (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/globalThis#browser_compatibility)
	 * we check for `globalThis` first. `globalThis` is necessary for jss
	 * to run in Agoric's secure version of JavaScript (SES). Under SES,
	 * `globalThis` exists, but `window`, `self`, and `Function('return
	 * this')()` are all undefined for security reasons.
	 *
	 * https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	 */
	var globalThis$1 = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' && window.Math === Math ? window : typeof self !== 'undefined' && self.Math === Math ? self : Function('return this')();
	
	var ns = '2f1acc6c3a606b082e5eef5e54414ffb';
	if (globalThis$1[ns] == null) globalThis$1[ns] = 0; // Bundle may contain multiple JSS versions at the same time. In order to identify
	// the current version with just one short number and use it for classes generation
	// we use a counter. Also it is more accurate, because user can manually reevaluate
	// the module.
	
	var moduleId = globalThis$1[ns]++;
	
	var maxRules = 1e10;
	/**
	 * Returns a function which generates unique class names based on counters.
	 * When new generator function is created, rule counter is reseted.
	 * We need to reset the rule counter for SSR for each request.
	 */
	
	var createGenerateId = function createGenerateId(options) {
	  if (options === void 0) {
	    options = {};
	  }
	
	  var ruleCounter = 0;
	
	  var generateId = function generateId(rule, sheet) {
	    ruleCounter += 1;
	
	    if (ruleCounter > maxRules) {
	       false ? warning__default['default'](false, "[JSS] You might have a memory leak. Rule counter is at " + ruleCounter + ".") : void 0;
	    }
	
	    var jssId = '';
	    var prefix = '';
	
	    if (sheet) {
	      if (sheet.options.classNamePrefix) {
	        prefix = sheet.options.classNamePrefix;
	      }
	
	      if (sheet.options.jss.id != null) {
	        jssId = String(sheet.options.jss.id);
	      }
	    }
	
	    if (options.minify) {
	      // Using "c" because a number can't be the first char in a class name.
	      return "" + (prefix || 'c') + moduleId + jssId + ruleCounter;
	    }
	
	    return prefix + rule.key + "-" + moduleId + (jssId ? "-" + jssId : '') + "-" + ruleCounter;
	  };
	
	  return generateId;
	};
	
	/**
	 * Cache the value from the first time a function is called.
	 */
	
	var memoize = function memoize(fn) {
	  var value;
	  return function () {
	    if (!value) value = fn();
	    return value;
	  };
	};
	/**
	 * Get a style property value.
	 */
	
	
	var getPropertyValue = function getPropertyValue(cssRule, prop) {
	  try {
	    // Support CSSTOM.
	    if (cssRule.attributeStyleMap) {
	      return cssRule.attributeStyleMap.get(prop);
	    }
	
	    return cssRule.style.getPropertyValue(prop);
	  } catch (err) {
	    // IE may throw if property is unknown.
	    return '';
	  }
	};
	/**
	 * Set a style property.
	 */
	
	
	var setProperty = function setProperty(cssRule, prop, value) {
	  try {
	    var cssValue = value;
	
	    if (Array.isArray(value)) {
	      cssValue = toCssValue(value);
	    } // Support CSSTOM.
	
	
	    if (cssRule.attributeStyleMap) {
	      cssRule.attributeStyleMap.set(prop, cssValue);
	    } else {
	      var indexOfImportantFlag = cssValue ? cssValue.indexOf('!important') : -1;
	      var cssValueWithoutImportantFlag = indexOfImportantFlag > -1 ? cssValue.substr(0, indexOfImportantFlag - 1) : cssValue;
	      cssRule.style.setProperty(prop, cssValueWithoutImportantFlag, indexOfImportantFlag > -1 ? 'important' : '');
	    }
	  } catch (err) {
	    // IE may throw if property is unknown.
	    return false;
	  }
	
	  return true;
	};
	/**
	 * Remove a style property.
	 */
	
	
	var removeProperty = function removeProperty(cssRule, prop) {
	  try {
	    // Support CSSTOM.
	    if (cssRule.attributeStyleMap) {
	      cssRule.attributeStyleMap.delete(prop);
	    } else {
	      cssRule.style.removeProperty(prop);
	    }
	  } catch (err) {
	     false ? warning__default['default'](false, "[JSS] DOMException \"" + err.message + "\" was thrown. Tried to remove property \"" + prop + "\".") : void 0;
	  }
	};
	/**
	 * Set the selector.
	 */
	
	
	var setSelector = function setSelector(cssRule, selectorText) {
	  cssRule.selectorText = selectorText; // Return false if setter was not successful.
	  // Currently works in chrome only.
	
	  return cssRule.selectorText === selectorText;
	};
	/**
	 * Gets the `head` element upon the first call and caches it.
	 * We assume it can't be null.
	 */
	
	
	var getHead = memoize(function () {
	  return document.querySelector('head');
	});
	/**
	 * Find attached sheet with an index higher than the passed one.
	 */
	
	function findHigherSheet(registry, options) {
	  for (var i = 0; i < registry.length; i++) {
	    var sheet = registry[i];
	
	    if (sheet.attached && sheet.options.index > options.index && sheet.options.insertionPoint === options.insertionPoint) {
	      return sheet;
	    }
	  }
	
	  return null;
	}
	/**
	 * Find attached sheet with the highest index.
	 */
	
	
	function findHighestSheet(registry, options) {
	  for (var i = registry.length - 1; i >= 0; i--) {
	    var sheet = registry[i];
	
	    if (sheet.attached && sheet.options.insertionPoint === options.insertionPoint) {
	      return sheet;
	    }
	  }
	
	  return null;
	}
	/**
	 * Find a comment with "jss" inside.
	 */
	
	
	function findCommentNode(text) {
	  var head = getHead();
	
	  for (var i = 0; i < head.childNodes.length; i++) {
	    var node = head.childNodes[i];
	
	    if (node.nodeType === 8 && node.nodeValue.trim() === text) {
	      return node;
	    }
	  }
	
	  return null;
	}
	/**
	 * Find a node before which we can insert the sheet.
	 */
	
	
	function findPrevNode(options) {
	  var registry = sheets.registry;
	
	  if (registry.length > 0) {
	    // Try to insert before the next higher sheet.
	    var sheet = findHigherSheet(registry, options);
	
	    if (sheet && sheet.renderer) {
	      return {
	        parent: sheet.renderer.element.parentNode,
	        node: sheet.renderer.element
	      };
	    } // Otherwise insert after the last attached.
	
	
	    sheet = findHighestSheet(registry, options);
	
	    if (sheet && sheet.renderer) {
	      return {
	        parent: sheet.renderer.element.parentNode,
	        node: sheet.renderer.element.nextSibling
	      };
	    }
	  } // Try to find a comment placeholder if registry is empty.
	
	
	  var insertionPoint = options.insertionPoint;
	
	  if (insertionPoint && typeof insertionPoint === 'string') {
	    var comment = findCommentNode(insertionPoint);
	
	    if (comment) {
	      return {
	        parent: comment.parentNode,
	        node: comment.nextSibling
	      };
	    } // If user specifies an insertion point and it can't be found in the document -
	    // bad specificity issues may appear.
	
	
	     false ? warning__default['default'](false, "[JSS] Insertion point \"" + insertionPoint + "\" not found.") : void 0;
	  }
	
	  return false;
	}
	/**
	 * Insert style element into the DOM.
	 */
	
	
	function insertStyle(style, options) {
	  var insertionPoint = options.insertionPoint;
	  var nextNode = findPrevNode(options);
	
	  if (nextNode !== false && nextNode.parent) {
	    nextNode.parent.insertBefore(style, nextNode.node);
	    return;
	  } // Works with iframes and any node types.
	
	
	  if (insertionPoint && typeof insertionPoint.nodeType === 'number') {
	    var insertionPointElement = insertionPoint;
	    var parentNode = insertionPointElement.parentNode;
	    if (parentNode) parentNode.insertBefore(style, insertionPointElement.nextSibling);else  false ? warning__default['default'](false, '[JSS] Insertion point is not in the DOM.') : void 0;
	    return;
	  }
	
	  getHead().appendChild(style);
	}
	/**
	 * Read jss nonce setting from the page if the user has set it.
	 */
	
	
	var getNonce = memoize(function () {
	  var node = document.querySelector('meta[property="csp-nonce"]');
	  return node ? node.getAttribute('content') : null;
	});
	
	var _insertRule = function insertRule(container, rule, index) {
	  try {
	    if ('insertRule' in container) {
	      container.insertRule(rule, index);
	    } // Keyframes rule.
	    else if ('appendRule' in container) {
	        container.appendRule(rule);
	      }
	  } catch (err) {
	     false ? warning__default['default'](false, "[JSS] " + err.message) : void 0;
	    return false;
	  }
	
	  return container.cssRules[index];
	};
	
	var getValidRuleInsertionIndex = function getValidRuleInsertionIndex(container, index) {
	  var maxIndex = container.cssRules.length; // In case previous insertion fails, passed index might be wrong
	
	  if (index === undefined || index > maxIndex) {
	    // eslint-disable-next-line no-param-reassign
	    return maxIndex;
	  }
	
	  return index;
	};
	
	var createStyle = function createStyle() {
	  var el = document.createElement('style'); // Without it, IE will have a broken source order specificity if we
	  // insert rules after we insert the style tag.
	  // It seems to kick-off the source order specificity algorithm.
	
	  el.textContent = '\n';
	  return el;
	};
	
	var DomRenderer =
	/*#__PURE__*/
	function () {
	  // Will be empty if link: true option is not set, because
	  // it is only for use together with insertRule API.
	  function DomRenderer(sheet) {
	    this.getPropertyValue = getPropertyValue;
	    this.setProperty = setProperty;
	    this.removeProperty = removeProperty;
	    this.setSelector = setSelector;
	    this.hasInsertedRules = false;
	    this.cssRules = [];
	    // There is no sheet when the renderer is used from a standalone StyleRule.
	    if (sheet) sheets.add(sheet);
	    this.sheet = sheet;
	
	    var _ref = this.sheet ? this.sheet.options : {},
	        media = _ref.media,
	        meta = _ref.meta,
	        element = _ref.element;
	
	    this.element = element || createStyle();
	    this.element.setAttribute('data-jss', '');
	    if (media) this.element.setAttribute('media', media);
	    if (meta) this.element.setAttribute('data-meta', meta);
	    var nonce = getNonce();
	    if (nonce) this.element.setAttribute('nonce', nonce);
	  }
	  /**
	   * Insert style element into render tree.
	   */
	
	
	  var _proto = DomRenderer.prototype;
	
	  _proto.attach = function attach() {
	    // In the case the element node is external and it is already in the DOM.
	    if (this.element.parentNode || !this.sheet) return;
	    insertStyle(this.element, this.sheet.options); // When rules are inserted using `insertRule` API, after `sheet.detach().attach()`
	    // most browsers create a new CSSStyleSheet, except of all IEs.
	
	    var deployed = Boolean(this.sheet && this.sheet.deployed);
	
	    if (this.hasInsertedRules && deployed) {
	      this.hasInsertedRules = false;
	      this.deploy();
	    }
	  }
	  /**
	   * Remove style element from render tree.
	   */
	  ;
	
	  _proto.detach = function detach() {
	    if (!this.sheet) return;
	    var parentNode = this.element.parentNode;
	    if (parentNode) parentNode.removeChild(this.element); // In the most browsers, rules inserted using insertRule() API will be lost when style element is removed.
	    // Though IE will keep them and we need a consistent behavior.
	
	    if (this.sheet.options.link) {
	      this.cssRules = [];
	      this.element.textContent = '\n';
	    }
	  }
	  /**
	   * Inject CSS string into element.
	   */
	  ;
	
	  _proto.deploy = function deploy() {
	    var sheet = this.sheet;
	    if (!sheet) return;
	
	    if (sheet.options.link) {
	      this.insertRules(sheet.rules);
	      return;
	    }
	
	    this.element.textContent = "\n" + sheet.toString() + "\n";
	  }
	  /**
	   * Insert RuleList into an element.
	   */
	  ;
	
	  _proto.insertRules = function insertRules(rules, nativeParent) {
	    for (var i = 0; i < rules.index.length; i++) {
	      this.insertRule(rules.index[i], i, nativeParent);
	    }
	  }
	  /**
	   * Insert a rule into element.
	   */
	  ;
	
	  _proto.insertRule = function insertRule(rule, index, nativeParent) {
	    if (nativeParent === void 0) {
	      nativeParent = this.element.sheet;
	    }
	
	    if (rule.rules) {
	      var parent = rule;
	      var latestNativeParent = nativeParent;
	
	      if (rule.type === 'conditional' || rule.type === 'keyframes') {
	        var _insertionIndex = getValidRuleInsertionIndex(nativeParent, index); // We need to render the container without children first.
	
	
	        latestNativeParent = _insertRule(nativeParent, parent.toString({
	          children: false
	        }), _insertionIndex);
	
	        if (latestNativeParent === false) {
	          return false;
	        }
	
	        this.refCssRule(rule, _insertionIndex, latestNativeParent);
	      }
	
	      this.insertRules(parent.rules, latestNativeParent);
	      return latestNativeParent;
	    }
	
	    var ruleStr = rule.toString();
	    if (!ruleStr) return false;
	    var insertionIndex = getValidRuleInsertionIndex(nativeParent, index);
	
	    var nativeRule = _insertRule(nativeParent, ruleStr, insertionIndex);
	
	    if (nativeRule === false) {
	      return false;
	    }
	
	    this.hasInsertedRules = true;
	    this.refCssRule(rule, insertionIndex, nativeRule);
	    return nativeRule;
	  };
	
	  _proto.refCssRule = function refCssRule(rule, index, cssRule) {
	    rule.renderable = cssRule; // We only want to reference the top level rules, deleteRule API doesn't support removing nested rules
	    // like rules inside media queries or keyframes
	
	    if (rule.options.parent instanceof StyleSheet) {
	      this.cssRules.splice(index, 0, cssRule);
	    }
	  }
	  /**
	   * Delete a rule.
	   */
	  ;
	
	  _proto.deleteRule = function deleteRule(cssRule) {
	    var sheet = this.element.sheet;
	    var index = this.indexOf(cssRule);
	    if (index === -1) return false;
	    sheet.deleteRule(index);
	    this.cssRules.splice(index, 1);
	    return true;
	  }
	  /**
	   * Get index of a CSS Rule.
	   */
	  ;
	
	  _proto.indexOf = function indexOf(cssRule) {
	    return this.cssRules.indexOf(cssRule);
	  }
	  /**
	   * Generate a new CSS rule and replace the existing one.
	   */
	  ;
	
	  _proto.replaceRule = function replaceRule(cssRule, rule) {
	    var index = this.indexOf(cssRule);
	    if (index === -1) return false;
	    this.element.sheet.deleteRule(index);
	    this.cssRules.splice(index, 1);
	    return this.insertRule(rule, index);
	  }
	  /**
	   * Get all rules elements.
	   */
	  ;
	
	  _proto.getRules = function getRules() {
	    return this.element.sheet.cssRules;
	  };
	
	  return DomRenderer;
	}();
	
	var instanceCounter = 0;
	
	var Jss =
	/*#__PURE__*/
	function () {
	  function Jss(options) {
	    this.id = instanceCounter++;
	    this.version = "10.10.0";
	    this.plugins = new PluginsRegistry();
	    this.options = {
	      id: {
	        minify: false
	      },
	      createGenerateId: createGenerateId,
	      Renderer: isInBrowser__default['default'] ? DomRenderer : null,
	      plugins: []
	    };
	    this.generateId = createGenerateId({
	      minify: false
	    });
	
	    for (var i = 0; i < plugins.length; i++) {
	      this.plugins.use(plugins[i], {
	        queue: 'internal'
	      });
	    }
	
	    this.setup(options);
	  }
	  /**
	   * Prepares various options, applies plugins.
	   * Should not be used twice on the same instance, because there is no plugins
	   * deduplication logic.
	   */
	
	
	  var _proto = Jss.prototype;
	
	  _proto.setup = function setup(options) {
	    if (options === void 0) {
	      options = {};
	    }
	
	    if (options.createGenerateId) {
	      this.options.createGenerateId = options.createGenerateId;
	    }
	
	    if (options.id) {
	      this.options.id = _extends__default['default']({}, this.options.id, options.id);
	    }
	
	    if (options.createGenerateId || options.id) {
	      this.generateId = this.options.createGenerateId(this.options.id);
	    }
	
	    if (options.insertionPoint != null) this.options.insertionPoint = options.insertionPoint;
	
	    if ('Renderer' in options) {
	      this.options.Renderer = options.Renderer;
	    } // eslint-disable-next-line prefer-spread
	
	
	    if (options.plugins) this.use.apply(this, options.plugins);
	    return this;
	  }
	  /**
	   * Create a Style Sheet.
	   */
	  ;
	
	  _proto.createStyleSheet = function createStyleSheet(styles, options) {
	    if (options === void 0) {
	      options = {};
	    }
	
	    var _options = options,
	        index = _options.index;
	
	    if (typeof index !== 'number') {
	      index = sheets.index === 0 ? 0 : sheets.index + 1;
	    }
	
	    var sheet = new StyleSheet(styles, _extends__default['default']({}, options, {
	      jss: this,
	      generateId: options.generateId || this.generateId,
	      insertionPoint: this.options.insertionPoint,
	      Renderer: this.options.Renderer,
	      index: index
	    }));
	    this.plugins.onProcessSheet(sheet);
	    return sheet;
	  }
	  /**
	   * Detach the Style Sheet and remove it from the registry.
	   */
	  ;
	
	  _proto.removeStyleSheet = function removeStyleSheet(sheet) {
	    sheet.detach();
	    sheets.remove(sheet);
	    return this;
	  }
	  /**
	   * Create a rule without a Style Sheet.
	   * [Deprecated] will be removed in the next major version.
	   */
	  ;
	
	  _proto.createRule = function createRule$1(name, style, options) {
	    if (style === void 0) {
	      style = {};
	    }
	
	    if (options === void 0) {
	      options = {};
	    }
	
	    // Enable rule without name for inline styles.
	    if (typeof name === 'object') {
	      return this.createRule(undefined, name, style);
	    }
	
	    var ruleOptions = _extends__default['default']({}, options, {
	      name: name,
	      jss: this,
	      Renderer: this.options.Renderer
	    });
	
	    if (!ruleOptions.generateId) ruleOptions.generateId = this.generateId;
	    if (!ruleOptions.classes) ruleOptions.classes = {};
	    if (!ruleOptions.keyframes) ruleOptions.keyframes = {};
	
	    var rule = createRule(name, style, ruleOptions);
	
	    if (rule) this.plugins.onProcessRule(rule);
	    return rule;
	  }
	  /**
	   * Register plugin. Passed function will be invoked with a rule instance.
	   */
	  ;
	
	  _proto.use = function use() {
	    var _this = this;
	
	    for (var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++) {
	      plugins[_key] = arguments[_key];
	    }
	
	    plugins.forEach(function (plugin) {
	      _this.plugins.use(plugin);
	    });
	    return this;
	  };
	
	  return Jss;
	}();
	
	var createJss = function createJss(options) {
	  return new Jss(options);
	};
	
	/**
	 * SheetsManager is like a WeakMap which is designed to count StyleSheet
	 * instances and attach/detach automatically.
	 * Used in react-jss.
	 */
	
	var SheetsManager =
	/*#__PURE__*/
	function () {
	  function SheetsManager() {
	    this.length = 0;
	    this.sheets = new WeakMap();
	  }
	
	  var _proto = SheetsManager.prototype;
	
	  _proto.get = function get(key) {
	    var entry = this.sheets.get(key);
	    return entry && entry.sheet;
	  };
	
	  _proto.add = function add(key, sheet) {
	    if (this.sheets.has(key)) return;
	    this.length++;
	    this.sheets.set(key, {
	      sheet: sheet,
	      refs: 0
	    });
	  };
	
	  _proto.manage = function manage(key) {
	    var entry = this.sheets.get(key);
	
	    if (entry) {
	      if (entry.refs === 0) {
	        entry.sheet.attach();
	      }
	
	      entry.refs++;
	      return entry.sheet;
	    }
	
	    warning__default['default'](false, "[JSS] SheetsManager: can't find sheet to manage");
	    return undefined;
	  };
	
	  _proto.unmanage = function unmanage(key) {
	    var entry = this.sheets.get(key);
	
	    if (entry) {
	      if (entry.refs > 0) {
	        entry.refs--;
	        if (entry.refs === 0) entry.sheet.detach();
	      }
	    } else {
	      warning__default['default'](false, "SheetsManager: can't find sheet to unmanage");
	    }
	  };
	
	  _createClass__default['default'](SheetsManager, [{
	    key: "size",
	    get: function get() {
	      return this.length;
	    }
	  }]);
	
	  return SheetsManager;
	}();
	
	/**
	* Export a constant indicating if this browser has CSSTOM support.
	* https://developers.google.com/web/updates/2018/03/cssom
	*/
	var hasCSSTOMSupport = typeof CSS === 'object' && CSS != null && 'number' in CSS;
	
	/**
	 * Extracts a styles object with only props that contain function values.
	 */
	function getDynamicStyles(styles) {
	  var to = null;
	
	  for (var key in styles) {
	    var value = styles[key];
	    var type = typeof value;
	
	    if (type === 'function') {
	      if (!to) to = {};
	      to[key] = value;
	    } else if (type === 'object' && value !== null && !Array.isArray(value)) {
	      var extracted = getDynamicStyles(value);
	
	      if (extracted) {
	        if (!to) to = {};
	        to[key] = extracted;
	      }
	    }
	  }
	
	  return to;
	}
	
	/**
	 * A better abstraction over CSS.
	 *
	 * @copyright Oleg Isonen (Slobodskoi) / Isonen 2014-present
	 * @website https://github.com/cssinjs/jss
	 * @license MIT
	 */
	var index = createJss();
	
	exports.RuleList = RuleList;
	exports.SheetsManager = SheetsManager;
	exports.SheetsRegistry = SheetsRegistry;
	exports.create = createJss;
	exports.createGenerateId = createGenerateId;
	exports.createRule = createRule;
	exports.default = index;
	exports.getDynamicStyles = getDynamicStyles;
	exports.hasCSSTOMSupport = hasCSSTOMSupport;
	exports.sheets = sheets;
	exports.toCssValue = toCssValue;


/***/ },
/* 111 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(1374);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  thousandSeparator: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.oneOf([true])]),
	  thousandSpacing: _propTypes2.default.oneOf(['2', '2s', '3', '4']),
	  decimalSeparator: _propTypes2.default.string,
	  decimalScale: _propTypes2.default.number,
	  fixedDecimalScale: _propTypes2.default.bool,
	  displayType: _propTypes2.default.oneOf(['input', 'text']),
	  prefix: _propTypes2.default.string,
	  suffix: _propTypes2.default.string,
	  format: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
	  removeFormatting: _propTypes2.default.func,
	  mask: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]),
	  value: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  isNumericString: _propTypes2.default.bool,
	  customInput: _propTypes2.default.func,
	  allowNegative: _propTypes2.default.bool,
	  onValueChange: _propTypes2.default.func,
	  onKeyDown: _propTypes2.default.func,
	  onMouseUp: _propTypes2.default.func,
	  onChange: _propTypes2.default.func,
	  onFocus: _propTypes2.default.func,
	  onBlur: _propTypes2.default.func,
	  type: _propTypes2.default.oneOf(['text', 'tel']),
	  isAllowed: _propTypes2.default.func,
	  renderText: _propTypes2.default.func
	};
	
	var defaultProps = {
	  displayType: 'input',
	  decimalSeparator: '.',
	  thousandSpacing: '3',
	  fixedDecimalScale: false,
	  prefix: '',
	  suffix: '',
	  allowNegative: true,
	  isNumericString: false,
	  type: 'text',
	  onValueChange: _utils.noop,
	  onChange: _utils.noop,
	  onKeyDown: _utils.noop,
	  onMouseUp: _utils.noop,
	  onFocus: _utils.noop,
	  onBlur: _utils.noop,
	  isAllowed: _utils.returnTrue
	};
	
	var CurrencyFormat = function (_React$Component) {
	  _inherits(CurrencyFormat, _React$Component);
	
	  function CurrencyFormat(props) {
	    _classCallCheck(this, CurrencyFormat);
	
	    //validate props
	    var _this = _possibleConstructorReturn(this, (CurrencyFormat.__proto__ || Object.getPrototypeOf(CurrencyFormat)).call(this, props));
	
	    _this.validateProps();
	
	    var formattedValue = _this.formatValueProp();
	
	    _this.state = {
	      value: formattedValue,
	      numAsString: _this.removeFormatting(formattedValue)
	    };
	
	    _this.onChange = _this.onChange.bind(_this);
	    _this.onKeyDown = _this.onKeyDown.bind(_this);
	    _this.onMouseUp = _this.onMouseUp.bind(_this);
	    _this.onFocus = _this.onFocus.bind(_this);
	    _this.onBlur = _this.onBlur.bind(_this);
	    return _this;
	  }
	
	  _createClass(CurrencyFormat, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      this.updateValueIfRequired(prevProps);
	    }
	  }, {
	    key: 'updateValueIfRequired',
	    value: function updateValueIfRequired(prevProps) {
	      var props = this.props,
	          state = this.state;
	
	
	      if (prevProps !== props) {
	        //validate props
	        this.validateProps();
	
	        var stateValue = state.value;
	
	        var lastNumStr = state.numAsString || '';
	
	        var formattedValue = props.value === undefined ? this.formatNumString(lastNumStr) : this.formatValueProp();
	
	        if (formattedValue !== stateValue) {
	          this.setState({
	            value: formattedValue,
	            numAsString: this.removeFormatting(formattedValue)
	          });
	        }
	      }
	    }
	
	    /** Misc methods **/
	
	  }, {
	    key: 'getFloatString',
	    value: function getFloatString() {
	      var num = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	      var _getSeparators = this.getSeparators(),
	          decimalSeparator = _getSeparators.decimalSeparator;
	
	      var numRegex = this.getNumberRegex(true);
	
	      //remove negation for regex check
	      var hasNegation = num[0] === '-';
	      if (hasNegation) num = num.replace('-', '');
	
	      num = (num.match(numRegex) || []).join('').replace(decimalSeparator, '.');
	
	      //remove extra decimals
	      var firstDecimalIndex = num.indexOf('.');
	
	      if (firstDecimalIndex !== -1) {
	        num = num.substring(0, firstDecimalIndex) + '.' + num.substring(firstDecimalIndex + 1, num.length).replace(new RegExp((0, _utils.escapeRegExp)(decimalSeparator), 'g'), '');
	      }
	
	      //add negation back
	      if (hasNegation) num = '-' + num;
	
	      return num;
	    }
	
	    //returned regex assumes decimalSeparator is as per prop
	
	  }, {
	    key: 'getNumberRegex',
	    value: function getNumberRegex(g, ignoreDecimalSeparator) {
	      var _props = this.props,
	          format = _props.format,
	          decimalScale = _props.decimalScale;
	
	      var _getSeparators2 = this.getSeparators(),
	          decimalSeparator = _getSeparators2.decimalSeparator;
	
	      return new RegExp('\\d' + (decimalSeparator && decimalScale !== 0 && !ignoreDecimalSeparator && !format ? '|' + (0, _utils.escapeRegExp)(decimalSeparator) : ''), g ? 'g' : undefined);
	    }
	  }, {
	    key: 'getSeparators',
	    value: function getSeparators() {
	      var _props2 = this.props,
	          decimalSeparator = _props2.decimalSeparator,
	          thousandSpacing = _props2.thousandSpacing;
	      var thousandSeparator = this.props.thousandSeparator;
	
	
	      if (thousandSeparator === true) {
	        thousandSeparator = ',';
	      }
	
	      return {
	        decimalSeparator: decimalSeparator,
	        thousandSeparator: thousandSeparator,
	        thousandSpacing: thousandSpacing
	      };
	    }
	  }, {
	    key: 'getMaskAtIndex',
	    value: function getMaskAtIndex(index) {
	      var _props$mask = this.props.mask,
	          mask = _props$mask === undefined ? ' ' : _props$mask;
	
	      if (typeof mask === 'string') {
	        return mask;
	      }
	
	      return mask[index] || ' ';
	    }
	  }, {
	    key: 'validateProps',
	    value: function validateProps() {
	      var mask = this.props.mask;
	
	      //validate decimalSeparator and thousandSeparator
	
	      var _getSeparators3 = this.getSeparators(),
	          decimalSeparator = _getSeparators3.decimalSeparator,
	          thousandSeparator = _getSeparators3.thousandSeparator;
	
	      if (decimalSeparator === thousandSeparator) {
	        throw new Error('\n          Decimal separator can\'t be same as thousand separator.\n\n          thousandSeparator: ' + thousandSeparator + ' (thousandSeparator = {true} is same as thousandSeparator = ",")\n          decimalSeparator: ' + decimalSeparator + ' (default value for decimalSeparator is .)\n       ');
	      }
	
	      //validate mask
	      if (mask) {
	        var maskAsStr = mask === 'string' ? mask : mask.toString();
	        if (maskAsStr.match(/\d/g)) {
	          throw new Error('\n          Mask ' + mask + ' should not contain numeric character;\n        ');
	        }
	      }
	    }
	  }, {
	    key: 'splitDecimal',
	    value: function splitDecimal(numStr) {
	      var allowNegative = this.props.allowNegative;
	
	      var hasNagation = numStr[0] === '-';
	      var addNegation = hasNagation && allowNegative;
	      numStr = numStr.replace('-', '');
	
	      var parts = numStr.split('.');
	      var beforeDecimal = parts[0];
	      var afterDecimal = parts[1] || '';
	
	      return {
	        beforeDecimal: beforeDecimal,
	        afterDecimal: afterDecimal,
	        hasNagation: hasNagation,
	        addNegation: addNegation
	      };
	    }
	
	    /** Misc methods end **/
	
	    /** caret specific methods **/
	
	  }, {
	    key: 'setPatchedCaretPosition',
	    value: function setPatchedCaretPosition(el, caretPos, currentValue) {
	      /* setting caret position within timeout of 0ms is required for mobile chrome,
	      otherwise browser resets the caret position after we set it
	      We are also setting it without timeout so that in normal browser we don't see the flickering */
	      (0, _utils.setCaretPosition)(el, caretPos);
	      setTimeout(function () {
	        if (el.value === currentValue) (0, _utils.setCaretPosition)(el, caretPos);
	      }, 0);
	    }
	
	    /* This keeps the caret within typing area so people can't type in between prefix or suffix */
	
	  }, {
	    key: 'correctCaretPosition',
	    value: function correctCaretPosition(value, caretPos, direction) {
	      var _props3 = this.props,
	          prefix = _props3.prefix,
	          suffix = _props3.suffix,
	          format = _props3.format;
	
	      //in case of format as number limit between prefix and suffix
	
	      if (!format) {
	        var hasNegation = value[0] === '-';
	        return Math.min(Math.max(caretPos, prefix.length + (hasNegation ? 1 : 0)), value.length - suffix.length);
	      }
	
	      //in case if custom format method don't do anything
	      if (typeof format === 'function') return caretPos;
	
	      /* in case format is string find the closest # position from the caret position */
	
	      //in case the caretPos have input value on it don't do anything
	      if (format[caretPos] === '#' && (0, _utils.charIsNumber)(value[caretPos])) return caretPos;
	
	      //if caretPos is just after input value don't do anything
	      if (format[caretPos - 1] === '#' && (0, _utils.charIsNumber)(value[caretPos - 1])) return caretPos;
	
	      //find the nearest caret position
	      var firstHashPosition = format.indexOf('#');
	      var lastHashPosition = format.lastIndexOf('#');
	
	      //limit the cursor between the first # position and the last # position
	      caretPos = Math.min(Math.max(caretPos, firstHashPosition), lastHashPosition + 1);
	
	      var nextPos = format.substring(caretPos, format.length).indexOf('#');
	      var caretLeftBound = caretPos;
	      var caretRightBoud = caretPos + (nextPos === -1 ? 0 : nextPos);
	
	      //get the position where the last number is present
	      while (caretLeftBound > firstHashPosition && (format[caretLeftBound] !== '#' || !(0, _utils.charIsNumber)(value[caretLeftBound]))) {
	        caretLeftBound -= 1;
	      }
	
	      var goToLeft = !(0, _utils.charIsNumber)(value[caretRightBoud]) || direction === 'left' && caretPos !== firstHashPosition || caretPos - caretLeftBound < caretRightBoud - caretPos;
	
	      return goToLeft ? caretLeftBound + 1 : caretRightBoud;
	    }
	  }, {
	    key: 'getCaretPosition',
	    value: function getCaretPosition(inputValue, formattedValue, caretPos) {
	      var format = this.props.format;
	
	      var stateValue = this.state.value;
	      var numRegex = this.getNumberRegex(true);
	      var inputNumber = (inputValue.match(numRegex) || []).join('');
	      var formattedNumber = (formattedValue.match(numRegex) || []).join('');
	      var j = void 0,
	          i = void 0;
	
	      j = 0;
	
	      for (i = 0; i < caretPos; i++) {
	        var currentInputChar = inputValue[i] || '';
	        var currentFormatChar = formattedValue[j] || '';
	        //no need to increase new cursor position if formatted value does not have those characters
	        //case inputValue = 1a23 and formattedValue =  123
	        if (!currentInputChar.match(numRegex) && currentInputChar !== currentFormatChar) continue;
	
	        //When we are striping out leading zeros maintain the new cursor position
	        //Case inputValue = 00023 and formattedValue = 23;
	        if (currentInputChar === '0' && currentFormatChar.match(numRegex) && currentFormatChar !== '0' && inputNumber.length !== formattedNumber.length) continue;
	
	        //we are not using currentFormatChar because j can change here
	        while (currentInputChar !== formattedValue[j] && j < formattedValue.length) {
	          j++;
	        }j++;
	      }
	
	      if (typeof format === 'string' && !stateValue) {
	        //set it to the maximum value so it goes after the last number
	        j = formattedValue.length;
	      }
	
	      //correct caret position if its outside of editable area
	      j = this.correctCaretPosition(formattedValue, j);
	
	      return j;
	    }
	    /** caret specific methods ends **/
	
	    /** methods to remove formattting **/
	
	  }, {
	    key: 'removePrefixAndSuffix',
	    value: function removePrefixAndSuffix(val) {
	      var _props4 = this.props,
	          format = _props4.format,
	          prefix = _props4.prefix,
	          suffix = _props4.suffix;
	
	      //remove prefix and suffix
	
	      if (!format && val) {
	        var isNegative = val[0] === '-';
	
	        //remove negation sign
	        if (isNegative) val = val.substring(1, val.length);
	
	        //remove prefix
	        val = prefix && val.indexOf(prefix) === 0 ? val.substring(prefix.length, val.length) : val;
	
	        //remove suffix
	        var suffixLastIndex = val.lastIndexOf(suffix);
	        val = suffix && suffixLastIndex !== -1 && suffixLastIndex === val.length - suffix.length ? val.substring(0, suffixLastIndex) : val;
	
	        //add negation sign back
	        if (isNegative) val = '-' + val;
	      }
	
	      return val;
	    }
	  }, {
	    key: 'removePatternFormatting',
	    value: function removePatternFormatting(val) {
	      var format = this.props.format;
	
	      var formatArray = format.split('#').filter(function (str) {
	        return str !== '';
	      });
	      var start = 0;
	      var numStr = '';
	
	      for (var i = 0, ln = formatArray.length; i <= ln; i++) {
	        var part = formatArray[i] || '';
	
	        //if i is the last fragment take the index of end of the value
	        //For case like +1 (911) 911 91 91 having pattern +1 (###) ### ## ##
	        var index = i === ln ? val.length : val.indexOf(part, start);
	
	        /* in any case if we don't find the pattern part in the value assume the val as numeric string
	        This will be also in case if user has started typing, in any other case it will not be -1
	        unless wrong prop value is provided */
	        if (index === -1) {
	          numStr = val;
	          break;
	        } else {
	          numStr += val.substring(start, index);
	          start = index + part.length;
	        }
	      }
	
	      return (numStr.match(/\d/g) || []).join('');
	    }
	  }, {
	    key: 'removeFormatting',
	    value: function removeFormatting(val) {
	      var _props5 = this.props,
	          format = _props5.format,
	          removeFormatting = _props5.removeFormatting;
	
	      if (!val) return val;
	
	      if (!format) {
	        val = this.removePrefixAndSuffix(val);
	        val = this.getFloatString(val);
	      } else if (typeof format === 'string') {
	        val = this.removePatternFormatting(val);
	      } else if (typeof removeFormatting === 'function') {
	        //condition need to be handled if format method is provide,
	        val = removeFormatting(val);
	      } else {
	        val = (val.match(/\d/g) || []).join('');
	      }
	      return val;
	    }
	    /** methods to remove formattting end **/
	
	    /*** format specific methods start ***/
	    /**
	     * Format when # based string is provided
	     * @param  {string} numStr Numeric String
	     * @return {string}        formatted Value
	     */
	
	  }, {
	    key: 'formatWithPattern',
	    value: function formatWithPattern(numStr) {
	      var format = this.props.format;
	
	      var hashCount = 0;
	      var formattedNumberAry = format.split('');
	      for (var i = 0, ln = format.length; i < ln; i++) {
	        if (format[i] === '#') {
	          formattedNumberAry[i] = numStr[hashCount] || this.getMaskAtIndex(hashCount);
	          hashCount += 1;
	        }
	      }
	      return formattedNumberAry.join('');
	    }
	    /**
	     * Format the given string according to thousand separator and thousand spacing
	     * @param {*} beforeDecimal 
	     * @param {*} thousandSeparator 
	     * @param {*} thousandSpacing 
	     */
	
	  }, {
	    key: 'formatThousand',
	    value: function formatThousand(beforeDecimal, thousandSeparator, thousandSpacing) {
	      var digitalGroup = void 0;
	      switch (thousandSpacing) {
	        case _utils.thousandGroupSpacing.two:
	          digitalGroup = /(\d)(?=(\d{2})+(?!\d))/g;
	          break;
	        case _utils.thousandGroupSpacing.twoScaled:
	          digitalGroup = /(\d)(?=(((\d{2})+)(\d{1})(?!\d)))/g;
	          break;
	        case _utils.thousandGroupSpacing.four:
	          digitalGroup = /(\d)(?=(\d{4})+(?!\d))/g;
	          break;
	        default:
	          digitalGroup = /(\d)(?=(\d{3})+(?!\d))/g;
	      }
	
	      return beforeDecimal.replace(digitalGroup, '$1' + thousandSeparator);
	    }
	    /**
	     * @param  {string} numStr Numeric string/floatString] It always have decimalSeparator as .
	     * @return {string} formatted Value
	     */
	
	  }, {
	    key: 'formatAsNumber',
	    value: function formatAsNumber(numStr) {
	      var _props6 = this.props,
	          decimalScale = _props6.decimalScale,
	          fixedDecimalScale = _props6.fixedDecimalScale,
	          prefix = _props6.prefix,
	          suffix = _props6.suffix;
	
	      var _getSeparators4 = this.getSeparators(),
	          thousandSeparator = _getSeparators4.thousandSeparator,
	          decimalSeparator = _getSeparators4.decimalSeparator,
	          thousandSpacing = _getSeparators4.thousandSpacing;
	
	      var hasDecimalSeparator = numStr.indexOf('.') !== -1 || decimalScale && fixedDecimalScale;
	
	      var _splitDecimal = this.splitDecimal(numStr),
	          beforeDecimal = _splitDecimal.beforeDecimal,
	          afterDecimal = _splitDecimal.afterDecimal,
	          addNegation = _splitDecimal.addNegation; // eslint-disable-line prefer-const
	
	      //apply decimal precision if its defined
	
	
	      if (decimalScale !== undefined) afterDecimal = (0, _utils.limitToScale)(afterDecimal, decimalScale, fixedDecimalScale);
	
	      if (thousandSeparator) {
	        beforeDecimal = this.formatThousand(beforeDecimal, thousandSeparator, thousandSpacing);
	      }
	
	      //add prefix and suffix
	      if (prefix) beforeDecimal = prefix + beforeDecimal;
	      if (suffix) afterDecimal = afterDecimal + suffix;
	
	      //restore negation sign
	      if (addNegation) beforeDecimal = '-' + beforeDecimal;
	
	      numStr = beforeDecimal + (hasDecimalSeparator && decimalSeparator || '') + afterDecimal;
	
	      return numStr;
	    }
	  }, {
	    key: 'formatNumString',
	    value: function formatNumString() {
	      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	      var format = this.props.format;
	
	      var formattedValue = value;
	
	      if (value === '') {
	        formattedValue = '';
	      } else if (value === '-' && !format) {
	        formattedValue = '-';
	        value = '';
	      } else if (typeof format === 'string') {
	        formattedValue = this.formatWithPattern(formattedValue);
	      } else if (typeof format === 'function') {
	        formattedValue = format(formattedValue);
	      } else {
	        formattedValue = this.formatAsNumber(formattedValue);
	      }
	
	      return formattedValue;
	    }
	  }, {
	    key: 'formatValueProp',
	    value: function formatValueProp() {
	      var _props7 = this.props,
	          format = _props7.format,
	          decimalScale = _props7.decimalScale,
	          fixedDecimalScale = _props7.fixedDecimalScale;
	      var _props8 = this.props,
	          value = _props8.value,
	          isNumericString = _props8.isNumericString;
	
	      // if value is not defined return empty string
	
	      if (value === undefined) return '';
	
	      if (typeof value === 'number') {
	        value = value.toString();
	        isNumericString = true;
	      }
	
	      //round the number based on decimalScale
	      //format only if non formatted value is provided
	      if (isNumericString && !format && typeof decimalScale === 'number') {
	        value = (0, _utils.roundToPrecision)(value, decimalScale, fixedDecimalScale);
	      }
	
	      var formattedValue = isNumericString ? this.formatNumString(value) : this.formatInput(value);
	
	      return formattedValue;
	    }
	  }, {
	    key: 'formatNegation',
	    value: function formatNegation() {
	      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	      var allowNegative = this.props.allowNegative;
	
	      var negationRegex = new RegExp('(-)');
	      var doubleNegationRegex = new RegExp('(-)(.)*(-)');
	
	      // Check number has '-' value
	      var hasNegation = negationRegex.test(value);
	
	      // Check number has 2 or more '-' values
	      var removeNegation = doubleNegationRegex.test(value);
	
	      //remove negation
	      value = value.replace(/-/g, '');
	
	      if (hasNegation && !removeNegation && allowNegative) {
	        value = '-' + value;
	      }
	
	      return value;
	    }
	  }, {
	    key: 'formatInput',
	    value: function formatInput() {
	      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	      var format = this.props.format;
	
	      //format negation only if we are formatting as number
	
	      if (!format) {
	        value = this.formatNegation(value);
	      }
	
	      //remove formatting from number
	      value = this.removeFormatting(value);
	
	      return this.formatNumString(value);
	    }
	
	    /*** format specific methods end ***/
	
	  }, {
	    key: 'isCharacterAFormat',
	    value: function isCharacterAFormat(caretPos, value) {
	      var _props9 = this.props,
	          format = _props9.format,
	          prefix = _props9.prefix,
	          suffix = _props9.suffix,
	          decimalScale = _props9.decimalScale,
	          fixedDecimalScale = _props9.fixedDecimalScale;
	
	      var _getSeparators5 = this.getSeparators(),
	          decimalSeparator = _getSeparators5.decimalSeparator;
	
	      //check within format pattern
	
	
	      if (typeof format === 'string' && format[caretPos] !== '#') return true;
	
	      //check in number format
	      if (!format && (caretPos < prefix.length || caretPos >= value.length - suffix.length || decimalScale && fixedDecimalScale && value[caretPos] === decimalSeparator)) {
	        return true;
	      }
	
	      return false;
	    }
	  }, {
	    key: 'checkIfFormatGotDeleted',
	    value: function checkIfFormatGotDeleted(start, end, value) {
	      for (var i = start; i < end; i++) {
	        if (this.isCharacterAFormat(i, value)) return true;
	      }
	      return false;
	    }
	
	    /**
	     * This will check if any formatting got removed by the delete or backspace and reset the value
	     * It will also work as fallback if android chome keyDown handler does not work
	     **/
	
	  }, {
	    key: 'correctInputValue',
	    value: function correctInputValue(caretPos, lastValue, value) {
	      var format = this.props.format;
	
	      var lastNumStr = this.state.numAsString || '';
	
	      //don't do anyhting if something got added, or if value is empty string (when whole input is cleared)
	      if (value.length >= lastValue.length || !value.length) {
	        return value;
	      }
	
	      var start = caretPos;
	      var lastValueParts = (0, _utils.splitString)(lastValue, caretPos);
	      var newValueParts = (0, _utils.splitString)(value, caretPos);
	      var deletedIndex = lastValueParts[1].lastIndexOf(newValueParts[1]);
	      var diff = deletedIndex !== -1 ? lastValueParts[1].substring(0, deletedIndex) : '';
	      var end = start + diff.length;
	
	      //if format got deleted reset the value to last value
	      if (this.checkIfFormatGotDeleted(start, end, lastValue)) {
	        value = lastValue;
	      }
	
	      //for numbers check if beforeDecimal got deleted and there is nothing after decimal,
	      //clear all numbers in such case while keeping the - sign
	      if (!format) {
	        var numericString = this.removeFormatting(value);
	
	        var _splitDecimal2 = this.splitDecimal(numericString),
	            beforeDecimal = _splitDecimal2.beforeDecimal,
	            afterDecimal = _splitDecimal2.afterDecimal,
	            addNegation = _splitDecimal2.addNegation; // eslint-disable-line prefer-const
	
	        //clear only if something got deleted
	
	
	        if (numericString.length < lastNumStr.length && beforeDecimal === '' && !parseFloat(afterDecimal)) {
	          return addNegation ? '-' : '';
	        }
	      }
	
	      return value;
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(e) {
	      e.persist();
	      var el = e.target;
	      var inputValue = el.value;
	      var state = this.state,
	          props = this.props;
	      var isAllowed = props.isAllowed;
	
	      var lastValue = state.value || '';
	
	      /*Max of selectionStart and selectionEnd is taken for the patch of pixel and other mobile device caret bug*/
	      var currentCaretPosition = Math.max(el.selectionStart, el.selectionEnd);
	
	      inputValue = this.correctInputValue(currentCaretPosition, lastValue, inputValue);
	
	      var formattedValue = this.formatInput(inputValue) || '';
	      var numAsString = this.removeFormatting(formattedValue);
	
	      var valueObj = {
	        formattedValue: formattedValue,
	        value: numAsString,
	        floatValue: parseFloat(numAsString)
	      };
	
	      if (!isAllowed(valueObj)) {
	        formattedValue = lastValue;
	      }
	
	      //set the value imperatively, this is required for IE fix
	      el.value = formattedValue;
	
	      //get the caret position
	      var caretPos = this.getCaretPosition(inputValue, formattedValue, currentCaretPosition);
	
	      //set caret position
	      this.setPatchedCaretPosition(el, caretPos, formattedValue);
	
	      //change the state
	      if (formattedValue !== lastValue) {
	        this.setState({ value: formattedValue, numAsString: numAsString }, function () {
	          props.onValueChange(valueObj);
	          props.onChange(e);
	        });
	      } else {
	        props.onChange(e);
	      }
	    }
	  }, {
	    key: 'onBlur',
	    value: function onBlur(e) {
	      var props = this.props,
	          state = this.state;
	      var format = props.format,
	          onBlur = props.onBlur;
	      var numAsString = state.numAsString;
	
	      var lastValue = state.value;
	      if (!format) {
	        numAsString = (0, _utils.fixLeadingZero)(numAsString);
	        var formattedValue = this.formatNumString(numAsString);
	        var valueObj = {
	          formattedValue: formattedValue,
	          value: numAsString,
	          floatValue: parseFloat(numAsString)
	        };
	
	        //change the state
	        if (formattedValue !== lastValue) {
	          // the event needs to be persisted because its properties can be accessed in an asynchronous way
	          e.persist();
	          this.setState({ value: formattedValue, numAsString: numAsString }, function () {
	            props.onValueChange(valueObj);
	            onBlur(e);
	          });
	          return;
	        }
	      }
	      onBlur(e);
	    }
	  }, {
	    key: 'onKeyDown',
	    value: function onKeyDown(e) {
	      var el = e.target;
	      var key = e.key;
	      var selectionEnd = el.selectionEnd,
	          value = el.value;
	      var selectionStart = el.selectionStart;
	
	      var expectedCaretPosition = void 0;
	      var _props10 = this.props,
	          decimalScale = _props10.decimalScale,
	          fixedDecimalScale = _props10.fixedDecimalScale,
	          prefix = _props10.prefix,
	          suffix = _props10.suffix,
	          format = _props10.format,
	          onKeyDown = _props10.onKeyDown;
	
	      var ignoreDecimalSeparator = decimalScale !== undefined && fixedDecimalScale;
	      var numRegex = this.getNumberRegex(false, ignoreDecimalSeparator);
	      var negativeRegex = new RegExp('-');
	      var isPatternFormat = typeof format === 'string';
	
	      //Handle backspace and delete against non numerical/decimal characters or arrow keys
	      if (key === 'ArrowLeft' || key === 'Backspace') {
	        expectedCaretPosition = selectionStart - 1;
	      } else if (key === 'ArrowRight') {
	        expectedCaretPosition = selectionStart + 1;
	      } else if (key === 'Delete') {
	        expectedCaretPosition = selectionStart;
	      }
	
	      //if expectedCaretPosition is not set it means we don't want to Handle keyDown
	      //also if multiple characters are selected don't handle
	      if (expectedCaretPosition === undefined || selectionStart !== selectionEnd) {
	        onKeyDown(e);
	        return;
	      }
	
	      var newCaretPosition = expectedCaretPosition;
	      var leftBound = isPatternFormat ? format.indexOf('#') : prefix.length;
	      var rightBound = isPatternFormat ? format.lastIndexOf('#') + 1 : value.length - suffix.length;
	
	      if (key === 'ArrowLeft' || key === 'ArrowRight') {
	        var direction = key === 'ArrowLeft' ? 'left' : 'right';
	        newCaretPosition = this.correctCaretPosition(value, expectedCaretPosition, direction);
	      } else if (key === 'Delete' && !numRegex.test(value[expectedCaretPosition]) && !negativeRegex.test(value[expectedCaretPosition])) {
	        while (!numRegex.test(value[newCaretPosition]) && newCaretPosition < rightBound) {
	          newCaretPosition++;
	        }
	      } else if (key === 'Backspace' && !numRegex.test(value[expectedCaretPosition]) && !negativeRegex.test(value[expectedCaretPosition])) {
	        while (!numRegex.test(value[newCaretPosition - 1]) && newCaretPosition > leftBound) {
	          newCaretPosition--;
	        }
	        newCaretPosition = this.correctCaretPosition(value, newCaretPosition, 'left');
	      }
	
	      if (newCaretPosition !== expectedCaretPosition || expectedCaretPosition < leftBound || expectedCaretPosition > rightBound) {
	        e.preventDefault();
	        this.setPatchedCaretPosition(el, newCaretPosition, value);
	      }
	
	      /* NOTE: this is just required for unit test as we need to get the newCaretPosition,
	              Remove this when you find different solution */
	      if (e.isUnitTestRun) {
	        this.setPatchedCaretPosition(el, newCaretPosition, value);
	      }
	
	      this.props.onKeyDown(e);
	    }
	
	    /** required to handle the caret position when click anywhere within the input **/
	
	  }, {
	    key: 'onMouseUp',
	    value: function onMouseUp(e) {
	      var el = e.target;
	      var selectionStart = el.selectionStart,
	          selectionEnd = el.selectionEnd,
	          value = el.value;
	
	
	      if (selectionStart === selectionEnd) {
	        var caretPostion = this.correctCaretPosition(value, selectionStart);
	        if (caretPostion !== selectionStart) {
	          this.setPatchedCaretPosition(el, caretPostion, value);
	        }
	      }
	
	      this.props.onMouseUp(e);
	    }
	  }, {
	    key: 'onFocus',
	    value: function onFocus(e) {
	      var _this2 = this;
	
	      // Workaround Chrome and Safari bug https://bugs.chromium.org/p/chromium/issues/detail?id=779328
	      // (onFocus event target selectionStart is always 0 before setTimeout)
	      e.persist();
	      setTimeout(function () {
	        var el = e.target;
	        var selectionStart = el.selectionStart,
	            value = el.value;
	
	
	        var caretPosition = _this2.correctCaretPosition(value, selectionStart);
	        if (caretPosition !== selectionStart) {
	          _this2.setPatchedCaretPosition(el, caretPosition, value);
	        }
	
	        _this2.props.onFocus(e);
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props11 = this.props,
	          type = _props11.type,
	          displayType = _props11.displayType,
	          customInput = _props11.customInput,
	          renderText = _props11.renderText;
	      var value = this.state.value;
	
	
	      var otherProps = (0, _utils.omit)(this.props, propTypes);
	
	      var inputProps = _extends({}, otherProps, {
	        type: type,
	        value: value,
	        onChange: this.onChange,
	        onKeyDown: this.onKeyDown,
	        onMouseUp: this.onMouseUp,
	        onFocus: this.onFocus,
	        onBlur: this.onBlur
	      });
	
	      if (displayType === 'text') {
	        return renderText ? renderText(value) || null : _react2.default.createElement(
	          'span',
	          otherProps,
	          value
	        );
	      } else if (customInput) {
	        var CustomInput = customInput;
	        return _react2.default.createElement(CustomInput, inputProps);
	      }
	
	      return _react2.default.createElement('input', inputProps);
	    }
	  }]);
	
	  return CurrencyFormat;
	}(_react2.default.Component);
	
	CurrencyFormat.propTypes = propTypes;
	CurrencyFormat.defaultProps = defaultProps;
	
	module.exports = CurrencyFormat;

/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var globalThis = __webpack_require__(54);
	var isCallable = __webpack_require__(52);
	
	var aFunction = function (argument) {
	  return isCallable(argument) ? argument : undefined;
	};
	
	module.exports = function (namespace, method) {
	  return arguments.length < 2 ? aFunction(globalThis[namespace]) : globalThis[namespace] && globalThis[namespace][method];
	};


/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// toObject with fallback for non-array-like ES3 strings
	var IndexedObject = __webpack_require__(607);
	var requireObjectCoercible = __webpack_require__(165);
	
	module.exports = function (it) {
	  return IndexedObject(requireObjectCoercible(it));
	};


/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        if (typeof b !== "function" && b !== null)
	            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (this && this.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __rest = (this && this.__rest) || function (s, e) {
	    var t = {};
	    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
	        t[p] = s[p];
	    if (s != null && typeof Object.getOwnPropertySymbols === "function")
	        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
	                t[p[i]] = s[p[i]];
	        }
	    return t;
	};
	var __importDefault = (this && this.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var react_1 = __importStar(__webpack_require__(1));
	var classnames_1 = __importDefault(__webpack_require__(9));
	var defaultChildren = function (shareCount) { return shareCount; };
	var SocialMediaShareCount = /** @class */ (function (_super) {
	    __extends(SocialMediaShareCount, _super);
	    function SocialMediaShareCount(props) {
	        var _this = _super.call(this, props) || this;
	        _this._isMounted = false;
	        _this.state = { count: 0, isLoading: false };
	        return _this;
	    }
	    SocialMediaShareCount.prototype.componentDidMount = function () {
	        this._isMounted = true;
	        this.updateCount(this.props.url);
	    };
	    SocialMediaShareCount.prototype.componentDidUpdate = function (prevProps) {
	        if (this.props.url !== prevProps.url) {
	            this.updateCount(this.props.url);
	        }
	    };
	    SocialMediaShareCount.prototype.componentWillUnmount = function () {
	        this._isMounted = false;
	    };
	    SocialMediaShareCount.prototype.updateCount = function (url) {
	        var _this = this;
	        this.setState({
	            isLoading: true,
	        });
	        this.props.getCount(url, function (count) {
	            if (_this._isMounted) {
	                _this.setState({
	                    count: count,
	                    isLoading: false,
	                });
	            }
	        });
	    };
	    SocialMediaShareCount.prototype.render = function () {
	        var _a = this.state, count = _a.count, isLoading = _a.isLoading;
	        var _b = this.props, _c = _b.children, children = _c === void 0 ? defaultChildren : _c, className = _b.className, _ = _b.getCount, rest = __rest(_b, ["children", "className", "getCount"]);
	        return (react_1.default.createElement("span", __assign({ className: (0, classnames_1.default)('react-share__ShareCount', className) }, rest), !isLoading && count !== undefined && children(count)));
	    };
	    return SocialMediaShareCount;
	}(react_1.Component));
	function createShareCount(getCount) {
	    var ShareCount = function (props) { return (react_1.default.createElement(SocialMediaShareCount, __assign({ getCount: getCount }, props))); };
	    ShareCount.displayName = "ShareCount(".concat(getCount.name, ")");
	    return ShareCount;
	}
	exports.default = createShareCount;


/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a duplex stream is just a stream that is both readable and writable.
	// Since JS doesn't have multiple prototypal inheritance, this class
	// prototypally inherits from Readable, and then parasitically from
	// Writable.
	
	'use strict';
	
	/*<replacement>*/
	
	var pna = __webpack_require__(202);
	/*</replacement>*/
	
	/*<replacement>*/
	var objectKeys = Object.keys || function (obj) {
	  var keys = [];
	  for (var key in obj) {
	    keys.push(key);
	  }return keys;
	};
	/*</replacement>*/
	
	module.exports = Duplex;
	
	/*<replacement>*/
	var util = Object.create(__webpack_require__(147));
	util.inherits = __webpack_require__(126);
	/*</replacement>*/
	
	var Readable = __webpack_require__(654);
	var Writable = __webpack_require__(304);
	
	util.inherits(Duplex, Readable);
	
	{
	  // avoid scope creep, the keys array can then be collected
	  var keys = objectKeys(Writable.prototype);
	  for (var v = 0; v < keys.length; v++) {
	    var method = keys[v];
	    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
	  }
	}
	
	function Duplex(options) {
	  if (!(this instanceof Duplex)) return new Duplex(options);
	
	  Readable.call(this, options);
	  Writable.call(this, options);
	
	  if (options && options.readable === false) this.readable = false;
	
	  if (options && options.writable === false) this.writable = false;
	
	  this.allowHalfOpen = true;
	  if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;
	
	  this.once('end', onend);
	}
	
	Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
	  // making it explicit this property is not enumerable
	  // because otherwise some prototype manipulation in
	  // userland will fail
	  enumerable: false,
	  get: function () {
	    return this._writableState.highWaterMark;
	  }
	});
	
	// the no-half-open enforcer
	function onend() {
	  // if we allow half-open state, or if the writable side ended,
	  // then we're ok.
	  if (this.allowHalfOpen || this._writableState.ended) return;
	
	  // no more data can be written.
	  // But allow more writes to happen in this tick.
	  pna.nextTick(onEndNT, this);
	}
	
	function onEndNT(self) {
	  self.end();
	}
	
	Object.defineProperty(Duplex.prototype, 'destroyed', {
	  get: function () {
	    if (this._readableState === undefined || this._writableState === undefined) {
	      return false;
	    }
	    return this._readableState.destroyed && this._writableState.destroyed;
	  },
	  set: function (value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (this._readableState === undefined || this._writableState === undefined) {
	      return;
	    }
	
	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._readableState.destroyed = value;
	    this._writableState.destroyed = value;
	  }
	});
	
	Duplex.prototype._destroy = function (err, cb) {
	  this.push(null);
	  this.end();
	
	  pna.nextTick(cb, err);
	};

/***/ },
/* 117 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formControlState;
	
	function formControlState(_ref) {
	  var props = _ref.props,
	      states = _ref.states,
	      muiFormControl = _ref.muiFormControl;
	  return states.reduce(function (acc, state) {
	    acc[state] = props[state];
	
	    if (muiFormControl) {
	      if (typeof props[state] === 'undefined') {
	        acc[state] = muiFormControl[state];
	      }
	    }
	
	    return acc;
	  }, {});
	}

/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = useFormControl;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _FormControlContext = _interopRequireDefault(__webpack_require__(230));
	
	function useFormControl() {
	  return React.useContext(_FormControlContext.default);
	}

/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	//var path = 'http://localhost:5005/api/';
	var path = ("https://api.bewise.in/api/");
	var userSite = ("https://www.bewise.in/");
	var config = {
	    register: path,
	    usersite: userSite
	};
	
	exports.default = config;

/***/ },
/* 120 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./type')} */
	module.exports = TypeError;


/***/ },
/* 121 */
18,
/* 122 */
18,
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/back-arrow-dark.074ca1bd.svg";

/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/mini-arrow.66a7c1c5.svg";

/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/** @type {import('.')} */
	var $gOPD = __webpack_require__(1299);
	
	if ($gOPD) {
		try {
			$gOPD([], 'length');
		} catch (e) {
			// IE 8 has a broken gOPD
			$gOPD = null;
		}
	}
	
	module.exports = $gOPD;


/***/ },
/* 126 */
/***/ function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    if (superCtor) {
	      ctor.super_ = superCtor
	      ctor.prototype = Object.create(superCtor.prototype, {
	        constructor: {
	          value: ctor,
	          enumerable: false,
	          writable: true,
	          configurable: true
	        }
	      })
	    }
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    if (superCtor) {
	      ctor.super_ = superCtor
	      var TempCtor = function () {}
	      TempCtor.prototype = superCtor.prototype
	      ctor.prototype = new TempCtor()
	      ctor.prototype.constructor = ctor
	    }
	  }
	}


/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	!function(t,e){ true?module.exports=e(__webpack_require__(1),__webpack_require__(84),__webpack_require__(27)):"function"==typeof define&&define.amd?define(["react","draft-js","immutable"],e):"object"==typeof exports?exports.reactDraftWysiwyg=e(require("react"),require("draft-js"),require("immutable")):t.reactDraftWysiwyg=e(t.react,t["draft-js"],t.immutable)}(window,function(n,o,r){return a={},i.m=c=[function(t,e,n){t.exports=n(10)()},function(t,e){t.exports=n},function(t,e,n){var o;
	/*!
	  Copyright (c) 2017 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	!function(){"use strict";var c={}.hasOwnProperty;function a(){for(var t=[],e=0;e<arguments.length;e++){var n=arguments[e];if(n){var o=typeof n;if("string"==o||"number"==o)t.push(n);else if(Array.isArray(n)&&n.length){var r=a.apply(null,n);r&&t.push(r)}else if("object"==o)for(var i in n)c.call(n,i)&&n[i]&&t.push(i)}}return t.join(" ")}t.exports?(a.default=a,t.exports=a):void 0===(o=function(){return a}.apply(e,[]))||(t.exports=o)}()},function(t,e){t.exports=o},function(t,e,n){function r(t){if(a[t])return a[t].exports;var e=a[t]={i:t,l:!1,exports:{}};return c[t].call(e.exports,e,e.exports,r),e.l=!0,e.exports}var o,i,c,a;window,t.exports=(o=n(3),i=n(5),a={},r.m=c=[function(t,e){t.exports=o},function(t,e){t.exports=i},function(t,e,n){t.exports=n(3)},function(t,e,n){"use strict";n.r(e);var M=n(0),i=n(1);function j(t){var e=t.getSelection(),n=t.getCurrentContent(),o=e.getStartKey(),r=e.getEndKey(),i=n.getBlockMap();return i.toSeq().skipUntil(function(t,e){return e===o}).takeUntil(function(t,e){return e===r}).concat([[r,i.get(r)]])}function u(t){return j(t).toList()}function l(t){if(t)return u(t).get(0)}function o(t){if(t){var n=l(t),e=t.getCurrentContent().getBlockMap().toSeq().toList(),o=0;if(e.forEach(function(t,e){t.get("key")===n.get("key")&&(o=e-1)}),-1<o)return e.get(o)}}function r(t){return t?t.getCurrentContent().getBlockMap().toList():new i.List}function c(t){var e=u(t);if(!e.some(function(t){return t.type!==e.get(0).type}))return e.get(0).type}function a(t){var e=M.RichUtils.tryToRemoveBlockStyle(t);return e?M.EditorState.push(t,e,"change-block-type"):t}function s(t){var e="",n=t.getSelection(),o=n.getAnchorOffset(),r=n.getFocusOffset(),i=u(t);if(0<i.size){if(n.getIsBackward()){var c=o;o=r,r=c}for(var a=0;a<i.size;a+=1){var l=0===a?o:0,s=a===i.size-1?r:i.get(a).getText().length;e+=i.get(a).getText().slice(l,s)}}return e}function p(t){var e=t.getCurrentContent(),n=t.getSelection(),o=M.Modifier.removeRange(e,n,"forward"),r=o.getSelectionAfter(),i=o.getBlockForKey(r.getStartKey());return o=M.Modifier.insertText(o,r,"\n",i.getInlineStyleAt(r.getStartOffset()),null),M.EditorState.push(t,o,"insert-fragment")}function d(t){var e=M.Modifier.splitBlock(t.getCurrentContent(),t.getSelection());return a(M.EditorState.push(t,e,"split-block"))}function f(t){var e=t.getCurrentContent().getBlockMap().toList(),n=t.getSelection().merge({anchorKey:e.first().get("key"),anchorOffset:0,focusKey:e.last().get("key"),focusOffset:e.last().getLength()}),o=M.Modifier.removeRange(t.getCurrentContent(),n,"forward");return M.EditorState.push(t,o,"remove-range")}function y(t,e){var n=M.Modifier.setBlockData(t.getCurrentContent(),t.getSelection(),e);return M.EditorState.push(t,n,"change-block-data")}function m(t){var o=new i.Map({}),e=u(t);if(e&&0<e.size)for(var n=function(t){var n=e.get(t).getData();if(!n||0===n.size)return o=o.clear(),"break";if(0===t)o=n;else if(o.forEach(function(t,e){n.get(e)&&n.get(e)===t||(o=o.delete(e))}),0===o.size)return o=o.clear(),"break"},r=0;r<e.size&&"break"!==n(r);r+=1);return o}var g=Object(i.Map)({code:{element:"pre"}}),b=M.DefaultDraftBlockRenderMap.merge(g);function h(t){if(t){var e=t.getType();return"unordered-list-item"===e||"ordered-list-item"===e}return!1}function v(t,e,n){var o,r=t.getSelection();o=r.getIsBackward()?r.getFocusKey():r.getAnchorKey();var i=t.getCurrentContent(),c=i.getBlockForKey(o),a=c.getType();if("unordered-list-item"!==a&&"ordered-list-item"!==a)return t;var l=i.getBlockBefore(o);if(!l)return t;if(l.getType()!==a)return t;var s=c.getDepth();if(1===e&&s===n)return t;var u,p,d,f,y,m,g,b=Math.min(l.getDepth()+1,n),h=(p=e,d=b,f=(u=t).getSelection(),y=u.getCurrentContent(),m=y.getBlockMap(),g=j(u).map(function(t){var e=t.getDepth()+p;return e=Math.max(0,Math.min(e,d)),t.set("depth",e)}),m=m.merge(g),y.merge({blockMap:m,selectionBefore:f,selectionAfter:f}));return M.EditorState.push(t,h,"adjust-depth")}function N(t,e){var n;return 13===(n=e).which&&(n.getModifierState("Shift")||n.getModifierState("Alt")||n.getModifierState("Control"))?t.getSelection().isCollapsed()?M.RichUtils.insertSoftNewline(t):p(t):function(t){var e=t.getSelection();if(e.isCollapsed()){var n=t.getCurrentContent(),o=e.getStartKey(),r=n.getBlockForKey(o);if(!h(r)&&"unstyled"!==r.getType()&&r.getLength()===e.getStartOffset())return d(t);if(h(r)&&0===r.getLength()){var i=r.getDepth();if(0===i)return a(t);if(0<i)return v(t,-1,i)}}}(t)}function E(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var o=Object.getOwnPropertySymbols(e);t&&(o=o.filter(function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable})),n.push.apply(n,o)}return n}function S(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}function w(t){return(w="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function C(t){var e=t.getSelection();if(e.isCollapsed()){var n={},o=t.getCurrentInlineStyle().toList().toJS();if(o)return["BOLD","ITALIC","UNDERLINE","STRIKETHROUGH","CODE","SUPERSCRIPT","SUBSCRIPT"].forEach(function(t){n[t]=0<=o.indexOf(t)}),n}var c=e.getStartOffset(),a=e.getEndOffset(),l=u(t);if(0<l.size){var r=function(){for(var n={BOLD:!0,ITALIC:!0,UNDERLINE:!0,STRIKETHROUGH:!0,CODE:!0,SUPERSCRIPT:!0,SUBSCRIPT:!0},o=0;o<l.size;o+=1){var t=0===o?c:0,e=o===l.size-1?a:l.get(o).getText().length;t===e&&0===t?(t=1,e=2):t===e&&--t;for(var r=function(t){var e=l.get(o).getInlineStyleAt(t);["BOLD","ITALIC","UNDERLINE","STRIKETHROUGH","CODE","SUPERSCRIPT","SUBSCRIPT"].forEach(function(t){n[t]=n[t]&&e.get(t)===t})},i=t;i<e;i+=1)r(i)}return{v:n}}();if("object"===w(r))return r.v}return{}}function L(t){var e,n=t.getSelection(),o=n.getStartOffset(),r=n.getEndOffset();o===r&&0===o?r=1:o===r&&--o;for(var i=l(t),c=o;c<r;c+=1){var a=i.getEntityAt(c);if(!a){e=void 0;break}if(c===o)e=a;else if(e!==a){e=void 0;break}}return e}function D(t,e){var n,o=l(t);return o.findEntityRanges(function(t){return t.get("entity")===e},function(t,e){n={start:t,end:e,text:o.get("text").slice(t,e)}}),n}function k(t,e,n){x[t]["".concat(t.toLowerCase(),"-").concat(n)]=S({},"".concat(e),n)}function O(){return function(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?E(Object(n),!0).forEach(function(t){S(e,t,n[t])}):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):E(Object(n)).forEach(function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))})}return e}({},x.color,{},x.bgcolor,{},x.fontSize,{},x.fontFamily,{CODE:x.CODE,SUPERSCRIPT:x.SUPERSCRIPT,SUBSCRIPT:x.SUBSCRIPT})}var x={color:{},bgcolor:{},fontSize:{},fontFamily:{},CODE:{fontFamily:"monospace",wordWrap:"break-word",background:"#f1f1f1",borderRadius:3,padding:"1px 3px"},SUPERSCRIPT:{fontSize:11,position:"relative",top:-8,display:"inline-flex"},SUBSCRIPT:{fontSize:11,position:"relative",bottom:-8,display:"inline-flex"}};function I(t,e,n){var o=t.getSelection(),r=Object.keys(x[e]).reduce(function(t,e){return M.Modifier.removeInlineStyle(t,o,e)},t.getCurrentContent()),i=M.EditorState.push(t,r,"changeinline-style"),c=t.getCurrentInlineStyle();if(o.isCollapsed()&&(i=c.reduce(function(t,e){return M.RichUtils.toggleInlineStyle(t,e)},i)),"SUPERSCRIPT"===e||"SUBSCRIPT"==e)c.has(n)||(i=M.RichUtils.toggleInlineStyle(i,n));else{var a="bgcolor"===e?"backgroundColor":e;c.has("".concat(a,"-").concat(n))||(i=M.RichUtils.toggleInlineStyle(i,"".concat(e.toLowerCase(),"-").concat(n)),k(e,a,n))}return i}function T(t){t&&t.getCurrentContent().getBlockMap().map(function(t){return t.get("characterList")}).toList().flatten().forEach(function(t){t&&0===t.indexOf("color-")?k("color","color",t.substr(6)):t&&0===t.indexOf("bgcolor-")?k("bgcolor","backgroundColor",t.substr(8)):t&&0===t.indexOf("fontsize-")?k("fontSize","fontSize",+t.substr(9)):t&&0===t.indexOf("fontfamily-")&&k("fontFamily","fontFamily",t.substr(11))})}function A(t,e,n){var o=t.getInlineStyleAt(n).toList().filter(function(t){return t.startsWith(e.toLowerCase())});if(o&&0<o.size)return o.get(0)}function z(o,s){if(o&&s&&0<s.length){var t=function(){var t=o.getSelection(),i={};if(t.isCollapsed())return s.forEach(function(t){i[t]=function(t,e){var n=t.getCurrentInlineStyle().toList().filter(function(t){return t.startsWith(e.toLowerCase())});if(n&&0<n.size)return n.get(0)}(o,t)}),{v:i};var c=t.getStartOffset(),a=t.getEndOffset(),l=u(o);if(0<l.size){for(var e=function(n){var t=0===n?c:0,e=n===l.size-1?a:l.get(n).getText().length;t===e&&0===t?(t=1,e=2):t===e&&--t;for(var o=function(e){e===t?s.forEach(function(t){i[t]=A(l.get(n),t,e)}):s.forEach(function(t){i[t]&&i[t]!==A(l.get(n),t,e)&&(i[t]=void 0)})},r=t;r<e;r+=1)o(r)},n=0;n<l.size;n+=1)e(n);return{v:i}}}();if("object"===w(t))return t.v}return{}}function _(e){var t=e.getCurrentInlineStyle(),n=e.getCurrentContent();return t.forEach(function(t){n=M.Modifier.removeInlineStyle(n,e.getSelection(),t)}),M.EditorState.push(e,n,"change-inline-style")}n.d(e,"isListBlock",function(){return h}),n.d(e,"changeDepth",function(){return v}),n.d(e,"handleNewLine",function(){return N}),n.d(e,"getEntityRange",function(){return D}),n.d(e,"getCustomStyleMap",function(){return O}),n.d(e,"toggleCustomInlineStyle",function(){return I}),n.d(e,"getSelectionEntity",function(){return L}),n.d(e,"extractInlineStyle",function(){return T}),n.d(e,"removeAllInlineStyles",function(){return _}),n.d(e,"getSelectionInlineStyle",function(){return C}),n.d(e,"getSelectionCustomInlineStyle",function(){return z}),n.d(e,"getSelectedBlocksMap",function(){return j}),n.d(e,"getSelectedBlocksList",function(){return u}),n.d(e,"getSelectedBlock",function(){return l}),n.d(e,"getBlockBeforeSelectedBlock",function(){return o}),n.d(e,"getAllBlocks",function(){return r}),n.d(e,"getSelectedBlocksType",function(){return c}),n.d(e,"removeSelectedBlocksStyle",function(){return a}),n.d(e,"getSelectionText",function(){return s}),n.d(e,"addLineBreakRemovingSelection",function(){return p}),n.d(e,"insertNewUnstyledBlock",function(){return d}),n.d(e,"clearEditorContent",function(){return f}),n.d(e,"setBlockData",function(){return y}),n.d(e,"getSelectedBlocksMetadata",function(){return m}),n.d(e,"blockRenderMap",function(){return b})}],r.c=a,r.d=function(t,e,n){r.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:n})},r.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},r.t=function(e,t){if(1&t&&(e=r(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var n=Object.create(null);if(r.r(n),Object.defineProperty(n,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var o in e)r.d(n,o,function(t){return e[t]}.bind(null,o));return n},r.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return r.d(e,"a",e),e},r.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},r.p="",r(r.s=2))},function(t,e){t.exports=r},function(t,e,n){function r(t){if(a[t])return a[t].exports;var e=a[t]={i:t,l:!1,exports:{}};return c[t].call(e.exports,e,e.exports,r),e.l=!0,e.exports}var o,i,c,a;window,t.exports=(o=n(5),i=n(3),a={},r.m=c=[function(t,e){t.exports=o},function(t,e){t.exports=i},function(t,e,n){t.exports=n(3)},function(t,e,n){"use strict";n.r(e);var j=n(1),s=n(0),v=function(t,e,n){var o,r=t.textContent;return""===r.trim()?{chunk:(o=n,{text:" ",inlines:[new s.OrderedSet],entities:[o],blocks:[]})}:{chunk:{text:r,inlines:Array(r.length).fill(e),entities:Array(r.length).fill(n),blocks:[]}}},N=function(){return{text:"\n",inlines:[new s.OrderedSet],entities:new Array(1),blocks:[]}},E=function(){return{text:"",inlines:[],entities:[],blocks:[]}},S=function(t,e){return{text:"",inlines:[],entities:[],blocks:[{type:t,depth:0,data:e||new s.Map({})}]}},w=function(t,e,n){return{text:"\r",inlines:[],entities:[],blocks:[{type:t,depth:Math.max(0,Math.min(4,e)),data:n||new s.Map({})}]}},C=function(t){return{text:"\r ",inlines:[new s.OrderedSet],entities:[t],blocks:[{type:"atomic",depth:0,data:new s.Map({})}]}},L=function(t,e){return{text:t.text+e.text,inlines:t.inlines.concat(e.inlines),entities:t.entities.concat(e.entities),blocks:t.blocks.concat(e.blocks)}},D=new s.Map({"header-one":{element:"h1"},"header-two":{element:"h2"},"header-three":{element:"h3"},"header-four":{element:"h4"},"header-five":{element:"h5"},"header-six":{element:"h6"},"unordered-list-item":{element:"li",wrapper:"ul"},"ordered-list-item":{element:"li",wrapper:"ol"},blockquote:{element:"blockquote"},code:{element:"pre"},atomic:{element:"figure"},unstyled:{element:"p",aliasedElements:["div"]}}),k={code:"CODE",del:"STRIKETHROUGH",em:"ITALIC",strong:"BOLD",ins:"UNDERLINE",sub:"SUBSCRIPT",sup:"SUPERSCRIPT"};function O(t){return t.style.textAlign?new s.Map({"text-align":t.style.textAlign}):t.style.marginLeft?new s.Map({"margin-left":t.style.marginLeft}):void 0}var x=function(t){var e=void 0;if(t instanceof HTMLAnchorElement){var n={};e=t.dataset&&void 0!==t.dataset.mention?(n.url=t.href,n.text=t.innerHTML,n.value=t.dataset.value,j.Entity.__create("MENTION","IMMUTABLE",n)):(n.url=t.getAttribute&&t.getAttribute("href")||t.href,n.title=t.innerHTML,n.targetOption=t.target,j.Entity.__create("LINK","MUTABLE",n))}return e};n.d(e,"default",function(){return o});var u=" ",p=new RegExp("&nbsp;","g"),I=!0;function o(t,e){var n,o,r,i=(n=e,o=t.trim().replace(p,u),(r=function(t){var e,n=null;return document.implementation&&document.implementation.createHTMLDocument&&((e=document.implementation.createHTMLDocument("foo")).documentElement.innerHTML=t,n=e.getElementsByTagName("body")[0]),n}(o))?(I=!0,{chunk:function t(e,n,o,r,i,c){var a=e.nodeName.toLowerCase();if(c){var l=c(a,e);if(l){var s=j.Entity.__create(l.type,l.mutability,l.data||{});return{chunk:C(s)}}}if("#text"===a&&"\n"!==e.textContent)return v(e,n,i);if("br"===a)return{chunk:N()};if("img"===a&&e instanceof HTMLImageElement){var u={};u.src=e.getAttribute&&e.getAttribute("src")||e.src,u.alt=e.alt,u.height=e.style.height,u.width=e.style.width,e.style.float&&(u.alignment=e.style.float);var p=j.Entity.__create("IMAGE","MUTABLE",u);return{chunk:C(p)}}if("video"===a&&e instanceof HTMLVideoElement){var d={};d.src=e.getAttribute&&e.getAttribute("src")||e.src,d.alt=e.alt,d.height=e.style.height,d.width=e.style.width,e.style.float&&(d.alignment=e.style.float);var f=j.Entity.__create("VIDEO","MUTABLE",d);return{chunk:C(f)}}if("iframe"===a&&e instanceof HTMLIFrameElement){var y={};y.src=e.getAttribute&&e.getAttribute("src")||e.src,y.height=e.height,y.width=e.width;var m=j.Entity.__create("EMBEDDED_LINK","MUTABLE",y);return{chunk:C(m)}}var g,b=function(e,n){var t=D.filter(function(t){return t.element===e&&(!t.wrapper||t.wrapper===n)||t.wrapper===e||t.aliasedElements&&-1<t.aliasedElements.indexOf(e)}).keySeq().toSet().toArray();if(1===t.length)return t[0]}(a,r);b&&("ul"===a||"ol"===a?(r=a,o+=1):("unordered-list-item"!==b&&"ordered-list-item"!==b&&(r="",o=-1),I?(g=S(b,O(e)),I=!1):g=w(b,o,O(e)))),g=g||E(),n=function(t,e,n){var o,r=k[t];if(r)o=n.add(r).toOrderedSet();else if(e instanceof HTMLElement){var l=e;o=(o=n).withMutations(function(t){var e=l.style.color,n=l.style.backgroundColor,o=l.style.fontSize,r=l.style.fontFamily.replace(/^"|"$/g,""),i=l.style.fontWeight,c=l.style.textDecoration,a=l.style.fontStyle;e&&t.add("color-".concat(e.replace(/ /g,""))),n&&t.add("bgcolor-".concat(n.replace(/ /g,""))),o&&t.add("fontsize-".concat(o.replace(/px$/g,""))),r&&t.add("fontfamily-".concat(r)),"bold"===i&&t.add(k.strong),"underline"===c&&t.add(k.ins),"italic"===a&&t.add(k.em)}).toOrderedSet()}return o}(a,e,n);for(var h=e.firstChild;h;){var M=t(h,n,o,r,x(h)||i,c).chunk;g=L(g,M),h=h.nextSibling}return{chunk:g}}(r,new s.OrderedSet,-1,"",void 0,n).chunk}):null);if(i){var c=i.chunk,a=new s.OrderedMap({});c.entities&&c.entities.forEach(function(t){t&&(a=a.set(t,j.Entity.__get(t)))});var l=0;return{contentBlocks:c.text.split("\r").map(function(t,e){var n=l+t.length,o=c&&c.inlines.slice(l,n),r=c&&c.entities.slice(l,n),i=new s.List(o.map(function(t,e){var n={style:t,entity:null};return r[e]&&(n.entity=r[e]),j.CharacterMetadata.create(n)}));return l=n,new j.ContentBlock({key:Object(j.genKey)(),type:c&&c.blocks[e]&&c.blocks[e].type||"unstyled",depth:c&&c.blocks[e]&&c.blocks[e].depth,data:c&&c.blocks[e]&&c.blocks[e].data||new s.Map({}),text:t,characterList:i})}),entityMap:a}}return null}}],r.c=a,r.d=function(t,e,n){r.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:n})},r.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},r.t=function(e,t){if(1&t&&(e=r(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var n=Object.create(null);if(r.r(n),Object.defineProperty(n,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var o in e)r.d(n,o,function(t){return e[t]}.bind(null,o));return n},r.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return r.d(e,"a",e),e},r.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},r.p="",r(r.s=2))},function(t,e,l){"use strict";function o(n){return Array.prototype.slice.call(arguments,1).forEach(function(e){e&&Object.keys(e).forEach(function(t){n[t]=e[t]})}),n}function s(t){return Object.prototype.toString.call(t)}function u(t){return"[object Function]"===s(t)}function p(t){return t.replace(/[.?*+^$[\]\\(){}|-]/g,"\\$&")}var r={fuzzyLink:!0,fuzzyEmail:!0,fuzzyIP:!1};var i={"http:":{validate:function(t,e,n){var o=t.slice(e);return n.re.http||(n.re.http=new RegExp("^\\/\\/"+n.re.src_auth+n.re.src_host_port_strict+n.re.src_path,"i")),n.re.http.test(o)?o.match(n.re.http)[0].length:0}},"https:":"http:","ftp:":"http:","//":{validate:function(t,e,n){var o=t.slice(e);return n.re.no_http||(n.re.no_http=new RegExp("^"+n.re.src_auth+"(?:localhost|(?:(?:"+n.re.src_domain+")\\.)+"+n.re.src_domain_root+")"+n.re.src_port+n.re.src_host_terminator+n.re.src_path,"i")),n.re.no_http.test(o)?3<=e&&":"===t[e-3]?0:3<=e&&"/"===t[e-3]?0:o.match(n.re.no_http)[0].length:0}},"mailto:":{validate:function(t,e,n){var o=t.slice(e);return n.re.mailto||(n.re.mailto=new RegExp("^"+n.re.src_email_name+"@"+n.re.src_host_strict,"i")),n.re.mailto.test(o)?o.match(n.re.mailto)[0].length:0}}},d="a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]",c="biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф".split("|");function f(){return function(t,e){e.normalize(t)}}function a(r){var e=r.re=l(21)(r.__opts__),t=r.__tlds__.slice();function n(t){return t.replace("%TLDS%",e.src_tlds)}r.onCompile(),r.__tlds_replaced__||t.push(d),t.push(e.src_xn),e.src_tlds=t.join("|"),e.email_fuzzy=RegExp(n(e.tpl_email_fuzzy),"i"),e.link_fuzzy=RegExp(n(e.tpl_link_fuzzy),"i"),e.link_no_ip_fuzzy=RegExp(n(e.tpl_link_no_ip_fuzzy),"i"),e.host_fuzzy_test=RegExp(n(e.tpl_host_fuzzy_test),"i");var i=[];function c(t,e){throw new Error('(LinkifyIt) Invalid schema "'+t+'": '+e)}r.__compiled__={},Object.keys(r.__schemas__).forEach(function(t){var e=r.__schemas__[t];if(null!==e){var o,n={validate:null,link:null};if(r.__compiled__[t]=n,"[object Object]"===s(e))return"[object RegExp]"===s(e.validate)?n.validate=(o=e.validate,function(t,e){var n=t.slice(e);return o.test(n)?n.match(o)[0].length:0}):u(e.validate)?n.validate=e.validate:c(t,e),void(u(e.normalize)?n.normalize=e.normalize:e.normalize?c(t,e):n.normalize=f());if("[object String]"!==s(e))c(t,e);else i.push(t)}}),i.forEach(function(t){r.__compiled__[r.__schemas__[t]]&&(r.__compiled__[t].validate=r.__compiled__[r.__schemas__[t]].validate,r.__compiled__[t].normalize=r.__compiled__[r.__schemas__[t]].normalize)}),r.__compiled__[""]={validate:null,normalize:f()};var o,a=Object.keys(r.__compiled__).filter(function(t){return 0<t.length&&r.__compiled__[t]}).map(p).join("|");r.re.schema_test=RegExp("(^|(?!_)(?:[><｜]|"+e.src_ZPCc+"))("+a+")","i"),r.re.schema_search=RegExp("(^|(?!_)(?:[><｜]|"+e.src_ZPCc+"))("+a+")","ig"),r.re.pretest=RegExp("("+r.re.schema_test.source+")|("+r.re.host_fuzzy_test.source+")|@","i"),(o=r).__index__=-1,o.__text_cache__=""}function y(t,e){var n=t.__index__,o=t.__last_index__,r=t.__text_cache__.slice(n,o);this.schema=t.__schema__.toLowerCase(),this.index=n+e,this.lastIndex=o+e,this.raw=r,this.text=r,this.url=r}function m(t,e){var n=new y(t,e);return t.__compiled__[n.schema].normalize(n,t),n}function g(t,e){if(!(this instanceof g))return new g(t,e);var n;e||(n=t,Object.keys(n||{}).reduce(function(t,e){return t||r.hasOwnProperty(e)},!1)&&(e=t,t={})),this.__opts__=o({},r,e),this.__index__=-1,this.__last_index__=-1,this.__schema__="",this.__text_cache__="",this.__schemas__=o({},i,t),this.__compiled__={},this.__tlds__=c,this.__tlds_replaced__=!1,this.re={},a(this)}g.prototype.add=function(t,e){return this.__schemas__[t]=e,a(this),this},g.prototype.set=function(t){return this.__opts__=o(this.__opts__,t),this},g.prototype.test=function(t){if(this.__text_cache__=t,this.__index__=-1,!t.length)return!1;var e,n,o,r,i,c,a,l;if(this.re.schema_test.test(t))for((a=this.re.schema_search).lastIndex=0;null!==(e=a.exec(t));)if(r=this.testSchemaAt(t,e[2],a.lastIndex)){this.__schema__=e[2],this.__index__=e.index+e[1].length,this.__last_index__=e.index+e[0].length+r;break}return this.__opts__.fuzzyLink&&this.__compiled__["http:"]&&0<=(l=t.search(this.re.host_fuzzy_test))&&(this.__index__<0||l<this.__index__)&&null!==(n=t.match(this.__opts__.fuzzyIP?this.re.link_fuzzy:this.re.link_no_ip_fuzzy))&&(i=n.index+n[1].length,(this.__index__<0||i<this.__index__)&&(this.__schema__="",this.__index__=i,this.__last_index__=n.index+n[0].length)),this.__opts__.fuzzyEmail&&this.__compiled__["mailto:"]&&0<=t.indexOf("@")&&null!==(o=t.match(this.re.email_fuzzy))&&(i=o.index+o[1].length,c=o.index+o[0].length,(this.__index__<0||i<this.__index__||i===this.__index__&&c>this.__last_index__)&&(this.__schema__="mailto:",this.__index__=i,this.__last_index__=c)),0<=this.__index__},g.prototype.pretest=function(t){return this.re.pretest.test(t)},g.prototype.testSchemaAt=function(t,e,n){return this.__compiled__[e.toLowerCase()]?this.__compiled__[e.toLowerCase()].validate(t,n,this):0},g.prototype.match=function(t){var e=0,n=[];0<=this.__index__&&this.__text_cache__===t&&(n.push(m(this,e)),e=this.__last_index__);for(var o=e?t.slice(e):t;this.test(o);)n.push(m(this,e)),o=o.slice(this.__last_index__),e+=this.__last_index__;return n.length?n:null},g.prototype.tlds=function(t,e){return t=Array.isArray(t)?t:[t],e?this.__tlds__=this.__tlds__.concat(t).sort().filter(function(t,e,n){return t!==n[e-1]}).reverse():(this.__tlds__=t.slice(),this.__tlds_replaced__=!0),a(this),this},g.prototype.normalize=function(t){t.schema||(t.url="http://"+t.url),"mailto:"!==t.schema||/^mailto:/i.test(t.url)||(t.url="mailto:"+t.url)},g.prototype.onCompile=function(){},t.exports=g},function(t,e,n){t.exports=n(40)},function(t,e,n){},function(t,e,n){"use strict";var a=n(11);function o(){}function r(){}r.resetWarningCache=o,t.exports=function(){function t(t,e,n,o,r,i){if(i!==a){var c=new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");throw c.name="Invariant Violation",c}}function e(){return t}var n={array:t.isRequired=t,bigint:t,bool:t,func:t,number:t,object:t,string:t,symbol:t,any:t,arrayOf:e,element:t,elementType:t,instanceOf:e,node:t,objectOf:e,oneOf:e,oneOfType:e,shape:e,exact:e,checkPropTypes:r,resetWarningCache:o};return n.PropTypes=n}},function(t,e,n){"use strict";t.exports="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED"},function(t,e,n){},function(t,e,n){},function(t,e,n){},function(t,e,n){},function(t,e,n){},function(t,e,n){},function(t,e,n){},function(t,e,n){},function(t,e,n){},function(t,e,o){"use strict";t.exports=function(t){var e={};e.src_Any=o(22).source,e.src_Cc=o(23).source,e.src_Z=o(24).source,e.src_P=o(25).source,e.src_ZPCc=[e.src_Z,e.src_P,e.src_Cc].join("|"),e.src_ZCc=[e.src_Z,e.src_Cc].join("|");var n="[><｜]";return e.src_pseudo_letter="(?:(?![><｜]|"+e.src_ZPCc+")"+e.src_Any+")",e.src_ip4="(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)",e.src_auth="(?:(?:(?!"+e.src_ZCc+"|[@/\\[\\]()]).)+@)?",e.src_port="(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?",e.src_host_terminator="(?=$|[><｜]|"+e.src_ZPCc+")(?!-|_|:\\d|\\.-|\\.(?!$|"+e.src_ZPCc+"))",e.src_path="(?:[/?#](?:(?!"+e.src_ZCc+"|"+n+"|[()[\\]{}.,\"'?!\\-]).|\\[(?:(?!"+e.src_ZCc+"|\\]).)*\\]|\\((?:(?!"+e.src_ZCc+"|[)]).)*\\)|\\{(?:(?!"+e.src_ZCc+'|[}]).)*\\}|\\"(?:(?!'+e.src_ZCc+'|["]).)+\\"|\\\'(?:(?!'+e.src_ZCc+"|[']).)+\\'|\\'(?="+e.src_pseudo_letter+"|[-]).|\\.{2,4}[a-zA-Z0-9%/]|\\.(?!"+e.src_ZCc+"|[.]).|"+(t&&t["---"]?"\\-(?!--(?:[^-]|$))(?:-*)|":"\\-+|")+"\\,(?!"+e.src_ZCc+").|\\!(?!"+e.src_ZCc+"|[!]).|\\?(?!"+e.src_ZCc+"|[?]).)+|\\/)?",e.src_email_name='[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*',e.src_xn="xn--[a-z0-9\\-]{1,59}",e.src_domain_root="(?:"+e.src_xn+"|"+e.src_pseudo_letter+"{1,63})",e.src_domain="(?:"+e.src_xn+"|(?:"+e.src_pseudo_letter+")|(?:"+e.src_pseudo_letter+"(?:-|"+e.src_pseudo_letter+"){0,61}"+e.src_pseudo_letter+"))",e.src_host="(?:(?:(?:(?:"+e.src_domain+")\\.)*"+e.src_domain+"))",e.tpl_host_fuzzy="(?:"+e.src_ip4+"|(?:(?:(?:"+e.src_domain+")\\.)+(?:%TLDS%)))",e.tpl_host_no_ip_fuzzy="(?:(?:(?:"+e.src_domain+")\\.)+(?:%TLDS%))",e.src_host_strict=e.src_host+e.src_host_terminator,e.tpl_host_fuzzy_strict=e.tpl_host_fuzzy+e.src_host_terminator,e.src_host_port_strict=e.src_host+e.src_port+e.src_host_terminator,e.tpl_host_port_fuzzy_strict=e.tpl_host_fuzzy+e.src_port+e.src_host_terminator,e.tpl_host_port_no_ip_fuzzy_strict=e.tpl_host_no_ip_fuzzy+e.src_port+e.src_host_terminator,e.tpl_host_fuzzy_test="localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:"+e.src_ZPCc+"|>|$))",e.tpl_email_fuzzy='(^|[><｜]|"|\\(|'+e.src_ZCc+")("+e.src_email_name+"@"+e.tpl_host_fuzzy_strict+")",e.tpl_link_fuzzy="(^|(?![.:/\\-_@])(?:[$+<=>^`|｜]|"+e.src_ZPCc+"))((?![$+<=>^`|｜])"+e.tpl_host_port_fuzzy_strict+e.src_path+")",e.tpl_link_no_ip_fuzzy="(^|(?![.:/\\-_@])(?:[$+<=>^`|｜]|"+e.src_ZPCc+"))((?![$+<=>^`|｜])"+e.tpl_host_port_no_ip_fuzzy_strict+e.src_path+")",e}},function(t,e){t.exports=/[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/},function(t,e){t.exports=/[\0-\x1F\x7F-\x9F]/},function(t,e){t.exports=/[ \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000]/},function(t,e){t.exports=/[!-#%-\*,-\/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4E\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD803[\uDF55-\uDF59]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDF3C-\uDF3E]|\uD806[\uDC3B\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2]|\uD807[\uDC41-\uDC45\uDC70\uDC71\uDEF7\uDEF8]|\uD809[\uDC70-\uDC74]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD81B[\uDE97-\uDE9A]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/},function(t,e,n){},function(t,e,n){},function(t,e,n){},function(t,e,n){},function(t,e,n){},function(t,e,n){},function(t,e,n){},function(t,e,n){},function(t,e,n){},function(t,e,n){},function(t,e,n){},function(t,e,n){},function(t,e,n){},function(t,e,n){},function(t,e,n){"use strict";n.r(e),n.d(e,"Editor",function(){return ar});var f=n(1),N=n.n(f),o=n(0),y=n.n(o),E=n(3),S=n(4),r=n(2),w=n.n(r);function i(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function c(t,e,n){return e&&i(t.prototype,e),n&&i(t,n),Object.defineProperty(t,"prototype",{writable:!1}),t}var a=c(function t(){var n=this;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this.callBacks=[],this.suggestionCallback=void 0,this.editorFlag=!1,this.suggestionFlag=!1,this.closeAllModals=function(e){n.callBacks.forEach(function(t){t(e)})},this.init=function(t){var e=document.getElementById(t);e&&e.addEventListener("click",function(){n.editorFlag=!0}),document&&(document.addEventListener("click",function(){n.editorFlag?n.editorFlag=!1:(n.closeAllModals(),n.suggestionCallback&&n.suggestionCallback())}),document.addEventListener("keydown",function(t){"Escape"===t.key&&n.closeAllModals()}))},this.onEditorClick=function(){n.closeModals(),!n.suggestionFlag&&n.suggestionCallback?n.suggestionCallback():n.suggestionFlag=!1},this.closeModals=function(t){n.closeAllModals(t)},this.registerCallBack=function(t){n.callBacks.push(t)},this.deregisterCallBack=function(e){n.callBacks=n.callBacks.filter(function(t){return t!==e})},this.setSuggestionCallback=function(t){n.suggestionCallback=t},this.removeSuggestionCallback=function(){n.suggestionCallback=void 0},this.onSuggestionClick=function(){n.suggestionFlag=!0}});function l(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function s(t,e,n){return e&&l(t.prototype,e),n&&l(t,n),Object.defineProperty(t,"prototype",{writable:!1}),t}var u,p=s(function t(){var e=this;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this.inputFocused=!1,this.editorMouseDown=!1,this.onEditorMouseDown=function(){e.editorFocused=!0},this.onInputMouseDown=function(){e.inputFocused=!0},this.isEditorBlur=function(t){return"INPUT"!==t.target.tagName&&"LABEL"!==t.target.tagName&&"TEXTAREA"!==t.target.tagName||e.editorFocused?!("INPUT"===t.target.tagName&&"LABEL"===t.target.tagName&&"TEXTAREA"===t.target.tagName||e.inputFocused)&&!(e.editorFocused=!1):!(e.inputFocused=!1)},this.isEditorFocused=function(){return!e.inputFocused||(e.inputFocused=!1)},this.isToolbarFocused=function(){return!e.editorFocused||(e.editorFocused=!1)},this.isInputFocused=function(){return e.inputFocused}}),d=[],C={onKeyDown:function(e){d.forEach(function(t){t(e)})},registerCallBack:function(t){d.push(t)},deregisterCallBack:function(e){d=d.filter(function(t){return t!==e})}},m=function(){u=!0},g=function(){u=!1},b=function(){return u};function L(t){var e=t.getData()&&t.getData().get("text-align");return e?"rdw-".concat(e,"-aligned-block"):""}function h(t,e){if(t)for(var n in t)!{}.hasOwnProperty.call(t,n)||e(n,t[n])}function M(t,e){var n=!1;if(t)for(var o in t)if({}.hasOwnProperty.call(t,o)&&e===o){n=!0;break}return n}function j(t){t.stopPropagation()}function v(t){return t[t.options[0]].icon}function D(t,o){if(t&&void 0===o)return t;var r={};return h(t,function(t,e){var n;n=e,"[object Object]"===Object.prototype.toString.call(n)?r[t]=D(e,o[t]):r[t]=void 0!==o[t]?o[t]:e}),r}var k=n(6),O=n.n(k),x=n(5);n(9);function I(t){return(I="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function T(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}function A(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function z(t,e){return(z=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function _(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=P(o);if(r){var n=P(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===I(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function P(t){return(P=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var R=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&z(t,e)}(i,f["Component"]);var t,e,n,o=_(i);function i(){var r;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,i);for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];return(r=o.call.apply(o,[this].concat(e))).onClick=function(){var t=r.props,e=t.disabled,n=t.onClick,o=t.value;e||n(o)},r}return t=i,(e=[{key:"render",value:function(){var t,e=this.props,n=e.children,o=e.className,r=e.activeClassName,i=e.active,c=e.disabled,a=e.title;return N.a.createElement("div",{className:w()("rdw-option-wrapper",o,(T(t={},"rdw-option-active ".concat(r),i),T(t,"rdw-option-disabled",c),t)),onClick:this.onClick,"aria-selected":i,title:a},n)}}])&&A(t.prototype,e),n&&A(t,n),Object.defineProperty(t,"prototype",{writable:!1}),i}();R.propTypes={onClick:y.a.func.isRequired,children:y.a.any,value:y.a.string,className:y.a.string,activeClassName:y.a.string,active:y.a.bool,disabled:y.a.bool,title:y.a.string},R.defaultProps={activeClassName:""};n(12);function U(t){return(U="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function B(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function F(t,e){return(F=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function Y(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=Q(o);if(r){var n=Q(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===U(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function Q(t){return(Q=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var H=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&F(t,e)}(i,f["Component"]);var t,e,n,r=Y(i);function i(){var o;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,i);for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];return(o=r.call.apply(r,[this].concat(e))).state={highlighted:-1},o.onChange=function(t){var e=o.props.onChange;e&&e(t),o.toggleExpansion()},o.setHighlighted=function(t){o.setState({highlighted:t})},o.toggleExpansion=function(){var t=o.props,e=t.doExpand,n=t.doCollapse;t.expanded?n():e()},o}return t=i,(e=[{key:"componentDidUpdate",value:function(t){var e=this.props.expanded;t.expanded&&!e&&this.setState({highlighted:-1})}},{key:"render",value:function(){var n=this,t=this.props,e=t.expanded,o=t.children,r=t.className,i=t.optionWrapperClassName,c=t.ariaLabel,a=t.onExpandEvent,l=t.title,s=this.state.highlighted,u=o.slice(1,o.length);return N.a.createElement("div",{className:w()("rdw-dropdown-wrapper",r),"aria-expanded":e,"aria-label":c||"rdw-dropdown"},N.a.createElement("a",{className:"rdw-dropdown-selectedtext",onClick:a,title:l},o[0],N.a.createElement("div",{className:w()({"rdw-dropdown-carettoclose":e,"rdw-dropdown-carettoopen":!e})})),e?N.a.createElement("ul",{className:w()("rdw-dropdown-optionwrapper",i),onClick:j},N.a.Children.map(u,function(t,e){return t&&N.a.cloneElement(t,{onSelect:n.onChange,highlighted:s===e,setHighlighted:n.setHighlighted,index:e})})):void 0)}}])&&B(t.prototype,e),n&&B(t,n),Object.defineProperty(t,"prototype",{writable:!1}),i}();H.propTypes={children:y.a.any,onChange:y.a.func,className:y.a.string,expanded:y.a.bool,doExpand:y.a.func,doCollapse:y.a.func,onExpandEvent:y.a.func,optionWrapperClassName:y.a.string,ariaLabel:y.a.string,title:y.a.string};n(13);function Z(t){return(Z="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function W(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}function G(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function J(t,e){return(J=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function V(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=q(o);if(r){var n=q(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===Z(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function q(t){return(q=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var K=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&J(t,e)}(r,f["Component"]);var t,e,n,o=V(r);function r(){var i;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,r);for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];return(i=o.call.apply(o,[this].concat(e))).onClick=function(t){var e=i.props,n=e.onSelect,o=e.onClick,r=e.value;e.disabled||(n&&n(r),o&&(t.stopPropagation(),o(r)))},i.setHighlighted=function(){var t=i.props;(0,t.setHighlighted)(t.index)},i.resetHighlighted=function(){(0,i.props.setHighlighted)(-1)},i}return t=r,(e=[{key:"render",value:function(){var t,e=this.props,n=e.children,o=e.active,r=e.disabled,i=e.highlighted,c=e.className,a=e.activeClassName,l=e.disabledClassName,s=e.highlightedClassName,u=e.title;return N.a.createElement("li",{className:w()("rdw-dropdownoption-default",c,(W(t={},"rdw-dropdownoption-active ".concat(a),o),W(t,"rdw-dropdownoption-highlighted ".concat(s),i),W(t,"rdw-dropdownoption-disabled ".concat(l),r),t)),onMouseEnter:this.setHighlighted,onMouseLeave:this.resetHighlighted,onClick:this.onClick,title:u},n)}}])&&G(t.prototype,e),n&&G(t,n),Object.defineProperty(t,"prototype",{writable:!1}),r}();K.propTypes={children:y.a.any,value:y.a.any,onClick:y.a.func,onSelect:y.a.func,setHighlighted:y.a.func,index:y.a.number,disabled:y.a.bool,active:y.a.bool,highlighted:y.a.bool,className:y.a.string,activeClassName:y.a.string,disabledClassName:y.a.string,highlightedClassName:y.a.string,title:y.a.string},K.defaultProps={activeClassName:"",disabledClassName:"",highlightedClassName:""};n(14);function X(t){return(X="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function $(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function tt(t,e){return(tt=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function et(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=nt(o);if(r){var n=nt(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===X(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function nt(t){return(nt=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var ot=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&tt(t,e)}(r,f["Component"]);var t,e,n,o=et(r);function r(){return function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,r),o.apply(this,arguments)}return t=r,(e=[{key:"renderInFlatList",value:function(){var t=this.props,n=t.config,o=t.currentState,r=t.onChange,i=t.translations;return N.a.createElement("div",{className:w()("rdw-inline-wrapper",n.className),"aria-label":"rdw-inline-control"},n.options.map(function(t,e){return N.a.createElement(R,{key:e,value:t,onClick:r,className:w()(n[t].className),active:!0===o[t]||"MONOSPACE"===t&&o.CODE,title:n[t].title||i["components.controls.inline.".concat(t)]},N.a.createElement("img",{alt:"",src:n[t].icon}))}))}},{key:"renderInDropDown",value:function(){var t=this.props,n=t.config,e=t.expanded,o=t.doExpand,r=t.onExpandEvent,i=t.doCollapse,c=t.currentState,a=t.onChange,l=t.translations,s=n.className,u=n.dropdownClassName,p=n.title;return N.a.createElement(H,{className:w()("rdw-inline-dropdown",s),optionWrapperClassName:w()(u),onChange:a,expanded:e,doExpand:o,doCollapse:i,onExpandEvent:r,"aria-label":"rdw-inline-control",title:p},N.a.createElement("img",{src:v(n),alt:""}),n.options.map(function(t,e){return N.a.createElement(K,{key:e,value:t,className:w()("rdw-inline-dropdownoption",n[t].className),active:!0===c[t]||"MONOSPACE"===t&&c.CODE,title:n[t].title||l["components.controls.inline.".concat(t)]},N.a.createElement("img",{src:n[t].icon,alt:""}))}))}},{key:"render",value:function(){return this.props.config.inDropdown?this.renderInDropDown():this.renderInFlatList()}}])&&$(t.prototype,e),n&&$(t,n),Object.defineProperty(t,"prototype",{writable:!1}),r}();function rt(t){return(rt="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function it(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function ct(t,e){return(ct=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function at(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=lt(o);if(r){var n=lt(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===rt(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function lt(t){return(lt=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}ot.propTypes={expanded:y.a.bool,doExpand:y.a.func,doCollapse:y.a.func,onExpandEvent:y.a.func,config:y.a.object,onChange:y.a.func,currentState:y.a.object,translations:y.a.object};var st=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&ct(t,e)}(i,f["Component"]);var t,e,n,r=at(i);function i(t){var l;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,i),(l=r.call(this,t)).onExpandEvent=function(){l.signalExpanded=!l.state.expanded},l.expandCollapse=function(){l.setState({expanded:l.signalExpanded}),l.signalExpanded=!1},l.toggleInlineStyle=function(t){var e="monospace"===t?"CODE":t.toUpperCase(),n=l.props,o=n.editorState,r=n.onChange,i=E.RichUtils.toggleInlineStyle(o,e);if("subscript"===t||"superscript"===t){var c="subscript"===t?"SUPERSCRIPT":"SUBSCRIPT",a=E.Modifier.removeInlineStyle(i.getCurrentContent(),i.getSelection(),c);i=E.EditorState.push(i,a,"change-inline-style")}i&&r(i)},l.changeKeys=function(t){if(t){var n={};return h(t,function(t,e){n["CODE"===t?"monospace":t.toLowerCase()]=e}),n}},l.doExpand=function(){l.setState({expanded:!0})},l.doCollapse=function(){l.setState({expanded:!1})};var e=l.props,n=e.editorState,o=e.modalHandler;return l.state={currentStyles:n?l.changeKeys(Object(S.getSelectionInlineStyle)(n)):{}},o.registerCallBack(l.expandCollapse),l}return t=i,(e=[{key:"componentDidUpdate",value:function(t){var e=this.props.editorState;e&&e!==t.editorState&&this.setState({currentStyles:this.changeKeys(Object(S.getSelectionInlineStyle)(e))})}},{key:"componentWillUnmount",value:function(){this.props.modalHandler.deregisterCallBack(this.expandCollapse)}},{key:"render",value:function(){var t=this.props,e=t.config,n=t.translations,o=this.state,r=o.expanded,i=o.currentStyles,c=e.component||ot;return N.a.createElement(c,{config:e,translations:n,currentState:i,expanded:r,onExpandEvent:this.onExpandEvent,doExpand:this.doExpand,doCollapse:this.doCollapse,onChange:this.toggleInlineStyle})}}])&&it(t.prototype,e),n&&it(t,n),Object.defineProperty(t,"prototype",{writable:!1}),i}();st.propTypes={onChange:y.a.func.isRequired,editorState:y.a.object.isRequired,modalHandler:y.a.object,config:y.a.object,translations:y.a.object};n(15);function ut(t){return(ut="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function pt(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function dt(t,e){return(dt=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function ft(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=yt(o);if(r){var n=yt(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===ut(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function yt(t){return(yt=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var mt=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&dt(t,e)}(r,f["Component"]);var t,e,n,o=ft(r);function r(t){var e;return function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,r),(e=o.call(this,t)).getBlockTypes=function(t){return[{label:"Normal",displayName:t["components.controls.blocktype.normal"]},{label:"H1",displayName:t["components.controls.blocktype.h1"]},{label:"H2",displayName:t["components.controls.blocktype.h2"]},{label:"H3",displayName:t["components.controls.blocktype.h3"]},{label:"H4",displayName:t["components.controls.blocktype.h4"]},{label:"H5",displayName:t["components.controls.blocktype.h5"]},{label:"H6",displayName:t["components.controls.blocktype.h6"]},{label:"Blockquote",displayName:t["components.controls.blocktype.blockquote"]},{label:"Code",displayName:t["components.controls.blocktype.code"]}]},e.state={blockTypes:e.getBlockTypes(t.translations)},e}return t=r,(e=[{key:"componentDidUpdate",value:function(t){var e=this.props.translations;e!==t.translations&&this.setState({blockTypes:this.getBlockTypes(e)})}},{key:"renderFlat",value:function(t){var e=this.props,n=e.config.className,o=e.onChange,r=e.currentState.blockType;return N.a.createElement("div",{className:w()("rdw-inline-wrapper",n)},t.map(function(t,e){return N.a.createElement(R,{key:e,value:t.label,active:r===t.label,onClick:o},t.displayName)}))}},{key:"renderInDropdown",value:function(t){var e=this.props,n=e.config,o=n.className,r=n.dropdownClassName,i=n.title,c=e.currentState.blockType,a=e.expanded,l=e.doExpand,s=e.onExpandEvent,u=e.doCollapse,p=e.onChange,d=e.translations,f=this.state.blockTypes.filter(function(t){return t.label===c}),y=f&&f[0]&&f[0].displayName;return N.a.createElement("div",{className:"rdw-block-wrapper","aria-label":"rdw-block-control"},N.a.createElement(H,{className:w()("rdw-block-dropdown",o),optionWrapperClassName:w()(r),onChange:p,expanded:a,doExpand:l,doCollapse:u,onExpandEvent:s,title:i||d["components.controls.blocktype.blocktype"]},N.a.createElement("span",null,y||d["components.controls.blocktype.blocktype"]),t.map(function(t,e){return N.a.createElement(K,{active:c===t.label,value:t.label,key:e},t.displayName)})))}},{key:"render",value:function(){var n=this.props.config,t=n.inDropdown,e=this.state.blockTypes.filter(function(t){var e=t.label;return-1<n.options.indexOf(e)});return t?this.renderInDropdown(e):this.renderFlat(e)}}])&&pt(t.prototype,e),n&&pt(t,n),Object.defineProperty(t,"prototype",{writable:!1}),r}();mt.propTypes={expanded:y.a.bool,onExpandEvent:y.a.func,doExpand:y.a.func,doCollapse:y.a.func,onChange:y.a.func,config:y.a.object,currentState:y.a.object,translations:y.a.object};var gt=mt;function bt(t){return(bt="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function ht(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function Mt(t,e){return(Mt=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function jt(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=vt(o);if(r){var n=vt(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===bt(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function vt(t){return(vt=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var Nt=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&Mt(t,e)}(r,f["Component"]);var t,e,n,o=jt(r);function r(t){var c;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,r),(c=o.call(this,t)).onExpandEvent=function(){c.signalExpanded=!c.state.expanded},c.expandCollapse=function(){c.setState({expanded:c.signalExpanded}),c.signalExpanded=!1},c.blocksTypes=[{label:"Normal",style:"unstyled"},{label:"H1",style:"header-one"},{label:"H2",style:"header-two"},{label:"H3",style:"header-three"},{label:"H4",style:"header-four"},{label:"H5",style:"header-five"},{label:"H6",style:"header-six"},{label:"Blockquote",style:"blockquote"},{label:"Code",style:"code"}],c.doExpand=function(){c.setState({expanded:!0})},c.doCollapse=function(){c.setState({expanded:!1})},c.toggleBlockType=function(e){var t=c.blocksTypes.find(function(t){return t.label===e}).style,n=c.props,o=n.editorState,r=n.onChange,i=E.RichUtils.toggleBlockType(o,t);i&&r(i)};var e=t.editorState,n=t.modalHandler;return c.state={expanded:!1,currentBlockType:e?Object(S.getSelectedBlocksType)(e):"unstyled"},n.registerCallBack(c.expandCollapse),c}return t=r,(e=[{key:"componentDidUpdate",value:function(t){var e=this.props.editorState;e&&e!==t.editorState&&this.setState({currentBlockType:Object(S.getSelectedBlocksType)(e)})}},{key:"componentWillUnmount",value:function(){this.props.modalHandler.deregisterCallBack(this.expandCollapse)}},{key:"render",value:function(){var t=this.props,e=t.config,n=t.translations,o=this.state,r=o.expanded,i=o.currentBlockType,c=e.component||gt,a=this.blocksTypes.find(function(t){return t.style===i});return N.a.createElement(c,{config:e,translations:n,currentState:{blockType:a&&a.label},onChange:this.toggleBlockType,expanded:r,onExpandEvent:this.onExpandEvent,doExpand:this.doExpand,doCollapse:this.doCollapse})}}])&&ht(t.prototype,e),n&&ht(t,n),Object.defineProperty(t,"prototype",{writable:!1}),r}();Nt.propTypes={onChange:y.a.func.isRequired,editorState:y.a.object,modalHandler:y.a.object,config:y.a.object,translations:y.a.object};var Et=Nt;n(16);function St(t){return(St="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function wt(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function Ct(t,e){return(Ct=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function Lt(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=Dt(o);if(r){var n=Dt(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===St(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function Dt(t){return(Dt=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var kt=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&Ct(t,e)}(i,f["Component"]);var t,e,n,r=Lt(i);function i(){var t;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,i);for(var e=arguments.length,n=new Array(e),o=0;o<e;o++)n[o]=arguments[o];return(t=r.call.apply(r,[this].concat(n))).state={defaultFontSize:void 0},t}return t=i,(e=[{key:"componentDidMount",value:function(){var t=document.getElementsByClassName("DraftEditor-root");if(t&&0<t.length){var e=window.getComputedStyle(t[0]).getPropertyValue("font-size");e=e.substring(0,e.length-2),this.setState({defaultFontSize:e})}}},{key:"render",value:function(){var t=this.props,e=t.config,n=e.icon,o=e.className,r=e.dropdownClassName,i=e.options,c=e.title,a=t.onChange,l=t.expanded,s=t.doCollapse,u=t.onExpandEvent,p=t.doExpand,d=t.translations,f=this.props.currentState.fontSize,y=this.state.defaultFontSize;return y=Number(y),f=f||i&&0<=i.indexOf(y)&&y,N.a.createElement("div",{className:"rdw-fontsize-wrapper","aria-label":"rdw-font-size-control"},N.a.createElement(H,{className:w()("rdw-fontsize-dropdown",o),optionWrapperClassName:w()(r),onChange:a,expanded:l,doExpand:p,doCollapse:s,onExpandEvent:u,title:c||d["components.controls.fontsize.fontsize"]},f?N.a.createElement("span",null,f):N.a.createElement("img",{src:n,alt:""}),i.map(function(t,e){return N.a.createElement(K,{className:"rdw-fontsize-option",active:f===t,value:t,key:e},t)})))}}])&&wt(t.prototype,e),n&&wt(t,n),Object.defineProperty(t,"prototype",{writable:!1}),i}();function Ot(t){return(Ot="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function xt(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function It(t,e){return(It=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function Tt(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=At(o);if(r){var n=At(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===Ot(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function At(t){return(At=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}kt.propTypes={expanded:y.a.bool,onExpandEvent:y.a.func,doExpand:y.a.func,doCollapse:y.a.func,onChange:y.a.func,config:y.a.object,currentState:y.a.object,translations:y.a.object};var zt=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&It(t,e)}(r,f["Component"]);var t,e,n,o=Tt(r);function r(t){var i;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,r),(i=o.call(this,t)).onExpandEvent=function(){i.signalExpanded=!i.state.expanded},i.expandCollapse=function(){i.setState({expanded:i.signalExpanded}),i.signalExpanded=!1},i.doExpand=function(){i.setState({expanded:!0})},i.doCollapse=function(){i.setState({expanded:!1})},i.toggleFontSize=function(t){var e=i.props,n=e.editorState,o=e.onChange,r=Object(S.toggleCustomInlineStyle)(n,"fontSize",t);r&&o(r)};var e=t.editorState,n=t.modalHandler;return i.state={expanded:void 0,currentFontSize:e?Object(S.getSelectionCustomInlineStyle)(e,["FONTSIZE"]).FONTSIZE:void 0},n.registerCallBack(i.expandCollapse),i}return t=r,(e=[{key:"componentDidUpdate",value:function(t){var e=this.props.editorState;e&&e!==t.editorState&&this.setState({currentFontSize:Object(S.getSelectionCustomInlineStyle)(e,["FONTSIZE"]).FONTSIZE})}},{key:"componentWillUnmount",value:function(){this.props.modalHandler.deregisterCallBack(this.expandCollapse)}},{key:"render",value:function(){var t=this.props,e=t.config,n=t.translations,o=this.state,r=o.expanded,i=o.currentFontSize,c=e.component||kt,a=i&&Number(i.substring(9));return N.a.createElement(c,{config:e,translations:n,currentState:{fontSize:a},onChange:this.toggleFontSize,expanded:r,onExpandEvent:this.onExpandEvent,doExpand:this.doExpand,doCollapse:this.doCollapse})}}])&&xt(t.prototype,e),n&&xt(t,n),Object.defineProperty(t,"prototype",{writable:!1}),r}();zt.propTypes={onChange:y.a.func.isRequired,editorState:y.a.object,modalHandler:y.a.object,config:y.a.object,translations:y.a.object};n(17);function _t(t){return(_t="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function Pt(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function Rt(t,e){return(Rt=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function Ut(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=Bt(o);if(r){var n=Bt(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===_t(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function Bt(t){return(Bt=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var Ft=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&Rt(t,e)}(i,f["Component"]);var t,e,n,r=Ut(i);function i(){var t;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,i);for(var e=arguments.length,n=new Array(e),o=0;o<e;o++)n[o]=arguments[o];return(t=r.call.apply(r,[this].concat(n))).state={defaultFontFamily:void 0},t}return t=i,(e=[{key:"componentDidMount",value:function(){var t=document.getElementsByClassName("DraftEditor-root");if(t&&0<t.length){var e=window.getComputedStyle(t[0]).getPropertyValue("font-family");this.setState({defaultFontFamily:e})}}},{key:"render",value:function(){var e=this.state.defaultFontFamily,t=this.props,n=t.config,o=n.className,r=n.dropdownClassName,i=n.options,c=n.title,a=t.translations,l=t.onChange,s=t.expanded,u=t.doCollapse,p=t.onExpandEvent,d=t.doExpand,f=this.props.currentState.fontFamily;return f=f||i&&e&&i.some(function(t){return t.toLowerCase()===e.toLowerCase()})&&e,N.a.createElement("div",{className:"rdw-fontfamily-wrapper","aria-label":"rdw-font-family-control"},N.a.createElement(H,{className:w()("rdw-fontfamily-dropdown",o),optionWrapperClassName:w()("rdw-fontfamily-optionwrapper",r),onChange:l,expanded:s,doExpand:d,doCollapse:u,onExpandEvent:p,title:c||a["components.controls.fontfamily.fontfamily"]},N.a.createElement("span",{className:"rdw-fontfamily-placeholder"},f||a["components.controls.fontfamily.fontfamily"]),i.map(function(t,e){return N.a.createElement(K,{active:f===t,value:t,key:e},t)})))}}])&&Pt(t.prototype,e),n&&Pt(t,n),Object.defineProperty(t,"prototype",{writable:!1}),i}();Ft.propTypes={expanded:y.a.bool,onExpandEvent:y.a.func,doExpand:y.a.func,doCollapse:y.a.func,onChange:y.a.func,config:y.a.object,currentState:y.a.object,translations:y.a.object};var Yt=Ft;function Qt(t){return(Qt="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function Ht(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function Zt(t,e){return(Zt=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function Wt(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=Gt(o);if(r){var n=Gt(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===Qt(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function Gt(t){return(Gt=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var Jt=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&Zt(t,e)}(r,f["Component"]);var t,e,n,o=Wt(r);function r(t){var i;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,r),(i=o.call(this,t)).onExpandEvent=function(){i.signalExpanded=!i.state.expanded},i.expandCollapse=function(){i.setState({expanded:i.signalExpanded}),i.signalExpanded=!1},i.doExpand=function(){i.setState({expanded:!0})},i.doCollapse=function(){i.setState({expanded:!1})},i.toggleFontFamily=function(t){var e=i.props,n=e.editorState,o=e.onChange,r=Object(S.toggleCustomInlineStyle)(n,"fontFamily",t);r&&o(r)};var e=t.editorState,n=t.modalHandler;return i.state={expanded:void 0,currentFontFamily:e?Object(S.getSelectionCustomInlineStyle)(e,["FONTFAMILY"]).FONTFAMILY:void 0},n.registerCallBack(i.expandCollapse),i}return t=r,(e=[{key:"componentDidUpdate",value:function(t){var e=this.props.editorState;e&&e!==t.editorState&&this.setState({currentFontFamily:Object(S.getSelectionCustomInlineStyle)(e,["FONTFAMILY"]).FONTFAMILY})}},{key:"componentWillUnmount",value:function(){this.props.modalHandler.deregisterCallBack(this.expandCollapse)}},{key:"render",value:function(){var t=this.props,e=t.config,n=t.translations,o=this.state,r=o.expanded,i=o.currentFontFamily,c=e.component||Yt,a=i&&i.substring(11);return N.a.createElement(c,{translations:n,config:e,currentState:{fontFamily:a},onChange:this.toggleFontFamily,expanded:r,onExpandEvent:this.onExpandEvent,doExpand:this.doExpand,doCollapse:this.doCollapse})}}])&&Ht(t.prototype,e),n&&Ht(t,n),Object.defineProperty(t,"prototype",{writable:!1}),r}();Jt.propTypes={onChange:y.a.func.isRequired,editorState:y.a.object,modalHandler:y.a.object,config:y.a.object,translations:y.a.object};n(18);function Vt(t){return(Vt="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function qt(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function Kt(t,e){return(Kt=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function Xt(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=$t(o);if(r){var n=$t(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===Vt(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function $t(t){return($t=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var te=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&Kt(t,e)}(i,f["Component"]);var t,e,n,r=Xt(i);function i(){var e;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,i);for(var t=arguments.length,n=new Array(t),o=0;o<t;o++)n[o]=arguments[o];return(e=r.call.apply(r,[this].concat(n))).options=["unordered","ordered","indent","outdent"],e.toggleBlockType=function(t){(0,e.props.onChange)(t)},e.indent=function(){(0,e.props.onChange)("indent")},e.outdent=function(){(0,e.props.onChange)("outdent")},e}return t=i,(e=[{key:"renderInFlatList",value:function(){var t=this.props,e=t.config,n=t.currentState.listType,o=t.translations,r=t.indentDisabled,i=t.outdentDisabled,c=e.options,a=e.unordered,l=e.ordered,s=e.indent,u=e.outdent,p=e.className;return N.a.createElement("div",{className:w()("rdw-list-wrapper",p),"aria-label":"rdw-list-control"},0<=c.indexOf("unordered")&&N.a.createElement(R,{value:"unordered",onClick:this.toggleBlockType,className:w()(a.className),active:"unordered"===n,title:a.title||o["components.controls.list.unordered"]},N.a.createElement("img",{src:a.icon,alt:""})),0<=c.indexOf("ordered")&&N.a.createElement(R,{value:"ordered",onClick:this.toggleBlockType,className:w()(l.className),active:"ordered"===n,title:l.title||o["components.controls.list.ordered"]},N.a.createElement("img",{src:l.icon,alt:""})),0<=c.indexOf("indent")&&N.a.createElement(R,{onClick:this.indent,disabled:r,className:w()(s.className),title:s.title||o["components.controls.list.indent"]},N.a.createElement("img",{src:s.icon,alt:""})),0<=c.indexOf("outdent")&&N.a.createElement(R,{onClick:this.outdent,disabled:i,className:w()(u.className),title:u.title||o["components.controls.list.outdent"]},N.a.createElement("img",{src:u.icon,alt:""})))}},{key:"renderInDropDown",value:function(){var n=this,t=this.props,o=t.config,e=t.expanded,r=t.doCollapse,i=t.doExpand,c=t.onExpandEvent,a=t.onChange,l=t.currentState.listType,s=t.translations,u=o.options,p=o.className,d=o.dropdownClassName,f=o.title;return N.a.createElement(H,{className:w()("rdw-list-dropdown",p),optionWrapperClassName:w()(d),onChange:a,expanded:e,doExpand:i,doCollapse:r,onExpandEvent:c,"aria-label":"rdw-list-control",title:f||s["components.controls.list.list"]},N.a.createElement("img",{src:v(o),alt:""}),this.options.filter(function(t){return 0<=u.indexOf(t)}).map(function(t,e){return N.a.createElement(K,{key:e,value:t,disabled:n.props["".concat(t,"Disabled")],className:w()("rdw-list-dropdownOption",o[t].className),active:l===t,title:o[t].title||s["components.controls.list.".concat(t)]},N.a.createElement("img",{src:o[t].icon,alt:""}))}))}},{key:"render",value:function(){return this.props.config.inDropdown?this.renderInDropDown():this.renderInFlatList()}}])&&qt(t.prototype,e),n&&qt(t,n),Object.defineProperty(t,"prototype",{writable:!1}),i}();function ee(t){return(ee="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function ne(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function oe(t,e){return(oe=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function re(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=ie(o);if(r){var n=ie(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===ee(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function ie(t){return(ie=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}te.propTypes={expanded:y.a.bool,doExpand:y.a.func,doCollapse:y.a.func,onExpandEvent:y.a.func,config:y.a.object,onChange:y.a.func,currentState:y.a.object,translations:y.a.object,indentDisabled:y.a.bool,outdentDisabled:y.a.bool};var ce=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&oe(t,e)}(c,f["Component"]);var t,e,n,r=re(c);function c(t){var i;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,c),(i=r.call(this,t)).onExpandEvent=function(){i.signalExpanded=!i.state.expanded},i.onChange=function(t){"unordered"===t?i.toggleBlockType("unordered-list-item"):"ordered"===t?i.toggleBlockType("ordered-list-item"):"indent"===t?i.adjustDepth(1):i.adjustDepth(-1)},i.expandCollapse=function(){i.setState({expanded:i.signalExpanded}),i.signalExpanded=!1},i.doExpand=function(){i.setState({expanded:!0})},i.doCollapse=function(){i.setState({expanded:!1})},i.toggleBlockType=function(t){var e=i.props,n=e.onChange,o=e.editorState,r=E.RichUtils.toggleBlockType(o,t);r&&n(r)},i.adjustDepth=function(t){var e=i.props,n=e.onChange,o=e.editorState,r=Object(S.changeDepth)(o,t,4);r&&n(r)},i.isIndentDisabled=function(){var t=i.props.editorState,e=i.state.currentBlock,n=Object(S.getBlockBeforeSelectedBlock)(t);return!n||!Object(S.isListBlock)(e)||n.get("type")!==e.get("type")||n.get("depth")<e.get("depth")},i.isOutdentDisabled=function(){var t=i.state.currentBlock;return!t||!Object(S.isListBlock)(t)||t.get("depth")<=0};var e=i.props,n=e.editorState,o=e.modalHandler;return i.state={expanded:!1,currentBlock:n?Object(S.getSelectedBlock)(n):void 0},o.registerCallBack(i.expandCollapse),i}return t=c,(e=[{key:"componentDidUpdate",value:function(t){var e=this.props.editorState;e&&e!==t.editorState&&this.setState({currentBlock:Object(S.getSelectedBlock)(e)})}},{key:"componentWillUnmount",value:function(){this.props.modalHandler.deregisterCallBack(this.expandCollapse)}},{key:"render",value:function(){var t,e=this.props,n=e.config,o=e.translations,r=this.state,i=r.expanded,c=r.currentBlock,a=n.component||te;"unordered-list-item"===c.get("type")?t="unordered":"ordered-list-item"===c.get("type")&&(t="ordered");var l=this.isIndentDisabled(),s=this.isOutdentDisabled();return N.a.createElement(a,{config:n,translations:o,currentState:{listType:t},expanded:i,onExpandEvent:this.onExpandEvent,doExpand:this.doExpand,doCollapse:this.doCollapse,onChange:this.onChange,indentDisabled:l,outdentDisabled:s})}}])&&ne(t.prototype,e),n&&ne(t,n),Object.defineProperty(t,"prototype",{writable:!1}),c}();ce.propTypes={onChange:y.a.func.isRequired,editorState:y.a.object.isRequired,modalHandler:y.a.object,config:y.a.object,translations:y.a.object};n(19);function ae(t){return(ae="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function le(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function se(t,e){return(se=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function ue(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=pe(o);if(r){var n=pe(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===ae(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function pe(t){return(pe=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var de=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&se(t,e)}(r,f["Component"]);var t,e,n,o=ue(r);function r(){return function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,r),o.apply(this,arguments)}return t=r,(e=[{key:"renderInFlatList",value:function(){var t=this.props,e=t.config,n=e.options,o=e.left,r=e.center,i=e.right,c=e.justify,a=e.className,l=t.onChange,s=t.currentState.textAlignment,u=t.translations;return N.a.createElement("div",{className:w()("rdw-text-align-wrapper",a),"aria-label":"rdw-textalign-control"},0<=n.indexOf("left")&&N.a.createElement(R,{value:"left",className:w()(o.className),active:"left"===s,onClick:l,title:o.title||u["components.controls.textalign.left"]},N.a.createElement("img",{src:o.icon,alt:""})),0<=n.indexOf("center")&&N.a.createElement(R,{value:"center",className:w()(r.className),active:"center"===s,onClick:l,title:r.title||u["components.controls.textalign.center"]},N.a.createElement("img",{src:r.icon,alt:""})),0<=n.indexOf("right")&&N.a.createElement(R,{value:"right",className:w()(i.className),active:"right"===s,onClick:l,title:i.title||u["components.controls.textalign.right"]},N.a.createElement("img",{src:i.icon,alt:""})),0<=n.indexOf("justify")&&N.a.createElement(R,{value:"justify",className:w()(c.className),active:"justify"===s,onClick:l,title:c.title||u["components.controls.textalign.justify"]},N.a.createElement("img",{src:c.icon,alt:""})))}},{key:"renderInDropDown",value:function(){var t=this.props,e=t.config,n=t.expanded,o=t.doExpand,r=t.onExpandEvent,i=t.doCollapse,c=t.currentState.textAlignment,a=t.onChange,l=t.translations,s=e.options,u=e.left,p=e.center,d=e.right,f=e.justify,y=e.className,m=e.dropdownClassName,g=e.title;return N.a.createElement(H,{className:w()("rdw-text-align-dropdown",y),optionWrapperClassName:w()(m),onChange:a,expanded:n,doExpand:o,doCollapse:i,onExpandEvent:r,"aria-label":"rdw-textalign-control",title:g||l["components.controls.textalign.textalign"]},N.a.createElement("img",{src:c&&e[c]&&e[c].icon||v(e),alt:""}),0<=s.indexOf("left")&&N.a.createElement(K,{value:"left",active:"left"===c,className:w()("rdw-text-align-dropdownOption",u.className),title:u.title||l["components.controls.textalign.left"]},N.a.createElement("img",{src:u.icon,alt:""})),0<=s.indexOf("center")&&N.a.createElement(K,{value:"center",active:"center"===c,className:w()("rdw-text-align-dropdownOption",p.className),title:p.title||l["components.controls.textalign.center"]},N.a.createElement("img",{src:p.icon,alt:""})),0<=s.indexOf("right")&&N.a.createElement(K,{value:"right",active:"right"===c,className:w()("rdw-text-align-dropdownOption",d.className),title:d.title||l["components.controls.textalign.right"]},N.a.createElement("img",{src:d.icon,alt:""})),0<=s.indexOf("justify")&&N.a.createElement(K,{value:"justify",active:"justify"===c,className:w()("rdw-text-align-dropdownOption",f.className),title:f.title||l["components.controls.textalign.justify"]},N.a.createElement("img",{src:f.icon,alt:""})))}},{key:"render",value:function(){return this.props.config.inDropdown?this.renderInDropDown():this.renderInFlatList()}}])&&le(t.prototype,e),n&&le(t,n),Object.defineProperty(t,"prototype",{writable:!1}),r}();function fe(t){return(fe="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function ye(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function me(t,e){return(me=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function ge(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=be(o);if(r){var n=be(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===fe(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function be(t){return(be=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}de.propTypes={expanded:y.a.bool,doExpand:y.a.func,doCollapse:y.a.func,onExpandEvent:y.a.func,config:y.a.object,onChange:y.a.func,currentState:y.a.object,translations:y.a.object};var he=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&me(t,e)}(i,f["Component"]);var t,e,n,o=ge(i);function i(t){var r;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,i),(r=o.call(this,t)).onExpandEvent=function(){r.signalExpanded=!r.state.expanded},r.expandCollapse=function(){r.setState({expanded:r.signalExpanded}),r.signalExpanded=!1},r.doExpand=function(){r.setState({expanded:!0})},r.doCollapse=function(){r.setState({expanded:!1})},r.addBlockAlignmentData=function(t){var e=r.props,n=e.editorState,o=e.onChange;o(r.state.currentTextAlignment!==t?Object(S.setBlockData)(n,{"text-align":t}):Object(S.setBlockData)(n,{"text-align":void 0}))};var e=r.props.modalHandler;return r.state={currentTextAlignment:void 0},e.registerCallBack(r.expandCollapse),r}return t=i,(e=[{key:"componentDidUpdate",value:function(t){var e=this.props.editorState;e!==t.editorState&&this.setState({currentTextAlignment:Object(S.getSelectedBlocksMetadata)(e).get("text-align")})}},{key:"componentWillUnmount",value:function(){this.props.modalHandler.deregisterCallBack(this.expandCollapse)}},{key:"render",value:function(){var t=this.props,e=t.config,n=t.translations,o=this.state,r=o.expanded,i=o.currentTextAlignment,c=e.component||de;return N.a.createElement(c,{config:e,translations:n,expanded:r,onExpandEvent:this.onExpandEvent,doExpand:this.doExpand,doCollapse:this.doCollapse,currentState:{textAlignment:i},onChange:this.addBlockAlignmentData})}}])&&ye(t.prototype,e),n&&ye(t,n),Object.defineProperty(t,"prototype",{writable:!1}),i}();he.propTypes={editorState:y.a.object.isRequired,onChange:y.a.func.isRequired,modalHandler:y.a.object,config:y.a.object,translations:y.a.object};n(20);function Me(t){return(Me="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function je(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function ve(t,e){return(ve=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function Ne(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=Ee(o);if(r){var n=Ee(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===Me(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function Ee(t){return(Ee=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var Se=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&ve(t,e)}(r,f["Component"]);var t,e,n,o=Ne(r);function r(){var u;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,r);for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];return(u=o.call.apply(o,[this].concat(e))).state={currentStyle:"color"},u.onChange=function(t){(0,u.props.onChange)(u.state.currentStyle,t)},u.setCurrentStyleColor=function(){u.setState({currentStyle:"color"})},u.setCurrentStyleBgcolor=function(){u.setState({currentStyle:"bgcolor"})},u.renderModal=function(){var t=u.props,e=t.config,n=e.popupClassName,o=e.colors,r=t.currentState,i=r.color,c=r.bgColor,a=t.translations,l=u.state.currentStyle,s="color"===l?i:c;return N.a.createElement("div",{className:w()("rdw-colorpicker-modal",n),onClick:j},N.a.createElement("span",{className:"rdw-colorpicker-modal-header"},N.a.createElement("span",{className:w()("rdw-colorpicker-modal-style-label",{"rdw-colorpicker-modal-style-label-active":"color"===l}),onClick:u.setCurrentStyleColor},a["components.controls.colorpicker.text"]),N.a.createElement("span",{className:w()("rdw-colorpicker-modal-style-label",{"rdw-colorpicker-modal-style-label-active":"bgcolor"===l}),onClick:u.setCurrentStyleBgcolor},a["components.controls.colorpicker.background"])),N.a.createElement("span",{className:"rdw-colorpicker-modal-options"},o.map(function(t,e){return N.a.createElement(R,{value:t,key:e,className:"rdw-colorpicker-option",activeClassName:"rdw-colorpicker-option-active",active:s===t,onClick:u.onChange},N.a.createElement("span",{style:{backgroundColor:t},className:"rdw-colorpicker-cube"}))})))},u}return t=r,(e=[{key:"componentDidUpdate",value:function(t){this.props.expanded&&!t.expanded&&this.setState({currentStyle:"color"})}},{key:"render",value:function(){var t=this.props,e=t.config,n=e.icon,o=e.className,r=e.title,i=t.expanded,c=t.onExpandEvent,a=t.translations;return N.a.createElement("div",{className:"rdw-colorpicker-wrapper","aria-haspopup":"true","aria-expanded":i,"aria-label":"rdw-color-picker",title:r||a["components.controls.colorpicker.colorpicker"]},N.a.createElement(R,{onClick:c,className:w()(o)},N.a.createElement("img",{src:n,alt:""})),i?this.renderModal():void 0)}}])&&je(t.prototype,e),n&&je(t,n),Object.defineProperty(t,"prototype",{writable:!1}),r}();Se.propTypes={expanded:y.a.bool,onExpandEvent:y.a.func,onChange:y.a.func,config:y.a.object,currentState:y.a.object,translations:y.a.object};var we=Se;function Ce(t){return(Ce="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function Le(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function De(t,e){return(De=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function ke(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=Oe(o);if(r){var n=Oe(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===Ce(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function Oe(t){return(Oe=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var xe=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&De(t,e)}(i,f["Component"]);var t,e,n,r=ke(i);function i(t){var c;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,i),(c=r.call(this,t)).state={expanded:!1,currentColor:void 0,currentBgColor:void 0},c.onExpandEvent=function(){c.signalExpanded=!c.state.expanded},c.expandCollapse=function(){c.setState({expanded:c.signalExpanded}),c.signalExpanded=!1},c.doExpand=function(){c.setState({expanded:!0})},c.doCollapse=function(){c.setState({expanded:!1})},c.toggleColor=function(t,e){var n=c.props,o=n.editorState,r=n.onChange,i=Object(S.toggleCustomInlineStyle)(o,t,e);i&&r(i),c.doCollapse()};var e=t.editorState,n=t.modalHandler,o={expanded:!1,currentColor:void 0,currentBgColor:void 0};return e&&(o.currentColor=Object(S.getSelectionCustomInlineStyle)(e,["COLOR"]).COLOR,o.currentBgColor=Object(S.getSelectionCustomInlineStyle)(e,["BGCOLOR"]).BGCOLOR),c.state=o,n.registerCallBack(c.expandCollapse),c}return t=i,(e=[{key:"componentDidUpdate",value:function(t){var e=this.props.editorState;e&&e!==t.editorState&&this.setState({currentColor:Object(S.getSelectionCustomInlineStyle)(e,["COLOR"]).COLOR,currentBgColor:Object(S.getSelectionCustomInlineStyle)(e,["BGCOLOR"]).BGCOLOR})}},{key:"componentWillUnmount",value:function(){this.props.modalHandler.deregisterCallBack(this.expandCollapse)}},{key:"render",value:function(){var t=this.props,e=t.config,n=t.translations,o=this.state,r=o.currentColor,i=o.currentBgColor,c=o.expanded,a=e.component||we,l=r&&r.substring(6),s=i&&i.substring(8);return N.a.createElement(a,{config:e,translations:n,onChange:this.toggleColor,expanded:c,onExpandEvent:this.onExpandEvent,doExpand:this.doExpand,doCollapse:this.doCollapse,currentState:{color:l,bgColor:s}})}}])&&Le(t.prototype,e),n&&Le(t,n),Object.defineProperty(t,"prototype",{writable:!1}),i}();xe.propTypes={onChange:y.a.func.isRequired,editorState:y.a.object.isRequired,modalHandler:y.a.object,config:y.a.object,translations:y.a.object};var Ie=xe,Te=n(7),Ae=n.n(Te);n(26);function ze(t){return(ze="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function _e(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function Pe(t,e){return(Pe=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function Re(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=Ue(o);if(r){var n=Ue(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===ze(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function Ue(t){return(Ue=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var Be=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&Pe(t,e)}(r,f["Component"]);var t,e,n,o=Re(r);function r(){var c;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,r);for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];return(c=o.call.apply(o,[this].concat(e))).state={showModal:!1,linkTarget:"",linkTitle:"",linkTargetOption:c.props.config.defaultTargetOption},c.removeLink=function(){(0,c.props.onChange)("unlink")},c.addLink=function(){var t=c.props.onChange,e=c.state;t("link",e.linkTitle,e.linkTarget,e.linkTargetOption)},c.updateValue=function(t){var e,n,o;c.setState((e={},n="".concat(t.target.name),o=t.target.value,n in e?Object.defineProperty(e,n,{value:o,enumerable:!0,configurable:!0,writable:!0}):e[n]=o,e))},c.updateTargetOption=function(t){c.setState({linkTargetOption:t.target.checked?"_blank":"_self"})},c.hideModal=function(){c.setState({showModal:!1})},c.signalExpandShowModal=function(){var t=c.props,e=t.onExpandEvent,n=t.currentState,o=n.link,r=n.selectionText,i=c.state.linkTargetOption;e(),c.setState({showModal:!0,linkTarget:o&&o.target||"",linkTargetOption:o&&o.targetOption||i,linkTitle:o&&o.title||r})},c.forceExpandAndShowModal=function(){var t=c.props,e=t.doExpand,n=t.currentState,o=n.link,r=n.selectionText,i=c.state.linkTargetOption;e(),c.setState({showModal:!0,linkTarget:o&&o.target,linkTargetOption:o&&o.targetOption||i,linkTitle:o&&o.title||r})},c}return t=r,(e=[{key:"componentDidUpdate",value:function(t){t.expanded&&!this.props.expanded&&this.setState({showModal:!1,linkTarget:"",linkTitle:"",linkTargetOption:this.props.config.defaultTargetOption})}},{key:"renderAddLinkModal",value:function(){var t=this.props,e=t.config.popupClassName,n=t.doCollapse,o=t.translations,r=this.state,i=r.linkTitle,c=r.linkTarget,a=r.linkTargetOption;return N.a.createElement("div",{className:w()("rdw-link-modal",e),onClick:j},N.a.createElement("label",{className:"rdw-link-modal-label",htmlFor:"linkTitle"},o["components.controls.link.linkTitle"]),N.a.createElement("input",{id:"linkTitle",className:"rdw-link-modal-input",onChange:this.updateValue,onBlur:this.updateValue,name:"linkTitle",value:i}),N.a.createElement("label",{className:"rdw-link-modal-label",htmlFor:"linkTarget"},o["components.controls.link.linkTarget"]),N.a.createElement("input",{id:"linkTarget",className:"rdw-link-modal-input",onChange:this.updateValue,onBlur:this.updateValue,name:"linkTarget",value:c}),N.a.createElement("label",{className:"rdw-link-modal-target-option",htmlFor:"openLinkInNewWindow"},N.a.createElement("input",{id:"openLinkInNewWindow",type:"checkbox",defaultChecked:"_blank"===a,value:"_blank",onChange:this.updateTargetOption}),N.a.createElement("span",null,o["components.controls.link.linkTargetOption"])),N.a.createElement("span",{className:"rdw-link-modal-buttonsection"},N.a.createElement("button",{className:"rdw-link-modal-btn",onClick:this.addLink,disabled:!c||!i},o["generic.add"]),N.a.createElement("button",{className:"rdw-link-modal-btn",onClick:n},o["generic.cancel"])))}},{key:"renderInFlatList",value:function(){var t=this.props,e=t.config,n=e.options,o=e.link,r=e.unlink,i=e.className,c=t.currentState,a=t.expanded,l=t.translations,s=this.state.showModal;return N.a.createElement("div",{className:w()("rdw-link-wrapper",i),"aria-label":"rdw-link-control"},0<=n.indexOf("link")&&N.a.createElement(R,{value:"unordered-list-item",className:w()(o.className),onClick:this.signalExpandShowModal,"aria-haspopup":"true","aria-expanded":s,title:o.title||l["components.controls.link.link"]},N.a.createElement("img",{src:o.icon,alt:""})),0<=n.indexOf("unlink")&&N.a.createElement(R,{disabled:!c.link,value:"ordered-list-item",className:w()(r.className),onClick:this.removeLink,title:r.title||l["components.controls.link.unlink"]},N.a.createElement("img",{src:r.icon,alt:""})),a&&s?this.renderAddLinkModal():void 0)}},{key:"renderInDropDown",value:function(){var t=this.props,e=t.expanded,n=t.onExpandEvent,o=t.doCollapse,r=t.doExpand,i=t.onChange,c=t.config,a=t.currentState,l=t.translations,s=c.options,u=c.link,p=c.unlink,d=c.className,f=c.dropdownClassName,y=c.title,m=this.state.showModal;return N.a.createElement("div",{className:"rdw-link-wrapper","aria-haspopup":"true","aria-label":"rdw-link-control","aria-expanded":e,title:y},N.a.createElement(H,{className:w()("rdw-link-dropdown",d),optionWrapperClassName:w()(f),onChange:i,expanded:e&&!m,doExpand:r,doCollapse:o,onExpandEvent:n},N.a.createElement("img",{src:v(c),alt:""}),0<=s.indexOf("link")&&N.a.createElement(K,{onClick:this.forceExpandAndShowModal,className:w()("rdw-link-dropdownoption",u.className),title:u.title||l["components.controls.link.link"]},N.a.createElement("img",{src:u.icon,alt:""})),0<=s.indexOf("unlink")&&N.a.createElement(K,{onClick:this.removeLink,disabled:!a.link,className:w()("rdw-link-dropdownoption",p.className),title:p.title||l["components.controls.link.unlink"]},N.a.createElement("img",{src:p.icon,alt:""}))),e&&m?this.renderAddLinkModal():void 0)}},{key:"render",value:function(){return this.props.config.inDropdown?this.renderInDropDown():this.renderInFlatList()}}])&&_e(t.prototype,e),n&&_e(t,n),Object.defineProperty(t,"prototype",{writable:!1}),r}();Be.propTypes={expanded:y.a.bool,doExpand:y.a.func,doCollapse:y.a.func,onExpandEvent:y.a.func,config:y.a.object,onChange:y.a.func,currentState:y.a.object,translations:y.a.object};var Fe=Be;function Ye(t){return(Ye="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function Qe(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function He(t,e){return(He=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function Ze(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=We(o);if(r){var n=We(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===Ye(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function We(t){return(We=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function Ge(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var o=Object.getOwnPropertySymbols(e);t&&(o=o.filter(function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable})),n.push.apply(n,o)}return n}function Je(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?Ge(Object(n),!0).forEach(function(t){Ve(e,t,n[t])}):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):Ge(Object(n)).forEach(function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))})}return e}function Ve(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}function qe(t){var e=Ke.match(t.target);return Je(Je({},t),{},{target:e&&e[0]&&e[0].url||t.target})}var Ke=Ae()(),Xe=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&He(t,e)}(i,f["Component"]);var t,e,n,r=Ze(i);function i(t){var d;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,i),(d=r.call(this,t)).onExpandEvent=function(){d.signalExpanded=!d.state.expanded},d.onChange=function(t,e,n,o){var r=d.props.config.linkCallback;if("link"===t){var i=(r||qe)({title:e,target:n,targetOption:o});d.addLink(i.title,i.target,i.targetOption)}else d.removeLink()},d.getCurrentValues=function(){var t=d.props.editorState,e=d.state.currentEntity,n=t.getCurrentContent(),o={};if(e&&"LINK"===n.getEntity(e).get("type")){o.link={};var r=e&&Object(S.getEntityRange)(t,e);o.link.target=e&&n.getEntity(e).get("data").url,o.link.targetOption=e&&n.getEntity(e).get("data").targetOption,o.link.title=r&&r.text}return o.selectionText=Object(S.getSelectionText)(t),o},d.doExpand=function(){d.setState({expanded:!0})},d.expandCollapse=function(){d.setState({expanded:d.signalExpanded}),d.signalExpanded=!1},d.doCollapse=function(){d.setState({expanded:!1})},d.removeLink=function(){var t=d.props,e=t.editorState,n=t.onChange,o=d.state.currentEntity,r=e.getSelection();if(o){var i=Object(S.getEntityRange)(e,o);r=r.getIsBackward()?r.merge({anchorOffset:i.end,focusOffset:i.start}):r.merge({anchorOffset:i.start,focusOffset:i.end}),n(E.RichUtils.toggleLink(e,r,null))}},d.addLink=function(t,e,n){var o=d.props,r=o.editorState,i=o.onChange,c=d.state.currentEntity,a=r.getSelection();if(c){var l=Object(S.getEntityRange)(r,c);a=a.getIsBackward()?a.merge({anchorOffset:l.end,focusOffset:l.start}):a.merge({anchorOffset:l.start,focusOffset:l.end})}var s=r.getCurrentContent().createEntity("LINK","MUTABLE",{url:e,targetOption:n}).getLastCreatedEntityKey(),u=E.Modifier.replaceText(r.getCurrentContent(),a,"".concat(t),r.getCurrentInlineStyle(),s),p=E.EditorState.push(r,u,"insert-characters");a=p.getSelection().merge({anchorOffset:a.get("anchorOffset")+t.length,focusOffset:a.get("anchorOffset")+t.length}),p=E.EditorState.acceptSelection(p,a),u=E.Modifier.insertText(p.getCurrentContent(),a," ",p.getCurrentInlineStyle(),void 0),i(E.EditorState.push(p,u,"insert-characters")),d.doCollapse()};var e=d.props,n=e.editorState,o=e.modalHandler;return d.state={expanded:!1,link:void 0,selectionText:void 0,currentEntity:n?Object(S.getSelectionEntity)(n):void 0},o.registerCallBack(d.expandCollapse),d}return t=i,(e=[{key:"componentDidUpdate",value:function(t){var e=this.props.editorState;e&&e!==t.editorState&&this.setState({currentEntity:Object(S.getSelectionEntity)(e)})}},{key:"componentWillUnmount",value:function(){this.props.modalHandler.deregisterCallBack(this.expandCollapse)}},{key:"render",value:function(){var t=this.props,e=t.config,n=t.translations,o=this.state.expanded,r=this.getCurrentValues(),i=r.link,c=r.selectionText,a=e.component||Fe;return N.a.createElement(a,{config:e,translations:n,expanded:o,onExpandEvent:this.onExpandEvent,doExpand:this.doExpand,doCollapse:this.doCollapse,currentState:{link:i,selectionText:c},onChange:this.onChange})}}])&&Qe(t.prototype,e),n&&Qe(t,n),Object.defineProperty(t,"prototype",{writable:!1}),i}();Xe.propTypes={editorState:y.a.object.isRequired,onChange:y.a.func.isRequired,modalHandler:y.a.object,config:y.a.object,translations:y.a.object};var $e=Xe;n(27);function tn(t){return(tn="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function en(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function nn(t,e){return(nn=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function on(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=rn(o);if(r){var n=rn(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===tn(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function rn(t){return(rn=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var cn=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&nn(t,e)}(i,f["Component"]);var t,e,n,o=on(i);function i(){var r;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,i);for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];return(r=o.call.apply(o,[this].concat(e))).state={embeddedLink:"",height:r.props.config.defaultSize.height,width:r.props.config.defaultSize.width},r.onChange=function(){var t=r.props.onChange,e=r.state;t(e.embeddedLink,e.height,e.width)},r.updateValue=function(t){var e,n,o;r.setState((e={},n="".concat(t.target.name),o=t.target.value,n in e?Object.defineProperty(e,n,{value:o,enumerable:!0,configurable:!0,writable:!0}):e[n]=o,e))},r}return t=i,(e=[{key:"componentDidUpdate",value:function(t){var e=this.props,n=e.expanded,o=e.config;if(!n&&t.expanded){var r=o.defaultSize,i=r.height,c=r.width;this.setState({embeddedLink:"",height:i,width:c})}}},{key:"rendeEmbeddedLinkModal",value:function(){var t=this.state,e=t.embeddedLink,n=t.height,o=t.width,r=this.props,i=r.config.popupClassName,c=r.doCollapse,a=r.translations;return N.a.createElement("div",{className:w()("rdw-embedded-modal",i),onClick:j},N.a.createElement("div",{className:"rdw-embedded-modal-header"},N.a.createElement("span",{className:"rdw-embedded-modal-header-option"},a["components.controls.embedded.embeddedlink"],N.a.createElement("span",{className:"rdw-embedded-modal-header-label"}))),N.a.createElement("div",{className:"rdw-embedded-modal-link-section"},N.a.createElement("span",{className:"rdw-embedded-modal-link-input-wrapper"},N.a.createElement("input",{className:"rdw-embedded-modal-link-input",placeholder:a["components.controls.embedded.enterlink"],onChange:this.updateValue,onBlur:this.updateValue,value:e,name:"embeddedLink"}),N.a.createElement("span",{className:"rdw-image-mandatory-sign"},"*")),N.a.createElement("div",{className:"rdw-embedded-modal-size"},N.a.createElement("span",null,N.a.createElement("input",{onChange:this.updateValue,onBlur:this.updateValue,value:n,name:"height",className:"rdw-embedded-modal-size-input",placeholder:"Height"}),N.a.createElement("span",{className:"rdw-image-mandatory-sign"},"*")),N.a.createElement("span",null,N.a.createElement("input",{onChange:this.updateValue,onBlur:this.updateValue,value:o,name:"width",className:"rdw-embedded-modal-size-input",placeholder:"Width"}),N.a.createElement("span",{className:"rdw-image-mandatory-sign"},"*")))),N.a.createElement("span",{className:"rdw-embedded-modal-btn-section"},N.a.createElement("button",{type:"button",className:"rdw-embedded-modal-btn",onClick:this.onChange,disabled:!e||!n||!o},a["generic.add"]),N.a.createElement("button",{type:"button",className:"rdw-embedded-modal-btn",onClick:c},a["generic.cancel"])))}},{key:"render",value:function(){var t=this.props,e=t.config,n=e.icon,o=e.className,r=e.title,i=t.expanded,c=t.onExpandEvent,a=t.translations;return N.a.createElement("div",{className:"rdw-embedded-wrapper","aria-haspopup":"true","aria-expanded":i,"aria-label":"rdw-embedded-control"},N.a.createElement(R,{className:w()(o),value:"unordered-list-item",onClick:c,title:r||a["components.controls.embedded.embedded"]},N.a.createElement("img",{src:n,alt:""})),i?this.rendeEmbeddedLinkModal():void 0)}}])&&en(t.prototype,e),n&&en(t,n),Object.defineProperty(t,"prototype",{writable:!1}),i}();cn.propTypes={expanded:y.a.bool,onExpandEvent:y.a.func,onChange:y.a.func,config:y.a.object,translations:y.a.object,doCollapse:y.a.func};var an=cn;function ln(t){return(ln="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function sn(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function un(t,e){return(un=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function pn(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=dn(o);if(r){var n=dn(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===ln(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function dn(t){return(dn=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var fn=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&un(t,e)}(r,f["Component"]);var t,e,n,o=pn(r);function r(){var s;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,r);for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];return(s=o.call.apply(o,[this].concat(e))).state={expanded:!1},s.onExpandEvent=function(){s.signalExpanded=!s.state.expanded},s.expandCollapse=function(){s.setState({expanded:s.signalExpanded}),s.signalExpanded=!1},s.doExpand=function(){s.setState({expanded:!0})},s.doCollapse=function(){s.setState({expanded:!1})},s.addEmbeddedLink=function(t,e,n){var o=s.props,r=o.editorState,i=o.onChange,c=o.config.embedCallback,a=c?c(t):t,l=r.getCurrentContent().createEntity("EMBEDDED_LINK","MUTABLE",{src:a,height:e,width:n}).getLastCreatedEntityKey();i(E.AtomicBlockUtils.insertAtomicBlock(r,l," ")),s.doCollapse()},s}return t=r,(e=[{key:"componentDidMount",value:function(){this.props.modalHandler.registerCallBack(this.expandCollapse)}},{key:"componentWillUnmount",value:function(){this.props.modalHandler.deregisterCallBack(this.expandCollapse)}},{key:"render",value:function(){var t=this.props,e=t.config,n=t.translations,o=this.state.expanded,r=e.component||an;return N.a.createElement(r,{config:e,translations:n,onChange:this.addEmbeddedLink,expanded:o,onExpandEvent:this.onExpandEvent,doExpand:this.doExpand,doCollapse:this.doCollapse})}}])&&sn(t.prototype,e),n&&sn(t,n),Object.defineProperty(t,"prototype",{writable:!1}),r}();fn.propTypes={editorState:y.a.object.isRequired,onChange:y.a.func.isRequired,modalHandler:y.a.object,config:y.a.object,translations:y.a.object};var yn=fn;n(28);function mn(t){return(mn="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function gn(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function bn(t,e){return(bn=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function hn(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=Mn(o);if(r){var n=Mn(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===mn(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function Mn(t){return(Mn=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var jn=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&bn(t,e)}(i,f["Component"]);var t,e,n,r=hn(i);function i(){var e;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,i);for(var t=arguments.length,n=new Array(t),o=0;o<t;o++)n[o]=arguments[o];return(e=r.call.apply(r,[this].concat(n))).onChange=function(t){(0,e.props.onChange)(t.target.innerHTML)},e}return t=i,(e=[{key:"renderEmojiModal",value:function(){var n=this,t=this.props.config,e=t.popupClassName,o=t.emojis;return N.a.createElement("div",{className:w()("rdw-emoji-modal",e),onClick:j},o.map(function(t,e){return N.a.createElement("span",{key:e,className:"rdw-emoji-icon",alt:"",onClick:n.onChange},t)}))}},{key:"render",value:function(){var t=this.props,e=t.config,n=e.icon,o=e.className,r=e.title,i=t.expanded,c=t.onExpandEvent,a=t.translations;return N.a.createElement("div",{className:"rdw-emoji-wrapper","aria-haspopup":"true","aria-label":"rdw-emoji-control","aria-expanded":i,title:r||a["components.controls.emoji.emoji"]},N.a.createElement(R,{className:w()(o),value:"unordered-list-item",onClick:c},N.a.createElement("img",{src:n,alt:""})),i?this.renderEmojiModal():void 0)}}])&&gn(t.prototype,e),n&&gn(t,n),Object.defineProperty(t,"prototype",{writable:!1}),i}();jn.propTypes={expanded:y.a.bool,onExpandEvent:y.a.func,onChange:y.a.func,config:y.a.object,translations:y.a.object};var vn=jn;function Nn(t){return(Nn="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function En(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function Sn(t,e){return(Sn=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function wn(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=Cn(o);if(r){var n=Cn(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===Nn(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function Cn(t){return(Cn=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var Ln=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&Sn(t,e)}(r,f["Component"]);var t,e,n,o=wn(r);function r(){var i;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,r);for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];return(i=o.call.apply(o,[this].concat(e))).state={expanded:!1},i.onExpandEvent=function(){i.signalExpanded=!i.state.expanded},i.expandCollapse=function(){i.setState({expanded:i.signalExpanded}),i.signalExpanded=!1},i.doExpand=function(){i.setState({expanded:!0})},i.doCollapse=function(){i.setState({expanded:!1})},i.addEmoji=function(t){var e=i.props,n=e.editorState,o=e.onChange,r=E.Modifier.replaceText(n.getCurrentContent(),n.getSelection(),t,n.getCurrentInlineStyle());o(E.EditorState.push(n,r,"insert-characters")),i.doCollapse()},i}return t=r,(e=[{key:"componentDidMount",value:function(){this.props.modalHandler.registerCallBack(this.expandCollapse)}},{key:"componentWillUnmount",value:function(){this.props.modalHandler.deregisterCallBack(this.expandCollapse)}},{key:"render",value:function(){var t=this.props,e=t.config,n=t.translations,o=this.state.expanded,r=e.component||vn;return N.a.createElement(r,{config:e,translations:n,onChange:this.addEmoji,expanded:o,onExpandEvent:this.onExpandEvent,doExpand:this.doExpand,doCollapse:this.doCollapse,onCollpase:this.closeModal})}}])&&En(t.prototype,e),n&&En(t,n),Object.defineProperty(t,"prototype",{writable:!1}),r}();Ln.propTypes={editorState:y.a.object.isRequired,onChange:y.a.func.isRequired,modalHandler:y.a.object,config:y.a.object,translations:y.a.object};function Dn(){return N.a.createElement("div",{className:"rdw-spinner"},N.a.createElement("div",{className:"rdw-bounce1"}),N.a.createElement("div",{className:"rdw-bounce2"}),N.a.createElement("div",{className:"rdw-bounce3"}))}n(29),n(30);function kn(t){return(kn="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function On(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function xn(t,e){return(xn=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function In(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=Tn(o);if(r){var n=Tn(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===kn(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function Tn(t){return(Tn=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var An=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&xn(t,e)}(r,f["Component"]);var t,e,n,o=In(r);function r(){var a;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,r);for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];return(a=o.call.apply(o,[this].concat(e))).state={imgSrc:"",dragEnter:!1,uploadHighlighted:a.props.config.uploadEnabled&&!!a.props.config.uploadCallback,showImageLoading:!1,height:a.props.config.defaultSize.height,width:a.props.config.defaultSize.width,alt:""},a.onDragEnter=function(t){a.stopPropagation(t),a.setState({dragEnter:!0})},a.onImageDrop=function(t){var e,n;t.preventDefault(),t.stopPropagation(),a.setState({dragEnter:!1}),n=t.dataTransfer.items?(e=t.dataTransfer.items,!0):(e=t.dataTransfer.files,!1);for(var o=0;o<e.length;o+=1)if((!n||"file"===e[o].kind)&&e[o].type.match("^image/")){var r=n?e[o].getAsFile():e[o];a.uploadImage(r)}},a.showImageUploadOption=function(){a.setState({uploadHighlighted:!0})},a.addImageFromState=function(){var t=a.state,e=t.imgSrc,n=t.alt,o=a.state,r=o.height,i=o.width,c=a.props.onChange;isNaN(r)||(r+="px"),isNaN(i)||(i+="px"),c(e,r,i,n)},a.showImageURLOption=function(){a.setState({uploadHighlighted:!1})},a.toggleShowImageLoading=function(){var t=!a.state.showImageLoading;a.setState({showImageLoading:t})},a.updateValue=function(t){var e,n,o;a.setState((e={},n="".concat(t.target.name),o=t.target.value,n in e?Object.defineProperty(e,n,{value:o,enumerable:!0,configurable:!0,writable:!0}):e[n]=o,e))},a.selectImage=function(t){t.target.files&&0<t.target.files.length&&a.uploadImage(t.target.files[0])},a.uploadImage=function(t){a.toggleShowImageLoading(),(0,a.props.config.uploadCallback)(t).then(function(t){var e=t.data;a.setState({showImageLoading:!1,dragEnter:!1,imgSrc:e.link||e.url}),a.fileUpload=!1}).catch(function(){a.setState({showImageLoading:!1,dragEnter:!1})})},a.fileUploadClick=function(t){a.fileUpload=!0,t.stopPropagation()},a.stopPropagation=function(t){a.fileUpload?a.fileUpload=!1:(t.preventDefault(),t.stopPropagation())},a}return t=r,(e=[{key:"componentDidUpdate",value:function(t){var e=this.props.config;t.expanded&&!this.props.expanded?this.setState({imgSrc:"",dragEnter:!1,uploadHighlighted:e.uploadEnabled&&!!e.uploadCallback,showImageLoading:!1,height:e.defaultSize.height,width:e.defaultSize.width,alt:""}):e.uploadCallback===t.config.uploadCallback&&e.uploadEnabled===t.config.uploadEnabled||this.setState({uploadHighlighted:e.uploadEnabled&&!!e.uploadCallback})}},{key:"renderAddImageModal",value:function(){var t=this.state,e=t.imgSrc,n=t.uploadHighlighted,o=t.showImageLoading,r=t.dragEnter,i=t.height,c=t.width,a=t.alt,l=this.props,s=l.config,u=s.popupClassName,p=s.uploadCallback,d=s.uploadEnabled,f=s.urlEnabled,y=s.previewImage,m=s.inputAccept,g=s.alt,b=l.doCollapse,h=l.translations;return N.a.createElement("div",{className:w()("rdw-image-modal",u),onClick:this.stopPropagation},N.a.createElement("div",{className:"rdw-image-modal-header"},d&&p&&N.a.createElement("span",{onClick:this.showImageUploadOption,className:"rdw-image-modal-header-option"},h["components.controls.image.fileUpload"],N.a.createElement("span",{className:w()("rdw-image-modal-header-label",{"rdw-image-modal-header-label-highlighted":n})})),f&&N.a.createElement("span",{onClick:this.showImageURLOption,className:"rdw-image-modal-header-option"},h["components.controls.image.byURL"],N.a.createElement("span",{className:w()("rdw-image-modal-header-label",{"rdw-image-modal-header-label-highlighted":!n})}))),n?N.a.createElement("div",{onClick:this.fileUploadClick},N.a.createElement("div",{onDragEnter:this.onDragEnter,onDragOver:this.stopPropagation,onDrop:this.onImageDrop,className:w()("rdw-image-modal-upload-option",{"rdw-image-modal-upload-option-highlighted":r})},N.a.createElement("label",{htmlFor:"file",className:"rdw-image-modal-upload-option-label"},y&&e?N.a.createElement("img",{src:e,alt:e,className:"rdw-image-modal-upload-option-image-preview"}):e||h["components.controls.image.dropFileText"])),N.a.createElement("input",{type:"file",id:"file",accept:m,onChange:this.selectImage,className:"rdw-image-modal-upload-option-input"})):N.a.createElement("div",{className:"rdw-image-modal-url-section"},N.a.createElement("input",{className:"rdw-image-modal-url-input",placeholder:h["components.controls.image.enterlink"],name:"imgSrc",onChange:this.updateValue,onBlur:this.updateValue,value:e}),N.a.createElement("span",{className:"rdw-image-mandatory-sign"},"*")),g.present&&N.a.createElement("div",{className:"rdw-image-modal-size"},N.a.createElement("span",{className:"rdw-image-modal-alt-lbl"},"Alt Text"),N.a.createElement("input",{onChange:this.updateValue,onBlur:this.updateValue,value:a,name:"alt",className:"rdw-image-modal-alt-input",placeholder:"alt"}),N.a.createElement("span",{className:"rdw-image-mandatory-sign"},g.mandatory&&"*")),N.a.createElement("div",{className:"rdw-image-modal-size"},"↕ ",N.a.createElement("input",{onChange:this.updateValue,onBlur:this.updateValue,value:i,name:"height",className:"rdw-image-modal-size-input",placeholder:"Height"}),N.a.createElement("span",{className:"rdw-image-mandatory-sign"},"*")," ↔ ",N.a.createElement("input",{onChange:this.updateValue,onBlur:this.updateValue,value:c,name:"width",className:"rdw-image-modal-size-input",placeholder:"Width"}),N.a.createElement("span",{className:"rdw-image-mandatory-sign"},"*")),N.a.createElement("span",{className:"rdw-image-modal-btn-section"},N.a.createElement("button",{className:"rdw-image-modal-btn",onClick:this.addImageFromState,disabled:!e||!i||!c||g.mandatory&&!a},h["generic.add"]),N.a.createElement("button",{className:"rdw-image-modal-btn",onClick:b},h["generic.cancel"])),o?N.a.createElement("div",{className:"rdw-image-modal-spinner"},N.a.createElement(Dn,null)):void 0)}},{key:"render",value:function(){var t=this.props,e=t.config,n=e.icon,o=e.className,r=e.title,i=t.expanded,c=t.onExpandEvent,a=t.translations;return N.a.createElement("div",{className:"rdw-image-wrapper","aria-haspopup":"true","aria-expanded":i,"aria-label":"rdw-image-control"},N.a.createElement(R,{className:w()(o),value:"unordered-list-item",onClick:c,title:r||a["components.controls.image.image"]},N.a.createElement("img",{src:n,alt:""})),i?this.renderAddImageModal():void 0)}}])&&On(t.prototype,e),n&&On(t,n),Object.defineProperty(t,"prototype",{writable:!1}),r}();An.propTypes={expanded:y.a.bool,onExpandEvent:y.a.func,doCollapse:y.a.func,onChange:y.a.func,config:y.a.object,translations:y.a.object};var zn=An;function _n(t){return(_n="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function Pn(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function Rn(t,e){return(Rn=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function Un(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=Bn(o);if(r){var n=Bn(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===_n(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function Bn(t){return(Bn=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var Fn=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&Rn(t,e)}(r,f["Component"]);var t,e,n,o=Un(r);function r(t){var s;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,r),(s=o.call(this,t)).onExpandEvent=function(){s.signalExpanded=!s.state.expanded},s.doExpand=function(){s.setState({expanded:!0})},s.doCollapse=function(){s.setState({expanded:!1})},s.expandCollapse=function(){s.setState({expanded:s.signalExpanded}),s.signalExpanded=!1},s.addImage=function(t,e,n,o){var r=s.props,i=r.editorState,c=r.onChange,a={src:t,height:e,width:n};r.config.alt.present&&(a.alt=o);var l=i.getCurrentContent().createEntity("IMAGE","MUTABLE",a).getLastCreatedEntityKey();c(E.AtomicBlockUtils.insertAtomicBlock(i,l," ")),s.doCollapse()};var e=s.props.modalHandler;return s.state={expanded:!1},e.registerCallBack(s.expandCollapse),s}return t=r,(e=[{key:"componentWillUnmount",value:function(){this.props.modalHandler.deregisterCallBack(this.expandCollapse)}},{key:"render",value:function(){var t=this.props,e=t.config,n=t.translations,o=this.state.expanded,r=e.component||zn;return N.a.createElement(r,{config:e,translations:n,onChange:this.addImage,expanded:o,onExpandEvent:this.onExpandEvent,doExpand:this.doExpand,doCollapse:this.doCollapse})}}])&&Pn(t.prototype,e),n&&Pn(t,n),Object.defineProperty(t,"prototype",{writable:!1}),r}();Fn.propTypes={editorState:y.a.object.isRequired,onChange:y.a.func.isRequired,modalHandler:y.a.object,config:y.a.object,translations:y.a.object};function Yn(t){var e=t.config,n=t.onChange,o=t.translations,r=e.icon,i=e.className,c=e.title;return N.a.createElement("div",{className:"rdw-remove-wrapper","aria-label":"rdw-remove-control"},N.a.createElement(R,{className:w()(i),onClick:n,title:c||o["components.controls.remove.remove"]},N.a.createElement("img",{src:r,alt:""})))}var Qn=Fn;n(31);Yn.propTypes={onChange:y.a.func,config:y.a.object,translations:y.a.object};var Hn=Yn;function Zn(t){return(Zn="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function Wn(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function Gn(t,e){return(Gn=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function Jn(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=Vn(o);if(r){var n=Vn(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===Zn(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function Vn(t){return(Vn=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var qn=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&Gn(t,e)}(i,f["Component"]);var t,e,n,r=Jn(i);function i(){var n;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,i);for(var t=arguments.length,e=new Array(t),o=0;o<t;o++)e[o]=arguments[o];return(n=r.call.apply(r,[this].concat(e))).state={expanded:!1},n.onExpandEvent=function(){n.signalExpanded=!n.state.expanded},n.expandCollapse=function(){n.setState({expanded:n.signalExpanded}),n.signalExpanded=!1},n.removeInlineStyles=function(){var t=n.props,e=t.editorState;(0,t.onChange)(n.removeAllInlineStyles(e))},n.removeAllInlineStyles=function(n){var o=n.getCurrentContent();return["BOLD","ITALIC","UNDERLINE","STRIKETHROUGH","MONOSPACE","SUPERSCRIPT","SUBSCRIPT"].forEach(function(t){o=E.Modifier.removeInlineStyle(o,n.getSelection(),t)}),h(Object(S.getSelectionCustomInlineStyle)(n,["FONTSIZE","FONTFAMILY","COLOR","BGCOLOR"]),function(t,e){e&&(o=E.Modifier.removeInlineStyle(o,n.getSelection(),e))}),E.EditorState.push(n,o,"change-inline-style")},n.doExpand=function(){n.setState({expanded:!0})},n.doCollapse=function(){n.setState({expanded:!1})},n}return t=i,(e=[{key:"componentDidMount",value:function(){this.props.modalHandler.registerCallBack(this.expandCollapse)}},{key:"componentWillUnmount",value:function(){this.props.modalHandler.deregisterCallBack(this.expandCollapse)}},{key:"render",value:function(){var t=this.props,e=t.config,n=t.translations,o=this.state.expanded,r=e.component||Hn;return N.a.createElement(r,{config:e,translations:n,expanded:o,onExpandEvent:this.onExpandEvent,doExpand:this.doExpand,doCollapse:this.doCollapse,onChange:this.removeInlineStyles})}}])&&Wn(t.prototype,e),n&&Wn(t,n),Object.defineProperty(t,"prototype",{writable:!1}),i}();qn.propTypes={onChange:y.a.func.isRequired,editorState:y.a.object.isRequired,config:y.a.object,translations:y.a.object,modalHandler:y.a.object};n(32);function Kn(t){return(Kn="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function Xn(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function $n(t,e){return($n=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function to(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=eo(o);if(r){var n=eo(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===Kn(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function eo(t){return(eo=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var no=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&$n(t,e)}(i,f["Component"]);var t,e,n,r=to(i);function i(){var e;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,i);for(var t=arguments.length,n=new Array(t),o=0;o<t;o++)n[o]=arguments[o];return(e=r.call.apply(r,[this].concat(n))).onChange=function(t){(0,e.props.onChange)(t)},e}return t=i,(e=[{key:"renderInDropDown",value:function(){var t=this.props,e=t.config,n=t.expanded,o=t.doExpand,r=t.onExpandEvent,i=t.doCollapse,c=t.currentState,a=c.undoDisabled,l=c.redoDisabled,s=t.translations,u=e.options,p=e.undo,d=e.redo,f=e.className,y=e.dropdownClassName,m=e.title;return N.a.createElement(H,{className:w()("rdw-history-dropdown",f),optionWrapperClassName:w()(y),expanded:n,doExpand:o,doCollapse:i,onExpandEvent:r,"aria-label":"rdw-history-control",title:m||s["components.controls.history.history"]},N.a.createElement("img",{src:v(e),alt:""}),0<=u.indexOf("undo")&&N.a.createElement(K,{value:"undo",onClick:this.onChange,disabled:a,className:w()("rdw-history-dropdownoption",p.className),title:p.title||s["components.controls.history.undo"]},N.a.createElement("img",{src:p.icon,alt:""})),0<=u.indexOf("redo")&&N.a.createElement(K,{value:"redo",onClick:this.onChange,disabled:l,className:w()("rdw-history-dropdownoption",d.className),title:d.title||s["components.controls.history.redo"]},N.a.createElement("img",{src:d.icon,alt:""})))}},{key:"renderInFlatList",value:function(){var t=this.props,e=t.config,n=e.options,o=e.undo,r=e.redo,i=e.className,c=t.currentState,a=c.undoDisabled,l=c.redoDisabled,s=t.translations;return N.a.createElement("div",{className:w()("rdw-history-wrapper",i),"aria-label":"rdw-history-control"},0<=n.indexOf("undo")&&N.a.createElement(R,{value:"undo",onClick:this.onChange,className:w()(o.className),disabled:a,title:o.title||s["components.controls.history.undo"]},N.a.createElement("img",{src:o.icon,alt:""})),0<=n.indexOf("redo")&&N.a.createElement(R,{value:"redo",onClick:this.onChange,className:w()(r.className),disabled:l,title:r.title||s["components.controls.history.redo"]},N.a.createElement("img",{src:r.icon,alt:""})))}},{key:"render",value:function(){return this.props.config.inDropdown?this.renderInDropDown():this.renderInFlatList()}}])&&Xn(t.prototype,e),n&&Xn(t,n),Object.defineProperty(t,"prototype",{writable:!1}),i}();function oo(t){return(oo="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function ro(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function io(t,e){return(io=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function co(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=ao(o);if(r){var n=ao(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===oo(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function ao(t){return(ao=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}no.propTypes={expanded:y.a.bool,doExpand:y.a.func,doCollapse:y.a.func,onExpandEvent:y.a.func,config:y.a.object,onChange:y.a.func,currentState:y.a.object,translations:y.a.object};var lo=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&io(t,e)}(c,f["Component"]);var t,e,n,r=co(c);function c(t){var i;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,c),(i=r.call(this,t)).onExpandEvent=function(){i.signalExpanded=!i.state.expanded},i.onChange=function(t){var e=i.props,n=e.editorState,o=e.onChange,r=E.EditorState[t](n);r&&o(r)},i.doExpand=function(){i.setState({expanded:!0})},i.doCollapse=function(){i.setState({expanded:!1})};var e={expanded:!(i.expandCollapse=function(){i.setState({expanded:i.signalExpanded}),i.signalExpanded=!1}),undoDisabled:!1,redoDisabled:!1},n=t.editorState,o=t.modalHandler;return n&&(e.undoDisabled=0===n.getUndoStack().size,e.redoDisabled=0===n.getRedoStack().size),i.state=e,o.registerCallBack(i.expandCollapse),i}return t=c,(e=[{key:"componentDidUpdate",value:function(t){var e=this.props.editorState;e&&t.editorState!==e&&this.setState({undoDisabled:0===e.getUndoStack().size,redoDisabled:0===e.getRedoStack().size})}},{key:"componentWillUnmount",value:function(){this.props.modalHandler.deregisterCallBack(this.expandCollapse)}},{key:"render",value:function(){var t=this.props,e=t.config,n=t.translations,o=this.state,r=o.undoDisabled,i=o.redoDisabled,c=o.expanded,a=e.component||no;return N.a.createElement(a,{config:e,translations:n,currentState:{undoDisabled:r,redoDisabled:i},expanded:c,onExpandEvent:this.onExpandEvent,doExpand:this.doExpand,doCollapse:this.doCollapse,onChange:this.onChange})}}])&&ro(t.prototype,e),n&&ro(t,n),Object.defineProperty(t,"prototype",{writable:!1}),c}();lo.propTypes={onChange:y.a.func.isRequired,editorState:y.a.object,modalHandler:y.a.object,config:y.a.object,translations:y.a.object};var so={inline:st,blockType:Et,fontSize:zt,fontFamily:Jt,list:ce,textAlign:he,colorPicker:Ie,link:$e,embedded:yn,emoji:Ln,image:Qn,remove:qn,history:lo},uo=/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205f\u3000]/g,po=/^(?:(?:https?|ftps?|mailto):|[^a-z]|[a-z+.-]+(?:[^a-z+.:-]|$))/i;function fo(t){return String(t).replace(uo,"").match(po)?t:"#"}n(33);function yo(t){return(yo="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function mo(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function go(t,e){return(go=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function bo(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=ho(o);if(r){var n=ho(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===yo(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function ho(t){return(ho=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function Mo(t,e,n){t.findEntityRanges(function(t){var e=t.getEntity();return null!==e&&"LINK"===n.getEntity(e).getType()},e)}function jo(t){var e,a=t.showOpenOptionOnHover;return(e=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&go(t,e)}(i,f["Component"]);var t,e,n,o=bo(i);function i(){var r;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,i);for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];return(r=o.call.apply(o,[this].concat(e))).state={showPopOver:!1},r.openLink=function(){var t=r.props,e=t.entityKey,n=t.contentState.getEntity(e).getData().url,o=window.open(fo(n),"blank");o&&o.focus()},r.toggleShowPopOver=function(){var t=!r.state.showPopOver;r.setState({showPopOver:t})},r}return t=i,(e=[{key:"render",value:function(){var t=this.props,e=t.children,n=t.entityKey,o=t.contentState.getEntity(n).getData(),r=o.url,i=o.targetOption,c=this.state.showPopOver;return N.a.createElement("span",{className:"rdw-link-decorator-wrapper",onMouseEnter:this.toggleShowPopOver,onMouseLeave:this.toggleShowPopOver},N.a.createElement("a",{href:fo(r),target:i},e),c&&a?N.a.createElement("img",{src:"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNMTQuMDcyIDBIOC45MTVhLjkyNS45MjUgMCAwIDAgMCAxLjg0OWgyLjkyNUw2Ljk2MSA2LjcyN2EuOTE4LjkxOCAwIDAgMC0uMjcuNjU0YzAgLjI0Ny4wOTUuNDguMjcuNjU0YS45MTguOTE4IDAgMCAwIC42NTQuMjcuOTE4LjkxOCAwIDAgMCAuNjUzLS4yN2w0Ljg4LTQuODh2Mi45MjZhLjkyNS45MjUgMCAwIDAgMS44NDggMFYuOTI0QS45MjUuOTI1IDAgMCAwIDE0LjA3MiAweiIvPjxwYXRoIGQ9Ik0xMC42MjMgMTMuNDExSDEuNTg1VjQuMzcyaDYuNzk4bDEuNTg0LTEuNTg0SC43OTJBLjc5Mi43OTIgMCAwIDAgMCAzLjU4djEwLjYyNGMwIC40MzcuMzU1Ljc5Mi43OTIuNzkyaDEwLjYyNGEuNzkyLjc5MiAwIDAgMCAuNzkyLS43OTJWNS4wMjlsLTEuNTg1IDEuNTg0djYuNzk4eiIvPjwvZz48L3N2Zz4=",alt:"",onClick:this.openLink,className:"rdw-link-decorator-icon"}):void 0)}}])&&mo(t.prototype,e),n&&mo(t,n),Object.defineProperty(t,"prototype",{writable:!1}),i}()).propTypes={entityKey:y.a.string.isRequired,children:y.a.array,contentState:y.a.object},e}n(34);function vo(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function No(t,e,n){return e&&vo(t.prototype,e),n&&vo(t,n),Object.defineProperty(t,"prototype",{writable:!1}),t}var Eo=No(function t(e){var n=this;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this.getMentionComponent=function(){function t(t){var e=t.entityKey,n=t.children,o=t.contentState.getEntity(e).getData(),r=o.url,i=o.value;return N.a.createElement("a",{href:r||i,className:w()("rdw-mention-link",c)},n)}var c=n.className;return t.propTypes={entityKey:y.a.number,children:y.a.array,contentState:y.a.object},t},this.getMentionDecorator=function(){return{strategy:n.findMentionEntities,component:n.getMentionComponent()}},this.className=e});Eo.prototype.findMentionEntities=function(t,e,n){t.findEntityRanges(function(t){var e=t.getEntity();return null!==e&&"MENTION"===n.getEntity(e).getType()},e)};var So=Eo;n(35);function wo(t){return(wo="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function Co(t,e){return(Co=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function Lo(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=Do(o);if(r){var n=Do(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===wo(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function Do(t){return(Do=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function ko(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function Oo(t,e,n){return e&&ko(t.prototype,e),n&&ko(t,n),Object.defineProperty(t,"prototype",{writable:!1}),t}function xo(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}var Io=Oo(function t(e){var p=this;xo(this,t),this.findSuggestionEntities=function(t,e){if(p.config.getEditorState()){var n=p.config,o=n.separator,r=n.trigger,i=n.getSuggestions,c=(0,n.getEditorState)().getSelection();if(c.get("anchorKey")===t.get("key")&&c.get("anchorKey")===c.get("focusKey")){var a=t.getText(),l=(a=a.substr(0,c.get("focusOffset")===a.length-1?a.length:c.get("focusOffset")+1)).lastIndexOf(o+r),s=o+r;if((void 0===l||l<0)&&a[0]===r&&(l=0,s=r),0<=l){var u=a.substr(l+s.length,a.length);i().some(function(t){return!!t.value&&(p.config.caseSensitive?0<=t.value.indexOf(u):0<=t.value.toLowerCase().indexOf(u&&u.toLowerCase()))})&&e(0===l?0:l+1,a.length)}}}},this.getSuggestionComponent=function(){var t,a=this.config;return(t=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&Co(t,e)}(r,f["Component"]);var o=Lo(r);function r(){var c;xo(this,r);for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];return(c=o.call.apply(o,[this].concat(e))).state={style:{left:15},activeOption:-1,showSuggestions:!0},c.onEditorKeyDown=function(t){var e=c.state.activeOption,n={};"ArrowDown"===t.key?(t.preventDefault(),e===c.filteredSuggestions.length-1?n.activeOption=0:n.activeOption=e+1):"ArrowUp"===t.key?n.activeOption=e<=0?c.filteredSuggestions.length-1:e-1:"Escape"===t.key?(n.showSuggestions=!1,g()):"Enter"===t.key&&c.addMention(),c.setState(n)},c.onOptionMouseEnter=function(t){var e=t.target.getAttribute("data-index");c.setState({activeOption:e})},c.onOptionMouseLeave=function(){c.setState({activeOption:-1})},c.setSuggestionReference=function(t){c.suggestion=t},c.setDropdownReference=function(t){c.dropdown=t},c.closeSuggestionDropdown=function(){c.setState({showSuggestions:!1})},c.filteredSuggestions=[],c.filterSuggestions=function(t){var e=t.children[0].props.text.substr(1),n=a.getSuggestions();c.filteredSuggestions=n&&n.filter(function(t){return!e||0===e.length||(a.caseSensitive?0<=t.value.indexOf(e):0<=t.value.toLowerCase().indexOf(e&&e.toLowerCase()))})},c.addMention=function(){var t=c.state.activeOption,e=a.getEditorState(),n=a.onChange,o=a.separator,r=a.trigger,i=c.filteredSuggestions[t];i&&function(t,e,n,o,r){var i=r.value,c=r.url,a=t.getCurrentContent().createEntity("MENTION","IMMUTABLE",{text:"".concat(o).concat(i),value:i,url:c}).getLastCreatedEntityKey(),l=Object(S.getSelectedBlock)(t).getText(),s=t.getSelection().focusOffset,u=(l.lastIndexOf(n+o,s)||0)+1,p=!1;l.length===u+1&&(s=l.length)," "===l[s]&&(p=!0);var d=t.getSelection().merge({anchorOffset:u,focusOffset:s}),f=E.EditorState.acceptSelection(t,d),y=E.Modifier.replaceText(f.getCurrentContent(),d,"".concat(o).concat(i),f.getCurrentInlineStyle(),a);f=E.EditorState.push(f,y,"insert-characters"),p||(d=f.getSelection().merge({anchorOffset:u+i.length+o.length,focusOffset:u+i.length+o.length}),f=E.EditorState.acceptSelection(f,d),y=E.Modifier.insertText(f.getCurrentContent(),d," ",f.getCurrentInlineStyle(),void 0)),e(E.EditorState.push(f,y,"insert-characters"))}(e,n,o,r,i)},c}return Oo(r,[{key:"componentDidMount",value:function(){var t,e,n,o=a.getWrapperRef().getBoundingClientRect(),r=this.suggestion.getBoundingClientRect(),i=this.dropdown.getBoundingClientRect();o.width<r.left-o.left+i.width?e=15:t=15,o.bottom<i.bottom&&(n=0),this.setState({style:{left:t,right:e,bottom:n}}),C.registerCallBack(this.onEditorKeyDown),m(),a.modalHandler.setSuggestionCallback(this.closeSuggestionDropdown),this.filterSuggestions(this.props)}},{key:"componentDidUpdate",value:function(t){this.props.children!==t.children&&(this.filterSuggestions(t),this.setState({showSuggestions:!0}))}},{key:"componentWillUnmount",value:function(){C.deregisterCallBack(this.onEditorKeyDown),g(),a.modalHandler.removeSuggestionCallback()}},{key:"render",value:function(){var n=this,t=this.props.children,e=this.state,o=e.activeOption,r=e.showSuggestions,i=a.dropdownClassName,c=a.optionClassName;return N.a.createElement("span",{className:"rdw-suggestion-wrapper",ref:this.setSuggestionReference,onClick:a.modalHandler.onSuggestionClick,"aria-haspopup":"true","aria-label":"rdw-suggestion-popup"},N.a.createElement("span",null,t),r&&N.a.createElement("span",{className:w()("rdw-suggestion-dropdown",i),contentEditable:"false",suppressContentEditableWarning:!0,style:this.state.style,ref:this.setDropdownReference},this.filteredSuggestions.map(function(t,e){return N.a.createElement("span",{key:e,spellCheck:!1,onClick:n.addMention,"data-index":e,onMouseEnter:n.onOptionMouseEnter,onMouseLeave:n.onOptionMouseLeave,className:w()("rdw-suggestion-option",c,{"rdw-suggestion-option-active":e===o})},t.text)})))}}]),r}()).propTypes={children:y.a.array},t}.bind(this),this.getSuggestionDecorator=function(){return{strategy:p.findSuggestionEntities,component:p.getSuggestionComponent()}};var n=e.separator,o=e.trigger,r=e.getSuggestions,i=e.onChange,c=e.getEditorState,a=e.getWrapperRef,l=e.caseSensitive,s=e.dropdownClassName,u=e.optionClassName,d=e.modalHandler;this.config={separator:n,trigger:o,getSuggestions:r,onChange:i,getEditorState:c,getWrapperRef:a,caseSensitive:l,dropdownClassName:s,optionClassName:u,modalHandler:d}}),To=function(t){return[new So(t.mentionClassName).getMentionDecorator(),new Io(t).getSuggestionDecorator()]};n(36);function Ao(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function zo(t,e,n){return e&&Ao(t.prototype,e),n&&Ao(t,n),Object.defineProperty(t,"prototype",{writable:!1}),t}function _o(t){var e=t.block,n=t.contentState.getEntity(e.getEntityAt(0)).getData(),o=n.src,r=n.height,i=n.width;return N.a.createElement("iframe",{height:r,width:i,src:o,frameBorder:"0",allowFullScreen:!0,title:"Wysiwyg Embedded Content"})}var Po=zo(function t(e){var a=this;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this.getHashtagComponent=function(){function t(t){var e=t.children,n=e[0].props.text;return N.a.createElement("a",{href:n,className:w()("rdw-hashtag-link",o)},e)}var o=a.className;return t.propTypes={children:y.a.object},t},this.findHashtagEntities=function(t,e){for(var n=t.getText(),o=0,r=0;0<n.length&&0<=o;)if(n[0]===a.hashCharacter?(r=o=0,n=n.substr(a.hashCharacter.length)):0<=(o=n.indexOf(a.separator+a.hashCharacter))&&(n=n.substr(o+(a.separator+a.hashCharacter).length),r+=o+a.separator.length),0<=o){var i=0<=n.indexOf(a.separator)?n.indexOf(a.separator):n.length,c=n.substr(0,i);c&&0<c.length&&(e(r,r+c.length+a.hashCharacter.length),r+=a.hashCharacter.length)}},this.getHashtagDecorator=function(){return{strategy:a.findHashtagEntities,component:a.getHashtagComponent()}},this.className=e.className,this.hashCharacter=e.hashCharacter||"#",this.separator=e.separator||" "}),Ro=function(t){return new Po(t).getHashtagDecorator()};_o.propTypes={block:y.a.object,contentState:y.a.object};var Uo=_o;n(37);function Bo(t){return(Bo="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function Fo(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function Yo(t,e){return(Yo=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function Qo(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=Ho(o);if(r){var n=Ho(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===Bo(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function Ho(t){return(Ho=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var Zo=function(d){var t;return(t=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&Yo(t,e)}(r,f["Component"]);var t,e,n,o=Qo(r);function r(){var i;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,r);for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];return(i=o.call.apply(o,[this].concat(e))).state={hovered:!1},i.setEntityAlignmentLeft=function(){i.setEntityAlignment("left")},i.setEntityAlignmentRight=function(){i.setEntityAlignment("right")},i.setEntityAlignmentCenter=function(){i.setEntityAlignment("none")},i.setEntityAlignment=function(t){var e=i.props,n=e.block,o=e.contentState,r=n.getEntityAt(0);o.mergeEntityData(r,{alignment:t}),d.onChange(E.EditorState.push(d.getEditorState(),o,"change-block-data")),i.setState({dummy:!0})},i.toggleHovered=function(){var t=!i.state.hovered;i.setState({hovered:t})},i}return t=r,(e=[{key:"renderAlignmentOptions",value:function(t){return N.a.createElement("div",{className:w()("rdw-image-alignment-options-popup",{"rdw-image-alignment-options-popup-right":"right"===t})},N.a.createElement(R,{onClick:this.setEntityAlignmentLeft,className:"rdw-image-alignment-option"},"L"),N.a.createElement(R,{onClick:this.setEntityAlignmentCenter,className:"rdw-image-alignment-option"},"C"),N.a.createElement(R,{onClick:this.setEntityAlignmentRight,className:"rdw-image-alignment-option"},"R"))}},{key:"render",value:function(){var t=this.props,e=t.block,n=t.contentState,o=this.state.hovered,r=d.isReadOnly,i=d.isImageAlignmentEnabled,c=n.getEntity(e.getEntityAt(0)).getData(),a=c.src,l=c.alignment,s=c.height,u=c.width,p=c.alt;return N.a.createElement("span",{onMouseEnter:this.toggleHovered,onMouseLeave:this.toggleHovered,className:w()("rdw-image-alignment",{"rdw-image-left":"left"===l,"rdw-image-right":"right"===l,"rdw-image-center":!l||"none"===l})},N.a.createElement("span",{className:"rdw-image-imagewrapper"},N.a.createElement("img",{src:a,alt:p,style:{height:s,width:u}}),!r()&&o&&i()?this.renderAlignmentOptions(l):void 0))}}])&&Fo(t.prototype,e),n&&Fo(t,n),Object.defineProperty(t,"prototype",{writable:!1}),r}()).propTypes={block:y.a.object,contentState:y.a.object},t},Wo=function(o,r){return function(t){if("function"==typeof r){var e=r(t,o,o.getEditorState);if(e)return e}if("atomic"===t.getType()){var n=o.getEditorState().getCurrentContent().getEntity(t.getEntityAt(0));if(n&&"IMAGE"===n.type)return{component:Zo(o),editable:!1};if(n&&"EMBEDDED_LINK"===n.type)return{component:Uo,editable:!1}}}},Go={options:["inline","blockType","fontSize","fontFamily","list","textAlign","colorPicker","link","embedded","emoji","image","remove","history"],inline:{inDropdown:!1,className:void 0,component:void 0,dropdownClassName:void 0,options:["bold","italic","underline","strikethrough","monospace","superscript","subscript"],bold:{icon:"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTMiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTYuMjM2IDBjMS42NTIgMCAyLjk0LjI5OCAzLjg2Ni44OTMuOTI1LjU5NSAxLjM4OCAxLjQ4NSAxLjM4OCAyLjY2OSAwIC42MDEtLjE3MyAxLjEzOS0uNTE2IDEuNjEtLjM0My40NzQtLjg0NC44My0xLjQ5OSAxLjA2OC44NDMuMTY3IDEuNDc0LjUyMyAxLjg5NSAxLjA3MS40MTkuNTUuNjMgMS4xODMuNjMgMS45MDMgMCAxLjI0NS0uNDQ0IDIuMTg3LTEuMzMgMi44MjUtLjg4Ni42NDEtMi4xNDQuOTYxLTMuNzY5Ljk2MUgwdi0yLjE2N2gxLjQ5NFYyLjE2N0gwVjBoNi4yMzZ6TTQuMzA4IDUuNDQ2aDIuMDI0Yy43NTIgMCAxLjMzLS4xNDMgMS43MzQtLjQzLjQwNS0uMjg1LjYwOC0uNzAxLjYwOC0xLjI1IDAtLjYtLjIwNC0xLjA0NC0uNjEyLTEuMzMtLjQwOC0uMjg2LTEuMDE2LS40MjctMS44MjYtLjQyN0g0LjMwOHYzLjQzN3ptMCAxLjgwNFYxMWgyLjU5M2MuNzQ3IDAgMS4zMTQtLjE1MiAxLjcwNy0uNDUyLjM5LS4zLjU4OC0uNzQ1LjU4OC0xLjMzNCAwLS42MzYtLjE2OC0xLjEyNC0uNS0xLjQ2LS4zMzYtLjMzNS0uODY0LS41MDQtMS41ODItLjUwNEg0LjMwOHoiIGZpbGw9IiMwMDAiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg==",className:void 0,title:void 0},italic:{icon:"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiI+PHBhdGggZD0iTTcgM1YyaDR2MUg5Ljc1M2wtMyAxMEg4djFINHYtMWgxLjI0N2wzLTEwSDd6Ii8+PC9zdmc+",className:void 0,title:void 0},underline:{icon:"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiI+PHBhdGggZD0iTTYuMDQ1IDJ2Ljk5Mkw0Ljc4NSAzdjUuMTcyYzAgLjg1OS4yNDMgMS41MTIuNzI3IDEuOTU3czEuMTI0LjY2OCAxLjkxOC42NjhjLjgzNiAwIDEuNTA5LS4yMjEgMi4wMTktLjY2NC41MTEtLjQ0Mi43NjYtMS4wOTYuNzY2LTEuOTYxVjNsLTEuMjYtLjAwOFYySDEzdi45OTJMMTEuNzM5IDN2NS4xNzJjMCAxLjIzNC0uMzk4IDIuMTgxLTEuMTk1IDIuODQtLjc5Ny42NTktMS44MzUuOTg4LTMuMTE0Ljk4OC0xLjI0MiAwLTIuMjQ4LS4zMjktMy4wMTctLjk4OC0uNzY5LS42NTktMS4xNTItMS42MDUtMS4xNTItMi44NFYzTDIgMi45OTJWMmg0LjA0NXpNMiAxM2gxMXYxSDJ6Ii8+PC9zdmc+",className:void 0,title:void 0},strikethrough:{icon:"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTMiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNNC4wNCA1Ljk1NGg2LjIxNWE3LjQxMiA3LjQxMiAwIDAgMC0uNzk1LS40MzggMTEuOTA3IDExLjkwNyAwIDAgMC0xLjQ0Ny0uNTU3Yy0xLjE4OC0uMzQ4LTEuOTY2LS43MTEtMi4zMzQtMS4wODgtLjM2OC0uMzc3LS41NTItLjc3LS41NTItMS4xODEgMC0uNDk1LjE4Ny0uOTA2LjU2LTEuMjMyLjM4LS4zMzEuODg3LS40OTcgMS41MjMtLjQ5Ny42OCAwIDEuMjY2LjI1NSAxLjc1Ny43NjcuMjk1LjMxNS41ODIuODkxLjg2MSAxLjczbC4xMTcuMDE2LjcwMy4wNS4xLS4wMjRjLjAyOC0uMTUyLjA0Mi0uMjc5LjA0Mi0uMzggMC0uMzM3LS4wMzktLjg1Mi0uMTE3LTEuNTQ0YTkuMzc0IDkuMzc0IDAgMCAwLS4xNzYtLjk5NUM5Ljg4LjM3OSA5LjM4NS4yNDQgOS4wMTcuMTc2IDguMzY1LjA3IDcuODk5LjAxNiA3LjYyLjAxNmMtMS40NSAwLTIuNTQ1LjM1Ny0zLjI4NyAxLjA3MS0uNzQ3LjcyLTEuMTIgMS41ODktMS4xMiAyLjYwNyAwIC41MTEuMTMzIDEuMDQuNCAxLjU4Ni4xMjkuMjUzLjI3LjQ3OC40MjcuNjc0ek04LjI4IDguMTE0Yy41NzUuMjM2Ljk1Ny40MzYgMS4xNDcuNTk5LjQ1MS40MS42NzcuODUyLjY3NyAxLjMyNCAwIC4zODMtLjEzLjc0NS0uMzkzIDEuMDg4LS4yNS4zMzgtLjU5LjU4LTEuMDIuNzI2YTMuNDE2IDMuNDE2IDAgMCAxLTEuMTYzLjIyOGMtLjQwNyAwLS43NzUtLjA2Mi0xLjEwNC0uMTg2YTIuNjk2IDIuNjk2IDAgMCAxLS44NzgtLjQ4IDMuMTMzIDMuMTMzIDAgMCAxLS42Ny0uNzk0IDEuNTI3IDEuNTI3IDAgMCAxLS4xMDQtLjIyNyA1Ny41MjMgNTcuNTIzIDAgMCAwLS4xODgtLjQ3MyAyMS4zNzEgMjEuMzcxIDAgMCAwLS4yNTEtLjU5OWwtLjg1My4wMTd2LjM3MWwtLjAxNy4zMTNhOS45MiA5LjkyIDAgMCAwIDAgLjU3M2MuMDExLjI3LjAxNy43MDkuMDE3IDEuMzE2di4xMWMwIC4wNzkuMDIyLjE0LjA2Ny4xODUuMDgzLjA2OC4yODQuMTQ3LjYwMi4yMzdsMS4xNy4zMzdjLjQ1Mi4xMy45OTYuMTk0IDEuNjMyLjE5NC42ODYgMCAxLjI1Mi0uMDU5IDEuNjk4LS4xNzdhNC42OTQgNC42OTQgMCAwIDAgMS4yOC0uNTU3Yy40MDEtLjI1OS43MDUtLjQ4Ni45MTEtLjY4My4yNjgtLjI3Ni40NjYtLjU2OC41OTQtLjg3OGE0Ljc0IDQuNzQgMCAwIDAgLjM0My0xLjc4OGMwLS4yOTgtLjAyLS41NTctLjA1OC0uNzc2SDguMjgxek0xNC45MTQgNi41N2EuMjYuMjYgMCAwIDAtLjE5My0uMDc2SC4yNjhhLjI2LjI2IDAgMCAwLS4xOTMuMDc2LjI2NC4yNjQgMCAwIDAtLjA3NS4xOTR2LjU0YzAgLjA3OS4wMjUuMTQzLjA3NS4xOTRhLjI2LjI2IDAgMCAwIC4xOTMuMDc2SDE0LjcyYS4yNi4yNiAwIDAgMCAuMTkzLS4wNzYuMjY0LjI2NCAwIDAgMCAuMDc1LS4xOTR2LS41NGEuMjY0LjI2NCAwIDAgMC0uMDc1LS4xOTR6Ii8+PC9nPjwvc3ZnPg==",className:void 0,title:void 0},monospace:{icon:"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTMiIGhlaWdodD0iMTUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzQ0NCIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNMS4wMjEgMi45MDZjLjE4NiAxLjIxOS4zNzIgMS41LjM3MiAyLjcxOUMxLjM5MyA2LjM3NSAwIDcuMDMxIDAgNy4wMzF2LjkzOHMxLjM5My42NTYgMS4zOTMgMS40MDZjMCAxLjIxOS0uMTg2IDEuNS0uMzcyIDIuNzE5Qy43NDMgMTQuMDYzIDEuNzY0IDE1IDIuNjkzIDE1aDEuOTV2LTEuODc1cy0xLjY3Mi4xODgtMS42NzItLjkzOGMwLS44NDMuMTg2LS44NDMuMzcyLTIuNzE4LjA5My0uODQ0LS40NjQtMS41LTEuMDIyLTEuOTY5LjU1OC0uNDY5IDEuMTE1LTEuMDMxIDEuMDIyLTEuODc1QzMuMDY0IDMuNzUgMi45NyAzLjc1IDIuOTcgMi45MDZjMC0xLjEyNSAxLjY3Mi0xLjAzMSAxLjY3Mi0xLjAzMVYwaC0xLjk1QzEuNjcgMCAuNzQzLjkzOCAxLjAyIDIuOTA2ek0xMS45NzkgMi45MDZjLS4xODYgMS4yMTktLjM3MiAxLjUtLjM3MiAyLjcxOSAwIC43NSAxLjM5MyAxLjQwNiAxLjM5MyAxLjQwNnYuOTM4cy0xLjM5My42NTYtMS4zOTMgMS40MDZjMCAxLjIxOS4xODYgMS41LjM3MiAyLjcxOS4yNzggMS45NjktLjc0MyAyLjkwNi0xLjY3MiAyLjkwNmgtMS45NXYtMS44NzVzMS42NzIuMTg4IDEuNjcyLS45MzhjMC0uODQzLS4xODYtLjg0My0uMzcyLTIuNzE4LS4wOTMtLjg0NC40NjQtMS41IDEuMDIyLTEuOTY5LS41NTgtLjQ2OS0xLjExNS0xLjAzMS0xLjAyMi0xLjg3NS4xODYtMS44NzUuMzcyLTEuODc1LjM3Mi0yLjcxOSAwLTEuMTI1LTEuNjcyLTEuMDMxLTEuNjcyLTEuMDMxVjBoMS45NWMxLjAyMiAwIDEuOTUuOTM4IDEuNjcyIDIuOTA2eiIvPjwvZz48L3N2Zz4=",className:void 0,title:void 0},superscript:{icon:"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTcuMzA1IDEwLjE2NUwxMS44NjUgMTVIOS4wNTdsLTMuMTkyLTMuNTM2TDIuNzQ2IDE1SDBsNC41MjMtNC44MzVMLjIxOCA1LjYwM2gyLjc3TDUuOTg2IDguOTEgOS4wMSA1LjYwM2gyLjY0OWwtNC4zNTQgNC41NjJ6bTYuMjM0LTMuMjY5bDEuODc5LTEuMzA2Yy42NC0uNDE2IDEuMDYyLS44MDEgMS4yNjQtMS4xNTcuMjAxLS4zNTYuMzAyLS43MzguMzAyLTEuMTQ4IDAtLjY2OS0uMjM3LTEuMjEtLjcxLTEuNjItLjQ3NC0uNDExLTEuMDk3LS42MTctMS44NjgtLjYxNy0uNzQ0IDAtMS4zNC4yMDgtMS43ODUuNjI0LS40NDcuNDE2LS42NyAxLjA0My0uNjcgMS44ODFoMS40MzZjMC0uNS4wOTQtLjg0Ni4yODEtMS4wMzguMTg4LS4xOTEuNDQ1LS4yODcuNzcyLS4yODdzLjU4NS4wOTcuNzc3LjI5MmMuMTkuMTk1LjI4Ni40MzcuMjg2LjcyNiAwIC4yOS0uMDg5LjU1LS4yNjYuNzg1cy0uNjcuNjI4LTEuNDc5IDEuMTg0Yy0uNjkxLjQ3Ny0xLjYyNy45MjctMS45MDggMS4zNWwuMDE0IDEuNTY5SDE3VjYuODk2aC0zLjQ2MXoiLz48L3N2Zz4=",className:void 0,title:void 0},subscript:{icon:"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTExLjg2NiAxMS42NDZIOS4wNkw1Ljg2NyA3Ljk0MmwtMy4xMjEgMy43MDRIMGw0LjUyNC01LjA2NEwuMjE4IDEuODA0aDIuNzdsMyAzLjQ2NCAzLjAyMy0zLjQ2NGgyLjY1TDcuMzA2IDYuNTgybDQuNTYgNS4wNjR6bTEuNzI1IDIuMDU4bDEuODI3LTEuMzY4Yy42NC0uNDM1IDEuMDYyLS44NCAxLjI2NC0xLjIxMi4yMDItLjM3Mi4zMDItLjc3My4zMDItMS4yMDIgMC0uNy0uMjM3LTEuMjY2LS43MS0xLjY5Ni0uNDc0LS40MzEtMS4wOTctLjY0Ni0xLjg2OS0uNjQ2LS43NDQgMC0xLjM0LjIxOC0xLjc4NS42NTMtLjQ0Ni40MzYtLjY3IDEuMDkyLS42NyAxLjk3aDEuNDM2YzAtLjUyNC4wOTQtLjg4Ni4yODEtMS4wODcuMTg4LS4yLjQ0NS0uMzAxLjc3Mi0uMzAxcy41ODYuMTAyLjc3Ny4zMDZjLjE5LjIwNC4yODYuNDU4LjI4Ni43NiAwIC4zMDMtLjA4OC41NzctLjI2Ni44MjItLjE3Ny4yNDUtLjY3LjY1OC0xLjQ3OCAxLjI0LS42OTIuNS0xLjYyOC45NzEtMS45MSAxLjQxM0wxMS44NjQgMTVIMTd2LTEuMjk2aC0zLjQxeiIvPjwvc3ZnPg==",className:void 0,title:void 0}},blockType:{inDropdown:!0,options:["Normal","H1","H2","H3","H4","H5","H6","Blockquote","Code"],className:void 0,component:void 0,dropdownClassName:void 0,title:void 0},fontSize:{icon:"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNMTEuOTIxIDMuMTE5YS40MjcuNDI3IDAgMCAwIC4zMzUuMTY0aC45N2EuNDI2LjQyNiAwIDAgMCAuMzA0LS4xMy40NDEuNDQxIDAgMCAwIC4xMjUtLjMxbC4wMDItMi40MWEuNDM0LjQzNCAwIDAgMC0uNDMtLjQzMkguNDNBLjQzNC40MzQgMCAwIDAgMCAuNDR2Mi40MDZjMCAuMjQyLjE5Mi40MzguNDMuNDM4aC45N2MuMTMgMCAuMjU0LS4wNi4zMzUtLjE2NWwuNzMtLjkzSDUuNTR2MTEuMzZjMCAuMjQxLjE5Mi40MzcuNDMuNDM3aDEuNzE3Yy4yMzcgMCAuNDMtLjE5Ni40My0uNDM3VjIuMTg4aDMuMDdsLjczNC45MzF6TTEzLjg5OCAxMS4yNjNhLjQyNS40MjUgMCAwIDAtLjQ4Mi0uMTQ2bC0uNTQ3LjE5NFY5LjYxN2EuNDQyLjQ0MiAwIDAgMC0uMTI2LS4zMS40MjYuNDI2IDAgMCAwLS4zMDQtLjEyN2gtLjQyOWEuNDM0LjQzNCAwIDAgMC0uNDMuNDM3djEuNjk0bC0uNTQ3LS4xOTRhLjQyNS40MjUgMCAwIDAtLjQ4MS4xNDYuNDQ0LjQ0NCAwIDAgMC0uMDE2LjUxMmwxLjMzMiAyLjAxN2EuNDI3LjQyNyAwIDAgMCAuNzEzIDBsMS4zMzMtMi4wMTdhLjQ0NC40NDQgMCAwIDAtLjAxNi0uNTEyeiIvPjwvZz48L3N2Zz4=",options:[8,9,10,11,12,14,16,18,24,30,36,48,60,72,96],className:void 0,component:void 0,dropdownClassName:void 0,title:void 0},fontFamily:{options:["Arial","Georgia","Impact","Tahoma","Times New Roman","Verdana"],className:void 0,component:void 0,dropdownClassName:void 0,title:void 0},list:{inDropdown:!1,className:void 0,component:void 0,dropdownClassName:void 0,options:["unordered","ordered","indent","outdent"],unordered:{icon:"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNMS43MiAzLjQyN2MuOTUxIDAgMS43MjItLjc2OCAxLjcyMi0xLjcwOFMyLjY3LjAxIDEuNzIuMDFDLjc3LjAwOCAwIC43NzUgMCAxLjcxNWMwIC45NC43NzQgMS43MTEgMS43MiAxLjcxMXptMC0yLjYyNWMuNTEgMCAuOTIyLjQxMi45MjIuOTE0YS45Mi45MiAwIDAgMS0xLjg0MiAwIC45Mi45MiAwIDAgMSAuOTItLjkxNHpNMS43MiA4LjcwM2MuOTUxIDAgMS43MjItLjc2OCAxLjcyMi0xLjcwOFMyLjY3IDUuMjg3IDEuNzIgNS4yODdDLjc3IDUuMjg3IDAgNi4wNTIgMCA2Ljk5NXMuNzc0IDEuNzA4IDEuNzIgMS43MDh6bTAtMi42MjJjLjUxIDAgLjkyMi40MTIuOTIyLjkxNGEuOTIuOTIgMCAwIDEtMS44NDIgMGMwLS41MDUuNDE1LS45MTQuOTItLjkxNHpNMS43MiAxMy45ODJjLjk1MSAwIDEuNzIyLS43NjggMS43MjItMS43MDggMC0uOTQzLS43NzQtMS43MDgtMS43MjEtMS43MDgtLjk0NyAwLTEuNzIxLjc2OC0xLjcyMSAxLjcwOHMuNzc0IDEuNzA4IDEuNzIgMS43MDh6bTAtMi42MjVjLjUxIDAgLjkyMi40MTIuOTIyLjkxNGEuOTIuOTIgMCAxIDEtMS44NDIgMCAuOTIuOTIgMCAwIDEgLjkyLS45MTR6TTUuNzQ0IDIuMTE1aDkuODQ1YS40LjQgMCAwIDAgLjQwMS0uMzk5LjQuNCAwIDAgMC0uNDAxLS4zOTlINS43NDRhLjQuNCAwIDAgMC0uNDAyLjM5OS40LjQgMCAwIDAgLjQwMi4zOTl6TTUuNzQ0IDcuMzk0aDkuODQ1YS40LjQgMCAwIDAgLjQwMS0uMzk5LjQuNCAwIDAgMC0uNDAxLS4zOThINS43NDRhLjQuNCAwIDAgMC0uNDAyLjM5OC40LjQgMCAwIDAgLjQwMi4zOTl6TTUuNzQ0IDEyLjY3aDkuODQ1YS40LjQgMCAwIDAgLjQwMS0uMzk5LjQuNCAwIDAgMC0uNDAxLS4zOTlINS43NDRhLjQuNCAwIDAgMC0uNDAyLjQuNC40IDAgMCAwIC40MDIuMzk4eiIvPjwvZz48L3N2Zz4=",className:void 0,title:void 0},ordered:{icon:"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTMiIGhlaWdodD0iMTMiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNNC4yMDIgMS40NjZoOC4xNWMuMzM4IDAgLjYxMi0uMzIyLjYxMi0uNzIgMC0uMzk3LS4yNzQtLjcyLS42MTItLjcyaC04LjE1Yy0uMzM4IDAtLjYxMS4zMjMtLjYxMS43MiAwIC4zOTguMjczLjcyLjYxLjcyek0xMi4zNTIgNS43ODNoLTguMTVjLS4zMzggMC0uNjExLjMyMi0uNjExLjcyIDAgLjM5Ny4yNzMuNzIuNjEuNzJoOC4xNTFjLjMzOCAwIC42MTItLjMyMy42MTItLjcyIDAtLjM5OC0uMjc0LS43Mi0uNjEyLS43MnpNMTIuMzUyIDExLjU0aC04LjE1Yy0uMzM4IDAtLjYxMS4zMjItLjYxMS43MiAwIC4zOTYuMjczLjcxOS42MS43MTloOC4xNTFjLjMzOCAwIC42MTItLjMyMy42MTItLjcyIDAtLjM5Ny0uMjc0LS43Mi0uNjEyLS43MnpNLjc2NyAxLjI0OXYxLjgwMmMwIC4xOTUuMTM2LjM0My4zMTUuMzQzLjE3NiAwIC4zMTUtLjE1LjMxNS0uMzQzVi4zNTZjMC0uMTktLjEzMy0uMzM5LS4zMDItLjMzOS0uMTQ4IDAtLjIyMy4xMTgtLjI0Ny4xNTZhLjIyOC4yMjggMCAwIDAtLjAwMy4wMDVMLjU3OS42MjFhLjQ3NC40NzQgMCAwIDAtLjA5OC4yNzNjMCAuMTk0LjEyOC4zNTEuMjg2LjM1NXpNLjM1MiA4LjE5SDEuNTVjLjE1NyAwIC4yODUtLjE2Mi4yODUtLjM2MiAwLS4xOTgtLjEyOC0uMzU5LS4yODUtLjM1OUguNjh2LS4wMDZjMC0uMTA3LjIxLS4yODEuMzc4LS40MjIuMzM2LS4yNzguNzUzLS42MjUuNzUzLTEuMjI2IDAtLjU3LS4zNzYtMS0uODc0LTEtLjQ3NyAwLS44MzYuMzg1LS44MzYuODk3IDAgLjI5Ny4xNjQuNDAyLjMwNS40MDIuMiAwIC4zMjEtLjE3Ni4zMjEtLjM0NiAwLS4xMDYuMDIzLS4yMjguMjA0LS4yMjguMjQzIDAgLjI1LjI1NC4yNS4yODMgMCAuMjI4LS4yNTIuNDQyLS40OTUuNjQ5LS4zMDEuMjU1LS42NDIuNTQ0LS42NDIuOTkydi4zODRjMCAuMjA1LjE1OS4zNDMuMzA4LjM0M3pNMS43NyAxMC41NDNjMC0uNTkyLS4yOTYtLjkzMS0uODE0LS45MzEtLjY4IDAtLjg1OS41Ny0uODU5Ljg3MiAwIC4zNTEuMjIyLjM5LjMxOC4zOS4xODUgMCAuMzEtLjE0OC4zMS0uMzY2IDAtLjA4NC4wMjYtLjE4MS4yMjQtLjE4MS4xNDIgMCAuMi4wMjQuMi4yNjcgMCAuMjM3LS4wNDMuMjYzLS4yMTMuMjYzLS4xNjQgMC0uMjg4LjE1Mi0uMjg4LjM1NCAwIC4yLjEyNS4zNS4yOTEuMzUuMjI1IDAgLjI3LjEwOC4yNy4yODN2LjA3NWMwIC4yOTQtLjA5Ny4zNS0uMjc3LjM1LS4yNDggMC0uMjY3LS4xNS0uMjY3LS4xOTcgMC0uMTc0LS4wOTgtLjM1LS4zMTctLjM1LS4xOTIgMC0uMzA3LjE0MS0uMzA3LjM3OCAwIC40My4zMTMuODg4Ljg5NS44ODguNTY0IDAgLjkwMS0uNC45MDEtMS4wN3YtLjA3NGMwLS4yNzQtLjA3NC0uNTAyLS4yMTQtLjY2Ni4wOTYtLjE2My4xNDgtLjM4LjE0OC0uNjM1eiIvPjwvZz48L3N2Zz4=",className:void 0,title:void 0},indent:{icon:"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNNS43MTYgMy4yMTFIMTd2MS4xOTdINS43MTZ6TTAgLjAyaDE3djEuMTk3SDB6TTAgMTIuNzgzaDE3djEuMTk3SDB6TTUuNzE2IDkuNTkzSDE3djEuMTk3SDUuNzE2ek01LjcxNiA2LjQwMkgxN3YxLjE5N0g1LjcxNnpNLjE4NyA5LjQ5MUwyLjUyIDcgLjE4NyA0LjUwOXoiLz48L2c+PC9zdmc+",className:void 0,title:void 0},outdent:{icon:"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNNS4zOTYgMy4xOTNoMTAuNTczVjQuMzlINS4zOTZ6TS4wMzkuMDAzaDE1LjkzVjEuMkguMDM5ek0uMDM5IDEyLjc2NmgxNS45M3YxLjE5N0guMDM5ek01LjM5NiA5LjU3NWgxMC41NzN2MS4xOTdINS4zOTZ6TTUuMzk2IDYuMzg0aDEwLjU3M3YxLjE5N0g1LjM5NnpNMi4xODcgNC40OTFMMCA2Ljk4M2wyLjE4NyAyLjQ5MXoiLz48L2c+PC9zdmc+",className:void 0,title:void 0},title:void 0},textAlign:{inDropdown:!1,className:void 0,component:void 0,dropdownClassName:void 0,options:["left","center","right","justify"],left:{icon:"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNOC40OTMgMTQuODg3SC4zMjZhLjMyNi4zMjYgMCAwIDEgMC0uNjUyaDguMTY3YS4zMjYuMzI2IDAgMCAxIDAgLjY1MnpNMTQuNjE4IDEwLjE2MkguMzI2YS4zMjYuMzI2IDAgMCAxIDAtLjY1M2gxNC4yOTJhLjMyNi4zMjYgMCAwIDEgMCAuNjUzek04LjQ5MyA1LjQzNUguMzI2YS4zMjYuMzI2IDAgMCAxIDAtLjY1Mmg4LjE2N2EuMzI2LjMyNiAwIDAgMSAwIC42NTJ6TTE0LjYxOC43MDlILjMyNmEuMzI2LjMyNiAwIDAgMSAwLS42NTJoMTQuMjkyYS4zMjYuMzI2IDAgMCAxIDAgLjY1MnoiLz48L2c+PC9zdmc+",className:void 0,title:void 0},center:{icon:"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNMTEuNTU2IDE0Ljg4N0gzLjM4OGEuMzI2LjMyNiAwIDAgMSAwLS42NTJoOC4xNjdhLjMyNi4zMjYgMCAwIDEgMCAuNjUyek0xNC42MTggMTAuMTYySC4zMjZhLjMyNi4zMjYgMCAwIDEgMC0uNjUzaDE0LjI5MmEuMzI2LjMyNiAwIDAgMSAwIC42NTN6TTExLjU1NiA1LjQzNUgzLjM4OGEuMzI2LjMyNiAwIDAgMSAwLS42NTJoOC4xNjdhLjMyNi4zMjYgMCAwIDEgMCAuNjUyek0xNC42MTguNzA5SC4zMjZhLjMyNi4zMjYgMCAwIDEgMC0uNjUyaDE0LjI5MmEuMzI2LjMyNiAwIDAgMSAwIC42NTJ6Ii8+PC9nPjwvc3ZnPg==",className:void 0,title:void 0},right:{icon:"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNMTQuNjE4IDE0Ljg4N0g2LjQ1YS4zMjYuMzI2IDAgMCAxIDAtLjY1Mmg4LjE2N2EuMzI2LjMyNiAwIDAgMSAwIC42NTJ6TTE0LjYxOCAxMC4xNjJILjMyNmEuMzI2LjMyNiAwIDAgMSAwLS42NTNoMTQuMjkyYS4zMjYuMzI2IDAgMCAxIDAgLjY1M3pNMTQuNjE4IDUuNDM1SDYuNDVhLjMyNi4zMjYgMCAwIDEgMC0uNjUyaDguMTY3YS4zMjYuMzI2IDAgMCAxIDAgLjY1MnpNMTQuNjE4LjcwOUguMzI2YS4zMjYuMzI2IDAgMCAxIDAtLjY1MmgxNC4yOTJhLjMyNi4zMjYgMCAwIDEgMCAuNjUyeiIvPjwvZz48L3N2Zz4=",className:void 0,title:void 0},justify:{icon:"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNMTQuNjIgMTQuODg4SC4zMjVhLjMyNi4zMjYgMCAwIDEgMC0uNjUySDE0LjYyYS4zMjYuMzI2IDAgMCAxIDAgLjY1MnpNMTQuNjIgMTAuMTYySC4zMjVhLjMyNi4zMjYgMCAwIDEgMC0uNjUySDE0LjYyYS4zMjYuMzI2IDAgMCAxIDAgLjY1MnpNMTQuNjIgNS40MzZILjMyNWEuMzI2LjMyNiAwIDAgMSAwLS42NTJIMTQuNjJhLjMyNi4zMjYgMCAwIDEgMCAuNjUyek0xNC42Mi43MUguMzI1YS4zMjYuMzI2IDAgMCAxIDAtLjY1M0gxNC42MmEuMzI2LjMyNiAwIDAgMSAwIC42NTN6Ii8+PC9nPjwvc3ZnPg==",className:void 0,title:void 0},title:void 0},colorPicker:{icon:"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNMTQuNDA2LjU4NWExLjk5OCAxLjk5OCAwIDAgMC0yLjgyNSAwbC0uNTQuNTRhLjc0MS43NDEgMCAxIDAtMS4wNDggMS4wNDhsLjE3NS4xNzUtNS44MjYgNS44MjUtMi4wMjIgMi4wMjNhLjkxLjkxIDAgMCAwLS4yNjYuNjAybC0uMDA1LjEwOHYuMDAybC0uMDgxIDEuODI5YS4zMDIuMzAyIDAgMCAwIC4zMDIuMzE2aC4wMTNsLjk3LS4wNDQuNTkyLS4wMjYuMjY4LS4wMTJjLjI5Ny0uMDEzLjU3OS0uMTM3Ljc5LS4zNDdsNy43Ny03Ljc3LjE0Ni4xNDRhLjc0Ljc0IDAgMCAwIDEuMDQ4IDBjLjI5LS4yOS4yOS0uNzU5IDAtMS4wNDhsLjU0LS41NGMuNzgtLjc4Ljc4LTIuMDQ0IDAtMi44MjV6TTguNzk1IDcuMzMzbC0yLjczLjUxNSA0LjQ1Mi00LjQ1MiAxLjEwOCAxLjEwNy0yLjgzIDIuODN6TTIuMDggMTMuNjczYy0xLjE0OCAwLTIuMDguMjk1LTIuMDguNjYgMCAuMzYzLjkzMi42NTggMi4wOC42NTggMS4xNSAwIDIuMDgtLjI5NCAyLjA4LS42NTkgMC0uMzY0LS45My0uNjU5LTIuMDgtLjY1OXoiLz48L2c+PC9zdmc+",className:void 0,component:void 0,popupClassName:void 0,colors:["rgb(97,189,109)","rgb(26,188,156)","rgb(84,172,210)","rgb(44,130,201)","rgb(147,101,184)","rgb(71,85,119)","rgb(204,204,204)","rgb(65,168,95)","rgb(0,168,133)","rgb(61,142,185)","rgb(41,105,176)","rgb(85,57,130)","rgb(40,50,78)","rgb(0,0,0)","rgb(247,218,100)","rgb(251,160,38)","rgb(235,107,86)","rgb(226,80,65)","rgb(163,143,132)","rgb(239,239,239)","rgb(255,255,255)","rgb(250,197,28)","rgb(243,121,52)","rgb(209,72,65)","rgb(184,49,47)","rgb(124,112,107)","rgb(209,213,216)"],title:void 0},link:{inDropdown:!1,className:void 0,component:void 0,popupClassName:void 0,dropdownClassName:void 0,showOpenOptionOnHover:!0,defaultTargetOption:"_self",options:["link","unlink"],link:{icon:"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTEzLjk2Ny45NUEzLjIyNiAzLjIyNiAwIDAgMCAxMS42Ny4wMDJjLS44NyAwLTEuNjg2LjMzNy0yLjI5Ny45NDhMNy4xMDUgMy4yMThBMy4yNDcgMy4yNDcgMCAwIDAgNi4yNCA2LjI0YTMuMjI1IDMuMjI1IDAgMCAwLTMuMDIyLjg2NUwuOTUgOS4zNzNhMy4yNTMgMy4yNTMgMCAwIDAgMCA0LjU5NCAzLjIyNiAzLjIyNiAwIDAgMCAyLjI5Ny45NDhjLjg3IDAgMS42ODYtLjMzNiAyLjI5OC0uOTQ4TDcuODEyIDExLjdhMy4yNDcgMy4yNDcgMCAwIDAgLjg2NS0zLjAyMyAzLjIyNSAzLjIyNSAwIDAgMCAzLjAyMi0uODY1bDIuMjY4LTIuMjY3YTMuMjUyIDMuMjUyIDAgMCAwIDAtNC41OTV6TTcuMTA1IDEwLjk5M0w0LjgzNyAxMy4yNmEyLjIzMyAyLjIzMyAwIDAgMS0xLjU5LjY1NSAyLjIzMyAyLjIzMyAwIDAgMS0xLjU5LS42NTUgMi4yNTIgMi4yNTIgMCAwIDEgMC0zLjE4bDIuMjY4LTIuMjY4YTIuMjMyIDIuMjMyIDAgMCAxIDEuNTktLjY1NWMuNDMgMCAuODQxLjEyIDEuMTk1LjM0M0w0Ljc3MiA5LjQzOGEuNS41IDAgMSAwIC43MDcuNzA3bDEuOTM5LTEuOTM4Yy41NDUuODY4LjQ0MiAyLjAzLS4zMTMgMi43ODV6bTYuMTU1LTYuMTU1bC0yLjI2OCAyLjI2N2EyLjIzMyAyLjIzMyAwIDAgMS0xLjU5LjY1NWMtLjQzMSAwLS44NDEtLjEyLTEuMTk1LS4zNDNsMS45MzgtMS45MzhhLjUuNSAwIDEgMC0uNzA3LS43MDdMNy40OTkgNi43MWEyLjI1MiAyLjI1MiAwIDAgMSAuMzEzLTIuNzg1bDIuMjY3LTIuMjY4YTIuMjMzIDIuMjMzIDAgMCAxIDEuNTktLjY1NSAyLjIzMyAyLjIzMyAwIDAgMSAyLjI0NiAyLjI0NWMwIC42MDMtLjIzMiAxLjE2OC0uNjU1IDEuNTl6IiBmaWxsPSIjMDAwIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4=",className:void 0,title:void 0},unlink:{icon:"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNMTMuOTU2IDEuMDM3YTMuNTUgMy41NSAwIDAgMC01LjAxNCAwTDYuNDM2IDMuNTQ0YS41NDUuNTQ1IDAgMSAwIC43Ny43N2wyLjUwOC0yLjUwNmEyLjQzOCAyLjQzOCAwIDAgMSAxLjczNS0uNzE1Yy42NTggMCAxLjI3NS4yNTQgMS43MzYuNzE1LjQ2LjQ2MS43MTUgMS4wNzguNzE1IDEuNzM2IDAgLjY1OC0uMjU0IDEuMjc0LS43MTUgMS43MzVMOS45MDcgOC41NThhMi40NTggMi40NTggMCAwIDEtMy40NzIgMCAuNTQ1LjU0NSAwIDEgMC0uNzcxLjc3MSAzLjUzNCAzLjUzNCAwIDAgMCAyLjUwNyAxLjAzN2MuOTA4IDAgMS44MTYtLjM0NiAyLjUwNy0xLjAzN2wzLjI3OC0zLjI3OGEzLjUyIDMuNTIgMCAwIDAgMS4wMzUtMi41MDdjMC0uOTUtLjM2Ny0xLjg0LTEuMDM1LTIuNTA3eiIvPjxwYXRoIGQ9Ik03LjQgMTEuMDY1bC0yLjEyMiAyLjEyYTIuNDM3IDIuNDM3IDAgMCAxLTEuNzM1LjcxNiAyLjQzNyAyLjQzNyAwIDAgMS0xLjczNi0uNzE1IDIuNDU3IDIuNDU3IDAgMCAxIDAtMy40NzFsMy4wODYtMy4wODZhMi40MzggMi40MzggMCAwIDEgMS43MzUtLjcxNWMuNjU4IDAgMS4yNzUuMjU0IDEuNzM2LjcxNWEuNTQ1LjU0NSAwIDEgMCAuNzcxLS43NzEgMy41NSAzLjU1IDAgMCAwLTUuMDE0IDBMMS4wMzYgOC45NDRBMy41MiAzLjUyIDAgMCAwIDAgMTEuNDVjMCAuOTUuMzY3IDEuODQgMS4wMzUgMi41MDdhMy41MiAzLjUyIDAgMCAwIDIuNTA2IDEuMDM1Yy45NSAwIDEuODQtLjM2OCAyLjUwNy0xLjAzNWwyLjEyMi0yLjEyMWEuNTQ1LjU0NSAwIDAgMC0uNzcxLS43NzF6TTkuMjc0IDEyLjAwMmEuNTQ2LjU0NiAwIDAgMC0uNTQ2LjU0NXYxLjYzN2EuNTQ2LjU0NiAwIDAgMCAxLjA5MSAwdi0xLjYzN2EuNTQ1LjU0NSAwIDAgMC0uNTQ1LS41NDV6TTExLjIzIDExLjYxNmEuNTQ1LjU0NSAwIDEgMC0uNzcyLjc3MmwxLjE1NyAxLjE1NmEuNTQzLjU0MyAwIDAgMCAuNzcxIDAgLjU0NS41NDUgMCAwIDAgMC0uNzdsLTEuMTU2LTEuMTU4ek0xMi41MzcgOS44MkgxMC45YS41NDYuNTQ2IDAgMCAwIDAgMS4wOTFoMS42MzdhLjU0Ni41NDYgMCAwIDAgMC0xLjA5ek00LjkxIDMuNTQ3YS41NDYuNTQ2IDAgMCAwIC41NDUtLjU0NVYxLjM2NmEuNTQ2LjU0NiAwIDAgMC0xLjA5IDB2MS42MzZjMCAuMzAxLjI0NC41NDUuNTQ1LjU0NXpNMi44ODggMy45MzNhLjU0My41NDMgMCAwIDAgLjc3MSAwIC41NDUuNTQ1IDAgMCAwIDAtLjc3MUwyLjUwMiAyLjAwNWEuNTQ1LjU0NSAwIDEgMC0uNzcxLjc3bDEuMTU3IDEuMTU4ek0xLjYyOCA1LjczaDEuNjM2YS41NDYuNTQ2IDAgMCAwIDAtMS4wOTJIMS42MjhhLjU0Ni41NDYgMCAwIDAgMCAxLjA5MXoiLz48L2c+PC9zdmc+",className:void 0,title:void 0},linkCallback:void 0},emoji:{icon:"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTciIHZpZXdCb3g9IjE1LjcyOSAyMi4wODIgMTcgMTciIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTI5LjcwOCAyNS4xMDRjLTMuMDIxLTMuMDIyLTcuOTM3LTMuMDIyLTEwLjk1OCAwLTMuMDIxIDMuMDItMy4wMiA3LjkzNiAwIDEwLjk1OCAzLjAyMSAzLjAyIDcuOTM3IDMuMDIgMTAuOTU4LS4wMDEgMy4wMi0zLjAyMSAzLjAyLTcuOTM2IDAtMTAuOTU3em0tLjg0NSAxMC4xMTJhNi41NiA2LjU2IDAgMCAxLTkuMjY4IDAgNi41NiA2LjU2IDAgMCAxIDAtOS4yNjcgNi41NiA2LjU2IDAgMCAxIDkuMjY4IDAgNi41NiA2LjU2IDAgMCAxIDAgOS4yNjd6bS03LjUyNC02LjczYS45MDYuOTA2IDAgMSAxIDEuODExIDAgLjkwNi45MDYgMCAwIDEtMS44MTEgMHptNC4xMDYgMGEuOTA2LjkwNiAwIDEgMSAxLjgxMiAwIC45MDYuOTA2IDAgMCAxLTEuODEyIDB6bTIuMTQxIDMuNzA4Yy0uNTYxIDEuMjk4LTEuODc1IDIuMTM3LTMuMzQ4IDIuMTM3LTEuNTA1IDAtMi44MjctLjg0My0zLjM2OS0yLjE0N2EuNDM4LjQzOCAwIDAgMSAuODEtLjMzNmMuNDA1Ljk3NiAxLjQxIDEuNjA3IDIuNTU5IDEuNjA3IDEuMTIzIDAgMi4xMjEtLjYzMSAyLjU0NC0xLjYwOGEuNDM4LjQzOCAwIDAgMSAuODA0LjM0N3oiLz48L3N2Zz4=",className:void 0,component:void 0,popupClassName:void 0,emojis:["😀","😁","😂","😃","😉","😋","😎","😍","😗","🤗","🤔","😣","😫","😴","😌","🤓","😛","😜","😠","😇","😷","😈","👻","😺","😸","😹","😻","😼","😽","🙀","🙈","🙉","🙊","👼","👮","🕵","💂","👳","🎅","👸","👰","👲","🙍","🙇","🚶","🏃","💃","⛷","🏂","🏌","🏄","🚣","🏊","⛹","🏋","🚴","👫","💪","👈","👉","👆","🖕","👇","🖖","🤘","🖐","👌","👍","👎","✊","👊","👏","🙌","🙏","🐵","🐶","🐇","🐥","🐸","🐌","🐛","🐜","🐝","🍉","🍄","🍔","🍤","🍨","🍪","🎂","🍰","🍾","🍷","🍸","🍺","🌍","🚑","⏰","🌙","🌝","🌞","⭐","🌟","🌠","🌨","🌩","⛄","🔥","🎄","🎈","🎉","🎊","🎁","🎗","🏀","🏈","🎲","🔇","🔈","📣","🔔","🎵","🎷","💰","🖊","📅","✅","❎","💯"],title:void 0},embedded:{icon:"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTciIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTYuNzA4IDYuNjE1YS40MzYuNDM2IDAgMCAwLS41NDMuMjkxbC0xLjgzIDYuMDQ1YS40MzYuNDM2IDAgMCAwIC44MzMuMjUyTDcgNy4xNmEuNDM2LjQzNiAwIDAgMC0uMjktLjU0NHpNOC45MzEgNi42MTVhLjQzNi40MzYgMCAwIDAtLjU0My4yOTFsLTEuODMgNi4wNDVhLjQzNi40MzYgMCAwIDAgLjgzNC4yNTJsMS44My02LjA0NGEuNDM2LjQzNiAwIDAgMC0uMjktLjU0NHoiLz48cGF0aCBkPSJNMTYuNTY0IDBILjQzNkEuNDM2LjQzNiAwIDAgMCAwIC40MzZ2MTYuMTI4YzAgLjI0LjE5NS40MzYuNDM2LjQzNmgxNi4xMjhjLjI0IDAgLjQzNi0uMTk1LjQzNi0uNDM2Vi40MzZBLjQzNi40MzYgMCAwIDAgMTYuNTY0IDB6TTMuNDg3Ljg3MmgxMC4wMjZ2MS43NDNIMy40ODdWLjg3MnptLTIuNjE1IDBoMS43NDN2MS43NDNILjg3MlYuODcyem0xNS4yNTYgMTUuMjU2SC44NzJWMy40ODhoMTUuMjU2djEyLjY0em0wLTEzLjUxM2gtMS43NDNWLjg3MmgxLjc0M3YxLjc0M3oiLz48Y2lyY2xlIGN4PSI5My44NjciIGN5PSIyNDUuMDY0IiByPSIxMy4xMjgiIHRyYW5zZm9ybT0ibWF0cml4KC4wMzMyIDAgMCAuMDMzMiAwIDApIi8+PGNpcmNsZSBjeD0iOTMuODY3IiBjeT0iMzYwLjU5MiIgcj0iMTMuMTI4IiB0cmFuc2Zvcm09Im1hdHJpeCguMDMzMiAwIDAgLjAzMzIgMCAwKSIvPjxwYXRoIGQ9Ik0xNC4yNTQgMTIuNjQxSDEwLjJhLjQzNi40MzYgMCAwIDAgMCAuODcyaDQuMDU0YS40MzYuNDM2IDAgMCAwIDAtLjg3MnoiLz48L3N2Zz4=",className:void 0,component:void 0,popupClassName:void 0,embedCallback:void 0,defaultSize:{height:"auto",width:"auto"},title:void 0},image:{icon:"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNMTQuNzQxIDBILjI2Qy4xMTYgMCAwIC4xMzYgMCAuMzA0djEzLjM5MmMwIC4xNjguMTE2LjMwNC4yNTkuMzA0SDE0Ljc0Yy4xNDMgMCAuMjU5LS4xMzYuMjU5LS4zMDRWLjMwNEMxNSAuMTM2IDE0Ljg4NCAwIDE0Ljc0MSAwem0tLjI1OCAxMy4zOTFILjUxN1YuNjFoMTMuOTY2VjEzLjM5eiIvPjxwYXRoIGQ9Ik00LjEzOCA2LjczOGMuNzk0IDAgMS40NC0uNzYgMS40NC0xLjY5NXMtLjY0Ni0xLjY5NS0xLjQ0LTEuNjk1Yy0uNzk0IDAtMS40NC43Ni0xLjQ0IDEuNjk1IDAgLjkzNC42NDYgMS42OTUgMS40NCAxLjY5NXptMC0yLjc4MWMuNTA5IDAgLjkyMy40ODcuOTIzIDEuMDg2IDAgLjU5OC0uNDE0IDEuMDg2LS45MjMgMS4wODYtLjUwOSAwLS45MjMtLjQ4Ny0uOTIzLTEuMDg2IDAtLjU5OS40MTQtMS4wODYuOTIzLTEuMDg2ek0xLjgxIDEyLjE3NGMuMDYgMCAuMTIyLS4wMjUuMTcxLS4wNzZMNi4yIDcuNzI4bDIuNjY0IDMuMTM0YS4yMzIuMjMyIDAgMCAwIC4zNjYgMCAuMzQzLjM0MyAwIDAgMCAwLS40M0w3Ljk4NyA4Ljk2OWwyLjM3NC0zLjA2IDIuOTEyIDMuMTQyYy4xMDYuMTEzLjI3LjEwNS4zNjYtLjAyYS4zNDMuMzQzIDAgMCAwLS4wMTYtLjQzbC0zLjEwNC0zLjM0N2EuMjQ0LjI0NCAwIDAgMC0uMTg2LS4wOC4yNDUuMjQ1IDAgMCAwLS4xOC4xTDcuNjIyIDguNTM3IDYuMzk0IDcuMDk0YS4yMzIuMjMyIDAgMCAwLS4zNTQtLjAxM2wtNC40IDQuNTZhLjM0My4zNDMgMCAwIDAtLjAyNC40My4yNDMuMjQzIDAgMCAwIC4xOTQuMTAzeiIvPjwvZz48L3N2Zz4=",className:void 0,component:void 0,popupClassName:void 0,urlEnabled:!0,uploadEnabled:!0,previewImage:!1,alignmentEnabled:!0,uploadCallback:void 0,inputAccept:"image/gif,image/jpeg,image/jpg,image/png,image/svg",alt:{present:!1,mandatory:!1},defaultSize:{height:"auto",width:"auto"},title:void 0},remove:{icon:"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNSIgaGVpZ2h0PSIxNSIgdmlld0JveD0iMCAwIDE2IDE2Ij48cGF0aCBkPSJNOC4xIDE0bDYuNC03LjJjLjYtLjcuNi0xLjgtLjEtMi41bC0yLjctMi43Yy0uMy0uNC0uOC0uNi0xLjMtLjZIOC42Yy0uNSAwLTEgLjItMS40LjZMLjUgOS4yYy0uNi43LS42IDEuOS4xIDIuNWwyLjcgMi43Yy4zLjQuOC42IDEuMy42SDE2di0xSDguMXptLTEuMy0uMXMwLS4xIDAgMGwtMi43LTIuN2MtLjQtLjQtLjQtLjkgMC0xLjNMNy41IDZoLTFsLTMgMy4zYy0uNi43LS42IDEuNy4xIDIuNEw1LjkgMTRINC42Yy0uMiAwLS40LS4xLS42LS4yTDEuMiAxMWMtLjMtLjMtLjMtLjggMC0xLjFMNC43IDZoMS44TDEwIDJoMUw3LjUgNmwzLjEgMy43LTMuNSA0Yy0uMS4xLS4yLjEtLjMuMnoiLz48L3N2Zz4=",className:void 0,component:void 0,title:void 0},history:{inDropdown:!1,className:void 0,component:void 0,dropdownClassName:void 0,options:["undo","redo"],undo:{icon:"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTciIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTcgMTQuODc1YzIuNjcyIDAgNC44NDYtMi4xNDUgNC44NDYtNC43ODEgMC0yLjYzNy0yLjE3NC00Ljc4MS00Ljg0Ni00Ljc4MVY4LjVMMS42MTUgNC4yNSA3IDB2My4xODhjMy44NiAwIDcgMy4wOTggNyA2LjkwNlMxMC44NiAxNyA3IDE3cy03LTMuMDk4LTctNi45MDZoMi4xNTRjMCAyLjYzNiAyLjE3NCA0Ljc4MSA0Ljg0NiA0Ljc4MXoiIGZpbGw9IiMwMDAiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg==",className:void 0,title:void 0},redo:{icon:"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTMiIGhlaWdodD0iMTYiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTYuNTA0IDEzLjk3N2E0LjQ5NyA0LjQ5NyAwIDAgMS00LjQ5Mi00LjQ5MiA0LjQ5NyA0LjQ5NyAwIDAgMSA0LjQ5Mi00LjQ5M3YyLjk5NWw0Ljk5LTMuOTkzTDYuNTA0IDB2Mi45OTVhNi40OTYgNi40OTYgMCAwIDAtNi40ODggNi40OWMwIDMuNTc4IDIuOTEgNi40OSA2LjQ4OCA2LjQ5YTYuNDk2IDYuNDk2IDAgMCAwIDYuNDg3LTYuNDloLTEuOTk2YTQuNDk3IDQuNDk3IDAgMCAxLTQuNDkxIDQuNDkyeiIgZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIi8+PC9zdmc+",className:void 0,title:void 0},title:void 0}},Jo={en:{"generic.add":"Add","generic.cancel":"Cancel","components.controls.blocktype.h1":"H1","components.controls.blocktype.h2":"H2","components.controls.blocktype.h3":"H3","components.controls.blocktype.h4":"H4","components.controls.blocktype.h5":"H5","components.controls.blocktype.h6":"H6","components.controls.blocktype.blockquote":"Blockquote","components.controls.blocktype.code":"Code","components.controls.blocktype.blocktype":"Block Type","components.controls.blocktype.normal":"Normal","components.controls.colorpicker.colorpicker":"Color Picker","components.controls.colorpicker.text":"Text","components.controls.colorpicker.background":"Highlight","components.controls.embedded.embedded":"Embedded","components.controls.embedded.embeddedlink":"Embedded Link","components.controls.embedded.enterlink":"Enter link","components.controls.emoji.emoji":"Emoji","components.controls.fontfamily.fontfamily":"Font","components.controls.fontsize.fontsize":"Font Size","components.controls.history.history":"History","components.controls.history.undo":"Undo","components.controls.history.redo":"Redo","components.controls.image.image":"Image","components.controls.image.fileUpload":"File Upload","components.controls.image.byURL":"URL","components.controls.image.dropFileText":"Drop the file or click to upload","components.controls.inline.bold":"Bold","components.controls.inline.italic":"Italic","components.controls.inline.underline":"Underline","components.controls.inline.strikethrough":"Strikethrough","components.controls.inline.monospace":"Monospace","components.controls.inline.superscript":"Superscript","components.controls.inline.subscript":"Subscript","components.controls.link.linkTitle":"Link Title","components.controls.link.linkTarget":"Link Target","components.controls.link.linkTargetOption":"Open link in new window","components.controls.link.link":"Link","components.controls.link.unlink":"Unlink","components.controls.list.list":"List","components.controls.list.unordered":"Unordered","components.controls.list.ordered":"Ordered","components.controls.list.indent":"Indent","components.controls.list.outdent":"Outdent","components.controls.remove.remove":"Remove","components.controls.textalign.textalign":"Text Align","components.controls.textalign.left":"Left","components.controls.textalign.center":"Center","components.controls.textalign.right":"Right","components.controls.textalign.justify":"Justify"},fr:{"generic.add":"Ok","generic.cancel":"Annuler","components.controls.blocktype.h1":"Titre 1","components.controls.blocktype.h2":"Titre 2","components.controls.blocktype.h3":"Titre 3","components.controls.blocktype.h4":"Titre 4","components.controls.blocktype.h5":"Titre 5","components.controls.blocktype.h6":"Titre 6","components.controls.blocktype.blockquote":"Citation","components.controls.blocktype.code":"Code","components.controls.blocktype.blocktype":"Type bloc","components.controls.blocktype.normal":"Normal","components.controls.colorpicker.colorpicker":"Palette de couleur","components.controls.colorpicker.text":"Texte","components.controls.colorpicker.background":"Fond","components.controls.embedded.embedded":"Embedded","components.controls.embedded.embeddedlink":"Lien iFrame","components.controls.embedded.enterlink":"Entrer le lien","components.controls.emoji.emoji":"Emoji","components.controls.fontfamily.fontfamily":"Police","components.controls.fontsize.fontsize":"Taille de police","components.controls.history.history":"Historique","components.controls.history.undo":"Précédent","components.controls.history.redo":"Suivant","components.controls.image.image":"Image","components.controls.image.fileUpload":"Téléchargement","components.controls.image.byURL":"URL","components.controls.image.dropFileText":"Glisser une image ou cliquer pour télécharger","components.controls.inline.bold":"Gras","components.controls.inline.italic":"Italique","components.controls.inline.underline":"Souligner","components.controls.inline.strikethrough":"Barrer","components.controls.inline.monospace":"Monospace","components.controls.inline.superscript":"Exposant","components.controls.inline.subscript":"Indice","components.controls.link.linkTitle":"Titre du lien","components.controls.link.linkTarget":"Cible du lien","components.controls.link.linkTargetOption":"Ouvrir le lien dans une nouvelle fenêtre","components.controls.link.link":"Lier","components.controls.link.unlink":"Délier","components.controls.list.list":"Liste","components.controls.list.unordered":"Désordonnée","components.controls.list.ordered":"Ordonnée","components.controls.list.indent":"Augmenter le retrait","components.controls.list.outdent":"Diminuer le retrait","components.controls.remove.remove":"Supprimer","components.controls.textalign.textalign":"Alignement du texte","components.controls.textalign.left":"Gauche","components.controls.textalign.center":"Centre","components.controls.textalign.right":"Droite","components.controls.textalign.justify":"Justifier"},zh:{"generic.add":"添加","generic.cancel":"取消","components.controls.blocktype.h1":"标题1","components.controls.blocktype.h2":"标题2","components.controls.blocktype.h3":"标题3","components.controls.blocktype.h4":"标题4","components.controls.blocktype.h5":"标题5","components.controls.blocktype.h6":"标题6","components.controls.blocktype.blockquote":"引用","components.controls.blocktype.code":"源码","components.controls.blocktype.blocktype":"样式","components.controls.blocktype.normal":"正文","components.controls.colorpicker.colorpicker":"选色器","components.controls.colorpicker.text":"文字","components.controls.colorpicker.background":"背景","components.controls.embedded.embedded":"内嵌","components.controls.embedded.embeddedlink":"内嵌网页","components.controls.embedded.enterlink":"输入网页地址","components.controls.emoji.emoji":"表情符号","components.controls.fontfamily.fontfamily":"字体","components.controls.fontsize.fontsize":"字号","components.controls.history.history":"历史","components.controls.history.undo":"撤销","components.controls.history.redo":"恢复","components.controls.image.image":"图片","components.controls.image.fileUpload":"来自文件","components.controls.image.byURL":"在线图片","components.controls.image.dropFileText":"点击或者拖拽文件上传","components.controls.inline.bold":"粗体","components.controls.inline.italic":"斜体","components.controls.inline.underline":"下划线","components.controls.inline.strikethrough":"删除线","components.controls.inline.monospace":"等宽字体","components.controls.inline.superscript":"上标","components.controls.inline.subscript":"下标","components.controls.link.linkTitle":"超链接","components.controls.link.linkTarget":"输入链接地址","components.controls.link.linkTargetOption":"在新窗口中打开链接","components.controls.link.link":"链接","components.controls.link.unlink":"删除链接","components.controls.list.list":"列表","components.controls.list.unordered":"项目符号","components.controls.list.ordered":"编号","components.controls.list.indent":"增加缩进量","components.controls.list.outdent":"减少缩进量","components.controls.remove.remove":"清除格式","components.controls.textalign.textalign":"文本对齐","components.controls.textalign.left":"文本左对齐","components.controls.textalign.center":"居中","components.controls.textalign.right":"文本右对齐","components.controls.textalign.justify":"两端对齐"},ru:{"generic.add":"Добавить","generic.cancel":"Отменить","components.controls.blocktype.h1":"Заголовок 1","components.controls.blocktype.h2":"Заголовок 2","components.controls.blocktype.h3":"Заголовок 3","components.controls.blocktype.h4":"Заголовок 4","components.controls.blocktype.h5":"Заголовок 5","components.controls.blocktype.h6":"Заголовок 6","components.controls.blocktype.blockquote":"Цитата","components.controls.blocktype.code":"Код","components.controls.blocktype.blocktype":"Форматирование","components.controls.blocktype.normal":"Обычный","components.controls.colorpicker.colorpicker":"Выбор цвета","components.controls.colorpicker.text":"Текст","components.controls.colorpicker.background":"Фон","components.controls.embedded.embedded":"Встраивание","components.controls.embedded.embeddedlink":"Ссылка в iFrame","components.controls.embedded.enterlink":"Вставьте ссылку","components.controls.emoji.emoji":"Эмодзи","components.controls.fontfamily.fontfamily":"Шрифт","components.controls.fontsize.fontsize":"Размер шрифта","components.controls.history.history":"История","components.controls.history.undo":"Отменить","components.controls.history.redo":"Вернуть","components.controls.image.image":"Изображение","components.controls.image.fileUpload":"Файлы","components.controls.image.byURL":"URL","components.controls.image.dropFileText":"Переместите в эту область файлы или кликните для загрузки","components.controls.inline.bold":"Жирный","components.controls.inline.italic":"Курсив","components.controls.inline.underline":"Подчеркивание","components.controls.inline.strikethrough":"Зачеркивание","components.controls.inline.monospace":"Monospace","components.controls.inline.superscript":"Верхний индекс","components.controls.inline.subscript":"Нижний индекс","components.controls.link.linkTitle":"Текст","components.controls.link.linkTarget":"Адрес ссылки","components.controls.link.linkTargetOption":"Открывать в новом окне","components.controls.link.link":"Ссылка","components.controls.link.unlink":"Убрать ссылку","components.controls.list.list":"Список","components.controls.list.unordered":"Неупорядоченный","components.controls.list.ordered":"Упорядоченный","components.controls.list.indent":"Отступ","components.controls.list.outdent":"Выступ","components.controls.remove.remove":"Удалить","components.controls.textalign.textalign":"Выравнивание текста","components.controls.textalign.left":"Слева","components.controls.textalign.center":"По центру","components.controls.textalign.right":"Справа","components.controls.textalign.justify":"Выравнить"},pt:{"generic.add":"Ok","generic.cancel":"Cancelar","components.controls.blocktype.h1":"Título 1","components.controls.blocktype.h2":"Título 2","components.controls.blocktype.h3":"Título 3","components.controls.blocktype.h4":"Título 4","components.controls.blocktype.h5":"Título 5","components.controls.blocktype.h6":"Título 6","components.controls.blocktype.blockquote":"Citação","components.controls.blocktype.code":"Code","components.controls.blocktype.blocktype":"Estilo","components.controls.blocktype.normal":"Normal","components.controls.colorpicker.colorpicker":"Paleta de cores","components.controls.colorpicker.text":"Texto","components.controls.colorpicker.background":"Fundo","components.controls.embedded.embedded":"Embarcado","components.controls.embedded.embeddedlink":"Link embarcado","components.controls.embedded.enterlink":"Coloque o link","components.controls.emoji.emoji":"Emoji","components.controls.fontfamily.fontfamily":"Fonte","components.controls.fontsize.fontsize":"Tamanho da Fonte","components.controls.history.history":"Histórico","components.controls.history.undo":"Desfazer","components.controls.history.redo":"Refazer","components.controls.image.image":"Imagem","components.controls.image.fileUpload":"Carregar arquivo","components.controls.image.byURL":"URL","components.controls.image.dropFileText":"Arraste uma imagem aqui ou clique para carregar","components.controls.inline.bold":"Negrito","components.controls.inline.italic":"Itálico","components.controls.inline.underline":"Sublinhado","components.controls.inline.strikethrough":"Strikethrough","components.controls.inline.monospace":"Monospace","components.controls.inline.superscript":"Sobrescrito","components.controls.inline.subscript":"Subscrito","components.controls.link.linkTitle":"Título do link","components.controls.link.linkTarget":"Alvo do link","components.controls.link.linkTargetOption":"Abrir link em outra janela","components.controls.link.link":"Adicionar Link","components.controls.link.unlink":"Remover link","components.controls.list.list":"Lista","components.controls.list.unordered":"Sem ordenção","components.controls.list.ordered":"Ordenada","components.controls.list.indent":"Aumentar recuo","components.controls.list.outdent":"Diminuir recuo","components.controls.remove.remove":"Remover","components.controls.textalign.textalign":"Alinhamento do texto","components.controls.textalign.left":"À Esquerda","components.controls.textalign.center":"Centralizado","components.controls.textalign.right":"À Direita","components.controls.textalign.justify":"Justificado"},ko:{"generic.add":"입력","generic.cancel":"취소","components.controls.blocktype.h1":"제목1","components.controls.blocktype.h2":"제목2","components.controls.blocktype.h3":"제목3","components.controls.blocktype.h4":"제목4","components.controls.blocktype.h5":"제목5","components.controls.blocktype.h6":"제목6","components.controls.blocktype.blockquote":"인용","components.controls.blocktype.code":"Code","components.controls.blocktype.blocktype":"블록","components.controls.blocktype.normal":"표준","components.controls.colorpicker.colorpicker":"색상 선택","components.controls.colorpicker.text":"글꼴색","components.controls.colorpicker.background":"배경색","components.controls.embedded.embedded":"임베드","components.controls.embedded.embeddedlink":"임베드 링크","components.controls.embedded.enterlink":"주소를 입력하세요","components.controls.emoji.emoji":"이모지","components.controls.fontfamily.fontfamily":"글꼴","components.controls.fontsize.fontsize":"글꼴 크기","components.controls.history.history":"히스토리","components.controls.history.undo":"실행 취소","components.controls.history.redo":"다시 실행","components.controls.image.image":"이미지","components.controls.image.fileUpload":"파일 업로드","components.controls.image.byURL":"주소","components.controls.image.dropFileText":"클릭하거나 파일을 드롭하여 업로드하세요","components.controls.inline.bold":"굵게","components.controls.inline.italic":"기울임꼴","components.controls.inline.underline":"밑줄","components.controls.inline.strikethrough":"취소선","components.controls.inline.monospace":"고정 너비","components.controls.inline.superscript":"위 첨자","components.controls.inline.subscript":"아래 첨자","components.controls.link.linkTitle":"링크 제목","components.controls.link.linkTarget":"링크 타겟","components.controls.link.linkTargetOption":"새창으로 열기","components.controls.link.link":"링크","components.controls.link.unlink":"링크 제거","components.controls.list.list":"리스트","components.controls.list.unordered":"일반 리스트","components.controls.list.ordered":"순서 리스트","components.controls.list.indent":"들여쓰기","components.controls.list.outdent":"내어쓰기","components.controls.remove.remove":"삭제","components.controls.textalign.textalign":"텍스트 정렬","components.controls.textalign.left":"왼쪽","components.controls.textalign.center":"중앙","components.controls.textalign.right":"오른쪽","components.controls.textalign.justify":"양쪽"},it:{"generic.add":"Aggiungi","generic.cancel":"Annulla","components.controls.blocktype.h1":"H1","components.controls.blocktype.h2":"H2","components.controls.blocktype.h3":"H3","components.controls.blocktype.h4":"H4","components.controls.blocktype.h5":"H5","components.controls.blocktype.h6":"H6","components.controls.blocktype.blockquote":"Citazione","components.controls.blocktype.code":"Codice","components.controls.blocktype.blocktype":"Stili","components.controls.blocktype.normal":"Normale","components.controls.colorpicker.colorpicker":"Colore testo","components.controls.colorpicker.text":"Testo","components.controls.colorpicker.background":"Evidenziazione","components.controls.embedded.embedded":"Incorpora","components.controls.embedded.embeddedlink":"Incorpora link","components.controls.embedded.enterlink":"Inserisci link","components.controls.emoji.emoji":"Emoji","components.controls.fontfamily.fontfamily":"Carattere","components.controls.fontsize.fontsize":"Dimensione carattere","components.controls.history.history":"Modifiche","components.controls.history.undo":"Annulla","components.controls.history.redo":"Ripristina","components.controls.image.image":"Immagine","components.controls.image.fileUpload":"Carica immagine","components.controls.image.byURL":"URL","components.controls.image.dropFileText":"Trascina il file o clicca per caricare","components.controls.inline.bold":"Grassetto","components.controls.inline.italic":"Corsivo","components.controls.inline.underline":"Sottolineato","components.controls.inline.strikethrough":"Barrato","components.controls.inline.monospace":"Monospace","components.controls.inline.superscript":"Apice","components.controls.inline.subscript":"Pedice","components.controls.link.linkTitle":"Testo","components.controls.link.linkTarget":"Link","components.controls.link.linkTargetOption":"Apri link in una nuova finestra","components.controls.link.link":"Inserisci link","components.controls.link.unlink":"Rimuovi link","components.controls.list.list":"Lista","components.controls.list.unordered":"Elenco puntato","components.controls.list.ordered":"Elenco numerato","components.controls.list.indent":"Indent","components.controls.list.outdent":"Outdent","components.controls.remove.remove":"Rimuovi formattazione","components.controls.textalign.textalign":"Allineamento del testo","components.controls.textalign.left":"Allinea a sinistra","components.controls.textalign.center":"Allinea al centro","components.controls.textalign.right":"Allinea a destra","components.controls.textalign.justify":"Giustifica"},nl:{"generic.add":"Toevoegen","generic.cancel":"Annuleren","components.controls.blocktype.h1":"H1","components.controls.blocktype.h2":"H2","components.controls.blocktype.h3":"H3","components.controls.blocktype.h4":"H4","components.controls.blocktype.h5":"H5","components.controls.blocktype.h6":"H6","components.controls.blocktype.blockquote":"Blockquote","components.controls.blocktype.code":"Code","components.controls.blocktype.blocktype":"Blocktype","components.controls.blocktype.normal":"Normaal","components.controls.colorpicker.colorpicker":"Kleurkiezer","components.controls.colorpicker.text":"Tekst","components.controls.colorpicker.background":"Achtergrond","components.controls.embedded.embedded":"Ingevoegd","components.controls.embedded.embeddedlink":"Ingevoegde link","components.controls.embedded.enterlink":"Voeg link toe","components.controls.emoji.emoji":"Emoji","components.controls.fontfamily.fontfamily":"Lettertype","components.controls.fontsize.fontsize":"Lettergrootte","components.controls.history.history":"Geschiedenis","components.controls.history.undo":"Ongedaan maken","components.controls.history.redo":"Opnieuw","components.controls.image.image":"Afbeelding","components.controls.image.fileUpload":"Bestand uploaden","components.controls.image.byURL":"URL","components.controls.image.dropFileText":"Drop het bestand hier of klik om te uploaden","components.controls.inline.bold":"Dikgedrukt","components.controls.inline.italic":"Schuingedrukt","components.controls.inline.underline":"Onderstrepen","components.controls.inline.strikethrough":"Doorstrepen","components.controls.inline.monospace":"Monospace","components.controls.inline.superscript":"Superscript","components.controls.inline.subscript":"Subscript","components.controls.link.linkTitle":"Linktitel","components.controls.link.linkTarget":"Link bestemming","components.controls.link.linkTargetOption":"Open link in een nieuw venster","components.controls.link.link":"Link","components.controls.link.unlink":"Unlink","components.controls.list.list":"Lijst","components.controls.list.unordered":"Ongeordend","components.controls.list.ordered":"Geordend","components.controls.list.indent":"Inspringen","components.controls.list.outdent":"Inspringen verkleinen","components.controls.remove.remove":"Verwijderen","components.controls.textalign.textalign":"Tekst uitlijnen","components.controls.textalign.left":"Links","components.controls.textalign.center":"Gecentreerd","components.controls.textalign.right":"Rechts","components.controls.textalign.justify":"Uitgelijnd"},de:{"generic.add":"Hinzufügen","generic.cancel":"Abbrechen","components.controls.blocktype.h1":"Überschrift 1","components.controls.blocktype.h2":"Überschrift 2","components.controls.blocktype.h3":"Überschrift 3","components.controls.blocktype.h4":"Überschrift 4","components.controls.blocktype.h5":"Überschrift 5","components.controls.blocktype.h6":"Überschrift 6","components.controls.blocktype.blockquote":"Zitat","components.controls.blocktype.code":"Quellcode","components.controls.blocktype.blocktype":"Blocktyp","components.controls.blocktype.normal":"Normal","components.controls.colorpicker.colorpicker":"Farbauswahl","components.controls.colorpicker.text":"Text","components.controls.colorpicker.background":"Hintergrund","components.controls.embedded.embedded":"Eingebettet","components.controls.embedded.embeddedlink":"Eingebetteter Link","components.controls.embedded.enterlink":"Link eingeben","components.controls.emoji.emoji":"Emoji","components.controls.fontfamily.fontfamily":"Schriftart","components.controls.fontsize.fontsize":"Schriftgröße","components.controls.history.history":"Historie","components.controls.history.undo":"Zurücknehmen","components.controls.history.redo":"Wiederholen","components.controls.image.image":"Bild","components.controls.image.fileUpload":"Datei-Upload","components.controls.image.byURL":"URL","components.controls.image.dropFileText":"Dateien ziehen und ablegen, oder klicken zum Hochladen","components.controls.inline.bold":"Fett","components.controls.inline.italic":"Kursiv","components.controls.inline.underline":"Unterstreichen","components.controls.inline.strikethrough":"Durchstreichen","components.controls.inline.monospace":"Monospace","components.controls.inline.superscript":"Hochgestellt","components.controls.inline.subscript":"Tiefgestellt","components.controls.link.linkTitle":"Link-Titel","components.controls.link.linkTarget":"Link-Ziel","components.controls.link.linkTargetOption":"Link in neuem Fenster öffnen","components.controls.link.link":"Link","components.controls.link.unlink":"Aufheben","components.controls.list.list":"Liste","components.controls.list.unordered":"Aufzählung","components.controls.list.ordered":"Nummerierte Liste","components.controls.list.indent":"Einzug vergrößern","components.controls.list.outdent":"Einzug reduzieren","components.controls.remove.remove":"Entfernen","components.controls.textalign.textalign":"Textausrichtung","components.controls.textalign.left":"Linksbündig","components.controls.textalign.center":"Zentrieren","components.controls.textalign.right":"Rechtsbündig","components.controls.textalign.justify":"Blocksatz"},da:{"generic.add":"Tilføj","generic.cancel":"Annuller","components.controls.blocktype.h1":"Overskrift 1","components.controls.blocktype.h2":"Overskrift 2","components.controls.blocktype.h3":"Overskrift 3","components.controls.blocktype.h4":"Overskrift 4","components.controls.blocktype.h5":"Overskrift 5","components.controls.blocktype.h6":"Overskrift 6","components.controls.blocktype.blockquote":"Blokcitat","components.controls.blocktype.code":"Kode","components.controls.blocktype.blocktype":"Blok Type","components.controls.blocktype.normal":"Normal","components.controls.colorpicker.colorpicker":"Farver","components.controls.colorpicker.text":"Tekst","components.controls.colorpicker.background":"Baggrund","components.controls.embedded.embedded":"Indlejre","components.controls.embedded.embeddedlink":"Indlejre Link","components.controls.embedded.enterlink":"Indtast link","components.controls.emoji.emoji":"Emoji","components.controls.fontfamily.fontfamily":"Fonttype","components.controls.fontsize.fontsize":"Fontstørrelser","components.controls.history.history":"Historie","components.controls.history.undo":"Fortryd","components.controls.history.redo":"Gendan","components.controls.image.image":"Billede","components.controls.image.fileUpload":"Filoverførsel","components.controls.image.byURL":"URL","components.controls.image.dropFileText":"Drop filen eller klik for at uploade","components.controls.inline.bold":"Fed","components.controls.inline.italic":"Kursiv","components.controls.inline.underline":"Understrege","components.controls.inline.strikethrough":"Gennemstreget","components.controls.inline.monospace":"Monospace","components.controls.inline.superscript":"Hævet","components.controls.inline.subscript":"Sænket","components.controls.link.linkTitle":"Link Titel","components.controls.link.linkTarget":"Link Mål","components.controls.link.linkTargetOption":"Åbn link i nyt vindue","components.controls.link.link":"Link","components.controls.link.unlink":"Fjern link","components.controls.list.list":"Liste","components.controls.list.unordered":"Uordnet","components.controls.list.ordered":"Ordnet","components.controls.list.indent":"Indrykning","components.controls.list.outdent":"Udrykning","components.controls.remove.remove":"Fjern","components.controls.textalign.textalign":"Tekstjustering","components.controls.textalign.left":"Venstre","components.controls.textalign.center":"Center","components.controls.textalign.right":"Højre","components.controls.textalign.justify":"Margener"},zh_tw:{"generic.add":"新增","generic.cancel":"取消","components.controls.blocktype.h1":"標題1","components.controls.blocktype.h2":"標題2","components.controls.blocktype.h3":"標題3","components.controls.blocktype.h4":"標題4","components.controls.blocktype.h5":"標題5","components.controls.blocktype.h6":"標題6","components.controls.blocktype.blockquote":"引用","components.controls.blocktype.code":"程式碼","components.controls.blocktype.blocktype":"樣式","components.controls.blocktype.normal":"正文","components.controls.colorpicker.colorpicker":"選色器","components.controls.colorpicker.text":"文字","components.controls.colorpicker.background":"背景","components.controls.embedded.embedded":"內嵌","components.controls.embedded.embeddedlink":"內嵌網頁","components.controls.embedded.enterlink":"輸入網頁地址","components.controls.emoji.emoji":"表情符號","components.controls.fontfamily.fontfamily":"字體","components.controls.fontsize.fontsize":"字體大小","components.controls.history.history":"歷史紀錄","components.controls.history.undo":"復原","components.controls.history.redo":"重做","components.controls.image.image":"圖片","components.controls.image.fileUpload":"檔案上傳","components.controls.image.byURL":"網址","components.controls.image.dropFileText":"點擊或拖曳檔案上傳","components.controls.inline.bold":"粗體","components.controls.inline.italic":"斜體","components.controls.inline.underline":"底線","components.controls.inline.strikethrough":"刪除線","components.controls.inline.monospace":"等寬字體","components.controls.inline.superscript":"上標","components.controls.inline.subscript":"下標","components.controls.link.linkTitle":"超連結","components.controls.link.linkTarget":"輸入連結位址","components.controls.link.linkTargetOption":"在新視窗打開連結","components.controls.link.link":"連結","components.controls.link.unlink":"刪除連結","components.controls.list.list":"列表","components.controls.list.unordered":"項目符號","components.controls.list.ordered":"編號","components.controls.list.indent":"增加縮排","components.controls.list.outdent":"減少縮排","components.controls.remove.remove":"清除格式","components.controls.textalign.textalign":"文字對齊","components.controls.textalign.left":"文字向左對齊","components.controls.textalign.center":"文字置中","components.controls.textalign.right":"文字向右對齊","components.controls.textalign.justify":"兩端對齊"},pl:{"generic.add":"Dodaj","generic.cancel":"Anuluj","components.controls.blocktype.h1":"Nagłówek 1","components.controls.blocktype.h2":"Nagłówek 2","components.controls.blocktype.h3":"Nagłówek 3","components.controls.blocktype.h4":"Nagłówek 4","components.controls.blocktype.h5":"Nagłówek 5","components.controls.blocktype.h6":"Nagłówek 6","components.controls.blocktype.blockquote":"Cytat","components.controls.blocktype.code":"Kod","components.controls.blocktype.blocktype":"Format","components.controls.blocktype.normal":"Normalny","components.controls.colorpicker.colorpicker":"Kolor","components.controls.colorpicker.text":"Tekst","components.controls.colorpicker.background":"Tło","components.controls.embedded.embedded":"Osadź","components.controls.embedded.embeddedlink":"Osadź odnośnik","components.controls.embedded.enterlink":"Wprowadź odnośnik","components.controls.emoji.emoji":"Emoji","components.controls.fontfamily.fontfamily":"Krój czcionki","components.controls.fontsize.fontsize":"Rozmiar czcionki","components.controls.history.history":"Historia","components.controls.history.undo":"Cofnij","components.controls.history.redo":"Ponów","components.controls.image.image":"Obrazek","components.controls.image.fileUpload":"Prześlij plik","components.controls.image.byURL":"URL","components.controls.image.dropFileText":"Upuść plik lub kliknij, aby przesłać","components.controls.inline.bold":"Pogrubienie","components.controls.inline.italic":"Kursywa","components.controls.inline.underline":"Podkreślenie","components.controls.inline.strikethrough":"Przekreślenie","components.controls.inline.monospace":"Monospace","components.controls.inline.superscript":"Indeks górny","components.controls.inline.subscript":"Indeks dolny","components.controls.link.linkTitle":"Tytuł odnośnika","components.controls.link.linkTarget":"Adres odnośnika","components.controls.link.linkTargetOption":"Otwórz odnośnik w nowej karcie","components.controls.link.link":"Wstaw odnośnik","components.controls.link.unlink":"Usuń odnośnik","components.controls.list.list":"Lista","components.controls.list.unordered":"Lista nieuporządkowana","components.controls.list.ordered":"Lista uporządkowana","components.controls.list.indent":"Zwiększ wcięcie","components.controls.list.outdent":"Zmniejsz wcięcie","components.controls.remove.remove":"Usuń","components.controls.textalign.textalign":"Wyrównaj tekst","components.controls.textalign.left":"Do lewej","components.controls.textalign.center":"Do środka","components.controls.textalign.right":"Do prawej","components.controls.textalign.justify":"Wyjustuj"},es:{"generic.add":"Añadir","generic.cancel":"Cancelar","components.controls.blocktype.h1":"H1","components.controls.blocktype.h2":"H2","components.controls.blocktype.h3":"H3","components.controls.blocktype.h4":"H4","components.controls.blocktype.h5":"H5","components.controls.blocktype.h6":"H6","components.controls.blocktype.blockquote":"Blockquote","components.controls.blocktype.code":"Código","components.controls.blocktype.blocktype":"Tipo de bloque","components.controls.blocktype.normal":"Normal","components.controls.colorpicker.colorpicker":"Seleccionar color","components.controls.colorpicker.text":"Texto","components.controls.colorpicker.background":"Subrayado","components.controls.embedded.embedded":"Adjuntar","components.controls.embedded.embeddedlink":"Adjuntar Link","components.controls.embedded.enterlink":"Introducir link","components.controls.emoji.emoji":"Emoji","components.controls.fontfamily.fontfamily":"Fuente","components.controls.fontsize.fontsize":"Tamaño de fuente","components.controls.history.history":"Histórico","components.controls.history.undo":"Deshacer","components.controls.history.redo":"Rehacer","components.controls.image.image":"Imagen","components.controls.image.fileUpload":"Subir archivo","components.controls.image.byURL":"URL","components.controls.image.dropFileText":"Arrastra el archivo o haz click para subirlo","components.controls.inline.bold":"Negrita","components.controls.inline.italic":"Cursiva","components.controls.inline.underline":"Subrayado","components.controls.inline.strikethrough":"Tachado","components.controls.inline.monospace":"Monospace","components.controls.inline.superscript":"Sobreíndice","components.controls.inline.subscript":"Subíndice","components.controls.link.linkTitle":"Título del enlace","components.controls.link.linkTarget":"Objetivo del enlace","components.controls.link.linkTargetOption":"Abrir en nueva ventana","components.controls.link.link":"Enlazar","components.controls.link.unlink":"Desenlazar","components.controls.list.list":"Lista","components.controls.list.unordered":"Desordenada","components.controls.list.ordered":"Ordenada","components.controls.list.indent":"Indentada","components.controls.list.outdent":"Dentada","components.controls.remove.remove":"Eliminar","components.controls.textalign.textalign":"Alineación del texto","components.controls.textalign.left":"Izquierda","components.controls.textalign.center":"Centrado","components.controls.textalign.right":"Derecha","components.controls.textalign.justify":"Justificado"},ja:{"generic.add":"追加","generic.cancel":"キャンセル","components.controls.blocktype.h1":"見出し1","components.controls.blocktype.h2":"見出し2","components.controls.blocktype.h3":"見出し3","components.controls.blocktype.h4":"見出し4","components.controls.blocktype.h5":"見出し5","components.controls.blocktype.h6":"見出し6","components.controls.blocktype.blockquote":"引用","components.controls.blocktype.code":"コード","components.controls.blocktype.blocktype":"スタイル","components.controls.blocktype.normal":"標準テキスト","components.controls.colorpicker.colorpicker":"テキストの色","components.controls.colorpicker.text":"テキスト","components.controls.colorpicker.background":"ハイライト","components.controls.embedded.embedded":"埋め込み","components.controls.embedded.embeddedlink":"埋め込みリンク","components.controls.embedded.enterlink":"リンクを入力してください","components.controls.emoji.emoji":"絵文字","components.controls.fontfamily.fontfamily":"フォント","components.controls.fontsize.fontsize":"フォントサイズ","components.controls.history.history":"履歴","components.controls.history.undo":"元に戻す","components.controls.history.redo":"やり直し","components.controls.image.image":"画像","components.controls.image.fileUpload":"ファイルをアップロード","components.controls.image.byURL":"URL","components.controls.image.dropFileText":"ここに画像をドラッグするか、クリックしてください","components.controls.inline.bold":"太字","components.controls.inline.italic":"斜体","components.controls.inline.underline":"下線","components.controls.inline.strikethrough":"取り消し線","components.controls.inline.monospace":"等幅フォント","components.controls.inline.superscript":"上付き文字","components.controls.inline.subscript":"下付き文字","components.controls.link.linkTitle":"リンクタイトル","components.controls.link.linkTarget":"リンク対象","components.controls.link.linkTargetOption":"新しいウィンドウで開く","components.controls.link.link":"リンク","components.controls.link.unlink":"リンクを解除","components.controls.list.list":"リスト","components.controls.list.unordered":"箇条書き","components.controls.list.ordered":"番号付き","components.controls.list.indent":"インデント増","components.controls.list.outdent":"インデント減","components.controls.remove.remove":"書式をクリア","components.controls.textalign.textalign":"整列","components.controls.textalign.left":"左揃え","components.controls.textalign.center":"中央揃え","components.controls.textalign.right":"右揃え","components.controls.textalign.justify":"両端揃え"}};n(38),n(39);function Vo(t){return(Vo="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function qo(){return(qo=Object.assign?Object.assign.bind():function(t){for(var e=1;e<arguments.length;e++){var n=arguments[e];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(t[o]=n[o])}return t}).apply(this,arguments)}function Ko(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var o=Object.getOwnPropertySymbols(e);t&&(o=o.filter(function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable})),n.push.apply(n,o)}return n}function Xo(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?Ko(Object(n),!0).forEach(function(t){$o(e,t,n[t])}):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):Ko(Object(n)).forEach(function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))})}return e}function $o(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}function tr(t){return function(t){if(Array.isArray(t))return er(t)}(t)||function(t){if("undefined"!=typeof Symbol&&null!=t[Symbol.iterator]||null!=t["@@iterator"])return Array.from(t)}(t)||function(t,e){if(!t)return;if("string"==typeof t)return er(t,e);var n=Object.prototype.toString.call(t).slice(8,-1);"Object"===n&&t.constructor&&(n=t.constructor.name);if("Map"===n||"Set"===n)return Array.from(t);if("Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return er(t,e)}(t)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function er(t,e){(null==e||e>t.length)&&(e=t.length);for(var n=0,o=new Array(e);n<e;n++)o[n]=t[n];return o}function nr(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function or(t,e){return(or=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function rr(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=ir(o);if(r){var n=ir(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===Vo(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function ir(t){return(ir=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var cr=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&or(t,e)}(i,f["Component"]);var t,e,n,r=rr(i);function i(t){var c;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,i),(c=r.call(this,t)).onEditorBlur=function(){c.setState({editorFocused:!1})},c.onEditorFocus=function(t){var e=c.props.onFocus;c.setState({editorFocused:!0});var n=c.focusHandler.isEditorFocused();e&&n&&e(t)},c.onEditorMouseDown=function(){c.focusHandler.onEditorMouseDown()},c.keyBindingFn=function(t){if("Tab"!==t.key)return"ArrowUp"!==t.key&&"ArrowDown"!==t.key||b()&&t.preventDefault(),Object(E.getDefaultKeyBinding)(t);var e=c.props.onTab;if(!e||!e(t)){var n=Object(S.changeDepth)(c.state.editorState,t.shiftKey?-1:1,4);n&&n!==c.state.editorState&&(c.onChange(n),t.preventDefault())}return null},c.onToolbarFocus=function(t){var e=c.props.onFocus;e&&c.focusHandler.isToolbarFocused()&&e(t)},c.onWrapperBlur=function(t){var e=c.props.onBlur;e&&c.focusHandler.isEditorBlur(t)&&e(t,c.getEditorState())},c.onChange=function(t){var e=c.props,n=e.readOnly,o=e.onEditorStateChange;n||"atomic"===Object(S.getSelectedBlocksType)(t)&&t.getSelection().isCollapsed||(o&&o(t,c.props.wrapperId),M(c.props,"editorState")?c.afterChange(t):c.setState({editorState:t},c.afterChange(t)))},c.setWrapperReference=function(t){c.wrapper=t},c.setEditorReference=function(t){c.props.editorRef&&c.props.editorRef(t),c.editor=t},c.getCompositeDecorator=function(t){var e=[].concat(tr(c.props.customDecorators),[{strategy:Mo,component:jo({showOpenOptionOnHover:t.link.showOpenOptionOnHover})}]);return c.props.mention&&e.push.apply(e,tr(To(Xo(Xo({},c.props.mention),{},{onChange:c.onChange,getEditorState:c.getEditorState,getSuggestions:c.getSuggestions,getWrapperRef:c.getWrapperRef,modalHandler:c.modalHandler})))),c.props.hashtag&&e.push(Ro(c.props.hashtag)),new E.CompositeDecorator(e)},c.getWrapperRef=function(){return c.wrapper},c.getEditorState=function(){return c.state?c.state.editorState:null},c.getSuggestions=function(){return c.props.mention&&c.props.mention.suggestions},c.afterChange=function(o){setTimeout(function(){var t=c.props,e=t.onChange,n=t.onContentStateChange;e&&e(Object(E.convertToRaw)(o.getCurrentContent())),n&&n(Object(E.convertToRaw)(o.getCurrentContent()))})},c.isReadOnly=function(){return c.props.readOnly},c.isImageAlignmentEnabled=function(){return c.state.toolbar.image.alignmentEnabled},c.createEditorState=function(t){var e;if(M(c.props,"editorState"))c.props.editorState&&(e=E.EditorState.set(c.props.editorState,{decorator:t}));else if(M(c.props,"defaultEditorState"))c.props.defaultEditorState&&(e=E.EditorState.set(c.props.defaultEditorState,{decorator:t}));else if(M(c.props,"contentState")){if(c.props.contentState){var n=Object(E.convertFromRaw)(c.props.contentState);e=E.EditorState.createWithContent(n,t),e=E.EditorState.moveSelectionToEnd(e)}}else if(M(c.props,"defaultContentState")||M(c.props,"initialContentState")){var o=c.props.defaultContentState||c.props.initialContentState;o&&(o=Object(E.convertFromRaw)(o),e=E.EditorState.createWithContent(o,t),e=E.EditorState.moveSelectionToEnd(e))}return e=e||E.EditorState.createEmpty(t)},c.filterEditorProps=function(t){return e=t,n=["onChange","onEditorStateChange","onContentStateChange","initialContentState","defaultContentState","contentState","editorState","defaultEditorState","locale","localization","toolbarOnFocus","toolbar","toolbarCustomButtons","toolbarClassName","editorClassName","toolbarHidden","wrapperClassName","toolbarStyle","editorStyle","wrapperStyle","uploadCallback","onFocus","onBlur","onTab","mention","hashtag","ariaLabel","customBlockRenderFunc","customDecorators","handlePastedText","customStyleMap"],o=Object.keys(e).filter(function(t){return n.indexOf(t)<0}),r={},o&&0<o.length&&o.forEach(function(t){r[t]=e[t]}),r;var e,n,o,r},c.getStyleMap=function(t){return Xo(Xo({},Object(S.getCustomStyleMap)()),t.customStyleMap)},c.changeEditorState=function(t){var e=Object(E.convertFromRaw)(t),n=c.state.editorState;return n=E.EditorState.push(n,e,"insert-characters"),n=E.EditorState.moveSelectionToEnd(n)},c.focusEditor=function(){setTimeout(function(){c.editor.focus()})},c.handleKeyCommand=function(t){var e=c.state,n=e.editorState,o=e.toolbar.inline;if(o&&0<=o.options.indexOf(t)){var r=E.RichUtils.handleKeyCommand(n,t);if(r)return c.onChange(r),!0}return!1},c.handleReturn=function(t){if(b())return!0;var e=c.state.editorState,n=Object(S.handleNewLine)(e,t);return!!n&&(c.onChange(n),!0)},c.handlePastedTextFn=function(t,e){var n=c.state.editorState,o=c.props,r=o.handlePastedText,i=o.stripPastedStyles;return r?r(t,e,n,c.onChange):!i&&function(t,e,n,o){var r=Object(S.getSelectedBlock)(n);if(r&&"code"===r.type){var i=E.Modifier.replaceText(n.getCurrentContent(),n.getSelection(),t,n.getCurrentInlineStyle());return o(E.EditorState.push(n,i,"insert-characters")),!0}if(e){var c=O()(e),a=n.getCurrentContent();return c.entityMap.forEach(function(t,e){a=a.mergeEntityData(e,t)}),a=E.Modifier.replaceWithFragment(a,n.getSelection(),new x.List(c.contentBlocks)),o(E.EditorState.push(n,a,"insert-characters")),!0}return!1}(t,e,n,c.onChange)},c.preventDefault=function(t){"INPUT"===t.target.tagName||"LABEL"===t.target.tagName||"TEXTAREA"===t.target.tagName?c.focusHandler.onInputMouseDown():t.preventDefault()};var e=D(Go,t.toolbar),n=t.wrapperId?t.wrapperId:Math.floor(1e4*Math.random());c.wrapperId="rdw-wrapper-".concat(n),c.modalHandler=new a,c.focusHandler=new p,c.blockRendererFn=Wo({isReadOnly:c.isReadOnly,isImageAlignmentEnabled:c.isImageAlignmentEnabled,getEditorState:c.getEditorState,onChange:c.onChange},t.customBlockRenderFunc),c.editorProps=c.filterEditorProps(t),c.customStyleMap=c.getStyleMap(t),c.compositeDecorator=c.getCompositeDecorator(e);var o=c.createEditorState(c.compositeDecorator);return Object(S.extractInlineStyle)(o),c.state={editorState:o,editorFocused:!1,toolbar:e},c}return t=i,(e=[{key:"componentDidMount",value:function(){this.modalHandler.init(this.wrapperId)}},{key:"componentDidUpdate",value:function(t){if(t!==this.props){var e={},n=this.props,o=n.editorState,r=n.contentState;if(!this.state.toolbar){var i=D(Go,i);e.toolbar=i}if(M(this.props,"editorState")&&o!==t.editorState)e.editorState=o?E.EditorState.set(o,{decorator:this.compositeDecorator}):E.EditorState.createEmpty(this.compositeDecorator);else if(M(this.props,"contentState")&&r!==t.contentState)if(r){var c=this.changeEditorState(r);c&&(e.editorState=c)}else e.editorState=E.EditorState.createEmpty(this.compositeDecorator);t.editorState===o&&t.contentState===r||Object(S.extractInlineStyle)(e.editorState),Object.keys(e).length&&this.setState(e),this.editorProps=this.filterEditorProps(this.props),this.customStyleMap=this.getStyleMap(this.props)}}},{key:"render",value:function(){var t=this.state,e=t.editorState,n=t.editorFocused,r=t.toolbar,o=this.props,i=o.locale,c=o.localization,a=c.locale,l=c.translations,s=o.toolbarCustomButtons,u=o.toolbarOnFocus,p=o.toolbarClassName,d=o.toolbarHidden,f=o.editorClassName,y=o.wrapperClassName,m=o.toolbarStyle,g=o.editorStyle,b=o.wrapperStyle,h=o.uploadCallback,M=o.ariaLabel,j={modalHandler:this.modalHandler,editorState:e,onChange:this.onChange,translations:Xo(Xo({},Jo[i||a]),l)},v=n||this.focusHandler.isInputFocused()||!u;return N.a.createElement("div",{id:this.wrapperId,className:w()(y,"rdw-editor-wrapper"),style:b,onClick:this.modalHandler.onEditorClick,onBlur:this.onWrapperBlur,"aria-label":"rdw-wrapper"},!d&&N.a.createElement("div",{className:w()("rdw-editor-toolbar",p),style:Xo({visibility:v?"visible":"hidden"},m),onMouseDown:this.preventDefault,"aria-label":"rdw-toolbar","aria-hidden":(!n&&u).toString(),onFocus:this.onToolbarFocus},r.options.map(function(t,e){var n=so[t],o=r[t];return"image"===t&&h&&(o.uploadCallback=h),N.a.createElement(n,qo({key:e},j,{config:o}))}),s&&s.map(function(t,e){return N.a.cloneElement(t,Xo({key:e},j))})),N.a.createElement("div",{ref:this.setWrapperReference,className:w()(f,"rdw-editor-main"),style:g,onClick:this.focusEditor,onFocus:this.onEditorFocus,onBlur:this.onEditorBlur,onKeyDown:C.onKeyDown,onMouseDown:this.onEditorMouseDown},N.a.createElement(E.Editor,qo({ref:this.setEditorReference,keyBindingFn:this.keyBindingFn,editorState:e,onChange:this.onChange,blockStyleFn:L,customStyleMap:this.getStyleMap(this.props),handleReturn:this.handleReturn,handlePastedText:this.handlePastedTextFn,blockRendererFn:this.blockRendererFn,handleKeyCommand:this.handleKeyCommand,ariaLabel:M||"rdw-editor",blockRenderMap:S.blockRenderMap},this.editorProps))))}}])&&nr(t.prototype,e),n&&nr(t,n),Object.defineProperty(t,"prototype",{writable:!1}),i}();cr.propTypes={onChange:y.a.func,onEditorStateChange:y.a.func,onContentStateChange:y.a.func,initialContentState:y.a.object,defaultContentState:y.a.object,contentState:y.a.object,editorState:y.a.object,defaultEditorState:y.a.object,toolbarOnFocus:y.a.bool,spellCheck:y.a.bool,stripPastedStyles:y.a.bool,toolbar:y.a.object,toolbarCustomButtons:y.a.array,toolbarClassName:y.a.string,toolbarHidden:y.a.bool,locale:y.a.string,localization:y.a.object,editorClassName:y.a.string,wrapperClassName:y.a.string,toolbarStyle:y.a.object,editorStyle:y.a.object,wrapperStyle:y.a.object,uploadCallback:y.a.func,onFocus:y.a.func,onBlur:y.a.func,onTab:y.a.func,mention:y.a.object,hashtag:y.a.object,textAlignment:y.a.string,readOnly:y.a.bool,tabIndex:y.a.number,placeholder:y.a.string,ariaLabel:y.a.string,ariaOwneeID:y.a.string,ariaActiveDescendantID:y.a.string,ariaAutoComplete:y.a.string,ariaDescribedBy:y.a.string,ariaExpanded:y.a.string,ariaHasPopup:y.a.string,customBlockRenderFunc:y.a.func,wrapperId:y.a.number,customDecorators:y.a.array,editorRef:y.a.func,handlePastedText:y.a.func},cr.defaultProps={toolbarOnFocus:!1,toolbarHidden:!1,stripPastedStyles:!1,localization:{locale:"en",translations:{}},customDecorators:[]};var ar=cr}],i.c=a,i.d=function(t,e,n){i.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:n})},i.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},i.t=function(e,t){if(1&t&&(e=i(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var n=Object.create(null);if(i.r(n),Object.defineProperty(n,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var o in e)i.d(n,o,function(t){return e[t]}.bind(null,o));return n},i.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return i.d(e,"a",e),e},i.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},i.p="",i(i.s=8);function i(t){if(a[t])return a[t].exports;var e=a[t]={i:t,l:!1,exports:{}};return c[t].call(e.exports,e,e.exports,i),e.l=!0,e.exports}var c,a});

/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var uncurryThis = __webpack_require__(44);
	
	var toString = uncurryThis({}.toString);
	var stringSlice = uncurryThis(''.slice);
	
	module.exports = function (it) {
	  return stringSlice(toString(it), 8, -1);
	};


/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var isCallable = __webpack_require__(52);
	var definePropertyModule = __webpack_require__(75);
	var makeBuiltIn = __webpack_require__(614);
	var defineGlobalProperty = __webpack_require__(281);
	
	module.exports = function (O, key, value, options) {
	  if (!options) options = {};
	  var simple = options.enumerable;
	  var name = options.name !== undefined ? options.name : key;
	  if (isCallable(value)) makeBuiltIn(value, name, options);
	  if (options.global) {
	    if (simple) O[key] = value;
	    else defineGlobalProperty(key, value);
	  } else {
	    try {
	      if (!options.unsafe) delete O[key];
	      else if (O[key]) simple = true;
	    } catch (error) { /* empty */ }
	    if (simple) O[key] = value;
	    else definePropertyModule.f(O, key, {
	      value: value,
	      enumerable: false,
	      configurable: !options.nonConfigurable,
	      writable: !options.nonWritable
	    });
	  } return O;
	};


/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	/* global ActiveXObject -- old IE, WSH */
	var anObject = __webpack_require__(161);
	var definePropertiesModule = __webpack_require__(615);
	var enumBugKeys = __webpack_require__(283);
	var hiddenKeys = __webpack_require__(206);
	var html = __webpack_require__(1397);
	var documentCreateElement = __webpack_require__(282);
	var sharedKey = __webpack_require__(209);
	
	var GT = '>';
	var LT = '<';
	var PROTOTYPE = 'prototype';
	var SCRIPT = 'script';
	var IE_PROTO = sharedKey('IE_PROTO');
	
	var EmptyConstructor = function () { /* empty */ };
	
	var scriptTag = function (content) {
	  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
	};
	
	// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
	var NullProtoObjectViaActiveX = function (activeXDocument) {
	  activeXDocument.write(scriptTag(''));
	  activeXDocument.close();
	  var temp = activeXDocument.parentWindow.Object;
	  // eslint-disable-next-line no-useless-assignment -- avoid memory leak
	  activeXDocument = null;
	  return temp;
	};
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var NullProtoObjectViaIFrame = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = documentCreateElement('iframe');
	  var JS = 'java' + SCRIPT + ':';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  html.appendChild(iframe);
	  // https://github.com/zloirock/core-js/issues/475
	  iframe.src = String(JS);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(scriptTag('document.F=Object'));
	  iframeDocument.close();
	  return iframeDocument.F;
	};
	
	// Check for document.domain and active x support
	// No need to use active x approach when document.domain is not set
	// see https://github.com/es-shims/es5-shim/issues/150
	// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
	// avoid IE GC bug
	var activeXDocument;
	var NullProtoObject = function () {
	  try {
	    activeXDocument = new ActiveXObject('htmlfile');
	  } catch (error) { /* ignore */ }
	  NullProtoObject = typeof document != 'undefined'
	    ? document.domain && activeXDocument
	      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
	      : NullProtoObjectViaIFrame()
	    : NullProtoObjectViaActiveX(activeXDocument); // WSH
	  var length = enumBugKeys.length;
	  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
	  return NullProtoObject();
	};
	
	hiddenKeys[IE_PROTO] = true;
	
	// `Object.create` method
	// https://tc39.es/ecma262/#sec-object.create
	// eslint-disable-next-line es/no-object-create -- safe
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    EmptyConstructor[PROTOTYPE] = anObject(O);
	    result = new EmptyConstructor();
	    EmptyConstructor[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = NullProtoObject();
	  return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
	};


/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	/* eslint-disable es/no-symbol -- required for testing */
	var V8_VERSION = __webpack_require__(1391);
	var fails = __webpack_require__(50);
	var globalThis = __webpack_require__(54);
	
	var $String = globalThis.String;
	
	// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
	module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
	  var symbol = Symbol('symbol detection');
	  // Chrome 38 Symbol has incorrect toString conversion
	  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
	  // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
	  // of course, fail.
	  return !$String(symbol) || !(Object(symbol) instanceof Symbol) ||
	    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
	    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
	});


/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getLatLng = exports.geocodeByPlaceId = exports.geocodeByAddress = undefined;
	
	var _PlacesAutocomplete = __webpack_require__(1443);
	
	var _PlacesAutocomplete2 = _interopRequireDefault(_PlacesAutocomplete);
	
	var _utils = __webpack_require__(1445);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.geocodeByAddress = _utils.geocodeByAddress;
	exports.geocodeByPlaceId = _utils.geocodeByPlaceId;
	exports.getLatLng = _utils.getLatLng;
	exports.default = _PlacesAutocomplete2.default;

/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var React = __webpack_require__(1);
	var PropTypes = __webpack_require__(3);
	var uuid = __webpack_require__(1635);
	
	function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }
	
	var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
	var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);
	
	function ownKeys$2(object, enumerableOnly) {
	  var keys = Object.keys(object);
	  if (Object.getOwnPropertySymbols) {
	    var symbols = Object.getOwnPropertySymbols(object);
	    enumerableOnly && (symbols = symbols.filter(function (sym) {
	      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
	    })), keys.push.apply(keys, symbols);
	  }
	  return keys;
	}
	function _objectSpread2(target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = null != arguments[i] ? arguments[i] : {};
	    i % 2 ? ownKeys$2(Object(source), !0).forEach(function (key) {
	      _defineProperty(target, key, source[key]);
	    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2(Object(source)).forEach(function (key) {
	      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
	    });
	  }
	  return target;
	}
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];
	    descriptor.enumerable = descriptor.enumerable || false;
	    descriptor.configurable = true;
	    if ("value" in descriptor) descriptor.writable = true;
	    Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	  if (staticProps) _defineProperties(Constructor, staticProps);
	  Object.defineProperty(Constructor, "prototype", {
	    writable: false
	  });
	  return Constructor;
	}
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	  return obj;
	}
	function _extends() {
	  _extends = Object.assign ? Object.assign.bind() : function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	    return target;
	  };
	  return _extends.apply(this, arguments);
	}
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      writable: true,
	      configurable: true
	    }
	  });
	  Object.defineProperty(subClass, "prototype", {
	    writable: false
	  });
	  if (superClass) _setPrototypeOf(subClass, superClass);
	}
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };
	  return _getPrototypeOf(o);
	}
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
	    o.__proto__ = p;
	    return o;
	  };
	  return _setPrototypeOf(o, p);
	}
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
	  if (Reflect.construct.sham) return false;
	  if (typeof Proxy === "function") return true;
	  try {
	    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
	    return true;
	  } catch (e) {
	    return false;
	  }
	}
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	  return self;
	}
	function _possibleConstructorReturn(self, call) {
	  if (call && (typeof call === "object" || typeof call === "function")) {
	    return call;
	  } else if (call !== void 0) {
	    throw new TypeError("Derived constructors may only return object or undefined");
	  }
	  return _assertThisInitialized(self);
	}
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();
	  return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	      result;
	    if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;
	      result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }
	    return _possibleConstructorReturn(this, result);
	  };
	}
	function _unsupportedIterableToArray(o, minLen) {
	  if (!o) return;
	  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
	  var n = Object.prototype.toString.call(o).slice(8, -1);
	  if (n === "Object" && o.constructor) n = o.constructor.name;
	  if (n === "Map" || n === "Set") return Array.from(o);
	  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
	}
	function _arrayLikeToArray(arr, len) {
	  if (len == null || len > arr.length) len = arr.length;
	  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
	  return arr2;
	}
	function _createForOfIteratorHelper(o, allowArrayLike) {
	  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
	  if (!it) {
	    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
	      if (it) o = it;
	      var i = 0;
	      var F = function () {};
	      return {
	        s: F,
	        n: function () {
	          if (i >= o.length) return {
	            done: true
	          };
	          return {
	            done: false,
	            value: o[i++]
	          };
	        },
	        e: function (e) {
	          throw e;
	        },
	        f: F
	      };
	    }
	    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	  }
	  var normalCompletion = true,
	    didErr = false,
	    err;
	  return {
	    s: function () {
	      it = it.call(o);
	    },
	    n: function () {
	      var step = it.next();
	      normalCompletion = step.done;
	      return step;
	    },
	    e: function (e) {
	      didErr = true;
	      err = e;
	    },
	    f: function () {
	      try {
	        if (!normalCompletion && it.return != null) it.return();
	      } finally {
	        if (didErr) throw err;
	      }
	    }
	  };
	}
	
	var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
	
	var check = function (it) {
	  return it && it.Math == Math && it;
	};
	
	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global$a =
	  // eslint-disable-next-line es/no-global-this -- safe
	  check(typeof globalThis == 'object' && globalThis) ||
	  check(typeof window == 'object' && window) ||
	  // eslint-disable-next-line no-restricted-globals -- safe
	  check(typeof self == 'object' && self) ||
	  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
	  // eslint-disable-next-line no-new-func -- fallback
	  (function () { return this; })() || Function('return this')();
	
	var objectGetOwnPropertyDescriptor = {};
	
	var fails$9 = function (exec) {
	  try {
	    return !!exec();
	  } catch (error) {
	    return true;
	  }
	};
	
	var fails$8 = fails$9;
	
	// Detect IE8's incomplete defineProperty implementation
	var descriptors = !fails$8(function () {
	  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
	  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
	});
	
	var fails$7 = fails$9;
	
	var functionBindNative = !fails$7(function () {
	  // eslint-disable-next-line es/no-function-prototype-bind -- safe
	  var test = (function () { /* empty */ }).bind();
	  // eslint-disable-next-line no-prototype-builtins -- safe
	  return typeof test != 'function' || test.hasOwnProperty('prototype');
	});
	
	var NATIVE_BIND$2 = functionBindNative;
	
	var call$4 = Function.prototype.call;
	
	var functionCall = NATIVE_BIND$2 ? call$4.bind(call$4) : function () {
	  return call$4.apply(call$4, arguments);
	};
	
	var objectPropertyIsEnumerable = {};
	
	var $propertyIsEnumerable = {}.propertyIsEnumerable;
	// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
	var getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;
	
	// Nashorn ~ JDK8 bug
	var NASHORN_BUG = getOwnPropertyDescriptor$1 && !$propertyIsEnumerable.call({ 1: 2 }, 1);
	
	// `Object.prototype.propertyIsEnumerable` method implementation
	// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
	objectPropertyIsEnumerable.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
	  var descriptor = getOwnPropertyDescriptor$1(this, V);
	  return !!descriptor && descriptor.enumerable;
	} : $propertyIsEnumerable;
	
	var createPropertyDescriptor$2 = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};
	
	var NATIVE_BIND$1 = functionBindNative;
	
	var FunctionPrototype$1 = Function.prototype;
	var call$3 = FunctionPrototype$1.call;
	var uncurryThisWithBind = NATIVE_BIND$1 && FunctionPrototype$1.bind.bind(call$3, call$3);
	
	var functionUncurryThisRaw = function (fn) {
	  return NATIVE_BIND$1 ? uncurryThisWithBind(fn) : function () {
	    return call$3.apply(fn, arguments);
	  };
	};
	
	var uncurryThisRaw$1 = functionUncurryThisRaw;
	
	var toString$1 = uncurryThisRaw$1({}.toString);
	var stringSlice = uncurryThisRaw$1(''.slice);
	
	var classofRaw$2 = function (it) {
	  return stringSlice(toString$1(it), 8, -1);
	};
	
	var classofRaw$1 = classofRaw$2;
	var uncurryThisRaw = functionUncurryThisRaw;
	
	var functionUncurryThis = function (fn) {
	  // Nashorn bug:
	  //   https://github.com/zloirock/core-js/issues/1128
	  //   https://github.com/zloirock/core-js/issues/1130
	  if (classofRaw$1(fn) === 'Function') return uncurryThisRaw(fn);
	};
	
	var uncurryThis$9 = functionUncurryThis;
	var fails$6 = fails$9;
	var classof$3 = classofRaw$2;
	
	var $Object$3 = Object;
	var split = uncurryThis$9(''.split);
	
	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var indexedObject = fails$6(function () {
	  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
	  // eslint-disable-next-line no-prototype-builtins -- safe
	  return !$Object$3('z').propertyIsEnumerable(0);
	}) ? function (it) {
	  return classof$3(it) == 'String' ? split(it, '') : $Object$3(it);
	} : $Object$3;
	
	// we can't use just `it == null` since of `document.all` special case
	// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
	var isNullOrUndefined$2 = function (it) {
	  return it === null || it === undefined;
	};
	
	var isNullOrUndefined$1 = isNullOrUndefined$2;
	
	var $TypeError$5 = TypeError;
	
	// `RequireObjectCoercible` abstract operation
	// https://tc39.es/ecma262/#sec-requireobjectcoercible
	var requireObjectCoercible$2 = function (it) {
	  if (isNullOrUndefined$1(it)) throw $TypeError$5("Can't call method on " + it);
	  return it;
	};
	
	// toObject with fallback for non-array-like ES3 strings
	var IndexedObject$1 = indexedObject;
	var requireObjectCoercible$1 = requireObjectCoercible$2;
	
	var toIndexedObject$4 = function (it) {
	  return IndexedObject$1(requireObjectCoercible$1(it));
	};
	
	var documentAll$2 = typeof document == 'object' && document.all;
	
	// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
	var IS_HTMLDDA = typeof documentAll$2 == 'undefined' && documentAll$2 !== undefined;
	
	var documentAll_1 = {
	  all: documentAll$2,
	  IS_HTMLDDA: IS_HTMLDDA
	};
	
	var $documentAll$1 = documentAll_1;
	
	var documentAll$1 = $documentAll$1.all;
	
	// `IsCallable` abstract operation
	// https://tc39.es/ecma262/#sec-iscallable
	var isCallable$c = $documentAll$1.IS_HTMLDDA ? function (argument) {
	  return typeof argument == 'function' || argument === documentAll$1;
	} : function (argument) {
	  return typeof argument == 'function';
	};
	
	var isCallable$b = isCallable$c;
	var $documentAll = documentAll_1;
	
	var documentAll = $documentAll.all;
	
	var isObject$6 = $documentAll.IS_HTMLDDA ? function (it) {
	  return typeof it == 'object' ? it !== null : isCallable$b(it) || it === documentAll;
	} : function (it) {
	  return typeof it == 'object' ? it !== null : isCallable$b(it);
	};
	
	var global$9 = global$a;
	var isCallable$a = isCallable$c;
	
	var aFunction = function (argument) {
	  return isCallable$a(argument) ? argument : undefined;
	};
	
	var getBuiltIn$5 = function (namespace, method) {
	  return arguments.length < 2 ? aFunction(global$9[namespace]) : global$9[namespace] && global$9[namespace][method];
	};
	
	var uncurryThis$8 = functionUncurryThis;
	
	var objectIsPrototypeOf = uncurryThis$8({}.isPrototypeOf);
	
	var getBuiltIn$4 = getBuiltIn$5;
	
	var engineUserAgent = getBuiltIn$4('navigator', 'userAgent') || '';
	
	var global$8 = global$a;
	var userAgent = engineUserAgent;
	
	var process = global$8.process;
	var Deno = global$8.Deno;
	var versions = process && process.versions || Deno && Deno.version;
	var v8 = versions && versions.v8;
	var match, version;
	
	if (v8) {
	  match = v8.split('.');
	  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
	  // but their correct versions are not interesting for us
	  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
	}
	
	// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
	// so check `userAgent` even if `.v8` exists, but 0
	if (!version && userAgent) {
	  match = userAgent.match(/Edge\/(\d+)/);
	  if (!match || match[1] >= 74) {
	    match = userAgent.match(/Chrome\/(\d+)/);
	    if (match) version = +match[1];
	  }
	}
	
	var engineV8Version = version;
	
	/* eslint-disable es/no-symbol -- required for testing */
	
	var V8_VERSION = engineV8Version;
	var fails$5 = fails$9;
	
	// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
	var symbolConstructorDetection = !!Object.getOwnPropertySymbols && !fails$5(function () {
	  var symbol = Symbol();
	  // Chrome 38 Symbol has incorrect toString conversion
	  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
	  return !String(symbol) || !(Object(symbol) instanceof Symbol) ||
	    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
	    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
	});
	
	/* eslint-disable es/no-symbol -- required for testing */
	
	var NATIVE_SYMBOL$1 = symbolConstructorDetection;
	
	var useSymbolAsUid = NATIVE_SYMBOL$1
	  && !Symbol.sham
	  && typeof Symbol.iterator == 'symbol';
	
	var getBuiltIn$3 = getBuiltIn$5;
	var isCallable$9 = isCallable$c;
	var isPrototypeOf = objectIsPrototypeOf;
	var USE_SYMBOL_AS_UID$1 = useSymbolAsUid;
	
	var $Object$2 = Object;
	
	var isSymbol$2 = USE_SYMBOL_AS_UID$1 ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  var $Symbol = getBuiltIn$3('Symbol');
	  return isCallable$9($Symbol) && isPrototypeOf($Symbol.prototype, $Object$2(it));
	};
	
	var $String$1 = String;
	
	var tryToString$1 = function (argument) {
	  try {
	    return $String$1(argument);
	  } catch (error) {
	    return 'Object';
	  }
	};
	
	var isCallable$8 = isCallable$c;
	var tryToString = tryToString$1;
	
	var $TypeError$4 = TypeError;
	
	// `Assert: IsCallable(argument) is true`
	var aCallable$2 = function (argument) {
	  if (isCallable$8(argument)) return argument;
	  throw $TypeError$4(tryToString(argument) + ' is not a function');
	};
	
	var aCallable$1 = aCallable$2;
	var isNullOrUndefined = isNullOrUndefined$2;
	
	// `GetMethod` abstract operation
	// https://tc39.es/ecma262/#sec-getmethod
	var getMethod$1 = function (V, P) {
	  var func = V[P];
	  return isNullOrUndefined(func) ? undefined : aCallable$1(func);
	};
	
	var call$2 = functionCall;
	var isCallable$7 = isCallable$c;
	var isObject$5 = isObject$6;
	
	var $TypeError$3 = TypeError;
	
	// `OrdinaryToPrimitive` abstract operation
	// https://tc39.es/ecma262/#sec-ordinarytoprimitive
	var ordinaryToPrimitive$1 = function (input, pref) {
	  var fn, val;
	  if (pref === 'string' && isCallable$7(fn = input.toString) && !isObject$5(val = call$2(fn, input))) return val;
	  if (isCallable$7(fn = input.valueOf) && !isObject$5(val = call$2(fn, input))) return val;
	  if (pref !== 'string' && isCallable$7(fn = input.toString) && !isObject$5(val = call$2(fn, input))) return val;
	  throw $TypeError$3("Can't convert object to primitive value");
	};
	
	var shared$3 = {exports: {}};
	
	var global$7 = global$a;
	
	// eslint-disable-next-line es/no-object-defineproperty -- safe
	var defineProperty$2 = Object.defineProperty;
	
	var defineGlobalProperty$3 = function (key, value) {
	  try {
	    defineProperty$2(global$7, key, { value: value, configurable: true, writable: true });
	  } catch (error) {
	    global$7[key] = value;
	  } return value;
	};
	
	var global$6 = global$a;
	var defineGlobalProperty$2 = defineGlobalProperty$3;
	
	var SHARED = '__core-js_shared__';
	var store$3 = global$6[SHARED] || defineGlobalProperty$2(SHARED, {});
	
	var sharedStore = store$3;
	
	var store$2 = sharedStore;
	
	(shared$3.exports = function (key, value) {
	  return store$2[key] || (store$2[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: '3.25.5',
	  mode: 'global',
	  copyright: '© 2014-2022 Denis Pushkarev (zloirock.ru)',
	  license: 'https://github.com/zloirock/core-js/blob/v3.25.5/LICENSE',
	  source: 'https://github.com/zloirock/core-js'
	});
	
	var requireObjectCoercible = requireObjectCoercible$2;
	
	var $Object$1 = Object;
	
	// `ToObject` abstract operation
	// https://tc39.es/ecma262/#sec-toobject
	var toObject$2 = function (argument) {
	  return $Object$1(requireObjectCoercible(argument));
	};
	
	var uncurryThis$7 = functionUncurryThis;
	var toObject$1 = toObject$2;
	
	var hasOwnProperty = uncurryThis$7({}.hasOwnProperty);
	
	// `HasOwnProperty` abstract operation
	// https://tc39.es/ecma262/#sec-hasownproperty
	// eslint-disable-next-line es/no-object-hasown -- safe
	var hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
	  return hasOwnProperty(toObject$1(it), key);
	};
	
	var uncurryThis$6 = functionUncurryThis;
	
	var id = 0;
	var postfix = Math.random();
	var toString = uncurryThis$6(1.0.toString);
	
	var uid$2 = function (key) {
	  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString(++id + postfix, 36);
	};
	
	var global$5 = global$a;
	var shared$2 = shared$3.exports;
	var hasOwn$6 = hasOwnProperty_1;
	var uid$1 = uid$2;
	var NATIVE_SYMBOL = symbolConstructorDetection;
	var USE_SYMBOL_AS_UID = useSymbolAsUid;
	
	var WellKnownSymbolsStore = shared$2('wks');
	var Symbol$1 = global$5.Symbol;
	var symbolFor = Symbol$1 && Symbol$1['for'];
	var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol$1 : Symbol$1 && Symbol$1.withoutSetter || uid$1;
	
	var wellKnownSymbol$5 = function (name) {
	  if (!hasOwn$6(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL || typeof WellKnownSymbolsStore[name] == 'string')) {
	    var description = 'Symbol.' + name;
	    if (NATIVE_SYMBOL && hasOwn$6(Symbol$1, name)) {
	      WellKnownSymbolsStore[name] = Symbol$1[name];
	    } else if (USE_SYMBOL_AS_UID && symbolFor) {
	      WellKnownSymbolsStore[name] = symbolFor(description);
	    } else {
	      WellKnownSymbolsStore[name] = createWellKnownSymbol(description);
	    }
	  } return WellKnownSymbolsStore[name];
	};
	
	var call$1 = functionCall;
	var isObject$4 = isObject$6;
	var isSymbol$1 = isSymbol$2;
	var getMethod = getMethod$1;
	var ordinaryToPrimitive = ordinaryToPrimitive$1;
	var wellKnownSymbol$4 = wellKnownSymbol$5;
	
	var $TypeError$2 = TypeError;
	var TO_PRIMITIVE = wellKnownSymbol$4('toPrimitive');
	
	// `ToPrimitive` abstract operation
	// https://tc39.es/ecma262/#sec-toprimitive
	var toPrimitive$1 = function (input, pref) {
	  if (!isObject$4(input) || isSymbol$1(input)) return input;
	  var exoticToPrim = getMethod(input, TO_PRIMITIVE);
	  var result;
	  if (exoticToPrim) {
	    if (pref === undefined) pref = 'default';
	    result = call$1(exoticToPrim, input, pref);
	    if (!isObject$4(result) || isSymbol$1(result)) return result;
	    throw $TypeError$2("Can't convert object to primitive value");
	  }
	  if (pref === undefined) pref = 'number';
	  return ordinaryToPrimitive(input, pref);
	};
	
	var toPrimitive = toPrimitive$1;
	var isSymbol = isSymbol$2;
	
	// `ToPropertyKey` abstract operation
	// https://tc39.es/ecma262/#sec-topropertykey
	var toPropertyKey$2 = function (argument) {
	  var key = toPrimitive(argument, 'string');
	  return isSymbol(key) ? key : key + '';
	};
	
	var global$4 = global$a;
	var isObject$3 = isObject$6;
	
	var document$1 = global$4.document;
	// typeof document.createElement is 'object' in old IE
	var EXISTS$1 = isObject$3(document$1) && isObject$3(document$1.createElement);
	
	var documentCreateElement$1 = function (it) {
	  return EXISTS$1 ? document$1.createElement(it) : {};
	};
	
	var DESCRIPTORS$7 = descriptors;
	var fails$4 = fails$9;
	var createElement = documentCreateElement$1;
	
	// Thanks to IE8 for its funny defineProperty
	var ie8DomDefine = !DESCRIPTORS$7 && !fails$4(function () {
	  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
	  return Object.defineProperty(createElement('div'), 'a', {
	    get: function () { return 7; }
	  }).a != 7;
	});
	
	var DESCRIPTORS$6 = descriptors;
	var call = functionCall;
	var propertyIsEnumerableModule = objectPropertyIsEnumerable;
	var createPropertyDescriptor$1 = createPropertyDescriptor$2;
	var toIndexedObject$3 = toIndexedObject$4;
	var toPropertyKey$1 = toPropertyKey$2;
	var hasOwn$5 = hasOwnProperty_1;
	var IE8_DOM_DEFINE$1 = ie8DomDefine;
	
	// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
	var $getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;
	
	// `Object.getOwnPropertyDescriptor` method
	// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
	objectGetOwnPropertyDescriptor.f = DESCRIPTORS$6 ? $getOwnPropertyDescriptor$1 : function getOwnPropertyDescriptor(O, P) {
	  O = toIndexedObject$3(O);
	  P = toPropertyKey$1(P);
	  if (IE8_DOM_DEFINE$1) try {
	    return $getOwnPropertyDescriptor$1(O, P);
	  } catch (error) { /* empty */ }
	  if (hasOwn$5(O, P)) return createPropertyDescriptor$1(!call(propertyIsEnumerableModule.f, O, P), O[P]);
	};
	
	var objectDefineProperty = {};
	
	var DESCRIPTORS$5 = descriptors;
	var fails$3 = fails$9;
	
	// V8 ~ Chrome 36-
	// https://bugs.chromium.org/p/v8/issues/detail?id=3334
	var v8PrototypeDefineBug = DESCRIPTORS$5 && fails$3(function () {
	  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
	  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
	    value: 42,
	    writable: false
	  }).prototype != 42;
	});
	
	var isObject$2 = isObject$6;
	
	var $String = String;
	var $TypeError$1 = TypeError;
	
	// `Assert: Type(argument) is Object`
	var anObject$4 = function (argument) {
	  if (isObject$2(argument)) return argument;
	  throw $TypeError$1($String(argument) + ' is not an object');
	};
	
	var DESCRIPTORS$4 = descriptors;
	var IE8_DOM_DEFINE = ie8DomDefine;
	var V8_PROTOTYPE_DEFINE_BUG$1 = v8PrototypeDefineBug;
	var anObject$3 = anObject$4;
	var toPropertyKey = toPropertyKey$2;
	
	var $TypeError = TypeError;
	// eslint-disable-next-line es/no-object-defineproperty -- safe
	var $defineProperty = Object.defineProperty;
	// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
	var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var ENUMERABLE = 'enumerable';
	var CONFIGURABLE$1 = 'configurable';
	var WRITABLE = 'writable';
	
	// `Object.defineProperty` method
	// https://tc39.es/ecma262/#sec-object.defineproperty
	objectDefineProperty.f = DESCRIPTORS$4 ? V8_PROTOTYPE_DEFINE_BUG$1 ? function defineProperty(O, P, Attributes) {
	  anObject$3(O);
	  P = toPropertyKey(P);
	  anObject$3(Attributes);
	  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
	    var current = $getOwnPropertyDescriptor(O, P);
	    if (current && current[WRITABLE]) {
	      O[P] = Attributes.value;
	      Attributes = {
	        configurable: CONFIGURABLE$1 in Attributes ? Attributes[CONFIGURABLE$1] : current[CONFIGURABLE$1],
	        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
	        writable: false
	      };
	    }
	  } return $defineProperty(O, P, Attributes);
	} : $defineProperty : function defineProperty(O, P, Attributes) {
	  anObject$3(O);
	  P = toPropertyKey(P);
	  anObject$3(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return $defineProperty(O, P, Attributes);
	  } catch (error) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw $TypeError('Accessors not supported');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};
	
	var DESCRIPTORS$3 = descriptors;
	var definePropertyModule$3 = objectDefineProperty;
	var createPropertyDescriptor = createPropertyDescriptor$2;
	
	var createNonEnumerableProperty$2 = DESCRIPTORS$3 ? function (object, key, value) {
	  return definePropertyModule$3.f(object, key, createPropertyDescriptor(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};
	
	var makeBuiltIn$2 = {exports: {}};
	
	var DESCRIPTORS$2 = descriptors;
	var hasOwn$4 = hasOwnProperty_1;
	
	var FunctionPrototype = Function.prototype;
	// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
	var getDescriptor = DESCRIPTORS$2 && Object.getOwnPropertyDescriptor;
	
	var EXISTS = hasOwn$4(FunctionPrototype, 'name');
	// additional protection from minified / mangled / dropped function names
	var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
	var CONFIGURABLE = EXISTS && (!DESCRIPTORS$2 || (DESCRIPTORS$2 && getDescriptor(FunctionPrototype, 'name').configurable));
	
	var functionName = {
	  EXISTS: EXISTS,
	  PROPER: PROPER,
	  CONFIGURABLE: CONFIGURABLE
	};
	
	var uncurryThis$5 = functionUncurryThis;
	var isCallable$6 = isCallable$c;
	var store$1 = sharedStore;
	
	var functionToString = uncurryThis$5(Function.toString);
	
	// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
	if (!isCallable$6(store$1.inspectSource)) {
	  store$1.inspectSource = function (it) {
	    return functionToString(it);
	  };
	}
	
	var inspectSource$2 = store$1.inspectSource;
	
	var global$3 = global$a;
	var isCallable$5 = isCallable$c;
	
	var WeakMap$1 = global$3.WeakMap;
	
	var weakMapBasicDetection = isCallable$5(WeakMap$1) && /native code/.test(String(WeakMap$1));
	
	var shared$1 = shared$3.exports;
	var uid = uid$2;
	
	var keys = shared$1('keys');
	
	var sharedKey$2 = function (key) {
	  return keys[key] || (keys[key] = uid(key));
	};
	
	var hiddenKeys$4 = {};
	
	var NATIVE_WEAK_MAP = weakMapBasicDetection;
	var global$2 = global$a;
	var isObject$1 = isObject$6;
	var createNonEnumerableProperty$1 = createNonEnumerableProperty$2;
	var hasOwn$3 = hasOwnProperty_1;
	var shared = sharedStore;
	var sharedKey$1 = sharedKey$2;
	var hiddenKeys$3 = hiddenKeys$4;
	
	var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
	var TypeError$1 = global$2.TypeError;
	var WeakMap = global$2.WeakMap;
	var set, get, has;
	
	var enforce = function (it) {
	  return has(it) ? get(it) : set(it, {});
	};
	
	var getterFor = function (TYPE) {
	  return function (it) {
	    var state;
	    if (!isObject$1(it) || (state = get(it)).type !== TYPE) {
	      throw TypeError$1('Incompatible receiver, ' + TYPE + ' required');
	    } return state;
	  };
	};
	
	if (NATIVE_WEAK_MAP || shared.state) {
	  var store = shared.state || (shared.state = new WeakMap());
	  /* eslint-disable no-self-assign -- prototype methods protection */
	  store.get = store.get;
	  store.has = store.has;
	  store.set = store.set;
	  /* eslint-enable no-self-assign -- prototype methods protection */
	  set = function (it, metadata) {
	    if (store.has(it)) throw TypeError$1(OBJECT_ALREADY_INITIALIZED);
	    metadata.facade = it;
	    store.set(it, metadata);
	    return metadata;
	  };
	  get = function (it) {
	    return store.get(it) || {};
	  };
	  has = function (it) {
	    return store.has(it);
	  };
	} else {
	  var STATE = sharedKey$1('state');
	  hiddenKeys$3[STATE] = true;
	  set = function (it, metadata) {
	    if (hasOwn$3(it, STATE)) throw TypeError$1(OBJECT_ALREADY_INITIALIZED);
	    metadata.facade = it;
	    createNonEnumerableProperty$1(it, STATE, metadata);
	    return metadata;
	  };
	  get = function (it) {
	    return hasOwn$3(it, STATE) ? it[STATE] : {};
	  };
	  has = function (it) {
	    return hasOwn$3(it, STATE);
	  };
	}
	
	var internalState = {
	  set: set,
	  get: get,
	  has: has,
	  enforce: enforce,
	  getterFor: getterFor
	};
	
	var fails$2 = fails$9;
	var isCallable$4 = isCallable$c;
	var hasOwn$2 = hasOwnProperty_1;
	var DESCRIPTORS$1 = descriptors;
	var CONFIGURABLE_FUNCTION_NAME = functionName.CONFIGURABLE;
	var inspectSource$1 = inspectSource$2;
	var InternalStateModule = internalState;
	
	var enforceInternalState = InternalStateModule.enforce;
	var getInternalState = InternalStateModule.get;
	// eslint-disable-next-line es/no-object-defineproperty -- safe
	var defineProperty$1 = Object.defineProperty;
	
	var CONFIGURABLE_LENGTH = DESCRIPTORS$1 && !fails$2(function () {
	  return defineProperty$1(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
	});
	
	var TEMPLATE = String(String).split('String');
	
	var makeBuiltIn$1 = makeBuiltIn$2.exports = function (value, name, options) {
	  if (String(name).slice(0, 7) === 'Symbol(') {
	    name = '[' + String(name).replace(/^Symbol\(([^)]*)\)/, '$1') + ']';
	  }
	  if (options && options.getter) name = 'get ' + name;
	  if (options && options.setter) name = 'set ' + name;
	  if (!hasOwn$2(value, 'name') || (CONFIGURABLE_FUNCTION_NAME && value.name !== name)) {
	    if (DESCRIPTORS$1) defineProperty$1(value, 'name', { value: name, configurable: true });
	    else value.name = name;
	  }
	  if (CONFIGURABLE_LENGTH && options && hasOwn$2(options, 'arity') && value.length !== options.arity) {
	    defineProperty$1(value, 'length', { value: options.arity });
	  }
	  try {
	    if (options && hasOwn$2(options, 'constructor') && options.constructor) {
	      if (DESCRIPTORS$1) defineProperty$1(value, 'prototype', { writable: false });
	    // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
	    } else if (value.prototype) value.prototype = undefined;
	  } catch (error) { /* empty */ }
	  var state = enforceInternalState(value);
	  if (!hasOwn$2(state, 'source')) {
	    state.source = TEMPLATE.join(typeof name == 'string' ? name : '');
	  } return value;
	};
	
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	// eslint-disable-next-line no-extend-native -- required
	Function.prototype.toString = makeBuiltIn$1(function toString() {
	  return isCallable$4(this) && getInternalState(this).source || inspectSource$1(this);
	}, 'toString');
	
	var isCallable$3 = isCallable$c;
	var definePropertyModule$2 = objectDefineProperty;
	var makeBuiltIn = makeBuiltIn$2.exports;
	var defineGlobalProperty$1 = defineGlobalProperty$3;
	
	var defineBuiltIn$1 = function (O, key, value, options) {
	  if (!options) options = {};
	  var simple = options.enumerable;
	  var name = options.name !== undefined ? options.name : key;
	  if (isCallable$3(value)) makeBuiltIn(value, name, options);
	  if (options.global) {
	    if (simple) O[key] = value;
	    else defineGlobalProperty$1(key, value);
	  } else {
	    try {
	      if (!options.unsafe) delete O[key];
	      else if (O[key]) simple = true;
	    } catch (error) { /* empty */ }
	    if (simple) O[key] = value;
	    else definePropertyModule$2.f(O, key, {
	      value: value,
	      enumerable: false,
	      configurable: !options.nonConfigurable,
	      writable: !options.nonWritable
	    });
	  } return O;
	};
	
	var objectGetOwnPropertyNames = {};
	
	var ceil = Math.ceil;
	var floor = Math.floor;
	
	// `Math.trunc` method
	// https://tc39.es/ecma262/#sec-math.trunc
	// eslint-disable-next-line es/no-math-trunc -- safe
	var mathTrunc = Math.trunc || function trunc(x) {
	  var n = +x;
	  return (n > 0 ? floor : ceil)(n);
	};
	
	var trunc = mathTrunc;
	
	// `ToIntegerOrInfinity` abstract operation
	// https://tc39.es/ecma262/#sec-tointegerorinfinity
	var toIntegerOrInfinity$2 = function (argument) {
	  var number = +argument;
	  // eslint-disable-next-line no-self-compare -- NaN check
	  return number !== number || number === 0 ? 0 : trunc(number);
	};
	
	var toIntegerOrInfinity$1 = toIntegerOrInfinity$2;
	
	var max = Math.max;
	var min$1 = Math.min;
	
	// Helper for a popular repeating case of the spec:
	// Let integer be ? ToInteger(index).
	// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
	var toAbsoluteIndex$1 = function (index, length) {
	  var integer = toIntegerOrInfinity$1(index);
	  return integer < 0 ? max(integer + length, 0) : min$1(integer, length);
	};
	
	var toIntegerOrInfinity = toIntegerOrInfinity$2;
	
	var min = Math.min;
	
	// `ToLength` abstract operation
	// https://tc39.es/ecma262/#sec-tolength
	var toLength$1 = function (argument) {
	  return argument > 0 ? min(toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
	};
	
	var toLength = toLength$1;
	
	// `LengthOfArrayLike` abstract operation
	// https://tc39.es/ecma262/#sec-lengthofarraylike
	var lengthOfArrayLike$2 = function (obj) {
	  return toLength(obj.length);
	};
	
	var toIndexedObject$2 = toIndexedObject$4;
	var toAbsoluteIndex = toAbsoluteIndex$1;
	var lengthOfArrayLike$1 = lengthOfArrayLike$2;
	
	// `Array.prototype.{ indexOf, includes }` methods implementation
	var createMethod$1 = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIndexedObject$2($this);
	    var length = lengthOfArrayLike$1(O);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare -- NaN check
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare -- NaN check
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) {
	      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};
	
	var arrayIncludes = {
	  // `Array.prototype.includes` method
	  // https://tc39.es/ecma262/#sec-array.prototype.includes
	  includes: createMethod$1(true),
	  // `Array.prototype.indexOf` method
	  // https://tc39.es/ecma262/#sec-array.prototype.indexof
	  indexOf: createMethod$1(false)
	};
	
	var uncurryThis$4 = functionUncurryThis;
	var hasOwn$1 = hasOwnProperty_1;
	var toIndexedObject$1 = toIndexedObject$4;
	var indexOf = arrayIncludes.indexOf;
	var hiddenKeys$2 = hiddenKeys$4;
	
	var push$1 = uncurryThis$4([].push);
	
	var objectKeysInternal = function (object, names) {
	  var O = toIndexedObject$1(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) !hasOwn$1(hiddenKeys$2, key) && hasOwn$1(O, key) && push$1(result, key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (hasOwn$1(O, key = names[i++])) {
	    ~indexOf(result, key) || push$1(result, key);
	  }
	  return result;
	};
	
	// IE8- don't enum bug keys
	var enumBugKeys$3 = [
	  'constructor',
	  'hasOwnProperty',
	  'isPrototypeOf',
	  'propertyIsEnumerable',
	  'toLocaleString',
	  'toString',
	  'valueOf'
	];
	
	var internalObjectKeys$1 = objectKeysInternal;
	var enumBugKeys$2 = enumBugKeys$3;
	
	var hiddenKeys$1 = enumBugKeys$2.concat('length', 'prototype');
	
	// `Object.getOwnPropertyNames` method
	// https://tc39.es/ecma262/#sec-object.getownpropertynames
	// eslint-disable-next-line es/no-object-getownpropertynames -- safe
	objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return internalObjectKeys$1(O, hiddenKeys$1);
	};
	
	var objectGetOwnPropertySymbols = {};
	
	// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
	objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;
	
	var getBuiltIn$2 = getBuiltIn$5;
	var uncurryThis$3 = functionUncurryThis;
	var getOwnPropertyNamesModule = objectGetOwnPropertyNames;
	var getOwnPropertySymbolsModule = objectGetOwnPropertySymbols;
	var anObject$2 = anObject$4;
	
	var concat = uncurryThis$3([].concat);
	
	// all object keys, includes non-enumerable and symbols
	var ownKeys$1 = getBuiltIn$2('Reflect', 'ownKeys') || function ownKeys(it) {
	  var keys = getOwnPropertyNamesModule.f(anObject$2(it));
	  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
	  return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
	};
	
	var hasOwn = hasOwnProperty_1;
	var ownKeys = ownKeys$1;
	var getOwnPropertyDescriptorModule = objectGetOwnPropertyDescriptor;
	var definePropertyModule$1 = objectDefineProperty;
	
	var copyConstructorProperties$1 = function (target, source, exceptions) {
	  var keys = ownKeys(source);
	  var defineProperty = definePropertyModule$1.f;
	  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    if (!hasOwn(target, key) && !(exceptions && hasOwn(exceptions, key))) {
	      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
	    }
	  }
	};
	
	var fails$1 = fails$9;
	var isCallable$2 = isCallable$c;
	
	var replacement = /#|\.prototype\./;
	
	var isForced$1 = function (feature, detection) {
	  var value = data[normalize(feature)];
	  return value == POLYFILL ? true
	    : value == NATIVE ? false
	    : isCallable$2(detection) ? fails$1(detection)
	    : !!detection;
	};
	
	var normalize = isForced$1.normalize = function (string) {
	  return String(string).replace(replacement, '.').toLowerCase();
	};
	
	var data = isForced$1.data = {};
	var NATIVE = isForced$1.NATIVE = 'N';
	var POLYFILL = isForced$1.POLYFILL = 'P';
	
	var isForced_1 = isForced$1;
	
	var global$1 = global$a;
	var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
	var createNonEnumerableProperty = createNonEnumerableProperty$2;
	var defineBuiltIn = defineBuiltIn$1;
	var defineGlobalProperty = defineGlobalProperty$3;
	var copyConstructorProperties = copyConstructorProperties$1;
	var isForced = isForced_1;
	
	/*
	  options.target         - name of the target object
	  options.global         - target is the global object
	  options.stat           - export as static methods of target
	  options.proto          - export as prototype methods of target
	  options.real           - real prototype method for the `pure` version
	  options.forced         - export even if the native feature is available
	  options.bind           - bind methods to the target, required for the `pure` version
	  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
	  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
	  options.sham           - add a flag to not completely full polyfills
	  options.enumerable     - export as enumerable property
	  options.dontCallGetSet - prevent calling a getter on target
	  options.name           - the .name of the function if it does not match the key
	*/
	var _export = function (options, source) {
	  var TARGET = options.target;
	  var GLOBAL = options.global;
	  var STATIC = options.stat;
	  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
	  if (GLOBAL) {
	    target = global$1;
	  } else if (STATIC) {
	    target = global$1[TARGET] || defineGlobalProperty(TARGET, {});
	  } else {
	    target = (global$1[TARGET] || {}).prototype;
	  }
	  if (target) for (key in source) {
	    sourceProperty = source[key];
	    if (options.dontCallGetSet) {
	      descriptor = getOwnPropertyDescriptor(target, key);
	      targetProperty = descriptor && descriptor.value;
	    } else targetProperty = target[key];
	    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
	    // contained in target
	    if (!FORCED && targetProperty !== undefined) {
	      if (typeof sourceProperty == typeof targetProperty) continue;
	      copyConstructorProperties(sourceProperty, targetProperty);
	    }
	    // add a flag to not completely full polyfills
	    if (options.sham || (targetProperty && targetProperty.sham)) {
	      createNonEnumerableProperty(sourceProperty, 'sham', true);
	    }
	    defineBuiltIn(target, key, sourceProperty, options);
	  }
	};
	
	var uncurryThis$2 = functionUncurryThis;
	var aCallable = aCallable$2;
	var NATIVE_BIND = functionBindNative;
	
	var bind$1 = uncurryThis$2(uncurryThis$2.bind);
	
	// optional / simple context binding
	var functionBindContext = function (fn, that) {
	  aCallable(fn);
	  return that === undefined ? fn : NATIVE_BIND ? bind$1(fn, that) : function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};
	
	var classof$2 = classofRaw$2;
	
	// `IsArray` abstract operation
	// https://tc39.es/ecma262/#sec-isarray
	// eslint-disable-next-line es/no-array-isarray -- safe
	var isArray$1 = Array.isArray || function isArray(argument) {
	  return classof$2(argument) == 'Array';
	};
	
	var wellKnownSymbol$3 = wellKnownSymbol$5;
	
	var TO_STRING_TAG$1 = wellKnownSymbol$3('toStringTag');
	var test = {};
	
	test[TO_STRING_TAG$1] = 'z';
	
	var toStringTagSupport = String(test) === '[object z]';
	
	var TO_STRING_TAG_SUPPORT = toStringTagSupport;
	var isCallable$1 = isCallable$c;
	var classofRaw = classofRaw$2;
	var wellKnownSymbol$2 = wellKnownSymbol$5;
	
	var TO_STRING_TAG = wellKnownSymbol$2('toStringTag');
	var $Object = Object;
	
	// ES3 wrong here
	var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (error) { /* empty */ }
	};
	
	// getting tag from ES6+ `Object.prototype.toString`
	var classof$1 = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
	  var O, tag, result;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (tag = tryGet(O = $Object(it), TO_STRING_TAG)) == 'string' ? tag
	    // builtinTag case
	    : CORRECT_ARGUMENTS ? classofRaw(O)
	    // ES3 arguments fallback
	    : (result = classofRaw(O)) == 'Object' && isCallable$1(O.callee) ? 'Arguments' : result;
	};
	
	var uncurryThis$1 = functionUncurryThis;
	var fails = fails$9;
	var isCallable = isCallable$c;
	var classof = classof$1;
	var getBuiltIn$1 = getBuiltIn$5;
	var inspectSource = inspectSource$2;
	
	var noop = function () { /* empty */ };
	var empty = [];
	var construct = getBuiltIn$1('Reflect', 'construct');
	var constructorRegExp = /^\s*(?:class|function)\b/;
	var exec = uncurryThis$1(constructorRegExp.exec);
	var INCORRECT_TO_STRING = !constructorRegExp.exec(noop);
	
	var isConstructorModern = function isConstructor(argument) {
	  if (!isCallable(argument)) return false;
	  try {
	    construct(noop, empty, argument);
	    return true;
	  } catch (error) {
	    return false;
	  }
	};
	
	var isConstructorLegacy = function isConstructor(argument) {
	  if (!isCallable(argument)) return false;
	  switch (classof(argument)) {
	    case 'AsyncFunction':
	    case 'GeneratorFunction':
	    case 'AsyncGeneratorFunction': return false;
	  }
	  try {
	    // we can't check .prototype since constructors produced by .bind haven't it
	    // `Function#toString` throws on some built-it function in some legacy engines
	    // (for example, `DOMQuad` and similar in FF41-)
	    return INCORRECT_TO_STRING || !!exec(constructorRegExp, inspectSource(argument));
	  } catch (error) {
	    return true;
	  }
	};
	
	isConstructorLegacy.sham = true;
	
	// `IsConstructor` abstract operation
	// https://tc39.es/ecma262/#sec-isconstructor
	var isConstructor$1 = !construct || fails(function () {
	  var called;
	  return isConstructorModern(isConstructorModern.call)
	    || !isConstructorModern(Object)
	    || !isConstructorModern(function () { called = true; })
	    || called;
	}) ? isConstructorLegacy : isConstructorModern;
	
	var isArray = isArray$1;
	var isConstructor = isConstructor$1;
	var isObject = isObject$6;
	var wellKnownSymbol$1 = wellKnownSymbol$5;
	
	var SPECIES = wellKnownSymbol$1('species');
	var $Array = Array;
	
	// a part of `ArraySpeciesCreate` abstract operation
	// https://tc39.es/ecma262/#sec-arrayspeciescreate
	var arraySpeciesConstructor$1 = function (originalArray) {
	  var C;
	  if (isArray(originalArray)) {
	    C = originalArray.constructor;
	    // cross-realm fallback
	    if (isConstructor(C) && (C === $Array || isArray(C.prototype))) C = undefined;
	    else if (isObject(C)) {
	      C = C[SPECIES];
	      if (C === null) C = undefined;
	    }
	  } return C === undefined ? $Array : C;
	};
	
	var arraySpeciesConstructor = arraySpeciesConstructor$1;
	
	// `ArraySpeciesCreate` abstract operation
	// https://tc39.es/ecma262/#sec-arrayspeciescreate
	var arraySpeciesCreate$1 = function (originalArray, length) {
	  return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
	};
	
	var bind = functionBindContext;
	var uncurryThis = functionUncurryThis;
	var IndexedObject = indexedObject;
	var toObject = toObject$2;
	var lengthOfArrayLike = lengthOfArrayLike$2;
	var arraySpeciesCreate = arraySpeciesCreate$1;
	
	var push = uncurryThis([].push);
	
	// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
	var createMethod = function (TYPE) {
	  var IS_MAP = TYPE == 1;
	  var IS_FILTER = TYPE == 2;
	  var IS_SOME = TYPE == 3;
	  var IS_EVERY = TYPE == 4;
	  var IS_FIND_INDEX = TYPE == 6;
	  var IS_FILTER_REJECT = TYPE == 7;
	  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
	  return function ($this, callbackfn, that, specificCreate) {
	    var O = toObject($this);
	    var self = IndexedObject(O);
	    var boundFunction = bind(callbackfn, that);
	    var length = lengthOfArrayLike(self);
	    var index = 0;
	    var create = specificCreate || arraySpeciesCreate;
	    var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
	    var value, result;
	    for (;length > index; index++) if (NO_HOLES || index in self) {
	      value = self[index];
	      result = boundFunction(value, index, O);
	      if (TYPE) {
	        if (IS_MAP) target[index] = result; // map
	        else if (result) switch (TYPE) {
	          case 3: return true;              // some
	          case 5: return value;             // find
	          case 6: return index;             // findIndex
	          case 2: push(target, value);      // filter
	        } else switch (TYPE) {
	          case 4: return false;             // every
	          case 7: push(target, value);      // filterReject
	        }
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
	  };
	};
	
	var arrayIteration = {
	  // `Array.prototype.forEach` method
	  // https://tc39.es/ecma262/#sec-array.prototype.foreach
	  forEach: createMethod(0),
	  // `Array.prototype.map` method
	  // https://tc39.es/ecma262/#sec-array.prototype.map
	  map: createMethod(1),
	  // `Array.prototype.filter` method
	  // https://tc39.es/ecma262/#sec-array.prototype.filter
	  filter: createMethod(2),
	  // `Array.prototype.some` method
	  // https://tc39.es/ecma262/#sec-array.prototype.some
	  some: createMethod(3),
	  // `Array.prototype.every` method
	  // https://tc39.es/ecma262/#sec-array.prototype.every
	  every: createMethod(4),
	  // `Array.prototype.find` method
	  // https://tc39.es/ecma262/#sec-array.prototype.find
	  find: createMethod(5),
	  // `Array.prototype.findIndex` method
	  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
	  findIndex: createMethod(6),
	  // `Array.prototype.filterReject` method
	  // https://github.com/tc39/proposal-array-filtering
	  filterReject: createMethod(7)
	};
	
	var objectDefineProperties = {};
	
	var internalObjectKeys = objectKeysInternal;
	var enumBugKeys$1 = enumBugKeys$3;
	
	// `Object.keys` method
	// https://tc39.es/ecma262/#sec-object.keys
	// eslint-disable-next-line es/no-object-keys -- safe
	var objectKeys$1 = Object.keys || function keys(O) {
	  return internalObjectKeys(O, enumBugKeys$1);
	};
	
	var DESCRIPTORS = descriptors;
	var V8_PROTOTYPE_DEFINE_BUG = v8PrototypeDefineBug;
	var definePropertyModule = objectDefineProperty;
	var anObject$1 = anObject$4;
	var toIndexedObject = toIndexedObject$4;
	var objectKeys = objectKeys$1;
	
	// `Object.defineProperties` method
	// https://tc39.es/ecma262/#sec-object.defineproperties
	// eslint-disable-next-line es/no-object-defineproperties -- safe
	objectDefineProperties.f = DESCRIPTORS && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject$1(O);
	  var props = toIndexedObject(Properties);
	  var keys = objectKeys(Properties);
	  var length = keys.length;
	  var index = 0;
	  var key;
	  while (length > index) definePropertyModule.f(O, key = keys[index++], props[key]);
	  return O;
	};
	
	var getBuiltIn = getBuiltIn$5;
	
	var html$1 = getBuiltIn('document', 'documentElement');
	
	/* global ActiveXObject -- old IE, WSH */
	
	var anObject = anObject$4;
	var definePropertiesModule = objectDefineProperties;
	var enumBugKeys = enumBugKeys$3;
	var hiddenKeys = hiddenKeys$4;
	var html = html$1;
	var documentCreateElement = documentCreateElement$1;
	var sharedKey = sharedKey$2;
	
	var GT = '>';
	var LT = '<';
	var PROTOTYPE = 'prototype';
	var SCRIPT = 'script';
	var IE_PROTO = sharedKey('IE_PROTO');
	
	var EmptyConstructor = function () { /* empty */ };
	
	var scriptTag = function (content) {
	  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
	};
	
	// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
	var NullProtoObjectViaActiveX = function (activeXDocument) {
	  activeXDocument.write(scriptTag(''));
	  activeXDocument.close();
	  var temp = activeXDocument.parentWindow.Object;
	  activeXDocument = null; // avoid memory leak
	  return temp;
	};
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var NullProtoObjectViaIFrame = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = documentCreateElement('iframe');
	  var JS = 'java' + SCRIPT + ':';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  html.appendChild(iframe);
	  // https://github.com/zloirock/core-js/issues/475
	  iframe.src = String(JS);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(scriptTag('document.F=Object'));
	  iframeDocument.close();
	  return iframeDocument.F;
	};
	
	// Check for document.domain and active x support
	// No need to use active x approach when document.domain is not set
	// see https://github.com/es-shims/es5-shim/issues/150
	// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
	// avoid IE GC bug
	var activeXDocument;
	var NullProtoObject = function () {
	  try {
	    activeXDocument = new ActiveXObject('htmlfile');
	  } catch (error) { /* ignore */ }
	  NullProtoObject = typeof document != 'undefined'
	    ? document.domain && activeXDocument
	      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
	      : NullProtoObjectViaIFrame()
	    : NullProtoObjectViaActiveX(activeXDocument); // WSH
	  var length = enumBugKeys.length;
	  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
	  return NullProtoObject();
	};
	
	hiddenKeys[IE_PROTO] = true;
	
	// `Object.create` method
	// https://tc39.es/ecma262/#sec-object.create
	// eslint-disable-next-line es/no-object-create -- safe
	var objectCreate = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    EmptyConstructor[PROTOTYPE] = anObject(O);
	    result = new EmptyConstructor();
	    EmptyConstructor[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = NullProtoObject();
	  return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
	};
	
	var wellKnownSymbol = wellKnownSymbol$5;
	var create = objectCreate;
	var defineProperty = objectDefineProperty.f;
	
	var UNSCOPABLES = wellKnownSymbol('unscopables');
	var ArrayPrototype = Array.prototype;
	
	// Array.prototype[@@unscopables]
	// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
	if (ArrayPrototype[UNSCOPABLES] == undefined) {
	  defineProperty(ArrayPrototype, UNSCOPABLES, {
	    configurable: true,
	    value: create(null)
	  });
	}
	
	// add a key to Array.prototype[@@unscopables]
	var addToUnscopables$1 = function (key) {
	  ArrayPrototype[UNSCOPABLES][key] = true;
	};
	
	var $ = _export;
	var $find = arrayIteration.find;
	var addToUnscopables = addToUnscopables$1;
	
	var FIND = 'find';
	var SKIPS_HOLES = true;
	
	// Shouldn't skip holes
	if (FIND in []) Array(1)[FIND](function () { SKIPS_HOLES = false; });
	
	// `Array.prototype.find` method
	// https://tc39.es/ecma262/#sec-array.prototype.find
	$({ target: 'Array', proto: true, forced: SKIPS_HOLES }, {
	  find: function find(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	
	// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
	addToUnscopables(FIND);
	
	var CONSTANT = {
	  GLOBAL: {
	    HIDE: '__react_tooltip_hide_event',
	    REBUILD: '__react_tooltip_rebuild_event',
	    SHOW: '__react_tooltip_show_event'
	  }
	};
	
	/**
	 * Static methods for react-tooltip
	 */
	var dispatchGlobalEvent = function dispatchGlobalEvent(eventName, opts) {
	  // Compatible with IE
	  // @see http://stackoverflow.com/questions/26596123/internet-explorer-9-10-11-event-constructor-doesnt-work
	  // @see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent
	  var event;
	  if (typeof window.CustomEvent === 'function') {
	    event = new window.CustomEvent(eventName, {
	      detail: opts
	    });
	  } else {
	    event = document.createEvent('Event');
	    event.initEvent(eventName, false, true, opts);
	  }
	  window.dispatchEvent(event);
	};
	function staticMethods (target) {
	  /**
	   * Hide all tooltip
	   * @trigger ReactTooltip.hide()
	   */
	  target.hide = function (target) {
	    dispatchGlobalEvent(CONSTANT.GLOBAL.HIDE, {
	      target: target
	    });
	  };
	
	  /**
	   * Rebuild all tooltip
	   * @trigger ReactTooltip.rebuild()
	   */
	  target.rebuild = function () {
	    dispatchGlobalEvent(CONSTANT.GLOBAL.REBUILD);
	  };
	
	  /**
	   * Show specific tooltip
	   * @trigger ReactTooltip.show()
	   */
	  target.show = function (target) {
	    dispatchGlobalEvent(CONSTANT.GLOBAL.SHOW, {
	      target: target
	    });
	  };
	  target.prototype.globalRebuild = function () {
	    if (this.mount) {
	      this.unbindListener();
	      this.bindListener();
	    }
	  };
	  target.prototype.globalShow = function (event) {
	    if (this.mount) {
	      var hasTarget = event && event.detail && event.detail.target && true || false;
	      // Create a fake event, specific show will limit the type to `solid`
	      // only `float` type cares e.clientX e.clientY
	      this.showTooltip({
	        currentTarget: hasTarget && event.detail.target
	      }, true);
	    }
	  };
	  target.prototype.globalHide = function (event) {
	    if (this.mount) {
	      var hasTarget = event && event.detail && event.detail.target && true || false;
	      this.hideTooltip({
	        currentTarget: hasTarget && event.detail.target
	      }, hasTarget);
	    }
	  };
	}
	
	/**
	 * Events that should be bound to the window
	 */
	function windowListener (target) {
	  target.prototype.bindWindowEvents = function (resizeHide) {
	    // ReactTooltip.hide
	    window.removeEventListener(CONSTANT.GLOBAL.HIDE, this.globalHide);
	    window.addEventListener(CONSTANT.GLOBAL.HIDE, this.globalHide, false);
	
	    // ReactTooltip.rebuild
	    window.removeEventListener(CONSTANT.GLOBAL.REBUILD, this.globalRebuild);
	    window.addEventListener(CONSTANT.GLOBAL.REBUILD, this.globalRebuild, false);
	
	    // ReactTooltip.show
	    window.removeEventListener(CONSTANT.GLOBAL.SHOW, this.globalShow);
	    window.addEventListener(CONSTANT.GLOBAL.SHOW, this.globalShow, false);
	
	    // Resize
	    if (resizeHide) {
	      window.removeEventListener('resize', this.onWindowResize);
	      window.addEventListener('resize', this.onWindowResize, false);
	    }
	  };
	  target.prototype.unbindWindowEvents = function () {
	    window.removeEventListener(CONSTANT.GLOBAL.HIDE, this.globalHide);
	    window.removeEventListener(CONSTANT.GLOBAL.REBUILD, this.globalRebuild);
	    window.removeEventListener(CONSTANT.GLOBAL.SHOW, this.globalShow);
	    window.removeEventListener('resize', this.onWindowResize);
	  };
	
	  /**
	   * invoked by resize event of window
	   */
	  target.prototype.onWindowResize = function () {
	    if (!this.mount) return;
	    this.hideTooltip();
	  };
	}
	
	/**
	 * Custom events to control showing and hiding of tooltip
	 *
	 * @attributes
	 * - `event` {String}
	 * - `eventOff` {String}
	 */
	
	var checkStatus = function checkStatus(dataEventOff, e) {
	  var show = this.state.show;
	  var id = this.props.id;
	  var isCapture = this.isCapture(e.currentTarget);
	  var currentItem = e.currentTarget.getAttribute('currentItem');
	  if (!isCapture) e.stopPropagation();
	  if (show && currentItem === 'true') {
	    if (!dataEventOff) this.hideTooltip(e);
	  } else {
	    e.currentTarget.setAttribute('currentItem', 'true');
	    setUntargetItems(e.currentTarget, this.getTargetArray(id));
	    this.showTooltip(e);
	  }
	};
	var setUntargetItems = function setUntargetItems(currentTarget, targetArray) {
	  for (var i = 0; i < targetArray.length; i++) {
	    if (currentTarget !== targetArray[i]) {
	      targetArray[i].setAttribute('currentItem', 'false');
	    } else {
	      targetArray[i].setAttribute('currentItem', 'true');
	    }
	  }
	};
	var customListeners = {
	  id: '9b69f92e-d3fe-498b-b1b4-c5e63a51b0cf',
	  set: function set(target, event, listener) {
	    if (this.id in target) {
	      var map = target[this.id];
	      map[event] = listener;
	    } else {
	      // this is workaround for WeakMap, which is not supported in older browsers, such as IE
	      Object.defineProperty(target, this.id, {
	        configurable: true,
	        value: _defineProperty({}, event, listener)
	      });
	    }
	  },
	  get: function get(target, event) {
	    var map = target[this.id];
	    if (map !== undefined) {
	      return map[event];
	    }
	  }
	};
	function customEvent (target) {
	  target.prototype.isCustomEvent = function (ele) {
	    var event = this.state.event;
	    return event || !!ele.getAttribute('data-event');
	  };
	
	  /* Bind listener for custom event */
	  target.prototype.customBindListener = function (ele) {
	    var _this = this;
	    var _this$state = this.state,
	      event = _this$state.event,
	      eventOff = _this$state.eventOff;
	    var dataEvent = ele.getAttribute('data-event') || event;
	    var dataEventOff = ele.getAttribute('data-event-off') || eventOff;
	    dataEvent.split(' ').forEach(function (event) {
	      ele.removeEventListener(event, customListeners.get(ele, event));
	      var customListener = checkStatus.bind(_this, dataEventOff);
	      customListeners.set(ele, event, customListener);
	      ele.addEventListener(event, customListener, false);
	    });
	    if (dataEventOff) {
	      dataEventOff.split(' ').forEach(function (event) {
	        ele.removeEventListener(event, _this.hideTooltip);
	        ele.addEventListener(event, _this.hideTooltip, false);
	      });
	    }
	  };
	
	  /* Unbind listener for custom event */
	  target.prototype.customUnbindListener = function (ele) {
	    var _this$state2 = this.state,
	      event = _this$state2.event,
	      eventOff = _this$state2.eventOff;
	    var dataEvent = event || ele.getAttribute('data-event');
	    var dataEventOff = eventOff || ele.getAttribute('data-event-off');
	    ele.removeEventListener(dataEvent, customListeners.get(ele, event));
	    if (dataEventOff) ele.removeEventListener(dataEventOff, this.hideTooltip);
	  };
	}
	
	/**
	 * Util method to judge if it should follow capture model
	 */
	
	function isCapture (target) {
	  target.prototype.isCapture = function (currentTarget) {
	    return currentTarget && currentTarget.getAttribute('data-iscapture') === 'true' || this.props.isCapture || false;
	  };
	}
	
	/**
	 * Util method to get effect
	 */
	
	function getEffect (target) {
	  target.prototype.getEffect = function (currentTarget) {
	    var dataEffect = currentTarget.getAttribute('data-effect');
	    return dataEffect || this.props.effect || 'float';
	  };
	}
	
	/**
	 * Util method to get effect
	 */
	var makeProxy = function makeProxy(e) {
	  var proxy = {};
	  for (var key in e) {
	    if (typeof e[key] === 'function') {
	      proxy[key] = e[key].bind(e);
	    } else {
	      proxy[key] = e[key];
	    }
	  }
	  return proxy;
	};
	var bodyListener = function bodyListener(callback, options, e) {
	  var _options$respectEffec = options.respectEffect,
	    respectEffect = _options$respectEffec === void 0 ? false : _options$respectEffec,
	    _options$customEvent = options.customEvent,
	    customEvent = _options$customEvent === void 0 ? false : _options$customEvent;
	  var id = this.props.id;
	  var tip = null;
	  var forId;
	  var target = e.target;
	  var lastTarget;
	  // walk up parent chain until tip is found
	  // there is no match if parent visible area is matched by mouse position, so some corner cases might not work as expected
	  while (tip === null && target !== null) {
	    lastTarget = target;
	    tip = target.getAttribute('data-tip') || null;
	    forId = target.getAttribute('data-for') || null;
	    target = target.parentElement;
	  }
	  target = lastTarget || e.target;
	  if (this.isCustomEvent(target) && !customEvent) {
	    return;
	  }
	  var isTargetBelongsToTooltip = id == null && forId == null || forId === id;
	  if (tip != null && (!respectEffect || this.getEffect(target) === 'float') && isTargetBelongsToTooltip) {
	    var proxy = makeProxy(e);
	    proxy.currentTarget = target;
	    callback(proxy);
	  }
	};
	var findCustomEvents = function findCustomEvents(targetArray, dataAttribute) {
	  var events = {};
	  targetArray.forEach(function (target) {
	    var event = target.getAttribute(dataAttribute);
	    if (event) event.split(' ').forEach(function (event) {
	      return events[event] = true;
	    });
	  });
	  return events;
	};
	var getBody = function getBody() {
	  return document.getElementsByTagName('body')[0];
	};
	function bodyMode (target) {
	  target.prototype.isBodyMode = function () {
	    return !!this.props.bodyMode;
	  };
	  target.prototype.bindBodyListener = function (targetArray) {
	    var _this = this;
	    var _this$state = this.state,
	      event = _this$state.event,
	      eventOff = _this$state.eventOff,
	      possibleCustomEvents = _this$state.possibleCustomEvents,
	      possibleCustomEventsOff = _this$state.possibleCustomEventsOff;
	    var body = getBody();
	    var customEvents = findCustomEvents(targetArray, 'data-event');
	    var customEventsOff = findCustomEvents(targetArray, 'data-event-off');
	    if (event != null) customEvents[event] = true;
	    if (eventOff != null) customEventsOff[eventOff] = true;
	    possibleCustomEvents.split(' ').forEach(function (event) {
	      return customEvents[event] = true;
	    });
	    possibleCustomEventsOff.split(' ').forEach(function (event) {
	      return customEventsOff[event] = true;
	    });
	    this.unbindBodyListener(body);
	    var listeners = this.bodyModeListeners = {};
	    if (event == null) {
	      listeners.mouseover = bodyListener.bind(this, this.showTooltip, {});
	      listeners.mousemove = bodyListener.bind(this, this.updateTooltip, {
	        respectEffect: true
	      });
	      listeners.mouseout = bodyListener.bind(this, this.hideTooltip, {});
	    }
	    for (var _event in customEvents) {
	      listeners[_event] = bodyListener.bind(this, function (e) {
	        var targetEventOff = e.currentTarget.getAttribute('data-event-off') || eventOff;
	        checkStatus.call(_this, targetEventOff, e);
	      }, {
	        customEvent: true
	      });
	    }
	    for (var _event2 in customEventsOff) {
	      listeners[_event2] = bodyListener.bind(this, this.hideTooltip, {
	        customEvent: true
	      });
	    }
	    for (var _event3 in listeners) {
	      body.addEventListener(_event3, listeners[_event3]);
	    }
	  };
	  target.prototype.unbindBodyListener = function (body) {
	    body = body || getBody();
	    var listeners = this.bodyModeListeners;
	    for (var event in listeners) {
	      body.removeEventListener(event, listeners[event]);
	    }
	  };
	}
	
	/**
	 * Tracking target removing from DOM.
	 * It's necessary to hide tooltip when it's target disappears.
	 * Otherwise, the tooltip would be shown forever until another target
	 * is triggered.
	 *
	 * If MutationObserver is not available, this feature just doesn't work.
	 */
	
	// https://hacks.mozilla.org/2012/05/dom-mutationobserver-reacting-to-dom-changes-without-killing-browser-performance/
	var getMutationObserverClass = function getMutationObserverClass() {
	  return window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
	};
	function trackRemoval (target) {
	  target.prototype.bindRemovalTracker = function () {
	    var _this = this;
	    var MutationObserver = getMutationObserverClass();
	    if (MutationObserver == null) return;
	    var observer = new MutationObserver(function (mutations) {
	      for (var m1 = 0; m1 < mutations.length; m1++) {
	        var mutation = mutations[m1];
	        for (var m2 = 0; m2 < mutation.removedNodes.length; m2++) {
	          var element = mutation.removedNodes[m2];
	          if (element === _this.state.currentTarget) {
	            _this.hideTooltip();
	            return;
	          }
	        }
	      }
	    });
	    observer.observe(window.document, {
	      childList: true,
	      subtree: true
	    });
	    this.removalTracker = observer;
	  };
	  target.prototype.unbindRemovalTracker = function () {
	    if (this.removalTracker) {
	      this.removalTracker.disconnect();
	      this.removalTracker = null;
	    }
	  };
	}
	
	/**
	 * Calculate the position of tooltip
	 *
	 * @params
	 * - `e` {Event} the event of current mouse
	 * - `target` {Element} the currentTarget of the event
	 * - `node` {DOM} the react-tooltip object
	 * - `place` {String} top / right / bottom / left
	 * - `effect` {String} float / solid
	 * - `offset` {Object} the offset to default position
	 *
	 * @return {Object}
	 * - `isNewState` {Bool} required
	 * - `newState` {Object}
	 * - `position` {Object} {left: {Number}, top: {Number}}
	 */
	function getPosition (e, target, node, place, desiredPlace, effect, offset) {
	  var _getDimensions = getDimensions(node),
	    tipWidth = _getDimensions.width,
	    tipHeight = _getDimensions.height;
	  var _getDimensions2 = getDimensions(target),
	    targetWidth = _getDimensions2.width,
	    targetHeight = _getDimensions2.height;
	  var _getCurrentOffset = getCurrentOffset(e, target, effect),
	    mouseX = _getCurrentOffset.mouseX,
	    mouseY = _getCurrentOffset.mouseY;
	  var defaultOffset = getDefaultPosition(effect, targetWidth, targetHeight, tipWidth, tipHeight);
	  var _calculateOffset = calculateOffset(offset),
	    extraOffsetX = _calculateOffset.extraOffsetX,
	    extraOffsetY = _calculateOffset.extraOffsetY;
	  var windowWidth = window.innerWidth;
	  var windowHeight = window.innerHeight;
	  var _getParent = getParent(node),
	    parentTop = _getParent.parentTop,
	    parentLeft = _getParent.parentLeft;
	
	  // Get the edge offset of the tooltip
	  var getTipOffsetLeft = function getTipOffsetLeft(place) {
	    var offsetX = defaultOffset[place].l;
	    return mouseX + offsetX + extraOffsetX;
	  };
	  var getTipOffsetRight = function getTipOffsetRight(place) {
	    var offsetX = defaultOffset[place].r;
	    return mouseX + offsetX + extraOffsetX;
	  };
	  var getTipOffsetTop = function getTipOffsetTop(place) {
	    var offsetY = defaultOffset[place].t;
	    return mouseY + offsetY + extraOffsetY;
	  };
	  var getTipOffsetBottom = function getTipOffsetBottom(place) {
	    var offsetY = defaultOffset[place].b;
	    return mouseY + offsetY + extraOffsetY;
	  };
	
	  //
	  // Functions to test whether the tooltip's sides are inside
	  // the client window for a given orientation p
	  //
	  //  _____________
	  // |             | <-- Right side
	  // | p = 'left'  |\
	  // |             |/  |\
	  // |_____________|   |_\  <-- Mouse
	  //      / \           |
	  //       |
	  //       |
	  //  Bottom side
	  //
	  var outsideLeft = function outsideLeft(p) {
	    return getTipOffsetLeft(p) < 0;
	  };
	  var outsideRight = function outsideRight(p) {
	    return getTipOffsetRight(p) > windowWidth;
	  };
	  var outsideTop = function outsideTop(p) {
	    return getTipOffsetTop(p) < 0;
	  };
	  var outsideBottom = function outsideBottom(p) {
	    return getTipOffsetBottom(p) > windowHeight;
	  };
	
	  // Check whether the tooltip with orientation p is completely inside the client window
	  var outside = function outside(p) {
	    return outsideLeft(p) || outsideRight(p) || outsideTop(p) || outsideBottom(p);
	  };
	  var inside = function inside(p) {
	    return !outside(p);
	  };
	  var placeIsInside = {
	    top: inside('top'),
	    bottom: inside('bottom'),
	    left: inside('left'),
	    right: inside('right')
	  };
	  function choose() {
	    var allPlaces = desiredPlace.split(',').concat(place, ['top', 'bottom', 'left', 'right']);
	    var _iterator = _createForOfIteratorHelper(allPlaces),
	      _step;
	    try {
	      for (_iterator.s(); !(_step = _iterator.n()).done;) {
	        var d = _step.value;
	        if (placeIsInside[d]) return d;
	      }
	      // if nothing is inside, just use the old place.
	    } catch (err) {
	      _iterator.e(err);
	    } finally {
	      _iterator.f();
	    }
	    return place;
	  }
	  var chosen = choose();
	  var isNewState = false;
	  var newPlace;
	  if (chosen && chosen !== place) {
	    isNewState = true;
	    newPlace = chosen;
	  }
	  if (isNewState) {
	    return {
	      isNewState: true,
	      newState: {
	        place: newPlace
	      }
	    };
	  }
	  return {
	    isNewState: false,
	    position: {
	      left: parseInt(getTipOffsetLeft(place) - parentLeft, 10),
	      top: parseInt(getTipOffsetTop(place) - parentTop, 10)
	    }
	  };
	}
	var getDimensions = function getDimensions(node) {
	  var _node$getBoundingClie = node.getBoundingClientRect(),
	    height = _node$getBoundingClie.height,
	    width = _node$getBoundingClie.width;
	  return {
	    height: parseInt(height, 10),
	    width: parseInt(width, 10)
	  };
	};
	
	// Get current mouse offset
	var getCurrentOffset = function getCurrentOffset(e, currentTarget, effect) {
	  var boundingClientRect = currentTarget.getBoundingClientRect();
	  var targetTop = boundingClientRect.top;
	  var targetLeft = boundingClientRect.left;
	  var _getDimensions3 = getDimensions(currentTarget),
	    targetWidth = _getDimensions3.width,
	    targetHeight = _getDimensions3.height;
	  if (effect === 'float') {
	    return {
	      mouseX: e.clientX,
	      mouseY: e.clientY
	    };
	  }
	  return {
	    mouseX: targetLeft + targetWidth / 2,
	    mouseY: targetTop + targetHeight / 2
	  };
	};
	
	// List all possibility of tooltip final offset
	// This is useful in judging if it is necessary for tooltip to switch position when out of window
	var getDefaultPosition = function getDefaultPosition(effect, targetWidth, targetHeight, tipWidth, tipHeight) {
	  var top;
	  var right;
	  var bottom;
	  var left;
	  var disToMouse = 3;
	  var triangleHeight = 2;
	  var cursorHeight = 12; // Optimize for float bottom only, cause the cursor will hide the tooltip
	
	  if (effect === 'float') {
	    top = {
	      l: -(tipWidth / 2),
	      r: tipWidth / 2,
	      t: -(tipHeight + disToMouse + triangleHeight),
	      b: -disToMouse
	    };
	    bottom = {
	      l: -(tipWidth / 2),
	      r: tipWidth / 2,
	      t: disToMouse + cursorHeight,
	      b: tipHeight + disToMouse + triangleHeight + cursorHeight
	    };
	    left = {
	      l: -(tipWidth + disToMouse + triangleHeight),
	      r: -disToMouse,
	      t: -(tipHeight / 2),
	      b: tipHeight / 2
	    };
	    right = {
	      l: disToMouse,
	      r: tipWidth + disToMouse + triangleHeight,
	      t: -(tipHeight / 2),
	      b: tipHeight / 2
	    };
	  } else if (effect === 'solid') {
	    top = {
	      l: -(tipWidth / 2),
	      r: tipWidth / 2,
	      t: -(targetHeight / 2 + tipHeight + triangleHeight),
	      b: -(targetHeight / 2)
	    };
	    bottom = {
	      l: -(tipWidth / 2),
	      r: tipWidth / 2,
	      t: targetHeight / 2,
	      b: targetHeight / 2 + tipHeight + triangleHeight
	    };
	    left = {
	      l: -(tipWidth + targetWidth / 2 + triangleHeight),
	      r: -(targetWidth / 2),
	      t: -(tipHeight / 2),
	      b: tipHeight / 2
	    };
	    right = {
	      l: targetWidth / 2,
	      r: tipWidth + targetWidth / 2 + triangleHeight,
	      t: -(tipHeight / 2),
	      b: tipHeight / 2
	    };
	  }
	  return {
	    top: top,
	    bottom: bottom,
	    left: left,
	    right: right
	  };
	};
	
	// Consider additional offset into position calculation
	var calculateOffset = function calculateOffset(offset) {
	  var extraOffsetX = 0;
	  var extraOffsetY = 0;
	  if (Object.prototype.toString.apply(offset) === '[object String]') {
	    offset = JSON.parse(offset.toString().replace(/'/g, '"'));
	  }
	  for (var key in offset) {
	    if (key === 'top') {
	      extraOffsetY -= parseInt(offset[key], 10);
	    } else if (key === 'bottom') {
	      extraOffsetY += parseInt(offset[key], 10);
	    } else if (key === 'left') {
	      extraOffsetX -= parseInt(offset[key], 10);
	    } else if (key === 'right') {
	      extraOffsetX += parseInt(offset[key], 10);
	    }
	  }
	  return {
	    extraOffsetX: extraOffsetX,
	    extraOffsetY: extraOffsetY
	  };
	};
	
	// Get the offset of the parent elements
	var getParent = function getParent(currentTarget) {
	  var currentParent = currentTarget;
	  while (currentParent) {
	    var computedStyle = window.getComputedStyle(currentParent);
	    // transform and will-change: transform change the containing block
	    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_Block
	    if (computedStyle.getPropertyValue('transform') !== 'none' || computedStyle.getPropertyValue('will-change') === 'transform') break;
	    currentParent = currentParent.parentElement;
	  }
	  var parentTop = currentParent && currentParent.getBoundingClientRect().top || 0;
	  var parentLeft = currentParent && currentParent.getBoundingClientRect().left || 0;
	  return {
	    parentTop: parentTop,
	    parentLeft: parentLeft
	  };
	};
	
	/**
	 * To get the tooltip content
	 * it may comes from data-tip or this.props.children
	 * it should support multiline
	 *
	 * @params
	 * - `tip` {String} value of data-tip
	 * - `children` {ReactElement} this.props.children
	 * - `multiline` {Any} could be Bool(true/false) or String('true'/'false')
	 *
	 * @return
	 * - String or react component
	 */
	function TipContent(tip, children, getContent, multiline) {
	  if (children) return children;
	  if (getContent !== undefined && getContent !== null) return getContent; // getContent can be 0, '', etc.
	  if (getContent === null) return null; // Tip not exist and children is null or undefined
	
	  var regexp = /<br\s*\/?>/;
	  if (!multiline || multiline === 'false' || !regexp.test(tip)) {
	    // No trim(), so that user can keep their input
	    return tip;
	  }
	
	  // Multiline tooltip content
	  return tip.split(regexp).map(function (d, i) {
	    return /*#__PURE__*/React__default["default"].createElement("span", {
	      key: i,
	      className: "multi-line"
	    }, d);
	  });
	}
	
	/**
	 * Support aria- and role in ReactTooltip
	 *
	 * @params props {Object}
	 * @return {Object}
	 */
	function parseAria(props) {
	  var ariaObj = {};
	  Object.keys(props).filter(function (prop) {
	    // aria-xxx and role is acceptable
	    return /(^aria-\w+$|^role$)/.test(prop);
	  }).forEach(function (prop) {
	    ariaObj[prop] = props[prop];
	  });
	  return ariaObj;
	}
	
	/**
	 * Convert nodelist to array
	 * @see https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/core/createArrayFromMixed.js#L24
	 * NodeLists are functions in Safari
	 */
	
	function nodeListToArray (nodeList) {
	  var length = nodeList.length;
	  if (nodeList.hasOwnProperty) {
	    return Array.prototype.slice.call(nodeList);
	  }
	  return new Array(length).fill().map(function (index) {
	    return nodeList[index];
	  });
	}
	
	function generateUUID() {
	  return 't' + uuid.v4();
	}
	
	var baseCss = ".__react_component_tooltip {\n  border-radius: 3px;\n  display: inline-block;\n  font-size: 13px;\n  left: -999em;\n  opacity: 0;\n  position: fixed;\n  pointer-events: none;\n  transition: opacity 0.3s ease-out;\n  top: -999em;\n  visibility: hidden;\n  z-index: 999;\n}\n.__react_component_tooltip.allow_hover, .__react_component_tooltip.allow_click {\n  pointer-events: auto;\n}\n.__react_component_tooltip::before, .__react_component_tooltip::after {\n  content: \"\";\n  width: 0;\n  height: 0;\n  position: absolute;\n}\n.__react_component_tooltip.show {\n  opacity: 0.9;\n  margin-top: 0;\n  margin-left: 0;\n  visibility: visible;\n}\n.__react_component_tooltip.place-top::before {\n  bottom: 0;\n  left: 50%;\n  margin-left: -11px;\n}\n.__react_component_tooltip.place-bottom::before {\n  top: 0;\n  left: 50%;\n  margin-left: -11px;\n}\n.__react_component_tooltip.place-left::before {\n  right: 0;\n  top: 50%;\n  margin-top: -9px;\n}\n.__react_component_tooltip.place-right::before {\n  left: 0;\n  top: 50%;\n  margin-top: -9px;\n}\n.__react_component_tooltip .multi-line {\n  display: block;\n  padding: 2px 0;\n  text-align: center;\n}";
	
	/**
	 * Default pop-up style values (text color, background color).
	 */
	var defaultColors = {
	  dark: {
	    text: '#fff',
	    background: '#222',
	    border: 'transparent',
	    arrow: '#222'
	  },
	  success: {
	    text: '#fff',
	    background: '#8DC572',
	    border: 'transparent',
	    arrow: '#8DC572'
	  },
	  warning: {
	    text: '#fff',
	    background: '#F0AD4E',
	    border: 'transparent',
	    arrow: '#F0AD4E'
	  },
	  error: {
	    text: '#fff',
	    background: '#BE6464',
	    border: 'transparent',
	    arrow: '#BE6464'
	  },
	  info: {
	    text: '#fff',
	    background: '#337AB7',
	    border: 'transparent',
	    arrow: '#337AB7'
	  },
	  light: {
	    text: '#222',
	    background: '#fff',
	    border: 'transparent',
	    arrow: '#fff'
	  }
	};
	function getDefaultPopupColors(type) {
	  return defaultColors[type] ? _objectSpread2({}, defaultColors[type]) : undefined;
	}
	var DEFAULT_PADDING = '8px 21px';
	var DEFAULT_RADIUS = {
	  tooltip: 3,
	  arrow: 0
	};
	
	/**
	 * Generates the specific tooltip style for use on render.
	 */
	function generateTooltipStyle(uuid, customColors, type, hasBorder, padding, radius) {
	  return generateStyle(uuid, getPopupColors(customColors, type, hasBorder), padding, radius);
	}
	
	/**
	 * Generates the tooltip style rules based on the element-specified "data-type" property.
	 */
	function generateStyle(uuid, colors) {
	  var padding = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_PADDING;
	  var radius = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : DEFAULT_RADIUS;
	  var textColor = colors.text;
	  var backgroundColor = colors.background;
	  var borderColor = colors.border;
	  var arrowColor = colors.arrow;
	  var arrowRadius = radius.arrow;
	  var tooltipRadius = radius.tooltip;
	  return "\n  \t.".concat(uuid, " {\n\t    color: ").concat(textColor, ";\n\t    background: ").concat(backgroundColor, ";\n\t    border: 1px solid ").concat(borderColor, ";\n\t    border-radius: ").concat(tooltipRadius, "px;\n\t    padding: ").concat(padding, ";\n  \t}\n\n  \t.").concat(uuid, ".place-top {\n        margin-top: -10px;\n    }\n    .").concat(uuid, ".place-top::before {\n        content: \"\";\n        background-color: inherit;\n        position: absolute;\n        z-index: 2;\n        width: 20px;\n        height: 12px;\n    }\n    .").concat(uuid, ".place-top::after {\n        content: \"\";\n        position: absolute;\n        width: 10px;\n        height: 10px;\n        border-top-right-radius: ").concat(arrowRadius, "px;\n        border: 1px solid ").concat(borderColor, ";\n        background-color: ").concat(arrowColor, ";\n        z-index: -2;\n        bottom: -6px;\n        left: 50%;\n        margin-left: -6px;\n        transform: rotate(135deg);\n    }\n\n    .").concat(uuid, ".place-bottom {\n        margin-top: 10px;\n    }\n    .").concat(uuid, ".place-bottom::before {\n        content: \"\";\n        background-color: inherit;\n        position: absolute;\n        z-index: -1;\n        width: 18px;\n        height: 10px;\n    }\n    .").concat(uuid, ".place-bottom::after {\n        content: \"\";\n        position: absolute;\n        width: 10px;\n        height: 10px;\n        border-top-right-radius: ").concat(arrowRadius, "px;\n        border: 1px solid ").concat(borderColor, ";\n        background-color: ").concat(arrowColor, ";\n        z-index: -2;\n        top: -6px;\n        left: 50%;\n        margin-left: -6px;\n        transform: rotate(45deg);\n    }\n\n    .").concat(uuid, ".place-left {\n        margin-left: -10px;\n    }\n    .").concat(uuid, ".place-left::before {\n        content: \"\";\n        background-color: inherit;\n        position: absolute;\n        z-index: -1;\n        width: 10px;\n        height: 18px;\n    }\n    .").concat(uuid, ".place-left::after {\n        content: \"\";\n        position: absolute;\n        width: 10px;\n        height: 10px;\n        border-top-right-radius: ").concat(arrowRadius, "px;\n        border: 1px solid ").concat(borderColor, ";\n        background-color: ").concat(arrowColor, ";\n        z-index: -2;\n        right: -6px;\n        top: 50%;\n        margin-top: -6px;\n        transform: rotate(45deg);\n    }\n\n    .").concat(uuid, ".place-right {\n        margin-left: 10px;\n    }\n    .").concat(uuid, ".place-right::before {\n        content: \"\";\n        background-color: inherit;\n        position: absolute;\n        z-index: -1;\n        width: 10px;\n        height: 18px;\n    }\n    .").concat(uuid, ".place-right::after {\n        content: \"\";\n        position: absolute;\n        width: 10px;\n        height: 10px;\n        border-top-right-radius: ").concat(arrowRadius, "px;\n        border: 1px solid ").concat(borderColor, ";\n        background-color: ").concat(arrowColor, ";\n        z-index: -2;\n        left: -6px;\n        top: 50%;\n        margin-top: -6px;\n        transform: rotate(-135deg);\n    }\n  ");
	}
	function getPopupColors(customColors, type, hasBorder) {
	  var textColor = customColors.text;
	  var backgroundColor = customColors.background;
	  var borderColor = customColors.border;
	  var arrowColor = customColors.arrow ? customColors.arrow : customColors.background;
	  var colors = getDefaultPopupColors(type);
	  if (textColor) {
	    colors.text = textColor;
	  }
	  if (backgroundColor) {
	    colors.background = backgroundColor;
	  }
	  if (hasBorder) {
	    if (borderColor) {
	      colors.border = borderColor;
	    } else {
	      colors.border = type === 'light' ? 'black' : 'white';
	    }
	  }
	  if (arrowColor) {
	    colors.arrow = arrowColor;
	  }
	  return colors;
	}
	
	var _class, _class2;
	
	/* Polyfill */
	var ReactTooltip = staticMethods(_class = windowListener(_class = customEvent(_class = isCapture(_class = getEffect(_class = bodyMode(_class = trackRemoval(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
	  _inherits(ReactTooltip, _React$Component);
	  var _super = _createSuper(ReactTooltip);
	  function ReactTooltip(props) {
	    var _this;
	    _classCallCheck(this, ReactTooltip);
	    _this = _super.call(this, props);
	    _this.state = {
	      uuid: props.uuid || generateUUID(),
	      place: props.place || 'top',
	      // Direction of tooltip
	      desiredPlace: props.place || 'top',
	      type: props.type || 'dark',
	      // Color theme of tooltip
	      effect: props.effect || 'float',
	      // float or fixed
	      show: false,
	      border: false,
	      borderClass: 'border',
	      customColors: {},
	      customRadius: {},
	      offset: {},
	      padding: props.padding,
	      extraClass: '',
	      html: false,
	      delayHide: 0,
	      delayShow: 0,
	      event: props.event || null,
	      eventOff: props.eventOff || null,
	      currentEvent: null,
	      // Current mouse event
	      currentTarget: null,
	      // Current target of mouse event
	      ariaProps: parseAria(props),
	      // aria- and role attributes
	      isEmptyTip: false,
	      disable: false,
	      possibleCustomEvents: props.possibleCustomEvents || '',
	      possibleCustomEventsOff: props.possibleCustomEventsOff || '',
	      originTooltip: null,
	      isMultiline: false
	    };
	    _this.bind(['showTooltip', 'updateTooltip', 'hideTooltip', 'hideTooltipOnScroll', 'getTooltipContent', 'globalRebuild', 'globalShow', 'globalHide', 'onWindowResize', 'mouseOnToolTip']);
	    _this.mount = true;
	    _this.delayShowLoop = null;
	    _this.delayHideLoop = null;
	    _this.delayReshow = null;
	    _this.intervalUpdateContent = null;
	    return _this;
	  }
	
	  /**
	   * For unify the bind and unbind listener
	   */
	  _createClass(ReactTooltip, [{
	    key: "bind",
	    value: function bind(methodArray) {
	      var _this2 = this;
	      methodArray.forEach(function (method) {
	        _this2[method] = _this2[method].bind(_this2);
	      });
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this$props = this.props;
	        _this$props.insecure;
	        var resizeHide = _this$props.resizeHide,
	        disableInternalStyle = _this$props.disableInternalStyle;
	      this.mount = true;
	      this.bindListener(); // Bind listener for tooltip
	      this.bindWindowEvents(resizeHide); // Bind global event for static method
	
	      if (!disableInternalStyle) {
	        this.injectStyles(); // Inject styles for each DOM root having tooltip.
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.mount = false;
	      this.clearTimer();
	      this.unbindListener();
	      this.removeScrollListener(this.state.currentTarget);
	      this.unbindWindowEvents();
	    }
	
	    /* Look for the closest DOM root having tooltip and inject styles. */
	  }, {
	    key: "injectStyles",
	    value: function injectStyles() {
	      var tooltipRef = this.tooltipRef;
	      if (!tooltipRef) {
	        return;
	      }
	      var parentNode = tooltipRef.parentNode;
	      while (parentNode.parentNode) {
	        parentNode = parentNode.parentNode;
	      }
	      var domRoot;
	      switch (parentNode.constructor.name) {
	        case 'Document':
	        case 'HTMLDocument':
	        case undefined:
	          domRoot = parentNode.head;
	          break;
	        case 'ShadowRoot':
	        default:
	          domRoot = parentNode;
	          break;
	      }
	
	      // Prevent styles duplication.
	      if (!domRoot.querySelector('style[data-react-tooltip]')) {
	        var style = document.createElement('style');
	        style.textContent = baseCss;
	        style.setAttribute('data-react-tooltip', 'true');
	        domRoot.appendChild(style);
	      }
	    }
	
	    /**
	     * Return if the mouse is on the tooltip.
	     * @returns {boolean} true - mouse is on the tooltip
	     */
	  }, {
	    key: "mouseOnToolTip",
	    value: function mouseOnToolTip() {
	      var show = this.state.show;
	      if (show && this.tooltipRef) {
	        /* old IE or Firefox work around */
	        if (!this.tooltipRef.matches) {
	          /* old IE work around */
	          if (this.tooltipRef.msMatchesSelector) {
	            this.tooltipRef.matches = this.tooltipRef.msMatchesSelector;
	          } else {
	            /* old Firefox work around */
	            this.tooltipRef.matches = this.tooltipRef.mozMatchesSelector;
	          }
	        }
	        return this.tooltipRef.matches(':hover');
	      }
	      return false;
	    }
	
	    /**
	     * Pick out corresponded target elements
	     */
	  }, {
	    key: "getTargetArray",
	    value: function getTargetArray(id) {
	      var targetArray = [];
	      var selector;
	      if (!id) {
	        selector = '[data-tip]:not([data-for])';
	      } else {
	        var escaped = id.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
	        selector = "[data-tip][data-for=\"".concat(escaped, "\"]");
	      }
	
	      // Scan document for shadow DOM elements
	      nodeListToArray(document.getElementsByTagName('*')).filter(function (element) {
	        return element.shadowRoot;
	      }).forEach(function (element) {
	        targetArray = targetArray.concat(nodeListToArray(element.shadowRoot.querySelectorAll(selector)));
	      });
	      return targetArray.concat(nodeListToArray(document.querySelectorAll(selector)));
	    }
	
	    /**
	     * Bind listener to the target elements
	     * These listeners used to trigger showing or hiding the tooltip
	     */
	  }, {
	    key: "bindListener",
	    value: function bindListener() {
	      var _this3 = this;
	      var _this$props2 = this.props,
	        id = _this$props2.id,
	        globalEventOff = _this$props2.globalEventOff,
	        isCapture = _this$props2.isCapture;
	      var targetArray = this.getTargetArray(id);
	      targetArray.forEach(function (target) {
	        if (target.getAttribute('currentItem') === null) {
	          target.setAttribute('currentItem', 'false');
	        }
	        _this3.unbindBasicListener(target);
	        if (_this3.isCustomEvent(target)) {
	          _this3.customUnbindListener(target);
	        }
	      });
	      if (this.isBodyMode()) {
	        this.bindBodyListener(targetArray);
	      } else {
	        targetArray.forEach(function (target) {
	          var isCaptureMode = _this3.isCapture(target);
	          var effect = _this3.getEffect(target);
	          if (_this3.isCustomEvent(target)) {
	            _this3.customBindListener(target);
	            return;
	          }
	          target.addEventListener('mouseenter', _this3.showTooltip, isCaptureMode);
	          target.addEventListener('focus', _this3.showTooltip, isCaptureMode);
	          if (effect === 'float') {
	            target.addEventListener('mousemove', _this3.updateTooltip, isCaptureMode);
	          }
	          target.addEventListener('mouseleave', _this3.hideTooltip, isCaptureMode);
	          target.addEventListener('blur', _this3.hideTooltip, isCaptureMode);
	        });
	      }
	
	      // Global event to hide tooltip
	      if (globalEventOff) {
	        window.removeEventListener(globalEventOff, this.hideTooltip);
	        window.addEventListener(globalEventOff, this.hideTooltip, isCapture);
	      }
	
	      // Track removal of targetArray elements from DOM
	      this.bindRemovalTracker();
	    }
	
	    /**
	     * Unbind listeners on target elements
	     */
	  }, {
	    key: "unbindListener",
	    value: function unbindListener() {
	      var _this4 = this;
	      var _this$props3 = this.props,
	        id = _this$props3.id,
	        globalEventOff = _this$props3.globalEventOff;
	      if (this.isBodyMode()) {
	        this.unbindBodyListener();
	      } else {
	        var targetArray = this.getTargetArray(id);
	        targetArray.forEach(function (target) {
	          _this4.unbindBasicListener(target);
	          if (_this4.isCustomEvent(target)) _this4.customUnbindListener(target);
	        });
	      }
	      if (globalEventOff) window.removeEventListener(globalEventOff, this.hideTooltip);
	      this.unbindRemovalTracker();
	    }
	
	    /**
	     * Invoke this before bind listener and unmount the component
	     * it is necessary to invoke this even when binding custom event
	     * so that the tooltip can switch between custom and default listener
	     */
	  }, {
	    key: "unbindBasicListener",
	    value: function unbindBasicListener(target) {
	      var isCaptureMode = this.isCapture(target);
	      target.removeEventListener('mouseenter', this.showTooltip, isCaptureMode);
	      target.removeEventListener('mousemove', this.updateTooltip, isCaptureMode);
	      target.removeEventListener('mouseleave', this.hideTooltip, isCaptureMode);
	    }
	  }, {
	    key: "getTooltipContent",
	    value: function getTooltipContent() {
	      var _this$props4 = this.props,
	        getContent = _this$props4.getContent,
	        children = _this$props4.children;
	
	      // Generate tooltip content
	      var content;
	      if (getContent) {
	        if (Array.isArray(getContent)) {
	          content = getContent[0] && getContent[0](this.state.originTooltip);
	        } else {
	          content = getContent(this.state.originTooltip);
	        }
	      }
	      return TipContent(this.state.originTooltip, children, content, this.state.isMultiline);
	    }
	  }, {
	    key: "isEmptyTip",
	    value: function isEmptyTip(placeholder) {
	      return typeof placeholder === 'string' && placeholder === '' || placeholder === null;
	    }
	
	    /**
	     * When mouse enter, show the tooltip
	     */
	  }, {
	    key: "showTooltip",
	    value: function showTooltip(e, isGlobalCall) {
	      if (!this.tooltipRef) {
	        return;
	      }
	      if (isGlobalCall) {
	        // Don't trigger other elements belongs to other ReactTooltip
	        var targetArray = this.getTargetArray(this.props.id);
	        var isMyElement = targetArray.some(function (ele) {
	          return ele === e.currentTarget;
	        });
	        if (!isMyElement) return;
	      }
	      // Get the tooltip content
	      // calculate in this phrase so that tip width height can be detected
	      var _this$props5 = this.props,
	        multiline = _this$props5.multiline,
	        getContent = _this$props5.getContent;
	      var originTooltip = e.currentTarget.getAttribute('data-tip');
	      var isMultiline = e.currentTarget.getAttribute('data-multiline') || multiline || false;
	
	      // If it is focus event or called by ReactTooltip.show, switch to `solid` effect
	      var switchToSolid = e instanceof window.FocusEvent || isGlobalCall;
	
	      // if it needs to skip adding hide listener to scroll
	      var scrollHide = true;
	      if (e.currentTarget.getAttribute('data-scroll-hide')) {
	        scrollHide = e.currentTarget.getAttribute('data-scroll-hide') === 'true';
	      } else if (this.props.scrollHide != null) {
	        scrollHide = this.props.scrollHide;
	      }
	
	      // adding aria-describedby to target to make tooltips read by screen readers
	      if (e && e.currentTarget && e.currentTarget.setAttribute) {
	        e.currentTarget.setAttribute('aria-describedby', this.props.id || this.state.uuid);
	      }
	
	      // Make sure the correct place is set
	      var desiredPlace = e.currentTarget.getAttribute('data-place') || this.props.place || 'top';
	      var effect = switchToSolid && 'solid' || this.getEffect(e.currentTarget);
	      var offset = e.currentTarget.getAttribute('data-offset') || this.props.offset || {};
	      var result = getPosition(e, e.currentTarget, this.tooltipRef, desiredPlace.split(',')[0], desiredPlace, effect, offset);
	      if (result.position && this.props.overridePosition) {
	        result.position = this.props.overridePosition(result.position, e, e.currentTarget, this.tooltipRef, desiredPlace, desiredPlace, effect, offset);
	      }
	      var place = result.isNewState ? result.newState.place : desiredPlace.split(',')[0];
	
	      // To prevent previously created timers from triggering
	      this.clearTimer();
	      var target = e.currentTarget;
	      var reshowDelay = this.state.show ? target.getAttribute('data-delay-update') || this.props.delayUpdate : 0;
	      var self = this;
	      var updateState = function updateState() {
	        self.setState({
	          originTooltip: originTooltip,
	          isMultiline: isMultiline,
	          desiredPlace: desiredPlace,
	          place: place,
	          type: target.getAttribute('data-type') || self.props.type || 'dark',
	          customColors: {
	            text: target.getAttribute('data-text-color') || self.props.textColor || null,
	            background: target.getAttribute('data-background-color') || self.props.backgroundColor || null,
	            border: target.getAttribute('data-border-color') || self.props.borderColor || null,
	            arrow: target.getAttribute('data-arrow-color') || self.props.arrowColor || null
	          },
	          customRadius: {
	            tooltip: target.getAttribute('data-tooltip-radius') || self.props.tooltipRadius || '3',
	            arrow: target.getAttribute('data-arrow-radius') || self.props.arrowRadius || '0'
	          },
	          effect: effect,
	          offset: offset,
	          padding: target.getAttribute('data-padding') || self.props.padding,
	          html: (target.getAttribute('data-html') ? target.getAttribute('data-html') === 'true' : self.props.html) || false,
	          delayShow: target.getAttribute('data-delay-show') || self.props.delayShow || 0,
	          delayHide: target.getAttribute('data-delay-hide') || self.props.delayHide || 0,
	          delayUpdate: target.getAttribute('data-delay-update') || self.props.delayUpdate || 0,
	          border: (target.getAttribute('data-border') ? target.getAttribute('data-border') === 'true' : self.props.border) || false,
	          borderClass: target.getAttribute('data-border-class') || self.props.borderClass || 'border',
	          extraClass: target.getAttribute('data-class') || self.props["class"] || self.props.className || '',
	          disable: (target.getAttribute('data-tip-disable') ? target.getAttribute('data-tip-disable') === 'true' : self.props.disable) || false,
	          currentTarget: target
	        }, function () {
	          if (scrollHide) {
	            self.addScrollListener(self.state.currentTarget);
	          }
	          self.updateTooltip(e);
	          if (getContent && Array.isArray(getContent)) {
	            self.intervalUpdateContent = setInterval(function () {
	              if (self.mount) {
	                var _getContent = self.props.getContent;
	                var placeholder = TipContent(originTooltip, '', _getContent[0](), isMultiline);
	                var isEmptyTip = self.isEmptyTip(placeholder);
	                self.setState({
	                  isEmptyTip: isEmptyTip
	                });
	                self.updatePosition();
	              }
	            }, getContent[1]);
	          }
	        });
	      };
	
	      // If there is no delay call immediately, don't allow events to get in first.
	      if (reshowDelay) {
	        this.delayReshow = setTimeout(updateState, reshowDelay);
	      } else {
	        updateState();
	      }
	    }
	
	    /**
	     * When mouse hover, update tool tip
	     */
	  }, {
	    key: "updateTooltip",
	    value: function updateTooltip(e) {
	      var _this5 = this;
	      var _this$state = this.state,
	        delayShow = _this$state.delayShow,
	        disable = _this$state.disable;
	      var _this$props6 = this.props,
	        afterShow = _this$props6.afterShow,
	        disableProp = _this$props6.disable;
	      var placeholder = this.getTooltipContent();
	      var eventTarget = e.currentTarget || e.target;
	
	      // Check if the mouse is actually over the tooltip, if so don't hide the tooltip
	      if (this.mouseOnToolTip()) {
	        return;
	      }
	
	      // if the tooltip is empty, disable the tooltip
	      if (this.isEmptyTip(placeholder) || disable || disableProp) {
	        return;
	      }
	      var delayTime = !this.state.show ? parseInt(delayShow, 10) : 0;
	      var updateState = function updateState() {
	        if (Array.isArray(placeholder) && placeholder.length > 0 || placeholder) {
	          var isInvisible = !_this5.state.show;
	          _this5.setState({
	            currentEvent: e,
	            currentTarget: eventTarget,
	            show: true
	          }, function () {
	            _this5.updatePosition(function () {
	              if (isInvisible && afterShow) {
	                afterShow(e);
	              }
	            });
	          });
	        }
	      };
	      if (this.delayShowLoop) {
	        clearTimeout(this.delayShowLoop);
	      }
	      if (delayTime) {
	        this.delayShowLoop = setTimeout(updateState, delayTime);
	      } else {
	        this.delayShowLoop = null;
	        updateState();
	      }
	    }
	
	    /*
	     * If we're mousing over the tooltip remove it when we leave.
	     */
	  }, {
	    key: "listenForTooltipExit",
	    value: function listenForTooltipExit() {
	      var show = this.state.show;
	      if (show && this.tooltipRef) {
	        this.tooltipRef.addEventListener('mouseleave', this.hideTooltip);
	      }
	    }
	  }, {
	    key: "removeListenerForTooltipExit",
	    value: function removeListenerForTooltipExit() {
	      var show = this.state.show;
	      if (show && this.tooltipRef) {
	        this.tooltipRef.removeEventListener('mouseleave', this.hideTooltip);
	      }
	    }
	
	    /**
	     * When mouse leave, hide tooltip
	     */
	  }, {
	    key: "hideTooltip",
	    value: function hideTooltip(e, hasTarget) {
	      var _this6 = this;
	      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
	        isScroll: false
	      };
	      var disable = this.state.disable;
	      var isScroll = options.isScroll;
	      var delayHide = isScroll ? 0 : this.state.delayHide;
	      var _this$props7 = this.props,
	        afterHide = _this$props7.afterHide,
	        disableProp = _this$props7.disable;
	      var placeholder = this.getTooltipContent();
	      if (!this.mount) return;
	      if (this.isEmptyTip(placeholder) || disable || disableProp) return; // if the tooltip is empty, disable the tooltip
	      if (hasTarget) {
	        // Don't trigger other elements belongs to other ReactTooltip
	        var targetArray = this.getTargetArray(this.props.id);
	        var isMyElement = targetArray.some(function (ele) {
	          return ele === e.currentTarget;
	        });
	        if (!isMyElement || !this.state.show) return;
	      }
	
	      // clean up aria-describedby when hiding tooltip
	      if (e && e.currentTarget && e.currentTarget.removeAttribute) {
	        e.currentTarget.removeAttribute('aria-describedby');
	      }
	      var resetState = function resetState() {
	        var isVisible = _this6.state.show;
	        // Check if the mouse is actually over the tooltip, if so don't hide the tooltip
	        if (_this6.mouseOnToolTip()) {
	          _this6.listenForTooltipExit();
	          return;
	        }
	        _this6.removeListenerForTooltipExit();
	        _this6.setState({
	          show: false
	        }, function () {
	          _this6.removeScrollListener(_this6.state.currentTarget);
	          if (isVisible && afterHide) {
	            afterHide(e);
	          }
	        });
	      };
	      this.clearTimer();
	      if (delayHide) {
	        this.delayHideLoop = setTimeout(resetState, parseInt(delayHide, 10));
	      } else {
	        resetState();
	      }
	    }
	
	    /**
	     * When scroll, hide tooltip
	     */
	  }, {
	    key: "hideTooltipOnScroll",
	    value: function hideTooltipOnScroll(event, hasTarget) {
	      this.hideTooltip(event, hasTarget, {
	        isScroll: true
	      });
	    }
	
	    /**
	     * Add scroll event listener when tooltip show
	     * automatically hide the tooltip when scrolling
	     */
	  }, {
	    key: "addScrollListener",
	    value: function addScrollListener(currentTarget) {
	      var isCaptureMode = this.isCapture(currentTarget);
	      window.addEventListener('scroll', this.hideTooltipOnScroll, isCaptureMode);
	    }
	  }, {
	    key: "removeScrollListener",
	    value: function removeScrollListener(currentTarget) {
	      var isCaptureMode = this.isCapture(currentTarget);
	      window.removeEventListener('scroll', this.hideTooltipOnScroll, isCaptureMode);
	    }
	
	    // Calculation the position
	  }, {
	    key: "updatePosition",
	    value: function updatePosition(callbackAfter) {
	      var _this7 = this;
	      var _this$state2 = this.state,
	        currentEvent = _this$state2.currentEvent,
	        currentTarget = _this$state2.currentTarget,
	        place = _this$state2.place,
	        desiredPlace = _this$state2.desiredPlace,
	        effect = _this$state2.effect,
	        offset = _this$state2.offset;
	      var node = this.tooltipRef;
	      var result = getPosition(currentEvent, currentTarget, node, place, desiredPlace, effect, offset);
	      if (result.position && this.props.overridePosition) {
	        result.position = this.props.overridePosition(result.position, currentEvent, currentTarget, node, place, desiredPlace, effect, offset);
	      }
	      if (result.isNewState) {
	        // Switch to reverse placement
	        return this.setState(result.newState, function () {
	          _this7.updatePosition(callbackAfter);
	        });
	      }
	      if (callbackAfter && typeof callbackAfter === 'function') {
	        callbackAfter();
	      }
	
	      // Set tooltip position
	      node.style.left = result.position.left + 'px';
	      node.style.top = result.position.top + 'px';
	    }
	
	    /**
	     * CLear all kinds of timeout of interval
	     */
	  }, {
	    key: "clearTimer",
	    value: function clearTimer() {
	      if (this.delayShowLoop) {
	        clearTimeout(this.delayShowLoop);
	        this.delayShowLoop = null;
	      }
	      if (this.delayHideLoop) {
	        clearTimeout(this.delayHideLoop);
	        this.delayHideLoop = null;
	      }
	      if (this.delayReshow) {
	        clearTimeout(this.delayReshow);
	        this.delayReshow = null;
	      }
	      if (this.intervalUpdateContent) {
	        clearInterval(this.intervalUpdateContent);
	        this.intervalUpdateContent = null;
	      }
	    }
	  }, {
	    key: "hasCustomColors",
	    value: function hasCustomColors() {
	      var _this8 = this;
	      return Boolean(Object.keys(this.state.customColors).find(function (color) {
	        return color !== 'border' && _this8.state.customColors[color];
	      }) || this.state.border && this.state.customColors['border']);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this9 = this;
	      var _this$state3 = this.state,
	        extraClass = _this$state3.extraClass,
	        html = _this$state3.html,
	        ariaProps = _this$state3.ariaProps,
	        disable = _this$state3.disable,
	        uuid = _this$state3.uuid;
	      var content = this.getTooltipContent();
	      var isEmptyTip = this.isEmptyTip(content);
	      var style = this.props.disableInternalStyle ? '' : generateTooltipStyle(this.state.uuid, this.state.customColors, this.state.type, this.state.border, this.state.padding, this.state.customRadius);
	      var tooltipClass = '__react_component_tooltip' + " ".concat(this.state.uuid) + (this.state.show && !disable && !isEmptyTip ? ' show' : '') + (this.state.border ? ' ' + this.state.borderClass : '') + " place-".concat(this.state.place) + // top, bottom, left, right
	      " type-".concat(this.hasCustomColors() ? 'custom' : this.state.type) + (
	      // dark, success, warning, error, info, light, custom
	      this.props.delayUpdate ? ' allow_hover' : '') + (this.props.clickable ? ' allow_click' : '');
	      var Wrapper = this.props.wrapper;
	      if (ReactTooltip.supportedWrappers.indexOf(Wrapper) < 0) {
	        Wrapper = ReactTooltip.defaultProps.wrapper;
	      }
	      var wrapperClassName = [tooltipClass, extraClass].filter(Boolean).join(' ');
	      if (html) {
	        var htmlContent = "".concat(content).concat(style ? "\n<style aria-hidden=\"true\">".concat(style, "</style>") : '');
	        return /*#__PURE__*/React__default["default"].createElement(Wrapper, _extends({
	          className: "".concat(wrapperClassName),
	          id: this.props.id || uuid,
	          ref: function ref(_ref) {
	            return _this9.tooltipRef = _ref;
	          }
	        }, ariaProps, {
	          "data-id": "tooltip",
	          dangerouslySetInnerHTML: {
	            __html: htmlContent
	          }
	        }));
	      } else {
	        return /*#__PURE__*/React__default["default"].createElement(Wrapper, _extends({
	          className: "".concat(wrapperClassName),
	          id: this.props.id || uuid
	        }, ariaProps, {
	          ref: function ref(_ref2) {
	            return _this9.tooltipRef = _ref2;
	          },
	          "data-id": "tooltip"
	        }), style && /*#__PURE__*/React__default["default"].createElement("style", {
	          dangerouslySetInnerHTML: {
	            __html: style
	          },
	          "aria-hidden": "true"
	        }), content);
	      }
	    }
	  }], [{
	    key: "propTypes",
	    get: function get() {
	      return {
	        uuid: PropTypes__default["default"].string,
	        children: PropTypes__default["default"].any,
	        place: PropTypes__default["default"].string,
	        type: PropTypes__default["default"].string,
	        effect: PropTypes__default["default"].string,
	        offset: PropTypes__default["default"].object,
	        padding: PropTypes__default["default"].string,
	        multiline: PropTypes__default["default"].bool,
	        border: PropTypes__default["default"].bool,
	        borderClass: PropTypes__default["default"].string,
	        textColor: PropTypes__default["default"].string,
	        backgroundColor: PropTypes__default["default"].string,
	        borderColor: PropTypes__default["default"].string,
	        arrowColor: PropTypes__default["default"].string,
	        arrowRadius: PropTypes__default["default"].string,
	        tooltipRadius: PropTypes__default["default"].string,
	        insecure: PropTypes__default["default"].bool,
	        "class": PropTypes__default["default"].string,
	        className: PropTypes__default["default"].string,
	        id: PropTypes__default["default"].string,
	        html: PropTypes__default["default"].bool,
	        delayHide: PropTypes__default["default"].number,
	        delayUpdate: PropTypes__default["default"].number,
	        delayShow: PropTypes__default["default"].number,
	        event: PropTypes__default["default"].string,
	        eventOff: PropTypes__default["default"].string,
	        isCapture: PropTypes__default["default"].bool,
	        globalEventOff: PropTypes__default["default"].string,
	        getContent: PropTypes__default["default"].any,
	        afterShow: PropTypes__default["default"].func,
	        afterHide: PropTypes__default["default"].func,
	        overridePosition: PropTypes__default["default"].func,
	        disable: PropTypes__default["default"].bool,
	        scrollHide: PropTypes__default["default"].bool,
	        resizeHide: PropTypes__default["default"].bool,
	        wrapper: PropTypes__default["default"].string,
	        bodyMode: PropTypes__default["default"].bool,
	        possibleCustomEvents: PropTypes__default["default"].string,
	        possibleCustomEventsOff: PropTypes__default["default"].string,
	        clickable: PropTypes__default["default"].bool,
	        disableInternalStyle: PropTypes__default["default"].bool
	      };
	    }
	  }, {
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps, prevState) {
	      var ariaProps = prevState.ariaProps;
	      var newAriaProps = parseAria(nextProps);
	      var isChanged = Object.keys(newAriaProps).some(function (props) {
	        return newAriaProps[props] !== ariaProps[props];
	      });
	      if (!isChanged) {
	        return null;
	      }
	      return _objectSpread2(_objectSpread2({}, prevState), {}, {
	        ariaProps: newAriaProps
	      });
	    }
	  }]);
	  return ReactTooltip;
	}(React__default["default"].Component), _defineProperty(_class2, "defaultProps", {
	  insecure: true,
	  resizeHide: true,
	  wrapper: 'div',
	  clickable: false
	}), _defineProperty(_class2, "supportedWrappers", ['div', 'span']), _defineProperty(_class2, "displayName", 'ReactTooltip'), _class2)) || _class) || _class) || _class) || _class) || _class) || _class) || _class;
	
	module.exports = ReactTooltip;
	//# sourceMappingURL=index.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var isProduction = ("production") === 'production';
	function warning(condition, message) {
	  if (!isProduction) {
	    if (condition) {
	      return;
	    }
	
	    var text = "Warning: " + message;
	
	    if (typeof console !== 'undefined') {
	      console.warn(text);
	    }
	
	    try {
	      throw Error(text);
	    } catch (x) {}
	  }
	}
	
	module.exports = warning;


/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _Cookies = _interopRequireDefault(__webpack_require__(1630));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _default = _Cookies["default"];
	exports["default"] = _default;
	module.exports = exports.default;

/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/chart-image.ba90291f.png";

/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/footerpreview.f9499d9e.png";

/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/headerimage.4ad32017.png";

/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/leftmenuimage.c6c284c3.png";

/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/previewheader.151f54ca.png";

/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/rightmenuimage.06620534.png";

/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _createTheme = _interopRequireDefault(__webpack_require__(234));
	
	var defaultTheme = (0, _createTheme.default)();
	var _default = defaultTheme;
	exports.default = _default;

/***/ },
/* 143 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setRef;
	
	// TODO v5: consider to make it private
	function setRef(ref, value) {
	  if (typeof ref === 'function') {
	    ref(value);
	  } else if (ref) {
	    ref.current = value;
	  }
	}

/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _useTheme.default;
	  }
	});
	
	var _useTheme = _interopRequireDefault(__webpack_require__(807));

/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MobilePopMenu = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FetchCall = __webpack_require__(4);
	
	var _Notification = __webpack_require__(958);
	
	var _reactTooltip = __webpack_require__(133);
	
	var _reactTooltip2 = _interopRequireDefault(_reactTooltip);
	
	var _reactstrap = __webpack_require__(17);
	
	var _partnerconstant = __webpack_require__(991);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MobilePopMenu = function (_Component) {
	  _inherits(MobilePopMenu, _Component);
	
	  function MobilePopMenu(props) {
	    _classCallCheck(this, MobilePopMenu);
	
	    var _this = _possibleConstructorReturn(this, (MobilePopMenu.__proto__ || Object.getPrototypeOf(MobilePopMenu)).call(this, props));
	
	    _this.handleMenu = function () {
	      _this.setState({
	        showmenu: true
	      });
	    };
	
	    _this.handleMenuShow = function (e, id) {
	      e.preventDefault();
	      (0, _jquery2.default)('.tab-panels .tab-panel').css('display', 'none');
	      (0, _jquery2.default)('.tab-panels .tab-panel[name="' + id + '"]').css('display', 'block');
	      var menuList = _this.state.menuList.map(function (item) {
	        item.defaultChecked = id == item.id;return item;
	      });
	      console.log('menuList', menuList);
	      _this.setState({
	        menuList: menuList
	      });
	    };
	
	    console.log('this.props', _this.props);
	    _this.state = {
	      showmenu: false,
	      menuList: _this.props.menu ? _this.props.menu : []
	    };
	    _this.wrapperRef = _react2.default.createRef();
	    _this.handleClickOutside = _this.handleClickOutside.bind(_this);
	    return _this;
	  }
	
	  _createClass(MobilePopMenu, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.addEventListener("click", this.handleClickOutside);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      document.removeEventListener("click", this.handleClickOutside);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps() {}
	  }, {
	    key: 'handleClickOutside',
	    value: function handleClickOutside(event) {
	      if (this.wrapperRef && !this.wrapperRef.current.contains(event.target)) {
	        this.setState({
	          showmenu: false
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var menuList = this.state.menuList;
	
	      var active = this.state.showmenu ? '' : 'hidden';
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          'nav',
	          { 'class': 'floating-menu ' + active, id: 'sideMenuContainer' },
	          menuList.map(function (item, i) {
	            var clsProp = item.disabled == true ? 'disabled' : item.defaultChecked == true ? 'active' : '';
	            return _react2.default.createElement('a', { href: 'javascript:;', 'class': 'menuitem ' + clsProp, onClick: function onClick(e) {
	                return _this2.handleMenuShow(e, item.id);
	              },
	              dangerouslySetInnerHTML: { __html: item.name } });
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'floating-menu-btn', ref: this.wrapperRef, onClick: function onClick() {
	              return _this2.handleMenu();
	            } },
	          _react2.default.createElement('i', { className: 'fa fa-bars', 'aria-hidden': 'true' })
	        )
	      );
	    }
	  }]);
	
	  return MobilePopMenu;
	}(_react.Component);
	
	exports.MobilePopMenu = MobilePopMenu;

/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict'
	
	var base64 = __webpack_require__(1070)
	var ieee754 = __webpack_require__(1306)
	var isArray = __webpack_require__(1071)
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()
	
	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength()
	
	function typedArraySupport () {
	  try {
	    var arr = new Uint8Array(1)
	    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
	    return arr.foo() === 42 && // typed array instances can be augmented
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}
	
	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}
	
	function createBuffer (that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length')
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length)
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length)
	    }
	    that.length = length
	  }
	
	  return that
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer (arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length)
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error(
	        'If encoding is specified then the first argument must be a string'
	      )
	    }
	    return allocUnsafe(this, arg)
	  }
	  return from(this, arg, encodingOrOffset, length)
	}
	
	Buffer.poolSize = 8192 // not used by this implementation
	
	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype
	  return arr
	}
	
	function from (that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number')
	  }
	
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length)
	  }
	
	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset)
	  }
	
	  return fromObject(that, value)
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length)
	}
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	  if (typeof Symbol !== 'undefined' && Symbol.species &&
	      Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    })
	  }
	}
	
	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number')
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative')
	  }
	}
	
	function alloc (that, size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(that, size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(that, size).fill(fill, encoding)
	      : createBuffer(that, size).fill(fill)
	  }
	  return createBuffer(that, size)
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding)
	}
	
	function allocUnsafe (that, size) {
	  assertSize(size)
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0
	    }
	  }
	  return that
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size)
	}
	
	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding')
	  }
	
	  var length = byteLength(string, encoding) | 0
	  that = createBuffer(that, length)
	
	  var actual = that.write(string, encoding)
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual)
	  }
	
	  return that
	}
	
	function fromArrayLike (that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  that = createBuffer(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	function fromArrayBuffer (that, array, byteOffset, length) {
	  array.byteLength // this throws if `array` is not a valid ArrayBuffer
	
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds')
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds')
	  }
	
	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array)
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset)
	  } else {
	    array = new Uint8Array(array, byteOffset, length)
	  }
	
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array)
	  }
	  return that
	}
	
	function fromObject (that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    that = createBuffer(that, len)
	
	    if (that.length === 0) {
	      return that
	    }
	
	    obj.copy(that, 0, 0, len)
	    return that
	  }
	
	  if (obj) {
	    if ((typeof ArrayBuffer !== 'undefined' &&
	        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0)
	      }
	      return fromArrayLike(that, obj)
	    }
	
	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data)
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
	}
	
	function checked (length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}
	
	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	    buf.copy(buffer, pos)
	    pos += buf.length
	  }
	  return buffer
	}
	
	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
	      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    string = '' + string
	  }
	
	  var len = string.length
	  if (len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length
	  }
	
	  if (end <= 0) {
	    return ''
	  }
	
	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0
	
	  if (end <= start) {
	    return ''
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true
	
	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}
	
	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}
	
	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}
	
	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}
	
	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer')
	  }
	
	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }
	
	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0
	
	  if (this === target) return 0
	
	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)
	
	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset  // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT &&
	        typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }
	
	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }
	
	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }
	
	  return -1
	}
	
	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}
	
	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function latin1Write (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i])
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end)
	    newBuf.__proto__ = Buffer.prototype
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start]
	    }
	  }
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	  var i
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, start + len),
	      targetStart
	    )
	  }
	
	  return len
	}
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if (code < 256) {
	        val = code
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }
	
	  if (end <= start) {
	    return this
	  }
	
	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0
	
	  if (!val) val = 0
	
	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : utf8ToBytes(new Buffer(val, encoding).toString())
	    var len = bytes.length
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}
	
	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	function isnan (val) {
	  return val !== val // eslint-disable-line no-self-compare
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	
	function isArray(arg) {
	  if (Array.isArray) {
	    return Array.isArray(arg);
	  }
	  return objectToString(arg) === '[object Array]';
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = __webpack_require__(146).Buffer.isBuffer;
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}


/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfUTCISOWeek;
	var _index = _interopRequireDefault(__webpack_require__(23));
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	function startOfUTCISOWeek(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var weekStartsOn = 1;
	  var date = (0, _index.default)(dirtyDate);
	  var day = date.getUTCDay();
	  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
	  date.setUTCDate(date.getUTCDate() - diff);
	  date.setUTCHours(0, 0, 0, 0);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfUTCWeek;
	var _index = _interopRequireDefault(__webpack_require__(23));
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	var _index3 = _interopRequireDefault(__webpack_require__(30));
	var _index4 = __webpack_require__(96);
	function startOfUTCWeek(dirtyDate, options) {
	  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
	  (0, _index2.default)(1, arguments);
	  var defaultOptions = (0, _index4.getDefaultOptions)();
	  var weekStartsOn = (0, _index3.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
	
	  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
	  }
	  var date = (0, _index.default)(dirtyDate);
	  var day = date.getUTCDay();
	  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
	  date.setUTCDate(date.getUTCDate() - diff);
	  date.setUTCHours(0, 0, 0, 0);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var keys = __webpack_require__(592);
	var hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';
	
	var toStr = Object.prototype.toString;
	var concat = Array.prototype.concat;
	var defineDataProperty = __webpack_require__(261);
	
	var isFunction = function (fn) {
		return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
	};
	
	var supportsDescriptors = __webpack_require__(273)();
	
	var defineProperty = function (object, name, value, predicate) {
		if (name in object) {
			if (predicate === true) {
				if (object[name] === value) {
					return;
				}
			} else if (!isFunction(predicate) || !predicate()) {
				return;
			}
		}
	
		if (supportsDescriptors) {
			defineDataProperty(object, name, value, true);
		} else {
			defineDataProperty(object, name, value);
		}
	};
	
	var defineProperties = function (object, map) {
		var predicates = arguments.length > 2 ? arguments[2] : {};
		var props = keys(map);
		if (hasSymbols) {
			props = concat.call(props, Object.getOwnPropertySymbols(map));
		}
		for (var i = 0; i < props.length; i += 1) {
			defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
		}
	};
	
	defineProperties.supportsDescriptors = !!supportsDescriptors;
	
	module.exports = defineProperties;


/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	var Immutable = __webpack_require__(27);
	
	var OrderedMap = Immutable.OrderedMap;
	var BlockMapBuilder = {
	  createFromArray: function createFromArray(blocks) {
	    return OrderedMap(blocks.map(function (block) {
	      return [block.getKey(), block];
	    }));
	  }
	};
	module.exports = BlockMapBuilder;

/***/ },
/* 152 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	/**
	 * Search through an array to find contiguous stretches of elements that
	 * match a specified filter function.
	 *
	 * When ranges are found, execute a specified `found` function to supply
	 * the values to the caller.
	 */
	function findRangesImmutable(haystack, areEqualFn, filterFn, foundFn) {
	  if (!haystack.size) {
	    return;
	  }
	
	  var cursor = 0;
	  haystack.reduce(function (value, nextValue, nextIndex) {
	    if (!areEqualFn(value, nextValue)) {
	      if (filterFn(value)) {
	        foundFn(cursor, nextIndex);
	      }
	
	      cursor = nextIndex;
	    }
	
	    return nextValue;
	  });
	  filterFn(haystack.last()) && foundFn(cursor, haystack.count());
	}
	
	module.exports = findRangesImmutable;

/***/ },
/* 153 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	function isHTMLElement(node) {
	  if (!node || !node.ownerDocument) {
	    return false;
	  }
	
	  if (!node.ownerDocument.defaultView) {
	    return node instanceof HTMLElement;
	  }
	
	  if (node instanceof node.ownerDocument.defaultView.HTMLElement) {
	    return true;
	  }
	
	  return false;
	}
	
	module.exports = isHTMLElement;

/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	var DraftModifier = __webpack_require__(59);
	
	var gkx = __webpack_require__(97);
	
	var experimentalTreeDataSupport = gkx('draft_tree_data_support');
	/**
	 * For a collapsed selection state, remove text based on the specified strategy.
	 * If the selection state is not collapsed, remove the entire selected range.
	 */
	
	function removeTextWithStrategy(editorState, strategy, direction) {
	  var selection = editorState.getSelection();
	  var content = editorState.getCurrentContent();
	  var target = selection;
	  var anchorKey = selection.getAnchorKey();
	  var focusKey = selection.getFocusKey();
	  var anchorBlock = content.getBlockForKey(anchorKey);
	
	  if (experimentalTreeDataSupport) {
	    if (direction === 'forward') {
	      if (anchorKey !== focusKey) {
	        // For now we ignore forward delete across blocks,
	        // if there is demand for this we will implement it.
	        return content;
	      }
	    }
	  }
	
	  if (selection.isCollapsed()) {
	    if (direction === 'forward') {
	      if (editorState.isSelectionAtEndOfContent()) {
	        return content;
	      }
	
	      if (experimentalTreeDataSupport) {
	        var isAtEndOfBlock = selection.getAnchorOffset() === content.getBlockForKey(anchorKey).getLength();
	
	        if (isAtEndOfBlock) {
	          var anchorBlockSibling = content.getBlockForKey(anchorBlock.nextSibling);
	
	          if (!anchorBlockSibling || anchorBlockSibling.getLength() === 0) {
	            // For now we ignore forward delete at the end of a block,
	            // if there is demand for this we will implement it.
	            return content;
	          }
	        }
	      }
	    } else if (editorState.isSelectionAtStartOfContent()) {
	      return content;
	    }
	
	    target = strategy(editorState);
	
	    if (target === selection) {
	      return content;
	    }
	  }
	
	  return DraftModifier.removeRange(content, target, direction);
	}
	
	module.exports = removeTextWithStrategy;

/***/ },
/* 155 */
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	function EventEmitter() {
	  this._events = this._events || {};
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function(n) {
	  if (!isNumber(n) || n < 0 || isNaN(n))
	    throw TypeError('n must be a positive number');
	  this._maxListeners = n;
	  return this;
	};
	
	EventEmitter.prototype.emit = function(type) {
	  var er, handler, len, args, i, listeners;
	
	  if (!this._events)
	    this._events = {};
	
	  // If there is no 'error' event listener then throw.
	  if (type === 'error') {
	    if (!this._events.error ||
	        (isObject(this._events.error) && !this._events.error.length)) {
	      er = arguments[1];
	      if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      } else {
	        // At least give some kind of context to the user
	        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
	        err.context = er;
	        throw err;
	      }
	    }
	  }
	
	  handler = this._events[type];
	
	  if (isUndefined(handler))
	    return false;
	
	  if (isFunction(handler)) {
	    switch (arguments.length) {
	      // fast cases
	      case 1:
	        handler.call(this);
	        break;
	      case 2:
	        handler.call(this, arguments[1]);
	        break;
	      case 3:
	        handler.call(this, arguments[1], arguments[2]);
	        break;
	      // slower
	      default:
	        args = Array.prototype.slice.call(arguments, 1);
	        handler.apply(this, args);
	    }
	  } else if (isObject(handler)) {
	    args = Array.prototype.slice.call(arguments, 1);
	    listeners = handler.slice();
	    len = listeners.length;
	    for (i = 0; i < len; i++)
	      listeners[i].apply(this, args);
	  }
	
	  return true;
	};
	
	EventEmitter.prototype.addListener = function(type, listener) {
	  var m;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events)
	    this._events = {};
	
	  // To avoid recursion in the case that type === "newListener"! Before
	  // adding it to the listeners, first emit "newListener".
	  if (this._events.newListener)
	    this.emit('newListener', type,
	              isFunction(listener.listener) ?
	              listener.listener : listener);
	
	  if (!this._events[type])
	    // Optimize the case of one listener. Don't need the extra array object.
	    this._events[type] = listener;
	  else if (isObject(this._events[type]))
	    // If we've already got an array, just append.
	    this._events[type].push(listener);
	  else
	    // Adding the second element, need to change to array.
	    this._events[type] = [this._events[type], listener];
	
	  // Check for listener leak
	  if (isObject(this._events[type]) && !this._events[type].warned) {
	    if (!isUndefined(this._maxListeners)) {
	      m = this._maxListeners;
	    } else {
	      m = EventEmitter.defaultMaxListeners;
	    }
	
	    if (m && m > 0 && this._events[type].length > m) {
	      this._events[type].warned = true;
	      console.error('(node) warning: possible EventEmitter memory ' +
	                    'leak detected. %d listeners added. ' +
	                    'Use emitter.setMaxListeners() to increase limit.',
	                    this._events[type].length);
	      if (typeof console.trace === 'function') {
	        // not supported in IE 10
	        console.trace();
	      }
	    }
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.once = function(type, listener) {
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  var fired = false;
	
	  function g() {
	    this.removeListener(type, g);
	
	    if (!fired) {
	      fired = true;
	      listener.apply(this, arguments);
	    }
	  }
	
	  g.listener = listener;
	  this.on(type, g);
	
	  return this;
	};
	
	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener = function(type, listener) {
	  var list, position, length, i;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events || !this._events[type])
	    return this;
	
	  list = this._events[type];
	  length = list.length;
	  position = -1;
	
	  if (list === listener ||
	      (isFunction(list.listener) && list.listener === listener)) {
	    delete this._events[type];
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	
	  } else if (isObject(list)) {
	    for (i = length; i-- > 0;) {
	      if (list[i] === listener ||
	          (list[i].listener && list[i].listener === listener)) {
	        position = i;
	        break;
	      }
	    }
	
	    if (position < 0)
	      return this;
	
	    if (list.length === 1) {
	      list.length = 0;
	      delete this._events[type];
	    } else {
	      list.splice(position, 1);
	    }
	
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.removeAllListeners = function(type) {
	  var key, listeners;
	
	  if (!this._events)
	    return this;
	
	  // not listening for removeListener, no need to emit
	  if (!this._events.removeListener) {
	    if (arguments.length === 0)
	      this._events = {};
	    else if (this._events[type])
	      delete this._events[type];
	    return this;
	  }
	
	  // emit removeListener for all listeners on all events
	  if (arguments.length === 0) {
	    for (key in this._events) {
	      if (key === 'removeListener') continue;
	      this.removeAllListeners(key);
	    }
	    this.removeAllListeners('removeListener');
	    this._events = {};
	    return this;
	  }
	
	  listeners = this._events[type];
	
	  if (isFunction(listeners)) {
	    this.removeListener(type, listeners);
	  } else if (listeners) {
	    // LIFO order
	    while (listeners.length)
	      this.removeListener(type, listeners[listeners.length - 1]);
	  }
	  delete this._events[type];
	
	  return this;
	};
	
	EventEmitter.prototype.listeners = function(type) {
	  var ret;
	  if (!this._events || !this._events[type])
	    ret = [];
	  else if (isFunction(this._events[type]))
	    ret = [this._events[type]];
	  else
	    ret = this._events[type].slice();
	  return ret;
	};
	
	EventEmitter.prototype.listenerCount = function(type) {
	  if (this._events) {
	    var evlistener = this._events[type];
	
	    if (isFunction(evlistener))
	      return 1;
	    else if (evlistener)
	      return evlistener.length;
	  }
	  return 0;
	};
	
	EventEmitter.listenerCount = function(emitter, type) {
	  return emitter.listenerCount(type);
	};
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isUndefined(arg) {
	  return arg === void 0;
	}


/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(1297);
	
	module.exports = Function.prototype.bind || implementation;


/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var reactIs = __webpack_require__(1304);
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var REACT_STATICS = {
	  childContextTypes: true,
	  contextType: true,
	  contextTypes: true,
	  defaultProps: true,
	  displayName: true,
	  getDefaultProps: true,
	  getDerivedStateFromError: true,
	  getDerivedStateFromProps: true,
	  mixins: true,
	  propTypes: true,
	  type: true
	};
	var KNOWN_STATICS = {
	  name: true,
	  length: true,
	  prototype: true,
	  caller: true,
	  callee: true,
	  arguments: true,
	  arity: true
	};
	var FORWARD_REF_STATICS = {
	  '$$typeof': true,
	  render: true,
	  defaultProps: true,
	  displayName: true,
	  propTypes: true
	};
	var MEMO_STATICS = {
	  '$$typeof': true,
	  compare: true,
	  defaultProps: true,
	  displayName: true,
	  propTypes: true,
	  type: true
	};
	var TYPE_STATICS = {};
	TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
	TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
	
	function getStatics(component) {
	  // React v16.11 and below
	  if (reactIs.isMemo(component)) {
	    return MEMO_STATICS;
	  } // React v16.12 and above
	
	
	  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
	}
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = Object.prototype;
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	  if (typeof sourceComponent !== 'string') {
	    // don't hoist over string (html) components
	    if (objectPrototype) {
	      var inheritedComponent = getPrototypeOf(sourceComponent);
	
	      if (inheritedComponent && inheritedComponent !== objectPrototype) {
	        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	      }
	    }
	
	    var keys = getOwnPropertyNames(sourceComponent);
	
	    if (getOwnPropertySymbols) {
	      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	    }
	
	    var targetStatics = getStatics(targetComponent);
	    var sourceStatics = getStatics(sourceComponent);
	
	    for (var i = 0; i < keys.length; ++i) {
	      var key = keys[i];
	
	      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
	        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	
	        try {
	          // Avoid failures from read-only properties
	          defineProperty(targetComponent, key, descriptor);
	        } catch (e) {}
	      }
	    }
	  }
	
	  return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	!function(e,t){ true?module.exports=t(__webpack_require__(27),__webpack_require__(84)):"function"==typeof define&&define.amd?define(["immutable","draft-js"],t):"object"==typeof exports?exports.htmlToDraftjs=t(require("immutable"),require("draft-js")):e.htmlToDraftjs=t(e.immutable,e["draft-js"])}(window,function(n,r){return o={},i.m=a=[function(e,t){e.exports=n},function(e,t){e.exports=r},function(e,t,n){e.exports=n(3)},function(e,t,n){"use strict";n.r(t);var v=n(1),u=n(0),s=function(e){var t,n=null;return document.implementation&&document.implementation.createHTMLDocument&&((t=document.implementation.createHTMLDocument("foo")).documentElement.innerHTML=e,n=t.getElementsByTagName("body")[0]),n},x=function(e,t,n){var r,i=e.textContent;return""===i.trim()?{chunk:(r=n,{text:" ",inlines:[new u.OrderedSet],entities:[r],blocks:[]})}:{chunk:{text:i,inlines:Array(i.length).fill(t),entities:Array(i.length).fill(n),blocks:[]}}},M=function(){return{text:"\n",inlines:[new u.OrderedSet],entities:new Array(1),blocks:[]}},k=function(){return{text:"",inlines:[],entities:[],blocks:[]}},E=function(e,t){return{text:"",inlines:[],entities:[],blocks:[{type:e,depth:0,data:t||new u.Map({})}]}},w=function(e,t,n){return{text:"\r",inlines:[],entities:[],blocks:[{type:e,depth:Math.max(0,Math.min(4,t)),data:n||new u.Map({})}]}},T=function(e){return{text:"\r ",inlines:[new u.OrderedSet],entities:[e],blocks:[{type:"atomic",depth:0,data:new u.Map({})}]}},L=function(e,t){return{text:e.text+t.text,inlines:e.inlines.concat(t.inlines),entities:e.entities.concat(t.entities),blocks:e.blocks.concat(t.blocks)}},A=new u.Map({"header-one":{element:"h1"},"header-two":{element:"h2"},"header-three":{element:"h3"},"header-four":{element:"h4"},"header-five":{element:"h5"},"header-six":{element:"h6"},"unordered-list-item":{element:"li",wrapper:"ul"},"ordered-list-item":{element:"li",wrapper:"ol"},blockquote:{element:"blockquote"},code:{element:"pre"},atomic:{element:"figure"},unstyled:{element:"p",aliasedElements:["div"]}});var O={code:"CODE",del:"STRIKETHROUGH",em:"ITALIC",strong:"BOLD",ins:"UNDERLINE",sub:"SUBSCRIPT",sup:"SUPERSCRIPT"};function S(e){return e.style.textAlign?new u.Map({"text-align":e.style.textAlign}):e.style.marginLeft?new u.Map({"margin-left":e.style.marginLeft}):void 0}var _=function(e){var t=void 0;if(e instanceof HTMLAnchorElement){var n={};t=e.dataset&&void 0!==e.dataset.mention?(n.url=e.href,n.text=e.innerHTML,n.value=e.dataset.value,v.Entity.__create("MENTION","IMMUTABLE",n)):(n.url=e.getAttribute&&e.getAttribute("href")||e.href,n.title=e.innerHTML,n.targetOption=e.target,v.Entity.__create("LINK","MUTABLE",n))}return t};n.d(t,"default",function(){return r});var d=" ",f=new RegExp("&nbsp;","g"),j=!0;function I(e,t,n,r,i,a){var o=e.nodeName.toLowerCase();if(a){var l=a(o,e);if(l){var c=v.Entity.__create(l.type,l.mutability,l.data||{});return{chunk:T(c)}}}if("#text"===o&&"\n"!==e.textContent)return x(e,t,i);if("br"===o)return{chunk:M()};if("img"===o&&e instanceof HTMLImageElement){var u={};u.src=e.getAttribute&&e.getAttribute("src")||e.src,u.alt=e.alt,u.height=e.style.height,u.width=e.style.width,e.style.float&&(u.alignment=e.style.float);var s=v.Entity.__create("IMAGE","MUTABLE",u);return{chunk:T(s)}}if("video"===o&&e instanceof HTMLVideoElement){var d={};d.src=e.getAttribute&&e.getAttribute("src")||e.src,d.alt=e.alt,d.height=e.style.height,d.width=e.style.width,e.style.float&&(d.alignment=e.style.float);var f=v.Entity.__create("VIDEO","MUTABLE",d);return{chunk:T(f)}}if("iframe"===o&&e instanceof HTMLIFrameElement){var m={};m.src=e.getAttribute&&e.getAttribute("src")||e.src,m.height=e.height,m.width=e.width;var p=v.Entity.__create("EMBEDDED_LINK","MUTABLE",m);return{chunk:T(p)}}var h,y=function(t,n){var e=A.filter(function(e){return e.element===t&&(!e.wrapper||e.wrapper===n)||e.wrapper===t||e.aliasedElements&&-1<e.aliasedElements.indexOf(t)}).keySeq().toSet().toArray();if(1===e.length)return e[0]}(o,r);y&&("ul"===o||"ol"===o?(r=o,n+=1):("unordered-list-item"!==y&&"ordered-list-item"!==y&&(r="",n=-1),j?(h=E(y,S(e)),j=!1):h=w(y,n,S(e)))),h=h||k(),t=function(e,t,n){var r,i=O[e];if(i)r=n.add(i).toOrderedSet();else if(t instanceof HTMLElement){var c=t;r=(r=n).withMutations(function(e){var t=c.style.color,n=c.style.backgroundColor,r=c.style.fontSize,i=c.style.fontFamily.replace(/^"|"$/g,""),a=c.style.fontWeight,o=c.style.textDecoration,l=c.style.fontStyle;t&&e.add("color-".concat(t.replace(/ /g,""))),n&&e.add("bgcolor-".concat(n.replace(/ /g,""))),r&&e.add("fontsize-".concat(r.replace(/px$/g,""))),i&&e.add("fontfamily-".concat(i)),"bold"===a&&e.add(O.strong),"underline"===o&&e.add(O.ins),"italic"===l&&e.add(O.em)}).toOrderedSet()}return r}(o,e,t);for(var b=e.firstChild;b;){var g=I(b,t,n,r,_(b)||i,a).chunk;h=L(h,g),b=b.nextSibling}return{chunk:h}}function r(e,t){var n,r,i,a=(n=t,r=e.trim().replace(f,d),(i=s(r))?(j=!0,{chunk:I(i,new u.OrderedSet,-1,"",void 0,n).chunk}):null);if(a){var o=a.chunk,l=new u.OrderedMap({});o.entities&&o.entities.forEach(function(e){e&&(l=l.set(e,v.Entity.__get(e)))});var c=0;return{contentBlocks:o.text.split("\r").map(function(e,t){var n=c+e.length,r=o&&o.inlines.slice(c,n),i=o&&o.entities.slice(c,n),a=new u.List(r.map(function(e,t){var n={style:e,entity:null};return i[t]&&(n.entity=i[t]),v.CharacterMetadata.create(n)}));return c=n,new v.ContentBlock({key:Object(v.genKey)(),type:o&&o.blocks[t]&&o.blocks[t].type||"unstyled",depth:o&&o.blocks[t]&&o.blocks[t].depth,data:o&&o.blocks[t]&&o.blocks[t].data||new u.Map({}),text:e,characterList:a})}),entityMap:l}}return null}}],i.c=o,i.d=function(e,t,n){i.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:n})},i.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},i.t=function(t,e){if(1&e&&(t=i(t)),8&e)return t;if(4&e&&"object"==typeof t&&t&&t.__esModule)return t;var n=Object.create(null);if(i.r(n),Object.defineProperty(n,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var r in t)i.d(n,r,function(e){return t[e]}.bind(null,r));return n},i.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return i.d(t,"a",t),t},i.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},i.p="",i(i.s=2);function i(e){if(o[e])return o[e].exports;var t=o[e]={i:e,l:!1,exports:{}};return a[e].call(t.exports,t,t.exports,i),t.l=!0,t.exports}var a,o});

/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	// load the global object first:
	// - it should be better integrated in the system (unhandledRejection in node)
	// - the environment may have a custom Promise implementation (see zone.js)
	var ES6Promise = null;
	if (typeof Promise !== "undefined") {
	    ES6Promise = Promise;
	} else {
	    ES6Promise = __webpack_require__(1338);
	}
	
	/**
	 * Let the user use/change some implementations.
	 */
	module.exports = {
	    Promise: ES6Promise
	};


/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var utils = __webpack_require__(42);
	var support = __webpack_require__(98);
	var nodejsUtils = __webpack_require__(201);
	var GenericWorker = __webpack_require__(72);
	
	/**
	 * The following functions come from pako, from pako/lib/utils/strings
	 * released under the MIT license, see pako https://github.com/nodeca/pako/
	 */
	
	// Table with utf8 lengths (calculated by first byte of sequence)
	// Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
	// because max possible codepoint is 0x10ffff
	var _utf8len = new Array(256);
	for (var i=0; i<256; i++) {
	    _utf8len[i] = (i >= 252 ? 6 : i >= 248 ? 5 : i >= 240 ? 4 : i >= 224 ? 3 : i >= 192 ? 2 : 1);
	}
	_utf8len[254]=_utf8len[254]=1; // Invalid sequence start
	
	// convert string to array (typed, when possible)
	var string2buf = function (str) {
	    var buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;
	
	    // count binary size
	    for (m_pos = 0; m_pos < str_len; m_pos++) {
	        c = str.charCodeAt(m_pos);
	        if ((c & 0xfc00) === 0xd800 && (m_pos+1 < str_len)) {
	            c2 = str.charCodeAt(m_pos+1);
	            if ((c2 & 0xfc00) === 0xdc00) {
	                c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
	                m_pos++;
	            }
	        }
	        buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
	    }
	
	    // allocate buffer
	    if (support.uint8array) {
	        buf = new Uint8Array(buf_len);
	    } else {
	        buf = new Array(buf_len);
	    }
	
	    // convert
	    for (i=0, m_pos = 0; i < buf_len; m_pos++) {
	        c = str.charCodeAt(m_pos);
	        if ((c & 0xfc00) === 0xd800 && (m_pos+1 < str_len)) {
	            c2 = str.charCodeAt(m_pos+1);
	            if ((c2 & 0xfc00) === 0xdc00) {
	                c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
	                m_pos++;
	            }
	        }
	        if (c < 0x80) {
	            /* one byte */
	            buf[i++] = c;
	        } else if (c < 0x800) {
	            /* two bytes */
	            buf[i++] = 0xC0 | (c >>> 6);
	            buf[i++] = 0x80 | (c & 0x3f);
	        } else if (c < 0x10000) {
	            /* three bytes */
	            buf[i++] = 0xE0 | (c >>> 12);
	            buf[i++] = 0x80 | (c >>> 6 & 0x3f);
	            buf[i++] = 0x80 | (c & 0x3f);
	        } else {
	            /* four bytes */
	            buf[i++] = 0xf0 | (c >>> 18);
	            buf[i++] = 0x80 | (c >>> 12 & 0x3f);
	            buf[i++] = 0x80 | (c >>> 6 & 0x3f);
	            buf[i++] = 0x80 | (c & 0x3f);
	        }
	    }
	
	    return buf;
	};
	
	// Calculate max possible position in utf8 buffer,
	// that will not break sequence. If that's not possible
	// - (very small limits) return max size as is.
	//
	// buf[] - utf8 bytes array
	// max   - length limit (mandatory);
	var utf8border = function(buf, max) {
	    var pos;
	
	    max = max || buf.length;
	    if (max > buf.length) { max = buf.length; }
	
	    // go back from last position, until start of sequence found
	    pos = max-1;
	    while (pos >= 0 && (buf[pos] & 0xC0) === 0x80) { pos--; }
	
	    // Fuckup - very small and broken sequence,
	    // return max, because we should return something anyway.
	    if (pos < 0) { return max; }
	
	    // If we came to start of buffer - that means vuffer is too small,
	    // return max too.
	    if (pos === 0) { return max; }
	
	    return (pos + _utf8len[buf[pos]] > max) ? pos : max;
	};
	
	// convert array to string
	var buf2string = function (buf) {
	    var i, out, c, c_len;
	    var len = buf.length;
	
	    // Reserve max possible length (2 words per char)
	    // NB: by unknown reasons, Array is significantly faster for
	    //     String.fromCharCode.apply than Uint16Array.
	    var utf16buf = new Array(len*2);
	
	    for (out=0, i=0; i<len;) {
	        c = buf[i++];
	        // quick process ascii
	        if (c < 0x80) { utf16buf[out++] = c; continue; }
	
	        c_len = _utf8len[c];
	        // skip 5 & 6 byte codes
	        if (c_len > 4) { utf16buf[out++] = 0xfffd; i += c_len-1; continue; }
	
	        // apply mask on first byte
	        c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
	        // join the rest
	        while (c_len > 1 && i < len) {
	            c = (c << 6) | (buf[i++] & 0x3f);
	            c_len--;
	        }
	
	        // terminated by end of string?
	        if (c_len > 1) { utf16buf[out++] = 0xfffd; continue; }
	
	        if (c < 0x10000) {
	            utf16buf[out++] = c;
	        } else {
	            c -= 0x10000;
	            utf16buf[out++] = 0xd800 | ((c >> 10) & 0x3ff);
	            utf16buf[out++] = 0xdc00 | (c & 0x3ff);
	        }
	    }
	
	    // shrinkBuf(utf16buf, out)
	    if (utf16buf.length !== out) {
	        if(utf16buf.subarray) {
	            utf16buf = utf16buf.subarray(0, out);
	        } else {
	            utf16buf.length = out;
	        }
	    }
	
	    // return String.fromCharCode.apply(null, utf16buf);
	    return utils.applyFromCharCode(utf16buf);
	};
	
	
	// That's all for the pako functions.
	
	
	/**
	 * Transform a javascript string into an array (typed if possible) of bytes,
	 * UTF-8 encoded.
	 * @param {String} str the string to encode
	 * @return {Array|Uint8Array|Buffer} the UTF-8 encoded string.
	 */
	exports.utf8encode = function utf8encode(str) {
	    if (support.nodebuffer) {
	        return nodejsUtils.newBufferFrom(str, "utf-8");
	    }
	
	    return string2buf(str);
	};
	
	
	/**
	 * Transform a bytes array (or a representation) representing an UTF-8 encoded
	 * string into a javascript string.
	 * @param {Array|Uint8Array|Buffer} buf the data de decode
	 * @return {String} the decoded string.
	 */
	exports.utf8decode = function utf8decode(buf) {
	    if (support.nodebuffer) {
	        return utils.transformTo("nodebuffer", buf).toString("utf-8");
	    }
	
	    buf = utils.transformTo(support.uint8array ? "uint8array" : "array", buf);
	
	    return buf2string(buf);
	};
	
	/**
	 * A worker to decode utf8 encoded binary chunks into string chunks.
	 * @constructor
	 */
	function Utf8DecodeWorker() {
	    GenericWorker.call(this, "utf-8 decode");
	    // the last bytes if a chunk didn't end with a complete codepoint.
	    this.leftOver = null;
	}
	utils.inherits(Utf8DecodeWorker, GenericWorker);
	
	/**
	 * @see GenericWorker.processChunk
	 */
	Utf8DecodeWorker.prototype.processChunk = function (chunk) {
	
	    var data = utils.transformTo(support.uint8array ? "uint8array" : "array", chunk.data);
	
	    // 1st step, re-use what's left of the previous chunk
	    if (this.leftOver && this.leftOver.length) {
	        if(support.uint8array) {
	            var previousData = data;
	            data = new Uint8Array(previousData.length + this.leftOver.length);
	            data.set(this.leftOver, 0);
	            data.set(previousData, this.leftOver.length);
	        } else {
	            data = this.leftOver.concat(data);
	        }
	        this.leftOver = null;
	    }
	
	    var nextBoundary = utf8border(data);
	    var usableData = data;
	    if (nextBoundary !== data.length) {
	        if (support.uint8array) {
	            usableData = data.subarray(0, nextBoundary);
	            this.leftOver = data.subarray(nextBoundary, data.length);
	        } else {
	            usableData = data.slice(0, nextBoundary);
	            this.leftOver = data.slice(nextBoundary, data.length);
	        }
	    }
	
	    this.push({
	        data : exports.utf8decode(usableData),
	        meta : chunk.meta
	    });
	};
	
	/**
	 * @see GenericWorker.flush
	 */
	Utf8DecodeWorker.prototype.flush = function () {
	    if(this.leftOver && this.leftOver.length) {
	        this.push({
	            data : exports.utf8decode(this.leftOver),
	            meta : {}
	        });
	        this.leftOver = null;
	    }
	};
	exports.Utf8DecodeWorker = Utf8DecodeWorker;
	
	/**
	 * A worker to endcode string chunks into utf8 encoded binary chunks.
	 * @constructor
	 */
	function Utf8EncodeWorker() {
	    GenericWorker.call(this, "utf-8 encode");
	}
	utils.inherits(Utf8EncodeWorker, GenericWorker);
	
	/**
	 * @see GenericWorker.processChunk
	 */
	Utf8EncodeWorker.prototype.processChunk = function (chunk) {
	    this.push({
	        data : exports.utf8encode(chunk.data),
	        meta : chunk.meta
	    });
	};
	exports.Utf8EncodeWorker = Utf8EncodeWorker;


/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var isObject = __webpack_require__(74);
	
	var $String = String;
	var $TypeError = TypeError;
	
	// `Assert: Type(argument) is Object`
	module.exports = function (argument) {
	  if (isObject(argument)) return argument;
	  throw new $TypeError($String(argument) + ' is not an object');
	};


/***/ },
/* 162 */
/***/ function(module, exports) {

	'use strict';
	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var NATIVE_WEAK_MAP = __webpack_require__(1419);
	var globalThis = __webpack_require__(54);
	var isObject = __webpack_require__(74);
	var createNonEnumerableProperty = __webpack_require__(204);
	var hasOwn = __webpack_require__(51);
	var shared = __webpack_require__(290);
	var sharedKey = __webpack_require__(209);
	var hiddenKeys = __webpack_require__(206);
	
	var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
	var TypeError = globalThis.TypeError;
	var WeakMap = globalThis.WeakMap;
	var set, get, has;
	
	var enforce = function (it) {
	  return has(it) ? get(it) : set(it, {});
	};
	
	var getterFor = function (TYPE) {
	  return function (it) {
	    var state;
	    if (!isObject(it) || (state = get(it)).type !== TYPE) {
	      throw new TypeError('Incompatible receiver, ' + TYPE + ' required');
	    } return state;
	  };
	};
	
	if (NATIVE_WEAK_MAP || shared.state) {
	  var store = shared.state || (shared.state = new WeakMap());
	  /* eslint-disable no-self-assign -- prototype methods protection */
	  store.get = store.get;
	  store.has = store.has;
	  store.set = store.set;
	  /* eslint-enable no-self-assign -- prototype methods protection */
	  set = function (it, metadata) {
	    if (store.has(it)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
	    metadata.facade = it;
	    store.set(it, metadata);
	    return metadata;
	  };
	  get = function (it) {
	    return store.get(it) || {};
	  };
	  has = function (it) {
	    return store.has(it);
	  };
	} else {
	  var STATE = sharedKey('state');
	  hiddenKeys[STATE] = true;
	  set = function (it, metadata) {
	    if (hasOwn(it, STATE)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
	    metadata.facade = it;
	    createNonEnumerableProperty(it, STATE, metadata);
	    return metadata;
	  };
	  get = function (it) {
	    return hasOwn(it, STATE) ? it[STATE] : {};
	  };
	  has = function (it) {
	    return hasOwn(it, STATE);
	  };
	}
	
	module.exports = {
	  set: set,
	  get: get,
	  has: has,
	  enforce: enforce,
	  getterFor: getterFor
	};


/***/ },
/* 164 */
/***/ function(module, exports) {

	'use strict';
	module.exports = false;


/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var isNullOrUndefined = __webpack_require__(610);
	
	var $TypeError = TypeError;
	
	// `RequireObjectCoercible` abstract operation
	// https://tc39.es/ecma262/#sec-requireobjectcoercible
	module.exports = function (it) {
	  if (isNullOrUndefined(it)) throw new $TypeError("Can't call method on " + it);
	  return it;
	};


/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var store = __webpack_require__(290);
	// eslint-disable-next-line es/no-object-create -- safe
	var create = Object.create || Object;
	
	module.exports = function (key, value) {
	  return store[key] || (store[key] = value || create(null));
	};


/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var requireObjectCoercible = __webpack_require__(165);
	
	var $Object = Object;
	
	// `ToObject` abstract operation
	// https://tc39.es/ecma262/#sec-toobject
	module.exports = function (argument) {
	  return $Object(requireObjectCoercible(argument));
	};


/***/ },
/* 168 */
[1664, 1437],
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "Popper", {
	  enumerable: true,
	  get: function get() {
	    return _Popper.default;
	  }
	});
	Object.defineProperty(exports, "placements", {
	  enumerable: true,
	  get: function get() {
	    return _Popper.placements;
	  }
	});
	Object.defineProperty(exports, "Manager", {
	  enumerable: true,
	  get: function get() {
	    return _Manager.default;
	  }
	});
	Object.defineProperty(exports, "Reference", {
	  enumerable: true,
	  get: function get() {
	    return _Reference.default;
	  }
	});
	
	var _Popper = _interopRequireWildcard(__webpack_require__(1446));
	
	var _Manager = _interopRequireDefault(__webpack_require__(295));
	
	var _Reference = _interopRequireDefault(__webpack_require__(1447));

/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	!function(e,t){ true?module.exports=t(__webpack_require__(1)):"function"==typeof define&&define.amd?define(["react"],t):"object"==typeof exports?exports.ReactRecaptcha=t(require("react")):e.ReactRecaptcha=t(e.React)}(this,function(e){return function(e){function t(r){if(a[r])return a[r].exports;var n=a[r]={exports:{},id:r,loaded:!1};return e[r].call(n.exports,n,n.exports,t),n.loaded=!0,n.exports}var a={};return t.m=e,t.c=a,t.p="",t(0)}([function(e,t,a){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function n(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var l=function(){function e(e,t){for(var a=0;a<t.length;a++){var r=t[a];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,a,r){return a&&e(t.prototype,a),r&&e(t,r),t}}(),s=a(6),c=r(s),p=a(4),u=r(p),d={className:u.default.string,onloadCallbackName:u.default.string,elementID:u.default.string,onloadCallback:u.default.func,verifyCallback:u.default.func,expiredCallback:u.default.func,render:u.default.oneOf(["onload","explicit"]),sitekey:u.default.string,theme:u.default.oneOf(["light","dark"]),type:u.default.string,verifyCallbackName:u.default.string,expiredCallbackName:u.default.string,size:u.default.oneOf(["invisible","compact","normal"]),tabindex:u.default.string,hl:u.default.string,badge:u.default.oneOf(["bottomright","bottomleft","inline"])},f={elementID:"g-recaptcha",className:"g-recaptcha",onloadCallback:void 0,onloadCallbackName:"onloadCallback",verifyCallback:void 0,verifyCallbackName:"verifyCallback",expiredCallback:void 0,expiredCallbackName:"expiredCallback",render:"onload",theme:"light",type:"image",size:"normal",tabindex:"0",hl:"en",badge:"bottomright"},h=function(){return"undefined"!=typeof window&&"undefined"!=typeof window.grecaptcha&&"function"==typeof window.grecaptcha.render},y=void 0,b=function(e){function t(e){n(this,t);var a=o(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return a._renderGrecaptcha=a._renderGrecaptcha.bind(a),a.reset=a.reset.bind(a),a.state={ready:h(),widget:null},a.state.ready||"undefined"==typeof window||(y=setInterval(a._updateReadyState.bind(a),1e3)),a}return i(t,e),l(t,[{key:"componentDidMount",value:function(){this.state.ready&&this._renderGrecaptcha()}},{key:"componentDidUpdate",value:function(e,t){var a=this.props,r=a.render,n=a.onloadCallback;"explicit"===r&&n&&this.state.ready&&!t.ready&&this._renderGrecaptcha()}},{key:"componentWillUnmount",value:function(){clearInterval(y)}},{key:"reset",value:function(){var e=this.state,t=e.ready,a=e.widget;t&&null!==a&&grecaptcha.reset(a)}},{key:"execute",value:function(){var e=this.state,t=e.ready,a=e.widget;t&&null!==a&&grecaptcha.execute(a)}},{key:"_updateReadyState",value:function(){h()&&(this.setState({ready:!0}),clearInterval(y))}},{key:"_renderGrecaptcha",value:function(){this.state.widget=grecaptcha.render(this.props.elementID,{sitekey:this.props.sitekey,callback:this.props.verifyCallback?this.props.verifyCallback:void 0,theme:this.props.theme,type:this.props.type,size:this.props.size,tabindex:this.props.tabindex,hl:this.props.hl,badge:this.props.badge,"expired-callback":this.props.expiredCallback?this.props.expiredCallback:void 0}),this.props.onloadCallback&&this.props.onloadCallback()}},{key:"render",value:function(){return"explicit"===this.props.render&&this.props.onloadCallback?c.default.createElement("div",{id:this.props.elementID,"data-onloadcallbackname":this.props.onloadCallbackName,"data-verifycallbackname":this.props.verifyCallbackName}):c.default.createElement("div",{id:this.props.elementID,className:this.props.className,"data-sitekey":this.props.sitekey,"data-theme":this.props.theme,"data-type":this.props.type,"data-size":this.props.size,"data-badge":this.props.badge,"data-tabindex":this.props.tabindex})}}]),t}(s.Component);t.default=b,b.propTypes=d,b.defaultProps=f,e.exports=t.default},function(e,t){"use strict";function a(e){return function(){return e}}var r=function(){};r.thatReturns=a,r.thatReturnsFalse=a(!1),r.thatReturnsTrue=a(!0),r.thatReturnsNull=a(null),r.thatReturnsThis=function(){return this},r.thatReturnsArgument=function(e){return e},e.exports=r},function(e,t,a){"use strict";function r(e,t,a,r,o,i,l,s){if(n(t),!e){var c;if(void 0===t)c=new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var p=[a,r,o,i,l,s],u=0;c=new Error(t.replace(/%s/g,function(){return p[u++]})),c.name="Invariant Violation"}throw c.framesToPop=1,c}}var n=function(e){};e.exports=r},function(e,t,a){"use strict";var r=a(1),n=a(2),o=a(5);e.exports=function(){function e(e,t,a,r,i,l){l!==o&&n(!1,"Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types")}function t(){return e}e.isRequired=e;var a={array:e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:t,element:e,instanceOf:t,node:e,objectOf:t,oneOf:t,oneOfType:t,shape:t};return a.checkPropTypes=r,a.PropTypes=a,a}},function(e,t,a){e.exports=a(3)()},function(e,t){"use strict";var a="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";e.exports=a},function(t,a){t.exports=e}])});

/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.clamp = clamp;
	exports.canUseDOM = exports.slidesOnLeft = exports.slidesOnRight = exports.siblingDirection = exports.getTotalSlides = exports.getPostClones = exports.getPreClones = exports.getTrackLeft = exports.getTrackAnimateCSS = exports.getTrackCSS = exports.checkSpecKeys = exports.getSlideCount = exports.checkNavigable = exports.getNavigableIndexes = exports.swipeEnd = exports.swipeMove = exports.swipeStart = exports.keyHandler = exports.changeSlide = exports.slideHandler = exports.initializedState = exports.extractObject = exports.canGoNext = exports.getSwipeDirection = exports.getHeight = exports.getWidth = exports.lazySlidesOnRight = exports.lazySlidesOnLeft = exports.lazyEndIndex = exports.lazyStartIndex = exports.getRequiredLazySlides = exports.getOnDemandLazySlides = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function clamp(number, lowerBound, upperBound) {
	  return Math.max(lowerBound, Math.min(number, upperBound));
	}
	
	var getOnDemandLazySlides = function getOnDemandLazySlides(spec) {
	  var onDemandSlides = [];
	  var startIndex = lazyStartIndex(spec);
	  var endIndex = lazyEndIndex(spec);
	
	  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
	    if (spec.lazyLoadedList.indexOf(slideIndex) < 0) {
	      onDemandSlides.push(slideIndex);
	    }
	  }
	
	  return onDemandSlides;
	}; // return list of slides that need to be present
	
	
	exports.getOnDemandLazySlides = getOnDemandLazySlides;
	
	var getRequiredLazySlides = function getRequiredLazySlides(spec) {
	  var requiredSlides = [];
	  var startIndex = lazyStartIndex(spec);
	  var endIndex = lazyEndIndex(spec);
	
	  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
	    requiredSlides.push(slideIndex);
	  }
	
	  return requiredSlides;
	}; // startIndex that needs to be present
	
	
	exports.getRequiredLazySlides = getRequiredLazySlides;
	
	var lazyStartIndex = function lazyStartIndex(spec) {
	  return spec.currentSlide - lazySlidesOnLeft(spec);
	};
	
	exports.lazyStartIndex = lazyStartIndex;
	
	var lazyEndIndex = function lazyEndIndex(spec) {
	  return spec.currentSlide + lazySlidesOnRight(spec);
	};
	
	exports.lazyEndIndex = lazyEndIndex;
	
	var lazySlidesOnLeft = function lazySlidesOnLeft(spec) {
	  return spec.centerMode ? Math.floor(spec.slidesToShow / 2) + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : 0;
	};
	
	exports.lazySlidesOnLeft = lazySlidesOnLeft;
	
	var lazySlidesOnRight = function lazySlidesOnRight(spec) {
	  return spec.centerMode ? Math.floor((spec.slidesToShow - 1) / 2) + 1 + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : spec.slidesToShow;
	}; // get width of an element
	
	
	exports.lazySlidesOnRight = lazySlidesOnRight;
	
	var getWidth = function getWidth(elem) {
	  return elem && elem.offsetWidth || 0;
	};
	
	exports.getWidth = getWidth;
	
	var getHeight = function getHeight(elem) {
	  return elem && elem.offsetHeight || 0;
	};
	
	exports.getHeight = getHeight;
	
	var getSwipeDirection = function getSwipeDirection(touchObject) {
	  var verticalSwiping = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	  var xDist, yDist, r, swipeAngle;
	  xDist = touchObject.startX - touchObject.curX;
	  yDist = touchObject.startY - touchObject.curY;
	  r = Math.atan2(yDist, xDist);
	  swipeAngle = Math.round(r * 180 / Math.PI);
	
	  if (swipeAngle < 0) {
	    swipeAngle = 360 - Math.abs(swipeAngle);
	  }
	
	  if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) {
	    return "left";
	  }
	
	  if (swipeAngle >= 135 && swipeAngle <= 225) {
	    return "right";
	  }
	
	  if (verticalSwiping === true) {
	    if (swipeAngle >= 35 && swipeAngle <= 135) {
	      return "up";
	    } else {
	      return "down";
	    }
	  }
	
	  return "vertical";
	}; // whether or not we can go next
	
	
	exports.getSwipeDirection = getSwipeDirection;
	
	var canGoNext = function canGoNext(spec) {
	  var canGo = true;
	
	  if (!spec.infinite) {
	    if (spec.centerMode && spec.currentSlide >= spec.slideCount - 1) {
	      canGo = false;
	    } else if (spec.slideCount <= spec.slidesToShow || spec.currentSlide >= spec.slideCount - spec.slidesToShow) {
	      canGo = false;
	    }
	  }
	
	  return canGo;
	}; // given an object and a list of keys, return new object with given keys
	
	
	exports.canGoNext = canGoNext;
	
	var extractObject = function extractObject(spec, keys) {
	  var newObject = {};
	  keys.forEach(function (key) {
	    return newObject[key] = spec[key];
	  });
	  return newObject;
	}; // get initialized state
	
	
	exports.extractObject = extractObject;
	
	var initializedState = function initializedState(spec) {
	  // spec also contains listRef, trackRef
	  var slideCount = _react["default"].Children.count(spec.children);
	
	  var listNode = spec.listRef;
	  var listWidth = Math.ceil(getWidth(listNode));
	  var trackNode = spec.trackRef && spec.trackRef.node;
	  var trackWidth = Math.ceil(getWidth(trackNode));
	  var slideWidth;
	
	  if (!spec.vertical) {
	    var centerPaddingAdj = spec.centerMode && parseInt(spec.centerPadding) * 2;
	
	    if (typeof spec.centerPadding === "string" && spec.centerPadding.slice(-1) === "%") {
	      centerPaddingAdj *= listWidth / 100;
	    }
	
	    slideWidth = Math.ceil((listWidth - centerPaddingAdj) / spec.slidesToShow);
	  } else {
	    slideWidth = listWidth;
	  }
	
	  var slideHeight = listNode && getHeight(listNode.querySelector('[data-index="0"]'));
	  var listHeight = slideHeight * spec.slidesToShow;
	  var currentSlide = spec.currentSlide === undefined ? spec.initialSlide : spec.currentSlide;
	
	  if (spec.rtl && spec.currentSlide === undefined) {
	    currentSlide = slideCount - 1 - spec.initialSlide;
	  }
	
	  var lazyLoadedList = spec.lazyLoadedList || [];
	  var slidesToLoad = getOnDemandLazySlides(_objectSpread(_objectSpread({}, spec), {}, {
	    currentSlide: currentSlide,
	    lazyLoadedList: lazyLoadedList
	  }));
	  lazyLoadedList.concat(slidesToLoad);
	  var state = {
	    slideCount: slideCount,
	    slideWidth: slideWidth,
	    listWidth: listWidth,
	    trackWidth: trackWidth,
	    currentSlide: currentSlide,
	    slideHeight: slideHeight,
	    listHeight: listHeight,
	    lazyLoadedList: lazyLoadedList
	  };
	
	  if (spec.autoplaying === null && spec.autoplay) {
	    state["autoplaying"] = "playing";
	  }
	
	  return state;
	};
	
	exports.initializedState = initializedState;
	
	var slideHandler = function slideHandler(spec) {
	  var waitForAnimate = spec.waitForAnimate,
	      animating = spec.animating,
	      fade = spec.fade,
	      infinite = spec.infinite,
	      index = spec.index,
	      slideCount = spec.slideCount,
	      lazyLoadedList = spec.lazyLoadedList,
	      lazyLoad = spec.lazyLoad,
	      currentSlide = spec.currentSlide,
	      centerMode = spec.centerMode,
	      slidesToScroll = spec.slidesToScroll,
	      slidesToShow = spec.slidesToShow,
	      useCSS = spec.useCSS;
	  if (waitForAnimate && animating) return {};
	  var animationSlide = index,
	      finalSlide,
	      animationLeft,
	      finalLeft;
	  var state = {},
	      nextState = {};
	  var targetSlide = infinite ? index : clamp(index, 0, slideCount - 1);
	
	  if (fade) {
	    if (!infinite && (index < 0 || index >= slideCount)) return {};
	
	    if (index < 0) {
	      animationSlide = index + slideCount;
	    } else if (index >= slideCount) {
	      animationSlide = index - slideCount;
	    }
	
	    if (lazyLoad && lazyLoadedList.indexOf(animationSlide) < 0) {
	      lazyLoadedList.push(animationSlide);
	    }
	
	    state = {
	      animating: true,
	      currentSlide: animationSlide,
	      lazyLoadedList: lazyLoadedList,
	      targetSlide: animationSlide
	    };
	    nextState = {
	      animating: false,
	      targetSlide: animationSlide
	    };
	  } else {
	    finalSlide = animationSlide;
	
	    if (animationSlide < 0) {
	      finalSlide = animationSlide + slideCount;
	      if (!infinite) finalSlide = 0;else if (slideCount % slidesToScroll !== 0) finalSlide = slideCount - slideCount % slidesToScroll;
	    } else if (!canGoNext(spec) && animationSlide > currentSlide) {
	      animationSlide = finalSlide = currentSlide;
	    } else if (centerMode && animationSlide >= slideCount) {
	      animationSlide = infinite ? slideCount : slideCount - 1;
	      finalSlide = infinite ? 0 : slideCount - 1;
	    } else if (animationSlide >= slideCount) {
	      finalSlide = animationSlide - slideCount;
	      if (!infinite) finalSlide = slideCount - slidesToShow;else if (slideCount % slidesToScroll !== 0) finalSlide = 0;
	    }
	
	    if (!infinite && animationSlide + slidesToShow >= slideCount) {
	      finalSlide = slideCount - slidesToShow;
	    }
	
	    animationLeft = getTrackLeft(_objectSpread(_objectSpread({}, spec), {}, {
	      slideIndex: animationSlide
	    }));
	    finalLeft = getTrackLeft(_objectSpread(_objectSpread({}, spec), {}, {
	      slideIndex: finalSlide
	    }));
	
	    if (!infinite) {
	      if (animationLeft === finalLeft) animationSlide = finalSlide;
	      animationLeft = finalLeft;
	    }
	
	    lazyLoad && lazyLoadedList.concat(getOnDemandLazySlides(_objectSpread(_objectSpread({}, spec), {}, {
	      currentSlide: animationSlide
	    })));
	
	    if (!useCSS) {
	      state = {
	        currentSlide: finalSlide,
	        trackStyle: getTrackCSS(_objectSpread(_objectSpread({}, spec), {}, {
	          left: finalLeft
	        })),
	        lazyLoadedList: lazyLoadedList,
	        targetSlide: targetSlide
	      };
	    } else {
	      state = {
	        animating: true,
	        currentSlide: finalSlide,
	        trackStyle: getTrackAnimateCSS(_objectSpread(_objectSpread({}, spec), {}, {
	          left: animationLeft
	        })),
	        lazyLoadedList: lazyLoadedList,
	        targetSlide: targetSlide
	      };
	      nextState = {
	        animating: false,
	        currentSlide: finalSlide,
	        trackStyle: getTrackCSS(_objectSpread(_objectSpread({}, spec), {}, {
	          left: finalLeft
	        })),
	        swipeLeft: null,
	        targetSlide: targetSlide
	      };
	    }
	  }
	
	  return {
	    state: state,
	    nextState: nextState
	  };
	};
	
	exports.slideHandler = slideHandler;
	
	var changeSlide = function changeSlide(spec, options) {
	  var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
	  var slidesToScroll = spec.slidesToScroll,
	      slidesToShow = spec.slidesToShow,
	      slideCount = spec.slideCount,
	      currentSlide = spec.currentSlide,
	      previousTargetSlide = spec.targetSlide,
	      lazyLoad = spec.lazyLoad,
	      infinite = spec.infinite;
	  unevenOffset = slideCount % slidesToScroll !== 0;
	  indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;
	
	  if (options.message === "previous") {
	    slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
	    targetSlide = currentSlide - slideOffset;
	
	    if (lazyLoad && !infinite) {
	      previousInt = currentSlide - slideOffset;
	      targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
	    }
	
	    if (!infinite) {
	      targetSlide = previousTargetSlide - slidesToScroll;
	    }
	  } else if (options.message === "next") {
	    slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
	    targetSlide = currentSlide + slideOffset;
	
	    if (lazyLoad && !infinite) {
	      targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
	    }
	
	    if (!infinite) {
	      targetSlide = previousTargetSlide + slidesToScroll;
	    }
	  } else if (options.message === "dots") {
	    // Click on dots
	    targetSlide = options.index * options.slidesToScroll;
	  } else if (options.message === "children") {
	    // Click on the slides
	    targetSlide = options.index;
	
	    if (infinite) {
	      var direction = siblingDirection(_objectSpread(_objectSpread({}, spec), {}, {
	        targetSlide: targetSlide
	      }));
	
	      if (targetSlide > options.currentSlide && direction === "left") {
	        targetSlide = targetSlide - slideCount;
	      } else if (targetSlide < options.currentSlide && direction === "right") {
	        targetSlide = targetSlide + slideCount;
	      }
	    }
	  } else if (options.message === "index") {
	    targetSlide = Number(options.index);
	  }
	
	  return targetSlide;
	};
	
	exports.changeSlide = changeSlide;
	
	var keyHandler = function keyHandler(e, accessibility, rtl) {
	  if (e.target.tagName.match("TEXTAREA|INPUT|SELECT") || !accessibility) return "";
	  if (e.keyCode === 37) return rtl ? "next" : "previous";
	  if (e.keyCode === 39) return rtl ? "previous" : "next";
	  return "";
	};
	
	exports.keyHandler = keyHandler;
	
	var swipeStart = function swipeStart(e, swipe, draggable) {
	  e.target.tagName === "IMG" && e.preventDefault();
	  if (!swipe || !draggable && e.type.indexOf("mouse") !== -1) return "";
	  return {
	    dragging: true,
	    touchObject: {
	      startX: e.touches ? e.touches[0].pageX : e.clientX,
	      startY: e.touches ? e.touches[0].pageY : e.clientY,
	      curX: e.touches ? e.touches[0].pageX : e.clientX,
	      curY: e.touches ? e.touches[0].pageY : e.clientY
	    }
	  };
	};
	
	exports.swipeStart = swipeStart;
	
	var swipeMove = function swipeMove(e, spec) {
	  // spec also contains, trackRef and slideIndex
	  var scrolling = spec.scrolling,
	      animating = spec.animating,
	      vertical = spec.vertical,
	      swipeToSlide = spec.swipeToSlide,
	      verticalSwiping = spec.verticalSwiping,
	      rtl = spec.rtl,
	      currentSlide = spec.currentSlide,
	      edgeFriction = spec.edgeFriction,
	      edgeDragged = spec.edgeDragged,
	      onEdge = spec.onEdge,
	      swiped = spec.swiped,
	      swiping = spec.swiping,
	      slideCount = spec.slideCount,
	      slidesToScroll = spec.slidesToScroll,
	      infinite = spec.infinite,
	      touchObject = spec.touchObject,
	      swipeEvent = spec.swipeEvent,
	      listHeight = spec.listHeight,
	      listWidth = spec.listWidth;
	  if (scrolling) return;
	  if (animating) return e.preventDefault();
	  if (vertical && swipeToSlide && verticalSwiping) e.preventDefault();
	  var swipeLeft,
	      state = {};
	  var curLeft = getTrackLeft(spec);
	  touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
	  touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
	  touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
	  var verticalSwipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));
	
	  if (!verticalSwiping && !swiping && verticalSwipeLength > 10) {
	    return {
	      scrolling: true
	    };
	  }
	
	  if (verticalSwiping) touchObject.swipeLength = verticalSwipeLength;
	  var positionOffset = (!rtl ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);
	  if (verticalSwiping) positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;
	  var dotCount = Math.ceil(slideCount / slidesToScroll);
	  var swipeDirection = getSwipeDirection(spec.touchObject, verticalSwiping);
	  var touchSwipeLength = touchObject.swipeLength;
	
	  if (!infinite) {
	    if (currentSlide === 0 && swipeDirection === "right" || currentSlide + 1 >= dotCount && swipeDirection === "left" || !canGoNext(spec) && swipeDirection === "left") {
	      touchSwipeLength = touchObject.swipeLength * edgeFriction;
	
	      if (edgeDragged === false && onEdge) {
	        onEdge(swipeDirection);
	        state["edgeDragged"] = true;
	      }
	    }
	  }
	
	  if (!swiped && swipeEvent) {
	    swipeEvent(swipeDirection);
	    state["swiped"] = true;
	  }
	
	  if (!vertical) {
	    if (!rtl) {
	      swipeLeft = curLeft + touchSwipeLength * positionOffset;
	    } else {
	      swipeLeft = curLeft - touchSwipeLength * positionOffset;
	    }
	  } else {
	    swipeLeft = curLeft + touchSwipeLength * (listHeight / listWidth) * positionOffset;
	  }
	
	  if (verticalSwiping) {
	    swipeLeft = curLeft + touchSwipeLength * positionOffset;
	  }
	
	  state = _objectSpread(_objectSpread({}, state), {}, {
	    touchObject: touchObject,
	    swipeLeft: swipeLeft,
	    trackStyle: getTrackCSS(_objectSpread(_objectSpread({}, spec), {}, {
	      left: swipeLeft
	    }))
	  });
	
	  if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) {
	    return state;
	  }
	
	  if (touchObject.swipeLength > 10) {
	    state["swiping"] = true;
	    e.preventDefault();
	  }
	
	  return state;
	};
	
	exports.swipeMove = swipeMove;
	
	var swipeEnd = function swipeEnd(e, spec) {
	  var dragging = spec.dragging,
	      swipe = spec.swipe,
	      touchObject = spec.touchObject,
	      listWidth = spec.listWidth,
	      touchThreshold = spec.touchThreshold,
	      verticalSwiping = spec.verticalSwiping,
	      listHeight = spec.listHeight,
	      swipeToSlide = spec.swipeToSlide,
	      scrolling = spec.scrolling,
	      onSwipe = spec.onSwipe,
	      targetSlide = spec.targetSlide,
	      currentSlide = spec.currentSlide,
	      infinite = spec.infinite;
	
	  if (!dragging) {
	    if (swipe) e.preventDefault();
	    return {};
	  }
	
	  var minSwipe = verticalSwiping ? listHeight / touchThreshold : listWidth / touchThreshold;
	  var swipeDirection = getSwipeDirection(touchObject, verticalSwiping); // reset the state of touch related state variables.
	
	  var state = {
	    dragging: false,
	    edgeDragged: false,
	    scrolling: false,
	    swiping: false,
	    swiped: false,
	    swipeLeft: null,
	    touchObject: {}
	  };
	
	  if (scrolling) {
	    return state;
	  }
	
	  if (!touchObject.swipeLength) {
	    return state;
	  }
	
	  if (touchObject.swipeLength > minSwipe) {
	    e.preventDefault();
	
	    if (onSwipe) {
	      onSwipe(swipeDirection);
	    }
	
	    var slideCount, newSlide;
	    var activeSlide = infinite ? currentSlide : targetSlide;
	
	    switch (swipeDirection) {
	      case "left":
	      case "up":
	        newSlide = activeSlide + getSlideCount(spec);
	        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
	        state["currentDirection"] = 0;
	        break;
	
	      case "right":
	      case "down":
	        newSlide = activeSlide - getSlideCount(spec);
	        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
	        state["currentDirection"] = 1;
	        break;
	
	      default:
	        slideCount = activeSlide;
	    }
	
	    state["triggerSlideHandler"] = slideCount;
	  } else {
	    // Adjust the track back to it's original position.
	    var currentLeft = getTrackLeft(spec);
	    state["trackStyle"] = getTrackAnimateCSS(_objectSpread(_objectSpread({}, spec), {}, {
	      left: currentLeft
	    }));
	  }
	
	  return state;
	};
	
	exports.swipeEnd = swipeEnd;
	
	var getNavigableIndexes = function getNavigableIndexes(spec) {
	  var max = spec.infinite ? spec.slideCount * 2 : spec.slideCount;
	  var breakpoint = spec.infinite ? spec.slidesToShow * -1 : 0;
	  var counter = spec.infinite ? spec.slidesToShow * -1 : 0;
	  var indexes = [];
	
	  while (breakpoint < max) {
	    indexes.push(breakpoint);
	    breakpoint = counter + spec.slidesToScroll;
	    counter += Math.min(spec.slidesToScroll, spec.slidesToShow);
	  }
	
	  return indexes;
	};
	
	exports.getNavigableIndexes = getNavigableIndexes;
	
	var checkNavigable = function checkNavigable(spec, index) {
	  var navigables = getNavigableIndexes(spec);
	  var prevNavigable = 0;
	
	  if (index > navigables[navigables.length - 1]) {
	    index = navigables[navigables.length - 1];
	  } else {
	    for (var n in navigables) {
	      if (index < navigables[n]) {
	        index = prevNavigable;
	        break;
	      }
	
	      prevNavigable = navigables[n];
	    }
	  }
	
	  return index;
	};
	
	exports.checkNavigable = checkNavigable;
	
	var getSlideCount = function getSlideCount(spec) {
	  var centerOffset = spec.centerMode ? spec.slideWidth * Math.floor(spec.slidesToShow / 2) : 0;
	
	  if (spec.swipeToSlide) {
	    var swipedSlide;
	    var slickList = spec.listRef;
	    var slides = slickList.querySelectorAll && slickList.querySelectorAll(".slick-slide") || [];
	    Array.from(slides).every(function (slide) {
	      if (!spec.vertical) {
	        if (slide.offsetLeft - centerOffset + getWidth(slide) / 2 > spec.swipeLeft * -1) {
	          swipedSlide = slide;
	          return false;
	        }
	      } else {
	        if (slide.offsetTop + getHeight(slide) / 2 > spec.swipeLeft * -1) {
	          swipedSlide = slide;
	          return false;
	        }
	      }
	
	      return true;
	    });
	
	    if (!swipedSlide) {
	      return 0;
	    }
	
	    var currentIndex = spec.rtl === true ? spec.slideCount - spec.currentSlide : spec.currentSlide;
	    var slidesTraversed = Math.abs(swipedSlide.dataset.index - currentIndex) || 1;
	    return slidesTraversed;
	  } else {
	    return spec.slidesToScroll;
	  }
	};
	
	exports.getSlideCount = getSlideCount;
	
	var checkSpecKeys = function checkSpecKeys(spec, keysArray) {
	  return keysArray.reduce(function (value, key) {
	    return value && spec.hasOwnProperty(key);
	  }, true) ? null : console.error("Keys Missing:", spec);
	};
	
	exports.checkSpecKeys = checkSpecKeys;
	
	var getTrackCSS = function getTrackCSS(spec) {
	  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth"]);
	  var trackWidth, trackHeight;
	  var trackChildren = spec.slideCount + 2 * spec.slidesToShow;
	
	  if (!spec.vertical) {
	    trackWidth = getTotalSlides(spec) * spec.slideWidth;
	  } else {
	    trackHeight = trackChildren * spec.slideHeight;
	  }
	
	  var style = {
	    opacity: 1,
	    transition: "",
	    WebkitTransition: ""
	  };
	
	  if (spec.useTransform) {
	    var WebkitTransform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
	    var transform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
	    var msTransform = !spec.vertical ? "translateX(" + spec.left + "px)" : "translateY(" + spec.left + "px)";
	    style = _objectSpread(_objectSpread({}, style), {}, {
	      WebkitTransform: WebkitTransform,
	      transform: transform,
	      msTransform: msTransform
	    });
	  } else {
	    if (spec.vertical) {
	      style["top"] = spec.left;
	    } else {
	      style["left"] = spec.left;
	    }
	  }
	
	  if (spec.fade) style = {
	    opacity: 1
	  };
	  if (trackWidth) style.width = trackWidth;
	  if (trackHeight) style.height = trackHeight; // Fallback for IE8
	
	  if (window && !window.addEventListener && window.attachEvent) {
	    if (!spec.vertical) {
	      style.marginLeft = spec.left + "px";
	    } else {
	      style.marginTop = spec.left + "px";
	    }
	  }
	
	  return style;
	};
	
	exports.getTrackCSS = getTrackCSS;
	
	var getTrackAnimateCSS = function getTrackAnimateCSS(spec) {
	  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth", "speed", "cssEase"]);
	  var style = getTrackCSS(spec); // useCSS is true by default so it can be undefined
	
	  if (spec.useTransform) {
	    style.WebkitTransition = "-webkit-transform " + spec.speed + "ms " + spec.cssEase;
	    style.transition = "transform " + spec.speed + "ms " + spec.cssEase;
	  } else {
	    if (spec.vertical) {
	      style.transition = "top " + spec.speed + "ms " + spec.cssEase;
	    } else {
	      style.transition = "left " + spec.speed + "ms " + spec.cssEase;
	    }
	  }
	
	  return style;
	};
	
	exports.getTrackAnimateCSS = getTrackAnimateCSS;
	
	var getTrackLeft = function getTrackLeft(spec) {
	  if (spec.unslick) {
	    return 0;
	  }
	
	  checkSpecKeys(spec, ["slideIndex", "trackRef", "infinite", "centerMode", "slideCount", "slidesToShow", "slidesToScroll", "slideWidth", "listWidth", "variableWidth", "slideHeight"]);
	  var slideIndex = spec.slideIndex,
	      trackRef = spec.trackRef,
	      infinite = spec.infinite,
	      centerMode = spec.centerMode,
	      slideCount = spec.slideCount,
	      slidesToShow = spec.slidesToShow,
	      slidesToScroll = spec.slidesToScroll,
	      slideWidth = spec.slideWidth,
	      listWidth = spec.listWidth,
	      variableWidth = spec.variableWidth,
	      slideHeight = spec.slideHeight,
	      fade = spec.fade,
	      vertical = spec.vertical;
	  var slideOffset = 0;
	  var targetLeft;
	  var targetSlide;
	  var verticalOffset = 0;
	
	  if (fade || spec.slideCount === 1) {
	    return 0;
	  }
	
	  var slidesToOffset = 0;
	
	  if (infinite) {
	    slidesToOffset = -getPreClones(spec); // bring active slide to the beginning of visual area
	    // if next scroll doesn't have enough children, just reach till the end of original slides instead of shifting slidesToScroll children
	
	    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
	      slidesToOffset = -(slideIndex > slideCount ? slidesToShow - (slideIndex - slideCount) : slideCount % slidesToScroll);
	    } // shift current slide to center of the frame
	
	
	    if (centerMode) {
	      slidesToOffset += parseInt(slidesToShow / 2);
	    }
	  } else {
	    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
	      slidesToOffset = slidesToShow - slideCount % slidesToScroll;
	    }
	
	    if (centerMode) {
	      slidesToOffset = parseInt(slidesToShow / 2);
	    }
	  }
	
	  slideOffset = slidesToOffset * slideWidth;
	  verticalOffset = slidesToOffset * slideHeight;
	
	  if (!vertical) {
	    targetLeft = slideIndex * slideWidth * -1 + slideOffset;
	  } else {
	    targetLeft = slideIndex * slideHeight * -1 + verticalOffset;
	  }
	
	  if (variableWidth === true) {
	    var targetSlideIndex;
	    var trackElem = trackRef && trackRef.node;
	    targetSlideIndex = slideIndex + getPreClones(spec);
	    targetSlide = trackElem && trackElem.childNodes[targetSlideIndex];
	    targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;
	
	    if (centerMode === true) {
	      targetSlideIndex = infinite ? slideIndex + getPreClones(spec) : slideIndex;
	      targetSlide = trackElem && trackElem.children[targetSlideIndex];
	      targetLeft = 0;
	
	      for (var slide = 0; slide < targetSlideIndex; slide++) {
	        targetLeft -= trackElem && trackElem.children[slide] && trackElem.children[slide].offsetWidth;
	      }
	
	      targetLeft -= parseInt(spec.centerPadding);
	      targetLeft += targetSlide && (listWidth - targetSlide.offsetWidth) / 2;
	    }
	  }
	
	  return targetLeft;
	};
	
	exports.getTrackLeft = getTrackLeft;
	
	var getPreClones = function getPreClones(spec) {
	  if (spec.unslick || !spec.infinite) {
	    return 0;
	  }
	
	  if (spec.variableWidth) {
	    return spec.slideCount;
	  }
	
	  return spec.slidesToShow + (spec.centerMode ? 1 : 0);
	};
	
	exports.getPreClones = getPreClones;
	
	var getPostClones = function getPostClones(spec) {
	  if (spec.unslick || !spec.infinite) {
	    return 0;
	  }
	
	  return spec.slideCount;
	};
	
	exports.getPostClones = getPostClones;
	
	var getTotalSlides = function getTotalSlides(spec) {
	  return spec.slideCount === 1 ? 1 : getPreClones(spec) + spec.slideCount + getPostClones(spec);
	};
	
	exports.getTotalSlides = getTotalSlides;
	
	var siblingDirection = function siblingDirection(spec) {
	  if (spec.targetSlide > spec.currentSlide) {
	    if (spec.targetSlide > spec.currentSlide + slidesOnRight(spec)) {
	      return "left";
	    }
	
	    return "right";
	  } else {
	    if (spec.targetSlide < spec.currentSlide - slidesOnLeft(spec)) {
	      return "right";
	    }
	
	    return "left";
	  }
	};
	
	exports.siblingDirection = siblingDirection;
	
	var slidesOnRight = function slidesOnRight(_ref) {
	  var slidesToShow = _ref.slidesToShow,
	      centerMode = _ref.centerMode,
	      rtl = _ref.rtl,
	      centerPadding = _ref.centerPadding;
	
	  // returns no of slides on the right of active slide
	  if (centerMode) {
	    var right = (slidesToShow - 1) / 2 + 1;
	    if (parseInt(centerPadding) > 0) right += 1;
	    if (rtl && slidesToShow % 2 === 0) right += 1;
	    return right;
	  }
	
	  if (rtl) {
	    return 0;
	  }
	
	  return slidesToShow - 1;
	};
	
	exports.slidesOnRight = slidesOnRight;
	
	var slidesOnLeft = function slidesOnLeft(_ref2) {
	  var slidesToShow = _ref2.slidesToShow,
	      centerMode = _ref2.centerMode,
	      rtl = _ref2.rtl,
	      centerPadding = _ref2.centerPadding;
	
	  // returns no of slides on the left of active slide
	  if (centerMode) {
	    var left = (slidesToShow - 1) / 2 + 1;
	    if (parseInt(centerPadding) > 0) left += 1;
	    if (!rtl && slidesToShow % 2 === 0) left += 1;
	    return left;
	  }
	
	  if (rtl) {
	    return slidesToShow - 1;
	  }
	
	  return 0;
	};
	
	exports.slidesOnLeft = slidesOnLeft;
	
	var canUseDOM = function canUseDOM() {
	  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
	};
	
	exports.canUseDOM = canUseDOM;

/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.DropdownContext = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	/**
	 * DropdownContext
	 * {
	 *  toggle: PropTypes.func.isRequired,
	 *  isOpen: PropTypes.bool.isRequired,
	 *  direction: PropTypes.oneOf(['up', 'down', 'left', 'right']).isRequired,
	 *  inNavbar: PropTypes.bool.isRequired,
	 *  disabled: PropTypes.bool
	 * }
	 */
	var DropdownContext = _react.default.createContext({});
	
	exports.DropdownContext = DropdownContext;

/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(13));
	
	var _objectSpread4 = _interopRequireDefault(__webpack_require__(47));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _reactTransitionGroup = __webpack_require__(303);
	
	var _utils = __webpack_require__(11);
	
	var propTypes = (0, _objectSpread4.default)({}, _reactTransitionGroup.Transition.propTypes, {
	  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]),
	  tag: _utils.tagPropType,
	  baseClass: _propTypes.default.string,
	  baseClassActive: _propTypes.default.string,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  innerRef: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string, _propTypes.default.func])
	});
	var defaultProps = (0, _objectSpread4.default)({}, _reactTransitionGroup.Transition.defaultProps, {
	  tag: 'div',
	  baseClass: 'fade',
	  baseClassActive: 'show',
	  timeout: _utils.TransitionTimeouts.Fade,
	  appear: true,
	  enter: true,
	  exit: true,
	  in: true
	});
	
	function Fade(props) {
	  var Tag = props.tag,
	      baseClass = props.baseClass,
	      baseClassActive = props.baseClassActive,
	      className = props.className,
	      cssModule = props.cssModule,
	      children = props.children,
	      innerRef = props.innerRef,
	      otherProps = (0, _objectWithoutPropertiesLoose2.default)(props, ["tag", "baseClass", "baseClassActive", "className", "cssModule", "children", "innerRef"]);
	  var transitionProps = (0, _utils.pick)(otherProps, _utils.TransitionPropTypeKeys);
	  var childProps = (0, _utils.omit)(otherProps, _utils.TransitionPropTypeKeys);
	  return _react.default.createElement(_reactTransitionGroup.Transition, transitionProps, function (status) {
	    var isActive = status === 'entered';
	    var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, baseClass, isActive && baseClassActive), cssModule);
	    return _react.default.createElement(Tag, (0, _extends2.default)({
	      className: classes
	    }, childProps, {
	      ref: innerRef
	    }), children);
	  });
	}
	
	Fade.propTypes = propTypes;
	Fade.defaultProps = defaultProps;
	var _default = Fade;
	exports.default = _default;

/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(setImmediate, clearImmediate) {!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define([],e):"object"==typeof exports?exports.swal=e():t.swal=e()}(this,function(){return function(t){function e(o){if(n[o])return n[o].exports;var r=n[o]={i:o,l:!1,exports:{}};return t[o].call(r.exports,r,r.exports,e),r.l=!0,r.exports}var n={};return e.m=t,e.c=n,e.d=function(t,n,o){e.o(t,n)||Object.defineProperty(t,n,{configurable:!1,enumerable:!0,get:o})},e.n=function(t){var n=t&&t.__esModule?function(){return t.default}:function(){return t};return e.d(n,"a",n),n},e.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},e.p="",e(e.s=8)}([function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o="swal-button";e.CLASS_NAMES={MODAL:"swal-modal",OVERLAY:"swal-overlay",SHOW_MODAL:"swal-overlay--show-modal",MODAL_TITLE:"swal-title",MODAL_TEXT:"swal-text",ICON:"swal-icon",ICON_CUSTOM:"swal-icon--custom",CONTENT:"swal-content",FOOTER:"swal-footer",BUTTON_CONTAINER:"swal-button-container",BUTTON:o,CONFIRM_BUTTON:o+"--confirm",CANCEL_BUTTON:o+"--cancel",DANGER_BUTTON:o+"--danger",BUTTON_LOADING:o+"--loading",BUTTON_LOADER:o+"__loader"},e.default=e.CLASS_NAMES},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.getNode=function(t){var e="."+t;return document.querySelector(e)},e.stringToNode=function(t){var e=document.createElement("div");return e.innerHTML=t.trim(),e.firstChild},e.insertAfter=function(t,e){var n=e.nextSibling;e.parentNode.insertBefore(t,n)},e.removeNode=function(t){t.parentElement.removeChild(t)},e.throwErr=function(t){throw t=t.replace(/ +(?= )/g,""),"SweetAlert: "+(t=t.trim())},e.isPlainObject=function(t){if("[object Object]"!==Object.prototype.toString.call(t))return!1;var e=Object.getPrototypeOf(t);return null===e||e===Object.prototype},e.ordinalSuffixOf=function(t){var e=t%10,n=t%100;return 1===e&&11!==n?t+"st":2===e&&12!==n?t+"nd":3===e&&13!==n?t+"rd":t+"th"}},function(t,e,n){"use strict";function o(t){for(var n in t)e.hasOwnProperty(n)||(e[n]=t[n])}Object.defineProperty(e,"__esModule",{value:!0}),o(n(25));var r=n(26);e.overlayMarkup=r.default,o(n(27)),o(n(28)),o(n(29));var i=n(0),a=i.default.MODAL_TITLE,s=i.default.MODAL_TEXT,c=i.default.ICON,l=i.default.FOOTER;e.iconMarkup='\n  <div class="'+c+'"></div>',e.titleMarkup='\n  <div class="'+a+'"></div>\n',e.textMarkup='\n  <div class="'+s+'"></div>',e.footerMarkup='\n  <div class="'+l+'"></div>\n'},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(1);e.CONFIRM_KEY="confirm",e.CANCEL_KEY="cancel";var r={visible:!0,text:null,value:null,className:"",closeModal:!0},i=Object.assign({},r,{visible:!1,text:"Cancel",value:null}),a=Object.assign({},r,{text:"OK",value:!0});e.defaultButtonList={cancel:i,confirm:a};var s=function(t){switch(t){case e.CONFIRM_KEY:return a;case e.CANCEL_KEY:return i;default:var n=t.charAt(0).toUpperCase()+t.slice(1);return Object.assign({},r,{text:n,value:t})}},c=function(t,e){var n=s(t);return!0===e?Object.assign({},n,{visible:!0}):"string"==typeof e?Object.assign({},n,{visible:!0,text:e}):o.isPlainObject(e)?Object.assign({visible:!0},n,e):Object.assign({},n,{visible:!1})},l=function(t){for(var e={},n=0,o=Object.keys(t);n<o.length;n++){var r=o[n],a=t[r],s=c(r,a);e[r]=s}return e.cancel||(e.cancel=i),e},u=function(t){var n={};switch(t.length){case 1:n[e.CANCEL_KEY]=Object.assign({},i,{visible:!1});break;case 2:n[e.CANCEL_KEY]=c(e.CANCEL_KEY,t[0]),n[e.CONFIRM_KEY]=c(e.CONFIRM_KEY,t[1]);break;default:o.throwErr("Invalid number of 'buttons' in array ("+t.length+").\n      If you want more than 2 buttons, you need to use an object!")}return n};e.getButtonListOpts=function(t){var n=e.defaultButtonList;return"string"==typeof t?n[e.CONFIRM_KEY]=c(e.CONFIRM_KEY,t):Array.isArray(t)?n=u(t):o.isPlainObject(t)?n=l(t):!0===t?n=u([!0,!0]):!1===t?n=u([!1,!1]):void 0===t&&(n=e.defaultButtonList),n}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(1),r=n(2),i=n(0),a=i.default.MODAL,s=i.default.OVERLAY,c=n(30),l=n(31),u=n(32),f=n(33);e.injectElIntoModal=function(t){var e=o.getNode(a),n=o.stringToNode(t);return e.appendChild(n),n};var d=function(t){t.className=a,t.textContent=""},p=function(t,e){d(t);var n=e.className;n&&t.classList.add(n)};e.initModalContent=function(t){var e=o.getNode(a);p(e,t),c.default(t.icon),l.initTitle(t.title),l.initText(t.text),f.default(t.content),u.default(t.buttons,t.dangerMode)};var m=function(){var t=o.getNode(s),e=o.stringToNode(r.modalMarkup);t.appendChild(e)};e.default=m},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(3),r={isOpen:!1,promise:null,actions:{},timer:null},i=Object.assign({},r);e.resetState=function(){i=Object.assign({},r)},e.setActionValue=function(t){if("string"==typeof t)return a(o.CONFIRM_KEY,t);for(var e in t)a(e,t[e])};var a=function(t,e){i.actions[t]||(i.actions[t]={}),Object.assign(i.actions[t],{value:e})};e.setActionOptionsFor=function(t,e){var n=(void 0===e?{}:e).closeModal,o=void 0===n||n;Object.assign(i.actions[t],{closeModal:o})},e.default=i},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(1),r=n(3),i=n(0),a=i.default.OVERLAY,s=i.default.SHOW_MODAL,c=i.default.BUTTON,l=i.default.BUTTON_LOADING,u=n(5);e.openModal=function(){o.getNode(a).classList.add(s),u.default.isOpen=!0};var f=function(){o.getNode(a).classList.remove(s),u.default.isOpen=!1};e.onAction=function(t){void 0===t&&(t=r.CANCEL_KEY);var e=u.default.actions[t],n=e.value;if(!1===e.closeModal){var i=c+"--"+t;o.getNode(i).classList.add(l)}else f();u.default.promise.resolve(n)},e.getState=function(){var t=Object.assign({},u.default);return delete t.promise,delete t.timer,t},e.stopLoading=function(){for(var t=document.querySelectorAll("."+c),e=0;e<t.length;e++){t[e].classList.remove(l)}}},function(t,e){var n;n=function(){return this}();try{n=n||Function("return this")()||(0,eval)("this")}catch(t){"object"==typeof window&&(n=window)}t.exports=n},function(t,e,n){(function(e){t.exports=e.sweetAlert=n(9)}).call(e,n(7))},function(t,e,n){(function(e){t.exports=e.swal=n(10)}).call(e,n(7))},function(t,e,n){"undefined"!=typeof window&&n(11),n(16);var o=n(23).default;t.exports=o},function(t,e,n){var o=n(12);"string"==typeof o&&(o=[[t.i,o,""]]);var r={insertAt:"top"};r.transform=void 0;n(14)(o,r);o.locals&&(t.exports=o.locals)},function(t,e,n){e=t.exports=n(13)(void 0),e.push([t.i,'.swal-icon--error{border-color:#f27474;-webkit-animation:animateErrorIcon .5s;animation:animateErrorIcon .5s}.swal-icon--error__x-mark{position:relative;display:block;-webkit-animation:animateXMark .5s;animation:animateXMark .5s}.swal-icon--error__line{position:absolute;height:5px;width:47px;background-color:#f27474;display:block;top:37px;border-radius:2px}.swal-icon--error__line--left{-webkit-transform:rotate(45deg);transform:rotate(45deg);left:17px}.swal-icon--error__line--right{-webkit-transform:rotate(-45deg);transform:rotate(-45deg);right:16px}@-webkit-keyframes animateErrorIcon{0%{-webkit-transform:rotateX(100deg);transform:rotateX(100deg);opacity:0}to{-webkit-transform:rotateX(0deg);transform:rotateX(0deg);opacity:1}}@keyframes animateErrorIcon{0%{-webkit-transform:rotateX(100deg);transform:rotateX(100deg);opacity:0}to{-webkit-transform:rotateX(0deg);transform:rotateX(0deg);opacity:1}}@-webkit-keyframes animateXMark{0%{-webkit-transform:scale(.4);transform:scale(.4);margin-top:26px;opacity:0}50%{-webkit-transform:scale(.4);transform:scale(.4);margin-top:26px;opacity:0}80%{-webkit-transform:scale(1.15);transform:scale(1.15);margin-top:-6px}to{-webkit-transform:scale(1);transform:scale(1);margin-top:0;opacity:1}}@keyframes animateXMark{0%{-webkit-transform:scale(.4);transform:scale(.4);margin-top:26px;opacity:0}50%{-webkit-transform:scale(.4);transform:scale(.4);margin-top:26px;opacity:0}80%{-webkit-transform:scale(1.15);transform:scale(1.15);margin-top:-6px}to{-webkit-transform:scale(1);transform:scale(1);margin-top:0;opacity:1}}.swal-icon--warning{border-color:#f8bb86;-webkit-animation:pulseWarning .75s infinite alternate;animation:pulseWarning .75s infinite alternate}.swal-icon--warning__body{width:5px;height:47px;top:10px;border-radius:2px;margin-left:-2px}.swal-icon--warning__body,.swal-icon--warning__dot{position:absolute;left:50%;background-color:#f8bb86}.swal-icon--warning__dot{width:7px;height:7px;border-radius:50%;margin-left:-4px;bottom:-11px}@-webkit-keyframes pulseWarning{0%{border-color:#f8d486}to{border-color:#f8bb86}}@keyframes pulseWarning{0%{border-color:#f8d486}to{border-color:#f8bb86}}.swal-icon--success{border-color:#a5dc86}.swal-icon--success:after,.swal-icon--success:before{content:"";border-radius:50%;position:absolute;width:60px;height:120px;background:#fff;-webkit-transform:rotate(45deg);transform:rotate(45deg)}.swal-icon--success:before{border-radius:120px 0 0 120px;top:-7px;left:-33px;-webkit-transform:rotate(-45deg);transform:rotate(-45deg);-webkit-transform-origin:60px 60px;transform-origin:60px 60px}.swal-icon--success:after{border-radius:0 120px 120px 0;top:-11px;left:30px;-webkit-transform:rotate(-45deg);transform:rotate(-45deg);-webkit-transform-origin:0 60px;transform-origin:0 60px;-webkit-animation:rotatePlaceholder 4.25s ease-in;animation:rotatePlaceholder 4.25s ease-in}.swal-icon--success__ring{width:80px;height:80px;border:4px solid hsla(98,55%,69%,.2);border-radius:50%;box-sizing:content-box;position:absolute;left:-4px;top:-4px;z-index:2}.swal-icon--success__hide-corners{width:5px;height:90px;background-color:#fff;padding:1px;position:absolute;left:28px;top:8px;z-index:1;-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}.swal-icon--success__line{height:5px;background-color:#a5dc86;display:block;border-radius:2px;position:absolute;z-index:2}.swal-icon--success__line--tip{width:25px;left:14px;top:46px;-webkit-transform:rotate(45deg);transform:rotate(45deg);-webkit-animation:animateSuccessTip .75s;animation:animateSuccessTip .75s}.swal-icon--success__line--long{width:47px;right:8px;top:38px;-webkit-transform:rotate(-45deg);transform:rotate(-45deg);-webkit-animation:animateSuccessLong .75s;animation:animateSuccessLong .75s}@-webkit-keyframes rotatePlaceholder{0%{-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}5%{-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}12%{-webkit-transform:rotate(-405deg);transform:rotate(-405deg)}to{-webkit-transform:rotate(-405deg);transform:rotate(-405deg)}}@keyframes rotatePlaceholder{0%{-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}5%{-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}12%{-webkit-transform:rotate(-405deg);transform:rotate(-405deg)}to{-webkit-transform:rotate(-405deg);transform:rotate(-405deg)}}@-webkit-keyframes animateSuccessTip{0%{width:0;left:1px;top:19px}54%{width:0;left:1px;top:19px}70%{width:50px;left:-8px;top:37px}84%{width:17px;left:21px;top:48px}to{width:25px;left:14px;top:45px}}@keyframes animateSuccessTip{0%{width:0;left:1px;top:19px}54%{width:0;left:1px;top:19px}70%{width:50px;left:-8px;top:37px}84%{width:17px;left:21px;top:48px}to{width:25px;left:14px;top:45px}}@-webkit-keyframes animateSuccessLong{0%{width:0;right:46px;top:54px}65%{width:0;right:46px;top:54px}84%{width:55px;right:0;top:35px}to{width:47px;right:8px;top:38px}}@keyframes animateSuccessLong{0%{width:0;right:46px;top:54px}65%{width:0;right:46px;top:54px}84%{width:55px;right:0;top:35px}to{width:47px;right:8px;top:38px}}.swal-icon--info{border-color:#c9dae1}.swal-icon--info:before{width:5px;height:29px;bottom:17px;border-radius:2px;margin-left:-2px}.swal-icon--info:after,.swal-icon--info:before{content:"";position:absolute;left:50%;background-color:#c9dae1}.swal-icon--info:after{width:7px;height:7px;border-radius:50%;margin-left:-3px;top:19px}.swal-icon{width:80px;height:80px;border-width:4px;border-style:solid;border-radius:50%;padding:0;position:relative;box-sizing:content-box;margin:20px auto}.swal-icon:first-child{margin-top:32px}.swal-icon--custom{width:auto;height:auto;max-width:100%;border:none;border-radius:0}.swal-icon img{max-width:100%;max-height:100%}.swal-title{color:rgba(0,0,0,.65);font-weight:600;text-transform:none;position:relative;display:block;padding:13px 16px;font-size:27px;line-height:normal;text-align:center;margin-bottom:0}.swal-title:first-child{margin-top:26px}.swal-title:not(:first-child){padding-bottom:0}.swal-title:not(:last-child){margin-bottom:13px}.swal-text{font-size:16px;position:relative;float:none;line-height:normal;vertical-align:top;text-align:left;display:inline-block;margin:0;padding:0 10px;font-weight:400;color:rgba(0,0,0,.64);max-width:calc(100% - 20px);overflow-wrap:break-word;box-sizing:border-box}.swal-text:first-child{margin-top:45px}.swal-text:last-child{margin-bottom:45px}.swal-footer{text-align:right;padding-top:13px;margin-top:13px;padding:13px 16px;border-radius:inherit;border-top-left-radius:0;border-top-right-radius:0}.swal-button-container{margin:5px;display:inline-block;position:relative}.swal-button{background-color:#7cd1f9;color:#fff;border:none;box-shadow:none;border-radius:5px;font-weight:600;font-size:14px;padding:10px 24px;margin:0;cursor:pointer}.swal-button:not([disabled]):hover{background-color:#78cbf2}.swal-button:active{background-color:#70bce0}.swal-button:focus{outline:none;box-shadow:0 0 0 1px #fff,0 0 0 3px rgba(43,114,165,.29)}.swal-button[disabled]{opacity:.5;cursor:default}.swal-button::-moz-focus-inner{border:0}.swal-button--cancel{color:#555;background-color:#efefef}.swal-button--cancel:not([disabled]):hover{background-color:#e8e8e8}.swal-button--cancel:active{background-color:#d7d7d7}.swal-button--cancel:focus{box-shadow:0 0 0 1px #fff,0 0 0 3px rgba(116,136,150,.29)}.swal-button--danger{background-color:#e64942}.swal-button--danger:not([disabled]):hover{background-color:#df4740}.swal-button--danger:active{background-color:#cf423b}.swal-button--danger:focus{box-shadow:0 0 0 1px #fff,0 0 0 3px rgba(165,43,43,.29)}.swal-content{padding:0 20px;margin-top:20px;font-size:medium}.swal-content:last-child{margin-bottom:20px}.swal-content__input,.swal-content__textarea{-webkit-appearance:none;background-color:#fff;border:none;font-size:14px;display:block;box-sizing:border-box;width:100%;border:1px solid rgba(0,0,0,.14);padding:10px 13px;border-radius:2px;transition:border-color .2s}.swal-content__input:focus,.swal-content__textarea:focus{outline:none;border-color:#6db8ff}.swal-content__textarea{resize:vertical}.swal-button--loading{color:transparent}.swal-button--loading~.swal-button__loader{opacity:1}.swal-button__loader{position:absolute;height:auto;width:43px;z-index:2;left:50%;top:50%;-webkit-transform:translateX(-50%) translateY(-50%);transform:translateX(-50%) translateY(-50%);text-align:center;pointer-events:none;opacity:0}.swal-button__loader div{display:inline-block;float:none;vertical-align:baseline;width:9px;height:9px;padding:0;border:none;margin:2px;opacity:.4;border-radius:7px;background-color:hsla(0,0%,100%,.9);transition:background .2s;-webkit-animation:swal-loading-anim 1s infinite;animation:swal-loading-anim 1s infinite}.swal-button__loader div:nth-child(3n+2){-webkit-animation-delay:.15s;animation-delay:.15s}.swal-button__loader div:nth-child(3n+3){-webkit-animation-delay:.3s;animation-delay:.3s}@-webkit-keyframes swal-loading-anim{0%{opacity:.4}20%{opacity:.4}50%{opacity:1}to{opacity:.4}}@keyframes swal-loading-anim{0%{opacity:.4}20%{opacity:.4}50%{opacity:1}to{opacity:.4}}.swal-overlay{position:fixed;top:0;bottom:0;left:0;right:0;text-align:center;font-size:0;overflow-y:auto;background-color:rgba(0,0,0,.4);z-index:10000;pointer-events:none;opacity:0;transition:opacity .3s}.swal-overlay:before{content:" ";display:inline-block;vertical-align:middle;height:100%}.swal-overlay--show-modal{opacity:1;pointer-events:auto}.swal-overlay--show-modal .swal-modal{opacity:1;pointer-events:auto;box-sizing:border-box;-webkit-animation:showSweetAlert .3s;animation:showSweetAlert .3s;will-change:transform}.swal-modal{width:478px;opacity:0;pointer-events:none;background-color:#fff;text-align:center;border-radius:5px;position:static;margin:20px auto;display:inline-block;vertical-align:middle;-webkit-transform:scale(1);transform:scale(1);-webkit-transform-origin:50% 50%;transform-origin:50% 50%;z-index:10001;transition:opacity .2s,-webkit-transform .3s;transition:transform .3s,opacity .2s;transition:transform .3s,opacity .2s,-webkit-transform .3s}@media (max-width:500px){.swal-modal{width:calc(100% - 20px)}}@-webkit-keyframes showSweetAlert{0%{-webkit-transform:scale(1);transform:scale(1)}1%{-webkit-transform:scale(.5);transform:scale(.5)}45%{-webkit-transform:scale(1.05);transform:scale(1.05)}80%{-webkit-transform:scale(.95);transform:scale(.95)}to{-webkit-transform:scale(1);transform:scale(1)}}@keyframes showSweetAlert{0%{-webkit-transform:scale(1);transform:scale(1)}1%{-webkit-transform:scale(.5);transform:scale(.5)}45%{-webkit-transform:scale(1.05);transform:scale(1.05)}80%{-webkit-transform:scale(.95);transform:scale(.95)}to{-webkit-transform:scale(1);transform:scale(1)}}',""])},function(t,e){function n(t,e){var n=t[1]||"",r=t[3];if(!r)return n;if(e&&"function"==typeof btoa){var i=o(r);return[n].concat(r.sources.map(function(t){return"/*# sourceURL="+r.sourceRoot+t+" */"})).concat([i]).join("\n")}return[n].join("\n")}function o(t){return"/*# sourceMappingURL=data:application/json;charset=utf-8;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(t))))+" */"}t.exports=function(t){var e=[];return e.toString=function(){return this.map(function(e){var o=n(e,t);return e[2]?"@media "+e[2]+"{"+o+"}":o}).join("")},e.i=function(t,n){"string"==typeof t&&(t=[[null,t,""]]);for(var o={},r=0;r<this.length;r++){var i=this[r][0];"number"==typeof i&&(o[i]=!0)}for(r=0;r<t.length;r++){var a=t[r];"number"==typeof a[0]&&o[a[0]]||(n&&!a[2]?a[2]=n:n&&(a[2]="("+a[2]+") and ("+n+")"),e.push(a))}},e}},function(t,e,n){function o(t,e){for(var n=0;n<t.length;n++){var o=t[n],r=m[o.id];if(r){r.refs++;for(var i=0;i<r.parts.length;i++)r.parts[i](o.parts[i]);for(;i<o.parts.length;i++)r.parts.push(u(o.parts[i],e))}else{for(var a=[],i=0;i<o.parts.length;i++)a.push(u(o.parts[i],e));m[o.id]={id:o.id,refs:1,parts:a}}}}function r(t,e){for(var n=[],o={},r=0;r<t.length;r++){var i=t[r],a=e.base?i[0]+e.base:i[0],s=i[1],c=i[2],l=i[3],u={css:s,media:c,sourceMap:l};o[a]?o[a].parts.push(u):n.push(o[a]={id:a,parts:[u]})}return n}function i(t,e){var n=v(t.insertInto);if(!n)throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");var o=w[w.length-1];if("top"===t.insertAt)o?o.nextSibling?n.insertBefore(e,o.nextSibling):n.appendChild(e):n.insertBefore(e,n.firstChild),w.push(e);else{if("bottom"!==t.insertAt)throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");n.appendChild(e)}}function a(t){if(null===t.parentNode)return!1;t.parentNode.removeChild(t);var e=w.indexOf(t);e>=0&&w.splice(e,1)}function s(t){var e=document.createElement("style");return t.attrs.type="text/css",l(e,t.attrs),i(t,e),e}function c(t){var e=document.createElement("link");return t.attrs.type="text/css",t.attrs.rel="stylesheet",l(e,t.attrs),i(t,e),e}function l(t,e){Object.keys(e).forEach(function(n){t.setAttribute(n,e[n])})}function u(t,e){var n,o,r,i;if(e.transform&&t.css){if(!(i=e.transform(t.css)))return function(){};t.css=i}if(e.singleton){var l=h++;n=g||(g=s(e)),o=f.bind(null,n,l,!1),r=f.bind(null,n,l,!0)}else t.sourceMap&&"function"==typeof URL&&"function"==typeof URL.createObjectURL&&"function"==typeof URL.revokeObjectURL&&"function"==typeof Blob&&"function"==typeof btoa?(n=c(e),o=p.bind(null,n,e),r=function(){a(n),n.href&&URL.revokeObjectURL(n.href)}):(n=s(e),o=d.bind(null,n),r=function(){a(n)});return o(t),function(e){if(e){if(e.css===t.css&&e.media===t.media&&e.sourceMap===t.sourceMap)return;o(t=e)}else r()}}function f(t,e,n,o){var r=n?"":o.css;if(t.styleSheet)t.styleSheet.cssText=x(e,r);else{var i=document.createTextNode(r),a=t.childNodes;a[e]&&t.removeChild(a[e]),a.length?t.insertBefore(i,a[e]):t.appendChild(i)}}function d(t,e){var n=e.css,o=e.media;if(o&&t.setAttribute("media",o),t.styleSheet)t.styleSheet.cssText=n;else{for(;t.firstChild;)t.removeChild(t.firstChild);t.appendChild(document.createTextNode(n))}}function p(t,e,n){var o=n.css,r=n.sourceMap,i=void 0===e.convertToAbsoluteUrls&&r;(e.convertToAbsoluteUrls||i)&&(o=y(o)),r&&(o+="\n/*# sourceMappingURL=data:application/json;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(r))))+" */");var a=new Blob([o],{type:"text/css"}),s=t.href;t.href=URL.createObjectURL(a),s&&URL.revokeObjectURL(s)}var m={},b=function(t){var e;return function(){return void 0===e&&(e=t.apply(this,arguments)),e}}(function(){return window&&document&&document.all&&!window.atob}),v=function(t){var e={};return function(n){return void 0===e[n]&&(e[n]=t.call(this,n)),e[n]}}(function(t){return document.querySelector(t)}),g=null,h=0,w=[],y=n(15);t.exports=function(t,e){if(false)throw new Error("The style-loader cannot be used in a non-browser environment");e=e||{},e.attrs="object"==typeof e.attrs?e.attrs:{},e.singleton||(e.singleton=b()),e.insertInto||(e.insertInto="head"),e.insertAt||(e.insertAt="bottom");var n=r(t,e);return o(n,e),function(t){for(var i=[],a=0;a<n.length;a++){var s=n[a],c=m[s.id];c.refs--,i.push(c)}if(t){o(r(t,e),e)}for(var a=0;a<i.length;a++){var c=i[a];if(0===c.refs){for(var l=0;l<c.parts.length;l++)c.parts[l]();delete m[c.id]}}}};var x=function(){var t=[];return function(e,n){return t[e]=n,t.filter(Boolean).join("\n")}}()},function(t,e){t.exports=function(t){var e="undefined"!=typeof window&&window.location;if(!e)throw new Error("fixUrls requires window.location");if(!t||"string"!=typeof t)return t;var n=e.protocol+"//"+e.host,o=n+e.pathname.replace(/\/[^\/]*$/,"/");return t.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi,function(t,e){var r=e.trim().replace(/^"(.*)"$/,function(t,e){return e}).replace(/^'(.*)'$/,function(t,e){return e});if(/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(r))return t;var i;return i=0===r.indexOf("//")?r:0===r.indexOf("/")?n+r:o+r.replace(/^\.\//,""),"url("+JSON.stringify(i)+")"})}},function(t,e,n){var o=n(17);"undefined"==typeof window||window.Promise||(window.Promise=o),n(21),String.prototype.includes||(String.prototype.includes=function(t,e){"use strict";return"number"!=typeof e&&(e=0),!(e+t.length>this.length)&&-1!==this.indexOf(t,e)}),Array.prototype.includes||Object.defineProperty(Array.prototype,"includes",{value:function(t,e){if(null==this)throw new TypeError('"this" is null or not defined');var n=Object(this),o=n.length>>>0;if(0===o)return!1;for(var r=0|e,i=Math.max(r>=0?r:o-Math.abs(r),0);i<o;){if(function(t,e){return t===e||"number"==typeof t&&"number"==typeof e&&isNaN(t)&&isNaN(e)}(n[i],t))return!0;i++}return!1}}),"undefined"!=typeof window&&function(t){t.forEach(function(t){t.hasOwnProperty("remove")||Object.defineProperty(t,"remove",{configurable:!0,enumerable:!0,writable:!0,value:function(){this.parentNode.removeChild(this)}})})}([Element.prototype,CharacterData.prototype,DocumentType.prototype])},function(t,e,n){(function(e){!function(n){function o(){}function r(t,e){return function(){t.apply(e,arguments)}}function i(t){if("object"!=typeof this)throw new TypeError("Promises must be constructed via new");if("function"!=typeof t)throw new TypeError("not a function");this._state=0,this._handled=!1,this._value=void 0,this._deferreds=[],f(t,this)}function a(t,e){for(;3===t._state;)t=t._value;if(0===t._state)return void t._deferreds.push(e);t._handled=!0,i._immediateFn(function(){var n=1===t._state?e.onFulfilled:e.onRejected;if(null===n)return void(1===t._state?s:c)(e.promise,t._value);var o;try{o=n(t._value)}catch(t){return void c(e.promise,t)}s(e.promise,o)})}function s(t,e){try{if(e===t)throw new TypeError("A promise cannot be resolved with itself.");if(e&&("object"==typeof e||"function"==typeof e)){var n=e.then;if(e instanceof i)return t._state=3,t._value=e,void l(t);if("function"==typeof n)return void f(r(n,e),t)}t._state=1,t._value=e,l(t)}catch(e){c(t,e)}}function c(t,e){t._state=2,t._value=e,l(t)}function l(t){2===t._state&&0===t._deferreds.length&&i._immediateFn(function(){t._handled||i._unhandledRejectionFn(t._value)});for(var e=0,n=t._deferreds.length;e<n;e++)a(t,t._deferreds[e]);t._deferreds=null}function u(t,e,n){this.onFulfilled="function"==typeof t?t:null,this.onRejected="function"==typeof e?e:null,this.promise=n}function f(t,e){var n=!1;try{t(function(t){n||(n=!0,s(e,t))},function(t){n||(n=!0,c(e,t))})}catch(t){if(n)return;n=!0,c(e,t)}}var d=setTimeout;i.prototype.catch=function(t){return this.then(null,t)},i.prototype.then=function(t,e){var n=new this.constructor(o);return a(this,new u(t,e,n)),n},i.all=function(t){var e=Array.prototype.slice.call(t);return new i(function(t,n){function o(i,a){try{if(a&&("object"==typeof a||"function"==typeof a)){var s=a.then;if("function"==typeof s)return void s.call(a,function(t){o(i,t)},n)}e[i]=a,0==--r&&t(e)}catch(t){n(t)}}if(0===e.length)return t([]);for(var r=e.length,i=0;i<e.length;i++)o(i,e[i])})},i.resolve=function(t){return t&&"object"==typeof t&&t.constructor===i?t:new i(function(e){e(t)})},i.reject=function(t){return new i(function(e,n){n(t)})},i.race=function(t){return new i(function(e,n){for(var o=0,r=t.length;o<r;o++)t[o].then(e,n)})},i._immediateFn="function"==typeof e&&function(t){e(t)}||function(t){d(t,0)},i._unhandledRejectionFn=function(t){"undefined"!=typeof console&&console&&console.warn("Possible Unhandled Promise Rejection:",t)},i._setImmediateFn=function(t){i._immediateFn=t},i._setUnhandledRejectionFn=function(t){i._unhandledRejectionFn=t},void 0!==t&&t.exports?t.exports=i:n.Promise||(n.Promise=i)}(this)}).call(e,n(18).setImmediate)},function(t,e,n){function o(t,e){this._id=t,this._clearFn=e}var r=Function.prototype.apply;e.setTimeout=function(){return new o(r.call(setTimeout,window,arguments),clearTimeout)},e.setInterval=function(){return new o(r.call(setInterval,window,arguments),clearInterval)},e.clearTimeout=e.clearInterval=function(t){t&&t.close()},o.prototype.unref=o.prototype.ref=function(){},o.prototype.close=function(){this._clearFn.call(window,this._id)},e.enroll=function(t,e){clearTimeout(t._idleTimeoutId),t._idleTimeout=e},e.unenroll=function(t){clearTimeout(t._idleTimeoutId),t._idleTimeout=-1},e._unrefActive=e.active=function(t){clearTimeout(t._idleTimeoutId);var e=t._idleTimeout;e>=0&&(t._idleTimeoutId=setTimeout(function(){t._onTimeout&&t._onTimeout()},e))},n(19),e.setImmediate=setImmediate,e.clearImmediate=clearImmediate},function(t,e,n){(function(t,e){!function(t,n){"use strict";function o(t){"function"!=typeof t&&(t=new Function(""+t));for(var e=new Array(arguments.length-1),n=0;n<e.length;n++)e[n]=arguments[n+1];var o={callback:t,args:e};return l[c]=o,s(c),c++}function r(t){delete l[t]}function i(t){var e=t.callback,o=t.args;switch(o.length){case 0:e();break;case 1:e(o[0]);break;case 2:e(o[0],o[1]);break;case 3:e(o[0],o[1],o[2]);break;default:e.apply(n,o)}}function a(t){if(u)setTimeout(a,0,t);else{var e=l[t];if(e){u=!0;try{i(e)}finally{r(t),u=!1}}}}if(!t.setImmediate){var s,c=1,l={},u=!1,f=t.document,d=Object.getPrototypeOf&&Object.getPrototypeOf(t);d=d&&d.setTimeout?d:t,"[object process]"==={}.toString.call(t.process)?function(){s=function(t){e.nextTick(function(){a(t)})}}():function(){if(t.postMessage&&!t.importScripts){var e=!0,n=t.onmessage;return t.onmessage=function(){e=!1},t.postMessage("","*"),t.onmessage=n,e}}()?function(){var e="setImmediate$"+Math.random()+"$",n=function(n){n.source===t&&"string"==typeof n.data&&0===n.data.indexOf(e)&&a(+n.data.slice(e.length))};t.addEventListener?t.addEventListener("message",n,!1):t.attachEvent("onmessage",n),s=function(n){t.postMessage(e+n,"*")}}():t.MessageChannel?function(){var t=new MessageChannel;t.port1.onmessage=function(t){a(t.data)},s=function(e){t.port2.postMessage(e)}}():f&&"onreadystatechange"in f.createElement("script")?function(){var t=f.documentElement;s=function(e){var n=f.createElement("script");n.onreadystatechange=function(){a(e),n.onreadystatechange=null,t.removeChild(n),n=null},t.appendChild(n)}}():function(){s=function(t){setTimeout(a,0,t)}}(),d.setImmediate=o,d.clearImmediate=r}}("undefined"==typeof self?void 0===t?this:t:self)}).call(e,n(7),n(20))},function(t,e){function n(){throw new Error("setTimeout has not been defined")}function o(){throw new Error("clearTimeout has not been defined")}function r(t){if(u===setTimeout)return setTimeout(t,0);if((u===n||!u)&&setTimeout)return u=setTimeout,setTimeout(t,0);try{return u(t,0)}catch(e){try{return u.call(null,t,0)}catch(e){return u.call(this,t,0)}}}function i(t){if(f===clearTimeout)return clearTimeout(t);if((f===o||!f)&&clearTimeout)return f=clearTimeout,clearTimeout(t);try{return f(t)}catch(e){try{return f.call(null,t)}catch(e){return f.call(this,t)}}}function a(){b&&p&&(b=!1,p.length?m=p.concat(m):v=-1,m.length&&s())}function s(){if(!b){var t=r(a);b=!0;for(var e=m.length;e;){for(p=m,m=[];++v<e;)p&&p[v].run();v=-1,e=m.length}p=null,b=!1,i(t)}}function c(t,e){this.fun=t,this.array=e}function l(){}var u,f,d=t.exports={};!function(){try{u="function"==typeof setTimeout?setTimeout:n}catch(t){u=n}try{f="function"==typeof clearTimeout?clearTimeout:o}catch(t){f=o}}();var p,m=[],b=!1,v=-1;d.nextTick=function(t){var e=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)e[n-1]=arguments[n];m.push(new c(t,e)),1!==m.length||b||r(s)},c.prototype.run=function(){this.fun.apply(null,this.array)},d.title="browser",d.browser=!0,d.env={},d.argv=[],d.version="",d.versions={},d.on=l,d.addListener=l,d.once=l,d.off=l,d.removeListener=l,d.removeAllListeners=l,d.emit=l,d.prependListener=l,d.prependOnceListener=l,d.listeners=function(t){return[]},d.binding=function(t){throw new Error("process.binding is not supported")},d.cwd=function(){return"/"},d.chdir=function(t){throw new Error("process.chdir is not supported")},d.umask=function(){return 0}},function(t,e,n){"use strict";n(22).polyfill()},function(t,e,n){"use strict";function o(t,e){if(void 0===t||null===t)throw new TypeError("Cannot convert first argument to object");for(var n=Object(t),o=1;o<arguments.length;o++){var r=arguments[o];if(void 0!==r&&null!==r)for(var i=Object.keys(Object(r)),a=0,s=i.length;a<s;a++){var c=i[a],l=Object.getOwnPropertyDescriptor(r,c);void 0!==l&&l.enumerable&&(n[c]=r[c])}}return n}function r(){Object.assign||Object.defineProperty(Object,"assign",{enumerable:!1,configurable:!0,writable:!0,value:o})}t.exports={assign:o,polyfill:r}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(24),r=n(6),i=n(5),a=n(36),s=function(){for(var t=[],e=0;e<arguments.length;e++)t[e]=arguments[e];if("undefined"!=typeof window){var n=a.getOpts.apply(void 0,t);return new Promise(function(t,e){i.default.promise={resolve:t,reject:e},o.default(n),setTimeout(function(){r.openModal()})})}};s.close=r.onAction,s.getState=r.getState,s.setActionValue=i.setActionValue,s.stopLoading=r.stopLoading,s.setDefaults=a.setDefaults,e.default=s},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(1),r=n(0),i=r.default.MODAL,a=n(4),s=n(34),c=n(35),l=n(1);e.init=function(t){o.getNode(i)||(document.body||l.throwErr("You can only use SweetAlert AFTER the DOM has loaded!"),s.default(),a.default()),a.initModalContent(t),c.default(t)},e.default=e.init},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(0),r=o.default.MODAL;e.modalMarkup='\n  <div class="'+r+'" role="dialog" aria-modal="true"></div>',e.default=e.modalMarkup},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(0),r=o.default.OVERLAY,i='<div \n    class="'+r+'"\n    tabIndex="-1">\n  </div>';e.default=i},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(0),r=o.default.ICON;e.errorIconMarkup=function(){var t=r+"--error",e=t+"__line";return'\n    <div class="'+t+'__x-mark">\n      <span class="'+e+" "+e+'--left"></span>\n      <span class="'+e+" "+e+'--right"></span>\n    </div>\n  '},e.warningIconMarkup=function(){var t=r+"--warning";return'\n    <span class="'+t+'__body">\n      <span class="'+t+'__dot"></span>\n    </span>\n  '},e.successIconMarkup=function(){var t=r+"--success";return'\n    <span class="'+t+"__line "+t+'__line--long"></span>\n    <span class="'+t+"__line "+t+'__line--tip"></span>\n\n    <div class="'+t+'__ring"></div>\n    <div class="'+t+'__hide-corners"></div>\n  '}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(0),r=o.default.CONTENT;e.contentMarkup='\n  <div class="'+r+'">\n\n  </div>\n'},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(0),r=o.default.BUTTON_CONTAINER,i=o.default.BUTTON,a=o.default.BUTTON_LOADER;e.buttonMarkup='\n  <div class="'+r+'">\n\n    <button\n      class="'+i+'"\n    ></button>\n\n    <div class="'+a+'">\n      <div></div>\n      <div></div>\n      <div></div>\n    </div>\n\n  </div>\n'},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(4),r=n(2),i=n(0),a=i.default.ICON,s=i.default.ICON_CUSTOM,c=["error","warning","success","info"],l={error:r.errorIconMarkup(),warning:r.warningIconMarkup(),success:r.successIconMarkup()},u=function(t,e){var n=a+"--"+t;e.classList.add(n);var o=l[t];o&&(e.innerHTML=o)},f=function(t,e){e.classList.add(s);var n=document.createElement("img");n.src=t,e.appendChild(n)},d=function(t){if(t){var e=o.injectElIntoModal(r.iconMarkup);c.includes(t)?u(t,e):f(t,e)}};e.default=d},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(2),r=n(4),i=function(t){navigator.userAgent.includes("AppleWebKit")&&(t.style.display="none",t.offsetHeight,t.style.display="")};e.initTitle=function(t){if(t){var e=r.injectElIntoModal(o.titleMarkup);e.textContent=t,i(e)}},e.initText=function(t){if(t){var e=document.createDocumentFragment();t.split("\n").forEach(function(t,n,o){e.appendChild(document.createTextNode(t)),n<o.length-1&&e.appendChild(document.createElement("br"))});var n=r.injectElIntoModal(o.textMarkup);n.appendChild(e),i(n)}}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(1),r=n(4),i=n(0),a=i.default.BUTTON,s=i.default.DANGER_BUTTON,c=n(3),l=n(2),u=n(6),f=n(5),d=function(t,e,n){var r=e.text,i=e.value,d=e.className,p=e.closeModal,m=o.stringToNode(l.buttonMarkup),b=m.querySelector("."+a),v=a+"--"+t;if(b.classList.add(v),d){(Array.isArray(d)?d:d.split(" ")).filter(function(t){return t.length>0}).forEach(function(t){b.classList.add(t)})}n&&t===c.CONFIRM_KEY&&b.classList.add(s),b.textContent=r;var g={};return g[t]=i,f.setActionValue(g),f.setActionOptionsFor(t,{closeModal:p}),b.addEventListener("click",function(){return u.onAction(t)}),m},p=function(t,e){var n=r.injectElIntoModal(l.footerMarkup);for(var o in t){var i=t[o],a=d(o,i,e);i.visible&&n.appendChild(a)}0===n.children.length&&n.remove()};e.default=p},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(3),r=n(4),i=n(2),a=n(5),s=n(6),c=n(0),l=c.default.CONTENT,u=function(t){t.addEventListener("input",function(t){var e=t.target,n=e.value;a.setActionValue(n)}),t.addEventListener("keyup",function(t){if("Enter"===t.key)return s.onAction(o.CONFIRM_KEY)}),setTimeout(function(){t.focus(),a.setActionValue("")},0)},f=function(t,e,n){var o=document.createElement(e),r=l+"__"+e;o.classList.add(r);for(var i in n){var a=n[i];o[i]=a}"input"===e&&u(o),t.appendChild(o)},d=function(t){if(t){var e=r.injectElIntoModal(i.contentMarkup),n=t.element,o=t.attributes;"string"==typeof n?f(e,n,o):e.appendChild(n)}};e.default=d},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(1),r=n(2),i=function(){var t=o.stringToNode(r.overlayMarkup);document.body.appendChild(t)};e.default=i},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(5),r=n(6),i=n(1),a=n(3),s=n(0),c=s.default.MODAL,l=s.default.BUTTON,u=s.default.OVERLAY,f=function(t){t.preventDefault(),v()},d=function(t){t.preventDefault(),g()},p=function(t){if(o.default.isOpen)switch(t.key){case"Escape":return r.onAction(a.CANCEL_KEY)}},m=function(t){if(o.default.isOpen)switch(t.key){case"Tab":return f(t)}},b=function(t){if(o.default.isOpen)return"Tab"===t.key&&t.shiftKey?d(t):void 0},v=function(){var t=i.getNode(l);t&&(t.tabIndex=0,t.focus())},g=function(){var t=i.getNode(c),e=t.querySelectorAll("."+l),n=e.length-1,o=e[n];o&&o.focus()},h=function(t){t[t.length-1].addEventListener("keydown",m)},w=function(t){t[0].addEventListener("keydown",b)},y=function(){var t=i.getNode(c),e=t.querySelectorAll("."+l);e.length&&(h(e),w(e))},x=function(t){if(i.getNode(u)===t.target)return r.onAction(a.CANCEL_KEY)},_=function(t){var e=i.getNode(u);e.removeEventListener("click",x),t&&e.addEventListener("click",x)},k=function(t){o.default.timer&&clearTimeout(o.default.timer),t&&(o.default.timer=window.setTimeout(function(){return r.onAction(a.CANCEL_KEY)},t))},O=function(t){t.closeOnEsc?document.addEventListener("keyup",p):document.removeEventListener("keyup",p),t.dangerMode?v():g(),y(),_(t.closeOnClickOutside),k(t.timer)};e.default=O},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(1),r=n(3),i=n(37),a=n(38),s={title:null,text:null,icon:null,buttons:r.defaultButtonList,content:null,className:null,closeOnClickOutside:!0,closeOnEsc:!0,dangerMode:!1,timer:null},c=Object.assign({},s);e.setDefaults=function(t){c=Object.assign({},s,t)};var l=function(t){var e=t&&t.button,n=t&&t.buttons;return void 0!==e&&void 0!==n&&o.throwErr("Cannot set both 'button' and 'buttons' options!"),void 0!==e?{confirm:e}:n},u=function(t){return o.ordinalSuffixOf(t+1)},f=function(t,e){o.throwErr(u(e)+" argument ('"+t+"') is invalid")},d=function(t,e){var n=t+1,r=e[n];o.isPlainObject(r)||void 0===r||o.throwErr("Expected "+u(n)+" argument ('"+r+"') to be a plain object")},p=function(t,e){var n=t+1,r=e[n];void 0!==r&&o.throwErr("Unexpected "+u(n)+" argument ("+r+")")},m=function(t,e,n,r){var i=typeof e,a="string"===i,s=e instanceof Element;if(a){if(0===n)return{text:e};if(1===n)return{text:e,title:r[0]};if(2===n)return d(n,r),{icon:e};f(e,n)}else{if(s&&0===n)return d(n,r),{content:e};if(o.isPlainObject(e))return p(n,r),e;f(e,n)}};e.getOpts=function(){for(var t=[],e=0;e<arguments.length;e++)t[e]=arguments[e];var n={};t.forEach(function(e,o){var r=m(0,e,o,t);Object.assign(n,r)});var o=l(n);n.buttons=r.getButtonListOpts(o),delete n.button,n.content=i.getContentOpts(n.content);var u=Object.assign({},s,c,n);return Object.keys(u).forEach(function(t){a.DEPRECATED_OPTS[t]&&a.logDeprecation(t)}),u}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(1),r={element:"input",attributes:{placeholder:""}};e.getContentOpts=function(t){var e={};return o.isPlainObject(t)?Object.assign(e,t):t instanceof Element?{element:t}:"input"===t?r:null}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.logDeprecation=function(t){var n=e.DEPRECATED_OPTS[t],o=n.onlyRename,r=n.replacement,i=n.subOption,a=n.link,s=o?"renamed":"deprecated",c='SweetAlert warning: "'+t+'" option has been '+s+".";if(r){c+=" Please use"+(i?' "'+i+'" in ':" ")+'"'+r+'" instead.'}var l="https://sweetalert.js.org";c+=a?" More details: "+l+a:" More details: "+l+"/guides/#upgrading-from-1x",console.warn(c)},e.DEPRECATED_OPTS={type:{replacement:"icon",link:"/docs/#icon"},imageUrl:{replacement:"icon",link:"/docs/#icon"},customClass:{replacement:"className",onlyRename:!0,link:"/docs/#classname"},imageSize:{},showCancelButton:{replacement:"buttons",link:"/docs/#buttons"},showConfirmButton:{replacement:"button",link:"/docs/#button"},confirmButtonText:{replacement:"button",link:"/docs/#button"},confirmButtonColor:{},cancelButtonText:{replacement:"buttons",link:"/docs/#buttons"},closeOnConfirm:{replacement:"button",subOption:"closeModal",link:"/docs/#button"},closeOnCancel:{replacement:"buttons",subOption:"closeModal",link:"/docs/#buttons"},showLoaderOnConfirm:{replacement:"buttons"},animation:{},inputType:{replacement:"content",link:"/docs/#content"},inputValue:{replacement:"content",link:"/docs/#content"},inputPlaceholder:{replacement:"content",link:"/docs/#content"},html:{replacement:"content",link:"/docs/#content"},allowEscapeKey:{replacement:"closeOnEsc",onlyRename:!0,link:"/docs/#closeonesc"},allowClickOutside:{replacement:"closeOnClickOutside",onlyRename:!0,link:"/docs/#closeonclickoutside"}}}])});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(214).setImmediate, __webpack_require__(214).clearImmediate))

/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	var arrayWithHoles = __webpack_require__(693);
	var iterableToArrayLimit = __webpack_require__(698);
	var unsupportedIterableToArray = __webpack_require__(229);
	var nonIterableRest = __webpack_require__(699);
	function _slicedToArray(r, e) {
	  return arrayWithHoles(r) || iterableToArrayLimit(r, e) || unsupportedIterableToArray(r, e) || nonIterableRest();
	}
	module.exports = _slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _TextField.default;
	  }
	});
	
	var _TextField = _interopRequireDefault(__webpack_require__(752));

/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.hexToRgb = hexToRgb;
	exports.rgbToHex = rgbToHex;
	exports.hslToRgb = hslToRgb;
	exports.decomposeColor = decomposeColor;
	exports.recomposeColor = recomposeColor;
	exports.getContrastRatio = getContrastRatio;
	exports.getLuminance = getLuminance;
	exports.emphasize = emphasize;
	exports.fade = fade;
	exports.alpha = alpha;
	exports.darken = darken;
	exports.lighten = lighten;
	
	var _utils = __webpack_require__(26);
	
	/* eslint-disable no-use-before-define */
	
	/**
	 * Returns a number whose value is limited to the given range.
	 *
	 * @param {number} value The value to be clamped
	 * @param {number} min The lower boundary of the output range
	 * @param {number} max The upper boundary of the output range
	 * @returns {number} A number in the range [min, max]
	 */
	function clamp(value) {
	  var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	  var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
	
	  if (false) {
	    if (value < min || value > max) {
	      console.error("Material-UI: The value provided ".concat(value, " is out of range [").concat(min, ", ").concat(max, "]."));
	    }
	  }
	
	  return Math.min(Math.max(min, value), max);
	}
	/**
	 * Converts a color from CSS hex format to CSS rgb format.
	 *
	 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
	 * @returns {string} A CSS rgb color string
	 */
	
	
	function hexToRgb(color) {
	  color = color.substr(1);
	  var re = new RegExp(".{1,".concat(color.length >= 6 ? 2 : 1, "}"), 'g');
	  var colors = color.match(re);
	
	  if (colors && colors[0].length === 1) {
	    colors = colors.map(function (n) {
	      return n + n;
	    });
	  }
	
	  return colors ? "rgb".concat(colors.length === 4 ? 'a' : '', "(").concat(colors.map(function (n, index) {
	    return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
	  }).join(', '), ")") : '';
	}
	
	function intToHex(int) {
	  var hex = int.toString(16);
	  return hex.length === 1 ? "0".concat(hex) : hex;
	}
	/**
	 * Converts a color from CSS rgb format to CSS hex format.
	 *
	 * @param {string} color - RGB color, i.e. rgb(n, n, n)
	 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
	 */
	
	
	function rgbToHex(color) {
	  // Idempotent
	  if (color.indexOf('#') === 0) {
	    return color;
	  }
	
	  var _decomposeColor = decomposeColor(color),
	      values = _decomposeColor.values;
	
	  return "#".concat(values.map(function (n) {
	    return intToHex(n);
	  }).join(''));
	}
	/**
	 * Converts a color from hsl format to rgb format.
	 *
	 * @param {string} color - HSL color values
	 * @returns {string} rgb color values
	 */
	
	
	function hslToRgb(color) {
	  color = decomposeColor(color);
	  var _color = color,
	      values = _color.values;
	  var h = values[0];
	  var s = values[1] / 100;
	  var l = values[2] / 100;
	  var a = s * Math.min(l, 1 - l);
	
	  var f = function f(n) {
	    var k = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (n + h / 30) % 12;
	    return l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
	  };
	
	  var type = 'rgb';
	  var rgb = [Math.round(f(0) * 255), Math.round(f(8) * 255), Math.round(f(4) * 255)];
	
	  if (color.type === 'hsla') {
	    type += 'a';
	    rgb.push(values[3]);
	  }
	
	  return recomposeColor({
	    type: type,
	    values: rgb
	  });
	}
	/**
	 * Returns an object with the type and values of a color.
	 *
	 * Note: Does not support rgb % values.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @returns {object} - A MUI color object: {type: string, values: number[]}
	 */
	
	
	function decomposeColor(color) {
	  // Idempotent
	  if (color.type) {
	    return color;
	  }
	
	  if (color.charAt(0) === '#') {
	    return decomposeColor(hexToRgb(color));
	  }
	
	  var marker = color.indexOf('(');
	  var type = color.substring(0, marker);
	
	  if (['rgb', 'rgba', 'hsl', 'hsla'].indexOf(type) === -1) {
	    throw new Error( false ? "Material-UI: Unsupported `".concat(color, "` color.\nWe support the following formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla().") : (0, _utils.formatMuiErrorMessage)(3, color));
	  }
	
	  var values = color.substring(marker + 1, color.length - 1).split(',');
	  values = values.map(function (value) {
	    return parseFloat(value);
	  });
	  return {
	    type: type,
	    values: values
	  };
	}
	/**
	 * Converts a color object with type and values to a string.
	 *
	 * @param {object} color - Decomposed color
	 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla'
	 * @param {array} color.values - [n,n,n] or [n,n,n,n]
	 * @returns {string} A CSS color string
	 */
	
	
	function recomposeColor(color) {
	  var type = color.type;
	  var values = color.values;
	
	  if (type.indexOf('rgb') !== -1) {
	    // Only convert the first 3 values to int (i.e. not alpha)
	    values = values.map(function (n, i) {
	      return i < 3 ? parseInt(n, 10) : n;
	    });
	  } else if (type.indexOf('hsl') !== -1) {
	    values[1] = "".concat(values[1], "%");
	    values[2] = "".concat(values[2], "%");
	  }
	
	  return "".concat(type, "(").concat(values.join(', '), ")");
	}
	/**
	 * Calculates the contrast ratio between two colors.
	 *
	 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
	 *
	 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @returns {number} A contrast ratio value in the range 0 - 21.
	 */
	
	
	function getContrastRatio(foreground, background) {
	  var lumA = getLuminance(foreground);
	  var lumB = getLuminance(background);
	  return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
	}
	/**
	 * The relative brightness of any point in a color space,
	 * normalized to 0 for darkest black and 1 for lightest white.
	 *
	 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @returns {number} The relative brightness of the color in the range 0 - 1
	 */
	
	
	function getLuminance(color) {
	  color = decomposeColor(color);
	  var rgb = color.type === 'hsl' ? decomposeColor(hslToRgb(color)).values : color.values;
	  rgb = rgb.map(function (val) {
	    val /= 255; // normalized
	
	    return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
	  }); // Truncate at 3 digits
	
	  return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
	}
	/**
	 * Darken or lighten a color, depending on its luminance.
	 * Light colors are darkened, dark colors are lightened.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
	 * @returns {string} A CSS color string. Hex input values are returned as rgb
	 */
	
	
	function emphasize(color) {
	  var coefficient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.15;
	  return getLuminance(color) > 0.5 ? darken(color, coefficient) : lighten(color, coefficient);
	}
	
	var warnedOnce = false;
	/**
	 * Set the absolute transparency of a color.
	 * Any existing alpha values are overwritten.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {number} value - value to set the alpha channel to in the range 0 -1
	 * @returns {string} A CSS color string. Hex input values are returned as rgb
	 *
	 * @deprecated
	 * Use `import { alpha } from '@material-ui/core/styles'` instead.
	 */
	
	function fade(color, value) {
	  if (false) {
	    if (!warnedOnce) {
	      warnedOnce = true;
	      console.error(['Material-UI: The `fade` color utility was renamed to `alpha` to better describe its functionality.', '', "You should use `import { alpha } from '@material-ui/core/styles'`"].join('\n'));
	    }
	  }
	
	  return alpha(color, value);
	}
	/**
	 * Set the absolute transparency of a color.
	 * Any existing alpha value is overwritten.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {number} value - value to set the alpha channel to in the range 0-1
	 * @returns {string} A CSS color string. Hex input values are returned as rgb
	 */
	
	
	function alpha(color, value) {
	  color = decomposeColor(color);
	  value = clamp(value);
	
	  if (color.type === 'rgb' || color.type === 'hsl') {
	    color.type += 'a';
	  }
	
	  color.values[3] = value;
	  return recomposeColor(color);
	}
	/**
	 * Darkens a color.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {number} coefficient - multiplier in the range 0 - 1
	 * @returns {string} A CSS color string. Hex input values are returned as rgb
	 */
	
	
	function darken(color, coefficient) {
	  color = decomposeColor(color);
	  coefficient = clamp(coefficient);
	
	  if (color.type.indexOf('hsl') !== -1) {
	    color.values[2] *= 1 - coefficient;
	  } else if (color.type.indexOf('rgb') !== -1) {
	    for (var i = 0; i < 3; i += 1) {
	      color.values[i] *= 1 - coefficient;
	    }
	  }
	
	  return recomposeColor(color);
	}
	/**
	 * Lightens a color.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {number} coefficient - multiplier in the range 0 - 1
	 * @returns {string} A CSS color string. Hex input values are returned as rgb
	 */
	
	
	function lighten(color, coefficient) {
	  color = decomposeColor(color);
	  coefficient = clamp(coefficient);
	
	  if (color.type.indexOf('hsl') !== -1) {
	    color.values[2] += (100 - color.values[2]) * coefficient;
	  } else if (color.type.indexOf('rgb') !== -1) {
	    for (var i = 0; i < 3; i += 1) {
	      color.values[i] += (255 - color.values[i]) * coefficient;
	    }
	  }
	
	  return recomposeColor(color);
	}

/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = useTheme;
	
	var _styles = __webpack_require__(80);
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _defaultTheme = _interopRequireDefault(__webpack_require__(142));
	
	function useTheme() {
	  var theme = (0, _styles.useTheme)() || _defaultTheme.default;
	
	  if (false) {
	    // eslint-disable-next-line react-hooks/rules-of-hooks
	    _react.default.useDebugValue(theme);
	  }
	
	  return theme;
	}

/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createChainedFunction;
	
	/**
	 * Safe chained function
	 *
	 * Will only create a new function if needed,
	 * otherwise will pass back existing functions or null.
	 *
	 * @param {function} functions to chain
	 * @returns {function|null}
	 */
	function createChainedFunction() {
	  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  return funcs.reduce(function (acc, func) {
	    if (func == null) {
	      return acc;
	    }
	
	    if (false) {
	      if (typeof func !== 'function') {
	        console.error('Material-UI: Invalid Argument Type, must only provide functions, undefined, or null.');
	      }
	    }
	
	    return function chainedFunction() {
	      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      acc.apply(this, args);
	      func.apply(this, args);
	    };
	  }, function () {});
	}

/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = useEventCallback;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var useEnhancedEffect = typeof window !== 'undefined' ? React.useLayoutEffect : React.useEffect;
	/**
	 * https://github.com/facebook/react/issues/14099#issuecomment-440013892
	 *
	 * @param {function} fn
	 */
	
	function useEventCallback(fn) {
	  var ref = React.useRef(fn);
	  useEnhancedEffect(function () {
	    ref.current = fn;
	  });
	  return React.useCallback(function () {
	    return (0, ref.current).apply(void 0, arguments);
	  }, []);
	}

/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Autocomplete.default;
	  }
	});
	Object.defineProperty(exports, "createFilterOptions", {
	  enumerable: true,
	  get: function get() {
	    return _Autocomplete.createFilterOptions;
	  }
	});
	
	var _Autocomplete = _interopRequireWildcard(__webpack_require__(784));

/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _utils = __webpack_require__(26);
	
	function merge(acc, item) {
	  if (!item) {
	    return acc;
	  }
	
	  return (0, _utils.deepmerge)(acc, item, {
	    clone: false // No need to clone deep, it's way faster.
	
	  });
	}
	
	var _default = merge;
	exports.default = _default;

/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var PDFMargin_1 = __webpack_require__(344);
	var fieldsNames = ['bottom', 'left', 'right', 'top'];
	/**
	 * @hidden
	 * Returns the margin options by reading the props of he component and the `PDFMargin` child.
	 * The props of the `PDFMargin` child are with greater priority.
	 */
	function getPageMargin(props) {
	    var marginChild = React.Children
	        .toArray(props.children)
	        .find(function (child) { return child && child.type === PDFMargin_1.PDFMargin; });
	    return marginChild ? getMarginComponentProps(marginChild) : props.margin;
	}
	exports.getPageMargin = getPageMargin;
	function getMarginComponentProps(marginComponent) {
	    var result = {};
	    for (var idx = 0; idx < fieldsNames.length; idx++) {
	        var fieldName = fieldsNames[idx];
	        var value = marginComponent.props[fieldName];
	        if (value !== undefined) {
	            result[fieldName] = value;
	        }
	    }
	    return result;
	}
	//# sourceMappingURL=getPageMargin.js.map

/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(848);

/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactStarRatingComponent = __webpack_require__(297);
	
	var _reactStarRatingComponent2 = _interopRequireDefault(_reactStarRatingComponent);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _DomainName = __webpack_require__(119);
	
	var _DomainName2 = _interopRequireDefault(_DomainName);
	
	var _constant = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FooterNew = function (_Component) {
	  _inherits(FooterNew, _Component);
	
	  function FooterNew(props) {
	    _classCallCheck(this, FooterNew);
	
	    return _possibleConstructorReturn(this, (FooterNew.__proto__ || Object.getPrototypeOf(FooterNew)).call(this, props));
	  }
	
	  _createClass(FooterNew, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'render',
	    value: function render() {
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement('div', { className: 'row' })
	      );
	    }
	  }]);
	
	  return FooterNew;
	}(_react.Component);
	
	exports.default = FooterNew;

/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constant = __webpack_require__(21);
	
	var _reactHelmet = __webpack_require__(77);
	
	var _bewiseLogoNew = __webpack_require__(1632);
	
	var _bewiseLogoNew2 = _interopRequireDefault(_bewiseLogoNew);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HeaderNew = function (_Component) {
	  _inherits(HeaderNew, _Component);
	
	  function HeaderNew(props) {
	    _classCallCheck(this, HeaderNew);
	
	    var _this = _possibleConstructorReturn(this, (HeaderNew.__proto__ || Object.getPrototypeOf(HeaderNew)).call(this, props));
	
	    var path = window.location.pathname;
	    _this.state = {
	      authe: false,
	      logged_user_name: "",
	      login_path: path == '/' ? '/admin_login' : '/login',
	      signup_path: path == 'individual' ? '/individual_signup' : '/institution_signup'
	    };
	    return _this;
	  }
	
	  _createClass(HeaderNew, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      console.log('window.location.pathname', window.location.pathname);
	      var logged = localStorage.getItem("authentication");
	      var auth_data = JSON.parse(localStorage.getItem("user_data"));
	      console.log("auth_data", typeof logged === "undefined" ? "undefined" : _typeof(logged));
	      if (auth_data) {
	        this.setState({
	          authe: logged == "true" ? true : false,
	          logged_user_name: auth_data.user_name
	        });
	      }
	    }
	  }, {
	    key: "logoutSess",
	    value: function logoutSess(e) {
	      localStorage.clear();
	      setTimeout(function () {
	        window.location = "/";
	      }, 1000);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        { style: {
	            position: "fixed",
	            zIndex: "999",
	            background: "#fff",
	            width: "100%",
	            top: 0
	          }, "class": "container-fluid" },
	        _react2.default.createElement(
	          "div",
	          { className: "tranparent-header-custom-inner" },
	          _react2.default.createElement(
	            "div",
	            { className: "container-fluid" },
	            _react2.default.createElement(
	              "div",
	              { className: "row display-flex-center header-custom stickymenu sticky-top desktop" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-lg-3 col-md-3 col-sm-3 bewise-logo-block" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "bewise-logo active" },
	                  _react2.default.createElement(
	                    "div",
	                    { "class": "row  display-flex-center" },
	                    _react2.default.createElement(
	                      "div",
	                      null,
	                      _react2.default.createElement(
	                        "a",
	                        { className: "logo-text", href: "/" },
	                        _react2.default.createElement("img", { src: _bewiseLogoNew2.default, className: "mainlogoimg", style: { width: "50px", marginRight: "2px" } })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "mainlogotext" },
	                      _react2.default.createElement(
	                        "h5",
	                        { style: { lineHeight: "3px", marginTop: "10px", fontWeight: "bold" } },
	                        "BeWise"
	                      ),
	                      _react2.default.createElement(
	                        "p",
	                        { className: "logoslogan", style: { fontSize: "8px", fontWeight: "bold" } },
	                        "Enabling Learning & Fun"
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-lg-6 col-md-6 col-sm-6", style: { textAlign: "center" } },
	                _react2.default.createElement(
	                  "div",
	                  { className: "topheading mainsearchareatop s003", style: { display: "none" } },
	                  _react2.default.createElement(
	                    "div",
	                    { "class": "bheader" },
	                    "Welcome to ",
	                    _react2.default.createElement(
	                      "span",
	                      { className: "bluetext" },
	                      "BeWise"
	                    ),
	                    " Partner Program"
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-lg-3 col-md-3 col-sm-3 text-right bewise-signin-block" },
	                _react2.default.createElement(
	                  "a",
	                  { href: "/login", className: "nsignbtn" },
	                  "Sign In"
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "row mobile" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-xs-8 bewise-logo-block", style: { paddingLeft: "0px" } },
	                _react2.default.createElement(
	                  "div",
	                  { className: "bewise-logo active" },
	                  _react2.default.createElement(
	                    "div",
	                    { "class": "leftLogo" },
	                    _react2.default.createElement(
	                      "a",
	                      { className: "logo-text", href: "/" },
	                      _react2.default.createElement("img", { src: _bewiseLogoNew2.default, className: "mainlogoimg", style: { width: "55px", marginRight: "2px" } })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "rightLogo" },
	                    _react2.default.createElement(
	                      "h5",
	                      { style: { lineHeight: "3px", marginTop: "10px", fontWeight: "bold" } },
	                      "BeWise"
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      { className: "logoslogan", style: { fontSize: "8px", fontWeight: "bold" } },
	                      "Enabling Learning & Fun"
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-xs-4 text-right bewise-signin-block" },
	                _react2.default.createElement(
	                  "a",
	                  { href: "/login", className: "nsignbtn" },
	                  "Sign In"
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "row align-items-center mobile" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-sm-12", style: { textAlign: "center" } },
	                _react2.default.createElement(
	                  "div",
	                  { "class": "bheader" },
	                  "Welcome to ",
	                  _react2.default.createElement(
	                    "span",
	                    { className: "bluetext" },
	                    "BeWise"
	                  ),
	                  " Partner Program"
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return HeaderNew;
	}(_react.Component);
	
	exports.default = HeaderNew;

/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _menu = __webpack_require__(1296);
	
	var _menu2 = _interopRequireDefault(_menu);
	
	var _constant = __webpack_require__(21);
	
	var _reactHelmet = __webpack_require__(77);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Header = function (_Component) {
	  _inherits(Header, _Component);
	
	  function Header(props) {
	    _classCallCheck(this, Header);
	
	    var _this = _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).call(this, props));
	
	    _this.state = {
	      authe: false,
	      logged_user_name: "",
	      login_path: window.location.pathname == '/' ? '/login' : '/login'
	    };
	    return _this;
	  }
	
	  _createClass(Header, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      console.log('window.location.pathname', window.location.pathname);
	      var logged = localStorage.getItem("authentication");
	      var auth_data = JSON.parse(localStorage.getItem("user_data"));
	      console.log("auth_data", typeof logged === "undefined" ? "undefined" : _typeof(logged));
	      if (auth_data) {
	        this.setState({
	          authe: logged == "true" ? true : false,
	          logged_user_name: auth_data.user_name
	        });
	      }
	    }
	  }, {
	    key: "logoutSess",
	    value: function logoutSess(e) {
	      localStorage.clear();
	      setTimeout(function () {
	        window.location = "/";
	      }, 1000);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        "div",
	        { className: "row menu-vendor", id: "navbarText" },
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm-2" },
	          _react2.default.createElement(
	            "a",
	            { href: _constant.USERURL, target: "_blank" },
	            _react2.default.createElement("img", { className: "logo-img", src: "assets/images/bewiselogo.png" })
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm-10 text-right navbar-text-logo header-rightside" },
	          this.state.authe === false ? _react2.default.createElement(
	            "a",
	            { href: this.state.login_path, style: { color: "black" } },
	            "SIGN IN"
	          ) : _react2.default.createElement(
	            "span",
	            { style: { cursor: "pointer" }, onClick: function onClick() {
	                return _this2.logoutSess();
	              } },
	            "SIGN OUT"
	          )
	        )
	      );
	    }
	  }]);
	
	  return Header;
	}(_react.Component);
	
	exports.default = Header;

/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _header = __webpack_require__(361);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _footer = __webpack_require__(360);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _coursesideBar = __webpack_require__(915);
	
	var _coursesideBar2 = _interopRequireDefault(_coursesideBar);
	
	var _reactHelmet = __webpack_require__(77);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CourseLayout = function (_Component) {
		_inherits(CourseLayout, _Component);
	
		function CourseLayout(props) {
			_classCallCheck(this, CourseLayout);
	
			var _this = _possibleConstructorReturn(this, (CourseLayout.__proto__ || Object.getPrototypeOf(CourseLayout)).call(this, props));
	
			_this.state = {
				auth_data: JSON.parse(localStorage.getItem("user_data"))
			};
			return _this;
		}
	
		_createClass(CourseLayout, [{
			key: 'render',
			value: function render() {
	
				return _react2.default.createElement(
					'div',
					{ className: 'App container-scroller bewiseui' },
					_react2.default.createElement(_header2.default, null),
					_react2.default.createElement(
						'div',
						{ 'class': 'container-fluid page-body-wrapper' },
						_react2.default.createElement(_coursesideBar2.default, null),
						_react2.default.createElement(
							'div',
							{ 'class': 'main-panel' },
							_react2.default.createElement(
								'div',
								{ 'class': 'content-wrapper nopadding overflowx' },
								this.props.children
							),
							_react2.default.createElement(_footer2.default, null)
						)
					)
				);
			}
		}]);
	
		return CourseLayout;
	}(_react.Component);
	
	exports.default = CourseLayout;

/***/ },
/* 189 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getTimezoneOffsetInMilliseconds;
	/**
	 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
	 * They usually appear for dates that denote time before the timezones were introduced
	 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
	 * and GMT+01:00:00 after that date)
	 *
	 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
	 * which would lead to incorrect calculations.
	 *
	 * This function returns the timezone offset in milliseconds that takes seconds in account.
	 */
	function getTimezoneOffsetInMilliseconds(date) {
	  var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
	  utcDate.setUTCFullYear(date.getFullYear());
	  return date.getTime() - utcDate.getTime();
	}
	module.exports = exports.default;

/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	var DraftEntityInstance = __webpack_require__(395);
	
	var Immutable = __webpack_require__(27);
	
	var invariant = __webpack_require__(32);
	
	var uuid = __webpack_require__(1253);
	
	var Map = Immutable.Map;
	var instances = Map();
	var instanceKey = uuid();
	/**
	 * Temporary utility for generating the warnings
	 */
	
	function logWarning(oldMethodCall, newMethodCall) {
	  console.warn('WARNING: ' + oldMethodCall + ' will be deprecated soon!\nPlease use "' + newMethodCall + '" instead.');
	}
	
	/**
	 * A "document entity" is an object containing metadata associated with a
	 * piece of text in a ContentBlock.
	 *
	 * For example, a `link` entity might include a `uri` property. When a
	 * ContentBlock is rendered in the browser, text that refers to that link
	 * entity may be rendered as an anchor, with the `uri` as the href value.
	 *
	 * In a ContentBlock, every position in the text may correspond to zero
	 * or one entities. This correspondence is tracked using a key string,
	 * generated via DraftEntity.create() and used to obtain entity metadata
	 * via DraftEntity.get().
	 */
	var DraftEntity = {
	  /**
	   * WARNING: This method will be deprecated soon!
	   * Please use 'contentState.getLastCreatedEntityKey' instead.
	   * ---
	   * Get the random key string from whatever entity was last created.
	   * We need this to support the new API, as part of transitioning to put Entity
	   * storage in contentState.
	   */
	  getLastCreatedEntityKey: function getLastCreatedEntityKey() {
	    logWarning('DraftEntity.getLastCreatedEntityKey', 'contentState.getLastCreatedEntityKey');
	    return DraftEntity.__getLastCreatedEntityKey();
	  },
	
	  /**
	   * WARNING: This method will be deprecated soon!
	   * Please use 'contentState.createEntity' instead.
	   * ---
	   * Create a DraftEntityInstance and store it for later retrieval.
	   *
	   * A random key string will be generated and returned. This key may
	   * be used to track the entity's usage in a ContentBlock, and for
	   * retrieving data about the entity at render time.
	   */
	  create: function create(type, mutability, data) {
	    logWarning('DraftEntity.create', 'contentState.createEntity');
	    return DraftEntity.__create(type, mutability, data);
	  },
	
	  /**
	   * WARNING: This method will be deprecated soon!
	   * Please use 'contentState.addEntity' instead.
	   * ---
	   * Add an existing DraftEntityInstance to the DraftEntity map. This is
	   * useful when restoring instances from the server.
	   */
	  add: function add(instance) {
	    logWarning('DraftEntity.add', 'contentState.addEntity');
	    return DraftEntity.__add(instance);
	  },
	
	  /**
	   * WARNING: This method will be deprecated soon!
	   * Please use 'contentState.getEntity' instead.
	   * ---
	   * Retrieve the entity corresponding to the supplied key string.
	   */
	  get: function get(key) {
	    logWarning('DraftEntity.get', 'contentState.getEntity');
	    return DraftEntity.__get(key);
	  },
	
	  /**
	   * Get all the entities in the content state.
	   */
	  __getAll: function __getAll() {
	    return instances;
	  },
	
	  /**
	   * Load the entity map with the given set of entities.
	   */
	  __loadWithEntities: function __loadWithEntities(entities) {
	    instances = entities;
	    instanceKey = uuid();
	  },
	
	  /**
	   * WARNING: This method will be deprecated soon!
	   * Please use 'contentState.mergeEntityData' instead.
	   * ---
	   * Entity instances are immutable. If you need to update the data for an
	   * instance, this method will merge your data updates and return a new
	   * instance.
	   */
	  mergeData: function mergeData(key, toMerge) {
	    logWarning('DraftEntity.mergeData', 'contentState.mergeEntityData');
	    return DraftEntity.__mergeData(key, toMerge);
	  },
	
	  /**
	   * WARNING: This method will be deprecated soon!
	   * Please use 'contentState.replaceEntityData' instead.
	   * ---
	   * Completely replace the data for a given instance.
	   */
	  replaceData: function replaceData(key, newData) {
	    logWarning('DraftEntity.replaceData', 'contentState.replaceEntityData');
	    return DraftEntity.__replaceData(key, newData);
	  },
	  // ***********************************WARNING******************************
	  // --- the above public API will be deprecated in the next version of Draft!
	  // The methods below this line are private - don't call them directly.
	
	  /**
	   * Get the random key string from whatever entity was last created.
	   * We need this to support the new API, as part of transitioning to put Entity
	   * storage in contentState.
	   */
	  __getLastCreatedEntityKey: function __getLastCreatedEntityKey() {
	    return instanceKey;
	  },
	
	  /**
	   * Create a DraftEntityInstance and store it for later retrieval.
	   *
	   * A random key string will be generated and returned. This key may
	   * be used to track the entity's usage in a ContentBlock, and for
	   * retrieving data about the entity at render time.
	   */
	  __create: function __create(type, mutability, data) {
	    return DraftEntity.__add(new DraftEntityInstance({
	      type: type,
	      mutability: mutability,
	      data: data || {}
	    }));
	  },
	
	  /**
	   * Add an existing DraftEntityInstance to the DraftEntity map. This is
	   * useful when restoring instances from the server.
	   */
	  __add: function __add(instance) {
	    instanceKey = uuid();
	    instances = instances.set(instanceKey, instance);
	    return instanceKey;
	  },
	
	  /**
	   * Retrieve the entity corresponding to the supplied key string.
	   */
	  __get: function __get(key) {
	    var instance = instances.get(key);
	    !!!instance ?  false ? invariant(false, 'Unknown DraftEntity key: %s.', key) : invariant(false) : void 0;
	    return instance;
	  },
	
	  /**
	   * Entity instances are immutable. If you need to update the data for an
	   * instance, this method will merge your data updates and return a new
	   * instance.
	   */
	  __mergeData: function __mergeData(key, toMerge) {
	    var instance = DraftEntity.__get(key);
	
	    var newData = _objectSpread({}, instance.getData(), toMerge);
	
	    var newInstance = instance.set('data', newData);
	    instances = instances.set(key, newInstance);
	    return newInstance;
	  },
	
	  /**
	   * Completely replace the data for a given instance.
	   */
	  __replaceData: function __replaceData(key, newData) {
	    var instance = DraftEntity.__get(key);
	
	    var newInstance = instance.set('data', newData);
	    instances = instances.set(key, newInstance);
	    return newInstance;
	  }
	};
	module.exports = DraftEntity;

/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	var Immutable = __webpack_require__(27);
	
	var Record = Immutable.Record;
	var defaultRecord = {
	  anchorKey: '',
	  anchorOffset: 0,
	  focusKey: '',
	  focusOffset: 0,
	  isBackward: false,
	  hasFocus: false
	};
	/* $FlowFixMe[unclear-type] This comment suppresses an error found when
	 * automatically adding a type annotation with the codemod Komodo/Annotate_
	 * exports. To see the error delete this comment and run Flow. */
	
	var SelectionStateRecord = Record(defaultRecord);
	
	var SelectionState = /*#__PURE__*/function (_SelectionStateRecord) {
	  _inheritsLoose(SelectionState, _SelectionStateRecord);
	
	  function SelectionState() {
	    return _SelectionStateRecord.apply(this, arguments) || this;
	  }
	
	  var _proto = SelectionState.prototype;
	
	  _proto.serialize = function serialize() {
	    return 'Anchor: ' + this.getAnchorKey() + ':' + this.getAnchorOffset() + ', ' + 'Focus: ' + this.getFocusKey() + ':' + this.getFocusOffset() + ', ' + 'Is Backward: ' + String(this.getIsBackward()) + ', ' + 'Has Focus: ' + String(this.getHasFocus());
	  };
	
	  _proto.getAnchorKey = function getAnchorKey() {
	    return this.get('anchorKey');
	  };
	
	  _proto.getAnchorOffset = function getAnchorOffset() {
	    return this.get('anchorOffset');
	  };
	
	  _proto.getFocusKey = function getFocusKey() {
	    return this.get('focusKey');
	  };
	
	  _proto.getFocusOffset = function getFocusOffset() {
	    return this.get('focusOffset');
	  };
	
	  _proto.getIsBackward = function getIsBackward() {
	    return this.get('isBackward');
	  };
	
	  _proto.getHasFocus = function getHasFocus() {
	    return this.get('hasFocus');
	  }
	  /**
	   * Return whether the specified range overlaps with an edge of the
	   * SelectionState.
	   */
	  ;
	
	  _proto.hasEdgeWithin = function hasEdgeWithin(blockKey, start, end) {
	    var anchorKey = this.getAnchorKey();
	    var focusKey = this.getFocusKey();
	
	    if (anchorKey === focusKey && anchorKey === blockKey) {
	      var selectionStart = this.getStartOffset();
	      var selectionEnd = this.getEndOffset();
	      return start <= selectionStart && selectionStart <= end || // selectionStart is between start and end, or
	      start <= selectionEnd && selectionEnd <= end // selectionEnd is between start and end
	      ;
	    }
	
	    if (blockKey !== anchorKey && blockKey !== focusKey) {
	      return false;
	    }
	
	    var offsetToCheck = blockKey === anchorKey ? this.getAnchorOffset() : this.getFocusOffset();
	    return start <= offsetToCheck && end >= offsetToCheck;
	  };
	
	  _proto.isCollapsed = function isCollapsed() {
	    return this.getAnchorKey() === this.getFocusKey() && this.getAnchorOffset() === this.getFocusOffset();
	  };
	
	  _proto.getStartKey = function getStartKey() {
	    return this.getIsBackward() ? this.getFocusKey() : this.getAnchorKey();
	  };
	
	  _proto.getStartOffset = function getStartOffset() {
	    return this.getIsBackward() ? this.getFocusOffset() : this.getAnchorOffset();
	  };
	
	  _proto.getEndKey = function getEndKey() {
	    return this.getIsBackward() ? this.getAnchorKey() : this.getFocusKey();
	  };
	
	  _proto.getEndOffset = function getEndOffset() {
	    return this.getIsBackward() ? this.getAnchorOffset() : this.getFocusOffset();
	  };
	
	  SelectionState.createEmpty = function createEmpty(key) {
	    return new SelectionState({
	      anchorKey: key,
	      anchorOffset: 0,
	      focusKey: key,
	      focusOffset: 0,
	      isBackward: false,
	      hasFocus: false
	    });
	  };
	
	  return SelectionState;
	}(SelectionStateRecord);
	
	module.exports = SelectionState;

/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	var getCorrectDocumentFromNode = __webpack_require__(194);
	
	var getSelectionOffsetKeyForNode = __webpack_require__(412);
	/**
	 * Get the key from the node's nearest offset-aware ancestor.
	 */
	
	
	function findAncestorOffsetKey(node) {
	  var searchNode = node;
	
	  while (searchNode && searchNode !== getCorrectDocumentFromNode(node).documentElement) {
	    var key = getSelectionOffsetKeyForNode(searchNode);
	
	    if (key != null) {
	      return key;
	    }
	
	    searchNode = searchNode.parentNode;
	  }
	
	  return null;
	}
	
	module.exports = findAncestorOffsetKey;

/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	var randomizeBlockMapKeys = __webpack_require__(421);
	
	var removeEntitiesAtEdges = __webpack_require__(422);
	
	var getContentStateFragment = function getContentStateFragment(contentState, selectionState) {
	  var startKey = selectionState.getStartKey();
	  var startOffset = selectionState.getStartOffset();
	  var endKey = selectionState.getEndKey();
	  var endOffset = selectionState.getEndOffset(); // Edge entities should be stripped to ensure that we don't preserve
	  // invalid partial entities when the fragment is reused. We do, however,
	  // preserve entities that are entirely within the selection range.
	
	  var contentWithoutEdgeEntities = removeEntitiesAtEdges(contentState, selectionState);
	  var blockMap = contentWithoutEdgeEntities.getBlockMap();
	  var blockKeys = blockMap.keySeq();
	  var startIndex = blockKeys.indexOf(startKey);
	  var endIndex = blockKeys.indexOf(endKey) + 1;
	  return randomizeBlockMapKeys(blockMap.slice(startIndex, endIndex).map(function (block, blockKey) {
	    var text = block.getText();
	    var chars = block.getCharacterList();
	
	    if (startKey === endKey) {
	      return block.merge({
	        text: text.slice(startOffset, endOffset),
	        characterList: chars.slice(startOffset, endOffset)
	      });
	    }
	
	    if (blockKey === startKey) {
	      return block.merge({
	        text: text.slice(startOffset),
	        characterList: chars.slice(startOffset)
	      });
	    }
	
	    if (blockKey === endKey) {
	      return block.merge({
	        text: text.slice(0, endOffset),
	        characterList: chars.slice(0, endOffset)
	      });
	    }
	
	    return block;
	  }));
	};
	
	module.exports = getContentStateFragment;

/***/ },
/* 194 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	function getCorrectDocumentFromNode(node) {
	  if (!node || !node.ownerDocument) {
	    return document;
	  }
	
	  return node.ownerDocument;
	}
	
	module.exports = getCorrectDocumentFromNode;

/***/ },
/* 195 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	/**
	 * Utility method for determining whether or not the value returned
	 * from a handler indicates that it was handled.
	 */
	function isEventHandled(value) {
	  return value === 'handled' || value === true;
	}
	
	module.exports = isEventHandled;

/***/ },
/* 196 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('.')} */
	var $defineProperty = Object.defineProperty || false;
	if ($defineProperty) {
		try {
			$defineProperty({}, 'a', { value: 1 });
		} catch (e) {
			// IE 8 has a broken defineProperty
			$defineProperty = false;
		}
	}
	
	module.exports = $defineProperty;


/***/ },
/* 197 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	module.exports = {
	  BACKSPACE: 8,
	  TAB: 9,
	  RETURN: 13,
	  ALT: 18,
	  ESC: 27,
	  SPACE: 32,
	  PAGE_UP: 33,
	  PAGE_DOWN: 34,
	  END: 35,
	  HOME: 36,
	  LEFT: 37,
	  UP: 38,
	  RIGHT: 39,
	  DOWN: 40,
	  DELETE: 46,
	  COMMA: 188,
	  PERIOD: 190,
	  A: 65,
	  Z: 90,
	  ZERO: 48,
	  NUMPAD_0: 96,
	  NUMPAD_9: 105
	};

/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	var getStyleProperty = __webpack_require__(1282);
	/**
	 * @param {DOMNode} element [description]
	 * @param {string} name Overflow style property name.
	 * @return {boolean} True if the supplied ndoe is scrollable.
	 */
	
	
	function _isNodeScrollable(element, name) {
	  var overflow = Style.get(element, name);
	  return overflow === 'auto' || overflow === 'scroll';
	}
	/**
	 * Utilities for querying and mutating style properties.
	 */
	
	
	var Style = {
	  /**
	   * Gets the style property for the supplied node. This will return either the
	   * computed style, if available, or the declared style.
	   *
	   * @param {DOMNode} node
	   * @param {string} name Style property name.
	   * @return {?string} Style property value.
	   */
	  get: getStyleProperty,
	
	  /**
	   * Determines the nearest ancestor of a node that is scrollable.
	   *
	   * NOTE: This can be expensive if used repeatedly or on a node nested deeply.
	   *
	   * @param {?DOMNode} node Node from which to start searching.
	   * @return {?DOMWindow|DOMElement} Scroll parent of the supplied node.
	   */
	  getScrollParent: function getScrollParent(node) {
	    if (!node) {
	      return null;
	    }
	
	    var ownerDocument = node.ownerDocument;
	
	    while (node && node !== ownerDocument.body) {
	      if (_isNodeScrollable(node, 'overflow') || _isNodeScrollable(node, 'overflowY') || _isNodeScrollable(node, 'overflowX')) {
	        return node;
	      }
	
	      node = node.parentNode;
	    }
	
	    return ownerDocument.defaultView || ownerDocument.parentWindow;
	  }
	};
	module.exports = Style;

/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 * 
	 */
	
	/**
	 * Constants to represent text directionality
	 *
	 * Also defines a *global* direciton, to be used in bidi algorithms as a
	 * default fallback direciton, when no better direction is found or provided.
	 *
	 * NOTE: Use `setGlobalDir()`, or update `initGlobalDir()`, to set the initial
	 *       global direction value based on the application.
	 *
	 * Part of the implementation of Unicode Bidirectional Algorithm (UBA)
	 * Unicode Standard Annex #9 (UAX9)
	 * http://www.unicode.org/reports/tr9/
	 */
	'use strict';
	
	var invariant = __webpack_require__(32);
	
	var NEUTRAL = 'NEUTRAL'; // No strong direction
	
	var LTR = 'LTR'; // Left-to-Right direction
	
	var RTL = 'RTL'; // Right-to-Left direction
	
	var globalDir = null; // == Helpers ==
	
	/**
	 * Check if a directionality value is a Strong one
	 */
	
	function isStrong(dir) {
	  return dir === LTR || dir === RTL;
	}
	/**
	 * Get string value to be used for `dir` HTML attribute or `direction` CSS
	 * property.
	 */
	
	
	function getHTMLDir(dir) {
	  !isStrong(dir) ?  false ? invariant(false, '`dir` must be a strong direction to be converted to HTML Direction') : invariant(false) : void 0;
	  return dir === LTR ? 'ltr' : 'rtl';
	}
	/**
	 * Get string value to be used for `dir` HTML attribute or `direction` CSS
	 * property, but returns null if `dir` has same value as `otherDir`.
	 * `null`.
	 */
	
	
	function getHTMLDirIfDifferent(dir, otherDir) {
	  !isStrong(dir) ?  false ? invariant(false, '`dir` must be a strong direction to be converted to HTML Direction') : invariant(false) : void 0;
	  !isStrong(otherDir) ?  false ? invariant(false, '`otherDir` must be a strong direction to be converted to HTML Direction') : invariant(false) : void 0;
	  return dir === otherDir ? null : getHTMLDir(dir);
	} // == Global Direction ==
	
	/**
	 * Set the global direction.
	 */
	
	
	function setGlobalDir(dir) {
	  globalDir = dir;
	}
	/**
	 * Initialize the global direction
	 */
	
	
	function initGlobalDir() {
	  setGlobalDir(LTR);
	}
	/**
	 * Get the global direction
	 */
	
	
	function getGlobalDir() {
	  if (!globalDir) {
	    this.initGlobalDir();
	  }
	
	  !globalDir ?  false ? invariant(false, 'Global direction not set.') : invariant(false) : void 0;
	  return globalDir;
	}
	
	var UnicodeBidiDirection = {
	  // Values
	  NEUTRAL: NEUTRAL,
	  LTR: LTR,
	  RTL: RTL,
	  // Helpers
	  isStrong: isStrong,
	  getHTMLDir: getHTMLDir,
	  getHTMLDirIfDifferent: getHTMLDirIfDifferent,
	  // Global Direction
	  setGlobalDir: setGlobalDir,
	  initGlobalDir: initGlobalDir,
	  getGlobalDir: getGlobalDir
	};
	module.exports = UnicodeBidiDirection;

/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	'use strict';
	
	var getDocumentScrollElement = __webpack_require__(1280);
	
	var getUnboundedScrollPosition = __webpack_require__(1283);
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are bounded. This means that if the scroll position is
	 * negative or exceeds the element boundaries (which is possible using inertial
	 * scrolling), you will get zero or the maximum scroll position, respectively.
	 *
	 * If you need the unbound scroll position, use `getUnboundedScrollPosition`.
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	
	
	function getScrollPosition(scrollable) {
	  var documentScrollElement = getDocumentScrollElement(scrollable.ownerDocument || scrollable.document);
	
	  if (scrollable.Window && scrollable instanceof scrollable.Window) {
	    scrollable = documentScrollElement;
	  }
	
	  var scrollPosition = getUnboundedScrollPosition(scrollable);
	  var viewport = scrollable === documentScrollElement ? scrollable.ownerDocument.documentElement : scrollable;
	  var xMax = scrollable.scrollWidth - viewport.clientWidth;
	  var yMax = scrollable.scrollHeight - viewport.clientHeight;
	  scrollPosition.x = Math.max(0, Math.min(scrollPosition.x, xMax));
	  scrollPosition.y = Math.max(0, Math.min(scrollPosition.y, yMax));
	  return scrollPosition;
	}
	
	module.exports = getScrollPosition;

/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {"use strict";
	
	module.exports = {
	    /**
	     * True if this is running in Nodejs, will be undefined in a browser.
	     * In a browser, browserify won't include this file and the whole module
	     * will be resolved an empty object.
	     */
	    isNode : typeof Buffer !== "undefined",
	    /**
	     * Create a new nodejs Buffer from an existing content.
	     * @param {Object} data the data to pass to the constructor.
	     * @param {String} encoding the encoding to use.
	     * @return {Buffer} a new Buffer.
	     */
	    newBufferFrom: function(data, encoding) {
	        if (Buffer.from && Buffer.from !== Uint8Array.from) {
	            return Buffer.from(data, encoding);
	        } else {
	            if (typeof data === "number") {
	                // Safeguard for old Node.js versions. On newer versions,
	                // Buffer.from(number) / Buffer(number, encoding) already throw.
	                throw new Error("The \"data\" argument must not be a number");
	            }
	            return new Buffer(data, encoding);
	        }
	    },
	    /**
	     * Create a new nodejs Buffer with the specified size.
	     * @param {Integer} size the size of the buffer.
	     * @return {Buffer} a new Buffer.
	     */
	    allocBuffer: function (size) {
	        if (Buffer.alloc) {
	            return Buffer.alloc(size);
	        } else {
	            var buf = new Buffer(size);
	            buf.fill(0);
	            return buf;
	        }
	    },
	    /**
	     * Find out if an object is a Buffer.
	     * @param {Object} b the object to test.
	     * @return {Boolean} true if the object is a Buffer, false otherwise.
	     */
	    isBuffer : function(b){
	        return Buffer.isBuffer(b);
	    },
	
	    isStream : function (obj) {
	        return obj &&
	            typeof obj.on === "function" &&
	            typeof obj.pause === "function" &&
	            typeof obj.resume === "function";
	    }
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(146).Buffer))

/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	if (typeof process === 'undefined' ||
	    !process.version ||
	    process.version.indexOf('v0.') === 0 ||
	    process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) {
	  module.exports = { nextTick: nextTick };
	} else {
	  module.exports = process
	}
	
	function nextTick(fn, arg1, arg2, arg3) {
	  if (typeof fn !== 'function') {
	    throw new TypeError('"callback" argument must be a function');
	  }
	  var len = arguments.length;
	  var args, i;
	  switch (len) {
	  case 0:
	  case 1:
	    return process.nextTick(fn);
	  case 2:
	    return process.nextTick(function afterTickOne() {
	      fn.call(null, arg1);
	    });
	  case 3:
	    return process.nextTick(function afterTickTwo() {
	      fn.call(null, arg1, arg2);
	    });
	  case 4:
	    return process.nextTick(function afterTickThree() {
	      fn.call(null, arg1, arg2, arg3);
	    });
	  default:
	    args = new Array(len - 1);
	    i = 0;
	    while (i < args.length) {
	      args[i++] = arguments[i];
	    }
	    return process.nextTick(function afterTick() {
	      fn.apply(null, args);
	    });
	  }
	}
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(111)))

/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var isCallable = __webpack_require__(52);
	var tryToString = __webpack_require__(621);
	
	var $TypeError = TypeError;
	
	// `Assert: IsCallable(argument) is true`
	module.exports = function (argument) {
	  if (isCallable(argument)) return argument;
	  throw new $TypeError(tryToString(argument) + ' is not a function');
	};


/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var DESCRIPTORS = __webpack_require__(62);
	var definePropertyModule = __webpack_require__(75);
	var createPropertyDescriptor = __webpack_require__(162);
	
	module.exports = DESCRIPTORS ? function (object, key, value) {
	  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var fails = __webpack_require__(50);
	
	module.exports = !fails(function () {
	  // eslint-disable-next-line es/no-function-prototype-bind -- safe
	  var test = function () { /* empty */ }.bind();
	  // eslint-disable-next-line no-prototype-builtins -- safe
	  return typeof test != 'function' || test.hasOwnProperty('prototype');
	});


/***/ },
/* 206 */
/***/ function(module, exports) {

	'use strict';
	module.exports = {};


/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var getBuiltIn = __webpack_require__(113);
	var isCallable = __webpack_require__(52);
	var isPrototypeOf = __webpack_require__(289);
	var USE_SYMBOL_AS_UID = __webpack_require__(622);
	
	var $Object = Object;
	
	module.exports = USE_SYMBOL_AS_UID ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  var $Symbol = getBuiltIn('Symbol');
	  return isCallable($Symbol) && isPrototypeOf($Symbol.prototype, $Object(it));
	};


/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var defineProperty = __webpack_require__(75).f;
	var hasOwn = __webpack_require__(51);
	var wellKnownSymbol = __webpack_require__(76);
	
	var TO_STRING_TAG = wellKnownSymbol('toStringTag');
	
	module.exports = function (target, TAG, STATIC) {
	  if (target && !STATIC) target = target.prototype;
	  if (target && !hasOwn(target, TO_STRING_TAG)) {
	    defineProperty(target, TO_STRING_TAG, { configurable: true, value: TAG });
	  }
	};


/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var shared = __webpack_require__(166);
	var uid = __webpack_require__(210);
	
	var keys = shared('keys');
	
	module.exports = function (key) {
	  return keys[key] || (keys[key] = uid(key));
	};


/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var uncurryThis = __webpack_require__(44);
	
	var id = 0;
	var postfix = Math.random();
	var toString = uncurryThis(1.1.toString);
	
	module.exports = function (key) {
	  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString(++id + postfix, 36);
	};


/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __importDefault = (this && this.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.WorkplaceShareButton = exports.WorkplaceIcon = exports.WhatsappShareButton = exports.WhatsappIcon = exports.WeiboShareButton = exports.WeiboIcon = exports.VKShareCount = exports.VKShareButton = exports.VKIcon = exports.ViberShareButton = exports.ViberIcon = exports.TwitterShareButton = exports.TwitterIcon = exports.TumblrShareCount = exports.TumblrShareButton = exports.TumblrIcon = exports.TelegramShareButton = exports.TelegramIcon = exports.RedditShareCount = exports.RedditShareButton = exports.RedditIcon = exports.PocketShareButton = exports.PocketIcon = exports.PinterestShareCount = exports.PinterestShareButton = exports.PinterestIcon = exports.OKShareCount = exports.OKShareButton = exports.OKIcon = exports.MailruShareButton = exports.MailruIcon = exports.LivejournalShareButton = exports.LivejournalIcon = exports.LinkedinShareButton = exports.LinkedinIcon = exports.LineShareButton = exports.LineIcon = exports.InstapaperShareButton = exports.InstapaperIcon = exports.HatenaShareCount = exports.HatenaShareButton = exports.HatenaIcon = exports.FacebookShareCount = exports.FacebookShareButton = exports.FacebookMessengerShareButton = exports.FacebookMessengerIcon = exports.FacebookIcon = exports.EmailShareButton = exports.EmailIcon = void 0;
	var EmailIcon_1 = __webpack_require__(1459);
	Object.defineProperty(exports, "EmailIcon", { enumerable: true, get: function () { return __importDefault(EmailIcon_1).default; } });
	var EmailShareButton_1 = __webpack_require__(1460);
	Object.defineProperty(exports, "EmailShareButton", { enumerable: true, get: function () { return __importDefault(EmailShareButton_1).default; } });
	var FacebookIcon_1 = __webpack_require__(1461);
	Object.defineProperty(exports, "FacebookIcon", { enumerable: true, get: function () { return __importDefault(FacebookIcon_1).default; } });
	var FacebookMessengerIcon_1 = __webpack_require__(1462);
	Object.defineProperty(exports, "FacebookMessengerIcon", { enumerable: true, get: function () { return __importDefault(FacebookMessengerIcon_1).default; } });
	var FacebookMessengerShareButton_1 = __webpack_require__(1463);
	Object.defineProperty(exports, "FacebookMessengerShareButton", { enumerable: true, get: function () { return __importDefault(FacebookMessengerShareButton_1).default; } });
	var FacebookShareButton_1 = __webpack_require__(1464);
	Object.defineProperty(exports, "FacebookShareButton", { enumerable: true, get: function () { return __importDefault(FacebookShareButton_1).default; } });
	var FacebookShareCount_1 = __webpack_require__(1465);
	Object.defineProperty(exports, "FacebookShareCount", { enumerable: true, get: function () { return __importDefault(FacebookShareCount_1).default; } });
	var HatenaIcon_1 = __webpack_require__(1466);
	Object.defineProperty(exports, "HatenaIcon", { enumerable: true, get: function () { return __importDefault(HatenaIcon_1).default; } });
	var HatenaShareButton_1 = __webpack_require__(1467);
	Object.defineProperty(exports, "HatenaShareButton", { enumerable: true, get: function () { return __importDefault(HatenaShareButton_1).default; } });
	var HatenaShareCount_1 = __webpack_require__(1468);
	Object.defineProperty(exports, "HatenaShareCount", { enumerable: true, get: function () { return __importDefault(HatenaShareCount_1).default; } });
	var InstapaperIcon_1 = __webpack_require__(1469);
	Object.defineProperty(exports, "InstapaperIcon", { enumerable: true, get: function () { return __importDefault(InstapaperIcon_1).default; } });
	var InstapaperShareButton_1 = __webpack_require__(1470);
	Object.defineProperty(exports, "InstapaperShareButton", { enumerable: true, get: function () { return __importDefault(InstapaperShareButton_1).default; } });
	var LineIcon_1 = __webpack_require__(1471);
	Object.defineProperty(exports, "LineIcon", { enumerable: true, get: function () { return __importDefault(LineIcon_1).default; } });
	var LineShareButton_1 = __webpack_require__(1472);
	Object.defineProperty(exports, "LineShareButton", { enumerable: true, get: function () { return __importDefault(LineShareButton_1).default; } });
	var LinkedinIcon_1 = __webpack_require__(1473);
	Object.defineProperty(exports, "LinkedinIcon", { enumerable: true, get: function () { return __importDefault(LinkedinIcon_1).default; } });
	var LinkedinShareButton_1 = __webpack_require__(1474);
	Object.defineProperty(exports, "LinkedinShareButton", { enumerable: true, get: function () { return __importDefault(LinkedinShareButton_1).default; } });
	var LivejournalIcon_1 = __webpack_require__(1475);
	Object.defineProperty(exports, "LivejournalIcon", { enumerable: true, get: function () { return __importDefault(LivejournalIcon_1).default; } });
	var LivejournalShareButton_1 = __webpack_require__(1476);
	Object.defineProperty(exports, "LivejournalShareButton", { enumerable: true, get: function () { return __importDefault(LivejournalShareButton_1).default; } });
	var MailruIcon_1 = __webpack_require__(1477);
	Object.defineProperty(exports, "MailruIcon", { enumerable: true, get: function () { return __importDefault(MailruIcon_1).default; } });
	var MailruShareButton_1 = __webpack_require__(1478);
	Object.defineProperty(exports, "MailruShareButton", { enumerable: true, get: function () { return __importDefault(MailruShareButton_1).default; } });
	var OKIcon_1 = __webpack_require__(1479);
	Object.defineProperty(exports, "OKIcon", { enumerable: true, get: function () { return __importDefault(OKIcon_1).default; } });
	var OKShareButton_1 = __webpack_require__(1480);
	Object.defineProperty(exports, "OKShareButton", { enumerable: true, get: function () { return __importDefault(OKShareButton_1).default; } });
	var OKShareCount_1 = __webpack_require__(1481);
	Object.defineProperty(exports, "OKShareCount", { enumerable: true, get: function () { return __importDefault(OKShareCount_1).default; } });
	var PinterestIcon_1 = __webpack_require__(1482);
	Object.defineProperty(exports, "PinterestIcon", { enumerable: true, get: function () { return __importDefault(PinterestIcon_1).default; } });
	var PinterestShareButton_1 = __webpack_require__(1483);
	Object.defineProperty(exports, "PinterestShareButton", { enumerable: true, get: function () { return __importDefault(PinterestShareButton_1).default; } });
	var PinterestShareCount_1 = __webpack_require__(1484);
	Object.defineProperty(exports, "PinterestShareCount", { enumerable: true, get: function () { return __importDefault(PinterestShareCount_1).default; } });
	var PocketIcon_1 = __webpack_require__(1485);
	Object.defineProperty(exports, "PocketIcon", { enumerable: true, get: function () { return __importDefault(PocketIcon_1).default; } });
	var PocketShareButton_1 = __webpack_require__(1486);
	Object.defineProperty(exports, "PocketShareButton", { enumerable: true, get: function () { return __importDefault(PocketShareButton_1).default; } });
	var RedditIcon_1 = __webpack_require__(1487);
	Object.defineProperty(exports, "RedditIcon", { enumerable: true, get: function () { return __importDefault(RedditIcon_1).default; } });
	var RedditShareButton_1 = __webpack_require__(1488);
	Object.defineProperty(exports, "RedditShareButton", { enumerable: true, get: function () { return __importDefault(RedditShareButton_1).default; } });
	var RedditShareCount_1 = __webpack_require__(1489);
	Object.defineProperty(exports, "RedditShareCount", { enumerable: true, get: function () { return __importDefault(RedditShareCount_1).default; } });
	var TelegramIcon_1 = __webpack_require__(1491);
	Object.defineProperty(exports, "TelegramIcon", { enumerable: true, get: function () { return __importDefault(TelegramIcon_1).default; } });
	var TelegramShareButton_1 = __webpack_require__(1492);
	Object.defineProperty(exports, "TelegramShareButton", { enumerable: true, get: function () { return __importDefault(TelegramShareButton_1).default; } });
	var TumblrIcon_1 = __webpack_require__(1493);
	Object.defineProperty(exports, "TumblrIcon", { enumerable: true, get: function () { return __importDefault(TumblrIcon_1).default; } });
	var TumblrShareButton_1 = __webpack_require__(1494);
	Object.defineProperty(exports, "TumblrShareButton", { enumerable: true, get: function () { return __importDefault(TumblrShareButton_1).default; } });
	var TumblrShareCount_1 = __webpack_require__(1495);
	Object.defineProperty(exports, "TumblrShareCount", { enumerable: true, get: function () { return __importDefault(TumblrShareCount_1).default; } });
	var TwitterIcon_1 = __webpack_require__(1496);
	Object.defineProperty(exports, "TwitterIcon", { enumerable: true, get: function () { return __importDefault(TwitterIcon_1).default; } });
	var TwitterShareButton_1 = __webpack_require__(1497);
	Object.defineProperty(exports, "TwitterShareButton", { enumerable: true, get: function () { return __importDefault(TwitterShareButton_1).default; } });
	var ViberIcon_1 = __webpack_require__(1501);
	Object.defineProperty(exports, "ViberIcon", { enumerable: true, get: function () { return __importDefault(ViberIcon_1).default; } });
	var ViberShareButton_1 = __webpack_require__(1502);
	Object.defineProperty(exports, "ViberShareButton", { enumerable: true, get: function () { return __importDefault(ViberShareButton_1).default; } });
	var VKIcon_1 = __webpack_require__(1498);
	Object.defineProperty(exports, "VKIcon", { enumerable: true, get: function () { return __importDefault(VKIcon_1).default; } });
	var VKShareButton_1 = __webpack_require__(1499);
	Object.defineProperty(exports, "VKShareButton", { enumerable: true, get: function () { return __importDefault(VKShareButton_1).default; } });
	var VKShareCount_1 = __webpack_require__(1500);
	Object.defineProperty(exports, "VKShareCount", { enumerable: true, get: function () { return __importDefault(VKShareCount_1).default; } });
	var WeiboIcon_1 = __webpack_require__(1503);
	Object.defineProperty(exports, "WeiboIcon", { enumerable: true, get: function () { return __importDefault(WeiboIcon_1).default; } });
	var WeiboShareButton_1 = __webpack_require__(1504);
	Object.defineProperty(exports, "WeiboShareButton", { enumerable: true, get: function () { return __importDefault(WeiboShareButton_1).default; } });
	var WhatsappIcon_1 = __webpack_require__(1505);
	Object.defineProperty(exports, "WhatsappIcon", { enumerable: true, get: function () { return __importDefault(WhatsappIcon_1).default; } });
	var WhatsappShareButton_1 = __webpack_require__(1506);
	Object.defineProperty(exports, "WhatsappShareButton", { enumerable: true, get: function () { return __importDefault(WhatsappShareButton_1).default; } });
	var WorkplaceIcon_1 = __webpack_require__(1507);
	Object.defineProperty(exports, "WorkplaceIcon", { enumerable: true, get: function () { return __importDefault(WorkplaceIcon_1).default; } });
	var WorkplaceShareButton_1 = __webpack_require__(1508);
	Object.defineProperty(exports, "WorkplaceShareButton", { enumerable: true, get: function () { return __importDefault(WorkplaceShareButton_1).default; } });


/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(13));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(12));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(34));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _reactPopper = __webpack_require__(169);
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _DropdownContext = __webpack_require__(172);
	
	var _utils = __webpack_require__(11);
	
	/* eslint react/no-find-dom-node: 0 */
	// https://github.com/yannickcr/eslint-plugin-react/blob/master/docs/rules/no-find-dom-node.md
	var propTypes = {
	  a11y: _propTypes.default.bool,
	  disabled: _propTypes.default.bool,
	  direction: _propTypes.default.oneOf(['up', 'down', 'left', 'right']),
	  group: _propTypes.default.bool,
	  isOpen: _propTypes.default.bool,
	  nav: _propTypes.default.bool,
	  active: _propTypes.default.bool,
	  addonType: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.oneOf(['prepend', 'append'])]),
	  size: _propTypes.default.string,
	  tag: _utils.tagPropType,
	  toggle: _propTypes.default.func,
	  children: _propTypes.default.node,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  inNavbar: _propTypes.default.bool,
	  setActiveFromChild: _propTypes.default.bool
	};
	var defaultProps = {
	  a11y: true,
	  isOpen: false,
	  direction: 'down',
	  nav: false,
	  active: false,
	  addonType: false,
	  inNavbar: false,
	  setActiveFromChild: false
	};
	var preventDefaultKeys = [_utils.keyCodes.space, _utils.keyCodes.enter, _utils.keyCodes.up, _utils.keyCodes.down, _utils.keyCodes.end, _utils.keyCodes.home];
	
	var Dropdown =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Dropdown, _React$Component);
	
	  function Dropdown(props) {
	    var _this;
	
	    _this = _React$Component.call(this, props) || this;
	    _this.addEvents = _this.addEvents.bind((0, _assertThisInitialized2.default)(_this));
	    _this.handleDocumentClick = _this.handleDocumentClick.bind((0, _assertThisInitialized2.default)(_this));
	    _this.handleKeyDown = _this.handleKeyDown.bind((0, _assertThisInitialized2.default)(_this));
	    _this.removeEvents = _this.removeEvents.bind((0, _assertThisInitialized2.default)(_this));
	    _this.toggle = _this.toggle.bind((0, _assertThisInitialized2.default)(_this));
	    _this.containerRef = _react.default.createRef();
	    return _this;
	  }
	
	  var _proto = Dropdown.prototype;
	
	  _proto.getContextValue = function getContextValue() {
	    return {
	      toggle: this.toggle,
	      isOpen: this.props.isOpen,
	      direction: this.props.direction === 'down' && this.props.dropup ? 'up' : this.props.direction,
	      inNavbar: this.props.inNavbar,
	      disabled: this.props.disabled
	    };
	  };
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.handleProps();
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
	    if (this.props.isOpen !== prevProps.isOpen) {
	      this.handleProps();
	    }
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.removeEvents();
	  };
	
	  _proto.getContainer = function getContainer() {
	    return this.containerRef.current;
	  };
	
	  _proto.getMenuCtrl = function getMenuCtrl() {
	    if (this._$menuCtrl) return this._$menuCtrl;
	    this._$menuCtrl = this.getContainer().querySelector('[aria-expanded]');
	    return this._$menuCtrl;
	  };
	
	  _proto.getMenuItems = function getMenuItems() {
	    return [].slice.call(this.getContainer().querySelectorAll('[role="menuitem"]'));
	  };
	
	  _proto.addEvents = function addEvents() {
	    var _this2 = this;
	
	    ['click', 'touchstart', 'keyup'].forEach(function (event) {
	      return document.addEventListener(event, _this2.handleDocumentClick, true);
	    });
	  };
	
	  _proto.removeEvents = function removeEvents() {
	    var _this3 = this;
	
	    ['click', 'touchstart', 'keyup'].forEach(function (event) {
	      return document.removeEventListener(event, _this3.handleDocumentClick, true);
	    });
	  };
	
	  _proto.handleDocumentClick = function handleDocumentClick(e) {
	    if (e && (e.which === 3 || e.type === 'keyup' && e.which !== _utils.keyCodes.tab)) return;
	    var container = this.getContainer();
	
	    if (container.contains(e.target) && container !== e.target && (e.type !== 'keyup' || e.which === _utils.keyCodes.tab)) {
	      return;
	    }
	
	    this.toggle(e);
	  };
	
	  _proto.handleKeyDown = function handleKeyDown(e) {
	    var _this4 = this;
	
	    if (/input|textarea/i.test(e.target.tagName) || _utils.keyCodes.tab === e.which && (e.target.getAttribute('role') !== 'menuitem' || !this.props.a11y)) {
	      return;
	    }
	
	    if (preventDefaultKeys.indexOf(e.which) !== -1 || e.which >= 48 && e.which <= 90) {
	      e.preventDefault();
	    }
	
	    if (this.props.disabled) return;
	
	    if (this.getMenuCtrl() === e.target) {
	      if (!this.props.isOpen && [_utils.keyCodes.space, _utils.keyCodes.enter, _utils.keyCodes.up, _utils.keyCodes.down].indexOf(e.which) > -1) {
	        this.toggle(e);
	        setTimeout(function () {
	          return _this4.getMenuItems()[0].focus();
	        });
	      } else if (this.props.isOpen && e.which === _utils.keyCodes.esc) {
	        this.toggle(e);
	      }
	    }
	
	    if (this.props.isOpen && e.target.getAttribute('role') === 'menuitem') {
	      if ([_utils.keyCodes.tab, _utils.keyCodes.esc].indexOf(e.which) > -1) {
	        this.toggle(e);
	        this.getMenuCtrl().focus();
	      } else if ([_utils.keyCodes.space, _utils.keyCodes.enter].indexOf(e.which) > -1) {
	        e.target.click();
	        this.getMenuCtrl().focus();
	      } else if ([_utils.keyCodes.down, _utils.keyCodes.up].indexOf(e.which) > -1 || [_utils.keyCodes.n, _utils.keyCodes.p].indexOf(e.which) > -1 && e.ctrlKey) {
	        var $menuitems = this.getMenuItems();
	        var index = $menuitems.indexOf(e.target);
	
	        if (_utils.keyCodes.up === e.which || _utils.keyCodes.p === e.which && e.ctrlKey) {
	          index = index !== 0 ? index - 1 : $menuitems.length - 1;
	        } else if (_utils.keyCodes.down === e.which || _utils.keyCodes.n === e.which && e.ctrlKey) {
	          index = index === $menuitems.length - 1 ? 0 : index + 1;
	        }
	
	        $menuitems[index].focus();
	      } else if (_utils.keyCodes.end === e.which) {
	        var _$menuitems = this.getMenuItems();
	
	        _$menuitems[_$menuitems.length - 1].focus();
	      } else if (_utils.keyCodes.home === e.which) {
	        var _$menuitems2 = this.getMenuItems();
	
	        _$menuitems2[0].focus();
	      } else if (e.which >= 48 && e.which <= 90) {
	        var _$menuitems3 = this.getMenuItems();
	
	        var charPressed = String.fromCharCode(e.which).toLowerCase();
	
	        for (var i = 0; i < _$menuitems3.length; i += 1) {
	          var firstLetter = _$menuitems3[i].textContent && _$menuitems3[i].textContent[0].toLowerCase();
	
	          if (firstLetter === charPressed) {
	            _$menuitems3[i].focus();
	
	            break;
	          }
	        }
	      }
	    }
	  };
	
	  _proto.handleProps = function handleProps() {
	    if (this.props.isOpen) {
	      this.addEvents();
	    } else {
	      this.removeEvents();
	    }
	  };
	
	  _proto.toggle = function toggle(e) {
	    if (this.props.disabled) {
	      return e && e.preventDefault();
	    }
	
	    return this.props.toggle(e);
	  };
	
	  _proto.render = function render() {
	    var _classNames, _ref;
	
	    var _omit = (0, _utils.omit)(this.props, ['toggle', 'disabled', 'inNavbar', 'a11y']),
	        className = _omit.className,
	        cssModule = _omit.cssModule,
	        direction = _omit.direction,
	        isOpen = _omit.isOpen,
	        group = _omit.group,
	        size = _omit.size,
	        nav = _omit.nav,
	        setActiveFromChild = _omit.setActiveFromChild,
	        active = _omit.active,
	        addonType = _omit.addonType,
	        tag = _omit.tag,
	        attrs = (0, _objectWithoutPropertiesLoose2.default)(_omit, ["className", "cssModule", "direction", "isOpen", "group", "size", "nav", "setActiveFromChild", "active", "addonType", "tag"]);
	
	    var Tag = tag || (nav ? 'li' : 'div');
	    var subItemIsActive = false;
	
	    if (setActiveFromChild) {
	      _react.default.Children.map(this.props.children[1].props.children, function (dropdownItem) {
	        if (dropdownItem && dropdownItem.props.active) subItemIsActive = true;
	      });
	    }
	
	    var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, direction !== 'down' && "drop" + direction, nav && active ? 'active' : false, setActiveFromChild && subItemIsActive ? 'active' : false, (_classNames = {}, _classNames["input-group-" + addonType] = addonType, _classNames['btn-group'] = group, _classNames["btn-group-" + size] = !!size, _classNames.dropdown = !group && !addonType, _classNames.show = isOpen, _classNames['nav-item'] = nav, _classNames)), cssModule);
	    return _react.default.createElement(_DropdownContext.DropdownContext.Provider, {
	      value: this.getContextValue()
	    }, _react.default.createElement(_reactPopper.Manager, null, _react.default.createElement(Tag, (0, _extends2.default)({}, attrs, (_ref = {}, _ref[typeof Tag === 'string' ? 'ref' : 'innerRef'] = this.containerRef, _ref), {
	      onKeyDown: this.handleKeyDown,
	      className: classes
	    }))));
	  };
	
	  return Dropdown;
	}(_react.default.Component);
	
	Dropdown.propTypes = propTypes;
	Dropdown.defaultProps = defaultProps;
	var _default = Dropdown;
	exports.default = _default;

/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	/* eslint-disable node/no-deprecated-api */
	var buffer = __webpack_require__(146)
	var Buffer = buffer.Buffer
	
	// alternative to using Object.keys for old browsers
	function copyProps (src, dst) {
	  for (var key in src) {
	    dst[key] = src[key]
	  }
	}
	if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
	  module.exports = buffer
	} else {
	  // Copy properties from require('buffer')
	  copyProps(buffer, exports)
	  exports.Buffer = SafeBuffer
	}
	
	function SafeBuffer (arg, encodingOrOffset, length) {
	  return Buffer(arg, encodingOrOffset, length)
	}
	
	// Copy static methods from Buffer
	copyProps(Buffer, SafeBuffer)
	
	SafeBuffer.from = function (arg, encodingOrOffset, length) {
	  if (typeof arg === 'number') {
	    throw new TypeError('Argument must not be a number')
	  }
	  return Buffer(arg, encodingOrOffset, length)
	}
	
	SafeBuffer.alloc = function (size, fill, encoding) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  var buf = Buffer(size)
	  if (fill !== undefined) {
	    if (typeof encoding === 'string') {
	      buf.fill(fill, encoding)
	    } else {
	      buf.fill(fill)
	    }
	  } else {
	    buf.fill(0)
	  }
	  return buf
	}
	
	SafeBuffer.allocUnsafe = function (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  return Buffer(size)
	}
	
	SafeBuffer.allocUnsafeSlow = function (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  return buffer.SlowBuffer(size)
	}


/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
	            (typeof self !== "undefined" && self) ||
	            window;
	var apply = Function.prototype.apply;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(scope, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// setimmediate attaches itself to the global object
	__webpack_require__(306);
	// On some exotic environments, it's not clear which object `setimmediate` was
	// able to install onto.  Search each possibility in the same order as the
	// `setimmediate` library.
	exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
	                       (typeof global !== "undefined" && global.setImmediate) ||
	                       (this && this.setImmediate);
	exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
	                         (typeof global !== "undefined" && global.clearImmediate) ||
	                         (this && this.clearImmediate);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icon1.4b6acc49.png";

/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icon2.dc9d9203.png";

/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icon3.d16ad720.png";

/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icon4.09a51552.png";

/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/approve.268f65a0.png";

/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/cash-on-delivery.b5209598.png";

/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/launch.c2998b73.png";

/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/signup.0ad91987.png";

/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/view1.8e91dc8f.png";

/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/view2.5b596116.png";

/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/view3.d3a4a779.png";

/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.handleFullscreenChange = handleFullscreenChange;
	exports.activate = activate;
	exports.userActivate = userActivate;
	exports.play = play;
	exports.pause = pause;
	exports.togglePlay = togglePlay;
	exports.seek = seek;
	exports.forward = forward;
	exports.replay = replay;
	exports.changeRate = changeRate;
	exports.changeVolume = changeVolume;
	exports.mute = mute;
	exports.toggleFullscreen = toggleFullscreen;
	exports.USER_ACTIVATE = exports.PLAYER_ACTIVATE = exports.FULLSCREEN_CHANGE = exports.OPERATE = void 0;
	
	var _fullscreen = _interopRequireDefault(__webpack_require__(690));
	
	var OPERATE = 'video-react/OPERATE';
	exports.OPERATE = OPERATE;
	var FULLSCREEN_CHANGE = 'video-react/FULLSCREEN_CHANGE';
	exports.FULLSCREEN_CHANGE = FULLSCREEN_CHANGE;
	var PLAYER_ACTIVATE = 'video-react/PLAYER_ACTIVATE';
	exports.PLAYER_ACTIVATE = PLAYER_ACTIVATE;
	var USER_ACTIVATE = 'video-react/USER_ACTIVATE';
	exports.USER_ACTIVATE = USER_ACTIVATE;
	
	function handleFullscreenChange(isFullscreen) {
	  return {
	    type: FULLSCREEN_CHANGE,
	    isFullscreen: isFullscreen
	  };
	}
	
	function activate(activity) {
	  return {
	    type: PLAYER_ACTIVATE,
	    activity: activity
	  };
	}
	
	function userActivate(activity) {
	  return {
	    type: USER_ACTIVATE,
	    activity: activity
	  };
	}
	
	function play() {
	  var operation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
	    action: 'play',
	    source: ''
	  };
	  this.video.play();
	  return {
	    type: OPERATE,
	    operation: operation
	  };
	}
	
	function pause() {
	  var operation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
	    action: 'pause',
	    source: ''
	  };
	  this.video.pause();
	  return {
	    type: OPERATE,
	    operation: operation
	  };
	}
	
	function togglePlay() {
	  var operation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
	    action: 'toggle-play',
	    source: ''
	  };
	  this.video.togglePlay();
	  return {
	    type: OPERATE,
	    operation: operation
	  };
	} // seek video by time
	
	
	function seek(time) {
	  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
	    action: 'seek',
	    source: ''
	  };
	  this.video.seek(time);
	  return {
	    type: OPERATE,
	    operation: operation
	  };
	} // jump forward x seconds
	
	
	function forward(seconds) {
	  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
	    action: "forward-".concat(seconds),
	    source: ''
	  };
	  this.video.forward(seconds);
	  return {
	    type: OPERATE,
	    operation: operation
	  };
	} // jump back x seconds
	
	
	function replay(seconds) {
	  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
	    action: "replay-".concat(seconds),
	    source: ''
	  };
	  this.video.replay(seconds);
	  return {
	    type: OPERATE,
	    operation: operation
	  };
	}
	
	function changeRate(rate) {
	  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
	    action: 'change-rate',
	    source: ''
	  };
	  this.video.playbackRate = rate;
	  return {
	    type: OPERATE,
	    operation: operation
	  };
	}
	
	function changeVolume(volume) {
	  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
	    action: 'change-volume',
	    source: ''
	  };
	  var v = volume;
	
	  if (volume < 0) {
	    v = 0;
	  }
	
	  if (volume > 1) {
	    v = 1;
	  }
	
	  this.video.volume = v;
	  return {
	    type: OPERATE,
	    operation: operation
	  };
	}
	
	function mute(muted) {
	  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
	    action: muted ? 'muted' : 'unmuted',
	    source: ''
	  };
	  this.video.muted = muted;
	  return {
	    type: OPERATE,
	    operation: operation
	  };
	}
	
	function toggleFullscreen(player) {
	  if (_fullscreen["default"].enabled) {
	    if (_fullscreen["default"].isFullscreen) {
	      _fullscreen["default"].exit();
	    } else {
	      _fullscreen["default"].request(this.rootElement);
	    }
	
	    return {
	      type: OPERATE,
	      operation: {
	        action: 'toggle-fullscreen',
	        source: ''
	      }
	    };
	  }
	
	  return {
	    type: FULLSCREEN_CHANGE,
	    isFullscreen: !player.isFullscreen
	  };
	}

/***/ },
/* 227 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.findElPosition = findElPosition;
	exports.getPointerPosition = getPointerPosition;
	exports.blurNode = blurNode;
	exports.focusNode = focusNode;
	exports.hasClass = hasClass;
	
	/**
	 * Offset Left
	 * getBoundingClientRect technique from
	 * John Resig http://ejohn.org/blog/getboundingclientrect-is-awesome/
	 *
	 * @function findElPosition
	 * @param {ReactNodeRef} el React Node ref from which to get offset
	 * @return {Object}
	 */
	function findElPosition(el) {
	  var box;
	
	  if (el.getBoundingClientRect && el.parentNode) {
	    box = el.getBoundingClientRect();
	  }
	
	  if (!box) {
	    return {
	      left: 0,
	      top: 0
	    };
	  }
	
	  var _document = document,
	      body = _document.body,
	      docEl = _document.documentElement;
	  var clientLeft = docEl.clientLeft || body.clientLeft || 0;
	  var scrollLeft = window.pageXOffset || body.scrollLeft;
	  var left = box.left + scrollLeft - clientLeft;
	  var clientTop = docEl.clientTop || body.clientTop || 0;
	  var scrollTop = window.pageYOffset || body.scrollTop;
	  var top = box.top + scrollTop - clientTop; // Android sometimes returns slightly off decimal values, so need to round
	
	  return {
	    left: Math.round(left),
	    top: Math.round(top)
	  };
	}
	/**
	 * Get pointer position in a React Node ref
	 * Returns an object with x and y coordinates.
	 * The base on the coordinates are the bottom left of the element.
	 *
	 * @function getPointerPosition
	 * @param {ReactNodeRef} el React Node ref on which to get the pointer position on
	 * @param {Event} event Event object
	 * @return {Object} This object will have x and y coordinates corresponding to the mouse position
	 */
	
	
	function getPointerPosition(el, event) {
	  var position = {};
	  var box = findElPosition(el);
	  var boxW = el.offsetWidth;
	  var boxH = el.offsetHeight;
	  var boxY = box.top;
	  var boxX = box.left;
	  var evtPageY = event.pageY;
	  var evtPageX = event.pageX;
	
	  if (event.changedTouches) {
	    evtPageX = event.changedTouches[0].pageX;
	    evtPageY = event.changedTouches[0].pageY;
	  }
	
	  position.y = Math.max(0, Math.min(1, (boxY - evtPageY + boxH) / boxH));
	  position.x = Math.max(0, Math.min(1, (evtPageX - boxX) / boxW));
	  return position;
	} // blur an element
	
	
	function blurNode(reactNode) {
	  if (reactNode && reactNode.blur) {
	    reactNode.blur();
	  }
	} // focus an element
	
	
	function focusNode(reactNode) {
	  if (reactNode && reactNode.focus) {
	    reactNode.focus();
	  }
	} // check if an element has a class name
	
	
	function hasClass(elm, cls) {
	  var classes = elm.className.split(' ');
	
	  for (var i = 0; i < classes.length; i++) {
	    if (classes[i].toLowerCase() === cls.toLowerCase()) {
	      return true;
	    }
	  }
	
	  return false;
	}

/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	if (typeof window !== "undefined") {
	  window.React = __webpack_require__(1);
	  window.ReactDOM = __webpack_require__(43);
	  window.createReactClass = __webpack_require__(1076);
	
	  __webpack_require__(692);
	
	  module.exports = window.AmCharts;
	
	} else {
	  module.exports = {};
	}


/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	var arrayLikeToArray = __webpack_require__(316);
	function _unsupportedIterableToArray(r, a) {
	  if (r) {
	    if ("string" == typeof r) return arrayLikeToArray(r, a);
	    var t = {}.toString.call(r).slice(8, -1);
	    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? arrayLikeToArray(r, a) : void 0;
	  }
	}
	module.exports = _unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.useFormControl = useFormControl;
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	/**
	 * @ignore - internal component.
	 */
	var FormControlContext = React.createContext();
	
	if (false) {
	  FormControlContext.displayName = 'FormControlContext';
	}
	
	function useFormControl() {
	  return React.useContext(FormControlContext);
	}
	
	var _default = FormControlContext;
	exports.default = _default;

/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Input.default;
	  }
	});
	
	var _Input = _interopRequireDefault(__webpack_require__(723));

/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _InputBase.default;
	  }
	});
	
	var _InputBase = _interopRequireDefault(__webpack_require__(724));

/***/ },
/* 233 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.hasValue = hasValue;
	exports.isFilled = isFilled;
	exports.isAdornedStart = isAdornedStart;
	
	// Supports determination of isControlled().
	// Controlled input accepts its current value as a prop.
	//
	// @see https://facebook.github.io/react/docs/forms.html#controlled-components
	// @param value
	// @returns {boolean} true if string (including '') or number (including zero)
	function hasValue(value) {
	  return value != null && !(Array.isArray(value) && value.length === 0);
	} // Determine if field is empty or filled.
	// Response determines if label is presented above field or as placeholder.
	//
	// @param obj
	// @param SSR
	// @returns {boolean} False when not present or empty string.
	//                    True when any number or string with length.
	
	
	function isFilled(obj) {
	  var SSR = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	  return obj && (hasValue(obj.value) && obj.value !== '' || SSR && hasValue(obj.defaultValue) && obj.defaultValue !== '');
	} // Determine if an Input is adorned on start.
	// It's corresponding to the left with LTR.
	//
	// @param obj
	// @returns {boolean} False when no adornments.
	//                    True when adorned at the start.
	
	
	function isAdornedStart(obj) {
	  return obj.startAdornment;
	}

/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createMuiTheme = createMuiTheme;
	exports.default = void 0;
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(24));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(25));
	
	var _utils = __webpack_require__(26);
	
	var _createBreakpoints = _interopRequireDefault(__webpack_require__(766));
	
	var _createMixins = _interopRequireDefault(__webpack_require__(767));
	
	var _createPalette = _interopRequireDefault(__webpack_require__(769));
	
	var _createTypography = _interopRequireDefault(__webpack_require__(772));
	
	var _shadows = _interopRequireDefault(__webpack_require__(777));
	
	var _shape = _interopRequireDefault(__webpack_require__(778));
	
	var _createSpacing = _interopRequireDefault(__webpack_require__(770));
	
	var _transitions = _interopRequireDefault(__webpack_require__(327));
	
	var _zIndex = _interopRequireDefault(__webpack_require__(328));
	
	function createTheme() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var _options$breakpoints = options.breakpoints,
	      breakpointsInput = _options$breakpoints === void 0 ? {} : _options$breakpoints,
	      _options$mixins = options.mixins,
	      mixinsInput = _options$mixins === void 0 ? {} : _options$mixins,
	      _options$palette = options.palette,
	      paletteInput = _options$palette === void 0 ? {} : _options$palette,
	      spacingInput = options.spacing,
	      _options$typography = options.typography,
	      typographyInput = _options$typography === void 0 ? {} : _options$typography,
	      other = (0, _objectWithoutProperties2.default)(options, ["breakpoints", "mixins", "palette", "spacing", "typography"]);
	  var palette = (0, _createPalette.default)(paletteInput);
	  var breakpoints = (0, _createBreakpoints.default)(breakpointsInput);
	  var spacing = (0, _createSpacing.default)(spacingInput);
	  var muiTheme = (0, _utils.deepmerge)({
	    breakpoints: breakpoints,
	    direction: 'ltr',
	    mixins: (0, _createMixins.default)(breakpoints, spacing, mixinsInput),
	    overrides: {},
	    // Inject custom styles
	    palette: palette,
	    props: {},
	    // Provide default props
	    shadows: _shadows.default,
	    typography: (0, _createTypography.default)(palette, typographyInput),
	    spacing: spacing,
	    shape: _shape.default,
	    transitions: _transitions.default,
	    zIndex: _zIndex.default
	  }, other);
	
	  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    args[_key - 1] = arguments[_key];
	  }
	
	  muiTheme = args.reduce(function (acc, argument) {
	    return (0, _utils.deepmerge)(acc, argument);
	  }, muiTheme);
	
	  if (false) {
	    var pseudoClasses = ['checked', 'disabled', 'error', 'focused', 'focusVisible', 'required', 'expanded', 'selected'];
	
	    var traverse = function traverse(node, parentKey) {
	      var depth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
	      var key; // eslint-disable-next-line guard-for-in, no-restricted-syntax
	
	      for (key in node) {
	        var child = node[key];
	
	        if (depth === 1) {
	          if (key.indexOf('Mui') === 0 && child) {
	            traverse(child, key, depth + 1);
	          }
	        } else if (pseudoClasses.indexOf(key) !== -1 && Object.keys(child).length > 0) {
	          if (process.env.NODE_ENV !== 'production') {
	            console.error(["Material-UI: The `".concat(parentKey, "` component increases ") + "the CSS specificity of the `".concat(key, "` internal state."), 'You can not override it like this: ', JSON.stringify(node, null, 2), '', 'Instead, you need to use the $ruleName syntax:', JSON.stringify({
	              root: (0, _defineProperty2.default)({}, "&$".concat(key), child)
	            }, null, 2), '', 'https://mui.com/r/pseudo-classes-guide'].join('\n'));
	          } // Remove the style to prevent global conflicts.
	
	
	          node[key] = {};
	        }
	      }
	    };
	
	    traverse(muiTheme.overrides);
	  }
	
	  return muiTheme;
	}
	
	var warnedOnce = false;
	
	function createMuiTheme() {
	  if (false) {
	    if (!warnedOnce) {
	      warnedOnce = true;
	      console.error(['Material-UI: the createMuiTheme function was renamed to createTheme.', '', "You should use `import { createTheme } from '@material-ui/core/styles'`"].join('\n'));
	    }
	  }
	
	  return createTheme.apply(void 0, arguments);
	}
	
	var _default = createTheme;
	exports.default = _default;

/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createSvgIcon;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _SvgIcon = _interopRequireDefault(__webpack_require__(751));
	
	/**
	 * Private module reserved for @material-ui/x packages.
	 */
	function createSvgIcon(path, displayName) {
	  var Component = function Component(props, ref) {
	    return /*#__PURE__*/_react.default.createElement(_SvgIcon.default, (0, _extends2.default)({
	      ref: ref
	    }, props), path);
	  };
	
	  if (false) {
	    // Need to set `displayName` on the inner component for React.memo.
	    // React prior to 16.14 ignores `displayName` on the wrapper.
	    Component.displayName = "".concat(displayName, "Icon");
	  }
	
	  Component.muiName = _SvgIcon.default.muiName;
	  return /*#__PURE__*/_react.default.memo( /*#__PURE__*/_react.default.forwardRef(Component));
	}

/***/ },
/* 236 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = debounce;
	
	// Corresponds to 10 frames at 60 Hz.
	// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
	function debounce(func) {
	  var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 166;
	  var timeout;
	
	  function debounced() {
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    // eslint-disable-next-line consistent-this
	    var that = this;
	
	    var later = function later() {
	      func.apply(that, args);
	    };
	
	    clearTimeout(timeout);
	    timeout = setTimeout(later, wait);
	  }
	
	  debounced.clear = function () {
	    clearTimeout(timeout);
	  };
	
	  return debounced;
	}

/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "capitalize", {
	  enumerable: true,
	  get: function get() {
	    return _capitalize.default;
	  }
	});
	Object.defineProperty(exports, "createChainedFunction", {
	  enumerable: true,
	  get: function get() {
	    return _createChainedFunction.default;
	  }
	});
	Object.defineProperty(exports, "createSvgIcon", {
	  enumerable: true,
	  get: function get() {
	    return _createSvgIcon.default;
	  }
	});
	Object.defineProperty(exports, "debounce", {
	  enumerable: true,
	  get: function get() {
	    return _debounce.default;
	  }
	});
	Object.defineProperty(exports, "deprecatedPropType", {
	  enumerable: true,
	  get: function get() {
	    return _deprecatedPropType.default;
	  }
	});
	Object.defineProperty(exports, "isMuiElement", {
	  enumerable: true,
	  get: function get() {
	    return _isMuiElement.default;
	  }
	});
	Object.defineProperty(exports, "ownerDocument", {
	  enumerable: true,
	  get: function get() {
	    return _ownerDocument.default;
	  }
	});
	Object.defineProperty(exports, "ownerWindow", {
	  enumerable: true,
	  get: function get() {
	    return _ownerWindow.default;
	  }
	});
	Object.defineProperty(exports, "requirePropFactory", {
	  enumerable: true,
	  get: function get() {
	    return _requirePropFactory.default;
	  }
	});
	Object.defineProperty(exports, "setRef", {
	  enumerable: true,
	  get: function get() {
	    return _setRef.default;
	  }
	});
	Object.defineProperty(exports, "unsupportedProp", {
	  enumerable: true,
	  get: function get() {
	    return _unsupportedProp.default;
	  }
	});
	Object.defineProperty(exports, "useControlled", {
	  enumerable: true,
	  get: function get() {
	    return _useControlled.default;
	  }
	});
	Object.defineProperty(exports, "useEventCallback", {
	  enumerable: true,
	  get: function get() {
	    return _useEventCallback.default;
	  }
	});
	Object.defineProperty(exports, "useForkRef", {
	  enumerable: true,
	  get: function get() {
	    return _useForkRef.default;
	  }
	});
	Object.defineProperty(exports, "unstable_useId", {
	  enumerable: true,
	  get: function get() {
	    return _unstable_useId.default;
	  }
	});
	Object.defineProperty(exports, "useIsFocusVisible", {
	  enumerable: true,
	  get: function get() {
	    return _useIsFocusVisible.default;
	  }
	});
	
	var _capitalize = _interopRequireDefault(__webpack_require__(78));
	
	var _createChainedFunction = _interopRequireDefault(__webpack_require__(179));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(235));
	
	var _debounce = _interopRequireDefault(__webpack_require__(236));
	
	var _deprecatedPropType = _interopRequireDefault(__webpack_require__(94));
	
	var _isMuiElement = _interopRequireDefault(__webpack_require__(330));
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(95));
	
	var _ownerWindow = _interopRequireDefault(__webpack_require__(238));
	
	var _requirePropFactory = _interopRequireDefault(__webpack_require__(782));
	
	var _setRef = _interopRequireDefault(__webpack_require__(143));
	
	var _unsupportedProp = _interopRequireDefault(__webpack_require__(331));
	
	var _useControlled = _interopRequireDefault(__webpack_require__(332));
	
	var _useEventCallback = _interopRequireDefault(__webpack_require__(180));
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(68));
	
	var _unstable_useId = _interopRequireDefault(__webpack_require__(783));
	
	var _useIsFocusVisible = _interopRequireDefault(__webpack_require__(333));

/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ownerWindow;
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(95));
	
	function ownerWindow(node) {
	  var doc = (0, _ownerDocument.default)(node);
	  return doc.defaultView || window;
	}

/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var _exportNames = {};
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _StylesProvider.default;
	  }
	});
	
	var _StylesProvider = _interopRequireWildcard(__webpack_require__(791));
	
	Object.keys(_StylesProvider).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _StylesProvider[key];
	    }
	  });
	});

/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _createGenerateClassName.default;
	  }
	});
	
	var _createGenerateClassName = _interopRequireDefault(__webpack_require__(794));

/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _makeStyles.default;
	  }
	});
	
	var _makeStyles = _interopRequireDefault(__webpack_require__(802));

/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.handleBreakpoints = handleBreakpoints;
	exports.default = void 0;
	
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(103));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _typeof2 = _interopRequireDefault(__webpack_require__(56));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _merge = _interopRequireDefault(__webpack_require__(182));
	
	// The breakpoint **start** at this value.
	// For instance with the first breakpoint xs: [xs, sm[.
	var values = {
	  xs: 0,
	  sm: 600,
	  md: 960,
	  lg: 1280,
	  xl: 1920
	};
	var defaultBreakpoints = {
	  // Sorted ASC by size. That's important.
	  // It can't be configured as it's used statically for propTypes.
	  keys: ['xs', 'sm', 'md', 'lg', 'xl'],
	  up: function up(key) {
	    return "@media (min-width:".concat(values[key], "px)");
	  }
	};
	
	function handleBreakpoints(props, propValue, styleFromPropValue) {
	  if (false) {
	    if (!props.theme) {
	      console.error('Material-UI: You are calling a style function without a theme value.');
	    }
	  }
	
	  if (Array.isArray(propValue)) {
	    var themeBreakpoints = props.theme.breakpoints || defaultBreakpoints;
	    return propValue.reduce(function (acc, item, index) {
	      acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
	      return acc;
	    }, {});
	  }
	
	  if ((0, _typeof2.default)(propValue) === 'object') {
	    var _themeBreakpoints = props.theme.breakpoints || defaultBreakpoints;
	
	    return Object.keys(propValue).reduce(function (acc, breakpoint) {
	      acc[_themeBreakpoints.up(breakpoint)] = styleFromPropValue(propValue[breakpoint]);
	      return acc;
	    }, {});
	  }
	
	  var output = styleFromPropValue(propValue);
	  return output;
	}
	
	function breakpoints(styleFunction) {
	  var newStyleFunction = function newStyleFunction(props) {
	    var base = styleFunction(props);
	    var themeBreakpoints = props.theme.breakpoints || defaultBreakpoints;
	    var extended = themeBreakpoints.keys.reduce(function (acc, key) {
	      if (props[key]) {
	        acc = acc || {};
	        acc[themeBreakpoints.up(key)] = styleFunction((0, _extends2.default)({
	          theme: props.theme
	        }, props[key]));
	      }
	
	      return acc;
	    }, null);
	    return (0, _merge.default)(base, extended);
	  };
	
	  newStyleFunction.propTypes =  false ? (0, _extends2.default)({}, styleFunction.propTypes, {
	    xs: _propTypes.default.object,
	    sm: _propTypes.default.object,
	    md: _propTypes.default.object,
	    lg: _propTypes.default.object,
	    xl: _propTypes.default.object
	  }) : {};
	  newStyleFunction.filterProps = ['xs', 'sm', 'md', 'lg', 'xl'].concat((0, _toConsumableArray2.default)(styleFunction.filterProps));
	  return newStyleFunction;
	}
	
	var _default = breakpoints;
	exports.default = _default;

/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = chainPropTypes;
	
	function chainPropTypes(propType1, propType2) {
	  if (true) {
	    return function () {
	      return null;
	    };
	  }
	
	  return function validate() {
	    return propType1.apply(void 0, arguments) || propType2.apply(void 0, arguments);
	  };
	}

/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var PDFExport_1 = __webpack_require__(834);
	exports.PDFExport = PDFExport_1.default;
	var PDFMargin_1 = __webpack_require__(344);
	exports.PDFMargin = PDFMargin_1.PDFMargin;
	var savePDF_1 = __webpack_require__(245);
	exports.savePDF = savePDF_1.savePDF;
	var getPageMargin_1 = __webpack_require__(183);
	exports.getPageMargin = getPageMargin_1.getPageMargin;
	var GridPDFExport_1 = __webpack_require__(836);
	exports.GridPDFExport = GridPDFExport_1.GridPDFExport;
	var TreeListPDFExport_1 = __webpack_require__(840);
	exports.TreeListPDFExport = TreeListPDFExport_1.TreeListPDFExport;
	//# sourceMappingURL=main.js.map

/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var kendo_drawing_1 = __webpack_require__(341);
	var kendo_file_saver_1 = __webpack_require__(342);
	var KendoDrawingAdapter_1 = __webpack_require__(343);
	/**
	 * Saves the content of a DOM element to a PDF file.
	 *
	 * @param domElement - The root DOM element to save to a PDF file.
	 * @param options - The export options.
	 * @param callback - The callback to be executed after the PDF is saved.
	 */
	function savePDF(domElement, options, callback) {
	    if (options === void 0) { options = {}; }
	    new KendoDrawingAdapter_1.default(kendo_drawing_1.drawDOM, kendo_drawing_1.exportPDF, kendo_file_saver_1.saveAs, domElement, options).savePDF(callback);
	}
	exports.savePDF = savePDF;
	//# sourceMappingURL=savePDF.js.map

/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	var utils = __webpack_require__(63);
	var normalizeHeaderName = __webpack_require__(861);
	var enhanceError = __webpack_require__(353);
	
	var DEFAULT_CONTENT_TYPE = {
	  'Content-Type': 'application/x-www-form-urlencoded'
	};
	
	function setContentTypeIfUnset(headers, value) {
	  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
	    headers['Content-Type'] = value;
	  }
	}
	
	function getDefaultAdapter() {
	  var adapter;
	  if (typeof XMLHttpRequest !== 'undefined') {
	    // For browsers use XHR adapter
	    adapter = __webpack_require__(349);
	  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
	    // For node use HTTP adapter
	    adapter = __webpack_require__(349);
	  }
	  return adapter;
	}
	
	function stringifySafely(rawValue, parser, encoder) {
	  if (utils.isString(rawValue)) {
	    try {
	      (parser || JSON.parse)(rawValue);
	      return utils.trim(rawValue);
	    } catch (e) {
	      if (e.name !== 'SyntaxError') {
	        throw e;
	      }
	    }
	  }
	
	  return (encoder || JSON.stringify)(rawValue);
	}
	
	var defaults = {
	
	  transitional: {
	    silentJSONParsing: true,
	    forcedJSONParsing: true,
	    clarifyTimeoutError: false
	  },
	
	  adapter: getDefaultAdapter(),
	
	  transformRequest: [function transformRequest(data, headers) {
	    normalizeHeaderName(headers, 'Accept');
	    normalizeHeaderName(headers, 'Content-Type');
	
	    if (utils.isFormData(data) ||
	      utils.isArrayBuffer(data) ||
	      utils.isBuffer(data) ||
	      utils.isStream(data) ||
	      utils.isFile(data) ||
	      utils.isBlob(data)
	    ) {
	      return data;
	    }
	    if (utils.isArrayBufferView(data)) {
	      return data.buffer;
	    }
	    if (utils.isURLSearchParams(data)) {
	      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
	      return data.toString();
	    }
	    if (utils.isObject(data) || (headers && headers['Content-Type'] === 'application/json')) {
	      setContentTypeIfUnset(headers, 'application/json');
	      return stringifySafely(data);
	    }
	    return data;
	  }],
	
	  transformResponse: [function transformResponse(data) {
	    var transitional = this.transitional;
	    var silentJSONParsing = transitional && transitional.silentJSONParsing;
	    var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
	    var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';
	
	    if (strictJSONParsing || (forcedJSONParsing && utils.isString(data) && data.length)) {
	      try {
	        return JSON.parse(data);
	      } catch (e) {
	        if (strictJSONParsing) {
	          if (e.name === 'SyntaxError') {
	            throw enhanceError(e, this, 'E_JSON_PARSE');
	          }
	          throw e;
	        }
	      }
	    }
	
	    return data;
	  }],
	
	  /**
	   * A timeout in milliseconds to abort a request. If set to 0 (default) a
	   * timeout is not created.
	   */
	  timeout: 0,
	
	  xsrfCookieName: 'XSRF-TOKEN',
	  xsrfHeaderName: 'X-XSRF-TOKEN',
	
	  maxContentLength: -1,
	  maxBodyLength: -1,
	
	  validateStatus: function validateStatus(status) {
	    return status >= 200 && status < 300;
	  }
	};
	
	defaults.headers = {
	  common: {
	    'Accept': 'application/json, text/plain, */*'
	  }
	};
	
	utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
	  defaults.headers[method] = {};
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
	});
	
	module.exports = defaults;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(111)))

/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constant = __webpack_require__(21);
	
	var _reactHelmet = __webpack_require__(77);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import jQuery from 'jquery';
	
	
	var foot = function (_React$Component) {
	    _inherits(foot, _React$Component);
	
	    function foot(props) {
	        _classCallCheck(this, foot);
	
	        //const { history } = this.props;
	        var _this = _possibleConstructorReturn(this, (foot.__proto__ || Object.getPrototypeOf(foot)).call(this, props));
	
	        _this.state = {
	            logged: localStorage.getItem("authentication"),
	            auth_data: JSON.parse(localStorage.getItem("user_data")),
	            logged_user_name: ''
	        };
	        return _this;
	    }
	
	    _createClass(foot, [{
	        key: 'logoutFunc',
	        value: function logoutFunc(e) {
	            e.preventDefault();
	            this.props.logoutSubmit();
	        }
	    }, {
	        key: 'logoutSess',
	        value: function logoutSess(e) {
	            localStorage.clear();
	            setTimeout(function () {
	                window.location = "/";
	            }, 1000);
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            if (this.state.logged !== 'true') {
	                this.props.history.push('/');
	            } else {
	                this.setState({
	                    vendor_role: this.state.auth_data.role,
	                    access_url: this.state.auth_data.access,
	                    logged_user_name: this.state.auth_data.user_name
	                });
	            }
	            // console.log('user data', this.state.auth_data)
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'pull-right' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'notify-wrap' },
	                        _react2.default.createElement(
	                            'a',
	                            { href: 'javascript:;' },
	                            _react2.default.createElement('img', { src: _constant.BASEURL + "assets/images/notification-icon.svg", alt: 'Notification' })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'profile-wrap dropdown' },
	                        _react2.default.createElement(
	                            'a',
	                            { href: '#', className: 'avatar dropdown-toggle', 'data-toggle': 'dropdown' },
	                            _react2.default.createElement(
	                                'span',
	                                { className: 'hidden-xs' },
	                                this.state.logged_user_name
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'ul',
	                            { className: 'dropdown-menu' },
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                _react2.default.createElement(
	                                    'a',
	                                    { href: 'javascript:;' },
	                                    _react2.default.createElement('img', { src: _constant.BASEURL + "assets/images/edit-icon.svg", alt: 'icon' }),
	                                    'Edit Profile'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                _react2.default.createElement(
	                                    'a',
	                                    { href: 'javascript:;' },
	                                    _react2.default.createElement('img', { src: _constant.BASEURL + "assets/images/settings-icon.svg", alt: 'icon' }),
	                                    'Change Password'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                _react2.default.createElement(
	                                    'a',
	                                    { onClick: function onClick(e) {
	                                            return _this2.logoutSess(e);
	                                        } },
	                                    _react2.default.createElement('img', { src: _constant.BASEURL + "assets/images/turn-off-icon.svg", alt: 'icon' }),
	                                    'Logout'
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return foot;
	}(_react2.default.Component);
	
	exports.default = foot;

/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constant = __webpack_require__(21);
	
	var _reactHelmet = __webpack_require__(77);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import jQuery from 'jquery';
	
	
	var head = function (_React$Component) {
	    _inherits(head, _React$Component);
	
	    function head(props) {
	        _classCallCheck(this, head);
	
	        //const { history } = this.props;
	        var _this = _possibleConstructorReturn(this, (head.__proto__ || Object.getPrototypeOf(head)).call(this, props));
	
	        _this.state = {
	            logged: localStorage.getItem("authentication"),
	            auth_data: JSON.parse(localStorage.getItem("user_data")),
	            logged_user_name: ''
	        };
	        return _this;
	    }
	
	    _createClass(head, [{
	        key: 'logoutFunc',
	        value: function logoutFunc(e) {
	            e.preventDefault();
	            this.props.logoutSubmit();
	        }
	    }, {
	        key: 'logoutSess',
	        value: function logoutSess(e) {
	            localStorage.clear();
	            setTimeout(function () {
	                window.location = "/";
	            }, 1000);
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {}
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { 'class': 'container exclpartners' },
	                    _react2.default.createElement(
	                        'nav',
	                        { 'class': 'navbar navbar-inverse' },
	                        _react2.default.createElement(
	                            'div',
	                            { 'class': 'navbar-header' },
	                            _react2.default.createElement(
	                                'button',
	                                { type: 'button', 'data-target': '#navbarCollapse', 'data-toggle': 'collapse', 'class': 'navbar-toggle' },
	                                _react2.default.createElement(
	                                    'span',
	                                    { 'class': 'sr-only' },
	                                    'Toggle navigation'
	                                ),
	                                _react2.default.createElement('span', { 'class': 'icon-bar' }),
	                                _react2.default.createElement('span', { 'class': 'icon-bar' }),
	                                _react2.default.createElement('span', { 'class': 'icon-bar' })
	                            ),
	                            _react2.default.createElement(
	                                'a',
	                                { href: '#', 'class': 'navbar-brand' },
	                                _react2.default.createElement('img', { src: '/assets/bewiseLogo.png', alt: 'logo'
	                                    // className='profile-round mCS_img_loaded' 
	                                })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { id: 'navbarCollapse', 'class': 'collapse navbar-collapse' },
	                            _react2.default.createElement(
	                                'ul',
	                                { 'class': 'nav navbar-nav' },
	                                _react2.default.createElement(
	                                    'li',
	                                    { 'class': 'active' },
	                                    _react2.default.createElement(
	                                        'a',
	                                        { href: '#' },
	                                        'Dashboard'
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'li',
	                                    null,
	                                    _react2.default.createElement(
	                                        'a',
	                                        { href: '#' },
	                                        'Profile'
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'li',
	                                    { 'class': 'dropdown' },
	                                    _react2.default.createElement(
	                                        'a',
	                                        { 'data-toggle': 'dropdown', 'class': 'dropdown-toggle', href: '#' },
	                                        'Activities ',
	                                        _react2.default.createElement('b', { 'class': 'caret' })
	                                    ),
	                                    _react2.default.createElement(
	                                        'ul',
	                                        { 'class': 'dropdown-menu' },
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            _react2.default.createElement(
	                                                'a',
	                                                { href: '#' },
	                                                'Create'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            _react2.default.createElement(
	                                                'a',
	                                                { href: '#' },
	                                                'View'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            _react2.default.createElement(
	                                                'a',
	                                                { href: '#' },
	                                                'Reports'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            _react2.default.createElement(
	                                                'a',
	                                                { href: '#' },
	                                                'Contact'
	                                            )
	                                        ),
	                                        '                                    '
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'form',
	                                { 'class': 'navbar-form navbar-left' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'input-group' },
	                                    _react2.default.createElement('input', { type: 'text', 'class': 'form-control', placeholder: 'Search' }),
	                                    _react2.default.createElement(
	                                        'span',
	                                        { 'class': 'input-group-btn' },
	                                        _react2.default.createElement(
	                                            'button',
	                                            { type: 'button', 'class': 'btn btn-default' },
	                                            _react2.default.createElement('span', { 'class': 'glyphicon glyphicon-search' })
	                                        )
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'ul',
	                                { 'class': 'nav navbar-nav navbar-right' },
	                                _react2.default.createElement(
	                                    'li',
	                                    null,
	                                    _react2.default.createElement(
	                                        'span',
	                                        { 'class': 'subtitleexcl' },
	                                        'Exclusive Partnerships'
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'li',
	                                    null,
	                                    _react2.default.createElement(
	                                        'a',
	                                        { href: '#' },
	                                        'Logout'
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return head;
	}(_react2.default.Component);
	
	exports.default = head;

/***/ },
/* 249 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./functionApply')} */
	module.exports = Function.prototype.apply;


/***/ },
/* 250 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./functionCall')} */
	module.exports = Function.prototype.call;


/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(156);
	var $TypeError = __webpack_require__(120);
	
	var $call = __webpack_require__(250);
	var $actualApply = __webpack_require__(370);
	
	/** @type {(args: [Function, thisArg?: unknown, ...args: unknown[]]) => Function} TODO FIXME, find a way to use import('.') */
	module.exports = function callBindBasic(args) {
		if (args.length < 1 || typeof args[0] !== 'function') {
			throw new $TypeError('a function is required');
		}
		return $actualApply(bind, $call, args);
	};


/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var setFunctionLength = __webpack_require__(1617);
	
	var $defineProperty = __webpack_require__(196);
	
	var callBindBasic = __webpack_require__(251);
	var applyBind = __webpack_require__(1072);
	
	module.exports = function callBind(originalFunction) {
		var func = callBindBasic(arguments);
		var adjustedLength = 1 + originalFunction.length - (arguments.length - 1);
		return setFunctionLength(
			func,
			adjustedLength > 0 ? adjustedLength : 0,
			true
		);
	};
	
	if ($defineProperty) {
		$defineProperty(module.exports, 'apply', { value: applyBind });
	} else {
		module.exports.apply = applyBind;
	}


/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getUTCWeekYear;
	var _index = _interopRequireDefault(__webpack_require__(23));
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	var _index3 = _interopRequireDefault(__webpack_require__(149));
	var _index4 = _interopRequireDefault(__webpack_require__(30));
	var _index5 = __webpack_require__(96);
	function getUTCWeekYear(dirtyDate, options) {
	  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var year = date.getUTCFullYear();
	  var defaultOptions = (0, _index5.getDefaultOptions)();
	  var firstWeekContainsDate = (0, _index4.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
	
	  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
	  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
	    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
	  }
	  var firstWeekOfNextYear = new Date(0);
	  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
	  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
	  var startOfNextYear = (0, _index3.default)(firstWeekOfNextYear, options);
	  var firstWeekOfThisYear = new Date(0);
	  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
	  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
	  var startOfThisYear = (0, _index3.default)(firstWeekOfThisYear, options);
	  if (date.getTime() >= startOfNextYear.getTime()) {
	    return year + 1;
	  } else if (date.getTime() >= startOfThisYear.getTime()) {
	    return year;
	  } else {
	    return year - 1;
	  }
	}
	module.exports = exports.default;

/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setUTCDay;
	var _index = _interopRequireDefault(__webpack_require__(23));
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	var _index3 = _interopRequireDefault(__webpack_require__(30));
	var _index4 = __webpack_require__(96);
	function setUTCDay(dirtyDate, dirtyDay, options) {
	  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
	  (0, _index2.default)(2, arguments);
	  var defaultOptions = (0, _index4.getDefaultOptions)();
	  var weekStartsOn = (0, _index3.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
	
	  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
	  }
	  var date = (0, _index.default)(dirtyDate);
	  var day = (0, _index3.default)(dirtyDay);
	  var currentDay = date.getUTCDay();
	  var remainder = day % 7;
	  var dayIndex = (remainder + 7) % 7;
	  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
	  date.setUTCDate(date.getUTCDate() + diff);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addDays;
	var _index = _interopRequireDefault(__webpack_require__(30));
	var _index2 = _interopRequireDefault(__webpack_require__(23));
	var _index3 = _interopRequireDefault(__webpack_require__(14));
	/**
	 * @name addDays
	 * @category Day Helpers
	 * @summary Add the specified number of days to the given date.
	 *
	 * @description
	 * Add the specified number of days to the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of days to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} - the new date with the days added
	 * @throws {TypeError} - 2 arguments required
	 *
	 * @example
	 * // Add 10 days to 1 September 2014:
	 * const result = addDays(new Date(2014, 8, 1), 10)
	 * //=> Thu Sep 11 2014 00:00:00
	 */
	function addDays(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var amount = (0, _index.default)(dirtyAmount);
	  if (isNaN(amount)) {
	    return new Date(NaN);
	  }
	  if (!amount) {
	    // If 0 days, no-op to avoid changing times in the hour before end of DST
	    return date;
	  }
	  date.setDate(date.getDate() + amount);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addMilliseconds;
	var _index = _interopRequireDefault(__webpack_require__(30));
	var _index2 = _interopRequireDefault(__webpack_require__(23));
	var _index3 = _interopRequireDefault(__webpack_require__(14));
	/**
	 * @name addMilliseconds
	 * @category Millisecond Helpers
	 * @summary Add the specified number of milliseconds to the given date.
	 *
	 * @description
	 * Add the specified number of milliseconds to the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the milliseconds added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
	 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
	 * //=> Thu Jul 10 2014 12:45:30.750
	 */
	function addMilliseconds(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var timestamp = (0, _index2.default)(dirtyDate).getTime();
	  var amount = (0, _index.default)(dirtyAmount);
	  return new Date(timestamp + amount);
	}
	module.exports = exports.default;

/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addMonths;
	var _index = _interopRequireDefault(__webpack_require__(30));
	var _index2 = _interopRequireDefault(__webpack_require__(23));
	var _index3 = _interopRequireDefault(__webpack_require__(14));
	/**
	 * @name addMonths
	 * @category Month Helpers
	 * @summary Add the specified number of months to the given date.
	 *
	 * @description
	 * Add the specified number of months to the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of months to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the months added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 5 months to 1 September 2014:
	 * const result = addMonths(new Date(2014, 8, 1), 5)
	 * //=> Sun Feb 01 2015 00:00:00
	 */
	function addMonths(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var amount = (0, _index.default)(dirtyAmount);
	  if (isNaN(amount)) {
	    return new Date(NaN);
	  }
	  if (!amount) {
	    // If 0 months, no-op to avoid changing times in the hour before end of DST
	    return date;
	  }
	  var dayOfMonth = date.getDate();
	
	  // The JS Date object supports date math by accepting out-of-bounds values for
	  // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
	  // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
	  // want except that dates will wrap around the end of a month, meaning that
	  // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
	  // we'll default to the end of the desired month by adding 1 to the desired
	  // month and using a date of 0 to back up one day to the end of the desired
	  // month.
	  var endOfDesiredMonth = new Date(date.getTime());
	  endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
	  var daysInMonth = endOfDesiredMonth.getDate();
	  if (dayOfMonth >= daysInMonth) {
	    // If we're already at the end of the month, then this is the correct date
	    // and we're done.
	    return endOfDesiredMonth;
	  } else {
	    // Otherwise, we now know that setting the original day-of-month value won't
	    // cause an overflow, so set the desired day-of-month. Note that we can't
	    // just set the date of `endOfDesiredMonth` because that object may have had
	    // its time changed in the unusual case where where a DST transition was on
	    // the last day of the month and its local time was in the hour skipped or
	    // repeated next to a DST transition.  So we use `date` instead which is
	    // guaranteed to still have the original time.
	    date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
	    return date;
	  }
	}
	module.exports = exports.default;

/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfDay;
	var _index = _interopRequireDefault(__webpack_require__(23));
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	/**
	 * @name startOfDay
	 * @category Day Helpers
	 * @summary Return the start of a day for the given date.
	 *
	 * @description
	 * Return the start of a day for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the start of a day
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The start of a day for 2 September 2014 11:55:00:
	 * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Tue Sep 02 2014 00:00:00
	 */
	function startOfDay(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfISOWeek;
	var _index = _interopRequireDefault(__webpack_require__(260));
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	/**
	 * @name startOfISOWeek
	 * @category ISO Week Helpers
	 * @summary Return the start of an ISO week for the given date.
	 *
	 * @description
	 * Return the start of an ISO week for the given date.
	 * The result will be in the local timezone.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the start of an ISO week
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The start of an ISO week for 2 September 2014 11:55:00:
	 * const result = startOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Mon Sep 01 2014 00:00:00
	 */
	function startOfISOWeek(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate, {
	    weekStartsOn: 1
	  });
	}
	module.exports = exports.default;

/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfWeek;
	var _index = _interopRequireDefault(__webpack_require__(23));
	var _index2 = _interopRequireDefault(__webpack_require__(30));
	var _index3 = _interopRequireDefault(__webpack_require__(14));
	var _index4 = __webpack_require__(96);
	/**
	 * @name startOfWeek
	 * @category Week Helpers
	 * @summary Return the start of a week for the given date.
	 *
	 * @description
	 * Return the start of a week for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|Number} date - the original date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Date} the start of a week
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 *
	 * @example
	 * // The start of a week for 2 September 2014 11:55:00:
	 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Sun Aug 31 2014 00:00:00
	 *
	 * @example
	 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
	 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
	 * //=> Mon Sep 01 2014 00:00:00
	 */
	function startOfWeek(dirtyDate, options) {
	  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
	  (0, _index3.default)(1, arguments);
	  var defaultOptions = (0, _index4.getDefaultOptions)();
	  var weekStartsOn = (0, _index2.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
	
	  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
	  }
	  var date = (0, _index.default)(dirtyDate);
	  var day = date.getDay();
	  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
	  date.setDate(date.getDate() - diff);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var $defineProperty = __webpack_require__(196);
	
	var $SyntaxError = __webpack_require__(426);
	var $TypeError = __webpack_require__(120);
	
	var gopd = __webpack_require__(125);
	
	/** @type {import('.')} */
	module.exports = function defineDataProperty(
		obj,
		property,
		value
	) {
		if (!obj || (typeof obj !== 'object' && typeof obj !== 'function')) {
			throw new $TypeError('`obj` must be an object or a function`');
		}
		if (typeof property !== 'string' && typeof property !== 'symbol') {
			throw new $TypeError('`property` must be a string or a symbol`');
		}
		if (arguments.length > 3 && typeof arguments[3] !== 'boolean' && arguments[3] !== null) {
			throw new $TypeError('`nonEnumerable`, if provided, must be a boolean or null');
		}
		if (arguments.length > 4 && typeof arguments[4] !== 'boolean' && arguments[4] !== null) {
			throw new $TypeError('`nonWritable`, if provided, must be a boolean or null');
		}
		if (arguments.length > 5 && typeof arguments[5] !== 'boolean' && arguments[5] !== null) {
			throw new $TypeError('`nonConfigurable`, if provided, must be a boolean or null');
		}
		if (arguments.length > 6 && typeof arguments[6] !== 'boolean') {
			throw new $TypeError('`loose`, if provided, must be a boolean');
		}
	
		var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
		var nonWritable = arguments.length > 4 ? arguments[4] : null;
		var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
		var loose = arguments.length > 6 ? arguments[6] : false;
	
		/* @type {false | TypedPropertyDescriptor<unknown>} */
		var desc = !!gopd && gopd(obj, property);
	
		if ($defineProperty) {
			$defineProperty(obj, property, {
				configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
				enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
				value: value,
				writable: nonWritable === null && desc ? desc.writable : !nonWritable
			});
		} else if (loose || (!nonEnumerable && !nonWritable && !nonConfigurable)) {
			// must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
			obj[property] = value; // eslint-disable-line no-param-reassign
		} else {
			throw new $SyntaxError('This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.');
		}
	};


/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	var BlockMapBuilder = __webpack_require__(151);
	
	var CharacterMetadata = __webpack_require__(70);
	
	var ContentBlock = __webpack_require__(104);
	
	var ContentBlockNode = __webpack_require__(71);
	
	var DraftEntity = __webpack_require__(190);
	
	var SelectionState = __webpack_require__(191);
	
	var generateRandomKey = __webpack_require__(85);
	
	var getOwnObjectValues = __webpack_require__(409);
	
	var gkx = __webpack_require__(97);
	
	var Immutable = __webpack_require__(27);
	
	var sanitizeDraftText = __webpack_require__(423);
	
	var List = Immutable.List,
	    Record = Immutable.Record,
	    Repeat = Immutable.Repeat,
	    ImmutableMap = Immutable.Map,
	    OrderedMap = Immutable.OrderedMap;
	var defaultRecord = {
	  entityMap: null,
	  blockMap: null,
	  selectionBefore: null,
	  selectionAfter: null
	};
	var ContentStateRecord = Record(defaultRecord);
	/* $FlowFixMe[signature-verification-failure] Supressing a `signature-
	 * verification-failure` error here. TODO: T65949050 Clean up the branch for
	 * this GK */
	
	var ContentBlockNodeRecord = gkx('draft_tree_data_support') ? ContentBlockNode : ContentBlock;
	
	var ContentState = /*#__PURE__*/function (_ContentStateRecord) {
	  _inheritsLoose(ContentState, _ContentStateRecord);
	
	  function ContentState() {
	    return _ContentStateRecord.apply(this, arguments) || this;
	  }
	
	  var _proto = ContentState.prototype;
	
	  _proto.getEntityMap = function getEntityMap() {
	    // TODO: update this when we fully remove DraftEntity
	    return DraftEntity;
	  };
	
	  _proto.getBlockMap = function getBlockMap() {
	    return this.get('blockMap');
	  };
	
	  _proto.getSelectionBefore = function getSelectionBefore() {
	    return this.get('selectionBefore');
	  };
	
	  _proto.getSelectionAfter = function getSelectionAfter() {
	    return this.get('selectionAfter');
	  };
	
	  _proto.getBlockForKey = function getBlockForKey(key) {
	    var block = this.getBlockMap().get(key);
	    return block;
	  };
	
	  _proto.getKeyBefore = function getKeyBefore(key) {
	    return this.getBlockMap().reverse().keySeq().skipUntil(function (v) {
	      return v === key;
	    }).skip(1).first();
	  };
	
	  _proto.getKeyAfter = function getKeyAfter(key) {
	    return this.getBlockMap().keySeq().skipUntil(function (v) {
	      return v === key;
	    }).skip(1).first();
	  };
	
	  _proto.getBlockAfter = function getBlockAfter(key) {
	    return this.getBlockMap().skipUntil(function (_, k) {
	      return k === key;
	    }).skip(1).first();
	  };
	
	  _proto.getBlockBefore = function getBlockBefore(key) {
	    return this.getBlockMap().reverse().skipUntil(function (_, k) {
	      return k === key;
	    }).skip(1).first();
	  };
	
	  _proto.getBlocksAsArray = function getBlocksAsArray() {
	    return this.getBlockMap().toArray();
	  };
	
	  _proto.getFirstBlock = function getFirstBlock() {
	    return this.getBlockMap().first();
	  };
	
	  _proto.getLastBlock = function getLastBlock() {
	    return this.getBlockMap().last();
	  };
	
	  _proto.getPlainText = function getPlainText(delimiter) {
	    return this.getBlockMap().map(function (block) {
	      return block ? block.getText() : '';
	    }).join(delimiter || '\n');
	  };
	
	  _proto.getLastCreatedEntityKey = function getLastCreatedEntityKey() {
	    // TODO: update this when we fully remove DraftEntity
	    return DraftEntity.__getLastCreatedEntityKey();
	  };
	
	  _proto.hasText = function hasText() {
	    var blockMap = this.getBlockMap();
	    return blockMap.size > 1 || // make sure that there are no zero width space chars
	    escape(blockMap.first().getText()).replace(/%u200B/g, '').length > 0;
	  };
	
	  _proto.createEntity = function createEntity(type, mutability, data) {
	    // TODO: update this when we fully remove DraftEntity
	    DraftEntity.__create(type, mutability, data);
	
	    return this;
	  };
	
	  _proto.mergeEntityData = function mergeEntityData(key, toMerge) {
	    // TODO: update this when we fully remove DraftEntity
	    DraftEntity.__mergeData(key, toMerge);
	
	    return this;
	  };
	
	  _proto.replaceEntityData = function replaceEntityData(key, newData) {
	    // TODO: update this when we fully remove DraftEntity
	    DraftEntity.__replaceData(key, newData);
	
	    return this;
	  };
	
	  _proto.addEntity = function addEntity(instance) {
	    // TODO: update this when we fully remove DraftEntity
	    DraftEntity.__add(instance);
	
	    return this;
	  };
	
	  _proto.getEntity = function getEntity(key) {
	    // TODO: update this when we fully remove DraftEntity
	    return DraftEntity.__get(key);
	  };
	
	  _proto.getAllEntities = function getAllEntities() {
	    return DraftEntity.__getAll();
	  };
	
	  _proto.loadWithEntities = function loadWithEntities(entities) {
	    return DraftEntity.__loadWithEntities(entities);
	  };
	
	  ContentState.createFromBlockArray = function createFromBlockArray( // TODO: update flow type when we completely deprecate the old entity API
	  blocks, entityMap) {
	    // TODO: remove this when we completely deprecate the old entity API
	    var theBlocks = Array.isArray(blocks) ? blocks : blocks.contentBlocks;
	    var blockMap = BlockMapBuilder.createFromArray(theBlocks);
	    var selectionState = blockMap.isEmpty() ? new SelectionState() : SelectionState.createEmpty(blockMap.first().getKey());
	    return new ContentState({
	      blockMap: blockMap,
	      entityMap: entityMap || DraftEntity,
	      selectionBefore: selectionState,
	      selectionAfter: selectionState
	    });
	  };
	
	  ContentState.createFromText = function createFromText(text) {
	    var delimiter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : /\r\n?|\n/g;
	    var strings = text.split(delimiter);
	    var blocks = strings.map(function (block) {
	      block = sanitizeDraftText(block);
	      return new ContentBlockNodeRecord({
	        key: generateRandomKey(),
	        text: block,
	        type: 'unstyled',
	        characterList: List(Repeat(CharacterMetadata.EMPTY, block.length))
	      });
	    });
	    return ContentState.createFromBlockArray(blocks);
	  };
	
	  ContentState.fromJS = function fromJS(state) {
	    return new ContentState(_objectSpread({}, state, {
	      blockMap: OrderedMap(state.blockMap).map(ContentState.createContentBlockFromJS),
	      selectionBefore: new SelectionState(state.selectionBefore),
	      selectionAfter: new SelectionState(state.selectionAfter)
	    }));
	  };
	
	  ContentState.createContentBlockFromJS = function createContentBlockFromJS(block) {
	    var characterList = block.characterList;
	    return new ContentBlockNodeRecord(_objectSpread({}, block, {
	      data: ImmutableMap(block.data),
	      characterList: characterList != null ? List((Array.isArray(characterList) ? characterList : getOwnObjectValues(characterList)).map(function (c) {
	        return CharacterMetadata.fromJS(c);
	      })) : undefined
	    }));
	  };
	
	  return ContentState;
	}(ContentStateRecord);
	
	module.exports = ContentState;

/***/ },
/* 263 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	var React = __webpack_require__(1);
	
	var cx = __webpack_require__(108);
	
	var _require = __webpack_require__(27),
	    Map = _require.Map;
	
	var UL_WRAP = React.createElement("ul", {
	  className: cx('public/DraftStyleDefault/ul')
	});
	var OL_WRAP = React.createElement("ol", {
	  className: cx('public/DraftStyleDefault/ol')
	});
	var PRE_WRAP = React.createElement("pre", {
	  className: cx('public/DraftStyleDefault/pre')
	});
	var DefaultDraftBlockRenderMap = Map({
	  'header-one': {
	    element: 'h1'
	  },
	  'header-two': {
	    element: 'h2'
	  },
	  'header-three': {
	    element: 'h3'
	  },
	  'header-four': {
	    element: 'h4'
	  },
	  'header-five': {
	    element: 'h5'
	  },
	  'header-six': {
	    element: 'h6'
	  },
	  section: {
	    element: 'section'
	  },
	  article: {
	    element: 'article'
	  },
	  'unordered-list-item': {
	    element: 'li',
	    wrapper: UL_WRAP
	  },
	  'ordered-list-item': {
	    element: 'li',
	    wrapper: OL_WRAP
	  },
	  blockquote: {
	    element: 'blockquote'
	  },
	  atomic: {
	    element: 'figure'
	  },
	  'code-block': {
	    element: 'pre',
	    wrapper: PRE_WRAP
	  },
	  unstyled: {
	    element: 'div',
	    aliasedElements: ['p']
	  }
	});
	module.exports = DefaultDraftBlockRenderMap;

/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	var UserAgent = __webpack_require__(60);
	
	var isSoftNewlineEvent = __webpack_require__(1238);
	
	var isOSX = UserAgent.isPlatform('Mac OS X');
	var KeyBindingUtil = {
	  /**
	   * Check whether the ctrlKey modifier is *not* being used in conjunction with
	   * the altKey modifier. If they are combined, the result is an `altGraph`
	   * key modifier, which should not be handled by this set of key bindings.
	   */
	  isCtrlKeyCommand: function isCtrlKeyCommand(e) {
	    return !!e.ctrlKey && !e.altKey;
	  },
	  isOptionKeyCommand: function isOptionKeyCommand(e) {
	    return isOSX && e.altKey;
	  },
	  usesMacOSHeuristics: function usesMacOSHeuristics() {
	    return isOSX;
	  },
	  hasCommandModifier: function hasCommandModifier(e) {
	    return isOSX ? !!e.metaKey && !e.altKey : KeyBindingUtil.isCtrlKeyCommand(e);
	  },
	  isSoftNewlineEvent: isSoftNewlineEvent
	};
	module.exports = KeyBindingUtil;

/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	var _require = __webpack_require__(401),
	    notEmptyKey = _require.notEmptyKey;
	/**
	 * Return the entity key that should be used when inserting text for the
	 * specified target selection, only if the entity is `MUTABLE`. `IMMUTABLE`
	 * and `SEGMENTED` entities should not be used for insertion behavior.
	 */
	
	
	function getEntityKeyForSelection(contentState, targetSelection) {
	  var entityKey;
	
	  if (targetSelection.isCollapsed()) {
	    var key = targetSelection.getAnchorKey();
	    var offset = targetSelection.getAnchorOffset();
	
	    if (offset > 0) {
	      entityKey = contentState.getBlockForKey(key).getEntityAt(offset - 1);
	
	      if (entityKey !== contentState.getBlockForKey(key).getEntityAt(offset)) {
	        return null;
	      }
	
	      return filterKey(contentState.getEntityMap(), entityKey);
	    }
	
	    return null;
	  }
	
	  var startKey = targetSelection.getStartKey();
	  var startOffset = targetSelection.getStartOffset();
	  var startBlock = contentState.getBlockForKey(startKey);
	  entityKey = startOffset === startBlock.getLength() ? null : startBlock.getEntityAt(startOffset);
	  return filterKey(contentState.getEntityMap(), entityKey);
	}
	/**
	 * Determine whether an entity key corresponds to a `MUTABLE` entity. If so,
	 * return it. If not, return null.
	 */
	
	
	function filterKey(entityMap, entityKey) {
	  if (notEmptyKey(entityKey)) {
	    var entity = entityMap.__get(entityKey);
	
	    return entity.getMutability() === 'MUTABLE' ? entityKey : null;
	  }
	
	  return null;
	}
	
	module.exports = getEntityKeyForSelection;

/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	var warning = __webpack_require__(271);
	/**
	 * Given a collapsed selection, move the focus `maxDistance` backward within
	 * the selected block. If the selection will go beyond the start of the block,
	 * move focus to the end of the previous block, but no further.
	 *
	 * This function is not Unicode-aware, so surrogate pairs will be treated
	 * as having length 2.
	 */
	
	
	function moveSelectionBackward(editorState, maxDistance) {
	  var selection = editorState.getSelection(); // Should eventually make this an invariant
	
	   false ? warning(selection.isCollapsed(), 'moveSelectionBackward should only be called with a collapsed SelectionState') : void 0;
	  var content = editorState.getCurrentContent();
	  var key = selection.getStartKey();
	  var offset = selection.getStartOffset();
	  var focusKey = key;
	  var focusOffset = 0;
	
	  if (maxDistance > offset) {
	    var keyBefore = content.getKeyBefore(key);
	
	    if (keyBefore == null) {
	      focusKey = key;
	    } else {
	      focusKey = keyBefore;
	      var blockBefore = content.getBlockForKey(keyBefore);
	      focusOffset = blockBefore.getText().length;
	    }
	  } else {
	    focusOffset = offset - maxDistance;
	  }
	
	  return selection.merge({
	    focusKey: focusKey,
	    focusOffset: focusOffset,
	    isBackward: true
	  });
	}
	
	module.exports = moveSelectionBackward;

/***/ },
/* 267 */
18,
/* 268 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/**
	 * @param {DOMElement} element
	 * @param {DOMDocument} doc
	 * @return {boolean}
	 */
	function _isViewportScrollElement(element, doc) {
	  return !!doc && (element === doc.documentElement || element === doc.body);
	}
	/**
	 * Scroll Module. This class contains 4 simple static functions
	 * to be used to access Element.scrollTop/scrollLeft properties.
	 * To solve the inconsistencies between browsers when either
	 * document.body or document.documentElement is supplied,
	 * below logic will be used to alleviate the issue:
	 *
	 * 1. If 'element' is either 'document.body' or 'document.documentElement,
	 *    get whichever element's 'scroll{Top,Left}' is larger.
	 * 2. If 'element' is either 'document.body' or 'document.documentElement',
	 *    set the 'scroll{Top,Left}' on both elements.
	 */
	
	
	var Scroll = {
	  /**
	   * @param {DOMElement} element
	   * @return {number}
	   */
	  getTop: function getTop(element) {
	    var doc = element.ownerDocument;
	    return _isViewportScrollElement(element, doc) ? // In practice, they will either both have the same value,
	    // or one will be zero and the other will be the scroll position
	    // of the viewport. So we can use `X || Y` instead of `Math.max(X, Y)`
	    doc.body.scrollTop || doc.documentElement.scrollTop : element.scrollTop;
	  },
	
	  /**
	   * @param {DOMElement} element
	   * @param {number} newTop
	   */
	  setTop: function setTop(element, newTop) {
	    var doc = element.ownerDocument;
	
	    if (_isViewportScrollElement(element, doc)) {
	      doc.body.scrollTop = doc.documentElement.scrollTop = newTop;
	    } else {
	      element.scrollTop = newTop;
	    }
	  },
	
	  /**
	   * @param {DOMElement} element
	   * @return {number}
	   */
	  getLeft: function getLeft(element) {
	    var doc = element.ownerDocument;
	    return _isViewportScrollElement(element, doc) ? doc.body.scrollLeft || doc.documentElement.scrollLeft : element.scrollLeft;
	  },
	
	  /**
	   * @param {DOMElement} element
	   * @param {number} newLeft
	   */
	  setLeft: function setLeft(element, newLeft) {
	    var doc = element.ownerDocument;
	
	    if (_isViewportScrollElement(element, doc)) {
	      doc.body.scrollLeft = doc.documentElement.scrollLeft = newLeft;
	    } else {
	      element.scrollLeft = newLeft;
	    }
	  }
	};
	module.exports = Scroll;

/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 * 
	 */
	
	/**
	 * Basic (stateless) API for text direction detection
	 *
	 * Part of our implementation of Unicode Bidirectional Algorithm (UBA)
	 * Unicode Standard Annex #9 (UAX9)
	 * http://www.unicode.org/reports/tr9/
	 */
	'use strict';
	
	var UnicodeBidiDirection = __webpack_require__(199);
	
	var invariant = __webpack_require__(32);
	
	/**
	 * RegExp ranges of characters with a *Strong* Bidi_Class value.
	 *
	 * Data is based on DerivedBidiClass.txt in UCD version 7.0.0.
	 *
	 * NOTE: For performance reasons, we only support Unicode's
	 *       Basic Multilingual Plane (BMP) for now.
	 */
	var RANGE_BY_BIDI_TYPE = {
	  L: "A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u01BA\u01BB" + "\u01BC-\u01BF\u01C0-\u01C3\u01C4-\u0293\u0294\u0295-\u02AF\u02B0-\u02B8" + "\u02BB-\u02C1\u02D0-\u02D1\u02E0-\u02E4\u02EE\u0370-\u0373\u0376-\u0377" + "\u037A\u037B-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1" + "\u03A3-\u03F5\u03F7-\u0481\u0482\u048A-\u052F\u0531-\u0556\u0559" + "\u055A-\u055F\u0561-\u0587\u0589\u0903\u0904-\u0939\u093B\u093D" + "\u093E-\u0940\u0949-\u094C\u094E-\u094F\u0950\u0958-\u0961\u0964-\u0965" + "\u0966-\u096F\u0970\u0971\u0972-\u0980\u0982-\u0983\u0985-\u098C" + "\u098F-\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD" + "\u09BE-\u09C0\u09C7-\u09C8\u09CB-\u09CC\u09CE\u09D7\u09DC-\u09DD" + "\u09DF-\u09E1\u09E6-\u09EF\u09F0-\u09F1\u09F4-\u09F9\u09FA\u0A03" + "\u0A05-\u0A0A\u0A0F-\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32-\u0A33" + "\u0A35-\u0A36\u0A38-\u0A39\u0A3E-\u0A40\u0A59-\u0A5C\u0A5E\u0A66-\u0A6F" + "\u0A72-\u0A74\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0" + "\u0AB2-\u0AB3\u0AB5-\u0AB9\u0ABD\u0ABE-\u0AC0\u0AC9\u0ACB-\u0ACC\u0AD0" + "\u0AE0-\u0AE1\u0AE6-\u0AEF\u0AF0\u0B02-\u0B03\u0B05-\u0B0C\u0B0F-\u0B10" + "\u0B13-\u0B28\u0B2A-\u0B30\u0B32-\u0B33\u0B35-\u0B39\u0B3D\u0B3E\u0B40" + "\u0B47-\u0B48\u0B4B-\u0B4C\u0B57\u0B5C-\u0B5D\u0B5F-\u0B61\u0B66-\u0B6F" + "\u0B70\u0B71\u0B72-\u0B77\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95" + "\u0B99-\u0B9A\u0B9C\u0B9E-\u0B9F\u0BA3-\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9" + "\u0BBE-\u0BBF\u0BC1-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCC\u0BD0\u0BD7" + "\u0BE6-\u0BEF\u0BF0-\u0BF2\u0C01-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10" + "\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C41-\u0C44\u0C58-\u0C59\u0C60-\u0C61" + "\u0C66-\u0C6F\u0C7F\u0C82-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8" + "\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CBE\u0CBF\u0CC0-\u0CC4\u0CC6" + "\u0CC7-\u0CC8\u0CCA-\u0CCB\u0CD5-\u0CD6\u0CDE\u0CE0-\u0CE1\u0CE6-\u0CEF" + "\u0CF1-\u0CF2\u0D02-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D" + "\u0D3E-\u0D40\u0D46-\u0D48\u0D4A-\u0D4C\u0D4E\u0D57\u0D60-\u0D61" + "\u0D66-\u0D6F\u0D70-\u0D75\u0D79\u0D7A-\u0D7F\u0D82-\u0D83\u0D85-\u0D96" + "\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCF-\u0DD1\u0DD8-\u0DDF" + "\u0DE6-\u0DEF\u0DF2-\u0DF3\u0DF4\u0E01-\u0E30\u0E32-\u0E33\u0E40-\u0E45" + "\u0E46\u0E4F\u0E50-\u0E59\u0E5A-\u0E5B\u0E81-\u0E82\u0E84\u0E87-\u0E88" + "\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7" + "\u0EAA-\u0EAB\u0EAD-\u0EB0\u0EB2-\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6" + "\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F01-\u0F03\u0F04-\u0F12\u0F13\u0F14" + "\u0F15-\u0F17\u0F1A-\u0F1F\u0F20-\u0F29\u0F2A-\u0F33\u0F34\u0F36\u0F38" + "\u0F3E-\u0F3F\u0F40-\u0F47\u0F49-\u0F6C\u0F7F\u0F85\u0F88-\u0F8C" + "\u0FBE-\u0FC5\u0FC7-\u0FCC\u0FCE-\u0FCF\u0FD0-\u0FD4\u0FD5-\u0FD8" + "\u0FD9-\u0FDA\u1000-\u102A\u102B-\u102C\u1031\u1038\u103B-\u103C\u103F" + "\u1040-\u1049\u104A-\u104F\u1050-\u1055\u1056-\u1057\u105A-\u105D\u1061" + "\u1062-\u1064\u1065-\u1066\u1067-\u106D\u106E-\u1070\u1075-\u1081" + "\u1083-\u1084\u1087-\u108C\u108E\u108F\u1090-\u1099\u109A-\u109C" + "\u109E-\u109F\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FB\u10FC" + "\u10FD-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288" + "\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5" + "\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1360-\u1368" + "\u1369-\u137C\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166D-\u166E" + "\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EB-\u16ED\u16EE-\u16F0" + "\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1735-\u1736" + "\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17B6\u17BE-\u17C5" + "\u17C7-\u17C8\u17D4-\u17D6\u17D7\u17D8-\u17DA\u17DC\u17E0-\u17E9" + "\u1810-\u1819\u1820-\u1842\u1843\u1844-\u1877\u1880-\u18A8\u18AA" + "\u18B0-\u18F5\u1900-\u191E\u1923-\u1926\u1929-\u192B\u1930-\u1931" + "\u1933-\u1938\u1946-\u194F\u1950-\u196D\u1970-\u1974\u1980-\u19AB" + "\u19B0-\u19C0\u19C1-\u19C7\u19C8-\u19C9\u19D0-\u19D9\u19DA\u1A00-\u1A16" + "\u1A19-\u1A1A\u1A1E-\u1A1F\u1A20-\u1A54\u1A55\u1A57\u1A61\u1A63-\u1A64" + "\u1A6D-\u1A72\u1A80-\u1A89\u1A90-\u1A99\u1AA0-\u1AA6\u1AA7\u1AA8-\u1AAD" + "\u1B04\u1B05-\u1B33\u1B35\u1B3B\u1B3D-\u1B41\u1B43-\u1B44\u1B45-\u1B4B" + "\u1B50-\u1B59\u1B5A-\u1B60\u1B61-\u1B6A\u1B74-\u1B7C\u1B82\u1B83-\u1BA0" + "\u1BA1\u1BA6-\u1BA7\u1BAA\u1BAE-\u1BAF\u1BB0-\u1BB9\u1BBA-\u1BE5\u1BE7" + "\u1BEA-\u1BEC\u1BEE\u1BF2-\u1BF3\u1BFC-\u1BFF\u1C00-\u1C23\u1C24-\u1C2B" + "\u1C34-\u1C35\u1C3B-\u1C3F\u1C40-\u1C49\u1C4D-\u1C4F\u1C50-\u1C59" + "\u1C5A-\u1C77\u1C78-\u1C7D\u1C7E-\u1C7F\u1CC0-\u1CC7\u1CD3\u1CE1" + "\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF2-\u1CF3\u1CF5-\u1CF6\u1D00-\u1D2B" + "\u1D2C-\u1D6A\u1D6B-\u1D77\u1D78\u1D79-\u1D9A\u1D9B-\u1DBF\u1E00-\u1F15" + "\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D" + "\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC" + "\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u200E" + "\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D" + "\u2124\u2126\u2128\u212A-\u212D\u212F-\u2134\u2135-\u2138\u2139" + "\u213C-\u213F\u2145-\u2149\u214E\u214F\u2160-\u2182\u2183-\u2184" + "\u2185-\u2188\u2336-\u237A\u2395\u249C-\u24E9\u26AC\u2800-\u28FF" + "\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2C7B\u2C7C-\u2C7D\u2C7E-\u2CE4" + "\u2CEB-\u2CEE\u2CF2-\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F" + "\u2D70\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE" + "\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u3005\u3006\u3007" + "\u3021-\u3029\u302E-\u302F\u3031-\u3035\u3038-\u303A\u303B\u303C" + "\u3041-\u3096\u309D-\u309E\u309F\u30A1-\u30FA\u30FC-\u30FE\u30FF" + "\u3105-\u312D\u3131-\u318E\u3190-\u3191\u3192-\u3195\u3196-\u319F" + "\u31A0-\u31BA\u31F0-\u31FF\u3200-\u321C\u3220-\u3229\u322A-\u3247" + "\u3248-\u324F\u3260-\u327B\u327F\u3280-\u3289\u328A-\u32B0\u32C0-\u32CB" + "\u32D0-\u32FE\u3300-\u3376\u337B-\u33DD\u33E0-\u33FE\u3400-\u4DB5" + "\u4E00-\u9FCC\uA000-\uA014\uA015\uA016-\uA48C\uA4D0-\uA4F7\uA4F8-\uA4FD" + "\uA4FE-\uA4FF\uA500-\uA60B\uA60C\uA610-\uA61F\uA620-\uA629\uA62A-\uA62B" + "\uA640-\uA66D\uA66E\uA680-\uA69B\uA69C-\uA69D\uA6A0-\uA6E5\uA6E6-\uA6EF" + "\uA6F2-\uA6F7\uA722-\uA76F\uA770\uA771-\uA787\uA789-\uA78A\uA78B-\uA78E" + "\uA790-\uA7AD\uA7B0-\uA7B1\uA7F7\uA7F8-\uA7F9\uA7FA\uA7FB-\uA801" + "\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA823-\uA824\uA827\uA830-\uA835" + "\uA836-\uA837\uA840-\uA873\uA880-\uA881\uA882-\uA8B3\uA8B4-\uA8C3" + "\uA8CE-\uA8CF\uA8D0-\uA8D9\uA8F2-\uA8F7\uA8F8-\uA8FA\uA8FB\uA900-\uA909" + "\uA90A-\uA925\uA92E-\uA92F\uA930-\uA946\uA952-\uA953\uA95F\uA960-\uA97C" + "\uA983\uA984-\uA9B2\uA9B4-\uA9B5\uA9BA-\uA9BB\uA9BD-\uA9C0\uA9C1-\uA9CD" + "\uA9CF\uA9D0-\uA9D9\uA9DE-\uA9DF\uA9E0-\uA9E4\uA9E6\uA9E7-\uA9EF" + "\uA9F0-\uA9F9\uA9FA-\uA9FE\uAA00-\uAA28\uAA2F-\uAA30\uAA33-\uAA34" + "\uAA40-\uAA42\uAA44-\uAA4B\uAA4D\uAA50-\uAA59\uAA5C-\uAA5F\uAA60-\uAA6F" + "\uAA70\uAA71-\uAA76\uAA77-\uAA79\uAA7A\uAA7B\uAA7D\uAA7E-\uAAAF\uAAB1" + "\uAAB5-\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADC\uAADD\uAADE-\uAADF" + "\uAAE0-\uAAEA\uAAEB\uAAEE-\uAAEF\uAAF0-\uAAF1\uAAF2\uAAF3-\uAAF4\uAAF5" + "\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E" + "\uAB30-\uAB5A\uAB5B\uAB5C-\uAB5F\uAB64-\uAB65\uABC0-\uABE2\uABE3-\uABE4" + "\uABE6-\uABE7\uABE9-\uABEA\uABEB\uABEC\uABF0-\uABF9\uAC00-\uD7A3" + "\uD7B0-\uD7C6\uD7CB-\uD7FB\uE000-\uF8FF\uF900-\uFA6D\uFA70-\uFAD9" + "\uFB00-\uFB06\uFB13-\uFB17\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFF6F\uFF70" + "\uFF71-\uFF9D\uFF9E-\uFF9F\uFFA0-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF" + "\uFFD2-\uFFD7\uFFDA-\uFFDC",
	  R: "\u0590\u05BE\u05C0\u05C3\u05C6\u05C8-\u05CF\u05D0-\u05EA\u05EB-\u05EF" + "\u05F0-\u05F2\u05F3-\u05F4\u05F5-\u05FF\u07C0-\u07C9\u07CA-\u07EA" + "\u07F4-\u07F5\u07FA\u07FB-\u07FF\u0800-\u0815\u081A\u0824\u0828" + "\u082E-\u082F\u0830-\u083E\u083F\u0840-\u0858\u085C-\u085D\u085E" + "\u085F-\u089F\u200F\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB37\uFB38-\uFB3C" + "\uFB3D\uFB3E\uFB3F\uFB40-\uFB41\uFB42\uFB43-\uFB44\uFB45\uFB46-\uFB4F",
	  AL: "\u0608\u060B\u060D\u061B\u061C\u061D\u061E-\u061F\u0620-\u063F\u0640" + "\u0641-\u064A\u066D\u066E-\u066F\u0671-\u06D3\u06D4\u06D5\u06E5-\u06E6" + "\u06EE-\u06EF\u06FA-\u06FC\u06FD-\u06FE\u06FF\u0700-\u070D\u070E\u070F" + "\u0710\u0712-\u072F\u074B-\u074C\u074D-\u07A5\u07B1\u07B2-\u07BF" + "\u08A0-\u08B2\u08B3-\u08E3\uFB50-\uFBB1\uFBB2-\uFBC1\uFBC2-\uFBD2" + "\uFBD3-\uFD3D\uFD40-\uFD4F\uFD50-\uFD8F\uFD90-\uFD91\uFD92-\uFDC7" + "\uFDC8-\uFDCF\uFDF0-\uFDFB\uFDFC\uFDFE-\uFDFF\uFE70-\uFE74\uFE75" + "\uFE76-\uFEFC\uFEFD-\uFEFE"
	};
	var REGEX_STRONG = new RegExp('[' + RANGE_BY_BIDI_TYPE.L + RANGE_BY_BIDI_TYPE.R + RANGE_BY_BIDI_TYPE.AL + ']');
	var REGEX_RTL = new RegExp('[' + RANGE_BY_BIDI_TYPE.R + RANGE_BY_BIDI_TYPE.AL + ']');
	/**
	 * Returns the first strong character (has Bidi_Class value of L, R, or AL).
	 *
	 * @param str  A text block; e.g. paragraph, table cell, tag
	 * @return     A character with strong bidi direction, or null if not found
	 */
	
	function firstStrongChar(str) {
	  var match = REGEX_STRONG.exec(str);
	  return match == null ? null : match[0];
	}
	/**
	 * Returns the direction of a block of text, based on the direction of its
	 * first strong character (has Bidi_Class value of L, R, or AL).
	 *
	 * @param str  A text block; e.g. paragraph, table cell, tag
	 * @return     The resolved direction
	 */
	
	
	function firstStrongCharDir(str) {
	  var strongChar = firstStrongChar(str);
	
	  if (strongChar == null) {
	    return UnicodeBidiDirection.NEUTRAL;
	  }
	
	  return REGEX_RTL.exec(strongChar) ? UnicodeBidiDirection.RTL : UnicodeBidiDirection.LTR;
	}
	/**
	 * Returns the direction of a block of text, based on the direction of its
	 * first strong character (has Bidi_Class value of L, R, or AL), or a fallback
	 * direction, if no strong character is found.
	 *
	 * This function is supposed to be used in respect to Higher-Level Protocol
	 * rule HL1. (http://www.unicode.org/reports/tr9/#HL1)
	 *
	 * @param str       A text block; e.g. paragraph, table cell, tag
	 * @param fallback  Fallback direction, used if no strong direction detected
	 *                  for the block (default = NEUTRAL)
	 * @return          The resolved direction
	 */
	
	
	function resolveBlockDir(str, fallback) {
	  fallback = fallback || UnicodeBidiDirection.NEUTRAL;
	
	  if (!str.length) {
	    return fallback;
	  }
	
	  var blockDir = firstStrongCharDir(str);
	  return blockDir === UnicodeBidiDirection.NEUTRAL ? fallback : blockDir;
	}
	/**
	 * Returns the direction of a block of text, based on the direction of its
	 * first strong character (has Bidi_Class value of L, R, or AL), or a fallback
	 * direction, if no strong character is found.
	 *
	 * NOTE: This function is similar to resolveBlockDir(), but uses the global
	 * direction as the fallback, so it *always* returns a Strong direction,
	 * making it useful for integration in places that you need to make the final
	 * decision, like setting some CSS class.
	 *
	 * This function is supposed to be used in respect to Higher-Level Protocol
	 * rule HL1. (http://www.unicode.org/reports/tr9/#HL1)
	 *
	 * @param str             A text block; e.g. paragraph, table cell
	 * @param strongFallback  Fallback direction, used if no strong direction
	 *                        detected for the block (default = global direction)
	 * @return                The resolved Strong direction
	 */
	
	
	function getDirection(str, strongFallback) {
	  if (!strongFallback) {
	    strongFallback = UnicodeBidiDirection.getGlobalDir();
	  }
	
	  !UnicodeBidiDirection.isStrong(strongFallback) ?  false ? invariant(false, 'Fallback direction must be a strong direction') : invariant(false) : void 0;
	  return resolveBlockDir(str, strongFallback);
	}
	/**
	 * Returns true if getDirection(arguments...) returns LTR.
	 *
	 * @param str             A text block; e.g. paragraph, table cell
	 * @param strongFallback  Fallback direction, used if no strong direction
	 *                        detected for the block (default = global direction)
	 * @return                True if the resolved direction is LTR
	 */
	
	
	function isDirectionLTR(str, strongFallback) {
	  return getDirection(str, strongFallback) === UnicodeBidiDirection.LTR;
	}
	/**
	 * Returns true if getDirection(arguments...) returns RTL.
	 *
	 * @param str             A text block; e.g. paragraph, table cell
	 * @param strongFallback  Fallback direction, used if no strong direction
	 *                        detected for the block (default = global direction)
	 * @return                True if the resolved direction is RTL
	 */
	
	
	function isDirectionRTL(str, strongFallback) {
	  return getDirection(str, strongFallback) === UnicodeBidiDirection.RTL;
	}
	
	var UnicodeBidi = {
	  firstStrongChar: firstStrongChar,
	  firstStrongCharDir: firstStrongCharDir,
	  resolveBlockDir: resolveBlockDir,
	  getDirection: getDirection,
	  isDirectionLTR: isDirectionLTR,
	  isDirectionRTL: isDirectionRTL
	};
	module.exports = UnicodeBidi;

/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	var isTextNode = __webpack_require__(1286);
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 */
	
	
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if ('contains' in outerNode) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;

/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	'use strict';
	
	var emptyFunction = __webpack_require__(429);
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	
	function printWarning(format) {
	  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    args[_key - 1] = arguments[_key];
	  }
	
	  var argIndex = 0;
	  var message = 'Warning: ' + format.replace(/%s/g, function () {
	    return args[argIndex++];
	  });
	
	  if (typeof console !== 'undefined') {
	    console.error(message);
	  }
	
	  try {
	    // --- Welcome to debugging React ---
	    // This error was thrown as a convenience so that you can use this stack
	    // to find the callsite that caused this warning to fire.
	    throw new Error(message);
	  } catch (x) {}
	}
	
	var warning =  false ? function (condition, format) {
	  if (format === undefined) {
	    throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	  }
	
	  if (!condition) {
	    for (var _len2 = arguments.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	      args[_key2 - 2] = arguments[_key2];
	    }
	
	    printWarning.apply(void 0, [format].concat(args));
	  }
	} : emptyFunction;
	module.exports = warning;

/***/ },
/* 272 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var undefined;
	
	var $Object = __webpack_require__(427);
	
	var $Error = __webpack_require__(425);
	var $EvalError = __webpack_require__(1259);
	var $RangeError = __webpack_require__(1260);
	var $ReferenceError = __webpack_require__(1261);
	var $SyntaxError = __webpack_require__(426);
	var $TypeError = __webpack_require__(120);
	var $URIError = __webpack_require__(1262);
	
	var abs = __webpack_require__(1339);
	var floor = __webpack_require__(1340);
	var max = __webpack_require__(1342);
	var min = __webpack_require__(1343);
	var pow = __webpack_require__(1344);
	var round = __webpack_require__(1345);
	var sign = __webpack_require__(1346);
	
	var $Function = Function;
	
	// eslint-disable-next-line consistent-return
	var getEvalledConstructor = function (expressionSyntax) {
		try {
			return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
		} catch (e) {}
	};
	
	var $gOPD = __webpack_require__(125);
	var $defineProperty = __webpack_require__(196);
	
	var throwTypeError = function () {
		throw new $TypeError();
	};
	var ThrowTypeError = $gOPD
		? (function () {
			try {
				// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
				arguments.callee; // IE 8 does not throw here
				return throwTypeError;
			} catch (calleeThrows) {
				try {
					// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
					return $gOPD(arguments, 'callee').get;
				} catch (gOPDthrows) {
					return throwTypeError;
				}
			}
		}())
		: throwTypeError;
	
	var hasSymbols = __webpack_require__(1301)();
	
	var getProto = __webpack_require__(435);
	var $ObjectGPO = __webpack_require__(433);
	var $ReflectGPO = __webpack_require__(434);
	
	var $apply = __webpack_require__(249);
	var $call = __webpack_require__(250);
	
	var needsEval = {};
	
	var TypedArray = typeof Uint8Array === 'undefined' || !getProto ? undefined : getProto(Uint8Array);
	
	var INTRINSICS = {
		__proto__: null,
		'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
		'%Array%': Array,
		'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
		'%ArrayIteratorPrototype%': hasSymbols && getProto ? getProto([][Symbol.iterator]()) : undefined,
		'%AsyncFromSyncIteratorPrototype%': undefined,
		'%AsyncFunction%': needsEval,
		'%AsyncGenerator%': needsEval,
		'%AsyncGeneratorFunction%': needsEval,
		'%AsyncIteratorPrototype%': needsEval,
		'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
		'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
		'%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
		'%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
		'%Boolean%': Boolean,
		'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
		'%Date%': Date,
		'%decodeURI%': decodeURI,
		'%decodeURIComponent%': decodeURIComponent,
		'%encodeURI%': encodeURI,
		'%encodeURIComponent%': encodeURIComponent,
		'%Error%': $Error,
		'%eval%': eval, // eslint-disable-line no-eval
		'%EvalError%': $EvalError,
		'%Float16Array%': typeof Float16Array === 'undefined' ? undefined : Float16Array,
		'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
		'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
		'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
		'%Function%': $Function,
		'%GeneratorFunction%': needsEval,
		'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
		'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
		'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
		'%isFinite%': isFinite,
		'%isNaN%': isNaN,
		'%IteratorPrototype%': hasSymbols && getProto ? getProto(getProto([][Symbol.iterator]())) : undefined,
		'%JSON%': typeof JSON === 'object' ? JSON : undefined,
		'%Map%': typeof Map === 'undefined' ? undefined : Map,
		'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Map()[Symbol.iterator]()),
		'%Math%': Math,
		'%Number%': Number,
		'%Object%': $Object,
		'%Object.getOwnPropertyDescriptor%': $gOPD,
		'%parseFloat%': parseFloat,
		'%parseInt%': parseInt,
		'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
		'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
		'%RangeError%': $RangeError,
		'%ReferenceError%': $ReferenceError,
		'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
		'%RegExp%': RegExp,
		'%Set%': typeof Set === 'undefined' ? undefined : Set,
		'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Set()[Symbol.iterator]()),
		'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
		'%String%': String,
		'%StringIteratorPrototype%': hasSymbols && getProto ? getProto(''[Symbol.iterator]()) : undefined,
		'%Symbol%': hasSymbols ? Symbol : undefined,
		'%SyntaxError%': $SyntaxError,
		'%ThrowTypeError%': ThrowTypeError,
		'%TypedArray%': TypedArray,
		'%TypeError%': $TypeError,
		'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
		'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
		'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
		'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
		'%URIError%': $URIError,
		'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
		'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
		'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
	
		'%Function.prototype.call%': $call,
		'%Function.prototype.apply%': $apply,
		'%Object.defineProperty%': $defineProperty,
		'%Object.getPrototypeOf%': $ObjectGPO,
		'%Math.abs%': abs,
		'%Math.floor%': floor,
		'%Math.max%': max,
		'%Math.min%': min,
		'%Math.pow%': pow,
		'%Math.round%': round,
		'%Math.sign%': sign,
		'%Reflect.getPrototypeOf%': $ReflectGPO
	};
	
	if (getProto) {
		try {
			null.error; // eslint-disable-line no-unused-expressions
		} catch (e) {
			// https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
			var errorProto = getProto(getProto(e));
			INTRINSICS['%Error.prototype%'] = errorProto;
		}
	}
	
	var doEval = function doEval(name) {
		var value;
		if (name === '%AsyncFunction%') {
			value = getEvalledConstructor('async function () {}');
		} else if (name === '%GeneratorFunction%') {
			value = getEvalledConstructor('function* () {}');
		} else if (name === '%AsyncGeneratorFunction%') {
			value = getEvalledConstructor('async function* () {}');
		} else if (name === '%AsyncGenerator%') {
			var fn = doEval('%AsyncGeneratorFunction%');
			if (fn) {
				value = fn.prototype;
			}
		} else if (name === '%AsyncIteratorPrototype%') {
			var gen = doEval('%AsyncGenerator%');
			if (gen && getProto) {
				value = getProto(gen.prototype);
			}
		}
	
		INTRINSICS[name] = value;
	
		return value;
	};
	
	var LEGACY_ALIASES = {
		__proto__: null,
		'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
		'%ArrayPrototype%': ['Array', 'prototype'],
		'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
		'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
		'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
		'%ArrayProto_values%': ['Array', 'prototype', 'values'],
		'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
		'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
		'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
		'%BooleanPrototype%': ['Boolean', 'prototype'],
		'%DataViewPrototype%': ['DataView', 'prototype'],
		'%DatePrototype%': ['Date', 'prototype'],
		'%ErrorPrototype%': ['Error', 'prototype'],
		'%EvalErrorPrototype%': ['EvalError', 'prototype'],
		'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
		'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
		'%FunctionPrototype%': ['Function', 'prototype'],
		'%Generator%': ['GeneratorFunction', 'prototype'],
		'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
		'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
		'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
		'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
		'%JSONParse%': ['JSON', 'parse'],
		'%JSONStringify%': ['JSON', 'stringify'],
		'%MapPrototype%': ['Map', 'prototype'],
		'%NumberPrototype%': ['Number', 'prototype'],
		'%ObjectPrototype%': ['Object', 'prototype'],
		'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
		'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
		'%PromisePrototype%': ['Promise', 'prototype'],
		'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
		'%Promise_all%': ['Promise', 'all'],
		'%Promise_reject%': ['Promise', 'reject'],
		'%Promise_resolve%': ['Promise', 'resolve'],
		'%RangeErrorPrototype%': ['RangeError', 'prototype'],
		'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
		'%RegExpPrototype%': ['RegExp', 'prototype'],
		'%SetPrototype%': ['Set', 'prototype'],
		'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
		'%StringPrototype%': ['String', 'prototype'],
		'%SymbolPrototype%': ['Symbol', 'prototype'],
		'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
		'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
		'%TypeErrorPrototype%': ['TypeError', 'prototype'],
		'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
		'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
		'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
		'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
		'%URIErrorPrototype%': ['URIError', 'prototype'],
		'%WeakMapPrototype%': ['WeakMap', 'prototype'],
		'%WeakSetPrototype%': ['WeakSet', 'prototype']
	};
	
	var bind = __webpack_require__(156);
	var hasOwn = __webpack_require__(437);
	var $concat = bind.call($call, Array.prototype.concat);
	var $spliceApply = bind.call($apply, Array.prototype.splice);
	var $replace = bind.call($call, String.prototype.replace);
	var $strSlice = bind.call($call, String.prototype.slice);
	var $exec = bind.call($call, RegExp.prototype.exec);
	
	/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
	var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
	var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
	var stringToPath = function stringToPath(string) {
		var first = $strSlice(string, 0, 1);
		var last = $strSlice(string, -1);
		if (first === '%' && last !== '%') {
			throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
		} else if (last === '%' && first !== '%') {
			throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
		}
		var result = [];
		$replace(string, rePropName, function (match, number, quote, subString) {
			result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
		});
		return result;
	};
	/* end adaptation */
	
	var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
		var intrinsicName = name;
		var alias;
		if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
			alias = LEGACY_ALIASES[intrinsicName];
			intrinsicName = '%' + alias[0] + '%';
		}
	
		if (hasOwn(INTRINSICS, intrinsicName)) {
			var value = INTRINSICS[intrinsicName];
			if (value === needsEval) {
				value = doEval(intrinsicName);
			}
			if (typeof value === 'undefined' && !allowMissing) {
				throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
			}
	
			return {
				alias: alias,
				name: intrinsicName,
				value: value
			};
		}
	
		throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
	};
	
	module.exports = function GetIntrinsic(name, allowMissing) {
		if (typeof name !== 'string' || name.length === 0) {
			throw new $TypeError('intrinsic name must be a non-empty string');
		}
		if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
			throw new $TypeError('"allowMissing" argument must be a boolean');
		}
	
		if ($exec(/^%?[^%]*%?$/, name) === null) {
			throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
		}
		var parts = stringToPath(name);
		var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
	
		var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
		var intrinsicRealName = intrinsic.name;
		var value = intrinsic.value;
		var skipFurtherCaching = false;
	
		var alias = intrinsic.alias;
		if (alias) {
			intrinsicBaseName = alias[0];
			$spliceApply(parts, $concat([0, 1], alias));
		}
	
		for (var i = 1, isOwn = true; i < parts.length; i += 1) {
			var part = parts[i];
			var first = $strSlice(part, 0, 1);
			var last = $strSlice(part, -1);
			if (
				(
					(first === '"' || first === "'" || first === '`')
					|| (last === '"' || last === "'" || last === '`')
				)
				&& first !== last
			) {
				throw new $SyntaxError('property names with quotes must have matching quotes');
			}
			if (part === 'constructor' || !isOwn) {
				skipFurtherCaching = true;
			}
	
			intrinsicBaseName += '.' + part;
			intrinsicRealName = '%' + intrinsicBaseName + '%';
	
			if (hasOwn(INTRINSICS, intrinsicRealName)) {
				value = INTRINSICS[intrinsicRealName];
			} else if (value != null) {
				if (!(part in value)) {
					if (!allowMissing) {
						throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
					}
					return void undefined;
				}
				if ($gOPD && (i + 1) >= parts.length) {
					var desc = $gOPD(value, part);
					isOwn = !!desc;
	
					// By convention, when a data property is converted to an accessor
					// property to emulate a data property that does not suffer from
					// the override mistake, that accessor's getter is marked with
					// an `originalValue` property. Here, when we detect this, we
					// uphold the illusion by pretending to see that original data
					// property, i.e., returning the value rather than the getter
					// itself.
					if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
						value = desc.get;
					} else {
						value = value[part];
					}
				} else {
					isOwn = hasOwn(value, part);
					value = value[part];
				}
	
				if (isOwn && !skipFurtherCaching) {
					INTRINSICS[intrinsicRealName] = value;
				}
			}
		}
		return value;
	};


/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var $defineProperty = __webpack_require__(196);
	
	var hasPropertyDescriptors = function hasPropertyDescriptors() {
		return !!$defineProperty;
	};
	
	hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
		// node v0.6 has a bug where array lengths can be Set but not Defined
		if (!$defineProperty) {
			return null;
		}
		try {
			return $defineProperty([], 'length', { value: 1 }).length !== 1;
		} catch (e) {
			// In Firefox 4-22, defining length on an array throws an exception.
			return true;
		}
	};
	
	module.exports = hasPropertyDescriptors;


/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var hasSymbols = __webpack_require__(436);
	
	/** @type {import('.')} */
	module.exports = function hasToStringTagShams() {
		return hasSymbols() && !!Symbol.toStringTag;
	};


/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var external = __webpack_require__(159);
	var DataWorker = __webpack_require__(450);
	var Crc32Probe = __webpack_require__(449);
	var DataLengthProbe = __webpack_require__(1334);
	
	/**
	 * Represent a compressed object, with everything needed to decompress it.
	 * @constructor
	 * @param {number} compressedSize the size of the data compressed.
	 * @param {number} uncompressedSize the size of the data after decompression.
	 * @param {number} crc32 the crc32 of the decompressed file.
	 * @param {object} compression the type of compression, see lib/compressions.js.
	 * @param {String|ArrayBuffer|Uint8Array|Buffer} data the compressed data.
	 */
	function CompressedObject(compressedSize, uncompressedSize, crc32, compression, data) {
	    this.compressedSize = compressedSize;
	    this.uncompressedSize = uncompressedSize;
	    this.crc32 = crc32;
	    this.compression = compression;
	    this.compressedContent = data;
	}
	
	CompressedObject.prototype = {
	    /**
	     * Create a worker to get the uncompressed content.
	     * @return {GenericWorker} the worker.
	     */
	    getContentWorker: function () {
	        var worker = new DataWorker(external.Promise.resolve(this.compressedContent))
	            .pipe(this.compression.uncompressWorker())
	            .pipe(new DataLengthProbe("data_length"));
	
	        var that = this;
	        worker.on("end", function () {
	            if (this.streamInfo["data_length"] !== that.uncompressedSize) {
	                throw new Error("Bug : uncompressed data size mismatch");
	            }
	        });
	        return worker;
	    },
	    /**
	     * Create a worker to get the compressed content.
	     * @return {GenericWorker} the worker.
	     */
	    getCompressedWorker: function () {
	        return new DataWorker(external.Promise.resolve(this.compressedContent))
	            .withStreamInfo("compressedSize", this.compressedSize)
	            .withStreamInfo("uncompressedSize", this.uncompressedSize)
	            .withStreamInfo("crc32", this.crc32)
	            .withStreamInfo("compression", this.compression)
	        ;
	    }
	};
	
	/**
	 * Chain the given worker with other workers to compress the content with the
	 * given compression.
	 * @param {GenericWorker} uncompressedWorker the worker to pipe.
	 * @param {Object} compression the compression object.
	 * @param {Object} compressionOptions the options to use when compressing.
	 * @return {GenericWorker} the new worker compressing the content.
	 */
	CompressedObject.createWorkerFrom = function (uncompressedWorker, compression, compressionOptions) {
	    return uncompressedWorker
	        .pipe(new Crc32Probe())
	        .pipe(new DataLengthProbe("uncompressedSize"))
	        .pipe(compression.compressWorker(compressionOptions))
	        .pipe(new DataLengthProbe("compressedSize"))
	        .withStreamInfo("compression", compression);
	};
	
	module.exports = CompressedObject;


/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var utils = __webpack_require__(42);
	
	/**
	 * The following functions come from pako, from pako/lib/zlib/crc32.js
	 * released under the MIT license, see pako https://github.com/nodeca/pako/
	 */
	
	// Use ordinary array, since untyped makes no boost here
	function makeTable() {
	    var c, table = [];
	
	    for(var n =0; n < 256; n++){
	        c = n;
	        for(var k =0; k < 8; k++){
	            c = ((c&1) ? (0xEDB88320 ^ (c >>> 1)) : (c >>> 1));
	        }
	        table[n] = c;
	    }
	
	    return table;
	}
	
	// Create table on load. Just 255 signed longs. Not a problem.
	var crcTable = makeTable();
	
	
	function crc32(crc, buf, len, pos) {
	    var t = crcTable, end = pos + len;
	
	    crc = crc ^ (-1);
	
	    for (var i = pos; i < end; i++ ) {
	        crc = (crc >>> 8) ^ t[(crc ^ buf[i]) & 0xFF];
	    }
	
	    return (crc ^ (-1)); // >>> 0;
	}
	
	// That's all for the pako functions.
	
	/**
	 * Compute the crc32 of a string.
	 * This is almost the same as the function crc32, but for strings. Using the
	 * same function for the two use cases leads to horrible performances.
	 * @param {Number} crc the starting value of the crc.
	 * @param {String} str the string to use.
	 * @param {Number} len the length of the string.
	 * @param {Number} pos the starting position for the crc32 computation.
	 * @return {Number} the computed crc32.
	 */
	function crc32str(crc, str, len, pos) {
	    var t = crcTable, end = pos + len;
	
	    crc = crc ^ (-1);
	
	    for (var i = pos; i < end; i++ ) {
	        crc = (crc >>> 8) ^ t[(crc ^ str.charCodeAt(i)) & 0xFF];
	    }
	
	    return (crc ^ (-1)); // >>> 0;
	}
	
	module.exports = function crc32wrapper(input, crc) {
	    if (typeof input === "undefined" || !input.length) {
	        return 0;
	    }
	
	    var isArray = utils.getTypeOf(input) !== "string";
	
	    if(isArray) {
	        return crc32(crc|0, input, input.length, 0);
	    } else {
	        return crc32str(crc|0, input, input.length, 0);
	    }
	};


/***/ },
/* 277 */
/***/ function(module, exports) {

	'use strict';
	
	// (C) 1995-2013 Jean-loup Gailly and Mark Adler
	// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	//
	// This software is provided 'as-is', without any express or implied
	// warranty. In no event will the authors be held liable for any damages
	// arising from the use of this software.
	//
	// Permission is granted to anyone to use this software for any purpose,
	// including commercial applications, and to alter it and redistribute it
	// freely, subject to the following restrictions:
	//
	// 1. The origin of this software must not be misrepresented; you must not
	//   claim that you wrote the original software. If you use this software
	//   in a product, an acknowledgment in the product documentation would be
	//   appreciated but is not required.
	// 2. Altered source versions must be plainly marked as such, and must not be
	//   misrepresented as being the original software.
	// 3. This notice may not be removed or altered from any source distribution.
	
	module.exports = {
	  2:      'need dictionary',     /* Z_NEED_DICT       2  */
	  1:      'stream end',          /* Z_STREAM_END      1  */
	  0:      '',                    /* Z_OK              0  */
	  '-1':   'file error',          /* Z_ERRNO         (-1) */
	  '-2':   'stream error',        /* Z_STREAM_ERROR  (-2) */
	  '-3':   'data error',          /* Z_DATA_ERROR    (-3) */
	  '-4':   'insufficient memory', /* Z_MEM_ERROR     (-4) */
	  '-5':   'buffer error',        /* Z_BUF_ERROR     (-5) */
	  '-6':   'incompatible version' /* Z_VERSION_ERROR (-6) */
	};


/***/ },
/* 278 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = compareObjects;
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function compareObjects(objA, objB) {
	  var keys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	
	  if (objA === objB) {
	    return false;
	  }
	
	  var aKeys = Object.keys(objA);
	  var bKeys = Object.keys(objB);
	
	  if (aKeys.length !== bKeys.length) {
	    return true;
	  }
	
	  var keysMap = {};
	  var i, len;
	
	  for (i = 0, len = keys.length; i < len; i++) {
	    keysMap[keys[i]] = true;
	  }
	
	  for (i = 0, len = aKeys.length; i < len; i++) {
	    var key = aKeys[i];
	    var aValue = objA[key];
	    var bValue = objB[key];
	
	    if (aValue === bValue) {
	      continue;
	    }
	
	    if (!keysMap[key] || aValue === null || bValue === null || _typeof(aValue) !== 'object' || _typeof(bValue) !== 'object') {
	      return true;
	    }
	
	    var aValueKeys = Object.keys(aValue);
	    var bValueKeys = Object.keys(bValue);
	
	    if (aValueKeys.length !== bValueKeys.length) {
	      return true;
	    }
	
	    for (var n = 0, length = aValueKeys.length; n < length; n++) {
	      var aValueKey = aValueKeys[n];
	
	      if (aValue[aValueKey] !== bValue[aValueKey]) {
	        return true;
	      }
	    }
	  }
	
	  return false;
	}

/***/ },
/* 279 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {!function(e,t){ true?t(exports,__webpack_require__(1),__webpack_require__(3),__webpack_require__(9),__webpack_require__(385),__webpack_require__(386),__webpack_require__(1094),__webpack_require__(381),__webpack_require__(380),__webpack_require__(255),__webpack_require__(382),__webpack_require__(257),__webpack_require__(383),__webpack_require__(1171),__webpack_require__(1170),__webpack_require__(1169),__webpack_require__(1173),__webpack_require__(1172),__webpack_require__(1174),__webpack_require__(1104),__webpack_require__(1101),__webpack_require__(1098),__webpack_require__(1096),__webpack_require__(1095),__webpack_require__(1099),__webpack_require__(1102),__webpack_require__(1103),__webpack_require__(1106),__webpack_require__(1105),__webpack_require__(1164),__webpack_require__(1162),__webpack_require__(1161),__webpack_require__(388),__webpack_require__(1163),__webpack_require__(1165),__webpack_require__(1126),__webpack_require__(1125),__webpack_require__(1087),__webpack_require__(1088),__webpack_require__(1089),__webpack_require__(1090),__webpack_require__(258),__webpack_require__(260),__webpack_require__(1167),__webpack_require__(389),__webpack_require__(1168),__webpack_require__(1091),__webpack_require__(1093),__webpack_require__(1092),__webpack_require__(1109),__webpack_require__(1110),__webpack_require__(1111),__webpack_require__(1113),__webpack_require__(1112),__webpack_require__(1107),__webpack_require__(1108),__webpack_require__(1114),__webpack_require__(23),__webpack_require__(1159),__webpack_require__(1160),__webpack_require__(1442),__webpack_require__(169),__webpack_require__(43)):"function"==typeof define&&define.amd?define(["exports","react","prop-types","classnames","date-fns/isDate","date-fns/isValid","date-fns/format","date-fns/addMinutes","date-fns/addHours","date-fns/addDays","date-fns/addWeeks","date-fns/addMonths","date-fns/addYears","date-fns/subMinutes","date-fns/subHours","date-fns/subDays","date-fns/subWeeks","date-fns/subMonths","date-fns/subYears","date-fns/getSeconds","date-fns/getMinutes","date-fns/getHours","date-fns/getDay","date-fns/getDate","date-fns/getISOWeek","date-fns/getMonth","date-fns/getQuarter","date-fns/getYear","date-fns/getTime","date-fns/setSeconds","date-fns/setMinutes","date-fns/setHours","date-fns/setMonth","date-fns/setQuarter","date-fns/setYear","date-fns/min","date-fns/max","date-fns/differenceInCalendarDays","date-fns/differenceInCalendarMonths","date-fns/differenceInCalendarWeeks","date-fns/differenceInCalendarYears","date-fns/startOfDay","date-fns/startOfWeek","date-fns/startOfMonth","date-fns/startOfQuarter","date-fns/startOfYear","date-fns/endOfDay","date-fns/endOfWeek","date-fns/endOfMonth","date-fns/isEqual","date-fns/isSameDay","date-fns/isSameMonth","date-fns/isSameYear","date-fns/isSameQuarter","date-fns/isAfter","date-fns/isBefore","date-fns/isWithinInterval","date-fns/toDate","date-fns/parse","date-fns/parseISO","react-onclickoutside","react-popper","react-dom"],t):t((e="undefined"!=typeof globalThis?globalThis:e||self).DatePicker={},e.React,e.PropTypes,e.classNames,e.isDate,e.isValidDate,e.format,e.addMinutes,e.addHours,e.addDays,e.addWeeks,e.addMonths,e.addYears,null,null,e.subDays,e.subWeeks,e.subMonths,e.subYears,e.getSeconds,e.getMinutes,e.getHours,e.getDay,e.getDate,e.getISOWeek,e.getMonth,e.getQuarter,e.getYear,e.getTime,e.setSeconds,e.setMinutes,e.setHours,e.setMonth,e.setQuarter,e.setYear,e.min,e.max,e.differenceInCalendarDays,e.differenceInCalendarMonths,null,e.differenceInCalendarYears,e.startOfDay,e.startOfWeek,e.startOfMonth,e.startOfQuarter,e.startOfYear,e.endOfDay,null,null,e.dfIsEqual,e.dfIsSameDay,e.dfIsSameMonth,e.dfIsSameYear,e.dfIsSameQuarter,e.isAfter,e.isBefore,e.isWithinInterval,e.toDate,e.parse,e.parseISO,e.onClickOutside,e.ReactPopper,e.ReactDOM)}(this,(function(e,t,r,a,n,o,s,i,p,l,d,c,u,f,h,m,y,v,D,w,k,g,b,C,S,_,M,P,E,N,O,Y,x,T,I,L,F,R,q,A,W,B,j,H,K,Q,V,U,$,z,G,J,X,Z,ee,te,re,ae,ne,oe,se,ie,pe){"use strict";function le(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var de=le(t),ce=le(a),ue=le(n),fe=le(o),he=le(s),me=le(i),ye=le(p),ve=le(l),De=le(d),we=le(c),ke=le(u),ge=le(m),be=le(y),Ce=le(v),Se=le(D),_e=le(w),Me=le(k),Pe=le(g),Ee=le(b),Ne=le(C),Oe=le(S),Ye=le(_),xe=le(M),Te=le(P),Ie=le(E),Le=le(N),Fe=le(O),Re=le(Y),qe=le(x),Ae=le(T),We=le(I),Be=le(L),je=le(F),He=le(R),Ke=le(q),Qe=le(W),Ve=le(B),Ue=le(j),$e=le(H),ze=le(K),Ge=le(Q),Je=le(V),Xe=le(z),Ze=le(G),et=le(J),tt=le(X),rt=le(Z),at=le(ee),nt=le(te),ot=le(re),st=le(ae),it=le(ne),pt=le(oe),lt=le(se),dt=le(pe);function ct(e){return(ct="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function ut(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function ft(e,t){for(var r=0;r<t.length;r++){var a=t[r];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}function ht(e,t,r){return t&&ft(e.prototype,t),r&&ft(e,r),e}function mt(e,t,r){return t in e?Object.defineProperty(e,t,{value:r,enumerable:!0,configurable:!0,writable:!0}):e[t]=r,e}function yt(){return(yt=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var a in r)Object.prototype.hasOwnProperty.call(r,a)&&(e[a]=r[a])}return e}).apply(this,arguments)}function vt(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var a=Object.getOwnPropertySymbols(e);t&&(a=a.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),r.push.apply(r,a)}return r}function Dt(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{};t%2?vt(Object(r),!0).forEach((function(t){mt(e,t,r[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):vt(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}return e}function wt(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&gt(e,t)}function kt(e){return(kt=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function gt(e,t){return(gt=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}function bt(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}function Ct(e,t){return!t||"object"!=typeof t&&"function"!=typeof t?bt(e):t}function St(e){var t=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=kt(e);if(t){var n=kt(this).constructor;r=Reflect.construct(a,arguments,n)}else r=a.apply(this,arguments);return Ct(this,r)}}function _t(e){return function(e){if(Array.isArray(e))return Mt(e)}(e)||function(e){if("undefined"!=typeof Symbol&&Symbol.iterator in Object(e))return Array.from(e)}(e)||function(e,t){if(!e)return;if("string"==typeof e)return Mt(e,t);var r=Object.prototype.toString.call(e).slice(8,-1);"Object"===r&&e.constructor&&(r=e.constructor.name);if("Map"===r||"Set"===r)return Array.from(e);if("Arguments"===r||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))return Mt(e,t)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function Mt(e,t){(null==t||t>e.length)&&(t=e.length);for(var r=0,a=new Array(t);r<t;r++)a[r]=e[r];return a}function Pt(e,t){switch(e){case"P":return t.date({width:"short"});case"PP":return t.date({width:"medium"});case"PPP":return t.date({width:"long"});case"PPPP":default:return t.date({width:"full"})}}function Et(e,t){switch(e){case"p":return t.time({width:"short"});case"pp":return t.time({width:"medium"});case"ppp":return t.time({width:"long"});case"pppp":default:return t.time({width:"full"})}}var Nt={p:Et,P:function(e,t){var r,a=e.match(/(P+)(p+)?/),n=a[1],o=a[2];if(!o)return Pt(e,t);switch(n){case"P":r=t.dateTime({width:"short"});break;case"PP":r=t.dateTime({width:"medium"});break;case"PPP":r=t.dateTime({width:"long"});break;case"PPPP":default:r=t.dateTime({width:"full"})}return r.replace("{{date}}",Pt(n,t)).replace("{{time}}",Et(o,t))}},Ot=12,Yt=/P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;function xt(e){var t=e?"string"==typeof e||e instanceof String?pt.default(e):st.default(e):new Date;return It(t)?t:null}function Tt(e,t,r,a){var n=null,o=Jt(r)||Jt(Gt()),s=!0;return Array.isArray(t)?(t.forEach((function(t){var r=it.default(e,t,new Date,{locale:o});a&&(s=It(r)&&e===he.default(r,t,{awareOfUnicodeTokens:!0})),It(r)&&s&&(n=r)})),n):(n=it.default(e,t,new Date,{locale:o}),a?s=It(n)&&e===he.default(n,t,{awareOfUnicodeTokens:!0}):It(n)||(t=t.match(Yt).map((function(e){var t=e[0];return"p"===t||"P"===t?o?(0,Nt[t])(e,o.formatLong):t:e})).join(""),e.length>0&&(n=it.default(e,t.slice(0,e.length),new Date)),It(n)||(n=new Date(e))),It(n)&&s?n:null)}function It(e){return fe.default(e)&&at.default(e,new Date("1/1/1000"))}function Lt(e,t,r){if("en"===r)return he.default(e,t,{awareOfUnicodeTokens:!0});var a=Jt(r);return r&&!a&&console.warn('A locale object was not found for the provided string ["'.concat(r,'"].')),!a&&Gt()&&Jt(Gt())&&(a=Jt(Gt())),he.default(e,t,{locale:a||null,awareOfUnicodeTokens:!0})}function Ft(e,t){var r=t.hour,a=void 0===r?0:r,n=t.minute,o=void 0===n?0:n,s=t.second,i=void 0===s?0:s;return Re.default(Fe.default(Le.default(e,i),o),a)}function Rt(e,t){var r=t&&Jt(t)||Gt()&&Jt(Gt());return Oe.default(e,r?{locale:r}:null)}function qt(e,t){return Lt(e,"ddd",t)}function At(e){return Ve.default(e)}function Wt(e,t){var r=Jt(t||Gt());return Ue.default(e,{locale:r})}function Bt(e){return $e.default(e)}function jt(e){return Ge.default(e)}function Ht(e){return ze.default(e)}function Kt(e,t){return e&&t?tt.default(e,t):!e&&!t}function Qt(e,t){return e&&t?et.default(e,t):!e&&!t}function Vt(e,t){return e&&t?rt.default(e,t):!e&&!t}function Ut(e,t){return e&&t?Ze.default(e,t):!e&&!t}function $t(e,t){return e&&t?Xe.default(e,t):!e&&!t}function zt(e,t,r){var a,n=Ve.default(t),o=Je.default(r);try{a=ot.default(e,{start:n,end:o})}catch(e){a=!1}return a}function Gt(){return("undefined"!=typeof window?window:global).__localeId__}function Jt(e){if("string"==typeof e){var t="undefined"!=typeof window?window:global;return t.__localeData__?t.__localeData__[e]:null}return e}function Xt(e,t){return Lt(qe.default(xt(),e),"LLLL",t)}function Zt(e,t){return Lt(qe.default(xt(),e),"LLL",t)}function er(e,t){return Lt(Ae.default(xt(),e),"QQQ",t)}function tr(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,a=t.maxDate,n=t.excludeDates,o=t.includeDates,s=t.filterDate;return pr(e,{minDate:r,maxDate:a})||n&&n.some((function(t){return Ut(e,t)}))||o&&!o.some((function(t){return Ut(e,t)}))||s&&!s(xt(e))||!1}function rr(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.excludeDates;return r&&r.some((function(t){return Ut(e,t)}))||!1}function ar(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,a=t.maxDate,n=t.excludeDates,o=t.includeDates,s=t.filterDate;return pr(e,{minDate:r,maxDate:a})||n&&n.some((function(t){return Qt(e,t)}))||o&&!o.some((function(t){return Qt(e,t)}))||s&&!s(xt(e))||!1}function nr(e,t,r,a){var n=Te.default(e),o=Ye.default(e),s=Te.default(t),i=Ye.default(t),p=Te.default(a);return n===s&&n===p?o<=r&&r<=i:n<s?p===n&&o<=r||p===s&&i>=r||p<s&&p>n:void 0}function or(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,a=t.maxDate,n=t.excludeDates,o=t.includeDates,s=t.filterDate;return pr(e,{minDate:r,maxDate:a})||n&&n.some((function(t){return Vt(e,t)}))||o&&!o.some((function(t){return Vt(e,t)}))||s&&!s(xt(e))||!1}function sr(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,a=t.maxDate,n=new Date(e,0,1);return pr(n,{minDate:r,maxDate:a})||!1}function ir(e,t,r,a){var n=Te.default(e),o=xe.default(e),s=Te.default(t),i=xe.default(t),p=Te.default(a);return n===s&&n===p?o<=r&&r<=i:n<s?p===n&&o<=r||p===s&&i>=r||p<s&&p>n:void 0}function pr(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,a=t.maxDate;return r&&He.default(e,r)<0||a&&He.default(e,a)>0}function lr(e,t){return t.some((function(t){return Pe.default(t)===Pe.default(e)&&Me.default(t)===Me.default(e)}))}function dr(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.excludeTimes,a=t.includeTimes,n=t.filterTime;return r&&lr(e,r)||a&&!lr(e,a)||n&&!n(e)||!1}function cr(e,t){var r=t.minTime,a=t.maxTime;if(!r||!a)throw new Error("Both minTime and maxTime props required");var n,o=xt(),s=Re.default(Fe.default(o,Me.default(e)),Pe.default(e)),i=Re.default(Fe.default(o,Me.default(r)),Pe.default(r)),p=Re.default(Fe.default(o,Me.default(a)),Pe.default(a));try{n=!ot.default(s,{start:i,end:p})}catch(e){n=!1}return n}function ur(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,a=t.includeDates,n=Ce.default(e,1);return r&&Ke.default(r,n)>0||a&&a.every((function(e){return Ke.default(e,n)>0}))||!1}function fr(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.maxDate,a=t.includeDates,n=we.default(e,1);return r&&Ke.default(n,r)>0||a&&a.every((function(e){return Ke.default(n,e)>0}))||!1}function hr(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,a=t.includeDates,n=Se.default(e,1);return r&&Qe.default(r,n)>0||a&&a.every((function(e){return Qe.default(e,n)>0}))||!1}function mr(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.maxDate,a=t.includeDates,n=ke.default(e,1);return r&&Qe.default(n,r)>0||a&&a.every((function(e){return Qe.default(n,e)>0}))||!1}function yr(e){var t=e.minDate,r=e.includeDates;if(r&&t){var a=r.filter((function(e){return He.default(e,t)>=0}));return Be.default(a)}return r?Be.default(r):t}function vr(e){var t=e.maxDate,r=e.includeDates;if(r&&t){var a=r.filter((function(e){return He.default(e,t)<=0}));return je.default(a)}return r?je.default(r):t}function Dr(){for(var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[],t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"react-datepicker__day--highlighted",r=new Map,a=0,n=e.length;a<n;a++){var o=e[a];if(ue.default(o)){var s=Lt(o,"MM.dd.yyyy"),i=r.get(s)||[];i.includes(t)||(i.push(t),r.set(s,i))}else if("object"===ct(o)){var p=Object.keys(o),l=p[0],d=o[p[0]];if("string"==typeof l&&d.constructor===Array)for(var c=0,u=d.length;c<u;c++){var f=Lt(d[c],"MM.dd.yyyy"),h=r.get(f)||[];h.includes(l)||(h.push(l),r.set(f,h))}}}return r}function wr(e,t,r,a,n){for(var o=n.length,s=[],i=0;i<o;i++){var p=me.default(ye.default(e,Pe.default(n[i])),Me.default(n[i])),l=me.default(e,(r+1)*a);at.default(p,t)&&nt.default(p,l)&&s.push(n[i])}return s}function kr(e){return e<10?"0".concat(e):"".concat(e)}function gr(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:Ot,r=Math.ceil(Te.default(e)/t)*t,a=r-(t-1);return{startPeriod:a,endPeriod:r}}function br(e,t,r,a){for(var n=[],o=0;o<2*t+1;o++){var s=e+t-o,i=!0;r&&(i=Te.default(r)<=s),a&&i&&(i=Te.default(a)>=s),i&&n.push(s)}return n}var Cr=function(e){wt(r,e);var t=St(r);function r(e){var a;ut(this,r),mt(bt(a=t.call(this,e)),"renderOptions",(function(){var e=a.props.year,t=a.state.yearsList.map((function(t){return de.default.createElement("div",{className:e===t?"react-datepicker__year-option react-datepicker__year-option--selected_year":"react-datepicker__year-option",key:t,onClick:a.onChange.bind(bt(a),t)},e===t?de.default.createElement("span",{className:"react-datepicker__year-option--selected"},"✓"):"",t)})),r=a.props.minDate?Te.default(a.props.minDate):null,n=a.props.maxDate?Te.default(a.props.maxDate):null;return n&&a.state.yearsList.find((function(e){return e===n}))||t.unshift(de.default.createElement("div",{className:"react-datepicker__year-option",key:"upcoming",onClick:a.incrementYears},de.default.createElement("a",{className:"react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming"}))),r&&a.state.yearsList.find((function(e){return e===r}))||t.push(de.default.createElement("div",{className:"react-datepicker__year-option",key:"previous",onClick:a.decrementYears},de.default.createElement("a",{className:"react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous"}))),t})),mt(bt(a),"onChange",(function(e){a.props.onChange(e)})),mt(bt(a),"handleClickOutside",(function(){a.props.onCancel()})),mt(bt(a),"shiftYears",(function(e){var t=a.state.yearsList.map((function(t){return t+e}));a.setState({yearsList:t})})),mt(bt(a),"incrementYears",(function(){return a.shiftYears(1)})),mt(bt(a),"decrementYears",(function(){return a.shiftYears(-1)}));var n=e.yearDropdownItemNumber,o=e.scrollableYearDropdown,s=n||(o?10:5);return a.state={yearsList:br(a.props.year,s,a.props.minDate,a.props.maxDate)},a}return ht(r,[{key:"render",value:function(){var e=ce.default({"react-datepicker__year-dropdown":!0,"react-datepicker__year-dropdown--scrollable":this.props.scrollableYearDropdown});return de.default.createElement("div",{className:e},this.renderOptions())}}]),r}(de.default.Component),Sr=lt.default(Cr),_r=function(e){wt(r,e);var t=St(r);function r(){var e;ut(this,r);for(var a=arguments.length,n=new Array(a),o=0;o<a;o++)n[o]=arguments[o];return mt(bt(e=t.call.apply(t,[this].concat(n))),"state",{dropdownVisible:!1}),mt(bt(e),"renderSelectOptions",(function(){for(var t=e.props.minDate?Te.default(e.props.minDate):1900,r=e.props.maxDate?Te.default(e.props.maxDate):2100,a=[],n=t;n<=r;n++)a.push(de.default.createElement("option",{key:n,value:n},n));return a})),mt(bt(e),"onSelectChange",(function(t){e.onChange(t.target.value)})),mt(bt(e),"renderSelectMode",(function(){return de.default.createElement("select",{value:e.props.year,className:"react-datepicker__year-select",onChange:e.onSelectChange},e.renderSelectOptions())})),mt(bt(e),"renderReadView",(function(t){return de.default.createElement("div",{key:"read",style:{visibility:t?"visible":"hidden"},className:"react-datepicker__year-read-view",onClick:function(t){return e.toggleDropdown(t)}},de.default.createElement("span",{className:"react-datepicker__year-read-view--down-arrow"}),de.default.createElement("span",{className:"react-datepicker__year-read-view--selected-year"},e.props.year))})),mt(bt(e),"renderDropdown",(function(){return de.default.createElement(Sr,{key:"dropdown",year:e.props.year,onChange:e.onChange,onCancel:e.toggleDropdown,minDate:e.props.minDate,maxDate:e.props.maxDate,scrollableYearDropdown:e.props.scrollableYearDropdown,yearDropdownItemNumber:e.props.yearDropdownItemNumber})})),mt(bt(e),"renderScrollMode",(function(){var t=e.state.dropdownVisible,r=[e.renderReadView(!t)];return t&&r.unshift(e.renderDropdown()),r})),mt(bt(e),"onChange",(function(t){e.toggleDropdown(),t!==e.props.year&&e.props.onChange(t)})),mt(bt(e),"toggleDropdown",(function(t){e.setState({dropdownVisible:!e.state.dropdownVisible},(function(){e.props.adjustDateOnChange&&e.handleYearChange(e.props.date,t)}))})),mt(bt(e),"handleYearChange",(function(t,r){e.onSelect(t,r),e.setOpen()})),mt(bt(e),"onSelect",(function(t,r){e.props.onSelect&&e.props.onSelect(t,r)})),mt(bt(e),"setOpen",(function(){e.props.setOpen&&e.props.setOpen(!0)})),e}return ht(r,[{key:"render",value:function(){var e;switch(this.props.dropdownMode){case"scroll":e=this.renderScrollMode();break;case"select":e=this.renderSelectMode()}return de.default.createElement("div",{className:"react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--".concat(this.props.dropdownMode)},e)}}]),r}(de.default.Component),Mr=function(e){wt(r,e);var t=St(r);function r(){var e;ut(this,r);for(var a=arguments.length,n=new Array(a),o=0;o<a;o++)n[o]=arguments[o];return mt(bt(e=t.call.apply(t,[this].concat(n))),"renderOptions",(function(){return e.props.monthNames.map((function(t,r){return de.default.createElement("div",{className:e.props.month===r?"react-datepicker__month-option react-datepicker__month-option--selected_month":"react-datepicker__month-option",key:t,onClick:e.onChange.bind(bt(e),r)},e.props.month===r?de.default.createElement("span",{className:"react-datepicker__month-option--selected"},"✓"):"",t)}))})),mt(bt(e),"onChange",(function(t){return e.props.onChange(t)})),mt(bt(e),"handleClickOutside",(function(){return e.props.onCancel()})),e}return ht(r,[{key:"render",value:function(){return de.default.createElement("div",{className:"react-datepicker__month-dropdown"},this.renderOptions())}}]),r}(de.default.Component),Pr=lt.default(Mr),Er=function(e){wt(r,e);var t=St(r);function r(){var e;ut(this,r);for(var a=arguments.length,n=new Array(a),o=0;o<a;o++)n[o]=arguments[o];return mt(bt(e=t.call.apply(t,[this].concat(n))),"state",{dropdownVisible:!1}),mt(bt(e),"renderSelectOptions",(function(e){return e.map((function(e,t){return de.default.createElement("option",{key:t,value:t},e)}))})),mt(bt(e),"renderSelectMode",(function(t){return de.default.createElement("select",{value:e.props.month,className:"react-datepicker__month-select",onChange:function(t){return e.onChange(t.target.value)}},e.renderSelectOptions(t))})),mt(bt(e),"renderReadView",(function(t,r){return de.default.createElement("div",{key:"read",style:{visibility:t?"visible":"hidden"},className:"react-datepicker__month-read-view",onClick:e.toggleDropdown},de.default.createElement("span",{className:"react-datepicker__month-read-view--down-arrow"}),de.default.createElement("span",{className:"react-datepicker__month-read-view--selected-month"},r[e.props.month]))})),mt(bt(e),"renderDropdown",(function(t){return de.default.createElement(Pr,{key:"dropdown",month:e.props.month,monthNames:t,onChange:e.onChange,onCancel:e.toggleDropdown})})),mt(bt(e),"renderScrollMode",(function(t){var r=e.state.dropdownVisible,a=[e.renderReadView(!r,t)];return r&&a.unshift(e.renderDropdown(t)),a})),mt(bt(e),"onChange",(function(t){e.toggleDropdown(),t!==e.props.month&&e.props.onChange(t)})),mt(bt(e),"toggleDropdown",(function(){return e.setState({dropdownVisible:!e.state.dropdownVisible})})),e}return ht(r,[{key:"render",value:function(){var e,t=this,r=[0,1,2,3,4,5,6,7,8,9,10,11].map(this.props.useShortMonthInDropdown?function(e){return Zt(e,t.props.locale)}:function(e){return Xt(e,t.props.locale)});switch(this.props.dropdownMode){case"scroll":e=this.renderScrollMode(r);break;case"select":e=this.renderSelectMode(r)}return de.default.createElement("div",{className:"react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--".concat(this.props.dropdownMode)},e)}}]),r}(de.default.Component);function Nr(e,t){for(var r=[],a=Bt(e),n=Bt(t);!at.default(a,n);)r.push(xt(a)),a=we.default(a,1);return r}var Or=function(e){wt(r,e);var t=St(r);function r(e){var a;return ut(this,r),mt(bt(a=t.call(this,e)),"renderOptions",(function(){return a.state.monthYearsList.map((function(e){var t=Ie.default(e),r=Kt(a.props.date,e)&&Qt(a.props.date,e);return de.default.createElement("div",{className:r?"react-datepicker__month-year-option --selected_month-year":"react-datepicker__month-year-option",key:t,onClick:a.onChange.bind(bt(a),t)},r?de.default.createElement("span",{className:"react-datepicker__month-year-option--selected"},"✓"):"",Lt(e,a.props.dateFormat,a.props.locale))}))})),mt(bt(a),"onChange",(function(e){return a.props.onChange(e)})),mt(bt(a),"handleClickOutside",(function(){a.props.onCancel()})),a.state={monthYearsList:Nr(a.props.minDate,a.props.maxDate)},a}return ht(r,[{key:"render",value:function(){var e=ce.default({"react-datepicker__month-year-dropdown":!0,"react-datepicker__month-year-dropdown--scrollable":this.props.scrollableMonthYearDropdown});return de.default.createElement("div",{className:e},this.renderOptions())}}]),r}(de.default.Component),Yr=lt.default(Or),xr=function(e){wt(r,e);var t=St(r);function r(){var e;ut(this,r);for(var a=arguments.length,n=new Array(a),o=0;o<a;o++)n[o]=arguments[o];return mt(bt(e=t.call.apply(t,[this].concat(n))),"state",{dropdownVisible:!1}),mt(bt(e),"renderSelectOptions",(function(){for(var t=Bt(e.props.minDate),r=Bt(e.props.maxDate),a=[];!at.default(t,r);){var n=Ie.default(t);a.push(de.default.createElement("option",{key:n,value:n},Lt(t,e.props.dateFormat,e.props.locale))),t=we.default(t,1)}return a})),mt(bt(e),"onSelectChange",(function(t){e.onChange(t.target.value)})),mt(bt(e),"renderSelectMode",(function(){return de.default.createElement("select",{value:Ie.default(Bt(e.props.date)),className:"react-datepicker__month-year-select",onChange:e.onSelectChange},e.renderSelectOptions())})),mt(bt(e),"renderReadView",(function(t){var r=Lt(e.props.date,e.props.dateFormat,e.props.locale);return de.default.createElement("div",{key:"read",style:{visibility:t?"visible":"hidden"},className:"react-datepicker__month-year-read-view",onClick:function(t){return e.toggleDropdown(t)}},de.default.createElement("span",{className:"react-datepicker__month-year-read-view--down-arrow"}),de.default.createElement("span",{className:"react-datepicker__month-year-read-view--selected-month-year"},r))})),mt(bt(e),"renderDropdown",(function(){return de.default.createElement(Yr,{key:"dropdown",date:e.props.date,dateFormat:e.props.dateFormat,onChange:e.onChange,onCancel:e.toggleDropdown,minDate:e.props.minDate,maxDate:e.props.maxDate,scrollableMonthYearDropdown:e.props.scrollableMonthYearDropdown,locale:e.props.locale})})),mt(bt(e),"renderScrollMode",(function(){var t=e.state.dropdownVisible,r=[e.renderReadView(!t)];return t&&r.unshift(e.renderDropdown()),r})),mt(bt(e),"onChange",(function(t){e.toggleDropdown();var r=xt(parseInt(t));Kt(e.props.date,r)&&Qt(e.props.date,r)||e.props.onChange(r)})),mt(bt(e),"toggleDropdown",(function(){return e.setState({dropdownVisible:!e.state.dropdownVisible})})),e}return ht(r,[{key:"render",value:function(){var e;switch(this.props.dropdownMode){case"scroll":e=this.renderScrollMode();break;case"select":e=this.renderSelectMode()}return de.default.createElement("div",{className:"react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--".concat(this.props.dropdownMode)},e)}}]),r}(de.default.Component),Tr=function(e){wt(r,e);var t=St(r);function r(){var e;ut(this,r);for(var a=arguments.length,n=new Array(a),o=0;o<a;o++)n[o]=arguments[o];return mt(bt(e=t.call.apply(t,[this].concat(n))),"dayEl",de.default.createRef()),mt(bt(e),"handleClick",(function(t){!e.isDisabled()&&e.props.onClick&&e.props.onClick(t)})),mt(bt(e),"handleMouseEnter",(function(t){!e.isDisabled()&&e.props.onMouseEnter&&e.props.onMouseEnter(t)})),mt(bt(e),"handleOnKeyDown",(function(t){" "===t.key&&(t.preventDefault(),t.key="Enter"),e.props.handleOnKeyDown(t)})),mt(bt(e),"isSameDay",(function(t){return Ut(e.props.day,t)})),mt(bt(e),"isKeyboardSelected",(function(){return!e.props.disabledKeyboardNavigation&&!e.isSameDay(e.props.selected)&&e.isSameDay(e.props.preSelection)})),mt(bt(e),"isDisabled",(function(){return tr(e.props.day,e.props)})),mt(bt(e),"isExcluded",(function(){return rr(e.props.day,e.props)})),mt(bt(e),"getHighLightedClass",(function(t){var r=e.props,a=r.day,n=r.highlightDates;if(!n)return!1;var o=Lt(a,"MM.dd.yyyy");return n.get(o)})),mt(bt(e),"isInRange",(function(){var t=e.props,r=t.day,a=t.startDate,n=t.endDate;return!(!a||!n)&&zt(r,a,n)})),mt(bt(e),"isInSelectingRange",(function(){var t=e.props,r=t.day,a=t.selectsStart,n=t.selectsEnd,o=t.selectsRange,s=t.selectingDate,i=t.startDate,p=t.endDate;return!(!(a||n||o)||!s||e.isDisabled())&&(a&&p&&(nt.default(s,p)||$t(s,p))?zt(r,s,p):(n&&i&&(at.default(s,i)||$t(s,i))||!(!o||!i||p||!at.default(s,i)&&!$t(s,i)))&&zt(r,i,s))})),mt(bt(e),"isSelectingRangeStart",(function(){if(!e.isInSelectingRange())return!1;var t=e.props,r=t.day,a=t.selectingDate,n=t.startDate;return Ut(r,t.selectsStart?a:n)})),mt(bt(e),"isSelectingRangeEnd",(function(){if(!e.isInSelectingRange())return!1;var t=e.props,r=t.day,a=t.selectingDate,n=t.endDate;return Ut(r,t.selectsEnd?a:n)})),mt(bt(e),"isRangeStart",(function(){var t=e.props,r=t.day,a=t.startDate,n=t.endDate;return!(!a||!n)&&Ut(a,r)})),mt(bt(e),"isRangeEnd",(function(){var t=e.props,r=t.day,a=t.startDate,n=t.endDate;return!(!a||!n)&&Ut(n,r)})),mt(bt(e),"isWeekend",(function(){var t=Ee.default(e.props.day);return 0===t||6===t})),mt(bt(e),"isOutsideMonth",(function(){return void 0!==e.props.month&&e.props.month!==Ye.default(e.props.day)})),mt(bt(e),"getClassNames",(function(t){var r=e.props.dayClassName?e.props.dayClassName(t):void 0;return ce.default("react-datepicker__day",r,"react-datepicker__day--"+qt(e.props.day),{"react-datepicker__day--disabled":e.isDisabled(),"react-datepicker__day--excluded":e.isExcluded(),"react-datepicker__day--selected":e.isSameDay(e.props.selected),"react-datepicker__day--keyboard-selected":e.isKeyboardSelected(),"react-datepicker__day--range-start":e.isRangeStart(),"react-datepicker__day--range-end":e.isRangeEnd(),"react-datepicker__day--in-range":e.isInRange(),"react-datepicker__day--in-selecting-range":e.isInSelectingRange(),"react-datepicker__day--selecting-range-start":e.isSelectingRangeStart(),"react-datepicker__day--selecting-range-end":e.isSelectingRangeEnd(),"react-datepicker__day--today":e.isSameDay(xt()),"react-datepicker__day--weekend":e.isWeekend(),"react-datepicker__day--outside-month":e.isOutsideMonth()},e.getHighLightedClass("react-datepicker__day--highlighted"))})),mt(bt(e),"getAriaLabel",(function(){var t=e.props,r=t.day,a=t.ariaLabelPrefixWhenEnabled,n=void 0===a?"Choose":a,o=t.ariaLabelPrefixWhenDisabled,s=void 0===o?"Not available":o,i=e.isDisabled()||e.isExcluded()?s:n;return"".concat(i," ").concat(Lt(r,"PPPP"))})),mt(bt(e),"getTabIndex",(function(t,r){var a=t||e.props.selected,n=r||e.props.preSelection;return e.isKeyboardSelected()||e.isSameDay(a)&&Ut(n,a)?0:-1})),mt(bt(e),"handleFocusDay",(function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},r=!1;0===e.getTabIndex()&&!t.isInputFocused&&e.isSameDay(e.props.preSelection)&&(document.activeElement&&document.activeElement!==document.body||(r=!0),e.props.inline&&!e.props.shouldFocusDayInline&&(r=!1),e.props.containerRef&&e.props.containerRef.current&&e.props.containerRef.current.contains(document.activeElement)&&document.activeElement.classList.contains("react-datepicker__day")&&(r=!0)),r&&e.dayEl.current.focus({preventScroll:!0})})),mt(bt(e),"renderDayContents",(function(){if(e.isOutsideMonth()){if(e.props.monthShowsDuplicateDaysEnd&&Ne.default(e.props.day)<10)return null;if(e.props.monthShowsDuplicateDaysStart&&Ne.default(e.props.day)>20)return null}return e.props.renderDayContents?e.props.renderDayContents(Ne.default(e.props.day),e.props.day):Ne.default(e.props.day)})),mt(bt(e),"render",(function(){return de.default.createElement("div",{ref:e.dayEl,className:e.getClassNames(e.props.day),onKeyDown:e.handleOnKeyDown,onClick:e.handleClick,onMouseEnter:e.handleMouseEnter,tabIndex:e.getTabIndex(),"aria-label":e.getAriaLabel(),role:"button","aria-disabled":e.isDisabled()},e.renderDayContents())})),e}return ht(r,[{key:"componentDidMount",value:function(){this.handleFocusDay()}},{key:"componentDidUpdate",value:function(e){this.handleFocusDay(e)}}]),r}(de.default.Component),Ir=function(e){wt(r,e);var t=St(r);function r(){var e;ut(this,r);for(var a=arguments.length,n=new Array(a),o=0;o<a;o++)n[o]=arguments[o];return mt(bt(e=t.call.apply(t,[this].concat(n))),"handleClick",(function(t){e.props.onClick&&e.props.onClick(t)})),e}return ht(r,[{key:"render",value:function(){var e=this.props,t=e.weekNumber,r=e.ariaLabelPrefix,a=void 0===r?"week ":r,n={"react-datepicker__week-number":!0,"react-datepicker__week-number--clickable":!!e.onClick};return de.default.createElement("div",{className:ce.default(n),"aria-label":"".concat(a," ").concat(this.props.weekNumber),onClick:this.handleClick},t)}}]),r}(de.default.Component),Lr=function(e){wt(r,e);var t=St(r);function r(){var e;ut(this,r);for(var a=arguments.length,n=new Array(a),o=0;o<a;o++)n[o]=arguments[o];return mt(bt(e=t.call.apply(t,[this].concat(n))),"handleDayClick",(function(t,r){e.props.onDayClick&&e.props.onDayClick(t,r)})),mt(bt(e),"handleDayMouseEnter",(function(t){e.props.onDayMouseEnter&&e.props.onDayMouseEnter(t)})),mt(bt(e),"handleWeekClick",(function(t,r,a){"function"==typeof e.props.onWeekSelect&&e.props.onWeekSelect(t,r,a),e.props.shouldCloseOnSelect&&e.props.setOpen(!1)})),mt(bt(e),"formatWeekNumber",(function(t){return e.props.formatWeekNumber?e.props.formatWeekNumber(t):Rt(t)})),mt(bt(e),"renderDays",(function(){var t=Wt(e.props.day,e.props.locale),r=[],a=e.formatWeekNumber(t);if(e.props.showWeekNumber){var n=e.props.onWeekSelect?e.handleWeekClick.bind(bt(e),t,a):void 0;r.push(de.default.createElement(Ir,{key:"W",weekNumber:a,onClick:n,ariaLabelPrefix:e.props.ariaLabelPrefix}))}return r.concat([0,1,2,3,4,5,6].map((function(r){var a=ve.default(t,r);return de.default.createElement(Tr,{ariaLabelPrefixWhenEnabled:e.props.chooseDayAriaLabelPrefix,ariaLabelPrefixWhenDisabled:e.props.disabledDayAriaLabelPrefix,key:a.valueOf(),day:a,month:e.props.month,onClick:e.handleDayClick.bind(bt(e),a),onMouseEnter:e.handleDayMouseEnter.bind(bt(e),a),minDate:e.props.minDate,maxDate:e.props.maxDate,excludeDates:e.props.excludeDates,includeDates:e.props.includeDates,highlightDates:e.props.highlightDates,selectingDate:e.props.selectingDate,filterDate:e.props.filterDate,preSelection:e.props.preSelection,selected:e.props.selected,selectsStart:e.props.selectsStart,selectsEnd:e.props.selectsEnd,selectsRange:e.props.selectsRange,startDate:e.props.startDate,endDate:e.props.endDate,dayClassName:e.props.dayClassName,renderDayContents:e.props.renderDayContents,disabledKeyboardNavigation:e.props.disabledKeyboardNavigation,handleOnKeyDown:e.props.handleOnKeyDown,isInputFocused:e.props.isInputFocused,containerRef:e.props.containerRef,inline:e.props.inline,shouldFocusDayInline:e.props.shouldFocusDayInline,monthShowsDuplicateDaysEnd:e.props.monthShowsDuplicateDaysEnd,monthShowsDuplicateDaysStart:e.props.monthShowsDuplicateDaysStart})})))})),e}return ht(r,[{key:"render",value:function(){return de.default.createElement("div",{className:"react-datepicker__week"},this.renderDays())}}],[{key:"defaultProps",get:function(){return{shouldCloseOnSelect:!0}}}]),r}(de.default.Component),Fr=function(e){wt(r,e);var t=St(r);function r(){var e;ut(this,r);for(var a=arguments.length,n=new Array(a),o=0;o<a;o++)n[o]=arguments[o];return mt(bt(e=t.call.apply(t,[this].concat(n))),"MONTH_REFS",_t(Array(12)).map((function(){return de.default.createRef()}))),mt(bt(e),"isDisabled",(function(t){return tr(t,e.props)})),mt(bt(e),"isExcluded",(function(t){return rr(t,e.props)})),mt(bt(e),"handleDayClick",(function(t,r){e.props.onDayClick&&e.props.onDayClick(t,r,e.props.orderInDisplay)})),mt(bt(e),"handleDayMouseEnter",(function(t){e.props.onDayMouseEnter&&e.props.onDayMouseEnter(t)})),mt(bt(e),"handleMouseLeave",(function(){e.props.onMouseLeave&&e.props.onMouseLeave()})),mt(bt(e),"isRangeStartMonth",(function(t){var r=e.props,a=r.day,n=r.startDate,o=r.endDate;return!(!n||!o)&&Qt(qe.default(a,t),n)})),mt(bt(e),"isRangeStartQuarter",(function(t){var r=e.props,a=r.day,n=r.startDate,o=r.endDate;return!(!n||!o)&&Vt(Ae.default(a,t),n)})),mt(bt(e),"isRangeEndMonth",(function(t){var r=e.props,a=r.day,n=r.startDate,o=r.endDate;return!(!n||!o)&&Qt(qe.default(a,t),o)})),mt(bt(e),"isRangeEndQuarter",(function(t){var r=e.props,a=r.day,n=r.startDate,o=r.endDate;return!(!n||!o)&&Vt(Ae.default(a,t),o)})),mt(bt(e),"isWeekInMonth",(function(t){var r=e.props.day,a=ve.default(t,6);return Qt(t,r)||Qt(a,r)})),mt(bt(e),"renderWeeks",(function(){for(var t=[],r=e.props.fixedHeight,a=Wt(Bt(e.props.day),e.props.locale),n=0,o=!1;t.push(de.default.createElement(Lr,{ariaLabelPrefix:e.props.weekAriaLabelPrefix,chooseDayAriaLabelPrefix:e.props.chooseDayAriaLabelPrefix,disabledDayAriaLabelPrefix:e.props.disabledDayAriaLabelPrefix,key:n,day:a,month:Ye.default(e.props.day),onDayClick:e.handleDayClick,onDayMouseEnter:e.handleDayMouseEnter,onWeekSelect:e.props.onWeekSelect,formatWeekNumber:e.props.formatWeekNumber,locale:e.props.locale,minDate:e.props.minDate,maxDate:e.props.maxDate,excludeDates:e.props.excludeDates,includeDates:e.props.includeDates,inline:e.props.inline,shouldFocusDayInline:e.props.shouldFocusDayInline,highlightDates:e.props.highlightDates,selectingDate:e.props.selectingDate,filterDate:e.props.filterDate,preSelection:e.props.preSelection,selected:e.props.selected,selectsStart:e.props.selectsStart,selectsEnd:e.props.selectsEnd,selectsRange:e.props.selectsRange,showWeekNumber:e.props.showWeekNumbers,startDate:e.props.startDate,endDate:e.props.endDate,dayClassName:e.props.dayClassName,setOpen:e.props.setOpen,shouldCloseOnSelect:e.props.shouldCloseOnSelect,disabledKeyboardNavigation:e.props.disabledKeyboardNavigation,renderDayContents:e.props.renderDayContents,handleOnKeyDown:e.props.handleOnKeyDown,isInputFocused:e.props.isInputFocused,containerRef:e.props.containerRef,monthShowsDuplicateDaysEnd:e.props.monthShowsDuplicateDaysEnd,monthShowsDuplicateDaysStart:e.props.monthShowsDuplicateDaysStart})),!o;){n++,a=De.default(a,1);var s=r&&n>=6,i=!r&&!e.isWeekInMonth(a);if(s||i){if(!e.props.peekNextMonth)break;o=!0}}return t})),mt(bt(e),"onMonthClick",(function(t,r){e.handleDayClick(Bt(qe.default(e.props.day,r)),t)})),mt(bt(e),"handleMonthNavigation",(function(t,r){e.isDisabled(r)||e.isExcluded(r)||(e.props.setPreSelection(r),e.MONTH_REFS[t].current&&e.MONTH_REFS[t].current.focus())})),mt(bt(e),"onMonthKeyDown",(function(t,r){var a=t.key;if(!e.props.disabledKeyboardNavigation)switch(a){case"Enter":e.onMonthClick(t,r),e.props.setPreSelection(e.props.selected);break;case"ArrowRight":e.handleMonthNavigation(11===r?0:r+1,we.default(e.props.preSelection,1));break;case"ArrowLeft":e.handleMonthNavigation(0===r?11:r-1,Ce.default(e.props.preSelection,1))}})),mt(bt(e),"onQuarterClick",(function(t,r){e.handleDayClick(Ht(Ae.default(e.props.day,r)),t)})),mt(bt(e),"getMonthClassNames",(function(t){var r=e.props,a=r.day,n=r.startDate,o=r.endDate,s=r.selected,i=r.minDate,p=r.maxDate,l=r.preSelection,d=r.monthClassName,c=d?d(a):void 0;return ce.default("react-datepicker__month-text","react-datepicker__month-".concat(t),c,{"react-datepicker__month--disabled":(i||p)&&ar(qe.default(a,t),e.props),"react-datepicker__month--selected":Ye.default(a)===t&&Te.default(a)===Te.default(s),"react-datepicker__month-text--keyboard-selected":Ye.default(l)===t,"react-datepicker__month--in-range":nr(n,o,t,a),"react-datepicker__month--range-start":e.isRangeStartMonth(t),"react-datepicker__month--range-end":e.isRangeEndMonth(t)})})),mt(bt(e),"getTabIndex",(function(t){var r=Ye.default(e.props.preSelection);return e.props.disabledKeyboardNavigation||t!==r?"-1":"0"})),mt(bt(e),"getAriaLabel",(function(t){var r=e.props,a=r.ariaLabelPrefix,n=void 0===a?"Choose":a,o=r.disabledDayAriaLabelPrefix,s=void 0===o?"Not available":o,i=r.day,p=qe.default(i,t),l=e.isDisabled(p)||e.isExcluded(p)?s:n;return"".concat(l," ").concat(Lt(p,"MMMM yyyy"))})),mt(bt(e),"getQuarterClassNames",(function(t){var r=e.props,a=r.day,n=r.startDate,o=r.endDate,s=r.selected,i=r.minDate,p=r.maxDate;return ce.default("react-datepicker__quarter-text","react-datepicker__quarter-".concat(t),{"react-datepicker__quarter--disabled":(i||p)&&or(Ae.default(a,t),e.props),"react-datepicker__quarter--selected":xe.default(a)===t&&Te.default(a)===Te.default(s),"react-datepicker__quarter--in-range":ir(n,o,t,a),"react-datepicker__quarter--range-start":e.isRangeStartQuarter(t),"react-datepicker__quarter--range-end":e.isRangeEndQuarter(t)})})),mt(bt(e),"renderMonths",(function(){var t=e.props,r=t.showFullMonthYearPicker,a=t.showTwoColumnMonthYearPicker,n=t.showFourColumnMonthYearPicker,o=t.locale;return(n?[[0,1,2,3],[4,5,6,7],[8,9,10,11]]:a?[[0,1],[2,3],[4,5],[6,7],[8,9],[10,11]]:[[0,1,2],[3,4,5],[6,7,8],[9,10,11]]).map((function(t,a){return de.default.createElement("div",{className:"react-datepicker__month-wrapper",key:a},t.map((function(t,a){return de.default.createElement("div",{ref:e.MONTH_REFS[t],key:a,onClick:function(r){e.onMonthClick(r,t)},onKeyDown:function(r){e.onMonthKeyDown(r,t)},tabIndex:e.getTabIndex(t),className:e.getMonthClassNames(t),role:"button","aria-label":e.getAriaLabel(t)},r?Xt(t,o):Zt(t,o))})))}))})),mt(bt(e),"renderQuarters",(function(){return de.default.createElement("div",{className:"react-datepicker__quarter-wrapper"},[1,2,3,4].map((function(t,r){return de.default.createElement("div",{key:r,onClick:function(r){e.onQuarterClick(r,t)},className:e.getQuarterClassNames(t)},er(t,e.props.locale))})))})),mt(bt(e),"getClassNames",(function(){var t=e.props;t.day;var r=t.selectingDate,a=t.selectsStart,n=t.selectsEnd,o=t.showMonthYearPicker,s=t.showQuarterYearPicker;return ce.default("react-datepicker__month",{"react-datepicker__month--selecting-range":r&&(a||n)},{"react-datepicker__monthPicker":o},{"react-datepicker__quarterPicker":s})})),e}return ht(r,[{key:"render",value:function(){var e=this.props,t=e.showMonthYearPicker,r=e.showQuarterYearPicker,a=e.day,n=e.ariaLabelPrefix,o=void 0===n?"month ":n;return de.default.createElement("div",{className:this.getClassNames(),onMouseLeave:this.handleMouseLeave,"aria-label":"".concat(o," ").concat(Lt(a,"yyyy-MM"))},t?this.renderMonths():r?this.renderQuarters():this.renderWeeks())}}]),r}(de.default.Component),Rr=function(e){wt(r,e);var t=St(r);function r(){var e;ut(this,r);for(var a=arguments.length,n=new Array(a),o=0;o<a;o++)n[o]=arguments[o];return mt(bt(e=t.call.apply(t,[this].concat(n))),"state",{height:null}),mt(bt(e),"handleClick",(function(t){(e.props.minTime||e.props.maxTime)&&cr(t,e.props)||(e.props.excludeTimes||e.props.includeTimes||e.props.filterTime)&&dr(t,e.props)||e.props.onChange(t)})),mt(bt(e),"liClasses",(function(t,r,a){var n=["react-datepicker__time-list-item",e.props.timeClassName?e.props.timeClassName(t,r,a):void 0];return e.props.selected&&r===Pe.default(t)&&a===Me.default(t)&&n.push("react-datepicker__time-list-item--selected"),((e.props.minTime||e.props.maxTime)&&cr(t,e.props)||(e.props.excludeTimes||e.props.includeTimes||e.props.filterTime)&&dr(t,e.props))&&n.push("react-datepicker__time-list-item--disabled"),e.props.injectTimes&&(60*Pe.default(t)+Me.default(t))%e.props.intervals!=0&&n.push("react-datepicker__time-list-item--injected"),n.join(" ")})),mt(bt(e),"renderTimes",(function(){for(var t=[],r=e.props.format?e.props.format:"p",a=e.props.intervals,n=At(xt(e.props.selected)),o=1440/a,s=e.props.injectTimes&&e.props.injectTimes.sort((function(e,t){return e-t})),i=e.props.selected||e.props.openToDate||xt(),p=Pe.default(i),l=Me.default(i),d=Re.default(Fe.default(n,l),p),c=0;c<o;c++){var u=me.default(n,c*a);if(t.push(u),s){var f=wr(n,u,c,a,s);t=t.concat(f)}}return t.map((function(t,a){return de.default.createElement("li",{key:a,onClick:e.handleClick.bind(bt(e),t),className:e.liClasses(t,p,l),ref:function(r){(nt.default(t,d)||$t(t,d))&&(e.centerLi=r)},tabIndex:"0"},Lt(t,r,e.props.locale))}))})),e}return ht(r,[{key:"componentDidMount",value:function(){this.list.scrollTop=r.calcCenterPosition(this.props.monthRef?this.props.monthRef.clientHeight-this.header.clientHeight:this.list.clientHeight,this.centerLi),this.props.monthRef&&this.header&&this.setState({height:this.props.monthRef.clientHeight-this.header.clientHeight})}},{key:"render",value:function(){var e=this,t=this.state.height;return de.default.createElement("div",{className:"react-datepicker__time-container ".concat(this.props.todayButton?"react-datepicker__time-container--with-today-button":"")},de.default.createElement("div",{className:"react-datepicker__header react-datepicker__header--time ".concat(this.props.showTimeSelectOnly?"react-datepicker__header--time--only":""),ref:function(t){e.header=t}},de.default.createElement("div",{className:"react-datepicker-time__header"},this.props.timeCaption)),de.default.createElement("div",{className:"react-datepicker__time"},de.default.createElement("div",{className:"react-datepicker__time-box"},de.default.createElement("ul",{className:"react-datepicker__time-list",ref:function(t){e.list=t},style:t?{height:t}:{},tabIndex:"0"},this.renderTimes()))))}}],[{key:"defaultProps",get:function(){return{intervals:30,onTimeChange:function(){},todayButton:null,timeCaption:"Time"}}}]),r}(de.default.Component);mt(Rr,"calcCenterPosition",(function(e,t){return t.offsetTop-(e/2-t.clientHeight/2)}));var qr=function(e){wt(r,e);var t=St(r);function r(e){var a;return ut(this,r),mt(bt(a=t.call(this,e)),"handleYearClick",(function(e,t){a.props.onDayClick&&a.props.onDayClick(e,t)})),mt(bt(a),"isSameDay",(function(e,t){return Ut(e,t)})),mt(bt(a),"isKeyboardSelected",(function(e){var t=jt(We.default(a.props.date,e));return!a.props.disabledKeyboardNavigation&&!a.props.inline&&!Ut(t,jt(a.props.selected))&&Ut(t,jt(a.props.preSelection))})),mt(bt(a),"onYearClick",(function(e,t){var r=a.props.date;a.handleYearClick(jt(We.default(r,t)),e)})),mt(bt(a),"getYearClassNames",(function(e){var t=a.props,r=t.minDate,n=t.maxDate,o=t.selected;return ce.default("react-datepicker__year-text",{"react-datepicker__year-text--selected":e===Te.default(o),"react-datepicker__year-text--disabled":(r||n)&&sr(e,a.props),"react-datepicker__year-text--keyboard-selected":a.isKeyboardSelected(e),"react-datepicker__year-text--today":e===Te.default(xt())})})),a}return ht(r,[{key:"render",value:function(){for(var e=this,t=[],r=this.props,a=gr(r.date,r.yearItemNumber),n=a.startPeriod,o=a.endPeriod,s=function(r){t.push(de.default.createElement("div",{onClick:function(t){e.onYearClick(t,r)},className:e.getYearClassNames(r),key:r},r))},i=n;i<=o;i++)s(i);return de.default.createElement("div",{className:"react-datepicker__year"},de.default.createElement("div",{className:"react-datepicker__year-wrapper"},t))}}]),r}(de.default.Component),Ar=function(e){wt(r,e);var t=St(r);function r(e){var a;return ut(this,r),mt(bt(a=t.call(this,e)),"onTimeChange",(function(e){a.setState({time:e});var t=new Date;t.setHours(e.split(":")[0]),t.setMinutes(e.split(":")[1]),a.props.onChange(t)})),mt(bt(a),"renderTimeInput",(function(){var e=a.state.time,t=a.props,r=t.date,n=t.timeString,o=t.customTimeInput;return o?de.default.cloneElement(o,{date:r,value:e,onChange:a.onTimeChange}):de.default.createElement("input",{type:"time",className:"react-datepicker-time__input",placeholder:"Time",name:"time-input",required:!0,value:e,onChange:function(e){a.onTimeChange(e.target.value||n)}})})),a.state={time:a.props.timeString},a}return ht(r,[{key:"render",value:function(){return de.default.createElement("div",{className:"react-datepicker__input-time-container"},de.default.createElement("div",{className:"react-datepicker-time__caption"},this.props.timeInputLabel),de.default.createElement("div",{className:"react-datepicker-time__input-container"},de.default.createElement("div",{className:"react-datepicker-time__input"},this.renderTimeInput())))}}],[{key:"getDerivedStateFromProps",value:function(e,t){return e.timeString!==t.time?{time:e.timeString}:null}}]),r}(de.default.Component);function Wr(e){var t=e.className,r=e.children,a=e.showPopperArrow,n=e.arrowProps,o=void 0===n?{}:n;return de.default.createElement("div",{className:t},a&&de.default.createElement("div",yt({className:"react-datepicker__triangle"},o)),r)}var Br=["react-datepicker__year-select","react-datepicker__month-select","react-datepicker__month-year-select"],jr=function(e){wt(r,e);var t=St(r);function r(e){var a;return ut(this,r),mt(bt(a=t.call(this,e)),"handleClickOutside",(function(e){a.props.onClickOutside(e)})),mt(bt(a),"setClickOutsideRef",(function(){return a.containerRef.current})),mt(bt(a),"handleDropdownFocus",(function(e){(function(){var e=((arguments.length>0&&void 0!==arguments[0]?arguments[0]:{}).className||"").split(/\s+/);return Br.some((function(t){return e.indexOf(t)>=0}))})(e.target)&&a.props.onDropdownFocus()})),mt(bt(a),"getDateInView",(function(){var e=a.props,t=e.preSelection,r=e.selected,n=e.openToDate,o=yr(a.props),s=vr(a.props),i=xt(),p=n||r||t;return p||(o&&nt.default(i,o)?o:s&&at.default(i,s)?s:i)})),mt(bt(a),"increaseMonth",(function(){a.setState((function(e){var t=e.date;return{date:we.default(t,1)}}),(function(){return a.handleMonthChange(a.state.date)}))})),mt(bt(a),"decreaseMonth",(function(){a.setState((function(e){var t=e.date;return{date:Ce.default(t,1)}}),(function(){return a.handleMonthChange(a.state.date)}))})),mt(bt(a),"handleDayClick",(function(e,t,r){a.props.onSelect(e,t,r),a.props.setPreSelection&&a.props.setPreSelection(e)})),mt(bt(a),"handleDayMouseEnter",(function(e){a.setState({selectingDate:e}),a.props.onDayMouseEnter&&a.props.onDayMouseEnter(e)})),mt(bt(a),"handleMonthMouseLeave",(function(){a.setState({selectingDate:null}),a.props.onMonthMouseLeave&&a.props.onMonthMouseLeave()})),mt(bt(a),"handleYearChange",(function(e){a.props.onYearChange&&a.props.onYearChange(e),a.props.adjustDateOnChange&&(a.props.onSelect&&a.props.onSelect(e),a.props.setOpen&&a.props.setOpen(!0)),a.props.setPreSelection&&a.props.setPreSelection(e)})),mt(bt(a),"handleMonthChange",(function(e){a.props.onMonthChange&&a.props.onMonthChange(e),a.props.adjustDateOnChange&&(a.props.onSelect&&a.props.onSelect(e),a.props.setOpen&&a.props.setOpen(!0)),a.props.setPreSelection&&a.props.setPreSelection(e)})),mt(bt(a),"handleMonthYearChange",(function(e){a.handleYearChange(e),a.handleMonthChange(e)})),mt(bt(a),"changeYear",(function(e){a.setState((function(t){var r=t.date;return{date:We.default(r,e)}}),(function(){return a.handleYearChange(a.state.date)}))})),mt(bt(a),"changeMonth",(function(e){a.setState((function(t){var r=t.date;return{date:qe.default(r,e)}}),(function(){return a.handleMonthChange(a.state.date)}))})),mt(bt(a),"changeMonthYear",(function(e){a.setState((function(t){var r=t.date;return{date:We.default(qe.default(r,Ye.default(e)),Te.default(e))}}),(function(){return a.handleMonthYearChange(a.state.date)}))})),mt(bt(a),"header",(function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:a.state.date,t=Wt(e,a.props.locale),r=[];return a.props.showWeekNumbers&&r.push(de.default.createElement("div",{key:"W",className:"react-datepicker__day-name"},a.props.weekLabel||"#")),r.concat([0,1,2,3,4,5,6].map((function(e){var r=ve.default(t,e),n=a.formatWeekday(r,a.props.locale),o=a.props.weekDayClassName?a.props.weekDayClassName(r):void 0;return de.default.createElement("div",{key:e,className:ce.default("react-datepicker__day-name",o)},n)})))})),mt(bt(a),"formatWeekday",(function(e,t){return a.props.formatWeekDay?function(e,t,r){return t(Lt(e,"EEEE",r))}(e,a.props.formatWeekDay,t):a.props.useWeekdaysShort?function(e,t){return Lt(e,"EEE",t)}(e,t):function(e,t){return Lt(e,"EEEEEE",t)}(e,t)})),mt(bt(a),"decreaseYear",(function(){a.setState((function(e){var t=e.date;return{date:Se.default(t,a.props.showYearPicker?a.props.yearItemNumber:1)}}),(function(){return a.handleYearChange(a.state.date)}))})),mt(bt(a),"renderPreviousButton",(function(){if(!a.props.renderCustomHeader){var e;switch(!0){case a.props.showMonthYearPicker:e=hr(a.state.date,a.props);break;case a.props.showYearPicker:e=function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,a=t.yearItemNumber,n=void 0===a?Ot:a,o=gr(jt(Se.default(e,n)),n).endPeriod,s=r&&Te.default(r);return s&&s>o||!1}(a.state.date,a.props);break;default:e=ur(a.state.date,a.props)}if((a.props.forceShowMonthNavigation||a.props.showDisabledMonthNavigation||!e)&&!a.props.showTimeSelectOnly){var t=["react-datepicker__navigation","react-datepicker__navigation--previous"],r=a.decreaseMonth;(a.props.showMonthYearPicker||a.props.showQuarterYearPicker||a.props.showYearPicker)&&(r=a.decreaseYear),e&&a.props.showDisabledMonthNavigation&&(t.push("react-datepicker__navigation--previous--disabled"),r=null);var n=a.props.showMonthYearPicker||a.props.showQuarterYearPicker||a.props.showYearPicker,o=a.props,s=o.previousMonthAriaLabel,i=void 0===s?"Previous Month":s,p=o.previousYearAriaLabel,l=void 0===p?"Previous Year":p;return de.default.createElement("button",{type:"button",className:t.join(" "),onClick:r,"aria-label":n?l:i},n?a.props.previousYearButtonLabel:a.props.previousMonthButtonLabel)}}})),mt(bt(a),"increaseYear",(function(){a.setState((function(e){var t=e.date;return{date:ke.default(t,a.props.showYearPicker?a.props.yearItemNumber:1)}}),(function(){return a.handleYearChange(a.state.date)}))})),mt(bt(a),"renderNextButton",(function(){if(!a.props.renderCustomHeader){var e;switch(!0){case a.props.showMonthYearPicker:e=mr(a.state.date,a.props);break;case a.props.showYearPicker:e=function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.maxDate,a=t.yearItemNumber,n=void 0===a?Ot:a,o=gr(ke.default(e,n),n).startPeriod,s=r&&Te.default(r);return s&&s<o||!1}(a.state.date,a.props);break;default:e=fr(a.state.date,a.props)}if((a.props.forceShowMonthNavigation||a.props.showDisabledMonthNavigation||!e)&&!a.props.showTimeSelectOnly){var t=["react-datepicker__navigation","react-datepicker__navigation--next"];a.props.showTimeSelect&&t.push("react-datepicker__navigation--next--with-time"),a.props.todayButton&&t.push("react-datepicker__navigation--next--with-today-button");var r=a.increaseMonth;(a.props.showMonthYearPicker||a.props.showQuarterYearPicker||a.props.showYearPicker)&&(r=a.increaseYear),e&&a.props.showDisabledMonthNavigation&&(t.push("react-datepicker__navigation--next--disabled"),r=null);var n=a.props.showMonthYearPicker||a.props.showQuarterYearPicker||a.props.showYearPicker,o=a.props,s=o.nextMonthAriaLabel,i=void 0===s?"Next Month":s,p=o.nextYearAriaLabel,l=void 0===p?"Next Year":p;return de.default.createElement("button",{type:"button",className:t.join(" "),onClick:r,"aria-label":n?l:i},n?a.props.nextYearButtonLabel:a.props.nextMonthButtonLabel)}}})),mt(bt(a),"renderCurrentMonth",(function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:a.state.date,t=["react-datepicker__current-month"];return a.props.showYearDropdown&&t.push("react-datepicker__current-month--hasYearDropdown"),a.props.showMonthDropdown&&t.push("react-datepicker__current-month--hasMonthDropdown"),a.props.showMonthYearDropdown&&t.push("react-datepicker__current-month--hasMonthYearDropdown"),de.default.createElement("div",{className:t.join(" ")},Lt(e,a.props.dateFormat,a.props.locale))})),mt(bt(a),"renderYearDropdown",(function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(a.props.showYearDropdown&&!e)return de.default.createElement(_r,{adjustDateOnChange:a.props.adjustDateOnChange,date:a.state.date,onSelect:a.props.onSelect,setOpen:a.props.setOpen,dropdownMode:a.props.dropdownMode,onChange:a.changeYear,minDate:a.props.minDate,maxDate:a.props.maxDate,year:Te.default(a.state.date),scrollableYearDropdown:a.props.scrollableYearDropdown,yearDropdownItemNumber:a.props.yearDropdownItemNumber})})),mt(bt(a),"renderMonthDropdown",(function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(a.props.showMonthDropdown&&!e)return de.default.createElement(Er,{dropdownMode:a.props.dropdownMode,locale:a.props.locale,onChange:a.changeMonth,month:Ye.default(a.state.date),useShortMonthInDropdown:a.props.useShortMonthInDropdown})})),mt(bt(a),"renderMonthYearDropdown",(function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(a.props.showMonthYearDropdown&&!e)return de.default.createElement(xr,{dropdownMode:a.props.dropdownMode,locale:a.props.locale,dateFormat:a.props.dateFormat,onChange:a.changeMonthYear,minDate:a.props.minDate,maxDate:a.props.maxDate,date:a.state.date,scrollableMonthYearDropdown:a.props.scrollableMonthYearDropdown})})),mt(bt(a),"renderTodayButton",(function(){if(a.props.todayButton&&!a.props.showTimeSelectOnly)return de.default.createElement("div",{className:"react-datepicker__today-button",onClick:function(e){return a.props.onSelect(Ve.default(xt()),e)}},a.props.todayButton)})),mt(bt(a),"renderDefaultHeader",(function(e){var t=e.monthDate,r=e.i;return de.default.createElement("div",{className:"react-datepicker__header ".concat(a.props.showTimeSelect?"react-datepicker__header--has-time-select":"")},a.renderCurrentMonth(t),de.default.createElement("div",{className:"react-datepicker__header__dropdown react-datepicker__header__dropdown--".concat(a.props.dropdownMode),onFocus:a.handleDropdownFocus},a.renderMonthDropdown(0!==r),a.renderMonthYearDropdown(0!==r),a.renderYearDropdown(0!==r)),de.default.createElement("div",{className:"react-datepicker__day-names"},a.header(t)))})),mt(bt(a),"renderCustomHeader",(function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=e.monthDate,r=e.i;if(a.props.showTimeSelect&&!a.state.monthContainer||a.props.showTimeSelectOnly)return null;var n=ur(a.state.date,a.props),o=fr(a.state.date,a.props),s=hr(a.state.date,a.props),i=mr(a.state.date,a.props),p=!a.props.showMonthYearPicker&&!a.props.showQuarterYearPicker&&!a.props.showYearPicker;return de.default.createElement("div",{className:"react-datepicker__header react-datepicker__header--custom",onFocus:a.props.onDropdownFocus},a.props.renderCustomHeader(Dt(Dt({},a.state),{},{customHeaderCount:r,changeMonth:a.changeMonth,changeYear:a.changeYear,decreaseMonth:a.decreaseMonth,increaseMonth:a.increaseMonth,decreaseYear:a.decreaseYear,increaseYear:a.increaseYear,prevMonthButtonDisabled:n,nextMonthButtonDisabled:o,prevYearButtonDisabled:s,nextYearButtonDisabled:i})),p&&de.default.createElement("div",{className:"react-datepicker__day-names"},a.header(t)))})),mt(bt(a),"renderYearHeader",(function(){var e=a.state.date,t=a.props,r=t.showYearPicker,n=gr(e,t.yearItemNumber),o=n.startPeriod,s=n.endPeriod;return de.default.createElement("div",{className:"react-datepicker__header react-datepicker-year-header"},r?"".concat(o," - ").concat(s):Te.default(e))})),mt(bt(a),"renderHeader",(function(e){switch(!0){case void 0!==a.props.renderCustomHeader:return a.renderCustomHeader(e);case a.props.showMonthYearPicker||a.props.showQuarterYearPicker||a.props.showYearPicker:return a.renderYearHeader(e);default:return a.renderDefaultHeader(e)}})),mt(bt(a),"renderMonths",(function(){if(!a.props.showTimeSelectOnly&&!a.props.showYearPicker){for(var e=[],t=a.props.showPreviousMonths?a.props.monthsShown-1:0,r=Ce.default(a.state.date,t),n=0;n<a.props.monthsShown;++n){var o=n-a.props.monthSelectedIn,s=we.default(r,o),i="month-".concat(n),p=n<a.props.monthsShown-1,l=n>0;e.push(de.default.createElement("div",{key:i,ref:function(e){a.monthContainer=e},className:"react-datepicker__month-container"},a.renderHeader({monthDate:s,i:n}),de.default.createElement(Fr,{chooseDayAriaLabelPrefix:a.props.chooseDayAriaLabelPrefix,disabledDayAriaLabelPrefix:a.props.disabledDayAriaLabelPrefix,weekAriaLabelPrefix:a.props.weekAriaLabelPrefix,onChange:a.changeMonthYear,day:s,dayClassName:a.props.dayClassName,monthClassName:a.props.monthClassName,onDayClick:a.handleDayClick,handleOnKeyDown:a.props.handleOnKeyDown,onDayMouseEnter:a.handleDayMouseEnter,onMouseLeave:a.handleMonthMouseLeave,onWeekSelect:a.props.onWeekSelect,orderInDisplay:n,formatWeekNumber:a.props.formatWeekNumber,locale:a.props.locale,minDate:a.props.minDate,maxDate:a.props.maxDate,excludeDates:a.props.excludeDates,highlightDates:a.props.highlightDates,selectingDate:a.state.selectingDate,includeDates:a.props.includeDates,inline:a.props.inline,shouldFocusDayInline:a.props.shouldFocusDayInline,fixedHeight:a.props.fixedHeight,filterDate:a.props.filterDate,preSelection:a.props.preSelection,setPreSelection:a.props.setPreSelection,selected:a.props.selected,selectsStart:a.props.selectsStart,selectsEnd:a.props.selectsEnd,selectsRange:a.props.selectsRange,showWeekNumbers:a.props.showWeekNumbers,startDate:a.props.startDate,endDate:a.props.endDate,peekNextMonth:a.props.peekNextMonth,setOpen:a.props.setOpen,shouldCloseOnSelect:a.props.shouldCloseOnSelect,renderDayContents:a.props.renderDayContents,disabledKeyboardNavigation:a.props.disabledKeyboardNavigation,showMonthYearPicker:a.props.showMonthYearPicker,showFullMonthYearPicker:a.props.showFullMonthYearPicker,showTwoColumnMonthYearPicker:a.props.showTwoColumnMonthYearPicker,showFourColumnMonthYearPicker:a.props.showFourColumnMonthYearPicker,showYearPicker:a.props.showYearPicker,showQuarterYearPicker:a.props.showQuarterYearPicker,isInputFocused:a.props.isInputFocused,containerRef:a.containerRef,monthShowsDuplicateDaysEnd:p,monthShowsDuplicateDaysStart:l})))}return e}})),mt(bt(a),"renderYears",(function(){if(!a.props.showTimeSelectOnly)return a.props.showYearPicker?de.default.createElement("div",{className:"react-datepicker__year--container"},a.renderHeader(),de.default.createElement(qr,yt({onDayClick:a.handleDayClick,date:a.state.date},a.props))):void 0})),mt(bt(a),"renderTimeSection",(function(){if(a.props.showTimeSelect&&(a.state.monthContainer||a.props.showTimeSelectOnly))return de.default.createElement(Rr,{selected:a.props.selected,openToDate:a.props.openToDate,onChange:a.props.onTimeChange,timeClassName:a.props.timeClassName,format:a.props.timeFormat,includeTimes:a.props.includeTimes,intervals:a.props.timeIntervals,minTime:a.props.minTime,maxTime:a.props.maxTime,excludeTimes:a.props.excludeTimes,filterTime:a.props.filterTime,timeCaption:a.props.timeCaption,todayButton:a.props.todayButton,showMonthDropdown:a.props.showMonthDropdown,showMonthYearDropdown:a.props.showMonthYearDropdown,showYearDropdown:a.props.showYearDropdown,withPortal:a.props.withPortal,monthRef:a.state.monthContainer,injectTimes:a.props.injectTimes,locale:a.props.locale,showTimeSelectOnly:a.props.showTimeSelectOnly})})),mt(bt(a),"renderInputTimeSection",(function(){var e=new Date(a.props.selected),t=It(e)&&Boolean(a.props.selected)?"".concat(kr(e.getHours()),":").concat(kr(e.getMinutes())):"";if(a.props.showTimeInput)return de.default.createElement(Ar,{date:e,timeString:t,timeInputLabel:a.props.timeInputLabel,onChange:a.props.onTimeChange,customTimeInput:a.props.customTimeInput})})),a.containerRef=de.default.createRef(),a.state={date:a.getDateInView(),selectingDate:null,monthContainer:null},a}return ht(r,[{key:"componentDidMount",value:function(){var e=this;this.props.showTimeSelect&&(this.assignMonthContainer=void e.setState({monthContainer:e.monthContainer}))}},{key:"componentDidUpdate",value:function(e){this.props.preSelection&&!Ut(this.props.preSelection,e.preSelection)?this.setState({date:this.props.preSelection}):this.props.openToDate&&!Ut(this.props.openToDate,e.openToDate)&&this.setState({date:this.props.openToDate})}},{key:"render",value:function(){var e=this.props.container||Wr;return de.default.createElement("div",{ref:this.containerRef},de.default.createElement(e,{className:ce.default("react-datepicker",this.props.className,{"react-datepicker--time-only":this.props.showTimeSelectOnly}),showPopperArrow:this.props.showPopperArrow,arrowProps:this.props.arrowProps},this.renderPreviousButton(),this.renderNextButton(),this.renderMonths(),this.renderYears(),this.renderTodayButton(),this.renderTimeSection(),this.renderInputTimeSection(),this.props.children))}}],[{key:"defaultProps",get:function(){return{onDropdownFocus:function(){},monthsShown:1,monthSelectedIn:0,forceShowMonthNavigation:!1,timeCaption:"Time",previousYearButtonLabel:"Previous Year",nextYearButtonLabel:"Next Year",previousMonthButtonLabel:"Previous Month",nextMonthButtonLabel:"Next Month",customTimeInput:null,yearItemNumber:Ot}}}]),r}(de.default.Component),Hr=function(e){return!e.disabled&&-1!==e.tabIndex},Kr=function(e){wt(r,e);var t=St(r);function r(e){var a;return ut(this,r),mt(bt(a=t.call(this,e)),"getTabChildren",(function(){return Array.prototype.slice.call(a.tabLoopRef.current.querySelectorAll("[tabindex], a, button, input, select, textarea"),1,-1).filter(Hr)})),mt(bt(a),"handleFocusStart",(function(e){var t=a.getTabChildren();t&&t.length>1&&t[t.length-1].focus()})),mt(bt(a),"handleFocusEnd",(function(e){var t=a.getTabChildren();t&&t.length>1&&t[0].focus()})),a.tabLoopRef=de.default.createRef(),a}return ht(r,[{key:"render",value:function(){return this.props.enableTabLoop?de.default.createElement("div",{className:"react-datepicker__tab-loop",ref:this.tabLoopRef},de.default.createElement("div",{className:"react-datepicker__tab-loop__start",tabIndex:"0",onFocus:this.handleFocusStart}),this.props.children,de.default.createElement("div",{className:"react-datepicker__tab-loop__end",tabIndex:"0",onFocus:this.handleFocusEnd})):this.props.children}}],[{key:"defaultProps",get:function(){return{enableTabLoop:!0}}}]),r}(de.default.Component),Qr=function(e){wt(r,e);var t=St(r);function r(e){var a;return ut(this,r),(a=t.call(this,e)).el=document.createElement("div"),a}return ht(r,[{key:"componentDidMount",value:function(){this.portalRoot=document.getElementById(this.props.portalId),this.portalRoot||(this.portalRoot=document.createElement("div"),this.portalRoot.setAttribute("id",this.props.portalId),document.body.appendChild(this.portalRoot)),this.portalRoot.appendChild(this.el)}},{key:"componentWillUnmount",value:function(){this.portalRoot.removeChild(this.el)}},{key:"render",value:function(){return dt.default.createPortal(this.props.children,this.el)}}]),r}(de.default.Component),Vr=function(e){wt(r,e);var t=St(r);function r(){return ut(this,r),t.apply(this,arguments)}return ht(r,[{key:"render",value:function(){var e,t=this.props,r=t.className,a=t.wrapperClassName,n=t.hidePopper,o=t.popperComponent,s=t.popperModifiers,i=t.popperPlacement,p=t.popperProps,l=t.targetComponent,d=t.enableTabLoop,c=t.popperOnKeyDown,u=t.portalId;if(!n){var f=ce.default("react-datepicker-popper",r);e=de.default.createElement(ie.Popper,yt({modifiers:s,placement:i},p),(function(e){var t=e.ref,r=e.style,a=e.placement,n=e.arrowProps;return de.default.createElement(Kr,{enableTabLoop:d},de.default.createElement("div",{ref:t,style:r,className:f,"data-placement":a,onKeyDown:c},de.default.cloneElement(o,{arrowProps:n})))}))}this.props.popperContainer&&(e=de.default.createElement(this.props.popperContainer,{},e)),u&&!n&&(e=de.default.createElement(Qr,{portalId:u},e));var h=ce.default("react-datepicker-wrapper",a);return de.default.createElement(ie.Manager,{className:"react-datepicker-manager"},de.default.createElement(ie.Reference,null,(function(e){var t=e.ref;return de.default.createElement("div",{ref:t,className:h},l)})),e)}}],[{key:"defaultProps",get:function(){return{hidePopper:!0,popperModifiers:{preventOverflow:{enabled:!0,escapeWithReference:!0,boundariesElement:"viewport"}},popperProps:{},popperPlacement:"bottom-start"}}}]),r}(de.default.Component),Ur="react-datepicker-ignore-onclickoutside",$r=lt.default(jr);var zr="Date input not valid.",Gr=function(e){wt(r,e);var t=St(r);function r(e){var a;return ut(this,r),mt(bt(a=t.call(this,e)),"getPreSelection",(function(){return a.props.openToDate?a.props.openToDate:a.props.selectsEnd&&a.props.startDate?a.props.startDate:a.props.selectsStart&&a.props.endDate?a.props.endDate:xt()})),mt(bt(a),"calcInitialState",(function(){var e=a.getPreSelection(),t=yr(a.props),r=vr(a.props),n=t&&nt.default(e,Ve.default(t))?t:r&&at.default(e,Je.default(r))?r:e;return{open:a.props.startOpen||!1,preventFocus:!1,preSelection:a.props.selected?a.props.selected:n,highlightDates:Dr(a.props.highlightDates),focused:!1,shouldFocusDayInline:!1}})),mt(bt(a),"clearPreventFocusTimeout",(function(){a.preventFocusTimeout&&clearTimeout(a.preventFocusTimeout)})),mt(bt(a),"setFocus",(function(){a.input&&a.input.focus&&a.input.focus({preventScroll:!0})})),mt(bt(a),"setBlur",(function(){a.input&&a.input.blur&&a.input.blur(),a.cancelFocusInput()})),mt(bt(a),"setOpen",(function(e){var t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];a.setState({open:e,preSelection:e&&a.state.open?a.state.preSelection:a.calcInitialState().preSelection,lastPreSelectChange:Xr},(function(){e||a.setState((function(e){return{focused:!!t&&e.focused}}),(function(){!t&&a.setBlur(),a.setState({inputValue:null})}))}))})),mt(bt(a),"inputOk",(function(){return ue.default(a.state.preSelection)})),mt(bt(a),"isCalendarOpen",(function(){return void 0===a.props.open?a.state.open&&!a.props.disabled&&!a.props.readOnly:a.props.open})),mt(bt(a),"handleFocus",(function(e){a.state.preventFocus||(a.props.onFocus(e),a.props.preventOpenOnFocus||a.props.readOnly||a.setOpen(!0)),a.setState({focused:!0})})),mt(bt(a),"cancelFocusInput",(function(){clearTimeout(a.inputFocusTimeout),a.inputFocusTimeout=null})),mt(bt(a),"deferFocusInput",(function(){a.cancelFocusInput(),a.inputFocusTimeout=setTimeout((function(){return a.setFocus()}),1)})),mt(bt(a),"handleDropdownFocus",(function(){a.cancelFocusInput()})),mt(bt(a),"handleBlur",(function(e){(!a.state.open||a.props.withPortal||a.props.showTimeInput)&&a.props.onBlur(e),a.setState({focused:!1})})),mt(bt(a),"handleCalendarClickOutside",(function(e){a.props.inline||a.setOpen(!1),a.props.onClickOutside(e),a.props.withPortal&&e.preventDefault()})),mt(bt(a),"handleChange",(function(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];var n=t[0];if(!a.props.onChangeRaw||(a.props.onChangeRaw.apply(bt(a),t),"function"==typeof n.isDefaultPrevented&&!n.isDefaultPrevented())){a.setState({inputValue:n.target.value,lastPreSelectChange:Jr});var o=Tt(n.target.value,a.props.dateFormat,a.props.locale,a.props.strictParsing);!o&&n.target.value||a.setSelected(o,n,!0)}})),mt(bt(a),"handleSelect",(function(e,t,r){a.setState({preventFocus:!0},(function(){return a.preventFocusTimeout=setTimeout((function(){return a.setState({preventFocus:!1})}),50),a.preventFocusTimeout})),a.props.onChangeRaw&&a.props.onChangeRaw(t),a.setSelected(e,t,!1,r),!a.props.shouldCloseOnSelect||a.props.showTimeSelect?a.setPreSelection(e):a.props.inline||a.setOpen(!1)})),mt(bt(a),"setSelected",(function(e,t,r,n){var o=e;if(null===o||!tr(o,a.props)){var s=a.props,i=s.onChange,p=s.selectsRange,l=s.startDate,d=s.endDate;if(!$t(a.props.selected,o)||a.props.allowSameDay||p)if(null!==o&&(!a.props.selected||r&&(a.props.showTimeSelect||a.props.showTimeSelectOnly||a.props.showTimeInput)||(o=Ft(o,{hour:Pe.default(a.props.selected),minute:Me.default(a.props.selected),second:_e.default(a.props.selected)})),a.props.inline||a.setState({preSelection:o}),a.props.focusSelectedMonth||a.setState({monthSelectedIn:n})),p){var c=l&&!d,u=l&&d;!l&&!d?i([o,null],t):c&&(nt.default(o,l)?i([o,null],t):i([l,o],t)),u&&i([o,null],t)}else i(o,t);r||(a.props.onSelect(o,t),a.setState({inputValue:null}))}})),mt(bt(a),"setPreSelection",(function(e){var t=void 0!==a.props.minDate,r=void 0!==a.props.maxDate,n=!0;if(e){var o=Ve.default(e);if(t&&r)n=zt(e,a.props.minDate,a.props.maxDate);else if(t){var s=Ve.default(a.props.minDate);n=at.default(e,s)||$t(o,s)}else if(r){var i=Je.default(a.props.maxDate);n=nt.default(e,i)||$t(o,i)}}n&&a.setState({preSelection:e})})),mt(bt(a),"handleTimeChange",(function(e){var t=Ft(a.props.selected?a.props.selected:a.getPreSelection(),{hour:Pe.default(e),minute:Me.default(e)});a.setState({preSelection:t}),a.props.onChange(t),a.props.shouldCloseOnSelect&&a.setOpen(!1),a.props.showTimeInput&&a.setOpen(!0),a.setState({inputValue:null})})),mt(bt(a),"onInputClick",(function(){a.props.disabled||a.props.readOnly||a.setOpen(!0),a.props.onInputClick()})),mt(bt(a),"onInputKeyDown",(function(e){a.props.onKeyDown(e);var t=e.key;if(a.state.open||a.props.inline||a.props.preventOpenOnFocus){if(a.state.open){if("ArrowDown"===t||"ArrowUp"===t){e.preventDefault();var r=a.calendar.componentNode&&a.calendar.componentNode.querySelector('.react-datepicker__day[tabindex="0"]');return void(r&&r.focus({preventScroll:!0}))}var n=xt(a.state.preSelection);"Enter"===t?(e.preventDefault(),a.inputOk()&&a.state.lastPreSelectChange===Xr?(a.handleSelect(n,e),!a.props.shouldCloseOnSelect&&a.setPreSelection(n)):a.setOpen(!1)):"Escape"===t&&(e.preventDefault(),a.setOpen(!1)),a.inputOk()||a.props.onInputError({code:1,msg:zr})}}else"ArrowDown"!==t&&"ArrowUp"!==t&&"Enter"!==t||a.onInputClick()})),mt(bt(a),"onDayKeyDown",(function(e){a.props.onKeyDown(e);var t=e.key,r=xt(a.state.preSelection);if("Enter"===t)e.preventDefault(),a.handleSelect(r,e),!a.props.shouldCloseOnSelect&&a.setPreSelection(r);else if("Escape"===t)e.preventDefault(),a.setOpen(!1),a.inputOk()||a.props.onInputError({code:1,msg:zr});else if(!a.props.disabledKeyboardNavigation){var n;switch(t){case"ArrowLeft":n=ge.default(r,1);break;case"ArrowRight":n=ve.default(r,1);break;case"ArrowUp":n=be.default(r,1);break;case"ArrowDown":n=De.default(r,1);break;case"PageUp":n=Ce.default(r,1);break;case"PageDown":n=we.default(r,1);break;case"Home":n=Se.default(r,1);break;case"End":n=ke.default(r,1)}if(!n)return void(a.props.onInputError&&a.props.onInputError({code:1,msg:zr}));if(e.preventDefault(),a.setState({lastPreSelectChange:Xr}),a.props.adjustDateOnChange&&a.setSelected(n),a.setPreSelection(n),a.props.inline){var o=Ye.default(r),s=Ye.default(n),i=Te.default(r),p=Te.default(n);o!==s||i!==p?a.setState({shouldFocusDayInline:!0}):a.setState({shouldFocusDayInline:!1})}}})),mt(bt(a),"onPopperKeyDown",(function(e){"Escape"===e.key&&(e.preventDefault(),a.setState({preventFocus:!0},(function(){a.setOpen(!1),setTimeout((function(){a.setFocus(),a.setState({preventFocus:!1})}))})))})),mt(bt(a),"onClearClick",(function(e){e&&e.preventDefault&&e.preventDefault(),a.props.onChange(null,e),a.setState({inputValue:null})})),mt(bt(a),"clear",(function(){a.onClearClick()})),mt(bt(a),"onScroll",(function(e){"boolean"==typeof a.props.closeOnScroll&&a.props.closeOnScroll?e.target!==document&&e.target!==document.documentElement&&e.target!==document.body||a.setOpen(!1):"function"==typeof a.props.closeOnScroll&&a.props.closeOnScroll(e)&&a.setOpen(!1)})),mt(bt(a),"renderCalendar",(function(){return a.props.inline||a.isCalendarOpen()?de.default.createElement($r,{ref:function(e){a.calendar=e},locale:a.props.locale,chooseDayAriaLabelPrefix:a.props.chooseDayAriaLabelPrefix,disabledDayAriaLabelPrefix:a.props.disabledDayAriaLabelPrefix,weekAriaLabelPrefix:a.props.weekAriaLabelPrefix,adjustDateOnChange:a.props.adjustDateOnChange,setOpen:a.setOpen,shouldCloseOnSelect:a.props.shouldCloseOnSelect,dateFormat:a.props.dateFormatCalendar,useWeekdaysShort:a.props.useWeekdaysShort,formatWeekDay:a.props.formatWeekDay,dropdownMode:a.props.dropdownMode,selected:a.props.selected,preSelection:a.state.preSelection,onSelect:a.handleSelect,onWeekSelect:a.props.onWeekSelect,openToDate:a.props.openToDate,minDate:a.props.minDate,maxDate:a.props.maxDate,selectsStart:a.props.selectsStart,selectsEnd:a.props.selectsEnd,selectsRange:a.props.selectsRange,startDate:a.props.startDate,endDate:a.props.endDate,excludeDates:a.props.excludeDates,filterDate:a.props.filterDate,onClickOutside:a.handleCalendarClickOutside,formatWeekNumber:a.props.formatWeekNumber,highlightDates:a.state.highlightDates,includeDates:a.props.includeDates,includeTimes:a.props.includeTimes,injectTimes:a.props.injectTimes,inline:a.props.inline,shouldFocusDayInline:a.state.shouldFocusDayInline,peekNextMonth:a.props.peekNextMonth,showMonthDropdown:a.props.showMonthDropdown,showPreviousMonths:a.props.showPreviousMonths,useShortMonthInDropdown:a.props.useShortMonthInDropdown,showMonthYearDropdown:a.props.showMonthYearDropdown,showWeekNumbers:a.props.showWeekNumbers,showYearDropdown:a.props.showYearDropdown,withPortal:a.props.withPortal,forceShowMonthNavigation:a.props.forceShowMonthNavigation,showDisabledMonthNavigation:a.props.showDisabledMonthNavigation,scrollableYearDropdown:a.props.scrollableYearDropdown,scrollableMonthYearDropdown:a.props.scrollableMonthYearDropdown,todayButton:a.props.todayButton,weekLabel:a.props.weekLabel,outsideClickIgnoreClass:Ur,fixedHeight:a.props.fixedHeight,monthsShown:a.props.monthsShown,monthSelectedIn:a.state.monthSelectedIn,onDropdownFocus:a.handleDropdownFocus,onMonthChange:a.props.onMonthChange,onYearChange:a.props.onYearChange,dayClassName:a.props.dayClassName,weekDayClassName:a.props.weekDayClassName,monthClassName:a.props.monthClassName,timeClassName:a.props.timeClassName,showTimeSelect:a.props.showTimeSelect,showTimeSelectOnly:a.props.showTimeSelectOnly,onTimeChange:a.handleTimeChange,timeFormat:a.props.timeFormat,timeIntervals:a.props.timeIntervals,minTime:a.props.minTime,maxTime:a.props.maxTime,excludeTimes:a.props.excludeTimes,filterTime:a.props.filterTime,timeCaption:a.props.timeCaption,className:a.props.calendarClassName,container:a.props.calendarContainer,yearItemNumber:a.props.yearItemNumber,yearDropdownItemNumber:a.props.yearDropdownItemNumber,previousMonthButtonLabel:a.props.previousMonthButtonLabel,nextMonthButtonLabel:a.props.nextMonthButtonLabel,previousYearButtonLabel:a.props.previousYearButtonLabel,nextYearButtonLabel:a.props.nextYearButtonLabel,timeInputLabel:a.props.timeInputLabel,disabledKeyboardNavigation:a.props.disabledKeyboardNavigation,renderCustomHeader:a.props.renderCustomHeader,popperProps:a.props.popperProps,renderDayContents:a.props.renderDayContents,onDayMouseEnter:a.props.onDayMouseEnter,onMonthMouseLeave:a.props.onMonthMouseLeave,showTimeInput:a.props.showTimeInput,showMonthYearPicker:a.props.showMonthYearPicker,showFullMonthYearPicker:a.props.showFullMonthYearPicker,showTwoColumnMonthYearPicker:a.props.showTwoColumnMonthYearPicker,showFourColumnMonthYearPicker:a.props.showFourColumnMonthYearPicker,showYearPicker:a.props.showYearPicker,showQuarterYearPicker:a.props.showQuarterYearPicker,showPopperArrow:a.props.showPopperArrow,excludeScrollbar:a.props.excludeScrollbar,handleOnKeyDown:a.onDayKeyDown,isInputFocused:a.state.focused,customTimeInput:a.props.customTimeInput,setPreSelection:a.setPreSelection},a.props.children):null})),mt(bt(a),"renderDateInput",(function(){var e,t,r,n,o,s=ce.default(a.props.className,mt({},Ur,a.state.open)),i=a.props.customInput||de.default.createElement("input",{type:"text"}),p=a.props.customInputRef||"ref",l="string"==typeof a.props.value?a.props.value:"string"==typeof a.state.inputValue?a.state.inputValue:(t=a.props.selected,r=a.props,n=r.dateFormat,o=r.locale,t&&Lt(t,Array.isArray(n)?n[0]:n,o)||"");return de.default.cloneElement(i,(mt(e={},p,(function(e){a.input=e})),mt(e,"value",l),mt(e,"onBlur",a.handleBlur),mt(e,"onChange",a.handleChange),mt(e,"onClick",a.onInputClick),mt(e,"onFocus",a.handleFocus),mt(e,"onKeyDown",a.onInputKeyDown),mt(e,"id",a.props.id),mt(e,"name",a.props.name),mt(e,"autoFocus",a.props.autoFocus),mt(e,"placeholder",a.props.placeholderText),mt(e,"disabled",a.props.disabled),mt(e,"autoComplete",a.props.autoComplete),mt(e,"className",ce.default(i.props.className,s)),mt(e,"title",a.props.title),mt(e,"readOnly",a.props.readOnly),mt(e,"required",a.props.required),mt(e,"tabIndex",a.props.tabIndex),mt(e,"aria-describedby",a.props.ariaDescribedBy),mt(e,"aria-invalid",a.props.ariaInvalid),mt(e,"aria-labelledby",a.props.ariaLabelledBy),mt(e,"aria-required",a.props.ariaRequired),e))})),mt(bt(a),"renderClearButton",(function(){var e=a.props,t=e.isClearable,r=e.selected,n=e.clearButtonTitle,o=e.clearButtonClassName,s=e.ariaLabelClose,i=void 0===s?"Close":s;return t&&null!=r?de.default.createElement("button",{type:"button",className:"react-datepicker__close-icon ".concat(o),"aria-label":i,onClick:a.onClearClick,title:n,tabIndex:-1}):null})),a.state=a.calcInitialState(),a}return ht(r,[{key:"componentDidMount",value:function(){window.addEventListener("scroll",this.onScroll,!0)}},{key:"componentDidUpdate",value:function(e,t){var r,a;e.inline&&(r=e.selected,a=this.props.selected,r&&a?Ye.default(r)!==Ye.default(a)||Te.default(r)!==Te.default(a):r!==a)&&this.setPreSelection(this.props.selected),void 0!==this.state.monthSelectedIn&&e.monthsShown!==this.props.monthsShown&&this.setState({monthSelectedIn:0}),e.highlightDates!==this.props.highlightDates&&this.setState({highlightDates:Dr(this.props.highlightDates)}),t.focused||$t(e.selected,this.props.selected)||this.setState({inputValue:null}),t.open!==this.state.open&&(!1===t.open&&!0===this.state.open&&this.props.onCalendarOpen(),!0===t.open&&!1===this.state.open&&this.props.onCalendarClose())}},{key:"componentWillUnmount",value:function(){this.clearPreventFocusTimeout(),window.removeEventListener("scroll",this.onScroll,!0)}},{key:"render",value:function(){var e=this.renderCalendar();return this.props.inline&&!this.props.withPortal?e:this.props.withPortal?de.default.createElement("div",null,this.props.inline?null:de.default.createElement("div",{className:"react-datepicker__input-container"},this.renderDateInput(),this.renderClearButton()),this.state.open||this.props.inline?de.default.createElement("div",{className:"react-datepicker__portal"},e):null):de.default.createElement(Vr,{className:this.props.popperClassName,wrapperClassName:this.props.wrapperClassName,hidePopper:!this.isCalendarOpen(),portalId:this.props.portalId,popperModifiers:this.props.popperModifiers,targetComponent:de.default.createElement("div",{className:"react-datepicker__input-container"},this.renderDateInput(),this.renderClearButton()),popperContainer:this.props.popperContainer,popperComponent:e,popperPlacement:this.props.popperPlacement,popperProps:this.props.popperProps,popperOnKeyDown:this.onPopperKeyDown,enableTabLoop:this.props.enableTabLoop})}}],[{key:"defaultProps",get:function(){return{allowSameDay:!1,dateFormat:"MM/dd/yyyy",dateFormatCalendar:"LLLL yyyy",onChange:function(){},disabled:!1,disabledKeyboardNavigation:!1,dropdownMode:"scroll",onFocus:function(){},onBlur:function(){},onKeyDown:function(){},onInputClick:function(){},onSelect:function(){},onClickOutside:function(){},onMonthChange:function(){},onCalendarOpen:function(){},onCalendarClose:function(){},preventOpenOnFocus:!1,onYearChange:function(){},onInputError:function(){},monthsShown:1,readOnly:!1,withPortal:!1,shouldCloseOnSelect:!0,showTimeSelect:!1,showTimeInput:!1,showPreviousMonths:!1,showMonthYearPicker:!1,showFullMonthYearPicker:!1,showTwoColumnMonthYearPicker:!1,showFourColumnMonthYearPicker:!1,showYearPicker:!1,showQuarterYearPicker:!1,strictParsing:!1,timeIntervals:30,timeCaption:"Time",previousMonthButtonLabel:"Previous Month",nextMonthButtonLabel:"Next Month",previousYearButtonLabel:"Previous Year",nextYearButtonLabel:"Next Year",timeInputLabel:"Time",enableTabLoop:!0,yearItemNumber:Ot,renderDayContents:function(e){return e},focusSelectedMonth:!1,showPopperArrow:!0,excludeScrollbar:!0,customTimeInput:null}}}]),r}(de.default.Component),Jr="input",Xr="navigate";e.CalendarContainer=Wr,e.default=Gr,e.getDefaultLocale=Gt,e.registerLocale=function(e,t){var r="undefined"!=typeof window?window:global;r.__localeData__||(r.__localeData__={}),r.__localeData__[e]=t},e.setDefaultLocale=function(e){("undefined"!=typeof window?window:global).__localeId__=e},Object.defineProperty(e,"__esModule",{value:!0})}));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 280 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var TO_STRING_TAG_SUPPORT = __webpack_require__(293);
	var isCallable = __webpack_require__(52);
	var classofRaw = __webpack_require__(128);
	var wellKnownSymbol = __webpack_require__(76);
	
	var TO_STRING_TAG = wellKnownSymbol('toStringTag');
	var $Object = Object;
	
	// ES3 wrong here
	var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) === 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (error) { /* empty */ }
	};
	
	// getting tag from ES6+ `Object.prototype.toString`
	module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
	  var O, tag, result;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (tag = tryGet(O = $Object(it), TO_STRING_TAG)) == 'string' ? tag
	    // builtinTag case
	    : CORRECT_ARGUMENTS ? classofRaw(O)
	    // ES3 arguments fallback
	    : (result = classofRaw(O)) === 'Object' && isCallable(O.callee) ? 'Arguments' : result;
	};


/***/ },
/* 281 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var globalThis = __webpack_require__(54);
	
	// eslint-disable-next-line es/no-object-defineproperty -- safe
	var defineProperty = Object.defineProperty;
	
	module.exports = function (key, value) {
	  try {
	    defineProperty(globalThis, key, { value: value, configurable: true, writable: true });
	  } catch (error) {
	    globalThis[key] = value;
	  } return value;
	};


/***/ },
/* 282 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var globalThis = __webpack_require__(54);
	var isObject = __webpack_require__(74);
	
	var document = globalThis.document;
	// typeof document.createElement is 'object' in old IE
	var EXISTS = isObject(document) && isObject(document.createElement);
	
	module.exports = function (it) {
	  return EXISTS ? document.createElement(it) : {};
	};


/***/ },
/* 283 */
/***/ function(module, exports) {

	'use strict';
	// IE8- don't enum bug keys
	module.exports = [
	  'constructor',
	  'hasOwnProperty',
	  'isPrototypeOf',
	  'propertyIsEnumerable',
	  'toLocaleString',
	  'toString',
	  'valueOf'
	];


/***/ },
/* 284 */
/***/ function(module, exports) {

	'use strict';
	module.exports = Object.create ? Object.create(null) : {};


/***/ },
/* 285 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var DESCRIPTORS = __webpack_require__(62);
	var call = __webpack_require__(100);
	var propertyIsEnumerableModule = __webpack_require__(618);
	var createPropertyDescriptor = __webpack_require__(162);
	var toIndexedObject = __webpack_require__(114);
	var toPropertyKey = __webpack_require__(292);
	var hasOwn = __webpack_require__(51);
	var IE8_DOM_DEFINE = __webpack_require__(606);
	
	// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
	var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	
	// `Object.getOwnPropertyDescriptor` method
	// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
	exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
	  O = toIndexedObject(O);
	  P = toPropertyKey(P);
	  if (IE8_DOM_DEFINE) try {
	    return $getOwnPropertyDescriptor(O, P);
	  } catch (error) { /* empty */ }
	  if (hasOwn(O, P)) return createPropertyDescriptor(!call(propertyIsEnumerableModule.f, O, P), O[P]);
	};


/***/ },
/* 286 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var internalObjectKeys = __webpack_require__(616);
	var enumBugKeys = __webpack_require__(283);
	
	var hiddenKeys = enumBugKeys.concat('length', 'prototype');
	
	// `Object.getOwnPropertyNames` method
	// https://tc39.es/ecma262/#sec-object.getownpropertynames
	// eslint-disable-next-line es/no-object-getownpropertynames -- safe
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return internalObjectKeys(O, hiddenKeys);
	};


/***/ },
/* 287 */
/***/ function(module, exports) {

	'use strict';
	// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
	exports.f = Object.getOwnPropertySymbols;


/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var hasOwn = __webpack_require__(51);
	var isCallable = __webpack_require__(52);
	var toObject = __webpack_require__(167);
	var sharedKey = __webpack_require__(209);
	var CORRECT_PROTOTYPE_GETTER = __webpack_require__(602);
	
	var IE_PROTO = sharedKey('IE_PROTO');
	var $Object = Object;
	var ObjectPrototype = $Object.prototype;
	
	// `Object.getPrototypeOf` method
	// https://tc39.es/ecma262/#sec-object.getprototypeof
	// eslint-disable-next-line es/no-object-getprototypeof -- safe
	module.exports = CORRECT_PROTOTYPE_GETTER ? $Object.getPrototypeOf : function (O) {
	  var object = toObject(O);
	  if (hasOwn(object, IE_PROTO)) return object[IE_PROTO];
	  var constructor = object.constructor;
	  if (isCallable(constructor) && object instanceof constructor) {
	    return constructor.prototype;
	  } return object instanceof $Object ? ObjectPrototype : null;
	};


/***/ },
/* 289 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var uncurryThis = __webpack_require__(44);
	
	module.exports = uncurryThis({}.isPrototypeOf);


/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var IS_PURE = __webpack_require__(164);
	var globalThis = __webpack_require__(54);
	var defineGlobalProperty = __webpack_require__(281);
	
	var SHARED = '__core-js_shared__';
	var store = module.exports = globalThis[SHARED] || defineGlobalProperty(SHARED, {});
	
	(store.versions || (store.versions = [])).push({
	  version: '3.50.0',
	  mode: IS_PURE ? 'pure' : 'global',
	  copyright: '© 2013–2025 Denis Pushkarev (zloirock.ru), 2025–2026 CoreJS Company (core-js.io). All rights reserved.',
	  license: 'https://github.com/zloirock/core-js/blob/v3.50.0/LICENSE',
	  source: 'https://github.com/zloirock/core-js'
	});


/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var trunc = __webpack_require__(1403);
	
	// `ToIntegerOrInfinity` abstract operation
	// https://tc39.es/ecma262/#sec-tointegerorinfinity
	module.exports = function (argument) {
	  var number = +argument;
	  // eslint-disable-next-line no-self-compare -- NaN check
	  return number !== number || number === 0 ? 0 : trunc(number);
	};


/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var toPrimitive = __webpack_require__(1418);
	var isSymbol = __webpack_require__(207);
	
	// `ToPropertyKey` abstract operation
	// https://tc39.es/ecma262/#sec-topropertykey
	module.exports = function (argument) {
	  var key = toPrimitive(argument, 'string');
	  return isSymbol(key) ? key : key + '';
	};


/***/ },
/* 293 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var wellKnownSymbol = __webpack_require__(76);
	
	var TO_STRING_TAG = wellKnownSymbol('toStringTag');
	var test = {};
	// eslint-disable-next-line unicorn/no-immediate-mutation -- ES3 syntax limitation
	test[TO_STRING_TAG] = 'z';
	
	module.exports = String(test) === '[object z]';


/***/ },
/* 294 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	function componentWillMount() {
	  // Call this.constructor.gDSFP to support sub-classes.
	  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
	  if (state !== null && state !== undefined) {
	    this.setState(state);
	  }
	}
	
	function componentWillReceiveProps(nextProps) {
	  // Call this.constructor.gDSFP to support sub-classes.
	  // Use the setState() updater to ensure state isn't stale in certain edge cases.
	  function updater(prevState) {
	    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
	    return state !== null && state !== undefined ? state : null;
	  }
	  // Binding "this" is important for shallow renderer support.
	  this.setState(updater.bind(this));
	}
	
	function componentWillUpdate(nextProps, nextState) {
	  try {
	    var prevProps = this.props;
	    var prevState = this.state;
	    this.props = nextProps;
	    this.state = nextState;
	    this.__reactInternalSnapshotFlag = true;
	    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
	      prevProps,
	      prevState
	    );
	  } finally {
	    this.props = prevProps;
	    this.state = prevState;
	  }
	}
	
	// React may warn about cWM/cWRP/cWU methods being deprecated.
	// Add a flag to suppress these warnings for this special case.
	componentWillMount.__suppressDeprecationWarning = true;
	componentWillReceiveProps.__suppressDeprecationWarning = true;
	componentWillUpdate.__suppressDeprecationWarning = true;
	
	function polyfill(Component) {
	  var prototype = Component.prototype;
	
	  if (!prototype || !prototype.isReactComponent) {
	    throw new Error('Can only polyfill class components');
	  }
	
	  if (
	    typeof Component.getDerivedStateFromProps !== 'function' &&
	    typeof prototype.getSnapshotBeforeUpdate !== 'function'
	  ) {
	    return Component;
	  }
	
	  // If new component APIs are defined, "unsafe" lifecycles won't be called.
	  // Error if any of these lifecycles are present,
	  // Because they would work differently between older and newer (16.3+) versions of React.
	  var foundWillMountName = null;
	  var foundWillReceivePropsName = null;
	  var foundWillUpdateName = null;
	  if (typeof prototype.componentWillMount === 'function') {
	    foundWillMountName = 'componentWillMount';
	  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
	    foundWillMountName = 'UNSAFE_componentWillMount';
	  }
	  if (typeof prototype.componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'componentWillReceiveProps';
	  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
	  }
	  if (typeof prototype.componentWillUpdate === 'function') {
	    foundWillUpdateName = 'componentWillUpdate';
	  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
	    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
	  }
	  if (
	    foundWillMountName !== null ||
	    foundWillReceivePropsName !== null ||
	    foundWillUpdateName !== null
	  ) {
	    var componentName = Component.displayName || Component.name;
	    var newApiName =
	      typeof Component.getDerivedStateFromProps === 'function'
	        ? 'getDerivedStateFromProps()'
	        : 'getSnapshotBeforeUpdate()';
	
	    throw Error(
	      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
	        componentName +
	        ' uses ' +
	        newApiName +
	        ' but also contains the following legacy lifecycles:' +
	        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
	        (foundWillReceivePropsName !== null
	          ? '\n  ' + foundWillReceivePropsName
	          : '') +
	        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
	        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
	        'https://fb.me/react-async-component-lifecycle-hooks'
	    );
	  }
	
	  // React <= 16.2 does not support static getDerivedStateFromProps.
	  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
	  // Newer versions of React will ignore these lifecycles if gDSFP exists.
	  if (typeof Component.getDerivedStateFromProps === 'function') {
	    prototype.componentWillMount = componentWillMount;
	    prototype.componentWillReceiveProps = componentWillReceiveProps;
	  }
	
	  // React <= 16.2 does not support getSnapshotBeforeUpdate.
	  // As a workaround, use cWU to invoke the new lifecycle.
	  // Newer versions of React will ignore that lifecycle if gSBU exists.
	  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
	    if (typeof prototype.componentDidUpdate !== 'function') {
	      throw new Error(
	        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
	      );
	    }
	
	    prototype.componentWillUpdate = componentWillUpdate;
	
	    var componentDidUpdate = prototype.componentDidUpdate;
	
	    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
	      prevProps,
	      prevState,
	      maybeSnapshot
	    ) {
	      // 16.3+ will not execute our will-update method;
	      // It will pass a snapshot value to did-update though.
	      // Older versions will require our polyfilled will-update value.
	      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
	      // Because for <= 15.x versions this might be a "prevContext" object.
	      // We also can't just check "__reactInternalSnapshot",
	      // Because get-snapshot might return a falsy value.
	      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
	      var snapshot = this.__reactInternalSnapshotFlag
	        ? this.__reactInternalSnapshot
	        : maybeSnapshot;
	
	      componentDidUpdate.call(this, prevProps, prevState, snapshot);
	    };
	  }
	
	  return Component;
	}
	
	exports.polyfill = polyfill;


/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.ManagerReferenceNodeSetterContext = exports.ManagerReferenceNodeContext = void 0;
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(34));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(12));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(24));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _createReactContext = _interopRequireDefault(__webpack_require__(706));
	
	var ManagerReferenceNodeContext = (0, _createReactContext.default)();
	exports.ManagerReferenceNodeContext = ManagerReferenceNodeContext;
	var ManagerReferenceNodeSetterContext = (0, _createReactContext.default)();
	exports.ManagerReferenceNodeSetterContext = ManagerReferenceNodeSetterContext;
	
	var Manager =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Manager, _React$Component);
	
	  function Manager() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "referenceNode", void 0);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "setReferenceNode", function (newReferenceNode) {
	      if (newReferenceNode && _this.referenceNode !== newReferenceNode) {
	        _this.referenceNode = newReferenceNode;
	
	        _this.forceUpdate();
	      }
	    });
	    return _this;
	  }
	
	  var _proto = Manager.prototype;
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.referenceNode = null;
	  };
	
	  _proto.render = function render() {
	    return React.createElement(ManagerReferenceNodeContext.Provider, {
	      value: this.referenceNode
	    }, React.createElement(ManagerReferenceNodeSetterContext.Provider, {
	      value: this.setReferenceNode
	    }, this.props.children));
	  };
	
	  return Manager;
	}(React.Component);
	
	exports.default = Manager;

/***/ },
/* 296 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	if (true) {
	  module.exports = __webpack_require__(1451);
	} else {
	  module.exports = require("./cjs/react-router-dom.js");
	}


/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StarRatingComponent = function (_Component) {
	  _inherits(StarRatingComponent, _Component);
	
	  function StarRatingComponent(props) {
	    _classCallCheck(this, StarRatingComponent);
	
	    var _this = _possibleConstructorReturn(this, (StarRatingComponent.__proto__ || Object.getPrototypeOf(StarRatingComponent)).call(this));
	
	    _this.state = {
	      value: props.value
	    };
	    return _this;
	  }
	
	  _createClass(StarRatingComponent, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var value = nextProps.value;
	
	
	      if (value != null && value !== this.state.value) {
	        this.setState({ value: value });
	      }
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(inputValue) {
	      var _props = this.props,
	          editing = _props.editing,
	          value = _props.value;
	
	
	      if (!editing) {
	        return;
	      }
	
	      // do not update internal state based on input value if prop passed
	      if (value != null) {
	        return;
	      }
	
	      this.setState({ value: inputValue });
	    }
	  }, {
	    key: 'onStarClick',
	    value: function onStarClick(index, value, name, e) {
	      e.stopPropagation();
	
	      var _props2 = this.props,
	          onStarClick = _props2.onStarClick,
	          editing = _props2.editing;
	
	
	      if (!editing) {
	        return;
	      }
	
	      onStarClick && onStarClick(index, value, name, e);
	    }
	  }, {
	    key: 'onStarHover',
	    value: function onStarHover(index, value, name, e) {
	      e.stopPropagation();
	
	      var _props3 = this.props,
	          onStarHover = _props3.onStarHover,
	          editing = _props3.editing;
	
	
	      if (!editing) {
	        return;
	      }
	
	      onStarHover && onStarHover(index, value, name, e);
	    }
	  }, {
	    key: 'onStarHoverOut',
	    value: function onStarHoverOut(index, value, name, e) {
	      e.stopPropagation();
	
	      var _props4 = this.props,
	          onStarHoverOut = _props4.onStarHoverOut,
	          editing = _props4.editing;
	
	
	      if (!editing) {
	        return;
	      }
	
	      onStarHoverOut && onStarHoverOut(index, value, name, e);
	    }
	  }, {
	    key: 'renderStars',
	    value: function renderStars() {
	      var _this2 = this;
	
	      var _props5 = this.props,
	          name = _props5.name,
	          starCount = _props5.starCount,
	          starColor = _props5.starColor,
	          emptyStarColor = _props5.emptyStarColor,
	          editing = _props5.editing;
	      var value = this.state.value;
	
	
	      var starStyles = function starStyles(i, value) {
	        return {
	          float: 'right',
	          cursor: editing ? 'pointer' : 'default',
	          color: value >= i ? starColor : emptyStarColor
	        };
	      };
	      var radioStyles = {
	        display: 'none',
	        position: 'absolute',
	        marginLeft: -9999
	      };
	
	      // populate stars
	      var starNodes = [];
	
	      var _loop = function _loop(i) {
	        var id = name + '_' + i;
	        var starNodeInput = _react2.default.createElement('input', {
	          key: 'input_' + id,
	          style: radioStyles,
	          className: 'dv-star-rating-input',
	          type: 'radio',
	          name: name,
	          id: id,
	          value: i,
	          checked: value === i,
	          onChange: _this2.onChange.bind(_this2, i, name)
	        });
	        var starNodeLabel = _react2.default.createElement(
	          'label',
	          {
	            key: 'label_' + id,
	            style: starStyles(i, value),
	            className: 'dv-star-rating-star ' + (value >= i ? 'dv-star-rating-full-star' : 'dv-star-rating-empty-star'),
	            htmlFor: id,
	            onClick: function onClick(e) {
	              return _this2.onStarClick(i, value, name, e);
	            },
	            onMouseOver: function onMouseOver(e) {
	              return _this2.onStarHover(i, value, name, e);
	            },
	            onMouseLeave: function onMouseLeave(e) {
	              return _this2.onStarHoverOut(i, value, name, e);
	            }
	          },
	          _this2.renderIcon(i, value, name, id)
	        );
	
	        starNodes.push(starNodeInput);
	        starNodes.push(starNodeLabel);
	      };
	
	      for (var i = starCount; i > 0; i--) {
	        _loop(i);
	      }
	
	      return starNodes.length ? starNodes : null;
	    }
	  }, {
	    key: 'renderIcon',
	    value: function renderIcon(index, value, name, id) {
	      var _props6 = this.props,
	          renderStarIcon = _props6.renderStarIcon,
	          renderStarIconHalf = _props6.renderStarIconHalf;
	
	
	      if (typeof renderStarIconHalf === 'function' && Math.ceil(value) === index && value % 1 !== 0) {
	        return renderStarIconHalf(index, value, name, id);
	      }
	
	      if (typeof renderStarIcon === 'function') {
	        return renderStarIcon(index, value, name, id);
	      }
	
	      return _react2.default.createElement(
	        'i',
	        { key: 'icon_' + id, style: { fontStyle: 'normal' } },
	        '\u2605'
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props7 = this.props,
	          editing = _props7.editing,
	          className = _props7.className;
	
	      var classes = (0, _classnames2.default)('dv-star-rating', {
	        'dv-star-rating-non-editable': !editing
	      }, className);
	
	      return _react2.default.createElement(
	        'div',
	        { style: { display: 'inline-block', position: 'relative' }, className: classes },
	        this.renderStars()
	      );
	    }
	  }]);
	
	  return StarRatingComponent;
	}(_react.Component);
	
	StarRatingComponent.propTypes = {
	  name: _propTypes2.default.string.isRequired,
	  value: _propTypes2.default.number,
	  editing: _propTypes2.default.bool,
	  starCount: _propTypes2.default.number,
	  starColor: _propTypes2.default.string,
	  onStarClick: _propTypes2.default.func,
	  onStarHover: _propTypes2.default.func,
	  onStarHoverOut: _propTypes2.default.func,
	  renderStarIcon: _propTypes2.default.func,
	  renderStarIconHalf: _propTypes2.default.func
	};
	StarRatingComponent.defaultProps = {
	  starCount: 5,
	  editing: true,
	  starColor: '#ffb400',
	  emptyStarColor: '#333'
	};
	exports.default = StarRatingComponent;
	module.exports = exports['default'];


/***/ },
/* 298 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(43));
	
	var _config = _interopRequireDefault(__webpack_require__(634));
	
	var _PropTypes = __webpack_require__(635);
	
	var _TransitionGroupContext = _interopRequireDefault(__webpack_require__(299));
	
	var _reflow = __webpack_require__(636);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	var UNMOUNTED = 'unmounted';
	exports.UNMOUNTED = UNMOUNTED;
	var EXITED = 'exited';
	exports.EXITED = EXITED;
	var ENTERING = 'entering';
	exports.ENTERING = ENTERING;
	var ENTERED = 'entered';
	exports.ENTERED = ENTERED;
	var EXITING = 'exiting';
	/**
	 * The Transition component lets you describe a transition from one component
	 * state to another _over time_ with a simple declarative API. Most commonly
	 * it's used to animate the mounting and unmounting of a component, but can also
	 * be used to describe in-place transition states as well.
	 *
	 * ---
	 *
	 * **Note**: `Transition` is a platform-agnostic base component. If you're using
	 * transitions in CSS, you'll probably want to use
	 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
	 * instead. It inherits all the features of `Transition`, but contains
	 * additional features necessary to play nice with CSS transitions (hence the
	 * name of the component).
	 *
	 * ---
	 *
	 * By default the `Transition` component does not alter the behavior of the
	 * component it renders, it only tracks "enter" and "exit" states for the
	 * components. It's up to you to give meaning and effect to those states. For
	 * example we can add styles to a component when it enters or exits:
	 *
	 * ```jsx
	 * import { Transition } from 'react-transition-group';
	 *
	 * const duration = 300;
	 *
	 * const defaultStyle = {
	 *   transition: `opacity ${duration}ms ease-in-out`,
	 *   opacity: 0,
	 * }
	 *
	 * const transitionStyles = {
	 *   entering: { opacity: 1 },
	 *   entered:  { opacity: 1 },
	 *   exiting:  { opacity: 0 },
	 *   exited:  { opacity: 0 },
	 * };
	 *
	 * const Fade = ({ in: inProp }) => (
	 *   <Transition in={inProp} timeout={duration}>
	 *     {state => (
	 *       <div style={{
	 *         ...defaultStyle,
	 *         ...transitionStyles[state]
	 *       }}>
	 *         I'm a fade Transition!
	 *       </div>
	 *     )}
	 *   </Transition>
	 * );
	 * ```
	 *
	 * There are 4 main states a Transition can be in:
	 *  - `'entering'`
	 *  - `'entered'`
	 *  - `'exiting'`
	 *  - `'exited'`
	 *
	 * Transition state is toggled via the `in` prop. When `true` the component
	 * begins the "Enter" stage. During this stage, the component will shift from
	 * its current transition state, to `'entering'` for the duration of the
	 * transition and then to the `'entered'` stage once it's complete. Let's take
	 * the following example (we'll use the
	 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
	 *
	 * ```jsx
	 * function App() {
	 *   const [inProp, setInProp] = useState(false);
	 *   return (
	 *     <div>
	 *       <Transition in={inProp} timeout={500}>
	 *         {state => (
	 *           // ...
	 *         )}
	 *       </Transition>
	 *       <button onClick={() => setInProp(true)}>
	 *         Click to Enter
	 *       </button>
	 *     </div>
	 *   );
	 * }
	 * ```
	 *
	 * When the button is clicked the component will shift to the `'entering'` state
	 * and stay there for 500ms (the value of `timeout`) before it finally switches
	 * to `'entered'`.
	 *
	 * When `in` is `false` the same thing happens except the state moves from
	 * `'exiting'` to `'exited'`.
	 */
	
	exports.EXITING = EXITING;
	
	var Transition = /*#__PURE__*/function (_React$Component) {
	  _inheritsLoose(Transition, _React$Component);
	
	  function Transition(props, context) {
	    var _this;
	
	    _this = _React$Component.call(this, props, context) || this;
	    var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
	
	    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
	    var initialStatus;
	    _this.appearStatus = null;
	
	    if (props.in) {
	      if (appear) {
	        initialStatus = EXITED;
	        _this.appearStatus = ENTERING;
	      } else {
	        initialStatus = ENTERED;
	      }
	    } else {
	      if (props.unmountOnExit || props.mountOnEnter) {
	        initialStatus = UNMOUNTED;
	      } else {
	        initialStatus = EXITED;
	      }
	    }
	
	    _this.state = {
	      status: initialStatus
	    };
	    _this.nextCallback = null;
	    return _this;
	  }
	
	  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
	    var nextIn = _ref.in;
	
	    if (nextIn && prevState.status === UNMOUNTED) {
	      return {
	        status: EXITED
	      };
	    }
	
	    return null;
	  } // getSnapshotBeforeUpdate(prevProps) {
	  //   let nextStatus = null
	  //   if (prevProps !== this.props) {
	  //     const { status } = this.state
	  //     if (this.props.in) {
	  //       if (status !== ENTERING && status !== ENTERED) {
	  //         nextStatus = ENTERING
	  //       }
	  //     } else {
	  //       if (status === ENTERING || status === ENTERED) {
	  //         nextStatus = EXITING
	  //       }
	  //     }
	  //   }
	  //   return { nextStatus }
	  // }
	  ;
	
	  var _proto = Transition.prototype;
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.updateStatus(true, this.appearStatus);
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var nextStatus = null;
	
	    if (prevProps !== this.props) {
	      var status = this.state.status;
	
	      if (this.props.in) {
	        if (status !== ENTERING && status !== ENTERED) {
	          nextStatus = ENTERING;
	        }
	      } else {
	        if (status === ENTERING || status === ENTERED) {
	          nextStatus = EXITING;
	        }
	      }
	    }
	
	    this.updateStatus(false, nextStatus);
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.cancelNextCallback();
	  };
	
	  _proto.getTimeouts = function getTimeouts() {
	    var timeout = this.props.timeout;
	    var exit, enter, appear;
	    exit = enter = appear = timeout;
	
	    if (timeout != null && typeof timeout !== 'number') {
	      exit = timeout.exit;
	      enter = timeout.enter; // TODO: remove fallback for next major
	
	      appear = timeout.appear !== undefined ? timeout.appear : enter;
	    }
	
	    return {
	      exit: exit,
	      enter: enter,
	      appear: appear
	    };
	  };
	
	  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
	    if (mounting === void 0) {
	      mounting = false;
	    }
	
	    if (nextStatus !== null) {
	      // nextStatus will always be ENTERING or EXITING.
	      this.cancelNextCallback();
	
	      if (nextStatus === ENTERING) {
	        if (this.props.unmountOnExit || this.props.mountOnEnter) {
	          var node = this.props.nodeRef ? this.props.nodeRef.current : _reactDom.default.findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
	          // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
	          // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
	
	          if (node) (0, _reflow.forceReflow)(node);
	        }
	
	        this.performEnter(mounting);
	      } else {
	        this.performExit();
	      }
	    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
	      this.setState({
	        status: UNMOUNTED
	      });
	    }
	  };
	
	  _proto.performEnter = function performEnter(mounting) {
	    var _this2 = this;
	
	    var enter = this.props.enter;
	    var appearing = this.context ? this.context.isMounting : mounting;
	
	    var _ref2 = this.props.nodeRef ? [appearing] : [_reactDom.default.findDOMNode(this), appearing],
	        maybeNode = _ref2[0],
	        maybeAppearing = _ref2[1];
	
	    var timeouts = this.getTimeouts();
	    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
	    // if we are mounting and running this it means appear _must_ be set
	
	    if (!mounting && !enter || _config.default.disabled) {
	      this.safeSetState({
	        status: ENTERED
	      }, function () {
	        _this2.props.onEntered(maybeNode);
	      });
	      return;
	    }
	
	    this.props.onEnter(maybeNode, maybeAppearing);
	    this.safeSetState({
	      status: ENTERING
	    }, function () {
	      _this2.props.onEntering(maybeNode, maybeAppearing);
	
	      _this2.onTransitionEnd(enterTimeout, function () {
	        _this2.safeSetState({
	          status: ENTERED
	        }, function () {
	          _this2.props.onEntered(maybeNode, maybeAppearing);
	        });
	      });
	    });
	  };
	
	  _proto.performExit = function performExit() {
	    var _this3 = this;
	
	    var exit = this.props.exit;
	    var timeouts = this.getTimeouts();
	    var maybeNode = this.props.nodeRef ? undefined : _reactDom.default.findDOMNode(this); // no exit animation skip right to EXITED
	
	    if (!exit || _config.default.disabled) {
	      this.safeSetState({
	        status: EXITED
	      }, function () {
	        _this3.props.onExited(maybeNode);
	      });
	      return;
	    }
	
	    this.props.onExit(maybeNode);
	    this.safeSetState({
	      status: EXITING
	    }, function () {
	      _this3.props.onExiting(maybeNode);
	
	      _this3.onTransitionEnd(timeouts.exit, function () {
	        _this3.safeSetState({
	          status: EXITED
	        }, function () {
	          _this3.props.onExited(maybeNode);
	        });
	      });
	    });
	  };
	
	  _proto.cancelNextCallback = function cancelNextCallback() {
	    if (this.nextCallback !== null) {
	      this.nextCallback.cancel();
	      this.nextCallback = null;
	    }
	  };
	
	  _proto.safeSetState = function safeSetState(nextState, callback) {
	    // This shouldn't be necessary, but there are weird race conditions with
	    // setState callbacks and unmounting in testing, so always make sure that
	    // we can cancel any pending setState callbacks after we unmount.
	    callback = this.setNextCallback(callback);
	    this.setState(nextState, callback);
	  };
	
	  _proto.setNextCallback = function setNextCallback(callback) {
	    var _this4 = this;
	
	    var active = true;
	
	    this.nextCallback = function (event) {
	      if (active) {
	        active = false;
	        _this4.nextCallback = null;
	        callback(event);
	      }
	    };
	
	    this.nextCallback.cancel = function () {
	      active = false;
	    };
	
	    return this.nextCallback;
	  };
	
	  _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
	    this.setNextCallback(handler);
	    var node = this.props.nodeRef ? this.props.nodeRef.current : _reactDom.default.findDOMNode(this);
	    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
	
	    if (!node || doesNotHaveTimeoutOrListener) {
	      setTimeout(this.nextCallback, 0);
	      return;
	    }
	
	    if (this.props.addEndListener) {
	      var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node, this.nextCallback],
	          maybeNode = _ref3[0],
	          maybeNextCallback = _ref3[1];
	
	      this.props.addEndListener(maybeNode, maybeNextCallback);
	    }
	
	    if (timeout != null) {
	      setTimeout(this.nextCallback, timeout);
	    }
	  };
	
	  _proto.render = function render() {
	    var status = this.state.status;
	
	    if (status === UNMOUNTED) {
	      return null;
	    }
	
	    var _this$props = this.props,
	        children = _this$props.children,
	        _in = _this$props.in,
	        _mountOnEnter = _this$props.mountOnEnter,
	        _unmountOnExit = _this$props.unmountOnExit,
	        _appear = _this$props.appear,
	        _enter = _this$props.enter,
	        _exit = _this$props.exit,
	        _timeout = _this$props.timeout,
	        _addEndListener = _this$props.addEndListener,
	        _onEnter = _this$props.onEnter,
	        _onEntering = _this$props.onEntering,
	        _onEntered = _this$props.onEntered,
	        _onExit = _this$props.onExit,
	        _onExiting = _this$props.onExiting,
	        _onExited = _this$props.onExited,
	        _nodeRef = _this$props.nodeRef,
	        childProps = _objectWithoutPropertiesLoose(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);
	
	    return (
	      /*#__PURE__*/
	      // allows for nested Transitions
	      _react.default.createElement(_TransitionGroupContext.default.Provider, {
	        value: null
	      }, typeof children === 'function' ? children(status, childProps) : _react.default.cloneElement(_react.default.Children.only(children), childProps))
	    );
	  };
	
	  return Transition;
	}(_react.default.Component);
	
	Transition.contextType = _TransitionGroupContext.default;
	Transition.propTypes =  false ? {
	  /**
	   * A React reference to DOM element that need to transition:
	   * https://stackoverflow.com/a/51127130/4671932
	   *
	   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
	   *      (e.g. `onEnter`) because user already has direct access to the node.
	   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
	   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
	   *     (see
	   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
	   */
	  nodeRef: _propTypes.default.shape({
	    current: typeof Element === 'undefined' ? _propTypes.default.any : function (propValue, key, componentName, location, propFullName, secret) {
	      var value = propValue[key];
	      return _propTypes.default.instanceOf(value && 'ownerDocument' in value ? value.ownerDocument.defaultView.Element : Element)(propValue, key, componentName, location, propFullName, secret);
	    }
	  }),
	
	  /**
	   * A `function` child can be used instead of a React element. This function is
	   * called with the current transition status (`'entering'`, `'entered'`,
	   * `'exiting'`, `'exited'`), which can be used to apply context
	   * specific props to a component.
	   *
	   * ```jsx
	   * <Transition in={this.state.in} timeout={150}>
	   *   {state => (
	   *     <MyComponent className={`fade fade-${state}`} />
	   *   )}
	   * </Transition>
	   * ```
	   */
	  children: _propTypes.default.oneOfType([_propTypes.default.func.isRequired, _propTypes.default.element.isRequired]).isRequired,
	
	  /**
	   * Show the component; triggers the enter or exit states
	   */
	  in: _propTypes.default.bool,
	
	  /**
	   * By default the child component is mounted immediately along with
	   * the parent `Transition` component. If you want to "lazy mount" the component on the
	   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
	   * mounted, even on "exited", unless you also specify `unmountOnExit`.
	   */
	  mountOnEnter: _propTypes.default.bool,
	
	  /**
	   * By default the child component stays mounted after it reaches the `'exited'` state.
	   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
	   */
	  unmountOnExit: _propTypes.default.bool,
	
	  /**
	   * By default the child component does not perform the enter transition when
	   * it first mounts, regardless of the value of `in`. If you want this
	   * behavior, set both `appear` and `in` to `true`.
	   *
	   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
	   * > only adds an additional enter transition. However, in the
	   * > `<CSSTransition>` component that first enter transition does result in
	   * > additional `.appear-*` classes, that way you can choose to style it
	   * > differently.
	   */
	  appear: _propTypes.default.bool,
	
	  /**
	   * Enable or disable enter transitions.
	   */
	  enter: _propTypes.default.bool,
	
	  /**
	   * Enable or disable exit transitions.
	   */
	  exit: _propTypes.default.bool,
	
	  /**
	   * The duration of the transition, in milliseconds.
	   * Required unless `addEndListener` is provided.
	   *
	   * You may specify a single timeout for all transitions:
	   *
	   * ```jsx
	   * timeout={500}
	   * ```
	   *
	   * or individually:
	   *
	   * ```jsx
	   * timeout={{
	   *  appear: 500,
	   *  enter: 300,
	   *  exit: 500,
	   * }}
	   * ```
	   *
	   * - `appear` defaults to the value of `enter`
	   * - `enter` defaults to `0`
	   * - `exit` defaults to `0`
	   *
	   * @type {number | { enter?: number, exit?: number, appear?: number }}
	   */
	  timeout: function timeout(props) {
	    var pt = _PropTypes.timeoutsShape;
	    if (!props.addEndListener) pt = pt.isRequired;
	
	    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return pt.apply(void 0, [props].concat(args));
	  },
	
	  /**
	   * Add a custom transition end trigger. Called with the transitioning
	   * DOM node and a `done` callback. Allows for more fine grained transition end
	   * logic. Timeouts are still used as a fallback if provided.
	   *
	   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
	   *
	   * ```jsx
	   * addEndListener={(node, done) => {
	   *   // use the css transitionend event to mark the finish of a transition
	   *   node.addEventListener('transitionend', done, false);
	   * }}
	   * ```
	   */
	  addEndListener: _propTypes.default.func,
	
	  /**
	   * Callback fired before the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * Callback fired after the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntering: _propTypes.default.func,
	
	  /**
	   * Callback fired after the "entered" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEntered: _propTypes.default.func,
	
	  /**
	   * Callback fired before the "exiting" status is applied.
	   *
	   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * Callback fired after the "exiting" status is applied.
	   *
	   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExiting: _propTypes.default.func,
	
	  /**
	   * Callback fired after the "exited" status is applied.
	   *
	   * **Note**: when `nodeRef` prop is passed, `node` is not passed
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExited: _propTypes.default.func
	} : {}; // Name the function so it is clearer in the documentation
	
	function noop() {}
	
	Transition.defaultProps = {
	  in: false,
	  mountOnEnter: false,
	  unmountOnExit: false,
	  appear: false,
	  enter: true,
	  exit: true,
	  onEnter: noop,
	  onEntering: noop,
	  onEntered: noop,
	  onExit: noop,
	  onExiting: noop,
	  onExited: noop
	};
	Transition.UNMOUNTED = UNMOUNTED;
	Transition.EXITED = EXITED;
	Transition.ENTERING = ENTERING;
	Transition.ENTERED = ENTERED;
	Transition.EXITING = EXITING;
	var _default = Transition;
	exports.default = _default;

/***/ },
/* 299 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _default = _react.default.createContext(null);
	
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 300 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.config = exports.Transition = exports.TransitionGroup = exports.SwitchTransition = exports.ReplaceTransition = exports.CSSTransition = void 0;
	
	var _CSSTransition = _interopRequireDefault(__webpack_require__(1519));
	
	exports.CSSTransition = _CSSTransition.default;
	
	var _ReplaceTransition = _interopRequireDefault(__webpack_require__(1520));
	
	exports.ReplaceTransition = _ReplaceTransition.default;
	
	var _SwitchTransition = _interopRequireDefault(__webpack_require__(1521));
	
	exports.SwitchTransition = _SwitchTransition.default;
	
	var _TransitionGroup = _interopRequireDefault(__webpack_require__(633));
	
	exports.TransitionGroup = _TransitionGroup.default;
	
	var _Transition = _interopRequireDefault(__webpack_require__(298));
	
	exports.Transition = _Transition.default;
	
	var _config = _interopRequireDefault(__webpack_require__(634));
	
	exports.config = _config.default;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 301 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(13));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(12));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(34));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _utils = __webpack_require__(11);
	
	var propTypes = {
	  active: _propTypes.default.bool,
	  'aria-label': _propTypes.default.string,
	  block: _propTypes.default.bool,
	  color: _propTypes.default.string,
	  disabled: _propTypes.default.bool,
	  outline: _propTypes.default.bool,
	  tag: _utils.tagPropType,
	  innerRef: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func, _propTypes.default.string]),
	  onClick: _propTypes.default.func,
	  size: _propTypes.default.string,
	  children: _propTypes.default.node,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  close: _propTypes.default.bool
	};
	var defaultProps = {
	  color: 'secondary',
	  tag: 'button'
	};
	
	var Button =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Button, _React$Component);
	
	  function Button(props) {
	    var _this;
	
	    _this = _React$Component.call(this, props) || this;
	    _this.onClick = _this.onClick.bind((0, _assertThisInitialized2.default)(_this));
	    return _this;
	  }
	
	  var _proto = Button.prototype;
	
	  _proto.onClick = function onClick(e) {
	    if (this.props.disabled) {
	      e.preventDefault();
	      return;
	    }
	
	    if (this.props.onClick) {
	      this.props.onClick(e);
	    }
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        active = _this$props.active,
	        ariaLabel = _this$props['aria-label'],
	        block = _this$props.block,
	        className = _this$props.className,
	        close = _this$props.close,
	        cssModule = _this$props.cssModule,
	        color = _this$props.color,
	        outline = _this$props.outline,
	        size = _this$props.size,
	        Tag = _this$props.tag,
	        innerRef = _this$props.innerRef,
	        attributes = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["active", "aria-label", "block", "className", "close", "cssModule", "color", "outline", "size", "tag", "innerRef"]);
	
	    if (close && typeof attributes.children === 'undefined') {
	      attributes.children = _react.default.createElement("span", {
	        "aria-hidden": true
	      }, "\xD7");
	    }
	
	    var btnOutlineColor = "btn" + (outline ? '-outline' : '') + "-" + color;
	    var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, {
	      close: close
	    }, close || 'btn', close || btnOutlineColor, size ? "btn-" + size : false, block ? 'btn-block' : false, {
	      active: active,
	      disabled: this.props.disabled
	    }), cssModule);
	
	    if (attributes.href && Tag === 'button') {
	      Tag = 'a';
	    }
	
	    var defaultAriaLabel = close ? 'Close' : null;
	    return _react.default.createElement(Tag, (0, _extends2.default)({
	      type: Tag === 'button' && attributes.onClick ? 'button' : undefined
	    }, attributes, {
	      className: classes,
	      ref: innerRef,
	      onClick: this.onClick,
	      "aria-label": ariaLabel || defaultAriaLabel
	    }));
	  };
	
	  return Button;
	}(_react.default.Component);
	
	Button.propTypes = propTypes;
	Button.defaultProps = defaultProps;
	var _default = Button;
	exports.default = _default;

/***/ },
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _objectSpread4 = _interopRequireDefault(__webpack_require__(47));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(13));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(12));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(34));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _reactTransitionGroup = __webpack_require__(303);
	
	var _utils = __webpack_require__(11);
	
	var CarouselItem =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(CarouselItem, _React$Component);
	
	  function CarouselItem(props) {
	    var _this;
	
	    _this = _React$Component.call(this, props) || this;
	    _this.state = {
	      startAnimation: false
	    };
	    _this.onEnter = _this.onEnter.bind((0, _assertThisInitialized2.default)(_this));
	    _this.onEntering = _this.onEntering.bind((0, _assertThisInitialized2.default)(_this));
	    _this.onExit = _this.onExit.bind((0, _assertThisInitialized2.default)(_this));
	    _this.onExiting = _this.onExiting.bind((0, _assertThisInitialized2.default)(_this));
	    _this.onExited = _this.onExited.bind((0, _assertThisInitialized2.default)(_this));
	    return _this;
	  }
	
	  var _proto = CarouselItem.prototype;
	
	  _proto.onEnter = function onEnter(node, isAppearing) {
	    this.setState({
	      startAnimation: false
	    });
	    this.props.onEnter(node, isAppearing);
	  };
	
	  _proto.onEntering = function onEntering(node, isAppearing) {
	    // getting this variable triggers a reflow
	    var offsetHeight = node.offsetHeight;
	    this.setState({
	      startAnimation: true
	    });
	    this.props.onEntering(node, isAppearing);
	    return offsetHeight;
	  };
	
	  _proto.onExit = function onExit(node) {
	    this.setState({
	      startAnimation: false
	    });
	    this.props.onExit(node);
	  };
	
	  _proto.onExiting = function onExiting(node) {
	    this.setState({
	      startAnimation: true
	    });
	    node.dispatchEvent(new CustomEvent('slide.bs.carousel'));
	    this.props.onExiting(node);
	  };
	
	  _proto.onExited = function onExited(node) {
	    node.dispatchEvent(new CustomEvent('slid.bs.carousel'));
	    this.props.onExited(node);
	  };
	
	  _proto.render = function render() {
	    var _this2 = this;
	
	    var _this$props = this.props,
	        isIn = _this$props.in,
	        children = _this$props.children,
	        cssModule = _this$props.cssModule,
	        slide = _this$props.slide,
	        Tag = _this$props.tag,
	        className = _this$props.className,
	        transitionProps = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["in", "children", "cssModule", "slide", "tag", "className"]);
	    return _react.default.createElement(_reactTransitionGroup.Transition, (0, _extends2.default)({}, transitionProps, {
	      enter: slide,
	      exit: slide,
	      in: isIn,
	      onEnter: this.onEnter,
	      onEntering: this.onEntering,
	      onExit: this.onExit,
	      onExiting: this.onExiting,
	      onExited: this.onExited
	    }), function (status) {
	      var direction = _this2.context.direction;
	      var isActive = status === _utils.TransitionStatuses.ENTERED || status === _utils.TransitionStatuses.EXITING;
	      var directionClassName = (status === _utils.TransitionStatuses.ENTERING || status === _utils.TransitionStatuses.EXITING) && _this2.state.startAnimation && (direction === 'right' ? 'carousel-item-left' : 'carousel-item-right');
	      var orderClassName = status === _utils.TransitionStatuses.ENTERING && (direction === 'right' ? 'carousel-item-next' : 'carousel-item-prev');
	      var itemClasses = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'carousel-item', isActive && 'active', directionClassName, orderClassName), cssModule);
	      return _react.default.createElement(Tag, {
	        className: itemClasses
	      }, children);
	    });
	  };
	
	  return CarouselItem;
	}(_react.default.Component);
	
	CarouselItem.propTypes = (0, _objectSpread4.default)({}, _reactTransitionGroup.Transition.propTypes, {
	  tag: _utils.tagPropType,
	  in: _propTypes.default.bool,
	  cssModule: _propTypes.default.object,
	  children: _propTypes.default.node,
	  slide: _propTypes.default.bool,
	  className: _propTypes.default.string
	});
	CarouselItem.defaultProps = (0, _objectSpread4.default)({}, _reactTransitionGroup.Transition.defaultProps, {
	  tag: 'div',
	  timeout: _utils.TransitionTimeouts.Carousel,
	  slide: true
	});
	CarouselItem.contextTypes = {
	  direction: _propTypes.default.string
	};
	var _default = CarouselItem;
	exports.default = _default;

/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _CSSTransition = _interopRequireDefault(__webpack_require__(1600));
	
	var _ReplaceTransition = _interopRequireDefault(__webpack_require__(1601));
	
	var _TransitionGroup = _interopRequireDefault(__webpack_require__(652));
	
	var _Transition = _interopRequireDefault(__webpack_require__(651));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = {
	  Transition: _Transition.default,
	  TransitionGroup: _TransitionGroup.default,
	  ReplaceTransition: _ReplaceTransition.default,
	  CSSTransition: _CSSTransition.default
	};

/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, setImmediate, global) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// A bit simpler than readable streams.
	// Implement an async ._write(chunk, encoding, cb), and it'll handle all
	// the drain event emission and buffering.
	
	'use strict';
	
	/*<replacement>*/
	
	var pna = __webpack_require__(202);
	/*</replacement>*/
	
	module.exports = Writable;
	
	/* <replacement> */
	function WriteReq(chunk, encoding, cb) {
	  this.chunk = chunk;
	  this.encoding = encoding;
	  this.callback = cb;
	  this.next = null;
	}
	
	// It seems a linked list but it is not
	// there will be only 2 of these for each stream
	function CorkedRequest(state) {
	  var _this = this;
	
	  this.next = null;
	  this.entry = null;
	  this.finish = function () {
	    onCorkedFinish(_this, state);
	  };
	}
	/* </replacement> */
	
	/*<replacement>*/
	var asyncWrite = !process.browser && ['v0.10', 'v0.9.'].indexOf(process.version.slice(0, 5)) > -1 ? setImmediate : pna.nextTick;
	/*</replacement>*/
	
	/*<replacement>*/
	var Duplex;
	/*</replacement>*/
	
	Writable.WritableState = WritableState;
	
	/*<replacement>*/
	var util = Object.create(__webpack_require__(147));
	util.inherits = __webpack_require__(126);
	/*</replacement>*/
	
	/*<replacement>*/
	var internalUtil = {
	  deprecate: __webpack_require__(1634)
	};
	/*</replacement>*/
	
	/*<replacement>*/
	var Stream = __webpack_require__(657);
	/*</replacement>*/
	
	/*<replacement>*/
	
	var Buffer = __webpack_require__(213).Buffer;
	var OurUint8Array = (typeof global !== 'undefined' ? global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function () {};
	function _uint8ArrayToBuffer(chunk) {
	  return Buffer.from(chunk);
	}
	function _isUint8Array(obj) {
	  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
	}
	
	/*</replacement>*/
	
	var destroyImpl = __webpack_require__(656);
	
	util.inherits(Writable, Stream);
	
	function nop() {}
	
	function WritableState(options, stream) {
	  Duplex = Duplex || __webpack_require__(116);
	
	  options = options || {};
	
	  // Duplex streams are both readable and writable, but share
	  // the same options object.
	  // However, some cases require setting options to different
	  // values for the readable and the writable sides of the duplex stream.
	  // These options can be provided separately as readableXXX and writableXXX.
	  var isDuplex = stream instanceof Duplex;
	
	  // object stream flag to indicate whether or not this stream
	  // contains buffers or objects.
	  this.objectMode = !!options.objectMode;
	
	  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
	
	  // the point at which write() starts returning false
	  // Note: 0 is a valid value, means that we always return false if
	  // the entire buffer is not flushed immediately on write()
	  var hwm = options.highWaterMark;
	  var writableHwm = options.writableHighWaterMark;
	  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
	
	  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;else this.highWaterMark = defaultHwm;
	
	  // cast to ints.
	  this.highWaterMark = Math.floor(this.highWaterMark);
	
	  // if _final has been called
	  this.finalCalled = false;
	
	  // drain event flag.
	  this.needDrain = false;
	  // at the start of calling end()
	  this.ending = false;
	  // when end() has been called, and returned
	  this.ended = false;
	  // when 'finish' is emitted
	  this.finished = false;
	
	  // has it been destroyed
	  this.destroyed = false;
	
	  // should we decode strings into buffers before passing to _write?
	  // this is here so that some node-core streams can optimize string
	  // handling at a lower level.
	  var noDecode = options.decodeStrings === false;
	  this.decodeStrings = !noDecode;
	
	  // Crypto is kind of old and crusty.  Historically, its default string
	  // encoding is 'binary' so we have to make this configurable.
	  // Everything else in the universe uses 'utf8', though.
	  this.defaultEncoding = options.defaultEncoding || 'utf8';
	
	  // not an actual buffer we keep track of, but a measurement
	  // of how much we're waiting to get pushed to some underlying
	  // socket or file.
	  this.length = 0;
	
	  // a flag to see when we're in the middle of a write.
	  this.writing = false;
	
	  // when true all writes will be buffered until .uncork() call
	  this.corked = 0;
	
	  // a flag to be able to tell if the onwrite cb is called immediately,
	  // or on a later tick.  We set this to true at first, because any
	  // actions that shouldn't happen until "later" should generally also
	  // not happen before the first write call.
	  this.sync = true;
	
	  // a flag to know if we're processing previously buffered items, which
	  // may call the _write() callback in the same tick, so that we don't
	  // end up in an overlapped onwrite situation.
	  this.bufferProcessing = false;
	
	  // the callback that's passed to _write(chunk,cb)
	  this.onwrite = function (er) {
	    onwrite(stream, er);
	  };
	
	  // the callback that the user supplies to write(chunk,encoding,cb)
	  this.writecb = null;
	
	  // the amount that is being written when _write is called.
	  this.writelen = 0;
	
	  this.bufferedRequest = null;
	  this.lastBufferedRequest = null;
	
	  // number of pending user-supplied write callbacks
	  // this must be 0 before 'finish' can be emitted
	  this.pendingcb = 0;
	
	  // emit prefinish if the only thing we're waiting for is _write cbs
	  // This is relevant for synchronous Transform streams
	  this.prefinished = false;
	
	  // True if the error was already emitted and should not be thrown again
	  this.errorEmitted = false;
	
	  // count buffered requests
	  this.bufferedRequestCount = 0;
	
	  // allocate the first CorkedRequest, there is always
	  // one allocated and free to use, and we maintain at most two
	  this.corkedRequestsFree = new CorkedRequest(this);
	}
	
	WritableState.prototype.getBuffer = function getBuffer() {
	  var current = this.bufferedRequest;
	  var out = [];
	  while (current) {
	    out.push(current);
	    current = current.next;
	  }
	  return out;
	};
	
	(function () {
	  try {
	    Object.defineProperty(WritableState.prototype, 'buffer', {
	      get: internalUtil.deprecate(function () {
	        return this.getBuffer();
	      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
	    });
	  } catch (_) {}
	})();
	
	// Test _writableState for inheritance to account for Duplex streams,
	// whose prototype chain only points to Readable.
	var realHasInstance;
	if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
	  realHasInstance = Function.prototype[Symbol.hasInstance];
	  Object.defineProperty(Writable, Symbol.hasInstance, {
	    value: function (object) {
	      if (realHasInstance.call(this, object)) return true;
	      if (this !== Writable) return false;
	
	      return object && object._writableState instanceof WritableState;
	    }
	  });
	} else {
	  realHasInstance = function (object) {
	    return object instanceof this;
	  };
	}
	
	function Writable(options) {
	  Duplex = Duplex || __webpack_require__(116);
	
	  // Writable ctor is applied to Duplexes, too.
	  // `realHasInstance` is necessary because using plain `instanceof`
	  // would return false, as no `_writableState` property is attached.
	
	  // Trying to use the custom `instanceof` for Writable here will also break the
	  // Node.js LazyTransform implementation, which has a non-trivial getter for
	  // `_writableState` that would lead to infinite recursion.
	  if (!realHasInstance.call(Writable, this) && !(this instanceof Duplex)) {
	    return new Writable(options);
	  }
	
	  this._writableState = new WritableState(options, this);
	
	  // legacy.
	  this.writable = true;
	
	  if (options) {
	    if (typeof options.write === 'function') this._write = options.write;
	
	    if (typeof options.writev === 'function') this._writev = options.writev;
	
	    if (typeof options.destroy === 'function') this._destroy = options.destroy;
	
	    if (typeof options.final === 'function') this._final = options.final;
	  }
	
	  Stream.call(this);
	}
	
	// Otherwise people can pipe Writable streams, which is just wrong.
	Writable.prototype.pipe = function () {
	  this.emit('error', new Error('Cannot pipe, not readable'));
	};
	
	function writeAfterEnd(stream, cb) {
	  var er = new Error('write after end');
	  // TODO: defer error events consistently everywhere, not just the cb
	  stream.emit('error', er);
	  pna.nextTick(cb, er);
	}
	
	// Checks that a user-supplied chunk is valid, especially for the particular
	// mode the stream is in. Currently this means that `null` is never accepted
	// and undefined/non-string values are only allowed in object mode.
	function validChunk(stream, state, chunk, cb) {
	  var valid = true;
	  var er = false;
	
	  if (chunk === null) {
	    er = new TypeError('May not write null values to stream');
	  } else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
	    er = new TypeError('Invalid non-string/buffer chunk');
	  }
	  if (er) {
	    stream.emit('error', er);
	    pna.nextTick(cb, er);
	    valid = false;
	  }
	  return valid;
	}
	
	Writable.prototype.write = function (chunk, encoding, cb) {
	  var state = this._writableState;
	  var ret = false;
	  var isBuf = !state.objectMode && _isUint8Array(chunk);
	
	  if (isBuf && !Buffer.isBuffer(chunk)) {
	    chunk = _uint8ArrayToBuffer(chunk);
	  }
	
	  if (typeof encoding === 'function') {
	    cb = encoding;
	    encoding = null;
	  }
	
	  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;
	
	  if (typeof cb !== 'function') cb = nop;
	
	  if (state.ended) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
	    state.pendingcb++;
	    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
	  }
	
	  return ret;
	};
	
	Writable.prototype.cork = function () {
	  var state = this._writableState;
	
	  state.corked++;
	};
	
	Writable.prototype.uncork = function () {
	  var state = this._writableState;
	
	  if (state.corked) {
	    state.corked--;
	
	    if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
	  }
	};
	
	Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
	  // node::ParseEncoding() requires lower case.
	  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
	  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
	  this._writableState.defaultEncoding = encoding;
	  return this;
	};
	
	function decodeChunk(state, chunk, encoding) {
	  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
	    chunk = Buffer.from(chunk, encoding);
	  }
	  return chunk;
	}
	
	Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
	  // making it explicit this property is not enumerable
	  // because otherwise some prototype manipulation in
	  // userland will fail
	  enumerable: false,
	  get: function () {
	    return this._writableState.highWaterMark;
	  }
	});
	
	// if we're already writing something, then just put this
	// in the queue, and wait our turn.  Otherwise, call _write
	// If we return false, then we need a drain event, so set that flag.
	function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
	  if (!isBuf) {
	    var newChunk = decodeChunk(state, chunk, encoding);
	    if (chunk !== newChunk) {
	      isBuf = true;
	      encoding = 'buffer';
	      chunk = newChunk;
	    }
	  }
	  var len = state.objectMode ? 1 : chunk.length;
	
	  state.length += len;
	
	  var ret = state.length < state.highWaterMark;
	  // we must ensure that previous needDrain will not be reset to false.
	  if (!ret) state.needDrain = true;
	
	  if (state.writing || state.corked) {
	    var last = state.lastBufferedRequest;
	    state.lastBufferedRequest = {
	      chunk: chunk,
	      encoding: encoding,
	      isBuf: isBuf,
	      callback: cb,
	      next: null
	    };
	    if (last) {
	      last.next = state.lastBufferedRequest;
	    } else {
	      state.bufferedRequest = state.lastBufferedRequest;
	    }
	    state.bufferedRequestCount += 1;
	  } else {
	    doWrite(stream, state, false, len, chunk, encoding, cb);
	  }
	
	  return ret;
	}
	
	function doWrite(stream, state, writev, len, chunk, encoding, cb) {
	  state.writelen = len;
	  state.writecb = cb;
	  state.writing = true;
	  state.sync = true;
	  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
	  state.sync = false;
	}
	
	function onwriteError(stream, state, sync, er, cb) {
	  --state.pendingcb;
	
	  if (sync) {
	    // defer the callback if we are being called synchronously
	    // to avoid piling up things on the stack
	    pna.nextTick(cb, er);
	    // this can emit finish, and it will always happen
	    // after error
	    pna.nextTick(finishMaybe, stream, state);
	    stream._writableState.errorEmitted = true;
	    stream.emit('error', er);
	  } else {
	    // the caller expect this to happen before if
	    // it is async
	    cb(er);
	    stream._writableState.errorEmitted = true;
	    stream.emit('error', er);
	    // this can emit finish, but finish must
	    // always follow error
	    finishMaybe(stream, state);
	  }
	}
	
	function onwriteStateUpdate(state) {
	  state.writing = false;
	  state.writecb = null;
	  state.length -= state.writelen;
	  state.writelen = 0;
	}
	
	function onwrite(stream, er) {
	  var state = stream._writableState;
	  var sync = state.sync;
	  var cb = state.writecb;
	
	  onwriteStateUpdate(state);
	
	  if (er) onwriteError(stream, state, sync, er, cb);else {
	    // Check if we're actually ready to finish, but don't emit yet
	    var finished = needFinish(state);
	
	    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
	      clearBuffer(stream, state);
	    }
	
	    if (sync) {
	      /*<replacement>*/
	      asyncWrite(afterWrite, stream, state, finished, cb);
	      /*</replacement>*/
	    } else {
	      afterWrite(stream, state, finished, cb);
	    }
	  }
	}
	
	function afterWrite(stream, state, finished, cb) {
	  if (!finished) onwriteDrain(stream, state);
	  state.pendingcb--;
	  cb();
	  finishMaybe(stream, state);
	}
	
	// Must force callback to be called on nextTick, so that we don't
	// emit 'drain' before the write() consumer gets the 'false' return
	// value, and has a chance to attach a 'drain' listener.
	function onwriteDrain(stream, state) {
	  if (state.length === 0 && state.needDrain) {
	    state.needDrain = false;
	    stream.emit('drain');
	  }
	}
	
	// if there's something in the buffer waiting, then process it
	function clearBuffer(stream, state) {
	  state.bufferProcessing = true;
	  var entry = state.bufferedRequest;
	
	  if (stream._writev && entry && entry.next) {
	    // Fast case, write everything using _writev()
	    var l = state.bufferedRequestCount;
	    var buffer = new Array(l);
	    var holder = state.corkedRequestsFree;
	    holder.entry = entry;
	
	    var count = 0;
	    var allBuffers = true;
	    while (entry) {
	      buffer[count] = entry;
	      if (!entry.isBuf) allBuffers = false;
	      entry = entry.next;
	      count += 1;
	    }
	    buffer.allBuffers = allBuffers;
	
	    doWrite(stream, state, true, state.length, buffer, '', holder.finish);
	
	    // doWrite is almost always async, defer these to save a bit of time
	    // as the hot path ends with doWrite
	    state.pendingcb++;
	    state.lastBufferedRequest = null;
	    if (holder.next) {
	      state.corkedRequestsFree = holder.next;
	      holder.next = null;
	    } else {
	      state.corkedRequestsFree = new CorkedRequest(state);
	    }
	    state.bufferedRequestCount = 0;
	  } else {
	    // Slow case, write chunks one-by-one
	    while (entry) {
	      var chunk = entry.chunk;
	      var encoding = entry.encoding;
	      var cb = entry.callback;
	      var len = state.objectMode ? 1 : chunk.length;
	
	      doWrite(stream, state, false, len, chunk, encoding, cb);
	      entry = entry.next;
	      state.bufferedRequestCount--;
	      // if we didn't call the onwrite immediately, then
	      // it means that we need to wait until it does.
	      // also, that means that the chunk and cb are currently
	      // being processed, so move the buffer counter past them.
	      if (state.writing) {
	        break;
	      }
	    }
	
	    if (entry === null) state.lastBufferedRequest = null;
	  }
	
	  state.bufferedRequest = entry;
	  state.bufferProcessing = false;
	}
	
	Writable.prototype._write = function (chunk, encoding, cb) {
	  cb(new Error('_write() is not implemented'));
	};
	
	Writable.prototype._writev = null;
	
	Writable.prototype.end = function (chunk, encoding, cb) {
	  var state = this._writableState;
	
	  if (typeof chunk === 'function') {
	    cb = chunk;
	    chunk = null;
	    encoding = null;
	  } else if (typeof encoding === 'function') {
	    cb = encoding;
	    encoding = null;
	  }
	
	  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
	
	  // .end() fully uncorks
	  if (state.corked) {
	    state.corked = 1;
	    this.uncork();
	  }
	
	  // ignore unnecessary end() calls.
	  if (!state.ending) endWritable(this, state, cb);
	};
	
	function needFinish(state) {
	  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
	}
	function callFinal(stream, state) {
	  stream._final(function (err) {
	    state.pendingcb--;
	    if (err) {
	      stream.emit('error', err);
	    }
	    state.prefinished = true;
	    stream.emit('prefinish');
	    finishMaybe(stream, state);
	  });
	}
	function prefinish(stream, state) {
	  if (!state.prefinished && !state.finalCalled) {
	    if (typeof stream._final === 'function') {
	      state.pendingcb++;
	      state.finalCalled = true;
	      pna.nextTick(callFinal, stream, state);
	    } else {
	      state.prefinished = true;
	      stream.emit('prefinish');
	    }
	  }
	}
	
	function finishMaybe(stream, state) {
	  var need = needFinish(state);
	  if (need) {
	    prefinish(stream, state);
	    if (state.pendingcb === 0) {
	      state.finished = true;
	      stream.emit('finish');
	    }
	  }
	  return need;
	}
	
	function endWritable(stream, state, cb) {
	  state.ending = true;
	  finishMaybe(stream, state);
	  if (cb) {
	    if (state.finished) pna.nextTick(cb);else stream.once('finish', cb);
	  }
	  state.ended = true;
	  stream.writable = false;
	}
	
	function onCorkedFinish(corkReq, state, err) {
	  var entry = corkReq.entry;
	  corkReq.entry = null;
	  while (entry) {
	    var cb = entry.callback;
	    state.pendingcb--;
	    cb(err);
	    entry = entry.next;
	  }
	
	  // reuse the free corkReq.
	  state.corkedRequestsFree.next = corkReq;
	}
	
	Object.defineProperty(Writable.prototype, 'destroyed', {
	  get: function () {
	    if (this._writableState === undefined) {
	      return false;
	    }
	    return this._writableState.destroyed;
	  },
	  set: function (value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (!this._writableState) {
	      return;
	    }
	
	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._writableState.destroyed = value;
	  }
	});
	
	Writable.prototype.destroy = destroyImpl.destroy;
	Writable.prototype._undestroy = destroyImpl.undestroy;
	Writable.prototype._destroy = function (err, cb) {
	  this.end();
	  cb(err);
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(111), __webpack_require__(214).setImmediate, (function() { return this; }())))

/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(654);
	exports.Stream = exports;
	exports.Readable = exports;
	exports.Writable = __webpack_require__(304);
	exports.Duplex = __webpack_require__(116);
	exports.Transform = __webpack_require__(655);
	exports.PassThrough = __webpack_require__(1604);


/***/ },
/* 306 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
	    "use strict";
	
	    if (global.setImmediate) {
	        return;
	    }
	
	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;
	
	    function setImmediate(callback) {
	      // Callback can either be a function or a string
	      if (typeof callback !== "function") {
	        callback = new Function("" + callback);
	      }
	      // Copy function arguments
	      var args = new Array(arguments.length - 1);
	      for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i + 1];
	      }
	      // Store and register the task
	      var task = { callback: callback, args: args };
	      tasksByHandle[nextHandle] = task;
	      registerImmediate(nextHandle);
	      return nextHandle++;
	    }
	
	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }
	
	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	        case 0:
	            callback();
	            break;
	        case 1:
	            callback(args[0]);
	            break;
	        case 2:
	            callback(args[0], args[1]);
	            break;
	        case 3:
	            callback(args[0], args[1], args[2]);
	            break;
	        default:
	            callback.apply(undefined, args);
	            break;
	        }
	    }
	
	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }
	
	    function installNextTickImplementation() {
	        registerImmediate = function(handle) {
	            process.nextTick(function () { runIfPresent(handle); });
	        };
	    }
	
	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function() {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }
	
	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	
	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function(event) {
	            if (event.source === global &&
	                typeof event.data === "string" &&
	                event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	
	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }
	
	        registerImmediate = function(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }
	
	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function(event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };
	
	        registerImmediate = function(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }
	
	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }
	
	    function installSetTimeoutImplementation() {
	        registerImmediate = function(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }
	
	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
	
	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();
	
	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();
	
	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();
	
	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();
	
	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }
	
	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(111)))

/***/ },
/* 307 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var isProduction = ("production") === 'production';
	var prefix = 'Invariant failed';
	function invariant(condition, message) {
	    if (condition) {
	        return;
	    }
	    if (isProduction) {
	        throw new Error(prefix);
	    }
	    var provided = typeof message === 'function' ? message() : message;
	    var value = provided ? "".concat(prefix, ": ").concat(provided) : prefix;
	    throw new Error(value);
	}
	
	module.exports = invariant;


/***/ },
/* 308 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAA3NCSVQICAjb4U/gAAAACXBIWXMAAADdAAAA3QFwU6IHAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAMxQTFRF////4ebm8VZDwcbL4ubnsLe9u8HGytHY0dfc1trd1tvf4uXn45WN7X5w8VZC8VlF8VtH8VtI8VxJ8l1J8mFO82tZ829e83Bf9HZm9Hts9H5v9YBx9YR19YZ49Yd59ox/9o6B9pKF9peL9piM95qO95uP952R96CV96KX96SZ+Kqf+Kuh+LCn+biw+bmw+buz+by0+r21+r22+r62+sO8+sW/+9HM/NfS/NfT/NnU/NvW/ODc/OHd/ero/u/t/vLx/vTy/vj3//r6////6UkM2QAAAAV0Uk5TADy4wMmamUNaAAAA0klEQVQ4y53R1w6CMBSA4aIoSrUuxIXixIV7i5v3fycBExJOS1H/i96cL+lCyEsQcaA4AoE5TkCBIYCCBkAwQFCwQEBAkIQCgjQUmEqW3DjgI3jAE1zgCj5wRATAchTA3jBGmGV9QEL6DdQXcz1XnJgjlRDDNHUK7LbGpdO4DtePqmJPp00aDEh30zgTMp4pdq2Wp8FhddNc0N4rtmW1GFv0ysQB6qmv2KxDTjRnqTxf92WpcPzrmlwQ8tQZH7hJdKkA4P7mV0Bkz0UfCEwhCgi9AaFeK7VdymjMAAAAAElFTkSuQmCC"

/***/ },
/* 309 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAA7AAAAOwBeShxvQAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAANESURBVFiF7ZdLaFRXGIC//87DmMZMZjRGEyXB1EnMLW3BEswYa2ckUC0FF1ooRbClhtYuXAgFkbootAuR0p2KXXZRbOmDQh8LnQkqob6woUnatKJJY1M0yUySmZTM4xwX85BpopmbuYUu/OBy4Nz/cf7//OcllEnT/nBFws1zylC3Jk7tuGNV32lVoe6tS6u1SgZQdGokMCtsRuMW5fgU2Gf7AOreuLBBG6oTQ29F06kyqU0ggmT/65ycaJZZdQ7kzeTovupapaafFnF0gt4KBIFVJVnSjCL0WnGu4ZZz5Zs9IQdql0YCouObtRjuB3H9h2jWibDXaYj+QSOu3IiWjtB778wLr5QqXtsd2YumwwBc5fgtF8ur4KFoOmoPRM4uJiboZDptHMnn27BtAEvEvgxYr4Et8H/KQINvGfufX8MHXw8XCRzsauCrK/cYiyULfTuf9aEU/Ng3+UCw3BpYXe3iYFcD/rWVBWH/2kqO7m7k1UBdkZF3X26kvXlFyVE+ikIG+kYSRBMpQm01DI3NAhAyvYX2o+/+BKDe68a/ZjnvnZ36d2jl1UBGaSKDUwTNmoJQsM3D3ekkzzRWsXJFdrvY8ZSPxFyGyzenLca6MEWrINwf5cRrT1JV4UBpaG+u5tgXt3l/TxPbWz18eWWckOnl0tA0ybQqtmTHPhAeiOF0CAG/h20tHpwOg+9vTHD55gxB04fbKQQ2VnO+P1p25HmKMjAZT9E3EidkehHg5+E44zMpwgMx3umqJ+CvoarCQc/gAgOwax8490uUkOklaHoJD2Qdne+P4qtycejFBn7/+x9GxueshfkI5u2EkcEYh19an3McA2BobJY7k3O0N1dz+txfC1uy6yy4cXuGiZlUYTryhAdiRa1dzMuA0vBZ710guzTzfHt9gu2bavjpj4csvyXWwIKH0YffDM/ru/hbjC3HrpVqv2Qe3wce3wek9kDEnju41XeBZh1Ch4HIx8B1IL6Yjq0IoxqOF72MPG9f8LozaVMro01EbQAxEdrQNLH4dH1upQbyFBXh1MltUeBi7itQ3321MpVJtCD4NbSK6FbAD7QAT2QDIm3VeU6vPHyv96x3OVVLSvPr5CfBUav69wGMQ0bXf47aywAAAABJRU5ErkJggg=="

/***/ },
/* 310 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAA7AAAAOwBeShxvQAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAALXSURBVFiF7ZdLSFRRHMZ/5947zuho2sN8JEZFGUUtstKohVpZYoJBUKJhElFRob0fGOmiIsSFRZZGUVAmQRr0gog20YRkBi2mTMPRjJpp0qDMGmfubRG2mJmc0cZm47c7//Od7//j3nPP5Qi8aX9aLKrjOELkoBHt1eMmgxKiLZs+/+DDrVUV/vgHJXtUilNiEDSBSAeM/gYpkiySohOXx69O/my52/TM33WSR0WnlANT/Q1wz4vQG6oyz+/ePHIATWSPsPmgZL1OOZdxdlfeyADQJv4jACB0RkPo5cyavbkjAAiYQkJkqX55bfGaYAEghNCHKYb6rAv7MoICAICmGRVZbsy6sCc1OAC/IcYpknJ/dW3xIvcpJVA9BlQnLz+8HcoS5VRdN4BpowLgUlU6ez/6ssW4F/7PKxhCYwBjAEEH8PkZCiE4lF5A1xcr1188pHRFIWarhU99vWTNXsKRezWomgpAYlQMRYt//0zrWh7QZu/2CeDzCWiaRp/jB5fWH+ZU9naOrtzEm09dpCbO5WB6PpIQAMiSxJNd5yhYkMnG5FU0l1wkNmLCvwMAVJsaeGXtZF9aHtWmBq8nnk5SiDaOx/atl2pTIxuuHuPj157AADhVFy3vWwFo6jR79fxwOsivK2eiMZLKnJ1U5ZYQqtMHBiA5IYnChVm027s5mb2NMJ3BwzMlMpotKTkU1Z9g280KZk5KYF7cDJ/Zfm3CM2t309RlZt2VUl4duMahjAL6HP0A2MrvAHD+6S0i9GE83lGNwzVAm70bs7XDJ4DwqOxd+h0IHRxGGsLJTFpE87vXdPR8ICVxDpPDx9Nm72Ze3PQ/y1ptXZitFlbMWogsZB61P6d/4Kd7ej+VT8KGBRBgeQAE/SAaA/AGYB/Ffh7ZngBC3Bm9/tpt3wCoZYBlFLpbcMhl7kXP27HpXR+L4+uRpCgggWHckP8iG5qow+XM57TJ5j75C0y32ksqMlkHAAAAAElFTkSuQmCC"

/***/ },
/* 311 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	/**
	 * Convert array of 16 byte values to UUID string format of the form:
	 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
	 */
	var byteToHex = [];
	
	for (var i = 0; i < 256; ++i) {
	  byteToHex[i] = (i + 0x100).toString(16).substr(1);
	}
	
	function bytesToUuid(buf, offset) {
	  var i = offset || 0;
	  var bth = byteToHex; // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
	
	  return [bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]]].join('');
	}
	
	var _default = bytesToUuid;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 312 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.handleLoadStart = handleLoadStart;
	exports.handleCanPlay = handleCanPlay;
	exports.handleWaiting = handleWaiting;
	exports.handleCanPlayThrough = handleCanPlayThrough;
	exports.handlePlaying = handlePlaying;
	exports.handlePlay = handlePlay;
	exports.handlePause = handlePause;
	exports.handleEnd = handleEnd;
	exports.handleSeeking = handleSeeking;
	exports.handleSeeked = handleSeeked;
	exports.handleDurationChange = handleDurationChange;
	exports.handleTimeUpdate = handleTimeUpdate;
	exports.handleVolumeChange = handleVolumeChange;
	exports.handleProgressChange = handleProgressChange;
	exports.handleRateChange = handleRateChange;
	exports.handleSuspend = handleSuspend;
	exports.handleAbort = handleAbort;
	exports.handleEmptied = handleEmptied;
	exports.handleStalled = handleStalled;
	exports.handleLoadedMetaData = handleLoadedMetaData;
	exports.handleLoadedData = handleLoadedData;
	exports.handleResize = handleResize;
	exports.handleError = handleError;
	exports.handleSeekingTime = handleSeekingTime;
	exports.handleEndSeeking = handleEndSeeking;
	exports.activateTextTrack = activateTextTrack;
	exports.ACTIVATE_TEXT_TRACK = exports.ERROR = exports.RESIZE = exports.LOADED_DATA = exports.LOADED_META_DATA = exports.STALLED = exports.EMPTIED = exports.ABORT = exports.SUSPEND = exports.RATE_CHANGE = exports.PROGRESS_CHANGE = exports.VOLUME_CHANGE = exports.TIME_UPDATE = exports.DURATION_CHANGE = exports.END_SEEKING = exports.SEEKING_TIME = exports.SEEKED = exports.SEEKING = exports.END = exports.PAUSE = exports.PLAY = exports.PLAYING = exports.CAN_PLAY_THROUGH = exports.WAITING = exports.CAN_PLAY = exports.LOAD_START = void 0;
	var LOAD_START = 'video-react/LOAD_START';
	exports.LOAD_START = LOAD_START;
	var CAN_PLAY = 'video-react/CAN_PLAY';
	exports.CAN_PLAY = CAN_PLAY;
	var WAITING = 'video-react/WAITING';
	exports.WAITING = WAITING;
	var CAN_PLAY_THROUGH = 'video-react/CAN_PLAY_THROUGH';
	exports.CAN_PLAY_THROUGH = CAN_PLAY_THROUGH;
	var PLAYING = 'video-react/PLAYING';
	exports.PLAYING = PLAYING;
	var PLAY = 'video-react/PLAY';
	exports.PLAY = PLAY;
	var PAUSE = 'video-react/PAUSE';
	exports.PAUSE = PAUSE;
	var END = 'video-react/END';
	exports.END = END;
	var SEEKING = 'video-react/SEEKING';
	exports.SEEKING = SEEKING;
	var SEEKED = 'video-react/SEEKED';
	exports.SEEKED = SEEKED;
	var SEEKING_TIME = 'video-react/SEEKING_TIME';
	exports.SEEKING_TIME = SEEKING_TIME;
	var END_SEEKING = 'video-react/END_SEEKING';
	exports.END_SEEKING = END_SEEKING;
	var DURATION_CHANGE = 'video-react/DURATION_CHANGE';
	exports.DURATION_CHANGE = DURATION_CHANGE;
	var TIME_UPDATE = 'video-react/TIME_UPDATE';
	exports.TIME_UPDATE = TIME_UPDATE;
	var VOLUME_CHANGE = 'video-react/VOLUME_CHANGE';
	exports.VOLUME_CHANGE = VOLUME_CHANGE;
	var PROGRESS_CHANGE = 'video-react/PROGRESS_CHANGE';
	exports.PROGRESS_CHANGE = PROGRESS_CHANGE;
	var RATE_CHANGE = 'video-react/RATE_CHANGE';
	exports.RATE_CHANGE = RATE_CHANGE;
	var SUSPEND = 'video-react/SUSPEND';
	exports.SUSPEND = SUSPEND;
	var ABORT = 'video-react/ABORT';
	exports.ABORT = ABORT;
	var EMPTIED = 'video-react/EMPTIED';
	exports.EMPTIED = EMPTIED;
	var STALLED = 'video-react/STALLED';
	exports.STALLED = STALLED;
	var LOADED_META_DATA = 'video-react/LOADED_META_DATA';
	exports.LOADED_META_DATA = LOADED_META_DATA;
	var LOADED_DATA = 'video-react/LOADED_DATA';
	exports.LOADED_DATA = LOADED_DATA;
	var RESIZE = 'video-react/RESIZE';
	exports.RESIZE = RESIZE;
	var ERROR = 'video-react/ERROR';
	exports.ERROR = ERROR;
	var ACTIVATE_TEXT_TRACK = 'video-react/ACTIVATE_TEXT_TRACK';
	exports.ACTIVATE_TEXT_TRACK = ACTIVATE_TEXT_TRACK;
	
	function handleLoadStart(videoProps) {
	  return {
	    type: LOAD_START,
	    videoProps: videoProps
	  };
	}
	
	function handleCanPlay(videoProps) {
	  return {
	    type: CAN_PLAY,
	    videoProps: videoProps
	  };
	}
	
	function handleWaiting(videoProps) {
	  return {
	    type: WAITING,
	    videoProps: videoProps
	  };
	}
	
	function handleCanPlayThrough(videoProps) {
	  return {
	    type: CAN_PLAY_THROUGH,
	    videoProps: videoProps
	  };
	}
	
	function handlePlaying(videoProps) {
	  return {
	    type: PLAYING,
	    videoProps: videoProps
	  };
	}
	
	function handlePlay(videoProps) {
	  return {
	    type: PLAY,
	    videoProps: videoProps
	  };
	}
	
	function handlePause(videoProps) {
	  return {
	    type: PAUSE,
	    videoProps: videoProps
	  };
	}
	
	function handleEnd(videoProps) {
	  return {
	    type: END,
	    videoProps: videoProps
	  };
	}
	
	function handleSeeking(videoProps) {
	  return {
	    type: SEEKING,
	    videoProps: videoProps
	  };
	}
	
	function handleSeeked(videoProps) {
	  return {
	    type: SEEKED,
	    videoProps: videoProps
	  };
	}
	
	function handleDurationChange(videoProps) {
	  return {
	    type: DURATION_CHANGE,
	    videoProps: videoProps
	  };
	}
	
	function handleTimeUpdate(videoProps) {
	  return {
	    type: TIME_UPDATE,
	    videoProps: videoProps
	  };
	}
	
	function handleVolumeChange(videoProps) {
	  return {
	    type: VOLUME_CHANGE,
	    videoProps: videoProps
	  };
	}
	
	function handleProgressChange(videoProps) {
	  return {
	    type: PROGRESS_CHANGE,
	    videoProps: videoProps
	  };
	}
	
	function handleRateChange(videoProps) {
	  return {
	    type: RATE_CHANGE,
	    videoProps: videoProps
	  };
	}
	
	function handleSuspend(videoProps) {
	  return {
	    type: SUSPEND,
	    videoProps: videoProps
	  };
	}
	
	function handleAbort(videoProps) {
	  return {
	    type: ABORT,
	    videoProps: videoProps
	  };
	}
	
	function handleEmptied(videoProps) {
	  return {
	    type: EMPTIED,
	    videoProps: videoProps
	  };
	}
	
	function handleStalled(videoProps) {
	  return {
	    type: STALLED,
	    videoProps: videoProps
	  };
	}
	
	function handleLoadedMetaData(videoProps) {
	  return {
	    type: LOADED_META_DATA,
	    videoProps: videoProps
	  };
	}
	
	function handleLoadedData(videoProps) {
	  return {
	    type: LOADED_DATA,
	    videoProps: videoProps
	  };
	}
	
	function handleResize(videoProps) {
	  return {
	    type: RESIZE,
	    videoProps: videoProps
	  };
	}
	
	function handleError(videoProps) {
	  return {
	    type: ERROR,
	    videoProps: videoProps
	  };
	}
	
	function handleSeekingTime(time) {
	  return {
	    type: SEEKING_TIME,
	    time: time
	  };
	}
	
	function handleEndSeeking(time) {
	  return {
	    type: END_SEEKING,
	    time: time
	  };
	}
	
	function activateTextTrack(textTrack) {
	  return {
	    type: ACTIVATE_TEXT_TRACK,
	    textTrack: textTrack
	  };
	}

/***/ },
/* 313 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(19));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(40));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(39));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(12));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(22));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var Dom = _interopRequireWildcard(__webpack_require__(227));
	
	var propTypes = {
	  className: _propTypes["default"].string,
	  onMouseDown: _propTypes["default"].func,
	  onMouseMove: _propTypes["default"].func,
	  stepForward: _propTypes["default"].func,
	  stepBack: _propTypes["default"].func,
	  sliderActive: _propTypes["default"].func,
	  sliderInactive: _propTypes["default"].func,
	  onMouseUp: _propTypes["default"].func,
	  onFocus: _propTypes["default"].func,
	  onBlur: _propTypes["default"].func,
	  onClick: _propTypes["default"].func,
	  getPercent: _propTypes["default"].func,
	  vertical: _propTypes["default"].bool,
	  children: _propTypes["default"].node,
	  label: _propTypes["default"].string,
	  valuenow: _propTypes["default"].string,
	  valuetext: _propTypes["default"].string
	};
	
	var Slider =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(Slider, _Component);
	
	  function Slider(props, context) {
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, Slider);
	    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Slider).call(this, props, context));
	    _this.handleMouseDown = _this.handleMouseDown.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleMouseMove = _this.handleMouseMove.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleMouseUp = _this.handleMouseUp.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleFocus = _this.handleFocus.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleBlur = _this.handleBlur.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleKeyPress = _this.handleKeyPress.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.stepForward = _this.stepForward.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.stepBack = _this.stepBack.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.calculateDistance = _this.calculateDistance.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.getProgress = _this.getProgress.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.renderChildren = _this.renderChildren.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.state = {
	      active: false
	    };
	    return _this;
	  }
	
	  (0, _createClass2["default"])(Slider, [{
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      document.removeEventListener('mousemove', this.handleMouseMove, true);
	      document.removeEventListener('mouseup', this.handleMouseUp, true);
	      document.removeEventListener('touchmove', this.handleMouseMove, true);
	      document.removeEventListener('touchend', this.handleMouseUp, true);
	      document.removeEventListener('keydown', this.handleKeyPress, true);
	    }
	  }, {
	    key: "getProgress",
	    value: function getProgress() {
	      var getPercent = this.props.getPercent;
	
	      if (!getPercent) {
	        return 0;
	      }
	
	      var progress = getPercent(); // Protect against no duration and other division issues
	
	      if (typeof progress !== 'number' || progress < 0 || progress === Infinity) {
	        progress = 0;
	      }
	
	      return progress;
	    }
	  }, {
	    key: "handleMouseDown",
	    value: function handleMouseDown(event) {
	      var onMouseDown = this.props.onMouseDown; // event.preventDefault();
	      // event.stopPropagation();
	
	      document.addEventListener('mousemove', this.handleMouseMove, true);
	      document.addEventListener('mouseup', this.handleMouseUp, true);
	      document.addEventListener('touchmove', this.handleMouseMove, true);
	      document.addEventListener('touchend', this.handleMouseUp, true);
	      this.setState({
	        active: true
	      });
	
	      if (this.props.sliderActive) {
	        this.props.sliderActive(event);
	      }
	
	      this.handleMouseMove(event);
	
	      if (onMouseDown) {
	        onMouseDown(event);
	      }
	    }
	  }, {
	    key: "handleMouseMove",
	    value: function handleMouseMove(event) {
	      var onMouseMove = this.props.onMouseMove;
	
	      if (onMouseMove) {
	        onMouseMove(event);
	      }
	    }
	  }, {
	    key: "handleMouseUp",
	    value: function handleMouseUp(event) {
	      // On iOS safari, a subsequent mouseup event will be fired after touchend.
	      // Its weird event positions make the player seek a wrong time.
	      // calling preventDefault (at touchend phase) will prevent the mouseup event
	      event.preventDefault();
	      var onMouseUp = this.props.onMouseUp;
	      document.removeEventListener('mousemove', this.handleMouseMove, true);
	      document.removeEventListener('mouseup', this.handleMouseUp, true);
	      document.removeEventListener('touchmove', this.handleMouseMove, true);
	      document.removeEventListener('touchend', this.handleMouseUp, true);
	      this.setState({
	        active: false
	      });
	
	      if (this.props.sliderInactive) {
	        this.props.sliderInactive(event);
	      }
	
	      if (onMouseUp) {
	        onMouseUp(event);
	      }
	    }
	  }, {
	    key: "handleFocus",
	    value: function handleFocus(e) {
	      document.addEventListener('keydown', this.handleKeyPress, true);
	
	      if (this.props.onFocus) {
	        this.props.onFocus(e);
	      }
	    }
	  }, {
	    key: "handleBlur",
	    value: function handleBlur(e) {
	      document.removeEventListener('keydown', this.handleKeyPress, true);
	
	      if (this.props.onBlur) {
	        this.props.onBlur(e);
	      }
	    }
	  }, {
	    key: "handleClick",
	    value: function handleClick(event) {
	      event.preventDefault(); // event.stopPropagation();
	
	      if (this.props.onClick) {
	        this.props.onClick(event);
	      }
	    }
	  }, {
	    key: "handleKeyPress",
	    value: function handleKeyPress(event) {
	      if (event.which === 37 || event.which === 40) {
	        // Left and Down Arrows
	        event.preventDefault();
	        event.stopPropagation();
	        this.stepBack();
	      } else if (event.which === 38 || event.which === 39) {
	        // Up and Right Arrows
	        event.preventDefault();
	        event.stopPropagation();
	        this.stepForward();
	      }
	    }
	  }, {
	    key: "stepForward",
	    value: function stepForward() {
	      if (this.props.stepForward) {
	        this.props.stepForward();
	      }
	    }
	  }, {
	    key: "stepBack",
	    value: function stepBack() {
	      if (this.props.stepBack) {
	        this.props.stepBack();
	      }
	    }
	  }, {
	    key: "calculateDistance",
	    value: function calculateDistance(event) {
	      var node = this.slider;
	      var position = Dom.getPointerPosition(node, event);
	
	      if (this.props.vertical) {
	        return position.y;
	      }
	
	      return position.x;
	    }
	  }, {
	    key: "renderChildren",
	    value: function renderChildren() {
	      var progress = this.getProgress();
	      var percentage = "".concat((progress * 100).toFixed(2), "%");
	      return _react["default"].Children.map(this.props.children, function (child) {
	        return _react["default"].cloneElement(child, {
	          progress: progress,
	          percentage: percentage
	        });
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _this$props = this.props,
	          vertical = _this$props.vertical,
	          label = _this$props.label,
	          valuenow = _this$props.valuenow,
	          valuetext = _this$props.valuetext;
	      return _react["default"].createElement("div", {
	        className: (0, _classnames["default"])(this.props.className, {
	          'video-react-slider-vertical': vertical,
	          'video-react-slider-horizontal': !vertical,
	          'video-react-sliding': this.state.active
	        }, 'video-react-slider'),
	        ref: function ref(c) {
	          _this2.slider = c;
	        },
	        tabIndex: "0",
	        role: "slider",
	        onMouseDown: this.handleMouseDown,
	        onTouchStart: this.handleMouseDown,
	        onFocus: this.handleFocus,
	        onBlur: this.handleBlur,
	        onClick: this.handleClick,
	        "aria-label": label || '',
	        "aria-valuenow": valuenow || '',
	        "aria-valuetext": valuetext || '',
	        "aria-valuemin": 0,
	        "aria-valuemax": 100
	      }, this.renderChildren());
	    }
	  }]);
	  return Slider;
	}(_react.Component);
	
	exports["default"] = Slider;
	Slider.propTypes = propTypes;
	Slider.displayName = 'Slider';

/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(19));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(40));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(39));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(12));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(22));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _MenuButton = _interopRequireDefault(__webpack_require__(315));
	
	var propTypes = {
	  player: _propTypes["default"].object,
	  actions: _propTypes["default"].object,
	  rates: _propTypes["default"].array,
	  className: _propTypes["default"].string
	};
	var defaultProps = {
	  rates: [2, 1.5, 1.25, 1, 0.5, 0.25]
	};
	
	var PlaybackRateMenuButton =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(PlaybackRateMenuButton, _Component);
	
	  function PlaybackRateMenuButton(props, context) {
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, PlaybackRateMenuButton);
	    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(PlaybackRateMenuButton).call(this, props, context));
	    _this.handleSelectItem = _this.handleSelectItem.bind((0, _assertThisInitialized2["default"])(_this));
	    return _this;
	  }
	
	  (0, _createClass2["default"])(PlaybackRateMenuButton, [{
	    key: "handleSelectItem",
	    value: function handleSelectItem(index) {
	      var _this$props = this.props,
	          rates = _this$props.rates,
	          actions = _this$props.actions;
	
	      if (index >= 0 && index < rates.length) {
	        actions.changeRate(rates[index]);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          rates = _this$props2.rates,
	          player = _this$props2.player;
	      var items = rates.map(function (rate) {
	        return {
	          label: "".concat(rate, "x"),
	          value: rate
	        };
	      });
	      var selectedIndex = rates.indexOf(player.playbackRate) || 0;
	      return _react["default"].createElement(_MenuButton["default"], {
	        className: (0, _classnames["default"])('video-react-playback-rate', this.props.className),
	        onSelectItem: this.handleSelectItem,
	        items: items,
	        selectedIndex: selectedIndex
	      }, _react["default"].createElement("span", {
	        className: "video-react-control-text"
	      }, "Playback Rate"), _react["default"].createElement("div", {
	        className: "video-react-playback-rate-value"
	      }, "".concat(player.playbackRate.toFixed(2), "x")));
	    }
	  }]);
	  return PlaybackRateMenuButton;
	}(_react.Component);
	
	PlaybackRateMenuButton.propTypes = propTypes;
	PlaybackRateMenuButton.defaultProps = defaultProps;
	PlaybackRateMenuButton.displayName = 'PlaybackRateMenuButton';
	var _default = PlaybackRateMenuButton;
	exports["default"] = _default;

/***/ },
/* 315 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(19));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(40));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(39));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(12));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(22));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _Menu = _interopRequireDefault(__webpack_require__(1648));
	
	var _MenuItem = _interopRequireDefault(__webpack_require__(1649));
	
	var _ClickableComponent = _interopRequireDefault(__webpack_require__(668));
	
	var propTypes = {
	  inline: _propTypes["default"].bool,
	  items: _propTypes["default"].array,
	  className: _propTypes["default"].string,
	  onSelectItem: _propTypes["default"].func,
	  children: _propTypes["default"].any,
	  selectedIndex: _propTypes["default"].number
	};
	
	var MenuButton =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(MenuButton, _Component);
	
	  function MenuButton(props, context) {
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, MenuButton);
	    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(MenuButton).call(this, props, context));
	    _this.state = {
	      active: false,
	      activateIndex: props.selectedIndex || 0
	    };
	    _this.commitSelection = _this.commitSelection.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.activateMenuItem = _this.activateMenuItem.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.renderMenu = _this.renderMenu.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleFocus = _this.handleFocus.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleBlur = _this.handleBlur.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleUpArrow = _this.handleUpArrow.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleDownArrow = _this.handleDownArrow.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleEscape = _this.handleEscape.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleReturn = _this.handleReturn.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleTab = _this.handleTab.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleKeyPress = _this.handleKeyPress.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleSelectItem = _this.handleSelectItem.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleIndexChange = _this.handleIndexChange.bind((0, _assertThisInitialized2["default"])(_this));
	    return _this;
	  }
	
	  (0, _createClass2["default"])(MenuButton, [{
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      if (prevProps.selectedIndex !== this.props.selectedIndex) {
	        this.activateMenuItem(this.props.selectedIndex);
	      }
	    }
	  }, {
	    key: "commitSelection",
	    value: function commitSelection(index) {
	      this.setState({
	        activateIndex: index
	      });
	      this.handleIndexChange(index);
	    }
	  }, {
	    key: "activateMenuItem",
	    value: function activateMenuItem(index) {
	      this.setState({
	        activateIndex: index
	      });
	      this.handleIndexChange(index);
	    }
	  }, {
	    key: "handleIndexChange",
	    value: function handleIndexChange(index) {
	      var onSelectItem = this.props.onSelectItem;
	      onSelectItem(index);
	    }
	  }, {
	    key: "handleClick",
	    value: function handleClick() {
	      this.setState(function (prevState) {
	        return {
	          active: !prevState.active
	        };
	      });
	    }
	  }, {
	    key: "handleFocus",
	    value: function handleFocus() {
	      document.addEventListener('keydown', this.handleKeyPress);
	    }
	  }, {
	    key: "handleBlur",
	    value: function handleBlur() {
	      this.setState({
	        active: false
	      });
	      document.removeEventListener('keydown', this.handleKeyPress);
	    }
	  }, {
	    key: "handleUpArrow",
	    value: function handleUpArrow(e) {
	      var items = this.props.items;
	
	      if (this.state.active) {
	        e.preventDefault();
	        var newIndex = this.state.activateIndex - 1;
	
	        if (newIndex < 0) {
	          newIndex = items.length ? items.length - 1 : 0;
	        }
	
	        this.activateMenuItem(newIndex);
	      }
	    }
	  }, {
	    key: "handleDownArrow",
	    value: function handleDownArrow(e) {
	      var items = this.props.items;
	
	      if (this.state.active) {
	        e.preventDefault();
	        var newIndex = this.state.activateIndex + 1;
	
	        if (newIndex >= items.length) {
	          newIndex = 0;
	        }
	
	        this.activateMenuItem(newIndex);
	      }
	    }
	  }, {
	    key: "handleTab",
	    value: function handleTab(e) {
	      if (this.state.active) {
	        e.preventDefault();
	        this.commitSelection(this.state.activateIndex);
	      }
	    }
	  }, {
	    key: "handleReturn",
	    value: function handleReturn(e) {
	      e.preventDefault();
	
	      if (this.state.active) {
	        this.commitSelection(this.state.activateIndex);
	      } else {
	        this.setState({
	          active: true
	        });
	      }
	    }
	  }, {
	    key: "handleEscape",
	    value: function handleEscape() {
	      this.setState({
	        active: false,
	        activateIndex: 0
	      });
	    }
	  }, {
	    key: "handleKeyPress",
	    value: function handleKeyPress(event) {
	      // Escape (27) key
	      if (event.which === 27) {
	        this.handleEscape(event);
	      } else if (event.which === 9) {
	        // Tab (9) key
	        this.handleTab(event);
	      } else if (event.which === 13) {
	        // Enter (13) key
	        this.handleReturn(event);
	      } else if (event.which === 38) {
	        // Up (38) key
	        this.handleUpArrow(event);
	      } else if (event.which === 40) {
	        // Down (40) key press
	        this.handleDownArrow(event);
	      }
	    }
	  }, {
	    key: "handleSelectItem",
	    value: function handleSelectItem(i) {
	      this.commitSelection(i);
	    }
	  }, {
	    key: "renderMenu",
	    value: function renderMenu() {
	      var _this2 = this;
	
	      if (!this.state.active) {
	        return null;
	      }
	
	      var items = this.props.items;
	      return _react["default"].createElement(_Menu["default"], null, items.map(function (item, i) {
	        return _react["default"].createElement(_MenuItem["default"], {
	          item: item,
	          index: i,
	          onSelectItem: _this2.handleSelectItem,
	          activateIndex: _this2.state.activateIndex,
	          key: "item-".concat(i++)
	        });
	      }));
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var _this$props = this.props,
	          inline = _this$props.inline,
	          className = _this$props.className;
	      return _react["default"].createElement(_ClickableComponent["default"], {
	        className: (0, _classnames["default"])(className, {
	          'video-react-menu-button-inline': !!inline,
	          'video-react-menu-button-popup': !inline,
	          'video-react-menu-button-active': this.state.active
	        }, 'video-react-control video-react-button video-react-menu-button'),
	        role: "button",
	        tabIndex: "0",
	        ref: function ref(c) {
	          _this3.menuButton = c;
	        },
	        onClick: this.handleClick,
	        onFocus: this.handleFocus,
	        onBlur: this.handleBlur
	      }, this.props.children, this.renderMenu());
	    }
	  }]);
	  return MenuButton;
	}(_react.Component);
	
	exports["default"] = MenuButton;
	MenuButton.propTypes = propTypes;
	MenuButton.displayName = 'MenuButton';

/***/ },
/* 316 */
/***/ function(module, exports) {

	function _arrayLikeToArray(r, a) {
	  (null == a || a > r.length) && (a = r.length);
	  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
	  return n;
	}
	module.exports = _arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 317 */
/***/ function(module, exports) {

	function _setPrototypeOf(t, e) {
	  return (module.exports = _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
	    return t.__proto__ = e, t;
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _setPrototypeOf(t, e);
	}
	module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	var _typeof = __webpack_require__(56)["default"];
	var toPrimitive = __webpack_require__(702);
	function toPropertyKey(t) {
	  var i = toPrimitive(t, "string");
	  return "symbol" == _typeof(i) ? i : i + "";
	}
	module.exports = toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ButtonBase.default;
	  }
	});
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(707));

/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _FilledInput.default;
	  }
	});
	
	var _FilledInput = _interopRequireDefault(__webpack_require__(712));

/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ariaHidden = ariaHidden;
	exports.default = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(19));
	
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(103));
	
	var _getScrollbarSize = _interopRequireDefault(__webpack_require__(329));
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(95));
	
	var _ownerWindow = _interopRequireDefault(__webpack_require__(238));
	
	// Is a vertical scrollbar displayed?
	function isOverflowing(container) {
	  var doc = (0, _ownerDocument.default)(container);
	
	  if (doc.body === container) {
	    return (0, _ownerWindow.default)(doc).innerWidth > doc.documentElement.clientWidth;
	  }
	
	  return container.scrollHeight > container.clientHeight;
	}
	
	function ariaHidden(node, show) {
	  if (show) {
	    node.setAttribute('aria-hidden', 'true');
	  } else {
	    node.removeAttribute('aria-hidden');
	  }
	}
	
	function getPaddingRight(node) {
	  return parseInt(window.getComputedStyle(node)['padding-right'], 10) || 0;
	}
	
	function ariaHiddenSiblings(container, mountNode, currentNode) {
	  var nodesToExclude = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
	  var show = arguments.length > 4 ? arguments[4] : undefined;
	  var blacklist = [mountNode, currentNode].concat((0, _toConsumableArray2.default)(nodesToExclude));
	  var blacklistTagNames = ['TEMPLATE', 'SCRIPT', 'STYLE'];
	  [].forEach.call(container.children, function (node) {
	    if (node.nodeType === 1 && blacklist.indexOf(node) === -1 && blacklistTagNames.indexOf(node.tagName) === -1) {
	      ariaHidden(node, show);
	    }
	  });
	}
	
	function findIndexOf(containerInfo, callback) {
	  var idx = -1;
	  containerInfo.some(function (item, index) {
	    if (callback(item)) {
	      idx = index;
	      return true;
	    }
	
	    return false;
	  });
	  return idx;
	}
	
	function handleContainer(containerInfo, props) {
	  var restoreStyle = [];
	  var restorePaddings = [];
	  var container = containerInfo.container;
	  var fixedNodes;
	
	  if (!props.disableScrollLock) {
	    if (isOverflowing(container)) {
	      // Compute the size before applying overflow hidden to avoid any scroll jumps.
	      var scrollbarSize = (0, _getScrollbarSize.default)();
	      restoreStyle.push({
	        value: container.style.paddingRight,
	        key: 'padding-right',
	        el: container
	      }); // Use computed style, here to get the real padding to add our scrollbar width.
	
	      container.style['padding-right'] = "".concat(getPaddingRight(container) + scrollbarSize, "px"); // .mui-fixed is a global helper.
	
	      fixedNodes = (0, _ownerDocument.default)(container).querySelectorAll('.mui-fixed');
	      [].forEach.call(fixedNodes, function (node) {
	        restorePaddings.push(node.style.paddingRight);
	        node.style.paddingRight = "".concat(getPaddingRight(node) + scrollbarSize, "px");
	      });
	    } // Improve Gatsby support
	    // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
	
	
	    var parent = container.parentElement;
	    var scrollContainer = parent.nodeName === 'HTML' && window.getComputedStyle(parent)['overflow-y'] === 'scroll' ? parent : container; // Block the scroll even if no scrollbar is visible to account for mobile keyboard
	    // screensize shrink.
	
	    restoreStyle.push({
	      value: scrollContainer.style.overflow,
	      key: 'overflow',
	      el: scrollContainer
	    });
	    scrollContainer.style.overflow = 'hidden';
	  }
	
	  var restore = function restore() {
	    if (fixedNodes) {
	      [].forEach.call(fixedNodes, function (node, i) {
	        if (restorePaddings[i]) {
	          node.style.paddingRight = restorePaddings[i];
	        } else {
	          node.style.removeProperty('padding-right');
	        }
	      });
	    }
	
	    restoreStyle.forEach(function (_ref) {
	      var value = _ref.value,
	          el = _ref.el,
	          key = _ref.key;
	
	      if (value) {
	        el.style.setProperty(key, value);
	      } else {
	        el.style.removeProperty(key);
	      }
	    });
	  };
	
	  return restore;
	}
	
	function getHiddenSiblings(container) {
	  var hiddenSiblings = [];
	  [].forEach.call(container.children, function (node) {
	    if (node.getAttribute && node.getAttribute('aria-hidden') === 'true') {
	      hiddenSiblings.push(node);
	    }
	  });
	  return hiddenSiblings;
	}
	/**
	 * @ignore - do not document.
	 *
	 * Proper state management for containers and the modals in those containers.
	 * Simplified, but inspired by react-overlay's ModalManager class.
	 * Used by the Modal to ensure proper styling of containers.
	 */
	
	
	var ModalManager = /*#__PURE__*/function () {
	  function ModalManager() {
	    (0, _classCallCheck2.default)(this, ModalManager);
	    // this.modals[modalIndex] = modal
	    this.modals = []; // this.containers[containerIndex] = {
	    //   modals: [],
	    //   container,
	    //   restore: null,
	    // }
	
	    this.containers = [];
	  }
	
	  (0, _createClass2.default)(ModalManager, [{
	    key: "add",
	    value: function add(modal, container) {
	      var modalIndex = this.modals.indexOf(modal);
	
	      if (modalIndex !== -1) {
	        return modalIndex;
	      }
	
	      modalIndex = this.modals.length;
	      this.modals.push(modal); // If the modal we are adding is already in the DOM.
	
	      if (modal.modalRef) {
	        ariaHidden(modal.modalRef, false);
	      }
	
	      var hiddenSiblingNodes = getHiddenSiblings(container);
	      ariaHiddenSiblings(container, modal.mountNode, modal.modalRef, hiddenSiblingNodes, true);
	      var containerIndex = findIndexOf(this.containers, function (item) {
	        return item.container === container;
	      });
	
	      if (containerIndex !== -1) {
	        this.containers[containerIndex].modals.push(modal);
	        return modalIndex;
	      }
	
	      this.containers.push({
	        modals: [modal],
	        container: container,
	        restore: null,
	        hiddenSiblingNodes: hiddenSiblingNodes
	      });
	      return modalIndex;
	    }
	  }, {
	    key: "mount",
	    value: function mount(modal, props) {
	      var containerIndex = findIndexOf(this.containers, function (item) {
	        return item.modals.indexOf(modal) !== -1;
	      });
	      var containerInfo = this.containers[containerIndex];
	
	      if (!containerInfo.restore) {
	        containerInfo.restore = handleContainer(containerInfo, props);
	      }
	    }
	  }, {
	    key: "remove",
	    value: function remove(modal) {
	      var modalIndex = this.modals.indexOf(modal);
	
	      if (modalIndex === -1) {
	        return modalIndex;
	      }
	
	      var containerIndex = findIndexOf(this.containers, function (item) {
	        return item.modals.indexOf(modal) !== -1;
	      });
	      var containerInfo = this.containers[containerIndex];
	      containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
	      this.modals.splice(modalIndex, 1); // If that was the last modal in a container, clean up the container.
	
	      if (containerInfo.modals.length === 0) {
	        // The modal might be closed before it had the chance to be mounted in the DOM.
	        if (containerInfo.restore) {
	          containerInfo.restore();
	        }
	
	        if (modal.modalRef) {
	          // In case the modal wasn't in the DOM yet.
	          ariaHidden(modal.modalRef, true);
	        }
	
	        ariaHiddenSiblings(containerInfo.container, modal.mountNode, modal.modalRef, containerInfo.hiddenSiblingNodes, false);
	        this.containers.splice(containerIndex, 1);
	      } else {
	        // Otherwise make sure the next top modal is visible to a screen reader.
	        var nextTop = containerInfo.modals[containerInfo.modals.length - 1]; // as soon as a modal is adding its modalRef is undefined. it can't set
	        // aria-hidden because the dom element doesn't exist either
	        // when modal was unmounted before modalRef gets null
	
	        if (nextTop.modalRef) {
	          ariaHidden(nextTop.modalRef, false);
	        }
	      }
	
	      return modalIndex;
	    }
	  }, {
	    key: "isTopModal",
	    value: function isTopModal(modal) {
	      return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
	    }
	  }]);
	  return ModalManager;
	}();
	
	exports.default = ModalManager;

/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(25));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(37));
	
	var _utils = __webpack_require__(26);
	
	var _capitalize = _interopRequireDefault(__webpack_require__(78));
	
	/**
	 * @ignore - internal component.
	 */
	var NativeSelectInput = /*#__PURE__*/React.forwardRef(function NativeSelectInput(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      disabled = props.disabled,
	      IconComponent = props.IconComponent,
	      inputRef = props.inputRef,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'standard' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "disabled", "IconComponent", "inputRef", "variant"]);
	  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("select", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, // TODO v5: merge root and select
	    classes.select, classes[variant], className, disabled && classes.disabled),
	    disabled: disabled,
	    ref: inputRef || ref
	  }, other)), props.multiple ? null : /*#__PURE__*/React.createElement(IconComponent, {
	    className: (0, _clsx.default)(classes.icon, classes["icon".concat((0, _capitalize.default)(variant))], disabled && classes.disabled)
	  }));
	});
	 false ? NativeSelectInput.propTypes = {
	  /**
	   * The option elements to populate the select with.
	   * Can be some `<option>` elements.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * The CSS class name of the select element.
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, the select will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * The icon that displays the arrow.
	   */
	  IconComponent: _propTypes.default.elementType.isRequired,
	
	  /**
	   * Use that prop to pass a ref to the native select element.
	   * @deprecated
	   */
	  inputRef: _utils.refType,
	
	  /**
	   * @ignore
	   */
	  multiple: _propTypes.default.bool,
	
	  /**
	   * Name attribute of the `select` or hidden `input` element.
	   */
	  name: _propTypes.default.string,
	
	  /**
	   * Callback function fired when a menu item is selected.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new value by accessing `event.target.value` (string).
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * The input value.
	   */
	  value: _propTypes.default.any,
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['standard', 'outlined', 'filled'])
	} : void 0;
	var _default = NativeSelectInput;
	exports.default = _default;

/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _OutlinedInput.default;
	  }
	});
	
	var _OutlinedInput = _interopRequireDefault(__webpack_require__(740));

/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Paper.default;
	  }
	});
	
	var _Paper = _interopRequireDefault(__webpack_require__(741));

/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Portal.default;
	  }
	});
	
	var _Portal = _interopRequireDefault(__webpack_require__(746));

/***/ },
/* 326 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(235));
	
	/**
	 * @ignore - internal component.
	 */
	var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
	  d: "M7 10l5 5 5-5z"
	}), 'ArrowDropDown');
	
	exports.default = _default;

/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.duration = exports.easing = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(25));
	
	// Follow https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves
	// to learn the context in which each easing should be used.
	var easing = {
	  // This is the most common easing curve.
	  easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
	  // Objects enter the screen at full velocity from off-screen and
	  // slowly decelerate to a resting point.
	  easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
	  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
	  easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
	  // The sharp curve is used by objects that may return to the screen at any time.
	  sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
	}; // Follow https://material.io/guidelines/motion/duration-easing.html#duration-easing-common-durations
	// to learn when use what timing
	
	exports.easing = easing;
	var duration = {
	  shortest: 150,
	  shorter: 200,
	  short: 250,
	  // most basic recommended timing
	  standard: 300,
	  // this is to be used in complex animations
	  complex: 375,
	  // recommended when something is entering screen
	  enteringScreen: 225,
	  // recommended when something is leaving screen
	  leavingScreen: 195
	};
	exports.duration = duration;
	
	function formatMs(milliseconds) {
	  return "".concat(Math.round(milliseconds), "ms");
	}
	/**
	 * @param {string|Array} props
	 * @param {object} param
	 * @param {string} param.prop
	 * @param {number} param.duration
	 * @param {string} param.easing
	 * @param {number} param.delay
	 */
	
	
	var _default = {
	  easing: easing,
	  duration: duration,
	  create: function create() {
	    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['all'];
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var _options$duration = options.duration,
	        durationOption = _options$duration === void 0 ? duration.standard : _options$duration,
	        _options$easing = options.easing,
	        easingOption = _options$easing === void 0 ? easing.easeInOut : _options$easing,
	        _options$delay = options.delay,
	        delay = _options$delay === void 0 ? 0 : _options$delay,
	        other = (0, _objectWithoutProperties2.default)(options, ["duration", "easing", "delay"]);
	
	    if (false) {
	      var isString = function isString(value) {
	        return typeof value === 'string';
	      };
	
	      var isNumber = function isNumber(value) {
	        return !isNaN(parseFloat(value));
	      };
	
	      if (!isString(props) && !Array.isArray(props)) {
	        console.error('Material-UI: Argument "props" must be a string or Array.');
	      }
	
	      if (!isNumber(durationOption) && !isString(durationOption)) {
	        console.error("Material-UI: Argument \"duration\" must be a number or a string but found ".concat(durationOption, "."));
	      }
	
	      if (!isString(easingOption)) {
	        console.error('Material-UI: Argument "easing" must be a string.');
	      }
	
	      if (!isNumber(delay) && !isString(delay)) {
	        console.error('Material-UI: Argument "delay" must be a number or a string.');
	      }
	
	      if (Object.keys(other).length !== 0) {
	        console.error("Material-UI: Unrecognized argument(s) [".concat(Object.keys(other).join(','), "]."));
	      }
	    }
	
	    return (Array.isArray(props) ? props : [props]).map(function (animatedProp) {
	      return "".concat(animatedProp, " ").concat(typeof durationOption === 'string' ? durationOption : formatMs(durationOption), " ").concat(easingOption, " ").concat(typeof delay === 'string' ? delay : formatMs(delay));
	    }).join(',');
	  },
	  getAutoHeightDuration: function getAutoHeightDuration(height) {
	    if (!height) {
	      return 0;
	    }
	
	    var constant = height / 36; // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
	
	    return Math.round((4 + 15 * Math.pow(constant, 0.25) + constant / 5) * 10);
	  }
	};
	exports.default = _default;

/***/ },
/* 328 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	// We need to centralize the zIndex definitions as they work
	// like global values in the browser.
	var zIndex = {
	  mobileStepper: 1000,
	  speedDial: 1050,
	  appBar: 1100,
	  drawer: 1200,
	  modal: 1300,
	  snackbar: 1400,
	  tooltip: 1500
	};
	var _default = zIndex;
	exports.default = _default;

/***/ },
/* 329 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getScrollbarSize;
	
	// A change of the browser zoom change the scrollbar size.
	// Credit https://github.com/twbs/bootstrap/blob/3ffe3a5d82f6f561b82ff78d82b32a7d14aed558/js/src/modal.js#L512-L519
	function getScrollbarSize() {
	  var scrollDiv = document.createElement('div');
	  scrollDiv.style.width = '99px';
	  scrollDiv.style.height = '99px';
	  scrollDiv.style.position = 'absolute';
	  scrollDiv.style.top = '-9999px';
	  scrollDiv.style.overflow = 'scroll';
	  document.body.appendChild(scrollDiv);
	  var scrollbarSize = scrollDiv.offsetWidth - scrollDiv.clientWidth;
	  document.body.removeChild(scrollDiv);
	  return scrollbarSize;
	}

/***/ },
/* 330 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isMuiElement;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	function isMuiElement(element, muiNames) {
	  return /*#__PURE__*/React.isValidElement(element) && muiNames.indexOf(element.type.muiName) !== -1;
	}

/***/ },
/* 331 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = unsupportedProp;
	
	function unsupportedProp(props, propName, componentName, location, propFullName) {
	  if (true) {
	    return null;
	  }
	
	  var propFullNameSafe = propFullName || propName;
	
	  if (typeof props[propName] !== 'undefined') {
	    return new Error("The prop `".concat(propFullNameSafe, "` is not supported. Please remove it."));
	  }
	
	  return null;
	}

/***/ },
/* 332 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = useControlled;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	/* eslint-disable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps */
	function useControlled(_ref) {
	  var controlled = _ref.controlled,
	      defaultProp = _ref.default,
	      name = _ref.name,
	      _ref$state = _ref.state,
	      state = _ref$state === void 0 ? 'value' : _ref$state;
	
	  var _React$useRef = React.useRef(controlled !== undefined),
	      isControlled = _React$useRef.current;
	
	  var _React$useState = React.useState(defaultProp),
	      valueState = _React$useState[0],
	      setValue = _React$useState[1];
	
	  var value = isControlled ? controlled : valueState;
	
	  if (false) {
	    React.useEffect(function () {
	      if (isControlled !== (controlled !== undefined)) {
	        console.error(["Material-UI: A component is changing the ".concat(isControlled ? '' : 'un', "controlled ").concat(state, " state of ").concat(name, " to be ").concat(isControlled ? 'un' : '', "controlled."), 'Elements should not switch from uncontrolled to controlled (or vice versa).', "Decide between using a controlled or uncontrolled ".concat(name, " ") + 'element for the lifetime of the component.', "The nature of the state is determined during the first render, it's considered controlled if the value is not `undefined`.", 'More info: https://fb.me/react-controlled-components'].join('\n'));
	      }
	    }, [controlled]);
	
	    var _React$useRef2 = React.useRef(defaultProp),
	        defaultValue = _React$useRef2.current;
	
	    React.useEffect(function () {
	      if (!isControlled && defaultValue !== defaultProp) {
	        console.error(["Material-UI: A component is changing the default ".concat(state, " state of an uncontrolled ").concat(name, " after being initialized. ") + "To suppress this warning opt to use a controlled ".concat(name, ".")].join('\n'));
	      }
	    }, [JSON.stringify(defaultProp)]);
	  }
	
	  var setValueIfUncontrolled = React.useCallback(function (newValue) {
	    if (!isControlled) {
	      setValue(newValue);
	    }
	  }, []);
	  return [value, setValueIfUncontrolled];
	}

/***/ },
/* 333 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.teardown = teardown;
	exports.default = useIsFocusVisible;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(43));
	
	// based on https://github.com/WICG/focus-visible/blob/v4.1.5/src/focus-visible.js
	var hadKeyboardEvent = true;
	var hadFocusVisibleRecently = false;
	var hadFocusVisibleRecentlyTimeout = null;
	var inputTypesWhitelist = {
	  text: true,
	  search: true,
	  url: true,
	  tel: true,
	  email: true,
	  password: true,
	  number: true,
	  date: true,
	  month: true,
	  week: true,
	  time: true,
	  datetime: true,
	  'datetime-local': true
	};
	/**
	 * Computes whether the given element should automatically trigger the
	 * `focus-visible` class being added, i.e. whether it should always match
	 * `:focus-visible` when focused.
	 * @param {Element} node
	 * @return {boolean}
	 */
	
	function focusTriggersKeyboardModality(node) {
	  var type = node.type,
	      tagName = node.tagName;
	
	  if (tagName === 'INPUT' && inputTypesWhitelist[type] && !node.readOnly) {
	    return true;
	  }
	
	  if (tagName === 'TEXTAREA' && !node.readOnly) {
	    return true;
	  }
	
	  if (node.isContentEditable) {
	    return true;
	  }
	
	  return false;
	}
	/**
	 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
	 * If the most recent user interaction was via the keyboard;
	 * and the key press did not include a meta, alt/option, or control key;
	 * then the modality is keyboard. Otherwise, the modality is not keyboard.
	 * @param {KeyboardEvent} event
	 */
	
	
	function handleKeyDown(event) {
	  if (event.metaKey || event.altKey || event.ctrlKey) {
	    return;
	  }
	
	  hadKeyboardEvent = true;
	}
	/**
	 * If at any point a user clicks with a pointing device, ensure that we change
	 * the modality away from keyboard.
	 * This avoids the situation where a user presses a key on an already focused
	 * element, and then clicks on a different element, focusing it with a
	 * pointing device, while we still think we're in keyboard modality.
	 */
	
	
	function handlePointerDown() {
	  hadKeyboardEvent = false;
	}
	
	function handleVisibilityChange() {
	  if (this.visibilityState === 'hidden') {
	    // If the tab becomes active again, the browser will handle calling focus
	    // on the element (Safari actually calls it twice).
	    // If this tab change caused a blur on an element with focus-visible,
	    // re-apply the class when the user switches back to the tab.
	    if (hadFocusVisibleRecently) {
	      hadKeyboardEvent = true;
	    }
	  }
	}
	
	function prepare(doc) {
	  doc.addEventListener('keydown', handleKeyDown, true);
	  doc.addEventListener('mousedown', handlePointerDown, true);
	  doc.addEventListener('pointerdown', handlePointerDown, true);
	  doc.addEventListener('touchstart', handlePointerDown, true);
	  doc.addEventListener('visibilitychange', handleVisibilityChange, true);
	}
	
	function teardown(doc) {
	  doc.removeEventListener('keydown', handleKeyDown, true);
	  doc.removeEventListener('mousedown', handlePointerDown, true);
	  doc.removeEventListener('pointerdown', handlePointerDown, true);
	  doc.removeEventListener('touchstart', handlePointerDown, true);
	  doc.removeEventListener('visibilitychange', handleVisibilityChange, true);
	}
	
	function isFocusVisible(event) {
	  var target = event.target;
	
	  try {
	    return target.matches(':focus-visible');
	  } catch (error) {} // browsers not implementing :focus-visible will throw a SyntaxError
	  // we use our own heuristic for those browsers
	  // rethrow might be better if it's not the expected error but do we really
	  // want to crash if focus-visible malfunctioned?
	  // no need for validFocusTarget check. the user does that by attaching it to
	  // focusable events only
	
	
	  return hadKeyboardEvent || focusTriggersKeyboardModality(target);
	}
	/**
	 * Should be called if a blur event is fired on a focus-visible element
	 */
	
	
	function handleBlurVisible() {
	  // To detect a tab/window switch, we look for a blur event followed
	  // rapidly by a visibility change.
	  // If we don't see a visibility change within 100ms, it's probably a
	  // regular focus change.
	  hadFocusVisibleRecently = true;
	  window.clearTimeout(hadFocusVisibleRecentlyTimeout);
	  hadFocusVisibleRecentlyTimeout = window.setTimeout(function () {
	    hadFocusVisibleRecently = false;
	  }, 100);
	}
	
	function useIsFocusVisible() {
	  var ref = React.useCallback(function (instance) {
	    var node = ReactDOM.findDOMNode(instance);
	
	    if (node != null) {
	      prepare(node.ownerDocument);
	    }
	  }, []);
	
	  if (false) {
	    // eslint-disable-next-line react-hooks/rules-of-hooks
	    React.useDebugValue(isFocusVisible);
	  }
	
	  return {
	    isFocusVisible: isFocusVisible,
	    onBlurVisible: handleBlurVisible,
	    ref: ref
	  };
	}

/***/ },
/* 334 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var hasSymbol = typeof Symbol === 'function' && Symbol.for;
	
	var _default = hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__';
	
	exports.default = _default;

/***/ },
/* 335 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	// We use the same empty object to ref count the styles that don't need a theme object.
	var noopTheme = {};
	var _default = noopTheme;
	exports.default = _default;

/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _getThemeProps.default;
	  }
	});
	
	var _getThemeProps = _interopRequireDefault(__webpack_require__(799));

/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _jssPreset.default;
	  }
	});
	
	var _jssPreset = _interopRequireDefault(__webpack_require__(800));

/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _mergeClasses.default;
	  }
	});
	
	var _mergeClasses = _interopRequireDefault(__webpack_require__(804));

/***/ },
/* 339 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var ThemeContext = _react.default.createContext(null);
	
	if (false) {
	  ThemeContext.displayName = 'ThemeContext';
	}
	
	var _default = ThemeContext;
	exports.default = _default;

/***/ },
/* 340 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var responsivePropType =  false ? _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string, _propTypes.default.object, _propTypes.default.array]) : {};
	var _default = responsivePropType;
	exports.default = _default;

/***/ },
/* 341 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var _progress_pakoEsm = __webpack_require__(843);
	
	var Class = function Class () {};
	
	var Observable = (function (Class$$1) {
	    function Observable() {
	        Class$$1.call(this);
	
	        this._events = {};
	    }
	
	    if ( Class$$1 ) Observable.__proto__ = Class$$1;
	    Observable.prototype = Object.create( Class$$1 && Class$$1.prototype );
	    Observable.prototype.constructor = Observable;
	
	    Observable.prototype.bind = function bind (eventName, handlers, one) {
	        var arguments$1 = arguments;
	        var this$1 = this;
	
	        var eventNames = getArray(eventName);
	        var handlersIsFunction = isFunction(handlers);
	        var length = eventNames.length;
	
	        if (handlers === undefined) {
	            for (var field in eventName) {
	                this$1.bind(field, eventName[field]);
	            }
	            return this;
	        }
	
	        var loop = function ( idx ) {
	            var eventName$1 = eventNames[idx];
	
	            var handler = handlersIsFunction ? handlers : handlers[eventName$1];
	
	            if (handler) {
	                if (one) {
	                    var original = handler;
	                    handler = function () { // eslint-disable-line no-loop-func
	                        this$1.unbind(eventName$1, handler);
	                        original.apply(this$1, arguments$1);
	                    };
	                    handler.original = original;
	                }
	                var events = this$1._events[eventName$1] = this$1._events[eventName$1] || [];
	                events.push(handler);
	            }
	        };
	
	        for (var idx = 0; idx < length; idx++) loop( idx );
	
	        return this;
	    };
	
	    Observable.prototype.one = function one (eventNames, handlers) {
	        return this.bind(eventNames, handlers, true);
	    };
	
	    Observable.prototype.first = function first (eventName, handlers) {
	        var this$1 = this;
	
	        var eventNames = getArray(eventName);
	        var handlersIsFunction = isFunction(handlers);
	
	        for (var idx = 0, length = eventNames.length; idx < length; idx++) {
	            var eventName$1 = eventNames[idx];
	
	            var handler = handlersIsFunction ? handlers : handlers[eventName$1];
	
	            if (handler) {
	                var events = this$1._events[eventName$1] = this$1._events[eventName$1] || [];
	                events.unshift(handler);
	            }
	        }
	
	        return this;
	    };
	
	    Observable.prototype.trigger = function trigger (eventName, e) {
	        var this$1 = this;
	        if ( e === void 0 ) e = {};
	
	        var events = this._events[eventName];
	
	        if (events) {
	            var length = events.length;
	
	            e.sender = this;
	            e._defaultPrevented = false;
	            e.preventDefault = preventDefault;
	            e.isDefaultPrevented = isDefaultPrevented;
	
	            events = events.slice();
	
	            for (var idx = 0; idx < length; idx++) {
	                events[idx].call(this$1, e);
	            }
	
	            return e._defaultPrevented === true;
	        }
	
	        return false;
	    };
	
	    Observable.prototype.unbind = function unbind (eventName, handler) {
	        var events = this._events[eventName];
	
	        if (eventName === undefined) {
	            this._events = {};
	        } else if (events) {
	            if (handler) {
	                for (var idx = events.length - 1; idx >= 0; idx--) {
	                    if (events[idx] === handler || events[idx].original === handler) {
	                        events.splice(idx, 1);
	                    }
	                }
	            } else {
	                this._events[eventName] = [];
	            }
	        }
	
	        return this;
	    };
	
	    return Observable;
	}(Class));
	
	function isFunction(value) {
	    return typeof value === "function";
	}
	
	function getArray(value) {
	    return typeof value === "string" ? [ value ] : value;
	}
	
	function preventDefault() {
	    this._defaultPrevented = true;
	}
	
	function isDefaultPrevented() {
	    return this._defaultPrevented === true;
	}
	
	var animationFrameProxy = function (callback) {
	    var wnd = typeof window !== "undefined" ? window : {};
	    var animationFrame = wnd.requestAnimationFrame ||
	                        wnd.webkitRequestAnimationFrame ||
	                        wnd.mozRequestAnimationFrame ||
	                        wnd.oRequestAnimationFrame ||
	                        wnd.msRequestAnimationFrame ||
	                        function(callback) { setTimeout(callback, 1000 / 60); };
	
	    animationFrameProxy = function (callback) { return animationFrame.call(wnd, callback); };
	    animationFrameProxy(callback);
	};
	
	var animationFrame = animationFrameProxy;
	
	var ampRegExp = /&/g;
	var ltRegExp = /</g;
	var quoteRegExp = /"/g;
	var aposRegExp = /'/g;
	var gtRegExp = />/g;
	
	function htmlEncode(value) {
	    return String(value).replace(ampRegExp, "&amp;").replace(ltRegExp, "&lt;").replace(gtRegExp, "&gt;").replace(quoteRegExp, "&quot;").replace(aposRegExp, "&#39;");
	}
	
	/* eslint-disable no-console */
	
	function logToConsole(message) {
	    var console = window.console;
	
	    if (typeof(console) != "undefined" && console.log) {
	        console.log(message);
	    }
	}
	
	// XXX: the following will not work with IE9 (requires server proxy).
	function saveAs(options) {
	    var dataURI = options.dataURI;
	    var fileName = options.fileName;
	    var data = dataURI;
	
	    if (typeof data == "string" && window.Blob) {
	        var parts = data.split(";base64,");
	        var contentType = parts[0];
	        var base64 = atob(parts[1]);
	        var array = new Uint8Array(base64.length);
	        for (var idx = 0; idx < base64.length; idx++) {
	            array[idx] = base64.charCodeAt(idx);
	        }
	        data = new Blob([ array.buffer ], { type: contentType });
	    }
	    if (navigator.msSaveBlob) {
	        navigator.msSaveBlob(data, fileName);
	    } else {
	        var link = document.createElement("a");
	        link.download = fileName;
	        data = link.href = URL.createObjectURL(data);
	        var e = document.createEvent("MouseEvents");
	        e.initMouseEvent("click", true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
	        link.dispatchEvent(e);
	        setTimeout(function() {
	            URL.revokeObjectURL(data);
	        });
	    }
	}
	
	function matchUserAgent(userAgent) {
	    var browserRxs = {
	        edge: /(edge)[ \/]([\w.]+)/i,
	        webkit: /(chrome)[ \/]([\w.]+)/i,
	        safari: /(webkit)[ \/]([\w.]+)/i,
	        opera: /(opera)(?:.*version|)[ \/]([\w.]+)/i,
	        msie: /(msie\s|trident.*? rv:)([\w.]+)/i,
	        mozilla: /(mozilla)(?:.*? rv:([\w.]+))/i
	    };
	
	    var browser = {};
	
	    for (var agent in browserRxs) {
	        if (browserRxs.hasOwnProperty(agent)) {
	            var match = userAgent.match(browserRxs[agent]);
	            if (match) {
	                browser[agent] = true;
	                browser[match[1].toLowerCase().split(" ")[0].split("/")[0]] = true;
	                browser.version = parseInt(document.documentMode || match[2], 10);
	
	                break;
	            }
	        }
	    }
	
	    return browser;
	}
	
	var browser = null;
	
	var support = {
	    get browser() {
	        if (typeof window === 'undefined' || browser) {
	            return browser;
	        }
	
	        browser = matchUserAgent(window.navigator.userAgent);
	        return browser;
	    }
	};
	
	function template$1() {
	    throw new Error("Template implementation missing.");
	}
	
	var now = Date.now || function() {
	    return new Date().getTime();
	};
	
	function throttle(fn, delay) {
	    var lastExecTime = 0;
	    var timeout;
	
	    if (!delay || delay <= 0) {
	        return fn;
	    }
	
	    var throttled = function() {
	        var elapsed = now() - lastExecTime;
	        var args = arguments;
	
	        var exec = function() {
	            fn.apply(null, args);
	            lastExecTime = now();
	        };
	
	        // first execution
	        if (!lastExecTime) {
	            return exec();
	        }
	
	        if (timeout) {
	            clearTimeout(timeout);
	        }
	
	        if (elapsed > delay) {
	            exec();
	        } else {
	            timeout = setTimeout(exec, delay - elapsed);
	        }
	    };
	
	    throttled.cancel = function() {
	        clearTimeout(timeout);
	    };
	
	    return throttled;
	}
	
	var namedColors = {
	    aliceblue: "f0f8ff", antiquewhite: "faebd7", aqua: "00ffff",
	    aquamarine: "7fffd4", azure: "f0ffff", beige: "f5f5dc",
	    bisque: "ffe4c4", black: "000000", blanchedalmond: "ffebcd",
	    blue: "0000ff", blueviolet: "8a2be2", brown: "a52a2a",
	    burlywood: "deb887", cadetblue: "5f9ea0", chartreuse: "7fff00",
	    chocolate: "d2691e", coral: "ff7f50", cornflowerblue: "6495ed",
	    cornsilk: "fff8dc", crimson: "dc143c", cyan: "00ffff",
	    darkblue: "00008b", darkcyan: "008b8b", darkgoldenrod: "b8860b",
	    darkgray: "a9a9a9", darkgrey: "a9a9a9", darkgreen: "006400",
	    darkkhaki: "bdb76b", darkmagenta: "8b008b", darkolivegreen: "556b2f",
	    darkorange: "ff8c00", darkorchid: "9932cc", darkred: "8b0000",
	    darksalmon: "e9967a", darkseagreen: "8fbc8f", darkslateblue: "483d8b",
	    darkslategray: "2f4f4f", darkslategrey: "2f4f4f", darkturquoise: "00ced1",
	    darkviolet: "9400d3", deeppink: "ff1493", deepskyblue: "00bfff",
	    dimgray: "696969", dimgrey: "696969", dodgerblue: "1e90ff",
	    firebrick: "b22222", floralwhite: "fffaf0", forestgreen: "228b22",
	    fuchsia: "ff00ff", gainsboro: "dcdcdc", ghostwhite: "f8f8ff",
	    gold: "ffd700", goldenrod: "daa520", gray: "808080",
	    grey: "808080", green: "008000", greenyellow: "adff2f",
	    honeydew: "f0fff0", hotpink: "ff69b4", indianred: "cd5c5c",
	    indigo: "4b0082", ivory: "fffff0", khaki: "f0e68c",
	    lavender: "e6e6fa", lavenderblush: "fff0f5", lawngreen: "7cfc00",
	    lemonchiffon: "fffacd", lightblue: "add8e6", lightcoral: "f08080",
	    lightcyan: "e0ffff", lightgoldenrodyellow: "fafad2", lightgray: "d3d3d3",
	    lightgrey: "d3d3d3", lightgreen: "90ee90", lightpink: "ffb6c1",
	    lightsalmon: "ffa07a", lightseagreen: "20b2aa", lightskyblue: "87cefa",
	    lightslategray: "778899", lightslategrey: "778899", lightsteelblue: "b0c4de",
	    lightyellow: "ffffe0", lime: "00ff00", limegreen: "32cd32",
	    linen: "faf0e6", magenta: "ff00ff", maroon: "800000",
	    mediumaquamarine: "66cdaa", mediumblue: "0000cd", mediumorchid: "ba55d3",
	    mediumpurple: "9370d8", mediumseagreen: "3cb371", mediumslateblue: "7b68ee",
	    mediumspringgreen: "00fa9a", mediumturquoise: "48d1cc", mediumvioletred: "c71585",
	    midnightblue: "191970", mintcream: "f5fffa", mistyrose: "ffe4e1",
	    moccasin: "ffe4b5", navajowhite: "ffdead", navy: "000080",
	    oldlace: "fdf5e6", olive: "808000", olivedrab: "6b8e23",
	    orange: "ffa500", orangered: "ff4500", orchid: "da70d6",
	    palegoldenrod: "eee8aa", palegreen: "98fb98", paleturquoise: "afeeee",
	    palevioletred: "d87093", papayawhip: "ffefd5", peachpuff: "ffdab9",
	    peru: "cd853f", pink: "ffc0cb", plum: "dda0dd",
	    powderblue: "b0e0e6", purple: "800080", red: "ff0000",
	    rosybrown: "bc8f8f", royalblue: "4169e1", saddlebrown: "8b4513",
	    salmon: "fa8072", sandybrown: "f4a460", seagreen: "2e8b57",
	    seashell: "fff5ee", sienna: "a0522d", silver: "c0c0c0",
	    skyblue: "87ceeb", slateblue: "6a5acd", slategray: "708090",
	    slategrey: "708090", snow: "fffafa", springgreen: "00ff7f",
	    steelblue: "4682b4", tan: "d2b48c", teal: "008080",
	    thistle: "d8bfd8", tomato: "ff6347", turquoise: "40e0d0",
	    violet: "ee82ee", wheat: "f5deb3", white: "ffffff",
	    whitesmoke: "f5f5f5", yellow: "ffff00", yellowgreen: "9acd32"
	};
	
	var browser$1 = support.browser;
	
	var matchNamedColor = function (color) {
	    var colorNames = Object.keys(namedColors);
	    colorNames.push("transparent");
	
	    var regexp = new RegExp("^(" + colorNames.join("|") + ")(\\W|$)", "i");
	    matchNamedColor = function (color) { return regexp.exec(color); };
	
	    return regexp.exec(color);
	};
	
	var BaseColor = (function (Class$$1) {
	    function BaseColor() { Class$$1.call(this); }
	
	    if ( Class$$1 ) BaseColor.__proto__ = Class$$1;
	    BaseColor.prototype = Object.create( Class$$1 && Class$$1.prototype );
	    BaseColor.prototype.constructor = BaseColor;
	    BaseColor.prototype.toHSV = function toHSV () { return this; };
	
	    BaseColor.prototype.toRGB = function toRGB () { return this; };
	
	    BaseColor.prototype.toHex = function toHex (options) { return this.toBytes().toHex(options); };
	
	    BaseColor.prototype.toBytes = function toBytes () { return this; };
	
	    BaseColor.prototype.toCss = function toCss (options) { return "#" + this.toHex(options); };
	
	    BaseColor.prototype.toCssRgba = function toCssRgba () {
	        var rgb = this.toBytes();
	        return ("rgba(" + (rgb.r) + ", " + (rgb.g) + ", " + (rgb.b) + ", " + (parseFloat((Number(this.a)).toFixed(3))) + ")");
	    };
	
	    BaseColor.prototype.toDisplay = function toDisplay () {
	        if (browser$1.msie && browser$1.version < 9) {
	            return this.toCss(); // no RGBA support; does it support any opacity in colors?
	        }
	        return this.toCssRgba();
	    };
	
	    BaseColor.prototype.equals = function equals (c) {
	        return c === this || ((c !== null && c !== undefined) && this.toCssRgba() === parseColor(c).toCssRgba());
	    };
	
	    BaseColor.prototype.diff = function diff (other) {
	        if (other === null) {
	            return NaN;
	        }
	
	        var c1 = this.toBytes();
	        var c2 = other.toBytes();
	
	        return Math.sqrt(Math.pow((c1.r - c2.r) * 0.30, 2) +
	                         Math.pow((c1.g - c2.g) * 0.59, 2) +
	                         Math.pow((c1.b - c2.b) * 0.11, 2));
	    };
	
	    BaseColor.prototype.clone = function clone () {
	        var c = this.toBytes();
	        if (c === this) {
	            c = new Bytes(c.r, c.g, c.b, c.a);
	        }
	
	        return c;
	    };
	
	    return BaseColor;
	}(Class));
	
	var RGB = (function (BaseColor) {
	    function RGB(r, g, b, a) {
	        BaseColor.call(this);
	
	        this.r = r;
	        this.g = g;
	        this.b = b;
	        this.a = a;
	    }
	
	    if ( BaseColor ) RGB.__proto__ = BaseColor;
	    RGB.prototype = Object.create( BaseColor && BaseColor.prototype );
	    RGB.prototype.constructor = RGB;
	
	    RGB.prototype.toHSV = function toHSV () {
	        var ref = this;
	        var r = ref.r;
	        var g = ref.g;
	        var b = ref.b;
	        var min = Math.min(r, g, b);
	        var max = Math.max(r, g, b);
	        var delta = max - min;
	        var v = max;
	        var h, s;
	
	        if (delta === 0) {
	            return new HSV(0, 0, v, this.a);
	        }
	
	        if (max !== 0) {
	            s = delta / max;
	            if (r === max) {
	                h = (g - b) / delta;
	            } else if (g === max) {
	                h = 2 + (b - r) / delta;
	            } else {
	                h = 4 + (r - g) / delta;
	            }
	
	            h *= 60;
	            if (h < 0) {
	                h += 360;
	            }
	        } else {
	            s = 0;
	            h = -1;
	        }
	
	        return new HSV(h, s, v, this.a);
	    };
	
	    RGB.prototype.toHSL = function toHSL () {
	        var ref = this;
	        var r = ref.r;
	        var g = ref.g;
	        var b = ref.b;
	        var max = Math.max(r, g, b);
	        var min = Math.min(r, g, b);
	        var h, s, l = (max + min) / 2;
	
	        if (max === min) {
	            h = s = 0;
	        } else {
	            var d = max - min;
	            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
	            switch (max) {
	            case r: h = (g - b) / d + (g < b ? 6 : 0); break;
	            case g: h = (b - r) / d + 2; break;
	            case b: h = (r - g) / d + 4; break;
	            default: break;
	            }
	        }
	
	        return new HSL(h * 60, s * 100, l * 100, this.a);
	    };
	
	    RGB.prototype.toBytes = function toBytes () {
	        return new Bytes(this.r * 255, this.g * 255, this.b * 255, this.a);
	    };
	
	    return RGB;
	}(BaseColor));
	
	var Bytes = (function (RGB) {
	    function Bytes(r, g, b, a) {
	        RGB.call(this, Math.round(r), Math.round(g), Math.round(b), a);
	    }
	
	    if ( RGB ) Bytes.__proto__ = RGB;
	    Bytes.prototype = Object.create( RGB && RGB.prototype );
	    Bytes.prototype.constructor = Bytes;
	
	    Bytes.prototype.toRGB = function toRGB () {
	        return new RGB(this.r / 255, this.g / 255, this.b / 255, this.a);
	    };
	
	    Bytes.prototype.toHSV = function toHSV () {
	        return this.toRGB().toHSV();
	    };
	
	    Bytes.prototype.toHSL = function toHSL () {
	        return this.toRGB().toHSL();
	    };
	
	    Bytes.prototype.toHex = function toHex (options) {
	        var value = hex(this.r, 2) + hex(this.g, 2) + hex(this.b, 2);
	
	        if (options && options.alpha) {
	            value += hex(Math.round(this.a * 255), 2);
	        }
	
	        return value;
	    };
	
	    Bytes.prototype.toBytes = function toBytes () {
	        return this;
	    };
	
	    return Bytes;
	}(RGB));
	
	function hex(n, width, pad) {
	    if ( pad === void 0 ) pad = "0";
	
	    var result = n.toString(16);
	    while (width > result.length) {
	        result = pad + result;
	    }
	
	    return result;
	}
	
	var HSV = (function (BaseColor) {
	    function HSV(h, s, v, a) {
	        BaseColor.call(this);
	
	        this.h = h;
	        this.s = s;
	        this.v = v;
	        this.a = a;
	    }
	
	    if ( BaseColor ) HSV.__proto__ = BaseColor;
	    HSV.prototype = Object.create( BaseColor && BaseColor.prototype );
	    HSV.prototype.constructor = HSV;
	
	    HSV.prototype.toRGB = function toRGB () {
	        var ref = this;
	        var h = ref.h;
	        var s = ref.s;
	        var v = ref.v;
	        var r, g, b;
	
	        if (s === 0) {
	            r = g = b = v;
	        } else {
	            h /= 60;
	
	            var i = Math.floor(h);
	            var f = h - i;
	            var p = v * (1 - s);
	            var q = v * (1 - s * f);
	            var t = v * (1 - s * (1 - f));
	
	            switch (i) {
	            case 0: r = v; g = t; b = p; break;
	            case 1: r = q; g = v; b = p; break;
	            case 2: r = p; g = v; b = t; break;
	            case 3: r = p; g = q; b = v; break;
	            case 4: r = t; g = p; b = v; break;
	            default: r = v; g = p; b = q; break;
	            }
	        }
	
	        return new RGB(r, g, b, this.a);
	    };
	
	    HSV.prototype.toHSL = function toHSL () {
	        return this.toRGB().toHSL();
	    };
	
	    HSV.prototype.toBytes = function toBytes () {
	        return this.toRGB().toBytes();
	    };
	
	    return HSV;
	}(BaseColor));
	
	var HSL = (function (BaseColor) {
	    function HSL(h, s, l, a) {
	        BaseColor.call(this);
	
	        this.h = h;
	        this.s = s;
	        this.l = l;
	        this.a = a;
	    }
	
	    if ( BaseColor ) HSL.__proto__ = BaseColor;
	    HSL.prototype = Object.create( BaseColor && BaseColor.prototype );
	    HSL.prototype.constructor = HSL;
	
	    HSL.prototype.toRGB = function toRGB () {
	        var h = this.h / 360;
	        var s = this.s / 100;
	        var l = this.l / 100;
	        var r, g, b;
	
	        if (s === 0) {
	            r = g = b = l; // achromatic
	        } else {
	            var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
	            var p = 2 * l - q;
	            r = hue2rgb(p, q, h + 1 / 3);
	            g = hue2rgb(p, q, h);
	            b = hue2rgb(p, q, h - 1 / 3);
	        }
	
	        return new RGB(r, g, b, this.a);
	    };
	
	    HSL.prototype.toHSV = function toHSV () {
	        return this.toRGB().toHSV();
	    };
	
	    HSL.prototype.toBytes = function toBytes () {
	        return this.toRGB().toBytes();
	    };
	
	    return HSL;
	}(BaseColor));
	
	function hue2rgb(p, q, s) {
	    var t = s;
	
	    if (t < 0) {
	        t += 1;
	    }
	
	    if (t > 1) {
	        t -= 1;
	    }
	
	    if (t < 1 / 6) {
	        return p + (q - p) * 6 * t;
	    }
	
	    if (t < 1 / 2) {
	        return q;
	    }
	
	    if (t < 2 / 3) {
	        return p + (q - p) * (2 / 3 - t) * 6;
	    }
	
	    return p;
	}
	
	function alphaFromHex(a) {
	    return parseFloat(parseFloat(parseInt(a, 16) / 255 ).toFixed(3));
	}
	
	function parseColor(value, safe) {
	    var m, ret;
	
	    if (value == null || value === "none") {
	        return null;
	    }
	
	    if (value instanceof BaseColor) {
	        return value;
	    }
	
	    var color = value.toLowerCase();
	    if ((m = matchNamedColor(color))) {
	        if (m[1] === "transparent") {
	            color = new RGB(1, 1, 1, 0);
	        } else {
	            color = parseColor(namedColors[m[1]], safe);
	        }
	        color.match = [ m[1] ];
	        return color;
	    }
	    if ((m = /^#?([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})\b/i.exec(color))) {
	        ret = new Bytes(parseInt(m[1], 16),
	            parseInt(m[2], 16),
	            parseInt(m[3], 16), 1);
	    } else if ((m = /^#?([0-9a-f])([0-9a-f])([0-9a-f])\b/i.exec(color))) {
	        ret = new Bytes(parseInt(m[1] + m[1], 16),
	            parseInt(m[2] + m[2], 16),
	            parseInt(m[3] + m[3], 16), 1);
	    } else if ((m = /^#?([0-9a-f])([0-9a-f])([0-9a-f])([0-9a-f])\b/i.exec(color))) { // Parse 4 digit hex color
	        ret = new Bytes(parseInt(m[1] + m[1], 16),
	            parseInt(m[2] + m[2], 16),
	            parseInt(m[3] + m[3], 16),
	            alphaFromHex(m[4] + m[4]));
	    } else if ((m = /^#?([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})\b/i.exec(color))) { // Parse 8 digit hex color
	        ret = new Bytes(parseInt(m[1], 16),
	            parseInt(m[2], 16),
	            parseInt(m[3], 16),
	            alphaFromHex(m[4]));
	    } else if ((m = /^rgb\(\s*([0-9]+)\s*,\s*([0-9]+)\s*,\s*([0-9]+)\s*\)/.exec(color))) {
	        ret = new Bytes(parseInt(m[1], 10),
	            parseInt(m[2], 10),
	            parseInt(m[3], 10), 1);
	    } else if ((m = /^rgba\(\s*([0-9]+)\s*,\s*([0-9]+)\s*,\s*([0-9]+)\s*,\s*([0-9.]+)\s*\)/.exec(color))) {
	        ret = new Bytes(parseInt(m[1], 10),
	            parseInt(m[2], 10),
	            parseInt(m[3], 10), parseFloat(m[4]));
	    } else if ((m = /^rgb\(\s*([0-9]*\.?[0-9]+)%\s*,\s*([0-9]*\.?[0-9]+)%\s*,\s*([0-9]*\.?[0-9]+)%\s*\)/.exec(color))) {
	        ret = new RGB(parseFloat(m[1]) / 100,
	            parseFloat(m[2]) / 100,
	            parseFloat(m[3]) / 100, 1);
	    } else if ((m = /^rgba\(\s*([0-9]*\.?[0-9]+)%\s*,\s*([0-9]*\.?[0-9]+)%\s*,\s*([0-9]*\.?[0-9]+)%\s*,\s*([0-9.]+)\s*\)/.exec(color))) {
	        ret = new RGB(parseFloat(m[1]) / 100,
	            parseFloat(m[2]) / 100,
	            parseFloat(m[3]) / 100, parseFloat(m[4]));
	    }
	
	    if (ret) {
	        ret.match = m;
	    } else if (!safe) {
	        throw new Error("Cannot parse color: " + color);
	    }
	
	    return ret;
	}
	
	var DARK_TRESHOLD = 180;
	
	var Color = (function (Class$$1) {
	    function Color(value) {
	        var this$1 = this;
	
	        Class$$1.call(this);
	
	        if (arguments.length === 1) {
	            var formats = Color.formats;
	            var resolvedColor = this.resolveColor(value);
	
	            for (var idx = 0; idx < formats.length; idx++) {
	                var formatRegex = formats[idx].re;
	                var processor = formats[idx].process;
	                var parts = formatRegex.exec(resolvedColor);
	
	                if (parts) {
	                    var channels = processor(parts);
	                    this$1.r = channels[0];
	                    this$1.g = channels[1];
	                    this$1.b = channels[2];
	                }
	            }
	        } else {
	            this.r = arguments[0];
	            this.g = arguments[1];
	            this.b = arguments[2];
	        }
	
	        this.r = this.normalizeByte(this.r);
	        this.g = this.normalizeByte(this.g);
	        this.b = this.normalizeByte(this.b);
	    }
	
	    if ( Class$$1 ) Color.__proto__ = Class$$1;
	    Color.prototype = Object.create( Class$$1 && Class$$1.prototype );
	    Color.prototype.constructor = Color;
	
	    Color.prototype.toHex = function toHex () {
	        var pad = this.padDigit;
	        var r = this.r.toString(16);
	        var g = this.g.toString(16);
	        var b = this.b.toString(16);
	
	        return "#" + pad(r) + pad(g) + pad(b);
	    };
	
	    Color.prototype.resolveColor = function resolveColor (value) {
	        var color = value || "black";
	
	        if (color.charAt(0) === "#") {
	            color = color.substr(1, 6);
	        }
	
	        color = color.replace(/ /g, "");
	        color = color.toLowerCase();
	        color = Color.namedColors[color] || color;
	
	        return color;
	    };
	
	    Color.prototype.normalizeByte = function normalizeByte (value) {
	        if (value < 0 || isNaN(value)) {
	            return 0;
	        }
	
	        return value > 255 ? 255 : value;
	    };
	
	    Color.prototype.padDigit = function padDigit (value) {
	        return (value.length === 1) ? "0" + value : value;
	    };
	
	    Color.prototype.brightness = function brightness (value) {
	        var round = Math.round;
	
	        this.r = round(this.normalizeByte(this.r * value));
	        this.g = round(this.normalizeByte(this.g * value));
	        this.b = round(this.normalizeByte(this.b * value));
	
	        return this;
	    };
	
	    Color.prototype.percBrightness = function percBrightness () {
	        return Math.sqrt(0.241 * this.r * this.r + 0.691 * this.g * this.g + 0.068 * this.b * this.b);
	    };
	
	    Color.prototype.isDark = function isDark () {
	        return this.percBrightness() < DARK_TRESHOLD;
	    };
	
	    Color.fromBytes = function fromBytes (r, g, b, a) {
	        return new Bytes(r, g, b, a != null ? a : 1);
	    };
	
	    Color.fromRGB = function fromRGB (r, g, b, a) {
	        return new RGB(r, g, b, a != null ? a : 1);
	    };
	
	    Color.fromHSV = function fromHSV (h, s, v, a) {
	        return new HSV(h, s, v, a != null ? a : 1);
	    };
	
	    Color.fromHSL = function fromHSL (h, s, l, a) {
	        return new HSL(h, s, l, a != null ? a : 1);
	    };
	
	    return Color;
	}(Class));
	
	Color.formats = [ {
	    re: /^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/,
	    process: function(parts) {
	        return [
	            parseInt(parts[1], 10), parseInt(parts[2], 10), parseInt(parts[3], 10)
	        ];
	    }
	}, {
	    re: /^(\w{2})(\w{2})(\w{2})$/,
	    process: function(parts) {
	        return [
	            parseInt(parts[1], 16), parseInt(parts[2], 16), parseInt(parts[3], 16)
	        ];
	    }
	}, {
	    re: /^(\w{1})(\w{1})(\w{1})$/,
	    process: function(parts) {
	        return [
	            parseInt(parts[1] + parts[1], 16),
	            parseInt(parts[2] + parts[2], 16),
	            parseInt(parts[3] + parts[3], 16)
	        ];
	    }
	} ];
	
	Color.namedColors = namedColors;
	
	var HasObservers = (function (Class$$1) {
	    function HasObservers () {
	        Class$$1.apply(this, arguments);
	    }
	
	    if ( Class$$1 ) HasObservers.__proto__ = Class$$1;
	    HasObservers.prototype = Object.create( Class$$1 && Class$$1.prototype );
	    HasObservers.prototype.constructor = HasObservers;
	
	    HasObservers.prototype.observers = function observers () {
	        this._observers = this._observers || [];
	        return this._observers;
	    };
	
	    HasObservers.prototype.addObserver = function addObserver (element) {
	        if (!this._observers) {
	            this._observers = [ element ];
	        } else {
	            this._observers.push(element);
	        }
	        return this;
	    };
	
	    HasObservers.prototype.removeObserver = function removeObserver (element) {
	        var observers = this.observers();
	        var index = observers.indexOf(element);
	        if (index !== -1) {
	            observers.splice(index, 1);
	        }
	        return this;
	    };
	
	    HasObservers.prototype.trigger = function trigger (methodName, event) {
	        var observers = this._observers;
	
	        if (observers && !this._suspended) {
	            for (var idx = 0; idx < observers.length; idx++) {
	                var observer = observers[idx];
	                if (observer[methodName]) {
	                    observer[methodName](event);
	                }
	            }
	        }
	        return this;
	    };
	
	    HasObservers.prototype.optionsChange = function optionsChange (e) {
	        if ( e === void 0 ) e = {};
	
	        e.element = this;
	        this.trigger("optionsChange", e);
	    };
	
	    HasObservers.prototype.geometryChange = function geometryChange () {
	        this.trigger("geometryChange", {
	            element: this
	        });
	    };
	
	    HasObservers.prototype.suspend = function suspend () {
	        this._suspended = (this._suspended || 0) + 1;
	        return this;
	    };
	
	    HasObservers.prototype.resume = function resume () {
	        this._suspended = Math.max((this._suspended || 0) - 1, 0);
	        return this;
	    };
	
	    HasObservers.prototype._observerField = function _observerField (field, value) {
	        if (this[field]) {
	            this[field].removeObserver(this);
	        }
	        this[field] = value;
	        value.addObserver(this);
	    };
	
	    return HasObservers;
	}(Class));
	
	function append$1$1(first, second) {
	    first.push.apply(first, second);
	    return first;
	}
	
	/* eslint-disable key-spacing,no-multi-spaces,no-param-reassign */
	
	var literals = {
	    1    : "i",       10   : "x",       100  : "c",
	    2    : "ii",      20   : "xx",      200  : "cc",
	    3    : "iii",     30   : "xxx",     300  : "ccc",
	    4    : "iv",      40   : "xl",      400  : "cd",
	    5    : "v",       50   : "l",       500  : "d",
	    6    : "vi",      60   : "lx",      600  : "dc",
	    7    : "vii",     70   : "lxx",     700  : "dcc",
	    8    : "viii",    80   : "lxxx",    800  : "dccc",
	    9    : "ix",      90   : "xc",      900  : "cm",
	    1000 : "m"
	};
	
	function arabicToRoman(n) {
	    var values = [ 1000,
	        900 , 800, 700, 600, 500, 400, 300, 200, 100,
	        90  , 80 , 70 , 60 , 50 , 40 , 30 , 20 , 10 ,
	        9   , 8  , 7  , 6  , 5  , 4  , 3  , 2  , 1 ];
	
	    var roman = "";
	    while (n > 0) {
	        if (n < values[0]) {
	            values.shift();
	        } else {
	            roman += literals[values[0]];
	            n -= values[0];
	        }
	    }
	    return roman;
	}
	
	function createPromise() {
	    var resolveFn, rejectFn;
	    var promise = new Promise(function (resolve, reject) {
	        resolveFn = function (data) {
	            promise._state = "resolved";
	            resolve(data);
	            return promise;
	        };
	        rejectFn = function (data) {
	            promise._state = "rejected";
	            reject(data);
	
	            return promise;
	        };
	    });
	    promise._state = "pending";
	    promise.resolve = resolveFn;
	    promise.reject = rejectFn;
	    promise.state = function () { return promise._state; };
	
	    return promise;
	}
	
	var UNDEFINED = "undefined";
	
	function defined(value) {
	    return typeof value !== UNDEFINED;
	}
	
	var defId = 1;
	
	function definitionId() {
	    return "kdef" + defId++;
	}
	
	var DEG_TO_RAD = Math.PI / 180;
	var MAX_NUM = Number.MAX_VALUE;
	var MIN_NUM = -Number.MAX_VALUE;
	
	function deg(radians) {
	    return radians / DEG_TO_RAD;
	}
	
	var fromCharCode = String.fromCharCode;
	
	var BOM = '\xfe\xff';
	
	// Encodes a string as UTF-8
	function encodeUTF8(input) {
	    var output = "";
	
	    for (var i = 0; i < input.length; i++) {
	        var code = input.charCodeAt(i);
	
	        if (0xD800 <= code && code <= 0xDBFF) {
	            var hi = code;
	            var low = input.charCodeAt(++i);
	
	            if (!isNaN(low)) {
	                // Combine high and low surrogate
	                // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/charCodeAt
	                code = (hi - 0xD800) * 0x400 +
	                       (low - 0xDC00) + 0x10000;
	            }
	        }
	
	        if (code < 0x80) {
	            // One byte
	            output += fromCharCode(code);
	        } else if (code < 0x800) {
	            // Two bytes
	            output += fromCharCode(0xC0 | (code >>> 6));
	            output += fromCharCode(0x80 | (code & 0x3f));
	        } else if (code < 0x10000) {
	            // Three bytes
	            output += fromCharCode(0xE0 | (code >>> 12));
	            output += fromCharCode(0x80 | (code >>> 6 & 0x3f));
	            output += fromCharCode(0x80 | (code & 0x3f));
	        } else if (code < 0x10FFFF) {
	            // Four bytes
	            output += fromCharCode(0xF0 | (code >>> 18));
	            output += fromCharCode(0x80 | (code >>> 12 & 0x3f));
	            output += fromCharCode(0x80 | (code >>> 6 & 0x3f));
	            output += fromCharCode(0x80 | (code & 0x3f));
	        }
	    }
	
	    return output;
	}
	
	function encodeUnit(codeUnit) {
	    return fromCharCode(codeUnit >> 8) + fromCharCode(codeUnit & 0x00ff);
	}
	
	// Encodes a string as UTF-16 big-endian
	function encodeUTF16BE(input) {
	    var output = '';
	
	    for (var i = 0; i < input.length; i++) {
	        var c = input.charCodeAt(i);
	
	        if (c < 0xFFFF) {
	            output += encodeUnit(c);
	        } else {
	            var lead = ((c - 0x10000) >> 10) + 0xD800;
	            var trail = ((c - 0x10000) & 0x3FF) + 0xDC00;
	            output += encodeUnit(lead);
	            output += encodeUnit(trail);
	        }
	    }
	
	    return output;
	}
	
	var KEY_STR = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
	
	function encodeBase64(input) {
	    var output = "";
	    var i = 0;
	
	    var utfInput = encodeUTF8(input);
	
	    while (i < utfInput.length) {
	        var chr1 = utfInput.charCodeAt(i++);
	        var chr2 = utfInput.charCodeAt(i++);
	        var chr3 = utfInput.charCodeAt(i++);
	
	        var enc1 = chr1 >> 2;
	        var enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
	        var enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
	        var enc4 = chr3 & 63;
	
	        if (isNaN(chr2)) {
	            enc3 = enc4 = 64;
	        } else if (isNaN(chr3)) {
	            enc4 = 64;
	        }
	
	        output = output +
	            KEY_STR.charAt(enc1) + KEY_STR.charAt(enc2) +
	            KEY_STR.charAt(enc3) + KEY_STR.charAt(enc4);
	    }
	
	    return output;
	}
	
	function eventCoordinates(e) {
	    if (defined((e.x || {}).location)) {
	        return {
	            x: e.x.location,
	            y: e.y.location
	        };
	    }
	
	    return {
	        x: e.pageX || e.clientX || 0,
	        y: e.pageY || e.clientY || 0
	    };
	}
	
	function eventElement(e) {
	    if ( e === void 0 ) e = {};
	
	    return e.touch ? e.touch.initialTouch : e.target;
	}
	
	function isTransparent(color) {
	    return color === "" || color === null || color === "none" || color === "transparent" || !defined(color);
	}
	
	function last(array) {
	    if (array) {
	        return array[array.length - 1];
	    }
	}
	
	function limitValue(value, min, max) {
	    return Math.max(Math.min(value, max), min);
	}
	
	/* eslint-disable no-multi-spaces, key-spacing, indent, camelcase, space-before-blocks, eqeqeq, brace-style */
	/* eslint-disable space-infix-ops, space-before-function-paren, array-bracket-spacing, object-curly-spacing */
	/* eslint-disable no-nested-ternary, max-params, default-case, no-else-return, no-empty */
	/* eslint-disable no-param-reassign, no-var, block-scoped-var */
	
	// mergeSort is stable.
	function mergeSort(a, cmp) {
	    if (a.length < 2) {
	        return a.slice();
	    }
	    function merge(a, b) {
	        var r = [], ai = 0, bi = 0, i = 0;
	        while (ai < a.length && bi < b.length) {
	            if (cmp(a[ai], b[bi]) <= 0) {
	                r[i++] = a[ai++];
	            } else {
	                r[i++] = b[bi++];
	            }
	        }
	        if (ai < a.length) {
	            r.push.apply(r, a.slice(ai));
	        }
	        if (bi < b.length) {
	            r.push.apply(r, b.slice(bi));
	        }
	        return r;
	    }
	    return (function sort(a) {
	        if (a.length <= 1) {
	            return a;
	        }
	        var m = Math.floor(a.length / 2);
	        var left = a.slice(0, m);
	        var right = a.slice(m);
	        left = sort(left);
	        right = sort(right);
	        return merge(left, right);
	    })(a);
	}
	
	function promiseAll(promises) {
	    return Promise.all(promises);
	}
	
	function rad(degrees) {
	    return degrees * DEG_TO_RAD;
	}
	
	function pow(p) {
	    if (p) {
	        return Math.pow(10, p);
	    }
	
	    return 1;
	}
	
	function round(value, precision) {
	    var power = pow(precision);
	    return Math.round(value * power) / power;
	}
	
	function valueOrDefault(value, defaultValue) {
	    return defined(value) ? value : defaultValue;
	}
	
	function bindEvents(element, events) {
	    for (var eventName in events) {
	        var eventNames = eventName.trim().split(" ");
	        for (var idx = 0; idx < eventNames.length; idx++) {
	            element.addEventListener(eventNames[idx], events[eventName], false);
	        }
	    }
	}
	
	function elementOffset(element) {
	    var box = element.getBoundingClientRect();
	
	    var documentElement = document.documentElement;
	
	    return {
	        top: box.top + (window.pageYOffset || documentElement.scrollTop) - (documentElement.clientTop || 0),
	        left: box.left + (window.pageXOffset || documentElement.scrollLeft) - (documentElement.clientLeft || 0)
	    };
	}
	
	function elementStyles(element, styles) {
	    var result = {};
	    var style = window.getComputedStyle(element) || {};
	    var stylesArray = Array.isArray(styles) ? styles : [ styles ];
	
	    for (var idx = 0; idx < stylesArray.length; idx++) {
	        var field = stylesArray[idx];
	        result[field] = style[field];
	    }
	
	    return result;
	}
	
	function getPixels(value) {
	    if (isNaN(value)) {
	        return value;
	    }
	    return value + "px";
	}
	
	function elementSize(element, size) {
	    if (size) {
	        var width = size.width;
	        var height = size.height;
	
	        if (defined(width)) {
	            element.style.width = getPixels(width);
	        }
	
	        if (defined(height)) {
	            element.style.height = getPixels(height);
	        }
	
	    } else {
	        var size$1 = elementStyles(element, [ 'width', 'height' ]);
	
	        return {
	            width: parseInt(size$1.width, 10),
	            height: parseInt(size$1.height, 10)
	        };
	    }
	}
	
	function unbindEvents(element, events) {
	    if ( events === void 0 ) events = {};
	
	    for (var name in events) {
	        var eventNames = name.trim().split(" ");
	        for (var idx = 0; idx < eventNames.length; idx++) {
	            element.removeEventListener(eventNames[idx], events[name], false);
	        }
	    }
	}
	
	function elementPadding(element) {
	    var ref = elementStyles(element, [ "paddingLeft", "paddingTop" ]);
	    var paddingLeft = ref.paddingLeft;
	    var paddingTop = ref.paddingTop;
	    return {
	        top: parseFloat(paddingTop),
	        left: parseFloat(paddingLeft)
	    };
	}
	
	var Matrix = (function (Class$$1) {
	    function Matrix(a, b, c, d, e, f) {
	        if ( a === void 0 ) a = 0;
	        if ( b === void 0 ) b = 0;
	        if ( c === void 0 ) c = 0;
	        if ( d === void 0 ) d = 0;
	        if ( e === void 0 ) e = 0;
	        if ( f === void 0 ) f = 0;
	
	        Class$$1.call(this);
	
	        this.a = a;
	        this.b = b;
	        this.c = c;
	        this.d = d;
	        this.e = e;
	        this.f = f;
	    }
	
	    if ( Class$$1 ) Matrix.__proto__ = Class$$1;
	    Matrix.prototype = Object.create( Class$$1 && Class$$1.prototype );
	    Matrix.prototype.constructor = Matrix;
	
	    Matrix.prototype.multiplyCopy = function multiplyCopy (matrix) {
	        return new Matrix(
	            this.a * matrix.a + this.c * matrix.b,
	            this.b * matrix.a + this.d * matrix.b,
	            this.a * matrix.c + this.c * matrix.d,
	            this.b * matrix.c + this.d * matrix.d,
	            this.a * matrix.e + this.c * matrix.f + this.e,
	            this.b * matrix.e + this.d * matrix.f + this.f
	        );
	    };
	
	    Matrix.prototype.invert = function invert () {
	        var ref = this;
	        var a = ref.a;
	        var b = ref.b;
	        var d = ref.c;
	        var e = ref.d;
	        var g = ref.e;
	        var h = ref.f;
	        var det = a * e - b * d;
	
	        if (det === 0) {
	            return null;
	        }
	
	        return new Matrix(e / det, -b / det, -d / det, a / det,
	            (d * h - e * g) / det, (b * g - a * h) / det);
	    };
	
	    Matrix.prototype.clone = function clone () {
	        return new Matrix(this.a, this.b, this.c, this.d, this.e, this.f);
	    };
	
	    Matrix.prototype.equals = function equals (other) {
	        if (!other) {
	            return false;
	        }
	
	        return this.a === other.a && this.b === other.b &&
	            this.c === other.c && this.d === other.d &&
	            this.e === other.e && this.f === other.f;
	    };
	
	    Matrix.prototype.round = function round$1 (precision) {
	        this.a = round(this.a, precision);
	        this.b = round(this.b, precision);
	        this.c = round(this.c, precision);
	        this.d = round(this.d, precision);
	        this.e = round(this.e, precision);
	        this.f = round(this.f, precision);
	
	        return this;
	    };
	
	    Matrix.prototype.toArray = function toArray (precision) {
	        var result = [ this.a, this.b, this.c, this.d, this.e, this.f ];
	
	        if (defined(precision)) {
	            for (var i = 0; i < result.length; i++) {
	                result[i] = round(result[i], precision);
	            }
	        }
	
	        return result;
	    };
	
	    Matrix.prototype.toString = function toString (precision, separator) {
	        if ( separator === void 0 ) separator = ",";
	
	        return this.toArray(precision).join(separator);
	    };
	
	    Matrix.translate = function translate (x, y) {
	        return new Matrix(1, 0, 0, 1, x, y);
	    };
	
	    Matrix.unit = function unit () {
	        return new Matrix(1, 0, 0, 1, 0, 0);
	    };
	
	    Matrix.rotate = function rotate (angle, x, y) {
	        var matrix = new Matrix();
	        matrix.a = Math.cos(rad(angle));
	        matrix.b = Math.sin(rad(angle));
	        matrix.c = -matrix.b;
	        matrix.d = matrix.a;
	        matrix.e = (x - x * matrix.a + y * matrix.b) || 0;
	        matrix.f = (y - y * matrix.a - x * matrix.b) || 0;
	
	        return matrix;
	    };
	
	    Matrix.scale = function scale (scaleX, scaleY) {
	        return new Matrix(scaleX, 0, 0, scaleY, 0, 0);
	    };
	
	    return Matrix;
	}(Class));
	
	Matrix.IDENTITY = Matrix.unit();
	
	var matrixRegexp = /matrix\((.*)\)/;
	
	function parseMatrix(matrixString) {
	    var match = matrixString.match(matrixRegexp);
	    if (match === null || match.length !== 2) {
	        return Matrix.unit();
	    }
	
	    var members = match[1].split(',').map(function (x) { return parseFloat(x); });
	    return new (Function.prototype.bind.apply( Matrix, [ null ].concat( members) ));
	}
	
	function transformMatrix(element) {
	    var transform = getComputedStyle(element).transform;
	
	    if (transform === 'none') {
	        return Matrix.unit();
	    }
	
	    return parseMatrix(transform);
	}
	
	function elementScale(element) {
	    if (!element) {
	        return Matrix.unit();
	    }
	
	    var matrix = transformMatrix(element);
	    var parent = element.parentElement;
	    while (parent) {
	        var parentMatrix = transformMatrix(parent);
	        matrix = matrix.multiplyCopy(parentMatrix);
	        parent = parent.parentElement;
	    }
	
	    matrix.b = matrix.c = matrix.e = matrix.f = 0;
	    return matrix;
	}
	
	var LRUCache = (function (Class$$1) {
	    function LRUCache(size) {
	        Class$$1.call(this);
	
	        this._size = size;
	        this._length = 0;
	        this._map = {};
	    }
	
	    if ( Class$$1 ) LRUCache.__proto__ = Class$$1;
	    LRUCache.prototype = Object.create( Class$$1 && Class$$1.prototype );
	    LRUCache.prototype.constructor = LRUCache;
	
	    LRUCache.prototype.put = function put (key, value) {
	        var map = this._map;
	        var entry = { key: key, value: value };
	
	        map[key] = entry;
	
	        if (!this._head) {
	            this._head = this._tail = entry;
	        } else {
	            this._tail.newer = entry;
	            entry.older = this._tail;
	            this._tail = entry;
	        }
	
	        if (this._length >= this._size) {
	            map[this._head.key] = null;
	            this._head = this._head.newer;
	            this._head.older = null;
	        } else {
	            this._length++;
	        }
	    };
	
	    LRUCache.prototype.get = function get (key) {
	        var entry = this._map[key];
	
	        if (entry) {
	            if (entry === this._head && entry !== this._tail) {
	                this._head = entry.newer;
	                this._head.older = null;
	            }
	
	            if (entry !== this._tail) {
	                if (entry.older) {
	                    entry.older.newer = entry.newer;
	                    entry.newer.older = entry.older;
	                }
	
	                entry.older = this._tail;
	                entry.newer = null;
	
	                this._tail.newer = entry;
	                this._tail = entry;
	            }
	
	            return entry.value;
	        }
	    };
	
	    return LRUCache;
	}(Class));
	
	var REPLACE_REGEX = /\r?\n|\r|\t/g;
	var SPACE = ' ';
	
	function normalizeText(text) {
	    return String(text).replace(REPLACE_REGEX, SPACE);
	}
	
	function objectKey(object) {
	    var parts = [];
	    for (var key in object) {
	        parts.push(key + object[key]);
	    }
	
	    return parts.sort().join("");
	}
	
	// Computes FNV-1 hash
	// See http://en.wikipedia.org/wiki/Fowler%E2%80%93Noll%E2%80%93Vo_hash_function
	function hashKey(str) {
	    // 32-bit FNV-1 offset basis
	    // See http://isthe.com/chongo/tech/comp/fnv/#FNV-param
	    var hash = 0x811C9DC5;
	
	    for (var i = 0; i < str.length; ++i) {
	        hash += (hash << 1) + (hash << 4) + (hash << 7) + (hash << 8) + (hash << 24);
	        hash ^= str.charCodeAt(i);
	    }
	
	    return hash >>> 0;
	}
	
	function zeroSize() {
	    return { width: 0, height: 0, baseline: 0 };
	}
	
	var DEFAULT_OPTIONS = {
	    baselineMarkerSize: 1
	};
	
	var defaultMeasureBox;
	
	if (typeof document !== "undefined") {
	    defaultMeasureBox = document.createElement("div");
	    defaultMeasureBox.style.cssText = "position: absolute !important; top: -4000px !important; width: auto !important; height: auto !important;" +
	              "padding: 0 !important; margin: 0 !important; border: 0 !important;" +
	              "line-height: normal !important; visibility: hidden !important; white-space: pre!important;";
	}
	
	var TextMetrics = (function (Class$$1) {
	    function TextMetrics(options) {
	        Class$$1.call(this);
	
	        this._cache = new LRUCache(1000);
	        this.options = Object.assign({}, DEFAULT_OPTIONS, options);
	    }
	
	    if ( Class$$1 ) TextMetrics.__proto__ = Class$$1;
	    TextMetrics.prototype = Object.create( Class$$1 && Class$$1.prototype );
	    TextMetrics.prototype.constructor = TextMetrics;
	
	    TextMetrics.prototype.measure = function measure (text, style, options) {
	        if ( options === void 0 ) options = {};
	
	        if (typeof text === 'undefined' || text === null) {
	            return zeroSize();
	        }
	
	        var styleKey = objectKey(style);
	        var cacheKey = hashKey(text + styleKey);
	        var cachedResult = this._cache.get(cacheKey);
	
	        if (cachedResult) {
	            return cachedResult;
	        }
	
	        var size = zeroSize();
	        var measureBox = options.box || defaultMeasureBox;
	        var baselineMarker = this._baselineMarker().cloneNode(false);
	
	        for (var key in style) {
	            var value = style[key];
	            if (typeof value !== "undefined") {
	                measureBox.style[key] = value;
	            }
	        }
	
	        var textStr = options.normalizeText !== false ? normalizeText(text) : String(text);
	
	        measureBox.textContent = textStr;
	        measureBox.appendChild(baselineMarker);
	        document.body.appendChild(measureBox);
	
	        if (textStr.length) {
	            size.width = measureBox.offsetWidth - this.options.baselineMarkerSize;
	            size.height = measureBox.offsetHeight;
	            size.baseline = baselineMarker.offsetTop + this.options.baselineMarkerSize;
	        }
	
	        if (size.width > 0 && size.height > 0) {
	            this._cache.put(cacheKey, size);
	        }
	
	        measureBox.parentNode.removeChild(measureBox);
	
	        return size;
	    };
	
	    TextMetrics.prototype._baselineMarker = function _baselineMarker () {
	        var marker = document.createElement("div");
	        marker.style.cssText = "display: inline-block; vertical-align: baseline;width: " +
	            this.options.baselineMarkerSize + "px; height: " + this.options.baselineMarkerSize + "px;overflow: hidden;";
	
	        return marker;
	    };
	
	    return TextMetrics;
	}(Class));
	
	TextMetrics.current = new TextMetrics();
	
	function measureText(text, style, measureBox) {
	    return TextMetrics.current.measure(text, style, measureBox);
	}
	
	
	
	var util = Object.freeze({
		append: append$1$1,
		arabicToRoman: arabicToRoman,
		createPromise: createPromise,
		defined: defined,
		definitionId: definitionId,
		deg: deg,
		encodeBase64: encodeBase64,
		eventCoordinates: eventCoordinates,
		eventElement: eventElement,
		isTransparent: isTransparent,
		last: last,
		limitValue: limitValue,
		mergeSort: mergeSort,
		now: now,
		promiseAll: promiseAll,
		rad: rad,
		round: round,
		valueOrDefault: valueOrDefault,
		bindEvents: bindEvents,
		elementOffset: elementOffset,
		elementSize: elementSize,
		elementStyles: elementStyles,
		unbindEvents: unbindEvents,
		elementPadding: elementPadding,
		elementScale: elementScale,
		DEG_TO_RAD: DEG_TO_RAD,
		MAX_NUM: MAX_NUM,
		MIN_NUM: MIN_NUM,
		LRUCache: LRUCache,
		TextMetrics: TextMetrics,
		measureText: measureText,
		objectKey: objectKey,
		hashKey: hashKey,
		normalizeText: normalizeText
	});
	
	var toString$1 = {}.toString;
	
	var OptionsStore = (function (HasObservers$$1) {
	    function OptionsStore(options, prefix) {
	        var this$1 = this;
	        if ( prefix === void 0 ) prefix = "";
	
	        HasObservers$$1.call(this);
	
	        this.prefix = prefix;
	
	        for (var field in options) {
	            var member = options[field];
	            member = this$1._wrap(member, field);
	            this$1[field] = member;
	        }
	    }
	
	    if ( HasObservers$$1 ) OptionsStore.__proto__ = HasObservers$$1;
	    OptionsStore.prototype = Object.create( HasObservers$$1 && HasObservers$$1.prototype );
	    OptionsStore.prototype.constructor = OptionsStore;
	
	    OptionsStore.prototype.get = function get (field) {
	        var parts = field.split(".");
	        var result = this;
	
	        while (parts.length && result) {
	            var part = parts.shift();
	            result = result[part];
	        }
	
	        return result;
	    };
	
	    OptionsStore.prototype.set = function set (field, value) {
	        var current = this.get(field);
	
	        if (current !== value) {
	            this._set(field, this._wrap(value, field));
	            this.optionsChange({
	                field: this.prefix + field,
	                value: value
	            });
	        }
	    };
	
	    OptionsStore.prototype._set = function _set (field, value) {
	        var this$1 = this;
	
	        var composite = field.indexOf(".") >= 0;
	        var parentObj = this;
	        var fieldName = field;
	
	        if (composite) {
	            var parts = fieldName.split(".");
	            var prefix = this.prefix;
	
	            while (parts.length > 1) {
	                fieldName = parts.shift();
	                prefix += fieldName + ".";
	
	                var obj = parentObj[fieldName];
	
	                if (!obj) {
	                    obj = new OptionsStore({}, prefix);
	                    obj.addObserver(this$1);
	                    parentObj[fieldName] = obj;
	                }
	                parentObj = obj;
	            }
	            fieldName = parts[0];
	        }
	
	        parentObj._clear(fieldName);
	        parentObj[fieldName] = value;
	    };
	
	    OptionsStore.prototype._clear = function _clear (field) {
	        var current = this[field];
	        if (current && current.removeObserver) {
	            current.removeObserver(this);
	        }
	    };
	
	    OptionsStore.prototype._wrap = function _wrap (object, field) {
	        var type = toString$1.call(object);
	        var wrapped = object;
	
	        if (wrapped !== null && defined(wrapped) && type === "[object Object]") {
	            if (!(object instanceof OptionsStore) && !(object instanceof Class)) {
	                wrapped = new OptionsStore(wrapped, this.prefix + field + ".");
	            }
	
	            wrapped.addObserver(this);
	        }
	
	        return wrapped;
	    };
	
	    return OptionsStore;
	}(HasObservers));
	
	function setAccessor(field) {
	    return function(value) {
	        if (this[field] !== value) {
	            this[field] = value;
	            this.geometryChange();
	        }
	
	        return this;
	    };
	}
	
	function getAccessor(field) {
	    return function() {
	        return this[field];
	    };
	}
	
	function defineAccessors(fn, fields) {
	    for (var i = 0; i < fields.length; i++) {
	        var name = fields[i];
	        var capitalized = name.charAt(0).toUpperCase() +
	                          name.substring(1, name.length);
	
	        fn["set" + capitalized] = setAccessor(name);
	        fn["get" + capitalized] = getAccessor(name);
	    }
	}
	
	var withAccessors = function (TBase, names) {
	    var result = (function (TBase) {
	        function result () {
	            TBase.apply(this, arguments);
	        }if ( TBase ) result.__proto__ = TBase;
	        result.prototype = Object.create( TBase && TBase.prototype );
	        result.prototype.constructor = result;
	
	        
	
	        return result;
	    }(TBase));
	    defineAccessors(result.prototype, names);
	
	    return result;
	};
	
	function toMatrix(transformation) {
	    if (transformation && typeof transformation.matrix === "function") {
	        return transformation.matrix();
	    }
	
	    return transformation;
	}
	
	var Point = (function (superclass) {
	    function Point(x, y) {
	        superclass.call(this);
	
	        this.x = x || 0;
	        this.y = y || 0;
	    }
	
	    if ( superclass ) Point.__proto__ = superclass;
	    Point.prototype = Object.create( superclass && superclass.prototype );
	    Point.prototype.constructor = Point;
	
	    var staticAccessors = { ZERO: {} };
	
	    Point.prototype.equals = function equals (other) {
	        return other && other.x === this.x && other.y === this.y;
	    };
	
	    Point.prototype.clone = function clone () {
	        return new Point(this.x, this.y);
	    };
	
	    Point.prototype.rotate = function rotate (angle, origin) {
	        var originPoint = Point.create(origin) || Point.ZERO;
	
	        return this.transform(Matrix.rotate(angle, originPoint.x, originPoint.y));
	    };
	
	    Point.prototype.translate = function translate (x, y) {
	        this.x += x;
	        this.y += y;
	
	        this.geometryChange();
	
	        return this;
	    };
	
	    Point.prototype.translateWith = function translateWith (point) {
	        return this.translate(point.x, point.y);
	    };
	
	    Point.prototype.move = function move (x, y) {
	        this.x = this.y = 0;
	        return this.translate(x, y);
	    };
	
	    Point.prototype.scale = function scale (scaleX, scaleY) {
	        if ( scaleY === void 0 ) scaleY = scaleX;
	
	        this.x *= scaleX;
	        this.y *= scaleY;
	
	        this.geometryChange();
	
	        return this;
	    };
	
	    Point.prototype.scaleCopy = function scaleCopy (scaleX, scaleY) {
	        return this.clone().scale(scaleX, scaleY);
	    };
	
	    Point.prototype.transform = function transform (transformation) {
	        var matrix = toMatrix(transformation);
	        var ref = this;
	        var x = ref.x;
	        var y = ref.y;
	
	        this.x = matrix.a * x + matrix.c * y + matrix.e;
	        this.y = matrix.b * x + matrix.d * y + matrix.f;
	
	        this.geometryChange();
	
	        return this;
	    };
	
	    Point.prototype.transformCopy = function transformCopy (transformation) {
	        var point = this.clone();
	
	        if (transformation) {
	            point.transform(transformation);
	        }
	
	        return point;
	    };
	
	    Point.prototype.distanceTo = function distanceTo (point) {
	        var dx = this.x - point.x;
	        var dy = this.y - point.y;
	
	        return Math.sqrt(dx * dx + dy * dy);
	    };
	
	    Point.prototype.round = function round$1 (digits) {
	        this.x = round(this.x, digits);
	        this.y = round(this.y, digits);
	
	        this.geometryChange();
	
	        return this;
	    };
	
	    Point.prototype.toArray = function toArray (digits) {
	        var doRound = defined(digits);
	        var x = doRound ? round(this.x, digits) : this.x;
	        var y = doRound ? round(this.y, digits) : this.y;
	
	        return [ x, y ];
	    };
	
	    Point.prototype.toString = function toString (digits, separator) {
	        if ( separator === void 0 ) separator = " ";
	
	        var ref = this;
	        var x = ref.x;
	        var y = ref.y;
	
	        if (defined(digits)) {
	            x = round(x, digits);
	            y = round(y, digits);
	        }
	
	        return x + separator + y;
	    };
	
	    Point.create = function create (arg0, arg1) {
	        if (defined(arg0)) {
	            if (arg0 instanceof Point) {
	                return arg0;
	            } else if (arguments.length === 1 && arg0.length === 2) {
	                return new Point(arg0[0], arg0[1]);
	            }
	
	            return new Point(arg0, arg1);
	        }
	    };
	
	    Point.min = function min () {
	        var arguments$1 = arguments;
	
	        var minX = MAX_NUM;
	        var minY = MAX_NUM;
	
	        for (var i = 0; i < arguments.length; i++) {
	            var point = arguments$1[i];
	            minX = Math.min(point.x, minX);
	            minY = Math.min(point.y, minY);
	        }
	
	        return new Point(minX, minY);
	    };
	
	    Point.max = function max () {
	        var arguments$1 = arguments;
	
	        var maxX = MIN_NUM;
	        var maxY = MIN_NUM;
	
	        for (var i = 0; i < arguments.length; i++) {
	            var point = arguments$1[i];
	            maxX = Math.max(point.x, maxX);
	            maxY = Math.max(point.y, maxY);
	        }
	
	        return new Point(maxX, maxY);
	    };
	
	    Point.minPoint = function minPoint () {
	        return new Point(MIN_NUM, MIN_NUM);
	    };
	
	    Point.maxPoint = function maxPoint () {
	        return new Point(MAX_NUM, MAX_NUM);
	    };
	
	    staticAccessors.ZERO.get = function () {
	        return new Point(0, 0);
	    };
	
	    Object.defineProperties( Point, staticAccessors );
	
	    return Point;
	}(withAccessors(HasObservers, [ "x", "y" ])));
	
	var Size = (function (superclass) {
	    function Size(width, height) {
	        superclass.call(this);
	
	        this.width = width || 0;
	        this.height = height || 0;
	    }
	
	    if ( superclass ) Size.__proto__ = superclass;
	    Size.prototype = Object.create( superclass && superclass.prototype );
	    Size.prototype.constructor = Size;
	
	    var staticAccessors = { ZERO: {} };
	
	    Size.prototype.equals = function equals (other) {
	        return other && other.width === this.width && other.height === this.height;
	    };
	
	    Size.prototype.clone = function clone () {
	        return new Size(this.width, this.height);
	    };
	
	    Size.prototype.toArray = function toArray (digits) {
	        var doRound = defined(digits);
	        var width = doRound ? round(this.width, digits) : this.width;
	        var height = doRound ? round(this.height, digits) : this.height;
	
	        return [ width, height ];
	    };
	
	    Size.create = function create (arg0, arg1) {
	        if (defined(arg0)) {
	            if (arg0 instanceof Size) {
	                return arg0;
	            } else if (arguments.length === 1 && arg0.length === 2) {
	                return new Size(arg0[0], arg0[1]);
	            }
	
	            return new Size(arg0, arg1);
	        }
	    };
	
	    staticAccessors.ZERO.get = function () {
	        return new Size(0, 0);
	    };
	
	    Object.defineProperties( Size, staticAccessors );
	
	    return Size;
	}(withAccessors(HasObservers, [ "width", "height" ])));
	
	var Rect = (function (HasObservers$$1) {
	    function Rect(origin, size, cornerRadius) {
	        if ( origin === void 0 ) origin = new Point();
	        if ( size === void 0 ) size = new Size();
	        if ( cornerRadius === void 0 ) cornerRadius = 0;
	
	        HasObservers$$1.call(this);
	
	        this.setOrigin(origin);
	        this.setSize(size);
	        this.setCornerRadius(cornerRadius);
	    }
	
	    if ( HasObservers$$1 ) Rect.__proto__ = HasObservers$$1;
	    Rect.prototype = Object.create( HasObservers$$1 && HasObservers$$1.prototype );
	    Rect.prototype.constructor = Rect;
	
	    Rect.prototype.clone = function clone () {
	        return new Rect(
	            this.origin.clone(),
	            this.size.clone()
	        );
	    };
	
	    Rect.prototype.equals = function equals (other) {
	        return other &&
	               other.origin.equals(this.origin) &&
	               other.size.equals(this.size);
	    };
	
	    Rect.prototype.setOrigin = function setOrigin (value) {
	        this._observerField("origin", Point.create(value));
	        this.geometryChange();
	        return this;
	    };
	
	    Rect.prototype.getOrigin = function getOrigin () {
	        return this.origin;
	    };
	
	    Rect.prototype.setCornerRadius = function setCornerRadius (radius) {
	        this.cornerRadius = Array.isArray(radius) ? radius : [ radius, radius ];
	
	        this.geometryChange();
	        return this;
	    };
	
	    Rect.prototype.getCornerRadius = function getCornerRadius () {
	        return this.cornerRadius;
	    };
	
	    Rect.prototype.setSize = function setSize (value) {
	        this._observerField("size", Size.create(value));
	        this.geometryChange();
	        return this;
	    };
	
	    Rect.prototype.getSize = function getSize () {
	        return this.size;
	    };
	
	    Rect.prototype.width = function width () {
	        return this.size.width;
	    };
	
	    Rect.prototype.height = function height () {
	        return this.size.height;
	    };
	
	    Rect.prototype.topLeft = function topLeft () {
	        return this.origin.clone();
	    };
	
	    Rect.prototype.bottomRight = function bottomRight () {
	        return this.origin.clone().translate(this.width(), this.height());
	    };
	
	    Rect.prototype.topRight = function topRight () {
	        return this.origin.clone().translate(this.width(), 0);
	    };
	
	    Rect.prototype.bottomLeft = function bottomLeft () {
	        return this.origin.clone().translate(0, this.height());
	    };
	
	    Rect.prototype.center = function center () {
	        return this.origin.clone().translate(this.width() / 2, this.height() / 2);
	    };
	
	    Rect.prototype.bbox = function bbox (matrix) {
	        var tl = this.topLeft().transformCopy(matrix);
	        var tr = this.topRight().transformCopy(matrix);
	        var br = this.bottomRight().transformCopy(matrix);
	        var bl = this.bottomLeft().transformCopy(matrix);
	
	        return Rect.fromPoints(tl, tr, br, bl);
	    };
	
	    Rect.prototype.transformCopy = function transformCopy (m) {
	        return Rect.fromPoints(
	            this.topLeft().transform(m),
	            this.bottomRight().transform(m)
	        );
	    };
	
	    Rect.prototype.expand = function expand (x, y) {
	        if ( y === void 0 ) y = x;
	
	
	        this.size.width += 2 * x;
	        this.size.height += 2 * y;
	
	        this.origin.translate(-x, -y);
	
	        return this;
	    };
	
	    Rect.prototype.expandCopy = function expandCopy (x, y) {
	        return this.clone().expand(x, y);
	    };
	
	    Rect.prototype.containsPoint = function containsPoint (point) {
	        var origin = this.origin;
	        var bottomRight = this.bottomRight();
	        return !(point.x < origin.x || point.y < origin.y || bottomRight.x < point.x || bottomRight.y < point.y);
	    };
	
	    Rect.prototype._isOnPath = function _isOnPath (point, width) {
	        var rectOuter = this.expandCopy(width, width);
	        var rectInner = this.expandCopy(-width, -width);
	
	        return rectOuter.containsPoint(point) && !rectInner.containsPoint(point);
	    };
	
	    Rect.fromPoints = function fromPoints () {
	        var topLeft = Point.min.apply(null, arguments);
	        var bottomRight = Point.max.apply(null, arguments);
	        var size = new Size(
	            bottomRight.x - topLeft.x,
	            bottomRight.y - topLeft.y
	        );
	
	        return new Rect(topLeft, size);
	    };
	
	    Rect.union = function union (a, b) {
	        return Rect.fromPoints(
	            Point.min(a.topLeft(), b.topLeft()),
	            Point.max(a.bottomRight(), b.bottomRight())
	        );
	    };
	
	    Rect.intersect = function intersect (a, b) {
	        var rect1 = {
	            left: a.topLeft().x,
	            top: a.topLeft().y,
	            right: a.bottomRight().x,
	            bottom: a.bottomRight().y
	        };
	
	        var rect2 = {
	            left: b.topLeft().x,
	            top: b.topLeft().y,
	            right: b.bottomRight().x,
	            bottom: b.bottomRight().y
	        };
	
	        if (rect1.left <= rect2.right &&
	            rect2.left <= rect1.right &&
	            rect1.top <= rect2.bottom &&
	            rect2.top <= rect1.bottom) {
	            return Rect.fromPoints(
	                new Point(Math.max(rect1.left, rect2.left), Math.max(rect1.top, rect2.top)),
	                new Point(Math.min(rect1.right, rect2.right), Math.min(rect1.bottom, rect2.bottom))
	            );
	        }
	    };
	
	    return Rect;
	}(HasObservers));
	
	var Transformation = (function (HasObservers$$1) {
	    function Transformation(matrix) {
	        if ( matrix === void 0 ) matrix = Matrix.unit();
	
	        HasObservers$$1.call(this);
	
	        this._matrix = matrix;
	    }
	
	    if ( HasObservers$$1 ) Transformation.__proto__ = HasObservers$$1;
	    Transformation.prototype = Object.create( HasObservers$$1 && HasObservers$$1.prototype );
	    Transformation.prototype.constructor = Transformation;
	
	    Transformation.prototype.clone = function clone () {
	        return new Transformation(
	            this._matrix.clone()
	        );
	    };
	
	    Transformation.prototype.equals = function equals (other) {
	        return other &&
	               other._matrix.equals(this._matrix);
	    };
	
	    Transformation.prototype.translate = function translate (x, y) {
	        this._matrix = this._matrix.multiplyCopy(Matrix.translate(x, y));
	
	        this._optionsChange();
	        return this;
	    };
	
	    Transformation.prototype.scale = function scale (scaleX, scaleY, origin) {
	        if ( scaleY === void 0 ) scaleY = scaleX;
	        if ( origin === void 0 ) origin = null;
	
	        var originPoint = origin;
	
	        if (originPoint) {
	            originPoint = Point.create(originPoint);
	            this._matrix = this._matrix.multiplyCopy(Matrix.translate(originPoint.x, originPoint.y));
	        }
	
	        this._matrix = this._matrix.multiplyCopy(Matrix.scale(scaleX, scaleY));
	
	        if (originPoint) {
	            this._matrix = this._matrix.multiplyCopy(Matrix.translate(-originPoint.x, -originPoint.y));
	        }
	
	        this._optionsChange();
	        return this;
	    };
	
	    Transformation.prototype.rotate = function rotate (angle, origin) {
	        var originPoint = Point.create(origin) || Point.ZERO;
	
	        this._matrix = this._matrix.multiplyCopy(Matrix.rotate(angle, originPoint.x, originPoint.y));
	
	        this._optionsChange();
	        return this;
	    };
	
	    Transformation.prototype.multiply = function multiply (transformation) {
	        var matrix = toMatrix(transformation);
	
	        this._matrix = this._matrix.multiplyCopy(matrix);
	
	        this._optionsChange();
	        return this;
	    };
	
	    Transformation.prototype.matrix = function matrix (value) {
	        if (value) {
	            this._matrix = value;
	            this._optionsChange();
	            return this;
	        }
	
	        return this._matrix;
	    };
	
	    Transformation.prototype._optionsChange = function _optionsChange () {
	        this.optionsChange({
	            field: "transform",
	            value: this
	        });
	    };
	
	    return Transformation;
	}(HasObservers));
	
	function transform$1(matrix) {
	    if (matrix === null) {
	        return null;
	    }
	
	    if (matrix instanceof Transformation) {
	        return matrix;
	    }
	
	    return new Transformation(matrix);
	}
	
	var Element$1 = (function (HasObservers$$1) {
	    function Element(options) {
	        HasObservers$$1.call(this);
	
	        this._initOptions(options);
	    }
	
	    if ( HasObservers$$1 ) Element.__proto__ = HasObservers$$1;
	    Element.prototype = Object.create( HasObservers$$1 && HasObservers$$1.prototype );
	    Element.prototype.constructor = Element;
	
	    var prototypeAccessors = { nodeType: {} };
	
	    prototypeAccessors.nodeType.get = function () {
	        return "Rect";
	    };
	
	    Element.prototype._initOptions = function _initOptions (options) {
	        if ( options === void 0 ) options = {};
	
	        var clip = options.clip;
	        var transform = options.transform;
	
	        if (transform) {
	            options.transform = transform$1(transform);
	        }
	
	        if (clip && !clip.id) {
	            clip.id = definitionId();
	        }
	
	        this.options = new OptionsStore(options);
	        this.options.addObserver(this);
	    };
	
	    Element.prototype.transform = function transform (value) {
	        if (defined(value)) {
	            this.options.set("transform", transform$1(value));
	        } else {
	            return this.options.get("transform");
	        }
	    };
	
	    Element.prototype.parentTransform = function parentTransform () {
	        var element = this;
	        var parentMatrix;
	
	        while (element.parent) {
	            element = element.parent;
	            var transformation = element.transform();
	            if (transformation) {
	                parentMatrix = transformation.matrix().multiplyCopy(parentMatrix || Matrix.unit());
	            }
	        }
	
	        if (parentMatrix) {
	            return transform$1(parentMatrix);
	        }
	    };
	
	    Element.prototype.currentTransform = function currentTransform (parentTransform) {
	        if ( parentTransform === void 0 ) parentTransform = this.parentTransform();
	
	        var elementTransform = this.transform();
	        var elementMatrix = toMatrix(elementTransform);
	
	        var parentMatrix = toMatrix(parentTransform);
	        var combinedMatrix;
	
	        if (elementMatrix && parentMatrix) {
	            combinedMatrix = parentMatrix.multiplyCopy(elementMatrix);
	        } else {
	            combinedMatrix = elementMatrix || parentMatrix;
	        }
	
	        if (combinedMatrix) {
	            return transform$1(combinedMatrix);
	        }
	    };
	
	    Element.prototype.visible = function visible (value) {
	        if (defined(value)) {
	            this.options.set("visible", value);
	            return this;
	        }
	
	        return this.options.get("visible") !== false;
	    };
	
	    Element.prototype.clip = function clip (value) {
	        var options = this.options;
	        if (defined(value)) {
	            if (value && !value.id) {
	                value.id = definitionId();
	            }
	            options.set("clip", value);
	            return this;
	        }
	
	        return options.get("clip");
	    };
	
	    Element.prototype.opacity = function opacity (value) {
	        if (defined(value)) {
	            this.options.set("opacity", value);
	            return this;
	        }
	
	        return valueOrDefault(this.options.get("opacity"), 1);
	    };
	
	    Element.prototype.className = function className (value) {
	        if (defined(value)) {
	            this.options.set("className", value);
	            return this;
	        }
	
	        return this.options.get("className");
	    };
	
	    Element.prototype.clippedBBox = function clippedBBox (transformation) {
	        var bbox = this._clippedBBox(transformation);
	        if (bbox) {
	            var clip = this.clip();
	            return clip ? Rect.intersect(bbox, clip.bbox(transformation)) : bbox;
	        }
	    };
	
	    Element.prototype.containsPoint = function containsPoint (point, parentTransform) {
	        if (this.visible()) {
	            var transform = this.currentTransform(parentTransform);
	            var transformedPoint = point;
	            if (transform) {
	                transformedPoint = point.transformCopy(transform.matrix().invert());
	            }
	            return (this._hasFill() && this._containsPoint(transformedPoint)) || (this._isOnPath && this._hasStroke() && this._isOnPath(transformedPoint));
	        }
	        return false;
	    };
	
	    Element.prototype._hasFill = function _hasFill () {
	        var fill = this.options.fill;
	        return fill && !isTransparent(fill.color);
	    };
	
	    Element.prototype._hasStroke = function _hasStroke () {
	        var stroke = this.options.stroke;
	        return stroke && stroke.width > 0 && !isTransparent(stroke.color);
	    };
	
	    Element.prototype._clippedBBox = function _clippedBBox (transformation) {
	        return this.bbox(transformation);
	    };
	
	    Object.defineProperties( Element.prototype, prototypeAccessors );
	
	    return Element;
	}(HasObservers));
	
	function ellipseExtremeAngles(center, rx, ry, matrix) {
	    var extremeX = 0;
	    var extremeY = 0;
	
	    if (matrix) {
	        extremeX = Math.atan2(matrix.c * ry, matrix.a * rx);
	        if (matrix.b !== 0) {
	            extremeY = Math.atan2(matrix.d * ry, matrix.b * rx);
	        }
	    }
	
	    return {
	        x: extremeX,
	        y: extremeY
	    };
	}
	
	var PI_DIV_2 = Math.PI / 2;
	
	var Circle$2 = (function (superclass) {
	    function Circle(center, radius) {
	        if ( center === void 0 ) center = new Point();
	        if ( radius === void 0 ) radius = 0;
	
	        superclass.call(this);
	
	        this.setCenter(center);
	        this.setRadius(radius);
	    }
	
	    if ( superclass ) Circle.__proto__ = superclass;
	    Circle.prototype = Object.create( superclass && superclass.prototype );
	    Circle.prototype.constructor = Circle;
	
	    Circle.prototype.setCenter = function setCenter (value) {
	        this._observerField("center", Point.create(value));
	        this.geometryChange();
	        return this;
	    };
	
	    Circle.prototype.getCenter = function getCenter () {
	        return this.center;
	    };
	
	    Circle.prototype.equals = function equals (other) {
	        return other &&
	               other.center.equals(this.center) &&
	               other.radius === this.radius;
	    };
	
	    Circle.prototype.clone = function clone () {
	        return new Circle(this.center.clone(), this.radius);
	    };
	
	    Circle.prototype.pointAt = function pointAt (angle) {
	        return this._pointAt(rad(angle));
	    };
	
	    Circle.prototype.bbox = function bbox (matrix) {
	        var this$1 = this;
	
	        var extremeAngles = ellipseExtremeAngles(this.center, this.radius, this.radius, matrix);
	        var minPoint = Point.maxPoint();
	        var maxPoint = Point.minPoint();
	
	        for (var i = 0; i < 4; i++) {
	            var currentPointX = this$1._pointAt(extremeAngles.x + i * PI_DIV_2).transformCopy(matrix);
	            var currentPointY = this$1._pointAt(extremeAngles.y + i * PI_DIV_2).transformCopy(matrix);
	            var currentPoint = new Point(currentPointX.x, currentPointY.y);
	
	            minPoint = Point.min(minPoint, currentPoint);
	            maxPoint = Point.max(maxPoint, currentPoint);
	        }
	
	        return Rect.fromPoints(minPoint, maxPoint);
	    };
	
	    Circle.prototype._pointAt = function _pointAt (angle) {
	        var ref = this;
	        var center = ref.center;
	        var radius = ref.radius;
	
	        return new Point(
	            center.x + radius * Math.cos(angle),
	            center.y + radius * Math.sin(angle)
	        );
	    };
	
	    Circle.prototype.containsPoint = function containsPoint (point) {
	        var ref = this;
	        var center = ref.center;
	        var radius = ref.radius;
	        var inCircle = Math.pow(point.x - center.x, 2) +
	            Math.pow(point.y - center.y, 2) <= Math.pow(radius, 2);
	        return inCircle;
	    };
	
	    Circle.prototype._isOnPath = function _isOnPath (point, width) {
	        var ref = this;
	        var center = ref.center;
	        var radius = ref.radius;
	        var pointDistance = center.distanceTo(point);
	
	        return radius - width <= pointDistance && pointDistance <= radius + width;
	    };
	
	    return Circle;
	}(withAccessors(HasObservers, [ "radius" ])));
	
	var GRADIENT = "Gradient";
	
	var paintable = function (TBase) { return (
	    (function (TBase) {
	        function anonymous () {
	            TBase.apply(this, arguments);
	        }
	
	        if ( TBase ) anonymous.__proto__ = TBase;
	        anonymous.prototype = Object.create( TBase && TBase.prototype );
	        anonymous.prototype.constructor = anonymous;
	
	        anonymous.prototype.fill = function fill (color, opacity) {
	            var options = this.options;
	
	            if (defined(color)) {
	                if (color && color.nodeType !== GRADIENT) {
	                    var newFill = {
	                        color: color
	                    };
	                    if (defined(opacity)) {
	                        newFill.opacity = opacity;
	                    }
	                    options.set("fill", newFill);
	                } else {
	                    options.set("fill", color);
	                }
	
	                return this;
	            }
	
	            return options.get("fill");
	        };
	
	        anonymous.prototype.stroke = function stroke (color, width, opacity) {
	            if (defined(color)) {
	                this.options.set("stroke.color", color);
	
	                if (defined(width)) {
	                    this.options.set("stroke.width", width);
	                }
	
	                if (defined(opacity)) {
	                    this.options.set("stroke.opacity", opacity);
	                }
	
	                return this;
	            }
	
	            return this.options.get("stroke");
	        };
	
	        return anonymous;
	    }(TBase))
	); };
	
	var IDENTITY_MATRIX_HASH = Matrix.IDENTITY.toString();
	
	var measurable = function (TBase) { return (
	    (function (TBase) {
	        function anonymous () {
	            TBase.apply(this, arguments);
	        }
	
	        if ( TBase ) anonymous.__proto__ = TBase;
	        anonymous.prototype = Object.create( TBase && TBase.prototype );
	        anonymous.prototype.constructor = anonymous;
	
	        anonymous.prototype.bbox = function bbox (transformation) {
	            var combinedMatrix = toMatrix(this.currentTransform(transformation));
	            var matrixHash = combinedMatrix ? combinedMatrix.toString() : IDENTITY_MATRIX_HASH;
	            var bbox;
	
	            if (this._bboxCache && this._matrixHash === matrixHash) {
	                bbox = this._bboxCache.clone();
	            } else {
	                bbox = this._bbox(combinedMatrix);
	                this._bboxCache = bbox ? bbox.clone() : null;
	                this._matrixHash = matrixHash;
	            }
	
	            var strokeWidth = this.options.get("stroke.width");
	            if (strokeWidth && bbox) {
	                bbox.expand(strokeWidth / 2);
	            }
	
	            return bbox;
	        };
	
	        anonymous.prototype.geometryChange = function geometryChange () {
	            delete this._bboxCache;
	            this.trigger("geometryChange", {
	                element: this
	            });
	        };
	
	        return anonymous;
	    }(TBase))
	); };
	
	function geometryAccessor(name) {
	    var fieldName = "_" + name;
	    return function(value) {
	        if (defined(value)) {
	            this._observerField(fieldName, value);
	            this.geometryChange();
	            return this;
	        }
	
	        return this[fieldName];
	    };
	}
	
	function defineGeometryAccessors(fn, names) {
	    for (var i = 0; i < names.length; i++) {
	        fn[names[i]] = geometryAccessor(names[i]);
	    }
	}
	
	var withGeometry = function (TBase, names) {
	    if ( names === void 0 ) names = [ "geometry" ];
	
	    var result = (function (TBase) {
	        function result () {
	            TBase.apply(this, arguments);
	        }if ( TBase ) result.__proto__ = TBase;
	        result.prototype = Object.create( TBase && TBase.prototype );
	        result.prototype.constructor = result;
	
	        
	
	        return result;
	    }(TBase));
	    defineGeometryAccessors(result.prototype, names);
	
	    return result;
	};
	
	var DEFAULT_STROKE = "#000";
	
	var Circle = (function (superclass) {
	    function Circle(geometry, options) {
	        if ( geometry === void 0 ) geometry = new Circle$2();
	        if ( options === void 0 ) options = {};
	
	        superclass.call(this, options);
	
	        this.geometry(geometry);
	
	        if (!defined(this.options.stroke)) {
	            this.stroke(DEFAULT_STROKE);
	        }
	    }
	
	    if ( superclass ) Circle.__proto__ = superclass;
	    Circle.prototype = Object.create( superclass && superclass.prototype );
	    Circle.prototype.constructor = Circle;
	
	    var prototypeAccessors = { nodeType: {} };
	
	    prototypeAccessors.nodeType.get = function () {
	        return "Circle";
	    };
	
	    Circle.prototype.rawBBox = function rawBBox () {
	        return this._geometry.bbox();
	    };
	
	    Circle.prototype._bbox = function _bbox (matrix) {
	        return this._geometry.bbox(matrix);
	    };
	
	    Circle.prototype._containsPoint = function _containsPoint (point) {
	        return this.geometry().containsPoint(point);
	    };
	
	    Circle.prototype._isOnPath = function _isOnPath (point) {
	        return this.geometry()._isOnPath(point, this.options.stroke.width / 2);
	    };
	
	    Object.defineProperties( Circle.prototype, prototypeAccessors );
	
	    return Circle;
	}(paintable(measurable(withGeometry(Element$1)))));
	
	var PRECISION = 10;
	
	function close$1(a, b, tolerance) {
	    if ( tolerance === void 0 ) tolerance = PRECISION;
	
	    return round(Math.abs(a - b), tolerance) === 0;
	}
	
	function closeOrLess(a, b, tolerance) {
	    return a < b || close$1(a, b, tolerance);
	}
	
	function lineIntersection(p0, p1, p2, p3) {
	    var s1x = p1.x - p0.x;
	    var s2x = p3.x - p2.x;
	    var s1y = p1.y - p0.y;
	    var s2y = p3.y - p2.y;
	    var nx = p0.x - p2.x;
	    var ny = p0.y - p2.y;
	    var d = s1x * s2y - s2x * s1y;
	    var s = (s1x * ny - s1y * nx) / d;
	    var t = (s2x * ny - s2y * nx) / d;
	
	    if (s >= 0 && s <= 1 && t >= 0 && t <= 1) {
	        return new Point(p0.x + t * s1x, p0.y + t * s1y);
	    }
	}
	
	var MAX_INTERVAL = 45;
	var pow$1 = Math.pow;
	var accessors = [ "radiusX", "radiusY", "startAngle", "endAngle", "anticlockwise" ];
	
	var Arc$2 = (function (superclass) {
	    function Arc(center, options) {
	        if ( center === void 0 ) center = new Point();
	        if ( options === void 0 ) options = {};
	
	        superclass.call(this);
	
	        this.setCenter(center);
	
	        this.radiusX = options.radiusX;
	        this.radiusY = options.radiusY || options.radiusX;
	        this.startAngle = options.startAngle;
	        this.endAngle = options.endAngle;
	        this.anticlockwise = options.anticlockwise || false;
	        this.xRotation = options.xRotation;
	    }
	
	    if ( superclass ) Arc.__proto__ = superclass;
	    Arc.prototype = Object.create( superclass && superclass.prototype );
	    Arc.prototype.constructor = Arc;
	
	    Arc.prototype.clone = function clone () {
	        return new Arc(this.center, {
	            radiusX: this.radiusX,
	            radiusY: this.radiusY,
	            startAngle: this.startAngle,
	            endAngle: this.endAngle,
	            anticlockwise: this.anticlockwise
	        });
	    };
	
	    Arc.prototype.setCenter = function setCenter (value) {
	        this._observerField("center", Point.create(value));
	        this.geometryChange();
	        return this;
	    };
	
	    Arc.prototype.getCenter = function getCenter () {
	        return this.center;
	    };
	
	    Arc.prototype.pointAt = function pointAt (angle) {
	        var center = this.center;
	        var radian = rad(angle);
	
	        return new Point(
	            center.x + this.radiusX * Math.cos(radian),
	            center.y + this.radiusY * Math.sin(radian)
	        );
	    };
	
	    Arc.prototype.curvePoints = function curvePoints () {
	        var this$1 = this;
	
	        var startAngle = this.startAngle;
	        var dir = this.anticlockwise ? -1 : 1;
	        var curvePoints = [ this.pointAt(startAngle) ];
	        var interval = this._arcInterval();
	        var intervalAngle = interval.endAngle - interval.startAngle;
	        var subIntervalsCount = Math.ceil(intervalAngle / MAX_INTERVAL);
	        var subIntervalAngle = intervalAngle / subIntervalsCount;
	        var currentAngle = startAngle;
	        var transformation;
	        if (this.xRotation) {
	            transformation = transform$1().rotate(this.xRotation, this.center);
	        }
	
	        for (var i = 1; i <= subIntervalsCount; i++) {
	            var nextAngle = currentAngle + dir * subIntervalAngle;
	            var points = this$1._intervalCurvePoints(currentAngle, nextAngle, transformation);
	
	            curvePoints.push(points.cp1, points.cp2, points.p2);
	            currentAngle = nextAngle;
	        }
	
	        return curvePoints;
	    };
	
	    Arc.prototype.bbox = function bbox (matrix) {
	        var this$1 = this;
	
	        var interval = this._arcInterval();
	        var startAngle = interval.startAngle;
	        var endAngle = interval.endAngle;
	        var extremeAngles = ellipseExtremeAngles(this.center, this.radiusX, this.radiusY, matrix);
	        var extremeX = deg(extremeAngles.x);
	        var extremeY = deg(extremeAngles.y);
	        var endPoint = this.pointAt(endAngle).transformCopy(matrix);
	        var currentAngleX = bboxStartAngle(extremeX, startAngle);
	        var currentAngleY = bboxStartAngle(extremeY, startAngle);
	        var currentPoint = this.pointAt(startAngle).transformCopy(matrix);
	        var minPoint = Point.min(currentPoint, endPoint);
	        var maxPoint = Point.max(currentPoint, endPoint);
	
	        while (currentAngleX < endAngle || currentAngleY < endAngle) {
	            var currentPointX = (void 0);
	            if (currentAngleX < endAngle) {
	                currentPointX = this$1.pointAt(currentAngleX).transformCopy(matrix);
	                currentAngleX += 90;
	            }
	
	            var currentPointY = (void 0);
	            if (currentAngleY < endAngle) {
	                currentPointY = this$1.pointAt(currentAngleY).transformCopy(matrix);
	                currentAngleY += 90;
	            }
	
	            currentPoint = new Point(currentPointX.x, currentPointY.y);
	            minPoint = Point.min(minPoint, currentPoint);
	            maxPoint = Point.max(maxPoint, currentPoint);
	        }
	
	        return Rect.fromPoints(minPoint, maxPoint);
	    };
	
	    Arc.prototype._arcInterval = function _arcInterval () {
	        var ref = this;
	        var startAngle = ref.startAngle;
	        var endAngle = ref.endAngle;
	        var anticlockwise = ref.anticlockwise;
	
	        if (anticlockwise) {
	            var oldStart = startAngle;
	            startAngle = endAngle;
	            endAngle = oldStart;
	        }
	
	        if (startAngle > endAngle || (anticlockwise && startAngle === endAngle)) {
	            endAngle += 360;
	        }
	
	        return {
	            startAngle: startAngle,
	            endAngle: endAngle
	        };
	    };
	
	    Arc.prototype._intervalCurvePoints = function _intervalCurvePoints (startAngle, endAngle, transformation) {
	        var p1 = this.pointAt(startAngle);
	        var p2 = this.pointAt(endAngle);
	        var p1Derivative = this._derivativeAt(startAngle);
	        var p2Derivative = this._derivativeAt(endAngle);
	        var t = (rad(endAngle) - rad(startAngle)) / 3;
	        var cp1 = new Point(p1.x + t * p1Derivative.x, p1.y + t * p1Derivative.y);
	        var cp2 = new Point(p2.x - t * p2Derivative.x, p2.y - t * p2Derivative.y);
	        if (transformation) {
	            p1.transform(transformation);
	            p2.transform(transformation);
	            cp1.transform(transformation);
	            cp2.transform(transformation);
	        }
	
	        return {
	            p1: p1,
	            cp1: cp1,
	            cp2: cp2,
	            p2: p2
	        };
	    };
	
	    Arc.prototype._derivativeAt = function _derivativeAt (angle) {
	        var radian = rad(angle);
	
	        return new Point(-this.radiusX * Math.sin(radian), this.radiusY * Math.cos(radian));
	    };
	
	    Arc.prototype.containsPoint = function containsPoint (point) {
	        var interval = this._arcInterval();
	        var intervalAngle = interval.endAngle - interval.startAngle;
	        var ref = this;
	        var center = ref.center;
	        var radiusX = ref.radiusX;
	        var radiusY = ref.radiusY;
	        var distance = center.distanceTo(point);
	        var angleRad = Math.atan2(point.y - center.y, point.x - center.x);
	        var pointRadius = (radiusX * radiusY) /
	            Math.sqrt(pow$1(radiusX, 2) * pow$1(Math.sin(angleRad), 2) + pow$1(radiusY, 2) * pow$1(Math.cos(angleRad), 2));
	        var startPoint = this.pointAt(this.startAngle).round(PRECISION);
	        var endPoint = this.pointAt(this.endAngle).round(PRECISION);
	        var intersection = lineIntersection(center, point.round(PRECISION), startPoint, endPoint);
	        var containsPoint;
	
	        if (intervalAngle < 180) {
	            containsPoint = intersection && closeOrLess(center.distanceTo(intersection), distance) && closeOrLess(distance, pointRadius);
	        } else {
	            var angle = calculateAngle(center.x, center.y, radiusX, radiusY, point.x, point.y);
	            if (angle !== 360) {
	                angle = (360 + angle) % 360;
	            }
	
	            var inAngleRange = interval.startAngle <= angle && angle <= interval.endAngle;
	            containsPoint = (inAngleRange && closeOrLess(distance, pointRadius)) || (!inAngleRange && (!intersection || intersection.equals(point)));
	        }
	        return containsPoint;
	    };
	
	    Arc.prototype._isOnPath = function _isOnPath (point, width) {
	        var interval = this._arcInterval();
	        var center = this.center;
	        var angle = calculateAngle(center.x, center.y, this.radiusX, this.radiusY, point.x, point.y);
	        if (angle !== 360) {
	            angle = (360 + angle) % 360;
	        }
	
	        var inAngleRange = interval.startAngle <= angle && angle <= interval.endAngle;
	
	        return inAngleRange && this.pointAt(angle).distanceTo(point) <= width;
	    };
	
	    Arc.fromPoints = function fromPoints (start, end, rx, ry, largeArc, swipe, rotation) {// eslint-disable-line max-params
	        var arcParameters = normalizeArcParameters({
	            x1: start.x,
	            y1: start.y,
	            x2: end.x,
	            y2: end.y,
	            rx: rx,
	            ry: ry,
	            largeArc: largeArc,
	            swipe: swipe,
	            rotation: rotation
	        });
	
	        return new Arc(arcParameters.center, {
	            startAngle: arcParameters.startAngle,
	            endAngle: arcParameters.endAngle,
	            radiusX: arcParameters.radiusX,
	            radiusY: arcParameters.radiusY,
	            xRotation: arcParameters.xRotation,
	            anticlockwise: swipe === 0
	        });
	    };
	
	    return Arc;
	}(withAccessors(HasObservers, accessors)));
	
	function calculateAngle(cx, cy, rx, ry, x, y) {
	    var cos = round((x - cx) / rx, 3);
	    var sin = round((y - cy) / ry, 3);
	
	    return round(deg(Math.atan2(sin, cos)));
	}
	
	function normalizeArcParameters(parameters) {
	    var x1 = parameters.x1;
	    var y1 = parameters.y1;
	    var x2 = parameters.x2;
	    var y2 = parameters.y2;
	    var rx = parameters.rx;
	    var ry = parameters.ry;
	    var largeArc = parameters.largeArc;
	    var swipe = parameters.swipe;
	    var rotation = parameters.rotation; if ( rotation === void 0 ) rotation = 0;
	
	    var radians = rad(rotation);
	    var cosine = Math.cos(radians);
	    var sine = Math.sin(radians);
	
	    var xT = cosine * (x1 - x2) / 2 + sine * (y1 - y2) / 2;
	    var yT = -sine * (x1 - x2) / 2 + cosine * (y1 - y2) / 2;
	
	    var sign = largeArc !== swipe ? 1 : -1;
	
	    var xt2 = Math.pow(xT, 2);
	    var yt2 = Math.pow(yT, 2);
	    var rx2 = Math.pow(rx, 2);
	    var ry2 = Math.pow(ry, 2);
	
	    var delta = xt2 / rx2 + yt2 / ry2;
	
	    if (delta > 1) {
	        delta = Math.sqrt(xt2 / rx2 + yt2 / ry2);
	        rx = delta * rx;
	        rx2 = Math.pow(rx, 2);
	
	        ry = delta * ry;
	        ry2 = Math.pow(ry, 2);
	    }
	
	    var constT = sign * Math.sqrt((rx2 * ry2 - rx2 * yt2 - ry2 * xt2) / (rx2 * yt2 + ry2 * xt2));
	    // due to rounding errors the value could become NaN even after radii correction
	    if (isNaN(constT)) {
	        constT = 0;
	    }
	
	    var cxT = constT * (rx * yT) / ry;
	    var cyT = - constT * (ry * xT) / rx;
	
	    var cx = cosine * cxT - sine * cyT + (x1 + x2) / 2;
	    var cy = sine * cxT + cosine * cyT + (y1 + y2) / 2;
	
	
	    var uX = (xT - cxT) / rx;
	    var uY = (yT - cyT) / ry;
	    var vX = -(xT + cxT) / rx;
	    var vY = -(yT + cyT) / ry;
	
	    var startAngle = (uY >= 0 ? 1 : -1) * deg(Math.acos(uX / Math.sqrt(uX * uX + uY * uY)));
	
	    var angleCosine = round((uX * vX + uY * vY) / (Math.sqrt(uX * uX + uY * uY) * Math.sqrt(vX * vX + vY * vY)), 10);
	    var angle = (uX * vY - uY * vX >= 0 ? 1 : -1) * deg(Math.acos(angleCosine));
	
	    if (!swipe && angle > 0) {
	        angle -= 360;
	    }
	
	    if (swipe && angle < 0) {
	        angle += 360;
	    }
	    var endAngle = startAngle + angle;
	    var signEndAngle = endAngle >= 0 ? 1 : -1;
	    endAngle = (Math.abs(endAngle) % 360) * signEndAngle;
	
	    return {
	        center: new Point(cx, cy),
	        startAngle: startAngle,
	        endAngle: endAngle,
	        radiusX: rx,
	        radiusY: ry,
	        xRotation: rotation
	    };
	}
	
	function bboxStartAngle(angle, start) {
	    var startAngle = angle;
	
	    while (startAngle < start) {
	        startAngle += 90;
	    }
	
	    return startAngle;
	}
	
	var push = [].push;
	var pop = [].pop;
	var splice = [].splice;
	var shift = [].shift;
	var slice = [].slice;
	var unshift = [].unshift;
	
	var ElementsArray = (function (HasObservers$$1) {
	    function ElementsArray(array) {
	        if ( array === void 0 ) array = [];
	
	        HasObservers$$1.call(this);
	
	        this.length = 0;
	        this._splice(0, array.length, array);
	    }
	
	    if ( HasObservers$$1 ) ElementsArray.__proto__ = HasObservers$$1;
	    ElementsArray.prototype = Object.create( HasObservers$$1 && HasObservers$$1.prototype );
	    ElementsArray.prototype.constructor = ElementsArray;
	
	    ElementsArray.prototype.elements = function elements (value) {
	        if (value) {
	            this._splice(0, this.length, value);
	
	            this._change();
	            return this;
	        }
	
	        return this.slice(0);
	    };
	
	    ElementsArray.prototype.push = function push$1 () {
	        var elements = arguments;
	        var result = push.apply(this, elements);
	
	        this._add(elements);
	
	        return result;
	    };
	
	    ElementsArray.prototype.slice = function slice$1 () {
	        return slice.call(this);
	    };
	
	    ElementsArray.prototype.pop = function pop$1 () {
	        var length = this.length;
	        var result = pop.apply(this);
	
	        if (length) {
	            this._remove([ result ]);
	        }
	
	        return result;
	    };
	
	    ElementsArray.prototype.splice = function splice$1 (index, howMany) {
	        var elements = slice.call(arguments, 2);
	        var result = this._splice(index, howMany, elements);
	
	        this._change();
	
	        return result;
	    };
	
	    ElementsArray.prototype.shift = function shift$1 () {
	        var length = this.length;
	        var result = shift.apply(this);
	
	        if (length) {
	            this._remove([ result ]);
	        }
	
	        return result;
	    };
	
	    ElementsArray.prototype.unshift = function unshift$1 () {
	        var elements = arguments;
	        var result = unshift.apply(this, elements);
	
	        this._add(elements);
	
	        return result;
	    };
	
	    ElementsArray.prototype.indexOf = function indexOf (element) {
	        var this$1 = this;
	
	        var length = this.length;
	
	        for (var idx = 0; idx < length; idx++) {
	            if (this$1[idx] === element) {
	                return idx;
	            }
	        }
	        return -1;
	    };
	
	    ElementsArray.prototype._splice = function _splice (index, howMany, elements) {
	        var result = splice.apply(this, [ index, howMany ].concat(elements));
	
	        this._clearObserver(result);
	        this._setObserver(elements);
	
	        return result;
	    };
	
	    ElementsArray.prototype._add = function _add (elements) {
	        this._setObserver(elements);
	        this._change();
	    };
	
	    ElementsArray.prototype._remove = function _remove (elements) {
	        this._clearObserver(elements);
	        this._change();
	    };
	
	    ElementsArray.prototype._setObserver = function _setObserver (elements) {
	        var this$1 = this;
	
	        for (var idx = 0; idx < elements.length; idx++) {
	            elements[idx].addObserver(this$1);
	        }
	    };
	
	    ElementsArray.prototype._clearObserver = function _clearObserver (elements) {
	        var this$1 = this;
	
	        for (var idx = 0; idx < elements.length; idx++) {
	            elements[idx].removeObserver(this$1);
	        }
	    };
	
	    ElementsArray.prototype._change = function _change () {};
	
	    return ElementsArray;
	}(HasObservers));
	
	var GeometryElementsArray = (function (ElementsArray$$1) {
	    function GeometryElementsArray () {
	        ElementsArray$$1.apply(this, arguments);
	    }
	
	    if ( ElementsArray$$1 ) GeometryElementsArray.__proto__ = ElementsArray$$1;
	    GeometryElementsArray.prototype = Object.create( ElementsArray$$1 && ElementsArray$$1.prototype );
	    GeometryElementsArray.prototype.constructor = GeometryElementsArray;
	
	    GeometryElementsArray.prototype._change = function _change () {
	        this.geometryChange();
	    };
	
	    return GeometryElementsArray;
	}(ElementsArray));
	
	function isOutOfEndPoint(endPoint, controlPoint, point) {
	    var angle = deg(Math.atan2(controlPoint.y - endPoint.y, controlPoint.x - endPoint.x));
	    var rotatedPoint = point.transformCopy(transform$1().rotate(-angle, endPoint));
	
	    return rotatedPoint.x < endPoint.x;
	}
	
	function calculateCurveAt(t, field, points) {
	    var t1 = 1 - t;
	    return Math.pow(t1, 3) * points[0][field] +
	        3 * Math.pow(t1, 2) * t * points[1][field] +
	        3 * Math.pow(t, 2) * t1 * points[2][field] +
	        Math.pow(t, 3) * points[3][field];
	}
	
	function toCubicPolynomial(points, field) {
	    return [ -points[0][field] + 3 * points[1][field] - 3 * points[2][field] + points[3][field],
	        3 * (points[0][field] - 2 * points[1][field] + points[2][field]),
	        3 * (-points[0][field] + points[1][field]),
	        points[0][field]
	    ];
	}
	
	var ComplexNumber = (function (Class$$1) {
	    function ComplexNumber(real, img) {
	        if ( real === void 0 ) real = 0;
	        if ( img === void 0 ) img = 0;
	
	        Class$$1.call(this);
	
	        this.real = real;
	        this.img = img;
	    }
	
	    if ( Class$$1 ) ComplexNumber.__proto__ = Class$$1;
	    ComplexNumber.prototype = Object.create( Class$$1 && Class$$1.prototype );
	    ComplexNumber.prototype.constructor = ComplexNumber;
	
	    ComplexNumber.prototype.add = function add (cNumber) {
	        return new ComplexNumber(round(this.real + cNumber.real, PRECISION), round(this.img + cNumber.img, PRECISION));
	    };
	
	    ComplexNumber.prototype.addConstant = function addConstant (value) {
	        return new ComplexNumber(this.real + value, this.img);
	    };
	
	    ComplexNumber.prototype.negate = function negate () {
	        return new ComplexNumber(-this.real, -this.img);
	    };
	
	    ComplexNumber.prototype.multiply = function multiply (cNumber) {
	        return new ComplexNumber(this.real * cNumber.real - this.img * cNumber.img,
	            this.real * cNumber.img + this.img * cNumber.real);
	    };
	
	    ComplexNumber.prototype.multiplyConstant = function multiplyConstant (value) {
	        return new ComplexNumber(this.real * value, this.img * value);
	    };
	
	    ComplexNumber.prototype.nthRoot = function nthRoot (n) {
	        var rad$$1 = Math.atan2(this.img, this.real);
	        var r = Math.sqrt(Math.pow(this.img, 2) + Math.pow(this.real, 2));
	        var nthR = Math.pow(r, 1 / n);
	
	        return new ComplexNumber(nthR * Math.cos(rad$$1 / n), nthR * Math.sin(rad$$1 / n)); //Moivre's formula
	    };
	
	    ComplexNumber.prototype.equals = function equals (cNumber) {
	        return this.real === cNumber.real && this.img === cNumber.img;
	    };
	
	    ComplexNumber.prototype.isReal = function isReal () {
	        return this.img === 0;
	    };
	
	    return ComplexNumber;
	}(Class));
	
	function numberSign$1(x) {
	    return x < 0 ? -1 : 1;
	}
	
	function solveQuadraticEquation(a, b, c) {
	    var squareRoot = Math.sqrt(Math.pow(b, 2) - 4 * a * c);
	    return [
	        (-b + squareRoot) / (2 * a),
	        (-b - squareRoot) / (2 * a)
	    ];
	}
	
	//Cardano's formula
	function solveCubicEquation(a, b, c, d) {
	    if (a === 0) {
	        return solveQuadraticEquation(b, c, d);
	    }
	
	    var p = (3 * a * c - Math.pow(b, 2)) / (3 * Math.pow(a, 2));
	    var q = (2 * Math.pow(b, 3) - 9 * a * b * c + 27 * Math.pow(a, 2) * d) / (27 * Math.pow(a, 3));
	    var Q = Math.pow(p / 3, 3) + Math.pow(q / 2, 2);
	    var i = new ComplexNumber(0,1);
	    var b3a = -b / (3 * a);
	    var x1, x2, y1, y2, y3, z1, z2;
	
	    if (Q < 0) {
	        x1 = new ComplexNumber(-q / 2, Math.sqrt(-Q)).nthRoot(3);
	        x2 = new ComplexNumber(-q / 2, - Math.sqrt(-Q)).nthRoot(3);
	    } else {
	        x1 = -q / 2 + Math.sqrt(Q);
	        x1 = new ComplexNumber(numberSign$1(x1) * Math.pow(Math.abs(x1), 1 / 3));
	        x2 = -q / 2 - Math.sqrt(Q);
	        x2 = new ComplexNumber(numberSign$1(x2) * Math.pow(Math.abs(x2), 1 / 3));
	    }
	
	    y1 = x1.add(x2);
	
	    z1 = x1.add(x2).multiplyConstant(-1 / 2);
	    z2 = x1.add(x2.negate()).multiplyConstant(Math.sqrt(3) / 2);
	
	    y2 = z1.add(i.multiply(z2));
	    y3 = z1.add(i.negate().multiply(z2));
	
	    var result = [];
	
	    if (y1.isReal()) {
	        result.push(round(y1.real + b3a, PRECISION));
	    }
	    if (y2.isReal()) {
	        result.push(round(y2.real + b3a, PRECISION));
	    }
	    if (y3.isReal()) {
	        result.push(round(y3.real + b3a, PRECISION));
	    }
	
	    return result;
	}
	
	function hasRootsInRange(points, point, field, rootField, range) {
	    var polynomial = toCubicPolynomial(points, rootField);
	    var roots = solveCubicEquation(polynomial[0], polynomial[1], polynomial[2], polynomial[3] - point[rootField]);
	    var intersection;
	
	    for (var idx = 0; idx < roots.length; idx++) {
	        if (0 <= roots[idx] && roots[idx] <= 1) {
	            intersection = calculateCurveAt(roots[idx], field, points);
	            if (Math.abs(intersection - point[field]) <= range) {
	                return true;
	            }
	        }
	    }
	}
	
	function curveIntersectionsCount(points, point, bbox) {
	    var polynomial = toCubicPolynomial(points, "x");
	    var roots = solveCubicEquation(polynomial[0], polynomial[1], polynomial[2], polynomial[3] - point.x);
	    var rayIntersection, intersectsRay;
	    var count = 0;
	    for (var i = 0; i < roots.length; i++) {
	        rayIntersection = calculateCurveAt(roots[i], "y", points);
	        intersectsRay = close$1(rayIntersection, point.y) || rayIntersection > point.y;
	        if (intersectsRay && (((roots[i] === 0 || roots[i] === 1) && bbox.bottomRight().x > point.x) || (0 < roots[i] && roots[i] < 1))) {
	            count++;
	        }
	    }
	
	    return count;
	}
	
	function lineIntersectionsCount(a, b, point) {
	    var intersects;
	    if (a.x !== b.x) {
	        var minX = Math.min(a.x, b.x);
	        var maxX = Math.max(a.x, b.x);
	        var minY = Math.min(a.y, b.y);
	        var maxY = Math.max(a.y, b.y);
	        var inRange = minX <= point.x && point.x < maxX;
	
	        if (minY === maxY) {
	            intersects = point.y <= minY && inRange;
	        } else {
	            intersects = inRange && (((maxY - minY) * ((a.x - b.x) * (a.y - b.y) > 0 ? point.x - minX : maxX - point.x)) / (maxX - minX) + minY - point.y) >= 0;
	        }
	    }
	
	    return intersects ? 1 : 0;
	}
	
	function pointAccessor(name) {
	    var fieldName = "_" + name;
	    return function(value) {
	        if (defined(value)) {
	            this._observerField(fieldName, Point.create(value));
	            this.geometryChange();
	            return this;
	        }
	
	        return this[fieldName];
	    };
	}
	
	function definePointAccessors(fn, names) {
	    for (var i = 0; i < names.length; i++) {
	        fn[names[i]] = pointAccessor(names[i]);
	    }
	}
	
	var withPoints = function (TBase, names) {
	    var result = (function (TBase) {
	        function result () {
	            TBase.apply(this, arguments);
	        }if ( TBase ) result.__proto__ = TBase;
	        result.prototype = Object.create( TBase && TBase.prototype );
	        result.prototype.constructor = result;
	
	        
	
	        return result;
	    }(TBase));
	    definePointAccessors(result.prototype, names);
	
	    return result;
	};
	
	var points = [ "anchor", "controlIn", "controlOut" ];
	
	var Segment = (function (superclass) {
	    function Segment(anchor, controlIn, controlOut) {
	        superclass.call(this);
	
	        this.anchor(anchor || new Point());
	        this.controlIn(controlIn);
	        this.controlOut(controlOut);
	    }
	
	    if ( superclass ) Segment.__proto__ = superclass;
	    Segment.prototype = Object.create( superclass && superclass.prototype );
	    Segment.prototype.constructor = Segment;
	
	    Segment.prototype.bboxTo = function bboxTo (toSegment, matrix) {
	        var segmentAnchor = this.anchor().transformCopy(matrix);
	        var toSegmentAnchor = toSegment.anchor().transformCopy(matrix);
	        var rect;
	
	        if (this.controlOut() && toSegment.controlIn()) {
	            rect = this._curveBoundingBox(
	                segmentAnchor, this.controlOut().transformCopy(matrix),
	                toSegment.controlIn().transformCopy(matrix), toSegmentAnchor
	            );
	        } else {
	            rect = this._lineBoundingBox(segmentAnchor, toSegmentAnchor);
	        }
	
	        return rect;
	    };
	
	    Segment.prototype._lineBoundingBox = function _lineBoundingBox (p1, p2) {
	        return Rect.fromPoints(p1, p2);
	    };
	
	    Segment.prototype._curveBoundingBox = function _curveBoundingBox (p1, cp1, cp2, p2) {
	        var points = [ p1, cp1, cp2, p2 ];
	        var extremesX = this._curveExtremesFor(points, "x");
	        var extremesY = this._curveExtremesFor(points, "y");
	        var xLimits = arrayLimits([ extremesX.min, extremesX.max, p1.x, p2.x ]);
	        var yLimits = arrayLimits([ extremesY.min, extremesY.max, p1.y, p2.y ]);
	
	        return Rect.fromPoints(new Point(xLimits.min, yLimits.min), new Point(xLimits.max, yLimits.max));
	    };
	
	    Segment.prototype._curveExtremesFor = function _curveExtremesFor (points, field) {
	        var extremes = this._curveExtremes(
	            points[0][field], points[1][field],
	            points[2][field], points[3][field]
	        );
	
	        return {
	            min: calculateCurveAt(extremes.min, field, points),
	            max: calculateCurveAt(extremes.max, field, points)
	        };
	    };
	
	    Segment.prototype._curveExtremes = function _curveExtremes (x1, x2, x3, x4) {
	        var a = x1 - 3 * x2 + 3 * x3 - x4;
	        var b = - 2 * (x1 - 2 * x2 + x3);
	        var c = x1 - x2;
	        var sqrt = Math.sqrt(b * b - 4 * a * c);
	        var t1 = 0;
	        var t2 = 1;
	
	        if (a === 0) {
	            if (b !== 0) {
	                t1 = t2 = -c / b;
	            }
	        } else if (!isNaN(sqrt)) {
	            t1 = (- b + sqrt) / (2 * a);
	            t2 = (- b - sqrt) / (2 * a);
	        }
	
	        var min = Math.max(Math.min(t1, t2), 0);
	        if (min < 0 || min > 1) {
	            min = 0;
	        }
	
	        var max = Math.min(Math.max(t1, t2), 1);
	        if (max > 1 || max < 0) {
	            max = 1;
	        }
	
	        return {
	            min: min,
	            max: max
	        };
	    };
	
	    Segment.prototype._intersectionsTo = function _intersectionsTo (segment, point) {
	        var intersectionsCount;
	        if (this.controlOut() && segment.controlIn()) {
	            intersectionsCount = curveIntersectionsCount([ this.anchor(), this.controlOut(), segment.controlIn(), segment.anchor() ], point, this.bboxTo(segment));
	        } else {
	            intersectionsCount = lineIntersectionsCount(this.anchor(), segment.anchor(), point);
	        }
	        return intersectionsCount;
	    };
	
	    Segment.prototype._isOnCurveTo = function _isOnCurveTo (segment, point, width, endSegment) {
	        var bbox = this.bboxTo(segment).expand(width, width);
	        if (bbox.containsPoint(point)) {
	            var p1 = this.anchor();
	            var p2 = this.controlOut();
	            var p3 = segment.controlIn();
	            var p4 = segment.anchor();
	
	            if (endSegment === "start" && p1.distanceTo(point) <= width) {
	                return !isOutOfEndPoint(p1, p2, point);
	            } else if (endSegment === "end" && p4.distanceTo(point) <= width) {
	                return !isOutOfEndPoint(p4, p3, point);
	            }
	
	            //the approach is not entirely correct but is close and the alternatives are solving a 6th degree polynomial or testing the segment points
	            var points = [ p1, p2, p3, p4 ];
	            if (hasRootsInRange(points, point, "x", "y", width) || hasRootsInRange(points, point, "y", "x", width)) {
	                return true;
	            }
	            var rotation = transform$1().rotate(45, point);
	            var rotatedPoints = [ p1.transformCopy(rotation), p2.transformCopy(rotation), p3.transformCopy(rotation), p4.transformCopy(rotation) ];
	            return hasRootsInRange(rotatedPoints, point, "x", "y", width) || hasRootsInRange(rotatedPoints, point, "y", "x", width);
	        }
	    };
	
	    Segment.prototype._isOnLineTo = function _isOnLineTo (segment, point, width) {
	        var p1 = this.anchor();
	        var p2 = segment.anchor();
	        var angle = deg(Math.atan2(p2.y - p1.y, p2.x - p1.x));
	        var rect = new Rect([ p1.x, p1.y - width / 2 ], [ p1.distanceTo(p2), width ]);
	        return rect.containsPoint(point.transformCopy(transform$1().rotate(-angle, p1)));
	    };
	
	    Segment.prototype._isOnPathTo = function _isOnPathTo (segment, point, width, endSegment) {
	        var isOnPath;
	        if (this.controlOut() && segment.controlIn()) {
	            isOnPath = this._isOnCurveTo(segment, point, width / 2, endSegment);
	        } else {
	            isOnPath = this._isOnLineTo(segment, point, width);
	        }
	        return isOnPath;
	    };
	
	    return Segment;
	}(withPoints(HasObservers, points)));
	
	function arrayLimits(arr) {
	    var length = arr.length;
	    var min = MAX_NUM;
	    var max = MIN_NUM;
	
	    for (var i = 0; i < length; i ++) {
	        max = Math.max(max, arr[i]);
	        min = Math.min(min, arr[i]);
	    }
	
	    return {
	        min: min,
	        max: max
	    };
	}
	
	
	
	var geometry = Object.freeze({
		Circle: Circle$2,
		Arc: Arc$2,
		Rect: Rect,
		Point: Point,
		Segment: Segment,
		Matrix: Matrix,
		Size: Size,
		toMatrix: toMatrix,
		Transformation: Transformation,
		transform: transform$1
	});
	
	var WEIGHT = 0.333;
	var EXTREMUM_ALLOWED_DEVIATION = 0.01;
	var X = "x";
	var Y = "y";
	
	function pointsToCurve(pointsIn, closed) {
	    var points = pointsIn.slice(0);
	    var segments = [];
	    var length = points.length;
	
	    if (length > 2) {
	        removeDuplicates(0, points);
	        length = points.length;
	    }
	
	    if (length < 2 || (length === 2 && points[0].equals(points[1]))) {
	        return segments;
	    }
	
	    var p0 = points[0];
	    var p1 = points[1];
	    var p2 = points[2];
	
	    segments.push(new Segment(p0));
	
	    while (p0.equals(points[length - 1])) {
	        closed = true;
	        points.pop();
	        length--;
	    }
	
	    if (length === 2) {
	        var tangent = getTangent(p0,p1, X, Y);
	
	        last(segments).controlOut(
	            firstControlPoint(tangent, p0, p1, X, Y)
	        );
	
	        segments.push(new Segment(
	            p1,
	            secondControlPoint(tangent, p0, p1, X, Y)
	        ));
	
	        return segments;
	    }
	
	    var initialControlPoint, lastControlPoint;
	
	    if (closed) {
	        p0 = points[length - 1]; p1 = points[0]; p2 = points[1];
	        var controlPoints = getControlPoints(p0, p1, p2);
	        initialControlPoint = controlPoints[1];
	        lastControlPoint = controlPoints[0];
	    } else {
	        var tangent$1 = getTangent(p0, p1, X,Y);
	        initialControlPoint = firstControlPoint(tangent$1, p0, p1, X, Y);
	    }
	
	    var cp0 = initialControlPoint;
	    for (var idx = 0; idx <= length - 3; idx++) {
	        removeDuplicates(idx, points);
	        length = points.length;
	        if (idx + 3 <= length) {
	            p0 = points[idx]; p1 = points[idx + 1]; p2 = points[idx + 2];
	            var controlPoints$1 = getControlPoints(p0,p1,p2);
	
	            last(segments).controlOut(cp0);
	            cp0 = controlPoints$1[1];
	
	            var cp1 = controlPoints$1[0];
	            segments.push(new Segment(p1, cp1));
	        }
	    }
	
	    if (closed) {
	        p0 = points[length - 2]; p1 = points[length - 1]; p2 = points[0];
	        var controlPoints$2 = getControlPoints(p0, p1, p2);
	
	        last(segments).controlOut(cp0);
	        segments.push(new Segment(
	            p1,
	            controlPoints$2[0]
	        ));
	
	        last(segments).controlOut(controlPoints$2[1]);
	        segments.push(new Segment(
	            p2,
	            lastControlPoint
	        ));
	    } else {
	        var tangent$2 = getTangent(p1, p2, X, Y);
	
	        last(segments).controlOut(cp0);
	        segments.push(new Segment(
	            p2,
	            secondControlPoint(tangent$2, p1, p2, X, Y)
	        ));
	    }
	
	    return segments;
	}
	
	
	
	function removeDuplicates(idx, points) {
	    while (points[idx + 1] && (points[idx].equals(points[idx + 1]) || points[idx + 1].equals(points[idx + 2]))) {
	        points.splice(idx + 1, 1);
	    }
	}
	
	function invertAxis(p0, p1, p2) {
	    var invertAxis = false;
	
	    if (p0.x === p1.x) {
	        invertAxis = true;
	    } else if (p1.x === p2.x) {
	        if ((p1.y < p2.y && p0.y <= p1.y) || (p2.y < p1.y && p1.y <= p0.y)) {
	            invertAxis = true;
	        }
	    } else {
	        var fn = lineFunction(p0,p1);
	        var y2 = calculateFunction(fn, p2.x);
	        if (!(p0.y <= p1.y && p2.y <= y2) &&
	            !(p1.y <= p0.y && p2.y >= y2)) {
	            invertAxis = true;
	        }
	    }
	
	    return invertAxis;
	}
	
	function isLine(p0, p1, p2) {
	    var fn = lineFunction(p0, p1);
	    var y2 = calculateFunction(fn, p2.x);
	
	    return (p0.x === p1.x && p1.x === p2.x) || round(y2, 1) === round(p2.y, 1);
	}
	
	function lineFunction(p1, p2) {
	    var a = (p2.y - p1.y) / (p2.x - p1.x);
	    var b = p1.y - a * p1.x;
	
	    return [ b, a ];
	}
	
	function getControlPoints(p0, p1, p2) {
	    var xField = X;
	    var yField = Y;
	    var restrict = false;
	    var switchOrientation = false;
	    var tangent;
	
	    if (isLine(p0, p1, p2)) {
	        tangent = getTangent(p0, p1, X, Y);
	    } else {
	        var monotonic = {
	            x: isMonotonicByField(p0, p1, p2, X),
	            y: isMonotonicByField(p0, p1, p2, Y)
	        };
	
	        if (monotonic.x && monotonic.y) {
	            tangent = getTangent(p0, p2, X, Y);
	            restrict = true;
	        } else {
	            if (invertAxis(p0, p1, p2)) {
	                xField = Y;
	                yField = X;
	            }
	
	            if (monotonic[xField]) {
	                tangent = 0;
	            } else {
	                var sign;
	                if ((p2[yField] < p0[yField] && p0[yField] <= p1[yField]) ||
	                    (p0[yField] < p2[yField] && p1[yField] <= p0[yField])) {
	                    sign = numberSign((p2[yField] - p0[yField]) * (p1[xField] - p0[xField]));
	                } else {
	                    sign = -numberSign((p2[xField] - p0[xField]) * (p1[yField] - p0[yField]));
	                }
	
	                tangent = EXTREMUM_ALLOWED_DEVIATION * sign;
	                switchOrientation = true;
	            }
	        }
	    }
	
	    var secondCP = secondControlPoint(tangent, p0, p1, xField, yField);
	
	    if (switchOrientation) {
	        var oldXField = xField;
	        xField = yField;
	        yField = oldXField;
	    }
	
	    var firstCP = firstControlPoint(tangent, p1, p2, xField, yField);
	
	    if (restrict) {
	        restrictControlPoint(p0, p1, secondCP, tangent);
	        restrictControlPoint(p1, p2, firstCP, tangent);
	    }
	
	    return [ secondCP, firstCP ];
	}
	
	function restrictControlPoint(p1, p2, cp, tangent) {
	    if (p1.y < p2.y) {
	        if (p2.y < cp.y) {
	            cp.x = p1.x + (p2.y - p1.y) / tangent;
	            cp.y = p2.y;
	        } else if (cp.y < p1.y) {
	            cp.x = p2.x - (p2.y - p1.y) / tangent;
	            cp.y = p1.y;
	        }
	    } else {
	        if (cp.y < p2.y) {
	            cp.x = p1.x - (p1.y - p2.y) / tangent;
	            cp.y = p2.y;
	        } else if (p1.y < cp.y) {
	            cp.x = p2.x + (p1.y - p2.y) / tangent;
	            cp.y = p1.y;
	        }
	    }
	}
	
	function getTangent(p0, p1, xField, yField) {
	    var x = p1[xField] - p0[xField];
	    var y = p1[yField] - p0[yField];
	    var tangent;
	
	    if (x === 0) {
	        tangent = 0;
	    } else {
	        tangent = y / x;
	    }
	
	    return tangent;
	}
	
	function isMonotonicByField(p0, p1, p2, field) {
	    return (p2[field] > p1[field] && p1[field] > p0[field]) ||
	                (p2[field] < p1[field] && p1[field] < p0[field]);
	}
	
	function firstControlPoint(tangent, p0, p3, xField, yField) {
	    var t1 = p0[xField];
	    var t2 = p3[xField];
	    var distance = (t2 - t1) * WEIGHT;
	
	    return point(t1 + distance, p0[yField] + distance * tangent, xField, yField);
	}
	
	function secondControlPoint(tangent, p0, p3, xField, yField) {
	    var t1 = p0[xField];
	    var t2 = p3[xField];
	    var distance = (t2 - t1) * WEIGHT;
	
	    return point(t2 - distance, p3[yField] - distance * tangent, xField, yField);
	}
	
	function point(xValue, yValue, xField, yField) {
	    var controlPoint = new Point();
	    controlPoint[xField] = xValue;
	    controlPoint[yField] = yValue;
	
	    return controlPoint;
	}
	
	function calculateFunction(fn, x) {
	    var length = fn.length;
	    var result = 0;
	
	    for (var i = 0; i < length; i++) {
	        result += Math.pow(x,i) * fn[i];
	    }
	    return result;
	}
	
	function numberSign(value) {
	    return value <= 0 ? -1 : 1;
	}
	
	var ShapeMap = {
	    l: function(path, options) {
	        var parameters = options.parameters;
	        var position = options.position;
	
	        for (var i = 0; i < parameters.length; i += 2) {
	            var point = new Point(parameters[i], parameters[i + 1]);
	
	            if (options.isRelative) {
	                point.translateWith(position);
	            }
	
	            path.lineTo(point.x, point.y);
	
	            position.x = point.x;
	            position.y = point.y;
	        }
	    },
	
	    c: function(path, options) {
	        var parameters = options.parameters;
	        var position = options.position;
	
	        for (var i = 0; i < parameters.length; i += 6) {
	            var controlOut = new Point(parameters[i], parameters[i + 1]);
	            var controlIn = new Point(parameters[i + 2], parameters[i + 3]);
	            var point = new Point(parameters[i + 4], parameters[i + 5]);
	            if (options.isRelative) {
	                controlIn.translateWith(position);
	                controlOut.translateWith(position);
	                point.translateWith(position);
	            }
	
	            path.curveTo(controlOut, controlIn, point);
	
	            position.x = point.x;
	            position.y = point.y;
	        }
	    },
	
	    v: function(path, options) {
	        var value = options.isRelative ? 0 : options.position.x;
	
	        toLineParamaters(options.parameters, true, value);
	        this.l(path, options);
	    },
	
	    h: function(path, options) {
	        var value = options.isRelative ? 0 : options.position.y;
	
	        toLineParamaters(options.parameters, false, value);
	        this.l(path, options);
	    },
	
	    a: function(path, options) {
	        var parameters = options.parameters;
	        var position = options.position;
	
	        for (var i = 0; i < parameters.length; i += 7) {
	            var radiusX = parameters[i];
	            var radiusY = parameters[i + 1];
	            var rotation = parameters[i + 2];
	            var largeArc = parameters[i + 3];
	            var swipe = parameters[i + 4];
	            var endPoint = new Point(parameters[i + 5], parameters[i + 6]);
	
	            if (options.isRelative) {
	                endPoint.translateWith(position);
	            }
	            if (position.x !== endPoint.x || position.y !== endPoint.y) {
	                path.arcTo(endPoint, radiusX, radiusY, largeArc, swipe, rotation);
	
	                position.x = endPoint.x;
	                position.y = endPoint.y;
	            }
	        }
	    },
	
	    s: function(path, options) {
	        var parameters = options.parameters;
	        var position = options.position;
	        var previousCommand = options.previousCommand;
	        var lastControlIn;
	
	        if (previousCommand === "s" || previousCommand === "c") {
	            lastControlIn = last(last(path.paths).segments).controlIn();
	        }
	
	        for (var i = 0; i < parameters.length; i += 4) {
	            var controlIn = new Point(parameters[i], parameters[i + 1]);
	            var endPoint = new Point(parameters[i + 2], parameters[i + 3]);
	            var controlOut = (void 0);
	
	            if (options.isRelative) {
	                controlIn.translateWith(position);
	                endPoint.translateWith(position);
	            }
	
	            if (lastControlIn) {
	                controlOut = reflectionPoint(lastControlIn, position);
	            } else {
	                controlOut = position.clone();
	            }
	
	            lastControlIn = controlIn;
	
	            path.curveTo(controlOut, controlIn, endPoint);
	
	            position.x = endPoint.x;
	            position.y = endPoint.y;
	        }
	    },
	
	    q: function(path, options) {
	        var parameters = options.parameters;
	        var position = options.position;
	
	        for (var i = 0; i < parameters.length; i += 4) {
	            var controlPoint = new Point(parameters[i], parameters[i + 1]);
	            var endPoint = new Point(parameters[i + 2], parameters[i + 3]);
	
	            if (options.isRelative) {
	                controlPoint.translateWith(position);
	                endPoint.translateWith(position);
	            }
	
	            var cubicControlPoints = quadraticToCubicControlPoints(position, controlPoint, endPoint);
	
	            path.curveTo(cubicControlPoints.controlOut, cubicControlPoints.controlIn, endPoint);
	
	            position.x = endPoint.x;
	            position.y = endPoint.y;
	        }
	    },
	
	    t: function(path, options) {
	        var parameters = options.parameters;
	        var position = options.position;
	        var previousCommand = options.previousCommand;
	        var controlPoint;
	
	        if (previousCommand === "q" || previousCommand === "t") {
	            var lastSegment = last(last(path.paths).segments);
	            controlPoint = lastSegment.controlIn().clone()
	                .translateWith(position.scaleCopy(-1 / 3))
	                .scale(3 / 2);
	        }
	
	        for (var i = 0; i < parameters.length; i += 2) {
	            var endPoint = new Point(parameters[i], parameters[i + 1]);
	            if (options.isRelative) {
	                endPoint.translateWith(position);
	            }
	
	            if (controlPoint) {
	                controlPoint = reflectionPoint(controlPoint, position);
	            } else {
	                controlPoint = position.clone();
	            }
	
	            var cubicControlPoints = quadraticToCubicControlPoints(position, controlPoint, endPoint);
	
	            path.curveTo(cubicControlPoints.controlOut, cubicControlPoints.controlIn, endPoint);
	
	            position.x = endPoint.x;
	            position.y = endPoint.y;
	        }
	    }
	};
	
	function toLineParamaters(parameters, isVertical, value) {
	    var insertPosition = isVertical ? 0 : 1;
	
	    for (var i = 0; i < parameters.length; i += 2) {
	        parameters.splice(i + insertPosition, 0, value);
	    }
	}
	
	function reflectionPoint(point, center) {
	    if (point && center) {
	        return center.scaleCopy(2).translate(-point.x, -point.y);
	    }
	}
	
	var third = 1 / 3;
	
	function quadraticToCubicControlPoints(position, controlPoint, endPoint) {
	    var scaledPoint = controlPoint.clone().scale(2 / 3);
	    return {
	        controlOut: scaledPoint.clone().translateWith(position.scaleCopy(third)),
	        controlIn: scaledPoint.translateWith(endPoint.scaleCopy(third))
	    };
	}
	
	var SEGMENT_REGEX = /([a-df-z]{1})([^a-df-z]*)(z)?/gi;
	var SPLIT_REGEX = /[,\s]?([+\-]?(?:\d*\.\d+|\d+)(?:[eE][+\-]?\d+)?)/g;
	var MOVE = "m";
	var CLOSE = "z";
	
	function parseParameters(str) {
	    var parameters = [];
	    str.replace(SPLIT_REGEX, function(match, number) {
	        parameters.push(parseFloat(number));
	    });
	    return parameters;
	}
	
	function parsePath(pathInstance, str) {
	    var position = new Point();
	    var previousCommand;
	
	    str.replace(SEGMENT_REGEX, function (match, element, params, closePath) {
	        var command = element.toLowerCase();
	        var isRelative = command === element;
	        var parameters = parseParameters(params.trim());
	
	        if (command === MOVE) {
	            if (isRelative) {
	                position.x += parameters[0];
	                position.y += parameters[1];
	            } else {
	                position.x = parameters[0];
	                position.y = parameters[1];
	            }
	
	            pathInstance.moveTo(position.x, position.y);
	
	            if (parameters.length > 2) {
	                command = "l";
	                parameters.splice(0, 2);
	            }
	        }
	
	        if (ShapeMap[command]) {
	            ShapeMap[command](
	                pathInstance, {
	                    parameters: parameters,
	                    position: position,
	                    isRelative: isRelative,
	                    previousCommand: previousCommand
	                }
	            );
	
	            if (closePath && closePath.toLowerCase() === CLOSE) {
	                pathInstance.close();
	            }
	        } else if (command !== MOVE) {
	            throw new Error("Error while parsing SVG path. Unsupported command: " + command);
	        }
	
	        previousCommand = command;
	    });
	
	    return pathInstance;
	}
	
	function elementsBoundingBox(elements, applyTransform, transformation) {
	    var boundingBox;
	
	    for (var i = 0; i < elements.length; i++) {
	        var element = elements[i];
	        if (element.visible()) {
	            var elementBoundingBox = applyTransform ? element.bbox(transformation) : element.rawBBox();
	            if (elementBoundingBox) {
	                if (boundingBox) {
	                    boundingBox = Rect.union(boundingBox, elementBoundingBox);
	                } else {
	                    boundingBox = elementBoundingBox;
	                }
	            }
	        }
	    }
	
	    return boundingBox;
	}
	
	function elementsClippedBoundingBox(elements, transformation) {
	    var boundingBox;
	
	    for (var i = 0; i < elements.length; i++) {
	        var element = elements[i];
	        if (element.visible()) {
	            var elementBoundingBox = element.clippedBBox(transformation);
	            if (elementBoundingBox) {
	                if (boundingBox) {
	                    boundingBox = Rect.union(boundingBox, elementBoundingBox);
	                } else {
	                    boundingBox = elementBoundingBox;
	                }
	            }
	        }
	    }
	
	    return boundingBox;
	}
	
	var SPACE$1 = ' ';
	var printPoints = function (precision) { return function () {
	    var points = [], len = arguments.length;
	    while ( len-- ) points[ len ] = arguments[ len ];
	
	    return points.map(function (p) { return p.toString(precision); }).join(SPACE$1);
	 }    };
	var segmentType = function (segmentStart, segmentEnd) { return segmentStart.controlOut() && segmentEnd.controlIn() ? 'C' : 'L'; };
	
	var Path = (function (superclass) {
	    function Path(options) {
	        superclass.call(this, options);
	        this.segments = new GeometryElementsArray();
	        this.segments.addObserver(this);
	
	        if (!defined(this.options.stroke)) {
	            this.stroke('#000');
	
	            if (!defined(this.options.stroke.lineJoin)) {
	                this.options.set('stroke.lineJoin', 'miter');
	            }
	        }
	    }
	
	    if ( superclass ) Path.__proto__ = superclass;
	    Path.prototype = Object.create( superclass && superclass.prototype );
	    Path.prototype.constructor = Path;
	
	    var prototypeAccessors = { nodeType: {} };
	
	    prototypeAccessors.nodeType.get = function () {
	        return 'Path';
	    };
	
	    Path.prototype.moveTo = function moveTo (x, y) {
	        this.suspend();
	        this.segments.elements([]);
	        this.resume();
	
	        this.lineTo(x, y);
	
	        return this;
	    };
	
	    Path.prototype.lineTo = function lineTo (x, y) {
	        var point$$1 = defined(y) ? new Point(x, y) : x;
	        var segment = new Segment(point$$1);
	
	        this.segments.push(segment);
	
	        return this;
	    };
	
	    Path.prototype.curveTo = function curveTo (controlOut, controlIn, point$$1) {
	        if (this.segments.length > 0) {
	            var lastSegment = last(this.segments);
	            var segment = new Segment(point$$1, controlIn);
	            this.suspend();
	            lastSegment.controlOut(controlOut);
	            this.resume();
	
	            this.segments.push(segment);
	        }
	
	        return this;
	    };
	
	    Path.prototype.arc = function arc (startAngle, endAngle, radiusX, radiusY, anticlockwise) {
	        if (this.segments.length > 0) {
	            var lastSegment = last(this.segments);
	            var anchor = lastSegment.anchor();
	            var start = rad(startAngle);
	            var center = new Point(anchor.x - radiusX * Math.cos(start),
	                anchor.y - radiusY * Math.sin(start));
	            var arc = new Arc$2(center, {
	                startAngle: startAngle,
	                endAngle: endAngle,
	                radiusX: radiusX,
	                radiusY: radiusY,
	                anticlockwise: anticlockwise
	            });
	
	            this._addArcSegments(arc);
	        }
	
	        return this;
	    };
	
	    Path.prototype.arcTo = function arcTo (end, rx, ry, largeArc, swipe, rotation) {
	        if (this.segments.length > 0) {
	            var lastSegment = last(this.segments);
	            var anchor = lastSegment.anchor();
	            var arc = Arc$2.fromPoints(anchor, Point.create(end), rx, ry, largeArc, swipe, rotation);
	
	            this._addArcSegments(arc);
	        }
	        return this;
	    };
	
	    Path.prototype._addArcSegments = function _addArcSegments (arc) {
	        var this$1 = this;
	
	        this.suspend();
	
	        var curvePoints = arc.curvePoints();
	
	        for (var i = 1; i < curvePoints.length; i += 3) {
	            this$1.curveTo(curvePoints[i], curvePoints[i + 1], curvePoints[i + 2]);
	        }
	
	        this.resume();
	        this.geometryChange();
	    };
	
	    Path.prototype.close = function close () {
	        this.options.closed = true;
	        this.geometryChange();
	
	        return this;
	    };
	
	    Path.prototype.rawBBox = function rawBBox () {
	        return this._bbox();
	    };
	
	    Path.prototype.toString = function toString (digits) {
	        var output = '';
	
	        var segments = this.segments;
	        var length = segments.length;
	        if (length > 0) {
	            var parts = [];
	            var print = printPoints(digits);
	            var currentType;
	
	            for (var i = 1; i < length; i++) {
	                var type = segmentType(segments[i - 1], segments[i]);
	                if (type !== currentType) {
	                    currentType = type;
	                    parts.push(type);
	                }
	
	                if (type === 'L') {
	                    parts.push(print(segments[i].anchor()));
	                } else {
	                    parts.push(print(
	                        segments[i - 1].controlOut(), segments[i].controlIn(), segments[i].anchor()
	                    ));
	                }
	            }
	
	            output = 'M' + print(segments[0].anchor()) + SPACE$1 + parts.join(SPACE$1);
	            if (this.options.closed) {
	                output += 'Z';
	            }
	        }
	
	        return output;
	    };
	
	    Path.prototype._containsPoint = function _containsPoint (point$$1) {
	        var segments = this.segments;
	        var length = segments.length;
	        var intersectionsCount = 0;
	        var previous, current;
	
	        for (var idx = 1; idx < length; idx++) {
	            previous = segments[idx - 1];
	            current = segments[idx];
	            intersectionsCount += previous._intersectionsTo(current, point$$1);
	        }
	
	        if (this.options.closed || !segments[0].anchor().equals(segments[length - 1].anchor())) {
	            intersectionsCount += lineIntersectionsCount(segments[0].anchor(), segments[length - 1].anchor(), point$$1);
	        }
	
	        return intersectionsCount % 2 !== 0;
	    };
	
	    Path.prototype._isOnPath = function _isOnPath (point$$1, width) {
	        var segments = this.segments;
	        var length = segments.length;
	        var pathWidth = width || this.options.stroke.width;
	
	        if (length > 1) {
	            if (segments[0]._isOnPathTo(segments[1], point$$1, pathWidth, 'start')) {
	                return true;
	            }
	
	            for (var idx = 2; idx <= length - 2; idx++) {
	                if (segments[idx - 1]._isOnPathTo(segments[idx], point$$1, pathWidth)) {
	                    return true;
	                }
	            }
	
	            if (segments[length - 2]._isOnPathTo(segments[length - 1], point$$1, pathWidth, 'end')) {
	                return true;
	            }
	        }
	        return false;
	    };
	
	    Path.prototype._bbox = function _bbox (matrix) {
	        var segments = this.segments;
	        var length = segments.length;
	        var boundingBox;
	
	        if (length === 1) {
	            var anchor = segments[0].anchor().transformCopy(matrix);
	            boundingBox = new Rect(anchor, Size.ZERO);
	        } else if (length > 0) {
	            for (var i = 1; i < length; i++) {
	                var segmentBox = segments[i - 1].bboxTo(segments[i], matrix);
	                if (boundingBox) {
	                    boundingBox = Rect.union(boundingBox, segmentBox);
	                } else {
	                    boundingBox = segmentBox;
	                }
	            }
	        }
	
	        return boundingBox;
	    };
	
	    Path.parse = function parse (str, options) {
	        return MultiPath.parse(str, options);
	    };
	
	    Path.fromRect = function fromRect (rect, options) {
	        var path = new Path(options);
	        var ref = rect.cornerRadius;
	        var rx = ref[0];
	        var ry = ref[1];
	
	        if (rx === 0 && ry === 0) {
	            path.moveTo(rect.topLeft())
	                .lineTo(rect.topRight())
	                .lineTo(rect.bottomRight())
	                .lineTo(rect.bottomLeft())
	                .close();
	        } else {
	            var origin = rect.origin;
	            var x = origin.x;
	            var y = origin.y;
	            var width = rect.width();
	            var height = rect.height();
	            rx = limitValue(rx, 0, width / 2);
	            ry = limitValue(ry, 0, height / 2);
	
	            path.moveTo(x + rx, y)
	                .lineTo(x + width - rx, y)
	                .arcTo([ x + width, y + ry ], rx, ry, false)
	                .lineTo(x + width, y + height - ry)
	                .arcTo([ x + width - rx, y + height ], rx, ry, false)
	                .lineTo(x + rx, y + height)
	                .arcTo([ x, y + height - ry ], rx, ry, false)
	                .lineTo(x, y + ry)
	                .arcTo([ x + rx, y ], rx, ry, false);
	        }
	
	        return path;
	    };
	
	    Path.fromPoints = function fromPoints (points, options) {
	        if (points) {
	            var path = new Path(options);
	
	            for (var i = 0; i < points.length; i++) {
	                var point$$1 = Point.create(points[i]);
	                if (point$$1) {
	                    if (i === 0) {
	                        path.moveTo(point$$1);
	                    } else {
	                        path.lineTo(point$$1);
	                    }
	                }
	            }
	
	            return path;
	        }
	    };
	
	    Path.curveFromPoints = function curveFromPoints (points, options) {
	        if (points) {
	            var segments = pointsToCurve(points);
	            var path = new Path(options);
	            path.segments.push.apply(path.segments, segments);
	
	            return path;
	        }
	    };
	
	    Path.fromArc = function fromArc (arc, options) {
	        var path = new Path(options);
	        var startAngle = arc.startAngle;
	        var start = arc.pointAt(startAngle);
	        path.moveTo(start.x, start.y);
	        path.arc(startAngle, arc.endAngle, arc.radiusX, arc.radiusY, arc.anticlockwise);
	        return path;
	    };
	
	    Object.defineProperties( Path.prototype, prototypeAccessors );
	
	    return Path;
	}(paintable(measurable(Element$1))));
	
	var MultiPath = (function (superclass) {
	    function MultiPath(options) {
	        superclass.call(this, options);
	        this.paths = new GeometryElementsArray();
	        this.paths.addObserver(this);
	
	        if (!defined(this.options.stroke)) {
	            this.stroke('#000');
	        }
	    }
	
	    if ( superclass ) MultiPath.__proto__ = superclass;
	    MultiPath.prototype = Object.create( superclass && superclass.prototype );
	    MultiPath.prototype.constructor = MultiPath;
	
	    var prototypeAccessors$1 = { nodeType: {} };
	
	    MultiPath.parse = function parse (str, options) {
	        var instance = new MultiPath(options);
	        return parsePath(instance, str);
	    };
	
	    MultiPath.prototype.toString = function toString (digits) {
	        var paths = this.paths;
	        var output = '';
	
	        if (paths.length > 0) {
	            var result = [];
	
	            for (var i = 0; i < paths.length; i++) {
	                result.push(paths[i].toString(digits));
	            }
	
	            output = result.join(SPACE$1);
	        }
	
	        return output;
	    };
	
	    prototypeAccessors$1.nodeType.get = function () {
	        return 'MultiPath';
	    };
	
	    MultiPath.prototype.moveTo = function moveTo (x, y) {
	        var path = new Path();
	        path.moveTo(x, y);
	
	        this.paths.push(path);
	
	        return this;
	    };
	
	    MultiPath.prototype.lineTo = function lineTo (x, y) {
	        if (this.paths.length > 0) {
	            last(this.paths).lineTo(x, y);
	        }
	
	        return this;
	    };
	
	    MultiPath.prototype.curveTo = function curveTo (controlOut, controlIn, point$$1) {
	        if (this.paths.length > 0) {
	            last(this.paths).curveTo(controlOut, controlIn, point$$1);
	        }
	
	        return this;
	    };
	
	    MultiPath.prototype.arc = function arc (startAngle, endAngle, radiusX, radiusY, anticlockwise) {
	        if (this.paths.length > 0) {
	            last(this.paths).arc(startAngle, endAngle, radiusX, radiusY, anticlockwise);
	        }
	
	        return this;
	    };
	
	    MultiPath.prototype.arcTo = function arcTo (end, rx, ry, largeArc, swipe, rotation) {
	        if (this.paths.length > 0) {
	            last(this.paths).arcTo(end, rx, ry, largeArc, swipe, rotation);
	        }
	
	        return this;
	    };
	
	    MultiPath.prototype.close = function close () {
	        if (this.paths.length > 0) {
	            last(this.paths).close();
	        }
	
	        return this;
	    };
	
	    MultiPath.prototype._bbox = function _bbox (matrix) {
	        return elementsBoundingBox(this.paths, true, matrix);
	    };
	
	    MultiPath.prototype.rawBBox = function rawBBox () {
	        return elementsBoundingBox(this.paths, false);
	    };
	
	    MultiPath.prototype._containsPoint = function _containsPoint (point$$1) {
	        var paths = this.paths;
	
	        for (var idx = 0; idx < paths.length; idx++) {
	            if (paths[idx]._containsPoint(point$$1)) {
	                return true;
	            }
	        }
	        return false;
	    };
	
	    MultiPath.prototype._isOnPath = function _isOnPath (point$$1) {
	        var paths = this.paths;
	        var width = this.options.stroke.width;
	
	        for (var idx = 0; idx < paths.length; idx++) {
	            if (paths[idx]._isOnPath(point$$1, width)) {
	                return true;
	            }
	        }
	        return false;
	    };
	
	    MultiPath.prototype._clippedBBox = function _clippedBBox (transformation) {
	        return elementsClippedBoundingBox(this.paths, this.currentTransform(transformation));
	    };
	
	    Object.defineProperties( MultiPath.prototype, prototypeAccessors$1 );
	
	    return MultiPath;
	}(paintable(measurable(Element$1))));
	
	var DEFAULT_STROKE$1 = "#000";
	
	var Arc = (function (superclass) {
	    function Arc(geometry, options) {
	        if ( geometry === void 0 ) geometry = new Arc$2();
	        if ( options === void 0 ) options = {};
	
	        superclass.call(this, options);
	
	        this.geometry(geometry);
	
	        if (!defined(this.options.stroke)) {
	            this.stroke(DEFAULT_STROKE$1);
	        }
	    }
	
	    if ( superclass ) Arc.__proto__ = superclass;
	    Arc.prototype = Object.create( superclass && superclass.prototype );
	    Arc.prototype.constructor = Arc;
	
	    var prototypeAccessors = { nodeType: {} };
	
	    prototypeAccessors.nodeType.get = function () {
	        return "Arc";
	    };
	
	    Arc.prototype._bbox = function _bbox (matrix) {
	        return this._geometry.bbox(matrix);
	    };
	
	    Arc.prototype.rawBBox = function rawBBox () {
	        return this.geometry().bbox();
	    };
	
	    Arc.prototype.toPath = function toPath () {
	        var path = new Path();
	        var curvePoints = this.geometry().curvePoints();
	
	        if (curvePoints.length > 0) {
	            path.moveTo(curvePoints[0].x, curvePoints[0].y);
	
	            for (var i = 1; i < curvePoints.length; i += 3) {
	                path.curveTo(curvePoints[i], curvePoints[i + 1], curvePoints[i + 2]);
	            }
	        }
	
	        return path;
	    };
	
	    Arc.prototype._containsPoint = function _containsPoint (point) {
	        return this.geometry().containsPoint(point);
	    };
	
	    Arc.prototype._isOnPath = function _isOnPath (point) {
	        return this.geometry()._isOnPath(point, this.options.stroke.width / 2);
	    };
	
	    Object.defineProperties( Arc.prototype, prototypeAccessors );
	
	    return Arc;
	}(paintable(measurable(withGeometry(Element$1)))));
	
	var DEFAULT_FONT = "12px sans-serif";
	var DEFAULT_FILL = "#000";
	
	var Text = (function (superclass) {
	    function Text(content, position, options) {
	        if ( position === void 0 ) position = new Point();
	        if ( options === void 0 ) options = {};
	
	        superclass.call(this, options);
	
	        this.content(content);
	        this.position(position);
	
	        if (!this.options.font) {
	            this.options.font = DEFAULT_FONT;
	        }
	
	        if (!defined(this.options.fill)) {
	            this.fill(DEFAULT_FILL);
	        }
	    }
	
	    if ( superclass ) Text.__proto__ = superclass;
	    Text.prototype = Object.create( superclass && superclass.prototype );
	    Text.prototype.constructor = Text;
	
	    var prototypeAccessors = { nodeType: {} };
	
	    prototypeAccessors.nodeType.get = function () {
	        return "Text";
	    };
	
	    Text.prototype.content = function content (value) {
	        if (defined(value)) {
	            this.options.set("content", value);
	            return this;
	        }
	
	        return this.options.get("content");
	    };
	
	    Text.prototype.measure = function measure () {
	        var metrics = measureText(this.content(), {
	            font: this.options.get("font")
	        });
	
	        return metrics;
	    };
	
	    Text.prototype.rect = function rect () {
	        var size = this.measure();
	        var pos = this.position().clone();
	        return new Rect(pos, [ size.width, size.height ]);
	    };
	
	    Text.prototype.bbox = function bbox (transformation) {
	        var combinedMatrix = toMatrix(this.currentTransform(transformation));
	        return this.rect().bbox(combinedMatrix);
	    };
	
	    Text.prototype.rawBBox = function rawBBox () {
	        return this.rect().bbox();
	    };
	
	    Text.prototype._containsPoint = function _containsPoint (point) {
	        return this.rect().containsPoint(point);
	    };
	
	    Object.defineProperties( Text.prototype, prototypeAccessors );
	
	    return Text;
	}(paintable(withPoints(Element$1, [ "position" ]))));
	
	var Image$1 = (function (superclass) {
	    function Image(src, rect, options) {
	        if ( rect === void 0 ) rect = new Rect();
	        if ( options === void 0 ) options = {};
	
	        superclass.call(this, options);
	
	        this.src(src);
	        this.rect(rect);
	    }
	
	    if ( superclass ) Image.__proto__ = superclass;
	    Image.prototype = Object.create( superclass && superclass.prototype );
	    Image.prototype.constructor = Image;
	
	    var prototypeAccessors = { nodeType: {} };
	
	    prototypeAccessors.nodeType.get = function () {
	        return "Image";
	    };
	
	    Image.prototype.src = function src (value) {
	        if (defined(value)) {
	            this.options.set("src", value);
	            return this;
	        }
	
	        return this.options.get("src");
	    };
	
	    Image.prototype.bbox = function bbox (transformation) {
	        var combinedMatrix = toMatrix(this.currentTransform(transformation));
	        return this._rect.bbox(combinedMatrix);
	    };
	
	    Image.prototype.rawBBox = function rawBBox () {
	        return this._rect.bbox();
	    };
	
	    Image.prototype._containsPoint = function _containsPoint (point) {
	        return this._rect.containsPoint(point);
	    };
	
	    Image.prototype._hasFill = function _hasFill () {
	        return this.src();
	    };
	
	    Object.defineProperties( Image.prototype, prototypeAccessors );
	
	    return Image;
	}(withGeometry(Element$1, [ "rect" ])));
	
	var traversable = function (TBase, childrenField) { return (
	    (function (TBase) {
	        function anonymous () {
	            TBase.apply(this, arguments);
	        }
	
	        if ( TBase ) anonymous.__proto__ = TBase;
	        anonymous.prototype = Object.create( TBase && TBase.prototype );
	        anonymous.prototype.constructor = anonymous;
	
	        anonymous.prototype.traverse = function traverse (callback) {
	            var children = this[childrenField];
	
	            for (var i = 0; i < children.length; i++) {
	                var child = children[i];
	
	                if (child.traverse) {
	                    child.traverse(callback);
	                } else {
	                    callback(child);
	                }
	            }
	
	            return this;
	        };
	
	        return anonymous;
	    }(TBase))
	); };
	
	var Group = (function (superclass) {
	    function Group(options) {
	        superclass.call(this, options);
	        this.children = [];
	    }
	
	    if ( superclass ) Group.__proto__ = superclass;
	    Group.prototype = Object.create( superclass && superclass.prototype );
	    Group.prototype.constructor = Group;
	
	    var prototypeAccessors = { nodeType: {} };
	
	    prototypeAccessors.nodeType.get = function () {
	        return "Group";
	    };
	
	    Group.prototype.childrenChange = function childrenChange (action, items, index) {
	        this.trigger("childrenChange",{
	            action: action,
	            items: items,
	            index: index
	        });
	    };
	
	    Group.prototype.append = function append$1 () {
	        append$1$1(this.children, arguments);
	        this._reparent(arguments, this);
	
	        this.childrenChange("add", arguments);
	
	        return this;
	    };
	
	    Group.prototype.insert = function insert (index, element) {
	        this.children.splice(index, 0, element);
	        element.parent = this;
	
	        this.childrenChange("add", [ element ], index);
	
	        return this;
	    };
	
	    Group.prototype.insertAt = function insertAt (element, index) {
	        return this.insert(index, element);
	    };
	
	    Group.prototype.remove = function remove (element) {
	        var index = this.children.indexOf(element);
	        if (index >= 0) {
	            this.children.splice(index, 1);
	            element.parent = null;
	            this.childrenChange("remove", [ element ], index);
	        }
	
	        return this;
	    };
	
	    Group.prototype.removeAt = function removeAt (index) {
	        if (0 <= index && index < this.children.length) {
	            var element = this.children[index];
	            this.children.splice(index, 1);
	            element.parent = null;
	            this.childrenChange("remove", [ element ], index);
	        }
	
	        return this;
	    };
	
	    Group.prototype.clear = function clear () {
	        var items = this.children;
	        this.children = [];
	        this._reparent(items, null);
	
	        this.childrenChange("remove", items, 0);
	
	        return this;
	    };
	
	    Group.prototype.bbox = function bbox (transformation) {
	        return elementsBoundingBox(this.children, true, this.currentTransform(transformation));
	    };
	
	    Group.prototype.rawBBox = function rawBBox () {
	        return elementsBoundingBox(this.children, false);
	    };
	
	    Group.prototype._clippedBBox = function _clippedBBox (transformation) {
	        return elementsClippedBoundingBox(this.children, this.currentTransform(transformation));
	    };
	
	    Group.prototype.currentTransform = function currentTransform (transformation) {
	        return Element$1.prototype.currentTransform.call(this, transformation) || null;
	    };
	
	    Group.prototype.containsPoint = function containsPoint (point, parentTransform) {
	        if (this.visible()) {
	            var children = this.children;
	            var transform = this.currentTransform(parentTransform);
	            for (var idx = 0; idx < children.length; idx++) {
	                if (children[idx].containsPoint(point, transform)) {
	                    return true;
	                }
	            }
	        }
	        return false;
	    };
	
	    Group.prototype._reparent = function _reparent (elements, newParent) {
	        var this$1 = this;
	
	        for (var i = 0; i < elements.length; i++) {
	            var child = elements[i];
	            var parent = child.parent;
	            if (parent && parent !== this$1 && parent.remove) {
	                parent.remove(child);
	            }
	
	            child.parent = newParent;
	        }
	    };
	
	    Object.defineProperties( Group.prototype, prototypeAccessors );
	
	    return Group;
	}(traversable(Element$1, "children")));
	
	function translateToPoint(point, bbox, element) {
	    var transofrm = element.transform() || transform$1();
	    var matrix = transofrm.matrix();
	    matrix.e += point.x - bbox.origin.x;
	    matrix.f += point.y - bbox.origin.y;
	
	    transofrm.matrix(matrix);
	    element.transform(transofrm);
	}
	
	function alignStart(size, rect, align, axis, sizeField) {
	    var start;
	    if (align === "start") {
	        start = rect.origin[axis];
	    } else if (align === "end") {
	        start = rect.origin[axis] + rect.size[sizeField] - size;
	    } else {
	        start = rect.origin[axis] + (rect.size[sizeField] - size) / 2;
	    }
	
	    return start;
	}
	
	function alignStartReverse(size, rect, align, axis, sizeField) {
	    var start;
	    if (align === "start") {
	        start = rect.origin[axis] + rect.size[sizeField] - size;
	    } else if (align === "end") {
	        start = rect.origin[axis];
	    } else {
	        start = rect.origin[axis] + (rect.size[sizeField] - size) / 2;
	    }
	
	    return start;
	}
	
	var DEFAULT_OPTIONS$1 = {
	    alignContent: "start",
	    justifyContent: "start",
	    alignItems: "start",
	    spacing: 0,
	    orientation: "horizontal",
	    lineSpacing: 0,
	    wrap: true,
	    revers: false
	};
	
	var forEach = function (elements, callback) {
	    elements.forEach(callback);
	};
	
	var forEachReverse = function (elements, callback) {
	    var length = elements.length;
	
	    for (var idx = length - 1; idx >= 0; idx--) {
	        callback(elements[idx], idx);
	    }
	};
	
	var Layout = (function (Group$$1) {
	    function Layout(rect, options) {
	        Group$$1.call(this, Object.assign({}, DEFAULT_OPTIONS$1, options));
	        this._rect = rect;
	        this._fieldMap = {};
	    }
	
	    if ( Group$$1 ) Layout.__proto__ = Group$$1;
	    Layout.prototype = Object.create( Group$$1 && Group$$1.prototype );
	    Layout.prototype.constructor = Layout;
	
	    Layout.prototype.rect = function rect (value) {
	        if (value) {
	            this._rect = value;
	            return this;
	        }
	
	        return this._rect;
	    };
	
	    Layout.prototype._initMap = function _initMap () {
	        var options = this.options;
	        var fieldMap = this._fieldMap;
	        if (options.orientation === "horizontal") {
	            fieldMap.sizeField = "width";
	            fieldMap.groupsSizeField = "height";
	            fieldMap.groupAxis = "x";
	            fieldMap.groupsAxis = "y";
	        } else {
	            fieldMap.sizeField = "height";
	            fieldMap.groupsSizeField = "width";
	            fieldMap.groupAxis = "y";
	            fieldMap.groupsAxis = "x";
	        }
	
	        if (options.reverse) {
	            this.forEach = forEachReverse;
	            this.justifyAlign = alignStartReverse;
	        } else {
	            this.forEach = forEach;
	            this.justifyAlign = alignStart;
	        }
	    };
	
	    Layout.prototype.reflow = function reflow () {
	        var this$1 = this;
	
	        if (!this._rect || this.children.length === 0) {
	            return;
	        }
	        this._initMap();
	
	        if (this.options.transform) {
	            this.transform(null);
	        }
	
	        var options = this.options;
	        var rect = this._rect;
	        var ref = this._initGroups();
	        var groups = ref.groups;
	        var groupsSize = ref.groupsSize;
	        var ref$1 = this._fieldMap;
	        var sizeField = ref$1.sizeField;
	        var groupsSizeField = ref$1.groupsSizeField;
	        var groupAxis = ref$1.groupAxis;
	        var groupsAxis = ref$1.groupsAxis;
	        var groupOrigin = new Point();
	        var elementOrigin = new Point();
	        var size = new Size();
	        var groupStart = alignStart(groupsSize, rect, options.alignContent, groupsAxis, groupsSizeField);
	        var elementStart, group, groupBox;
	
	        var arrangeElements = function (bbox, idx) {
	            var element = group.elements[idx];
	
	            elementOrigin[groupAxis] = elementStart;
	            elementOrigin[groupsAxis] = alignStart(bbox.size[groupsSizeField], groupBox, options.alignItems, groupsAxis, groupsSizeField);
	            translateToPoint(elementOrigin, bbox, element);
	            elementStart += bbox.size[sizeField] + options.spacing;
	        };
	
	        for (var groupIdx = 0; groupIdx < groups.length; groupIdx++) {
	            group = groups[groupIdx];
	            groupOrigin[groupAxis] = elementStart = this$1.justifyAlign(group.size, rect, options.justifyContent, groupAxis, sizeField);
	            groupOrigin[groupsAxis] = groupStart;
	            size[sizeField] = group.size;
	            size[groupsSizeField] = group.lineSize;
	            groupBox = new Rect(groupOrigin, size);
	            this$1.forEach(group.bboxes, arrangeElements);
	
	            groupStart += group.lineSize + options.lineSpacing;
	        }
	
	        if (!options.wrap && group.size > rect.size[sizeField]) {
	            var scale = rect.size[sizeField] / groupBox.size[sizeField];
	            var scaledStart = groupBox.topLeft().scale(scale, scale);
	            var scaledSize = groupBox.size[groupsSizeField] * scale;
	            var newStart = alignStart(scaledSize, rect, options.alignContent, groupsAxis, groupsSizeField);
	            var transform = transform$1();
	            if (groupAxis === "x") {
	                transform.translate(rect.origin.x - scaledStart.x, newStart - scaledStart.y);
	            } else {
	                transform.translate(newStart - scaledStart.x, rect.origin.y - scaledStart.y);
	            }
	            transform.scale(scale, scale);
	
	            this.transform(transform);
	        }
	    };
	
	    Layout.prototype._initGroups = function _initGroups () {
	        var this$1 = this;
	
	        var ref = this;
	        var options = ref.options;
	        var children = ref.children;
	        var lineSpacing = options.lineSpacing;
	        var wrap = options.wrap;
	        var spacing = options.spacing;
	        var sizeField = this._fieldMap.sizeField;
	        var group = this._newGroup();
	        var groups = [];
	        var addGroup = function() {
	            groups.push(group);
	            groupsSize += group.lineSize + lineSpacing;
	        };
	        var groupsSize = -lineSpacing;
	
	        for (var idx = 0; idx < children.length; idx++) {
	            var element = children[idx];
	            var bbox = children[idx].clippedBBox();
	            if (element.visible() && bbox) {
	                if (wrap && group.size + bbox.size[sizeField] + spacing > this$1._rect.size[sizeField]) {
	                    if (group.bboxes.length === 0) {
	                        this$1._addToGroup(group, bbox, element);
	                        addGroup();
	                        group = this$1._newGroup();
	                    } else {
	                        addGroup();
	                        group = this$1._newGroup();
	                        this$1._addToGroup(group, bbox, element);
	                    }
	                } else {
	                    this$1._addToGroup(group, bbox, element);
	                }
	            }
	        }
	
	        if (group.bboxes.length) {
	            addGroup();
	        }
	
	        return {
	            groups: groups,
	            groupsSize: groupsSize
	        };
	    };
	
	    Layout.prototype._addToGroup = function _addToGroup (group, bbox, element) {
	        group.size += bbox.size[this._fieldMap.sizeField] + this.options.spacing;
	        group.lineSize = Math.max(bbox.size[this._fieldMap.groupsSizeField], group.lineSize);
	        group.bboxes.push(bbox);
	        group.elements.push(element);
	    };
	
	    Layout.prototype._newGroup = function _newGroup () {
	        return {
	            lineSize: 0,
	            size: -this.options.spacing,
	            bboxes: [],
	            elements: []
	        };
	    };
	
	    return Layout;
	}(Group));
	
	var Rect$2 = (function (superclass) {
	    function Rect$$1(geometry, options) {
	        if ( geometry === void 0 ) geometry = new Rect();
	        if ( options === void 0 ) options = {};
	
	        superclass.call(this, options);
	
	        this.geometry(geometry);
	
	        if (!defined(this.options.stroke)) {
	            this.stroke("#000");
	        }
	    }
	
	    if ( superclass ) Rect$$1.__proto__ = superclass;
	    Rect$$1.prototype = Object.create( superclass && superclass.prototype );
	    Rect$$1.prototype.constructor = Rect$$1;
	
	    var prototypeAccessors = { nodeType: {} };
	
	    prototypeAccessors.nodeType.get = function () {
	        return "Rect";
	    };
	
	    Rect$$1.prototype._bbox = function _bbox (matrix) {
	        return this._geometry.bbox(matrix);
	    };
	
	    Rect$$1.prototype.rawBBox = function rawBBox () {
	        return this._geometry.bbox();
	    };
	
	    Rect$$1.prototype._containsPoint = function _containsPoint (point) {
	        return this._geometry.containsPoint(point);
	    };
	
	    Rect$$1.prototype._isOnPath = function _isOnPath (point) {
	        return this.geometry()._isOnPath(point, this.options.stroke.width / 2);
	    };
	
	    Object.defineProperties( Rect$$1.prototype, prototypeAccessors );
	
	    return Rect$$1;
	}(paintable(measurable(withGeometry(Element$1)))));
	
	function alignElements(elements, rect, alignment, axis, sizeField) {
	    for (var idx = 0; idx < elements.length; idx++) {
	        var bbox = elements[idx].clippedBBox();
	        if (bbox) {
	            var point = bbox.origin.clone();
	            point[axis] = alignStart(bbox.size[sizeField], rect, alignment || "start", axis, sizeField);
	            translateToPoint(point, bbox, elements[idx]);
	        }
	    }
	}
	
	function align(elements, rect, alignment) {
	    alignElements(elements, rect, alignment, "x", "width");
	}
	
	function vAlign(elements, rect, alignment) {
	    alignElements(elements, rect, alignment, "y", "height");
	}
	
	function stackElements(elements, stackAxis, otherAxis, sizeField) {
	    if (elements.length > 1) {
	        var origin = new Point();
	        var previousBBox = elements[0].bbox;
	
	        for (var idx = 1; idx < elements.length; idx++) {
	            var element = elements[idx].element;
	            var bbox = elements[idx].bbox;
	            origin[stackAxis] = previousBBox.origin[stackAxis] + previousBBox.size[sizeField];
	            origin[otherAxis] = bbox.origin[otherAxis];
	            translateToPoint(origin, bbox, element);
	            bbox.origin[stackAxis] = origin[stackAxis];
	            previousBBox = bbox;
	        }
	    }
	}
	
	function createStackElements(elements) {
	    var stackElements = [];
	
	    for (var idx = 0; idx < elements.length; idx++) {
	        var element = elements[idx];
	        var bbox = element.clippedBBox();
	        if (bbox) {
	            stackElements.push({
	                element: element,
	                bbox: bbox
	            });
	        }
	    }
	
	    return stackElements;
	}
	
	function stack(elements) {
	    stackElements(createStackElements(elements), "x", "y", "width");
	}
	
	function vStack(elements) {
	    stackElements(createStackElements(elements), "y", "x", "height");
	}
	
	function getStacks(elements, rect, sizeField) {
	    var maxSize = rect.size[sizeField];
	    var stacks = [];
	    var stack = [];
	    var stackSize = 0;
	    var element, bbox;
	
	    var addElementToStack = function() {
	        stack.push({
	            element: element,
	            bbox: bbox
	        });
	    };
	
	    for (var idx = 0; idx < elements.length; idx++) {
	        element = elements[idx];
	
	        bbox = element.clippedBBox();
	        if (bbox) {
	            var size = bbox.size[sizeField];
	            if (stackSize + size > maxSize) {
	                if (stack.length) {
	                    stacks.push(stack);
	                    stack = [];
	                    addElementToStack();
	                    stackSize = size;
	                } else {
	                    addElementToStack();
	                    stacks.push(stack);
	                    stack = [];
	                    stackSize = 0;
	                }
	            } else {
	                addElementToStack();
	                stackSize += size;
	            }
	        }
	    }
	
	    if (stack.length) {
	        stacks.push(stack);
	    }
	
	    return stacks;
	}
	
	function wrapElements(elements, rect, axis, otherAxis, sizeField) {
	    var stacks = getStacks(elements, rect, sizeField);
	    var origin = rect.origin.clone();
	    var result = [];
	
	    for (var idx = 0; idx < stacks.length; idx++) {
	        var stack = stacks[idx];
	        var startElement = stack[0];
	        origin[otherAxis] = startElement.bbox.origin[otherAxis];
	        translateToPoint(origin, startElement.bbox, startElement.element);
	        startElement.bbox.origin[axis] = origin[axis];
	        stackElements(stack, axis, otherAxis, sizeField);
	        result.push([]);
	        for (var elementIdx = 0; elementIdx < stack.length; elementIdx++) {
	            result[idx].push(stack[elementIdx].element);
	        }
	    }
	    return result;
	}
	
	function wrap(elements, rect) {
	    return wrapElements(elements, rect, "x", "y", "width");
	}
	
	function vWrap(elements, rect) {
	    return wrapElements(elements, rect, "y", "x", "height");
	}
	
	function fit(element, rect) {
	    var bbox = element.clippedBBox();
	    if (bbox) {
	        var elementSize = bbox.size;
	        var rectSize = rect.size;
	        if (rectSize.width < elementSize.width || rectSize.height < elementSize.height) {
	            var scale = Math.min(rectSize.width / elementSize.width, rectSize.height / elementSize.height);
	            var transform = element.transform() || transform$1();
	            transform.scale(scale, scale);
	            element.transform(transform);
	        }
	    }
	}
	
	var StopsArray = (function (ElementsArray$$1) {
	    function StopsArray () {
	        ElementsArray$$1.apply(this, arguments);
	    }
	
	    if ( ElementsArray$$1 ) StopsArray.__proto__ = ElementsArray$$1;
	    StopsArray.prototype = Object.create( ElementsArray$$1 && ElementsArray$$1.prototype );
	    StopsArray.prototype.constructor = StopsArray;
	
	    StopsArray.prototype._change = function _change () {
	        this.optionsChange({
	            field: "stops"
	        });
	    };
	
	    return StopsArray;
	}(ElementsArray));
	
	function optionsAccessor(name) {
	    return function(value) {
	        if (defined(value)) {
	            this.options.set(name, value);
	            return this;
	        }
	
	        return this.options.get(name);
	    };
	}
	
	function defineOptionsAccessors(fn, names) {
	    for (var i = 0; i < names.length; i++) {
	        fn[names[i]] = optionsAccessor(names[i]);
	    }
	}
	
	var withOptions = function (TBase, names) {
	    var result = (function (TBase) {
	        function result () {
	            TBase.apply(this, arguments);
	        }if ( TBase ) result.__proto__ = TBase;
	        result.prototype = Object.create( TBase && TBase.prototype );
	        result.prototype.constructor = result;
	
	        
	
	        return result;
	    }(TBase));
	    defineOptionsAccessors(result.prototype, names);
	
	    return result;
	};
	
	var options = [ "offset", "color", "opacity" ];
	
	var GradientStop = (function (superclass) {
	    function GradientStop(offset, color, opacity) {
	        superclass.call(this);
	
	        this.options = new OptionsStore({
	            offset: offset,
	            color: color,
	            opacity: defined(opacity) ? opacity : 1
	        });
	
	        this.options.addObserver(this);
	    }
	
	    if ( superclass ) GradientStop.__proto__ = superclass;
	    GradientStop.prototype = Object.create( superclass && superclass.prototype );
	    GradientStop.prototype.constructor = GradientStop;
	
	    GradientStop.create = function create (arg) {
	        if (defined(arg)) {
	            var stop;
	            if (arg instanceof GradientStop) {
	                stop = arg;
	            } else if (arg.length > 1) {
	                stop = new GradientStop(arg[0], arg[1], arg[2]);
	            } else {
	                stop = new GradientStop(arg.offset, arg.color, arg.opacity);
	            }
	
	            return stop;
	        }
	    };
	
	    return GradientStop;
	}(withOptions(HasObservers, options)));
	
	var Gradient = (function (HasObservers$$1) {
	    function Gradient(options) {
	        if ( options === void 0 ) options = {};
	
	        HasObservers$$1.call(this);
	
	        this.stops = new StopsArray(this._createStops(options.stops));
	        this.stops.addObserver(this);
	        this._userSpace = options.userSpace;
	        this.id = definitionId();
	    }
	
	    if ( HasObservers$$1 ) Gradient.__proto__ = HasObservers$$1;
	    Gradient.prototype = Object.create( HasObservers$$1 && HasObservers$$1.prototype );
	    Gradient.prototype.constructor = Gradient;
	
	    var prototypeAccessors = { nodeType: {} };
	
	    prototypeAccessors.nodeType.get = function () {
	        return "Gradient";
	    };
	
	    Gradient.prototype.userSpace = function userSpace (value) {
	        if (defined(value)) {
	            this._userSpace = value;
	            this.optionsChange();
	            return this;
	        }
	
	        return this._userSpace;
	    };
	
	    Gradient.prototype._createStops = function _createStops (stops) {
	        if ( stops === void 0 ) stops = [];
	
	        var result = [];
	        for (var idx = 0; idx < stops.length; idx++) {
	            result.push(GradientStop.create(stops[idx]));
	        }
	
	        return result;
	    };
	
	    Gradient.prototype.addStop = function addStop (offset, color, opacity) {
	        this.stops.push(new GradientStop(offset, color, opacity));
	    };
	
	    Gradient.prototype.removeStop = function removeStop (stop) {
	        var index = this.stops.indexOf(stop);
	        if (index >= 0) {
	            this.stops.splice(index, 1);
	        }
	    };
	
	    Gradient.prototype.optionsChange = function optionsChange (e) {
	        this.trigger("optionsChange", {
	            field: "gradient" + (e ? "." + e.field : ""),
	            value: this
	        });
	    };
	
	    Gradient.prototype.geometryChange = function geometryChange () {
	        this.optionsChange();
	    };
	
	    Object.defineProperties( Gradient.prototype, prototypeAccessors );
	
	    return Gradient;
	}(HasObservers));
	
	var points$1 = [ "start", "end" ];
	
	var LinearGradient = (function (superclass) {
	    function LinearGradient(options) {
	        if ( options === void 0 ) options = {};
	
	        superclass.call(this, options);
	
	        this.start(options.start || new Point());
	        this.end(options.end || new Point(1, 0));
	    }
	
	    if ( superclass ) LinearGradient.__proto__ = superclass;
	    LinearGradient.prototype = Object.create( superclass && superclass.prototype );
	    LinearGradient.prototype.constructor = LinearGradient;
	
	    return LinearGradient;
	}(withPoints(Gradient, points$1)));
	
	var RadialGradient = (function (superclass) {
	    function RadialGradient(options) {
	        if ( options === void 0 ) options = {};
	
	        superclass.call(this, options);
	
	        this.center(options.center || new Point());
	        this._radius = defined(options.radius) ? options.radius : 1;
	        this._fallbackFill = options.fallbackFill;
	    }
	
	    if ( superclass ) RadialGradient.__proto__ = superclass;
	    RadialGradient.prototype = Object.create( superclass && superclass.prototype );
	    RadialGradient.prototype.constructor = RadialGradient;
	
	    RadialGradient.prototype.radius = function radius (value) {
	        if (defined(value)) {
	            this._radius = value;
	            this.geometryChange();
	            return this;
	        }
	
	        return this._radius;
	    };
	
	    RadialGradient.prototype.fallbackFill = function fallbackFill (value) {
	        if (defined(value)) {
	            this._fallbackFill = value;
	            this.optionsChange();
	            return this;
	        }
	
	        return this._fallbackFill;
	    };
	
	    return RadialGradient;
	}(withPoints(Gradient, [ "center" ])));
	
	function swing(position) {
	    return 0.5 - Math.cos(position * Math.PI) / 2;
	}
	
	function linear(position) {
	    return position;
	}
	
	function easeOutElastic(position, time, start, diff) {
	    var s = 1.70158,
	        p = 0,
	        a = diff;
	
	    if (position === 0) {
	        return start;
	    }
	
	    if (position === 1) {
	        return start + diff;
	    }
	
	    if (!p) {
	        p = 0.5;
	    }
	
	    if (a < Math.abs(diff)) {
	        a = diff;
	        s = p / 4;
	    } else {
	        s = p / (2 * Math.PI) * Math.asin(diff / a);
	    }
	
	    return a * Math.pow(2, -10 * position) *
	           Math.sin((Number(position) - s) * (1.1 * Math.PI) / p) + diff + start;
	}
	
	
	var easingFunctions = Object.freeze({
		swing: swing,
		linear: linear,
		easeOutElastic: easeOutElastic
	});
	
	var instance;
	
	var AnimationFactory = (function (Class$$1) {
	    function AnimationFactory() {
	        Class$$1.call(this);
	
	        this._items = [];
	    }
	
	    if ( Class$$1 ) AnimationFactory.__proto__ = Class$$1;
	    AnimationFactory.prototype = Object.create( Class$$1 && Class$$1.prototype );
	    AnimationFactory.prototype.constructor = AnimationFactory;
	
	    var staticAccessors = { current: {} };
	
	    staticAccessors.current.get = function () {
	        if (!instance) {
	            instance = new AnimationFactory();
	        }
	
	        return instance;
	    };
	
	    AnimationFactory.prototype.register = function register (name, type) {
	        this._items.push({
	            name: name,
	            type: type
	        });
	    };
	
	    AnimationFactory.prototype.create = function create (element, options) {
	        var items = this._items;
	        var match;
	
	        if (options && options.type) {
	            var type = options.type.toLowerCase();
	            for (var i = 0; i < items.length; i++) {
	                if (items[i].name.toLowerCase() === type) {
	                    match = items[i];
	                    break;
	                }
	            }
	        }
	
	        if (match) {
	            return new match.type(element, options);
	        }
	    };
	
	    Object.defineProperties( AnimationFactory, staticAccessors );
	
	    return AnimationFactory;
	}(Class));
	
	var Animation = (function (Class$$1) {
	    function Animation(element, options) {
	        Class$$1.call(this);
	
	        this.options = Object.assign({}, this.options, options);
	        this.element = element;
	    }
	
	    if ( Class$$1 ) Animation.__proto__ = Class$$1;
	    Animation.prototype = Object.create( Class$$1 && Class$$1.prototype );
	    Animation.prototype.constructor = Animation;
	
	    var prototypeAccessors = { options: {} };
	
	    Animation.create = function create (type, element, options) {
	        return AnimationFactory.current.create(type, element, options);
	    };
	
	    prototypeAccessors.options.get = function () {
	        return this._options || {
	            duration: 500,
	            easing: "swing"
	        };
	    };
	
	    prototypeAccessors.options.set = function (value) {
	        this._options = value;
	    };
	
	    Animation.prototype.setup = function setup () {};
	    Animation.prototype.step = function step () {};
	
	    Animation.prototype.play = function play () {
	        var this$1 = this;
	
	        var options = this.options;
	        var duration = options.duration;
	        var delay = options.delay; if ( delay === void 0 ) delay = 0;
	        var easing = easingFunctions[options.easing];
	        var start = now() + delay;
	        var finish = start + duration;
	
	        if (duration === 0) {
	            this.step(1);
	            this.abort();
	        } else {
	            setTimeout(function () {
	                var loop = function () {
	                    if (this$1._stopped) {
	                        return;
	                    }
	
	                    var wallTime = now();
	
	                    var time = limitValue(wallTime - start, 0, duration);
	                    var position = time / duration;
	                    var easingPosition = easing(position, time, 0, 1, duration);
	
	                    this$1.step(easingPosition);
	
	                    if (wallTime < finish) {
	                        animationFrame(loop);
	                    } else {
	                        this$1.abort();
	                    }
	                };
	
	                loop();
	            }, delay);
	        }
	    };
	
	    Animation.prototype.abort = function abort () {
	        this._stopped = true;
	    };
	
	    Animation.prototype.destroy = function destroy () {
	        this.abort();
	    };
	
	    Object.defineProperties( Animation.prototype, prototypeAccessors );
	
	    return Animation;
	}(Class));
	
	var instance$1;
	
	var PathParser = (function (Class$$1) {
	    function PathParser () {
	        Class$$1.apply(this, arguments);
	    }
	
	    if ( Class$$1 ) PathParser.__proto__ = Class$$1;
	    PathParser.prototype = Object.create( Class$$1 && Class$$1.prototype );
	    PathParser.prototype.constructor = PathParser;
	
	    var staticAccessors = { current: {} };
	
	    staticAccessors.current.get = function () {
	        if (!instance$1) {
	            instance$1 = new PathParser();
	        }
	
	        return instance$1;
	    };
	
	    PathParser.prototype.parse = function parse (str, options) {
	        var multiPath = new MultiPath(options);
	        return parsePath(multiPath, str);
	    };
	
	    Object.defineProperties( PathParser, staticAccessors );
	
	    return PathParser;
	}(Class));
	
	var BaseNode = (function (Class$$1) {
	    function BaseNode(srcElement) {
	        Class$$1.call(this);
	
	        this.childNodes = [];
	        this.parent = null;
	
	        if (srcElement) {
	            this.srcElement = srcElement;
	            this.observe();
	        }
	    }
	
	    if ( Class$$1 ) BaseNode.__proto__ = Class$$1;
	    BaseNode.prototype = Object.create( Class$$1 && Class$$1.prototype );
	    BaseNode.prototype.constructor = BaseNode;
	
	    BaseNode.prototype.destroy = function destroy () {
	        var this$1 = this;
	
	        if (this.srcElement) {
	            this.srcElement.removeObserver(this);
	        }
	
	        var children = this.childNodes;
	        for (var i = 0; i < children.length; i++) {
	            this$1.childNodes[i].destroy();
	        }
	
	        this.parent = null;
	    };
	
	    BaseNode.prototype.load = function load () {};
	
	    BaseNode.prototype.observe = function observe () {
	        if (this.srcElement) {
	            this.srcElement.addObserver(this);
	        }
	    };
	
	    BaseNode.prototype.append = function append (node) {
	        this.childNodes.push(node);
	        node.parent = this;
	    };
	
	    BaseNode.prototype.insertAt = function insertAt (node, pos) {
	        this.childNodes.splice(pos, 0, node);
	        node.parent = this;
	    };
	
	    BaseNode.prototype.remove = function remove (index, count) {
	        var this$1 = this;
	
	        var end = index + count;
	        for (var i = index; i < end; i++) {
	            this$1.childNodes[i].removeSelf();
	        }
	        this.childNodes.splice(index, count);
	    };
	
	    BaseNode.prototype.removeSelf = function removeSelf () {
	        this.clear();
	        this.destroy();
	    };
	
	    BaseNode.prototype.clear = function clear () {
	        this.remove(0, this.childNodes.length);
	    };
	
	    BaseNode.prototype.invalidate = function invalidate () {
	        if (this.parent) {
	            this.parent.invalidate();
	        }
	    };
	
	    BaseNode.prototype.geometryChange = function geometryChange () {
	        this.invalidate();
	    };
	
	    BaseNode.prototype.optionsChange = function optionsChange () {
	        this.invalidate();
	    };
	
	    BaseNode.prototype.childrenChange = function childrenChange (e) {
	        if (e.action === "add") {
	            this.load(e.items, e.index);
	        } else if (e.action === "remove") {
	            this.remove(e.index, e.items.length);
	        }
	
	        this.invalidate();
	    };
	
	    return BaseNode;
	}(Class));
	
	var events = [
	    "click",
	    "mouseenter",
	    "mouseleave",
	    "mousemove",
	    "resize"
	];
	
	var Surface$2 = (function (Observable$$1) {
	    function Surface(element, options) {
	        Observable$$1.call(this);
	
	        this.options = Object.assign({}, options);
	        this.element = element;
	        this.element._kendoExportVisual = this.exportVisual.bind(this);
	
	        this._click = this._handler("click");
	        this._mouseenter = this._handler("mouseenter");
	        this._mouseleave = this._handler("mouseleave");
	        this._mousemove = this._handler("mousemove");
	
	        this._visual = new Group();
	
	        elementSize(element, this.options);
	
	        this.bind(events, this.options);
	
	        this._enableTracking();
	    }
	
	    if ( Observable$$1 ) Surface.__proto__ = Observable$$1;
	    Surface.prototype = Object.create( Observable$$1 && Observable$$1.prototype );
	    Surface.prototype.constructor = Surface;
	
	    Surface.prototype.draw = function draw (element) {
	        this._visual.children.push(element);
	    };
	
	    Surface.prototype.clear = function clear () {
	        this._visual.children = [];
	    };
	
	    Surface.prototype.destroy = function destroy () {
	        this._visual = null;
	        this.element._kendoExportVisual = null;
	        this.unbind();
	    };
	
	    Surface.prototype.eventTarget = function eventTarget (e) {
	        var this$1 = this;
	
	        var domNode = eventElement(e);
	        var node;
	
	        while (!node && domNode) {
	            node = domNode._kendoNode;
	            if (domNode === this$1.element) {
	                break;
	            }
	
	            domNode = domNode.parentElement;
	        }
	
	        if (node) {
	            return node.srcElement;
	        }
	    };
	
	    Surface.prototype.exportVisual = function exportVisual () {
	        return this._visual;
	    };
	
	    Surface.prototype.getSize = function getSize () {
	        return elementSize(this.element);
	    };
	
	    Surface.prototype.currentSize = function currentSize (size) {
	        if (size) {
	            this._size = size;
	        } else {
	            return this._size;
	        }
	    };
	
	    Surface.prototype.setSize = function setSize (size) {
	        elementSize(this.element, size);
	
	        this.currentSize(size);
	        this._resize();
	    };
	
	    Surface.prototype.resize = function resize (force) {
	        var size = this.getSize();
	        var currentSize = this.currentSize();
	
	        if (force || (size.width > 0 || size.height > 0) && (!currentSize || size.width !== currentSize.width || size.height !== currentSize.height)) {
	            this.currentSize(size);
	            this._resize(size, force);
	            this.trigger("resize", size);
	        }
	    };
	
	    Surface.prototype.size = function size (value) {
	        if (!value) {
	            return this.getSize();
	        }
	
	        this.setSize(value);
	    };
	
	    Surface.prototype.suspendTracking = function suspendTracking () {
	        this._suspendedTracking = true;
	    };
	
	    Surface.prototype.resumeTracking = function resumeTracking () {
	        this._suspendedTracking = false;
	    };
	
	    Surface.prototype._enableTracking = function _enableTracking () {};
	
	    Surface.prototype._resize = function _resize () {};
	
	    Surface.prototype._handler = function _handler (eventName) {
	        var this$1 = this;
	
	        return function (e) {
	            var node = this$1.eventTarget(e);
	            if (node && !this$1._suspendedTracking) {
	                this$1.trigger(eventName, {
	                    element: node,
	                    originalEvent: e,
	                    type: eventName
	                });
	            }
	        };
	    };
	
	    Surface.prototype._elementOffset = function _elementOffset () {
	        var element = this.element;
	        var padding = elementPadding(element);
	        var ref = elementOffset(element);
	        var left = ref.left;
	        var top = ref.top;
	
	        return {
	            left: left + padding.left,
	            top: top + padding.top
	        };
	    };
	
	    Surface.prototype._surfacePoint = function _surfacePoint (e) {
	        var offset = this._elementOffset();
	        var coord = eventCoordinates(e);
	        var x = coord.x - offset.left;
	        var y = coord.y - offset.top;
	
	        var inverseTransform = elementScale(this.element).invert();
	        var point = new Point(
	            x,
	            y
	        ).transform(inverseTransform);
	
	        return point;
	    };
	
	    return Surface;
	}(Observable));
	
	function renderAttr(name, value) {
	    return (defined(value) && value !== null) ? (" " + name + "=\"" + value + "\" ") : "";
	}
	
	function renderAllAttr(attrs) {
	    var output = "";
	    for (var i = 0; i < attrs.length; i++) {
	        output += renderAttr(attrs[i][0], attrs[i][1]);
	    }
	
	    return output;
	}
	
	function renderStyle(attrs) {
	    var output = "";
	    for (var i = 0; i < attrs.length; i++) {
	        var value = attrs[i][1];
	        if (defined(value)) {
	            output += attrs[i][0] + ":" + value + ";";
	        }
	    }
	
	    if (output !== "") {
	        return output;
	    }
	}
	
	var NODE_MAP = {};
	
	var SVG_NS = "http://www.w3.org/2000/svg";
	var NONE = "none";
	var POINT_DIGITS = 3;
	
	var applyStyle = function (styleString, element) { return styleString.split(';').filter(function (s) { return s !== ''; }).forEach(function (s) {
	        var parts = s.split(':');
	        element.style[parts[0].trim()] = parts[1].trim();
	    }); };
	
	var styleAttr = 'data-style';
	var replaceStyleAttr = function (html) { return html.replace(/\sstyle=/g, ' ' + styleAttr + '='); };
	var restoreStyleAttr = function (container) {
	    Array.from(container.querySelectorAll('[' + styleAttr +']')).forEach(function (element) {
	        var styleString = element.getAttribute(styleAttr);
	        element.removeAttribute(styleAttr);
	        applyStyle(styleString, element);
	    });
	};
	
	var renderSVG = function(container, svg) {
	    container.innerHTML = replaceStyleAttr(svg);
	    restoreStyleAttr(container);
	};
	
	if (typeof document !== "undefined") {
	    var testFragment = "<svg xmlns='" + SVG_NS + "'></svg>";
	    var testContainer = document.createElement("div");
	    var hasParser = typeof DOMParser !== "undefined";
	
	    testContainer.innerHTML = testFragment;
	
	    if (hasParser && testContainer.firstChild.namespaceURI !== SVG_NS) {
	        renderSVG = function(container, svg) {
	            var parser = new DOMParser();
	            var chartDoc = parser.parseFromString(replaceStyleAttr(svg), "text/xml");
	            restoreStyleAttr(chartDoc);
	            var importedDoc = document.adoptNode(chartDoc.documentElement);
	
	            container.innerHTML = "";
	            container.appendChild(importedDoc);
	        };
	    }
	}
	
	var renderSVG$1 = renderSVG;
	
	var TRANSFORM = "transform";
	var DefinitionMap = {
	    clip: "clip-path",
	    fill: "fill"
	};
	
	function isDefinition(type, value) {
	    return type === "clip" || (type === "fill" && (!value || value.nodeType === "Gradient"));
	}
	
	function baseUrl() {
	    var base = document.getElementsByTagName("base")[0];
	    var href = document.location.href;
	    var url = "";
	
	    if (base && !(support.browser || {}).msie) {
	        var hashIndex = href.indexOf("#");
	        if (hashIndex !== -1) {
	            href = href.substring(0, hashIndex);
	        }
	
	        url = href;
	    }
	
	    return url;
	}
	
	var Node = (function (BaseNode$$1) {
	    function Node(srcElement, options) {
	        BaseNode$$1.call(this, srcElement);
	        this.definitions = {};
	
	        this.options = options;
	    }
	
	    if ( BaseNode$$1 ) Node.__proto__ = BaseNode$$1;
	    Node.prototype = Object.create( BaseNode$$1 && BaseNode$$1.prototype );
	    Node.prototype.constructor = Node;
	
	    Node.prototype.destroy = function destroy () {
	        if (this.element) {
	            this.element._kendoNode = null;
	            this.element = null;
	        }
	
	        this.clearDefinitions();
	        BaseNode$$1.prototype.destroy.call(this);
	    };
	
	    Node.prototype.load = function load (elements, pos) {
	        var this$1 = this;
	
	        for (var i = 0; i < elements.length; i++) {
	            var srcElement = elements[i];
	            var children = srcElement.children;
	
	            var childNode = new NODE_MAP[srcElement.nodeType](srcElement, this$1.options);
	
	            if (defined(pos)) {
	                this$1.insertAt(childNode, pos);
	            } else {
	                this$1.append(childNode);
	            }
	
	            childNode.createDefinitions();
	
	            if (children && children.length > 0) {
	                childNode.load(children);
	            }
	
	            var element = this$1.element;
	            if (element) {
	                childNode.attachTo(element, pos);
	            }
	        }
	    };
	
	    Node.prototype.root = function root () {
	        var root = this;
	
	        while (root.parent) {
	            root = root.parent;
	        }
	
	        return root;
	    };
	
	    Node.prototype.attachTo = function attachTo (domElement, pos) {
	        var container = document.createElement("div");
	        renderSVG$1(container,
	            "<svg xmlns='" + SVG_NS + "' version='1.1'>" +
	                this.render() +
	            "</svg>"
	        );
	
	        var element = container.firstChild.firstChild;
	        if (element) {
	            if (defined(pos)) {
	                domElement.insertBefore(element, domElement.childNodes[pos] || null);
	            } else {
	                domElement.appendChild(element);
	            }
	            this.setElement(element);
	        }
	    };
	
	    Node.prototype.setElement = function setElement (element) {
	        if (this.element) {
	            this.element._kendoNode = null;
	        }
	
	        this.element = element;
	        this.element._kendoNode = this;
	
	        var nodes = this.childNodes;
	        for (var i = 0; i < nodes.length; i++) {
	            var childElement = element.childNodes[i];
	            nodes[i].setElement(childElement);
	        }
	    };
	
	    Node.prototype.clear = function clear () {
	        this.clearDefinitions();
	
	        if (this.element) {
	            this.element.innerHTML = "";
	        }
	
	        var children = this.childNodes;
	        for (var i = 0; i < children.length; i++) {
	            children[i].destroy();
	        }
	
	        this.childNodes = [];
	    };
	
	    Node.prototype.removeSelf = function removeSelf () {
	        if (this.element) {
	            var parentNode = this.element.parentNode;
	            if (parentNode) {
	                parentNode.removeChild(this.element);
	            }
	            this.element = null;
	        }
	
	        BaseNode$$1.prototype.removeSelf.call(this);
	    };
	
	    Node.prototype.template = function template () {
	        return this.renderChildren();
	    };
	
	    Node.prototype.render = function render () {
	        return this.template();
	    };
	
	    Node.prototype.renderChildren = function renderChildren () {
	        var nodes = this.childNodes;
	        var output = "";
	
	        for (var i = 0; i < nodes.length; i++) {
	            output += nodes[i].render();
	        }
	
	        return output;
	    };
	
	    Node.prototype.optionsChange = function optionsChange (e) {
	        var field = e.field;
	        var value = e.value;
	
	        if (field === "visible") {
	            this.css("display", value ? "" : NONE);
	        } else if (DefinitionMap[field] && isDefinition(field, value)) {
	            this.updateDefinition(field, value);
	        } else if (field === "opacity") {
	            this.attr("opacity", value);
	        } else if (field === "cursor") {
	            this.css("cursor", value);
	        } else if (field === "id") {
	            if (value) {
	                this.attr("id", value);
	            } else {
	                this.removeAttr("id");
	            }
	        }
	
	        BaseNode$$1.prototype.optionsChange.call(this, e);
	    };
	
	    Node.prototype.accessibilityOptionsChange = function accessibilityOptionsChange (e) {
	        var field = e.field;
	        var value = e.value;
	
	
	        if (field === "role") {
	            if (value) {
	                this.attr("role", value);
	            } else {
	                this.removeAttr("role");
	            }
	        } else if (field === "ariaLabel") {
	            if (value) {
	                this.attr("aria-label", htmlEncode(value));
	            } else {
	                this.removeAttr("aria-label");
	            }
	        } else if (field === "ariaRoleDescription") {
	            if (value) {
	                this.attr("aria-roledescription", htmlEncode(value));
	            } else {
	                this.removeAttr("aria-roledescription");
	            }
	        } else if (field === "ariaChecked") {
	            if (defined(value)) {
	                this.attr("aria-checked", value);
	            } else {
	                this.removeAttr("aria-checked");
	            }
	        } else if (field === "className") {
	            this.className(value);
	        }
	    };
	
	    Node.prototype.attr = function attr (name, value) {
	        if (this.element) {
	            this.element.setAttribute(name, value);
	        }
	    };
	
	    Node.prototype.allAttr = function allAttr (attrs) {
	        var this$1 = this;
	
	        for (var i = 0; i < attrs.length; i++) {
	            this$1.attr(attrs[i][0], attrs[i][1]);
	        }
	    };
	
	    Node.prototype.toggleAttr = function toggleAttr (name, value) {
	        if (value) {
	            this.attr(name, value);
	        } else {
	            this.removeAttr(name);
	        }
	    };
	
	    Node.prototype.css = function css (name, value) {
	        if (this.element) {
	            this.element.style[name] = value;
	        }
	    };
	
	    Node.prototype.allCss = function allCss (styles) {
	        var this$1 = this;
	
	        for (var i = 0; i < styles.length; i++) {
	            this$1.css(styles[i][0], styles[i][1]);
	        }
	    };
	
	    Node.prototype.className = function className (value) {
	        var this$1 = this;
	
	        if (this.element) {
	            (ref = this.element.classList).remove.apply(ref, this.element.classList);
	            value.split(" ").forEach(function (item) {
	                this$1.element.classList.add(item);
	            });
	        }
	        var ref;
	    };
	
	    Node.prototype.removeAttr = function removeAttr (name) {
	        if (this.element) {
	            this.element.removeAttribute(name);
	        }
	    };
	
	    Node.prototype.mapTransform = function mapTransform (transform) {
	        var attrs = [];
	        if (transform) {
	            attrs.push([
	                TRANSFORM,
	                "matrix(" + transform.matrix().toString(6) + ")"
	            ]);
	        }
	
	        return attrs;
	    };
	
	    Node.prototype.renderTransform = function renderTransform () {
	        return renderAllAttr(
	            this.mapTransform(this.srcElement.transform())
	        );
	    };
	
	    Node.prototype.transformChange = function transformChange (value) {
	        if (value) {
	            this.allAttr(this.mapTransform(value));
	        } else {
	            this.removeAttr(TRANSFORM);
	        }
	    };
	
	    Node.prototype.mapStyle = function mapStyle () {
	        var options = this.srcElement.options;
	        var style = [ [ "cursor", options.cursor ] ];
	
	        if (options.visible === false) {
	            style.push([ "display", NONE ]);
	        }
	
	        return style;
	    };
	
	    Node.prototype.renderStyle = function renderStyle$1 () {
	        return renderAttr("style", renderStyle(this.mapStyle(true)));
	    };
	
	    Node.prototype.renderOpacity = function renderOpacity () {
	        return renderAttr("opacity", this.srcElement.options.opacity);
	    };
	
	    Node.prototype.renderId = function renderId () {
	        return renderAttr("id", this.srcElement.options.id);
	    };
	
	    Node.prototype.renderClassName = function renderClassName () {
	        return renderAttr("class", this.srcElement.options.className);
	    };
	
	    Node.prototype.renderRole = function renderRole () {
	        return renderAttr("role", this.srcElement.options.role);
	    };
	
	    Node.prototype.renderAriaLabel = function renderAriaLabel () {
	        var value = this.srcElement.options.ariaLabel;
	        if (value) {
	            value = htmlEncode(value);
	        }
	        return renderAttr("aria-label", value);
	    };
	
	    Node.prototype.renderAriaRoleDescription = function renderAriaRoleDescription () {
	        var value = this.srcElement.options.ariaRoleDescription;
	        if (value) {
	            value = htmlEncode(value);
	        }
	        return renderAttr("aria-roledescription", value);
	    };
	
	    Node.prototype.renderAriaChecked = function renderAriaChecked () {
	        return renderAttr("aria-checked", this.srcElement.options.ariaChecked);
	    };
	
	    Node.prototype.createDefinitions = function createDefinitions () {
	        var srcElement = this.srcElement;
	        var definitions = this.definitions;
	        if (srcElement) {
	            var options = srcElement.options;
	            var hasDefinitions;
	
	            for (var field in DefinitionMap) {
	                var definition = options.get(field);
	                if (definition && isDefinition(field, definition)) {
	                    definitions[field] = definition;
	                    hasDefinitions = true;
	                }
	            }
	            if (hasDefinitions) {
	                this.definitionChange({
	                    action: "add",
	                    definitions: definitions
	                });
	            }
	        }
	    };
	
	    Node.prototype.definitionChange = function definitionChange (e) {
	        if (this.parent) {
	            this.parent.definitionChange(e);
	        }
	    };
	
	    Node.prototype.updateDefinition = function updateDefinition (type, value) {
	        var definitions = this.definitions;
	        var current = definitions[type];
	        var attr = DefinitionMap[type];
	        var definition = {};
	        if (current) {
	            definition[type] = current;
	            this.definitionChange({
	                action: "remove",
	                definitions: definition
	            });
	            delete definitions[type];
	        }
	
	        if (!value) {
	            if (current) {
	                this.removeAttr(attr);
	            }
	        } else {
	            definition[type] = value;
	            this.definitionChange({
	                action: "add",
	                definitions: definition
	            });
	            definitions[type] = value;
	            this.attr(attr, this.refUrl(value.id));
	        }
	    };
	
	    Node.prototype.clearDefinitions = function clearDefinitions () {
	        var definitions = this.definitions;
	
	        this.definitionChange({
	            action: "remove",
	            definitions: definitions
	        });
	        this.definitions = {};
	    };
	
	    Node.prototype.renderDefinitions = function renderDefinitions () {
	        return renderAllAttr(this.mapDefinitions());
	    };
	
	    Node.prototype.mapDefinitions = function mapDefinitions () {
	        var this$1 = this;
	
	        var definitions = this.definitions;
	        var attrs = [];
	
	        for (var field in definitions) {
	            attrs.push([ DefinitionMap[field], this$1.refUrl(definitions[field].id) ]);
	        }
	
	        return attrs;
	    };
	
	    Node.prototype.refUrl = function refUrl (id) {
	        var skipBaseHref = (this.options || {}).skipBaseHref;
	        var baseHref = this.baseUrl().replace(/'/g, "\\'");
	        var base = skipBaseHref ? '' : baseHref;
	        return ("url(" + base + "#" + id + ")");
	    };
	
	    Node.prototype.baseUrl = function baseUrl$1 () {
	        return baseUrl();
	    };
	
	    return Node;
	}(BaseNode));
	
	var GradientStopNode = (function (Node$$1) {
	    function GradientStopNode () {
	        Node$$1.apply(this, arguments);
	    }
	
	    if ( Node$$1 ) GradientStopNode.__proto__ = Node$$1;
	    GradientStopNode.prototype = Object.create( Node$$1 && Node$$1.prototype );
	    GradientStopNode.prototype.constructor = GradientStopNode;
	
	    GradientStopNode.prototype.template = function template () {
	        return ("<stop " + (this.renderOffset()) + " " + (this.renderStyle()) + " />");
	    };
	
	    GradientStopNode.prototype.renderOffset = function renderOffset () {
	        return renderAttr("offset", this.srcElement.offset());
	    };
	
	    GradientStopNode.prototype.mapStyle = function mapStyle () {
	        var srcElement = this.srcElement;
	        return [
	            [ "stop-color", srcElement.color() ],
	            [ "stop-opacity", srcElement.opacity() ]
	        ];
	    };
	
	    GradientStopNode.prototype.optionsChange = function optionsChange (e) {
	        if (e.field === "offset") {
	            this.attr(e.field, e.value);
	        } else if (e.field === "color" || e.field === "opacity") {
	            this.css("stop-" + e.field, e.value);
	        }
	    };
	
	    return GradientStopNode;
	}(Node));
	
	var GradientNode = (function (Node$$1) {
	    function GradientNode(srcElement) {
	        Node$$1.call(this, srcElement);
	
	        this.id = srcElement.id;
	
	        this.loadStops();
	    }
	
	    if ( Node$$1 ) GradientNode.__proto__ = Node$$1;
	    GradientNode.prototype = Object.create( Node$$1 && Node$$1.prototype );
	    GradientNode.prototype.constructor = GradientNode;
	
	    GradientNode.prototype.loadStops = function loadStops () {
	        var this$1 = this;
	
	        var stops = this.srcElement.stops;
	        var element = this.element;
	
	        for (var idx = 0; idx < stops.length; idx++) {
	            var stopNode = new GradientStopNode(stops[idx]);
	            this$1.append(stopNode);
	            if (element) {
	                stopNode.attachTo(element);
	            }
	        }
	    };
	
	    GradientNode.prototype.optionsChange = function optionsChange (e) {
	        if (e.field === "gradient.stops") {
	            BaseNode.prototype.clear.call(this);
	            this.loadStops();
	        } else if (e.field === "gradient") {
	            this.allAttr(this.mapCoordinates());
	        }
	    };
	
	    GradientNode.prototype.renderCoordinates = function renderCoordinates () {
	        return renderAllAttr(this.mapCoordinates());
	    };
	
	    GradientNode.prototype.mapSpace = function mapSpace () {
	        return [ "gradientUnits", this.srcElement.userSpace() ? "userSpaceOnUse" : "objectBoundingBox" ];
	    };
	
	    return GradientNode;
	}(Node));
	
	var LinearGradientNode = (function (GradientNode$$1) {
	    function LinearGradientNode () {
	        GradientNode$$1.apply(this, arguments);
	    }
	
	    if ( GradientNode$$1 ) LinearGradientNode.__proto__ = GradientNode$$1;
	    LinearGradientNode.prototype = Object.create( GradientNode$$1 && GradientNode$$1.prototype );
	    LinearGradientNode.prototype.constructor = LinearGradientNode;
	
	    LinearGradientNode.prototype.template = function template () {
	        return ("<linearGradient id='" + (this.id) + "' " + (this.renderCoordinates()) + ">" + (this.renderChildren()) + "</linearGradient>");
	    };
	
	    LinearGradientNode.prototype.mapCoordinates = function mapCoordinates () {
	        var srcElement = this.srcElement;
	        var start = srcElement.start();
	        var end = srcElement.end();
	        var attrs = [
	            [ "x1", start.x ],
	            [ "y1", start.y ],
	            [ "x2", end.x ],
	            [ "y2", end.y ],
	            this.mapSpace()
	        ];
	
	        return attrs;
	    };
	
	    return LinearGradientNode;
	}(GradientNode));
	
	var RadialGradientNode = (function (GradientNode$$1) {
	    function RadialGradientNode () {
	        GradientNode$$1.apply(this, arguments);
	    }
	
	    if ( GradientNode$$1 ) RadialGradientNode.__proto__ = GradientNode$$1;
	    RadialGradientNode.prototype = Object.create( GradientNode$$1 && GradientNode$$1.prototype );
	    RadialGradientNode.prototype.constructor = RadialGradientNode;
	
	    RadialGradientNode.prototype.template = function template () {
	        return ("<radialGradient id='" + (this.id) + "' " + (this.renderCoordinates()) + ">" + (this.renderChildren()) + "</radialGradient>");
	    };
	
	    RadialGradientNode.prototype.mapCoordinates = function mapCoordinates () {
	        var srcElement = this.srcElement;
	        var center = srcElement.center();
	        var radius = srcElement.radius();
	        var attrs = [
	            [ "cx", center.x ],
	            [ "cy", center.y ],
	            [ "r", radius ],
	            this.mapSpace()
	        ];
	        return attrs;
	    };
	
	    return RadialGradientNode;
	}(GradientNode));
	
	var ClipNode = (function (Node$$1) {
	    function ClipNode(srcElement) {
	        Node$$1.call(this);
	
	        this.srcElement = srcElement;
	        this.id = srcElement.id;
	
	        this.load([ srcElement ]);
	    }
	
	    if ( Node$$1 ) ClipNode.__proto__ = Node$$1;
	    ClipNode.prototype = Object.create( Node$$1 && Node$$1.prototype );
	    ClipNode.prototype.constructor = ClipNode;
	
	    ClipNode.prototype.renderClipRule = function renderClipRule () {
	        return renderAttr("clip-rule", "evenodd");
	    };
	    ClipNode.prototype.template = function template () {
	        return ("<clipPath " + (this.renderClipRule()) + " id='" + (this.id) + "'>" + (this.renderChildren()) + "</clipPath>");
	    };
	
	    return ClipNode;
	}(Node));
	
	var DefinitionNode = (function (Node$$1) {
	    function DefinitionNode() {
	        Node$$1.call(this);
	        this.definitionMap = {};
	    }
	
	    if ( Node$$1 ) DefinitionNode.__proto__ = Node$$1;
	    DefinitionNode.prototype = Object.create( Node$$1 && Node$$1.prototype );
	    DefinitionNode.prototype.constructor = DefinitionNode;
	
	    DefinitionNode.prototype.attachTo = function attachTo (domElement) {
	        this.element = domElement;
	    };
	
	    DefinitionNode.prototype.template = function template () {
	        return ("<defs>" + (this.renderChildren()) + "</defs>");
	    };
	
	    DefinitionNode.prototype.definitionChange = function definitionChange (e) {
	        var definitions = e.definitions;
	        var action = e.action;
	
	        if (action === "add") {
	            this.addDefinitions(definitions);
	        } else if (action === "remove") {
	            this.removeDefinitions(definitions);
	        }
	    };
	
	    DefinitionNode.prototype.createDefinition = function createDefinition (type, item) {
	        var nodeType;
	        if (type === "clip") {
	            nodeType = ClipNode;
	        } else if (type === "fill") {
	            if (item instanceof LinearGradient) {
	                nodeType = LinearGradientNode;
	            } else if (item instanceof RadialGradient) {
	                nodeType = RadialGradientNode;
	            }
	        }
	        return new nodeType(item);
	    };
	
	    DefinitionNode.prototype.addDefinitions = function addDefinitions (definitions) {
	        var this$1 = this;
	
	        for (var field in definitions) {
	            this$1.addDefinition(field, definitions[field]);
	        }
	    };
	
	    DefinitionNode.prototype.addDefinition = function addDefinition (type, srcElement) {
	        var ref = this;
	        var element = ref.element;
	        var definitionMap = ref.definitionMap;
	        var id = srcElement.id;
	        var mapItem = definitionMap[id];
	        if (!mapItem) {
	            var node = this.createDefinition(type, srcElement);
	            definitionMap[id] = {
	                element: node,
	                count: 1
	            };
	            this.append(node);
	            if (element) {
	                node.attachTo(this.element);
	            }
	        } else {
	            mapItem.count++;
	        }
	    };
	
	    DefinitionNode.prototype.removeDefinitions = function removeDefinitions (definitions) {
	        var this$1 = this;
	
	        for (var field in definitions) {
	            this$1.removeDefinition(definitions[field]);
	        }
	    };
	
	    DefinitionNode.prototype.removeDefinition = function removeDefinition (srcElement) {
	        var definitionMap = this.definitionMap;
	        var id = srcElement.id;
	        var mapItem = definitionMap[id];
	
	        if (mapItem) {
	            mapItem.count--;
	            if (mapItem.count === 0) {
	                this.remove(this.childNodes.indexOf(mapItem.element), 1);
	                delete definitionMap[id];
	            }
	        }
	    };
	
	    return DefinitionNode;
	}(Node));
	
	var RootNode = (function (Node$$1) {
	    function RootNode(options) {
	        Node$$1.call(this);
	        this.options = options;
	        this.defs = new DefinitionNode();
	    }
	
	    if ( Node$$1 ) RootNode.__proto__ = Node$$1;
	    RootNode.prototype = Object.create( Node$$1 && Node$$1.prototype );
	    RootNode.prototype.constructor = RootNode;
	
	    RootNode.prototype.attachTo = function attachTo (domElement) {
	        this.element = domElement;
	        this.defs.attachTo(domElement.firstElementChild);
	    };
	
	    RootNode.prototype.clear = function clear () {
	        BaseNode.prototype.clear.call(this);
	    };
	
	    RootNode.prototype.template = function template () {
	        return this.defs.render() + this.renderChildren();
	    };
	
	    RootNode.prototype.definitionChange = function definitionChange (e) {
	        this.defs.definitionChange(e);
	    };
	
	    return RootNode;
	}(Node));
	
	var DASH_ARRAYS = {
	    dot: [ 1.5, 3.5 ],
	    dash: [ 4, 3.5 ],
	    longdash: [ 8, 3.5 ],
	    dashdot: [ 3.5, 3.5, 1.5, 3.5 ],
	    longdashdot: [ 8, 3.5, 1.5, 3.5 ],
	    longdashdotdot: [ 8, 3.5, 1.5, 3.5, 1.5, 3.5 ]
	};
	
	var SOLID = "solid";
	var BUTT = "butt";
	
	var ATTRIBUTE_MAP = {
	    "fill.opacity": "fill-opacity",
	    "stroke.color": "stroke",
	    "stroke.width": "stroke-width",
	    "stroke.opacity": "stroke-opacity"
	};
	
	var PathNode = (function (Node$$1) {
	    function PathNode () {
	        Node$$1.apply(this, arguments);
	    }
	
	    if ( Node$$1 ) PathNode.__proto__ = Node$$1;
	    PathNode.prototype = Object.create( Node$$1 && Node$$1.prototype );
	    PathNode.prototype.constructor = PathNode;
	
	    PathNode.prototype.geometryChange = function geometryChange () {
	        this.attr("d", this.renderData());
	        this.invalidate();
	    };
	
	    PathNode.prototype.optionsChange = function optionsChange (e) {
	        switch (e.field) {
	        case "fill":
	            if (e.value) {
	                this.allAttr(this.mapFill(e.value));
	            } else {
	                this.removeAttr("fill");
	            }
	            break;
	
	        case "fill.color":
	            this.allAttr(this.mapFill({ color: e.value }));
	            break;
	
	        case "stroke":
	            if (e.value) {
	                this.allAttr(this.mapStroke(e.value));
	            } else {
	                this.removeAttr("stroke");
	            }
	            break;
	
	        case "transform":
	            this.transformChange(e.value);
	            break;
	
	        default:
	            var name = ATTRIBUTE_MAP[e.field];
	            if (name) {
	                this.attr(name, e.value);
	            }
	            break;
	        }
	
	        this.accessibilityOptionsChange(e);
	
	        Node$$1.prototype.optionsChange.call(this, e);
	    };
	
	    PathNode.prototype.content = function content () {
	        if (this.element) {
	            this.element.textContent = this.srcElement.content();
	        }
	    };
	
	    PathNode.prototype.renderData = function renderData () {
	        return this.srcElement.toString(POINT_DIGITS) || undefined;
	    };
	
	    PathNode.prototype.mapStroke = function mapStroke (stroke) {
	        var attrs = [];
	
	        if (stroke && !isTransparent(stroke.color)) {
	            attrs.push([ "stroke", stroke.color ]);
	            attrs.push([ "stroke-width", stroke.width ]);
	            attrs.push([ "stroke-linecap", this.renderLinecap(stroke) ]);
	            attrs.push([ "stroke-linejoin", stroke.lineJoin ]);
	
	            if (defined(stroke.opacity)) {
	                attrs.push([ "stroke-opacity", stroke.opacity ]);
	            }
	
	            if (defined(stroke.dashType)) {
	                attrs.push([ "stroke-dasharray", this.renderDashType(stroke) ]);
	            }
	        } else {
	            attrs.push([ "stroke", NONE ]);
	        }
	
	        return attrs;
	    };
	
	    PathNode.prototype.renderStroke = function renderStroke () {
	        return renderAllAttr(
	            this.mapStroke(this.srcElement.options.stroke)
	        );
	    };
	
	    PathNode.prototype.renderDashType = function renderDashType (stroke) {
	        var dashType = stroke.dashType;
	        var width = stroke.width; if ( width === void 0 ) width = 1;
	
	        if (dashType && dashType !== SOLID) {
	            var dashArray = DASH_ARRAYS[dashType.toLowerCase()];
	            var result = [];
	
	            for (var i = 0; i < dashArray.length; i++) {
	                result.push(dashArray[i] * width);
	            }
	
	            return result.join(" ");
	        }
	    };
	
	    PathNode.prototype.renderLinecap = function renderLinecap (stroke) {
	        var dashType = stroke.dashType;
	        var lineCap = stroke.lineCap;
	
	        return (dashType && dashType !== "solid") ? BUTT : lineCap;
	    };
	
	    PathNode.prototype.mapFill = function mapFill (fill) {
	        var attrs = [];
	        if (!(fill && fill.nodeType === "Gradient")) {
	            if (fill && !isTransparent(fill.color)) {
	                attrs.push([ "fill", fill.color ]);
	
	                if (defined(fill.opacity)) {
	                    attrs.push([ "fill-opacity", fill.opacity ]);
	                }
	            } else {
	                attrs.push([ "fill", NONE ]);
	            }
	        }
	
	        return attrs;
	    };
	
	    PathNode.prototype.renderFill = function renderFill () {
	        return renderAllAttr(
	            this.mapFill(this.srcElement.options.fill)
	        );
	    };
	
	    PathNode.prototype.template = function template () {
	        return "<path " + (this.renderId()) + " " + (this.renderStyle()) + " " + (this.renderOpacity()) + " " + (renderAttr('d', this.renderData())) +
	                "" + (this.renderStroke()) + (this.renderFill()) + (this.renderDefinitions()) + (this.renderTransform()) +
	                (this.renderClassName()) + " " + (this.renderRole()) +
	                (this.renderAriaLabel()) + " " + (this.renderAriaRoleDescription()) +
	                (this.renderAriaChecked()) + " ></path>";
	    };
	
	    return PathNode;
	}(Node));
	
	var ArcNode = (function (PathNode$$1) {
	    function ArcNode () {
	        PathNode$$1.apply(this, arguments);
	    }
	
	    if ( PathNode$$1 ) ArcNode.__proto__ = PathNode$$1;
	    ArcNode.prototype = Object.create( PathNode$$1 && PathNode$$1.prototype );
	    ArcNode.prototype.constructor = ArcNode;
	
	    ArcNode.prototype.renderData = function renderData () {
	        return this.srcElement.toPath().toString(POINT_DIGITS);
	    };
	
	    return ArcNode;
	}(PathNode));
	
	var CircleNode = (function (PathNode$$1) {
	    function CircleNode () {
	        PathNode$$1.apply(this, arguments);
	    }
	
	    if ( PathNode$$1 ) CircleNode.__proto__ = PathNode$$1;
	    CircleNode.prototype = Object.create( PathNode$$1 && PathNode$$1.prototype );
	    CircleNode.prototype.constructor = CircleNode;
	
	    CircleNode.prototype.geometryChange = function geometryChange () {
	        var center = this.center();
	        this.attr("cx", center.x);
	        this.attr("cy", center.y);
	        this.attr("r", this.radius());
	        this.invalidate();
	    };
	
	    CircleNode.prototype.center = function center () {
	        return this.srcElement.geometry().center;
	    };
	
	    CircleNode.prototype.radius = function radius () {
	        return this.srcElement.geometry().radius;
	    };
	
	    CircleNode.prototype.template = function template () {
	        return "<circle " + (this.renderId()) + " " + (this.renderStyle()) + " " + (this.renderOpacity()) +
	                    "cx='" + (this.center().x) + "' cy='" + (this.center().y) + "' r='" + (this.radius()) + "'" +
	                    (this.renderStroke()) + " " + (this.renderFill()) + " " + (this.renderDefinitions()) +
	                    (this.renderClassName()) + " " + (this.renderRole()) +
	                    (this.renderAriaLabel()) + " " + (this.renderAriaRoleDescription()) +
	                    (this.renderAriaChecked()) + " " + (this.renderTransform()) + " ></circle>";
	    };
	
	    return CircleNode;
	}(PathNode));
	
	var GroupNode = (function (Node$$1) {
	    function GroupNode () {
	        Node$$1.apply(this, arguments);
	    }
	
	    if ( Node$$1 ) GroupNode.__proto__ = Node$$1;
	    GroupNode.prototype = Object.create( Node$$1 && Node$$1.prototype );
	    GroupNode.prototype.constructor = GroupNode;
	
	    GroupNode.prototype.template = function template () {
	        return ("<g" + (this.renderId() + 
	            this.renderTransform() + 
	            this.renderClassName() + 
	            this.renderStyle() + 
	            this.renderOpacity() + 
	            this.renderRole() + 
	            this.renderAriaLabel() + 
	            this.renderAriaRoleDescription() + 
	            this.renderAriaChecked() +
	            this.renderDefinitions()) + ">" + (this.renderChildren()) + "</g>");
	    };
	
	    GroupNode.prototype.optionsChange = function optionsChange (e) {
	        var field = e.field;
	        var value = e.value;
	
	        if (field === "transform") {
	            this.transformChange(value);
	        }
	
	        this.accessibilityOptionsChange(e);
	
	        Node$$1.prototype.optionsChange.call(this, e);
	    };
	
	    return GroupNode;
	}(Node));
	
	var ImageNode = (function (PathNode$$1) {
	    function ImageNode () {
	        PathNode$$1.apply(this, arguments);
	    }
	
	    if ( PathNode$$1 ) ImageNode.__proto__ = PathNode$$1;
	    ImageNode.prototype = Object.create( PathNode$$1 && PathNode$$1.prototype );
	    ImageNode.prototype.constructor = ImageNode;
	
	    ImageNode.prototype.geometryChange = function geometryChange () {
	        this.allAttr(this.mapPosition());
	        this.invalidate();
	    };
	
	    ImageNode.prototype.optionsChange = function optionsChange (e) {
	        if (e.field === "src") {
	            this.allAttr(this.mapSource());
	        }
	
	        PathNode$$1.prototype.optionsChange.call(this, e);
	    };
	
	    ImageNode.prototype.mapPosition = function mapPosition () {
	        var rect = this.srcElement.rect();
	        var tl = rect.topLeft();
	
	        return [
	            [ "x", tl.x ],
	            [ "y", tl.y ],
	            [ "width", rect.width() + "px" ],
	            [ "height", rect.height() + "px" ]
	        ];
	    };
	
	    ImageNode.prototype.renderPosition = function renderPosition () {
	        return renderAllAttr(this.mapPosition());
	    };
	
	    ImageNode.prototype.mapSource = function mapSource (encode) {
	        var src = this.srcElement.src();
	
	        if (encode) {
	            src = htmlEncode(src);
	        }
	
	        return [ [ "xlink:href", src ] ];
	    };
	
	    ImageNode.prototype.renderSource = function renderSource () {
	        return renderAllAttr(this.mapSource(true));
	    };
	
	    ImageNode.prototype.template = function template () {
	        return "<image preserveAspectRatio='none' " + (this.renderId()) + " " + (this.renderStyle()) + " " + (this.renderTransform()) + " " + (this.renderOpacity()) +
	               (this.renderPosition()) + " " + (this.renderSource()) + " " + (this.renderDefinitions()) +
	               (this.renderClassName()) + " " + (this.renderRole()) +
	                (this.renderAriaLabel()) + " " + (this.renderAriaRoleDescription()) +
	                (this.renderAriaChecked()) + " >" +
	               "</image>";
	    };
	
	    return ImageNode;
	}(PathNode));
	
	var MultiPathNode = (function (PathNode$$1) {
	    function MultiPathNode () {
	        PathNode$$1.apply(this, arguments);
	    }
	
	    if ( PathNode$$1 ) MultiPathNode.__proto__ = PathNode$$1;
	    MultiPathNode.prototype = Object.create( PathNode$$1 && PathNode$$1.prototype );
	    MultiPathNode.prototype.constructor = MultiPathNode;
	
	    MultiPathNode.prototype.renderData = function renderData () {
	        return this.srcElement.toString(POINT_DIGITS) || 'undefined';
	    };
	
	    return MultiPathNode;
	}(PathNode));
	
	var RectNode = (function (PathNode$$1) {
	    function RectNode () {
	        PathNode$$1.apply(this, arguments);
	    }
	
	    if ( PathNode$$1 ) RectNode.__proto__ = PathNode$$1;
	    RectNode.prototype = Object.create( PathNode$$1 && PathNode$$1.prototype );
	    RectNode.prototype.constructor = RectNode;
	
	    RectNode.prototype.geometryChange = function geometryChange () {
	        var geometry = this.srcElement.geometry();
	        this.attr("x", geometry.origin.x);
	        this.attr("y", geometry.origin.y);
	        this.attr("width", geometry.size.width);
	        this.attr("height", geometry.size.height);
	        this.attr("rx", geometry.cornerRadius[0]);
	        this.attr("ry", geometry.cornerRadius[1]);
	        this.invalidate();
	    };
	
	    RectNode.prototype.size = function size () {
	        return this.srcElement.geometry().size;
	    };
	
	    RectNode.prototype.origin = function origin () {
	        return this.srcElement.geometry().origin;
	    };
	
	    RectNode.prototype.rx = function rx () {
	        return this.srcElement.geometry().cornerRadius[0];
	    };
	
	    RectNode.prototype.ry = function ry () {
	        return this.srcElement.geometry().cornerRadius[1];
	    };
	
	    RectNode.prototype.template = function template () {
	        return "<rect " + (this.renderId()) + " " + (this.renderStyle()) + " " + (this.renderOpacity()) + " x='" + (this.origin().x) + "' y='" + (this.origin().y) + "' " +
	                    "rx='" + (this.rx()) + "' ry='" + (this.ry()) + "' " +
	                    "width='" + (this.size().width) + "' height='" + (this.size().height) + "' " + (this.renderStroke()) + " " +
	                    (this.renderFill()) + " " + (this.renderDefinitions()) + " " + (this.renderTransform()) +
	                    (this.renderClassName()) + " " + (this.renderRole()) +
	                    (this.renderAriaLabel()) + " " + (this.renderAriaRoleDescription()) +
	                    (this.renderAriaChecked()) + " />";
	    };
	
	    return RectNode;
	}(PathNode));
	
	var ENTITY_REGEX = /&(?:[a-zA-Z]+|#\d+);/g;
	
	function decodeEntities(text) {
	    if (!text || typeof text !== "string" || !ENTITY_REGEX.test(text)) {
	        return text;
	    }
	
	    var element = decodeEntities._element;
	    ENTITY_REGEX.lastIndex = 0;
	
	    return text.replace(ENTITY_REGEX, function (match) {
	        element.innerHTML = match;
	
	        return element.textContent || element.innerText;
	    });
	}
	
	if (typeof document !== "undefined") {
	    decodeEntities._element = document.createElement("span");
	}
	
	var TextNode = (function (PathNode$$1) {
	    function TextNode () {
	        PathNode$$1.apply(this, arguments);
	    }
	
	    if ( PathNode$$1 ) TextNode.__proto__ = PathNode$$1;
	    TextNode.prototype = Object.create( PathNode$$1 && PathNode$$1.prototype );
	    TextNode.prototype.constructor = TextNode;
	
	    TextNode.prototype.geometryChange = function geometryChange () {
	        var pos = this.pos();
	        this.attr("x", pos.x);
	        this.attr("y", pos.y);
	        this.invalidate();
	    };
	
	    TextNode.prototype.optionsChange = function optionsChange (e) {
	        if (e.field === "font") {
	            this.attr("style", renderStyle(this.mapStyle()));
	            this.geometryChange();
	        } else if (e.field === "content") {
	            PathNode$$1.prototype.content.call(this, this.srcElement.content());
	        }
	
	        PathNode$$1.prototype.optionsChange.call(this, e);
	    };
	
	    TextNode.prototype.mapStyle = function mapStyle (encode) {
	        var style = PathNode$$1.prototype.mapStyle.call(this, encode);
	        var font = this.srcElement.options.font;
	
	        if (encode) {
	            font = htmlEncode(font);
	        }
	
	        style.push([ "font", font ], [ "white-space", "pre" ]);
	
	        return style;
	    };
	
	    TextNode.prototype.pos = function pos () {
	        var pos = this.srcElement.position();
	        var size = this.srcElement.measure();
	        return pos.clone().setY(pos.y + size.baseline);
	    };
	
	    TextNode.prototype.renderContent = function renderContent () {
	        var content = this.srcElement.content();
	        content = decodeEntities(content);
	        content = htmlEncode(content);
	
	        return normalizeText(content);
	    };
	
	    TextNode.prototype.renderTextAnchor = function renderTextAnchor () {
	        var anchor;
	
	        if ((this.options || {}).rtl && !(support.browser.msie || support.browser.edge)) {
	            anchor = 'end';
	        }
	
	        return renderAttr("text-anchor", anchor);
	    };
	
	    TextNode.prototype.renderPaintOrder = function renderPaintOrder () {
	        var paintOrder = this.srcElement.options.paintOrder;
	        return paintOrder ? renderAttr("paint-order", paintOrder) : "";
	    };
	
	    TextNode.prototype.template = function template () {
	        return "<text " + (this.renderId()) + " " + (this.renderTextAnchor()) + " " + (this.renderStyle()) + " " + (this.renderOpacity()) +
	                    "x='" + (this.pos().x) + "' y='" + (this.pos().y) + "' " + (this.renderStroke()) + " " + (this.renderTransform()) + " " + (this.renderDefinitions()) +
	                    "" + (this.renderPaintOrder()) +
	                    "" + (this.renderFill()) +
	                    (this.renderClassName()) + " " + (this.renderRole()) +
	                    (this.renderAriaLabel()) + " " + (this.renderAriaRoleDescription()) +
	                    (this.renderAriaChecked()) + ">" + (this.renderContent()) + "</text>";
	    };
	
	    return TextNode;
	}(PathNode));
	
	NODE_MAP.Arc = ArcNode;
	NODE_MAP.Circle = CircleNode;
	NODE_MAP.Group = GroupNode;
	NODE_MAP.Image = ImageNode;
	NODE_MAP.MultiPath = MultiPathNode;
	NODE_MAP.Path = PathNode;
	NODE_MAP.Rect = RectNode;
	NODE_MAP.Text = TextNode;
	
	var RTL = 'rtl';
	
	function alignToScreen(element) {
	    var ctm;
	
	    try {
	        ctm = element.getScreenCTM ? element.getScreenCTM() : null;
	    } catch (e) { } // eslint-disable-line no-empty
	
	    if (ctm) {
	        var left = - ctm.e % 1;
	        var top = - ctm.f % 1;
	        var style = element.style;
	
	        if (left !== 0 || top !== 0) {
	            style.left = left + "px";
	            style.top = top + "px";
	        }
	    }
	}
	
	var Surface$3 = (function (BaseSurface) {
	    function Surface(element, options) {
	        BaseSurface.call(this, element, options);
	
	        this._root = new RootNode(Object.assign({
	            rtl: elementStyles(element, 'direction').direction === RTL
	        }, this.options));
	
	        renderSVG$1(this.element, this._template(''));
	
	        this._rootElement = this.element.firstElementChild;
	        this._rootElement.style.width = '100%';
	        this._rootElement.style.height = '100%';
	        this._rootElement.style.overflow = 'hidden';
	
	        alignToScreen(this._rootElement);
	
	        this._root.attachTo(this._rootElement);
	
	        bindEvents(this.element, {
	            click: this._click,
	            mouseover: this._mouseenter,
	            mouseout: this._mouseleave,
	            mousemove: this._mousemove
	        });
	
	        this.resize();
	    }
	
	    if ( BaseSurface ) Surface.__proto__ = BaseSurface;
	    Surface.prototype = Object.create( BaseSurface && BaseSurface.prototype );
	    Surface.prototype.constructor = Surface;
	
	    var prototypeAccessors = { type: {} };
	
	    prototypeAccessors.type.get = function () {
	        return "svg";
	    };
	
	    Surface.prototype.destroy = function destroy () {
	        if (this._root) {
	            this._root.destroy();
	            this._root = null;
	            this._rootElement = null;
	            unbindEvents(this.element, {
	                click: this._click,
	                mouseover: this._mouseenter,
	                mouseout: this._mouseleave,
	                mousemove: this._mousemove
	            });
	        }
	
	        BaseSurface.prototype.destroy.call(this);
	    };
	
	    Surface.prototype.translate = function translate (offset) {
	        var viewBox = (Math.round(offset.x)) + " " + (Math.round(offset.y)) + " " + (this._size.width) + " " + (this._size.height);
	
	        this._offset = offset;
	        this._rootElement.setAttribute("viewBox", viewBox);
	    };
	
	    Surface.prototype.draw = function draw (element) {
	        BaseSurface.prototype.draw.call(this, element);
	        this._root.load([ element ]);
	    };
	
	    Surface.prototype.clear = function clear () {
	        BaseSurface.prototype.clear.call(this);
	        this._root.clear();
	    };
	
	    Surface.prototype.svg = function svg () {
	        return "<?xml version='1.0' ?>" + this._template();
	    };
	
	    Surface.prototype.exportVisual = function exportVisual () {
	        var ref = this;
	        var visual = ref._visual;
	        var offset = ref._offset;
	
	        if (offset) {
	            var wrap = new Group();
	            wrap.children.push(visual);
	
	            wrap.transform(
	                transform$1().translate(-offset.x, -offset.y)
	            );
	
	            visual = wrap;
	        }
	
	        return visual;
	    };
	
	    Surface.prototype._resize = function _resize () {
	        if (this._offset) {
	            this.translate(this._offset);
	        }
	    };
	
	    Surface.prototype._template = function _template (svgStyles) {
	        var styles = typeof svgStyles === 'string' ? svgStyles :
	            "style='width: 100%; height: 100%; overflow: hidden;' ";
	        return ("<svg " + styles + "xmlns='" + SVG_NS + "' xmlns:xlink='http://www.w3.org/1999/xlink' version='1.1'>" + (this._root.render()) + "</svg>");
	    };
	
	    Object.defineProperties( Surface.prototype, prototypeAccessors );
	
	    return Surface;
	}(Surface$2));
	
	var NODE_MAP$2 = {};
	
	var Node$2 = (function (BaseNode$$1) {
	    function Node(srcElement) {
	        BaseNode$$1.call(this, srcElement);
	        if (srcElement) {
	            this.initClip();
	        }
	    }
	
	    if ( BaseNode$$1 ) Node.__proto__ = BaseNode$$1;
	    Node.prototype = Object.create( BaseNode$$1 && BaseNode$$1.prototype );
	    Node.prototype.constructor = Node;
	
	    Node.prototype.initClip = function initClip () {
	        var clip = this.srcElement.clip();
	        if (clip) {
	            this.clip = clip;
	            clip.addObserver(this);
	        }
	    };
	
	    Node.prototype.clear = function clear () {
	        if (this.srcElement) {
	            this.srcElement.removeObserver(this);
	        }
	
	        this.clearClip();
	
	        BaseNode$$1.prototype.clear.call(this);
	    };
	
	    Node.prototype.clearClip = function clearClip () {
	        if (this.clip) {
	            this.clip.removeObserver(this);
	            delete this.clip;
	        }
	    };
	
	    Node.prototype.setClip = function setClip (ctx) {
	        if (this.clip) {
	            ctx.beginPath();
	
	            var clipNode = new NODE_MAP$2[this.clip.nodeType](this.clip);
	            clipNode.renderPoints(ctx, this.clip);
	
	            ctx.clip("evenodd");
	        }
	    };
	
	    Node.prototype.optionsChange = function optionsChange (e) {
	        if (e.field === "clip") {
	            this.clearClip();
	            this.initClip();
	        }
	
	        BaseNode$$1.prototype.optionsChange.call(this, e);
	    };
	
	    Node.prototype.setTransform = function setTransform (ctx) {
	        if (this.srcElement) {
	            var transform = this.srcElement.transform();
	            if (transform) {
	                ctx.transform.apply(ctx, transform.matrix().toArray(6));
	            }
	        }
	    };
	
	    Node.prototype.loadElements = function loadElements (elements, pos, cors) {
	        var this$1 = this;
	
	        for (var i = 0; i < elements.length; i++) {
	            var srcElement = elements[i];
	            var children = srcElement.children;
	
	            var childNode = new NODE_MAP$2[srcElement.nodeType](srcElement, cors);
	
	            if (children && children.length > 0) {
	                childNode.load(children, pos, cors);
	            }
	
	            if (defined(pos)) {
	                this$1.insertAt(childNode, pos);
	            } else {
	                this$1.append(childNode);
	            }
	        }
	    };
	
	    Node.prototype.load = function load (elements, pos, cors) {
	        this.loadElements(elements, pos, cors);
	
	        this.invalidate();
	    };
	
	    Node.prototype.setOpacity = function setOpacity (ctx) {
	        if (this.srcElement) {
	            var opacity = this.srcElement.opacity();
	            if (defined(opacity)) {
	                this.globalAlpha(ctx, opacity);
	            }
	        }
	    };
	
	    Node.prototype.globalAlpha = function globalAlpha (ctx, value) {
	        var opactity = value;
	        if (opactity && ctx.globalAlpha) {
	            opactity *= ctx.globalAlpha;
	        }
	        ctx.globalAlpha = opactity;
	    };
	
	    Node.prototype.visible = function visible () {
	        var src = this.srcElement;
	        return !src || (src && src.options.visible !== false);
	    };
	
	    return Node;
	}(BaseNode));
	
	var GroupNode$2 = (function (superclass) {
	    function GroupNode () {
	        superclass.apply(this, arguments);
	    }
	
	    if ( superclass ) GroupNode.__proto__ = superclass;
	    GroupNode.prototype = Object.create( superclass && superclass.prototype );
	    GroupNode.prototype.constructor = GroupNode;
	
	    GroupNode.prototype.renderTo = function renderTo (ctx) {
	        if (!this.visible()) {
	            return;
	        }
	
	        ctx.save();
	
	        this.setTransform(ctx);
	        this.setClip(ctx);
	        this.setOpacity(ctx);
	
	        var childNodes = this.childNodes;
	        for (var i = 0; i < childNodes.length; i++) {
	            var child = childNodes[i];
	            if (child.visible()) {
	                child.renderTo(ctx);
	            }
	        }
	
	        ctx.restore();
	    };
	
	    return GroupNode;
	}(traversable(Node$2, "childNodes")));
	
	var FRAME_DELAY = 1000 / 60;
	
	var RootNode$2 = (function (superclass) {
	    function RootNode(canvas, size) {
	        superclass.call(this);
	
	        this.canvas = canvas;
	        this.size = size;
	        this.ctx = canvas.getContext("2d");
	
	        var invalidateHandler = this._invalidate.bind(this);
	        this.invalidate = throttle(function () {
	            animationFrame(invalidateHandler);
	        }, FRAME_DELAY);
	    }
	
	    if ( superclass ) RootNode.__proto__ = superclass;
	    RootNode.prototype = Object.create( superclass && superclass.prototype );
	    RootNode.prototype.constructor = RootNode;
	
	    RootNode.prototype.destroy = function destroy () {
	        superclass.prototype.destroy.call(this);
	        this.canvas = null;
	        this.ctx = null;
	    };
	
	    RootNode.prototype.load = function load (elements, pos, cors) {
	        this.loadElements(elements, pos, cors);
	        this._invalidate();
	    };
	
	    RootNode.prototype._rescale = function _rescale (scale) {
	        var ref = this;
	        var canvas = ref.canvas;
	        var size = ref.size;
	        canvas.width = size.width * scale;
	        canvas.height = size.height * scale;
	        this.ctx.scale(scale, scale);
	    };
	
	    RootNode.prototype._devicePixelRatio = function _devicePixelRatio () {
	        if (typeof window.devicePixelRatio === 'number') {
	            return window.devicePixelRatio;
	        }
	
	        return 1;
	    };
	
	    RootNode.prototype._invalidate = function _invalidate (options) {
	        if (!this.ctx) {
	            return;
	        }
	
	        var fixedScale = options && options.fixedScale;
	        var scale = fixedScale ? 1 : this._devicePixelRatio();
	        this._rescale(scale);
	
	        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
	        this.renderTo(this.ctx);
	    };
	
	    return RootNode;
	}(traversable(GroupNode$2, "childNodes")));
	
	var QuadRoot = (function (Class$$1) {
	    function QuadRoot() {
	        Class$$1.call(this);
	
	        this.shapes = [];
	    }
	
	    if ( Class$$1 ) QuadRoot.__proto__ = Class$$1;
	    QuadRoot.prototype = Object.create( Class$$1 && Class$$1.prototype );
	    QuadRoot.prototype.constructor = QuadRoot;
	
	    QuadRoot.prototype._add = function _add (shape, bbox) {
	        this.shapes.push({
	            bbox: bbox,
	            shape: shape
	        });
	        shape._quadNode = this;
	    };
	
	    QuadRoot.prototype.pointShapes = function pointShapes (point) {
	        var shapes = this.shapes;
	        var length = shapes.length;
	        var result = [];
	        for (var idx = 0; idx < length; idx++) {
	            if (shapes[idx].bbox.containsPoint(point)) {
	                result.push(shapes[idx].shape);
	            }
	        }
	        return result;
	    };
	
	    QuadRoot.prototype.insert = function insert (shape, bbox) {
	        this._add(shape, bbox);
	    };
	
	    QuadRoot.prototype.remove = function remove (shape) {
	        var shapes = this.shapes;
	        var length = shapes.length;
	
	        for (var idx = 0; idx < length; idx++) {
	            if (shapes[idx].shape === shape) {
	                shapes.splice(idx, 1);
	                break;
	            }
	        }
	    };
	
	    return QuadRoot;
	}(Class));
	
	var QuadNode = (function (QuadRoot$$1) {
	    function QuadNode(rect) {
	        QuadRoot$$1.call(this);
	        this.children = [];
	        this.rect = rect;
	    }
	
	    if ( QuadRoot$$1 ) QuadNode.__proto__ = QuadRoot$$1;
	    QuadNode.prototype = Object.create( QuadRoot$$1 && QuadRoot$$1.prototype );
	    QuadNode.prototype.constructor = QuadNode;
	
	    QuadNode.prototype.inBounds = function inBounds (rect) {
	        var nodeRect = this.rect;
	        var nodeBottomRight = nodeRect.bottomRight();
	        var bottomRight = rect.bottomRight();
	        var inBounds = nodeRect.origin.x <= rect.origin.x && nodeRect.origin.y <= rect.origin.y && bottomRight.x <= nodeBottomRight.x &&
	            bottomRight.y <= nodeBottomRight.y;
	        return inBounds;
	    };
	
	    QuadNode.prototype.pointShapes = function pointShapes (point) {
	        var children = this.children;
	        var length = children.length;
	        var result = QuadRoot$$1.prototype.pointShapes.call(this, point);
	        for (var idx = 0; idx < length; idx++) {
	            append$1$1(result, children[idx].pointShapes(point));
	        }
	        return result;
	    };
	
	    QuadNode.prototype.insert = function insert (shape, bbox) {
	        var children = this.children;
	        var inserted = false;
	
	        if (this.inBounds(bbox)) {
	            if (this.shapes.length < 4) {
	                this._add(shape, bbox);
	            } else {
	                if (!children.length) {
	                    this._initChildren();
	                }
	
	                for (var idx = 0; idx < children.length; idx++) {
	                    if (children[idx].insert(shape, bbox)) {
	                        inserted = true;
	                        break;
	                    }
	                }
	
	                if (!inserted) {
	                    this._add(shape, bbox);
	                }
	            }
	            inserted = true;
	        }
	
	        return inserted;
	    };
	
	    QuadNode.prototype._initChildren = function _initChildren () {
	        var ref = this;
	        var rect = ref.rect;
	        var children = ref.children;
	        var center = rect.center();
	        var halfWidth = rect.width() / 2;
	        var halfHeight = rect.height() / 2;
	
	        children.push(
	            new QuadNode(new Rect([ rect.origin.x, rect.origin.y ], [ halfWidth, halfHeight ])),
	            new QuadNode(new Rect([ center.x, rect.origin.y ], [ halfWidth, halfHeight ])),
	            new QuadNode(new Rect([ rect.origin.x, center.y ], [ halfWidth, halfHeight ])),
	            new QuadNode(new Rect([ center.x, center.y ], [ halfWidth, halfHeight ]))
	        );
	    };
	
	    return QuadNode;
	}(QuadRoot));
	
	var ROOT_SIZE = 3000;
	var LEVEL_STEP = 10000;
	var MAX_LEVEL = 75;
	
	var ShapesQuadTree = (function (Class$$1) {
	    function ShapesQuadTree() {
	        Class$$1.call(this);
	
	        this.initRoots();
	    }
	
	    if ( Class$$1 ) ShapesQuadTree.__proto__ = Class$$1;
	    ShapesQuadTree.prototype = Object.create( Class$$1 && Class$$1.prototype );
	    ShapesQuadTree.prototype.constructor = ShapesQuadTree;
	
	    ShapesQuadTree.prototype.initRoots = function initRoots () {
	        this.rootMap = {};
	        this.root = new QuadRoot();
	        this.rootElements = [];
	    };
	
	    ShapesQuadTree.prototype.clear = function clear () {
	        var this$1 = this;
	
	        var rootElements = this.rootElements;
	        for (var idx = 0; idx < rootElements.length; idx++) {
	            this$1.remove(rootElements[idx]);
	        }
	        this.initRoots();
	    };
	
	    ShapesQuadTree.prototype.pointShape = function pointShape (point) {
	        var sectorRoot = ( this.rootMap[ Math.floor( point.x / ROOT_SIZE ) ] || {} )[ Math.floor( point.y / ROOT_SIZE ) ];
	        var result = this.root.pointShapes(point);
	
	        if (sectorRoot) {
	            result = result.concat(sectorRoot.pointShapes(point));
	        }
	
	        this.assignZindex(result);
	
	        result.sort(zIndexComparer);
	        for (var idx = 0; idx < result.length; idx++) {
	            if (result[idx].containsPoint(point)) {
	                return result[idx];
	            }
	        }
	    };
	
	    ShapesQuadTree.prototype.assignZindex = function assignZindex (elements) {
	        var this$1 = this;
	
	        for (var idx = 0; idx < elements.length; idx++) {
	            var element = elements[idx];
	            var zIndex = 0;
	            var levelWeight = Math.pow(LEVEL_STEP, MAX_LEVEL);
	            var parents = [];
	
	            while (element) {
	                parents.push(element);
	                element = element.parent;
	            }
	
	            while (parents.length) {
	                element = parents.pop();
	                zIndex += ((element.parent ? element.parent.children : this$1.rootElements).indexOf(element) + 1) * levelWeight;
	                levelWeight /= LEVEL_STEP;
	            }
	
	            elements[idx]._zIndex = zIndex;
	        }
	    };
	
	    ShapesQuadTree.prototype.optionsChange = function optionsChange (e) {
	        if (e.field === "transform" || e.field === "stroke.width") {
	            this.bboxChange(e.element);
	        }
	    };
	
	    ShapesQuadTree.prototype.geometryChange = function geometryChange (e) {
	        this.bboxChange(e.element);
	    };
	
	    ShapesQuadTree.prototype.bboxChange = function bboxChange (element) {
	        var this$1 = this;
	
	        if (element.nodeType === "Group") {
	            for (var idx = 0; idx < element.children.length; idx++) {
	                this$1.bboxChange(element.children[idx]);
	            }
	        } else {
	            if (element._quadNode) {
	                element._quadNode.remove(element);
	            }
	            this._insertShape(element);
	        }
	    };
	
	    ShapesQuadTree.prototype.add = function add (elements) {
	        var elementsArray = Array.isArray(elements) ? elements.slice(0) : [ elements ];
	
	        append$1$1(this.rootElements, elementsArray);
	        this._insert(elementsArray);
	    };
	
	    ShapesQuadTree.prototype.childrenChange = function childrenChange (e) {
	        var this$1 = this;
	
	        if (e.action === "remove") {
	            for (var idx = 0; idx < e.items.length; idx++) {
	                this$1.remove(e.items[idx]);
	            }
	        } else {
	            this._insert(Array.prototype.slice.call(e.items, 0));
	        }
	    };
	
	    ShapesQuadTree.prototype._insert = function _insert (elements) {
	        var this$1 = this;
	
	        var element;
	
	        while (elements.length > 0) {
	            element = elements.pop();
	            element.addObserver(this$1);
	            if (element.nodeType === "Group") {
	                append$1$1(elements, element.children);
	            } else {
	                this$1._insertShape(element);
	            }
	        }
	    };
	
	    ShapesQuadTree.prototype._insertShape = function _insertShape (shape) {
	        var bbox = shape.bbox();
	        if (bbox) {
	            var sectors = this.getSectors(bbox);
	            var x = sectors[0][0];
	            var y = sectors[1][0];
	
	            if (this.inRoot(sectors)) {
	                this.root.insert(shape, bbox);
	            } else {
	                var rootMap = this.rootMap;
	                if (!rootMap[x]) {
	                    rootMap[x] = {};
	                }
	
	                if (!rootMap[x][y]) {
	                    rootMap[x][y] = new QuadNode(
	                        new Rect([ x * ROOT_SIZE, y * ROOT_SIZE ], [ ROOT_SIZE, ROOT_SIZE ])
	                    );
	                }
	
	                rootMap[x][y].insert(shape, bbox);
	            }
	        }
	    };
	
	    ShapesQuadTree.prototype.remove = function remove (element) {
	        var this$1 = this;
	
	        element.removeObserver(this);
	
	        if (element.nodeType === "Group") {
	            var children = element.children;
	            for (var idx = 0; idx < children.length; idx++) {
	                this$1.remove(children[idx]);
	            }
	        } else if (element._quadNode) {
	            element._quadNode.remove(element);
	            delete element._quadNode;
	        }
	    };
	
	    ShapesQuadTree.prototype.inRoot = function inRoot (sectors) {
	        return sectors[0].length > 1 || sectors[1].length > 1;
	    };
	
	    ShapesQuadTree.prototype.getSectors = function getSectors (rect) {
	        var bottomRight = rect.bottomRight();
	        var bottomX = Math.floor(bottomRight.x / ROOT_SIZE);
	        var bottomY = Math.floor(bottomRight.y / ROOT_SIZE);
	        var sectors = [ [], [] ];
	        for (var x = Math.floor(rect.origin.x / ROOT_SIZE); x <= bottomX; x++) {
	            sectors[0].push(x);
	        }
	        for (var y = Math.floor(rect.origin.y / ROOT_SIZE); y <= bottomY; y++) {
	            sectors[1].push(y);
	        }
	        return sectors;
	    };
	
	    return ShapesQuadTree;
	}(Class));
	
	function zIndexComparer(x1, x2) {
	    if (x1._zIndex < x2._zIndex) {
	        return 1;
	    }
	    if (x1._zIndex > x2._zIndex) {
	        return -1;
	    }
	
	    return 0;
	}
	
	var SurfaceCursor = function SurfaceCursor(surface) {
	    surface.bind("mouseenter", this._mouseenter.bind(this));
	    surface.bind("mouseleave", this._mouseleave.bind(this));
	
	    this.element = surface.element;
	};
	
	SurfaceCursor.prototype.clear = function clear () {
	    this._resetCursor();
	};
	
	SurfaceCursor.prototype.destroy = function destroy () {
	    this._resetCursor();
	    delete this.element;
	};
	
	SurfaceCursor.prototype._mouseenter = function _mouseenter (e) {
	    var cursor = this._shapeCursor(e);
	
	    if (!cursor) {
	        this._resetCursor();
	    } else {
	        if (!this._current) {
	            this._defaultCursor = this._getCursor();
	        }
	
	        this._setCursor(cursor);
	    }
	};
	
	SurfaceCursor.prototype._mouseleave = function _mouseleave () {
	    this._resetCursor();
	};
	
	SurfaceCursor.prototype._shapeCursor = function _shapeCursor (e) {
	    var shape = e.element;
	
	    while (shape && !defined(shape.options.cursor)) {
	        shape = shape.parent;
	    }
	
	    if (shape) {
	        return shape.options.cursor;
	    }
	};
	
	SurfaceCursor.prototype._getCursor = function _getCursor () {
	    if (this.element) {
	        return this.element.style.cursor;
	    }
	};
	
	SurfaceCursor.prototype._setCursor = function _setCursor (cursor) {
	    if (this.element) {
	        this.element.style.cursor = cursor;
	        this._current = cursor;
	    }
	};
	
	SurfaceCursor.prototype._resetCursor = function _resetCursor () {
	    if (this._current) {
	        this._setCursor(this._defaultCursor || "");
	        delete this._current;
	    }
	};
	
	function renderPath(ctx, path) {
	    var segments = path.segments;
	
	    if (segments.length === 0) {
	        return;
	    }
	
	    var segment = segments[0];
	    var anchor = segment.anchor();
	    ctx.moveTo(anchor.x, anchor.y);
	
	    for (var i = 1; i < segments.length; i++) {
	        segment = segments[i];
	        anchor = segment.anchor();
	
	        var prevSeg = segments[i - 1];
	        var prevOut = prevSeg.controlOut();
	        var controlIn = segment.controlIn();
	
	        if (prevOut && controlIn) {
	            ctx.bezierCurveTo(prevOut.x, prevOut.y,
	                controlIn.x, controlIn.y,
	                anchor.x, anchor.y);
	        } else {
	            ctx.lineTo(anchor.x, anchor.y);
	        }
	    }
	
	    if (path.options.closed) {
	        ctx.closePath();
	    }
	}
	
	function addGradientStops(gradient, stops) {
	    for (var idx = 0; idx < stops.length; idx++) {
	        var stop = stops[idx];
	        var color = parseColor(stop.color());
	
	        color.a *= stop.opacity();
	
	        gradient.addColorStop(stop.offset(), color.toCssRgba());
	    }
	}
	
	var PathNode$2 = (function (Node) {
	    function PathNode () {
	        Node.apply(this, arguments);
	    }
	
	    if ( Node ) PathNode.__proto__ = Node;
	    PathNode.prototype = Object.create( Node && Node.prototype );
	    PathNode.prototype.constructor = PathNode;
	
	    PathNode.prototype.renderTo = function renderTo (ctx) {
	        ctx.save();
	
	        this.setTransform(ctx);
	        this.setClip(ctx);
	        this.setOpacity(ctx);
	
	        ctx.beginPath();
	
	        this.renderPoints(ctx, this.srcElement);
	
	        this.setLineDash(ctx);
	        this.setLineCap(ctx);
	        this.setLineJoin(ctx);
	
	        this.setFill(ctx);
	        this.setStroke(ctx);
	
	        ctx.restore();
	    };
	
	    PathNode.prototype.setFill = function setFill (ctx) {
	        var fill = this.srcElement.options.fill;
	        var hasFill = false;
	
	        if (fill) {
	            if (fill.nodeType === "Gradient") {
	                this.setGradientFill(ctx, fill);
	                hasFill = true;
	            } else if (!isTransparent(fill.color)) {
	                ctx.fillStyle = fill.color;
	
	                ctx.save();
	                this.globalAlpha(ctx, fill.opacity);
	                ctx.fill();
	                ctx.restore();
	
	                hasFill = true;
	            }
	        }
	
	        return hasFill;
	    };
	
	    PathNode.prototype.setGradientFill = function setGradientFill (ctx, fill) {
	        var bbox = this.srcElement.rawBBox();
	        var gradient;
	
	        if (fill instanceof LinearGradient) {
	            var start = fill.start();
	            var end = fill.end();
	            gradient = ctx.createLinearGradient(start.x, start.y, end.x, end.y);
	        } else if (fill instanceof RadialGradient) {
	            var center = fill.center();
	            gradient = ctx.createRadialGradient(center.x, center.y, 0, center.x, center.y, fill.radius());
	        }
	
	        addGradientStops(gradient, fill.stops);
	
	        ctx.save();
	
	        if (!fill.userSpace()) {
	            ctx.transform(bbox.width(), 0, 0, bbox.height(), bbox.origin.x, bbox.origin.y);
	        }
	        ctx.fillStyle = gradient;
	        ctx.fill();
	
	        ctx.restore();
	    };
	
	    PathNode.prototype.setStroke = function setStroke (ctx) {
	        var stroke = this.srcElement.options.stroke;
	        if (stroke && !isTransparent(stroke.color) && stroke.width > 0) {
	            ctx.strokeStyle = stroke.color;
	            ctx.lineWidth = valueOrDefault(stroke.width, 1);
	            ctx.lineJoin = valueOrDefault(stroke.lineJoin, ctx.lineJoin);
	
	            ctx.save();
	            this.globalAlpha(ctx, stroke.opacity);
	            ctx.stroke();
	            ctx.restore();
	
	            return true;
	        }
	    };
	
	    PathNode.prototype.dashType = function dashType () {
	        var stroke = this.srcElement.options.stroke;
	        if (stroke && stroke.dashType) {
	            return stroke.dashType.toLowerCase();
	        }
	    };
	
	    PathNode.prototype.setLineDash = function setLineDash (ctx) {
	        var dashType = this.dashType();
	        if (dashType && dashType !== SOLID) {
	            var dashArray = DASH_ARRAYS[dashType];
	            if (ctx.setLineDash) {
	                ctx.setLineDash(dashArray);
	            } else {
	                ctx.mozDash = dashArray;
	                ctx.webkitLineDash = dashArray;
	            }
	        }
	    };
	
	    PathNode.prototype.setLineCap = function setLineCap (ctx) {
	        var dashType = this.dashType();
	        var stroke = this.srcElement.options.stroke;
	        if (dashType && dashType !== SOLID) {
	            ctx.lineCap = BUTT;
	        } else if (stroke && stroke.lineCap) {
	            ctx.lineCap = stroke.lineCap;
	        }
	    };
	
	    PathNode.prototype.setLineJoin = function setLineJoin (ctx) {
	        var stroke = this.srcElement.options.stroke;
	        if (stroke && stroke.lineJoin) {
	            ctx.lineJoin = stroke.lineJoin;
	        }
	    };
	
	    PathNode.prototype.renderPoints = function renderPoints (ctx, path) {
	        renderPath(ctx, path);
	    };
	
	    return PathNode;
	}(Node$2));
	
	var ArcNode$2 = (function (PathNode) {
	    function ArcNode () {
	        PathNode.apply(this, arguments);
	    }
	
	    if ( PathNode ) ArcNode.__proto__ = PathNode;
	    ArcNode.prototype = Object.create( PathNode && PathNode.prototype );
	    ArcNode.prototype.constructor = ArcNode;
	
	    ArcNode.prototype.renderPoints = function renderPoints (ctx) {
	        var path = this.srcElement.toPath();
	        renderPath(ctx, path);
	    };
	
	    return ArcNode;
	}(PathNode$2));
	
	var CircleNode$2 = (function (PathNode) {
	    function CircleNode () {
	        PathNode.apply(this, arguments);
	    }
	
	    if ( PathNode ) CircleNode.__proto__ = PathNode;
	    CircleNode.prototype = Object.create( PathNode && PathNode.prototype );
	    CircleNode.prototype.constructor = CircleNode;
	
	    CircleNode.prototype.renderPoints = function renderPoints (ctx) {
	        var ref = this.srcElement.geometry();
	        var center = ref.center;
	        var radius = ref.radius;
	
	        ctx.arc(center.x, center.y, radius, 0, Math.PI * 2);
	    };
	
	    return CircleNode;
	}(PathNode$2));
	
	var ImageNode$2 = (function (PathNode) {
	    function ImageNode(srcElement, cors) {
	        PathNode.call(this, srcElement);
	
	        this.onLoad = this.onLoad.bind(this);
	        this.onError = this.onError.bind(this);
	
	        this.loading = createPromise();
	
	        var img = this.img = new Image();
	        var src = srcElement.src();
	
	        if (cors && !(/^data:/i.test(src))) {
	            img.crossOrigin = cors;
	        }
	
	        if (src) {
	            img.src = src;
	        }
	
	        if (img.complete) {
	            this.onLoad();
	        } else {
	            img.onload = this.onLoad;
	            img.onerror = this.onError;
	        }
	    }
	
	    if ( PathNode ) ImageNode.__proto__ = PathNode;
	    ImageNode.prototype = Object.create( PathNode && PathNode.prototype );
	    ImageNode.prototype.constructor = ImageNode;
	
	    ImageNode.prototype.renderTo = function renderTo (ctx) {
	        if (this.loading.state() === "resolved") {
	            ctx.save();
	
	            this.setTransform(ctx);
	            this.setClip(ctx);
	
	            this.drawImage(ctx);
	
	            ctx.restore();
	        }
	    };
	
	    ImageNode.prototype.optionsChange = function optionsChange (e) {
	        if (e.field === "src") {
	            this.loading = createPromise();
	            this.img.src = this.srcElement.src();
	        } else {
	            PathNode.prototype.optionsChange.call(this, e);
	        }
	    };
	
	    ImageNode.prototype.onLoad = function onLoad () {
	        this.loading.resolve();
	        this.invalidate();
	    };
	
	    ImageNode.prototype.onError = function onError () {
	        this.loading.reject(new Error(
	            "Unable to load image '" + this.img.src +
	            "'. Check for connectivity and verify CORS headers."
	        ));
	    };
	
	    ImageNode.prototype.drawImage = function drawImage (ctx) {
	        var rect = this.srcElement.rect();
	        var topLeft = rect.topLeft();
	
	        ctx.drawImage(
	            this.img, topLeft.x, topLeft.y, rect.width(), rect.height()
	        );
	    };
	
	    return ImageNode;
	}(PathNode$2));
	
	var MultiPathNode$2 = (function (PathNode) {
	    function MultiPathNode () {
	        PathNode.apply(this, arguments);
	    }
	
	    if ( PathNode ) MultiPathNode.__proto__ = PathNode;
	    MultiPathNode.prototype = Object.create( PathNode && PathNode.prototype );
	    MultiPathNode.prototype.constructor = MultiPathNode;
	
	    MultiPathNode.prototype.renderPoints = function renderPoints (ctx) {
	        var paths = this.srcElement.paths;
	        for (var i = 0; i < paths.length; i++) {
	            renderPath(ctx, paths[i]);
	        }
	    };
	
	    return MultiPathNode;
	}(PathNode$2));
	
	var RectNode$2 = (function (PathNode) {
	    function RectNode () {
	        PathNode.apply(this, arguments);
	    }
	
	    if ( PathNode ) RectNode.__proto__ = PathNode;
	    RectNode.prototype = Object.create( PathNode && PathNode.prototype );
	    RectNode.prototype.constructor = RectNode;
	
	    RectNode.prototype.renderPoints = function renderPoints (ctx) {
	        var geometry = this.srcElement.geometry();
	        var ref = geometry.cornerRadius;
	        var rx = ref[0];
	        var ry = ref[1];
	
	        if (rx === 0 && ry === 0) {
	            var origin = geometry.origin;
	            var size = geometry.size;
	            ctx.rect(origin.x, origin.y, size.width, size.height);
	        } else {
	            PathNode.prototype.renderPoints.call(this, ctx, Path.fromRect(geometry));
	        }
	    };
	
	    return RectNode;
	}(PathNode$2));
	
	var TextNode$2 = (function (PathNode) {
	    function TextNode () {
	        PathNode.apply(this, arguments);
	    }
	
	    if ( PathNode ) TextNode.__proto__ = PathNode;
	    TextNode.prototype = Object.create( PathNode && PathNode.prototype );
	    TextNode.prototype.constructor = TextNode;
	
	    TextNode.prototype.renderTo = function renderTo (ctx) {
	        var text = this.srcElement;
	        var pos = text.position();
	        var size = text.measure();
	
	        ctx.save();
	
	        this.setTransform(ctx);
	        this.setClip(ctx);
	        this.setOpacity(ctx);
	
	        ctx.beginPath();
	
	        ctx.font = text.options.font;
	        ctx.textAlign = 'left';
	
	        if (text.options.paintOrder === 'stroke') {
	            this.stroke(ctx, text, pos, size);
	            this.fill(ctx, text, pos, size);
	        } else {
	            this.fill(ctx, text, pos, size);
	            this.stroke(ctx, text, pos, size);
	        }
	
	        ctx.restore();
	    };
	
	    TextNode.prototype.stroke = function stroke (ctx, text, pos, size) {
	        if (this.setStroke(ctx)) {
	            this.setLineDash(ctx);
	            ctx.strokeText(text.content(), pos.x, pos.y + size.baseline);
	        }
	    };
	
	    TextNode.prototype.fill = function fill (ctx, text, pos, size) {
	        if (this.setFill(ctx)) {
	            ctx.fillText(text.content(), pos.x, pos.y + size.baseline);
	        }
	    };
	
	    return TextNode;
	}(PathNode$2));
	
	NODE_MAP$2.Arc = ArcNode$2;
	NODE_MAP$2.Circle = CircleNode$2;
	NODE_MAP$2.Group = GroupNode$2;
	NODE_MAP$2.Image = ImageNode$2;
	NODE_MAP$2.MultiPath = MultiPathNode$2;
	NODE_MAP$2.Path = PathNode$2;
	NODE_MAP$2.Rect = RectNode$2;
	NODE_MAP$2.Text = TextNode$2;
	
	
	var Surface$4 = (function (BaseSurface) {
	    function Surface(element, options) {
	        BaseSurface.call(this, element, options);
	
	        this.element.innerHTML = this._template(this);
	
	        var canvas = this.element.firstElementChild;
	        canvas.style.width = '100%';
	        canvas.style.height = '100%';
	
	        var size = elementSize(element);
	
	        canvas.width = size.width;
	        canvas.height = size.height;
	
	        this._rootElement = canvas;
	
	        this._root = new RootNode$2(canvas, size);
	
	        this._mouseTrackHandler = this._trackMouse.bind(this);
	
	        bindEvents(this.element, {
	            click: this._mouseTrackHandler,
	            mousemove: this._mouseTrackHandler
	        });
	    }
	
	    if ( BaseSurface ) Surface.__proto__ = BaseSurface;
	    Surface.prototype = Object.create( BaseSurface && BaseSurface.prototype );
	    Surface.prototype.constructor = Surface;
	
	    var prototypeAccessors = { type: {} };
	
	    prototypeAccessors.type.get = function () {
	        return "canvas";
	    };
	
	    Surface.prototype.destroy = function destroy () {
	        BaseSurface.prototype.destroy.call(this);
	
	        if (this._root) {
	            this._root.destroy();
	            this._root = null;
	        }
	
	        if (this._searchTree) {
	            this._searchTree.clear();
	            delete this._searchTree;
	        }
	
	        if (this._cursor) {
	            this._cursor.destroy();
	            delete this._cursor;
	        }
	
	        unbindEvents(this.element, {
	            click: this._mouseTrackHandler,
	            mousemove: this._mouseTrackHandler
	        });
	    };
	
	    Surface.prototype.draw = function draw (element) {
	        BaseSurface.prototype.draw.call(this, element);
	        this._root.load([ element ], undefined, this.options.cors);
	
	        if (this._searchTree) {
	            this._searchTree.add([ element ]);
	        }
	    };
	
	    Surface.prototype.clear = function clear () {
	        BaseSurface.prototype.clear.call(this);
	        this._root.clear();
	
	        if (this._searchTree) {
	            this._searchTree.clear();
	        }
	
	        if (this._cursor) {
	            this._cursor.clear();
	        }
	    };
	
	    Surface.prototype.eventTarget = function eventTarget (e) {
	        if (this._searchTree) {
	            var point = this._surfacePoint(e);
	            var shape = this._searchTree.pointShape(point);
	            return shape;
	        }
	    };
	
	    Surface.prototype.image = function image () {
	        var ref = this;
	        var root = ref._root;
	        var rootElement = ref._rootElement;
	        var loadingStates = [];
	
	        root.traverse(function (childNode) {
	            if (childNode.loading) {
	                loadingStates.push(childNode.loading);
	            }
	        });
	
	        var promise = createPromise();
	        var resolveDataURL = function () {
	            root._invalidate({ fixedScale: true });
	
	            try {
	                var data = rootElement.toDataURL();
	                promise.resolve(data);
	            } catch (e) {
	                promise.reject(e);
	            }
	        };
	
	        promiseAll(loadingStates).then(resolveDataURL, resolveDataURL);
	
	        return promise;
	    };
	
	    Surface.prototype.suspendTracking = function suspendTracking () {
	        BaseSurface.prototype.suspendTracking.call(this);
	        if (this._searchTree) {
	            this._searchTree.clear();
	            delete this._searchTree;
	        }
	    };
	
	    Surface.prototype.resumeTracking = function resumeTracking () {
	        BaseSurface.prototype.resumeTracking.call(this);
	        if (!this._searchTree) {
	            this._searchTree = new ShapesQuadTree();
	
	            var childNodes = this._root.childNodes;
	            var rootElements = [];
	            for (var idx = 0; idx < childNodes.length; idx++) {
	                rootElements.push(childNodes[idx].srcElement);
	            }
	            this._searchTree.add(rootElements);
	        }
	    };
	
	    Surface.prototype._resize = function _resize () {
	        this._rootElement.width = this._size.width;
	        this._rootElement.height = this._size.height;
	
	        this._root.size = this._size;
	        this._root.invalidate();
	    };
	
	    Surface.prototype._template = function _template () {
	        return "<canvas></canvas>";
	    };
	
	    Surface.prototype._enableTracking = function _enableTracking () {
	        this._searchTree = new ShapesQuadTree();
	        this._cursor = new SurfaceCursor(this);
	
	        BaseSurface.prototype._enableTracking.call(this);
	    };
	
	    Surface.prototype._trackMouse = function _trackMouse (e) {
	        if (this._suspendedTracking) {
	            return;
	        }
	
	        var shape = this.eventTarget(e);
	
	        if (e.type !== "click") {
	            var currentShape = this._currentShape;
	            if (currentShape && currentShape !== shape) {
	                this.trigger("mouseleave", {
	                    element: currentShape,
	                    originalEvent: e,
	                    type: "mouseleave"
	                });
	            }
	
	            if (shape && currentShape !== shape) {
	                this.trigger("mouseenter", {
	                    element: shape,
	                    originalEvent: e,
	                    type: "mouseenter"
	                });
	            }
	
	            this.trigger("mousemove", {
	                element: shape,
	                originalEvent: e,
	                type: "mousemove"
	            });
	
	            this._currentShape = shape;
	        } else if (shape) {
	            this.trigger("click", {
	                element: shape,
	                originalEvent: e,
	                type: "click"
	            });
	        }
	    };
	
	    Object.defineProperties( Surface.prototype, prototypeAccessors );
	
	    return Surface;
	}(Surface$2));
	
	var instance$2;
	var support$2;
	
	var hasDocument = function () { return typeof document !== "undefined"; };
	
	var supportsCanvas = function () { return hasDocument() &&
	    document.createElement("canvas").getContext; };
	
	var supportsSVG = function () { return hasDocument() &&
	    document.implementation.hasFeature("http://www.w3.org/TR/SVG11/feature#BasicStructure", "1.1"); };
	
	var SurfaceFactory = (function (Class$$1) {
	    function SurfaceFactory() {
	        Class$$1.call(this);
	
	        this._items = [ {
	            name: "svg",
	            type: Surface$3
	        }, {
	            name: "canvas",
	            type: Surface$4
	        } ];
	    }
	
	    if ( Class$$1 ) SurfaceFactory.__proto__ = Class$$1;
	    SurfaceFactory.prototype = Object.create( Class$$1 && Class$$1.prototype );
	    SurfaceFactory.prototype.constructor = SurfaceFactory;
	
	    var staticAccessors = { support: {},current: {} };
	
	    staticAccessors.support.get = function () {
	        if (!support$2) {
	            support$2 = {
	                canvas: supportsCanvas(),
	                svg: supportsSVG()
	            };
	        }
	
	        return support$2;
	    };
	
	    staticAccessors.current.get = function () {
	        if (!instance$2) {
	            instance$2 = new SurfaceFactory();
	        }
	
	        return instance$2;
	    };
	
	    SurfaceFactory.prototype.create = function create (element, options) {
	        var items = this._items;
	        var match = items[0];
	
	        if (options && options.type) {
	            var preferred = options.type.toLowerCase();
	            for (var i = 0; i < items.length; i++) {
	                if (items[i].name === preferred) {
	                    match = items[i];
	                    break;
	                }
	            }
	        }
	
	        if (match) {
	            return new match.type(element, options);
	        }
	
	        logToConsole(
	            "Warning: Unable to create Kendo UI Drawing Surface. Possible causes:\n" +
	            "- The browser does not support SVG and Canvas. User agent: " + (navigator.userAgent));
	    };
	
	    Object.defineProperties( SurfaceFactory, staticAccessors );
	
	    return SurfaceFactory;
	}(Class));
	
	var Surface = (function (BaseSurface) {
	    function Surface () {
	        BaseSurface.apply(this, arguments);
	    }
	
	    if ( BaseSurface ) Surface.__proto__ = BaseSurface;
	    Surface.prototype = Object.create( BaseSurface && BaseSurface.prototype );
	    Surface.prototype.constructor = Surface;
	
	    var staticAccessors = { support: {} };
	
	    staticAccessors.support.get = function () {
	        return SurfaceFactory.support;
	    };
	
	    Surface.create = function create (element, options) {
	        return SurfaceFactory.current.create(element, options);
	    };
	
	    Object.defineProperties( Surface, staticAccessors );
	
	    return Surface;
	}(Surface$2));
	
	function exportGroup(group) {
	    var root = new RootNode({
	        skipBaseHref: true
	    });
	    var bbox = group.clippedBBox();
	    var rootGroup = group;
	
	    if (bbox) {
	        var origin = bbox.getOrigin();
	        var exportRoot = new Group();
	        exportRoot.transform(transform$1().translate(-origin.x, -origin.y));
	        exportRoot.children.push(group);
	        rootGroup = exportRoot;
	    }
	
	    root.load([ rootGroup ]);
	
	    var svg = "<?xml version='1.0' ?><svg xmlns='" + SVG_NS + "' xmlns:xlink='http://www.w3.org/1999/xlink' version='1.1'>" + (root.render()) + "</svg>";
	
	    root.destroy();
	
	    return svg;
	}
	
	
	
	var svg$1 = Object.freeze({
		Surface: Surface$3,
		RootNode: RootNode,
		Node: Node,
		GroupNode: GroupNode,
		ArcNode: ArcNode,
		CircleNode: CircleNode,
		RectNode: RectNode,
		ImageNode: ImageNode,
		TextNode: TextNode,
		PathNode: PathNode,
		MultiPathNode: MultiPathNode,
		DefinitionNode: DefinitionNode,
		ClipNode: ClipNode,
		GradientStopNode: GradientStopNode,
		LinearGradientNode: LinearGradientNode,
		RadialGradientNode: RadialGradientNode,
		exportGroup: exportGroup
	});
	
	
	
	var canvas = Object.freeze({
		Surface: Surface$4,
		RootNode: RootNode$2,
		Node: Node$2,
		GroupNode: GroupNode$2,
		ArcNode: ArcNode$2,
		CircleNode: CircleNode$2,
		RectNode: RectNode$2,
		ImageNode: ImageNode$2,
		TextNode: TextNode$2,
		PathNode: PathNode$2,
		MultiPathNode: MultiPathNode$2
	});
	
	function exportImage(group, options) {
	    var defaults = {
	        width: "800px", height: "600px",
	        cors: "Anonymous"
	    };
	
	    var exportRoot = group;
	    var bbox = group.clippedBBox();
	
	
	    if (bbox) {
	        var origin = bbox.getOrigin();
	        exportRoot = new Group();
	        exportRoot.transform(transform$1().translate(-origin.x, -origin.y));
	        exportRoot.children.push(group);
	
	        var size = bbox.getSize();
	        defaults.width = size.width + "px";
	        defaults.height = size.height + "px";
	    }
	
	    var surfaceOptions = Object.assign(defaults, options);
	
	    var container = document.createElement("div");
	    var style = container.style;
	
	    style.display = "none";
	    style.width = surfaceOptions.width;
	    style.height = surfaceOptions.height;
	    document.body.appendChild(container);
	
	    var surface = new Surface$4(container, surfaceOptions);
	    surface.suspendTracking();
	    surface.draw(exportRoot);
	
	    var promise = surface.image();
	    var destroy = function () {
	        surface.destroy();
	        document.body.removeChild(container);
	    };
	    promise.then(destroy, destroy);
	
	    return promise;
	}
	
	function exportSVG(group, options) {
	    var svg = exportGroup(group);
	
	    if (!options || !options.raw) {
	        svg = "data:image/svg+xml;base64," + encodeBase64(svg);
	    }
	
	    return createPromise().resolve(svg);
	}
	
	
	
	var drawing = Object.freeze({
		svg: svg$1,
		canvas: canvas,
		util: util,
		HasObservers: HasObservers,
		PathParser: PathParser,
		parsePath: parsePath,
		BaseNode: BaseNode,
		OptionsStore: OptionsStore,
		Surface: Surface,
		SurfaceFactory: SurfaceFactory,
		exportImage: exportImage,
		exportSVG: exportSVG,
		QuadNode: QuadNode,
		ShapesQuadTree: ShapesQuadTree,
		Element: Element$1,
		Circle: Circle,
		Arc: Arc,
		Path: Path,
		MultiPath: MultiPath,
		Text: Text,
		Image: Image$1,
		Group: Group,
		Layout: Layout,
		Rect: Rect$2,
		align: align,
		vAlign: vAlign,
		stack: stack,
		vStack: vStack,
		wrap: wrap,
		vWrap: vWrap,
		fit: fit,
		LinearGradient: LinearGradient,
		RadialGradient: RadialGradient,
		GradientStop: GradientStop,
		Gradient: Gradient,
		Animation: Animation,
		AnimationFactory: AnimationFactory
	});
	
	/* eslint-disable no-multi-spaces, key-spacing, indent, camelcase, space-before-blocks, eqeqeq, brace-style */
	/* eslint-disable space-infix-ops, space-before-function-paren, array-bracket-spacing, object-curly-spacing */
	/* eslint-disable no-nested-ternary, max-params, default-case, no-else-return, no-empty */
	/* eslint-disable no-param-reassign, no-var, block-scoped-var */
	
	// XXX: remove this junk (assume `true`) when we no longer have to support IE < 10
	// IE 9 (at least compatibility) reports having Uint8Array but the request response does not contain ArrayBuffer which results in missing table head error
	var HAS_TYPED_ARRAYS = typeof Uint8Array !== 'undefined' && support.browser && (!support.browser.msie || support.browser.version > 9);
	
	var BASE64 = (function(){
	    var keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
	    return {
	        decode: function(str) {
	            var input = str.replace(/[^A-Za-z0-9\+\/\=]/g, ""), i = 0, n = input.length, output = [];
	
	            while (i < n) {
	                var enc1 = keyStr.indexOf(input.charAt(i++));
	                var enc2 = keyStr.indexOf(input.charAt(i++));
	                var enc3 = keyStr.indexOf(input.charAt(i++));
	                var enc4 = keyStr.indexOf(input.charAt(i++));
	
	                var chr1 = (enc1 << 2) | (enc2 >>> 4);
	                var chr2 = ((enc2 & 15) << 4) | (enc3 >>> 2);
	                var chr3 = ((enc3 & 3) << 6) | enc4;
	
	                output.push(chr1);
	                if (enc3 != 64) {
	                    output.push(chr2);
	                }
	                if (enc4 != 64) {
	                    output.push(chr3);
	                }
	            }
	
	            return output;
	        },
	        encode: function(bytes) {
	            var i = 0, n = bytes.length;
	            var output = "";
	
	            while (i < n) {
	                var chr1 = bytes[i++];
	                var chr2 = bytes[i++];
	                var chr3 = bytes[i++];
	
	                var enc1 = chr1 >>> 2;
	                var enc2 = ((chr1 & 3) << 4) | (chr2 >>> 4);
	                var enc3 = ((chr2 & 15) << 2) | (chr3 >>> 6);
	                var enc4 = chr3 & 63;
	
	                if (i - n == 2) {
	                    enc3 = enc4 = 64;
	                } else if (i - n == 1) {
	                    enc4 = 64;
	                }
	
	                output += keyStr.charAt(enc1) + keyStr.charAt(enc2) + keyStr.charAt(enc3) + keyStr.charAt(enc4);
	            }
	            return output;
	        }
	    };
	}());
	
	function BinaryStream(data) {
	    var offset = 0, length = 0;
	    if (data == null) {
	        data = HAS_TYPED_ARRAYS ? new Uint8Array(256) : [];
	    } else {
	        length = data.length;
	    }
	
	    var ensure = HAS_TYPED_ARRAYS ? function(len) {
	        if (len >= data.length) {
	            var tmp = new Uint8Array(Math.max(len + 256, data.length * 2));
	            tmp.set(data, 0);
	            data = tmp;
	        }
	    } : function() {};
	
	    var get = HAS_TYPED_ARRAYS ? function() {
	        return new Uint8Array(data.buffer, 0, length);
	    } : function() {
	        return data;
	    };
	
	    var write = HAS_TYPED_ARRAYS ? function(bytes) {
	        if (typeof bytes == "string") {
	            return writeString(bytes);
	        }
	        var len = bytes.length;
	        ensure(offset + len);
	        data.set(bytes, offset);
	        offset += len;
	        if (offset > length) {
	            length = offset;
	        }
	    } : function(bytes) {
	        if (typeof bytes == "string") {
	            return writeString(bytes);
	        }
	        for (var i = 0; i < bytes.length; ++i) {
	            writeByte(bytes[i]);
	        }
	    };
	
	    var slice = HAS_TYPED_ARRAYS ? function(start, length) {
	        if (data.buffer.slice) {
	            return new Uint8Array(data.buffer.slice(start, start + length));
	        } else {
	            // IE10
	            var x = new Uint8Array(length);
	            x.set(new Uint8Array(data.buffer, start, length));
	            return x;
	        }
	    } : function(start, length) {
	        return data.slice(start, start + length);
	    };
	
	    function eof() {
	        return offset >= length;
	    }
	    function readByte() {
	        return offset < length ? data[offset++] : 0;
	    }
	    function writeByte(b) {
	        ensure(offset);
	        data[offset++] = b & 0xFF;
	        if (offset > length) {
	            length = offset;
	        }
	    }
	    function readShort() {
	        return (readByte() << 8) | readByte();
	    }
	    function writeShort(w) {
	        writeByte(w >> 8);
	        writeByte(w);
	    }
	    function readShort_() {
	        var w = readShort();
	        return w >= 0x8000 ? w - 0x10000 : w;
	    }
	    function writeShort_(w) {
	        writeShort(w < 0 ? w + 0x10000 : w);
	    }
	    function readLong() {
	        return (readShort() * 0x10000) + readShort();
	    }
	    function writeLong(w) {
	        writeShort((w >>> 16) & 0xFFFF);
	        writeShort(w & 0xFFFF);
	    }
	    function readLong_() {
	        var w = readLong();
	        return w >= 0x80000000 ? w - 0x100000000 : w;
	    }
	    function writeLong_(w) {
	        writeLong(w < 0 ? w + 0x100000000 : w);
	    }
	    function readFixed() {
	        return readLong() / 0x10000;
	    }
	    function writeFixed(f) {
	        writeLong(Math.round(f * 0x10000));
	    }
	    function readFixed_() {
	        return readLong_() / 0x10000;
	    }
	    function writeFixed_(f) {
	        writeLong_(Math.round(f * 0x10000));
	    }
	    function read(len) {
	        return times(len, readByte);
	    }
	    function readString(len) {
	        return String.fromCharCode.apply(String, read(len));
	    }
	    function writeString(str) {
	        for (var i = 0; i < str.length; ++i) {
	            writeByte(str.charCodeAt(i));
	        }
	    }
	    function times(n, reader) {
	        for (var ret = new Array(n), i = 0; i < n; ++i) {
	            ret[i] = reader();
	        }
	        return ret;
	    }
	
	    var stream = {
	        eof         : eof,
	        readByte    : readByte,
	        writeByte   : writeByte,
	        readShort   : readShort,
	        writeShort  : writeShort,
	        readLong    : readLong,
	        writeLong   : writeLong,
	        readFixed   : readFixed,
	        writeFixed  : writeFixed,
	
	        // signed numbers.
	        readShort_  : readShort_,
	        writeShort_ : writeShort_,
	        readLong_   : readLong_,
	        writeLong_  : writeLong_,
	        readFixed_  : readFixed_,
	        writeFixed_ : writeFixed_,
	
	        read        : read,
	        write       : write,
	        readString  : readString,
	        writeString : writeString,
	
	        times       : times,
	        get         : get,
	        slice       : slice,
	
	        offset: function(pos) {
	            if (pos != null) {
	                offset = pos;
	                return stream;
	            }
	            return offset;
	        },
	
	        skip: function(nbytes) {
	            offset += nbytes;
	        },
	
	        toString: function() {
	            throw new Error("FIX CALLER.  BinaryStream is no longer convertible to string!");
	        },
	
	        length: function() { return length; },
	
	        saveExcursion: function(f) {
	            var pos = offset;
	            try {
	                return f();
	            } finally {
	                offset = pos;
	            }
	        },
	
	        writeBase64: function(base64) {
	            if (window.atob) {
	                writeString(window.atob(base64));
	            } else {
	                write(BASE64.decode(base64));
	            }
	        },
	        base64: function() {
	            return BASE64.encode(get());
	        }
	    };
	
	    return stream;
	}
	
	function ucs2decode(string) {
	    var output = [],
	        counter = 0,
	        length = string.length,
	        value,
	        extra;
	    while (counter < length) {
	        value = string.charCodeAt(counter++);
	        if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
	            // high surrogate, and there is a next character
	            extra = string.charCodeAt(counter++);
	            if ((extra & 0xFC00) == 0xDC00) { // low surrogate
	                output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
	            } else {
	                // unmatched surrogate; only append this code unit, in case the next
	                // code unit is the high surrogate of a surrogate pair
	                output.push(value);
	                counter--;
	            }
	        } else {
	            output.push(value);
	        }
	    }
	    return output;
	}
	
	function ucs2encode(array) {
	    return array.map(function(value){
	        var output = "";
	        if (value > 0xFFFF) {
	            value -= 0x10000;
	            output += String.fromCharCode(value >>> 10 & 0x3FF | 0xD800);
	            value = 0xDC00 | value & 0x3FF;
	        }
	        output += String.fromCharCode(value);
	        return output;
	    }).join("");
	}
	
	function atobUint8Array(base64) {
	    var data = window.atob(base64);
	    var result = new Uint8Array(data.length);
	
	    for (var idx = 0; idx < data.length; idx++) {
	        result[idx] = data.charCodeAt(idx);
	    }
	
	    return result;
	}
	
	function createUint8Array(data) {
	    var result = new Uint8Array(data.length);
	
	    for (var idx = 0; idx < data.length; idx++) {
	        result[idx] = data[idx];
	    }
	
	    return result;
	}
	
	function base64ToUint8Array(base64) {
	    if (window.atob) {
	        return atobUint8Array(base64);
	    }
	
	    return createUint8Array(BASE64.decode(base64));
	}
	
	/* eslint-disable no-multi-spaces, key-spacing, indent, camelcase, space-before-blocks, eqeqeq, brace-style */
	/* eslint-disable space-infix-ops, space-before-function-paren, array-bracket-spacing, object-curly-spacing */
	/* eslint-disable no-nested-ternary, max-params, default-case, no-else-return, no-empty */
	/* eslint-disable no-param-reassign, no-var, block-scoped-var */
	
	/*****************************************************************************\
	 *
	 * The code in this file, although written from scratch, is influenced by the
	 * TrueType parser/encoder in PDFKit -- http://pdfkit.org/ (a CoffeeScript
	 * library for producing PDF files).
	 *
	 * PDFKit is (c) Devon Govett 2014 and released under the MIT License.
	 *
	\*****************************************************************************/
	
	function hasOwnProperty$1(obj, key) {
	    return Object.prototype.hasOwnProperty.call(obj, key);
	}
	
	function sortedKeys(obj) {
	    return Object.keys(obj).sort(function(a, b){ return a - b; }).map(parseFloat);
	}
	
	///
	var Directory = function Directory(data) {
	    this.raw = data;
	    this.scalerType = data.readLong();
	    this.tableCount = data.readShort();
	    this.searchRange = data.readShort();
	    this.entrySelector = data.readShort();
	    this.rangeShift = data.readShort();
	
	    var tables = this.tables = {};
	    for (var i = 0; i < this.tableCount; ++i) {
	        var entry = {
	            tag  : data.readString(4),
	            checksum : data.readLong(),
	            offset   : data.readLong(),
	            length   : data.readLong()
	        };
	        tables[entry.tag] = entry;
	    }
	};
	
	Directory.prototype.readTable = function readTable (name, Ctor) {
	    var def = this.tables[name];
	    if (!def) {
	        throw new Error("Table " + name + " not found in directory");
	    }
	    return (this[name] = def.table = new Ctor(this, def));
	};
	
	Directory.prototype.render = function render (tables) {
	        var this$1 = this;
	
	    var tableCount = Object.keys(tables).length;
	
	    var maxpow2 = Math.pow(2, Math.floor(Math.log(tableCount) / Math.LN2));
	    var searchRange = maxpow2 * 16;
	    var entrySelector = Math.floor(Math.log(maxpow2) / Math.LN2);
	    var rangeShift = tableCount * 16 - searchRange;
	
	    var out = BinaryStream();
	    out.writeLong(this.scalerType);
	    out.writeShort(tableCount);
	    out.writeShort(searchRange);
	    out.writeShort(entrySelector);
	    out.writeShort(rangeShift);
	
	    var directoryLength = tableCount * 16;
	    var offset = out.offset() + directoryLength;
	    var headOffset = null;
	    var tableData = BinaryStream();
	
	    for (var tag in tables) {
	        if (hasOwnProperty$1(tables, tag)) {
	            var table = tables[tag];
	
	            out.writeString(tag);
	            out.writeLong(this$1.checksum(table));
	            out.writeLong(offset);
	            out.writeLong(table.length);
	
	            tableData.write(table);
	            if (tag == "head") {
	                headOffset = offset;
	            }
	            offset += table.length;
	
	            while (offset % 4) {
	                tableData.writeByte(0);
	                offset++;
	            }
	        }
	    }
	
	    out.write(tableData.get());
	    var sum = this.checksum(out.get());
	    var adjustment = 0xB1B0AFBA - sum;
	
	    out.offset(headOffset + 8);
	    out.writeLong(adjustment);
	    return out.get();
	};
	
	Directory.prototype.checksum = function checksum (data) {
	    data = BinaryStream(data);
	    var sum = 0;
	    while (!data.eof()) {
	        sum += data.readLong();
	    }
	    return sum & 0xFFFFFFFF;
	};
	
	var Table = function Table(file, def) {
	    this.definition = def;
	    this.length = def.length;
	    this.offset = def.offset;
	    this.file = file;
	    this.rawData = file.raw;
	    this.parse(file.raw);
	};
	
	Table.prototype.raw = function raw () {
	    return this.rawData.slice(this.offset, this.length);
	};
	
	Table.prototype.parse = function parse () {};
	
	var HeadTable = (function (Table) {
	    function HeadTable () {
	        Table.apply(this, arguments);
	    }
	
	    if ( Table ) HeadTable.__proto__ = Table;
	    HeadTable.prototype = Object.create( Table && Table.prototype );
	    HeadTable.prototype.constructor = HeadTable;
	
	    HeadTable.prototype.parse = function parse (data) {
	        data.offset(this.offset);
	        this.version             = data.readLong();
	        this.revision            = data.readLong();
	        this.checkSumAdjustment  = data.readLong();
	        this.magicNumber         = data.readLong();
	        this.flags               = data.readShort();
	        this.unitsPerEm          = data.readShort();
	        this.created             = data.read(8);
	        this.modified            = data.read(8);
	
	        this.xMin = data.readShort_();
	        this.yMin = data.readShort_();
	        this.xMax = data.readShort_();
	        this.yMax = data.readShort_();
	
	        this.macStyle           = data.readShort();
	        this.lowestRecPPEM      = data.readShort();
	        this.fontDirectionHint  = data.readShort_();
	        this.indexToLocFormat   = data.readShort_();
	        this.glyphDataFormat    = data.readShort_();
	    };
	
	    HeadTable.prototype.render = function render (indexToLocFormat) {
	        var out = BinaryStream();
	        out.writeLong(this.version);
	        out.writeLong(this.revision);
	        out.writeLong(0);       // checksum adjustment; shall be computed later
	        out.writeLong(this.magicNumber);
	        out.writeShort(this.flags);
	        out.writeShort(this.unitsPerEm);
	        out.write(this.created);
	        out.write(this.modified);
	        out.writeShort_(this.xMin);
	        out.writeShort_(this.yMin);
	        out.writeShort_(this.xMax);
	        out.writeShort_(this.yMax);
	        out.writeShort(this.macStyle);
	        out.writeShort(this.lowestRecPPEM);
	        out.writeShort_(this.fontDirectionHint);
	        out.writeShort_(indexToLocFormat); // this will depend on the `loca` table
	        out.writeShort_(this.glyphDataFormat);
	        return out.get();
	    };
	
	    return HeadTable;
	}(Table));
	
	var LocaTable = (function (Table) {
	    function LocaTable () {
	        Table.apply(this, arguments);
	    }
	
	    if ( Table ) LocaTable.__proto__ = Table;
	    LocaTable.prototype = Object.create( Table && Table.prototype );
	    LocaTable.prototype.constructor = LocaTable;
	
	    LocaTable.prototype.parse = function parse (data) {
	        data.offset(this.offset);
	        var format = this.file.head.indexToLocFormat;
	        if (format === 0) {
	            this.offsets = data.times(this.length / 2, function(){
	                return 2 * data.readShort();
	            });
	        } else {
	            this.offsets = data.times(this.length / 4, data.readLong);
	        }
	    };
	
	    LocaTable.prototype.offsetOf = function offsetOf (id) {
	        return this.offsets[id];
	    };
	
	    LocaTable.prototype.lengthOf = function lengthOf (id) {
	        return this.offsets[id + 1] - this.offsets[id];
	    };
	
	    LocaTable.prototype.render = function render (offsets) {
	        var out = BinaryStream();
	        var needsLongFormat = offsets[offsets.length - 1] > 0xFFFF;
	        for (var i = 0; i < offsets.length; ++i) {
	            if (needsLongFormat) {
	                out.writeLong(offsets[i]);
	            } else {
	                out.writeShort(offsets[i] / 2);
	            }
	        }
	        return {
	            format: needsLongFormat ? 1 : 0,
	            table: out.get()
	        };
	    };
	
	    return LocaTable;
	}(Table));
	
	var HheaTable = (function (Table) {
	    function HheaTable () {
	        Table.apply(this, arguments);
	    }
	
	    if ( Table ) HheaTable.__proto__ = Table;
	    HheaTable.prototype = Object.create( Table && Table.prototype );
	    HheaTable.prototype.constructor = HheaTable;
	
	    HheaTable.prototype.parse = function parse (data) {
	        data.offset(this.offset);
	
	        this.version              = data.readLong();
	        this.ascent               = data.readShort_();
	        this.descent              = data.readShort_();
	        this.lineGap              = data.readShort_();
	        this.advanceWidthMax      = data.readShort();
	        this.minLeftSideBearing   = data.readShort_();
	        this.minRightSideBearing  = data.readShort_();
	        this.xMaxExtent           = data.readShort_();
	        this.caretSlopeRise       = data.readShort_();
	        this.caretSlopeRun        = data.readShort_();
	        this.caretOffset          = data.readShort_();
	
	        data.skip(4 * 2);       // reserved
	
	        this.metricDataFormat     = data.readShort_();
	        this.numOfLongHorMetrics  = data.readShort();
	    };
	
	    HheaTable.prototype.render = function render (ids) {
	        var out = BinaryStream();
	        out.writeLong(this.version);
	        out.writeShort_(this.ascent);
	        out.writeShort_(this.descent);
	        out.writeShort_(this.lineGap);
	        out.writeShort(this.advanceWidthMax);
	        out.writeShort_(this.minLeftSideBearing);
	        out.writeShort_(this.minRightSideBearing);
	        out.writeShort_(this.xMaxExtent);
	        out.writeShort_(this.caretSlopeRise);
	        out.writeShort_(this.caretSlopeRun);
	        out.writeShort_(this.caretOffset);
	
	        out.write([ 0, 0, 0, 0, 0, 0, 0, 0 ]); // reserved bytes
	
	        out.writeShort_(this.metricDataFormat);
	        out.writeShort(ids.length);
	        return out.get();
	    };
	
	    return HheaTable;
	}(Table));
	
	var MaxpTable = (function (Table) {
	    function MaxpTable () {
	        Table.apply(this, arguments);
	    }
	
	    if ( Table ) MaxpTable.__proto__ = Table;
	    MaxpTable.prototype = Object.create( Table && Table.prototype );
	    MaxpTable.prototype.constructor = MaxpTable;
	
	    MaxpTable.prototype.parse = function parse (data) {
	        data.offset(this.offset);
	        this.version = data.readLong();
	        this.numGlyphs = data.readShort();
	        this.maxPoints = data.readShort();
	        this.maxContours = data.readShort();
	        this.maxComponentPoints = data.readShort();
	        this.maxComponentContours = data.readShort();
	        this.maxZones = data.readShort();
	        this.maxTwilightPoints = data.readShort();
	        this.maxStorage = data.readShort();
	        this.maxFunctionDefs = data.readShort();
	        this.maxInstructionDefs = data.readShort();
	        this.maxStackElements = data.readShort();
	        this.maxSizeOfInstructions = data.readShort();
	        this.maxComponentElements = data.readShort();
	        this.maxComponentDepth = data.readShort();
	    };
	
	    MaxpTable.prototype.render = function render (glyphIds) {
	        var out = BinaryStream();
	        out.writeLong(this.version);
	        out.writeShort(glyphIds.length);
	        out.writeShort(this.maxPoints);
	        out.writeShort(this.maxContours);
	        out.writeShort(this.maxComponentPoints);
	        out.writeShort(this.maxComponentContours);
	        out.writeShort(this.maxZones);
	        out.writeShort(this.maxTwilightPoints);
	        out.writeShort(this.maxStorage);
	        out.writeShort(this.maxFunctionDefs);
	        out.writeShort(this.maxInstructionDefs);
	        out.writeShort(this.maxStackElements);
	        out.writeShort(this.maxSizeOfInstructions);
	        out.writeShort(this.maxComponentElements);
	        out.writeShort(this.maxComponentDepth);
	        return out.get();
	    };
	
	    return MaxpTable;
	}(Table));
	
	var HmtxTable = (function (Table) {
	    function HmtxTable () {
	        Table.apply(this, arguments);
	    }
	
	    if ( Table ) HmtxTable.__proto__ = Table;
	    HmtxTable.prototype = Object.create( Table && Table.prototype );
	    HmtxTable.prototype.constructor = HmtxTable;
	
	    HmtxTable.prototype.parse = function parse (data) {
	        data.offset(this.offset);
	        var dir = this.file, hhea = dir.hhea;
	        this.metrics = data.times(hhea.numOfLongHorMetrics, function(){
	            return {
	                advance: data.readShort(),
	                lsb: data.readShort_()
	            };
	        });
	        var lsbCount = dir.maxp.numGlyphs - dir.hhea.numOfLongHorMetrics;
	        this.leftSideBearings = data.times(lsbCount, data.readShort_);
	    };
	
	    HmtxTable.prototype.forGlyph = function forGlyph (id) {
	        var metrics = this.metrics;
	        var n = metrics.length;
	        if (id < n) {
	            return metrics[id];
	        }
	        return {
	            advance: metrics[n - 1].advance,
	            lsb: this.leftSideBearings[id - n]
	        };
	    };
	
	    HmtxTable.prototype.render = function render (glyphIds) {
	        var this$1 = this;
	
	        var out = BinaryStream();
	        for (var i = 0; i < glyphIds.length; ++i) {
	            var m = this$1.forGlyph(glyphIds[i]);
	            out.writeShort(m.advance);
	            out.writeShort_(m.lsb);
	        }
	        return out.get();
	    };
	
	    return HmtxTable;
	}(Table));
	
	var GlyfTable = (function(){
	    var SimpleGlyph = function SimpleGlyph(raw) {
	        this.raw = raw;
	    };
	
	    var prototypeAccessors = { compound: {} };
	
	    prototypeAccessors.compound.get = function () {
	        return false;
	    };
	
	    SimpleGlyph.prototype.render = function render () {
	        return this.raw.get();
	    };
	
	    Object.defineProperties( SimpleGlyph.prototype, prototypeAccessors );
	
	    var ARG_1_AND_2_ARE_WORDS     = 0x0001;
	    var WE_HAVE_A_SCALE           = 0x0008;
	    var MORE_COMPONENTS           = 0x0020;
	    var WE_HAVE_AN_X_AND_Y_SCALE  = 0x0040;
	    var WE_HAVE_A_TWO_BY_TWO      = 0x0080;
	    //var WE_HAVE_INSTRUCTIONS      = 0x0100;
	
	    var CompoundGlyph = function CompoundGlyph(data) {
	        this.raw = data;
	        var ids = this.glyphIds = [];
	        var offsets = this.idOffsets = [];
	        while (true) {      // eslint-disable-line no-constant-condition
	            var flags = data.readShort();
	            offsets.push(data.offset());
	            ids.push(data.readShort());
	
	            if (!(flags & MORE_COMPONENTS)) {
	                break;
	            }
	
	            data.skip(flags & ARG_1_AND_2_ARE_WORDS ? 4 : 2);
	
	            if (flags & WE_HAVE_A_TWO_BY_TWO) {
	                data.skip(8);
	            } else if (flags & WE_HAVE_AN_X_AND_Y_SCALE) {
	                data.skip(4);
	            } else if (flags & WE_HAVE_A_SCALE) {
	                data.skip(2);
	            }
	        }
	    };
	
	    var prototypeAccessors$1 = { compound: {} };
	
	    prototypeAccessors$1.compound.get = function () {
	        return true;
	    };
	
	    CompoundGlyph.prototype.render = function render (old2new) {
	            var this$1 = this;
	
	        var out = BinaryStream(this.raw.get());
	        for (var i = 0; i < this.glyphIds.length; ++i) {
	            var id = this$1.glyphIds[i];
	            out.offset(this$1.idOffsets[i]);
	            out.writeShort(old2new[id]);
	        }
	        return out.get();
	    };
	
	    Object.defineProperties( CompoundGlyph.prototype, prototypeAccessors$1 );
	
	    return (function (Table) {
	        function anonymous () {
	            Table.apply(this, arguments);
	        }
	
	        if ( Table ) anonymous.__proto__ = Table;
	        anonymous.prototype = Object.create( Table && Table.prototype );
	        anonymous.prototype.constructor = anonymous;
	
	        anonymous.prototype.parse = function parse () {
	            this.cache = {};
	        };
	
	        anonymous.prototype.glyphFor = function glyphFor (id) {
	            var cache = this.cache;
	            if (hasOwnProperty$1(cache, id)) {
	                return cache[id];
	            }
	
	            var loca = this.file.loca;
	            var length = loca.lengthOf(id);
	
	            if (length === 0) {
	                return (cache[id] = null);
	            }
	
	            var data = this.rawData;
	            var offset = this.offset + loca.offsetOf(id);
	            var raw = BinaryStream(data.slice(offset, length));
	
	            var numberOfContours = raw.readShort_();
	            var xMin = raw.readShort_();
	            var yMin = raw.readShort_();
	            var xMax = raw.readShort_();
	            var yMax = raw.readShort_();
	
	            var glyph = cache[id] = numberOfContours < 0 ? new CompoundGlyph(raw) : new SimpleGlyph(raw);
	
	            glyph.numberOfContours = numberOfContours;
	            glyph.xMin = xMin;
	            glyph.yMin = yMin;
	            glyph.xMax = xMax;
	            glyph.yMax = yMax;
	
	            return glyph;
	        };
	
	        anonymous.prototype.render = function render (glyphs, oldIds, old2new) {
	            var out = BinaryStream(), offsets = [];
	            for (var i = 0; i < oldIds.length; ++i) {
	                var id = oldIds[i];
	                var glyph = glyphs[id];
	                if (out.offset() % 2) {
	                    out.writeByte(0);
	                }
	                offsets.push(out.offset());
	                if (glyph) {
	                    out.write(glyph.render(old2new));
	                }
	            }
	            if (out.offset() % 2) {
	                out.writeByte(0);
	            }
	            offsets.push(out.offset());
	            return {
	                table: out.get(),
	                offsets: offsets
	            };
	        };
	
	        return anonymous;
	    }(Table));
	}());
	
	var NameTable = (function(){
	    var NameEntry = function NameEntry(text, entry) {
	        this.text = text;
	        this.length = text.length;
	        this.platformID = entry.platformID;
	        this.platformSpecificID = entry.platformSpecificID;
	        this.languageID = entry.languageID;
	        this.nameID = entry.nameID;
	    };
	
	    return (function (Table) {
	        function anonymous () {
	            Table.apply(this, arguments);
	        }
	
	        if ( Table ) anonymous.__proto__ = Table;
	        anonymous.prototype = Object.create( Table && Table.prototype );
	        anonymous.prototype.constructor = anonymous;
	
	        anonymous.prototype.parse = function parse (data) {
	            data.offset(this.offset);
	            data.readShort();   // format
	            var count = data.readShort();
	            var stringOffset = this.offset + data.readShort();
	            var nameRecords = data.times(count, function(){
	                return {
	                    platformID         : data.readShort(),
	                    platformSpecificID : data.readShort(),
	                    languageID         : data.readShort(),
	                    nameID             : data.readShort(),
	                    length             : data.readShort(),
	                    offset             : data.readShort() + stringOffset
	                };
	            });
	            var strings = this.strings = {};
	            for (var i = 0; i < nameRecords.length; ++i) {
	                var rec = nameRecords[i];
	                data.offset(rec.offset);
	                var text = data.readString(rec.length);
	                if (!strings[rec.nameID]) {
	                    strings[rec.nameID] = [];
	                }
	                strings[rec.nameID].push(new NameEntry(text, rec));
	            }
	            this.postscriptEntry = strings[6][0];
	            this.postscriptName = this.postscriptEntry.text.replace(/[^\x20-\x7F]/g, "");
	        };
	
	        anonymous.prototype.render = function render (psName) {
	            var this$1 = this;
	
	            var strings = this.strings;
	            var strCount = 0;
	            for (var i in strings) {
	                if (hasOwnProperty$1(strings, i)) {
	                    strCount += strings[i].length;
	                }
	            }
	            var out = BinaryStream();
	            var strTable = BinaryStream();
	
	            out.writeShort(0);  // format
	            out.writeShort(strCount);
	            out.writeShort(6 + 12 * strCount); // stringOffset
	
	            for (i in strings) {
	                if (hasOwnProperty$1(strings, i)) {
	                    var list = i == 6 ? [
	                        new NameEntry(psName, this$1.postscriptEntry)
	                    ] : strings[i];
	                    for (var j = 0; j < list.length; ++j) {
	                        var str = list[j];
	                        out.writeShort(str.platformID);
	                        out.writeShort(str.platformSpecificID);
	                        out.writeShort(str.languageID);
	                        out.writeShort(str.nameID);
	                        out.writeShort(str.length);
	                        out.writeShort(strTable.offset());
	
	                        strTable.writeString(str.text);
	                    }
	                }
	            }
	
	            out.write(strTable.get());
	
	            return out.get();
	        };
	
	        return anonymous;
	    }(Table));
	})();
	
	var PostTable = (function(){
	    var POSTSCRIPT_GLYPHS = ".notdef .null nonmarkingreturn space exclam quotedbl numbersign dollar percent ampersand quotesingle parenleft parenright asterisk plus comma hyphen period slash zero one two three four five six seven eight nine colon semicolon less equal greater question at A B C D E F G H I J K L M N O P Q R S T U V W X Y Z bracketleft backslash bracketright asciicircum underscore grave a b c d e f g h i j k l m n o p q r s t u v w x y z braceleft bar braceright asciitilde Adieresis Aring Ccedilla Eacute Ntilde Odieresis Udieresis aacute agrave acircumflex adieresis atilde aring ccedilla eacute egrave ecircumflex edieresis iacute igrave icircumflex idieresis ntilde oacute ograve ocircumflex odieresis otilde uacute ugrave ucircumflex udieresis dagger degree cent sterling section bullet paragraph germandbls registered copyright trademark acute dieresis notequal AE Oslash infinity plusminus lessequal greaterequal yen mu partialdiff summation product pi integral ordfeminine ordmasculine Omega ae oslash questiondown exclamdown logicalnot radical florin approxequal Delta guillemotleft guillemotright ellipsis nonbreakingspace Agrave Atilde Otilde OE oe endash emdash quotedblleft quotedblright quoteleft quoteright divide lozenge ydieresis Ydieresis fraction currency guilsinglleft guilsinglright fi fl daggerdbl periodcentered quotesinglbase quotedblbase perthousand Acircumflex Ecircumflex Aacute Edieresis Egrave Iacute Icircumflex Idieresis Igrave Oacute Ocircumflex apple Ograve Uacute Ucircumflex Ugrave dotlessi circumflex tilde macron breve dotaccent ring cedilla hungarumlaut ogonek caron Lslash lslash Scaron scaron Zcaron zcaron brokenbar Eth eth Yacute yacute Thorn thorn minus multiply onesuperior twosuperior threesuperior onehalf onequarter threequarters franc Gbreve gbreve Idotaccent Scedilla scedilla Cacute cacute Ccaron ccaron dcroat".split(/\s+/g);
	
	    return (function (Table) {
	        function anonymous () {
	            Table.apply(this, arguments);
	        }
	
	        if ( Table ) anonymous.__proto__ = Table;
	        anonymous.prototype = Object.create( Table && Table.prototype );
	        anonymous.prototype.constructor = anonymous;
	
	        anonymous.prototype.parse = function parse (data) {
	            var this$1 = this;
	
	            data.offset(this.offset);
	
	            this.format = data.readLong();
	            this.italicAngle = data.readFixed_();
	            this.underlinePosition = data.readShort_();
	            this.underlineThickness = data.readShort_();
	            this.isFixedPitch = data.readLong();
	            this.minMemType42 = data.readLong();
	            this.maxMemType42 = data.readLong();
	            this.minMemType1 = data.readLong();
	            this.maxMemType1 = data.readLong();
	
	            var numberOfGlyphs;
	
	            switch (this.format) {
	              case 0x00010000:
	              case 0x00030000:
	                break;
	
	              case 0x00020000:
	                numberOfGlyphs = data.readShort();
	                this.glyphNameIndex = data.times(numberOfGlyphs, data.readShort);
	                this.names = [];
	                var limit = this.offset + this.length;
	                while (data.offset() < limit) {
	                    this$1.names.push(data.readString(data.readByte()));
	                }
	                break;
	
	              case 0x00025000:
	                numberOfGlyphs = data.readShort();
	                this.offsets = data.read(numberOfGlyphs);
	                break;
	
	              case 0x00040000:
	                this.map = data.times(this.file.maxp.numGlyphs, data.readShort);
	                break;
	            }
	        };
	
	        anonymous.prototype.glyphFor = function glyphFor (code) {
	            switch (this.format) {
	              case 0x00010000:
	                return POSTSCRIPT_GLYPHS[code] || ".notdef";
	
	              case 0x00020000:
	                var index = this.glyphNameIndex[code];
	                if (index < POSTSCRIPT_GLYPHS.length) {
	                    return POSTSCRIPT_GLYPHS[index];
	                }
	                return this.names[index - POSTSCRIPT_GLYPHS.length] || ".notdef";
	
	              case 0x00025000:
	
	              case 0x00030000:
	                return ".notdef";
	
	              case 0x00040000:
	                return this.map[code] || 0xFFFF;
	            }
	        };
	
	        anonymous.prototype.render = function render (mapping) {
	            var this$1 = this;
	
	            if (this.format == 0x00030000) {
	                return this.raw();
	            }
	
	            // keep original header, but set format to 2.0
	            var out = BinaryStream(this.rawData.slice(this.offset, 32));
	            out.writeLong(0x00020000);
	            out.offset(32);
	
	            var indexes = [];
	            var strings = [];
	
	            for (var i = 0; i < mapping.length; ++i) {
	                var id = mapping[i];
	                var post = this$1.glyphFor(id);
	                var index = POSTSCRIPT_GLYPHS.indexOf(post);
	                if (index >= 0) {
	                    indexes.push(index);
	                } else {
	                    indexes.push(POSTSCRIPT_GLYPHS.length + strings.length);
	                    strings.push(post);
	                }
	            }
	
	            out.writeShort(mapping.length);
	
	            for (i = 0; i < indexes.length; ++i) {
	                out.writeShort(indexes[i]);
	            }
	
	            for (i = 0; i < strings.length; ++i) {
	                out.writeByte(strings[i].length);
	                out.writeString(strings[i]);
	            }
	
	            return out.get();
	        };
	
	        return anonymous;
	    }(Table));
	})();
	
	var CmapTable = (function(){
	    var CmapEntry = function CmapEntry(data, offset, codeMap) {
	        var self = this;
	        self.platformID = data.readShort();
	        self.platformSpecificID = data.readShort();
	        self.offset = offset + data.readLong();
	
	        data.saveExcursion(function(){
	            var code;
	            data.offset(self.offset);
	            self.format = data.readShort();
	
	            switch (self.format) {
	            case 0:
	                self.length = data.readShort();
	                self.language = data.readShort();
	                for (var i = 0; i < 256; ++i) {
	                    codeMap[i] = data.readByte();
	                }
	                break;
	
	            case 4:
	                self.length = data.readShort();
	                self.language = data.readShort();
	                var segCount = data.readShort() / 2;
	
	                data.skip(6);   // searchRange, entrySelector, rangeShift
	                var endCode = data.times(segCount, data.readShort);
	                data.skip(2);   // reserved pad
	                var startCode = data.times(segCount, data.readShort);
	                var idDelta = data.times(segCount, data.readShort_);
	                var idRangeOffset = data.times(segCount, data.readShort);
	
	                var count = (self.length + self.offset - data.offset()) / 2;
	                var glyphIds = data.times(count, data.readShort);
	
	                for (i = 0; i < segCount; ++i) {
	                    var start = startCode[i], end = endCode[i];
	                    for (code = start; code <= end; ++code) {
	                        var glyphId;
	                        if (idRangeOffset[i] === 0) {
	                            glyphId = code + idDelta[i];
	                        } else {
	                            ///
	                            // When non-zero, idRangeOffset contains for each segment the byte offset of the Glyph ID
	                            // into the glyphIds table, from the *current* `i` cell of idRangeOffset.  In other words,
	                            // this offset spans from the first into the second array.  This works, because the arrays
	                            // are consecutive in the TTF file:
	                            //
	                            // [ ...idRangeOffset... ][ ...glyphIds... ]
	                            //   ...... 48 ......   .... ID ....
	                            //          ^----- 48 bytes -----^
	                            //
	                            // (but I can't stop wondering why is it not just a plain index, possibly incremented by 1
	                            // so that we can have that special `zero` value.)
	                            //
	                            // The elements of idRangeOffset are even numbers, because both arrays contain 16-bit words,
	                            // yet the offset is in bytes.  That is why we divide it by 2.  Then we subtract the
	                            // remaining segments (segCount-i), and add the code-start offset, to which we need to add
	                            // the corresponding delta to get the actual glyph ID.
	                            ///
	                            var index = idRangeOffset[i] / 2 - (segCount - i) + (code - start);
	                            glyphId = glyphIds[index] || 0;
	                            if (glyphId !== 0) {
	                                glyphId += idDelta[i];
	                            }
	                        }
	                        codeMap[code] = glyphId & 0xFFFF;
	                    }
	                }
	                break;
	
	            case 6:
	                self.length = data.readShort();
	                self.language = data.readShort();
	                code = data.readShort();
	                var length = data.readShort();
	                while (length-- > 0) {
	                    codeMap[code++] = data.readShort();
	                }
	                break;
	
	            case 12:
	                data.readShort(); // reserved
	                self.length = data.readLong();
	                self.language = data.readLong();
	                var ngroups = data.readLong();
	                while (ngroups-- > 0) {
	                    code = data.readLong();
	                    var endCharCode = data.readLong();
	                    var glyphCode = data.readLong();
	                    while (code <= endCharCode) {
	                        codeMap[code++] = glyphCode++;
	                    }
	                }
	                break;
	
	            default:
	                if (window.console) {
	                    window.console.error("Unhandled CMAP format: " + self.format);
	                }
	            }
	        });
	    };
	
	    function renderCharmap(ncid2ogid, ogid2ngid) {
	        var codes = sortedKeys(ncid2ogid);
	        var startCodes = [];
	        var endCodes = [];
	        var last = null;
	        var diff = null;
	
	        function new_gid(charcode) {
	            return ogid2ngid[ncid2ogid[charcode]];
	        }
	
	        for (var i = 0; i < codes.length; ++i) {
	            var code = codes[i];
	            var gid = new_gid(code);
	            var delta = gid - code;
	            if (last == null || delta !== diff) {
	                if (last) {
	                    endCodes.push(last);
	                }
	                startCodes.push(code);
	                diff = delta;
	            }
	            last = code;
	        }
	
	        if (last) {
	            endCodes.push(last);
	        }
	        endCodes.push(0xFFFF);
	        startCodes.push(0xFFFF);
	
	        var segCount = startCodes.length;
	        var segCountX2 = segCount * 2;
	        var searchRange = 2 * Math.pow(2, Math.floor(Math.log(segCount) / Math.LN2));
	        var entrySelector = Math.log(searchRange / 2) / Math.LN2;
	        var rangeShift = segCountX2 - searchRange;
	
	        var deltas = [];
	        var rangeOffsets = [];
	        var glyphIds = [];
	
	        for (i = 0; i < segCount; ++i) {
	            var startCode = startCodes[i];
	            var endCode = endCodes[i];
	            if (startCode == 0xFFFF) {
	                deltas.push(0);
	                rangeOffsets.push(0);
	                break;
	            }
	            var startGlyph = new_gid(startCode);
	            if (startCode - startGlyph >= 0x8000) {
	                deltas.push(0);
	                rangeOffsets.push(2 * (glyphIds.length + segCount - i));
	                for (var j = startCode; j <= endCode; ++j) {
	                    glyphIds.push(new_gid(j));
	                }
	            } else {
	                deltas.push(startGlyph - startCode);
	                rangeOffsets.push(0);
	            }
	        }
	
	        var out = BinaryStream();
	
	        out.writeShort(3);      // platformID
	        out.writeShort(1);      // platformSpecificID
	        out.writeLong(12);      // offset
	        out.writeShort(4);      // format
	        out.writeShort(16 + segCount * 8 + glyphIds.length * 2); // length
	        out.writeShort(0);      // language
	        out.writeShort(segCountX2);
	        out.writeShort(searchRange);
	        out.writeShort(entrySelector);
	        out.writeShort(rangeShift);
	
	        endCodes.forEach(out.writeShort);
	        out.writeShort(0);      // reserved pad
	        startCodes.forEach(out.writeShort);
	        deltas.forEach(out.writeShort_);
	        rangeOffsets.forEach(out.writeShort);
	        glyphIds.forEach(out.writeShort);
	
	        return out.get();
	    }
	
	    return (function (Table) {
	        function anonymous () {
	            Table.apply(this, arguments);
	        }
	
	        if ( Table ) anonymous.__proto__ = Table;
	        anonymous.prototype = Object.create( Table && Table.prototype );
	        anonymous.prototype.constructor = anonymous;
	
	        anonymous.prototype.parse = function parse (data) {
	            var self = this;
	            var offset = self.offset;
	            data.offset(offset);
	            self.codeMap = {};
	            self.version = data.readShort();
	            var tableCount = data.readShort();
	            self.tables = data.times(tableCount, function(){
	                return new CmapEntry(data, offset, self.codeMap);
	            });
	        };
	
	        anonymous.render = function render (ncid2ogid, ogid2ngid) {
	            var out = BinaryStream();
	            out.writeShort(0);  // version
	            out.writeShort(1);  // tableCount
	            out.write(renderCharmap(ncid2ogid, ogid2ngid));
	            return out.get();
	        };
	
	        return anonymous;
	    }(Table));
	
	})();
	
	var OS2Table = (function (Table) {
	    function OS2Table () {
	        Table.apply(this, arguments);
	    }
	
	    if ( Table ) OS2Table.__proto__ = Table;
	    OS2Table.prototype = Object.create( Table && Table.prototype );
	    OS2Table.prototype.constructor = OS2Table;
	
	    OS2Table.prototype.parse = function parse (data) {
	        data.offset(this.offset);
	        this.version = data.readShort();
	        this.averageCharWidth = data.readShort_();
	        this.weightClass = data.readShort();
	        this.widthClass = data.readShort();
	        this.type = data.readShort();
	        this.ySubscriptXSize = data.readShort_();
	        this.ySubscriptYSize = data.readShort_();
	        this.ySubscriptXOffset = data.readShort_();
	        this.ySubscriptYOffset = data.readShort_();
	        this.ySuperscriptXSize = data.readShort_();
	        this.ySuperscriptYSize = data.readShort_();
	        this.ySuperscriptXOffset = data.readShort_();
	        this.ySuperscriptYOffset = data.readShort_();
	        this.yStrikeoutSize = data.readShort_();
	        this.yStrikeoutPosition = data.readShort_();
	        this.familyClass = data.readShort_();
	
	        this.panose = data.times(10, data.readByte);
	        this.charRange = data.times(4, data.readLong);
	
	        this.vendorID = data.readString(4);
	        this.selection = data.readShort();
	        this.firstCharIndex = data.readShort();
	        this.lastCharIndex = data.readShort();
	
	        if (this.version > 0) {
	            this.ascent = data.readShort_();
	            this.descent = data.readShort_();
	            this.lineGap = data.readShort_();
	            this.winAscent = data.readShort();
	            this.winDescent = data.readShort();
	            this.codePageRange = data.times(2, data.readLong);
	
	            if (this.version > 1) {
	                this.xHeight = data.readShort();
	                this.capHeight = data.readShort();
	                this.defaultChar = data.readShort();
	                this.breakChar = data.readShort();
	                this.maxContext = data.readShort();
	            }
	        }
	    };
	
	    OS2Table.prototype.render = function render () {
	        return this.raw();
	    };
	
	    return OS2Table;
	}(Table));
	
	var subsetTag = 100000;
	
	function nextSubsetTag() {
	    var ret = "", n = String(subsetTag);
	    for (var i = 0; i < n.length; ++i) {
	        ret += String.fromCharCode(n.charCodeAt(i) - 48 + 65);
	    }
	    ++subsetTag;
	    return ret;
	}
	
	var Subfont = function Subfont(font) {
	    this.font = font;
	    this.subset = {};
	    this.unicodes = {};
	    this.ogid2ngid = { 0: 0 };
	    this.ngid2ogid = { 0: 0 };
	    this.ncid2ogid = {};
	    this.next = this.firstChar = 1;
	    this.nextGid = 1;
	    this.psName = nextSubsetTag() + "+" + this.font.psName;
	};
	
	Subfont.prototype.use = function use (ch) {
	    var self = this;
	    if (typeof ch == "string") {
	        return ucs2decode(ch).reduce(function(ret, code){
	            return ret + String.fromCharCode(self.use(code));
	        }, "");
	    }
	    var code = self.unicodes[ch];
	    if (!code) {
	        code = self.next++;
	        self.subset[code] = ch;
	        self.unicodes[ch] = code;
	
	        // generate new GID (glyph ID) and maintain newGID ->
	        // oldGID and back mappings
	        var old_gid = self.font.cmap.codeMap[ch];
	        if (old_gid) {
	            self.ncid2ogid[code] = old_gid;
	            if (self.ogid2ngid[old_gid] == null) {
	                var new_gid = self.nextGid++;
	                self.ogid2ngid[old_gid] = new_gid;
	                self.ngid2ogid[new_gid] = old_gid;
	            }
	        }
	    }
	    return code;
	};
	
	Subfont.prototype.encodeText = function encodeText (text) {
	    return this.use(text);
	};
	
	Subfont.prototype.glyphIds = function glyphIds () {
	    return sortedKeys(this.ogid2ngid);
	};
	
	Subfont.prototype.glyphsFor = function glyphsFor (glyphIds, result) {
	        var this$1 = this;
	
	    if (!result) {
	        result = {};
	    }
	    for (var i = 0; i < glyphIds.length; ++i) {
	        var id = glyphIds[i];
	        if (!result[id]) {
	            var glyph = result[id] = this$1.font.glyf.glyphFor(id);
	            if (glyph && glyph.compound) {
	                this$1.glyphsFor(glyph.glyphIds, result);
	            }
	        }
	    }
	    return result;
	};
	
	Subfont.prototype.render = function render () {
	        var this$1 = this;
	
	    var glyphs = this.glyphsFor(this.glyphIds());
	
	    // add missing sub-glyphs
	    for (var old_gid in glyphs) {
	        if (hasOwnProperty$1(glyphs, old_gid)) {
	            old_gid = parseInt(old_gid, 10);
	            if (this$1.ogid2ngid[old_gid] == null) {
	                var new_gid = this$1.nextGid++;
	                this$1.ogid2ngid[old_gid] = new_gid;
	                this$1.ngid2ogid[new_gid] = old_gid;
	            }
	        }
	    }
	
	    // must obtain old_gid_ids in an order matching sorted
	    // new_gid_ids
	    var new_gid_ids = sortedKeys(this.ngid2ogid);
	    var old_gid_ids = new_gid_ids.map(function(id){
	        return this.ngid2ogid[id];
	    }, this);
	
	    var font = this.font;
	    var glyf = font.glyf.render(glyphs, old_gid_ids, this.ogid2ngid);
	    var loca = font.loca.render(glyf.offsets);
	
	    this.lastChar = this.next - 1;
	
	    var tables = {
	        "cmap" : CmapTable.render(this.ncid2ogid, this.ogid2ngid),
	        "glyf" : glyf.table,
	        "loca" : loca.table,
	        "hmtx" : font.hmtx.render(old_gid_ids),
	        "hhea" : font.hhea.render(old_gid_ids),
	        "maxp" : font.maxp.render(old_gid_ids),
	        "post" : font.post.render(old_gid_ids),
	        "name" : font.name.render(this.psName),
	        "head" : font.head.render(loca.format),
	        "OS/2" : font.os2.render()
	    };
	
	    return this.font.directory.render(tables);
	};
	
	Subfont.prototype.cidToGidMap = function cidToGidMap () {
	        var this$1 = this;
	
	    var out = BinaryStream(), len = 0;
	    for (var cid = this.firstChar; cid < this.next; ++cid) {
	        while (len < cid) {
	            out.writeShort(0);
	            len++;
	        }
	        var old_gid = this$1.ncid2ogid[cid];
	        if (old_gid) {
	            var new_gid = this$1.ogid2ngid[old_gid];
	            out.writeShort(new_gid);
	        } else {
	            out.writeShort(0);
	        }
	        len++;
	    }
	    return out.get();
	};
	
	var TTFFont = function TTFFont(rawData, name) {
	    var self = this;
	    var data = self.contents = BinaryStream(rawData);
	    if (data.readString(4) == "ttcf") {
	        var offset;
	        var parse = function() {
	            data.offset(offset);
	            self.parse();
	        };
	        if (!name) {
	            throw new Error("Must specify a name for TTC files");
	        }
	        data.readLong();    // version
	        var numFonts = data.readLong();
	        for (var i = 0; i < numFonts; ++i) {
	            offset = data.readLong();
	            data.saveExcursion(parse);
	            if (self.psName == name) {
	                return;
	            }
	        }
	        throw new Error("Font " + name + " not found in collection");
	    } else {
	        data.offset(0);
	        self.parse();
	    }
	};
	
	TTFFont.prototype.parse = function parse () {
	    var dir = this.directory = new Directory(this.contents);
	
	    this.head = dir.readTable("head", HeadTable);
	    this.loca = dir.readTable("loca", LocaTable);
	    this.hhea = dir.readTable("hhea", HheaTable);
	    this.maxp = dir.readTable("maxp", MaxpTable);
	    this.hmtx = dir.readTable("hmtx", HmtxTable);
	    this.glyf = dir.readTable("glyf", GlyfTable);
	    this.name = dir.readTable("name", NameTable);
	    this.post = dir.readTable("post", PostTable);
	    this.cmap = dir.readTable("cmap", CmapTable);
	    this.os2  = dir.readTable("OS/2", OS2Table);
	
	    this.psName = this.name.postscriptName;
	    this.ascent = this.os2.ascent || this.hhea.ascent;
	    this.descent = this.os2.descent || this.hhea.descent;
	    this.lineGap = this.os2.lineGap || this.hhea.lineGap;
	    this.scale = 1000 / this.head.unitsPerEm;
	};
	
	TTFFont.prototype.widthOfGlyph = function widthOfGlyph (glyph) {
	    return this.hmtx.forGlyph(glyph).advance * this.scale;
	};
	
	TTFFont.prototype.makeSubset = function makeSubset () {
	    return new Subfont(this);
	};
	
	var deflate$1 = _progress_pakoEsm.deflate;
	
	function supportsDeflate() {
	    return true;
	}
	
	/* eslint-disable no-multi-spaces, key-spacing, indent, camelcase, space-before-blocks, eqeqeq, brace-style */
	/* eslint-disable space-infix-ops, space-before-function-paren, array-bracket-spacing, object-curly-spacing */
	/* eslint-disable no-nested-ternary, max-params, default-case, no-else-return, no-empty */
	/* eslint-disable no-param-reassign, no-var, block-scoped-var */
	
	var browser$2 = support.browser;
	var NL = "\n";
	
	var RESOURCE_COUNTER = 0;
	
	var PAPER_SIZE = {
	    a0        : [ 2383.94 , 3370.39 ],
	    a1        : [ 1683.78 , 2383.94 ],
	    a2        : [ 1190.55 , 1683.78 ],
	    a3        : [ 841.89  , 1190.55 ],
	    a4        : [ 595.28  , 841.89  ],
	    a5        : [ 419.53  , 595.28  ],
	    a6        : [ 297.64  , 419.53  ],
	    a7        : [ 209.76  , 297.64  ],
	    a8        : [ 147.40  , 209.76  ],
	    a9        : [ 104.88  , 147.40  ],
	    a10       : [ 73.70   , 104.88  ],
	    b0        : [ 2834.65 , 4008.19 ],
	    b1        : [ 2004.09 , 2834.65 ],
	    b2        : [ 1417.32 , 2004.09 ],
	    b3        : [ 1000.63 , 1417.32 ],
	    b4        : [ 708.66  , 1000.63 ],
	    b5        : [ 498.90  , 708.66  ],
	    b6        : [ 354.33  , 498.90  ],
	    b7        : [ 249.45  , 354.33  ],
	    b8        : [ 175.75  , 249.45  ],
	    b9        : [ 124.72  , 175.75  ],
	    b10       : [ 87.87   , 124.72  ],
	    c0        : [ 2599.37 , 3676.54 ],
	    c1        : [ 1836.85 , 2599.37 ],
	    c2        : [ 1298.27 , 1836.85 ],
	    c3        : [ 918.43  , 1298.27 ],
	    c4        : [ 649.13  , 918.43  ],
	    c5        : [ 459.21  , 649.13  ],
	    c6        : [ 323.15  , 459.21  ],
	    c7        : [ 229.61  , 323.15  ],
	    c8        : [ 161.57  , 229.61  ],
	    c9        : [ 113.39  , 161.57  ],
	    c10       : [ 79.37   , 113.39  ],
	    executive : [ 521.86  , 756.00  ],
	    folio     : [ 612.00  , 936.00  ],
	    legal     : [ 612.00  , 1008.00 ],
	    letter    : [ 612.00  , 792.00  ],
	    tabloid   : [ 792.00  , 1224.00 ]
	};
	
	function makeOutput() {
	    var indentLevel = 0, output = BinaryStream();
	    function out() {
	        var arguments$1 = arguments;
	
	        for (var i = 0; i < arguments.length; ++i) {
	            var x = arguments$1[i];
	            if (x === undefined) {
	                throw new Error("Cannot output undefined to PDF");
	            }
	            else if (x instanceof PDFValue) {
	                x.beforeRender(out);
	                x.render(out);
	            }
	            else if (isArray(x)) {
	                renderArray(x, out);
	            }
	            else if (isDate(x)) {
	                renderDate(x, out);
	            }
	            else if (typeof x == "number") {
	                if (isNaN(x)) {
	                    throw new Error("Cannot output NaN to PDF");
	                }
	                // make sure it doesn't end up in exponent notation
	                var num = x.toFixed(7);
	                if (num.indexOf(".") >= 0) {
	                    num = num.replace(/\.?0+$/, "");
	                }
	                if (num == "-0") {
	                    num = "0";
	                }
	                output.writeString(num);
	            }
	            else if (/string|boolean/.test(typeof x)) {
	                output.writeString(String(x));
	            }
	            else if (typeof x.get == "function") {
	                output.write(x.get());
	            }
	            else if (typeof x == "object") {
	                if (!x) {
	                    output.writeString("null");
	                } else {
	                    out(new PDFDictionary(x));
	                }
	            }
	        }
	    }
	    out.writeData = function(data) {
	        output.write(data);
	    };
	    out.withIndent = function(f) {
	        ++indentLevel;
	        f(out);
	        --indentLevel;
	    };
	    out.indent = function() {
	        out(NL, pad("", indentLevel * 2, "  "));
	        out.apply(null, arguments);
	    };
	    out.offset = function() {
	        return output.offset();
	    };
	    out.toString = function() {
	        throw new Error("FIX CALLER");
	    };
	    out.get = function() {
	        return output.get();
	    };
	    out.stream = function() {
	        return output;
	    };
	    return out;
	}
	
	function wrapObject(value, id) {
	    var beforeRender = value.beforeRender;
	    var renderValue = value.render;
	
	    value.beforeRender = function(){};
	
	    value.render = function(out) {
	        out(id, " 0 R");
	    };
	
	    value.renderFull = function(out) {
	        value._offset = out.offset();
	        out(id, " 0 obj ");
	        beforeRender.call(value, out);
	        renderValue.call(value, out);
	        out(" endobj");
	    };
	}
	
	function getPaperOptions(getOption) {
	    if (typeof getOption != "function") {
	        var options = getOption;
	        getOption = function(key, def) {
	            return key in options ? options[key] : def;
	        };
	    }
	    var paperSize = getOption("paperSize", PAPER_SIZE.a4);
	    if (!paperSize) {
	        return {};
	    }
	    if (typeof paperSize == "string") {
	        paperSize = PAPER_SIZE[paperSize.toLowerCase()];
	        if (paperSize == null) {
	            throw new Error("Unknown paper size");
	        }
	    }
	
	    paperSize[0] = unitsToPoints(paperSize[0]);
	    paperSize[1] = unitsToPoints(paperSize[1]);
	
	    if (getOption("landscape", false)) {
	        paperSize = [
	            Math.max(paperSize[0], paperSize[1]),
	            Math.min(paperSize[0], paperSize[1])
	        ];
	    }
	
	    var margin = getOption("margin");
	    if (margin) {
	        if (typeof margin == "string" || typeof margin == "number") {
	            margin = unitsToPoints(margin, 0);
	            margin = { left: margin, top: margin, right: margin, bottom: margin };
	        } else {
	            margin = {
	                left   : unitsToPoints(margin.left, 0),
	                top    : unitsToPoints(margin.top, 0),
	                right  : unitsToPoints(margin.right, 0),
	                bottom : unitsToPoints(margin.bottom, 0)
	            };
	        }
	        if (getOption("addMargin")) {
	            paperSize[0] += margin.left + margin.right;
	            paperSize[1] += margin.top + margin.bottom;
	        }
	    }
	    return { paperSize: paperSize, margin: margin };
	}
	
	var FONT_CACHE = {
	    "Times-Roman"           : true,
	    "Times-Bold"            : true,
	    "Times-Italic"          : true,
	    "Times-BoldItalic"      : true,
	    "Helvetica"             : true,
	    "Helvetica-Bold"        : true,
	    "Helvetica-Oblique"     : true,
	    "Helvetica-BoldOblique" : true,
	    "Courier"               : true,
	    "Courier-Bold"          : true,
	    "Courier-Oblique"       : true,
	    "Courier-BoldOblique"   : true,
	    "Symbol"                : true,
	    "ZapfDingbats"          : true
	};
	
	function loadBinary(url, cont) {
	    // IE throws Accesss denied error for Data URIs
	    var m;
	    if (browser$2.msie && (m = /^data:.*?;base64,/i.exec(url))) {
	        cont(base64ToUint8Array(url.substr(m[0].length)));
	        return;
	    }
	
	    function error() {
	        if (window.console) {
	            if (window.console.error) {
	                window.console.error("Cannot load URL: %s", url);
	            } else {
	                window.console.log("Cannot load URL: %s", url);
	            }
	        }
	        cont(null);
	    }
	    var req = new XMLHttpRequest();
	    req.open('GET', url, true);
	    if (HAS_TYPED_ARRAYS) {
	        req.responseType = "arraybuffer";
	    }
	    req.onload = function() {
	        if (req.status == 200 || req.status == 304) {
	            if (HAS_TYPED_ARRAYS) {
	                cont(new Uint8Array(req.response));
	            } else {
	                cont(new window.VBArray(req.responseBody).toArray()); // IE9 only
	            }
	        } else {
	            error();
	        }
	    };
	    req.onerror = error;
	    req.send(null);
	}
	
	function loadFont(url, cont) {
	    var font = FONT_CACHE[url];
	    if (font) {
	        cont(font);
	    } else {
	        loadBinary(url, function(data){
	            if (data == null) {
	                throw new Error("Cannot load font from " + url);
	            } else {
	                var font = new TTFFont(data);
	                FONT_CACHE[url] = font;
	                cont(font);
	            }
	        });
	    }
	}
	
	var IMAGE_CACHE = {};
	
	function clearImageCache() {
	    IMAGE_CACHE = {};
	}
	
	function loadImage(url, size, cont, options) {
	    var img = IMAGE_CACHE[url], bloburl, blob;
	    if (img) {
	        cont(img);
	    } else {
	        img = new Image();
	        if (!(/^data:/i.test(url))) {
	            img.crossOrigin = "Anonymous";
	        }
	        if (HAS_TYPED_ARRAYS && !(/^data:/i.test(url))) {
	            // IE10 fails to load images from another domain even when the server sends the
	            // proper CORS headers.  a XHR, however, will be able to load the data.
	            // http://stackoverflow.com/a/19734516/154985
	            //
	            // On the other hand, it's worth doing it this way for all browsers which support
	            // responseType = "blob" (HAS_TYPED_ARRAYS will be true), because we can inspect the
	            // mime type and if it's a JPEG (very common case) we can save a lot of time in
	            // _load below.
	            var xhr = new XMLHttpRequest();
	            xhr.onload = function() {
	                blob = xhr.response;
	                if (browser$2.mozilla && blob.type == "image/svg+xml") {
	                    // Firefox won't render SVGs that don't contain width and height attributes.
	                    var reader = new FileReader();
	                    reader.onload = function() {
	                        var doc = new window.DOMParser().parseFromString(this.result, "image/svg+xml");
	                        var svg = doc.documentElement;
	                        if (svg.getAttribute("width") && svg.getAttribute("height")) {
	                            // we're good, continue with the existing blob.
	                            bloburl = URL.createObjectURL(blob);
	                            _load(bloburl);
	                        } else {
	                            svg.setAttribute("width", size.width);
	                            svg.setAttribute("height", size.height);
	                            var xml = new window.XMLSerializer().serializeToString(svg);
	                            var dataURL = "data:image/svg+xml;base64," + (encodeBase64(xml));
	                            _load(dataURL);
	                        }
	                    };
	                    reader.readAsText(blob);
	                } else {
	                    bloburl = URL.createObjectURL(blob);
	                    _load(bloburl);
	                }
	            };
	            xhr.onerror = _onerror;
	            xhr.open("GET", url, true);
	            xhr.responseType = "blob";
	            xhr.send();
	        } else {
	            _load(url);
	        }
	    }
	
	    function _load(url) {
	        img.src = url;
	        if (img.complete && !browser$2.msie) {
	            // IE, bless its little heart, says img.complete == true even though the image is
	            // not loaded (width=0), therefore we must go the onload route (ticket 929635).
	            _onload.call(img);
	        } else {
	            img.onload = _onload;
	            img.onerror = _onerror;
	        }
	    }
	
	    function _trycanvas() {
	        if (!size) {
	            size = { width: img.width, height: img.height };
	        }
	
	        var canvas = document.createElement("canvas");
	        canvas.width = size.width;
	        canvas.height = size.height;
	
	        var ctx = canvas.getContext("2d");
	        ctx.drawImage(img, 0, 0, size.width, size.height);
	
	        var imgdata;
	        try {
	            imgdata = ctx.getImageData(0, 0, size.width, size.height);
	        } catch (ex) {
	            // it tainted the canvas -- can't draw it.
	            _onerror();
	            return;
	        } finally {
	            if (bloburl) {
	                URL.revokeObjectURL(bloburl);
	            }
	        }
	
	        // in case it contains transparency, we must separate rgb data from the alpha
	        // channel and create a PDFRawImage image with opacity.  otherwise we can use a
	        // PDFJpegImage.
	        //
	        // to do this in one step, we create the rgb and alpha streams anyway, even if
	        // we might end up not using them if hasAlpha remains false.
	
	        var hasAlpha = false, rgb = BinaryStream(), alpha = BinaryStream();
	        var rawbytes = imgdata.data;
	        var i = 0;
	        while (i < rawbytes.length) {
	            rgb.writeByte(rawbytes[i++]);
	            rgb.writeByte(rawbytes[i++]);
	            rgb.writeByte(rawbytes[i++]);
	            var a = rawbytes[i++];
	            if (a < 255) {
	                hasAlpha = true;
	            }
	            alpha.writeByte(a);
	        }
	
	        if (hasAlpha || options.keepPNG) {
	            img = new PDFRawImage(size.width, size.height, rgb, alpha);
	        } else {
	            // no transparency, encode as JPEG.
	            var data = canvas.toDataURL("image/jpeg", options.jpegQuality);
	            data = data.substr(data.indexOf(";base64,") + 8);
	
	            var stream = BinaryStream();
	            stream.writeBase64(data);
	            img = new PDFJpegImage(stream);
	        }
	
	        cont(IMAGE_CACHE[url] = img);
	    }
	
	    function _onerror() {
	        cont(IMAGE_CACHE[url] = "ERROR");
	    }
	
	    function _onload() {
	        if (size) {
	            var svg = (blob && blob.type === 'image/svg+xml') || (
	              /^data:image\/svg\+xml;/i.test(this.src.substring(0, 19))
	            );
	
	            var upscale = size.width >= img.width || size.height >= img.height;
	
	            // Use the original image if requested size is bigger than the source,
	            // unless it's an SVG that can be upscaled.
	            if (!svg && upscale) {
	                size = null;
	            }
	        }
	        if (!size && blob && /^image\/jpe?g$/i.test(blob.type)) {
	            // If we know we got a JPEG, we can skip the process of rendering it to a
	            // canvas, getting the pixel data, searching for transparency we know we won't
	            // find, getting back a data URI and then decoding the BASE64 to finally get the
	            // binary we already have.  Also, we avoid downgrading the image quality, with
	            // the possible drawback of making a bigger PDF; still, seems legit.
	            //
	            // Besides saving a lot of work, this also reuses the buffer memory
	            // (BinaryStream does not create a copy), potentially saving some GC cycles.
	            var reader = new FileReader();
	            reader.onload = function() {
	                try {
	                    var img = new PDFJpegImage(BinaryStream(new Uint8Array(this.result)));
	                    URL.revokeObjectURL(bloburl);
	                    cont(IMAGE_CACHE[url] = img);
	                } catch (ex) {
	                    // if there's an error parsing the JPEG stream, it could be due to a
	                    // misconfigured server (improper content-type:
	                    // https://github.com/telerik/kendo-ui-core/issues/4184).  If that's the case,
	                    // the canvas will still be able to draw it.
	                    _trycanvas();
	                }
	            };
	            reader.readAsArrayBuffer(blob);
	        } else {
	            _trycanvas();
	        }
	    }
	}
	
	function manyLoader(loadOne) {
	    return function(urls, callback) {
	        var n = urls.length, i = n;
	        if (n === 0) {
	            return callback();
	        }
	        function next() {
	            if (--n === 0) {
	                callback();
	            }
	        }
	        while (i-- > 0) {
	            loadOne(urls[i], next);
	        }
	    };
	}
	
	var loadFonts = manyLoader(loadFont);
	var loadImages = function(images, callback, options) {
	    options = Object.assign({
	        jpegQuality : 0.92,
	        keepPNG     : false
	    }, options);
	    var urls = Object.keys(images), n = urls.length;
	    if (n === 0) {
	        return callback();
	    }
	    function next() {
	        if (--n === 0) {
	            callback();
	        }
	    }
	    urls.forEach(function(url){
	        loadImage(url, images[url], next, options);
	    });
	};
	
	var PDFDocument = function PDFDocument (options) {
	    var self = this;
	    var out = makeOutput();
	    var objcount = 0;
	    var objects = [];
	
	    function getOption(name, defval) {
	        return (options && options[name] != null) ? options[name] : defval;
	    }
	
	    self.getOption = getOption;
	
	    self.attach = function(value) {
	        if (objects.indexOf(value) < 0) {
	            wrapObject(value, ++objcount);
	            objects.push(value);
	        }
	        return value;
	    };
	
	    self.pages = [];
	
	    self.FONTS = {};
	    self.IMAGES = {};
	    self.GRAD_COL_FUNCTIONS = {}; // cache for color gradient functions
	    self.GRAD_OPC_FUNCTIONS = {}; // cache for opacity gradient functions
	    self.GRAD_COL = {}; // cache for whole color gradient objects
	    self.GRAD_OPC = {}; // cache for whole opacity gradient objects
	
	    var catalog = self.attach(new PDFCatalog());
	    var pageTree = self.attach(new PDFPageTree());
	
	    if (getOption("autoPrint")) {
	        var nameTree = {};
	        nameTree.JavaScript = new PDFDictionary({ Names: [
	            new PDFString("JS"), self.attach(new PDFDictionary({
	                S: _("JavaScript"),
	                JS: new PDFString("print(true);")
	            }))
	        ] });
	        catalog.props.Names = new PDFDictionary(nameTree);
	    }
	
	    catalog.setPages(pageTree);
	
	    var info = self.attach(new PDFDictionary({
	        Producer : new PDFString(getOption("producer", "Kendo UI PDF Generator"), true), // XXX: kendo.version?
	        Title    : new PDFString(getOption("title", ""), true),
	        Author   : new PDFString(getOption("author", ""), true),
	        Subject  : new PDFString(getOption("subject", ""), true),
	        Keywords : new PDFString(getOption("keywords", ""), true),
	        Creator  : new PDFString(getOption("creator", "Kendo UI PDF Generator"), true),
	        CreationDate : getOption("date", new Date())
	    }));
	
	    self.addPage = function(options) {
	        var paperOptions  = getPaperOptions(function(name, defval){
	            return (options && options[name] != null) ? options[name] : defval;
	        });
	        var paperSize = paperOptions.paperSize;
	        var margin    = paperOptions.margin;
	        var contentWidth  = paperSize[0];
	        var contentHeight = paperSize[1];
	        if (margin) {
	            contentWidth -= margin.left + margin.right;
	            contentHeight -= margin.top + margin.bottom;
	        }
	        var content = new PDFStream(makeOutput(), null, true);
	        var props = {
	            Contents : self.attach(content),
	            Parent   : pageTree,
	            MediaBox : [ 0, 0, paperSize[0], paperSize[1] ]
	        };
	        var page = new PDFPage(self, props);
	        page._content = content;
	        pageTree.addPage(self.attach(page));
	
	        // canvas-like coord. system.  (0,0) is upper-left.
	        // text must be vertically mirorred before drawing.
	        page.transform(1, 0, 0, -1, 0, paperSize[1]);
	
	        if (margin) {
	            page.translate(margin.left, margin.top);
	            // XXX: clip to right/bottom margin.  Make this optional?
	            page.rect(0, 0, contentWidth, contentHeight);
	            page.clip();
	        }
	
	        self.pages.push(page);
	        return page;
	    };
	
	    self.render = function() {
	        var i;
	        /// file header
	        out("%PDF-1.4", NL, "%\xc2\xc1\xda\xcf\xce", NL, NL);
	
	        /// file body
	        for (i = 0; i < objects.length; ++i) {
	            objects[i].renderFull(out);
	            out(NL, NL);
	        }
	
	        /// cross-reference table
	        var xrefOffset = out.offset();
	        out("xref", NL, 0, " ", objects.length + 1, NL);
	        out("0000000000 65535 f ", NL);
	        for (i = 0; i < objects.length; ++i) {
	            out(zeropad(objects[i]._offset, 10), " 00000 n ", NL);
	        }
	        out(NL);
	
	        /// trailer
	        out("trailer", NL);
	        out(new PDFDictionary({
	            Size: objects.length + 1,
	            Root: catalog,
	            Info: info
	        }), NL, NL);
	
	        /// end
	        out("startxref", NL, xrefOffset, NL);
	        out("%%EOF", NL);
	
	        return out.stream().offset(0);
	    };
	
	    self.loadFonts = loadFonts;
	    self.loadImages = loadImages;
	};
	
	PDFDocument.prototype.getFont = function getFont (url) {
	    var font = this.FONTS[url];
	    if (!font) {
	        font = FONT_CACHE[url];
	        if (!font) {
	            throw new Error("Font " + url + " has not been loaded");
	        }
	        if (font === true) {
	            font = this.attach(new PDFStandardFont(url));
	        } else {
	            font = this.attach(new PDFFont(this, font));
	        }
	        this.FONTS[url] = font;
	    }
	    return font;
	};
	
	PDFDocument.prototype.getImage = function getImage (url) {
	    var img = this.IMAGES[url];
	    if (!img) {
	        img = IMAGE_CACHE[url];
	        if (!img) {
	            throw new Error("Image " + url + " has not been loaded");
	        }
	        if (img === "ERROR") {
	            return null;
	        }
	        img = this.IMAGES[url] = this.attach(img.asStream(this));
	    }
	    return img;
	};
	
	PDFDocument.prototype.getOpacityGS = function getOpacityGS (opacity, forStroke) {
	    var id = parseFloat(opacity).toFixed(3);
	    opacity = parseFloat(id);
	    id += forStroke ? "S" : "F";
	    var cache = this._opacityGSCache || (this._opacityGSCache = {});
	    var gs = cache[id];
	    if (!gs) {
	        var props = {
	            Type: _("ExtGState")
	        };
	        if (forStroke) {
	            props.CA = opacity;
	        } else {
	            props.ca = opacity;
	        }
	        gs = this.attach(new PDFDictionary(props));
	        gs._resourceName = _("GS" + (++RESOURCE_COUNTER));
	        cache[id] = gs;
	    }
	    return gs;
	};
	
	PDFDocument.prototype.dict = function dict (props) {
	    return new PDFDictionary(props);
	};
	
	PDFDocument.prototype.name = function name (str) {
	    return _(str);
	};
	
	PDFDocument.prototype.stream = function stream (props, content) {
	    return new PDFStream(content, props);
	};
	
	/* -----[ utils ]----- */
	
	function pad(str, len, ch) {
	    while (str.length < len) {
	        str = ch + str;
	    }
	    return str;
	}
	
	function zeropad(n, len) {
	    return pad(String(n), len, "0");
	}
	
	function hasOwnProperty(obj, key) {
	    return Object.prototype.hasOwnProperty.call(obj, key);
	}
	
	var isArray = Array.isArray || function(obj) {
	    return obj instanceof Array;
	};
	
	function isDate(obj) {
	    return obj instanceof Date;
	}
	
	function renderArray(a, out) {
	    out("[");
	    if (a.length > 0) {
	        out.withIndent(function(){
	            for (var i = 0; i < a.length; ++i) {
	                if (i > 0 && i % 8 === 0) {
	                    out.indent(a[i]);
	                } else {
	                    out(" ", a[i]);
	                }
	            }
	        });
	        //out.indent();
	    }
	    out(" ]");
	}
	
	function renderDate(date, out) {
	    out("(D:",
	        zeropad(date.getUTCFullYear(), 4),
	        zeropad(date.getUTCMonth() + 1, 2),
	        zeropad(date.getUTCDate(), 2),
	        zeropad(date.getUTCHours(), 2),
	        zeropad(date.getUTCMinutes(), 2),
	        zeropad(date.getUTCSeconds(), 2),
	        "Z)");
	}
	
	function mm2pt(mm) {
	    return mm * (72/25.4);
	}
	
	function cm2pt(cm) {
	    return mm2pt(cm * 10);
	}
	
	function in2pt(inch)  {
	    return inch * 72;
	}
	
	
	function unitsToPoints(x, def) {
	    if (typeof x == "number") {
	        return x;
	    }
	    if (typeof x == "string") {
	        var m;
	        m = /^\s*([0-9.]+)\s*(mm|cm|in|pt)\s*$/.exec(x);
	        if (m) {
	            var num = parseFloat(m[1]);
	            if (!isNaN(num)) {
	                if (m[2] == "pt") {
	                    return num;
	                }
	                return {
	                    "mm": mm2pt,
	                    "cm": cm2pt,
	                    "in": in2pt
	                }[m[2]](num);
	            }
	        }
	    }
	    if (def != null) {
	        return def;
	    }
	    throw new Error("Can't parse unit: " + x);
	}
	
	/* -----[ PDF basic objects ]----- */
	
	var PDFValue = function PDFValue () {};
	
	PDFValue.prototype.beforeRender = function beforeRender () {};
	
	var PDFString = (function (PDFValue) {
	    function PDFString(value, utf16be) {
	        PDFValue.call(this);
	        this.value = value;
	        this.utf16be = Boolean(utf16be);
	    }
	
	    if ( PDFValue ) PDFString.__proto__ = PDFValue;
	    PDFString.prototype = Object.create( PDFValue && PDFValue.prototype );
	    PDFString.prototype.constructor = PDFString;
	
	    PDFString.prototype.render = function render (out) {
	        var txt = this.value;
	        if (this.utf16be) {
	            txt = BOM + encodeUTF16BE(txt);
	            txt = txt.replace(/([\(\)\\])/g, "\\$1");
	            out("(", txt, ")");
	        } else {
	            // out.writeString truncates charcodes to 8 bits and
	            // 0x128 & 0xFF is 40, the code for open paren.
	            // therefore we need to do the chopping here to make
	            // sure we backslash all cases.
	            var data = [ 40 ]; // open PDF string '('
	            for (var i = 0; i < txt.length; ++i) {
	                var code = txt.charCodeAt(i) & 0xFF;
	                if (code == 40 || code == 41 || code == 92) {
	                    // backslash before (, ) and \
	                    data.push(92);
	                }
	                data.push(code);
	            }
	            data.push(41);  // ')' close PDF string
	            out.writeData(data);
	        }
	    };
	
	    PDFString.prototype.toString = function toString () {
	        return this.value;
	    };
	
	    return PDFString;
	}(PDFValue));
	
	var PDFHexString = (function (PDFString) {
	    function PDFHexString(value) {
	        PDFString.call(this, value);
	        this.value = value;
	    }
	
	    if ( PDFString ) PDFHexString.__proto__ = PDFString;
	    PDFHexString.prototype = Object.create( PDFString && PDFString.prototype );
	    PDFHexString.prototype.constructor = PDFHexString;
	
	    PDFHexString.prototype.render = function render (out) {
	        var this$1 = this;
	
	        out("<");
	        for (var i = 0; i < this.value.length; ++i) {
	            out(zeropad(this$1.value.charCodeAt(i).toString(16), 4));
	        }
	        out(">");
	    };
	
	    return PDFHexString;
	}(PDFString));
	
	/// names
	var PDFName = (function (PDFValue) {
	    function PDFName(name) {
	        PDFValue.call(this);
	        this.name = name;
	    }
	
	    if ( PDFValue ) PDFName.__proto__ = PDFValue;
	    PDFName.prototype = Object.create( PDFValue && PDFValue.prototype );
	    PDFName.prototype.constructor = PDFName;
	
	    PDFName.get = function get (name) {
	        return _(name);
	    };
	
	    PDFName.prototype.render = function render (out) {
	        out("/" + this.escape());
	    };
	
	    PDFName.prototype.escape = function escape () {
	        return this.name.replace(/[^\x21-\x7E]/g, function(c){
	            return "#" + zeropad(c.charCodeAt(0).toString(16), 2);
	        });
	    };
	
	    PDFName.prototype.toString = function toString () {
	        return this.name;
	    };
	
	    return PDFName;
	}(PDFValue));
	
	function _(name) {
	    return new PDFName(name);
	}
	
	/// dictionary
	
	var PDFDictionary = (function (PDFValue) {
	    function PDFDictionary(props) {
	        PDFValue.call(this);
	        this.props = props;
	    }
	
	    if ( PDFValue ) PDFDictionary.__proto__ = PDFValue;
	    PDFDictionary.prototype = Object.create( PDFValue && PDFValue.prototype );
	    PDFDictionary.prototype.constructor = PDFDictionary;
	
	    PDFDictionary.prototype.render = function render (out) {
	        var props = this.props, empty = true;
	        out("<<");
	        out.withIndent(function(){
	            for (var i in props) {
	                if (hasOwnProperty(props, i) && !/^_/.test(i)) {
	                    empty = false;
	                    out.indent(_(i), " ", props[i]);
	                }
	            }
	        });
	        if (!empty) {
	            out.indent();
	        }
	        out(">>");
	    };
	
	    return PDFDictionary;
	}(PDFValue));
	
	/// streams
	
	var PDFStream = (function (PDFValue) {
	    function PDFStream(data, props, compress) {
	        PDFValue.call(this);
	        if (typeof data == "string") {
	            var tmp = BinaryStream();
	            tmp.write(data);
	            data = tmp;
	        }
	        this.data = data;
	        this.props = props || {};
	        this.compress = compress;
	    }
	
	    if ( PDFValue ) PDFStream.__proto__ = PDFValue;
	    PDFStream.prototype = Object.create( PDFValue && PDFValue.prototype );
	    PDFStream.prototype.constructor = PDFStream;
	
	    PDFStream.prototype.render = function render (out) {
	        var data = this.data.get(), props = this.props;
	        if (this.compress && supportsDeflate()) {
	            if (!props.Filter) {
	                props.Filter = [];
	            } else if (!(props.Filter instanceof Array)) {
	                props.Filter = [ props.Filter ];
	            }
	            props.Filter.unshift(_("FlateDecode"));
	            data = deflate$1(data);
	        }
	        props.Length = data.length;
	        out(new PDFDictionary(props), " stream", NL);
	        out.writeData(data);
	        out(NL, "endstream");
	    };
	
	    return PDFStream;
	}(PDFValue));
	
	/// catalog
	
	var PDFCatalog = (function (PDFDictionary) {
	    function PDFCatalog() {
	        PDFDictionary.call(this, {
	            Type: _("Catalog")
	        });
	    }
	
	    if ( PDFDictionary ) PDFCatalog.__proto__ = PDFDictionary;
	    PDFCatalog.prototype = Object.create( PDFDictionary && PDFDictionary.prototype );
	    PDFCatalog.prototype.constructor = PDFCatalog;
	
	    PDFCatalog.prototype.setPages = function setPages (pagesObj) {
	        this.props.Pages = pagesObj;
	    };
	
	    return PDFCatalog;
	}(PDFDictionary));
	
	/// page tree
	
	var PDFPageTree = (function (PDFDictionary) {
	    function PDFPageTree() {
	        PDFDictionary.call(this, {
	            Type  : _("Pages"),
	            Kids  : [],
	            Count : 0
	        });
	    }
	
	    if ( PDFDictionary ) PDFPageTree.__proto__ = PDFDictionary;
	    PDFPageTree.prototype = Object.create( PDFDictionary && PDFDictionary.prototype );
	    PDFPageTree.prototype.constructor = PDFPageTree;
	
	    PDFPageTree.prototype.addPage = function addPage (pageObj) {
	        this.props.Kids.push(pageObj);
	        this.props.Count++;
	    };
	
	    return PDFPageTree;
	}(PDFDictionary));
	
	/// images
	
	// JPEG
	
	var SOF_CODES = [0xc0, 0xc1, 0xc2, 0xc3, 0xc5, 0xc6, 0xc7, 0xc9, 0xca, 0xcb, 0xcd, 0xce, 0xcf];
	
	var PDFJpegImage = function PDFJpegImage(data) {
	    // we must determine the correct color space.  we'll parse a bit
	    // of the JPEG stream for this, it's still better than going
	    // through the canvas.
	    // https://github.com/telerik/kendo-ui-core/issues/2845
	    data.offset(0);
	    var width, height, colorSpace, bitsPerComponent;
	    var soi = data.readShort();
	    if (soi != 0xFFD8) {
	        // XXX: do we have some better options here?
	        throw new Error("Invalid JPEG image");
	    }
	    while (!data.eof()) {
	        var ff = data.readByte();
	        if (ff != 0xFF) {
	            throw new Error("Invalid JPEG image");
	        }
	        var marker = data.readByte();
	        var length = data.readShort();
	        if (SOF_CODES.indexOf(marker) >= 0) {
	            // "start of frame" marker
	            bitsPerComponent = data.readByte();
	            height = data.readShort();
	            width = data.readShort();
	            colorSpace = data.readByte();
	            break;
	        }
	        data.skip(length - 2);
	    }
	
	    if (colorSpace == null) {
	        throw new Error("Invalid JPEG image");
	    }
	
	    var props = {
	        Type         : _("XObject"),
	        Subtype      : _("Image"),
	        Width        : width,
	        Height       : height,
	        BitsPerComponent : bitsPerComponent,
	        Filter       : _("DCTDecode")
	    };
	
	    switch (colorSpace) {
	    case 1:
	        props.ColorSpace = _("DeviceGray");
	        break;
	    case 3:
	        props.ColorSpace = _("DeviceRGB");
	        break;
	    case 4:
	        props.ColorSpace = _("DeviceCMYK");
	        props.Decode = [ 1, 0, 1, 0, 1, 0, 1, 0 ]; // invert colors
	        break;
	    }
	
	    this.asStream = function() {
	        data.offset(0);
	        var stream = new PDFStream(data, props);
	        stream._resourceName = _("I" + (++RESOURCE_COUNTER));
	        return stream;
	    };
	};
	
	// PDFRawImage will be used for images with transparency (PNG)
	
	var PDFRawImage = function PDFRawImage(width, height, rgb, alpha) {
	    this.asStream = function(pdf) {
	        var mask = new PDFStream(alpha, {
	            Type         : _("XObject"),
	            Subtype      : _("Image"),
	            Width        : width,
	            Height       : height,
	            BitsPerComponent : 8,
	            ColorSpace   : _("DeviceGray")
	        }, true);
	        var stream = new PDFStream(rgb, {
	            Type         : _("XObject"),
	            Subtype      : _("Image"),
	            Width        : width,
	            Height       : height,
	            BitsPerComponent : 8,
	            ColorSpace   : _("DeviceRGB"),
	            SMask        : pdf.attach(mask)
	        }, true);
	        stream._resourceName = _("I" + (++RESOURCE_COUNTER));
	        return stream;
	    };
	};
	
	/// standard fonts
	
	var PDFStandardFont = (function (PDFDictionary) {
	    function PDFStandardFont(name){
	        PDFDictionary.call(this, {
	            Type     : _("Font"),
	            Subtype  : _("Type1"),
	            BaseFont : _(name)
	        });
	
	        this._resourceName = _("F" + (++RESOURCE_COUNTER));
	    }
	
	    if ( PDFDictionary ) PDFStandardFont.__proto__ = PDFDictionary;
	    PDFStandardFont.prototype = Object.create( PDFDictionary && PDFDictionary.prototype );
	    PDFStandardFont.prototype.constructor = PDFStandardFont;
	
	    PDFStandardFont.prototype.encodeText = function encodeText (str) {
	        return new PDFString(String(str));
	    };
	
	    return PDFStandardFont;
	}(PDFDictionary));
	
	/// TTF fonts
	
	var PDFFont = (function (PDFDictionary) {
	    function PDFFont(pdf, font, props){
	        PDFDictionary.call(this, {});
	
	        props = this.props;
	        props.Type = _("Font");
	        props.Subtype = _("Type0");
	        props.Encoding = _("Identity-H");
	
	        this._pdf = pdf;
	        this._font = font;
	        this._sub = font.makeSubset();
	        this._resourceName = _("F" + (++RESOURCE_COUNTER));
	
	        var head = font.head;
	
	        this.name = font.psName;
	        var scale = this.scale = font.scale;
	        this.bbox = [
	            head.xMin * scale,
	            head.yMin * scale,
	            head.xMax * scale,
	            head.yMax * scale
	        ];
	
	        this.italicAngle = font.post.italicAngle;
	        this.ascent = font.ascent * scale;
	        this.descent = font.descent * scale;
	        this.lineGap = font.lineGap * scale;
	        this.capHeight = font.os2.capHeight || this.ascent;
	        this.xHeight = font.os2.xHeight || 0;
	        this.stemV = 0;
	
	        this.familyClass = (font.os2.familyClass || 0) >> 8;
	        this.isSerif = this.familyClass >= 1 && this.familyClass <= 7;
	        this.isScript = this.familyClass == 10;
	
	        this.flags = ((font.post.isFixedPitch ? 1 : 0) |
	                    (this.isSerif ? 1 << 1 : 0) |
	                    (this.isScript ? 1 << 3 : 0) |
	                    (this.italicAngle !== 0 ? 1 << 6 : 0) |
	                    (1 << 5));
	        }
	
	    if ( PDFDictionary ) PDFFont.__proto__ = PDFDictionary;
	    PDFFont.prototype = Object.create( PDFDictionary && PDFDictionary.prototype );
	    PDFFont.prototype.constructor = PDFFont;
	
	        PDFFont.prototype.encodeText = function encodeText (text) {
	            return new PDFHexString(this._sub.encodeText(String(text)));
	        };
	
	        PDFFont.prototype.getTextWidth = function getTextWidth (fontSize, text) {
	            var this$1 = this;
	
	            var width = 0, codeMap = this._font.cmap.codeMap;
	            for (var i = 0; i < text.length; ++i) {
	                var glyphId = codeMap[text.charCodeAt(i)];
	                width += this$1._font.widthOfGlyph(glyphId || 0);
	            }
	            return width * fontSize / 1000;
	        };
	
	        PDFFont.prototype.beforeRender = function beforeRender () {
	            var self = this;
	            var sub = self._sub;
	
	            // write the TTF data
	            var data = sub.render();
	            var fontStream = new PDFStream(BinaryStream(data), {
	                Length1: data.length
	            }, true);
	
	            var descriptor = self._pdf.attach(new PDFDictionary({
	                Type         : _("FontDescriptor"),
	                FontName     : _(self._sub.psName),
	                FontBBox     : self.bbox,
	                Flags        : self.flags,
	                StemV        : self.stemV,
	                ItalicAngle  : self.italicAngle,
	                Ascent       : self.ascent,
	                Descent      : self.descent,
	                CapHeight    : self.capHeight,
	                XHeight      : self.xHeight,
	                FontFile2    : self._pdf.attach(fontStream)
	            }));
	
	            var cmap = sub.ncid2ogid;
	            var firstChar = sub.firstChar;
	            var lastChar = sub.lastChar;
	            var charWidths = [];
	            (function loop(i, chunk){
	                if (i <= lastChar) {
	                    var gid = cmap[i];
	                    if (gid == null) {
	                        loop(i + 1);
	                    } else {
	                        if (!chunk) {
	                            charWidths.push(i, chunk = []);
	                        }
	                        chunk.push(self._font.widthOfGlyph(gid));
	                        loop(i + 1, chunk);
	                    }
	                }
	            })(firstChar);
	
	            // As if two dictionaries weren't enough, we need another
	            // one, the "descendant font".  Only that one can be of
	            // Subtype CIDFontType2.  PDF is the X11 of document
	            // formats: portable but full of legacy that nobody cares
	            // about anymore.
	
	            var descendant = new PDFDictionary({
	                Type: _("Font"),
	                Subtype: _("CIDFontType2"),
	                BaseFont: _(self._sub.psName),
	                CIDSystemInfo: new PDFDictionary({
	                    Registry   : new PDFString("Adobe"),
	                    Ordering   : new PDFString("Identity"),
	                    Supplement : 0
	                }),
	                FontDescriptor: descriptor,
	                FirstChar: firstChar,
	                LastChar: lastChar,
	                DW: Math.round(self._font.widthOfGlyph(0)),
	                W: charWidths,
	                CIDToGIDMap: self._pdf.attach(self._makeCidToGidMap())
	            });
	
	            var dict = self.props;
	            dict.BaseFont = _(self._sub.psName);
	            dict.DescendantFonts = [ self._pdf.attach(descendant) ];
	
	            // Compute the ToUnicode map so that apps can extract
	            // meaningful text from the PDF.
	            var unimap = new PDFToUnicodeCmap(firstChar, lastChar, sub.subset);
	            var unimapStream = new PDFStream(makeOutput(), null, true);
	            unimapStream.data(unimap);
	            dict.ToUnicode = self._pdf.attach(unimapStream);
	        };
	
	        PDFFont.prototype._makeCidToGidMap = function _makeCidToGidMap () {
	            return new PDFStream(BinaryStream(this._sub.cidToGidMap()), null, true);
	        };
	
	    return PDFFont;
	}(PDFDictionary));
	
	var PDFToUnicodeCmap = (function (PDFValue) {
	    function PDFToUnicodeCmap(firstChar, lastChar, map){
	        PDFValue.call(this);
	        this.firstChar = firstChar;
	        this.lastChar = lastChar;
	        this.map = map;
	    }
	
	    if ( PDFValue ) PDFToUnicodeCmap.__proto__ = PDFValue;
	    PDFToUnicodeCmap.prototype = Object.create( PDFValue && PDFValue.prototype );
	    PDFToUnicodeCmap.prototype.constructor = PDFToUnicodeCmap;
	
	    PDFToUnicodeCmap.prototype.render = function render (out) {
	        out.indent("/CIDInit /ProcSet findresource begin");
	        out.indent("12 dict begin");
	        out.indent("begincmap");
	        out.indent("/CIDSystemInfo <<");
	        out.indent("  /Registry (Adobe)");
	        out.indent("  /Ordering (UCS)");
	        out.indent("  /Supplement 0");
	        out.indent(">> def");
	        out.indent("/CMapName /Adobe-Identity-UCS def");
	        out.indent("/CMapType 2 def");
	        out.indent("1 begincodespacerange");
	        out.indent("  <0000><ffff>");
	        out.indent("endcodespacerange");
	
	        var self = this;
	        out.indent(self.lastChar - self.firstChar + 1, " beginbfchar");
	        out.withIndent(function(){
	            for (var code = self.firstChar; code <= self.lastChar; ++code) {
	                var unicode = self.map[code];
	                var str = ucs2encode([ unicode ]);
	                out.indent("<", zeropad(code.toString(16), 4), ">", "<");
	                for (var i = 0; i < str.length; ++i) {
	                    out(zeropad(str.charCodeAt(i).toString(16), 4));
	                }
	                out(">");
	            }
	        });
	        out.indent("endbfchar");
	
	        out.indent("endcmap");
	        out.indent("CMapName currentdict /CMap defineresource pop");
	        out.indent("end");
	        out.indent("end");
	    };
	
	    return PDFToUnicodeCmap;
	}(PDFValue));
	
	/// gradients
	
	function makeHash(a) {
	    return a.map(function(x){
	        return isArray(x) ? makeHash(x)
	            : typeof x == "number" ? (Math.round(x * 1000) / 1000).toFixed(3)
	            : x;
	    }).join(" ");
	}
	
	function cacheColorGradientFunction(pdf, r1, g1, b1, r2, g2, b2) {
	    var hash = makeHash([ r1, g1, b1, r2, g2, b2 ]);
	    var func = pdf.GRAD_COL_FUNCTIONS[hash];
	    if (!func) {
	        func = pdf.GRAD_COL_FUNCTIONS[hash] = pdf.attach(new PDFDictionary({
	            FunctionType: 2,
	            Domain: [ 0, 1 ],
	            Range: [ 0, 1, 0, 1, 0, 1 ],
	            N: 1,
	            C0: [ r1 , g1 , b1 ],
	            C1: [ r2 , g2 , b2 ]
	        }));
	    }
	    return func;
	}
	
	function cacheOpacityGradientFunction(pdf, a1, a2) {
	    var hash = makeHash([ a1, a2 ]);
	    var func = pdf.GRAD_OPC_FUNCTIONS[hash];
	    if (!func) {
	        func = pdf.GRAD_OPC_FUNCTIONS[hash] = pdf.attach(new PDFDictionary({
	            FunctionType: 2,
	            Domain: [ 0, 1 ],
	            Range: [ 0, 1 ],
	            N: 1,
	            C0: [ a1 ],
	            C1: [ a2 ]
	        }));
	    }
	    return func;
	}
	
	function makeGradientFunctions(pdf, stops) {
	    var hasAlpha = false;
	    var opacities = [];
	    var colors = [];
	    var offsets = [];
	    var encode = [];
	    var i, prev, cur, prevColor, curColor;
	    for (i = 1; i < stops.length; ++i) {
	        prev = stops[i - 1];
	        cur = stops[i];
	        prevColor = prev.color;
	        curColor = cur.color;
	        colors.push(cacheColorGradientFunction(
	            pdf,
	            prevColor.r, prevColor.g, prevColor.b,
	            curColor.r,  curColor.g,  curColor.b
	        ));
	        if (prevColor.a < 1 || curColor.a < 1) {
	            hasAlpha = true;
	        }
	        offsets.push(cur.offset);
	        encode.push(0, 1);
	    }
	    if (hasAlpha) {
	        for (i = 1; i < stops.length; ++i) {
	            prev = stops[i - 1];
	            cur = stops[i];
	            prevColor = prev.color;
	            curColor = cur.color;
	            opacities.push(cacheOpacityGradientFunction(
	                pdf, prevColor.a, curColor.a
	            ));
	        }
	    }
	    offsets.pop();
	    return {
	        hasAlpha  : hasAlpha,
	        colors    : assemble(colors),
	        opacities : hasAlpha ? assemble(opacities) : null
	    };
	    function assemble(funcs) {
	        if (funcs.length == 1) {
	            return funcs[0];
	        }
	        return {
	            FunctionType: 3,
	            Functions: funcs,
	            Domain: [ 0, 1 ],
	            Bounds: offsets,
	            Encode: encode
	        };
	    }
	}
	
	function cacheColorGradient(pdf, isRadial, stops, coords, funcs, box) {
	    var shading, hash;
	    // if box is given then we have user-space coordinates, which
	    // means the gradient is designed for a certain position/size
	    // on page.  caching won't do any good.
	    if (!box) {
	        var a = [ isRadial ].concat(coords);
	        stops.forEach(function(x){
	            a.push(x.offset, x.color.r, x.color.g, x.color.b);
	        });
	        hash = makeHash(a);
	        shading = pdf.GRAD_COL[hash];
	    }
	    if (!shading) {
	        shading = new PDFDictionary({
	            Type: _("Shading"),
	            ShadingType: isRadial ? 3 : 2,
	            ColorSpace: _("DeviceRGB"),
	            Coords: coords,
	            Domain: [ 0, 1 ],
	            Function: funcs,
	            Extend: [ true, true ]
	        });
	        pdf.attach(shading);
	        shading._resourceName = "S" + (++RESOURCE_COUNTER);
	        if (hash) {
	            pdf.GRAD_COL[hash] = shading;
	        }
	    }
	    return shading;
	}
	
	function cacheOpacityGradient(pdf, isRadial, stops, coords, funcs, box) {
	    var opacity, hash;
	    // if box is given then we have user-space coordinates, which
	    // means the gradient is designed for a certain position/size
	    // on page.  caching won't do any good.
	    if (!box) {
	        var a = [ isRadial ].concat(coords);
	        stops.forEach(function(x){
	            a.push(x.offset, x.color.a);
	        });
	        hash = makeHash(a);
	        opacity = pdf.GRAD_OPC[hash];
	    }
	    if (!opacity) {
	        opacity = new PDFDictionary({
	            Type: _("ExtGState"),
	            AIS: false,
	            CA: 1,
	            ca: 1,
	            SMask: {
	                Type: _("Mask"),
	                S: _("Luminosity"),
	                G: pdf.attach(new PDFStream("/a0 gs /s0 sh", {
	                    Type: _("XObject"),
	                    Subtype: _("Form"),
	                    FormType: 1,
	                    BBox: (box ? [
	                        box.left, box.top + box.height, box.left + box.width, box.top
	                    ] : [ 0, 1, 1, 0 ]),
	                    Group: {
	                        Type: _("Group"),
	                        S: _("Transparency"),
	                        CS: _("DeviceGray"),
	                        I: true
	                    },
	                    Resources: {
	                        ExtGState: {
	                            a0: { CA: 1, ca: 1 }
	                        },
	                        Shading: {
	                            s0: {
	                                ColorSpace: _("DeviceGray"),
	                                Coords: coords,
	                                Domain: [ 0, 1 ],
	                                ShadingType: isRadial ? 3 : 2,
	                                Function: funcs,
	                                Extend: [ true, true ]
	                            }
	                        }
	                    }
	                }))
	            }
	        });
	        pdf.attach(opacity);
	        opacity._resourceName = "O" + (++RESOURCE_COUNTER);
	        if (hash) {
	            pdf.GRAD_OPC[hash] = opacity;
	        }
	    }
	    return opacity;
	}
	
	function cacheGradient(pdf, gradient, box) {
	    var isRadial = gradient.type == "radial";
	    var funcs = makeGradientFunctions(pdf, gradient.stops);
	    var coords = isRadial ? [
	        gradient.start.x , gradient.start.y , gradient.start.r,
	        gradient.end.x   , gradient.end.y   , gradient.end.r
	    ] : [
	        gradient.start.x , gradient.start.y,
	        gradient.end.x   , gradient.end.y
	    ];
	    var shading = cacheColorGradient(
	        pdf, isRadial, gradient.stops, coords, funcs.colors, gradient.userSpace && box
	    );
	    var opacity = funcs.hasAlpha ? cacheOpacityGradient(
	        pdf, isRadial, gradient.stops, coords, funcs.opacities, gradient.userSpace && box
	    ) : null;
	    return {
	        hasAlpha: funcs.hasAlpha,
	        shading: shading,
	        opacity: opacity
	    };
	}
	
	/// page object
	
	var PDFPage = (function (PDFDictionary) {
	    function PDFPage(pdf, props){
	        PDFDictionary.call(this, props);
	
	        this._pdf = pdf;
	        this._rcount = 0;
	        this._textMode = false;
	        this._fontResources = {};
	        this._gsResources = {};
	        this._xResources = {};
	        this._patResources = {};
	        this._shResources = {};
	        this._opacity = 1;
	        this._matrix = [ 1, 0, 0, 1, 0, 0 ];
	        this._annotations = [];
	
	        this._font = null;
	        this._fontSize = null;
	
	        this._contextStack = [];
	
	        props = this.props;
	        props.Type = _("Page");
	        props.ProcSet = [
	            _("PDF"),
	            _("Text"),
	            _("ImageB"),
	            _("ImageC"),
	            _("ImageI")
	        ];
	        props.Resources = new PDFDictionary({
	            Font      : new PDFDictionary(this._fontResources),
	            ExtGState : new PDFDictionary(this._gsResources),
	            XObject   : new PDFDictionary(this._xResources),
	            Pattern   : new PDFDictionary(this._patResources),
	            Shading   : new PDFDictionary(this._shResources)
	        });
	        props.Annots = this._annotations;
	    }
	
	    if ( PDFDictionary ) PDFPage.__proto__ = PDFDictionary;
	    PDFPage.prototype = Object.create( PDFDictionary && PDFDictionary.prototype );
	    PDFPage.prototype.constructor = PDFPage;
	
	    PDFPage.prototype._out = function _out () {
	        this._content.data.apply(null, arguments);
	    };
	
	    PDFPage.prototype.transform = function transform (a, b, c, d, e, f) {
	        if (!isIdentityMatrix(arguments)) {
	            this._matrix = mmul(arguments, this._matrix);
	            this._out(a, " ", b, " ", c, " ", d, " ", e, " ", f, " cm");
	            // XXX: debug
	            // this._out(" % current matrix: ", this._matrix);
	            this._out(NL);
	        }
	    };
	
	    PDFPage.prototype.translate = function translate (dx, dy) {
	        this.transform(1, 0, 0, 1, dx, dy);
	    };
	
	    PDFPage.prototype.scale = function scale (sx, sy) {
	        this.transform(sx, 0, 0, sy, 0, 0);
	    };
	
	    PDFPage.prototype.rotate = function rotate (angle) {
	        var cos = Math.cos(angle), sin = Math.sin(angle);
	        this.transform(cos, sin, -sin, cos, 0, 0);
	    };
	
	    PDFPage.prototype.beginText = function beginText () {
	        this._textMode = true;
	        this._out("BT", NL);
	    };
	
	    PDFPage.prototype.endText = function endText () {
	        this._textMode = false;
	        this._out("ET", NL);
	    };
	
	    PDFPage.prototype._requireTextMode = function _requireTextMode () {
	        if (!this._textMode) {
	            throw new Error("Text mode required; call page.beginText() first");
	        }
	    };
	
	    PDFPage.prototype._requireFont = function _requireFont () {
	        if (!this._font) {
	            throw new Error("No font selected; call page.setFont() first");
	        }
	    };
	
	    PDFPage.prototype.setFont = function setFont (font, size) {
	        this._requireTextMode();
	        if (font == null) {
	            font = this._font;
	        } else if (!(font instanceof PDFFont)) {
	            font = this._pdf.getFont(font);
	        }
	        if (size == null) {
	            size = this._fontSize;
	        }
	        this._fontResources[font._resourceName] = font;
	        this._font = font;
	        this._fontSize = size;
	        this._out(font._resourceName, " ", size, " Tf", NL);
	    };
	
	    PDFPage.prototype.setTextLeading = function setTextLeading (size) {
	        this._requireTextMode();
	        this._out(size, " TL", NL);
	    };
	
	    PDFPage.prototype.setTextRenderingMode = function setTextRenderingMode (mode) {
	        this._requireTextMode();
	        this._out(mode, " Tr", NL);
	    };
	
	    PDFPage.prototype.showText = function showText (text, requestedWidth) {
	        this._requireFont();
	        if (text.length > 1 && requestedWidth && this._font instanceof PDFFont) {
	            var outputWidth = this._font.getTextWidth(this._fontSize, text);
	            var scale = requestedWidth / outputWidth * 100;
	            this._out(scale, " Tz ");
	        }
	        this._out(this._font.encodeText(text), " Tj", NL);
	    };
	
	    PDFPage.prototype.showTextNL = function showTextNL (text) {
	        this._requireFont();
	        this._out(this._font.encodeText(text), " '", NL);
	    };
	
	    PDFPage.prototype.addLink = function addLink (uri, box) {
	        var ll = this._toPage({ x: box.left, y: box.bottom });
	        var ur = this._toPage({ x: box.right, y: box.top });
	        this._annotations.push(new PDFDictionary({
	            Type    : _("Annot"),
	            Subtype : _("Link"),
	            Rect    : [ ll.x, ll.y, ur.x, ur.y ],
	            Border  : [ 0, 0, 0 ],
	            A       : new PDFDictionary({
	                Type : _("Action"),
	                S    : _("URI"),
	                URI  : new PDFString(uri)
	            })
	        }));
	    };
	
	    PDFPage.prototype.setStrokeColor = function setStrokeColor (r, g, b) {
	        this._out(r, " ", g, " ", b, " RG", NL);
	    };
	
	    PDFPage.prototype.setOpacity = function setOpacity (opacity) {
	        this.setFillOpacity(opacity);
	        this.setStrokeOpacity(opacity);
	        this._opacity *= opacity;
	    };
	
	    PDFPage.prototype.setStrokeOpacity = function setStrokeOpacity (opacity) {
	        if (opacity < 1) {
	            var gs = this._pdf.getOpacityGS(this._opacity * opacity, true);
	            this._gsResources[gs._resourceName] = gs;
	            this._out(gs._resourceName, " gs", NL);
	        }
	    };
	
	    PDFPage.prototype.setFillColor = function setFillColor (r, g, b) {
	        this._out(r, " ", g, " ", b, " rg", NL);
	    };
	
	    PDFPage.prototype.setFillOpacity = function setFillOpacity (opacity) {
	        if (opacity < 1) {
	            var gs = this._pdf.getOpacityGS(this._opacity * opacity, false);
	            this._gsResources[gs._resourceName] = gs;
	            this._out(gs._resourceName, " gs", NL);
	        }
	    };
	
	    PDFPage.prototype.gradient = function gradient (gradient, box) {
	        this.save();
	        this.rect(box.left, box.top, box.width, box.height);
	        this.clip();
	        if (!gradient.userSpace) {
	            this.transform(box.width, 0, 0, box.height, box.left, box.top);
	        }
	        var g = cacheGradient(this._pdf, gradient, box);
	        var sname = g.shading._resourceName, oname;
	        this._shResources[sname] = g.shading;
	        if (g.hasAlpha) {
	            oname = g.opacity._resourceName;
	            this._gsResources[oname] = g.opacity;
	            this._out("/" + oname + " gs ");
	        }
	        this._out("/" + sname + " sh", NL);
	        this.restore();
	    };
	
	    PDFPage.prototype.setDashPattern = function setDashPattern (dashArray, dashPhase) {
	        this._out(dashArray, " ", dashPhase, " d", NL);
	    };
	
	    PDFPage.prototype.setLineWidth = function setLineWidth (width) {
	        this._out(width, " w", NL);
	    };
	
	    PDFPage.prototype.setLineCap = function setLineCap (lineCap) {
	        this._out(lineCap, " J", NL);
	    };
	
	    PDFPage.prototype.setLineJoin = function setLineJoin (lineJoin) {
	        this._out(lineJoin, " j", NL);
	    };
	
	    PDFPage.prototype.setMitterLimit = function setMitterLimit (mitterLimit) {
	        this._out(mitterLimit, " M", NL);
	    };
	
	    PDFPage.prototype.save = function save () {
	        this._contextStack.push(this._context());
	        this._out("q", NL);
	    };
	
	    PDFPage.prototype.restore = function restore () {
	        this._out("Q", NL);
	        this._context(this._contextStack.pop());
	    };
	
	
	    // paths
	    PDFPage.prototype.moveTo = function moveTo (x, y) {
	        this._out(x, " ", y, " m", NL);
	    };
	
	    PDFPage.prototype.lineTo = function lineTo (x, y) {
	        this._out(x, " ", y, " l", NL);
	    };
	
	    PDFPage.prototype.bezier = function bezier (x1, y1, x2, y2, x3, y3) {
	        this._out(x1, " ", y1, " ", x2, " ", y2, " ", x3, " ", y3, " c", NL);
	    };
	
	    PDFPage.prototype.bezier1 = function bezier1 (x1, y1, x3, y3) {
	        this._out(x1, " ", y1, " ", x3, " ", y3, " y", NL);
	    };
	
	    PDFPage.prototype.bezier2 = function bezier2 (x2, y2, x3, y3) {
	        this._out(x2, " ", y2, " ", x3, " ", y3, " v", NL);
	    };
	
	    PDFPage.prototype.close = function close () {
	        this._out("h", NL);
	    };
	
	    PDFPage.prototype.rect = function rect (x, y, w, h) {
	        this._out(x, " ", y, " ", w, " ", h, " re", NL);
	    };
	
	    PDFPage.prototype.ellipse = function ellipse (x, y, rx, ry) {
	        function _X(v) { return x + v; }
	        function _Y(v) { return y + v; }
	
	        // how to get to the "magic number" is explained here:
	        // http://www.whizkidtech.redprince.net/bezier/circle/kappa/
	        var k = 0.5522847498307936;
	
	        this.moveTo(_X(0), _Y(ry));
	        this.bezier(
	            _X(rx * k) , _Y(ry),
	            _X(rx)     , _Y(ry * k),
	            _X(rx)     , _Y(0)
	        );
	        this.bezier(
	            _X(rx)     , _Y(-ry * k),
	            _X(rx * k) , _Y(-ry),
	            _X(0)      , _Y(-ry)
	        );
	        this.bezier(
	            _X(-rx * k) , _Y(-ry),
	            _X(-rx)     , _Y(-ry * k),
	            _X(-rx)     , _Y(0)
	        );
	        this.bezier(
	            _X(-rx)     , _Y(ry * k),
	            _X(-rx * k) , _Y(ry),
	            _X(0)       , _Y(ry)
	        );
	    };
	
	    PDFPage.prototype.circle = function circle (x, y, r) {
	        this.ellipse(x, y, r, r);
	    };
	
	    PDFPage.prototype.stroke = function stroke () {
	        this._out("S", NL);
	    };
	
	    PDFPage.prototype.nop = function nop () {
	        this._out("n", NL);
	    };
	
	    PDFPage.prototype.clip = function clip () {
	        this._out("W n", NL);
	    };
	
	    PDFPage.prototype.clipStroke = function clipStroke () {
	        this._out("W S", NL);
	    };
	
	    PDFPage.prototype.closeStroke = function closeStroke () {
	        this._out("s", NL);
	    };
	
	    PDFPage.prototype.fill = function fill () {
	        this._out("f", NL);
	    };
	
	    PDFPage.prototype.fillStroke = function fillStroke () {
	        this._out("B", NL);
	    };
	
	    PDFPage.prototype.drawImage = function drawImage (url) {
	        var img = this._pdf.getImage(url);
	        if (img) { // the result can be null for a cross-domain image
	            this._xResources[img._resourceName] = img;
	            this._out(img._resourceName, " Do", NL);
	        }
	    };
	
	    PDFPage.prototype.comment = function comment (txt) {
	        var self = this;
	        txt.split(/\r?\n/g).forEach(function(line){
	            self._out("% ", line, NL);
	        });
	    };
	
	    // internal
	    PDFPage.prototype._context = function _context (val) {
	        if (val != null) {
	            this._opacity = val.opacity;
	            this._matrix = val.matrix;
	        } else {
	            return {
	                opacity: this._opacity,
	                matrix: this._matrix
	            };
	        }
	    };
	
	    PDFPage.prototype._toPage = function _toPage (p) {
	        var m = this._matrix;
	        var a = m[0], b = m[1], c = m[2], d = m[3], e = m[4], f = m[5];
	        return {
	            x: a*p.x + c*p.y + e,
	            y: b*p.x + d*p.y + f
	        };
	    };
	
	    return PDFPage;
	}(PDFDictionary));
	
	function unquote(str) {
	    return str.replace(/^\s*(['"])(.*)\1\s*$/, "$2");
	}
	
	function parseFontDef(fontdef) {
	    // XXX: this is very crude for now and buggy.  Proper parsing is quite involved.
	    var rx = /^\s*((normal|italic)\s+)?((normal|small-caps)\s+)?((normal|bold|\d+)\s+)?(([0-9.]+)(px|pt))(\/(([0-9.]+)(px|pt)|normal))?\s+(.*?)\s*$/i;
	    var m = rx.exec(fontdef);
	    if (!m) {
	        return { fontSize: 12, fontFamily: "sans-serif" };
	    }
	    var fontSize = m[8] ? parseInt(m[8], 10) : 12;
	    return {
	        italic     : m[2] && m[2].toLowerCase() == "italic",
	        variant    : m[4],
	        bold       : m[6] && /bold|700/i.test(m[6]),
	        fontSize   : fontSize,
	        lineHeight : m[12] ? m[12] == "normal" ? fontSize : parseInt(m[12], 10) : null,
	        fontFamily : m[14].split(/\s*,\s*/g).map(unquote)
	    };
	}
	
	function getFontURL(style) {
	    function mkFamily(name) {
	        if (style.bold) {
	            name += "|bold";
	        }
	        if (style.italic) {
	            name += "|italic";
	        }
	        return name.toLowerCase();
	    }
	    var fontFamily = style.fontFamily;
	    var name, url;
	    if (fontFamily instanceof Array) {
	        for (var i = 0; i < fontFamily.length; ++i) {
	            name = mkFamily(fontFamily[i]);
	            url = FONT_MAPPINGS[name];
	            if (url) {
	                break;
	            }
	        }
	    } else {
	        url = FONT_MAPPINGS[fontFamily.toLowerCase()];
	    }
	    while (typeof url == "function") {
	        url = url();
	    }
	    if (!url) {
	        url = "Times-Roman";
	    }
	    return url;
	}
	
	var FONT_MAPPINGS = {
	    "serif"                    : "Times-Roman",
	    "serif|bold"               : "Times-Bold",
	    "serif|italic"             : "Times-Italic",
	    "serif|bold|italic"        : "Times-BoldItalic",
	    "sans-serif"               : "Helvetica",
	    "sans-serif|bold"          : "Helvetica-Bold",
	    "sans-serif|italic"        : "Helvetica-Oblique",
	    "sans-serif|bold|italic"   : "Helvetica-BoldOblique",
	    "monospace"                : "Courier",
	    "monospace|bold"           : "Courier-Bold",
	    "monospace|italic"         : "Courier-Oblique",
	    "monospace|bold|italic"    : "Courier-BoldOblique",
	    "zapfdingbats"             : "ZapfDingbats",
	    "zapfdingbats|bold"        : "ZapfDingbats",
	    "zapfdingbats|italic"      : "ZapfDingbats",
	    "zapfdingbats|bold|italic" : "ZapfDingbats"
	};
	
	function fontAlias(alias, name) {
	    alias = alias.toLowerCase();
	    FONT_MAPPINGS[alias] = function() {
	        return FONT_MAPPINGS[name];
	    };
	    FONT_MAPPINGS[alias + "|bold"] = function() {
	        return FONT_MAPPINGS[name + "|bold"];
	    };
	    FONT_MAPPINGS[alias + "|italic"] = function() {
	        return FONT_MAPPINGS[name + "|italic"];
	    };
	    FONT_MAPPINGS[alias + "|bold|italic"] = function() {
	        return FONT_MAPPINGS[name + "|bold|italic"];
	    };
	}
	
	// Let's define some common names to an appropriate replacement.
	// These are overridable via pdf.defineFont, should the user want to
	// include the proper versions.
	
	fontAlias("Times New Roman" , "serif");
	fontAlias("Courier New"     , "monospace");
	fontAlias("Arial"           , "sans-serif");
	fontAlias("Helvetica"       , "sans-serif");
	fontAlias("Verdana"         , "sans-serif");
	fontAlias("Tahoma"          , "sans-serif");
	fontAlias("Georgia"         , "sans-serif");
	fontAlias("Monaco"          , "monospace");
	fontAlias("Andale Mono"     , "monospace");
	
	function defineFont(name, url) {
	    if (arguments.length == 1) {
	        for (var i in name) {
	            if (hasOwnProperty(name, i)) {
	                defineFont(i, name[i]);
	            }
	        }
	    } else {
	        name = name.toLowerCase();
	        FONT_MAPPINGS[name] = url;
	
	        // special handling for DejaVu fonts: if they get defined,
	        // let them also replace the default families, for good
	        // Unicode support out of the box.
	        switch (name) {
	          case "dejavu sans"               : FONT_MAPPINGS["sans-serif"]              = url; break;
	          case "dejavu sans|bold"          : FONT_MAPPINGS["sans-serif|bold"]         = url; break;
	          case "dejavu sans|italic"        : FONT_MAPPINGS["sans-serif|italic"]       = url; break;
	          case "dejavu sans|bold|italic"   : FONT_MAPPINGS["sans-serif|bold|italic"]  = url; break;
	          case "dejavu serif"              : FONT_MAPPINGS["serif"]                   = url; break;
	          case "dejavu serif|bold"         : FONT_MAPPINGS["serif|bold"]              = url; break;
	          case "dejavu serif|italic"       : FONT_MAPPINGS["serif|italic"]            = url; break;
	          case "dejavu serif|bold|italic"  : FONT_MAPPINGS["serif|bold|italic"]       = url; break;
	          case "dejavu mono"               : FONT_MAPPINGS["monospace"]               = url; break;
	          case "dejavu mono|bold"          : FONT_MAPPINGS["monospace|bold"]          = url; break;
	          case "dejavu mono|italic"        : FONT_MAPPINGS["monospace|italic"]        = url; break;
	          case "dejavu mono|bold|italic"   : FONT_MAPPINGS["monospace|bold|italic"]   = url; break;
	        }
	    }
	}
	
	function mmul(a, b) {
	    var a1 = a[0], b1 = a[1], c1 = a[2], d1 = a[3], e1 = a[4], f1 = a[5];
	    var a2 = b[0], b2 = b[1], c2 = b[2], d2 = b[3], e2 = b[4], f2 = b[5];
	    return [
	        a1*a2 + b1*c2,          a1*b2 + b1*d2,
	        c1*a2 + d1*c2,          c1*b2 + d1*d2,
	        e1*a2 + f1*c2 + e2,     e1*b2 + f1*d2 + f2
	    ];
	}
	
	function isIdentityMatrix(m) {
	    return m[0] === 1 && m[1] === 0 && m[2] === 0 && m[3] === 1 && m[4] === 0 && m[5] === 0;
	}
	
	var TEXT_RENDERING_MODE = {
	    fill           : 0,
	    stroke         : 1,
	    fillAndStroke  : 2,
	    invisible      : 3,
	    fillAndClip    : 4,
	    strokeAndClip  : 5,
	    fillStrokeClip : 6,
	    clip           : 7
	};
	
	/* eslint-disable no-multi-spaces, key-spacing, indent, camelcase, space-before-blocks, eqeqeq, brace-style */
	/* eslint-disable space-infix-ops, space-before-function-paren, array-bracket-spacing, object-curly-spacing */
	/* eslint-disable no-nested-ternary, max-params, default-case, no-else-return, no-empty */
	/* eslint-disable no-param-reassign, no-var, block-scoped-var */
	
	var DEFAULT_IMAGE_DPI = 300;
	var TEXT_RENDERING_MODE$1 = TEXT_RENDERING_MODE;
	
	var DASH_PATTERNS = {
	    dash           : [ 4 ],
	    dashDot        : [ 4, 2, 1, 2 ],
	    dot            : [ 1, 2 ],
	    longDash       : [ 8, 2 ],
	    longDashDot    : [ 8, 2, 1, 2 ],
	    longDashDotDot : [ 8, 2, 1, 2, 1, 2 ],
	    solid          : []
	};
	
	var LINE_CAP = {
	    butt   : 0,
	    round  : 1,
	    square : 2
	};
	
	var LINE_JOIN = {
	    miter : 0,
	    round : 1,
	    bevel : 2
	};
	
	function render$1(group, callback) {
	    var fonts = [], images = {}, options = group.options;
	
	    function getOption(name, defval, hash) {
	        if (!hash) {
	            hash = options;
	        }
	        if (hash.pdf && hash.pdf[name] != null) {
	            return hash.pdf[name];
	        }
	        return defval;
	    }
	
	    var multiPage = getOption("multiPage");
	    var imgDPI = getOption("imgDPI", DEFAULT_IMAGE_DPI);
	
	    clearImageCache();
	
	    group.traverse(function(element){
	        dispatch({
	            Image: function(element) {
	                var url = element.src();
	                var size = element.bbox().size;
	                if (imgDPI) {
	                    var prev = images[url];
	                    size = {
	                      width: Math.ceil(size.width * imgDPI / 72),
	                      height: Math.ceil(size.height * imgDPI / 72)
	                    };
	
	                    if (prev) {
	                      size.width = Math.max(prev.width, size.width);
	                      size.height = Math.max(prev.height, size.height);
	                    }
	                }
	
	                images[url] = size;
	            },
	            Text: function(element) {
	                var style = parseFontDef(element.options.font);
	                var url = getFontURL(style);
	                if (fonts.indexOf(url) < 0) {
	                    fonts.push(url);
	                }
	            }
	        }, element);
	    });
	
	    function doIt() {
	        if (--count > 0) {
	            return;
	        }
	
	        var pdf = new (PDFDocument)({
	            producer  : getOption("producer"),
	            title     : getOption("title"),
	            author    : getOption("author"),
	            subject   : getOption("subject"),
	            keywords  : getOption("keywords"),
	            creator   : getOption("creator"),
	            date      : getOption("date"),
	
	            autoPrint : getOption("autoPrint")
	        });
	
	        function drawPage(group) {
	            var options = group.options;
	
	            var tmp = optimize(group);
	            var bbox = tmp.bbox;
	            group = tmp.root;
	            // var tmp, bbox;
	
	            var paperSize = getOption("paperSize", getOption("paperSize", "auto"), options), addMargin = false;
	            if (paperSize == "auto") {
	                if (bbox) {
	                    var size = bbox.getSize();
	                    paperSize = [ size.width, size.height ];
	                    addMargin = true;
	                    var origin = bbox.getOrigin();
	                    tmp = new Group();
	                    tmp.transform(new Matrix(1, 0, 0, 1, -origin.x, -origin.y));
	                    tmp.append(group);
	                    group = tmp;
	                }
	                else {
	                    paperSize = "A4";
	                }
	            }
	
	            var page;
	            page = pdf.addPage({
	                paperSize : paperSize,
	                margin    : getOption("margin", getOption("margin"), options),
	                addMargin : addMargin,
	                landscape : getOption("landscape", getOption("landscape", false), options)
	            });
	            drawElement(group, page, pdf);
	        }
	
	        if (multiPage) {
	            group.children.forEach(drawPage);
	        } else {
	            drawPage(group);
	        }
	
	        callback(pdf.render(), pdf);
	    }
	
	    var count = 2;
	    loadFonts(fonts, doIt);
	    loadImages(images, doIt, {
	        jpegQuality : getOption("jpegQuality", 0.92),
	        keepPNG     : getOption("keepPNG", false)
	    });
	}
	
	function toDataURL(group, callback) {
	    render$1(group, function(data){
	        callback("data:application/pdf;base64," + data.base64());
	    });
	}
	
	function toBlob(group, callback) {
	    render$1(group, function(data){
	        callback(new window.Blob([ data.get() ], { type: "application/pdf" }));
	    });
	}
	
	function saveAs$1(group, filename, proxy, callback) {
	    // XXX: Safari has Blob, but does not support the download attribute
	    //      so we'd end up converting to dataURL and using the proxy anyway.
	    if (window.Blob && !support.browser.safari) {
	        toBlob(group, function(blob){
	            saveAs({ dataURI: blob, fileName: filename });
	            if (callback) {
	                callback(blob);
	            }
	        });
	    } else {
	        toDataURL(group, function(dataURL){
	            saveAs({ dataURI: dataURL, fileName: filename, proxyURL: proxy });
	            if (callback) {
	                callback(dataURL);
	            }
	        });
	    }
	}
	
	function dispatch(handlers, element) {
	    var handler = handlers[element.nodeType];
	    if (handler) {
	        return handler.call.apply(handler, arguments);
	    }
	    return element;
	}
	
	function drawElement(element, page, pdf) {
	    if (element.options._pdfDebug) {
	        page.comment("BEGIN: " + element.options._pdfDebug);
	    }
	
	    var transform$$1 = element.transform();
	    var opacity = element.opacity();
	
	    page.save();
	
	    if (opacity != null && opacity < 1) {
	        page.setOpacity(opacity);
	    }
	
	    setStrokeOptions(element, page, pdf);
	    setFillOptions(element, page, pdf);
	
	    if (transform$$1) {
	        var m = transform$$1.matrix();
	        page.transform(m.a, m.b, m.c, m.d, m.e, m.f);
	    }
	
	    setClipping(element, page, pdf);
	
	    dispatch({
	        Path      : drawPath,
	        MultiPath : drawMultiPath,
	        Circle    : drawCircle,
	        Arc       : drawArc,
	        Text      : drawText,
	        Image     : drawImage$1,
	        Group     : drawGroup,
	        Rect      : drawRect
	    }, element, page, pdf);
	
	    page.restore();
	
	    if (element.options._pdfDebug) {
	        page.comment("END: " + element.options._pdfDebug);
	    }
	}
	
	function setStrokeOptions(element, page) {
	    var stroke = element.stroke && element.stroke();
	    if (!stroke) {
	        return;
	    }
	
	    var color = stroke.color;
	    if (color) {
	        color = parseColor$1(color);
	        if (color == null) {
	            return; // no stroke
	        }
	        page.setStrokeColor(color.r, color.g, color.b);
	        if (color.a != 1) {
	            page.setStrokeOpacity(color.a);
	        }
	    }
	
	    var width = stroke.width;
	    if (width != null) {
	        if (width === 0) {
	            return; // no stroke
	        }
	        page.setLineWidth(width);
	    }
	
	    var dashType = stroke.dashType;
	    if (dashType) {
	        page.setDashPattern(DASH_PATTERNS[dashType], 0);
	    }
	
	    var lineCap = stroke.lineCap;
	    if (lineCap) {
	        page.setLineCap(LINE_CAP[lineCap]);
	    }
	
	    var lineJoin = stroke.lineJoin;
	    if (lineJoin) {
	        page.setLineJoin(LINE_JOIN[lineJoin]);
	    }
	
	    var opacity = stroke.opacity;
	    if (opacity != null) {
	        page.setStrokeOpacity(opacity);
	    }
	}
	
	function setFillOptions(element, page) {
	    var fill = element.fill && element.fill();
	    if (!fill) {
	        return;
	    }
	
	    if (fill instanceof Gradient) {
	        return;
	    }
	
	    var color = fill.color;
	    if (color) {
	        color = parseColor$1(color);
	        if (color == null) {
	            return; // no fill
	        }
	        page.setFillColor(color.r, color.g, color.b);
	        if (color.a != 1) {
	            page.setFillOpacity(color.a);
	        }
	    }
	
	    var opacity = fill.opacity;
	    if (opacity != null) {
	        page.setFillOpacity(opacity);
	    }
	}
	
	function setClipping(element, page, pdf) {
	    // XXX: only Path supported at the moment.
	    var clip = element.clip();
	    if (clip) {
	        _drawPath(clip, page, pdf);
	        page.clip();
	        // page.setStrokeColor(Math.random(), Math.random(), Math.random());
	        // page.setLineWidth(1);
	        // page.stroke();
	    }
	}
	
	function shouldDraw(thing) {
	    return (thing &&
	            (thing instanceof Gradient ||
	             (thing.color && !/^(none|transparent)$/i.test(thing.color) &&
	              (thing.width == null || thing.width > 0) &&
	              (thing.opacity == null || thing.opacity > 0))));
	}
	
	function maybeGradient(element, page, pdf, stroke) {
	    var fill = element.fill();
	    if (fill instanceof Gradient) {
	        if (stroke) {
	            page.clipStroke();
	        } else {
	            page.clip();
	        }
	        var isRadial = fill instanceof RadialGradient;
	        var start, end;
	        if (isRadial) {
	            start = { x: fill.center().x , y: fill.center().y , r: 0 };
	            end   = { x: fill.center().x , y: fill.center().y , r: fill.radius() };
	        } else {
	            start = { x: fill.start().x , y: fill.start().y };
	            end   = { x: fill.end().x   , y: fill.end().y   };
	        }
	
	        var stops = fill.stops.elements().map(function(stop){
	            var offset = stop.offset();
	            if (/%$/.test(offset)) {
	                offset = parseFloat(offset) / 100;
	            } else {
	                offset = parseFloat(offset);
	            }
	            var color = parseColor$1(stop.color());
	            color.a *= stop.opacity();
	            return {
	                offset: offset,
	                color: color
	            };
	        });
	
	        // Duplicats first and last stop to fix
	        // https://github.com/telerik/kendo-ui-core/issues/1782
	        stops.unshift(stops[0]);
	        stops.push(stops[stops.length - 1]);
	
	        var gradient = {
	            userSpace : fill.userSpace(),
	            type      : isRadial ? "radial" : "linear",
	            start     : start,
	            end       : end,
	            stops     : stops
	        };
	        var box = element.rawBBox();
	        var tl = box.topLeft(), size = box.getSize();
	        box = {
	            left   : tl.x,
	            top    : tl.y,
	            width  : size.width,
	            height : size.height
	        };
	        page.gradient(gradient, box);
	        return true;
	    }
	}
	
	function maybeFillStroke(element, page, pdf) {
	    if (shouldDraw(element.fill()) && shouldDraw(element.stroke())) {
	        if (!maybeGradient(element, page, pdf, true)) {
	            page.fillStroke();
	        }
	    } else if (shouldDraw(element.fill())) {
	        if (!maybeGradient(element, page, pdf, false)) {
	            page.fill();
	        }
	    } else if (shouldDraw(element.stroke())) {
	        page.stroke();
	    } else {
	        // we should not get here; the path should have been
	        // optimized away.  but let's be prepared.
	        page.nop();
	    }
	}
	
	function maybeDrawRect(path, page) {
	    var segments = path.segments;
	    if (segments.length == 4 && path.options.closed) {
	        // detect if this path looks like a rectangle parallel to the axis
	        var a = [];
	        for (var i = 0; i < segments.length; ++i) {
	            if (segments[i].controlIn()) { // has curve?
	                return false;
	            }
	            a[i] = segments[i].anchor();
	        }
	        // it's a rectangle if the y/x/y/x or x/y/x/y coords of
	        // consecutive points are the same.
	        var isRect = (
	            a[0].y == a[1].y && a[1].x == a[2].x && a[2].y == a[3].y && a[3].x == a[0].x
	        ) || (
	            a[0].x == a[1].x && a[1].y == a[2].y && a[2].x == a[3].x && a[3].y == a[0].y
	        );
	        if (isRect) {
	            // this saves a bunch of instructions in PDF:
	            // moveTo, lineTo, lineTo, lineTo, close -> rect.
	            page.rect(a[0].x, a[0].y,
	                      a[2].x - a[0].x /*width*/,
	                      a[2].y - a[0].y /*height*/);
	            return true;
	        }
	    }
	}
	
	function _drawPath(element, page, pdf) {
	    var segments = element.segments;
	    if (segments.length === 0) {
	        return;
	    }
	    if (!maybeDrawRect(element, page, pdf)) {
	        for (var prev, i = 0; i < segments.length; ++i) {
	            var seg = segments[i];
	            var anchor = seg.anchor();
	            if (!prev) {
	                page.moveTo(anchor.x, anchor.y);
	            } else {
	                var prevOut = prev.controlOut();
	                var controlIn = seg.controlIn();
	                if (prevOut && controlIn) {
	                    page.bezier(
	                        prevOut.x   , prevOut.y,
	                        controlIn.x , controlIn.y,
	                        anchor.x    , anchor.y
	                    );
	                } else {
	                    page.lineTo(anchor.x, anchor.y);
	                }
	            }
	            prev = seg;
	        }
	        if (element.options.closed) {
	            page.close();
	        }
	    }
	}
	
	function drawPath(element, page, pdf) {
	    _drawPath(element, page, pdf);
	    maybeFillStroke(element, page, pdf);
	}
	
	function drawMultiPath(element, page, pdf) {
	    var paths = element.paths;
	    for (var i = 0; i < paths.length; ++i) {
	        _drawPath(paths[i], page, pdf);
	    }
	    maybeFillStroke(element, page, pdf);
	}
	
	function drawCircle(element, page, pdf) {
	    var g = element.geometry();
	    page.circle(g.center.x, g.center.y, g.radius);
	    maybeFillStroke(element, page, pdf);
	}
	
	function drawArc(element, page, pdf) {
	    var points = element.geometry().curvePoints();
	    page.moveTo(points[0].x, points[0].y);
	    for (var i = 1; i < points.length;) {
	        page.bezier(
	            points[i].x, points[i++].y,
	            points[i].x, points[i++].y,
	            points[i].x, points[i++].y
	        );
	    }
	    maybeFillStroke(element, page, pdf);
	}
	
	function drawText(element, page) {
	    var style = parseFontDef(element.options.font);
	    var pos = element._position;
	    var mode;
	
	    page.transform(1, 0, 0, -1, pos.x, pos.y + style.fontSize);
	
	    var draw = function (renderMode) {
	        page.beginText();
	        page.setFont(getFontURL(style), style.fontSize);
	        page.setTextRenderingMode(renderMode);
	        page.showText(element.content(), element._pdfRect ? element._pdfRect.width() : null);
	    };
	
	    if (element.fill() && element.stroke()) {
	        mode = TEXT_RENDERING_MODE$1.fillAndStroke;
	        if (element.options.paintOrder === "stroke") {
	            draw(TEXT_RENDERING_MODE$1.stroke);
	            mode = TEXT_RENDERING_MODE$1.fill;
	        }
	    } else if (element.fill()) {
	        mode = TEXT_RENDERING_MODE$1.fill;
	    } else if (element.stroke()) {
	        mode = TEXT_RENDERING_MODE$1.stroke;
	    }
	
	    draw(mode);
	    page.endText();
	}
	
	function drawGroup(element, page, pdf) {
	    if (element._pdfLink) {
	        page.addLink(element._pdfLink.url, element._pdfLink);
	    }
	    var children = element.children;
	    for (var i = 0; i < children.length; ++i) {
	        drawElement(children[i], page, pdf);
	    }
	}
	
	function drawImage$1(element, page) {
	    var url = element.src();
	    if (!url) {
	        return;
	    }
	
	    var rect = element.rect();
	    var tl = rect.getOrigin();
	    var sz = rect.getSize();
	    page.transform(sz.width, 0, 0, -sz.height, tl.x, tl.y + sz.height);
	    page.drawImage(url);
	}
	
	function drawRect(element, page, pdf) {
	    var geometry = element.geometry();
	    var ref = geometry.cornerRadius;
	    var rx = ref[0];
	    var ry = ref[1];
	    if (rx === 0 && ry === 0) {
	        page.rect(geometry.origin.x, geometry.origin.y, geometry.size.width, geometry.size.height);
	        maybeFillStroke(element, page, pdf);
	    } else {
	        drawPath(Path.fromRect(geometry, element.options), page, pdf);
	    }
	}
	
	function parseColor$1(value) {
	    var color = parseColor(value, true);
	    return color ? color.toRGB() : null;
	}
	
	function optimize(root) {
	    var clipbox = false;
	    var matrix = Matrix.unit();
	    var currentBox = null;
	    var changed;
	    do {
	        changed = false;
	        root = opt(root);
	    } while (root && changed);
	    return { root: root, bbox: currentBox };
	
	    function change(newShape) {
	        changed = true;
	        return newShape;
	    }
	
	    function visible(shape) {
	        return (shape.visible() && shape.opacity() > 0 &&
	                ( shouldDraw(shape.fill()) ||
	                  shouldDraw(shape.stroke()) ));
	    }
	
	    function optArray(a) {
	        var b = [];
	        for (var i = 0; i < a.length; ++i) {
	            var el = opt(a[i]);
	            if (el != null) {
	                b.push(el);
	            }
	        }
	        return b;
	    }
	
	    function withClipping(shape, f) {
	        var saveclipbox = clipbox;
	        var savematrix = matrix;
	
	        if (shape.transform()) {
	            matrix = matrix.multiplyCopy(shape.transform().matrix());
	        }
	
	        var clip = shape.clip();
	        if (clip) {
	            clip = clip.bbox();
	            if (clip) {
	                clip = clip.bbox(matrix);
	                clipbox = clipbox ? Rect.intersect(clipbox, clip) : clip;
	            }
	        }
	
	        try {
	            return f();
	        }
	        finally {
	            clipbox = saveclipbox;
	            matrix = savematrix;
	        }
	    }
	
	    function inClipbox(shape) {
	        if (clipbox == null) {
	            return false;
	        }
	        var box = shape.rawBBox().bbox(matrix);
	        if (clipbox && box) {
	            box = Rect.intersect(box, clipbox);
	        }
	        return box;
	    }
	
	    function opt(shape) {
	        return withClipping(shape, function(){
	            if (!(shape instanceof Group || shape instanceof MultiPath)) {
	                var box = inClipbox(shape);
	                if (!box) {
	                    return change(null);
	                }
	                currentBox = currentBox ? Rect.union(currentBox, box) : box;
	            }
	            return dispatch({
	                Path: function(shape) {
	                    if (shape.segments.length === 0 || !visible(shape)) {
	                        return change(null);
	                    }
	                    return shape;
	                },
	                MultiPath: function(shape) {
	                    if (!visible(shape)) {
	                        return change(null);
	                    }
	                    var el = new MultiPath(shape.options);
	                    el.paths = optArray(shape.paths);
	                    if (el.paths.length === 0) {
	                        return change(null);
	                    }
	                    return el;
	                },
	                Circle: function(shape) {
	                    if (!visible(shape)) {
	                        return change(null);
	                    }
	                    return shape;
	                },
	                Arc: function(shape) {
	                    if (!visible(shape)) {
	                        return change(null);
	                    }
	                    return shape;
	                },
	                Text: function(shape) {
	                    if (!/\S/.test(shape.content()) || !visible(shape)) {
	                        return change(null);
	                    }
	                    return shape;
	                },
	                Image: function(shape) {
	                    if (!(shape.visible() && shape.opacity() > 0)) {
	                        return change(null);
	                    }
	                    return shape;
	                },
	                Group: function(shape) {
	                    if (!(shape.visible() && shape.opacity() > 0)) {
	                        return change(null);
	                    }
	                    var el = new Group(shape.options);
	                    el.children = optArray(shape.children);
	                    el._pdfLink = shape._pdfLink;
	                    if (shape !== root && el.children.length === 0 && !shape._pdfLink) {
	                        return change(null);
	                    }
	                    return el;
	                },
	                Rect: function(shape) {
	                    if (!visible(shape)) {
	                        return change(null);
	                    }
	                    return shape;
	                }
	            }, shape);
	        });
	    }
	}
	
	function exportPDF(group, options) {
	    var promise = createPromise();
	
	    for (var i in options) {
	        if (i == "margin" && group.options.pdf && group.options.pdf._ignoreMargin) {
	            // This hackish option is set by the page breaking code in drawDOM.  The idea is
	            // that margin is already taken into account there (that's required to do proper
	            // page breaking) and we don't want to set it again here, as it would double the
	            // top-left margin, and truncate the content on bottom/right.
	            continue;
	        }
	        group.options.set("pdf." + i, options[i]);
	    }
	
	    toDataURL(group, promise.resolve);
	
	    return promise;
	}
	
	// XXX: the duplication is in order to keep exportPDF return a data
	// URI, which is what previous versions do.  Currently only IE9 does
	// not support Blob, IMO we should switch to Blob by default
	// everywhere.
	function exportPDFToBlob(group, options) {
	    var promise = createPromise();
	
	    for (var i in options) {
	        if (i == "margin" && group.options.pdf && group.options.pdf._ignoreMargin) {
	            // This hackish option is set by the page breaking code in drawDOM.  The idea is
	            // that margin is already taken into account there (that's required to do proper
	            // page breaking) and we don't want to set it again here, as it would double the
	            // top-left margin, and truncate the content on bottom/right.
	            continue;
	        }
	        group.options.set("pdf." + i, options[i]);
	    }
	
	    if (window.Blob && !support.browser.safari) {
	        toBlob(group, promise.resolve);
	    } else {
	        toDataURL(group, promise.resolve);
	    }
	
	    return promise;
	}
	
	
	
	var pdf = Object.freeze({
		Document: PDFDocument,
		BinaryStream: BinaryStream,
		defineFont: defineFont,
		parseFontDef: parseFontDef,
		getFontURL: getFontURL,
		loadFonts: loadFonts,
		loadImages: loadImages,
		getPaperOptions: getPaperOptions,
		clearImageCache: clearImageCache,
		TEXT_RENDERING_MODE: TEXT_RENDERING_MODE,
		exportPDF: exportPDF,
		exportPDFToBlob: exportPDFToBlob,
		saveAs: saveAs$1,
		toDataURL: toDataURL,
		toBlob: toBlob,
		render: render$1
	});
	
	/* eslint-disable no-multi-spaces, key-spacing, indent, camelcase, space-before-blocks, eqeqeq, brace-style */
	/* eslint-disable space-infix-ops, space-before-function-paren, array-bracket-spacing, object-curly-spacing */
	/* eslint-disable no-nested-ternary, max-params, default-case, no-else-return, no-empty, yoda */
	/* eslint-disable no-param-reassign, no-var, block-scoped-var */
	
	var browser$3 = support.browser || {};
	/*
	
	  XXX: to test:
	
	  - cloneNodes function:
	    - drawing document containing canvas with page breaking
	    - drawing document with named radio <input>-s (should not clear selection)
	    - IE9/IE10 don't support el.dataset; do they copy user data?
	
	  - repeating table headers/footers on page breaking
	
	  - forceBreak, keepTogether
	
	  - avoidLinks
	
	 */
	
	/* -----[ local vars ]----- */
	
	function slice$1$1(thing) {
	    return Array.prototype.slice.call(thing);
	}
	
	var KENDO_PSEUDO_ELEMENT = "KENDO-PSEUDO-ELEMENT";
	var KENDO_BULLET_TYPE = 'data-kendo-bullet-type';
	
	var IMAGE_CACHE$1 = {};
	
	var nodeInfo = {};
	nodeInfo._root = nodeInfo;
	
	/* -----[ Custom Text node to speed up rendering in PDF ]----- */
	
	var inBrowser = typeof window !== 'undefined';
	var microsoft = inBrowser ? browser$3.msie || browser$3.edge : false;
	
	var TextRect = (function (Text$$1) {
	  function TextRect(str, rect, options) {
	        Text$$1.call(this, str, rect.getOrigin(), options);
	        this._pdfRect = rect;
	    }
	
	  if ( Text$$1 ) TextRect.__proto__ = Text$$1;
	  TextRect.prototype = Object.create( Text$$1 && Text$$1.prototype );
	  TextRect.prototype.constructor = TextRect;
	    TextRect.prototype.rect = function rect () {
	        // this is the crux of it: we can avoid a call to
	        // measure(), which is what the base class does, since we
	        // already know the rect.  measure() is s-l-o-w.
	        return this._pdfRect;
	    };
	    TextRect.prototype.rawBBox = function rawBBox () {
	        // also let's avoid creating a new rectangle.
	        return this._pdfRect;
	    };
	
	  return TextRect;
	}(Text));
	
	function addClass(el, cls) {
	    if (el.classList) {
	        el.classList.add(cls);
	    } else {
	        el.className += " " + cls;
	    }
	}
	
	function removeClass(el, cls) {
	    if (el.classList) {
	        el.classList.remove(cls);
	    } else {
	        el.className = el.className.split(/\s+/).reduce(function(a, word){
	            if (word != cls) {
	                a.push(word);
	            }
	            return a;
	        }, []).join(" ");
	    }
	}
	
	function setCSS(el, styles) {
	    Object.keys(styles).forEach(function(key){
	        el.style[key] = styles[key];
	    });
	}
	
	var matches = typeof Element !== "undefined" && Element.prototype && (function(p){
	    if (p.matches) {
	        return function(el, selector) { return el.matches(selector); };
	    }
	    if (p.webkitMatchesSelector) {
	        return function(el, selector) { return el.webkitMatchesSelector(selector); };
	    }
	    if (p.mozMatchesSelector) {
	        return function(el, selector) { return el.mozMatchesSelector(selector); };
	    }
	    if (p.msMatchesSelector) {
	        return function(el, selector) { return el.msMatchesSelector(selector); };
	    }
	    return function(s) {
		return [].indexOf.call(document.querySelectorAll(s), this) !== -1;
	    };
	})(Element.prototype);
	
	function closest(el, selector) {
	    if (el.closest) {
	        return el.closest(selector);
	    }
	    // IE: stringifying rather than simply comparing with `document`,
	    // which is not iframe-proof and fails in editor export —
	    // https://github.com/telerik/kendo/issues/6721
	    while (el && !/^\[object (?:HTML)?Document\]$/.test(String(el))) {
	        if (el.nodeType == 1 /* Element */ && matches(el, selector)) {
	            return el;
	        }
	        el = el.parentNode;
	    }
	}
	
	// clone nodes ourselves, so that we redraw <canvas> (DOM or
	// jQuery clone will not)
	var cloneNodes = (function($){
	    if ($) {
	        // if we have Kendo and jQuery, use this version as it will
	        // maintain proper links between cloned element and Kendo
	        // widgets (i.e. it clones jQuery data(), which isn't the same
	        // as element's data attributes).
	        // https://github.com/telerik/kendo-ui-core/issues/2750
	        return function cloneNodes(el) {
	            var clone = el.cloneNode(false);
	            if (el.nodeType == 1 /* Element */) {
	                var $el = $(el), $clone = $(clone), i;
	                var data = $el.data();
	                for (i in data) {
	                    $clone.data(i, data[i]);
	                }
	                if (/^canvas$/i.test(el.tagName)) {
	                    clone.getContext("2d").drawImage(el, 0, 0);
	                } else if (/^(?:input|select|textarea|option)$/i.test(el.tagName)) {
	                    // drop the name attributes so that we don't affect the selection of the
	                    // original nodes (i.e. checked status of radio buttons) when we insert our copy
	                    // into the DOM.  https://github.com/telerik/kendo/issues/5409
	                    clone.removeAttribute("id");
	                    clone.removeAttribute("name");
	                    if (!/^textarea$/i.test(el.tagName)) {
	                        clone.value = el.value;
	                    }
	                    clone.checked = el.checked;
	                    clone.selected = el.selected;
	                }
	                for (i = el.firstChild; i; i = i.nextSibling) {
	                    clone.appendChild(cloneNodes(i));
	                }
	            }
	            return clone;
	        };
	    } else {
	        // the no-jQuery version
	        return function cloneNodes(el) {
	            var clone = (function dive(node){
	                var clone = node.cloneNode(false);
	                if (node._kendoExportVisual) {
	                    clone._kendoExportVisual = node._kendoExportVisual;
	                }
	                for (var i = node.firstChild; i; i = i.nextSibling) {
	                    clone.appendChild(dive(i));
	                }
	                return clone;
	            })(el);
	
	            // re-draw canvases - https://github.com/telerik/kendo/issues/4872
	            var canvases = el.querySelectorAll("canvas");
	            if (canvases.length) {
	                slice$1$1(clone.querySelectorAll("canvas")).forEach(function (canvas$$1, i) {
	                    canvas$$1.getContext("2d").drawImage(canvases[i], 0, 0);
	                });
	            }
	
	            // remove "name" attributes from <input> elements -
	            // https://github.com/telerik/kendo/issues/5409
	            var orig = el.querySelectorAll("input, select, textarea, option");
	            slice$1$1(clone.querySelectorAll("input, select, textarea, option")).forEach(function (el, i) {
	                el.removeAttribute("id");
	                el.removeAttribute("name");
	                if (!/^textarea$/i.test(el.tagName)) {
	                    el.value = orig[i].value;
	                }
	                el.checked = orig[i].checked;
	                el.selected = orig[i].selected;
	            });
	
	            return clone;
	        };
	    }
	})(typeof window !== "undefined" && window.kendo && window.kendo.jQuery);
	
	function getXY(thing) {
	    if (typeof thing == "number") {
	        return { x: thing, y: thing };
	    }
	    if (Array.isArray(thing)) {
	        return { x: thing[0], y: thing[1] };
	    }
	    return { x: thing.x, y: thing.y };
	}
	
	function drawDOM(element, options) {
	    if (!options) {
	        options = {};
	    }
	    var promise = createPromise();
	
	    if (!element) {
	        return promise.reject("No element to export");
	    }
	
	    if (typeof window.getComputedStyle != "function") {
	        throw new Error("window.getComputedStyle is missing.  You are using an unsupported browser, or running in IE8 compatibility mode.  Drawing HTML is supported in Chrome, Firefox, Safari and IE9+.");
	    }
	
	    defineFont(getFontFaces(element.ownerDocument));
	
	    var scale = getXY(options.scale || 1);
	
	    function doOne(element) {
	        var group = new Group();
	
	        // translate to start of page
	        var pos = element.getBoundingClientRect();
	        setTransform$1(group, [
	            scale.x,
	            0,
	            0,
	            scale.y,
	            (-pos.left * scale.x),
	            (-pos.top * scale.y)
	        ]);
	
	        nodeInfo._clipbox = false;
	        nodeInfo._matrix = Matrix.unit();
	        nodeInfo._stackingContext = {
	            element: element,
	            group: group
	        };
	
	        if (options.avoidLinks === true) {
	            nodeInfo._avoidLinks = "a";
	        } else {
	            nodeInfo._avoidLinks = options.avoidLinks;
	        }
	
	        addClass(element, "k-pdf-export");
	        renderElement(element, group);
	        removeClass(element, "k-pdf-export");
	
	        return group;
	    }
	
	    cacheImages([ element ], function(){
	        var forceBreak = options && options.forcePageBreak;
	        var hasPaperSize = options && options.paperSize && options.paperSize != "auto";
	        var paperOptions = getPaperOptions(function(key, def){
	            if (key == "paperSize") {
	                // PDF.getPaperOptions croaks on "auto", just pass dummy A4 as we might
	                // still be interested in margins.
	                return hasPaperSize ? options[key] : "A4";
	            }
	            return key in options ? options[key] : def;
	        });
	        var pageWidth = hasPaperSize && paperOptions.paperSize[0];
	        var pageHeight = hasPaperSize && paperOptions.paperSize[1];
	        var margin = options.margin && paperOptions.margin;
	        var hasMargin = Boolean(margin);
	        if (forceBreak || pageHeight) {
	            if (!margin) {
	                margin = { left: 0, top: 0, right: 0, bottom: 0 };
	            }
	
	            // we want paper size and margin to be unaffected by
	            // scaling in the output, so we have to reverse-scale
	            // before our calculations begin.
	            if (pageWidth)  { pageWidth  /= scale.x; }
	            if (pageHeight) { pageHeight /= scale.y; }
	            margin.left   /= scale.x;
	            margin.right  /= scale.x;
	            margin.top    /= scale.y;
	            margin.bottom /= scale.y;
	
	            var group = new Group({
	                pdf: {
	                    multiPage     : true,
	                    paperSize     : hasPaperSize ? paperOptions.paperSize : "auto",
	                    _ignoreMargin : hasMargin // HACK!  see exportPDF in pdf/drawing.js
	                }
	            });
	            handlePageBreaks(
	                function(x) {
	                    if (options.progress) {
	                        var canceled = false, pageNum = 0;
	                        (function next(){
	                            if (pageNum < x.pages.length) {
	                                var page = doOne(x.pages[pageNum]);
	                                group.append(page);
	                                options.progress({
	                                    page: page,
	                                    pageNum: ++pageNum,
	                                    totalPages: x.pages.length,
	                                    cancel: function() {
	                                        canceled = true;
	                                    }
	                                });
	                                if (!canceled) {
	                                    setTimeout(next);
	                                } else {
	                                    // XXX: should we also fail() the deferred object?
	                                    x.container.parentNode.removeChild(x.container);
	                                }
	                            } else {
	                                x.container.parentNode.removeChild(x.container);
	                                promise.resolve(group);
	                            }
	                        })();
	                    } else {
	                        x.pages.forEach(function(page){
	                            group.append(doOne(page));
	                        });
	                        x.container.parentNode.removeChild(x.container);
	                        promise.resolve(group);
	                    }
	                },
	                element,
	                forceBreak,
	                pageWidth ? pageWidth - margin.left - margin.right : null,
	                pageHeight ? pageHeight - margin.top - margin.bottom : null,
	                margin,
	                options
	            );
	        } else {
	            promise.resolve(doOne(element));
	        }
	    });
	
	    function makeTemplate(template$$1) {
	        if (template$$1 != null) {
	            if (typeof template$$1 == "string") {
	                template$$1 = template$1(template$$1.replace(/^\s+|\s+$/g, ""));
	            }
	            if (typeof template$$1 == "function") {
	                return function(data) {
	                    var el = template$$1(data);
	                    if (el && typeof el == "string") {
	                        var div = document.createElement("div");
	                        div.innerHTML = el;
	                        el = div.firstElementChild;
	                    }
	                    return el;
	                };
	            }
	            // assumed DOM element
	            return function() {
	                return template$$1.cloneNode(true);
	            };
	        }
	    }
	
	    function handlePageBreaks(callback, element, forceBreak, pageWidth, pageHeight, margin, options) {
	        var template$$1 = makeTemplate(options.template);
	        var doc = element.ownerDocument;
	        var pages = [];
	        var copy = options._destructive ? element : cloneNodes(element);
	        var container = doc.createElement("KENDO-PDF-DOCUMENT");
	        var adjust = 0;
	
	        // make sure <tfoot> elements are at the end (Grid widget
	        // places TFOOT before TBODY, tricking our algorithm to
	        // insert a page break right after the header).
	        // https://github.com/telerik/kendo/issues/4699
	        slice$1$1(copy.querySelectorAll("tfoot")).forEach(function(tfoot){
	            tfoot.parentNode.appendChild(tfoot);
	        });
	
	        // remember the index of each LI from an ordered list.
	        // we'll use it to reconstruct the proper numbering.
	        slice$1$1(copy.querySelectorAll("ol")).forEach(function(ol){
	            slice$1$1(ol.children).forEach(function(li, index){
	                li.setAttribute("kendo-split-index", index);
	            });
	        });
	
	        setCSS(container, {
	            display   : "block",
	            position  : "absolute",
	            boxSizing : "content-box",
	            left      : "-10000px",
	            top       : "-10000px"
	        });
	
	        if (pageWidth) {
	            // subtle: if we don't set the width *and* margins here, the layout in this
	            // container will be different from the one in our final page elements, and we'll
	            // split at the wrong places.
	            setCSS(container, {
	                width        : pageWidth + "px",
	                paddingLeft  : margin.left + "px",
	                paddingRight : margin.right + "px"
	            });
	
	            // when the first element has a margin-top (i.e. a <h1>) the page will be
	            // inadvertently enlarged by that number (the browser will report the container's
	            // bounding box top to start at the element's top, rather than including its
	            // margin).  Adding overflow: hidden seems to fix it.
	            //
	            // to understand the difference, try the following snippets in your browser:
	            //
	            // 1. <div style="background: yellow">
	            //      <h1 style="margin: 3em">Foo</h1>
	            //    </div>
	            //
	            // 2. <div style="background: yellow; overflow: hidden">
	            //      <h1 style="margin: 3em">Foo</h1>
	            //    </div>
	            //
	            // this detail is not important when automatic page breaking is not requested, hence
	            // doing it only if pageWidth is defined.
	            setCSS(copy, { overflow: "hidden" });
	        }
	
	        element.parentNode.insertBefore(container, element);
	        container.appendChild(copy);
	
	        // With cache disabled, images will still have height zero until their `complete` attribute
	        // is true.  `whenImagesAreActuallyLoaded` will wait for it.
	        if (options.beforePageBreak) {
	            whenImagesAreActuallyLoaded([ container ], function() {
	                options.beforePageBreak(container, doPageBreak);
	            });
	        } else {
	            whenImagesAreActuallyLoaded([ container ], doPageBreak);
	        }
	
	        function doPageBreak() {
	            if (forceBreak != "-" || pageHeight) {
	                splitElement(copy);
	            }
	
	            {
	                var page = makePage();
	                copy.parentNode.insertBefore(page, copy);
	                page.appendChild(copy);
	            }
	
	            if (template$$1) {
	                pages.forEach(function(page, i){
	                    var el = template$$1({
	                        element    : page,
	                        pageNum    : i + 1,
	                        totalPages : pages.length
	                    });
	                    if (el) {
	                        page.appendChild(el);
	                    }
	                });
	            }
	
	            cacheImages(pages, callback.bind(null, { pages: pages, container: container }));
	        }
	
	        function keepTogether(el) {
	            if (options.keepTogether && matches(el, options.keepTogether) && el.offsetHeight <= pageHeight - adjust) {
	                return true;
	            }
	
	            var tag = el.tagName;
	            if (/^h[1-6]$/i.test(tag) && el.offsetHeight >= pageHeight - adjust) {
	                return false;
	            }
	
	            return (el.getAttribute("data-kendo-chart") ||
	                    /^(?:img|tr|thead|th|tfoot|iframe|svg|object|canvas|input|textarea|select|video|h[1-6])/i.test(el.tagName));
	        }
	
	        function splitElement(element) {
	            if (element.tagName == "TABLE") {
	                setCSS(element, { tableLayout: "fixed" });
	            }
	            if (keepTogether(element)) {
	                return;
	            }
	            var style = getComputedStyle$1(element);
	            var bottomPadding = parseFloat(getPropertyValue(style, "padding-bottom"));
	            var bottomBorder = parseFloat(getPropertyValue(style, "border-bottom-width"));
	            var saveAdjust = adjust;
	            adjust += bottomPadding + bottomBorder;
	            var isFirst = true;
	            for (var el = element.firstChild; el; el = el.nextSibling) {
	                if (el.nodeType == 1 /* Element */) {
	                    isFirst = false;
	                    if (matches(el, forceBreak)) {
	                        breakAtElement(el);
	                        continue;
	                    }
	                    if (!pageHeight) {
	                        // we're in "manual breaks mode"
	                        splitElement(el);
	                        continue;
	                    }
	                    if (!/^(?:static|relative)$/.test(getPropertyValue(getComputedStyle$1(el), "position"))) {
	                        continue;
	                    }
	                    var fall = fallsOnMargin(el);
	                    if (fall == 1) {
	                        // element starts on next page, break before anyway.
	                        breakAtElement(el);
	                    }
	                    else if (fall) {
	                        // elements ends up on next page, or possibly doesn't fit on a page at
	                        // all.  break before it anyway if it's an <img> or <tr>, otherwise
	                        // attempt to split.
	                        if (keepTogether(el)) {
	                            breakAtElement(el);
	                        } else {
	                            splitElement(el);
	                        }
	                    }
	                    else {
	                        splitElement(el);
	                    }
	                }
	                else if (el.nodeType == 3 /* Text */ && pageHeight) {
	                    splitText(el, isFirst);
	                    isFirst = false;
	                }
	            }
	            adjust = saveAdjust;
	        }
	
	        function firstInParent(el) {
	            var p = el.parentNode, first = p.firstChild;
	            if (el === first) {
	                return true;
	            }
	            if (el === p.children[0]) {
	                if (first.nodeType == 7 /* comment */ ||
	                    first.nodeType == 8 /* processing instruction */) {
	                    return true;
	                }
	                if (first.nodeType == 3 /* text */) {
	                    // if whitespace only we can probably consider it's first
	                    return !/\S/.test(first.data);
	                }
	            }
	            return false;
	        }
	
	        function breakAtElement(el) {
	            if (el.nodeType == 1 && el !== copy && firstInParent(el)) {
	                return breakAtElement(el.parentNode);
	            }
	            var table, colgroup, thead, grid, gridHead;
	            table = closest(el, "table");
	            colgroup = table && table.querySelector("colgroup");
	            if (options.repeatHeaders) {
	                thead = table && table.querySelector("thead");
	
	                // If we break page in a Kendo Grid, repeat its header.  This ugly hack is
	                // necessary because a scrollable grid will keep the header in a separate
	                // <table> element from its content.
	                //
	                // XXX: This is likely to break as soon as the widget HTML is modified.
	                grid = closest(el, ".k-grid");
	                if (grid && grid.querySelector(".k-auto-scrollable")) {
	                    gridHead = grid.querySelector(".k-grid-header");
	                }
	            }
	            var page = makePage();
	            var range = doc.createRange();
	            range.setStartBefore(copy);
	            range.setEndBefore(el);
	            page.appendChild(range.extractContents());
	            copy.parentNode.insertBefore(page, copy);
	            preventBulletOnListItem(el.parentNode);
	            if (table) {
	                table = closest(el, "table"); // that's the <table> on next page!
	                if (options.repeatHeaders && thead) {
	                    table.insertBefore(thead.cloneNode(true), table.firstChild);
	                }
	                if (colgroup) {
	                    table.insertBefore(colgroup.cloneNode(true), table.firstChild);
	                }
	            }
	            if (options.repeatHeaders && gridHead) {
	                grid = closest(el, ".k-grid");
	                grid.insertBefore(gridHead.cloneNode(true), grid.firstChild);
	            }
	        }
	
	        function makePage() {
	            var page = doc.createElement("KENDO-PDF-PAGE");
	            setCSS(page, {
	                display  : "block",
	                boxSizing: "content-box",
	                width    : pageWidth ? (pageWidth + "px") : "auto",
	                padding  : (margin.top + "px " +
	                            margin.right + "px " +
	                            margin.bottom + "px " +
	                            margin.left + "px"),
	
	                // allow absolutely positioned elements to be relative to current page
	                position : "relative",
	
	                // without the following we might affect layout of subsequent pages
	                height   : pageHeight ? (pageHeight + "px") : "auto",
	                overflow : pageHeight || pageWidth ? "hidden" : "visible",
	                clear    : "both"
	            });
	
	            // debug
	            // $("<div>").css({
	            //     position  : "absolute",
	            //     left      : margin.left,
	            //     top       : margin.top,
	            //     width     : pageWidth,
	            //     height    : pageHeight,
	            //     boxSizing : "border-box",
	            //     background: "rgba(255, 255, 0, 0.5)"
	            //     //border    : "1px solid red"
	            // }).appendTo(page);
	
	            if (options && options.pageClassName) {
	                page.className = options.pageClassName;
	            }
	            pages.push(page);
	            return page;
	        }
	
	        function fallsOnMargin(thing) {
	            var box = thing.getBoundingClientRect();
	            if (box.width === 0 || box.height === 0) {
	                // I'd say an element with dimensions zero fits on current page.
	                return 0;
	            }
	            var top = copy.getBoundingClientRect().top;
	            var available = pageHeight - adjust;
	            return (box.height > available) ? 3
	                : (box.top - top > available) ? 1
	                : (box.bottom - top > available) ? 2
	                : 0;
	        }
	
	        function splitText(node, isFirst) {
	            if (!/\S/.test(node.data)) {
	                return;
	            }
	
	            var len = node.data.length;
	            var range = doc.createRange();
	            range.selectNodeContents(node);
	            var fall = fallsOnMargin(range);
	            if (!fall) {
	                return;     // the whole text fits on current page
	            }
	
	            var nextnode = node;
	            if (fall == 1) {
	                // starts on next page, break before anyway.
	                if (isFirst) {
	                    // avoid leaving an empty <p>, <li>, etc. on previous page.
	                    breakAtElement(node.parentNode);
	                } else {
	                    breakAtElement(node);
	                }
	            }
	            else {
	                (function findEOP(min, pos, max) {
	                    range.setEnd(node, pos);
	                    if (min == pos || pos == max) {
	                        return pos;
	                    }
	                    if (fallsOnMargin(range)) {
	                        return findEOP(min, (min + pos) >> 1, pos);
	                    } else {
	                        return findEOP(pos, (pos + max) >> 1, max);
	                    }
	                })(0, len >> 1, len);
	
	                if (!/\S/.test(range.toString()) && isFirst) {
	                    // avoid leaving an empty <p>, <li>, etc. on previous page.
	                    breakAtElement(node.parentNode);
	                } else {
	                    // This is only needed for IE, but it feels cleaner to do it anyway.  Without
	                    // it, IE will truncate a very long text (playground/pdf-long-text-2.html).
	                    nextnode = node.splitText(range.endOffset);
	
	                    var page = makePage();
	                    range.setStartBefore(copy);
	                    page.appendChild(range.extractContents());
	                    copy.parentNode.insertBefore(page, copy);
	                    preventBulletOnListItem(nextnode.parentNode);
	                }
	            }
	
	            splitText(nextnode);
	        }
	
	        function preventBulletOnListItem(el) {
	            // set a hint on continued LI elements, to tell the
	            // renderer not to draw the bullet again.
	            // https://github.com/telerik/kendo-ui-core/issues/2732
	            var li = closest(el, "li");
	            if (li) {
	                li.setAttribute("kendo-no-bullet", "1");
	                preventBulletOnListItem(li.parentNode);
	            }
	        }
	    }
	
	    return promise;
	}
	
	// This is needed for the Spreadsheet print functionality.  Since
	// there we only need to draw text, this cuts through the ceremony
	// of drawDOM/renderElement and renders the text node directly.
	function drawText$1(element) {
	    var group = new Group();
	    nodeInfo._clipbox = false;
	    nodeInfo._matrix = Matrix.unit();
	    nodeInfo._stackingContext = {
	        element: element,
	        group: group
	    };
	    pushNodeInfo(element, getComputedStyle$1(element), group);
	    if (element.firstChild.nodeType == 3 /* Text */) {
	        // avoid the penalty of renderElement
	        renderText(element, element.firstChild, group);
	    } else {
	        _renderElement(element, group);
	    }
	    popNodeInfo();
	    return group;
	}
	
	var parseBackgroundImage = (function(){
	    var tok_linear_gradient  = /^((-webkit-|-moz-|-o-|-ms-)?linear-gradient\s*)\(/;
	    //var tok_radial_gradient  = /^((-webkit-|-moz-|-o-|-ms-)?radial-gradient\s*)\(/;
	    var tok_percent          = /^([-0-9.]+%)/;
	    var tok_length           = /^([-0-9.]+px)/;
	    var tok_keyword          = /^(left|right|top|bottom|to|center)\W/;
	    var tok_angle            = /^([-0-9.]+(deg|grad|rad|turn)|0)/;
	    var tok_whitespace       = /^(\s+)/;
	    var tok_popen            = /^(\()/;
	    var tok_pclose           = /^(\))/;
	    var tok_comma            = /^(,)/;
	    var tok_url              = /^(url)\(/;
	    var tok_content          = /^(.*?)\)/;
	
	    var cache1 = {}, cache2 = {};
	
	    function parse(input) {
	        var orig = input;
	        if (hasOwnProperty$2(cache1, orig)) {
	            return cache1[orig];
	        }
	        function skip_ws() {
	            var m = tok_whitespace.exec(input);
	            if (m) {
	                input = input.substr(m[1].length);
	            }
	        }
	        function read(token) {
	            skip_ws();
	            var m = token.exec(input);
	            if (m) {
	                input = input.substr(m[1].length);
	                return m[1];
	            }
	        }
	
	        function read_stop() {
	            var color = parseColor(input, true);
	            var length, percent;
	            if (color) {
	                var match =
	                    /^#[0-9a-f]+/i.exec(input) ||
	                    /^rgba?\(.*?\)/i.exec(input) ||
	                    /^..*?\b/.exec(input); // maybe named color
	                input = input.substr(match[0].length);
	                color = color.toRGB();
	                if (!(length = read(tok_length))) {
	                    percent = read(tok_percent);
	                }
	                return { color: color, length: length, percent: percent };
	            }
	        }
	
	        function read_linear_gradient(propName) {
	            var angle;
	            var to1, to2;
	            var stops = [];
	            var reverse = false;
	
	            if (read(tok_popen)) {
	                // 1. [ <angle> || to <side-or-corner>, ]?
	                angle = read(tok_angle);
	                if (angle == "0") {
	                    angle = "0deg"; // Edge
	                }
	                if (angle) {
	                    angle = parseAngle(angle);
	                    read(tok_comma);
	                }
	                else {
	                    to1 = read(tok_keyword);
	                    if (to1 == "to") {
	                        to1 = read(tok_keyword);
	                    } else if (to1 && /^-/.test(propName)) {
	                        reverse = true;
	                    }
	                    to2 = read(tok_keyword);
	                    read(tok_comma);
	                }
	
	                if (/-moz-/.test(propName) && angle == null && to1 == null) {
	                    var x = read(tok_percent), y = read(tok_percent);
	                    reverse = true;
	                    if (x == "0%") {
	                        to1 = "left";
	                    } else if (x == "100%") {
	                        to1 = "right";
	                    }
	                    if (y == "0%") {
	                        to2 = "top";
	                    } else if (y == "100%") {
	                        to2 = "bottom";
	                    }
	                    read(tok_comma);
	                }
	
	                // 2. color stops
	                while (input && !read(tok_pclose)) {
	                    var stop = read_stop();
	                    if (!stop) {
	                        break;
	                    }
	                    stops.push(stop);
	                    read(tok_comma);
	                }
	
	                return {
	                    type    : "linear",
	                    angle   : angle,
	                    to      : to1 && to2 ? to1 + " " + to2 : to1 ? to1 : to2 ? to2 : null,
	                    stops   : stops,
	                    reverse : reverse
	                };
	            }
	        }
	
	        function read_url() {
	            if (read(tok_popen)) {
	                var url = read(tok_content);
	                url = url.replace(/^['"]+|["']+$/g, "");
	                read(tok_pclose);
	                return { type: "url", url: url };
	            }
	        }
	
	        var tok;
	
	        if ((tok = read(tok_linear_gradient))) {
	            tok = read_linear_gradient(tok);
	        }
	        else if ((tok = read(tok_url))) {
	            tok = read_url();
	        }
	
	        return (cache1[orig] = tok || { type: "none" });
	    }
	
	    return function(input) {
	        if (hasOwnProperty$2(cache2, input)) {
	            return cache2[input];
	        }
	        return (cache2[input] = splitProperty(input).map(parse));
	    };
	})();
	
	var splitProperty = (function(){
	    var cache = {};
	    return function(input, separator) {
	        if (!separator) {
	            separator = /^\s*,\s*/;
	        }
	
	        var cacheKey = input + separator;
	
	        if (hasOwnProperty$2(cache, cacheKey)) {
	            return cache[cacheKey];
	        }
	
	        var ret = [];
	        var last$$1 = 0, pos = 0;
	        var in_paren = 0;
	        var in_string = false;
	        var m;
	
	        function looking_at(rx) {
	            return (m = rx.exec(input.substr(pos)));
	        }
	
	        function trim(str) {
	            return str.replace(/^\s+|\s+$/g, "");
	        }
	
	        while (pos < input.length) {
	            if (!in_string && looking_at(/^[\(\[\{]/)) {
	                in_paren++;
	                pos++;
	            }
	            else if (!in_string && looking_at(/^[\)\]\}]/)) {
	                in_paren--;
	                pos++;
	            }
	            else if (!in_string && looking_at(/^[\"\']/)) {
	                in_string = m[0];
	                pos++;
	            }
	            else if (in_string == "'" && looking_at(/^\\\'/)) {
	                pos += 2;
	            }
	            else if (in_string == '"' && looking_at(/^\\\"/)) {
	                pos += 2;
	            }
	            else if (in_string == "'" && looking_at(/^\'/)) {
	                in_string = false;
	                pos++;
	            }
	            else if (in_string == '"' && looking_at(/^\"/)) {
	                in_string = false;
	                pos++;
	            }
	            else if (looking_at(separator)) {
	                if (!in_string && !in_paren && pos > last$$1) {
	                    ret.push(trim(input.substring(last$$1, pos)));
	                    last$$1 = pos + m[0].length;
	                }
	                pos += m[0].length;
	            }
	            else {
	                pos++;
	            }
	        }
	        if (last$$1 < pos) {
	            ret.push(trim(input.substring(last$$1, pos)));
	        }
	        return (cache[cacheKey] = ret);
	    };
	})();
	
	var getFontURL$1 = (function(cache){
	    return function(el){
	        // XXX: for IE we get here the whole cssText of the rule,
	        // because the computedStyle.src is empty.  Next time we need
	        // to fix these regexps we better write a CSS parser. :-\
	        var url = cache[el];
	        if (!url) {
	            var m;
	            if ((m = /url\((['"]?)([^'")]*?)\1\)\s+format\((['"]?)truetype\3\)/.exec(el))) {
	                url = cache[el] = m[2];
	            } else if ((m = /url\((['"]?)([^'")]*?\.ttf)\1\)/.exec(el))) {
	                url = cache[el] = m[2];
	            }
	        }
	        return url;
	    };
	})(Object.create(null));
	
	var getFontHeight = (function(cache){
	    return function(font) {
	        var height = cache[font];
	        if (height == null) {
	            height = cache[font] = measureText("Mapq", { font: font }).height;
	        }
	        return height;
	    };
	})(Object.create(null));
	
	function getFontFaces(doc) {
	    if (doc == null) {
	        doc = document;
	    }
	    var result = {};
	    for (var i = 0; i < doc.styleSheets.length; ++i) {
	        doStylesheet(doc.styleSheets[i]);
	    }
	    return result;
	    function doStylesheet(ss) {
	        if (ss) {
	            var rules = null;
	            try {
	                rules = ss.cssRules;
	            } catch (ex) {}
	            if (rules) {
	                addRules(ss, rules);
	            }
	        }
	    }
	    function findFonts(rule) {
	        var src = getPropertyValue(rule.style, "src");
	        if (src) {
	            return splitProperty(src).reduce(function(a, el){
	                var font = getFontURL$1(el);
	                if (font) {
	                    a.push(font);
	                }
	                return a;
	            }, []);
	        } else {
	            // Internet Explorer
	            // XXX: this is gross.  should work though for valid CSS.
	            var font = getFontURL$1(rule.cssText);
	            return font ? [ font ] : [];
	        }
	    }
	    function addRules(styleSheet, rules) {
	        for (var i = 0; i < rules.length; ++i) {
	            var r = rules[i];
	            switch (r.type) {
	              case 3:       // CSSImportRule
	                doStylesheet(r.styleSheet);
	                break;
	              case 5:       // CSSFontFaceRule
	                var style  = r.style;
	                var family = splitProperty(getPropertyValue(style, "font-family"));
	                var bold   = /^([56789]00|bold)$/i.test(getPropertyValue(style, "font-weight"));
	                var italic = "italic" == getPropertyValue(style, "font-style");
	                var src    = findFonts(r);
	                if (src.length > 0) {
	                    addRule(styleSheet, family, bold, italic, src[0]);
	                }
	            }
	        }
	    }
	    function addRule(styleSheet, names, bold, italic, url) {
	        // We get full resolved absolute URLs in Chrome, but sadly
	        // not in Firefox.
	        if (!(/^data:/i.test(url))) {
	            if (!(/^[^\/:]+:\/\//.test(url) || /^\//.test(url))) {
	                url = String(styleSheet.href).replace(/[^\/]*$/, "") + url;
	            }
	        }
	        names.forEach(function(name){
	            name = name.replace(/^(['"]?)(.*?)\1$/, "$2"); // it's quoted
	            if (bold) {
	                name += "|bold";
	            }
	            if (italic) {
	                name += "|italic";
	            }
	            result[name] = url;
	        });
	    }
	}
	
	function hasOwnProperty$2(obj, key) {
	    return Object.prototype.hasOwnProperty.call(obj, key);
	}
	
	function getCounter(name) {
	    name = "_counter_" + name;
	    return nodeInfo[name];
	}
	
	function getAllCounters(name) {
	    var values = [], p = nodeInfo;
	    name = "_counter_" + name;
	    while (p) {
	        if (hasOwnProperty$2(p, name)) {
	            values.push(p[name]);
	        }
	        p = Object.getPrototypeOf(p);
	    }
	    return values.reverse();
	}
	
	function incCounter(name, inc) {
	    var p = nodeInfo;
	    name = "_counter_" + name;
	    while (p && !hasOwnProperty$2(p, name)) {
	        p = Object.getPrototypeOf(p);
	    }
	    if (!p) {
	        p = nodeInfo._root;
	    }
	    p[name] = (p[name] || 0) + (inc == null ? 1 : inc);
	}
	
	function resetCounter(name, val) {
	    name = "_counter_" + name;
	    nodeInfo[name] = val == null ? 0 : val;
	}
	
	function doCounters(a, f, def) {
	    for (var i = 0; i < a.length;) {
	        var name = a[i++];
	        var val = parseFloat(a[i]);
	        if (isNaN(val)) {
	            f(name, def);
	        } else {
	            f(name, val);
	            ++i;
	        }
	    }
	}
	
	function updateCounters(style) {
	    var counterReset = getPropertyValue(style, "counter-reset");
	    if (counterReset) {
	        doCounters(splitProperty(counterReset, /^\s+/), resetCounter, 0);
	    }
	    var counterIncrement = getPropertyValue(style, "counter-increment");
	    if (counterIncrement) {
	        doCounters(splitProperty(counterIncrement, /^\s+/), incCounter, 1);
	    }
	}
	
	function parseColor$2(str, css) {
	    var color = parseColor(str, true);
	    if (color) {
	        color = color.toRGB();
	        if (css) {
	            color = color.toCssRgba();
	        } else if (color.a === 0) {
	            color = null;
	        }
	    }
	    return color;
	}
	
	function whenImagesAreActuallyLoaded(elements, callback) {
	    var pending = 0;
	    var done = false;
	    elements.forEach(function(el){
	        var images = el.querySelectorAll("img");
	        for (var i = 0; i < images.length; ++i) {
	            var img = images[i];
	            if (!img.complete) {
	                pending++;
	                img.onload = img.onerror = next;
	            }
	        }
	    });
	
	    if (!pending) {
	        next();
	    }
	
	    function next() {
	        if (!done && --pending <= 0) {
	            callback();
	            done = true;
	        }
	    }
	}
	
	function cacheImages(elements, callback) {
	    var urls = [];
	    function add(url) {
	        if (!IMAGE_CACHE$1[url]) {
	            IMAGE_CACHE$1[url] = true;
	            urls.push(url);
	        }
	    }
	
	    elements.forEach(function dive(element){
	        if (/^img$/i.test(element.tagName)) {
	            add(element.src);
	        }
	        parseBackgroundImage(
	            getPropertyValue(
	                getComputedStyle$1(element), "background-image"
	            )
	        ).forEach(function(bg){
	            if (bg.type == "url") {
	                add(bg.url);
	            }
	        });
	
	        if (element.children) {
	            slice$1$1(element.children).forEach(dive);
	        }
	    });
	
	    var count = urls.length;
	    function next() {
	        if (--count <= 0) {
	            // Even though we cached them, they simply won't be available immediately in the newly
	            // created DOM.  Previously we'd allow a 10ms timeout, but that's arbitrary and clearly
	            // not working in all cases (https://github.com/telerik/kendo/issues/5399), so this
	            // function will wait for their .complete attribute.
	            whenImagesAreActuallyLoaded(elements, callback);
	        }
	    }
	    if (count === 0) {
	        next();
	    }
	    urls.forEach(function(url){
	        var img = IMAGE_CACHE$1[url] = new window.Image();
	        if (!(/^data:/i.test(url))) {
	            img.crossOrigin = "Anonymous";
	        }
	        img.src = url;
	        if (img.complete) {
	            next();
	        } else {
	            img.onload = next;
	            img.onerror = function() {
	                IMAGE_CACHE$1[url] = null;
	                next();
	            };
	        }
	    });
	}
	
	function alphaNumeral(n) {
	    var result = "";
	    do {
	        var r = n % 26;
	        result = String.fromCharCode(97 + r) + result;
	        n = Math.floor(n / 26);
	    } while (n > 0);
	    return result;
	}
	
	function pushNodeInfo(element, style, group) {
	    nodeInfo = Object.create(nodeInfo);
	    nodeInfo[element.tagName.toLowerCase()] = {
	        element: element,
	        style: style
	    };
	    var decoration = getPropertyValue(style, "text-decoration");
	    if (decoration && decoration != "none") {
	        var color = getPropertyValue(style, "text-decoration-color");
	        decoration.split(/\s+/g).forEach(function(name){
	            if (!nodeInfo[name]) {
	                nodeInfo[name] = color;
	                if (name == "underline") {
	                    var offset = getPropertyValue(style, "text-underline-offset");
	                    if (offset != "auto") {
	                        nodeInfo["underline-offset"] = parseFloat(offset);
	                    }
	                }
	            }
	        });
	    }
	
	    if (createsStackingContext(style)) {
	        nodeInfo._stackingContext = {
	            element: element,
	            group: group
	        };
	    }
	}
	
	function popNodeInfo() {
	    nodeInfo = Object.getPrototypeOf(nodeInfo);
	}
	
	function updateClipbox(path) {
	    if (nodeInfo._clipbox != null) {
	        var box = path.bbox(nodeInfo._matrix);
	        if (nodeInfo._clipbox) {
	            nodeInfo._clipbox = Rect.intersect(nodeInfo._clipbox, box);
	        } else {
	            nodeInfo._clipbox = box;
	        }
	    }
	}
	
	function emptyClipbox() {
	    var cb = nodeInfo._clipbox;
	    if (cb == null) {
	        return true;
	    }
	    if (cb) {
	        return cb.width() === 0 || cb.height() === 0;
	    }
	}
	
	function createsStackingContext(style) {
	    function prop(name) { return getPropertyValue(style, name); }
	    if (prop("transform") != "none" ||
	        prop("position") != "static" ||
	        prop("z-index") != "auto" ||
	        prop("opacity") < 1) {
	        return true;
	    }
	}
	
	function getComputedStyle$1(element, pseudoElt) {
	    return window.getComputedStyle(element, pseudoElt || null);
	}
	
	function getPropertyValue(style, prop, defa) {
	    var val = style.getPropertyValue(prop);
	    if (val == null || val === "") {
	        if (browser$3.webkit) {
	            val = style.getPropertyValue("-webkit-" + prop );
	        } else if (browser$3.mozilla) {
	            val = style.getPropertyValue("-moz-" + prop );
	        } else if (browser$3.opera) {
	            val = style.getPropertyValue("-o-" + prop);
	        } else if (microsoft) {
	            val = style.getPropertyValue("-ms-" + prop);
	        }
	    }
	    if (arguments.length > 2 && (val == null || val === "")) {
	        return defa;
	    } else {
	        return val;
	    }
	}
	
	function pleaseSetPropertyValue(style, prop, value, important) {
	    style.setProperty(prop, value, important);
	    if (browser$3.webkit) {
	        style.setProperty("-webkit-" + prop, value, important);
	    } else if (browser$3.mozilla) {
	        style.setProperty("-moz-" + prop, value, important);
	    } else if (browser$3.opera) {
	        style.setProperty("-o-" + prop, value, important);
	    } else if (microsoft) {
	        style.setProperty("-ms-" + prop, value, important);
	        prop = "ms" + prop.replace(/(^|-)([a-z])/g, function(s, p1, p2){
	            return p1 + p2.toUpperCase();
	        });
	        style[prop] = value;
	    }
	}
	
	function getBorder(style, side) {
	    side = "border-" + side;
	    return {
	        width: parseFloat(getPropertyValue(style, side + "-width")),
	        style: getPropertyValue(style, side + "-style"),
	        color: parseColor$2(getPropertyValue(style, side + "-color"), true)
	    };
	}
	
	function saveStyle(element, func) {
	    var prev = element.style.cssText;
	    var result = func();
	    element.style.cssText = prev;
	    return result;
	}
	
	function getBorderRadius(style, side) {
	    var r = getPropertyValue(style, "border-" + side + "-radius").split(/\s+/g).map(parseFloat);
	    if (r.length == 1) {
	        r.push(r[0]);
	    }
	    return sanitizeRadius({ x: r[0], y: r[1] });
	}
	
	function getContentBox(element) {
	    var box = element.getBoundingClientRect();
	    box = innerBox(box, "border-*-width", element);
	    box = innerBox(box, "padding-*", element);
	    return box;
	}
	
	function innerBox(box, prop, element) {
	    var style, wt, wr, wb, wl;
	    if (typeof prop == "string") {
	        style = getComputedStyle$1(element);
	        wt = parseFloat(getPropertyValue(style, prop.replace("*", "top")));
	        wr = parseFloat(getPropertyValue(style, prop.replace("*", "right")));
	        wb = parseFloat(getPropertyValue(style, prop.replace("*", "bottom")));
	        wl = parseFloat(getPropertyValue(style, prop.replace("*", "left")));
	    }
	    else if (typeof prop == "number") {
	        wt = wr = wb = wl = prop;
	    }
	    return {
	        top    : box.top + wt,
	        right  : box.right - wr,
	        bottom : box.bottom - wb,
	        left   : box.left + wl,
	        width  : box.right - box.left - wr - wl,
	        height : box.bottom - box.top - wb - wt
	    };
	}
	
	function getTransform(style) {
	    var transform$$1 = getPropertyValue(style, "transform");
	    if (transform$$1 == "none") {
	        return null;
	    }
	    var matrix = /^\s*matrix\(\s*(.*?)\s*\)\s*$/.exec(transform$$1);
	    if (matrix) {
	        var origin = getPropertyValue(style, "transform-origin");
	        matrix = matrix[1].split(/\s*,\s*/g).map(parseFloat);
	        origin = origin.split(/\s+/g).map(parseFloat);
	        return {
	            matrix: matrix,
	            origin: origin
	        };
	    }
	}
	
	function radiansToDegrees(radians) {
	    return ((180 * radians) / Math.PI) % 360;
	}
	
	function parseAngle(angle) {
	    var num = parseFloat(angle);
	    if (/grad$/.test(angle)) {
	        return Math.PI * num / 200;
	    }
	    else if (/rad$/.test(angle)) {
	        return num;
	    }
	    else if (/turn$/.test(angle)) {
	        return Math.PI * num * 2;
	    }
	    else if (/deg$/.test(angle)) {
	        return Math.PI * num / 180;
	    }
	}
	
	function setTransform$1(shape, m) {
	    m = new Matrix(m[0], m[1], m[2], m[3], m[4], m[5]);
	    shape.transform(m);
	    return m;
	}
	
	function setClipping$1(shape, clipPath) {
	    shape.clip(clipPath);
	}
	
	function addArcToPath(path, x, y, options) {
	    var points = new Arc$2([ x, y ], options).curvePoints(), i = 1;
	    while (i < points.length) {
	        path.curveTo(points[i++], points[i++], points[i++]);
	    }
	}
	
	function sanitizeRadius(r) {
	    if (r.x <= 0 || r.y <= 0) {
	        r.x = r.y = 0;
	    }
	    return r;
	}
	
	function adjustBorderRadiusForBox(box, rTL, rTR, rBR, rBL) {
	    // adjust border radiuses such that the sum of adjacent
	    // radiuses is not bigger than the length of the side.
	    // seems the correct algorithm is variant (3) from here:
	    // http://www.w3.org/Style/CSS/Tracker/issues/29?changelog
	    var tl_x = Math.max(0, rTL.x), tl_y = Math.max(0, rTL.y);
	    var tr_x = Math.max(0, rTR.x), tr_y = Math.max(0, rTR.y);
	    var br_x = Math.max(0, rBR.x), br_y = Math.max(0, rBR.y);
	    var bl_x = Math.max(0, rBL.x), bl_y = Math.max(0, rBL.y);
	
	    var f = Math.min(
	        box.width / (tl_x + tr_x),
	        box.height / (tr_y + br_y),
	        box.width / (br_x + bl_x),
	        box.height / (bl_y + tl_y)
	    );
	
	    if (f < 1) {
	        tl_x *= f; tl_y *= f;
	        tr_x *= f; tr_y *= f;
	        br_x *= f; br_y *= f;
	        bl_x *= f; bl_y *= f;
	    }
	
	    return {
	        tl: { x: tl_x, y: tl_y },
	        tr: { x: tr_x, y: tr_y },
	        br: { x: br_x, y: br_y },
	        bl: { x: bl_x, y: bl_y }
	    };
	}
	
	function elementRoundBox(element, box, type) {
	    var style = getComputedStyle$1(element);
	
	    var rTL = getBorderRadius(style, "top-left");
	    var rTR = getBorderRadius(style, "top-right");
	    var rBL = getBorderRadius(style, "bottom-left");
	    var rBR = getBorderRadius(style, "bottom-right");
	
	    if (type == "padding" || type == "content") {
	        var bt = getBorder(style, "top");
	        var br = getBorder(style, "right");
	        var bb = getBorder(style, "bottom");
	        var bl = getBorder(style, "left");
	        rTL.x -= bl.width; rTL.y -= bt.width;
	        rTR.x -= br.width; rTR.y -= bt.width;
	        rBR.x -= br.width; rBR.y -= bb.width;
	        rBL.x -= bl.width; rBL.y -= bb.width;
	        if (type == "content") {
	            var pt = parseFloat(getPropertyValue(style, "padding-top"));
	            var pr = parseFloat(getPropertyValue(style, "padding-right"));
	            var pb = parseFloat(getPropertyValue(style, "padding-bottom"));
	            var pl = parseFloat(getPropertyValue(style, "padding-left"));
	            rTL.x -= pl; rTL.y -= pt;
	            rTR.x -= pr; rTR.y -= pt;
	            rBR.x -= pr; rBR.y -= pb;
	            rBL.x -= pl; rBL.y -= pb;
	        }
	    }
	
	    if (typeof type == "number") {
	        rTL.x -= type; rTL.y -= type;
	        rTR.x -= type; rTR.y -= type;
	        rBR.x -= type; rBR.y -= type;
	        rBL.x -= type; rBL.y -= type;
	    }
	
	    return roundBox(box, rTL, rTR, rBR, rBL);
	}
	
	// Create a drawing.Path for a rounded rectangle.  Receives the
	// bounding box and the border-radiuses in CSS order (top-left,
	// top-right, bottom-right, bottom-left).  The radiuses must be
	// objects containing x (horiz. radius) and y (vertical radius).
	function roundBox(box, rTL0, rTR0, rBR0, rBL0) {
	    var tmp = adjustBorderRadiusForBox(box, rTL0, rTR0, rBR0, rBL0);
	    var rTL = tmp.tl;
	    var rTR = tmp.tr;
	    var rBR = tmp.br;
	    var rBL = tmp.bl;
	    var path = new Path({ fill: null, stroke: null });
	    path.moveTo(box.left, box.top + rTL.y);
	    if (rTL.x) {
	        addArcToPath(path, box.left + rTL.x, box.top + rTL.y, {
	            startAngle: -180,
	            endAngle: -90,
	            radiusX: rTL.x,
	            radiusY: rTL.y
	        });
	    }
	    path.lineTo(box.right - rTR.x, box.top);
	    if (rTR.x) {
	        addArcToPath(path, box.right - rTR.x, box.top + rTR.y, {
	            startAngle: -90,
	            endAngle: 0,
	            radiusX: rTR.x,
	            radiusY: rTR.y
	        });
	    }
	    path.lineTo(box.right, box.bottom - rBR.y);
	    if (rBR.x) {
	        addArcToPath(path, box.right - rBR.x, box.bottom - rBR.y, {
	            startAngle: 0,
	            endAngle: 90,
	            radiusX: rBR.x,
	            radiusY: rBR.y
	        });
	    }
	    path.lineTo(box.left + rBL.x, box.bottom);
	    if (rBL.x) {
	        addArcToPath(path, box.left + rBL.x, box.bottom - rBL.y, {
	            startAngle: 90,
	            endAngle: 180,
	            radiusX: rBL.x,
	            radiusY: rBL.y
	        });
	    }
	    return path.close();
	}
	
	function formatCounter(val, style) {
	    var str = String(parseFloat(val));
	    switch (style) {
	      case "decimal-leading-zero":
	        if (str.length < 2) {
	            str = "0" + str;
	        }
	        return str;
	      case "lower-roman":
	        return arabicToRoman(val).toLowerCase();
	      case "upper-roman":
	        return arabicToRoman(val).toUpperCase();
	      case "lower-latin":
	      case "lower-alpha":
	        return alphaNumeral(val - 1);
	      case "upper-latin":
	      case "upper-alpha":
	        return alphaNumeral(val - 1).toUpperCase();
	      default:
	        return str;
	    }
	}
	
	function evalPseudoElementContent(element, content) {
	    function displayCounter(name, style, separator) {
	        if (!separator) {
	            return formatCounter(getCounter(name) || 0, style);
	        }
	        separator = separator.replace(/^\s*(["'])(.*)\1\s*$/, "$2");
	        return getAllCounters(name).map(function(val){
	            return formatCounter(val, style);
	        }).join(separator);
	    }
	    var a = splitProperty(content, /^\s+/);
	    var result = [], m;
	    a.forEach(function(el){
	        var tmp;
	        if ((m = /^\s*(["'])(.*)\1\s*$/.exec(el))) {
	            result.push(m[2].replace(/\\([0-9a-f]{4})/gi, function(s, p){
	                return String.fromCharCode(parseInt(p, 16));
	            }));
	        }
	        else if ((m = /^\s*counter\((.*?)\)\s*$/.exec(el))) {
	            tmp = splitProperty(m[1]);
	            result.push(displayCounter(tmp[0], tmp[1]));
	        }
	        else if ((m = /^\s*counters\((.*?)\)\s*$/.exec(el))) {
	            tmp = splitProperty(m[1]);
	            result.push(displayCounter(tmp[0], tmp[2], tmp[1]));
	        }
	        else if ((m = /^\s*attr\((.*?)\)\s*$/.exec(el))) {
	            result.push(element.getAttribute(m[1]) || "");
	        }
	        else {
	            result.push(el);
	        }
	    });
	    return result.join("");
	}
	
	function getCssText(style) {
	    if (style.cssText) {
	        return style.cssText;
	    }
	    // Status: NEW.  Report year: 2002.  Current year: 2014.
	    // Nice played, Mozillians.
	    // https://bugzilla.mozilla.org/show_bug.cgi?id=137687
	    var result = [];
	    for (var i = 0; i < style.length; ++i) {
	        result.push(style[i] + ": " + getPropertyValue(style, style[i]));
	    }
	    return result.join(";\n");
	}
	
	function _renderWithPseudoElements(element, group) {
	    if (element.tagName == KENDO_PSEUDO_ELEMENT) {
	        _renderElement(element, group);
	        return;
	    }
	    var fake = [];
	    function pseudo(kind, place) {
	        var style = getComputedStyle$1(element, kind), content = style.content;
	        updateCounters(style);
	        if (content && content != "normal" && content != "none" && style.width != "0px") {
	            var psel = element.ownerDocument.createElement(KENDO_PSEUDO_ELEMENT);
	            psel.style.cssText = getCssText(style);
	            psel.textContent = evalPseudoElementContent(element, content);
	            element.insertBefore(psel, place);
	            fake.push(psel);
	        }
	    }
	    pseudo(":before", element.firstChild);
	    pseudo(":after", null);
	    if (fake.length > 0) {
	        var saveClass = element.className;
	        element.className += " kendo-pdf-hide-pseudo-elements";
	        _renderElement(element, group);
	        element.className = saveClass;
	        fake.forEach(function(el){ element.removeChild(el); });
	    } else {
	        _renderElement(element, group);
	    }
	}
	
	function _renderElement(element, group) {
	    var style = getComputedStyle$1(element);
	
	    var top = getBorder(style, "top");
	    var right = getBorder(style, "right");
	    var bottom = getBorder(style, "bottom");
	    var left = getBorder(style, "left");
	
	    var rTL0 = getBorderRadius(style, "top-left");
	    var rTR0 = getBorderRadius(style, "top-right");
	    var rBL0 = getBorderRadius(style, "bottom-left");
	    var rBR0 = getBorderRadius(style, "bottom-right");
	
	    var dir = getPropertyValue(style, "direction");
	
	    var backgroundColor = getPropertyValue(style, "background-color");
	    backgroundColor = parseColor$2(backgroundColor);
	
	    var backgroundImage = parseBackgroundImage( getPropertyValue(style, "background-image") );
	    var backgroundRepeat = splitProperty( getPropertyValue(style, "background-repeat") );
	    var backgroundPosition = splitProperty( getPropertyValue(style, "background-position") );
	    var backgroundOrigin = splitProperty( getPropertyValue(style, "background-origin") );
	    var backgroundSize = splitProperty( getPropertyValue(style, "background-size") );
	
	    // IE shrinks the text with text-overflow: ellipsis,
	    // apparently because the returned bounding box for the range
	    // is limited to the visible area minus space for the dots,
	    // instead of being the full width of the text.
	    //
	    // https://github.com/telerik/kendo/issues/5232
	    // https://github.com/telerik/kendo-ui-core/issues/1868
	    //
	    // We have to test it here rather than in renderText because
	    // text-overflow: ellipsis could be set on a parent element (not
	    // necessarily the one containing the text); in this case,
	    // getComputedStyle(elementWithTheText) will return "clip", not
	    // "ellipsis" (which is probably a bug, but oh well...)
	    var textOverflow, saveTextOverflow;
	    if (microsoft) {
	        textOverflow = style.textOverflow;             // computed style
	        if (textOverflow == "ellipsis") {
	            saveTextOverflow = element.style.textOverflow; // own style.
	            element.style.textOverflow = "clip";
	        }
	    }
	
	    if (browser$3.msie && browser$3.version < 10) {
	        // IE9 hacks.  getPropertyValue won't return the correct
	        // value.  Sucks that we have to do it here, I'd prefer to
	        // move it in getPropertyValue, but we don't have the
	        // element.
	        backgroundPosition = splitProperty(element.currentStyle.backgroundPosition);
	    }
	
	    var innerbox = innerBox(element.getBoundingClientRect(), "border-*-width", element);
	
	    // CSS "clip" property - if present, replace the group with a
	    // new one which is clipped.  This must happen before drawing
	    // the borders and background.
	    (function(){
	        var clip = getPropertyValue(style, "clip");
	        var m = /^\s*rect\((.*)\)\s*$/.exec(clip);
	        if (m) {
	            var a = m[1].split(/[ ,]+/g);
	            var top = a[0] == "auto" ? innerbox.top : parseFloat(a[0]) + innerbox.top;
	            var right = a[1] == "auto" ? innerbox.right : parseFloat(a[1]) + innerbox.left;
	            var bottom = a[2] == "auto" ? innerbox.bottom : parseFloat(a[2]) + innerbox.top;
	            var left = a[3] == "auto" ? innerbox.left : parseFloat(a[3]) + innerbox.left;
	            var tmp = new Group();
	            var clipPath = new Path()
	                .moveTo(left, top)
	                .lineTo(right, top)
	                .lineTo(right, bottom)
	                .lineTo(left, bottom)
	                .close();
	            setClipping$1(tmp, clipPath);
	            group.append(tmp);
	            group = tmp;
	            updateClipbox(clipPath);
	        }
	    })();
	
	    var boxes, i, cells;
	    var display = getPropertyValue(style, "display");
	
	    if (display == "table-row") {
	        // because of rowspan/colspan, we shouldn't draw background of table row elements on the
	        // box given by its getBoundingClientRect, because if we do we risk overwritting a
	        // previously rendered cell.  https://github.com/telerik/kendo/issues/4881
	        boxes = [];
	        for (i = 0, cells = element.children; i < cells.length; ++i) {
	            boxes.push(cells[i].getBoundingClientRect());
	        }
	    } else {
	        boxes = element.getClientRects();
	        if (boxes.length == 1) {
	            // Workaround the missing borders in Chrome!  getClientRects() boxes contains values
	            // rounded to integer.  getBoundingClientRect() appears to work fine.  We still need
	            // getClientRects() to support cases where there are more boxes (continued inline
	            // elements that might have border/background).
	            boxes = [ element.getBoundingClientRect() ];
	        }
	    }
	
	    // This function workarounds another Chrome bug, where boxes returned for a table with
	    // border-collapse: collapse will overlap the table border.  Our rendering is not perfect in
	    // such case anyway, but with this is better than without it.
	    boxes = adjustBoxes(boxes);
	
	    for (i = 0; i < boxes.length; ++i) {
	        drawOneBox(boxes[i], i === 0, i == boxes.length - 1);
	    }
	
	    // Render links as separate groups.  We can't use boxes returned by element's getClientRects
	    // because if display type is "inline" (default for <a>), boxes will not include the height of
	    // images inside.  https://github.com/telerik/kendo-ui-core/issues/3359
	    if (element.tagName == "A" && element.href && !/^#?$/.test(element.getAttribute("href"))) {
	        if (!nodeInfo._avoidLinks || !matches(element, nodeInfo._avoidLinks)) {
	            var r = document.createRange();
	            r.selectNodeContents(element);
	            slice$1$1(r.getClientRects()).forEach(function(box){
	                var g = new Group();
	                g._pdfLink = {
	                    url    : element.href,
	                    top    : box.top,
	                    right  : box.right,
	                    bottom : box.bottom,
	                    left   : box.left
	                };
	                group.append(g);
	            });
	        }
	    }
	
	    if (boxes.length > 0 && display == "list-item" && !element.getAttribute("kendo-no-bullet")) {
	        drawBullet(boxes[0]);
	    }
	
	    // overflow: hidden/auto - if present, replace the group with
	    // a new one clipped by the inner box.
	    (function(){
	        function clipit() {
	            var clipPath = elementRoundBox(element, innerbox, "padding");
	            var tmp = new Group();
	            setClipping$1(tmp, clipPath);
	            group.append(tmp);
	            group = tmp;
	            updateClipbox(clipPath);
	        }
	        if (isFormField(element)) {
	            clipit();
	        } else if (/^(hidden|auto|scroll)/.test(getPropertyValue(style, "overflow"))) {
	            clipit();
	        } else if (/^(hidden|auto|scroll)/.test(getPropertyValue(style, "overflow-x"))) {
	            clipit();
	        } else if (/^(hidden|auto|scroll)/.test(getPropertyValue(style, "overflow-y"))) {
	            clipit();
	        }
	    })();
	
	    if (!maybeRenderWidget(element, group) && !maybeRenderBullet(element, group)) {
	        renderContents(element, group);
	    }
	
	    if (microsoft && textOverflow == "ellipsis") {
	        element.style.textOverflow = saveTextOverflow;
	    }
	
	    return group; // only utility functions after this line.
	
	    function adjustBoxes(boxes) {
	        if (/^td$/i.test(element.tagName)) {
	            var table = nodeInfo.table;
	            if (table && getPropertyValue(table.style, "border-collapse") == "collapse") {
	                var tableBorderLeft = getBorder(table.style, "left").width;
	                var tableBorderTop = getBorder(table.style, "top").width;
	                // check if we need to adjust
	                if (tableBorderLeft === 0 && tableBorderTop === 0) {
	                    return boxes; // nope
	                }
	                var tableBox = table.element.getBoundingClientRect();
	                var firstCell = table.element.rows[0].cells[0];
	                var firstCellBox = firstCell.getBoundingClientRect();
	                if (firstCellBox.top == tableBox.top || firstCellBox.left == tableBox.left) {
	                    return slice$1$1(boxes).map(function(box){
	                        return {
	                            left   : box.left + tableBorderLeft,
	                            top    : box.top + tableBorderTop,
	                            right  : box.right + tableBorderLeft,
	                            bottom : box.bottom + tableBorderTop,
	                            height : box.height,
	                            width  : box.width
	                        };
	                    });
	                }
	            }
	        }
	        return boxes;
	    }
	
	    // this function will be called to draw each border.  it
	    // draws starting at origin and the resulted path must be
	    // translated/rotated to be placed in the proper position.
	    //
	    // arguments are named as if it draws the top border:
	    //
	    //    - `len` the length of the edge
	    //    - `Wtop` the width of the edge (i.e. border-top-width)
	    //    - `Wleft` the width of the left edge (border-left-width)
	    //    - `Wright` the width of the right edge
	    //    - `rl` and `rl` -- the border radius on the left and right
	    //      (objects containing x and y, for horiz/vertical radius)
	    //    - `transform` -- transformation to apply
	    //
	    function drawEdge(color, len, Wtop, Wleft, Wright, rl, rr, transform$$1) {
	        if (Wtop <= 0) {
	            return;
	        }
	
	        var path, edge = new Group();
	        setTransform$1(edge, transform$$1);
	        group.append(edge);
	
	        sanitizeRadius(rl);
	        sanitizeRadius(rr);
	
	        // draw main border.  this is the area without the rounded corners
	        path = new Path({
	            fill: { color: color },
	            stroke: null
	        });
	        edge.append(path);
	        path.moveTo(rl.x ? Math.max(rl.x, Wleft) : 0, 0)
	            .lineTo(len - (rr.x ? Math.max(rr.x, Wright) : 0), 0)
	            .lineTo(len - Math.max(rr.x, Wright), Wtop)
	            .lineTo(Math.max(rl.x, Wleft), Wtop)
	            .close();
	
	        if (rl.x) {
	            drawRoundCorner(Wleft, rl, [ -1, 0, 0, 1, rl.x, 0 ]);
	        }
	
	        if (rr.x) {
	            drawRoundCorner(Wright, rr, [ 1, 0, 0, 1, len - rr.x, 0 ]);
	        }
	
	        // draws one round corner, starting at origin (needs to be
	        // translated/rotated to be placed properly).
	        function drawRoundCorner(Wright, r, transform$$1) {
	            var angle = Math.PI/2 * Wright / (Wright + Wtop);
	
	            // not sanitizing this one, because negative values
	            // are useful to fill the box correctly.
	            var ri = {
	                x: r.x - Wright,
	                y: r.y - Wtop
	            };
	
	            var path = new Path({
	                fill: { color: color },
	                stroke: null
	            }).moveTo(0, 0);
	
	            setTransform$1(path, transform$$1);
	
	            addArcToPath(path, 0, r.y, {
	                startAngle: -90,
	                endAngle: -radiansToDegrees(angle),
	                radiusX: r.x,
	                radiusY: r.y
	            });
	
	            if (ri.x > 0 && ri.y > 0) {
	                path.lineTo(ri.x * Math.cos(angle), r.y - ri.y * Math.sin(angle));
	                addArcToPath(path, 0, r.y, {
	                    startAngle: -radiansToDegrees(angle),
	                    endAngle: -90,
	                    radiusX: ri.x,
	                    radiusY: ri.y,
	                    anticlockwise: true
	                });
	            }
	            else if (ri.x > 0) {
	                path.lineTo(ri.x, Wtop)
	                    .lineTo(0, Wtop);
	            }
	            else {
	                path.lineTo(ri.x, Wtop)
	                    .lineTo(ri.x, 0);
	            }
	
	            edge.append(path.close());
	        }
	    }
	
	    function drawBackground(box) {
	        var background = new Group();
	        setClipping$1(background, roundBox(box, rTL0, rTR0, rBR0, rBL0));
	        group.append(background);
	
	        if (backgroundColor) {
	            var path = new Path({
	                fill: { color: backgroundColor.toCssRgba() },
	                stroke: null
	            });
	            path.moveTo(box.left, box.top)
	                .lineTo(box.right, box.top)
	                .lineTo(box.right, box.bottom)
	                .lineTo(box.left, box.bottom)
	                .close();
	            background.append(path);
	        }
	
	        for (var i = backgroundImage.length; --i >= 0;) {
	            drawOneBackground(
	                background, box,
	                backgroundImage[i],
	                backgroundRepeat[i % backgroundRepeat.length],
	                backgroundPosition[i % backgroundPosition.length],
	                backgroundOrigin[i % backgroundOrigin.length],
	                backgroundSize[i % backgroundSize.length]
	            );
	        }
	    }
	
	    function drawOneBackground(group, box, background, backgroundRepeat, backgroundPosition, backgroundOrigin, backgroundSize) {
	        if (!background || (background == "none")) {
	            return;
	        }
	
	        if (background.type == "url") {
	            var img = IMAGE_CACHE$1[background.url];
	            if (img && img.width > 0 && img.height > 0) {
	                drawBackgroundImage(group, box, img.width, img.height, function(group, rect){
	                    group.append(new Image$1(background.url, rect));
	                });
	            }
	        } else if (background.type == "linear") {
	            drawBackgroundImage(group, box, box.width, box.height, gradientRenderer(background));
	        } else {
	            return;
	        }
	
	        function drawBackgroundImage(group, box, img_width, img_height, renderBG) {
	            var aspect_ratio = img_width / img_height, f;
	
	            // for background-origin: border-box the box is already appropriate
	            var orgBox = box;
	            if (backgroundOrigin == "content-box") {
	                orgBox = innerBox(orgBox, "border-*-width", element);
	                orgBox = innerBox(orgBox, "padding-*", element);
	            } else if (backgroundOrigin == "padding-box") {
	                orgBox = innerBox(orgBox, "border-*-width", element);
	            }
	
	            if (!/^\s*auto(\s+auto)?\s*$/.test(backgroundSize)) {
	                if (backgroundSize == "contain") {
	                    f = Math.min(orgBox.width / img_width,
	                                 orgBox.height / img_height);
	                    img_width *= f;
	                    img_height *= f;
	                }
	                else if (backgroundSize == "cover") {
	                    f = Math.max(orgBox.width / img_width,
	                                 orgBox.height / img_height);
	                    img_width *= f;
	                    img_height *= f;
	                }
	                else {
	                    var size = backgroundSize.split(/\s+/g);
	                    // compute width
	                    if (/%$/.test(size[0])) {
	                        img_width = orgBox.width * parseFloat(size[0]) / 100;
	                    } else {
	                        img_width = parseFloat(size[0]);
	                    }
	                    // compute height
	                    if (size.length == 1 || size[1] == "auto") {
	                        img_height = img_width / aspect_ratio;
	                    } else if (/%$/.test(size[1])) {
	                        img_height = orgBox.height * parseFloat(size[1]) / 100;
	                    } else {
	                        img_height = parseFloat(size[1]);
	                    }
	                }
	            }
	
	            var pos = String(backgroundPosition);
	
	            // IE sometimes reports single-word positions
	            // https://github.com/telerik/kendo-ui-core/issues/2786
	            //
	            // it seems to switch to percentages when the horizontal
	            // position is not "center", therefore we don't handle
	            // multi-word cases here.  All other browsers return
	            // percentages or pixels instead of keywords.  At least
	            // for now...
	            switch (pos) {
	              case "bottom" : pos = "50% 100%"; break;
	              case "top"    : pos = "50% 0"; break;
	              case "left"   : pos = "0 50%"; break;
	              case "right"  : pos = "100% 50%"; break;
	              case "center" : pos = "50% 50%"; break;
	            }
	
	            pos = pos.split(/\s+/);
	            if (pos.length == 1) {
	                pos[1] = "50%";
	            }
	
	            if (/%$/.test(pos[0])) {
	                pos[0] = parseFloat(pos[0]) / 100 * (orgBox.width - img_width);
	            } else {
	                pos[0] = parseFloat(pos[0]);
	            }
	            if (/%$/.test(pos[1])) {
	                pos[1] = parseFloat(pos[1]) / 100 * (orgBox.height - img_height);
	            } else {
	                pos[1] = parseFloat(pos[1]);
	            }
	
	            var rect = new Rect([ orgBox.left + pos[0], orgBox.top + pos[1] ], [ img_width, img_height ]);
	
	            // XXX: background-repeat could be implemented more
	            //      efficiently as a fill pattern (at least for PDF
	            //      output, probably SVG too).
	
	            function rewX() {
	                while (rect.origin.x > box.left) {
	                    rect.origin.x -= img_width;
	                }
	            }
	
	            function rewY() {
	                while (rect.origin.y > box.top) {
	                    rect.origin.y -= img_height;
	                }
	            }
	
	            function repeatX() {
	                while (rect.origin.x < box.right) {
	                    renderBG(group, rect.clone());
	                    rect.origin.x += img_width;
	                }
	            }
	
	            if (backgroundRepeat == "no-repeat") {
	                renderBG(group, rect);
	            }
	            else if (backgroundRepeat == "repeat-x") {
	                rewX();
	                repeatX();
	            }
	            else if (backgroundRepeat == "repeat-y") {
	                rewY();
	                while (rect.origin.y < box.bottom) {
	                    renderBG(group, rect.clone());
	                    rect.origin.y += img_height;
	                }
	            }
	            else if (backgroundRepeat == "repeat") {
	                rewX();
	                rewY();
	                var origin = rect.origin.clone();
	                while (rect.origin.y < box.bottom) {
	                    rect.origin.x = origin.x;
	                    repeatX();
	                    rect.origin.y += img_height;
	                }
	            }
	        }
	    }
	
	    function drawBullet() {
	        var listStyleType = getPropertyValue(style, "list-style-type");
	        if (listStyleType == "none") {
	            return;
	        }
	        var listStylePosition = getPropertyValue(style, "list-style-position");
	
	        function _drawBullet(f) {
	            saveStyle(element, function(){
	                element.style.position = "relative";
	                var bullet = element.ownerDocument.createElement(KENDO_PSEUDO_ELEMENT);
	                bullet.style.position = "absolute";
	                bullet.style.boxSizing = "border-box";
	                if (listStylePosition == "outside") {
	                    bullet.style.width = "6em";
	                    bullet.style.left = "-6.8em";
	                    bullet.style.textAlign = "right";
	                } else {
	                    bullet.style.left = "0px";
	                }
	                f(bullet);
	                element.insertBefore(bullet, element.firstChild);
	                renderElement(bullet, group);
	                element.removeChild(bullet);
	            });
	        }
	
	        function elementIndex(f) {
	            var a = element.parentNode.children;
	            var k = element.getAttribute("kendo-split-index");
	            if (k != null) {
	                return f(k|0, a.length);
	            }
	            for (var i = 0; i < a.length; ++i) {
	                if (a[i] === element) {
	                    return f(i, a.length);
	                }
	            }
	        }
	
	        switch (listStyleType) {
	          case "circle":
	          case "disc":
	          case "square":
	            _drawBullet(function(bullet){
	                bullet.innerHTML = '&nbsp;';
	                bullet.setAttribute(KENDO_BULLET_TYPE, listStyleType);
	            });
	            break;
	
	          case "decimal":
	          case "decimal-leading-zero":
	            _drawBullet(function(bullet){
	                elementIndex(function(idx){
	                    ++idx;
	                    if (listStyleType == "decimal-leading-zero" && idx < 10) {
	                        idx = "0" + idx;
	                    }
	                    bullet.innerHTML = idx + ".";
	                });
	            });
	            break;
	
	          case "lower-roman":
	          case "upper-roman":
	            _drawBullet(function(bullet){
	                elementIndex(function(idx){
	                    idx = arabicToRoman(idx + 1);
	                    if (listStyleType == "upper-roman") {
	                        idx = idx.toUpperCase();
	                    }
	                    bullet.innerHTML = idx + ".";
	                });
	            });
	            break;
	
	          case "lower-latin":
	          case "lower-alpha":
	          case "upper-latin":
	          case "upper-alpha":
	            _drawBullet(function(bullet){
	                elementIndex(function(idx){
	                    idx = alphaNumeral(idx);
	                    if (/^upper/i.test(listStyleType)) {
	                        idx = idx.toUpperCase();
	                    }
	                    bullet.innerHTML = idx + ".";
	                });
	            });
	            break;
	        }
	    }
	
	    // draws a single border box
	    function drawOneBox(box, isFirst, isLast) {
	        if (box.width === 0 || box.height === 0) {
	            return;
	        }
	
	        drawBackground(box);
	
	        var shouldDrawLeft = (left.width > 0 && ((isFirst && dir == "ltr") || (isLast && dir == "rtl")));
	        var shouldDrawRight = (right.width > 0 && ((isLast && dir == "ltr") || (isFirst && dir == "rtl")));
	
	        // The most general case is that the 4 borders have different widths and border
	        // radiuses.  The way that is handled is by drawing 3 Paths for each border: the
	        // straight line, and two round corners which represent half of the entire rounded
	        // corner.  To simplify code those shapes are drawed at origin (by the drawEdge
	        // function), then translated/rotated into the right position.
	        //
	        // However, this leads to poor results due to rounding in the simpler cases where
	        // borders are straight lines.  Therefore we handle a few such cases separately with
	        // straight lines. C^wC^wC^w -- nope, scratch that.  poor rendering was because of a bug
	        // in Chrome (getClientRects() returns rounded integer values rather than exact floats.
	        // web dev is still a ghetto.)
	
	        // first, just in case there is no border...
	        if (top.width === 0 && left.width === 0 && right.width === 0 && bottom.width === 0) {
	            return;
	        }
	
	        // START paint borders
	        // if all borders have equal colors...
	        if (top.color == right.color && top.color == bottom.color && top.color == left.color) {
	
	            // if same widths too, we can draw the whole border by stroking a single path.
	            if (top.width == right.width && top.width == bottom.width && top.width == left.width)
	            {
	                if (shouldDrawLeft && shouldDrawRight) {
	                    // reduce box by half the border width, so we can draw it by stroking.
	                    box = innerBox(box, top.width/2);
	
	                    // adjust the border radiuses, again by top.width/2, and make the path element.
	                    var path = elementRoundBox(element, box, top.width/2);
	                    path.options.stroke = {
	                        color: top.color,
	                        width: top.width
	                    };
	                    group.append(path);
	                    return;
	                }
	            }
	        }
	
	        // if border radiuses are zero and widths are at most one pixel, we can again use simple
	        // paths.
	        if (rTL0.x === 0 && rTR0.x === 0 && rBR0.x === 0 && rBL0.x === 0) {
	            // alright, 1.9px will do as well.  the difference in color blending should not be
	            // noticeable.
	            if (top.width < 2 && left.width < 2 && right.width < 2 && bottom.width < 2) {
	                // top border
	                if (top.width > 0) {
	                    group.append(
	                        new Path({
	                            stroke: { width: top.width, color: top.color }
	                        })
	                            .moveTo(box.left, box.top + top.width/2)
	                            .lineTo(box.right, box.top + top.width/2)
	                    );
	                }
	
	                // bottom border
	                if (bottom.width > 0) {
	                    group.append(
	                        new Path({
	                            stroke: { width: bottom.width, color: bottom.color }
	                        })
	                            .moveTo(box.left, box.bottom - bottom.width/2)
	                            .lineTo(box.right, box.bottom - bottom.width/2)
	                    );
	                }
	
	                // left border
	                if (shouldDrawLeft) {
	                    group.append(
	                        new Path({
	                            stroke: { width: left.width, color: left.color }
	                        })
	                            .moveTo(box.left + left.width/2, box.top)
	                            .lineTo(box.left + left.width/2, box.bottom)
	                    );
	                }
	
	                // right border
	                if (shouldDrawRight) {
	                    group.append(
	                        new Path({
	                            stroke: { width: right.width, color: right.color }
	                        })
	                            .moveTo(box.right - right.width/2, box.top)
	                            .lineTo(box.right - right.width/2, box.bottom)
	                    );
	                }
	
	                return;
	            }
	        }
	        // END paint borders
	
	        var tmp = adjustBorderRadiusForBox(box, rTL0, rTR0, rBR0, rBL0);
	        var rTL = tmp.tl;
	        var rTR = tmp.tr;
	        var rBR = tmp.br;
	        var rBL = tmp.bl;
	
	        // top border
	        drawEdge(top.color,
	                 box.width, top.width, left.width, right.width,
	                 rTL, rTR,
	                 [ 1, 0, 0, 1, box.left, box.top ]);
	
	        // bottom border
	        drawEdge(bottom.color,
	                 box.width, bottom.width, right.width, left.width,
	                 rBR, rBL,
	                 [ -1, 0, 0, -1, box.right, box.bottom ]);
	
	        // for left/right borders we need to invert the border-radiuses
	        function inv(p) {
	            return { x: p.y, y: p.x };
	        }
	
	        // left border
	        drawEdge(left.color,
	                 box.height, left.width, bottom.width, top.width,
	                 inv(rBL), inv(rTL),
	                 [ 0, -1, 1, 0, box.left, box.bottom ]);
	
	        // right border
	        drawEdge(right.color,
	                 box.height, right.width, top.width, bottom.width,
	                 inv(rTR), inv(rBR),
	                 [ 0, 1, -1, 0, box.right, box.top ]);
	    }
	}
	
	function gradientRenderer(gradient) {
	    return function(group, rect) {
	        var width = rect.width(), height = rect.height();
	
	        switch (gradient.type) {
	          case "linear":
	
	            // figure out the angle.
	            var angle = gradient.angle != null ? gradient.angle : Math.PI;
	            switch (gradient.to) {
	              case "top":
	                angle = 0;
	                break;
	              case "left":
	                angle = -Math.PI / 2;
	                break;
	              case "bottom":
	                angle = Math.PI;
	                break;
	              case "right":
	                angle = Math.PI / 2;
	                break;
	              case "top left": case "left top":
	                angle = -Math.atan2(height, width);
	                break;
	              case "top right": case "right top":
	                angle = Math.atan2(height, width);
	                break;
	              case "bottom left": case "left bottom":
	                angle = Math.PI + Math.atan2(height, width);
	                break;
	              case "bottom right": case "right bottom":
	                angle = Math.PI - Math.atan2(height, width);
	                break;
	            }
	
	            if (gradient.reverse) {
	                angle -= Math.PI;
	            }
	
	            // limit the angle between 0..2PI
	            angle %= 2 * Math.PI;
	            if (angle < 0) {
	                angle += 2 * Math.PI;
	            }
	
	            // compute gradient's start/end points.  here len is the length of the gradient line
	            // and x,y is the end point relative to the center of the rectangle in conventional
	            // (math) axis direction.
	
	            // this is the original (unscaled) length of the gradient line.  needed to deal with
	            // absolutely positioned color stops.  formula from the CSS spec:
	            // http://dev.w3.org/csswg/css-images-3/#linear-gradient-syntax
	            var pxlen = Math.abs(width * Math.sin(angle)) + Math.abs(height * Math.cos(angle));
	
	            // The math below is pretty simple, but it took a while to figure out.  We compute x
	            // and y, the *end* of the gradient line.  However, we want to transform them into
	            // element-based coordinates (SVG's gradientUnits="objectBoundingBox").  That means,
	            // x=0 is the left edge, x=1 is the right edge, y=0 is the top edge and y=1 is the
	            // bottom edge.
	            //
	            // A naive approach would use the original angle for these calculations.  Say we'd
	            // like to draw a gradient angled at 45deg in a 100x400 box.  When we use
	            // objectBoundingBox, the renderer will draw it in a 1x1 *square* box, and then
	            // scale that to the desired dimensions.  The 45deg angle will look more like 70deg
	            // after scaling.  SVG (http://www.w3.org/TR/SVG/pservers.html#LinearGradients) says
	            // the following:
	            //
	            //     When gradientUnits="objectBoundingBox" and 'gradientTransform' is the
	            //     identity matrix, the normal of the linear gradient is perpendicular to the
	            //     gradient vector in object bounding box space (i.e., the abstract coordinate
	            //     system where (0,0) is at the top/left of the object bounding box and (1,1) is
	            //     at the bottom/right of the object bounding box). When the object's bounding
	            //     box is not square, the gradient normal which is initially perpendicular to
	            //     the gradient vector within object bounding box space may render
	            //     non-perpendicular relative to the gradient vector in user space. If the
	            //     gradient vector is parallel to one of the axes of the bounding box, the
	            //     gradient normal will remain perpendicular. This transformation is due to
	            //     application of the non-uniform scaling transformation from bounding box space
	            //     to user space.
	            //
	            // which is an extremely long and confusing way to tell what I just said above.
	            //
	            // For this reason we need to apply the reverse scaling to the original angle, so
	            // that when it'll finally be rendered it'll actually be at the desired slope.  Now
	            // I'll let you figure out the math yourself.
	
	            var scaledAngle = Math.atan(width * Math.tan(angle) / height);
	            var sin = Math.sin(scaledAngle), cos = Math.cos(scaledAngle);
	            var len = Math.abs(sin) + Math.abs(cos);
	            var x = len/2 * sin;
	            var y = len/2 * cos;
	
	            // Because of the arctangent, our scaledAngle ends up between -PI/2..PI/2, possibly
	            // losing the intended direction of the gradient.  The following fixes it.
	            if (angle > Math.PI/2 && angle <= 3*Math.PI/2) {
	                x = -x;
	                y = -y;
	            }
	
	            // compute the color stops.
	            var implicit = [], right = 0;
	            var stops = gradient.stops.map(function(s, i){
	                var offset = s.percent;
	                if (offset) {
	                    offset = parseFloat(offset) / 100;
	                } else if (s.length) {
	                    offset = parseFloat(s.length) / pxlen;
	                } else if (i === 0) {
	                    offset = 0;
	                } else if (i == gradient.stops.length - 1) {
	                    offset = 1;
	                }
	                var stop = {
	                    color: s.color.toCssRgba(),
	                    offset: offset
	                };
	                if (offset != null) {
	                    right = offset;
	                    // fix implicit offsets
	                    implicit.forEach(function(s, i){
	                        var stop = s.stop;
	                        stop.offset = s.left + (right - s.left) * (i + 1) / (implicit.length + 1);
	                    });
	                    implicit = [];
	                } else {
	                    implicit.push({ left: right, stop: stop });
	                }
	                return stop;
	            });
	
	            var start = [ 0.5 - x, 0.5 + y ];
	            var end = [ 0.5 + x, 0.5 - y ];
	
	            // finally, draw it.
	            group.append(
	                Path.fromRect(rect)
	                    .stroke(null)
	                    .fill(new LinearGradient({
	                        start     : start,
	                        end       : end,
	                        stops     : stops,
	                        userSpace : false
	                    }))
	            );
	            break;
	          case "radial":
	            // XXX:
	            if (window.console && window.console.log) {
	                window.console.log("Radial gradients are not yet supported in HTML renderer");
	            }
	            break;
	        }
	    };
	}
	
	function maybeRenderWidget(element, group) {
	    var visual;
	
	    if (element._kendoExportVisual) {
	        visual = element._kendoExportVisual();
	    } else if (window.kendo && window.kendo.jQuery && element.getAttribute(window.kendo.attr("role"))) {
	        var widget = window.kendo.widgetInstance(window.kendo.jQuery(element));
	        if (widget && (widget.exportDOMVisual || widget.exportVisual)) {
	            if (widget.exportDOMVisual) {
	                visual = widget.exportDOMVisual();
	            } else {
	                visual = widget.exportVisual();
	            }
	        }
	    }
	
	    if (!visual) {
	        return false;
	    }
	
	    var wrap$$1 = new Group();
	    wrap$$1.children.push(visual);
	
	    var bbox = element.getBoundingClientRect();
	    wrap$$1.transform(transform$1().translate(bbox.left, bbox.top));
	
	    group.append(wrap$$1);
	
	    return true;
	}
	
	function maybeRenderBullet(element, group) {
	    var bulletType = element.getAttribute(KENDO_BULLET_TYPE);
	
	    if (!bulletType) {
	        return false;
	    }
	
	    var box = element.getBoundingClientRect();
	    var color = getComputedStyle$1(element).color;
	
	    if (bulletType === 'square') {
	        var rectSize = box.height / 5;
	        group.append(new Rect$2(new Rect([
	            box.right - rectSize,
	            box.top + box.height / 2.1
	        ], [rectSize, rectSize])).fill(color).stroke(color));
	    } else {
	        var radius = box.height / 7;
	        var center = [
	            box.right - radius,
	            box.top + (box.height + radius) / 2
	        ];
	        var circle = new Circle(new Circle$2(center, radius));
	        if (bulletType === 'circle') {
	            circle.stroke(color, 0.5);
	        } else {
	            circle.fill(color).stroke(null);
	        }
	        group.append(circle);
	    }
	
	    return true;
	}
	
	function renderImage(element, url, group) {
	    var box = getContentBox(element);
	    var rect = new Rect([ box.left, box.top ], [ box.width, box.height ]);
	    var image = new Image$1(url, rect);
	    setClipping$1(image, elementRoundBox(element, box, "content"));
	    group.append(image);
	}
	
	function zIndexSort(a, b) {
	    var sa = getComputedStyle$1(a);
	    var sb = getComputedStyle$1(b);
	    var za = parseFloat(getPropertyValue(sa, "z-index"));
	    var zb = parseFloat(getPropertyValue(sb, "z-index"));
	    var pa = getPropertyValue(sa, "position");
	    var pb = getPropertyValue(sb, "position");
	    if (isNaN(za) && isNaN(zb)) {
	        if ((/static|absolute/.test(pa)) && (/static|absolute/.test(pb))) {
	            return 0;
	        }
	        if (pa == "static") {
	            return -1;
	        }
	        if (pb == "static") {
	            return 1;
	        }
	        return 0;
	    }
	    if (isNaN(za)) {
	        return zb === 0 ? 0 : zb > 0 ? -1 : 1;
	    }
	    if (isNaN(zb)) {
	        return za === 0 ? 0 : za > 0 ? 1 : -1;
	    }
	    return parseFloat(za) - parseFloat(zb);
	}
	
	function isFormField(element) {
	    return /^(?:textarea|select|input)$/i.test(element.tagName);
	}
	
	function getSelectedOption(element) {
	    if (element.selectedOptions && element.selectedOptions.length > 0) {
	        return element.selectedOptions[0];
	    }
	    return element.options[element.selectedIndex];
	}
	
	function renderCheckbox(element, group) {
	    var style = getComputedStyle$1(element);
	    var color = getPropertyValue(style, "color");
	    var box = element.getBoundingClientRect();
	    if (element.type == "checkbox") {
	        group.append(
	            Path.fromRect(
	                new Rect([ box.left+1, box.top+1 ],
	                             [ box.width-2, box.height-2 ])
	            ).stroke(color, 1)
	        );
	        if (element.checked) {
	            // fill a rectangle inside?  looks kinda ugly.
	            // group.append(
	            //     Path.fromRect(
	            //         new geo.Rect([ box.left+4, box.top+4 ],
	            //                      [ box.width-8, box.height-8])
	            //     ).fill(color).stroke(null)
	            // );
	
	            // let's draw a checkmark instead.  artistic, eh?
	            group.append(
	                new Path()
	                    .stroke(color, 1.2)
	                    .moveTo(box.left + 0.22 * box.width,
	                            box.top + 0.55 * box.height)
	                    .lineTo(box.left + 0.45 * box.width,
	                            box.top + 0.75 * box.height)
	                    .lineTo(box.left + 0.78 * box.width,
	                            box.top + 0.22 * box.width)
	            );
	        }
	    } else {
	        group.append(
	            new Circle(
	                new Circle$2([
	                    (box.left + box.right) / 2,
	                    (box.top + box.bottom) / 2
	                ], Math.min(box.width-2, box.height-2) / 2)
	            ).stroke(color, 1)
	        );
	        if (element.checked) {
	            group.append(
	                new Circle(
	                    new Circle$2([
	                        (box.left + box.right) / 2,
	                        (box.top + box.bottom) / 2
	                    ], Math.min(box.width-8, box.height-8) / 2)
	                ).fill(color).stroke(null)
	            );
	        }
	    }
	}
	
	function renderFormField(element, group) {
	    var tag = element.tagName.toLowerCase();
	    if (tag == "input" && (element.type == "checkbox" || element.type == "radio")) {
	        return renderCheckbox(element, group);
	    }
	    var p = element.parentNode;
	    var doc = element.ownerDocument;
	    var el = doc.createElement(KENDO_PSEUDO_ELEMENT);
	    var option;
	    el.style.cssText = getCssText(getComputedStyle$1(element));
	    if (tag == "input") {
	        el.style.whiteSpace = "pre";
	    }
	    if (tag == "select" || tag == "textarea") {
	        el.style.overflow = "auto";
	    }
	    if (tag == "select") {
	        if (element.multiple) {
	            for (var i = 0; i < element.options.length; ++i) {
	                option = doc.createElement(KENDO_PSEUDO_ELEMENT);
	                option.style.cssText = getCssText(getComputedStyle$1(element.options[i]));
	                option.style.display = "block"; // IE9 messes up without this
	                option.textContent = element.options[i].textContent;
	                el.appendChild(option);
	            }
	        } else {
	            option = getSelectedOption(element);
	            if (option) {
	                el.textContent = option.textContent;
	            }
	        }
	    } else {
	        el.textContent = element.value;
	    }
	    p.insertBefore(el, element);
	    el.scrollLeft = element.scrollLeft;
	    el.scrollTop = element.scrollTop;
	
	    // must temporarily hide the original element, otherwise it
	    // may affect layout of the fake element we want to render.
	    element.style.display = "none";
	
	    renderContents(el, group);
	    element.style.display = "";
	    p.removeChild(el);
	}
	
	function serializeSVG(element) {
	    var serializer = new window.XMLSerializer();
	    var xml = serializer.serializeToString(element);
	
	    if (browser$3.mozilla && !(element.getAttribute("width") && element.getAttribute("height"))) {
	        var doc = new window.DOMParser().parseFromString(xml, "image/svg+xml");
	        var svg$$1 = doc.documentElement;
	        var box = getContentBox(element);
	        svg$$1.setAttribute("width", box.width);
	        svg$$1.setAttribute("height", box.height);
	        xml = serializer.serializeToString(svg$$1);
	    }
	
	    return xml;
	}
	
	function renderContents(element, group) {
	    if (nodeInfo._stackingContext.element === element) {
	        // the group that was set in pushNodeInfo might have
	        // changed due to clipping/transforms, update it here.
	        nodeInfo._stackingContext.group = group;
	    }
	    switch (element.tagName.toLowerCase()) {
	      case "img":
	        renderImage(element, element.src, group);
	        break;
	
	      case "svg":
	        var xml = serializeSVG(element);
	        var dataURL = "data:image/svg+xml;base64," + (encodeBase64(xml));
	        renderImage(element, dataURL, group);
	        break;
	
	      case "canvas":
	        try {
	            renderImage(element, element.toDataURL("image/png"), group);
	        } catch (ex) {
	            // tainted; can't draw it, ignore.
	        }
	        break;
	
	      case "textarea":
	      case "input":
	      case "select":
	        renderFormField(element, group);
	        break;
	
	      default:
	        var children = [], floats = [], positioned = [];
	        for (var i = element.firstChild; i; i = i.nextSibling) {
	            switch (i.nodeType) {
	              case 3:         // Text
	                if (/\S/.test(i.data)) {
	                    renderText(element, i, group);
	                }
	                break;
	              case 1:         // Element
	                var style = getComputedStyle$1(i);
	                var floating = getPropertyValue(style, "float");
	                var position = getPropertyValue(style, "position");
	                if (position != "static") {
	                    positioned.push(i);
	                }
	                else if (floating != "none") {
	                    floats.push(i);
	                } else {
	                    children.push(i);
	                }
	                break;
	            }
	        }
	
	        mergeSort(children, zIndexSort).forEach(function(el){ renderElement(el, group); });
	        mergeSort(floats, zIndexSort).forEach(function(el){ renderElement(el, group); });
	        mergeSort(positioned, zIndexSort).forEach(function(el){ renderElement(el, group); });
	    }
	}
	
	function renderText(element, node, group) {
	    if (emptyClipbox()) {
	        return;
	    }
	    var style = getComputedStyle$1(element);
	
	    if (parseFloat(getPropertyValue(style, "text-indent")) < -500) {
	        // assume it should not be displayed.  the slider's
	        // draggable handle displays a Drag text for some reason,
	        // having text-indent: -3333px.
	        return;
	    }
	
	    var text = node.data;
	    var start = 0;
	    var end = text.search(/\S\s*$/) + 1;
	
	    if (!end) {
	        return; // whitespace-only node
	    }
	
	    var fontSize = getPropertyValue(style, "font-size");
	    var lineHeight = getPropertyValue(style, "line-height");
	
	    // simply getPropertyValue("font") doesn't work in Firefox :-\
	    var font = [
	        getPropertyValue(style, "font-style"),
	        getPropertyValue(style, "font-variant"),
	        getPropertyValue(style, "font-weight"),
	        fontSize, // no need for line height here; it breaks layout in FF
	        getPropertyValue(style, "font-family")
	    ].join(" ");
	
	    fontSize = parseFloat(fontSize);
	    lineHeight = parseFloat(lineHeight);
	
	    if (fontSize === 0 || isNaN(fontSize)) {
	        return;
	    }
	
	    var color = getPropertyValue(style, "color");
	    var range = element.ownerDocument.createRange();
	    var align$$1 = getPropertyValue(style, "text-align");
	    var isJustified = align$$1 == "justify";
	    var columnCount = getPropertyValue(style, "column-count", 1);
	    var whiteSpace = getPropertyValue(style, "white-space");
	    var textTransform = getPropertyValue(style, "text-transform");
	
	    // A line of 500px, with a font of 12px, contains an average of 80 characters, but since we
	    // err, we'd like to guess a bigger number rather than a smaller one.  Multiplying by 5
	    // seems to be a good option.
	    var estimateLineLength = element.getBoundingClientRect().width / fontSize * 5;
	    if (estimateLineLength === 0) {
	        estimateLineLength = 500;
	    }
	
	    // we'll maintain this so we can workaround bugs in Chrome's Range.getClientRects
	    // https://github.com/telerik/kendo/issues/5740
	    var prevLineBottom = null;
	
	    var underline = nodeInfo["underline"];
	    var lineThrough = nodeInfo["line-through"];
	    var overline = nodeInfo["overline"];
	    var underlineOffset = nodeInfo["underline-offset"];
	
	    if (underline) {
	        forEachRect(decorateUnder);
	    }
	
	    // doChunk returns true when all text has been rendered
	    while (!doChunk()) {}
	
	    if (lineThrough || overline) {
	        forEachRect(decorateOver);
	    }
	
	    return;                 // only function declarations after this line
	
	    function forEachRect(callback) {
	        range.selectNode(node);
	        var clientRects = slice$1$1(range.getClientRects());
	
	        forEachRect = function (cb) { return clientRects.forEach(cb); };
	        forEachRect(callback);
	    }
	
	    function actuallyGetRangeBoundingRect(range) {
	        // XXX: to be revised when this Chrome bug is fixed:
	        // https://bugs.chromium.org/p/chromium/issues/detail?id=612459
	        if (microsoft || browser$3.chrome || browser$3.safari) {
	            // Workaround browser bugs: IE and Chrome would sometimes
	            // return 0 or 1-width rectangles before or after the main
	            // one.  https://github.com/telerik/kendo/issues/4674
	
	            // Actually Chrome 50 got worse, since the rectangles can now have the width of a
	            // full character, making it hard to tell whether it's a bogus rectangle or valid
	            // selection location.  The workaround is to ignore rectangles that fall on the
	            // previous line.  https://github.com/telerik/kendo/issues/5740
	            var rectangles = range.getClientRects(), box = {
	                top    :  Infinity,
	                right  : -Infinity,
	                bottom : -Infinity,
	                left   :  Infinity
	            }, done = false;
	            for (var i = 0; i < rectangles.length; ++i) {
	                var b = rectangles[i];
	                if (b.width <= 1 || b.bottom === prevLineBottom) {
	                    continue;   // bogus rectangle
	                }
	                box.left   = Math.min(b.left   , box.left);
	                box.top    = Math.min(b.top    , box.top);
	                box.right  = Math.max(b.right  , box.right);
	                box.bottom = Math.max(b.bottom , box.bottom);
	                done = true;
	            }
	            if (!done) {
	                return range.getBoundingClientRect();
	            }
	            box.width = box.right - box.left;
	            box.height = box.bottom - box.top;
	            return box;
	        }
	        return range.getBoundingClientRect();
	    }
	
	    // Render a chunk of text, typically one line (but for justified text we render each word as
	    // a separate Text object, because spacing is variable).  Returns true when it finished the
	    // current node.  After each chunk it updates `start` to just after the last rendered
	    // character.
	    function doChunk() {
	        var origStart = start;
	        var box, pos = text.substr(start).search(/\S/);
	        start += pos;
	        if (pos < 0 || start >= end) {
	            return true;
	        }
	
	        // Select a single character to determine the height of a line of text.  The box.bottom
	        // will be essential for us to figure out where the next line begins.
	        range.setStart(node, start);
	        range.setEnd(node, start + 1);
	        box = actuallyGetRangeBoundingRect(range);
	
	        // for justified text we must split at each space, because space has variable width.
	        var found = false;
	        if (isJustified || columnCount > 1) {
	            pos = text.substr(start).search(/\s/);
	            if (pos >= 0) {
	                // we can only split there if it's on the same line, otherwise we'll fall back
	                // to the default mechanism (see findEOL below).
	                range.setEnd(node, start + pos);
	                var r = actuallyGetRangeBoundingRect(range);
	                if (r.bottom == box.bottom) {
	                    box = r;
	                    found = true;
	                    start += pos;
	                }
	            }
	        }
	
	        if (!found) {
	            // This code does three things: (1) it selects one line of text in `range`, (2) it
	            // leaves the bounding rect of that line in `box` and (3) it returns the position
	            // just after the EOL.  We know where the line starts (`start`) but we don't know
	            // where it ends.  To figure this out, we select a piece of text and look at the
	            // bottom of the bounding box.  If it changes, we have more than one line selected
	            // and should retry with a smaller selection.
	            //
	            // To speed things up, we first try to select all text in the node (`start` ->
	            // `end`).  If there's more than one line there, then select only half of it.  And
	            // so on.  When we find a value for `end` that fits in one line, we try increasing
	            // it (also in halves) until we get to the next line.  The algorithm stops when the
	            // right side of the bounding box does not change.
	            //
	            // One more thing to note is that everything happens in a single Text DOM node.
	            // There's no other tags inside it, therefore the left/top coordinates of the
	            // bounding box will not change.
	            pos = (function findEOL(min, eol, max){
	                range.setEnd(node, eol);
	                var r = actuallyGetRangeBoundingRect(range);
	                if (r.bottom != box.bottom && min < eol) {
	                    return findEOL(min, (min + eol) >> 1, eol);
	                } else if (r.right != box.right) {
	                    box = r;
	                    if (eol < max) {
	                        return findEOL(eol, (eol + max) >> 1, max);
	                    } else {
	                        return eol;
	                    }
	                } else {
	                    return eol;
	                }
	            })(start, Math.min(end, start + estimateLineLength), end);
	
	            if (pos == start) {
	                // if EOL is at the start, then no more text fits on this line.  Skip the
	                // remainder of this node entirely to avoid a stack overflow.
	                return true;
	            }
	            start = pos;
	
	            pos = range.toString().search(/\s+$/);
	            if (pos === 0) {
	                return false; // whitespace only; we should not get here.
	            }
	            if (pos > 0) {
	                // eliminate trailing whitespace
	                range.setEnd(node, range.startOffset + pos);
	                box = actuallyGetRangeBoundingRect(range);
	            }
	        }
	
	        // another workaround for IE: if we rely on getBoundingClientRect() we'll overlap with the bullet for LI
	        // elements.  Calling getClientRects() and using the *first* rect appears to give us the correct location.
	        // Note: not to be used in Chrome as it randomly returns a zero-width rectangle from the previous line.
	        if (microsoft) {
	            box = range.getClientRects()[0];
	        }
	
	        var str = range.toString();
	        if (!/^(?:pre|pre-wrap)$/i.test(whiteSpace)) {
	            // node with non-significant space -- collapse whitespace.
	            str = str.replace(/\s+/g, " ");
	        }
	        else if (/\t/.test(str)) {
	            // with significant whitespace we need to do something about literal TAB characters.
	            // There's no TAB glyph in a font so they would be rendered in PDF as an empty box,
	            // and the whole text will stretch to fill the original width.  The core PDF lib
	            // does not have sufficient context to deal with it.
	
	            // calculate the starting column here, since we initially discarded any whitespace.
	            var cc = 0;
	            for (pos = origStart; pos < range.startOffset; ++pos) {
	                var code = text.charCodeAt(pos);
	                if (code == 9) {
	                    // when we meet a TAB we must round up to the next tab stop.
	                    // in all browsers TABs seem to be 8 characters.
	                    cc += 8 - cc % 8;
	                } else if (code == 10 || code == 13) {
	                    // just in case we meet a newline we must restart.
	                    cc = 0;
	                } else {
	                    // ordinary character --> advance one column
	                    cc++;
	                }
	            }
	
	            // based on starting column, replace any TAB characters in the string we actually
	            // have to display with spaces so that they align to columns multiple of 8.
	            while ((pos = str.search("\t")) >= 0) {
	                var indent = "        ".substr(0, 8 - (cc + pos) % 8);
	                str = str.substr(0, pos) + indent + str.substr(pos + 1);
	            }
	        }
	
	        if (!found) {
	            prevLineBottom = box.bottom;
	        }
	        drawText(str, box);
	    }
	
	    function drawText(str, box) {
	        // In IE the box height will be approximately lineHeight, while in
	        // other browsers it'll (correctly) be the height of the bounding
	        // box for the current text/font.  Which is to say, IE sucks again.
	        // The only good solution I can think of is to measure the text
	        // ourselves and center the bounding box.
	        if (microsoft && !isNaN(lineHeight)) {
	            var height = getFontHeight(font);
	            var top = (box.top + box.bottom - height) / 2;
	            box = {
	                top    : top,
	                right  : box.right,
	                bottom : top + height,
	                left   : box.left,
	                height : height,
	                width  : box.right - box.left
	            };
	        }
	
	        // var path = new Path({ stroke: { color: "red" }});
	        // path.moveTo(box.left, box.top)
	        //     .lineTo(box.right, box.top)
	        //     .lineTo(box.right, box.bottom)
	        //     .lineTo(box.left, box.bottom)
	        //     .close();
	        // group.append(path);
	
	        switch (textTransform) {
	          case "uppercase":
	            str = str.toUpperCase();
	            break;
	          case "lowercase":
	            str = str.toLowerCase();
	            break;
	          case "capitalize":
	            str = str.replace(/(?:^|\s)\S/g, function (l) { return l.toUpperCase(); });
	            break;
	        }
	
	        var text = new TextRect(
	            str, new Rect([ box.left, box.top ],
	                              [ box.width, box.height ]),
	            {
	                font: font,
	                fill: { color: color }
	            }
	        );
	        group.append(text);
	    }
	
	    function drawTextLine(lineWidth, textBox, color, ypos) {
	        if (color) {
	            var path = new Path({ stroke: {
	                width: lineWidth,
	                color: color
	            }});
	
	            ypos -= lineWidth;
	            path.moveTo(textBox.left, ypos)
	                .lineTo(textBox.right, ypos);
	            group.append(path);
	        }
	    }
	
	    function decorateOver(box) {
	        var width = fontSize / 12;
	        drawTextLine(width, box, lineThrough, box.bottom - box.height / 2.7);
	        drawTextLine(width, box, overline, box.top);
	    }
	
	    function decorateUnder(box) {
	        var width = fontSize / 12;
	        var underlinePos = box.bottom;
	        if (underlineOffset != null) {
	            underlinePos += underlineOffset;
	        } else {
	            underlinePos += width; // for "auto" it seems better to add line width
	        }
	        drawTextLine(width, box, underline, underlinePos);
	    }
	}
	
	function groupInStackingContext(element, group, zIndex) {
	    var main;
	    if (zIndex != "auto") {
	        // use the current stacking context
	        main = nodeInfo._stackingContext.group;
	        zIndex = parseFloat(zIndex);
	    } else {
	        // normal flow — use given container.  we still have to
	        // figure out where should we insert this element with the
	        // assumption that its z-index is zero, as the group might
	        // already contain elements with higher z-index.
	        main = group;
	        zIndex = 0;
	    }
	    var a = main.children;
	    for (var i = 0; i < a.length; ++i) {
	        if (a[i]._dom_zIndex != null && a[i]._dom_zIndex > zIndex) {
	            break;
	        }
	    }
	
	    var tmp = new Group();
	    main.insert(i, tmp);
	    tmp._dom_zIndex = zIndex;
	
	    if (main !== group) {
	        // console.log("Placing", element, "in", nodeInfo._stackingContext.element, "at position", i, " / ", a.length);
	        // console.log(a.slice(i+1));
	
	        // if (nodeInfo._matrix) {
	        //     tmp.transform(nodeInfo._matrix);
	        // }
	        if (nodeInfo._clipbox) {
	            var m = nodeInfo._matrix.invert();
	            var r = nodeInfo._clipbox.transformCopy(m);
	            setClipping$1(tmp, Path.fromRect(r));
	            // console.log(r);
	            // tmp.append(Path.fromRect(r));
	            // tmp.append(new Text(element.className || element.id, r.topLeft()));
	        }
	    }
	
	    return tmp;
	}
	
	function renderElement(element, container) {
	    var style = getComputedStyle$1(element);
	
	    updateCounters(style);
	
	    if (/^(style|script|link|meta|iframe|col|colgroup)$/i.test(element.tagName)) {
	        return;
	    }
	
	    if (nodeInfo._clipbox == null) {
	        return;
	    }
	
	    var opacity = parseFloat(getPropertyValue(style, "opacity"));
	    var visibility = getPropertyValue(style, "visibility");
	    var display = getPropertyValue(style, "display");
	
	    if (opacity === 0 || visibility == "hidden" || display == "none") {
	        return;
	    }
	
	    var tr = getTransform(style);
	    var group;
	
	    var zIndex = getPropertyValue(style, "z-index");
	    if ((tr || opacity < 1) && zIndex == "auto") {
	        zIndex = 0;
	    }
	    group = groupInStackingContext(element, container, zIndex);
	
	    // XXX: remove at some point
	    // group._pdfElement = element;
	    // group.options._pdfDebug = "";
	    // if (element.id) {
	    //     group.options._pdfDebug = "#" + element.id;
	    // }
	    // if (element.className) {
	    //     group.options._pdfDebug += "." + element.className.split(" ").join(".");
	    // }
	
	    if (opacity < 1) {
	        group.opacity(opacity * group.opacity());
	    }
	
	    pushNodeInfo(element, style, group);
	
	    if (!tr) {
	        _renderWithPseudoElements(element, group);
	    }
	    else {
	        saveStyle(element, function(){
	            // must clear transform, so getBoundingClientRect returns correct values.
	            pleaseSetPropertyValue(element.style, "transform", "none", "important");
	
	            // must also clear transitions, so correct values are returned *immediately*
	            pleaseSetPropertyValue(element.style, "transition", "none", "important");
	
	            // the presence of any transform makes it behave like it had position: relative,
	            // because why not.
	            // http://meyerweb.com/eric/thoughts/2011/09/12/un-fixing-fixed-elements-with-css-transforms/
	            if (getPropertyValue(style, "position") == "static") {
	                // but only if it's not already positioned. :-/
	                pleaseSetPropertyValue(element.style, "position", "relative", "important");
	            }
	
	            // must translate to origin before applying the CSS
	            // transformation, then translate back.
	            var bbox = element.getBoundingClientRect();
	            var x = bbox.left + tr.origin[0];
	            var y = bbox.top + tr.origin[1];
	            var m = [ 1, 0, 0, 1, -x, -y ];
	            m = mmul$1(m, tr.matrix);
	            m = mmul$1(m, [ 1, 0, 0, 1, x, y ]);
	            m = setTransform$1(group, m);
	
	            nodeInfo._matrix = nodeInfo._matrix.multiplyCopy(m);
	
	            _renderWithPseudoElements(element, group);
	        });
	    }
	
	    popNodeInfo();
	
	    //drawDebugBox(element.getBoundingClientRect(), container);
	}
	
	// function drawDebugBox(box, group, color) {
	//     var path = Path.fromRect(new geo.Rect([ box.left, box.top ], [ box.width, box.height ]));
	//     if (color) {
	//         path.stroke(color);
	//     }
	//     group.append(path);
	// }
	
	// function dumpTextNode(node) {
	//     var txt = node.data.replace(/^\s+/, "");
	//     if (txt.length < 100) {
	//         console.log(node.data.length + ": |" + txt);
	//     } else {
	//         console.log(node.data.length + ": |" + txt.substr(0, 50) + "|...|" + txt.substr(-50));
	//     }
	// }
	
	function mmul$1(a, b) {
	    var a1 = a[0], b1 = a[1], c1 = a[2], d1 = a[3], e1 = a[4], f1 = a[5];
	    var a2 = b[0], b2 = b[1], c2 = b[2], d2 = b[3], e2 = b[4], f2 = b[5];
	    return [
	        a1*a2 + b1*c2,          a1*b2 + b1*d2,
	        c1*a2 + d1*c2,          c1*b2 + d1*d2,
	        e1*a2 + f1*c2 + e2,     e1*b2 + f1*d2 + f2
	    ];
	}
	
	exports.drawing = drawing;
	exports.geometry = geometry;
	exports.pdf = pdf;
	exports.exportPDF = exportPDF;
	exports.exportImage = exportImage;
	exports.exportSVG = exportSVG;
	exports.animationFrame = animationFrame;
	exports.Class = Class;
	exports.Color = Color;
	exports.htmlEncode = htmlEncode;
	exports.logToConsole = logToConsole;
	exports.Observable = Observable;
	exports.saveAs = saveAs;
	exports.support = support;
	exports.template = template$1;
	exports.throttle = throttle;
	exports.parseColor = parseColor;
	exports.namedColors = namedColors;
	exports.Animation = Animation;
	exports.AnimationFactory = AnimationFactory;
	exports.Arc = Arc;
	exports.BaseNode = BaseNode;
	exports.Circle = Circle;
	exports.Element = Element$1;
	exports.Gradient = Gradient;
	exports.GradientStop = GradientStop;
	exports.Group = Group;
	exports.Image = Image$1;
	exports.Layout = Layout;
	exports.LinearGradient = LinearGradient;
	exports.MultiPath = MultiPath;
	exports.HasObservers = HasObservers;
	exports.OptionsStore = OptionsStore;
	exports.Path = Path;
	exports.PathParser = PathParser;
	exports.QuadNode = QuadNode;
	exports.RadialGradient = RadialGradient;
	exports.Rect = Rect$2;
	exports.ShapesQuadTree = ShapesQuadTree;
	exports.Surface = Surface;
	exports.SurfaceFactory = SurfaceFactory;
	exports.Text = Text;
	exports.align = align;
	exports.fit = fit;
	exports.stack = stack;
	exports.vAlign = vAlign;
	exports.vStack = vStack;
	exports.vWrap = vWrap;
	exports.wrap = wrap;
	exports.drawDOM = drawDOM;
	exports.drawText = drawText$1;
	exports.getFontFaces = getFontFaces;
	
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 342 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function saveAs(data, fileName, options) {
	  if ( options === void 0 ) options = {};
	
	  var save = postToProxy;
	
	  if (options.forceProxy && !options.proxyURL) {
	    throw new Error('No proxyURL is set, but forceProxy is true');
	  }
	
	  if (!options.forceProxy) {
	    if (canDownload()) {
	      save = saveAsDataURI;
	    }
	
	    if (navigator.msSaveBlob) {
	      save = saveAsBlob;
	    }
	  }
	
	  save(data, fileName, options);
	}
	
	var anchor = function () { return document.createElement('a'); };
	var canDownload = function () { return 'download' in anchor(); };
	
	function saveAsBlob(data, fileName) {
	  var blob = data; // could be a Blob object
	
	  if (typeof data === 'string') {
	    var parts = data.split(';base64,');
	    var contentType = parts[0];
	    var base64 = atob(parts[1]);
	    var array = new Uint8Array(base64.length);
	
	    for (var idx = 0; idx < base64.length; idx++) {
	      array[idx] = base64.charCodeAt(idx);
	    }
	
	    blob = new Blob([ array.buffer ], { type: contentType });
	  }
	
	  navigator.msSaveBlob(blob, fileName);
	}
	
	function saveAsDataURI(data, fileName) {
	  var dataURI = data;
	  if (window.Blob && data instanceof Blob) {
	    dataURI = URL.createObjectURL(data);
	  }
	
	  var fileSaver = anchor();
	  fileSaver.download = fileName;
	  fileSaver.href = dataURI;
	
	  var e = document.createEvent('MouseEvents');
	  e.initMouseEvent('click', true, false, window,
	  0, 0, 0, 0, 0, false, false, false, false, 0, null);
	
	  fileSaver.dispatchEvent(e);
	  setTimeout(function () { return URL.revokeObjectURL(dataURI); });
	}
	
	function postToProxy(dataURI, fileName, options) {
	  if (!options.proxyURL) {
	    return;
	  }
	
	  var form = document.createElement('form');
	  form.setAttribute('action', options.proxyURL);
	  form.setAttribute('method', 'POST');
	  form.setAttribute('target', options.proxyTarget || '_self');
	
	  var formData = options.proxyData || {};
	  formData.fileName = fileName;
	
	  var parts = dataURI.split(";base64,");
	  formData.contentType = parts[0].replace("data:", "");
	  formData.base64 = parts[1];
	
	  for (var name in formData) {
	    if (formData.hasOwnProperty(name)) {
	      var input = document.createElement('input');
	      input.setAttribute('type', 'hidden');
	      input.setAttribute('name', name);
	      input.setAttribute('value', formData[name]);
	
	      form.appendChild(input);
	    }
	  }
	
	  document.body.appendChild(form);
	  form.submit();
	  document.body.removeChild(form);
	}
	
	var KEY_STR = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
	var fromCharCode = String.fromCharCode;
	
	function encodeBase64(plainText) {
	  var input = encodeUTF8(plainText);
	  var output = "";
	  var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
	  var i = 0;
	
	  while (i < input.length) {
	    chr1 = input.charCodeAt(i++);
	    chr2 = input.charCodeAt(i++);
	    chr3 = input.charCodeAt(i++);
	
	    enc1 = chr1 >> 2;
	    enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
	    enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
	    enc4 = chr3 & 63;
	
	    if (isNaN(chr2)) {
	      enc3 = enc4 = 64;
	    } else if (isNaN(chr3)) {
	      enc4 = 64;
	    }
	
	    output = output +
	      KEY_STR.charAt(enc1) + KEY_STR.charAt(enc2) +
	      KEY_STR.charAt(enc3) + KEY_STR.charAt(enc4);
	  }
	
	  return output;
	}
	
	function encodeUTF8(input) {
	  var output = "";
	
	  for (var i = 0; i < input.length; i++) {
	    var c = input.charCodeAt(i);
	
	    if (c < 0x80) {
	      // One byte
	      output += fromCharCode(c);
	    } else if (c < 0x800) {
	      // Two bytes
	      output += fromCharCode(0xC0 | (c >>> 6));
	      output += fromCharCode(0x80 | (c & 0x3f));
	    } else if (c < 0x10000) {
	      // Three bytes
	      output += fromCharCode(0xE0 | (c >>> 12));
	      output += fromCharCode(0x80 | (c >>> 6 & 0x3f));
	      output += fromCharCode(0x80 | (c & 0x3f));
	    }
	  }
	
	  return output;
	}
	
	exports.saveAs = saveAs;
	exports.encodeBase64 = encodeBase64;
	
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var ReactDOMServer = __webpack_require__(1377);
	var defaultFileName = 'export.pdf';
	var defaultCreator = 'KendoReact PDF Generator';
	/**
	 * @hidden
	 */
	var KendoDrawingAdapter = /** @class */ (function () {
	    function KendoDrawingAdapter(drawDOM, exportPDF, saveAs, domElement, options) {
	        if (options === void 0) { options = {}; }
	        var _this = this;
	        this.drawDOM = drawDOM;
	        this.exportPDF = exportPDF;
	        this.saveAs = saveAs;
	        this.domElement = domElement;
	        this.options = options;
	        this.convertPageTemplateToHtml = function (pageContext) {
	            var pageTemplateContent = ReactDOMServer.renderToStaticMarkup(React.createElement(_this.options.pageTemplate, {
	                pageNum: pageContext.pageNum, totalPages: pageContext.totalPages
	            }));
	            return "<span>" + pageTemplateContent + "</span>";
	        };
	    }
	    KendoDrawingAdapter.prototype.savePDF = function (callback) {
	        var _this = this;
	        var savePromise = this.drawDOM(this.domElement, this.getDrawOptions())
	            .then(function (group) { return _this.exportPDF(group, _this.getPDFOptions()); })
	            .then(function (dataUri) { return _this.saveAs(dataUri, _this.options.fileName || defaultFileName, _this.getSaveOptions()); });
	        if (callback) {
	            savePromise.then(callback, callback);
	        }
	    };
	    KendoDrawingAdapter.prototype.getDrawOptions = function () {
	        return {
	            avoidLinks: this.options.avoidLinks,
	            forcePageBreak: this.options.forcePageBreak,
	            keepTogether: this.options.keepTogether,
	            margin: this.options.margin,
	            paperSize: this.options.paperSize,
	            landscape: this.options.landscape,
	            repeatHeaders: this.options.repeatHeaders,
	            scale: this.options.scale,
	            template: this.options.pageTemplate && this.convertPageTemplateToHtml
	        };
	    };
	    KendoDrawingAdapter.prototype.getPDFOptions = function () {
	        return {
	            author: this.options.author,
	            creator: this.options.creator || defaultCreator,
	            date: this.options.date,
	            imgDPI: this.options.imageResolution,
	            keywords: this.options.keywords,
	            landscape: this.options.landscape,
	            margin: this.options.margin,
	            multiPage: true,
	            paperSize: this.options.paperSize,
	            producer: this.options.producer,
	            subject: this.options.subject,
	            title: this.options.title
	        };
	    };
	    KendoDrawingAdapter.prototype.getSaveOptions = function () {
	        return {
	            forceProxy: this.options.forceProxy,
	            proxyData: this.options.proxyData,
	            proxyTarget: this.options.proxyTarget,
	            proxyURL: this.options.proxyURL
	        };
	    };
	    return KendoDrawingAdapter;
	}());
	exports.default = KendoDrawingAdapter;
	//# sourceMappingURL=KendoDrawingAdapter.js.map

/***/ },
/* 344 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var PropTypes = __webpack_require__(3);
	/**
	 * @hidden
	 */
	var PDFMargin = /** @class */ (function (_super) {
	    __extends(PDFMargin, _super);
	    function PDFMargin() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    PDFMargin.prototype.render = function () {
	        return null;
	    };
	    PDFMargin.propTypes = {
	        left: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	        top: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	        right: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	        bottom: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
	    };
	    return PDFMargin;
	}(React.Component));
	exports.PDFMargin = PDFMargin;
	//# sourceMappingURL=PDFMargin.js.map

/***/ },
/* 345 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var focusableRegex = /^(?:a|input|select|option|textarea|button|object)$/i;
	var NODE_NAME_PREDICATES = {};
	var toClassList = function (classNames) { return String(classNames).trim().split(' '); };
	/**
	 * @hidden
	 */
	exports.hasClasses = function (element, classNames) {
	    var namesList = toClassList(classNames);
	    return Boolean(toClassList(element.className).find(function (className) { return namesList.indexOf(className) >= 0; }));
	};
	/**
	 * @hidden
	 */
	exports.matchesClasses = function (classNames) {
	    return function (element) { return exports.hasClasses(element, classNames); };
	};
	/**
	 * @hidden
	 */
	exports.matchesNodeName = function (nodeName) {
	    if (!NODE_NAME_PREDICATES[nodeName]) {
	        NODE_NAME_PREDICATES[nodeName] = function (element) {
	            return String(element.nodeName).toLowerCase() === nodeName.toLowerCase();
	        };
	    }
	    return NODE_NAME_PREDICATES[nodeName];
	};
	/**
	 * @hidden
	 */
	exports.closest = function (node, predicate) {
	    while (node && !predicate(node)) {
	        node = node.parentNode;
	    }
	    return node;
	};
	/**
	 * @hidden
	 */
	exports.closestInScope = function (node, predicate, scope) {
	    while (node && node !== scope && !predicate(node)) {
	        node = node.parentNode;
	    }
	    if (node !== scope) {
	        return node;
	    }
	};
	/**
	 * @hidden
	 */
	exports.contains = function (parent, node, matchSelf) {
	    if (matchSelf === void 0) { matchSelf = false; }
	    var outside = !exports.closest(node, function (child) { return child === parent; });
	    if (outside) {
	        return false;
	    }
	    var el = exports.closest(node, function (child) { return child === node; });
	    return el && (matchSelf || el !== parent);
	};
	/**
	 * @hidden
	 */
	exports.isVisible = function (element) {
	    var rect = element.getBoundingClientRect();
	    var hasSize = rect.width > 0 && rect.height > 0;
	    var hasPosition = rect.x !== 0 && rect.y !== 0;
	    // Elements can have zero size due to styling, but they still count as visible.
	    // For example, the selection checkbox has no size, but is made visible through styling.
	    return (hasSize || hasPosition) && window.getComputedStyle(element).visibility !== 'hidden';
	};
	/**
	 * @hidden
	 */
	exports.isFocusable = function (element, checkVisibility) {
	    if (checkVisibility === void 0) { checkVisibility = true; }
	    if (element.tagName) {
	        var tagName = element.tagName.toLowerCase();
	        var tabIndex = element.getAttribute('tabIndex');
	        var skipTab = tabIndex === '-1';
	        var focusable = tabIndex !== null && !skipTab;
	        if (focusableRegex.test(tagName)) {
	            focusable = !element.disabled && !skipTab;
	        }
	        return focusable && (!checkVisibility || exports.isVisible(element));
	    }
	    return false;
	};
	/**
	 * @hidden
	 */
	exports.findElement = function (node, predicate, matchSelf) {
	    if (matchSelf === void 0) { matchSelf = true; }
	    if (!node) {
	        return;
	    }
	    if (matchSelf && predicate(node)) {
	        return node;
	    }
	    node = node.firstChild;
	    while (node) {
	        if (node.nodeType === 1) {
	            var element = exports.findElement(node, predicate);
	            if (element) {
	                return element;
	            }
	        }
	        node = node.nextSibling;
	    }
	};
	/**
	 * @hidden
	 */
	exports.findFocusable = function (element, checkVisibility) {
	    if (checkVisibility === void 0) { checkVisibility = true; }
	    return exports.findElement(element, function (node) { return exports.isFocusable(node, checkVisibility); });
	};
	/**
	 * @hidden
	 */
	exports.findFocusableChild = function (element, checkVisibility) {
	    if (checkVisibility === void 0) { checkVisibility = true; }
	    return exports.findElement(element, function (node) { return exports.isFocusable(node, checkVisibility); }, false);
	};
	//# sourceMappingURL=dom-queries.js.map

/***/ },
/* 346 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var FIRST_CLASS = 'k-first';
	var HEADER_CLASS = 'k-grid-header';
	var FOOTER_CLASS = 'k-grid-footer';
	/**
	 * @hidden
	 */
	exports.appendNodes = function (element, nodes) {
	    var length = nodes.length;
	    for (var idx = 0; idx < length; idx++) {
	        element.appendChild(nodes[idx].cloneNode(true));
	    }
	};
	/**
	 * @hidden
	 */
	exports.wrapTable = function (table) {
	    var wrapper = document.createElement('div');
	    wrapper.className = 'k-widget k-grid';
	    wrapper.appendChild(table);
	    return wrapper;
	};
	/**
	 * @hidden
	 */
	exports.createTableElement = function (sources) {
	    var sourceCount = sources.length;
	    var element = sources[0].cloneNode(true);
	    var rowsCount = element.rows.length;
	    if (sourceCount > 1) {
	        for (var rowIdx = 0; rowIdx < rowsCount; rowIdx++) {
	            for (var sourceIdx = 1; sourceIdx < sourceCount; sourceIdx++) {
	                exports.appendNodes(element.rows[rowIdx], sources[sourceIdx].rows[rowIdx].cells);
	            }
	        }
	    }
	    return element;
	};
	/**
	 * @hidden
	 */
	exports.setFirstCellClass = function (header, headers) {
	    if (headers.length > 1 && header.rows.length > 1) {
	        for (var idx = 1; idx < header.rows.length; idx++) {
	            var firstCellIndex = headers[0].rows[idx].cells.length;
	            var cell = header.rows[idx].cells[firstCellIndex];
	            if (String(cell.className).indexOf(FIRST_CLASS) === -1) {
	                cell.className += " " + FIRST_CLASS;
	            }
	        }
	    }
	};
	/**
	 * @hidden
	 */
	exports.createTable = function (colGroups, headers, bodies, footers) {
	    var table = document.createElement('table');
	    var colGroup = colGroups[0].cloneNode(true);
	    for (var idx = 1; idx < colGroups.length; idx++) {
	        exports.appendNodes(colGroup, colGroups[idx].querySelectorAll('col'));
	    }
	    var header = exports.createTableElement(headers);
	    var body = exports.createTableElement(bodies);
	    header.className = HEADER_CLASS;
	    exports.setFirstCellClass(header, headers);
	    table.appendChild(colGroup);
	    table.appendChild(header);
	    table.appendChild(body);
	    if (footers.length) {
	        var footer = exports.createTableElement(footers);
	        footer.className = FOOTER_CLASS;
	        table.appendChild(footer);
	    }
	    return exports.wrapTable(table);
	};
	//# sourceMappingURL=utils.js.map

/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright (c) 2017-present, Ephox, Inc.
	 *
	 * This source code is licensed under the Apache 2 license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.setMode = exports.isInDoc = exports.isBeforeInputEventAvailable = exports.mergePlugins = exports.isTextareaOrInput = exports.uuid = exports.configHandlers = exports.configHandlers2 = exports.isFunction = void 0;
	var EditorPropTypes_1 = __webpack_require__(348);
	var isFunction = function (x) { return typeof x === 'function'; };
	exports.isFunction = isFunction;
	var isEventProp = function (name) { return name in EditorPropTypes_1.eventPropTypes; };
	var eventAttrToEventName = function (attrName) { return attrName.substr(2); };
	var configHandlers2 = function (handlerLookup, on, off, adapter, prevProps, props, boundHandlers) {
	    var prevEventKeys = Object.keys(prevProps).filter(isEventProp);
	    var currEventKeys = Object.keys(props).filter(isEventProp);
	    var removedKeys = prevEventKeys.filter(function (key) { return props[key] === undefined; });
	    var addedKeys = currEventKeys.filter(function (key) { return prevProps[key] === undefined; });
	    removedKeys.forEach(function (key) {
	        // remove event handler
	        var eventName = eventAttrToEventName(key);
	        var wrappedHandler = boundHandlers[eventName];
	        off(eventName, wrappedHandler);
	        delete boundHandlers[eventName];
	    });
	    addedKeys.forEach(function (key) {
	        var wrappedHandler = adapter(handlerLookup, key);
	        var eventName = eventAttrToEventName(key);
	        boundHandlers[eventName] = wrappedHandler;
	        on(eventName, wrappedHandler);
	    });
	};
	exports.configHandlers2 = configHandlers2;
	var configHandlers = function (editor, prevProps, props, boundHandlers, lookup) {
	    return (0, exports.configHandlers2)(lookup, editor.on.bind(editor), editor.off.bind(editor), 
	    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
	    function (handlerLookup, key) { return function (e) { var _a; return (_a = handlerLookup(key)) === null || _a === void 0 ? void 0 : _a(e, editor); }; }, prevProps, props, boundHandlers);
	};
	exports.configHandlers = configHandlers;
	var unique = 0;
	var uuid = function (prefix) {
	    var time = Date.now();
	    var random = Math.floor(Math.random() * 1000000000);
	    unique++;
	    return prefix + '_' + random + unique + String(time);
	};
	exports.uuid = uuid;
	var isTextareaOrInput = function (element) {
	    return element !== null && (element.tagName.toLowerCase() === 'textarea' || element.tagName.toLowerCase() === 'input');
	};
	exports.isTextareaOrInput = isTextareaOrInput;
	var normalizePluginArray = function (plugins) {
	    if (typeof plugins === 'undefined' || plugins === '') {
	        return [];
	    }
	    return Array.isArray(plugins) ? plugins : plugins.split(' ');
	};
	// eslint-disable-next-line max-len
	var mergePlugins = function (initPlugins, inputPlugins) { return normalizePluginArray(initPlugins).concat(normalizePluginArray(inputPlugins)); };
	exports.mergePlugins = mergePlugins;
	var isBeforeInputEventAvailable = function () { return window.InputEvent && typeof InputEvent.prototype.getTargetRanges === 'function'; };
	exports.isBeforeInputEventAvailable = isBeforeInputEventAvailable;
	var isInDoc = function (elem) {
	    if (!('isConnected' in Node.prototype)) {
	        // Fallback for IE and old Edge
	        var current = elem;
	        var parent_1 = elem.parentNode;
	        while (parent_1 != null) {
	            current = parent_1;
	            parent_1 = current.parentNode;
	        }
	        return current === elem.ownerDocument;
	    }
	    return elem.isConnected;
	};
	exports.isInDoc = isInDoc;
	var setMode = function (editor, mode) {
	    if (editor !== undefined) {
	        if (editor.mode != null && typeof editor.mode === 'object' && typeof editor.mode.set === 'function') {
	            editor.mode.set(mode);
	        }
	        else { // support TinyMCE 4
	            editor.setMode(mode);
	        }
	    }
	};
	exports.setMode = setMode;


/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright (c) 2017-present, Ephox, Inc.
	 *
	 * This source code is licensed under the Apache 2 license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.EditorPropTypes = exports.eventPropTypes = void 0;
	var PropTypes = __webpack_require__(3);
	exports.eventPropTypes = {
	    onActivate: PropTypes.func,
	    onAddUndo: PropTypes.func,
	    onBeforeAddUndo: PropTypes.func,
	    onBeforeExecCommand: PropTypes.func,
	    onBeforeGetContent: PropTypes.func,
	    onBeforeRenderUI: PropTypes.func,
	    onBeforeSetContent: PropTypes.func,
	    onBeforePaste: PropTypes.func,
	    onBlur: PropTypes.func,
	    onChange: PropTypes.func,
	    onClearUndos: PropTypes.func,
	    onClick: PropTypes.func,
	    onContextMenu: PropTypes.func,
	    onCopy: PropTypes.func,
	    onCut: PropTypes.func,
	    onDblclick: PropTypes.func,
	    onDeactivate: PropTypes.func,
	    onDirty: PropTypes.func,
	    onDrag: PropTypes.func,
	    onDragDrop: PropTypes.func,
	    onDragEnd: PropTypes.func,
	    onDragGesture: PropTypes.func,
	    onDragOver: PropTypes.func,
	    onDrop: PropTypes.func,
	    onExecCommand: PropTypes.func,
	    onFocus: PropTypes.func,
	    onFocusIn: PropTypes.func,
	    onFocusOut: PropTypes.func,
	    onGetContent: PropTypes.func,
	    onHide: PropTypes.func,
	    onInit: PropTypes.func,
	    onKeyDown: PropTypes.func,
	    onKeyPress: PropTypes.func,
	    onKeyUp: PropTypes.func,
	    onLoadContent: PropTypes.func,
	    onMouseDown: PropTypes.func,
	    onMouseEnter: PropTypes.func,
	    onMouseLeave: PropTypes.func,
	    onMouseMove: PropTypes.func,
	    onMouseOut: PropTypes.func,
	    onMouseOver: PropTypes.func,
	    onMouseUp: PropTypes.func,
	    onNodeChange: PropTypes.func,
	    onObjectResizeStart: PropTypes.func,
	    onObjectResized: PropTypes.func,
	    onObjectSelected: PropTypes.func,
	    onPaste: PropTypes.func,
	    onPostProcess: PropTypes.func,
	    onPostRender: PropTypes.func,
	    onPreProcess: PropTypes.func,
	    onProgressState: PropTypes.func,
	    onRedo: PropTypes.func,
	    onRemove: PropTypes.func,
	    onReset: PropTypes.func,
	    onSaveContent: PropTypes.func,
	    onSelectionChange: PropTypes.func,
	    onSetAttrib: PropTypes.func,
	    onSetContent: PropTypes.func,
	    onShow: PropTypes.func,
	    onSubmit: PropTypes.func,
	    onUndo: PropTypes.func,
	    onVisualAid: PropTypes.func
	};
	exports.EditorPropTypes = __assign({ apiKey: PropTypes.string, id: PropTypes.string, inline: PropTypes.bool, init: PropTypes.object, initialValue: PropTypes.string, onEditorChange: PropTypes.func, outputFormat: PropTypes.oneOf(['html', 'text']), value: PropTypes.string, tagName: PropTypes.string, cloudChannel: PropTypes.string, plugins: PropTypes.oneOfType([PropTypes.string, PropTypes.array]), toolbar: PropTypes.oneOfType([PropTypes.string, PropTypes.array]), disabled: PropTypes.bool, textareaName: PropTypes.string, tinymceScriptSrc: PropTypes.string, rollback: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf([false])]), scriptLoading: PropTypes.shape({
	        async: PropTypes.bool,
	        defer: PropTypes.bool,
	        delay: PropTypes.number
	    }) }, exports.eventPropTypes);


/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(63);
	var settle = __webpack_require__(854);
	var cookies = __webpack_require__(857);
	var buildURL = __webpack_require__(356);
	var buildFullPath = __webpack_require__(852);
	var parseHeaders = __webpack_require__(862);
	var isURLSameOrigin = __webpack_require__(860);
	var createError = __webpack_require__(352);
	
	module.exports = function xhrAdapter(config) {
	  return new Promise(function dispatchXhrRequest(resolve, reject) {
	    var requestData = config.data;
	    var requestHeaders = config.headers;
	    var responseType = config.responseType;
	
	    if (utils.isFormData(requestData)) {
	      delete requestHeaders['Content-Type']; // Let the browser set it
	    }
	
	    var request = new XMLHttpRequest();
	
	    // HTTP basic authentication
	    if (config.auth) {
	      var username = config.auth.username || '';
	      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
	      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
	    }
	
	    var fullPath = buildFullPath(config.baseURL, config.url);
	    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);
	
	    // Set the request timeout in MS
	    request.timeout = config.timeout;
	
	    function onloadend() {
	      if (!request) {
	        return;
	      }
	      // Prepare the response
	      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
	      var responseData = !responseType || responseType === 'text' ||  responseType === 'json' ?
	        request.responseText : request.response;
	      var response = {
	        data: responseData,
	        status: request.status,
	        statusText: request.statusText,
	        headers: responseHeaders,
	        config: config,
	        request: request
	      };
	
	      settle(resolve, reject, response);
	
	      // Clean up request
	      request = null;
	    }
	
	    if ('onloadend' in request) {
	      // Use onloadend if available
	      request.onloadend = onloadend;
	    } else {
	      // Listen for ready state to emulate onloadend
	      request.onreadystatechange = function handleLoad() {
	        if (!request || request.readyState !== 4) {
	          return;
	        }
	
	        // The request errored out and we didn't get a response, this will be
	        // handled by onerror instead
	        // With one exception: request that using file: protocol, most browsers
	        // will return status as 0 even though it's a successful request
	        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
	          return;
	        }
	        // readystate handler is calling before onerror or ontimeout handlers,
	        // so we should call onloadend on the next 'tick'
	        setTimeout(onloadend);
	      };
	    }
	
	    // Handle browser request cancellation (as opposed to a manual cancellation)
	    request.onabort = function handleAbort() {
	      if (!request) {
	        return;
	      }
	
	      reject(createError('Request aborted', config, 'ECONNABORTED', request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle low level network errors
	    request.onerror = function handleError() {
	      // Real errors are hidden from us by the browser
	      // onerror should only fire if it's a network error
	      reject(createError('Network Error', config, null, request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle timeout
	    request.ontimeout = function handleTimeout() {
	      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
	      if (config.timeoutErrorMessage) {
	        timeoutErrorMessage = config.timeoutErrorMessage;
	      }
	      reject(createError(
	        timeoutErrorMessage,
	        config,
	        config.transitional && config.transitional.clarifyTimeoutError ? 'ETIMEDOUT' : 'ECONNABORTED',
	        request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Add xsrf header
	    // This is only done if running in a standard browser environment.
	    // Specifically not if we're in a web worker, or react-native.
	    if (utils.isStandardBrowserEnv()) {
	      // Add xsrf header
	      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
	        cookies.read(config.xsrfCookieName) :
	        undefined;
	
	      if (xsrfValue) {
	        requestHeaders[config.xsrfHeaderName] = xsrfValue;
	      }
	    }
	
	    // Add headers to the request
	    if ('setRequestHeader' in request) {
	      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
	        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
	          // Remove Content-Type if data is undefined
	          delete requestHeaders[key];
	        } else {
	          // Otherwise add header to the request
	          request.setRequestHeader(key, val);
	        }
	      });
	    }
	
	    // Add withCredentials to request if needed
	    if (!utils.isUndefined(config.withCredentials)) {
	      request.withCredentials = !!config.withCredentials;
	    }
	
	    // Add responseType to request if needed
	    if (responseType && responseType !== 'json') {
	      request.responseType = config.responseType;
	    }
	
	    // Handle progress if needed
	    if (typeof config.onDownloadProgress === 'function') {
	      request.addEventListener('progress', config.onDownloadProgress);
	    }
	
	    // Not all browsers support upload events
	    if (typeof config.onUploadProgress === 'function' && request.upload) {
	      request.upload.addEventListener('progress', config.onUploadProgress);
	    }
	
	    if (config.cancelToken) {
	      // Handle cancellation
	      config.cancelToken.promise.then(function onCanceled(cancel) {
	        if (!request) {
	          return;
	        }
	
	        request.abort();
	        reject(cancel);
	        // Clean up request
	        request = null;
	      });
	    }
	
	    if (!requestData) {
	      requestData = null;
	    }
	
	    // Send the request
	    request.send(requestData);
	  });
	};


/***/ },
/* 350 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * A `Cancel` is an object that is thrown when an operation is canceled.
	 *
	 * @class
	 * @param {string=} message The message.
	 */
	function Cancel(message) {
	  this.message = message;
	}
	
	Cancel.prototype.toString = function toString() {
	  return 'Cancel' + (this.message ? ': ' + this.message : '');
	};
	
	Cancel.prototype.__CANCEL__ = true;
	
	module.exports = Cancel;


/***/ },
/* 351 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function isCancel(value) {
	  return !!(value && value.__CANCEL__);
	};


/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var enhanceError = __webpack_require__(353);
	
	/**
	 * Create an Error with the specified message, config, error code, request and response.
	 *
	 * @param {string} message The error message.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The created error.
	 */
	module.exports = function createError(message, config, code, request, response) {
	  var error = new Error(message);
	  return enhanceError(error, config, code, request, response);
	};


/***/ },
/* 353 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Update an Error with the specified config, error code, and response.
	 *
	 * @param {Error} error The error to update.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The error.
	 */
	module.exports = function enhanceError(error, config, code, request, response) {
	  error.config = config;
	  if (code) {
	    error.code = code;
	  }
	
	  error.request = request;
	  error.response = response;
	  error.isAxiosError = true;
	
	  error.toJSON = function toJSON() {
	    return {
	      // Standard
	      message: this.message,
	      name: this.name,
	      // Microsoft
	      description: this.description,
	      number: this.number,
	      // Mozilla
	      fileName: this.fileName,
	      lineNumber: this.lineNumber,
	      columnNumber: this.columnNumber,
	      stack: this.stack,
	      // Axios
	      config: this.config,
	      code: this.code
	    };
	  };
	  return error;
	};


/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(63);
	
	/**
	 * Config-specific merge-function which creates a new config-object
	 * by merging two configuration objects together.
	 *
	 * @param {Object} config1
	 * @param {Object} config2
	 * @returns {Object} New object resulting from merging config2 to config1
	 */
	module.exports = function mergeConfig(config1, config2) {
	  // eslint-disable-next-line no-param-reassign
	  config2 = config2 || {};
	  var config = {};
	
	  var valueFromConfig2Keys = ['url', 'method', 'data'];
	  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy', 'params'];
	  var defaultToConfig2Keys = [
	    'baseURL', 'transformRequest', 'transformResponse', 'paramsSerializer',
	    'timeout', 'timeoutMessage', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
	    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress', 'decompress',
	    'maxContentLength', 'maxBodyLength', 'maxRedirects', 'transport', 'httpAgent',
	    'httpsAgent', 'cancelToken', 'socketPath', 'responseEncoding'
	  ];
	  var directMergeKeys = ['validateStatus'];
	
	  function getMergedValue(target, source) {
	    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
	      return utils.merge(target, source);
	    } else if (utils.isPlainObject(source)) {
	      return utils.merge({}, source);
	    } else if (utils.isArray(source)) {
	      return source.slice();
	    }
	    return source;
	  }
	
	  function mergeDeepProperties(prop) {
	    if (!utils.isUndefined(config2[prop])) {
	      config[prop] = getMergedValue(config1[prop], config2[prop]);
	    } else if (!utils.isUndefined(config1[prop])) {
	      config[prop] = getMergedValue(undefined, config1[prop]);
	    }
	  }
	
	  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
	    if (!utils.isUndefined(config2[prop])) {
	      config[prop] = getMergedValue(undefined, config2[prop]);
	    }
	  });
	
	  utils.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);
	
	  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
	    if (!utils.isUndefined(config2[prop])) {
	      config[prop] = getMergedValue(undefined, config2[prop]);
	    } else if (!utils.isUndefined(config1[prop])) {
	      config[prop] = getMergedValue(undefined, config1[prop]);
	    }
	  });
	
	  utils.forEach(directMergeKeys, function merge(prop) {
	    if (prop in config2) {
	      config[prop] = getMergedValue(config1[prop], config2[prop]);
	    } else if (prop in config1) {
	      config[prop] = getMergedValue(undefined, config1[prop]);
	    }
	  });
	
	  var axiosKeys = valueFromConfig2Keys
	    .concat(mergeDeepPropertiesKeys)
	    .concat(defaultToConfig2Keys)
	    .concat(directMergeKeys);
	
	  var otherKeys = Object
	    .keys(config1)
	    .concat(Object.keys(config2))
	    .filter(function filterAxiosKeys(key) {
	      return axiosKeys.indexOf(key) === -1;
	    });
	
	  utils.forEach(otherKeys, mergeDeepProperties);
	
	  return config;
	};


/***/ },
/* 355 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function bind(fn, thisArg) {
	  return function wrap() {
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	    return fn.apply(thisArg, args);
	  };
	};


/***/ },
/* 356 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(63);
	
	function encode(val) {
	  return encodeURIComponent(val).
	    replace(/%3A/gi, ':').
	    replace(/%24/g, '$').
	    replace(/%2C/gi, ',').
	    replace(/%20/g, '+').
	    replace(/%5B/gi, '[').
	    replace(/%5D/gi, ']');
	}
	
	/**
	 * Build a URL by appending params to the end
	 *
	 * @param {string} url The base of the url (e.g., http://www.google.com)
	 * @param {object} [params] The params to be appended
	 * @returns {string} The formatted url
	 */
	module.exports = function buildURL(url, params, paramsSerializer) {
	  /*eslint no-param-reassign:0*/
	  if (!params) {
	    return url;
	  }
	
	  var serializedParams;
	  if (paramsSerializer) {
	    serializedParams = paramsSerializer(params);
	  } else if (utils.isURLSearchParams(params)) {
	    serializedParams = params.toString();
	  } else {
	    var parts = [];
	
	    utils.forEach(params, function serialize(val, key) {
	      if (val === null || typeof val === 'undefined') {
	        return;
	      }
	
	      if (utils.isArray(val)) {
	        key = key + '[]';
	      } else {
	        val = [val];
	      }
	
	      utils.forEach(val, function parseValue(v) {
	        if (utils.isDate(v)) {
	          v = v.toISOString();
	        } else if (utils.isObject(v)) {
	          v = JSON.stringify(v);
	        }
	        parts.push(encode(key) + '=' + encode(v));
	      });
	    });
	
	    serializedParams = parts.join('&');
	  }
	
	  if (serializedParams) {
	    var hashmarkIndex = url.indexOf('#');
	    if (hashmarkIndex !== -1) {
	      url = url.slice(0, hashmarkIndex);
	    }
	
	    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
	  }
	
	  return url;
	};


/***/ },
/* 357 */
185,
/* 358 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constant = __webpack_require__(21);
	
	var _reactHelmet = __webpack_require__(77);
	
	var _bewise_logo_mini = __webpack_require__(1633);
	
	var _bewise_logo_mini2 = _interopRequireDefault(_bewise_logo_mini);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HeaderNew = function (_Component) {
	  _inherits(HeaderNew, _Component);
	
	  function HeaderNew(props) {
	    _classCallCheck(this, HeaderNew);
	
	    var _this = _possibleConstructorReturn(this, (HeaderNew.__proto__ || Object.getPrototypeOf(HeaderNew)).call(this, props));
	
	    _this.handleScroll = function () {
	
	      if (window.scrollY >= 800) {
	        _this.setState({ tabmoved: true });
	      } else {
	        _this.setState({ tabmoved: false });
	      }
	    };
	
	    _this.toggleOpenTab1 = function (e) {
	      _this.props.toggleOpenTab1();
	      _this.setState({ schoolpreschoolselected: true, otherselected: false });
	      window.scrollTo(150, 300);
	    };
	
	    _this.toggleOpenTab2 = function (e) {
	      _this.props.toggleOpenTab2();
	      _this.setState({ schoolpreschoolselected: false, otherselected: true });
	      window.scrollTo(150, 300);
	    };
	
	    var path = window.location.pathname;
	    _this.state = {
	      authe: false,
	      tabmoved: false,
	      logged_user_name: "",
	      login_path: path == '/' ? '/admin_login' : '/login',
	      signup_path: path == 'individual' ? '/individual_signup' : '/institution_signup'
	    };
	    _this.handleScroll = _this.handleScroll.bind(_this);
	    _this.toggleOpenTab1 = _this.toggleOpenTab1.bind(_this);
	    _this.toggleOpenTab2 = _this.toggleOpenTab2.bind(_this);
	    return _this;
	  }
	
	  _createClass(HeaderNew, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      console.log('window.location.pathname', window.location.pathname);
	      var logged = localStorage.getItem("authentication");
	      var auth_data = JSON.parse(localStorage.getItem("user_data"));
	      console.log("auth_data", typeof logged === "undefined" ? "undefined" : _typeof(logged));
	      if (auth_data) {
	        this.setState({
	          authe: logged == "true" ? true : false,
	          logged_user_name: auth_data.user_name
	        });
	      }
	      var schoolpreschoolselected = this.props.schoolpreschoolselected;
	      var otherselected = this.props.otherselected;
	      this.setState({ schoolpreschoolselected: schoolpreschoolselected, otherselected: otherselected });
	
	      window.addEventListener('scroll', this.handleScroll);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      window.removeEventListener('scroll', this.handleScroll);
	    }
	  }, {
	    key: "logoutSess",
	    value: function logoutSess(e) {
	      localStorage.clear();
	      setTimeout(function () {
	        window.location = "/";
	      }, 1000);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var tabmoved = this.state.tabmoved;
	
	
	      return _react2.default.createElement(
	        "div",
	        { style: {
	            position: "fixed",
	            zIndex: "999",
	            background: "#fff",
	            width: "100%",
	            top: 0
	          }, "class": "container-fluid" },
	        _react2.default.createElement(
	          "div",
	          { className: "tranparent-header-custom-inner" },
	          _react2.default.createElement(
	            "div",
	            { className: "container-fluid" },
	            _react2.default.createElement(
	              "div",
	              { className: "row display-flex-center header-custom stickymenu sticky-top desktop" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-lg-3 col-md-3 col-sm-3 bewise-logo-block" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "bewise-logo active" },
	                  _react2.default.createElement(
	                    "div",
	                    { "class": "row  display-flex-center" },
	                    _react2.default.createElement(
	                      "div",
	                      null,
	                      _react2.default.createElement(
	                        "a",
	                        { className: "logo-text", href: "/" },
	                        _react2.default.createElement("img", { src: _bewise_logo_mini2.default, className: "mainlogoimg", style: { width: "100%", marginRight: "2px" } })
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-lg-6 col-md-6 col-sm-6", style: { textAlign: "center" } },
	                _react2.default.createElement(
	                  "div",
	                  { className: "topheading mainsearchareatop s003", style: { display: "none" } },
	                  _react2.default.createElement(
	                    "div",
	                    { "class": "bheader" },
	                    "Welcome to ",
	                    _react2.default.createElement(
	                      "span",
	                      { className: "bluetext" },
	                      "BeWise"
	                    ),
	                    " Partner Program"
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-lg-3 col-md-3 col-sm-3 text-right bewise-signin-block" },
	                _react2.default.createElement(
	                  "a",
	                  { href: "/login", className: "nsignbtn" },
	                  "Sign In"
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "mobile" },
	              _react2.default.createElement(
	                "div",
	                { "class": "mobiletopmenu" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "bewise-logo-block", style: { paddingLeft: "0px" } },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "bewise-logo active" },
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "leftLogo" },
	                      _react2.default.createElement(
	                        "a",
	                        { className: "logo-text", href: "/" },
	                        _react2.default.createElement("img", { src: _bewise_logo_mini2.default, className: "mainlogoimg", style: { width: "55px", marginRight: "2px" } })
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "text-right bewise-signin-block" },
	                  _react2.default.createElement(
	                    "a",
	                    { href: "/login", className: "nsignbtn" },
	                    "Sign In"
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "row align-items-center mobile slogn" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-sm-12", style: { textAlign: "center" } },
	                _react2.default.createElement(
	                  "div",
	                  { "class": "bheader" },
	                  "Welcome to ",
	                  _react2.default.createElement(
	                    "span",
	                    { className: "blue2text" },
	                    "BeWise"
	                  ),
	                  " Partner Program"
	                )
	              )
	            )
	          )
	        ),
	        tabmoved && _react2.default.createElement(
	          "div",
	          { "class": "partnerpricepage topheaders" },
	          _react2.default.createElement(
	            "div",
	            { "class": "tabs" },
	            _react2.default.createElement(
	              "div",
	              { "class": "tabby-tab" },
	              _react2.default.createElement("input", { type: "radio", id: "tab-2", name: "tabby-tabs" }),
	              _react2.default.createElement(
	                "label",
	                { id: "tab11", className: this.props.schoolpreschoolselected === true ? 'active' : '', "for": "tab-2", onClick: this.toggleOpenTab1 },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  "Schools & Pre-Schools"
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { "class": "tabby-tab" },
	              _react2.default.createElement("input", { type: "radio", id: "tab-3", name: "tabby-tabs" }),
	              _react2.default.createElement(
	                "label",
	                { id: "tab12", className: this.props.otherselected === true ? 'active' : '', "for": "tab-3", onClick: this.toggleOpenTab2 },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  "All Others"
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return HeaderNew;
	}(_react.Component);
	
	exports.default = HeaderNew;

/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _kendoReactPdf = __webpack_require__(244);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DocService = function DocService() {
	  _classCallCheck(this, DocService);
	
	  this.createPdf = function (html) {
	    (0, _kendoReactPdf.savePDF)(html, {
	      //   paperSize: 'Letter',
	      fileName: 'invoice.pdf',
	      margin: 30,
	      fontSize: 12
	    });
	  };
	
	  this.createComparePdf = function (html) {
	    (0, _kendoReactPdf.savePDF)(html, {
	      //   paperSize: 'Letter',
	      fileName: 'invoice.pdf',
	      margin: 150,
	      fontSize: 12
	    });
	  };
	};
	
	var Doc = new DocService();
	exports.default = Doc;

/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import jQuery from 'jquery';
	
	var BeWise_Footer = function (_React$Component) {
	    _inherits(BeWise_Footer, _React$Component);
	
	    function BeWise_Footer(props) {
	        _classCallCheck(this, BeWise_Footer);
	
	        //const { history } = this.props;
	        var _this = _possibleConstructorReturn(this, (BeWise_Footer.__proto__ || Object.getPrototypeOf(BeWise_Footer)).call(this, props));
	
	        _this.state = {
	            logged_user_name: ''
	        };
	        return _this;
	    }
	
	    _createClass(BeWise_Footer, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	
	            // console.log('user data', this.state.auth_data)
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _react2.default.createElement(
	                    'footer',
	                    { 'class': 'footer' },
	                    _react2.default.createElement(
	                        'div',
	                        { 'class': 'text-right' },
	                        _react2.default.createElement(
	                            'span',
	                            { 'class': 'text-center text-sm-left d-block d-sm-inline-block black-text' },
	                            'Copyright \xA9 ',
	                            _react2.default.createElement(
	                                'a',
	                                { href: 'https://www.bewise.in/', target: '_blank' },
	                                'BeWise'
	                            ),
	                            ' 2023'
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return BeWise_Footer;
	}(_react2.default.Component);
	
	exports.default = BeWise_Footer;

/***/ },
/* 361 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import jQuery from 'jquery';
	
	
	var BeWise_Header = function (_React$Component) {
	  _inherits(BeWise_Header, _React$Component);
	
	  function BeWise_Header(props) {
	    _classCallCheck(this, BeWise_Header);
	
	    //const { history } = this.props;
	    var _this = _possibleConstructorReturn(this, (BeWise_Header.__proto__ || Object.getPrototypeOf(BeWise_Header)).call(this, props));
	
	    _this.state = {
	      logged_user_name: ''
	    };
	    return _this;
	  }
	
	  _createClass(BeWise_Header, [{
	    key: 'logoutSess',
	    value: function logoutSess(e) {
	      localStorage.clear();
	      setTimeout(function () {
	        window.location = '/login';
	      }, 1000);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	
	      // console.log('user data', this.state.auth_data)
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          'nav',
	          { 'class': 'navbar col-lg-12 col-12 p-0 fixed-top d-flex flex-row c' },
	          _react2.default.createElement(
	            'div',
	            { 'class': 'text-center navbar-brand-wrapper d-flex align-items-center justify-content-space-between' },
	            _react2.default.createElement(
	              'a',
	              { 'class': 'navbar-brand brand-logo' },
	              _react2.default.createElement('img', { src: '/images/bewiseLogo.png', alt: 'BeWise' })
	            ),
	            _react2.default.createElement(
	              'a',
	              { 'class': 'navbar-brand brand-logo-mini' },
	              _react2.default.createElement('img', { src: '/images/bewise-logo-mini.png', alt: 'BeWise' })
	            ),
	            _react2.default.createElement(
	              'button',
	              { 'class': 'navbar-toggler navbar-toggler align-self-center d-none d-lg-flex', type: 'button', 'data-toggle': 'minimize' },
	              _react2.default.createElement('span', { 'class': 'typcn typcn-th-menu' })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { 'class': 'navbar-menu-wrapper d-flex align-items-center justify-content-end' },
	            _react2.default.createElement(
	              'ul',
	              { 'class': 'navbar-nav navbar-nav-right' },
	              _react2.default.createElement(
	                'li',
	                { 'class': 'nav-item nav-profile dropdown' },
	                _react2.default.createElement(
	                  'a',
	                  { 'class': 'nav-link dropdown-toggle  pl-0 pr-0', href: '#', 'data-toggle': 'dropdown', id: 'profileDropdown' },
	                  _react2.default.createElement('i', { 'class': 'typcn typcn-user-outline mr-0' }),
	                  _react2.default.createElement(
	                    'span',
	                    { 'class': 'nav-profile-name' },
	                    this.state.nickname
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'dropdown-menu dropdown-menu-right navbar-dropdown', 'aria-labelledby': 'profileDropdown' },
	                  _react2.default.createElement(
	                    'a',
	                    { 'class': 'dropdown-item', onClick: function onClick() {
	                        return _this2.logoutSess();
	                      } },
	                    _react2.default.createElement('i', { 'class': 'typcn typcn-power text-primary' }),
	                    'Logout'
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'button',
	              { 'class': 'navbar-toggler navbar-toggler-right d-lg-none align-self-center', type: 'button', 'data-toggle': 'offcanvas' },
	              _react2.default.createElement('span', { 'class': 'typcn typcn-th-menu' })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return BeWise_Header;
	}(_react2.default.Component);
	
	exports.default = BeWise_Header;

/***/ },
/* 362 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FetchCall = __webpack_require__(4);
	
	var _sweetalert = __webpack_require__(174);
	
	var _sweetalert2 = _interopRequireDefault(_sweetalert);
	
	var _reactAutosuggest = __webpack_require__(86);
	
	var _reactAutosuggest2 = _interopRequireDefault(_reactAutosuggest);
	
	var _constant = __webpack_require__(21);
	
	var _reactTooltip = __webpack_require__(133);
	
	var _reactTooltip2 = _interopRequireDefault(_reactTooltip);
	
	__webpack_require__(18);
	
	var _reactNotifications = __webpack_require__(16);
	
	var _simpleReactValidator = __webpack_require__(28);
	
	var _simpleReactValidator2 = _interopRequireDefault(_simpleReactValidator);
	
	var _reactDataTableComponent = __webpack_require__(53);
	
	var _reactDataTableComponent2 = _interopRequireDefault(_reactDataTableComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//$.DataTable = require('datatables.net')
	var $ = __webpack_require__(5);
	/*
	{ data: 'org_name' },
	{ data: 'email_id' },
	{ data: 'category_name' },
	{ data: 'branch' },
	{ data: 'action' },
	*/
	var customStyles = {
	    headCells: {
	        style: {
	            fontWeight: 'bold'
	        }
	    }
	};
	
	var columns_af = [{
	    name: 'Org',
	    selector: function selector(row) {
	        return row.org_name;
	    },
	    sortable: true
	}, {
	    name: 'No of Persons',
	    selector: function selector(row) {
	        return row.email_id;
	    }
	}, {
	    name: 'Month',
	    selector: function selector(row) {
	        return row.category_name;
	    }
	}, {
	    name: 'Month',
	    selector: function selector(row) {
	        return row.branch;
	    }
	}, {
	    name: 'Month',
	    selector: function selector(row) {
	        return row.action;
	    }
	}];
	
	var Branch = function (_Component) {
	    _inherits(Branch, _Component);
	
	    function Branch(props) {
	        var _this2 = this;
	
	        _classCallCheck(this, Branch);
	
	        var _this = _possibleConstructorReturn(this, (Branch.__proto__ || Object.getPrototypeOf(Branch)).call(this, props));
	
	        _this.getCategories = function (cids) {
	
	            var req = JSON.stringify({
	                cids: cids
	            });
	
	            (0, _FetchCall.fetch_category_by_ids)(req).then(function (res) {
	
	                if (res.status === 1) {
	                    var cat_list = res.category_data;
	                    _this.setState({
	                        cat_list: cat_list.result
	                    });
	                }
	            });
	        };
	
	        _this.onChange = function (event, _ref) {
	            var newValue = _ref.newValue,
	                method = _ref.method;
	
	            _this.setState({
	                e_org_name: newValue
	            });
	        };
	
	        _this.onChange_e = function (event, _ref2) {
	            var newValue = _ref2.newValue,
	                method = _ref2.method;
	
	            _this.setState({
	                e_org_name: newValue
	            });
	        };
	
	        _this.handlePaste = function (e) {
	            _this.Geocode_location();
	        };
	
	        _this.handlePaste = function (e) {
	            _this.Geocode_location();
	        };
	
	        _this.handleChange = function (e) {
	            var propName = e.target.name;
	            _this.setState(_defineProperty({}, e.target.name, e.target.value));
	        };
	
	        _this.handleSelect = function (e) {
	            var propName = e.target.name;
	            var value = [].concat(_toConsumableArray(e.target.selectedOptions)).map(function (item) {
	                return item.value;
	            });
	            _this.setState(_defineProperty({}, propName, value));
	        };
	
	        _this.shouldRenderSuggestions = function (value, reason) {
	            return value.trim().length > 2;
	        };
	
	        _this.onSuggestionsFetchRequested = function (_ref3) {
	            var value = _ref3.value;
	
	            var val = _this.escapeRegexCharacters(value.trim());
	            var login_id = _this.state.user_data.login_id;
	            var fetch = JSON.stringify({
	                keyword: val,
	                login_id: login_id,
	                url: 'getDataByName'
	            });
	            (0, _FetchCall.partnerApi)(fetch).then(function (res) {
	                if (res.status == 1) {
	                    _this.setState({
	                        suggestions: res.result
	                    });
	                }
	            });
	        };
	
	        _this.onSuggestionsClearRequested = function () {
	            _this.setState({
	                suggestions: []
	            });
	        };
	
	        _this.getSuggestionValue = function (suggestion) {
	            _this.setState({ confirmModal: true });
	            var currentData = suggestion;
	            currentData.url = 'getDataById';
	            var data = JSON.stringify(currentData);
	            (0, _FetchCall.partnerApi)(data).then(function (res) {
	                if (res.status === 1) {
	                    var _data = res.result;
	                    _this.setState({
	                        registration_no: _data.organisation_register_number,
	                        address: _data.address,
	                        google_address: _data.google_address,
	                        city: _data.location,
	                        state: _data.state,
	                        pincode: _data.pin_code,
	                        contact_number: _data.institution_contact_number,
	                        email: _data.institution_email_address,
	                        social_media: _data.social_link,
	                        social_media_link: _data.social_media_link,
	                        social_link_data: _data.social_link_data ? JSON.parse(_data.social_link_data) : _this.state.social_link_data
	                    });
	                } else {
	                    _this.setState({
	                        registration_no: '',
	                        address: '',
	                        google_address: '',
	                        city: '',
	                        state: '',
	                        pincode: '',
	                        contact_number: '',
	                        email: '',
	                        social_media: '',
	                        social_media_link: '',
	                        social_link_data: _this.state.social_link_data
	                    });
	                }
	            });
	            return suggestion.name;
	        };
	
	        _this.getEditProfileData = function () {
	            var user_type = _this.state.user_data.user_type;
	            var e_vendor_id = _this.state.e_vendor_id;
	
	
	            var req = JSON.stringify({
	                vendor_id: e_vendor_id,
	                url: 'getSpecificVendorInfo'
	            });
	            (0, _FetchCall.partnerApi)(req).then(function (res) {
	                if (res.status === 1) {
	                    var data = res.result;
	                    //this.Geocode_location(data.address);
	
	                    if (user_type === 1) {
	                        _this.setState({
	                            e_vendor_id: data.vendor_id,
	                            e_registration_no: data.organisation_register_number,
	                            e_org_name: data.organisation_name,
	                            e_temp_org_name: data.organisation_name,
	                            e_first_name: '',
	                            e_last_name: '',
	                            e_address: data.address,
	                            e_temp_org_address: data.address,
	                            e_google_address: data.address,
	                            e_city: data.location,
	                            e_state: data.state,
	                            e_pincode: data.pin_code,
	                            e_email: data.institution_email_address,
	                            e_social_link_data: data.social_link_data ? JSON.parse(data.social_link_data) : _this.state.social_link_data,
	                            e_contact_number: data.phone_number,
	                            e_landline: data.landline_number,
	                            e_social_media: data.social_link,
	                            e_social_media_link: data.social_media_link,
	                            e_main_access: data.main_access
	
	                        });
	                    } else if (user_type === 2) {
	                        _this.setState({
	                            e_vendor_id: data.vendor_id,
	                            e_main_id: data.main_id ? data.main_id : 0,
	                            e_registration_no: '',
	                            e_org_name: '',
	                            e_first_name: data.first_name,
	                            e_last_name: data.last_name,
	                            e_address: data.address,
	                            e_google_address: data.address,
	                            e_city: data.location,
	                            e_state: data.state,
	                            e_pincode: data.pin_code,
	                            e_email: data.email_id,
	                            e_contact_number: data.phone_number,
	                            e_landline: data.landline_number,
	                            e_social_media: data.social_link,
	                            e_social_media_link: data.social_media_link,
	                            e_main_access: data.main_access
	
	                        });
	                    }
	                    _this.setState({
	                        e_location_list: res.location,
	                        e_master_data: data.master_data,
	                        e_uids: data.uids,
	                        e_cids: data.cids
	                    });
	
	                    _this.getCategories(data.cids);
	                }
	            });
	        };
	
	        _this.getProfileData = function () {
	            var _this$state$user_data = _this.state.user_data,
	                user_type = _this$state$user_data.user_type,
	                vendor_id = _this$state$user_data.vendor_id,
	                login_id = _this$state$user_data.login_id,
	                is_completd = _this$state$user_data.is_completd,
	                current_category = _this$state$user_data.current_category,
	                set_id = _this$state$user_data.set_id;
	
	
	            var req = JSON.stringify({
	                vendor_id: vendor_id,
	                url: 'getSpecificVendorInfo'
	            });
	            (0, _FetchCall.partnerApi)(req).then(function (res) {
	                if (res.status === 1) {
	                    var data = res.result;
	                    _this.Geocode_location(data.address);
	
	                    if (user_type === 1) {
	                        _this.setState({
	                            vendor_id: data.vendor_id,
	                            registration_no: data.organisation_register_number,
	                            org_name: data.organisation_name,
	                            temp_org_name: data.organisation_name,
	                            first_name: '',
	                            last_name: '',
	                            address: data.address,
	                            temp_org_address: data.address,
	                            google_address: data.address,
	                            city: data.location,
	                            state: data.state,
	                            pincode: data.pin_code,
	                            email: data.institution_email_address,
	                            social_link_data: data.social_link_data ? JSON.parse(data.social_link_data) : _this.state.social_link_data,
	                            contact_number: data.phone_number,
	                            landline: data.landline_number,
	                            social_media: data.social_link,
	                            social_media_link: data.social_media_link,
	                            main_access: data.main_access,
	                            is_completd: data.is_completd
	                        });
	                    } else if (user_type === 2) {
	                        _this.setState({
	                            vendor_id: data.vendor_id,
	                            main_id: data.main_id ? data.main_id : 0,
	                            registration_no: '',
	                            org_name: '',
	                            first_name: data.first_name,
	                            last_name: data.last_name,
	                            address: data.address,
	                            google_address: data.address,
	                            city: data.location,
	                            state: data.state,
	                            pincode: data.pin_code,
	                            email: data.email_id,
	                            contact_number: data.phone_number,
	                            landline: data.landline_number,
	                            social_media: data.social_link,
	                            social_media_link: data.social_media_link,
	                            main_access: data.main_access,
	                            is_completd: data.is_completd
	                        });
	                    }
	                    _this.setState({
	                        location_list: res.location,
	                        master_data: data.master_data,
	                        uids: data.uids,
	                        cids: data.cids
	                    });
	
	                    _this.getCategories(data.cids);
	                }
	            });
	        };
	
	        _this.getpageData = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	            var _this$state$user_data2, user_type, login_id, insdata;
	
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            _this$state$user_data2 = _this.state.user_data, user_type = _this$state$user_data2.user_type, login_id = _this$state$user_data2.login_id;
	                            insdata = JSON.stringify({
	                                user_type: user_type,
	                                login_id: login_id,
	                                role: 3,
	                                url: 'getBranch'
	                            });
	                            _context.next = 4;
	                            return (0, _FetchCall.partnerBranch)(insdata).then(function (response) {
	                                if (response.status === 1) {
	                                    _this.setState({
	                                        dataSet: response.data
	                                    });
	                                    //this.datatabledata(response.data);
	                                }
	                            });
	
	                        case 4:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, _this2);
	        }));
	
	        _this.deleteBranch = function (delid) {
	            (0, _sweetalert2.default)({
	                title: "Are you sure to Delete Branch?",
	                text: "",
	                icon: "warning",
	                buttons: true,
	                dangerMode: true
	            }).then(function (willDelete) {
	                if (willDelete) {
	                    var user_data = _this.state.user_data;
	                    console.log('user_data', user_data);
	                    var req = JSON.stringify({
	                        login_id: user_data.login_id,
	                        set_id: delid,
	                        role: 3,
	                        url: 'deleteBranch'
	                    });
	                    (0, _FetchCall.partnerBranch)(req).then(function (res) {
	                        var toastr = '';
	                        if (res.status === 1) {
	                            alert("success");
	                            /*
	                            toastr = window.toastr.success;
	                            toastr('', res.message, {
	                                positionClass: "toast-bottom-right",
	                                containerId: "toast-bottom-right"
	                            });
	                            */
	                            setTimeout(function () {
	                                window.location.reload();
	                            }, 1000);
	                        } else {
	                            alert("failure");
	                            /*
	                            toastr = window.toastr.error; 
	                            toastr('', res.message, {
	                                positionClass: "toast-bottom-right",
	                                containerId: "toast-bottom-right"
	                            });
	                            */
	                        }
	                    });
	                }
	            });
	        };
	
	        _this.submitForm = function (e) {
	            e.preventDefault();
	            if (_this.validator.allValid()) {
	
	                //console.log(this.state.selected_cids);
	
	                if (_this.state.e_org_name == _this.state.temp_org_name) {
	
	                    console.log("Same name");
	                    _reactNotifications.NotificationManager.error("Name should not be the same as Head Office");
	                } else if (_this.state.e_address == _this.state.temp_org_address) {
	
	                    console.log("Address should not be same");
	                    _reactNotifications.NotificationManager.error("Branch Location and address should not be the same as Head Office");
	                } else {
	                    var _this$state$user_data3 = _this.state.user_data,
	                        user_type = _this$state$user_data3.user_type,
	                        login_id = _this$state$user_data3.login_id;
	
	                    var request = JSON.stringify({
	                        vendor_id: _this.state.vendor_id,
	                        user_type: user_type,
	                        master_data: _this.state.master_data,
	                        uids: _this.state.uids,
	                        cids: _this.state.cids,
	                        selected_cids: _this.state.selected_cids,
	                        login_id: login_id,
	                        is_completd: _this.state.is_completd,
	                        registration_no: _this.state.registration_no,
	                        org_name: _this.state.e_org_name,
	                        first_name: _this.state.e_first_name,
	                        city: _this.state.e_city,
	                        state: _this.state.e_state,
	                        pincode: _this.state.e_pincode,
	                        email: _this.state.e_email,
	                        contact_number: _this.state.e_contact_number,
	                        landline: _this.state.e_landline,
	                        social_media: _this.state.e_social_media,
	                        social_media_link: _this.state.e_social_media_link,
	                        social_link_data: JSON.stringify(_this.state.social_link_data),
	                        access: _this.state.access,
	                        sub_category: _this.state.sub_category,
	                        main_access: _this.state.main_access,
	                        type_one: _this.state.type_one,
	                        type_two: _this.state.type_two
	                    });
	
	                    //console.log(request);
	
	                    (0, _FetchCall.partnerUpdateBranch)(request).then(function (res) {
	                        if (res.status === 1) {
	                            _reactNotifications.NotificationManager.success(res.message);
	                            _this.setState({ editclicked: false });
	                        } else {
	                            _reactNotifications.NotificationManager.error(res.message);
	                            _this.setState({ editclicked: true });
	                        }
	                    });
	                }
	            } else {
	                _this.validator.showMessages();
	                _this.forceUpdate();
	            }
	        };
	
	        _this.state = {
	            editclicked: false,
	            suggestions: [],
	            user_data: localStorage.getItem('user_data') ? JSON.parse(localStorage.getItem('user_data')) : [],
	            authentication: localStorage.getItem('authentication') ? JSON.parse(localStorage.getItem('authentication')) : false,
	            master_data: [],
	            uids: [],
	            cids: [],
	            cat_list: [],
	            selected_cids: [],
	            sub_category: [],
	            type_one: [],
	            dataSet: [],
	            type_two: [],
	            first_category: [],
	            second_category: [],
	            third_category: [],
	            button: 'Submit',
	            location_list: [],
	            spartner_list: [],
	            social_link_data: [{ id: "li", name: 'LinkedIn', link: "" }, { id: "fb", name: 'Facebook', link: "" }, { id: "in", name: 'Instagram', link: "" }],
	            e_social_link_data: [{ id: "li", name: 'LinkedIn', link: "" }, { id: "fb", name: 'Facebook', link: "" }, { id: "in", name: 'Instagram', link: "" }],
	            autosaveddata: []
	        };
	
	        _this.validator = new _simpleReactValidator2.default({
	            validators: {
	                checkMobile: _constant.MOBILE_REGEX,
	                checkUrl: _constant.URL_REGEX
	            }
	        });
	
	        _this.getpageData();
	        _this.getCategories = _this.getCategories.bind(_this);
	        _this.goBack = _this.goBack.bind(_this);
	        return _this;
	    }
	
	    _createClass(Branch, [{
	        key: 'escapeRegexCharacters',
	        value: function escapeRegexCharacters(str) {
	            return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	        }
	    }, {
	        key: 'renderSuggestion',
	        value: function renderSuggestion(suggestion) {
	            return _react2.default.createElement(
	                'span',
	                null,
	                suggestion.name
	            );
	        }
	    }, {
	        key: 'goBack',
	        value: function goBack() {
	            this.setState({ editclicked: false });
	            this.getpageData();
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var THIS = this;
	            $(document).on('click', '.deletebranch', function () {
	                var delete_id = $(this).data("id");
	                THIS.setState({
	                    delete_id: delete_id
	                });
	                THIS.deleteBranch(delete_id);
	            });
	
	            $(document).on('click', '.editbranch', function () {
	                var edit_id = $(this).data("vendor_id");
	                THIS.setState({
	                    e_vendor_id: edit_id,
	                    editclicked: true
	                });
	                THIS.getEditProfileData();
	                //THIS.deleteBranch(delete_id);
	            });
	        }
	    }, {
	        key: 'datatabledata',
	        value: function datatabledata(data) {
	            console.log('data', data);
	            this.setState({
	                dataSet: data
	            });
	            this.el = $(this.el);
	            this.el.DataTable({
	                data: this.state.dataSet,
	                columns: [{ data: 'org_name' }, { data: 'email_id' }, { data: 'category_name' }, { data: 'branch' }, { data: 'action' }]
	
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            this.validator.purgeFields();
	            var _state = this.state,
	                user_type = _state.user_type,
	                user_data = _state.user_data,
	                suggestions = _state.suggestions,
	                cat_list = _state.cat_list;
	
	            var add_type = user_type == 1 ? ' Of the Institution' : '';
	            var type = user_type == 1 ? ' Institution' : '';
	            var inputProps = {
	                value: this.state.org_name ? this.state.org_name : '',
	                onChange: this.onChange,
	                name: 'org_name',
	                className: 'form-control'
	            };
	
	            var e_inputProps = {
	                value: this.state.e_org_name ? this.state.e_org_name : '',
	                onChange: this.onChange_e,
	                name: 'e_org_name',
	                className: 'form-control'
	            };
	
	            return _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { 'class': 'box-shadow-custom' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-12' },
	                        !this.state.editclicked && _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'table-responsive custom-table-wrap content-sec col-md-12 col-xs-12 pad-no mar-t-no' },
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table dataTable', ref: function ref(el) {
	                                            return _this3.el = el;
	                                        } },
	                                    _react2.default.createElement(
	                                        'thead',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            { role: 'row' },
	                                            _react2.default.createElement(
	                                                'th',
	                                                { className: 'tabledata' },
	                                                'Name'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                { className: 'tabledata' },
	                                                'Login Id'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                { className: 'tabledata' },
	                                                'Categories'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                { className: 'tabledata' },
	                                                'Branch/Location'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                { className: 'tabledata' },
	                                                'Action'
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        this.state.dataSet.map(function (eachbranch, index) {
	                                            return _react2.default.createElement(
	                                                'tr',
	                                                null,
	                                                _react2.default.createElement(
	                                                    'td',
	                                                    null,
	                                                    eachbranch.org_name
	                                                ),
	                                                _react2.default.createElement(
	                                                    'td',
	                                                    null,
	                                                    eachbranch.email_id
	                                                ),
	                                                _react2.default.createElement(
	                                                    'td',
	                                                    null,
	                                                    eachbranch.category_name
	                                                ),
	                                                _react2.default.createElement(
	                                                    'td',
	                                                    null,
	                                                    eachbranch.branch
	                                                ),
	                                                _react2.default.createElement('td', { style: { textAlign: 'center' }, dangerouslySetInnerHTML: { __html: eachbranch.action } })
	                                            );
	                                        })
	                                    )
	                                )
	                            )
	                        ),
	                        this.state.editclicked && _react2.default.createElement(
	                            'div',
	                            { 'class': 'row' },
	                            _react2.default.createElement(
	                                'div',
	                                { 'class': 'flexrow' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'headertitle' },
	                                    'Editing'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'goback' },
	                                    _react2.default.createElement(
	                                        'button',
	                                        { 'class': 'btn btn-primary', onClick: this.goBack },
	                                        'Go Back'
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'form',
	                                { onSubmit: this.submitForm, autoComplete: 'off' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'box-shadow-custom' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'row' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'form-group col-md-4' },
	                                            _react2.default.createElement(
	                                                'label',
	                                                null,
	                                                'Name of the Institution ',
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'class': 'astrick' },
	                                                    '*'
	                                                )
	                                            ),
	                                            _react2.default.createElement(_reactAutosuggest2.default, {
	                                                suggestions: suggestions,
	                                                shouldRenderSuggestions: this.shouldRenderSuggestions,
	                                                onSuggestionsFetchRequested: this.onSuggestionsFetchRequested,
	                                                onSuggestionsClearRequested: this.onSuggestionsClearRequested,
	                                                getSuggestionValue: this.getSuggestionValue,
	                                                renderSuggestion: this.renderSuggestion,
	                                                inputProps: e_inputProps }),
	                                            this.validator.message('Name of the Institution', this.state.e_org_name, 'required', { className: 'text-danger' })
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'form-group col-md-4' },
	                                            _react2.default.createElement(
	                                                'label',
	                                                null,
	                                                'Business Registration Number ',
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'class': 'astrick' },
	                                                    '*'
	                                                )
	                                            ),
	                                            _react2.default.createElement('input', { type: 'text',
	                                                'class': 'form-control', name: 'registration_no',
	                                                value: this.state.e_registration_no,
	                                                onKeyUp: this.autoSave,
	                                                onChange: this.handleChange }),
	                                            this.validator.message('Business Registration Number', this.state.e_registration_no, 'required|alpha_num', { className: 'text-danger' })
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'form-group col-md-4' },
	                                            _react2.default.createElement(
	                                                'label',
	                                                null,
	                                                'Category ',
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'class': 'astrick' },
	                                                    '*'
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'select',
	                                                { className: 'form-control selectpicker',
	                                                    title: "Select Category",
	                                                    name: 'selected_cids',
	                                                    multiple: true,
	                                                    onChange: this.handleSelect },
	                                                cat_list.map(function (item, k) {
	                                                    return _react2.default.createElement(
	                                                        'option',
	                                                        { value: item.category_id },
	                                                        item.category_name
	                                                    );
	                                                })
	                                            ),
	                                            this.validator.message('Category', this.state.selected_cids, 'required', { className: 'text-danger' })
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'row' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'form-group col-md-4' },
	                                            _react2.default.createElement(
	                                                'label',
	                                                null,
	                                                'Name ',
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'class': 'astrick' },
	                                                    '*'
	                                                )
	                                            ),
	                                            _react2.default.createElement('input', { type: 'text',
	                                                'class': 'form-control', name: 'first_name',
	                                                value: this.state.e_first_name,
	                                                onKeyUp: this.autoSave,
	                                                onChange: this.handleChange }),
	                                            this.validator.message('First Name', this.state.first_name, 'required', { className: 'text-danger' })
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'row' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'form-group col-md-6' },
	                                            _react2.default.createElement(
	                                                'label',
	                                                null,
	                                                'Address ',
	                                                add_type,
	                                                ' ',
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'class': 'astrick' },
	                                                    '*'
	                                                )
	                                            ),
	                                            _react2.default.createElement('input', { type: 'text',
	                                                'class': 'form-control', name: 'address',
	                                                value: this.state.e_address,
	                                                onKeyUp: this.autoSave,
	                                                onChange: this.handleChange }),
	                                            this.validator.message('Address' + add_type, this.state.e_address, 'required', { className: 'text-danger' })
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'form-group col-md-6' },
	                                            _react2.default.createElement(
	                                                'label',
	                                                null,
	                                                'Google Location ',
	                                                _react2.default.createElement('i', { 'class': 'fa fa-info-circle info-tool', 'data-tip': true, 'data-for': 'info-goole', 'aria-hidden': 'true' }),
	                                                _react2.default.createElement(
	                                                    _reactTooltip2.default,
	                                                    { id: 'info-goole', place: 'bottom', effect: 'solid', className: 'react_tooltip_backgrnd' },
	                                                    _react2.default.createElement(
	                                                        'p',
	                                                        null,
	                                                        'https://www.google.com/maps"'
	                                                    )
	                                                ),
	                                                ' ',
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'class': 'astrick' },
	                                                    '*'
	                                                )
	                                            ),
	                                            _react2.default.createElement('input', { type: 'text',
	                                                'class': 'form-control', name: 'google_address',
	                                                value: this.state.e_google_address,
	                                                onKeyUp: this.autoSave,
	                                                onChange: this.handleChange }),
	                                            this.validator.message('Google Location', this.state.e_google_address, 'required', { className: 'text-danger' })
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'row' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'form-group col-md-4' },
	                                            _react2.default.createElement(
	                                                'label',
	                                                null,
	                                                'City ',
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'class': 'astrick' },
	                                                    '*'
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'select',
	                                                { className: 'form-control selectpicker',
	                                                    title: "Select",
	                                                    name: 'city',
	                                                    onChange: this.handleChange,
	                                                    onKeyUp: this.autoSave,
	                                                    value: this.state.e_city },
	                                                this.state.location_list.map(function (item, i) {
	                                                    return _react2.default.createElement(
	                                                        'option',
	                                                        { key: i + 'L' },
	                                                        item.location
	                                                    );
	                                                })
	                                            ),
	                                            this.validator.message('City', this.state.e_city, 'required', { className: 'text-danger' })
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'form-group col-md-4' },
	                                            _react2.default.createElement(
	                                                'label',
	                                                null,
	                                                'State ',
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'class': 'astrick' },
	                                                    '*'
	                                                )
	                                            ),
	                                            _react2.default.createElement('input', { type: 'text',
	                                                'class': 'form-control', name: 'state',
	                                                value: this.state.e_state,
	                                                onKeyUp: this.autoSave,
	                                                onChange: this.handleChange }),
	                                            this.validator.message('state', this.state.e_state, 'required|alpha_num', { className: 'text-danger' })
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'form-group col-md-4' },
	                                            _react2.default.createElement(
	                                                'label',
	                                                null,
	                                                'Pincode ',
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'class': 'astrick' },
	                                                    '*'
	                                                )
	                                            ),
	                                            _react2.default.createElement('input', { type: 'text',
	                                                'class': 'form-control', name: 'pincode',
	                                                value: this.state.e_pincode,
	                                                onKeyUp: this.autoSave,
	                                                onChange: this.handleChange }),
	                                            this.validator.message('pincode', this.state.e_pincode, 'required|numeric|min:1,num', { className: 'text-danger' })
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'row' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'form-group col-md-4' },
	                                            _react2.default.createElement(
	                                                'label',
	                                                null,
	                                                type,
	                                                ' Email Address ',
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'class': 'astrick' },
	                                                    '*'
	                                                )
	                                            ),
	                                            _react2.default.createElement('input', { type: 'text',
	                                                'class': 'form-control', name: 'email',
	                                                value: this.state.e_email,
	                                                onKeyUp: this.autoSave,
	                                                onChange: this.handleChange }),
	                                            this.validator.message(type + 'Email Address', this.state.e_email, 'required|email', { className: 'text-danger' })
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'form-group col-md-4' },
	                                            _react2.default.createElement(
	                                                'label',
	                                                null,
	                                                type,
	                                                ' Contact Number ',
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'class': 'astrick' },
	                                                    '*'
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'phone-wrapper' },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'custom-select-drop dropdown' },
	                                                    _react2.default.createElement(
	                                                        'select',
	                                                        { className: 'form-control selectpicker' },
	                                                        _react2.default.createElement(
	                                                            'option',
	                                                            null,
	                                                            '+91'
	                                                        )
	                                                    )
	                                                ),
	                                                _react2.default.createElement('input', { type: 'text', name: 'contact_number',
	                                                    placeholder: '',
	                                                    onKeyUp: this.autoSave,
	                                                    value: this.state.e_contact_number,
	                                                    onChange: this.handleChange, className: 'form-control' })
	                                            ),
	                                            this.validator.message(type + 'Contact Number', this.state.contact_number, 'required|checkMobile|min:10|max:50', { className: 'text-danger' })
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'form-group col-md-4' },
	                                            _react2.default.createElement(
	                                                'label',
	                                                null,
	                                                type,
	                                                ' Landline '
	                                            ),
	                                            _react2.default.createElement('input', { type: 'text',
	                                                'class': 'form-control', name: 'landline',
	                                                value: this.state.e_landline,
	                                                onKeyUp: this.autoSave,
	                                                onChange: this.handleChange }),
	                                            this.validator.message(type + 'Landline', this.state.e_landline, 'numeric', { className: 'text-danger' })
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'row' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'form-group col-md-12' },
	                                            _react2.default.createElement(
	                                                'label',
	                                                null,
	                                                ' Social Links ',
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { className: 'astrick' },
	                                                    '*'
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'table',
	                                                { className: 'table socialtable desktoponly' },
	                                                _react2.default.createElement(
	                                                    'tbody',
	                                                    null,
	                                                    _react2.default.createElement(
	                                                        'tr',
	                                                        null,
	                                                        _react2.default.createElement(
	                                                            'td',
	                                                            null,
	                                                            _react2.default.createElement(
	                                                                'b',
	                                                                null,
	                                                                'Media'
	                                                            )
	                                                        ),
	                                                        this.state.e_social_link_data.map(function (item, i) {
	                                                            return _react2.default.createElement(
	                                                                'td',
	                                                                null,
	                                                                item.name
	                                                            );
	                                                        })
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'tr',
	                                                        null,
	                                                        _react2.default.createElement(
	                                                            'td',
	                                                            null,
	                                                            _react2.default.createElement(
	                                                                'b',
	                                                                null,
	                                                                'Link'
	                                                            ),
	                                                            ' ',
	                                                            _react2.default.createElement('i', { 'class': 'fa fa-info-circle info-tool', 'data-tip': true, 'data-for': 'info', 'aria-hidden': 'true' }),
	                                                            _react2.default.createElement(
	                                                                _reactTooltip2.default,
	                                                                { id: 'info', place: 'bottom', effect: 'solid', className: 'react_tooltip_backgrnd' },
	                                                                _react2.default.createElement(
	                                                                    'p',
	                                                                    null,
	                                                                    'Please start with "https://...."'
	                                                                )
	                                                            )
	                                                        ),
	                                                        this.state.e_social_link_data.map(function (item, i) {
	                                                            return _react2.default.createElement(
	                                                                'td',
	                                                                null,
	                                                                _react2.default.createElement('input', { type: 'text', className: 'form-control', onChange: function onChange(e) {
	                                                                        return _this3.customChange(e, i);
	                                                                    },
	                                                                    value: item.link }),
	                                                                _this3.validator.message(item.name, item.link, 'url', { className: 'text-danger' })
	                                                            );
	                                                        })
	                                                    )
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'table',
	                                                { className: 'table socialtable mobileonly' },
	                                                _react2.default.createElement(
	                                                    'tbody',
	                                                    null,
	                                                    _react2.default.createElement(
	                                                        'tr',
	                                                        null,
	                                                        _react2.default.createElement(
	                                                            'th',
	                                                            null,
	                                                            _react2.default.createElement(
	                                                                'b',
	                                                                null,
	                                                                'Media'
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'th',
	                                                            null,
	                                                            _react2.default.createElement(
	                                                                'b',
	                                                                null,
	                                                                'Link'
	                                                            )
	                                                        )
	                                                    ),
	                                                    this.state.e_social_link_data.map(function (item, i) {
	                                                        return _react2.default.createElement(
	                                                            'tr',
	                                                            null,
	                                                            _react2.default.createElement(
	                                                                'td',
	                                                                null,
	                                                                item.name
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'td',
	                                                                null,
	                                                                _react2.default.createElement('input', { type: 'text', className: 'form-control', onChange: function onChange(e) {
	                                                                        return _this3.customChange(e, i);
	                                                                    },
	                                                                    value: item.link }),
	                                                                _this3.validator.message(item.name, item.link, 'url', { className: 'text-danger' })
	                                                            )
	                                                        );
	                                                    })
	                                                )
	                                            )
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'box-shadow-custom' },
	                                    _react2.default.createElement(
	                                        'h5',
	                                        { className: 'astrick' },
	                                        _react2.default.createElement(
	                                            'b',
	                                            null,
	                                            'Notes'
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'ul',
	                                        null,
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            'Please suffix location to the name of the institution when you add a branch or category'
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            'If you need help - please write to us at contact@bewise.in'
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'col-md-12 col-xs-12 btn-bdr text-right pad-hor-no mar-btm' },
	                                    _react2.default.createElement(
	                                        'button',
	                                        { type: 'submit', id: 'btnSubmit',
	                                            className: 'btn btn-primary btn-sm', disabled: this.state.btnDisabled },
	                                        this.state.button
	                                    )
	                                )
	                            ),
	                            ' '
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Branch;
	}(_react.Component);
	
	exports.default = Branch;

/***/ },
/* 363 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FetchCall = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var $ = __webpack_require__(5);
	//$.DataTable = require('datatables.net')
	
	var Invoice = function (_Component) {
	  _inherits(Invoice, _Component);
	
	  function Invoice(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, Invoice);
	
	    var _this = _possibleConstructorReturn(this, (Invoice.__proto__ || Object.getPrototypeOf(Invoice)).call(this, props));
	
	    _this.UserDataList = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var req, res;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.prev = 0;
	              req = JSON.stringify({
	                role: 3,
	                partner_id: _this.state.auth_data.login_id,
	                url: 'getTransaction'
	              });
	              _context.next = 4;
	              return (0, _FetchCall.partnerApi)(req);
	
	            case 4:
	              res = _context.sent;
	
	              if (res.status == 1) {
	                console.log("invoice", res.list);
	                _this.setState({ mobilelist: res.list });
	                //this.datatabledata(res.list);
	              } else {
	                  //this.datatabledata([]);
	                }
	
	              _context.next = 11;
	              break;
	
	            case 8:
	              _context.prev = 8;
	              _context.t0 = _context['catch'](0);
	
	              _this.setState({ error: true });
	
	            case 11:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2, [[0, 8]]);
	    }));
	
	    _this.state = {
	      mobilelist: [],
	      logged: localStorage.getItem("authentication"),
	      auth_data: JSON.parse(localStorage.getItem("user_data"))
	    };
	    return _this;
	  }
	
	  _createClass(Invoice, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.UserDataList();
	    }
	  }, {
	    key: 'datatabledata',
	    value: function datatabledata(data) {
	
	      console.log('data', data);
	      this.setState({
	        dataSet: data
	      });
	      this.el = $(this.el);
	      this.el.DataTable({
	        data: this.state.dataSet,
	        columns: [{ data: 's_no' }, { data: 'created_date' }, { data: 'description' }, { data: 'razorpay_payment_id' }, { data: 'invoice_no' }, { data: 'amount' }, { data: 'status' }, { data: 'action' }]
	
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'box-shadow-custom desktoponly' },
	          _react2.default.createElement(
	            'div',
	            { className: 'table-responsive content-sec col-md-12 col-xs-12 pad-no mar-t-no' },
	            _react2.default.createElement(
	              'table',
	              { className: 'table table-custom-design table-striped' },
	              _react2.default.createElement(
	                'thead',
	                null,
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'th',
	                    { className: 'tabledata' },
	                    'S.No'
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    { className: 'tabledata' },
	                    'Date'
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    { className: 'tabledata w100px', width: '100px' },
	                    'Desc'
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    { className: 'tabledata' },
	                    'RazorPay Id'
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    { className: 'tabledata w100px', width: '100px' },
	                    'Invoice'
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    { className: 'tabledata' },
	                    'Amount'
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    { className: 'tabledata' },
	                    'Status'
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    { className: 'tabledata w50px' },
	                    'Action'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'tbody',
	                null,
	                this.state.mobilelist.map(function (invitem, index) {
	                  return _react2.default.createElement(
	                    'tr',
	                    { 'class': '' },
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      index + 1
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      invitem.created_date
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      invitem.description
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      invitem.razorpay_payment_id
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      invitem.invoice_no
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      invitem.amount
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      invitem.status
	                    ),
	                    _react2.default.createElement('td', { style: { textAlign: 'center' }, dangerouslySetInnerHTML: { __html: invitem.action } })
	                  );
	                })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'mobileonly' },
	          _react2.default.createElement(
	            'div',
	            { 'class': 'invoiceline' },
	            this.state.mobilelist.map(function (invitem, index) {
	              return _react2.default.createElement(
	                'div',
	                { 'class': 'mobileinvline box-shadow-custom' },
	                _react2.default.createElement(
	                  'h2',
	                  null,
	                  invitem.invoice_no
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(
	                    'b',
	                    null,
	                    'Date :'
	                  ),
	                  ' ',
	                  _react2.default.createElement('br', null),
	                  ' ',
	                  invitem.created_date
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(
	                    'b',
	                    null,
	                    'Desc :'
	                  ),
	                  ' ',
	                  _react2.default.createElement('br', null),
	                  ' ',
	                  invitem.description
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(
	                    'b',
	                    null,
	                    'Razor Pay ID :'
	                  ),
	                  ' ',
	                  _react2.default.createElement('br', null),
	                  invitem.razorpay_payment_id
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(
	                    'b',
	                    null,
	                    'Amount:'
	                  ),
	                  ' ',
	                  _react2.default.createElement('br', null),
	                  invitem.amount
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(
	                    'b',
	                    null,
	                    'Status :'
	                  ),
	                  ' ',
	                  _react2.default.createElement('br', null),
	                  ' ',
	                  invitem.status
	                ),
	                _react2.default.createElement('div', { style: { textAlign: 'center' }, dangerouslySetInnerHTML: { __html: invitem.action } })
	              );
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Invoice;
	}(_react.Component);
	
	exports.default = Invoice;

/***/ },
/* 364 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FetchCall = __webpack_require__(4);
	
	var _FetchCall2 = _interopRequireDefault(_FetchCall);
	
	var _simpleReactValidator = __webpack_require__(28);
	
	var _simpleReactValidator2 = _interopRequireDefault(_simpleReactValidator);
	
	var _reactTooltip = __webpack_require__(133);
	
	var _reactTooltip2 = _interopRequireDefault(_reactTooltip);
	
	__webpack_require__(18);
	
	var _reactNotifications = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Category_tabv1 = function (_Component) {
	  _inherits(Category_tabv1, _Component);
	
	  function Category_tabv1(props) {
	    _classCallCheck(this, Category_tabv1);
	
	    var _this = _possibleConstructorReturn(this, (Category_tabv1.__proto__ || Object.getPrototypeOf(Category_tabv1)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var qrystr = window.location.search;
	    var urlParams = new URLSearchParams(qrystr);
	    var sid = urlParams.get('sid');
	    _this.state = {
	      user_data: localStorage.getItem('user_data') ? JSON.parse(localStorage.getItem('user_data')) : [],
	      authentication: localStorage.getItem('authentication') ? JSON.parse(localStorage.getItem('authentication')) : false,
	      sid: sid != null ? sid : -1,
	      category_data: [],
	      subcategory_data: [],
	      first_category_list: [],
	      third_categorycollected: [],
	      checking: false,
	      btnDisable: false
	    };
	    _this.validator = new _simpleReactValidator2.default();
	    _this.getCategoryData();
	    // this.getAFACategoryDataOnFirst();
	    return _this;
	  }
	
	  _createClass(Category_tabv1, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      window.jQuery('.selectpicker').selectpicker('refresh');
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      this.validator.purgeFields();
	      var userdata = this.state.user_data;
	      //console.log('this.state.category_data', this.state.category_data)
	      console.log('this.state.subcategory_data', this.state.subcategory_data);
	      var isValidNewOption = function isValidNewOption(inputValue, selectValue) {
	        return inputValue.length > 0 && selectValue.length < 4;
	      };
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          'div',
	          { 'class': 'category_block' },
	          _react2.default.createElement(
	            'div',
	            { 'class': 'titleline' },
	            _react2.default.createElement(
	              'h4',
	              null,
	              'Category'
	            )
	          ),
	          _react2.default.createElement(
	            'form',
	            { onSubmit: this.submitForm, novalidate: true },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'box-shadow-custom' },
	              this.state.sid != 0 && _react2.default.createElement(
	                'div',
	                { className: 'row mar-btm pull-right' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row mar-btm pull-right' },
	                  _react2.default.createElement(
	                    'span',
	                    {
	                      className: 'btn btn-primary btn-sm', onClick: this.addCategory },
	                    _react2.default.createElement('i', { 'class': 'fa fa-plus', 'aria-hidden': 'true' }),
	                    ' Add Category'
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactTooltip2.default,
	                  { id: 'addcategory-detail-tip', place: 'bottom', effect: 'solid', className: 'react_tooltip_backgrnd' },
	                  _react2.default.createElement(
	                    'ul',
	                    null,
	                    this.state.first_category_list.map(function (item, i) {
	                      return _react2.default.createElement(
	                        'li',
	                        null,
	                        ' ',
	                        item.category_name
	                      );
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement('br', null),
	              _react2.default.createElement(
	                'div',
	                { className: 'row mar-top' },
	                this.state.category_data.length > 0 ? this.state.category_data.map(function (cat, i) {
	                  console.log('test', _this2.state.sid);
	                  return _react2.default.createElement(
	                    'div',
	                    { className: cat.is_active == 1 ? 'categoryrow activecatrow' : cat.is_active == 0 ? 'categoryrow payrestore' : 'categoryrow newcatrow', id: "row" + cat.uid },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'col-md-6' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          'Main Category'
	                        ),
	                        _react2.default.createElement(
	                          'select',
	                          { className: 'form-control selectpicker',
	                            title: "Select Category",
	                            name: 'first_category_id',
	                            required: true,
	                            disabled: cat.uid != 0 ? true : false,
	                            onChange: function onChange(e) {
	                              return _this2.handleCustomeSelect(e, i, 'second_category');
	                            },
	                            value: cat.first_category_id },
	                          cat.first_list.map(function (items, j) {
	                            return _react2.default.createElement(
	                              'option',
	                              { value: items.category_id, key: i + j + '1' },
	                              items.category_name
	                            );
	                          })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'col-md-6' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          'Status'
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: cat.is_active == 1 ? 'statuslabel greenstatus' : cat.is_active == 0 ? 'statuslabel redstatus' : 'statuslabel newstatus' },
	                          cat.is_active == 1 ? 'Active' : cat.is_active == 0 ? 'Pay to restore' : 'New'
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: i != 0 && _this2.state.sid != -1 && userdata.isSubpartner == false && cat.uid != 0 ? "btn blue-btn btn-sm" : "hidden", onClick: function onClick(e) {
	                              return _this2.handleRemovalCategory(cat.uid, cat.first_category_id, e);
	                            } },
	                          'Remove'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'col-md-6' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          'Sub Category 1 ',
	                          _react2.default.createElement(
	                            'small',
	                            null,
	                            _react2.default.createElement('i', { 'class': 'fa fa-info-circle info-tool', 'data-tip': true, 'data-for': 'subcateone-detail-tip', 'aria-hidden': 'true' })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          _reactTooltip2.default,
	                          { id: 'subcateone-detail-tip', place: 'bottom', effect: 'solid', className: 'react_tooltip_backgrnd' },
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            'Sub Category 1 contains the classification of the main category. Its mandatory to chose this for every category!'
	                          )
	                        ),
	                        cat.second_selection == true ? _react2.default.createElement(
	                          'select',
	                          { className: 'form-control selectpicker',
	                            title: "Select Category", required: true,
	                            name: 'second_category_id',
	                            multiple: true,
	                            onChange: function onChange(e) {
	                              return _this2.handleCustomeSelect(e, i, 'third_category');
	                            },
	                            value: cat.second_category_id },
	                          cat.second_category.map(function (itemstwo, k) {
	
	                            if (itemstwo.category_id != 184) {
	                              return _react2.default.createElement(
	                                'option',
	                                { value: itemstwo.category_id, key: i + k + '2' },
	                                itemstwo.category_name
	                              );
	                            }
	                          })
	                        ) : _react2.default.createElement(
	                          'select',
	                          { className: 'form-control selectpicker',
	                            title: "Select Category",
	                            name: 'second_category_id',
	                            isValidNewOption: isValidNewOption,
	                            multiple: true, required: true,
	                            onChange: function onChange(e) {
	                              return _this2.handleCustomeSelect(e, i, 'third_category');
	                            },
	                            value: cat.second_category_id },
	                          cat.second_category.map(function (itemstwo, k) {
	                            return _react2.default.createElement(
	                              'option',
	                              { value: itemstwo.category_id, key: i + k + '2' },
	                              itemstwo.category_name
	                            );
	                          })
	                        ),
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'greenstatus' },
	                          ' ',
	                          cat.third_category.length > 0 ? 'Note: One of the sub categories has its own sub categories' : ''
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: cat.first_category_id == 4 ? 'row' : 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'col-md-6' },
	                        cat.third_category.length > 0 && _react2.default.createElement(
	                          'div',
	                          { className: 'subcategories', id: "box" + i },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            'Sub Category 2  ',
	                            _react2.default.createElement(
	                              'small',
	                              null,
	                              _react2.default.createElement('i', { 'class': 'fa fa-info-circle info-tool', 'data-tip': true, 'data-for': 'subcatetwo-detail-tip', 'aria-hidden': 'true' })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            _reactTooltip2.default,
	                            { id: 'subcatetwo-detail-tip', place: 'bottom', effect: 'solid', className: 'react_tooltip_backgrnd' },
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              'Sub Category 2 contains the sub divisions for each of Sub Category 1. Its mandatory to chose this for Afterschools category.'
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'select',
	                            { className: 'form-control selectpicker 1',
	                              title: cat.third_lbl ? cat.third_lbl : "Select Category",
	                              name: 'third_category_id',
	                              multiple: true
	                              //onloadCallback={(e)=>this.loadSubCategories(e)}
	                              , onChange: function onChange(e) {
	                                return _this2.handleCustomeSelect(e, i, 'fourth_category');
	                              },
	                              value: cat.third_category_id },
	                            cat.third_category.map(function (itemsthree, l) {
	                              return _react2.default.createElement(
	                                'option',
	                                { value: itemsthree.category_id, key: i + l + '3' },
	                                itemsthree.category_name,
	                                ' (',
	                                itemsthree.parent,
	                                ')'
	                              );
	                            })
	                          )
	                        )
	                      )
	                    )
	                  );
	                }) : _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement('td', { colSpan: '3' })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'box-shadow-custom' },
	              _react2.default.createElement(
	                'h5',
	                { className: 'astrick' },
	                _react2.default.createElement(
	                  'b',
	                  null,
	                  'Notes'
	                )
	              ),
	              _react2.default.createElement(
	                'ul',
	                null,
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'Each category/vertical selection will be add as a new subscription at (50% base price)'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'Please suffix location to the name of the institution when you add a branch or category'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'If you need help - please write to us at contact@bewise.in'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { 'class': 'col-md-12 col-xs-12 btn-bdr text-right pad-hor-no mar-btm' },
	              _react2.default.createElement(
	                'button',
	                { type: 'submit', id: 'btnSubmit',
	                  className: 'btn btn-primary btn-sm', disabled: this.state.btnDisable },
	                this.state.btnDisable ? 'Please Wait...' : 'Save'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_reactNotifications.NotificationContainer, null)
	      );
	    }
	  }]);
	
	  return Category_tabv1;
	}(_react.Component);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this3 = this;
	
	  this.handleRemovalCategory = function (vendor_id, category_id, e) {
	    //console.log(vendor_id);
	
	    if (window.confirm("You are sure?")) {
	
	      window.jQuery('#row' + vendor_id).html("<strong>It is successfully removed</strong>");
	      var _state$user_data = _this3.state.user_data,
	          login_id = _state$user_data.login_id,
	          set_id = _state$user_data.set_id;
	
	      var req_c = JSON.stringify({
	        partner_id: login_id,
	        category_id: category_id,
	        sid: set_id,
	        vendor_id: vendor_id,
	        url: 'remove_category'
	      });
	
	      (0, _FetchCall.updateRemoveCategory)(req_c).then(function (res) {
	        if (res.status == 1) {
	          window.location.href = '';
	        } else {
	          alert(res.message);
	        }
	      });
	    }
	  };
	
	  this.getAFACategoryDataOnFirst = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	    var defaultCategories, req_c, THIS;
	    return _regenerator2.default.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            defaultCategories = [26, 27, 28, 29, 30, 31, 32];
	            //const { user_type, login_id, set_id } = this.state.user_data;
	
	            req_c = JSON.stringify({
	              categories: defaultCategories,
	              url: 'partner_category_data_afa'
	            });
	            THIS = _this3;
	            _context2.next = 5;
	            return (0, _FetchCall.partnerAfaCategory)(req_c).then(function () {
	              var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(res_c) {
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                  while (1) {
	                    switch (_context.prev = _context.next) {
	                      case 0:
	                        if (res_c.status === 1) {
	
	                          _this3.setState({
	                            third_categorycollected: res_c.category_data
	                          });
	                        }
	
	                      case 1:
	                      case 'end':
	                        return _context.stop();
	                    }
	                  }
	                }, _callee, _this3);
	              }));
	
	              return function (_x) {
	                return _ref2.apply(this, arguments);
	              };
	            }());
	
	          case 5:
	          case 'end':
	            return _context2.stop();
	        }
	      }
	    }, _callee2, _this3);
	  }));
	
	  this.getAFACategoryData = function () {
	    var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(value, index) {
	      var req_c, THIS;
	      return _regenerator2.default.wrap(function _callee4$(_context4) {
	        while (1) {
	          switch (_context4.prev = _context4.next) {
	            case 0:
	
	              //const { user_type, login_id, set_id } = this.state.user_data;
	              req_c = JSON.stringify({
	                categories: value,
	                url: 'partner_category_data_afa'
	              });
	              THIS = _this3;
	              _context4.next = 4;
	              return (0, _FetchCall.partnerAfaCategory)(req_c).then(function () {
	                var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(res_c) {
	                  return _regenerator2.default.wrap(function _callee3$(_context3) {
	                    while (1) {
	                      switch (_context3.prev = _context3.next) {
	                        case 0:
	                          if (res_c.status === 1) {
	
	                            _this3.setState({
	                              third_categorycollected: res_c.category_data
	                            });
	                          }
	
	                        case 1:
	                        case 'end':
	                          return _context3.stop();
	                      }
	                    }
	                  }, _callee3, _this3);
	                }));
	
	                return function (_x4) {
	                  return _ref4.apply(this, arguments);
	                };
	              }());
	
	            case 4:
	            case 'end':
	              return _context4.stop();
	          }
	        }
	      }, _callee4, _this3);
	    }));
	
	    return function (_x2, _x3) {
	      return _ref3.apply(this, arguments);
	    };
	  }();
	
	  this.getCategoryData = _asyncToGenerator(_regenerator2.default.mark(function _callee6() {
	    var _JSON$stringify;
	
	    var _state$user_data2, user_type, login_id, set_id, sid, req_c, THIS;
	
	    return _regenerator2.default.wrap(function _callee6$(_context6) {
	      while (1) {
	        switch (_context6.prev = _context6.next) {
	          case 0:
	            _state$user_data2 = _this3.state.user_data, user_type = _state$user_data2.user_type, login_id = _state$user_data2.login_id, set_id = _state$user_data2.set_id;
	            sid = _this3.state.sid != -1 ? _this3.state.sid : set_id;
	            req_c = JSON.stringify((_JSON$stringify = {
	              partner_id: login_id,
	              sid: _this3.state.sid != -1 ? _this3.state.sid : set_id,
	              user_type: user_type }, _defineProperty(_JSON$stringify, 'user_type', user_type), _defineProperty(_JSON$stringify, 'role', 3), _defineProperty(_JSON$stringify, 'category_id', 0), _defineProperty(_JSON$stringify, 'url', 'partner_category_data'), _JSON$stringify));
	            THIS = _this3;
	            _context6.next = 6;
	            return (0, _FetchCall.partnerCategory)(req_c).then(function () {
	              var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(res_c) {
	                return _regenerator2.default.wrap(function _callee5$(_context5) {
	                  while (1) {
	                    switch (_context5.prev = _context5.next) {
	                      case 0:
	                        if (res_c.status === 1) {
	
	                          _this3.setState({
	                            sid: sid,
	                            category_data: res_c.category_data,
	                            first_category_list: res_c.category_data[0].first_list
	                          });
	                        }
	
	                      case 1:
	                      case 'end':
	                        return _context5.stop();
	                    }
	                  }
	                }, _callee5, _this3);
	              }));
	
	              return function (_x5) {
	                return _ref6.apply(this, arguments);
	              };
	            }());
	
	          case 6:
	
	            _this3.setState({
	              checking: true
	            });
	            setTimeout(function () {
	              THIS.setState({
	                checking: false
	              });
	            }, 5000);
	
	          case 8:
	          case 'end':
	            return _context6.stop();
	        }
	      }
	    }, _callee6, _this3);
	  }));
	
	  this.checkHasSubCategory = function () {
	    var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(current_arr, ele) {
	      var checkId, THIS, arr, temp, item;
	      return _regenerator2.default.wrap(function _callee7$(_context7) {
	        while (1) {
	          switch (_context7.prev = _context7.next) {
	            case 0:
	              checkId = ele == 'second_category' ? current_arr.first_category_id : current_arr.second_category_id;
	              THIS = _this3;
	              arr = ele == 'second_category' ? current_arr.first_list : current_arr.second_category;
	
	              console.log('checkId', arr);
	              temp = arr.filter(function (item) {
	                return item.is_parent == 1 && checkId.includes(item['category_id'].toString());
	              });
	
	              console.log('*** temp', temp);
	              // if (temp.length === 1) {
	              item = temp.map(function (value) {
	                return value.category_id;
	              });
	
	              console.log('checkId came inside', item);
	              _context7.next = 10;
	              return _this3.getCategory(item, ele, current_arr);
	
	            case 10:
	              current_arr = _context7.sent;
	
	              current_arr['second_lbl'] = item['category_name'];
	              // }
	              _this3.setState({
	                checking: true
	              });
	              setTimeout(function () {
	                THIS.setState({
	                  checking: false
	                });
	              }, 500);
	              return _context7.abrupt('return', current_arr);
	
	            case 15:
	            case 'end':
	              return _context7.stop();
	          }
	        }
	      }, _callee7, _this3);
	    }));
	
	    return function (_x6, _x7) {
	      return _ref7.apply(this, arguments);
	    };
	  }();
	
	  this.handleChange = function (e) {
	    var propName = e.target.name;
	    _this3.setState(_defineProperty({}, e.target.name, e.target.value));
	  };
	
	  this.loadSubCategories = function () {
	    var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee9(e, i, name) {
	      var req_c, THIS;
	      return _regenerator2.default.wrap(function _callee9$(_context9) {
	        while (1) {
	          switch (_context9.prev = _context9.next) {
	            case 0:
	
	              alert(e.target.value);
	              req_c = JSON.stringify({
	                categories: e.target.value,
	                url: 'partner_category_data_afa'
	              });
	              THIS = _this3;
	              _context9.next = 5;
	              return (0, _FetchCall.partnerAfaCategory)(req_c).then(function () {
	                var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee8(res_c) {
	                  return _regenerator2.default.wrap(function _callee8$(_context8) {
	                    while (1) {
	                      switch (_context8.prev = _context8.next) {
	                        case 0:
	                          if (res_c.status === 1) {
	
	                            _this3.setState({
	                              third_categorycollected: res_c.category_data
	                            });
	                          }
	
	                        case 1:
	                        case 'end':
	                          return _context8.stop();
	                      }
	                    }
	                  }, _callee8, _this3);
	                }));
	
	                return function (_x11) {
	                  return _ref9.apply(this, arguments);
	                };
	              }());
	
	            case 5:
	            case 'end':
	              return _context9.stop();
	          }
	        }
	      }, _callee9, _this3);
	    }));
	
	    return function (_x8, _x9, _x10) {
	      return _ref8.apply(this, arguments);
	    };
	  }();
	
	  this.handleCustomeSelect = function () {
	    var _ref10 = _asyncToGenerator(_regenerator2.default.mark(function _callee10(e, i, name) {
	      var propName, value, category_data;
	      return _regenerator2.default.wrap(function _callee10$(_context10) {
	        while (1) {
	          switch (_context10.prev = _context10.next) {
	            case 0:
	              propName = e.target.name;
	              value = [].concat(_toConsumableArray(e.target.selectedOptions)).map(function (item) {
	                return item.value;
	              });
	              category_data = _this3.state.category_data;
	
	              category_data[i][propName] = value;
	              if (propName == 'first_category_id') {
	                category_data[i].second_category_id = [];
	                category_data[i].second_category = [];
	                category_data[i].third_category_id = [];
	                category_data[i].third_category = [];
	              } else if (propName == 'second_category_id') {
	                category_data[i].third_category_id = [];
	                category_data[i].third_category = [];
	              }
	
	              if (!(name == 'second_category' || name == 'third_category')) {
	                _context10.next = 10;
	                break;
	              }
	
	              _context10.next = 8;
	              return _this3.checkHasSubCategory(category_data[i], name);
	
	            case 8:
	              _context10.next = 10;
	              return _this3.getAFACategoryData(value, i);
	
	            case 10:
	              _this3.setState({ category_data: category_data });
	
	            case 11:
	            case 'end':
	              return _context10.stop();
	          }
	        }
	      }, _callee10, _this3);
	    }));
	
	    return function (_x12, _x13, _x14) {
	      return _ref10.apply(this, arguments);
	    };
	  }();
	
	  this.getCategory = function () {
	    var _ref11 = _asyncToGenerator(_regenerator2.default.mark(function _callee11(id, name, current_arr) {
	      var response, temp_name, has_children, temp, temp_selection;
	      return _regenerator2.default.wrap(function _callee11$(_context11) {
	        while (1) {
	          switch (_context11.prev = _context11.next) {
	            case 0:
	              id = id.length > 0 ? id : [444];
	              console.log('getCategory', id, name, current_arr);
	              _context11.next = 4;
	              return _FetchCall2.default.getSubCategory(id);
	
	            case 4:
	              response = _context11.sent;
	
	              if (!(response.status === 1)) {
	                _context11.next = 26;
	                break;
	              }
	
	              console.log('*** in', current_arr);
	              current_arr[name] = response.results;
	
	              if (!(name == 'second_category' || name == 'third_category')) {
	                _context11.next = 24;
	                break;
	              }
	
	              temp_name = name == 'second_category' ? 'third_category' : '';
	              _context11.next = 12;
	              return _this3.checkHasSubCategory(current_arr, temp_name);
	
	            case 12:
	              current_arr = _context11.sent;
	
	              console.log('*** first', current_arr);
	              has_children = 0;
	              temp = [];
	
	              if (name != 'fourth_category') temp = response.results.filter(function (item) {
	                return item.is_parent == 1;
	              });
	              has_children = temp.length;
	              console.log('temp', name);
	              console.log('temp', temp_name);
	              console.log('temp', temp);
	              console.log('temp', has_children);
	              temp_selection = name == 'second_category' ? 'second_selection' : 'third_selection';
	
	              current_arr[temp_selection] = true;
	
	            case 24:
	              _context11.next = 27;
	              break;
	
	            case 26:
	              current_arr[name] = [];
	
	            case 27:
	              console.log('*** last', current_arr);
	              return _context11.abrupt('return', current_arr);
	
	            case 29:
	            case 'end':
	              return _context11.stop();
	          }
	        }
	      }, _callee11, _this3);
	    }));
	
	    return function (_x15, _x16, _x17) {
	      return _ref11.apply(this, arguments);
	    };
	  }();
	
	  this.addCategory = function (e) {
	    e.preventDefault;
	    var temp = {
	      first_category_id: [],
	      first_list: _this3.state.first_category_list,
	      second_category: [],
	      second_category_id: [],
	      second_selection: true,
	      third_category: [],
	      third_category_id: [],
	      third_selection: true,
	      uid: 0
	    };
	    var category_data = _this3.state.category_data;
	    category_data.push(temp);
	    _this3.setState({
	      category_data: category_data
	    });
	  };
	
	  this.submitForm = function (e) {
	    e.preventDefault();
	    if (_this3.validator.allValid()) {
	      var _JSON$stringify2;
	
	      _this3.setState({
	        btnDisable: true
	      });
	      var _state$user_data3 = _this3.state.user_data,
	          user_type = _state$user_data3.user_type,
	          login_id = _state$user_data3.login_id,
	          set_id = _state$user_data3.set_id;
	
	      var req_c = JSON.stringify((_JSON$stringify2 = {
	        partner_id: login_id,
	        sid: _this3.state.sid != -1 ? _this3.state.sid : set_id,
	        user_type: user_type }, _defineProperty(_JSON$stringify2, 'user_type', user_type), _defineProperty(_JSON$stringify2, 'role', 3), _defineProperty(_JSON$stringify2, 'category_data', _this3.state.sid == 0 ? _this3.state.category_data[0] : _this3.state.category_data), _defineProperty(_JSON$stringify2, 'url', 'save_category'), _JSON$stringify2));
	      if (_this3.state.sid == 0) {
	        (0, _FetchCall.partnerBranch)(req_c).then(function (res) {
	          //let toastr = '';
	          _this3.setState({
	            btnDisable: false
	          });
	          if (res.status === 1) {
	            _reactNotifications.NotificationManager.success(res.message);
	            //toastr = window.toastr.success;
	            setTimeout(function () {
	              window.location.href = '/partner/profile?sid=' + res.set_id;
	            }, 1000);
	          } else {
	            _reactNotifications.NotificationManager.error(res.message);
	            //toastr = window.toastr.error;
	          }
	
	          /*
	          toastr(res.message, {
	            positionClass: "toast-bottom-right",
	            containerId: "toast-bottom-right"
	          });
	          */
	        });
	      } else {
	        (0, _FetchCall.partnerCategory)(req_c).then(function (res) {
	          //let toastr = '';
	          _this3.setState({
	            btnDisable: false
	          });
	          if (res.status === 1) {
	            //toastr = window.toastr.success;
	            _reactNotifications.NotificationManager.success(res.message);
	            setTimeout(function () {
	              window.location.reload();
	            }, 1000);
	          } else {
	            _reactNotifications.NotificationManager.error(res.message);
	            //toastr = window.toastr.error;
	          }
	
	          /*
	          toastr(res.message, {
	            positionClass: "toast-bottom-right",
	            containerId: "toast-bottom-right"
	          });
	          */
	        });
	      }
	    } else {
	      _this3.validator.showMessages();
	      _this3.forceUpdate();
	    }
	  };
	};
	
	exports.default = Category_tabv1;

/***/ },
/* 365 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FetchCall = __webpack_require__(4);
	
	var _FetchCall2 = _interopRequireDefault(_FetchCall);
	
	var _simpleReactValidator = __webpack_require__(28);
	
	var _simpleReactValidator2 = _interopRequireDefault(_simpleReactValidator);
	
	var _constant = __webpack_require__(21);
	
	__webpack_require__(18);
	
	var _reactNotifications = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Contact = function (_Component) {
	  _inherits(Contact, _Component);
	
	  function Contact(props) {
	    _classCallCheck(this, Contact);
	
	    var _this = _possibleConstructorReturn(this, (Contact.__proto__ || Object.getPrototypeOf(Contact)).call(this, props));
	
	    _this.getContacteData = function () {
	      var _this$state$user_data = _this.state.user_data,
	          user_type = _this$state$user_data.user_type,
	          login_id = _this$state$user_data.login_id,
	          set_id = _this$state$user_data.set_id;
	
	
	      var req = JSON.stringify({
	        user_type: user_type,
	        login_id: login_id,
	        sid: _this.state.sid != -1 ? _this.state.sid : set_id,
	        url: 'getContactDetails'
	      });
	      (0, _FetchCall.partnerApi)(req).then(function (res) {
	        if (res.status === 1) {
	          var data = res.result;
	          _this.setState({
	            first_name: data.first_name,
	            last_name: data.last_name,
	            designation: data.designation,
	            email: data.email_id,
	            uids: data.uids,
	            contact_number: data.phone_number,
	            landline: data.landline_number,
	            owner_type: data.owner_type ? data.owner_type : ''
	          });
	        }
	      });
	    };
	
	    _this.handleChange = function (e) {
	      var propName = e.target.name;
	      _this.setState(_defineProperty({}, e.target.name, e.target.value));
	      if (propName == 'owner_type' && e.target.value == 1) {
	        _this.setState({
	          designation: ''
	        });
	      }
	      if (propName == 'email') {
	        _this.validateMail(e.target.value);
	      }
	    };
	
	    _this.validateMail = function (value) {
	      var _JSON$stringify;
	
	      var _this$state$user_data2 = _this.state.user_data,
	          partner_id = _this$state$user_data2.partner_id,
	          login_id = _this$state$user_data2.login_id,
	          set_id = _this$state$user_data2.set_id;
	
	      var tid = partner_id == login_id ? '' : partner_id;
	      var name = 'email_id';
	      var type_name = 'isEmailValid';
	      var req = JSON.stringify((_JSON$stringify = {}, _defineProperty(_JSON$stringify, name, value), _defineProperty(_JSON$stringify, 'sid', _this.state.sid != -1 ? _this.state.sid : set_id), _defineProperty(_JSON$stringify, 'vendor_id', tid), _defineProperty(_JSON$stringify, 'url', 'isemailExist_check'), _JSON$stringify));
	      var res = (0, _FetchCall.partnerApi)(req).then(function (res) {
	        console.log('valuee', res);
	        if (res.status === 1) {
	          _this.setState(_defineProperty({}, type_name, false));
	        } else {
	          // return res.status;
	          _this.setState(_defineProperty({}, type_name, true));
	        }
	      });
	    };
	
	    _this.handleSelect = function (e) {
	      var propName = e.target.name;
	      var value = [].concat(_toConsumableArray(e.target.selectedOptions)).map(function (item) {
	        return item.value;
	      });
	      _this.setState(_defineProperty({}, propName, value));
	    };
	
	    _this.submitForm = function (e) {
	      e.preventDefault();
	      if (_this.validator.allValid()) {
	        var _this$state$user_data3 = _this.state.user_data,
	            user_type = _this$state$user_data3.user_type,
	            login_id = _this$state$user_data3.login_id,
	            partner_id = _this$state$user_data3.partner_id,
	            set_id = _this$state$user_data3.set_id;
	
	        var request = JSON.stringify({
	          user_type: user_type,
	          login_id: login_id,
	          partner_id: partner_id,
	          sid: _this.state.sid != -1 ? _this.state.sid : set_id,
	          uids: _this.state.uids,
	          first_name: _this.state.first_name,
	          last_name: _this.state.last_name,
	          designation: _this.state.designation,
	          email: _this.state.email,
	          contact_number: _this.state.contact_number,
	          landline: _this.state.landline,
	          owner_type: _this.state.owner_type ? _this.state.owner_type : '0',
	          url: 'updateContact'
	        });
	        (0, _FetchCall.partnerApi)(request).then(function (res) {
	          //let toastr = '';
	          if (res.status === 1) {
	            _reactNotifications.NotificationManager.success(res.message);
	            //toastr = window.toastr.success;
	          } else {
	            _reactNotifications.NotificationManager.error(res.message);
	            //toastr = window.toastr.error;
	          }
	          /*
	          toastr(res.message, {
	            positionClass: "toast-bottom-right",
	            containerId: "toast-bottom-right"
	          });
	          */
	        });
	      } else {
	        _this.validator.showMessages();
	        _this.forceUpdate();
	      }
	    };
	
	    var qrystr = window.location.search;
	    var urlParams = new URLSearchParams(qrystr);
	    var sid = urlParams.get('sid');
	    _this.state = {
	      user_data: localStorage.getItem('user_data') ? JSON.parse(localStorage.getItem('user_data')) : [],
	      authentication: localStorage.getItem('authentication') ? JSON.parse(localStorage.getItem('authentication')) : false,
	      user_type: 0,
	      sid: sid != null ? sid : -1,
	      main_id: 0,
	      first_name: '',
	      last_name: '',
	      designation: '',
	      email: '',
	      contact_number: '',
	      landline: '',
	      owner_type: '',
	      uids: []
	    };
	    _this.validator = new _simpleReactValidator2.default({
	      validators: {
	        emailExist_check: { // name the rule
	          message: 'The :attribute Already Exist.',
	          rule: function rule(val, params, validator) {
	            return _this.state.isEmailValid;
	          },
	          messageReplace: function messageReplace(message, params) {
	            return message.replace(':values', _this.helpers.toSentence(params));
	          }, // optional
	          required: true // optional
	        },
	        checkMobile: _constant.MOBILE_REGEX,
	        checkUrl: _constant.URL_REGEX
	      }
	    });
	    return _this;
	  }
	
	  _createClass(Contact, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.state.authentication == true) {
	        this.setState({
	          user_type: this.state.user_data.user_type
	        });
	      }
	      this.getContacteData();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      window.jQuery('.selectpicker').selectpicker('refresh');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      this.validator.purgeFields();
	      var user_type = this.state.user_type;
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          'div',
	          { 'class': 'category_block' },
	          _react2.default.createElement(
	            'div',
	            { 'class': 'titleline' },
	            _react2.default.createElement(
	              'h4',
	              null,
	              'Contact Info'
	            )
	          ),
	          _react2.default.createElement(
	            'form',
	            { onSubmit: this.submitForm },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'box-shadow-custom' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'form-group col-md-4' },
	                  _react2.default.createElement(
	                    'label',
	                    null,
	                    ' Email Address (User name) ',
	                    _react2.default.createElement(
	                      'span',
	                      { 'class': 'astrick' },
	                      '*'
	                    )
	                  ),
	                  _react2.default.createElement('input', { type: 'text',
	                    'class': 'form-control', name: 'email',
	                    value: this.state.email,
	                    onChange: this.handleChange }),
	                  this.validator.message('Email Address', this.state.email, 'required|email|emailExist_check', { className: 'text-danger' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'form-group col-md-4' },
	                  _react2.default.createElement(
	                    'label',
	                    null,
	                    'Name ',
	                    _react2.default.createElement(
	                      'span',
	                      { 'class': 'astrick' },
	                      '*'
	                    )
	                  ),
	                  _react2.default.createElement('input', { type: 'text',
	                    'class': 'form-control', name: 'first_name',
	                    value: this.state.first_name,
	                    onChange: this.handleChange }),
	                  this.validator.message('Name', this.state.first_name, 'required|alpha_space', { className: 'text-danger' })
	                )
	              ),
	              _react2.default.createElement('div', { className: 'row' }),
	              user_type == 1 && _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'form-group col-md-4' },
	                  _react2.default.createElement(
	                    'label',
	                    null,
	                    'Are you the owner?',
	                    _react2.default.createElement(
	                      'span',
	                      { 'class': 'astrick' },
	                      '*'
	                    )
	                  ),
	                  _react2.default.createElement('br', null),
	                  _react2.default.createElement('input', {
	                    type: 'radio',
	                    name: 'owner_type',
	                    checked: this.state.owner_type === '1',
	                    value: '1',
	                    onChange: this.handleChange
	                  }),
	                  ' Yes\xA0\xA0',
	                  _react2.default.createElement('input', {
	                    type: 'radio',
	                    name: 'owner_type',
	                    checked: this.state.owner_type === '2',
	                    value: '2',
	                    onChange: this.handleChange
	                  }),
	                  ' No \xA0\xA0\xA0',
	                  this.validator.message('Owner type', this.state.owner_type, 'required', { className: 'text-danger' })
	                ),
	                this.state.owner_type == 2 && _react2.default.createElement(
	                  'div',
	                  { 'class': 'form-group col-md-4' },
	                  _react2.default.createElement(
	                    'label',
	                    null,
	                    ' Designation ',
	                    _react2.default.createElement(
	                      'span',
	                      { 'class': 'astrick' },
	                      '*'
	                    )
	                  ),
	                  _react2.default.createElement('input', { type: 'text',
	                    'class': 'form-control', name: 'designation',
	                    value: this.state.designation,
	                    onChange: this.handleChange }),
	                  this.validator.message('Designation', this.state.designation, 'required|alpha_space', { className: 'text-danger' })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'form-group col-md-4' },
	                  _react2.default.createElement(
	                    'label',
	                    null,
	                    'Contact Number ',
	                    _react2.default.createElement(
	                      'span',
	                      { 'class': 'astrick' },
	                      '*'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'phone-wrapper' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'custom-select-drop dropdown' },
	                      _react2.default.createElement(
	                        'select',
	                        { className: 'form-control selectpicker' },
	                        _react2.default.createElement(
	                          'option',
	                          null,
	                          '+91'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement('input', { type: 'text', name: 'contact_number',
	                      placeholder: 'Mobile Number',
	                      value: this.state.contact_number,
	                      onChange: this.handleChange, className: 'form-control' }),
	                    this.validator.message('Mobile Number', this.state.contact_number, 'required|checkMobile|min:10|max:60', { className: 'text-danger' })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'form-group col-md-4' },
	                  _react2.default.createElement(
	                    'label',
	                    null,
	                    ' Landline'
	                  ),
	                  _react2.default.createElement('input', { type: 'text',
	                    'class': 'form-control', name: 'landline',
	                    value: this.state.landline,
	                    onChange: this.handleChange }),
	                  this.validator.message('Landline', this.state.landline, 'numeric', { className: 'text-danger' })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { 'class': 'col-md-12 col-xs-12 btn-bdr text-right pad-hor-no mar-btm' },
	              _react2.default.createElement(
	                'button',
	                { type: 'submit', id: 'btnSubmit',
	                  className: 'btn btn-primary btn-sm' },
	                'Save'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_reactNotifications.NotificationContainer, null)
	      );
	    }
	  }]);
	
	  return Contact;
	}(_react.Component);
	
	exports.default = Contact;

/***/ },
/* 366 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FetchCall = __webpack_require__(4);
	
	var _simpleReactValidator = __webpack_require__(28);
	
	var _simpleReactValidator2 = _interopRequireDefault(_simpleReactValidator);
	
	__webpack_require__(18);
	
	var _reactNotifications = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Documents = function (_Component) {
	  _inherits(Documents, _Component);
	
	  function Documents(props) {
	    _classCallCheck(this, Documents);
	
	    var _this = _possibleConstructorReturn(this, (Documents.__proto__ || Object.getPrototypeOf(Documents)).call(this, props));
	
	    _this.getDocs = function (user_data) {
	      console.log('user_data', user_data);
	      var req = JSON.stringify({
	        partner_id: user_data.login_id,
	        url: 'getDocs',
	        role: 3
	      });
	      (0, _FetchCall.partnerApi)(req).then(function (res) {
	        if (res.status === 1) {
	          _this.setState({
	            id_proof: res.details.idproof_att,
	            qualification: res.details.qualification_att,
	            user_img: res.details.user_image_att,
	            pid: res.details.pid,
	            base_url: res.details.base_url
	          });
	        }
	      });
	    };
	
	    _this.handleFileChange = function (e) {
	      _this.setState(_defineProperty({}, e.target.name, e.target.files[0]));
	    };
	
	    _this.submitForm = function (e) {
	      e.preventDefault();
	      if (_this.validator.allValid()) {
	        var _this$state$user_data = _this.state.user_data,
	            user_type = _this$state$user_data.user_type,
	            login_id = _this$state$user_data.login_id;
	
	        var request = {
	          user_type: user_type,
	          login_id: login_id,
	          pid: _this.state.pid,
	          id_proof_new: _this.state.id_proof_new,
	          qualification_new: _this.state.qualification_new,
	          user_img_new: _this.state.user_img_new
	        };
	        (0, _FetchCall.partnerDocupload)(request).then(function (res) {
	          //let toastr = '';
	          if (res.status === 1) {
	            _reactNotifications.NotificationManager.success(res.message);
	            //toastr = window.toastr.success;
	            setTimeout(function () {
	              window.location.reload();
	            }, 2000);
	          } else if (res.status === 2) {
	            _reactNotifications.NotificationManager.error(res.message);
	            //toastr = window.toastr.warning;
	          } else {
	            _reactNotifications.NotificationManager.error(res.message);
	            //toastr = window.toastr.error;
	          }
	          /*
	          toastr(res.message, {
	            positionClass: "toast-bottom-right",
	            containerId: "toast-bottom-right"
	          });
	          */
	        });
	      } else {
	        _this.validator.showMessages();
	        _this.forceUpdate();
	      }
	    };
	
	    _this.state = {
	      user_data: localStorage.getItem('user_data') ? JSON.parse(localStorage.getItem('user_data')) : [],
	      authentication: localStorage.getItem('authentication') ? JSON.parse(localStorage.getItem('authentication')) : false,
	      user_type: 1,
	      id_proof: '',
	      qualification: '',
	      user_img: '',
	      id_proof_new: '',
	      qualification_new: '',
	      user_img_new: '',
	      base_url: '',
	      pid: ''
	    };
	    _this.validator = new _simpleReactValidator2.default({
	      validators: {
	        password_custome: { // name the rule
	          message: 'The :attribute must be a Min of 8 characters in length – One Capital Letter, One Number, One Character.',
	          rule: function rule(val, params, validator) {
	            return validator.helpers.testRegex(val, /^(?=.*\d)(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,15}$/) && params.indexOf(val) === -1;
	          },
	          messageReplace: function messageReplace(message, params) {
	            return message.replace(':values', _this.helpers.toSentence(params));
	          }, // optional
	          required: true // optional
	        },
	        confirmpassword: { // name the rule
	          message: 'The :attribute must be Same as Password.',
	          rule: function rule(val, params, validator) {
	            if (val != _this.state.password) {
	              return false;
	            }
	          },
	          messageReplace: function messageReplace(message, params) {
	            return message.replace(':values', _this.helpers.toSentence(params));
	          }, // optional
	          required: true // optional
	        }
	      }
	    });
	
	    return _this;
	  }
	
	  _createClass(Documents, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var user_data = this.state.user_data;
	
	      if (this.state.authentication == true) {
	        this.setState({
	          user_type: user_data.user_type
	        });
	      }
	      if (user_data.user_type == 2 && user_data.isSubpartner == false) {
	        this.getDocs(user_data);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      this.validator.purgeFields();
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          'div',
	          { 'class': 'category_block' },
	          _react2.default.createElement(
	            'div',
	            { 'class': 'titleline' },
	            _react2.default.createElement(
	              'h4',
	              null,
	              'Documents'
	            )
	          ),
	          _react2.default.createElement(
	            'form',
	            { onSubmit: this.submitForm },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'box-shadow-custom' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row form-group' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-md-6' },
	                  _react2.default.createElement(
	                    'label',
	                    null,
	                    'Update ID proof'
	                  ),
	                  _react2.default.createElement('input', { type: 'file', className: 'form-control', onChange: this.handleFileChange, name: 'id_proof_new' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-md-6' },
	                  this.state.id_proof && _react2.default.createElement(
	                    _react2.default.Fragment,
	                    null,
	                    _react2.default.createElement(
	                      'label',
	                      null,
	                      'Existing ID proof'
	                    ),
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement(
	                      'b',
	                      null,
	                      _react2.default.createElement(
	                        'a',
	                        { href: this.state.base_url + this.state.id_proof, target: '_blank' },
	                        'View'
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'row form-group' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-md-6' },
	                  _react2.default.createElement(
	                    'label',
	                    null,
	                    'Update Qualification Certificate'
	                  ),
	                  _react2.default.createElement('input', { type: 'file', className: 'form-control', onChange: this.handleFileChange, name: 'qualification_new' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-md-6' },
	                  this.state.qualification && _react2.default.createElement(
	                    _react2.default.Fragment,
	                    null,
	                    _react2.default.createElement(
	                      'label',
	                      null,
	                      'Existing Qualification Certificate'
	                    ),
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement(
	                      'b',
	                      null,
	                      _react2.default.createElement(
	                        'a',
	                        { href: this.state.base_url + this.state.qualification, target: '_blank' },
	                        'View'
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'row form-group' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-md-6' },
	                  _react2.default.createElement(
	                    'label',
	                    null,
	                    'Update Profile'
	                  ),
	                  _react2.default.createElement('input', { type: 'file', className: 'form-control', onChange: this.handleFileChange, name: 'user_img_new' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-md-6' },
	                  this.state.user_img && _react2.default.createElement(
	                    _react2.default.Fragment,
	                    null,
	                    _react2.default.createElement(
	                      'label',
	                      null,
	                      'Existing Profile'
	                    ),
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement(
	                      'b',
	                      null,
	                      _react2.default.createElement(
	                        'a',
	                        { href: this.state.base_url + this.state.user_img, target: '_blank' },
	                        'View'
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { 'class': 'col-md-12 col-xs-12 btn-bdr text-right pad-hor-no mar-btm' },
	              _react2.default.createElement(
	                'button',
	                { type: 'submit', id: 'btnSubmit',
	                  className: 'btn btn-primary btn-sm' },
	                'Save'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_reactNotifications.NotificationContainer, null)
	      );
	    }
	  }]);
	
	  return Documents;
	}(_react.Component);
	
	exports.default = Documents;

/***/ },
/* 367 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FetchCall = __webpack_require__(4);
	
	var _FetchCall2 = _interopRequireDefault(_FetchCall);
	
	var _constant = __webpack_require__(21);
	
	var _simpleReactValidator = __webpack_require__(28);
	
	var _simpleReactValidator2 = _interopRequireDefault(_simpleReactValidator);
	
	var _reactAutosuggest = __webpack_require__(86);
	
	var _reactAutosuggest2 = _interopRequireDefault(_reactAutosuggest);
	
	var _reactGeocode = __webpack_require__(55);
	
	var _reactGeocode2 = _interopRequireDefault(_reactGeocode);
	
	var _reactTooltip = __webpack_require__(133);
	
	var _reactTooltip2 = _interopRequireDefault(_reactTooltip);
	
	var _reactPlacesAutocomplete = __webpack_require__(132);
	
	var _reactPlacesAutocomplete2 = _interopRequireDefault(_reactPlacesAutocomplete);
	
	__webpack_require__(18);
	
	var _reactNotifications = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	_reactGeocode2.default.setApiKey("AIzaSyA9MtbfG_zlo64B2lqNMvigTBuXHkagKcE");
	
	
	_reactGeocode2.default.setLanguage("en");
	_reactGeocode2.default.setRegion("es");
	_reactGeocode2.default.enableDebug();
	
	var Overview = function (_Component) {
	  _inherits(Overview, _Component);
	
	  function Overview(props) {
	    _classCallCheck(this, Overview);
	
	    var _this = _possibleConstructorReturn(this, (Overview.__proto__ || Object.getPrototypeOf(Overview)).call(this, props));
	
	    _this.getProfileData = function () {
	      var _this$state$user_data = _this.state.user_data,
	          user_type = _this$state$user_data.user_type,
	          login_id = _this$state$user_data.login_id,
	          is_completd = _this$state$user_data.is_completd,
	          current_category = _this$state$user_data.current_category,
	          set_id = _this$state$user_data.set_id;
	
	
	      var req = JSON.stringify({
	        user_type: user_type,
	        login_id: login_id,
	        is_completd: is_completd,
	        category: current_category,
	        sid: _this.state.sid != -1 ? _this.state.sid : set_id,
	        url: 'getProfileData'
	      });
	      (0, _FetchCall.partnerApi)(req).then(function (res) {
	        if (res.status === 1) {
	          var data = res.result;
	          _this.Geocode_location(data.address);
	          var sociallinkWithoutTwtr = data.social_link_data;
	          sociallinkWithoutTwtr = JSON.parse(sociallinkWithoutTwtr);
	          sociallinkWithoutTwtr = sociallinkWithoutTwtr.filter(function (sociallink) {
	            return sociallink.name !== "Twitter";
	          });
	          if (user_type === 1) {
	            _this.setState({
	              registration_no: data.organisation_register_number,
	              org_name: data.organisation_name,
	              first_name: '',
	              last_name: '',
	              address: data.address,
	              google_address: data.google_location,
	              city: data.location,
	              state: data.state,
	              pincode: data.pin_code,
	              email: data.institution_email_address,
	              social_link_data: data.social_link_data ? sociallinkWithoutTwtr : _this.state.social_link_data,
	              contact_number: data.institution_contact_number,
	              landline: data.landline_number,
	              social_media: data.social_link,
	              social_media_link: data.social_media_link,
	              main_access: data.main_access,
	              is_completd: data.is_completd
	            });
	          } else if (user_type === 2) {
	            _this.setState({
	              main_id: data.main_id ? data.main_id : 0,
	              registration_no: '',
	              org_name: '',
	              first_name: data.first_name,
	              last_name: data.last_name,
	              address: data.address,
	              google_address: data.google_location,
	              city: data.location,
	              state: data.state,
	              pincode: data.pin_code,
	              email: data.email_id,
	              contact_number: data.institution_contact_number,
	              landline: data.landline_number,
	              social_media: data.social_link,
	              social_media_link: data.social_media_link,
	              main_access: data.main_access,
	              is_completd: data.is_completd
	            });
	          }
	          _this.setState({
	            location_list: res.location,
	            master_data: data.master_data,
	            uids: data.uids,
	            cids: data.cids
	          });
	        }
	      });
	    };
	
	    _this.customChange = function (e, i) {
	      var social_link_data = _this.state.social_link_data;
	      if (social_link_data.length > 0 && social_link_data[i]) {
	        social_link_data[i].link = e.target.value;
	      }
	      _this.setState({ social_link_data: social_link_data });
	    };
	
	    _this.handleplaceChangeIns = function (google_address) {
	      _this.setState({ google_address: google_address });
	    };
	
	    _this.handleplaceSelectIns = function (address) {
	      _this.setState({ google_address: address });
	    };
	
	    _this.handlePaste = function (e) {
	      _this.Geocode_location();
	    };
	
	    _this.handleChange = function (e) {
	      var propName = e.target.name;
	      _this.setState(_defineProperty({}, e.target.name, e.target.value));
	    };
	
	    _this.handleSelect = function (e) {
	      var propName = e.target.name;
	      var value = [].concat(_toConsumableArray(e.target.selectedOptions)).map(function (item) {
	        return item.value;
	      });
	      _this.setState(_defineProperty({}, propName, value));
	    };
	
	    _this.shouldRenderSuggestions = function (value, reason) {
	      return value.trim().length > 2;
	    };
	
	    _this.onSuggestionsFetchRequested = function (_ref) {
	      var value = _ref.value;
	
	      var val = _this.escapeRegexCharacters(value.trim());
	      var login_id = _this.state.user_data.login_id;
	      var fetch = JSON.stringify({
	        keyword: val,
	        login_id: login_id,
	        url: 'getDataByName'
	      });
	      (0, _FetchCall.partnerApi)(fetch).then(function (res) {
	        if (res.status == 1) {
	          _this.setState({
	            suggestions: res.result
	          });
	        }
	      });
	    };
	
	    _this.onSuggestionsClearRequested = function () {
	      _this.setState({
	        suggestions: []
	      });
	    };
	
	    _this.getSuggestionValue = function (suggestion) {
	      _this.setState({ confirmModal: true });
	      var currentData = suggestion;
	      currentData.url = 'getDataById';
	      var data = JSON.stringify(currentData);
	      (0, _FetchCall.partnerApi)(data).then(function (res) {
	        if (res.status === 1) {
	          var _data = res.result;
	          _this.setState({
	            registration_no: _data.organisation_register_number,
	            address: _data.address,
	            google_address: _data.google_address,
	            city: _data.location,
	            state: _data.state,
	            pincode: _data.pin_code,
	            contact_number: _data.institution_contact_number,
	            email: _data.institution_email_address,
	            social_media: _data.social_link,
	            social_media_link: _data.social_media_link,
	            social_link_data: _data.social_link_data ? JSON.parse(_data.social_link_data) : _this.state.social_link_data
	          });
	        } else {
	          _this.setState({
	            registration_no: '',
	            address: '',
	            google_address: '',
	            city: '',
	            state: '',
	            pincode: '',
	            contact_number: '',
	            email: '',
	            social_media: '',
	            social_media_link: '',
	            social_link_data: _this.state.social_link_data
	          });
	        }
	      });
	      return suggestion.name;
	    };
	
	    _this.onChange = function (event, _ref2) {
	      var newValue = _ref2.newValue,
	          method = _ref2.method;
	
	      _this.setState({
	        org_name: newValue
	      });
	    };
	
	    _this.autoSave = function (e) {
	      e.preventDefault();
	      var autosaving1 = _this.state.autosaveddata;
	      var autosaving2 = _this.state.autosaveddata;
	      autosaving1.push(_defineProperty({}, e.target.name, e.target.value));
	      var lastautosaving = autosaving1.pop();
	      //console.log("data2",lastautosaving);
	      autosaving2.push(lastautosaving);
	      _this.setState({ autosaveddata: lastautosaving });
	      console.log("data", _this.state.autosaveddata);
	    };
	
	    _this.submitForm = function (e) {
	      e.preventDefault();
	      if (_this.validator.allValid()) {
	        var _this$state$user_data2 = _this.state.user_data,
	            user_type = _this$state$user_data2.user_type,
	            login_id = _this$state$user_data2.login_id;
	
	        var request = JSON.stringify({
	          user_type: user_type,
	          master_data: _this.state.master_data,
	          uids: _this.state.uids,
	          cids: _this.state.cids,
	          login_id: login_id,
	          is_completd: _this.state.is_completd,
	          registration_no: _this.state.registration_no,
	          org_name: _this.state.org_name,
	          first_name: _this.state.first_name,
	          last_name: _this.state.last_name,
	          address: _this.state.address,
	          google_address: _this.state.google_address,
	          latitude: _this.state.latitude,
	          longitude: _this.state.longitude,
	          city: _this.state.city,
	          state: _this.state.state,
	          pincode: _this.state.pincode,
	          email: _this.state.email,
	          contact_number: _this.state.contact_number,
	          landline: _this.state.landline,
	          social_media: _this.state.social_media,
	          social_media_link: _this.state.social_media_link,
	          social_link_data: JSON.stringify(_this.state.social_link_data),
	          access: _this.state.access,
	          sub_category: _this.state.sub_category,
	          main_access: _this.state.main_access,
	          type_one: _this.state.type_one,
	          type_two: _this.state.type_two,
	          url: 'updateOverview'
	        });
	        (0, _FetchCall.partnerApi)(request).then(function (res) {
	
	          if (res.status === 1) {
	            //toastr = window.toastr.success;
	            localStorage.setItem('is_completed', 1);
	            _reactNotifications.NotificationManager.success(res.message);
	            /*
	            toastr(res.message, {
	              positionClass: "toast-bottom-right",
	              containerId: "toast-bottom-right"
	            });
	             setTimeout(function () {
	              window.location.reload();
	            }, 1000);
	            */
	          } else {
	            _reactNotifications.NotificationManager.error(res.message);
	            /*toastr = window.toastr.error;
	            toastr(res.message, {
	              positionClass: "toast-bottom-right",
	              containerId: "toast-bottom-right"
	            });*/
	          }
	        });
	      } else {
	        _this.validator.showMessages();
	        _this.forceUpdate();
	      }
	    };
	
	    var qrystr = window.location.search;
	    var urlParams = new URLSearchParams(qrystr);
	    var sid = urlParams.get('sid');
	    _this.state = {
	      user_data: localStorage.getItem('user_data') ? JSON.parse(localStorage.getItem('user_data')) : [],
	      authentication: localStorage.getItem('authentication') ? JSON.parse(localStorage.getItem('authentication')) : false,
	      is_completed: localStorage.getItem('is_completed') ? localStorage.getItem('is_completed') : 0,
	      access: [],
	      sid: sid != null ? sid : -1,
	      main_id: 0,
	      user_type: 0,
	      spartner_id: 0,
	      registration_no: '',
	      org_name: '',
	      first_name: '',
	      last_name: '',
	      address: '',
	      google_address: '',
	      location: '',
	      state: '',
	      pincode: '',
	      email: '',
	      contact_number: '',
	      landline: '',
	      social_media: '',
	      social_media_link: '',
	      sub_category: [],
	      type_one: [],
	      type_two: [],
	      first_category: [],
	      second_category: [],
	      third_category: [],
	      location_list: [],
	      spartner_list: [],
	      suggestions: [],
	      first_type_mul: true,
	      second_mult: false,
	      third_mult: false,
	      lbl_sec_cate: '',
	      lbl_third_cate: '',
	      latitude: '',
	      longitude: '',
	      is_completd: 0,
	      main_access: '',
	      main_category: 0,
	      button: 'Publish',
	      master_data: [],
	      uids: [],
	      cids: [],
	      social_link_data: [{ id: "li", name: 'LinkedIn', field: 'linkedin', link: "" }, { id: "fb", name: 'Facebook', field: 'facebook', link: "" }, { id: "in", name: 'Instagram', field: 'instagram', link: "" }],
	      autosaveddata: []
	    };
	    _this.validator = new _simpleReactValidator2.default({
	      validators: {
	        checkMobile: _constant.MOBILE_REGEX,
	        checkUrl: _constant.URL_REGEX
	      }
	    });
	    return _this;
	  }
	
	  _createClass(Overview, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      window.jQuery('.selectpicker').selectpicker('refresh');
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.state.button = this.state.is_completed == 0 ? 'Publish' : 'Save';
	      if (this.state.authentication == true) {
	        this.setState({
	          user_type: this.state.user_data.user_type,
	          access: this.state.user_data.current_category.split(',')
	        });
	      } else {
	        window.location.href = '/';
	      }
	      this.getProfileData();
	    }
	  }, {
	    key: 'Geocode_location',
	    value: function Geocode_location() {
	      var address = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	      var THIS = this;
	      var add = address ? address : this.state.google_address;
	      _reactGeocode2.default.fromAddress(add).then(function (response) {
	        var _response$results$0$g = response.results[0].geometry.location,
	            lat = _response$results$0$g.lat,
	            lng = _response$results$0$g.lng;
	
	        THIS.setState({
	          latitude: lat,
	          longitude: lng
	        });
	      }, function (error) {
	        console.error(error);
	      });
	    }
	  }, {
	    key: 'escapeRegexCharacters',
	    value: function escapeRegexCharacters(str) {
	      return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	    }
	  }, {
	    key: 'renderSuggestion',
	    value: function renderSuggestion(suggestion) {
	      return _react2.default.createElement(
	        'span',
	        null,
	        suggestion.name
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      this.validator.purgeFields();
	      var _state = this.state,
	          user_type = _state.user_type,
	          user_data = _state.user_data,
	          suggestions = _state.suggestions;
	
	      var add_type = user_type == 1 ? ' Of the Institution' : '';
	      var type = user_type == 1 ? ' Institution' : '';
	      var inputProps = {
	        value: this.state.org_name ? this.state.org_name : '',
	        onChange: this.onChange,
	        name: 'org_name',
	        className: 'form-control'
	      };
	      return user_type != 0 && _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          'div',
	          { 'class': 'category_block' },
	          _react2.default.createElement(
	            'div',
	            { 'class': 'titleline' },
	            _react2.default.createElement(
	              'h4',
	              null,
	              'Overview'
	            )
	          ),
	          _react2.default.createElement(
	            'form',
	            { onSubmit: this.submitForm, autoComplete: 'off' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'box-shadow-custom' },
	              user_type == 1 && _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'form-group col-md-4' },
	                  _react2.default.createElement(
	                    'label',
	                    null,
	                    'Name of the Institution ',
	                    _react2.default.createElement(
	                      'span',
	                      { 'class': 'astrick' },
	                      '*'
	                    )
	                  ),
	                  _react2.default.createElement(_reactAutosuggest2.default, {
	                    suggestions: suggestions,
	                    shouldRenderSuggestions: this.shouldRenderSuggestions,
	                    onSuggestionsFetchRequested: this.onSuggestionsFetchRequested,
	                    onSuggestionsClearRequested: this.onSuggestionsClearRequested,
	                    getSuggestionValue: this.getSuggestionValue,
	                    renderSuggestion: this.renderSuggestion,
	                    inputProps: inputProps }),
	                  this.validator.message('Name of the Institution', this.state.org_name, 'required', { className: 'text-danger' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'form-group col-md-4' },
	                  _react2.default.createElement(
	                    'label',
	                    null,
	                    'Business Registration Number ',
	                    _react2.default.createElement(
	                      'span',
	                      { 'class': 'astrick' },
	                      '*'
	                    )
	                  ),
	                  _react2.default.createElement('input', { type: 'text',
	                    'class': 'form-control', name: 'registration_no',
	                    value: this.state.registration_no,
	                    onKeyUp: this.autoSave,
	                    onChange: this.handleChange }),
	                  this.validator.message('Business Registration Number', this.state.registration_no, 'required|alpha_num', { className: 'text-danger' })
	                )
	              ),
	              user_type == 2 && _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'form-group col-md-4' },
	                  _react2.default.createElement(
	                    'label',
	                    null,
	                    'Name ',
	                    _react2.default.createElement(
	                      'span',
	                      { 'class': 'astrick' },
	                      '*'
	                    )
	                  ),
	                  _react2.default.createElement('input', { type: 'text',
	                    'class': 'form-control', name: 'first_name',
	                    value: this.state.first_name,
	                    onKeyUp: this.autoSave,
	                    onChange: this.handleChange }),
	                  this.validator.message('First Name', this.state.first_name, 'required', { className: 'text-danger' })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'form-group col-md-6' },
	                  _react2.default.createElement(
	                    'label',
	                    null,
	                    'Address ',
	                    add_type,
	                    ' ',
	                    _react2.default.createElement(
	                      'span',
	                      { 'class': 'astrick' },
	                      '*'
	                    )
	                  ),
	                  _react2.default.createElement('input', { type: 'text',
	                    'class': 'form-control', name: 'address',
	                    value: this.state.address,
	                    onKeyUp: this.autoSave,
	                    onChange: this.handleChange }),
	                  this.validator.message('Address' + add_type, this.state.address, 'required', { className: 'text-danger' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'form-group col-md-6' },
	                  _react2.default.createElement(
	                    'label',
	                    null,
	                    'Google Location ',
	                    _react2.default.createElement('i', { 'class': 'fa fa-info-circle info-tool', 'data-tip': true, 'data-for': 'info-goole', 'aria-hidden': 'true' }),
	                    _react2.default.createElement(
	                      _reactTooltip2.default,
	                      { id: 'info-goole', place: 'bottom', effect: 'solid', className: 'react_tooltip_backgrnd' },
	                      _react2.default.createElement(
	                        'p',
	                        null,
	                        'Type and Select From Autopopulated List'
	                      )
	                    ),
	                    ' ',
	                    _react2.default.createElement(
	                      'span',
	                      { 'class': 'astrick' },
	                      '*'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactPlacesAutocomplete2.default,
	                    {
	                      value: this.state.google_address,
	                      className: 'form-control',
	                      onChange: this.handleplaceChangeIns,
	                      onSelect: this.handleplaceSelectIns
	                    },
	                    function (_ref3) {
	                      var getInputProps = _ref3.getInputProps,
	                          suggestions = _ref3.suggestions,
	                          getSuggestionItemProps = _ref3.getSuggestionItemProps,
	                          loading = _ref3.loading;
	                      return _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement('input', Object.assign({}, getInputProps({
	                          placeholder: 'Search Places ...',
	                          className: 'form-control',
	                          id: 'address_ins'
	                        }), {
	                          value: _this2.state.google_address
	                        })),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'autocomplete-dropdown-container',
	                            style: { position: "absolute", zIndex: "999" } },
	                          loading && _react2.default.createElement(
	                            'div',
	                            null,
	                            'Loading...'
	                          ),
	                          suggestions.map(function (suggestion) {
	                            var className = suggestion.active ? 'suggestion-item--active' : 'suggestion-item';
	                            // inline style for demonstration purpose
	                            var style = suggestion.active ? { backgroundColor: '#fafafa', cursor: 'pointer' } : { backgroundColor: '#ffffff', cursor: 'pointer' };
	                            return _react2.default.createElement(
	                              'div',
	                              getSuggestionItemProps(suggestion, {
	                                className: className,
	                                style: style
	                              }),
	                              _react2.default.createElement(
	                                'span',
	                                null,
	                                suggestion.description
	                              )
	                            );
	                          })
	                        )
	                      );
	                    }
	                  ),
	                  this.validator.message('Google Location', this.state.google_address, 'required', { className: 'text-danger' })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'form-group col-md-4' },
	                  _react2.default.createElement(
	                    'label',
	                    null,
	                    'City ',
	                    _react2.default.createElement(
	                      'span',
	                      { 'class': 'astrick' },
	                      '*'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'select',
	                    { className: 'form-control selectpicker',
	                      title: "Select",
	                      name: 'city',
	                      onChange: this.handleChange,
	                      onKeyUp: this.autoSave,
	                      value: this.state.city },
	                    this.state.location_list.map(function (item, i) {
	                      return _react2.default.createElement(
	                        'option',
	                        { key: i + 'L' },
	                        item.location
	                      );
	                    })
	                  ),
	                  this.validator.message('City', this.state.city, 'required', { className: 'text-danger' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'form-group col-md-4' },
	                  _react2.default.createElement(
	                    'label',
	                    null,
	                    'State ',
	                    _react2.default.createElement(
	                      'span',
	                      { 'class': 'astrick' },
	                      '*'
	                    )
	                  ),
	                  _react2.default.createElement('input', { type: 'text',
	                    'class': 'form-control', name: 'state',
	                    value: this.state.state,
	                    onKeyUp: this.autoSave,
	                    onChange: this.handleChange }),
	                  this.validator.message('state', this.state.state, 'required|alpha_num', { className: 'text-danger' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'form-group col-md-4' },
	                  _react2.default.createElement(
	                    'label',
	                    null,
	                    'Pincode ',
	                    _react2.default.createElement(
	                      'span',
	                      { 'class': 'astrick' },
	                      '*'
	                    )
	                  ),
	                  _react2.default.createElement('input', { type: 'text',
	                    'class': 'form-control', name: 'pincode',
	                    value: this.state.pincode,
	                    onKeyUp: this.autoSave,
	                    onChange: this.handleChange }),
	                  this.validator.message('pincode', this.state.pincode, 'required|numeric|min:1,num', { className: 'text-danger' })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'form-group col-md-4' },
	                  _react2.default.createElement(
	                    'label',
	                    null,
	                    type,
	                    ' Email Address ',
	                    _react2.default.createElement(
	                      'span',
	                      { 'class': 'astrick' },
	                      '*'
	                    )
	                  ),
	                  _react2.default.createElement('input', { type: 'text',
	                    'class': 'form-control', name: 'email',
	                    value: this.state.email,
	                    onKeyUp: this.autoSave,
	                    onChange: this.handleChange }),
	                  this.validator.message(type + 'Email Address', this.state.email, 'required|email', { className: 'text-danger' })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'form-group col-6' },
	                  _react2.default.createElement(
	                    'label',
	                    null,
	                    type,
	                    ' Contact Number ',
	                    _react2.default.createElement(
	                      'span',
	                      { 'class': 'astrick' },
	                      '*'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'phone-wrapper-new' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'form-group col-4' },
	                        _react2.default.createElement('input', { type: 'text', name: 'contact_number_code',
	                          placeholder: '',
	                          onKeyUp: this.autoSave,
	                          value: '+91',
	                          onChange: this.handleChange, className: 'form-control', disabled: true })
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'form-group col-8' },
	                        _react2.default.createElement('input', { type: 'text', name: 'contact_number',
	                          placeholder: '',
	                          onKeyUp: this.autoSave,
	                          value: this.state.contact_number,
	                          onChange: this.handleChange, className: 'form-control' })
	                      )
	                    )
	                  ),
	                  this.validator.message(type + 'Contact Number', this.state.contact_number, 'required|checkMobile|min:10|max:50', { className: 'text-danger' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'form-group col-6' },
	                  _react2.default.createElement(
	                    'label',
	                    null,
	                    type,
	                    ' Landline '
	                  ),
	                  _react2.default.createElement('input', { type: 'text',
	                    'class': 'form-control', name: 'landline',
	                    value: this.state.landline,
	                    onKeyUp: this.autoSave,
	                    onChange: this.handleChange }),
	                  this.validator.message(type + 'Landline', this.state.landline, 'numeric', { className: 'text-danger' })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'form-group col-md-12' },
	                  _react2.default.createElement(
	                    'label',
	                    null,
	                    ' Social Links ',
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'astrick' },
	                      '*'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'table',
	                    { className: 'table socialtable desktoponly' },
	                    _react2.default.createElement(
	                      'tbody',
	                      null,
	                      _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                          'td',
	                          null,
	                          _react2.default.createElement(
	                            'b',
	                            null,
	                            'Media'
	                          )
	                        ),
	                        this.state.social_link_data.map(function (item, i) {
	                          return _react2.default.createElement(
	                            'td',
	                            null,
	                            item.name
	                          );
	                        })
	                      ),
	                      _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                          'td',
	                          null,
	                          _react2.default.createElement(
	                            'b',
	                            null,
	                            'Link'
	                          ),
	                          ' ',
	                          _react2.default.createElement('i', { 'class': 'fa fa-info-circle info-tool', 'data-tip': true, 'data-for': 'info', 'aria-hidden': 'true' }),
	                          _react2.default.createElement(
	                            _reactTooltip2.default,
	                            { id: 'info', place: 'bottom', effect: 'solid', className: 'react_tooltip_backgrnd' },
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              'Please start with "https://www....."'
	                            )
	                          )
	                        ),
	                        this.state.social_link_data.map(function (item, i) {
	                          return _react2.default.createElement(
	                            'td',
	                            null,
	                            _react2.default.createElement('input', { type: 'text', className: 'form-control', name: item.field, onChange: function onChange(e) {
	                                return _this2.customChange(e, i);
	                              },
	                              value: item.link }),
	                            _this2.validator.message(item.name, item.link, 'required|url', { className: 'text-danger' })
	                          );
	                        })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'table',
	                    { className: 'table socialtable mobileonly' },
	                    _react2.default.createElement(
	                      'tbody',
	                      null,
	                      _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'b',
	                            null,
	                            'Media'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'b',
	                            null,
	                            'Link'
	                          )
	                        )
	                      ),
	                      this.state.social_link_data.map(function (item, i) {
	                        return _react2.default.createElement(
	                          'tr',
	                          null,
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.name
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            _react2.default.createElement('input', { type: 'text', className: 'form-control', name: item.field, onChange: function onChange(e) {
	                                return _this2.customChange(e, i);
	                              },
	                              value: item.link }),
	                            _this2.validator.message(item.name, item.link, 'required|url', { className: 'text-danger' })
	                          )
	                        );
	                      })
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'box-shadow-custom' },
	              _react2.default.createElement(
	                'h5',
	                { className: 'astrick' },
	                _react2.default.createElement(
	                  'b',
	                  null,
	                  'Notes'
	                )
	              ),
	              _react2.default.createElement(
	                'ul',
	                null,
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'Partner\'s profile will get the visibility on user\'s page only when mandatory fields are filled, submitted from the partner and approved by admin'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { 'class': 'col-md-12 col-xs-12 btn-bdr text-right pad-hor-no mar-btm' },
	              _react2.default.createElement(
	                'button',
	                { type: 'submit', id: 'btnSubmit',
	                  className: 'btn btn-primary btn-sm' },
	                this.state.button
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_reactNotifications.NotificationContainer, null)
	      );
	    }
	  }]);
	
	  return Overview;
	}(_react.Component);
	
	exports.default = Overview;

/***/ },
/* 368 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FetchCall = __webpack_require__(4);
	
	var _FetchCall2 = _interopRequireDefault(_FetchCall);
	
	var _simpleReactValidator = __webpack_require__(28);
	
	var _simpleReactValidator2 = _interopRequireDefault(_simpleReactValidator);
	
	__webpack_require__(18);
	
	var _reactNotifications = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Password_pro = function (_Component) {
	  _inherits(Password_pro, _Component);
	
	  function Password_pro(props) {
	    _classCallCheck(this, Password_pro);
	
	    var _this = _possibleConstructorReturn(this, (Password_pro.__proto__ || Object.getPrototypeOf(Password_pro)).call(this, props));
	
	    _this.handleChange = function (e) {
	      var propName = e.target.name;
	      _this.setState(_defineProperty({}, e.target.name, e.target.value));
	    };
	
	    _this.submitForm = function (e) {
	      e.preventDefault();
	      if (_this.validator.allValid()) {
	        var _this$state$user_data = _this.state.user_data,
	            user_type = _this$state$user_data.user_type,
	            partner_id = _this$state$user_data.partner_id,
	            is_completd = _this$state$user_data.is_completd;
	
	        var request = JSON.stringify({
	          user_type: user_type,
	          login_id: partner_id,
	          password: _this.state.password,
	          url: 'updatePassword'
	        });
	        (0, _FetchCall.partnerApi)(request).then(function (res) {
	          //let toastr = '';
	          if (res.status === 1) {
	            /*
	            toastr = window.toastr.success;
	            */
	            _this.setState({
	              password: '',
	              confirm_password: '',
	              old_password: ''
	            });
	            _reactNotifications.NotificationManager.success(res.message);
	          } else {
	            _reactNotifications.NotificationManager.error(res.message);
	            //toastr = window.toastr.error;
	          }
	
	          /*
	          toastr(res.message, {
	            positionClass: "toast-bottom-right",
	            containerId: "toast-bottom-right"
	          });
	          */
	        });
	      } else {
	        _this.validator.showMessages();
	        _this.forceUpdate();
	      }
	    };
	
	    _this.state = {
	      user_data: localStorage.getItem('user_data') ? JSON.parse(localStorage.getItem('user_data')) : [],
	      authentication: localStorage.getItem('authentication') ? JSON.parse(localStorage.getItem('authentication')) : false,
	      user_type: 1,
	      password: '',
	      confirm_password: ''
	    };
	    _this.validator = new _simpleReactValidator2.default({
	      validators: {
	        password_custome: { // name the rule
	          message: 'The :attribute must be a Min of 8 characters in length – One Capital Letter, One Number, One Character.',
	          rule: function rule(val, params, validator) {
	            return validator.helpers.testRegex(val, /^(?=.*\d)(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,15}$/) && params.indexOf(val) === -1;
	          },
	          messageReplace: function messageReplace(message, params) {
	            return message.replace(':values', _this.helpers.toSentence(params));
	          }, // optional
	          required: true // optional
	        },
	        confirmpassword: { // name the rule
	          message: 'The :attribute must be Same as Password.',
	          rule: function rule(val, params, validator) {
	            if (val != _this.state.password) {
	              return false;
	            }
	          },
	          messageReplace: function messageReplace(message, params) {
	            return message.replace(':values', _this.helpers.toSentence(params));
	          }, // optional
	          required: true // optional
	        }
	      }
	    });
	    return _this;
	  }
	
	  _createClass(Password_pro, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.state.authentication == true) {
	        this.setState({
	          user_type: this.state.user_data.user_type
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      this.validator.purgeFields();
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          'div',
	          { 'class': 'category_block' },
	          _react2.default.createElement(
	            'div',
	            { 'class': 'titleline' },
	            _react2.default.createElement(
	              'h4',
	              null,
	              'Password'
	            )
	          ),
	          _react2.default.createElement(
	            'form',
	            { onSubmit: this.submitForm },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'box-shadow-custom' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'form-group col-md-4' },
	                  _react2.default.createElement(
	                    'label',
	                    null,
	                    'Enter Old Password ',
	                    _react2.default.createElement(
	                      'span',
	                      { 'class': 'astrick' },
	                      '*'
	                    )
	                  ),
	                  _react2.default.createElement('input', { type: 'password',
	                    'class': 'form-control', name: 'old_password',
	                    value: this.state.old_password,
	                    onChange: this.handleChange }),
	                  this.validator.message('Old Password', this.state.old_password, 'required', { className: 'text-danger' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'form-group col-md-4' },
	                  _react2.default.createElement(
	                    'label',
	                    null,
	                    'Enter New Password ',
	                    _react2.default.createElement(
	                      'span',
	                      { 'class': 'astrick' },
	                      '*'
	                    )
	                  ),
	                  _react2.default.createElement('input', { type: 'password',
	                    'class': 'form-control', name: 'password',
	                    value: this.state.password,
	                    onChange: this.handleChange }),
	                  this.validator.message('Password', this.state.password, 'required|password_custome', { className: 'text-danger' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'form-group col-md-4' },
	                  _react2.default.createElement(
	                    'label',
	                    null,
	                    'Re-type New Password ',
	                    _react2.default.createElement(
	                      'span',
	                      { 'class': 'astrick' },
	                      '*'
	                    )
	                  ),
	                  _react2.default.createElement('input', { type: 'password',
	                    'class': 'form-control', name: 'confirm_password',
	                    value: this.state.confirm_password,
	                    onChange: this.handleChange }),
	                  this.validator.message('Confirm Password', this.state.confirm_password, 'required|confirmpassword', { className: 'text-danger' })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { 'class': 'col-md-12 col-xs-12 btn-bdr text-right pad-hor-no mar-btm' },
	              _react2.default.createElement(
	                'button',
	                { type: 'submit', id: 'btnSubmit',
	                  className: 'btn btn-primary btn-sm' },
	                'Save'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_reactNotifications.NotificationContainer, null)
	      );
	    }
	  }]);
	
	  return Password_pro;
	}(_react.Component);
	
	exports.default = Password_pro;

/***/ },
/* 369 */
/***/ function(module, exports) {

	'use strict';
	
	function uploadImageCallBack(file) {
	  return new Promise(function (resolve, reject) {
	    var reader = new window.FileReader();
	    var xhr = new XMLHttpRequest(); // eslint-disable-line no-undef
	    xhr.open('POST', 'https://api.bewise.in/api/campaign/mail/uploadeditorimage');
	    xhr.setRequestHeader('x-auth-token', 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ2ZW5kZXIiOnsiaWQiOiI1ZWJkMTMyOTQwMjJhMjNlMmM1YzA4MzkifSwiaWF0IjoxNTkxMTgwOTA3LCJleHAiOjM2MDAwMDAwMDAxNTkxMTgwMDAwfQ.TKBUep0bss3gqQBK8CkbUuRlO3jRLHEvGTGgm90gLRE');
	    var data = new FormData(); // eslint-disable-line no-undef
	    data.append('image', file);
	    xhr.send(data);
	    xhr.addEventListener('load', function () {
	      var response = JSON.parse(xhr.responseText);
	      resolve(response);
	    });
	    xhr.addEventListener('error', function () {
	      var error = JSON.parse(xhr.responseText);
	      reject(error);
	    });
	  });
	}

/***/ },
/* 370 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(156);
	
	var $apply = __webpack_require__(249);
	var $call = __webpack_require__(250);
	var $reflectApply = __webpack_require__(1073);
	
	/** @type {import('./actualApply')} */
	module.exports = $reflectApply || bind.call($call, $apply);


/***/ },
/* 371 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var GetIntrinsic = __webpack_require__(272);
	
	var callBindBasic = __webpack_require__(251);
	
	/** @type {(thisArg: string, searchString: string, position?: number) => number} */
	var $indexOf = callBindBasic([GetIntrinsic('%String.prototype.indexOf%')]);
	
	/** @type {import('.')} */
	module.exports = function callBoundIntrinsic(name, allowMissing) {
		/* eslint no-extra-parens: 0 */
	
		var intrinsic = /** @type {(this: unknown, ...args: unknown[]) => unknown} */ (GetIntrinsic(name, !!allowMissing));
		if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
			return callBindBasic(/** @type {const} */ ([intrinsic]));
		}
		return intrinsic;
	};


/***/ },
/* 372 */
/***/ function(module, exports) {

	/*!
	 * cookie
	 * Copyright(c) 2012-2014 Roman Shtylman
	 * Copyright(c) 2015 Douglas Christopher Wilson
	 * MIT Licensed
	 */
	
	'use strict';
	
	/**
	 * Module exports.
	 * @public
	 */
	
	exports.parse = parse;
	exports.serialize = serialize;
	
	/**
	 * Module variables.
	 * @private
	 */
	
	var decode = decodeURIComponent;
	var encode = encodeURIComponent;
	
	/**
	 * RegExp to match field-content in RFC 7230 sec 3.2
	 *
	 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
	 * field-vchar   = VCHAR / obs-text
	 * obs-text      = %x80-FF
	 */
	
	var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
	
	/**
	 * Parse a cookie header.
	 *
	 * Parse the given cookie header string into an object
	 * The object has the various cookies as keys(names) => values
	 *
	 * @param {string} str
	 * @param {object} [options]
	 * @return {object}
	 * @public
	 */
	
	function parse(str, options) {
	  if (typeof str !== 'string') {
	    throw new TypeError('argument str must be a string');
	  }
	
	  var obj = {}
	  var opt = options || {};
	  var pairs = str.split(';')
	  var dec = opt.decode || decode;
	
	  for (var i = 0; i < pairs.length; i++) {
	    var pair = pairs[i];
	    var index = pair.indexOf('=')
	
	    // skip things that don't look like key=value
	    if (index < 0) {
	      continue;
	    }
	
	    var key = pair.substring(0, index).trim()
	
	    // only assign once
	    if (undefined == obj[key]) {
	      var val = pair.substring(index + 1, pair.length).trim()
	
	      // quoted values
	      if (val[0] === '"') {
	        val = val.slice(1, -1)
	      }
	
	      obj[key] = tryDecode(val, dec);
	    }
	  }
	
	  return obj;
	}
	
	/**
	 * Serialize data into a cookie header.
	 *
	 * Serialize the a name value pair into a cookie string suitable for
	 * http headers. An optional options object specified cookie parameters.
	 *
	 * serialize('foo', 'bar', { httpOnly: true })
	 *   => "foo=bar; httpOnly"
	 *
	 * @param {string} name
	 * @param {string} val
	 * @param {object} [options]
	 * @return {string}
	 * @public
	 */
	
	function serialize(name, val, options) {
	  var opt = options || {};
	  var enc = opt.encode || encode;
	
	  if (typeof enc !== 'function') {
	    throw new TypeError('option encode is invalid');
	  }
	
	  if (!fieldContentRegExp.test(name)) {
	    throw new TypeError('argument name is invalid');
	  }
	
	  var value = enc(val);
	
	  if (value && !fieldContentRegExp.test(value)) {
	    throw new TypeError('argument val is invalid');
	  }
	
	  var str = name + '=' + value;
	
	  if (null != opt.maxAge) {
	    var maxAge = opt.maxAge - 0;
	
	    if (isNaN(maxAge) || !isFinite(maxAge)) {
	      throw new TypeError('option maxAge is invalid')
	    }
	
	    str += '; Max-Age=' + Math.floor(maxAge);
	  }
	
	  if (opt.domain) {
	    if (!fieldContentRegExp.test(opt.domain)) {
	      throw new TypeError('option domain is invalid');
	    }
	
	    str += '; Domain=' + opt.domain;
	  }
	
	  if (opt.path) {
	    if (!fieldContentRegExp.test(opt.path)) {
	      throw new TypeError('option path is invalid');
	    }
	
	    str += '; Path=' + opt.path;
	  }
	
	  if (opt.expires) {
	    if (typeof opt.expires.toUTCString !== 'function') {
	      throw new TypeError('option expires is invalid');
	    }
	
	    str += '; Expires=' + opt.expires.toUTCString();
	  }
	
	  if (opt.httpOnly) {
	    str += '; HttpOnly';
	  }
	
	  if (opt.secure) {
	    str += '; Secure';
	  }
	
	  if (opt.sameSite) {
	    var sameSite = typeof opt.sameSite === 'string'
	      ? opt.sameSite.toLowerCase() : opt.sameSite;
	
	    switch (sameSite) {
	      case true:
	        str += '; SameSite=Strict';
	        break;
	      case 'lax':
	        str += '; SameSite=Lax';
	        break;
	      case 'strict':
	        str += '; SameSite=Strict';
	        break;
	      case 'none':
	        str += '; SameSite=None';
	        break;
	      default:
	        throw new TypeError('option sameSite is invalid');
	    }
	  }
	
	  return str;
	}
	
	/**
	 * Try decoding a string using a decoding function.
	 *
	 * @param {string} str
	 * @param {function} decode
	 * @private
	 */
	
	function tryDecode(str, decode) {
	  try {
	    return decode(str);
	  } catch (e) {
	    return str;
	  }
	}


/***/ },
/* 373 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addLeadingZeros;
	function addLeadingZeros(number, targetLength) {
	  var sign = number < 0 ? '-' : '';
	  var output = Math.abs(number).toString();
	  while (output.length < targetLength) {
	    output = '0' + output;
	  }
	  return sign + output;
	}
	module.exports = exports.default;

/***/ },
/* 374 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _index = _interopRequireDefault(__webpack_require__(1124));
	var _default = _index.default;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 375 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
	  switch (pattern) {
	    case 'P':
	      return formatLong.date({
	        width: 'short'
	      });
	    case 'PP':
	      return formatLong.date({
	        width: 'medium'
	      });
	    case 'PPP':
	      return formatLong.date({
	        width: 'long'
	      });
	    case 'PPPP':
	    default:
	      return formatLong.date({
	        width: 'full'
	      });
	  }
	};
	var timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
	  switch (pattern) {
	    case 'p':
	      return formatLong.time({
	        width: 'short'
	      });
	    case 'pp':
	      return formatLong.time({
	        width: 'medium'
	      });
	    case 'ppp':
	      return formatLong.time({
	        width: 'long'
	      });
	    case 'pppp':
	    default:
	      return formatLong.time({
	        width: 'full'
	      });
	  }
	};
	var dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
	  var matchResult = pattern.match(/(P+)(p+)?/) || [];
	  var datePattern = matchResult[1];
	  var timePattern = matchResult[2];
	  if (!timePattern) {
	    return dateLongFormatter(pattern, formatLong);
	  }
	  var dateTimeFormat;
	  switch (datePattern) {
	    case 'P':
	      dateTimeFormat = formatLong.dateTime({
	        width: 'short'
	      });
	      break;
	    case 'PP':
	      dateTimeFormat = formatLong.dateTime({
	        width: 'medium'
	      });
	      break;
	    case 'PPP':
	      dateTimeFormat = formatLong.dateTime({
	        width: 'long'
	      });
	      break;
	    case 'PPPP':
	    default:
	      dateTimeFormat = formatLong.dateTime({
	        width: 'full'
	      });
	      break;
	  }
	  return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
	};
	var longFormatters = {
	  p: timeLongFormatter,
	  P: dateTimeLongFormatter
	};
	var _default = longFormatters;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 376 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getUTCISOWeek;
	var _index = _interopRequireDefault(__webpack_require__(23));
	var _index2 = _interopRequireDefault(__webpack_require__(148));
	var _index3 = _interopRequireDefault(__webpack_require__(1085));
	var _index4 = _interopRequireDefault(__webpack_require__(14));
	var MILLISECONDS_IN_WEEK = 604800000;
	function getUTCISOWeek(dirtyDate) {
	  (0, _index4.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var diff = (0, _index2.default)(date).getTime() - (0, _index3.default)(date).getTime();
	
	  // Round the number of days to the nearest integer
	  // because the number of milliseconds in a week is not constant
	  // (e.g. it's different in the week of the daylight saving time clock shift)
	  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
	}
	module.exports = exports.default;

/***/ },
/* 377 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getUTCISOWeekYear;
	var _index = _interopRequireDefault(__webpack_require__(23));
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	var _index3 = _interopRequireDefault(__webpack_require__(148));
	function getUTCISOWeekYear(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var year = date.getUTCFullYear();
	  var fourthOfJanuaryOfNextYear = new Date(0);
	  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
	  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
	  var startOfNextYear = (0, _index3.default)(fourthOfJanuaryOfNextYear);
	  var fourthOfJanuaryOfThisYear = new Date(0);
	  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
	  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
	  var startOfThisYear = (0, _index3.default)(fourthOfJanuaryOfThisYear);
	  if (date.getTime() >= startOfNextYear.getTime()) {
	    return year + 1;
	  } else if (date.getTime() >= startOfThisYear.getTime()) {
	    return year;
	  } else {
	    return year - 1;
	  }
	}
	module.exports = exports.default;

/***/ },
/* 378 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getUTCWeek;
	var _index = _interopRequireDefault(__webpack_require__(23));
	var _index2 = _interopRequireDefault(__webpack_require__(149));
	var _index3 = _interopRequireDefault(__webpack_require__(1086));
	var _index4 = _interopRequireDefault(__webpack_require__(14));
	var MILLISECONDS_IN_WEEK = 604800000;
	function getUTCWeek(dirtyDate, options) {
	  (0, _index4.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var diff = (0, _index2.default)(date, options).getTime() - (0, _index3.default)(date, options).getTime();
	
	  // Round the number of days to the nearest integer
	  // because the number of milliseconds in a week is not constant
	  // (e.g. it's different in the week of the daylight saving time clock shift)
	  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
	}
	module.exports = exports.default;

/***/ },
/* 379 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isProtectedDayOfYearToken = isProtectedDayOfYearToken;
	exports.isProtectedWeekYearToken = isProtectedWeekYearToken;
	exports.throwProtectedError = throwProtectedError;
	var protectedDayOfYearTokens = ['D', 'DD'];
	var protectedWeekYearTokens = ['YY', 'YYYY'];
	function isProtectedDayOfYearToken(token) {
	  return protectedDayOfYearTokens.indexOf(token) !== -1;
	}
	function isProtectedWeekYearToken(token) {
	  return protectedWeekYearTokens.indexOf(token) !== -1;
	}
	function throwProtectedError(token, format, input) {
	  if (token === 'YYYY') {
	    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
	  } else if (token === 'YY') {
	    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
	  } else if (token === 'D') {
	    throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
	  } else if (token === 'DD') {
	    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
	  }
	}

/***/ },
/* 380 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addHours;
	var _index = _interopRequireDefault(__webpack_require__(30));
	var _index2 = _interopRequireDefault(__webpack_require__(256));
	var _index3 = _interopRequireDefault(__webpack_require__(14));
	var MILLISECONDS_IN_HOUR = 3600000;
	
	/**
	 * @name addHours
	 * @category Hour Helpers
	 * @summary Add the specified number of hours to the given date.
	 *
	 * @description
	 * Add the specified number of hours to the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of hours to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the hours added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 2 hours to 10 July 2014 23:00:00:
	 * const result = addHours(new Date(2014, 6, 10, 23, 0), 2)
	 * //=> Fri Jul 11 2014 01:00:00
	 */
	function addHours(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, amount * MILLISECONDS_IN_HOUR);
	}
	module.exports = exports.default;

/***/ },
/* 381 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addMinutes;
	var _index = _interopRequireDefault(__webpack_require__(30));
	var _index2 = _interopRequireDefault(__webpack_require__(256));
	var _index3 = _interopRequireDefault(__webpack_require__(14));
	var MILLISECONDS_IN_MINUTE = 60000;
	
	/**
	 * @name addMinutes
	 * @category Minute Helpers
	 * @summary Add the specified number of minutes to the given date.
	 *
	 * @description
	 * Add the specified number of minutes to the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of minutes to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the minutes added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 30 minutes to 10 July 2014 12:00:00:
	 * const result = addMinutes(new Date(2014, 6, 10, 12, 0), 30)
	 * //=> Thu Jul 10 2014 12:30:00
	 */
	function addMinutes(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, amount * MILLISECONDS_IN_MINUTE);
	}
	module.exports = exports.default;

/***/ },
/* 382 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addWeeks;
	var _index = _interopRequireDefault(__webpack_require__(30));
	var _index2 = _interopRequireDefault(__webpack_require__(255));
	var _index3 = _interopRequireDefault(__webpack_require__(14));
	/**
	 * @name addWeeks
	 * @category Week Helpers
	 * @summary Add the specified number of weeks to the given date.
	 *
	 * @description
	 * Add the specified number of week to the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of weeks to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the weeks added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 4 weeks to 1 September 2014:
	 * const result = addWeeks(new Date(2014, 8, 1), 4)
	 * //=> Mon Sep 29 2014 00:00:00
	 */
	function addWeeks(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  var days = amount * 7;
	  return (0, _index2.default)(dirtyDate, days);
	}
	module.exports = exports.default;

/***/ },
/* 383 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addYears;
	var _index = _interopRequireDefault(__webpack_require__(30));
	var _index2 = _interopRequireDefault(__webpack_require__(257));
	var _index3 = _interopRequireDefault(__webpack_require__(14));
	/**
	 * @name addYears
	 * @category Year Helpers
	 * @summary Add the specified number of years to the given date.
	 *
	 * @description
	 * Add the specified number of years to the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of years to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the years added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 5 years to 1 September 2014:
	 * const result = addYears(new Date(2014, 8, 1), 5)
	 * //=> Sun Sep 01 2019 00:00:00
	 */
	function addYears(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, amount * 12);
	}
	module.exports = exports.default;

/***/ },
/* 384 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.secondsInYear = exports.secondsInWeek = exports.secondsInQuarter = exports.secondsInMonth = exports.secondsInMinute = exports.secondsInHour = exports.secondsInDay = exports.quartersInYear = exports.monthsInYear = exports.monthsInQuarter = exports.minutesInHour = exports.minTime = exports.millisecondsInSecond = exports.millisecondsInMinute = exports.millisecondsInHour = exports.maxTime = exports.daysInYear = exports.daysInWeek = void 0;
	/**
	 * Days in 1 week.
	 *
	 * @name daysInWeek
	 * @constant
	 * @type {number}
	 * @default
	 */
	var daysInWeek = 7;
	
	/**
	 * Days in 1 year
	 * One years equals 365.2425 days according to the formula:
	 *
	 * > Leap year occures every 4 years, except for years that are divisable by 100 and not divisable by 400.
	 * > 1 mean year = (365+1/4-1/100+1/400) days = 365.2425 days
	 *
	 * @name daysInYear
	 * @constant
	 * @type {number}
	 * @default
	 */
	exports.daysInWeek = daysInWeek;
	var daysInYear = 365.2425;
	
	/**
	 * Maximum allowed time.
	 *
	 * @name maxTime
	 * @constant
	 * @type {number}
	 * @default
	 */
	exports.daysInYear = daysInYear;
	var maxTime = Math.pow(10, 8) * 24 * 60 * 60 * 1000;
	
	/**
	 * Milliseconds in 1 minute
	 *
	 * @name millisecondsInMinute
	 * @constant
	 * @type {number}
	 * @default
	 */
	exports.maxTime = maxTime;
	var millisecondsInMinute = 60000;
	
	/**
	 * Milliseconds in 1 hour
	 *
	 * @name millisecondsInHour
	 * @constant
	 * @type {number}
	 * @default
	 */
	exports.millisecondsInMinute = millisecondsInMinute;
	var millisecondsInHour = 3600000;
	
	/**
	 * Milliseconds in 1 second
	 *
	 * @name millisecondsInSecond
	 * @constant
	 * @type {number}
	 * @default
	 */
	exports.millisecondsInHour = millisecondsInHour;
	var millisecondsInSecond = 1000;
	
	/**
	 * Minimum allowed time.
	 *
	 * @name minTime
	 * @constant
	 * @type {number}
	 * @default
	 */
	exports.millisecondsInSecond = millisecondsInSecond;
	var minTime = -maxTime;
	
	/**
	 * Minutes in 1 hour
	 *
	 * @name minutesInHour
	 * @constant
	 * @type {number}
	 * @default
	 */
	exports.minTime = minTime;
	var minutesInHour = 60;
	
	/**
	 * Months in 1 quarter
	 *
	 * @name monthsInQuarter
	 * @constant
	 * @type {number}
	 * @default
	 */
	exports.minutesInHour = minutesInHour;
	var monthsInQuarter = 3;
	
	/**
	 * Months in 1 year
	 *
	 * @name monthsInYear
	 * @constant
	 * @type {number}
	 * @default
	 */
	exports.monthsInQuarter = monthsInQuarter;
	var monthsInYear = 12;
	
	/**
	 * Quarters in 1 year
	 *
	 * @name quartersInYear
	 * @constant
	 * @type {number}
	 * @default
	 */
	exports.monthsInYear = monthsInYear;
	var quartersInYear = 4;
	
	/**
	 * Seconds in 1 hour
	 *
	 * @name secondsInHour
	 * @constant
	 * @type {number}
	 * @default
	 */
	exports.quartersInYear = quartersInYear;
	var secondsInHour = 3600;
	
	/**
	 * Seconds in 1 minute
	 *
	 * @name secondsInMinute
	 * @constant
	 * @type {number}
	 * @default
	 */
	exports.secondsInHour = secondsInHour;
	var secondsInMinute = 60;
	
	/**
	 * Seconds in 1 day
	 *
	 * @name secondsInDay
	 * @constant
	 * @type {number}
	 * @default
	 */
	exports.secondsInMinute = secondsInMinute;
	var secondsInDay = secondsInHour * 24;
	
	/**
	 * Seconds in 1 week
	 *
	 * @name secondsInWeek
	 * @constant
	 * @type {number}
	 * @default
	 */
	exports.secondsInDay = secondsInDay;
	var secondsInWeek = secondsInDay * 7;
	
	/**
	 * Seconds in 1 year
	 *
	 * @name secondsInYear
	 * @constant
	 * @type {number}
	 * @default
	 */
	exports.secondsInWeek = secondsInWeek;
	var secondsInYear = secondsInDay * daysInYear;
	
	/**
	 * Seconds in 1 month
	 *
	 * @name secondsInMonth
	 * @constant
	 * @type {number}
	 * @default
	 */
	exports.secondsInYear = secondsInYear;
	var secondsInMonth = secondsInYear / 12;
	
	/**
	 * Seconds in 1 quarter
	 *
	 * @name secondsInQuarter
	 * @constant
	 * @type {number}
	 * @default
	 */
	exports.secondsInMonth = secondsInMonth;
	var secondsInQuarter = secondsInMonth * 3;
	exports.secondsInQuarter = secondsInQuarter;

/***/ },
/* 385 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isDate;
	var _typeof2 = _interopRequireDefault(__webpack_require__(56));
	var _index = _interopRequireDefault(__webpack_require__(14));
	/**
	 * @name isDate
	 * @category Common Helpers
	 * @summary Is the given value a date?
	 *
	 * @description
	 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
	 *
	 * @param {*} value - the value to check
	 * @returns {boolean} true if the given value is a date
	 * @throws {TypeError} 1 arguments required
	 *
	 * @example
	 * // For a valid date:
	 * const result = isDate(new Date())
	 * //=> true
	 *
	 * @example
	 * // For an invalid date:
	 * const result = isDate(new Date(NaN))
	 * //=> true
	 *
	 * @example
	 * // For some value:
	 * const result = isDate('2014-02-31')
	 * //=> false
	 *
	 * @example
	 * // For an object:
	 * const result = isDate({})
	 * //=> false
	 */
	function isDate(value) {
	  (0, _index.default)(1, arguments);
	  return value instanceof Date || (0, _typeof2.default)(value) === 'object' && Object.prototype.toString.call(value) === '[object Date]';
	}
	module.exports = exports.default;

/***/ },
/* 386 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isValid;
	var _index = _interopRequireDefault(__webpack_require__(385));
	var _index2 = _interopRequireDefault(__webpack_require__(23));
	var _index3 = _interopRequireDefault(__webpack_require__(14));
	/**
	 * @name isValid
	 * @category Common Helpers
	 * @summary Is the given date valid?
	 *
	 * @description
	 * Returns false if argument is Invalid Date and true otherwise.
	 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * Invalid Date is a Date, whose time value is NaN.
	 *
	 * Time value of Date: http://es5.github.io/#x15.9.1.1
	 *
	 * @param {*} date - the date to check
	 * @returns {Boolean} the date is valid
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // For the valid date:
	 * const result = isValid(new Date(2014, 1, 31))
	 * //=> true
	 *
	 * @example
	 * // For the value, convertable into a date:
	 * const result = isValid(1393804800000)
	 * //=> true
	 *
	 * @example
	 * // For the invalid date:
	 * const result = isValid(new Date(''))
	 * //=> false
	 */
	function isValid(dirtyDate) {
	  (0, _index3.default)(1, arguments);
	  if (!(0, _index.default)(dirtyDate) && typeof dirtyDate !== 'number') {
	    return false;
	  }
	  var date = (0, _index2.default)(dirtyDate);
	  return !isNaN(Number(date));
	}
	module.exports = exports.default;

/***/ },
/* 387 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ValueSetter = exports.Setter = exports.DateToSystemTimezoneSetter = void 0;
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(12));
	var _inherits2 = _interopRequireDefault(__webpack_require__(22));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(29));
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	var _createClass2 = _interopRequireDefault(__webpack_require__(19));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(24));
	var TIMEZONE_UNIT_PRIORITY = 10;
	var Setter = /*#__PURE__*/function () {
	  function Setter() {
	    (0, _classCallCheck2.default)(this, Setter);
	    (0, _defineProperty2.default)(this, "priority", void 0);
	    (0, _defineProperty2.default)(this, "subPriority", 0);
	  }
	  (0, _createClass2.default)(Setter, [{
	    key: "validate",
	    value: function validate(_utcDate, _options) {
	      return true;
	    }
	  }]);
	  return Setter;
	}();
	exports.Setter = Setter;
	var ValueSetter = /*#__PURE__*/function (_Setter) {
	  (0, _inherits2.default)(ValueSetter, _Setter);
	  var _super = (0, _createSuper2.default)(ValueSetter);
	  function ValueSetter(value, validateValue, setValue, priority, subPriority) {
	    var _this;
	    (0, _classCallCheck2.default)(this, ValueSetter);
	    _this = _super.call(this);
	    _this.value = value;
	    _this.validateValue = validateValue;
	    _this.setValue = setValue;
	    _this.priority = priority;
	    if (subPriority) {
	      _this.subPriority = subPriority;
	    }
	    return _this;
	  }
	  (0, _createClass2.default)(ValueSetter, [{
	    key: "validate",
	    value: function validate(utcDate, options) {
	      return this.validateValue(utcDate, this.value, options);
	    }
	  }, {
	    key: "set",
	    value: function set(utcDate, flags, options) {
	      return this.setValue(utcDate, flags, this.value, options);
	    }
	  }]);
	  return ValueSetter;
	}(Setter);
	exports.ValueSetter = ValueSetter;
	var DateToSystemTimezoneSetter = /*#__PURE__*/function (_Setter2) {
	  (0, _inherits2.default)(DateToSystemTimezoneSetter, _Setter2);
	  var _super2 = (0, _createSuper2.default)(DateToSystemTimezoneSetter);
	  function DateToSystemTimezoneSetter() {
	    var _this2;
	    (0, _classCallCheck2.default)(this, DateToSystemTimezoneSetter);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this2 = _super2.call.apply(_super2, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this2), "priority", TIMEZONE_UNIT_PRIORITY);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this2), "subPriority", -1);
	    return _this2;
	  }
	  (0, _createClass2.default)(DateToSystemTimezoneSetter, [{
	    key: "set",
	    value: function set(date, flags) {
	      if (flags.timestampIsSet) {
	        return date;
	      }
	      var convertedDate = new Date(0);
	      convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
	      convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
	      return convertedDate;
	    }
	  }]);
	  return DateToSystemTimezoneSetter;
	}(Setter);
	exports.DateToSystemTimezoneSetter = DateToSystemTimezoneSetter;

/***/ },
/* 388 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setMonth;
	var _index = _interopRequireDefault(__webpack_require__(30));
	var _index2 = _interopRequireDefault(__webpack_require__(23));
	var _index3 = _interopRequireDefault(__webpack_require__(1097));
	var _index4 = _interopRequireDefault(__webpack_require__(14));
	/**
	 * @name setMonth
	 * @category Month Helpers
	 * @summary Set the month to the given date.
	 *
	 * @description
	 * Set the month to the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} month - the month of the new date
	 * @returns {Date} the new date with the month set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set February to 1 September 2014:
	 * const result = setMonth(new Date(2014, 8, 1), 1)
	 * //=> Sat Feb 01 2014 00:00:00
	 */
	function setMonth(dirtyDate, dirtyMonth) {
	  (0, _index4.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var month = (0, _index.default)(dirtyMonth);
	  var year = date.getFullYear();
	  var day = date.getDate();
	  var dateWithDesiredMonth = new Date(0);
	  dateWithDesiredMonth.setFullYear(year, month, 15);
	  dateWithDesiredMonth.setHours(0, 0, 0, 0);
	  var daysInMonth = (0, _index3.default)(dateWithDesiredMonth);
	  // Set the last day of the new month
	  // if the original date was the last day of the longer month
	  date.setMonth(month, Math.min(day, daysInMonth));
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 389 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfQuarter;
	var _index = _interopRequireDefault(__webpack_require__(23));
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	/**
	 * @name startOfQuarter
	 * @category Quarter Helpers
	 * @summary Return the start of a year quarter for the given date.
	 *
	 * @description
	 * Return the start of a year quarter for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the start of a quarter
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The start of a quarter for 2 September 2014 11:55:00:
	 * const result = startOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Tue Jul 01 2014 00:00:00
	 */
	function startOfQuarter(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var currentMonth = date.getMonth();
	  var month = currentMonth - currentMonth % 3;
	  date.setMonth(month, 1);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 390 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subMilliseconds;
	var _index = _interopRequireDefault(__webpack_require__(256));
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	var _index3 = _interopRequireDefault(__webpack_require__(30));
	/**
	 * @name subMilliseconds
	 * @category Millisecond Helpers
	 * @summary Subtract the specified number of milliseconds from the given date.
	 *
	 * @description
	 * Subtract the specified number of milliseconds from the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the milliseconds subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
	 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
	 * //=> Thu Jul 10 2014 12:45:29.250
	 */
	function subMilliseconds(dirtyDate, dirtyAmount) {
	  (0, _index2.default)(2, arguments);
	  var amount = (0, _index3.default)(dirtyAmount);
	  return (0, _index.default)(dirtyDate, -amount);
	}
	module.exports = exports.default;

/***/ },
/* 391 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	module.exports = {
	  BOLD: {
	    fontWeight: 'bold'
	  },
	  CODE: {
	    fontFamily: 'monospace',
	    wordWrap: 'break-word'
	  },
	  ITALIC: {
	    fontStyle: 'italic'
	  },
	  STRIKETHROUGH: {
	    textDecoration: 'line-through'
	  },
	  UNDERLINE: {
	    textDecoration: 'underline'
	  }
	};

/***/ },
/* 392 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	var _assign = __webpack_require__(58);
	
	function _extends() { _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var DraftEditorLeaf = __webpack_require__(393);
	
	var DraftOffsetKey = __webpack_require__(91);
	
	var React = __webpack_require__(1);
	
	var Scroll = __webpack_require__(268);
	
	var Style = __webpack_require__(198);
	
	var UnicodeBidi = __webpack_require__(269);
	
	var UnicodeBidiDirection = __webpack_require__(199);
	
	var cx = __webpack_require__(108);
	
	var getElementPosition = __webpack_require__(431);
	
	var getScrollPosition = __webpack_require__(200);
	
	var getViewportDimensions = __webpack_require__(432);
	
	var invariant = __webpack_require__(32);
	
	var isHTMLElement = __webpack_require__(153);
	
	var nullthrows = __webpack_require__(61);
	
	var SCROLL_BUFFER = 10;
	
	/**
	 * Return whether a block overlaps with either edge of the `SelectionState`.
	 */
	var isBlockOnSelectionEdge = function isBlockOnSelectionEdge(selection, key) {
	  return selection.getAnchorKey() === key || selection.getFocusKey() === key;
	};
	/**
	 * The default block renderer for a `DraftEditor` component.
	 *
	 * A `DraftEditorBlock` is able to render a given `ContentBlock` to its
	 * appropriate decorator and inline style components.
	 */
	
	
	var DraftEditorBlock = /*#__PURE__*/function (_React$Component) {
	  _inheritsLoose(DraftEditorBlock, _React$Component);
	
	  function DraftEditorBlock() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	
	    _defineProperty(_assertThisInitialized(_this), "_node", void 0);
	
	    return _this;
	  }
	
	  var _proto = DraftEditorBlock.prototype;
	
	  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	    return this.props.block !== nextProps.block || this.props.tree !== nextProps.tree || this.props.direction !== nextProps.direction || isBlockOnSelectionEdge(nextProps.selection, nextProps.block.getKey()) && nextProps.forceSelection;
	  }
	  /**
	   * When a block is mounted and overlaps the selection state, we need to make
	   * sure that the cursor is visible to match native behavior. This may not
	   * be the case if the user has pressed `RETURN` or pasted some content, since
	   * programmatically creating these new blocks and setting the DOM selection
	   * will miss out on the browser natively scrolling to that position.
	   *
	   * To replicate native behavior, if the block overlaps the selection state
	   * on mount, force the scroll position. Check the scroll state of the scroll
	   * parent, and adjust it to align the entire block to the bottom of the
	   * scroll parent.
	   */
	  ;
	
	  _proto.componentDidMount = function componentDidMount() {
	    if (this.props.preventScroll) {
	      return;
	    }
	
	    var selection = this.props.selection;
	    var endKey = selection.getEndKey();
	
	    if (!selection.getHasFocus() || endKey !== this.props.block.getKey()) {
	      return;
	    }
	
	    var blockNode = this._node;
	
	    if (blockNode == null) {
	      return;
	    }
	
	    var scrollParent = Style.getScrollParent(blockNode);
	    var scrollPosition = getScrollPosition(scrollParent);
	    var scrollDelta;
	
	    if (scrollParent === window) {
	      var nodePosition = getElementPosition(blockNode);
	      var nodeBottom = nodePosition.y + nodePosition.height;
	      var viewportHeight = getViewportDimensions().height;
	      scrollDelta = nodeBottom - viewportHeight;
	
	      if (scrollDelta > 0) {
	        window.scrollTo(scrollPosition.x, scrollPosition.y + scrollDelta + SCROLL_BUFFER);
	      }
	    } else {
	      !isHTMLElement(blockNode) ?  false ? invariant(false, 'blockNode is not an HTMLElement') : invariant(false) : void 0;
	      var blockBottom = blockNode.offsetHeight + blockNode.offsetTop;
	      var pOffset = scrollParent.offsetTop + scrollParent.offsetHeight;
	      var scrollBottom = pOffset + scrollPosition.y;
	      scrollDelta = blockBottom - scrollBottom;
	
	      if (scrollDelta > 0) {
	        Scroll.setTop(scrollParent, Scroll.getTop(scrollParent) + scrollDelta + SCROLL_BUFFER);
	      }
	    }
	  };
	
	  _proto._renderChildren = function _renderChildren() {
	    var _this2 = this;
	
	    var block = this.props.block;
	    var blockKey = block.getKey();
	    var text = block.getText();
	    var lastLeafSet = this.props.tree.size - 1;
	    var hasSelection = isBlockOnSelectionEdge(this.props.selection, blockKey);
	    return this.props.tree.map(function (leafSet, ii) {
	      var leavesForLeafSet = leafSet.get('leaves'); // T44088704
	
	      if (leavesForLeafSet.size === 0) {
	        return null;
	      }
	
	      var lastLeaf = leavesForLeafSet.size - 1;
	      var leaves = leavesForLeafSet.map(function (leaf, jj) {
	        var offsetKey = DraftOffsetKey.encode(blockKey, ii, jj);
	        var start = leaf.get('start');
	        var end = leaf.get('end');
	        return React.createElement(DraftEditorLeaf, {
	          key: offsetKey,
	          offsetKey: offsetKey,
	          block: block,
	          start: start,
	          selection: hasSelection ? _this2.props.selection : null,
	          forceSelection: _this2.props.forceSelection,
	          text: text.slice(start, end),
	          styleSet: block.getInlineStyleAt(start),
	          customStyleMap: _this2.props.customStyleMap,
	          customStyleFn: _this2.props.customStyleFn,
	          isLast: ii === lastLeafSet && jj === lastLeaf
	        });
	      }).toArray();
	      var decoratorKey = leafSet.get('decoratorKey');
	
	      if (decoratorKey == null) {
	        return leaves;
	      }
	
	      if (!_this2.props.decorator) {
	        return leaves;
	      }
	
	      var decorator = nullthrows(_this2.props.decorator);
	      var DecoratorComponent = decorator.getComponentForKey(decoratorKey);
	
	      if (!DecoratorComponent) {
	        return leaves;
	      }
	
	      var decoratorProps = decorator.getPropsForKey(decoratorKey);
	      var decoratorOffsetKey = DraftOffsetKey.encode(blockKey, ii, 0);
	      var start = leavesForLeafSet.first().get('start');
	      var end = leavesForLeafSet.last().get('end');
	      var decoratedText = text.slice(start, end);
	      var entityKey = block.getEntityAt(leafSet.get('start')); // Resetting dir to the same value on a child node makes Chrome/Firefox
	      // confused on cursor movement. See http://jsfiddle.net/d157kLck/3/
	
	      var dir = UnicodeBidiDirection.getHTMLDirIfDifferent(UnicodeBidi.getDirection(decoratedText), _this2.props.direction);
	      var commonProps = {
	        contentState: _this2.props.contentState,
	        decoratedText: decoratedText,
	        dir: dir,
	        start: start,
	        end: end,
	        blockKey: blockKey,
	        entityKey: entityKey,
	        offsetKey: decoratorOffsetKey
	      };
	      return React.createElement(DecoratorComponent, _extends({}, decoratorProps, commonProps, {
	        key: decoratorOffsetKey
	      }), leaves);
	    }).toArray();
	  };
	
	  _proto.render = function render() {
	    var _this3 = this;
	
	    var _this$props = this.props,
	        direction = _this$props.direction,
	        offsetKey = _this$props.offsetKey;
	    var className = cx({
	      'public/DraftStyleDefault/block': true,
	      'public/DraftStyleDefault/ltr': direction === 'LTR',
	      'public/DraftStyleDefault/rtl': direction === 'RTL'
	    });
	    return React.createElement("div", {
	      "data-offset-key": offsetKey,
	      className: className,
	      ref: function ref(_ref) {
	        return _this3._node = _ref;
	      }
	    }, this._renderChildren());
	  };
	
	  return DraftEditorBlock;
	}(React.Component);
	
	module.exports = DraftEditorBlock;

/***/ },
/* 393 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	var _assign = __webpack_require__(58);
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var DraftEditorTextNode = __webpack_require__(1198);
	
	var React = __webpack_require__(1);
	
	var invariant = __webpack_require__(32);
	
	var isHTMLBRElement = __webpack_require__(417);
	
	var setDraftEditorSelection = __webpack_require__(1250).setDraftEditorSelection;
	
	/**
	 * All leaf nodes in the editor are spans with single text nodes. Leaf
	 * elements are styled based on the merging of an optional custom style map
	 * and a default style map.
	 *
	 * `DraftEditorLeaf` also provides a wrapper for calling into the imperative
	 * DOM Selection API. In this way, top-level components can declaratively
	 * maintain the selection state.
	 */
	var DraftEditorLeaf = /*#__PURE__*/function (_React$Component) {
	  _inheritsLoose(DraftEditorLeaf, _React$Component);
	
	  function DraftEditorLeaf() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	
	    _defineProperty(_assertThisInitialized(_this), "leaf", void 0);
	
	    return _this;
	  }
	
	  var _proto = DraftEditorLeaf.prototype;
	
	  _proto._setSelection = function _setSelection() {
	    var selection = this.props.selection; // If selection state is irrelevant to the parent block, no-op.
	
	    if (selection == null || !selection.getHasFocus()) {
	      return;
	    }
	
	    var _this$props = this.props,
	        block = _this$props.block,
	        start = _this$props.start,
	        text = _this$props.text;
	    var blockKey = block.getKey();
	    var end = start + text.length;
	
	    if (!selection.hasEdgeWithin(blockKey, start, end)) {
	      return;
	    } // Determine the appropriate target node for selection. If the child
	    // is not a text node, it is a <br /> spacer. In this case, use the
	    // <span> itself as the selection target.
	
	
	    var node = this.leaf;
	    !node ?  false ? invariant(false, 'Missing node') : invariant(false) : void 0;
	    var child = node.firstChild;
	    !child ?  false ? invariant(false, 'Missing child') : invariant(false) : void 0;
	    var targetNode;
	
	    if (child.nodeType === Node.TEXT_NODE) {
	      targetNode = child;
	    } else if (isHTMLBRElement(child)) {
	      targetNode = node;
	    } else {
	      targetNode = child.firstChild;
	      !targetNode ?  false ? invariant(false, 'Missing targetNode') : invariant(false) : void 0;
	    }
	
	    setDraftEditorSelection(selection, targetNode, blockKey, start, end);
	  };
	
	  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	    var leafNode = this.leaf;
	    !leafNode ?  false ? invariant(false, 'Missing leafNode') : invariant(false) : void 0;
	    var shouldUpdate = leafNode.textContent !== nextProps.text || nextProps.styleSet !== this.props.styleSet || nextProps.forceSelection;
	    return shouldUpdate;
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate() {
	    this._setSelection();
	  };
	
	  _proto.componentDidMount = function componentDidMount() {
	    this._setSelection();
	  };
	
	  _proto.render = function render() {
	    var _this2 = this;
	
	    var block = this.props.block;
	    var text = this.props.text; // If the leaf is at the end of its block and ends in a soft newline, append
	    // an extra line feed character. Browsers collapse trailing newline
	    // characters, which leaves the cursor in the wrong place after a
	    // shift+enter. The extra character repairs this.
	
	    if (text.endsWith('\n') && this.props.isLast) {
	      text += '\n';
	    }
	
	    var _this$props2 = this.props,
	        customStyleMap = _this$props2.customStyleMap,
	        customStyleFn = _this$props2.customStyleFn,
	        offsetKey = _this$props2.offsetKey,
	        styleSet = _this$props2.styleSet;
	    var styleObj = styleSet.reduce(function (map, styleName) {
	      var mergedStyles = {};
	      var style = customStyleMap[styleName];
	
	      if (style !== undefined && map.textDecoration !== style.textDecoration) {
	        // .trim() is necessary for IE9/10/11 and Edge
	        mergedStyles.textDecoration = [map.textDecoration, style.textDecoration].join(' ').trim();
	      }
	
	      return _assign(map, style, mergedStyles);
	    }, {});
	
	    if (customStyleFn) {
	      var newStyles = customStyleFn(styleSet, block);
	      styleObj = _assign(styleObj, newStyles);
	    }
	
	    return React.createElement("span", {
	      "data-offset-key": offsetKey,
	      ref: function ref(_ref) {
	        return _this2.leaf = _ref;
	      },
	      style: styleObj
	    }, React.createElement(DraftEditorTextNode, null, text));
	  };
	
	  return DraftEditorLeaf;
	}(React.Component);
	
	module.exports = DraftEditorLeaf;

/***/ },
/* 394 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	'use strict';
	
	module.exports = {
	  initODS: function initODS() {},
	  handleExtensionCausedError: function handleExtensionCausedError() {}
	};

/***/ },
/* 395 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @legacyServerCallableInstance
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	var Immutable = __webpack_require__(27);
	
	var Record = Immutable.Record;
	var DraftEntityInstanceRecord = Record({
	  type: 'TOKEN',
	  mutability: 'IMMUTABLE',
	  data: Object
	});
	/**
	 * An instance of a document entity, consisting of a `type` and relevant
	 * `data`, metadata about the entity.
	 *
	 * For instance, a "link" entity might provide a URI, and a "mention"
	 * entity might provide the mentioned user's ID. These pieces of data
	 * may be used when rendering the entity as part of a ContentBlock DOM
	 * representation. For a link, the data would be used as an href for
	 * the rendered anchor. For a mention, the ID could be used to retrieve
	 * a hovercard.
	 */
	
	var DraftEntityInstance = /*#__PURE__*/function (_DraftEntityInstanceR) {
	  _inheritsLoose(DraftEntityInstance, _DraftEntityInstanceR);
	
	  function DraftEntityInstance() {
	    return _DraftEntityInstanceR.apply(this, arguments) || this;
	  }
	
	  var _proto = DraftEntityInstance.prototype;
	
	  _proto.getType = function getType() {
	    return this.get('type');
	  };
	
	  _proto.getMutability = function getMutability() {
	    return this.get('mutability');
	  };
	
	  _proto.getData = function getData() {
	    return this.get('data');
	  };
	
	  return DraftEntityInstance;
	}(DraftEntityInstanceRecord);
	
	module.exports = DraftEntityInstance;

/***/ },
/* 396 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	'use strict';
	
	module.exports = {
	  logBlockedSelectionEvent: function logBlockedSelectionEvent() {
	    return null;
	  },
	  logSelectionStateFailure: function logSelectionStateFailure() {
	    return null;
	  }
	};

/***/ },
/* 397 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	var TokenizeUtil = __webpack_require__(1273);
	
	var punctuation = TokenizeUtil.getPunctuation(); // The apostrophe and curly single quotes behave in a curious way: when
	// surrounded on both sides by word characters, they behave as word chars; when
	// either neighbor is punctuation or an end of the string, they behave as
	// punctuation.
	
	var CHAMELEON_CHARS = "['\u2018\u2019]"; // Remove the underscore, which should count as part of the removable word. The
	// "chameleon chars" also count as punctuation in this regex.
	
	var WHITESPACE_AND_PUNCTUATION = '\\s|(?![_])' + punctuation;
	var DELETE_STRING = '^' + '(?:' + WHITESPACE_AND_PUNCTUATION + ')*' + '(?:' + CHAMELEON_CHARS + '|(?!' + WHITESPACE_AND_PUNCTUATION + ').)*' + '(?:(?!' + WHITESPACE_AND_PUNCTUATION + ').)';
	var DELETE_REGEX = new RegExp(DELETE_STRING);
	var BACKSPACE_STRING = '(?:(?!' + WHITESPACE_AND_PUNCTUATION + ').)' + '(?:' + CHAMELEON_CHARS + '|(?!' + WHITESPACE_AND_PUNCTUATION + ').)*' + '(?:' + WHITESPACE_AND_PUNCTUATION + ')*' + '$';
	var BACKSPACE_REGEX = new RegExp(BACKSPACE_STRING);
	
	function getRemovableWord(text, isBackward) {
	  var matches = isBackward ? BACKSPACE_REGEX.exec(text) : DELETE_REGEX.exec(text);
	  return matches ? matches[0] : text;
	}
	
	var DraftRemovableWord = {
	  getBackward: function getBackward(text) {
	    return getRemovableWord(text, true);
	  },
	  getForward: function getForward(text) {
	    return getRemovableWord(text, false);
	  }
	};
	module.exports = DraftRemovableWord;

/***/ },
/* 398 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	var DraftStringKey = {
	  stringify: function stringify(key) {
	    return '_' + String(key);
	  },
	  unstringify: function unstringify(key) {
	    return key.slice(1);
	  }
	};
	module.exports = DraftStringKey;

/***/ },
/* 399 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	var DraftModifier = __webpack_require__(59);
	
	var EditorState = __webpack_require__(36);
	
	var adjustBlockDepthForContentState = __webpack_require__(1206);
	
	var nullthrows = __webpack_require__(61);
	
	var RichTextEditorUtil = {
	  currentBlockContainsLink: function currentBlockContainsLink(editorState) {
	    var selection = editorState.getSelection();
	    var contentState = editorState.getCurrentContent();
	    var entityMap = contentState.getEntityMap();
	    return contentState.getBlockForKey(selection.getAnchorKey()).getCharacterList().slice(selection.getStartOffset(), selection.getEndOffset()).some(function (v) {
	      var entity = v.getEntity();
	      return !!entity && entityMap.__get(entity).getType() === 'LINK';
	    });
	  },
	  getCurrentBlockType: function getCurrentBlockType(editorState) {
	    var selection = editorState.getSelection();
	    return editorState.getCurrentContent().getBlockForKey(selection.getStartKey()).getType();
	  },
	  getDataObjectForLinkURL: function getDataObjectForLinkURL(uri) {
	    return {
	      url: uri.toString()
	    };
	  },
	  handleKeyCommand: function handleKeyCommand(editorState, command, eventTimeStamp) {
	    switch (command) {
	      case 'bold':
	        return RichTextEditorUtil.toggleInlineStyle(editorState, 'BOLD');
	
	      case 'italic':
	        return RichTextEditorUtil.toggleInlineStyle(editorState, 'ITALIC');
	
	      case 'underline':
	        return RichTextEditorUtil.toggleInlineStyle(editorState, 'UNDERLINE');
	
	      case 'code':
	        return RichTextEditorUtil.toggleCode(editorState);
	
	      case 'backspace':
	      case 'backspace-word':
	      case 'backspace-to-start-of-line':
	        return RichTextEditorUtil.onBackspace(editorState);
	
	      case 'delete':
	      case 'delete-word':
	      case 'delete-to-end-of-block':
	        return RichTextEditorUtil.onDelete(editorState);
	
	      default:
	        // they may have custom editor commands; ignore those
	        return null;
	    }
	  },
	  insertSoftNewline: function insertSoftNewline(editorState) {
	    var contentState = DraftModifier.insertText(editorState.getCurrentContent(), editorState.getSelection(), '\n', editorState.getCurrentInlineStyle(), null);
	    var newEditorState = EditorState.push(editorState, contentState, 'insert-characters');
	    return EditorState.forceSelection(newEditorState, contentState.getSelectionAfter());
	  },
	
	  /**
	   * For collapsed selections at the start of styled blocks, backspace should
	   * just remove the existing style.
	   */
	  onBackspace: function onBackspace(editorState) {
	    var selection = editorState.getSelection();
	
	    if (!selection.isCollapsed() || selection.getAnchorOffset() || selection.getFocusOffset()) {
	      return null;
	    } // First, try to remove a preceding atomic block.
	
	
	    var content = editorState.getCurrentContent();
	    var startKey = selection.getStartKey();
	    var blockBefore = content.getBlockBefore(startKey);
	
	    if (blockBefore && blockBefore.getType() === 'atomic') {
	      var blockMap = content.getBlockMap()["delete"](blockBefore.getKey());
	      var withoutAtomicBlock = content.merge({
	        blockMap: blockMap,
	        selectionAfter: selection
	      });
	
	      if (withoutAtomicBlock !== content) {
	        return EditorState.push(editorState, withoutAtomicBlock, 'remove-range');
	      }
	    } // If that doesn't succeed, try to remove the current block style.
	
	
	    var withoutBlockStyle = RichTextEditorUtil.tryToRemoveBlockStyle(editorState);
	
	    if (withoutBlockStyle) {
	      return EditorState.push(editorState, withoutBlockStyle, 'change-block-type');
	    }
	
	    return null;
	  },
	  onDelete: function onDelete(editorState) {
	    var selection = editorState.getSelection();
	
	    if (!selection.isCollapsed()) {
	      return null;
	    }
	
	    var content = editorState.getCurrentContent();
	    var startKey = selection.getStartKey();
	    var block = content.getBlockForKey(startKey);
	    var length = block.getLength(); // The cursor is somewhere within the text. Behave normally.
	
	    if (selection.getStartOffset() < length) {
	      return null;
	    }
	
	    var blockAfter = content.getBlockAfter(startKey);
	
	    if (!blockAfter || blockAfter.getType() !== 'atomic') {
	      return null;
	    }
	
	    var atomicBlockTarget = selection.merge({
	      focusKey: blockAfter.getKey(),
	      focusOffset: blockAfter.getLength()
	    });
	    var withoutAtomicBlock = DraftModifier.removeRange(content, atomicBlockTarget, 'forward');
	
	    if (withoutAtomicBlock !== content) {
	      return EditorState.push(editorState, withoutAtomicBlock, 'remove-range');
	    }
	
	    return null;
	  },
	  onTab: function onTab(event, editorState, maxDepth) {
	    var selection = editorState.getSelection();
	    var key = selection.getAnchorKey();
	
	    if (key !== selection.getFocusKey()) {
	      return editorState;
	    }
	
	    var content = editorState.getCurrentContent();
	    var block = content.getBlockForKey(key);
	    var type = block.getType();
	
	    if (type !== 'unordered-list-item' && type !== 'ordered-list-item') {
	      return editorState;
	    }
	
	    event.preventDefault();
	    var depth = block.getDepth();
	
	    if (!event.shiftKey && depth === maxDepth) {
	      return editorState;
	    }
	
	    var withAdjustment = adjustBlockDepthForContentState(content, selection, event.shiftKey ? -1 : 1, maxDepth);
	    return EditorState.push(editorState, withAdjustment, 'adjust-depth');
	  },
	  toggleBlockType: function toggleBlockType(editorState, blockType) {
	    var selection = editorState.getSelection();
	    var startKey = selection.getStartKey();
	    var endKey = selection.getEndKey();
	    var content = editorState.getCurrentContent();
	    var target = selection; // Triple-click can lead to a selection that includes offset 0 of the
	    // following block. The `SelectionState` for this case is accurate, but
	    // we should avoid toggling block type for the trailing block because it
	    // is a confusing interaction.
	
	    if (startKey !== endKey && selection.getEndOffset() === 0) {
	      var blockBefore = nullthrows(content.getBlockBefore(endKey));
	      endKey = blockBefore.getKey();
	      target = target.merge({
	        anchorKey: startKey,
	        anchorOffset: selection.getStartOffset(),
	        focusKey: endKey,
	        focusOffset: blockBefore.getLength(),
	        isBackward: false
	      });
	    }
	
	    var hasAtomicBlock = content.getBlockMap().skipWhile(function (_, k) {
	      return k !== startKey;
	    }).reverse().skipWhile(function (_, k) {
	      return k !== endKey;
	    }).some(function (v) {
	      return v.getType() === 'atomic';
	    });
	
	    if (hasAtomicBlock) {
	      return editorState;
	    }
	
	    var typeToSet = content.getBlockForKey(startKey).getType() === blockType ? 'unstyled' : blockType;
	    return EditorState.push(editorState, DraftModifier.setBlockType(content, target, typeToSet), 'change-block-type');
	  },
	  toggleCode: function toggleCode(editorState) {
	    var selection = editorState.getSelection();
	    var anchorKey = selection.getAnchorKey();
	    var focusKey = selection.getFocusKey();
	
	    if (selection.isCollapsed() || anchorKey !== focusKey) {
	      return RichTextEditorUtil.toggleBlockType(editorState, 'code-block');
	    }
	
	    return RichTextEditorUtil.toggleInlineStyle(editorState, 'CODE');
	  },
	
	  /**
	   * Toggle the specified inline style for the selection. If the
	   * user's selection is collapsed, apply or remove the style for the
	   * internal state. If it is not collapsed, apply the change directly
	   * to the document state.
	   */
	  toggleInlineStyle: function toggleInlineStyle(editorState, inlineStyle) {
	    var selection = editorState.getSelection();
	    var currentStyle = editorState.getCurrentInlineStyle(); // If the selection is collapsed, toggle the specified style on or off and
	    // set the result as the new inline style override. This will then be
	    // used as the inline style for the next character to be inserted.
	
	    if (selection.isCollapsed()) {
	      return EditorState.setInlineStyleOverride(editorState, currentStyle.has(inlineStyle) ? currentStyle.remove(inlineStyle) : currentStyle.add(inlineStyle));
	    } // If characters are selected, immediately apply or remove the
	    // inline style on the document state itself.
	
	
	    var content = editorState.getCurrentContent();
	    var newContent; // If the style is already present for the selection range, remove it.
	    // Otherwise, apply it.
	
	    if (currentStyle.has(inlineStyle)) {
	      newContent = DraftModifier.removeInlineStyle(content, selection, inlineStyle);
	    } else {
	      newContent = DraftModifier.applyInlineStyle(content, selection, inlineStyle);
	    }
	
	    return EditorState.push(editorState, newContent, 'change-inline-style');
	  },
	  toggleLink: function toggleLink(editorState, targetSelection, entityKey) {
	    var withoutLink = DraftModifier.applyEntity(editorState.getCurrentContent(), targetSelection, entityKey);
	    return EditorState.push(editorState, withoutLink, 'apply-entity');
	  },
	
	  /**
	   * When a collapsed cursor is at the start of a styled block, changes block
	   * type to 'unstyled'. Returns null if selection does not meet that criteria.
	   */
	  tryToRemoveBlockStyle: function tryToRemoveBlockStyle(editorState) {
	    var selection = editorState.getSelection();
	    var offset = selection.getAnchorOffset();
	
	    if (selection.isCollapsed() && offset === 0) {
	      var key = selection.getAnchorKey();
	      var content = editorState.getCurrentContent();
	      var block = content.getBlockForKey(key);
	      var type = block.getType();
	      var blockBefore = content.getBlockBefore(key);
	
	      if (type === 'code-block' && blockBefore && blockBefore.getType() === 'code-block' && blockBefore.getLength() !== 0) {
	        return null;
	      }
	
	      if (type !== 'unstyled') {
	        return DraftModifier.setBlockType(content, selection, 'unstyled');
	      }
	    }
	
	    return null;
	  }
	};
	module.exports = RichTextEditorUtil;

/***/ },
/* 400 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	var _knownListItemDepthCl;
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var CharacterMetadata = __webpack_require__(70);
	
	var ContentBlock = __webpack_require__(104);
	
	var ContentBlockNode = __webpack_require__(71);
	
	var DefaultDraftBlockRenderMap = __webpack_require__(263);
	
	var DraftEntity = __webpack_require__(190);
	
	var URI = __webpack_require__(1274);
	
	var cx = __webpack_require__(108);
	
	var generateRandomKey = __webpack_require__(85);
	
	var getSafeBodyFromHTML = __webpack_require__(411);
	
	var gkx = __webpack_require__(97);
	
	var _require = __webpack_require__(27),
	    List = _require.List,
	    Map = _require.Map,
	    OrderedSet = _require.OrderedSet;
	
	var isHTMLAnchorElement = __webpack_require__(1234);
	
	var isHTMLBRElement = __webpack_require__(417);
	
	var isHTMLElement = __webpack_require__(153);
	
	var isHTMLImageElement = __webpack_require__(1235);
	
	var experimentalTreeDataSupport = gkx('draft_tree_data_support');
	var NBSP = '&nbsp;';
	var SPACE = ' '; // used for replacing characters in HTML
	
	var REGEX_CR = new RegExp('\r', 'g');
	var REGEX_LF = new RegExp('\n', 'g');
	var REGEX_LEADING_LF = new RegExp('^\n', 'g');
	var REGEX_NBSP = new RegExp(NBSP, 'g');
	var REGEX_CARRIAGE = new RegExp('&#13;?', 'g');
	var REGEX_ZWS = new RegExp('&#8203;?', 'g'); // https://developer.mozilla.org/en-US/docs/Web/CSS/font-weight
	
	var boldValues = ['bold', 'bolder', '500', '600', '700', '800', '900'];
	var notBoldValues = ['light', 'lighter', 'normal', '100', '200', '300', '400'];
	var anchorAttr = ['className', 'href', 'rel', 'target', 'title'];
	var imgAttr = ['alt', 'className', 'height', 'src', 'width'];
	var knownListItemDepthClasses = (_knownListItemDepthCl = {}, _defineProperty(_knownListItemDepthCl, cx('public/DraftStyleDefault/depth0'), 0), _defineProperty(_knownListItemDepthCl, cx('public/DraftStyleDefault/depth1'), 1), _defineProperty(_knownListItemDepthCl, cx('public/DraftStyleDefault/depth2'), 2), _defineProperty(_knownListItemDepthCl, cx('public/DraftStyleDefault/depth3'), 3), _defineProperty(_knownListItemDepthCl, cx('public/DraftStyleDefault/depth4'), 4), _knownListItemDepthCl);
	var HTMLTagToRawInlineStyleMap = Map({
	  b: 'BOLD',
	  code: 'CODE',
	  del: 'STRIKETHROUGH',
	  em: 'ITALIC',
	  i: 'ITALIC',
	  s: 'STRIKETHROUGH',
	  strike: 'STRIKETHROUGH',
	  strong: 'BOLD',
	  u: 'UNDERLINE',
	  mark: 'HIGHLIGHT'
	});
	
	/**
	 * Build a mapping from HTML tags to draftjs block types
	 * out of a BlockRenderMap.
	 *
	 * The BlockTypeMap for the default BlockRenderMap looks like this:
	 *   Map({
	 *     h1: 'header-one',
	 *     h2: 'header-two',
	 *     h3: 'header-three',
	 *     h4: 'header-four',
	 *     h5: 'header-five',
	 *     h6: 'header-six',
	 *     blockquote: 'blockquote',
	 *     figure: 'atomic',
	 *     pre: ['code-block'],
	 *     div: 'unstyled',
	 *     p: 'unstyled',
	 *     li: ['ordered-list-item', 'unordered-list-item'],
	 *   })
	 */
	var buildBlockTypeMap = function buildBlockTypeMap(blockRenderMap) {
	  var blockTypeMap = {};
	  blockRenderMap.mapKeys(function (blockType, desc) {
	    var elements = [desc.element];
	
	    if (desc.aliasedElements !== undefined) {
	      elements.push.apply(elements, desc.aliasedElements);
	    }
	
	    elements.forEach(function (element) {
	      if (blockTypeMap[element] === undefined) {
	        blockTypeMap[element] = blockType;
	      } else if (typeof blockTypeMap[element] === 'string') {
	        blockTypeMap[element] = [blockTypeMap[element], blockType];
	      } else {
	        blockTypeMap[element].push(blockType);
	      }
	    });
	  });
	  return Map(blockTypeMap);
	};
	
	var detectInlineStyle = function detectInlineStyle(node) {
	  if (isHTMLElement(node)) {
	    var element = node; // Currently only used to detect preformatted inline code
	
	    if (element.style.fontFamily.includes('monospace')) {
	      return 'CODE';
	    }
	  }
	
	  return null;
	};
	/**
	 * If we're pasting from one DraftEditor to another we can check to see if
	 * existing list item depth classes are being used and preserve this style
	 */
	
	
	var getListItemDepth = function getListItemDepth(node) {
	  var depth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	  Object.keys(knownListItemDepthClasses).some(function (depthClass) {
	    if (node.classList.contains(depthClass)) {
	      depth = knownListItemDepthClasses[depthClass];
	    }
	  });
	  return depth;
	};
	/**
	 * Return true if the provided HTML Element can be used to build a
	 * Draftjs-compatible link.
	 */
	
	
	var isValidAnchor = function isValidAnchor(node) {
	  if (!isHTMLAnchorElement(node)) {
	    return false;
	  }
	
	  var anchorNode = node;
	
	  if (!anchorNode.href || anchorNode.protocol !== 'http:' && anchorNode.protocol !== 'https:' && anchorNode.protocol !== 'mailto:' && anchorNode.protocol !== 'tel:') {
	    return false;
	  }
	
	  try {
	    // Just checking whether we can actually create a URI
	    var _ = new URI(anchorNode.href);
	
	    return true; // We need our catch statements to have arguments, else
	    // UglifyJS (which we use for our OSS builds) will crash.
	    // eslint-disable-next-line fb-www/no-unused-catch-bindings
	  } catch (_) {
	    return false;
	  }
	};
	/**
	 * Return true if the provided HTML Element can be used to build a
	 * Draftjs-compatible image.
	 */
	
	
	var isValidImage = function isValidImage(node) {
	  if (!isHTMLImageElement(node)) {
	    return false;
	  }
	
	  var imageNode = node;
	  return !!(imageNode.attributes.getNamedItem('src') && imageNode.attributes.getNamedItem('src').value);
	};
	/**
	 * Try to guess the inline style of an HTML element based on its css
	 * styles (font-weight, font-style and text-decoration).
	 */
	
	
	var styleFromNodeAttributes = function styleFromNodeAttributes(node, style) {
	  if (!isHTMLElement(node)) {
	    return style;
	  }
	
	  var htmlElement = node;
	  var fontWeight = htmlElement.style.fontWeight;
	  var fontStyle = htmlElement.style.fontStyle;
	  var textDecoration = htmlElement.style.textDecoration;
	  return style.withMutations(function (style) {
	    if (boldValues.indexOf(fontWeight) >= 0) {
	      style.add('BOLD');
	    } else if (notBoldValues.indexOf(fontWeight) >= 0) {
	      style.remove('BOLD');
	    }
	
	    if (fontStyle === 'italic') {
	      style.add('ITALIC');
	    } else if (fontStyle === 'normal') {
	      style.remove('ITALIC');
	    }
	
	    if (textDecoration === 'underline') {
	      style.add('UNDERLINE');
	    }
	
	    if (textDecoration === 'line-through') {
	      style.add('STRIKETHROUGH');
	    }
	
	    if (textDecoration === 'none') {
	      style.remove('UNDERLINE');
	      style.remove('STRIKETHROUGH');
	    }
	  });
	};
	/**
	 * Determine if a nodeName is a list type, 'ul' or 'ol'
	 */
	
	
	var isListNode = function isListNode(nodeName) {
	  return nodeName === 'ul' || nodeName === 'ol';
	};
	/**
	 *  ContentBlockConfig is a mutable data structure that holds all
	 *  the information required to build a ContentBlock and an array of
	 *  all the child nodes (childConfigs).
	 *  It is being used a temporary data structure by the
	 *  ContentBlocksBuilder class.
	 */
	
	
	/**
	 * ContentBlocksBuilder builds a list of ContentBlocks and an Entity Map
	 * out of one (or several) HTMLElement(s).
	 *
	 * The algorithm has two passes: first it builds a tree of ContentBlockConfigs
	 * by walking through the HTML nodes and their children, then it walks the
	 * ContentBlockConfigs tree to compute parents/siblings and create
	 * the actual ContentBlocks.
	 *
	 * Typical usage is:
	 *     new ContentBlocksBuilder()
	 *        .addDOMNode(someHTMLNode)
	 *        .addDOMNode(someOtherHTMLNode)
	 *       .getContentBlocks();
	 *
	 */
	var ContentBlocksBuilder = /*#__PURE__*/function () {
	  // Most of the method in the class depend on the state of the content builder
	  // (i.e. currentBlockType, currentDepth, currentEntity etc.). Though it may
	  // be confusing at first, it made the code simpler than the alternative which
	  // is to pass those values around in every call.
	  // The following attributes are used to accumulate text and styles
	  // as we are walking the HTML node tree.
	  // Describes the future ContentState as a tree of content blocks
	  // The content blocks generated from the blockConfigs
	  // Entity map use to store links and images found in the HTML nodes
	  // Map HTML tags to draftjs block types and disambiguation function
	  function ContentBlocksBuilder(blockTypeMap, disambiguate) {
	    _defineProperty(this, "characterList", List());
	
	    _defineProperty(this, "currentBlockType", 'unstyled');
	
	    _defineProperty(this, "currentDepth", 0);
	
	    _defineProperty(this, "currentEntity", null);
	
	    _defineProperty(this, "currentText", '');
	
	    _defineProperty(this, "wrapper", null);
	
	    _defineProperty(this, "blockConfigs", []);
	
	    _defineProperty(this, "contentBlocks", []);
	
	    _defineProperty(this, "entityMap", DraftEntity);
	
	    _defineProperty(this, "blockTypeMap", void 0);
	
	    _defineProperty(this, "disambiguate", void 0);
	
	    this.clear();
	    this.blockTypeMap = blockTypeMap;
	    this.disambiguate = disambiguate;
	  }
	  /**
	   * Clear the internal state of the ContentBlocksBuilder
	   */
	
	
	  var _proto = ContentBlocksBuilder.prototype;
	
	  _proto.clear = function clear() {
	    this.characterList = List();
	    this.blockConfigs = [];
	    this.currentBlockType = 'unstyled';
	    this.currentDepth = 0;
	    this.currentEntity = null;
	    this.currentText = '';
	    this.entityMap = DraftEntity;
	    this.wrapper = null;
	    this.contentBlocks = [];
	  }
	  /**
	   * Add an HTMLElement to the ContentBlocksBuilder
	   */
	  ;
	
	  _proto.addDOMNode = function addDOMNode(node) {
	    var _this$blockConfigs;
	
	    this.contentBlocks = [];
	    this.currentDepth = 0; // Converts the HTML node to block config
	
	    (_this$blockConfigs = this.blockConfigs).push.apply(_this$blockConfigs, this._toBlockConfigs([node], OrderedSet())); // There might be some left over text in the builder's
	    // internal state, if so make a ContentBlock out of it.
	
	
	    this._trimCurrentText();
	
	    if (this.currentText !== '') {
	      this.blockConfigs.push(this._makeBlockConfig());
	    } // for chaining
	
	
	    return this;
	  }
	  /**
	   * Return the ContentBlocks and the EntityMap that corresponds
	   * to the previously added HTML nodes.
	   */
	  ;
	
	  _proto.getContentBlocks = function getContentBlocks() {
	    if (this.contentBlocks.length === 0) {
	      if (experimentalTreeDataSupport) {
	        this._toContentBlocks(this.blockConfigs);
	      } else {
	        this._toFlatContentBlocks(this.blockConfigs);
	      }
	    }
	
	    return {
	      contentBlocks: this.contentBlocks,
	      entityMap: this.entityMap
	    };
	  } // ***********************************WARNING******************************
	  // The methods below this line are private - don't call them directly.
	
	  /**
	   * Generate a new ContentBlockConfig out of the current internal state
	   * of the builder, then clears the internal state.
	   */
	  ;
	
	  _proto._makeBlockConfig = function _makeBlockConfig() {
	    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var key = config.key || generateRandomKey();
	
	    var block = _objectSpread({
	      key: key,
	      type: this.currentBlockType,
	      text: this.currentText,
	      characterList: this.characterList,
	      depth: this.currentDepth,
	      parent: null,
	      children: List(),
	      prevSibling: null,
	      nextSibling: null,
	      childConfigs: []
	    }, config);
	
	    this.characterList = List();
	    this.currentBlockType = 'unstyled';
	    this.currentText = '';
	    return block;
	  }
	  /**
	   * Converts an array of HTML elements to a multi-root tree of content
	   * block configs. Some text content may be left in the builders internal
	   * state to enable chaining sucessive calls.
	   */
	  ;
	
	  _proto._toBlockConfigs = function _toBlockConfigs(nodes, style) {
	    var blockConfigs = [];
	
	    for (var i = 0; i < nodes.length; i++) {
	      var node = nodes[i];
	      var nodeName = node.nodeName.toLowerCase();
	
	      if (nodeName === 'body' || isListNode(nodeName)) {
	        // body, ol and ul are 'block' type nodes so create a block config
	        // with the text accumulated so far (if any)
	        this._trimCurrentText();
	
	        if (this.currentText !== '') {
	          blockConfigs.push(this._makeBlockConfig());
	        } // body, ol and ul nodes are ignored, but their children are inlined in
	        // the parent block config.
	
	
	        var wasCurrentDepth = this.currentDepth;
	        var wasWrapper = this.wrapper;
	
	        if (isListNode(nodeName)) {
	          this.wrapper = nodeName;
	
	          if (isListNode(wasWrapper)) {
	            this.currentDepth++;
	          }
	        }
	
	        blockConfigs.push.apply(blockConfigs, this._toBlockConfigs(Array.from(node.childNodes), style));
	        this.currentDepth = wasCurrentDepth;
	        this.wrapper = wasWrapper;
	        continue;
	      }
	
	      var blockType = this.blockTypeMap.get(nodeName);
	
	      if (blockType !== undefined) {
	        // 'block' type node means we need to create a block config
	        // with the text accumulated so far (if any)
	        this._trimCurrentText();
	
	        if (this.currentText !== '') {
	          blockConfigs.push(this._makeBlockConfig());
	        }
	
	        var _wasCurrentDepth = this.currentDepth;
	        var _wasWrapper = this.wrapper;
	        this.wrapper = nodeName === 'pre' ? 'pre' : this.wrapper;
	
	        if (typeof blockType !== 'string') {
	          blockType = this.disambiguate(nodeName, this.wrapper) || blockType[0] || 'unstyled';
	        }
	
	        if (!experimentalTreeDataSupport && isHTMLElement(node) && (blockType === 'unordered-list-item' || blockType === 'ordered-list-item')) {
	          var htmlElement = node;
	          this.currentDepth = getListItemDepth(htmlElement, this.currentDepth);
	        }
	
	        var key = generateRandomKey();
	
	        var childConfigs = this._toBlockConfigs(Array.from(node.childNodes), style);
	
	        this._trimCurrentText();
	
	        blockConfigs.push(this._makeBlockConfig({
	          key: key,
	          childConfigs: childConfigs,
	          type: blockType
	        }));
	        this.currentDepth = _wasCurrentDepth;
	        this.wrapper = _wasWrapper;
	        continue;
	      }
	
	      if (nodeName === '#text') {
	        this._addTextNode(node, style);
	
	        continue;
	      }
	
	      if (nodeName === 'br') {
	        this._addBreakNode(node, style);
	
	        continue;
	      }
	
	      if (isValidImage(node)) {
	        this._addImgNode(node, style);
	
	        continue;
	      }
	
	      if (isValidAnchor(node)) {
	        this._addAnchorNode(node, blockConfigs, style);
	
	        continue;
	      }
	
	      var newStyle = style;
	
	      if (HTMLTagToRawInlineStyleMap.has(nodeName)) {
	        newStyle = newStyle.add(HTMLTagToRawInlineStyleMap.get(nodeName));
	      }
	
	      newStyle = styleFromNodeAttributes(node, newStyle);
	      var inlineStyle = detectInlineStyle(node);
	
	      if (inlineStyle != null) {
	        newStyle = newStyle.add(inlineStyle);
	      }
	
	      blockConfigs.push.apply(blockConfigs, this._toBlockConfigs(Array.from(node.childNodes), newStyle));
	    }
	
	    return blockConfigs;
	  }
	  /**
	   * Append a string of text to the internal buffer.
	   */
	  ;
	
	  _proto._appendText = function _appendText(text, style) {
	    var _this$characterList;
	
	    this.currentText += text;
	    var characterMetadata = CharacterMetadata.create({
	      style: style,
	      entity: this.currentEntity
	    });
	    this.characterList = (_this$characterList = this.characterList).push.apply(_this$characterList, Array(text.length).fill(characterMetadata));
	  }
	  /**
	   * Trim the text in the internal buffer.
	   */
	  ;
	
	  _proto._trimCurrentText = function _trimCurrentText() {
	    var l = this.currentText.length;
	    var begin = l - this.currentText.trimLeft().length;
	    var end = this.currentText.trimRight().length; // We should not trim whitespaces for which an entity is defined.
	
	    var entity = this.characterList.findEntry(function (characterMetadata) {
	      return characterMetadata.getEntity() !== null;
	    });
	    begin = entity !== undefined ? Math.min(begin, entity[0]) : begin;
	    entity = this.characterList.reverse().findEntry(function (characterMetadata) {
	      return characterMetadata.getEntity() !== null;
	    });
	    end = entity !== undefined ? Math.max(end, l - entity[0]) : end;
	
	    if (begin > end) {
	      this.currentText = '';
	      this.characterList = List();
	    } else {
	      this.currentText = this.currentText.slice(begin, end);
	      this.characterList = this.characterList.slice(begin, end);
	    }
	  }
	  /**
	   * Add the content of an HTML text node to the internal state
	   */
	  ;
	
	  _proto._addTextNode = function _addTextNode(node, style) {
	    var text = node.textContent;
	    var trimmedText = text.trim(); // If we are not in a pre block and the trimmed content is empty,
	    // normalize to a single space.
	
	    if (trimmedText === '' && this.wrapper !== 'pre') {
	      text = ' ';
	    }
	
	    if (this.wrapper !== 'pre') {
	      // Trim leading line feed, which is invisible in HTML
	      text = text.replace(REGEX_LEADING_LF, ''); // Can't use empty string because MSWord
	
	      text = text.replace(REGEX_LF, SPACE);
	    }
	
	    this._appendText(text, style);
	  };
	
	  _proto._addBreakNode = function _addBreakNode(node, style) {
	    if (!isHTMLBRElement(node)) {
	      return;
	    }
	
	    this._appendText('\n', style);
	  }
	  /**
	   * Add the content of an HTML img node to the internal state
	   */
	  ;
	
	  _proto._addImgNode = function _addImgNode(node, style) {
	    if (!isHTMLImageElement(node)) {
	      return;
	    }
	
	    var image = node;
	    var entityConfig = {};
	    imgAttr.forEach(function (attr) {
	      var imageAttribute = image.getAttribute(attr);
	
	      if (imageAttribute) {
	        entityConfig[attr] = imageAttribute;
	      }
	    }); // TODO: T15530363 update this when we remove DraftEntity entirely
	
	    this.currentEntity = this.entityMap.__create('IMAGE', 'IMMUTABLE', entityConfig); // The child text node cannot just have a space or return as content (since
	    // we strip those out), unless the image is for presentation only.
	    // See https://github.com/facebook/draft-js/issues/231 for some context.
	
	    if (gkx('draftjs_fix_paste_for_img')) {
	      if (image.getAttribute('role') !== 'presentation') {
	        this._appendText("\uD83D\uDCF7", style);
	      }
	    } else {
	      this._appendText("\uD83D\uDCF7", style);
	    }
	
	    this.currentEntity = null;
	  }
	  /**
	   * Add the content of an HTML 'a' node to the internal state. Child nodes
	   * (if any) are converted to Block Configs and appended to the provided
	   * blockConfig array.
	   */
	  ;
	
	  _proto._addAnchorNode = function _addAnchorNode(node, blockConfigs, style) {
	    // The check has already been made by isValidAnchor but
	    // we have to do it again to keep flow happy.
	    if (!isHTMLAnchorElement(node)) {
	      return;
	    }
	
	    var anchor = node;
	    var entityConfig = {};
	    anchorAttr.forEach(function (attr) {
	      var anchorAttribute = anchor.getAttribute(attr);
	
	      if (anchorAttribute) {
	        entityConfig[attr] = anchorAttribute;
	      }
	    });
	    entityConfig.url = new URI(anchor.href).toString(); // TODO: T15530363 update this when we remove DraftEntity completely
	
	    this.currentEntity = this.entityMap.__create('LINK', 'MUTABLE', entityConfig || {});
	    blockConfigs.push.apply(blockConfigs, this._toBlockConfigs(Array.from(node.childNodes), style));
	    this.currentEntity = null;
	  }
	  /**
	   * Walk the BlockConfig tree, compute parent/children/siblings,
	   * and generate the corresponding ContentBlockNode
	   */
	  ;
	
	  _proto._toContentBlocks = function _toContentBlocks(blockConfigs) {
	    var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	    var l = blockConfigs.length - 1;
	
	    for (var i = 0; i <= l; i++) {
	      var config = blockConfigs[i];
	      config.parent = parent;
	      config.prevSibling = i > 0 ? blockConfigs[i - 1].key : null;
	      config.nextSibling = i < l ? blockConfigs[i + 1].key : null;
	      config.children = List(config.childConfigs.map(function (child) {
	        return child.key;
	      }));
	      this.contentBlocks.push(new ContentBlockNode(_objectSpread({}, config)));
	
	      this._toContentBlocks(config.childConfigs, config.key);
	    }
	  }
	  /**
	   * Remove 'useless' container nodes from the block config hierarchy, by
	   * replacing them with their children.
	   */
	  ;
	
	  _proto._hoistContainersInBlockConfigs = function _hoistContainersInBlockConfigs(blockConfigs) {
	    var _this = this;
	
	    var hoisted = List(blockConfigs).flatMap(function (blockConfig) {
	      // Don't mess with useful blocks
	      if (blockConfig.type !== 'unstyled' || blockConfig.text !== '') {
	        return [blockConfig];
	      }
	
	      return _this._hoistContainersInBlockConfigs(blockConfig.childConfigs);
	    });
	    return hoisted;
	  } // ***********************************************************************
	  // The two methods below are used for backward compatibility when
	  // experimentalTreeDataSupport is disabled.
	
	  /**
	   * Same as _toContentBlocks but replaces nested blocks by their
	   * text content.
	   */
	  ;
	
	  _proto._toFlatContentBlocks = function _toFlatContentBlocks(blockConfigs) {
	    var _this2 = this;
	
	    var cleanConfigs = this._hoistContainersInBlockConfigs(blockConfigs);
	
	    cleanConfigs.forEach(function (config) {
	      var _this2$_extractTextFr = _this2._extractTextFromBlockConfigs(config.childConfigs),
	          text = _this2$_extractTextFr.text,
	          characterList = _this2$_extractTextFr.characterList;
	
	      _this2.contentBlocks.push(new ContentBlock(_objectSpread({}, config, {
	        text: config.text + text,
	        characterList: config.characterList.concat(characterList)
	      })));
	    });
	  }
	  /**
	   * Extract the text and the associated inline styles form an
	   * array of content block configs.
	   */
	  ;
	
	  _proto._extractTextFromBlockConfigs = function _extractTextFromBlockConfigs(blockConfigs) {
	    var l = blockConfigs.length - 1;
	    var text = '';
	    var characterList = List();
	
	    for (var i = 0; i <= l; i++) {
	      var config = blockConfigs[i];
	      text += config.text;
	      characterList = characterList.concat(config.characterList);
	
	      if (text !== '' && config.type !== 'unstyled') {
	        text += '\n';
	        characterList = characterList.push(characterList.last());
	      }
	
	      var children = this._extractTextFromBlockConfigs(config.childConfigs);
	
	      text += children.text;
	      characterList = characterList.concat(children.characterList);
	    }
	
	    return {
	      text: text,
	      characterList: characterList
	    };
	  };
	
	  return ContentBlocksBuilder;
	}();
	/**
	 * Converts an HTML string to an array of ContentBlocks and an EntityMap
	 * suitable to initialize the internal state of a Draftjs component.
	 */
	
	
	var convertFromHTMLToContentBlocks = function convertFromHTMLToContentBlocks(html) {
	  var DOMBuilder = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getSafeBodyFromHTML;
	  var blockRenderMap = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DefaultDraftBlockRenderMap;
	  // Be ABSOLUTELY SURE that the dom builder you pass here won't execute
	  // arbitrary code in whatever environment you're running this in. For an
	  // example of how we try to do this in-browser, see getSafeBodyFromHTML.
	  // Remove funky characters from the HTML string
	  html = html.trim().replace(REGEX_CR, '').replace(REGEX_NBSP, SPACE).replace(REGEX_CARRIAGE, '').replace(REGEX_ZWS, ''); // Build a DOM tree out of the HTML string
	
	  var safeBody = DOMBuilder(html);
	
	  if (!safeBody) {
	    return null;
	  } // Build a BlockTypeMap out of the BlockRenderMap
	
	
	  var blockTypeMap = buildBlockTypeMap(blockRenderMap); // Select the proper block type for the cases where the blockRenderMap
	  // uses multiple block types for the same html tag.
	
	  var disambiguate = function disambiguate(tag, wrapper) {
	    if (tag === 'li') {
	      return wrapper === 'ol' ? 'ordered-list-item' : 'unordered-list-item';
	    }
	
	    return null;
	  };
	
	  return new ContentBlocksBuilder(blockTypeMap, disambiguate).addDOMNode(safeBody).getContentBlocks();
	};
	
	module.exports = convertFromHTMLToContentBlocks;

/***/ },
/* 401 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * Provides utilities for handling draftjs keys.
	 *
	 * @emails oncall+draft_js
	 * 
	 * @format
	 */
	'use strict';
	
	function notEmptyKey(key) {
	  return key != null && key != '';
	}
	
	module.exports = {
	  notEmptyKey: notEmptyKey
	};

/***/ },
/* 402 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	var DraftJsDebugLogging = __webpack_require__(396);
	
	var EditorState = __webpack_require__(36);
	
	var getContentEditableContainer = __webpack_require__(403);
	
	var getDraftEditorSelection = __webpack_require__(405);
	
	function editOnSelect(editor) {
	  if (editor._blockSelectEvents || editor._latestEditorState !== editor.props.editorState) {
	    if (editor._blockSelectEvents) {
	      var _editorState = editor.props.editorState;
	
	      var selectionState = _editorState.getSelection();
	
	      DraftJsDebugLogging.logBlockedSelectionEvent({
	        // For now I don't think we need any other info
	        anonymizedDom: 'N/A',
	        extraParams: JSON.stringify({
	          stacktrace: new Error().stack
	        }),
	        selectionState: JSON.stringify(selectionState.toJS())
	      });
	    }
	
	    return;
	  }
	
	  var editorState = editor.props.editorState;
	  var documentSelection = getDraftEditorSelection(editorState, getContentEditableContainer(editor));
	  var updatedSelectionState = documentSelection.selectionState;
	
	  if (updatedSelectionState !== editorState.getSelection()) {
	    if (documentSelection.needsRecovery) {
	      editorState = EditorState.forceSelection(editorState, updatedSelectionState);
	    } else {
	      editorState = EditorState.acceptSelection(editorState, updatedSelectionState);
	    }
	
	    editor.update(editorState);
	  }
	}
	
	module.exports = editOnSelect;

/***/ },
/* 403 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	var invariant = __webpack_require__(32);
	
	var isHTMLElement = __webpack_require__(153);
	
	function getContentEditableContainer(editor) {
	  var editorNode = editor.editorContainer;
	  !editorNode ?  false ? invariant(false, 'Missing editorNode') : invariant(false) : void 0;
	  !isHTMLElement(editorNode.firstChild) ?  false ? invariant(false, 'editorNode.firstChild is not an HTMLElement') : invariant(false) : void 0;
	  var htmlElement = editorNode.firstChild;
	  return htmlElement;
	}
	
	module.exports = getContentEditableContainer;

/***/ },
/* 404 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	var KeyBindingUtil = __webpack_require__(264);
	
	var Keys = __webpack_require__(197);
	
	var UserAgent = __webpack_require__(60);
	
	var isOSX = UserAgent.isPlatform('Mac OS X'); // Firefox on OSX had a bug resulting in navigation instead of cursor movement.
	// This bug was fixed in Firefox 29. Feature detection is virtually impossible
	// so we just check the version number. See #342765.
	
	var shouldFixFirefoxMovement = isOSX && UserAgent.isBrowser('Firefox < 29');
	var hasCommandModifier = KeyBindingUtil.hasCommandModifier,
	    isCtrlKeyCommand = KeyBindingUtil.isCtrlKeyCommand;
	
	function shouldRemoveWord(e) {
	  return isOSX && e.altKey || isCtrlKeyCommand(e);
	}
	/**
	 * Get the appropriate undo/redo command for a Z key command.
	 */
	
	
	function getZCommand(e) {
	  if (!hasCommandModifier(e)) {
	    return null;
	  }
	
	  return e.shiftKey ? 'redo' : 'undo';
	}
	
	function getDeleteCommand(e) {
	  // Allow default "cut" behavior for PCs on Shift + Delete.
	  if (!isOSX && e.shiftKey) {
	    return null;
	  }
	
	  return shouldRemoveWord(e) ? 'delete-word' : 'delete';
	}
	
	function getBackspaceCommand(e) {
	  if (hasCommandModifier(e) && isOSX) {
	    return 'backspace-to-start-of-line';
	  }
	
	  return shouldRemoveWord(e) ? 'backspace-word' : 'backspace';
	}
	/**
	 * Retrieve a bound key command for the given event.
	 */
	
	
	function getDefaultKeyBinding(e) {
	  switch (e.keyCode) {
	    case 66:
	      // B
	      return hasCommandModifier(e) ? 'bold' : null;
	
	    case 68:
	      // D
	      return isCtrlKeyCommand(e) ? 'delete' : null;
	
	    case 72:
	      // H
	      return isCtrlKeyCommand(e) ? 'backspace' : null;
	
	    case 73:
	      // I
	      return hasCommandModifier(e) ? 'italic' : null;
	
	    case 74:
	      // J
	      return hasCommandModifier(e) ? 'code' : null;
	
	    case 75:
	      // K
	      return isOSX && isCtrlKeyCommand(e) ? 'secondary-cut' : null;
	
	    case 77:
	      // M
	      return isCtrlKeyCommand(e) ? 'split-block' : null;
	
	    case 79:
	      // O
	      return isCtrlKeyCommand(e) ? 'split-block' : null;
	
	    case 84:
	      // T
	      return isOSX && isCtrlKeyCommand(e) ? 'transpose-characters' : null;
	
	    case 85:
	      // U
	      return hasCommandModifier(e) ? 'underline' : null;
	
	    case 87:
	      // W
	      return isOSX && isCtrlKeyCommand(e) ? 'backspace-word' : null;
	
	    case 89:
	      // Y
	      if (isCtrlKeyCommand(e)) {
	        return isOSX ? 'secondary-paste' : 'redo';
	      }
	
	      return null;
	
	    case 90:
	      // Z
	      return getZCommand(e) || null;
	
	    case Keys.RETURN:
	      return 'split-block';
	
	    case Keys.DELETE:
	      return getDeleteCommand(e);
	
	    case Keys.BACKSPACE:
	      return getBackspaceCommand(e);
	    // LEFT/RIGHT handlers serve as a workaround for a Firefox bug.
	
	    case Keys.LEFT:
	      return shouldFixFirefoxMovement && hasCommandModifier(e) ? 'move-selection-to-start-of-block' : null;
	
	    case Keys.RIGHT:
	      return shouldFixFirefoxMovement && hasCommandModifier(e) ? 'move-selection-to-end-of-block' : null;
	
	    default:
	      return null;
	  }
	}
	
	module.exports = getDefaultKeyBinding;

/***/ },
/* 405 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	var getDraftEditorSelectionWithNodes = __webpack_require__(406);
	/**
	 * Convert the current selection range to an anchor/focus pair of offset keys
	 * and values that can be interpreted by components.
	 */
	
	
	function getDraftEditorSelection(editorState, root) {
	  var selection = root.ownerDocument.defaultView.getSelection();
	  var anchorNode = selection.anchorNode,
	      anchorOffset = selection.anchorOffset,
	      focusNode = selection.focusNode,
	      focusOffset = selection.focusOffset,
	      rangeCount = selection.rangeCount;
	
	  if ( // No active selection.
	  rangeCount === 0 || // No selection, ever. As in, the user hasn't selected anything since
	  // opening the document.
	  anchorNode == null || focusNode == null) {
	    return {
	      selectionState: editorState.getSelection().set('hasFocus', false),
	      needsRecovery: false
	    };
	  }
	
	  return getDraftEditorSelectionWithNodes(editorState, root, anchorNode, anchorOffset, focusNode, focusOffset);
	}
	
	module.exports = getDraftEditorSelection;

/***/ },
/* 406 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	var findAncestorOffsetKey = __webpack_require__(192);
	
	var getSelectionOffsetKeyForNode = __webpack_require__(412);
	
	var getUpdatedSelectionState = __webpack_require__(414);
	
	var invariant = __webpack_require__(32);
	
	var isElement = __webpack_require__(105);
	
	var nullthrows = __webpack_require__(61);
	
	/**
	 * Convert the current selection range to an anchor/focus pair of offset keys
	 * and values that can be interpreted by components.
	 */
	function getDraftEditorSelectionWithNodes(editorState, root, anchorNode, anchorOffset, focusNode, focusOffset) {
	  var anchorIsTextNode = anchorNode.nodeType === Node.TEXT_NODE;
	  var focusIsTextNode = focusNode.nodeType === Node.TEXT_NODE; // If the selection range lies only on text nodes, the task is simple.
	  // Find the nearest offset-aware elements and use the
	  // offset values supplied by the selection range.
	
	  if (anchorIsTextNode && focusIsTextNode) {
	    return {
	      selectionState: getUpdatedSelectionState(editorState, nullthrows(findAncestorOffsetKey(anchorNode)), anchorOffset, nullthrows(findAncestorOffsetKey(focusNode)), focusOffset),
	      needsRecovery: false
	    };
	  }
	
	  var anchorPoint = null;
	  var focusPoint = null;
	  var needsRecovery = true; // An element is selected. Convert this selection range into leaf offset
	  // keys and offset values for consumption at the component level. This
	  // is common in Firefox, where select-all and triple click behavior leads
	  // to entire elements being selected.
	  //
	  // Note that we use the `needsRecovery` parameter in the callback here. This
	  // is because when certain elements are selected, the behavior for subsequent
	  // cursor movement (e.g. via arrow keys) is uncertain and may not match
	  // expectations at the component level. For example, if an entire <div> is
	  // selected and the user presses the right arrow, Firefox keeps the selection
	  // on the <div>. If we allow subsequent keypresses to insert characters
	  // natively, they will be inserted into a browser-created text node to the
	  // right of that <div>. This is obviously undesirable.
	  //
	  // With the `needsRecovery` flag, we inform the caller that it is responsible
	  // for manually setting the selection state on the rendered document to
	  // ensure proper selection state maintenance.
	
	  if (anchorIsTextNode) {
	    anchorPoint = {
	      key: nullthrows(findAncestorOffsetKey(anchorNode)),
	      offset: anchorOffset
	    };
	    focusPoint = getPointForNonTextNode(root, focusNode, focusOffset);
	  } else if (focusIsTextNode) {
	    focusPoint = {
	      key: nullthrows(findAncestorOffsetKey(focusNode)),
	      offset: focusOffset
	    };
	    anchorPoint = getPointForNonTextNode(root, anchorNode, anchorOffset);
	  } else {
	    anchorPoint = getPointForNonTextNode(root, anchorNode, anchorOffset);
	    focusPoint = getPointForNonTextNode(root, focusNode, focusOffset); // If the selection is collapsed on an empty block, don't force recovery.
	    // This way, on arrow key selection changes, the browser can move the
	    // cursor from a non-zero offset on one block, through empty blocks,
	    // to a matching non-zero offset on other text blocks.
	
	    if (anchorNode === focusNode && anchorOffset === focusOffset) {
	      needsRecovery = !!anchorNode.firstChild && anchorNode.firstChild.nodeName !== 'BR';
	    }
	  }
	
	  return {
	    selectionState: getUpdatedSelectionState(editorState, anchorPoint.key, anchorPoint.offset, focusPoint.key, focusPoint.offset),
	    needsRecovery: needsRecovery
	  };
	}
	/**
	 * Identify the first leaf descendant for the given node.
	 */
	
	
	function getFirstLeaf(node) {
	  while (node.firstChild && ( // data-blocks has no offset
	  isElement(node.firstChild) && node.firstChild.getAttribute('data-blocks') === 'true' || getSelectionOffsetKeyForNode(node.firstChild))) {
	    node = node.firstChild;
	  }
	
	  return node;
	}
	/**
	 * Identify the last leaf descendant for the given node.
	 */
	
	
	function getLastLeaf(node) {
	  while (node.lastChild && ( // data-blocks has no offset
	  isElement(node.lastChild) && node.lastChild.getAttribute('data-blocks') === 'true' || getSelectionOffsetKeyForNode(node.lastChild))) {
	    node = node.lastChild;
	  }
	
	  return node;
	}
	
	function getPointForNonTextNode(editorRoot, startNode, childOffset) {
	  var node = startNode;
	  var offsetKey = findAncestorOffsetKey(node);
	  !(offsetKey != null || editorRoot && (editorRoot === node || editorRoot.firstChild === node)) ?  false ? invariant(false, 'Unknown node in selection range.') : invariant(false) : void 0; // If the editorRoot is the selection, step downward into the content
	  // wrapper.
	
	  if (editorRoot === node) {
	    node = node.firstChild;
	    !isElement(node) ?  false ? invariant(false, 'Invalid DraftEditorContents node.') : invariant(false) : void 0;
	    var castedNode = node; // assignment only added for flow :/
	    // otherwise it throws in line 200 saying that node can be null or undefined
	
	    node = castedNode;
	    !(node.getAttribute('data-contents') === 'true') ?  false ? invariant(false, 'Invalid DraftEditorContents structure.') : invariant(false) : void 0;
	
	    if (childOffset > 0) {
	      childOffset = node.childNodes.length;
	    }
	  } // If the child offset is zero and we have an offset key, we're done.
	  // If there's no offset key because the entire editor is selected,
	  // find the leftmost ("first") leaf in the tree and use that as the offset
	  // key.
	
	
	  if (childOffset === 0) {
	    var key = null;
	
	    if (offsetKey != null) {
	      key = offsetKey;
	    } else {
	      var firstLeaf = getFirstLeaf(node);
	      key = nullthrows(getSelectionOffsetKeyForNode(firstLeaf));
	    }
	
	    return {
	      key: key,
	      offset: 0
	    };
	  }
	
	  var nodeBeforeCursor = node.childNodes[childOffset - 1];
	  var leafKey = null;
	  var textLength = null;
	
	  if (!getSelectionOffsetKeyForNode(nodeBeforeCursor)) {
	    // Our target node may be a leaf or a text node, in which case we're
	    // already where we want to be and can just use the child's length as
	    // our offset.
	    leafKey = nullthrows(offsetKey);
	    textLength = getTextContentLength(nodeBeforeCursor);
	  } else {
	    // Otherwise, we'll look at the child to the left of the cursor and find
	    // the last leaf node in its subtree.
	    var lastLeaf = getLastLeaf(nodeBeforeCursor);
	    leafKey = nullthrows(getSelectionOffsetKeyForNode(lastLeaf));
	    textLength = getTextContentLength(lastLeaf);
	  }
	
	  return {
	    key: leafKey,
	    offset: textLength
	  };
	}
	/**
	 * Return the length of a node's textContent, regarding single newline
	 * characters as zero-length. This allows us to avoid problems with identifying
	 * the correct selection offset for empty blocks in IE, in which we
	 * render newlines instead of break tags.
	 */
	
	
	function getTextContentLength(node) {
	  var textContent = node.textContent;
	  return textContent === '\n' ? 0 : textContent.length;
	}
	
	module.exports = getDraftEditorSelectionWithNodes;

/***/ },
/* 407 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	var getContentStateFragment = __webpack_require__(193);
	
	function getFragmentFromSelection(editorState) {
	  var selectionState = editorState.getSelection();
	
	  if (selectionState.isCollapsed()) {
	    return null;
	  }
	
	  return getContentStateFragment(editorState.getCurrentContent(), selectionState);
	}
	
	module.exports = getFragmentFromSelection;

/***/ },
/* 408 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 *
	 * This is unstable and not part of the public API and should not be used by
	 * production systems. This file may be update/removed without notice.
	 */
	var ContentBlockNode = __webpack_require__(71);
	
	var getNextDelimiterBlockKey = function getNextDelimiterBlockKey(block, blockMap) {
	  var isExperimentalTreeBlock = block instanceof ContentBlockNode;
	
	  if (!isExperimentalTreeBlock) {
	    return null;
	  }
	
	  var nextSiblingKey = block.getNextSiblingKey();
	
	  if (nextSiblingKey) {
	    return nextSiblingKey;
	  }
	
	  var parent = block.getParentKey();
	
	  if (!parent) {
	    return null;
	  }
	
	  var nextNonDescendantBlock = blockMap.get(parent);
	
	  while (nextNonDescendantBlock && !nextNonDescendantBlock.getNextSiblingKey()) {
	    var parentKey = nextNonDescendantBlock.getParentKey();
	    nextNonDescendantBlock = parentKey ? blockMap.get(parentKey) : null;
	  }
	
	  if (!nextNonDescendantBlock) {
	    return null;
	  }
	
	  return nextNonDescendantBlock.getNextSiblingKey();
	};
	
	module.exports = getNextDelimiterBlockKey;

/***/ },
/* 409 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright 2004-present Facebook. All Rights Reserved.
	 *
	 * 
	 * @typechecks
	 * @format
	 */
	
	/**
	 * Retrieve an object's own values as an array. If you want the values in the
	 * protoype chain, too, use getObjectValuesIncludingPrototype.
	 *
	 * If you are looking for a function that creates an Array instance based
	 * on an "Array-like" object, use createArrayFrom instead.
	 *
	 * @param {object} obj An object.
	 * @return {array}     The object's values.
	 */
	function getOwnObjectValues(obj) {
	  return Object.keys(obj).map(function (key) {
	    return obj[key];
	  });
	}
	
	module.exports = getOwnObjectValues;

/***/ },
/* 410 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	var UserAgent = __webpack_require__(60);
	
	var invariant = __webpack_require__(32);
	
	var isChrome = UserAgent.isBrowser('Chrome'); // In Chrome, the client rects will include the entire bounds of all nodes that
	// begin (have a start tag) within the selection, even if the selection does
	// not overlap the entire node. To resolve this, we split the range at each
	// start tag and join the client rects together.
	// https://code.google.com/p/chromium/issues/detail?id=324437
	
	/* eslint-disable consistent-return */
	
	function getRangeClientRectsChrome(range) {
	  var tempRange = range.cloneRange();
	  var clientRects = [];
	
	  for (var ancestor = range.endContainer; ancestor != null; ancestor = ancestor.parentNode) {
	    // If we've climbed up to the common ancestor, we can now use the
	    // original start point and stop climbing the tree.
	    var atCommonAncestor = ancestor === range.commonAncestorContainer;
	
	    if (atCommonAncestor) {
	      tempRange.setStart(range.startContainer, range.startOffset);
	    } else {
	      tempRange.setStart(tempRange.endContainer, 0);
	    }
	
	    var rects = Array.from(tempRange.getClientRects());
	    clientRects.push(rects);
	
	    if (atCommonAncestor) {
	      var _ref;
	
	      clientRects.reverse();
	      return (_ref = []).concat.apply(_ref, clientRects);
	    }
	
	    tempRange.setEndBefore(ancestor);
	  }
	
	   true ?  false ? invariant(false, 'Found an unexpected detached subtree when getting range client rects.') : invariant(false) : void 0;
	}
	/* eslint-enable consistent-return */
	
	/**
	 * Like range.getClientRects() but normalizes for browser bugs.
	 */
	
	
	var getRangeClientRects = isChrome ? getRangeClientRectsChrome : function (range) {
	  return Array.from(range.getClientRects());
	};
	module.exports = getRangeClientRects;

/***/ },
/* 411 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	var UserAgent = __webpack_require__(60);
	
	var invariant = __webpack_require__(32);
	
	var isOldIE = UserAgent.isBrowser('IE <= 9'); // Provides a dom node that will not execute scripts
	// https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation.createHTMLDocument
	// https://developer.mozilla.org/en-US/Add-ons/Code_snippets/HTML_to_DOM
	
	function getSafeBodyFromHTML(html) {
	  var doc;
	  var root = null; // Provides a safe context
	
	  if (!isOldIE && document.implementation && document.implementation.createHTMLDocument) {
	    doc = document.implementation.createHTMLDocument('foo');
	    !doc.documentElement ?  false ? invariant(false, 'Missing doc.documentElement') : invariant(false) : void 0;
	    doc.documentElement.innerHTML = html;
	    root = doc.getElementsByTagName('body')[0];
	  }
	
	  return root;
	}
	
	module.exports = getSafeBodyFromHTML;

/***/ },
/* 412 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	/**
	 * Get offset key from a node or it's child nodes. Return the first offset key
	 * found on the DOM tree of given node.
	 */
	
	var isElement = __webpack_require__(105);
	
	function getSelectionOffsetKeyForNode(node) {
	  if (isElement(node)) {
	    var castedNode = node;
	    var offsetKey = castedNode.getAttribute('data-offset-key');
	
	    if (offsetKey) {
	      return offsetKey;
	    }
	
	    for (var ii = 0; ii < castedNode.childNodes.length; ii++) {
	      var childOffsetKey = getSelectionOffsetKeyForNode(castedNode.childNodes[ii]);
	
	      if (childOffsetKey) {
	        return childOffsetKey;
	      }
	    }
	  }
	
	  return null;
	}
	
	module.exports = getSelectionOffsetKeyForNode;

/***/ },
/* 413 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	var invariant = __webpack_require__(32);
	
	var TEXT_CLIPPING_REGEX = /\.textClipping$/;
	var TEXT_TYPES = {
	  'text/plain': true,
	  'text/html': true,
	  'text/rtf': true
	}; // Somewhat arbitrary upper bound on text size. Let's not lock up the browser.
	
	var TEXT_SIZE_UPPER_BOUND = 5000;
	/**
	 * Extract the text content from a file list.
	 */
	
	function getTextContentFromFiles(files, callback) {
	  var readCount = 0;
	  var results = [];
	  files.forEach(function (
	  /*blob*/
	  file) {
	    readFile(file, function (
	    /*string*/
	    text) {
	      readCount++;
	      text && results.push(text.slice(0, TEXT_SIZE_UPPER_BOUND));
	
	      if (readCount == files.length) {
	        callback(results.join('\r'));
	      }
	    });
	  });
	}
	/**
	 * todo isaac: Do work to turn html/rtf into a content fragment.
	 */
	
	
	function readFile(file, callback) {
	  if (!global.FileReader || file.type && !(file.type in TEXT_TYPES)) {
	    callback('');
	    return;
	  }
	
	  if (file.type === '') {
	    var _contents = ''; // Special-case text clippings, which have an empty type but include
	    // `.textClipping` in the file name. `readAsText` results in an empty
	    // string for text clippings, so we force the file name to serve
	    // as the text value for the file.
	
	    if (TEXT_CLIPPING_REGEX.test(file.name)) {
	      _contents = file.name.replace(TEXT_CLIPPING_REGEX, '');
	    }
	
	    callback(_contents);
	    return;
	  }
	
	  var reader = new FileReader();
	
	  reader.onload = function () {
	    var result = reader.result;
	    !(typeof result === 'string') ?  false ? invariant(false, 'We should be calling "FileReader.readAsText" which returns a string') : invariant(false) : void 0;
	    callback(result);
	  };
	
	  reader.onerror = function () {
	    callback('');
	  };
	
	  reader.readAsText(file);
	}
	
	module.exports = getTextContentFromFiles;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 414 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	var DraftOffsetKey = __webpack_require__(91);
	
	var nullthrows = __webpack_require__(61);
	
	function getUpdatedSelectionState(editorState, anchorKey, anchorOffset, focusKey, focusOffset) {
	  var selection = nullthrows(editorState.getSelection());
	
	  if (!anchorKey || !focusKey) {
	    // If we cannot make sense of the updated selection state, stick to the current one.
	    if (false) {
	      /* eslint-disable-next-line */
	      console.warn('Invalid selection state.', arguments, editorState.toJS());
	    }
	
	    return selection;
	  }
	
	  var anchorPath = DraftOffsetKey.decode(anchorKey);
	  var anchorBlockKey = anchorPath.blockKey;
	  var anchorLeafBlockTree = editorState.getBlockTree(anchorBlockKey);
	  var anchorLeaf = anchorLeafBlockTree && anchorLeafBlockTree.getIn([anchorPath.decoratorKey, 'leaves', anchorPath.leafKey]);
	  var focusPath = DraftOffsetKey.decode(focusKey);
	  var focusBlockKey = focusPath.blockKey;
	  var focusLeafBlockTree = editorState.getBlockTree(focusBlockKey);
	  var focusLeaf = focusLeafBlockTree && focusLeafBlockTree.getIn([focusPath.decoratorKey, 'leaves', focusPath.leafKey]);
	
	  if (!anchorLeaf || !focusLeaf) {
	    // If we cannot make sense of the updated selection state, stick to the current one.
	    if (false) {
	      /* eslint-disable-next-line */
	      console.warn('Invalid selection state.', arguments, editorState.toJS());
	    }
	
	    return selection;
	  }
	
	  var anchorLeafStart = anchorLeaf.get('start');
	  var focusLeafStart = focusLeaf.get('start');
	  var anchorBlockOffset = anchorLeaf ? anchorLeafStart + anchorOffset : null;
	  var focusBlockOffset = focusLeaf ? focusLeafStart + focusOffset : null;
	  var areEqual = selection.getAnchorKey() === anchorBlockKey && selection.getAnchorOffset() === anchorBlockOffset && selection.getFocusKey() === focusBlockKey && selection.getFocusOffset() === focusBlockOffset;
	
	  if (areEqual) {
	    return selection;
	  }
	
	  var isBackward = false;
	
	  if (anchorBlockKey === focusBlockKey) {
	    var anchorLeafEnd = anchorLeaf.get('end');
	    var focusLeafEnd = focusLeaf.get('end');
	
	    if (focusLeafStart === anchorLeafStart && focusLeafEnd === anchorLeafEnd) {
	      isBackward = focusOffset < anchorOffset;
	    } else {
	      isBackward = focusLeafStart < anchorLeafStart;
	    }
	  } else {
	    var startKey = editorState.getCurrentContent().getBlockMap().keySeq().skipUntil(function (v) {
	      return v === anchorBlockKey || v === focusBlockKey;
	    }).first();
	    isBackward = startKey === focusBlockKey;
	  }
	
	  return selection.merge({
	    anchorKey: anchorBlockKey,
	    anchorOffset: anchorBlockOffset,
	    focusKey: focusBlockKey,
	    focusOffset: focusBlockOffset,
	    isBackward: isBackward
	  });
	}
	
	module.exports = getUpdatedSelectionState;

/***/ },
/* 415 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	function getWindowForNode(node) {
	  if (!node || !node.ownerDocument || !node.ownerDocument.defaultView) {
	    return window;
	  }
	
	  return node.ownerDocument.defaultView;
	}
	
	module.exports = getWindowForNode;

/***/ },
/* 416 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	/**
	 * Maintain persistence for target list when appending and prepending.
	 */
	function insertIntoList(targetListArg, toInsert, offset) {
	  var targetList = targetListArg;
	
	  if (offset === targetList.count()) {
	    toInsert.forEach(function (c) {
	      targetList = targetList.push(c);
	    });
	  } else if (offset === 0) {
	    toInsert.reverse().forEach(function (c) {
	      targetList = targetList.unshift(c);
	    });
	  } else {
	    var head = targetList.slice(0, offset);
	    var tail = targetList.slice(offset);
	    targetList = head.concat(toInsert, tail).toList();
	  }
	
	  return targetList;
	}
	
	module.exports = insertIntoList;

/***/ },
/* 417 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	var isElement = __webpack_require__(105);
	
	function isHTMLBRElement(node) {
	  if (!node || !node.ownerDocument) {
	    return false;
	  }
	
	  return isElement(node) && node.nodeName === 'BR';
	}
	
	module.exports = isHTMLBRElement;

/***/ },
/* 418 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	var EditorState = __webpack_require__(36);
	
	var UnicodeUtils = __webpack_require__(107);
	
	var moveSelectionBackward = __webpack_require__(266);
	
	var removeTextWithStrategy = __webpack_require__(154);
	/**
	 * Remove the selected range. If the cursor is collapsed, remove the preceding
	 * character. This operation is Unicode-aware, so removing a single character
	 * will remove a surrogate pair properly as well.
	 */
	
	
	function keyCommandPlainBackspace(editorState) {
	  var afterRemoval = removeTextWithStrategy(editorState, function (strategyState) {
	    var selection = strategyState.getSelection();
	    var content = strategyState.getCurrentContent();
	    var key = selection.getAnchorKey();
	    var offset = selection.getAnchorOffset();
	    var charBehind = content.getBlockForKey(key).getText()[offset - 1];
	    return moveSelectionBackward(strategyState, charBehind ? UnicodeUtils.getUTF16Length(charBehind, 0) : 1);
	  }, 'backward');
	
	  if (afterRemoval === editorState.getCurrentContent()) {
	    return editorState;
	  }
	
	  var selection = editorState.getSelection();
	  return EditorState.push(editorState, afterRemoval.set('selectionBefore', selection), selection.isCollapsed() ? 'backspace-character' : 'remove-range');
	}
	
	module.exports = keyCommandPlainBackspace;

/***/ },
/* 419 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	var Immutable = __webpack_require__(27);
	
	var Map = Immutable.Map;
	
	function modifyBlockForContentState(contentState, selectionState, operation) {
	  var startKey = selectionState.getStartKey();
	  var endKey = selectionState.getEndKey();
	  var blockMap = contentState.getBlockMap();
	  var newBlocks = blockMap.toSeq().skipUntil(function (_, k) {
	    return k === startKey;
	  }).takeUntil(function (_, k) {
	    return k === endKey;
	  }).concat(Map([[endKey, blockMap.get(endKey)]])).map(operation);
	  return contentState.merge({
	    blockMap: blockMap.merge(newBlocks),
	    selectionBefore: selectionState,
	    selectionAfter: selectionState
	  });
	}
	
	module.exports = modifyBlockForContentState;

/***/ },
/* 420 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	var warning = __webpack_require__(271);
	/**
	 * Given a collapsed selection, move the focus `maxDistance` forward within
	 * the selected block. If the selection will go beyond the end of the block,
	 * move focus to the start of the next block, but no further.
	 *
	 * This function is not Unicode-aware, so surrogate pairs will be treated
	 * as having length 2.
	 */
	
	
	function moveSelectionForward(editorState, maxDistance) {
	  var selection = editorState.getSelection(); // Should eventually make this an invariant
	
	   false ? warning(selection.isCollapsed(), 'moveSelectionForward should only be called with a collapsed SelectionState') : void 0;
	  var key = selection.getStartKey();
	  var offset = selection.getStartOffset();
	  var content = editorState.getCurrentContent();
	  var focusKey = key;
	  var focusOffset;
	  var block = content.getBlockForKey(key);
	
	  if (maxDistance > block.getText().length - offset) {
	    focusKey = content.getKeyAfter(key);
	    focusOffset = 0;
	  } else {
	    focusOffset = offset + maxDistance;
	  }
	
	  return selection.merge({
	    focusKey: focusKey,
	    focusOffset: focusOffset
	  });
	}
	
	module.exports = moveSelectionForward;

/***/ },
/* 421 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	var ContentBlockNode = __webpack_require__(71);
	
	var generateRandomKey = __webpack_require__(85);
	
	var Immutable = __webpack_require__(27);
	
	var OrderedMap = Immutable.OrderedMap;
	
	var randomizeContentBlockNodeKeys = function randomizeContentBlockNodeKeys(blockMap) {
	  var newKeysRef = {}; // we keep track of root blocks in order to update subsequent sibling links
	
	  var lastRootBlock;
	  return OrderedMap(blockMap.withMutations(function (blockMapState) {
	    blockMapState.forEach(function (block, index) {
	      var oldKey = block.getKey();
	      var nextKey = block.getNextSiblingKey();
	      var prevKey = block.getPrevSiblingKey();
	      var childrenKeys = block.getChildKeys();
	      var parentKey = block.getParentKey(); // new key that we will use to build linking
	
	      var key = generateRandomKey(); // we will add it here to re-use it later
	
	      newKeysRef[oldKey] = key;
	
	      if (nextKey) {
	        var nextBlock = blockMapState.get(nextKey);
	
	        if (nextBlock) {
	          blockMapState.setIn([nextKey, 'prevSibling'], key);
	        } else {
	          // this can happen when generating random keys for fragments
	          blockMapState.setIn([oldKey, 'nextSibling'], null);
	        }
	      }
	
	      if (prevKey) {
	        var prevBlock = blockMapState.get(prevKey);
	
	        if (prevBlock) {
	          blockMapState.setIn([prevKey, 'nextSibling'], key);
	        } else {
	          // this can happen when generating random keys for fragments
	          blockMapState.setIn([oldKey, 'prevSibling'], null);
	        }
	      }
	
	      if (parentKey && blockMapState.get(parentKey)) {
	        var parentBlock = blockMapState.get(parentKey);
	        var parentChildrenList = parentBlock.getChildKeys();
	        blockMapState.setIn([parentKey, 'children'], parentChildrenList.set(parentChildrenList.indexOf(block.getKey()), key));
	      } else {
	        // blocks will then be treated as root block nodes
	        blockMapState.setIn([oldKey, 'parent'], null);
	
	        if (lastRootBlock) {
	          blockMapState.setIn([lastRootBlock.getKey(), 'nextSibling'], key);
	          blockMapState.setIn([oldKey, 'prevSibling'], newKeysRef[lastRootBlock.getKey()]);
	        }
	
	        lastRootBlock = blockMapState.get(oldKey);
	      }
	
	      childrenKeys.forEach(function (childKey) {
	        var childBlock = blockMapState.get(childKey);
	
	        if (childBlock) {
	          blockMapState.setIn([childKey, 'parent'], key);
	        } else {
	          blockMapState.setIn([oldKey, 'children'], block.getChildKeys().filter(function (child) {
	            return child !== childKey;
	          }));
	        }
	      });
	    });
	  }).toArray().map(function (block) {
	    return [newKeysRef[block.getKey()], block.set('key', newKeysRef[block.getKey()])];
	  }));
	};
	
	var randomizeContentBlockKeys = function randomizeContentBlockKeys(blockMap) {
	  return OrderedMap(blockMap.toArray().map(function (block) {
	    var key = generateRandomKey();
	    return [key, block.set('key', key)];
	  }));
	};
	
	var randomizeBlockMapKeys = function randomizeBlockMapKeys(blockMap) {
	  var isTreeBasedBlockMap = blockMap.first() instanceof ContentBlockNode;
	
	  if (!isTreeBasedBlockMap) {
	    return randomizeContentBlockKeys(blockMap);
	  }
	
	  return randomizeContentBlockNodeKeys(blockMap);
	};
	
	module.exports = randomizeBlockMapKeys;

/***/ },
/* 422 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	var CharacterMetadata = __webpack_require__(70);
	
	var findRangesImmutable = __webpack_require__(152);
	
	var invariant = __webpack_require__(32);
	
	function removeEntitiesAtEdges(contentState, selectionState) {
	  var blockMap = contentState.getBlockMap();
	  var entityMap = contentState.getEntityMap();
	  var updatedBlocks = {};
	  var startKey = selectionState.getStartKey();
	  var startOffset = selectionState.getStartOffset();
	  var startBlock = blockMap.get(startKey);
	  var updatedStart = removeForBlock(entityMap, startBlock, startOffset);
	
	  if (updatedStart !== startBlock) {
	    updatedBlocks[startKey] = updatedStart;
	  }
	
	  var endKey = selectionState.getEndKey();
	  var endOffset = selectionState.getEndOffset();
	  var endBlock = blockMap.get(endKey);
	
	  if (startKey === endKey) {
	    endBlock = updatedStart;
	  }
	
	  var updatedEnd = removeForBlock(entityMap, endBlock, endOffset);
	
	  if (updatedEnd !== endBlock) {
	    updatedBlocks[endKey] = updatedEnd;
	  }
	
	  if (!Object.keys(updatedBlocks).length) {
	    return contentState.set('selectionAfter', selectionState);
	  }
	
	  return contentState.merge({
	    blockMap: blockMap.merge(updatedBlocks),
	    selectionAfter: selectionState
	  });
	}
	/**
	 * Given a list of characters and an offset that is in the middle of an entity,
	 * returns the start and end of the entity that is overlapping the offset.
	 * Note: This method requires that the offset be in an entity range.
	 */
	
	
	function getRemovalRange(characters, entityKey, offset) {
	  var removalRange; // Iterates through a list looking for ranges of matching items
	  // based on the 'isEqual' callback.
	  // Then instead of returning the result, call the 'found' callback
	  // with each range.
	  // Then filters those ranges based on the 'filter' callback
	  //
	  // Here we use it to find ranges of characters with the same entity key.
	
	  findRangesImmutable(characters, // the list to iterate through
	  function (a, b) {
	    return a.getEntity() === b.getEntity();
	  }, // 'isEqual' callback
	  function (element) {
	    return element.getEntity() === entityKey;
	  }, // 'filter' callback
	  function (start, end) {
	    // 'found' callback
	    if (start <= offset && end >= offset) {
	      // this entity overlaps the offset index
	      removalRange = {
	        start: start,
	        end: end
	      };
	    }
	  });
	  !(typeof removalRange === 'object') ?  false ? invariant(false, 'Removal range must exist within character list.') : invariant(false) : void 0;
	  return removalRange;
	}
	
	function removeForBlock(entityMap, block, offset) {
	  var chars = block.getCharacterList();
	  var charBefore = offset > 0 ? chars.get(offset - 1) : undefined;
	  var charAfter = offset < chars.count() ? chars.get(offset) : undefined;
	  var entityBeforeCursor = charBefore ? charBefore.getEntity() : undefined;
	  var entityAfterCursor = charAfter ? charAfter.getEntity() : undefined;
	
	  if (entityAfterCursor && entityAfterCursor === entityBeforeCursor) {
	    var entity = entityMap.__get(entityAfterCursor);
	
	    if (entity.getMutability() !== 'MUTABLE') {
	      var _getRemovalRange = getRemovalRange(chars, entityAfterCursor, offset),
	          start = _getRemovalRange.start,
	          end = _getRemovalRange.end;
	
	      var current;
	
	      while (start < end) {
	        current = chars.get(start);
	        chars = chars.set(start, CharacterMetadata.applyEntity(current, null));
	        start++;
	      }
	
	      return block.set('characterList', chars);
	    }
	  }
	
	  return block;
	}
	
	module.exports = removeEntitiesAtEdges;

/***/ },
/* 423 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	var REGEX_BLOCK_DELIMITER = new RegExp('\r', 'g');
	
	function sanitizeDraftText(input) {
	  return input.replace(REGEX_BLOCK_DELIMITER, '');
	}
	
	module.exports = sanitizeDraftText;

/***/ },
/* 424 */
/***/ function(module, exports) {

	/**
	 * Helper function for iterating over a collection
	 *
	 * @param collection
	 * @param fn
	 */
	function each(collection, fn) {
	    var i      = 0,
	        length = collection.length,
	        cont;
	
	    for(i; i < length; i++) {
	        cont = fn(collection[i], i);
	        if(cont === false) {
	            break; //allow early exit
	        }
	    }
	}
	
	/**
	 * Helper function for determining whether target object is an array
	 *
	 * @param target the object under test
	 * @return {Boolean} true if array, false otherwise
	 */
	function isArray(target) {
	    return Object.prototype.toString.apply(target) === '[object Array]';
	}
	
	/**
	 * Helper function for determining whether target object is a function
	 *
	 * @param target the object under test
	 * @return {Boolean} true if function, false otherwise
	 */
	function isFunction(target) {
	    return typeof target === 'function';
	}
	
	module.exports = {
	    isFunction : isFunction,
	    isArray : isArray,
	    each : each
	};


/***/ },
/* 425 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('.')} */
	module.exports = Error;


/***/ },
/* 426 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./syntax')} */
	module.exports = SyntaxError;


/***/ },
/* 427 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('.')} */
	module.exports = Object;


/***/ },
/* 428 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	var PhotosMimeType = __webpack_require__(1272);
	
	var createArrayFromMixed = __webpack_require__(1279);
	
	var emptyFunction = __webpack_require__(429);
	
	var CR_LF_REGEX = new RegExp("\r\n", 'g');
	var LF_ONLY = "\n";
	var RICH_TEXT_TYPES = {
	  'text/rtf': 1,
	  'text/html': 1
	};
	/**
	 * If DataTransferItem is a file then return the Blob of data.
	 *
	 * @param {object} item
	 * @return {?blob}
	 */
	
	function getFileFromDataTransfer(item) {
	  if (item.kind == 'file') {
	    return item.getAsFile();
	  }
	}
	
	var DataTransfer =
	/*#__PURE__*/
	function () {
	  /**
	   * @param {object} data
	   */
	  function DataTransfer(data) {
	    this.data = data; // Types could be DOMStringList or array
	
	    this.types = data.types ? createArrayFromMixed(data.types) : [];
	  }
	  /**
	   * Is this likely to be a rich text data transfer?
	   *
	   * @return {boolean}
	   */
	
	
	  var _proto = DataTransfer.prototype;
	
	  _proto.isRichText = function isRichText() {
	    // If HTML is available, treat this data as rich text. This way, we avoid
	    // using a pasted image if it is packaged with HTML -- this may occur with
	    // pastes from MS Word, for example.  However this is only rich text if
	    // there's accompanying text.
	    if (this.getHTML() && this.getText()) {
	      return true;
	    } // When an image is copied from a preview window, you end up with two
	    // DataTransferItems one of which is a file's metadata as text.  Skip those.
	
	
	    if (this.isImage()) {
	      return false;
	    }
	
	    return this.types.some(function (type) {
	      return RICH_TEXT_TYPES[type];
	    });
	  };
	  /**
	   * Get raw text.
	   *
	   * @return {?string}
	   */
	
	
	  _proto.getText = function getText() {
	    var text;
	
	    if (this.data.getData) {
	      if (!this.types.length) {
	        text = this.data.getData('Text');
	      } else if (this.types.indexOf('text/plain') != -1) {
	        text = this.data.getData('text/plain');
	      }
	    }
	
	    return text ? text.replace(CR_LF_REGEX, LF_ONLY) : null;
	  };
	  /**
	   * Get HTML paste data
	   *
	   * @return {?string}
	   */
	
	
	  _proto.getHTML = function getHTML() {
	    if (this.data.getData) {
	      if (!this.types.length) {
	        return this.data.getData('Text');
	      } else if (this.types.indexOf('text/html') != -1) {
	        return this.data.getData('text/html');
	      }
	    }
	  };
	  /**
	   * Is this a link data transfer?
	   *
	   * @return {boolean}
	   */
	
	
	  _proto.isLink = function isLink() {
	    return this.types.some(function (type) {
	      return type.indexOf('Url') != -1 || type.indexOf('text/uri-list') != -1 || type.indexOf('text/x-moz-url');
	    });
	  };
	  /**
	   * Get a link url.
	   *
	   * @return {?string}
	   */
	
	
	  _proto.getLink = function getLink() {
	    if (this.data.getData) {
	      if (this.types.indexOf('text/x-moz-url') != -1) {
	        var url = this.data.getData('text/x-moz-url').split('\n');
	        return url[0];
	      }
	
	      return this.types.indexOf('text/uri-list') != -1 ? this.data.getData('text/uri-list') : this.data.getData('url');
	    }
	
	    return null;
	  };
	  /**
	   * Is this an image data transfer?
	   *
	   * @return {boolean}
	   */
	
	
	  _proto.isImage = function isImage() {
	    var isImage = this.types.some(function (type) {
	      // Firefox will have a type of application/x-moz-file for images during
	      // dragging
	      return type.indexOf('application/x-moz-file') != -1;
	    });
	
	    if (isImage) {
	      return true;
	    }
	
	    var items = this.getFiles();
	
	    for (var i = 0; i < items.length; i++) {
	      var type = items[i].type;
	
	      if (!PhotosMimeType.isImage(type)) {
	        return false;
	      }
	    }
	
	    return true;
	  };
	
	  _proto.getCount = function getCount() {
	    if (this.data.hasOwnProperty('items')) {
	      return this.data.items.length;
	    } else if (this.data.hasOwnProperty('mozItemCount')) {
	      return this.data.mozItemCount;
	    } else if (this.data.files) {
	      return this.data.files.length;
	    }
	
	    return null;
	  };
	  /**
	   * Get files.
	   *
	   * @return {array}
	   */
	
	
	  _proto.getFiles = function getFiles() {
	    if (this.data.items) {
	      // createArrayFromMixed doesn't properly handle DataTransferItemLists.
	      return Array.prototype.slice.call(this.data.items).map(getFileFromDataTransfer).filter(emptyFunction.thatReturnsArgument);
	    } else if (this.data.files) {
	      return Array.prototype.slice.call(this.data.files);
	    } else {
	      return [];
	    }
	  };
	  /**
	   * Are there any files to fetch?
	   *
	   * @return {boolean}
	   */
	
	
	  _proto.hasFiles = function hasFiles() {
	    return this.getFiles().length > 0;
	  };
	
	  return DataTransfer;
	}();
	
	module.exports = DataTransfer;

/***/ },
/* 429 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	
	
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },
/* 430 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 *
	 * @param {?DOMDocument} doc Defaults to current document.
	 * @return {?DOMElement}
	 */
	function getActiveElement(doc)
	/*?DOMElement*/
	{
	  doc = doc || (typeof document !== 'undefined' ? document : undefined);
	
	  if (typeof doc === 'undefined') {
	    return null;
	  }
	
	  try {
	    return doc.activeElement || doc.body;
	  } catch (e) {
	    return doc.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ },
/* 431 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	var getElementRect = __webpack_require__(1281);
	/**
	 * Gets an element's position in pixels relative to the viewport. The returned
	 * object represents the position of the element's top left corner.
	 *
	 * @param {DOMElement} element
	 * @return {object}
	 */
	
	
	function getElementPosition(element) {
	  var rect = getElementRect(element);
	  return {
	    x: rect.left,
	    y: rect.top,
	    width: rect.right - rect.left,
	    height: rect.bottom - rect.top
	  };
	}
	
	module.exports = getElementPosition;

/***/ },
/* 432 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @typechecks
	 */
	function getViewportWidth() {
	  var width;
	
	  if (document.documentElement) {
	    width = document.documentElement.clientWidth;
	  }
	
	  if (!width && document.body) {
	    width = document.body.clientWidth;
	  }
	
	  return width || 0;
	}
	
	function getViewportHeight() {
	  var height;
	
	  if (document.documentElement) {
	    height = document.documentElement.clientHeight;
	  }
	
	  if (!height && document.body) {
	    height = document.body.clientHeight;
	  }
	
	  return height || 0;
	}
	/**
	 * Gets the viewport dimensions including any scrollbars.
	 */
	
	
	function getViewportDimensions() {
	  return {
	    width: window.innerWidth || getViewportWidth(),
	    height: window.innerHeight || getViewportHeight()
	  };
	}
	/**
	 * Gets the viewport dimensions excluding any scrollbars.
	 */
	
	
	getViewportDimensions.withoutScrollbars = function () {
	  return {
	    width: getViewportWidth(),
	    height: getViewportHeight()
	  };
	};
	
	module.exports = getViewportDimensions;

/***/ },
/* 433 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var $Object = __webpack_require__(427);
	
	/** @type {import('./Object.getPrototypeOf')} */
	module.exports = $Object.getPrototypeOf || null;


/***/ },
/* 434 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./Reflect.getPrototypeOf')} */
	module.exports = (typeof Reflect !== 'undefined' && Reflect.getPrototypeOf) || null;


/***/ },
/* 435 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var reflectGetProto = __webpack_require__(434);
	var originalGetProto = __webpack_require__(433);
	
	var getDunderProto = __webpack_require__(1254);
	
	/** @type {import('.')} */
	module.exports = reflectGetProto
		? function getProto(O) {
			// @ts-expect-error TS can't narrow inside a closure, for some reason
			return reflectGetProto(O);
		}
		: originalGetProto
			? function getProto(O) {
				if (!O || (typeof O !== 'object' && typeof O !== 'function')) {
					throw new TypeError('getProto: not an object');
				}
				// @ts-expect-error TS can't narrow inside a closure, for some reason
				return originalGetProto(O);
			}
			: getDunderProto
				? function getProto(O) {
					// @ts-expect-error TS can't narrow inside a closure, for some reason
					return getDunderProto(O);
				}
				: null;


/***/ },
/* 436 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./shams')} */
	/* eslint complexity: [2, 18], max-statements: [2, 33] */
	module.exports = function hasSymbols() {
		if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
		if (typeof Symbol.iterator === 'symbol') { return true; }
	
		/** @type {{ [k in symbol]?: unknown }} */
		var obj = {};
		var sym = Symbol('test');
		var symObj = Object(sym);
		if (typeof sym === 'string') { return false; }
	
		if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
		if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }
	
		// temp disabled per https://github.com/ljharb/object.assign/issues/17
		// if (sym instanceof Symbol) { return false; }
		// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
		// if (!(symObj instanceof Symbol)) { return false; }
	
		// if (typeof Symbol.prototype.toString !== 'function') { return false; }
		// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
	
		var symVal = 42;
		obj[sym] = symVal;
		for (var _ in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
		if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }
	
		if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }
	
		var syms = Object.getOwnPropertySymbols(obj);
		if (syms.length !== 1 || syms[0] !== sym) { return false; }
	
		if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }
	
		if (typeof Object.getOwnPropertyDescriptor === 'function') {
			// eslint-disable-next-line no-extra-parens
			var descriptor = /** @type {PropertyDescriptor} */ (Object.getOwnPropertyDescriptor(obj, sym));
			if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
		}
	
		return true;
	};


/***/ },
/* 437 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var call = Function.prototype.call;
	var $hasOwn = Object.prototype.hasOwnProperty;
	var bind = __webpack_require__(156);
	
	/** @type {import('.')} */
	module.exports = bind.call(call, $hasOwn);


/***/ },
/* 438 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(1302);
	} else {
	  module.exports = require('./cjs/history.js');
	}


/***/ },
/* 439 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var isBrowser = exports.isBrowser = (typeof window === "undefined" ? "undefined" : _typeof(window)) === "object" && (typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && document.nodeType === 9;
	
	exports.default = isBrowser;

/***/ },
/* 440 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var utils = __webpack_require__(42);
	var support = __webpack_require__(98);
	// private property
	var _keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
	
	
	// public method for encoding
	exports.encode = function(input) {
	    var output = [];
	    var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
	    var i = 0, len = input.length, remainingBytes = len;
	
	    var isArray = utils.getTypeOf(input) !== "string";
	    while (i < input.length) {
	        remainingBytes = len - i;
	
	        if (!isArray) {
	            chr1 = input.charCodeAt(i++);
	            chr2 = i < len ? input.charCodeAt(i++) : 0;
	            chr3 = i < len ? input.charCodeAt(i++) : 0;
	        } else {
	            chr1 = input[i++];
	            chr2 = i < len ? input[i++] : 0;
	            chr3 = i < len ? input[i++] : 0;
	        }
	
	        enc1 = chr1 >> 2;
	        enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
	        enc3 = remainingBytes > 1 ? (((chr2 & 15) << 2) | (chr3 >> 6)) : 64;
	        enc4 = remainingBytes > 2 ? (chr3 & 63) : 64;
	
	        output.push(_keyStr.charAt(enc1) + _keyStr.charAt(enc2) + _keyStr.charAt(enc3) + _keyStr.charAt(enc4));
	
	    }
	
	    return output.join("");
	};
	
	// public method for decoding
	exports.decode = function(input) {
	    var chr1, chr2, chr3;
	    var enc1, enc2, enc3, enc4;
	    var i = 0, resultIndex = 0;
	
	    var dataUrlPrefix = "data:";
	
	    if (input.substr(0, dataUrlPrefix.length) === dataUrlPrefix) {
	        // This is a common error: people give a data url
	        // (data:image/png;base64,iVBOR...) with a {base64: true} and
	        // wonders why things don't work.
	        // We can detect that the string input looks like a data url but we
	        // *can't* be sure it is one: removing everything up to the comma would
	        // be too dangerous.
	        throw new Error("Invalid base64 input, it looks like a data url.");
	    }
	
	    input = input.replace(/[^A-Za-z0-9+/=]/g, "");
	
	    var totalLength = input.length * 3 / 4;
	    if(input.charAt(input.length - 1) === _keyStr.charAt(64)) {
	        totalLength--;
	    }
	    if(input.charAt(input.length - 2) === _keyStr.charAt(64)) {
	        totalLength--;
	    }
	    if (totalLength % 1 !== 0) {
	        // totalLength is not an integer, the length does not match a valid
	        // base64 content. That can happen if:
	        // - the input is not a base64 content
	        // - the input is *almost* a base64 content, with a extra chars at the
	        //   beginning or at the end
	        // - the input uses a base64 variant (base64url for example)
	        throw new Error("Invalid base64 input, bad content length.");
	    }
	    var output;
	    if (support.uint8array) {
	        output = new Uint8Array(totalLength|0);
	    } else {
	        output = new Array(totalLength|0);
	    }
	
	    while (i < input.length) {
	
	        enc1 = _keyStr.indexOf(input.charAt(i++));
	        enc2 = _keyStr.indexOf(input.charAt(i++));
	        enc3 = _keyStr.indexOf(input.charAt(i++));
	        enc4 = _keyStr.indexOf(input.charAt(i++));
	
	        chr1 = (enc1 << 2) | (enc2 >> 4);
	        chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
	        chr3 = ((enc3 & 3) << 6) | enc4;
	
	        output[resultIndex++] = chr1;
	
	        if (enc3 !== 64) {
	            output[resultIndex++] = chr2;
	        }
	        if (enc4 !== 64) {
	            output[resultIndex++] = chr3;
	        }
	
	    }
	
	    return output;
	};


/***/ },
/* 441 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var GenericWorker = __webpack_require__(72);
	
	exports.STORE = {
	    magic: "\x00\x00",
	    compressWorker : function () {
	        return new GenericWorker("STORE compression");
	    },
	    uncompressWorker : function () {
	        return new GenericWorker("STORE decompression");
	    }
	};
	exports.DEFLATE = __webpack_require__(1323);


/***/ },
/* 442 */
/***/ function(module, exports) {

	"use strict";
	exports.base64 = false;
	exports.binary = false;
	exports.dir = false;
	exports.createFolders = true;
	exports.date = null;
	exports.compression = null;
	exports.compressionOptions = null;
	exports.comment = null;
	exports.unixPermissions = null;
	exports.dosPermissions = null;


/***/ },
/* 443 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * This file is used by module bundlers (browserify/webpack/etc) when
	 * including a stream implementation. We use "readable-stream" to get a
	 * consistent behavior between nodejs versions but bundlers often have a shim
	 * for "stream". Using this shim greatly improve the compatibility and greatly
	 * reduce the final size of the bundle (only one stream implementation, not
	 * two).
	 */
	module.exports = __webpack_require__(1621);


/***/ },
/* 444 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var DataReader = __webpack_require__(445);
	var utils = __webpack_require__(42);
	
	function ArrayReader(data) {
	    DataReader.call(this, data);
	    for(var i = 0; i < this.data.length; i++) {
	        data[i] = data[i] & 0xFF;
	    }
	}
	utils.inherits(ArrayReader, DataReader);
	/**
	 * @see DataReader.byteAt
	 */
	ArrayReader.prototype.byteAt = function(i) {
	    return this.data[this.zero + i];
	};
	/**
	 * @see DataReader.lastIndexOfSignature
	 */
	ArrayReader.prototype.lastIndexOfSignature = function(sig) {
	    var sig0 = sig.charCodeAt(0),
	        sig1 = sig.charCodeAt(1),
	        sig2 = sig.charCodeAt(2),
	        sig3 = sig.charCodeAt(3);
	    for (var i = this.length - 4; i >= 0; --i) {
	        if (this.data[i] === sig0 && this.data[i + 1] === sig1 && this.data[i + 2] === sig2 && this.data[i + 3] === sig3) {
	            return i - this.zero;
	        }
	    }
	
	    return -1;
	};
	/**
	 * @see DataReader.readAndCheckSignature
	 */
	ArrayReader.prototype.readAndCheckSignature = function (sig) {
	    var sig0 = sig.charCodeAt(0),
	        sig1 = sig.charCodeAt(1),
	        sig2 = sig.charCodeAt(2),
	        sig3 = sig.charCodeAt(3),
	        data = this.readData(4);
	    return sig0 === data[0] && sig1 === data[1] && sig2 === data[2] && sig3 === data[3];
	};
	/**
	 * @see DataReader.readData
	 */
	ArrayReader.prototype.readData = function(size) {
	    this.checkOffset(size);
	    if(size === 0) {
	        return [];
	    }
	    var result = this.data.slice(this.zero + this.index, this.zero + this.index + size);
	    this.index += size;
	    return result;
	};
	module.exports = ArrayReader;


/***/ },
/* 445 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var utils = __webpack_require__(42);
	
	function DataReader(data) {
	    this.data = data; // type : see implementation
	    this.length = data.length;
	    this.index = 0;
	    this.zero = 0;
	}
	DataReader.prototype = {
	    /**
	     * Check that the offset will not go too far.
	     * @param {string} offset the additional offset to check.
	     * @throws {Error} an Error if the offset is out of bounds.
	     */
	    checkOffset: function(offset) {
	        this.checkIndex(this.index + offset);
	    },
	    /**
	     * Check that the specified index will not be too far.
	     * @param {string} newIndex the index to check.
	     * @throws {Error} an Error if the index is out of bounds.
	     */
	    checkIndex: function(newIndex) {
	        if (this.length < this.zero + newIndex || newIndex < 0) {
	            throw new Error("End of data reached (data length = " + this.length + ", asked index = " + (newIndex) + "). Corrupted zip ?");
	        }
	    },
	    /**
	     * Change the index.
	     * @param {number} newIndex The new index.
	     * @throws {Error} if the new index is out of the data.
	     */
	    setIndex: function(newIndex) {
	        this.checkIndex(newIndex);
	        this.index = newIndex;
	    },
	    /**
	     * Skip the next n bytes.
	     * @param {number} n the number of bytes to skip.
	     * @throws {Error} if the new index is out of the data.
	     */
	    skip: function(n) {
	        this.setIndex(this.index + n);
	    },
	    /**
	     * Get the byte at the specified index.
	     * @param {number} i the index to use.
	     * @return {number} a byte.
	     */
	    byteAt: function() {
	        // see implementations
	    },
	    /**
	     * Get the next number with a given byte size.
	     * @param {number} size the number of bytes to read.
	     * @return {number} the corresponding number.
	     */
	    readInt: function(size) {
	        var result = 0,
	            i;
	        this.checkOffset(size);
	        for (i = this.index + size - 1; i >= this.index; i--) {
	            result = (result << 8) + this.byteAt(i);
	        }
	        this.index += size;
	        return result;
	    },
	    /**
	     * Get the next string with a given byte size.
	     * @param {number} size the number of bytes to read.
	     * @return {string} the corresponding string.
	     */
	    readString: function(size) {
	        return utils.transformTo("string", this.readData(size));
	    },
	    /**
	     * Get raw data without conversion, <size> bytes.
	     * @param {number} size the number of bytes to read.
	     * @return {Object} the raw data, implementation specific.
	     */
	    readData: function() {
	        // see implementations
	    },
	    /**
	     * Find the last occurrence of a zip signature (4 bytes).
	     * @param {string} sig the signature to find.
	     * @return {number} the index of the last occurrence, -1 if not found.
	     */
	    lastIndexOfSignature: function() {
	        // see implementations
	    },
	    /**
	     * Read the signature (4 bytes) at the current position and compare it with sig.
	     * @param {string} sig the expected signature
	     * @return {boolean} true if the signature matches, false otherwise.
	     */
	    readAndCheckSignature: function() {
	        // see implementations
	    },
	    /**
	     * Get the next date.
	     * @return {Date} the date.
	     */
	    readDate: function() {
	        var dostime = this.readInt(4);
	        return new Date(Date.UTC(
	            ((dostime >> 25) & 0x7f) + 1980, // year
	            ((dostime >> 21) & 0x0f) - 1, // month
	            (dostime >> 16) & 0x1f, // day
	            (dostime >> 11) & 0x1f, // hour
	            (dostime >> 5) & 0x3f, // minute
	            (dostime & 0x1f) << 1)); // second
	    }
	};
	module.exports = DataReader;


/***/ },
/* 446 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var ArrayReader = __webpack_require__(444);
	var utils = __webpack_require__(42);
	
	function Uint8ArrayReader(data) {
	    ArrayReader.call(this, data);
	}
	utils.inherits(Uint8ArrayReader, ArrayReader);
	/**
	 * @see DataReader.readData
	 */
	Uint8ArrayReader.prototype.readData = function(size) {
	    this.checkOffset(size);
	    if(size === 0) {
	        // in IE10, when using subarray(idx, idx), we get the array [0x00] instead of [].
	        return new Uint8Array(0);
	    }
	    var result = this.data.subarray(this.zero + this.index, this.zero + this.index + size);
	    this.index += size;
	    return result;
	};
	module.exports = Uint8ArrayReader;


/***/ },
/* 447 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var utils = __webpack_require__(42);
	var support = __webpack_require__(98);
	var ArrayReader = __webpack_require__(444);
	var StringReader = __webpack_require__(1332);
	var NodeBufferReader = __webpack_require__(1331);
	var Uint8ArrayReader = __webpack_require__(446);
	
	/**
	 * Create a reader adapted to the data.
	 * @param {String|ArrayBuffer|Uint8Array|Buffer} data the data to read.
	 * @return {DataReader} the data reader.
	 */
	module.exports = function (data) {
	    var type = utils.getTypeOf(data);
	    utils.checkSupport(type);
	    if (type === "string" && !support.uint8array) {
	        return new StringReader(data);
	    }
	    if (type === "nodebuffer") {
	        return new NodeBufferReader(data);
	    }
	    if (support.uint8array) {
	        return new Uint8ArrayReader(utils.transformTo("uint8array", data));
	    }
	    return new ArrayReader(utils.transformTo("array", data));
	};


/***/ },
/* 448 */
/***/ function(module, exports) {

	"use strict";
	exports.LOCAL_FILE_HEADER = "PK\x03\x04";
	exports.CENTRAL_FILE_HEADER = "PK\x01\x02";
	exports.CENTRAL_DIRECTORY_END = "PK\x05\x06";
	exports.ZIP64_CENTRAL_DIRECTORY_LOCATOR = "PK\x06\x07";
	exports.ZIP64_CENTRAL_DIRECTORY_END = "PK\x06\x06";
	exports.DATA_DESCRIPTOR = "PK\x07\x08";


/***/ },
/* 449 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var GenericWorker = __webpack_require__(72);
	var crc32 = __webpack_require__(276);
	var utils = __webpack_require__(42);
	
	/**
	 * A worker which calculate the crc32 of the data flowing through.
	 * @constructor
	 */
	function Crc32Probe() {
	    GenericWorker.call(this, "Crc32Probe");
	    this.withStreamInfo("crc32", 0);
	}
	utils.inherits(Crc32Probe, GenericWorker);
	
	/**
	 * @see GenericWorker.processChunk
	 */
	Crc32Probe.prototype.processChunk = function (chunk) {
	    this.streamInfo.crc32 = crc32(chunk.data, this.streamInfo.crc32 || 0);
	    this.push(chunk);
	};
	module.exports = Crc32Probe;


/***/ },
/* 450 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var utils = __webpack_require__(42);
	var GenericWorker = __webpack_require__(72);
	
	// the size of the generated chunks
	// TODO expose this as a public variable
	var DEFAULT_BLOCK_SIZE = 16 * 1024;
	
	/**
	 * A worker that reads a content and emits chunks.
	 * @constructor
	 * @param {Promise} dataP the promise of the data to split
	 */
	function DataWorker(dataP) {
	    GenericWorker.call(this, "DataWorker");
	    var self = this;
	    this.dataIsReady = false;
	    this.index = 0;
	    this.max = 0;
	    this.data = null;
	    this.type = "";
	
	    this._tickScheduled = false;
	
	    dataP.then(function (data) {
	        self.dataIsReady = true;
	        self.data = data;
	        self.max = data && data.length || 0;
	        self.type = utils.getTypeOf(data);
	        if(!self.isPaused) {
	            self._tickAndRepeat();
	        }
	    }, function (e) {
	        self.error(e);
	    });
	}
	
	utils.inherits(DataWorker, GenericWorker);
	
	/**
	 * @see GenericWorker.cleanUp
	 */
	DataWorker.prototype.cleanUp = function () {
	    GenericWorker.prototype.cleanUp.call(this);
	    this.data = null;
	};
	
	/**
	 * @see GenericWorker.resume
	 */
	DataWorker.prototype.resume = function () {
	    if(!GenericWorker.prototype.resume.call(this)) {
	        return false;
	    }
	
	    if (!this._tickScheduled && this.dataIsReady) {
	        this._tickScheduled = true;
	        utils.delay(this._tickAndRepeat, [], this);
	    }
	    return true;
	};
	
	/**
	 * Trigger a tick a schedule an other call to this function.
	 */
	DataWorker.prototype._tickAndRepeat = function() {
	    this._tickScheduled = false;
	    if(this.isPaused || this.isFinished) {
	        return;
	    }
	    this._tick();
	    if(!this.isFinished) {
	        utils.delay(this._tickAndRepeat, [], this);
	        this._tickScheduled = true;
	    }
	};
	
	/**
	 * Read and push a chunk.
	 */
	DataWorker.prototype._tick = function() {
	
	    if(this.isPaused || this.isFinished) {
	        return false;
	    }
	
	    var size = DEFAULT_BLOCK_SIZE;
	    var data = null, nextIndex = Math.min(this.max, this.index + size);
	    if (this.index >= this.max) {
	        // EOF
	        return this.end();
	    } else {
	        switch(this.type) {
	        case "string":
	            data = this.data.substring(this.index, nextIndex);
	            break;
	        case "uint8array":
	            data = this.data.subarray(this.index, nextIndex);
	            break;
	        case "array":
	        case "nodebuffer":
	            data = this.data.slice(this.index, nextIndex);
	            break;
	        }
	        this.index = nextIndex;
	        return this.push({
	            data : data,
	            meta : {
	                percent : this.max ? this.index / this.max * 100 : 0
	            }
	        });
	    }
	};
	
	module.exports = DataWorker;


/***/ },
/* 451 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {"use strict";
	
	var utils = __webpack_require__(42);
	var ConvertWorker = __webpack_require__(1333);
	var GenericWorker = __webpack_require__(72);
	var base64 = __webpack_require__(440);
	var support = __webpack_require__(98);
	var external = __webpack_require__(159);
	
	var NodejsStreamOutputAdapter = null;
	if (support.nodestream) {
	    try {
	        NodejsStreamOutputAdapter = __webpack_require__(1329);
	    } catch(e) {
	        // ignore
	    }
	}
	
	/**
	 * Apply the final transformation of the data. If the user wants a Blob for
	 * example, it's easier to work with an U8intArray and finally do the
	 * ArrayBuffer/Blob conversion.
	 * @param {String} type the name of the final type
	 * @param {String|Uint8Array|Buffer} content the content to transform
	 * @param {String} mimeType the mime type of the content, if applicable.
	 * @return {String|Uint8Array|ArrayBuffer|Buffer|Blob} the content in the right format.
	 */
	function transformZipOutput(type, content, mimeType) {
	    switch(type) {
	    case "blob" :
	        return utils.newBlob(utils.transformTo("arraybuffer", content), mimeType);
	    case "base64" :
	        return base64.encode(content);
	    default :
	        return utils.transformTo(type, content);
	    }
	}
	
	/**
	 * Concatenate an array of data of the given type.
	 * @param {String} type the type of the data in the given array.
	 * @param {Array} dataArray the array containing the data chunks to concatenate
	 * @return {String|Uint8Array|Buffer} the concatenated data
	 * @throws Error if the asked type is unsupported
	 */
	function concat (type, dataArray) {
	    var i, index = 0, res = null, totalLength = 0;
	    for(i = 0; i < dataArray.length; i++) {
	        totalLength += dataArray[i].length;
	    }
	    switch(type) {
	    case "string":
	        return dataArray.join("");
	    case "array":
	        return Array.prototype.concat.apply([], dataArray);
	    case "uint8array":
	        res = new Uint8Array(totalLength);
	        for(i = 0; i < dataArray.length; i++) {
	            res.set(dataArray[i], index);
	            index += dataArray[i].length;
	        }
	        return res;
	    case "nodebuffer":
	        return Buffer.concat(dataArray);
	    default:
	        throw new Error("concat : unsupported type '"  + type + "'");
	    }
	}
	
	/**
	 * Listen a StreamHelper, accumulate its content and concatenate it into a
	 * complete block.
	 * @param {StreamHelper} helper the helper to use.
	 * @param {Function} updateCallback a callback called on each update. Called
	 * with one arg :
	 * - the metadata linked to the update received.
	 * @return Promise the promise for the accumulation.
	 */
	function accumulate(helper, updateCallback) {
	    return new external.Promise(function (resolve, reject){
	        var dataArray = [];
	        var chunkType = helper._internalType,
	            resultType = helper._outputType,
	            mimeType = helper._mimeType;
	        helper
	            .on("data", function (data, meta) {
	                dataArray.push(data);
	                if(updateCallback) {
	                    updateCallback(meta);
	                }
	            })
	            .on("error", function(err) {
	                dataArray = [];
	                reject(err);
	            })
	            .on("end", function (){
	                try {
	                    var result = transformZipOutput(resultType, concat(chunkType, dataArray), mimeType);
	                    resolve(result);
	                } catch (e) {
	                    reject(e);
	                }
	                dataArray = [];
	            })
	            .resume();
	    });
	}
	
	/**
	 * An helper to easily use workers outside of JSZip.
	 * @constructor
	 * @param {Worker} worker the worker to wrap
	 * @param {String} outputType the type of data expected by the use
	 * @param {String} mimeType the mime type of the content, if applicable.
	 */
	function StreamHelper(worker, outputType, mimeType) {
	    var internalType = outputType;
	    switch(outputType) {
	    case "blob":
	    case "arraybuffer":
	        internalType = "uint8array";
	        break;
	    case "base64":
	        internalType = "string";
	        break;
	    }
	
	    try {
	        // the type used internally
	        this._internalType = internalType;
	        // the type used to output results
	        this._outputType = outputType;
	        // the mime type
	        this._mimeType = mimeType;
	        utils.checkSupport(internalType);
	        this._worker = worker.pipe(new ConvertWorker(internalType));
	        // the last workers can be rewired without issues but we need to
	        // prevent any updates on previous workers.
	        worker.lock();
	    } catch(e) {
	        this._worker = new GenericWorker("error");
	        this._worker.error(e);
	    }
	}
	
	StreamHelper.prototype = {
	    /**
	     * Listen a StreamHelper, accumulate its content and concatenate it into a
	     * complete block.
	     * @param {Function} updateCb the update callback.
	     * @return Promise the promise for the accumulation.
	     */
	    accumulate : function (updateCb) {
	        return accumulate(this, updateCb);
	    },
	    /**
	     * Add a listener on an event triggered on a stream.
	     * @param {String} evt the name of the event
	     * @param {Function} fn the listener
	     * @return {StreamHelper} the current helper.
	     */
	    on : function (evt, fn) {
	        var self = this;
	
	        if(evt === "data") {
	            this._worker.on(evt, function (chunk) {
	                fn.call(self, chunk.data, chunk.meta);
	            });
	        } else {
	            this._worker.on(evt, function () {
	                utils.delay(fn, arguments, self);
	            });
	        }
	        return this;
	    },
	    /**
	     * Resume the flow of chunks.
	     * @return {StreamHelper} the current helper.
	     */
	    resume : function () {
	        utils.delay(this._worker.resume, [], this._worker);
	        return this;
	    },
	    /**
	     * Pause the flow of chunks.
	     * @return {StreamHelper} the current helper.
	     */
	    pause : function () {
	        this._worker.pause();
	        return this;
	    },
	    /**
	     * Return a nodejs stream for this helper.
	     * @param {Function} updateCb the update callback.
	     * @return {NodejsStreamOutputAdapter} the nodejs stream.
	     */
	    toNodejsStream : function (updateCb) {
	        utils.checkSupport("nodestream");
	        if (this._outputType !== "nodebuffer") {
	            // an object stream containing blob/arraybuffer/uint8array/string
	            // is strange and I don't know if it would be useful.
	            // I you find this comment and have a good usecase, please open a
	            // bug report !
	            throw new Error(this._outputType + " is not supported by this method");
	        }
	
	        return new NodejsStreamOutputAdapter(this, {
	            objectMode : this._outputType !== "nodebuffer"
	        }, updateCb);
	    }
	};
	
	
	module.exports = StreamHelper;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(146).Buffer))

/***/ },
/* 452 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        result = wait - timeSinceLastCall;
	
	    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = debounce;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 453 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Afrikaans [af]
	//! author : Werner Mollentze : https://github.com/wernerm
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var af = moment.defineLocale('af', {
	        months: 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	        weekdays: 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split(
	            '_'
	        ),
	        weekdaysShort: 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	        weekdaysMin: 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	        meridiemParse: /vm|nm/i,
	        isPM: function (input) {
	            return /^nm$/i.test(input);
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'vm' : 'VM';
	            } else {
	                return isLower ? 'nm' : 'NM';
	            }
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Vandag om] LT',
	            nextDay: '[Môre om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[Gister om] LT',
	            lastWeek: '[Laas] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'oor %s',
	            past: '%s gelede',
	            s: "'n paar sekondes",
	            ss: '%d sekondes',
	            m: "'n minuut",
	            mm: '%d minute',
	            h: "'n uur",
	            hh: '%d ure',
	            d: "'n dag",
	            dd: '%d dae',
	            M: "'n maand",
	            MM: '%d maande',
	            y: "'n jaar",
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            ); // Thanks to Joris Röling : https://github.com/jjupiter
	        },
	        week: {
	            dow: 1, // Maandag is die eerste dag van die week.
	            doy: 4, // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	        },
	    });
	
	    return af;
	
	})));


/***/ },
/* 454 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Algeria) [ar-dz]
	//! author : Amine Roukh: https://github.com/Amine27
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	//! author : Noureddine LOUAHEDJ : https://github.com/noureddinem
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var pluralForm = function (n) {
	            return n === 0
	                ? 0
	                : n === 1
	                  ? 1
	                  : n === 2
	                    ? 2
	                    : n % 100 >= 3 && n % 100 <= 10
	                      ? 3
	                      : n % 100 >= 11
	                        ? 4
	                        : 5;
	        },
	        plurals = {
	            s: [
	                'أقل من ثانية',
	                'ثانية واحدة',
	                ['ثانيتان', 'ثانيتين'],
	                '%d ثوان',
	                '%d ثانية',
	                '%d ثانية',
	            ],
	            m: [
	                'أقل من دقيقة',
	                'دقيقة واحدة',
	                ['دقيقتان', 'دقيقتين'],
	                '%d دقائق',
	                '%d دقيقة',
	                '%d دقيقة',
	            ],
	            h: [
	                'أقل من ساعة',
	                'ساعة واحدة',
	                ['ساعتان', 'ساعتين'],
	                '%d ساعات',
	                '%d ساعة',
	                '%d ساعة',
	            ],
	            d: [
	                'أقل من يوم',
	                'يوم واحد',
	                ['يومان', 'يومين'],
	                '%d أيام',
	                '%d يومًا',
	                '%d يوم',
	            ],
	            M: [
	                'أقل من شهر',
	                'شهر واحد',
	                ['شهران', 'شهرين'],
	                '%d أشهر',
	                '%d شهرا',
	                '%d شهر',
	            ],
	            y: [
	                'أقل من عام',
	                'عام واحد',
	                ['عامان', 'عامين'],
	                '%d أعوام',
	                '%d عامًا',
	                '%d عام',
	            ],
	        },
	        pluralize = function (u) {
	            return function (number, withoutSuffix, string, isFuture) {
	                var f = pluralForm(number),
	                    str = plurals[u][pluralForm(number)];
	                if (f === 2) {
	                    str = str[withoutSuffix ? 0 : 1];
	                }
	                return str.replace(/%d/i, number);
	            };
	        },
	        months = [
	            'جانفي',
	            'فيفري',
	            'مارس',
	            'أفريل',
	            'ماي',
	            'جوان',
	            'جويلية',
	            'أوت',
	            'سبتمبر',
	            'أكتوبر',
	            'نوفمبر',
	            'ديسمبر',
	        ];
	
	    var arDz = moment.defineLocale('ar-dz', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            ss: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y'),
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return arDz;
	
	})));


/***/ },
/* 455 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Kuwait) [ar-kw]
	//! author : Nusret Parlak: https://github.com/nusretparlak
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arKw = moment.defineLocale('ar-kw', {
	        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	            '_'
	        ),
	        monthsShort:
	            'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	                '_'
	            ),
	        weekdays: 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return arKw;
	
	})));


/***/ },
/* 456 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Libya) [ar-ly]
	//! author : Ali Hmer: https://github.com/kikoanis
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '1',
	            2: '2',
	            3: '3',
	            4: '4',
	            5: '5',
	            6: '6',
	            7: '7',
	            8: '8',
	            9: '9',
	            0: '0',
	        },
	        pluralForm = function (n) {
	            return n === 0
	                ? 0
	                : n === 1
	                  ? 1
	                  : n === 2
	                    ? 2
	                    : n % 100 >= 3 && n % 100 <= 10
	                      ? 3
	                      : n % 100 >= 11
	                        ? 4
	                        : 5;
	        },
	        plurals = {
	            s: [
	                'أقل من ثانية',
	                'ثانية واحدة',
	                ['ثانيتان', 'ثانيتين'],
	                '%d ثوان',
	                '%d ثانية',
	                '%d ثانية',
	            ],
	            m: [
	                'أقل من دقيقة',
	                'دقيقة واحدة',
	                ['دقيقتان', 'دقيقتين'],
	                '%d دقائق',
	                '%d دقيقة',
	                '%d دقيقة',
	            ],
	            h: [
	                'أقل من ساعة',
	                'ساعة واحدة',
	                ['ساعتان', 'ساعتين'],
	                '%d ساعات',
	                '%d ساعة',
	                '%d ساعة',
	            ],
	            d: [
	                'أقل من يوم',
	                'يوم واحد',
	                ['يومان', 'يومين'],
	                '%d أيام',
	                '%d يومًا',
	                '%d يوم',
	            ],
	            M: [
	                'أقل من شهر',
	                'شهر واحد',
	                ['شهران', 'شهرين'],
	                '%d أشهر',
	                '%d شهرا',
	                '%d شهر',
	            ],
	            y: [
	                'أقل من عام',
	                'عام واحد',
	                ['عامان', 'عامين'],
	                '%d أعوام',
	                '%d عامًا',
	                '%d عام',
	            ],
	        },
	        pluralize = function (u) {
	            return function (number, withoutSuffix, string, isFuture) {
	                var f = pluralForm(number),
	                    str = plurals[u][pluralForm(number)];
	                if (f === 2) {
	                    str = str[withoutSuffix ? 0 : 1];
	                }
	                return str.replace(/%d/i, number);
	            };
	        },
	        months = [
	            'يناير',
	            'فبراير',
	            'مارس',
	            'أبريل',
	            'مايو',
	            'يونيو',
	            'يوليو',
	            'أغسطس',
	            'سبتمبر',
	            'أكتوبر',
	            'نوفمبر',
	            'ديسمبر',
	        ];
	
	    var arLy = moment.defineLocale('ar-ly', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            ss: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y'),
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return arLy;
	
	})));


/***/ },
/* 457 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Morocco) [ar-ma]
	//! author : ElFadili Yassine : https://github.com/ElFadiliY
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arMa = moment.defineLocale('ar-ma', {
	        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	            '_'
	        ),
	        monthsShort:
	            'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	                '_'
	            ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return arMa;
	
	})));


/***/ },
/* 458 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Palestine) [ar-ps]
	//! author : Majd Al-Shihabi : https://github.com/majdal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '١',
	            2: '٢',
	            3: '٣',
	            4: '٤',
	            5: '٥',
	            6: '٦',
	            7: '٧',
	            8: '٨',
	            9: '٩',
	            0: '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        };
	
	    var arPs = moment.defineLocale('ar-ps', {
	        months: 'كانون الثاني_شباط_آذار_نيسان_أيّار_حزيران_تمّوز_آب_أيلول_تشري الأوّل_تشرين الثاني_كانون الأوّل'.split(
	            '_'
	        ),
	        monthsShort:
	            'ك٢_شباط_آذار_نيسان_أيّار_حزيران_تمّوز_آب_أيلول_ت١_ت٢_ك١'.split('_'),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .split('') // reversed since negative lookbehind not supported everywhere
	                .reverse()
	                .join('')
	                .replace(/[١٢](?![\u062a\u0643])/g, function (match) {
	                    return numberMap[match];
	                })
	                .split('')
	                .reverse()
	                .join('')
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return arPs;
	
	})));


/***/ },
/* 459 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Saudi Arabia) [ar-sa]
	//! author : Suhail Alkowaileet : https://github.com/xsoh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '١',
	            2: '٢',
	            3: '٣',
	            4: '٤',
	            5: '٥',
	            6: '٦',
	            7: '٧',
	            8: '٨',
	            9: '٩',
	            0: '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        };
	
	    var arSa = moment.defineLocale('ar-sa', {
	        months: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	            '_'
	        ),
	        monthsShort:
	            'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	                '_'
	            ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return arSa;
	
	})));


/***/ },
/* 460 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale  :  Arabic (Tunisia) [ar-tn]
	//! author : Nader Toukabri : https://github.com/naderio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arTn = moment.defineLocale('ar-tn', {
	        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	            '_'
	        ),
	        monthsShort:
	            'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	                '_'
	            ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return arTn;
	
	})));


/***/ },
/* 461 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic [ar]
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '١',
	            2: '٢',
	            3: '٣',
	            4: '٤',
	            5: '٥',
	            6: '٦',
	            7: '٧',
	            8: '٨',
	            9: '٩',
	            0: '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        },
	        pluralForm = function (n) {
	            return n === 0
	                ? 0
	                : n === 1
	                  ? 1
	                  : n === 2
	                    ? 2
	                    : n % 100 >= 3 && n % 100 <= 10
	                      ? 3
	                      : n % 100 >= 11
	                        ? 4
	                        : 5;
	        },
	        plurals = {
	            s: [
	                'أقل من ثانية',
	                'ثانية واحدة',
	                ['ثانيتان', 'ثانيتين'],
	                '%d ثوان',
	                '%d ثانية',
	                '%d ثانية',
	            ],
	            m: [
	                'أقل من دقيقة',
	                'دقيقة واحدة',
	                ['دقيقتان', 'دقيقتين'],
	                '%d دقائق',
	                '%d دقيقة',
	                '%d دقيقة',
	            ],
	            h: [
	                'أقل من ساعة',
	                'ساعة واحدة',
	                ['ساعتان', 'ساعتين'],
	                '%d ساعات',
	                '%d ساعة',
	                '%d ساعة',
	            ],
	            d: [
	                'أقل من يوم',
	                'يوم واحد',
	                ['يومان', 'يومين'],
	                '%d أيام',
	                '%d يومًا',
	                '%d يوم',
	            ],
	            M: [
	                'أقل من شهر',
	                'شهر واحد',
	                ['شهران', 'شهرين'],
	                '%d أشهر',
	                '%d شهرا',
	                '%d شهر',
	            ],
	            y: [
	                'أقل من عام',
	                'عام واحد',
	                ['عامان', 'عامين'],
	                '%d أعوام',
	                '%d عامًا',
	                '%d عام',
	            ],
	        },
	        pluralize = function (u) {
	            return function (number, withoutSuffix, string, isFuture) {
	                var f = pluralForm(number),
	                    str = plurals[u][pluralForm(number)];
	                if (f === 2) {
	                    str = str[withoutSuffix ? 0 : 1];
	                }
	                return str.replace(/%d/i, number);
	            };
	        },
	        months = [
	            'يناير',
	            'فبراير',
	            'مارس',
	            'أبريل',
	            'مايو',
	            'يونيو',
	            'يوليو',
	            'أغسطس',
	            'سبتمبر',
	            'أكتوبر',
	            'نوفمبر',
	            'ديسمبر',
	        ];
	
	    var ar = moment.defineLocale('ar', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            ss: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y'),
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return ar;
	
	})));


/***/ },
/* 462 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Azerbaijani [az]
	//! author : topchiyev : https://github.com/topchiyev
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        1: '-inci',
	        5: '-inci',
	        8: '-inci',
	        70: '-inci',
	        80: '-inci',
	        2: '-nci',
	        7: '-nci',
	        20: '-nci',
	        50: '-nci',
	        3: '-üncü',
	        4: '-üncü',
	        100: '-üncü',
	        6: '-ncı',
	        9: '-uncu',
	        10: '-uncu',
	        30: '-uncu',
	        60: '-ıncı',
	        90: '-ıncı',
	    };
	
	    var az = moment.defineLocale('az', {
	        months: 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split(
	            '_'
	        ),
	        monthsShort: 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	        weekdays:
	            'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split(
	                '_'
	            ),
	        weekdaysShort: 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	        weekdaysMin: 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[bugün saat] LT',
	            nextDay: '[sabah saat] LT',
	            nextWeek: '[gələn həftə] dddd [saat] LT',
	            lastDay: '[dünən] LT',
	            lastWeek: '[keçən həftə] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s sonra',
	            past: '%s əvvəl',
	            s: 'bir neçə saniyə',
	            ss: '%d saniyə',
	            m: 'bir dəqiqə',
	            mm: '%d dəqiqə',
	            h: 'bir saat',
	            hh: '%d saat',
	            d: 'bir gün',
	            dd: '%d gün',
	            M: 'bir ay',
	            MM: '%d ay',
	            y: 'bir il',
	            yy: '%d il',
	        },
	        meridiemParse: /gecə|səhər|gündüz|axşam/,
	        isPM: function (input) {
	            return /^(gündüz|axşam)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'gecə';
	            } else if (hour < 12) {
	                return 'səhər';
	            } else if (hour < 17) {
	                return 'gündüz';
	            } else {
	                return 'axşam';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	        ordinal: function (number) {
	            if (number === 0) {
	                // special case for zero
	                return number + '-ıncı';
	            }
	            var a = number % 10,
	                b = (number % 100) - a,
	                c = number >= 100 ? 100 : null;
	            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return az;
	
	})));


/***/ },
/* 463 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Belarusian [be]
	//! author : Dmitry Demidov : https://github.com/demidov91
	//! author: Praleska: http://praleska.pro/
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	              ? forms[1]
	              : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            mm: withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	            hh: withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	            dd: 'дзень_дні_дзён',
	            MM: 'месяц_месяцы_месяцаў',
	            yy: 'год_гады_гадоў',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвіліна' : 'хвіліну';
	        } else if (key === 'h') {
	            return withoutSuffix ? 'гадзіна' : 'гадзіну';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	
	    var be = moment.defineLocale('be', {
	        months: {
	            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split(
	                '_'
	            ),
	            standalone:
	                'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split(
	                    '_'
	                ),
	        },
	        monthsShort:
	            'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
	        weekdays: {
	            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split(
	                '_'
	            ),
	            standalone:
	                'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split(
	                    '_'
	                ),
	            isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/,
	        },
	        weekdaysShort: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        weekdaysMin: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY г.',
	            LLL: 'D MMMM YYYY г., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY г., HH:mm',
	        },
	        calendar: {
	            sameDay: '[Сёння ў] LT',
	            nextDay: '[Заўтра ў] LT',
	            lastDay: '[Учора ў] LT',
	            nextWeek: function () {
	                return '[У] dddd [ў] LT';
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[У мінулую] dddd [ў] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[У мінулы] dddd [ў] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'праз %s',
	            past: '%s таму',
	            s: 'некалькі секунд',
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: relativeTimeWithPlural,
	            hh: relativeTimeWithPlural,
	            d: 'дзень',
	            dd: relativeTimeWithPlural,
	            M: 'месяц',
	            MM: relativeTimeWithPlural,
	            y: 'год',
	            yy: relativeTimeWithPlural,
	        },
	        meridiemParse: /ночы|раніцы|дня|вечара/,
	        isPM: function (input) {
	            return /^(дня|вечара)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночы';
	            } else if (hour < 12) {
	                return 'раніцы';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечара';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return (number % 10 === 2 || number % 10 === 3) &&
	                        number % 100 !== 12 &&
	                        number % 100 !== 13
	                        ? number + '-і'
	                        : number + '-ы';
	                case 'D':
	                    return number + '-га';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return be;
	
	})));


/***/ },
/* 464 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bulgarian [bg]
	//! author : Krasen Borisov : https://github.com/kraz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var bg = moment.defineLocale('bg', {
	        months: 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split(
	            '_'
	        ),
	        monthsShort: 'яну_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays: 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split(
	            '_'
	        ),
	        weekdaysShort: 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[Днес в] LT',
	            nextDay: '[Утре в] LT',
	            nextWeek: 'dddd [в] LT',
	            lastDay: '[Вчера в] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[Миналата] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[Миналия] dddd [в] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'след %s',
	            past: 'преди %s',
	            s: 'няколко секунди',
	            ss: '%d секунди',
	            m: 'минута',
	            mm: '%d минути',
	            h: 'час',
	            hh: '%d часа',
	            d: 'ден',
	            dd: '%d дена',
	            w: 'седмица',
	            ww: '%d седмици',
	            M: 'месец',
	            MM: '%d месеца',
	            y: 'година',
	            yy: '%d години',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal: function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return bg;
	
	})));


/***/ },
/* 465 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bambara [bm]
	//! author : Estelle Comment : https://github.com/estellecomment
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var bm = moment.defineLocale('bm', {
	        months: 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split(
	            '_'
	        ),
	        monthsShort: 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
	        weekdays: 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
	        weekdaysShort: 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
	        weekdaysMin: 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'MMMM [tile] D [san] YYYY',
	            LLL: 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
	            LLLL: 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
	        },
	        calendar: {
	            sameDay: '[Bi lɛrɛ] LT',
	            nextDay: '[Sini lɛrɛ] LT',
	            nextWeek: 'dddd [don lɛrɛ] LT',
	            lastDay: '[Kunu lɛrɛ] LT',
	            lastWeek: 'dddd [tɛmɛnen lɛrɛ] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s kɔnɔ',
	            past: 'a bɛ %s bɔ',
	            s: 'sanga dama dama',
	            ss: 'sekondi %d',
	            m: 'miniti kelen',
	            mm: 'miniti %d',
	            h: 'lɛrɛ kelen',
	            hh: 'lɛrɛ %d',
	            d: 'tile kelen',
	            dd: 'tile %d',
	            M: 'kalo kelen',
	            MM: 'kalo %d',
	            y: 'san kelen',
	            yy: 'san %d',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return bm;
	
	})));


/***/ },
/* 466 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali (Bangladesh) [bn-bd]
	//! author : Asraf Hossain Patoary : https://github.com/ashwoolford
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '১',
	            2: '২',
	            3: '৩',
	            4: '৪',
	            5: '৫',
	            6: '৬',
	            7: '৭',
	            8: '৮',
	            9: '৯',
	            0: '০',
	        },
	        numberMap = {
	            '১': '1',
	            '২': '2',
	            '৩': '3',
	            '৪': '4',
	            '৫': '5',
	            '৬': '6',
	            '৭': '7',
	            '৮': '8',
	            '৯': '9',
	            '০': '0',
	        };
	
	    var bnBd = moment.defineLocale('bn-bd', {
	        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
	            '_'
	        ),
	        monthsShort:
	            'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
	                '_'
	            ),
	        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
	            '_'
	        ),
	        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm সময়',
	            LTS: 'A h:mm:ss সময়',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm সময়',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
	        },
	        calendar: {
	            sameDay: '[আজ] LT',
	            nextDay: '[আগামীকাল] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[গতকাল] LT',
	            lastWeek: '[গত] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s পরে',
	            past: '%s আগে',
	            s: 'কয়েক সেকেন্ড',
	            ss: '%d সেকেন্ড',
	            m: 'এক মিনিট',
	            mm: '%d মিনিট',
	            h: 'এক ঘন্টা',
	            hh: '%d ঘন্টা',
	            d: 'এক দিন',
	            dd: '%d দিন',
	            M: 'এক মাস',
	            MM: '%d মাস',
	            y: 'এক বছর',
	            yy: '%d বছর',
	        },
	        preparse: function (string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	
	        meridiemParse: /রাত|ভোর|সকাল|দুপুর|বিকাল|সন্ধ্যা|রাত/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'রাত') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ভোর') {
	                return hour;
	            } else if (meridiem === 'সকাল') {
	                return hour;
	            } else if (meridiem === 'দুপুর') {
	                return hour >= 3 ? hour : hour + 12;
	            } else if (meridiem === 'বিকাল') {
	                return hour + 12;
	            } else if (meridiem === 'সন্ধ্যা') {
	                return hour + 12;
	            }
	        },
	
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 6) {
	                return 'ভোর';
	            } else if (hour < 12) {
	                return 'সকাল';
	            } else if (hour < 15) {
	                return 'দুপুর';
	            } else if (hour < 18) {
	                return 'বিকাল';
	            } else if (hour < 20) {
	                return 'সন্ধ্যা';
	            } else {
	                return 'রাত';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return bnBd;
	
	})));


/***/ },
/* 467 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali [bn]
	//! author : Kaushik Gandhi : https://github.com/kaushikgandhi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '১',
	            2: '২',
	            3: '৩',
	            4: '৪',
	            5: '৫',
	            6: '৬',
	            7: '৭',
	            8: '৮',
	            9: '৯',
	            0: '০',
	        },
	        numberMap = {
	            '১': '1',
	            '২': '2',
	            '৩': '3',
	            '৪': '4',
	            '৫': '5',
	            '৬': '6',
	            '৭': '7',
	            '৮': '8',
	            '৯': '9',
	            '০': '0',
	        };
	
	    var bn = moment.defineLocale('bn', {
	        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
	            '_'
	        ),
	        monthsShort:
	            'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
	                '_'
	            ),
	        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
	            '_'
	        ),
	        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm সময়',
	            LTS: 'A h:mm:ss সময়',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm সময়',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
	        },
	        calendar: {
	            sameDay: '[আজ] LT',
	            nextDay: '[আগামীকাল] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[গতকাল] LT',
	            lastWeek: '[গত] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s পরে',
	            past: '%s আগে',
	            s: 'কয়েক সেকেন্ড',
	            ss: '%d সেকেন্ড',
	            m: 'এক মিনিট',
	            mm: '%d মিনিট',
	            h: 'এক ঘন্টা',
	            hh: '%d ঘন্টা',
	            d: 'এক দিন',
	            dd: '%d দিন',
	            M: 'এক মাস',
	            MM: '%d মাস',
	            y: 'এক বছর',
	            yy: '%d বছর',
	        },
	        preparse: function (string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'রাত' && hour >= 4) ||
	                (meridiem === 'দুপুর' && hour < 5) ||
	                meridiem === 'বিকাল'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 10) {
	                return 'সকাল';
	            } else if (hour < 17) {
	                return 'দুপুর';
	            } else if (hour < 20) {
	                return 'বিকাল';
	            } else {
	                return 'রাত';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return bn;
	
	})));


/***/ },
/* 468 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tibetan [bo]
	//! author : Thupten N. Chakrishar : https://github.com/vajradog
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '༡',
	            2: '༢',
	            3: '༣',
	            4: '༤',
	            5: '༥',
	            6: '༦',
	            7: '༧',
	            8: '༨',
	            9: '༩',
	            0: '༠',
	        },
	        numberMap = {
	            '༡': '1',
	            '༢': '2',
	            '༣': '3',
	            '༤': '4',
	            '༥': '5',
	            '༦': '6',
	            '༧': '7',
	            '༨': '8',
	            '༩': '9',
	            '༠': '0',
	        };
	
	    var bo = moment.defineLocale('bo', {
	        months: 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split(
	            '_'
	        ),
	        monthsShort:
	            'ཟླ་1_ཟླ་2_ཟླ་3_ཟླ་4_ཟླ་5_ཟླ་6_ཟླ་7_ཟླ་8_ཟླ་9_ཟླ་10_ཟླ་11_ཟླ་12'.split(
	                '_'
	            ),
	        monthsShortRegex: /^(ཟླ་\d{1,2})/,
	        monthsParseExact: true,
	        weekdays:
	            'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split(
	                '_'
	            ),
	        weekdaysShort: 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split(
	            '_'
	        ),
	        weekdaysMin: 'ཉི_ཟླ_མིག_ལྷག_ཕུར_སངས_སྤེན'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[དི་རིང] LT',
	            nextDay: '[སང་ཉིན] LT',
	            nextWeek: '[བདུན་ཕྲག་རྗེས་མ], LT',
	            lastDay: '[ཁ་སང] LT',
	            lastWeek: '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ལ་',
	            past: '%s སྔན་ལ',
	            s: 'ལམ་སང',
	            ss: '%d སྐར་ཆ།',
	            m: 'སྐར་མ་གཅིག',
	            mm: '%d སྐར་མ',
	            h: 'ཆུ་ཚོད་གཅིག',
	            hh: '%d ཆུ་ཚོད',
	            d: 'ཉིན་གཅིག',
	            dd: '%d ཉིན་',
	            M: 'ཟླ་བ་གཅིག',
	            MM: '%d ཟླ་བ',
	            y: 'ལོ་གཅིག',
	            yy: '%d ལོ',
	        },
	        preparse: function (string) {
	            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'མཚན་མོ' && hour >= 4) ||
	                (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                meridiem === 'དགོང་དག'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'མཚན་མོ';
	            } else if (hour < 10) {
	                return 'ཞོགས་ཀས';
	            } else if (hour < 17) {
	                return 'ཉིན་གུང';
	            } else if (hour < 20) {
	                return 'དགོང་དག';
	            } else {
	                return 'མཚན་མོ';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return bo;
	
	})));


/***/ },
/* 469 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Breton [br]
	//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function relativeTimeWithMutation(number, withoutSuffix, key) {
	        var format = {
	            mm: 'munutenn',
	            MM: 'miz',
	            dd: 'devezh',
	        };
	        return number + ' ' + mutation(format[key], number);
	    }
	    function specialMutationForYears(number) {
	        switch (lastNumber(number)) {
	            case 1:
	            case 3:
	            case 4:
	            case 5:
	            case 9:
	                return number + ' bloaz';
	            default:
	                return number + ' vloaz';
	        }
	    }
	    function lastNumber(number) {
	        if (number > 9) {
	            return lastNumber(number % 10);
	        }
	        return number;
	    }
	    function mutation(text, number) {
	        if (number === 2) {
	            return softMutation(text);
	        }
	        return text;
	    }
	    function softMutation(text) {
	        var mutationTable = {
	            m: 'v',
	            b: 'v',
	            d: 'z',
	        };
	        if (mutationTable[text.charAt(0)] === undefined) {
	            return text;
	        }
	        return mutationTable[text.charAt(0)] + text.substring(1);
	    }
	
	    var monthsParse = [
	            /^gen/i,
	            /^c[ʼ\']hwe/i,
	            /^meu/i,
	            /^ebr/i,
	            /^mae/i,
	            /^(mez|eve)/i,
	            /^gou/i,
	            /^eos/i,
	            /^gwe/i,
	            /^her/i,
	            /^du/i,
	            /^ker/i,
	        ],
	        monthsRegex =
	            /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu|gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
	        monthsStrictRegex =
	            /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu)/i,
	        monthsShortStrictRegex =
	            /^(gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
	        fullWeekdaysParse = [
	            /^sul/i,
	            /^lun/i,
	            /^meurzh/i,
	            /^merc[ʼ\']her/i,
	            /^yaou/i,
	            /^gwener/i,
	            /^sadorn/i,
	        ],
	        shortWeekdaysParse = [
	            /^Sul/i,
	            /^Lun/i,
	            /^Meu/i,
	            /^Mer/i,
	            /^Yao/i,
	            /^Gwe/i,
	            /^Sad/i,
	        ],
	        minWeekdaysParse = [
	            /^Su/i,
	            /^Lu/i,
	            /^Me([^r]|$)/i,
	            /^Mer/i,
	            /^Ya/i,
	            /^Gw/i,
	            /^Sa/i,
	        ];
	
	    var br = moment.defineLocale('br', {
	        months: 'Genver_Cʼhwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split(
	            '_'
	        ),
	        monthsShort: 'Gen_Cʼhwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	        weekdays: 'Sul_Lun_Meurzh_Mercʼher_Yaou_Gwener_Sadorn'.split('_'),
	        weekdaysShort: 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	        weekdaysParse: minWeekdaysParse,
	        fullWeekdaysParse: fullWeekdaysParse,
	        shortWeekdaysParse: shortWeekdaysParse,
	        minWeekdaysParse: minWeekdaysParse,
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: monthsStrictRegex,
	        monthsShortStrictRegex: monthsShortStrictRegex,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [a viz] MMMM YYYY',
	            LLL: 'D [a viz] MMMM YYYY HH:mm',
	            LLLL: 'dddd, D [a viz] MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hiziv da] LT',
	            nextDay: '[Warcʼhoazh da] LT',
	            nextWeek: 'dddd [da] LT',
	            lastDay: '[Decʼh da] LT',
	            lastWeek: 'dddd [paset da] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'a-benn %s',
	            past: '%s ʼzo',
	            s: 'un nebeud segondennoù',
	            ss: '%d eilenn',
	            m: 'ur vunutenn',
	            mm: relativeTimeWithMutation,
	            h: 'un eur',
	            hh: '%d eur',
	            d: 'un devezh',
	            dd: relativeTimeWithMutation,
	            M: 'ur miz',
	            MM: relativeTimeWithMutation,
	            y: 'ur bloaz',
	            yy: specialMutationForYears,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'añ' : 'vet';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        meridiemParse: /a.m.|g.m./, // goude merenn | a-raok merenn
	        isPM: function (token) {
	            return token === 'g.m.';
	        },
	        meridiem: function (hour, minute, isLower) {
	            return hour < 12 ? 'a.m.' : 'g.m.';
	        },
	    });
	
	    return br;
	
	})));


/***/ },
/* 470 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bosnian [bs]
	//! author : Nedim Cholich : https://github.com/frontyard
	//! author : Rasid Redzic : https://github.com/rasidre
	//! based on (hr) translation by Bojan Marković
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        switch (key) {
	            case 'm':
	                return withoutSuffix
	                    ? 'jedna minuta'
	                    : isFuture
	                      ? 'jednu minutu'
	                      : 'jedne minute';
	        }
	    }
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jedan sat';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var bs = moment.defineLocale('bs', {
	        months: 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[jučer u] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                        return '[prošlu] dddd [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'par sekundi',
	            ss: translate,
	            m: processRelativeTime,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: 'dan',
	            dd: translate,
	            M: 'mjesec',
	            MM: translate,
	            y: 'godinu',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return bs;
	
	})));


/***/ },
/* 471 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Catalan [ca]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ca = moment.defineLocale('ca', {
	        months: {
	            standalone:
	                'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split(
	                    '_'
	                ),
	            format: "de gener_de febrer_de març_d'abril_de maig_de juny_de juliol_d'agost_de setembre_d'octubre_de novembre_de desembre".split(
	                '_'
	            ),
	            isFormat: /D[oD]?(\s)+MMMM/,
	        },
	        monthsShort:
	            'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split(
	                '_'
	            ),
	        weekdaysShort: 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin: 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [de] YYYY',
	            ll: 'D MMM YYYY',
	            LLL: 'D MMMM [de] YYYY [a les] H:mm',
	            lll: 'D MMM YYYY, H:mm',
	            LLLL: 'dddd D MMMM [de] YYYY [a les] H:mm',
	            llll: 'ddd D MMM YYYY, H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[avui a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            nextDay: function () {
	                return '[demà a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            lastDay: function () {
	                return '[ahir a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [passat a ' +
	                    (this.hours() !== 1 ? 'les' : 'la') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: "d'aquí %s",
	            past: 'fa %s',
	            s: 'uns segons',
	            ss: '%d segons',
	            m: 'un minut',
	            mm: '%d minuts',
	            h: 'una hora',
	            hh: '%d hores',
	            d: 'un dia',
	            dd: '%d dies',
	            M: 'un mes',
	            MM: '%d mesos',
	            y: 'un any',
	            yy: '%d anys',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal: function (number, period) {
	            var output =
	                number === 1
	                    ? 'r'
	                    : number === 2
	                      ? 'n'
	                      : number === 3
	                        ? 'r'
	                        : number === 4
	                          ? 't'
	                          : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ca;
	
	})));


/***/ },
/* 472 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Czech [cs]
	//! author : petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = {
	            standalone:
	                'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split(
	                    '_'
	                ),
	            format: 'ledna_února_března_dubna_května_června_července_srpna_září_října_listopadu_prosince'.split(
	                '_'
	            ),
	            isFormat: /DD?[o.]?(\[[^\[\]]*\]|\s)+MMMM/,
	        },
	        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_'),
	        monthsParse = [
	            /^led/i,
	            /^úno/i,
	            /^bře/i,
	            /^dub/i,
	            /^kvě/i,
	            /^(čvn|červen$|června)/i,
	            /^(čvc|červenec|července)/i,
	            /^srp/i,
	            /^zář/i,
	            /^říj/i,
	            /^lis/i,
	            /^pro/i,
	        ],
	        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	        monthsRegex =
	            /^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i;
	
	    function plural(n) {
	        return n > 1 && n < 5 && ~~(n / 10) !== 1;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's': // a few seconds / in a few seconds / a few seconds ago
	                return withoutSuffix || isFuture ? 'pár sekund' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekund');
	                } else {
	                    return result + 'sekundami';
	                }
	            case 'm': // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minuta' : isFuture ? 'minutu' : 'minutou';
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minuty' : 'minut');
	                } else {
	                    return result + 'minutami';
	                }
	            case 'h': // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodin');
	                } else {
	                    return result + 'hodinami';
	                }
	            case 'd': // a day / in a day / a day ago
	                return withoutSuffix || isFuture ? 'den' : 'dnem';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dny' : 'dní');
	                } else {
	                    return result + 'dny';
	                }
	            case 'M': // a month / in a month / a month ago
	                return withoutSuffix || isFuture ? 'měsíc' : 'měsícem';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'měsíce' : 'měsíců');
	                } else {
	                    return result + 'měsíci';
	                }
	            case 'y': // a year / in a year / a year ago
	                return withoutSuffix || isFuture ? 'rok' : 'rokem';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'let');
	                } else {
	                    return result + 'lety';
	                }
	        }
	    }
	
	    var cs = moment.defineLocale('cs', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	        monthsStrictRegex:
	            /^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,
	        monthsShortStrictRegex:
	            /^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	        weekdaysShort: 'ne_po_út_st_čt_pá_so'.split('_'),
	        weekdaysMin: 'ne_po_út_st_čt_pá_so'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd D. MMMM YYYY H:mm',
	            l: 'D. M. YYYY',
	        },
	        calendar: {
	            sameDay: '[dnes v] LT',
	            nextDay: '[zítra v] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [v] LT';
	                    case 3:
	                        return '[ve středu v] LT';
	                    case 4:
	                        return '[ve čtvrtek v] LT';
	                    case 5:
	                        return '[v pátek v] LT';
	                    case 6:
	                        return '[v sobotu v] LT';
	                }
	            },
	            lastDay: '[včera v] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulou neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[minulé] dddd [v] LT';
	                    case 3:
	                        return '[minulou středu v] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [v] LT';
	                    case 6:
	                        return '[minulou sobotu v] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'před %s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return cs;
	
	})));


/***/ },
/* 473 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chuvash [cv]
	//! author : Anatoly Mironov : https://github.com/mirontoli
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var cv = moment.defineLocale('cv', {
	        months: 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split(
	            '_'
	        ),
	        monthsShort: 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	        weekdays:
	            'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split(
	                '_'
	            ),
	        weekdaysShort: 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	        weekdaysMin: 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	            LLL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	            LLLL: 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	        },
	        calendar: {
	            sameDay: '[Паян] LT [сехетре]',
	            nextDay: '[Ыран] LT [сехетре]',
	            lastDay: '[Ӗнер] LT [сехетре]',
	            nextWeek: '[Ҫитес] dddd LT [сехетре]',
	            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (output) {
	                var affix = /сехет$/i.exec(output)
	                    ? 'рен'
	                    : /ҫул$/i.exec(output)
	                      ? 'тан'
	                      : 'ран';
	                return output + affix;
	            },
	            past: '%s каялла',
	            s: 'пӗр-ик ҫеккунт',
	            ss: '%d ҫеккунт',
	            m: 'пӗр минут',
	            mm: '%d минут',
	            h: 'пӗр сехет',
	            hh: '%d сехет',
	            d: 'пӗр кун',
	            dd: '%d кун',
	            M: 'пӗр уйӑх',
	            MM: '%d уйӑх',
	            y: 'пӗр ҫул',
	            yy: '%d ҫул',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
	        ordinal: '%d-мӗш',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return cv;
	
	})));


/***/ },
/* 474 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Welsh [cy]
	//! author : Robert Allen : https://github.com/robgallen
	//! author : https://github.com/ryangreaves
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var cy = moment.defineLocale('cy', {
	        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split(
	            '_'
	        ),
	        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split(
	            '_'
	        ),
	        weekdays:
	            'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split(
	                '_'
	            ),
	        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	        weekdaysParseExact: true,
	        // time formats are the same as en-gb
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Heddiw am] LT',
	            nextDay: '[Yfory am] LT',
	            nextWeek: 'dddd [am] LT',
	            lastDay: '[Ddoe am] LT',
	            lastWeek: 'dddd [diwethaf am] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'mewn %s',
	            past: '%s yn ôl',
	            s: 'ychydig eiliadau',
	            ss: '%d eiliad',
	            m: 'munud',
	            mm: '%d munud',
	            h: 'awr',
	            hh: '%d awr',
	            d: 'diwrnod',
	            dd: '%d diwrnod',
	            M: 'mis',
	            MM: '%d mis',
	            y: 'blwyddyn',
	            yy: '%d flynedd',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	        ordinal: function (number) {
	            var b = number,
	                output = '',
	                lookup = [
	                    '',
	                    'af',
	                    'il',
	                    'ydd',
	                    'ydd',
	                    'ed',
	                    'ed',
	                    'ed',
	                    'fed',
	                    'fed',
	                    'fed', // 1af to 10fed
	                    'eg',
	                    'fed',
	                    'eg',
	                    'eg',
	                    'fed',
	                    'eg',
	                    'eg',
	                    'fed',
	                    'eg',
	                    'fed', // 11eg to 20fed
	                ];
	            if (b > 20) {
	                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                    output = 'fed'; // not 30ain, 70ain or 90ain
	                } else {
	                    output = 'ain';
	                }
	            } else if (b > 0) {
	                output = lookup[b];
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return cy;
	
	})));


/***/ },
/* 475 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Danish [da]
	//! author : Ulrik Nielsen : https://github.com/mrbase
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var da = moment.defineLocale('da', {
	        months: 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort: 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd [d.] D. MMMM YYYY [kl.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'på dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[i] dddd[s kl.] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s siden',
	            s: 'få sekunder',
	            ss: '%d sekunder',
	            m: 'et minut',
	            mm: '%d minutter',
	            h: 'en time',
	            hh: '%d timer',
	            d: 'en dag',
	            dd: '%d dage',
	            M: 'en måned',
	            MM: '%d måneder',
	            y: 'et år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return da;
	
	})));


/***/ },
/* 476 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Austria) [de-at]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Martin Groller : https://github.com/MadMG
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            w: ['eine Woche', 'einer Woche'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deAt = moment.defineLocale('de-at', {
	        months: 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort:
	            'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact: true,
	        weekdays:
	            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	                '_'
	            ),
	        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: '%d Wochen',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return deAt;
	
	})));


/***/ },
/* 477 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Switzerland) [de-ch]
	//! author : sschueller : https://github.com/sschueller
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            w: ['eine Woche', 'einer Woche'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deCh = moment.defineLocale('de-ch', {
	        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort:
	            'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact: true,
	        weekdays:
	            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	                '_'
	            ),
	        weekdaysShort: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: '%d Wochen',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return deCh;
	
	})));


/***/ },
/* 478 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German [de]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            w: ['eine Woche', 'einer Woche'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var de = moment.defineLocale('de', {
	        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort:
	            'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact: true,
	        weekdays:
	            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	                '_'
	            ),
	        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: '%d Wochen',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return de;
	
	})));


/***/ },
/* 479 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maldivian [dv]
	//! author : Jawish Hameed : https://github.com/jawish
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'ޖެނުއަރީ',
	            'ފެބްރުއަރީ',
	            'މާރިޗު',
	            'އޭޕްރީލު',
	            'މޭ',
	            'ޖޫން',
	            'ޖުލައި',
	            'އޯގަސްޓު',
	            'ސެޕްޓެމްބަރު',
	            'އޮކްޓޯބަރު',
	            'ނޮވެމްބަރު',
	            'ޑިސެމްބަރު',
	        ],
	        weekdays = [
	            'އާދިއްތަ',
	            'ހޯމަ',
	            'އަންގާރަ',
	            'ބުދަ',
	            'ބުރާސްފަތި',
	            'ހުކުރު',
	            'ހޮނިހިރު',
	        ];
	
	    var dv = moment.defineLocale('dv', {
	        months: months,
	        monthsShort: months,
	        weekdays: weekdays,
	        weekdaysShort: weekdays,
	        weekdaysMin: 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/M/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /މކ|މފ/,
	        isPM: function (input) {
	            return 'މފ' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'މކ';
	            } else {
	                return 'މފ';
	            }
	        },
	        calendar: {
	            sameDay: '[މިއަދު] LT',
	            nextDay: '[މާދަމާ] LT',
	            nextWeek: 'dddd LT',
	            lastDay: '[އިއްޔެ] LT',
	            lastWeek: '[ފާއިތުވި] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ތެރޭގައި %s',
	            past: 'ކުރިން %s',
	            s: 'ސިކުންތުކޮޅެއް',
	            ss: 'd% ސިކުންތު',
	            m: 'މިނިޓެއް',
	            mm: 'މިނިޓު %d',
	            h: 'ގަޑިއިރެއް',
	            hh: 'ގަޑިއިރު %d',
	            d: 'ދުވަހެއް',
	            dd: 'ދުވަސް %d',
	            M: 'މަހެއް',
	            MM: 'މަސް %d',
	            y: 'އަހަރެއް',
	            yy: 'އަހަރު %d',
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 7, // Sunday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return dv;
	
	})));


/***/ },
/* 480 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Greek [el]
	//! author : Aggelos Karalias : https://github.com/mehiel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function isFunction(input) {
	        return (
	            (typeof Function !== 'undefined' && input instanceof Function) ||
	            Object.prototype.toString.call(input) === '[object Function]'
	        );
	    }
	
	    var el = moment.defineLocale('el', {
	        monthsNominativeEl:
	            'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split(
	                '_'
	            ),
	        monthsGenitiveEl:
	            'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split(
	                '_'
	            ),
	        months: function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return this._monthsNominativeEl;
	            } else if (
	                typeof format === 'string' &&
	                /D/.test(format.substring(0, format.indexOf('MMMM')))
	            ) {
	                // if there is a day number before 'MMMM'
	                return this._monthsGenitiveEl[momentToFormat.month()];
	            } else {
	                return this._monthsNominativeEl[momentToFormat.month()];
	            }
	        },
	        monthsShort: 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	        weekdays: 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split(
	            '_'
	        ),
	        weekdaysShort: 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	        weekdaysMin: 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'μμ' : 'ΜΜ';
	            } else {
	                return isLower ? 'πμ' : 'ΠΜ';
	            }
	        },
	        isPM: function (input) {
	            return (input + '').toLowerCase()[0] === 'μ';
	        },
	        meridiemParse: /[ΠΜ]\.?Μ?\.?/i,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendarEl: {
	            sameDay: '[Σήμερα {}] LT',
	            nextDay: '[Αύριο {}] LT',
	            nextWeek: 'dddd [{}] LT',
	            lastDay: '[Χθες {}] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 6:
	                        return '[το προηγούμενο] dddd [{}] LT';
	                    default:
	                        return '[την προηγούμενη] dddd [{}] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        calendar: function (key, mom) {
	            var output = this._calendarEl[key],
	                hours = mom && mom.hours();
	            if (isFunction(output)) {
	                output = output.apply(mom);
	            }
	            return output.replace('{}', hours % 12 === 1 ? 'στη' : 'στις');
	        },
	        relativeTime: {
	            future: 'σε %s',
	            past: '%s πριν',
	            s: 'λίγα δευτερόλεπτα',
	            ss: '%d δευτερόλεπτα',
	            m: 'ένα λεπτό',
	            mm: '%d λεπτά',
	            h: 'μία ώρα',
	            hh: '%d ώρες',
	            d: 'μία μέρα',
	            dd: '%d μέρες',
	            M: 'ένας μήνας',
	            MM: '%d μήνες',
	            y: 'ένας χρόνος',
	            yy: '%d χρόνια',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}η/,
	        ordinal: '%dη',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4st is the first week of the year.
	        },
	    });
	
	    return el;
	
	})));


/***/ },
/* 481 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Australia) [en-au]
	//! author : Jared Morse : https://github.com/jarcoal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enAu = moment.defineLocale('en-au', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                          ? 'st'
	                          : b === 2
	                            ? 'nd'
	                            : b === 3
	                              ? 'rd'
	                              : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enAu;
	
	})));


/***/ },
/* 482 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Canada) [en-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enCa = moment.defineLocale('en-ca', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'YYYY-MM-DD',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY h:mm A',
	            LLLL: 'dddd, MMMM D, YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                          ? 'st'
	                          : b === 2
	                            ? 'nd'
	                            : b === 3
	                              ? 'rd'
	                              : 'th';
	            return number + output;
	        },
	    });
	
	    return enCa;
	
	})));


/***/ },
/* 483 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (United Kingdom) [en-gb]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enGb = moment.defineLocale('en-gb', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                          ? 'st'
	                          : b === 2
	                            ? 'nd'
	                            : b === 3
	                              ? 'rd'
	                              : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enGb;
	
	})));


/***/ },
/* 484 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Ireland) [en-ie]
	//! author : Chris Cartlidge : https://github.com/chriscartlidge
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIe = moment.defineLocale('en-ie', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                          ? 'st'
	                          : b === 2
	                            ? 'nd'
	                            : b === 3
	                              ? 'rd'
	                              : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enIe;
	
	})));


/***/ },
/* 485 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Israel) [en-il]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIl = moment.defineLocale('en-il', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                          ? 'st'
	                          : b === 2
	                            ? 'nd'
	                            : b === 3
	                              ? 'rd'
	                              : 'th';
	            return number + output;
	        },
	    });
	
	    return enIl;
	
	})));


/***/ },
/* 486 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (India) [en-in]
	//! author : Jatin Agrawal : https://github.com/jatinag22
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIn = moment.defineLocale('en-in', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                          ? 'st'
	                          : b === 2
	                            ? 'nd'
	                            : b === 3
	                              ? 'rd'
	                              : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 1st is the first week of the year.
	        },
	    });
	
	    return enIn;
	
	})));


/***/ },
/* 487 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (New Zealand) [en-nz]
	//! author : Luke McGregor : https://github.com/lukemcgregor
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enNz = moment.defineLocale('en-nz', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                          ? 'st'
	                          : b === 2
	                            ? 'nd'
	                            : b === 3
	                              ? 'rd'
	                              : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enNz;
	
	})));


/***/ },
/* 488 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Singapore) [en-sg]
	//! author : Matthew Castrillon-Madrigal : https://github.com/techdimension
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enSg = moment.defineLocale('en-sg', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                          ? 'st'
	                          : b === 2
	                            ? 'nd'
	                            : b === 3
	                              ? 'rd'
	                              : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enSg;
	
	})));


/***/ },
/* 489 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Esperanto [eo]
	//! author : Colin Dean : https://github.com/colindean
	//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
	//! comment : miestasmia corrected the translation by colindean
	//! comment : Vivakvo corrected the translation by colindean and miestasmia
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var eo = moment.defineLocale('eo', {
	        months: 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mart_apr_maj_jun_jul_aŭg_sept_okt_nov_dec'.split('_'),
	        weekdays: 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
	        weekdaysShort: 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: '[la] D[-an de] MMMM, YYYY',
	            LLL: '[la] D[-an de] MMMM, YYYY HH:mm',
	            LLLL: 'dddd[n], [la] D[-an de] MMMM, YYYY HH:mm',
	            llll: 'ddd, [la] D[-an de] MMM, YYYY HH:mm',
	        },
	        meridiemParse: /[ap]\.t\.m/i,
	        isPM: function (input) {
	            return input.charAt(0).toLowerCase() === 'p';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'p.t.m.' : 'P.T.M.';
	            } else {
	                return isLower ? 'a.t.m.' : 'A.T.M.';
	            }
	        },
	        calendar: {
	            sameDay: '[Hodiaŭ je] LT',
	            nextDay: '[Morgaŭ je] LT',
	            nextWeek: 'dddd[n je] LT',
	            lastDay: '[Hieraŭ je] LT',
	            lastWeek: '[pasintan] dddd[n je] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'post %s',
	            past: 'antaŭ %s',
	            s: 'kelkaj sekundoj',
	            ss: '%d sekundoj',
	            m: 'unu minuto',
	            mm: '%d minutoj',
	            h: 'unu horo',
	            hh: '%d horoj',
	            d: 'unu tago', //ne 'diurno', ĉar estas uzita por proksimumo
	            dd: '%d tagoj',
	            M: 'unu monato',
	            MM: '%d monatoj',
	            y: 'unu jaro',
	            yy: '%d jaroj',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}a/,
	        ordinal: '%da',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return eo;
	
	})));


/***/ },
/* 490 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Dominican Republic) [es-do]
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot =
	            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	                '_'
	            ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex =
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esDo = moment.defineLocale('es-do', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex:
	            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return esDo;
	
	})));


/***/ },
/* 491 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Mexico) [es-mx]
	//! author : JC Franco : https://github.com/jcfranco
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot =
	            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	                '_'
	            ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex =
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esMx = moment.defineLocale('es-mx', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex:
	            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        invalidDate: 'Fecha inválida',
	    });
	
	    return esMx;
	
	})));


/***/ },
/* 492 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (United States) [es-us]
	//! author : bustta : https://github.com/bustta
	//! author : chrisrodz : https://github.com/chrisrodz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot =
	            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	                '_'
	            ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex =
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esUs = moment.defineLocale('es-us', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex:
	            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'MM/DD/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return esUs;
	
	})));


/***/ },
/* 493 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish [es]
	//! author : Julio Napurí : https://github.com/julionc
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot =
	            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	                '_'
	            ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex =
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var es = moment.defineLocale('es', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex:
	            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        invalidDate: 'Fecha inválida',
	    });
	
	    return es;
	
	})));


/***/ },
/* 494 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Estonian [et]
	//! author : Henry Kehlmann : https://github.com/madhenry
	//! improvements : Illimar Tambek : https://github.com/ragulka
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	            ss: [number + 'sekundi', number + 'sekundit'],
	            m: ['ühe minuti', 'üks minut'],
	            mm: [number + ' minuti', number + ' minutit'],
	            h: ['ühe tunni', 'tund aega', 'üks tund'],
	            hh: [number + ' tunni', number + ' tundi'],
	            d: ['ühe päeva', 'üks päev'],
	            M: ['kuu aja', 'kuu aega', 'üks kuu'],
	            MM: [number + ' kuu', number + ' kuud'],
	            y: ['ühe aasta', 'aasta', 'üks aasta'],
	            yy: [number + ' aasta', number + ' aastat'],
	        };
	        if (withoutSuffix) {
	            return format[key][2] ? format[key][2] : format[key][1];
	        }
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var et = moment.defineLocale('et', {
	        months: 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split(
	            '_'
	        ),
	        monthsShort:
	            'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
	        weekdays:
	            'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split(
	                '_'
	            ),
	        weekdaysShort: 'P_E_T_K_N_R_L'.split('_'),
	        weekdaysMin: 'P_E_T_K_N_R_L'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[Täna,] LT',
	            nextDay: '[Homme,] LT',
	            nextWeek: '[Järgmine] dddd LT',
	            lastDay: '[Eile,] LT',
	            lastWeek: '[Eelmine] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s pärast',
	            past: '%s tagasi',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: '%d päeva',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return et;
	
	})));


/***/ },
/* 495 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Basque [eu]
	//! author : Eneko Illarramendi : https://github.com/eillarra
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var eu = moment.defineLocale('eu', {
	        months: 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split(
	            '_'
	        ),
	        monthsShort:
	            'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split(
	                '_'
	            ),
	        weekdaysShort: 'ig._al._ar._az._og._ol._lr.'.split('_'),
	        weekdaysMin: 'ig_al_ar_az_og_ol_lr'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY[ko] MMMM[ren] D[a]',
	            LLL: 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	            LLLL: 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	            l: 'YYYY-M-D',
	            ll: 'YYYY[ko] MMM D[a]',
	            lll: 'YYYY[ko] MMM D[a] HH:mm',
	            llll: 'ddd, YYYY[ko] MMM D[a] HH:mm',
	        },
	        calendar: {
	            sameDay: '[gaur] LT[etan]',
	            nextDay: '[bihar] LT[etan]',
	            nextWeek: 'dddd LT[etan]',
	            lastDay: '[atzo] LT[etan]',
	            lastWeek: '[aurreko] dddd LT[etan]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s barru',
	            past: 'duela %s',
	            s: 'segundo batzuk',
	            ss: '%d segundo',
	            m: 'minutu bat',
	            mm: '%d minutu',
	            h: 'ordu bat',
	            hh: '%d ordu',
	            d: 'egun bat',
	            dd: '%d egun',
	            M: 'hilabete bat',
	            MM: '%d hilabete',
	            y: 'urte bat',
	            yy: '%d urte',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return eu;
	
	})));


/***/ },
/* 496 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Persian [fa]
	//! author : Ebrahim Byagowi : https://github.com/ebraminio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '۱',
	            2: '۲',
	            3: '۳',
	            4: '۴',
	            5: '۵',
	            6: '۶',
	            7: '۷',
	            8: '۸',
	            9: '۹',
	            0: '۰',
	        },
	        numberMap = {
	            '۱': '1',
	            '۲': '2',
	            '۳': '3',
	            '۴': '4',
	            '۵': '5',
	            '۶': '6',
	            '۷': '7',
	            '۸': '8',
	            '۹': '9',
	            '۰': '0',
	        };
	
	    var fa = moment.defineLocale('fa', {
	        months: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
	            '_'
	        ),
	        monthsShort:
	            'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
	                '_'
	            ),
	        weekdays:
	            'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
	                '_'
	            ),
	        weekdaysShort:
	            'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
	                '_'
	            ),
	        weekdaysMin: 'ی_د_س_چ_پ_ج_ش'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /قبل از ظهر|بعد از ظهر/,
	        isPM: function (input) {
	            return /بعد از ظهر/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'قبل از ظهر';
	            } else {
	                return 'بعد از ظهر';
	            }
	        },
	        calendar: {
	            sameDay: '[امروز ساعت] LT',
	            nextDay: '[فردا ساعت] LT',
	            nextWeek: 'dddd [ساعت] LT',
	            lastDay: '[دیروز ساعت] LT',
	            lastWeek: 'dddd [پیش] [ساعت] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'در %s',
	            past: '%s پیش',
	            s: 'چند ثانیه',
	            ss: '%d ثانیه',
	            m: 'یک دقیقه',
	            mm: '%d دقیقه',
	            h: 'یک ساعت',
	            hh: '%d ساعت',
	            d: 'یک روز',
	            dd: '%d روز',
	            M: 'یک ماه',
	            MM: '%d ماه',
	            y: 'یک سال',
	            yy: '%d سال',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[۰-۹]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}م/,
	        ordinal: '%dم',
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return fa;
	
	})));


/***/ },
/* 497 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Finnish [fi]
	//! author : Tarmo Aidantausta : https://github.com/bleadof
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var numbersPast =
	            'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(
	                ' '
	            ),
	        numbersFuture = [
	            'nolla',
	            'yhden',
	            'kahden',
	            'kolmen',
	            'neljän',
	            'viiden',
	            'kuuden',
	            numbersPast[7],
	            numbersPast[8],
	            numbersPast[9],
	        ];
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = '';
	        switch (key) {
	            case 's':
	                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	            case 'ss':
	                result = isFuture ? 'sekunnin' : 'sekuntia';
	                break;
	            case 'm':
	                return isFuture ? 'minuutin' : 'minuutti';
	            case 'mm':
	                result = isFuture ? 'minuutin' : 'minuuttia';
	                break;
	            case 'h':
	                return isFuture ? 'tunnin' : 'tunti';
	            case 'hh':
	                result = isFuture ? 'tunnin' : 'tuntia';
	                break;
	            case 'd':
	                return isFuture ? 'päivän' : 'päivä';
	            case 'dd':
	                result = isFuture ? 'päivän' : 'päivää';
	                break;
	            case 'M':
	                return isFuture ? 'kuukauden' : 'kuukausi';
	            case 'MM':
	                result = isFuture ? 'kuukauden' : 'kuukautta';
	                break;
	            case 'y':
	                return isFuture ? 'vuoden' : 'vuosi';
	            case 'yy':
	                result = isFuture ? 'vuoden' : 'vuotta';
	                break;
	        }
	        result = verbalNumber(number, isFuture) + ' ' + result;
	        return result;
	    }
	    function verbalNumber(number, isFuture) {
	        return number < 10
	            ? isFuture
	                ? numbersFuture[number]
	                : numbersPast[number]
	            : number;
	    }
	
	    var fi = moment.defineLocale('fi', {
	        months: 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split(
	            '_'
	        ),
	        monthsShort:
	            'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split(
	                '_'
	            ),
	        weekdays:
	            'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split(
	                '_'
	            ),
	        weekdaysShort: 'su_ma_ti_ke_to_pe_la'.split('_'),
	        weekdaysMin: 'su_ma_ti_ke_to_pe_la'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD.MM.YYYY',
	            LL: 'Do MMMM[ta] YYYY',
	            LLL: 'Do MMMM[ta] YYYY, [klo] HH.mm',
	            LLLL: 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	            l: 'D.M.YYYY',
	            ll: 'Do MMM YYYY',
	            lll: 'Do MMM YYYY, [klo] HH.mm',
	            llll: 'ddd, Do MMM YYYY, [klo] HH.mm',
	        },
	        calendar: {
	            sameDay: '[tänään] [klo] LT',
	            nextDay: '[huomenna] [klo] LT',
	            nextWeek: 'dddd [klo] LT',
	            lastDay: '[eilen] [klo] LT',
	            lastWeek: '[viime] dddd[na] [klo] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s päästä',
	            past: '%s sitten',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fi;
	
	})));


/***/ },
/* 498 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Filipino [fil]
	//! author : Dan Hagman : https://github.com/hagmandan
	//! author : Matthew Co : https://github.com/matthewdeeco
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var fil = moment.defineLocale('fil', {
	        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
	            '_'
	        ),
	        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
	            '_'
	        ),
	        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'MM/D/YYYY',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY HH:mm',
	            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: 'LT [ngayong araw]',
	            nextDay: '[Bukas ng] LT',
	            nextWeek: 'LT [sa susunod na] dddd',
	            lastDay: 'LT [kahapon]',
	            lastWeek: 'LT [noong nakaraang] dddd',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'sa loob ng %s',
	            past: '%s ang nakalipas',
	            s: 'ilang segundo',
	            ss: '%d segundo',
	            m: 'isang minuto',
	            mm: '%d minuto',
	            h: 'isang oras',
	            hh: '%d oras',
	            d: 'isang araw',
	            dd: '%d araw',
	            M: 'isang buwan',
	            MM: '%d buwan',
	            y: 'isang taon',
	            yy: '%d taon',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function (number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fil;
	
	})));


/***/ },
/* 499 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Faroese [fo]
	//! author : Ragnar Johannesen : https://github.com/ragnar123
	//! author : Kristian Sakarisson : https://github.com/sakarisson
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var fo = moment.defineLocale('fo', {
	        months: 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays:
	            'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split(
	                '_'
	            ),
	        weekdaysShort: 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	        weekdaysMin: 'su_má_tý_mi_hó_fr_le'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D. MMMM, YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Í dag kl.] LT',
	            nextDay: '[Í morgin kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[Í gjár kl.] LT',
	            lastWeek: '[síðstu] dddd [kl] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'um %s',
	            past: '%s síðani',
	            s: 'fá sekund',
	            ss: '%d sekundir',
	            m: 'ein minuttur',
	            mm: '%d minuttir',
	            h: 'ein tími',
	            hh: '%d tímar',
	            d: 'ein dagur',
	            dd: '%d dagar',
	            M: 'ein mánaður',
	            MM: '%d mánaðir',
	            y: 'eitt ár',
	            yy: '%d ár',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fo;
	
	})));


/***/ },
/* 500 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Canada) [fr-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var frCa = moment.defineLocale('fr-ca', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort:
	            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	    });
	
	    return frCa;
	
	})));


/***/ },
/* 501 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Switzerland) [fr-ch]
	//! author : Gaspard Bucher : https://github.com/gaspard
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var frCh = moment.defineLocale('fr-ch', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort:
	            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return frCh;
	
	})));


/***/ },
/* 502 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French [fr]
	//! author : John Fischer : https://github.com/jfroffice
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsStrictRegex =
	            /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
	        monthsShortStrictRegex =
	            /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?)/i,
	        monthsRegex =
	            /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
	        monthsParse = [
	            /^janv/i,
	            /^févr/i,
	            /^mars/i,
	            /^avr/i,
	            /^mai/i,
	            /^juin/i,
	            /^juil/i,
	            /^août/i,
	            /^sept/i,
	            /^oct/i,
	            /^nov/i,
	            /^déc/i,
	        ];
	
	    var fr = moment.defineLocale('fr', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort:
	            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	                '_'
	            ),
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: monthsStrictRegex,
	        monthsShortStrictRegex: monthsShortStrictRegex,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            w: 'une semaine',
	            ww: '%d semaines',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // TODO: Return 'e' when day of month > 1. Move this case inside
	                // block for masculine words below.
	                // See https://github.com/moment/moment/issues/3375
	                case 'D':
	                    return number + (number === 1 ? 'er' : '');
	
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fr;
	
	})));


/***/ },
/* 503 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Frisian [fy]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots =
	            'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'),
	        monthsShortWithoutDots =
	            'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');
	
	    var fy = moment.defineLocale('fy', {
	        months: 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	        monthsParseExact: true,
	        weekdays: 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split(
	            '_'
	        ),
	        weekdaysShort: 'si._mo._ti._wo._to._fr._so.'.split('_'),
	        weekdaysMin: 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[hjoed om] LT',
	            nextDay: '[moarn om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[juster om] LT',
	            lastWeek: '[ôfrûne] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'oer %s',
	            past: '%s lyn',
	            s: 'in pear sekonden',
	            ss: '%d sekonden',
	            m: 'ien minút',
	            mm: '%d minuten',
	            h: 'ien oere',
	            hh: '%d oeren',
	            d: 'ien dei',
	            dd: '%d dagen',
	            M: 'ien moanne',
	            MM: '%d moannen',
	            y: 'ien jier',
	            yy: '%d jierren',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fy;
	
	})));


/***/ },
/* 504 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Irish or Irish Gaelic [ga]
	//! author : André Silva : https://github.com/askpt
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'Eanáir',
	            'Feabhra',
	            'Márta',
	            'Aibreán',
	            'Bealtaine',
	            'Meitheamh',
	            'Iúil',
	            'Lúnasa',
	            'Meán Fómhair',
	            'Deireadh Fómhair',
	            'Samhain',
	            'Nollaig',
	        ],
	        monthsShort = [
	            'Ean',
	            'Feabh',
	            'Márt',
	            'Aib',
	            'Beal',
	            'Meith',
	            'Iúil',
	            'Lún',
	            'M.F.',
	            'D.F.',
	            'Samh',
	            'Noll',
	        ],
	        weekdays = [
	            'Dé Domhnaigh',
	            'Dé Luain',
	            'Dé Máirt',
	            'Dé Céadaoin',
	            'Déardaoin',
	            'Dé hAoine',
	            'Dé Sathairn',
	        ],
	        weekdaysShort = ['Domh', 'Luan', 'Máirt', 'Céad', 'Déar', 'Aoine', 'Sath'],
	        weekdaysMin = ['Do', 'Lu', 'Má', 'Cé', 'Dé', 'A', 'Sa'];
	
	    var ga = moment.defineLocale('ga', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsParseExact: true,
	        weekdays: weekdays,
	        weekdaysShort: weekdaysShort,
	        weekdaysMin: weekdaysMin,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Inniu ag] LT',
	            nextDay: '[Amárach ag] LT',
	            nextWeek: 'dddd [ag] LT',
	            lastDay: '[Inné ag] LT',
	            lastWeek: 'dddd [seo caite] [ag] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'i %s',
	            past: '%s ó shin',
	            s: 'cúpla soicind',
	            ss: '%d soicind',
	            m: 'nóiméad',
	            mm: '%d nóiméad',
	            h: 'uair an chloig',
	            hh: '%d uair an chloig',
	            d: 'lá',
	            dd: '%d lá',
	            M: 'mí',
	            MM: '%d míonna',
	            y: 'bliain',
	            yy: '%d bliain',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ga;
	
	})));


/***/ },
/* 505 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Scottish Gaelic [gd]
	//! author : Jon Ashdown : https://github.com/jonashdown
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'Am Faoilleach',
	            'An Gearran',
	            'Am Màrt',
	            'An Giblean',
	            'An Cèitean',
	            'An t-Ògmhios',
	            'An t-Iuchar',
	            'An Lùnastal',
	            'An t-Sultain',
	            'An Dàmhair',
	            'An t-Samhain',
	            'An Dùbhlachd',
	        ],
	        monthsShort = [
	            'Faoi',
	            'Gear',
	            'Màrt',
	            'Gibl',
	            'Cèit',
	            'Ògmh',
	            'Iuch',
	            'Lùn',
	            'Sult',
	            'Dàmh',
	            'Samh',
	            'Dùbh',
	        ],
	        weekdays = [
	            'Didòmhnaich',
	            'Diluain',
	            'Dimàirt',
	            'Diciadain',
	            'Diardaoin',
	            'Dihaoine',
	            'Disathairne',
	        ],
	        weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'],
	        weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
	
	    var gd = moment.defineLocale('gd', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsParseExact: true,
	        weekdays: weekdays,
	        weekdaysShort: weekdaysShort,
	        weekdaysMin: weekdaysMin,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[An-diugh aig] LT',
	            nextDay: '[A-màireach aig] LT',
	            nextWeek: 'dddd [aig] LT',
	            lastDay: '[An-dè aig] LT',
	            lastWeek: 'dddd [seo chaidh] [aig] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ann an %s',
	            past: 'bho chionn %s',
	            s: 'beagan diogan',
	            ss: '%d diogan',
	            m: 'mionaid',
	            mm: '%d mionaidean',
	            h: 'uair',
	            hh: '%d uairean',
	            d: 'latha',
	            dd: '%d latha',
	            M: 'mìos',
	            MM: '%d mìosan',
	            y: 'bliadhna',
	            yy: '%d bliadhna',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return gd;
	
	})));


/***/ },
/* 506 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Galician [gl]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var gl = moment.defineLocale('gl', {
	        months: 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split(
	            '_'
	        ),
	        monthsShort:
	            'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mé_xo_ve_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoxe ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañá ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT';
	            },
	            lastDay: function () {
	                return '[onte ' + (this.hours() !== 1 ? 'á' : 'a') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[o] dddd [pasado ' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (str) {
	                if (str.indexOf('un') === 0) {
	                    return 'n' + str;
	                }
	                return 'en ' + str;
	            },
	            past: 'hai %s',
	            s: 'uns segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'unha hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return gl;
	
	})));


/***/ },
/* 507 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Konkani Devanagari script [gom-deva]
	//! author : The Discoverer : https://github.com/WikiDiscoverer
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['थोडया सॅकंडांनी', 'थोडे सॅकंड'],
	            ss: [number + ' सॅकंडांनी', number + ' सॅकंड'],
	            m: ['एका मिणटान', 'एक मिनूट'],
	            mm: [number + ' मिणटांनी', number + ' मिणटां'],
	            h: ['एका वरान', 'एक वर'],
	            hh: [number + ' वरांनी', number + ' वरां'],
	            d: ['एका दिसान', 'एक दीस'],
	            dd: [number + ' दिसांनी', number + ' दीस'],
	            M: ['एका म्हयन्यान', 'एक म्हयनो'],
	            MM: [number + ' म्हयन्यानी', number + ' म्हयने'],
	            y: ['एका वर्सान', 'एक वर्स'],
	            yy: [number + ' वर्सांनी', number + ' वर्सां'],
	        };
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var gomDeva = moment.defineLocale('gom-deva', {
	        months: {
	            standalone:
	                'जानेवारी_फेब्रुवारी_मार्च_एप्रील_मे_जून_जुलय_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
	                    '_'
	                ),
	            format: 'जानेवारीच्या_फेब्रुवारीच्या_मार्चाच्या_एप्रीलाच्या_मेयाच्या_जूनाच्या_जुलयाच्या_ऑगस्टाच्या_सप्टेंबराच्या_ऑक्टोबराच्या_नोव्हेंबराच्या_डिसेंबराच्या'.split(
	                '_'
	            ),
	            isFormat: /MMMM(\s)+D[oD]?/,
	        },
	        monthsShort:
	            'जाने._फेब्रु._मार्च_एप्री._मे_जून_जुल._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'आयतार_सोमार_मंगळार_बुधवार_बिरेस्तार_सुक्रार_शेनवार'.split('_'),
	        weekdaysShort: 'आयत._सोम._मंगळ._बुध._ब्रेस्त._सुक्र._शेन.'.split('_'),
	        weekdaysMin: 'आ_सो_मं_बु_ब्रे_सु_शे'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'A h:mm [वाजतां]',
	            LTS: 'A h:mm:ss [वाजतां]',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY A h:mm [वाजतां]',
	            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [वाजतां]',
	            llll: 'ddd, D MMM YYYY, A h:mm [वाजतां]',
	        },
	        calendar: {
	            sameDay: '[आयज] LT',
	            nextDay: '[फाल्यां] LT',
	            nextWeek: '[फुडलो] dddd[,] LT',
	            lastDay: '[काल] LT',
	            lastWeek: '[फाटलो] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s',
	            past: '%s आदीं',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(वेर)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // the ordinal 'वेर' only applies to day of the month
	                case 'D':
	                    return number + 'वेर';
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                case 'w':
	                case 'W':
	                    return number;
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week
	            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
	        },
	        meridiemParse: /राती|सकाळीं|दनपारां|सांजे/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राती') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सकाळीं') {
	                return hour;
	            } else if (meridiem === 'दनपारां') {
	                return hour > 12 ? hour : hour + 12;
	            } else if (meridiem === 'सांजे') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'राती';
	            } else if (hour < 12) {
	                return 'सकाळीं';
	            } else if (hour < 16) {
	                return 'दनपारां';
	            } else if (hour < 20) {
	                return 'सांजे';
	            } else {
	                return 'राती';
	            }
	        },
	    });
	
	    return gomDeva;
	
	})));


/***/ },
/* 508 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Konkani Latin script [gom-latn]
	//! author : The Discoverer : https://github.com/WikiDiscoverer
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['thoddea sekondamni', 'thodde sekond'],
	            ss: [number + ' sekondamni', number + ' sekond'],
	            m: ['eka mintan', 'ek minut'],
	            mm: [number + ' mintamni', number + ' mintam'],
	            h: ['eka voran', 'ek vor'],
	            hh: [number + ' voramni', number + ' voram'],
	            d: ['eka disan', 'ek dis'],
	            dd: [number + ' disamni', number + ' dis'],
	            M: ['eka mhoinean', 'ek mhoino'],
	            MM: [number + ' mhoineamni', number + ' mhoine'],
	            y: ['eka vorsan', 'ek voros'],
	            yy: [number + ' vorsamni', number + ' vorsam'],
	        };
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var gomLatn = moment.defineLocale('gom-latn', {
	        months: {
	            standalone:
	                'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split(
	                    '_'
	                ),
	            format: 'Janerachea_Febrerachea_Marsachea_Abrilachea_Maiachea_Junachea_Julaiachea_Agostachea_Setembrachea_Otubrachea_Novembrachea_Dezembrachea'.split(
	                '_'
	            ),
	            isFormat: /MMMM(\s)+D[oD]?/,
	        },
	        monthsShort:
	            'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
	        monthsParseExact: true,
	        weekdays: "Aitar_Somar_Mongllar_Budhvar_Birestar_Sukrar_Son'var".split('_'),
	        weekdaysShort: 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
	        weekdaysMin: 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'A h:mm [vazta]',
	            LTS: 'A h:mm:ss [vazta]',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY A h:mm [vazta]',
	            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [vazta]',
	            llll: 'ddd, D MMM YYYY, A h:mm [vazta]',
	        },
	        calendar: {
	            sameDay: '[Aiz] LT',
	            nextDay: '[Faleam] LT',
	            nextWeek: '[Fuddlo] dddd[,] LT',
	            lastDay: '[Kal] LT',
	            lastWeek: '[Fattlo] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s',
	            past: '%s adim',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // the ordinal 'er' only applies to day of the month
	                case 'D':
	                    return number + 'er';
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                case 'w':
	                case 'W':
	                    return number;
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week
	            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
	        },
	        meridiemParse: /rati|sokallim|donparam|sanje/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'rati') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'sokallim') {
	                return hour;
	            } else if (meridiem === 'donparam') {
	                return hour > 12 ? hour : hour + 12;
	            } else if (meridiem === 'sanje') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'rati';
	            } else if (hour < 12) {
	                return 'sokallim';
	            } else if (hour < 16) {
	                return 'donparam';
	            } else if (hour < 20) {
	                return 'sanje';
	            } else {
	                return 'rati';
	            }
	        },
	    });
	
	    return gomLatn;
	
	})));


/***/ },
/* 509 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Gujarati [gu]
	//! author : Kaushik Thanki : https://github.com/Kaushik1987
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '૧',
	            2: '૨',
	            3: '૩',
	            4: '૪',
	            5: '૫',
	            6: '૬',
	            7: '૭',
	            8: '૮',
	            9: '૯',
	            0: '૦',
	        },
	        numberMap = {
	            '૧': '1',
	            '૨': '2',
	            '૩': '3',
	            '૪': '4',
	            '૫': '5',
	            '૬': '6',
	            '૭': '7',
	            '૮': '8',
	            '૯': '9',
	            '૦': '0',
	        };
	
	    var gu = moment.defineLocale('gu', {
	        months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split(
	            '_'
	        ),
	        monthsShort:
	            'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split(
	            '_'
	        ),
	        weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
	        weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm વાગ્યે',
	            LTS: 'A h:mm:ss વાગ્યે',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે',
	        },
	        calendar: {
	            sameDay: '[આજ] LT',
	            nextDay: '[કાલે] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ગઇકાલે] LT',
	            lastWeek: '[પાછલા] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s મા',
	            past: '%s પહેલા',
	            s: 'અમુક પળો',
	            ss: '%d સેકંડ',
	            m: 'એક મિનિટ',
	            mm: '%d મિનિટ',
	            h: 'એક કલાક',
	            hh: '%d કલાક',
	            d: 'એક દિવસ',
	            dd: '%d દિવસ',
	            M: 'એક મહિનો',
	            MM: '%d મહિનો',
	            y: 'એક વર્ષ',
	            yy: '%d વર્ષ',
	        },
	        preparse: function (string) {
	            return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
	        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'રાત') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'સવાર') {
	                return hour;
	            } else if (meridiem === 'બપોર') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'સાંજ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'રાત';
	            } else if (hour < 10) {
	                return 'સવાર';
	            } else if (hour < 17) {
	                return 'બપોર';
	            } else if (hour < 20) {
	                return 'સાંજ';
	            } else {
	                return 'રાત';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return gu;
	
	})));


/***/ },
/* 510 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hebrew [he]
	//! author : Tomer Cohen : https://github.com/tomer
	//! author : Moshe Simantov : https://github.com/DevelopmentIL
	//! author : Tal Ater : https://github.com/TalAter
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var he = moment.defineLocale('he', {
	        months: 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split(
	            '_'
	        ),
	        monthsShort:
	            'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
	        weekdays: 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	        weekdaysShort: 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	        weekdaysMin: 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [ב]MMMM YYYY',
	            LLL: 'D [ב]MMMM YYYY HH:mm',
	            LLLL: 'dddd, D [ב]MMMM YYYY HH:mm',
	            l: 'D/M/YYYY',
	            ll: 'D MMM YYYY',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd, D MMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[היום ב־]LT',
	            nextDay: '[מחר ב־]LT',
	            nextWeek: 'dddd [בשעה] LT',
	            lastDay: '[אתמול ב־]LT',
	            lastWeek: '[ביום] dddd [האחרון בשעה] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'בעוד %s',
	            past: 'לפני %s',
	            s: 'מספר שניות',
	            ss: '%d שניות',
	            m: 'דקה',
	            mm: '%d דקות',
	            h: 'שעה',
	            hh: function (number) {
	                if (number === 2) {
	                    return 'שעתיים';
	                }
	                return number + ' שעות';
	            },
	            d: 'יום',
	            dd: function (number) {
	                if (number === 2) {
	                    return 'יומיים';
	                }
	                return number + ' ימים';
	            },
	            M: 'חודש',
	            MM: function (number) {
	                if (number === 2) {
	                    return 'חודשיים';
	                }
	                return number + ' חודשים';
	            },
	            y: 'שנה',
	            yy: function (number) {
	                if (number === 2) {
	                    return 'שנתיים';
	                } else if (number % 10 === 0 && number !== 10) {
	                    return number + ' שנה';
	                }
	                return number + ' שנים';
	            },
	        },
	        meridiemParse:
	            /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	        isPM: function (input) {
	            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 5) {
	                return 'לפנות בוקר';
	            } else if (hour < 10) {
	                return 'בבוקר';
	            } else if (hour < 12) {
	                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	            } else if (hour < 18) {
	                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	            } else {
	                return 'בערב';
	            }
	        },
	    });
	
	    return he;
	
	})));


/***/ },
/* 511 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hindi [hi]
	//! author : Mayank Singhal : https://github.com/mayanksinghal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '१',
	            2: '२',
	            3: '३',
	            4: '४',
	            5: '५',
	            6: '६',
	            7: '७',
	            8: '८',
	            9: '९',
	            0: '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        },
	        monthsParse = [
	            /^जन/i,
	            /^फ़र|फर/i,
	            /^मार्च/i,
	            /^अप्रै/i,
	            /^मई/i,
	            /^जून/i,
	            /^जुल/i,
	            /^अग/i,
	            /^सितं|सित/i,
	            /^अक्टू/i,
	            /^नव|नवं/i,
	            /^दिसं|दिस/i,
	        ],
	        shortMonthsParse = [
	            /^जन/i,
	            /^फ़र/i,
	            /^मार्च/i,
	            /^अप्रै/i,
	            /^मई/i,
	            /^जून/i,
	            /^जुल/i,
	            /^अग/i,
	            /^सित/i,
	            /^अक्टू/i,
	            /^नव/i,
	            /^दिस/i,
	        ];
	
	    var hi = moment.defineLocale('hi', {
	        months: {
	            format: 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split(
	                '_'
	            ),
	            standalone:
	                'जनवरी_फरवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितंबर_अक्टूबर_नवंबर_दिसंबर'.split(
	                    '_'
	                ),
	        },
	        monthsShort:
	            'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
	        weekdays: 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort: 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm बजे',
	            LTS: 'A h:mm:ss बजे',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm बजे',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm बजे',
	        },
	
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: shortMonthsParse,
	
	        monthsRegex:
	            /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,
	
	        monthsShortRegex:
	            /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,
	
	        monthsStrictRegex:
	            /^(जनवरी?|फ़रवरी|फरवरी?|मार्च?|अप्रैल?|मई?|जून?|जुलाई?|अगस्त?|सितम्बर|सितंबर|सित?\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर?|दिसम्बर|दिसंबर?)/i,
	
	        monthsShortStrictRegex:
	            /^(जन\.?|फ़र\.?|मार्च?|अप्रै\.?|मई?|जून?|जुल\.?|अग\.?|सित\.?|अक्टू\.?|नव\.?|दिस\.?)/i,
	
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[कल] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[कल] LT',
	            lastWeek: '[पिछले] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s में',
	            past: '%s पहले',
	            s: 'कुछ ही क्षण',
	            ss: '%d सेकंड',
	            m: 'एक मिनट',
	            mm: '%d मिनट',
	            h: 'एक घंटा',
	            hh: '%d घंटे',
	            d: 'एक दिन',
	            dd: '%d दिन',
	            M: 'एक महीने',
	            MM: '%d महीने',
	            y: 'एक वर्ष',
	            yy: '%d वर्ष',
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	        meridiemParse: /रात|सुबह|दोपहर|शाम/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सुबह') {
	                return hour;
	            } else if (meridiem === 'दोपहर') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'शाम') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात';
	            } else if (hour < 10) {
	                return 'सुबह';
	            } else if (hour < 17) {
	                return 'दोपहर';
	            } else if (hour < 20) {
	                return 'शाम';
	            } else {
	                return 'रात';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return hi;
	
	})));


/***/ },
/* 512 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Croatian [hr]
	//! author : Bojan Marković : https://github.com/bmarkovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var hr = moment.defineLocale('hr', {
	        months: {
	            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split(
	                '_'
	            ),
	            standalone:
	                'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split(
	                    '_'
	                ),
	        },
	        monthsShort:
	            'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'Do MMMM YYYY',
	            LLL: 'Do MMMM YYYY H:mm',
	            LLLL: 'dddd, Do MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[jučer u] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[prošlu] [nedjelju] [u] LT';
	                    case 3:
	                        return '[prošlu] [srijedu] [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'par sekundi',
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: 'dan',
	            dd: translate,
	            M: 'mjesec',
	            MM: translate,
	            y: 'godinu',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return hr;
	
	})));


/***/ },
/* 513 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hungarian [hu]
	//! author : Adam Brunner : https://github.com/adambrunner
	//! author : Peter Viszt  : https://github.com/passatgt
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var weekEndings =
	        'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
	    function translate(number, withoutSuffix, key, isFuture) {
	        var num = number;
	        switch (key) {
	            case 's':
	                return isFuture || withoutSuffix
	                    ? 'néhány másodperc'
	                    : 'néhány másodperce';
	            case 'ss':
	                return num + (isFuture || withoutSuffix)
	                    ? ' másodperc'
	                    : ' másodperce';
	            case 'm':
	                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'mm':
	                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'h':
	                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'hh':
	                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'd':
	                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'dd':
	                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'M':
	                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'MM':
	                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'y':
	                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	            case 'yy':
	                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	        }
	        return '';
	    }
	    function week(isFuture) {
	        return (
	            (isFuture ? '' : '[múlt] ') +
	            '[' +
	            weekEndings[this.day()] +
	            '] LT[-kor]'
	        );
	    }
	
	    var hu = moment.defineLocale('hu', {
	        months: 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._márc._ápr._máj._jún._júl._aug._szept._okt._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	        weekdaysShort: 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	        weekdaysMin: 'v_h_k_sze_cs_p_szo'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'YYYY.MM.DD.',
	            LL: 'YYYY. MMMM D.',
	            LLL: 'YYYY. MMMM D. H:mm',
	            LLLL: 'YYYY. MMMM D., dddd H:mm',
	        },
	        meridiemParse: /de|du/i,
	        isPM: function (input) {
	            return input.charAt(1).toLowerCase() === 'u';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower === true ? 'de' : 'DE';
	            } else {
	                return isLower === true ? 'du' : 'DU';
	            }
	        },
	        calendar: {
	            sameDay: '[ma] LT[-kor]',
	            nextDay: '[holnap] LT[-kor]',
	            nextWeek: function () {
	                return week.call(this, true);
	            },
	            lastDay: '[tegnap] LT[-kor]',
	            lastWeek: function () {
	                return week.call(this, false);
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s múlva',
	            past: '%s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return hu;
	
	})));


/***/ },
/* 514 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Armenian [hy-am]
	//! author : Armendarabyan : https://github.com/armendarabyan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var hyAm = moment.defineLocale('hy-am', {
	        months: {
	            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split(
	                '_'
	            ),
	            standalone:
	                'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split(
	                    '_'
	                ),
	        },
	        monthsShort: 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	        weekdays:
	            'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split(
	                '_'
	            ),
	        weekdaysShort: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        weekdaysMin: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY թ.',
	            LLL: 'D MMMM YYYY թ., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY թ., HH:mm',
	        },
	        calendar: {
	            sameDay: '[այսօր] LT',
	            nextDay: '[վաղը] LT',
	            lastDay: '[երեկ] LT',
	            nextWeek: function () {
	                return 'dddd [օրը ժամը] LT';
	            },
	            lastWeek: function () {
	                return '[անցած] dddd [օրը ժամը] LT';
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s հետո',
	            past: '%s առաջ',
	            s: 'մի քանի վայրկյան',
	            ss: '%d վայրկյան',
	            m: 'րոպե',
	            mm: '%d րոպե',
	            h: 'ժամ',
	            hh: '%d ժամ',
	            d: 'օր',
	            dd: '%d օր',
	            M: 'ամիս',
	            MM: '%d ամիս',
	            y: 'տարի',
	            yy: '%d տարի',
	        },
	        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	        isPM: function (input) {
	            return /^(ցերեկվա|երեկոյան)$/.test(input);
	        },
	        meridiem: function (hour) {
	            if (hour < 4) {
	                return 'գիշերվա';
	            } else if (hour < 12) {
	                return 'առավոտվա';
	            } else if (hour < 17) {
	                return 'ցերեկվա';
	            } else {
	                return 'երեկոյան';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'DDD':
	                case 'w':
	                case 'W':
	                case 'DDDo':
	                    if (number === 1) {
	                        return number + '-ին';
	                    }
	                    return number + '-րդ';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return hyAm;
	
	})));


/***/ },
/* 515 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Indonesian [id]
	//! author : Mohammad Satrio Utomo : https://github.com/tyok
	//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var id = moment.defineLocale('id', {
	        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
	        weekdays: 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	        weekdaysShort: 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /pagi|siang|sore|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'siang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sore' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'siang';
	            } else if (hours < 19) {
	                return 'sore';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Besok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kemarin pukul] LT',
	            lastWeek: 'dddd [lalu pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lalu',
	            s: 'beberapa detik',
	            ss: '%d detik',
	            m: 'semenit',
	            mm: '%d menit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun',
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return id;
	
	})));


/***/ },
/* 516 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Icelandic [is]
	//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(n) {
	        if (n % 100 === 11) {
	            return true;
	        } else if (n % 10 === 1) {
	            return false;
	        }
	        return true;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture
	                    ? 'nokkrar sekúndur'
	                    : 'nokkrum sekúndum';
	            case 'ss':
	                if (plural(number)) {
	                    return (
	                        result +
	                        (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum')
	                    );
	                }
	                return result + 'sekúnda';
	            case 'm':
	                return withoutSuffix ? 'mínúta' : 'mínútu';
	            case 'mm':
	                if (plural(number)) {
	                    return (
	                        result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum')
	                    );
	                } else if (withoutSuffix) {
	                    return result + 'mínúta';
	                }
	                return result + 'mínútu';
	            case 'hh':
	                if (plural(number)) {
	                    return (
	                        result +
	                        (withoutSuffix || isFuture
	                            ? 'klukkustundir'
	                            : 'klukkustundum')
	                    );
	                }
	                return result + 'klukkustund';
	            case 'd':
	                if (withoutSuffix) {
	                    return 'dagur';
	                }
	                return isFuture ? 'dag' : 'degi';
	            case 'dd':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'dagar';
	                    }
	                    return result + (isFuture ? 'daga' : 'dögum');
	                } else if (withoutSuffix) {
	                    return result + 'dagur';
	                }
	                return result + (isFuture ? 'dag' : 'degi');
	            case 'M':
	                if (withoutSuffix) {
	                    return 'mánuður';
	                }
	                return isFuture ? 'mánuð' : 'mánuði';
	            case 'MM':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'mánuðir';
	                    }
	                    return result + (isFuture ? 'mánuði' : 'mánuðum');
	                } else if (withoutSuffix) {
	                    return result + 'mánuður';
	                }
	                return result + (isFuture ? 'mánuð' : 'mánuði');
	            case 'y':
	                return withoutSuffix || isFuture ? 'ár' : 'ári';
	            case 'yy':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	                }
	                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	        }
	    }
	
	    var is = moment.defineLocale('is', {
	        months: 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	        weekdays:
	            'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split(
	                '_'
	            ),
	        weekdaysShort: 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	        weekdaysMin: 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] H:mm',
	            LLLL: 'dddd, D. MMMM YYYY [kl.] H:mm',
	        },
	        calendar: {
	            sameDay: '[í dag kl.] LT',
	            nextDay: '[á morgun kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[í gær kl.] LT',
	            lastWeek: '[síðasta] dddd [kl.] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'eftir %s',
	            past: 'fyrir %s síðan',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: 'klukkustund',
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return is;
	
	})));


/***/ },
/* 517 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian (Switzerland) [it-ch]
	//! author : xfh : https://github.com/xfh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var itCh = moment.defineLocale('it-ch', {
	        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
	            '_'
	        ),
	        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
	            '_'
	        ),
	        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Oggi alle] LT',
	            nextDay: '[Domani alle] LT',
	            nextWeek: 'dddd [alle] LT',
	            lastDay: '[Ieri alle] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[la scorsa] dddd [alle] LT';
	                    default:
	                        return '[lo scorso] dddd [alle] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (s) {
	                return (/^[0-9].+$/.test(s) ? 'tra' : 'in') + ' ' + s;
	            },
	            past: '%s fa',
	            s: 'alcuni secondi',
	            ss: '%d secondi',
	            m: 'un minuto',
	            mm: '%d minuti',
	            h: "un'ora",
	            hh: '%d ore',
	            d: 'un giorno',
	            dd: '%d giorni',
	            M: 'un mese',
	            MM: '%d mesi',
	            y: 'un anno',
	            yy: '%d anni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return itCh;
	
	})));


/***/ },
/* 518 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian [it]
	//! author : Lorenzo : https://github.com/aliem
	//! author: Mattia Larentis: https://github.com/nostalgiaz
	//! author: Marco : https://github.com/Manfre98
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var it = moment.defineLocale('it', {
	        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
	            '_'
	        ),
	        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
	            '_'
	        ),
	        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return (
	                    '[Oggi a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            nextDay: function () {
	                return (
	                    '[Domani a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            nextWeek: function () {
	                return (
	                    'dddd [a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            lastDay: function () {
	                return (
	                    '[Ieri a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return (
	                            '[La scorsa] dddd [a' +
	                            (this.hours() > 1
	                                ? 'lle '
	                                : this.hours() === 0
	                                  ? ' '
	                                  : "ll'") +
	                            ']LT'
	                        );
	                    default:
	                        return (
	                            '[Lo scorso] dddd [a' +
	                            (this.hours() > 1
	                                ? 'lle '
	                                : this.hours() === 0
	                                  ? ' '
	                                  : "ll'") +
	                            ']LT'
	                        );
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'tra %s',
	            past: '%s fa',
	            s: 'alcuni secondi',
	            ss: '%d secondi',
	            m: 'un minuto',
	            mm: '%d minuti',
	            h: "un'ora",
	            hh: '%d ore',
	            d: 'un giorno',
	            dd: '%d giorni',
	            w: 'una settimana',
	            ww: '%d settimane',
	            M: 'un mese',
	            MM: '%d mesi',
	            y: 'un anno',
	            yy: '%d anni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return it;
	
	})));


/***/ },
/* 519 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Japanese [ja]
	//! author : LI Long : https://github.com/baryon
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ja = moment.defineLocale('ja', {
	        eras: [
	            {
	                since: '2019-05-01',
	                offset: 1,
	                name: '令和',
	                narrow: '㋿',
	                abbr: 'R',
	            },
	            {
	                since: '1989-01-08',
	                until: '2019-04-30',
	                offset: 1,
	                name: '平成',
	                narrow: '㍻',
	                abbr: 'H',
	            },
	            {
	                since: '1926-12-25',
	                until: '1989-01-07',
	                offset: 1,
	                name: '昭和',
	                narrow: '㍼',
	                abbr: 'S',
	            },
	            {
	                since: '1912-07-30',
	                until: '1926-12-24',
	                offset: 1,
	                name: '大正',
	                narrow: '㍽',
	                abbr: 'T',
	            },
	            {
	                since: '1873-01-01',
	                until: '1912-07-29',
	                offset: 6,
	                name: '明治',
	                narrow: '㍾',
	                abbr: 'M',
	            },
	            {
	                since: '0001-01-01',
	                until: '1873-12-31',
	                offset: 1,
	                name: '西暦',
	                narrow: 'AD',
	                abbr: 'AD',
	            },
	            {
	                since: '0000-12-31',
	                until: -Infinity,
	                offset: 1,
	                name: '紀元前',
	                narrow: 'BC',
	                abbr: 'BC',
	            },
	        ],
	        eraYearOrdinalRegex: /(元|\d+)年/,
	        eraYearOrdinalParse: function (input, match) {
	            return match[1] === '元' ? 1 : parseInt(match[1] || input, 10);
	        },
	        months: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	        weekdaysShort: '日_月_火_水_木_金_土'.split('_'),
	        weekdaysMin: '日_月_火_水_木_金_土'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日 dddd HH:mm',
	            l: 'YYYY/MM/DD',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日(ddd) HH:mm',
	        },
	        meridiemParse: /午前|午後/i,
	        isPM: function (input) {
	            return input === '午後';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return '午前';
	            } else {
	                return '午後';
	            }
	        },
	        calendar: {
	            sameDay: '[今日] LT',
	            nextDay: '[明日] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    return '[来週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            lastDay: '[昨日] LT',
	            lastWeek: function (now) {
	                if (this.week() !== now.week()) {
	                    return '[先週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}日/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'y':
	                    return number === 1 ? '元年' : number + '年';
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '数秒',
	            ss: '%d秒',
	            m: '1分',
	            mm: '%d分',
	            h: '1時間',
	            hh: '%d時間',
	            d: '1日',
	            dd: '%d日',
	            M: '1ヶ月',
	            MM: '%dヶ月',
	            y: '1年',
	            yy: '%d年',
	        },
	    });
	
	    return ja;
	
	})));


/***/ },
/* 520 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Javanese [jv]
	//! author : Rony Lantip : https://github.com/lantip
	//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var jv = moment.defineLocale('jv', {
	        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	        weekdays: 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	        weekdaysShort: 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /enjing|siyang|sonten|ndalu/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'enjing') {
	                return hour;
	            } else if (meridiem === 'siyang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'enjing';
	            } else if (hours < 15) {
	                return 'siyang';
	            } else if (hours < 19) {
	                return 'sonten';
	            } else {
	                return 'ndalu';
	            }
	        },
	        calendar: {
	            sameDay: '[Dinten puniko pukul] LT',
	            nextDay: '[Mbenjang pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kala wingi pukul] LT',
	            lastWeek: 'dddd [kepengker pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'wonten ing %s',
	            past: '%s ingkang kepengker',
	            s: 'sawetawis detik',
	            ss: '%d detik',
	            m: 'setunggal menit',
	            mm: '%d menit',
	            h: 'setunggal jam',
	            hh: '%d jam',
	            d: 'sedinten',
	            dd: '%d dinten',
	            M: 'sewulan',
	            MM: '%d wulan',
	            y: 'setaun',
	            yy: '%d taun',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return jv;
	
	})));


/***/ },
/* 521 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Georgian [ka]
	//! author : Irakli Janiashvili : https://github.com/IrakliJani
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ka = moment.defineLocale('ka', {
	        months: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split(
	            '_'
	        ),
	        monthsShort: 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	        weekdays: {
	            standalone:
	                'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split(
	                    '_'
	                ),
	            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split(
	                '_'
	            ),
	            isFormat: /(წინა|შემდეგ)/,
	        },
	        weekdaysShort: 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	        weekdaysMin: 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[დღეს] LT[-ზე]',
	            nextDay: '[ხვალ] LT[-ზე]',
	            lastDay: '[გუშინ] LT[-ზე]',
	            nextWeek: '[შემდეგ] dddd LT[-ზე]',
	            lastWeek: '[წინა] dddd LT-ზე',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (s) {
	                return s.replace(
	                    /(წამ|წუთ|საათ|წელ|დღ|თვ)(ი|ე)/,
	                    function ($0, $1, $2) {
	                        return $2 === 'ი' ? $1 + 'ში' : $1 + $2 + 'ში';
	                    }
	                );
	            },
	            past: function (s) {
	                if (/(წამი|წუთი|საათი|დღე|თვე)/.test(s)) {
	                    return s.replace(/(ი|ე)$/, 'ის წინ');
	                }
	                if (/წელი/.test(s)) {
	                    return s.replace(/წელი$/, 'წლის წინ');
	                }
	                return s;
	            },
	            s: 'რამდენიმე წამი',
	            ss: '%d წამი',
	            m: 'წუთი',
	            mm: '%d წუთი',
	            h: 'საათი',
	            hh: '%d საათი',
	            d: 'დღე',
	            dd: '%d დღე',
	            M: 'თვე',
	            MM: '%d თვე',
	            y: 'წელი',
	            yy: '%d წელი',
	        },
	        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	        ordinal: function (number) {
	            if (number === 0) {
	                return number;
	            }
	            if (number === 1) {
	                return number + '-ლი';
	            }
	            if (
	                number < 20 ||
	                (number <= 100 && number % 20 === 0) ||
	                number % 100 === 0
	            ) {
	                return 'მე-' + number;
	            }
	            return number + '-ე';
	        },
	        week: {
	            dow: 1,
	            doy: 7,
	        },
	    });
	
	    return ka;
	
	})));


/***/ },
/* 522 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kazakh [kk]
	//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        0: '-ші',
	        1: '-ші',
	        2: '-ші',
	        3: '-ші',
	        4: '-ші',
	        5: '-ші',
	        6: '-шы',
	        7: '-ші',
	        8: '-ші',
	        9: '-шы',
	        10: '-шы',
	        20: '-шы',
	        30: '-шы',
	        40: '-шы',
	        50: '-ші',
	        60: '-шы',
	        70: '-ші',
	        80: '-ші',
	        90: '-шы',
	        100: '-ші',
	    };
	
	    var kk = moment.defineLocale('kk', {
	        months: 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split(
	            '_'
	        ),
	        monthsShort: 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	        weekdays: 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split(
	            '_'
	        ),
	        weekdaysShort: 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	        weekdaysMin: 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Бүгін сағат] LT',
	            nextDay: '[Ертең сағат] LT',
	            nextWeek: 'dddd [сағат] LT',
	            lastDay: '[Кеше сағат] LT',
	            lastWeek: '[Өткен аптаның] dddd [сағат] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ішінде',
	            past: '%s бұрын',
	            s: 'бірнеше секунд',
	            ss: '%d секунд',
	            m: 'бір минут',
	            mm: '%d минут',
	            h: 'бір сағат',
	            hh: '%d сағат',
	            d: 'бір күн',
	            dd: '%d күн',
	            M: 'бір ай',
	            MM: '%d ай',
	            y: 'бір жыл',
	            yy: '%d жыл',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return kk;
	
	})));


/***/ },
/* 523 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Cambodian [km]
	//! author : Kruy Vanna : https://github.com/kruyvanna
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '១',
	            2: '២',
	            3: '៣',
	            4: '៤',
	            5: '៥',
	            6: '៦',
	            7: '៧',
	            8: '៨',
	            9: '៩',
	            0: '០',
	        },
	        numberMap = {
	            '១': '1',
	            '២': '2',
	            '៣': '3',
	            '៤': '4',
	            '៥': '5',
	            '៦': '6',
	            '៧': '7',
	            '៨': '8',
	            '៩': '9',
	            '០': '0',
	        };
	
	    var km = moment.defineLocale('km', {
	        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	            '_'
	        ),
	        monthsShort:
	            'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	                '_'
	            ),
	        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ព្រឹក|ល្ងាច/,
	        isPM: function (input) {
	            return input === 'ល្ងាច';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ព្រឹក';
	            } else {
	                return 'ល្ងាច';
	            }
	        },
	        calendar: {
	            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	            nextDay: '[ស្អែក ម៉ោង] LT',
	            nextWeek: 'dddd [ម៉ោង] LT',
	            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sទៀត',
	            past: '%sមុន',
	            s: 'ប៉ុន្មានវិនាទី',
	            ss: '%d វិនាទី',
	            m: 'មួយនាទី',
	            mm: '%d នាទី',
	            h: 'មួយម៉ោង',
	            hh: '%d ម៉ោង',
	            d: 'មួយថ្ងៃ',
	            dd: '%d ថ្ងៃ',
	            M: 'មួយខែ',
	            MM: '%d ខែ',
	            y: 'មួយឆ្នាំ',
	            yy: '%d ឆ្នាំ',
	        },
	        dayOfMonthOrdinalParse: /ទី\d{1,2}/,
	        ordinal: 'ទី%d',
	        preparse: function (string) {
	            return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return km;
	
	})));


/***/ },
/* 524 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kannada [kn]
	//! author : Rajeev Naik : https://github.com/rajeevnaikte
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '೧',
	            2: '೨',
	            3: '೩',
	            4: '೪',
	            5: '೫',
	            6: '೬',
	            7: '೭',
	            8: '೮',
	            9: '೯',
	            0: '೦',
	        },
	        numberMap = {
	            '೧': '1',
	            '೨': '2',
	            '೩': '3',
	            '೪': '4',
	            '೫': '5',
	            '೬': '6',
	            '೭': '7',
	            '೮': '8',
	            '೯': '9',
	            '೦': '0',
	        };
	
	    var kn = moment.defineLocale('kn', {
	        months: 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split(
	            '_'
	        ),
	        monthsShort:
	            'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split(
	            '_'
	        ),
	        weekdaysShort: 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
	        weekdaysMin: 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[ಇಂದು] LT',
	            nextDay: '[ನಾಳೆ] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ನಿನ್ನೆ] LT',
	            lastWeek: '[ಕೊನೆಯ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ನಂತರ',
	            past: '%s ಹಿಂದೆ',
	            s: 'ಕೆಲವು ಕ್ಷಣಗಳು',
	            ss: '%d ಸೆಕೆಂಡುಗಳು',
	            m: 'ಒಂದು ನಿಮಿಷ',
	            mm: '%d ನಿಮಿಷ',
	            h: 'ಒಂದು ಗಂಟೆ',
	            hh: '%d ಗಂಟೆ',
	            d: 'ಒಂದು ದಿನ',
	            dd: '%d ದಿನ',
	            M: 'ಒಂದು ತಿಂಗಳು',
	            MM: '%d ತಿಂಗಳು',
	            y: 'ಒಂದು ವರ್ಷ',
	            yy: '%d ವರ್ಷ',
	        },
	        preparse: function (string) {
	            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ರಾತ್ರಿ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
	                return hour;
	            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ಸಂಜೆ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ರಾತ್ರಿ';
	            } else if (hour < 10) {
	                return 'ಬೆಳಿಗ್ಗೆ';
	            } else if (hour < 17) {
	                return 'ಮಧ್ಯಾಹ್ನ';
	            } else if (hour < 20) {
	                return 'ಸಂಜೆ';
	            } else {
	                return 'ರಾತ್ರಿ';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
	        ordinal: function (number) {
	            return number + 'ನೇ';
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return kn;
	
	})));


/***/ },
/* 525 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Korean [ko]
	//! author : Kyungwook, Park : https://github.com/kyungw00k
	//! author : Jeeeyul Lee <jeeeyul@gmail.com>
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ko = moment.defineLocale('ko', {
	        months: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        monthsShort: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split(
	            '_'
	        ),
	        weekdays: '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	        weekdaysShort: '일_월_화_수_목_금_토'.split('_'),
	        weekdaysMin: '일_월_화_수_목_금_토'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'YYYY.MM.DD.',
	            LL: 'YYYY년 MMMM D일',
	            LLL: 'YYYY년 MMMM D일 A h:mm',
	            LLLL: 'YYYY년 MMMM D일 dddd A h:mm',
	            l: 'YYYY.MM.DD.',
	            ll: 'YYYY년 MMMM D일',
	            lll: 'YYYY년 MMMM D일 A h:mm',
	            llll: 'YYYY년 MMMM D일 dddd A h:mm',
	        },
	        calendar: {
	            sameDay: '오늘 LT',
	            nextDay: '내일 LT',
	            nextWeek: 'dddd LT',
	            lastDay: '어제 LT',
	            lastWeek: '지난주 dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s 후',
	            past: '%s 전',
	            s: '몇 초',
	            ss: '%d초',
	            m: '1분',
	            mm: '%d분',
	            h: '한 시간',
	            hh: '%d시간',
	            d: '하루',
	            dd: '%d일',
	            M: '한 달',
	            MM: '%d달',
	            y: '일 년',
	            yy: '%d년',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(일|월|주)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '일';
	                case 'M':
	                    return number + '월';
	                case 'w':
	                case 'W':
	                    return number + '주';
	                default:
	                    return number;
	            }
	        },
	        meridiemParse: /오전|오후/,
	        isPM: function (token) {
	            return token === '오후';
	        },
	        meridiem: function (hour, minute, isUpper) {
	            return hour < 12 ? '오전' : '오후';
	        },
	    });
	
	    return ko;
	
	})));


/***/ },
/* 526 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Northern Kurdish [ku-kmr]
	//! authors : Mazlum Özdogan : https://github.com/mergehez
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(num, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['çend sanîye', 'çend sanîyeyan'],
	            ss: [num + ' sanîye', num + ' sanîyeyan'],
	            m: ['deqîqeyek', 'deqîqeyekê'],
	            mm: [num + ' deqîqe', num + ' deqîqeyan'],
	            h: ['saetek', 'saetekê'],
	            hh: [num + ' saet', num + ' saetan'],
	            d: ['rojek', 'rojekê'],
	            dd: [num + ' roj', num + ' rojan'],
	            w: ['hefteyek', 'hefteyekê'],
	            ww: [num + ' hefte', num + ' hefteyan'],
	            M: ['mehek', 'mehekê'],
	            MM: [num + ' meh', num + ' mehan'],
	            y: ['salek', 'salekê'],
	            yy: [num + ' sal', num + ' salan'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	    // function obliqueNumSuffix(num) {
	    //     if(num.includes(':'))
	    //         num = parseInt(num.split(':')[0]);
	    //     else
	    //         num = parseInt(num);
	    //     return num == 0 || num % 10 == 1 ? 'ê'
	    //                         : (num > 10 && num % 10 == 0 ? 'î' : 'an');
	    // }
	    function ezafeNumSuffix(num) {
	        num = '' + num;
	        var l = num.substring(num.length - 1),
	            ll = num.length > 1 ? num.substring(num.length - 2) : '';
	        if (
	            !(ll == 12 || ll == 13) &&
	            (l == '2' || l == '3' || ll == '50' || l == '70' || l == '80')
	        )
	            return 'yê';
	        return 'ê';
	    }
	
	    var kuKmr = moment.defineLocale('ku-kmr', {
	        // According to the spelling rules defined by the work group of Weqfa Mezopotamyayê (Mesopotamia Foundation)
	        // this should be: 'Kanûna Paşîn_Sibat_Adar_Nîsan_Gulan_Hezîran_Tîrmeh_Tebax_Îlon_Çirîya Pêşîn_Çirîya Paşîn_Kanûna Pêşîn'
	        // But the names below are more well known and handy
	        months: 'Rêbendan_Sibat_Adar_Nîsan_Gulan_Hezîran_Tîrmeh_Tebax_Îlon_Cotmeh_Mijdar_Berfanbar'.split(
	            '_'
	        ),
	        monthsShort: 'Rêb_Sib_Ada_Nîs_Gul_Hez_Tîr_Teb_Îlo_Cot_Mij_Ber'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'Yekşem_Duşem_Sêşem_Çarşem_Pêncşem_În_Şemî'.split('_'),
	        weekdaysShort: 'Yek_Du_Sê_Çar_Pên_În_Şem'.split('_'),
	        weekdaysMin: 'Ye_Du_Sê_Ça_Pê_În_Şe'.split('_'),
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'bn' : 'BN';
	            } else {
	                return isLower ? 'pn' : 'PN';
	            }
	        },
	        meridiemParse: /bn|BN|pn|PN/,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'Do MMMM[a] YYYY[an]',
	            LLL: 'Do MMMM[a] YYYY[an] HH:mm',
	            LLLL: 'dddd, Do MMMM[a] YYYY[an] HH:mm',
	            ll: 'Do MMM[.] YYYY[an]',
	            lll: 'Do MMM[.] YYYY[an] HH:mm',
	            llll: 'ddd[.], Do MMM[.] YYYY[an] HH:mm',
	        },
	        calendar: {
	            sameDay: '[Îro di saet] LT [de]',
	            nextDay: '[Sibê di saet] LT [de]',
	            nextWeek: 'dddd [di saet] LT [de]',
	            lastDay: '[Duh di saet] LT [de]',
	            lastWeek: 'dddd[a borî di saet] LT [de]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'di %s de',
	            past: 'berî %s',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(?:yê|ê|\.)/,
	        ordinal: function (num, period) {
	            var p = period.toLowerCase();
	            if (p.includes('w') || p.includes('m')) return num + '.';
	
	            return num + ezafeNumSuffix(num);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return kuKmr;
	
	})));


/***/ },
/* 527 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kurdish [ku]
	//! author : Shahram Mebashar : https://github.com/ShahramMebashar
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '١',
	            2: '٢',
	            3: '٣',
	            4: '٤',
	            5: '٥',
	            6: '٦',
	            7: '٧',
	            8: '٨',
	            9: '٩',
	            0: '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        },
	        months = [
	            'کانونی دووەم',
	            'شوبات',
	            'ئازار',
	            'نیسان',
	            'ئایار',
	            'حوزەیران',
	            'تەمموز',
	            'ئاب',
	            'ئەیلوول',
	            'تشرینی یەكەم',
	            'تشرینی دووەم',
	            'كانونی یەکەم',
	        ];
	
	    var ku = moment.defineLocale('ku', {
	        months: months,
	        monthsShort: months,
	        weekdays:
	            'یه‌كشه‌ممه‌_دووشه‌ممه‌_سێشه‌ممه‌_چوارشه‌ممه‌_پێنجشه‌ممه‌_هه‌ینی_شه‌ممه‌'.split(
	                '_'
	            ),
	        weekdaysShort:
	            'یه‌كشه‌م_دووشه‌م_سێشه‌م_چوارشه‌م_پێنجشه‌م_هه‌ینی_شه‌ممه‌'.split('_'),
	        weekdaysMin: 'ی_د_س_چ_پ_ه_ش'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ئێواره‌|به‌یانی/,
	        isPM: function (input) {
	            return /ئێواره‌/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'به‌یانی';
	            } else {
	                return 'ئێواره‌';
	            }
	        },
	        calendar: {
	            sameDay: '[ئه‌مرۆ كاتژمێر] LT',
	            nextDay: '[به‌یانی كاتژمێر] LT',
	            nextWeek: 'dddd [كاتژمێر] LT',
	            lastDay: '[دوێنێ كاتژمێر] LT',
	            lastWeek: 'dddd [كاتژمێر] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'له‌ %s',
	            past: '%s',
	            s: 'چه‌ند چركه‌یه‌ك',
	            ss: 'چركه‌ %d',
	            m: 'یه‌ك خوله‌ك',
	            mm: '%d خوله‌ك',
	            h: 'یه‌ك كاتژمێر',
	            hh: '%d كاتژمێر',
	            d: 'یه‌ك ڕۆژ',
	            dd: '%d ڕۆژ',
	            M: 'یه‌ك مانگ',
	            MM: '%d مانگ',
	            y: 'یه‌ك ساڵ',
	            yy: '%d ساڵ',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return ku;
	
	})));


/***/ },
/* 528 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kyrgyz [ky]
	//! author : Chyngyz Arystan uulu : https://github.com/chyngyz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        0: '-чү',
	        1: '-чи',
	        2: '-чи',
	        3: '-чү',
	        4: '-чү',
	        5: '-чи',
	        6: '-чы',
	        7: '-чи',
	        8: '-чи',
	        9: '-чу',
	        10: '-чу',
	        20: '-чы',
	        30: '-чу',
	        40: '-чы',
	        50: '-чү',
	        60: '-чы',
	        70: '-чи',
	        80: '-чи',
	        90: '-чу',
	        100: '-чү',
	    };
	
	    var ky = moment.defineLocale('ky', {
	        months: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
	            '_'
	        ),
	        monthsShort: 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split(
	            '_'
	        ),
	        weekdays: 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split(
	            '_'
	        ),
	        weekdaysShort: 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	        weekdaysMin: 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Бүгүн саат] LT',
	            nextDay: '[Эртең саат] LT',
	            nextWeek: 'dddd [саат] LT',
	            lastDay: '[Кечээ саат] LT',
	            lastWeek: '[Өткөн аптанын] dddd [күнү] [саат] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ичинде',
	            past: '%s мурун',
	            s: 'бирнече секунд',
	            ss: '%d секунд',
	            m: 'бир мүнөт',
	            mm: '%d мүнөт',
	            h: 'бир саат',
	            hh: '%d саат',
	            d: 'бир күн',
	            dd: '%d күн',
	            M: 'бир ай',
	            MM: '%d ай',
	            y: 'бир жыл',
	            yy: '%d жыл',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return ky;
	
	})));


/***/ },
/* 529 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Luxembourgish [lb]
	//! author : mweimerskirch : https://github.com/mweimerskirch
	//! author : David Raison : https://github.com/kwisatz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eng Minutt', 'enger Minutt'],
	            h: ['eng Stonn', 'enger Stonn'],
	            d: ['een Dag', 'engem Dag'],
	            M: ['ee Mount', 'engem Mount'],
	            y: ['ee Joer', 'engem Joer'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	    function processFutureTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'a ' + string;
	        }
	        return 'an ' + string;
	    }
	    function processPastTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'viru ' + string;
	        }
	        return 'virun ' + string;
	    }
	    /**
	     * Returns true if the word before the given number loses the '-n' ending.
	     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	     *
	     * @param number {integer}
	     * @returns {boolean}
	     */
	    function eifelerRegelAppliesToNumber(number) {
	        number = parseInt(number, 10);
	        if (isNaN(number)) {
	            return false;
	        }
	        if (number < 0) {
	            // Negative Number --> always true
	            return true;
	        } else if (number < 10) {
	            // Only 1 digit
	            if (4 <= number && number <= 7) {
	                return true;
	            }
	            return false;
	        } else if (number < 100) {
	            // 2 digits
	            var lastDigit = number % 10,
	                firstDigit = number / 10;
	            if (lastDigit === 0) {
	                return eifelerRegelAppliesToNumber(firstDigit);
	            }
	            return eifelerRegelAppliesToNumber(lastDigit);
	        } else if (number < 10000) {
	            // 3 or 4 digits --> recursively check first digit
	            while (number >= 10) {
	                number = number / 10;
	            }
	            return eifelerRegelAppliesToNumber(number);
	        } else {
	            // Anything larger than 4 digits: recursively check first n-3 digits
	            number = number / 1000;
	            return eifelerRegelAppliesToNumber(number);
	        }
	    }
	
	    var lb = moment.defineLocale('lb', {
	        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort:
	            'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split(
	                '_'
	            ),
	        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm [Auer]',
	            LTS: 'H:mm:ss [Auer]',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm [Auer]',
	            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]',
	        },
	        calendar: {
	            sameDay: '[Haut um] LT',
	            sameElse: 'L',
	            nextDay: '[Muer um] LT',
	            nextWeek: 'dddd [um] LT',
	            lastDay: '[Gëschter um] LT',
	            lastWeek: function () {
	                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	                switch (this.day()) {
	                    case 2:
	                    case 4:
	                        return '[Leschten] dddd [um] LT';
	                    default:
	                        return '[Leschte] dddd [um] LT';
	                }
	            },
	        },
	        relativeTime: {
	            future: processFutureTime,
	            past: processPastTime,
	            s: 'e puer Sekonnen',
	            ss: '%d Sekonnen',
	            m: processRelativeTime,
	            mm: '%d Minutten',
	            h: processRelativeTime,
	            hh: '%d Stonnen',
	            d: processRelativeTime,
	            dd: '%d Deeg',
	            M: processRelativeTime,
	            MM: '%d Méint',
	            y: processRelativeTime,
	            yy: '%d Joer',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lb;
	
	})));


/***/ },
/* 530 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lao [lo]
	//! author : Ryan Hart : https://github.com/ryanhart2
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var lo = moment.defineLocale('lo', {
	        months: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
	            '_'
	        ),
	        monthsShort:
	            'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
	                '_'
	            ),
	        weekdays: 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysShort: 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysMin: 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'ວັນdddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	        isPM: function (input) {
	            return input === 'ຕອນແລງ';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ຕອນເຊົ້າ';
	            } else {
	                return 'ຕອນແລງ';
	            }
	        },
	        calendar: {
	            sameDay: '[ມື້ນີ້ເວລາ] LT',
	            nextDay: '[ມື້ອື່ນເວລາ] LT',
	            nextWeek: '[ວັນ]dddd[ໜ້າເວລາ] LT',
	            lastDay: '[ມື້ວານນີ້ເວລາ] LT',
	            lastWeek: '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ອີກ %s',
	            past: '%sຜ່ານມາ',
	            s: 'ບໍ່ເທົ່າໃດວິນາທີ',
	            ss: '%d ວິນາທີ',
	            m: '1 ນາທີ',
	            mm: '%d ນາທີ',
	            h: '1 ຊົ່ວໂມງ',
	            hh: '%d ຊົ່ວໂມງ',
	            d: '1 ມື້',
	            dd: '%d ມື້',
	            M: '1 ເດືອນ',
	            MM: '%d ເດືອນ',
	            y: '1 ປີ',
	            yy: '%d ປີ',
	        },
	        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
	        ordinal: function (number) {
	            return 'ທີ່' + number;
	        },
	    });
	
	    return lo;
	
	})));


/***/ },
/* 531 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lithuanian [lt]
	//! author : Mindaugas Mozūras : https://github.com/mmozuras
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var units = {
	        ss: 'sekundė_sekundžių_sekundes',
	        m: 'minutė_minutės_minutę',
	        mm: 'minutės_minučių_minutes',
	        h: 'valanda_valandos_valandą',
	        hh: 'valandos_valandų_valandas',
	        d: 'diena_dienos_dieną',
	        dd: 'dienos_dienų_dienas',
	        M: 'mėnuo_mėnesio_mėnesį',
	        MM: 'mėnesiai_mėnesių_mėnesius',
	        y: 'metai_metų_metus',
	        yy: 'metai_metų_metus',
	    };
	    function translateSeconds(number, withoutSuffix, key, isFuture) {
	        if (withoutSuffix) {
	            return 'kelios sekundės';
	        } else {
	            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	        }
	    }
	    function translateSingular(number, withoutSuffix, key, isFuture) {
	        return withoutSuffix
	            ? forms(key)[0]
	            : isFuture
	              ? forms(key)[1]
	              : forms(key)[2];
	    }
	    function special(number) {
	        return number % 10 === 0 || (number > 10 && number < 20);
	    }
	    function forms(key) {
	        return units[key].split('_');
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        if (number === 1) {
	            return (
	                result + translateSingular(number, withoutSuffix, key[0], isFuture)
	            );
	        } else if (withoutSuffix) {
	            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	        } else {
	            if (isFuture) {
	                return result + forms(key)[1];
	            } else {
	                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	            }
	        }
	    }
	    var lt = moment.defineLocale('lt', {
	        months: {
	            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split(
	                '_'
	            ),
	            standalone:
	                'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split(
	                    '_'
	                ),
	            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/,
	        },
	        monthsShort: 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	        weekdays: {
	            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split(
	                '_'
	            ),
	            standalone:
	                'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split(
	                    '_'
	                ),
	            isFormat: /dddd HH:mm/,
	        },
	        weekdaysShort: 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	        weekdaysMin: 'S_P_A_T_K_Pn_Š'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY [m.] MMMM D [d.]',
	            LLL: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            LLLL: 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	            l: 'YYYY-MM-DD',
	            ll: 'YYYY [m.] MMMM D [d.]',
	            lll: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            llll: 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]',
	        },
	        calendar: {
	            sameDay: '[Šiandien] LT',
	            nextDay: '[Rytoj] LT',
	            nextWeek: 'dddd LT',
	            lastDay: '[Vakar] LT',
	            lastWeek: '[Praėjusį] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'po %s',
	            past: 'prieš %s',
	            s: translateSeconds,
	            ss: translate,
	            m: translateSingular,
	            mm: translate,
	            h: translateSingular,
	            hh: translate,
	            d: translateSingular,
	            dd: translate,
	            M: translateSingular,
	            MM: translate,
	            y: translateSingular,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
	        ordinal: function (number) {
	            return number + '-oji';
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lt;
	
	})));


/***/ },
/* 532 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Latvian [lv]
	//! author : Kristaps Karlsons : https://github.com/skakri
	//! author : Jānis Elmeris : https://github.com/JanisE
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var units = {
	        ss: 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
	        m: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        mm: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        h: 'stundas_stundām_stunda_stundas'.split('_'),
	        hh: 'stundas_stundām_stunda_stundas'.split('_'),
	        d: 'dienas_dienām_diena_dienas'.split('_'),
	        dd: 'dienas_dienām_diena_dienas'.split('_'),
	        M: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        MM: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        y: 'gada_gadiem_gads_gadi'.split('_'),
	        yy: 'gada_gadiem_gads_gadi'.split('_'),
	    };
	    /**
	     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	     */
	    function format(forms, number, withoutSuffix) {
	        if (withoutSuffix) {
	            // E.g. "21 minūte", "3 minūtes".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
	        } else {
	            // E.g. "21 minūtes" as in "pēc 21 minūtes".
	            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
	        }
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        return number + ' ' + format(units[key], number, withoutSuffix);
	    }
	    function relativeTimeWithSingular(number, withoutSuffix, key) {
	        return format(units[key], number, withoutSuffix);
	    }
	    function relativeSeconds(number, withoutSuffix) {
	        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	    }
	
	    var lv = moment.defineLocale('lv', {
	        months: 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	        weekdays:
	            'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split(
	                '_'
	            ),
	        weekdaysShort: 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysMin: 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY.',
	            LL: 'YYYY. [gada] D. MMMM',
	            LLL: 'YYYY. [gada] D. MMMM, HH:mm',
	            LLLL: 'YYYY. [gada] D. MMMM, dddd, HH:mm',
	        },
	        calendar: {
	            sameDay: '[Šodien pulksten] LT',
	            nextDay: '[Rīt pulksten] LT',
	            nextWeek: 'dddd [pulksten] LT',
	            lastDay: '[Vakar pulksten] LT',
	            lastWeek: '[Pagājušā] dddd [pulksten] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'pēc %s',
	            past: 'pirms %s',
	            s: relativeSeconds,
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithSingular,
	            mm: relativeTimeWithPlural,
	            h: relativeTimeWithSingular,
	            hh: relativeTimeWithPlural,
	            d: relativeTimeWithSingular,
	            dd: relativeTimeWithPlural,
	            M: relativeTimeWithSingular,
	            MM: relativeTimeWithPlural,
	            y: relativeTimeWithSingular,
	            yy: relativeTimeWithPlural,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lv;
	
	})));


/***/ },
/* 533 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Montenegrin [me]
	//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['sekund', 'sekunda', 'sekundi'],
	            m: ['jedan minut', 'jednog minuta'],
	            mm: ['minut', 'minuta', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mjesec', 'mjeseca', 'mjeseci'],
	            yy: ['godina', 'godine', 'godina'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1
	                ? wordKey[0]
	                : number >= 2 && number <= 4
	                  ? wordKey[1]
	                  : wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return (
	                    number +
	                    ' ' +
	                    translator.correctGrammaticalCase(number, wordKey)
	                );
	            }
	        },
	    };
	
	    var me = moment.defineLocale('me', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sjutra u] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[juče u] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[prošle] [nedjelje] [u] LT',
	                    '[prošlog] [ponedjeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srijede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'nekoliko sekundi',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: 'dan',
	            dd: translator.translate,
	            M: 'mjesec',
	            MM: translator.translate,
	            y: 'godinu',
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return me;
	
	})));


/***/ },
/* 534 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maori [mi]
	//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var mi = moment.defineLocale('mi', {
	        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split(
	            '_'
	        ),
	        monthsShort:
	            'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split(
	                '_'
	            ),
	        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
	        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
	        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [i] HH:mm',
	            LLLL: 'dddd, D MMMM YYYY [i] HH:mm',
	        },
	        calendar: {
	            sameDay: '[i teie mahana, i] LT',
	            nextDay: '[apopo i] LT',
	            nextWeek: 'dddd [i] LT',
	            lastDay: '[inanahi i] LT',
	            lastWeek: 'dddd [whakamutunga i] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'i roto i %s',
	            past: '%s i mua',
	            s: 'te hēkona ruarua',
	            ss: '%d hēkona',
	            m: 'he meneti',
	            mm: '%d meneti',
	            h: 'te haora',
	            hh: '%d haora',
	            d: 'he ra',
	            dd: '%d ra',
	            M: 'he marama',
	            MM: '%d marama',
	            y: 'he tau',
	            yy: '%d tau',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return mi;
	
	})));


/***/ },
/* 535 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Macedonian [mk]
	//! author : Borislav Mickov : https://github.com/B0k0
	//! author : Sashko Todorov : https://github.com/bkyceh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var mk = moment.defineLocale('mk', {
	        months: 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split(
	            '_'
	        ),
	        monthsShort: 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays: 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split(
	            '_'
	        ),
	        weekdaysShort: 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	        weekdaysMin: 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[Денес во] LT',
	            nextDay: '[Утре во] LT',
	            nextWeek: '[Во] dddd [во] LT',
	            lastDay: '[Вчера во] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[Изминатата] dddd [во] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[Изминатиот] dddd [во] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: 'пред %s',
	            s: 'неколку секунди',
	            ss: '%d секунди',
	            m: 'една минута',
	            mm: '%d минути',
	            h: 'еден час',
	            hh: '%d часа',
	            d: 'еден ден',
	            dd: '%d дена',
	            M: 'еден месец',
	            MM: '%d месеци',
	            y: 'една година',
	            yy: '%d години',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal: function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return mk;
	
	})));


/***/ },
/* 536 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malayalam [ml]
	//! author : Floyd Pink : https://github.com/floydpink
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ml = moment.defineLocale('ml', {
	        months: 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split(
	            '_'
	        ),
	        monthsShort:
	            'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split(
	                '_'
	            ),
	        weekdaysShort: 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	        weekdaysMin: 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm -നു',
	            LTS: 'A h:mm:ss -നു',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm -നു',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm -നു',
	        },
	        calendar: {
	            sameDay: '[ഇന്ന്] LT',
	            nextDay: '[നാളെ] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ഇന്നലെ] LT',
	            lastWeek: '[കഴിഞ്ഞ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s കഴിഞ്ഞ്',
	            past: '%s മുൻപ്',
	            s: 'അൽപ നിമിഷങ്ങൾ',
	            ss: '%d സെക്കൻഡ്',
	            m: 'ഒരു മിനിറ്റ്',
	            mm: '%d മിനിറ്റ്',
	            h: 'ഒരു മണിക്കൂർ',
	            hh: '%d മണിക്കൂർ',
	            d: 'ഒരു ദിവസം',
	            dd: '%d ദിവസം',
	            M: 'ഒരു മാസം',
	            MM: '%d മാസം',
	            y: 'ഒരു വർഷം',
	            yy: '%d വർഷം',
	        },
	        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'രാത്രി' && hour >= 4) ||
	                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                meridiem === 'വൈകുന്നേരം'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'രാത്രി';
	            } else if (hour < 12) {
	                return 'രാവിലെ';
	            } else if (hour < 17) {
	                return 'ഉച്ച കഴിഞ്ഞ്';
	            } else if (hour < 20) {
	                return 'വൈകുന്നേരം';
	            } else {
	                return 'രാത്രി';
	            }
	        },
	    });
	
	    return ml;
	
	})));


/***/ },
/* 537 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Mongolian [mn]
	//! author : Javkhlantugs Nyamdorj : https://github.com/javkhaanj7
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function translate(number, withoutSuffix, key, isFuture) {
	        switch (key) {
	            case 's':
	                return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын';
	            case 'ss':
	                return number + (withoutSuffix ? ' секунд' : ' секундын');
	            case 'm':
	            case 'mm':
	                return number + (withoutSuffix ? ' минут' : ' минутын');
	            case 'h':
	            case 'hh':
	                return number + (withoutSuffix ? ' цаг' : ' цагийн');
	            case 'd':
	            case 'dd':
	                return number + (withoutSuffix ? ' өдөр' : ' өдрийн');
	            case 'M':
	            case 'MM':
	                return number + (withoutSuffix ? ' сар' : ' сарын');
	            case 'y':
	            case 'yy':
	                return number + (withoutSuffix ? ' жил' : ' жилийн');
	            default:
	                return number;
	        }
	    }
	
	    var mn = moment.defineLocale('mn', {
	        months: 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split(
	            '_'
	        ),
	        monthsShort:
	            '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
	        weekdaysShort: 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
	        weekdaysMin: 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY оны MMMMын D',
	            LLL: 'YYYY оны MMMMын D HH:mm',
	            LLLL: 'dddd, YYYY оны MMMMын D HH:mm',
	        },
	        meridiemParse: /ҮӨ|ҮХ/i,
	        isPM: function (input) {
	            return input === 'ҮХ';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ҮӨ';
	            } else {
	                return 'ҮХ';
	            }
	        },
	        calendar: {
	            sameDay: '[Өнөөдөр] LT',
	            nextDay: '[Маргааш] LT',
	            nextWeek: '[Ирэх] dddd LT',
	            lastDay: '[Өчигдөр] LT',
	            lastWeek: '[Өнгөрсөн] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s дараа',
	            past: '%s өмнө',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + ' өдөр';
	                default:
	                    return number;
	            }
	        },
	    });
	
	    return mn;
	
	})));


/***/ },
/* 538 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Marathi [mr]
	//! author : Harshad Kale : https://github.com/kalehv
	//! author : Vivek Athalye : https://github.com/vnathalye
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '१',
	            2: '२',
	            3: '३',
	            4: '४',
	            5: '५',
	            6: '६',
	            7: '७',
	            8: '८',
	            9: '९',
	            0: '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        };
	
	    function relativeTimeMr(number, withoutSuffix, string, isFuture) {
	        var output = '';
	        if (withoutSuffix) {
	            switch (string) {
	                case 's':
	                    output = 'काही सेकंद';
	                    break;
	                case 'ss':
	                    output = '%d सेकंद';
	                    break;
	                case 'm':
	                    output = 'एक मिनिट';
	                    break;
	                case 'mm':
	                    output = '%d मिनिटे';
	                    break;
	                case 'h':
	                    output = 'एक तास';
	                    break;
	                case 'hh':
	                    output = '%d तास';
	                    break;
	                case 'd':
	                    output = 'एक दिवस';
	                    break;
	                case 'dd':
	                    output = '%d दिवस';
	                    break;
	                case 'M':
	                    output = 'एक महिना';
	                    break;
	                case 'MM':
	                    output = '%d महिने';
	                    break;
	                case 'y':
	                    output = 'एक वर्ष';
	                    break;
	                case 'yy':
	                    output = '%d वर्षे';
	                    break;
	            }
	        } else {
	            switch (string) {
	                case 's':
	                    output = 'काही सेकंदां';
	                    break;
	                case 'ss':
	                    output = '%d सेकंदां';
	                    break;
	                case 'm':
	                    output = 'एका मिनिटा';
	                    break;
	                case 'mm':
	                    output = '%d मिनिटां';
	                    break;
	                case 'h':
	                    output = 'एका तासा';
	                    break;
	                case 'hh':
	                    output = '%d तासां';
	                    break;
	                case 'd':
	                    output = 'एका दिवसा';
	                    break;
	                case 'dd':
	                    output = '%d दिवसां';
	                    break;
	                case 'M':
	                    output = 'एका महिन्या';
	                    break;
	                case 'MM':
	                    output = '%d महिन्यां';
	                    break;
	                case 'y':
	                    output = 'एका वर्षा';
	                    break;
	                case 'yy':
	                    output = '%d वर्षां';
	                    break;
	            }
	        }
	        return output.replace(/%d/i, number);
	    }
	
	    var mr = moment.defineLocale('mr', {
	        months: 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
	            '_'
	        ),
	        monthsShort:
	            'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort: 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm वाजता',
	            LTS: 'A h:mm:ss वाजता',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm वाजता',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm वाजता',
	        },
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[उद्या] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[काल] LT',
	            lastWeek: '[मागील] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sमध्ये',
	            past: '%sपूर्वी',
	            s: relativeTimeMr,
	            ss: relativeTimeMr,
	            m: relativeTimeMr,
	            mm: relativeTimeMr,
	            h: relativeTimeMr,
	            hh: relativeTimeMr,
	            d: relativeTimeMr,
	            dd: relativeTimeMr,
	            M: relativeTimeMr,
	            MM: relativeTimeMr,
	            y: relativeTimeMr,
	            yy: relativeTimeMr,
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /पहाटे|सकाळी|दुपारी|सायंकाळी|रात्री/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'पहाटे' || meridiem === 'सकाळी') {
	                return hour;
	            } else if (
	                meridiem === 'दुपारी' ||
	                meridiem === 'सायंकाळी' ||
	                meridiem === 'रात्री'
	            ) {
	                return hour >= 12 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour >= 0 && hour < 6) {
	                return 'पहाटे';
	            } else if (hour < 12) {
	                return 'सकाळी';
	            } else if (hour < 17) {
	                return 'दुपारी';
	            } else if (hour < 20) {
	                return 'सायंकाळी';
	            } else {
	                return 'रात्री';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return mr;
	
	})));


/***/ },
/* 539 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms-my]
	//! note : DEPRECATED, the correct one is [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var msMy = moment.defineLocale('ms-my', {
	        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Esok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kelmarin pukul] LT',
	            lastWeek: 'dddd [lepas pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lepas',
	            s: 'beberapa saat',
	            ss: '%d saat',
	            m: 'seminit',
	            mm: '%d minit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return msMy;
	
	})));


/***/ },
/* 540 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ms = moment.defineLocale('ms', {
	        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Esok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kelmarin pukul] LT',
	            lastWeek: 'dddd [lepas pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lepas',
	            s: 'beberapa saat',
	            ss: '%d saat',
	            m: 'seminit',
	            mm: '%d minit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return ms;
	
	})));


/***/ },
/* 541 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maltese (Malta) [mt]
	//! author : Alessandro Maruccia : https://github.com/alesma
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var mt = moment.defineLocale('mt', {
	        months: 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
	        weekdays:
	            'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split(
	                '_'
	            ),
	        weekdaysShort: 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
	        weekdaysMin: 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Illum fil-]LT',
	            nextDay: '[Għada fil-]LT',
	            nextWeek: 'dddd [fil-]LT',
	            lastDay: '[Il-bieraħ fil-]LT',
	            lastWeek: 'dddd [li għadda] [fil-]LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'f’ %s',
	            past: '%s ilu',
	            s: 'ftit sekondi',
	            ss: '%d sekondi',
	            m: 'minuta',
	            mm: '%d minuti',
	            h: 'siegħa',
	            hh: '%d siegħat',
	            d: 'ġurnata',
	            dd: '%d ġranet',
	            M: 'xahar',
	            MM: '%d xhur',
	            y: 'sena',
	            yy: '%d sni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return mt;
	
	})));


/***/ },
/* 542 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Burmese [my]
	//! author : Squar team, mysquar.com
	//! author : David Rossellat : https://github.com/gholadr
	//! author : Tin Aung Lin : https://github.com/thanyawzinmin
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '၁',
	            2: '၂',
	            3: '၃',
	            4: '၄',
	            5: '၅',
	            6: '၆',
	            7: '၇',
	            8: '၈',
	            9: '၉',
	            0: '၀',
	        },
	        numberMap = {
	            '၁': '1',
	            '၂': '2',
	            '၃': '3',
	            '၄': '4',
	            '၅': '5',
	            '၆': '6',
	            '၇': '7',
	            '၈': '8',
	            '၉': '9',
	            '၀': '0',
	        };
	
	    var my = moment.defineLocale('my', {
	        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split(
	            '_'
	        ),
	        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split(
	            '_'
	        ),
	        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[ယနေ.] LT [မှာ]',
	            nextDay: '[မနက်ဖြန်] LT [မှာ]',
	            nextWeek: 'dddd LT [မှာ]',
	            lastDay: '[မနေ.က] LT [မှာ]',
	            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'လာမည့် %s မှာ',
	            past: 'လွန်ခဲ့သော %s က',
	            s: 'စက္ကန်.အနည်းငယ်',
	            ss: '%d စက္ကန့်',
	            m: 'တစ်မိနစ်',
	            mm: '%d မိနစ်',
	            h: 'တစ်နာရီ',
	            hh: '%d နာရီ',
	            d: 'တစ်ရက်',
	            dd: '%d ရက်',
	            M: 'တစ်လ',
	            MM: '%d လ',
	            y: 'တစ်နှစ်',
	            yy: '%d နှစ်',
	        },
	        preparse: function (string) {
	            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return my;
	
	})));


/***/ },
/* 543 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Norwegian Bokmål [nb]
	//! authors : Espen Hovlandsdal : https://github.com/rexxars
	//!           Sigurd Gartmann : https://github.com/sigurdga
	//!           Stephen Ramthun : https://github.com/stephenramthun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var nb = moment.defineLocale('nb', {
	        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort: 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] HH:mm',
	            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[forrige] dddd [kl.] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s siden',
	            s: 'noen sekunder',
	            ss: '%d sekunder',
	            m: 'ett minutt',
	            mm: '%d minutter',
	            h: 'én time',
	            hh: '%d timer',
	            d: 'én dag',
	            dd: '%d dager',
	            w: 'én uke',
	            ww: '%d uker',
	            M: 'én måned',
	            MM: '%d måneder',
	            y: 'ett år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nb;
	
	})));


/***/ },
/* 544 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nepalese [ne]
	//! author : suvash : https://github.com/suvash
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '१',
	            2: '२',
	            3: '३',
	            4: '४',
	            5: '५',
	            6: '६',
	            7: '७',
	            8: '८',
	            9: '९',
	            0: '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        };
	
	    var ne = moment.defineLocale('ne', {
	        months: 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split(
	            '_'
	        ),
	        monthsShort:
	            'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split(
	            '_'
	        ),
	        weekdaysShort: 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	        weekdaysMin: 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'Aको h:mm बजे',
	            LTS: 'Aको h:mm:ss बजे',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, Aको h:mm बजे',
	            LLLL: 'dddd, D MMMM YYYY, Aको h:mm बजे',
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राति') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'बिहान') {
	                return hour;
	            } else if (meridiem === 'दिउँसो') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'साँझ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 3) {
	                return 'राति';
	            } else if (hour < 12) {
	                return 'बिहान';
	            } else if (hour < 16) {
	                return 'दिउँसो';
	            } else if (hour < 20) {
	                return 'साँझ';
	            } else {
	                return 'राति';
	            }
	        },
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[भोलि] LT',
	            nextWeek: '[आउँदो] dddd[,] LT',
	            lastDay: '[हिजो] LT',
	            lastWeek: '[गएको] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sमा',
	            past: '%s अगाडि',
	            s: 'केही क्षण',
	            ss: '%d सेकेण्ड',
	            m: 'एक मिनेट',
	            mm: '%d मिनेट',
	            h: 'एक घण्टा',
	            hh: '%d घण्टा',
	            d: 'एक दिन',
	            dd: '%d दिन',
	            M: 'एक महिना',
	            MM: '%d महिना',
	            y: 'एक बर्ष',
	            yy: '%d बर्ष',
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return ne;
	
	})));


/***/ },
/* 545 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch (Belgium) [nl-be]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots =
	            'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots =
	            'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        monthsParse = [
	            /^jan/i,
	            /^feb/i,
	            /^(maart|mrt\.?)$/i,
	            /^apr/i,
	            /^mei$/i,
	            /^jun[i.]?$/i,
	            /^jul[i.]?$/i,
	            /^aug/i,
	            /^sep/i,
	            /^okt/i,
	            /^nov/i,
	            /^dec/i,
	        ],
	        monthsRegex =
	            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nlBe = moment.defineLocale('nl-be', {
	        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex:
	            /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        weekdays:
	            'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'over %s',
	            past: '%s geleden',
	            s: 'een paar seconden',
	            ss: '%d seconden',
	            m: 'één minuut',
	            mm: '%d minuten',
	            h: 'één uur',
	            hh: '%d uur',
	            d: 'één dag',
	            dd: '%d dagen',
	            M: 'één maand',
	            MM: '%d maanden',
	            y: 'één jaar',
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nlBe;
	
	})));


/***/ },
/* 546 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch [nl]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots =
	            'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots =
	            'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        monthsParse = [
	            /^jan/i,
	            /^feb/i,
	            /^(maart|mrt\.?)$/i,
	            /^apr/i,
	            /^mei$/i,
	            /^jun[i.]?$/i,
	            /^jul[i.]?$/i,
	            /^aug/i,
	            /^sep/i,
	            /^okt/i,
	            /^nov/i,
	            /^dec/i,
	        ],
	        monthsRegex =
	            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nl = moment.defineLocale('nl', {
	        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex:
	            /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        weekdays:
	            'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'over %s',
	            past: '%s geleden',
	            s: 'een paar seconden',
	            ss: '%d seconden',
	            m: 'één minuut',
	            mm: '%d minuten',
	            h: 'één uur',
	            hh: '%d uur',
	            d: 'één dag',
	            dd: '%d dagen',
	            w: 'één week',
	            ww: '%d weken',
	            M: 'één maand',
	            MM: '%d maanden',
	            y: 'één jaar',
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nl;
	
	})));


/***/ },
/* 547 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nynorsk [nn]
	//! authors : https://github.com/mechuwind
	//!           Stephen Ramthun : https://github.com/stephenramthun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var nn = moment.defineLocale('nn', {
	        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	        weekdaysShort: 'su._må._ty._on._to._fr._lau.'.split('_'),
	        weekdaysMin: 'su_må_ty_on_to_fr_la'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] H:mm',
	            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[I dag klokka] LT',
	            nextDay: '[I morgon klokka] LT',
	            nextWeek: 'dddd [klokka] LT',
	            lastDay: '[I går klokka] LT',
	            lastWeek: '[Føregåande] dddd [klokka] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s sidan',
	            s: 'nokre sekund',
	            ss: '%d sekund',
	            m: 'eit minutt',
	            mm: '%d minutt',
	            h: 'ein time',
	            hh: '%d timar',
	            d: 'ein dag',
	            dd: '%d dagar',
	            w: 'ei veke',
	            ww: '%d veker',
	            M: 'ein månad',
	            MM: '%d månader',
	            y: 'eit år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nn;
	
	})));


/***/ },
/* 548 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Occitan, lengadocian dialecte [oc-lnc]
	//! author : Quentin PAGÈS : https://github.com/Quenty31
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ocLnc = moment.defineLocale('oc-lnc', {
	        months: {
	            standalone:
	                'genièr_febrièr_març_abril_mai_junh_julhet_agost_setembre_octòbre_novembre_decembre'.split(
	                    '_'
	                ),
	            format: "de genièr_de febrièr_de març_d'abril_de mai_de junh_de julhet_d'agost_de setembre_d'octòbre_de novembre_de decembre".split(
	                '_'
	            ),
	            isFormat: /D[oD]?(\s)+MMMM/,
	        },
	        monthsShort:
	            'gen._febr._març_abr._mai_junh_julh._ago._set._oct._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'dimenge_diluns_dimars_dimècres_dijòus_divendres_dissabte'.split(
	            '_'
	        ),
	        weekdaysShort: 'dg._dl._dm._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin: 'dg_dl_dm_dc_dj_dv_ds'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [de] YYYY',
	            ll: 'D MMM YYYY',
	            LLL: 'D MMMM [de] YYYY [a] H:mm',
	            lll: 'D MMM YYYY, H:mm',
	            LLLL: 'dddd D MMMM [de] YYYY [a] H:mm',
	            llll: 'ddd D MMM YYYY, H:mm',
	        },
	        calendar: {
	            sameDay: '[uèi a] LT',
	            nextDay: '[deman a] LT',
	            nextWeek: 'dddd [a] LT',
	            lastDay: '[ièr a] LT',
	            lastWeek: 'dddd [passat a] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: "d'aquí %s",
	            past: 'fa %s',
	            s: 'unas segondas',
	            ss: '%d segondas',
	            m: 'una minuta',
	            mm: '%d minutas',
	            h: 'una ora',
	            hh: '%d oras',
	            d: 'un jorn',
	            dd: '%d jorns',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal: function (number, period) {
	            var output =
	                number === 1
	                    ? 'r'
	                    : number === 2
	                      ? 'n'
	                      : number === 3
	                        ? 'r'
	                        : number === 4
	                          ? 't'
	                          : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4,
	        },
	    });
	
	    return ocLnc;
	
	})));


/***/ },
/* 549 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Punjabi (India) [pa-in]
	//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '੧',
	            2: '੨',
	            3: '੩',
	            4: '੪',
	            5: '੫',
	            6: '੬',
	            7: '੭',
	            8: '੮',
	            9: '੯',
	            0: '੦',
	        },
	        numberMap = {
	            '੧': '1',
	            '੨': '2',
	            '੩': '3',
	            '੪': '4',
	            '੫': '5',
	            '੬': '6',
	            '੭': '7',
	            '੮': '8',
	            '੯': '9',
	            '੦': '0',
	        };
	
	    var paIn = moment.defineLocale('pa-in', {
	        // There are months name as per Nanakshahi Calendar but they are not used as rigidly in modern Punjabi.
	        months: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
	            '_'
	        ),
	        monthsShort:
	            'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
	                '_'
	            ),
	        weekdays: 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split(
	            '_'
	        ),
	        weekdaysShort: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        weekdaysMin: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm ਵਜੇ',
	            LTS: 'A h:mm:ss ਵਜੇ',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm ਵਜੇ',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm ਵਜੇ',
	        },
	        calendar: {
	            sameDay: '[ਅਜ] LT',
	            nextDay: '[ਕਲ] LT',
	            nextWeek: '[ਅਗਲਾ] dddd, LT',
	            lastDay: '[ਕਲ] LT',
	            lastWeek: '[ਪਿਛਲੇ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ਵਿੱਚ',
	            past: '%s ਪਿਛਲੇ',
	            s: 'ਕੁਝ ਸਕਿੰਟ',
	            ss: '%d ਸਕਿੰਟ',
	            m: 'ਇਕ ਮਿੰਟ',
	            mm: '%d ਮਿੰਟ',
	            h: 'ਇੱਕ ਘੰਟਾ',
	            hh: '%d ਘੰਟੇ',
	            d: 'ਇੱਕ ਦਿਨ',
	            dd: '%d ਦਿਨ',
	            M: 'ਇੱਕ ਮਹੀਨਾ',
	            MM: '%d ਮਹੀਨੇ',
	            y: 'ਇੱਕ ਸਾਲ',
	            yy: '%d ਸਾਲ',
	        },
	        preparse: function (string) {
	            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ਰਾਤ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ਸਵੇਰ') {
	                return hour;
	            } else if (meridiem === 'ਦੁਪਹਿਰ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ਸ਼ਾਮ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ਰਾਤ';
	            } else if (hour < 10) {
	                return 'ਸਵੇਰ';
	            } else if (hour < 17) {
	                return 'ਦੁਪਹਿਰ';
	            } else if (hour < 20) {
	                return 'ਸ਼ਾਮ';
	            } else {
	                return 'ਰਾਤ';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return paIn;
	
	})));


/***/ },
/* 550 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Polish [pl]
	//! author : Rafal Hirsz : https://github.com/evoL
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsNominative =
	            'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split(
	                '_'
	            ),
	        monthsSubjective =
	            'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split(
	                '_'
	            ),
	        monthsParse = [
	            /^sty/i,
	            /^lut/i,
	            /^mar/i,
	            /^kwi/i,
	            /^maj/i,
	            /^cze/i,
	            /^lip/i,
	            /^sie/i,
	            /^wrz/i,
	            /^paź/i,
	            /^lis/i,
	            /^gru/i,
	        ];
	    function plural(n) {
	        return n % 10 < 5 && n % 10 > 1 && ~~(n / 10) % 10 !== 1;
	    }
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                return result + (plural(number) ? 'sekundy' : 'sekund');
	            case 'm':
	                return withoutSuffix ? 'minuta' : 'minutę';
	            case 'mm':
	                return result + (plural(number) ? 'minuty' : 'minut');
	            case 'h':
	                return withoutSuffix ? 'godzina' : 'godzinę';
	            case 'hh':
	                return result + (plural(number) ? 'godziny' : 'godzin');
	            case 'ww':
	                return result + (plural(number) ? 'tygodnie' : 'tygodni');
	            case 'MM':
	                return result + (plural(number) ? 'miesiące' : 'miesięcy');
	            case 'yy':
	                return result + (plural(number) ? 'lata' : 'lat');
	        }
	    }
	
	    var pl = moment.defineLocale('pl', {
	        months: function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return monthsNominative;
	            } else if (/D MMMM/.test(format)) {
	                return monthsSubjective[momentToFormat.month()];
	            } else {
	                return monthsNominative[momentToFormat.month()];
	            }
	        },
	        monthsShort: 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays:
	            'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
	        weekdaysShort: 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
	        weekdaysMin: 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Dziś o] LT',
	            nextDay: '[Jutro o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W niedzielę o] LT';
	
	                    case 2:
	                        return '[We wtorek o] LT';
	
	                    case 3:
	                        return '[W środę o] LT';
	
	                    case 6:
	                        return '[W sobotę o] LT';
	
	                    default:
	                        return '[W] dddd [o] LT';
	                }
	            },
	            lastDay: '[Wczoraj o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W zeszłą niedzielę o] LT';
	                    case 3:
	                        return '[W zeszłą środę o] LT';
	                    case 6:
	                        return '[W zeszłą sobotę o] LT';
	                    default:
	                        return '[W zeszły] dddd [o] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: '%s temu',
	            s: 'kilka sekund',
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: '1 dzień',
	            dd: '%d dni',
	            w: 'tydzień',
	            ww: translate,
	            M: 'miesiąc',
	            MM: translate,
	            y: 'rok',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return pl;
	
	})));


/***/ },
/* 551 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese (Brazil) [pt-br]
	//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ptBr = moment.defineLocale('pt-br', {
	        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
	            '_'
	        ),
	        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	        weekdays:
	            'domingo_segunda-feira_terça-feira_quarta-feira_quinta-feira_sexta-feira_sábado'.split(
	                '_'
	            ),
	        weekdaysShort: 'dom_seg_ter_qua_qui_sex_sáb'.split('_'),
	        weekdaysMin: 'do_2ª_3ª_4ª_5ª_6ª_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY [às] HH:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY [às] HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return this.day() === 0 || this.day() === 6
	                    ? '[Último] dddd [às] LT' // Saturday + Sunday
	                    : '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'em %s',
	            past: 'há %s',
	            s: 'poucos segundos',
	            ss: '%d segundos',
	            m: 'um minuto',
	            mm: '%d minutos',
	            h: 'uma hora',
	            hh: '%d horas',
	            d: 'um dia',
	            dd: '%d dias',
	            M: 'um mês',
	            MM: '%d meses',
	            y: 'um ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        invalidDate: 'Data inválida',
	    });
	
	    return ptBr;
	
	})));


/***/ },
/* 552 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese [pt]
	//! author : Jefferson : https://github.com/jalex79
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var pt = moment.defineLocale('pt', {
	        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
	            '_'
	        ),
	        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	        weekdays:
	            'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split(
	                '_'
	            ),
	        weekdaysShort: 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin: 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY HH:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return this.day() === 0 || this.day() === 6
	                    ? '[Último] dddd [às] LT' // Saturday + Sunday
	                    : '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'em %s',
	            past: 'há %s',
	            s: 'segundos',
	            ss: '%d segundos',
	            m: 'um minuto',
	            mm: '%d minutos',
	            h: 'uma hora',
	            hh: '%d horas',
	            d: 'um dia',
	            dd: '%d dias',
	            w: 'uma semana',
	            ww: '%d semanas',
	            M: 'um mês',
	            MM: '%d meses',
	            y: 'um ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return pt;
	
	})));


/***/ },
/* 553 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Romanian [ro]
	//! author : Vlad Gurdiga : https://github.com/gurdiga
	//! author : Valentin Agachi : https://github.com/avaly
	//! author : Emanuel Cepoi : https://github.com/cepem
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	                ss: 'secunde',
	                mm: 'minute',
	                hh: 'ore',
	                dd: 'zile',
	                ww: 'săptămâni',
	                MM: 'luni',
	                yy: 'ani',
	            },
	            separator = ' ';
	        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	            separator = ' de ';
	        }
	        return number + separator + format[key];
	    }
	
	    var ro = moment.defineLocale('ro', {
	        months: 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split(
	            '_'
	        ),
	        monthsShort:
	            'ian._feb._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	        weekdaysShort: 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	        weekdaysMin: 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[azi la] LT',
	            nextDay: '[mâine la] LT',
	            nextWeek: 'dddd [la] LT',
	            lastDay: '[ieri la] LT',
	            lastWeek: '[fosta] dddd [la] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'peste %s',
	            past: '%s în urmă',
	            s: 'câteva secunde',
	            ss: relativeTimeWithPlural,
	            m: 'un minut',
	            mm: relativeTimeWithPlural,
	            h: 'o oră',
	            hh: relativeTimeWithPlural,
	            d: 'o zi',
	            dd: relativeTimeWithPlural,
	            w: 'o săptămână',
	            ww: relativeTimeWithPlural,
	            M: 'o lună',
	            MM: relativeTimeWithPlural,
	            y: 'un an',
	            yy: relativeTimeWithPlural,
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return ro;
	
	})));


/***/ },
/* 554 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Russian [ru]
	//! author : Viktorminator : https://github.com/Viktorminator
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Коренберг Марк : https://github.com/socketpair
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	              ? forms[1]
	              : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            mm: withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	            hh: 'час_часа_часов',
	            dd: 'день_дня_дней',
	            ww: 'неделя_недели_недель',
	            MM: 'месяц_месяца_месяцев',
	            yy: 'год_года_лет',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'минута' : 'минуту';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    var monthsParse = [
	        /^янв/i,
	        /^фев/i,
	        /^мар/i,
	        /^апр/i,
	        /^ма[йя]/i,
	        /^июн/i,
	        /^июл/i,
	        /^авг/i,
	        /^сен/i,
	        /^окт/i,
	        /^ноя/i,
	        /^дек/i,
	    ];
	
	    // http://new.gramota.ru/spravka/rules/139-prop : § 103
	    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	    var ru = moment.defineLocale('ru', {
	        months: {
	            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split(
	                '_'
	            ),
	            standalone:
	                'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
	                    '_'
	                ),
	        },
	        monthsShort: {
	            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку?
	            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split(
	                '_'
	            ),
	            standalone:
	                'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split(
	                    '_'
	                ),
	        },
	        weekdays: {
	            standalone:
	                'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split(
	                    '_'
	                ),
	            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split(
	                '_'
	            ),
	            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?] ?dddd/,
	        },
	        weekdaysShort: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	        monthsRegex:
	            /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // копия предыдущего
	        monthsShortRegex:
	            /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // полные названия с падежами
	        monthsStrictRegex:
	            /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	        // Выражение, которое соответствует только сокращённым формам
	        monthsShortStrictRegex:
	            /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY г.',
	            LLL: 'D MMMM YYYY г., H:mm',
	            LLLL: 'dddd, D MMMM YYYY г., H:mm',
	        },
	        calendar: {
	            sameDay: '[Сегодня, в] LT',
	            nextDay: '[Завтра, в] LT',
	            lastDay: '[Вчера, в] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В следующее] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В следующий] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В следующую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            lastWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В прошлое] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В прошлый] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В прошлую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'через %s',
	            past: '%s назад',
	            s: 'несколько секунд',
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: 'час',
	            hh: relativeTimeWithPlural,
	            d: 'день',
	            dd: relativeTimeWithPlural,
	            w: 'неделя',
	            ww: relativeTimeWithPlural,
	            M: 'месяц',
	            MM: relativeTimeWithPlural,
	            y: 'год',
	            yy: relativeTimeWithPlural,
	        },
	        meridiemParse: /ночи|утра|дня|вечера/i,
	        isPM: function (input) {
	            return /^(дня|вечера)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночи';
	            } else if (hour < 12) {
	                return 'утра';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечера';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                case 'w':
	                case 'W':
	                    return number + '-я';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ru;
	
	})));


/***/ },
/* 555 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sindhi [sd]
	//! author : Narain Sagar : https://github.com/narainsagar
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'جنوري',
	            'فيبروري',
	            'مارچ',
	            'اپريل',
	            'مئي',
	            'جون',
	            'جولاءِ',
	            'آگسٽ',
	            'سيپٽمبر',
	            'آڪٽوبر',
	            'نومبر',
	            'ڊسمبر',
	        ],
	        days = ['آچر', 'سومر', 'اڱارو', 'اربع', 'خميس', 'جمع', 'ڇنڇر'];
	
	    var sd = moment.defineLocale('sd', {
	        months: months,
	        monthsShort: months,
	        weekdays: days,
	        weekdaysShort: days,
	        weekdaysMin: days,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd، D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /صبح|شام/,
	        isPM: function (input) {
	            return 'شام' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar: {
	            sameDay: '[اڄ] LT',
	            nextDay: '[سڀاڻي] LT',
	            nextWeek: 'dddd [اڳين هفتي تي] LT',
	            lastDay: '[ڪالهه] LT',
	            lastWeek: '[گزريل هفتي] dddd [تي] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s پوء',
	            past: '%s اڳ',
	            s: 'چند سيڪنڊ',
	            ss: '%d سيڪنڊ',
	            m: 'هڪ منٽ',
	            mm: '%d منٽ',
	            h: 'هڪ ڪلاڪ',
	            hh: '%d ڪلاڪ',
	            d: 'هڪ ڏينهن',
	            dd: '%d ڏينهن',
	            M: 'هڪ مهينو',
	            MM: '%d مهينا',
	            y: 'هڪ سال',
	            yy: '%d سال',
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sd;
	
	})));


/***/ },
/* 556 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Northern Sami [se]
	//! authors : Bård Rolstad Henriksen : https://github.com/karamell
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var se = moment.defineLocale('se', {
	        months: 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split(
	            '_'
	        ),
	        monthsShort:
	            'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
	        weekdays:
	            'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split(
	                '_'
	            ),
	        weekdaysShort: 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	        weekdaysMin: 's_v_m_g_d_b_L'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'MMMM D. [b.] YYYY',
	            LLL: 'MMMM D. [b.] YYYY [ti.] HH:mm',
	            LLLL: 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[otne ti] LT',
	            nextDay: '[ihttin ti] LT',
	            nextWeek: 'dddd [ti] LT',
	            lastDay: '[ikte ti] LT',
	            lastWeek: '[ovddit] dddd [ti] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s geažes',
	            past: 'maŋit %s',
	            s: 'moadde sekunddat',
	            ss: '%d sekunddat',
	            m: 'okta minuhta',
	            mm: '%d minuhtat',
	            h: 'okta diimmu',
	            hh: '%d diimmut',
	            d: 'okta beaivi',
	            dd: '%d beaivvit',
	            M: 'okta mánnu',
	            MM: '%d mánut',
	            y: 'okta jahki',
	            yy: '%d jagit',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return se;
	
	})));


/***/ },
/* 557 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sinhalese [si]
	//! author : Sampath Sitinamaluwa : https://github.com/sampathsris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    /*jshint -W100*/
	    var si = moment.defineLocale('si', {
	        months: 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split(
	            '_'
	        ),
	        monthsShort: 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split(
	            '_'
	        ),
	        weekdays:
	            'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split(
	                '_'
	            ),
	        weekdaysShort: 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	        weekdaysMin: 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'a h:mm',
	            LTS: 'a h:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY MMMM D',
	            LLL: 'YYYY MMMM D, a h:mm',
	            LLLL: 'YYYY MMMM D [වැනි] dddd, a h:mm:ss',
	        },
	        calendar: {
	            sameDay: '[අද] LT[ට]',
	            nextDay: '[හෙට] LT[ට]',
	            nextWeek: 'dddd LT[ට]',
	            lastDay: '[ඊයේ] LT[ට]',
	            lastWeek: '[පසුගිය] dddd LT[ට]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sකින්',
	            past: '%sකට පෙර',
	            s: 'තත්පර කිහිපය',
	            ss: 'තත්පර %d',
	            m: 'මිනිත්තුව',
	            mm: 'මිනිත්තු %d',
	            h: 'පැය',
	            hh: 'පැය %d',
	            d: 'දිනය',
	            dd: 'දින %d',
	            M: 'මාසය',
	            MM: 'මාස %d',
	            y: 'වසර',
	            yy: 'වසර %d',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
	        ordinal: function (number) {
	            return number + ' වැනි';
	        },
	        meridiemParse: /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	        isPM: function (input) {
	            return input === 'ප.ව.' || input === 'පස් වරු';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'ප.ව.' : 'පස් වරු';
	            } else {
	                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	            }
	        },
	    });
	
	    return si;
	
	})));


/***/ },
/* 558 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovak [sk]
	//! author : Martin Minka : https://github.com/k2s
	//! based on work of petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months =
	            'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split(
	                '_'
	            ),
	        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	    function plural(n) {
	        return n > 1 && n < 5;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's': // a few seconds / in a few seconds / a few seconds ago
	                return withoutSuffix || isFuture ? 'pár sekúnd' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekúnd');
	                } else {
	                    return result + 'sekundami';
	                }
	            case 'm': // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minúta' : isFuture ? 'minútu' : 'minútou';
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minúty' : 'minút');
	                } else {
	                    return result + 'minútami';
	                }
	            case 'h': // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodín');
	                } else {
	                    return result + 'hodinami';
	                }
	            case 'd': // a day / in a day / a day ago
	                return withoutSuffix || isFuture ? 'deň' : 'dňom';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dni' : 'dní');
	                } else {
	                    return result + 'dňami';
	                }
	            case 'M': // a month / in a month / a month ago
	                return withoutSuffix || isFuture ? 'mesiac' : 'mesiacom';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
	                } else {
	                    return result + 'mesiacmi';
	                }
	            case 'y': // a year / in a year / a year ago
	                return withoutSuffix || isFuture ? 'rok' : 'rokom';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'rokov');
	                } else {
	                    return result + 'rokmi';
	                }
	        }
	    }
	
	    var sk = moment.defineLocale('sk', {
	        months: months,
	        monthsShort: monthsShort,
	        weekdays: 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	        weekdaysShort: 'ne_po_ut_st_št_pi_so'.split('_'),
	        weekdaysMin: 'ne_po_ut_st_št_pi_so'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[dnes o] LT',
	            nextDay: '[zajtra o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [o] LT';
	                    case 3:
	                        return '[v stredu o] LT';
	                    case 4:
	                        return '[vo štvrtok o] LT';
	                    case 5:
	                        return '[v piatok o] LT';
	                    case 6:
	                        return '[v sobotu o] LT';
	                }
	            },
	            lastDay: '[včera o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulú nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[minulý] dddd [o] LT';
	                    case 3:
	                        return '[minulú stredu o] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [o] LT';
	                    case 6:
	                        return '[minulú sobotu o] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'pred %s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sk;
	
	})));


/***/ },
/* 559 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovenian [sl]
	//! author : Robert Sedovšek : https://github.com/sedovsek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture
	                    ? 'nekaj sekund'
	                    : 'nekaj sekundami';
	            case 'ss':
	                if (number === 1) {
	                    result += withoutSuffix ? 'sekundo' : 'sekundi';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
	                } else {
	                    result += 'sekund';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'ena minuta' : 'eno minuto';
	            case 'mm':
	                if (number === 1) {
	                    result += withoutSuffix ? 'minuta' : 'minuto';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'ena ura' : 'eno uro';
	            case 'hh':
	                if (number === 1) {
	                    result += withoutSuffix ? 'ura' : 'uro';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
	                }
	                return result;
	            case 'd':
	                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	            case 'dd':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	                } else {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	                }
	                return result;
	            case 'M':
	                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	            case 'MM':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	                } else {
	                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	                }
	                return result;
	            case 'y':
	                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	            case 'yy':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
	                } else {
	                    result += withoutSuffix || isFuture ? 'let' : 'leti';
	                }
	                return result;
	        }
	    }
	
	    var sl = moment.defineLocale('sl', {
	        months: 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	        weekdaysShort: 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	        weekdaysMin: 'ne_po_to_sr_če_pe_so'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD. MM. YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danes ob] LT',
	            nextDay: '[jutri ob] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[v] [sredo] [ob] LT';
	                    case 6:
	                        return '[v] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[v] dddd [ob] LT';
	                }
	            },
	            lastDay: '[včeraj ob] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[prejšnjo] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[prejšnjo] [sredo] [ob] LT';
	                    case 6:
	                        return '[prejšnjo] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prejšnji] dddd [ob] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'čez %s',
	            past: 'pred %s',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sl;
	
	})));


/***/ },
/* 560 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Albanian [sq]
	//! author : Flakërim Ismani : https://github.com/flakerimi
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Oerd Cukalla : https://github.com/oerd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var sq = moment.defineLocale('sq', {
	        months: 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	        weekdays: 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split(
	            '_'
	        ),
	        weekdaysShort: 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	        weekdaysMin: 'D_H_Ma_Më_E_P_Sh'.split('_'),
	        weekdaysParseExact: true,
	        meridiemParse: /PD|MD/,
	        isPM: function (input) {
	            return input.charAt(0) === 'M';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            return hours < 12 ? 'PD' : 'MD';
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Sot në] LT',
	            nextDay: '[Nesër në] LT',
	            nextWeek: 'dddd [në] LT',
	            lastDay: '[Dje në] LT',
	            lastWeek: 'dddd [e kaluar në] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'në %s',
	            past: '%s më parë',
	            s: 'disa sekonda',
	            ss: '%d sekonda',
	            m: 'një minutë',
	            mm: '%d minuta',
	            h: 'një orë',
	            hh: '%d orë',
	            d: 'një ditë',
	            dd: '%d ditë',
	            M: 'një muaj',
	            MM: '%d muaj',
	            y: 'një vit',
	            yy: '%d vite',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sq;
	
	})));


/***/ },
/* 561 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian Cyrillic [sr-cyrl]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['секунда', 'секунде', 'секунди'],
	            m: ['један минут', 'једног минута'],
	            mm: ['минут', 'минута', 'минута'],
	            h: ['један сат', 'једног сата'],
	            hh: ['сат', 'сата', 'сати'],
	            d: ['један дан', 'једног дана'],
	            dd: ['дан', 'дана', 'дана'],
	            M: ['један месец', 'једног месеца'],
	            MM: ['месец', 'месеца', 'месеци'],
	            y: ['једну годину', 'једне године'],
	            yy: ['годину', 'године', 'година'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            if (
	                number % 10 >= 1 &&
	                number % 10 <= 4 &&
	                (number % 100 < 10 || number % 100 >= 20)
	            ) {
	                return number % 10 === 1 ? wordKey[0] : wordKey[1];
	            }
	            return wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key, isFuture) {
	            var wordKey = translator.words[key],
	                word;
	
	            if (key.length === 1) {
	                // Nominativ
	                if (key === 'y' && withoutSuffix) return 'једна година';
	                return isFuture || withoutSuffix ? wordKey[0] : wordKey[1];
	            }
	
	            word = translator.correctGrammaticalCase(number, wordKey);
	            // Nominativ
	            if (key === 'yy' && withoutSuffix && word === 'годину') {
	                return number + ' година';
	            }
	
	            return number + ' ' + word;
	        },
	    };
	
	    var srCyrl = moment.defineLocale('sr-cyrl', {
	        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split(
	            '_'
	        ),
	        monthsShort:
	            'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D. M. YYYY.',
	            LL: 'D. MMMM YYYY.',
	            LLL: 'D. MMMM YYYY. H:mm',
	            LLLL: 'dddd, D. MMMM YYYY. H:mm',
	        },
	        calendar: {
	            sameDay: '[данас у] LT',
	            nextDay: '[сутра у] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[у] [недељу] [у] LT';
	                    case 3:
	                        return '[у] [среду] [у] LT';
	                    case 6:
	                        return '[у] [суботу] [у] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[у] dddd [у] LT';
	                }
	            },
	            lastDay: '[јуче у] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[прошле] [недеље] [у] LT',
	                    '[прошлог] [понедељка] [у] LT',
	                    '[прошлог] [уторка] [у] LT',
	                    '[прошле] [среде] [у] LT',
	                    '[прошлог] [четвртка] [у] LT',
	                    '[прошлог] [петка] [у] LT',
	                    '[прошле] [суботе] [у] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: 'пре %s',
	            s: 'неколико секунди',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: translator.translate,
	            dd: translator.translate,
	            M: translator.translate,
	            MM: translator.translate,
	            y: translator.translate,
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 1st is the first week of the year.
	        },
	    });
	
	    return srCyrl;
	
	})));


/***/ },
/* 562 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian [sr]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['sekunda', 'sekunde', 'sekundi'],
	            m: ['jedan minut', 'jednog minuta'],
	            mm: ['minut', 'minuta', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            d: ['jedan dan', 'jednog dana'],
	            dd: ['dan', 'dana', 'dana'],
	            M: ['jedan mesec', 'jednog meseca'],
	            MM: ['mesec', 'meseca', 'meseci'],
	            y: ['jednu godinu', 'jedne godine'],
	            yy: ['godinu', 'godine', 'godina'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            if (
	                number % 10 >= 1 &&
	                number % 10 <= 4 &&
	                (number % 100 < 10 || number % 100 >= 20)
	            ) {
	                return number % 10 === 1 ? wordKey[0] : wordKey[1];
	            }
	            return wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key, isFuture) {
	            var wordKey = translator.words[key],
	                word;
	
	            if (key.length === 1) {
	                // Nominativ
	                if (key === 'y' && withoutSuffix) return 'jedna godina';
	                return isFuture || withoutSuffix ? wordKey[0] : wordKey[1];
	            }
	
	            word = translator.correctGrammaticalCase(number, wordKey);
	            // Nominativ
	            if (key === 'yy' && withoutSuffix && word === 'godinu') {
	                return number + ' godina';
	            }
	
	            return number + ' ' + word;
	        },
	    };
	
	    var sr = moment.defineLocale('sr', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D. M. YYYY.',
	            LL: 'D. MMMM YYYY.',
	            LLL: 'D. MMMM YYYY. H:mm',
	            LLLL: 'dddd, D. MMMM YYYY. H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedelju] [u] LT';
	                    case 3:
	                        return '[u] [sredu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[juče u] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[prošle] [nedelje] [u] LT',
	                    '[prošlog] [ponedeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'pre %s',
	            s: 'nekoliko sekundi',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: translator.translate,
	            dd: translator.translate,
	            M: translator.translate,
	            MM: translator.translate,
	            y: translator.translate,
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sr;
	
	})));


/***/ },
/* 563 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : siSwati [ss]
	//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ss = moment.defineLocale('ss', {
	        months: "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split(
	            '_'
	        ),
	        monthsShort: 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	        weekdays:
	            'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split(
	                '_'
	            ),
	        weekdaysShort: 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	        weekdaysMin: 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Namuhla nga] LT',
	            nextDay: '[Kusasa nga] LT',
	            nextWeek: 'dddd [nga] LT',
	            lastDay: '[Itolo nga] LT',
	            lastWeek: 'dddd [leliphelile] [nga] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'nga %s',
	            past: 'wenteka nga %s',
	            s: 'emizuzwana lomcane',
	            ss: '%d mzuzwana',
	            m: 'umzuzu',
	            mm: '%d emizuzu',
	            h: 'lihora',
	            hh: '%d emahora',
	            d: 'lilanga',
	            dd: '%d emalanga',
	            M: 'inyanga',
	            MM: '%d tinyanga',
	            y: 'umnyaka',
	            yy: '%d iminyaka',
	        },
	        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'ekuseni';
	            } else if (hours < 15) {
	                return 'emini';
	            } else if (hours < 19) {
	                return 'entsambama';
	            } else {
	                return 'ebusuku';
	            }
	        },
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ekuseni') {
	                return hour;
	            } else if (meridiem === 'emini') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	                if (hour === 0) {
	                    return 0;
	                }
	                return hour + 12;
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: '%d',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ss;
	
	})));


/***/ },
/* 564 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swedish [sv]
	//! author : Jens Alm : https://github.com/ulmus
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var sv = moment.defineLocale('sv', {
	        months: 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays: 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	        weekdaysShort: 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	        weekdaysMin: 'sö_må_ti_on_to_fr_lö'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [kl.] HH:mm',
	            LLLL: 'dddd D MMMM YYYY [kl.] HH:mm',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd D MMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Idag] LT',
	            nextDay: '[Imorgon] LT',
	            lastDay: '[Igår] LT',
	            nextWeek: '[På] dddd LT',
	            lastWeek: '[I] dddd[s] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: 'för %s sedan',
	            s: 'några sekunder',
	            ss: '%d sekunder',
	            m: 'en minut',
	            mm: '%d minuter',
	            h: 'en timme',
	            hh: '%d timmar',
	            d: 'en dag',
	            dd: '%d dagar',
	            M: 'en månad',
	            MM: '%d månader',
	            y: 'ett år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(\:e|\:a)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? ':e'
	                        : b === 1
	                          ? ':a'
	                          : b === 2
	                            ? ':a'
	                            : b === 3
	                              ? ':e'
	                              : ':e';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sv;
	
	})));


/***/ },
/* 565 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swahili [sw]
	//! author : Fahad Kassim : https://github.com/fadsel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var sw = moment.defineLocale('sw', {
	        months: 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	        weekdays:
	            'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split(
	                '_'
	            ),
	        weekdaysShort: 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	        weekdaysMin: 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'hh:mm A',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[leo saa] LT',
	            nextDay: '[kesho saa] LT',
	            nextWeek: '[wiki ijayo] dddd [saat] LT',
	            lastDay: '[jana] LT',
	            lastWeek: '[wiki iliyopita] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s baadaye',
	            past: 'tokea %s',
	            s: 'hivi punde',
	            ss: 'sekunde %d',
	            m: 'dakika moja',
	            mm: 'dakika %d',
	            h: 'saa limoja',
	            hh: 'masaa %d',
	            d: 'siku moja',
	            dd: 'siku %d',
	            M: 'mwezi mmoja',
	            MM: 'miezi %d',
	            y: 'mwaka mmoja',
	            yy: 'miaka %d',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sw;
	
	})));


/***/ },
/* 566 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tamil [ta]
	//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '௧',
	            2: '௨',
	            3: '௩',
	            4: '௪',
	            5: '௫',
	            6: '௬',
	            7: '௭',
	            8: '௮',
	            9: '௯',
	            0: '௦',
	        },
	        numberMap = {
	            '௧': '1',
	            '௨': '2',
	            '௩': '3',
	            '௪': '4',
	            '௫': '5',
	            '௬': '6',
	            '௭': '7',
	            '௮': '8',
	            '௯': '9',
	            '௦': '0',
	        };
	
	    var ta = moment.defineLocale('ta', {
	        months: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
	            '_'
	        ),
	        monthsShort:
	            'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
	                '_'
	            ),
	        weekdays:
	            'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split(
	                '_'
	            ),
	        weekdaysShort: 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split(
	            '_'
	        ),
	        weekdaysMin: 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, HH:mm',
	            LLLL: 'dddd, D MMMM YYYY, HH:mm',
	        },
	        calendar: {
	            sameDay: '[இன்று] LT',
	            nextDay: '[நாளை] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[நேற்று] LT',
	            lastWeek: '[கடந்த வாரம்] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s இல்',
	            past: '%s முன்',
	            s: 'ஒரு சில விநாடிகள்',
	            ss: '%d விநாடிகள்',
	            m: 'ஒரு நிமிடம்',
	            mm: '%d நிமிடங்கள்',
	            h: 'ஒரு மணி நேரம்',
	            hh: '%d மணி நேரம்',
	            d: 'ஒரு நாள்',
	            dd: '%d நாட்கள்',
	            M: 'ஒரு மாதம்',
	            MM: '%d மாதங்கள்',
	            y: 'ஒரு வருடம்',
	            yy: '%d ஆண்டுகள்',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}வது/,
	        ordinal: function (number) {
	            return number + 'வது';
	        },
	        preparse: function (string) {
	            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // refer http://ta.wikipedia.org/s/1er1
	        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 2) {
	                return ' யாமம்';
	            } else if (hour < 6) {
	                return ' வைகறை'; // வைகறை
	            } else if (hour < 10) {
	                return ' காலை'; // காலை
	            } else if (hour < 14) {
	                return ' நண்பகல்'; // நண்பகல்
	            } else if (hour < 18) {
	                return ' எற்பாடு'; // எற்பாடு
	            } else if (hour < 22) {
	                return ' மாலை'; // மாலை
	            } else {
	                return ' யாமம்';
	            }
	        },
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'யாமம்') {
	                return hour < 2 ? hour : hour + 12;
	            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	                return hour;
	            } else if (meridiem === 'நண்பகல்') {
	                return hour >= 10 ? hour : hour + 12;
	            } else {
	                return hour + 12;
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return ta;
	
	})));


/***/ },
/* 567 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Telugu [te]
	//! author : Krishna Chaitanya Thota : https://github.com/kcthota
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var te = moment.defineLocale('te', {
	        months: 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జులై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split(
	            '_'
	        ),
	        monthsShort:
	            'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జులై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split(
	                '_'
	            ),
	        weekdaysShort: 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	        weekdaysMin: 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[నేడు] LT',
	            nextDay: '[రేపు] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[నిన్న] LT',
	            lastWeek: '[గత] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s లో',
	            past: '%s క్రితం',
	            s: 'కొన్ని క్షణాలు',
	            ss: '%d సెకన్లు',
	            m: 'ఒక నిమిషం',
	            mm: '%d నిమిషాలు',
	            h: 'ఒక గంట',
	            hh: '%d గంటలు',
	            d: 'ఒక రోజు',
	            dd: '%d రోజులు',
	            M: 'ఒక నెల',
	            MM: '%d నెలలు',
	            y: 'ఒక సంవత్సరం',
	            yy: '%d సంవత్సరాలు',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}వ/,
	        ordinal: '%dవ',
	        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'రాత్రి') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ఉదయం') {
	                return hour;
	            } else if (meridiem === 'మధ్యాహ్నం') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'సాయంత్రం') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'రాత్రి';
	            } else if (hour < 10) {
	                return 'ఉదయం';
	            } else if (hour < 17) {
	                return 'మధ్యాహ్నం';
	            } else if (hour < 20) {
	                return 'సాయంత్రం';
	            } else {
	                return 'రాత్రి';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return te;
	
	})));


/***/ },
/* 568 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tetun Dili (East Timor) [tet]
	//! author : Joshua Brooks : https://github.com/joshbrooks
	//! author : Onorio De J. Afonso : https://github.com/marobo
	//! author : Sonia Simoes : https://github.com/soniasimoes
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tet = moment.defineLocale('tet', {
	        months: 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays: 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
	        weekdaysShort: 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
	        weekdaysMin: 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Ohin iha] LT',
	            nextDay: '[Aban iha] LT',
	            nextWeek: 'dddd [iha] LT',
	            lastDay: '[Horiseik iha] LT',
	            lastWeek: 'dddd [semana kotuk] [iha] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'iha %s',
	            past: '%s liuba',
	            s: 'segundu balun',
	            ss: 'segundu %d',
	            m: 'minutu ida',
	            mm: 'minutu %d',
	            h: 'oras ida',
	            hh: 'oras %d',
	            d: 'loron ida',
	            dd: 'loron %d',
	            M: 'fulan ida',
	            MM: 'fulan %d',
	            y: 'tinan ida',
	            yy: 'tinan %d',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                          ? 'st'
	                          : b === 2
	                            ? 'nd'
	                            : b === 3
	                              ? 'rd'
	                              : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return tet;
	
	})));


/***/ },
/* 569 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tajik [tg]
	//! author : Orif N. Jr. : https://github.com/orif-jr
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        0: '-ум',
	        1: '-ум',
	        2: '-юм',
	        3: '-юм',
	        4: '-ум',
	        5: '-ум',
	        6: '-ум',
	        7: '-ум',
	        8: '-ум',
	        9: '-ум',
	        10: '-ум',
	        12: '-ум',
	        13: '-ум',
	        20: '-ум',
	        30: '-юм',
	        40: '-ум',
	        50: '-ум',
	        60: '-ум',
	        70: '-ум',
	        80: '-ум',
	        90: '-ум',
	        100: '-ум',
	    };
	
	    var tg = moment.defineLocale('tg', {
	        months: {
	            format: 'январи_феврали_марти_апрели_майи_июни_июли_августи_сентябри_октябри_ноябри_декабри'.split(
	                '_'
	            ),
	            standalone:
	                'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
	                    '_'
	                ),
	        },
	        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays: 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split(
	            '_'
	        ),
	        weekdaysShort: 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
	        weekdaysMin: 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Имрӯз соати] LT',
	            nextDay: '[Фардо соати] LT',
	            lastDay: '[Дирӯз соати] LT',
	            nextWeek: 'dddd[и] [ҳафтаи оянда соати] LT',
	            lastWeek: 'dddd[и] [ҳафтаи гузашта соати] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'баъди %s',
	            past: '%s пеш',
	            s: 'якчанд сония',
	            m: 'як дақиқа',
	            mm: '%d дақиқа',
	            h: 'як соат',
	            hh: '%d соат',
	            d: 'як рӯз',
	            dd: '%d рӯз',
	            M: 'як моҳ',
	            MM: '%d моҳ',
	            y: 'як сол',
	            yy: '%d сол',
	        },
	        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'шаб') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'субҳ') {
	                return hour;
	            } else if (meridiem === 'рӯз') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'бегоҳ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'шаб';
	            } else if (hour < 11) {
	                return 'субҳ';
	            } else if (hour < 16) {
	                return 'рӯз';
	            } else if (hour < 19) {
	                return 'бегоҳ';
	            } else {
	                return 'шаб';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 1th is the first week of the year.
	        },
	    });
	
	    return tg;
	
	})));


/***/ },
/* 570 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Thai [th]
	//! author : Kridsada Thanabulpong : https://github.com/sirn
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var th = moment.defineLocale('th', {
	        months: 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split(
	            '_'
	        ),
	        monthsShort:
	            'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	        weekdaysShort: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	        weekdaysMin: 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY เวลา H:mm',
	            LLLL: 'วันddddที่ D MMMM YYYY เวลา H:mm',
	        },
	        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	        isPM: function (input) {
	            return input === 'หลังเที่ยง';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ก่อนเที่ยง';
	            } else {
	                return 'หลังเที่ยง';
	            }
	        },
	        calendar: {
	            sameDay: '[วันนี้ เวลา] LT',
	            nextDay: '[พรุ่งนี้ เวลา] LT',
	            nextWeek: 'dddd[หน้า เวลา] LT',
	            lastDay: '[เมื่อวานนี้ เวลา] LT',
	            lastWeek: '[วัน]dddd[ที่แล้ว เวลา] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'อีก %s',
	            past: '%sที่แล้ว',
	            s: 'ไม่กี่วินาที',
	            ss: '%d วินาที',
	            m: '1 นาที',
	            mm: '%d นาที',
	            h: '1 ชั่วโมง',
	            hh: '%d ชั่วโมง',
	            d: '1 วัน',
	            dd: '%d วัน',
	            w: '1 สัปดาห์',
	            ww: '%d สัปดาห์',
	            M: '1 เดือน',
	            MM: '%d เดือน',
	            y: '1 ปี',
	            yy: '%d ปี',
	        },
	    });
	
	    return th;
	
	})));


/***/ },
/* 571 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkmen [tk]
	//! author : Atamyrat Abdyrahmanov : https://github.com/atamyratabdy
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        1: "'inji",
	        5: "'inji",
	        8: "'inji",
	        70: "'inji",
	        80: "'inji",
	        2: "'nji",
	        7: "'nji",
	        20: "'nji",
	        50: "'nji",
	        3: "'ünji",
	        4: "'ünji",
	        100: "'ünji",
	        6: "'njy",
	        9: "'unjy",
	        10: "'unjy",
	        30: "'unjy",
	        60: "'ynjy",
	        90: "'ynjy",
	    };
	
	    var tk = moment.defineLocale('tk', {
	        months: 'Ýanwar_Fewral_Mart_Aprel_Maý_Iýun_Iýul_Awgust_Sentýabr_Oktýabr_Noýabr_Dekabr'.split(
	            '_'
	        ),
	        monthsShort: 'Ýan_Few_Mar_Apr_Maý_Iýn_Iýl_Awg_Sen_Okt_Noý_Dek'.split('_'),
	        weekdays: 'Ýekşenbe_Duşenbe_Sişenbe_Çarşenbe_Penşenbe_Anna_Şenbe'.split(
	            '_'
	        ),
	        weekdaysShort: 'Ýek_Duş_Siş_Çar_Pen_Ann_Şen'.split('_'),
	        weekdaysMin: 'Ýk_Dş_Sş_Çr_Pn_An_Şn'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[bugün sagat] LT',
	            nextDay: '[ertir sagat] LT',
	            nextWeek: '[indiki] dddd [sagat] LT',
	            lastDay: '[düýn] LT',
	            lastWeek: '[geçen] dddd [sagat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s soň',
	            past: '%s öň',
	            s: 'birnäçe sekunt',
	            m: 'bir minut',
	            mm: '%d minut',
	            h: 'bir sagat',
	            hh: '%d sagat',
	            d: 'bir gün',
	            dd: '%d gün',
	            M: 'bir aý',
	            MM: '%d aý',
	            y: 'bir ýyl',
	            yy: '%d ýyl',
	        },
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'Do':
	                case 'DD':
	                    return number;
	                default:
	                    if (number === 0) {
	                        // special case for zero
	                        return number + "'unjy";
	                    }
	                    var a = number % 10,
	                        b = (number % 100) - a,
	                        c = number >= 100 ? 100 : null;
	                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return tk;
	
	})));


/***/ },
/* 572 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tagalog (Philippines) [tl-ph]
	//! author : Dan Hagman : https://github.com/hagmandan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tlPh = moment.defineLocale('tl-ph', {
	        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
	            '_'
	        ),
	        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
	            '_'
	        ),
	        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'MM/D/YYYY',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY HH:mm',
	            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: 'LT [ngayong araw]',
	            nextDay: '[Bukas ng] LT',
	            nextWeek: 'LT [sa susunod na] dddd',
	            lastDay: 'LT [kahapon]',
	            lastWeek: 'LT [noong nakaraang] dddd',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'sa loob ng %s',
	            past: '%s ang nakalipas',
	            s: 'ilang segundo',
	            ss: '%d segundo',
	            m: 'isang minuto',
	            mm: '%d minuto',
	            h: 'isang oras',
	            hh: '%d oras',
	            d: 'isang araw',
	            dd: '%d araw',
	            M: 'isang buwan',
	            MM: '%d buwan',
	            y: 'isang taon',
	            yy: '%d taon',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function (number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return tlPh;
	
	})));


/***/ },
/* 573 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Klingon [tlh]
	//! author : Dominika Kruk : https://github.com/amaranthrose
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	    function translateFuture(output) {
	        var time = output;
	        time =
	            output.indexOf('jaj') !== -1
	                ? time.slice(0, -3) + 'leS'
	                : output.indexOf('jar') !== -1
	                  ? time.slice(0, -3) + 'waQ'
	                  : output.indexOf('DIS') !== -1
	                    ? time.slice(0, -3) + 'nem'
	                    : time + ' pIq';
	        return time;
	    }
	
	    function translatePast(output) {
	        var time = output;
	        time =
	            output.indexOf('jaj') !== -1
	                ? time.slice(0, -3) + 'Hu’'
	                : output.indexOf('jar') !== -1
	                  ? time.slice(0, -3) + 'wen'
	                  : output.indexOf('DIS') !== -1
	                    ? time.slice(0, -3) + 'ben'
	                    : time + ' ret';
	        return time;
	    }
	
	    function translate(number, withoutSuffix, string, isFuture) {
	        var numberNoun = numberAsNoun(number);
	        switch (string) {
	            case 'ss':
	                return numberNoun + ' lup';
	            case 'mm':
	                return numberNoun + ' tup';
	            case 'hh':
	                return numberNoun + ' rep';
	            case 'dd':
	                return numberNoun + ' jaj';
	            case 'MM':
	                return numberNoun + ' jar';
	            case 'yy':
	                return numberNoun + ' DIS';
	        }
	    }
	
	    function numberAsNoun(number) {
	        var hundred = Math.floor((number % 1000) / 100),
	            ten = Math.floor((number % 100) / 10),
	            one = number % 10,
	            word = '';
	        if (hundred > 0) {
	            word += numbersNouns[hundred] + 'vatlh';
	        }
	        if (ten > 0) {
	            word += (word !== '' ? ' ' : '') + numbersNouns[ten] + 'maH';
	        }
	        if (one > 0) {
	            word += (word !== '' ? ' ' : '') + numbersNouns[one];
	        }
	        return word === '' ? 'pagh' : word;
	    }
	
	    var tlh = moment.defineLocale('tlh', {
	        months: 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split(
	            '_'
	        ),
	        monthsShort:
	            'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
	            '_'
	        ),
	        weekdaysShort:
	            'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        weekdaysMin:
	            'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[DaHjaj] LT',
	            nextDay: '[wa’leS] LT',
	            nextWeek: 'LLL',
	            lastDay: '[wa’Hu’] LT',
	            lastWeek: 'LLL',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: translateFuture,
	            past: translatePast,
	            s: 'puS lup',
	            ss: translate,
	            m: 'wa’ tup',
	            mm: translate,
	            h: 'wa’ rep',
	            hh: translate,
	            d: 'wa’ jaj',
	            dd: translate,
	            M: 'wa’ jar',
	            MM: translate,
	            y: 'wa’ DIS',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return tlh;
	
	})));


/***/ },
/* 574 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkish [tr]
	//! authors : Erhan Gundogan : https://github.com/erhangundogan,
	//!           Burak Yiğit Kaya: https://github.com/BYK
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        1: "'inci",
	        5: "'inci",
	        8: "'inci",
	        70: "'inci",
	        80: "'inci",
	        2: "'nci",
	        7: "'nci",
	        20: "'nci",
	        50: "'nci",
	        3: "'üncü",
	        4: "'üncü",
	        100: "'üncü",
	        6: "'ncı",
	        9: "'uncu",
	        10: "'uncu",
	        30: "'uncu",
	        60: "'ıncı",
	        90: "'ıncı",
	    };
	
	    var tr = moment.defineLocale('tr', {
	        months: 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split(
	            '_'
	        ),
	        monthsShort: 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	        weekdays: 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split(
	            '_'
	        ),
	        weekdaysShort: 'Paz_Pzt_Sal_Çar_Per_Cum_Cmt'.split('_'),
	        weekdaysMin: 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'öö' : 'ÖÖ';
	            } else {
	                return isLower ? 'ös' : 'ÖS';
	            }
	        },
	        meridiemParse: /öö|ÖÖ|ös|ÖS/,
	        isPM: function (input) {
	            return input === 'ös' || input === 'ÖS';
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[bugün saat] LT',
	            nextDay: '[yarın saat] LT',
	            nextWeek: '[gelecek] dddd [saat] LT',
	            lastDay: '[dün] LT',
	            lastWeek: '[geçen] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s sonra',
	            past: '%s önce',
	            s: 'birkaç saniye',
	            ss: '%d saniye',
	            m: 'bir dakika',
	            mm: '%d dakika',
	            h: 'bir saat',
	            hh: '%d saat',
	            d: 'bir gün',
	            dd: '%d gün',
	            w: 'bir hafta',
	            ww: '%d hafta',
	            M: 'bir ay',
	            MM: '%d ay',
	            y: 'bir yıl',
	            yy: '%d yıl',
	        },
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'Do':
	                case 'DD':
	                    return number;
	                default:
	                    if (number === 0) {
	                        // special case for zero
	                        return number + "'ıncı";
	                    }
	                    var a = number % 10,
	                        b = (number % 100) - a,
	                        c = number >= 100 ? 100 : null;
	                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return tr;
	
	})));


/***/ },
/* 575 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Talossan [tzl]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	//! author : Iustì Canun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	    // This is currently too difficult (maybe even impossible) to add.
	    var tzl = moment.defineLocale('tzl', {
	        months: 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	        weekdays: 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	        weekdaysShort: 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	        weekdaysMin: 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM [dallas] YYYY',
	            LLL: 'D. MMMM [dallas] YYYY HH.mm',
	            LLLL: 'dddd, [li] D. MMMM [dallas] YYYY HH.mm',
	        },
	        meridiemParse: /d\'o|d\'a/i,
	        isPM: function (input) {
	            return "d'o" === input.toLowerCase();
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? "d'o" : "D'O";
	            } else {
	                return isLower ? "d'a" : "D'A";
	            }
	        },
	        calendar: {
	            sameDay: '[oxhi à] LT',
	            nextDay: '[demà à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[ieiri à] LT',
	            lastWeek: '[sür el] dddd [lasteu à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'osprei %s',
	            past: 'ja%s',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['viensas secunds', "'iensas secunds"],
	            ss: [number + ' secunds', '' + number + ' secunds'],
	            m: ["'n míut", "'iens míut"],
	            mm: [number + ' míuts', '' + number + ' míuts'],
	            h: ["'n þora", "'iensa þora"],
	            hh: [number + ' þoras', '' + number + ' þoras'],
	            d: ["'n ziua", "'iensa ziua"],
	            dd: [number + ' ziuas', '' + number + ' ziuas'],
	            M: ["'n mes", "'iens mes"],
	            MM: [number + ' mesen', '' + number + ' mesen'],
	            y: ["'n ar", "'iens ar"],
	            yy: [number + ' ars', '' + number + ' ars'],
	        };
	        return isFuture
	            ? format[key][0]
	            : withoutSuffix
	              ? format[key][0]
	              : format[key][1];
	    }
	
	    return tzl;
	
	})));


/***/ },
/* 576 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight Latin [tzm-latn]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tzmLatn = moment.defineLocale('tzm-latn', {
	        months: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
	            '_'
	        ),
	        monthsShort:
	            'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
	                '_'
	            ),
	        weekdays: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysShort: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysMin: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[asdkh g] LT',
	            nextDay: '[aska g] LT',
	            nextWeek: 'dddd [g] LT',
	            lastDay: '[assant g] LT',
	            lastWeek: 'dddd [g] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dadkh s yan %s',
	            past: 'yan %s',
	            s: 'imik',
	            ss: '%d imik',
	            m: 'minuḍ',
	            mm: '%d minuḍ',
	            h: 'saɛa',
	            hh: '%d tassaɛin',
	            d: 'ass',
	            dd: '%d ossan',
	            M: 'ayowr',
	            MM: '%d iyyirn',
	            y: 'asgas',
	            yy: '%d isgasn',
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return tzmLatn;
	
	})));


/***/ },
/* 577 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight [tzm]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tzm = moment.defineLocale('tzm', {
	        months: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
	            '_'
	        ),
	        monthsShort:
	            'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
	                '_'
	            ),
	        weekdays: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysShort: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysMin: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	            nextWeek: 'dddd [ⴴ] LT',
	            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	            lastWeek: 'dddd [ⴴ] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	            past: 'ⵢⴰⵏ %s',
	            s: 'ⵉⵎⵉⴽ',
	            ss: '%d ⵉⵎⵉⴽ',
	            m: 'ⵎⵉⵏⵓⴺ',
	            mm: '%d ⵎⵉⵏⵓⴺ',
	            h: 'ⵙⴰⵄⴰ',
	            hh: '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	            d: 'ⴰⵙⵙ',
	            dd: '%d oⵙⵙⴰⵏ',
	            M: 'ⴰⵢoⵓⵔ',
	            MM: '%d ⵉⵢⵢⵉⵔⵏ',
	            y: 'ⴰⵙⴳⴰⵙ',
	            yy: '%d ⵉⵙⴳⴰⵙⵏ',
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return tzm;
	
	})));


/***/ },
/* 578 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uyghur (China) [ug-cn]
	//! author: boyaq : https://github.com/boyaq
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ugCn = moment.defineLocale('ug-cn', {
	        months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	            '_'
	        ),
	        monthsShort:
	            'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	                '_'
	            ),
	        weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split(
	            '_'
	        ),
	        weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
	            LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
	            LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
	        },
	        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                meridiem === 'يېرىم كېچە' ||
	                meridiem === 'سەھەر' ||
	                meridiem === 'چۈشتىن بۇرۇن'
	            ) {
	                return hour;
	            } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
	                return hour + 12;
	            } else {
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return 'يېرىم كېچە';
	            } else if (hm < 900) {
	                return 'سەھەر';
	            } else if (hm < 1130) {
	                return 'چۈشتىن بۇرۇن';
	            } else if (hm < 1230) {
	                return 'چۈش';
	            } else if (hm < 1800) {
	                return 'چۈشتىن كېيىن';
	            } else {
	                return 'كەچ';
	            }
	        },
	        calendar: {
	            sameDay: '[بۈگۈن سائەت] LT',
	            nextDay: '[ئەتە سائەت] LT',
	            nextWeek: '[كېلەركى] dddd [سائەت] LT',
	            lastDay: '[تۆنۈگۈن] LT',
	            lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s كېيىن',
	            past: '%s بۇرۇن',
	            s: 'نەچچە سېكونت',
	            ss: '%d سېكونت',
	            m: 'بىر مىنۇت',
	            mm: '%d مىنۇت',
	            h: 'بىر سائەت',
	            hh: '%d سائەت',
	            d: 'بىر كۈن',
	            dd: '%d كۈن',
	            M: 'بىر ئاي',
	            MM: '%d ئاي',
	            y: 'بىر يىل',
	            yy: '%d يىل',
	        },
	
	        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '-كۈنى';
	                case 'w':
	                case 'W':
	                    return number + '-ھەپتە';
	                default:
	                    return number;
	            }
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 1st is the first week of the year.
	        },
	    });
	
	    return ugCn;
	
	})));


/***/ },
/* 579 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Ukrainian [uk]
	//! author : zemlanin : https://github.com/zemlanin
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	              ? forms[1]
	              : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
	            mm: withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	            hh: withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	            dd: 'день_дні_днів',
	            MM: 'місяць_місяці_місяців',
	            yy: 'рік_роки_років',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвилина' : 'хвилину';
	        } else if (key === 'h') {
	            return withoutSuffix ? 'година' : 'годину';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    function weekdaysCaseReplace(m, format) {
	        var weekdays = {
	                nominative:
	                    'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split(
	                        '_'
	                    ),
	                accusative:
	                    'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split(
	                        '_'
	                    ),
	                genitive:
	                    'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split(
	                        '_'
	                    ),
	            },
	            nounCase;
	
	        if (m === true) {
	            return weekdays['nominative']
	                .slice(1, 7)
	                .concat(weekdays['nominative'].slice(0, 1));
	        }
	        if (!m) {
	            return weekdays['nominative'];
	        }
	
	        nounCase = /(\[[ВвУу]\]) ?dddd/.test(format)
	            ? 'accusative'
	            : /\[?(?:минулої|наступної)? ?\] ?dddd/.test(format)
	              ? 'genitive'
	              : 'nominative';
	        return weekdays[nounCase][m.day()];
	    }
	    function processHoursFunction(str) {
	        return function () {
	            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	        };
	    }
	
	    var uk = moment.defineLocale('uk', {
	        months: {
	            format: 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split(
	                '_'
	            ),
	            standalone:
	                'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split(
	                    '_'
	                ),
	        },
	        monthsShort: 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split(
	            '_'
	        ),
	        weekdays: weekdaysCaseReplace,
	        weekdaysShort: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY р.',
	            LLL: 'D MMMM YYYY р., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY р., HH:mm',
	        },
	        calendar: {
	            sameDay: processHoursFunction('[Сьогодні '),
	            nextDay: processHoursFunction('[Завтра '),
	            lastDay: processHoursFunction('[Вчора '),
	            nextWeek: processHoursFunction('[У] dddd ['),
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return processHoursFunction('[Минулої] dddd [').call(this);
	                    case 1:
	                    case 2:
	                    case 4:
	                        return processHoursFunction('[Минулого] dddd [').call(this);
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: '%s тому',
	            s: 'декілька секунд',
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: 'годину',
	            hh: relativeTimeWithPlural,
	            d: 'день',
	            dd: relativeTimeWithPlural,
	            M: 'місяць',
	            MM: relativeTimeWithPlural,
	            y: 'рік',
	            yy: relativeTimeWithPlural,
	        },
	        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	        meridiemParse: /ночі|ранку|дня|вечора/,
	        isPM: function (input) {
	            return /^(дня|вечора)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночі';
	            } else if (hour < 12) {
	                return 'ранку';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечора';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return uk;
	
	})));


/***/ },
/* 580 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Urdu [ur]
	//! author : Sawood Alam : https://github.com/ibnesayeed
	//! author : Zack : https://github.com/ZackVision
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'جنوری',
	            'فروری',
	            'مارچ',
	            'اپریل',
	            'مئی',
	            'جون',
	            'جولائی',
	            'اگست',
	            'ستمبر',
	            'اکتوبر',
	            'نومبر',
	            'دسمبر',
	        ],
	        days = ['اتوار', 'پیر', 'منگل', 'بدھ', 'جمعرات', 'جمعہ', 'ہفتہ'];
	
	    var ur = moment.defineLocale('ur', {
	        months: months,
	        monthsShort: months,
	        weekdays: days,
	        weekdaysShort: days,
	        weekdaysMin: days,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd، D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /صبح|شام/,
	        isPM: function (input) {
	            return 'شام' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar: {
	            sameDay: '[آج بوقت] LT',
	            nextDay: '[کل بوقت] LT',
	            nextWeek: 'dddd [بوقت] LT',
	            lastDay: '[گذشتہ روز بوقت] LT',
	            lastWeek: '[گذشتہ] dddd [بوقت] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s بعد',
	            past: '%s قبل',
	            s: 'چند سیکنڈ',
	            ss: '%d سیکنڈ',
	            m: 'ایک منٹ',
	            mm: '%d منٹ',
	            h: 'ایک گھنٹہ',
	            hh: '%d گھنٹے',
	            d: 'ایک دن',
	            dd: '%d دن',
	            M: 'ایک ماہ',
	            MM: '%d ماہ',
	            y: 'ایک سال',
	            yy: '%d سال',
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ur;
	
	})));


/***/ },
/* 581 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek Latin [uz-latn]
	//! author : Rasulbek Mirzayev : github.com/Rasulbeeek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var uzLatn = moment.defineLocale('uz-latn', {
	        months: 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split(
	            '_'
	        ),
	        monthsShort: 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
	        weekdays:
	            'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split(
	                '_'
	            ),
	        weekdaysShort: 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
	        weekdaysMin: 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'D MMMM YYYY, dddd HH:mm',
	        },
	        calendar: {
	            sameDay: '[Bugun soat] LT [da]',
	            nextDay: '[Ertaga] LT [da]',
	            nextWeek: 'dddd [kuni soat] LT [da]',
	            lastDay: '[Kecha soat] LT [da]',
	            lastWeek: "[O'tgan] dddd [kuni soat] LT [da]",
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'Yaqin %s ichida',
	            past: 'Bir necha %s oldin',
	            s: 'soniya',
	            ss: '%d soniya',
	            m: 'bir daqiqa',
	            mm: '%d daqiqa',
	            h: 'bir soat',
	            hh: '%d soat',
	            d: 'bir kun',
	            dd: '%d kun',
	            M: 'bir oy',
	            MM: '%d oy',
	            y: 'bir yil',
	            yy: '%d yil',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return uzLatn;
	
	})));


/***/ },
/* 582 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek [uz]
	//! author : Sardor Muminov : https://github.com/muminoff
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var uz = moment.defineLocale('uz', {
	        months: 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
	            '_'
	        ),
	        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays: 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	        weekdaysShort: 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	        weekdaysMin: 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'D MMMM YYYY, dddd HH:mm',
	        },
	        calendar: {
	            sameDay: '[Бугун соат] LT [да]',
	            nextDay: '[Эртага] LT [да]',
	            nextWeek: 'dddd [куни соат] LT [да]',
	            lastDay: '[Кеча соат] LT [да]',
	            lastWeek: '[Утган] dddd [куни соат] LT [да]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'Якин %s ичида',
	            past: 'Бир неча %s олдин',
	            s: 'фурсат',
	            ss: '%d фурсат',
	            m: 'бир дакика',
	            mm: '%d дакика',
	            h: 'бир соат',
	            hh: '%d соат',
	            d: 'бир кун',
	            dd: '%d кун',
	            M: 'бир ой',
	            MM: '%d ой',
	            y: 'бир йил',
	            yy: '%d йил',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return uz;
	
	})));


/***/ },
/* 583 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Vietnamese [vi]
	//! author : Bang Nguyen : https://github.com/bangnk
	//! author : Chien Kira : https://github.com/chienkira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var vi = moment.defineLocale('vi', {
	        months: 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split(
	            '_'
	        ),
	        monthsShort:
	            'Thg 01_Thg 02_Thg 03_Thg 04_Thg 05_Thg 06_Thg 07_Thg 08_Thg 09_Thg 10_Thg 11_Thg 12'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split(
	            '_'
	        ),
	        weekdaysShort: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysMin: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysParseExact: true,
	        meridiemParse: /sa|ch/i,
	        isPM: function (input) {
	            return /^ch$/i.test(input);
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'sa' : 'SA';
	            } else {
	                return isLower ? 'ch' : 'CH';
	            }
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [năm] YYYY',
	            LLL: 'D MMMM [năm] YYYY HH:mm',
	            LLLL: 'dddd, D MMMM [năm] YYYY HH:mm',
	            l: 'DD/M/YYYY',
	            ll: 'D MMM YYYY',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd, D MMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hôm nay lúc] LT',
	            nextDay: '[Ngày mai lúc] LT',
	            nextWeek: 'dddd [tuần tới lúc] LT',
	            lastDay: '[Hôm qua lúc] LT',
	            lastWeek: 'dddd [tuần trước lúc] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s tới',
	            past: '%s trước',
	            s: 'vài giây',
	            ss: '%d giây',
	            m: 'một phút',
	            mm: '%d phút',
	            h: 'một giờ',
	            hh: '%d giờ',
	            d: 'một ngày',
	            dd: '%d ngày',
	            w: 'một tuần',
	            ww: '%d tuần',
	            M: 'một tháng',
	            MM: '%d tháng',
	            y: 'một năm',
	            yy: '%d năm',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function (number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return vi;
	
	})));


/***/ },
/* 584 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Pseudo [x-pseudo]
	//! author : Andrew Hood : https://github.com/andrewhood125
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var xPseudo = moment.defineLocale('x-pseudo', {
	        months: 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split(
	            '_'
	        ),
	        monthsShort:
	            'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split(
	                '_'
	            ),
	        weekdaysShort: 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	        weekdaysMin: 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[T~ódá~ý át] LT',
	            nextDay: '[T~ómó~rró~w át] LT',
	            nextWeek: 'dddd [át] LT',
	            lastDay: '[Ý~ést~érdá~ý át] LT',
	            lastWeek: '[L~ást] dddd [át] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'í~ñ %s',
	            past: '%s á~gó',
	            s: 'á ~féw ~sécó~ñds',
	            ss: '%d s~écóñ~ds',
	            m: 'á ~míñ~úté',
	            mm: '%d m~íñú~tés',
	            h: 'á~ñ hó~úr',
	            hh: '%d h~óúrs',
	            d: 'á ~dáý',
	            dd: '%d d~áýs',
	            M: 'á ~móñ~th',
	            MM: '%d m~óñt~hs',
	            y: 'á ~ýéár',
	            yy: '%d ý~éárs',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                          ? 'st'
	                          : b === 2
	                            ? 'nd'
	                            : b === 3
	                              ? 'rd'
	                              : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return xPseudo;
	
	})));


/***/ },
/* 585 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Yoruba Nigeria [yo]
	//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var yo = moment.defineLocale('yo', {
	        months: 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split(
	            '_'
	        ),
	        monthsShort: 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
	        weekdays: 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
	        weekdaysShort: 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
	        weekdaysMin: 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Ònì ni] LT',
	            nextDay: '[Ọ̀la ni] LT',
	            nextWeek: "dddd [Ọsẹ̀ tón'bọ] [ni] LT",
	            lastDay: '[Àna ni] LT',
	            lastWeek: 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ní %s',
	            past: '%s kọjá',
	            s: 'ìsẹjú aayá die',
	            ss: 'aayá %d',
	            m: 'ìsẹjú kan',
	            mm: 'ìsẹjú %d',
	            h: 'wákati kan',
	            hh: 'wákati %d',
	            d: 'ọjọ́ kan',
	            dd: 'ọjọ́ %d',
	            M: 'osù kan',
	            MM: 'osù %d',
	            y: 'ọdún kan',
	            yy: 'ọdún %d',
	        },
	        dayOfMonthOrdinalParse: /ọjọ́\s\d{1,2}/,
	        ordinal: 'ọjọ́ %d',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return yo;
	
	})));


/***/ },
/* 586 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (China) [zh-cn]
	//! author : suupic : https://github.com/suupic
	//! author : Zeno Zeng : https://github.com/zenozeng
	//! author : uu109 : https://github.com/uu109
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhCn = moment.defineLocale('zh-cn', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日Ah点mm分',
	            LLLL: 'YYYY年M月D日ddddAh点mm分',
	            l: 'YYYY/M/D',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            } else {
	                // '中午'
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天]LT',
	            nextDay: '[明天]LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    return '[下]dddLT';
	                } else {
	                    return '[本]dddLT';
	                }
	            },
	            lastDay: '[昨天]LT',
	            lastWeek: function (now) {
	                if (this.week() !== now.week()) {
	                    return '[上]dddLT';
	                } else {
	                    return '[本]dddLT';
	                }
	            },
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '周';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s后',
	            past: '%s前',
	            s: '几秒',
	            ss: '%d 秒',
	            m: '1 分钟',
	            mm: '%d 分钟',
	            h: '1 小时',
	            hh: '%d 小时',
	            d: '1 天',
	            dd: '%d 天',
	            w: '1 周',
	            ww: '%d 周',
	            M: '1 个月',
	            MM: '%d 个月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	        week: {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return zhCn;
	
	})));


/***/ },
/* 587 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Hong Kong) [zh-hk]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Konstantin : https://github.com/skfd
	//! author : Anthony : https://github.com/anthonylau
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhHk = moment.defineLocale('zh-hk', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日dddd HH:mm',
	            l: 'YYYY/M/D',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1200) {
	                return '上午';
	            } else if (hm === 1200) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天]LT',
	            nextDay: '[明天]LT',
	            nextWeek: '[下]ddddLT',
	            lastDay: '[昨天]LT',
	            lastWeek: '[上]ddddLT',
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '幾秒',
	            ss: '%d 秒',
	            m: '1 分鐘',
	            mm: '%d 分鐘',
	            h: '1 小時',
	            hh: '%d 小時',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 個月',
	            MM: '%d 個月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	    });
	
	    return zhHk;
	
	})));


/***/ },
/* 588 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Macau) [zh-mo]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Tan Yuanhong : https://github.com/le0tan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhMo = moment.defineLocale('zh-mo', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日dddd HH:mm',
	            l: 'D/M/YYYY',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天] LT',
	            nextDay: '[明天] LT',
	            nextWeek: '[下]dddd LT',
	            lastDay: '[昨天] LT',
	            lastWeek: '[上]dddd LT',
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s內',
	            past: '%s前',
	            s: '幾秒',
	            ss: '%d 秒',
	            m: '1 分鐘',
	            mm: '%d 分鐘',
	            h: '1 小時',
	            hh: '%d 小時',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 個月',
	            MM: '%d 個月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	    });
	
	    return zhMo;
	
	})));


/***/ },
/* 589 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Taiwan) [zh-tw]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhTw = moment.defineLocale('zh-tw', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日dddd HH:mm',
	            l: 'YYYY/M/D',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天] LT',
	            nextDay: '[明天] LT',
	            nextWeek: '[下]dddd LT',
	            lastDay: '[昨天] LT',
	            lastWeek: '[上]dddd LT',
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '幾秒',
	            ss: '%d 秒',
	            m: '1 分鐘',
	            mm: '%d 分鐘',
	            h: '1 小時',
	            hh: '%d 小時',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 個月',
	            MM: '%d 個月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	    });
	
	    return zhTw;
	
	})));


/***/ },
/* 590 */
/***/ function(module, exports) {

	'use strict';
	
	var numberIsNaN = function (value) {
		return value !== value;
	};
	
	module.exports = function is(a, b) {
		if (a === 0 && b === 0) {
			return 1 / a === 1 / b;
		}
		if (a === b) {
			return true;
		}
		if (numberIsNaN(a) && numberIsNaN(b)) {
			return true;
		}
		return false;
	};
	


/***/ },
/* 591 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(590);
	
	module.exports = function getPolyfill() {
		return typeof Object.is === 'function' ? Object.is : implementation;
	};


/***/ },
/* 592 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var slice = Array.prototype.slice;
	var isArgs = __webpack_require__(593);
	
	var origKeys = Object.keys;
	var keysShim = origKeys ? function keys(o) { return origKeys(o); } : __webpack_require__(1352);
	
	var originalKeys = Object.keys;
	
	keysShim.shim = function shimObjectKeys() {
		if (Object.keys) {
			var keysWorksWithArguments = (function () {
				// Safari 5.0 bug
				var args = Object.keys(arguments);
				return args && args.length === arguments.length;
			}(1, 2));
			if (!keysWorksWithArguments) {
				Object.keys = function keys(object) { // eslint-disable-line func-name-matching
					if (isArgs(object)) {
						return originalKeys(slice.call(object));
					}
					return originalKeys(object);
				};
			}
		} else {
			Object.keys = keysShim;
		}
		return Object.keys || keysShim;
	};
	
	module.exports = keysShim;


/***/ },
/* 593 */
/***/ function(module, exports) {

	'use strict';
	
	var toStr = Object.prototype.toString;
	
	module.exports = function isArguments(value) {
		var str = toStr.call(value);
		var isArgs = str === '[object Arguments]';
		if (!isArgs) {
			isArgs = str !== '[object Array]' &&
				value !== null &&
				typeof value === 'object' &&
				typeof value.length === 'number' &&
				value.length >= 0 &&
				toStr.call(value.callee) === '[object Function]';
		}
		return isArgs;
	};


/***/ },
/* 594 */
/***/ function(module, exports, __webpack_require__) {

	// String encode/decode helpers
	'use strict';
	
	
	var utils = __webpack_require__(99);
	
	
	// Quick check if we can use fast array to bin string conversion
	//
	// - apply(Array) can fail on Android 2.2
	// - apply(Uint8Array) can fail on iOS 5.1 Safari
	//
	var STR_APPLY_OK = true;
	var STR_APPLY_UIA_OK = true;
	
	try { String.fromCharCode.apply(null, [ 0 ]); } catch (__) { STR_APPLY_OK = false; }
	try { String.fromCharCode.apply(null, new Uint8Array(1)); } catch (__) { STR_APPLY_UIA_OK = false; }
	
	
	// Table with utf8 lengths (calculated by first byte of sequence)
	// Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
	// because max possible codepoint is 0x10ffff
	var _utf8len = new utils.Buf8(256);
	for (var q = 0; q < 256; q++) {
	  _utf8len[q] = (q >= 252 ? 6 : q >= 248 ? 5 : q >= 240 ? 4 : q >= 224 ? 3 : q >= 192 ? 2 : 1);
	}
	_utf8len[254] = _utf8len[254] = 1; // Invalid sequence start
	
	
	// convert string to array (typed, when possible)
	exports.string2buf = function (str) {
	  var buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;
	
	  // count binary size
	  for (m_pos = 0; m_pos < str_len; m_pos++) {
	    c = str.charCodeAt(m_pos);
	    if ((c & 0xfc00) === 0xd800 && (m_pos + 1 < str_len)) {
	      c2 = str.charCodeAt(m_pos + 1);
	      if ((c2 & 0xfc00) === 0xdc00) {
	        c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
	        m_pos++;
	      }
	    }
	    buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
	  }
	
	  // allocate buffer
	  buf = new utils.Buf8(buf_len);
	
	  // convert
	  for (i = 0, m_pos = 0; i < buf_len; m_pos++) {
	    c = str.charCodeAt(m_pos);
	    if ((c & 0xfc00) === 0xd800 && (m_pos + 1 < str_len)) {
	      c2 = str.charCodeAt(m_pos + 1);
	      if ((c2 & 0xfc00) === 0xdc00) {
	        c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
	        m_pos++;
	      }
	    }
	    if (c < 0x80) {
	      /* one byte */
	      buf[i++] = c;
	    } else if (c < 0x800) {
	      /* two bytes */
	      buf[i++] = 0xC0 | (c >>> 6);
	      buf[i++] = 0x80 | (c & 0x3f);
	    } else if (c < 0x10000) {
	      /* three bytes */
	      buf[i++] = 0xE0 | (c >>> 12);
	      buf[i++] = 0x80 | (c >>> 6 & 0x3f);
	      buf[i++] = 0x80 | (c & 0x3f);
	    } else {
	      /* four bytes */
	      buf[i++] = 0xf0 | (c >>> 18);
	      buf[i++] = 0x80 | (c >>> 12 & 0x3f);
	      buf[i++] = 0x80 | (c >>> 6 & 0x3f);
	      buf[i++] = 0x80 | (c & 0x3f);
	    }
	  }
	
	  return buf;
	};
	
	// Helper (used in 2 places)
	function buf2binstring(buf, len) {
	  // On Chrome, the arguments in a function call that are allowed is `65534`.
	  // If the length of the buffer is smaller than that, we can use this optimization,
	  // otherwise we will take a slower path.
	  if (len < 65534) {
	    if ((buf.subarray && STR_APPLY_UIA_OK) || (!buf.subarray && STR_APPLY_OK)) {
	      return String.fromCharCode.apply(null, utils.shrinkBuf(buf, len));
	    }
	  }
	
	  var result = '';
	  for (var i = 0; i < len; i++) {
	    result += String.fromCharCode(buf[i]);
	  }
	  return result;
	}
	
	
	// Convert byte array to binary string
	exports.buf2binstring = function (buf) {
	  return buf2binstring(buf, buf.length);
	};
	
	
	// Convert binary string (typed, when possible)
	exports.binstring2buf = function (str) {
	  var buf = new utils.Buf8(str.length);
	  for (var i = 0, len = buf.length; i < len; i++) {
	    buf[i] = str.charCodeAt(i);
	  }
	  return buf;
	};
	
	
	// convert array to string
	exports.buf2string = function (buf, max) {
	  var i, out, c, c_len;
	  var len = max || buf.length;
	
	  // Reserve max possible length (2 words per char)
	  // NB: by unknown reasons, Array is significantly faster for
	  //     String.fromCharCode.apply than Uint16Array.
	  var utf16buf = new Array(len * 2);
	
	  for (out = 0, i = 0; i < len;) {
	    c = buf[i++];
	    // quick process ascii
	    if (c < 0x80) { utf16buf[out++] = c; continue; }
	
	    c_len = _utf8len[c];
	    // skip 5 & 6 byte codes
	    if (c_len > 4) { utf16buf[out++] = 0xfffd; i += c_len - 1; continue; }
	
	    // apply mask on first byte
	    c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
	    // join the rest
	    while (c_len > 1 && i < len) {
	      c = (c << 6) | (buf[i++] & 0x3f);
	      c_len--;
	    }
	
	    // terminated by end of string?
	    if (c_len > 1) { utf16buf[out++] = 0xfffd; continue; }
	
	    if (c < 0x10000) {
	      utf16buf[out++] = c;
	    } else {
	      c -= 0x10000;
	      utf16buf[out++] = 0xd800 | ((c >> 10) & 0x3ff);
	      utf16buf[out++] = 0xdc00 | (c & 0x3ff);
	    }
	  }
	
	  return buf2binstring(utf16buf, out);
	};
	
	
	// Calculate max possible position in utf8 buffer,
	// that will not break sequence. If that's not possible
	// - (very small limits) return max size as is.
	//
	// buf[] - utf8 bytes array
	// max   - length limit (mandatory);
	exports.utf8border = function (buf, max) {
	  var pos;
	
	  max = max || buf.length;
	  if (max > buf.length) { max = buf.length; }
	
	  // go back from last position, until start of sequence found
	  pos = max - 1;
	  while (pos >= 0 && (buf[pos] & 0xC0) === 0x80) { pos--; }
	
	  // Very small and broken sequence,
	  // return max, because we should return something anyway.
	  if (pos < 0) { return max; }
	
	  // If we came to start of buffer - that means buffer is too small,
	  // return max too.
	  if (pos === 0) { return max; }
	
	  return (pos + _utf8len[buf[pos]] > max) ? pos : max;
	};


/***/ },
/* 595 */
/***/ function(module, exports) {

	'use strict';
	
	// Note: adler32 takes 12% for level 0 and 2% for level 6.
	// It isn't worth it to make additional optimizations as in original.
	// Small size is preferable.
	
	// (C) 1995-2013 Jean-loup Gailly and Mark Adler
	// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	//
	// This software is provided 'as-is', without any express or implied
	// warranty. In no event will the authors be held liable for any damages
	// arising from the use of this software.
	//
	// Permission is granted to anyone to use this software for any purpose,
	// including commercial applications, and to alter it and redistribute it
	// freely, subject to the following restrictions:
	//
	// 1. The origin of this software must not be misrepresented; you must not
	//   claim that you wrote the original software. If you use this software
	//   in a product, an acknowledgment in the product documentation would be
	//   appreciated but is not required.
	// 2. Altered source versions must be plainly marked as such, and must not be
	//   misrepresented as being the original software.
	// 3. This notice may not be removed or altered from any source distribution.
	
	function adler32(adler, buf, len, pos) {
	  var s1 = (adler & 0xffff) |0,
	      s2 = ((adler >>> 16) & 0xffff) |0,
	      n = 0;
	
	  while (len !== 0) {
	    // Set limit ~ twice less than 5552, to keep
	    // s2 in 31-bits, because we force signed ints.
	    // in other case %= will fail.
	    n = len > 2000 ? 2000 : len;
	    len -= n;
	
	    do {
	      s1 = (s1 + buf[pos++]) |0;
	      s2 = (s2 + s1) |0;
	    } while (--n);
	
	    s1 %= 65521;
	    s2 %= 65521;
	  }
	
	  return (s1 | (s2 << 16)) |0;
	}
	
	
	module.exports = adler32;


/***/ },
/* 596 */
/***/ function(module, exports) {

	'use strict';
	
	// (C) 1995-2013 Jean-loup Gailly and Mark Adler
	// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	//
	// This software is provided 'as-is', without any express or implied
	// warranty. In no event will the authors be held liable for any damages
	// arising from the use of this software.
	//
	// Permission is granted to anyone to use this software for any purpose,
	// including commercial applications, and to alter it and redistribute it
	// freely, subject to the following restrictions:
	//
	// 1. The origin of this software must not be misrepresented; you must not
	//   claim that you wrote the original software. If you use this software
	//   in a product, an acknowledgment in the product documentation would be
	//   appreciated but is not required.
	// 2. Altered source versions must be plainly marked as such, and must not be
	//   misrepresented as being the original software.
	// 3. This notice may not be removed or altered from any source distribution.
	
	module.exports = {
	
	  /* Allowed flush values; see deflate() and inflate() below for details */
	  Z_NO_FLUSH:         0,
	  Z_PARTIAL_FLUSH:    1,
	  Z_SYNC_FLUSH:       2,
	  Z_FULL_FLUSH:       3,
	  Z_FINISH:           4,
	  Z_BLOCK:            5,
	  Z_TREES:            6,
	
	  /* Return codes for the compression/decompression functions. Negative values
	  * are errors, positive values are used for special but normal events.
	  */
	  Z_OK:               0,
	  Z_STREAM_END:       1,
	  Z_NEED_DICT:        2,
	  Z_ERRNO:           -1,
	  Z_STREAM_ERROR:    -2,
	  Z_DATA_ERROR:      -3,
	  //Z_MEM_ERROR:     -4,
	  Z_BUF_ERROR:       -5,
	  //Z_VERSION_ERROR: -6,
	
	  /* compression levels */
	  Z_NO_COMPRESSION:         0,
	  Z_BEST_SPEED:             1,
	  Z_BEST_COMPRESSION:       9,
	  Z_DEFAULT_COMPRESSION:   -1,
	
	
	  Z_FILTERED:               1,
	  Z_HUFFMAN_ONLY:           2,
	  Z_RLE:                    3,
	  Z_FIXED:                  4,
	  Z_DEFAULT_STRATEGY:       0,
	
	  /* Possible values of the data_type field (though see inflate()) */
	  Z_BINARY:                 0,
	  Z_TEXT:                   1,
	  //Z_ASCII:                1, // = Z_TEXT (deprecated)
	  Z_UNKNOWN:                2,
	
	  /* The deflate compression method */
	  Z_DEFLATED:               8
	  //Z_NULL:                 null // Use -1 or null inline, depending on var type
	};


/***/ },
/* 597 */
/***/ function(module, exports) {

	'use strict';
	
	// Note: we can't get significant speed boost here.
	// So write code to minimize size - no pregenerated tables
	// and array tools dependencies.
	
	// (C) 1995-2013 Jean-loup Gailly and Mark Adler
	// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	//
	// This software is provided 'as-is', without any express or implied
	// warranty. In no event will the authors be held liable for any damages
	// arising from the use of this software.
	//
	// Permission is granted to anyone to use this software for any purpose,
	// including commercial applications, and to alter it and redistribute it
	// freely, subject to the following restrictions:
	//
	// 1. The origin of this software must not be misrepresented; you must not
	//   claim that you wrote the original software. If you use this software
	//   in a product, an acknowledgment in the product documentation would be
	//   appreciated but is not required.
	// 2. Altered source versions must be plainly marked as such, and must not be
	//   misrepresented as being the original software.
	// 3. This notice may not be removed or altered from any source distribution.
	
	// Use ordinary array, since untyped makes no boost here
	function makeTable() {
	  var c, table = [];
	
	  for (var n = 0; n < 256; n++) {
	    c = n;
	    for (var k = 0; k < 8; k++) {
	      c = ((c & 1) ? (0xEDB88320 ^ (c >>> 1)) : (c >>> 1));
	    }
	    table[n] = c;
	  }
	
	  return table;
	}
	
	// Create table on load. Just 255 signed longs. Not a problem.
	var crcTable = makeTable();
	
	
	function crc32(crc, buf, len, pos) {
	  var t = crcTable,
	      end = pos + len;
	
	  crc ^= -1;
	
	  for (var i = pos; i < end; i++) {
	    crc = (crc >>> 8) ^ t[(crc ^ buf[i]) & 0xFF];
	  }
	
	  return (crc ^ (-1)); // >>> 0;
	}
	
	
	module.exports = crc32;


/***/ },
/* 598 */
/***/ function(module, exports) {

	'use strict';
	
	// (C) 1995-2013 Jean-loup Gailly and Mark Adler
	// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	//
	// This software is provided 'as-is', without any express or implied
	// warranty. In no event will the authors be held liable for any damages
	// arising from the use of this software.
	//
	// Permission is granted to anyone to use this software for any purpose,
	// including commercial applications, and to alter it and redistribute it
	// freely, subject to the following restrictions:
	//
	// 1. The origin of this software must not be misrepresented; you must not
	//   claim that you wrote the original software. If you use this software
	//   in a product, an acknowledgment in the product documentation would be
	//   appreciated but is not required.
	// 2. Altered source versions must be plainly marked as such, and must not be
	//   misrepresented as being the original software.
	// 3. This notice may not be removed or altered from any source distribution.
	
	function ZStream() {
	  /* next input byte */
	  this.input = null; // JS specific, because we have no pointers
	  this.next_in = 0;
	  /* number of bytes available at input */
	  this.avail_in = 0;
	  /* total number of input bytes read so far */
	  this.total_in = 0;
	  /* next output byte should be put there */
	  this.output = null; // JS specific, because we have no pointers
	  this.next_out = 0;
	  /* remaining free space at output */
	  this.avail_out = 0;
	  /* total number of bytes output so far */
	  this.total_out = 0;
	  /* last error message, NULL if no error */
	  this.msg = ''/*Z_NULL*/;
	  /* not visible by applications */
	  this.state = null;
	  /* best guess about the data type: binary or text */
	  this.data_type = 2/*Z_UNKNOWN*/;
	  /* adler32 value of the uncompressed data */
	  this.adler = 0;
	}
	
	module.exports = ZStream;


/***/ },
/* 599 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var toIndexedObject = __webpack_require__(114);
	var toAbsoluteIndex = __webpack_require__(1416);
	var lengthOfArrayLike = __webpack_require__(613);
	
	// `Array.prototype.{ indexOf, includes }` methods implementation
	var createMethod = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIndexedObject($this);
	    var length = lengthOfArrayLike(O);
	    if (length === 0) return !IS_INCLUDES && -1;
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare -- NaN check
	    if (IS_INCLUDES && el !== el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare -- NaN check
	      if (value !== value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) {
	      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};
	
	module.exports = {
	  // `Array.prototype.includes` method
	  // https://tc39.es/ecma262/#sec-array.prototype.includes
	  includes: createMethod(true),
	  // `Array.prototype.indexOf` method
	  // https://tc39.es/ecma262/#sec-array.prototype.indexof
	  indexOf: createMethod(false)
	};


/***/ },
/* 600 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var uncurryThis = __webpack_require__(44);
	
	module.exports = uncurryThis([].slice);


/***/ },
/* 601 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var hasOwn = __webpack_require__(51);
	var ownKeys = __webpack_require__(1409);
	var getOwnPropertyDescriptorModule = __webpack_require__(285);
	var definePropertyModule = __webpack_require__(75);
	
	module.exports = function (target, source, exceptions) {
	  var keys = ownKeys(source);
	  var defineProperty = definePropertyModule.f;
	  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    if (!hasOwn(target, key) && !(exceptions && hasOwn(exceptions, key))) {
	      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
	    }
	  }
	};


/***/ },
/* 602 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var fails = __webpack_require__(50);
	
	module.exports = !fails(function () {
	  function F() { /* empty */ }
	  F.prototype.constructor = null;
	  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
	  return Object.getPrototypeOf(new F()) !== F.prototype;
	});


/***/ },
/* 603 */
/***/ function(module, exports) {

	'use strict';
	// `CreateIterResultObject` abstract operation
	// https://tc39.es/ecma262/#sec-createiterresultobject
	module.exports = function (value, done) {
	  return { value: value, done: done };
	};


/***/ },
/* 604 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var makeBuiltIn = __webpack_require__(614);
	var defineProperty = __webpack_require__(75);
	
	module.exports = function (target, name, descriptor) {
	  if (descriptor.get) makeBuiltIn(descriptor.get, name, { getter: true });
	  if (descriptor.set) makeBuiltIn(descriptor.set, name, { setter: true });
	  return defineProperty.f(target, name, descriptor);
	};


/***/ },
/* 605 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var DESCRIPTORS = __webpack_require__(62);
	var hasOwn = __webpack_require__(51);
	
	var FunctionPrototype = Function.prototype;
	// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
	var getDescriptor = DESCRIPTORS && Object.getOwnPropertyDescriptor;
	
	var EXISTS = hasOwn(FunctionPrototype, 'name');
	// additional protection from minified / mangled / dropped function names
	var PROPER = EXISTS && function something() { /* empty */ }.name === 'something';
	var CONFIGURABLE = EXISTS && (!DESCRIPTORS || (DESCRIPTORS && getDescriptor(FunctionPrototype, 'name').configurable));
	
	module.exports = {
	  EXISTS: EXISTS,
	  PROPER: PROPER,
	  CONFIGURABLE: CONFIGURABLE
	};


/***/ },
/* 606 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var DESCRIPTORS = __webpack_require__(62);
	var fails = __webpack_require__(50);
	var createElement = __webpack_require__(282);
	
	// Thanks to IE8 for its funny defineProperty
	module.exports = !DESCRIPTORS && !fails(function () {
	  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
	  return Object.defineProperty(createElement('div'), 'a', {
	    get: function () { return 7; }
	  }).a !== 7;
	});


/***/ },
/* 607 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var uncurryThis = __webpack_require__(44);
	var fails = __webpack_require__(50);
	var classof = __webpack_require__(128);
	
	var $Object = Object;
	var split = uncurryThis(''.split);
	
	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	module.exports = fails(function () {
	  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
	  // eslint-disable-next-line no-prototype-builtins -- safe
	  return !$Object('z').propertyIsEnumerable(0);
	}) ? function (it) {
	  return classof(it) === 'String' ? split(it, '') : $Object(it);
	} : $Object;


/***/ },
/* 608 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var uncurryThis = __webpack_require__(44);
	var isCallable = __webpack_require__(52);
	var store = __webpack_require__(290);
	
	var functionToString = uncurryThis(Function.toString);
	
	// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
	if (!isCallable(store.inspectSource)) {
	  store.inspectSource = function (it) {
	    return functionToString(it);
	  };
	}
	
	module.exports = store.inspectSource;


/***/ },
/* 609 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var classof = __webpack_require__(128);
	
	// `IsArray` abstract operation
	// https://tc39.es/ecma262/#sec-isarray
	// eslint-disable-next-line es/no-array-isarray -- safe
	module.exports = Array.isArray || function isArray(argument) {
	  return classof(argument) === 'Array';
	};


/***/ },
/* 610 */
/***/ function(module, exports) {

	'use strict';
	// we can't use just `it == null` since of `document.all` special case
	// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
	module.exports = function (it) {
	  return it === null || it === undefined;
	};


/***/ },
/* 611 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(67);
	var call = __webpack_require__(100);
	var IS_PURE = __webpack_require__(164);
	var FunctionName = __webpack_require__(605);
	var isCallable = __webpack_require__(52);
	var createIteratorConstructor = __webpack_require__(1402);
	var getPrototypeOf = __webpack_require__(288);
	var setPrototypeOf = __webpack_require__(619);
	var setToStringTag = __webpack_require__(208);
	var createNonEnumerableProperty = __webpack_require__(204);
	var defineBuiltIn = __webpack_require__(129);
	var wellKnownSymbol = __webpack_require__(76);
	var Iterators = __webpack_require__(284);
	var IteratorsCore = __webpack_require__(612);
	
	var PROPER_FUNCTION_NAME = FunctionName.PROPER;
	var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
	var IteratorPrototype = IteratorsCore.IteratorPrototype;
	var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
	var ITERATOR = wellKnownSymbol('iterator');
	var KEYS = 'keys';
	var VALUES = 'values';
	var ENTRIES = 'entries';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
	  createIteratorConstructor(IteratorConstructor, NAME, next);
	
	  var getIterationMethod = function (KIND) {
	    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
	    if (!BUGGY_SAFARI_ITERATORS && KIND && KIND in IterablePrototype) return IterablePrototype[KIND];
	
	    switch (KIND) {
	      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
	      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
	      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
	    }
	
	    return function () { return new IteratorConstructor(this); };
	  };
	
	  var TO_STRING_TAG = NAME + ' Iterator';
	  var INCORRECT_VALUES_NAME = false;
	  var IterablePrototype = Iterable.prototype;
	  var nativeIterator = IterablePrototype[ITERATOR]
	    || IterablePrototype['@@iterator']
	    || DEFAULT && IterablePrototype[DEFAULT];
	  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
	  var anyNativeIterator = NAME === 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
	  var CurrentIteratorPrototype, methods, KEY;
	
	  // fix native
	  if (anyNativeIterator) {
	    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
	    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
	      if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
	        if (setPrototypeOf) {
	          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
	        } else if (!isCallable(CurrentIteratorPrototype[ITERATOR])) {
	          defineBuiltIn(CurrentIteratorPrototype, ITERATOR, returnThis);
	        }
	      }
	      // Set @@toStringTag to native iterators
	      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
	      if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
	    }
	  }
	
	  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
	  if (PROPER_FUNCTION_NAME && DEFAULT === VALUES && nativeIterator && nativeIterator.name !== VALUES) {
	    if (!IS_PURE && CONFIGURABLE_FUNCTION_NAME) {
	      createNonEnumerableProperty(IterablePrototype, 'name', VALUES);
	    } else {
	      INCORRECT_VALUES_NAME = true;
	      defaultIterator = function values() { return call(nativeIterator, this); };
	    }
	  }
	
	  // export additional methods
	  if (DEFAULT) {
	    methods = {
	      values: getIterationMethod(VALUES),
	      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
	      entries: getIterationMethod(ENTRIES)
	    };
	    if (FORCED) for (KEY in methods) {
	      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
	        defineBuiltIn(IterablePrototype, KEY, methods[KEY]);
	      }
	    } else $({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
	  }
	
	  // define iterator
	  if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) {
	    defineBuiltIn(IterablePrototype, ITERATOR, defaultIterator, { name: DEFAULT });
	  }
	  Iterators[NAME] = defaultIterator;
	
	  return methods;
	};


/***/ },
/* 612 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var fails = __webpack_require__(50);
	var isCallable = __webpack_require__(52);
	var isObject = __webpack_require__(74);
	var create = __webpack_require__(130);
	var getPrototypeOf = __webpack_require__(288);
	var defineBuiltIn = __webpack_require__(129);
	var wellKnownSymbol = __webpack_require__(76);
	var IS_PURE = __webpack_require__(164);
	
	var ITERATOR = wellKnownSymbol('iterator');
	var BUGGY_SAFARI_ITERATORS = false;
	
	// `%IteratorPrototype%` object
	// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
	var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;
	
	/* eslint-disable es/no-array-prototype-keys -- safe */
	if ([].keys) {
	  arrayIterator = [].keys();
	  // Safari 8 has buggy iterators w/o `next`
	  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
	  else {
	    PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
	    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
	  }
	}
	
	var NEW_ITERATOR_PROTOTYPE = !isObject(IteratorPrototype) || fails(function () {
	  var test = {};
	  // FF44- legacy iterators case
	  return IteratorPrototype[ITERATOR].call(test) !== test;
	});
	
	if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype = {};
	else if (IS_PURE) IteratorPrototype = create(IteratorPrototype);
	
	// `%IteratorPrototype%[@@iterator]()` method
	// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
	if (!isCallable(IteratorPrototype[ITERATOR])) {
	  defineBuiltIn(IteratorPrototype, ITERATOR, function () {
	    return this;
	  });
	}
	
	module.exports = {
	  IteratorPrototype: IteratorPrototype,
	  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
	};


/***/ },
/* 613 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var toLength = __webpack_require__(1417);
	
	// `LengthOfArrayLike` abstract operation
	// https://tc39.es/ecma262/#sec-lengthofarraylike
	module.exports = function (obj) {
	  return toLength(obj.length);
	};


/***/ },
/* 614 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var uncurryThis = __webpack_require__(44);
	var fails = __webpack_require__(50);
	var isCallable = __webpack_require__(52);
	var hasOwn = __webpack_require__(51);
	var DESCRIPTORS = __webpack_require__(62);
	var CONFIGURABLE_FUNCTION_NAME = __webpack_require__(605).CONFIGURABLE;
	var inspectSource = __webpack_require__(608);
	var InternalStateModule = __webpack_require__(163);
	
	var enforceInternalState = InternalStateModule.enforce;
	var getInternalState = InternalStateModule.get;
	var $String = String;
	// eslint-disable-next-line es/no-object-defineproperty -- safe
	var defineProperty = Object.defineProperty;
	var stringSlice = uncurryThis(''.slice);
	var replace = uncurryThis(''.replace);
	var join = uncurryThis([].join);
	
	var CONFIGURABLE_LENGTH = DESCRIPTORS && !fails(function () {
	  return defineProperty(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
	});
	
	var TEMPLATE = String(String).split('String');
	
	var makeBuiltIn = module.exports = function (value, name, options) {
	  if (stringSlice($String(name), 0, 7) === 'Symbol(') {
	    name = '[' + replace($String(name), /^Symbol\(([^)]*)\).*$/, '$1') + ']';
	  }
	  if (options && options.getter) name = 'get ' + name;
	  if (options && options.setter) name = 'set ' + name;
	  if (!hasOwn(value, 'name') || (CONFIGURABLE_FUNCTION_NAME && value.name !== name)) {
	    if (DESCRIPTORS) defineProperty(value, 'name', { value: name, configurable: true });
	    else value.name = name;
	  }
	  if (CONFIGURABLE_LENGTH && options && hasOwn(options, 'arity') && value.length !== options.arity) {
	    defineProperty(value, 'length', { value: options.arity });
	  }
	  try {
	    if (options && hasOwn(options, 'constructor') && options.constructor) {
	      if (DESCRIPTORS) defineProperty(value, 'prototype', { writable: false });
	    // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
	    } else if (value.prototype) value.prototype = undefined;
	  } catch (error) { /* empty */ }
	  var state = enforceInternalState(value);
	  if (!hasOwn(state, 'source')) {
	    state.source = join(TEMPLATE, typeof name == 'string' ? name : '');
	  } return value;
	};
	
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	// eslint-disable-next-line no-extend-native -- required
	Function.prototype.toString = makeBuiltIn(function toString() {
	  return isCallable(this) && getInternalState(this).source || inspectSource(this);
	}, 'toString');


/***/ },
/* 615 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var DESCRIPTORS = __webpack_require__(62);
	var V8_PROTOTYPE_DEFINE_BUG = __webpack_require__(623);
	var definePropertyModule = __webpack_require__(75);
	var anObject = __webpack_require__(161);
	var toIndexedObject = __webpack_require__(114);
	var objectKeys = __webpack_require__(617);
	
	// `Object.defineProperties` method
	// https://tc39.es/ecma262/#sec-object.defineproperties
	// eslint-disable-next-line es/no-object-defineproperties -- safe
	exports.f = DESCRIPTORS && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var props = toIndexedObject(Properties);
	  var keys = objectKeys(Properties);
	  var length = keys.length;
	  var index = 0;
	  var key;
	  while (length > index) definePropertyModule.f(O, key = keys[index++], props[key]);
	  return O;
	};


/***/ },
/* 616 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var uncurryThis = __webpack_require__(44);
	var hasOwn = __webpack_require__(51);
	var toIndexedObject = __webpack_require__(114);
	var indexOf = __webpack_require__(599).indexOf;
	var hiddenKeys = __webpack_require__(206);
	
	var push = uncurryThis([].push);
	
	module.exports = function (object, names) {
	  var O = toIndexedObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) !hasOwn(hiddenKeys, key) && hasOwn(O, key) && push(result, key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (hasOwn(O, key = names[i++])) {
	    ~indexOf(result, key) || push(result, key);
	  }
	  return result;
	};


/***/ },
/* 617 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var internalObjectKeys = __webpack_require__(616);
	var enumBugKeys = __webpack_require__(283);
	
	// `Object.keys` method
	// https://tc39.es/ecma262/#sec-object.keys
	// eslint-disable-next-line es/no-object-keys -- safe
	module.exports = Object.keys || function keys(O) {
	  return internalObjectKeys(O, enumBugKeys);
	};


/***/ },
/* 618 */
/***/ function(module, exports) {

	'use strict';
	var $propertyIsEnumerable = {}.propertyIsEnumerable;
	// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	
	// Nashorn ~ JDK8 bug
	var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({ 1: 2 }, 1);
	
	// `Object.prototype.propertyIsEnumerable` method implementation
	// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
	exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
	  var descriptor = getOwnPropertyDescriptor(this, V);
	  return !!descriptor && descriptor.enumerable;
	} : $propertyIsEnumerable;


/***/ },
/* 619 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	/* eslint-disable no-proto -- safe */
	var uncurryThisAccessor = __webpack_require__(1394);
	var isObject = __webpack_require__(74);
	var requireObjectCoercible = __webpack_require__(165);
	var aPossiblePrototype = __webpack_require__(1382);
	
	// `Object.setPrototypeOf` method
	// https://tc39.es/ecma262/#sec-object.setprototypeof
	// Works with __proto__ only. Old v8 can't work with null proto objects.
	// eslint-disable-next-line es/no-object-setprototypeof -- safe
	module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
	  var CORRECT_SETTER = false;
	  var test = {};
	  var setter;
	  try {
	    setter = uncurryThisAccessor(Object.prototype, '__proto__', 'set');
	    setter(test, []);
	    CORRECT_SETTER = test instanceof Array;
	  } catch (error) { /* empty */ }
	  return function setPrototypeOf(O, proto) {
	    requireObjectCoercible(O);
	    aPossiblePrototype(proto);
	    if (!isObject(O)) return O;
	    if (CORRECT_SETTER) setter(O, proto);
	    else O.__proto__ = proto;
	    return O;
	  };
	}() : undefined);


/***/ },
/* 620 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var NATIVE_SYMBOL = __webpack_require__(131);
	
	/* eslint-disable es/no-symbol -- safe */
	module.exports = NATIVE_SYMBOL && !!Symbol['for'] && !!Symbol.keyFor;


/***/ },
/* 621 */
/***/ function(module, exports) {

	'use strict';
	var $String = String;
	
	module.exports = function (argument) {
	  try {
	    return $String(argument);
	  } catch (error) {
	    return 'Object';
	  }
	};


/***/ },
/* 622 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	/* eslint-disable es/no-symbol -- required for testing */
	var NATIVE_SYMBOL = __webpack_require__(131);
	
	module.exports = NATIVE_SYMBOL &&
	  !Symbol.sham &&
	  typeof Symbol.iterator == 'symbol';


/***/ },
/* 623 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var DESCRIPTORS = __webpack_require__(62);
	var fails = __webpack_require__(50);
	
	// V8 ~ Chrome 36-
	// https://bugs.chromium.org/p/v8/issues/detail?id=3334
	module.exports = DESCRIPTORS && fails(function () {
	  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
	  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
	    value: 42,
	    writable: false
	  }).prototype !== 42;
	});


/***/ },
/* 624 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var path = __webpack_require__(1411);
	var hasOwn = __webpack_require__(51);
	var wrappedWellKnownSymbolModule = __webpack_require__(625);
	var defineProperty = __webpack_require__(75).f;
	
	module.exports = function (NAME) {
	  var Symbol = path.Symbol || (path.Symbol = {});
	  if (!hasOwn(Symbol, NAME)) defineProperty(Symbol, NAME, {
	    value: wrappedWellKnownSymbolModule.f(NAME)
	  });
	};


/***/ },
/* 625 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var wellKnownSymbol = __webpack_require__(76);
	
	exports.f = wellKnownSymbol;


/***/ },
/* 626 */
/***/ function(module, exports) {

	'use strict';
	// a string of all valid unicode whitespaces
	module.exports = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002' +
	  '\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ },
/* 627 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var toIndexedObject = __webpack_require__(114);
	var addToUnscopables = __webpack_require__(1383);
	var Iterators = __webpack_require__(284);
	var InternalStateModule = __webpack_require__(163);
	var defineProperty = __webpack_require__(75).f;
	var defineIterator = __webpack_require__(611);
	var createIterResultObject = __webpack_require__(603);
	var IS_PURE = __webpack_require__(164);
	var DESCRIPTORS = __webpack_require__(62);
	
	var ARRAY_ITERATOR = 'Array Iterator';
	var setInternalState = InternalStateModule.set;
	var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);
	
	// `Array.prototype.entries` method
	// https://tc39.es/ecma262/#sec-array.prototype.entries
	// `Array.prototype.keys` method
	// https://tc39.es/ecma262/#sec-array.prototype.keys
	// `Array.prototype.values` method
	// https://tc39.es/ecma262/#sec-array.prototype.values
	// `Array.prototype[@@iterator]` method
	// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
	// `CreateArrayIterator` internal method
	// https://tc39.es/ecma262/#sec-createarrayiterator
	module.exports = defineIterator(Array, 'Array', function (iterated, kind) {
	  setInternalState(this, {
	    type: ARRAY_ITERATOR,
	    target: toIndexedObject(iterated), // target
	    index: 0,                          // next index
	    kind: kind                         // kind
	  });
	// `%ArrayIteratorPrototype%.next` method
	// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
	}, function () {
	  var state = getInternalState(this);
	  var target = state.target;
	  var index = state.index++;
	  if (!target || index >= target.length) {
	    state.target = null;
	    return createIterResultObject(undefined, true);
	  }
	  switch (state.kind) {
	    case 'keys': return createIterResultObject(index, false);
	    case 'values': return createIterResultObject(target[index], false);
	  } return createIterResultObject([index, target[index]], false);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values%
	// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
	// https://tc39.es/ecma262/#sec-createmappedargumentsobject
	var values = Iterators.Arguments = Iterators.Array;
	
	// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');
	
	// V8 ~ Chrome 45- bug
	if (!IS_PURE && DESCRIPTORS && values.name !== 'values') try {
	  defineProperty(values, 'name', { value: 'values' });
	} catch (error) { /* empty */ }


/***/ },
/* 628 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(67);
	var DESCRIPTORS = __webpack_require__(62);
	var defineProperty = __webpack_require__(75).f;
	
	// `Object.defineProperty` method
	// https://tc39.es/ecma262/#sec-object.defineproperty
	// eslint-disable-next-line es/no-object-defineproperty -- safe
	$({ target: 'Object', stat: true, forced: Object.defineProperty !== defineProperty, sham: !DESCRIPTORS }, {
	  defineProperty: defineProperty
	});


/***/ },
/* 629 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _events = __webpack_require__(155);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var createUUID = function createUUID() {
	  var pattern = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';
	  return pattern.replace(/[xy]/g, function (c) {
	    var r = Math.random() * 16 | 0;
	    var v = c === 'x' ? r : r & 0x3 | 0x8;
	    return v.toString(16);
	  });
	};
	
	var Constants = {
	  CHANGE: 'change',
	  INFO: 'info',
	  SUCCESS: 'success',
	  WARNING: 'warning',
	  ERROR: 'error'
	};
	
	var NotificationManager = /*#__PURE__*/function (_EventEmitter) {
	  _inherits(NotificationManager, _EventEmitter);
	
	  var _super = _createSuper(NotificationManager);
	
	  function NotificationManager() {
	    var _this;
	
	    _classCallCheck(this, NotificationManager);
	
	    _this = _super.call(this);
	    _this.listNotify = [];
	    return _this;
	  }
	
	  _createClass(NotificationManager, [{
	    key: "create",
	    value: function create(notify) {
	      var defaultNotify = {
	        id: createUUID(),
	        type: 'info',
	        title: null,
	        message: null,
	        timeOut: 5000
	      };
	
	      if (notify.priority) {
	        this.listNotify.unshift(Object.assign(defaultNotify, notify));
	      } else {
	        this.listNotify.push(Object.assign(defaultNotify, notify));
	      }
	
	      this.emitChange();
	    }
	  }, {
	    key: "info",
	    value: function info(message, title, timeOut, onClick, priority) {
	      this.create({
	        type: Constants.INFO,
	        message: message,
	        title: title,
	        timeOut: timeOut,
	        onClick: onClick,
	        priority: priority
	      });
	    }
	  }, {
	    key: "success",
	    value: function success(message, title, timeOut, onClick, priority) {
	      this.create({
	        type: Constants.SUCCESS,
	        message: message,
	        title: title,
	        timeOut: timeOut,
	        onClick: onClick,
	        priority: priority
	      });
	    }
	  }, {
	    key: "warning",
	    value: function warning(message, title, timeOut, onClick, priority) {
	      this.create({
	        type: Constants.WARNING,
	        message: message,
	        title: title,
	        timeOut: timeOut,
	        onClick: onClick,
	        priority: priority
	      });
	    }
	  }, {
	    key: "error",
	    value: function error(message, title, timeOut, onClick, priority) {
	      this.create({
	        type: Constants.ERROR,
	        message: message,
	        title: title,
	        timeOut: timeOut,
	        onClick: onClick,
	        priority: priority
	      });
	    }
	  }, {
	    key: "remove",
	    value: function remove(notification) {
	      this.listNotify = this.listNotify.filter(function (n) {
	        return notification.id !== n.id;
	      });
	      this.emitChange();
	    }
	  }, {
	    key: "removeAll",
	    value: function removeAll() {
	      this.listNotify.length = 0;
	      this.emitChange();
	    }
	  }, {
	    key: "emitChange",
	    value: function emitChange() {
	      this.emit(Constants.CHANGE, this.listNotify);
	    }
	  }, {
	    key: "addChangeListener",
	    value: function addChangeListener(callback) {
	      this.addListener(Constants.CHANGE, callback);
	    }
	  }, {
	    key: "removeChangeListener",
	    value: function removeChangeListener(callback) {
	      this.removeListener(Constants.CHANGE, callback);
	    }
	  }]);
	
	  return NotificationManager;
	}(_events.EventEmitter);
	
	var _default = new NotificationManager();
	
	exports.default = _default;

/***/ },
/* 630 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _reactTransitionGroup = __webpack_require__(300);
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _Notification = _interopRequireDefault(__webpack_require__(1440));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var Notifications = /*#__PURE__*/function (_React$Component) {
	  _inherits(Notifications, _React$Component);
	
	  var _super = _createSuper(Notifications);
	
	  function Notifications() {
	    var _this;
	
	    _classCallCheck(this, Notifications);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _super.call.apply(_super, [this].concat(args));
	
	    _defineProperty(_assertThisInitialized(_this), "handleRequestHide", function (notification) {
	      return function () {
	        var onRequestHide = _this.props.onRequestHide;
	
	        if (onRequestHide) {
	          onRequestHide(notification);
	        }
	      };
	    });
	
	    return _this;
	  }
	
	  _createClass(Notifications, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _this$props = this.props,
	          notifications = _this$props.notifications,
	          enterTimeout = _this$props.enterTimeout,
	          leaveTimeout = _this$props.leaveTimeout;
	      var className = (0, _classnames.default)('notification-container', {
	        'notification-container-empty': notifications.length === 0
	      });
	      var items = notifications.map(function (notification) {
	        var key = notification.id || new Date().getTime();
	        return /*#__PURE__*/_react.default.createElement(_reactTransitionGroup.CSSTransition, {
	          key: key,
	          classNames: "notification",
	          timeout: {
	            enter: enterTimeout,
	            exit: leaveTimeout
	          }
	        }, /*#__PURE__*/_react.default.createElement(_Notification.default, {
	          type: notification.type,
	          title: notification.title,
	          message: notification.message,
	          timeOut: notification.timeOut,
	          onClick: notification.onClick,
	          onRequestHide: _this2.handleRequestHide(notification)
	        }));
	      });
	      return /*#__PURE__*/_react.default.createElement("div", {
	        className: className
	      }, /*#__PURE__*/_react.default.createElement(_reactTransitionGroup.TransitionGroup, null, items));
	    }
	  }]);
	
	  return Notifications;
	}(_react.default.Component);
	
	_defineProperty(Notifications, "propTypes", {
	  notifications: _propTypes.default.array,
	  onRequestHide: _propTypes.default.func,
	  enterTimeout: _propTypes.default.number,
	  leaveTimeout: _propTypes.default.number
	});
	
	_defineProperty(Notifications, "defaultProps", {
	  notifications: [],
	  onRequestHide: function onRequestHide() {},
	  enterTimeout: 400,
	  leaveTimeout: 400
	});
	
	var _default = Notifications;
	exports.default = _default;

/***/ },
/* 631 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setRef = exports.shallowEqual = exports.safeInvoke = exports.unwrapArray = void 0;
	
	/**
	 * Takes an argument and if it's an array, returns the first item in the array,
	 * otherwise returns the argument. Used for Preact compatibility.
	 */
	var unwrapArray = function unwrapArray(arg) {
	  return Array.isArray(arg) ? arg[0] : arg;
	};
	/**
	 * Takes a maybe-undefined function and arbitrary args and invokes the function
	 * only if it is defined.
	 */
	
	
	exports.unwrapArray = unwrapArray;
	
	var safeInvoke = function safeInvoke(fn) {
	  if (typeof fn === "function") {
	    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return fn.apply(void 0, args);
	  }
	};
	/**
	 * Does a shallow equality check of two objects by comparing the reference
	 * equality of each value.
	 */
	
	
	exports.safeInvoke = safeInvoke;
	
	var shallowEqual = function shallowEqual(objA, objB) {
	  var aKeys = Object.keys(objA);
	  var bKeys = Object.keys(objB);
	
	  if (bKeys.length !== aKeys.length) {
	    return false;
	  }
	
	  for (var i = 0; i < bKeys.length; i++) {
	    var key = aKeys[i];
	
	    if (objA[key] !== objB[key]) {
	      return false;
	    }
	  }
	
	  return true;
	};
	/**
	 * Sets a ref using either a ref callback or a ref object
	 */
	
	
	exports.shallowEqual = shallowEqual;
	
	var setRef = function setRef(ref, node) {
	  // if its a function call it
	  if (typeof ref === "function") {
	    return safeInvoke(ref, node);
	  } // otherwise we should treat it as a ref object
	  else if (ref != null) {
	      ref.current = node;
	    }
	};
	
	exports.setRef = setRef;

/***/ },
/* 632 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var asap = __webpack_require__(847);
	
	function noop() {}
	
	// States:
	//
	// 0 - pending
	// 1 - fulfilled with _value
	// 2 - rejected with _value
	// 3 - adopted the state of another promise, _value
	//
	// once the state is no longer pending (0) it is immutable
	
	// All `_` prefixed properties will be reduced to `_{random number}`
	// at build time to obfuscate them and discourage their use.
	// We don't use symbols or Object.defineProperty to fully hide them
	// because the performance isn't good enough.
	
	
	// to avoid using try/catch inside critical functions, we
	// extract them to here.
	var LAST_ERROR = null;
	var IS_ERROR = {};
	function getThen(obj) {
	  try {
	    return obj.then;
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	function tryCallOne(fn, a) {
	  try {
	    return fn(a);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	function tryCallTwo(fn, a, b) {
	  try {
	    fn(a, b);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	module.exports = Promise;
	
	function Promise(fn) {
	  if (typeof this !== 'object') {
	    throw new TypeError('Promises must be constructed via new');
	  }
	  if (typeof fn !== 'function') {
	    throw new TypeError('not a function');
	  }
	  this._45 = 0;
	  this._81 = 0;
	  this._65 = null;
	  this._54 = null;
	  if (fn === noop) return;
	  doResolve(fn, this);
	}
	Promise._10 = null;
	Promise._97 = null;
	Promise._61 = noop;
	
	Promise.prototype.then = function(onFulfilled, onRejected) {
	  if (this.constructor !== Promise) {
	    return safeThen(this, onFulfilled, onRejected);
	  }
	  var res = new Promise(noop);
	  handle(this, new Handler(onFulfilled, onRejected, res));
	  return res;
	};
	
	function safeThen(self, onFulfilled, onRejected) {
	  return new self.constructor(function (resolve, reject) {
	    var res = new Promise(noop);
	    res.then(resolve, reject);
	    handle(self, new Handler(onFulfilled, onRejected, res));
	  });
	};
	function handle(self, deferred) {
	  while (self._81 === 3) {
	    self = self._65;
	  }
	  if (Promise._10) {
	    Promise._10(self);
	  }
	  if (self._81 === 0) {
	    if (self._45 === 0) {
	      self._45 = 1;
	      self._54 = deferred;
	      return;
	    }
	    if (self._45 === 1) {
	      self._45 = 2;
	      self._54 = [self._54, deferred];
	      return;
	    }
	    self._54.push(deferred);
	    return;
	  }
	  handleResolved(self, deferred);
	}
	
	function handleResolved(self, deferred) {
	  asap(function() {
	    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
	    if (cb === null) {
	      if (self._81 === 1) {
	        resolve(deferred.promise, self._65);
	      } else {
	        reject(deferred.promise, self._65);
	      }
	      return;
	    }
	    var ret = tryCallOne(cb, self._65);
	    if (ret === IS_ERROR) {
	      reject(deferred.promise, LAST_ERROR);
	    } else {
	      resolve(deferred.promise, ret);
	    }
	  });
	}
	function resolve(self, newValue) {
	  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	  if (newValue === self) {
	    return reject(
	      self,
	      new TypeError('A promise cannot be resolved with itself.')
	    );
	  }
	  if (
	    newValue &&
	    (typeof newValue === 'object' || typeof newValue === 'function')
	  ) {
	    var then = getThen(newValue);
	    if (then === IS_ERROR) {
	      return reject(self, LAST_ERROR);
	    }
	    if (
	      then === self.then &&
	      newValue instanceof Promise
	    ) {
	      self._81 = 3;
	      self._65 = newValue;
	      finale(self);
	      return;
	    } else if (typeof then === 'function') {
	      doResolve(then.bind(newValue), self);
	      return;
	    }
	  }
	  self._81 = 1;
	  self._65 = newValue;
	  finale(self);
	}
	
	function reject(self, newValue) {
	  self._81 = 2;
	  self._65 = newValue;
	  if (Promise._97) {
	    Promise._97(self, newValue);
	  }
	  finale(self);
	}
	function finale(self) {
	  if (self._45 === 1) {
	    handle(self, self._54);
	    self._54 = null;
	  }
	  if (self._45 === 2) {
	    for (var i = 0; i < self._54.length; i++) {
	      handle(self, self._54[i]);
	    }
	    self._54 = null;
	  }
	}
	
	function Handler(onFulfilled, onRejected, promise){
	  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	  this.promise = promise;
	}
	
	/**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */
	function doResolve(fn, promise) {
	  var done = false;
	  var res = tryCallTwo(fn, function (value) {
	    if (done) return;
	    done = true;
	    resolve(promise, value);
	  }, function (reason) {
	    if (done) return;
	    done = true;
	    reject(promise, reason);
	  })
	  if (!done && res === IS_ERROR) {
	    done = true;
	    reject(promise, LAST_ERROR);
	  }
	}


/***/ },
/* 633 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _TransitionGroupContext = _interopRequireDefault(__webpack_require__(299));
	
	var _ChildMapping = __webpack_require__(1522);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	var values = Object.values || function (obj) {
	  return Object.keys(obj).map(function (k) {
	    return obj[k];
	  });
	};
	
	var defaultProps = {
	  component: 'div',
	  childFactory: function childFactory(child) {
	    return child;
	  }
	};
	/**
	 * The `<TransitionGroup>` component manages a set of transition components
	 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
	 * components, `<TransitionGroup>` is a state machine for managing the mounting
	 * and unmounting of components over time.
	 *
	 * Consider the example below. As items are removed or added to the TodoList the
	 * `in` prop is toggled automatically by the `<TransitionGroup>`.
	 *
	 * Note that `<TransitionGroup>`  does not define any animation behavior!
	 * Exactly _how_ a list item animates is up to the individual transition
	 * component. This means you can mix and match animations across different list
	 * items.
	 */
	
	var TransitionGroup = /*#__PURE__*/function (_React$Component) {
	  _inheritsLoose(TransitionGroup, _React$Component);
	
	  function TransitionGroup(props, context) {
	    var _this;
	
	    _this = _React$Component.call(this, props, context) || this;
	
	    var handleExited = _this.handleExited.bind(_assertThisInitialized(_this)); // Initial children should all be entering, dependent on appear
	
	
	    _this.state = {
	      contextValue: {
	        isMounting: true
	      },
	      handleExited: handleExited,
	      firstRender: true
	    };
	    return _this;
	  }
	
	  var _proto = TransitionGroup.prototype;
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.mounted = true;
	    this.setState({
	      contextValue: {
	        isMounting: false
	      }
	    });
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.mounted = false;
	  };
	
	  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
	    var prevChildMapping = _ref.children,
	        handleExited = _ref.handleExited,
	        firstRender = _ref.firstRender;
	    return {
	      children: firstRender ? (0, _ChildMapping.getInitialChildMapping)(nextProps, handleExited) : (0, _ChildMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
	      firstRender: false
	    };
	  } // node is `undefined` when user provided `nodeRef` prop
	  ;
	
	  _proto.handleExited = function handleExited(child, node) {
	    var currentChildMapping = (0, _ChildMapping.getChildMapping)(this.props.children);
	    if (child.key in currentChildMapping) return;
	
	    if (child.props.onExited) {
	      child.props.onExited(node);
	    }
	
	    if (this.mounted) {
	      this.setState(function (state) {
	        var children = _extends({}, state.children);
	
	        delete children[child.key];
	        return {
	          children: children
	        };
	      });
	    }
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        Component = _this$props.component,
	        childFactory = _this$props.childFactory,
	        props = _objectWithoutPropertiesLoose(_this$props, ["component", "childFactory"]);
	
	    var contextValue = this.state.contextValue;
	    var children = values(this.state.children).map(childFactory);
	    delete props.appear;
	    delete props.enter;
	    delete props.exit;
	
	    if (Component === null) {
	      return /*#__PURE__*/_react.default.createElement(_TransitionGroupContext.default.Provider, {
	        value: contextValue
	      }, children);
	    }
	
	    return /*#__PURE__*/_react.default.createElement(_TransitionGroupContext.default.Provider, {
	      value: contextValue
	    }, /*#__PURE__*/_react.default.createElement(Component, props, children));
	  };
	
	  return TransitionGroup;
	}(_react.default.Component);
	
	TransitionGroup.propTypes =  false ? {
	  /**
	   * `<TransitionGroup>` renders a `<div>` by default. You can change this
	   * behavior by providing a `component` prop.
	   * If you use React v16+ and would like to avoid a wrapping `<div>` element
	   * you can pass in `component={null}`. This is useful if the wrapping div
	   * borks your css styles.
	   */
	  component: _propTypes.default.any,
	
	  /**
	   * A set of `<Transition>` components, that are toggled `in` and out as they
	   * leave. the `<TransitionGroup>` will inject specific transition props, so
	   * remember to spread them through if you are wrapping the `<Transition>` as
	   * with our `<Fade>` example.
	   *
	   * While this component is meant for multiple `Transition` or `CSSTransition`
	   * children, sometimes you may want to have a single transition child with
	   * content that you want to be transitioned out and in when you change it
	   * (e.g. routes, images etc.) In that case you can change the `key` prop of
	   * the transition child as you change its content, this will cause
	   * `TransitionGroup` to transition the child out and back in.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * A convenience prop that enables or disables appear animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  appear: _propTypes.default.bool,
	
	  /**
	   * A convenience prop that enables or disables enter animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  enter: _propTypes.default.bool,
	
	  /**
	   * A convenience prop that enables or disables exit animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  exit: _propTypes.default.bool,
	
	  /**
	   * You may need to apply reactive updates to a child as it is exiting.
	   * This is generally done by using `cloneElement` however in the case of an exiting
	   * child the element has already been removed and not accessible to the consumer.
	   *
	   * If you do need to update a child as it leaves you can provide a `childFactory`
	   * to wrap every child, even the ones that are leaving.
	   *
	   * @type Function(child: ReactElement) -> ReactElement
	   */
	  childFactory: _propTypes.default.func
	} : {};
	TransitionGroup.defaultProps = defaultProps;
	var _default = TransitionGroup;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 634 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	var _default = {
	  disabled: false
	};
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 635 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.classNamesShape = exports.timeoutsShape = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var timeoutsShape =  false ? _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	  enter: _propTypes.default.number,
	  exit: _propTypes.default.number,
	  appear: _propTypes.default.number
	}).isRequired]) : null;
	exports.timeoutsShape = timeoutsShape;
	var classNamesShape =  false ? _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
	  enter: _propTypes.default.string,
	  exit: _propTypes.default.string,
	  active: _propTypes.default.string
	}), _propTypes.default.shape({
	  enter: _propTypes.default.string,
	  enterDone: _propTypes.default.string,
	  enterActive: _propTypes.default.string,
	  exit: _propTypes.default.string,
	  exitDone: _propTypes.default.string,
	  exitActive: _propTypes.default.string
	})]) : null;
	exports.classNamesShape = classNamesShape;

/***/ },
/* 636 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.forceReflow = void 0;
	
	var forceReflow = function forceReflow(node) {
	  return node.scrollTop;
	};
	
	exports.forceReflow = forceReflow;

/***/ },
/* 637 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(13));
	
	var _objectSpread4 = _interopRequireDefault(__webpack_require__(47));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _utils = __webpack_require__(11);
	
	var _Fade = _interopRequireDefault(__webpack_require__(173));
	
	var propTypes = {
	  children: _propTypes.default.node,
	  className: _propTypes.default.string,
	  closeClassName: _propTypes.default.string,
	  closeAriaLabel: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  color: _propTypes.default.string,
	  fade: _propTypes.default.bool,
	  isOpen: _propTypes.default.bool,
	  toggle: _propTypes.default.func,
	  tag: _utils.tagPropType,
	  transition: _propTypes.default.shape(_Fade.default.propTypes),
	  innerRef: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string, _propTypes.default.func])
	};
	var defaultProps = {
	  color: 'success',
	  isOpen: true,
	  tag: 'div',
	  closeAriaLabel: 'Close',
	  fade: true,
	  transition: (0, _objectSpread4.default)({}, _Fade.default.defaultProps, {
	    unmountOnExit: true
	  })
	};
	
	function Alert(props) {
	  var className = props.className,
	      closeClassName = props.closeClassName,
	      closeAriaLabel = props.closeAriaLabel,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      color = props.color,
	      isOpen = props.isOpen,
	      toggle = props.toggle,
	      children = props.children,
	      transition = props.transition,
	      fade = props.fade,
	      innerRef = props.innerRef,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "closeClassName", "closeAriaLabel", "cssModule", "tag", "color", "isOpen", "toggle", "children", "transition", "fade", "innerRef"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'alert', "alert-" + color, {
	    'alert-dismissible': toggle
	  }), cssModule);
	  var closeClasses = (0, _utils.mapToCssModules)((0, _classnames.default)('close', closeClassName), cssModule);
	  var alertTransition = (0, _objectSpread4.default)({}, _Fade.default.defaultProps, {}, transition, {
	    baseClass: fade ? transition.baseClass : '',
	    timeout: fade ? transition.timeout : 0
	  });
	  return _react.default.createElement(_Fade.default, (0, _extends2.default)({}, attributes, alertTransition, {
	    tag: Tag,
	    className: classes,
	    in: isOpen,
	    role: "alert",
	    innerRef: innerRef
	  }), toggle ? _react.default.createElement("button", {
	    type: "button",
	    className: closeClasses,
	    "aria-label": closeAriaLabel,
	    onClick: toggle
	  }, _react.default.createElement("span", {
	    "aria-hidden": "true"
	  }, "\xD7")) : null, children);
	}
	
	Alert.propTypes = propTypes;
	Alert.defaultProps = defaultProps;
	var _default = Alert;
	exports.default = _default;

/***/ },
/* 638 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _Dropdown = _interopRequireDefault(__webpack_require__(212));
	
	var propTypes = {
	  children: _propTypes.default.node
	};
	
	var ButtonDropdown = function ButtonDropdown(props) {
	  return _react.default.createElement(_Dropdown.default, (0, _extends2.default)({
	    group: true
	  }, props));
	};
	
	ButtonDropdown.propTypes = propTypes;
	var _default = ButtonDropdown;
	exports.default = _default;

/***/ },
/* 639 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(12));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(34));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _CarouselItem = _interopRequireDefault(__webpack_require__(302));
	
	var _utils = __webpack_require__(11);
	
	var SWIPE_THRESHOLD = 40;
	
	var Carousel =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Carousel, _React$Component);
	
	  function Carousel(props) {
	    var _this;
	
	    _this = _React$Component.call(this, props) || this;
	    _this.handleKeyPress = _this.handleKeyPress.bind((0, _assertThisInitialized2.default)(_this));
	    _this.renderItems = _this.renderItems.bind((0, _assertThisInitialized2.default)(_this));
	    _this.hoverStart = _this.hoverStart.bind((0, _assertThisInitialized2.default)(_this));
	    _this.hoverEnd = _this.hoverEnd.bind((0, _assertThisInitialized2.default)(_this));
	    _this.handleTouchStart = _this.handleTouchStart.bind((0, _assertThisInitialized2.default)(_this));
	    _this.handleTouchEnd = _this.handleTouchEnd.bind((0, _assertThisInitialized2.default)(_this));
	    _this.touchStartX = 0;
	    _this.touchStartY = 0;
	    _this.state = {
	      activeIndex: _this.props.activeIndex,
	      direction: 'right',
	      indicatorClicked: false
	    };
	    return _this;
	  }
	
	  var _proto = Carousel.prototype;
	
	  _proto.getChildContext = function getChildContext() {
	    return {
	      direction: this.state.direction
	    };
	  };
	
	  _proto.componentDidMount = function componentDidMount() {
	    // Set up the cycle
	    if (this.props.ride === 'carousel') {
	      this.setInterval();
	    } // TODO: move this to the specific carousel like bootstrap. Currently it will trigger ALL carousels on the page.
	
	
	    document.addEventListener('keyup', this.handleKeyPress);
	  };
	
	  Carousel.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
	    var newState = null;
	    var activeIndex = prevState.activeIndex,
	        direction = prevState.direction,
	        indicatorClicked = prevState.indicatorClicked;
	
	    if (nextProps.activeIndex !== activeIndex) {
	      // Calculate the direction to turn
	      if (nextProps.activeIndex === activeIndex + 1) {
	        direction = 'right';
	      } else if (nextProps.activeIndex === activeIndex - 1) {
	        direction = 'left';
	      } else if (nextProps.activeIndex < activeIndex) {
	        direction = indicatorClicked ? 'left' : 'right';
	      } else if (nextProps.activeIndex !== activeIndex) {
	        direction = indicatorClicked ? 'right' : 'left';
	      }
	
	      newState = {
	        activeIndex: nextProps.activeIndex,
	        direction: direction,
	        indicatorClicked: false
	      };
	    }
	
	    return newState;
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
	    if (prevState.activeIndex === this.state.activeIndex) return;
	    this.setInterval(this.props);
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.clearInterval();
	    document.removeEventListener('keyup', this.handleKeyPress);
	  };
	
	  _proto.setInterval = function (_setInterval) {
	    function setInterval() {
	      return _setInterval.apply(this, arguments);
	    }
	
	    setInterval.toString = function () {
	      return _setInterval.toString();
	    };
	
	    return setInterval;
	  }(function (props) {
	    if (props === void 0) {
	      props = this.props;
	    }
	
	    // make sure not to have multiple intervals going...
	    this.clearInterval();
	
	    if (props.interval) {
	      this.cycleInterval = setInterval(function () {
	        props.next();
	      }, parseInt(props.interval, 10));
	    }
	  });
	
	  _proto.clearInterval = function (_clearInterval) {
	    function clearInterval() {
	      return _clearInterval.apply(this, arguments);
	    }
	
	    clearInterval.toString = function () {
	      return _clearInterval.toString();
	    };
	
	    return clearInterval;
	  }(function () {
	    clearInterval(this.cycleInterval);
	  });
	
	  _proto.hoverStart = function hoverStart() {
	    if (this.props.pause === 'hover') {
	      this.clearInterval();
	    }
	
	    if (this.props.mouseEnter) {
	      var _this$props;
	
	      (_this$props = this.props).mouseEnter.apply(_this$props, arguments);
	    }
	  };
	
	  _proto.hoverEnd = function hoverEnd() {
	    if (this.props.pause === 'hover') {
	      this.setInterval();
	    }
	
	    if (this.props.mouseLeave) {
	      var _this$props2;
	
	      (_this$props2 = this.props).mouseLeave.apply(_this$props2, arguments);
	    }
	  };
	
	  _proto.handleKeyPress = function handleKeyPress(evt) {
	    if (this.props.keyboard) {
	      if (evt.keyCode === 37) {
	        this.props.previous();
	      } else if (evt.keyCode === 39) {
	        this.props.next();
	      }
	    }
	  };
	
	  _proto.handleTouchStart = function handleTouchStart(e) {
	    if (!this.props.enableTouch) {
	      return;
	    }
	
	    this.touchStartX = e.changedTouches[0].screenX;
	    this.touchStartY = e.changedTouches[0].screenY;
	  };
	
	  _proto.handleTouchEnd = function handleTouchEnd(e) {
	    if (!this.props.enableTouch) {
	      return;
	    }
	
	    var currentX = e.changedTouches[0].screenX;
	    var currentY = e.changedTouches[0].screenY;
	    var diffX = Math.abs(this.touchStartX - currentX);
	    var diffY = Math.abs(this.touchStartY - currentY); // Don't swipe if Y-movement is bigger than X-movement
	
	    if (diffX < diffY) {
	      return;
	    }
	
	    if (diffX < SWIPE_THRESHOLD) {
	      return;
	    }
	
	    if (currentX < this.touchStartX) {
	      this.props.next();
	    } else {
	      this.props.previous();
	    }
	  };
	
	  _proto.renderItems = function renderItems(carouselItems, className) {
	    var _this2 = this;
	
	    var slide = this.props.slide;
	    return _react.default.createElement("div", {
	      className: className
	    }, carouselItems.map(function (item, index) {
	      var isIn = index === _this2.state.activeIndex;
	      return _react.default.cloneElement(item, {
	        in: isIn,
	        slide: slide
	      });
	    }));
	  };
	
	  _proto.render = function render() {
	    var _this3 = this;
	
	    var _this$props3 = this.props,
	        cssModule = _this$props3.cssModule,
	        slide = _this$props3.slide,
	        className = _this$props3.className;
	    var outerClasses = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'carousel', slide && 'slide'), cssModule);
	    var innerClasses = (0, _utils.mapToCssModules)((0, _classnames.default)('carousel-inner'), cssModule); // filter out booleans, null, or undefined
	
	    var children = this.props.children.filter(function (child) {
	      return child !== null && child !== undefined && typeof child !== 'boolean';
	    });
	    var slidesOnly = children.every(function (child) {
	      return child.type === _CarouselItem.default;
	    }); // Rendering only slides
	
	    if (slidesOnly) {
	      return _react.default.createElement("div", {
	        className: outerClasses,
	        onMouseEnter: this.hoverStart,
	        onMouseLeave: this.hoverEnd
	      }, this.renderItems(children, innerClasses));
	    } // Rendering slides and controls
	
	
	    if (children[0] instanceof Array) {
	      var _carouselItems = children[0];
	      var _controlLeft = children[1];
	      var _controlRight = children[2];
	      return _react.default.createElement("div", {
	        className: outerClasses,
	        onMouseEnter: this.hoverStart,
	        onMouseLeave: this.hoverEnd
	      }, this.renderItems(_carouselItems, innerClasses), _controlLeft, _controlRight);
	    } // Rendering indicators, slides and controls
	
	
	    var indicators = children[0];
	
	    var wrappedOnClick = function wrappedOnClick(e) {
	      if (typeof indicators.props.onClickHandler === 'function') {
	        _this3.setState({
	          indicatorClicked: true
	        }, function () {
	          return indicators.props.onClickHandler(e);
	        });
	      }
	    };
	
	    var wrappedIndicators = _react.default.cloneElement(indicators, {
	      onClickHandler: wrappedOnClick
	    });
	
	    var carouselItems = children[1];
	    var controlLeft = children[2];
	    var controlRight = children[3];
	    return _react.default.createElement("div", {
	      className: outerClasses,
	      onMouseEnter: this.hoverStart,
	      onMouseLeave: this.hoverEnd,
	      onTouchStart: this.handleTouchStart,
	      onTouchEnd: this.handleTouchEnd
	    }, wrappedIndicators, this.renderItems(carouselItems, innerClasses), controlLeft, controlRight);
	  };
	
	  return Carousel;
	}(_react.default.Component);
	
	Carousel.propTypes = {
	  // the current active slide of the carousel
	  activeIndex: _propTypes.default.number,
	  // a function which should advance the carousel to the next slide (via activeIndex)
	  next: _propTypes.default.func.isRequired,
	  // a function which should advance the carousel to the previous slide (via activeIndex)
	  previous: _propTypes.default.func.isRequired,
	  // controls if the left and right arrow keys should control the carousel
	  keyboard: _propTypes.default.bool,
	
	  /* If set to "hover", pauses the cycling of the carousel on mouseenter and resumes the cycling of the carousel on
	   * mouseleave. If set to false, hovering over the carousel won't pause it. (default: "hover")
	   */
	  pause: _propTypes.default.oneOf(['hover', false]),
	  // Autoplays the carousel after the user manually cycles the first item. If "carousel", autoplays the carousel on load.
	  // This is how bootstrap defines it... I would prefer a bool named autoplay or something...
	  ride: _propTypes.default.oneOf(['carousel']),
	  // the interval at which the carousel automatically cycles (default: 5000)
	  // eslint-disable-next-line react/no-unused-prop-types
	  interval: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string, _propTypes.default.bool]),
	  children: _propTypes.default.array,
	  // called when the mouse enters the Carousel
	  mouseEnter: _propTypes.default.func,
	  // called when the mouse exits the Carousel
	  mouseLeave: _propTypes.default.func,
	  // controls whether the slide animation on the Carousel works or not
	  slide: _propTypes.default.bool,
	  cssModule: _propTypes.default.object,
	  className: _propTypes.default.string,
	  enableTouch: _propTypes.default.bool
	};
	Carousel.defaultProps = {
	  interval: 5000,
	  pause: 'hover',
	  keyboard: true,
	  slide: true,
	  enableTouch: true
	};
	Carousel.childContextTypes = {
	  direction: _propTypes.default.string
	};
	var _default = Carousel;
	exports.default = _default;

/***/ },
/* 640 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _utils = __webpack_require__(11);
	
	var CarouselCaption = function CarouselCaption(props) {
	  var captionHeader = props.captionHeader,
	      captionText = props.captionText,
	      cssModule = props.cssModule,
	      className = props.className;
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'carousel-caption', 'd-none', 'd-md-block'), cssModule);
	  return _react.default.createElement("div", {
	    className: classes
	  }, _react.default.createElement("h3", null, captionHeader), _react.default.createElement("p", null, captionText));
	};
	
	CarouselCaption.propTypes = {
	  captionHeader: _propTypes.default.node,
	  captionText: _propTypes.default.node.isRequired,
	  cssModule: _propTypes.default.object,
	  className: _propTypes.default.string
	};
	var _default = CarouselCaption;
	exports.default = _default;

/***/ },
/* 641 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _utils = __webpack_require__(11);
	
	var CarouselControl = function CarouselControl(props) {
	  var direction = props.direction,
	      onClickHandler = props.onClickHandler,
	      cssModule = props.cssModule,
	      directionText = props.directionText,
	      className = props.className;
	  var anchorClasses = (0, _utils.mapToCssModules)((0, _classnames.default)(className, "carousel-control-" + direction), cssModule);
	  var iconClasses = (0, _utils.mapToCssModules)((0, _classnames.default)("carousel-control-" + direction + "-icon"), cssModule);
	  var screenReaderClasses = (0, _utils.mapToCssModules)((0, _classnames.default)('sr-only'), cssModule);
	  return _react.default.createElement("a", {
	    className: anchorClasses,
	    style: {
	      cursor: "pointer"
	    },
	    role: "button",
	    tabIndex: "0",
	    onClick: function onClick(e) {
	      e.preventDefault();
	      onClickHandler();
	    }
	  }, _react.default.createElement("span", {
	    className: iconClasses,
	    "aria-hidden": "true"
	  }), _react.default.createElement("span", {
	    className: screenReaderClasses
	  }, directionText || direction));
	};
	
	CarouselControl.propTypes = {
	  direction: _propTypes.default.oneOf(['prev', 'next']).isRequired,
	  onClickHandler: _propTypes.default.func.isRequired,
	  cssModule: _propTypes.default.object,
	  directionText: _propTypes.default.string,
	  className: _propTypes.default.string
	};
	var _default = CarouselControl;
	exports.default = _default;

/***/ },
/* 642 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _utils = __webpack_require__(11);
	
	var CarouselIndicators = function CarouselIndicators(props) {
	  var items = props.items,
	      activeIndex = props.activeIndex,
	      cssModule = props.cssModule,
	      onClickHandler = props.onClickHandler,
	      className = props.className;
	  var listClasses = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'carousel-indicators'), cssModule);
	  var indicators = items.map(function (item, idx) {
	    var indicatorClasses = (0, _utils.mapToCssModules)((0, _classnames.default)({
	      active: activeIndex === idx
	    }), cssModule);
	    return _react.default.createElement("li", {
	      key: "" + (item.key || Object.values(item).join('')),
	      onClick: function onClick(e) {
	        e.preventDefault();
	        onClickHandler(idx);
	      },
	      className: indicatorClasses
	    });
	  });
	  return _react.default.createElement("ol", {
	    className: listClasses
	  }, indicators);
	};
	
	CarouselIndicators.propTypes = {
	  items: _propTypes.default.array.isRequired,
	  activeIndex: _propTypes.default.number.isRequired,
	  cssModule: _propTypes.default.object,
	  onClickHandler: _propTypes.default.func.isRequired,
	  className: _propTypes.default.string
	};
	var _default = CarouselIndicators;
	exports.default = _default;

/***/ },
/* 643 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(13));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(12));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(34));
	
	var _objectSpread5 = _interopRequireDefault(__webpack_require__(47));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _reactTransitionGroup = __webpack_require__(303);
	
	var _utils = __webpack_require__(11);
	
	var _transitionStatusToCl;
	
	var propTypes = (0, _objectSpread5.default)({}, _reactTransitionGroup.Transition.propTypes, {
	  isOpen: _propTypes.default.bool,
	  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]),
	  tag: _utils.tagPropType,
	  className: _propTypes.default.node,
	  navbar: _propTypes.default.bool,
	  cssModule: _propTypes.default.object,
	  innerRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.string, _propTypes.default.object])
	});
	var defaultProps = (0, _objectSpread5.default)({}, _reactTransitionGroup.Transition.defaultProps, {
	  isOpen: false,
	  appear: false,
	  enter: true,
	  exit: true,
	  tag: 'div',
	  timeout: _utils.TransitionTimeouts.Collapse
	});
	var transitionStatusToClassHash = (_transitionStatusToCl = {}, _transitionStatusToCl[_utils.TransitionStatuses.ENTERING] = 'collapsing', _transitionStatusToCl[_utils.TransitionStatuses.ENTERED] = 'collapse show', _transitionStatusToCl[_utils.TransitionStatuses.EXITING] = 'collapsing', _transitionStatusToCl[_utils.TransitionStatuses.EXITED] = 'collapse', _transitionStatusToCl);
	
	function getTransitionClass(status) {
	  return transitionStatusToClassHash[status] || 'collapse';
	}
	
	function getHeight(node) {
	  return node.scrollHeight;
	}
	
	var Collapse =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inheritsLoose2.default)(Collapse, _Component);
	
	  function Collapse(props) {
	    var _this;
	
	    _this = _Component.call(this, props) || this;
	    _this.state = {
	      height: null
	    };
	    ['onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited'].forEach(function (name) {
	      _this[name] = _this[name].bind((0, _assertThisInitialized2.default)(_this));
	    });
	    return _this;
	  }
	
	  var _proto = Collapse.prototype;
	
	  _proto.onEntering = function onEntering(node, isAppearing) {
	    this.setState({
	      height: getHeight(node)
	    });
	    this.props.onEntering(node, isAppearing);
	  };
	
	  _proto.onEntered = function onEntered(node, isAppearing) {
	    this.setState({
	      height: null
	    });
	    this.props.onEntered(node, isAppearing);
	  };
	
	  _proto.onExit = function onExit(node) {
	    this.setState({
	      height: getHeight(node)
	    });
	    this.props.onExit(node);
	  };
	
	  _proto.onExiting = function onExiting(node) {
	    // getting this variable triggers a reflow
	    var _unused = node.offsetHeight; // eslint-disable-line no-unused-vars
	
	    this.setState({
	      height: 0
	    });
	    this.props.onExiting(node);
	  };
	
	  _proto.onExited = function onExited(node) {
	    this.setState({
	      height: null
	    });
	    this.props.onExited(node);
	  };
	
	  _proto.render = function render() {
	    var _this2 = this;
	
	    var _this$props = this.props,
	        Tag = _this$props.tag,
	        isOpen = _this$props.isOpen,
	        className = _this$props.className,
	        navbar = _this$props.navbar,
	        cssModule = _this$props.cssModule,
	        children = _this$props.children,
	        innerRef = _this$props.innerRef,
	        otherProps = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["tag", "isOpen", "className", "navbar", "cssModule", "children", "innerRef"]);
	    var height = this.state.height;
	    var transitionProps = (0, _utils.pick)(otherProps, _utils.TransitionPropTypeKeys);
	    var childProps = (0, _utils.omit)(otherProps, _utils.TransitionPropTypeKeys);
	    return _react.default.createElement(_reactTransitionGroup.Transition, (0, _extends2.default)({}, transitionProps, {
	      in: isOpen,
	      onEntering: this.onEntering,
	      onEntered: this.onEntered,
	      onExit: this.onExit,
	      onExiting: this.onExiting,
	      onExited: this.onExited
	    }), function (status) {
	      var collapseClass = getTransitionClass(status);
	      var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, collapseClass, navbar && 'navbar-collapse'), cssModule);
	      var style = height === null ? null : {
	        height: height
	      };
	      return _react.default.createElement(Tag, (0, _extends2.default)({}, childProps, {
	        style: (0, _objectSpread5.default)({}, childProps.style, {}, style),
	        className: classes,
	        ref: _this2.props.innerRef
	      }), children);
	    });
	  };
	
	  return Collapse;
	}(_react.Component);
	
	Collapse.propTypes = propTypes;
	Collapse.defaultProps = defaultProps;
	var _default = Collapse;
	exports.default = _default;

/***/ },
/* 644 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(13));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(12));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(34));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _utils = __webpack_require__(11);
	
	var propTypes = {
	  className: _propTypes.default.string,
	  id: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]).isRequired,
	  label: _propTypes.default.node,
	  valid: _propTypes.default.bool,
	  invalid: _propTypes.default.bool,
	  bsSize: _propTypes.default.string,
	  htmlFor: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  onChange: _propTypes.default.func,
	  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.array, _propTypes.default.func]),
	  innerRef: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string, _propTypes.default.func])
	};
	
	var CustomFileInput =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(CustomFileInput, _React$Component);
	
	  function CustomFileInput(props) {
	    var _this;
	
	    _this = _React$Component.call(this, props) || this;
	    _this.state = {
	      files: null
	    };
	    _this.onChange = _this.onChange.bind((0, _assertThisInitialized2.default)(_this));
	    return _this;
	  }
	
	  var _proto = CustomFileInput.prototype;
	
	  _proto.onChange = function onChange(e) {
	    var input = e.target;
	    var onChange = this.props.onChange;
	    var files = this.getSelectedFiles(input);
	
	    if (typeof onChange === 'function') {
	      onChange.apply(void 0, arguments);
	    }
	
	    this.setState({
	      files: files
	    });
	  };
	
	  _proto.getSelectedFiles = function getSelectedFiles(input) {
	    var multiple = this.props.multiple;
	
	    if (multiple && input.files) {
	      var files = [].slice.call(input.files);
	      return files.map(function (file) {
	        return file.name;
	      }).join(', ');
	    }
	
	    if (input.value.indexOf('fakepath') !== -1) {
	      var parts = input.value.split('\\');
	      return parts[parts.length - 1];
	    }
	
	    return input.value;
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        className = _this$props.className,
	        label = _this$props.label,
	        valid = _this$props.valid,
	        invalid = _this$props.invalid,
	        cssModule = _this$props.cssModule,
	        children = _this$props.children,
	        bsSize = _this$props.bsSize,
	        innerRef = _this$props.innerRef,
	        htmlFor = _this$props.htmlFor,
	        type = _this$props.type,
	        onChange = _this$props.onChange,
	        dataBrowse = _this$props.dataBrowse,
	        attributes = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["className", "label", "valid", "invalid", "cssModule", "children", "bsSize", "innerRef", "htmlFor", "type", "onChange", "dataBrowse"]);
	    var customClass = (0, _utils.mapToCssModules)((0, _classnames.default)(className, "custom-file"), cssModule);
	    var validationClassNames = (0, _utils.mapToCssModules)((0, _classnames.default)(invalid && 'is-invalid', valid && 'is-valid'), cssModule);
	    var labelHtmlFor = htmlFor || attributes.id;
	    var files = this.state.files;
	    return _react.default.createElement("div", {
	      className: customClass
	    }, _react.default.createElement("input", (0, _extends2.default)({
	      type: "file"
	    }, attributes, {
	      ref: innerRef,
	      className: (0, _classnames.default)(validationClassNames, (0, _utils.mapToCssModules)('custom-file-input', cssModule)),
	      onChange: this.onChange
	    })), _react.default.createElement("label", {
	      className: (0, _utils.mapToCssModules)('custom-file-label', cssModule),
	      htmlFor: labelHtmlFor,
	      "data-browse": dataBrowse
	    }, files || label || 'Choose file'), children);
	  };
	
	  return CustomFileInput;
	}(_react.default.Component);
	
	CustomFileInput.propTypes = propTypes;
	var _default = CustomFileInput;
	exports.default = _default;

/***/ },
/* 645 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _utils = __webpack_require__(11);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'span'
	};
	
	var InputGroupText = function InputGroupText(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'input-group-text'), cssModule);
	  return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	InputGroupText.propTypes = propTypes;
	InputGroupText.defaultProps = defaultProps;
	var _default = InputGroupText;
	exports.default = _default;

/***/ },
/* 646 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _TooltipPopoverWrapper = _interopRequireWildcard(__webpack_require__(650));
	
	var defaultProps = {
	  placement: 'right',
	  placementPrefix: 'bs-popover',
	  trigger: 'click'
	};
	
	var Popover = function Popover(props) {
	  var popperClasses = (0, _classnames.default)('popover', 'show', props.popperClassName);
	  var classes = (0, _classnames.default)('popover-inner', props.innerClassName);
	  return _react.default.createElement(_TooltipPopoverWrapper.default, (0, _extends2.default)({}, props, {
	    popperClassName: popperClasses,
	    innerClassName: classes
	  }));
	};
	
	Popover.propTypes = _TooltipPopoverWrapper.propTypes;
	Popover.defaultProps = defaultProps;
	var _default = Popover;
	exports.default = _default;

/***/ },
/* 647 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(13));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(12));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(34));
	
	var _objectSpread5 = _interopRequireDefault(__webpack_require__(47));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(43));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _reactPopper = __webpack_require__(169);
	
	var _utils = __webpack_require__(11);
	
	var _Fade = _interopRequireDefault(__webpack_require__(173));
	
	function noop() {}
	
	var propTypes = {
	  children: _propTypes.default.node.isRequired,
	  popperClassName: _propTypes.default.string,
	  placement: _propTypes.default.string,
	  placementPrefix: _propTypes.default.string,
	  arrowClassName: _propTypes.default.string,
	  hideArrow: _propTypes.default.bool,
	  tag: _utils.tagPropType,
	  isOpen: _propTypes.default.bool.isRequired,
	  cssModule: _propTypes.default.object,
	  offset: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  fallbackPlacement: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.array]),
	  flip: _propTypes.default.bool,
	  container: _utils.targetPropType,
	  target: _utils.targetPropType.isRequired,
	  modifiers: _propTypes.default.object,
	  boundariesElement: _propTypes.default.oneOfType([_propTypes.default.string, _utils.DOMElement]),
	  onClosed: _propTypes.default.func,
	  fade: _propTypes.default.bool,
	  transition: _propTypes.default.shape(_Fade.default.propTypes)
	};
	var defaultProps = {
	  boundariesElement: 'scrollParent',
	  placement: 'auto',
	  hideArrow: false,
	  isOpen: false,
	  offset: 0,
	  fallbackPlacement: 'flip',
	  flip: true,
	  container: 'body',
	  modifiers: {},
	  onClosed: noop,
	  fade: true,
	  transition: (0, _objectSpread5.default)({}, _Fade.default.defaultProps)
	};
	
	var PopperContent =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(PopperContent, _React$Component);
	
	  function PopperContent(props) {
	    var _this;
	
	    _this = _React$Component.call(this, props) || this;
	    _this.setTargetNode = _this.setTargetNode.bind((0, _assertThisInitialized2.default)(_this));
	    _this.getTargetNode = _this.getTargetNode.bind((0, _assertThisInitialized2.default)(_this));
	    _this.getRef = _this.getRef.bind((0, _assertThisInitialized2.default)(_this));
	    _this.onClosed = _this.onClosed.bind((0, _assertThisInitialized2.default)(_this));
	    _this.state = {
	      isOpen: props.isOpen
	    };
	    return _this;
	  }
	
	  PopperContent.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
	    if (props.isOpen && !state.isOpen) {
	      return {
	        isOpen: props.isOpen
	      };
	    } else return null;
	  };
	
	  var _proto = PopperContent.prototype;
	
	  _proto.componentDidUpdate = function componentDidUpdate() {
	    if (this._element && this._element.childNodes && this._element.childNodes[0] && this._element.childNodes[0].focus) {
	      this._element.childNodes[0].focus();
	    }
	  };
	
	  _proto.setTargetNode = function setTargetNode(node) {
	    this.targetNode = typeof node === 'string' ? (0, _utils.getTarget)(node) : node;
	  };
	
	  _proto.getTargetNode = function getTargetNode() {
	    return this.targetNode;
	  };
	
	  _proto.getContainerNode = function getContainerNode() {
	    return (0, _utils.getTarget)(this.props.container);
	  };
	
	  _proto.getRef = function getRef(ref) {
	    this._element = ref;
	  };
	
	  _proto.onClosed = function onClosed() {
	    this.props.onClosed();
	    this.setState({
	      isOpen: false
	    });
	  };
	
	  _proto.renderChildren = function renderChildren() {
	    var _this$props = this.props,
	        cssModule = _this$props.cssModule,
	        children = _this$props.children,
	        isOpen = _this$props.isOpen,
	        flip = _this$props.flip,
	        target = _this$props.target,
	        offset = _this$props.offset,
	        fallbackPlacement = _this$props.fallbackPlacement,
	        placementPrefix = _this$props.placementPrefix,
	        _arrowClassName = _this$props.arrowClassName,
	        hideArrow = _this$props.hideArrow,
	        _popperClassName = _this$props.popperClassName,
	        tag = _this$props.tag,
	        container = _this$props.container,
	        modifiers = _this$props.modifiers,
	        boundariesElement = _this$props.boundariesElement,
	        onClosed = _this$props.onClosed,
	        fade = _this$props.fade,
	        transition = _this$props.transition,
	        placement = _this$props.placement,
	        attrs = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["cssModule", "children", "isOpen", "flip", "target", "offset", "fallbackPlacement", "placementPrefix", "arrowClassName", "hideArrow", "popperClassName", "tag", "container", "modifiers", "boundariesElement", "onClosed", "fade", "transition", "placement"]);
	    var arrowClassName = (0, _utils.mapToCssModules)((0, _classnames.default)('arrow', _arrowClassName), cssModule);
	    var popperClassName = (0, _utils.mapToCssModules)((0, _classnames.default)(_popperClassName, placementPrefix ? placementPrefix + "-auto" : ''), this.props.cssModule);
	    var extendedModifiers = (0, _objectSpread5.default)({
	      offset: {
	        offset: offset
	      },
	      flip: {
	        enabled: flip,
	        behavior: fallbackPlacement
	      },
	      preventOverflow: {
	        boundariesElement: boundariesElement
	      }
	    }, modifiers);
	    var popperTransition = (0, _objectSpread5.default)({}, _Fade.default.defaultProps, {}, transition, {
	      baseClass: fade ? transition.baseClass : '',
	      timeout: fade ? transition.timeout : 0
	    });
	    return _react.default.createElement(_Fade.default, (0, _extends2.default)({}, popperTransition, attrs, {
	      in: isOpen,
	      onExited: this.onClosed,
	      tag: tag
	    }), _react.default.createElement(_reactPopper.Popper, {
	      referenceElement: this.targetNode,
	      modifiers: extendedModifiers,
	      placement: placement
	    }, function (_ref) {
	      var ref = _ref.ref,
	          style = _ref.style,
	          placement = _ref.placement,
	          arrowProps = _ref.arrowProps;
	      return _react.default.createElement("div", {
	        ref: ref,
	        style: style,
	        className: popperClassName,
	        "x-placement": placement
	      }, children, !hideArrow && _react.default.createElement("span", {
	        ref: arrowProps.ref,
	        className: arrowClassName,
	        style: arrowProps.style
	      }));
	    }));
	  };
	
	  _proto.render = function render() {
	    this.setTargetNode(this.props.target);
	
	    if (this.state.isOpen) {
	      return this.props.container === 'inline' ? this.renderChildren() : _reactDom.default.createPortal(_react.default.createElement("div", {
	        ref: this.getRef
	      }, this.renderChildren()), this.getContainerNode());
	    }
	
	    return null;
	  };
	
	  return PopperContent;
	}(_react.default.Component);
	
	PopperContent.propTypes = propTypes;
	PopperContent.defaultProps = defaultProps;
	var _default = PopperContent;
	exports.default = _default;

/***/ },
/* 648 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.TabContext = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	/**
	 * TabContext
	 * {
	 *  activeTabId: PropTypes.any
	 * }
	 */
	var TabContext = _react.default.createContext({});
	
	exports.TabContext = TabContext;

/***/ },
/* 649 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _TooltipPopoverWrapper = _interopRequireWildcard(__webpack_require__(650));
	
	var defaultProps = {
	  placement: 'top',
	  autohide: true,
	  placementPrefix: 'bs-tooltip',
	  trigger: 'hover focus'
	};
	
	var Tooltip = function Tooltip(props) {
	  var popperClasses = (0, _classnames.default)('tooltip', 'show', props.popperClassName);
	  var classes = (0, _classnames.default)('tooltip-inner', props.innerClassName);
	  return _react.default.createElement(_TooltipPopoverWrapper.default, (0, _extends2.default)({}, props, {
	    popperClassName: popperClasses,
	    innerClassName: classes
	  }));
	};
	
	Tooltip.propTypes = _TooltipPopoverWrapper.propTypes;
	Tooltip.defaultProps = defaultProps;
	var _default = Tooltip;
	exports.default = _default;

/***/ },
/* 650 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = exports.propTypes = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(12));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(34));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _PopperContent = _interopRequireDefault(__webpack_require__(647));
	
	var _utils = __webpack_require__(11);
	
	var propTypes = {
	  placement: _propTypes.default.oneOf(_utils.PopperPlacements),
	  target: _utils.targetPropType.isRequired,
	  container: _utils.targetPropType,
	  isOpen: _propTypes.default.bool,
	  disabled: _propTypes.default.bool,
	  hideArrow: _propTypes.default.bool,
	  boundariesElement: _propTypes.default.oneOfType([_propTypes.default.string, _utils.DOMElement]),
	  className: _propTypes.default.string,
	  innerClassName: _propTypes.default.string,
	  arrowClassName: _propTypes.default.string,
	  popperClassName: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  toggle: _propTypes.default.func,
	  autohide: _propTypes.default.bool,
	  placementPrefix: _propTypes.default.string,
	  delay: _propTypes.default.oneOfType([_propTypes.default.shape({
	    show: _propTypes.default.number,
	    hide: _propTypes.default.number
	  }), _propTypes.default.number]),
	  modifiers: _propTypes.default.object,
	  offset: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  innerRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.string, _propTypes.default.object]),
	  trigger: _propTypes.default.string,
	  fade: _propTypes.default.bool,
	  flip: _propTypes.default.bool
	};
	exports.propTypes = propTypes;
	var DEFAULT_DELAYS = {
	  show: 0,
	  hide: 50
	};
	var defaultProps = {
	  isOpen: false,
	  hideArrow: false,
	  autohide: false,
	  delay: DEFAULT_DELAYS,
	  toggle: function toggle() {},
	  trigger: 'click',
	  fade: true
	};
	
	function isInDOMSubtree(element, subtreeRoot) {
	  return subtreeRoot && (element === subtreeRoot || subtreeRoot.contains(element));
	}
	
	function isInDOMSubtrees(element, subtreeRoots) {
	  if (subtreeRoots === void 0) {
	    subtreeRoots = [];
	  }
	
	  return subtreeRoots && subtreeRoots.length && subtreeRoots.find(function (subTreeRoot) {
	    return isInDOMSubtree(element, subTreeRoot);
	  });
	}
	
	var TooltipPopoverWrapper =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(TooltipPopoverWrapper, _React$Component);
	
	  function TooltipPopoverWrapper(props) {
	    var _this;
	
	    _this = _React$Component.call(this, props) || this;
	    _this._targets = [];
	    _this.currentTargetElement = null;
	    _this.addTargetEvents = _this.addTargetEvents.bind((0, _assertThisInitialized2.default)(_this));
	    _this.handleDocumentClick = _this.handleDocumentClick.bind((0, _assertThisInitialized2.default)(_this));
	    _this.removeTargetEvents = _this.removeTargetEvents.bind((0, _assertThisInitialized2.default)(_this));
	    _this.toggle = _this.toggle.bind((0, _assertThisInitialized2.default)(_this));
	    _this.showWithDelay = _this.showWithDelay.bind((0, _assertThisInitialized2.default)(_this));
	    _this.hideWithDelay = _this.hideWithDelay.bind((0, _assertThisInitialized2.default)(_this));
	    _this.onMouseOverTooltipContent = _this.onMouseOverTooltipContent.bind((0, _assertThisInitialized2.default)(_this));
	    _this.onMouseLeaveTooltipContent = _this.onMouseLeaveTooltipContent.bind((0, _assertThisInitialized2.default)(_this));
	    _this.show = _this.show.bind((0, _assertThisInitialized2.default)(_this));
	    _this.hide = _this.hide.bind((0, _assertThisInitialized2.default)(_this));
	    _this.onEscKeyDown = _this.onEscKeyDown.bind((0, _assertThisInitialized2.default)(_this));
	    _this.getRef = _this.getRef.bind((0, _assertThisInitialized2.default)(_this));
	    _this.state = {
	      isOpen: props.isOpen
	    };
	    _this._isMounted = false;
	    return _this;
	  }
	
	  var _proto = TooltipPopoverWrapper.prototype;
	
	  _proto.componentDidMount = function componentDidMount() {
	    this._isMounted = true;
	    this.updateTarget();
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this._isMounted = false;
	    this.removeTargetEvents();
	    this._targets = null;
	    this.clearShowTimeout();
	    this.clearHideTimeout();
	  };
	
	  TooltipPopoverWrapper.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
	    if (props.isOpen && !state.isOpen) {
	      return {
	        isOpen: props.isOpen
	      };
	    } else return null;
	  };
	
	  _proto.onMouseOverTooltipContent = function onMouseOverTooltipContent() {
	    if (this.props.trigger.indexOf('hover') > -1 && !this.props.autohide) {
	      if (this._hideTimeout) {
	        this.clearHideTimeout();
	      }
	
	      if (this.state.isOpen && !this.props.isOpen) {
	        this.toggle();
	      }
	    }
	  };
	
	  _proto.onMouseLeaveTooltipContent = function onMouseLeaveTooltipContent(e) {
	    if (this.props.trigger.indexOf('hover') > -1 && !this.props.autohide) {
	      if (this._showTimeout) {
	        this.clearShowTimeout();
	      }
	
	      e.persist();
	      this._hideTimeout = setTimeout(this.hide.bind(this, e), this.getDelay('hide'));
	    }
	  };
	
	  _proto.onEscKeyDown = function onEscKeyDown(e) {
	    if (e.key === 'Escape') {
	      this.hide(e);
	    }
	  };
	
	  _proto.getRef = function getRef(ref) {
	    var innerRef = this.props.innerRef;
	
	    if (innerRef) {
	      if (typeof innerRef === 'function') {
	        innerRef(ref);
	      } else if (typeof innerRef === 'object') {
	        innerRef.current = ref;
	      }
	    }
	
	    this._popover = ref;
	  };
	
	  _proto.getDelay = function getDelay(key) {
	    var delay = this.props.delay;
	
	    if (typeof delay === 'object') {
	      return isNaN(delay[key]) ? DEFAULT_DELAYS[key] : delay[key];
	    }
	
	    return delay;
	  };
	
	  _proto.show = function show(e) {
	    if (!this.props.isOpen) {
	      this.clearShowTimeout();
	      this.currentTargetElement = e ? e.currentTarget || e.target : null;
	
	      if (e && e.composedPath && typeof e.composedPath === 'function') {
	        var path = e.composedPath();
	        this.currentTargetElement = path && path[0] || this.currentTargetElement;
	      }
	
	      this.toggle(e);
	    }
	  };
	
	  _proto.showWithDelay = function showWithDelay(e) {
	    if (this._hideTimeout) {
	      this.clearHideTimeout();
	    }
	
	    this._showTimeout = setTimeout(this.show.bind(this, e), this.getDelay('show'));
	  };
	
	  _proto.hide = function hide(e) {
	    if (this.props.isOpen) {
	      this.clearHideTimeout();
	      this.currentTargetElement = null;
	      this.toggle(e);
	    }
	  };
	
	  _proto.hideWithDelay = function hideWithDelay(e) {
	    if (this._showTimeout) {
	      this.clearShowTimeout();
	    }
	
	    this._hideTimeout = setTimeout(this.hide.bind(this, e), this.getDelay('hide'));
	  };
	
	  _proto.clearShowTimeout = function clearShowTimeout() {
	    clearTimeout(this._showTimeout);
	    this._showTimeout = undefined;
	  };
	
	  _proto.clearHideTimeout = function clearHideTimeout() {
	    clearTimeout(this._hideTimeout);
	    this._hideTimeout = undefined;
	  };
	
	  _proto.handleDocumentClick = function handleDocumentClick(e) {
	    var triggers = this.props.trigger.split(' ');
	
	    if (triggers.indexOf('legacy') > -1 && (this.props.isOpen || isInDOMSubtrees(e.target, this._targets))) {
	      if (this._hideTimeout) {
	        this.clearHideTimeout();
	      }
	
	      if (this.props.isOpen && !isInDOMSubtree(e.target, this._popover)) {
	        this.hideWithDelay(e);
	      } else if (!this.props.isOpen) {
	        this.showWithDelay(e);
	      }
	    } else if (triggers.indexOf('click') > -1 && isInDOMSubtrees(e.target, this._targets)) {
	      if (this._hideTimeout) {
	        this.clearHideTimeout();
	      }
	
	      if (!this.props.isOpen) {
	        this.showWithDelay(e);
	      } else {
	        this.hideWithDelay(e);
	      }
	    }
	  };
	
	  _proto.addEventOnTargets = function addEventOnTargets(type, handler, isBubble) {
	    this._targets.forEach(function (target) {
	      target.addEventListener(type, handler, isBubble);
	    });
	  };
	
	  _proto.removeEventOnTargets = function removeEventOnTargets(type, handler, isBubble) {
	    this._targets.forEach(function (target) {
	      target.removeEventListener(type, handler, isBubble);
	    });
	  };
	
	  _proto.addTargetEvents = function addTargetEvents() {
	    if (this.props.trigger) {
	      var triggers = this.props.trigger.split(' ');
	
	      if (triggers.indexOf('manual') === -1) {
	        if (triggers.indexOf('click') > -1 || triggers.indexOf('legacy') > -1) {
	          document.addEventListener('click', this.handleDocumentClick, true);
	        }
	
	        if (this._targets && this._targets.length) {
	          if (triggers.indexOf('hover') > -1) {
	            this.addEventOnTargets('mouseover', this.showWithDelay, true);
	            this.addEventOnTargets('mouseout', this.hideWithDelay, true);
	          }
	
	          if (triggers.indexOf('focus') > -1) {
	            this.addEventOnTargets('focusin', this.show, true);
	            this.addEventOnTargets('focusout', this.hide, true);
	          }
	
	          this.addEventOnTargets('keydown', this.onEscKeyDown, true);
	        }
	      }
	    }
	  };
	
	  _proto.removeTargetEvents = function removeTargetEvents() {
	    if (this._targets) {
	      this.removeEventOnTargets('mouseover', this.showWithDelay, true);
	      this.removeEventOnTargets('mouseout', this.hideWithDelay, true);
	      this.removeEventOnTargets('keydown', this.onEscKeyDown, true);
	      this.removeEventOnTargets('focusin', this.show, true);
	      this.removeEventOnTargets('focusout', this.hide, true);
	    }
	
	    document.removeEventListener('click', this.handleDocumentClick, true);
	  };
	
	  _proto.updateTarget = function updateTarget() {
	    var newTarget = (0, _utils.getTarget)(this.props.target, true);
	
	    if (newTarget !== this._targets) {
	      this.removeTargetEvents();
	      this._targets = newTarget ? Array.from(newTarget) : [];
	      this.currentTargetElement = this.currentTargetElement || this._targets[0];
	      this.addTargetEvents();
	    }
	  };
	
	  _proto.toggle = function toggle(e) {
	    if (this.props.disabled || !this._isMounted) {
	      return e && e.preventDefault();
	    }
	
	    return this.props.toggle(e);
	  };
	
	  _proto.render = function render() {
	    if (!this.props.isOpen) {
	      return null;
	    }
	
	    this.updateTarget();
	    var _this$props = this.props,
	        className = _this$props.className,
	        cssModule = _this$props.cssModule,
	        innerClassName = _this$props.innerClassName,
	        isOpen = _this$props.isOpen,
	        hideArrow = _this$props.hideArrow,
	        boundariesElement = _this$props.boundariesElement,
	        placement = _this$props.placement,
	        placementPrefix = _this$props.placementPrefix,
	        arrowClassName = _this$props.arrowClassName,
	        popperClassName = _this$props.popperClassName,
	        container = _this$props.container,
	        modifiers = _this$props.modifiers,
	        offset = _this$props.offset,
	        fade = _this$props.fade,
	        flip = _this$props.flip;
	    var attributes = (0, _utils.omit)(this.props, Object.keys(propTypes));
	    var popperClasses = (0, _utils.mapToCssModules)(popperClassName, cssModule);
	    var classes = (0, _utils.mapToCssModules)(innerClassName, cssModule);
	    return _react.default.createElement(_PopperContent.default, {
	      className: className,
	      target: this.currentTargetElement || this._targets[0],
	      isOpen: isOpen,
	      hideArrow: hideArrow,
	      boundariesElement: boundariesElement,
	      placement: placement,
	      placementPrefix: placementPrefix,
	      arrowClassName: arrowClassName,
	      popperClassName: popperClasses,
	      container: container,
	      modifiers: modifiers,
	      offset: offset,
	      cssModule: cssModule,
	      fade: fade,
	      flip: flip
	    }, _react.default.createElement("div", (0, _extends2.default)({}, attributes, {
	      ref: this.getRef,
	      className: classes,
	      role: "tooltip",
	      onMouseOver: this.onMouseOverTooltipContent,
	      onMouseLeave: this.onMouseLeaveTooltipContent,
	      onKeyDown: this.onEscKeyDown
	    })));
	  };
	
	  return TooltipPopoverWrapper;
	}(_react.default.Component);
	
	TooltipPopoverWrapper.propTypes = propTypes;
	TooltipPopoverWrapper.defaultProps = defaultProps;
	var _default = TooltipPopoverWrapper;
	exports.default = _default;

/***/ },
/* 651 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(3));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(43));
	
	var _reactLifecyclesCompat = __webpack_require__(294);
	
	var _PropTypes = __webpack_require__(653);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	var UNMOUNTED = 'unmounted';
	exports.UNMOUNTED = UNMOUNTED;
	var EXITED = 'exited';
	exports.EXITED = EXITED;
	var ENTERING = 'entering';
	exports.ENTERING = ENTERING;
	var ENTERED = 'entered';
	exports.ENTERED = ENTERED;
	var EXITING = 'exiting';
	/**
	 * The Transition component lets you describe a transition from one component
	 * state to another _over time_ with a simple declarative API. Most commonly
	 * it's used to animate the mounting and unmounting of a component, but can also
	 * be used to describe in-place transition states as well.
	 *
	 * ---
	 *
	 * **Note**: `Transition` is a platform-agnostic base component. If you're using
	 * transitions in CSS, you'll probably want to use
	 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
	 * instead. It inherits all the features of `Transition`, but contains
	 * additional features necessary to play nice with CSS transitions (hence the
	 * name of the component).
	 *
	 * ---
	 *
	 * By default the `Transition` component does not alter the behavior of the
	 * component it renders, it only tracks "enter" and "exit" states for the
	 * components. It's up to you to give meaning and effect to those states. For
	 * example we can add styles to a component when it enters or exits:
	 *
	 * ```jsx
	 * import { Transition } from 'react-transition-group';
	 *
	 * const duration = 300;
	 *
	 * const defaultStyle = {
	 *   transition: `opacity ${duration}ms ease-in-out`,
	 *   opacity: 0,
	 * }
	 *
	 * const transitionStyles = {
	 *   entering: { opacity: 0 },
	 *   entered:  { opacity: 1 },
	 * };
	 *
	 * const Fade = ({ in: inProp }) => (
	 *   <Transition in={inProp} timeout={duration}>
	 *     {state => (
	 *       <div style={{
	 *         ...defaultStyle,
	 *         ...transitionStyles[state]
	 *       }}>
	 *         I'm a fade Transition!
	 *       </div>
	 *     )}
	 *   </Transition>
	 * );
	 * ```
	 *
	 * There are 4 main states a Transition can be in:
	 *  - `'entering'`
	 *  - `'entered'`
	 *  - `'exiting'`
	 *  - `'exited'`
	 *
	 * Transition state is toggled via the `in` prop. When `true` the component
	 * begins the "Enter" stage. During this stage, the component will shift from
	 * its current transition state, to `'entering'` for the duration of the
	 * transition and then to the `'entered'` stage once it's complete. Let's take
	 * the following example (we'll use the
	 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
	 *
	 * ```jsx
	 * function App() {
	 *   const [inProp, setInProp] = useState(false);
	 *   return (
	 *     <div>
	 *       <Transition in={inProp} timeout={500}>
	 *         {state => (
	 *           // ...
	 *         )}
	 *       </Transition>
	 *       <button onClick={() => setInProp(true)}>
	 *         Click to Enter
	 *       </button>
	 *     </div>
	 *   );
	 * }
	 * ```
	 *
	 * When the button is clicked the component will shift to the `'entering'` state
	 * and stay there for 500ms (the value of `timeout`) before it finally switches
	 * to `'entered'`.
	 *
	 * When `in` is `false` the same thing happens except the state moves from
	 * `'exiting'` to `'exited'`.
	 */
	
	exports.EXITING = EXITING;
	
	var Transition =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(Transition, _React$Component);
	
	  function Transition(props, context) {
	    var _this;
	
	    _this = _React$Component.call(this, props, context) || this;
	    var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears
	
	    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
	    var initialStatus;
	    _this.appearStatus = null;
	
	    if (props.in) {
	      if (appear) {
	        initialStatus = EXITED;
	        _this.appearStatus = ENTERING;
	      } else {
	        initialStatus = ENTERED;
	      }
	    } else {
	      if (props.unmountOnExit || props.mountOnEnter) {
	        initialStatus = UNMOUNTED;
	      } else {
	        initialStatus = EXITED;
	      }
	    }
	
	    _this.state = {
	      status: initialStatus
	    };
	    _this.nextCallback = null;
	    return _this;
	  }
	
	  var _proto = Transition.prototype;
	
	  _proto.getChildContext = function getChildContext() {
	    return {
	      transitionGroup: null // allows for nested Transitions
	
	    };
	  };
	
	  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
	    var nextIn = _ref.in;
	
	    if (nextIn && prevState.status === UNMOUNTED) {
	      return {
	        status: EXITED
	      };
	    }
	
	    return null;
	  }; // getSnapshotBeforeUpdate(prevProps) {
	  //   let nextStatus = null
	  //   if (prevProps !== this.props) {
	  //     const { status } = this.state
	  //     if (this.props.in) {
	  //       if (status !== ENTERING && status !== ENTERED) {
	  //         nextStatus = ENTERING
	  //       }
	  //     } else {
	  //       if (status === ENTERING || status === ENTERED) {
	  //         nextStatus = EXITING
	  //       }
	  //     }
	  //   }
	  //   return { nextStatus }
	  // }
	
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.updateStatus(true, this.appearStatus);
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var nextStatus = null;
	
	    if (prevProps !== this.props) {
	      var status = this.state.status;
	
	      if (this.props.in) {
	        if (status !== ENTERING && status !== ENTERED) {
	          nextStatus = ENTERING;
	        }
	      } else {
	        if (status === ENTERING || status === ENTERED) {
	          nextStatus = EXITING;
	        }
	      }
	    }
	
	    this.updateStatus(false, nextStatus);
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.cancelNextCallback();
	  };
	
	  _proto.getTimeouts = function getTimeouts() {
	    var timeout = this.props.timeout;
	    var exit, enter, appear;
	    exit = enter = appear = timeout;
	
	    if (timeout != null && typeof timeout !== 'number') {
	      exit = timeout.exit;
	      enter = timeout.enter; // TODO: remove fallback for next major
	
	      appear = timeout.appear !== undefined ? timeout.appear : enter;
	    }
	
	    return {
	      exit: exit,
	      enter: enter,
	      appear: appear
	    };
	  };
	
	  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
	    if (mounting === void 0) {
	      mounting = false;
	    }
	
	    if (nextStatus !== null) {
	      // nextStatus will always be ENTERING or EXITING.
	      this.cancelNextCallback();
	
	      var node = _reactDom.default.findDOMNode(this);
	
	      if (nextStatus === ENTERING) {
	        this.performEnter(node, mounting);
	      } else {
	        this.performExit(node);
	      }
	    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
	      this.setState({
	        status: UNMOUNTED
	      });
	    }
	  };
	
	  _proto.performEnter = function performEnter(node, mounting) {
	    var _this2 = this;
	
	    var enter = this.props.enter;
	    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
	    var timeouts = this.getTimeouts();
	    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
	    // if we are mounting and running this it means appear _must_ be set
	
	    if (!mounting && !enter) {
	      this.safeSetState({
	        status: ENTERED
	      }, function () {
	        _this2.props.onEntered(node);
	      });
	      return;
	    }
	
	    this.props.onEnter(node, appearing);
	    this.safeSetState({
	      status: ENTERING
	    }, function () {
	      _this2.props.onEntering(node, appearing);
	
	      _this2.onTransitionEnd(node, enterTimeout, function () {
	        _this2.safeSetState({
	          status: ENTERED
	        }, function () {
	          _this2.props.onEntered(node, appearing);
	        });
	      });
	    });
	  };
	
	  _proto.performExit = function performExit(node) {
	    var _this3 = this;
	
	    var exit = this.props.exit;
	    var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED
	
	    if (!exit) {
	      this.safeSetState({
	        status: EXITED
	      }, function () {
	        _this3.props.onExited(node);
	      });
	      return;
	    }
	
	    this.props.onExit(node);
	    this.safeSetState({
	      status: EXITING
	    }, function () {
	      _this3.props.onExiting(node);
	
	      _this3.onTransitionEnd(node, timeouts.exit, function () {
	        _this3.safeSetState({
	          status: EXITED
	        }, function () {
	          _this3.props.onExited(node);
	        });
	      });
	    });
	  };
	
	  _proto.cancelNextCallback = function cancelNextCallback() {
	    if (this.nextCallback !== null) {
	      this.nextCallback.cancel();
	      this.nextCallback = null;
	    }
	  };
	
	  _proto.safeSetState = function safeSetState(nextState, callback) {
	    // This shouldn't be necessary, but there are weird race conditions with
	    // setState callbacks and unmounting in testing, so always make sure that
	    // we can cancel any pending setState callbacks after we unmount.
	    callback = this.setNextCallback(callback);
	    this.setState(nextState, callback);
	  };
	
	  _proto.setNextCallback = function setNextCallback(callback) {
	    var _this4 = this;
	
	    var active = true;
	
	    this.nextCallback = function (event) {
	      if (active) {
	        active = false;
	        _this4.nextCallback = null;
	        callback(event);
	      }
	    };
	
	    this.nextCallback.cancel = function () {
	      active = false;
	    };
	
	    return this.nextCallback;
	  };
	
	  _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
	    this.setNextCallback(handler);
	    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
	
	    if (!node || doesNotHaveTimeoutOrListener) {
	      setTimeout(this.nextCallback, 0);
	      return;
	    }
	
	    if (this.props.addEndListener) {
	      this.props.addEndListener(node, this.nextCallback);
	    }
	
	    if (timeout != null) {
	      setTimeout(this.nextCallback, timeout);
	    }
	  };
	
	  _proto.render = function render() {
	    var status = this.state.status;
	
	    if (status === UNMOUNTED) {
	      return null;
	    }
	
	    var _this$props = this.props,
	        children = _this$props.children,
	        childProps = _objectWithoutPropertiesLoose(_this$props, ["children"]); // filter props for Transtition
	
	
	    delete childProps.in;
	    delete childProps.mountOnEnter;
	    delete childProps.unmountOnExit;
	    delete childProps.appear;
	    delete childProps.enter;
	    delete childProps.exit;
	    delete childProps.timeout;
	    delete childProps.addEndListener;
	    delete childProps.onEnter;
	    delete childProps.onEntering;
	    delete childProps.onEntered;
	    delete childProps.onExit;
	    delete childProps.onExiting;
	    delete childProps.onExited;
	
	    if (typeof children === 'function') {
	      return children(status, childProps);
	    }
	
	    var child = _react.default.Children.only(children);
	
	    return _react.default.cloneElement(child, childProps);
	  };
	
	  return Transition;
	}(_react.default.Component);
	
	Transition.contextTypes = {
	  transitionGroup: PropTypes.object
	};
	Transition.childContextTypes = {
	  transitionGroup: function transitionGroup() {}
	};
	Transition.propTypes =  false ? {
	  /**
	   * A `function` child can be used instead of a React element. This function is
	   * called with the current transition status (`'entering'`, `'entered'`,
	   * `'exiting'`, `'exited'`, `'unmounted'`), which can be used to apply context
	   * specific props to a component.
	   *
	   * ```jsx
	   * <Transition in={this.state.in} timeout={150}>
	   *   {state => (
	   *     <MyComponent className={`fade fade-${state}`} />
	   *   )}
	   * </Transition>
	   * ```
	   */
	  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,
	
	  /**
	   * Show the component; triggers the enter or exit states
	   */
	  in: PropTypes.bool,
	
	  /**
	   * By default the child component is mounted immediately along with
	   * the parent `Transition` component. If you want to "lazy mount" the component on the
	   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
	   * mounted, even on "exited", unless you also specify `unmountOnExit`.
	   */
	  mountOnEnter: PropTypes.bool,
	
	  /**
	   * By default the child component stays mounted after it reaches the `'exited'` state.
	   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
	   */
	  unmountOnExit: PropTypes.bool,
	
	  /**
	   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
	   * If you want to transition on the first mount set `appear` to `true`, and the
	   * component will transition in as soon as the `<Transition>` mounts.
	   *
	   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
	   */
	  appear: PropTypes.bool,
	
	  /**
	   * Enable or disable enter transitions.
	   */
	  enter: PropTypes.bool,
	
	  /**
	   * Enable or disable exit transitions.
	   */
	  exit: PropTypes.bool,
	
	  /**
	   * The duration of the transition, in milliseconds.
	   * Required unless `addEndListener` is provided.
	   *
	   * You may specify a single timeout for all transitions:
	   *
	   * ```jsx
	   * timeout={500}
	   * ```
	   *
	   * or individually:
	   *
	   * ```jsx
	   * timeout={{
	   *  appear: 500,
	   *  enter: 300,
	   *  exit: 500,
	   * }}
	   * ```
	   *
	   * - `appear` defaults to the value of `enter`
	   * - `enter` defaults to `0`
	   * - `exit` defaults to `0`
	   *
	   * @type {number | { enter?: number, exit?: number, appear?: number }}
	   */
	  timeout: function timeout(props) {
	    var pt = _PropTypes.timeoutsShape;
	    if (!props.addEndListener) pt = pt.isRequired;
	
	    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return pt.apply(void 0, [props].concat(args));
	  },
	
	  /**
	   * Add a custom transition end trigger. Called with the transitioning
	   * DOM node and a `done` callback. Allows for more fine grained transition end
	   * logic. **Note:** Timeouts are still used as a fallback if provided.
	   *
	   * ```jsx
	   * addEndListener={(node, done) => {
	   *   // use the css transitionend event to mark the finish of a transition
	   *   node.addEventListener('transitionend', done, false);
	   * }}
	   * ```
	   */
	  addEndListener: PropTypes.func,
	
	  /**
	   * Callback fired before the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEnter: PropTypes.func,
	
	  /**
	   * Callback fired after the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntering: PropTypes.func,
	
	  /**
	   * Callback fired after the "entered" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEntered: PropTypes.func,
	
	  /**
	   * Callback fired before the "exiting" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExit: PropTypes.func,
	
	  /**
	   * Callback fired after the "exiting" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExiting: PropTypes.func,
	
	  /**
	   * Callback fired after the "exited" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExited: PropTypes.func // Name the function so it is clearer in the documentation
	
	} : {};
	
	function noop() {}
	
	Transition.defaultProps = {
	  in: false,
	  mountOnEnter: false,
	  unmountOnExit: false,
	  appear: false,
	  enter: true,
	  exit: true,
	  onEnter: noop,
	  onEntering: noop,
	  onEntered: noop,
	  onExit: noop,
	  onExiting: noop,
	  onExited: noop
	};
	Transition.UNMOUNTED = 0;
	Transition.EXITED = 1;
	Transition.ENTERING = 2;
	Transition.ENTERED = 3;
	Transition.EXITING = 4;
	
	var _default = (0, _reactLifecyclesCompat.polyfill)(Transition);
	
	exports.default = _default;

/***/ },
/* 652 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactLifecyclesCompat = __webpack_require__(294);
	
	var _ChildMapping = __webpack_require__(1602);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	var values = Object.values || function (obj) {
	  return Object.keys(obj).map(function (k) {
	    return obj[k];
	  });
	};
	
	var defaultProps = {
	  component: 'div',
	  childFactory: function childFactory(child) {
	    return child;
	  }
	  /**
	   * The `<TransitionGroup>` component manages a set of transition components
	   * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
	   * components, `<TransitionGroup>` is a state machine for managing the mounting
	   * and unmounting of components over time.
	   *
	   * Consider the example below. As items are removed or added to the TodoList the
	   * `in` prop is toggled automatically by the `<TransitionGroup>`.
	   *
	   * Note that `<TransitionGroup>`  does not define any animation behavior!
	   * Exactly _how_ a list item animates is up to the individual transition
	   * component. This means you can mix and match animations across different list
	   * items.
	   */
	
	};
	
	var TransitionGroup =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(TransitionGroup, _React$Component);
	
	  function TransitionGroup(props, context) {
	    var _this;
	
	    _this = _React$Component.call(this, props, context) || this;
	
	    var handleExited = _this.handleExited.bind(_assertThisInitialized(_assertThisInitialized(_this))); // Initial children should all be entering, dependent on appear
	
	
	    _this.state = {
	      handleExited: handleExited,
	      firstRender: true
	    };
	    return _this;
	  }
	
	  var _proto = TransitionGroup.prototype;
	
	  _proto.getChildContext = function getChildContext() {
	    return {
	      transitionGroup: {
	        isMounting: !this.appeared
	      }
	    };
	  };
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.appeared = true;
	    this.mounted = true;
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.mounted = false;
	  };
	
	  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
	    var prevChildMapping = _ref.children,
	        handleExited = _ref.handleExited,
	        firstRender = _ref.firstRender;
	    return {
	      children: firstRender ? (0, _ChildMapping.getInitialChildMapping)(nextProps, handleExited) : (0, _ChildMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
	      firstRender: false
	    };
	  };
	
	  _proto.handleExited = function handleExited(child, node) {
	    var currentChildMapping = (0, _ChildMapping.getChildMapping)(this.props.children);
	    if (child.key in currentChildMapping) return;
	
	    if (child.props.onExited) {
	      child.props.onExited(node);
	    }
	
	    if (this.mounted) {
	      this.setState(function (state) {
	        var children = _extends({}, state.children);
	
	        delete children[child.key];
	        return {
	          children: children
	        };
	      });
	    }
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        Component = _this$props.component,
	        childFactory = _this$props.childFactory,
	        props = _objectWithoutPropertiesLoose(_this$props, ["component", "childFactory"]);
	
	    var children = values(this.state.children).map(childFactory);
	    delete props.appear;
	    delete props.enter;
	    delete props.exit;
	
	    if (Component === null) {
	      return children;
	    }
	
	    return _react.default.createElement(Component, props, children);
	  };
	
	  return TransitionGroup;
	}(_react.default.Component);
	
	TransitionGroup.childContextTypes = {
	  transitionGroup: _propTypes.default.object.isRequired
	};
	TransitionGroup.propTypes =  false ? {
	  /**
	   * `<TransitionGroup>` renders a `<div>` by default. You can change this
	   * behavior by providing a `component` prop.
	   * If you use React v16+ and would like to avoid a wrapping `<div>` element
	   * you can pass in `component={null}`. This is useful if the wrapping div
	   * borks your css styles.
	   */
	  component: _propTypes.default.any,
	
	  /**
	   * A set of `<Transition>` components, that are toggled `in` and out as they
	   * leave. the `<TransitionGroup>` will inject specific transition props, so
	   * remember to spread them through if you are wrapping the `<Transition>` as
	   * with our `<Fade>` example.
	   *
	   * While this component is meant for multiple `Transition` or `CSSTransition`
	   * children, sometimes you may want to have a single transition child with
	   * content that you want to be transitioned out and in when you change it
	   * (e.g. routes, images etc.) In that case you can change the `key` prop of
	   * the transition child as you change its content, this will cause
	   * `TransitionGroup` to transition the child out and back in.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * A convenience prop that enables or disables appear animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  appear: _propTypes.default.bool,
	
	  /**
	   * A convenience prop that enables or disables enter animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  enter: _propTypes.default.bool,
	
	  /**
	   * A convenience prop that enables or disables exit animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  exit: _propTypes.default.bool,
	
	  /**
	   * You may need to apply reactive updates to a child as it is exiting.
	   * This is generally done by using `cloneElement` however in the case of an exiting
	   * child the element has already been removed and not accessible to the consumer.
	   *
	   * If you do need to update a child as it leaves you can provide a `childFactory`
	   * to wrap every child, even the ones that are leaving.
	   *
	   * @type Function(child: ReactElement) -> ReactElement
	   */
	  childFactory: _propTypes.default.func
	} : {};
	TransitionGroup.defaultProps = defaultProps;
	
	var _default = (0, _reactLifecyclesCompat.polyfill)(TransitionGroup);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 653 */
635,
/* 654 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	/*<replacement>*/
	
	var pna = __webpack_require__(202);
	/*</replacement>*/
	
	module.exports = Readable;
	
	/*<replacement>*/
	var isArray = __webpack_require__(1606);
	/*</replacement>*/
	
	/*<replacement>*/
	var Duplex;
	/*</replacement>*/
	
	Readable.ReadableState = ReadableState;
	
	/*<replacement>*/
	var EE = __webpack_require__(155).EventEmitter;
	
	var EElistenerCount = function (emitter, type) {
	  return emitter.listeners(type).length;
	};
	/*</replacement>*/
	
	/*<replacement>*/
	var Stream = __webpack_require__(657);
	/*</replacement>*/
	
	/*<replacement>*/
	
	var Buffer = __webpack_require__(213).Buffer;
	var OurUint8Array = (typeof global !== 'undefined' ? global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function () {};
	function _uint8ArrayToBuffer(chunk) {
	  return Buffer.from(chunk);
	}
	function _isUint8Array(obj) {
	  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
	}
	
	/*</replacement>*/
	
	/*<replacement>*/
	var util = Object.create(__webpack_require__(147));
	util.inherits = __webpack_require__(126);
	/*</replacement>*/
	
	/*<replacement>*/
	var debugUtil = __webpack_require__(1662);
	var debug = void 0;
	if (debugUtil && debugUtil.debuglog) {
	  debug = debugUtil.debuglog('stream');
	} else {
	  debug = function () {};
	}
	/*</replacement>*/
	
	var BufferList = __webpack_require__(1605);
	var destroyImpl = __webpack_require__(656);
	var StringDecoder;
	
	util.inherits(Readable, Stream);
	
	var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];
	
	function prependListener(emitter, event, fn) {
	  // Sadly this is not cacheable as some libraries bundle their own
	  // event emitter implementation with them.
	  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
	
	  // This is a hack to make sure that our error handler is attached before any
	  // userland ones.  NEVER DO THIS. This is here only because this code needs
	  // to continue to work with older versions of Node.js that do not include
	  // the prependListener() method. The goal is to eventually remove this hack.
	  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
	}
	
	function ReadableState(options, stream) {
	  Duplex = Duplex || __webpack_require__(116);
	
	  options = options || {};
	
	  // Duplex streams are both readable and writable, but share
	  // the same options object.
	  // However, some cases require setting options to different
	  // values for the readable and the writable sides of the duplex stream.
	  // These options can be provided separately as readableXXX and writableXXX.
	  var isDuplex = stream instanceof Duplex;
	
	  // object stream flag. Used to make read(n) ignore n and to
	  // make all the buffer merging and length checks go away
	  this.objectMode = !!options.objectMode;
	
	  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
	
	  // the point at which it stops calling _read() to fill the buffer
	  // Note: 0 is a valid value, means "don't call _read preemptively ever"
	  var hwm = options.highWaterMark;
	  var readableHwm = options.readableHighWaterMark;
	  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
	
	  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;else this.highWaterMark = defaultHwm;
	
	  // cast to ints.
	  this.highWaterMark = Math.floor(this.highWaterMark);
	
	  // A linked list is used to store data chunks instead of an array because the
	  // linked list can remove elements from the beginning faster than
	  // array.shift()
	  this.buffer = new BufferList();
	  this.length = 0;
	  this.pipes = null;
	  this.pipesCount = 0;
	  this.flowing = null;
	  this.ended = false;
	  this.endEmitted = false;
	  this.reading = false;
	
	  // a flag to be able to tell if the event 'readable'/'data' is emitted
	  // immediately, or on a later tick.  We set this to true at first, because
	  // any actions that shouldn't happen until "later" should generally also
	  // not happen before the first read call.
	  this.sync = true;
	
	  // whenever we return null, then we set a flag to say
	  // that we're awaiting a 'readable' event emission.
	  this.needReadable = false;
	  this.emittedReadable = false;
	  this.readableListening = false;
	  this.resumeScheduled = false;
	
	  // has it been destroyed
	  this.destroyed = false;
	
	  // Crypto is kind of old and crusty.  Historically, its default string
	  // encoding is 'binary' so we have to make this configurable.
	  // Everything else in the universe uses 'utf8', though.
	  this.defaultEncoding = options.defaultEncoding || 'utf8';
	
	  // the number of writers that are awaiting a drain event in .pipe()s
	  this.awaitDrain = 0;
	
	  // if true, a maybeReadMore has been scheduled
	  this.readingMore = false;
	
	  this.decoder = null;
	  this.encoding = null;
	  if (options.encoding) {
	    if (!StringDecoder) StringDecoder = __webpack_require__(661).StringDecoder;
	    this.decoder = new StringDecoder(options.encoding);
	    this.encoding = options.encoding;
	  }
	}
	
	function Readable(options) {
	  Duplex = Duplex || __webpack_require__(116);
	
	  if (!(this instanceof Readable)) return new Readable(options);
	
	  this._readableState = new ReadableState(options, this);
	
	  // legacy
	  this.readable = true;
	
	  if (options) {
	    if (typeof options.read === 'function') this._read = options.read;
	
	    if (typeof options.destroy === 'function') this._destroy = options.destroy;
	  }
	
	  Stream.call(this);
	}
	
	Object.defineProperty(Readable.prototype, 'destroyed', {
	  get: function () {
	    if (this._readableState === undefined) {
	      return false;
	    }
	    return this._readableState.destroyed;
	  },
	  set: function (value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (!this._readableState) {
	      return;
	    }
	
	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._readableState.destroyed = value;
	  }
	});
	
	Readable.prototype.destroy = destroyImpl.destroy;
	Readable.prototype._undestroy = destroyImpl.undestroy;
	Readable.prototype._destroy = function (err, cb) {
	  this.push(null);
	  cb(err);
	};
	
	// Manually shove something into the read() buffer.
	// This returns true if the highWaterMark has not been hit yet,
	// similar to how Writable.write() returns true if you should
	// write() some more.
	Readable.prototype.push = function (chunk, encoding) {
	  var state = this._readableState;
	  var skipChunkCheck;
	
	  if (!state.objectMode) {
	    if (typeof chunk === 'string') {
	      encoding = encoding || state.defaultEncoding;
	      if (encoding !== state.encoding) {
	        chunk = Buffer.from(chunk, encoding);
	        encoding = '';
	      }
	      skipChunkCheck = true;
	    }
	  } else {
	    skipChunkCheck = true;
	  }
	
	  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
	};
	
	// Unshift should *always* be something directly out of read()
	Readable.prototype.unshift = function (chunk) {
	  return readableAddChunk(this, chunk, null, true, false);
	};
	
	function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
	  var state = stream._readableState;
	  if (chunk === null) {
	    state.reading = false;
	    onEofChunk(stream, state);
	  } else {
	    var er;
	    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
	    if (er) {
	      stream.emit('error', er);
	    } else if (state.objectMode || chunk && chunk.length > 0) {
	      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
	        chunk = _uint8ArrayToBuffer(chunk);
	      }
	
	      if (addToFront) {
	        if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));else addChunk(stream, state, chunk, true);
	      } else if (state.ended) {
	        stream.emit('error', new Error('stream.push() after EOF'));
	      } else {
	        state.reading = false;
	        if (state.decoder && !encoding) {
	          chunk = state.decoder.write(chunk);
	          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
	        } else {
	          addChunk(stream, state, chunk, false);
	        }
	      }
	    } else if (!addToFront) {
	      state.reading = false;
	    }
	  }
	
	  return needMoreData(state);
	}
	
	function addChunk(stream, state, chunk, addToFront) {
	  if (state.flowing && state.length === 0 && !state.sync) {
	    stream.emit('data', chunk);
	    stream.read(0);
	  } else {
	    // update the buffer info.
	    state.length += state.objectMode ? 1 : chunk.length;
	    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);
	
	    if (state.needReadable) emitReadable(stream);
	  }
	  maybeReadMore(stream, state);
	}
	
	function chunkInvalid(state, chunk) {
	  var er;
	  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
	    er = new TypeError('Invalid non-string/buffer chunk');
	  }
	  return er;
	}
	
	// if it's past the high water mark, we can push in some more.
	// Also, if we have no data yet, we can stand some
	// more bytes.  This is to work around cases where hwm=0,
	// such as the repl.  Also, if the push() triggered a
	// readable event, and the user called read(largeNumber) such that
	// needReadable was set, then we ought to push more, so that another
	// 'readable' event will be triggered.
	function needMoreData(state) {
	  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
	}
	
	Readable.prototype.isPaused = function () {
	  return this._readableState.flowing === false;
	};
	
	// backwards compatibility.
	Readable.prototype.setEncoding = function (enc) {
	  if (!StringDecoder) StringDecoder = __webpack_require__(661).StringDecoder;
	  this._readableState.decoder = new StringDecoder(enc);
	  this._readableState.encoding = enc;
	  return this;
	};
	
	// Don't raise the hwm > 8MB
	var MAX_HWM = 0x800000;
	function computeNewHighWaterMark(n) {
	  if (n >= MAX_HWM) {
	    n = MAX_HWM;
	  } else {
	    // Get the next highest power of 2 to prevent increasing hwm excessively in
	    // tiny amounts
	    n--;
	    n |= n >>> 1;
	    n |= n >>> 2;
	    n |= n >>> 4;
	    n |= n >>> 8;
	    n |= n >>> 16;
	    n++;
	  }
	  return n;
	}
	
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function howMuchToRead(n, state) {
	  if (n <= 0 || state.length === 0 && state.ended) return 0;
	  if (state.objectMode) return 1;
	  if (n !== n) {
	    // Only flow one buffer at a time
	    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
	  }
	  // If we're asking for more than the current hwm, then raise the hwm.
	  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
	  if (n <= state.length) return n;
	  // Don't have enough
	  if (!state.ended) {
	    state.needReadable = true;
	    return 0;
	  }
	  return state.length;
	}
	
	// you can override either this method, or the async _read(n) below.
	Readable.prototype.read = function (n) {
	  debug('read', n);
	  n = parseInt(n, 10);
	  var state = this._readableState;
	  var nOrig = n;
	
	  if (n !== 0) state.emittedReadable = false;
	
	  // if we're doing read(0) to trigger a readable event, but we
	  // already have a bunch of data in the buffer, then just trigger
	  // the 'readable' event and move on.
	  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
	    debug('read: emitReadable', state.length, state.ended);
	    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
	    return null;
	  }
	
	  n = howMuchToRead(n, state);
	
	  // if we've ended, and we're now clear, then finish it up.
	  if (n === 0 && state.ended) {
	    if (state.length === 0) endReadable(this);
	    return null;
	  }
	
	  // All the actual chunk generation logic needs to be
	  // *below* the call to _read.  The reason is that in certain
	  // synthetic stream cases, such as passthrough streams, _read
	  // may be a completely synchronous operation which may change
	  // the state of the read buffer, providing enough data when
	  // before there was *not* enough.
	  //
	  // So, the steps are:
	  // 1. Figure out what the state of things will be after we do
	  // a read from the buffer.
	  //
	  // 2. If that resulting state will trigger a _read, then call _read.
	  // Note that this may be asynchronous, or synchronous.  Yes, it is
	  // deeply ugly to write APIs this way, but that still doesn't mean
	  // that the Readable class should behave improperly, as streams are
	  // designed to be sync/async agnostic.
	  // Take note if the _read call is sync or async (ie, if the read call
	  // has returned yet), so that we know whether or not it's safe to emit
	  // 'readable' etc.
	  //
	  // 3. Actually pull the requested chunks out of the buffer and return.
	
	  // if we need a readable event, then we need to do some reading.
	  var doRead = state.needReadable;
	  debug('need readable', doRead);
	
	  // if we currently have less than the highWaterMark, then also read some
	  if (state.length === 0 || state.length - n < state.highWaterMark) {
	    doRead = true;
	    debug('length less than watermark', doRead);
	  }
	
	  // however, if we've ended, then there's no point, and if we're already
	  // reading, then it's unnecessary.
	  if (state.ended || state.reading) {
	    doRead = false;
	    debug('reading or ended', doRead);
	  } else if (doRead) {
	    debug('do read');
	    state.reading = true;
	    state.sync = true;
	    // if the length is currently zero, then we *need* a readable event.
	    if (state.length === 0) state.needReadable = true;
	    // call internal read method
	    this._read(state.highWaterMark);
	    state.sync = false;
	    // If _read pushed data synchronously, then `reading` will be false,
	    // and we need to re-evaluate how much data we can return to the user.
	    if (!state.reading) n = howMuchToRead(nOrig, state);
	  }
	
	  var ret;
	  if (n > 0) ret = fromList(n, state);else ret = null;
	
	  if (ret === null) {
	    state.needReadable = true;
	    n = 0;
	  } else {
	    state.length -= n;
	  }
	
	  if (state.length === 0) {
	    // If we have nothing in the buffer, then we want to know
	    // as soon as we *do* get something into the buffer.
	    if (!state.ended) state.needReadable = true;
	
	    // If we tried to read() past the EOF, then emit end on the next tick.
	    if (nOrig !== n && state.ended) endReadable(this);
	  }
	
	  if (ret !== null) this.emit('data', ret);
	
	  return ret;
	};
	
	function onEofChunk(stream, state) {
	  if (state.ended) return;
	  if (state.decoder) {
	    var chunk = state.decoder.end();
	    if (chunk && chunk.length) {
	      state.buffer.push(chunk);
	      state.length += state.objectMode ? 1 : chunk.length;
	    }
	  }
	  state.ended = true;
	
	  // emit 'readable' now to make sure it gets picked up.
	  emitReadable(stream);
	}
	
	// Don't emit readable right away in sync mode, because this can trigger
	// another read() call => stack overflow.  This way, it might trigger
	// a nextTick recursion warning, but that's not so bad.
	function emitReadable(stream) {
	  var state = stream._readableState;
	  state.needReadable = false;
	  if (!state.emittedReadable) {
	    debug('emitReadable', state.flowing);
	    state.emittedReadable = true;
	    if (state.sync) pna.nextTick(emitReadable_, stream);else emitReadable_(stream);
	  }
	}
	
	function emitReadable_(stream) {
	  debug('emit readable');
	  stream.emit('readable');
	  flow(stream);
	}
	
	// at this point, the user has presumably seen the 'readable' event,
	// and called read() to consume some data.  that may have triggered
	// in turn another _read(n) call, in which case reading = true if
	// it's in progress.
	// However, if we're not ended, or reading, and the length < hwm,
	// then go ahead and try to read some more preemptively.
	function maybeReadMore(stream, state) {
	  if (!state.readingMore) {
	    state.readingMore = true;
	    pna.nextTick(maybeReadMore_, stream, state);
	  }
	}
	
	function maybeReadMore_(stream, state) {
	  var len = state.length;
	  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
	    debug('maybeReadMore read 0');
	    stream.read(0);
	    if (len === state.length)
	      // didn't get any data, stop spinning.
	      break;else len = state.length;
	  }
	  state.readingMore = false;
	}
	
	// abstract method.  to be overridden in specific implementation classes.
	// call cb(er, data) where data is <= n in length.
	// for virtual (non-string, non-buffer) streams, "length" is somewhat
	// arbitrary, and perhaps not very meaningful.
	Readable.prototype._read = function (n) {
	  this.emit('error', new Error('_read() is not implemented'));
	};
	
	Readable.prototype.pipe = function (dest, pipeOpts) {
	  var src = this;
	  var state = this._readableState;
	
	  switch (state.pipesCount) {
	    case 0:
	      state.pipes = dest;
	      break;
	    case 1:
	      state.pipes = [state.pipes, dest];
	      break;
	    default:
	      state.pipes.push(dest);
	      break;
	  }
	  state.pipesCount += 1;
	  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
	
	  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;
	
	  var endFn = doEnd ? onend : unpipe;
	  if (state.endEmitted) pna.nextTick(endFn);else src.once('end', endFn);
	
	  dest.on('unpipe', onunpipe);
	  function onunpipe(readable, unpipeInfo) {
	    debug('onunpipe');
	    if (readable === src) {
	      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
	        unpipeInfo.hasUnpiped = true;
	        cleanup();
	      }
	    }
	  }
	
	  function onend() {
	    debug('onend');
	    dest.end();
	  }
	
	  // when the dest drains, it reduces the awaitDrain counter
	  // on the source.  This would be more elegant with a .once()
	  // handler in flow(), but adding and removing repeatedly is
	  // too slow.
	  var ondrain = pipeOnDrain(src);
	  dest.on('drain', ondrain);
	
	  var cleanedUp = false;
	  function cleanup() {
	    debug('cleanup');
	    // cleanup event handlers once the pipe is broken
	    dest.removeListener('close', onclose);
	    dest.removeListener('finish', onfinish);
	    dest.removeListener('drain', ondrain);
	    dest.removeListener('error', onerror);
	    dest.removeListener('unpipe', onunpipe);
	    src.removeListener('end', onend);
	    src.removeListener('end', unpipe);
	    src.removeListener('data', ondata);
	
	    cleanedUp = true;
	
	    // if the reader is waiting for a drain event from this
	    // specific writer, then it would cause it to never start
	    // flowing again.
	    // So, if this is awaiting a drain, then we just call it now.
	    // If we don't know, then assume that we are waiting for one.
	    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
	  }
	
	  // If the user pushes more data while we're writing to dest then we'll end up
	  // in ondata again. However, we only want to increase awaitDrain once because
	  // dest will only emit one 'drain' event for the multiple writes.
	  // => Introduce a guard on increasing awaitDrain.
	  var increasedAwaitDrain = false;
	  src.on('data', ondata);
	  function ondata(chunk) {
	    debug('ondata');
	    increasedAwaitDrain = false;
	    var ret = dest.write(chunk);
	    if (false === ret && !increasedAwaitDrain) {
	      // If the user unpiped during `dest.write()`, it is possible
	      // to get stuck in a permanently paused state if that write
	      // also returned false.
	      // => Check whether `dest` is still a piping destination.
	      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
	        debug('false write response, pause', state.awaitDrain);
	        state.awaitDrain++;
	        increasedAwaitDrain = true;
	      }
	      src.pause();
	    }
	  }
	
	  // if the dest has an error, then stop piping into it.
	  // however, don't suppress the throwing behavior for this.
	  function onerror(er) {
	    debug('onerror', er);
	    unpipe();
	    dest.removeListener('error', onerror);
	    if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
	  }
	
	  // Make sure our error handler is attached before userland ones.
	  prependListener(dest, 'error', onerror);
	
	  // Both close and finish should trigger unpipe, but only once.
	  function onclose() {
	    dest.removeListener('finish', onfinish);
	    unpipe();
	  }
	  dest.once('close', onclose);
	  function onfinish() {
	    debug('onfinish');
	    dest.removeListener('close', onclose);
	    unpipe();
	  }
	  dest.once('finish', onfinish);
	
	  function unpipe() {
	    debug('unpipe');
	    src.unpipe(dest);
	  }
	
	  // tell the dest that it's being piped to
	  dest.emit('pipe', src);
	
	  // start the flow if it hasn't been started already.
	  if (!state.flowing) {
	    debug('pipe resume');
	    src.resume();
	  }
	
	  return dest;
	};
	
	function pipeOnDrain(src) {
	  return function () {
	    var state = src._readableState;
	    debug('pipeOnDrain', state.awaitDrain);
	    if (state.awaitDrain) state.awaitDrain--;
	    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
	      state.flowing = true;
	      flow(src);
	    }
	  };
	}
	
	Readable.prototype.unpipe = function (dest) {
	  var state = this._readableState;
	  var unpipeInfo = { hasUnpiped: false };
	
	  // if we're not piping anywhere, then do nothing.
	  if (state.pipesCount === 0) return this;
	
	  // just one destination.  most common case.
	  if (state.pipesCount === 1) {
	    // passed in one, but it's not the right one.
	    if (dest && dest !== state.pipes) return this;
	
	    if (!dest) dest = state.pipes;
	
	    // got a match.
	    state.pipes = null;
	    state.pipesCount = 0;
	    state.flowing = false;
	    if (dest) dest.emit('unpipe', this, unpipeInfo);
	    return this;
	  }
	
	  // slow case. multiple pipe destinations.
	
	  if (!dest) {
	    // remove all.
	    var dests = state.pipes;
	    var len = state.pipesCount;
	    state.pipes = null;
	    state.pipesCount = 0;
	    state.flowing = false;
	
	    for (var i = 0; i < len; i++) {
	      dests[i].emit('unpipe', this, { hasUnpiped: false });
	    }return this;
	  }
	
	  // try to find the right one.
	  var index = indexOf(state.pipes, dest);
	  if (index === -1) return this;
	
	  state.pipes.splice(index, 1);
	  state.pipesCount -= 1;
	  if (state.pipesCount === 1) state.pipes = state.pipes[0];
	
	  dest.emit('unpipe', this, unpipeInfo);
	
	  return this;
	};
	
	// set up data events if they are asked for
	// Ensure readable listeners eventually get something
	Readable.prototype.on = function (ev, fn) {
	  var res = Stream.prototype.on.call(this, ev, fn);
	
	  if (ev === 'data') {
	    // Start flowing on next tick if stream isn't explicitly paused
	    if (this._readableState.flowing !== false) this.resume();
	  } else if (ev === 'readable') {
	    var state = this._readableState;
	    if (!state.endEmitted && !state.readableListening) {
	      state.readableListening = state.needReadable = true;
	      state.emittedReadable = false;
	      if (!state.reading) {
	        pna.nextTick(nReadingNextTick, this);
	      } else if (state.length) {
	        emitReadable(this);
	      }
	    }
	  }
	
	  return res;
	};
	Readable.prototype.addListener = Readable.prototype.on;
	
	function nReadingNextTick(self) {
	  debug('readable nexttick read 0');
	  self.read(0);
	}
	
	// pause() and resume() are remnants of the legacy readable stream API
	// If the user uses them, then switch into old mode.
	Readable.prototype.resume = function () {
	  var state = this._readableState;
	  if (!state.flowing) {
	    debug('resume');
	    state.flowing = true;
	    resume(this, state);
	  }
	  return this;
	};
	
	function resume(stream, state) {
	  if (!state.resumeScheduled) {
	    state.resumeScheduled = true;
	    pna.nextTick(resume_, stream, state);
	  }
	}
	
	function resume_(stream, state) {
	  if (!state.reading) {
	    debug('resume read 0');
	    stream.read(0);
	  }
	
	  state.resumeScheduled = false;
	  state.awaitDrain = 0;
	  stream.emit('resume');
	  flow(stream);
	  if (state.flowing && !state.reading) stream.read(0);
	}
	
	Readable.prototype.pause = function () {
	  debug('call pause flowing=%j', this._readableState.flowing);
	  if (false !== this._readableState.flowing) {
	    debug('pause');
	    this._readableState.flowing = false;
	    this.emit('pause');
	  }
	  return this;
	};
	
	function flow(stream) {
	  var state = stream._readableState;
	  debug('flow', state.flowing);
	  while (state.flowing && stream.read() !== null) {}
	}
	
	// wrap an old-style stream as the async data source.
	// This is *not* part of the readable stream interface.
	// It is an ugly unfortunate mess of history.
	Readable.prototype.wrap = function (stream) {
	  var _this = this;
	
	  var state = this._readableState;
	  var paused = false;
	
	  stream.on('end', function () {
	    debug('wrapped end');
	    if (state.decoder && !state.ended) {
	      var chunk = state.decoder.end();
	      if (chunk && chunk.length) _this.push(chunk);
	    }
	
	    _this.push(null);
	  });
	
	  stream.on('data', function (chunk) {
	    debug('wrapped data');
	    if (state.decoder) chunk = state.decoder.write(chunk);
	
	    // don't skip over falsy values in objectMode
	    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;
	
	    var ret = _this.push(chunk);
	    if (!ret) {
	      paused = true;
	      stream.pause();
	    }
	  });
	
	  // proxy all the other methods.
	  // important when wrapping filters and duplexes.
	  for (var i in stream) {
	    if (this[i] === undefined && typeof stream[i] === 'function') {
	      this[i] = function (method) {
	        return function () {
	          return stream[method].apply(stream, arguments);
	        };
	      }(i);
	    }
	  }
	
	  // proxy certain important events.
	  for (var n = 0; n < kProxyEvents.length; n++) {
	    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
	  }
	
	  // when we try to consume some more bytes, simply unpause the
	  // underlying stream.
	  this._read = function (n) {
	    debug('wrapped _read', n);
	    if (paused) {
	      paused = false;
	      stream.resume();
	    }
	  };
	
	  return this;
	};
	
	Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
	  // making it explicit this property is not enumerable
	  // because otherwise some prototype manipulation in
	  // userland will fail
	  enumerable: false,
	  get: function () {
	    return this._readableState.highWaterMark;
	  }
	});
	
	// exposed for testing purposes only.
	Readable._fromList = fromList;
	
	// Pluck off n bytes from an array of buffers.
	// Length is the combined lengths of all the buffers in the list.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function fromList(n, state) {
	  // nothing buffered
	  if (state.length === 0) return null;
	
	  var ret;
	  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
	    // read it all, truncate the list
	    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
	    state.buffer.clear();
	  } else {
	    // read part of list
	    ret = fromListPartial(n, state.buffer, state.decoder);
	  }
	
	  return ret;
	}
	
	// Extracts only enough buffered data to satisfy the amount requested.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function fromListPartial(n, list, hasStrings) {
	  var ret;
	  if (n < list.head.data.length) {
	    // slice is the same for buffers and strings
	    ret = list.head.data.slice(0, n);
	    list.head.data = list.head.data.slice(n);
	  } else if (n === list.head.data.length) {
	    // first chunk is a perfect match
	    ret = list.shift();
	  } else {
	    // result spans more than one buffer
	    ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
	  }
	  return ret;
	}
	
	// Copies a specified amount of characters from the list of buffered data
	// chunks.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function copyFromBufferString(n, list) {
	  var p = list.head;
	  var c = 1;
	  var ret = p.data;
	  n -= ret.length;
	  while (p = p.next) {
	    var str = p.data;
	    var nb = n > str.length ? str.length : n;
	    if (nb === str.length) ret += str;else ret += str.slice(0, n);
	    n -= nb;
	    if (n === 0) {
	      if (nb === str.length) {
	        ++c;
	        if (p.next) list.head = p.next;else list.head = list.tail = null;
	      } else {
	        list.head = p;
	        p.data = str.slice(nb);
	      }
	      break;
	    }
	    ++c;
	  }
	  list.length -= c;
	  return ret;
	}
	
	// Copies a specified amount of bytes from the list of buffered data chunks.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function copyFromBuffer(n, list) {
	  var ret = Buffer.allocUnsafe(n);
	  var p = list.head;
	  var c = 1;
	  p.data.copy(ret);
	  n -= p.data.length;
	  while (p = p.next) {
	    var buf = p.data;
	    var nb = n > buf.length ? buf.length : n;
	    buf.copy(ret, ret.length - n, 0, nb);
	    n -= nb;
	    if (n === 0) {
	      if (nb === buf.length) {
	        ++c;
	        if (p.next) list.head = p.next;else list.head = list.tail = null;
	      } else {
	        list.head = p;
	        p.data = buf.slice(nb);
	      }
	      break;
	    }
	    ++c;
	  }
	  list.length -= c;
	  return ret;
	}
	
	function endReadable(stream) {
	  var state = stream._readableState;
	
	  // If we get here before consuming all the bytes, then that is a
	  // bug in node.  Should never happen.
	  if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');
	
	  if (!state.endEmitted) {
	    state.ended = true;
	    pna.nextTick(endReadableNT, state, stream);
	  }
	}
	
	function endReadableNT(state, stream) {
	  // Check that we didn't get one last unshift.
	  if (!state.endEmitted && state.length === 0) {
	    state.endEmitted = true;
	    stream.readable = false;
	    stream.emit('end');
	  }
	}
	
	function indexOf(xs, x) {
	  for (var i = 0, l = xs.length; i < l; i++) {
	    if (xs[i] === x) return i;
	  }
	  return -1;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(111)))

/***/ },
/* 655 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a transform stream is a readable/writable stream where you do
	// something with the data.  Sometimes it's called a "filter",
	// but that's not a great name for it, since that implies a thing where
	// some bits pass through, and others are simply ignored.  (That would
	// be a valid example of a transform, of course.)
	//
	// While the output is causally related to the input, it's not a
	// necessarily symmetric or synchronous transformation.  For example,
	// a zlib stream might take multiple plain-text writes(), and then
	// emit a single compressed chunk some time in the future.
	//
	// Here's how this works:
	//
	// The Transform stream has all the aspects of the readable and writable
	// stream classes.  When you write(chunk), that calls _write(chunk,cb)
	// internally, and returns false if there's a lot of pending writes
	// buffered up.  When you call read(), that calls _read(n) until
	// there's enough pending readable data buffered up.
	//
	// In a transform stream, the written data is placed in a buffer.  When
	// _read(n) is called, it transforms the queued up data, calling the
	// buffered _write cb's as it consumes chunks.  If consuming a single
	// written chunk would result in multiple output chunks, then the first
	// outputted bit calls the readcb, and subsequent chunks just go into
	// the read buffer, and will cause it to emit 'readable' if necessary.
	//
	// This way, back-pressure is actually determined by the reading side,
	// since _read has to be called to start processing a new chunk.  However,
	// a pathological inflate type of transform can cause excessive buffering
	// here.  For example, imagine a stream where every byte of input is
	// interpreted as an integer from 0-255, and then results in that many
	// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
	// 1kb of data being output.  In this case, you could write a very small
	// amount of input, and end up with a very large amount of output.  In
	// such a pathological inflating mechanism, there'd be no way to tell
	// the system to stop doing the transform.  A single 4MB write could
	// cause the system to run out of memory.
	//
	// However, even in such a pathological case, only a single written chunk
	// would be consumed, and then the rest would wait (un-transformed) until
	// the results of the previous transformed chunk were consumed.
	
	'use strict';
	
	module.exports = Transform;
	
	var Duplex = __webpack_require__(116);
	
	/*<replacement>*/
	var util = Object.create(__webpack_require__(147));
	util.inherits = __webpack_require__(126);
	/*</replacement>*/
	
	util.inherits(Transform, Duplex);
	
	function afterTransform(er, data) {
	  var ts = this._transformState;
	  ts.transforming = false;
	
	  var cb = ts.writecb;
	
	  if (!cb) {
	    return this.emit('error', new Error('write callback called multiple times'));
	  }
	
	  ts.writechunk = null;
	  ts.writecb = null;
	
	  if (data != null) // single equals check for both `null` and `undefined`
	    this.push(data);
	
	  cb(er);
	
	  var rs = this._readableState;
	  rs.reading = false;
	  if (rs.needReadable || rs.length < rs.highWaterMark) {
	    this._read(rs.highWaterMark);
	  }
	}
	
	function Transform(options) {
	  if (!(this instanceof Transform)) return new Transform(options);
	
	  Duplex.call(this, options);
	
	  this._transformState = {
	    afterTransform: afterTransform.bind(this),
	    needTransform: false,
	    transforming: false,
	    writecb: null,
	    writechunk: null,
	    writeencoding: null
	  };
	
	  // start out asking for a readable event once data is transformed.
	  this._readableState.needReadable = true;
	
	  // we have implemented the _read method, and done the other things
	  // that Readable wants before the first _read call, so unset the
	  // sync guard flag.
	  this._readableState.sync = false;
	
	  if (options) {
	    if (typeof options.transform === 'function') this._transform = options.transform;
	
	    if (typeof options.flush === 'function') this._flush = options.flush;
	  }
	
	  // When the writable side finishes, then flush out anything remaining.
	  this.on('prefinish', prefinish);
	}
	
	function prefinish() {
	  var _this = this;
	
	  if (typeof this._flush === 'function') {
	    this._flush(function (er, data) {
	      done(_this, er, data);
	    });
	  } else {
	    done(this, null, null);
	  }
	}
	
	Transform.prototype.push = function (chunk, encoding) {
	  this._transformState.needTransform = false;
	  return Duplex.prototype.push.call(this, chunk, encoding);
	};
	
	// This is the part where you do stuff!
	// override this function in implementation classes.
	// 'chunk' is an input chunk.
	//
	// Call `push(newChunk)` to pass along transformed output
	// to the readable side.  You may call 'push' zero or more times.
	//
	// Call `cb(err)` when you are done with this chunk.  If you pass
	// an error, then that'll put the hurt on the whole operation.  If you
	// never call cb(), then you'll never get another chunk.
	Transform.prototype._transform = function (chunk, encoding, cb) {
	  throw new Error('_transform() is not implemented');
	};
	
	Transform.prototype._write = function (chunk, encoding, cb) {
	  var ts = this._transformState;
	  ts.writecb = cb;
	  ts.writechunk = chunk;
	  ts.writeencoding = encoding;
	  if (!ts.transforming) {
	    var rs = this._readableState;
	    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
	  }
	};
	
	// Doesn't matter what the args are here.
	// _transform does all the work.
	// That we got here means that the readable side wants more data.
	Transform.prototype._read = function (n) {
	  var ts = this._transformState;
	
	  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
	    ts.transforming = true;
	    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
	  } else {
	    // mark that we need a transform, so that any data that comes in
	    // will get processed, now that we've asked for it.
	    ts.needTransform = true;
	  }
	};
	
	Transform.prototype._destroy = function (err, cb) {
	  var _this2 = this;
	
	  Duplex.prototype._destroy.call(this, err, function (err2) {
	    cb(err2);
	    _this2.emit('close');
	  });
	};
	
	function done(stream, er, data) {
	  if (er) return stream.emit('error', er);
	
	  if (data != null) // single equals check for both `null` and `undefined`
	    stream.push(data);
	
	  // if there's nothing in the write buffer, then that means
	  // that nothing more will ever be provided
	  if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');
	
	  if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');
	
	  return stream.push(null);
	}

/***/ },
/* 656 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*<replacement>*/
	
	var pna = __webpack_require__(202);
	/*</replacement>*/
	
	// undocumented cb() API, needed for core, not for public API
	function destroy(err, cb) {
	  var _this = this;
	
	  var readableDestroyed = this._readableState && this._readableState.destroyed;
	  var writableDestroyed = this._writableState && this._writableState.destroyed;
	
	  if (readableDestroyed || writableDestroyed) {
	    if (cb) {
	      cb(err);
	    } else if (err) {
	      if (!this._writableState) {
	        pna.nextTick(emitErrorNT, this, err);
	      } else if (!this._writableState.errorEmitted) {
	        this._writableState.errorEmitted = true;
	        pna.nextTick(emitErrorNT, this, err);
	      }
	    }
	
	    return this;
	  }
	
	  // we set destroyed to true before firing error callbacks in order
	  // to make it re-entrance safe in case destroy() is called within callbacks
	
	  if (this._readableState) {
	    this._readableState.destroyed = true;
	  }
	
	  // if this is a duplex stream mark the writable part as destroyed as well
	  if (this._writableState) {
	    this._writableState.destroyed = true;
	  }
	
	  this._destroy(err || null, function (err) {
	    if (!cb && err) {
	      if (!_this._writableState) {
	        pna.nextTick(emitErrorNT, _this, err);
	      } else if (!_this._writableState.errorEmitted) {
	        _this._writableState.errorEmitted = true;
	        pna.nextTick(emitErrorNT, _this, err);
	      }
	    } else if (cb) {
	      cb(err);
	    }
	  });
	
	  return this;
	}
	
	function undestroy() {
	  if (this._readableState) {
	    this._readableState.destroyed = false;
	    this._readableState.reading = false;
	    this._readableState.ended = false;
	    this._readableState.endEmitted = false;
	  }
	
	  if (this._writableState) {
	    this._writableState.destroyed = false;
	    this._writableState.ended = false;
	    this._writableState.ending = false;
	    this._writableState.finalCalled = false;
	    this._writableState.prefinished = false;
	    this._writableState.finished = false;
	    this._writableState.errorEmitted = false;
	  }
	}
	
	function emitErrorNT(self, err) {
	  self.emit('error', err);
	}
	
	module.exports = {
	  destroy: destroy,
	  undestroy: undestroy
	};

/***/ },
/* 657 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(155).EventEmitter;


/***/ },
/* 658 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var setFunctionName = __webpack_require__(1618);
	var $TypeError = __webpack_require__(120);
	
	var $Object = Object;
	
	module.exports = setFunctionName(function flags() {
		if (this == null || this !== $Object(this)) {
			throw new $TypeError('RegExp.prototype.flags getter called on non-object');
		}
		var result = '';
		if (this.hasIndices) {
			result += 'd';
		}
		if (this.global) {
			result += 'g';
		}
		if (this.ignoreCase) {
			result += 'i';
		}
		if (this.multiline) {
			result += 'm';
		}
		if (this.dotAll) {
			result += 's';
		}
		if (this.unicode) {
			result += 'u';
		}
		if (this.unicodeSets) {
			result += 'v';
		}
		if (this.sticky) {
			result += 'y';
		}
		return result;
	}, 'get flags', true);
	


/***/ },
/* 659 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(658);
	
	var supportsDescriptors = __webpack_require__(150).supportsDescriptors;
	var $gOPD = Object.getOwnPropertyDescriptor;
	
	module.exports = function getPolyfill() {
		if (supportsDescriptors && (/a/mig).flags === 'gim') {
			var descriptor = $gOPD(RegExp.prototype, 'flags');
			if (
				descriptor
				&& typeof descriptor.get === 'function'
				&& 'dotAll' in RegExp.prototype
				&& 'hasIndices' in RegExp.prototype
			) {
				/* eslint getter-return: 0 */
				var calls = '';
				var o = {};
				Object.defineProperty(o, 'hasIndices', {
					get: function () {
						calls += 'd';
					}
				});
				Object.defineProperty(o, 'sticky', {
					get: function () {
						calls += 'y';
					}
				});
	
				descriptor.get.call(o);
	
				if (calls === 'dy') {
					return descriptor.get;
				}
			}
		}
		return implementation;
	};


/***/ },
/* 660 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.ResizeObserver = factory());
	}(this, (function () { 'use strict';
	
	    /**
	     * A collection of shims that provide minimal functionality of the ES6 collections.
	     *
	     * These implementations are not meant to be used outside of the ResizeObserver
	     * modules as they cover only a limited range of use cases.
	     */
	    /* eslint-disable require-jsdoc, valid-jsdoc */
	    var MapShim = (function () {
	        if (typeof Map !== 'undefined') {
	            return Map;
	        }
	        /**
	         * Returns index in provided array that matches the specified key.
	         *
	         * @param {Array<Array>} arr
	         * @param {*} key
	         * @returns {number}
	         */
	        function getIndex(arr, key) {
	            var result = -1;
	            arr.some(function (entry, index) {
	                if (entry[0] === key) {
	                    result = index;
	                    return true;
	                }
	                return false;
	            });
	            return result;
	        }
	        return /** @class */ (function () {
	            function class_1() {
	                this.__entries__ = [];
	            }
	            Object.defineProperty(class_1.prototype, "size", {
	                /**
	                 * @returns {boolean}
	                 */
	                get: function () {
	                    return this.__entries__.length;
	                },
	                enumerable: true,
	                configurable: true
	            });
	            /**
	             * @param {*} key
	             * @returns {*}
	             */
	            class_1.prototype.get = function (key) {
	                var index = getIndex(this.__entries__, key);
	                var entry = this.__entries__[index];
	                return entry && entry[1];
	            };
	            /**
	             * @param {*} key
	             * @param {*} value
	             * @returns {void}
	             */
	            class_1.prototype.set = function (key, value) {
	                var index = getIndex(this.__entries__, key);
	                if (~index) {
	                    this.__entries__[index][1] = value;
	                }
	                else {
	                    this.__entries__.push([key, value]);
	                }
	            };
	            /**
	             * @param {*} key
	             * @returns {void}
	             */
	            class_1.prototype.delete = function (key) {
	                var entries = this.__entries__;
	                var index = getIndex(entries, key);
	                if (~index) {
	                    entries.splice(index, 1);
	                }
	            };
	            /**
	             * @param {*} key
	             * @returns {void}
	             */
	            class_1.prototype.has = function (key) {
	                return !!~getIndex(this.__entries__, key);
	            };
	            /**
	             * @returns {void}
	             */
	            class_1.prototype.clear = function () {
	                this.__entries__.splice(0);
	            };
	            /**
	             * @param {Function} callback
	             * @param {*} [ctx=null]
	             * @returns {void}
	             */
	            class_1.prototype.forEach = function (callback, ctx) {
	                if (ctx === void 0) { ctx = null; }
	                for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
	                    var entry = _a[_i];
	                    callback.call(ctx, entry[1], entry[0]);
	                }
	            };
	            return class_1;
	        }());
	    })();
	
	    /**
	     * Detects whether window and document objects are available in current environment.
	     */
	    var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;
	
	    // Returns global object of a current environment.
	    var global$1 = (function () {
	        if (typeof global !== 'undefined' && global.Math === Math) {
	            return global;
	        }
	        if (typeof self !== 'undefined' && self.Math === Math) {
	            return self;
	        }
	        if (typeof window !== 'undefined' && window.Math === Math) {
	            return window;
	        }
	        // eslint-disable-next-line no-new-func
	        return Function('return this')();
	    })();
	
	    /**
	     * A shim for the requestAnimationFrame which falls back to the setTimeout if
	     * first one is not supported.
	     *
	     * @returns {number} Requests' identifier.
	     */
	    var requestAnimationFrame$1 = (function () {
	        if (typeof requestAnimationFrame === 'function') {
	            // It's required to use a bounded function because IE sometimes throws
	            // an "Invalid calling object" error if rAF is invoked without the global
	            // object on the left hand side.
	            return requestAnimationFrame.bind(global$1);
	        }
	        return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
	    })();
	
	    // Defines minimum timeout before adding a trailing call.
	    var trailingTimeout = 2;
	    /**
	     * Creates a wrapper function which ensures that provided callback will be
	     * invoked only once during the specified delay period.
	     *
	     * @param {Function} callback - Function to be invoked after the delay period.
	     * @param {number} delay - Delay after which to invoke callback.
	     * @returns {Function}
	     */
	    function throttle (callback, delay) {
	        var leadingCall = false, trailingCall = false, lastCallTime = 0;
	        /**
	         * Invokes the original callback function and schedules new invocation if
	         * the "proxy" was called during current request.
	         *
	         * @returns {void}
	         */
	        function resolvePending() {
	            if (leadingCall) {
	                leadingCall = false;
	                callback();
	            }
	            if (trailingCall) {
	                proxy();
	            }
	        }
	        /**
	         * Callback invoked after the specified delay. It will further postpone
	         * invocation of the original function delegating it to the
	         * requestAnimationFrame.
	         *
	         * @returns {void}
	         */
	        function timeoutCallback() {
	            requestAnimationFrame$1(resolvePending);
	        }
	        /**
	         * Schedules invocation of the original function.
	         *
	         * @returns {void}
	         */
	        function proxy() {
	            var timeStamp = Date.now();
	            if (leadingCall) {
	                // Reject immediately following calls.
	                if (timeStamp - lastCallTime < trailingTimeout) {
	                    return;
	                }
	                // Schedule new call to be in invoked when the pending one is resolved.
	                // This is important for "transitions" which never actually start
	                // immediately so there is a chance that we might miss one if change
	                // happens amids the pending invocation.
	                trailingCall = true;
	            }
	            else {
	                leadingCall = true;
	                trailingCall = false;
	                setTimeout(timeoutCallback, delay);
	            }
	            lastCallTime = timeStamp;
	        }
	        return proxy;
	    }
	
	    // Minimum delay before invoking the update of observers.
	    var REFRESH_DELAY = 20;
	    // A list of substrings of CSS properties used to find transition events that
	    // might affect dimensions of observed elements.
	    var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
	    // Check if MutationObserver is available.
	    var mutationObserverSupported = typeof MutationObserver !== 'undefined';
	    /**
	     * Singleton controller class which handles updates of ResizeObserver instances.
	     */
	    var ResizeObserverController = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserverController.
	         *
	         * @private
	         */
	        function ResizeObserverController() {
	            /**
	             * Indicates whether DOM listeners have been added.
	             *
	             * @private {boolean}
	             */
	            this.connected_ = false;
	            /**
	             * Tells that controller has subscribed for Mutation Events.
	             *
	             * @private {boolean}
	             */
	            this.mutationEventsAdded_ = false;
	            /**
	             * Keeps reference to the instance of MutationObserver.
	             *
	             * @private {MutationObserver}
	             */
	            this.mutationsObserver_ = null;
	            /**
	             * A list of connected observers.
	             *
	             * @private {Array<ResizeObserverSPI>}
	             */
	            this.observers_ = [];
	            this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
	            this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
	        }
	        /**
	         * Adds observer to observers list.
	         *
	         * @param {ResizeObserverSPI} observer - Observer to be added.
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.addObserver = function (observer) {
	            if (!~this.observers_.indexOf(observer)) {
	                this.observers_.push(observer);
	            }
	            // Add listeners if they haven't been added yet.
	            if (!this.connected_) {
	                this.connect_();
	            }
	        };
	        /**
	         * Removes observer from observers list.
	         *
	         * @param {ResizeObserverSPI} observer - Observer to be removed.
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.removeObserver = function (observer) {
	            var observers = this.observers_;
	            var index = observers.indexOf(observer);
	            // Remove observer if it's present in registry.
	            if (~index) {
	                observers.splice(index, 1);
	            }
	            // Remove listeners if controller has no connected observers.
	            if (!observers.length && this.connected_) {
	                this.disconnect_();
	            }
	        };
	        /**
	         * Invokes the update of observers. It will continue running updates insofar
	         * it detects changes.
	         *
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.refresh = function () {
	            var changesDetected = this.updateObservers_();
	            // Continue running updates if changes have been detected as there might
	            // be future ones caused by CSS transitions.
	            if (changesDetected) {
	                this.refresh();
	            }
	        };
	        /**
	         * Updates every observer from observers list and notifies them of queued
	         * entries.
	         *
	         * @private
	         * @returns {boolean} Returns "true" if any observer has detected changes in
	         *      dimensions of it's elements.
	         */
	        ResizeObserverController.prototype.updateObservers_ = function () {
	            // Collect observers that have active observations.
	            var activeObservers = this.observers_.filter(function (observer) {
	                return observer.gatherActive(), observer.hasActive();
	            });
	            // Deliver notifications in a separate cycle in order to avoid any
	            // collisions between observers, e.g. when multiple instances of
	            // ResizeObserver are tracking the same element and the callback of one
	            // of them changes content dimensions of the observed target. Sometimes
	            // this may result in notifications being blocked for the rest of observers.
	            activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
	            return activeObservers.length > 0;
	        };
	        /**
	         * Initializes DOM listeners.
	         *
	         * @private
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.connect_ = function () {
	            // Do nothing if running in a non-browser environment or if listeners
	            // have been already added.
	            if (!isBrowser || this.connected_) {
	                return;
	            }
	            // Subscription to the "Transitionend" event is used as a workaround for
	            // delayed transitions. This way it's possible to capture at least the
	            // final state of an element.
	            document.addEventListener('transitionend', this.onTransitionEnd_);
	            window.addEventListener('resize', this.refresh);
	            if (mutationObserverSupported) {
	                this.mutationsObserver_ = new MutationObserver(this.refresh);
	                this.mutationsObserver_.observe(document, {
	                    attributes: true,
	                    childList: true,
	                    characterData: true,
	                    subtree: true
	                });
	            }
	            else {
	                document.addEventListener('DOMSubtreeModified', this.refresh);
	                this.mutationEventsAdded_ = true;
	            }
	            this.connected_ = true;
	        };
	        /**
	         * Removes DOM listeners.
	         *
	         * @private
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.disconnect_ = function () {
	            // Do nothing if running in a non-browser environment or if listeners
	            // have been already removed.
	            if (!isBrowser || !this.connected_) {
	                return;
	            }
	            document.removeEventListener('transitionend', this.onTransitionEnd_);
	            window.removeEventListener('resize', this.refresh);
	            if (this.mutationsObserver_) {
	                this.mutationsObserver_.disconnect();
	            }
	            if (this.mutationEventsAdded_) {
	                document.removeEventListener('DOMSubtreeModified', this.refresh);
	            }
	            this.mutationsObserver_ = null;
	            this.mutationEventsAdded_ = false;
	            this.connected_ = false;
	        };
	        /**
	         * "Transitionend" event handler.
	         *
	         * @private
	         * @param {TransitionEvent} event
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
	            var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
	            // Detect whether transition may affect dimensions of an element.
	            var isReflowProperty = transitionKeys.some(function (key) {
	                return !!~propertyName.indexOf(key);
	            });
	            if (isReflowProperty) {
	                this.refresh();
	            }
	        };
	        /**
	         * Returns instance of the ResizeObserverController.
	         *
	         * @returns {ResizeObserverController}
	         */
	        ResizeObserverController.getInstance = function () {
	            if (!this.instance_) {
	                this.instance_ = new ResizeObserverController();
	            }
	            return this.instance_;
	        };
	        /**
	         * Holds reference to the controller's instance.
	         *
	         * @private {ResizeObserverController}
	         */
	        ResizeObserverController.instance_ = null;
	        return ResizeObserverController;
	    }());
	
	    /**
	     * Defines non-writable/enumerable properties of the provided target object.
	     *
	     * @param {Object} target - Object for which to define properties.
	     * @param {Object} props - Properties to be defined.
	     * @returns {Object} Target object.
	     */
	    var defineConfigurable = (function (target, props) {
	        for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
	            var key = _a[_i];
	            Object.defineProperty(target, key, {
	                value: props[key],
	                enumerable: false,
	                writable: false,
	                configurable: true
	            });
	        }
	        return target;
	    });
	
	    /**
	     * Returns the global object associated with provided element.
	     *
	     * @param {Object} target
	     * @returns {Object}
	     */
	    var getWindowOf = (function (target) {
	        // Assume that the element is an instance of Node, which means that it
	        // has the "ownerDocument" property from which we can retrieve a
	        // corresponding global object.
	        var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
	        // Return the local global object if it's not possible extract one from
	        // provided element.
	        return ownerGlobal || global$1;
	    });
	
	    // Placeholder of an empty content rectangle.
	    var emptyRect = createRectInit(0, 0, 0, 0);
	    /**
	     * Converts provided string to a number.
	     *
	     * @param {number|string} value
	     * @returns {number}
	     */
	    function toFloat(value) {
	        return parseFloat(value) || 0;
	    }
	    /**
	     * Extracts borders size from provided styles.
	     *
	     * @param {CSSStyleDeclaration} styles
	     * @param {...string} positions - Borders positions (top, right, ...)
	     * @returns {number}
	     */
	    function getBordersSize(styles) {
	        var positions = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            positions[_i - 1] = arguments[_i];
	        }
	        return positions.reduce(function (size, position) {
	            var value = styles['border-' + position + '-width'];
	            return size + toFloat(value);
	        }, 0);
	    }
	    /**
	     * Extracts paddings sizes from provided styles.
	     *
	     * @param {CSSStyleDeclaration} styles
	     * @returns {Object} Paddings box.
	     */
	    function getPaddings(styles) {
	        var positions = ['top', 'right', 'bottom', 'left'];
	        var paddings = {};
	        for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
	            var position = positions_1[_i];
	            var value = styles['padding-' + position];
	            paddings[position] = toFloat(value);
	        }
	        return paddings;
	    }
	    /**
	     * Calculates content rectangle of provided SVG element.
	     *
	     * @param {SVGGraphicsElement} target - Element content rectangle of which needs
	     *      to be calculated.
	     * @returns {DOMRectInit}
	     */
	    function getSVGContentRect(target) {
	        var bbox = target.getBBox();
	        return createRectInit(0, 0, bbox.width, bbox.height);
	    }
	    /**
	     * Calculates content rectangle of provided HTMLElement.
	     *
	     * @param {HTMLElement} target - Element for which to calculate the content rectangle.
	     * @returns {DOMRectInit}
	     */
	    function getHTMLElementContentRect(target) {
	        // Client width & height properties can't be
	        // used exclusively as they provide rounded values.
	        var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
	        // By this condition we can catch all non-replaced inline, hidden and
	        // detached elements. Though elements with width & height properties less
	        // than 0.5 will be discarded as well.
	        //
	        // Without it we would need to implement separate methods for each of
	        // those cases and it's not possible to perform a precise and performance
	        // effective test for hidden elements. E.g. even jQuery's ':visible' filter
	        // gives wrong results for elements with width & height less than 0.5.
	        if (!clientWidth && !clientHeight) {
	            return emptyRect;
	        }
	        var styles = getWindowOf(target).getComputedStyle(target);
	        var paddings = getPaddings(styles);
	        var horizPad = paddings.left + paddings.right;
	        var vertPad = paddings.top + paddings.bottom;
	        // Computed styles of width & height are being used because they are the
	        // only dimensions available to JS that contain non-rounded values. It could
	        // be possible to utilize the getBoundingClientRect if only it's data wasn't
	        // affected by CSS transformations let alone paddings, borders and scroll bars.
	        var width = toFloat(styles.width), height = toFloat(styles.height);
	        // Width & height include paddings and borders when the 'border-box' box
	        // model is applied (except for IE).
	        if (styles.boxSizing === 'border-box') {
	            // Following conditions are required to handle Internet Explorer which
	            // doesn't include paddings and borders to computed CSS dimensions.
	            //
	            // We can say that if CSS dimensions + paddings are equal to the "client"
	            // properties then it's either IE, and thus we don't need to subtract
	            // anything, or an element merely doesn't have paddings/borders styles.
	            if (Math.round(width + horizPad) !== clientWidth) {
	                width -= getBordersSize(styles, 'left', 'right') + horizPad;
	            }
	            if (Math.round(height + vertPad) !== clientHeight) {
	                height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
	            }
	        }
	        // Following steps can't be applied to the document's root element as its
	        // client[Width/Height] properties represent viewport area of the window.
	        // Besides, it's as well not necessary as the <html> itself neither has
	        // rendered scroll bars nor it can be clipped.
	        if (!isDocumentElement(target)) {
	            // In some browsers (only in Firefox, actually) CSS width & height
	            // include scroll bars size which can be removed at this step as scroll
	            // bars are the only difference between rounded dimensions + paddings
	            // and "client" properties, though that is not always true in Chrome.
	            var vertScrollbar = Math.round(width + horizPad) - clientWidth;
	            var horizScrollbar = Math.round(height + vertPad) - clientHeight;
	            // Chrome has a rather weird rounding of "client" properties.
	            // E.g. for an element with content width of 314.2px it sometimes gives
	            // the client width of 315px and for the width of 314.7px it may give
	            // 314px. And it doesn't happen all the time. So just ignore this delta
	            // as a non-relevant.
	            if (Math.abs(vertScrollbar) !== 1) {
	                width -= vertScrollbar;
	            }
	            if (Math.abs(horizScrollbar) !== 1) {
	                height -= horizScrollbar;
	            }
	        }
	        return createRectInit(paddings.left, paddings.top, width, height);
	    }
	    /**
	     * Checks whether provided element is an instance of the SVGGraphicsElement.
	     *
	     * @param {Element} target - Element to be checked.
	     * @returns {boolean}
	     */
	    var isSVGGraphicsElement = (function () {
	        // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
	        // interface.
	        if (typeof SVGGraphicsElement !== 'undefined') {
	            return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
	        }
	        // If it's so, then check that element is at least an instance of the
	        // SVGElement and that it has the "getBBox" method.
	        // eslint-disable-next-line no-extra-parens
	        return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
	            typeof target.getBBox === 'function'); };
	    })();
	    /**
	     * Checks whether provided element is a document element (<html>).
	     *
	     * @param {Element} target - Element to be checked.
	     * @returns {boolean}
	     */
	    function isDocumentElement(target) {
	        return target === getWindowOf(target).document.documentElement;
	    }
	    /**
	     * Calculates an appropriate content rectangle for provided html or svg element.
	     *
	     * @param {Element} target - Element content rectangle of which needs to be calculated.
	     * @returns {DOMRectInit}
	     */
	    function getContentRect(target) {
	        if (!isBrowser) {
	            return emptyRect;
	        }
	        if (isSVGGraphicsElement(target)) {
	            return getSVGContentRect(target);
	        }
	        return getHTMLElementContentRect(target);
	    }
	    /**
	     * Creates rectangle with an interface of the DOMRectReadOnly.
	     * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
	     *
	     * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
	     * @returns {DOMRectReadOnly}
	     */
	    function createReadOnlyRect(_a) {
	        var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
	        // If DOMRectReadOnly is available use it as a prototype for the rectangle.
	        var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
	        var rect = Object.create(Constr.prototype);
	        // Rectangle's properties are not writable and non-enumerable.
	        defineConfigurable(rect, {
	            x: x, y: y, width: width, height: height,
	            top: y,
	            right: x + width,
	            bottom: height + y,
	            left: x
	        });
	        return rect;
	    }
	    /**
	     * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
	     * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
	     *
	     * @param {number} x - X coordinate.
	     * @param {number} y - Y coordinate.
	     * @param {number} width - Rectangle's width.
	     * @param {number} height - Rectangle's height.
	     * @returns {DOMRectInit}
	     */
	    function createRectInit(x, y, width, height) {
	        return { x: x, y: y, width: width, height: height };
	    }
	
	    /**
	     * Class that is responsible for computations of the content rectangle of
	     * provided DOM element and for keeping track of it's changes.
	     */
	    var ResizeObservation = /** @class */ (function () {
	        /**
	         * Creates an instance of ResizeObservation.
	         *
	         * @param {Element} target - Element to be observed.
	         */
	        function ResizeObservation(target) {
	            /**
	             * Broadcasted width of content rectangle.
	             *
	             * @type {number}
	             */
	            this.broadcastWidth = 0;
	            /**
	             * Broadcasted height of content rectangle.
	             *
	             * @type {number}
	             */
	            this.broadcastHeight = 0;
	            /**
	             * Reference to the last observed content rectangle.
	             *
	             * @private {DOMRectInit}
	             */
	            this.contentRect_ = createRectInit(0, 0, 0, 0);
	            this.target = target;
	        }
	        /**
	         * Updates content rectangle and tells whether it's width or height properties
	         * have changed since the last broadcast.
	         *
	         * @returns {boolean}
	         */
	        ResizeObservation.prototype.isActive = function () {
	            var rect = getContentRect(this.target);
	            this.contentRect_ = rect;
	            return (rect.width !== this.broadcastWidth ||
	                rect.height !== this.broadcastHeight);
	        };
	        /**
	         * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
	         * from the corresponding properties of the last observed content rectangle.
	         *
	         * @returns {DOMRectInit} Last observed content rectangle.
	         */
	        ResizeObservation.prototype.broadcastRect = function () {
	            var rect = this.contentRect_;
	            this.broadcastWidth = rect.width;
	            this.broadcastHeight = rect.height;
	            return rect;
	        };
	        return ResizeObservation;
	    }());
	
	    var ResizeObserverEntry = /** @class */ (function () {
	        /**
	         * Creates an instance of ResizeObserverEntry.
	         *
	         * @param {Element} target - Element that is being observed.
	         * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
	         */
	        function ResizeObserverEntry(target, rectInit) {
	            var contentRect = createReadOnlyRect(rectInit);
	            // According to the specification following properties are not writable
	            // and are also not enumerable in the native implementation.
	            //
	            // Property accessors are not being used as they'd require to define a
	            // private WeakMap storage which may cause memory leaks in browsers that
	            // don't support this type of collections.
	            defineConfigurable(this, { target: target, contentRect: contentRect });
	        }
	        return ResizeObserverEntry;
	    }());
	
	    var ResizeObserverSPI = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserver.
	         *
	         * @param {ResizeObserverCallback} callback - Callback function that is invoked
	         *      when one of the observed elements changes it's content dimensions.
	         * @param {ResizeObserverController} controller - Controller instance which
	         *      is responsible for the updates of observer.
	         * @param {ResizeObserver} callbackCtx - Reference to the public
	         *      ResizeObserver instance which will be passed to callback function.
	         */
	        function ResizeObserverSPI(callback, controller, callbackCtx) {
	            /**
	             * Collection of resize observations that have detected changes in dimensions
	             * of elements.
	             *
	             * @private {Array<ResizeObservation>}
	             */
	            this.activeObservations_ = [];
	            /**
	             * Registry of the ResizeObservation instances.
	             *
	             * @private {Map<Element, ResizeObservation>}
	             */
	            this.observations_ = new MapShim();
	            if (typeof callback !== 'function') {
	                throw new TypeError('The callback provided as parameter 1 is not a function.');
	            }
	            this.callback_ = callback;
	            this.controller_ = controller;
	            this.callbackCtx_ = callbackCtx;
	        }
	        /**
	         * Starts observing provided element.
	         *
	         * @param {Element} target - Element to be observed.
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.observe = function (target) {
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            // Do nothing if current environment doesn't have the Element interface.
	            if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	                return;
	            }
	            if (!(target instanceof getWindowOf(target).Element)) {
	                throw new TypeError('parameter 1 is not of type "Element".');
	            }
	            var observations = this.observations_;
	            // Do nothing if element is already being observed.
	            if (observations.has(target)) {
	                return;
	            }
	            observations.set(target, new ResizeObservation(target));
	            this.controller_.addObserver(this);
	            // Force the update of observations.
	            this.controller_.refresh();
	        };
	        /**
	         * Stops observing provided element.
	         *
	         * @param {Element} target - Element to stop observing.
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.unobserve = function (target) {
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            // Do nothing if current environment doesn't have the Element interface.
	            if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	                return;
	            }
	            if (!(target instanceof getWindowOf(target).Element)) {
	                throw new TypeError('parameter 1 is not of type "Element".');
	            }
	            var observations = this.observations_;
	            // Do nothing if element is not being observed.
	            if (!observations.has(target)) {
	                return;
	            }
	            observations.delete(target);
	            if (!observations.size) {
	                this.controller_.removeObserver(this);
	            }
	        };
	        /**
	         * Stops observing all elements.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.disconnect = function () {
	            this.clearActive();
	            this.observations_.clear();
	            this.controller_.removeObserver(this);
	        };
	        /**
	         * Collects observation instances the associated element of which has changed
	         * it's content rectangle.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.gatherActive = function () {
	            var _this = this;
	            this.clearActive();
	            this.observations_.forEach(function (observation) {
	                if (observation.isActive()) {
	                    _this.activeObservations_.push(observation);
	                }
	            });
	        };
	        /**
	         * Invokes initial callback function with a list of ResizeObserverEntry
	         * instances collected from active resize observations.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.broadcastActive = function () {
	            // Do nothing if observer doesn't have active observations.
	            if (!this.hasActive()) {
	                return;
	            }
	            var ctx = this.callbackCtx_;
	            // Create ResizeObserverEntry instance for every active observation.
	            var entries = this.activeObservations_.map(function (observation) {
	                return new ResizeObserverEntry(observation.target, observation.broadcastRect());
	            });
	            this.callback_.call(ctx, entries, ctx);
	            this.clearActive();
	        };
	        /**
	         * Clears the collection of active observations.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.clearActive = function () {
	            this.activeObservations_.splice(0);
	        };
	        /**
	         * Tells whether observer has active observations.
	         *
	         * @returns {boolean}
	         */
	        ResizeObserverSPI.prototype.hasActive = function () {
	            return this.activeObservations_.length > 0;
	        };
	        return ResizeObserverSPI;
	    }());
	
	    // Registry of internal observers. If WeakMap is not available use current shim
	    // for the Map collection as it has all required methods and because WeakMap
	    // can't be fully polyfilled anyway.
	    var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
	    /**
	     * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
	     * exposing only those methods and properties that are defined in the spec.
	     */
	    var ResizeObserver = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserver.
	         *
	         * @param {ResizeObserverCallback} callback - Callback that is invoked when
	         *      dimensions of the observed elements change.
	         */
	        function ResizeObserver(callback) {
	            if (!(this instanceof ResizeObserver)) {
	                throw new TypeError('Cannot call a class as a function.');
	            }
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            var controller = ResizeObserverController.getInstance();
	            var observer = new ResizeObserverSPI(callback, controller, this);
	            observers.set(this, observer);
	        }
	        return ResizeObserver;
	    }());
	    // Expose public methods of ResizeObserver.
	    [
	        'observe',
	        'unobserve',
	        'disconnect'
	    ].forEach(function (method) {
	        ResizeObserver.prototype[method] = function () {
	            var _a;
	            return (_a = observers.get(this))[method].apply(_a, arguments);
	        };
	    });
	
	    var index = (function () {
	        // Export existing implementation if available.
	        if (typeof global$1.ResizeObserver !== 'undefined') {
	            return global$1.ResizeObserver;
	        }
	        return ResizeObserver;
	    })();
	
	    return index;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 661 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	/*<replacement>*/
	
	var Buffer = __webpack_require__(213).Buffer;
	/*</replacement>*/
	
	var isEncoding = Buffer.isEncoding || function (encoding) {
	  encoding = '' + encoding;
	  switch (encoding && encoding.toLowerCase()) {
	    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
	      return true;
	    default:
	      return false;
	  }
	};
	
	function _normalizeEncoding(enc) {
	  if (!enc) return 'utf8';
	  var retried;
	  while (true) {
	    switch (enc) {
	      case 'utf8':
	      case 'utf-8':
	        return 'utf8';
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return 'utf16le';
	      case 'latin1':
	      case 'binary':
	        return 'latin1';
	      case 'base64':
	      case 'ascii':
	      case 'hex':
	        return enc;
	      default:
	        if (retried) return; // undefined
	        enc = ('' + enc).toLowerCase();
	        retried = true;
	    }
	  }
	};
	
	// Do not cache `Buffer.isEncoding` when checking encoding names as some
	// modules monkey-patch it to support additional encodings
	function normalizeEncoding(enc) {
	  var nenc = _normalizeEncoding(enc);
	  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
	  return nenc || enc;
	}
	
	// StringDecoder provides an interface for efficiently splitting a series of
	// buffers into a series of JS strings without breaking apart multi-byte
	// characters.
	exports.StringDecoder = StringDecoder;
	function StringDecoder(encoding) {
	  this.encoding = normalizeEncoding(encoding);
	  var nb;
	  switch (this.encoding) {
	    case 'utf16le':
	      this.text = utf16Text;
	      this.end = utf16End;
	      nb = 4;
	      break;
	    case 'utf8':
	      this.fillLast = utf8FillLast;
	      nb = 4;
	      break;
	    case 'base64':
	      this.text = base64Text;
	      this.end = base64End;
	      nb = 3;
	      break;
	    default:
	      this.write = simpleWrite;
	      this.end = simpleEnd;
	      return;
	  }
	  this.lastNeed = 0;
	  this.lastTotal = 0;
	  this.lastChar = Buffer.allocUnsafe(nb);
	}
	
	StringDecoder.prototype.write = function (buf) {
	  if (buf.length === 0) return '';
	  var r;
	  var i;
	  if (this.lastNeed) {
	    r = this.fillLast(buf);
	    if (r === undefined) return '';
	    i = this.lastNeed;
	    this.lastNeed = 0;
	  } else {
	    i = 0;
	  }
	  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
	  return r || '';
	};
	
	StringDecoder.prototype.end = utf8End;
	
	// Returns only complete characters in a Buffer
	StringDecoder.prototype.text = utf8Text;
	
	// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
	StringDecoder.prototype.fillLast = function (buf) {
	  if (this.lastNeed <= buf.length) {
	    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
	    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
	  }
	  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
	  this.lastNeed -= buf.length;
	};
	
	// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
	// continuation byte. If an invalid byte is detected, -2 is returned.
	function utf8CheckByte(byte) {
	  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
	  return byte >> 6 === 0x02 ? -1 : -2;
	}
	
	// Checks at most 3 bytes at the end of a Buffer in order to detect an
	// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
	// needed to complete the UTF-8 character (if applicable) are returned.
	function utf8CheckIncomplete(self, buf, i) {
	  var j = buf.length - 1;
	  if (j < i) return 0;
	  var nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) self.lastNeed = nb - 1;
	    return nb;
	  }
	  if (--j < i || nb === -2) return 0;
	  nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) self.lastNeed = nb - 2;
	    return nb;
	  }
	  if (--j < i || nb === -2) return 0;
	  nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) {
	      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
	    }
	    return nb;
	  }
	  return 0;
	}
	
	// Validates as many continuation bytes for a multi-byte UTF-8 character as
	// needed or are available. If we see a non-continuation byte where we expect
	// one, we "replace" the validated continuation bytes we've seen so far with
	// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
	// behavior. The continuation byte check is included three times in the case
	// where all of the continuation bytes for a character exist in the same buffer.
	// It is also done this way as a slight performance increase instead of using a
	// loop.
	function utf8CheckExtraBytes(self, buf, p) {
	  if ((buf[0] & 0xC0) !== 0x80) {
	    self.lastNeed = 0;
	    return '\ufffd';
	  }
	  if (self.lastNeed > 1 && buf.length > 1) {
	    if ((buf[1] & 0xC0) !== 0x80) {
	      self.lastNeed = 1;
	      return '\ufffd';
	    }
	    if (self.lastNeed > 2 && buf.length > 2) {
	      if ((buf[2] & 0xC0) !== 0x80) {
	        self.lastNeed = 2;
	        return '\ufffd';
	      }
	    }
	  }
	}
	
	// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
	function utf8FillLast(buf) {
	  var p = this.lastTotal - this.lastNeed;
	  var r = utf8CheckExtraBytes(this, buf, p);
	  if (r !== undefined) return r;
	  if (this.lastNeed <= buf.length) {
	    buf.copy(this.lastChar, p, 0, this.lastNeed);
	    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
	  }
	  buf.copy(this.lastChar, p, 0, buf.length);
	  this.lastNeed -= buf.length;
	}
	
	// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
	// partial character, the character's bytes are buffered until the required
	// number of bytes are available.
	function utf8Text(buf, i) {
	  var total = utf8CheckIncomplete(this, buf, i);
	  if (!this.lastNeed) return buf.toString('utf8', i);
	  this.lastTotal = total;
	  var end = buf.length - (total - this.lastNeed);
	  buf.copy(this.lastChar, 0, end);
	  return buf.toString('utf8', i, end);
	}
	
	// For UTF-8, a replacement character is added when ending on a partial
	// character.
	function utf8End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) return r + '\ufffd';
	  return r;
	}
	
	// UTF-16LE typically needs two bytes per character, but even if we have an even
	// number of bytes available, we need to check if we end on a leading/high
	// surrogate. In that case, we need to wait for the next two bytes in order to
	// decode the last character properly.
	function utf16Text(buf, i) {
	  if ((buf.length - i) % 2 === 0) {
	    var r = buf.toString('utf16le', i);
	    if (r) {
	      var c = r.charCodeAt(r.length - 1);
	      if (c >= 0xD800 && c <= 0xDBFF) {
	        this.lastNeed = 2;
	        this.lastTotal = 4;
	        this.lastChar[0] = buf[buf.length - 2];
	        this.lastChar[1] = buf[buf.length - 1];
	        return r.slice(0, -1);
	      }
	    }
	    return r;
	  }
	  this.lastNeed = 1;
	  this.lastTotal = 2;
	  this.lastChar[0] = buf[buf.length - 1];
	  return buf.toString('utf16le', i, buf.length - 1);
	}
	
	// For UTF-16LE we do not explicitly append special replacement characters if we
	// end on a partial character, we simply let v8 handle that.
	function utf16End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) {
	    var end = this.lastTotal - this.lastNeed;
	    return r + this.lastChar.toString('utf16le', 0, end);
	  }
	  return r;
	}
	
	function base64Text(buf, i) {
	  var n = (buf.length - i) % 3;
	  if (n === 0) return buf.toString('base64', i);
	  this.lastNeed = 3 - n;
	  this.lastTotal = 3;
	  if (n === 1) {
	    this.lastChar[0] = buf[buf.length - 1];
	  } else {
	    this.lastChar[0] = buf[buf.length - 2];
	    this.lastChar[1] = buf[buf.length - 1];
	  }
	  return buf.toString('base64', i, buf.length - n);
	}
	
	function base64End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
	  return r;
	}
	
	// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
	function simpleWrite(buf) {
	  return buf.toString(this.encoding);
	}
	
	function simpleEnd(buf) {
	  return buf && buf.length ? this.write(buf) : '';
	}

/***/ },
/* 662 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/bannerbg.fa70babc.png";

/***/ },
/* 663 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/bannerbgindividual.79269026.png";

/***/ },
/* 664 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = rng;
	// Unique ID creation requires a high quality random # generator. In the browser we therefore
	// require the crypto API and do not support built-in fallback to lower quality random number
	// generators (like Math.random()).
	// getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
	// find the complete implementation of crypto (msCrypto) on IE11.
	var getRandomValues = typeof crypto != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != 'undefined' && typeof msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto);
	var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
	
	function rng() {
	  if (!getRandomValues) {
	    throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
	  }
	
	  return getRandomValues(rnds8);
	}
	
	module.exports = exports.default;

/***/ },
/* 665 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = _default;
	exports.URL = exports.DNS = void 0;
	
	var _bytesToUuid = _interopRequireDefault(__webpack_require__(311));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function uuidToBytes(uuid) {
	  // Note: We assume we're being passed a valid uuid string
	  var bytes = [];
	  uuid.replace(/[a-fA-F0-9]{2}/g, function (hex) {
	    bytes.push(parseInt(hex, 16));
	  });
	  return bytes;
	}
	
	function stringToBytes(str) {
	  str = unescape(encodeURIComponent(str)); // UTF8 escape
	
	  var bytes = new Array(str.length);
	
	  for (var i = 0; i < str.length; i++) {
	    bytes[i] = str.charCodeAt(i);
	  }
	
	  return bytes;
	}
	
	const DNS = '6ba7b810-9dad-11d1-80b4-00c04fd430c8';
	exports.DNS = DNS;
	const URL = '6ba7b811-9dad-11d1-80b4-00c04fd430c8';
	exports.URL = URL;
	
	function _default(name, version, hashfunc) {
	  var generateUUID = function (value, namespace, buf, offset) {
	    var off = buf && offset || 0;
	    if (typeof value == 'string') value = stringToBytes(value);
	    if (typeof namespace == 'string') namespace = uuidToBytes(namespace);
	    if (!Array.isArray(value)) throw TypeError('value must be an array of bytes');
	    if (!Array.isArray(namespace) || namespace.length !== 16) throw TypeError('namespace must be uuid string or an Array of 16 byte values'); // Per 4.3
	
	    var bytes = hashfunc(namespace.concat(value));
	    bytes[6] = bytes[6] & 0x0f | version;
	    bytes[8] = bytes[8] & 0x3f | 0x80;
	
	    if (buf) {
	      for (var idx = 0; idx < 16; ++idx) {
	        buf[off + idx] = bytes[idx];
	      }
	    }
	
	    return buf || (0, _bytesToUuid.default)(bytes);
	  }; // Function#name is not settable on some platforms (#270)
	
	
	  try {
	    generateUUID.name = name;
	  } catch (err) {} // For CommonJS default export support
	
	
	  generateUUID.DNS = DNS;
	  generateUUID.URL = URL;
	  return generateUUID;
	}

/***/ },
/* 666 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(19));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(40));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(39));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(12));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(22));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var propTypes = {
	  manager: _propTypes["default"].object,
	  className: _propTypes["default"].string
	};
	
	var Bezel =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(Bezel, _Component);
	
	  function Bezel(props, context) {
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, Bezel);
	    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Bezel).call(this, props, context));
	    _this.timer = null;
	    props.manager.subscribeToOperationStateChange(_this.handleStateChange.bind((0, _assertThisInitialized2["default"])(_this)));
	    _this.state = {
	      hidden: true,
	      operation: {}
	    };
	    return _this;
	  }
	
	  (0, _createClass2["default"])(Bezel, [{
	    key: "handleStateChange",
	    value: function handleStateChange(state, prevState) {
	      var _this2 = this;
	
	      if (state.count !== prevState.count && state.operation.source === 'shortcut') {
	        if (this.timer) {
	          // previous animation is not finished
	          clearTimeout(this.timer); // cancel it
	
	          this.timer = null;
	        } // show it
	        // update operation
	
	
	        this.setState({
	          hidden: false,
	          count: state.count,
	          operation: state.operation
	        }); // hide it after 0.5s
	
	        this.timer = setTimeout(function () {
	          _this2.setState({
	            hidden: true
	          });
	
	          _this2.timer = null;
	        }, 500);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      // only displays for shortcut so far
	      if (this.state.operation.source !== 'shortcut') {
	        return null;
	      }
	
	      var style = this.state.hidden ? {
	        display: 'none'
	      } : null;
	      return _react["default"].createElement("div", {
	        className: (0, _classnames["default"])({
	          'video-react-bezel': true,
	          'video-react-bezel-animation': this.state.count % 2 === 0,
	          'video-react-bezel-animation-alt': this.state.count % 2 === 1
	        }, this.props.className),
	        style: style,
	        role: "status",
	        "aria-label": this.state.operation.action
	      }, _react["default"].createElement("div", {
	        className: (0, _classnames["default"])('video-react-bezel-icon', "video-react-bezel-icon-".concat(this.state.operation.action))
	      }));
	    }
	  }]);
	  return Bezel;
	}(_react.Component);
	
	exports["default"] = Bezel;
	Bezel.propTypes = propTypes;
	Bezel.displayName = 'Bezel';

/***/ },
/* 667 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(19));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(40));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(39));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(12));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(22));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var propTypes = {
	  actions: _propTypes["default"].object,
	  player: _propTypes["default"].object,
	  position: _propTypes["default"].string,
	  className: _propTypes["default"].string
	};
	var defaultProps = {
	  position: 'left'
	};
	
	var BigPlayButton =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(BigPlayButton, _Component);
	
	  function BigPlayButton(props, context) {
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, BigPlayButton);
	    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(BigPlayButton).call(this, props, context));
	    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
	    return _this;
	  }
	
	  (0, _createClass2["default"])(BigPlayButton, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {}
	  }, {
	    key: "handleClick",
	    value: function handleClick() {
	      var actions = this.props.actions;
	      actions.play();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          player = _this$props.player,
	          position = _this$props.position;
	      return _react["default"].createElement("button", {
	        className: (0, _classnames["default"])('video-react-button', 'video-react-big-play-button', "video-react-big-play-button-".concat(position), this.props.className, {
	          'big-play-button-hide': player.hasStarted || !player.currentSrc
	        }),
	        type: "button",
	        "aria-live": "polite",
	        tabIndex: "0",
	        onClick: this.handleClick
	      }, _react["default"].createElement("span", {
	        className: "video-react-control-text"
	      }, "Play Video"));
	    }
	  }]);
	  return BigPlayButton;
	}(_react.Component);
	
	exports["default"] = BigPlayButton;
	BigPlayButton.propTypes = propTypes;
	BigPlayButton.defaultProps = defaultProps;
	BigPlayButton.displayName = 'BigPlayButton';

/***/ },
/* 668 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(47));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(19));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(40));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(39));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(12));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(22));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var propTypes = {
	  tagName: _propTypes["default"].string,
	  onClick: _propTypes["default"].func.isRequired,
	  onFocus: _propTypes["default"].func,
	  onBlur: _propTypes["default"].func,
	  className: _propTypes["default"].string
	};
	var defaultProps = {
	  tagName: 'div'
	};
	
	var ClickableComponent =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(ClickableComponent, _Component);
	
	  function ClickableComponent(props, context) {
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, ClickableComponent);
	    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(ClickableComponent).call(this, props, context));
	    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleFocus = _this.handleFocus.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleBlur = _this.handleBlur.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleKeypress = _this.handleKeypress.bind((0, _assertThisInitialized2["default"])(_this));
	    return _this;
	  }
	
	  (0, _createClass2["default"])(ClickableComponent, [{
	    key: "componentWillUnmount",
	    value: function componentWillUnmount(e) {
	      this.handleBlur(e);
	    }
	  }, {
	    key: "handleKeypress",
	    value: function handleKeypress(event) {
	      // Support Space (32) or Enter (13) key operation to fire a click event
	      if (event.which === 32 || event.which === 13) {
	        event.preventDefault();
	        this.handleClick(event);
	      }
	    }
	  }, {
	    key: "handleClick",
	    value: function handleClick(event) {
	      var onClick = this.props.onClick;
	      onClick(event);
	    }
	  }, {
	    key: "handleFocus",
	    value: function handleFocus(e) {
	      document.addEventListener('keydown', this.handleKeypress);
	
	      if (this.props.onFocus) {
	        this.props.onFocus(e);
	      }
	    }
	  }, {
	    key: "handleBlur",
	    value: function handleBlur(e) {
	      document.removeEventListener('keydown', this.handleKeypress);
	
	      if (this.props.onBlur) {
	        this.props.onBlur(e);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var Tag = this.props.tagName;
	      var props = (0, _objectSpread2["default"])({}, this.props);
	      delete props.tagName;
	      delete props.className;
	      return _react["default"].createElement(Tag, (0, _extends2["default"])({
	        className: (0, _classnames["default"])(this.props.className),
	        role: "button",
	        tabIndex: "0",
	        onClick: this.handleClick,
	        onFocus: this.handleFocus,
	        onBlur: this.handleBlur
	      }, props));
	    }
	  }]);
	  return ClickableComponent;
	}(_react.Component);
	
	exports["default"] = ClickableComponent;
	ClickableComponent.propTypes = propTypes;
	ClickableComponent.defaultProps = defaultProps;
	ClickableComponent.displayName = 'ClickableComponent';

/***/ },
/* 669 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = LoadingSpinner;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var propTypes = {
	  player: _propTypes["default"].object,
	  className: _propTypes["default"].string
	};
	
	function LoadingSpinner(_ref) {
	  var player = _ref.player,
	      className = _ref.className;
	
	  if (player.error) {
	    return null;
	  }
	
	  return _react["default"].createElement("div", {
	    className: (0, _classnames["default"])('video-react-loading-spinner', className)
	  });
	}
	
	LoadingSpinner.propTypes = propTypes;
	LoadingSpinner.displayName = 'LoadingSpinner';

/***/ },
/* 670 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var propTypes = {
	  poster: _propTypes["default"].string,
	  player: _propTypes["default"].object,
	  actions: _propTypes["default"].object,
	  className: _propTypes["default"].string
	};
	
	function PosterImage(_ref) {
	  var poster = _ref.poster,
	      player = _ref.player,
	      actions = _ref.actions,
	      className = _ref.className;
	
	  if (!poster || player.hasStarted) {
	    return null;
	  }
	
	  return _react["default"].createElement("div", {
	    className: (0, _classnames["default"])('video-react-poster', className),
	    style: {
	      backgroundImage: "url(\"".concat(poster, "\")")
	    },
	    onClick: function onClick() {
	      if (player.paused) {
	        actions.play();
	      }
	    }
	  });
	}
	
	PosterImage.propTypes = propTypes;
	PosterImage.displayName = 'PosterImage';
	var _default = PosterImage;
	exports["default"] = _default;

/***/ },
/* 671 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(24));
	
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(103));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(19));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(40));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(39));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(12));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(22));
	
	var _react = __webpack_require__(1);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _dom = __webpack_require__(227);
	
	var propTypes = {
	  clickable: _propTypes["default"].bool,
	  dblclickable: _propTypes["default"].bool,
	  manager: _propTypes["default"].object,
	  actions: _propTypes["default"].object,
	  player: _propTypes["default"].object,
	  shortcuts: _propTypes["default"].array
	};
	var defaultProps = {
	  clickable: true,
	  dblclickable: true
	};
	
	var Shortcut =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(Shortcut, _Component);
	
	  function Shortcut(props, context) {
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, Shortcut);
	    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Shortcut).call(this, props, context));
	    _this.defaultShortcuts = [{
	      keyCode: 32,
	      // spacebar
	      handle: _this.togglePlay
	    }, {
	      keyCode: 75,
	      // k
	      handle: _this.togglePlay
	    }, {
	      keyCode: 70,
	      // f
	      handle: _this.toggleFullscreen
	    }, {
	      keyCode: 37,
	      // Left arrow
	      handle: function handle(player, actions) {
	        if (!player.hasStarted) {
	          return;
	        }
	
	        actions.replay(5, {
	          action: 'replay-5',
	          source: 'shortcut'
	        }); // Go back 5 seconds
	      }
	    }, {
	      keyCode: 74,
	      // j
	      handle: function handle(player, actions) {
	        if (!player.hasStarted) {
	          return;
	        }
	
	        actions.replay(10, {
	          action: 'replay-10',
	          source: 'shortcut'
	        }); // Go back 10 seconds
	      }
	    }, {
	      keyCode: 39,
	      // Right arrow
	      handle: function handle(player, actions) {
	        if (!player.hasStarted) {
	          return;
	        }
	
	        actions.forward(5, {
	          action: 'forward-5',
	          source: 'shortcut'
	        }); // Go forward 5 seconds
	      }
	    }, {
	      keyCode: 76,
	      // l
	      handle: function handle(player, actions) {
	        if (!player.hasStarted) {
	          return;
	        }
	
	        actions.forward(10, {
	          action: 'forward-10',
	          source: 'shortcut'
	        }); // Go forward 10 seconds
	      }
	    }, {
	      keyCode: 36,
	      // Home
	      handle: function handle(player, actions) {
	        if (!player.hasStarted) {
	          return;
	        }
	
	        actions.seek(0); // Go to beginning of video
	      }
	    }, {
	      keyCode: 35,
	      // End
	      handle: function handle(player, actions) {
	        if (!player.hasStarted) {
	          return;
	        } // Go to end of video
	
	
	        actions.seek(player.duration);
	      }
	    }, {
	      keyCode: 38,
	      // Up arrow
	      handle: function handle(player, actions) {
	        // Increase volume 5%
	        var v = player.volume + 0.05;
	
	        if (v > 1) {
	          v = 1;
	        }
	
	        actions.changeVolume(v, {
	          action: 'volume-up',
	          source: 'shortcut'
	        });
	      }
	    }, {
	      keyCode: 40,
	      // Down arrow
	      handle: function handle(player, actions) {
	        // Decrease volume 5%
	        var v = player.volume - 0.05;
	
	        if (v < 0) {
	          v = 0;
	        }
	
	        var action = v > 0 ? 'volume-down' : 'volume-off';
	        actions.changeVolume(v, {
	          action: action,
	          source: 'shortcut'
	        });
	      }
	    }, {
	      keyCode: 190,
	      // Shift + >
	      shift: true,
	      handle: function handle(player, actions) {
	        // Increase speed
	        var playbackRate = player.playbackRate;
	
	        if (playbackRate >= 1.5) {
	          playbackRate = 2;
	        } else if (playbackRate >= 1.25) {
	          playbackRate = 1.5;
	        } else if (playbackRate >= 1.0) {
	          playbackRate = 1.25;
	        } else if (playbackRate >= 0.5) {
	          playbackRate = 1.0;
	        } else if (playbackRate >= 0.25) {
	          playbackRate = 0.5;
	        } else if (playbackRate >= 0) {
	          playbackRate = 0.25;
	        }
	
	        actions.changeRate(playbackRate, {
	          action: 'fast-forward',
	          source: 'shortcut'
	        });
	      }
	    }, {
	      keyCode: 188,
	      // Shift + <
	      shift: true,
	      handle: function handle(player, actions) {
	        // Decrease speed
	        var playbackRate = player.playbackRate;
	
	        if (playbackRate <= 0.5) {
	          playbackRate = 0.25;
	        } else if (playbackRate <= 1.0) {
	          playbackRate = 0.5;
	        } else if (playbackRate <= 1.25) {
	          playbackRate = 1.0;
	        } else if (playbackRate <= 1.5) {
	          playbackRate = 1.25;
	        } else if (playbackRate <= 2) {
	          playbackRate = 1.5;
	        }
	
	        actions.changeRate(playbackRate, {
	          action: 'fast-rewind',
	          source: 'shortcut'
	        });
	      }
	    }];
	    _this.shortcuts = (0, _toConsumableArray2["default"])(_this.defaultShortcuts);
	    _this.mergeShortcuts = _this.mergeShortcuts.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleKeyPress = _this.handleKeyPress.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleDoubleClick = _this.handleDoubleClick.bind((0, _assertThisInitialized2["default"])(_this));
	    return _this;
	  }
	
	  (0, _createClass2["default"])(Shortcut, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.mergeShortcuts();
	      document.addEventListener('keydown', this.handleKeyPress);
	      document.addEventListener('click', this.handleClick);
	      document.addEventListener('dblclick', this.handleDoubleClick);
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      if (prevProps.shortcuts !== this.props.shortcuts) {
	        this.mergeShortcuts();
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      document.removeEventListener('keydown', this.handleKeyPress);
	      document.removeEventListener('click', this.handleClick);
	      document.removeEventListener('dblclick', this.handleDoubleClick);
	    } // merge the shortcuts from props
	
	  }, {
	    key: "mergeShortcuts",
	    value: function mergeShortcuts() {
	      var getShortcutKey = function getShortcutKey(_ref) {
	        var _ref$keyCode = _ref.keyCode,
	            keyCode = _ref$keyCode === void 0 ? 0 : _ref$keyCode,
	            _ref$ctrl = _ref.ctrl,
	            ctrl = _ref$ctrl === void 0 ? false : _ref$ctrl,
	            _ref$shift = _ref.shift,
	            shift = _ref$shift === void 0 ? false : _ref$shift,
	            _ref$alt = _ref.alt,
	            alt = _ref$alt === void 0 ? false : _ref$alt;
	        return "".concat(keyCode, ":").concat(ctrl, ":").concat(shift, ":").concat(alt);
	      };
	
	      var defaultShortcuts = this.defaultShortcuts.reduce(function (shortcuts, shortcut) {
	        return Object.assign(shortcuts, (0, _defineProperty2["default"])({}, getShortcutKey(shortcut), shortcut));
	      }, {});
	      var mergedShortcuts = (this.props.shortcuts || []).reduce(function (shortcuts, shortcut) {
	        var keyCode = shortcut.keyCode,
	            handle = shortcut.handle;
	
	        if (keyCode && typeof handle === 'function') {
	          return Object.assign(shortcuts, (0, _defineProperty2["default"])({}, getShortcutKey(shortcut), shortcut));
	        }
	
	        return shortcuts;
	      }, defaultShortcuts);
	
	      var gradeShortcut = function gradeShortcut(s) {
	        var score = 0;
	        var ps = ['ctrl', 'shift', 'alt'];
	        ps.forEach(function (key) {
	          if (s[key]) {
	            score++;
	          }
	        });
	        return score;
	      };
	
	      this.shortcuts = Object.keys(mergedShortcuts).map(function (key) {
	        return mergedShortcuts[key];
	      }).sort(function (a, b) {
	        return gradeShortcut(b) - gradeShortcut(a);
	      });
	    }
	  }, {
	    key: "togglePlay",
	    value: function togglePlay(player, actions) {
	      if (player.paused) {
	        actions.play({
	          action: 'play',
	          source: 'shortcut'
	        });
	      } else {
	        actions.pause({
	          action: 'pause',
	          source: 'shortcut'
	        });
	      }
	    }
	  }, {
	    key: "toggleFullscreen",
	    value: function toggleFullscreen(player, actions) {
	      actions.toggleFullscreen(player);
	    }
	  }, {
	    key: "handleKeyPress",
	    value: function handleKeyPress(e) {
	      var _this$props = this.props,
	          player = _this$props.player,
	          actions = _this$props.actions;
	
	      if (!player.isActive) {
	        return;
	      }
	
	      if (document.activeElement && ((0, _dom.hasClass)(document.activeElement, 'video-react-control') || (0, _dom.hasClass)(document.activeElement, 'video-react-menu-button-active') // || hasClass(document.activeElement, 'video-react-slider')
	      || (0, _dom.hasClass)(document.activeElement, 'video-react-big-play-button'))) {
	        return;
	      }
	
	      var keyCode = e.keyCode || e.which;
	      var ctrl = e.ctrlKey || e.metaKey;
	      var shift = e.shiftKey;
	      var alt = e.altKey;
	      var shortcut = this.shortcuts.filter(function (s) {
	        if (!s.keyCode || s.keyCode - keyCode !== 0) {
	          return false;
	        }
	
	        if (s.ctrl !== undefined && s.ctrl !== ctrl || s.shift !== undefined && s.shift !== shift || s.alt !== undefined && s.alt !== alt) {
	          return false;
	        }
	
	        return true;
	      })[0];
	
	      if (shortcut) {
	        shortcut.handle(player, actions);
	        e.preventDefault();
	      }
	    } // only if player is active and player is ready
	
	  }, {
	    key: "canBeClicked",
	    value: function canBeClicked(player, e) {
	      if (!player.isActive || e.target.nodeName !== 'VIDEO' || player.readyState !== 4) {
	        return false;
	      }
	
	      return true;
	    }
	  }, {
	    key: "handleClick",
	    value: function handleClick(e) {
	      var _this$props2 = this.props,
	          player = _this$props2.player,
	          actions = _this$props2.actions,
	          clickable = _this$props2.clickable;
	
	      if (!this.canBeClicked(player, e) || !clickable) {
	        return;
	      }
	
	      this.togglePlay(player, actions); // e.preventDefault();
	    }
	  }, {
	    key: "handleDoubleClick",
	    value: function handleDoubleClick(e) {
	      var _this$props3 = this.props,
	          player = _this$props3.player,
	          actions = _this$props3.actions,
	          dblclickable = _this$props3.dblclickable;
	
	      if (!this.canBeClicked(player, e) || !dblclickable) {
	        return;
	      }
	
	      this.toggleFullscreen(player, actions); // e.preventDefault();
	    } // this component dose not render anything
	    // it's just for the key down event
	
	  }, {
	    key: "render",
	    value: function render() {
	      return null;
	    }
	  }]);
	  return Shortcut;
	}(_react.Component);
	
	exports["default"] = Shortcut;
	Shortcut.propTypes = propTypes;
	Shortcut.defaultProps = defaultProps;
	Shortcut.displayName = 'Shortcut';

/***/ },
/* 672 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(47));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(19));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(40));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(39));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(12));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(22));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _utils = __webpack_require__(87);
	
	var propTypes = {
	  actions: _propTypes["default"].object,
	  player: _propTypes["default"].object,
	  children: _propTypes["default"].any,
	  startTime: _propTypes["default"].number,
	  loop: _propTypes["default"].bool,
	  muted: _propTypes["default"].bool,
	  autoPlay: _propTypes["default"].bool,
	  playsInline: _propTypes["default"].bool,
	  src: _propTypes["default"].string,
	  poster: _propTypes["default"].string,
	  className: _propTypes["default"].string,
	  preload: _propTypes["default"].oneOf(['auto', 'metadata', 'none']),
	  crossOrigin: _propTypes["default"].string,
	  onLoadStart: _propTypes["default"].func,
	  onWaiting: _propTypes["default"].func,
	  onCanPlay: _propTypes["default"].func,
	  onCanPlayThrough: _propTypes["default"].func,
	  onPlaying: _propTypes["default"].func,
	  onEnded: _propTypes["default"].func,
	  onSeeking: _propTypes["default"].func,
	  onSeeked: _propTypes["default"].func,
	  onPlay: _propTypes["default"].func,
	  onPause: _propTypes["default"].func,
	  onProgress: _propTypes["default"].func,
	  onDurationChange: _propTypes["default"].func,
	  onError: _propTypes["default"].func,
	  onSuspend: _propTypes["default"].func,
	  onAbort: _propTypes["default"].func,
	  onEmptied: _propTypes["default"].func,
	  onStalled: _propTypes["default"].func,
	  onLoadedMetadata: _propTypes["default"].func,
	  onLoadedData: _propTypes["default"].func,
	  onTimeUpdate: _propTypes["default"].func,
	  onRateChange: _propTypes["default"].func,
	  onVolumeChange: _propTypes["default"].func,
	  onResize: _propTypes["default"].func
	};
	
	var Video =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(Video, _Component);
	
	  function Video(props) {
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, Video);
	    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Video).call(this, props));
	    _this.video = null; // the html5 video
	
	    _this.play = _this.play.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.pause = _this.pause.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.seek = _this.seek.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.forward = _this.forward.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.replay = _this.replay.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.toggleFullscreen = _this.toggleFullscreen.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.getProperties = _this.getProperties.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.renderChildren = _this.renderChildren.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleLoadStart = _this.handleLoadStart.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleCanPlay = _this.handleCanPlay.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleCanPlayThrough = _this.handleCanPlayThrough.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handlePlay = _this.handlePlay.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handlePlaying = _this.handlePlaying.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handlePause = _this.handlePause.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleEnded = _this.handleEnded.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleWaiting = _this.handleWaiting.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleSeeking = _this.handleSeeking.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleSeeked = _this.handleSeeked.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleFullscreenChange = _this.handleFullscreenChange.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleError = _this.handleError.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleSuspend = _this.handleSuspend.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleAbort = _this.handleAbort.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleEmptied = _this.handleEmptied.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleStalled = _this.handleStalled.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleLoadedMetaData = _this.handleLoadedMetaData.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleLoadedData = _this.handleLoadedData.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleTimeUpdate = _this.handleTimeUpdate.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleRateChange = _this.handleRateChange.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleVolumeChange = _this.handleVolumeChange.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleDurationChange = _this.handleDurationChange.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleProgress = (0, _utils.throttle)(_this.handleProgress.bind((0, _assertThisInitialized2["default"])(_this)), 250);
	    _this.handleKeypress = _this.handleKeypress.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleTextTrackChange = _this.handleTextTrackChange.bind((0, _assertThisInitialized2["default"])(_this));
	    return _this;
	  }
	
	  (0, _createClass2["default"])(Video, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.forceUpdate(); // make sure the children can get the video property
	
	      if (this.video && this.video.textTracks) {
	        this.video.textTracks.onaddtrack = this.handleTextTrackChange;
	        this.video.textTracks.onremovetrack = this.handleTextTrackChange;
	      }
	    } // get all video properties
	
	  }, {
	    key: "getProperties",
	    value: function getProperties() {
	      var _this2 = this;
	
	      if (!this.video) {
	        return null;
	      }
	
	      return _utils.mediaProperties.reduce(function (properties, key) {
	        properties[key] = _this2.video[key];
	        return properties;
	      }, {});
	    } // get playback rate
	
	  }, {
	    key: "handleTextTrackChange",
	    value: function handleTextTrackChange() {
	      var _this$props = this.props,
	          actions = _this$props.actions,
	          player = _this$props.player;
	
	      if (this.video && this.video.textTracks) {
	        var activeTextTrack = Array.from(this.video.textTracks).find(function (textTrack) {
	          return textTrack.mode === 'showing';
	        });
	
	        if (activeTextTrack !== player.activeTextTrack) {
	          actions.activateTextTrack(activeTextTrack);
	        }
	      }
	    } // play the video
	
	  }, {
	    key: "play",
	    value: function play() {
	      var promise = this.video.play();
	
	      if (promise !== undefined) {
	        promise["catch"](function () {}).then(function () {});
	      }
	    } // pause the video
	
	  }, {
	    key: "pause",
	    value: function pause() {
	      var promise = this.video.pause();
	
	      if (promise !== undefined) {
	        promise["catch"](function () {}).then(function () {});
	      }
	    } // Change the video source and re-load the video:
	
	  }, {
	    key: "load",
	    value: function load() {
	      this.video.load();
	    } // Add a new text track to the video
	
	  }, {
	    key: "addTextTrack",
	    value: function addTextTrack() {
	      var _this$video;
	
	      (_this$video = this.video).addTextTrack.apply(_this$video, arguments);
	    } // Check if your browser can play different types of video:
	
	  }, {
	    key: "canPlayType",
	    value: function canPlayType() {
	      var _this$video2;
	
	      (_this$video2 = this.video).canPlayType.apply(_this$video2, arguments);
	    } // toggle play
	
	  }, {
	    key: "togglePlay",
	    value: function togglePlay() {
	      if (this.video.paused) {
	        this.play();
	      } else {
	        this.pause();
	      }
	    } // seek video by time
	
	  }, {
	    key: "seek",
	    value: function seek(time) {
	      try {
	        this.video.currentTime = time;
	      } catch (e) {// console.log(e, 'Video is not ready.')
	      }
	    } // jump forward x seconds
	
	  }, {
	    key: "forward",
	    value: function forward(seconds) {
	      this.seek(this.video.currentTime + seconds);
	    } // jump back x seconds
	
	  }, {
	    key: "replay",
	    value: function replay(seconds) {
	      this.forward(-seconds);
	    } // enter or exist full screen
	
	  }, {
	    key: "toggleFullscreen",
	    value: function toggleFullscreen() {
	      var _this$props2 = this.props,
	          player = _this$props2.player,
	          actions = _this$props2.actions;
	      actions.toggleFullscreen(player);
	    } // Fired when the user agent
	    // begins looking for media data
	
	  }, {
	    key: "handleLoadStart",
	    value: function handleLoadStart() {
	      var _this$props3 = this.props,
	          actions = _this$props3.actions,
	          onLoadStart = _this$props3.onLoadStart;
	      actions.handleLoadStart(this.getProperties());
	
	      if (onLoadStart) {
	        onLoadStart.apply(void 0, arguments);
	      }
	    } // A handler for events that
	    // signal that waiting has ended
	
	  }, {
	    key: "handleCanPlay",
	    value: function handleCanPlay() {
	      var _this$props4 = this.props,
	          actions = _this$props4.actions,
	          onCanPlay = _this$props4.onCanPlay;
	      actions.handleCanPlay(this.getProperties());
	
	      if (onCanPlay) {
	        onCanPlay.apply(void 0, arguments);
	      }
	    } // A handler for events that
	    // signal that waiting has ended
	
	  }, {
	    key: "handleCanPlayThrough",
	    value: function handleCanPlayThrough() {
	      var _this$props5 = this.props,
	          actions = _this$props5.actions,
	          onCanPlayThrough = _this$props5.onCanPlayThrough;
	      actions.handleCanPlayThrough(this.getProperties());
	
	      if (onCanPlayThrough) {
	        onCanPlayThrough.apply(void 0, arguments);
	      }
	    } // A handler for events that
	    // signal that waiting has ended
	
	  }, {
	    key: "handlePlaying",
	    value: function handlePlaying() {
	      var _this$props6 = this.props,
	          actions = _this$props6.actions,
	          onPlaying = _this$props6.onPlaying;
	      actions.handlePlaying(this.getProperties());
	
	      if (onPlaying) {
	        onPlaying.apply(void 0, arguments);
	      }
	    } // Fired whenever the media has been started
	
	  }, {
	    key: "handlePlay",
	    value: function handlePlay() {
	      var _this$props7 = this.props,
	          actions = _this$props7.actions,
	          onPlay = _this$props7.onPlay;
	      actions.handlePlay(this.getProperties());
	
	      if (onPlay) {
	        onPlay.apply(void 0, arguments);
	      }
	    } // Fired whenever the media has been paused
	
	  }, {
	    key: "handlePause",
	    value: function handlePause() {
	      var _this$props8 = this.props,
	          actions = _this$props8.actions,
	          onPause = _this$props8.onPause;
	      actions.handlePause(this.getProperties());
	
	      if (onPause) {
	        onPause.apply(void 0, arguments);
	      }
	    } // Fired when the duration of
	    // the media resource is first known or changed
	
	  }, {
	    key: "handleDurationChange",
	    value: function handleDurationChange() {
	      var _this$props9 = this.props,
	          actions = _this$props9.actions,
	          onDurationChange = _this$props9.onDurationChange;
	      actions.handleDurationChange(this.getProperties());
	
	      if (onDurationChange) {
	        onDurationChange.apply(void 0, arguments);
	      }
	    } // Fired while the user agent
	    // is downloading media data
	
	  }, {
	    key: "handleProgress",
	    value: function handleProgress() {
	      var _this$props10 = this.props,
	          actions = _this$props10.actions,
	          onProgress = _this$props10.onProgress;
	
	      if (this.video) {
	        actions.handleProgressChange(this.getProperties());
	      }
	
	      if (onProgress) {
	        onProgress.apply(void 0, arguments);
	      }
	    } // Fired when the end of the media resource
	    // is reached (currentTime == duration)
	
	  }, {
	    key: "handleEnded",
	    value: function handleEnded() {
	      var _this$props11 = this.props,
	          loop = _this$props11.loop,
	          player = _this$props11.player,
	          actions = _this$props11.actions,
	          onEnded = _this$props11.onEnded;
	
	      if (loop) {
	        this.seek(0);
	        this.play();
	      } else if (!player.paused) {
	        this.pause();
	      }
	
	      actions.handleEnd(this.getProperties());
	
	      if (onEnded) {
	        onEnded.apply(void 0, arguments);
	      }
	    } // Fired whenever the media begins waiting
	
	  }, {
	    key: "handleWaiting",
	    value: function handleWaiting() {
	      var _this$props12 = this.props,
	          actions = _this$props12.actions,
	          onWaiting = _this$props12.onWaiting;
	      actions.handleWaiting(this.getProperties());
	
	      if (onWaiting) {
	        onWaiting.apply(void 0, arguments);
	      }
	    } // Fired whenever the player
	    // is jumping to a new time
	
	  }, {
	    key: "handleSeeking",
	    value: function handleSeeking() {
	      var _this$props13 = this.props,
	          actions = _this$props13.actions,
	          onSeeking = _this$props13.onSeeking;
	      actions.handleSeeking(this.getProperties());
	
	      if (onSeeking) {
	        onSeeking.apply(void 0, arguments);
	      }
	    } // Fired when the player has
	    // finished jumping to a new time
	
	  }, {
	    key: "handleSeeked",
	    value: function handleSeeked() {
	      var _this$props14 = this.props,
	          actions = _this$props14.actions,
	          onSeeked = _this$props14.onSeeked;
	      actions.handleSeeked(this.getProperties());
	
	      if (onSeeked) {
	        onSeeked.apply(void 0, arguments);
	      }
	    } // Handle Fullscreen Change
	
	  }, {
	    key: "handleFullscreenChange",
	    value: function handleFullscreenChange() {} // Fires when the browser is
	    // intentionally not getting media data
	
	  }, {
	    key: "handleSuspend",
	    value: function handleSuspend() {
	      var _this$props15 = this.props,
	          actions = _this$props15.actions,
	          onSuspend = _this$props15.onSuspend;
	      actions.handleSuspend(this.getProperties());
	
	      if (onSuspend) {
	        onSuspend.apply(void 0, arguments);
	      }
	    } // Fires when the loading of an audio/video is aborted
	
	  }, {
	    key: "handleAbort",
	    value: function handleAbort() {
	      var _this$props16 = this.props,
	          actions = _this$props16.actions,
	          onAbort = _this$props16.onAbort;
	      actions.handleAbort(this.getProperties());
	
	      if (onAbort) {
	        onAbort.apply(void 0, arguments);
	      }
	    } // Fires when the current playlist is empty
	
	  }, {
	    key: "handleEmptied",
	    value: function handleEmptied() {
	      var _this$props17 = this.props,
	          actions = _this$props17.actions,
	          onEmptied = _this$props17.onEmptied;
	      actions.handleEmptied(this.getProperties());
	
	      if (onEmptied) {
	        onEmptied.apply(void 0, arguments);
	      }
	    } // Fires when the browser is trying to
	    // get media data, but data is not available
	
	  }, {
	    key: "handleStalled",
	    value: function handleStalled() {
	      var _this$props18 = this.props,
	          actions = _this$props18.actions,
	          onStalled = _this$props18.onStalled;
	      actions.handleStalled(this.getProperties());
	
	      if (onStalled) {
	        onStalled.apply(void 0, arguments);
	      }
	    } // Fires when the browser has loaded
	    // meta data for the audio/video
	
	  }, {
	    key: "handleLoadedMetaData",
	    value: function handleLoadedMetaData() {
	      var _this$props19 = this.props,
	          actions = _this$props19.actions,
	          onLoadedMetadata = _this$props19.onLoadedMetadata,
	          startTime = _this$props19.startTime;
	
	      if (startTime && startTime > 0) {
	        this.video.currentTime = startTime;
	      }
	
	      actions.handleLoadedMetaData(this.getProperties());
	
	      if (onLoadedMetadata) {
	        onLoadedMetadata.apply(void 0, arguments);
	      }
	    } // Fires when the browser has loaded
	    // the current frame of the audio/video
	
	  }, {
	    key: "handleLoadedData",
	    value: function handleLoadedData() {
	      var _this$props20 = this.props,
	          actions = _this$props20.actions,
	          onLoadedData = _this$props20.onLoadedData;
	      actions.handleLoadedData(this.getProperties());
	
	      if (onLoadedData) {
	        onLoadedData.apply(void 0, arguments);
	      }
	    } // Fires when the current
	    // playback position has changed
	
	  }, {
	    key: "handleTimeUpdate",
	    value: function handleTimeUpdate() {
	      var _this$props21 = this.props,
	          actions = _this$props21.actions,
	          onTimeUpdate = _this$props21.onTimeUpdate;
	      actions.handleTimeUpdate(this.getProperties());
	
	      if (onTimeUpdate) {
	        onTimeUpdate.apply(void 0, arguments);
	      }
	    }
	    /**
	     * Fires when the playing speed of the audio/video is changed
	     */
	
	  }, {
	    key: "handleRateChange",
	    value: function handleRateChange() {
	      var _this$props22 = this.props,
	          actions = _this$props22.actions,
	          onRateChange = _this$props22.onRateChange;
	      actions.handleRateChange(this.getProperties());
	
	      if (onRateChange) {
	        onRateChange.apply(void 0, arguments);
	      }
	    } // Fires when the volume has been changed
	
	  }, {
	    key: "handleVolumeChange",
	    value: function handleVolumeChange() {
	      var _this$props23 = this.props,
	          actions = _this$props23.actions,
	          onVolumeChange = _this$props23.onVolumeChange;
	      actions.handleVolumeChange(this.getProperties());
	
	      if (onVolumeChange) {
	        onVolumeChange.apply(void 0, arguments);
	      }
	    } // Fires when an error occurred
	    // during the loading of an audio/video
	
	  }, {
	    key: "handleError",
	    value: function handleError() {
	      var _this$props24 = this.props,
	          actions = _this$props24.actions,
	          onError = _this$props24.onError;
	      actions.handleError(this.getProperties());
	
	      if (onError) {
	        onError.apply(void 0, arguments);
	      }
	    }
	  }, {
	    key: "handleResize",
	    value: function handleResize() {
	      var _this$props25 = this.props,
	          actions = _this$props25.actions,
	          onResize = _this$props25.onResize;
	      actions.handleResize(this.getProperties());
	
	      if (onResize) {
	        onResize.apply(void 0, arguments);
	      }
	    }
	  }, {
	    key: "handleKeypress",
	    value: function handleKeypress() {}
	  }, {
	    key: "renderChildren",
	    value: function renderChildren() {
	      var _this3 = this;
	
	      var props = (0, _objectSpread2["default"])({}, this.props, {
	        video: this.video
	      }); // to make sure the children can get video property
	
	      if (!this.video) {
	        return null;
	      } // only keep <source />, <track />, <MyComponent isVideoChild /> elements
	
	
	      return _react["default"].Children.toArray(this.props.children).filter(_utils.isVideoChild).map(function (c) {
	        var cprops;
	
	        if (typeof c.type === 'string') {
	          // add onError to <source />
	          if (c.type === 'source') {
	            cprops = (0, _objectSpread2["default"])({}, c.props);
	            var preOnError = cprops.onError;
	
	            cprops.onError = function () {
	              if (preOnError) {
	                preOnError.apply(void 0, arguments);
	              }
	
	              _this3.handleError.apply(_this3, arguments);
	            };
	          }
	        } else {
	          cprops = props;
	        }
	
	        return _react["default"].cloneElement(c, cprops);
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this4 = this;
	
	      var _this$props26 = this.props,
	          loop = _this$props26.loop,
	          poster = _this$props26.poster,
	          preload = _this$props26.preload,
	          src = _this$props26.src,
	          autoPlay = _this$props26.autoPlay,
	          playsInline = _this$props26.playsInline,
	          muted = _this$props26.muted,
	          crossOrigin = _this$props26.crossOrigin,
	          videoId = _this$props26.videoId;
	      return _react["default"].createElement("video", {
	        className: (0, _classnames["default"])('video-react-video', this.props.className),
	        id: videoId,
	        crossOrigin: crossOrigin,
	        ref: function ref(c) {
	          _this4.video = c;
	        },
	        muted: muted,
	        preload: preload,
	        loop: loop,
	        playsInline: playsInline,
	        autoPlay: autoPlay,
	        poster: poster,
	        src: src,
	        onLoadStart: this.handleLoadStart,
	        onWaiting: this.handleWaiting,
	        onCanPlay: this.handleCanPlay,
	        onCanPlayThrough: this.handleCanPlayThrough,
	        onPlaying: this.handlePlaying,
	        onEnded: this.handleEnded,
	        onSeeking: this.handleSeeking,
	        onSeeked: this.handleSeeked,
	        onPlay: this.handlePlay,
	        onPause: this.handlePause,
	        onProgress: this.handleProgress,
	        onDurationChange: this.handleDurationChange,
	        onError: this.handleError,
	        onSuspend: this.handleSuspend,
	        onAbort: this.handleAbort,
	        onEmptied: this.handleEmptied,
	        onStalled: this.handleStalled,
	        onLoadedMetadata: this.handleLoadedMetaData,
	        onLoadedData: this.handleLoadedData,
	        onTimeUpdate: this.handleTimeUpdate,
	        onRateChange: this.handleRateChange,
	        onVolumeChange: this.handleVolumeChange,
	        tabIndex: "-1"
	      }, this.renderChildren());
	    }
	  }, {
	    key: "playbackRate",
	    get: function get() {
	      return this.video.playbackRate;
	    } // set playback rate
	    // speed of video
	    ,
	    set: function set(rate) {
	      this.video.playbackRate = rate;
	    }
	  }, {
	    key: "muted",
	    get: function get() {
	      return this.video.muted;
	    },
	    set: function set(val) {
	      this.video.muted = val;
	    }
	  }, {
	    key: "volume",
	    get: function get() {
	      return this.video.volume;
	    },
	    set: function set(val) {
	      if (val > 1) {
	        val = 1;
	      }
	
	      if (val < 0) {
	        val = 0;
	      }
	
	      this.video.volume = val;
	    } // video width
	
	  }, {
	    key: "videoWidth",
	    get: function get() {
	      return this.video.videoWidth;
	    } // video height
	
	  }, {
	    key: "videoHeight",
	    get: function get() {
	      return this.video.videoHeight;
	    }
	  }]);
	  return Video;
	}(_react.Component);
	
	exports["default"] = Video;
	Video.propTypes = propTypes;
	Video.displayName = 'Video';

/***/ },
/* 673 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(25));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(19));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(40));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(39));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(12));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(22));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _ProgressControl = _interopRequireDefault(__webpack_require__(681));
	
	var _PlayToggle = _interopRequireDefault(__webpack_require__(680));
	
	var _ForwardControl = _interopRequireDefault(__webpack_require__(674));
	
	var _ReplayControl = _interopRequireDefault(__webpack_require__(682));
	
	var _FullscreenToggle = _interopRequireDefault(__webpack_require__(676));
	
	var _RemainingTimeDisplay = _interopRequireDefault(__webpack_require__(687));
	
	var _CurrentTimeDisplay = _interopRequireDefault(__webpack_require__(685));
	
	var _DurationDisplay = _interopRequireDefault(__webpack_require__(686));
	
	var _TimeDivider = _interopRequireDefault(__webpack_require__(688));
	
	var _VolumeMenuButton = _interopRequireDefault(__webpack_require__(684));
	
	var _PlaybackRateMenuButton = _interopRequireDefault(__webpack_require__(314));
	
	var _utils = __webpack_require__(87);
	
	var propTypes = {
	  children: _propTypes["default"].any,
	  autoHide: _propTypes["default"].bool,
	  autoHideTime: _propTypes["default"].number,
	  // used in Player
	  disableDefaultControls: _propTypes["default"].bool,
	  disableCompletely: _propTypes["default"].bool,
	  className: _propTypes["default"].string
	};
	var defaultProps = {
	  autoHide: true,
	  disableCompletely: false
	};
	
	var ControlBar =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(ControlBar, _Component);
	
	  function ControlBar(props) {
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, ControlBar);
	    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(ControlBar).call(this, props));
	    _this.getDefaultChildren = _this.getDefaultChildren.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.getFullChildren = _this.getFullChildren.bind((0, _assertThisInitialized2["default"])(_this));
	    return _this;
	  }
	
	  (0, _createClass2["default"])(ControlBar, [{
	    key: "getDefaultChildren",
	    value: function getDefaultChildren() {
	      return [_react["default"].createElement(_PlayToggle["default"], {
	        key: "play-toggle",
	        order: 1
	      }), _react["default"].createElement(_VolumeMenuButton["default"], {
	        key: "volume-menu-button",
	        order: 4
	      }), _react["default"].createElement(_CurrentTimeDisplay["default"], {
	        key: "current-time-display",
	        order: 5.1
	      }), _react["default"].createElement(_TimeDivider["default"], {
	        key: "time-divider",
	        order: 5.2
	      }), _react["default"].createElement(_DurationDisplay["default"], {
	        key: "duration-display",
	        order: 5.3
	      }), _react["default"].createElement(_ProgressControl["default"], {
	        key: "progress-control",
	        order: 6
	      }), _react["default"].createElement(_FullscreenToggle["default"], {
	        key: "fullscreen-toggle",
	        order: 8
	      })];
	    }
	  }, {
	    key: "getFullChildren",
	    value: function getFullChildren() {
	      return [_react["default"].createElement(_PlayToggle["default"], {
	        key: "play-toggle",
	        order: 1
	      }), _react["default"].createElement(_ReplayControl["default"], {
	        key: "replay-control",
	        order: 2
	      }), _react["default"].createElement(_ForwardControl["default"], {
	        key: "forward-control",
	        order: 3
	      }), _react["default"].createElement(_VolumeMenuButton["default"], {
	        key: "volume-menu-button",
	        order: 4
	      }), _react["default"].createElement(_CurrentTimeDisplay["default"], {
	        key: "current-time-display",
	        order: 5
	      }), _react["default"].createElement(_TimeDivider["default"], {
	        key: "time-divider",
	        order: 6
	      }), _react["default"].createElement(_DurationDisplay["default"], {
	        key: "duration-display",
	        order: 7
	      }), _react["default"].createElement(_ProgressControl["default"], {
	        key: "progress-control",
	        order: 8
	      }), _react["default"].createElement(_RemainingTimeDisplay["default"], {
	        key: "remaining-time-display",
	        order: 9
	      }), _react["default"].createElement(_PlaybackRateMenuButton["default"], {
	        rates: [1, 1.25, 1.5, 2],
	        key: "playback-rate",
	        order: 10
	      }), _react["default"].createElement(_FullscreenToggle["default"], {
	        key: "fullscreen-toggle",
	        order: 11
	      })];
	    }
	  }, {
	    key: "getChildren",
	    value: function getChildren() {
	      var children = _react["default"].Children.toArray(this.props.children);
	
	      var defaultChildren = this.props.disableDefaultControls ? [] : this.getDefaultChildren();
	      var _this$props = this.props,
	          className = _this$props.className,
	          parentProps = (0, _objectWithoutProperties2["default"])(_this$props, ["className"]); // remove className
	
	      return (0, _utils.mergeAndSortChildren)(defaultChildren, children, parentProps);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          autoHide = _this$props2.autoHide,
	          className = _this$props2.className,
	          disableCompletely = _this$props2.disableCompletely;
	      var children = this.getChildren();
	      return disableCompletely ? null : _react["default"].createElement("div", {
	        className: (0, _classnames["default"])('video-react-control-bar', {
	          'video-react-control-bar-auto-hide': autoHide
	        }, className)
	      }, children);
	    }
	  }]);
	  return ControlBar;
	}(_react.Component);
	
	exports["default"] = ControlBar;
	ControlBar.propTypes = propTypes;
	ControlBar.defaultProps = defaultProps;
	ControlBar.displayName = 'ControlBar';

/***/ },
/* 674 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _ForwardReplayControl = _interopRequireDefault(__webpack_require__(675));
	
	// Pass mode into parent function
	var ForwardControl = (0, _ForwardReplayControl["default"])('forward');
	ForwardControl.displayName = 'ForwardControl';
	var _default = ForwardControl;
	exports["default"] = _default;

/***/ },
/* 675 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(19));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(40));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(39));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(12));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(22));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var propTypes = {
	  actions: _propTypes["default"].object,
	  className: _propTypes["default"].string,
	  seconds: _propTypes["default"].oneOf([5, 10, 30])
	};
	var defaultProps = {
	  seconds: 10
	};
	
	var _default = function _default(mode) {
	  var ForwardReplayControl =
	  /*#__PURE__*/
	  function (_Component) {
	    (0, _inherits2["default"])(ForwardReplayControl, _Component);
	
	    function ForwardReplayControl(props, context) {
	      var _this;
	
	      (0, _classCallCheck2["default"])(this, ForwardReplayControl);
	      _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(ForwardReplayControl).call(this, props, context));
	      _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
	      return _this;
	    }
	
	    (0, _createClass2["default"])(ForwardReplayControl, [{
	      key: "handleClick",
	      value: function handleClick() {
	        var _this$props = this.props,
	            actions = _this$props.actions,
	            seconds = _this$props.seconds; // Depends mode to implement different actions
	
	        if (mode === 'forward') {
	          actions.forward(seconds);
	        } else {
	          actions.replay(seconds);
	        }
	      }
	    }, {
	      key: "render",
	      value: function render() {
	        var _this2 = this;
	
	        var _this$props2 = this.props,
	            seconds = _this$props2.seconds,
	            className = _this$props2.className;
	        var classNames = ['video-react-control', 'video-react-button', 'video-react-icon'];
	        classNames.push("video-react-icon-".concat(mode, "-").concat(seconds), "video-react-".concat(mode, "-control"));
	
	        if (className) {
	          classNames.push(className);
	        }
	
	        return _react["default"].createElement("button", {
	          ref: function ref(c) {
	            _this2.button = c;
	          },
	          className: classNames.join(' '),
	          type: "button",
	          onClick: this.handleClick
	        }, _react["default"].createElement("span", {
	          className: "video-react-control-text"
	        }, "".concat(mode, " ").concat(seconds, " seconds")));
	      }
	    }]);
	    return ForwardReplayControl;
	  }(_react.Component);
	
	  ForwardReplayControl.propTypes = propTypes;
	  ForwardReplayControl.defaultProps = defaultProps;
	  return ForwardReplayControl;
	};
	
	exports["default"] = _default;

/***/ },
/* 676 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(19));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(40));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(39));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(12));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(22));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var propTypes = {
	  actions: _propTypes["default"].object,
	  player: _propTypes["default"].object,
	  className: _propTypes["default"].string
	};
	
	var FullscreenToggle =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(FullscreenToggle, _Component);
	
	  function FullscreenToggle(props, context) {
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, FullscreenToggle);
	    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(FullscreenToggle).call(this, props, context));
	    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
	    return _this;
	  }
	
	  (0, _createClass2["default"])(FullscreenToggle, [{
	    key: "handleClick",
	    value: function handleClick() {
	      var _this$props = this.props,
	          player = _this$props.player,
	          actions = _this$props.actions;
	      actions.toggleFullscreen(player);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _this$props2 = this.props,
	          player = _this$props2.player,
	          className = _this$props2.className;
	      return _react["default"].createElement("button", {
	        className: (0, _classnames["default"])(className, {
	          'video-react-icon-fullscreen-exit': player.isFullscreen,
	          'video-react-icon-fullscreen': !player.isFullscreen
	        }, 'video-react-fullscreen-control video-react-control video-react-button video-react-icon'),
	        ref: function ref(c) {
	          _this2.button = c;
	        },
	        type: "button",
	        tabIndex: "0",
	        onClick: this.handleClick
	      }, _react["default"].createElement("span", {
	        className: "video-react-control-text"
	      }, "Non-Fullscreen"));
	    }
	  }]);
	  return FullscreenToggle;
	}(_react.Component);
	
	exports["default"] = FullscreenToggle;
	FullscreenToggle.propTypes = propTypes;
	FullscreenToggle.displayName = 'FullscreenToggle';

/***/ },
/* 677 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = LoadProgressBar;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var propTypes = {
	  duration: _propTypes["default"].number,
	  buffered: _propTypes["default"].object,
	  className: _propTypes["default"].string
	}; // Shows load progress
	
	function LoadProgressBar(_ref) {
	  var buffered = _ref.buffered,
	      duration = _ref.duration,
	      className = _ref.className;
	
	  if (!buffered || !buffered.length) {
	    return null;
	  }
	
	  var bufferedEnd = buffered.end(buffered.length - 1);
	  var style = {};
	
	  if (bufferedEnd > duration) {
	    bufferedEnd = duration;
	  } // get the percent width of a time compared to the total end
	
	
	  function percentify(time, end) {
	    var percent = time / end || 0; // no NaN
	
	    return "".concat((percent >= 1 ? 1 : percent) * 100, "%");
	  } // the width of the progress bar
	
	
	  style.width = percentify(bufferedEnd, duration);
	  var parts = []; // add child elements to represent the individual buffered time ranges
	
	  for (var i = 0; i < buffered.length; i++) {
	    var start = buffered.start(i);
	    var end = buffered.end(i); // set the percent based on the width of the progress bar (bufferedEnd)
	
	    var part = _react["default"].createElement("div", {
	      style: {
	        left: percentify(start, bufferedEnd),
	        width: percentify(end - start, bufferedEnd)
	      },
	      key: "part-".concat(i)
	    });
	
	    parts.push(part);
	  }
	
	  if (parts.length === 0) {
	    parts = null;
	  }
	
	  return _react["default"].createElement("div", {
	    style: style,
	    className: (0, _classnames["default"])('video-react-load-progress', className)
	  }, _react["default"].createElement("span", {
	    className: "video-react-control-text"
	  }, "Loaded: 0%"), parts);
	}
	
	LoadProgressBar.propTypes = propTypes;
	LoadProgressBar.displayName = 'LoadProgressBar';

/***/ },
/* 678 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _utils = __webpack_require__(87);
	
	function MouseTimeDisplay(_ref) {
	  var duration = _ref.duration,
	      mouseTime = _ref.mouseTime,
	      className = _ref.className,
	      text = _ref.text;
	
	  if (!mouseTime.time) {
	    return null;
	  }
	
	  var time = text || (0, _utils.formatTime)(mouseTime.time, duration);
	  return _react["default"].createElement("div", {
	    className: (0, _classnames["default"])('video-react-mouse-display', className),
	    style: {
	      left: "".concat(mouseTime.position, "px")
	    },
	    "data-current-time": time
	  });
	}
	
	MouseTimeDisplay.propTypes = {
	  duration: _propTypes["default"].number,
	  mouseTime: _propTypes["default"].object,
	  className: _propTypes["default"].string
	};
	MouseTimeDisplay.displayName = 'MouseTimeDisplay';
	var _default = MouseTimeDisplay;
	exports["default"] = _default;

/***/ },
/* 679 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = PlayProgressBar;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _utils = __webpack_require__(87);
	
	var propTypes = {
	  currentTime: _propTypes["default"].number,
	  duration: _propTypes["default"].number,
	  percentage: _propTypes["default"].string,
	  className: _propTypes["default"].string
	}; // Shows play progress
	
	function PlayProgressBar(_ref) {
	  var currentTime = _ref.currentTime,
	      duration = _ref.duration,
	      percentage = _ref.percentage,
	      className = _ref.className;
	  return _react["default"].createElement("div", {
	    "data-current-time": (0, _utils.formatTime)(currentTime, duration),
	    className: (0, _classnames["default"])('video-react-play-progress video-react-slider-bar', className),
	    style: {
	      width: percentage
	    }
	  }, _react["default"].createElement("span", {
	    className: "video-react-control-text"
	  }, "Progress: ".concat(percentage)));
	}
	
	PlayProgressBar.propTypes = propTypes;
	PlayProgressBar.displayName = 'PlayProgressBar';

/***/ },
/* 680 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(19));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(40));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(39));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(12));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(22));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var propTypes = {
	  actions: _propTypes["default"].object,
	  player: _propTypes["default"].object,
	  className: _propTypes["default"].string
	};
	
	var PlayToggle =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(PlayToggle, _Component);
	
	  function PlayToggle(props, context) {
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, PlayToggle);
	    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(PlayToggle).call(this, props, context));
	    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
	    return _this;
	  }
	
	  (0, _createClass2["default"])(PlayToggle, [{
	    key: "handleClick",
	    value: function handleClick() {
	      var _this$props = this.props,
	          actions = _this$props.actions,
	          player = _this$props.player;
	
	      if (player.paused) {
	        actions.play();
	      } else {
	        actions.pause();
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _this$props2 = this.props,
	          player = _this$props2.player,
	          className = _this$props2.className;
	      var controlText = player.paused ? 'Play' : 'Pause';
	      return _react["default"].createElement("button", {
	        ref: function ref(c) {
	          _this2.button = c;
	        },
	        className: (0, _classnames["default"])(className, {
	          'video-react-play-control': true,
	          'video-react-control': true,
	          'video-react-button': true,
	          'video-react-paused': player.paused,
	          'video-react-playing': !player.paused
	        }),
	        type: "button",
	        tabIndex: "0",
	        onClick: this.handleClick
	      }, _react["default"].createElement("span", {
	        className: "video-react-control-text"
	      }, controlText));
	    }
	  }]);
	  return PlayToggle;
	}(_react.Component);
	
	exports["default"] = PlayToggle;
	PlayToggle.propTypes = propTypes;
	PlayToggle.displayName = 'PlayToggle';

/***/ },
/* 681 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(19));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(40));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(39));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(12));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(22));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var Dom = _interopRequireWildcard(__webpack_require__(227));
	
	var _SeekBar = _interopRequireDefault(__webpack_require__(683));
	
	var propTypes = {
	  player: _propTypes["default"].object,
	  className: _propTypes["default"].string
	};
	
	var ProgressControl =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(ProgressControl, _Component);
	
	  function ProgressControl(props, context) {
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, ProgressControl);
	    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(ProgressControl).call(this, props, context));
	    _this.state = {
	      mouseTime: {
	        time: null,
	        position: 0
	      }
	    };
	    _this.handleMouseMoveThrottle = _this.handleMouseMove.bind((0, _assertThisInitialized2["default"])(_this));
	    return _this;
	  }
	
	  (0, _createClass2["default"])(ProgressControl, [{
	    key: "handleMouseMove",
	    value: function handleMouseMove(event) {
	      if (!event.pageX) {
	        return;
	      }
	
	      var duration = this.props.player.duration;
	      var node = this.seekBar;
	      var newTime = Dom.getPointerPosition(node, event).x * duration;
	      var position = event.pageX - Dom.findElPosition(node).left;
	      this.setState({
	        mouseTime: {
	          time: newTime,
	          position: position
	        }
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var className = this.props.className;
	      return _react["default"].createElement("div", {
	        onMouseMove: this.handleMouseMoveThrottle,
	        className: (0, _classnames["default"])('video-react-progress-control video-react-control', className)
	      }, _react["default"].createElement(_SeekBar["default"], (0, _extends2["default"])({
	        mouseTime: this.state.mouseTime,
	        ref: function ref(c) {
	          _this2.seekBar = c;
	        }
	      }, this.props)));
	    }
	  }]);
	  return ProgressControl;
	}(_react.Component);
	
	exports["default"] = ProgressControl;
	ProgressControl.propTypes = propTypes;
	ProgressControl.displayName = 'ProgressControl';

/***/ },
/* 682 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _ForwardReplayControl = _interopRequireDefault(__webpack_require__(675));
	
	// Pass mode into parent function
	var ReplayControl = (0, _ForwardReplayControl["default"])('replay');
	ReplayControl.displayName = 'ReplayControl';
	var _default = ReplayControl;
	exports["default"] = _default;

/***/ },
/* 683 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(19));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(40));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(39));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(12));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(22));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _Slider = _interopRequireDefault(__webpack_require__(313));
	
	var _PlayProgressBar = _interopRequireDefault(__webpack_require__(679));
	
	var _LoadProgressBar = _interopRequireDefault(__webpack_require__(677));
	
	var _MouseTimeDisplay = _interopRequireDefault(__webpack_require__(678));
	
	var _utils = __webpack_require__(87);
	
	var propTypes = {
	  player: _propTypes["default"].object,
	  mouseTime: _propTypes["default"].object,
	  actions: _propTypes["default"].object,
	  className: _propTypes["default"].string
	};
	
	var SeekBar =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(SeekBar, _Component);
	
	  function SeekBar(props, context) {
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, SeekBar);
	    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(SeekBar).call(this, props, context));
	    _this.getPercent = _this.getPercent.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.getNewTime = _this.getNewTime.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.stepForward = _this.stepForward.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.stepBack = _this.stepBack.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleMouseDown = _this.handleMouseDown.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleMouseMove = _this.handleMouseMove.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleMouseUp = _this.handleMouseUp.bind((0, _assertThisInitialized2["default"])(_this));
	    return _this;
	  }
	
	  (0, _createClass2["default"])(SeekBar, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {}
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {}
	    /**
	     * Get percentage of video played
	     *
	     * @return {Number} Percentage played
	     * @method getPercent
	     */
	
	  }, {
	    key: "getPercent",
	    value: function getPercent() {
	      var _this$props$player = this.props.player,
	          currentTime = _this$props$player.currentTime,
	          seekingTime = _this$props$player.seekingTime,
	          duration = _this$props$player.duration;
	      var time = seekingTime || currentTime;
	      var percent = time / duration;
	      return percent >= 1 ? 1 : percent;
	    }
	  }, {
	    key: "getNewTime",
	    value: function getNewTime(event) {
	      var duration = this.props.player.duration;
	      var distance = this.slider.calculateDistance(event);
	      var newTime = distance * duration; // Don't let video end while scrubbing.
	
	      return newTime === duration ? newTime - 0.1 : newTime;
	    }
	  }, {
	    key: "handleMouseDown",
	    value: function handleMouseDown() {}
	  }, {
	    key: "handleMouseUp",
	    value: function handleMouseUp(event) {
	      var actions = this.props.actions;
	      var newTime = this.getNewTime(event); // Set new time (tell video to seek to new time)
	
	      actions.seek(newTime);
	      actions.handleEndSeeking(newTime);
	    }
	  }, {
	    key: "handleMouseMove",
	    value: function handleMouseMove(event) {
	      var actions = this.props.actions;
	      var newTime = this.getNewTime(event);
	      actions.handleSeekingTime(newTime);
	    }
	  }, {
	    key: "stepForward",
	    value: function stepForward() {
	      var actions = this.props.actions;
	      actions.forward(5);
	    }
	  }, {
	    key: "stepBack",
	    value: function stepBack() {
	      var actions = this.props.actions;
	      actions.replay(5);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _this$props = this.props,
	          _this$props$player2 = _this$props.player,
	          currentTime = _this$props$player2.currentTime,
	          seekingTime = _this$props$player2.seekingTime,
	          duration = _this$props$player2.duration,
	          buffered = _this$props$player2.buffered,
	          mouseTime = _this$props.mouseTime;
	      var time = seekingTime || currentTime;
	      return _react["default"].createElement(_Slider["default"], {
	        ref: function ref(input) {
	          _this2.slider = input;
	        },
	        label: "video progress bar",
	        className: (0, _classnames["default"])('video-react-progress-holder', this.props.className),
	        valuenow: (this.getPercent() * 100).toFixed(2),
	        valuetext: (0, _utils.formatTime)(time, duration),
	        onMouseDown: this.handleMouseDown,
	        onMouseMove: this.handleMouseMove,
	        onMouseUp: this.handleMouseUp,
	        getPercent: this.getPercent,
	        stepForward: this.stepForward,
	        stepBack: this.stepBack
	      }, _react["default"].createElement(_LoadProgressBar["default"], {
	        buffered: buffered,
	        currentTime: time,
	        duration: duration
	      }), _react["default"].createElement(_MouseTimeDisplay["default"], {
	        duration: duration,
	        mouseTime: mouseTime
	      }), _react["default"].createElement(_PlayProgressBar["default"], {
	        currentTime: time,
	        duration: duration
	      }));
	    }
	  }]);
	  return SeekBar;
	}(_react.Component);
	
	exports["default"] = SeekBar;
	SeekBar.propTypes = propTypes;
	SeekBar.displayName = 'SeekBar';

/***/ },
/* 684 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(19));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(40));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(39));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(12));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(22));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _PopupButton = _interopRequireDefault(__webpack_require__(1651));
	
	var _VolumeBar = _interopRequireDefault(__webpack_require__(1652));
	
	var propTypes = {
	  player: _propTypes["default"].object,
	  actions: _propTypes["default"].object,
	  vertical: _propTypes["default"].bool,
	  className: _propTypes["default"].string,
	  alwaysShowVolume: _propTypes["default"].bool
	};
	var defaultProps = {
	  vertical: false
	};
	
	var VolumeMenuButton =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(VolumeMenuButton, _Component);
	
	  function VolumeMenuButton(props, context) {
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, VolumeMenuButton);
	    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(VolumeMenuButton).call(this, props, context));
	    _this.state = {
	      active: false
	    };
	    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleFocus = _this.handleFocus.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleBlur = _this.handleBlur.bind((0, _assertThisInitialized2["default"])(_this));
	    return _this;
	  }
	
	  (0, _createClass2["default"])(VolumeMenuButton, [{
	    key: "handleClick",
	    value: function handleClick() {
	      var _this$props = this.props,
	          player = _this$props.player,
	          actions = _this$props.actions;
	      actions.mute(!player.muted);
	    }
	  }, {
	    key: "handleFocus",
	    value: function handleFocus() {
	      this.setState({
	        active: true
	      });
	    }
	  }, {
	    key: "handleBlur",
	    value: function handleBlur() {
	      this.setState({
	        active: false
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          vertical = _this$props2.vertical,
	          player = _this$props2.player,
	          className = _this$props2.className;
	      var inline = !vertical;
	      var level = this.volumeLevel;
	      return _react["default"].createElement(_PopupButton["default"], {
	        className: (0, _classnames["default"])(className, {
	          'video-react-volume-menu-button-vertical': vertical,
	          'video-react-volume-menu-button-horizontal': !vertical,
	          'video-react-vol-muted': player.muted,
	          'video-react-vol-0': level === 0 && !player.muted,
	          'video-react-vol-1': level === 1,
	          'video-react-vol-2': level === 2,
	          'video-react-vol-3': level === 3,
	          'video-react-slider-active': this.props.alwaysShowVolume || this.state.active,
	          'video-react-lock-showing': this.props.alwaysShowVolume || this.state.active
	        }, 'video-react-volume-menu-button'),
	        onClick: this.handleClick,
	        inline: inline
	      }, _react["default"].createElement(_VolumeBar["default"], (0, _extends2["default"])({
	        onFocus: this.handleFocus,
	        onBlur: this.handleBlur
	      }, this.props)));
	    }
	  }, {
	    key: "volumeLevel",
	    get: function get() {
	      var _this$props$player = this.props.player,
	          volume = _this$props$player.volume,
	          muted = _this$props$player.muted;
	      var level = 3;
	
	      if (volume === 0 || muted) {
	        level = 0;
	      } else if (volume < 0.33) {
	        level = 1;
	      } else if (volume < 0.67) {
	        level = 2;
	      }
	
	      return level;
	    }
	  }]);
	  return VolumeMenuButton;
	}(_react.Component);
	
	VolumeMenuButton.propTypes = propTypes;
	VolumeMenuButton.defaultProps = defaultProps;
	VolumeMenuButton.displayName = 'VolumeMenuButton';
	var _default = VolumeMenuButton;
	exports["default"] = _default;

/***/ },
/* 685 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _utils = __webpack_require__(87);
	
	var propTypes = {
	  player: _propTypes["default"].object,
	  className: _propTypes["default"].string
	};
	
	function CurrentTimeDisplay(_ref) {
	  var _ref$player = _ref.player,
	      currentTime = _ref$player.currentTime,
	      duration = _ref$player.duration,
	      className = _ref.className;
	  var formattedTime = (0, _utils.formatTime)(currentTime, duration);
	  return _react["default"].createElement("div", {
	    className: (0, _classnames["default"])('video-react-current-time video-react-time-control video-react-control', className)
	  }, _react["default"].createElement("div", {
	    className: "video-react-current-time-display",
	    "aria-live": "off"
	  }, _react["default"].createElement("span", {
	    className: "video-react-control-text"
	  }, "Current Time "), formattedTime));
	}
	
	CurrentTimeDisplay.propTypes = propTypes;
	CurrentTimeDisplay.displayName = 'CurrentTimeDisplay';
	var _default = CurrentTimeDisplay;
	exports["default"] = _default;

/***/ },
/* 686 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _utils = __webpack_require__(87);
	
	var propTypes = {
	  player: _propTypes["default"].object,
	  className: _propTypes["default"].string
	};
	
	function DurationDisplay(_ref) {
	  var duration = _ref.player.duration,
	      className = _ref.className;
	  var formattedTime = (0, _utils.formatTime)(duration);
	  return _react["default"].createElement("div", {
	    className: (0, _classnames["default"])(className, 'video-react-duration video-react-time-control video-react-control')
	  }, _react["default"].createElement("div", {
	    className: "video-react-duration-display",
	    "aria-live": "off"
	  }, _react["default"].createElement("span", {
	    className: "video-react-control-text"
	  }, "Duration Time "), formattedTime));
	}
	
	DurationDisplay.propTypes = propTypes;
	DurationDisplay.displayName = 'DurationDisplay';
	var _default = DurationDisplay;
	exports["default"] = _default;

/***/ },
/* 687 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _utils = __webpack_require__(87);
	
	var propTypes = {
	  player: _propTypes["default"].object,
	  className: _propTypes["default"].string
	};
	
	function RemainingTimeDisplay(_ref) {
	  var _ref$player = _ref.player,
	      currentTime = _ref$player.currentTime,
	      duration = _ref$player.duration,
	      className = _ref.className;
	  var remainingTime = duration - currentTime;
	  var formattedTime = (0, _utils.formatTime)(remainingTime);
	  return _react["default"].createElement("div", {
	    className: (0, _classnames["default"])('video-react-remaining-time video-react-time-control video-react-control', className)
	  }, _react["default"].createElement("div", {
	    className: "video-react-remaining-time-display",
	    "aria-live": "off"
	  }, _react["default"].createElement("span", {
	    className: "video-react-control-text"
	  }, "Remaining Time "), "-".concat(formattedTime)));
	}
	
	RemainingTimeDisplay.propTypes = propTypes;
	RemainingTimeDisplay.displayName = 'RemainingTimeDisplay';
	var _default = RemainingTimeDisplay;
	exports["default"] = _default;

/***/ },
/* 688 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = TimeDivider;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var propTypes = {
	  separator: _propTypes["default"].string,
	  className: _propTypes["default"].string
	};
	
	function TimeDivider(_ref) {
	  var separator = _ref.separator,
	      className = _ref.className;
	  var separatorText = separator || '/';
	  return _react["default"].createElement("div", {
	    className: (0, _classnames["default"])('video-react-time-control video-react-time-divider', className),
	    dir: "ltr"
	  }, _react["default"].createElement("div", null, _react["default"].createElement("span", null, separatorText)));
	}
	
	TimeDivider.propTypes = propTypes;
	TimeDivider.displayName = 'TimeDivider';

/***/ },
/* 689 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = _default;
	exports.operationReducer = exports.playerReducer = void 0;
	
	var _player = _interopRequireDefault(__webpack_require__(1656));
	
	var _operation = _interopRequireDefault(__webpack_require__(1655));
	
	function _default() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments.length > 1 ? arguments[1] : undefined;
	  return {
	    player: (0, _player["default"])(state.player, action),
	    operation: (0, _operation["default"])(state.operation, action)
	  };
	}
	
	var playerReducer = _player["default"];
	exports.playerReducer = playerReducer;
	var operationReducer = _operation["default"];
	exports.operationReducer = operationReducer;

/***/ },
/* 690 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(19));
	
	var Fullscreen =
	/*#__PURE__*/
	function () {
	  function Fullscreen() {
	    (0, _classCallCheck2["default"])(this, Fullscreen);
	  }
	
	  (0, _createClass2["default"])(Fullscreen, [{
	    key: "request",
	    value: function request(elm) {
	      if (elm.requestFullscreen) {
	        elm.requestFullscreen();
	      } else if (elm.webkitRequestFullscreen) {
	        elm.webkitRequestFullscreen();
	      } else if (elm.mozRequestFullScreen) {
	        elm.mozRequestFullScreen();
	      } else if (elm.msRequestFullscreen) {
	        elm.msRequestFullscreen();
	      }
	    }
	  }, {
	    key: "exit",
	    value: function exit() {
	      if (document.exitFullscreen) {
	        document.exitFullscreen();
	      } else if (document.webkitExitFullscreen) {
	        document.webkitExitFullscreen();
	      } else if (document.mozCancelFullScreen) {
	        document.mozCancelFullScreen();
	      } else if (document.msExitFullscreen) {
	        document.msExitFullscreen();
	      }
	    }
	  }, {
	    key: "addEventListener",
	    value: function addEventListener(handler) {
	      document.addEventListener('fullscreenchange', handler);
	      document.addEventListener('webkitfullscreenchange', handler);
	      document.addEventListener('mozfullscreenchange', handler);
	      document.addEventListener('MSFullscreenChange', handler);
	    }
	  }, {
	    key: "removeEventListener",
	    value: function removeEventListener(handler) {
	      document.removeEventListener('fullscreenchange', handler);
	      document.removeEventListener('webkitfullscreenchange', handler);
	      document.removeEventListener('mozfullscreenchange', handler);
	      document.removeEventListener('MSFullscreenChange', handler);
	    }
	  }, {
	    key: "isFullscreen",
	    get: function get() {
	      return document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement;
	    }
	  }, {
	    key: "enabled",
	    get: function get() {
	      return document.fullscreenEnabled || document.webkitFullscreenEnabled || document.mozFullScreenEnabled || document.msFullscreenEnabled;
	    }
	  }]);
	  return Fullscreen;
	}();
	
	var _default = new Fullscreen();
	
	exports["default"] = _default;

/***/ },
/* 691 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var __DEV__ = ("production") !== 'production';
	
	var warning = function() {};
	
	if (__DEV__) {
	  var printWarning = function printWarning(format, args) {
	    var len = arguments.length;
	    args = new Array(len > 1 ? len - 1 : 0);
	    for (var key = 1; key < len; key++) {
	      args[key - 1] = arguments[key];
	    }
	    var argIndex = 0;
	    var message = 'Warning: ' +
	      format.replace(/%s/g, function() {
	        return args[argIndex++];
	      });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  }
	
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	          '`warning(condition, format, ...args)` requires a warning ' +
	          'message argument'
	      );
	    }
	    if (!condition) {
	      printWarning.apply(null, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;


/***/ },
/* 692 */
/***/ function(module, exports) {

	(function () {
	  function getType(x) {
	    // TODO make this faster ?
	    return {}.toString.call(x);
	  }
	
	  function hasOwnKey(obj, key) {
	    return {}.hasOwnProperty.call(obj, key);
	  }
	
	
	  function copyObject(x) {
	    var output = {};
	
	    // TODO use Object.keys ?
	    for (var key in x) {
	      if (hasOwnKey(x, key)) {
	        output[key] = copy(x[key]);
	      }
	    }
	
	    return output;
	  }
	
	  function copyArray(x) {
	    var length = x.length;
	
	    var output = new Array(length);
	
	    for (var i = 0; i < length; ++i) {
	      output[i] = copy(x[i]);
	    }
	
	    return output;
	  }
	
	  // TODO can this be made faster ?
	  // TODO what about regexps, etc. ?
	  function copy(x) {
	    switch (getType(x)) {
	    case "[object Array]":
	      return copyArray(x);
	
	    case "[object Object]":
	      return copyObject(x);
	
	    // TODO is this necessary ?
	    case "[object Date]":
	      return new Date(x.getTime());
	
	    default:
	      return x;
	    }
	  }
	
	
	  function isNaN(x) {
	    return x !== x;
	  }
	
	  function isNumberEqual(x, y) {
	    return x === y || (isNaN(x) && isNaN(y));
	  }
	
	
	  function removeChartListeners(chart, x, y) {
	    if (x !== y) {
	      // TODO is this necessary ?
	      if (x == null) {
	        x = [];
	      }
	
	      // TODO is this necessary ?
	      if (y == null) {
	        y = [];
	      }
	
	      var xLength = x.length;
	      var yLength = y.length;
	
	      for (var i = 0; i < xLength; ++i) {
	        var xValue = x[i];
	
	        var has = false;
	
	        // TODO make this faster ?
	        for (var j = 0; j < yLength; ++j) {
	          var yValue = y[j];
	
	          // TODO is this correct ?
	          if (xValue.event  === yValue.event &&
	              xValue.method === yValue.method) {
	            has = true;
	            break;
	          }
	        }
	
	        if (!has) {
	          // TODO is this correct ?
	          chart.removeListener(chart, xValue.event, xValue.method);
	        }
	      }
	    }
	  }
	
	
	  function updateArray(a, x, y) {
	    var didUpdate = false;
	
	    if (x !== y) {
	      var xLength = x.length;
	      var yLength = y.length;
	
	      if (xLength !== yLength) {
	        a.length = yLength;
	        didUpdate = true;
	      }
	
	      for (var i = 0; i < yLength; ++i) {
	        if (i < xLength) {
	          if (update(a, i, x[i], y[i])) {
	            didUpdate = true;
	          }
	
	        } else {
	          // TODO make this faster ?
	          a[i] = copy(y[i]);
	          // TODO is this necessary ?
	          didUpdate = true;
	        }
	      }
	    }
	
	    return didUpdate;
	  }
	
	
	  function update(obj, key, x, y) {
	    var didUpdate = false;
	
	    if (x !== y) {
	      // https://github.com/amcharts/amcharts3-react/issues/40
	      if (hasOwnKey(obj, key)) {
	        var xType = getType(x);
	        var yType = getType(y);
	
	        if (xType === yType) {
	          switch (xType) {
	          case "[object Array]":
	            // TODO hacky, remove this after the following bug is fixed:
	            //      Zendesk #28040
	            //      https://codepen.io/team/amcharts/pen/0d61f559cda74682c0ca55d9a24a0f77
	            //      https://www.amcharts.com/kbase/forcing-grouping-stock-chart-data-specific-periods/
	            if (key === "groupToPeriods") {
	              // TODO is the copy necessary ?
	              obj[key] = copy(y);
	              didUpdate = true;
	
	            } else {
	              if (updateArray(obj[key], x, y)) {
	                didUpdate = true;
	              }
	            }
	            break;
	
	          case "[object Object]":
	            if (updateObject(obj[key], x, y)) {
	              didUpdate = true;
	            }
	            break;
	
	          case "[object Date]":
	            if (x.getTime() !== y.getTime()) {
	              // TODO make this faster ?
	              obj[key] = copy(y);
	              didUpdate = true;
	            }
	            break;
	
	          case "[object Number]":
	            if (!isNumberEqual(x, y)) {
	              // TODO is the copy necessary ?
	              obj[key] = copy(y);
	              didUpdate = true;
	            }
	            break;
	
	          default:
	            // TODO is the copy necessary ?
	            obj[key] = copy(y);
	            didUpdate = true;
	            break;
	          }
	
	        // TODO is this correct ?
	        } else {
	          // TODO make this faster ?
	          obj[key] = copy(y);
	          didUpdate = true;
	        }
	      }
	    }
	
	    return didUpdate;
	  }
	
	  function updateObject(chart, oldObj, newObj) {
	    var didUpdate = false;
	
	    if (oldObj !== newObj) {
	      // TODO use Object.keys ?
	      for (var key in newObj) {
	        if (hasOwnKey(newObj, key)) {
	          // TODO make this faster ?
	          if (hasOwnKey(oldObj, key)) {
	            // TODO should this count as an update ?
	            if (key === "listeners") {
	              // TODO make this faster ?
	              removeChartListeners(chart, oldObj[key], newObj[key]);
	            }
	
	            if (update(chart, key, oldObj[key], newObj[key])) {
	              didUpdate = true;
	            }
	
	          } else {
	            // TODO make this faster ?
	            chart[key] = copy(newObj[key]);
	            didUpdate = true;
	          }
	        }
	      }
	
	      // TODO use Object.keys ?
	      for (var key in oldObj) {
	        if (hasOwnKey(oldObj, key) && !hasOwnKey(newObj, key)) {
	          if (key === "listeners") {
	            removeChartListeners(chart, oldObj[key], []);
	          }
	
	          delete chart[key];
	          didUpdate = true;
	        }
	      }
	    }
	
	    return didUpdate;
	  }
	
	
	  var id = 0;
	
	  AmCharts.React = createReactClass({
	    getInitialState: function () {
	      return {
	        id: "__AmCharts_React_" + (++id) + "__",
	        chart: null
	      };
	    },
	
	    componentDidMount: function () {
	      // AmCharts mutates the config object, so we have to make a deep copy to prevent that
	      var props = copy(this.props.options);
	
	      var chart = AmCharts.makeChart(this.state.id, props, this.props.delay);
	
	      this.setState({
	        chart: chart
	      });
	    },
	
	    // TODO is this correct ? should this use componentWillUpdate instead ?
	    componentDidUpdate: function (oldProps) {
	      if (this.state.chart) {
	        var didUpdate = updateObject(this.state.chart, oldProps.options, this.props.options);
	
	        // TODO make this faster
	        if (didUpdate) {
	          this.state.chart.validateNow(true);
	        }
	      }
	    },
	
	    componentWillUnmount: function () {
	      if (this.state.chart) {
	        this.state.chart.clear();
	      }
	    },
	
	    render: function () {
	      return React.createElement("div", {
	        id: this.state.id,
	        className: this.props.className,
	        style: this.props.style
	      });
	    }
	  });
	})();


/***/ },
/* 693 */
/***/ function(module, exports) {

	function _arrayWithHoles(r) {
	  if (Array.isArray(r)) return r;
	}
	module.exports = _arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 694 */
/***/ function(module, exports, __webpack_require__) {

	var arrayLikeToArray = __webpack_require__(316);
	function _arrayWithoutHoles(r) {
	  if (Array.isArray(r)) return arrayLikeToArray(r);
	}
	module.exports = _arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 695 */
/***/ function(module, exports, __webpack_require__) {

	var unsupportedIterableToArray = __webpack_require__(229);
	function _createForOfIteratorHelper(r, e) {
	  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
	  if (!t) {
	    if (Array.isArray(r) || (t = unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
	      t && (r = t);
	      var _n = 0,
	        F = function F() {};
	      return {
	        s: F,
	        n: function n() {
	          return _n >= r.length ? {
	            done: !0
	          } : {
	            done: !1,
	            value: r[_n++]
	          };
	        },
	        e: function e(r) {
	          throw r;
	        },
	        f: F
	      };
	    }
	    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	  }
	  var o,
	    a = !0,
	    u = !1;
	  return {
	    s: function s() {
	      t = t.call(r);
	    },
	    n: function n() {
	      var r = t.next();
	      return a = r.done, r;
	    },
	    e: function e(r) {
	      u = !0, o = r;
	    },
	    f: function f() {
	      try {
	        a || null == t["return"] || t["return"]();
	      } finally {
	        if (u) throw o;
	      }
	    }
	  };
	}
	module.exports = _createForOfIteratorHelper, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 696 */
/***/ function(module, exports) {

	function _isNativeReflectConstruct() {
	  try {
	    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
	  } catch (t) {}
	  return (module.exports = _isNativeReflectConstruct = function _isNativeReflectConstruct() {
	    return !!t;
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
	}
	module.exports = _isNativeReflectConstruct, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 697 */
/***/ function(module, exports) {

	function _iterableToArray(r) {
	  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
	}
	module.exports = _iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 698 */
/***/ function(module, exports) {

	function _iterableToArrayLimit(r, l) {
	  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
	  if (null != t) {
	    var e,
	      n,
	      i,
	      u,
	      a = [],
	      f = !0,
	      o = !1;
	    try {
	      if (i = (t = t.call(r)).next, 0 === l) {
	        if (Object(t) !== t) return;
	        f = !1;
	      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
	    } catch (r) {
	      o = !0, n = r;
	    } finally {
	      try {
	        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
	      } finally {
	        if (o) throw n;
	      }
	    }
	    return a;
	  }
	}
	module.exports = _iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 699 */
/***/ function(module, exports) {

	function _nonIterableRest() {
	  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	module.exports = _nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 700 */
/***/ function(module, exports) {

	function _nonIterableSpread() {
	  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	module.exports = _nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 701 */
/***/ function(module, exports, __webpack_require__) {

	var defineProperty = __webpack_require__(24);
	function ownKeys(e, r) {
	  var t = Object.keys(e);
	  if (Object.getOwnPropertySymbols) {
	    var o = Object.getOwnPropertySymbols(e);
	    r && (o = o.filter(function (r) {
	      return Object.getOwnPropertyDescriptor(e, r).enumerable;
	    })), t.push.apply(t, o);
	  }
	  return t;
	}
	function _objectSpread2(e) {
	  for (var r = 1; r < arguments.length; r++) {
	    var t = null != arguments[r] ? arguments[r] : {};
	    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
	      defineProperty(e, r, t[r]);
	    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
	      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
	    });
	  }
	  return e;
	}
	module.exports = _objectSpread2, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 702 */
/***/ function(module, exports, __webpack_require__) {

	var _typeof = __webpack_require__(56)["default"];
	function toPrimitive(t, r) {
	  if ("object" != _typeof(t) || !t) return t;
	  var e = t[Symbol.toPrimitive];
	  if (void 0 !== e) {
	    var i = e.call(t, r || "default");
	    if ("object" != _typeof(i)) return i;
	    throw new TypeError("@@toPrimitive must return a primitive value.");
	  }
	  return ("string" === r ? String : Number)(t);
	}
	module.exports = toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 703 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function stylis_min (W) {
	  function M(d, c, e, h, a) {
	    for (var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;) {
	      g = e.charCodeAt(l);
	      l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);
	
	      if (0 === b + n + v + m) {
	        if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
	          switch (g) {
	            case 32:
	            case 9:
	            case 59:
	            case 13:
	            case 10:
	              break;
	
	            default:
	              f += e.charAt(l);
	          }
	
	          g = 59;
	        }
	
	        switch (g) {
	          case 123:
	            f = f.trim();
	            q = f.charCodeAt(0);
	            k = 1;
	
	            for (t = ++l; l < B;) {
	              switch (g = e.charCodeAt(l)) {
	                case 123:
	                  k++;
	                  break;
	
	                case 125:
	                  k--;
	                  break;
	
	                case 47:
	                  switch (g = e.charCodeAt(l + 1)) {
	                    case 42:
	                    case 47:
	                      a: {
	                        for (u = l + 1; u < J; ++u) {
	                          switch (e.charCodeAt(u)) {
	                            case 47:
	                              if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
	                                l = u + 1;
	                                break a;
	                              }
	
	                              break;
	
	                            case 10:
	                              if (47 === g) {
	                                l = u + 1;
	                                break a;
	                              }
	
	                          }
	                        }
	
	                        l = u;
	                      }
	
	                  }
	
	                  break;
	
	                case 91:
	                  g++;
	
	                case 40:
	                  g++;
	
	                case 34:
	                case 39:
	                  for (; l++ < J && e.charCodeAt(l) !== g;) {
	                  }
	
	              }
	
	              if (0 === k) break;
	              l++;
	            }
	
	            k = e.substring(t, l);
	            0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));
	
	            switch (q) {
	              case 64:
	                0 < r && (f = f.replace(N, ''));
	                g = f.charCodeAt(1);
	
	                switch (g) {
	                  case 100:
	                  case 109:
	                  case 115:
	                  case 45:
	                    r = c;
	                    break;
	
	                  default:
	                    r = O;
	                }
	
	                k = M(c, r, k, g, a + 1);
	                t = k.length;
	                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
	                if (0 < t) switch (g) {
	                  case 115:
	                    f = f.replace(da, ea);
	
	                  case 100:
	                  case 109:
	                  case 45:
	                    k = f + '{' + k + '}';
	                    break;
	
	                  case 107:
	                    f = f.replace(fa, '$1 $2');
	                    k = f + '{' + k + '}';
	                    k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
	                    break;
	
	                  default:
	                    k = f + k, 112 === h && (k = (p += k, ''));
	                } else k = '';
	                break;
	
	              default:
	                k = M(c, X(c, f, I), k, h, a + 1);
	            }
	
	            F += k;
	            k = I = r = u = q = 0;
	            f = '';
	            g = e.charCodeAt(++l);
	            break;
	
	          case 125:
	          case 59:
	            f = (0 < r ? f.replace(N, '') : f).trim();
	            if (1 < (t = f.length)) switch (0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q) {
	              case 0:
	                break;
	
	              case 64:
	                if (105 === g || 99 === g) {
	                  G += f + e.charAt(l);
	                  break;
	                }
	
	              default:
	                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
	            }
	            I = r = u = q = 0;
	            f = '';
	            g = e.charCodeAt(++l);
	        }
	      }
	
	      switch (g) {
	        case 13:
	        case 10:
	          47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
	          0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
	          z = 1;
	          D++;
	          break;
	
	        case 59:
	        case 125:
	          if (0 === b + n + v + m) {
	            z++;
	            break;
	          }
	
	        default:
	          z++;
	          y = e.charAt(l);
	
	          switch (g) {
	            case 9:
	            case 32:
	              if (0 === n + m + b) switch (x) {
	                case 44:
	                case 58:
	                case 9:
	                case 32:
	                  y = '';
	                  break;
	
	                default:
	                  32 !== g && (y = ' ');
	              }
	              break;
	
	            case 0:
	              y = '\\0';
	              break;
	
	            case 12:
	              y = '\\f';
	              break;
	
	            case 11:
	              y = '\\v';
	              break;
	
	            case 38:
	              0 === n + b + m && (r = I = 1, y = '\f' + y);
	              break;
	
	            case 108:
	              if (0 === n + b + m + E && 0 < u) switch (l - u) {
	                case 2:
	                  112 === x && 58 === e.charCodeAt(l - 3) && (E = x);
	
	                case 8:
	                  111 === K && (E = K);
	              }
	              break;
	
	            case 58:
	              0 === n + b + m && (u = l);
	              break;
	
	            case 44:
	              0 === b + v + n + m && (r = 1, y += '\r');
	              break;
	
	            case 34:
	            case 39:
	              0 === b && (n = n === g ? 0 : 0 === n ? g : n);
	              break;
	
	            case 91:
	              0 === n + b + v && m++;
	              break;
	
	            case 93:
	              0 === n + b + v && m--;
	              break;
	
	            case 41:
	              0 === n + b + m && v--;
	              break;
	
	            case 40:
	              if (0 === n + b + m) {
	                if (0 === q) switch (2 * x + 3 * K) {
	                  case 533:
	                    break;
	
	                  default:
	                    q = 1;
	                }
	                v++;
	              }
	
	              break;
	
	            case 64:
	              0 === b + v + n + m + u + k && (k = 1);
	              break;
	
	            case 42:
	            case 47:
	              if (!(0 < n + m + v)) switch (b) {
	                case 0:
	                  switch (2 * g + 3 * e.charCodeAt(l + 1)) {
	                    case 235:
	                      b = 47;
	                      break;
	
	                    case 220:
	                      t = l, b = 42;
	                  }
	
	                  break;
	
	                case 42:
	                  47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
	              }
	          }
	
	          0 === b && (f += y);
	      }
	
	      K = x;
	      x = g;
	      l++;
	    }
	
	    t = p.length;
	
	    if (0 < t) {
	      r = c;
	      if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
	      p = r.join(',') + '{' + p + '}';
	
	      if (0 !== w * E) {
	        2 !== w || L(p, 2) || (E = 0);
	
	        switch (E) {
	          case 111:
	            p = p.replace(ha, ':-moz-$1') + p;
	            break;
	
	          case 112:
	            p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
	        }
	
	        E = 0;
	      }
	    }
	
	    return G + p + F;
	  }
	
	  function X(d, c, e) {
	    var h = c.trim().split(ia);
	    c = h;
	    var a = h.length,
	        m = d.length;
	
	    switch (m) {
	      case 0:
	      case 1:
	        var b = 0;
	
	        for (d = 0 === m ? '' : d[0] + ' '; b < a; ++b) {
	          c[b] = Z(d, c[b], e).trim();
	        }
	
	        break;
	
	      default:
	        var v = b = 0;
	
	        for (c = []; b < a; ++b) {
	          for (var n = 0; n < m; ++n) {
	            c[v++] = Z(d[n] + ' ', h[b], e).trim();
	          }
	        }
	
	    }
	
	    return c;
	  }
	
	  function Z(d, c, e) {
	    var h = c.charCodeAt(0);
	    33 > h && (h = (c = c.trim()).charCodeAt(0));
	
	    switch (h) {
	      case 38:
	        return c.replace(F, '$1' + d.trim());
	
	      case 58:
	        return d.trim() + c.replace(F, '$1' + d.trim());
	
	      default:
	        if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
	    }
	
	    return d + c;
	  }
	
	  function P(d, c, e, h) {
	    var a = d + ';',
	        m = 2 * c + 3 * e + 4 * h;
	
	    if (944 === m) {
	      d = a.indexOf(':', 9) + 1;
	      var b = a.substring(d, a.length - 1).trim();
	      b = a.substring(0, d).trim() + b + ';';
	      return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
	    }
	
	    if (0 === w || 2 === w && !L(a, 1)) return a;
	
	    switch (m) {
	      case 1015:
	        return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;
	
	      case 951:
	        return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;
	
	      case 963:
	        return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;
	
	      case 1009:
	        if (100 !== a.charCodeAt(4)) break;
	
	      case 969:
	      case 942:
	        return '-webkit-' + a + a;
	
	      case 978:
	        return '-webkit-' + a + '-moz-' + a + a;
	
	      case 1019:
	      case 983:
	        return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;
	
	      case 883:
	        if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
	        if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
	        break;
	
	      case 932:
	        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
	          case 103:
	            return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;
	
	          case 115:
	            return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;
	
	          case 98:
	            return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
	        }
	        return '-webkit-' + a + '-ms-' + a + a;
	
	      case 964:
	        return '-webkit-' + a + '-ms-flex-' + a + a;
	
	      case 1023:
	        if (99 !== a.charCodeAt(8)) break;
	        b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
	        return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;
	
	      case 1005:
	        return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;
	
	      case 1e3:
	        b = a.substring(13).trim();
	        c = b.indexOf('-') + 1;
	
	        switch (b.charCodeAt(0) + b.charCodeAt(c)) {
	          case 226:
	            b = a.replace(G, 'tb');
	            break;
	
	          case 232:
	            b = a.replace(G, 'tb-rl');
	            break;
	
	          case 220:
	            b = a.replace(G, 'lr');
	            break;
	
	          default:
	            return a;
	        }
	
	        return '-webkit-' + a + '-ms-' + b + a;
	
	      case 1017:
	        if (-1 === a.indexOf('sticky', 9)) break;
	
	      case 975:
	        c = (a = d).length - 10;
	        b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();
	
	        switch (m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
	          case 203:
	            if (111 > b.charCodeAt(8)) break;
	
	          case 115:
	            a = a.replace(b, '-webkit-' + b) + ';' + a;
	            break;
	
	          case 207:
	          case 102:
	            a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
	        }
	
	        return a + ';';
	
	      case 938:
	        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
	          case 105:
	            return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;
	
	          case 115:
	            return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;
	
	          default:
	            return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
	        }
	        break;
	
	      case 973:
	      case 989:
	        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;
	
	      case 931:
	      case 953:
	        if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
	        break;
	
	      case 962:
	        if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
	    }
	
	    return a;
	  }
	
	  function L(d, c) {
	    var e = d.indexOf(1 === c ? ':' : '{'),
	        h = d.substring(0, 3 !== c ? e : 10);
	    e = d.substring(e + 1, d.length - 1);
	    return R(2 !== c ? h : h.replace(na, '$1'), e, c);
	  }
	
	  function ea(d, c) {
	    var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
	    return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
	  }
	
	  function H(d, c, e, h, a, m, b, v, n, q) {
	    for (var g = 0, x = c, w; g < A; ++g) {
	      switch (w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)) {
	        case void 0:
	        case !1:
	        case !0:
	        case null:
	          break;
	
	        default:
	          x = w;
	      }
	    }
	
	    if (x !== c) return x;
	  }
	
	  function T(d) {
	    switch (d) {
	      case void 0:
	      case null:
	        A = S.length = 0;
	        break;
	
	      default:
	        if ('function' === typeof d) S[A++] = d;else if ('object' === typeof d) for (var c = 0, e = d.length; c < e; ++c) {
	          T(d[c]);
	        } else Y = !!d | 0;
	    }
	
	    return T;
	  }
	
	  function U(d) {
	    d = d.prefix;
	    void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
	    return U;
	  }
	
	  function B(d, c) {
	    var e = d;
	    33 > e.charCodeAt(0) && (e = e.trim());
	    V = e;
	    e = [V];
	
	    if (0 < A) {
	      var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
	      void 0 !== h && 'string' === typeof h && (c = h);
	    }
	
	    var a = M(O, e, c, 0, 0);
	    0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
	    V = '';
	    E = 0;
	    z = D = 1;
	    return a;
	  }
	
	  var ca = /^\0+/g,
	      N = /[\0\r\f]/g,
	      aa = /: */g,
	      ka = /zoo|gra/,
	      ma = /([,: ])(transform)/g,
	      ia = /,\r+?/g,
	      F = /([\t\r\n ])*\f?&/g,
	      fa = /@(k\w+)\s*(\S*)\s*/,
	      Q = /::(place)/g,
	      ha = /:(read-only)/g,
	      G = /[svh]\w+-[tblr]{2}/,
	      da = /\(\s*(.*)\s*\)/g,
	      oa = /([\s\S]*?);/g,
	      ba = /-self|flex-/g,
	      na = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
	      la = /stretch|:\s*\w+\-(?:conte|avail)/,
	      ja = /([^-])(image-set\()/,
	      z = 1,
	      D = 1,
	      E = 0,
	      w = 1,
	      O = [],
	      S = [],
	      A = 0,
	      R = null,
	      Y = 0,
	      V = '';
	  B.use = T;
	  B.set = U;
	  void 0 !== W && U(W);
	  return B;
	}
	
	exports.default = stylis_min;


/***/ },
/* 704 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var unitlessKeys = {
	  animationIterationCount: 1,
	  borderImageOutset: 1,
	  borderImageSlice: 1,
	  borderImageWidth: 1,
	  boxFlex: 1,
	  boxFlexGroup: 1,
	  boxOrdinalGroup: 1,
	  columnCount: 1,
	  columns: 1,
	  flex: 1,
	  flexGrow: 1,
	  flexPositive: 1,
	  flexShrink: 1,
	  flexNegative: 1,
	  flexOrder: 1,
	  gridRow: 1,
	  gridRowEnd: 1,
	  gridRowSpan: 1,
	  gridRowStart: 1,
	  gridColumn: 1,
	  gridColumnEnd: 1,
	  gridColumnSpan: 1,
	  gridColumnStart: 1,
	  msGridRow: 1,
	  msGridRowSpan: 1,
	  msGridColumn: 1,
	  msGridColumnSpan: 1,
	  fontWeight: 1,
	  lineHeight: 1,
	  opacity: 1,
	  order: 1,
	  orphans: 1,
	  tabSize: 1,
	  widows: 1,
	  zIndex: 1,
	  zoom: 1,
	  WebkitLineClamp: 1,
	  // SVG-related properties
	  fillOpacity: 1,
	  floodOpacity: 1,
	  stopOpacity: 1,
	  strokeDasharray: 1,
	  strokeDashoffset: 1,
	  strokeMiterlimit: 1,
	  strokeOpacity: 1,
	  strokeWidth: 1
	};
	
	exports.default = unitlessKeys;


/***/ },
/* 705 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gud = __webpack_require__(1300);
	
	var _gud2 = _interopRequireDefault(_gud);
	
	var _warning = __webpack_require__(691);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MAX_SIGNED_31_BIT_INT = 1073741823;
	
	// Inlined Object.is polyfill.
	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	function objectIs(x, y) {
	  if (x === y) {
	    return x !== 0 || 1 / x === 1 / y;
	  } else {
	    return x !== x && y !== y;
	  }
	}
	
	function createEventEmitter(value) {
	  var handlers = [];
	  return {
	    on: function on(handler) {
	      handlers.push(handler);
	    },
	    off: function off(handler) {
	      handlers = handlers.filter(function (h) {
	        return h !== handler;
	      });
	    },
	    get: function get() {
	      return value;
	    },
	    set: function set(newValue, changedBits) {
	      value = newValue;
	      handlers.forEach(function (handler) {
	        return handler(value, changedBits);
	      });
	    }
	  };
	}
	
	function onlyChild(children) {
	  return Array.isArray(children) ? children[0] : children;
	}
	
	function createReactContext(defaultValue, calculateChangedBits) {
	  var _Provider$childContex, _Consumer$contextType;
	
	  var contextProp = '__create-react-context-' + (0, _gud2.default)() + '__';
	
	  var Provider = function (_Component) {
	    _inherits(Provider, _Component);
	
	    function Provider() {
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, Provider);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.emitter = createEventEmitter(_this.props.value), _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    Provider.prototype.getChildContext = function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[contextProp] = this.emitter, _ref;
	    };
	
	    Provider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	      if (this.props.value !== nextProps.value) {
	        var oldValue = this.props.value;
	        var newValue = nextProps.value;
	        var changedBits = void 0;
	
	        if (objectIs(oldValue, newValue)) {
	          changedBits = 0; // No change
	        } else {
	          changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
	          if (false) {
	            (0, _warning2.default)((changedBits & MAX_SIGNED_31_BIT_INT) === changedBits, 'calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: %s', changedBits);
	          }
	
	          changedBits |= 0;
	
	          if (changedBits !== 0) {
	            this.emitter.set(nextProps.value, changedBits);
	          }
	        }
	      }
	    };
	
	    Provider.prototype.render = function render() {
	      return this.props.children;
	    };
	
	    return Provider;
	  }(_react.Component);
	
	  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = _propTypes2.default.object.isRequired, _Provider$childContex);
	
	  var Consumer = function (_Component2) {
	    _inherits(Consumer, _Component2);
	
	    function Consumer() {
	      var _temp2, _this2, _ret2;
	
	      _classCallCheck(this, Consumer);
	
	      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, _Component2.call.apply(_Component2, [this].concat(args))), _this2), _this2.state = {
	        value: _this2.getValue()
	      }, _this2.onUpdate = function (newValue, changedBits) {
	        var observedBits = _this2.observedBits | 0;
	        if ((observedBits & changedBits) !== 0) {
	          _this2.setState({ value: _this2.getValue() });
	        }
	      }, _temp2), _possibleConstructorReturn(_this2, _ret2);
	    }
	
	    Consumer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	      var observedBits = nextProps.observedBits;
	
	      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
	      : observedBits;
	    };
	
	    Consumer.prototype.componentDidMount = function componentDidMount() {
	      if (this.context[contextProp]) {
	        this.context[contextProp].on(this.onUpdate);
	      }
	      var observedBits = this.props.observedBits;
	
	      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
	      : observedBits;
	    };
	
	    Consumer.prototype.componentWillUnmount = function componentWillUnmount() {
	      if (this.context[contextProp]) {
	        this.context[contextProp].off(this.onUpdate);
	      }
	    };
	
	    Consumer.prototype.getValue = function getValue() {
	      if (this.context[contextProp]) {
	        return this.context[contextProp].get();
	      } else {
	        return defaultValue;
	      }
	    };
	
	    Consumer.prototype.render = function render() {
	      return onlyChild(this.props.children)(this.state.value);
	    };
	
	    return Consumer;
	  }(_react.Component);
	
	  Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = _propTypes2.default.object, _Consumer$contextType);
	
	
	  return {
	    Provider: Provider,
	    Consumer: Consumer
	  };
	}
	
	exports.default = createReactContext;
	module.exports = exports['default'];

/***/ },
/* 706 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _implementation = __webpack_require__(705);
	
	var _implementation2 = _interopRequireDefault(_implementation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _react2.default.createContext || _implementation2.default;
	module.exports = exports['default'];

/***/ },
/* 707 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(25));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(43));
	
	var _clsx = _interopRequireDefault(__webpack_require__(37));
	
	var _utils = __webpack_require__(26);
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(68));
	
	var _useEventCallback = _interopRequireDefault(__webpack_require__(180));
	
	var _deprecatedPropType = _interopRequireDefault(__webpack_require__(94));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(41));
	
	var _useIsFocusVisible2 = _interopRequireDefault(__webpack_require__(333));
	
	var _TouchRipple = _interopRequireDefault(__webpack_require__(709));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    display: 'inline-flex',
	    alignItems: 'center',
	    justifyContent: 'center',
	    position: 'relative',
	    WebkitTapHighlightColor: 'transparent',
	    backgroundColor: 'transparent',
	    // Reset default value
	    // We disable the focus ring for mouse, touch and keyboard users.
	    outline: 0,
	    border: 0,
	    margin: 0,
	    // Remove the margin in Safari
	    borderRadius: 0,
	    padding: 0,
	    // Remove the padding in Firefox
	    cursor: 'pointer',
	    userSelect: 'none',
	    verticalAlign: 'middle',
	    '-moz-appearance': 'none',
	    // Reset
	    '-webkit-appearance': 'none',
	    // Reset
	    textDecoration: 'none',
	    // So we take precedent over the style of a native <a /> element.
	    color: 'inherit',
	    '&::-moz-focus-inner': {
	      borderStyle: 'none' // Remove Firefox dotted outline.
	
	    },
	    '&$disabled': {
	      pointerEvents: 'none',
	      // Disable link interactions
	      cursor: 'default'
	    },
	    '@media print': {
	      colorAdjust: 'exact'
	    }
	  },
	
	  /* Pseudo-class applied to the root element if `disabled={true}`. */
	  disabled: {},
	
	  /* Pseudo-class applied to the root element if keyboard focused. */
	  focusVisible: {}
	};
	/**
	 * `ButtonBase` contains as few styles as possible.
	 * It aims to be a simple building block for creating a button.
	 * It contains a load of style reset and some focus/ripple logic.
	 */
	
	exports.styles = styles;
	var ButtonBase = /*#__PURE__*/React.forwardRef(function ButtonBase(props, ref) {
	  var action = props.action,
	      buttonRefProp = props.buttonRef,
	      _props$centerRipple = props.centerRipple,
	      centerRipple = _props$centerRipple === void 0 ? false : _props$centerRipple,
	      children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      component = _props$component === void 0 ? 'button' : _props$component,
	      _props$disabled = props.disabled,
	      disabled = _props$disabled === void 0 ? false : _props$disabled,
	      _props$disableRipple = props.disableRipple,
	      disableRipple = _props$disableRipple === void 0 ? false : _props$disableRipple,
	      _props$disableTouchRi = props.disableTouchRipple,
	      disableTouchRipple = _props$disableTouchRi === void 0 ? false : _props$disableTouchRi,
	      _props$focusRipple = props.focusRipple,
	      focusRipple = _props$focusRipple === void 0 ? false : _props$focusRipple,
	      focusVisibleClassName = props.focusVisibleClassName,
	      onBlur = props.onBlur,
	      onClick = props.onClick,
	      onFocus = props.onFocus,
	      onFocusVisible = props.onFocusVisible,
	      onKeyDown = props.onKeyDown,
	      onKeyUp = props.onKeyUp,
	      onMouseDown = props.onMouseDown,
	      onMouseLeave = props.onMouseLeave,
	      onMouseUp = props.onMouseUp,
	      onTouchEnd = props.onTouchEnd,
	      onTouchMove = props.onTouchMove,
	      onTouchStart = props.onTouchStart,
	      onDragLeave = props.onDragLeave,
	      _props$tabIndex = props.tabIndex,
	      tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex,
	      TouchRippleProps = props.TouchRippleProps,
	      _props$type = props.type,
	      type = _props$type === void 0 ? 'button' : _props$type,
	      other = (0, _objectWithoutProperties2.default)(props, ["action", "buttonRef", "centerRipple", "children", "classes", "className", "component", "disabled", "disableRipple", "disableTouchRipple", "focusRipple", "focusVisibleClassName", "onBlur", "onClick", "onFocus", "onFocusVisible", "onKeyDown", "onKeyUp", "onMouseDown", "onMouseLeave", "onMouseUp", "onTouchEnd", "onTouchMove", "onTouchStart", "onDragLeave", "tabIndex", "TouchRippleProps", "type"]);
	  var buttonRef = React.useRef(null);
	
	  function getButtonNode() {
	    // #StrictMode ready
	    return ReactDOM.findDOMNode(buttonRef.current);
	  }
	
	  var rippleRef = React.useRef(null);
	
	  var _React$useState = React.useState(false),
	      focusVisible = _React$useState[0],
	      setFocusVisible = _React$useState[1];
	
	  if (disabled && focusVisible) {
	    setFocusVisible(false);
	  }
	
	  var _useIsFocusVisible = (0, _useIsFocusVisible2.default)(),
	      isFocusVisible = _useIsFocusVisible.isFocusVisible,
	      onBlurVisible = _useIsFocusVisible.onBlurVisible,
	      focusVisibleRef = _useIsFocusVisible.ref;
	
	  React.useImperativeHandle(action, function () {
	    return {
	      focusVisible: function focusVisible() {
	        setFocusVisible(true);
	        buttonRef.current.focus();
	      }
	    };
	  }, []);
	  React.useEffect(function () {
	    if (focusVisible && focusRipple && !disableRipple) {
	      rippleRef.current.pulsate();
	    }
	  }, [disableRipple, focusRipple, focusVisible]);
	
	  function useRippleHandler(rippleAction, eventCallback) {
	    var skipRippleAction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : disableTouchRipple;
	    return (0, _useEventCallback.default)(function (event) {
	      if (eventCallback) {
	        eventCallback(event);
	      }
	
	      var ignore = skipRippleAction;
	
	      if (!ignore && rippleRef.current) {
	        rippleRef.current[rippleAction](event);
	      }
	
	      return true;
	    });
	  }
	
	  var handleMouseDown = useRippleHandler('start', onMouseDown);
	  var handleDragLeave = useRippleHandler('stop', onDragLeave);
	  var handleMouseUp = useRippleHandler('stop', onMouseUp);
	  var handleMouseLeave = useRippleHandler('stop', function (event) {
	    if (focusVisible) {
	      event.preventDefault();
	    }
	
	    if (onMouseLeave) {
	      onMouseLeave(event);
	    }
	  });
	  var handleTouchStart = useRippleHandler('start', onTouchStart);
	  var handleTouchEnd = useRippleHandler('stop', onTouchEnd);
	  var handleTouchMove = useRippleHandler('stop', onTouchMove);
	  var handleBlur = useRippleHandler('stop', function (event) {
	    if (focusVisible) {
	      onBlurVisible(event);
	      setFocusVisible(false);
	    }
	
	    if (onBlur) {
	      onBlur(event);
	    }
	  }, false);
	  var handleFocus = (0, _useEventCallback.default)(function (event) {
	    // Fix for https://github.com/facebook/react/issues/7769
	    if (!buttonRef.current) {
	      buttonRef.current = event.currentTarget;
	    }
	
	    if (isFocusVisible(event)) {
	      setFocusVisible(true);
	
	      if (onFocusVisible) {
	        onFocusVisible(event);
	      }
	    }
	
	    if (onFocus) {
	      onFocus(event);
	    }
	  });
	
	  var isNonNativeButton = function isNonNativeButton() {
	    var button = getButtonNode();
	    return component && component !== 'button' && !(button.tagName === 'A' && button.href);
	  };
	  /**
	   * IE 11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
	   */
	
	
	  var keydownRef = React.useRef(false);
	  var handleKeyDown = (0, _useEventCallback.default)(function (event) {
	    // Check if key is already down to avoid repeats being counted as multiple activations
	    if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === ' ') {
	      keydownRef.current = true;
	      event.persist();
	      rippleRef.current.stop(event, function () {
	        rippleRef.current.start(event);
	      });
	    }
	
	    if (event.target === event.currentTarget && isNonNativeButton() && event.key === ' ') {
	      event.preventDefault();
	    }
	
	    if (onKeyDown) {
	      onKeyDown(event);
	    } // Keyboard accessibility for non interactive elements
	
	
	    if (event.target === event.currentTarget && isNonNativeButton() && event.key === 'Enter' && !disabled) {
	      event.preventDefault();
	
	      if (onClick) {
	        onClick(event);
	      }
	    }
	  });
	  var handleKeyUp = (0, _useEventCallback.default)(function (event) {
	    // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
	    // https://codesandbox.io/s/button-keyup-preventdefault-dn7f0
	    if (focusRipple && event.key === ' ' && rippleRef.current && focusVisible && !event.defaultPrevented) {
	      keydownRef.current = false;
	      event.persist();
	      rippleRef.current.stop(event, function () {
	        rippleRef.current.pulsate(event);
	      });
	    }
	
	    if (onKeyUp) {
	      onKeyUp(event);
	    } // Keyboard accessibility for non interactive elements
	
	
	    if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === ' ' && !event.defaultPrevented) {
	      onClick(event);
	    }
	  });
	  var ComponentProp = component;
	
	  if (ComponentProp === 'button' && other.href) {
	    ComponentProp = 'a';
	  }
	
	  var buttonProps = {};
	
	  if (ComponentProp === 'button') {
	    buttonProps.type = type;
	    buttonProps.disabled = disabled;
	  } else {
	    if (ComponentProp !== 'a' || !other.href) {
	      buttonProps.role = 'button';
	    }
	
	    buttonProps['aria-disabled'] = disabled;
	  }
	
	  var handleUserRef = (0, _useForkRef.default)(buttonRefProp, ref);
	  var handleOwnRef = (0, _useForkRef.default)(focusVisibleRef, buttonRef);
	  var handleRef = (0, _useForkRef.default)(handleUserRef, handleOwnRef);
	
	  var _React$useState2 = React.useState(false),
	      mountedState = _React$useState2[0],
	      setMountedState = _React$useState2[1];
	
	  React.useEffect(function () {
	    setMountedState(true);
	  }, []);
	  var enableTouchRipple = mountedState && !disableRipple && !disabled;
	
	  if (false) {
	    // eslint-disable-next-line react-hooks/rules-of-hooks
	    React.useEffect(function () {
	      if (enableTouchRipple && !rippleRef.current) {
	        console.error(['Material-UI: The `component` prop provided to ButtonBase is invalid.', 'Please make sure the children prop is rendered in this custom component.'].join('\n'));
	      }
	    }, [enableTouchRipple]);
	  }
	
	  return /*#__PURE__*/React.createElement(ComponentProp, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, focusVisible && [classes.focusVisible, focusVisibleClassName], disabled && classes.disabled),
	    onBlur: handleBlur,
	    onClick: onClick,
	    onFocus: handleFocus,
	    onKeyDown: handleKeyDown,
	    onKeyUp: handleKeyUp,
	    onMouseDown: handleMouseDown,
	    onMouseLeave: handleMouseLeave,
	    onMouseUp: handleMouseUp,
	    onDragLeave: handleDragLeave,
	    onTouchEnd: handleTouchEnd,
	    onTouchMove: handleTouchMove,
	    onTouchStart: handleTouchStart,
	    ref: handleRef,
	    tabIndex: disabled ? -1 : tabIndex
	  }, buttonProps, other), children, enableTouchRipple ?
	  /*#__PURE__*/
	
	  /* TouchRipple is only needed client-side, x2 boost on the server. */
	  React.createElement(_TouchRipple.default, (0, _extends2.default)({
	    ref: rippleRef,
	    center: centerRipple
	  }, TouchRippleProps)) : null);
	});
	 false ? ButtonBase.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * A ref for imperative actions.
	   * It currently only supports `focusVisible()` action.
	   */
	  action: _utils.refType,
	
	  /**
	   * @ignore
	   *
	   * Use that prop to pass a ref to the native button component.
	   * @deprecated Use `ref` instead.
	   */
	  buttonRef: (0, _deprecatedPropType.default)(_utils.refType, 'Use `ref` instead.'),
	
	  /**
	   * If `true`, the ripples will be centered.
	   * They won't start at the cursor interaction position.
	   */
	  centerRipple: _propTypes.default.bool,
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _utils.elementTypeAcceptingRef,
	
	  /**
	   * If `true`, the base button will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the ripple effect will be disabled.
	   *
	   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
	   * to highlight the element by applying separate styles with the `focusVisibleClassName`.
	   */
	  disableRipple: _propTypes.default.bool,
	
	  /**
	   * If `true`, the touch ripple effect will be disabled.
	   */
	  disableTouchRipple: _propTypes.default.bool,
	
	  /**
	   * If `true`, the base button will have a keyboard focus ripple.
	   */
	  focusRipple: _propTypes.default.bool,
	
	  /**
	   * This prop can help identify which element has keyboard focus.
	   * The class name will be applied when the element gains the focus through keyboard interaction.
	   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
	   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/master/explainer.md).
	   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
	   * if needed.
	   */
	  focusVisibleClassName: _propTypes.default.string,
	
	  /**
	   * @ignore
	   */
	  href: _propTypes.default.string,
	
	  /**
	   * @ignore
	   */
	  onBlur: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onClick: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onDragLeave: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onFocus: _propTypes.default.func,
	
	  /**
	   * Callback fired when the component is focused with a keyboard.
	   * We trigger a `onFocus` callback too.
	   */
	  onFocusVisible: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onKeyDown: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onKeyUp: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onMouseDown: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onMouseLeave: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onMouseUp: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onTouchEnd: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onTouchMove: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onTouchStart: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  tabIndex: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * Props applied to the `TouchRipple` element.
	   */
	  TouchRippleProps: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  type: _propTypes.default.oneOfType([_propTypes.default.oneOf(['button', 'reset', 'submit']), _propTypes.default.string])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiButtonBase'
	})(ButtonBase);
	
	exports.default = _default;

/***/ },
/* 708 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(37));
	
	var _useEventCallback = _interopRequireDefault(__webpack_require__(180));
	
	var useEnhancedEffect = typeof window === 'undefined' ? React.useEffect : React.useLayoutEffect;
	/**
	 * @ignore - internal component.
	 */
	
	function Ripple(props) {
	  var classes = props.classes,
	      _props$pulsate = props.pulsate,
	      pulsate = _props$pulsate === void 0 ? false : _props$pulsate,
	      rippleX = props.rippleX,
	      rippleY = props.rippleY,
	      rippleSize = props.rippleSize,
	      inProp = props.in,
	      _props$onExited = props.onExited,
	      onExited = _props$onExited === void 0 ? function () {} : _props$onExited,
	      timeout = props.timeout;
	
	  var _React$useState = React.useState(false),
	      leaving = _React$useState[0],
	      setLeaving = _React$useState[1];
	
	  var rippleClassName = (0, _clsx.default)(classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
	  var rippleStyles = {
	    width: rippleSize,
	    height: rippleSize,
	    top: -(rippleSize / 2) + rippleY,
	    left: -(rippleSize / 2) + rippleX
	  };
	  var childClassName = (0, _clsx.default)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
	  var handleExited = (0, _useEventCallback.default)(onExited); // Ripple is used for user feedback (e.g. click or press) so we want to apply styles with the highest priority
	
	  useEnhancedEffect(function () {
	    if (!inProp) {
	      // react-transition-group#onExit
	      setLeaving(true); // react-transition-group#onExited
	
	      var timeoutId = setTimeout(handleExited, timeout);
	      return function () {
	        clearTimeout(timeoutId);
	      };
	    }
	
	    return undefined;
	  }, [handleExited, inProp, timeout]);
	  return /*#__PURE__*/React.createElement("span", {
	    className: rippleClassName,
	    style: rippleStyles
	  }, /*#__PURE__*/React.createElement("span", {
	    className: childClassName
	  }));
	}
	
	 false ? Ripple.propTypes = {
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore - injected from TransitionGroup
	   */
	  in: _propTypes.default.bool,
	
	  /**
	   * @ignore - injected from TransitionGroup
	   */
	  onExited: _propTypes.default.func,
	
	  /**
	   * If `true`, the ripple pulsates, typically indicating the keyboard focus state of an element.
	   */
	  pulsate: _propTypes.default.bool,
	
	  /**
	   * Diameter of the ripple.
	   */
	  rippleSize: _propTypes.default.number,
	
	  /**
	   * Horizontal position of the ripple center.
	   */
	  rippleX: _propTypes.default.number,
	
	  /**
	   * Vertical position of the ripple center.
	   */
	  rippleY: _propTypes.default.number,
	
	  /**
	   * exit delay
	   */
	  timeout: _propTypes.default.number.isRequired
	} : void 0;
	var _default = Ripple;
	exports.default = _default;

/***/ },
/* 709 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = exports.DELAY_RIPPLE = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(103));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(25));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _reactTransitionGroup = __webpack_require__(300);
	
	var _clsx = _interopRequireDefault(__webpack_require__(37));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(41));
	
	var _Ripple = _interopRequireDefault(__webpack_require__(708));
	
	var DURATION = 550;
	var DELAY_RIPPLE = 80;
	exports.DELAY_RIPPLE = DELAY_RIPPLE;
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      overflow: 'hidden',
	      pointerEvents: 'none',
	      position: 'absolute',
	      zIndex: 0,
	      top: 0,
	      right: 0,
	      bottom: 0,
	      left: 0,
	      borderRadius: 'inherit'
	    },
	
	    /* Styles applied to the internal `Ripple` components `ripple` class. */
	    ripple: {
	      opacity: 0,
	      position: 'absolute'
	    },
	
	    /* Styles applied to the internal `Ripple` components `rippleVisible` class. */
	    rippleVisible: {
	      opacity: 0.3,
	      transform: 'scale(1)',
	      animation: "$enter ".concat(DURATION, "ms ").concat(theme.transitions.easing.easeInOut)
	    },
	
	    /* Styles applied to the internal `Ripple` components `ripplePulsate` class. */
	    ripplePulsate: {
	      animationDuration: "".concat(theme.transitions.duration.shorter, "ms")
	    },
	
	    /* Styles applied to the internal `Ripple` components `child` class. */
	    child: {
	      opacity: 1,
	      display: 'block',
	      width: '100%',
	      height: '100%',
	      borderRadius: '50%',
	      backgroundColor: 'currentColor'
	    },
	
	    /* Styles applied to the internal `Ripple` components `childLeaving` class. */
	    childLeaving: {
	      opacity: 0,
	      animation: "$exit ".concat(DURATION, "ms ").concat(theme.transitions.easing.easeInOut)
	    },
	
	    /* Styles applied to the internal `Ripple` components `childPulsate` class. */
	    childPulsate: {
	      position: 'absolute',
	      left: 0,
	      top: 0,
	      animation: "$pulsate 2500ms ".concat(theme.transitions.easing.easeInOut, " 200ms infinite")
	    },
	    '@keyframes enter': {
	      '0%': {
	        transform: 'scale(0)',
	        opacity: 0.1
	      },
	      '100%': {
	        transform: 'scale(1)',
	        opacity: 0.3
	      }
	    },
	    '@keyframes exit': {
	      '0%': {
	        opacity: 1
	      },
	      '100%': {
	        opacity: 0
	      }
	    },
	    '@keyframes pulsate': {
	      '0%': {
	        transform: 'scale(1)'
	      },
	      '50%': {
	        transform: 'scale(0.92)'
	      },
	      '100%': {
	        transform: 'scale(1)'
	      }
	    }
	  };
	};
	/**
	 * @ignore - internal component.
	 *
	 * TODO v5: Make private
	 */
	
	
	exports.styles = styles;
	var TouchRipple = /*#__PURE__*/React.forwardRef(function TouchRipple(props, ref) {
	  var _props$center = props.center,
	      centerProp = _props$center === void 0 ? false : _props$center,
	      classes = props.classes,
	      className = props.className,
	      other = (0, _objectWithoutProperties2.default)(props, ["center", "classes", "className"]);
	
	  var _React$useState = React.useState([]),
	      ripples = _React$useState[0],
	      setRipples = _React$useState[1];
	
	  var nextKey = React.useRef(0);
	  var rippleCallback = React.useRef(null);
	  React.useEffect(function () {
	    if (rippleCallback.current) {
	      rippleCallback.current();
	      rippleCallback.current = null;
	    }
	  }, [ripples]); // Used to filter out mouse emulated events on mobile.
	
	  var ignoringMouseDown = React.useRef(false); // We use a timer in order to only show the ripples for touch "click" like events.
	  // We don't want to display the ripple for touch scroll events.
	
	  var startTimer = React.useRef(null); // This is the hook called once the previous timeout is ready.
	
	  var startTimerCommit = React.useRef(null);
	  var container = React.useRef(null);
	  React.useEffect(function () {
	    return function () {
	      clearTimeout(startTimer.current);
	    };
	  }, []);
	  var startCommit = React.useCallback(function (params) {
	    var pulsate = params.pulsate,
	        rippleX = params.rippleX,
	        rippleY = params.rippleY,
	        rippleSize = params.rippleSize,
	        cb = params.cb;
	    setRipples(function (oldRipples) {
	      return [].concat((0, _toConsumableArray2.default)(oldRipples), [/*#__PURE__*/React.createElement(_Ripple.default, {
	        key: nextKey.current,
	        classes: classes,
	        timeout: DURATION,
	        pulsate: pulsate,
	        rippleX: rippleX,
	        rippleY: rippleY,
	        rippleSize: rippleSize
	      })]);
	    });
	    nextKey.current += 1;
	    rippleCallback.current = cb;
	  }, [classes]);
	  var start = React.useCallback(function () {
	    var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var cb = arguments.length > 2 ? arguments[2] : undefined;
	    var _options$pulsate = options.pulsate,
	        pulsate = _options$pulsate === void 0 ? false : _options$pulsate,
	        _options$center = options.center,
	        center = _options$center === void 0 ? centerProp || options.pulsate : _options$center,
	        _options$fakeElement = options.fakeElement,
	        fakeElement = _options$fakeElement === void 0 ? false : _options$fakeElement;
	
	    if (event.type === 'mousedown' && ignoringMouseDown.current) {
	      ignoringMouseDown.current = false;
	      return;
	    }
	
	    if (event.type === 'touchstart') {
	      ignoringMouseDown.current = true;
	    }
	
	    var element = fakeElement ? null : container.current;
	    var rect = element ? element.getBoundingClientRect() : {
	      width: 0,
	      height: 0,
	      left: 0,
	      top: 0
	    }; // Get the size of the ripple
	
	    var rippleX;
	    var rippleY;
	    var rippleSize;
	
	    if (center || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
	      rippleX = Math.round(rect.width / 2);
	      rippleY = Math.round(rect.height / 2);
	    } else {
	      var _ref = event.touches ? event.touches[0] : event,
	          clientX = _ref.clientX,
	          clientY = _ref.clientY;
	
	      rippleX = Math.round(clientX - rect.left);
	      rippleY = Math.round(clientY - rect.top);
	    }
	
	    if (center) {
	      rippleSize = Math.sqrt((2 * Math.pow(rect.width, 2) + Math.pow(rect.height, 2)) / 3); // For some reason the animation is broken on Mobile Chrome if the size if even.
	
	      if (rippleSize % 2 === 0) {
	        rippleSize += 1;
	      }
	    } else {
	      var sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
	      var sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
	      rippleSize = Math.sqrt(Math.pow(sizeX, 2) + Math.pow(sizeY, 2));
	    } // Touche devices
	
	
	    if (event.touches) {
	      // check that this isn't another touchstart due to multitouch
	      // otherwise we will only clear a single timer when unmounting while two
	      // are running
	      if (startTimerCommit.current === null) {
	        // Prepare the ripple effect.
	        startTimerCommit.current = function () {
	          startCommit({
	            pulsate: pulsate,
	            rippleX: rippleX,
	            rippleY: rippleY,
	            rippleSize: rippleSize,
	            cb: cb
	          });
	        }; // Delay the execution of the ripple effect.
	
	
	        startTimer.current = setTimeout(function () {
	          if (startTimerCommit.current) {
	            startTimerCommit.current();
	            startTimerCommit.current = null;
	          }
	        }, DELAY_RIPPLE); // We have to make a tradeoff with this value.
	      }
	    } else {
	      startCommit({
	        pulsate: pulsate,
	        rippleX: rippleX,
	        rippleY: rippleY,
	        rippleSize: rippleSize,
	        cb: cb
	      });
	    }
	  }, [centerProp, startCommit]);
	  var pulsate = React.useCallback(function () {
	    start({}, {
	      pulsate: true
	    });
	  }, [start]);
	  var stop = React.useCallback(function (event, cb) {
	    clearTimeout(startTimer.current); // The touch interaction occurs too quickly.
	    // We still want to show ripple effect.
	
	    if (event.type === 'touchend' && startTimerCommit.current) {
	      event.persist();
	      startTimerCommit.current();
	      startTimerCommit.current = null;
	      startTimer.current = setTimeout(function () {
	        stop(event, cb);
	      });
	      return;
	    }
	
	    startTimerCommit.current = null;
	    setRipples(function (oldRipples) {
	      if (oldRipples.length > 0) {
	        return oldRipples.slice(1);
	      }
	
	      return oldRipples;
	    });
	    rippleCallback.current = cb;
	  }, []);
	  React.useImperativeHandle(ref, function () {
	    return {
	      pulsate: pulsate,
	      start: start,
	      stop: stop
	    };
	  }, [pulsate, start, stop]);
	  return /*#__PURE__*/React.createElement("span", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className),
	    ref: container
	  }, other), /*#__PURE__*/React.createElement(_reactTransitionGroup.TransitionGroup, {
	    component: null,
	    exit: true
	  }, ripples));
	});
	 false ? TouchRipple.propTypes = {
	  /**
	   * If `true`, the ripple starts at the center of the component
	   * rather than at the point of interaction.
	   */
	  center: _propTypes.default.bool,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  flip: false,
	  name: 'MuiTouchRipple'
	})( /*#__PURE__*/React.memo(TouchRipple));
	
	exports.default = _default;

/***/ },
/* 710 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(25));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(37));
	
	var _Cancel = _interopRequireDefault(__webpack_require__(765));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(41));
	
	var _colorManipulator = __webpack_require__(177);
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(68));
	
	var _unsupportedProp = _interopRequireDefault(__webpack_require__(331));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(78));
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(319));
	
	var styles = function styles(theme) {
	  var backgroundColor = theme.palette.type === 'light' ? theme.palette.grey[300] : theme.palette.grey[700];
	  var deleteIconColor = (0, _colorManipulator.alpha)(theme.palette.text.primary, 0.26);
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      fontFamily: theme.typography.fontFamily,
	      fontSize: theme.typography.pxToRem(13),
	      display: 'inline-flex',
	      alignItems: 'center',
	      justifyContent: 'center',
	      height: 32,
	      color: theme.palette.getContrastText(backgroundColor),
	      backgroundColor: backgroundColor,
	      borderRadius: 32 / 2,
	      whiteSpace: 'nowrap',
	      transition: theme.transitions.create(['background-color', 'box-shadow']),
	      // label will inherit this from root, then `clickable` class overrides this for both
	      cursor: 'default',
	      // We disable the focus ring for mouse, touch and keyboard users.
	      outline: 0,
	      textDecoration: 'none',
	      border: 'none',
	      // Remove `button` border
	      padding: 0,
	      // Remove `button` padding
	      verticalAlign: 'middle',
	      boxSizing: 'border-box',
	      '&$disabled': {
	        opacity: 0.5,
	        pointerEvents: 'none'
	      },
	      '& $avatar': {
	        marginLeft: 5,
	        marginRight: -6,
	        width: 24,
	        height: 24,
	        color: theme.palette.type === 'light' ? theme.palette.grey[700] : theme.palette.grey[300],
	        fontSize: theme.typography.pxToRem(12)
	      },
	      '& $avatarColorPrimary': {
	        color: theme.palette.primary.contrastText,
	        backgroundColor: theme.palette.primary.dark
	      },
	      '& $avatarColorSecondary': {
	        color: theme.palette.secondary.contrastText,
	        backgroundColor: theme.palette.secondary.dark
	      },
	      '& $avatarSmall': {
	        marginLeft: 4,
	        marginRight: -4,
	        width: 18,
	        height: 18,
	        fontSize: theme.typography.pxToRem(10)
	      }
	    },
	
	    /* Styles applied to the root element if `size="small"`. */
	    sizeSmall: {
	      height: 24
	    },
	
	    /* Styles applied to the root element if `color="primary"`. */
	    colorPrimary: {
	      backgroundColor: theme.palette.primary.main,
	      color: theme.palette.primary.contrastText
	    },
	
	    /* Styles applied to the root element if `color="secondary"`. */
	    colorSecondary: {
	      backgroundColor: theme.palette.secondary.main,
	      color: theme.palette.secondary.contrastText
	    },
	
	    /* Pseudo-class applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the root element if `onClick` is defined or `clickable={true}`. */
	    clickable: {
	      userSelect: 'none',
	      WebkitTapHighlightColor: 'transparent',
	      cursor: 'pointer',
	      '&:hover, &:focus': {
	        backgroundColor: (0, _colorManipulator.emphasize)(backgroundColor, 0.08)
	      },
	      '&:active': {
	        boxShadow: theme.shadows[1]
	      }
	    },
	
	    /* Styles applied to the root element if `onClick` and `color="primary"` is defined or `clickable={true}`. */
	    clickableColorPrimary: {
	      '&:hover, &:focus': {
	        backgroundColor: (0, _colorManipulator.emphasize)(theme.palette.primary.main, 0.08)
	      }
	    },
	
	    /* Styles applied to the root element if `onClick` and `color="secondary"` is defined or `clickable={true}`. */
	    clickableColorSecondary: {
	      '&:hover, &:focus': {
	        backgroundColor: (0, _colorManipulator.emphasize)(theme.palette.secondary.main, 0.08)
	      }
	    },
	
	    /* Styles applied to the root element if `onDelete` is defined. */
	    deletable: {
	      '&:focus': {
	        backgroundColor: (0, _colorManipulator.emphasize)(backgroundColor, 0.08)
	      }
	    },
	
	    /* Styles applied to the root element if `onDelete` and `color="primary"` is defined. */
	    deletableColorPrimary: {
	      '&:focus': {
	        backgroundColor: (0, _colorManipulator.emphasize)(theme.palette.primary.main, 0.2)
	      }
	    },
	
	    /* Styles applied to the root element if `onDelete` and `color="secondary"` is defined. */
	    deletableColorSecondary: {
	      '&:focus': {
	        backgroundColor: (0, _colorManipulator.emphasize)(theme.palette.secondary.main, 0.2)
	      }
	    },
	
	    /* Styles applied to the root element if `variant="outlined"`. */
	    outlined: {
	      backgroundColor: 'transparent',
	      border: "1px solid ".concat(theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'),
	      '$clickable&:hover, $clickable&:focus, $deletable&:focus': {
	        backgroundColor: (0, _colorManipulator.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity)
	      },
	      '& $avatar': {
	        marginLeft: 4
	      },
	      '& $avatarSmall': {
	        marginLeft: 2
	      },
	      '& $icon': {
	        marginLeft: 4
	      },
	      '& $iconSmall': {
	        marginLeft: 2
	      },
	      '& $deleteIcon': {
	        marginRight: 5
	      },
	      '& $deleteIconSmall': {
	        marginRight: 3
	      }
	    },
	
	    /* Styles applied to the root element if `variant="outlined"` and `color="primary"`. */
	    outlinedPrimary: {
	      color: theme.palette.primary.main,
	      border: "1px solid ".concat(theme.palette.primary.main),
	      '$clickable&:hover, $clickable&:focus, $deletable&:focus': {
	        backgroundColor: (0, _colorManipulator.alpha)(theme.palette.primary.main, theme.palette.action.hoverOpacity)
	      }
	    },
	
	    /* Styles applied to the root element if `variant="outlined"` and `color="secondary"`. */
	    outlinedSecondary: {
	      color: theme.palette.secondary.main,
	      border: "1px solid ".concat(theme.palette.secondary.main),
	      '$clickable&:hover, $clickable&:focus, $deletable&:focus': {
	        backgroundColor: (0, _colorManipulator.alpha)(theme.palette.secondary.main, theme.palette.action.hoverOpacity)
	      }
	    },
	    // TODO v5: remove
	
	    /* Styles applied to the `avatar` element. */
	    avatar: {},
	
	    /* Styles applied to the `avatar` element if `size="small"`. */
	    avatarSmall: {},
	
	    /* Styles applied to the `avatar` element if `color="primary"`. */
	    avatarColorPrimary: {},
	
	    /* Styles applied to the `avatar` element if `color="secondary"`. */
	    avatarColorSecondary: {},
	
	    /* Styles applied to the `icon` element. */
	    icon: {
	      color: theme.palette.type === 'light' ? theme.palette.grey[700] : theme.palette.grey[300],
	      marginLeft: 5,
	      marginRight: -6
	    },
	
	    /* Styles applied to the `icon` element if `size="small"`. */
	    iconSmall: {
	      width: 18,
	      height: 18,
	      marginLeft: 4,
	      marginRight: -4
	    },
	
	    /* Styles applied to the `icon` element if `color="primary"`. */
	    iconColorPrimary: {
	      color: 'inherit'
	    },
	
	    /* Styles applied to the `icon` element if `color="secondary"`. */
	    iconColorSecondary: {
	      color: 'inherit'
	    },
	
	    /* Styles applied to the label `span` element. */
	    label: {
	      overflow: 'hidden',
	      textOverflow: 'ellipsis',
	      paddingLeft: 12,
	      paddingRight: 12,
	      whiteSpace: 'nowrap'
	    },
	
	    /* Styles applied to the label `span` element if `size="small"`. */
	    labelSmall: {
	      paddingLeft: 8,
	      paddingRight: 8
	    },
	
	    /* Styles applied to the `deleteIcon` element. */
	    deleteIcon: {
	      WebkitTapHighlightColor: 'transparent',
	      color: deleteIconColor,
	      height: 22,
	      width: 22,
	      cursor: 'pointer',
	      margin: '0 5px 0 -6px',
	      '&:hover': {
	        color: (0, _colorManipulator.alpha)(deleteIconColor, 0.4)
	      }
	    },
	
	    /* Styles applied to the `deleteIcon` element if `size="small"`. */
	    deleteIconSmall: {
	      height: 16,
	      width: 16,
	      marginRight: 4,
	      marginLeft: -4
	    },
	
	    /* Styles applied to the deleteIcon element if `color="primary"` and `variant="default"`. */
	    deleteIconColorPrimary: {
	      color: (0, _colorManipulator.alpha)(theme.palette.primary.contrastText, 0.7),
	      '&:hover, &:active': {
	        color: theme.palette.primary.contrastText
	      }
	    },
	
	    /* Styles applied to the deleteIcon element if `color="secondary"` and `variant="default"`. */
	    deleteIconColorSecondary: {
	      color: (0, _colorManipulator.alpha)(theme.palette.secondary.contrastText, 0.7),
	      '&:hover, &:active': {
	        color: theme.palette.secondary.contrastText
	      }
	    },
	
	    /* Styles applied to the deleteIcon element if `color="primary"` and `variant="outlined"`. */
	    deleteIconOutlinedColorPrimary: {
	      color: (0, _colorManipulator.alpha)(theme.palette.primary.main, 0.7),
	      '&:hover, &:active': {
	        color: theme.palette.primary.main
	      }
	    },
	
	    /* Styles applied to the deleteIcon element if `color="secondary"` and `variant="outlined"`. */
	    deleteIconOutlinedColorSecondary: {
	      color: (0, _colorManipulator.alpha)(theme.palette.secondary.main, 0.7),
	      '&:hover, &:active': {
	        color: theme.palette.secondary.main
	      }
	    }
	  };
	};
	
	exports.styles = styles;
	
	function isDeleteKeyboardEvent(keyboardEvent) {
	  return keyboardEvent.key === 'Backspace' || keyboardEvent.key === 'Delete';
	}
	/**
	 * Chips represent complex entities in small blocks, such as a contact.
	 */
	
	
	var Chip = /*#__PURE__*/React.forwardRef(function Chip(props, ref) {
	  var avatarProp = props.avatar,
	      classes = props.classes,
	      className = props.className,
	      clickableProp = props.clickable,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'default' : _props$color,
	      ComponentProp = props.component,
	      deleteIconProp = props.deleteIcon,
	      _props$disabled = props.disabled,
	      disabled = _props$disabled === void 0 ? false : _props$disabled,
	      iconProp = props.icon,
	      label = props.label,
	      onClick = props.onClick,
	      onDelete = props.onDelete,
	      onKeyDown = props.onKeyDown,
	      onKeyUp = props.onKeyUp,
	      _props$size = props.size,
	      size = _props$size === void 0 ? 'medium' : _props$size,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'default' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["avatar", "classes", "className", "clickable", "color", "component", "deleteIcon", "disabled", "icon", "label", "onClick", "onDelete", "onKeyDown", "onKeyUp", "size", "variant"]);
	  var chipRef = React.useRef(null);
	  var handleRef = (0, _useForkRef.default)(chipRef, ref);
	
	  var handleDeleteIconClick = function handleDeleteIconClick(event) {
	    // Stop the event from bubbling up to the `Chip`
	    event.stopPropagation();
	
	    if (onDelete) {
	      onDelete(event);
	    }
	  };
	
	  var handleKeyDown = function handleKeyDown(event) {
	    // Ignore events from children of `Chip`.
	    if (event.currentTarget === event.target && isDeleteKeyboardEvent(event)) {
	      // will be handled in keyUp, otherwise some browsers
	      // might init navigation
	      event.preventDefault();
	    }
	
	    if (onKeyDown) {
	      onKeyDown(event);
	    }
	  };
	
	  var handleKeyUp = function handleKeyUp(event) {
	    // Ignore events from children of `Chip`.
	    if (event.currentTarget === event.target) {
	      if (onDelete && isDeleteKeyboardEvent(event)) {
	        onDelete(event);
	      } else if (event.key === 'Escape' && chipRef.current) {
	        chipRef.current.blur();
	      }
	    }
	
	    if (onKeyUp) {
	      onKeyUp(event);
	    }
	  };
	
	  var clickable = clickableProp !== false && onClick ? true : clickableProp;
	  var small = size === 'small';
	  var Component = ComponentProp || (clickable ? _ButtonBase.default : 'div');
	  var moreProps = Component === _ButtonBase.default ? {
	    component: 'div'
	  } : {};
	  var deleteIcon = null;
	
	  if (onDelete) {
	    var customClasses = (0, _clsx.default)(color !== 'default' && (variant === "default" ? classes["deleteIconColor".concat((0, _capitalize.default)(color))] : classes["deleteIconOutlinedColor".concat((0, _capitalize.default)(color))]), small && classes.deleteIconSmall);
	    deleteIcon = deleteIconProp && /*#__PURE__*/React.isValidElement(deleteIconProp) ? /*#__PURE__*/React.cloneElement(deleteIconProp, {
	      className: (0, _clsx.default)(deleteIconProp.props.className, classes.deleteIcon, customClasses),
	      onClick: handleDeleteIconClick
	    }) : /*#__PURE__*/React.createElement(_Cancel.default, {
	      className: (0, _clsx.default)(classes.deleteIcon, customClasses),
	      onClick: handleDeleteIconClick
	    });
	  }
	
	  var avatar = null;
	
	  if (avatarProp && /*#__PURE__*/React.isValidElement(avatarProp)) {
	    avatar = /*#__PURE__*/React.cloneElement(avatarProp, {
	      className: (0, _clsx.default)(classes.avatar, avatarProp.props.className, small && classes.avatarSmall, color !== 'default' && classes["avatarColor".concat((0, _capitalize.default)(color))])
	    });
	  }
	
	  var icon = null;
	
	  if (iconProp && /*#__PURE__*/React.isValidElement(iconProp)) {
	    icon = /*#__PURE__*/React.cloneElement(iconProp, {
	      className: (0, _clsx.default)(classes.icon, iconProp.props.className, small && classes.iconSmall, color !== 'default' && classes["iconColor".concat((0, _capitalize.default)(color))])
	    });
	  }
	
	  if (false) {
	    if (avatar && icon) {
	      console.error('Material-UI: The Chip component can not handle the avatar ' + 'and the icon prop at the same time. Pick one.');
	    }
	  }
	
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    role: clickable || onDelete ? 'button' : undefined,
	    className: (0, _clsx.default)(classes.root, className, color !== 'default' && [classes["color".concat((0, _capitalize.default)(color))], clickable && classes["clickableColor".concat((0, _capitalize.default)(color))], onDelete && classes["deletableColor".concat((0, _capitalize.default)(color))]], variant !== "default" && [classes.outlined, {
	      'primary': classes.outlinedPrimary,
	      'secondary': classes.outlinedSecondary
	    }[color]], disabled && classes.disabled, small && classes.sizeSmall, clickable && classes.clickable, onDelete && classes.deletable),
	    "aria-disabled": disabled ? true : undefined,
	    tabIndex: clickable || onDelete ? 0 : undefined,
	    onClick: onClick,
	    onKeyDown: handleKeyDown,
	    onKeyUp: handleKeyUp,
	    ref: handleRef
	  }, moreProps, other), avatar || icon, /*#__PURE__*/React.createElement("span", {
	    className: (0, _clsx.default)(classes.label, small && classes.labelSmall)
	  }, label), deleteIcon);
	});
	 false ? Chip.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * Avatar element.
	   */
	  avatar: _propTypes.default.element,
	
	  /**
	   * This prop isn't supported.
	   * Use the `component` prop if you need to change the children structure.
	   */
	  children: _unsupportedProp.default,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, the chip will appear clickable, and will raise when pressed,
	   * even if the onClick prop is not defined.
	   * If false, the chip will not be clickable, even if onClick prop is defined.
	   * This can be used, for example,
	   * along with the component prop to indicate an anchor Chip is clickable.
	   */
	  clickable: _propTypes.default.bool,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['default', 'primary', 'secondary']),
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .elementType,
	
	  /**
	   * Override the default delete icon element. Shown only if `onDelete` is set.
	   */
	  deleteIcon: _propTypes.default.element,
	
	  /**
	   * If `true`, the chip should be displayed in a disabled state.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * Icon element.
	   */
	  icon: _propTypes.default.element,
	
	  /**
	   * The content of the label.
	   */
	  label: _propTypes.default.node,
	
	  /**
	   * @ignore
	   */
	  onClick: _propTypes.default.func,
	
	  /**
	   * Callback function fired when the delete icon is clicked.
	   * If set, the delete icon will be shown.
	   */
	  onDelete: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onKeyDown: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onKeyUp: _propTypes.default.func,
	
	  /**
	   * The size of the chip.
	   */
	  size: _propTypes.default.oneOf(['medium', 'small']),
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['default', 'outlined'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiChip'
	})(Chip);
	
	exports.default = _default;

/***/ },
/* 711 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Chip.default;
	  }
	});
	
	var _Chip = _interopRequireDefault(__webpack_require__(710));

/***/ },
/* 712 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(25));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(37));
	
	var _utils = __webpack_require__(26);
	
	var _InputBase = _interopRequireDefault(__webpack_require__(232));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(41));
	
	var styles = function styles(theme) {
	  var light = theme.palette.type === 'light';
	  var bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
	  var backgroundColor = light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.09)';
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      position: 'relative',
	      backgroundColor: backgroundColor,
	      borderTopLeftRadius: theme.shape.borderRadius,
	      borderTopRightRadius: theme.shape.borderRadius,
	      transition: theme.transitions.create('background-color', {
	        duration: theme.transitions.duration.shorter,
	        easing: theme.transitions.easing.easeOut
	      }),
	      '&:hover': {
	        backgroundColor: light ? 'rgba(0, 0, 0, 0.13)' : 'rgba(255, 255, 255, 0.13)',
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: backgroundColor
	        }
	      },
	      '&$focused': {
	        backgroundColor: light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.09)'
	      },
	      '&$disabled': {
	        backgroundColor: light ? 'rgba(0, 0, 0, 0.12)' : 'rgba(255, 255, 255, 0.12)'
	      }
	    },
	
	    /* Styles applied to the root element if color secondary. */
	    colorSecondary: {
	      '&$underline:after': {
	        borderBottomColor: theme.palette.secondary.main
	      }
	    },
	
	    /* Styles applied to the root element if `disableUnderline={false}`. */
	    underline: {
	      '&:after': {
	        borderBottom: "2px solid ".concat(theme.palette.primary.main),
	        left: 0,
	        bottom: 0,
	        // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
	        content: '""',
	        position: 'absolute',
	        right: 0,
	        transform: 'scaleX(0)',
	        transition: theme.transitions.create('transform', {
	          duration: theme.transitions.duration.shorter,
	          easing: theme.transitions.easing.easeOut
	        }),
	        pointerEvents: 'none' // Transparent to the hover style.
	
	      },
	      '&$focused:after': {
	        transform: 'scaleX(1)'
	      },
	      '&$error:after': {
	        borderBottomColor: theme.palette.error.main,
	        transform: 'scaleX(1)' // error is always underlined in red
	
	      },
	      '&:before': {
	        borderBottom: "1px solid ".concat(bottomLineColor),
	        left: 0,
	        bottom: 0,
	        // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
	        content: '"\\00a0"',
	        position: 'absolute',
	        right: 0,
	        transition: theme.transitions.create('border-bottom-color', {
	          duration: theme.transitions.duration.shorter
	        }),
	        pointerEvents: 'none' // Transparent to the hover style.
	
	      },
	      '&:hover:before': {
	        borderBottom: "1px solid ".concat(theme.palette.text.primary)
	      },
	      '&$disabled:before': {
	        borderBottomStyle: 'dotted'
	      }
	    },
	
	    /* Pseudo-class applied to the root element if the component is focused. */
	    focused: {},
	
	    /* Pseudo-class applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the root element if `startAdornment` is provided. */
	    adornedStart: {
	      paddingLeft: 12
	    },
	
	    /* Styles applied to the root element if `endAdornment` is provided. */
	    adornedEnd: {
	      paddingRight: 12
	    },
	
	    /* Pseudo-class applied to the root element if `error={true}`. */
	    error: {},
	
	    /* Styles applied to the `input` element if `margin="dense"`. */
	    marginDense: {},
	
	    /* Styles applied to the root element if `multiline={true}`. */
	    multiline: {
	      padding: '27px 12px 10px',
	      '&$marginDense': {
	        paddingTop: 23,
	        paddingBottom: 6
	      }
	    },
	
	    /* Styles applied to the `input` element. */
	    input: {
	      padding: '27px 12px 10px',
	      '&:-webkit-autofill': {
	        WebkitBoxShadow: theme.palette.type === 'light' ? null : '0 0 0 100px #266798 inset',
	        WebkitTextFillColor: theme.palette.type === 'light' ? null : '#fff',
	        caretColor: theme.palette.type === 'light' ? null : '#fff',
	        borderTopLeftRadius: 'inherit',
	        borderTopRightRadius: 'inherit'
	      }
	    },
	
	    /* Styles applied to the `input` element if `margin="dense"`. */
	    inputMarginDense: {
	      paddingTop: 23,
	      paddingBottom: 6
	    },
	
	    /* Styles applied to the `input` if in `<FormControl hiddenLabel />`. */
	    inputHiddenLabel: {
	      paddingTop: 18,
	      paddingBottom: 19,
	      '&$inputMarginDense': {
	        paddingTop: 10,
	        paddingBottom: 11
	      }
	    },
	
	    /* Styles applied to the `input` element if `multiline={true}`. */
	    inputMultiline: {
	      padding: 0
	    },
	
	    /* Styles applied to the `input` element if `startAdornment` is provided. */
	    inputAdornedStart: {
	      paddingLeft: 0
	    },
	
	    /* Styles applied to the `input` element if `endAdornment` is provided. */
	    inputAdornedEnd: {
	      paddingRight: 0
	    }
	  };
	};
	
	exports.styles = styles;
	var FilledInput = /*#__PURE__*/React.forwardRef(function FilledInput(props, ref) {
	  var disableUnderline = props.disableUnderline,
	      classes = props.classes,
	      _props$fullWidth = props.fullWidth,
	      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
	      _props$inputComponent = props.inputComponent,
	      inputComponent = _props$inputComponent === void 0 ? 'input' : _props$inputComponent,
	      _props$multiline = props.multiline,
	      multiline = _props$multiline === void 0 ? false : _props$multiline,
	      _props$type = props.type,
	      type = _props$type === void 0 ? 'text' : _props$type,
	      other = (0, _objectWithoutProperties2.default)(props, ["disableUnderline", "classes", "fullWidth", "inputComponent", "multiline", "type"]);
	  return /*#__PURE__*/React.createElement(_InputBase.default, (0, _extends2.default)({
	    classes: (0, _extends2.default)({}, classes, {
	      root: (0, _clsx.default)(classes.root, !disableUnderline && classes.underline),
	      underline: null
	    }),
	    fullWidth: fullWidth,
	    inputComponent: inputComponent,
	    multiline: multiline,
	    ref: ref,
	    type: type
	  }, other));
	});
	 false ? FilledInput.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * This prop helps users to fill forms faster, especially on mobile devices.
	   * The name can be confusing, as it's more like an autofill.
	   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
	   */
	  autoComplete: _propTypes.default.string,
	
	  /**
	   * If `true`, the `input` element will be focused during the first mount.
	   */
	  autoFocus: _propTypes.default.bool,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['primary', 'secondary']),
	
	  /**
	   * The default `input` element value. Use when the component is not controlled.
	   */
	  defaultValue: _propTypes.default.any,
	
	  /**
	   * If `true`, the `input` element will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the input will not have an underline.
	   */
	  disableUnderline: _propTypes.default.bool,
	
	  /**
	   * End `InputAdornment` for this component.
	   */
	  endAdornment: _propTypes.default.node,
	
	  /**
	   * If `true`, the input will indicate an error. This is normally obtained via context from
	   * FormControl.
	   */
	  error: _propTypes.default.bool,
	
	  /**
	   * If `true`, the input will take up the full width of its container.
	   */
	  fullWidth: _propTypes.default.bool,
	
	  /**
	   * The id of the `input` element.
	   */
	  id: _propTypes.default.string,
	
	  /**
	   * The component used for the `input` element.
	   * Either a string to use a HTML element or a component.
	   */
	  inputComponent: _propTypes.default.elementType,
	
	  /**
	   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
	   */
	  inputProps: _propTypes.default.object,
	
	  /**
	   * Pass a ref to the `input` element.
	   */
	  inputRef: _utils.refType,
	
	  /**
	   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
	   * FormControl.
	   */
	  margin: _propTypes.default.oneOf(['dense', 'none']),
	
	  /**
	   * Maximum number of rows to display when multiline option is set to true.
	   */
	  maxRows: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * If `true`, a textarea element will be rendered.
	   */
	  multiline: _propTypes.default.bool,
	
	  /**
	   * Name attribute of the `input` element.
	   */
	  name: _propTypes.default.string,
	
	  /**
	   * Callback fired when the value is changed.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new value by accessing `event.target.value` (string).
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * The short hint displayed in the input before the user enters a value.
	   */
	  placeholder: _propTypes.default.string,
	
	  /**
	   * It prevents the user from changing the value of the field
	   * (not from interacting with the field).
	   */
	  readOnly: _propTypes.default.bool,
	
	  /**
	   * If `true`, the `input` element will be required.
	   */
	  required: _propTypes.default.bool,
	
	  /**
	   * Number of rows to display when multiline option is set to true.
	   */
	  rows: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * Start `InputAdornment` for this component.
	   */
	  startAdornment: _propTypes.default.node,
	
	  /**
	   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
	   */
	  type: _propTypes.default.string,
	
	  /**
	   * The value of the `input` element, required for a controlled component.
	   */
	  value: _propTypes.default.any
	} : void 0;
	FilledInput.muiName = 'Input';
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiFilledInput'
	})(FilledInput);
	
	exports.default = _default;

/***/ },
/* 713 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(25));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(37));
	
	var _utils = __webpack_require__(233);
	
	var _withStyles = _interopRequireDefault(__webpack_require__(41));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(78));
	
	var _isMuiElement = _interopRequireDefault(__webpack_require__(330));
	
	var _FormControlContext = _interopRequireDefault(__webpack_require__(230));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    display: 'inline-flex',
	    flexDirection: 'column',
	    position: 'relative',
	    // Reset fieldset default style.
	    minWidth: 0,
	    padding: 0,
	    margin: 0,
	    border: 0,
	    verticalAlign: 'top' // Fix alignment issue on Safari.
	
	  },
	
	  /* Styles applied to the root element if `margin="normal"`. */
	  marginNormal: {
	    marginTop: 16,
	    marginBottom: 8
	  },
	
	  /* Styles applied to the root element if `margin="dense"`. */
	  marginDense: {
	    marginTop: 8,
	    marginBottom: 4
	  },
	
	  /* Styles applied to the root element if `fullWidth={true}`. */
	  fullWidth: {
	    width: '100%'
	  }
	};
	/**
	 * Provides context such as filled/focused/error/required for form inputs.
	 * Relying on the context provides high flexibility and ensures that the state always stays
	 * consistent across the children of the `FormControl`.
	 * This context is used by the following components:
	 *
	 *  - FormLabel
	 *  - FormHelperText
	 *  - Input
	 *  - InputLabel
	 *
	 * You can find one composition example below and more going to [the demos](/components/text-fields/#components).
	 *
	 * ```jsx
	 * <FormControl>
	 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
	 *   <Input id="my-input" aria-describedby="my-helper-text" />
	 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
	 * </FormControl>
	 * ```
	 *
	 * ⚠️Only one input can be used within a FormControl.
	 */
	
	exports.styles = styles;
	var FormControl = /*#__PURE__*/React.forwardRef(function FormControl(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'primary' : _props$color,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'div' : _props$component,
	      _props$disabled = props.disabled,
	      disabled = _props$disabled === void 0 ? false : _props$disabled,
	      _props$error = props.error,
	      error = _props$error === void 0 ? false : _props$error,
	      _props$fullWidth = props.fullWidth,
	      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
	      visuallyFocused = props.focused,
	      _props$hiddenLabel = props.hiddenLabel,
	      hiddenLabel = _props$hiddenLabel === void 0 ? false : _props$hiddenLabel,
	      _props$margin = props.margin,
	      margin = _props$margin === void 0 ? 'none' : _props$margin,
	      _props$required = props.required,
	      required = _props$required === void 0 ? false : _props$required,
	      size = props.size,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'standard' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "color", "component", "disabled", "error", "fullWidth", "focused", "hiddenLabel", "margin", "required", "size", "variant"]);
	
	  var _React$useState = React.useState(function () {
	    // We need to iterate through the children and find the Input in order
	    // to fully support server-side rendering.
	    var initialAdornedStart = false;
	
	    if (children) {
	      React.Children.forEach(children, function (child) {
	        if (!(0, _isMuiElement.default)(child, ['Input', 'Select'])) {
	          return;
	        }
	
	        var input = (0, _isMuiElement.default)(child, ['Select']) ? child.props.input : child;
	
	        if (input && (0, _utils.isAdornedStart)(input.props)) {
	          initialAdornedStart = true;
	        }
	      });
	    }
	
	    return initialAdornedStart;
	  }),
	      adornedStart = _React$useState[0],
	      setAdornedStart = _React$useState[1];
	
	  var _React$useState2 = React.useState(function () {
	    // We need to iterate through the children and find the Input in order
	    // to fully support server-side rendering.
	    var initialFilled = false;
	
	    if (children) {
	      React.Children.forEach(children, function (child) {
	        if (!(0, _isMuiElement.default)(child, ['Input', 'Select'])) {
	          return;
	        }
	
	        if ((0, _utils.isFilled)(child.props, true)) {
	          initialFilled = true;
	        }
	      });
	    }
	
	    return initialFilled;
	  }),
	      filled = _React$useState2[0],
	      setFilled = _React$useState2[1];
	
	  var _React$useState3 = React.useState(false),
	      _focused = _React$useState3[0],
	      setFocused = _React$useState3[1];
	
	  var focused = visuallyFocused !== undefined ? visuallyFocused : _focused;
	
	  if (disabled && focused) {
	    setFocused(false);
	  }
	
	  var registerEffect;
	
	  if (false) {
	    // eslint-disable-next-line react-hooks/rules-of-hooks
	    var registeredInput = React.useRef(false);
	
	    registerEffect = function registerEffect() {
	      if (registeredInput.current) {
	        console.error(['Material-UI: There are multiple InputBase components inside a FormControl.', 'This is not supported. It might cause infinite rendering loops.', 'Only use one InputBase.'].join('\n'));
	      }
	
	      registeredInput.current = true;
	      return function () {
	        registeredInput.current = false;
	      };
	    };
	  }
	
	  var onFilled = React.useCallback(function () {
	    setFilled(true);
	  }, []);
	  var onEmpty = React.useCallback(function () {
	    setFilled(false);
	  }, []);
	  var childContext = {
	    adornedStart: adornedStart,
	    setAdornedStart: setAdornedStart,
	    color: color,
	    disabled: disabled,
	    error: error,
	    filled: filled,
	    focused: focused,
	    fullWidth: fullWidth,
	    hiddenLabel: hiddenLabel,
	    margin: (size === 'small' ? 'dense' : undefined) || margin,
	    onBlur: function onBlur() {
	      setFocused(false);
	    },
	    onEmpty: onEmpty,
	    onFilled: onFilled,
	    onFocus: function onFocus() {
	      setFocused(true);
	    },
	    registerEffect: registerEffect,
	    required: required,
	    variant: variant
	  };
	  return /*#__PURE__*/React.createElement(_FormControlContext.default.Provider, {
	    value: childContext
	  }, /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, margin !== 'none' && classes["margin".concat((0, _capitalize.default)(margin))], fullWidth && classes.fullWidth),
	    ref: ref
	  }, other), children));
	});
	 false ? FormControl.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The contents of the form control.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['primary', 'secondary']),
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .elementType,
	
	  /**
	   * If `true`, the label, input and helper text should be displayed in a disabled state.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the label should be displayed in an error state.
	   */
	  error: _propTypes.default.bool,
	
	  /**
	   * If `true`, the component will be displayed in focused state.
	   */
	  focused: _propTypes.default.bool,
	
	  /**
	   * If `true`, the component will take up the full width of its container.
	   */
	  fullWidth: _propTypes.default.bool,
	
	  /**
	   * If `true`, the label will be hidden.
	   * This is used to increase density for a `FilledInput`.
	   * Be sure to add `aria-label` to the `input` element.
	   */
	  hiddenLabel: _propTypes.default.bool,
	
	  /**
	   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
	   */
	  margin: _propTypes.default.oneOf(['dense', 'none', 'normal']),
	
	  /**
	   * If `true`, the label will indicate that the input is required.
	   */
	  required: _propTypes.default.bool,
	
	  /**
	   * The size of the text field.
	   */
	  size: _propTypes.default.oneOf(['medium', 'small']),
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['filled', 'outlined', 'standard'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiFormControl'
	})(FormControl);
	
	exports.default = _default;

/***/ },
/* 714 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _FormControl.default;
	  }
	});
	Object.defineProperty(exports, "useFormControl", {
	  enumerable: true,
	  get: function get() {
	    return _useFormControl.default;
	  }
	});
	
	var _FormControl = _interopRequireDefault(__webpack_require__(713));
	
	var _useFormControl = _interopRequireDefault(__webpack_require__(118));

/***/ },
/* 715 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(25));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(37));
	
	var _formControlState = _interopRequireDefault(__webpack_require__(117));
	
	var _useFormControl = _interopRequireDefault(__webpack_require__(118));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(41));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: (0, _extends2.default)({
	      color: theme.palette.text.secondary
	    }, theme.typography.caption, {
	      textAlign: 'left',
	      marginTop: 3,
	      margin: 0,
	      '&$disabled': {
	        color: theme.palette.text.disabled
	      },
	      '&$error': {
	        color: theme.palette.error.main
	      }
	    }),
	
	    /* Pseudo-class applied to the root element if `error={true}`. */
	    error: {},
	
	    /* Pseudo-class applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the root element if `margin="dense"`. */
	    marginDense: {
	      marginTop: 4
	    },
	
	    /* Styles applied to the root element if `variant="filled"` or `variant="outlined"`. */
	    contained: {
	      marginLeft: 14,
	      marginRight: 14
	    },
	
	    /* Pseudo-class applied to the root element if `focused={true}`. */
	    focused: {},
	
	    /* Pseudo-class applied to the root element if `filled={true}`. */
	    filled: {},
	
	    /* Pseudo-class applied to the root element if `required={true}`. */
	    required: {}
	  };
	};
	
	exports.styles = styles;
	var FormHelperText = /*#__PURE__*/React.forwardRef(function FormHelperText(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'p' : _props$component,
	      disabled = props.disabled,
	      error = props.error,
	      filled = props.filled,
	      focused = props.focused,
	      margin = props.margin,
	      required = props.required,
	      variant = props.variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "component", "disabled", "error", "filled", "focused", "margin", "required", "variant"]);
	  var muiFormControl = (0, _useFormControl.default)();
	  var fcs = (0, _formControlState.default)({
	    props: props,
	    muiFormControl: muiFormControl,
	    states: ['variant', 'margin', 'disabled', 'error', 'filled', 'focused', 'required']
	  });
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, (fcs.variant === 'filled' || fcs.variant === 'outlined') && classes.contained, className, fcs.disabled && classes.disabled, fcs.error && classes.error, fcs.filled && classes.filled, fcs.focused && classes.focused, fcs.required && classes.required, fcs.margin === 'dense' && classes.marginDense),
	    ref: ref
	  }, other), children === ' ' ?
	  /*#__PURE__*/
	  // eslint-disable-next-line react/no-danger
	  React.createElement("span", {
	    dangerouslySetInnerHTML: {
	      __html: '&#8203;'
	    }
	  }) : children);
	});
	 false ? FormHelperText.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the component.
	   *
	   * If `' '` is provided, the component reserves one line height for displaying a future message.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .elementType,
	
	  /**
	   * If `true`, the helper text should be displayed in a disabled state.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, helper text should be displayed in an error state.
	   */
	  error: _propTypes.default.bool,
	
	  /**
	   * If `true`, the helper text should use filled classes key.
	   */
	  filled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the helper text should use focused classes key.
	   */
	  focused: _propTypes.default.bool,
	
	  /**
	   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
	   * FormControl.
	   */
	  margin: _propTypes.default.oneOf(['dense']),
	
	  /**
	   * If `true`, the helper text should use required classes key.
	   */
	  required: _propTypes.default.bool,
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['filled', 'outlined', 'standard'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiFormHelperText'
	})(FormHelperText);
	
	exports.default = _default;

/***/ },
/* 716 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _FormHelperText.default;
	  }
	});
	
	var _FormHelperText = _interopRequireDefault(__webpack_require__(715));

/***/ },
/* 717 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(25));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(37));
	
	var _formControlState = _interopRequireDefault(__webpack_require__(117));
	
	var _useFormControl = _interopRequireDefault(__webpack_require__(118));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(78));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(41));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: (0, _extends2.default)({
	      color: theme.palette.text.secondary
	    }, theme.typography.body1, {
	      lineHeight: 1,
	      padding: 0,
	      '&$focused': {
	        color: theme.palette.primary.main
	      },
	      '&$disabled': {
	        color: theme.palette.text.disabled
	      },
	      '&$error': {
	        color: theme.palette.error.main
	      }
	    }),
	
	    /* Styles applied to the root element if the color is secondary. */
	    colorSecondary: {
	      '&$focused': {
	        color: theme.palette.secondary.main
	      }
	    },
	
	    /* Pseudo-class applied to the root element if `focused={true}`. */
	    focused: {},
	
	    /* Pseudo-class applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Pseudo-class applied to the root element if `error={true}`. */
	    error: {},
	
	    /* Pseudo-class applied to the root element if `filled={true}`. */
	    filled: {},
	
	    /* Pseudo-class applied to the root element if `required={true}`. */
	    required: {},
	
	    /* Styles applied to the asterisk element. */
	    asterisk: {
	      '&$error': {
	        color: theme.palette.error.main
	      }
	    }
	  };
	};
	
	exports.styles = styles;
	var FormLabel = /*#__PURE__*/React.forwardRef(function FormLabel(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      color = props.color,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'label' : _props$component,
	      disabled = props.disabled,
	      error = props.error,
	      filled = props.filled,
	      focused = props.focused,
	      required = props.required,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "color", "component", "disabled", "error", "filled", "focused", "required"]);
	  var muiFormControl = (0, _useFormControl.default)();
	  var fcs = (0, _formControlState.default)({
	    props: props,
	    muiFormControl: muiFormControl,
	    states: ['color', 'required', 'focused', 'disabled', 'error', 'filled']
	  });
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, classes["color".concat((0, _capitalize.default)(fcs.color || 'primary'))], className, fcs.disabled && classes.disabled, fcs.error && classes.error, fcs.filled && classes.filled, fcs.focused && classes.focused, fcs.required && classes.required),
	    ref: ref
	  }, other), children, fcs.required && /*#__PURE__*/React.createElement("span", {
	    "aria-hidden": true,
	    className: (0, _clsx.default)(classes.asterisk, fcs.error && classes.error)
	  }, "\u2009", '*'));
	});
	 false ? FormLabel.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['primary', 'secondary']),
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .elementType,
	
	  /**
	   * If `true`, the label should be displayed in a disabled state.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the label should be displayed in an error state.
	   */
	  error: _propTypes.default.bool,
	
	  /**
	   * If `true`, the label should use filled classes key.
	   */
	  filled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the input of this label is focused (used by `FormGroup` components).
	   */
	  focused: _propTypes.default.bool,
	
	  /**
	   * If `true`, the label will indicate that the input is required.
	   */
	  required: _propTypes.default.bool
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiFormLabel'
	})(FormLabel);
	
	exports.default = _default;

/***/ },
/* 718 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _FormLabel.default;
	  }
	});
	
	var _FormLabel = _interopRequireDefault(__webpack_require__(717));

/***/ },
/* 719 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(175));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(25));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _reactTransitionGroup = __webpack_require__(300);
	
	var _useTheme = _interopRequireDefault(__webpack_require__(178));
	
	var _utils = __webpack_require__(781);
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(68));
	
	function getScale(value) {
	  return "scale(".concat(value, ", ").concat(Math.pow(value, 2), ")");
	}
	
	var styles = {
	  entering: {
	    opacity: 1,
	    transform: getScale(1)
	  },
	  entered: {
	    opacity: 1,
	    transform: 'none'
	  }
	};
	/**
	 * The Grow transition is used by the [Tooltip](/components/tooltips/) and
	 * [Popover](/components/popover/) components.
	 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
	 */
	
	var Grow = /*#__PURE__*/React.forwardRef(function Grow(props, ref) {
	  var children = props.children,
	      _props$disableStrictM = props.disableStrictModeCompat,
	      disableStrictModeCompat = _props$disableStrictM === void 0 ? false : _props$disableStrictM,
	      inProp = props.in,
	      onEnter = props.onEnter,
	      onEntered = props.onEntered,
	      onEntering = props.onEntering,
	      onExit = props.onExit,
	      onExited = props.onExited,
	      onExiting = props.onExiting,
	      style = props.style,
	      _props$timeout = props.timeout,
	      timeout = _props$timeout === void 0 ? 'auto' : _props$timeout,
	      _props$TransitionComp = props.TransitionComponent,
	      TransitionComponent = _props$TransitionComp === void 0 ? _reactTransitionGroup.Transition : _props$TransitionComp,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "disableStrictModeCompat", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"]);
	  var timer = React.useRef();
	  var autoTimeout = React.useRef();
	  var theme = (0, _useTheme.default)();
	  var enableStrictModeCompat = theme.unstable_strictMode && !disableStrictModeCompat;
	  var nodeRef = React.useRef(null);
	  var foreignRef = (0, _useForkRef.default)(children.ref, ref);
	  var handleRef = (0, _useForkRef.default)(enableStrictModeCompat ? nodeRef : undefined, foreignRef);
	
	  var normalizedTransitionCallback = function normalizedTransitionCallback(callback) {
	    return function (nodeOrAppearing, maybeAppearing) {
	      if (callback) {
	        var _ref = enableStrictModeCompat ? [nodeRef.current, nodeOrAppearing] : [nodeOrAppearing, maybeAppearing],
	            _ref2 = (0, _slicedToArray2.default)(_ref, 2),
	            node = _ref2[0],
	            isAppearing = _ref2[1]; // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
	
	
	        if (isAppearing === undefined) {
	          callback(node);
	        } else {
	          callback(node, isAppearing);
	        }
	      }
	    };
	  };
	
	  var handleEntering = normalizedTransitionCallback(onEntering);
	  var handleEnter = normalizedTransitionCallback(function (node, isAppearing) {
	    (0, _utils.reflow)(node); // So the animation always start from the start.
	
	    var _getTransitionProps = (0, _utils.getTransitionProps)({
	      style: style,
	      timeout: timeout
	    }, {
	      mode: 'enter'
	    }),
	        transitionDuration = _getTransitionProps.duration,
	        delay = _getTransitionProps.delay;
	
	    var duration;
	
	    if (timeout === 'auto') {
	      duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
	      autoTimeout.current = duration;
	    } else {
	      duration = transitionDuration;
	    }
	
	    node.style.transition = [theme.transitions.create('opacity', {
	      duration: duration,
	      delay: delay
	    }), theme.transitions.create('transform', {
	      duration: duration * 0.666,
	      delay: delay
	    })].join(',');
	
	    if (onEnter) {
	      onEnter(node, isAppearing);
	    }
	  });
	  var handleEntered = normalizedTransitionCallback(onEntered);
	  var handleExiting = normalizedTransitionCallback(onExiting);
	  var handleExit = normalizedTransitionCallback(function (node) {
	    var _getTransitionProps2 = (0, _utils.getTransitionProps)({
	      style: style,
	      timeout: timeout
	    }, {
	      mode: 'exit'
	    }),
	        transitionDuration = _getTransitionProps2.duration,
	        delay = _getTransitionProps2.delay;
	
	    var duration;
	
	    if (timeout === 'auto') {
	      duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
	      autoTimeout.current = duration;
	    } else {
	      duration = transitionDuration;
	    }
	
	    node.style.transition = [theme.transitions.create('opacity', {
	      duration: duration,
	      delay: delay
	    }), theme.transitions.create('transform', {
	      duration: duration * 0.666,
	      delay: delay || duration * 0.333
	    })].join(',');
	    node.style.opacity = '0';
	    node.style.transform = getScale(0.75);
	
	    if (onExit) {
	      onExit(node);
	    }
	  });
	  var handleExited = normalizedTransitionCallback(onExited);
	
	  var addEndListener = function addEndListener(nodeOrNext, maybeNext) {
	    var next = enableStrictModeCompat ? nodeOrNext : maybeNext;
	
	    if (timeout === 'auto') {
	      timer.current = setTimeout(next, autoTimeout.current || 0);
	    }
	  };
	
	  React.useEffect(function () {
	    return function () {
	      clearTimeout(timer.current);
	    };
	  }, []);
	  return /*#__PURE__*/React.createElement(TransitionComponent, (0, _extends2.default)({
	    appear: true,
	    in: inProp,
	    nodeRef: enableStrictModeCompat ? nodeRef : undefined,
	    onEnter: handleEnter,
	    onEntered: handleEntered,
	    onEntering: handleEntering,
	    onExit: handleExit,
	    onExited: handleExited,
	    onExiting: handleExiting,
	    addEndListener: addEndListener,
	    timeout: timeout === 'auto' ? null : timeout
	  }, other), function (state, childProps) {
	    return /*#__PURE__*/React.cloneElement(children, (0, _extends2.default)({
	      style: (0, _extends2.default)({
	        opacity: 0,
	        transform: getScale(0.75),
	        visibility: state === 'exited' && !inProp ? 'hidden' : undefined
	      }, styles[state], style, children.props.style),
	      ref: handleRef
	    }, childProps));
	  });
	});
	 false ? Grow.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * A single child content element.
	   */
	  children: _propTypes.default.element,
	
	  /**
	   * Enable this prop if you encounter 'Function components cannot be given refs',
	   * use `unstable_createStrictModeTheme`,
	   * and can't forward the ref in the child component.
	   */
	  disableStrictModeCompat: _propTypes.default.bool,
	
	  /**
	   * If `true`, show the component; triggers the enter or exit animation.
	   */
	  in: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onEntered: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onEntering: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onExited: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onExiting: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  style: _propTypes.default.object,
	
	  /**
	   * The duration for the transition, in milliseconds.
	   * You may specify a single timeout for all transitions, or individually with an object.
	   *
	   * Set to 'auto' to automatically calculate transition time based on height.
	   */
	  timeout: _propTypes.default.oneOfType([_propTypes.default.oneOf(['auto']), _propTypes.default.number, _propTypes.default.shape({
	    appear: _propTypes.default.number,
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  })])
	} : void 0;
	Grow.muiSupportAuto = true;
	var _default = Grow;
	exports.default = _default;

/***/ },
/* 720 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Grow.default;
	  }
	});
	
	var _Grow = _interopRequireDefault(__webpack_require__(719));

/***/ },
/* 721 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(25));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(37));
	
	var _utils = __webpack_require__(26);
	
	var _withStyles = _interopRequireDefault(__webpack_require__(41));
	
	var _colorManipulator = __webpack_require__(177);
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(319));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(78));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      textAlign: 'center',
	      flex: '0 0 auto',
	      fontSize: theme.typography.pxToRem(24),
	      padding: 12,
	      borderRadius: '50%',
	      overflow: 'visible',
	      // Explicitly set the default value to solve a bug on IE 11.
	      color: theme.palette.action.active,
	      transition: theme.transitions.create('background-color', {
	        duration: theme.transitions.duration.shortest
	      }),
	      '&:hover': {
	        backgroundColor: (0, _colorManipulator.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: 'transparent'
	        }
	      },
	      '&$disabled': {
	        backgroundColor: 'transparent',
	        color: theme.palette.action.disabled
	      }
	    },
	
	    /* Styles applied to the root element if `edge="start"`. */
	    edgeStart: {
	      marginLeft: -12,
	      '$sizeSmall&': {
	        marginLeft: -3
	      }
	    },
	
	    /* Styles applied to the root element if `edge="end"`. */
	    edgeEnd: {
	      marginRight: -12,
	      '$sizeSmall&': {
	        marginRight: -3
	      }
	    },
	
	    /* Styles applied to the root element if `color="inherit"`. */
	    colorInherit: {
	      color: 'inherit'
	    },
	
	    /* Styles applied to the root element if `color="primary"`. */
	    colorPrimary: {
	      color: theme.palette.primary.main,
	      '&:hover': {
	        backgroundColor: (0, _colorManipulator.alpha)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: 'transparent'
	        }
	      }
	    },
	
	    /* Styles applied to the root element if `color="secondary"`. */
	    colorSecondary: {
	      color: theme.palette.secondary.main,
	      '&:hover': {
	        backgroundColor: (0, _colorManipulator.alpha)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: 'transparent'
	        }
	      }
	    },
	
	    /* Pseudo-class applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the root element if `size="small"`. */
	    sizeSmall: {
	      padding: 3,
	      fontSize: theme.typography.pxToRem(18)
	    },
	
	    /* Styles applied to the children container element. */
	    label: {
	      width: '100%',
	      display: 'flex',
	      alignItems: 'inherit',
	      justifyContent: 'inherit'
	    }
	  };
	};
	/**
	 * Refer to the [Icons](/components/icons/) section of the documentation
	 * regarding the available icon options.
	 */
	
	
	exports.styles = styles;
	var IconButton = /*#__PURE__*/React.forwardRef(function IconButton(props, ref) {
	  var _props$edge = props.edge,
	      edge = _props$edge === void 0 ? false : _props$edge,
	      children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'default' : _props$color,
	      _props$disabled = props.disabled,
	      disabled = _props$disabled === void 0 ? false : _props$disabled,
	      _props$disableFocusRi = props.disableFocusRipple,
	      disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi,
	      _props$size = props.size,
	      size = _props$size === void 0 ? 'medium' : _props$size,
	      other = (0, _objectWithoutProperties2.default)(props, ["edge", "children", "classes", "className", "color", "disabled", "disableFocusRipple", "size"]);
	  return /*#__PURE__*/React.createElement(_ButtonBase.default, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, color !== 'default' && classes["color".concat((0, _capitalize.default)(color))], disabled && classes.disabled, size === "small" && classes["size".concat((0, _capitalize.default)(size))], {
	      'start': classes.edgeStart,
	      'end': classes.edgeEnd
	    }[edge]),
	    centerRipple: true,
	    focusRipple: !disableFocusRipple,
	    disabled: disabled,
	    ref: ref
	  }, other), /*#__PURE__*/React.createElement("span", {
	    className: classes.label
	  }, children));
	});
	 false ? IconButton.propTypes = {
	  /**
	   * The icon element.
	   */
	  children: (0, _utils.chainPropTypes)(_propTypes.default.node, function (props) {
	    var found = React.Children.toArray(props.children).some(function (child) {
	      return /*#__PURE__*/React.isValidElement(child) && child.props.onClick;
	    });
	
	    if (found) {
	      return new Error(['Material-UI: You are providing an onClick event listener ' + 'to a child of a button element.', 'Firefox will never trigger the event.', 'You should move the onClick listener to the parent button element.', 'https://github.com/mui-org/material-ui/issues/13957'].join('\n'));
	    }
	
	    return null;
	  }),
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['default', 'inherit', 'primary', 'secondary']),
	
	  /**
	   * If `true`, the button will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the  keyboard focus ripple will be disabled.
	   */
	  disableFocusRipple: _propTypes.default.bool,
	
	  /**
	   * If `true`, the ripple effect will be disabled.
	   */
	  disableRipple: _propTypes.default.bool,
	
	  /**
	   * If given, uses a negative margin to counteract the padding on one
	   * side (this is often helpful for aligning the left or right
	   * side of the icon with content above or below, without ruining the border
	   * size and shape).
	   */
	  edge: _propTypes.default.oneOf(['start', 'end', false]),
	
	  /**
	   * The size of the button.
	   * `small` is equivalent to the dense button styling.
	   */
	  size: _propTypes.default.oneOf(['small', 'medium'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiIconButton'
	})(IconButton);
	
	exports.default = _default;

/***/ },
/* 722 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _IconButton.default;
	  }
	});
	
	var _IconButton = _interopRequireDefault(__webpack_require__(721));

/***/ },
/* 723 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(25));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(37));
	
	var _utils = __webpack_require__(26);
	
	var _InputBase = _interopRequireDefault(__webpack_require__(232));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(41));
	
	var styles = function styles(theme) {
	  var light = theme.palette.type === 'light';
	  var bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      position: 'relative'
	    },
	
	    /* Styles applied to the root element if the component is a descendant of `FormControl`. */
	    formControl: {
	      'label + &': {
	        marginTop: 16
	      }
	    },
	
	    /* Styles applied to the root element if the component is focused. */
	    focused: {},
	
	    /* Styles applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the root element if color secondary. */
	    colorSecondary: {
	      '&$underline:after': {
	        borderBottomColor: theme.palette.secondary.main
	      }
	    },
	
	    /* Styles applied to the root element if `disableUnderline={false}`. */
	    underline: {
	      '&:after': {
	        borderBottom: "2px solid ".concat(theme.palette.primary.main),
	        left: 0,
	        bottom: 0,
	        // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
	        content: '""',
	        position: 'absolute',
	        right: 0,
	        transform: 'scaleX(0)',
	        transition: theme.transitions.create('transform', {
	          duration: theme.transitions.duration.shorter,
	          easing: theme.transitions.easing.easeOut
	        }),
	        pointerEvents: 'none' // Transparent to the hover style.
	
	      },
	      '&$focused:after': {
	        transform: 'scaleX(1)'
	      },
	      '&$error:after': {
	        borderBottomColor: theme.palette.error.main,
	        transform: 'scaleX(1)' // error is always underlined in red
	
	      },
	      '&:before': {
	        borderBottom: "1px solid ".concat(bottomLineColor),
	        left: 0,
	        bottom: 0,
	        // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
	        content: '"\\00a0"',
	        position: 'absolute',
	        right: 0,
	        transition: theme.transitions.create('border-bottom-color', {
	          duration: theme.transitions.duration.shorter
	        }),
	        pointerEvents: 'none' // Transparent to the hover style.
	
	      },
	      '&:hover:not($disabled):before': {
	        borderBottom: "2px solid ".concat(theme.palette.text.primary),
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          borderBottom: "1px solid ".concat(bottomLineColor)
	        }
	      },
	      '&$disabled:before': {
	        borderBottomStyle: 'dotted'
	      }
	    },
	
	    /* Pseudo-class applied to the root element if `error={true}`. */
	    error: {},
	
	    /* Styles applied to the `input` element if `margin="dense"`. */
	    marginDense: {},
	
	    /* Styles applied to the root element if `multiline={true}`. */
	    multiline: {},
	
	    /* Styles applied to the root element if `fullWidth={true}`. */
	    fullWidth: {},
	
	    /* Styles applied to the `input` element. */
	    input: {},
	
	    /* Styles applied to the `input` element if `margin="dense"`. */
	    inputMarginDense: {},
	
	    /* Styles applied to the `input` element if `multiline={true}`. */
	    inputMultiline: {},
	
	    /* Styles applied to the `input` element if `type="search"`. */
	    inputTypeSearch: {}
	  };
	};
	
	exports.styles = styles;
	var Input = /*#__PURE__*/React.forwardRef(function Input(props, ref) {
	  var disableUnderline = props.disableUnderline,
	      classes = props.classes,
	      _props$fullWidth = props.fullWidth,
	      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
	      _props$inputComponent = props.inputComponent,
	      inputComponent = _props$inputComponent === void 0 ? 'input' : _props$inputComponent,
	      _props$multiline = props.multiline,
	      multiline = _props$multiline === void 0 ? false : _props$multiline,
	      _props$type = props.type,
	      type = _props$type === void 0 ? 'text' : _props$type,
	      other = (0, _objectWithoutProperties2.default)(props, ["disableUnderline", "classes", "fullWidth", "inputComponent", "multiline", "type"]);
	  return /*#__PURE__*/React.createElement(_InputBase.default, (0, _extends2.default)({
	    classes: (0, _extends2.default)({}, classes, {
	      root: (0, _clsx.default)(classes.root, !disableUnderline && classes.underline),
	      underline: null
	    }),
	    fullWidth: fullWidth,
	    inputComponent: inputComponent,
	    multiline: multiline,
	    ref: ref,
	    type: type
	  }, other));
	});
	 false ? Input.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * This prop helps users to fill forms faster, especially on mobile devices.
	   * The name can be confusing, as it's more like an autofill.
	   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
	   */
	  autoComplete: _propTypes.default.string,
	
	  /**
	   * If `true`, the `input` element will be focused during the first mount.
	   */
	  autoFocus: _propTypes.default.bool,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['primary', 'secondary']),
	
	  /**
	   * The default `input` element value. Use when the component is not controlled.
	   */
	  defaultValue: _propTypes.default.any,
	
	  /**
	   * If `true`, the `input` element will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the input will not have an underline.
	   */
	  disableUnderline: _propTypes.default.bool,
	
	  /**
	   * End `InputAdornment` for this component.
	   */
	  endAdornment: _propTypes.default.node,
	
	  /**
	   * If `true`, the input will indicate an error. This is normally obtained via context from
	   * FormControl.
	   */
	  error: _propTypes.default.bool,
	
	  /**
	   * If `true`, the input will take up the full width of its container.
	   */
	  fullWidth: _propTypes.default.bool,
	
	  /**
	   * The id of the `input` element.
	   */
	  id: _propTypes.default.string,
	
	  /**
	   * The component used for the `input` element.
	   * Either a string to use a HTML element or a component.
	   */
	  inputComponent: _propTypes.default.elementType,
	
	  /**
	   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
	   */
	  inputProps: _propTypes.default.object,
	
	  /**
	   * Pass a ref to the `input` element.
	   */
	  inputRef: _utils.refType,
	
	  /**
	   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
	   * FormControl.
	   */
	  margin: _propTypes.default.oneOf(['dense', 'none']),
	
	  /**
	   * Maximum number of rows to display when multiline option is set to true.
	   */
	  maxRows: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * If `true`, a textarea element will be rendered.
	   */
	  multiline: _propTypes.default.bool,
	
	  /**
	   * Name attribute of the `input` element.
	   */
	  name: _propTypes.default.string,
	
	  /**
	   * Callback fired when the value is changed.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new value by accessing `event.target.value` (string).
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * The short hint displayed in the input before the user enters a value.
	   */
	  placeholder: _propTypes.default.string,
	
	  /**
	   * It prevents the user from changing the value of the field
	   * (not from interacting with the field).
	   */
	  readOnly: _propTypes.default.bool,
	
	  /**
	   * If `true`, the `input` element will be required.
	   */
	  required: _propTypes.default.bool,
	
	  /**
	   * Number of rows to display when multiline option is set to true.
	   */
	  rows: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * Start `InputAdornment` for this component.
	   */
	  startAdornment: _propTypes.default.node,
	
	  /**
	   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
	   */
	  type: _propTypes.default.string,
	
	  /**
	   * The value of the `input` element, required for a controlled component.
	   */
	  value: _propTypes.default.any
	} : void 0;
	Input.muiName = 'Input';
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiInput'
	})(Input);
	
	exports.default = _default;

/***/ },
/* 724 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(25));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _utils = __webpack_require__(26);
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(37));
	
	var _formControlState = _interopRequireDefault(__webpack_require__(117));
	
	var _FormControlContext = _interopRequireWildcard(__webpack_require__(230));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(41));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(78));
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(68));
	
	var _TextareaAutosize = _interopRequireDefault(__webpack_require__(754));
	
	var _utils2 = __webpack_require__(233);
	
	/* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */
	var styles = function styles(theme) {
	  var light = theme.palette.type === 'light';
	  var placeholder = {
	    color: 'currentColor',
	    opacity: light ? 0.42 : 0.5,
	    transition: theme.transitions.create('opacity', {
	      duration: theme.transitions.duration.shorter
	    })
	  };
	  var placeholderHidden = {
	    opacity: '0 !important'
	  };
	  var placeholderVisible = {
	    opacity: light ? 0.42 : 0.5
	  };
	  return {
	    '@global': {
	      '@keyframes mui-auto-fill': {},
	      '@keyframes mui-auto-fill-cancel': {}
	    },
	
	    /* Styles applied to the root element. */
	    root: (0, _extends2.default)({}, theme.typography.body1, {
	      color: theme.palette.text.primary,
	      lineHeight: '1.1876em',
	      // Reset (19px), match the native input line-height
	      boxSizing: 'border-box',
	      // Prevent padding issue with fullWidth.
	      position: 'relative',
	      cursor: 'text',
	      display: 'inline-flex',
	      alignItems: 'center',
	      '&$disabled': {
	        color: theme.palette.text.disabled,
	        cursor: 'default'
	      }
	    }),
	
	    /* Styles applied to the root element if the component is a descendant of `FormControl`. */
	    formControl: {},
	
	    /* Styles applied to the root element if the component is focused. */
	    focused: {},
	
	    /* Styles applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the root element if `startAdornment` is provided. */
	    adornedStart: {},
	
	    /* Styles applied to the root element if `endAdornment` is provided. */
	    adornedEnd: {},
	
	    /* Pseudo-class applied to the root element if `error={true}`. */
	    error: {},
	
	    /* Styles applied to the `input` element if `margin="dense"`. */
	    marginDense: {},
	
	    /* Styles applied to the root element if `multiline={true}`. */
	    multiline: {
	      padding: "".concat(8 - 2, "px 0 ").concat(8 - 1, "px"),
	      '&$marginDense': {
	        paddingTop: 4 - 1
	      }
	    },
	
	    /* Styles applied to the root element if the color is secondary. */
	    colorSecondary: {},
	
	    /* Styles applied to the root element if `fullWidth={true}`. */
	    fullWidth: {
	      width: '100%'
	    },
	
	    /* Styles applied to the `input` element. */
	    input: {
	      font: 'inherit',
	      letterSpacing: 'inherit',
	      color: 'currentColor',
	      padding: "".concat(8 - 2, "px 0 ").concat(8 - 1, "px"),
	      border: 0,
	      boxSizing: 'content-box',
	      background: 'none',
	      height: '1.1876em',
	      // Reset (19px), match the native input line-height
	      margin: 0,
	      // Reset for Safari
	      WebkitTapHighlightColor: 'transparent',
	      display: 'block',
	      // Make the flex item shrink with Firefox
	      minWidth: 0,
	      width: '100%',
	      // Fix IE 11 width issue
	      animationName: 'mui-auto-fill-cancel',
	      animationDuration: '10ms',
	      '&::-webkit-input-placeholder': placeholder,
	      '&::-moz-placeholder': placeholder,
	      // Firefox 19+
	      '&:-ms-input-placeholder': placeholder,
	      // IE 11
	      '&::-ms-input-placeholder': placeholder,
	      // Edge
	      '&:focus': {
	        outline: 0
	      },
	      // Reset Firefox invalid required input style
	      '&:invalid': {
	        boxShadow: 'none'
	      },
	      '&::-webkit-search-decoration': {
	        // Remove the padding when type=search.
	        '-webkit-appearance': 'none'
	      },
	      // Show and hide the placeholder logic
	      'label[data-shrink=false] + $formControl &': {
	        '&::-webkit-input-placeholder': placeholderHidden,
	        '&::-moz-placeholder': placeholderHidden,
	        // Firefox 19+
	        '&:-ms-input-placeholder': placeholderHidden,
	        // IE 11
	        '&::-ms-input-placeholder': placeholderHidden,
	        // Edge
	        '&:focus::-webkit-input-placeholder': placeholderVisible,
	        '&:focus::-moz-placeholder': placeholderVisible,
	        // Firefox 19+
	        '&:focus:-ms-input-placeholder': placeholderVisible,
	        // IE 11
	        '&:focus::-ms-input-placeholder': placeholderVisible // Edge
	
	      },
	      '&$disabled': {
	        opacity: 1 // Reset iOS opacity
	
	      },
	      '&:-webkit-autofill': {
	        animationDuration: '5000s',
	        animationName: 'mui-auto-fill'
	      }
	    },
	
	    /* Styles applied to the `input` element if `margin="dense"`. */
	    inputMarginDense: {
	      paddingTop: 4 - 1
	    },
	
	    /* Styles applied to the `input` element if `multiline={true}`. */
	    inputMultiline: {
	      height: 'auto',
	      resize: 'none',
	      padding: 0
	    },
	
	    /* Styles applied to the `input` element if `type="search"`. */
	    inputTypeSearch: {
	      // Improve type search style.
	      '-moz-appearance': 'textfield',
	      '-webkit-appearance': 'textfield'
	    },
	
	    /* Styles applied to the `input` element if `startAdornment` is provided. */
	    inputAdornedStart: {},
	
	    /* Styles applied to the `input` element if `endAdornment` is provided. */
	    inputAdornedEnd: {},
	
	    /* Styles applied to the `input` element if `hiddenLabel={true}`. */
	    inputHiddenLabel: {}
	  };
	};
	
	exports.styles = styles;
	var useEnhancedEffect = typeof window === 'undefined' ? React.useEffect : React.useLayoutEffect;
	/**
	 * `InputBase` contains as few styles as possible.
	 * It aims to be a simple building block for creating an input.
	 * It contains a load of style reset and some state logic.
	 */
	
	var InputBase = /*#__PURE__*/React.forwardRef(function InputBase(props, ref) {
	  var ariaDescribedby = props['aria-describedby'],
	      autoComplete = props.autoComplete,
	      autoFocus = props.autoFocus,
	      classes = props.classes,
	      className = props.className,
	      color = props.color,
	      defaultValue = props.defaultValue,
	      disabled = props.disabled,
	      endAdornment = props.endAdornment,
	      error = props.error,
	      _props$fullWidth = props.fullWidth,
	      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
	      id = props.id,
	      _props$inputComponent = props.inputComponent,
	      inputComponent = _props$inputComponent === void 0 ? 'input' : _props$inputComponent,
	      _props$inputProps = props.inputProps,
	      inputPropsProp = _props$inputProps === void 0 ? {} : _props$inputProps,
	      inputRefProp = props.inputRef,
	      margin = props.margin,
	      _props$multiline = props.multiline,
	      multiline = _props$multiline === void 0 ? false : _props$multiline,
	      name = props.name,
	      onBlur = props.onBlur,
	      onChange = props.onChange,
	      onClick = props.onClick,
	      onFocus = props.onFocus,
	      onKeyDown = props.onKeyDown,
	      onKeyUp = props.onKeyUp,
	      placeholder = props.placeholder,
	      readOnly = props.readOnly,
	      renderSuffix = props.renderSuffix,
	      rows = props.rows,
	      rowsMax = props.rowsMax,
	      rowsMin = props.rowsMin,
	      maxRows = props.maxRows,
	      minRows = props.minRows,
	      startAdornment = props.startAdornment,
	      _props$type = props.type,
	      type = _props$type === void 0 ? 'text' : _props$type,
	      valueProp = props.value,
	      other = (0, _objectWithoutProperties2.default)(props, ["aria-describedby", "autoComplete", "autoFocus", "classes", "className", "color", "defaultValue", "disabled", "endAdornment", "error", "fullWidth", "id", "inputComponent", "inputProps", "inputRef", "margin", "multiline", "name", "onBlur", "onChange", "onClick", "onFocus", "onKeyDown", "onKeyUp", "placeholder", "readOnly", "renderSuffix", "rows", "rowsMax", "rowsMin", "maxRows", "minRows", "startAdornment", "type", "value"]);
	  var value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
	
	  var _React$useRef = React.useRef(value != null),
	      isControlled = _React$useRef.current;
	
	  var inputRef = React.useRef();
	  var handleInputRefWarning = React.useCallback(function (instance) {
	    if (false) {
	      if (instance && instance.nodeName !== 'INPUT' && !instance.focus) {
	        console.error(['Material-UI: You have provided a `inputComponent` to the input component', 'that does not correctly handle the `inputRef` prop.', 'Make sure the `inputRef` prop is called with a HTMLInputElement.'].join('\n'));
	      }
	    }
	  }, []);
	  var handleInputPropsRefProp = (0, _useForkRef.default)(inputPropsProp.ref, handleInputRefWarning);
	  var handleInputRefProp = (0, _useForkRef.default)(inputRefProp, handleInputPropsRefProp);
	  var handleInputRef = (0, _useForkRef.default)(inputRef, handleInputRefProp);
	
	  var _React$useState = React.useState(false),
	      focused = _React$useState[0],
	      setFocused = _React$useState[1];
	
	  var muiFormControl = (0, _FormControlContext.useFormControl)();
	
	  if (false) {
	    // eslint-disable-next-line react-hooks/rules-of-hooks
	    React.useEffect(function () {
	      if (muiFormControl) {
	        return muiFormControl.registerEffect();
	      }
	
	      return undefined;
	    }, [muiFormControl]);
	  }
	
	  var fcs = (0, _formControlState.default)({
	    props: props,
	    muiFormControl: muiFormControl,
	    states: ['color', 'disabled', 'error', 'hiddenLabel', 'margin', 'required', 'filled']
	  });
	  fcs.focused = muiFormControl ? muiFormControl.focused : focused; // The blur won't fire when the disabled state is set on a focused input.
	  // We need to book keep the focused state manually.
	
	  React.useEffect(function () {
	    if (!muiFormControl && disabled && focused) {
	      setFocused(false);
	
	      if (onBlur) {
	        onBlur();
	      }
	    }
	  }, [muiFormControl, disabled, focused, onBlur]);
	  var onFilled = muiFormControl && muiFormControl.onFilled;
	  var onEmpty = muiFormControl && muiFormControl.onEmpty;
	  var checkDirty = React.useCallback(function (obj) {
	    if ((0, _utils2.isFilled)(obj)) {
	      if (onFilled) {
	        onFilled();
	      }
	    } else if (onEmpty) {
	      onEmpty();
	    }
	  }, [onFilled, onEmpty]);
	  useEnhancedEffect(function () {
	    if (isControlled) {
	      checkDirty({
	        value: value
	      });
	    }
	  }, [value, checkDirty, isControlled]);
	
	  var handleFocus = function handleFocus(event) {
	    // Fix a bug with IE 11 where the focus/blur events are triggered
	    // while the input is disabled.
	    if (fcs.disabled) {
	      event.stopPropagation();
	      return;
	    }
	
	    if (onFocus) {
	      onFocus(event);
	    }
	
	    if (inputPropsProp.onFocus) {
	      inputPropsProp.onFocus(event);
	    }
	
	    if (muiFormControl && muiFormControl.onFocus) {
	      muiFormControl.onFocus(event);
	    } else {
	      setFocused(true);
	    }
	  };
	
	  var handleBlur = function handleBlur(event) {
	    if (onBlur) {
	      onBlur(event);
	    }
	
	    if (inputPropsProp.onBlur) {
	      inputPropsProp.onBlur(event);
	    }
	
	    if (muiFormControl && muiFormControl.onBlur) {
	      muiFormControl.onBlur(event);
	    } else {
	      setFocused(false);
	    }
	  };
	
	  var handleChange = function handleChange(event) {
	    if (!isControlled) {
	      var element = event.target || inputRef.current;
	
	      if (element == null) {
	        throw new Error( false ? "Material-UI: Expected valid input target. Did you use a custom `inputComponent` and forget to forward refs? See https://mui.com/r/input-component-ref-interface for more info." : (0, _utils.formatMuiErrorMessage)(1));
	      }
	
	      checkDirty({
	        value: element.value
	      });
	    }
	
	    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    if (inputPropsProp.onChange) {
	      inputPropsProp.onChange.apply(inputPropsProp, [event].concat(args));
	    } // Perform in the willUpdate
	
	
	    if (onChange) {
	      onChange.apply(void 0, [event].concat(args));
	    }
	  }; // Check the input state on mount, in case it was filled by the user
	  // or auto filled by the browser before the hydration (for SSR).
	
	
	  React.useEffect(function () {
	    checkDirty(inputRef.current);
	  }, []); // eslint-disable-line react-hooks/exhaustive-deps
	
	  var handleClick = function handleClick(event) {
	    if (inputRef.current && event.currentTarget === event.target) {
	      inputRef.current.focus();
	    }
	
	    if (onClick) {
	      onClick(event);
	    }
	  };
	
	  var InputComponent = inputComponent;
	  var inputProps = (0, _extends2.default)({}, inputPropsProp, {
	    ref: handleInputRef
	  });
	
	  if (typeof InputComponent !== 'string') {
	    inputProps = (0, _extends2.default)({
	      // Rename ref to inputRef as we don't know the
	      // provided `inputComponent` structure.
	      inputRef: handleInputRef,
	      type: type
	    }, inputProps, {
	      ref: null
	    });
	  } else if (multiline) {
	    if (rows && !maxRows && !minRows && !rowsMax && !rowsMin) {
	      InputComponent = 'textarea';
	    } else {
	      inputProps = (0, _extends2.default)({
	        minRows: rows || minRows,
	        rowsMax: rowsMax,
	        maxRows: maxRows
	      }, inputProps);
	      InputComponent = _TextareaAutosize.default;
	    }
	  } else {
	    inputProps = (0, _extends2.default)({
	      type: type
	    }, inputProps);
	  }
	
	  var handleAutoFill = function handleAutoFill(event) {
	    // Provide a fake value as Chrome might not let you access it for security reasons.
	    checkDirty(event.animationName === 'mui-auto-fill-cancel' ? inputRef.current : {
	      value: 'x'
	    });
	  };
	
	  React.useEffect(function () {
	    if (muiFormControl) {
	      muiFormControl.setAdornedStart(Boolean(startAdornment));
	    }
	  }, [muiFormControl, startAdornment]);
	  return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, classes["color".concat((0, _capitalize.default)(fcs.color || 'primary'))], className, fcs.disabled && classes.disabled, fcs.error && classes.error, fullWidth && classes.fullWidth, fcs.focused && classes.focused, muiFormControl && classes.formControl, multiline && classes.multiline, startAdornment && classes.adornedStart, endAdornment && classes.adornedEnd, fcs.margin === 'dense' && classes.marginDense),
	    onClick: handleClick,
	    ref: ref
	  }, other), startAdornment, /*#__PURE__*/React.createElement(_FormControlContext.default.Provider, {
	    value: null
	  }, /*#__PURE__*/React.createElement(InputComponent, (0, _extends2.default)({
	    "aria-invalid": fcs.error,
	    "aria-describedby": ariaDescribedby,
	    autoComplete: autoComplete,
	    autoFocus: autoFocus,
	    defaultValue: defaultValue,
	    disabled: fcs.disabled,
	    id: id,
	    onAnimationStart: handleAutoFill,
	    name: name,
	    placeholder: placeholder,
	    readOnly: readOnly,
	    required: fcs.required,
	    rows: rows,
	    value: value,
	    onKeyDown: onKeyDown,
	    onKeyUp: onKeyUp
	  }, inputProps, {
	    className: (0, _clsx.default)(classes.input, inputPropsProp.className, fcs.disabled && classes.disabled, multiline && classes.inputMultiline, fcs.hiddenLabel && classes.inputHiddenLabel, startAdornment && classes.inputAdornedStart, endAdornment && classes.inputAdornedEnd, type === 'search' && classes.inputTypeSearch, fcs.margin === 'dense' && classes.inputMarginDense),
	    onBlur: handleBlur,
	    onChange: handleChange,
	    onFocus: handleFocus
	  }))), endAdornment, renderSuffix ? renderSuffix((0, _extends2.default)({}, fcs, {
	    startAdornment: startAdornment
	  })) : null);
	});
	 false ? InputBase.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * @ignore
	   */
	  'aria-describedby': _propTypes.default.string,
	
	  /**
	   * This prop helps users to fill forms faster, especially on mobile devices.
	   * The name can be confusing, as it's more like an autofill.
	   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
	   */
	  autoComplete: _propTypes.default.string,
	
	  /**
	   * If `true`, the `input` element will be focused during the first mount.
	   */
	  autoFocus: _propTypes.default.bool,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['primary', 'secondary']),
	
	  /**
	   * The default `input` element value. Use when the component is not controlled.
	   */
	  defaultValue: _propTypes.default.any,
	
	  /**
	   * If `true`, the `input` element will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * End `InputAdornment` for this component.
	   */
	  endAdornment: _propTypes.default.node,
	
	  /**
	   * If `true`, the input will indicate an error. This is normally obtained via context from
	   * FormControl.
	   */
	  error: _propTypes.default.bool,
	
	  /**
	   * If `true`, the input will take up the full width of its container.
	   */
	  fullWidth: _propTypes.default.bool,
	
	  /**
	   * The id of the `input` element.
	   */
	  id: _propTypes.default.string,
	
	  /**
	   * The component used for the `input` element.
	   * Either a string to use a HTML element or a component.
	   */
	  inputComponent: _propTypes.default.elementType,
	
	  /**
	   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
	   */
	  inputProps: _propTypes.default.object,
	
	  /**
	   * Pass a ref to the `input` element.
	   */
	  inputRef: _utils.refType,
	
	  /**
	   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
	   * FormControl.
	   */
	  margin: _propTypes.default.oneOf(['dense', 'none']),
	
	  /**
	   * Maximum number of rows to display when multiline option is set to true.
	   */
	  maxRows: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * Minimum number of rows to display when multiline option is set to true.
	   */
	  minRows: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * If `true`, a textarea element will be rendered.
	   */
	  multiline: _propTypes.default.bool,
	
	  /**
	   * Name attribute of the `input` element.
	   */
	  name: _propTypes.default.string,
	
	  /**
	   * Callback fired when the input is blurred.
	   *
	   * Notice that the first argument (event) might be undefined.
	   */
	  onBlur: _propTypes.default.func,
	
	  /**
	   * Callback fired when the value is changed.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new value by accessing `event.target.value` (string).
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onClick: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onFocus: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onKeyDown: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onKeyUp: _propTypes.default.func,
	
	  /**
	   * The short hint displayed in the input before the user enters a value.
	   */
	  placeholder: _propTypes.default.string,
	
	  /**
	   * It prevents the user from changing the value of the field
	   * (not from interacting with the field).
	   */
	  readOnly: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  renderSuffix: _propTypes.default.func,
	
	  /**
	   * If `true`, the `input` element will be required.
	   */
	  required: _propTypes.default.bool,
	
	  /**
	   * Number of rows to display when multiline option is set to true.
	   */
	  rows: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * Maximum number of rows to display.
	   * @deprecated Use `maxRows` instead.
	   */
	  rowsMax: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * Minimum number of rows to display.
	   * @deprecated Use `minRows` instead.
	   */
	  rowsMin: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * Start `InputAdornment` for this component.
	   */
	  startAdornment: _propTypes.default.node,
	
	  /**
	   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
	   */
	  type: _propTypes.default.string,
	
	  /**
	   * The value of the `input` element, required for a controlled component.
	   */
	  value: _propTypes.default.any
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiInputBase'
	})(InputBase);
	
	exports.default = _default;

/***/ },
/* 725 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(25));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(37));
	
	var _formControlState = _interopRequireDefault(__webpack_require__(117));
	
	var _useFormControl = _interopRequireDefault(__webpack_require__(118));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(41));
	
	var _FormLabel = _interopRequireDefault(__webpack_require__(718));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      display: 'block',
	      transformOrigin: 'top left'
	    },
	
	    /* Pseudo-class applied to the root element if `focused={true}`. */
	    focused: {},
	
	    /* Pseudo-class applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Pseudo-class applied to the root element if `error={true}`. */
	    error: {},
	
	    /* Pseudo-class applied to the root element if `required={true}`. */
	    required: {},
	
	    /* Pseudo-class applied to the asterisk element. */
	    asterisk: {},
	
	    /* Styles applied to the root element if the component is a descendant of `FormControl`. */
	    formControl: {
	      position: 'absolute',
	      left: 0,
	      top: 0,
	      // slight alteration to spec spacing to match visual spec result
	      transform: 'translate(0, 24px) scale(1)'
	    },
	
	    /* Styles applied to the root element if `margin="dense"`. */
	    marginDense: {
	      // Compensation for the `Input.inputDense` style.
	      transform: 'translate(0, 21px) scale(1)'
	    },
	
	    /* Styles applied to the `input` element if `shrink={true}`. */
	    shrink: {
	      transform: 'translate(0, 1.5px) scale(0.75)',
	      transformOrigin: 'top left'
	    },
	
	    /* Styles applied to the `input` element if `disableAnimation={false}`. */
	    animated: {
	      transition: theme.transitions.create(['color', 'transform'], {
	        duration: theme.transitions.duration.shorter,
	        easing: theme.transitions.easing.easeOut
	      })
	    },
	
	    /* Styles applied to the root element if `variant="filled"`. */
	    filled: {
	      // Chrome's autofill feature gives the input field a yellow background.
	      // Since the input field is behind the label in the HTML tree,
	      // the input field is drawn last and hides the label with an opaque background color.
	      // zIndex: 1 will raise the label above opaque background-colors of input.
	      zIndex: 1,
	      pointerEvents: 'none',
	      transform: 'translate(12px, 20px) scale(1)',
	      '&$marginDense': {
	        transform: 'translate(12px, 17px) scale(1)'
	      },
	      '&$shrink': {
	        transform: 'translate(12px, 10px) scale(0.75)',
	        '&$marginDense': {
	          transform: 'translate(12px, 7px) scale(0.75)'
	        }
	      }
	    },
	
	    /* Styles applied to the root element if `variant="outlined"`. */
	    outlined: {
	      // see comment above on filled.zIndex
	      zIndex: 1,
	      pointerEvents: 'none',
	      transform: 'translate(14px, 20px) scale(1)',
	      '&$marginDense': {
	        transform: 'translate(14px, 12px) scale(1)'
	      },
	      '&$shrink': {
	        transform: 'translate(14px, -6px) scale(0.75)'
	      }
	    }
	  };
	};
	
	exports.styles = styles;
	var InputLabel = /*#__PURE__*/React.forwardRef(function InputLabel(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$disableAnimati = props.disableAnimation,
	      disableAnimation = _props$disableAnimati === void 0 ? false : _props$disableAnimati,
	      margin = props.margin,
	      shrinkProp = props.shrink,
	      variant = props.variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "disableAnimation", "margin", "shrink", "variant"]);
	  var muiFormControl = (0, _useFormControl.default)();
	  var shrink = shrinkProp;
	
	  if (typeof shrink === 'undefined' && muiFormControl) {
	    shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
	  }
	
	  var fcs = (0, _formControlState.default)({
	    props: props,
	    muiFormControl: muiFormControl,
	    states: ['margin', 'variant']
	  });
	  return /*#__PURE__*/React.createElement(_FormLabel.default, (0, _extends2.default)({
	    "data-shrink": shrink,
	    className: (0, _clsx.default)(classes.root, className, muiFormControl && classes.formControl, !disableAnimation && classes.animated, shrink && classes.shrink, fcs.margin === 'dense' && classes.marginDense, {
	      'filled': classes.filled,
	      'outlined': classes.outlined
	    }[fcs.variant]),
	    classes: {
	      focused: classes.focused,
	      disabled: classes.disabled,
	      error: classes.error,
	      required: classes.required,
	      asterisk: classes.asterisk
	    },
	    ref: ref
	  }, other));
	});
	 false ? InputLabel.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The contents of the `InputLabel`.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['primary', 'secondary']),
	
	  /**
	   * If `true`, the transition animation is disabled.
	   */
	  disableAnimation: _propTypes.default.bool,
	
	  /**
	   * If `true`, apply disabled class.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the label will be displayed in an error state.
	   */
	  error: _propTypes.default.bool,
	
	  /**
	   * If `true`, the input of this label is focused.
	   */
	  focused: _propTypes.default.bool,
	
	  /**
	   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
	   * FormControl.
	   */
	  margin: _propTypes.default.oneOf(['dense']),
	
	  /**
	   * if `true`, the label will indicate that the input is required.
	   */
	  required: _propTypes.default.bool,
	
	  /**
	   * If `true`, the label is shrunk.
	   */
	  shrink: _propTypes.default.bool,
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['filled', 'outlined', 'standard'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiInputLabel'
	})(InputLabel);
	
	exports.default = _default;

/***/ },
/* 726 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _InputLabel.default;
	  }
	});
	
	var _InputLabel = _interopRequireDefault(__webpack_require__(725));

/***/ },
/* 727 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(25));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(37));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(41));
	
	var _ListContext = _interopRequireDefault(__webpack_require__(728));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    listStyle: 'none',
	    margin: 0,
	    padding: 0,
	    position: 'relative'
	  },
	
	  /* Styles applied to the root element if `disablePadding={false}`. */
	  padding: {
	    paddingTop: 8,
	    paddingBottom: 8
	  },
	
	  /* Styles applied to the root element if dense. */
	  dense: {},
	
	  /* Styles applied to the root element if a `subheader` is provided. */
	  subheader: {
	    paddingTop: 0
	  }
	};
	exports.styles = styles;
	var List = /*#__PURE__*/React.forwardRef(function List(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'ul' : _props$component,
	      _props$dense = props.dense,
	      dense = _props$dense === void 0 ? false : _props$dense,
	      _props$disablePadding = props.disablePadding,
	      disablePadding = _props$disablePadding === void 0 ? false : _props$disablePadding,
	      subheader = props.subheader,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "component", "dense", "disablePadding", "subheader"]);
	  var context = React.useMemo(function () {
	    return {
	      dense: dense
	    };
	  }, [dense]);
	  return /*#__PURE__*/React.createElement(_ListContext.default.Provider, {
	    value: context
	  }, /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, dense && classes.dense, !disablePadding && classes.padding, subheader && classes.subheader),
	    ref: ref
	  }, other), subheader, children));
	});
	 false ? List.propTypes = {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .elementType,
	
	  /**
	   * If `true`, compact vertical padding designed for keyboard and mouse input will be used for
	   * the list and list items.
	   * The prop is available to descendant components as the `dense` context.
	   */
	  dense: _propTypes.default.bool,
	
	  /**
	   * If `true`, vertical padding will be removed from the list.
	   */
	  disablePadding: _propTypes.default.bool,
	
	  /**
	   * The content of the subheader, normally `ListSubheader`.
	   */
	  subheader: _propTypes.default.node
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiList'
	})(List);
	
	exports.default = _default;

/***/ },
/* 728 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	/**
	 * @ignore - internal component.
	 */
	var ListContext = React.createContext({});
	
	if (false) {
	  ListContext.displayName = 'ListContext';
	}
	
	var _default = ListContext;
	exports.default = _default;

/***/ },
/* 729 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _List.default;
	  }
	});
	
	var _List = _interopRequireDefault(__webpack_require__(727));

/***/ },
/* 730 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(25));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(37));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(41));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(78));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      boxSizing: 'border-box',
	      lineHeight: '48px',
	      listStyle: 'none',
	      color: theme.palette.text.secondary,
	      fontFamily: theme.typography.fontFamily,
	      fontWeight: theme.typography.fontWeightMedium,
	      fontSize: theme.typography.pxToRem(14)
	    },
	
	    /* Styles applied to the root element if `color="primary"`. */
	    colorPrimary: {
	      color: theme.palette.primary.main
	    },
	
	    /* Styles applied to the root element if `color="inherit"`. */
	    colorInherit: {
	      color: 'inherit'
	    },
	
	    /* Styles applied to the inner `component` element if `disableGutters={false}`. */
	    gutters: {
	      paddingLeft: 16,
	      paddingRight: 16
	    },
	
	    /* Styles applied to the root element if `inset={true}`. */
	    inset: {
	      paddingLeft: 72
	    },
	
	    /* Styles applied to the root element if `disableSticky={false}`. */
	    sticky: {
	      position: 'sticky',
	      top: 0,
	      zIndex: 1,
	      backgroundColor: 'inherit'
	    }
	  };
	};
	
	exports.styles = styles;
	var ListSubheader = /*#__PURE__*/React.forwardRef(function ListSubheader(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'default' : _props$color,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'li' : _props$component,
	      _props$disableGutters = props.disableGutters,
	      disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters,
	      _props$disableSticky = props.disableSticky,
	      disableSticky = _props$disableSticky === void 0 ? false : _props$disableSticky,
	      _props$inset = props.inset,
	      inset = _props$inset === void 0 ? false : _props$inset,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "color", "component", "disableGutters", "disableSticky", "inset"]);
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, color !== 'default' && classes["color".concat((0, _capitalize.default)(color))], inset && classes.inset, !disableSticky && classes.sticky, !disableGutters && classes.gutters),
	    ref: ref
	  }, other));
	});
	 false ? ListSubheader.propTypes = {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['default', 'primary', 'inherit']),
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .elementType,
	
	  /**
	   * If `true`, the List Subheader will not have gutters.
	   */
	  disableGutters: _propTypes.default.bool,
	
	  /**
	   * If `true`, the List Subheader will not stick to the top during scroll.
	   */
	  disableSticky: _propTypes.default.bool,
	
	  /**
	   * If `true`, the List Subheader will be indented.
	   */
	  inset: _propTypes.default.bool
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiListSubheader'
	})(ListSubheader);
	
	exports.default = _default;

/***/ },
/* 731 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ListSubheader.default;
	  }
	});
	
	var _ListSubheader = _interopRequireDefault(__webpack_require__(730));

/***/ },
/* 732 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(25));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _reactIs = __webpack_require__(168);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(37));
	
	var _utils = __webpack_require__(26);
	
	var _withStyles = _interopRequireDefault(__webpack_require__(41));
	
	var _Popover = _interopRequireDefault(__webpack_require__(743));
	
	var _MenuList = _interopRequireDefault(__webpack_require__(734));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(43));
	
	var _setRef = _interopRequireDefault(__webpack_require__(143));
	
	var _useTheme = _interopRequireDefault(__webpack_require__(178));
	
	var _deprecatedPropType = _interopRequireDefault(__webpack_require__(94));
	
	var RTL_ORIGIN = {
	  vertical: 'top',
	  horizontal: 'right'
	};
	var LTR_ORIGIN = {
	  vertical: 'top',
	  horizontal: 'left'
	};
	var styles = {
	  /* Styles applied to the `Paper` component. */
	  paper: {
	    // specZ: The maximum height of a simple menu should be one or more rows less than the view
	    // height. This ensures a tapable area outside of the simple menu with which to dismiss
	    // the menu.
	    maxHeight: 'calc(100% - 96px)',
	    // Add iOS momentum scrolling.
	    WebkitOverflowScrolling: 'touch'
	  },
	
	  /* Styles applied to the `List` component via `MenuList`. */
	  list: {
	    // We disable the focus ring for mouse, touch and keyboard users.
	    outline: 0
	  }
	};
	exports.styles = styles;
	var Menu = /*#__PURE__*/React.forwardRef(function Menu(props, ref) {
	  var _props$autoFocus = props.autoFocus,
	      autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus,
	      children = props.children,
	      classes = props.classes,
	      _props$disableAutoFoc = props.disableAutoFocusItem,
	      disableAutoFocusItem = _props$disableAutoFoc === void 0 ? false : _props$disableAutoFoc,
	      _props$MenuListProps = props.MenuListProps,
	      MenuListProps = _props$MenuListProps === void 0 ? {} : _props$MenuListProps,
	      onClose = props.onClose,
	      onEnteringProp = props.onEntering,
	      open = props.open,
	      _props$PaperProps = props.PaperProps,
	      PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps,
	      PopoverClasses = props.PopoverClasses,
	      _props$transitionDura = props.transitionDuration,
	      transitionDuration = _props$transitionDura === void 0 ? 'auto' : _props$transitionDura,
	      _props$TransitionProp = props.TransitionProps;
	  _props$TransitionProp = _props$TransitionProp === void 0 ? {} : _props$TransitionProp;
	  var onEntering = _props$TransitionProp.onEntering,
	      TransitionProps = (0, _objectWithoutProperties2.default)(_props$TransitionProp, ["onEntering"]),
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'selectedMenu' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["autoFocus", "children", "classes", "disableAutoFocusItem", "MenuListProps", "onClose", "onEntering", "open", "PaperProps", "PopoverClasses", "transitionDuration", "TransitionProps", "variant"]);
	  var theme = (0, _useTheme.default)();
	  var autoFocusItem = autoFocus && !disableAutoFocusItem && open;
	  var menuListActionsRef = React.useRef(null);
	  var contentAnchorRef = React.useRef(null);
	
	  var getContentAnchorEl = function getContentAnchorEl() {
	    return contentAnchorRef.current;
	  };
	
	  var handleEntering = function handleEntering(element, isAppearing) {
	    if (menuListActionsRef.current) {
	      menuListActionsRef.current.adjustStyleForScrollbar(element, theme);
	    }
	
	    if (onEnteringProp) {
	      onEnteringProp(element, isAppearing);
	    }
	
	    if (onEntering) {
	      onEntering(element, isAppearing);
	    }
	  };
	
	  var handleListKeyDown = function handleListKeyDown(event) {
	    if (event.key === 'Tab') {
	      event.preventDefault();
	
	      if (onClose) {
	        onClose(event, 'tabKeyDown');
	      }
	    }
	  };
	  /**
	   * the index of the item should receive focus
	   * in a `variant="selectedMenu"` it's the first `selected` item
	   * otherwise it's the very first item.
	   */
	
	
	  var activeItemIndex = -1; // since we inject focus related props into children we have to do a lookahead
	  // to check if there is a `selected` item. We're looking for the last `selected`
	  // item and use the first valid item as a fallback
	
	  React.Children.map(children, function (child, index) {
	    if (! /*#__PURE__*/React.isValidElement(child)) {
	      return;
	    }
	
	    if (false) {
	      if ((0, _reactIs.isFragment)(child)) {
	        console.error(["Material-UI: The Menu component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
	      }
	    }
	
	    if (!child.props.disabled) {
	      if (variant !== "menu" && child.props.selected) {
	        activeItemIndex = index;
	      } else if (activeItemIndex === -1) {
	        activeItemIndex = index;
	      }
	    }
	  });
	  var items = React.Children.map(children, function (child, index) {
	    if (index === activeItemIndex) {
	      return /*#__PURE__*/React.cloneElement(child, {
	        ref: function ref(instance) {
	          // #StrictMode ready
	          contentAnchorRef.current = ReactDOM.findDOMNode(instance);
	          (0, _setRef.default)(child.ref, instance);
	        }
	      });
	    }
	
	    return child;
	  });
	  return /*#__PURE__*/React.createElement(_Popover.default, (0, _extends2.default)({
	    getContentAnchorEl: getContentAnchorEl,
	    classes: PopoverClasses,
	    onClose: onClose,
	    TransitionProps: (0, _extends2.default)({
	      onEntering: handleEntering
	    }, TransitionProps),
	    anchorOrigin: theme.direction === 'rtl' ? RTL_ORIGIN : LTR_ORIGIN,
	    transformOrigin: theme.direction === 'rtl' ? RTL_ORIGIN : LTR_ORIGIN,
	    PaperProps: (0, _extends2.default)({}, PaperProps, {
	      classes: (0, _extends2.default)({}, PaperProps.classes, {
	        root: classes.paper
	      })
	    }),
	    open: open,
	    ref: ref,
	    transitionDuration: transitionDuration
	  }, other), /*#__PURE__*/React.createElement(_MenuList.default, (0, _extends2.default)({
	    onKeyDown: handleListKeyDown,
	    actions: menuListActionsRef,
	    autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
	    autoFocusItem: autoFocusItem,
	    variant: variant
	  }, MenuListProps, {
	    className: (0, _clsx.default)(classes.list, MenuListProps.className)
	  }), items));
	});
	 false ? Menu.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * A HTML element, or a function that returns it.
	   * It's used to set the position of the menu.
	   */
	  anchorEl: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .oneOfType([_utils.HTMLElementType, _propTypes.default.func]),
	
	  /**
	   * If `true` (Default) will focus the `[role="menu"]` if no focusable child is found. Disabled
	   * children are not focusable. If you set this prop to `false` focus will be placed
	   * on the parent modal container. This has severe accessibility implications
	   * and should only be considered if you manage focus otherwise.
	   */
	  autoFocus: _propTypes.default.bool,
	
	  /**
	   * Menu contents, normally `MenuItem`s.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * When opening the menu will not focus the active item but the `[role="menu"]`
	   * unless `autoFocus` is also set to `false`. Not using the default means not
	   * following WAI-ARIA authoring practices. Please be considerate about possible
	   * accessibility implications.
	   */
	  disableAutoFocusItem: _propTypes.default.bool,
	
	  /**
	   * Props applied to the [`MenuList`](/api/menu-list/) element.
	   */
	  MenuListProps: _propTypes.default.object,
	
	  /**
	   * Callback fired when the component requests to be closed.
	   *
	   * @param {object} event The event source of the callback.
	   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`, `"tabKeyDown"`.
	   */
	  onClose: _propTypes.default.func,
	
	  /**
	   * Callback fired before the Menu enters.
	   * @deprecated Use the `TransitionProps` prop instead.
	   */
	  onEnter: (0, _deprecatedPropType.default)(_propTypes.default.func, 'Use the `TransitionProps` prop instead.'),
	
	  /**
	   * Callback fired when the Menu has entered.
	   * @deprecated Use the `TransitionProps` prop instead.
	   */
	  onEntered: (0, _deprecatedPropType.default)(_propTypes.default.func, 'Use the `TransitionProps` prop instead.'),
	
	  /**
	   * Callback fired when the Menu is entering.
	   * @deprecated Use the `TransitionProps` prop instead.
	   */
	  onEntering: (0, _deprecatedPropType.default)(_propTypes.default.func, 'Use the `TransitionProps` prop instead.'),
	
	  /**
	   * Callback fired before the Menu exits.
	   * @deprecated Use the `TransitionProps` prop instead.
	   */
	  onExit: (0, _deprecatedPropType.default)(_propTypes.default.func, 'Use the `TransitionProps` prop instead.'),
	
	  /**
	   * Callback fired when the Menu has exited.
	   * @deprecated Use the `TransitionProps` prop instead.
	   */
	  onExited: (0, _deprecatedPropType.default)(_propTypes.default.func, 'Use the `TransitionProps` prop instead.'),
	
	  /**
	   * Callback fired when the Menu is exiting.
	   * @deprecated Use the `TransitionProps` prop instead.
	   */
	  onExiting: (0, _deprecatedPropType.default)(_propTypes.default.func, 'Use the `TransitionProps` prop instead.'),
	
	  /**
	   * If `true`, the menu is visible.
	   */
	  open: _propTypes.default.bool.isRequired,
	
	  /**
	   * @ignore
	   */
	  PaperProps: _propTypes.default.object,
	
	  /**
	   * `classes` prop applied to the [`Popover`](/api/popover/) element.
	   */
	  PopoverClasses: _propTypes.default.object,
	
	  /**
	   * The length of the transition in `ms`, or 'auto'
	   */
	  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.oneOf(['auto']), _propTypes.default.number, _propTypes.default.shape({
	    appear: _propTypes.default.number,
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  })]),
	
	  /**
	   * Props applied to the transition element.
	   * By default, the element is based on this [`Transition`](http://reactcommunity.org/react-transition-group/transition) component.
	   */
	  TransitionProps: _propTypes.default.object,
	
	  /**
	   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus
	   * and the vertical alignment relative to the anchor element.
	   */
	  variant: _propTypes.default.oneOf(['menu', 'selectedMenu'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiMenu'
	})(Menu);
	
	exports.default = _default;

/***/ },
/* 733 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(25));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _reactIs = __webpack_require__(168);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(43));
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(95));
	
	var _List = _interopRequireDefault(__webpack_require__(729));
	
	var _getScrollbarSize = _interopRequireDefault(__webpack_require__(329));
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(68));
	
	function nextItem(list, item, disableListWrap) {
	  if (list === item) {
	    return list.firstChild;
	  }
	
	  if (item && item.nextElementSibling) {
	    return item.nextElementSibling;
	  }
	
	  return disableListWrap ? null : list.firstChild;
	}
	
	function previousItem(list, item, disableListWrap) {
	  if (list === item) {
	    return disableListWrap ? list.firstChild : list.lastChild;
	  }
	
	  if (item && item.previousElementSibling) {
	    return item.previousElementSibling;
	  }
	
	  return disableListWrap ? null : list.lastChild;
	}
	
	function textCriteriaMatches(nextFocus, textCriteria) {
	  if (textCriteria === undefined) {
	    return true;
	  }
	
	  var text = nextFocus.innerText;
	
	  if (text === undefined) {
	    // jsdom doesn't support innerText
	    text = nextFocus.textContent;
	  }
	
	  text = text.trim().toLowerCase();
	
	  if (text.length === 0) {
	    return false;
	  }
	
	  if (textCriteria.repeating) {
	    return text[0] === textCriteria.keys[0];
	  }
	
	  return text.indexOf(textCriteria.keys.join('')) === 0;
	}
	
	function moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
	  var wrappedOnce = false;
	  var nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);
	
	  while (nextFocus) {
	    // Prevent infinite loop.
	    if (nextFocus === list.firstChild) {
	      if (wrappedOnce) {
	        return;
	      }
	
	      wrappedOnce = true;
	    } // Same logic as useAutocomplete.js
	
	
	    var nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute('aria-disabled') === 'true';
	
	    if (!nextFocus.hasAttribute('tabindex') || !textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) {
	      // Move to the next element.
	      nextFocus = traversalFunction(list, nextFocus, disableListWrap);
	    } else {
	      nextFocus.focus();
	      return;
	    }
	  }
	}
	
	var useEnhancedEffect = typeof window === 'undefined' ? React.useEffect : React.useLayoutEffect;
	/**
	 * A permanently displayed menu following https://www.w3.org/TR/wai-aria-practices/#menubutton.
	 * It's exposed to help customization of the [`Menu`](/api/menu/) component. If you
	 * use it separately you need to move focus into the component manually. Once
	 * the focus is placed inside the component it is fully keyboard accessible.
	 */
	
	var MenuList = /*#__PURE__*/React.forwardRef(function MenuList(props, ref) {
	  var actions = props.actions,
	      _props$autoFocus = props.autoFocus,
	      autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus,
	      _props$autoFocusItem = props.autoFocusItem,
	      autoFocusItem = _props$autoFocusItem === void 0 ? false : _props$autoFocusItem,
	      children = props.children,
	      className = props.className,
	      _props$disabledItemsF = props.disabledItemsFocusable,
	      disabledItemsFocusable = _props$disabledItemsF === void 0 ? false : _props$disabledItemsF,
	      _props$disableListWra = props.disableListWrap,
	      disableListWrap = _props$disableListWra === void 0 ? false : _props$disableListWra,
	      onKeyDown = props.onKeyDown,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'selectedMenu' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["actions", "autoFocus", "autoFocusItem", "children", "className", "disabledItemsFocusable", "disableListWrap", "onKeyDown", "variant"]);
	  var listRef = React.useRef(null);
	  var textCriteriaRef = React.useRef({
	    keys: [],
	    repeating: true,
	    previousKeyMatched: true,
	    lastTime: null
	  });
	  useEnhancedEffect(function () {
	    if (autoFocus) {
	      listRef.current.focus();
	    }
	  }, [autoFocus]);
	  React.useImperativeHandle(actions, function () {
	    return {
	      adjustStyleForScrollbar: function adjustStyleForScrollbar(containerElement, theme) {
	        // Let's ignore that piece of logic if users are already overriding the width
	        // of the menu.
	        var noExplicitWidth = !listRef.current.style.width;
	
	        if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
	          var scrollbarSize = "".concat((0, _getScrollbarSize.default)(true), "px");
	          listRef.current.style[theme.direction === 'rtl' ? 'paddingLeft' : 'paddingRight'] = scrollbarSize;
	          listRef.current.style.width = "calc(100% + ".concat(scrollbarSize, ")");
	        }
	
	        return listRef.current;
	      }
	    };
	  }, []);
	
	  var handleKeyDown = function handleKeyDown(event) {
	    var list = listRef.current;
	    var key = event.key;
	    /**
	     * @type {Element} - will always be defined since we are in a keydown handler
	     * attached to an element. A keydown event is either dispatched to the activeElement
	     * or document.body or document.documentElement. Only the first case will
	     * trigger this specific handler.
	     */
	
	    var currentFocus = (0, _ownerDocument.default)(list).activeElement;
	
	    if (key === 'ArrowDown') {
	      // Prevent scroll of the page
	      event.preventDefault();
	      moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, nextItem);
	    } else if (key === 'ArrowUp') {
	      event.preventDefault();
	      moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, previousItem);
	    } else if (key === 'Home') {
	      event.preventDefault();
	      moveFocus(list, null, disableListWrap, disabledItemsFocusable, nextItem);
	    } else if (key === 'End') {
	      event.preventDefault();
	      moveFocus(list, null, disableListWrap, disabledItemsFocusable, previousItem);
	    } else if (key.length === 1) {
	      var criteria = textCriteriaRef.current;
	      var lowerKey = key.toLowerCase();
	      var currTime = performance.now();
	
	      if (criteria.keys.length > 0) {
	        // Reset
	        if (currTime - criteria.lastTime > 500) {
	          criteria.keys = [];
	          criteria.repeating = true;
	          criteria.previousKeyMatched = true;
	        } else if (criteria.repeating && lowerKey !== criteria.keys[0]) {
	          criteria.repeating = false;
	        }
	      }
	
	      criteria.lastTime = currTime;
	      criteria.keys.push(lowerKey);
	      var keepFocusOnCurrent = currentFocus && !criteria.repeating && textCriteriaMatches(currentFocus, criteria);
	
	      if (criteria.previousKeyMatched && (keepFocusOnCurrent || moveFocus(list, currentFocus, false, disabledItemsFocusable, nextItem, criteria))) {
	        event.preventDefault();
	      } else {
	        criteria.previousKeyMatched = false;
	      }
	    }
	
	    if (onKeyDown) {
	      onKeyDown(event);
	    }
	  };
	
	  var handleOwnRef = React.useCallback(function (instance) {
	    // #StrictMode ready
	    listRef.current = ReactDOM.findDOMNode(instance);
	  }, []);
	  var handleRef = (0, _useForkRef.default)(handleOwnRef, ref);
	  /**
	   * the index of the item should receive focus
	   * in a `variant="selectedMenu"` it's the first `selected` item
	   * otherwise it's the very first item.
	   */
	
	  var activeItemIndex = -1; // since we inject focus related props into children we have to do a lookahead
	  // to check if there is a `selected` item. We're looking for the last `selected`
	  // item and use the first valid item as a fallback
	
	  React.Children.forEach(children, function (child, index) {
	    if (! /*#__PURE__*/React.isValidElement(child)) {
	      return;
	    }
	
	    if (false) {
	      if ((0, _reactIs.isFragment)(child)) {
	        console.error(["Material-UI: The Menu component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
	      }
	    }
	
	    if (!child.props.disabled) {
	      if (variant === 'selectedMenu' && child.props.selected) {
	        activeItemIndex = index;
	      } else if (activeItemIndex === -1) {
	        activeItemIndex = index;
	      }
	    }
	  });
	  var items = React.Children.map(children, function (child, index) {
	    if (index === activeItemIndex) {
	      var newChildProps = {};
	
	      if (autoFocusItem) {
	        newChildProps.autoFocus = true;
	      }
	
	      if (child.props.tabIndex === undefined && variant === 'selectedMenu') {
	        newChildProps.tabIndex = 0;
	      }
	
	      return /*#__PURE__*/React.cloneElement(child, newChildProps);
	    }
	
	    return child;
	  });
	  return /*#__PURE__*/React.createElement(_List.default, (0, _extends2.default)({
	    role: "menu",
	    ref: handleRef,
	    className: className,
	    onKeyDown: handleKeyDown,
	    tabIndex: autoFocus ? 0 : -1
	  }, other), items);
	});
	 false ? MenuList.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * If `true`, will focus the `[role="menu"]` container and move into tab order.
	   */
	  autoFocus: _propTypes.default.bool,
	
	  /**
	   * If `true`, will focus the first menuitem if `variant="menu"` or selected item
	   * if `variant="selectedMenu"`.
	   */
	  autoFocusItem: _propTypes.default.bool,
	
	  /**
	   * MenuList contents, normally `MenuItem`s.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, will allow focus on disabled items.
	   */
	  disabledItemsFocusable: _propTypes.default.bool,
	
	  /**
	   * If `true`, the menu items will not wrap focus.
	   */
	  disableListWrap: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  onKeyDown: _propTypes.default.func,
	
	  /**
	   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus
	   * and the vertical alignment relative to the anchor element.
	   */
	  variant: _propTypes.default.oneOf(['menu', 'selectedMenu'])
	} : void 0;
	var _default = MenuList;
	exports.default = _default;

/***/ },
/* 734 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _MenuList.default;
	  }
	});
	
	var _MenuList = _interopRequireDefault(__webpack_require__(733));

/***/ },
/* 735 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(25));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(43));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _styles = __webpack_require__(80);
	
	var _utils = __webpack_require__(26);
	
	var _deprecatedPropType = _interopRequireDefault(__webpack_require__(94));
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(95));
	
	var _Portal = _interopRequireDefault(__webpack_require__(325));
	
	var _createChainedFunction = _interopRequireDefault(__webpack_require__(179));
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(68));
	
	var _useEventCallback = _interopRequireDefault(__webpack_require__(180));
	
	var _zIndex = _interopRequireDefault(__webpack_require__(328));
	
	var _ModalManager = _interopRequireWildcard(__webpack_require__(321));
	
	var _Unstable_TrapFocus = _interopRequireDefault(__webpack_require__(756));
	
	var _SimpleBackdrop = _interopRequireDefault(__webpack_require__(736));
	
	function getContainer(container) {
	  container = typeof container === 'function' ? container() : container;
	  return ReactDOM.findDOMNode(container);
	}
	
	function getHasTransition(props) {
	  return props.children ? props.children.props.hasOwnProperty('in') : false;
	} // A modal manager used to track and manage the state of open Modals.
	// Modals don't open on the server so this won't conflict with concurrent requests.
	
	
	var defaultManager = new _ModalManager.default();
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      position: 'fixed',
	      zIndex: theme.zIndex.modal,
	      right: 0,
	      bottom: 0,
	      top: 0,
	      left: 0
	    },
	
	    /* Styles applied to the root element if the `Modal` has exited. */
	    hidden: {
	      visibility: 'hidden'
	    }
	  };
	};
	/**
	 * Modal is a lower-level construct that is leveraged by the following components:
	 *
	 * - [Dialog](/api/dialog/)
	 * - [Drawer](/api/drawer/)
	 * - [Menu](/api/menu/)
	 * - [Popover](/api/popover/)
	 *
	 * If you are creating a modal dialog, you probably want to use the [Dialog](/api/dialog/) component
	 * rather than directly using Modal.
	 *
	 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
	 */
	
	
	exports.styles = styles;
	var Modal = /*#__PURE__*/React.forwardRef(function Modal(inProps, ref) {
	  var theme = (0, _styles.useTheme)();
	  var props = (0, _styles.getThemeProps)({
	    name: 'MuiModal',
	    props: (0, _extends2.default)({}, inProps),
	    theme: theme
	  });
	  var _props$BackdropCompon = props.BackdropComponent,
	      BackdropComponent = _props$BackdropCompon === void 0 ? _SimpleBackdrop.default : _props$BackdropCompon,
	      BackdropProps = props.BackdropProps,
	      children = props.children,
	      _props$closeAfterTran = props.closeAfterTransition,
	      closeAfterTransition = _props$closeAfterTran === void 0 ? false : _props$closeAfterTran,
	      container = props.container,
	      _props$disableAutoFoc = props.disableAutoFocus,
	      disableAutoFocus = _props$disableAutoFoc === void 0 ? false : _props$disableAutoFoc,
	      _props$disableBackdro = props.disableBackdropClick,
	      disableBackdropClick = _props$disableBackdro === void 0 ? false : _props$disableBackdro,
	      _props$disableEnforce = props.disableEnforceFocus,
	      disableEnforceFocus = _props$disableEnforce === void 0 ? false : _props$disableEnforce,
	      _props$disableEscapeK = props.disableEscapeKeyDown,
	      disableEscapeKeyDown = _props$disableEscapeK === void 0 ? false : _props$disableEscapeK,
	      _props$disablePortal = props.disablePortal,
	      disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal,
	      _props$disableRestore = props.disableRestoreFocus,
	      disableRestoreFocus = _props$disableRestore === void 0 ? false : _props$disableRestore,
	      _props$disableScrollL = props.disableScrollLock,
	      disableScrollLock = _props$disableScrollL === void 0 ? false : _props$disableScrollL,
	      _props$hideBackdrop = props.hideBackdrop,
	      hideBackdrop = _props$hideBackdrop === void 0 ? false : _props$hideBackdrop,
	      _props$keepMounted = props.keepMounted,
	      keepMounted = _props$keepMounted === void 0 ? false : _props$keepMounted,
	      _props$manager = props.manager,
	      manager = _props$manager === void 0 ? defaultManager : _props$manager,
	      onBackdropClick = props.onBackdropClick,
	      onClose = props.onClose,
	      onEscapeKeyDown = props.onEscapeKeyDown,
	      onRendered = props.onRendered,
	      open = props.open,
	      other = (0, _objectWithoutProperties2.default)(props, ["BackdropComponent", "BackdropProps", "children", "closeAfterTransition", "container", "disableAutoFocus", "disableBackdropClick", "disableEnforceFocus", "disableEscapeKeyDown", "disablePortal", "disableRestoreFocus", "disableScrollLock", "hideBackdrop", "keepMounted", "manager", "onBackdropClick", "onClose", "onEscapeKeyDown", "onRendered", "open"]);
	
	  var _React$useState = React.useState(true),
	      exited = _React$useState[0],
	      setExited = _React$useState[1];
	
	  var modal = React.useRef({});
	  var mountNodeRef = React.useRef(null);
	  var modalRef = React.useRef(null);
	  var handleRef = (0, _useForkRef.default)(modalRef, ref);
	  var hasTransition = getHasTransition(props);
	
	  var getDoc = function getDoc() {
	    return (0, _ownerDocument.default)(mountNodeRef.current);
	  };
	
	  var getModal = function getModal() {
	    modal.current.modalRef = modalRef.current;
	    modal.current.mountNode = mountNodeRef.current;
	    return modal.current;
	  };
	
	  var handleMounted = function handleMounted() {
	    manager.mount(getModal(), {
	      disableScrollLock: disableScrollLock
	    }); // Fix a bug on Chrome where the scroll isn't initially 0.
	
	    modalRef.current.scrollTop = 0;
	  };
	
	  var handleOpen = (0, _useEventCallback.default)(function () {
	    var resolvedContainer = getContainer(container) || getDoc().body;
	    manager.add(getModal(), resolvedContainer); // The element was already mounted.
	
	    if (modalRef.current) {
	      handleMounted();
	    }
	  });
	  var isTopModal = React.useCallback(function () {
	    return manager.isTopModal(getModal());
	  }, [manager]);
	  var handlePortalRef = (0, _useEventCallback.default)(function (node) {
	    mountNodeRef.current = node;
	
	    if (!node) {
	      return;
	    }
	
	    if (onRendered) {
	      onRendered();
	    }
	
	    if (open && isTopModal()) {
	      handleMounted();
	    } else {
	      (0, _ModalManager.ariaHidden)(modalRef.current, true);
	    }
	  });
	  var handleClose = React.useCallback(function () {
	    manager.remove(getModal());
	  }, [manager]);
	  React.useEffect(function () {
	    return function () {
	      handleClose();
	    };
	  }, [handleClose]);
	  React.useEffect(function () {
	    if (open) {
	      handleOpen();
	    } else if (!hasTransition || !closeAfterTransition) {
	      handleClose();
	    }
	  }, [open, handleClose, hasTransition, closeAfterTransition, handleOpen]);
	
	  if (!keepMounted && !open && (!hasTransition || exited)) {
	    return null;
	  }
	
	  var handleEnter = function handleEnter() {
	    setExited(false);
	  };
	
	  var handleExited = function handleExited() {
	    setExited(true);
	
	    if (closeAfterTransition) {
	      handleClose();
	    }
	  };
	
	  var handleBackdropClick = function handleBackdropClick(event) {
	    if (event.target !== event.currentTarget) {
	      return;
	    }
	
	    if (onBackdropClick) {
	      onBackdropClick(event);
	    }
	
	    if (!disableBackdropClick && onClose) {
	      onClose(event, 'backdropClick');
	    }
	  };
	
	  var handleKeyDown = function handleKeyDown(event) {
	    // The handler doesn't take event.defaultPrevented into account:
	    //
	    // event.preventDefault() is meant to stop default behaviours like
	    // clicking a checkbox to check it, hitting a button to submit a form,
	    // and hitting left arrow to move the cursor in a text input etc.
	    // Only special HTML elements have these default behaviors.
	    if (event.key !== 'Escape' || !isTopModal()) {
	      return;
	    }
	
	    if (onEscapeKeyDown) {
	      onEscapeKeyDown(event);
	    }
	
	    if (!disableEscapeKeyDown) {
	      // Swallow the event, in case someone is listening for the escape key on the body.
	      event.stopPropagation();
	
	      if (onClose) {
	        onClose(event, 'escapeKeyDown');
	      }
	    }
	  };
	
	  var inlineStyle = styles(theme || {
	    zIndex: _zIndex.default
	  });
	  var childProps = {};
	
	  if (children.props.tabIndex === undefined) {
	    childProps.tabIndex = children.props.tabIndex || '-1';
	  } // It's a Transition like component
	
	
	  if (hasTransition) {
	    childProps.onEnter = (0, _createChainedFunction.default)(handleEnter, children.props.onEnter);
	    childProps.onExited = (0, _createChainedFunction.default)(handleExited, children.props.onExited);
	  }
	
	  return /*#__PURE__*/React.createElement(_Portal.default, {
	    ref: handlePortalRef,
	    container: container,
	    disablePortal: disablePortal
	  }, /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    ref: handleRef,
	    onKeyDown: handleKeyDown,
	    role: "presentation"
	  }, other, {
	    style: (0, _extends2.default)({}, inlineStyle.root, !open && exited ? inlineStyle.hidden : {}, other.style)
	  }), hideBackdrop ? null : /*#__PURE__*/React.createElement(BackdropComponent, (0, _extends2.default)({
	    open: open,
	    onClick: handleBackdropClick
	  }, BackdropProps)), /*#__PURE__*/React.createElement(_Unstable_TrapFocus.default, {
	    disableEnforceFocus: disableEnforceFocus,
	    disableAutoFocus: disableAutoFocus,
	    disableRestoreFocus: disableRestoreFocus,
	    getDoc: getDoc,
	    isEnabled: isTopModal,
	    open: open
	  }, /*#__PURE__*/React.cloneElement(children, childProps))));
	});
	 false ? Modal.propTypes = {
	  /**
	   * A backdrop component. This prop enables custom backdrop rendering.
	   */
	  BackdropComponent: _propTypes.default.elementType,
	
	  /**
	   * Props applied to the [`Backdrop`](/api/backdrop/) element.
	   */
	  BackdropProps: _propTypes.default.object,
	
	  /**
	   * A single child content element.
	   */
	  children: _utils.elementAcceptingRef.isRequired,
	
	  /**
	   * When set to true the Modal waits until a nested Transition is completed before closing.
	   */
	  closeAfterTransition: _propTypes.default.bool,
	
	  /**
	   * A HTML element, component instance, or function that returns either.
	   * The `container` will have the portal children appended to it.
	   *
	   * By default, it uses the body of the top-level document object,
	   * so it's simply `document.body` most of the time.
	   */
	  container: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .oneOfType([_utils.HTMLElementType, _propTypes.default.instanceOf(React.Component), _propTypes.default.func]),
	
	  /**
	   * If `true`, the modal will not automatically shift focus to itself when it opens, and
	   * replace it to the last focused element when it closes.
	   * This also works correctly with any modal children that have the `disableAutoFocus` prop.
	   *
	   * Generally this should never be set to `true` as it makes the modal less
	   * accessible to assistive technologies, like screen readers.
	   */
	  disableAutoFocus: _propTypes.default.bool,
	
	  /**
	   * If `true`, clicking the backdrop will not fire `onClose`.
	   */
	  disableBackdropClick: (0, _deprecatedPropType.default)(_propTypes.default.bool, 'Use the onClose prop with the `reason` argument to filter the `backdropClick` events.'),
	
	  /**
	   * If `true`, the modal will not prevent focus from leaving the modal while open.
	   *
	   * Generally this should never be set to `true` as it makes the modal less
	   * accessible to assistive technologies, like screen readers.
	   */
	  disableEnforceFocus: _propTypes.default.bool,
	
	  /**
	   * If `true`, hitting escape will not fire `onClose`.
	   */
	  disableEscapeKeyDown: _propTypes.default.bool,
	
	  /**
	   * Disable the portal behavior.
	   * The children stay within it's parent DOM hierarchy.
	   */
	  disablePortal: _propTypes.default.bool,
	
	  /**
	   * If `true`, the modal will not restore focus to previously focused element once
	   * modal is hidden.
	   */
	  disableRestoreFocus: _propTypes.default.bool,
	
	  /**
	   * Disable the scroll lock behavior.
	   */
	  disableScrollLock: _propTypes.default.bool,
	
	  /**
	   * If `true`, the backdrop is not rendered.
	   */
	  hideBackdrop: _propTypes.default.bool,
	
	  /**
	   * Always keep the children in the DOM.
	   * This prop can be useful in SEO situation or
	   * when you want to maximize the responsiveness of the Modal.
	   */
	  keepMounted: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  manager: _propTypes.default.object,
	
	  /**
	   * Callback fired when the backdrop is clicked.
	   */
	  onBackdropClick: (0, _deprecatedPropType.default)(_propTypes.default.func, 'Use the onClose prop with the `reason` argument to handle the `backdropClick` events.'),
	
	  /**
	   * Callback fired when the component requests to be closed.
	   * The `reason` parameter can optionally be used to control the response to `onClose`.
	   *
	   * @param {object} event The event source of the callback.
	   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
	   */
	  onClose: _propTypes.default.func,
	
	  /**
	   * Callback fired when the escape key is pressed,
	   * `disableEscapeKeyDown` is false and the modal is in focus.
	   */
	  onEscapeKeyDown: (0, _deprecatedPropType.default)(_propTypes.default.func, 'Use the onClose prop with the `reason` argument to handle the `escapeKeyDown` events.'),
	
	  /**
	   * Callback fired once the children has been mounted into the `container`.
	   * It signals that the `open={true}` prop took effect.
	   *
	   * This prop will be removed in v5, the ref can be used instead.
	   */
	  onRendered: (0, _deprecatedPropType.default)(_propTypes.default.func, 'Use the ref instead.'),
	
	  /**
	   * If `true`, the modal is open.
	   */
	  open: _propTypes.default.bool.isRequired
	} : void 0;
	var _default = Modal;
	exports.default = _default;

/***/ },
/* 736 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(25));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    zIndex: -1,
	    position: 'fixed',
	    right: 0,
	    bottom: 0,
	    top: 0,
	    left: 0,
	    backgroundColor: 'rgba(0, 0, 0, 0.5)',
	    WebkitTapHighlightColor: 'transparent'
	  },
	
	  /* Styles applied to the root element if `invisible={true}`. */
	  invisible: {
	    backgroundColor: 'transparent'
	  }
	};
	/**
	 * @ignore - internal component.
	 */
	
	exports.styles = styles;
	var SimpleBackdrop = /*#__PURE__*/React.forwardRef(function SimpleBackdrop(props, ref) {
	  var _props$invisible = props.invisible,
	      invisible = _props$invisible === void 0 ? false : _props$invisible,
	      open = props.open,
	      other = (0, _objectWithoutProperties2.default)(props, ["invisible", "open"]);
	  return open ? /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    "aria-hidden": true,
	    ref: ref
	  }, other, {
	    style: (0, _extends2.default)({}, styles.root, invisible ? styles.invisible : {}, other.style)
	  })) : null;
	});
	 false ? SimpleBackdrop.propTypes = {
	  /**
	   * If `true`, the backdrop is invisible.
	   * It can be used when rendering a popover or a custom select component.
	   */
	  invisible: _propTypes.default.bool,
	
	  /**
	   * If `true`, the backdrop is open.
	   */
	  open: _propTypes.default.bool.isRequired
	} : void 0;
	var _default = SimpleBackdrop;
	exports.default = _default;

/***/ },
/* 737 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Modal.default;
	  }
	});
	Object.defineProperty(exports, "ModalManager", {
	  enumerable: true,
	  get: function get() {
	    return _ModalManager.default;
	  }
	});
	
	var _Modal = _interopRequireDefault(__webpack_require__(735));
	
	var _ModalManager = _interopRequireDefault(__webpack_require__(321));

/***/ },
/* 738 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(25));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _NativeSelectInput = _interopRequireDefault(__webpack_require__(322));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(41));
	
	var _formControlState = _interopRequireDefault(__webpack_require__(117));
	
	var _useFormControl = _interopRequireDefault(__webpack_require__(118));
	
	var _ArrowDropDown = _interopRequireDefault(__webpack_require__(326));
	
	var _Input = _interopRequireDefault(__webpack_require__(231));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the select component `root` class. */
	    root: {},
	
	    /* Styles applied to the select component `select` class. */
	    select: {
	      '-moz-appearance': 'none',
	      // Reset
	      '-webkit-appearance': 'none',
	      // Reset
	      // When interacting quickly, the text can end up selected.
	      // Native select can't be selected either.
	      userSelect: 'none',
	      borderRadius: 0,
	      // Reset
	      minWidth: 16,
	      // So it doesn't collapse.
	      cursor: 'pointer',
	      '&:focus': {
	        // Show that it's not an text input
	        backgroundColor: theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.05)' : 'rgba(255, 255, 255, 0.05)',
	        borderRadius: 0 // Reset Chrome style
	
	      },
	      // Remove IE 11 arrow
	      '&::-ms-expand': {
	        display: 'none'
	      },
	      '&$disabled': {
	        cursor: 'default'
	      },
	      '&[multiple]': {
	        height: 'auto'
	      },
	      '&:not([multiple]) option, &:not([multiple]) optgroup': {
	        backgroundColor: theme.palette.background.paper
	      },
	      '&&': {
	        paddingRight: 24
	      }
	    },
	
	    /* Styles applied to the select component if `variant="filled"`. */
	    filled: {
	      '&&': {
	        paddingRight: 32
	      }
	    },
	
	    /* Styles applied to the select component if `variant="outlined"`. */
	    outlined: {
	      borderRadius: theme.shape.borderRadius,
	      '&&': {
	        paddingRight: 32
	      }
	    },
	
	    /* Styles applied to the select component `selectMenu` class. */
	    selectMenu: {
	      height: 'auto',
	      // Resets for multpile select with chips
	      minHeight: '1.1876em',
	      // Required for select\text-field height consistency
	      textOverflow: 'ellipsis',
	      whiteSpace: 'nowrap',
	      overflow: 'hidden'
	    },
	
	    /* Pseudo-class applied to the select component `disabled` class. */
	    disabled: {},
	
	    /* Styles applied to the icon component. */
	    icon: {
	      // We use a position absolute over a flexbox in order to forward the pointer events
	      // to the input and to support wrapping tags..
	      position: 'absolute',
	      right: 0,
	      top: 'calc(50% - 12px)',
	      // Center vertically
	      pointerEvents: 'none',
	      // Don't block pointer events on the select under the icon.
	      color: theme.palette.action.active,
	      '&$disabled': {
	        color: theme.palette.action.disabled
	      }
	    },
	
	    /* Styles applied to the icon component if the popup is open. */
	    iconOpen: {
	      transform: 'rotate(180deg)'
	    },
	
	    /* Styles applied to the icon component if `variant="filled"`. */
	    iconFilled: {
	      right: 7
	    },
	
	    /* Styles applied to the icon component if `variant="outlined"`. */
	    iconOutlined: {
	      right: 7
	    },
	
	    /* Styles applied to the underlying native input component. */
	    nativeInput: {
	      bottom: 0,
	      left: 0,
	      position: 'absolute',
	      opacity: 0,
	      pointerEvents: 'none',
	      width: '100%'
	    }
	  };
	};
	
	exports.styles = styles;
	var defaultInput = /*#__PURE__*/React.createElement(_Input.default, null);
	/**
	 * An alternative to `<Select native />` with a much smaller bundle size footprint.
	 */
	
	var NativeSelect = /*#__PURE__*/React.forwardRef(function NativeSelect(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      _props$IconComponent = props.IconComponent,
	      IconComponent = _props$IconComponent === void 0 ? _ArrowDropDown.default : _props$IconComponent,
	      _props$input = props.input,
	      input = _props$input === void 0 ? defaultInput : _props$input,
	      inputProps = props.inputProps,
	      variant = props.variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "IconComponent", "input", "inputProps", "variant"]);
	  var muiFormControl = (0, _useFormControl.default)();
	  var fcs = (0, _formControlState.default)({
	    props: props,
	    muiFormControl: muiFormControl,
	    states: ['variant']
	  });
	  return /*#__PURE__*/React.cloneElement(input, (0, _extends2.default)({
	    // Most of the logic is implemented in `NativeSelectInput`.
	    // The `Select` component is a simple API wrapper to expose something better to play with.
	    inputComponent: _NativeSelectInput.default,
	    inputProps: (0, _extends2.default)({
	      children: children,
	      classes: classes,
	      IconComponent: IconComponent,
	      variant: fcs.variant,
	      type: undefined
	    }, inputProps, input ? input.props.inputProps : {}),
	    ref: ref
	  }, other));
	});
	 false ? NativeSelect.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The option elements to populate the select with.
	   * Can be some `<option>` elements.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * The icon that displays the arrow.
	   */
	  IconComponent: _propTypes.default.elementType,
	
	  /**
	   * An `Input` element; does not have to be a material-ui specific `Input`.
	   */
	  input: _propTypes.default.element,
	
	  /**
	   * Attributes applied to the `select` element.
	   */
	  inputProps: _propTypes.default.object,
	
	  /**
	   * Callback function fired when a menu item is selected.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new value by accessing `event.target.value` (string).
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * The input value. The DOM API casts this to a string.
	   */
	  value: _propTypes.default.any,
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['filled', 'outlined', 'standard'])
	} : void 0;
	NativeSelect.muiName = 'Select';
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiNativeSelect'
	})(NativeSelect);
	
	exports.default = _default;

/***/ },
/* 739 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(24));
	
	var _extends3 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(25));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(37));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(41));
	
	var _useTheme = _interopRequireDefault(__webpack_require__(178));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(78));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      position: 'absolute',
	      bottom: 0,
	      right: 0,
	      top: -5,
	      left: 0,
	      margin: 0,
	      padding: '0 8px',
	      pointerEvents: 'none',
	      borderRadius: 'inherit',
	      borderStyle: 'solid',
	      borderWidth: 1,
	      overflow: 'hidden'
	    },
	
	    /* Styles applied to the legend element when `labelWidth` is provided. */
	    legend: {
	      textAlign: 'left',
	      padding: 0,
	      lineHeight: '11px',
	      // sync with `height` in `legend` styles
	      transition: theme.transitions.create('width', {
	        duration: 150,
	        easing: theme.transitions.easing.easeOut
	      })
	    },
	
	    /* Styles applied to the legend element. */
	    legendLabelled: {
	      display: 'block',
	      width: 'auto',
	      textAlign: 'left',
	      padding: 0,
	      height: 11,
	      // sync with `lineHeight` in `legend` styles
	      fontSize: '0.75em',
	      visibility: 'hidden',
	      maxWidth: 0.01,
	      transition: theme.transitions.create('max-width', {
	        duration: 50,
	        easing: theme.transitions.easing.easeOut
	      }),
	      '& > span': {
	        paddingLeft: 5,
	        paddingRight: 5,
	        display: 'inline-block'
	      }
	    },
	
	    /* Styles applied to the legend element is notched. */
	    legendNotched: {
	      maxWidth: 1000,
	      transition: theme.transitions.create('max-width', {
	        duration: 100,
	        easing: theme.transitions.easing.easeOut,
	        delay: 50
	      })
	    }
	  };
	};
	/**
	 * @ignore - internal component.
	 */
	
	
	exports.styles = styles;
	var NotchedOutline = /*#__PURE__*/React.forwardRef(function NotchedOutline(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      label = props.label,
	      labelWidthProp = props.labelWidth,
	      notched = props.notched,
	      style = props.style,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "label", "labelWidth", "notched", "style"]);
	  var theme = (0, _useTheme.default)();
	  var align = theme.direction === 'rtl' ? 'right' : 'left';
	
	  if (label !== undefined) {
	    return /*#__PURE__*/React.createElement("fieldset", (0, _extends3.default)({
	      "aria-hidden": true,
	      className: (0, _clsx.default)(classes.root, className),
	      ref: ref,
	      style: style
	    }, other), /*#__PURE__*/React.createElement("legend", {
	      className: (0, _clsx.default)(classes.legendLabelled, notched && classes.legendNotched)
	    }, label ? /*#__PURE__*/React.createElement("span", null, label) : /*#__PURE__*/React.createElement("span", {
	      dangerouslySetInnerHTML: {
	        __html: '&#8203;'
	      }
	    })));
	  }
	
	  var labelWidth = labelWidthProp > 0 ? labelWidthProp * 0.75 + 8 : 0.01;
	  return /*#__PURE__*/React.createElement("fieldset", (0, _extends3.default)({
	    "aria-hidden": true,
	    style: (0, _extends3.default)((0, _defineProperty2.default)({}, "padding".concat((0, _capitalize.default)(align)), 8), style),
	    className: (0, _clsx.default)(classes.root, className),
	    ref: ref
	  }, other), /*#__PURE__*/React.createElement("legend", {
	    className: classes.legend,
	    style: {
	      // IE 11: fieldset with legend does not render
	      // a border radius. This maintains consistency
	      // by always having a legend rendered
	      width: notched ? labelWidth : 0.01
	    }
	  }, /*#__PURE__*/React.createElement("span", {
	    dangerouslySetInnerHTML: {
	      __html: '&#8203;'
	    }
	  })));
	});
	 false ? NotchedOutline.propTypes = {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The label.
	   */
	  label: _propTypes.default.node,
	
	  /**
	   * The width of the label.
	   */
	  labelWidth: _propTypes.default.number.isRequired,
	
	  /**
	   * If `true`, the outline is notched to accommodate the label.
	   */
	  notched: _propTypes.default.bool.isRequired,
	
	  /**
	   * @ignore
	   */
	  style: _propTypes.default.object
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'PrivateNotchedOutline'
	})(NotchedOutline);
	
	exports.default = _default;

/***/ },
/* 740 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(25));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(37));
	
	var _utils = __webpack_require__(26);
	
	var _InputBase = _interopRequireDefault(__webpack_require__(232));
	
	var _NotchedOutline = _interopRequireDefault(__webpack_require__(739));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(41));
	
	var styles = function styles(theme) {
	  var borderColor = theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      position: 'relative',
	      borderRadius: theme.shape.borderRadius,
	      '&:hover $notchedOutline': {
	        borderColor: theme.palette.text.primary
	      },
	      // Reset on touch devices, it doesn't add specificity
	      '@media (hover: none)': {
	        '&:hover $notchedOutline': {
	          borderColor: borderColor
	        }
	      },
	      '&$focused $notchedOutline': {
	        borderColor: theme.palette.primary.main,
	        borderWidth: 2
	      },
	      '&$error $notchedOutline': {
	        borderColor: theme.palette.error.main
	      },
	      '&$disabled $notchedOutline': {
	        borderColor: theme.palette.action.disabled
	      }
	    },
	
	    /* Styles applied to the root element if the color is secondary. */
	    colorSecondary: {
	      '&$focused $notchedOutline': {
	        borderColor: theme.palette.secondary.main
	      }
	    },
	
	    /* Styles applied to the root element if the component is focused. */
	    focused: {},
	
	    /* Styles applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the root element if `startAdornment` is provided. */
	    adornedStart: {
	      paddingLeft: 14
	    },
	
	    /* Styles applied to the root element if `endAdornment` is provided. */
	    adornedEnd: {
	      paddingRight: 14
	    },
	
	    /* Pseudo-class applied to the root element if `error={true}`. */
	    error: {},
	
	    /* Styles applied to the `input` element if `margin="dense"`. */
	    marginDense: {},
	
	    /* Styles applied to the root element if `multiline={true}`. */
	    multiline: {
	      padding: '18.5px 14px',
	      '&$marginDense': {
	        paddingTop: 10.5,
	        paddingBottom: 10.5
	      }
	    },
	
	    /* Styles applied to the `NotchedOutline` element. */
	    notchedOutline: {
	      borderColor: borderColor
	    },
	
	    /* Styles applied to the `input` element. */
	    input: {
	      padding: '18.5px 14px',
	      '&:-webkit-autofill': {
	        WebkitBoxShadow: theme.palette.type === 'light' ? null : '0 0 0 100px #266798 inset',
	        WebkitTextFillColor: theme.palette.type === 'light' ? null : '#fff',
	        caretColor: theme.palette.type === 'light' ? null : '#fff',
	        borderRadius: 'inherit'
	      }
	    },
	
	    /* Styles applied to the `input` element if `margin="dense"`. */
	    inputMarginDense: {
	      paddingTop: 10.5,
	      paddingBottom: 10.5
	    },
	
	    /* Styles applied to the `input` element if `multiline={true}`. */
	    inputMultiline: {
	      padding: 0
	    },
	
	    /* Styles applied to the `input` element if `startAdornment` is provided. */
	    inputAdornedStart: {
	      paddingLeft: 0
	    },
	
	    /* Styles applied to the `input` element if `endAdornment` is provided. */
	    inputAdornedEnd: {
	      paddingRight: 0
	    }
	  };
	};
	
	exports.styles = styles;
	var OutlinedInput = /*#__PURE__*/React.forwardRef(function OutlinedInput(props, ref) {
	  var classes = props.classes,
	      _props$fullWidth = props.fullWidth,
	      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
	      _props$inputComponent = props.inputComponent,
	      inputComponent = _props$inputComponent === void 0 ? 'input' : _props$inputComponent,
	      label = props.label,
	      _props$labelWidth = props.labelWidth,
	      labelWidth = _props$labelWidth === void 0 ? 0 : _props$labelWidth,
	      _props$multiline = props.multiline,
	      multiline = _props$multiline === void 0 ? false : _props$multiline,
	      notched = props.notched,
	      _props$type = props.type,
	      type = _props$type === void 0 ? 'text' : _props$type,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "fullWidth", "inputComponent", "label", "labelWidth", "multiline", "notched", "type"]);
	  return /*#__PURE__*/React.createElement(_InputBase.default, (0, _extends2.default)({
	    renderSuffix: function renderSuffix(state) {
	      return /*#__PURE__*/React.createElement(_NotchedOutline.default, {
	        className: classes.notchedOutline,
	        label: label,
	        labelWidth: labelWidth,
	        notched: typeof notched !== 'undefined' ? notched : Boolean(state.startAdornment || state.filled || state.focused)
	      });
	    },
	    classes: (0, _extends2.default)({}, classes, {
	      root: (0, _clsx.default)(classes.root, classes.underline),
	      notchedOutline: null
	    }),
	    fullWidth: fullWidth,
	    inputComponent: inputComponent,
	    multiline: multiline,
	    ref: ref,
	    type: type
	  }, other));
	});
	 false ? OutlinedInput.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * This prop helps users to fill forms faster, especially on mobile devices.
	   * The name can be confusing, as it's more like an autofill.
	   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
	   */
	  autoComplete: _propTypes.default.string,
	
	  /**
	   * If `true`, the `input` element will be focused during the first mount.
	   */
	  autoFocus: _propTypes.default.bool,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['primary', 'secondary']),
	
	  /**
	   * The default `input` element value. Use when the component is not controlled.
	   */
	  defaultValue: _propTypes.default.any,
	
	  /**
	   * If `true`, the `input` element will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * End `InputAdornment` for this component.
	   */
	  endAdornment: _propTypes.default.node,
	
	  /**
	   * If `true`, the input will indicate an error. This is normally obtained via context from
	   * FormControl.
	   */
	  error: _propTypes.default.bool,
	
	  /**
	   * If `true`, the input will take up the full width of its container.
	   */
	  fullWidth: _propTypes.default.bool,
	
	  /**
	   * The id of the `input` element.
	   */
	  id: _propTypes.default.string,
	
	  /**
	   * The component used for the `input` element.
	   * Either a string to use a HTML element or a component.
	   */
	  inputComponent: _propTypes.default.elementType,
	
	  /**
	   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
	   */
	  inputProps: _propTypes.default.object,
	
	  /**
	   * Pass a ref to the `input` element.
	   */
	  inputRef: _utils.refType,
	
	  /**
	   * The label of the input. It is only used for layout. The actual labelling
	   * is handled by `InputLabel`. If specified `labelWidth` is ignored.
	   */
	  label: _propTypes.default.node,
	
	  /**
	   * The width of the label. Is ignored if `label` is provided. Prefer `label`
	   * if the input label appears with a strike through.
	   */
	  labelWidth: _propTypes.default.number,
	
	  /**
	   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
	   * FormControl.
	   */
	  margin: _propTypes.default.oneOf(['dense', 'none']),
	
	  /**
	   * Maximum number of rows to display when multiline option is set to true.
	   */
	  maxRows: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * If `true`, a textarea element will be rendered.
	   */
	  multiline: _propTypes.default.bool,
	
	  /**
	   * Name attribute of the `input` element.
	   */
	  name: _propTypes.default.string,
	
	  /**
	   * If `true`, the outline is notched to accommodate the label.
	   */
	  notched: _propTypes.default.bool,
	
	  /**
	   * Callback fired when the value is changed.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new value by accessing `event.target.value` (string).
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * The short hint displayed in the input before the user enters a value.
	   */
	  placeholder: _propTypes.default.string,
	
	  /**
	   * It prevents the user from changing the value of the field
	   * (not from interacting with the field).
	   */
	  readOnly: _propTypes.default.bool,
	
	  /**
	   * If `true`, the `input` element will be required.
	   */
	  required: _propTypes.default.bool,
	
	  /**
	   * Number of rows to display when multiline option is set to true.
	   */
	  rows: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * Start `InputAdornment` for this component.
	   */
	  startAdornment: _propTypes.default.node,
	
	  /**
	   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
	   */
	  type: _propTypes.default.string,
	
	  /**
	   * The value of the `input` element, required for a controlled component.
	   */
	  value: _propTypes.default.any
	} : void 0;
	OutlinedInput.muiName = 'Input';
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiOutlinedInput'
	})(OutlinedInput);
	
	exports.default = _default;

/***/ },
/* 741 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(25));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(37));
	
	var _utils = __webpack_require__(26);
	
	var _withStyles = _interopRequireDefault(__webpack_require__(41));
	
	var styles = function styles(theme) {
	  var elevations = {};
	  theme.shadows.forEach(function (shadow, index) {
	    elevations["elevation".concat(index)] = {
	      boxShadow: shadow
	    };
	  });
	  return (0, _extends2.default)({
	    /* Styles applied to the root element. */
	    root: {
	      backgroundColor: theme.palette.background.paper,
	      color: theme.palette.text.primary,
	      transition: theme.transitions.create('box-shadow')
	    },
	
	    /* Styles applied to the root element if `square={false}`. */
	    rounded: {
	      borderRadius: theme.shape.borderRadius
	    },
	
	    /* Styles applied to the root element if `variant="outlined"`. */
	    outlined: {
	      border: "1px solid ".concat(theme.palette.divider)
	    }
	  }, elevations);
	};
	
	exports.styles = styles;
	var Paper = /*#__PURE__*/React.forwardRef(function Paper(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'div' : _props$component,
	      _props$square = props.square,
	      square = _props$square === void 0 ? false : _props$square,
	      _props$elevation = props.elevation,
	      elevation = _props$elevation === void 0 ? 1 : _props$elevation,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'elevation' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component", "square", "elevation", "variant"]);
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, variant === 'outlined' ? classes.outlined : classes["elevation".concat(elevation)], !square && classes.rounded),
	    ref: ref
	  }, other));
	});
	 false ? Paper.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .elementType,
	
	  /**
	   * Shadow depth, corresponds to `dp` in the spec.
	   * It accepts values between 0 and 24 inclusive.
	   */
	  elevation: (0, _utils.chainPropTypes)(_propTypes.default.number, function (props) {
	    var classes = props.classes,
	        elevation = props.elevation; // in case `withStyles` fails to inject we don't need this warning
	
	    if (classes === undefined) {
	      return null;
	    }
	
	    if (elevation != null && classes["elevation".concat(elevation)] === undefined) {
	      return new Error("Material-UI: This elevation `".concat(elevation, "` is not implemented."));
	    }
	
	    return null;
	  }),
	
	  /**
	   * If `true`, rounded corners are disabled.
	   */
	  square: _propTypes.default.bool,
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['elevation', 'outlined'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiPaper'
	})(Paper);
	
	exports.default = _default;

/***/ },
/* 742 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getOffsetTop = getOffsetTop;
	exports.getOffsetLeft = getOffsetLeft;
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(25));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(43));
	
	var _utils = __webpack_require__(26);
	
	var _debounce = _interopRequireDefault(__webpack_require__(236));
	
	var _clsx = _interopRequireDefault(__webpack_require__(37));
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(95));
	
	var _ownerWindow = _interopRequireDefault(__webpack_require__(238));
	
	var _createChainedFunction = _interopRequireDefault(__webpack_require__(179));
	
	var _deprecatedPropType = _interopRequireDefault(__webpack_require__(94));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(41));
	
	var _Modal = _interopRequireDefault(__webpack_require__(737));
	
	var _Grow = _interopRequireDefault(__webpack_require__(720));
	
	var _Paper = _interopRequireDefault(__webpack_require__(324));
	
	function getOffsetTop(rect, vertical) {
	  var offset = 0;
	
	  if (typeof vertical === 'number') {
	    offset = vertical;
	  } else if (vertical === 'center') {
	    offset = rect.height / 2;
	  } else if (vertical === 'bottom') {
	    offset = rect.height;
	  }
	
	  return offset;
	}
	
	function getOffsetLeft(rect, horizontal) {
	  var offset = 0;
	
	  if (typeof horizontal === 'number') {
	    offset = horizontal;
	  } else if (horizontal === 'center') {
	    offset = rect.width / 2;
	  } else if (horizontal === 'right') {
	    offset = rect.width;
	  }
	
	  return offset;
	}
	
	function getTransformOriginValue(transformOrigin) {
	  return [transformOrigin.horizontal, transformOrigin.vertical].map(function (n) {
	    return typeof n === 'number' ? "".concat(n, "px") : n;
	  }).join(' ');
	} // Sum the scrollTop between two elements.
	
	
	function getScrollParent(parent, child) {
	  var element = child;
	  var scrollTop = 0;
	
	  while (element && element !== parent) {
	    element = element.parentElement;
	    scrollTop += element.scrollTop;
	  }
	
	  return scrollTop;
	}
	
	function getAnchorEl(anchorEl) {
	  return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
	}
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {},
	
	  /* Styles applied to the `Paper` component. */
	  paper: {
	    position: 'absolute',
	    overflowY: 'auto',
	    overflowX: 'hidden',
	    // So we see the popover when it's empty.
	    // It's most likely on issue on userland.
	    minWidth: 16,
	    minHeight: 16,
	    maxWidth: 'calc(100% - 32px)',
	    maxHeight: 'calc(100% - 32px)',
	    // We disable the focus ring for mouse, touch and keyboard users.
	    outline: 0
	  }
	};
	exports.styles = styles;
	var Popover = /*#__PURE__*/React.forwardRef(function Popover(props, ref) {
	  var action = props.action,
	      anchorEl = props.anchorEl,
	      _props$anchorOrigin = props.anchorOrigin,
	      anchorOrigin = _props$anchorOrigin === void 0 ? {
	    vertical: 'top',
	    horizontal: 'left'
	  } : _props$anchorOrigin,
	      anchorPosition = props.anchorPosition,
	      _props$anchorReferenc = props.anchorReference,
	      anchorReference = _props$anchorReferenc === void 0 ? 'anchorEl' : _props$anchorReferenc,
	      children = props.children,
	      classes = props.classes,
	      className = props.className,
	      containerProp = props.container,
	      _props$elevation = props.elevation,
	      elevation = _props$elevation === void 0 ? 8 : _props$elevation,
	      getContentAnchorEl = props.getContentAnchorEl,
	      _props$marginThreshol = props.marginThreshold,
	      marginThreshold = _props$marginThreshol === void 0 ? 16 : _props$marginThreshol,
	      onEnter = props.onEnter,
	      onEntered = props.onEntered,
	      onEntering = props.onEntering,
	      onExit = props.onExit,
	      onExited = props.onExited,
	      onExiting = props.onExiting,
	      open = props.open,
	      _props$PaperProps = props.PaperProps,
	      PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps,
	      _props$transformOrigi = props.transformOrigin,
	      transformOrigin = _props$transformOrigi === void 0 ? {
	    vertical: 'top',
	    horizontal: 'left'
	  } : _props$transformOrigi,
	      _props$TransitionComp = props.TransitionComponent,
	      TransitionComponent = _props$TransitionComp === void 0 ? _Grow.default : _props$TransitionComp,
	      _props$transitionDura = props.transitionDuration,
	      transitionDurationProp = _props$transitionDura === void 0 ? 'auto' : _props$transitionDura,
	      _props$TransitionProp = props.TransitionProps,
	      TransitionProps = _props$TransitionProp === void 0 ? {} : _props$TransitionProp,
	      other = (0, _objectWithoutProperties2.default)(props, ["action", "anchorEl", "anchorOrigin", "anchorPosition", "anchorReference", "children", "classes", "className", "container", "elevation", "getContentAnchorEl", "marginThreshold", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "open", "PaperProps", "transformOrigin", "TransitionComponent", "transitionDuration", "TransitionProps"]);
	  var paperRef = React.useRef(); // Returns the top/left offset of the position
	  // to attach to on the anchor element (or body if none is provided)
	
	  var getAnchorOffset = React.useCallback(function (contentAnchorOffset) {
	    if (anchorReference === 'anchorPosition') {
	      if (false) {
	        if (!anchorPosition) {
	          console.error('Material-UI: You need to provide a `anchorPosition` prop when using ' + '<Popover anchorReference="anchorPosition" />.');
	        }
	      }
	
	      return anchorPosition;
	    }
	
	    var resolvedAnchorEl = getAnchorEl(anchorEl); // If an anchor element wasn't provided, just use the parent body element of this Popover
	
	    var anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : (0, _ownerDocument.default)(paperRef.current).body;
	    var anchorRect = anchorElement.getBoundingClientRect();
	
	    if (false) {
	      var box = anchorElement.getBoundingClientRect();
	
	      if (process.env.NODE_ENV !== 'test' && box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) {
	        console.warn(['Material-UI: The `anchorEl` prop provided to the component is invalid.', 'The anchor element should be part of the document layout.', "Make sure the element is present in the document or that it's not display none."].join('\n'));
	      }
	    }
	
	    var anchorVertical = contentAnchorOffset === 0 ? anchorOrigin.vertical : 'center';
	    return {
	      top: anchorRect.top + getOffsetTop(anchorRect, anchorVertical),
	      left: anchorRect.left + getOffsetLeft(anchorRect, anchorOrigin.horizontal)
	    };
	  }, [anchorEl, anchorOrigin.horizontal, anchorOrigin.vertical, anchorPosition, anchorReference]); // Returns the vertical offset of inner content to anchor the transform on if provided
	
	  var getContentAnchorOffset = React.useCallback(function (element) {
	    var contentAnchorOffset = 0;
	
	    if (getContentAnchorEl && anchorReference === 'anchorEl') {
	      var contentAnchorEl = getContentAnchorEl(element);
	
	      if (contentAnchorEl && element.contains(contentAnchorEl)) {
	        var scrollTop = getScrollParent(element, contentAnchorEl);
	        contentAnchorOffset = contentAnchorEl.offsetTop + contentAnchorEl.clientHeight / 2 - scrollTop || 0;
	      } // != the default value
	
	
	      if (false) {
	        if (anchorOrigin.vertical !== 'top') {
	          console.error(['Material-UI: You can not change the default `anchorOrigin.vertical` value ', 'when also providing the `getContentAnchorEl` prop to the popover component.', 'Only use one of the two props.', 'Set `getContentAnchorEl` to `null | undefined`' + ' or leave `anchorOrigin.vertical` unchanged.'].join('\n'));
	        }
	      }
	    }
	
	    return contentAnchorOffset;
	  }, [anchorOrigin.vertical, anchorReference, getContentAnchorEl]); // Return the base transform origin using the element
	  // and taking the content anchor offset into account if in use
	
	  var getTransformOrigin = React.useCallback(function (elemRect) {
	    var contentAnchorOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	    return {
	      vertical: getOffsetTop(elemRect, transformOrigin.vertical) + contentAnchorOffset,
	      horizontal: getOffsetLeft(elemRect, transformOrigin.horizontal)
	    };
	  }, [transformOrigin.horizontal, transformOrigin.vertical]);
	  var getPositioningStyle = React.useCallback(function (element) {
	    // Check if the parent has requested anchoring on an inner content node
	    var contentAnchorOffset = getContentAnchorOffset(element);
	    var elemRect = {
	      width: element.offsetWidth,
	      height: element.offsetHeight
	    }; // Get the transform origin point on the element itself
	
	    var elemTransformOrigin = getTransformOrigin(elemRect, contentAnchorOffset);
	
	    if (anchorReference === 'none') {
	      return {
	        top: null,
	        left: null,
	        transformOrigin: getTransformOriginValue(elemTransformOrigin)
	      };
	    } // Get the offset of of the anchoring element
	
	
	    var anchorOffset = getAnchorOffset(contentAnchorOffset); // Calculate element positioning
	
	    var top = anchorOffset.top - elemTransformOrigin.vertical;
	    var left = anchorOffset.left - elemTransformOrigin.horizontal;
	    var bottom = top + elemRect.height;
	    var right = left + elemRect.width; // Use the parent window of the anchorEl if provided
	
	    var containerWindow = (0, _ownerWindow.default)(getAnchorEl(anchorEl)); // Window thresholds taking required margin into account
	
	    var heightThreshold = containerWindow.innerHeight - marginThreshold;
	    var widthThreshold = containerWindow.innerWidth - marginThreshold; // Check if the vertical axis needs shifting
	
	    if (top < marginThreshold) {
	      var diff = top - marginThreshold;
	      top -= diff;
	      elemTransformOrigin.vertical += diff;
	    } else if (bottom > heightThreshold) {
	      var _diff = bottom - heightThreshold;
	
	      top -= _diff;
	      elemTransformOrigin.vertical += _diff;
	    }
	
	    if (false) {
	      if (elemRect.height > heightThreshold && elemRect.height && heightThreshold) {
	        console.error(['Material-UI: The popover component is too tall.', "Some part of it can not be seen on the screen (".concat(elemRect.height - heightThreshold, "px)."), 'Please consider adding a `max-height` to improve the user-experience.'].join('\n'));
	      }
	    } // Check if the horizontal axis needs shifting
	
	
	    if (left < marginThreshold) {
	      var _diff2 = left - marginThreshold;
	
	      left -= _diff2;
	      elemTransformOrigin.horizontal += _diff2;
	    } else if (right > widthThreshold) {
	      var _diff3 = right - widthThreshold;
	
	      left -= _diff3;
	      elemTransformOrigin.horizontal += _diff3;
	    }
	
	    return {
	      top: "".concat(Math.round(top), "px"),
	      left: "".concat(Math.round(left), "px"),
	      transformOrigin: getTransformOriginValue(elemTransformOrigin)
	    };
	  }, [anchorEl, anchorReference, getAnchorOffset, getContentAnchorOffset, getTransformOrigin, marginThreshold]);
	  var setPositioningStyles = React.useCallback(function () {
	    var element = paperRef.current;
	
	    if (!element) {
	      return;
	    }
	
	    var positioning = getPositioningStyle(element);
	
	    if (positioning.top !== null) {
	      element.style.top = positioning.top;
	    }
	
	    if (positioning.left !== null) {
	      element.style.left = positioning.left;
	    }
	
	    element.style.transformOrigin = positioning.transformOrigin;
	  }, [getPositioningStyle]);
	
	  var handleEntering = function handleEntering(element, isAppearing) {
	    if (onEntering) {
	      onEntering(element, isAppearing);
	    }
	
	    setPositioningStyles();
	  };
	
	  var handlePaperRef = React.useCallback(function (instance) {
	    // #StrictMode ready
	    paperRef.current = ReactDOM.findDOMNode(instance);
	  }, []);
	  React.useEffect(function () {
	    if (open) {
	      setPositioningStyles();
	    }
	  });
	  React.useImperativeHandle(action, function () {
	    return open ? {
	      updatePosition: function updatePosition() {
	        setPositioningStyles();
	      }
	    } : null;
	  }, [open, setPositioningStyles]);
	  React.useEffect(function () {
	    if (!open) {
	      return undefined;
	    }
	
	    var handleResize = (0, _debounce.default)(function () {
	      setPositioningStyles();
	    });
	    window.addEventListener('resize', handleResize);
	    return function () {
	      handleResize.clear();
	      window.removeEventListener('resize', handleResize);
	    };
	  }, [open, setPositioningStyles]);
	  var transitionDuration = transitionDurationProp;
	
	  if (transitionDurationProp === 'auto' && !TransitionComponent.muiSupportAuto) {
	    transitionDuration = undefined;
	  } // If the container prop is provided, use that
	  // If the anchorEl prop is provided, use its parent body element as the container
	  // If neither are provided let the Modal take care of choosing the container
	
	
	  var container = containerProp || (anchorEl ? (0, _ownerDocument.default)(getAnchorEl(anchorEl)).body : undefined);
	  return /*#__PURE__*/React.createElement(_Modal.default, (0, _extends2.default)({
	    container: container,
	    open: open,
	    ref: ref,
	    BackdropProps: {
	      invisible: true
	    },
	    className: (0, _clsx.default)(classes.root, className)
	  }, other), /*#__PURE__*/React.createElement(TransitionComponent, (0, _extends2.default)({
	    appear: true,
	    in: open,
	    onEnter: onEnter,
	    onEntered: onEntered,
	    onExit: onExit,
	    onExited: onExited,
	    onExiting: onExiting,
	    timeout: transitionDuration
	  }, TransitionProps, {
	    onEntering: (0, _createChainedFunction.default)(handleEntering, TransitionProps.onEntering)
	  }), /*#__PURE__*/React.createElement(_Paper.default, (0, _extends2.default)({
	    elevation: elevation,
	    ref: handlePaperRef
	  }, PaperProps, {
	    className: (0, _clsx.default)(classes.paper, PaperProps.className)
	  }), children)));
	});
	 false ? Popover.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * A ref for imperative actions.
	   * It currently only supports updatePosition() action.
	   */
	  action: _utils.refType,
	
	  /**
	   * A HTML element, or a function that returns it.
	   * It's used to set the position of the popover.
	   */
	  anchorEl: (0, _utils.chainPropTypes)(_propTypes.default.oneOfType([_utils.HTMLElementType, _propTypes.default.func]), function (props) {
	    if (props.open && (!props.anchorReference || props.anchorReference === 'anchorEl')) {
	      var resolvedAnchorEl = getAnchorEl(props.anchorEl);
	
	      if (resolvedAnchorEl && resolvedAnchorEl.nodeType === 1) {
	        var box = resolvedAnchorEl.getBoundingClientRect();
	
	        if (process.env.NODE_ENV !== 'test' && box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) {
	          return new Error(['Material-UI: The `anchorEl` prop provided to the component is invalid.', 'The anchor element should be part of the document layout.', "Make sure the element is present in the document or that it's not display none."].join('\n'));
	        }
	      } else {
	        return new Error(['Material-UI: The `anchorEl` prop provided to the component is invalid.', "It should be an Element instance but it's `".concat(resolvedAnchorEl, "` instead.")].join('\n'));
	      }
	    }
	
	    return null;
	  }),
	
	  /**
	   * This is the point on the anchor where the popover's
	   * `anchorEl` will attach to. This is not used when the
	   * anchorReference is 'anchorPosition'.
	   *
	   * Options:
	   * vertical: [top, center, bottom];
	   * horizontal: [left, center, right].
	   */
	  anchorOrigin: _propTypes.default.shape({
	    horizontal: _propTypes.default.oneOfType([_propTypes.default.oneOf(['center', 'left', 'right']), _propTypes.default.number]).isRequired,
	    vertical: _propTypes.default.oneOfType([_propTypes.default.oneOf(['bottom', 'center', 'top']), _propTypes.default.number]).isRequired
	  }),
	
	  /**
	   * This is the position that may be used
	   * to set the position of the popover.
	   * The coordinates are relative to
	   * the application's client area.
	   */
	  anchorPosition: _propTypes.default.shape({
	    left: _propTypes.default.number.isRequired,
	    top: _propTypes.default.number.isRequired
	  }),
	
	  /**
	   * This determines which anchor prop to refer to to set
	   * the position of the popover.
	   */
	  anchorReference: _propTypes.default.oneOf(['anchorEl', 'anchorPosition', 'none']),
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * A HTML element, component instance, or function that returns either.
	   * The `container` will passed to the Modal component.
	   *
	   * By default, it uses the body of the anchorEl's top-level document object,
	   * so it's simply `document.body` most of the time.
	   */
	  container: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .oneOfType([_utils.HTMLElementType, _propTypes.default.instanceOf(React.Component), _propTypes.default.func]),
	
	  /**
	   * The elevation of the popover.
	   */
	  elevation: _propTypes.default.number,
	
	  /**
	   * This function is called in order to retrieve the content anchor element.
	   * It's the opposite of the `anchorEl` prop.
	   * The content anchor element should be an element inside the popover.
	   * It's used to correctly scroll and set the position of the popover.
	   * The positioning strategy tries to make the content anchor element just above the
	   * anchor element.
	   */
	  getContentAnchorEl: _propTypes.default.func,
	
	  /**
	   * Specifies how close to the edge of the window the popover can appear.
	   */
	  marginThreshold: _propTypes.default.number,
	
	  /**
	   * Callback fired when the component requests to be closed.
	   */
	  onClose: _propTypes.default.func,
	
	  /**
	   * Callback fired before the component is entering.
	   * @deprecated Use the `TransitionProps` prop instead.
	   */
	  onEnter: (0, _deprecatedPropType.default)(_propTypes.default.func, 'Use the `TransitionProps` prop instead.'),
	
	  /**
	   * Callback fired when the component has entered.
	   * @deprecated Use the `TransitionProps` prop instead.
	   */
	  onEntered: (0, _deprecatedPropType.default)(_propTypes.default.func, 'Use the `TransitionProps` prop instead.'),
	
	  /**
	   * Callback fired when the component is entering.
	   * @deprecated Use the `TransitionProps` prop instead.
	   */
	  onEntering: (0, _deprecatedPropType.default)(_propTypes.default.func, 'Use the `TransitionProps` prop instead.'),
	
	  /**
	   * Callback fired before the component is exiting.
	   * @deprecated Use the `TransitionProps` prop instead.
	   */
	  onExit: (0, _deprecatedPropType.default)(_propTypes.default.func, 'Use the `TransitionProps` prop instead.'),
	
	  /**
	   * Callback fired when the component has exited.
	   * @deprecated Use the `TransitionProps` prop instead.
	   */
	  onExited: (0, _deprecatedPropType.default)(_propTypes.default.func, 'Use the `TransitionProps` prop instead.'),
	
	  /**
	   * Callback fired when the component is exiting.
	   * @deprecated Use the `TransitionProps` prop instead.
	   */
	  onExiting: (0, _deprecatedPropType.default)(_propTypes.default.func, 'Use the `TransitionProps` prop instead.'),
	
	  /**
	   * If `true`, the popover is visible.
	   */
	  open: _propTypes.default.bool.isRequired,
	
	  /**
	   * Props applied to the [`Paper`](/api/paper/) element.
	   */
	  PaperProps: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .shape({
	    component: _utils.elementTypeAcceptingRef
	  }),
	
	  /**
	   * This is the point on the popover which
	   * will attach to the anchor's origin.
	   *
	   * Options:
	   * vertical: [top, center, bottom, x(px)];
	   * horizontal: [left, center, right, x(px)].
	   */
	  transformOrigin: _propTypes.default.shape({
	    horizontal: _propTypes.default.oneOfType([_propTypes.default.oneOf(['center', 'left', 'right']), _propTypes.default.number]).isRequired,
	    vertical: _propTypes.default.oneOfType([_propTypes.default.oneOf(['bottom', 'center', 'top']), _propTypes.default.number]).isRequired
	  }),
	
	  /**
	   * The component used for the transition.
	   * [Follow this guide](/components/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
	   */
	  TransitionComponent: _propTypes.default.elementType,
	
	  /**
	   * Set to 'auto' to automatically calculate transition time based on height.
	   */
	  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.oneOf(['auto']), _propTypes.default.number, _propTypes.default.shape({
	    appear: _propTypes.default.number,
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  })]),
	
	  /**
	   * Props applied to the [`Transition`](http://reactcommunity.org/react-transition-group/transition#Transition-props) element.
	   */
	  TransitionProps: _propTypes.default.object
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiPopover'
	})(Popover);
	
	exports.default = _default;

/***/ },
/* 743 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Popover.default;
	  }
	});
	
	var _Popover = _interopRequireDefault(__webpack_require__(742));

/***/ },
/* 744 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(25));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _popper = _interopRequireDefault(__webpack_require__(1364));
	
	var _utils = __webpack_require__(26);
	
	var _styles = __webpack_require__(80);
	
	var _Portal = _interopRequireDefault(__webpack_require__(325));
	
	var _createChainedFunction = _interopRequireDefault(__webpack_require__(179));
	
	var _setRef = _interopRequireDefault(__webpack_require__(143));
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(68));
	
	function flipPlacement(placement, theme) {
	  var direction = theme && theme.direction || 'ltr';
	
	  if (direction === 'ltr') {
	    return placement;
	  }
	
	  switch (placement) {
	    case 'bottom-end':
	      return 'bottom-start';
	
	    case 'bottom-start':
	      return 'bottom-end';
	
	    case 'top-end':
	      return 'top-start';
	
	    case 'top-start':
	      return 'top-end';
	
	    default:
	      return placement;
	  }
	}
	
	function getAnchorEl(anchorEl) {
	  return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
	}
	
	var useEnhancedEffect = typeof window !== 'undefined' ? React.useLayoutEffect : React.useEffect;
	var defaultPopperOptions = {};
	/**
	 * Poppers rely on the 3rd party library [Popper.js](https://popper.js.org/docs/v1/) for positioning.
	 */
	
	var Popper = /*#__PURE__*/React.forwardRef(function Popper(props, ref) {
	  var anchorEl = props.anchorEl,
	      children = props.children,
	      container = props.container,
	      _props$disablePortal = props.disablePortal,
	      disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal,
	      _props$keepMounted = props.keepMounted,
	      keepMounted = _props$keepMounted === void 0 ? false : _props$keepMounted,
	      modifiers = props.modifiers,
	      open = props.open,
	      _props$placement = props.placement,
	      initialPlacement = _props$placement === void 0 ? 'bottom' : _props$placement,
	      _props$popperOptions = props.popperOptions,
	      popperOptions = _props$popperOptions === void 0 ? defaultPopperOptions : _props$popperOptions,
	      popperRefProp = props.popperRef,
	      style = props.style,
	      _props$transition = props.transition,
	      transition = _props$transition === void 0 ? false : _props$transition,
	      other = (0, _objectWithoutProperties2.default)(props, ["anchorEl", "children", "container", "disablePortal", "keepMounted", "modifiers", "open", "placement", "popperOptions", "popperRef", "style", "transition"]);
	  var tooltipRef = React.useRef(null);
	  var ownRef = (0, _useForkRef.default)(tooltipRef, ref);
	  var popperRef = React.useRef(null);
	  var handlePopperRef = (0, _useForkRef.default)(popperRef, popperRefProp);
	  var handlePopperRefRef = React.useRef(handlePopperRef);
	  useEnhancedEffect(function () {
	    handlePopperRefRef.current = handlePopperRef;
	  }, [handlePopperRef]);
	  React.useImperativeHandle(popperRefProp, function () {
	    return popperRef.current;
	  }, []);
	
	  var _React$useState = React.useState(true),
	      exited = _React$useState[0],
	      setExited = _React$useState[1];
	
	  var theme = (0, _styles.useTheme)();
	  var rtlPlacement = flipPlacement(initialPlacement, theme);
	  /**
	   * placement initialized from prop but can change during lifetime if modifiers.flip.
	   * modifiers.flip is essentially a flip for controlled/uncontrolled behavior
	   */
	
	  var _React$useState2 = React.useState(rtlPlacement),
	      placement = _React$useState2[0],
	      setPlacement = _React$useState2[1];
	
	  React.useEffect(function () {
	    if (popperRef.current) {
	      popperRef.current.update();
	    }
	  });
	  var handleOpen = React.useCallback(function () {
	    if (!tooltipRef.current || !anchorEl || !open) {
	      return;
	    }
	
	    if (popperRef.current) {
	      popperRef.current.destroy();
	      handlePopperRefRef.current(null);
	    }
	
	    var handlePopperUpdate = function handlePopperUpdate(data) {
	      setPlacement(data.placement);
	    };
	
	    var resolvedAnchorEl = getAnchorEl(anchorEl);
	
	    if (false) {
	      if (resolvedAnchorEl && resolvedAnchorEl.nodeType === 1) {
	        var box = resolvedAnchorEl.getBoundingClientRect();
	
	        if (process.env.NODE_ENV !== 'test' && box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) {
	          console.warn(['Material-UI: The `anchorEl` prop provided to the component is invalid.', 'The anchor element should be part of the document layout.', "Make sure the element is present in the document or that it's not display none."].join('\n'));
	        }
	      }
	    }
	
	    var popper = new _popper.default(getAnchorEl(anchorEl), tooltipRef.current, (0, _extends2.default)({
	      placement: rtlPlacement
	    }, popperOptions, {
	      modifiers: (0, _extends2.default)({}, disablePortal ? {} : {
	        // It's using scrollParent by default, we can use the viewport when using a portal.
	        preventOverflow: {
	          boundariesElement: 'window'
	        }
	      }, modifiers, popperOptions.modifiers),
	      // We could have been using a custom modifier like react-popper is doing.
	      // But it seems this is the best public API for this use case.
	      onCreate: (0, _createChainedFunction.default)(handlePopperUpdate, popperOptions.onCreate),
	      onUpdate: (0, _createChainedFunction.default)(handlePopperUpdate, popperOptions.onUpdate)
	    }));
	    handlePopperRefRef.current(popper);
	  }, [anchorEl, disablePortal, modifiers, open, rtlPlacement, popperOptions]);
	  var handleRef = React.useCallback(function (node) {
	    (0, _setRef.default)(ownRef, node);
	    handleOpen();
	  }, [ownRef, handleOpen]);
	
	  var handleEnter = function handleEnter() {
	    setExited(false);
	  };
	
	  var handleClose = function handleClose() {
	    if (!popperRef.current) {
	      return;
	    }
	
	    popperRef.current.destroy();
	    handlePopperRefRef.current(null);
	  };
	
	  var handleExited = function handleExited() {
	    setExited(true);
	    handleClose();
	  };
	
	  React.useEffect(function () {
	    return function () {
	      handleClose();
	    };
	  }, []);
	  React.useEffect(function () {
	    if (!open && !transition) {
	      // Otherwise handleExited will call this.
	      handleClose();
	    }
	  }, [open, transition]);
	
	  if (!keepMounted && !open && (!transition || exited)) {
	    return null;
	  }
	
	  var childProps = {
	    placement: placement
	  };
	
	  if (transition) {
	    childProps.TransitionProps = {
	      in: open,
	      onEnter: handleEnter,
	      onExited: handleExited
	    };
	  }
	
	  return /*#__PURE__*/React.createElement(_Portal.default, {
	    disablePortal: disablePortal,
	    container: container
	  }, /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    ref: handleRef,
	    role: "tooltip"
	  }, other, {
	    style: (0, _extends2.default)({
	      // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
	      position: 'fixed',
	      // Fix Popper.js display issue
	      top: 0,
	      left: 0,
	      display: !open && keepMounted && !transition ? 'none' : null
	    }, style)
	  }), typeof children === 'function' ? children(childProps) : children));
	});
	 false ? Popper.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * A HTML element, [referenceObject](https://popper.js.org/docs/v1/#referenceObject),
	   * or a function that returns either.
	   * It's used to set the position of the popper.
	   * The return value will passed as the reference object of the Popper instance.
	   */
	  anchorEl: (0, _utils.chainPropTypes)(_propTypes.default.oneOfType([_utils.HTMLElementType, _propTypes.default.object, _propTypes.default.func]), function (props) {
	    if (props.open) {
	      var resolvedAnchorEl = getAnchorEl(props.anchorEl);
	
	      if (resolvedAnchorEl && resolvedAnchorEl.nodeType === 1) {
	        var box = resolvedAnchorEl.getBoundingClientRect();
	
	        if (process.env.NODE_ENV !== 'test' && box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) {
	          return new Error(['Material-UI: The `anchorEl` prop provided to the component is invalid.', 'The anchor element should be part of the document layout.', "Make sure the element is present in the document or that it's not display none."].join('\n'));
	        }
	      } else if (!resolvedAnchorEl || typeof resolvedAnchorEl.clientWidth !== 'number' || typeof resolvedAnchorEl.clientHeight !== 'number' || typeof resolvedAnchorEl.getBoundingClientRect !== 'function') {
	        return new Error(['Material-UI: The `anchorEl` prop provided to the component is invalid.', 'It should be an HTML element instance or a referenceObject ', '(https://popper.js.org/docs/v1/#referenceObject).'].join('\n'));
	      }
	    }
	
	    return null;
	  }),
	
	  /**
	   * Popper render function or node.
	   */
	  children: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .oneOfType([_propTypes.default.node, _propTypes.default.func]).isRequired,
	
	  /**
	   * A HTML element, component instance, or function that returns either.
	   * The `container` will have the portal children appended to it.
	   *
	   * By default, it uses the body of the top-level document object,
	   * so it's simply `document.body` most of the time.
	   */
	  container: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .oneOfType([_utils.HTMLElementType, _propTypes.default.instanceOf(React.Component), _propTypes.default.func]),
	
	  /**
	   * Disable the portal behavior.
	   * The children stay within it's parent DOM hierarchy.
	   */
	  disablePortal: _propTypes.default.bool,
	
	  /**
	   * Always keep the children in the DOM.
	   * This prop can be useful in SEO situation or
	   * when you want to maximize the responsiveness of the Popper.
	   */
	  keepMounted: _propTypes.default.bool,
	
	  /**
	   * Popper.js is based on a "plugin-like" architecture,
	   * most of its features are fully encapsulated "modifiers".
	   *
	   * A modifier is a function that is called each time Popper.js needs to
	   * compute the position of the popper.
	   * For this reason, modifiers should be very performant to avoid bottlenecks.
	   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v1/#modifiers).
	   */
	  modifiers: _propTypes.default.object,
	
	  /**
	   * If `true`, the popper is visible.
	   */
	  open: _propTypes.default.bool.isRequired,
	
	  /**
	   * Popper placement.
	   */
	  placement: _propTypes.default.oneOf(['bottom-end', 'bottom-start', 'bottom', 'left-end', 'left-start', 'left', 'right-end', 'right-start', 'right', 'top-end', 'top-start', 'top']),
	
	  /**
	   * Options provided to the [`popper.js`](https://popper.js.org/docs/v1/) instance.
	   */
	  popperOptions: _propTypes.default.object,
	
	  /**
	   * A ref that points to the used popper instance.
	   */
	  popperRef: _utils.refType,
	
	  /**
	   * @ignore
	   */
	  style: _propTypes.default.object,
	
	  /**
	   * Help supporting a react-transition-group/Transition component.
	   */
	  transition: _propTypes.default.bool
	} : void 0;
	var _default = Popper;
	exports.default = _default;

/***/ },
/* 745 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Popper.default;
	  }
	});
	
	var _Popper = _interopRequireDefault(__webpack_require__(744));

/***/ },
/* 746 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(43));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(26);
	
	var _deprecatedPropType = _interopRequireDefault(__webpack_require__(94));
	
	var _setRef = _interopRequireDefault(__webpack_require__(143));
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(68));
	
	function getContainer(container) {
	  container = typeof container === 'function' ? container() : container; // #StrictMode ready
	
	  return ReactDOM.findDOMNode(container);
	}
	
	var useEnhancedEffect = typeof window !== 'undefined' ? React.useLayoutEffect : React.useEffect;
	/**
	 * Portals provide a first-class way to render children into a DOM node
	 * that exists outside the DOM hierarchy of the parent component.
	 */
	
	var Portal = /*#__PURE__*/React.forwardRef(function Portal(props, ref) {
	  var children = props.children,
	      container = props.container,
	      _props$disablePortal = props.disablePortal,
	      disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal,
	      onRendered = props.onRendered;
	
	  var _React$useState = React.useState(null),
	      mountNode = _React$useState[0],
	      setMountNode = _React$useState[1];
	
	  var handleRef = (0, _useForkRef.default)( /*#__PURE__*/React.isValidElement(children) ? children.ref : null, ref);
	  useEnhancedEffect(function () {
	    if (!disablePortal) {
	      setMountNode(getContainer(container) || document.body);
	    }
	  }, [container, disablePortal]);
	  useEnhancedEffect(function () {
	    if (mountNode && !disablePortal) {
	      (0, _setRef.default)(ref, mountNode);
	      return function () {
	        (0, _setRef.default)(ref, null);
	      };
	    }
	
	    return undefined;
	  }, [ref, mountNode, disablePortal]);
	  useEnhancedEffect(function () {
	    if (onRendered && (mountNode || disablePortal)) {
	      onRendered();
	    }
	  }, [onRendered, mountNode, disablePortal]);
	
	  if (disablePortal) {
	    if ( /*#__PURE__*/React.isValidElement(children)) {
	      return /*#__PURE__*/React.cloneElement(children, {
	        ref: handleRef
	      });
	    }
	
	    return children;
	  }
	
	  return mountNode ? /*#__PURE__*/ReactDOM.createPortal(children, mountNode) : mountNode;
	});
	 false ? Portal.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The children to render into the `container`.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * A HTML element, component instance, or function that returns either.
	   * The `container` will have the portal children appended to it.
	   *
	   * By default, it uses the body of the top-level document object,
	   * so it's simply `document.body` most of the time.
	   */
	  container: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .oneOfType([_utils.HTMLElementType, _propTypes.default.instanceOf(React.Component), _propTypes.default.func]),
	
	  /**
	   * Disable the portal behavior.
	   * The children stay within it's parent DOM hierarchy.
	   */
	  disablePortal: _propTypes.default.bool,
	
	  /**
	   * Callback fired once the children has been mounted into the `container`.
	   *
	   * This prop will be removed in v5, the ref can be used instead.
	   * @deprecated Use the ref instead.
	   */
	  onRendered: (0, _deprecatedPropType.default)(_propTypes.default.func, 'Use the ref instead.')
	} : void 0;
	
	if (false) {
	  // eslint-disable-next-line
	  Portal['propTypes' + ''] = (0, _utils.exactProp)(Portal.propTypes);
	}
	
	var _default = Portal;
	exports.default = _default;

/***/ },
/* 747 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(25));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _styles = __webpack_require__(80);
	
	var _SelectInput = _interopRequireDefault(__webpack_require__(748));
	
	var _formControlState = _interopRequireDefault(__webpack_require__(117));
	
	var _useFormControl = _interopRequireDefault(__webpack_require__(118));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(41));
	
	var _ArrowDropDown = _interopRequireDefault(__webpack_require__(326));
	
	var _Input = _interopRequireDefault(__webpack_require__(231));
	
	var _NativeSelect = __webpack_require__(738);
	
	var _NativeSelectInput = _interopRequireDefault(__webpack_require__(322));
	
	var _FilledInput = _interopRequireDefault(__webpack_require__(320));
	
	var _OutlinedInput = _interopRequireDefault(__webpack_require__(323));
	
	var styles = _NativeSelect.styles;
	exports.styles = styles;
	
	var _ref = /*#__PURE__*/React.createElement(_Input.default, null);
	
	var _ref2 = /*#__PURE__*/React.createElement(_FilledInput.default, null);
	
	var Select = /*#__PURE__*/React.forwardRef(function Select(props, ref) {
	  var _props$autoWidth = props.autoWidth,
	      autoWidth = _props$autoWidth === void 0 ? false : _props$autoWidth,
	      children = props.children,
	      classes = props.classes,
	      _props$displayEmpty = props.displayEmpty,
	      displayEmpty = _props$displayEmpty === void 0 ? false : _props$displayEmpty,
	      _props$IconComponent = props.IconComponent,
	      IconComponent = _props$IconComponent === void 0 ? _ArrowDropDown.default : _props$IconComponent,
	      id = props.id,
	      input = props.input,
	      inputProps = props.inputProps,
	      label = props.label,
	      labelId = props.labelId,
	      _props$labelWidth = props.labelWidth,
	      labelWidth = _props$labelWidth === void 0 ? 0 : _props$labelWidth,
	      MenuProps = props.MenuProps,
	      _props$multiple = props.multiple,
	      multiple = _props$multiple === void 0 ? false : _props$multiple,
	      _props$native = props.native,
	      native = _props$native === void 0 ? false : _props$native,
	      onClose = props.onClose,
	      onOpen = props.onOpen,
	      open = props.open,
	      renderValue = props.renderValue,
	      SelectDisplayProps = props.SelectDisplayProps,
	      _props$variant = props.variant,
	      variantProps = _props$variant === void 0 ? 'standard' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["autoWidth", "children", "classes", "displayEmpty", "IconComponent", "id", "input", "inputProps", "label", "labelId", "labelWidth", "MenuProps", "multiple", "native", "onClose", "onOpen", "open", "renderValue", "SelectDisplayProps", "variant"]);
	  var inputComponent = native ? _NativeSelectInput.default : _SelectInput.default;
	  var muiFormControl = (0, _useFormControl.default)();
	  var fcs = (0, _formControlState.default)({
	    props: props,
	    muiFormControl: muiFormControl,
	    states: ['variant']
	  });
	  var variant = fcs.variant || variantProps;
	  var InputComponent = input || {
	    standard: _ref,
	    outlined: /*#__PURE__*/React.createElement(_OutlinedInput.default, {
	      label: label,
	      labelWidth: labelWidth
	    }),
	    filled: _ref2
	  }[variant];
	  return /*#__PURE__*/React.cloneElement(InputComponent, (0, _extends2.default)({
	    // Most of the logic is implemented in `SelectInput`.
	    // The `Select` component is a simple API wrapper to expose something better to play with.
	    inputComponent: inputComponent,
	    inputProps: (0, _extends2.default)({
	      children: children,
	      IconComponent: IconComponent,
	      variant: variant,
	      type: undefined,
	      // We render a select. We can ignore the type provided by the `Input`.
	      multiple: multiple
	    }, native ? {
	      id: id
	    } : {
	      autoWidth: autoWidth,
	      displayEmpty: displayEmpty,
	      labelId: labelId,
	      MenuProps: MenuProps,
	      onClose: onClose,
	      onOpen: onOpen,
	      open: open,
	      renderValue: renderValue,
	      SelectDisplayProps: (0, _extends2.default)({
	        id: id
	      }, SelectDisplayProps)
	    }, inputProps, {
	      classes: inputProps ? (0, _styles.mergeClasses)({
	        baseClasses: classes,
	        newClasses: inputProps.classes,
	        Component: Select
	      }) : classes
	    }, input ? input.props.inputProps : {}),
	    ref: ref
	  }, other));
	});
	 false ? Select.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * If `true`, the width of the popover will automatically be set according to the items inside the
	   * menu, otherwise it will be at least the width of the select input.
	   */
	  autoWidth: _propTypes.default.bool,
	
	  /**
	   * The option elements to populate the select with.
	   * Can be some `MenuItem` when `native` is false and `option` when `native` is true.
	   *
	   * ⚠️The `MenuItem` elements **must** be direct descendants when `native` is false.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * The default element value. Use when the component is not controlled.
	   */
	  defaultValue: _propTypes.default.any,
	
	  /**
	   * If `true`, a value is displayed even if no items are selected.
	   *
	   * In order to display a meaningful value, a function should be passed to the `renderValue` prop which returns the value to be displayed when no items are selected.
	   * You can only use it when the `native` prop is `false` (default).
	   */
	  displayEmpty: _propTypes.default.bool,
	
	  /**
	   * The icon that displays the arrow.
	   */
	  IconComponent: _propTypes.default.elementType,
	
	  /**
	   * The `id` of the wrapper element or the `select` element when `native`.
	   */
	  id: _propTypes.default.string,
	
	  /**
	   * An `Input` element; does not have to be a material-ui specific `Input`.
	   */
	  input: _propTypes.default.element,
	
	  /**
	   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
	   * When `native` is `true`, the attributes are applied on the `select` element.
	   */
	  inputProps: _propTypes.default.object,
	
	  /**
	   * See [OutlinedInput#label](/api/outlined-input/#props)
	   */
	  label: _propTypes.default.node,
	
	  /**
	   * The ID of an element that acts as an additional label. The Select will
	   * be labelled by the additional label and the selected value.
	   */
	  labelId: _propTypes.default.string,
	
	  /**
	   * See [OutlinedInput#label](/api/outlined-input/#props)
	   */
	  labelWidth: _propTypes.default.number,
	
	  /**
	   * Props applied to the [`Menu`](/api/menu/) element.
	   */
	  MenuProps: _propTypes.default.object,
	
	  /**
	   * If `true`, `value` must be an array and the menu will support multiple selections.
	   */
	  multiple: _propTypes.default.bool,
	
	  /**
	   * If `true`, the component will be using a native `select` element.
	   */
	  native: _propTypes.default.bool,
	
	  /**
	   * Callback function fired when a menu item is selected.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new value by accessing `event.target.value` (any).
	   * @param {object} [child] The react element that was selected when `native` is `false` (default).
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * Callback fired when the component requests to be closed.
	   * Use in controlled mode (see open).
	   *
	   * @param {object} event The event source of the callback.
	   */
	  onClose: _propTypes.default.func,
	
	  /**
	   * Callback fired when the component requests to be opened.
	   * Use in controlled mode (see open).
	   *
	   * @param {object} event The event source of the callback.
	   */
	  onOpen: _propTypes.default.func,
	
	  /**
	   * Control `select` open state.
	   * You can only use it when the `native` prop is `false` (default).
	   */
	  open: _propTypes.default.bool,
	
	  /**
	   * Render the selected value.
	   * You can only use it when the `native` prop is `false` (default).
	   *
	   * @param {any} value The `value` provided to the component.
	   * @returns {ReactNode}
	   */
	  renderValue: _propTypes.default.func,
	
	  /**
	   * Props applied to the clickable div element.
	   */
	  SelectDisplayProps: _propTypes.default.object,
	
	  /**
	   * The input value. Providing an empty string will select no options.
	   * This prop is required when the `native` prop is `false` (default).
	   * Set to an empty string `''` if you don't want any of the available options to be selected.
	   *
	   * If the value is an object it must have reference equality with the option in order to be selected.
	   * If the value is not an object, the string representation must match with the string representation of the option in order to be selected.
	   */
	  value: _propTypes.default.any,
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['filled', 'outlined', 'standard'])
	} : void 0;
	Select.muiName = 'Select';
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiSelect'
	})(Select);
	
	exports.default = _default;

/***/ },
/* 748 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(175));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(25));
	
	var _typeof2 = _interopRequireDefault(__webpack_require__(56));
	
	var _utils = __webpack_require__(26);
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _reactIs = __webpack_require__(168);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(37));
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(95));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(78));
	
	var _Menu = _interopRequireDefault(__webpack_require__(732));
	
	var _utils2 = __webpack_require__(233);
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(68));
	
	var _useControlled3 = _interopRequireDefault(__webpack_require__(332));
	
	function areEqualValues(a, b) {
	  if ((0, _typeof2.default)(b) === 'object' && b !== null) {
	    return a === b;
	  }
	
	  return String(a) === String(b);
	}
	
	function isEmpty(display) {
	  return display == null || typeof display === 'string' && !display.trim();
	}
	/**
	 * @ignore - internal component.
	 */
	
	
	var SelectInput = /*#__PURE__*/React.forwardRef(function SelectInput(props, ref) {
	  var ariaLabel = props['aria-label'],
	      autoFocus = props.autoFocus,
	      autoWidth = props.autoWidth,
	      children = props.children,
	      classes = props.classes,
	      className = props.className,
	      defaultValue = props.defaultValue,
	      disabled = props.disabled,
	      displayEmpty = props.displayEmpty,
	      IconComponent = props.IconComponent,
	      inputRefProp = props.inputRef,
	      labelId = props.labelId,
	      _props$MenuProps = props.MenuProps,
	      MenuProps = _props$MenuProps === void 0 ? {} : _props$MenuProps,
	      multiple = props.multiple,
	      name = props.name,
	      onBlur = props.onBlur,
	      onChange = props.onChange,
	      onClose = props.onClose,
	      onFocus = props.onFocus,
	      onOpen = props.onOpen,
	      openProp = props.open,
	      readOnly = props.readOnly,
	      renderValue = props.renderValue,
	      _props$SelectDisplayP = props.SelectDisplayProps,
	      SelectDisplayProps = _props$SelectDisplayP === void 0 ? {} : _props$SelectDisplayP,
	      tabIndexProp = props.tabIndex,
	      type = props.type,
	      valueProp = props.value,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'standard' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["aria-label", "autoFocus", "autoWidth", "children", "classes", "className", "defaultValue", "disabled", "displayEmpty", "IconComponent", "inputRef", "labelId", "MenuProps", "multiple", "name", "onBlur", "onChange", "onClose", "onFocus", "onOpen", "open", "readOnly", "renderValue", "SelectDisplayProps", "tabIndex", "type", "value", "variant"]);
	
	  var _useControlled = (0, _useControlled3.default)({
	    controlled: valueProp,
	    default: defaultValue,
	    name: 'Select'
	  }),
	      _useControlled2 = (0, _slicedToArray2.default)(_useControlled, 2),
	      value = _useControlled2[0],
	      setValue = _useControlled2[1];
	
	  var inputRef = React.useRef(null);
	
	  var _React$useState = React.useState(null),
	      displayNode = _React$useState[0],
	      setDisplayNode = _React$useState[1];
	
	  var _React$useRef = React.useRef(openProp != null),
	      isOpenControlled = _React$useRef.current;
	
	  var _React$useState2 = React.useState(),
	      menuMinWidthState = _React$useState2[0],
	      setMenuMinWidthState = _React$useState2[1];
	
	  var _React$useState3 = React.useState(false),
	      openState = _React$useState3[0],
	      setOpenState = _React$useState3[1];
	
	  var handleRef = (0, _useForkRef.default)(ref, inputRefProp);
	  React.useImperativeHandle(handleRef, function () {
	    return {
	      focus: function focus() {
	        displayNode.focus();
	      },
	      node: inputRef.current,
	      value: value
	    };
	  }, [displayNode, value]);
	  React.useEffect(function () {
	    if (autoFocus && displayNode) {
	      displayNode.focus();
	    }
	  }, [autoFocus, displayNode]);
	  React.useEffect(function () {
	    if (displayNode) {
	      var label = (0, _ownerDocument.default)(displayNode).getElementById(labelId);
	
	      if (label) {
	        var handler = function handler() {
	          if (getSelection().isCollapsed) {
	            displayNode.focus();
	          }
	        };
	
	        label.addEventListener('click', handler);
	        return function () {
	          label.removeEventListener('click', handler);
	        };
	      }
	    }
	
	    return undefined;
	  }, [labelId, displayNode]);
	
	  var update = function update(open, event) {
	    if (open) {
	      if (onOpen) {
	        onOpen(event);
	      }
	    } else if (onClose) {
	      onClose(event);
	    }
	
	    if (!isOpenControlled) {
	      setMenuMinWidthState(autoWidth ? null : displayNode.clientWidth);
	      setOpenState(open);
	    }
	  };
	
	  var handleMouseDown = function handleMouseDown(event) {
	    // Ignore everything but left-click
	    if (event.button !== 0) {
	      return;
	    } // Hijack the default focus behavior.
	
	
	    event.preventDefault();
	    displayNode.focus();
	    update(true, event);
	  };
	
	  var handleClose = function handleClose(event) {
	    update(false, event);
	  };
	
	  var childrenArray = React.Children.toArray(children); // Support autofill.
	
	  var handleChange = function handleChange(event) {
	    var index = childrenArray.map(function (child) {
	      return child.props.value;
	    }).indexOf(event.target.value);
	
	    if (index === -1) {
	      return;
	    }
	
	    var child = childrenArray[index];
	    setValue(child.props.value);
	
	    if (onChange) {
	      onChange(event, child);
	    }
	  };
	
	  var handleItemClick = function handleItemClick(child) {
	    return function (event) {
	      if (!multiple) {
	        update(false, event);
	      }
	
	      var newValue;
	
	      if (multiple) {
	        newValue = Array.isArray(value) ? value.slice() : [];
	        var itemIndex = value.indexOf(child.props.value);
	
	        if (itemIndex === -1) {
	          newValue.push(child.props.value);
	        } else {
	          newValue.splice(itemIndex, 1);
	        }
	      } else {
	        newValue = child.props.value;
	      }
	
	      if (child.props.onClick) {
	        child.props.onClick(event);
	      }
	
	      if (value === newValue) {
	        return;
	      }
	
	      setValue(newValue);
	
	      if (onChange) {
	        event.persist(); // Preact support, target is read only property on a native event.
	
	        Object.defineProperty(event, 'target', {
	          writable: true,
	          value: {
	            value: newValue,
	            name: name
	          }
	        });
	        onChange(event, child);
	      }
	    };
	  };
	
	  var handleKeyDown = function handleKeyDown(event) {
	    if (!readOnly) {
	      var validKeys = [' ', 'ArrowUp', 'ArrowDown', // The native select doesn't respond to enter on MacOS, but it's recommended by
	      // https://www.w3.org/TR/wai-aria-practices/examples/listbox/listbox-collapsible.html
	      'Enter'];
	
	      if (validKeys.indexOf(event.key) !== -1) {
	        event.preventDefault();
	        update(true, event);
	      }
	    }
	  };
	
	  var open = displayNode !== null && (isOpenControlled ? openProp : openState);
	
	  var handleBlur = function handleBlur(event) {
	    // if open event.stopImmediatePropagation
	    if (!open && onBlur) {
	      event.persist(); // Preact support, target is read only property on a native event.
	
	      Object.defineProperty(event, 'target', {
	        writable: true,
	        value: {
	          value: value,
	          name: name
	        }
	      });
	      onBlur(event);
	    }
	  };
	
	  delete other['aria-invalid'];
	  var display;
	  var displaySingle;
	  var displayMultiple = [];
	  var computeDisplay = false;
	  var foundMatch = false; // No need to display any value if the field is empty.
	
	  if ((0, _utils2.isFilled)({
	    value: value
	  }) || displayEmpty) {
	    if (renderValue) {
	      display = renderValue(value);
	    } else {
	      computeDisplay = true;
	    }
	  }
	
	  var items = childrenArray.map(function (child) {
	    if (! /*#__PURE__*/React.isValidElement(child)) {
	      return null;
	    }
	
	    if (false) {
	      if ((0, _reactIs.isFragment)(child)) {
	        console.error(["Material-UI: The Select component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
	      }
	    }
	
	    var selected;
	
	    if (multiple) {
	      if (!Array.isArray(value)) {
	        throw new Error( false ? "Material-UI: The `value` prop must be an array when using the `Select` component with `multiple`." : (0, _utils.formatMuiErrorMessage)(2));
	      }
	
	      selected = value.some(function (v) {
	        return areEqualValues(v, child.props.value);
	      });
	
	      if (selected && computeDisplay) {
	        displayMultiple.push(child.props.children);
	      }
	    } else {
	      selected = areEqualValues(value, child.props.value);
	
	      if (selected && computeDisplay) {
	        displaySingle = child.props.children;
	      }
	    }
	
	    if (selected) {
	      foundMatch = true;
	    }
	
	    return /*#__PURE__*/React.cloneElement(child, {
	      'aria-selected': selected ? 'true' : undefined,
	      onClick: handleItemClick(child),
	      onKeyUp: function onKeyUp(event) {
	        if (event.key === ' ') {
	          // otherwise our MenuItems dispatches a click event
	          // it's not behavior of the native <option> and causes
	          // the select to close immediately since we open on space keydown
	          event.preventDefault();
	        }
	
	        if (child.props.onKeyUp) {
	          child.props.onKeyUp(event);
	        }
	      },
	      role: 'option',
	      selected: selected,
	      value: undefined,
	      // The value is most likely not a valid HTML attribute.
	      'data-value': child.props.value // Instead, we provide it as a data attribute.
	
	    });
	  });
	
	  if (false) {
	    // eslint-disable-next-line react-hooks/rules-of-hooks
	    React.useEffect(function () {
	      if (!foundMatch && !multiple && value !== '') {
	        var values = childrenArray.map(function (child) {
	          return child.props.value;
	        });
	        console.warn(["Material-UI: You have provided an out-of-range value `".concat(value, "` for the select ").concat(name ? "(name=\"".concat(name, "\") ") : '', "component."), "Consider providing a value that matches one of the available options or ''.", "The available values are ".concat(values.filter(function (x) {
	          return x != null;
	        }).map(function (x) {
	          return "`".concat(x, "`");
	        }).join(', ') || '""', ".")].join('\n'));
	      }
	    }, [foundMatch, childrenArray, multiple, name, value]);
	  }
	
	  if (computeDisplay) {
	    display = multiple ? displayMultiple.join(', ') : displaySingle;
	  } // Avoid performing a layout computation in the render method.
	
	
	  var menuMinWidth = menuMinWidthState;
	
	  if (!autoWidth && isOpenControlled && displayNode) {
	    menuMinWidth = displayNode.clientWidth;
	  }
	
	  var tabIndex;
	
	  if (typeof tabIndexProp !== 'undefined') {
	    tabIndex = tabIndexProp;
	  } else {
	    tabIndex = disabled ? null : 0;
	  }
	
	  var buttonId = SelectDisplayProps.id || (name ? "mui-component-select-".concat(name) : undefined);
	  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, // TODO v5: merge root and select
	    classes.select, classes.selectMenu, classes[variant], className, disabled && classes.disabled),
	    ref: setDisplayNode,
	    tabIndex: tabIndex,
	    role: "button",
	    "aria-disabled": disabled ? 'true' : undefined,
	    "aria-expanded": open ? 'true' : undefined,
	    "aria-haspopup": "listbox",
	    "aria-label": ariaLabel,
	    "aria-labelledby": [labelId, buttonId].filter(Boolean).join(' ') || undefined,
	    onKeyDown: handleKeyDown,
	    onMouseDown: disabled || readOnly ? null : handleMouseDown,
	    onBlur: handleBlur,
	    onFocus: onFocus
	  }, SelectDisplayProps, {
	    // The id is required for proper a11y
	    id: buttonId
	  }), isEmpty(display) ?
	  /*#__PURE__*/
	  // eslint-disable-next-line react/no-danger
	  React.createElement("span", {
	    dangerouslySetInnerHTML: {
	      __html: '&#8203;'
	    }
	  }) : display), /*#__PURE__*/React.createElement("input", (0, _extends2.default)({
	    value: Array.isArray(value) ? value.join(',') : value,
	    name: name,
	    ref: inputRef,
	    "aria-hidden": true,
	    onChange: handleChange,
	    tabIndex: -1,
	    className: classes.nativeInput,
	    autoFocus: autoFocus
	  }, other)), /*#__PURE__*/React.createElement(IconComponent, {
	    className: (0, _clsx.default)(classes.icon, classes["icon".concat((0, _capitalize.default)(variant))], open && classes.iconOpen, disabled && classes.disabled)
	  }), /*#__PURE__*/React.createElement(_Menu.default, (0, _extends2.default)({
	    id: "menu-".concat(name || ''),
	    anchorEl: displayNode,
	    open: open,
	    onClose: handleClose
	  }, MenuProps, {
	    MenuListProps: (0, _extends2.default)({
	      'aria-labelledby': labelId,
	      role: 'listbox',
	      disableListWrap: true
	    }, MenuProps.MenuListProps),
	    PaperProps: (0, _extends2.default)({}, MenuProps.PaperProps, {
	      style: (0, _extends2.default)({
	        minWidth: menuMinWidth
	      }, MenuProps.PaperProps != null ? MenuProps.PaperProps.style : null)
	    })
	  }), items));
	});
	 false ? SelectInput.propTypes = {
	  /**
	   * @ignore
	   */
	  'aria-label': _propTypes.default.string,
	
	  /**
	   * @ignore
	   */
	  autoFocus: _propTypes.default.bool,
	
	  /**
	   * If `true`, the width of the popover will automatically be set according to the items inside the
	   * menu, otherwise it will be at least the width of the select input.
	   */
	  autoWidth: _propTypes.default.bool,
	
	  /**
	   * The option elements to populate the select with.
	   * Can be some `<MenuItem>` elements.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * The CSS class name of the select element.
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The default element value. Use when the component is not controlled.
	   */
	  defaultValue: _propTypes.default.any,
	
	  /**
	   * If `true`, the select will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the selected item is displayed even if its value is empty.
	   */
	  displayEmpty: _propTypes.default.bool,
	
	  /**
	   * The icon that displays the arrow.
	   */
	  IconComponent: _propTypes.default.elementType.isRequired,
	
	  /**
	   * Imperative handle implementing `{ value: T, node: HTMLElement, focus(): void }`
	   * Equivalent to `ref`
	   */
	  inputRef: _utils.refType,
	
	  /**
	   * The ID of an element that acts as an additional label. The Select will
	   * be labelled by the additional label and the selected value.
	   */
	  labelId: _propTypes.default.string,
	
	  /**
	   * Props applied to the [`Menu`](/api/menu/) element.
	   */
	  MenuProps: _propTypes.default.object,
	
	  /**
	   * If `true`, `value` must be an array and the menu will support multiple selections.
	   */
	  multiple: _propTypes.default.bool,
	
	  /**
	   * Name attribute of the `select` or hidden `input` element.
	   */
	  name: _propTypes.default.string,
	
	  /**
	   * @ignore
	   */
	  onBlur: _propTypes.default.func,
	
	  /**
	   * Callback function fired when a menu item is selected.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new value by accessing `event.target.value` (any).
	   * @param {object} [child] The react element that was selected.
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * Callback fired when the component requests to be closed.
	   * Use in controlled mode (see open).
	   *
	   * @param {object} event The event source of the callback.
	   */
	  onClose: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onFocus: _propTypes.default.func,
	
	  /**
	   * Callback fired when the component requests to be opened.
	   * Use in controlled mode (see open).
	   *
	   * @param {object} event The event source of the callback.
	   */
	  onOpen: _propTypes.default.func,
	
	  /**
	   * Control `select` open state.
	   */
	  open: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  readOnly: _propTypes.default.bool,
	
	  /**
	   * Render the selected value.
	   *
	   * @param {any} value The `value` provided to the component.
	   * @returns {ReactNode}
	   */
	  renderValue: _propTypes.default.func,
	
	  /**
	   * Props applied to the clickable div element.
	   */
	  SelectDisplayProps: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  tabIndex: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * @ignore
	   */
	  type: _propTypes.default.any,
	
	  /**
	   * The input value.
	   */
	  value: _propTypes.default.any,
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['standard', 'outlined', 'filled'])
	} : void 0;
	var _default = SelectInput;
	exports.default = _default;

/***/ },
/* 749 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Select.default;
	  }
	});
	
	var _Select = _interopRequireDefault(__webpack_require__(747));

/***/ },
/* 750 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(25));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(37));
	
	var _utils = __webpack_require__(26);
	
	var _withStyles = _interopRequireDefault(__webpack_require__(41));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(78));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      userSelect: 'none',
	      width: '1em',
	      height: '1em',
	      display: 'inline-block',
	      fill: 'currentColor',
	      flexShrink: 0,
	      fontSize: theme.typography.pxToRem(24),
	      transition: theme.transitions.create('fill', {
	        duration: theme.transitions.duration.shorter
	      })
	    },
	
	    /* Styles applied to the root element if `color="primary"`. */
	    colorPrimary: {
	      color: theme.palette.primary.main
	    },
	
	    /* Styles applied to the root element if `color="secondary"`. */
	    colorSecondary: {
	      color: theme.palette.secondary.main
	    },
	
	    /* Styles applied to the root element if `color="action"`. */
	    colorAction: {
	      color: theme.palette.action.active
	    },
	
	    /* Styles applied to the root element if `color="error"`. */
	    colorError: {
	      color: theme.palette.error.main
	    },
	
	    /* Styles applied to the root element if `color="disabled"`. */
	    colorDisabled: {
	      color: theme.palette.action.disabled
	    },
	
	    /* Styles applied to the root element if `fontSize="inherit"`. */
	    fontSizeInherit: {
	      fontSize: 'inherit'
	    },
	
	    /* Styles applied to the root element if `fontSize="small"`. */
	    fontSizeSmall: {
	      fontSize: theme.typography.pxToRem(20)
	    },
	
	    /* Styles applied to the root element if `fontSize="large"`. */
	    fontSizeLarge: {
	      fontSize: theme.typography.pxToRem(35)
	    }
	  };
	};
	
	exports.styles = styles;
	var SvgIcon = /*#__PURE__*/React.forwardRef(function SvgIcon(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'inherit' : _props$color,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'svg' : _props$component,
	      _props$fontSize = props.fontSize,
	      fontSize = _props$fontSize === void 0 ? 'medium' : _props$fontSize,
	      htmlColor = props.htmlColor,
	      titleAccess = props.titleAccess,
	      _props$viewBox = props.viewBox,
	      viewBox = _props$viewBox === void 0 ? '0 0 24 24' : _props$viewBox,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "color", "component", "fontSize", "htmlColor", "titleAccess", "viewBox"]);
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, color !== 'inherit' && classes["color".concat((0, _capitalize.default)(color))], fontSize !== 'default' && fontSize !== 'medium' && classes["fontSize".concat((0, _capitalize.default)(fontSize))]),
	    focusable: "false",
	    viewBox: viewBox,
	    color: htmlColor,
	    "aria-hidden": titleAccess ? undefined : true,
	    role: titleAccess ? 'img' : undefined,
	    ref: ref
	  }, other), children, titleAccess ? /*#__PURE__*/React.createElement("title", null, titleAccess) : null);
	});
	 false ? SvgIcon.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * Node passed into the SVG element.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   * You can use the `htmlColor` prop to apply a color attribute to the SVG element.
	   */
	  color: _propTypes.default.oneOf(['action', 'disabled', 'error', 'inherit', 'primary', 'secondary']),
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .elementType,
	
	  /**
	   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
	   */
	  fontSize: (0, _utils.chainPropTypes)(_propTypes.default.oneOf(['default', 'inherit', 'large', 'medium', 'small']), function (props) {
	    var fontSize = props.fontSize;
	
	    if (fontSize === 'default') {
	      throw new Error('Material-UI: `fontSize="default"` is deprecated. Use `fontSize="medium"` instead.');
	    }
	
	    return null;
	  }),
	
	  /**
	   * Applies a color attribute to the SVG element.
	   */
	  htmlColor: _propTypes.default.string,
	
	  /**
	   * The shape-rendering attribute. The behavior of the different options is described on the
	   * [MDN Web Docs](https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/shape-rendering).
	   * If you are having issues with blurry icons you should investigate this property.
	   */
	  shapeRendering: _propTypes.default.string,
	
	  /**
	   * Provides a human-readable title for the element that contains it.
	   * https://www.w3.org/TR/SVG-access/#Equivalent
	   */
	  titleAccess: _propTypes.default.string,
	
	  /**
	   * Allows you to redefine what the coordinates without units mean inside an SVG element.
	   * For example, if the SVG element is 500 (width) by 200 (height),
	   * and you pass viewBox="0 0 50 20",
	   * this means that the coordinates inside the SVG will go from the top left corner (0,0)
	   * to bottom right (50,20) and each unit will be worth 10px.
	   */
	  viewBox: _propTypes.default.string
	} : void 0;
	SvgIcon.muiName = 'SvgIcon';
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiSvgIcon'
	})(SvgIcon);
	
	exports.default = _default;

/***/ },
/* 751 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _SvgIcon.default;
	  }
	});
	
	var _SvgIcon = _interopRequireDefault(__webpack_require__(750));

/***/ },
/* 752 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(25));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(37));
	
	var _utils = __webpack_require__(26);
	
	var _deprecatedPropType = _interopRequireDefault(__webpack_require__(94));
	
	var _Input = _interopRequireDefault(__webpack_require__(231));
	
	var _FilledInput = _interopRequireDefault(__webpack_require__(320));
	
	var _OutlinedInput = _interopRequireDefault(__webpack_require__(323));
	
	var _InputLabel = _interopRequireDefault(__webpack_require__(726));
	
	var _FormControl = _interopRequireDefault(__webpack_require__(714));
	
	var _FormHelperText = _interopRequireDefault(__webpack_require__(716));
	
	var _Select = _interopRequireDefault(__webpack_require__(749));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(41));
	
	var variantComponent = {
	  standard: _Input.default,
	  filled: _FilledInput.default,
	  outlined: _OutlinedInput.default
	};
	var styles = {
	  /* Styles applied to the root element. */
	  root: {}
	};
	/**
	 * The `TextField` is a convenience wrapper for the most common cases (80%).
	 * It cannot be all things to all people, otherwise the API would grow out of control.
	 *
	 * ## Advanced Configuration
	 *
	 * It's important to understand that the text field is a simple abstraction
	 * on top of the following components:
	 *
	 * - [FormControl](/api/form-control/)
	 * - [InputLabel](/api/input-label/)
	 * - [FilledInput](/api/filled-input/)
	 * - [OutlinedInput](/api/outlined-input/)
	 * - [Input](/api/input/)
	 * - [FormHelperText](/api/form-helper-text/)
	 *
	 * If you wish to alter the props applied to the `input` element, you can do so as follows:
	 *
	 * ```jsx
	 * const inputProps = {
	 *   step: 300,
	 * };
	 *
	 * return <TextField id="time" type="time" inputProps={inputProps} />;
	 * ```
	 *
	 * For advanced cases, please look at the source of TextField by clicking on the
	 * "Edit this page" button above. Consider either:
	 *
	 * - using the upper case props for passing values directly to the components
	 * - using the underlying components directly as shown in the demos
	 */
	
	exports.styles = styles;
	var TextField = /*#__PURE__*/React.forwardRef(function TextField(props, ref) {
	  var autoComplete = props.autoComplete,
	      _props$autoFocus = props.autoFocus,
	      autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus,
	      children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'primary' : _props$color,
	      defaultValue = props.defaultValue,
	      _props$disabled = props.disabled,
	      disabled = _props$disabled === void 0 ? false : _props$disabled,
	      _props$error = props.error,
	      error = _props$error === void 0 ? false : _props$error,
	      FormHelperTextProps = props.FormHelperTextProps,
	      _props$fullWidth = props.fullWidth,
	      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
	      helperText = props.helperText,
	      hiddenLabel = props.hiddenLabel,
	      id = props.id,
	      InputLabelProps = props.InputLabelProps,
	      inputProps = props.inputProps,
	      InputProps = props.InputProps,
	      inputRef = props.inputRef,
	      label = props.label,
	      _props$multiline = props.multiline,
	      multiline = _props$multiline === void 0 ? false : _props$multiline,
	      name = props.name,
	      onBlur = props.onBlur,
	      onChange = props.onChange,
	      onFocus = props.onFocus,
	      placeholder = props.placeholder,
	      _props$required = props.required,
	      required = _props$required === void 0 ? false : _props$required,
	      rows = props.rows,
	      rowsMax = props.rowsMax,
	      maxRows = props.maxRows,
	      minRows = props.minRows,
	      _props$select = props.select,
	      select = _props$select === void 0 ? false : _props$select,
	      SelectProps = props.SelectProps,
	      type = props.type,
	      value = props.value,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'standard' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["autoComplete", "autoFocus", "children", "classes", "className", "color", "defaultValue", "disabled", "error", "FormHelperTextProps", "fullWidth", "helperText", "hiddenLabel", "id", "InputLabelProps", "inputProps", "InputProps", "inputRef", "label", "multiline", "name", "onBlur", "onChange", "onFocus", "placeholder", "required", "rows", "rowsMax", "maxRows", "minRows", "select", "SelectProps", "type", "value", "variant"]);
	
	  if (false) {
	    if (select && !children) {
	      console.error('Material-UI: `children` must be passed when using the `TextField` component with `select`.');
	    }
	  }
	
	  var InputMore = {};
	
	  if (variant === 'outlined') {
	    if (InputLabelProps && typeof InputLabelProps.shrink !== 'undefined') {
	      InputMore.notched = InputLabelProps.shrink;
	    }
	
	    if (label) {
	      var _InputLabelProps$requ;
	
	      var displayRequired = (_InputLabelProps$requ = InputLabelProps === null || InputLabelProps === void 0 ? void 0 : InputLabelProps.required) !== null && _InputLabelProps$requ !== void 0 ? _InputLabelProps$requ : required;
	      InputMore.label = /*#__PURE__*/React.createElement(React.Fragment, null, label, displayRequired && "\xA0*");
	    }
	  }
	
	  if (select) {
	    // unset defaults from textbox inputs
	    if (!SelectProps || !SelectProps.native) {
	      InputMore.id = undefined;
	    }
	
	    InputMore['aria-describedby'] = undefined;
	  }
	
	  var helperTextId = helperText && id ? "".concat(id, "-helper-text") : undefined;
	  var inputLabelId = label && id ? "".concat(id, "-label") : undefined;
	  var InputComponent = variantComponent[variant];
	  var InputElement = /*#__PURE__*/React.createElement(InputComponent, (0, _extends2.default)({
	    "aria-describedby": helperTextId,
	    autoComplete: autoComplete,
	    autoFocus: autoFocus,
	    defaultValue: defaultValue,
	    fullWidth: fullWidth,
	    multiline: multiline,
	    name: name,
	    rows: rows,
	    rowsMax: rowsMax,
	    maxRows: maxRows,
	    minRows: minRows,
	    type: type,
	    value: value,
	    id: id,
	    inputRef: inputRef,
	    onBlur: onBlur,
	    onChange: onChange,
	    onFocus: onFocus,
	    placeholder: placeholder,
	    inputProps: inputProps
	  }, InputMore, InputProps));
	  return /*#__PURE__*/React.createElement(_FormControl.default, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className),
	    disabled: disabled,
	    error: error,
	    fullWidth: fullWidth,
	    hiddenLabel: hiddenLabel,
	    ref: ref,
	    required: required,
	    color: color,
	    variant: variant
	  }, other), label && /*#__PURE__*/React.createElement(_InputLabel.default, (0, _extends2.default)({
	    htmlFor: id,
	    id: inputLabelId
	  }, InputLabelProps), label), select ? /*#__PURE__*/React.createElement(_Select.default, (0, _extends2.default)({
	    "aria-describedby": helperTextId,
	    id: id,
	    labelId: inputLabelId,
	    value: value,
	    input: InputElement
	  }, SelectProps), children) : InputElement, helperText && /*#__PURE__*/React.createElement(_FormHelperText.default, (0, _extends2.default)({
	    id: helperTextId
	  }, FormHelperTextProps), helperText));
	});
	 false ? TextField.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * This prop helps users to fill forms faster, especially on mobile devices.
	   * The name can be confusing, as it's more like an autofill.
	   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
	   */
	  autoComplete: _propTypes.default.string,
	
	  /**
	   * If `true`, the `input` element will be focused during the first mount.
	   */
	  autoFocus: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['primary', 'secondary']),
	
	  /**
	   * The default value of the `input` element.
	   */
	  defaultValue: _propTypes.default.any,
	
	  /**
	   * If `true`, the `input` element will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the label will be displayed in an error state.
	   */
	  error: _propTypes.default.bool,
	
	  /**
	   * Props applied to the [`FormHelperText`](/api/form-helper-text/) element.
	   */
	  FormHelperTextProps: _propTypes.default.object,
	
	  /**
	   * If `true`, the input will take up the full width of its container.
	   */
	  fullWidth: _propTypes.default.bool,
	
	  /**
	   * The helper text content.
	   */
	  helperText: _propTypes.default.node,
	
	  /**
	   * @ignore
	   */
	  hiddenLabel: _propTypes.default.bool,
	
	  /**
	   * The id of the `input` element.
	   * Use this prop to make `label` and `helperText` accessible for screen readers.
	   */
	  id: _propTypes.default.string,
	
	  /**
	   * Props applied to the [`InputLabel`](/api/input-label/) element.
	   */
	  InputLabelProps: _propTypes.default.object,
	
	  /**
	   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
	   */
	  inputProps: _propTypes.default.object,
	
	  /**
	   * Props applied to the Input element.
	   * It will be a [`FilledInput`](/api/filled-input/),
	   * [`OutlinedInput`](/api/outlined-input/) or [`Input`](/api/input/)
	   * component depending on the `variant` prop value.
	   */
	  InputProps: _propTypes.default.object,
	
	  /**
	   * Pass a ref to the `input` element.
	   */
	  inputRef: _utils.refType,
	
	  /**
	   * The label content.
	   */
	  label: _propTypes.default.node,
	
	  /**
	   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
	   */
	  margin: _propTypes.default.oneOf(['dense', 'none', 'normal']),
	
	  /**
	   * Maximum number of rows to display when multiline option is set to true.
	   */
	  maxRows: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * Minimum number of rows to display.
	   */
	  minRows: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * If `true`, a textarea element will be rendered instead of an input.
	   */
	  multiline: _propTypes.default.bool,
	
	  /**
	   * Name attribute of the `input` element.
	   */
	  name: _propTypes.default.string,
	
	  /**
	   * @ignore
	   */
	  onBlur: _propTypes.default.func,
	
	  /**
	   * Callback fired when the value is changed.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new value by accessing `event.target.value` (string).
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onFocus: _propTypes.default.func,
	
	  /**
	   * The short hint displayed in the input before the user enters a value.
	   */
	  placeholder: _propTypes.default.string,
	
	  /**
	   * If `true`, the label is displayed as required and the `input` element` will be required.
	   */
	  required: _propTypes.default.bool,
	
	  /**
	   * Number of rows to display when multiline option is set to true.
	   * @deprecated Use `minRows` instead.
	   */
	  rows: (0, _deprecatedPropType.default)(_propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]), 'Use `minRows` instead'),
	
	  /**
	   * Maximum number of rows to display.
	   * @deprecated Use `maxRows` instead.
	   */
	  rowsMax: (0, _deprecatedPropType.default)(_propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]), 'Use `maxRows` instead'),
	
	  /**
	   * Render a [`Select`](/api/select/) element while passing the Input element to `Select` as `input` parameter.
	   * If this option is set you must pass the options of the select as children.
	   */
	  select: _propTypes.default.bool,
	
	  /**
	   * Props applied to the [`Select`](/api/select/) element.
	   */
	  SelectProps: _propTypes.default.object,
	
	  /**
	   * The size of the text field.
	   */
	  size: _propTypes.default.oneOf(['medium', 'small']),
	
	  /**
	   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
	   */
	  type: _propTypes.default.string,
	
	  /**
	   * The value of the `input` element, required for a controlled component.
	   */
	  value: _propTypes.default.any,
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['filled', 'outlined', 'standard'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiTextField'
	})(TextField);
	
	exports.default = _default;

/***/ },
/* 753 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(25));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _debounce = _interopRequireDefault(__webpack_require__(236));
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(68));
	
	var _deprecatedPropType = _interopRequireDefault(__webpack_require__(94));
	
	function getStyleValue(computedStyle, property) {
	  return parseInt(computedStyle[property], 10) || 0;
	}
	
	var useEnhancedEffect = typeof window !== 'undefined' ? React.useLayoutEffect : React.useEffect;
	var styles = {
	  /* Styles applied to the shadow textarea element. */
	  shadow: {
	    // Visibility needed to hide the extra text area on iPads
	    visibility: 'hidden',
	    // Remove from the content flow
	    position: 'absolute',
	    // Ignore the scrollbar width
	    overflow: 'hidden',
	    height: 0,
	    top: 0,
	    left: 0,
	    // Create a new layer, increase the isolation of the computed values
	    transform: 'translateZ(0)'
	  }
	};
	var TextareaAutosize = /*#__PURE__*/React.forwardRef(function TextareaAutosize(props, ref) {
	  var onChange = props.onChange,
	      rows = props.rows,
	      rowsMax = props.rowsMax,
	      rowsMinProp = props.rowsMin,
	      maxRowsProp = props.maxRows,
	      _props$minRows = props.minRows,
	      minRowsProp = _props$minRows === void 0 ? 1 : _props$minRows,
	      style = props.style,
	      value = props.value,
	      other = (0, _objectWithoutProperties2.default)(props, ["onChange", "rows", "rowsMax", "rowsMin", "maxRows", "minRows", "style", "value"]);
	  var maxRows = maxRowsProp || rowsMax;
	  var minRows = rows || rowsMinProp || minRowsProp;
	
	  var _React$useRef = React.useRef(value != null),
	      isControlled = _React$useRef.current;
	
	  var inputRef = React.useRef(null);
	  var handleRef = (0, _useForkRef.default)(ref, inputRef);
	  var shadowRef = React.useRef(null);
	  var renders = React.useRef(0);
	
	  var _React$useState = React.useState({}),
	      state = _React$useState[0],
	      setState = _React$useState[1];
	
	  var syncHeight = React.useCallback(function () {
	    var input = inputRef.current;
	    var computedStyle = window.getComputedStyle(input);
	    var inputShallow = shadowRef.current;
	    inputShallow.style.width = computedStyle.width;
	    inputShallow.value = input.value || props.placeholder || 'x';
	
	    if (inputShallow.value.slice(-1) === '\n') {
	      // Certain fonts which overflow the line height will cause the textarea
	      // to report a different scrollHeight depending on whether the last line
	      // is empty. Make it non-empty to avoid this issue.
	      inputShallow.value += ' ';
	    }
	
	    var boxSizing = computedStyle['box-sizing'];
	    var padding = getStyleValue(computedStyle, 'padding-bottom') + getStyleValue(computedStyle, 'padding-top');
	    var border = getStyleValue(computedStyle, 'border-bottom-width') + getStyleValue(computedStyle, 'border-top-width'); // The height of the inner content
	
	    var innerHeight = inputShallow.scrollHeight - padding; // Measure height of a textarea with a single row
	
	    inputShallow.value = 'x';
	    var singleRowHeight = inputShallow.scrollHeight - padding; // The height of the outer content
	
	    var outerHeight = innerHeight;
	
	    if (minRows) {
	      outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
	    }
	
	    if (maxRows) {
	      outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
	    }
	
	    outerHeight = Math.max(outerHeight, singleRowHeight); // Take the box sizing into account for applying this value as a style.
	
	    var outerHeightStyle = outerHeight + (boxSizing === 'border-box' ? padding + border : 0);
	    var overflow = Math.abs(outerHeight - innerHeight) <= 1;
	    setState(function (prevState) {
	      // Need a large enough difference to update the height.
	      // This prevents infinite rendering loop.
	      if (renders.current < 20 && (outerHeightStyle > 0 && Math.abs((prevState.outerHeightStyle || 0) - outerHeightStyle) > 1 || prevState.overflow !== overflow)) {
	        renders.current += 1;
	        return {
	          overflow: overflow,
	          outerHeightStyle: outerHeightStyle
	        };
	      }
	
	      if (false) {
	        if (renders.current === 20) {
	          console.error(['Material-UI: Too many re-renders. The layout is unstable.', 'TextareaAutosize limits the number of renders to prevent an infinite loop.'].join('\n'));
	        }
	      }
	
	      return prevState;
	    });
	  }, [maxRows, minRows, props.placeholder]);
	  React.useEffect(function () {
	    var handleResize = (0, _debounce.default)(function () {
	      renders.current = 0;
	      syncHeight();
	    });
	    window.addEventListener('resize', handleResize);
	    return function () {
	      handleResize.clear();
	      window.removeEventListener('resize', handleResize);
	    };
	  }, [syncHeight]);
	  useEnhancedEffect(function () {
	    syncHeight();
	  });
	  React.useEffect(function () {
	    renders.current = 0;
	  }, [value]);
	
	  var handleChange = function handleChange(event) {
	    renders.current = 0;
	
	    if (!isControlled) {
	      syncHeight();
	    }
	
	    if (onChange) {
	      onChange(event);
	    }
	  };
	
	  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("textarea", (0, _extends2.default)({
	    value: value,
	    onChange: handleChange,
	    ref: handleRef // Apply the rows prop to get a "correct" first SSR paint
	    ,
	    rows: minRows,
	    style: (0, _extends2.default)({
	      height: state.outerHeightStyle,
	      // Need a large enough difference to allow scrolling.
	      // This prevents infinite rendering loop.
	      overflow: state.overflow ? 'hidden' : null
	    }, style)
	  }, other)), /*#__PURE__*/React.createElement("textarea", {
	    "aria-hidden": true,
	    className: props.className,
	    readOnly: true,
	    ref: shadowRef,
	    tabIndex: -1,
	    style: (0, _extends2.default)({}, styles.shadow, style)
	  }));
	});
	 false ? TextareaAutosize.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * Maximum number of rows to display.
	   */
	  maxRows: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * Minimum number of rows to display.
	   */
	  minRows: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * @ignore
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  placeholder: _propTypes.default.string,
	
	  /**
	   * Minimum number of rows to display.
	   * @deprecated Use `minRows` instead.
	   */
	  rows: (0, _deprecatedPropType.default)(_propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]), 'Use `minRows` instead.'),
	
	  /**
	   * Maximum number of rows to display.
	   * @deprecated Use `maxRows` instead.
	   */
	  rowsMax: (0, _deprecatedPropType.default)(_propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]), 'Use `maxRows` instead.'),
	
	  /**
	   * Minimum number of rows to display.
	   * @deprecated Use `minRows` instead.
	   */
	  rowsMin: (0, _deprecatedPropType.default)(_propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]), 'Use `minRows` instead.'),
	
	  /**
	   * @ignore
	   */
	  style: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  value: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.string), _propTypes.default.number, _propTypes.default.string])
	} : void 0;
	var _default = TextareaAutosize;
	exports.default = _default;

/***/ },
/* 754 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _TextareaAutosize.default;
	  }
	});
	
	var _TextareaAutosize = _interopRequireDefault(__webpack_require__(753));

/***/ },
/* 755 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(43));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(95));
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(68));
	
	var _utils = __webpack_require__(26);
	
	/* eslint-disable consistent-return, jsx-a11y/no-noninteractive-tabindex, camelcase */
	
	/**
	 * Utility component that locks focus inside the component.
	 */
	function Unstable_TrapFocus(props) {
	  var children = props.children,
	      _props$disableAutoFoc = props.disableAutoFocus,
	      disableAutoFocus = _props$disableAutoFoc === void 0 ? false : _props$disableAutoFoc,
	      _props$disableEnforce = props.disableEnforceFocus,
	      disableEnforceFocus = _props$disableEnforce === void 0 ? false : _props$disableEnforce,
	      _props$disableRestore = props.disableRestoreFocus,
	      disableRestoreFocus = _props$disableRestore === void 0 ? false : _props$disableRestore,
	      getDoc = props.getDoc,
	      isEnabled = props.isEnabled,
	      open = props.open;
	  var ignoreNextEnforceFocus = React.useRef();
	  var sentinelStart = React.useRef(null);
	  var sentinelEnd = React.useRef(null);
	  var nodeToRestore = React.useRef();
	  var rootRef = React.useRef(null); // can be removed once we drop support for non ref forwarding class components
	
	  var handleOwnRef = React.useCallback(function (instance) {
	    // #StrictMode ready
	    rootRef.current = ReactDOM.findDOMNode(instance);
	  }, []);
	  var handleRef = (0, _useForkRef.default)(children.ref, handleOwnRef);
	  var prevOpenRef = React.useRef();
	  React.useEffect(function () {
	    prevOpenRef.current = open;
	  }, [open]);
	
	  if (!prevOpenRef.current && open && typeof window !== 'undefined') {
	    // WARNING: Potentially unsafe in concurrent mode.
	    // The way the read on `nodeToRestore` is setup could make this actually safe.
	    // Say we render `open={false}` -> `open={true}` but never commit.
	    // We have now written a state that wasn't committed. But no committed effect
	    // will read this wrong value. We only read from `nodeToRestore` in effects
	    // that were committed on `open={true}`
	    // WARNING: Prevents the instance from being garbage collected. Should only
	    // hold a weak ref.
	    nodeToRestore.current = getDoc().activeElement;
	  }
	
	  React.useEffect(function () {
	    if (!open) {
	      return;
	    }
	
	    var doc = (0, _ownerDocument.default)(rootRef.current); // We might render an empty child.
	
	    if (!disableAutoFocus && rootRef.current && !rootRef.current.contains(doc.activeElement)) {
	      if (!rootRef.current.hasAttribute('tabIndex')) {
	        if (false) {
	          console.error(['Material-UI: The modal content node does not accept focus.', 'For the benefit of assistive technologies, ' + 'the tabIndex of the node is being set to "-1".'].join('\n'));
	        }
	
	        rootRef.current.setAttribute('tabIndex', -1);
	      }
	
	      rootRef.current.focus();
	    }
	
	    var contain = function contain() {
	      var rootElement = rootRef.current; // Cleanup functions are executed lazily in React 17.
	      // Contain can be called between the component being unmounted and its cleanup function being run.
	
	      if (rootElement === null) {
	        return;
	      }
	
	      if (!doc.hasFocus() || disableEnforceFocus || !isEnabled() || ignoreNextEnforceFocus.current) {
	        ignoreNextEnforceFocus.current = false;
	        return;
	      }
	
	      if (rootRef.current && !rootRef.current.contains(doc.activeElement)) {
	        rootRef.current.focus();
	      }
	    };
	
	    var loopFocus = function loopFocus(event) {
	      // 9 = Tab
	      if (disableEnforceFocus || !isEnabled() || event.keyCode !== 9) {
	        return;
	      } // Make sure the next tab starts from the right place.
	
	
	      if (doc.activeElement === rootRef.current) {
	        // We need to ignore the next contain as
	        // it will try to move the focus back to the rootRef element.
	        ignoreNextEnforceFocus.current = true;
	
	        if (event.shiftKey) {
	          sentinelEnd.current.focus();
	        } else {
	          sentinelStart.current.focus();
	        }
	      }
	    };
	
	    doc.addEventListener('focus', contain, true);
	    doc.addEventListener('keydown', loopFocus, true); // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area
	    // e.g. https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
	    //
	    // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
	    // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
	
	    var interval = setInterval(function () {
	      contain();
	    }, 50);
	    return function () {
	      clearInterval(interval);
	      doc.removeEventListener('focus', contain, true);
	      doc.removeEventListener('keydown', loopFocus, true); // restoreLastFocus()
	
	      if (!disableRestoreFocus) {
	        // In IE 11 it is possible for document.activeElement to be null resulting
	        // in nodeToRestore.current being null.
	        // Not all elements in IE 11 have a focus method.
	        // Once IE 11 support is dropped the focus() call can be unconditional.
	        if (nodeToRestore.current && nodeToRestore.current.focus) {
	          nodeToRestore.current.focus();
	        }
	
	        nodeToRestore.current = null;
	      }
	    };
	  }, [disableAutoFocus, disableEnforceFocus, disableRestoreFocus, isEnabled, open]);
	  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
	    tabIndex: 0,
	    ref: sentinelStart,
	    "data-test": "sentinelStart"
	  }), /*#__PURE__*/React.cloneElement(children, {
	    ref: handleRef
	  }), /*#__PURE__*/React.createElement("div", {
	    tabIndex: 0,
	    ref: sentinelEnd,
	    "data-test": "sentinelEnd"
	  }));
	}
	
	 false ? Unstable_TrapFocus.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * A single child content element.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * If `true`, the trap focus will not automatically shift focus to itself when it opens, and
	   * replace it to the last focused element when it closes.
	   * This also works correctly with any trap focus children that have the `disableAutoFocus` prop.
	   *
	   * Generally this should never be set to `true` as it makes the trap focus less
	   * accessible to assistive technologies, like screen readers.
	   */
	  disableAutoFocus: _propTypes.default.bool,
	
	  /**
	   * If `true`, the trap focus will not prevent focus from leaving the trap focus while open.
	   *
	   * Generally this should never be set to `true` as it makes the trap focus less
	   * accessible to assistive technologies, like screen readers.
	   */
	  disableEnforceFocus: _propTypes.default.bool,
	
	  /**
	   * If `true`, the trap focus will not restore focus to previously focused element once
	   * trap focus is hidden.
	   */
	  disableRestoreFocus: _propTypes.default.bool,
	
	  /**
	   * Return the document to consider.
	   * We use it to implement the restore focus between different browser documents.
	   */
	  getDoc: _propTypes.default.func.isRequired,
	
	  /**
	   * Do we still want to enforce the focus?
	   * This prop helps nesting TrapFocus elements.
	   */
	  isEnabled: _propTypes.default.func.isRequired,
	
	  /**
	   * If `true`, focus will be locked.
	   */
	  open: _propTypes.default.bool.isRequired
	} : void 0;
	
	if (false) {
	  // eslint-disable-next-line
	  Unstable_TrapFocus['propTypes' + ''] = (0, _utils.exactProp)(Unstable_TrapFocus.propTypes);
	}
	
	var _default = Unstable_TrapFocus;
	exports.default = _default;

/***/ },
/* 756 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Unstable_TrapFocus.default;
	  }
	});
	
	var _Unstable_TrapFocus = _interopRequireDefault(__webpack_require__(755));

/***/ },
/* 757 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var blue = {
	  50: '#e3f2fd',
	  100: '#bbdefb',
	  200: '#90caf9',
	  300: '#64b5f6',
	  400: '#42a5f5',
	  500: '#2196f3',
	  600: '#1e88e5',
	  700: '#1976d2',
	  800: '#1565c0',
	  900: '#0d47a1',
	  A100: '#82b1ff',
	  A200: '#448aff',
	  A400: '#2979ff',
	  A700: '#2962ff'
	};
	var _default = blue;
	exports.default = _default;

/***/ },
/* 758 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var common = {
	  black: '#000',
	  white: '#fff'
	};
	var _default = common;
	exports.default = _default;

/***/ },
/* 759 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var green = {
	  50: '#e8f5e9',
	  100: '#c8e6c9',
	  200: '#a5d6a7',
	  300: '#81c784',
	  400: '#66bb6a',
	  500: '#4caf50',
	  600: '#43a047',
	  700: '#388e3c',
	  800: '#2e7d32',
	  900: '#1b5e20',
	  A100: '#b9f6ca',
	  A200: '#69f0ae',
	  A400: '#00e676',
	  A700: '#00c853'
	};
	var _default = green;
	exports.default = _default;

/***/ },
/* 760 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var grey = {
	  50: '#fafafa',
	  100: '#f5f5f5',
	  200: '#eeeeee',
	  300: '#e0e0e0',
	  400: '#bdbdbd',
	  500: '#9e9e9e',
	  600: '#757575',
	  700: '#616161',
	  800: '#424242',
	  900: '#212121',
	  A100: '#d5d5d5',
	  A200: '#aaaaaa',
	  A400: '#303030',
	  A700: '#616161'
	};
	var _default = grey;
	exports.default = _default;

/***/ },
/* 761 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var indigo = {
	  50: '#e8eaf6',
	  100: '#c5cae9',
	  200: '#9fa8da',
	  300: '#7986cb',
	  400: '#5c6bc0',
	  500: '#3f51b5',
	  600: '#3949ab',
	  700: '#303f9f',
	  800: '#283593',
	  900: '#1a237e',
	  A100: '#8c9eff',
	  A200: '#536dfe',
	  A400: '#3d5afe',
	  A700: '#304ffe'
	};
	var _default = indigo;
	exports.default = _default;

/***/ },
/* 762 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var orange = {
	  50: '#fff3e0',
	  100: '#ffe0b2',
	  200: '#ffcc80',
	  300: '#ffb74d',
	  400: '#ffa726',
	  500: '#ff9800',
	  600: '#fb8c00',
	  700: '#f57c00',
	  800: '#ef6c00',
	  900: '#e65100',
	  A100: '#ffd180',
	  A200: '#ffab40',
	  A400: '#ff9100',
	  A700: '#ff6d00'
	};
	var _default = orange;
	exports.default = _default;

/***/ },
/* 763 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var pink = {
	  50: '#fce4ec',
	  100: '#f8bbd0',
	  200: '#f48fb1',
	  300: '#f06292',
	  400: '#ec407a',
	  500: '#e91e63',
	  600: '#d81b60',
	  700: '#c2185b',
	  800: '#ad1457',
	  900: '#880e4f',
	  A100: '#ff80ab',
	  A200: '#ff4081',
	  A400: '#f50057',
	  A700: '#c51162'
	};
	var _default = pink;
	exports.default = _default;

/***/ },
/* 764 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var red = {
	  50: '#ffebee',
	  100: '#ffcdd2',
	  200: '#ef9a9a',
	  300: '#e57373',
	  400: '#ef5350',
	  500: '#f44336',
	  600: '#e53935',
	  700: '#d32f2f',
	  800: '#c62828',
	  900: '#b71c1c',
	  A100: '#ff8a80',
	  A200: '#ff5252',
	  A400: '#ff1744',
	  A700: '#d50000'
	};
	var _default = red;
	exports.default = _default;

/***/ },
/* 765 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(235));
	
	/**
	 * @ignore - internal component.
	 */
	var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
	  d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
	}), 'Cancel');
	
	exports.default = _default;

/***/ },
/* 766 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createBreakpoints;
	exports.keys = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(25));
	
	// Sorted ASC by size. That's important.
	// It can't be configured as it's used statically for propTypes.
	var keys = ['xs', 'sm', 'md', 'lg', 'xl']; // Keep in mind that @media is inclusive by the CSS specification.
	
	exports.keys = keys;
	
	function createBreakpoints(breakpoints) {
	  var _breakpoints$values = breakpoints.values,
	      values = _breakpoints$values === void 0 ? {
	    xs: 0,
	    sm: 600,
	    md: 960,
	    lg: 1280,
	    xl: 1920
	  } : _breakpoints$values,
	      _breakpoints$unit = breakpoints.unit,
	      unit = _breakpoints$unit === void 0 ? 'px' : _breakpoints$unit,
	      _breakpoints$step = breakpoints.step,
	      step = _breakpoints$step === void 0 ? 5 : _breakpoints$step,
	      other = (0, _objectWithoutProperties2.default)(breakpoints, ["values", "unit", "step"]);
	
	  function up(key) {
	    var value = typeof values[key] === 'number' ? values[key] : key;
	    return "@media (min-width:".concat(value).concat(unit, ")");
	  }
	
	  function down(key) {
	    var endIndex = keys.indexOf(key) + 1;
	    var upperbound = values[keys[endIndex]];
	
	    if (endIndex === keys.length) {
	      // xl down applies to all sizes
	      return up('xs');
	    }
	
	    var value = typeof upperbound === 'number' && endIndex > 0 ? upperbound : key;
	    return "@media (max-width:".concat(value - step / 100).concat(unit, ")");
	  }
	
	  function between(start, end) {
	    var endIndex = keys.indexOf(end);
	
	    if (endIndex === keys.length - 1) {
	      return up(start);
	    }
	
	    return "@media (min-width:".concat(typeof values[start] === 'number' ? values[start] : start).concat(unit, ") and ") + "(max-width:".concat((endIndex !== -1 && typeof values[keys[endIndex + 1]] === 'number' ? values[keys[endIndex + 1]] : end) - step / 100).concat(unit, ")");
	  }
	
	  function only(key) {
	    return between(key, key);
	  }
	
	  var warnedOnce = false;
	
	  function width(key) {
	    if (false) {
	      if (!warnedOnce) {
	        warnedOnce = true;
	        console.warn(["Material-UI: The `theme.breakpoints.width` utility is deprecated because it's redundant.", 'Use the `theme.breakpoints.values` instead.'].join('\n'));
	      }
	    }
	
	    return values[key];
	  }
	
	  return (0, _extends2.default)({
	    keys: keys,
	    values: values,
	    up: up,
	    down: down,
	    between: between,
	    only: only,
	    width: width
	  }, other);
	}

/***/ },
/* 767 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createMixins;
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(24));
	
	var _extends3 = _interopRequireDefault(__webpack_require__(6));
	
	function createMixins(breakpoints, spacing, mixins) {
	  var _toolbar;
	
	  return (0, _extends3.default)({
	    gutters: function gutters() {
	      var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      console.warn(['Material-UI: theme.mixins.gutters() is deprecated.', 'You can use the source of the mixin directly:', "\n      paddingLeft: theme.spacing(2),\n      paddingRight: theme.spacing(2),\n      [theme.breakpoints.up('sm')]: {\n        paddingLeft: theme.spacing(3),\n        paddingRight: theme.spacing(3),\n      },\n      "].join('\n'));
	      return (0, _extends3.default)({
	        paddingLeft: spacing(2),
	        paddingRight: spacing(2)
	      }, styles, (0, _defineProperty2.default)({}, breakpoints.up('sm'), (0, _extends3.default)({
	        paddingLeft: spacing(3),
	        paddingRight: spacing(3)
	      }, styles[breakpoints.up('sm')])));
	    },
	    toolbar: (_toolbar = {
	      minHeight: 56
	    }, (0, _defineProperty2.default)(_toolbar, "".concat(breakpoints.up('xs'), " and (orientation: landscape)"), {
	      minHeight: 48
	    }), (0, _defineProperty2.default)(_toolbar, breakpoints.up('sm'), {
	      minHeight: 64
	    }), _toolbar)
	  }, mixins);
	}

/***/ },
/* 768 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createMuiStrictModeTheme;
	
	var _utils = __webpack_require__(26);
	
	var _createTheme = _interopRequireDefault(__webpack_require__(234));
	
	function createMuiStrictModeTheme(options) {
	  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    args[_key - 1] = arguments[_key];
	  }
	
	  return _createTheme.default.apply(void 0, [(0, _utils.deepmerge)({
	    unstable_strictMode: true
	  }, options)].concat(args));
	}

/***/ },
/* 769 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createPalette;
	exports.dark = exports.light = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(25));
	
	var _utils = __webpack_require__(26);
	
	var _common = _interopRequireDefault(__webpack_require__(758));
	
	var _grey = _interopRequireDefault(__webpack_require__(760));
	
	var _indigo = _interopRequireDefault(__webpack_require__(761));
	
	var _pink = _interopRequireDefault(__webpack_require__(763));
	
	var _red = _interopRequireDefault(__webpack_require__(764));
	
	var _orange = _interopRequireDefault(__webpack_require__(762));
	
	var _blue = _interopRequireDefault(__webpack_require__(757));
	
	var _green = _interopRequireDefault(__webpack_require__(759));
	
	var _colorManipulator = __webpack_require__(177);
	
	var light = {
	  // The colors used to style the text.
	  text: {
	    // The most important text.
	    primary: 'rgba(0, 0, 0, 0.87)',
	    // Secondary text.
	    secondary: 'rgba(0, 0, 0, 0.54)',
	    // Disabled text have even lower visual prominence.
	    disabled: 'rgba(0, 0, 0, 0.38)',
	    // Text hints.
	    hint: 'rgba(0, 0, 0, 0.38)'
	  },
	  // The color used to divide different elements.
	  divider: 'rgba(0, 0, 0, 0.12)',
	  // The background colors used to style the surfaces.
	  // Consistency between these values is important.
	  background: {
	    paper: _common.default.white,
	    default: _grey.default[50]
	  },
	  // The colors used to style the action elements.
	  action: {
	    // The color of an active action like an icon button.
	    active: 'rgba(0, 0, 0, 0.54)',
	    // The color of an hovered action.
	    hover: 'rgba(0, 0, 0, 0.04)',
	    hoverOpacity: 0.04,
	    // The color of a selected action.
	    selected: 'rgba(0, 0, 0, 0.08)',
	    selectedOpacity: 0.08,
	    // The color of a disabled action.
	    disabled: 'rgba(0, 0, 0, 0.26)',
	    // The background color of a disabled action.
	    disabledBackground: 'rgba(0, 0, 0, 0.12)',
	    disabledOpacity: 0.38,
	    focus: 'rgba(0, 0, 0, 0.12)',
	    focusOpacity: 0.12,
	    activatedOpacity: 0.12
	  }
	};
	exports.light = light;
	var dark = {
	  text: {
	    primary: _common.default.white,
	    secondary: 'rgba(255, 255, 255, 0.7)',
	    disabled: 'rgba(255, 255, 255, 0.5)',
	    hint: 'rgba(255, 255, 255, 0.5)',
	    icon: 'rgba(255, 255, 255, 0.5)'
	  },
	  divider: 'rgba(255, 255, 255, 0.12)',
	  background: {
	    paper: _grey.default[800],
	    default: '#303030'
	  },
	  action: {
	    active: _common.default.white,
	    hover: 'rgba(255, 255, 255, 0.08)',
	    hoverOpacity: 0.08,
	    selected: 'rgba(255, 255, 255, 0.16)',
	    selectedOpacity: 0.16,
	    disabled: 'rgba(255, 255, 255, 0.3)',
	    disabledBackground: 'rgba(255, 255, 255, 0.12)',
	    disabledOpacity: 0.38,
	    focus: 'rgba(255, 255, 255, 0.12)',
	    focusOpacity: 0.12,
	    activatedOpacity: 0.24
	  }
	};
	exports.dark = dark;
	
	function addLightOrDark(intent, direction, shade, tonalOffset) {
	  var tonalOffsetLight = tonalOffset.light || tonalOffset;
	  var tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
	
	  if (!intent[direction]) {
	    if (intent.hasOwnProperty(shade)) {
	      intent[direction] = intent[shade];
	    } else if (direction === 'light') {
	      intent.light = (0, _colorManipulator.lighten)(intent.main, tonalOffsetLight);
	    } else if (direction === 'dark') {
	      intent.dark = (0, _colorManipulator.darken)(intent.main, tonalOffsetDark);
	    }
	  }
	}
	
	function createPalette(palette) {
	  var _palette$primary = palette.primary,
	      primary = _palette$primary === void 0 ? {
	    light: _indigo.default[300],
	    main: _indigo.default[500],
	    dark: _indigo.default[700]
	  } : _palette$primary,
	      _palette$secondary = palette.secondary,
	      secondary = _palette$secondary === void 0 ? {
	    light: _pink.default.A200,
	    main: _pink.default.A400,
	    dark: _pink.default.A700
	  } : _palette$secondary,
	      _palette$error = palette.error,
	      error = _palette$error === void 0 ? {
	    light: _red.default[300],
	    main: _red.default[500],
	    dark: _red.default[700]
	  } : _palette$error,
	      _palette$warning = palette.warning,
	      warning = _palette$warning === void 0 ? {
	    light: _orange.default[300],
	    main: _orange.default[500],
	    dark: _orange.default[700]
	  } : _palette$warning,
	      _palette$info = palette.info,
	      info = _palette$info === void 0 ? {
	    light: _blue.default[300],
	    main: _blue.default[500],
	    dark: _blue.default[700]
	  } : _palette$info,
	      _palette$success = palette.success,
	      success = _palette$success === void 0 ? {
	    light: _green.default[300],
	    main: _green.default[500],
	    dark: _green.default[700]
	  } : _palette$success,
	      _palette$type = palette.type,
	      type = _palette$type === void 0 ? 'light' : _palette$type,
	      _palette$contrastThre = palette.contrastThreshold,
	      contrastThreshold = _palette$contrastThre === void 0 ? 3 : _palette$contrastThre,
	      _palette$tonalOffset = palette.tonalOffset,
	      tonalOffset = _palette$tonalOffset === void 0 ? 0.2 : _palette$tonalOffset,
	      other = (0, _objectWithoutProperties2.default)(palette, ["primary", "secondary", "error", "warning", "info", "success", "type", "contrastThreshold", "tonalOffset"]); // Use the same logic as
	  // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
	  // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
	
	  function getContrastText(background) {
	    var contrastText = (0, _colorManipulator.getContrastRatio)(background, dark.text.primary) >= contrastThreshold ? dark.text.primary : light.text.primary;
	
	    if (false) {
	      var contrast = (0, _colorManipulator.getContrastRatio)(background, contrastText);
	
	      if (contrast < 3) {
	        console.error(["Material-UI: The contrast ratio of ".concat(contrast, ":1 for ").concat(contrastText, " on ").concat(background), 'falls below the WCAG recommended absolute minimum contrast ratio of 3:1.', 'https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast'].join('\n'));
	      }
	    }
	
	    return contrastText;
	  }
	
	  var augmentColor = function augmentColor(color) {
	    var mainShade = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
	    var lightShade = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 300;
	    var darkShade = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 700;
	    color = (0, _extends2.default)({}, color);
	
	    if (!color.main && color[mainShade]) {
	      color.main = color[mainShade];
	    }
	
	    if (!color.main) {
	      throw new Error( false ? "Material-UI: The color provided to augmentColor(color) is invalid.\nThe color object needs to have a `main` property or a `".concat(mainShade, "` property.") : (0, _utils.formatMuiErrorMessage)(4, mainShade));
	    }
	
	    if (typeof color.main !== 'string') {
	      throw new Error( false ? "Material-UI: The color provided to augmentColor(color) is invalid.\n`color.main` should be a string, but `".concat(JSON.stringify(color.main), "` was provided instead.\n\nDid you intend to use one of the following approaches?\n\nimport {\xA0green } from \"@material-ui/core/colors\";\n\nconst theme1 = createTheme({ palette: {\n  primary: green,\n} });\n\nconst theme2 = createTheme({ palette: {\n  primary: { main: green[500] },\n} });") : _formatMuiErrorMessage(5, JSON.stringify(color.main)));
	    }
	
	    addLightOrDark(color, 'light', lightShade, tonalOffset);
	    addLightOrDark(color, 'dark', darkShade, tonalOffset);
	
	    if (!color.contrastText) {
	      color.contrastText = getContrastText(color.main);
	    }
	
	    return color;
	  };
	
	  var types = {
	    dark: dark,
	    light: light
	  };
	
	  if (false) {
	    if (!types[type]) {
	      console.error("Material-UI: The palette type `".concat(type, "` is not supported."));
	    }
	  }
	
	  var paletteOutput = (0, _utils.deepmerge)((0, _extends2.default)({
	    // A collection of common colors.
	    common: _common.default,
	    // The palette type, can be light or dark.
	    type: type,
	    // The colors used to represent primary interface elements for a user.
	    primary: augmentColor(primary),
	    // The colors used to represent secondary interface elements for a user.
	    secondary: augmentColor(secondary, 'A400', 'A200', 'A700'),
	    // The colors used to represent interface elements that the user should be made aware of.
	    error: augmentColor(error),
	    // The colors used to represent potentially dangerous actions or important messages.
	    warning: augmentColor(warning),
	    // The colors used to present information to the user that is neutral and not necessarily important.
	    info: augmentColor(info),
	    // The colors used to indicate the successful completion of an action that user triggered.
	    success: augmentColor(success),
	    // The grey colors.
	    grey: _grey.default,
	    // Used by `getContrastText()` to maximize the contrast between
	    // the background and the text.
	    contrastThreshold: contrastThreshold,
	    // Takes a background color and returns the text color that maximizes the contrast.
	    getContrastText: getContrastText,
	    // Generate a rich color object.
	    augmentColor: augmentColor,
	    // Used by the functions below to shift a color's luminance by approximately
	    // two indexes within its tonal palette.
	    // E.g., shift from Red 500 to Red 300 or Red 700.
	    tonalOffset: tonalOffset
	  }, types[type]), other);
	  return paletteOutput;
	}

/***/ },
/* 770 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createSpacing;
	
	var _system = __webpack_require__(816);
	
	var warnOnce;
	
	function createSpacing() {
	  var spacingInput = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 8;
	
	  // Already transformed.
	  if (spacingInput.mui) {
	    return spacingInput;
	  } // Material Design layouts are visually balanced. Most measurements align to an 8dp grid applied, which aligns both spacing and the overall layout.
	  // Smaller components, such as icons and type, can align to a 4dp grid.
	  // https://material.io/design/layout/understanding-layout.html#usage
	
	
	  var transform = (0, _system.createUnarySpacing)({
	    spacing: spacingInput
	  });
	
	  var spacing = function spacing() {
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    if (false) {
	      if (!(args.length <= 4)) {
	        console.error("Material-UI: Too many arguments provided, expected between 0 and 4, got ".concat(args.length));
	      }
	    }
	
	    if (args.length === 0) {
	      return transform(1);
	    }
	
	    if (args.length === 1) {
	      return transform(args[0]);
	    }
	
	    return args.map(function (argument) {
	      if (typeof argument === 'string') {
	        return argument;
	      }
	
	      var output = transform(argument);
	      return typeof output === 'number' ? "".concat(output, "px") : output;
	    }).join(' ');
	  }; // Backward compatibility, to remove in v5.
	
	
	  Object.defineProperty(spacing, 'unit', {
	    get: function get() {
	      if (false) {
	        if (!warnOnce || process.env.NODE_ENV === 'test') {
	          console.error(['Material-UI: theme.spacing.unit usage has been deprecated.', 'It will be removed in v5.', 'You can replace `theme.spacing.unit * y` with `theme.spacing(y)`.', '', 'You can use the `https://github.com/mui-org/material-ui/tree/master/packages/material-ui-codemod/README.md#theme-spacing-api` migration helper to make the process smoother.'].join('\n'));
	        }
	
	        warnOnce = true;
	      }
	
	      return spacingInput;
	    }
	  });
	  spacing.mui = true;
	  return spacing;
	}

/***/ },
/* 771 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createStyles;
	
	var _styles = __webpack_require__(80);
	
	// let warnOnce = false;
	// To remove in v5
	function createStyles(styles) {
	  // warning(
	  //   warnOnce,
	  //   [
	  //     'Material-UI: createStyles from @material-ui/core/styles is deprecated.',
	  //     'Please use @material-ui/styles/createStyles',
	  //   ].join('\n'),
	  // );
	  // warnOnce = true;
	  return (0, _styles.createStyles)(styles);
	}

/***/ },
/* 772 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createTypography;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(25));
	
	var _utils = __webpack_require__(26);
	
	function round(value) {
	  return Math.round(value * 1e5) / 1e5;
	}
	
	var warnedOnce = false;
	
	function roundWithDeprecationWarning(value) {
	  if (false) {
	    if (!warnedOnce) {
	      console.warn(['Material-UI: The `theme.typography.round` helper is deprecated.', 'Head to https://mui.com/r/migration-v4/#theme for a migration path.'].join('\n'));
	      warnedOnce = true;
	    }
	  }
	
	  return round(value);
	}
	
	var caseAllCaps = {
	  textTransform: 'uppercase'
	};
	var defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
	/**
	 * @see @link{https://material.io/design/typography/the-type-system.html}
	 * @see @link{https://material.io/design/typography/understanding-typography.html}
	 */
	
	function createTypography(palette, typography) {
	  var _ref = typeof typography === 'function' ? typography(palette) : typography,
	      _ref$fontFamily = _ref.fontFamily,
	      fontFamily = _ref$fontFamily === void 0 ? defaultFontFamily : _ref$fontFamily,
	      _ref$fontSize = _ref.fontSize,
	      fontSize = _ref$fontSize === void 0 ? 14 : _ref$fontSize,
	      _ref$fontWeightLight = _ref.fontWeightLight,
	      fontWeightLight = _ref$fontWeightLight === void 0 ? 300 : _ref$fontWeightLight,
	      _ref$fontWeightRegula = _ref.fontWeightRegular,
	      fontWeightRegular = _ref$fontWeightRegula === void 0 ? 400 : _ref$fontWeightRegula,
	      _ref$fontWeightMedium = _ref.fontWeightMedium,
	      fontWeightMedium = _ref$fontWeightMedium === void 0 ? 500 : _ref$fontWeightMedium,
	      _ref$fontWeightBold = _ref.fontWeightBold,
	      fontWeightBold = _ref$fontWeightBold === void 0 ? 700 : _ref$fontWeightBold,
	      _ref$htmlFontSize = _ref.htmlFontSize,
	      htmlFontSize = _ref$htmlFontSize === void 0 ? 16 : _ref$htmlFontSize,
	      allVariants = _ref.allVariants,
	      pxToRem2 = _ref.pxToRem,
	      other = (0, _objectWithoutProperties2.default)(_ref, ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "fontWeightBold", "htmlFontSize", "allVariants", "pxToRem"]);
	
	  if (false) {
	    if (typeof fontSize !== 'number') {
	      console.error('Material-UI: `fontSize` is required to be a number.');
	    }
	
	    if (typeof htmlFontSize !== 'number') {
	      console.error('Material-UI: `htmlFontSize` is required to be a number.');
	    }
	  }
	
	  var coef = fontSize / 14;
	
	  var pxToRem = pxToRem2 || function (size) {
	    return "".concat(size / htmlFontSize * coef, "rem");
	  };
	
	  var buildVariant = function buildVariant(fontWeight, size, lineHeight, letterSpacing, casing) {
	    return (0, _extends2.default)({
	      fontFamily: fontFamily,
	      fontWeight: fontWeight,
	      fontSize: pxToRem(size),
	      // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
	      lineHeight: lineHeight
	    }, fontFamily === defaultFontFamily ? {
	      letterSpacing: "".concat(round(letterSpacing / size), "em")
	    } : {}, casing, allVariants);
	  };
	
	  var variants = {
	    h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
	    h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
	    h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
	    h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
	    h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
	    h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
	    subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
	    subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
	    body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
	    body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
	    button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, caseAllCaps),
	    caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
	    overline: buildVariant(fontWeightRegular, 12, 2.66, 1, caseAllCaps)
	  };
	  return (0, _utils.deepmerge)((0, _extends2.default)({
	    htmlFontSize: htmlFontSize,
	    pxToRem: pxToRem,
	    round: roundWithDeprecationWarning,
	    // TODO v5: remove
	    fontFamily: fontFamily,
	    fontSize: fontSize,
	    fontWeightLight: fontWeightLight,
	    fontWeightRegular: fontWeightRegular,
	    fontWeightMedium: fontWeightMedium,
	    fontWeightBold: fontWeightBold
	  }, variants), other, {
	    clone: false // No need to clone deep
	
	  });
	}

/***/ },
/* 773 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isUnitless = isUnitless;
	exports.getUnit = getUnit;
	exports.toUnitless = toUnitless;
	exports.convertLength = convertLength;
	exports.alignProperty = alignProperty;
	exports.fontGrid = fontGrid;
	exports.responsiveProperty = responsiveProperty;
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(24));
	
	function isUnitless(value) {
	  return String(parseFloat(value)).length === String(value).length;
	} // Ported from Compass
	// https://github.com/Compass/compass/blob/master/core/stylesheets/compass/typography/_units.scss
	// Emulate the sass function "unit"
	
	
	function getUnit(input) {
	  return String(input).match(/[\d.\-+]*\s*(.*)/)[1] || '';
	} // Emulate the sass function "unitless"
	
	
	function toUnitless(length) {
	  return parseFloat(length);
	} // Convert any CSS <length> or <percentage> value to any another.
	// From https://github.com/KyleAMathews/convert-css-length
	
	
	function convertLength(baseFontSize) {
	  return function (length, toUnit) {
	    var fromUnit = getUnit(length); // Optimize for cases where `from` and `to` units are accidentally the same.
	
	    if (fromUnit === toUnit) {
	      return length;
	    } // Convert input length to pixels.
	
	
	    var pxLength = toUnitless(length);
	
	    if (fromUnit !== 'px') {
	      if (fromUnit === 'em') {
	        pxLength = toUnitless(length) * toUnitless(baseFontSize);
	      } else if (fromUnit === 'rem') {
	        pxLength = toUnitless(length) * toUnitless(baseFontSize);
	        return length;
	      }
	    } // Convert length in pixels to the output unit
	
	
	    var outputLength = pxLength;
	
	    if (toUnit !== 'px') {
	      if (toUnit === 'em') {
	        outputLength = pxLength / toUnitless(baseFontSize);
	      } else if (toUnit === 'rem') {
	        outputLength = pxLength / toUnitless(baseFontSize);
	      } else {
	        return length;
	      }
	    }
	
	    return parseFloat(outputLength.toFixed(5)) + toUnit;
	  };
	}
	
	function alignProperty(_ref) {
	  var size = _ref.size,
	      grid = _ref.grid;
	  var sizeBelow = size - size % grid;
	  var sizeAbove = sizeBelow + grid;
	  return size - sizeBelow < sizeAbove - size ? sizeBelow : sizeAbove;
	} // fontGrid finds a minimal grid (in rem) for the fontSize values so that the
	// lineHeight falls under a x pixels grid, 4px in the case of Material Design,
	// without changing the relative line height
	
	
	function fontGrid(_ref2) {
	  var lineHeight = _ref2.lineHeight,
	      pixels = _ref2.pixels,
	      htmlFontSize = _ref2.htmlFontSize;
	  return pixels / (lineHeight * htmlFontSize);
	}
	/**
	 * generate a responsive version of a given CSS property
	 * @example
	 * responsiveProperty({
	 *   cssProperty: 'fontSize',
	 *   min: 15,
	 *   max: 20,
	 *   unit: 'px',
	 *   breakpoints: [300, 600],
	 * })
	 *
	 * // this returns
	 *
	 * {
	 *   fontSize: '15px',
	 *   '@media (min-width:300px)': {
	 *     fontSize: '17.5px',
	 *   },
	 *   '@media (min-width:600px)': {
	 *     fontSize: '20px',
	 *   },
	 * }
	 *
	 * @param {Object} params
	 * @param {string} params.cssProperty - The CSS property to be made responsive
	 * @param {number} params.min - The smallest value of the CSS property
	 * @param {number} params.max - The largest value of the CSS property
	 * @param {string} [params.unit] - The unit to be used for the CSS property
	 * @param {Array.number} [params.breakpoints]  - An array of breakpoints
	 * @param {number} [params.alignStep] - Round scaled value to fall under this grid
	 * @returns {Object} responsive styles for {params.cssProperty}
	 */
	
	
	function responsiveProperty(_ref3) {
	  var cssProperty = _ref3.cssProperty,
	      min = _ref3.min,
	      max = _ref3.max,
	      _ref3$unit = _ref3.unit,
	      unit = _ref3$unit === void 0 ? 'rem' : _ref3$unit,
	      _ref3$breakpoints = _ref3.breakpoints,
	      breakpoints = _ref3$breakpoints === void 0 ? [600, 960, 1280] : _ref3$breakpoints,
	      _ref3$transform = _ref3.transform,
	      transform = _ref3$transform === void 0 ? null : _ref3$transform;
	  var output = (0, _defineProperty2.default)({}, cssProperty, "".concat(min).concat(unit));
	  var factor = (max - min) / breakpoints[breakpoints.length - 1];
	  breakpoints.forEach(function (breakpoint) {
	    var value = min + factor * breakpoint;
	
	    if (transform !== null) {
	      value = transform(value);
	    }
	
	    output["@media (min-width:".concat(breakpoint, "px)")] = (0, _defineProperty2.default)({}, cssProperty, "".concat(Math.round(value * 10000) / 10000).concat(unit));
	  });
	  return output;
	}

/***/ },
/* 774 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var _exportNames = {
	  createTheme: true,
	  createMuiTheme: true,
	  unstable_createMuiStrictModeTheme: true,
	  createStyles: true,
	  makeStyles: true,
	  responsiveFontSizes: true,
	  styled: true,
	  useTheme: true,
	  withStyles: true,
	  withTheme: true,
	  createGenerateClassName: true,
	  jssPreset: true,
	  ServerStyleSheets: true,
	  StylesProvider: true,
	  MuiThemeProvider: true,
	  ThemeProvider: true
	};
	Object.defineProperty(exports, "createTheme", {
	  enumerable: true,
	  get: function get() {
	    return _createTheme.default;
	  }
	});
	Object.defineProperty(exports, "createMuiTheme", {
	  enumerable: true,
	  get: function get() {
	    return _createTheme.createMuiTheme;
	  }
	});
	Object.defineProperty(exports, "unstable_createMuiStrictModeTheme", {
	  enumerable: true,
	  get: function get() {
	    return _createMuiStrictModeTheme.default;
	  }
	});
	Object.defineProperty(exports, "createStyles", {
	  enumerable: true,
	  get: function get() {
	    return _createStyles.default;
	  }
	});
	Object.defineProperty(exports, "makeStyles", {
	  enumerable: true,
	  get: function get() {
	    return _makeStyles.default;
	  }
	});
	Object.defineProperty(exports, "responsiveFontSizes", {
	  enumerable: true,
	  get: function get() {
	    return _responsiveFontSizes.default;
	  }
	});
	Object.defineProperty(exports, "styled", {
	  enumerable: true,
	  get: function get() {
	    return _styled.default;
	  }
	});
	Object.defineProperty(exports, "useTheme", {
	  enumerable: true,
	  get: function get() {
	    return _useTheme.default;
	  }
	});
	Object.defineProperty(exports, "withStyles", {
	  enumerable: true,
	  get: function get() {
	    return _withStyles.default;
	  }
	});
	Object.defineProperty(exports, "withTheme", {
	  enumerable: true,
	  get: function get() {
	    return _withTheme.default;
	  }
	});
	Object.defineProperty(exports, "createGenerateClassName", {
	  enumerable: true,
	  get: function get() {
	    return _styles.createGenerateClassName;
	  }
	});
	Object.defineProperty(exports, "jssPreset", {
	  enumerable: true,
	  get: function get() {
	    return _styles.jssPreset;
	  }
	});
	Object.defineProperty(exports, "ServerStyleSheets", {
	  enumerable: true,
	  get: function get() {
	    return _styles.ServerStyleSheets;
	  }
	});
	Object.defineProperty(exports, "StylesProvider", {
	  enumerable: true,
	  get: function get() {
	    return _styles.StylesProvider;
	  }
	});
	Object.defineProperty(exports, "MuiThemeProvider", {
	  enumerable: true,
	  get: function get() {
	    return _styles.ThemeProvider;
	  }
	});
	Object.defineProperty(exports, "ThemeProvider", {
	  enumerable: true,
	  get: function get() {
	    return _styles.ThemeProvider;
	  }
	});
	
	var _colorManipulator = __webpack_require__(177);
	
	Object.keys(_colorManipulator).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _colorManipulator[key];
	    }
	  });
	});
	
	var _createTheme = _interopRequireWildcard(__webpack_require__(234));
	
	var _createMuiStrictModeTheme = _interopRequireDefault(__webpack_require__(768));
	
	var _createStyles = _interopRequireDefault(__webpack_require__(771));
	
	var _makeStyles = _interopRequireDefault(__webpack_require__(775));
	
	var _responsiveFontSizes = _interopRequireDefault(__webpack_require__(776));
	
	var _styled = _interopRequireDefault(__webpack_require__(779));
	
	var _transitions = __webpack_require__(327);
	
	Object.keys(_transitions).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _transitions[key];
	    }
	  });
	});
	
	var _useTheme = _interopRequireDefault(__webpack_require__(178));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(41));
	
	var _withTheme = _interopRequireDefault(__webpack_require__(780));
	
	var _styles = __webpack_require__(80);

/***/ },
/* 775 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _styles = __webpack_require__(80);
	
	var _defaultTheme = _interopRequireDefault(__webpack_require__(142));
	
	function makeStyles(stylesOrCreator) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  return (0, _styles.makeStyles)(stylesOrCreator, (0, _extends2.default)({
	    defaultTheme: _defaultTheme.default
	  }, options));
	}
	
	var _default = makeStyles;
	exports.default = _default;

/***/ },
/* 776 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = responsiveFontSizes;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _utils = __webpack_require__(26);
	
	var _cssUtils = __webpack_require__(773);
	
	function responsiveFontSizes(themeInput) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var _options$breakpoints = options.breakpoints,
	      breakpoints = _options$breakpoints === void 0 ? ['sm', 'md', 'lg'] : _options$breakpoints,
	      _options$disableAlign = options.disableAlign,
	      disableAlign = _options$disableAlign === void 0 ? false : _options$disableAlign,
	      _options$factor = options.factor,
	      factor = _options$factor === void 0 ? 2 : _options$factor,
	      _options$variants = options.variants,
	      variants = _options$variants === void 0 ? ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'subtitle1', 'subtitle2', 'body1', 'body2', 'caption', 'button', 'overline'] : _options$variants;
	  var theme = (0, _extends2.default)({}, themeInput);
	  theme.typography = (0, _extends2.default)({}, theme.typography);
	  var typography = theme.typography; // Convert between css lengths e.g. em->px or px->rem
	  // Set the baseFontSize for your project. Defaults to 16px (also the browser default).
	
	  var convert = (0, _cssUtils.convertLength)(typography.htmlFontSize);
	  var breakpointValues = breakpoints.map(function (x) {
	    return theme.breakpoints.values[x];
	  });
	  variants.forEach(function (variant) {
	    var style = typography[variant];
	    var remFontSize = parseFloat(convert(style.fontSize, 'rem'));
	
	    if (remFontSize <= 1) {
	      return;
	    }
	
	    var maxFontSize = remFontSize;
	    var minFontSize = 1 + (maxFontSize - 1) / factor;
	    var lineHeight = style.lineHeight;
	
	    if (!(0, _cssUtils.isUnitless)(lineHeight) && !disableAlign) {
	      throw new Error( false ? "Material-UI: Unsupported non-unitless line height with grid alignment.\nUse unitless line heights instead." : (0, _utils.formatMuiErrorMessage)(6));
	    }
	
	    if (!(0, _cssUtils.isUnitless)(lineHeight)) {
	      // make it unitless
	      lineHeight = parseFloat(convert(lineHeight, 'rem')) / parseFloat(remFontSize);
	    }
	
	    var transform = null;
	
	    if (!disableAlign) {
	      transform = function transform(value) {
	        return (0, _cssUtils.alignProperty)({
	          size: value,
	          grid: (0, _cssUtils.fontGrid)({
	            pixels: 4,
	            lineHeight: lineHeight,
	            htmlFontSize: typography.htmlFontSize
	          })
	        });
	      };
	    }
	
	    typography[variant] = (0, _extends2.default)({}, style, (0, _cssUtils.responsiveProperty)({
	      cssProperty: 'fontSize',
	      min: minFontSize,
	      max: maxFontSize,
	      unit: 'rem',
	      breakpoints: breakpointValues,
	      transform: transform
	    }));
	  });
	  return theme;
	}

/***/ },
/* 777 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var shadowKeyUmbraOpacity = 0.2;
	var shadowKeyPenumbraOpacity = 0.14;
	var shadowAmbientShadowOpacity = 0.12;
	
	function createShadow() {
	  return ["".concat(arguments.length <= 0 ? undefined : arguments[0], "px ").concat(arguments.length <= 1 ? undefined : arguments[1], "px ").concat(arguments.length <= 2 ? undefined : arguments[2], "px ").concat(arguments.length <= 3 ? undefined : arguments[3], "px rgba(0,0,0,").concat(shadowKeyUmbraOpacity, ")"), "".concat(arguments.length <= 4 ? undefined : arguments[4], "px ").concat(arguments.length <= 5 ? undefined : arguments[5], "px ").concat(arguments.length <= 6 ? undefined : arguments[6], "px ").concat(arguments.length <= 7 ? undefined : arguments[7], "px rgba(0,0,0,").concat(shadowKeyPenumbraOpacity, ")"), "".concat(arguments.length <= 8 ? undefined : arguments[8], "px ").concat(arguments.length <= 9 ? undefined : arguments[9], "px ").concat(arguments.length <= 10 ? undefined : arguments[10], "px ").concat(arguments.length <= 11 ? undefined : arguments[11], "px rgba(0,0,0,").concat(shadowAmbientShadowOpacity, ")")].join(',');
	} // Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
	
	
	var shadows = ['none', createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)];
	var _default = shadows;
	exports.default = _default;

/***/ },
/* 778 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var shape = {
	  borderRadius: 4
	};
	var _default = shape;
	exports.default = _default;

/***/ },
/* 779 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _styles = __webpack_require__(80);
	
	var _defaultTheme = _interopRequireDefault(__webpack_require__(142));
	
	var styled = function styled(Component) {
	  var componentCreator = (0, _styles.styled)(Component);
	  return function (style, options) {
	    return componentCreator(style, (0, _extends2.default)({
	      defaultTheme: _defaultTheme.default
	    }, options));
	  };
	};
	
	var _default = styled;
	exports.default = _default;

/***/ },
/* 780 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _styles = __webpack_require__(80);
	
	var _defaultTheme = _interopRequireDefault(__webpack_require__(142));
	
	var withTheme = (0, _styles.withThemeCreator)({
	  defaultTheme: _defaultTheme.default
	});
	var _default = withTheme;
	exports.default = _default;

/***/ },
/* 781 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getTransitionProps = getTransitionProps;
	exports.reflow = void 0;
	
	var reflow = function reflow(node) {
	  return node.scrollTop;
	};
	
	exports.reflow = reflow;
	
	function getTransitionProps(props, options) {
	  var timeout = props.timeout,
	      _props$style = props.style,
	      style = _props$style === void 0 ? {} : _props$style;
	  return {
	    duration: style.transitionDuration || typeof timeout === 'number' ? timeout : timeout[options.mode] || 0,
	    delay: style.transitionDelay
	  };
	}

/***/ },
/* 782 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = requirePropFactory;
	
	function requirePropFactory(componentNameInError) {
	  if (true) {
	    return function () {
	      return null;
	    };
	  }
	
	  var requireProp = function requireProp(requiredProp) {
	    return function (props, propName, componentName, location, propFullName) {
	      var propFullNameSafe = propFullName || propName;
	
	      if (typeof props[propName] !== 'undefined' && !props[requiredProp]) {
	        return new Error("The prop `".concat(propFullNameSafe, "` of ") + "`".concat(componentNameInError, "` must be used on `").concat(requiredProp, "`."));
	      }
	
	      return null;
	    };
	  };
	
	  return requireProp;
	}

/***/ },
/* 783 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = useId;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	/**
	 * Private module reserved for @material-ui/x packages.
	 */
	function useId(idOverride) {
	  var _React$useState = React.useState(idOverride),
	      defaultId = _React$useState[0],
	      setDefaultId = _React$useState[1];
	
	  var id = idOverride || defaultId;
	  React.useEffect(function () {
	    if (defaultId == null) {
	      // Fallback to this default id when possible.
	      // Use the random value for client-side rendering only.
	      // We can't use it server-side.
	      setDefaultId("mui-".concat(Math.round(Math.random() * 1e5)));
	    }
	  }, [defaultId]);
	  return id;
	}

/***/ },
/* 784 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "createFilterOptions", {
	  enumerable: true,
	  get: function get() {
	    return _useAutocomplete2.createFilterOptions;
	  }
	});
	exports.default = exports.styles = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(25));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(24));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(37));
	
	var _styles = __webpack_require__(774);
	
	var _Popper = _interopRequireDefault(__webpack_require__(745));
	
	var _ListSubheader = _interopRequireDefault(__webpack_require__(731));
	
	var _Paper = _interopRequireDefault(__webpack_require__(324));
	
	var _IconButton = _interopRequireDefault(__webpack_require__(722));
	
	var _Chip = _interopRequireDefault(__webpack_require__(711));
	
	var _Close = _interopRequireDefault(__webpack_require__(786));
	
	var _ArrowDropDown = _interopRequireDefault(__webpack_require__(785));
	
	var _useAutocomplete2 = _interopRequireWildcard(__webpack_require__(787));
	
	var styles = function styles(theme) {
	  var _option;
	
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      '&$focused $clearIndicatorDirty': {
	        visibility: 'visible'
	      },
	
	      /* Avoid double tap issue on iOS */
	      '@media (pointer: fine)': {
	        '&:hover $clearIndicatorDirty': {
	          visibility: 'visible'
	        }
	      }
	    },
	
	    /* Styles applied to the root element if `fullWidth={true}`. */
	    fullWidth: {
	      width: '100%'
	    },
	
	    /* Pseudo-class applied to the root element if focused. */
	    focused: {},
	
	    /* Styles applied to the tag elements, e.g. the chips. */
	    tag: {
	      margin: 3,
	      maxWidth: 'calc(100% - 6px)'
	    },
	
	    /* Styles applied to the tag elements, e.g. the chips if `size="small"`. */
	    tagSizeSmall: {
	      margin: 2,
	      maxWidth: 'calc(100% - 4px)'
	    },
	
	    /* Styles applied when the popup icon is rendered. */
	    hasPopupIcon: {},
	
	    /* Styles applied when the clear icon is rendered. */
	    hasClearIcon: {},
	
	    /* Styles applied to the Input element. */
	    inputRoot: {
	      flexWrap: 'wrap',
	      '$hasPopupIcon &, $hasClearIcon &': {
	        paddingRight: 26 + 4
	      },
	      '$hasPopupIcon$hasClearIcon &': {
	        paddingRight: 52 + 4
	      },
	      '& $input': {
	        width: 0,
	        minWidth: 30
	      },
	      '&[class*="MuiInput-root"]': {
	        paddingBottom: 1,
	        '& $input': {
	          padding: 4
	        },
	        '& $input:first-child': {
	          padding: '6px 0'
	        }
	      },
	      '&[class*="MuiInput-root"][class*="MuiInput-marginDense"]': {
	        '& $input': {
	          padding: '4px 4px 5px'
	        },
	        '& $input:first-child': {
	          padding: '3px 0 6px'
	        }
	      },
	      '&[class*="MuiOutlinedInput-root"]': {
	        padding: 9,
	        '$hasPopupIcon &, $hasClearIcon &': {
	          paddingRight: 26 + 4 + 9
	        },
	        '$hasPopupIcon$hasClearIcon &': {
	          paddingRight: 52 + 4 + 9
	        },
	        '& $input': {
	          padding: '9.5px 4px'
	        },
	        '& $input:first-child': {
	          paddingLeft: 6
	        },
	        '& $endAdornment': {
	          right: 9
	        }
	      },
	      '&[class*="MuiOutlinedInput-root"][class*="MuiOutlinedInput-marginDense"]': {
	        padding: 6,
	        '& $input': {
	          padding: '4.5px 4px'
	        }
	      },
	      '&[class*="MuiFilledInput-root"]': {
	        paddingTop: 19,
	        paddingLeft: 8,
	        '$hasPopupIcon &, $hasClearIcon &': {
	          paddingRight: 26 + 4 + 9
	        },
	        '$hasPopupIcon$hasClearIcon &': {
	          paddingRight: 52 + 4 + 9
	        },
	        '& $input': {
	          padding: '9px 4px'
	        },
	        '& $endAdornment': {
	          right: 9
	        }
	      },
	      '&[class*="MuiFilledInput-root"][class*="MuiFilledInput-marginDense"]': {
	        paddingBottom: 1,
	        '& $input': {
	          padding: '4.5px 4px'
	        }
	      }
	    },
	
	    /* Styles applied to the input element. */
	    input: {
	      flexGrow: 1,
	      textOverflow: 'ellipsis',
	      opacity: 0
	    },
	
	    /* Styles applied to the input element if tag focused. */
	    inputFocused: {
	      opacity: 1
	    },
	
	    /* Styles applied to the endAdornment element. */
	    endAdornment: {
	      // We use a position absolute to support wrapping tags.
	      position: 'absolute',
	      right: 0,
	      top: 'calc(50% - 14px)' // Center vertically
	
	    },
	
	    /* Styles applied to the clear indicator. */
	    clearIndicator: {
	      marginRight: -2,
	      padding: 4,
	      visibility: 'hidden'
	    },
	
	    /* Styles applied to the clear indicator if the input is dirty. */
	    clearIndicatorDirty: {},
	
	    /* Styles applied to the popup indicator. */
	    popupIndicator: {
	      padding: 2,
	      marginRight: -2
	    },
	
	    /* Styles applied to the popup indicator if the popup is open. */
	    popupIndicatorOpen: {
	      transform: 'rotate(180deg)'
	    },
	
	    /* Styles applied to the popper element. */
	    popper: {
	      zIndex: theme.zIndex.modal
	    },
	
	    /* Styles applied to the popper element if `disablePortal={true}`. */
	    popperDisablePortal: {
	      position: 'absolute'
	    },
	
	    /* Styles applied to the `Paper` component. */
	    paper: (0, _extends2.default)({}, theme.typography.body1, {
	      overflow: 'hidden',
	      margin: '4px 0'
	    }),
	
	    /* Styles applied to the `listbox` component. */
	    listbox: {
	      listStyle: 'none',
	      margin: 0,
	      padding: '8px 0',
	      maxHeight: '40vh',
	      overflow: 'auto'
	    },
	
	    /* Styles applied to the loading wrapper. */
	    loading: {
	      color: theme.palette.text.secondary,
	      padding: '14px 16px'
	    },
	
	    /* Styles applied to the no option wrapper. */
	    noOptions: {
	      color: theme.palette.text.secondary,
	      padding: '14px 16px'
	    },
	
	    /* Styles applied to the option elements. */
	    option: (_option = {
	      minHeight: 48,
	      display: 'flex',
	      justifyContent: 'flex-start',
	      alignItems: 'center',
	      cursor: 'pointer',
	      paddingTop: 6,
	      boxSizing: 'border-box',
	      outline: '0',
	      WebkitTapHighlightColor: 'transparent',
	      paddingBottom: 6,
	      paddingLeft: 16,
	      paddingRight: 16
	    }, (0, _defineProperty2.default)(_option, theme.breakpoints.up('sm'), {
	      minHeight: 'auto'
	    }), (0, _defineProperty2.default)(_option, '&[aria-selected="true"]', {
	      backgroundColor: theme.palette.action.selected
	    }), (0, _defineProperty2.default)(_option, '&[data-focus="true"]', {
	      backgroundColor: theme.palette.action.hover
	    }), (0, _defineProperty2.default)(_option, '&:active', {
	      backgroundColor: theme.palette.action.selected
	    }), (0, _defineProperty2.default)(_option, '&[aria-disabled="true"]', {
	      opacity: theme.palette.action.disabledOpacity,
	      pointerEvents: 'none'
	    }), _option),
	
	    /* Styles applied to the group's label elements. */
	    groupLabel: {
	      backgroundColor: theme.palette.background.paper,
	      top: -8
	    },
	
	    /* Styles applied to the group's ul elements. */
	    groupUl: {
	      padding: 0,
	      '& $option': {
	        paddingLeft: 24
	      }
	    }
	  };
	};
	
	exports.styles = styles;
	
	function DisablePortal(props) {
	  // eslint-disable-next-line react/prop-types
	  var anchorEl = props.anchorEl,
	      open = props.open,
	      other = (0, _objectWithoutProperties2.default)(props, ["anchorEl", "open"]);
	  return /*#__PURE__*/React.createElement("div", other);
	}
	
	var _ref = /*#__PURE__*/React.createElement(_Close.default, {
	  fontSize: "small"
	});
	
	var _ref2 = /*#__PURE__*/React.createElement(_ArrowDropDown.default, null);
	
	var Autocomplete = /*#__PURE__*/React.forwardRef(function Autocomplete(props, ref) {
	  /* eslint-disable no-unused-vars */
	  var _props$autoComplete = props.autoComplete,
	      autoComplete = _props$autoComplete === void 0 ? false : _props$autoComplete,
	      _props$autoHighlight = props.autoHighlight,
	      autoHighlight = _props$autoHighlight === void 0 ? false : _props$autoHighlight,
	      _props$autoSelect = props.autoSelect,
	      autoSelect = _props$autoSelect === void 0 ? false : _props$autoSelect,
	      _props$blurOnSelect = props.blurOnSelect,
	      blurOnSelect = _props$blurOnSelect === void 0 ? false : _props$blurOnSelect,
	      ChipProps = props.ChipProps,
	      classes = props.classes,
	      className = props.className,
	      _props$clearOnBlur = props.clearOnBlur,
	      clearOnBlur = _props$clearOnBlur === void 0 ? !props.freeSolo : _props$clearOnBlur,
	      _props$clearOnEscape = props.clearOnEscape,
	      clearOnEscape = _props$clearOnEscape === void 0 ? false : _props$clearOnEscape,
	      _props$clearText = props.clearText,
	      clearText = _props$clearText === void 0 ? 'Clear' : _props$clearText,
	      _props$closeIcon = props.closeIcon,
	      closeIcon = _props$closeIcon === void 0 ? _ref : _props$closeIcon,
	      _props$closeText = props.closeText,
	      closeText = _props$closeText === void 0 ? 'Close' : _props$closeText,
	      _props$debug = props.debug,
	      debug = _props$debug === void 0 ? false : _props$debug,
	      _props$defaultValue = props.defaultValue,
	      defaultValue = _props$defaultValue === void 0 ? props.multiple ? [] : null : _props$defaultValue,
	      _props$disableClearab = props.disableClearable,
	      disableClearable = _props$disableClearab === void 0 ? false : _props$disableClearab,
	      _props$disableCloseOn = props.disableCloseOnSelect,
	      disableCloseOnSelect = _props$disableCloseOn === void 0 ? false : _props$disableCloseOn,
	      _props$disabled = props.disabled,
	      disabled = _props$disabled === void 0 ? false : _props$disabled,
	      _props$disabledItemsF = props.disabledItemsFocusable,
	      disabledItemsFocusable = _props$disabledItemsF === void 0 ? false : _props$disabledItemsF,
	      _props$disableListWra = props.disableListWrap,
	      disableListWrap = _props$disableListWra === void 0 ? false : _props$disableListWra,
	      _props$disablePortal = props.disablePortal,
	      disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal,
	      filterOptions = props.filterOptions,
	      _props$filterSelected = props.filterSelectedOptions,
	      filterSelectedOptions = _props$filterSelected === void 0 ? false : _props$filterSelected,
	      _props$forcePopupIcon = props.forcePopupIcon,
	      forcePopupIcon = _props$forcePopupIcon === void 0 ? 'auto' : _props$forcePopupIcon,
	      _props$freeSolo = props.freeSolo,
	      freeSolo = _props$freeSolo === void 0 ? false : _props$freeSolo,
	      _props$fullWidth = props.fullWidth,
	      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
	      _props$getLimitTagsTe = props.getLimitTagsText,
	      getLimitTagsText = _props$getLimitTagsTe === void 0 ? function (more) {
	    return "+".concat(more);
	  } : _props$getLimitTagsTe,
	      getOptionDisabled = props.getOptionDisabled,
	      _props$getOptionLabel = props.getOptionLabel,
	      getOptionLabel = _props$getOptionLabel === void 0 ? function (x) {
	    return x;
	  } : _props$getOptionLabel,
	      getOptionSelected = props.getOptionSelected,
	      groupBy = props.groupBy,
	      _props$handleHomeEndK = props.handleHomeEndKeys,
	      handleHomeEndKeys = _props$handleHomeEndK === void 0 ? !props.freeSolo : _props$handleHomeEndK,
	      idProp = props.id,
	      _props$includeInputIn = props.includeInputInList,
	      includeInputInList = _props$includeInputIn === void 0 ? false : _props$includeInputIn,
	      inputValueProp = props.inputValue,
	      _props$limitTags = props.limitTags,
	      limitTags = _props$limitTags === void 0 ? -1 : _props$limitTags,
	      _props$ListboxCompone = props.ListboxComponent,
	      ListboxComponent = _props$ListboxCompone === void 0 ? 'ul' : _props$ListboxCompone,
	      ListboxProps = props.ListboxProps,
	      _props$loading = props.loading,
	      loading = _props$loading === void 0 ? false : _props$loading,
	      _props$loadingText = props.loadingText,
	      loadingText = _props$loadingText === void 0 ? 'Loading…' : _props$loadingText,
	      _props$multiple = props.multiple,
	      multiple = _props$multiple === void 0 ? false : _props$multiple,
	      _props$noOptionsText = props.noOptionsText,
	      noOptionsText = _props$noOptionsText === void 0 ? 'No options' : _props$noOptionsText,
	      onChange = props.onChange,
	      onClose = props.onClose,
	      onHighlightChange = props.onHighlightChange,
	      onInputChange = props.onInputChange,
	      onOpen = props.onOpen,
	      open = props.open,
	      _props$openOnFocus = props.openOnFocus,
	      openOnFocus = _props$openOnFocus === void 0 ? false : _props$openOnFocus,
	      _props$openText = props.openText,
	      openText = _props$openText === void 0 ? 'Open' : _props$openText,
	      options = props.options,
	      _props$PaperComponent = props.PaperComponent,
	      PaperComponent = _props$PaperComponent === void 0 ? _Paper.default : _props$PaperComponent,
	      _props$PopperComponen = props.PopperComponent,
	      PopperComponentProp = _props$PopperComponen === void 0 ? _Popper.default : _props$PopperComponen,
	      _props$popupIcon = props.popupIcon,
	      popupIcon = _props$popupIcon === void 0 ? _ref2 : _props$popupIcon,
	      renderGroupProp = props.renderGroup,
	      renderInput = props.renderInput,
	      renderOptionProp = props.renderOption,
	      renderTags = props.renderTags,
	      _props$selectOnFocus = props.selectOnFocus,
	      selectOnFocus = _props$selectOnFocus === void 0 ? !props.freeSolo : _props$selectOnFocus,
	      _props$size = props.size,
	      size = _props$size === void 0 ? 'medium' : _props$size,
	      valueProp = props.value,
	      other = (0, _objectWithoutProperties2.default)(props, ["autoComplete", "autoHighlight", "autoSelect", "blurOnSelect", "ChipProps", "classes", "className", "clearOnBlur", "clearOnEscape", "clearText", "closeIcon", "closeText", "debug", "defaultValue", "disableClearable", "disableCloseOnSelect", "disabled", "disabledItemsFocusable", "disableListWrap", "disablePortal", "filterOptions", "filterSelectedOptions", "forcePopupIcon", "freeSolo", "fullWidth", "getLimitTagsText", "getOptionDisabled", "getOptionLabel", "getOptionSelected", "groupBy", "handleHomeEndKeys", "id", "includeInputInList", "inputValue", "limitTags", "ListboxComponent", "ListboxProps", "loading", "loadingText", "multiple", "noOptionsText", "onChange", "onClose", "onHighlightChange", "onInputChange", "onOpen", "open", "openOnFocus", "openText", "options", "PaperComponent", "PopperComponent", "popupIcon", "renderGroup", "renderInput", "renderOption", "renderTags", "selectOnFocus", "size", "value"]);
	  /* eslint-enable no-unused-vars */
	
	  var PopperComponent = disablePortal ? DisablePortal : PopperComponentProp;
	
	  var _useAutocomplete = (0, _useAutocomplete2.default)((0, _extends2.default)({}, props, {
	    componentName: 'Autocomplete'
	  })),
	      getRootProps = _useAutocomplete.getRootProps,
	      getInputProps = _useAutocomplete.getInputProps,
	      getInputLabelProps = _useAutocomplete.getInputLabelProps,
	      getPopupIndicatorProps = _useAutocomplete.getPopupIndicatorProps,
	      getClearProps = _useAutocomplete.getClearProps,
	      getTagProps = _useAutocomplete.getTagProps,
	      getListboxProps = _useAutocomplete.getListboxProps,
	      getOptionProps = _useAutocomplete.getOptionProps,
	      value = _useAutocomplete.value,
	      dirty = _useAutocomplete.dirty,
	      id = _useAutocomplete.id,
	      popupOpen = _useAutocomplete.popupOpen,
	      focused = _useAutocomplete.focused,
	      focusedTag = _useAutocomplete.focusedTag,
	      anchorEl = _useAutocomplete.anchorEl,
	      setAnchorEl = _useAutocomplete.setAnchorEl,
	      inputValue = _useAutocomplete.inputValue,
	      groupedOptions = _useAutocomplete.groupedOptions;
	
	  var startAdornment;
	
	  if (multiple && value.length > 0) {
	    var getCustomizedTagProps = function getCustomizedTagProps(params) {
	      return (0, _extends2.default)({
	        className: (0, _clsx.default)(classes.tag, size === 'small' && classes.tagSizeSmall),
	        disabled: disabled
	      }, getTagProps(params));
	    };
	
	    if (renderTags) {
	      startAdornment = renderTags(value, getCustomizedTagProps);
	    } else {
	      startAdornment = value.map(function (option, index) {
	        return /*#__PURE__*/React.createElement(_Chip.default, (0, _extends2.default)({
	          label: getOptionLabel(option),
	          size: size
	        }, getCustomizedTagProps({
	          index: index
	        }), ChipProps));
	      });
	    }
	  }
	
	  if (limitTags > -1 && Array.isArray(startAdornment)) {
	    var more = startAdornment.length - limitTags;
	
	    if (!focused && more > 0) {
	      startAdornment = startAdornment.splice(0, limitTags);
	      startAdornment.push( /*#__PURE__*/React.createElement("span", {
	        className: classes.tag,
	        key: startAdornment.length
	      }, getLimitTagsText(more)));
	    }
	  }
	
	  var defaultRenderGroup = function defaultRenderGroup(params) {
	    return /*#__PURE__*/React.createElement("li", {
	      key: params.key
	    }, /*#__PURE__*/React.createElement(_ListSubheader.default, {
	      className: classes.groupLabel,
	      component: "div"
	    }, params.group), /*#__PURE__*/React.createElement("ul", {
	      className: classes.groupUl
	    }, params.children));
	  };
	
	  var renderGroup = renderGroupProp || defaultRenderGroup;
	  var renderOption = renderOptionProp || getOptionLabel;
	
	  var renderListOption = function renderListOption(option, index) {
	    var optionProps = getOptionProps({
	      option: option,
	      index: index
	    });
	    return /*#__PURE__*/React.createElement("li", (0, _extends2.default)({}, optionProps, {
	      className: classes.option
	    }), renderOption(option, {
	      selected: optionProps['aria-selected'],
	      inputValue: inputValue
	    }));
	  };
	
	  var hasClearIcon = !disableClearable && !disabled;
	  var hasPopupIcon = (!freeSolo || forcePopupIcon === true) && forcePopupIcon !== false;
	  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    ref: ref,
	    className: (0, _clsx.default)(classes.root, className, focused && classes.focused, fullWidth && classes.fullWidth, hasClearIcon && classes.hasClearIcon, hasPopupIcon && classes.hasPopupIcon)
	  }, getRootProps(other)), renderInput({
	    id: id,
	    disabled: disabled,
	    fullWidth: true,
	    size: size === 'small' ? 'small' : undefined,
	    InputLabelProps: getInputLabelProps(),
	    InputProps: {
	      ref: setAnchorEl,
	      className: classes.inputRoot,
	      startAdornment: startAdornment,
	      endAdornment: /*#__PURE__*/React.createElement("div", {
	        className: classes.endAdornment
	      }, hasClearIcon ? /*#__PURE__*/React.createElement(_IconButton.default, (0, _extends2.default)({}, getClearProps(), {
	        "aria-label": clearText,
	        title: clearText,
	        className: (0, _clsx.default)(classes.clearIndicator, dirty && classes.clearIndicatorDirty)
	      }), closeIcon) : null, hasPopupIcon ? /*#__PURE__*/React.createElement(_IconButton.default, (0, _extends2.default)({}, getPopupIndicatorProps(), {
	        disabled: disabled,
	        "aria-label": popupOpen ? closeText : openText,
	        title: popupOpen ? closeText : openText,
	        className: (0, _clsx.default)(classes.popupIndicator, popupOpen && classes.popupIndicatorOpen)
	      }), popupIcon) : null)
	    },
	    inputProps: (0, _extends2.default)({
	      className: (0, _clsx.default)(classes.input, focusedTag === -1 && classes.inputFocused),
	      disabled: disabled
	    }, getInputProps())
	  })), popupOpen && anchorEl ? /*#__PURE__*/React.createElement(PopperComponent, {
	    className: (0, _clsx.default)(classes.popper, disablePortal && classes.popperDisablePortal),
	    style: {
	      width: anchorEl ? anchorEl.clientWidth : null
	    },
	    role: "presentation",
	    anchorEl: anchorEl,
	    open: true
	  }, /*#__PURE__*/React.createElement(PaperComponent, {
	    className: classes.paper
	  }, loading && groupedOptions.length === 0 ? /*#__PURE__*/React.createElement("div", {
	    className: classes.loading
	  }, loadingText) : null, groupedOptions.length === 0 && !freeSolo && !loading ? /*#__PURE__*/React.createElement("div", {
	    className: classes.noOptions
	  }, noOptionsText) : null, groupedOptions.length > 0 ? /*#__PURE__*/React.createElement(ListboxComponent, (0, _extends2.default)({
	    className: classes.listbox
	  }, getListboxProps(), ListboxProps), groupedOptions.map(function (option, index) {
	    if (groupBy) {
	      return renderGroup({
	        key: option.key,
	        group: option.group,
	        children: option.options.map(function (option2, index2) {
	          return renderListOption(option2, option.index + index2);
	        })
	      });
	    }
	
	    return renderListOption(option, index);
	  })) : null)) : null);
	});
	 false ? Autocomplete.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * If `true`, the portion of the selected suggestion that has not been typed by the user,
	   * known as the completion string, appears inline after the input cursor in the textbox.
	   * The inline completion string is visually highlighted and has a selected state.
	   */
	  autoComplete: _propTypes.default.bool,
	
	  /**
	   * If `true`, the first option is automatically highlighted.
	   */
	  autoHighlight: _propTypes.default.bool,
	
	  /**
	   * If `true`, the selected option becomes the value of the input
	   * when the Autocomplete loses focus unless the user chooses
	   * a different option or changes the character string in the input.
	   */
	  autoSelect: _propTypes.default.bool,
	
	  /**
	   * Control if the input should be blurred when an option is selected:
	   *
	   * - `false` the input is not blurred.
	   * - `true` the input is always blurred.
	   * - `touch` the input is blurred after a touch event.
	   * - `mouse` the input is blurred after a mouse event.
	   */
	  blurOnSelect: _propTypes.default.oneOfType([_propTypes.default.oneOf(['mouse', 'touch']), _propTypes.default.bool]),
	
	  /**
	   * Props applied to the [`Chip`](/api/chip/) element.
	   */
	  ChipProps: _propTypes.default.object,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, the input's text will be cleared on blur if no value is selected.
	   *
	   * Set to `true` if you want to help the user enter a new value.
	   * Set to `false` if you want to help the user resume his search.
	   */
	  clearOnBlur: _propTypes.default.bool,
	
	  /**
	   * If `true`, clear all values when the user presses escape and the popup is closed.
	   */
	  clearOnEscape: _propTypes.default.bool,
	
	  /**
	   * Override the default text for the *clear* icon button.
	   *
	   * For localization purposes, you can use the provided [translations](/guides/localization/).
	   */
	  clearText: _propTypes.default.string,
	
	  /**
	   * The icon to display in place of the default close icon.
	   */
	  closeIcon: _propTypes.default.node,
	
	  /**
	   * Override the default text for the *close popup* icon button.
	   *
	   * For localization purposes, you can use the provided [translations](/guides/localization/).
	   */
	  closeText: _propTypes.default.string,
	
	  /**
	   * If `true`, the popup will ignore the blur event if the input is filled.
	   * You can inspect the popup markup with your browser tools.
	   * Consider this option when you need to customize the component.
	   */
	  debug: _propTypes.default.bool,
	
	  /**
	   * The default input value. Use when the component is not controlled.
	   */
	  defaultValue: _propTypes.default.any,
	
	  /**
	   * If `true`, the input can't be cleared.
	   */
	  disableClearable: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .bool,
	
	  /**
	   * If `true`, the popup won't close when a value is selected.
	   */
	  disableCloseOnSelect: _propTypes.default.bool,
	
	  /**
	   * If `true`, the input will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, will allow focus on disabled items.
	   */
	  disabledItemsFocusable: _propTypes.default.bool,
	
	  /**
	   * If `true`, the list box in the popup will not wrap focus.
	   */
	  disableListWrap: _propTypes.default.bool,
	
	  /**
	   * Disable the portal behavior.
	   * The children stay within it's parent DOM hierarchy.
	   */
	  disablePortal: _propTypes.default.bool,
	
	  /**
	   * A filter function that determines the options that are eligible.
	   *
	   * @param {T[]} options The options to render.
	   * @param {object} state The state of the component.
	   * @returns {T[]}
	   */
	  filterOptions: _propTypes.default.func,
	
	  /**
	   * If `true`, hide the selected options from the list box.
	   */
	  filterSelectedOptions: _propTypes.default.bool,
	
	  /**
	   * Force the visibility display of the popup icon.
	   */
	  forcePopupIcon: _propTypes.default.oneOfType([_propTypes.default.oneOf(['auto']), _propTypes.default.bool]),
	
	  /**
	   * If `true`, the Autocomplete is free solo, meaning that the user input is not bound to provided options.
	   */
	  freeSolo: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .bool,
	
	  /**
	   * If `true`, the input will take up the full width of its container.
	   */
	  fullWidth: _propTypes.default.bool,
	
	  /**
	   * The label to display when the tags are truncated (`limitTags`).
	   *
	   * @param {number} more The number of truncated tags.
	   * @returns {ReactNode}
	   */
	  getLimitTagsText: _propTypes.default.func,
	
	  /**
	   * Used to determine the disabled state for a given option.
	   *
	   * @param {T} option The option to test.
	   * @returns {boolean}
	   */
	  getOptionDisabled: _propTypes.default.func,
	
	  /**
	   * Used to determine the string value for a given option.
	   * It's used to fill the input (and the list box options if `renderOption` is not provided).
	   *
	   * @param {T} option
	   * @returns {string}
	   */
	  getOptionLabel: _propTypes.default.func,
	
	  /**
	   * Used to determine if an option is selected, considering the current value.
	   * Uses strict equality by default.
	   *
	   * @param {T} option The option to test.
	   * @param {T} value The value to test against.
	   * @returns {boolean}
	   */
	  getOptionSelected: _propTypes.default.func,
	
	  /**
	   * If provided, the options will be grouped under the returned string.
	   * The groupBy value is also used as the text for group headings when `renderGroup` is not provided.
	   *
	   * @param {T} options The options to group.
	   * @returns {string}
	   */
	  groupBy: _propTypes.default.func,
	
	  /**
	   * If `true`, the component handles the "Home" and "End" keys when the popup is open.
	   * It should move focus to the first option and last option, respectively.
	   */
	  handleHomeEndKeys: _propTypes.default.bool,
	
	  /**
	   * This prop is used to help implement the accessibility logic.
	   * If you don't provide this prop. It falls back to a randomly generated id.
	   */
	  id: _propTypes.default.string,
	
	  /**
	   * If `true`, the highlight can move to the input.
	   */
	  includeInputInList: _propTypes.default.bool,
	
	  /**
	   * The input value.
	   */
	  inputValue: _propTypes.default.string,
	
	  /**
	   * The maximum number of tags that will be visible when not focused.
	   * Set `-1` to disable the limit.
	   */
	  limitTags: _propTypes.default.number,
	
	  /**
	   * The component used to render the listbox.
	   */
	  ListboxComponent: _propTypes.default.elementType,
	
	  /**
	   * Props applied to the Listbox element.
	   */
	  ListboxProps: _propTypes.default.object,
	
	  /**
	   * If `true`, the component is in a loading state.
	   */
	  loading: _propTypes.default.bool,
	
	  /**
	   * Text to display when in a loading state.
	   *
	   * For localization purposes, you can use the provided [translations](/guides/localization/).
	   */
	  loadingText: _propTypes.default.node,
	
	  /**
	   * If `true`, `value` must be an array and the menu will support multiple selections.
	   */
	  multiple: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .bool,
	
	  /**
	   * Text to display when there are no options.
	   *
	   * For localization purposes, you can use the provided [translations](/guides/localization/).
	   */
	  noOptionsText: _propTypes.default.node,
	
	  /**
	   * Callback fired when the value changes.
	   *
	   * @param {object} event The event source of the callback.
	   * @param {T|T[]} value The new value of the component.
	   * @param {string} reason One of "create-option", "select-option", "remove-option", "blur" or "clear".
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * Callback fired when the popup requests to be closed.
	   * Use in controlled mode (see open).
	   *
	   * @param {object} event The event source of the callback.
	   * @param {string} reason Can be: `"toggleInput"`, `"escape"`, `"select-option"`, `"blur"`.
	   */
	  onClose: _propTypes.default.func,
	
	  /**
	   * Callback fired when the highlight option changes.
	   *
	   * @param {object} event The event source of the callback.
	   * @param {T} option The highlighted option.
	   * @param {string} reason Can be: `"keyboard"`, `"auto"`, `"mouse"`.
	   */
	  onHighlightChange: _propTypes.default.func,
	
	  /**
	   * Callback fired when the input value changes.
	   *
	   * @param {object} event The event source of the callback.
	   * @param {string} value The new value of the text input.
	   * @param {string} reason Can be: `"input"` (user input), `"reset"` (programmatic change), `"clear"`.
	   */
	  onInputChange: _propTypes.default.func,
	
	  /**
	   * Callback fired when the popup requests to be opened.
	   * Use in controlled mode (see open).
	   *
	   * @param {object} event The event source of the callback.
	   */
	  onOpen: _propTypes.default.func,
	
	  /**
	   * Control the popup` open state.
	   */
	  open: _propTypes.default.bool,
	
	  /**
	   * If `true`, the popup will open on input focus.
	   */
	  openOnFocus: _propTypes.default.bool,
	
	  /**
	   * Override the default text for the *open popup* icon button.
	   *
	   * For localization purposes, you can use the provided [translations](/guides/localization/).
	   */
	  openText: _propTypes.default.string,
	
	  /**
	   * Array of options.
	   */
	  options: _propTypes.default.array.isRequired,
	
	  /**
	   * The component used to render the body of the popup.
	   */
	  PaperComponent: _propTypes.default.elementType,
	
	  /**
	   * The component used to position the popup.
	   */
	  PopperComponent: _propTypes.default.elementType,
	
	  /**
	   * The icon to display in place of the default popup icon.
	   */
	  popupIcon: _propTypes.default.node,
	
	  /**
	   * Render the group.
	   *
	   * @param {any} option The group to render.
	   * @returns {ReactNode}
	   */
	  renderGroup: _propTypes.default.func,
	
	  /**
	   * Render the input.
	   *
	   * @param {object} params
	   * @returns {ReactNode}
	   */
	  renderInput: _propTypes.default.func.isRequired,
	
	  /**
	   * Render the option, use `getOptionLabel` by default.
	   *
	   * @param {T} option The option to render.
	   * @param {object} state The state of the component.
	   * @returns {ReactNode}
	   */
	  renderOption: _propTypes.default.func,
	
	  /**
	   * Render the selected value.
	   *
	   * @param {T[]} value The `value` provided to the component.
	   * @param {function} getTagProps A tag props getter.
	   * @returns {ReactNode}
	   */
	  renderTags: _propTypes.default.func,
	
	  /**
	   * If `true`, the input's text will be selected on focus.
	   * It helps the user clear the selected value.
	   */
	  selectOnFocus: _propTypes.default.bool,
	
	  /**
	   * The size of the autocomplete.
	   */
	  size: _propTypes.default.oneOf(['medium', 'small']),
	
	  /**
	   * The value of the autocomplete.
	   *
	   * The value must have reference equality with the option in order to be selected.
	   * You can customize the equality behavior with the `getOptionSelected` prop.
	   */
	  value: _propTypes.default.any
	} : void 0;
	
	var _default = (0, _styles.withStyles)(styles, {
	  name: 'MuiAutocomplete'
	})(Autocomplete);
	
	exports.default = _default;

/***/ },
/* 785 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _utils = __webpack_require__(237);
	
	/**
	 * @ignore - internal component.
	 */
	var _default = (0, _utils.createSvgIcon)( /*#__PURE__*/React.createElement("path", {
	  d: "M7 10l5 5 5-5z"
	}), 'ArrowDropDown');
	
	exports.default = _default;

/***/ },
/* 786 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _utils = __webpack_require__(237);
	
	/**
	 * @ignore - internal component.
	 */
	var _default = (0, _utils.createSvgIcon)( /*#__PURE__*/React.createElement("path", {
	  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
	}), 'Close');
	
	exports.default = _default;

/***/ },
/* 787 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _useAutocomplete.default;
	  }
	});
	Object.defineProperty(exports, "createFilterOptions", {
	  enumerable: true,
	  get: function get() {
	    return _useAutocomplete.createFilterOptions;
	  }
	});
	
	var _useAutocomplete = _interopRequireWildcard(__webpack_require__(788));

/***/ },
/* 788 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createFilterOptions = createFilterOptions;
	exports.default = useAutocomplete;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(175));
	
	var _typeof2 = _interopRequireDefault(__webpack_require__(56));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _utils = __webpack_require__(237);
	
	/* eslint-disable no-constant-condition */
	// https://stackoverflow.com/questions/990904/remove-accents-diacritics-in-a-string-in-javascript
	// Give up on IE 11 support for this feature
	function stripDiacritics(string) {
	  return typeof string.normalize !== 'undefined' ? string.normalize('NFD').replace(/[\u0300-\u036f]/g, '') : string;
	}
	
	function createFilterOptions() {
	  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var _config$ignoreAccents = config.ignoreAccents,
	      ignoreAccents = _config$ignoreAccents === void 0 ? true : _config$ignoreAccents,
	      _config$ignoreCase = config.ignoreCase,
	      ignoreCase = _config$ignoreCase === void 0 ? true : _config$ignoreCase,
	      limit = config.limit,
	      _config$matchFrom = config.matchFrom,
	      matchFrom = _config$matchFrom === void 0 ? 'any' : _config$matchFrom,
	      stringify = config.stringify,
	      _config$trim = config.trim,
	      trim = _config$trim === void 0 ? false : _config$trim;
	  return function (options, _ref) {
	    var inputValue = _ref.inputValue,
	        getOptionLabel = _ref.getOptionLabel;
	    var input = trim ? inputValue.trim() : inputValue;
	
	    if (ignoreCase) {
	      input = input.toLowerCase();
	    }
	
	    if (ignoreAccents) {
	      input = stripDiacritics(input);
	    }
	
	    var filteredOptions = options.filter(function (option) {
	      var candidate = (stringify || getOptionLabel)(option);
	
	      if (ignoreCase) {
	        candidate = candidate.toLowerCase();
	      }
	
	      if (ignoreAccents) {
	        candidate = stripDiacritics(candidate);
	      }
	
	      return matchFrom === 'start' ? candidate.indexOf(input) === 0 : candidate.indexOf(input) > -1;
	    });
	    return typeof limit === 'number' ? filteredOptions.slice(0, limit) : filteredOptions;
	  };
	} // To replace with .findIndex() once we stop IE 11 support.
	
	
	function findIndex(array, comp) {
	  for (var i = 0; i < array.length; i += 1) {
	    if (comp(array[i])) {
	      return i;
	    }
	  }
	
	  return -1;
	}
	
	var defaultFilterOptions = createFilterOptions(); // Number of options to jump in list box when pageup and pagedown keys are used.
	
	var pageSize = 5;
	
	function useAutocomplete(props) {
	  var _props$autoComplete = props.autoComplete,
	      autoComplete = _props$autoComplete === void 0 ? false : _props$autoComplete,
	      _props$autoHighlight = props.autoHighlight,
	      autoHighlight = _props$autoHighlight === void 0 ? false : _props$autoHighlight,
	      _props$autoSelect = props.autoSelect,
	      autoSelect = _props$autoSelect === void 0 ? false : _props$autoSelect,
	      _props$blurOnSelect = props.blurOnSelect,
	      blurOnSelect = _props$blurOnSelect === void 0 ? false : _props$blurOnSelect,
	      _props$clearOnBlur = props.clearOnBlur,
	      clearOnBlur = _props$clearOnBlur === void 0 ? !props.freeSolo : _props$clearOnBlur,
	      _props$clearOnEscape = props.clearOnEscape,
	      clearOnEscape = _props$clearOnEscape === void 0 ? false : _props$clearOnEscape,
	      _props$componentName = props.componentName,
	      componentName = _props$componentName === void 0 ? 'useAutocomplete' : _props$componentName,
	      _props$debug = props.debug,
	      debug = _props$debug === void 0 ? false : _props$debug,
	      _props$defaultValue = props.defaultValue,
	      defaultValue = _props$defaultValue === void 0 ? props.multiple ? [] : null : _props$defaultValue,
	      _props$disableClearab = props.disableClearable,
	      disableClearable = _props$disableClearab === void 0 ? false : _props$disableClearab,
	      _props$disableCloseOn = props.disableCloseOnSelect,
	      disableCloseOnSelect = _props$disableCloseOn === void 0 ? false : _props$disableCloseOn,
	      _props$disabledItemsF = props.disabledItemsFocusable,
	      disabledItemsFocusable = _props$disabledItemsF === void 0 ? false : _props$disabledItemsF,
	      _props$disableListWra = props.disableListWrap,
	      disableListWrap = _props$disableListWra === void 0 ? false : _props$disableListWra,
	      _props$filterOptions = props.filterOptions,
	      filterOptions = _props$filterOptions === void 0 ? defaultFilterOptions : _props$filterOptions,
	      _props$filterSelected = props.filterSelectedOptions,
	      filterSelectedOptions = _props$filterSelected === void 0 ? false : _props$filterSelected,
	      _props$freeSolo = props.freeSolo,
	      freeSolo = _props$freeSolo === void 0 ? false : _props$freeSolo,
	      getOptionDisabled = props.getOptionDisabled,
	      _props$getOptionLabel = props.getOptionLabel,
	      getOptionLabelProp = _props$getOptionLabel === void 0 ? function (option) {
	    return option;
	  } : _props$getOptionLabel,
	      _props$getOptionSelec = props.getOptionSelected,
	      getOptionSelected = _props$getOptionSelec === void 0 ? function (option, value) {
	    return option === value;
	  } : _props$getOptionSelec,
	      groupBy = props.groupBy,
	      _props$handleHomeEndK = props.handleHomeEndKeys,
	      handleHomeEndKeys = _props$handleHomeEndK === void 0 ? !props.freeSolo : _props$handleHomeEndK,
	      idProp = props.id,
	      _props$includeInputIn = props.includeInputInList,
	      includeInputInList = _props$includeInputIn === void 0 ? false : _props$includeInputIn,
	      inputValueProp = props.inputValue,
	      _props$multiple = props.multiple,
	      multiple = _props$multiple === void 0 ? false : _props$multiple,
	      onChange = props.onChange,
	      onClose = props.onClose,
	      onHighlightChange = props.onHighlightChange,
	      onInputChange = props.onInputChange,
	      onOpen = props.onOpen,
	      openProp = props.open,
	      _props$openOnFocus = props.openOnFocus,
	      openOnFocus = _props$openOnFocus === void 0 ? false : _props$openOnFocus,
	      options = props.options,
	      _props$selectOnFocus = props.selectOnFocus,
	      selectOnFocus = _props$selectOnFocus === void 0 ? !props.freeSolo : _props$selectOnFocus,
	      valueProp = props.value;
	  var id = (0, _utils.unstable_useId)(idProp);
	  var getOptionLabel = getOptionLabelProp;
	
	  if (false) {
	    getOptionLabel = function getOptionLabel(option) {
	      var optionLabel = getOptionLabelProp(option);
	
	      if (typeof optionLabel !== 'string') {
	        var erroneousReturn = optionLabel === undefined ? 'undefined' : "".concat((0, _typeof2.default)(optionLabel), " (").concat(optionLabel, ")");
	        console.error("Material-UI: The `getOptionLabel` method of ".concat(componentName, " returned ").concat(erroneousReturn, " instead of a string for ").concat(JSON.stringify(option), "."));
	      }
	
	      return optionLabel;
	    };
	  }
	
	  var ignoreFocus = React.useRef(false);
	  var firstFocus = React.useRef(true);
	  var inputRef = React.useRef(null);
	  var listboxRef = React.useRef(null);
	
	  var _React$useState = React.useState(null),
	      anchorEl = _React$useState[0],
	      setAnchorEl = _React$useState[1];
	
	  var _React$useState2 = React.useState(-1),
	      focusedTag = _React$useState2[0],
	      setFocusedTag = _React$useState2[1];
	
	  var defaultHighlighted = autoHighlight ? 0 : -1;
	  var highlightedIndexRef = React.useRef(defaultHighlighted);
	
	  var _useControlled = (0, _utils.useControlled)({
	    controlled: valueProp,
	    default: defaultValue,
	    name: componentName
	  }),
	      _useControlled2 = (0, _slicedToArray2.default)(_useControlled, 2),
	      value = _useControlled2[0],
	      setValue = _useControlled2[1];
	
	  var _useControlled3 = (0, _utils.useControlled)({
	    controlled: inputValueProp,
	    default: '',
	    name: componentName,
	    state: 'inputValue'
	  }),
	      _useControlled4 = (0, _slicedToArray2.default)(_useControlled3, 2),
	      inputValue = _useControlled4[0],
	      setInputValue = _useControlled4[1];
	
	  var _React$useState3 = React.useState(false),
	      focused = _React$useState3[0],
	      setFocused = _React$useState3[1];
	
	  var resetInputValue = (0, _utils.useEventCallback)(function (event, newValue) {
	    var newInputValue;
	
	    if (multiple) {
	      newInputValue = '';
	    } else if (newValue == null) {
	      newInputValue = '';
	    } else {
	      var optionLabel = getOptionLabel(newValue);
	      newInputValue = typeof optionLabel === 'string' ? optionLabel : '';
	    }
	
	    if (inputValue === newInputValue) {
	      return;
	    }
	
	    setInputValue(newInputValue);
	
	    if (onInputChange) {
	      onInputChange(event, newInputValue, 'reset');
	    }
	  });
	  React.useEffect(function () {
	    resetInputValue(null, value);
	  }, [value, resetInputValue]);
	
	  var _useControlled5 = (0, _utils.useControlled)({
	    controlled: openProp,
	    default: false,
	    name: componentName,
	    state: 'open'
	  }),
	      _useControlled6 = (0, _slicedToArray2.default)(_useControlled5, 2),
	      open = _useControlled6[0],
	      setOpenState = _useControlled6[1];
	
	  var inputValueIsSelectedValue = !multiple && value != null && inputValue === getOptionLabel(value);
	  var popupOpen = open;
	  var filteredOptions = popupOpen ? filterOptions(options.filter(function (option) {
	    if (filterSelectedOptions && (multiple ? value : [value]).some(function (value2) {
	      return value2 !== null && getOptionSelected(option, value2);
	    })) {
	      return false;
	    }
	
	    return true;
	  }), // we use the empty string to manipulate `filterOptions` to not filter any options
	  // i.e. the filter predicate always returns true
	  {
	    inputValue: inputValueIsSelectedValue ? '' : inputValue,
	    getOptionLabel: getOptionLabel
	  }) : [];
	
	  if (false) {
	    if (value !== null && !freeSolo && options.length > 0) {
	      var missingValue = (multiple ? value : [value]).filter(function (value2) {
	        return !options.some(function (option) {
	          return getOptionSelected(option, value2);
	        });
	      });
	
	      if (missingValue.length > 0) {
	        console.warn(["Material-UI: The value provided to ".concat(componentName, " is invalid."), "None of the options match with `".concat(missingValue.length > 1 ? JSON.stringify(missingValue) : JSON.stringify(missingValue[0]), "`."), 'You can use the `getOptionSelected` prop to customize the equality test.'].join('\n'));
	      }
	    }
	  }
	
	  var focusTag = (0, _utils.useEventCallback)(function (tagToFocus) {
	    if (tagToFocus === -1) {
	      inputRef.current.focus();
	    } else {
	      anchorEl.querySelector("[data-tag-index=\"".concat(tagToFocus, "\"]")).focus();
	    }
	  }); // Ensure the focusedTag is never inconsistent
	
	  React.useEffect(function () {
	    if (multiple && focusedTag > value.length - 1) {
	      setFocusedTag(-1);
	      focusTag(-1);
	    }
	  }, [value, multiple, focusedTag, focusTag]);
	
	  function validOptionIndex(index, direction) {
	    if (!listboxRef.current || index === -1) {
	      return -1;
	    }
	
	    var nextFocus = index;
	
	    while (true) {
	      // Out of range
	      if (direction === 'next' && nextFocus === filteredOptions.length || direction === 'previous' && nextFocus === -1) {
	        return -1;
	      }
	
	      var option = listboxRef.current.querySelector("[data-option-index=\"".concat(nextFocus, "\"]")); // Same logic as MenuList.js
	
	      var nextFocusDisabled = disabledItemsFocusable ? false : option && (option.disabled || option.getAttribute('aria-disabled') === 'true');
	
	      if (option && !option.hasAttribute('tabindex') || nextFocusDisabled) {
	        // Move to the next element.
	        nextFocus += direction === 'next' ? 1 : -1;
	      } else {
	        return nextFocus;
	      }
	    }
	  }
	
	  var setHighlightedIndex = (0, _utils.useEventCallback)(function (_ref2) {
	    var event = _ref2.event,
	        index = _ref2.index,
	        _ref2$reason = _ref2.reason,
	        reason = _ref2$reason === void 0 ? 'auto' : _ref2$reason;
	    highlightedIndexRef.current = index; // does the index exist?
	
	    if (index === -1) {
	      inputRef.current.removeAttribute('aria-activedescendant');
	    } else {
	      inputRef.current.setAttribute('aria-activedescendant', "".concat(id, "-option-").concat(index));
	    }
	
	    if (onHighlightChange) {
	      onHighlightChange(event, index === -1 ? null : filteredOptions[index], reason);
	    }
	
	    if (!listboxRef.current) {
	      return;
	    }
	
	    var prev = listboxRef.current.querySelector('[data-focus]');
	
	    if (prev) {
	      prev.removeAttribute('data-focus');
	    }
	
	    var listboxNode = listboxRef.current.parentElement.querySelector('[role="listbox"]'); // "No results"
	
	    if (!listboxNode) {
	      return;
	    }
	
	    if (index === -1) {
	      listboxNode.scrollTop = 0;
	      return;
	    }
	
	    var option = listboxRef.current.querySelector("[data-option-index=\"".concat(index, "\"]"));
	
	    if (!option) {
	      return;
	    }
	
	    option.setAttribute('data-focus', 'true'); // Scroll active descendant into view.
	    // Logic copied from https://www.w3.org/TR/wai-aria-practices/examples/listbox/js/listbox.js
	    //
	    // Consider this API instead once it has a better browser support:
	    // .scrollIntoView({ scrollMode: 'if-needed', block: 'nearest' });
	
	    if (listboxNode.scrollHeight > listboxNode.clientHeight && reason !== 'mouse') {
	      var element = option;
	      var scrollBottom = listboxNode.clientHeight + listboxNode.scrollTop;
	      var elementBottom = element.offsetTop + element.offsetHeight;
	
	      if (elementBottom > scrollBottom) {
	        listboxNode.scrollTop = elementBottom - listboxNode.clientHeight;
	      } else if (element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0) < listboxNode.scrollTop) {
	        listboxNode.scrollTop = element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0);
	      }
	    }
	  });
	  var changeHighlightedIndex = (0, _utils.useEventCallback)(function (_ref3) {
	    var event = _ref3.event,
	        diff = _ref3.diff,
	        _ref3$direction = _ref3.direction,
	        direction = _ref3$direction === void 0 ? 'next' : _ref3$direction,
	        _ref3$reason = _ref3.reason,
	        reason = _ref3$reason === void 0 ? 'auto' : _ref3$reason;
	
	    if (!popupOpen) {
	      return;
	    }
	
	    var getNextIndex = function getNextIndex() {
	      var maxIndex = filteredOptions.length - 1;
	
	      if (diff === 'reset') {
	        return defaultHighlighted;
	      }
	
	      if (diff === 'start') {
	        return 0;
	      }
	
	      if (diff === 'end') {
	        return maxIndex;
	      }
	
	      var newIndex = highlightedIndexRef.current + diff;
	
	      if (newIndex < 0) {
	        if (newIndex === -1 && includeInputInList) {
	          return -1;
	        }
	
	        if (disableListWrap && highlightedIndexRef.current !== -1 || Math.abs(diff) > 1) {
	          return 0;
	        }
	
	        return maxIndex;
	      }
	
	      if (newIndex > maxIndex) {
	        if (newIndex === maxIndex + 1 && includeInputInList) {
	          return -1;
	        }
	
	        if (disableListWrap || Math.abs(diff) > 1) {
	          return maxIndex;
	        }
	
	        return 0;
	      }
	
	      return newIndex;
	    };
	
	    var nextIndex = validOptionIndex(getNextIndex(), direction);
	    setHighlightedIndex({
	      index: nextIndex,
	      reason: reason,
	      event: event
	    }); // Sync the content of the input with the highlighted option.
	
	    if (autoComplete && diff !== 'reset') {
	      if (nextIndex === -1) {
	        inputRef.current.value = inputValue;
	      } else {
	        var option = getOptionLabel(filteredOptions[nextIndex]);
	        inputRef.current.value = option; // The portion of the selected suggestion that has not been typed by the user,
	        // a completion string, appears inline after the input cursor in the textbox.
	
	        var index = option.toLowerCase().indexOf(inputValue.toLowerCase());
	
	        if (index === 0 && inputValue.length > 0) {
	          inputRef.current.setSelectionRange(inputValue.length, option.length);
	        }
	      }
	    }
	  });
	  var syncHighlightedIndex = React.useCallback(function () {
	    if (!popupOpen) {
	      return;
	    }
	
	    var valueItem = multiple ? value[0] : value; // The popup is empty, reset
	
	    if (filteredOptions.length === 0 || valueItem == null) {
	      changeHighlightedIndex({
	        diff: 'reset'
	      });
	      return;
	    }
	
	    if (!listboxRef.current) {
	      return;
	    } // Synchronize the value with the highlighted index
	
	
	    if (!filterSelectedOptions && valueItem != null) {
	      var currentOption = filteredOptions[highlightedIndexRef.current]; // Keep the current highlighted index if possible
	
	      if (multiple && currentOption && findIndex(value, function (val) {
	        return getOptionSelected(currentOption, val);
	      }) !== -1) {
	        return;
	      }
	
	      var itemIndex = findIndex(filteredOptions, function (optionItem) {
	        return getOptionSelected(optionItem, valueItem);
	      });
	
	      if (itemIndex === -1) {
	        changeHighlightedIndex({
	          diff: 'reset'
	        });
	      } else {
	        setHighlightedIndex({
	          index: itemIndex
	        });
	      }
	
	      return;
	    } // Prevent the highlighted index to leak outside the boundaries.
	
	
	    if (highlightedIndexRef.current >= filteredOptions.length - 1) {
	      setHighlightedIndex({
	        index: filteredOptions.length - 1
	      });
	      return;
	    } // Restore the focus to the previous index.
	
	
	    setHighlightedIndex({
	      index: highlightedIndexRef.current
	    }); // Ignore filteredOptions (and options, getOptionSelected, getOptionLabel) not to break the scroll position
	    // eslint-disable-next-line react-hooks/exhaustive-deps
	  }, [// Only sync the highlighted index when the option switch between empty and not
	  // eslint-disable-next-line react-hooks/exhaustive-deps
	  filteredOptions.length === 0, // Don't sync the highlighted index with the value when multiple
	  // eslint-disable-next-line react-hooks/exhaustive-deps
	  multiple ? false : value, filterSelectedOptions, changeHighlightedIndex, setHighlightedIndex, popupOpen, inputValue, multiple]);
	  var handleListboxRef = (0, _utils.useEventCallback)(function (node) {
	    (0, _utils.setRef)(listboxRef, node);
	
	    if (!node) {
	      return;
	    }
	
	    syncHighlightedIndex();
	  });
	  React.useEffect(function () {
	    syncHighlightedIndex();
	  }, [syncHighlightedIndex]);
	
	  var handleOpen = function handleOpen(event) {
	    if (open) {
	      return;
	    }
	
	    setOpenState(true);
	
	    if (onOpen) {
	      onOpen(event);
	    }
	  };
	
	  var handleClose = function handleClose(event, reason) {
	    if (!open) {
	      return;
	    }
	
	    setOpenState(false);
	
	    if (onClose) {
	      onClose(event, reason);
	    }
	  };
	
	  var handleValue = function handleValue(event, newValue, reason, details) {
	    if (value === newValue) {
	      return;
	    }
	
	    if (onChange) {
	      onChange(event, newValue, reason, details);
	    }
	
	    setValue(newValue);
	  };
	
	  var isTouch = React.useRef(false);
	
	  var selectNewValue = function selectNewValue(event, option) {
	    var reasonProp = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'select-option';
	    var origin = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'options';
	    var reason = reasonProp;
	    var newValue = option;
	
	    if (multiple) {
	      newValue = Array.isArray(value) ? value.slice() : [];
	
	      if (false) {
	        var matches = newValue.filter(function (val) {
	          return getOptionSelected(option, val);
	        });
	
	        if (matches.length > 1) {
	          console.error(["Material-UI: The `getOptionSelected` method of ".concat(componentName, " do not handle the arguments correctly."), "The component expects a single value to match a given option but found ".concat(matches.length, " matches.")].join('\n'));
	        }
	      }
	
	      var itemIndex = findIndex(newValue, function (valueItem) {
	        return getOptionSelected(option, valueItem);
	      });
	
	      if (itemIndex === -1) {
	        newValue.push(option);
	      } else if (origin !== 'freeSolo') {
	        newValue.splice(itemIndex, 1);
	        reason = 'remove-option';
	      }
	    }
	
	    resetInputValue(event, newValue);
	    handleValue(event, newValue, reason, {
	      option: option
	    });
	
	    if (!disableCloseOnSelect) {
	      handleClose(event, reason);
	    }
	
	    if (blurOnSelect === true || blurOnSelect === 'touch' && isTouch.current || blurOnSelect === 'mouse' && !isTouch.current) {
	      inputRef.current.blur();
	    }
	  };
	
	  function validTagIndex(index, direction) {
	    if (index === -1) {
	      return -1;
	    }
	
	    var nextFocus = index;
	
	    while (true) {
	      // Out of range
	      if (direction === 'next' && nextFocus === value.length || direction === 'previous' && nextFocus === -1) {
	        return -1;
	      }
	
	      var option = anchorEl.querySelector("[data-tag-index=\"".concat(nextFocus, "\"]")); // Same logic as MenuList.js
	
	      if (option && (!option.hasAttribute('tabindex') || option.disabled || option.getAttribute('aria-disabled') === 'true')) {
	        nextFocus += direction === 'next' ? 1 : -1;
	      } else {
	        return nextFocus;
	      }
	    }
	  }
	
	  var handleFocusTag = function handleFocusTag(event, direction) {
	    if (!multiple) {
	      return;
	    }
	
	    handleClose(event, 'toggleInput');
	    var nextTag = focusedTag;
	
	    if (focusedTag === -1) {
	      if (inputValue === '' && direction === 'previous') {
	        nextTag = value.length - 1;
	      }
	    } else {
	      nextTag += direction === 'next' ? 1 : -1;
	
	      if (nextTag < 0) {
	        nextTag = 0;
	      }
	
	      if (nextTag === value.length) {
	        nextTag = -1;
	      }
	    }
	
	    nextTag = validTagIndex(nextTag, direction);
	    setFocusedTag(nextTag);
	    focusTag(nextTag);
	  };
	
	  var handleClear = function handleClear(event) {
	    ignoreFocus.current = true;
	    setInputValue('');
	
	    if (onInputChange) {
	      onInputChange(event, '', 'clear');
	    }
	
	    handleValue(event, multiple ? [] : null, 'clear');
	  };
	
	  var handleKeyDown = function handleKeyDown(other) {
	    return function (event) {
	      if (focusedTag !== -1 && ['ArrowLeft', 'ArrowRight'].indexOf(event.key) === -1) {
	        setFocusedTag(-1);
	        focusTag(-1);
	      }
	
	      switch (event.key) {
	        case 'Home':
	          if (popupOpen && handleHomeEndKeys) {
	            // Prevent scroll of the page
	            event.preventDefault();
	            changeHighlightedIndex({
	              diff: 'start',
	              direction: 'next',
	              reason: 'keyboard',
	              event: event
	            });
	          }
	
	          break;
	
	        case 'End':
	          if (popupOpen && handleHomeEndKeys) {
	            // Prevent scroll of the page
	            event.preventDefault();
	            changeHighlightedIndex({
	              diff: 'end',
	              direction: 'previous',
	              reason: 'keyboard',
	              event: event
	            });
	          }
	
	          break;
	
	        case 'PageUp':
	          // Prevent scroll of the page
	          event.preventDefault();
	          changeHighlightedIndex({
	            diff: -pageSize,
	            direction: 'previous',
	            reason: 'keyboard',
	            event: event
	          });
	          handleOpen(event);
	          break;
	
	        case 'PageDown':
	          // Prevent scroll of the page
	          event.preventDefault();
	          changeHighlightedIndex({
	            diff: pageSize,
	            direction: 'next',
	            reason: 'keyboard',
	            event: event
	          });
	          handleOpen(event);
	          break;
	
	        case 'ArrowDown':
	          // Prevent cursor move
	          event.preventDefault();
	          changeHighlightedIndex({
	            diff: 1,
	            direction: 'next',
	            reason: 'keyboard',
	            event: event
	          });
	          handleOpen(event);
	          break;
	
	        case 'ArrowUp':
	          // Prevent cursor move
	          event.preventDefault();
	          changeHighlightedIndex({
	            diff: -1,
	            direction: 'previous',
	            reason: 'keyboard',
	            event: event
	          });
	          handleOpen(event);
	          break;
	
	        case 'ArrowLeft':
	          handleFocusTag(event, 'previous');
	          break;
	
	        case 'ArrowRight':
	          handleFocusTag(event, 'next');
	          break;
	
	        case 'Enter':
	          // Wait until IME is settled.
	          if (event.which === 229) {
	            break;
	          }
	
	          if (highlightedIndexRef.current !== -1 && popupOpen) {
	            var option = filteredOptions[highlightedIndexRef.current];
	            var disabled = getOptionDisabled ? getOptionDisabled(option) : false; // We don't want to validate the form.
	
	            event.preventDefault();
	
	            if (disabled) {
	              return;
	            }
	
	            selectNewValue(event, option, 'select-option'); // Move the selection to the end.
	
	            if (autoComplete) {
	              inputRef.current.setSelectionRange(inputRef.current.value.length, inputRef.current.value.length);
	            }
	          } else if (freeSolo && inputValue !== '' && inputValueIsSelectedValue === false) {
	            if (multiple) {
	              // Allow people to add new values before they submit the form.
	              event.preventDefault();
	            }
	
	            selectNewValue(event, inputValue, 'create-option', 'freeSolo');
	          }
	
	          break;
	
	        case 'Escape':
	          if (popupOpen) {
	            // Avoid Opera to exit fullscreen mode.
	            event.preventDefault(); // Avoid the Modal to handle the event.
	
	            event.stopPropagation();
	            handleClose(event, 'escape');
	          } else if (clearOnEscape && (inputValue !== '' || multiple && value.length > 0)) {
	            // Avoid Opera to exit fullscreen mode.
	            event.preventDefault(); // Avoid the Modal to handle the event.
	
	            event.stopPropagation();
	            handleClear(event);
	          }
	
	          break;
	
	        case 'Backspace':
	          if (multiple && inputValue === '' && value.length > 0) {
	            var index = focusedTag === -1 ? value.length - 1 : focusedTag;
	            var newValue = value.slice();
	            newValue.splice(index, 1);
	            handleValue(event, newValue, 'remove-option', {
	              option: value[index]
	            });
	          }
	
	          break;
	
	        default:
	      }
	
	      if (other.onKeyDown) {
	        other.onKeyDown(event);
	      }
	    };
	  };
	
	  var handleFocus = function handleFocus(event) {
	    setFocused(true);
	
	    if (openOnFocus && !ignoreFocus.current) {
	      handleOpen(event);
	    }
	  };
	
	  var handleBlur = function handleBlur(event) {
	    // Ignore the event when using the scrollbar with IE 11
	    if (listboxRef.current !== null && document.activeElement === listboxRef.current.parentElement) {
	      inputRef.current.focus();
	      return;
	    }
	
	    setFocused(false);
	    firstFocus.current = true;
	    ignoreFocus.current = false;
	
	    if (debug && inputValue !== '') {
	      return;
	    }
	
	    if (autoSelect && highlightedIndexRef.current !== -1 && popupOpen) {
	      selectNewValue(event, filteredOptions[highlightedIndexRef.current], 'blur');
	    } else if (autoSelect && freeSolo && inputValue !== '') {
	      selectNewValue(event, inputValue, 'blur', 'freeSolo');
	    } else if (clearOnBlur) {
	      resetInputValue(event, value);
	    }
	
	    handleClose(event, 'blur');
	  };
	
	  var handleInputChange = function handleInputChange(event) {
	    var newValue = event.target.value;
	
	    if (inputValue !== newValue) {
	      setInputValue(newValue);
	
	      if (onInputChange) {
	        onInputChange(event, newValue, 'input');
	      }
	    }
	
	    if (newValue === '') {
	      if (!disableClearable && !multiple) {
	        handleValue(event, null, 'clear');
	      }
	    } else {
	      handleOpen(event);
	    }
	  };
	
	  var handleOptionMouseOver = function handleOptionMouseOver(event) {
	    setHighlightedIndex({
	      event: event,
	      index: Number(event.currentTarget.getAttribute('data-option-index')),
	      reason: 'mouse'
	    });
	  };
	
	  var handleOptionTouchStart = function handleOptionTouchStart() {
	    isTouch.current = true;
	  };
	
	  var handleOptionClick = function handleOptionClick(event) {
	    var index = Number(event.currentTarget.getAttribute('data-option-index'));
	    selectNewValue(event, filteredOptions[index], 'select-option');
	    isTouch.current = false;
	  };
	
	  var handleTagDelete = function handleTagDelete(index) {
	    return function (event) {
	      var newValue = value.slice();
	      newValue.splice(index, 1);
	      handleValue(event, newValue, 'remove-option', {
	        option: value[index]
	      });
	    };
	  };
	
	  var handlePopupIndicator = function handlePopupIndicator(event) {
	    if (open) {
	      handleClose(event, 'toggleInput');
	    } else {
	      handleOpen(event);
	    }
	  }; // Prevent input blur when interacting with the combobox
	
	
	  var handleMouseDown = function handleMouseDown(event) {
	    if (event.target.getAttribute('id') !== id) {
	      event.preventDefault();
	    }
	  }; // Focus the input when interacting with the combobox
	
	
	  var handleClick = function handleClick() {
	    inputRef.current.focus();
	
	    if (selectOnFocus && firstFocus.current && inputRef.current.selectionEnd - inputRef.current.selectionStart === 0) {
	      inputRef.current.select();
	    }
	
	    firstFocus.current = false;
	  };
	
	  var handleInputMouseDown = function handleInputMouseDown(event) {
	    if (inputValue === '' || !open) {
	      handlePopupIndicator(event);
	    }
	  };
	
	  var dirty = freeSolo && inputValue.length > 0;
	  dirty = dirty || (multiple ? value.length > 0 : value !== null);
	  var groupedOptions = filteredOptions;
	
	  if (groupBy) {
	    // used to keep track of key and indexes in the result array
	    var indexBy = new Map();
	    var warn = false;
	    groupedOptions = filteredOptions.reduce(function (acc, option, index) {
	      var group = groupBy(option);
	
	      if (acc.length > 0 && acc[acc.length - 1].group === group) {
	        acc[acc.length - 1].options.push(option);
	      } else {
	        if (false) {
	          if (indexBy.get(group) && !warn) {
	            console.warn("Material-UI: The options provided combined with the `groupBy` method of ".concat(componentName, " returns duplicated headers."), 'You can solve the issue by sorting the options with the output of `groupBy`.');
	            warn = true;
	          }
	
	          indexBy.set(group, true);
	        }
	
	        acc.push({
	          key: index,
	          index: index,
	          group: group,
	          options: [option]
	        });
	      }
	
	      return acc;
	    }, []);
	  }
	
	  return {
	    getRootProps: function getRootProps() {
	      var other = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      return (0, _extends2.default)({
	        'aria-owns': popupOpen ? "".concat(id, "-popup") : null,
	        role: 'combobox',
	        'aria-expanded': popupOpen
	      }, other, {
	        onKeyDown: handleKeyDown(other),
	        onMouseDown: handleMouseDown,
	        onClick: handleClick
	      });
	    },
	    getInputLabelProps: function getInputLabelProps() {
	      return {
	        id: "".concat(id, "-label"),
	        htmlFor: id
	      };
	    },
	    getInputProps: function getInputProps() {
	      return {
	        id: id,
	        value: inputValue,
	        onBlur: handleBlur,
	        onFocus: handleFocus,
	        onChange: handleInputChange,
	        onMouseDown: handleInputMouseDown,
	        // if open then this is handled imperativeley so don't let react override
	        // only have an opinion about this when closed
	        'aria-activedescendant': popupOpen ? '' : null,
	        'aria-autocomplete': autoComplete ? 'both' : 'list',
	        'aria-controls': popupOpen ? "".concat(id, "-popup") : null,
	        // Disable browser's suggestion that might overlap with the popup.
	        // Handle autocomplete but not autofill.
	        autoComplete: 'off',
	        ref: inputRef,
	        autoCapitalize: 'none',
	        spellCheck: 'false'
	      };
	    },
	    getClearProps: function getClearProps() {
	      return {
	        tabIndex: -1,
	        onClick: handleClear
	      };
	    },
	    getPopupIndicatorProps: function getPopupIndicatorProps() {
	      return {
	        tabIndex: -1,
	        onClick: handlePopupIndicator
	      };
	    },
	    getTagProps: function getTagProps(_ref4) {
	      var index = _ref4.index;
	      return {
	        key: index,
	        'data-tag-index': index,
	        tabIndex: -1,
	        onDelete: handleTagDelete(index)
	      };
	    },
	    getListboxProps: function getListboxProps() {
	      return {
	        role: 'listbox',
	        id: "".concat(id, "-popup"),
	        'aria-labelledby': "".concat(id, "-label"),
	        ref: handleListboxRef,
	        onMouseDown: function onMouseDown(event) {
	          // Prevent blur
	          event.preventDefault();
	        }
	      };
	    },
	    getOptionProps: function getOptionProps(_ref5) {
	      var index = _ref5.index,
	          option = _ref5.option;
	      var selected = (multiple ? value : [value]).some(function (value2) {
	        return value2 != null && getOptionSelected(option, value2);
	      });
	      var disabled = getOptionDisabled ? getOptionDisabled(option) : false;
	      return {
	        key: index,
	        tabIndex: -1,
	        role: 'option',
	        id: "".concat(id, "-option-").concat(index),
	        onMouseOver: handleOptionMouseOver,
	        onClick: handleOptionClick,
	        onTouchStart: handleOptionTouchStart,
	        'data-option-index': index,
	        'aria-disabled': disabled,
	        'aria-selected': selected
	      };
	    },
	    id: id,
	    inputValue: inputValue,
	    value: value,
	    dirty: dirty,
	    popupOpen: popupOpen,
	    focused: focused || focusedTag !== -1,
	    anchorEl: anchorEl,
	    setAnchorEl: setAnchorEl,
	    focusedTag: focusedTag,
	    groupedOptions: groupedOptions
	  };
	}

/***/ },
/* 789 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(19));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _jss = __webpack_require__(110);
	
	var _StylesProvider = _interopRequireDefault(__webpack_require__(239));
	
	var _createGenerateClassName = _interopRequireDefault(__webpack_require__(240));
	
	var ServerStyleSheets = /*#__PURE__*/function () {
	  function ServerStyleSheets() {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    (0, _classCallCheck2.default)(this, ServerStyleSheets);
	    this.options = options;
	  }
	
	  (0, _createClass2.default)(ServerStyleSheets, [{
	    key: "collect",
	    value: function collect(children) {
	      // This is needed in order to deduplicate the injection of CSS in the page.
	      var sheetsManager = new Map(); // This is needed in order to inject the critical CSS.
	
	      this.sheetsRegistry = new _jss.SheetsRegistry(); // A new class name generator
	
	      var generateClassName = (0, _createGenerateClassName.default)();
	      return /*#__PURE__*/_react.default.createElement(_StylesProvider.default, (0, _extends2.default)({
	        sheetsManager: sheetsManager,
	        serverGenerateClassName: generateClassName,
	        sheetsRegistry: this.sheetsRegistry
	      }, this.options), children);
	    }
	  }, {
	    key: "toString",
	    value: function toString() {
	      return this.sheetsRegistry ? this.sheetsRegistry.toString() : '';
	    }
	  }, {
	    key: "getStyleElement",
	    value: function getStyleElement(props) {
	      return /*#__PURE__*/_react.default.createElement('style', (0, _extends2.default)({
	        id: 'jss-server-side',
	        key: 'jss-server-side',
	        dangerouslySetInnerHTML: {
	          __html: this.toString()
	        }
	      }, props));
	    }
	  }]);
	  return ServerStyleSheets;
	}();
	
	exports.default = ServerStyleSheets;

/***/ },
/* 790 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ServerStyleSheets.default;
	  }
	});
	
	var _ServerStyleSheets = _interopRequireDefault(__webpack_require__(789));

/***/ },
/* 791 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = StylesProvider;
	exports.StylesContext = exports.sheetsManager = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(25));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(26);
	
	var _createGenerateClassName = _interopRequireDefault(__webpack_require__(240));
	
	var _jss = __webpack_require__(110);
	
	var _jssPreset = _interopRequireDefault(__webpack_require__(337));
	
	// Default JSS instance.
	var jss = (0, _jss.create)((0, _jssPreset.default)()); // Use a singleton or the provided one by the context.
	//
	// The counter-based approach doesn't tolerate any mistake.
	// It's much safer to use the same counter everywhere.
	
	var generateClassName = (0, _createGenerateClassName.default)(); // Exported for test purposes
	
	var sheetsManager = new Map();
	exports.sheetsManager = sheetsManager;
	var defaultOptions = {
	  disableGeneration: false,
	  generateClassName: generateClassName,
	  jss: jss,
	  sheetsCache: null,
	  sheetsManager: sheetsManager,
	  sheetsRegistry: null
	};
	
	var StylesContext = _react.default.createContext(defaultOptions);
	
	exports.StylesContext = StylesContext;
	
	if (false) {
	  StylesContext.displayName = 'StylesContext';
	}
	
	var injectFirstNode;
	
	function StylesProvider(props) {
	  var children = props.children,
	      _props$injectFirst = props.injectFirst,
	      injectFirst = _props$injectFirst === void 0 ? false : _props$injectFirst,
	      _props$disableGenerat = props.disableGeneration,
	      disableGeneration = _props$disableGenerat === void 0 ? false : _props$disableGenerat,
	      localOptions = (0, _objectWithoutProperties2.default)(props, ["children", "injectFirst", "disableGeneration"]);
	
	  var outerOptions = _react.default.useContext(StylesContext);
	
	  var context = (0, _extends2.default)({}, outerOptions, {
	    disableGeneration: disableGeneration
	  }, localOptions);
	
	  if (false) {
	    if (typeof window === 'undefined' && !context.sheetsManager) {
	      console.error('Material-UI: You need to use the ServerStyleSheets API when rendering on the server.');
	    }
	  }
	
	  if (false) {
	    if (context.jss.options.insertionPoint && injectFirst) {
	      console.error('Material-UI: You cannot use a custom insertionPoint and <StylesContext injectFirst> at the same time.');
	    }
	  }
	
	  if (false) {
	    if (injectFirst && localOptions.jss) {
	      console.error('Material-UI: You cannot use the jss and injectFirst props at the same time.');
	    }
	  }
	
	  if (!context.jss.options.insertionPoint && injectFirst && typeof window !== 'undefined') {
	    if (!injectFirstNode) {
	      var head = document.head;
	      injectFirstNode = document.createComment('mui-inject-first');
	      head.insertBefore(injectFirstNode, head.firstChild);
	    }
	
	    context.jss = (0, _jss.create)({
	      plugins: (0, _jssPreset.default)().plugins,
	      insertionPoint: injectFirstNode
	    });
	  }
	
	  return /*#__PURE__*/_react.default.createElement(StylesContext.Provider, {
	    value: context
	  }, children);
	}
	
	 false ? StylesProvider.propTypes = {
	  /**
	   * Your component tree.
	   */
	  children: _propTypes.default.node.isRequired,
	
	  /**
	   * You can disable the generation of the styles with this option.
	   * It can be useful when traversing the React tree outside of the HTML
	   * rendering step on the server.
	   * Let's say you are using react-apollo to extract all
	   * the queries made by the interface server-side - you can significantly speed up the traversal with this prop.
	   */
	  disableGeneration: _propTypes.default.bool,
	
	  /**
	   * JSS's class name generator.
	   */
	  generateClassName: _propTypes.default.func,
	
	  /**
	   * By default, the styles are injected last in the <head> element of the page.
	   * As a result, they gain more specificity than any other style sheet.
	   * If you want to override Material-UI's styles, set this prop.
	   */
	  injectFirst: _propTypes.default.bool,
	
	  /**
	   * JSS's instance.
	   */
	  jss: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  serverGenerateClassName: _propTypes.default.func,
	
	  /**
	   * @ignore
	   *
	   * Beta feature.
	   *
	   * Cache for the sheets.
	   */
	  sheetsCache: _propTypes.default.object,
	
	  /**
	   * @ignore
	   *
	   * The sheetsManager is used to deduplicate style sheet injection in the page.
	   * It's deduplicating using the (theme, styles) couple.
	   * On the server, you should provide a new instance for each request.
	   */
	  sheetsManager: _propTypes.default.object,
	
	  /**
	   * @ignore
	   *
	   * Collect the sheets.
	   */
	  sheetsRegistry: _propTypes.default.object
	} : void 0;
	
	if (false) {
	  process.env.NODE_ENV !== "production" ? StylesProvider.propTypes = (0, _utils.exactProp)(StylesProvider.propTypes) : void 0;
	}

/***/ },
/* 792 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(26);
	
	var _ThemeContext = _interopRequireDefault(__webpack_require__(339));
	
	var _useTheme = _interopRequireDefault(__webpack_require__(144));
	
	var _nested = _interopRequireDefault(__webpack_require__(334));
	
	// To support composition of theme.
	function mergeOuterLocalTheme(outerTheme, localTheme) {
	  if (typeof localTheme === 'function') {
	    var mergedTheme = localTheme(outerTheme);
	
	    if (false) {
	      if (!mergedTheme) {
	        console.error(['Material-UI: You should return an object from your theme function, i.e.', '<ThemeProvider theme={() => ({})} />'].join('\n'));
	      }
	    }
	
	    return mergedTheme;
	  }
	
	  return (0, _extends2.default)({}, outerTheme, localTheme);
	}
	/**
	 * This component takes a `theme` prop.
	 * It makes the `theme` available down the React tree thanks to React context.
	 * This component should preferably be used at **the root of your component tree**.
	 */
	
	
	function ThemeProvider(props) {
	  var children = props.children,
	      localTheme = props.theme;
	  var outerTheme = (0, _useTheme.default)();
	
	  if (false) {
	    if (outerTheme === null && typeof localTheme === 'function') {
	      console.error(['Material-UI: You are providing a theme function prop to the ThemeProvider component:', '<ThemeProvider theme={outerTheme => outerTheme} />', '', 'However, no outer theme is present.', 'Make sure a theme is already injected higher in the React tree ' + 'or provide a theme object.'].join('\n'));
	    }
	  }
	
	  var theme = _react.default.useMemo(function () {
	    var output = outerTheme === null ? localTheme : mergeOuterLocalTheme(outerTheme, localTheme);
	
	    if (output != null) {
	      output[_nested.default] = outerTheme !== null;
	    }
	
	    return output;
	  }, [localTheme, outerTheme]);
	
	  return /*#__PURE__*/_react.default.createElement(_ThemeContext.default.Provider, {
	    value: theme
	  }, children);
	}
	
	 false ? ThemeProvider.propTypes = {
	  /**
	   * Your component tree.
	   */
	  children: _propTypes.default.node.isRequired,
	
	  /**
	   * A theme object. You can provide a function to extend the outer theme.
	   */
	  theme: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]).isRequired
	} : void 0;
	
	if (false) {
	  process.env.NODE_ENV !== "production" ? ThemeProvider.propTypes = (0, _utils.exactProp)(ThemeProvider.propTypes) : void 0;
	}
	
	var _default = ThemeProvider;
	exports.default = _default;

/***/ },
/* 793 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ThemeProvider.default;
	  }
	});
	
	var _ThemeProvider = _interopRequireDefault(__webpack_require__(792));

/***/ },
/* 794 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createGenerateClassName;
	
	var _nested = _interopRequireDefault(__webpack_require__(334));
	
	/**
	 * This is the list of the style rule name we use as drop in replacement for the built-in
	 * pseudo classes (:checked, :disabled, :focused, etc.).
	 *
	 * Why do they exist in the first place?
	 * These classes are used at a specificity of 2.
	 * It allows them to override previously definied styles as well as
	 * being untouched by simple user overrides.
	 */
	var pseudoClasses = ['checked', 'disabled', 'error', 'focused', 'focusVisible', 'required', 'expanded', 'selected']; // Returns a function which generates unique class names based on counters.
	// When new generator function is created, rule counter is reset.
	// We need to reset the rule counter for SSR for each request.
	//
	// It's inspired by
	// https://github.com/cssinjs/jss/blob/4e6a05dd3f7b6572fdd3ab216861d9e446c20331/src/utils/createGenerateClassName.js
	
	function createGenerateClassName() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var _options$disableGloba = options.disableGlobal,
	      disableGlobal = _options$disableGloba === void 0 ? false : _options$disableGloba,
	      _options$productionPr = options.productionPrefix,
	      productionPrefix = _options$productionPr === void 0 ? 'jss' : _options$productionPr,
	      _options$seed = options.seed,
	      seed = _options$seed === void 0 ? '' : _options$seed;
	  var seedPrefix = seed === '' ? '' : "".concat(seed, "-");
	  var ruleCounter = 0;
	
	  var getNextCounterId = function getNextCounterId() {
	    ruleCounter += 1;
	
	    if (false) {
	      if (ruleCounter >= 1e10) {
	        console.warn(['Material-UI: You might have a memory leak.', 'The ruleCounter is not supposed to grow that much.'].join(''));
	      }
	    }
	
	    return ruleCounter;
	  };
	
	  return function (rule, styleSheet) {
	    var name = styleSheet.options.name; // Is a global static MUI style?
	
	    if (name && name.indexOf('Mui') === 0 && !styleSheet.options.link && !disableGlobal) {
	      // We can use a shorthand class name, we never use the keys to style the components.
	      if (pseudoClasses.indexOf(rule.key) !== -1) {
	        return "Mui-".concat(rule.key);
	      }
	
	      var prefix = "".concat(seedPrefix).concat(name, "-").concat(rule.key);
	
	      if (!styleSheet.options.theme[_nested.default] || seed !== '') {
	        return prefix;
	      }
	
	      return "".concat(prefix, "-").concat(getNextCounterId());
	    }
	
	    if (true) {
	      return "".concat(seedPrefix).concat(productionPrefix).concat(getNextCounterId());
	    }
	
	    var suffix = "".concat(rule.key, "-").concat(getNextCounterId()); // Help with debuggability.
	
	    if (styleSheet.options.classNamePrefix) {
	      return "".concat(seedPrefix).concat(styleSheet.options.classNamePrefix, "-").concat(suffix);
	    }
	
	    return "".concat(seedPrefix).concat(suffix);
	  };
	}

/***/ },
/* 795 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createStyles;
	
	function createStyles(styles) {
	  return styles;
	}

/***/ },
/* 796 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _createStyles.default;
	  }
	});
	
	var _createStyles = _interopRequireDefault(__webpack_require__(795));

/***/ },
/* 797 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getStylesCreator;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _typeof2 = _interopRequireDefault(__webpack_require__(56));
	
	var _utils = __webpack_require__(26);
	
	var _noopTheme = _interopRequireDefault(__webpack_require__(335));
	
	function getStylesCreator(stylesOrCreator) {
	  var themingEnabled = typeof stylesOrCreator === 'function';
	
	  if (false) {
	    if ((0, _typeof2.default)(stylesOrCreator) !== 'object' && !themingEnabled) {
	      console.error(['Material-UI: The `styles` argument provided is invalid.', 'You need to provide a function generating the styles or a styles object.'].join('\n'));
	    }
	  }
	
	  return {
	    create: function create(theme, name) {
	      var styles;
	
	      try {
	        styles = themingEnabled ? stylesOrCreator(theme) : stylesOrCreator;
	      } catch (err) {
	        if (false) {
	          if (themingEnabled === true && theme === _noopTheme.default) {
	            // TODO: prepend error message/name instead
	            console.error(['Material-UI: The `styles` argument provided is invalid.', 'You are providing a function without a theme in the context.', 'One of the parent elements needs to use a ThemeProvider.'].join('\n'));
	          }
	        }
	
	        throw err;
	      }
	
	      if (!name || !theme.overrides || !theme.overrides[name]) {
	        return styles;
	      }
	
	      var overrides = theme.overrides[name];
	      var stylesWithOverrides = (0, _extends2.default)({}, styles);
	      Object.keys(overrides).forEach(function (key) {
	        if (false) {
	          if (!stylesWithOverrides[key]) {
	            console.warn(['Material-UI: You are trying to override a style that does not exist.', "Fix the `".concat(key, "` key of `theme.overrides.").concat(name, "`.")].join('\n'));
	          }
	        }
	
	        stylesWithOverrides[key] = (0, _utils.deepmerge)(stylesWithOverrides[key], overrides[key]);
	      });
	      return stylesWithOverrides;
	    },
	    options: {}
	  };
	}

/***/ },
/* 798 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _getStylesCreator.default;
	  }
	});
	
	var _getStylesCreator = _interopRequireDefault(__webpack_require__(797));

/***/ },
/* 799 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getThemeProps;
	
	/* eslint-disable no-restricted-syntax */
	function getThemeProps(params) {
	  var theme = params.theme,
	      name = params.name,
	      props = params.props;
	
	  if (!theme || !theme.props || !theme.props[name]) {
	    return props;
	  } // Resolve default props, code borrow from React source.
	  // https://github.com/facebook/react/blob/15a8f031838a553e41c0b66eb1bcf1da8448104d/packages/react/src/ReactElement.js#L221
	
	
	  var defaultProps = theme.props[name];
	  var propName;
	
	  for (propName in defaultProps) {
	    if (props[propName] === undefined) {
	      props[propName] = defaultProps[propName];
	    }
	  }
	
	  return props;
	}

/***/ },
/* 800 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = jssPreset;
	
	var _jssPluginRuleValueFunction = _interopRequireDefault(__webpack_require__(1321));
	
	var _jssPluginGlobal = _interopRequireDefault(__webpack_require__(1318));
	
	var _jssPluginNested = _interopRequireDefault(__webpack_require__(1319));
	
	var _jssPluginCamelCase = _interopRequireDefault(__webpack_require__(1316));
	
	var _jssPluginDefaultUnit = _interopRequireDefault(__webpack_require__(1317));
	
	var _jssPluginVendorPrefixer = _interopRequireDefault(__webpack_require__(1322));
	
	var _jssPluginPropsSort = _interopRequireDefault(__webpack_require__(1320));
	
	// Subset of jss-preset-default with only the plugins the Material-UI components are using.
	function jssPreset() {
	  return {
	    plugins: [(0, _jssPluginRuleValueFunction.default)(), (0, _jssPluginGlobal.default)(), (0, _jssPluginNested.default)(), (0, _jssPluginCamelCase.default)(), (0, _jssPluginDefaultUnit.default)(), // Disable the vendor prefixer server-side, it does nothing.
	    // This way, we can get a performance boost.
	    // In the documentation, we are using `autoprefixer` to solve this problem.
	    typeof window === 'undefined' ? null : (0, _jssPluginVendorPrefixer.default)(), (0, _jssPluginPropsSort.default)()]
	  };
	}

/***/ },
/* 801 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.increment = increment;
	
	/* eslint-disable import/prefer-default-export */
	// Global index counter to preserve source order.
	// We create the style sheet during the creation of the component,
	// children are handled after the parents, so the order of style elements would be parent->child.
	// It is a problem though when a parent passes a className
	// which needs to override any child's styles.
	// StyleSheet of the child has a higher specificity, because of the source order.
	// So our solution is to render sheets them in the reverse order child->sheet, so
	// that parent has a higher specificity.
	var indexCounter = -1e9;
	
	function increment() {
	  indexCounter += 1;
	
	  if (false) {
	    if (indexCounter >= 0) {
	      console.warn(['Material-UI: You might have a memory leak.', 'The indexCounter is not supposed to grow that much.'].join('\n'));
	    }
	  }
	
	  return indexCounter;
	}

/***/ },
/* 802 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = makeStyles;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(25));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _jss = __webpack_require__(110);
	
	var _mergeClasses = _interopRequireDefault(__webpack_require__(338));
	
	var _multiKeyStore = _interopRequireDefault(__webpack_require__(803));
	
	var _useTheme = _interopRequireDefault(__webpack_require__(144));
	
	var _StylesProvider = __webpack_require__(239);
	
	var _indexCounter = __webpack_require__(801);
	
	var _getStylesCreator = _interopRequireDefault(__webpack_require__(798));
	
	var _noopTheme = _interopRequireDefault(__webpack_require__(335));
	
	function getClasses(_ref, classes, Component) {
	  var state = _ref.state,
	      stylesOptions = _ref.stylesOptions;
	
	  if (stylesOptions.disableGeneration) {
	    return classes || {};
	  }
	
	  if (!state.cacheClasses) {
	    state.cacheClasses = {
	      // Cache for the finalized classes value.
	      value: null,
	      // Cache for the last used classes prop pointer.
	      lastProp: null,
	      // Cache for the last used rendered classes pointer.
	      lastJSS: {}
	    };
	  } // Tracks if either the rendered classes or classes prop has changed,
	  // requiring the generation of a new finalized classes object.
	
	
	  var generate = false;
	
	  if (state.classes !== state.cacheClasses.lastJSS) {
	    state.cacheClasses.lastJSS = state.classes;
	    generate = true;
	  }
	
	  if (classes !== state.cacheClasses.lastProp) {
	    state.cacheClasses.lastProp = classes;
	    generate = true;
	  }
	
	  if (generate) {
	    state.cacheClasses.value = (0, _mergeClasses.default)({
	      baseClasses: state.cacheClasses.lastJSS,
	      newClasses: classes,
	      Component: Component
	    });
	  }
	
	  return state.cacheClasses.value;
	}
	
	function attach(_ref2, props) {
	  var state = _ref2.state,
	      theme = _ref2.theme,
	      stylesOptions = _ref2.stylesOptions,
	      stylesCreator = _ref2.stylesCreator,
	      name = _ref2.name;
	
	  if (stylesOptions.disableGeneration) {
	    return;
	  }
	
	  var sheetManager = _multiKeyStore.default.get(stylesOptions.sheetsManager, stylesCreator, theme);
	
	  if (!sheetManager) {
	    sheetManager = {
	      refs: 0,
	      staticSheet: null,
	      dynamicStyles: null
	    };
	
	    _multiKeyStore.default.set(stylesOptions.sheetsManager, stylesCreator, theme, sheetManager);
	  }
	
	  var options = (0, _extends2.default)({}, stylesCreator.options, stylesOptions, {
	    theme: theme,
	    flip: typeof stylesOptions.flip === 'boolean' ? stylesOptions.flip : theme.direction === 'rtl'
	  });
	  options.generateId = options.serverGenerateClassName || options.generateClassName;
	  var sheetsRegistry = stylesOptions.sheetsRegistry;
	
	  if (sheetManager.refs === 0) {
	    var staticSheet;
	
	    if (stylesOptions.sheetsCache) {
	      staticSheet = _multiKeyStore.default.get(stylesOptions.sheetsCache, stylesCreator, theme);
	    }
	
	    var styles = stylesCreator.create(theme, name);
	
	    if (!staticSheet) {
	      staticSheet = stylesOptions.jss.createStyleSheet(styles, (0, _extends2.default)({
	        link: false
	      }, options));
	      staticSheet.attach();
	
	      if (stylesOptions.sheetsCache) {
	        _multiKeyStore.default.set(stylesOptions.sheetsCache, stylesCreator, theme, staticSheet);
	      }
	    }
	
	    if (sheetsRegistry) {
	      sheetsRegistry.add(staticSheet);
	    }
	
	    sheetManager.staticSheet = staticSheet;
	    sheetManager.dynamicStyles = (0, _jss.getDynamicStyles)(styles);
	  }
	
	  if (sheetManager.dynamicStyles) {
	    var dynamicSheet = stylesOptions.jss.createStyleSheet(sheetManager.dynamicStyles, (0, _extends2.default)({
	      link: true
	    }, options));
	    dynamicSheet.update(props);
	    dynamicSheet.attach();
	    state.dynamicSheet = dynamicSheet;
	    state.classes = (0, _mergeClasses.default)({
	      baseClasses: sheetManager.staticSheet.classes,
	      newClasses: dynamicSheet.classes
	    });
	
	    if (sheetsRegistry) {
	      sheetsRegistry.add(dynamicSheet);
	    }
	  } else {
	    state.classes = sheetManager.staticSheet.classes;
	  }
	
	  sheetManager.refs += 1;
	}
	
	function update(_ref3, props) {
	  var state = _ref3.state;
	
	  if (state.dynamicSheet) {
	    state.dynamicSheet.update(props);
	  }
	}
	
	function detach(_ref4) {
	  var state = _ref4.state,
	      theme = _ref4.theme,
	      stylesOptions = _ref4.stylesOptions,
	      stylesCreator = _ref4.stylesCreator;
	
	  if (stylesOptions.disableGeneration) {
	    return;
	  }
	
	  var sheetManager = _multiKeyStore.default.get(stylesOptions.sheetsManager, stylesCreator, theme);
	
	  sheetManager.refs -= 1;
	  var sheetsRegistry = stylesOptions.sheetsRegistry;
	
	  if (sheetManager.refs === 0) {
	    _multiKeyStore.default.delete(stylesOptions.sheetsManager, stylesCreator, theme);
	
	    stylesOptions.jss.removeStyleSheet(sheetManager.staticSheet);
	
	    if (sheetsRegistry) {
	      sheetsRegistry.remove(sheetManager.staticSheet);
	    }
	  }
	
	  if (state.dynamicSheet) {
	    stylesOptions.jss.removeStyleSheet(state.dynamicSheet);
	
	    if (sheetsRegistry) {
	      sheetsRegistry.remove(state.dynamicSheet);
	    }
	  }
	}
	
	function useSynchronousEffect(func, values) {
	  var key = _react.default.useRef([]);
	
	  var output; // Store "generation" key. Just returns a new object every time
	
	  var currentKey = _react.default.useMemo(function () {
	    return {};
	  }, values); // eslint-disable-line react-hooks/exhaustive-deps
	  // "the first render", or "memo dropped the value"
	
	
	  if (key.current !== currentKey) {
	    key.current = currentKey;
	    output = func();
	  }
	
	  _react.default.useEffect(function () {
	    return function () {
	      if (output) {
	        output();
	      }
	    };
	  }, [currentKey] // eslint-disable-line react-hooks/exhaustive-deps
	  );
	}
	
	function makeStyles(stylesOrCreator) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var name = options.name,
	      classNamePrefixOption = options.classNamePrefix,
	      Component = options.Component,
	      _options$defaultTheme = options.defaultTheme,
	      defaultTheme = _options$defaultTheme === void 0 ? _noopTheme.default : _options$defaultTheme,
	      stylesOptions2 = (0, _objectWithoutProperties2.default)(options, ["name", "classNamePrefix", "Component", "defaultTheme"]);
	  var stylesCreator = (0, _getStylesCreator.default)(stylesOrCreator);
	  var classNamePrefix = name || classNamePrefixOption || 'makeStyles';
	  stylesCreator.options = {
	    index: (0, _indexCounter.increment)(),
	    name: name,
	    meta: classNamePrefix,
	    classNamePrefix: classNamePrefix
	  };
	
	  var useStyles = function useStyles() {
	    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var theme = (0, _useTheme.default)() || defaultTheme;
	    var stylesOptions = (0, _extends2.default)({}, _react.default.useContext(_StylesProvider.StylesContext), stylesOptions2);
	
	    var instance = _react.default.useRef();
	
	    var shouldUpdate = _react.default.useRef();
	
	    useSynchronousEffect(function () {
	      var current = {
	        name: name,
	        state: {},
	        stylesCreator: stylesCreator,
	        stylesOptions: stylesOptions,
	        theme: theme
	      };
	      attach(current, props);
	      shouldUpdate.current = false;
	      instance.current = current;
	      return function () {
	        detach(current);
	      };
	    }, [theme, stylesCreator]);
	
	    _react.default.useEffect(function () {
	      if (shouldUpdate.current) {
	        update(instance.current, props);
	      }
	
	      shouldUpdate.current = true;
	    });
	
	    var classes = getClasses(instance.current, props.classes, Component);
	
	    if (false) {
	      // eslint-disable-next-line react-hooks/rules-of-hooks
	      _react.default.useDebugValue(classes);
	    }
	
	    return classes;
	  };
	
	  return useStyles;
	}

/***/ },
/* 803 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	// Used https://github.com/thinkloop/multi-key-cache as inspiration
	var multiKeyStore = {
	  set: function set(cache, key1, key2, value) {
	    var subCache = cache.get(key1);
	
	    if (!subCache) {
	      subCache = new Map();
	      cache.set(key1, subCache);
	    }
	
	    subCache.set(key2, value);
	  },
	  get: function get(cache, key1, key2) {
	    var subCache = cache.get(key1);
	    return subCache ? subCache.get(key2) : undefined;
	  },
	  delete: function _delete(cache, key1, key2) {
	    var subCache = cache.get(key1);
	    subCache.delete(key2);
	  }
	};
	var _default = multiKeyStore;
	exports.default = _default;

/***/ },
/* 804 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = mergeClasses;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _utils = __webpack_require__(26);
	
	function mergeClasses() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var baseClasses = options.baseClasses,
	      newClasses = options.newClasses,
	      Component = options.Component;
	
	  if (!newClasses) {
	    return baseClasses;
	  }
	
	  var nextClasses = (0, _extends2.default)({}, baseClasses);
	
	  if (false) {
	    if (typeof newClasses === 'string') {
	      console.error(["Material-UI: The value `".concat(newClasses, "` ") + "provided to the classes prop of ".concat((0, _utils.getDisplayName)(Component), " is incorrect."), 'You might want to use the className prop instead.'].join('\n'));
	      return baseClasses;
	    }
	  }
	
	  Object.keys(newClasses).forEach(function (key) {
	    if (false) {
	      if (!baseClasses[key] && newClasses[key]) {
	        console.error(["Material-UI: The key `".concat(key, "` ") + "provided to the classes prop is not implemented in ".concat((0, _utils.getDisplayName)(Component), "."), "You can only override one of the following: ".concat(Object.keys(baseClasses).join(','), ".")].join('\n'));
	      }
	
	      if (newClasses[key] && typeof newClasses[key] !== 'string') {
	        console.error(["Material-UI: The key `".concat(key, "` ") + "provided to the classes prop is not valid for ".concat((0, _utils.getDisplayName)(Component), "."), "You need to provide a non empty string instead of: ".concat(newClasses[key], ".")].join('\n'));
	      }
	    }
	
	    if (newClasses[key]) {
	      nextClasses[key] = "".concat(baseClasses[key], " ").concat(newClasses[key]);
	    }
	  });
	  return nextClasses;
	}

/***/ },
/* 805 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _styled.default;
	  }
	});
	
	var _styled = _interopRequireDefault(__webpack_require__(806));

/***/ },
/* 806 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = styled;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(25));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _clsx = _interopRequireDefault(__webpack_require__(37));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(26);
	
	var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(157));
	
	var _makeStyles = _interopRequireDefault(__webpack_require__(241));
	
	function omit(input, fields) {
	  var output = {};
	  Object.keys(input).forEach(function (prop) {
	    if (fields.indexOf(prop) === -1) {
	      output[prop] = input[prop];
	    }
	  });
	  return output;
	} // styled-components's API removes the mapping between components and styles.
	// Using components as a low-level styling construct can be simpler.
	
	
	function styled(Component) {
	  var componentCreator = function componentCreator(style) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var name = options.name,
	        stylesOptions = (0, _objectWithoutProperties2.default)(options, ["name"]);
	
	    if (false) {
	      throw new Error(['You are calling styled(Component)(style) with an undefined component.', 'You may have forgotten to import it.'].join('\n'));
	    }
	
	    var classNamePrefix = name;
	
	    if (false) {
	      if (!name) {
	        // Provide a better DX outside production.
	        var displayName = (0, _utils.getDisplayName)(Component);
	
	        if (displayName !== undefined) {
	          classNamePrefix = displayName;
	        }
	      }
	    }
	
	    var stylesOrCreator = typeof style === 'function' ? function (theme) {
	      return {
	        root: function root(props) {
	          return style((0, _extends2.default)({
	            theme: theme
	          }, props));
	        }
	      };
	    } : {
	      root: style
	    };
	    var useStyles = (0, _makeStyles.default)(stylesOrCreator, (0, _extends2.default)({
	      Component: Component,
	      name: name || Component.displayName,
	      classNamePrefix: classNamePrefix
	    }, stylesOptions));
	    var filterProps;
	    var propTypes = {};
	
	    if (style.filterProps) {
	      filterProps = style.filterProps;
	      delete style.filterProps;
	    }
	    /* eslint-disable react/forbid-foreign-prop-types */
	
	
	    if (style.propTypes) {
	      propTypes = style.propTypes;
	      delete style.propTypes;
	    }
	    /* eslint-enable react/forbid-foreign-prop-types */
	
	
	    var StyledComponent = /*#__PURE__*/_react.default.forwardRef(function StyledComponent(props, ref) {
	      var children = props.children,
	          classNameProp = props.className,
	          clone = props.clone,
	          ComponentProp = props.component,
	          other = (0, _objectWithoutProperties2.default)(props, ["children", "className", "clone", "component"]);
	      var classes = useStyles(props);
	      var className = (0, _clsx.default)(classes.root, classNameProp);
	      var spread = other;
	
	      if (filterProps) {
	        spread = omit(spread, filterProps);
	      }
	
	      if (clone) {
	        return /*#__PURE__*/_react.default.cloneElement(children, (0, _extends2.default)({
	          className: (0, _clsx.default)(children.props.className, className)
	        }, spread));
	      }
	
	      if (typeof children === 'function') {
	        return children((0, _extends2.default)({
	          className: className
	        }, spread));
	      }
	
	      var FinalComponent = ComponentProp || Component;
	      return /*#__PURE__*/_react.default.createElement(FinalComponent, (0, _extends2.default)({
	        ref: ref,
	        className: className
	      }, spread), children);
	    });
	
	     false ? StyledComponent.propTypes = (0, _extends2.default)({
	      /**
	       * A render function or node.
	       */
	      children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.func]),
	
	      /**
	       * @ignore
	       */
	      className: _propTypes.default.string,
	
	      /**
	       * If `true`, the component will recycle it's children HTML element.
	       * It's using `React.cloneElement` internally.
	       *
	       * This prop will be deprecated and removed in v5
	       */
	      clone: (0, _utils.chainPropTypes)(_propTypes.default.bool, function (props) {
	        if (props.clone && props.component) {
	          return new Error('You can not use the clone and component prop at the same time.');
	        }
	
	        return null;
	      }),
	
	      /**
	       * The component used for the root node.
	       * Either a string to use a HTML element or a component.
	       */
	      component: _propTypes.default
	      /* @typescript-to-proptypes-ignore */
	      .elementType
	    }, propTypes) : void 0;
	
	    if (false) {
	      StyledComponent.displayName = "Styled(".concat(classNamePrefix, ")");
	    }
	
	    (0, _hoistNonReactStatics.default)(StyledComponent, Component);
	    return StyledComponent;
	  };
	
	  return componentCreator;
	}

/***/ },
/* 807 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = useTheme;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _ThemeContext = _interopRequireDefault(__webpack_require__(339));
	
	function useTheme() {
	  var theme = _react.default.useContext(_ThemeContext.default);
	
	  if (false) {
	    // eslint-disable-next-line react-hooks/rules-of-hooks
	    _react.default.useDebugValue(theme);
	  }
	
	  return theme;
	}

/***/ },
/* 808 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _withStyles.default;
	  }
	});
	
	var _withStyles = _interopRequireDefault(__webpack_require__(809));

/***/ },
/* 809 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(25));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(157));
	
	var _utils = __webpack_require__(26);
	
	var _makeStyles = _interopRequireDefault(__webpack_require__(241));
	
	var _getThemeProps = _interopRequireDefault(__webpack_require__(336));
	
	var _useTheme = _interopRequireDefault(__webpack_require__(144));
	
	// Link a style sheet with a component.
	// It does not modify the component passed to it;
	// instead, it returns a new component, with a `classes` property.
	var withStyles = function withStyles(stylesOrCreator) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  return function (Component) {
	    var defaultTheme = options.defaultTheme,
	        _options$withTheme = options.withTheme,
	        withTheme = _options$withTheme === void 0 ? false : _options$withTheme,
	        name = options.name,
	        stylesOptions = (0, _objectWithoutProperties2.default)(options, ["defaultTheme", "withTheme", "name"]);
	
	    if (false) {
	      if (Component === undefined) {
	        throw new Error(['You are calling withStyles(styles)(Component) with an undefined component.', 'You may have forgotten to import it.'].join('\n'));
	      }
	    }
	
	    var classNamePrefix = name;
	
	    if (false) {
	      if (!name) {
	        // Provide a better DX outside production.
	        var displayName = (0, _utils.getDisplayName)(Component);
	
	        if (displayName !== undefined) {
	          classNamePrefix = displayName;
	        }
	      }
	    }
	
	    var useStyles = (0, _makeStyles.default)(stylesOrCreator, (0, _extends2.default)({
	      defaultTheme: defaultTheme,
	      Component: Component,
	      name: name || Component.displayName,
	      classNamePrefix: classNamePrefix
	    }, stylesOptions));
	
	    var WithStyles = /*#__PURE__*/_react.default.forwardRef(function WithStyles(props, ref) {
	      var classesProp = props.classes,
	          innerRef = props.innerRef,
	          other = (0, _objectWithoutProperties2.default)(props, ["classes", "innerRef"]); // The wrapper receives only user supplied props, which could be a subset of
	      // the actual props Component might receive due to merging with defaultProps.
	      // So copying it here would give us the same result in the wrapper as well.
	
	      var classes = useStyles((0, _extends2.default)({}, Component.defaultProps, props));
	      var theme;
	      var more = other;
	
	      if (typeof name === 'string' || withTheme) {
	        // name and withTheme are invariant in the outer scope
	        // eslint-disable-next-line react-hooks/rules-of-hooks
	        theme = (0, _useTheme.default)() || defaultTheme;
	
	        if (name) {
	          more = (0, _getThemeProps.default)({
	            theme: theme,
	            name: name,
	            props: other
	          });
	        } // Provide the theme to the wrapped component.
	        // So we don't have to use the `withTheme()` Higher-order Component.
	
	
	        if (withTheme && !more.theme) {
	          more.theme = theme;
	        }
	      }
	
	      return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({
	        ref: innerRef || ref,
	        classes: classes
	      }, more));
	    });
	
	     false ? WithStyles.propTypes = {
	      /**
	       * Override or extend the styles applied to the component.
	       */
	      classes: _propTypes.default.object,
	
	      /**
	       * Use that prop to pass a ref to the decorated component.
	       * @deprecated
	       */
	      innerRef: (0, _utils.chainPropTypes)(_propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]), function (props) {
	        if (props.innerRef == null) {
	          return null;
	        }
	
	        return null; // return new Error(
	        //   'Material-UI: The `innerRef` prop is deprecated and will be removed in v5. ' +
	        //     'Refs are now automatically forwarded to the inner component.',
	        // );
	      })
	    } : void 0;
	
	    if (false) {
	      WithStyles.displayName = "WithStyles(".concat((0, _utils.getDisplayName)(Component), ")");
	    }
	
	    (0, _hoistNonReactStatics.default)(WithStyles, Component);
	
	    if (false) {
	      // Exposed for test purposes.
	      WithStyles.Naked = Component;
	      WithStyles.options = options;
	      WithStyles.useStyles = useStyles;
	    }
	
	    return WithStyles;
	  };
	};
	
	var _default = withStyles;
	exports.default = _default;

/***/ },
/* 810 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var _exportNames = {};
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _withTheme.default;
	  }
	});
	
	var _withTheme = _interopRequireWildcard(__webpack_require__(811));
	
	Object.keys(_withTheme).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _withTheme[key];
	    }
	  });
	});

/***/ },
/* 811 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.withThemeCreator = withThemeCreator;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(25));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(157));
	
	var _utils = __webpack_require__(26);
	
	var _useTheme = _interopRequireDefault(__webpack_require__(144));
	
	function withThemeCreator() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var defaultTheme = options.defaultTheme;
	
	  var withTheme = function withTheme(Component) {
	    if (false) {
	      if (Component === undefined) {
	        throw new Error(['You are calling withTheme(Component) with an undefined component.', 'You may have forgotten to import it.'].join('\n'));
	      }
	    }
	
	    var WithTheme = /*#__PURE__*/_react.default.forwardRef(function WithTheme(props, ref) {
	      var innerRef = props.innerRef,
	          other = (0, _objectWithoutProperties2.default)(props, ["innerRef"]);
	      var theme = (0, _useTheme.default)() || defaultTheme;
	      return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({
	        theme: theme,
	        ref: innerRef || ref
	      }, other));
	    });
	
	     false ? WithTheme.propTypes = {
	      /**
	       * Use that prop to pass a ref to the decorated component.
	       * @deprecated
	       */
	      innerRef: (0, _utils.chainPropTypes)(_propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]), function (props) {
	        if (props.innerRef == null) {
	          return null;
	        }
	
	        return new Error('Material-UI: The `innerRef` prop is deprecated and will be removed in v5. ' + 'Refs are now automatically forwarded to the inner component.');
	      })
	    } : void 0;
	
	    if (false) {
	      WithTheme.displayName = "WithTheme(".concat((0, _utils.getDisplayName)(Component), ")");
	    }
	
	    (0, _hoistNonReactStatics.default)(WithTheme, Component);
	
	    if (false) {
	      // Exposed for test purposes.
	      WithTheme.Naked = Component;
	    }
	
	    return WithTheme;
	  };
	
	  return withTheme;
	} // Provide the theme object as a prop to the input component.
	// It's an alternative API to useTheme().
	// We encourage the usage of useTheme() where possible.
	
	
	var withTheme = withThemeCreator();
	var _default = withTheme;
	exports.default = _default;

/***/ },
/* 812 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.borderRadius = exports.borderColor = exports.borderLeft = exports.borderBottom = exports.borderRight = exports.borderTop = exports.border = void 0;
	
	var _style = _interopRequireDefault(__webpack_require__(81));
	
	var _compose = _interopRequireDefault(__webpack_require__(88));
	
	function getBorder(value) {
	  if (typeof value !== 'number') {
	    return value;
	  }
	
	  return "".concat(value, "px solid");
	}
	
	var border = (0, _style.default)({
	  prop: 'border',
	  themeKey: 'borders',
	  transform: getBorder
	});
	exports.border = border;
	var borderTop = (0, _style.default)({
	  prop: 'borderTop',
	  themeKey: 'borders',
	  transform: getBorder
	});
	exports.borderTop = borderTop;
	var borderRight = (0, _style.default)({
	  prop: 'borderRight',
	  themeKey: 'borders',
	  transform: getBorder
	});
	exports.borderRight = borderRight;
	var borderBottom = (0, _style.default)({
	  prop: 'borderBottom',
	  themeKey: 'borders',
	  transform: getBorder
	});
	exports.borderBottom = borderBottom;
	var borderLeft = (0, _style.default)({
	  prop: 'borderLeft',
	  themeKey: 'borders',
	  transform: getBorder
	});
	exports.borderLeft = borderLeft;
	var borderColor = (0, _style.default)({
	  prop: 'borderColor',
	  themeKey: 'palette'
	});
	exports.borderColor = borderColor;
	var borderRadius = (0, _style.default)({
	  prop: 'borderRadius',
	  themeKey: 'shape'
	});
	exports.borderRadius = borderRadius;
	var borders = (0, _compose.default)(border, borderTop, borderRight, borderBottom, borderLeft, borderColor, borderRadius);
	var _default = borders;
	exports.default = _default;

/***/ },
/* 813 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.whiteSpace = exports.visibility = exports.textOverflow = exports.overflow = exports.displayRaw = exports.displayPrint = void 0;
	
	var _style = _interopRequireDefault(__webpack_require__(81));
	
	var _compose = _interopRequireDefault(__webpack_require__(88));
	
	var displayPrint = (0, _style.default)({
	  prop: 'displayPrint',
	  cssProperty: false,
	  transform: function transform(value) {
	    return {
	      '@media print': {
	        display: value
	      }
	    };
	  }
	});
	exports.displayPrint = displayPrint;
	var displayRaw = (0, _style.default)({
	  prop: 'display'
	});
	exports.displayRaw = displayRaw;
	var overflow = (0, _style.default)({
	  prop: 'overflow'
	});
	exports.overflow = overflow;
	var textOverflow = (0, _style.default)({
	  prop: 'textOverflow'
	});
	exports.textOverflow = textOverflow;
	var visibility = (0, _style.default)({
	  prop: 'visibility'
	});
	exports.visibility = visibility;
	var whiteSpace = (0, _style.default)({
	  prop: 'whiteSpace'
	});
	exports.whiteSpace = whiteSpace;
	
	var _default = (0, _compose.default)(displayPrint, displayRaw, overflow, textOverflow, visibility, whiteSpace);
	
	exports.default = _default;

/***/ },
/* 814 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.justifySelf = exports.justifyItems = exports.alignSelf = exports.flexShrink = exports.flexGrow = exports.flex = exports.order = exports.alignContent = exports.alignItems = exports.justifyContent = exports.flexWrap = exports.flexDirection = exports.flexBasis = void 0;
	
	var _style = _interopRequireDefault(__webpack_require__(81));
	
	var _compose = _interopRequireDefault(__webpack_require__(88));
	
	var flexBasis = (0, _style.default)({
	  prop: 'flexBasis'
	});
	exports.flexBasis = flexBasis;
	var flexDirection = (0, _style.default)({
	  prop: 'flexDirection'
	});
	exports.flexDirection = flexDirection;
	var flexWrap = (0, _style.default)({
	  prop: 'flexWrap'
	});
	exports.flexWrap = flexWrap;
	var justifyContent = (0, _style.default)({
	  prop: 'justifyContent'
	});
	exports.justifyContent = justifyContent;
	var alignItems = (0, _style.default)({
	  prop: 'alignItems'
	});
	exports.alignItems = alignItems;
	var alignContent = (0, _style.default)({
	  prop: 'alignContent'
	});
	exports.alignContent = alignContent;
	var order = (0, _style.default)({
	  prop: 'order'
	});
	exports.order = order;
	var flex = (0, _style.default)({
	  prop: 'flex'
	});
	exports.flex = flex;
	var flexGrow = (0, _style.default)({
	  prop: 'flexGrow'
	});
	exports.flexGrow = flexGrow;
	var flexShrink = (0, _style.default)({
	  prop: 'flexShrink'
	});
	exports.flexShrink = flexShrink;
	var alignSelf = (0, _style.default)({
	  prop: 'alignSelf'
	});
	exports.alignSelf = alignSelf;
	var justifyItems = (0, _style.default)({
	  prop: 'justifyItems'
	});
	exports.justifyItems = justifyItems;
	var justifySelf = (0, _style.default)({
	  prop: 'justifySelf'
	});
	exports.justifySelf = justifySelf;
	var flexbox = (0, _compose.default)(flexBasis, flexDirection, flexWrap, justifyContent, alignItems, alignContent, order, flex, flexGrow, flexShrink, alignSelf, justifyItems, justifySelf);
	var _default = flexbox;
	exports.default = _default;

/***/ },
/* 815 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.gridArea = exports.gridTemplateAreas = exports.gridTemplateRows = exports.gridTemplateColumns = exports.gridAutoRows = exports.gridAutoColumns = exports.gridAutoFlow = exports.gridRow = exports.gridColumn = exports.gridRowGap = exports.gridColumnGap = exports.gridGap = void 0;
	
	var _style = _interopRequireDefault(__webpack_require__(81));
	
	var _compose = _interopRequireDefault(__webpack_require__(88));
	
	var gridGap = (0, _style.default)({
	  prop: 'gridGap'
	});
	exports.gridGap = gridGap;
	var gridColumnGap = (0, _style.default)({
	  prop: 'gridColumnGap'
	});
	exports.gridColumnGap = gridColumnGap;
	var gridRowGap = (0, _style.default)({
	  prop: 'gridRowGap'
	});
	exports.gridRowGap = gridRowGap;
	var gridColumn = (0, _style.default)({
	  prop: 'gridColumn'
	});
	exports.gridColumn = gridColumn;
	var gridRow = (0, _style.default)({
	  prop: 'gridRow'
	});
	exports.gridRow = gridRow;
	var gridAutoFlow = (0, _style.default)({
	  prop: 'gridAutoFlow'
	});
	exports.gridAutoFlow = gridAutoFlow;
	var gridAutoColumns = (0, _style.default)({
	  prop: 'gridAutoColumns'
	});
	exports.gridAutoColumns = gridAutoColumns;
	var gridAutoRows = (0, _style.default)({
	  prop: 'gridAutoRows'
	});
	exports.gridAutoRows = gridAutoRows;
	var gridTemplateColumns = (0, _style.default)({
	  prop: 'gridTemplateColumns'
	});
	exports.gridTemplateColumns = gridTemplateColumns;
	var gridTemplateRows = (0, _style.default)({
	  prop: 'gridTemplateRows'
	});
	exports.gridTemplateRows = gridTemplateRows;
	var gridTemplateAreas = (0, _style.default)({
	  prop: 'gridTemplateAreas'
	});
	exports.gridTemplateAreas = gridTemplateAreas;
	var gridArea = (0, _style.default)({
	  prop: 'gridArea'
	});
	exports.gridArea = gridArea;
	var grid = (0, _compose.default)(gridGap, gridColumnGap, gridRowGap, gridColumn, gridRow, gridAutoFlow, gridAutoColumns, gridAutoRows, gridTemplateColumns, gridTemplateRows, gridTemplateAreas, gridArea);
	var _default = grid;
	exports.default = _default;

/***/ },
/* 816 */
/***/ function(module, exports, __webpack_require__) {

	/** @license Material-UI v4.12.2
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var _exportNames = {
	  borders: true,
	  breakpoints: true,
	  compose: true,
	  styleFunctionSx: true,
	  display: true,
	  flexbox: true,
	  grid: true,
	  palette: true,
	  positions: true,
	  shadows: true,
	  sizing: true,
	  spacing: true,
	  style: true,
	  typography: true
	};
	Object.defineProperty(exports, "borders", {
	  enumerable: true,
	  get: function get() {
	    return _borders.default;
	  }
	});
	Object.defineProperty(exports, "breakpoints", {
	  enumerable: true,
	  get: function get() {
	    return _breakpoints.default;
	  }
	});
	Object.defineProperty(exports, "compose", {
	  enumerable: true,
	  get: function get() {
	    return _compose.default;
	  }
	});
	Object.defineProperty(exports, "styleFunctionSx", {
	  enumerable: true,
	  get: function get() {
	    return _styleFunctionSx.default;
	  }
	});
	Object.defineProperty(exports, "display", {
	  enumerable: true,
	  get: function get() {
	    return _display.default;
	  }
	});
	Object.defineProperty(exports, "flexbox", {
	  enumerable: true,
	  get: function get() {
	    return _flexbox.default;
	  }
	});
	Object.defineProperty(exports, "grid", {
	  enumerable: true,
	  get: function get() {
	    return _grid.default;
	  }
	});
	Object.defineProperty(exports, "palette", {
	  enumerable: true,
	  get: function get() {
	    return _palette.default;
	  }
	});
	Object.defineProperty(exports, "positions", {
	  enumerable: true,
	  get: function get() {
	    return _positions.default;
	  }
	});
	Object.defineProperty(exports, "shadows", {
	  enumerable: true,
	  get: function get() {
	    return _shadows.default;
	  }
	});
	Object.defineProperty(exports, "sizing", {
	  enumerable: true,
	  get: function get() {
	    return _sizing.default;
	  }
	});
	Object.defineProperty(exports, "spacing", {
	  enumerable: true,
	  get: function get() {
	    return _spacing.default;
	  }
	});
	Object.defineProperty(exports, "style", {
	  enumerable: true,
	  get: function get() {
	    return _style.default;
	  }
	});
	Object.defineProperty(exports, "typography", {
	  enumerable: true,
	  get: function get() {
	    return _typography.default;
	  }
	});
	
	var _borders = _interopRequireWildcard(__webpack_require__(812));
	
	Object.keys(_borders).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _borders[key];
	    }
	  });
	});
	
	var _breakpoints = _interopRequireDefault(__webpack_require__(242));
	
	var _compose = _interopRequireDefault(__webpack_require__(88));
	
	var _styleFunctionSx = _interopRequireWildcard(__webpack_require__(823));
	
	Object.keys(_styleFunctionSx).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _styleFunctionSx[key];
	    }
	  });
	});
	
	var _display = _interopRequireDefault(__webpack_require__(813));
	
	var _flexbox = _interopRequireWildcard(__webpack_require__(814));
	
	Object.keys(_flexbox).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _flexbox[key];
	    }
	  });
	});
	
	var _grid = _interopRequireWildcard(__webpack_require__(815));
	
	Object.keys(_grid).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _grid[key];
	    }
	  });
	});
	
	var _palette = _interopRequireWildcard(__webpack_require__(818));
	
	Object.keys(_palette).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _palette[key];
	    }
	  });
	});
	
	var _positions = _interopRequireWildcard(__webpack_require__(819));
	
	Object.keys(_positions).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _positions[key];
	    }
	  });
	});
	
	var _shadows = _interopRequireDefault(__webpack_require__(820));
	
	var _sizing = _interopRequireWildcard(__webpack_require__(821));
	
	Object.keys(_sizing).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _sizing[key];
	    }
	  });
	});
	
	var _spacing = _interopRequireWildcard(__webpack_require__(822));
	
	Object.keys(_spacing).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _spacing[key];
	    }
	  });
	});
	
	var _style = _interopRequireDefault(__webpack_require__(81));
	
	var _typography = _interopRequireWildcard(__webpack_require__(824));
	
	Object.keys(_typography).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _typography[key];
	    }
	  });
	});

/***/ },
/* 817 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = memoize;
	
	function memoize(fn) {
	  var cache = {};
	  return function (arg) {
	    if (cache[arg] === undefined) {
	      cache[arg] = fn(arg);
	    }
	
	    return cache[arg];
	  };
	}

/***/ },
/* 818 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.bgcolor = exports.color = void 0;
	
	var _style = _interopRequireDefault(__webpack_require__(81));
	
	var _compose = _interopRequireDefault(__webpack_require__(88));
	
	var color = (0, _style.default)({
	  prop: 'color',
	  themeKey: 'palette'
	});
	exports.color = color;
	var bgcolor = (0, _style.default)({
	  prop: 'bgcolor',
	  cssProperty: 'backgroundColor',
	  themeKey: 'palette'
	});
	exports.bgcolor = bgcolor;
	var palette = (0, _compose.default)(color, bgcolor);
	var _default = palette;
	exports.default = _default;

/***/ },
/* 819 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.left = exports.bottom = exports.right = exports.top = exports.zIndex = exports.position = void 0;
	
	var _style = _interopRequireDefault(__webpack_require__(81));
	
	var _compose = _interopRequireDefault(__webpack_require__(88));
	
	var position = (0, _style.default)({
	  prop: 'position'
	});
	exports.position = position;
	var zIndex = (0, _style.default)({
	  prop: 'zIndex',
	  themeKey: 'zIndex'
	});
	exports.zIndex = zIndex;
	var top = (0, _style.default)({
	  prop: 'top'
	});
	exports.top = top;
	var right = (0, _style.default)({
	  prop: 'right'
	});
	exports.right = right;
	var bottom = (0, _style.default)({
	  prop: 'bottom'
	});
	exports.bottom = bottom;
	var left = (0, _style.default)({
	  prop: 'left'
	});
	exports.left = left;
	
	var _default = (0, _compose.default)(position, zIndex, top, right, bottom, left);
	
	exports.default = _default;

/***/ },
/* 820 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _style = _interopRequireDefault(__webpack_require__(81));
	
	var boxShadow = (0, _style.default)({
	  prop: 'boxShadow',
	  themeKey: 'shadows'
	});
	var _default = boxShadow;
	exports.default = _default;

/***/ },
/* 821 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.boxSizing = exports.sizeHeight = exports.sizeWidth = exports.minHeight = exports.maxHeight = exports.height = exports.minWidth = exports.maxWidth = exports.width = void 0;
	
	var _style = _interopRequireDefault(__webpack_require__(81));
	
	var _compose = _interopRequireDefault(__webpack_require__(88));
	
	function transform(value) {
	  return value <= 1 ? "".concat(value * 100, "%") : value;
	}
	
	var width = (0, _style.default)({
	  prop: 'width',
	  transform: transform
	});
	exports.width = width;
	var maxWidth = (0, _style.default)({
	  prop: 'maxWidth',
	  transform: transform
	});
	exports.maxWidth = maxWidth;
	var minWidth = (0, _style.default)({
	  prop: 'minWidth',
	  transform: transform
	});
	exports.minWidth = minWidth;
	var height = (0, _style.default)({
	  prop: 'height',
	  transform: transform
	});
	exports.height = height;
	var maxHeight = (0, _style.default)({
	  prop: 'maxHeight',
	  transform: transform
	});
	exports.maxHeight = maxHeight;
	var minHeight = (0, _style.default)({
	  prop: 'minHeight',
	  transform: transform
	});
	exports.minHeight = minHeight;
	var sizeWidth = (0, _style.default)({
	  prop: 'size',
	  cssProperty: 'width',
	  transform: transform
	});
	exports.sizeWidth = sizeWidth;
	var sizeHeight = (0, _style.default)({
	  prop: 'size',
	  cssProperty: 'height',
	  transform: transform
	});
	exports.sizeHeight = sizeHeight;
	var boxSizing = (0, _style.default)({
	  prop: 'boxSizing'
	});
	exports.boxSizing = boxSizing;
	var sizing = (0, _compose.default)(width, maxWidth, minWidth, height, maxHeight, minHeight, boxSizing);
	var _default = sizing;
	exports.default = _default;

/***/ },
/* 822 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createUnarySpacing = createUnarySpacing;
	exports.default = void 0;
	
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(175));
	
	var _responsivePropType = _interopRequireDefault(__webpack_require__(340));
	
	var _breakpoints = __webpack_require__(242);
	
	var _merge = _interopRequireDefault(__webpack_require__(182));
	
	var _memoize = _interopRequireDefault(__webpack_require__(817));
	
	var properties = {
	  m: 'margin',
	  p: 'padding'
	};
	var directions = {
	  t: 'Top',
	  r: 'Right',
	  b: 'Bottom',
	  l: 'Left',
	  x: ['Left', 'Right'],
	  y: ['Top', 'Bottom']
	};
	var aliases = {
	  marginX: 'mx',
	  marginY: 'my',
	  paddingX: 'px',
	  paddingY: 'py'
	}; // memoize() impact:
	// From 300,000 ops/sec
	// To 350,000 ops/sec
	
	var getCssProperties = (0, _memoize.default)(function (prop) {
	  // It's not a shorthand notation.
	  if (prop.length > 2) {
	    if (aliases[prop]) {
	      prop = aliases[prop];
	    } else {
	      return [prop];
	    }
	  }
	
	  var _prop$split = prop.split(''),
	      _prop$split2 = (0, _slicedToArray2.default)(_prop$split, 2),
	      a = _prop$split2[0],
	      b = _prop$split2[1];
	
	  var property = properties[a];
	  var direction = directions[b] || '';
	  return Array.isArray(direction) ? direction.map(function (dir) {
	    return property + dir;
	  }) : [property + direction];
	});
	var spacingKeys = ['m', 'mt', 'mr', 'mb', 'ml', 'mx', 'my', 'p', 'pt', 'pr', 'pb', 'pl', 'px', 'py', 'margin', 'marginTop', 'marginRight', 'marginBottom', 'marginLeft', 'marginX', 'marginY', 'padding', 'paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft', 'paddingX', 'paddingY'];
	
	function createUnarySpacing(theme) {
	  var themeSpacing = theme.spacing || 8;
	
	  if (typeof themeSpacing === 'number') {
	    return function (abs) {
	      if (false) {
	        if (typeof abs !== 'number') {
	          console.error("Material-UI: Expected spacing argument to be a number, got ".concat(abs, "."));
	        }
	      }
	
	      return themeSpacing * abs;
	    };
	  }
	
	  if (Array.isArray(themeSpacing)) {
	    return function (abs) {
	      if (false) {
	        if (abs > themeSpacing.length - 1) {
	          console.error(["Material-UI: The value provided (".concat(abs, ") overflows."), "The supported values are: ".concat(JSON.stringify(themeSpacing), "."), "".concat(abs, " > ").concat(themeSpacing.length - 1, ", you need to add the missing values.")].join('\n'));
	        }
	      }
	
	      return themeSpacing[abs];
	    };
	  }
	
	  if (typeof themeSpacing === 'function') {
	    return themeSpacing;
	  }
	
	  if (false) {
	    console.error(["Material-UI: The `theme.spacing` value (".concat(themeSpacing, ") is invalid."), 'It should be a number, an array or a function.'].join('\n'));
	  }
	
	  return function () {
	    return undefined;
	  };
	}
	
	function getValue(transformer, propValue) {
	  if (typeof propValue === 'string' || propValue == null) {
	    return propValue;
	  }
	
	  var abs = Math.abs(propValue);
	  var transformed = transformer(abs);
	
	  if (propValue >= 0) {
	    return transformed;
	  }
	
	  if (typeof transformed === 'number') {
	    return -transformed;
	  }
	
	  return "-".concat(transformed);
	}
	
	function getStyleFromPropValue(cssProperties, transformer) {
	  return function (propValue) {
	    return cssProperties.reduce(function (acc, cssProperty) {
	      acc[cssProperty] = getValue(transformer, propValue);
	      return acc;
	    }, {});
	  };
	}
	
	function spacing(props) {
	  var theme = props.theme;
	  var transformer = createUnarySpacing(theme);
	  return Object.keys(props).map(function (prop) {
	    // Using a hash computation over an array iteration could be faster, but with only 28 items,
	    // it's doesn't worth the bundle size.
	    if (spacingKeys.indexOf(prop) === -1) {
	      return null;
	    }
	
	    var cssProperties = getCssProperties(prop);
	    var styleFromPropValue = getStyleFromPropValue(cssProperties, transformer);
	    var propValue = props[prop];
	    return (0, _breakpoints.handleBreakpoints)(props, propValue, styleFromPropValue);
	  }).reduce(_merge.default, {});
	}
	
	spacing.propTypes =  false ? spacingKeys.reduce(function (obj, key) {
	  obj[key] = _responsivePropType.default;
	  return obj;
	}, {}) : {};
	spacing.filterProps = spacingKeys;
	var _default = spacing;
	exports.default = _default;

/***/ },
/* 823 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.css = css;
	exports.default = void 0;
	
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(103));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(26);
	
	var _merge = _interopRequireDefault(__webpack_require__(182));
	
	function omit(input, fields) {
	  var output = {};
	  Object.keys(input).forEach(function (prop) {
	    if (fields.indexOf(prop) === -1) {
	      output[prop] = input[prop];
	    }
	  });
	  return output;
	}
	
	var warnedOnce = false;
	
	function styleFunctionSx(styleFunction) {
	  var newStyleFunction = function newStyleFunction(props) {
	    var output = styleFunction(props);
	
	    if (props.css) {
	      return (0, _extends2.default)({}, (0, _merge.default)(output, styleFunction((0, _extends2.default)({
	        theme: props.theme
	      }, props.css))), omit(props.css, [styleFunction.filterProps]));
	    }
	
	    if (props.sx) {
	      return (0, _extends2.default)({}, (0, _merge.default)(output, styleFunction((0, _extends2.default)({
	        theme: props.theme
	      }, props.sx))), omit(props.sx, [styleFunction.filterProps]));
	    }
	
	    return output;
	  };
	
	  newStyleFunction.propTypes =  false ? (0, _extends2.default)({}, styleFunction.propTypes, {
	    css: (0, _utils.chainPropTypes)(_propTypes.default.object, function (props) {
	      if (!warnedOnce && props.css !== undefined) {
	        warnedOnce = true;
	        return new Error('Material-UI: The `css` prop is deprecated, please use the `sx` prop instead.');
	      }
	
	      return null;
	    }),
	    sx: _propTypes.default.object
	  }) : {};
	  newStyleFunction.filterProps = ['css', 'sx'].concat((0, _toConsumableArray2.default)(styleFunction.filterProps));
	  return newStyleFunction;
	}
	/**
	 *
	 * @deprecated
	 * The css style function is deprecated. Use the `styleFunctionSx` instead.
	 */
	
	
	function css(styleFunction) {
	  if (false) {
	    console.warn('Material-UI: The `css` function is deprecated. Use the `styleFunctionSx` instead.');
	  }
	
	  return styleFunctionSx(styleFunction);
	}
	
	var _default = styleFunctionSx;
	exports.default = _default;

/***/ },
/* 824 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.textAlign = exports.lineHeight = exports.letterSpacing = exports.fontWeight = exports.fontStyle = exports.fontSize = exports.fontFamily = void 0;
	
	var _style = _interopRequireDefault(__webpack_require__(81));
	
	var _compose = _interopRequireDefault(__webpack_require__(88));
	
	var fontFamily = (0, _style.default)({
	  prop: 'fontFamily',
	  themeKey: 'typography'
	});
	exports.fontFamily = fontFamily;
	var fontSize = (0, _style.default)({
	  prop: 'fontSize',
	  themeKey: 'typography'
	});
	exports.fontSize = fontSize;
	var fontStyle = (0, _style.default)({
	  prop: 'fontStyle',
	  themeKey: 'typography'
	});
	exports.fontStyle = fontStyle;
	var fontWeight = (0, _style.default)({
	  prop: 'fontWeight',
	  themeKey: 'typography'
	});
	exports.fontWeight = fontWeight;
	var letterSpacing = (0, _style.default)({
	  prop: 'letterSpacing'
	});
	exports.letterSpacing = letterSpacing;
	var lineHeight = (0, _style.default)({
	  prop: 'lineHeight'
	});
	exports.lineHeight = lineHeight;
	var textAlign = (0, _style.default)({
	  prop: 'textAlign'
	});
	exports.textAlign = textAlign;
	var typography = (0, _compose.default)(fontFamily, fontSize, fontStyle, fontWeight, letterSpacing, lineHeight, textAlign);
	var _default = typography;
	exports.default = _default;

/***/ },
/* 825 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = HTMLElementType;
	
	function HTMLElementType(props, propName, componentName, location, propFullName) {
	  if (true) {
	    return null;
	  }
	
	  var propValue = props[propName];
	  var safePropName = propFullName || propName;
	
	  if (propValue == null) {
	    return null;
	  }
	
	  if (propValue && propValue.nodeType !== 1) {
	    return new Error("Invalid ".concat(location, " `").concat(safePropName, "` supplied to `").concat(componentName, "`. ") + "Expected an HTMLElement.");
	  }
	
	  return null;
	}

/***/ },
/* 826 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isPlainObject = isPlainObject;
	exports.default = deepmerge;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _typeof2 = _interopRequireDefault(__webpack_require__(56));
	
	function isPlainObject(item) {
	  return item && (0, _typeof2.default)(item) === 'object' && item.constructor === Object;
	}
	
	function deepmerge(target, source) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
	    clone: true
	  };
	  var output = options.clone ? (0, _extends2.default)({}, target) : target;
	
	  if (isPlainObject(target) && isPlainObject(source)) {
	    Object.keys(source).forEach(function (key) {
	      // Avoid prototype pollution
	      if (key === '__proto__') {
	        return;
	      }
	
	      if (isPlainObject(source[key]) && key in target) {
	        output[key] = deepmerge(target[key], source[key], options);
	      } else {
	        output[key] = source[key];
	      }
	    });
	  }
	
	  return output;
	}

/***/ },
/* 827 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _chainPropTypes = _interopRequireDefault(__webpack_require__(243));
	
	function isClassComponent(elementType) {
	  // elementType.prototype?.isReactComponent
	  var _elementType$prototyp = elementType.prototype,
	      prototype = _elementType$prototyp === void 0 ? {} : _elementType$prototyp;
	  return Boolean(prototype.isReactComponent);
	}
	
	function acceptingRef(props, propName, componentName, location, propFullName) {
	  var element = props[propName];
	  var safePropName = propFullName || propName;
	
	  if (element == null) {
	    return null;
	  }
	
	  var warningHint;
	  var elementType = element.type;
	  /**
	   * Blacklisting instead of whitelisting
	   *
	   * Blacklisting will miss some components, such as React.Fragment. Those will at least
	   * trigger a warning in React.
	   * We can't whitelist because there is no safe way to detect React.forwardRef
	   * or class components. "Safe" means there's no public API.
	   *
	   */
	
	  if (typeof elementType === 'function' && !isClassComponent(elementType)) {
	    warningHint = 'Did you accidentally use a plain function component for an element instead?';
	  }
	
	  if (warningHint !== undefined) {
	    return new Error("Invalid ".concat(location, " `").concat(safePropName, "` supplied to `").concat(componentName, "`. ") + "Expected an element that can hold a ref. ".concat(warningHint, " ") + 'For more information see https://mui.com/r/caveat-with-refs-guide');
	  }
	
	  return null;
	}
	
	var elementAcceptingRef = (0, _chainPropTypes.default)(_propTypes.default.element, acceptingRef);
	elementAcceptingRef.isRequired = (0, _chainPropTypes.default)(_propTypes.default.element.isRequired, acceptingRef);
	var _default = elementAcceptingRef;
	exports.default = _default;

/***/ },
/* 828 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(3));
	
	var _chainPropTypes = _interopRequireDefault(__webpack_require__(243));
	
	function isClassComponent(elementType) {
	  // elementType.prototype?.isReactComponent
	  var _elementType$prototyp = elementType.prototype,
	      prototype = _elementType$prototyp === void 0 ? {} : _elementType$prototyp;
	  return Boolean(prototype.isReactComponent);
	}
	
	function elementTypeAcceptingRef(props, propName, componentName, location, propFullName) {
	  var propValue = props[propName];
	  var safePropName = propFullName || propName;
	
	  if (propValue == null) {
	    return null;
	  }
	
	  var warningHint;
	  /**
	   * Blacklisting instead of whitelisting
	   *
	   * Blacklisting will miss some components, such as React.Fragment. Those will at least
	   * trigger a warning in React.
	   * We can't whitelist because there is no safe way to detect React.forwardRef
	   * or class components. "Safe" means there's no public API.
	   *
	   */
	
	  if (typeof propValue === 'function' && !isClassComponent(propValue)) {
	    warningHint = 'Did you accidentally provide a plain function component instead?';
	  }
	
	  if (warningHint !== undefined) {
	    return new Error("Invalid ".concat(location, " `").concat(safePropName, "` supplied to `").concat(componentName, "`. ") + "Expected an element type that can hold a ref. ".concat(warningHint, " ") + 'For more information see https://mui.com/r/caveat-with-refs-guide');
	  }
	
	  return null;
	}
	
	var _default = (0, _chainPropTypes.default)(PropTypes.elementType, elementTypeAcceptingRef);
	
	exports.default = _default;

/***/ },
/* 829 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exactProp;
	exports.specialProperty = void 0;
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(24));
	
	var _extends3 = _interopRequireDefault(__webpack_require__(6));
	
	// This module is based on https://github.com/airbnb/prop-types-exact repository.
	// However, in order to reduce the number of dependencies and to remove some extra safe checks
	// the module was forked.
	// Only exported for test purposes.
	var specialProperty = "exact-prop: \u200B";
	exports.specialProperty = specialProperty;
	
	function exactProp(propTypes) {
	  if (true) {
	    return propTypes;
	  }
	
	  return (0, _extends3.default)({}, propTypes, (0, _defineProperty2.default)({}, specialProperty, function (props) {
	    var unsupportedProps = Object.keys(props).filter(function (prop) {
	      return !propTypes.hasOwnProperty(prop);
	    });
	
	    if (unsupportedProps.length > 0) {
	      return new Error("The following props are not supported: ".concat(unsupportedProps.map(function (prop) {
	        return "`".concat(prop, "`");
	      }).join(', '), ". Please remove them."));
	    }
	
	    return null;
	  }));
	}

/***/ },
/* 830 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatMuiErrorMessage;
	
	/**
	 * WARNING: Don't import this directly.
	 * Use `MuiError` from `@material-ui/utils/macros/MuiError.macro` instead.
	 * @param {number} code
	 */
	function formatMuiErrorMessage(code) {
	  // Apply babel-plugin-transform-template-literals in loose mode
	  // loose mode is safe iff we're concatenating primitives
	  // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
	
	  /* eslint-disable prefer-template */
	  var url = 'https://mui.com/production-error/?code=' + code;
	
	  for (var i = 1; i < arguments.length; i += 1) {
	    // rest params over-transpile for this case
	    // eslint-disable-next-line prefer-rest-params
	    url += '&args[]=' + encodeURIComponent(arguments[i]);
	  }
	
	  return 'Minified Material-UI error #' + code + '; visit ' + url + ' for the full message.';
	  /* eslint-enable prefer-template */
	}

/***/ },
/* 831 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getFunctionName = getFunctionName;
	exports.default = getDisplayName;
	
	var _typeof2 = _interopRequireDefault(__webpack_require__(56));
	
	var _reactIs = __webpack_require__(168);
	
	// Simplified polyfill for IE 11 support
	// https://github.com/JamesMGreene/Function.name/blob/58b314d4a983110c3682f1228f845d39ccca1817/Function.name.js#L3
	var fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
	
	function getFunctionName(fn) {
	  var match = "".concat(fn).match(fnNameMatchRegex);
	  var name = match && match[1];
	  return name || '';
	}
	/**
	 * @param {function} Component
	 * @param {string} fallback
	 * @returns {string | undefined}
	 */
	
	
	function getFunctionComponentName(Component) {
	  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	  return Component.displayName || Component.name || getFunctionName(Component) || fallback;
	}
	
	function getWrappedName(outerType, innerType, wrapperName) {
	  var functionName = getFunctionComponentName(innerType);
	  return outerType.displayName || (functionName !== '' ? "".concat(wrapperName, "(").concat(functionName, ")") : wrapperName);
	}
	/**
	 * cherry-pick from
	 * https://github.com/facebook/react/blob/769b1f270e1251d9dbdce0fcbd9e92e502d059b8/packages/shared/getComponentName.js
	 * originally forked from recompose/getDisplayName with added IE 11 support
	 *
	 * @param {React.ReactType} Component
	 * @returns {string | undefined}
	 */
	
	
	function getDisplayName(Component) {
	  if (Component == null) {
	    return undefined;
	  }
	
	  if (typeof Component === 'string') {
	    return Component;
	  }
	
	  if (typeof Component === 'function') {
	    return getFunctionComponentName(Component, 'Component');
	  }
	
	  if ((0, _typeof2.default)(Component) === 'object') {
	    switch (Component.$$typeof) {
	      case _reactIs.ForwardRef:
	        return getWrappedName(Component, Component.render, 'ForwardRef');
	
	      case _reactIs.Memo:
	        return getWrappedName(Component, Component.type, 'memo');
	
	      default:
	        return undefined;
	    }
	  }
	
	  return undefined;
	}

/***/ },
/* 832 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	/* eslint-disable */
	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var _default = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
	
	exports.default = _default;

/***/ },
/* 833 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var refType = _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]);
	
	var _default = refType;
	exports.default = _default;

/***/ },
/* 834 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var PropTypes = __webpack_require__(3);
	var kendo_drawing_1 = __webpack_require__(341);
	var kendo_file_saver_1 = __webpack_require__(342);
	var getPageMargin_1 = __webpack_require__(183);
	var KendoDrawingAdapter_1 = __webpack_require__(343);
	/**
	 * Represents the KendoReact PDFExport component.
	 */
	var PDFExport = /** @class */ (function (_super) {
	    __extends(PDFExport, _super);
	    function PDFExport() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * @hidden
	     */
	    PDFExport.prototype.render = function () {
	        var _this = this;
	        return (React.createElement("div", { ref: function (el) { _this.rootElForPDF = el; } }, this.props.children));
	    };
	    /**
	     * Saves the content as a PDF file.
	     *
	     * @param callback - The callback to be executed after the PDF is saved.
	     */
	    PDFExport.prototype.save = function (callback) {
	        new KendoDrawingAdapter_1.default(kendo_drawing_1.drawDOM, kendo_drawing_1.exportPDF, kendo_file_saver_1.saveAs, this.rootElForPDF, this.getOptions()).savePDF(callback);
	    };
	    PDFExport.prototype.getOptions = function () {
	        return Object.assign({}, this.props, { margin: getPageMargin_1.getPageMargin(this.props) });
	    };
	    /**
	     * @hidden
	     */
	    PDFExport.propTypes = {
	        author: PropTypes.string,
	        avoidLinks: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
	        forcePageBreak: PropTypes.string,
	        keepTogether: PropTypes.string,
	        creator: PropTypes.string,
	        date: PropTypes.instanceOf(Date),
	        imageResolution: PropTypes.number,
	        fileName: PropTypes.string,
	        forceProxy: PropTypes.bool,
	        keywords: PropTypes.string,
	        landscape: PropTypes.bool,
	        margin: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.shape({
	                left: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	                top: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	                right: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	                bottom: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
	            })]),
	        pageTemplate: PropTypes.any,
	        paperSize: PropTypes.any,
	        repeatHeaders: PropTypes.bool,
	        scale: PropTypes.number,
	        proxyData: PropTypes.any,
	        proxyURL: PropTypes.string,
	        proxyTarget: PropTypes.string,
	        producer: PropTypes.string,
	        subject: PropTypes.string,
	        title: PropTypes.string
	    };
	    return PDFExport;
	}(React.Component));
	exports.default = PDFExport;
	//# sourceMappingURL=PDFExport.js.map

/***/ },
/* 835 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var dom_queries_1 = __webpack_require__(345);
	/**
	 * @hidden
	 */
	exports.HEADER_CLASS = 'k-grid-header';
	/**
	 * @hidden
	 */
	exports.FOOTER_CLASS = 'k-grid-footer';
	var TABLE = 'TABLE';
	var matchesTable = dom_queries_1.matchesNodeName(TABLE);
	/**
	 * @hidden
	 */
	var GridQuery = /** @class */ (function () {
	    function GridQuery(element) {
	        this.element = element;
	        this.list = dom_queries_1.findElement(element, dom_queries_1.matchesClasses("k-grid"));
	    }
	    GridQuery.prototype.content = function () {
	        return dom_queries_1.findElement(this.list, dom_queries_1.matchesClasses("k-grid"));
	    };
	    GridQuery.prototype.header = function () {
	        this.headerWrap = this.headerWrap || dom_queries_1.findElement(this.element, dom_queries_1.matchesClasses(exports.HEADER_CLASS));
	        return dom_queries_1.findElement(this.headerWrap, dom_queries_1.matchesClasses("" + exports.HEADER_CLASS));
	    };
	    GridQuery.prototype.footer = function () {
	        this.footerWrap = this.footerWrap || dom_queries_1.findElement(this.element, dom_queries_1.matchesClasses(exports.FOOTER_CLASS));
	        return dom_queries_1.findElement(this.footerWrap, dom_queries_1.matchesClasses("" + exports.FOOTER_CLASS));
	    };
	    GridQuery.prototype.table = function () {
	        return dom_queries_1.findElement(this.element, matchesTable);
	    };
	    return GridQuery;
	}());
	exports.GridQuery = GridQuery;
	//# sourceMappingURL=table-query.js.map

/***/ },
/* 836 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var PropTypes = __webpack_require__(3);
	var getPageMargin_1 = __webpack_require__(183);
	var savePDF_1 = __webpack_require__(245);
	var provideSaveGridPDF_1 = __webpack_require__(839);
	/**
	 * A React component which facilitates the PDF export of the Grid.
	 */
	var GridPDFExport = /** @class */ (function (_super) {
	    __extends(GridPDFExport, _super);
	    function GridPDFExport(props) {
	        var _this = _super.call(this, props) || this;
	        _this.saveGridPDF = provideSaveGridPDF_1.provideSaveGridPDF(_this.getSavePDF());
	        return _this;
	    }
	    /**
	     * @hidden
	     */
	    GridPDFExport.prototype.render = function () {
	        return null;
	    };
	    // tslint:disable:max-line-length
	    /**
	     * Saves the content of the Grid as a PDF file.
	     *
	     * @param data - The data can be different from the currently displayed data in the Grid. Can be used to export all Grid pages.
	     * @param callback - The callback that will be executed after the PDF is saved.
	     */
	    // tslint:enable:max-line-length
	    GridPDFExport.prototype.save = function (data, callback) {
	        this.saveGridPDF(this.getGrid(), Object.assign({}, this.props, { margin: getPageMargin_1.getPageMargin(this.props) }), callback, data, this.getCustomColumns());
	    };
	    GridPDFExport.prototype.getSavePDF = function () {
	        return savePDF_1.savePDF;
	    };
	    GridPDFExport.prototype.getGrid = function () {
	        return React.Children
	            .toArray(this.props.children)
	            .find(function (child) { return child &&
	            child.type.displayName === 'KendoReactGrid'; });
	    };
	    GridPDFExport.prototype.getCustomColumns = function () {
	        return React.Children
	            .toArray(this.props.children)
	            .filter(function (child) { return child &&
	            child.type.displayName === 'KendoReactGridColumn'; });
	    };
	    /**
	     * @hidden
	     */
	    GridPDFExport.propTypes = {
	        author: PropTypes.string,
	        avoidLinks: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
	        forcePageBreak: PropTypes.string,
	        keepTogether: PropTypes.string,
	        creator: PropTypes.string,
	        date: PropTypes.instanceOf(Date),
	        imageResolution: PropTypes.number,
	        fileName: PropTypes.string,
	        forceProxy: PropTypes.bool,
	        keywords: PropTypes.string,
	        landscape: PropTypes.bool,
	        margin: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.shape({
	                left: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	                top: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	                right: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	                bottom: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
	            })]),
	        pageTemplate: PropTypes.any,
	        paperSize: PropTypes.any,
	        repeatHeaders: PropTypes.bool,
	        scale: PropTypes.number,
	        proxyData: PropTypes.any,
	        proxyURL: PropTypes.string,
	        proxyTarget: PropTypes.string,
	        producer: PropTypes.string,
	        subject: PropTypes.string,
	        title: PropTypes.string
	    };
	    return GridPDFExport;
	}(React.Component));
	exports.GridPDFExport = GridPDFExport;
	//# sourceMappingURL=GridPDFExport.js.map

/***/ },
/* 837 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var grid_query_1 = __webpack_require__(838);
	var utils_1 = __webpack_require__(346);
	/**
	 * @hidden
	 */
	exports.exportElement = function (wrapper) {
	    var query = new grid_query_1.GridQuery(wrapper);
	    var content = query.content();
	    var result;
	    if (content) {
	        var colGroups = [content.querySelector('colgroup')];
	        var headers = [query.header().querySelector('thead')];
	        var bodies = [content.querySelector('tbody')];
	        var footer = query.footer();
	        var footers = footer ? [footer.querySelector('tfoot')] : [];
	        result = utils_1.createTable(colGroups, headers, bodies, footers);
	    }
	    else {
	        result = utils_1.wrapTable(query.table().cloneNode(true));
	    }
	    return result;
	};
	//# sourceMappingURL=export-element.js.map

/***/ },
/* 838 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var dom_queries_1 = __webpack_require__(345);
	/**
	 * @hidden
	 */
	exports.HEADER_CLASS = 'k-grid-header';
	/**
	 * @hidden
	 */
	exports.FOOTER_CLASS = 'k-grid-footer';
	var TABLE = 'TABLE';
	var matchesTable = dom_queries_1.matchesNodeName(TABLE);
	var suffix = function (locked) { return locked ? 'locked' : 'wrap'; };
	/**
	 * @hidden
	 */
	var GridQuery = /** @class */ (function () {
	    function GridQuery(element) {
	        this.element = element;
	        this.list = dom_queries_1.findElement(element, dom_queries_1.matchesClasses("k-grid-container"));
	    }
	    GridQuery.prototype.content = function (locked) {
	        return dom_queries_1.findElement(this.list, dom_queries_1.matchesClasses("k-grid-content" + (locked ? '-locked' : '')));
	    };
	    GridQuery.prototype.header = function (locked) {
	        this.headerWrap = this.headerWrap || dom_queries_1.findElement(this.element, dom_queries_1.matchesClasses(exports.HEADER_CLASS));
	        return dom_queries_1.findElement(this.headerWrap, dom_queries_1.matchesClasses(exports.HEADER_CLASS + "-" + suffix(locked)));
	    };
	    GridQuery.prototype.footer = function (locked) {
	        this.footerWrap = this.footerWrap || dom_queries_1.findElement(this.element, dom_queries_1.matchesClasses(exports.FOOTER_CLASS));
	        return dom_queries_1.findElement(this.footerWrap, dom_queries_1.matchesClasses(exports.FOOTER_CLASS + "-" + suffix(locked)));
	    };
	    GridQuery.prototype.table = function () {
	        return dom_queries_1.findElement(this.element, matchesTable);
	    };
	    return GridQuery;
	}());
	exports.GridQuery = GridQuery;
	//# sourceMappingURL=grid-query.js.map

/***/ },
/* 839 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ReactDOM = __webpack_require__(43);
	var React = __webpack_require__(1);
	var export_element_1 = __webpack_require__(837);
	/**
	 * @hidden
	 */
	function provideSaveGridPDF(savePDF) {
	    return function (grid, pdfExportOptions, callback, data, columns) {
	        if (pdfExportOptions === void 0) { pdfExportOptions = {}; }
	        return saveGridPDF(savePDF, grid, pdfExportOptions, callback, data, columns);
	    };
	}
	exports.provideSaveGridPDF = provideSaveGridPDF;
	function saveGridPDF(savePDF, grid, pdfExportOptions, callback, data, columns) {
	    if (pdfExportOptions === void 0) { pdfExportOptions = {}; }
	    renderGrid();
	    var gridOuterWrapper;
	    var gridInnerWrapper;
	    var finalContainer;
	    function renderGrid() {
	        gridOuterWrapper = document.createElement('div');
	        gridOuterWrapper.setAttribute('style', 'position:absolute; left: -5000px; top: 0px;');
	        gridInnerWrapper = document.createElement('div');
	        gridOuterWrapper.appendChild(gridInnerWrapper);
	        document.body.appendChild(gridOuterWrapper);
	        ReactDOM.render(prepareRawGridForExport(), gridInnerWrapper, onGridRendered);
	    }
	    function onGridRendered() {
	        savePDF(prepareFinalElementForExport(), pdfExportOptions, cleanUpAndInvokeCallback);
	    }
	    function cleanUpAndInvokeCallback() {
	        document.body.removeChild(gridOuterWrapper);
	        document.body.removeChild(finalContainer);
	        gridOuterWrapper = finalContainer = undefined;
	        if (callback) {
	            callback();
	        }
	    }
	    function prepareFinalElementForExport() {
	        /* Ultimatelly, there is no need for double DOM-copying of the grid.
	        The one in this method is a copied Angular implementation
	        that has been plugged almost seemlessly. */
	        finalContainer = document.createElement('div');
	        finalContainer.className = 'k-grid-pdf-export-element';
	        var result = export_element_1.exportElement(gridInnerWrapper);
	        finalContainer.appendChild(result);
	        document.body.appendChild(finalContainer);
	        return result;
	    }
	    function prepareRawGridForExport() {
	        var customDataProps = data && { data: data, total: data.length, pageSize: data.length, skip: 0 };
	        // A custom width is needed because otherwise when all pages are exported,
	        // the "hidden" PDF grid will be visible.
	        var customStyleProp = { style: Object.assign({}, grid.props.style, { width: '1000px' }) };
	        var customProps = Object.assign({}, customDataProps, customStyleProp);
	        if (columns && columns.length > 0) {
	            var notColumnChildren = getGridNotColumnChildren(grid);
	            return React.cloneElement(grid, customProps, columns.concat(notColumnChildren));
	        }
	        else {
	            return React.cloneElement(grid, customProps);
	        }
	    }
	}
	function getGridNotColumnChildren(grid) {
	    return React.Children
	        .toArray(grid.props.children)
	        .filter(function (child) { return child &&
	        child.type.displayName !== 'KendoReactGridColumn'; });
	}
	//# sourceMappingURL=provideSaveGridPDF.js.map

/***/ },
/* 840 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var PropTypes = __webpack_require__(3);
	var getPageMargin_1 = __webpack_require__(183);
	var savePDF_1 = __webpack_require__(245);
	var provideSaveTreeListPDF_1 = __webpack_require__(842);
	/**
	 * A React component which facilitates the PDF export of the TreeList.
	 */
	var TreeListPDFExport = /** @class */ (function (_super) {
	    __extends(TreeListPDFExport, _super);
	    function TreeListPDFExport(props) {
	        var _this = _super.call(this, props) || this;
	        _this.saveTreeListPDF = provideSaveTreeListPDF_1.provideSaveTreeListPDF(_this.getSavePDF());
	        return _this;
	    }
	    /**
	     * @hidden
	     */
	    TreeListPDFExport.prototype.render = function () {
	        return null;
	    };
	    // tslint:disable:max-line-length
	    /**
	     * Saves the content of the TreeList as a PDF file.
	     *
	     * @param data - The data that will be exported to the PDF. The data can be different from the currently displayed data in the TreeList.
	     * @param columns - The columns that will be exported to the PDF. The columns collection can be different from the currently displayed in the TreeList.
	     * @param callback - The callback that will be executed after the PDF is saved.
	     */
	    // tslint:enable:max-line-length
	    TreeListPDFExport.prototype.save = function (data, columns, callback) {
	        this.saveTreeListPDF(this.getTreeList(), Object.assign({}, this.props, { margin: getPageMargin_1.getPageMargin(this.props) }), callback, data, columns || []);
	    };
	    TreeListPDFExport.prototype.getSavePDF = function () {
	        return savePDF_1.savePDF;
	    };
	    TreeListPDFExport.prototype.getTreeList = function () {
	        var children = this.props.children;
	        if (children && children.props.data && children.props.columns) {
	            return this.props.children;
	        }
	    };
	    /**
	     * @hidden
	     */
	    TreeListPDFExport.propTypes = {
	        author: PropTypes.string,
	        avoidLinks: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
	        forcePageBreak: PropTypes.string,
	        keepTogether: PropTypes.string,
	        creator: PropTypes.string,
	        date: PropTypes.instanceOf(Date),
	        imageResolution: PropTypes.number,
	        fileName: PropTypes.string,
	        forceProxy: PropTypes.bool,
	        keywords: PropTypes.string,
	        landscape: PropTypes.bool,
	        margin: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.shape({
	                left: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	                top: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	                right: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	                bottom: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
	            })]),
	        pageTemplate: PropTypes.any,
	        paperSize: PropTypes.any,
	        repeatHeaders: PropTypes.bool,
	        scale: PropTypes.number,
	        proxyData: PropTypes.any,
	        proxyURL: PropTypes.string,
	        proxyTarget: PropTypes.string,
	        producer: PropTypes.string,
	        subject: PropTypes.string,
	        title: PropTypes.string,
	        allPages: PropTypes.bool
	    };
	    return TreeListPDFExport;
	}(React.Component));
	exports.TreeListPDFExport = TreeListPDFExport;
	//# sourceMappingURL=TreeListPDFExport.js.map

/***/ },
/* 841 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var table_query_1 = __webpack_require__(835);
	var utils_1 = __webpack_require__(346);
	/**
	 * @hidden
	 */
	exports.exportElement = function (wrapper) {
	    var query = new table_query_1.GridQuery(wrapper);
	    var content = query.content();
	    var result;
	    var headerWithoutFilter = query.header();
	    if (headerWithoutFilter.childNodes.length > 1) {
	        headerWithoutFilter.removeChild(headerWithoutFilter.childNodes[1]);
	    }
	    headerWithoutFilter.childNodes[0].childNodes.forEach(function (headerCell) { return headerCell.style.top = 0; });
	    if (content) {
	        var colGroups = [content.querySelector('colgroup')];
	        var headers = [headerWithoutFilter];
	        var bodies = [content.querySelector('tbody')];
	        var footer = query.footer();
	        var footers = footer ? [footer.querySelector('tfoot')] : [];
	        result = utils_1.createTable(colGroups, headers, bodies, footers);
	    }
	    else {
	        result = utils_1.wrapTable(query.table().cloneNode(true));
	    }
	    return result;
	};
	//# sourceMappingURL=export-element.js.map

/***/ },
/* 842 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ReactDOM = __webpack_require__(43);
	var React = __webpack_require__(1);
	var export_element_1 = __webpack_require__(841);
	/**
	 * @hidden
	 */
	function provideSaveTreeListPDF(savePDF) {
	    return function (treeList, pdfExportOptions, callback, data, columns) {
	        if (pdfExportOptions === void 0) { pdfExportOptions = {}; }
	        return saveTreeListPDF(savePDF, treeList, pdfExportOptions, callback, data, columns);
	    };
	}
	exports.provideSaveTreeListPDF = provideSaveTreeListPDF;
	function saveTreeListPDF(savePDF, treeList, pdfExportOptions, callback, data, columns) {
	    if (pdfExportOptions === void 0) { pdfExportOptions = {}; }
	    rendertreeList();
	    var treeListOuterWrapper;
	    var treeListInnerWrapper;
	    var finalContainer;
	    function rendertreeList() {
	        treeListOuterWrapper = document.createElement('div');
	        treeListOuterWrapper.setAttribute('style', 'position:absolute; left: -5000px; top: 0px;');
	        treeListInnerWrapper = document.createElement('div');
	        treeListOuterWrapper.appendChild(treeListInnerWrapper);
	        document.body.appendChild(treeListOuterWrapper);
	        ReactDOM.render(prepareRawTreeListForExport(), treeListInnerWrapper, ontreeListRendered);
	    }
	    function ontreeListRendered() {
	        savePDF(prepareFinalElementForExport(), pdfExportOptions, cleanUpAndInvokeCallback);
	    }
	    function cleanUpAndInvokeCallback() {
	        document.body.removeChild(treeListOuterWrapper);
	        document.body.removeChild(finalContainer);
	        treeListOuterWrapper = finalContainer = undefined;
	        if (callback) {
	            callback();
	        }
	    }
	    function prepareFinalElementForExport() {
	        /* Ultimatelly, there is no need for double DOM-copying of the treeList.
	        The one in this method is a copied Angular implementation
	        that has been plugged almost seemlessly. */
	        finalContainer = document.createElement('div');
	        finalContainer.className = 'k-treelist-pdf-export-element';
	        var result = export_element_1.exportElement(treeListInnerWrapper);
	        finalContainer.appendChild(result);
	        document.body.appendChild(finalContainer);
	        return finalContainer;
	    }
	    function prepareRawTreeListForExport() {
	        var customDataProps = pdfExportOptions.allPages && data ? { data: data, take: Number.MAX_VALUE, skip: 0 } : {};
	        // A custom width is needed because otherwise when all pages are exported,
	        // the "hidden" PDF treeList will be visible.
	        var customStyleProp = { style: Object.assign({}, treeList.props.style, { width: '1000px' }) };
	        var customProps = Object.assign({}, customDataProps, customStyleProp);
	        if (columns && columns.length > 0) {
	            return React.cloneElement(treeList, Object.assign({}, customProps, { columns: columns }));
	        }
	        else {
	            return React.cloneElement(treeList, customProps);
	        }
	    }
	}
	//# sourceMappingURL=provideSaveTreeListPDF.js.map

/***/ },
/* 843 */
/***/ function(module, exports, __webpack_require__) {

	(function (global, factory) {
	   true ? factory(exports) :
	  typeof define === 'function' && define.amd ? define(['exports'], factory) :
	  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.pako = {}));
	}(this, (function (exports) { 'use strict';
	
	  /* eslint-disable */
	
	  // (C) 1995-2013 Jean-loup Gailly and Mark Adler
	  // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	  //
	  // This software is provided 'as-is', without any express or implied
	  // warranty. In no event will the authors be held liable for any damages
	  // arising from the use of this software.
	  //
	  // Permission is granted to anyone to use this software for any purpose,
	  // including commercial applications, and to alter it and redistribute it
	  // freely, subject to the following restrictions:
	  //
	  // 1. The origin of this software must not be misrepresented; you must not
	  //   claim that you wrote the original software. If you use this software
	  //   in a product, an acknowledgment in the product documentation would be
	  //   appreciated but is not required.
	  // 2. Altered source versions must be plainly marked as such, and must not be
	  //   misrepresented as being the original software.
	  // 3. This notice may not be removed or altered from any source distribution.
	
	  /* Allowed flush values; see deflate() and inflate() below for details */
	  var Z_NO_FLUSH =          0;
	  var Z_PARTIAL_FLUSH =     1;
	  var Z_SYNC_FLUSH =        2;
	  var Z_FULL_FLUSH =        3;
	  var Z_FINISH =            4;
	  var Z_BLOCK =             5;
	  var Z_TREES =             6;
	
	  /* Return codes for the compression/decompression functions. Negative values
	  * are errors, positive values are used for special but normal events.
	  */
	  var Z_OK =                0;
	  var Z_STREAM_END =        1;
	  var Z_NEED_DICT =         2;
	  var Z_ERRNO =            -1;
	  var Z_STREAM_ERROR =     -2;
	  var Z_DATA_ERROR =       -3;
	  //export var Z_MEM_ERROR =      -4;
	  var Z_BUF_ERROR =        -5;
	  //export var Z_VERSION_ERROR =  -6;
	
	  /* compression levels */
	  var Z_NO_COMPRESSION =          0;
	  var Z_BEST_SPEED =              1;
	  var Z_BEST_COMPRESSION =        9;
	  var Z_DEFAULT_COMPRESSION =    -1;
	
	
	  var Z_FILTERED =                1;
	  var Z_HUFFMAN_ONLY =            2;
	  var Z_RLE =                     3;
	  var Z_FIXED =                   4;
	  var Z_DEFAULT_STRATEGY =        0;
	
	  /* Possible values of the data_type field (though see inflate()) */
	  var Z_BINARY =                  0;
	  var Z_TEXT =                    1;
	  //export var Z_ASCII =                 1; // = Z_TEXT (deprecated)
	  var Z_UNKNOWN =                 2;
	
	  /* The deflate compression method */
	  var Z_DEFLATED =                8;
	  //export var Z_NULL =                  null // Use -1 or null inline; depending on var type
	
	  /* eslint-disable */
	
	  function _has(obj, key) {
	    return Object.prototype.hasOwnProperty.call(obj, key);
	  }
	
	  function assign(obj /*from1, from2, from3, ...*/) {
	    var sources = Array.prototype.slice.call(arguments, 1);
	    while (sources.length) {
	      var source = sources.shift();
	      if (!source) { continue; }
	
	      if (typeof source !== 'object') {
	        throw new TypeError(source + 'must be non-object');
	      }
	
	      for (var p in source) {
	        if (_has(source, p)) {
	          obj[p] = source[p];
	        }
	      }
	    }
	
	    return obj;
	  }
	
	
	  // reduce buffer size, avoiding mem copy
	  function shrinkBuf(buf, size) {
	    if (buf.length === size) { return buf; }
	    if (buf.subarray) { return buf.subarray(0, size); }
	    buf.length = size;
	    return buf;
	  }
	
	  var fnTyped = {
	    arraySet: function (dest, src, src_offs, len, dest_offs) {
	      if (src.subarray && dest.subarray) {
	        dest.set(src.subarray(src_offs, src_offs + len), dest_offs);
	        return;
	      }
	      // Fallback to ordinary array
	      for (var i = 0; i < len; i++) {
	        dest[dest_offs + i] = src[src_offs + i];
	      }
	    },
	    // Join array of chunks to single array.
	    flattenChunks: function (chunks) {
	      var i, l, len, pos, chunk, result;
	
	      // calculate data length
	      len = 0;
	      for (i = 0, l = chunks.length; i < l; i++) {
	        len += chunks[i].length;
	      }
	
	      // join chunks
	      result = new Uint8Array(len);
	      pos = 0;
	      for (i = 0, l = chunks.length; i < l; i++) {
	        chunk = chunks[i];
	        result.set(chunk, pos);
	        pos += chunk.length;
	      }
	
	      return result;
	    },
	    Buf8: function(size) {
	      return new Uint8Array(size);
	    },
	    Buf16: function(size) {
	      return new Uint16Array(size);
	    },
	    Buf32: function(size) {
	      return new Int32Array(size);
	    }
	  };
	
	  var fnUntyped = {
	    arraySet: function (dest, src, src_offs, len, dest_offs) {
	      for (var i = 0; i < len; i++) {
	        dest[dest_offs + i] = src[src_offs + i];
	      }
	    },
	    // Join array of chunks to single array.
	    flattenChunks: function (chunks) {
	      return [].concat.apply([], chunks);
	    },
	    Buf8: function(size) {
	      return new Array(size);
	    },
	    Buf16: function(size) {
	      return new Array(size);
	    },
	    Buf32: function(size) {
	      return new Array(size);
	    }
	  };
	
	  var typedOK = function () {
	    var supported =
	      (typeof Uint8Array !== 'undefined') &&
	      (typeof Uint16Array !== 'undefined') &&
	      (typeof Int32Array !== 'undefined');
	
	    typedOK = function () { return supported; };
	    return supported;
	  };
	
	  var arraySet = function (dest, src, src_offs, len, dest_offs) {
	    arraySet = typedOK() ?
	      fnTyped.arraySet : fnUntyped.arraySet;
	
	    return arraySet(dest, src, src_offs, len, dest_offs);
	  };
	
	  var flattenChunks = function (chunks) {
	    flattenChunks = typedOK() ?
	      fnTyped.flattenChunks : fnUntyped.flattenChunks;
	
	    return flattenChunks(chunks);
	  };
	
	  var Buf8 = function (size) {
	    Buf8 = typedOK() ? fnTyped.Buf8 : fnUntyped.Buf8;
	    return Buf8(size);
	  };
	
	  var Buf16 = function (size) {
	    Buf16 = typedOK() ? fnTyped.Buf16 : fnUntyped.Buf16;
	    return Buf16(size);
	  };
	
	  var Buf32 = function (size) {
	    Buf32 = typedOK() ? fnTyped.Buf32 : fnUntyped.Buf32;
	    return Buf32(size);
	  };
	
	  /* eslint-disable */
	
	
	  // Quick check if we can use fast array to bin string conversion
	  //
	  // - apply(Array) can fail on Android 2.2
	  // - apply(Uint8Array) can fail on iOS 5.1 Safari
	  var strApplyOK = function() {
	      var result = true;
	      try {
	          String.fromCharCode.apply(null, [ 0 ]);
	      } catch (_) {
	          result = false;
	      }
	
	      strApplyOK = function () { return result; };
	      return result;
	  };
	
	  var strApplyUintOK = function() {
	      var result = true;
	      try {
	          String.fromCharCode.apply(null, new Uint8Array(1));
	      } catch (_) {
	          result = false;
	      }
	
	      strApplyUintOK = function () { return result; };
	      return result;
	  };
	
	  var utf8len = function(c) {
	      // Table with utf8 lengths (calculated by first byte of sequence)
	      // Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
	      // because max possible codepoint is 0x10ffff
	      var table = Buf8(256);
	      for (var q = 0; q < 256; q++) {
	        table[q] = (q >= 252 ? 6 : q >= 248 ? 5 : q >= 240 ? 4 : q >= 224 ? 3 : q >= 192 ? 2 : 1);
	      }
	      table[254] = table[254] = 1; // Invalid sequence start
	
	      utf8len = function (arg) { return table[arg]; };
	      return table[c];
	  };
	
	  // convert string to array (typed, when possible)
	  function string2buf(str) {
	    var buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;
	
	    // count binary size
	    for (m_pos = 0; m_pos < str_len; m_pos++) {
	      c = str.charCodeAt(m_pos);
	      if ((c & 0xfc00) === 0xd800 && (m_pos + 1 < str_len)) {
	        c2 = str.charCodeAt(m_pos + 1);
	        if ((c2 & 0xfc00) === 0xdc00) {
	          c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
	          m_pos++;
	        }
	      }
	      buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
	    }
	
	    // allocate buffer
	    buf = new Uint8Array(buf_len);
	
	    // convert
	    for (i = 0, m_pos = 0; i < buf_len; m_pos++) {
	      c = str.charCodeAt(m_pos);
	      if ((c & 0xfc00) === 0xd800 && (m_pos + 1 < str_len)) {
	        c2 = str.charCodeAt(m_pos + 1);
	        if ((c2 & 0xfc00) === 0xdc00) {
	          c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
	          m_pos++;
	        }
	      }
	      if (c < 0x80) {
	        /* one byte */
	        buf[i++] = c;
	      } else if (c < 0x800) {
	        /* two bytes */
	        buf[i++] = 0xC0 | (c >>> 6);
	        buf[i++] = 0x80 | (c & 0x3f);
	      } else if (c < 0x10000) {
	        /* three bytes */
	        buf[i++] = 0xE0 | (c >>> 12);
	        buf[i++] = 0x80 | (c >>> 6 & 0x3f);
	        buf[i++] = 0x80 | (c & 0x3f);
	      } else {
	        /* four bytes */
	        buf[i++] = 0xf0 | (c >>> 18);
	        buf[i++] = 0x80 | (c >>> 12 & 0x3f);
	        buf[i++] = 0x80 | (c >>> 6 & 0x3f);
	        buf[i++] = 0x80 | (c & 0x3f);
	      }
	    }
	
	    return buf;
	  }
	
	  // Helper (used in 2 places)
	  function _buf2binstring(buf, len) {
	    // On Chrome, the arguments in a function call that are allowed is `65534`.
	    // If the length of the buffer is smaller than that, we can use this optimization,
	    // otherwise we will take a slower path.
	    if (len < 65534) {
	      if ((buf.subarray && strApplyUintOK()) || (!buf.subarray && strApplyOK())) {
	        return String.fromCharCode.apply(null, shrinkBuf(buf, len));
	      }
	    }
	
	    var result = '';
	    for (var i = 0; i < len; i++) {
	      result += String.fromCharCode(buf[i]);
	    }
	    return result;
	  }
	
	
	  // Convert byte array to binary string
	  function buf2binstring(buf) {
	    return _buf2binstring(buf, buf.length);
	  }
	
	
	  // Convert binary string (typed, when possible)
	  function binstring2buf(str) {
	    var buf = new Uint8Array(str.length);
	    for (var i = 0, len = buf.length; i < len; i++) {
	      buf[i] = str.charCodeAt(i);
	    }
	    return buf;
	  }
	
	
	  // convert array to string
	  function buf2string(buf, max) {
	    var i, out, c, c_len;
	    var len = max || buf.length;
	
	    // Reserve max possible length (2 words per char)
	    // NB: by unknown reasons, Array is significantly faster for
	    //     String.fromCharCode.apply than Uint16Array.
	    var utf16buf = new Array(len * 2);
	
	    for (out = 0, i = 0; i < len;) {
	      c = buf[i++];
	      // quick process ascii
	      if (c < 0x80) { utf16buf[out++] = c; continue; }
	
	      c_len = utf8len(c);
	      // skip 5 & 6 byte codes
	      if (c_len > 4) { utf16buf[out++] = 0xfffd; i += c_len - 1; continue; }
	
	      // apply mask on first byte
	      c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
	      // join the rest
	      while (c_len > 1 && i < len) {
	        c = (c << 6) | (buf[i++] & 0x3f);
	        c_len--;
	      }
	
	      // terminated by end of string?
	      if (c_len > 1) { utf16buf[out++] = 0xfffd; continue; }
	
	      if (c < 0x10000) {
	        utf16buf[out++] = c;
	      } else {
	        c -= 0x10000;
	        utf16buf[out++] = 0xd800 | ((c >> 10) & 0x3ff);
	        utf16buf[out++] = 0xdc00 | (c & 0x3ff);
	      }
	    }
	
	    return _buf2binstring(utf16buf, out);
	  }
	
	
	  // Calculate max possible position in utf8 buffer,
	  // that will not break sequence. If that's not possible
	  // - (very small limits) return max size as is.
	  //
	  // buf[] - utf8 bytes array
	  // max   - length limit (mandatory);
	  function utf8border(buf, max) {
	    var pos;
	
	    max = max || buf.length;
	    if (max > buf.length) { max = buf.length; }
	
	    // go back from last position, until start of sequence found
	    pos = max - 1;
	    while (pos >= 0 && (buf[pos] & 0xC0) === 0x80) { pos--; }
	
	    // Very small and broken sequence,
	    // return max, because we should return something anyway.
	    if (pos < 0) { return max; }
	
	    // If we came to start of buffer - that means buffer is too small,
	    // return max too.
	    if (pos === 0) { return max; }
	
	    return (pos + utf8len(buf[pos]) > max) ? pos : max;
	  }
	
	  /* eslint-disable */
	
	  // Note: adler32 takes 12% for level 0 and 2% for level 6.
	  // It isn't worth it to make additional optimizations as in original.
	  // Small size is preferable.
	
	  // (C) 1995-2013 Jean-loup Gailly and Mark Adler
	  // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	  //
	  // This software is provided 'as-is', without any express or implied
	  // warranty. In no event will the authors be held liable for any damages
	  // arising from the use of this software.
	  //
	  // Permission is granted to anyone to use this software for any purpose,
	  // including commercial applications, and to alter it and redistribute it
	  // freely, subject to the following restrictions:
	  //
	  // 1. The origin of this software must not be misrepresented; you must not
	  //   claim that you wrote the original software. If you use this software
	  //   in a product, an acknowledgment in the product documentation would be
	  //   appreciated but is not required.
	  // 2. Altered source versions must be plainly marked as such, and must not be
	  //   misrepresented as being the original software.
	  // 3. This notice may not be removed or altered from any source distribution.
	
	  function adler32(adler, buf, len, pos) {
	    var s1 = (adler & 0xffff) |0,
	        s2 = ((adler >>> 16) & 0xffff) |0,
	        n = 0;
	
	    while (len !== 0) {
	      // Set limit ~ twice less than 5552, to keep
	      // s2 in 31-bits, because we force signed ints.
	      // in other case %= will fail.
	      n = len > 2000 ? 2000 : len;
	      len -= n;
	
	      do {
	        s1 = (s1 + buf[pos++]) |0;
	        s2 = (s2 + s1) |0;
	      } while (--n);
	
	      s1 %= 65521;
	      s2 %= 65521;
	    }
	
	    return (s1 | (s2 << 16)) |0;
	  }
	
	  /* eslint-disable */
	
	  // Note: we can't get significant speed boost here.
	  // So write code to minimize size - no pregenerated tables
	  // and array tools dependencies.
	
	  // (C) 1995-2013 Jean-loup Gailly and Mark Adler
	  // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	  //
	  // This software is provided 'as-is', without any express or implied
	  // warranty. In no event will the authors be held liable for any damages
	  // arising from the use of this software.
	  //
	  // Permission is granted to anyone to use this software for any purpose,
	  // including commercial applications, and to alter it and redistribute it
	  // freely, subject to the following restrictions:
	  //
	  // 1. The origin of this software must not be misrepresented; you must not
	  //   claim that you wrote the original software. If you use this software
	  //   in a product, an acknowledgment in the product documentation would be
	  //   appreciated but is not required.
	  // 2. Altered source versions must be plainly marked as such, and must not be
	  //   misrepresented as being the original software.
	  // 3. This notice may not be removed or altered from any source distribution.
	
	  // Use ordinary array, since untyped makes no boost here
	  function makeTable() {
	    var c, table = [];
	
	    for (var n = 0; n < 256; n++) {
	      c = n;
	      for (var k = 0; k < 8; k++) {
	        c = ((c & 1) ? (0xEDB88320 ^ (c >>> 1)) : (c >>> 1));
	      }
	      table[n] = c;
	    }
	
	    return table;
	  }
	
	  var crcTable = function() {
	      var table = makeTable();
	      crcTable = function () { return table; };
	      return table;
	  };
	
	  function crc32(crc, buf, len, pos) {
	    var t = crcTable(),
	        end = pos + len;
	
	    crc ^= -1;
	
	    for (var i = pos; i < end; i++) {
	      crc = (crc >>> 8) ^ t[(crc ^ buf[i]) & 0xFF];
	    }
	
	    return (crc ^ (-1)); // >>> 0;
	  }
	
	  /* eslint-disable */
	
	  // (C) 1995-2013 Jean-loup Gailly and Mark Adler
	  // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	  //
	  // This software is provided 'as-is', without any express or implied
	  // warranty. In no event will the authors be held liable for any damages
	  // arising from the use of this software.
	  //
	  // Permission is granted to anyone to use this software for any purpose,
	  // including commercial applications, and to alter it and redistribute it
	  // freely, subject to the following restrictions:
	  //
	  // 1. The origin of this software must not be misrepresented; you must not
	  //   claim that you wrote the original software. If you use this software
	  //   in a product, an acknowledgment in the product documentation would be
	  //   appreciated but is not required.
	  // 2. Altered source versions must be plainly marked as such, and must not be
	  //   misrepresented as being the original software.
	  // 3. This notice may not be removed or altered from any source distribution.
	
	  // See state defs from inflate.js
	  var BAD = 30;       /* got a data error -- remain here until reset */
	  var TYPE = 12;      /* i: waiting for type bits, including last-flag bit */
	
	  /*
	     Decode literal, length, and distance codes and write out the resulting
	     literal and match bytes until either not enough input or output is
	     available, an end-of-block is encountered, or a data error is encountered.
	     When large enough input and output buffers are supplied to inflate(), for
	     example, a 16K input buffer and a 64K output buffer, more than 95% of the
	     inflate execution time is spent in this routine.
	
	     Entry assumptions:
	
	          state.mode === LEN
	          strm.avail_in >= 6
	          strm.avail_out >= 258
	          start >= strm.avail_out
	          state.bits < 8
	
	     On return, state.mode is one of:
	
	          LEN -- ran out of enough output space or enough available input
	          TYPE -- reached end of block code, inflate() to interpret next block
	          BAD -- error in block data
	
	     Notes:
	
	      - The maximum input bits used by a length/distance pair is 15 bits for the
	        length code, 5 bits for the length extra, 15 bits for the distance code,
	        and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
	        Therefore if strm.avail_in >= 6, then there is enough input to avoid
	        checking for available input while decoding.
	
	      - The maximum bytes that a single length/distance pair can output is 258
	        bytes, which is the maximum length that can be coded.  inflate_fast()
	        requires strm.avail_out >= 258 for each loop to avoid checking for
	        output space.
	   */
	  function inflate_fast(strm, start) {
	    var state;
	    var _in;                    /* local strm.input */
	    var last;                   /* have enough input while in < last */
	    var _out;                   /* local strm.output */
	    var beg;                    /* inflate()'s initial strm.output */
	    var end;                    /* while out < end, enough space available */
	  //#ifdef INFLATE_STRICT
	    var dmax;                   /* maximum distance from zlib header */
	  //#endif
	    var wsize;                  /* window size or zero if not using window */
	    var whave;                  /* valid bytes in the window */
	    var wnext;                  /* window write index */
	    // Use `s_window` instead `window`, avoid conflict with instrumentation tools
	    var s_window;               /* allocated sliding window, if wsize != 0 */
	    var hold;                   /* local strm.hold */
	    var bits;                   /* local strm.bits */
	    var lcode;                  /* local strm.lencode */
	    var dcode;                  /* local strm.distcode */
	    var lmask;                  /* mask for first level of length codes */
	    var dmask;                  /* mask for first level of distance codes */
	    var here;                   /* retrieved table entry */
	    var op;                     /* code bits, operation, extra bits, or */
	                                /*  window position, window bytes to copy */
	    var len;                    /* match length, unused bytes */
	    var dist;                   /* match distance */
	    var from;                   /* where to copy match from */
	    var from_source;
	
	
	    var input, output; // JS specific, because we have no pointers
	
	    /* copy state to local variables */
	    state = strm.state;
	    //here = state.here;
	    _in = strm.next_in;
	    input = strm.input;
	    last = _in + (strm.avail_in - 5);
	    _out = strm.next_out;
	    output = strm.output;
	    beg = _out - (start - strm.avail_out);
	    end = _out + (strm.avail_out - 257);
	  //#ifdef INFLATE_STRICT
	    dmax = state.dmax;
	  //#endif
	    wsize = state.wsize;
	    whave = state.whave;
	    wnext = state.wnext;
	    s_window = state.window;
	    hold = state.hold;
	    bits = state.bits;
	    lcode = state.lencode;
	    dcode = state.distcode;
	    lmask = (1 << state.lenbits) - 1;
	    dmask = (1 << state.distbits) - 1;
	
	
	    /* decode literals and length/distances until end-of-block or not enough
	       input data or output space */
	
	    top:
	    do {
	      if (bits < 15) {
	        hold += input[_in++] << bits;
	        bits += 8;
	        hold += input[_in++] << bits;
	        bits += 8;
	      }
	
	      here = lcode[hold & lmask];
	
	      dolen:
	      for (;;) { // Goto emulation
	        op = here >>> 24/*here.bits*/;
	        hold >>>= op;
	        bits -= op;
	        op = (here >>> 16) & 0xff/*here.op*/;
	        if (op === 0) {                          /* literal */
	          //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
	          //        "inflate:         literal '%c'\n" :
	          //        "inflate:         literal 0x%02x\n", here.val));
	          output[_out++] = here & 0xffff/*here.val*/;
	        }
	        else if (op & 16) {                     /* length base */
	          len = here & 0xffff/*here.val*/;
	          op &= 15;                           /* number of extra bits */
	          if (op) {
	            if (bits < op) {
	              hold += input[_in++] << bits;
	              bits += 8;
	            }
	            len += hold & ((1 << op) - 1);
	            hold >>>= op;
	            bits -= op;
	          }
	          //Tracevv((stderr, "inflate:         length %u\n", len));
	          if (bits < 15) {
	            hold += input[_in++] << bits;
	            bits += 8;
	            hold += input[_in++] << bits;
	            bits += 8;
	          }
	          here = dcode[hold & dmask];
	
	          dodist:
	          for (;;) { // goto emulation
	            op = here >>> 24/*here.bits*/;
	            hold >>>= op;
	            bits -= op;
	            op = (here >>> 16) & 0xff/*here.op*/;
	
	            if (op & 16) {                      /* distance base */
	              dist = here & 0xffff/*here.val*/;
	              op &= 15;                       /* number of extra bits */
	              if (bits < op) {
	                hold += input[_in++] << bits;
	                bits += 8;
	                if (bits < op) {
	                  hold += input[_in++] << bits;
	                  bits += 8;
	                }
	              }
	              dist += hold & ((1 << op) - 1);
	  //#ifdef INFLATE_STRICT
	              if (dist > dmax) {
	                strm.msg = 'invalid distance too far back';
	                state.mode = BAD;
	                break top;
	              }
	  //#endif
	              hold >>>= op;
	              bits -= op;
	              //Tracevv((stderr, "inflate:         distance %u\n", dist));
	              op = _out - beg;                /* max distance in output */
	              if (dist > op) {                /* see if copy from window */
	                op = dist - op;               /* distance back in window */
	                if (op > whave) {
	                  if (state.sane) {
	                    strm.msg = 'invalid distance too far back';
	                    state.mode = BAD;
	                    break top;
	                  }
	
	  // (!) This block is disabled in zlib defaults,
	  // don't enable it for binary compatibility
	  //#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
	  //                if (len <= op - whave) {
	  //                  do {
	  //                    output[_out++] = 0;
	  //                  } while (--len);
	  //                  continue top;
	  //                }
	  //                len -= op - whave;
	  //                do {
	  //                  output[_out++] = 0;
	  //                } while (--op > whave);
	  //                if (op === 0) {
	  //                  from = _out - dist;
	  //                  do {
	  //                    output[_out++] = output[from++];
	  //                  } while (--len);
	  //                  continue top;
	  //                }
	  //#endif
	                }
	                from = 0; // window index
	                from_source = s_window;
	                if (wnext === 0) {           /* very common case */
	                  from += wsize - op;
	                  if (op < len) {         /* some from window */
	                    len -= op;
	                    do {
	                      output[_out++] = s_window[from++];
	                    } while (--op);
	                    from = _out - dist;  /* rest from output */
	                    from_source = output;
	                  }
	                }
	                else if (wnext < op) {      /* wrap around window */
	                  from += wsize + wnext - op;
	                  op -= wnext;
	                  if (op < len) {         /* some from end of window */
	                    len -= op;
	                    do {
	                      output[_out++] = s_window[from++];
	                    } while (--op);
	                    from = 0;
	                    if (wnext < len) {  /* some from start of window */
	                      op = wnext;
	                      len -= op;
	                      do {
	                        output[_out++] = s_window[from++];
	                      } while (--op);
	                      from = _out - dist;      /* rest from output */
	                      from_source = output;
	                    }
	                  }
	                }
	                else {                      /* contiguous in window */
	                  from += wnext - op;
	                  if (op < len) {         /* some from window */
	                    len -= op;
	                    do {
	                      output[_out++] = s_window[from++];
	                    } while (--op);
	                    from = _out - dist;  /* rest from output */
	                    from_source = output;
	                  }
	                }
	                while (len > 2) {
	                  output[_out++] = from_source[from++];
	                  output[_out++] = from_source[from++];
	                  output[_out++] = from_source[from++];
	                  len -= 3;
	                }
	                if (len) {
	                  output[_out++] = from_source[from++];
	                  if (len > 1) {
	                    output[_out++] = from_source[from++];
	                  }
	                }
	              }
	              else {
	                from = _out - dist;          /* copy direct from output */
	                do {                        /* minimum length is three */
	                  output[_out++] = output[from++];
	                  output[_out++] = output[from++];
	                  output[_out++] = output[from++];
	                  len -= 3;
	                } while (len > 2);
	                if (len) {
	                  output[_out++] = output[from++];
	                  if (len > 1) {
	                    output[_out++] = output[from++];
	                  }
	                }
	              }
	            }
	            else if ((op & 64) === 0) {          /* 2nd level distance code */
	              here = dcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
	              continue dodist;
	            }
	            else {
	              strm.msg = 'invalid distance code';
	              state.mode = BAD;
	              break top;
	            }
	
	            break; // need to emulate goto via "continue"
	          }
	        }
	        else if ((op & 64) === 0) {              /* 2nd level length code */
	          here = lcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
	          continue dolen;
	        }
	        else if (op & 32) {                     /* end-of-block */
	          //Tracevv((stderr, "inflate:         end of block\n"));
	          state.mode = TYPE;
	          break top;
	        }
	        else {
	          strm.msg = 'invalid literal/length code';
	          state.mode = BAD;
	          break top;
	        }
	
	        break; // need to emulate goto via "continue"
	      }
	    } while (_in < last && _out < end);
	
	    /* return unused bytes (on entry, bits < 8, so in won't go too far back) */
	    len = bits >> 3;
	    _in -= len;
	    bits -= len << 3;
	    hold &= (1 << bits) - 1;
	
	    /* update state and return */
	    strm.next_in = _in;
	    strm.next_out = _out;
	    strm.avail_in = (_in < last ? 5 + (last - _in) : 5 - (_in - last));
	    strm.avail_out = (_out < end ? 257 + (end - _out) : 257 - (_out - end));
	    state.hold = hold;
	    state.bits = bits;
	    return;
	  }
	
	  /* eslint-disable */
	
	  var MAXBITS = 15;
	  var ENOUGH_LENS = 852;
	  var ENOUGH_DISTS = 592;
	  //var ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);
	
	  var CODES = 0;
	  var LENS = 1;
	  var DISTS = 2;
	
	  var lbase = [ /* Length codes 257..285 base */
	    3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31,
	    35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0
	  ];
	
	  var lext = [ /* Length codes 257..285 extra */
	    16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18,
	    19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78
	  ];
	
	  var dbase = [ /* Distance codes 0..29 base */
	    1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193,
	    257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145,
	    8193, 12289, 16385, 24577, 0, 0
	  ];
	
	  var dext = [ /* Distance codes 0..29 extra */
	    16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22,
	    23, 23, 24, 24, 25, 25, 26, 26, 27, 27,
	    28, 28, 29, 29, 64, 64
	  ];
	
	  function inflate_table(type, lens, lens_index, codes, table, table_index, work, opts) {
	    var bits = opts.bits;
	        //here = opts.here; /* table entry for duplication */
	
	    var len = 0;               /* a code's length in bits */
	    var sym = 0;               /* index of code symbols */
	    var min = 0, max = 0;          /* minimum and maximum code lengths */
	    var root = 0;              /* number of index bits for root table */
	    var curr = 0;              /* number of index bits for current table */
	    var drop = 0;              /* code bits to drop for sub-table */
	    var left = 0;                   /* number of prefix codes available */
	    var used = 0;              /* code entries in table used */
	    var huff = 0;              /* Huffman code */
	    var incr;              /* for incrementing code, index */
	    var fill;              /* index for replicating entries */
	    var low;               /* low bits for current root entry */
	    var mask;              /* mask for low root bits */
	    var next;             /* next available space in table */
	    var base = null;     /* base value table to use */
	    var base_index = 0;
	  //  var shoextra;    /* extra bits table to use */
	    var end;                    /* use base and extra for symbol > end */
	    var count = Buf16(MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */
	    var offs = Buf16(MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */
	    var extra = null;
	    var extra_index = 0;
	
	    var here_bits, here_op, here_val;
	
	    /*
	     Process a set of code lengths to create a canonical Huffman code.  The
	     code lengths are lens[0..codes-1].  Each length corresponds to the
	     symbols 0..codes-1.  The Huffman code is generated by first sorting the
	     symbols by length from short to long, and retaining the symbol order
	     for codes with equal lengths.  Then the code starts with all zero bits
	     for the first code of the shortest length, and the codes are integer
	     increments for the same length, and zeros are appended as the length
	     increases.  For the deflate format, these bits are stored backwards
	     from their more natural integer increment ordering, and so when the
	     decoding tables are built in the large loop below, the integer codes
	     are incremented backwards.
	
	     This routine assumes, but does not check, that all of the entries in
	     lens[] are in the range 0..MAXBITS.  The caller must assure this.
	     1..MAXBITS is interpreted as that code length.  zero means that that
	     symbol does not occur in this code.
	
	     The codes are sorted by computing a count of codes for each length,
	     creating from that a table of starting indices for each length in the
	     sorted table, and then entering the symbols in order in the sorted
	     table.  The sorted table is work[], with that space being provided by
	     the caller.
	
	     The length counts are used for other purposes as well, i.e. finding
	     the minimum and maximum length codes, determining if there are any
	     codes at all, checking for a valid set of lengths, and looking ahead
	     at length counts to determine sub-table sizes when building the
	     decoding tables.
	     */
	
	    /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */
	    for (len = 0; len <= MAXBITS; len++) {
	      count[len] = 0;
	    }
	    for (sym = 0; sym < codes; sym++) {
	      count[lens[lens_index + sym]]++;
	    }
	
	    /* bound code lengths, force root to be within code lengths */
	    root = bits;
	    for (max = MAXBITS; max >= 1; max--) {
	      if (count[max] !== 0) { break; }
	    }
	    if (root > max) {
	      root = max;
	    }
	    if (max === 0) {                     /* no symbols to code at all */
	      //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
	      //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
	      //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
	      table[table_index++] = (1 << 24) | (64 << 16) | 0;
	
	
	      //table.op[opts.table_index] = 64;
	      //table.bits[opts.table_index] = 1;
	      //table.val[opts.table_index++] = 0;
	      table[table_index++] = (1 << 24) | (64 << 16) | 0;
	
	      opts.bits = 1;
	      return 0;     /* no symbols, but wait for decoding to report error */
	    }
	    for (min = 1; min < max; min++) {
	      if (count[min] !== 0) { break; }
	    }
	    if (root < min) {
	      root = min;
	    }
	
	    /* check for an over-subscribed or incomplete set of lengths */
	    left = 1;
	    for (len = 1; len <= MAXBITS; len++) {
	      left <<= 1;
	      left -= count[len];
	      if (left < 0) {
	        return -1;
	      }        /* over-subscribed */
	    }
	    if (left > 0 && (type === CODES || max !== 1)) {
	      return -1;                      /* incomplete set */
	    }
	
	    /* generate offsets into symbol table for each length for sorting */
	    offs[1] = 0;
	    for (len = 1; len < MAXBITS; len++) {
	      offs[len + 1] = offs[len] + count[len];
	    }
	
	    /* sort symbols by length, by symbol order within each length */
	    for (sym = 0; sym < codes; sym++) {
	      if (lens[lens_index + sym] !== 0) {
	        work[offs[lens[lens_index + sym]]++] = sym;
	      }
	    }
	
	    /*
	     Create and fill in decoding tables.  In this loop, the table being
	     filled is at next and has curr index bits.  The code being used is huff
	     with length len.  That code is converted to an index by dropping drop
	     bits off of the bottom.  For codes where len is less than drop + curr,
	     those top drop + curr - len bits are incremented through all values to
	     fill the table with replicated entries.
	
	     root is the number of index bits for the root table.  When len exceeds
	     root, sub-tables are created pointed to by the root entry with an index
	     of the low root bits of huff.  This is saved in low to check for when a
	     new sub-table should be started.  drop is zero when the root table is
	     being filled, and drop is root when sub-tables are being filled.
	
	     When a new sub-table is needed, it is necessary to look ahead in the
	     code lengths to determine what size sub-table is needed.  The length
	     counts are used for this, and so count[] is decremented as codes are
	     entered in the tables.
	
	     used keeps track of how many table entries have been allocated from the
	     provided *table space.  It is checked for LENS and DIST tables against
	     the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
	     the initial root table size constants.  See the comments in inftrees.h
	     for more information.
	
	     sym increments through all symbols, and the loop terminates when
	     all codes of length max, i.e. all codes, have been processed.  This
	     routine permits incomplete codes, so another loop after this one fills
	     in the rest of the decoding tables with invalid code markers.
	     */
	
	    /* set up for code type */
	    // poor man optimization - use if-else instead of switch,
	    // to avoid deopts in old v8
	    if (type === CODES) {
	      base = extra = work;    /* dummy value--not used */
	      end = 19;
	
	    } else if (type === LENS) {
	      base = lbase;
	      base_index -= 257;
	      extra = lext;
	      extra_index -= 257;
	      end = 256;
	
	    } else {                    /* DISTS */
	      base = dbase;
	      extra = dext;
	      end = -1;
	    }
	
	    /* initialize opts for loop */
	    huff = 0;                   /* starting code */
	    sym = 0;                    /* starting code symbol */
	    len = min;                  /* starting code length */
	    next = table_index;              /* current table to fill in */
	    curr = root;                /* current table index bits */
	    drop = 0;                   /* current bits to drop from code for index */
	    low = -1;                   /* trigger new sub-table when len > root */
	    used = 1 << root;          /* use root table entries */
	    mask = used - 1;            /* mask for comparing low */
	
	    /* check available table space */
	    if ((type === LENS && used > ENOUGH_LENS) ||
	      (type === DISTS && used > ENOUGH_DISTS)) {
	      return 1;
	    }
	
	    /* process all codes and make table entries */
	    for (;;) {
	      /* create table entry */
	      here_bits = len - drop;
	      if (work[sym] < end) {
	        here_op = 0;
	        here_val = work[sym];
	      }
	      else if (work[sym] > end) {
	        here_op = extra[extra_index + work[sym]];
	        here_val = base[base_index + work[sym]];
	      }
	      else {
	        here_op = 32 + 64;         /* end of block */
	        here_val = 0;
	      }
	
	      /* replicate for those indices with low len bits equal to huff */
	      incr = 1 << (len - drop);
	      fill = 1 << curr;
	      min = fill;                 /* save offset to next table */
	      do {
	        fill -= incr;
	        table[next + (huff >> drop) + fill] = (here_bits << 24) | (here_op << 16) | here_val |0;
	      } while (fill !== 0);
	
	      /* backwards increment the len-bit code huff */
	      incr = 1 << (len - 1);
	      while (huff & incr) {
	        incr >>= 1;
	      }
	      if (incr !== 0) {
	        huff &= incr - 1;
	        huff += incr;
	      } else {
	        huff = 0;
	      }
	
	      /* go to next symbol, update count, len */
	      sym++;
	      if (--count[len] === 0) {
	        if (len === max) { break; }
	        len = lens[lens_index + work[sym]];
	      }
	
	      /* create new sub-table if needed */
	      if (len > root && (huff & mask) !== low) {
	        /* if first time, transition to sub-tables */
	        if (drop === 0) {
	          drop = root;
	        }
	
	        /* increment past last table */
	        next += min;            /* here min is 1 << curr */
	
	        /* determine length of next table */
	        curr = len - drop;
	        left = 1 << curr;
	        while (curr + drop < max) {
	          left -= count[curr + drop];
	          if (left <= 0) { break; }
	          curr++;
	          left <<= 1;
	        }
	
	        /* check for enough space */
	        used += 1 << curr;
	        if ((type === LENS && used > ENOUGH_LENS) ||
	          (type === DISTS && used > ENOUGH_DISTS)) {
	          return 1;
	        }
	
	        /* point entry in root table to sub-table */
	        low = huff & mask;
	        /*table.op[low] = curr;
	        table.bits[low] = root;
	        table.val[low] = next - opts.table_index;*/
	        table[low] = (root << 24) | (curr << 16) | (next - table_index) |0;
	      }
	    }
	
	    /* fill in remaining table entry if code is incomplete (guaranteed to have
	     at most one remaining entry, since if the code is incomplete, the
	     maximum code length that was allowed to get this far is one bit) */
	    if (huff !== 0) {
	      //table.op[next + huff] = 64;            /* invalid code marker */
	      //table.bits[next + huff] = len - drop;
	      //table.val[next + huff] = 0;
	      table[next + huff] = ((len - drop) << 24) | (64 << 16) |0;
	    }
	
	    /* set return parameters */
	    //opts.table_index += used;
	    opts.bits = root;
	    return 0;
	  }
	
	  /* eslint-disable */
	
	  var CODES$1 = 0;
	  var LENS$1 = 1;
	  var DISTS$1 = 2;
	
	  /* Public constants ==========================================================*/
	  /* ===========================================================================*/
	
	
	  /* Allowed flush values; see deflate() and inflate() below for details */
	  //var Z_NO_FLUSH      = 0;
	  //var Z_PARTIAL_FLUSH = 1;
	  //var Z_SYNC_FLUSH    = 2;
	  //var Z_FULL_FLUSH    = 3;
	  var Z_FINISH$1        = 4;
	  var Z_BLOCK$1         = 5;
	  var Z_TREES$1         = 6;
	
	
	  /* Return codes for the compression/decompression functions. Negative values
	   * are errors, positive values are used for special but normal events.
	   */
	  var Z_OK$1            = 0;
	  var Z_STREAM_END$1    = 1;
	  var Z_NEED_DICT$1     = 2;
	  //var Z_ERRNO         = -1;
	  var Z_STREAM_ERROR$1  = -2;
	  var Z_DATA_ERROR$1    = -3;
	  var Z_MEM_ERROR     = -4;
	  var Z_BUF_ERROR$1     = -5;
	  //var Z_VERSION_ERROR = -6;
	
	  /* The deflate compression method */
	  var Z_DEFLATED$1  = 8;
	
	
	  /* STATES ====================================================================*/
	  /* ===========================================================================*/
	
	
	  var    HEAD = 1;       /* i: waiting for magic header */
	  var    FLAGS = 2;      /* i: waiting for method and flags (gzip) */
	  var    TIME = 3;       /* i: waiting for modification time (gzip) */
	  var    OS = 4;         /* i: waiting for extra flags and operating system (gzip) */
	  var    EXLEN = 5;      /* i: waiting for extra length (gzip) */
	  var    EXTRA = 6;      /* i: waiting for extra bytes (gzip) */
	  var    NAME = 7;       /* i: waiting for end of file name (gzip) */
	  var    COMMENT = 8;    /* i: waiting for end of comment (gzip) */
	  var    HCRC = 9;       /* i: waiting for header crc (gzip) */
	  var    DICTID = 10;    /* i: waiting for dictionary check value */
	  var    DICT = 11;      /* waiting for inflateSetDictionary() call */
	  var        TYPE$1 = 12;      /* i: waiting for type bits, including last-flag bit */
	  var        TYPEDO = 13;    /* i: same, but skip check to exit inflate on new block */
	  var        STORED = 14;    /* i: waiting for stored size (length and complement) */
	  var        COPY_ = 15;     /* i/o: same as COPY below, but only first time in */
	  var        COPY = 16;      /* i/o: waiting for input or output to copy stored block */
	  var        TABLE = 17;     /* i: waiting for dynamic block table lengths */
	  var        LENLENS = 18;   /* i: waiting for code length code lengths */
	  var        CODELENS = 19;  /* i: waiting for length/lit and distance code lengths */
	  var            LEN_ = 20;      /* i: same as LEN below, but only first time in */
	  var            LEN = 21;       /* i: waiting for length/lit/eob code */
	  var            LENEXT = 22;    /* i: waiting for length extra bits */
	  var            DIST = 23;      /* i: waiting for distance code */
	  var            DISTEXT = 24;   /* i: waiting for distance extra bits */
	  var            MATCH = 25;     /* o: waiting for output space to copy string */
	  var            LIT = 26;       /* o: waiting for output space to write literal */
	  var    CHECK = 27;     /* i: waiting for 32-bit check value */
	  var    LENGTH = 28;    /* i: waiting for 32-bit length (gzip) */
	  var    DONE = 29;      /* finished check, done -- remain here until reset */
	  var    BAD$1 = 30;       /* got a data error -- remain here until reset */
	  var    MEM = 31;       /* got an inflate() memory error -- remain here until reset */
	  var    SYNC = 32;      /* looking for synchronization bytes to restart inflate() */
	
	  /* ===========================================================================*/
	
	
	
	  var ENOUGH_LENS$1 = 852;
	  var ENOUGH_DISTS$1 = 592;
	
	
	  function zswap32(q) {
	    return  (((q >>> 24) & 0xff) +
	            ((q >>> 8) & 0xff00) +
	            ((q & 0xff00) << 8) +
	            ((q & 0xff) << 24));
	  }
	
	
	  function InflateState() {
	    this.mode = 0;             /* current inflate mode */
	    this.last = false;          /* true if processing last block */
	    this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip */
	    this.havedict = false;      /* true if dictionary provided */
	    this.flags = 0;             /* gzip header method and flags (0 if zlib) */
	    this.dmax = 0;              /* zlib header max distance (INFLATE_STRICT) */
	    this.check = 0;             /* protected copy of check value */
	    this.total = 0;             /* protected copy of output count */
	    // TODO: may be {}
	    this.head = null;           /* where to save gzip header information */
	
	    /* sliding window */
	    this.wbits = 0;             /* log base 2 of requested window size */
	    this.wsize = 0;             /* window size or zero if not using window */
	    this.whave = 0;             /* valid bytes in the window */
	    this.wnext = 0;             /* window write index */
	    this.window = null;         /* allocated sliding window, if needed */
	
	    /* bit accumulator */
	    this.hold = 0;              /* input bit accumulator */
	    this.bits = 0;              /* number of bits in "in" */
	
	    /* for string and stored block copying */
	    this.length = 0;            /* literal or length of data to copy */
	    this.offset = 0;            /* distance back to copy string from */
	
	    /* for table and code decoding */
	    this.extra = 0;             /* extra bits needed */
	
	    /* fixed and dynamic code tables */
	    this.lencode = null;          /* starting table for length/literal codes */
	    this.distcode = null;         /* starting table for distance codes */
	    this.lenbits = 0;           /* index bits for lencode */
	    this.distbits = 0;          /* index bits for distcode */
	
	    /* dynamic table building */
	    this.ncode = 0;             /* number of code length code lengths */
	    this.nlen = 0;              /* number of length code lengths */
	    this.ndist = 0;             /* number of distance code lengths */
	    this.have = 0;              /* number of code lengths in lens[] */
	    this.next = null;              /* next available space in codes[] */
	
	    this.lens = Buf16(320); /* temporary storage for code lengths */
	    this.work = Buf16(288); /* work area for code table building */
	
	    /*
	     because we don't have pointers in js, we use lencode and distcode directly
	     as buffers so we don't need codes
	    */
	    //this.codes = Buf32(ENOUGH);       /* space for code tables */
	    this.lendyn = null;              /* dynamic table for length/literal codes (JS specific) */
	    this.distdyn = null;             /* dynamic table for distance codes (JS specific) */
	    this.sane = 0;                   /* if false, allow invalid distance too far */
	    this.back = 0;                   /* bits back of last unprocessed length/lit */
	    this.was = 0;                    /* initial length of match */
	  }
	
	  function inflateResetKeep(strm) {
	    var state;
	
	    if (!strm || !strm.state) { return Z_STREAM_ERROR$1; }
	    state = strm.state;
	    strm.total_in = strm.total_out = state.total = 0;
	    strm.msg = ''; /*Z_NULL*/
	    if (state.wrap) {       /* to support ill-conceived Java test suite */
	      strm.adler = state.wrap & 1;
	    }
	    state.mode = HEAD;
	    state.last = 0;
	    state.havedict = 0;
	    state.dmax = 32768;
	    state.head = null/*Z_NULL*/;
	    state.hold = 0;
	    state.bits = 0;
	    //state.lencode = state.distcode = state.next = state.codes;
	    state.lencode = state.lendyn = Buf32(ENOUGH_LENS$1);
	    state.distcode = state.distdyn = Buf32(ENOUGH_DISTS$1);
	
	    state.sane = 1;
	    state.back = -1;
	    //Tracev((stderr, "inflate: reset\n"));
	    return Z_OK$1;
	  }
	
	  function inflateReset(strm) {
	    var state;
	
	    if (!strm || !strm.state) { return Z_STREAM_ERROR$1; }
	    state = strm.state;
	    state.wsize = 0;
	    state.whave = 0;
	    state.wnext = 0;
	    return inflateResetKeep(strm);
	
	  }
	
	  function inflateReset2(strm, windowBits) {
	    var wrap;
	    var state;
	
	    /* get the state */
	    if (!strm || !strm.state) { return Z_STREAM_ERROR$1; }
	    state = strm.state;
	
	    /* extract wrap request from windowBits parameter */
	    if (windowBits < 0) {
	      wrap = 0;
	      windowBits = -windowBits;
	    }
	    else {
	      wrap = (windowBits >> 4) + 1;
	      if (windowBits < 48) {
	        windowBits &= 15;
	      }
	    }
	
	    /* set number of window bits, free window if different */
	    if (windowBits && (windowBits < 8 || windowBits > 15)) {
	      return Z_STREAM_ERROR$1;
	    }
	    if (state.window !== null && state.wbits !== windowBits) {
	      state.window = null;
	    }
	
	    /* update state and reset the rest of it */
	    state.wrap = wrap;
	    state.wbits = windowBits;
	    return inflateReset(strm);
	  }
	
	  function inflateInit2(strm, windowBits) {
	    var ret;
	    var state;
	
	    if (!strm) { return Z_STREAM_ERROR$1; }
	    //strm.msg = Z_NULL;                 /* in case we return an error */
	
	    state = new InflateState();
	
	    //if (state === Z_NULL) return Z_MEM_ERROR;
	    //Tracev((stderr, "inflate: allocated\n"));
	    strm.state = state;
	    state.window = null/*Z_NULL*/;
	    ret = inflateReset2(strm, windowBits);
	    if (ret !== Z_OK$1) {
	      strm.state = null/*Z_NULL*/;
	    }
	    return ret;
	  }
	
	
	  /*
	   Return state with length and distance decoding tables and index sizes set to
	   fixed code decoding.  Normally this returns fixed tables from inffixed.h.
	   If BUILDFIXED is defined, then instead this routine builds the tables the
	   first time it's called, and returns those tables the first time and
	   thereafter.  This reduces the size of the code by about 2K bytes, in
	   exchange for a little execution time.  However, BUILDFIXED should not be
	   used for threaded applications, since the rewriting of the tables and virgin
	   may not be thread-safe.
	   */
	  var virgin = true;
	
	  var lenfix, distfix; // We have no pointers in JS, so keep tables separate
	
	  function fixedtables(state) {
	    /* build fixed huffman tables if first call (may not be thread safe) */
	    if (virgin) {
	      var sym;
	
	      lenfix = Buf32(512);
	      distfix = Buf32(32);
	
	      /* literal/length table */
	      sym = 0;
	      while (sym < 144) { state.lens[sym++] = 8; }
	      while (sym < 256) { state.lens[sym++] = 9; }
	      while (sym < 280) { state.lens[sym++] = 7; }
	      while (sym < 288) { state.lens[sym++] = 8; }
	
	      inflate_table(LENS$1,  state.lens, 0, 288, lenfix,   0, state.work, { bits: 9 });
	
	      /* distance table */
	      sym = 0;
	      while (sym < 32) { state.lens[sym++] = 5; }
	
	      inflate_table(DISTS$1, state.lens, 0, 32,   distfix, 0, state.work, { bits: 5 });
	
	      /* do this just once */
	      virgin = false;
	    }
	
	    state.lencode = lenfix;
	    state.lenbits = 9;
	    state.distcode = distfix;
	    state.distbits = 5;
	  }
	
	
	  /*
	   Update the window with the last wsize (normally 32K) bytes written before
	   returning.  If window does not exist yet, create it.  This is only called
	   when a window is already in use, or when output has been written during this
	   inflate call, but the end of the deflate stream has not been reached yet.
	   It is also called to create a window for dictionary data when a dictionary
	   is loaded.
	
	   Providing output buffers larger than 32K to inflate() should provide a speed
	   advantage, since only the last 32K of output is copied to the sliding window
	   upon return from inflate(), and since all distances after the first 32K of
	   output will fall in the output data, making match copies simpler and faster.
	   The advantage may be dependent on the size of the processor's data caches.
	   */
	  function updatewindow(strm, src, end, copy) {
	    var dist;
	    var state = strm.state;
	
	    /* if it hasn't been done already, allocate space for the window */
	    if (state.window === null) {
	      state.wsize = 1 << state.wbits;
	      state.wnext = 0;
	      state.whave = 0;
	
	      state.window = Buf8(state.wsize);
	    }
	
	    /* copy state->wsize or less output bytes into the circular window */
	    if (copy >= state.wsize) {
	      arraySet(state.window, src, end - state.wsize, state.wsize, 0);
	      state.wnext = 0;
	      state.whave = state.wsize;
	    }
	    else {
	      dist = state.wsize - state.wnext;
	      if (dist > copy) {
	        dist = copy;
	      }
	      //zmemcpy(state->window + state->wnext, end - copy, dist);
	      arraySet(state.window, src, end - copy, dist, state.wnext);
	      copy -= dist;
	      if (copy) {
	        //zmemcpy(state->window, end - copy, copy);
	        arraySet(state.window, src, end - copy, copy, 0);
	        state.wnext = copy;
	        state.whave = state.wsize;
	      }
	      else {
	        state.wnext += dist;
	        if (state.wnext === state.wsize) { state.wnext = 0; }
	        if (state.whave < state.wsize) { state.whave += dist; }
	      }
	    }
	    return 0;
	  }
	
	  function inflate(strm, flush) {
	    var state;
	    var input, output;          // input/output buffers
	    var next;                   /* next input INDEX */
	    var put;                    /* next output INDEX */
	    var have, left;             /* available input and output */
	    var hold;                   /* bit buffer */
	    var bits;                   /* bits in bit buffer */
	    var _in, _out;              /* save starting available input and output */
	    var copy;                   /* number of stored or match bytes to copy */
	    var from;                   /* where to copy match bytes from */
	    var from_source;
	    var here = 0;               /* current decoding table entry */
	    var here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
	    //var last;                   /* parent table entry */
	    var last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
	    var len;                    /* length to copy for repeats, bits to drop */
	    var ret;                    /* return code */
	    var hbuf = Buf8(4);    /* buffer for gzip header crc calculation */
	    var opts;
	
	    var n; // temporary var for NEED_BITS
	
	    var order = /* permutation of code lengths */
	      [ 16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15 ];
	
	
	    if (!strm || !strm.state || !strm.output ||
	        (!strm.input && strm.avail_in !== 0)) {
	      return Z_STREAM_ERROR$1;
	    }
	
	    state = strm.state;
	    if (state.mode === TYPE$1) { state.mode = TYPEDO; }    /* skip check */
	
	
	    //--- LOAD() ---
	    put = strm.next_out;
	    output = strm.output;
	    left = strm.avail_out;
	    next = strm.next_in;
	    input = strm.input;
	    have = strm.avail_in;
	    hold = state.hold;
	    bits = state.bits;
	    //---
	
	    _in = have;
	    _out = left;
	    ret = Z_OK$1;
	
	    inf_leave: // goto emulation
	    for (;;) {
	      switch (state.mode) {
	        case HEAD:
	          if (state.wrap === 0) {
	            state.mode = TYPEDO;
	            break;
	          }
	          //=== NEEDBITS(16);
	          while (bits < 16) {
	            if (have === 0) { break inf_leave; }
	            have--;
	            hold += input[next++] << bits;
	            bits += 8;
	          }
	          //===//
	          if ((state.wrap & 2) && hold === 0x8b1f) {  /* gzip header */
	            state.check = 0/*crc32(0L, Z_NULL, 0)*/;
	            //=== CRC2(state.check, hold);
	            hbuf[0] = hold & 0xff;
	            hbuf[1] = (hold >>> 8) & 0xff;
	            state.check = crc32(state.check, hbuf, 2, 0);
	            //===//
	
	            //=== INITBITS();
	            hold = 0;
	            bits = 0;
	            //===//
	            state.mode = FLAGS;
	            break;
	          }
	          state.flags = 0;           /* expect zlib header */
	          if (state.head) {
	            state.head.done = false;
	          }
	          if (!(state.wrap & 1) ||   /* check if zlib header allowed */
	            (((hold & 0xff)/*BITS(8)*/ << 8) + (hold >> 8)) % 31) {
	            strm.msg = 'incorrect header check';
	            state.mode = BAD$1;
	            break;
	          }
	          if ((hold & 0x0f)/*BITS(4)*/ !== Z_DEFLATED$1) {
	            strm.msg = 'unknown compression method';
	            state.mode = BAD$1;
	            break;
	          }
	          //--- DROPBITS(4) ---//
	          hold >>>= 4;
	          bits -= 4;
	          //---//
	          len = (hold & 0x0f)/*BITS(4)*/ + 8;
	          if (state.wbits === 0) {
	            state.wbits = len;
	          }
	          else if (len > state.wbits) {
	            strm.msg = 'invalid window size';
	            state.mode = BAD$1;
	            break;
	          }
	          state.dmax = 1 << len;
	          //Tracev((stderr, "inflate:   zlib header ok\n"));
	          strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
	          state.mode = hold & 0x200 ? DICTID : TYPE$1;
	          //=== INITBITS();
	          hold = 0;
	          bits = 0;
	          //===//
	          break;
	        case FLAGS:
	          //=== NEEDBITS(16); */
	          while (bits < 16) {
	            if (have === 0) { break inf_leave; }
	            have--;
	            hold += input[next++] << bits;
	            bits += 8;
	          }
	          //===//
	          state.flags = hold;
	          if ((state.flags & 0xff) !== Z_DEFLATED$1) {
	            strm.msg = 'unknown compression method';
	            state.mode = BAD$1;
	            break;
	          }
	          if (state.flags & 0xe000) {
	            strm.msg = 'unknown header flags set';
	            state.mode = BAD$1;
	            break;
	          }
	          if (state.head) {
	            state.head.text = ((hold >> 8) & 1);
	          }
	          if (state.flags & 0x0200) {
	            //=== CRC2(state.check, hold);
	            hbuf[0] = hold & 0xff;
	            hbuf[1] = (hold >>> 8) & 0xff;
	            state.check = crc32(state.check, hbuf, 2, 0);
	            //===//
	          }
	          //=== INITBITS();
	          hold = 0;
	          bits = 0;
	          //===//
	          state.mode = TIME;
	          /* falls through */
	        case TIME:
	          //=== NEEDBITS(32); */
	          while (bits < 32) {
	            if (have === 0) { break inf_leave; }
	            have--;
	            hold += input[next++] << bits;
	            bits += 8;
	          }
	          //===//
	          if (state.head) {
	            state.head.time = hold;
	          }
	          if (state.flags & 0x0200) {
	            //=== CRC4(state.check, hold)
	            hbuf[0] = hold & 0xff;
	            hbuf[1] = (hold >>> 8) & 0xff;
	            hbuf[2] = (hold >>> 16) & 0xff;
	            hbuf[3] = (hold >>> 24) & 0xff;
	            state.check = crc32(state.check, hbuf, 4, 0);
	            //===
	          }
	          //=== INITBITS();
	          hold = 0;
	          bits = 0;
	          //===//
	          state.mode = OS;
	          /* falls through */
	        case OS:
	          //=== NEEDBITS(16); */
	          while (bits < 16) {
	            if (have === 0) { break inf_leave; }
	            have--;
	            hold += input[next++] << bits;
	            bits += 8;
	          }
	          //===//
	          if (state.head) {
	            state.head.xflags = (hold & 0xff);
	            state.head.os = (hold >> 8);
	          }
	          if (state.flags & 0x0200) {
	            //=== CRC2(state.check, hold);
	            hbuf[0] = hold & 0xff;
	            hbuf[1] = (hold >>> 8) & 0xff;
	            state.check = crc32(state.check, hbuf, 2, 0);
	            //===//
	          }
	          //=== INITBITS();
	          hold = 0;
	          bits = 0;
	          //===//
	          state.mode = EXLEN;
	          /* falls through */
	        case EXLEN:
	          if (state.flags & 0x0400) {
	            //=== NEEDBITS(16); */
	            while (bits < 16) {
	              if (have === 0) { break inf_leave; }
	              have--;
	              hold += input[next++] << bits;
	              bits += 8;
	            }
	            //===//
	            state.length = hold;
	            if (state.head) {
	              state.head.extra_len = hold;
	            }
	            if (state.flags & 0x0200) {
	              //=== CRC2(state.check, hold);
	              hbuf[0] = hold & 0xff;
	              hbuf[1] = (hold >>> 8) & 0xff;
	              state.check = crc32(state.check, hbuf, 2, 0);
	              //===//
	            }
	            //=== INITBITS();
	            hold = 0;
	            bits = 0;
	            //===//
	          }
	          else if (state.head) {
	            state.head.extra = null/*Z_NULL*/;
	          }
	          state.mode = EXTRA;
	          /* falls through */
	        case EXTRA:
	          if (state.flags & 0x0400) {
	            copy = state.length;
	            if (copy > have) { copy = have; }
	            if (copy) {
	              if (state.head) {
	                len = state.head.extra_len - state.length;
	                if (!state.head.extra) {
	                  // Use untyped array for more convenient processing later
	                  state.head.extra = new Array(state.head.extra_len);
	                }
	                arraySet(
	                  state.head.extra,
	                  input,
	                  next,
	                  // extra field is limited to 65536 bytes
	                  // - no need for additional size check
	                  copy,
	                  /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
	                  len
	                );
	                //zmemcpy(state.head.extra + len, next,
	                //        len + copy > state.head.extra_max ?
	                //        state.head.extra_max - len : copy);
	              }
	              if (state.flags & 0x0200) {
	                state.check = crc32(state.check, input, copy, next);
	              }
	              have -= copy;
	              next += copy;
	              state.length -= copy;
	            }
	            if (state.length) { break inf_leave; }
	          }
	          state.length = 0;
	          state.mode = NAME;
	          /* falls through */
	        case NAME:
	          if (state.flags & 0x0800) {
	            if (have === 0) { break inf_leave; }
	            copy = 0;
	            do {
	              // TODO: 2 or 1 bytes?
	              len = input[next + copy++];
	              /* use constant limit because in js we should not preallocate memory */
	              if (state.head && len &&
	                  (state.length < 65536 /*state.head.name_max*/)) {
	                state.head.name += String.fromCharCode(len);
	              }
	            } while (len && copy < have);
	
	            if (state.flags & 0x0200) {
	              state.check = crc32(state.check, input, copy, next);
	            }
	            have -= copy;
	            next += copy;
	            if (len) { break inf_leave; }
	          }
	          else if (state.head) {
	            state.head.name = null;
	          }
	          state.length = 0;
	          state.mode = COMMENT;
	          /* falls through */
	        case COMMENT:
	          if (state.flags & 0x1000) {
	            if (have === 0) { break inf_leave; }
	            copy = 0;
	            do {
	              len = input[next + copy++];
	              /* use constant limit because in js we should not preallocate memory */
	              if (state.head && len &&
	                  (state.length < 65536 /*state.head.comm_max*/)) {
	                state.head.comment += String.fromCharCode(len);
	              }
	            } while (len && copy < have);
	            if (state.flags & 0x0200) {
	              state.check = crc32(state.check, input, copy, next);
	            }
	            have -= copy;
	            next += copy;
	            if (len) { break inf_leave; }
	          }
	          else if (state.head) {
	            state.head.comment = null;
	          }
	          state.mode = HCRC;
	          /* falls through */
	        case HCRC:
	          if (state.flags & 0x0200) {
	            //=== NEEDBITS(16); */
	            while (bits < 16) {
	              if (have === 0) { break inf_leave; }
	              have--;
	              hold += input[next++] << bits;
	              bits += 8;
	            }
	            //===//
	            if (hold !== (state.check & 0xffff)) {
	              strm.msg = 'header crc mismatch';
	              state.mode = BAD$1;
	              break;
	            }
	            //=== INITBITS();
	            hold = 0;
	            bits = 0;
	            //===//
	          }
	          if (state.head) {
	            state.head.hcrc = ((state.flags >> 9) & 1);
	            state.head.done = true;
	          }
	          strm.adler = state.check = 0;
	          state.mode = TYPE$1;
	          break;
	        case DICTID:
	          //=== NEEDBITS(32); */
	          while (bits < 32) {
	            if (have === 0) { break inf_leave; }
	            have--;
	            hold += input[next++] << bits;
	            bits += 8;
	          }
	          //===//
	          strm.adler = state.check = zswap32(hold);
	          //=== INITBITS();
	          hold = 0;
	          bits = 0;
	          //===//
	          state.mode = DICT;
	          /* falls through */
	        case DICT:
	          if (state.havedict === 0) {
	            //--- RESTORE() ---
	            strm.next_out = put;
	            strm.avail_out = left;
	            strm.next_in = next;
	            strm.avail_in = have;
	            state.hold = hold;
	            state.bits = bits;
	            //---
	            return Z_NEED_DICT$1;
	          }
	          strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
	          state.mode = TYPE$1;
	          /* falls through */
	        case TYPE$1:
	          if (flush === Z_BLOCK$1 || flush === Z_TREES$1) { break inf_leave; }
	          /* falls through */
	        case TYPEDO:
	          if (state.last) {
	            //--- BYTEBITS() ---//
	            hold >>>= bits & 7;
	            bits -= bits & 7;
	            //---//
	            state.mode = CHECK;
	            break;
	          }
	          //=== NEEDBITS(3); */
	          while (bits < 3) {
	            if (have === 0) { break inf_leave; }
	            have--;
	            hold += input[next++] << bits;
	            bits += 8;
	          }
	          //===//
	          state.last = (hold & 0x01)/*BITS(1)*/;
	          //--- DROPBITS(1) ---//
	          hold >>>= 1;
	          bits -= 1;
	          //---//
	
	          switch ((hold & 0x03)/*BITS(2)*/) {
	            case 0:                             /* stored block */
	              //Tracev((stderr, "inflate:     stored block%s\n",
	              //        state.last ? " (last)" : ""));
	              state.mode = STORED;
	              break;
	            case 1:                             /* fixed block */
	              fixedtables(state);
	              //Tracev((stderr, "inflate:     fixed codes block%s\n",
	              //        state.last ? " (last)" : ""));
	              state.mode = LEN_;             /* decode codes */
	              if (flush === Z_TREES$1) {
	                //--- DROPBITS(2) ---//
	                hold >>>= 2;
	                bits -= 2;
	                //---//
	                break inf_leave;
	              }
	              break;
	            case 2:                             /* dynamic block */
	              //Tracev((stderr, "inflate:     dynamic codes block%s\n",
	              //        state.last ? " (last)" : ""));
	              state.mode = TABLE;
	              break;
	            case 3:
	              strm.msg = 'invalid block type';
	              state.mode = BAD$1;
	          }
	          //--- DROPBITS(2) ---//
	          hold >>>= 2;
	          bits -= 2;
	          //---//
	          break;
	        case STORED:
	          //--- BYTEBITS() ---// /* go to byte boundary */
	          hold >>>= bits & 7;
	          bits -= bits & 7;
	          //---//
	          //=== NEEDBITS(32); */
	          while (bits < 32) {
	            if (have === 0) { break inf_leave; }
	            have--;
	            hold += input[next++] << bits;
	            bits += 8;
	          }
	          //===//
	          if ((hold & 0xffff) !== ((hold >>> 16) ^ 0xffff)) {
	            strm.msg = 'invalid stored block lengths';
	            state.mode = BAD$1;
	            break;
	          }
	          state.length = hold & 0xffff;
	          //Tracev((stderr, "inflate:       stored length %u\n",
	          //        state.length));
	          //=== INITBITS();
	          hold = 0;
	          bits = 0;
	          //===//
	          state.mode = COPY_;
	          if (flush === Z_TREES$1) { break inf_leave; }
	          /* falls through */
	        case COPY_:
	          state.mode = COPY;
	          /* falls through */
	        case COPY:
	          copy = state.length;
	          if (copy) {
	            if (copy > have) { copy = have; }
	            if (copy > left) { copy = left; }
	            if (copy === 0) { break inf_leave; }
	            //--- zmemcpy(put, next, copy); ---
	            arraySet(output, input, next, copy, put);
	            //---//
	            have -= copy;
	            next += copy;
	            left -= copy;
	            put += copy;
	            state.length -= copy;
	            break;
	          }
	          //Tracev((stderr, "inflate:       stored end\n"));
	          state.mode = TYPE$1;
	          break;
	        case TABLE:
	          //=== NEEDBITS(14); */
	          while (bits < 14) {
	            if (have === 0) { break inf_leave; }
	            have--;
	            hold += input[next++] << bits;
	            bits += 8;
	          }
	          //===//
	          state.nlen = (hold & 0x1f)/*BITS(5)*/ + 257;
	          //--- DROPBITS(5) ---//
	          hold >>>= 5;
	          bits -= 5;
	          //---//
	          state.ndist = (hold & 0x1f)/*BITS(5)*/ + 1;
	          //--- DROPBITS(5) ---//
	          hold >>>= 5;
	          bits -= 5;
	          //---//
	          state.ncode = (hold & 0x0f)/*BITS(4)*/ + 4;
	          //--- DROPBITS(4) ---//
	          hold >>>= 4;
	          bits -= 4;
	          //---//
	  //#ifndef PKZIP_BUG_WORKAROUND
	          if (state.nlen > 286 || state.ndist > 30) {
	            strm.msg = 'too many length or distance symbols';
	            state.mode = BAD$1;
	            break;
	          }
	  //#endif
	          //Tracev((stderr, "inflate:       table sizes ok\n"));
	          state.have = 0;
	          state.mode = LENLENS;
	          /* falls through */
	        case LENLENS:
	          while (state.have < state.ncode) {
	            //=== NEEDBITS(3);
	            while (bits < 3) {
	              if (have === 0) { break inf_leave; }
	              have--;
	              hold += input[next++] << bits;
	              bits += 8;
	            }
	            //===//
	            state.lens[order[state.have++]] = (hold & 0x07);//BITS(3);
	            //--- DROPBITS(3) ---//
	            hold >>>= 3;
	            bits -= 3;
	            //---//
	          }
	          while (state.have < 19) {
	            state.lens[order[state.have++]] = 0;
	          }
	          // We have separate tables & no pointers. 2 commented lines below not needed.
	          //state.next = state.codes;
	          //state.lencode = state.next;
	          // Switch to use dynamic table
	          state.lencode = state.lendyn;
	          state.lenbits = 7;
	
	          opts = { bits: state.lenbits };
	          ret = inflate_table(CODES$1, state.lens, 0, 19, state.lencode, 0, state.work, opts);
	          state.lenbits = opts.bits;
	
	          if (ret) {
	            strm.msg = 'invalid code lengths set';
	            state.mode = BAD$1;
	            break;
	          }
	          //Tracev((stderr, "inflate:       code lengths ok\n"));
	          state.have = 0;
	          state.mode = CODELENS;
	          /* falls through */
	        case CODELENS:
	          while (state.have < state.nlen + state.ndist) {
	            for (;;) {
	              here = state.lencode[hold & ((1 << state.lenbits) - 1)];/*BITS(state.lenbits)*/
	              here_bits = here >>> 24;
	              here_op = (here >>> 16) & 0xff;
	              here_val = here & 0xffff;
	
	              if ((here_bits) <= bits) { break; }
	              //--- PULLBYTE() ---//
	              if (have === 0) { break inf_leave; }
	              have--;
	              hold += input[next++] << bits;
	              bits += 8;
	              //---//
	            }
	            if (here_val < 16) {
	              //--- DROPBITS(here.bits) ---//
	              hold >>>= here_bits;
	              bits -= here_bits;
	              //---//
	              state.lens[state.have++] = here_val;
	            }
	            else {
	              if (here_val === 16) {
	                //=== NEEDBITS(here.bits + 2);
	                n = here_bits + 2;
	                while (bits < n) {
	                  if (have === 0) { break inf_leave; }
	                  have--;
	                  hold += input[next++] << bits;
	                  bits += 8;
	                }
	                //===//
	                //--- DROPBITS(here.bits) ---//
	                hold >>>= here_bits;
	                bits -= here_bits;
	                //---//
	                if (state.have === 0) {
	                  strm.msg = 'invalid bit length repeat';
	                  state.mode = BAD$1;
	                  break;
	                }
	                len = state.lens[state.have - 1];
	                copy = 3 + (hold & 0x03);//BITS(2);
	                //--- DROPBITS(2) ---//
	                hold >>>= 2;
	                bits -= 2;
	                //---//
	              }
	              else if (here_val === 17) {
	                //=== NEEDBITS(here.bits + 3);
	                n = here_bits + 3;
	                while (bits < n) {
	                  if (have === 0) { break inf_leave; }
	                  have--;
	                  hold += input[next++] << bits;
	                  bits += 8;
	                }
	                //===//
	                //--- DROPBITS(here.bits) ---//
	                hold >>>= here_bits;
	                bits -= here_bits;
	                //---//
	                len = 0;
	                copy = 3 + (hold & 0x07);//BITS(3);
	                //--- DROPBITS(3) ---//
	                hold >>>= 3;
	                bits -= 3;
	                //---//
	              }
	              else {
	                //=== NEEDBITS(here.bits + 7);
	                n = here_bits + 7;
	                while (bits < n) {
	                  if (have === 0) { break inf_leave; }
	                  have--;
	                  hold += input[next++] << bits;
	                  bits += 8;
	                }
	                //===//
	                //--- DROPBITS(here.bits) ---//
	                hold >>>= here_bits;
	                bits -= here_bits;
	                //---//
	                len = 0;
	                copy = 11 + (hold & 0x7f);//BITS(7);
	                //--- DROPBITS(7) ---//
	                hold >>>= 7;
	                bits -= 7;
	                //---//
	              }
	              if (state.have + copy > state.nlen + state.ndist) {
	                strm.msg = 'invalid bit length repeat';
	                state.mode = BAD$1;
	                break;
	              }
	              while (copy--) {
	                state.lens[state.have++] = len;
	              }
	            }
	          }
	
	          /* handle error breaks in while */
	          if (state.mode === BAD$1) { break; }
	
	          /* check for end-of-block code (better have one) */
	          if (state.lens[256] === 0) {
	            strm.msg = 'invalid code -- missing end-of-block';
	            state.mode = BAD$1;
	            break;
	          }
	
	          /* build code tables -- note: do not change the lenbits or distbits
	             values here (9 and 6) without reading the comments in inftrees.h
	             concerning the ENOUGH constants, which depend on those values */
	          state.lenbits = 9;
	
	          opts = { bits: state.lenbits };
	          ret = inflate_table(LENS$1, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
	          // We have separate tables & no pointers. 2 commented lines below not needed.
	          // state.next_index = opts.table_index;
	          state.lenbits = opts.bits;
	          // state.lencode = state.next;
	
	          if (ret) {
	            strm.msg = 'invalid literal/lengths set';
	            state.mode = BAD$1;
	            break;
	          }
	
	          state.distbits = 6;
	          //state.distcode.copy(state.codes);
	          // Switch to use dynamic table
	          state.distcode = state.distdyn;
	          opts = { bits: state.distbits };
	          ret = inflate_table(DISTS$1, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
	          // We have separate tables & no pointers. 2 commented lines below not needed.
	          // state.next_index = opts.table_index;
	          state.distbits = opts.bits;
	          // state.distcode = state.next;
	
	          if (ret) {
	            strm.msg = 'invalid distances set';
	            state.mode = BAD$1;
	            break;
	          }
	          //Tracev((stderr, 'inflate:       codes ok\n'));
	          state.mode = LEN_;
	          if (flush === Z_TREES$1) { break inf_leave; }
	          /* falls through */
	        case LEN_:
	          state.mode = LEN;
	          /* falls through */
	        case LEN:
	          if (have >= 6 && left >= 258) {
	            //--- RESTORE() ---
	            strm.next_out = put;
	            strm.avail_out = left;
	            strm.next_in = next;
	            strm.avail_in = have;
	            state.hold = hold;
	            state.bits = bits;
	            //---
	            inflate_fast(strm, _out);
	            //--- LOAD() ---
	            put = strm.next_out;
	            output = strm.output;
	            left = strm.avail_out;
	            next = strm.next_in;
	            input = strm.input;
	            have = strm.avail_in;
	            hold = state.hold;
	            bits = state.bits;
	            //---
	
	            if (state.mode === TYPE$1) {
	              state.back = -1;
	            }
	            break;
	          }
	          state.back = 0;
	          for (;;) {
	            here = state.lencode[hold & ((1 << state.lenbits) - 1)];  /*BITS(state.lenbits)*/
	            here_bits = here >>> 24;
	            here_op = (here >>> 16) & 0xff;
	            here_val = here & 0xffff;
	
	            if (here_bits <= bits) { break; }
	            //--- PULLBYTE() ---//
	            if (have === 0) { break inf_leave; }
	            have--;
	            hold += input[next++] << bits;
	            bits += 8;
	            //---//
	          }
	          if (here_op && (here_op & 0xf0) === 0) {
	            last_bits = here_bits;
	            last_op = here_op;
	            last_val = here_val;
	            for (;;) {
	              here = state.lencode[last_val +
	                      ((hold & ((1 << (last_bits + last_op)) - 1))/*BITS(last.bits + last.op)*/ >> last_bits)];
	              here_bits = here >>> 24;
	              here_op = (here >>> 16) & 0xff;
	              here_val = here & 0xffff;
	
	              if ((last_bits + here_bits) <= bits) { break; }
	              //--- PULLBYTE() ---//
	              if (have === 0) { break inf_leave; }
	              have--;
	              hold += input[next++] << bits;
	              bits += 8;
	              //---//
	            }
	            //--- DROPBITS(last.bits) ---//
	            hold >>>= last_bits;
	            bits -= last_bits;
	            //---//
	            state.back += last_bits;
	          }
	          //--- DROPBITS(here.bits) ---//
	          hold >>>= here_bits;
	          bits -= here_bits;
	          //---//
	          state.back += here_bits;
	          state.length = here_val;
	          if (here_op === 0) {
	            //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
	            //        "inflate:         literal '%c'\n" :
	            //        "inflate:         literal 0x%02x\n", here.val));
	            state.mode = LIT;
	            break;
	          }
	          if (here_op & 32) {
	            //Tracevv((stderr, "inflate:         end of block\n"));
	            state.back = -1;
	            state.mode = TYPE$1;
	            break;
	          }
	          if (here_op & 64) {
	            strm.msg = 'invalid literal/length code';
	            state.mode = BAD$1;
	            break;
	          }
	          state.extra = here_op & 15;
	          state.mode = LENEXT;
	          /* falls through */
	        case LENEXT:
	          if (state.extra) {
	            //=== NEEDBITS(state.extra);
	            n = state.extra;
	            while (bits < n) {
	              if (have === 0) { break inf_leave; }
	              have--;
	              hold += input[next++] << bits;
	              bits += 8;
	            }
	            //===//
	            state.length += hold & ((1 << state.extra) - 1)/*BITS(state.extra)*/;
	            //--- DROPBITS(state.extra) ---//
	            hold >>>= state.extra;
	            bits -= state.extra;
	            //---//
	            state.back += state.extra;
	          }
	          //Tracevv((stderr, "inflate:         length %u\n", state.length));
	          state.was = state.length;
	          state.mode = DIST;
	          /* falls through */
	        case DIST:
	          for (;;) {
	            here = state.distcode[hold & ((1 << state.distbits) - 1)];/*BITS(state.distbits)*/
	            here_bits = here >>> 24;
	            here_op = (here >>> 16) & 0xff;
	            here_val = here & 0xffff;
	
	            if ((here_bits) <= bits) { break; }
	            //--- PULLBYTE() ---//
	            if (have === 0) { break inf_leave; }
	            have--;
	            hold += input[next++] << bits;
	            bits += 8;
	            //---//
	          }
	          if ((here_op & 0xf0) === 0) {
	            last_bits = here_bits;
	            last_op = here_op;
	            last_val = here_val;
	            for (;;) {
	              here = state.distcode[last_val +
	                      ((hold & ((1 << (last_bits + last_op)) - 1))/*BITS(last.bits + last.op)*/ >> last_bits)];
	              here_bits = here >>> 24;
	              here_op = (here >>> 16) & 0xff;
	              here_val = here & 0xffff;
	
	              if ((last_bits + here_bits) <= bits) { break; }
	              //--- PULLBYTE() ---//
	              if (have === 0) { break inf_leave; }
	              have--;
	              hold += input[next++] << bits;
	              bits += 8;
	              //---//
	            }
	            //--- DROPBITS(last.bits) ---//
	            hold >>>= last_bits;
	            bits -= last_bits;
	            //---//
	            state.back += last_bits;
	          }
	          //--- DROPBITS(here.bits) ---//
	          hold >>>= here_bits;
	          bits -= here_bits;
	          //---//
	          state.back += here_bits;
	          if (here_op & 64) {
	            strm.msg = 'invalid distance code';
	            state.mode = BAD$1;
	            break;
	          }
	          state.offset = here_val;
	          state.extra = (here_op) & 15;
	          state.mode = DISTEXT;
	          /* falls through */
	        case DISTEXT:
	          if (state.extra) {
	            //=== NEEDBITS(state.extra);
	            n = state.extra;
	            while (bits < n) {
	              if (have === 0) { break inf_leave; }
	              have--;
	              hold += input[next++] << bits;
	              bits += 8;
	            }
	            //===//
	            state.offset += hold & ((1 << state.extra) - 1)/*BITS(state.extra)*/;
	            //--- DROPBITS(state.extra) ---//
	            hold >>>= state.extra;
	            bits -= state.extra;
	            //---//
	            state.back += state.extra;
	          }
	  //#ifdef INFLATE_STRICT
	          if (state.offset > state.dmax) {
	            strm.msg = 'invalid distance too far back';
	            state.mode = BAD$1;
	            break;
	          }
	  //#endif
	          //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
	          state.mode = MATCH;
	          /* falls through */
	        case MATCH:
	          if (left === 0) { break inf_leave; }
	          copy = _out - left;
	          if (state.offset > copy) {         /* copy from window */
	            copy = state.offset - copy;
	            if (copy > state.whave) {
	              if (state.sane) {
	                strm.msg = 'invalid distance too far back';
	                state.mode = BAD$1;
	                break;
	              }
	  // (!) This block is disabled in zlib defaults,
	  // don't enable it for binary compatibility
	  //#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
	  //          Trace((stderr, "inflate.c too far\n"));
	  //          copy -= state.whave;
	  //          if (copy > state.length) { copy = state.length; }
	  //          if (copy > left) { copy = left; }
	  //          left -= copy;
	  //          state.length -= copy;
	  //          do {
	  //            output[put++] = 0;
	  //          } while (--copy);
	  //          if (state.length === 0) { state.mode = LEN; }
	  //          break;
	  //#endif
	            }
	            if (copy > state.wnext) {
	              copy -= state.wnext;
	              from = state.wsize - copy;
	            }
	            else {
	              from = state.wnext - copy;
	            }
	            if (copy > state.length) { copy = state.length; }
	            from_source = state.window;
	          }
	          else {                              /* copy from output */
	            from_source = output;
	            from = put - state.offset;
	            copy = state.length;
	          }
	          if (copy > left) { copy = left; }
	          left -= copy;
	          state.length -= copy;
	          do {
	            output[put++] = from_source[from++];
	          } while (--copy);
	          if (state.length === 0) { state.mode = LEN; }
	          break;
	        case LIT:
	          if (left === 0) { break inf_leave; }
	          output[put++] = state.length;
	          left--;
	          state.mode = LEN;
	          break;
	        case CHECK:
	          if (state.wrap) {
	            //=== NEEDBITS(32);
	            while (bits < 32) {
	              if (have === 0) { break inf_leave; }
	              have--;
	              // Use '|' instead of '+' to make sure that result is signed
	              hold |= input[next++] << bits;
	              bits += 8;
	            }
	            //===//
	            _out -= left;
	            strm.total_out += _out;
	            state.total += _out;
	            if (_out) {
	              strm.adler = state.check =
	                  /*UPDATE(state.check, put - _out, _out);*/
	                  (state.flags ? crc32(state.check, output, _out, put - _out) : adler32(state.check, output, _out, put - _out));
	
	            }
	            _out = left;
	            // NB: crc32 stored as signed 32-bit int, zswap32 returns signed too
	            if ((state.flags ? hold : zswap32(hold)) !== state.check) {
	              strm.msg = 'incorrect data check';
	              state.mode = BAD$1;
	              break;
	            }
	            //=== INITBITS();
	            hold = 0;
	            bits = 0;
	            //===//
	            //Tracev((stderr, "inflate:   check matches trailer\n"));
	          }
	          state.mode = LENGTH;
	          /* falls through */
	        case LENGTH:
	          if (state.wrap && state.flags) {
	            //=== NEEDBITS(32);
	            while (bits < 32) {
	              if (have === 0) { break inf_leave; }
	              have--;
	              hold += input[next++] << bits;
	              bits += 8;
	            }
	            //===//
	            if (hold !== (state.total & 0xffffffff)) {
	              strm.msg = 'incorrect length check';
	              state.mode = BAD$1;
	              break;
	            }
	            //=== INITBITS();
	            hold = 0;
	            bits = 0;
	            //===//
	            //Tracev((stderr, "inflate:   length matches trailer\n"));
	          }
	          state.mode = DONE;
	          /* falls through */
	        case DONE:
	          ret = Z_STREAM_END$1;
	          break inf_leave;
	        case BAD$1:
	          ret = Z_DATA_ERROR$1;
	          break inf_leave;
	        case MEM:
	          return Z_MEM_ERROR;
	        case SYNC:
	          /* falls through */
	        default:
	          return Z_STREAM_ERROR$1;
	      }
	    }
	
	    // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"
	
	    /*
	       Return from inflate(), updating the total counts and the check value.
	       If there was no progress during the inflate() call, return a buffer
	       error.  Call updatewindow() to create and/or update the window state.
	       Note: a memory error from inflate() is non-recoverable.
	     */
	
	    //--- RESTORE() ---
	    strm.next_out = put;
	    strm.avail_out = left;
	    strm.next_in = next;
	    strm.avail_in = have;
	    state.hold = hold;
	    state.bits = bits;
	    //---
	
	    if (state.wsize || (_out !== strm.avail_out && state.mode < BAD$1 &&
	                        (state.mode < CHECK || flush !== Z_FINISH$1))) {
	      if (updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out)) ;
	    }
	    _in -= strm.avail_in;
	    _out -= strm.avail_out;
	    strm.total_in += _in;
	    strm.total_out += _out;
	    state.total += _out;
	    if (state.wrap && _out) {
	      strm.adler = state.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/
	        (state.flags ? crc32(state.check, output, _out, strm.next_out - _out) : adler32(state.check, output, _out, strm.next_out - _out));
	    }
	    strm.data_type = state.bits + (state.last ? 64 : 0) +
	                      (state.mode === TYPE$1 ? 128 : 0) +
	                      (state.mode === LEN_ || state.mode === COPY_ ? 256 : 0);
	    if (((_in === 0 && _out === 0) || flush === Z_FINISH$1) && ret === Z_OK$1) {
	      ret = Z_BUF_ERROR$1;
	    }
	    return ret;
	  }
	
	  function inflateEnd(strm) {
	
	    if (!strm || !strm.state /*|| strm->zfree == (free_func)0*/) {
	      return Z_STREAM_ERROR$1;
	    }
	
	    var state = strm.state;
	    if (state.window) {
	      state.window = null;
	    }
	    strm.state = null;
	    return Z_OK$1;
	  }
	
	  function inflateGetHeader(strm, head) {
	    var state;
	
	    /* check state */
	    if (!strm || !strm.state) { return Z_STREAM_ERROR$1; }
	    state = strm.state;
	    if ((state.wrap & 2) === 0) { return Z_STREAM_ERROR$1; }
	
	    /* save header structure */
	    state.head = head;
	    head.done = false;
	    return Z_OK$1;
	  }
	
	  function inflateSetDictionary(strm, dictionary) {
	    var dictLength = dictionary.length;
	
	    var state;
	    var dictid;
	    var ret;
	
	    /* check state */
	    if (!strm /* == Z_NULL */ || !strm.state /* == Z_NULL */) { return Z_STREAM_ERROR$1; }
	    state = strm.state;
	
	    if (state.wrap !== 0 && state.mode !== DICT) {
	      return Z_STREAM_ERROR$1;
	    }
	
	    /* check for correct dictionary identifier */
	    if (state.mode === DICT) {
	      dictid = 1; /* adler32(0, null, 0)*/
	      /* dictid = adler32(dictid, dictionary, dictLength); */
	      dictid = adler32(dictid, dictionary, dictLength, 0);
	      if (dictid !== state.check) {
	        return Z_DATA_ERROR$1;
	      }
	    }
	    /* copy dictionary to window using updatewindow(), which will amend the
	     existing dictionary if appropriate */
	    ret = updatewindow(strm, dictionary, dictLength, dictLength);
	    if (ret) {
	      state.mode = MEM;
	      return Z_MEM_ERROR;
	    }
	    state.havedict = 1;
	    // Tracev((stderr, "inflate:   dictionary set\n"));
	    return Z_OK$1;
	  }
	
	  /* Not implemented
	  exports.inflateCopy = inflateCopy;
	  exports.inflateGetDictionary = inflateGetDictionary;
	  exports.inflateMark = inflateMark;
	  exports.inflatePrime = inflatePrime;
	  exports.inflateSync = inflateSync;
	  exports.inflateSyncPoint = inflateSyncPoint;
	  exports.inflateUndermine = inflateUndermine;
	  */
	
	  /* eslint-disable */
	
	  // (C) 1995-2013 Jean-loup Gailly and Mark Adler
	  // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	  //
	  // This software is provided 'as-is', without any express or implied
	  // warranty. In no event will the authors be held liable for any damages
	  // arising from the use of this software.
	  //
	  // Permission is granted to anyone to use this software for any purpose,
	  // including commercial applications, and to alter it and redistribute it
	  // freely, subject to the following restrictions:
	  //
	  // 1. The origin of this software must not be misrepresented; you must not
	  //   claim that you wrote the original software. If you use this software
	  //   in a product, an acknowledgment in the product documentation would be
	  //   appreciated but is not required.
	  // 2. Altered source versions must be plainly marked as such, and must not be
	  //   misrepresented as being the original software.
	  // 3. This notice may not be removed or altered from any source distribution.
	
	  var msg = {
	    2:      'need dictionary',     /* Z_NEED_DICT       2  */
	    1:      'stream end',          /* Z_STREAM_END      1  */
	    0:      '',                    /* Z_OK              0  */
	    '-1':   'file error',          /* Z_ERRNO         (-1) */
	    '-2':   'stream error',        /* Z_STREAM_ERROR  (-2) */
	    '-3':   'data error',          /* Z_DATA_ERROR    (-3) */
	    '-4':   'insufficient memory', /* Z_MEM_ERROR     (-4) */
	    '-5':   'buffer error',        /* Z_BUF_ERROR     (-5) */
	    '-6':   'incompatible version' /* Z_VERSION_ERROR (-6) */
	  };
	
	  /* eslint-disable */
	
	  // (C) 1995-2013 Jean-loup Gailly and Mark Adler
	  // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	  //
	  // This software is provided 'as-is', without any express or implied
	  // warranty. In no event will the authors be held liable for any damages
	  // arising from the use of this software.
	  //
	  // Permission is granted to anyone to use this software for any purpose,
	  // including commercial applications, and to alter it and redistribute it
	  // freely, subject to the following restrictions:
	  //
	  // 1. The origin of this software must not be misrepresented; you must not
	  //   claim that you wrote the original software. If you use this software
	  //   in a product, an acknowledgment in the product documentation would be
	  //   appreciated but is not required.
	  // 2. Altered source versions must be plainly marked as such, and must not be
	  //   misrepresented as being the original software.
	  // 3. This notice may not be removed or altered from any source distribution.
	
	  function ZStream() {
	    /* next input byte */
	    this.input = null; // JS specific, because we have no pointers
	    this.next_in = 0;
	    /* number of bytes available at input */
	    this.avail_in = 0;
	    /* total number of input bytes read so far */
	    this.total_in = 0;
	    /* next output byte should be put there */
	    this.output = null; // JS specific, because we have no pointers
	    this.next_out = 0;
	    /* remaining free space at output */
	    this.avail_out = 0;
	    /* total number of bytes output so far */
	    this.total_out = 0;
	    /* last error message, NULL if no error */
	    this.msg = ''/*Z_NULL*/;
	    /* not visible by applications */
	    this.state = null;
	    /* best guess about the data type: binary or text */
	    this.data_type = 2/*Z_UNKNOWN*/;
	    /* adler32 value of the uncompressed data */
	    this.adler = 0;
	  }
	
	  /* eslint-disable */
	
	  // (C) 1995-2013 Jean-loup Gailly and Mark Adler
	  // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	  //
	  // This software is provided 'as-is', without any express or implied
	  // warranty. In no event will the authors be held liable for any damages
	  // arising from the use of this software.
	  //
	  // Permission is granted to anyone to use this software for any purpose,
	  // including commercial applications, and to alter it and redistribute it
	  // freely, subject to the following restrictions:
	  //
	  // 1. The origin of this software must not be misrepresented; you must not
	  //   claim that you wrote the original software. If you use this software
	  //   in a product, an acknowledgment in the product documentation would be
	  //   appreciated but is not required.
	  // 2. Altered source versions must be plainly marked as such, and must not be
	  //   misrepresented as being the original software.
	  // 3. This notice may not be removed or altered from any source distribution.
	
	  function GZheader() {
	    /* true if compressed data believed to be text */
	    this.text       = 0;
	    /* modification time */
	    this.time       = 0;
	    /* extra flags (not used when writing a gzip file) */
	    this.xflags     = 0;
	    /* operating system */
	    this.os         = 0;
	    /* pointer to extra field or Z_NULL if none */
	    this.extra      = null;
	    /* extra field length (valid if extra != Z_NULL) */
	    this.extra_len  = 0; // Actually, we don't need it in JS,
	                         // but leave for few code modifications
	
	    //
	    // Setup limits is not necessary because in js we should not preallocate memory
	    // for inflate use constant limit in 65536 bytes
	    //
	
	    /* space at extra (only when reading header) */
	    // this.extra_max  = 0;
	    /* pointer to zero-terminated file name or Z_NULL */
	    this.name       = '';
	    /* space at name (only when reading header) */
	    // this.name_max   = 0;
	    /* pointer to zero-terminated comment or Z_NULL */
	    this.comment    = '';
	    /* space at comment (only when reading header) */
	    // this.comm_max   = 0;
	    /* true if there was or will be a header crc */
	    this.hcrc       = 0;
	    /* true when done reading gzip header (not used when writing a gzip file) */
	    this.done       = false;
	  }
	
	  /* eslint-disable */
	
	  var toString = Object.prototype.toString;
	
	  /**
	   * class Inflate
	   *
	   * Generic JS-style wrapper for zlib calls. If you don't need
	   * streaming behaviour - use more simple functions: [[inflate]]
	   * and [[inflateRaw]].
	   **/
	
	  /* internal
	   * inflate.chunks -> Array
	   *
	   * Chunks of output data, if [[Inflate#onData]] not overridden.
	   **/
	
	  /**
	   * Inflate.result -> Uint8Array|Array|String
	   *
	   * Uncompressed result, generated by default [[Inflate#onData]]
	   * and [[Inflate#onEnd]] handlers. Filled after you push last chunk
	   * (call [[Inflate#push]] with `Z_FINISH` / `true` param) or if you
	   * push a chunk with explicit flush (call [[Inflate#push]] with
	   * `Z_SYNC_FLUSH` param).
	   **/
	
	  /**
	   * Inflate.err -> Number
	   *
	   * Error code after inflate finished. 0 (Z_OK) on success.
	   * Should be checked if broken data possible.
	   **/
	
	  /**
	   * Inflate.msg -> String
	   *
	   * Error message, if [[Inflate.err]] != 0
	   **/
	
	
	  /**
	   * new Inflate(options)
	   * - options (Object): zlib inflate options.
	   *
	   * Creates new inflator instance with specified params. Throws exception
	   * on bad params. Supported options:
	   *
	   * - `windowBits`
	   * - `dictionary`
	   *
	   * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
	   * for more information on these.
	   *
	   * Additional options, for internal needs:
	   *
	   * - `chunkSize` - size of generated data chunks (16K by default)
	   * - `raw` (Boolean) - do raw inflate
	   * - `to` (String) - if equal to 'string', then result will be converted
	   *   from utf8 to utf16 (javascript) string. When string output requested,
	   *   chunk length can differ from `chunkSize`, depending on content.
	   *
	   * By default, when no options set, autodetect deflate/gzip data format via
	   * wrapper header.
	   *
	   * ##### Example:
	   *
	   * ```javascript
	   * var pako = require('pako')
	   *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
	   *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
	   *
	   * var inflate = new pako.Inflate({ level: 3});
	   *
	   * inflate.push(chunk1, false);
	   * inflate.push(chunk2, true);  // true -> last chunk
	   *
	   * if (inflate.err) { throw new Error(inflate.err); }
	   *
	   * console.log(inflate.result);
	   * ```
	   **/
	  var Inflate = function Inflate(options) {
	    if (!(this instanceof Inflate)) { return new Inflate(options); }
	
	    this.options = assign({
	      chunkSize: 16384,
	      windowBits: 0,
	      to: ''
	    }, options || {});
	
	    var opt = this.options;
	
	    // Force window size for `raw` data, if not set directly,
	    // because we have no header for autodetect.
	    if (opt.raw && (opt.windowBits >= 0) && (opt.windowBits < 16)) {
	      opt.windowBits = -opt.windowBits;
	      if (opt.windowBits === 0) { opt.windowBits = -15; }
	    }
	
	    // If `windowBits` not defined (and mode not raw) - set autodetect flag for gzip/deflate
	    if ((opt.windowBits >= 0) && (opt.windowBits < 16) &&
	        !(options && options.windowBits)) {
	      opt.windowBits += 32;
	    }
	
	    // Gzip header has no info about windows size, we can do autodetect only
	    // for deflate. So, if window size not set, force it to max when gzip possible
	    if ((opt.windowBits > 15) && (opt.windowBits < 48)) {
	      // bit 3 (16) -> gzipped data
	      // bit 4 (32) -> autodetect gzip/deflate
	      if ((opt.windowBits & 15) === 0) {
	        opt.windowBits |= 15;
	      }
	    }
	
	    this.err  = 0;    // error code, if happens (0 = Z_OK)
	    this.msg  = '';   // error message
	    this.ended= false;// used to avoid multiple onEnd() calls
	    this.chunks = [];   // chunks of compressed data
	
	    this.strm = new ZStream();
	    this.strm.avail_out = 0;
	
	    var status= inflateInit2(
	      this.strm,
	      opt.windowBits
	    );
	
	    if (status !== Z_OK) {
	      throw new Error(msg[status]);
	    }
	
	    this.header = new GZheader();
	
	    inflateGetHeader(this.strm, this.header);
	
	    // Setup dictionary
	    if (opt.dictionary) {
	      // Convert data if needed
	      if (typeof opt.dictionary === 'string') {
	        opt.dictionary = string2buf(opt.dictionary);
	      } else if (toString.call(opt.dictionary) === '[object ArrayBuffer]') {
	        opt.dictionary = new Uint8Array(opt.dictionary);
	      }
	      if (opt.raw) { //In raw mode we need to set the dictionary early
	        status = inflateSetDictionary(this.strm, opt.dictionary);
	        if (status !== Z_OK) {
	          throw new Error(msg[status]);
	        }
	      }
	    }
	  };
	
	  /**
	   * Inflate#push(data[, mode]) -> Boolean
	   * - data (Uint8Array|Array|ArrayBuffer|String): input data
	   * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
	   * See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
	   *
	   * Sends input data to inflate pipe, generating [[Inflate#onData]] calls with
	   * new output chunks. Returns `true` on success. The last data block must have
	   * mode Z_FINISH (or `true`). That will flush internal pending buffers and call
	   * [[Inflate#onEnd]]. For interim explicit flushes (without ending the stream) you
	   * can use mode Z_SYNC_FLUSH, keeping the decompression context.
	   *
	   * On fail call [[Inflate#onEnd]] with error code and return false.
	   *
	   * We strongly recommend to use `Uint8Array` on input for best speed (output
	   * format is detected automatically). Also, don't skip last param and always
	   * use the same type in your code (boolean or number). That will improve JS speed.
	   *
	   * For regular `Array`-s make sure all elements are [0..255].
	   *
	   * ##### Example
	   *
	   * ```javascript
	   * push(chunk, false); // push one of data chunks
	   * ...
	   * push(chunk, true);// push last chunk
	   * ```
	   **/
	  Inflate.prototype.push = function push (data, mode) {
	    var strm = this.strm;
	    var chunkSize = this.options.chunkSize;
	    var dictionary = this.options.dictionary;
	    var status, _mode;
	    var next_out_utf8, tail, utf8str;
	    var dict;
	
	    // Flag to properly process Z_BUF_ERROR on testing inflate call
	    // when we check that all output data was flushed.
	    var allowBufError = false;
	
	    if (this.ended) { return false; }
	    _mode = (mode === ~~mode) ? mode : ((mode === true) ? Z_FINISH : Z_NO_FLUSH);
	
	    // Convert data if needed
	    if (typeof data === 'string') {
	      // Only binary strings can be decompressed on practice
	      strm.input = binstring2buf(data);
	    } else if (toString.call(data) === '[object ArrayBuffer]') {
	      strm.input = new Uint8Array(data);
	    } else {
	      strm.input = data;
	    }
	
	    strm.next_in = 0;
	    strm.avail_in = strm.input.length;
	
	    do {
	      if (strm.avail_out === 0) {
	        strm.output = Buf8(chunkSize);
	        strm.next_out = 0;
	        strm.avail_out = chunkSize;
	      }
	
	      status = inflate(strm, Z_NO_FLUSH);  /* no bad return value */
	
	      if (status === Z_NEED_DICT && dictionary) {
	        // Convert data if needed
	        if (typeof dictionary === 'string') {
	          dict = string2buf(dictionary);
	        } else if (toString.call(dictionary) === '[object ArrayBuffer]') {
	          dict = new Uint8Array(dictionary);
	        } else {
	          dict = dictionary;
	        }
	
	        status = inflateSetDictionary(this.strm, dict);
	
	      }
	
	      if (status === Z_BUF_ERROR && allowBufError === true) {
	        status = Z_OK;
	        allowBufError = false;
	      }
	
	      if (status !== Z_STREAM_END && status !== Z_OK) {
	        this.onEnd(status);
	        this.ended = true;
	        return false;
	      }
	
	      if (strm.next_out) {
	        if (strm.avail_out === 0 || status === Z_STREAM_END || (strm.avail_in === 0 && (_mode === Z_FINISH || _mode === Z_SYNC_FLUSH))) {
	
	          if (this.options.to === 'string') {
	
	            next_out_utf8 = utf8border(strm.output, strm.next_out);
	
	            tail = strm.next_out - next_out_utf8;
	            utf8str = buf2string(strm.output, next_out_utf8);
	
	            // move tail
	            strm.next_out = tail;
	            strm.avail_out = chunkSize - tail;
	            if (tail) { arraySet(strm.output, strm.output, next_out_utf8, tail, 0); }
	
	            this.onData(utf8str);
	
	          } else {
	            this.onData(shrinkBuf(strm.output, strm.next_out));
	          }
	        }
	      }
	
	      // When no more input data, we should check that internal inflate buffers
	      // are flushed. The only way to do it when avail_out = 0 - run one more
	      // inflate pass. But if output data not exists, inflate return Z_BUF_ERROR.
	      // Here we set flag to process this error properly.
	      //
	      // NOTE. Deflate does not return error in this case and does not needs such
	      // logic.
	      if (strm.avail_in === 0 && strm.avail_out === 0) {
	        allowBufError = true;
	      }
	
	    } while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== Z_STREAM_END);
	
	    if (status === Z_STREAM_END) {
	      _mode = Z_FINISH;
	    }
	
	    // Finalize on the last chunk.
	    if (_mode === Z_FINISH) {
	      status = inflateEnd(this.strm);
	      this.onEnd(status);
	      this.ended = true;
	      return status === Z_OK;
	    }
	
	    // callback interim results if Z_SYNC_FLUSH.
	    if (_mode === Z_SYNC_FLUSH) {
	      this.onEnd(Z_OK);
	      strm.avail_out = 0;
	      return true;
	    }
	
	    return true;
	  };
	
	
	  /**
	   * Inflate#onData(chunk) -> Void
	   * - chunk (Uint8Array|Array|String): output data. Type of array depends
	   * on js engine support. When string output requested, each chunk
	   * will be string.
	   *
	   * By default, stores data blocks in `chunks[]` property and glue
	   * those in `onEnd`. Override this handler, if you need another behaviour.
	   **/
	  Inflate.prototype.onData = function onData (chunk) {
	    this.chunks.push(chunk);
	  };
	
	
	  /**
	   * Inflate#onEnd(status) -> Void
	   * - status (Number): inflate status. 0 (Z_OK) on success,
	   * other if not.
	   *
	   * Called either after you tell inflate that the input stream is
	   * complete (Z_FINISH) or should be flushed (Z_SYNC_FLUSH)
	   * or if an error happened. By default - join collected chunks,
	   * free memory and fill `results` / `err` properties.
	   **/
	  Inflate.prototype.onEnd = function onEnd (status) {
	    // On success - join
	    if (status === Z_OK) {
	      if (this.options.to === 'string') {
	        // Glue & convert here, until we teach pako to send
	        // utf8 aligned strings to onData
	        this.result = this.chunks.join('');
	      } else {
	        this.result = flattenChunks(this.chunks);
	      }
	    }
	    this.chunks = [];
	    this.err = status;
	    this.msg = this.strm.msg;
	  };
	
	  /**
	   * inflate(data[, options]) -> Uint8Array|Array|String
	   * - data (Uint8Array|Array|String): input data to decompress.
	   * - options (Object): zlib inflate options.
	   *
	   * Decompress `data` with inflate/ungzip and `options`. Autodetect
	   * format via wrapper header by default. That's why we don't provide
	   * separate `ungzip` method.
	   *
	   * Supported options are:
	   *
	   * - windowBits
	   *
	   * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
	   * for more information.
	   *
	   * Sugar (options):
	   *
	   * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
	   *   negative windowBits implicitly.
	   * - `to` (String) - if equal to 'string', then result will be converted
	   *   from utf8 to utf16 (javascript) string. When string output requested,
	   *   chunk length can differ from `chunkSize`, depending on content.
	   *
	   *
	   * ##### Example:
	   *
	   * ```javascript
	   * var pako = require('pako')
	   *   , input = pako.deflate([1,2,3,4,5,6,7,8,9])
	   *   , output;
	   *
	   * try {
	   *   output = pako.inflate(input);
	   * } catch (err)
	   *   console.log(err);
	   * }
	   * ```
	   **/
	  function inflate$1(input, options) {
	    var inflator = new Inflate(options);
	
	    inflator.push(input, true);
	
	    // That will never happens, if you don't cheat with options :)
	    if (inflator.err) { throw inflator.msg || msg[inflator.err]; }
	
	    return inflator.result;
	  }
	
	
	  /**
	   * inflateRaw(data[, options]) -> Uint8Array|Array|String
	   * - data (Uint8Array|Array|String): input data to decompress.
	   * - options (Object): zlib inflate options.
	   *
	   * The same as [[inflate]], but creates raw data, without wrapper
	   * (header and adler32 crc).
	   **/
	  function inflateRaw(input, options) {
	    options = options || {};
	    options.raw = true;
	    return inflate$1(input, options);
	  }
	
	  /**
	   * ungzip(data[, options]) -> Uint8Array|Array|String
	   * - data (Uint8Array|Array|String): input data to decompress.
	   * - options (Object): zlib inflate options.
	   *
	   * Just shortcut to [[inflate]], because it autodetects format
	   * by header.content. Done for convenience.
	   **/
	  var ungzip = inflate$1;
	
	  /* eslint-disable */
	
	  function zero(buf) { var len = buf.length; while (--len >= 0) { buf[len] = 0; } }
	
	  // From zutil.h
	
	  var STORED_BLOCK = 0;
	  var STATIC_TREES = 1;
	  var DYN_TREES    = 2;
	  /* The three kinds of block type */
	
	  var MIN_MATCH    = 3;
	  var MAX_MATCH    = 258;
	  /* The minimum and maximum match lengths */
	
	  // From deflate.h
	  /* ===========================================================================
	   * Internal compression state.
	   */
	
	  var LENGTH_CODES  = 29;
	  /* number of length codes, not counting the special END_BLOCK code */
	
	  var LITERALS      = 256;
	  /* number of literal bytes 0..255 */
	
	  var L_CODES       = LITERALS + 1 + LENGTH_CODES;
	  /* number of Literal or Length codes, including the END_BLOCK code */
	
	  var D_CODES       = 30;
	  /* number of distance codes */
	
	  var BL_CODES      = 19;
	  /* number of codes used to transfer the bit lengths */
	
	  var HEAP_SIZE     = 2 * L_CODES + 1;
	  /* maximum heap size */
	
	  var MAX_BITS      = 15;
	  /* All codes must not exceed MAX_BITS bits */
	
	  var Buf_size      = 16;
	  /* size of bit buffer in bi_buf */
	
	
	  /* ===========================================================================
	   * Constants
	   */
	
	  var MAX_BL_BITS = 7;
	  /* Bit length codes must not exceed MAX_BL_BITS bits */
	
	  var END_BLOCK   = 256;
	  /* end of block literal code */
	
	  var REP_3_6     = 16;
	  /* repeat previous bit length 3-6 times (2 bits of repeat count) */
	
	  var REPZ_3_10   = 17;
	  /* repeat a zero length 3-10 times  (3 bits of repeat count) */
	
	  var REPZ_11_138 = 18;
	  /* repeat a zero length 11-138 times  (7 bits of repeat count) */
	
	  /* eslint-disable comma-spacing,array-bracket-spacing */
	  var extra_lbits =   /* extra bits for each length code */
	    [0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0];
	
	  var extra_dbits =   /* extra bits for each distance code */
	    [0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13];
	
	  var extra_blbits =  /* extra bits for each bit length code */
	    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7];
	
	  var bl_order =
	    [16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15];
	  /* eslint-enable comma-spacing,array-bracket-spacing */
	
	  /* The lengths of the bit length codes are sent in order of decreasing
	   * probability, to avoid transmitting the lengths for unused bit length codes.
	   */
	
	  /* ===========================================================================
	   * Local data. These are initialized only once.
	   */
	
	  // We pre-fill arrays with 0 to avoid uninitialized gaps
	
	  var DIST_CODE_LEN = 512; /* see definition of array dist_code below */
	
	  // !!!! Use flat array instead of structure, Freq = i*2, Len = i*2+1
	  var static_ltree;
	  /* The static literal tree. Since the bit lengths are imposed, there is no
	   * need for the L_CODES extra codes used during heap construction. However
	   * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
	   * below).
	   */
	
	  var static_dtree;
	  /* The static distance tree. (Actually a trivial tree since all codes use
	   * 5 bits.)
	   */
	
	  var _dist_code;
	  /* Distance codes. The first 256 values correspond to the distances
	   * 3 .. 258, the last 256 values correspond to the top 8 bits of
	   * the 15 bit distances.
	   */
	
	  var _length_code;
	  /* length code for each normalized match length (0 == MIN_MATCH) */
	
	  var base_length;
	  /* First normalized length for each code (0 = MIN_MATCH) */
	
	  var base_dist;
	  /* First normalized distance for each code (0 = distance of 1) */
	
	
	  function StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {
	
	    this.static_tree  = static_tree;  /* static tree or NULL */
	    this.extra_bits   = extra_bits;   /* extra bits for each code or NULL */
	    this.extra_base   = extra_base;   /* base index for extra_bits */
	    this.elems        = elems;        /* max number of elements in the tree */
	    this.max_length   = max_length;   /* max bit length for the codes */
	
	    // show if `static_tree` has data or dummy - needed for monomorphic objects
	    this.has_stree    = static_tree && static_tree.length;
	  }
	
	
	  var static_l_desc;
	  var static_d_desc;
	  var static_bl_desc;
	
	
	  function TreeDesc(dyn_tree, stat_desc) {
	    this.dyn_tree = dyn_tree;     /* the dynamic tree */
	    this.max_code = 0;            /* largest code with non zero frequency */
	    this.stat_desc = stat_desc;   /* the corresponding static tree */
	  }
	
	
	
	  function d_code(dist) {
	    return dist < 256 ? _dist_code[dist] : _dist_code[256 + (dist >>> 7)];
	  }
	
	
	  /* ===========================================================================
	   * Output a short LSB first on the stream.
	   * IN assertion: there is enough room in pendingBuf.
	   */
	  function put_short(s, w) {
	  //    put_byte(s, (uch)((w) & 0xff));
	  //    put_byte(s, (uch)((ush)(w) >> 8));
	    s.pending_buf[s.pending++] = (w) & 0xff;
	    s.pending_buf[s.pending++] = (w >>> 8) & 0xff;
	  }
	
	
	  /* ===========================================================================
	   * Send a value on a given number of bits.
	   * IN assertion: length <= 16 and value fits in length bits.
	   */
	  function send_bits(s, value, length) {
	    if (s.bi_valid > (Buf_size - length)) {
	      s.bi_buf |= (value << s.bi_valid) & 0xffff;
	      put_short(s, s.bi_buf);
	      s.bi_buf = value >> (Buf_size - s.bi_valid);
	      s.bi_valid += length - Buf_size;
	    } else {
	      s.bi_buf |= (value << s.bi_valid) & 0xffff;
	      s.bi_valid += length;
	    }
	  }
	
	
	  function send_code(s, c, tree) {
	    send_bits(s, tree[c * 2]/*.Code*/, tree[c * 2 + 1]/*.Len*/);
	  }
	
	
	  /* ===========================================================================
	   * Reverse the first len bits of a code, using straightforward code (a faster
	   * method would use a table)
	   * IN assertion: 1 <= len <= 15
	   */
	  function bi_reverse(code, len) {
	    var res = 0;
	    do {
	      res |= code & 1;
	      code >>>= 1;
	      res <<= 1;
	    } while (--len > 0);
	    return res >>> 1;
	  }
	
	
	  /* ===========================================================================
	   * Flush the bit buffer, keeping at most 7 bits in it.
	   */
	  function bi_flush(s) {
	    if (s.bi_valid === 16) {
	      put_short(s, s.bi_buf);
	      s.bi_buf = 0;
	      s.bi_valid = 0;
	
	    } else if (s.bi_valid >= 8) {
	      s.pending_buf[s.pending++] = s.bi_buf & 0xff;
	      s.bi_buf >>= 8;
	      s.bi_valid -= 8;
	    }
	  }
	
	
	  /* ===========================================================================
	   * Compute the optimal bit lengths for a tree and update the total bit length
	   * for the current block.
	   * IN assertion: the fields freq and dad are set, heap[heap_max] and
	   *    above are the tree nodes sorted by increasing frequency.
	   * OUT assertions: the field len is set to the optimal bit length, the
	   *     array bl_count contains the frequencies for each bit length.
	   *     The length opt_len is updated; static_len is also updated if stree is
	   *     not null.
	   */
	  function gen_bitlen(s, desc)
	  //    deflate_state *s;
	  //    tree_desc *desc;    /* the tree descriptor */
	  {
	    var tree            = desc.dyn_tree;
	    var max_code        = desc.max_code;
	    var stree           = desc.stat_desc.static_tree;
	    var has_stree       = desc.stat_desc.has_stree;
	    var extra           = desc.stat_desc.extra_bits;
	    var base            = desc.stat_desc.extra_base;
	    var max_length      = desc.stat_desc.max_length;
	    var h;              /* heap index */
	    var n, m;           /* iterate over the tree elements */
	    var bits;           /* bit length */
	    var xbits;          /* extra bits */
	    var f;              /* frequency */
	    var overflow = 0;   /* number of elements with bit length too large */
	
	    for (bits = 0; bits <= MAX_BITS; bits++) {
	      s.bl_count[bits] = 0;
	    }
	
	    /* In a first pass, compute the optimal bit lengths (which may
	     * overflow in the case of the bit length tree).
	     */
	    tree[s.heap[s.heap_max] * 2 + 1]/*.Len*/ = 0; /* root of the heap */
	
	    for (h = s.heap_max + 1; h < HEAP_SIZE; h++) {
	      n = s.heap[h];
	      bits = tree[tree[n * 2 + 1]/*.Dad*/ * 2 + 1]/*.Len*/ + 1;
	      if (bits > max_length) {
	        bits = max_length;
	        overflow++;
	      }
	      tree[n * 2 + 1]/*.Len*/ = bits;
	      /* We overwrite tree[n].Dad which is no longer needed */
	
	      if (n > max_code) { continue; } /* not a leaf node */
	
	      s.bl_count[bits]++;
	      xbits = 0;
	      if (n >= base) {
	        xbits = extra[n - base];
	      }
	      f = tree[n * 2]/*.Freq*/;
	      s.opt_len += f * (bits + xbits);
	      if (has_stree) {
	        s.static_len += f * (stree[n * 2 + 1]/*.Len*/ + xbits);
	      }
	    }
	    if (overflow === 0) { return; }
	
	    // Trace((stderr,"\nbit length overflow\n"));
	    /* This happens for example on obj2 and pic of the Calgary corpus */
	
	    /* Find the first bit length which could increase: */
	    do {
	      bits = max_length - 1;
	      while (s.bl_count[bits] === 0) { bits--; }
	      s.bl_count[bits]--;      /* move one leaf down the tree */
	      s.bl_count[bits + 1] += 2; /* move one overflow item as its brother */
	      s.bl_count[max_length]--;
	      /* The brother of the overflow item also moves one step up,
	       * but this does not affect bl_count[max_length]
	       */
	      overflow -= 2;
	    } while (overflow > 0);
	
	    /* Now recompute all bit lengths, scanning in increasing frequency.
	     * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
	     * lengths instead of fixing only the wrong ones. This idea is taken
	     * from 'ar' written by Haruhiko Okumura.)
	     */
	    for (bits = max_length; bits !== 0; bits--) {
	      n = s.bl_count[bits];
	      while (n !== 0) {
	        m = s.heap[--h];
	        if (m > max_code) { continue; }
	        if (tree[m * 2 + 1]/*.Len*/ !== bits) {
	          // Trace((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
	          s.opt_len += (bits - tree[m * 2 + 1]/*.Len*/) * tree[m * 2]/*.Freq*/;
	          tree[m * 2 + 1]/*.Len*/ = bits;
	        }
	        n--;
	      }
	    }
	  }
	
	
	  /* ===========================================================================
	   * Generate the codes for a given tree and bit counts (which need not be
	   * optimal).
	   * IN assertion: the array bl_count contains the bit length statistics for
	   * the given tree and the field len is set for all tree elements.
	   * OUT assertion: the field code is set for all tree elements of non
	   *     zero code length.
	   */
	  function gen_codes(tree, max_code, bl_count)
	  //    ct_data *tree;             /* the tree to decorate */
	  //    int max_code;              /* largest code with non zero frequency */
	  //    ushf *bl_count;            /* number of codes at each bit length */
	  {
	    var next_code = new Array(MAX_BITS + 1); /* next code value for each bit length */
	    var code = 0;              /* running code value */
	    var bits;                  /* bit index */
	    var n;                     /* code index */
	
	    /* The distribution counts are first used to generate the code values
	     * without bit reversal.
	     */
	    for (bits = 1; bits <= MAX_BITS; bits++) {
	      next_code[bits] = code = (code + bl_count[bits - 1]) << 1;
	    }
	    /* Check that the bit counts in bl_count are consistent. The last code
	     * must be all ones.
	     */
	    //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
	    //        "inconsistent bit counts");
	    //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));
	
	    for (n = 0;  n <= max_code; n++) {
	      var len = tree[n * 2 + 1]/*.Len*/;
	      if (len === 0) { continue; }
	      /* Now reverse the bits */
	      tree[n * 2]/*.Code*/ = bi_reverse(next_code[len]++, len);
	
	      //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
	      //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
	    }
	  }
	
	
	  /* ===========================================================================
	   * Initialize the various 'constant' tables.
	   */
	  function tr_static_init() {
	    var n;        /* iterates over tree elements */
	    var bits;     /* bit counter */
	    var length;   /* length value */
	    var code;     /* code value */
	    var dist;     /* distance index */
	    var bl_count = new Array(MAX_BITS + 1);
	    /* number of codes at each bit length for an optimal tree */
	
	    static_ltree  = new Array((L_CODES + 2) * 2);
	    zero(static_ltree);
	
	    static_dtree  = new Array(D_CODES * 2);
	    zero(static_dtree);
	
	    _dist_code    = new Array(DIST_CODE_LEN);
	    zero(_dist_code);
	
	    _length_code  = new Array(MAX_MATCH - MIN_MATCH + 1);
	    zero(_length_code);
	
	    base_length   = new Array(LENGTH_CODES);
	    zero(base_length);
	
	    base_dist     = new Array(D_CODES);
	    zero(base_dist);
	
	    // do check in _tr_init()
	    //if (static_init_done) return;
	
	    /* For some embedded targets, global variables are not initialized: */
	  /*#ifdef NO_INIT_GLOBAL_POINTERS
	    static_l_desc.static_tree = static_ltree;
	    static_l_desc.extra_bits = extra_lbits;
	    static_d_desc.static_tree = static_dtree;
	    static_d_desc.extra_bits = extra_dbits;
	    static_bl_desc.extra_bits = extra_blbits;
	  #endif*/
	
	    /* Initialize the mapping length (0..255) -> length code (0..28) */
	    length = 0;
	    for (code = 0; code < LENGTH_CODES - 1; code++) {
	      base_length[code] = length;
	      for (n = 0; n < (1 << extra_lbits[code]); n++) {
	        _length_code[length++] = code;
	      }
	    }
	    //Assert (length == 256, "tr_static_init: length != 256");
	    /* Note that the length 255 (match length 258) can be represented
	     * in two different ways: code 284 + 5 bits or code 285, so we
	     * overwrite length_code[255] to use the best encoding:
	     */
	    _length_code[length - 1] = code;
	
	    /* Initialize the mapping dist (0..32K) -> dist code (0..29) */
	    dist = 0;
	    for (code = 0; code < 16; code++) {
	      base_dist[code] = dist;
	      for (n = 0; n < (1 << extra_dbits[code]); n++) {
	        _dist_code[dist++] = code;
	      }
	    }
	    //Assert (dist == 256, "tr_static_init: dist != 256");
	    dist >>= 7; /* from now on, all distances are divided by 128 */
	    for (; code < D_CODES; code++) {
	      base_dist[code] = dist << 7;
	      for (n = 0; n < (1 << (extra_dbits[code] - 7)); n++) {
	        _dist_code[256 + dist++] = code;
	      }
	    }
	    //Assert (dist == 256, "tr_static_init: 256+dist != 512");
	
	    /* Construct the codes of the static literal tree */
	    for (bits = 0; bits <= MAX_BITS; bits++) {
	      bl_count[bits] = 0;
	    }
	
	    n = 0;
	    while (n <= 143) {
	      static_ltree[n * 2 + 1]/*.Len*/ = 8;
	      n++;
	      bl_count[8]++;
	    }
	    while (n <= 255) {
	      static_ltree[n * 2 + 1]/*.Len*/ = 9;
	      n++;
	      bl_count[9]++;
	    }
	    while (n <= 279) {
	      static_ltree[n * 2 + 1]/*.Len*/ = 7;
	      n++;
	      bl_count[7]++;
	    }
	    while (n <= 287) {
	      static_ltree[n * 2 + 1]/*.Len*/ = 8;
	      n++;
	      bl_count[8]++;
	    }
	    /* Codes 286 and 287 do not exist, but we must include them in the
	     * tree construction to get a canonical Huffman tree (longest code
	     * all ones)
	     */
	    gen_codes(static_ltree, L_CODES + 1, bl_count);
	
	    /* The static distance tree is trivial: */
	    for (n = 0; n < D_CODES; n++) {
	      static_dtree[n * 2 + 1]/*.Len*/ = 5;
	      static_dtree[n * 2]/*.Code*/ = bi_reverse(n, 5);
	    }
	
	    // Now data ready and we can init static trees
	    static_l_desc = new StaticTreeDesc(static_ltree, extra_lbits, LITERALS + 1, L_CODES, MAX_BITS);
	    static_d_desc = new StaticTreeDesc(static_dtree, extra_dbits, 0,          D_CODES, MAX_BITS);
	    static_bl_desc = new StaticTreeDesc(new Array(0), extra_blbits, 0,         BL_CODES, MAX_BL_BITS);
	
	    //static_init_done = true;
	  }
	
	
	  /* ===========================================================================
	   * Initialize a new block.
	   */
	  function init_block(s) {
	    var n; /* iterates over tree elements */
	
	    /* Initialize the trees. */
	    for (n = 0; n < L_CODES;  n++) { s.dyn_ltree[n * 2]/*.Freq*/ = 0; }
	    for (n = 0; n < D_CODES;  n++) { s.dyn_dtree[n * 2]/*.Freq*/ = 0; }
	    for (n = 0; n < BL_CODES; n++) { s.bl_tree[n * 2]/*.Freq*/ = 0; }
	
	    s.dyn_ltree[END_BLOCK * 2]/*.Freq*/ = 1;
	    s.opt_len = s.static_len = 0;
	    s.last_lit = s.matches = 0;
	  }
	
	
	  /* ===========================================================================
	   * Flush the bit buffer and align the output on a byte boundary
	   */
	  function bi_windup(s)
	  {
	    if (s.bi_valid > 8) {
	      put_short(s, s.bi_buf);
	    } else if (s.bi_valid > 0) {
	      //put_byte(s, (Byte)s->bi_buf);
	      s.pending_buf[s.pending++] = s.bi_buf;
	    }
	    s.bi_buf = 0;
	    s.bi_valid = 0;
	  }
	
	  /* ===========================================================================
	   * Copy a stored block, storing first the length and its
	   * one's complement if requested.
	   */
	  function copy_block(s, buf, len, header)
	  //DeflateState *s;
	  //charf    *buf;    /* the input data */
	  //unsigned len;     /* its length */
	  //int      header;  /* true if block header must be written */
	  {
	    bi_windup(s);        /* align on byte boundary */
	
	    if (header) {
	      put_short(s, len);
	      put_short(s, ~len);
	    }
	  //  while (len--) {
	  //    put_byte(s, *buf++);
	  //  }
	    arraySet(s.pending_buf, s.window, buf, len, s.pending);
	    s.pending += len;
	  }
	
	  /* ===========================================================================
	   * Compares to subtrees, using the tree depth as tie breaker when
	   * the subtrees have equal frequency. This minimizes the worst case length.
	   */
	  function smaller(tree, n, m, depth) {
	    var _n2 = n * 2;
	    var _m2 = m * 2;
	    return (tree[_n2]/*.Freq*/ < tree[_m2]/*.Freq*/ ||
	           (tree[_n2]/*.Freq*/ === tree[_m2]/*.Freq*/ && depth[n] <= depth[m]));
	  }
	
	  /* ===========================================================================
	   * Restore the heap property by moving down the tree starting at node k,
	   * exchanging a node with the smallest of its two sons if necessary, stopping
	   * when the heap property is re-established (each father smaller than its
	   * two sons).
	   */
	  function pqdownheap(s, tree, k)
	  //    deflate_state *s;
	  //    ct_data *tree;  /* the tree to restore */
	  //    int k;               /* node to move down */
	  {
	    var v = s.heap[k];
	    var j = k << 1;  /* left son of k */
	    while (j <= s.heap_len) {
	      /* Set j to the smallest of the two sons: */
	      if (j < s.heap_len &&
	        smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) {
	        j++;
	      }
	      /* Exit if v is smaller than both sons */
	      if (smaller(tree, v, s.heap[j], s.depth)) { break; }
	
	      /* Exchange v with the smallest son */
	      s.heap[k] = s.heap[j];
	      k = j;
	
	      /* And continue down the tree, setting j to the left son of k */
	      j <<= 1;
	    }
	    s.heap[k] = v;
	  }
	
	
	  // inlined manually
	  // var SMALLEST = 1;
	
	  /* ===========================================================================
	   * Send the block data compressed using the given Huffman trees
	   */
	  function compress_block(s, ltree, dtree)
	  //    deflate_state *s;
	  //    const ct_data *ltree; /* literal tree */
	  //    const ct_data *dtree; /* distance tree */
	  {
	    var dist;           /* distance of matched string */
	    var lc;             /* match length or unmatched char (if dist == 0) */
	    var lx = 0;         /* running index in l_buf */
	    var code;           /* the code to send */
	    var extra;          /* number of extra bits to send */
	
	    if (s.last_lit !== 0) {
	      do {
	        dist = (s.pending_buf[s.d_buf + lx * 2] << 8) | (s.pending_buf[s.d_buf + lx * 2 + 1]);
	        lc = s.pending_buf[s.l_buf + lx];
	        lx++;
	
	        if (dist === 0) {
	          send_code(s, lc, ltree); /* send a literal byte */
	          //Tracecv(isgraph(lc), (stderr," '%c' ", lc));
	        } else {
	          /* Here, lc is the match length - MIN_MATCH */
	          code = _length_code[lc];
	          send_code(s, code + LITERALS + 1, ltree); /* send the length code */
	          extra = extra_lbits[code];
	          if (extra !== 0) {
	            lc -= base_length[code];
	            send_bits(s, lc, extra);       /* send the extra length bits */
	          }
	          dist--; /* dist is now the match distance - 1 */
	          code = d_code(dist);
	          //Assert (code < D_CODES, "bad d_code");
	
	          send_code(s, code, dtree);       /* send the distance code */
	          extra = extra_dbits[code];
	          if (extra !== 0) {
	            dist -= base_dist[code];
	            send_bits(s, dist, extra);   /* send the extra distance bits */
	          }
	        } /* literal or match pair ? */
	
	        /* Check that the overlay between pending_buf and d_buf+l_buf is ok: */
	        //Assert((uInt)(s->pending) < s->lit_bufsize + 2*lx,
	        //       "pendingBuf overflow");
	
	      } while (lx < s.last_lit);
	    }
	
	    send_code(s, END_BLOCK, ltree);
	  }
	
	
	  /* ===========================================================================
	   * Construct one Huffman tree and assigns the code bit strings and lengths.
	   * Update the total bit length for the current block.
	   * IN assertion: the field freq is set for all tree elements.
	   * OUT assertions: the fields len and code are set to the optimal bit length
	   *     and corresponding code. The length opt_len is updated; static_len is
	   *     also updated if stree is not null. The field max_code is set.
	   */
	  function build_tree(s, desc)
	  //    deflate_state *s;
	  //    tree_desc *desc; /* the tree descriptor */
	  {
	    var tree     = desc.dyn_tree;
	    var stree    = desc.stat_desc.static_tree;
	    var has_stree = desc.stat_desc.has_stree;
	    var elems    = desc.stat_desc.elems;
	    var n, m;          /* iterate over heap elements */
	    var max_code = -1; /* largest code with non zero frequency */
	    var node;          /* new node being created */
	
	    /* Construct the initial heap, with least frequent element in
	     * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
	     * heap[0] is not used.
	     */
	    s.heap_len = 0;
	    s.heap_max = HEAP_SIZE;
	
	    for (n = 0; n < elems; n++) {
	      if (tree[n * 2]/*.Freq*/ !== 0) {
	        s.heap[++s.heap_len] = max_code = n;
	        s.depth[n] = 0;
	
	      } else {
	        tree[n * 2 + 1]/*.Len*/ = 0;
	      }
	    }
	
	    /* The pkzip format requires that at least one distance code exists,
	     * and that at least one bit should be sent even if there is only one
	     * possible code. So to avoid special checks later on we force at least
	     * two codes of non zero frequency.
	     */
	    while (s.heap_len < 2) {
	      node = s.heap[++s.heap_len] = (max_code < 2 ? ++max_code : 0);
	      tree[node * 2]/*.Freq*/ = 1;
	      s.depth[node] = 0;
	      s.opt_len--;
	
	      if (has_stree) {
	        s.static_len -= stree[node * 2 + 1]/*.Len*/;
	      }
	      /* node is 0 or 1 so it does not have extra bits */
	    }
	    desc.max_code = max_code;
	
	    /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
	     * establish sub-heaps of increasing lengths:
	     */
	    for (n = (s.heap_len >> 1/*int /2*/); n >= 1; n--) { pqdownheap(s, tree, n); }
	
	    /* Construct the Huffman tree by repeatedly combining the least two
	     * frequent nodes.
	     */
	    node = elems;              /* next internal node of the tree */
	    do {
	      //pqremove(s, tree, n);  /* n = node of least frequency */
	      /*** pqremove ***/
	      n = s.heap[1/*SMALLEST*/];
	      s.heap[1/*SMALLEST*/] = s.heap[s.heap_len--];
	      pqdownheap(s, tree, 1/*SMALLEST*/);
	      /***/
	
	      m = s.heap[1/*SMALLEST*/]; /* m = node of next least frequency */
	
	      s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */
	      s.heap[--s.heap_max] = m;
	
	      /* Create a new node father of n and m */
	      tree[node * 2]/*.Freq*/ = tree[n * 2]/*.Freq*/ + tree[m * 2]/*.Freq*/;
	      s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
	      tree[n * 2 + 1]/*.Dad*/ = tree[m * 2 + 1]/*.Dad*/ = node;
	
	      /* and insert the new node in the heap */
	      s.heap[1/*SMALLEST*/] = node++;
	      pqdownheap(s, tree, 1/*SMALLEST*/);
	
	    } while (s.heap_len >= 2);
	
	    s.heap[--s.heap_max] = s.heap[1/*SMALLEST*/];
	
	    /* At this point, the fields freq and dad are set. We can now
	     * generate the bit lengths.
	     */
	    gen_bitlen(s, desc);
	
	    /* The field len is now set, we can generate the bit codes */
	    gen_codes(tree, max_code, s.bl_count);
	  }
	
	
	  /* ===========================================================================
	   * Scan a literal or distance tree to determine the frequencies of the codes
	   * in the bit length tree.
	   */
	  function scan_tree(s, tree, max_code)
	  //    deflate_state *s;
	  //    ct_data *tree;   /* the tree to be scanned */
	  //    int max_code;    /* and its largest code of non zero frequency */
	  {
	    var n;                     /* iterates over all tree elements */
	    var prevlen = -1;          /* last emitted length */
	    var curlen;                /* length of current code */
	
	    var nextlen = tree[0 * 2 + 1]/*.Len*/; /* length of next code */
	
	    var count = 0;             /* repeat count of the current code */
	    var max_count = 7;         /* max repeat count */
	    var min_count = 4;         /* min repeat count */
	
	    if (nextlen === 0) {
	      max_count = 138;
	      min_count = 3;
	    }
	    tree[(max_code + 1) * 2 + 1]/*.Len*/ = 0xffff; /* guard */
	
	    for (n = 0; n <= max_code; n++) {
	      curlen = nextlen;
	      nextlen = tree[(n + 1) * 2 + 1]/*.Len*/;
	
	      if (++count < max_count && curlen === nextlen) {
	        continue;
	
	      } else if (count < min_count) {
	        s.bl_tree[curlen * 2]/*.Freq*/ += count;
	
	      } else if (curlen !== 0) {
	
	        if (curlen !== prevlen) { s.bl_tree[curlen * 2]/*.Freq*/++; }
	        s.bl_tree[REP_3_6 * 2]/*.Freq*/++;
	
	      } else if (count <= 10) {
	        s.bl_tree[REPZ_3_10 * 2]/*.Freq*/++;
	
	      } else {
	        s.bl_tree[REPZ_11_138 * 2]/*.Freq*/++;
	      }
	
	      count = 0;
	      prevlen = curlen;
	
	      if (nextlen === 0) {
	        max_count = 138;
	        min_count = 3;
	
	      } else if (curlen === nextlen) {
	        max_count = 6;
	        min_count = 3;
	
	      } else {
	        max_count = 7;
	        min_count = 4;
	      }
	    }
	  }
	
	
	  /* ===========================================================================
	   * Send a literal or distance tree in compressed form, using the codes in
	   * bl_tree.
	   */
	  function send_tree(s, tree, max_code)
	  //    deflate_state *s;
	  //    ct_data *tree; /* the tree to be scanned */
	  //    int max_code;       /* and its largest code of non zero frequency */
	  {
	    var n;                     /* iterates over all tree elements */
	    var prevlen = -1;          /* last emitted length */
	    var curlen;                /* length of current code */
	
	    var nextlen = tree[0 * 2 + 1]/*.Len*/; /* length of next code */
	
	    var count = 0;             /* repeat count of the current code */
	    var max_count = 7;         /* max repeat count */
	    var min_count = 4;         /* min repeat count */
	
	    /* tree[max_code+1].Len = -1; */  /* guard already set */
	    if (nextlen === 0) {
	      max_count = 138;
	      min_count = 3;
	    }
	
	    for (n = 0; n <= max_code; n++) {
	      curlen = nextlen;
	      nextlen = tree[(n + 1) * 2 + 1]/*.Len*/;
	
	      if (++count < max_count && curlen === nextlen) {
	        continue;
	
	      } else if (count < min_count) {
	        do { send_code(s, curlen, s.bl_tree); } while (--count !== 0);
	
	      } else if (curlen !== 0) {
	        if (curlen !== prevlen) {
	          send_code(s, curlen, s.bl_tree);
	          count--;
	        }
	        //Assert(count >= 3 && count <= 6, " 3_6?");
	        send_code(s, REP_3_6, s.bl_tree);
	        send_bits(s, count - 3, 2);
	
	      } else if (count <= 10) {
	        send_code(s, REPZ_3_10, s.bl_tree);
	        send_bits(s, count - 3, 3);
	
	      } else {
	        send_code(s, REPZ_11_138, s.bl_tree);
	        send_bits(s, count - 11, 7);
	      }
	
	      count = 0;
	      prevlen = curlen;
	      if (nextlen === 0) {
	        max_count = 138;
	        min_count = 3;
	
	      } else if (curlen === nextlen) {
	        max_count = 6;
	        min_count = 3;
	
	      } else {
	        max_count = 7;
	        min_count = 4;
	      }
	    }
	  }
	
	
	  /* ===========================================================================
	   * Construct the Huffman tree for the bit lengths and return the index in
	   * bl_order of the last bit length code to send.
	   */
	  function build_bl_tree(s) {
	    var max_blindex;  /* index of last bit length code of non zero freq */
	
	    /* Determine the bit length frequencies for literal and distance trees */
	    scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
	    scan_tree(s, s.dyn_dtree, s.d_desc.max_code);
	
	    /* Build the bit length tree: */
	    build_tree(s, s.bl_desc);
	    /* opt_len now includes the length of the tree representations, except
	     * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
	     */
	
	    /* Determine the number of bit length codes to send. The pkzip format
	     * requires that at least 4 bit length codes be sent. (appnote.txt says
	     * 3 but the actual value used is 4.)
	     */
	    for (max_blindex = BL_CODES - 1; max_blindex >= 3; max_blindex--) {
	      if (s.bl_tree[bl_order[max_blindex] * 2 + 1]/*.Len*/ !== 0) {
	        break;
	      }
	    }
	    /* Update opt_len to include the bit length tree and counts */
	    s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
	    //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
	    //        s->opt_len, s->static_len));
	
	    return max_blindex;
	  }
	
	
	  /* ===========================================================================
	   * Send the header for a block using dynamic Huffman trees: the counts, the
	   * lengths of the bit length codes, the literal tree and the distance tree.
	   * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
	   */
	  function send_all_trees(s, lcodes, dcodes, blcodes)
	  //    deflate_state *s;
	  //    int lcodes, dcodes, blcodes; /* number of codes for each tree */
	  {
	    var rank;                    /* index in bl_order */
	
	    //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
	    //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
	    //        "too many codes");
	    //Tracev((stderr, "\nbl counts: "));
	    send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */
	    send_bits(s, dcodes - 1,   5);
	    send_bits(s, blcodes - 4,  4); /* not -3 as stated in appnote.txt */
	    for (rank = 0; rank < blcodes; rank++) {
	      //Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
	      send_bits(s, s.bl_tree[bl_order[rank] * 2 + 1]/*.Len*/, 3);
	    }
	    //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));
	
	    send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */
	    //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));
	
	    send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */
	    //Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
	  }
	
	
	  /* ===========================================================================
	   * Check if the data type is TEXT or BINARY, using the following algorithm:
	   * - TEXT if the two conditions below are satisfied:
	   *    a) There are no non-portable control characters belonging to the
	   *       "black list" (0..6, 14..25, 28..31).
	   *    b) There is at least one printable character belonging to the
	   *       "white list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
	   * - BINARY otherwise.
	   * - The following partially-portable control characters form a
	   *   "gray list" that is ignored in this detection algorithm:
	   *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
	   * IN assertion: the fields Freq of dyn_ltree are set.
	   */
	  function detect_data_type(s) {
	    /* black_mask is the bit mask of black-listed bytes
	     * set bits 0..6, 14..25, and 28..31
	     * 0xf3ffc07f = binary 11110011111111111100000001111111
	     */
	    var black_mask = 0xf3ffc07f;
	    var n;
	
	    /* Check for non-textual ("black-listed") bytes. */
	    for (n = 0; n <= 31; n++, black_mask >>>= 1) {
	      if ((black_mask & 1) && (s.dyn_ltree[n * 2]/*.Freq*/ !== 0)) {
	        return Z_BINARY;
	      }
	    }
	
	    /* Check for textual ("white-listed") bytes. */
	    if (s.dyn_ltree[9 * 2]/*.Freq*/ !== 0 || s.dyn_ltree[10 * 2]/*.Freq*/ !== 0 ||
	        s.dyn_ltree[13 * 2]/*.Freq*/ !== 0) {
	      return Z_TEXT;
	    }
	    for (n = 32; n < LITERALS; n++) {
	      if (s.dyn_ltree[n * 2]/*.Freq*/ !== 0) {
	        return Z_TEXT;
	      }
	    }
	
	    /* There are no "black-listed" or "white-listed" bytes:
	     * this stream either is empty or has tolerated ("gray-listed") bytes only.
	     */
	    return Z_BINARY;
	  }
	
	
	  var static_init_done = false;
	
	  /* ===========================================================================
	   * Initialize the tree data structures for a new zlib stream.
	   */
	  function _tr_init(s) {
	
	    if (!static_init_done) {
	      tr_static_init();
	      static_init_done = true;
	    }
	
	    s.l_desc  = new TreeDesc(s.dyn_ltree, static_l_desc);
	    s.d_desc  = new TreeDesc(s.dyn_dtree, static_d_desc);
	    s.bl_desc = new TreeDesc(s.bl_tree, static_bl_desc);
	
	    s.bi_buf = 0;
	    s.bi_valid = 0;
	
	    /* Initialize the first block of the first file: */
	    init_block(s);
	  }
	
	
	  /* ===========================================================================
	   * Send a stored block
	   */
	  function _tr_stored_block(s, buf, stored_len, last) {
	    //DeflateState *s;
	    //charf *buf;       /* input block */
	    //ulg stored_len;   /* length of input block */
	    //int last;         /* one if this is the last block for a file */
	    send_bits(s, (STORED_BLOCK << 1) + (last ? 1 : 0), 3);    /* send block type */
	    copy_block(s, buf, stored_len, true); /* with header */
	  }
	
	
	  /* ===========================================================================
	   * Send one empty static block to give enough lookahead for inflate.
	   * This takes 10 bits, of which 7 may remain in the bit buffer.
	   */
	  function _tr_align(s) {
	    send_bits(s, STATIC_TREES << 1, 3);
	    send_code(s, END_BLOCK, static_ltree);
	    bi_flush(s);
	  }
	
	
	  /* ===========================================================================
	   * Determine the best encoding for the current block: dynamic trees, static
	   * trees or store, and output the encoded block to the zip file.
	   */
	  function _tr_flush_block(s, buf, stored_len, last) {
	    //DeflateState *s;
	    //charf *buf;       /* input block, or NULL if too old */
	    //ulg stored_len;   /* length of input block */
	    //int last;         /* one if this is the last block for a file */
	    var opt_lenb, static_lenb;  /* opt_len and static_len in bytes */
	    var max_blindex = 0;        /* index of last bit length code of non zero freq */
	
	    /* Build the Huffman trees unless a stored block is forced */
	    if (s.level > 0) {
	
	      /* Check if the file is binary or text */
	      if (s.strm.data_type === Z_UNKNOWN) {
	        s.strm.data_type = detect_data_type(s);
	      }
	
	      /* Construct the literal and distance trees */
	      build_tree(s, s.l_desc);
	      // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
	      //        s->static_len));
	
	      build_tree(s, s.d_desc);
	      // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
	      //        s->static_len));
	      /* At this point, opt_len and static_len are the total bit lengths of
	       * the compressed block data, excluding the tree representations.
	       */
	
	      /* Build the bit length tree for the above two trees, and get the index
	       * in bl_order of the last bit length code to send.
	       */
	      max_blindex = build_bl_tree(s);
	
	      /* Determine the best encoding. Compute the block lengths in bytes. */
	      opt_lenb = (s.opt_len + 3 + 7) >>> 3;
	      static_lenb = (s.static_len + 3 + 7) >>> 3;
	
	      // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
	      //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
	      //        s->last_lit));
	
	      if (static_lenb <= opt_lenb) { opt_lenb = static_lenb; }
	
	    } else {
	      // Assert(buf != (char*)0, "lost buf");
	      opt_lenb = static_lenb = stored_len + 5; /* force a stored block */
	    }
	
	    if ((stored_len + 4 <= opt_lenb) && (buf !== -1)) {
	      /* 4: two words for the lengths */
	
	      /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
	       * Otherwise we can't have processed more than WSIZE input bytes since
	       * the last block flush, because compression would have been
	       * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
	       * transform a block into a stored block.
	       */
	      _tr_stored_block(s, buf, stored_len, last);
	
	    } else if (s.strategy === Z_FIXED || static_lenb === opt_lenb) {
	
	      send_bits(s, (STATIC_TREES << 1) + (last ? 1 : 0), 3);
	      compress_block(s, static_ltree, static_dtree);
	
	    } else {
	      send_bits(s, (DYN_TREES << 1) + (last ? 1 : 0), 3);
	      send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
	      compress_block(s, s.dyn_ltree, s.dyn_dtree);
	    }
	    // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
	    /* The above check is made mod 2^32, for files larger than 512 MB
	     * and uLong implemented on 32 bits.
	     */
	    init_block(s);
	
	    if (last) {
	      bi_windup(s);
	    }
	    // Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
	    //       s->compressed_len-7*last));
	  }
	
	  /* ===========================================================================
	   * Save the match info and tally the frequency counts. Return true if
	   * the current block must be flushed.
	   */
	  function _tr_tally(s, dist, lc) {
	    //    deflate_state *s;
	    //    unsigned dist;  /* distance of matched string */
	    //    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
	    //var out_length, in_length, dcode;
	
	    s.pending_buf[s.d_buf + s.last_lit * 2]     = (dist >>> 8) & 0xff;
	    s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist & 0xff;
	
	    s.pending_buf[s.l_buf + s.last_lit] = lc & 0xff;
	    s.last_lit++;
	
	    if (dist === 0) {
	      /* lc is the unmatched char */
	      s.dyn_ltree[lc * 2]/*.Freq*/++;
	    } else {
	      s.matches++;
	      /* Here, lc is the match length - MIN_MATCH */
	      dist--;             /* dist = match distance - 1 */
	      //Assert((ush)dist < (ush)MAX_DIST(s) &&
	      //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
	      //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");
	
	      s.dyn_ltree[(_length_code[lc] + LITERALS + 1) * 2]/*.Freq*/++;
	      s.dyn_dtree[d_code(dist) * 2]/*.Freq*/++;
	    }
	
	  // (!) This block is disabled in zlib defaults,
	  // don't enable it for binary compatibility
	
	  //#ifdef TRUNCATE_BLOCK
	  //  /* Try to guess if it is profitable to stop the current block here */
	  //  if ((s.last_lit & 0x1fff) === 0 && s.level > 2) {
	  //    /* Compute an upper bound for the compressed length */
	  //    out_length = s.last_lit*8;
	  //    in_length = s.strstart - s.block_start;
	  //
	  //    for (dcode = 0; dcode < D_CODES; dcode++) {
	  //      out_length += s.dyn_dtree[dcode*2]/*.Freq*/ * (5 + extra_dbits[dcode]);
	  //    }
	  //    out_length >>>= 3;
	  //    //Tracev((stderr,"\nlast_lit %u, in %ld, out ~%ld(%ld%%) ",
	  //    //       s->last_lit, in_length, out_length,
	  //    //       100L - out_length*100L/in_length));
	  //    if (s.matches < (s.last_lit>>1)/*int /2*/ && out_length < (in_length>>1)/*int /2*/) {
	  //      return true;
	  //    }
	  //  }
	  //#endif
	
	    return (s.last_lit === s.lit_bufsize - 1);
	    /* We avoid equality with lit_bufsize because of wraparound at 64K
	     * on 16 bit machines and because stored blocks are restricted to
	     * 64K-1 bytes.
	     */
	  }
	
	  /* eslint-disable */
	
	  var MAX_MEM_LEVEL = 9;
	
	
	  var LENGTH_CODES$1  = 29;
	  /* number of length codes, not counting the special END_BLOCK code */
	  var LITERALS$1      = 256;
	  /* number of literal bytes 0..255 */
	  var L_CODES$1       = LITERALS$1 + 1 + LENGTH_CODES$1;
	  /* number of Literal or Length codes, including the END_BLOCK code */
	  var D_CODES$1       = 30;
	  /* number of distance codes */
	  var BL_CODES$1      = 19;
	  /* number of codes used to transfer the bit lengths */
	  var HEAP_SIZE$1     = 2 * L_CODES$1 + 1;
	  /* maximum heap size */
	  var MAX_BITS$1  = 15;
	  /* All codes must not exceed MAX_BITS bits */
	
	  var MIN_MATCH$1 = 3;
	  var MAX_MATCH$1 = 258;
	  var MIN_LOOKAHEAD = (MAX_MATCH$1 + MIN_MATCH$1 + 1);
	
	  var PRESET_DICT = 0x20;
	
	  var INIT_STATE = 42;
	  var EXTRA_STATE = 69;
	  var NAME_STATE = 73;
	  var COMMENT_STATE = 91;
	  var HCRC_STATE = 103;
	  var BUSY_STATE = 113;
	  var FINISH_STATE = 666;
	
	  var BS_NEED_MORE      = 1; /* block not completed, need more input or more output */
	  var BS_BLOCK_DONE     = 2; /* block flush performed */
	  var BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */
	  var BS_FINISH_DONE    = 4; /* finish done, accept no more input or output */
	
	  var OS_CODE = 0x03; // Unix :) . Don't detect, use this default.
	
	  function err(strm, errorCode) {
	    strm.msg = msg[errorCode];
	    return errorCode;
	  }
	
	  function rank(f) {
	    return ((f) << 1) - ((f) > 4 ? 9 : 0);
	  }
	
	  function zero$1(buf) { var len = buf.length; while (--len >= 0) { buf[len] = 0; } }
	
	
	  /* =========================================================================
	   * Flush as much pending output as possible. All deflate() output goes
	   * through this function so some applications may wish to modify it
	   * to avoid allocating a large strm->output buffer and copying into it.
	   * (See also read_buf()).
	   */
	  function flush_pending(strm) {
	    var s = strm.state;
	
	    //_tr_flush_bits(s);
	    var len = s.pending;
	    if (len > strm.avail_out) {
	      len = strm.avail_out;
	    }
	    if (len === 0) { return; }
	
	    arraySet(strm.output, s.pending_buf, s.pending_out, len, strm.next_out);
	    strm.next_out += len;
	    s.pending_out += len;
	    strm.total_out += len;
	    strm.avail_out -= len;
	    s.pending -= len;
	    if (s.pending === 0) {
	      s.pending_out = 0;
	    }
	  }
	
	
	  function flush_block_only(s, last) {
	    _tr_flush_block(s, (s.block_start >= 0 ? s.block_start : -1), s.strstart - s.block_start, last);
	    s.block_start = s.strstart;
	    flush_pending(s.strm);
	  }
	
	
	  function put_byte(s, b) {
	    s.pending_buf[s.pending++] = b;
	  }
	
	
	  /* =========================================================================
	   * Put a short in the pending buffer. The 16-bit value is put in MSB order.
	   * IN assertion: the stream state is correct and there is enough room in
	   * pending_buf.
	   */
	  function putShortMSB(s, b) {
	  //  put_byte(s, (Byte)(b >> 8));
	  //  put_byte(s, (Byte)(b & 0xff));
	    s.pending_buf[s.pending++] = (b >>> 8) & 0xff;
	    s.pending_buf[s.pending++] = b & 0xff;
	  }
	
	
	  /* ===========================================================================
	   * Read a new buffer from the current input stream, update the adler32
	   * and total number of bytes read.  All deflate() input goes through
	   * this function so some applications may wish to modify it to avoid
	   * allocating a large strm->input buffer and copying from it.
	   * (See also flush_pending()).
	   */
	  function read_buf(strm, buf, start, size) {
	    var len = strm.avail_in;
	
	    if (len > size) { len = size; }
	    if (len === 0) { return 0; }
	
	    strm.avail_in -= len;
	
	    // zmemcpy(buf, strm->next_in, len);
	    arraySet(buf, strm.input, strm.next_in, len, start);
	    if (strm.state.wrap === 1) {
	      strm.adler = adler32(strm.adler, buf, len, start);
	    }
	
	    else if (strm.state.wrap === 2) {
	      strm.adler = crc32(strm.adler, buf, len, start);
	    }
	
	    strm.next_in += len;
	    strm.total_in += len;
	
	    return len;
	  }
	
	
	  /* ===========================================================================
	   * Set match_start to the longest match starting at the given string and
	   * return its length. Matches shorter or equal to prev_length are discarded,
	   * in which case the result is equal to prev_length and match_start is
	   * garbage.
	   * IN assertions: cur_match is the head of the hash chain for the current
	   *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
	   * OUT assertion: the match length is not greater than s->lookahead.
	   */
	  function longest_match(s, cur_match) {
	    var chain_length = s.max_chain_length;      /* max hash chain length */
	    var scan = s.strstart; /* current string */
	    var match;                       /* matched string */
	    var len;                           /* length of current match */
	    var best_len = s.prev_length;              /* best match length so far */
	    var nice_match = s.nice_match;             /* stop if match long enough */
	    var limit = (s.strstart > (s.w_size - MIN_LOOKAHEAD)) ?
	        s.strstart - (s.w_size - MIN_LOOKAHEAD) : 0/*NIL*/;
	
	    var _win = s.window; // shortcut
	
	    var wmask = s.w_mask;
	    var prev  = s.prev;
	
	    /* Stop when cur_match becomes <= limit. To simplify the code,
	     * we prevent matches with the string of window index 0.
	     */
	
	    var strend = s.strstart + MAX_MATCH$1;
	    var scan_end1  = _win[scan + best_len - 1];
	    var scan_end   = _win[scan + best_len];
	
	    /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
	     * It is easy to get rid of this optimization if necessary.
	     */
	    // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");
	
	    /* Do not waste too much time if we already have a good match: */
	    if (s.prev_length >= s.good_match) {
	      chain_length >>= 2;
	    }
	    /* Do not look for matches beyond the end of the input. This is necessary
	     * to make deflate deterministic.
	     */
	    if (nice_match > s.lookahead) { nice_match = s.lookahead; }
	
	    // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");
	
	    do {
	      // Assert(cur_match < s->strstart, "no future");
	      match = cur_match;
	
	      /* Skip to next match if the match length cannot increase
	       * or if the match length is less than 2.  Note that the checks below
	       * for insufficient lookahead only occur occasionally for performance
	       * reasons.  Therefore uninitialized memory will be accessed, and
	       * conditional jumps will be made that depend on those values.
	       * However the length of the match is limited to the lookahead, so
	       * the output of deflate is not affected by the uninitialized values.
	       */
	
	      if (_win[match + best_len]     !== scan_end  ||
	          _win[match + best_len - 1] !== scan_end1 ||
	          _win[match]                !== _win[scan] ||
	          _win[++match]              !== _win[scan + 1]) {
	        continue;
	      }
	
	      /* The check at best_len-1 can be removed because it will be made
	       * again later. (This heuristic is not always a win.)
	       * It is not necessary to compare scan[2] and match[2] since they
	       * are always equal when the other bytes match, given that
	       * the hash keys are equal and that HASH_BITS >= 8.
	       */
	      scan += 2;
	      match++;
	      // Assert(*scan == *match, "match[2]?");
	
	      /* We check for insufficient lookahead only every 8th comparison;
	       * the 256th check will be made at strstart+258.
	       */
	      do {
	        /*jshint noempty:false*/
	      } while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	               _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	               _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	               _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	               scan < strend);
	
	      // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");
	
	      len = MAX_MATCH$1 - (strend - scan);
	      scan = strend - MAX_MATCH$1;
	
	      if (len > best_len) {
	        s.match_start = cur_match;
	        best_len = len;
	        if (len >= nice_match) {
	          break;
	        }
	        scan_end1  = _win[scan + best_len - 1];
	        scan_end   = _win[scan + best_len];
	      }
	    } while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);
	
	    if (best_len <= s.lookahead) {
	      return best_len;
	    }
	    return s.lookahead;
	  }
	
	
	  /* ===========================================================================
	   * Fill the window when the lookahead becomes insufficient.
	   * Updates strstart and lookahead.
	   *
	   * IN assertion: lookahead < MIN_LOOKAHEAD
	   * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
	   *    At least one byte has been read, or avail_in == 0; reads are
	   *    performed for at least two bytes (required for the zip translate_eol
	   *    option -- not supported here).
	   */
	  function fill_window(s) {
	    var _w_size = s.w_size;
	    var p, n, m, more, str;
	
	    //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");
	
	    do {
	      more = s.window_size - s.lookahead - s.strstart;
	
	      // JS ints have 32 bit, block below not needed
	      /* Deal with !@#$% 64K limit: */
	      //if (sizeof(int) <= 2) {
	      //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
	      //        more = wsize;
	      //
	      //  } else if (more == (unsigned)(-1)) {
	      //        /* Very unlikely, but possible on 16 bit machine if
	      //         * strstart == 0 && lookahead == 1 (input done a byte at time)
	      //         */
	      //        more--;
	      //    }
	      //}
	
	
	      /* If the window is almost full and there is insufficient lookahead,
	       * move the upper half to the lower one to make room in the upper half.
	       */
	      if (s.strstart >= _w_size + (_w_size - MIN_LOOKAHEAD)) {
	
	        arraySet(s.window, s.window, _w_size, _w_size, 0);
	        s.match_start -= _w_size;
	        s.strstart -= _w_size;
	        /* we now have strstart >= MAX_DIST */
	        s.block_start -= _w_size;
	
	        /* Slide the hash table (could be avoided with 32 bit values
	         at the expense of memory usage). We slide even when level == 0
	         to keep the hash table consistent if we switch back to level > 0
	         later. (Using level 0 permanently is not an optimal usage of
	         zlib, so we don't care about this pathological case.)
	         */
	
	        n = s.hash_size;
	        p = n;
	        do {
	          m = s.head[--p];
	          s.head[p] = (m >= _w_size ? m - _w_size : 0);
	        } while (--n);
	
	        n = _w_size;
	        p = n;
	        do {
	          m = s.prev[--p];
	          s.prev[p] = (m >= _w_size ? m - _w_size : 0);
	          /* If n is not on any hash chain, prev[n] is garbage but
	           * its value will never be used.
	           */
	        } while (--n);
	
	        more += _w_size;
	      }
	      if (s.strm.avail_in === 0) {
	        break;
	      }
	
	      /* If there was no sliding:
	       *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
	       *    more == window_size - lookahead - strstart
	       * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
	       * => more >= window_size - 2*WSIZE + 2
	       * In the BIG_MEM or MMAP case (not yet supported),
	       *   window_size == input_size + MIN_LOOKAHEAD  &&
	       *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
	       * Otherwise, window_size == 2*WSIZE so more >= 2.
	       * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
	       */
	      //Assert(more >= 2, "more < 2");
	      n = read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
	      s.lookahead += n;
	
	      /* Initialize the hash value now that we have some input: */
	      if (s.lookahead + s.insert >= MIN_MATCH$1) {
	        str = s.strstart - s.insert;
	        s.ins_h = s.window[str];
	
	        /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */
	        s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + 1]) & s.hash_mask;
	  //#if MIN_MATCH != 3
	  //        Call update_hash() MIN_MATCH-3 more times
	  //#endif
	        while (s.insert) {
	          /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
	          s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + MIN_MATCH$1 - 1]) & s.hash_mask;
	
	          s.prev[str & s.w_mask] = s.head[s.ins_h];
	          s.head[s.ins_h] = str;
	          str++;
	          s.insert--;
	          if (s.lookahead + s.insert < MIN_MATCH$1) {
	            break;
	          }
	        }
	      }
	      /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
	       * but this is not important since only literal bytes will be emitted.
	       */
	
	    } while (s.lookahead < MIN_LOOKAHEAD && s.strm.avail_in !== 0);
	
	    /* If the WIN_INIT bytes after the end of the current data have never been
	     * written, then zero those bytes in order to avoid memory check reports of
	     * the use of uninitialized (or uninitialised as Julian writes) bytes by
	     * the longest match routines.  Update the high water mark for the next
	     * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
	     * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
	     */
	  //  if (s.high_water < s.window_size) {
	  //    var curr = s.strstart + s.lookahead;
	  //    var init = 0;
	  //
	  //    if (s.high_water < curr) {
	  //      /* Previous high water mark below current data -- zero WIN_INIT
	  //       * bytes or up to end of window, whichever is less.
	  //       */
	  //      init = s.window_size - curr;
	  //      if (init > WIN_INIT)
	  //        init = WIN_INIT;
	  //      zmemzero(s->window + curr, (unsigned)init);
	  //      s->high_water = curr + init;
	  //    }
	  //    else if (s->high_water < (ulg)curr + WIN_INIT) {
	  //      /* High water mark at or above current data, but below current data
	  //       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
	  //       * to end of window, whichever is less.
	  //       */
	  //      init = (ulg)curr + WIN_INIT - s->high_water;
	  //      if (init > s->window_size - s->high_water)
	  //        init = s->window_size - s->high_water;
	  //      zmemzero(s->window + s->high_water, (unsigned)init);
	  //      s->high_water += init;
	  //    }
	  //  }
	  //
	  //  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
	  //    "not enough room for search");
	  }
	
	  /* ===========================================================================
	   * Copy without compression as much as possible from the input stream, return
	   * the current block state.
	   * This function does not insert new strings in the dictionary since
	   * uncompressible data is probably not useful. This function is used
	   * only for the level=0 compression option.
	   * NOTE: this function should be optimized to avoid extra copying from
	   * window to pending_buf.
	   */
	  function deflate_stored(s, flush) {
	    /* Stored blocks are limited to 0xffff bytes, pending_buf is limited
	     * to pending_buf_size, and each stored block has a 5 byte header:
	     */
	    var max_block_size = 0xffff;
	
	    if (max_block_size > s.pending_buf_size - 5) {
	      max_block_size = s.pending_buf_size - 5;
	    }
	
	    /* Copy as much as possible from input to output: */
	    for (;;) {
	      /* Fill the window as much as possible: */
	      if (s.lookahead <= 1) {
	
	        //Assert(s->strstart < s->w_size+MAX_DIST(s) ||
	        //  s->block_start >= (long)s->w_size, "slide too late");
	  //      if (!(s.strstart < s.w_size + (s.w_size - MIN_LOOKAHEAD) ||
	  //        s.block_start >= s.w_size)) {
	  //        throw  new Error("slide too late");
	  //      }
	
	        fill_window(s);
	        if (s.lookahead === 0 && flush === Z_NO_FLUSH) {
	          return BS_NEED_MORE;
	        }
	
	        if (s.lookahead === 0) {
	          break;
	        }
	        /* flush the current block */
	      }
	      //Assert(s->block_start >= 0L, "block gone");
	  //    if (s.block_start < 0) throw new Error("block gone");
	
	      s.strstart += s.lookahead;
	      s.lookahead = 0;
	
	      /* Emit a stored block if pending_buf will be full: */
	      var max_start = s.block_start + max_block_size;
	
	      if (s.strstart === 0 || s.strstart >= max_start) {
	        /* strstart == 0 is possible when wraparound on 16-bit machine */
	        s.lookahead = s.strstart - max_start;
	        s.strstart = max_start;
	        /*** FLUSH_BLOCK(s, 0); ***/
	        flush_block_only(s, false);
	        if (s.strm.avail_out === 0) {
	          return BS_NEED_MORE;
	        }
	        /***/
	
	
	      }
	      /* Flush if we may have to slide, otherwise block_start may become
	       * negative and the data will be gone:
	       */
	      if (s.strstart - s.block_start >= (s.w_size - MIN_LOOKAHEAD)) {
	        /*** FLUSH_BLOCK(s, 0); ***/
	        flush_block_only(s, false);
	        if (s.strm.avail_out === 0) {
	          return BS_NEED_MORE;
	        }
	        /***/
	      }
	    }
	
	    s.insert = 0;
	
	    if (flush === Z_FINISH) {
	      /*** FLUSH_BLOCK(s, 1); ***/
	      flush_block_only(s, true);
	      if (s.strm.avail_out === 0) {
	        return BS_FINISH_STARTED;
	      }
	      /***/
	      return BS_FINISH_DONE;
	    }
	
	    if (s.strstart > s.block_start) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	
	    return BS_NEED_MORE;
	  }
	
	  /* ===========================================================================
	   * Compress as much as possible from the input stream, return the current
	   * block state.
	   * This function does not perform lazy evaluation of matches and inserts
	   * new strings in the dictionary only for unmatched strings or for short
	   * matches. It is used only for the fast compression options.
	   */
	  function deflate_fast(s, flush) {
	    var hash_head;        /* head of the hash chain */
	    var bflush;           /* set if current block must be flushed */
	
	    for (;;) {
	      /* Make sure that we always have enough lookahead, except
	       * at the end of the input file. We need MAX_MATCH bytes
	       * for the next match, plus MIN_MATCH bytes to insert the
	       * string following the next match.
	       */
	      if (s.lookahead < MIN_LOOKAHEAD) {
	        fill_window(s);
	        if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
	          return BS_NEED_MORE;
	        }
	        if (s.lookahead === 0) {
	          break; /* flush the current block */
	        }
	      }
	
	      /* Insert the string window[strstart .. strstart+2] in the
	       * dictionary, and set hash_head to the head of the hash chain:
	       */
	      hash_head = 0/*NIL*/;
	      if (s.lookahead >= MIN_MATCH$1) {
	        /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	        s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH$1 - 1]) & s.hash_mask;
	        hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	        s.head[s.ins_h] = s.strstart;
	        /***/
	      }
	
	      /* Find the longest match, discarding those <= prev_length.
	       * At this point we have always match_length < MIN_MATCH
	       */
	      if (hash_head !== 0/*NIL*/ && ((s.strstart - hash_head) <= (s.w_size - MIN_LOOKAHEAD))) {
	        /* To simplify the code, we prevent matches with the string
	         * of window index 0 (in particular we have to avoid a match
	         * of the string with itself at the start of the input file).
	         */
	        s.match_length = longest_match(s, hash_head);
	        /* longest_match() sets match_start */
	      }
	      if (s.match_length >= MIN_MATCH$1) {
	        // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only
	
	        /*** _tr_tally_dist(s, s.strstart - s.match_start,
	                       s.match_length - MIN_MATCH, bflush); ***/
	        bflush = _tr_tally(s, s.strstart - s.match_start, s.match_length - MIN_MATCH$1);
	
	        s.lookahead -= s.match_length;
	
	        /* Insert new strings in the hash table only if the match length
	         * is not too large. This saves time but degrades compression.
	         */
	        if (s.match_length <= s.max_lazy_match/*max_insert_length*/ && s.lookahead >= MIN_MATCH$1) {
	          s.match_length--; /* string at strstart already in table */
	          do {
	            s.strstart++;
	            /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	            s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH$1 - 1]) & s.hash_mask;
	            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	            s.head[s.ins_h] = s.strstart;
	            /***/
	            /* strstart never exceeds WSIZE-MAX_MATCH, so there are
	             * always MIN_MATCH bytes ahead.
	             */
	          } while (--s.match_length !== 0);
	          s.strstart++;
	        } else
	        {
	          s.strstart += s.match_length;
	          s.match_length = 0;
	          s.ins_h = s.window[s.strstart];
	          /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */
	          s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + 1]) & s.hash_mask;
	
	  //#if MIN_MATCH != 3
	  //                Call UPDATE_HASH() MIN_MATCH-3 more times
	  //#endif
	          /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
	           * matter since it will be recomputed at next deflate call.
	           */
	        }
	      } else {
	        /* No match, output a literal byte */
	        //Tracevv((stderr,"%c", s.window[s.strstart]));
	        /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
	        bflush = _tr_tally(s, 0, s.window[s.strstart]);
	
	        s.lookahead--;
	        s.strstart++;
	      }
	      if (bflush) {
	        /*** FLUSH_BLOCK(s, 0); ***/
	        flush_block_only(s, false);
	        if (s.strm.avail_out === 0) {
	          return BS_NEED_MORE;
	        }
	        /***/
	      }
	    }
	    s.insert = ((s.strstart < (MIN_MATCH$1 - 1)) ? s.strstart : MIN_MATCH$1 - 1);
	    if (flush === Z_FINISH) {
	      /*** FLUSH_BLOCK(s, 1); ***/
	      flush_block_only(s, true);
	      if (s.strm.avail_out === 0) {
	        return BS_FINISH_STARTED;
	      }
	      /***/
	      return BS_FINISH_DONE;
	    }
	    if (s.last_lit) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	    return BS_BLOCK_DONE;
	  }
	
	  /* ===========================================================================
	   * Same as above, but achieves better compression. We use a lazy
	   * evaluation for matches: a match is finally adopted only if there is
	   * no better match at the next window position.
	   */
	  function deflate_slow(s, flush) {
	    var hash_head;          /* head of hash chain */
	    var bflush;              /* set if current block must be flushed */
	
	    var max_insert;
	
	    /* Process the input block. */
	    for (;;) {
	      /* Make sure that we always have enough lookahead, except
	       * at the end of the input file. We need MAX_MATCH bytes
	       * for the next match, plus MIN_MATCH bytes to insert the
	       * string following the next match.
	       */
	      if (s.lookahead < MIN_LOOKAHEAD) {
	        fill_window(s);
	        if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
	          return BS_NEED_MORE;
	        }
	        if (s.lookahead === 0) { break; } /* flush the current block */
	      }
	
	      /* Insert the string window[strstart .. strstart+2] in the
	       * dictionary, and set hash_head to the head of the hash chain:
	       */
	      hash_head = 0/*NIL*/;
	      if (s.lookahead >= MIN_MATCH$1) {
	        /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	        s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH$1 - 1]) & s.hash_mask;
	        hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	        s.head[s.ins_h] = s.strstart;
	        /***/
	      }
	
	      /* Find the longest match, discarding those <= prev_length.
	       */
	      s.prev_length = s.match_length;
	      s.prev_match = s.match_start;
	      s.match_length = MIN_MATCH$1 - 1;
	
	      if (hash_head !== 0/*NIL*/ && s.prev_length < s.max_lazy_match &&
	          s.strstart - hash_head <= (s.w_size - MIN_LOOKAHEAD)/*MAX_DIST(s)*/) {
	        /* To simplify the code, we prevent matches with the string
	         * of window index 0 (in particular we have to avoid a match
	         * of the string with itself at the start of the input file).
	         */
	        s.match_length = longest_match(s, hash_head);
	        /* longest_match() sets match_start */
	
	        if (s.match_length <= 5 &&
	           (s.strategy === Z_FILTERED || (s.match_length === MIN_MATCH$1 && s.strstart - s.match_start > 4096/*TOO_FAR*/))) {
	
	          /* If prev_match is also MIN_MATCH, match_start is garbage
	           * but we will ignore the current match anyway.
	           */
	          s.match_length = MIN_MATCH$1 - 1;
	        }
	      }
	      /* If there was a match at the previous step and the current
	       * match is not better, output the previous match:
	       */
	      if (s.prev_length >= MIN_MATCH$1 && s.match_length <= s.prev_length) {
	        max_insert = s.strstart + s.lookahead - MIN_MATCH$1;
	        /* Do not insert strings in hash table beyond this. */
	
	        //check_match(s, s.strstart-1, s.prev_match, s.prev_length);
	
	        /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
	                       s.prev_length - MIN_MATCH, bflush);***/
	        bflush = _tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - MIN_MATCH$1);
	        /* Insert in hash table all strings up to the end of the match.
	         * strstart-1 and strstart are already inserted. If there is not
	         * enough lookahead, the last two strings are not inserted in
	         * the hash table.
	         */
	        s.lookahead -= s.prev_length - 1;
	        s.prev_length -= 2;
	        do {
	          if (++s.strstart <= max_insert) {
	            /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	            s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH$1 - 1]) & s.hash_mask;
	            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	            s.head[s.ins_h] = s.strstart;
	            /***/
	          }
	        } while (--s.prev_length !== 0);
	        s.match_available = 0;
	        s.match_length = MIN_MATCH$1 - 1;
	        s.strstart++;
	
	        if (bflush) {
	          /*** FLUSH_BLOCK(s, 0); ***/
	          flush_block_only(s, false);
	          if (s.strm.avail_out === 0) {
	            return BS_NEED_MORE;
	          }
	          /***/
	        }
	
	      } else if (s.match_available) {
	        /* If there was no match at the previous position, output a
	         * single literal. If there was a match but the current match
	         * is longer, truncate the previous match to a single literal.
	         */
	        //Tracevv((stderr,"%c", s->window[s->strstart-1]));
	        /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
	        bflush = _tr_tally(s, 0, s.window[s.strstart - 1]);
	
	        if (bflush) {
	          /*** FLUSH_BLOCK_ONLY(s, 0) ***/
	          flush_block_only(s, false);
	          /***/
	        }
	        s.strstart++;
	        s.lookahead--;
	        if (s.strm.avail_out === 0) {
	          return BS_NEED_MORE;
	        }
	      } else {
	        /* There is no previous match to compare with, wait for
	         * the next step to decide.
	         */
	        s.match_available = 1;
	        s.strstart++;
	        s.lookahead--;
	      }
	    }
	    //Assert (flush != Z_NO_FLUSH, "no flush?");
	    if (s.match_available) {
	      //Tracevv((stderr,"%c", s->window[s->strstart-1]));
	      /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
	      bflush = _tr_tally(s, 0, s.window[s.strstart - 1]);
	
	      s.match_available = 0;
	    }
	    s.insert = s.strstart < MIN_MATCH$1 - 1 ? s.strstart : MIN_MATCH$1 - 1;
	    if (flush === Z_FINISH) {
	      /*** FLUSH_BLOCK(s, 1); ***/
	      flush_block_only(s, true);
	      if (s.strm.avail_out === 0) {
	        return BS_FINISH_STARTED;
	      }
	      /***/
	      return BS_FINISH_DONE;
	    }
	    if (s.last_lit) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	
	    return BS_BLOCK_DONE;
	  }
	
	
	  /* ===========================================================================
	   * For Z_RLE, simply look for runs of bytes, generate matches only of distance
	   * one.  Do not maintain a hash table.  (It will be regenerated if this run of
	   * deflate switches away from Z_RLE.)
	   */
	  function deflate_rle(s, flush) {
	    var bflush;            /* set if current block must be flushed */
	    var prev;              /* byte at distance one to match */
	    var scan, strend;      /* scan goes up to strend for length of run */
	
	    var _win = s.window;
	
	    for (;;) {
	      /* Make sure that we always have enough lookahead, except
	       * at the end of the input file. We need MAX_MATCH bytes
	       * for the longest run, plus one for the unrolled loop.
	       */
	      if (s.lookahead <= MAX_MATCH$1) {
	        fill_window(s);
	        if (s.lookahead <= MAX_MATCH$1 && flush === Z_NO_FLUSH) {
	          return BS_NEED_MORE;
	        }
	        if (s.lookahead === 0) { break; } /* flush the current block */
	      }
	
	      /* See how many times the previous byte repeats */
	      s.match_length = 0;
	      if (s.lookahead >= MIN_MATCH$1 && s.strstart > 0) {
	        scan = s.strstart - 1;
	        prev = _win[scan];
	        if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
	          strend = s.strstart + MAX_MATCH$1;
	          do {
	            /*jshint noempty:false*/
	          } while (prev === _win[++scan] && prev === _win[++scan] &&
	                   prev === _win[++scan] && prev === _win[++scan] &&
	                   prev === _win[++scan] && prev === _win[++scan] &&
	                   prev === _win[++scan] && prev === _win[++scan] &&
	                   scan < strend);
	          s.match_length = MAX_MATCH$1 - (strend - scan);
	          if (s.match_length > s.lookahead) {
	            s.match_length = s.lookahead;
	          }
	        }
	        //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
	      }
	
	      /* Emit match if have run of MIN_MATCH or longer, else emit literal */
	      if (s.match_length >= MIN_MATCH$1) {
	        //check_match(s, s.strstart, s.strstart - 1, s.match_length);
	
	        /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/
	        bflush = _tr_tally(s, 1, s.match_length - MIN_MATCH$1);
	
	        s.lookahead -= s.match_length;
	        s.strstart += s.match_length;
	        s.match_length = 0;
	      } else {
	        /* No match, output a literal byte */
	        //Tracevv((stderr,"%c", s->window[s->strstart]));
	        /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
	        bflush = _tr_tally(s, 0, s.window[s.strstart]);
	
	        s.lookahead--;
	        s.strstart++;
	      }
	      if (bflush) {
	        /*** FLUSH_BLOCK(s, 0); ***/
	        flush_block_only(s, false);
	        if (s.strm.avail_out === 0) {
	          return BS_NEED_MORE;
	        }
	        /***/
	      }
	    }
	    s.insert = 0;
	    if (flush === Z_FINISH) {
	      /*** FLUSH_BLOCK(s, 1); ***/
	      flush_block_only(s, true);
	      if (s.strm.avail_out === 0) {
	        return BS_FINISH_STARTED;
	      }
	      /***/
	      return BS_FINISH_DONE;
	    }
	    if (s.last_lit) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	    return BS_BLOCK_DONE;
	  }
	
	  /* ===========================================================================
	   * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
	   * (It will be regenerated if this run of deflate switches away from Huffman.)
	   */
	  function deflate_huff(s, flush) {
	    var bflush;             /* set if current block must be flushed */
	
	    for (;;) {
	      /* Make sure that we have a literal to write. */
	      if (s.lookahead === 0) {
	        fill_window(s);
	        if (s.lookahead === 0) {
	          if (flush === Z_NO_FLUSH) {
	            return BS_NEED_MORE;
	          }
	          break;      /* flush the current block */
	        }
	      }
	
	      /* Output a literal byte */
	      s.match_length = 0;
	      //Tracevv((stderr,"%c", s->window[s->strstart]));
	      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
	      bflush = _tr_tally(s, 0, s.window[s.strstart]);
	      s.lookahead--;
	      s.strstart++;
	      if (bflush) {
	        /*** FLUSH_BLOCK(s, 0); ***/
	        flush_block_only(s, false);
	        if (s.strm.avail_out === 0) {
	          return BS_NEED_MORE;
	        }
	        /***/
	      }
	    }
	    s.insert = 0;
	    if (flush === Z_FINISH) {
	      /*** FLUSH_BLOCK(s, 1); ***/
	      flush_block_only(s, true);
	      if (s.strm.avail_out === 0) {
	        return BS_FINISH_STARTED;
	      }
	      /***/
	      return BS_FINISH_DONE;
	    }
	    if (s.last_lit) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	    return BS_BLOCK_DONE;
	  }
	
	  /* Values for max_lazy_match, good_match and max_chain_length, depending on
	   * the desired pack level (0..9). The values given below have been tuned to
	   * exclude worst case performance for pathological files. Better values may be
	   * found for specific files.
	   */
	  function Config(good_length, max_lazy, nice_length, max_chain, func) {
	    this.good_length = good_length;
	    this.max_lazy = max_lazy;
	    this.nice_length = nice_length;
	    this.max_chain = max_chain;
	    this.func = func;
	  }
	
	  var configurationTable = function() {
	    var table = [
	      /*      good lazy nice chain */
	      new Config(0, 0, 0, 0, deflate_stored),          /* 0 store only */
	      new Config(4, 4, 8, 4, deflate_fast),            /* 1 max speed, no lazy matches */
	      new Config(4, 5, 16, 8, deflate_fast),           /* 2 */
	      new Config(4, 6, 32, 32, deflate_fast),          /* 3 */
	    
	      new Config(4, 4, 16, 16, deflate_slow),          /* 4 lazy matches */
	      new Config(8, 16, 32, 32, deflate_slow),         /* 5 */
	      new Config(8, 16, 128, 128, deflate_slow),       /* 6 */
	      new Config(8, 32, 128, 256, deflate_slow),       /* 7 */
	      new Config(32, 128, 258, 1024, deflate_slow),    /* 8 */
	      new Config(32, 258, 258, 4096, deflate_slow)     /* 9 max compression */
	    ];
	
	    configurationTable = function () { return table; };
	    return table;
	  };
	
	  /* ===========================================================================
	   * Initialize the "longest match" routines for a new zlib stream
	   */
	  function lm_init(s) {
	    s.window_size = 2 * s.w_size;
	
	    /*** CLEAR_HASH(s); ***/
	    zero$1(s.head); // Fill with NIL (= 0);
	
	    var table = configurationTable();
	    /* Set the default configuration parameters:
	     */
	    s.max_lazy_match = table[s.level].max_lazy;
	    s.good_match = table[s.level].good_length;
	    s.nice_match = table[s.level].nice_length;
	    s.max_chain_length = table[s.level].max_chain;
	
	    s.strstart = 0;
	    s.block_start = 0;
	    s.lookahead = 0;
	    s.insert = 0;
	    s.match_length = s.prev_length = MIN_MATCH$1 - 1;
	    s.match_available = 0;
	    s.ins_h = 0;
	  }
	
	
	  function DeflateState() {
	    this.strm = null;            /* pointer back to this zlib stream */
	    this.status = 0;            /* as the name implies */
	    this.pending_buf = null;      /* output still pending */
	    this.pending_buf_size = 0;  /* size of pending_buf */
	    this.pending_out = 0;       /* next pending byte to output to the stream */
	    this.pending = 0;           /* nb of bytes in the pending buffer */
	    this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip */
	    this.gzhead = null;         /* gzip header information to write */
	    this.gzindex = 0;           /* where in extra, name, or comment */
	    this.method = Z_DEFLATED; /* can only be DEFLATED */
	    this.last_flush = -1;   /* value of flush param for previous deflate call */
	
	    this.w_size = 0;  /* LZ77 window size (32K by default) */
	    this.w_bits = 0;  /* log2(w_size)  (8..16) */
	    this.w_mask = 0;  /* w_size - 1 */
	
	    this.window = null;
	    /* Sliding window. Input bytes are read into the second half of the window,
	     * and move to the first half later to keep a dictionary of at least wSize
	     * bytes. With this organization, matches are limited to a distance of
	     * wSize-MAX_MATCH bytes, but this ensures that IO is always
	     * performed with a length multiple of the block size.
	     */
	
	    this.window_size = 0;
	    /* Actual size of window: 2*wSize, except when the user input buffer
	     * is directly used as sliding window.
	     */
	
	    this.prev = null;
	    /* Link to older string with same hash index. To limit the size of this
	     * array to 64K, this link is maintained only for the last 32K strings.
	     * An index in this array is thus a window index modulo 32K.
	     */
	
	    this.head = null;   /* Heads of the hash chains or NIL. */
	
	    this.ins_h = 0;       /* hash index of string to be inserted */
	    this.hash_size = 0;   /* number of elements in hash table */
	    this.hash_bits = 0;   /* log2(hash_size) */
	    this.hash_mask = 0;   /* hash_size-1 */
	
	    this.hash_shift = 0;
	    /* Number of bits by which ins_h must be shifted at each input
	     * step. It must be such that after MIN_MATCH steps, the oldest
	     * byte no longer takes part in the hash key, that is:
	     *   hash_shift * MIN_MATCH >= hash_bits
	     */
	
	    this.block_start = 0;
	    /* Window position at the beginning of the current output block. Gets
	     * negative when the window is moved backwards.
	     */
	
	    this.match_length = 0;      /* length of best match */
	    this.prev_match = 0;        /* previous match */
	    this.match_available = 0;   /* set if previous match exists */
	    this.strstart = 0;          /* start of string to insert */
	    this.match_start = 0;       /* start of matching string */
	    this.lookahead = 0;         /* number of valid bytes ahead in window */
	
	    this.prev_length = 0;
	    /* Length of the best match at previous step. Matches not greater than this
	     * are discarded. This is used in the lazy match evaluation.
	     */
	
	    this.max_chain_length = 0;
	    /* To speed up deflation, hash chains are never searched beyond this
	     * length.  A higher limit improves compression ratio but degrades the
	     * speed.
	     */
	
	    this.max_lazy_match = 0;
	    /* Attempt to find a better match only when the current match is strictly
	     * smaller than this value. This mechanism is used only for compression
	     * levels >= 4.
	     */
	    // That's alias to max_lazy_match, don't use directly
	    //this.max_insert_length = 0;
	    /* Insert new strings in the hash table only if the match length is not
	     * greater than this length. This saves time but degrades compression.
	     * max_insert_length is used only for compression levels <= 3.
	     */
	
	    this.level = 0;     /* compression level (1..9) */
	    this.strategy = 0;  /* favor or force Huffman coding*/
	
	    this.good_match = 0;
	    /* Use a faster search when the previous match is longer than this */
	
	    this.nice_match = 0; /* Stop searching when current match exceeds this */
	
	                /* used by trees.c: */
	
	    /* Didn't use ct_data typedef below to suppress compiler warning */
	
	    // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
	    // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
	    // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */
	
	    // Use flat array of DOUBLE size, with interleaved fata,
	    // because JS does not support effective
	    this.dyn_ltree  = Buf16(HEAP_SIZE$1 * 2);
	    this.dyn_dtree  = Buf16((2 * D_CODES$1 + 1) * 2);
	    this.bl_tree    = Buf16((2 * BL_CODES$1 + 1) * 2);
	    zero$1(this.dyn_ltree);
	    zero$1(this.dyn_dtree);
	    zero$1(this.bl_tree);
	
	    this.l_desc   = null;         /* desc. for literal tree */
	    this.d_desc   = null;         /* desc. for distance tree */
	    this.bl_desc  = null;         /* desc. for bit length tree */
	
	    //ush bl_count[MAX_BITS+1];
	    this.bl_count = Buf16(MAX_BITS$1 + 1);
	    /* number of codes at each bit length for an optimal tree */
	
	    //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
	    this.heap = Buf16(2 * L_CODES$1 + 1);  /* heap used to build the Huffman trees */
	    zero$1(this.heap);
	
	    this.heap_len = 0;               /* number of elements in the heap */
	    this.heap_max = 0;               /* element of largest frequency */
	    /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
	     * The same heap array is used to build all trees.
	     */
	
	    this.depth = Buf16(2 * L_CODES$1 + 1); //uch depth[2*L_CODES+1];
	    zero$1(this.depth);
	    /* Depth of each subtree used as tie breaker for trees of equal frequency
	     */
	
	    this.l_buf = 0;          /* buffer index for literals or lengths */
	
	    this.lit_bufsize = 0;
	    /* Size of match buffer for literals/lengths.  There are 4 reasons for
	     * limiting lit_bufsize to 64K:
	     *   - frequencies can be kept in 16 bit counters
	     *   - if compression is not successful for the first block, all input
	     *     data is still in the window so we can still emit a stored block even
	     *     when input comes from standard input.  (This can also be done for
	     *     all blocks if lit_bufsize is not greater than 32K.)
	     *   - if compression is not successful for a file smaller than 64K, we can
	     *     even emit a stored file instead of a stored block (saving 5 bytes).
	     *     This is applicable only for zip (not gzip or zlib).
	     *   - creating new Huffman trees less frequently may not provide fast
	     *     adaptation to changes in the input data statistics. (Take for
	     *     example a binary file with poorly compressible code followed by
	     *     a highly compressible string table.) Smaller buffer sizes give
	     *     fast adaptation but have of course the overhead of transmitting
	     *     trees more frequently.
	     *   - I can't count above 4
	     */
	
	    this.last_lit = 0;      /* running index in l_buf */
	
	    this.d_buf = 0;
	    /* Buffer index for distances. To simplify the code, d_buf and l_buf have
	     * the same number of elements. To use different lengths, an extra flag
	     * array would be necessary.
	     */
	
	    this.opt_len = 0;       /* bit length of current block with optimal trees */
	    this.static_len = 0;    /* bit length of current block with static trees */
	    this.matches = 0;       /* number of string matches in current block */
	    this.insert = 0;        /* bytes at end of window left to insert */
	
	
	    this.bi_buf = 0;
	    /* Output buffer. bits are inserted starting at the bottom (least
	     * significant bits).
	     */
	    this.bi_valid = 0;
	    /* Number of valid bits in bi_buf.  All bits above the last valid bit
	     * are always zero.
	     */
	
	    // Used for window memory init. We safely ignore it for JS. That makes
	    // sense only for pointers and memory check tools.
	    //this.high_water = 0;
	    /* High water mark offset in window for initialized bytes -- bytes above
	     * this are set to zero in order to avoid memory check warnings when
	     * longest match routines access bytes past the input.  This is then
	     * updated to the new high water mark.
	     */
	  }
	
	
	  function deflateResetKeep(strm) {
	    var s;
	
	    if (!strm || !strm.state) {
	      return err(strm, Z_STREAM_ERROR);
	    }
	
	    strm.total_in = strm.total_out = 0;
	    strm.data_type = Z_UNKNOWN;
	
	    s = strm.state;
	    s.pending = 0;
	    s.pending_out = 0;
	
	    if (s.wrap < 0) {
	      s.wrap = -s.wrap;
	      /* was made negative by deflate(..., Z_FINISH); */
	    }
	    s.status = (s.wrap ? INIT_STATE : BUSY_STATE);
	    strm.adler = (s.wrap === 2) ?
	      0  // crc32(0, Z_NULL, 0)
	    :
	      1; // adler32(0, Z_NULL, 0)
	    s.last_flush = Z_NO_FLUSH;
	    _tr_init(s);
	    return Z_OK;
	  }
	
	
	  function deflateReset(strm) {
	    var ret = deflateResetKeep(strm);
	    if (ret === Z_OK) {
	      lm_init(strm.state);
	    }
	    return ret;
	  }
	
	
	  function deflateSetHeader(strm, head) {
	    if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	    if (strm.state.wrap !== 2) { return Z_STREAM_ERROR; }
	    strm.state.gzhead = head;
	    return Z_OK;
	  }
	
	
	  function deflateInit2(strm, level, method, windowBits, memLevel, strategy) {
	    if (!strm) { // === Z_NULL
	      return Z_STREAM_ERROR;
	    }
	    var wrap = 1;
	
	    if (level === Z_DEFAULT_COMPRESSION) {
	      level = 6;
	    }
	
	    if (windowBits < 0) { /* suppress zlib wrapper */
	      wrap = 0;
	      windowBits = -windowBits;
	    }
	
	    else if (windowBits > 15) {
	      wrap = 2;           /* write gzip wrapper instead */
	      windowBits -= 16;
	    }
	
	
	    if (memLevel < 1 || memLevel > MAX_MEM_LEVEL || method !== Z_DEFLATED ||
	      windowBits < 8 || windowBits > 15 || level < 0 || level > 9 ||
	      strategy < 0 || strategy > Z_FIXED) {
	      return err(strm, Z_STREAM_ERROR);
	    }
	
	
	    if (windowBits === 8) {
	      windowBits = 9;
	    }
	    /* until 256-byte window bug fixed */
	
	    var s = new DeflateState();
	
	    strm.state = s;
	    s.strm = strm;
	
	    s.wrap = wrap;
	    s.gzhead = null;
	    s.w_bits = windowBits;
	    s.w_size = 1 << s.w_bits;
	    s.w_mask = s.w_size - 1;
	
	    s.hash_bits = memLevel + 7;
	    s.hash_size = 1 << s.hash_bits;
	    s.hash_mask = s.hash_size - 1;
	    s.hash_shift = ~~((s.hash_bits + MIN_MATCH$1 - 1) / MIN_MATCH$1);
	
	    s.window = Buf8(s.w_size * 2);
	    s.head = Buf16(s.hash_size);
	    s.prev = Buf16(s.w_size);
	
	    // Don't need mem init magic for JS.
	    //s.high_water = 0;  /* nothing written to s->window yet */
	
	    s.lit_bufsize = 1 << (memLevel + 6); /* 16K elements by default */
	
	    s.pending_buf_size = s.lit_bufsize * 4;
	
	    //overlay = (ushf *) ZALLOC(strm, s->lit_bufsize, sizeof(ush)+2);
	    //s->pending_buf = (uchf *) overlay;
	    s.pending_buf = Buf8(s.pending_buf_size);
	
	    // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
	    //s->d_buf = overlay + s->lit_bufsize/sizeof(ush);
	    s.d_buf = 1 * s.lit_bufsize;
	
	    //s->l_buf = s->pending_buf + (1+sizeof(ush))*s->lit_bufsize;
	    s.l_buf = (1 + 2) * s.lit_bufsize;
	
	    s.level = level;
	    s.strategy = strategy;
	    s.method = method;
	
	    return deflateReset(strm);
	  }
	
	
	  function deflate(strm, flush) {
	    var old_flush, s;
	    var beg, val; // for gzip header write only
	
	    if (!strm || !strm.state ||
	      flush > Z_BLOCK || flush < 0) {
	      return strm ? err(strm, Z_STREAM_ERROR) : Z_STREAM_ERROR;
	    }
	
	    s = strm.state;
	
	    if (!strm.output ||
	        (!strm.input && strm.avail_in !== 0) ||
	        (s.status === FINISH_STATE && flush !== Z_FINISH)) {
	      return err(strm, (strm.avail_out === 0) ? Z_BUF_ERROR : Z_STREAM_ERROR);
	    }
	
	    s.strm = strm; /* just in case */
	    old_flush = s.last_flush;
	    s.last_flush = flush;
	
	    /* Write the header */
	    if (s.status === INIT_STATE) {
	
	      if (s.wrap === 2) { // GZIP header
	        strm.adler = 0;  //crc32(0L, Z_NULL, 0);
	        put_byte(s, 31);
	        put_byte(s, 139);
	        put_byte(s, 8);
	        if (!s.gzhead) { // s->gzhead == Z_NULL
	          put_byte(s, 0);
	          put_byte(s, 0);
	          put_byte(s, 0);
	          put_byte(s, 0);
	          put_byte(s, 0);
	          put_byte(s, s.level === 9 ? 2 :
	                      (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
	                       4 : 0));
	          put_byte(s, OS_CODE);
	          s.status = BUSY_STATE;
	        }
	        else {
	          put_byte(s, (s.gzhead.text ? 1 : 0) +
	                      (s.gzhead.hcrc ? 2 : 0) +
	                      (!s.gzhead.extra ? 0 : 4) +
	                      (!s.gzhead.name ? 0 : 8) +
	                      (!s.gzhead.comment ? 0 : 16)
	          );
	          put_byte(s, s.gzhead.time & 0xff);
	          put_byte(s, (s.gzhead.time >> 8) & 0xff);
	          put_byte(s, (s.gzhead.time >> 16) & 0xff);
	          put_byte(s, (s.gzhead.time >> 24) & 0xff);
	          put_byte(s, s.level === 9 ? 2 :
	                      (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
	                       4 : 0));
	          put_byte(s, s.gzhead.os & 0xff);
	          if (s.gzhead.extra && s.gzhead.extra.length) {
	            put_byte(s, s.gzhead.extra.length & 0xff);
	            put_byte(s, (s.gzhead.extra.length >> 8) & 0xff);
	          }
	          if (s.gzhead.hcrc) {
	            strm.adler = crc32(strm.adler, s.pending_buf, s.pending, 0);
	          }
	          s.gzindex = 0;
	          s.status = EXTRA_STATE;
	        }
	      }
	      else // DEFLATE header
	      {
	        var header = (Z_DEFLATED + ((s.w_bits - 8) << 4)) << 8;
	        var level_flags = -1;
	
	        if (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2) {
	          level_flags = 0;
	        } else if (s.level < 6) {
	          level_flags = 1;
	        } else if (s.level === 6) {
	          level_flags = 2;
	        } else {
	          level_flags = 3;
	        }
	        header |= (level_flags << 6);
	        if (s.strstart !== 0) { header |= PRESET_DICT; }
	        header += 31 - (header % 31);
	
	        s.status = BUSY_STATE;
	        putShortMSB(s, header);
	
	        /* Save the adler32 of the preset dictionary: */
	        if (s.strstart !== 0) {
	          putShortMSB(s, strm.adler >>> 16);
	          putShortMSB(s, strm.adler & 0xffff);
	        }
	        strm.adler = 1; // adler32(0L, Z_NULL, 0);
	      }
	    }
	
	  //#ifdef GZIP
	    if (s.status === EXTRA_STATE) {
	      if (s.gzhead.extra/* != Z_NULL*/) {
	        beg = s.pending;  /* start of bytes to update crc */
	
	        while (s.gzindex < (s.gzhead.extra.length & 0xffff)) {
	          if (s.pending === s.pending_buf_size) {
	            if (s.gzhead.hcrc && s.pending > beg) {
	              strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	            }
	            flush_pending(strm);
	            beg = s.pending;
	            if (s.pending === s.pending_buf_size) {
	              break;
	            }
	          }
	          put_byte(s, s.gzhead.extra[s.gzindex] & 0xff);
	          s.gzindex++;
	        }
	        if (s.gzhead.hcrc && s.pending > beg) {
	          strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	        }
	        if (s.gzindex === s.gzhead.extra.length) {
	          s.gzindex = 0;
	          s.status = NAME_STATE;
	        }
	      }
	      else {
	        s.status = NAME_STATE;
	      }
	    }
	    if (s.status === NAME_STATE) {
	      if (s.gzhead.name/* != Z_NULL*/) {
	        beg = s.pending;  /* start of bytes to update crc */
	        //int val;
	
	        do {
	          if (s.pending === s.pending_buf_size) {
	            if (s.gzhead.hcrc && s.pending > beg) {
	              strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	            }
	            flush_pending(strm);
	            beg = s.pending;
	            if (s.pending === s.pending_buf_size) {
	              val = 1;
	              break;
	            }
	          }
	          // JS specific: little magic to add zero terminator to end of string
	          if (s.gzindex < s.gzhead.name.length) {
	            val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
	          } else {
	            val = 0;
	          }
	          put_byte(s, val);
	        } while (val !== 0);
	
	        if (s.gzhead.hcrc && s.pending > beg) {
	          strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	        }
	        if (val === 0) {
	          s.gzindex = 0;
	          s.status = COMMENT_STATE;
	        }
	      }
	      else {
	        s.status = COMMENT_STATE;
	      }
	    }
	    if (s.status === COMMENT_STATE) {
	      if (s.gzhead.comment/* != Z_NULL*/) {
	        beg = s.pending;  /* start of bytes to update crc */
	        //int val;
	
	        do {
	          if (s.pending === s.pending_buf_size) {
	            if (s.gzhead.hcrc && s.pending > beg) {
	              strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	            }
	            flush_pending(strm);
	            beg = s.pending;
	            if (s.pending === s.pending_buf_size) {
	              val = 1;
	              break;
	            }
	          }
	          // JS specific: little magic to add zero terminator to end of string
	          if (s.gzindex < s.gzhead.comment.length) {
	            val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
	          } else {
	            val = 0;
	          }
	          put_byte(s, val);
	        } while (val !== 0);
	
	        if (s.gzhead.hcrc && s.pending > beg) {
	          strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	        }
	        if (val === 0) {
	          s.status = HCRC_STATE;
	        }
	      }
	      else {
	        s.status = HCRC_STATE;
	      }
	    }
	    if (s.status === HCRC_STATE) {
	      if (s.gzhead.hcrc) {
	        if (s.pending + 2 > s.pending_buf_size) {
	          flush_pending(strm);
	        }
	        if (s.pending + 2 <= s.pending_buf_size) {
	          put_byte(s, strm.adler & 0xff);
	          put_byte(s, (strm.adler >> 8) & 0xff);
	          strm.adler = 0; //crc32(0L, Z_NULL, 0);
	          s.status = BUSY_STATE;
	        }
	      }
	      else {
	        s.status = BUSY_STATE;
	      }
	    }
	  //#endif
	
	    /* Flush as much pending output as possible */
	    if (s.pending !== 0) {
	      flush_pending(strm);
	      if (strm.avail_out === 0) {
	        /* Since avail_out is 0, deflate will be called again with
	         * more output space, but possibly with both pending and
	         * avail_in equal to zero. There won't be anything to do,
	         * but this is not an error situation so make sure we
	         * return OK instead of BUF_ERROR at next call of deflate:
	         */
	        s.last_flush = -1;
	        return Z_OK;
	      }
	
	      /* Make sure there is something to do and avoid duplicate consecutive
	       * flushes. For repeated and useless calls with Z_FINISH, we keep
	       * returning Z_STREAM_END instead of Z_BUF_ERROR.
	       */
	    } else if (strm.avail_in === 0 && rank(flush) <= rank(old_flush) &&
	      flush !== Z_FINISH) {
	      return err(strm, Z_BUF_ERROR);
	    }
	
	    /* User must not provide more input after the first FINISH: */
	    if (s.status === FINISH_STATE && strm.avail_in !== 0) {
	      return err(strm, Z_BUF_ERROR);
	    }
	
	    /* Start a new block or continue the current one.
	     */
	    if (strm.avail_in !== 0 || s.lookahead !== 0 ||
	      (flush !== Z_NO_FLUSH && s.status !== FINISH_STATE)) {
	      var bstate = (s.strategy === Z_HUFFMAN_ONLY) ? deflate_huff(s, flush) :
	        (s.strategy === Z_RLE ? deflate_rle(s, flush) :
	          configurationTable()[s.level].func(s, flush));
	
	      if (bstate === BS_FINISH_STARTED || bstate === BS_FINISH_DONE) {
	        s.status = FINISH_STATE;
	      }
	      if (bstate === BS_NEED_MORE || bstate === BS_FINISH_STARTED) {
	        if (strm.avail_out === 0) {
	          s.last_flush = -1;
	          /* avoid BUF_ERROR next call, see above */
	        }
	        return Z_OK;
	        /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
	         * of deflate should use the same flush parameter to make sure
	         * that the flush is complete. So we don't have to output an
	         * empty block here, this will be done at next call. This also
	         * ensures that for a very small output buffer, we emit at most
	         * one empty block.
	         */
	      }
	      if (bstate === BS_BLOCK_DONE) {
	        if (flush === Z_PARTIAL_FLUSH) {
	          _tr_align(s);
	        }
	        else if (flush !== Z_BLOCK) { /* FULL_FLUSH or SYNC_FLUSH */
	
	          _tr_stored_block(s, 0, 0, false);
	          /* For a full flush, this empty block will be recognized
	           * as a special marker by inflate_sync().
	           */
	          if (flush === Z_FULL_FLUSH) {
	            /*** CLEAR_HASH(s); ***/             /* forget history */
	            zero$1(s.head); // Fill with NIL (= 0);
	
	            if (s.lookahead === 0) {
	              s.strstart = 0;
	              s.block_start = 0;
	              s.insert = 0;
	            }
	          }
	        }
	        flush_pending(strm);
	        if (strm.avail_out === 0) {
	          s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */
	          return Z_OK;
	        }
	      }
	    }
	    //Assert(strm->avail_out > 0, "bug2");
	    //if (strm.avail_out <= 0) { throw new Error("bug2");}
	
	    if (flush !== Z_FINISH) { return Z_OK; }
	    if (s.wrap <= 0) { return Z_STREAM_END; }
	
	    /* Write the trailer */
	    if (s.wrap === 2) {
	      put_byte(s, strm.adler & 0xff);
	      put_byte(s, (strm.adler >> 8) & 0xff);
	      put_byte(s, (strm.adler >> 16) & 0xff);
	      put_byte(s, (strm.adler >> 24) & 0xff);
	      put_byte(s, strm.total_in & 0xff);
	      put_byte(s, (strm.total_in >> 8) & 0xff);
	      put_byte(s, (strm.total_in >> 16) & 0xff);
	      put_byte(s, (strm.total_in >> 24) & 0xff);
	    }
	    else
	    {
	      putShortMSB(s, strm.adler >>> 16);
	      putShortMSB(s, strm.adler & 0xffff);
	    }
	
	    flush_pending(strm);
	    /* If avail_out is zero, the application will call deflate again
	     * to flush the rest.
	     */
	    if (s.wrap > 0) { s.wrap = -s.wrap; }
	    /* write the trailer only once! */
	    return s.pending !== 0 ? Z_OK : Z_STREAM_END;
	  }
	
	  function deflateEnd(strm) {
	    var status;
	
	    if (!strm/*== Z_NULL*/ || !strm.state/*== Z_NULL*/) {
	      return Z_STREAM_ERROR;
	    }
	
	    status = strm.state.status;
	    if (status !== INIT_STATE &&
	      status !== EXTRA_STATE &&
	      status !== NAME_STATE &&
	      status !== COMMENT_STATE &&
	      status !== HCRC_STATE &&
	      status !== BUSY_STATE &&
	      status !== FINISH_STATE
	    ) {
	      return err(strm, Z_STREAM_ERROR);
	    }
	
	    strm.state = null;
	
	    return status === BUSY_STATE ? err(strm, Z_DATA_ERROR) : Z_OK;
	  }
	
	
	  /* =========================================================================
	   * Initializes the compression dictionary from the given byte
	   * sequence without producing any compressed output.
	   */
	  function deflateSetDictionary(strm, dictionary) {
	    var dictLength = dictionary.length;
	
	    var s;
	    var str, n;
	    var wrap;
	    var avail;
	    var next;
	    var input;
	    var tmpDict;
	
	    if (!strm/*== Z_NULL*/ || !strm.state/*== Z_NULL*/) {
	      return Z_STREAM_ERROR;
	    }
	
	    s = strm.state;
	    wrap = s.wrap;
	
	    if (wrap === 2 || (wrap === 1 && s.status !== INIT_STATE) || s.lookahead) {
	      return Z_STREAM_ERROR;
	    }
	
	    /* when using zlib wrappers, compute Adler-32 for provided dictionary */
	    if (wrap === 1) {
	      /* adler32(strm->adler, dictionary, dictLength); */
	      strm.adler = adler32(strm.adler, dictionary, dictLength, 0);
	    }
	
	    s.wrap = 0;   /* avoid computing Adler-32 in read_buf */
	
	    /* if dictionary would fill window, just replace the history */
	    if (dictLength >= s.w_size) {
	      if (wrap === 0) {            /* already empty otherwise */
	        /*** CLEAR_HASH(s); ***/
	        zero$1(s.head); // Fill with NIL (= 0);
	        s.strstart = 0;
	        s.block_start = 0;
	        s.insert = 0;
	      }
	      /* use the tail */
	      // dictionary = dictionary.slice(dictLength - s.w_size);
	      tmpDict = Buf8(s.w_size);
	      arraySet(tmpDict, dictionary, dictLength - s.w_size, s.w_size, 0);
	      dictionary = tmpDict;
	      dictLength = s.w_size;
	    }
	    /* insert dictionary into window and hash */
	    avail = strm.avail_in;
	    next = strm.next_in;
	    input = strm.input;
	    strm.avail_in = dictLength;
	    strm.next_in = 0;
	    strm.input = dictionary;
	    fill_window(s);
	    while (s.lookahead >= MIN_MATCH$1) {
	      str = s.strstart;
	      n = s.lookahead - (MIN_MATCH$1 - 1);
	      do {
	        /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
	        s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + MIN_MATCH$1 - 1]) & s.hash_mask;
	
	        s.prev[str & s.w_mask] = s.head[s.ins_h];
	
	        s.head[s.ins_h] = str;
	        str++;
	      } while (--n);
	      s.strstart = str;
	      s.lookahead = MIN_MATCH$1 - 1;
	      fill_window(s);
	    }
	    s.strstart += s.lookahead;
	    s.block_start = s.strstart;
	    s.insert = s.lookahead;
	    s.lookahead = 0;
	    s.match_length = s.prev_length = MIN_MATCH$1 - 1;
	    s.match_available = 0;
	    strm.next_in = next;
	    strm.input = input;
	    strm.avail_in = avail;
	    s.wrap = wrap;
	    return Z_OK;
	  }
	
	  /* Not implemented
	  exports.deflateBound = deflateBound;
	  exports.deflateCopy = deflateCopy;
	  exports.deflateParams = deflateParams;
	  exports.deflatePending = deflatePending;
	  exports.deflatePrime = deflatePrime;
	  exports.deflateTune = deflateTune;
	  */
	
	  /* eslint-disable */
	
	  var toString$1 = Object.prototype.toString;
	
	  /**
	   * class Deflate
	   *
	   * Generic JS-style wrapper for zlib calls. If you don't need
	   * streaming behaviour - use more simple functions: [[deflate]],
	   * [[deflateRaw]] and [[gzip]].
	   **/
	
	  /* internal
	   * Deflate.chunks -> Array
	   *
	   * Chunks of output data, if [[Deflate#onData]] not overridden.
	   **/
	
	  /**
	   * Deflate.result -> Uint8Array|Array
	   *
	   * Compressed result, generated by default [[Deflate#onData]]
	   * and [[Deflate#onEnd]] handlers. Filled after you push last chunk
	   * (call [[Deflate#push]] with `Z_FINISH` / `true` param)  or if you
	   * push a chunk with explicit flush (call [[Deflate#push]] with
	   * `Z_SYNC_FLUSH` param).
	   **/
	
	  /**
	   * Deflate.err -> Number
	   *
	   * Error code after deflate finished. 0 (Z_OK) on success.
	   * You will not need it in real life, because deflate errors
	   * are possible only on wrong options or bad `onData` / `onEnd`
	   * custom handlers.
	   **/
	
	  /**
	   * Deflate.msg -> String
	   *
	   * Error message, if [[Deflate.err]] != 0
	   **/
	
	  /**
	   * new Deflate(options)
	   * - options (Object): zlib deflate options.
	   *
	   * Creates new deflator instance with specified params. Throws exception
	   * on bad params. Supported options:
	   *
	   * - `level`
	   * - `windowBits`
	   * - `memLevel`
	   * - `strategy`
	   * - `dictionary`
	   *
	   * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
	   * for more information on these.
	   *
	   * Additional options, for internal needs:
	   *
	   * - `chunkSize` - size of generated data chunks (16K by default)
	   * - `raw` (Boolean) - do raw deflate
	   * - `gzip` (Boolean) - create gzip wrapper
	   * - `to` (String) - if equal to 'string', then result will be "binary string"
	   *    (each char code [0..255])
	   * - `header` (Object) - custom header for gzip
	   *   - `text` (Boolean) - true if compressed data believed to be text
	   *   - `time` (Number) - modification time, unix timestamp
	   *   - `os` (Number) - operation system code
	   *   - `extra` (Array) - array of bytes with extra data (max 65536)
	   *   - `name` (String) - file name (binary string)
	   *   - `comment` (String) - comment (binary string)
	   *   - `hcrc` (Boolean) - true if header crc should be added
	   *
	   * ##### Example:
	   *
	   * ```javascript
	   * var pako = require('pako')
	   *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
	   *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
	   *
	   * var deflate = new pako.Deflate({ level: 3});
	   *
	   * deflate.push(chunk1, false);
	   * deflate.push(chunk2, true);  // true -> last chunk
	   *
	   * if (deflate.err) { throw new Error(deflate.err); }
	   *
	   * console.log(deflate.result);
	   * ```
	   **/
	  var Deflate = function Deflate(options) {
	    this.options = assign({
	      level: Z_DEFAULT_COMPRESSION,
	      method: Z_DEFLATED,
	      chunkSize: 16384,
	      windowBits: 15,
	      memLevel: 8,
	      strategy: Z_DEFAULT_STRATEGY,
	      to: ''
	    }, options || {});
	
	    var opt = this.options;
	
	    if (opt.raw && (opt.windowBits > 0)) {
	      opt.windowBits = -opt.windowBits;
	    }
	
	    else if (opt.gzip && (opt.windowBits > 0) && (opt.windowBits < 16)) {
	      opt.windowBits += 16;
	    }
	
	    this.err  = 0;    // error code, if happens (0 = Z_OK)
	    this.msg  = '';   // error message
	    this.ended= false;// used to avoid multiple onEnd() calls
	    this.chunks = [];   // chunks of compressed data
	
	    this.strm = new ZStream();
	    this.strm.avail_out = 0;
	
	    var status = deflateInit2(
	      this.strm,
	      opt.level,
	      opt.method,
	      opt.windowBits,
	      opt.memLevel,
	      opt.strategy
	    );
	
	    if (status !== Z_OK) {
	      throw new Error(msg[status]);
	    }
	
	    if (opt.header) {
	      deflateSetHeader(this.strm, opt.header);
	    }
	
	    if (opt.dictionary) {
	      var dict;
	      // Convert data if needed
	      if (typeof opt.dictionary === 'string') {
	        // If we need to compress text, change encoding to utf8.
	        dict = string2buf(opt.dictionary);
	      } else if (toString$1.call(opt.dictionary) === '[object ArrayBuffer]') {
	        dict = new Uint8Array(opt.dictionary);
	      } else {
	        dict = opt.dictionary;
	      }
	
	      status = deflateSetDictionary(this.strm, dict);
	
	      if (status !== Z_OK) {
	        throw new Error(msg[status]);
	      }
	
	      this._dict_set = true;
	    }
	  };
	
	  /**
	   * Deflate#push(data[, mode]) -> Boolean
	   * - data (Uint8Array|Array|ArrayBuffer|String): input data. Strings will be
	   * converted to utf8 byte sequence.
	   * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
	   * See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
	   *
	   * Sends input data to deflate pipe, generating [[Deflate#onData]] calls with
	   * new compressed chunks. Returns `true` on success. The last data block must have
	   * mode Z_FINISH (or `true`). That will flush internal pending buffers and call
	   * [[Deflate#onEnd]]. For interim explicit flushes (without ending the stream) you
	   * can use mode Z_SYNC_FLUSH, keeping the compression context.
	   *
	   * On fail call [[Deflate#onEnd]] with error code and return false.
	   *
	   * We strongly recommend to use `Uint8Array` on input for best speed (output
	   * array format is detected automatically). Also, don't skip last param and always
	   * use the same type in your code (boolean or number). That will improve JS speed.
	   *
	   * For regular `Array`-s make sure all elements are [0..255].
	   *
	   * ##### Example
	   *
	   * ```javascript
	   * push(chunk, false); // push one of data chunks
	   * ...
	   * push(chunk, true);// push last chunk
	   * ```
	   **/
	  Deflate.prototype.push = function push (data, mode) {
	    var strm = this.strm;
	    var chunkSize = this.options.chunkSize;
	    var status, _mode;
	
	    if (this.ended) { return false; }
	
	    _mode = (mode === ~~mode) ? mode : ((mode === true) ? Z_FINISH : Z_NO_FLUSH);
	
	    // Convert data if needed
	    if (typeof data === 'string') {
	      // If we need to compress text, change encoding to utf8.
	      strm.input = string2buf(data);
	    } else if (toString$1.call(data) === '[object ArrayBuffer]') {
	      strm.input = new Uint8Array(data);
	    } else {
	      strm.input = data;
	    }
	
	    strm.next_in = 0;
	    strm.avail_in = strm.input.length;
	
	    do {
	      if (strm.avail_out === 0) {
	        strm.output = Buf8(chunkSize);
	        strm.next_out = 0;
	        strm.avail_out = chunkSize;
	      }
	      status = deflate(strm, _mode);  /* no bad return value */
	
	      if (status !== Z_STREAM_END && status !== Z_OK) {
	        this.onEnd(status);
	        this.ended = true;
	        return false;
	      }
	      if (strm.avail_out === 0 || (strm.avail_in === 0 && (_mode === Z_FINISH || _mode === Z_SYNC_FLUSH))) {
	        if (this.options.to === 'string') {
	          this.onData(buf2binstring(shrinkBuf(strm.output, strm.next_out)));
	        } else {
	          this.onData(shrinkBuf(strm.output, strm.next_out));
	        }
	      }
	    } while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== Z_STREAM_END);
	
	    // Finalize on the last chunk.
	    if (_mode === Z_FINISH) {
	      status = deflateEnd(this.strm);
	      this.onEnd(status);
	      this.ended = true;
	      return status === Z_OK;
	    }
	
	    // callback interim results if Z_SYNC_FLUSH.
	    if (_mode === Z_SYNC_FLUSH) {
	      this.onEnd(Z_OK);
	      strm.avail_out = 0;
	      return true;
	    }
	
	    return true;
	  };
	
	
	  /**
	   * Deflate#onData(chunk) -> Void
	   * - chunk (Uint8Array|Array|String): output data. Type of array depends
	   * on js engine support. When string output requested, each chunk
	   * will be string.
	   *
	   * By default, stores data blocks in `chunks[]` property and glue
	   * those in `onEnd`. Override this handler, if you need another behaviour.
	   **/
	  Deflate.prototype.onData = function onData (chunk) {
	    this.chunks.push(chunk);
	  };
	
	
	  /**
	   * Deflate#onEnd(status) -> Void
	   * - status (Number): deflate status. 0 (Z_OK) on success,
	   * other if not.
	   *
	   * Called once after you tell deflate that the input stream is
	   * complete (Z_FINISH) or should be flushed (Z_SYNC_FLUSH)
	   * or if an error happened. By default - join collected chunks,
	   * free memory and fill `results` / `err` properties.
	   **/
	  Deflate.prototype.onEnd = function onEnd (status) {
	    // On success - join
	    if (status === Z_OK) {
	      if (this.options.to === 'string') {
	        this.result = this.chunks.join('');
	      } else {
	        this.result = flattenChunks(this.chunks);
	      }
	    }
	    this.chunks = [];
	    this.err = status;
	    this.msg = this.strm.msg;
	  };
	
	
	  /**
	   * deflate(data[, options]) -> Uint8Array|Array|String
	   * - data (Uint8Array|Array|String): input data to compress.
	   * - options (Object): zlib deflate options.
	   *
	   * Compress `data` with deflate algorithm and `options`.
	   *
	   * Supported options are:
	   *
	   * - level
	   * - windowBits
	   * - memLevel
	   * - strategy
	   * - dictionary
	   *
	   * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
	   * for more information on these.
	   *
	   * Sugar (options):
	   *
	   * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
	   *   negative windowBits implicitly.
	   * - `to` (String) - if equal to 'string', then result will be "binary string"
	   *    (each char code [0..255])
	   *
	   * ##### Example:
	   *
	   * ```javascript
	   * var pako = require('pako')
	   *   , data = Uint8Array([1,2,3,4,5,6,7,8,9]);
	   *
	   * console.log(pako.deflate(data));
	   * ```
	   **/
	  function deflate$1(input, options) {
	    var deflator = new Deflate(options);
	
	    deflator.push(input, true);
	
	    // That will never happens, if you don't cheat with options :)
	    if (deflator.err) { throw deflator.msg || msg[deflator.err]; }
	
	    return deflator.result;
	  }
	
	
	  /**
	   * deflateRaw(data[, options]) -> Uint8Array|Array|String
	   * - data (Uint8Array|Array|String): input data to compress.
	   * - options (Object): zlib deflate options.
	   *
	   * The same as [[deflate]], but creates raw data, without wrapper
	   * (header and adler32 crc).
	   **/
	  function deflateRaw(input, options) {
	    options = options || {};
	    options.raw = true;
	    return deflate$1(input, options);
	  }
	
	
	  /**
	   * gzip(data[, options]) -> Uint8Array|Array|String
	   * - data (Uint8Array|Array|String): input data to compress.
	   * - options (Object): zlib deflate options.
	   *
	   * The same as [[deflate]], but create gzip wrapper instead of
	   * deflate one.
	   **/
	  function gzip(input, options) {
	    options = options || {};
	    options.gzip = true;
	    return deflate$1(input, options);
	  }
	
	  exports.Deflate = Deflate;
	  exports.Inflate = Inflate;
	  exports.Z_BEST_COMPRESSION = Z_BEST_COMPRESSION;
	  exports.Z_BEST_SPEED = Z_BEST_SPEED;
	  exports.Z_BINARY = Z_BINARY;
	  exports.Z_BLOCK = Z_BLOCK;
	  exports.Z_BUF_ERROR = Z_BUF_ERROR;
	  exports.Z_DATA_ERROR = Z_DATA_ERROR;
	  exports.Z_DEFAULT_COMPRESSION = Z_DEFAULT_COMPRESSION;
	  exports.Z_DEFAULT_STRATEGY = Z_DEFAULT_STRATEGY;
	  exports.Z_DEFLATED = Z_DEFLATED;
	  exports.Z_ERRNO = Z_ERRNO;
	  exports.Z_FILTERED = Z_FILTERED;
	  exports.Z_FINISH = Z_FINISH;
	  exports.Z_FIXED = Z_FIXED;
	  exports.Z_FULL_FLUSH = Z_FULL_FLUSH;
	  exports.Z_HUFFMAN_ONLY = Z_HUFFMAN_ONLY;
	  exports.Z_NEED_DICT = Z_NEED_DICT;
	  exports.Z_NO_COMPRESSION = Z_NO_COMPRESSION;
	  exports.Z_NO_FLUSH = Z_NO_FLUSH;
	  exports.Z_OK = Z_OK;
	  exports.Z_PARTIAL_FLUSH = Z_PARTIAL_FLUSH;
	  exports.Z_RLE = Z_RLE;
	  exports.Z_STREAM_END = Z_STREAM_END;
	  exports.Z_STREAM_ERROR = Z_STREAM_ERROR;
	  exports.Z_SYNC_FLUSH = Z_SYNC_FLUSH;
	  exports.Z_TEXT = Z_TEXT;
	  exports.Z_TREES = Z_TREES;
	  exports.Z_UNKNOWN = Z_UNKNOWN;
	  exports.deflate = deflate$1;
	  exports.deflateRaw = deflateRaw;
	  exports.gzip = gzip;
	  exports.inflate = inflate$1;
	  exports.inflateRaw = inflateRaw;
	  exports.ungzip = ungzip;
	
	  Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 844 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright (c) 2017-present, Ephox, Inc.
	 *
	 * This source code is licensed under the Apache 2 license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ScriptLoader = void 0;
	var Utils_1 = __webpack_require__(347);
	var createState = function () { return ({
	    listeners: [],
	    scriptId: (0, Utils_1.uuid)('tiny-script'),
	    scriptLoading: false,
	    scriptLoaded: false
	}); };
	var CreateScriptLoader = function () {
	    var state = createState();
	    var injectScriptTag = function (scriptId, doc, url, async, defer, callback) {
	        var scriptTag = doc.createElement('script');
	        scriptTag.referrerPolicy = 'origin';
	        scriptTag.type = 'application/javascript';
	        scriptTag.id = scriptId;
	        scriptTag.src = url;
	        scriptTag.async = async;
	        scriptTag.defer = defer;
	        var handler = function () {
	            scriptTag.removeEventListener('load', handler);
	            callback();
	        };
	        scriptTag.addEventListener('load', handler);
	        if (doc.head) {
	            doc.head.appendChild(scriptTag);
	        }
	    };
	    var load = function (doc, url, async, defer, delay, callback) {
	        var scriptTagInjection = function () { return injectScriptTag(state.scriptId, doc, url, async, defer, function () {
	            state.listeners.forEach(function (fn) { return fn(); });
	            state.scriptLoaded = true;
	        }); };
	        if (state.scriptLoaded) {
	            callback();
	        }
	        else {
	            state.listeners.push(callback);
	            if (!state.scriptLoading) {
	                state.scriptLoading = true;
	                if (delay > 0) {
	                    setTimeout(scriptTagInjection, delay);
	                }
	                else {
	                    scriptTagInjection();
	                }
	            }
	        }
	    };
	    // Only to be used by tests.
	    var reinitialize = function () {
	        state = createState();
	    };
	    return {
	        load: load,
	        reinitialize: reinitialize
	    };
	};
	var ScriptLoader = CreateScriptLoader();
	exports.ScriptLoader = ScriptLoader;


/***/ },
/* 845 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	/**
	 * Copyright (c) 2017-present, Ephox, Inc.
	 *
	 * This source code is licensed under the Apache 2 license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.getTinymce = void 0;
	var getGlobal = function () { return (typeof window !== 'undefined' ? window : global); };
	var getTinymce = function () {
	    var global = getGlobal();
	    return global && global.tinymce ? global.tinymce : null;
	};
	exports.getTinymce = getTinymce;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 846 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright (c) 2017-present, Ephox, Inc.
	 *
	 * This source code is licensed under the Apache 2 license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        if (typeof b !== "function" && b !== null)
	            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.Editor = void 0;
	var React = __webpack_require__(1);
	var ScriptLoader_1 = __webpack_require__(844);
	var TinyMCE_1 = __webpack_require__(845);
	var Utils_1 = __webpack_require__(347);
	var EditorPropTypes_1 = __webpack_require__(348);
	var changeEvents = function () { var _a, _b, _c; return ((_c = (_b = (_a = (0, TinyMCE_1.getTinymce)()) === null || _a === void 0 ? void 0 : _a.Env) === null || _b === void 0 ? void 0 : _b.browser) === null || _c === void 0 ? void 0 : _c.isIE()) ? 'change keyup compositionend setcontent' : 'change input compositionend setcontent'; };
	var beforeInputEvent = function () { return (0, Utils_1.isBeforeInputEventAvailable)() ? 'beforeinput SelectionChange' : 'SelectionChange'; };
	var Editor = /** @class */ (function (_super) {
	    __extends(Editor, _super);
	    function Editor(props) {
	        var _this = this;
	        var _a, _b, _c;
	        _this = _super.call(this, props) || this;
	        _this.rollbackTimer = undefined;
	        _this.valueCursor = undefined;
	        _this.rollbackChange = function () {
	            var editor = _this.editor;
	            var value = _this.props.value;
	            if (editor && value && value !== _this.currentContent) {
	                editor.undoManager.ignore(function () {
	                    editor.setContent(value);
	                    // only restore cursor on inline editors when they are focused
	                    // as otherwise it will cause a focus grab
	                    if (_this.valueCursor && (!_this.inline || editor.hasFocus())) {
	                        try {
	                            editor.selection.moveToBookmark(_this.valueCursor);
	                        }
	                        catch (e) { /* ignore */ }
	                    }
	                });
	            }
	            _this.rollbackTimer = undefined;
	        };
	        _this.handleBeforeInput = function (_evt) {
	            if (_this.props.value !== undefined && _this.props.value === _this.currentContent && _this.editor) {
	                if (!_this.inline || _this.editor.hasFocus) {
	                    try {
	                        // getBookmark throws exceptions when the editor has not been focused
	                        // possibly only in inline mode but I'm not taking chances
	                        _this.valueCursor = _this.editor.selection.getBookmark(3);
	                    }
	                    catch (e) { /* ignore */ }
	                }
	            }
	        };
	        _this.handleBeforeInputSpecial = function (evt) {
	            if (evt.key === 'Enter' || evt.key === 'Backspace' || evt.key === 'Delete') {
	                _this.handleBeforeInput(evt);
	            }
	        };
	        _this.handleEditorChange = function (_evt) {
	            var editor = _this.editor;
	            if (editor && editor.initialized) {
	                var newContent = editor.getContent();
	                if (_this.props.value !== undefined && _this.props.value !== newContent && _this.props.rollback !== false) {
	                    // start a timer and revert to the value if not applied in time
	                    if (!_this.rollbackTimer) {
	                        _this.rollbackTimer = window.setTimeout(_this.rollbackChange, typeof _this.props.rollback === 'number' ? _this.props.rollback : 200);
	                    }
	                }
	                if (newContent !== _this.currentContent) {
	                    _this.currentContent = newContent;
	                    if ((0, Utils_1.isFunction)(_this.props.onEditorChange)) {
	                        var format = _this.props.outputFormat;
	                        var out = format === 'html' ? newContent : editor.getContent({ format: format });
	                        _this.props.onEditorChange(out, editor);
	                    }
	                }
	            }
	        };
	        _this.handleEditorChangeSpecial = function (evt) {
	            if (evt.key === 'Backspace' || evt.key === 'Delete') {
	                _this.handleEditorChange(evt);
	            }
	        };
	        _this.initialise = function (attempts) {
	            var _a, _b, _c;
	            if (attempts === void 0) { attempts = 0; }
	            var target = _this.elementRef.current;
	            if (!target) {
	                return; // Editor has been unmounted
	            }
	            if (!(0, Utils_1.isInDoc)(target)) {
	                // this is probably someone trying to help by rendering us offscreen
	                // but we can't do that because the editor iframe must be in the document
	                // in order to have state
	                if (attempts === 0) {
	                    // we probably just need to wait for the current events to be processed
	                    setTimeout(function () { return _this.initialise(1); }, 1);
	                }
	                else if (attempts < 100) {
	                    // wait for ten seconds, polling every tenth of a second
	                    setTimeout(function () { return _this.initialise(attempts + 1); }, 100);
	                }
	                else {
	                    // give up, at this point it seems that more polling is unlikely to help
	                    throw new Error('tinymce can only be initialised when in a document');
	                }
	                return;
	            }
	            var tinymce = (0, TinyMCE_1.getTinymce)();
	            if (!tinymce) {
	                throw new Error('tinymce should have been loaded into global scope');
	            }
	            var finalInit = __assign(__assign({}, _this.props.init), { selector: undefined, target: target, readonly: _this.props.disabled, inline: _this.inline, plugins: (0, Utils_1.mergePlugins)((_a = _this.props.init) === null || _a === void 0 ? void 0 : _a.plugins, _this.props.plugins), toolbar: (_b = _this.props.toolbar) !== null && _b !== void 0 ? _b : (_c = _this.props.init) === null || _c === void 0 ? void 0 : _c.toolbar, setup: function (editor) {
	                    _this.editor = editor;
	                    _this.bindHandlers({});
	                    // When running in inline mode the editor gets the initial value
	                    // from the innerHTML of the element it is initialized on.
	                    // However we don't want to take on the responsibility of sanitizing
	                    // to remove XSS in the react integration so we have a chicken and egg
	                    // problem... We avoid it by sneaking in a set content before the first
	                    // "official" setContent and using TinyMCE to do the sanitization.
	                    if (_this.inline && !(0, Utils_1.isTextareaOrInput)(target)) {
	                        editor.once('PostRender', function (_evt) {
	                            editor.setContent(_this.getInitialValue(), { no_events: true });
	                        });
	                    }
	                    if (_this.props.init && (0, Utils_1.isFunction)(_this.props.init.setup)) {
	                        _this.props.init.setup(editor);
	                    }
	                }, init_instance_callback: function (editor) {
	                    var _a, _b;
	                    // check for changes that happened since tinymce.init() was called
	                    var initialValue = _this.getInitialValue();
	                    _this.currentContent = (_a = _this.currentContent) !== null && _a !== void 0 ? _a : editor.getContent();
	                    if (_this.currentContent !== initialValue) {
	                        _this.currentContent = initialValue;
	                        // same as resetContent in TinyMCE 5
	                        editor.setContent(initialValue);
	                        editor.undoManager.clear();
	                        editor.undoManager.add();
	                        editor.setDirty(false);
	                    }
	                    var disabled = (_b = _this.props.disabled) !== null && _b !== void 0 ? _b : false;
	                    (0, Utils_1.setMode)(_this.editor, disabled ? 'readonly' : 'design');
	                    // ensure existing init_instance_callback is called
	                    if (_this.props.init && (0, Utils_1.isFunction)(_this.props.init.init_instance_callback)) {
	                        _this.props.init.init_instance_callback(editor);
	                    }
	                } });
	            if (!_this.inline) {
	                target.style.visibility = '';
	            }
	            if ((0, Utils_1.isTextareaOrInput)(target)) {
	                target.value = _this.getInitialValue();
	            }
	            tinymce.init(finalInit);
	        };
	        _this.id = _this.props.id || (0, Utils_1.uuid)('tiny-react');
	        _this.elementRef = React.createRef();
	        _this.inline = (_c = (_a = _this.props.inline) !== null && _a !== void 0 ? _a : (_b = _this.props.init) === null || _b === void 0 ? void 0 : _b.inline) !== null && _c !== void 0 ? _c : false;
	        _this.boundHandlers = {};
	        return _this;
	    }
	    Editor.prototype.componentDidUpdate = function (prevProps) {
	        var _this = this;
	        var _a, _b;
	        if (this.rollbackTimer) {
	            clearTimeout(this.rollbackTimer);
	            this.rollbackTimer = undefined;
	        }
	        if (this.editor) {
	            this.bindHandlers(prevProps);
	            if (this.editor.initialized) {
	                this.currentContent = (_a = this.currentContent) !== null && _a !== void 0 ? _a : this.editor.getContent();
	                if (typeof this.props.initialValue === 'string' && this.props.initialValue !== prevProps.initialValue) {
	                    // same as resetContent in TinyMCE 5
	                    this.editor.setContent(this.props.initialValue);
	                    this.editor.undoManager.clear();
	                    this.editor.undoManager.add();
	                    this.editor.setDirty(false);
	                }
	                else if (typeof this.props.value === 'string' && this.props.value !== this.currentContent) {
	                    var localEditor_1 = this.editor;
	                    localEditor_1.undoManager.transact(function () {
	                        // inline editors grab focus when restoring selection
	                        // so we don't try to keep their selection unless they are currently focused
	                        var cursor;
	                        if (!_this.inline || localEditor_1.hasFocus()) {
	                            try {
	                                // getBookmark throws exceptions when the editor has not been focused
	                                // possibly only in inline mode but I'm not taking chances
	                                cursor = localEditor_1.selection.getBookmark(3);
	                            }
	                            catch (e) { /* ignore */ }
	                        }
	                        var valueCursor = _this.valueCursor;
	                        localEditor_1.setContent(_this.props.value);
	                        if (!_this.inline || localEditor_1.hasFocus()) {
	                            for (var _i = 0, _a = [cursor, valueCursor]; _i < _a.length; _i++) {
	                                var bookmark = _a[_i];
	                                if (bookmark) {
	                                    try {
	                                        localEditor_1.selection.moveToBookmark(bookmark);
	                                        _this.valueCursor = bookmark;
	                                        break;
	                                    }
	                                    catch (e) { /* ignore */ }
	                                }
	                            }
	                        }
	                    });
	                }
	                if (this.props.disabled !== prevProps.disabled) {
	                    var disabled = (_b = this.props.disabled) !== null && _b !== void 0 ? _b : false;
	                    (0, Utils_1.setMode)(this.editor, disabled ? 'readonly' : 'design');
	                }
	            }
	        }
	    };
	    Editor.prototype.componentDidMount = function () {
	        var _a, _b, _c, _d, _e, _f;
	        if ((0, TinyMCE_1.getTinymce)() !== null) {
	            this.initialise();
	        }
	        else if (this.elementRef.current && this.elementRef.current.ownerDocument) {
	            ScriptLoader_1.ScriptLoader.load(this.elementRef.current.ownerDocument, this.getScriptSrc(), (_b = (_a = this.props.scriptLoading) === null || _a === void 0 ? void 0 : _a.async) !== null && _b !== void 0 ? _b : false, (_d = (_c = this.props.scriptLoading) === null || _c === void 0 ? void 0 : _c.defer) !== null && _d !== void 0 ? _d : false, (_f = (_e = this.props.scriptLoading) === null || _e === void 0 ? void 0 : _e.delay) !== null && _f !== void 0 ? _f : 0, this.initialise);
	        }
	    };
	    Editor.prototype.componentWillUnmount = function () {
	        var _this = this;
	        var editor = this.editor;
	        if (editor) {
	            editor.off(changeEvents(), this.handleEditorChange);
	            editor.off(beforeInputEvent(), this.handleBeforeInput);
	            editor.off('keypress', this.handleEditorChangeSpecial);
	            editor.off('keydown', this.handleBeforeInputSpecial);
	            editor.off('NewBlock', this.handleEditorChange);
	            Object.keys(this.boundHandlers).forEach(function (eventName) {
	                editor.off(eventName, _this.boundHandlers[eventName]);
	            });
	            this.boundHandlers = {};
	            editor.remove();
	            this.editor = undefined;
	        }
	    };
	    Editor.prototype.render = function () {
	        return this.inline ? this.renderInline() : this.renderIframe();
	    };
	    Editor.prototype.renderInline = function () {
	        var _a = this.props.tagName, tagName = _a === void 0 ? 'div' : _a;
	        return React.createElement(tagName, {
	            ref: this.elementRef,
	            id: this.id
	        });
	    };
	    Editor.prototype.renderIframe = function () {
	        return React.createElement('textarea', {
	            ref: this.elementRef,
	            style: { visibility: 'hidden' },
	            name: this.props.textareaName,
	            id: this.id
	        });
	    };
	    Editor.prototype.getScriptSrc = function () {
	        if (typeof this.props.tinymceScriptSrc === 'string') {
	            return this.props.tinymceScriptSrc;
	        }
	        else {
	            var channel = this.props.cloudChannel;
	            var apiKey = this.props.apiKey ? this.props.apiKey : 'no-api-key';
	            return "https://cdn.tiny.cloud/1/".concat(apiKey, "/tinymce/").concat(channel, "/tinymce.min.js");
	        }
	    };
	    Editor.prototype.getInitialValue = function () {
	        if (typeof this.props.initialValue === 'string') {
	            return this.props.initialValue;
	        }
	        else if (typeof this.props.value === 'string') {
	            return this.props.value;
	        }
	        else {
	            return '';
	        }
	    };
	    Editor.prototype.bindHandlers = function (prevProps) {
	        var _this = this;
	        if (this.editor !== undefined) {
	            // typescript chokes trying to understand the type of the lookup function
	            (0, Utils_1.configHandlers)(this.editor, prevProps, this.props, this.boundHandlers, function (key) { return _this.props[key]; });
	            // check if we should monitor editor changes
	            var isValueControlled = function (p) { return p.onEditorChange !== undefined || p.value !== undefined; };
	            var wasControlled = isValueControlled(prevProps);
	            var nowControlled = isValueControlled(this.props);
	            if (!wasControlled && nowControlled) {
	                this.editor.on(changeEvents(), this.handleEditorChange);
	                this.editor.on(beforeInputEvent(), this.handleBeforeInput);
	                this.editor.on('keydown', this.handleBeforeInputSpecial);
	                this.editor.on('keyup', this.handleEditorChangeSpecial);
	                this.editor.on('NewBlock', this.handleEditorChange);
	            }
	            else if (wasControlled && !nowControlled) {
	                this.editor.off(changeEvents(), this.handleEditorChange);
	                this.editor.off(beforeInputEvent(), this.handleBeforeInput);
	                this.editor.off('keydown', this.handleBeforeInputSpecial);
	                this.editor.off('keyup', this.handleEditorChangeSpecial);
	                this.editor.off('NewBlock', this.handleEditorChange);
	            }
	        }
	    };
	    Editor.propTypes = EditorPropTypes_1.EditorPropTypes;
	    Editor.defaultProps = {
	        cloudChannel: '5'
	    };
	    return Editor;
	}(React.Component));
	exports.Editor = Editor;


/***/ },
/* 847 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	// Use the fastest means possible to execute a task in its own turn, with
	// priority over other events including IO, animation, reflow, and redraw
	// events in browsers.
	//
	// An exception thrown by a task will permanently interrupt the processing of
	// subsequent tasks. The higher level `asap` function ensures that if an
	// exception is thrown by a task, that the task queue will continue flushing as
	// soon as possible, but if you use `rawAsap` directly, you are responsible to
	// either ensure that no exceptions are thrown from your task, or to manually
	// call `rawAsap.requestFlush` if an exception is thrown.
	module.exports = rawAsap;
	function rawAsap(task) {
	    if (!queue.length) {
	        requestFlush();
	        flushing = true;
	    }
	    // Equivalent to push, but avoids a function call.
	    queue[queue.length] = task;
	}
	
	var queue = [];
	// Once a flush has been requested, no further calls to `requestFlush` are
	// necessary until the next `flush` completes.
	var flushing = false;
	// `requestFlush` is an implementation-specific method that attempts to kick
	// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
	// the event queue before yielding to the browser's own event loop.
	var requestFlush;
	// The position of the next task to execute in the task queue. This is
	// preserved between calls to `flush` so that it can be resumed if
	// a task throws an exception.
	var index = 0;
	// If a task schedules additional tasks recursively, the task queue can grow
	// unbounded. To prevent memory exhaustion, the task queue will periodically
	// truncate already-completed tasks.
	var capacity = 1024;
	
	// The flush function processes all tasks that have been scheduled with
	// `rawAsap` unless and until one of those tasks throws an exception.
	// If a task throws an exception, `flush` ensures that its state will remain
	// consistent and will resume where it left off when called again.
	// However, `flush` does not make any arrangements to be called again if an
	// exception is thrown.
	function flush() {
	    while (index < queue.length) {
	        var currentIndex = index;
	        // Advance the index before calling the task. This ensures that we will
	        // begin flushing on the next task the task throws an error.
	        index = index + 1;
	        queue[currentIndex].call();
	        // Prevent leaking memory for long chains of recursive calls to `asap`.
	        // If we call `asap` within tasks scheduled by `asap`, the queue will
	        // grow, but to avoid an O(n) walk for every task we execute, we don't
	        // shift tasks off the queue after they have been executed.
	        // Instead, we periodically shift 1024 tasks off the queue.
	        if (index > capacity) {
	            // Manually shift all values starting at the index back to the
	            // beginning of the queue.
	            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
	                queue[scan] = queue[scan + index];
	            }
	            queue.length -= index;
	            index = 0;
	        }
	    }
	    queue.length = 0;
	    index = 0;
	    flushing = false;
	}
	
	// `requestFlush` is implemented using a strategy based on data collected from
	// every available SauceLabs Selenium web driver worker at time of writing.
	// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
	
	// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
	// have WebKitMutationObserver but not un-prefixed MutationObserver.
	// Must use `global` or `self` instead of `window` to work in both frames and web
	// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
	
	/* globals self */
	var scope = typeof global !== "undefined" ? global : self;
	var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
	
	// MutationObservers are desirable because they have high priority and work
	// reliably everywhere they are implemented.
	// They are implemented in all modern browsers.
	//
	// - Android 4-4.3
	// - Chrome 26-34
	// - Firefox 14-29
	// - Internet Explorer 11
	// - iPad Safari 6-7.1
	// - iPhone Safari 7-7.1
	// - Safari 6-7
	if (typeof BrowserMutationObserver === "function") {
	    requestFlush = makeRequestCallFromMutationObserver(flush);
	
	// MessageChannels are desirable because they give direct access to the HTML
	// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
	// 11-12, and in web workers in many engines.
	// Although message channels yield to any queued rendering and IO tasks, they
	// would be better than imposing the 4ms delay of timers.
	// However, they do not work reliably in Internet Explorer or Safari.
	
	// Internet Explorer 10 is the only browser that has setImmediate but does
	// not have MutationObservers.
	// Although setImmediate yields to the browser's renderer, it would be
	// preferrable to falling back to setTimeout since it does not have
	// the minimum 4ms penalty.
	// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
	// Desktop to a lesser extent) that renders both setImmediate and
	// MessageChannel useless for the purposes of ASAP.
	// https://github.com/kriskowal/q/issues/396
	
	// Timers are implemented universally.
	// We fall back to timers in workers in most engines, and in foreground
	// contexts in the following browsers.
	// However, note that even this simple case requires nuances to operate in a
	// broad spectrum of browsers.
	//
	// - Firefox 3-13
	// - Internet Explorer 6-9
	// - iPad Safari 4.3
	// - Lynx 2.8.7
	} else {
	    requestFlush = makeRequestCallFromTimer(flush);
	}
	
	// `requestFlush` requests that the high priority event queue be flushed as
	// soon as possible.
	// This is useful to prevent an error thrown in a task from stalling the event
	// queue if the exception handled by Node.js’s
	// `process.on("uncaughtException")` or by a domain.
	rawAsap.requestFlush = requestFlush;
	
	// To request a high priority event, we induce a mutation observer by toggling
	// the text of a text node between "1" and "-1".
	function makeRequestCallFromMutationObserver(callback) {
	    var toggle = 1;
	    var observer = new BrowserMutationObserver(callback);
	    var node = document.createTextNode("");
	    observer.observe(node, {characterData: true});
	    return function requestCall() {
	        toggle = -toggle;
	        node.data = toggle;
	    };
	}
	
	// The message channel technique was discovered by Malte Ubl and was the
	// original foundation for this library.
	// http://www.nonblocking.io/2011/06/windownexttick.html
	
	// Safari 6.0.5 (at least) intermittently fails to create message ports on a
	// page's first load. Thankfully, this version of Safari supports
	// MutationObservers, so we don't need to fall back in that case.
	
	// function makeRequestCallFromMessageChannel(callback) {
	//     var channel = new MessageChannel();
	//     channel.port1.onmessage = callback;
	//     return function requestCall() {
	//         channel.port2.postMessage(0);
	//     };
	// }
	
	// For reasons explained above, we are also unable to use `setImmediate`
	// under any circumstances.
	// Even if we were, there is another bug in Internet Explorer 10.
	// It is not sufficient to assign `setImmediate` to `requestFlush` because
	// `setImmediate` must be called *by name* and therefore must be wrapped in a
	// closure.
	// Never forget.
	
	// function makeRequestCallFromSetImmediate(callback) {
	//     return function requestCall() {
	//         setImmediate(callback);
	//     };
	// }
	
	// Safari 6.0 has a problem where timers will get lost while the user is
	// scrolling. This problem does not impact ASAP because Safari 6.0 supports
	// mutation observers, so that implementation is used instead.
	// However, if we ever elect to use timers in Safari, the prevalent work-around
	// is to add a scroll event listener that calls for a flush.
	
	// `setTimeout` does not call the passed callback if the delay is less than
	// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
	// even then.
	
	function makeRequestCallFromTimer(callback) {
	    return function requestCall() {
	        // We dispatch a timeout with a specified delay of 0 for engines that
	        // can reliably accommodate that request. This will usually be snapped
	        // to a 4 milisecond delay, but once we're flushing, there's no delay
	        // between events.
	        var timeoutHandle = setTimeout(handleTimer, 0);
	        // However, since this timer gets frequently dropped in Firefox
	        // workers, we enlist an interval handle that will try to fire
	        // an event 20 times per second until it succeeds.
	        var intervalHandle = setInterval(handleTimer, 50);
	
	        function handleTimer() {
	            // Whichever timer succeeds will cancel both timers and
	            // execute the callback.
	            clearTimeout(timeoutHandle);
	            clearInterval(intervalHandle);
	            callback();
	        }
	    };
	}
	
	// This is for `asap.js` only.
	// Its name will be periodically randomized to break any code that depends on
	// its existence.
	rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
	
	// ASAP was originally a nextTick shim included in Q. This was factored out
	// into this ASAP package. It was later adapted to RSVP which made further
	// amendments. These decisions, particularly to marginalize MessageChannel and
	// to capture the MutationObserver implementation in a closure, were integrated
	// back into ASAP proper.
	// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 848 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(63);
	var bind = __webpack_require__(355);
	var Axios = __webpack_require__(850);
	var mergeConfig = __webpack_require__(354);
	var defaults = __webpack_require__(246);
	
	/**
	 * Create an instance of Axios
	 *
	 * @param {Object} defaultConfig The default config for the instance
	 * @return {Axios} A new instance of Axios
	 */
	function createInstance(defaultConfig) {
	  var context = new Axios(defaultConfig);
	  var instance = bind(Axios.prototype.request, context);
	
	  // Copy axios.prototype to instance
	  utils.extend(instance, Axios.prototype, context);
	
	  // Copy context to instance
	  utils.extend(instance, context);
	
	  return instance;
	}
	
	// Create the default instance to be exported
	var axios = createInstance(defaults);
	
	// Expose Axios class to allow class inheritance
	axios.Axios = Axios;
	
	// Factory for creating new instances
	axios.create = function create(instanceConfig) {
	  return createInstance(mergeConfig(axios.defaults, instanceConfig));
	};
	
	// Expose Cancel & CancelToken
	axios.Cancel = __webpack_require__(350);
	axios.CancelToken = __webpack_require__(849);
	axios.isCancel = __webpack_require__(351);
	
	// Expose all/spread
	axios.all = function all(promises) {
	  return Promise.all(promises);
	};
	axios.spread = __webpack_require__(863);
	
	// Expose isAxiosError
	axios.isAxiosError = __webpack_require__(859);
	
	module.exports = axios;
	
	// Allow use of default import syntax in TypeScript
	module.exports.default = axios;


/***/ },
/* 849 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Cancel = __webpack_require__(350);
	
	/**
	 * A `CancelToken` is an object that can be used to request cancellation of an operation.
	 *
	 * @class
	 * @param {Function} executor The executor function.
	 */
	function CancelToken(executor) {
	  if (typeof executor !== 'function') {
	    throw new TypeError('executor must be a function.');
	  }
	
	  var resolvePromise;
	  this.promise = new Promise(function promiseExecutor(resolve) {
	    resolvePromise = resolve;
	  });
	
	  var token = this;
	  executor(function cancel(message) {
	    if (token.reason) {
	      // Cancellation has already been requested
	      return;
	    }
	
	    token.reason = new Cancel(message);
	    resolvePromise(token.reason);
	  });
	}
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	CancelToken.prototype.throwIfRequested = function throwIfRequested() {
	  if (this.reason) {
	    throw this.reason;
	  }
	};
	
	/**
	 * Returns an object that contains a new `CancelToken` and a function that, when called,
	 * cancels the `CancelToken`.
	 */
	CancelToken.source = function source() {
	  var cancel;
	  var token = new CancelToken(function executor(c) {
	    cancel = c;
	  });
	  return {
	    token: token,
	    cancel: cancel
	  };
	};
	
	module.exports = CancelToken;


/***/ },
/* 850 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(63);
	var buildURL = __webpack_require__(356);
	var InterceptorManager = __webpack_require__(851);
	var dispatchRequest = __webpack_require__(853);
	var mergeConfig = __webpack_require__(354);
	var validator = __webpack_require__(864);
	
	var validators = validator.validators;
	/**
	 * Create a new instance of Axios
	 *
	 * @param {Object} instanceConfig The default config for the instance
	 */
	function Axios(instanceConfig) {
	  this.defaults = instanceConfig;
	  this.interceptors = {
	    request: new InterceptorManager(),
	    response: new InterceptorManager()
	  };
	}
	
	/**
	 * Dispatch a request
	 *
	 * @param {Object} config The config specific for this request (merged with this.defaults)
	 */
	Axios.prototype.request = function request(config) {
	  /*eslint no-param-reassign:0*/
	  // Allow for axios('example/url'[, config]) a la fetch API
	  if (typeof config === 'string') {
	    config = arguments[1] || {};
	    config.url = arguments[0];
	  } else {
	    config = config || {};
	  }
	
	  config = mergeConfig(this.defaults, config);
	
	  // Set config.method
	  if (config.method) {
	    config.method = config.method.toLowerCase();
	  } else if (this.defaults.method) {
	    config.method = this.defaults.method.toLowerCase();
	  } else {
	    config.method = 'get';
	  }
	
	  var transitional = config.transitional;
	
	  if (transitional !== undefined) {
	    validator.assertOptions(transitional, {
	      silentJSONParsing: validators.transitional(validators.boolean, '1.0.0'),
	      forcedJSONParsing: validators.transitional(validators.boolean, '1.0.0'),
	      clarifyTimeoutError: validators.transitional(validators.boolean, '1.0.0')
	    }, false);
	  }
	
	  // filter out skipped interceptors
	  var requestInterceptorChain = [];
	  var synchronousRequestInterceptors = true;
	  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
	    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
	      return;
	    }
	
	    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
	
	    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  var responseInterceptorChain = [];
	  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
	    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  var promise;
	
	  if (!synchronousRequestInterceptors) {
	    var chain = [dispatchRequest, undefined];
	
	    Array.prototype.unshift.apply(chain, requestInterceptorChain);
	    chain = chain.concat(responseInterceptorChain);
	
	    promise = Promise.resolve(config);
	    while (chain.length) {
	      promise = promise.then(chain.shift(), chain.shift());
	    }
	
	    return promise;
	  }
	
	
	  var newConfig = config;
	  while (requestInterceptorChain.length) {
	    var onFulfilled = requestInterceptorChain.shift();
	    var onRejected = requestInterceptorChain.shift();
	    try {
	      newConfig = onFulfilled(newConfig);
	    } catch (error) {
	      onRejected(error);
	      break;
	    }
	  }
	
	  try {
	    promise = dispatchRequest(newConfig);
	  } catch (error) {
	    return Promise.reject(error);
	  }
	
	  while (responseInterceptorChain.length) {
	    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
	  }
	
	  return promise;
	};
	
	Axios.prototype.getUri = function getUri(config) {
	  config = mergeConfig(this.defaults, config);
	  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
	};
	
	// Provide aliases for supported request methods
	utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, config) {
	    return this.request(mergeConfig(config || {}, {
	      method: method,
	      url: url,
	      data: (config || {}).data
	    }));
	  };
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, data, config) {
	    return this.request(mergeConfig(config || {}, {
	      method: method,
	      url: url,
	      data: data
	    }));
	  };
	});
	
	module.exports = Axios;


/***/ },
/* 851 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(63);
	
	function InterceptorManager() {
	  this.handlers = [];
	}
	
	/**
	 * Add a new interceptor to the stack
	 *
	 * @param {Function} fulfilled The function to handle `then` for a `Promise`
	 * @param {Function} rejected The function to handle `reject` for a `Promise`
	 *
	 * @return {Number} An ID used to remove interceptor later
	 */
	InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
	  this.handlers.push({
	    fulfilled: fulfilled,
	    rejected: rejected,
	    synchronous: options ? options.synchronous : false,
	    runWhen: options ? options.runWhen : null
	  });
	  return this.handlers.length - 1;
	};
	
	/**
	 * Remove an interceptor from the stack
	 *
	 * @param {Number} id The ID that was returned by `use`
	 */
	InterceptorManager.prototype.eject = function eject(id) {
	  if (this.handlers[id]) {
	    this.handlers[id] = null;
	  }
	};
	
	/**
	 * Iterate over all the registered interceptors
	 *
	 * This method is particularly useful for skipping over any
	 * interceptors that may have become `null` calling `eject`.
	 *
	 * @param {Function} fn The function to call for each interceptor
	 */
	InterceptorManager.prototype.forEach = function forEach(fn) {
	  utils.forEach(this.handlers, function forEachHandler(h) {
	    if (h !== null) {
	      fn(h);
	    }
	  });
	};
	
	module.exports = InterceptorManager;


/***/ },
/* 852 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var isAbsoluteURL = __webpack_require__(858);
	var combineURLs = __webpack_require__(856);
	
	/**
	 * Creates a new URL by combining the baseURL with the requestedURL,
	 * only when the requestedURL is not already an absolute URL.
	 * If the requestURL is absolute, this function returns the requestedURL untouched.
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} requestedURL Absolute or relative URL to combine
	 * @returns {string} The combined full path
	 */
	module.exports = function buildFullPath(baseURL, requestedURL) {
	  if (baseURL && !isAbsoluteURL(requestedURL)) {
	    return combineURLs(baseURL, requestedURL);
	  }
	  return requestedURL;
	};


/***/ },
/* 853 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(63);
	var transformData = __webpack_require__(855);
	var isCancel = __webpack_require__(351);
	var defaults = __webpack_require__(246);
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	function throwIfCancellationRequested(config) {
	  if (config.cancelToken) {
	    config.cancelToken.throwIfRequested();
	  }
	}
	
	/**
	 * Dispatch a request to the server using the configured adapter.
	 *
	 * @param {object} config The config that is to be used for the request
	 * @returns {Promise} The Promise to be fulfilled
	 */
	module.exports = function dispatchRequest(config) {
	  throwIfCancellationRequested(config);
	
	  // Ensure headers exist
	  config.headers = config.headers || {};
	
	  // Transform request data
	  config.data = transformData.call(
	    config,
	    config.data,
	    config.headers,
	    config.transformRequest
	  );
	
	  // Flatten headers
	  config.headers = utils.merge(
	    config.headers.common || {},
	    config.headers[config.method] || {},
	    config.headers
	  );
	
	  utils.forEach(
	    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
	    function cleanHeaderConfig(method) {
	      delete config.headers[method];
	    }
	  );
	
	  var adapter = config.adapter || defaults.adapter;
	
	  return adapter(config).then(function onAdapterResolution(response) {
	    throwIfCancellationRequested(config);
	
	    // Transform response data
	    response.data = transformData.call(
	      config,
	      response.data,
	      response.headers,
	      config.transformResponse
	    );
	
	    return response;
	  }, function onAdapterRejection(reason) {
	    if (!isCancel(reason)) {
	      throwIfCancellationRequested(config);
	
	      // Transform response data
	      if (reason && reason.response) {
	        reason.response.data = transformData.call(
	          config,
	          reason.response.data,
	          reason.response.headers,
	          config.transformResponse
	        );
	      }
	    }
	
	    return Promise.reject(reason);
	  });
	};


/***/ },
/* 854 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var createError = __webpack_require__(352);
	
	/**
	 * Resolve or reject a Promise based on response status.
	 *
	 * @param {Function} resolve A function that resolves the promise.
	 * @param {Function} reject A function that rejects the promise.
	 * @param {object} response The response.
	 */
	module.exports = function settle(resolve, reject, response) {
	  var validateStatus = response.config.validateStatus;
	  if (!response.status || !validateStatus || validateStatus(response.status)) {
	    resolve(response);
	  } else {
	    reject(createError(
	      'Request failed with status code ' + response.status,
	      response.config,
	      null,
	      response.request,
	      response
	    ));
	  }
	};


/***/ },
/* 855 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(63);
	var defaults = __webpack_require__(246);
	
	/**
	 * Transform the data for a request or a response
	 *
	 * @param {Object|String} data The data to be transformed
	 * @param {Array} headers The headers for the request or response
	 * @param {Array|Function} fns A single function or Array of functions
	 * @returns {*} The resulting transformed data
	 */
	module.exports = function transformData(data, headers, fns) {
	  var context = this || defaults;
	  /*eslint no-param-reassign:0*/
	  utils.forEach(fns, function transform(fn) {
	    data = fn.call(context, data, headers);
	  });
	
	  return data;
	};


/***/ },
/* 856 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Creates a new URL by combining the specified URLs
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} relativeURL The relative URL
	 * @returns {string} The combined URL
	 */
	module.exports = function combineURLs(baseURL, relativeURL) {
	  return relativeURL
	    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
	    : baseURL;
	};


/***/ },
/* 857 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(63);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs support document.cookie
	    (function standardBrowserEnv() {
	      return {
	        write: function write(name, value, expires, path, domain, secure) {
	          var cookie = [];
	          cookie.push(name + '=' + encodeURIComponent(value));
	
	          if (utils.isNumber(expires)) {
	            cookie.push('expires=' + new Date(expires).toGMTString());
	          }
	
	          if (utils.isString(path)) {
	            cookie.push('path=' + path);
	          }
	
	          if (utils.isString(domain)) {
	            cookie.push('domain=' + domain);
	          }
	
	          if (secure === true) {
	            cookie.push('secure');
	          }
	
	          document.cookie = cookie.join('; ');
	        },
	
	        read: function read(name) {
	          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
	          return (match ? decodeURIComponent(match[3]) : null);
	        },
	
	        remove: function remove(name) {
	          this.write(name, '', Date.now() - 86400000);
	        }
	      };
	    })() :
	
	  // Non standard browser env (web workers, react-native) lack needed support.
	    (function nonStandardBrowserEnv() {
	      return {
	        write: function write() {},
	        read: function read() { return null; },
	        remove: function remove() {}
	      };
	    })()
	);


/***/ },
/* 858 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Determines whether the specified URL is absolute
	 *
	 * @param {string} url The URL to test
	 * @returns {boolean} True if the specified URL is absolute, otherwise false
	 */
	module.exports = function isAbsoluteURL(url) {
	  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
	  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
	  // by any combination of letters, digits, plus, period, or hyphen.
	  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
	};


/***/ },
/* 859 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Determines whether the payload is an error thrown by Axios
	 *
	 * @param {*} payload The value to test
	 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
	 */
	module.exports = function isAxiosError(payload) {
	  return (typeof payload === 'object') && (payload.isAxiosError === true);
	};


/***/ },
/* 860 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(63);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs have full support of the APIs needed to test
	  // whether the request URL is of the same origin as current location.
	    (function standardBrowserEnv() {
	      var msie = /(msie|trident)/i.test(navigator.userAgent);
	      var urlParsingNode = document.createElement('a');
	      var originURL;
	
	      /**
	    * Parse a URL to discover it's components
	    *
	    * @param {String} url The URL to be parsed
	    * @returns {Object}
	    */
	      function resolveURL(url) {
	        var href = url;
	
	        if (msie) {
	        // IE needs attribute set twice to normalize properties
	          urlParsingNode.setAttribute('href', href);
	          href = urlParsingNode.href;
	        }
	
	        urlParsingNode.setAttribute('href', href);
	
	        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	        return {
	          href: urlParsingNode.href,
	          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	          host: urlParsingNode.host,
	          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	          hostname: urlParsingNode.hostname,
	          port: urlParsingNode.port,
	          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
	            urlParsingNode.pathname :
	            '/' + urlParsingNode.pathname
	        };
	      }
	
	      originURL = resolveURL(window.location.href);
	
	      /**
	    * Determine if a URL shares the same origin as the current location
	    *
	    * @param {String} requestURL The URL to test
	    * @returns {boolean} True if URL shares the same origin, otherwise false
	    */
	      return function isURLSameOrigin(requestURL) {
	        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
	        return (parsed.protocol === originURL.protocol &&
	            parsed.host === originURL.host);
	      };
	    })() :
	
	  // Non standard browser envs (web workers, react-native) lack needed support.
	    (function nonStandardBrowserEnv() {
	      return function isURLSameOrigin() {
	        return true;
	      };
	    })()
	);


/***/ },
/* 861 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(63);
	
	module.exports = function normalizeHeaderName(headers, normalizedName) {
	  utils.forEach(headers, function processHeader(value, name) {
	    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
	      headers[normalizedName] = value;
	      delete headers[name];
	    }
	  });
	};


/***/ },
/* 862 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(63);
	
	// Headers whose duplicates are ignored by node
	// c.f. https://nodejs.org/api/http.html#http_message_headers
	var ignoreDuplicateOf = [
	  'age', 'authorization', 'content-length', 'content-type', 'etag',
	  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
	  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
	  'referer', 'retry-after', 'user-agent'
	];
	
	/**
	 * Parse headers into an object
	 *
	 * ```
	 * Date: Wed, 27 Aug 2014 08:58:49 GMT
	 * Content-Type: application/json
	 * Connection: keep-alive
	 * Transfer-Encoding: chunked
	 * ```
	 *
	 * @param {String} headers Headers needing to be parsed
	 * @returns {Object} Headers parsed into an object
	 */
	module.exports = function parseHeaders(headers) {
	  var parsed = {};
	  var key;
	  var val;
	  var i;
	
	  if (!headers) { return parsed; }
	
	  utils.forEach(headers.split('\n'), function parser(line) {
	    i = line.indexOf(':');
	    key = utils.trim(line.substr(0, i)).toLowerCase();
	    val = utils.trim(line.substr(i + 1));
	
	    if (key) {
	      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
	        return;
	      }
	      if (key === 'set-cookie') {
	        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
	      } else {
	        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	      }
	    }
	  });
	
	  return parsed;
	};


/***/ },
/* 863 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Syntactic sugar for invoking a function and expanding an array for arguments.
	 *
	 * Common use case would be to use `Function.prototype.apply`.
	 *
	 *  ```js
	 *  function f(x, y, z) {}
	 *  var args = [1, 2, 3];
	 *  f.apply(null, args);
	 *  ```
	 *
	 * With `spread` this example can be re-written.
	 *
	 *  ```js
	 *  spread(function(x, y, z) {})([1, 2, 3]);
	 *  ```
	 *
	 * @param {Function} callback
	 * @returns {Function}
	 */
	module.exports = function spread(callback) {
	  return function wrap(arr) {
	    return callback.apply(null, arr);
	  };
	};


/***/ },
/* 864 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var pkg = __webpack_require__(1313);
	
	var validators = {};
	
	// eslint-disable-next-line func-names
	['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function(type, i) {
	  validators[type] = function validator(thing) {
	    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
	  };
	});
	
	var deprecatedWarnings = {};
	var currentVerArr = pkg.version.split('.');
	
	/**
	 * Compare package versions
	 * @param {string} version
	 * @param {string?} thanVersion
	 * @returns {boolean}
	 */
	function isOlderVersion(version, thanVersion) {
	  var pkgVersionArr = thanVersion ? thanVersion.split('.') : currentVerArr;
	  var destVer = version.split('.');
	  for (var i = 0; i < 3; i++) {
	    if (pkgVersionArr[i] > destVer[i]) {
	      return true;
	    } else if (pkgVersionArr[i] < destVer[i]) {
	      return false;
	    }
	  }
	  return false;
	}
	
	/**
	 * Transitional option validator
	 * @param {function|boolean?} validator
	 * @param {string?} version
	 * @param {string} message
	 * @returns {function}
	 */
	validators.transitional = function transitional(validator, version, message) {
	  var isDeprecated = version && isOlderVersion(version);
	
	  function formatMessage(opt, desc) {
	    return '[Axios v' + pkg.version + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
	  }
	
	  // eslint-disable-next-line func-names
	  return function(value, opt, opts) {
	    if (validator === false) {
	      throw new Error(formatMessage(opt, ' has been removed in ' + version));
	    }
	
	    if (isDeprecated && !deprecatedWarnings[opt]) {
	      deprecatedWarnings[opt] = true;
	      // eslint-disable-next-line no-console
	      console.warn(
	        formatMessage(
	          opt,
	          ' has been deprecated since v' + version + ' and will be removed in the near future'
	        )
	      );
	    }
	
	    return validator ? validator(value, opt, opts) : true;
	  };
	};
	
	/**
	 * Assert object's properties type
	 * @param {object} options
	 * @param {object} schema
	 * @param {boolean?} allowUnknown
	 */
	
	function assertOptions(options, schema, allowUnknown) {
	  if (typeof options !== 'object') {
	    throw new TypeError('options must be an object');
	  }
	  var keys = Object.keys(options);
	  var i = keys.length;
	  while (i-- > 0) {
	    var opt = keys[i];
	    var validator = schema[opt];
	    if (validator) {
	      var value = options[opt];
	      var result = value === undefined || validator(value, opt, options);
	      if (result !== true) {
	        throw new TypeError('option ' + opt + ' must be ' + result);
	      }
	      continue;
	    }
	    if (allowUnknown !== true) {
	      throw Error('Unknown option ' + opt);
	    }
	  }
	}
	
	module.exports = {
	  isOlderVersion: isOlderVersion,
	  assertOptions: assertOptions,
	  validators: validators
	};


/***/ },
/* 865 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1263);
	
	__webpack_require__(1269);
	
	var _reactRouterDom = __webpack_require__(296);
	
	var _login = __webpack_require__(950);
	
	var _login2 = _interopRequireDefault(_login);
	
	var _loginexcl = __webpack_require__(951);
	
	var _loginexcl2 = _interopRequireDefault(_loginexcl);
	
	var _courselogin = __webpack_require__(910);
	
	var _courselogin2 = _interopRequireDefault(_courselogin);
	
	var _dashboard = __webpack_require__(917);
	
	var _dashboard2 = _interopRequireDefault(_dashboard);
	
	var _dashboardV = __webpack_require__(919);
	
	var _dashboardV2 = _interopRequireDefault(_dashboardV);
	
	var _singleReport = __webpack_require__(1015);
	
	var _singleReport2 = _interopRequireDefault(_singleReport);
	
	var _reports = __webpack_require__(1011);
	
	var _reports2 = _interopRequireDefault(_reports);
	
	var _dashboardNew = __webpack_require__(918);
	
	var _dashboardNew2 = _interopRequireDefault(_dashboardNew);
	
	var _verticalSchool = __webpack_require__(1036);
	
	var _verticalSchool2 = _interopRequireDefault(_verticalSchool);
	
	var _verticalSchoolEdit = __webpack_require__(1038);
	
	var _verticalSchoolEdit2 = _interopRequireDefault(_verticalSchoolEdit);
	
	var _verticalSchoolDetail = __webpack_require__(1037);
	
	var _verticalSchoolDetail2 = _interopRequireDefault(_verticalSchoolDetail);
	
	var _verticalPreSchool = __webpack_require__(1033);
	
	var _verticalPreSchool2 = _interopRequireDefault(_verticalPreSchool);
	
	var _verticalPreSchoolEdit = __webpack_require__(1035);
	
	var _verticalPreSchoolEdit2 = _interopRequireDefault(_verticalPreSchoolEdit);
	
	var _verticalPreSchoolDetail = __webpack_require__(1034);
	
	var _verticalPreSchoolDetail2 = _interopRequireDefault(_verticalPreSchoolDetail);
	
	var _verticalTuitions = __webpack_require__(1041);
	
	var _verticalTuitions2 = _interopRequireDefault(_verticalTuitions);
	
	var _verticalTuitionEdit = __webpack_require__(1040);
	
	var _verticalTuitionEdit2 = _interopRequireDefault(_verticalTuitionEdit);
	
	var _verticalTuitionDetail = __webpack_require__(1039);
	
	var _verticalTuitionDetail2 = _interopRequireDefault(_verticalTuitionDetail);
	
	var _verticalAFA = __webpack_require__(1019);
	
	var _verticalAFA2 = _interopRequireDefault(_verticalAFA);
	
	var _verticalAFAEdit = __webpack_require__(1021);
	
	var _verticalAFAEdit2 = _interopRequireDefault(_verticalAFAEdit);
	
	var _verticalAFADetail = __webpack_require__(1020);
	
	var _verticalAFADetail2 = _interopRequireDefault(_verticalAFADetail);
	
	var _verticalCamps = __webpack_require__(1022);
	
	var _verticalCamps2 = _interopRequireDefault(_verticalCamps);
	
	var _verticalCampsEdit = __webpack_require__(1024);
	
	var _verticalCampsEdit2 = _interopRequireDefault(_verticalCampsEdit);
	
	var _verticalCampsDetail = __webpack_require__(1023);
	
	var _verticalCampsDetail2 = _interopRequireDefault(_verticalCampsDetail);
	
	var _verticalCommunity = __webpack_require__(1025);
	
	var _verticalCommunity2 = _interopRequireDefault(_verticalCommunity);
	
	var _verticalCommunityEdit = __webpack_require__(1027);
	
	var _verticalCommunityEdit2 = _interopRequireDefault(_verticalCommunityEdit);
	
	var _verticalCommunityDetail = __webpack_require__(1026);
	
	var _verticalCommunityDetail2 = _interopRequireDefault(_verticalCommunityDetail);
	
	var _verticalKidsPlayArea = __webpack_require__(1031);
	
	var _verticalKidsPlayArea2 = _interopRequireDefault(_verticalKidsPlayArea);
	
	var _verticalKidsPlayAreaEdit = __webpack_require__(1032);
	
	var _verticalKidsPlayAreaEdit2 = _interopRequireDefault(_verticalKidsPlayAreaEdit);
	
	var _verticalEvents = __webpack_require__(1028);
	
	var _verticalEvents2 = _interopRequireDefault(_verticalEvents);
	
	var _verticalEventsEdit = __webpack_require__(1030);
	
	var _verticalEventsEdit2 = _interopRequireDefault(_verticalEventsEdit);
	
	var _verticalEventsDetail = __webpack_require__(1029);
	
	var _verticalEventsDetail2 = _interopRequireDefault(_verticalEventsDetail);
	
	var _cmsMails = __webpack_require__(906);
	
	var _cmsMails2 = _interopRequireDefault(_cmsMails);
	
	var _cmsEditMail = __webpack_require__(903);
	
	var _cmsEditMail2 = _interopRequireDefault(_cmsEditMail);
	
	var _webAds = __webpack_require__(1042);
	
	var _webAds2 = _interopRequireDefault(_webAds);
	
	var _leadList = __webpack_require__(948);
	
	var _leadList2 = _interopRequireDefault(_leadList);
	
	var _leadDetail = __webpack_require__(947);
	
	var _leadDetail2 = _interopRequireDefault(_leadDetail);
	
	var _leadStats = __webpack_require__(949);
	
	var _leadStats2 = _interopRequireDefault(_leadStats);
	
	var _enquiriesList = __webpack_require__(928);
	
	var _enquiriesList2 = _interopRequireDefault(_enquiriesList);
	
	var _enquiryDetail = __webpack_require__(929);
	
	var _enquiryDetail2 = _interopRequireDefault(_enquiryDetail);
	
	var _cmsSiteContents = __webpack_require__(908);
	
	var _cmsSiteContents2 = _interopRequireDefault(_cmsSiteContents);
	
	var _cmsEvents = __webpack_require__(904);
	
	var _cmsEvents2 = _interopRequireDefault(_cmsEvents);
	
	var _cmsInsights = __webpack_require__(905);
	
	var _cmsInsights2 = _interopRequireDefault(_cmsInsights);
	
	var _cmsNews = __webpack_require__(907);
	
	var _cmsNews2 = _interopRequireDefault(_cmsNews);
	
	var _cmsAddNews = __webpack_require__(902);
	
	var _cmsAddNews2 = _interopRequireDefault(_cmsAddNews);
	
	var _cmsSpecialGuests = __webpack_require__(909);
	
	var _cmsSpecialGuests2 = _interopRequireDefault(_cmsSpecialGuests);
	
	var _cmsAddEditSpecialGuest = __webpack_require__(901);
	
	var _cmsAddEditSpecialGuest2 = _interopRequireDefault(_cmsAddEditSpecialGuest);
	
	var _cmsAddEditInsight = __webpack_require__(900);
	
	var _cmsAddEditInsight2 = _interopRequireDefault(_cmsAddEditInsight);
	
	var _customMails = __webpack_require__(916);
	
	var _customMails2 = _interopRequireDefault(_customMails);
	
	var _paymentlinks = __webpack_require__(1006);
	
	var _paymentlinks2 = _interopRequireDefault(_paymentlinks);
	
	var _paymentsLinksDetail = __webpack_require__(1007);
	
	var _paymentsLinksDetail2 = _interopRequireDefault(_paymentsLinksDetail);
	
	var _transactions = __webpack_require__(1017);
	
	var _transactions2 = _interopRequireDefault(_transactions);
	
	var _transactionDetail = __webpack_require__(1016);
	
	var _transactionDetail2 = _interopRequireDefault(_transactionDetail);
	
	var _paymentInfo = __webpack_require__(1005);
	
	var _paymentInfo2 = _interopRequireDefault(_paymentInfo);
	
	var _partnerStats = __webpack_require__(957);
	
	var _partnerStats2 = _interopRequireDefault(_partnerStats);
	
	var _parentList = __webpack_require__(954);
	
	var _parentList2 = _interopRequireDefault(_parentList);
	
	var _parentDetail = __webpack_require__(953);
	
	var _parentDetail2 = _interopRequireDefault(_parentDetail);
	
	var _partnerList = __webpack_require__(956);
	
	var _partnerList2 = _interopRequireDefault(_partnerList);
	
	var _partnerDetail = __webpack_require__(955);
	
	var _partnerDetail2 = _interopRequireDefault(_partnerDetail);
	
	var _partnerList3 = __webpack_require__(1018);
	
	var _partnerList4 = _interopRequireDefault(_partnerList3);
	
	var _exclusivePartnerList = __webpack_require__(935);
	
	var _exclusivePartnerList2 = _interopRequireDefault(_exclusivePartnerList);
	
	var _exclusiveUserEdit = __webpack_require__(936);
	
	var _exclusiveUserEdit2 = _interopRequireDefault(_exclusiveUserEdit);
	
	var _exclusiveParterView = __webpack_require__(932);
	
	var _exclusiveParterView2 = _interopRequireDefault(_exclusiveParterView);
	
	var _exclusiveParterViewB2B = __webpack_require__(933);
	
	var _exclusiveParterViewB2B2 = _interopRequireDefault(_exclusiveParterViewB2B);
	
	var _exclusiveParterViewB2C = __webpack_require__(934);
	
	var _exclusiveParterViewB2C2 = _interopRequireDefault(_exclusiveParterViewB2C);
	
	var _bewiseUsers = __webpack_require__(896);
	
	var _bewiseUsers2 = _interopRequireDefault(_bewiseUsers);
	
	var _bewiseUsersEdit = __webpack_require__(897);
	
	var _bewiseUsersEdit2 = _interopRequireDefault(_bewiseUsersEdit);
	
	var _generalImages = __webpack_require__(944);
	
	var _generalImages2 = _interopRequireDefault(_generalImages);
	
	var _generalCities = __webpack_require__(942);
	
	var _generalCities2 = _interopRequireDefault(_generalCities);
	
	var _generalLocalities = __webpack_require__(945);
	
	var _generalLocalities2 = _interopRequireDefault(_generalLocalities);
	
	var _generalContacts = __webpack_require__(943);
	
	var _generalContacts2 = _interopRequireDefault(_generalContacts);
	
	var _bewisetotal = __webpack_require__(899);
	
	var _bewisetotal2 = _interopRequireDefault(_bewisetotal);
	
	var _adminRoles = __webpack_require__(892);
	
	var _adminRoles2 = _interopRequireDefault(_adminRoles);
	
	var _adminAddRole = __webpack_require__(889);
	
	var _adminAddRole2 = _interopRequireDefault(_adminAddRole);
	
	var _adminGst = __webpack_require__(890);
	
	var _adminGst2 = _interopRequireDefault(_adminGst);
	
	var _adminPackages = __webpack_require__(891);
	
	var _adminPackages2 = _interopRequireDefault(_adminPackages);
	
	var _editPackage = __webpack_require__(927);
	
	var _editPackage2 = _interopRequireDefault(_editPackage);
	
	var _promoCodes = __webpack_require__(1008);
	
	var _promoCodes2 = _interopRequireDefault(_promoCodes);
	
	var _resourceList = __webpack_require__(1012);
	
	var _resourceList2 = _interopRequireDefault(_resourceList);
	
	var _bewiseCuratedCamps = __webpack_require__(894);
	
	var _bewiseCuratedCamps2 = _interopRequireDefault(_bewiseCuratedCamps);
	
	var _bewiseEditCuratedCamp = __webpack_require__(895);
	
	var _bewiseEditCuratedCamp2 = _interopRequireDefault(_bewiseEditCuratedCamp);
	
	var _bewiseViewPaymentCamp = __webpack_require__(898);
	
	var _bewiseViewPaymentCamp2 = _interopRequireDefault(_bewiseViewPaymentCamp);
	
	var _profile = __webpack_require__(993);
	
	var _profile2 = _interopRequireDefault(_profile);
	
	var _profileNew = __webpack_require__(994);
	
	var _profileNew2 = _interopRequireDefault(_profileNew);
	
	var _dashboard3 = __webpack_require__(979);
	
	var _dashboard4 = _interopRequireDefault(_dashboard3);
	
	var _dashboardV3 = __webpack_require__(980);
	
	var _dashboardV4 = _interopRequireDefault(_dashboardV3);
	
	var _reports3 = __webpack_require__(995);
	
	var _reports4 = _interopRequireDefault(_reports3);
	
	var _accountinfoV = __webpack_require__(960);
	
	var _accountinfoV2 = _interopRequireDefault(_accountinfoV);
	
	var _accountinfonew = __webpack_require__(961);
	
	var _accountinfonew2 = _interopRequireDefault(_accountinfonew);
	
	var _subscriptioninfo = __webpack_require__(1000);
	
	var _subscriptioninfo2 = _interopRequireDefault(_subscriptioninfo);
	
	var _subscriptioninfov = __webpack_require__(1001);
	
	var _subscriptioninfov2 = _interopRequireDefault(_subscriptioninfov);
	
	var _benchmarking = __webpack_require__(975);
	
	var _benchmarking2 = _interopRequireDefault(_benchmarking);
	
	var _news = __webpack_require__(984);
	
	var _news2 = _interopRequireDefault(_news);
	
	var _jobposting = __webpack_require__(983);
	
	var _jobposting2 = _interopRequireDefault(_jobposting);
	
	var _compare = __webpack_require__(967);
	
	var _compare2 = _interopRequireDefault(_compare);
	
	var _transactions3 = __webpack_require__(1004);
	
	var _transactions4 = _interopRequireDefault(_transactions3);
	
	var _paymentlinks3 = __webpack_require__(992);
	
	var _paymentlinks4 = _interopRequireDefault(_paymentlinks3);
	
	var _branches = __webpack_require__(978);
	
	var _branches2 = _interopRequireDefault(_branches);
	
	var _articles = __webpack_require__(962);
	
	var _articles2 = _interopRequireDefault(_articles);
	
	var _review = __webpack_require__(996);
	
	var _review2 = _interopRequireDefault(_review);
	
	var _exclusivepartnerships = __webpack_require__(981);
	
	var _exclusivepartnerships2 = _interopRequireDefault(_exclusivepartnerships);
	
	var _ins_landingpage = __webpack_require__(874);
	
	var _ins_landingpage2 = _interopRequireDefault(_ins_landingpage);
	
	var _plans_schoolspreschools = __webpack_require__(876);
	
	var _plans_schoolspreschools2 = _interopRequireDefault(_plans_schoolspreschools);
	
	var _plans_individualandinstitutions = __webpack_require__(875);
	
	var _plans_individualandinstitutions2 = _interopRequireDefault(_plans_individualandinstitutions);
	
	var _ind_landingpage = __webpack_require__(873);
	
	var _ind_landingpage2 = _interopRequireDefault(_ind_landingpage);
	
	var _institutional_signup = __webpack_require__(882);
	
	var _institutional_signup2 = _interopRequireDefault(_institutional_signup);
	
	var _individual_signup = __webpack_require__(881);
	
	var _individual_signup2 = _interopRequireDefault(_individual_signup);
	
	var _individual_complete = __webpack_require__(880);
	
	var _individual_complete2 = _interopRequireDefault(_individual_complete);
	
	var _about = __webpack_require__(868);
	
	var _about2 = _interopRequireDefault(_about);
	
	var _privacy = __webpack_require__(870);
	
	var _privacy2 = _interopRequireDefault(_privacy);
	
	var _faq = __webpack_require__(869);
	
	var _faq2 = _interopRequireDefault(_faq);
	
	var _unsubscribe = __webpack_require__(872);
	
	var _unsubscribe2 = _interopRequireDefault(_unsubscribe);
	
	var _forget = __webpack_require__(877);
	
	var _forget2 = _interopRequireDefault(_forget);
	
	var _forget_excl = __webpack_require__(878);
	
	var _forget_excl2 = _interopRequireDefault(_forget_excl);
	
	var _termsconditions = __webpack_require__(871);
	
	var _termsconditions2 = _interopRequireDefault(_termsconditions);
	
	var _register = __webpack_require__(879);
	
	var _register2 = _interopRequireDefault(_register);
	
	var _subscriberslist = __webpack_require__(1061);
	
	var _subscriberslist2 = _interopRequireDefault(_subscriberslist);
	
	var _registeredUserList = __webpack_require__(1060);
	
	var _registeredUserList2 = _interopRequireDefault(_registeredUserList);
	
	var _newsLetterSubscribersList = __webpack_require__(1057);
	
	var _newsLetterSubscribersList2 = _interopRequireDefault(_newsLetterSubscribersList);
	
	var _auroscholars = __webpack_require__(931);
	
	var _auroscholars2 = _interopRequireDefault(_auroscholars);
	
	var _dashboard5 = __webpack_require__(1052);
	
	var _dashboard6 = _interopRequireDefault(_dashboard5);
	
	var _postajob = __webpack_require__(1059);
	
	var _postajob2 = _interopRequireDefault(_postajob);
	
	var _viewjob = __webpack_require__(1065);
	
	var _viewjob2 = _interopRequireDefault(_viewjob);
	
	var _advisory = __webpack_require__(1047);
	
	var _advisory2 = _interopRequireDefault(_advisory);
	
	var _talentsearch = __webpack_require__(1062);
	
	var _talentsearch2 = _interopRequireDefault(_talentsearch);
	
	var _viewprofile = __webpack_require__(1066);
	
	var _viewprofile2 = _interopRequireDefault(_viewprofile);
	
	var _userprofile = __webpack_require__(1063);
	
	var _userprofile2 = _interopRequireDefault(_userprofile);
	
	var _downloadprofile = __webpack_require__(1053);
	
	var _downloadprofile2 = _interopRequireDefault(_downloadprofile);
	
	var _applicants = __webpack_require__(1048);
	
	var _applicants2 = _interopRequireDefault(_applicants);
	
	var _othercourses = __webpack_require__(1058);
	
	var _othercourses2 = _interopRequireDefault(_othercourses);
	
	var _addothercourse = __webpack_require__(1046);
	
	var _addothercourse2 = _interopRequireDefault(_addothercourse);
	
	var _courses = __webpack_require__(1050);
	
	var _courses2 = _interopRequireDefault(_courses);
	
	var _addcourse = __webpack_require__(1044);
	
	var _addcourse2 = _interopRequireDefault(_addcourse);
	
	var _viewcourse = __webpack_require__(1064);
	
	var _viewcourse2 = _interopRequireDefault(_viewcourse);
	
	var _dashboard7 = __webpack_require__(938);
	
	var _dashboard8 = _interopRequireDefault(_dashboard7);
	
	var _exclusivePartnerEdit = __webpack_require__(939);
	
	var _exclusivePartnerEdit2 = _interopRequireDefault(_exclusivePartnerEdit);
	
	var _exclusivePartnerParentEdit = __webpack_require__(940);
	
	var _exclusivePartnerParentEdit2 = _interopRequireDefault(_exclusivePartnerParentEdit);
	
	var _exclusivePartnerPartnerEdit = __webpack_require__(941);
	
	var _exclusivePartnerPartnerEdit2 = _interopRequireDefault(_exclusivePartnerPartnerEdit);
	
	var _schoolList = __webpack_require__(925);
	
	var _schoolList2 = _interopRequireDefault(_schoolList);
	
	var _preSchoolList = __webpack_require__(924);
	
	var _preSchoolList2 = _interopRequireDefault(_preSchoolList);
	
	var _tuitionList = __webpack_require__(926);
	
	var _tuitionList2 = _interopRequireDefault(_tuitionList);
	
	var _afterschoolList = __webpack_require__(920);
	
	var _afterschoolList2 = _interopRequireDefault(_afterschoolList);
	
	var _learningcampsList = __webpack_require__(923);
	
	var _learningcampsList2 = _interopRequireDefault(_learningcampsList);
	
	var _kidsplayareaList = __webpack_require__(922);
	
	var _kidsplayareaList2 = _interopRequireDefault(_kidsplayareaList);
	
	var _communityList = __webpack_require__(921);
	
	var _communityList2 = _interopRequireDefault(_communityList);
	
	var _invoice_new = __webpack_require__(982);
	
	var _invoice_new2 = _interopRequireDefault(_invoice_new);
	
	var _dashboard9 = __webpack_require__(912);
	
	var _dashboard10 = _interopRequireDefault(_dashboard9);
	
	var _addcourse3 = __webpack_require__(911);
	
	var _addcourse4 = _interopRequireDefault(_addcourse3);
	
	var _editcourse = __webpack_require__(913);
	
	var _editcourse2 = _interopRequireDefault(_editcourse);
	
	var _listcourses = __webpack_require__(914);
	
	var _listcourses2 = _interopRequireDefault(_listcourses);
	
	var _jobs = __webpack_require__(1056);
	
	var _jobs2 = _interopRequireDefault(_jobs);
	
	var _addjob = __webpack_require__(1045);
	
	var _addjob2 = _interopRequireDefault(_addjob);
	
	var _editjob = __webpack_require__(1055);
	
	var _editjob2 = _interopRequireDefault(_editjob);
	
	var _blogs = __webpack_require__(1049);
	
	var _blogs2 = _interopRequireDefault(_blogs);
	
	var _addblog = __webpack_require__(1043);
	
	var _addblog2 = _interopRequireDefault(_addblog);
	
	var _editblog = __webpack_require__(1054);
	
	var _editblog2 = _interopRequireDefault(_editblog);
	
	var _createprovider = __webpack_require__(1051);
	
	var _createprovider2 = _interopRequireDefault(_createprovider);
	
	var _new_partner_institutions = __webpack_require__(866);
	
	var _new_partner_institutions2 = _interopRequireDefault(_new_partner_institutions);
	
	var _new_partner_institutionsv = __webpack_require__(867);
	
	var _new_partner_institutionsv2 = _interopRequireDefault(_new_partner_institutionsv);
	
	var _reportV = __webpack_require__(1009);
	
	var _reportV2 = _interopRequireDefault(_reportV);
	
	var _reportV3 = __webpack_require__(1010);
	
	var _reportV4 = _interopRequireDefault(_reportV3);
	
	var _branchadd = __webpack_require__(977);
	
	var _branchadd2 = _interopRequireDefault(_branchadd);
	
	var _restart = __webpack_require__(1013);
	
	var _restart2 = _interopRequireDefault(_restart);
	
	var _azupload = __webpack_require__(893);
	
	var _azupload2 = _interopRequireDefault(_azupload);
	
	var _notFound = __webpack_require__(952);
	
	var _notFound2 = _interopRequireDefault(_notFound);
	
	__webpack_require__(1264);
	
	__webpack_require__(1270);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* User Pages */
	function App() {
	  return _react2.default.createElement(
	    _reactRouterDom.BrowserRouter,
	    null,
	    _react2.default.createElement(
	      _reactRouterDom.Switch,
	      null,
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/', exact: true, component: _login2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/login', exact: true, component: _login2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/admin_login', exact: true, component: _login2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/excl_login', exact: true, component: _loginexcl2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/courselogin', exact: true, component: _courselogin2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/courses/dashboard', exact: true, component: _dashboard10.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/courses/listcourses', exact: true, component: _listcourses2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/courses/addcourse', exact: true, component: _addcourse4.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/courses/editcourse/:id', exact: true, component: _editcourse2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/dashboard/dashboard', exact: true, component: _dashboard2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/dashboard/dashboardV1', exact: true, component: _dashboardV2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/dashboard/dashboard/bewisetotal', exact: true, component: _bewisetotal2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/dashboard/reports', exact: true, component: _reports2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/dashboard/reportsnew', exact: true, component: _dashboardNew2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/dashboard/singlereport/:id', exact: true, component: _singleReport2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/vertical/school', exact: true, component: _verticalSchool2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/vertical/school/add', exact: true, component: _verticalSchoolEdit2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/vertical/school/updateschools/:id', exact: true, component: _verticalSchoolEdit2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/vertical/school/schooldetail/:id', exact: true, component: _verticalSchoolDetail2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/vertical/preschool', exact: true, component: _verticalPreSchool2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/vertical/preschool/add', exact: true, component: _verticalPreSchoolEdit2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/vertical/preschool/update/:id', exact: true, component: _verticalPreSchoolEdit2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/vertical/preschool/detail/:id', exact: true, component: _verticalPreSchoolDetail2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/vertical/tuitions', exact: true, component: _verticalTuitions2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/vertical/tuitions/add', exact: true, component: _verticalTuitionEdit2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/vertical/tuition/add', exact: true, component: _verticalTuitionEdit2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/vertical/tuitions/update/:id', exact: true, component: _verticalTuitionEdit2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/vertical/tuitions/detail/:id', exact: true, component: _verticalTuitionDetail2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/vertical/afterschoolactivities', exact: true, component: _verticalAFA2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/vertical/afterschoolactivities/add/:id/:type', exact: true, component: _verticalAFAEdit2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/vertical/afterschoolactivities/update/:id/:type/:token', exact: true, component: _verticalAFAEdit2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/vertical/afterschoolactivities/detail/:id', exact: true, component: _verticalAFADetail2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/vertical/learningcamps', exact: true, component: _verticalCamps2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/vertical/learningcamps/add', exact: true, component: _verticalCampsEdit2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/vertical/learningcamps/update/:id', exact: true, component: _verticalCampsEdit2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/vertical/learningcamps/detail/:id', exact: true, component: _verticalCampsDetail2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/vertical/kidsplayarea', exact: true, component: _verticalKidsPlayArea2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/vertical/kidsplayarea/add', exact: true, component: _verticalKidsPlayAreaEdit2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/vertical/kidsplayarea/update/:id', exact: true, component: _verticalKidsPlayAreaEdit2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/vertical/communitysupports', exact: true, component: _verticalCommunity2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/vertical/communitysupports/add', exact: true, component: _verticalCommunityEdit2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/vertical/communitysupports/update/:id', exact: true, component: _verticalCommunityEdit2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/vertical/communitysupports/detail/:id', exact: true, component: _verticalCommunityDetail2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/vertical/birthdayevents', exact: true, component: _verticalEvents2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/vertical/birthdayevents/add', exact: true, component: _verticalEventsEdit2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/vertical/birthdayevents/update/:ids/:seditid', exact: true, component: _verticalEventsEdit2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/vertical/birthdayevents/detail/:id', exact: true, component: _verticalEventsDetail2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/vertical/afterschoolactivities/add', exact: true, component: _verticalAFAEdit2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/cms/insights', exact: true, component: _cmsInsights2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/cms/insights/addinsight', exact: true, component: _cmsAddEditInsight2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/cms/insights/edit-blog/:id', exact: true, component: _cmsAddEditInsight2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/cms/mails', exact: true, component: _cmsMails2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/cms/sitecontents', exact: true, component: _cmsSiteContents2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/cms/events', exact: true, component: _cmsEvents2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/cms/websiteads', exact: true, component: _webAds2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/cms/specialguests', exact: true, component: _cmsSpecialGuests2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/cms/specialguests/add', exact: true, component: _cmsAddEditSpecialGuest2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/cms/specialguests/edit/:id', exact: true, component: _cmsAddEditSpecialGuest2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/cms/news', exact: true, component: _cmsNews2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/cms/news/addnews', exact: true, component: _cmsAddNews2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/cms/news/editnews/:id', exact: true, component: _cmsAddNews2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/leads/leadlist', exact: true, component: _leadList2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/leads/leadDetail/:id', exact: true, component: _leadDetail2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/leads/stats', exact: true, component: _leadStats2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/enquiry/enquiries', exact: true, component: _enquiriesList2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/enquiry/enquiryDetail/:id', exact: true, component: _enquiryDetail2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/cms/mail/edit/:id', exact: true, component: _cmsEditMail2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/general/images', exact: true, component: _generalImages2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/general/localities', exact: true, component: _generalLocalities2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/general/cities', exact: true, component: _generalCities2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/general/contacts', exact: true, component: _generalContacts2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/admin/roles', exact: true, component: _adminRoles2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/admin/roles/add', exact: true, component: _adminAddRole2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/admin/roles/edit/:id', exact: true, component: _adminAddRole2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/admin/gst', exact: true, component: _adminGst2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/admin/packages', exact: true, component: _adminPackages2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/admin/packages/edit/:id', exact: true, component: _editPackage2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/admin/promocode', exact: true, component: _promoCodes2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/admin/eventresources', exact: true, component: _resourceList2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/admin/custommails', exact: true, component: _customMails2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/admin/bewisecuratedcamps', exact: true, component: _bewiseCuratedCamps2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/admin/bewisecuratedcamps/edit/:camp_id', exact: true, component: _bewiseEditCuratedCamp2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/admin/bewisecuratedcamps/viewpayments/:camp_id', exact: true, component: _bewiseViewPaymentCamp2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/payments/paymentlinks', exact: true, component: _paymentlinks2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/payments/transactions', exact: true, component: _transactions2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/payments/paymentinfo', exact: true, component: _paymentInfo2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/payments/paymentlinks/rzpaylink_transaction_details/:id', exact: true, component: _paymentsLinksDetail2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/payments/transactions/transactiondetails/:id', exact: true, component: _transactionDetail2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/stats_partners', exact: true, component: _partnerStats2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/users/parents', exact: true, component: _parentList2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/users/parents/parentdetail/:id', exact: true, component: _parentDetail2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/users/partners', exact: true, component: _partnerList2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/users/partners/partnerDetail/:id', exact: true, component: _partnerDetail2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/trash/partners', exact: true, component: _partnerList4.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/users/exclusivepartners', exact: true, component: _exclusivePartnerList2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/users/exclusivepartners/update/:id', exact: true, component: _exclusiveUserEdit2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/users/exclusivepartners/viewexclusivepartership/:id', exact: true, component: _exclusiveParterView2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/users/exclusivepartners/viewexclusivepartership/b2b/:id', exact: true, component: _exclusiveParterViewB2B2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/users/exclusivepartners/viewexclusivepartership/b2c/:id', exact: true, component: _exclusiveParterViewB2C2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/users/exclusivepartners/add', exact: true, component: _exclusiveUserEdit2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/users/bewiseusers', exact: true, component: _bewiseUsers2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/users/bewiseusers/updatebewiseuser/:id', exact: true, component: _bewiseUsersEdit2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/users/bewiseusers/addbewiseuser', exact: true, component: _bewiseUsersEdit2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/exclusiveparnter/dashboard', exact: true, component: _dashboard8.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/exclusiveparnter/create_excl_parent', exact: true, component: _exclusivePartnerParentEdit2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/exclusiveparnter/edit_excl_parent/:id', exact: true, component: _exclusivePartnerParentEdit2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/exclusiveparnter/create_excl_partner', exact: true, component: _exclusivePartnerPartnerEdit2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/exclusiveparnter/edit_excl_partner/:id', exact: true, component: _exclusivePartnerPartnerEdit2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/exclusiveparnter/create_excl', exact: true, component: _exclusivePartnerEdit2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/exclusiveparnter/edit_excl/:id', exact: true, component: _exclusivePartnerEdit2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/institutionbk', exact: true, component: _ins_landingpage2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/individualbk', exact: true, component: _ind_landingpage2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/institution-partners', exact: true, component: _ins_landingpage2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/individual-partners', exact: true, component: _ind_landingpage2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/individual_signup', exact: true, component: _individual_signup2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/sign-up-individual-partner', exact: true, component: _individual_signup2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/sign-up-institution-partner', exact: true, component: _institutional_signup2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/indsignup/:token/:id', exact: true, component: _individual_complete2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/institution_signup', exact: true, component: _institutional_signup2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/about', exact: true, component: _about2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/forgot', exact: true, component: _forget2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/forgot_excl', exact: true, component: _forget_excl2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/forgot_excl/:ref/:token', exact: true, component: _forget_excl2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/forgot/:ref/:token', exact: true, component: _forget2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/register', exact: true, component: _register2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/termsconditions', exact: true, component: _termsconditions2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/privacy', exact: true, component: _privacy2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/faq', exact: true, component: _faq2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/unsubscribe/:token', component: _unsubscribe2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/partner/profile', exact: true, component: _profile2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/partner/profilenew', exact: true, component: _profileNew2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/partner/dashboard', exact: true, component: _dashboard4.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/partner/dashboardV1', exact: true, component: _dashboardV4.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/partner/reportV2', exact: true, component: _reportV2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/partner/reportV3', exact: true, component: _reportV4.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/partner/reports', exact: true, component: _reports4.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/partner/accountinfo', exact: true, component: _accountinfoV2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/partner/accountinfonew', exact: true, component: _accountinfonew2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/partner/subscriptioninfo', exact: true, component: _subscriptioninfov2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/partner/subscriptioninfov1', exact: true, component: _subscriptioninfov2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/partner/benchmarking', exact: true, component: _benchmarking2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/partner/news', exact: true, component: _news2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/partner/jobposting', exact: true, component: _jobposting2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/partner/bench_mark_view', exact: true, component: _compare2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/partner/transactions', exact: true, component: _transactions4.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/partner/paymentlinks', exact: true, component: _paymentlinks4.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/partner/branches', exact: true, component: _branches2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/partner/exclusivepartnerships', exact: true, component: _exclusivepartnerships2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/partner/articles', exact: true, component: _articles2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/partner/review', exact: true, component: _review2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/partner/view_invoice/:id', exact: true, component: _invoice_new2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/partner/wcdashboard', exact: true, component: _dashboard6.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/partner/wiseconnect/viewjob/:jobid', exact: true, component: _viewjob2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/partner/wcpostajob', exact: true, component: _postajob2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/partner/wctalentsearch', exact: true, component: _talentsearch2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/partner/applicants', exact: true, component: _applicants2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/partner/wiseconnect/applicants/:jobid', exact: true, component: _applicants2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/partner/wiseconnect/viewprofile/:id/:jobid', exact: true, component: _viewprofile2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/partner/wiseconnect/downloadprofile/:id', exact: true, component: _downloadprofile2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/partner/viewprofile', exact: true, component: _viewprofile2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/partner/wcadvisory', exact: true, component: _advisory2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/partner/wctalentsearch/viewprofile/:id', exact: true, component: _viewprofile2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/duplicates/duplicateinschool', exact: true, component: _schoolList2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/duplicates/duplicateinpreschool', exact: true, component: _preSchoolList2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/duplicates/duplicateintuition', exact: true, component: _tuitionList2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/duplicates/duplicateinafterschool', exact: true, component: _afterschoolList2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/duplicates/duplicateinkidsplayarea', exact: true, component: _kidsplayareaList2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/duplicates/duplicateinlearningcamps', exact: true, component: _learningcampsList2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/duplicates/duplicateincommunity', exact: true, component: _communityList2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/wiseconnect/subscriberslist', exact: true, component: _subscriberslist2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/wiseconnect/newslettersubscribers', exact: true, component: _newsLetterSubscribersList2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/wiseconnect/registeredusers', exact: true, component: _registeredUserList2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/wiseconnect/viewprofile/:id', exact: true, component: _userprofile2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/exclsignups/auroscholars', exact: true, component: _auroscholars2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/wiseconnect/othercourses', exact: true, component: _othercourses2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/wiseconnect/addothercourse', exact: true, component: _addothercourse2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/wiseconnect/courses', exact: true, component: _courses2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/wiseconnect/addcourse', exact: true, component: _addcourse2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/wiseconnect/viewcourse/:id', exact: true, component: _viewcourse2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/wiseconnect/jobs', exact: true, component: _jobs2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/wiseconnect/addjob', exact: true, component: _addjob2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/wiseconnect/editjob/:id', exact: true, component: _editjob2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/wiseconnect/externalblogs', exact: true, component: _blogs2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/wiseconnect/addblog', exact: true, component: _addblog2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/wiseconnect/editblog/:id', exact: true, component: _editblog2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/wiseconnect/createprovider', exact: true, component: _createprovider2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/partner/newsubscription', exact: true, component: _subscriptioninfo2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/plan_schoolpreschools', exact: true, component: _plans_schoolspreschools2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/plan_individualandinstitutions', exact: true, component: _plans_individualandinstitutions2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/plan_schoolpreschools/:wc', exact: true, component: _plans_schoolspreschools2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/bewisepartnerplans', component: function component() {
	          window.location.href = '/joinus';
	          return null;
	        } }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/joinus', exact: true, component: _new_partner_institutions2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/joinus_v1', exact: true, component: _new_partner_institutionsv2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/joinus/:type', exact: true, component: _new_partner_institutions2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/azblogtest/fileupload', exact: true, component: _azupload2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/partner/addbranch/:login_id', exact: true, component: _branchadd2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/restartapp', exact: true, component: _restart2.default }),
	      _react2.default.createElement(_reactRouterDom.Route, { path: '/:somerandom', exact: true, component: _notFound2.default, status: 404 })
	    )
	  );
	}
	
	/* partner pages  */
	
	
	/*Admin Access */
	
	
	/* Admin pages */
	
	
	/* CMS */
	exports.default = App;

/***/ },
/* 866 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _HeaderNew = __webpack_require__(358);
	
	var _HeaderNew2 = _interopRequireDefault(_HeaderNew);
	
	var _FooterNew = __webpack_require__(357);
	
	var _FooterNew2 = _interopRequireDefault(_FooterNew);
	
	var _Footer = __webpack_require__(82);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _backArrowDark = __webpack_require__(123);
	
	var _backArrowDark2 = _interopRequireDefault(_backArrowDark);
	
	var _chartImage = __webpack_require__(136);
	
	var _chartImage2 = _interopRequireDefault(_chartImage);
	
	var _miniArrow = __webpack_require__(124);
	
	var _miniArrow2 = _interopRequireDefault(_miniArrow);
	
	var _reactSlick = __webpack_require__(93);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	__webpack_require__(122);
	
	__webpack_require__(121);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _FetchCall = __webpack_require__(4);
	
	var _reactstrap = __webpack_require__(17);
	
	var _ModalHeader = __webpack_require__(102);
	
	var _ModalHeader2 = _interopRequireDefault(_ModalHeader);
	
	var _reactHelmet = __webpack_require__(77);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import { Scrollbar } from 'react-scrollbars-custom';
	
	var CurrencyFormat = __webpack_require__(112);
	
	var benefits = [_react2.default.createElement(
	  "ul",
	  null,
	  _react2.default.createElement(
	    "li",
	    null,
	    "200-word write-up about yourself and services offered on your page."
	  ),
	  _react2.default.createElement(
	    "li",
	    null,
	    "Manage your profile page frequently to improve brand and visibility."
	  ),
	  _react2.default.createElement(
	    "li",
	    null,
	    "Upload up to 8 images on your profile page."
	  ),
	  _react2.default.createElement(
	    "li",
	    null,
	    "Post your social media link(s) on your page."
	  ),
	  _react2.default.createElement(
	    "li",
	    null,
	    "Email interaction with prospective parents."
	  ),
	  _react2.default.createElement(
	    "li",
	    null,
	    "Respond to users on their feedback."
	  ),
	  _react2.default.createElement(
	    "li",
	    null,
	    "Upload videos links to showcase excellence."
	  ),
	  _react2.default.createElement(
	    "li",
	    null,
	    "Publish two articles a year on thought leadership."
	  )
	), _react2.default.createElement(
	  "ul",
	  null,
	  _react2.default.createElement(
	    "li",
	    null,
	    "400-word write-up about yourself and services offered on your page."
	  ),
	  _react2.default.createElement(
	    "li",
	    null,
	    "Manage your profile page frequently to improve brand and visibility."
	  ),
	  _react2.default.createElement(
	    "li",
	    null,
	    "Upload up to 15 images on your profile page."
	  ),
	  _react2.default.createElement(
	    "li",
	    null,
	    "Post your social media link(s) on your page."
	  ),
	  _react2.default.createElement(
	    "li",
	    null,
	    "Drive showcase you in some of our social media."
	  ),
	  _react2.default.createElement(
	    "li",
	    null,
	    "Email interaction with prospective parents."
	  ),
	  _react2.default.createElement(
	    "li",
	    null,
	    "Upload videos links to showcase excellence."
	  ),
	  _react2.default.createElement(
	    "li",
	    null,
	    "Publish two articles a year on thought leadership."
	  )
	)];
	
	var NewPartnerInstitutionPage = function (_Component) {
	  _inherits(NewPartnerInstitutionPage, _Component);
	
	  function NewPartnerInstitutionPage(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, NewPartnerInstitutionPage);
	
	    var _this = _possibleConstructorReturn(this, (NewPartnerInstitutionPage.__proto__ || Object.getPrototypeOf(NewPartnerInstitutionPage)).call(this, props));
	
	    _this.showValuePrice = function () {
	      _this.setState({ isValuePriceClikedView: true });
	    };
	
	    _this.showStandardPrice1 = function () {
	      _this.setState({ isStandardPriceClikedView1: true });
	    };
	
	    _this.showStandardPrice2 = function () {
	      _this.setState({ isStandardPriceClikedView2: true });
	    };
	
	    _this.showMagicPrice = function () {
	      _this.setState({ isMagicPriceClikedView: true });
	    };
	
	    _this.openTab1 = function () {
	      _this.setState({ schoolpreschoolselected: true, otherselected: false });
	      (0, _jquery2.default)("#tab1").addClass('active');
	      (0, _jquery2.default)("#tab2").removeClass('active');
	      (0, _jquery2.default)(".tabby-content-1").removeClass('hidden');
	      (0, _jquery2.default)(".tabby-content-2").addClass('hidden');
	      (0, _jquery2.default)(".tabby-content-1").css('opacity', '1.0');
	    };
	
	    _this.openTab2 = function () {
	      _this.setState({ otherselected: true, schoolpreschoolselected: false });
	      (0, _jquery2.default)("#tab2").addClass('active');
	      (0, _jquery2.default)("#tab1").removeClass('active');
	      (0, _jquery2.default)(".tabby-content-1").addClass('hidden');
	      (0, _jquery2.default)(".tabby-content-2").removeClass('hidden');
	      (0, _jquery2.default)(".tabby-content-2").css('opacity', '1.0');
	    };
	
	    _this.getPlanList = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var planData;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              planData = JSON.stringify({
	                user_type: 1
	              });
	
	
	              (0, _FetchCall.getPlan)(planData).then(function (response) {
	                if (response.status == 1) {
	                  _this.setState({
	                    plan_list2: response.results
	                  });
	                } else {
	                  console.log('else');
	                }
	              });
	
	            case 2:
	            case "end":
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    }));
	
	    _this.handlePlan = function (id) {
	      var plan_info = _this.state.plan_list2.filter(function (o) {
	        return o.id == id;
	      });
	      console.log('plan_info', plan_info);
	      _this.setState({
	        current_plan: plan_info,
	        plan_id: id,
	        offerModal: true,
	        analyticsModal: false
	      });
	      setTimeout(function () {
	        (0, _jquery2.default)(".modal").addClass("in");
	      }, 500);
	    };
	
	    _this.analyticsOffer = function () {
	      _this.setState({
	        offerModal: false,
	        analyticsModal: true
	      });
	      setTimeout(function () {
	        (0, _jquery2.default)(".modal").addClass("in");
	      }, 500);
	    };
	
	    _this.backToOffer = function () {
	      _this.setState({
	        offerModal: true,
	        analyticsModal: false
	      });
	      setTimeout(function () {
	        (0, _jquery2.default)(".modal").addClass("in");
	      }, 500);
	    };
	
	    _this.backToSlide = function () {
	      _this.setState({
	        offerModal: false,
	        analyticsModal: false
	      });
	      setTimeout(function () {
	        (0, _jquery2.default)(".modal").removeClass("in");
	      }, 500);
	    };
	
	    _this.state = {
	      plan_list2: [],
	      current_plan: [],
	      istabmoved: false,
	      schoolpreschoolselected: true,
	      isMagicPriceClikedView: false,
	      isValuePriceClikedView: false,
	      isStandardPriceClikedView1: false,
	      isStandardPriceClikedView2: false
	    };
	
	    _this.getPlanList();
	
	    _this.type = _this.props.match.params.type;
	
	    _this.slideCustom = _react2.default.createRef();
	    _this.slidepackages = _react2.default.createRef();
	    _this.slideCustom3 = _react2.default.createRef();
	    _this.openTab1 = _this.openTab1.bind(_this);
	    _this.openTab2 = _this.openTab2.bind(_this);
	    _this.showValuePrice = _this.showValuePrice.bind(_this);
	    _this.showMagicPrice = _this.showMagicPrice.bind(_this);
	
	    return _this;
	  }
	
	  _createClass(NewPartnerInstitutionPage, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	
	      if (this.type == 'other') this.openTab2();else this.openTab1();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	
	      var settings = {
	        dots: false,
	        infinite: false,
	        speed: 2000,
	        slidesToShow: 4,
	        slidesToScroll: 4,
	        autoplay: false,
	        autoplaySpeed: 5000,
	        responsive: [{
	          breakpoint: 768,
	          settings: {
	            slidesToShow: 1,
	            centerMode: false, /* set centerMode to false to show complete slide instead of 3 */
	            slidesToScroll: 1
	          }
	        }]
	
	      };
	
	      var plan_settings = {
	
	        dots: false,
	        infinite: true,
	        speed: 1000,
	        slidesToShow: 1,
	        slidesToScroll: 1,
	        autoplay: true,
	        autoplaySpeed: 2000,
	        responsive: [{
	          breakpoint: 768,
	          settings: {
	            slidesToShow: 1,
	            centerMode: false, /* set centerMode to false to show complete slide instead of 3 */
	            slidesToScroll: 1
	          }
	        }]
	
	      };
	
	      var settings_partners = {
	
	        dots: true,
	        infinite: true,
	        speed: 2000,
	        slidesToShow: 3,
	        slidesToScroll: 3,
	        autoplay: false,
	        autoplaySpeed: 3000,
	        arrows: true,
	        responsive: [{
	          breakpoint: 768,
	          settings: {
	            slidesToShow: 1,
	            centerMode: false, /* set centerMode to false to show complete slide instead of 3 */
	            slidesToScroll: 1
	          }
	        }]
	
	      };
	
	      var settings_dashboards = {
	
	        dots: true,
	        infinite: false,
	        speed: 2000,
	        slidesToShow: 1,
	        slidesToScroll: 1,
	        autoplay: false,
	        autoplaySpeed: 5000,
	        responsive: [{
	          breakpoint: 768,
	          settings: {
	            slidesToShow: 1,
	            centerMode: false, /* set centerMode to false to show complete slide instead of 3 */
	            slidesToScroll: 1
	          }
	        }]
	
	      };
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _reactHelmet.Helmet,
	          null,
	          _react2.default.createElement(
	            "title",
	            null,
	            "BeWise Partners Plans- Enhancing Education Together"
	          ),
	          _react2.default.createElement("meta", { name: "description", content: 'Collaborate with us to access customized solutions for the growth of your institution with Bewise. Explore our custom plans that elevate learning and drive success.' })
	        ),
	        _react2.default.createElement(_HeaderNew2.default, {
	          schoolpreschoolselected: this.state.schoolpreschoolselected,
	          otherselected: this.state.otherselected,
	          toggleOpenTab1: this.openTab1,
	          toggleOpenTab2: this.openTab2
	        }),
	        _react2.default.createElement(
	          "div",
	          { "class": "row display-flex-center mainrowheader", style: { marginTop: "85px" } },
	          _react2.default.createElement(
	            "div",
	            { "class": "col-lg-12 col-sm-12 col-md-12 partnerpricepage" },
	            _react2.default.createElement(
	              "div",
	              { "class": "mainpara" },
	              "Welcome to BeWise partner portal, your gateway to ",
	              _react2.default.createElement(
	                "b",
	                null,
	                "growth and success!"
	              ),
	              " Explore and choose amongst the many value-driven and tailor made opportunities that elevate your journey towards success, and one where every click or interaction opens fresh horizons of progress"
	            ),
	            _react2.default.createElement(
	              "div",
	              { "class": "maincontent" },
	              _react2.default.createElement(
	                "div",
	                { "class": "howitworksection" },
	                _react2.default.createElement(
	                  "div",
	                  { "class": "become_text bolder" },
	                  "Become a BeWise partner in just ",
	                  _react2.default.createElement(
	                    "span",
	                    null,
	                    "3 Steps"
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { "class": "threestepboxes desktop" },
	                  _react2.default.createElement(
	                    "div",
	                    { "class": "stepperbox" },
	                    _react2.default.createElement("img", { src: "/images/box1.png" }),
	                    _react2.default.createElement(
	                      "div",
	                      null,
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "he1" },
	                        "Sign up"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "he2" },
	                        "Login and complete verifications"
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { "class": "stepperbox" },
	                    _react2.default.createElement("img", { src: "/images/box2.png" }),
	                    _react2.default.createElement(
	                      "div",
	                      null,
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "he1" },
	                        "Create and Complete Profile"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "he2" },
	                        "Update your organisation details"
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { "class": "stepperbox" },
	                    _react2.default.createElement("img", { src: "/images/box3.png" }),
	                    _react2.default.createElement(
	                      "div",
	                      null,
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "he1" },
	                        "Activate"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "he2" },
	                        "Choose your options & enjoy the benefits"
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { "class": "threestepboxes mobile" },
	                  _react2.default.createElement(
	                    _reactSlick2.default,
	                    settings_dashboards,
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "stepperbox" },
	                      _react2.default.createElement("img", { src: "/images/box1.png" }),
	                      _react2.default.createElement(
	                        "div",
	                        null,
	                        _react2.default.createElement(
	                          "div",
	                          { "class": "he1" },
	                          "Sign up"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { "class": "he2" },
	                          "Login and complete verifications"
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "stepperbox" },
	                      _react2.default.createElement("img", { src: "/images/box2.png" }),
	                      _react2.default.createElement(
	                        "div",
	                        null,
	                        _react2.default.createElement(
	                          "div",
	                          { "class": "he1" },
	                          "Create and Complete Profile"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { "class": "he2" },
	                          "Update your organisation details"
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "stepperbox" },
	                      _react2.default.createElement("img", { src: "/images/box3.png" }),
	                      _react2.default.createElement(
	                        "div",
	                        null,
	                        _react2.default.createElement(
	                          "div",
	                          { "class": "he1" },
	                          "Activate"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { "class": "he2" },
	                          "Choose your options & enjoy the benefits"
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { "class": "chooseyour" },
	                "Choose your ",
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  "business context!"
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { "class": "tabs" },
	                _react2.default.createElement(
	                  "div",
	                  { "class": "tabby-tab" },
	                  _react2.default.createElement("input", { type: "radio", id: "tab-2", name: "tabby-tabs", checked: true }),
	                  _react2.default.createElement(
	                    "label",
	                    { id: "tab1", "for": "tab-2", onClick: this.openTab1 },
	                    _react2.default.createElement(
	                      "span",
	                      null,
	                      "Schools & Pre-Schools"
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { "class": "tabby-tab" },
	                  _react2.default.createElement("input", { type: "radio", id: "tab-3", name: "tabby-tabs" }),
	                  _react2.default.createElement(
	                    "label",
	                    { id: "tab2", "for": "tab-3", onClick: this.openTab2 },
	                    _react2.default.createElement(
	                      "span",
	                      null,
	                      "All Others"
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { "class": "tabc tabby-content-1" },
	                _react2.default.createElement(
	                  "div",
	                  { "class": "chooseyour benefitstitle" },
	                  "Your Benefits"
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { "class": "desktop" },
	                  _react2.default.createElement(
	                    "div",
	                    { "class": "flexrow" },
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bgflower" },
	                      _react2.default.createElement("img", { src: "https://partner.bewise.in/images/flower.png" })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "rowheadtitle" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "rtitle" },
	                        "Engagement"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "rpara" },
	                        _react2.default.createElement(
	                          "ul",
	                          { "class": "rparalist" },
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "24x 7 Digital presence and trust amongst target audience "
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Maximise brand recall amongst prospects / talent"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Directly receive leads and enquiries @ platform "
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Effective & Improved Interaction with all parent community "
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Attract & interact directly with top talent "
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "rowheadshowimg" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "showimg" },
	                        _react2.default.createElement("img", { src: "https://partner.bewise.in/images/excellendex.png" })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { "class": "flexrow" },
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bgflower rightside" },
	                      _react2.default.createElement("img", { src: "https://partner.bewise.in/images/flower.png" })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "rowheadshowimg" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "showimg" },
	                        _react2.default.createElement("img", { src: "https://partner.bewise.in/images/enga_graph_1.png" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "rowheadtitle" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "rtitle" },
	                        "Excellence"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "rpara" },
	                        _react2.default.createElement(
	                          "ul",
	                          { "class": "rparalist" },
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "https://partner.bewise.in/images/check-mark.png" }),
	                            " Data led insights, reports & comparison with peers to accelerate growth"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "https://partner.bewise.in/images/check-mark.png" }),
	                            " Benchmarking Vs institutions - to enable your strategic options. "
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "https://partner.bewise.in/images/check-mark.png" }),
	                            " Maximise quality reviews, ratings, and response time for parents "
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "https://partner.bewise.in/images/check-mark.png" }),
	                            " Drive / create thought leadership to impact your brand. "
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { "class": "flexrow" },
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "rowheadtitle" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "rtitle" },
	                        "Efficiency "
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "rpara" },
	                        _react2.default.createElement(
	                          "ul",
	                          { "class": "rparalist" },
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "https://partner.bewise.in/images/check-mark.png" }),
	                            "Higher Growth, ROI & Savings on spends."
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "https://partner.bewise.in/images/check-mark.png" }),
	                            "Explore benefits & scholarships from curated partners for your institution. "
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "https://partner.bewise.in/images/check-mark.png" }),
	                            "Evolutionary / new collaborations to grow brand value & earnings!"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "https://partner.bewise.in/images/check-mark.png" }),
	                            "Choose & follow institutions you benchmark with for free."
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "rowheadshowimg" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "showimg" },
	                        _react2.default.createElement("img", { src: "https://partner.bewise.in/images/enga_graph_2.png" })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { "class": "flexrow" },
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bgflower rightside" },
	                      _react2.default.createElement("img", { src: "https://partner.bewise.in/images/flower.png" })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "rowheadshowimg" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "showimg" },
	                        _react2.default.createElement("img", { src: "https://partner.bewise.in/images/rocket.png" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "rowheadtitle" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "rtitle" },
	                        "Elevate"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "rpara" },
	                        _react2.default.createElement(
	                          "ul",
	                          { "class": "rparalist" },
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "https://partner.bewise.in/images/check-mark.png" }),
	                            " Explore best suited options to upskill yourself & team @ WiseConnect "
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "https://partner.bewise.in/images/check-mark.png" }),
	                            " Explore need based outsourcing & advisory services. "
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "https://partner.bewise.in/images/check-mark.png" }),
	                            " Frequently showcase success of your institution to target audience (Yourself & team for individuals)  "
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "https://partner.bewise.in/images/check-mark.png" }),
	                            " Create followers well in advance of turning them into prospects.  "
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "https://partner.bewise.in/images/check-mark.png" }),
	                            " Increase Brand visibility & presence by active participation @ Portal    "
	                          )
	                        )
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { "class": "mobile" },
	                  _react2.default.createElement(
	                    "div",
	                    { "class": "flexrow" },
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bgflower" },
	                      _react2.default.createElement("img", { src: "https://partner.bewise.in/images/flower.png" })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "rowheadtitle" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "rtitle" },
	                        "Engagement"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "rowheadshowimg" },
	                        _react2.default.createElement(
	                          "div",
	                          { "class": "showimg" },
	                          _react2.default.createElement("img", { src: "https://partner.bewise.in/images/excellendex.png" })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "rpara" },
	                        _react2.default.createElement(
	                          "ul",
	                          { "class": "rparalist" },
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "24x 7 Digital presence and trust amongst target audience "
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Maximise brand recall amongst prospects / talent"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Directly receive leads and enquiries @ platform "
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Effective & Improved Interaction with all parent community "
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Attract & interact directly with top talent "
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { "class": "flexrow" },
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bgflower rightside" },
	                      _react2.default.createElement("img", { src: "https://partner.bewise.in/images/flower.png" })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "rowheadtitle" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "rtitle" },
	                        "Excellence"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "rowheadshowimg" },
	                        _react2.default.createElement(
	                          "div",
	                          { "class": "showimg" },
	                          _react2.default.createElement("img", { src: "https://partner.bewise.in/images/enga_graph_1.png" })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "rpara" },
	                        _react2.default.createElement(
	                          "ul",
	                          { "class": "rparalist" },
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "https://partner.bewise.in/images/check-mark.png" }),
	                            " Data led insights, reports & comparison with peers to accelerate growth"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "https://partner.bewise.in/images/check-mark.png" }),
	                            " Benchmarking Vs institutions - to enable your strategic options. "
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "https://partner.bewise.in/images/check-mark.png" }),
	                            " Maximise quality reviews, ratings, and response time for parents "
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "https://partner.bewise.in/images/check-mark.png" }),
	                            " Drive / create thought leadership to impact your brand. "
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { "class": "flexrow" },
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "rowheadtitle" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "rtitle" },
	                        "Efficiency "
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "rowheadshowimg" },
	                        _react2.default.createElement(
	                          "div",
	                          { "class": "showimg" },
	                          _react2.default.createElement("img", { src: "https://partner.bewise.in/images/enga_graph_2.png" })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "rpara" },
	                        _react2.default.createElement(
	                          "ul",
	                          { "class": "rparalist" },
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "https://partner.bewise.in/images/check-mark.png" }),
	                            "Higher Growth, ROI & Savings on spends."
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "https://partner.bewise.in/images/check-mark.png" }),
	                            "Explore benefits & scholarships from curated partners for your institution. "
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "https://partner.bewise.in/images/check-mark.png" }),
	                            "Evolutionary / new collaborations to grow brand value & earnings!"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "https://partner.bewise.in/images/check-mark.png" }),
	                            "Choose & follow institutions you benchmark with for free."
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { "class": "flexrow" },
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bgflower rightside" },
	                      _react2.default.createElement("img", { src: "https://partner.bewise.in/images/flower.png" })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "rowheadtitle" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "rtitle" },
	                        "Elevate"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "rowheadshowimg" },
	                        _react2.default.createElement(
	                          "div",
	                          { "class": "showimg" },
	                          _react2.default.createElement("img", { src: "https://partner.bewise.in/images/rocket.png" })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "rpara" },
	                        _react2.default.createElement(
	                          "ul",
	                          { "class": "rparalist" },
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "https://partner.bewise.in/images/check-mark.png" }),
	                            " Explore best suited options to upskill yourself & team @ WiseConnect "
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "https://partner.bewise.in/images/check-mark.png" }),
	                            " Explore need based outsourcing & advisory services. "
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "https://partner.bewise.in/images/check-mark.png" }),
	                            " Frequently showcase success of your institution to target audience (Yourself & team for individuals)  "
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "https://partner.bewise.in/images/check-mark.png" }),
	                            " Create followers well in advance of turning them into prospects.  "
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "https://partner.bewise.in/images/check-mark.png" }),
	                            " Increase Brand visibility & presence by active participation @ Portal    "
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { "class": "tabc tabby-content-2 hidden" },
	                _react2.default.createElement(
	                  "div",
	                  { "class": "chooseyour benefitstitle" },
	                  "Your Benefits"
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { "class": "desktop" },
	                  _react2.default.createElement(
	                    "div",
	                    { "class": "flexrow" },
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bgflower" },
	                      _react2.default.createElement("img", { src: "https://partner.bewise.in/images/flower.png" })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "rowheadtitle" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "rtitle" },
	                        "Engagement"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "rpara" },
	                        _react2.default.createElement(
	                          "ul",
	                          { "class": "rparalist" },
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "24x 7 Digital presence and trust amongst target audience "
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Maximise brand recall amongst prospects / talent"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Directly receive leads and enquiries @ platform "
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Effective & Improved Interaction with all parent community "
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "rowheadshowimg" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "showimg" },
	                        _react2.default.createElement("img", { src: "https://partner.bewise.in/images/excellendex.png" })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { "class": "flexrow" },
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bgflower rightside" },
	                      _react2.default.createElement("img", { src: "https://partner.bewise.in/images/flower.png" })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "rowheadshowimg" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "showimg" },
	                        _react2.default.createElement("img", { src: "https://partner.bewise.in/images/enga_graph_1.png" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "rowheadtitle" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "rtitle" },
	                        "Excellence"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "rpara" },
	                        _react2.default.createElement(
	                          "ul",
	                          { "class": "rparalist" },
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "https://partner.bewise.in/images/check-mark.png" }),
	                            " Data led insights, reports & comparison with peers to accelerate growth"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "https://partner.bewise.in/images/check-mark.png" }),
	                            " Benchmarking Vs institutions - to enable your strategic options. "
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "https://partner.bewise.in/images/check-mark.png" }),
	                            " Maximise quality reviews, ratings, and response time for parents "
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "https://partner.bewise.in/images/check-mark.png" }),
	                            " Drive / create thought leadership to impact your brand. "
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { "class": "flexrow" },
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "rowheadtitle" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "rtitle" },
	                        "Efficiency "
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "rpara" },
	                        _react2.default.createElement(
	                          "ul",
	                          { "class": "rparalist" },
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "images/check-mark.png" }),
	                            "Higher Growth, ROI & Savings on spends."
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "images/check-mark.png" }),
	                            "Explore benefits & scholarships from curated partners for your institution. "
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "images/check-mark.png" }),
	                            "Evolutionary / new collaborations to grow brand value & earnings!"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "images/check-mark.png" }),
	                            "Choose & follow institutions you benchmark with for free."
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "rowheadshowimg" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "showimg" },
	                        _react2.default.createElement("img", { src: "/images/enga_graph_2.png" })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { "class": "flexrow" },
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bgflower rightside" },
	                      _react2.default.createElement("img", { src: "/images/flower.png" })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "rowheadshowimg" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "showimg" },
	                        _react2.default.createElement("img", { src: "/images/rocket.png" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "rowheadtitle" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "rtitle" },
	                        "Elevate"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "rpara" },
	                        _react2.default.createElement(
	                          "ul",
	                          { "class": "rparalist" },
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "images/check-mark.png" }),
	                            " Explore best suited options to upskill yourself & team @ WiseConnect "
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "images/check-mark.png" }),
	                            " Frequently showcase success of your institution to target audience (Yourself & team for individuals)  "
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "images/check-mark.png" }),
	                            " Create followers well in advance of turning them into prospects.  "
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "images/check-mark.png" }),
	                            " Increase Brand visibility & presence by active participation @ Portal  "
	                          )
	                        )
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { "class": "mobile" },
	                  _react2.default.createElement(
	                    "div",
	                    { "class": "flexrow" },
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bgflower" },
	                      _react2.default.createElement("img", { src: "/images/flower.png" })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "rowheadtitle" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "rtitle" },
	                        "Engagement"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "rowheadshowimg" },
	                        _react2.default.createElement(
	                          "div",
	                          { "class": "showimg" },
	                          _react2.default.createElement("img", { src: "/images/excellendex.png" })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "rpara" },
	                        _react2.default.createElement(
	                          "ul",
	                          { "class": "rparalist" },
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "24x 7 Digital presence and trust amongst target audience "
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Maximise brand recall amongst prospects / talent"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Directly receive leads and enquiries @ platform "
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Effective & Improved Interaction with all parent community "
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { "class": "flexrow" },
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bgflower rightside" },
	                      _react2.default.createElement("img", { src: "/images/flower.png" })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "rowheadtitle" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "rtitle" },
	                        "Excellence"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "rowheadshowimg" },
	                        _react2.default.createElement(
	                          "div",
	                          { "class": "showimg" },
	                          _react2.default.createElement("img", { src: "/images/enga_graph_1.png" })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "rpara" },
	                        _react2.default.createElement(
	                          "ul",
	                          { "class": "rparalist" },
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "images/check-mark.png" }),
	                            " Data led insights, reports & comparison with peers to accelerate growth"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "images/check-mark.png" }),
	                            " Benchmarking Vs institutions - to enable your strategic options. "
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "images/check-mark.png" }),
	                            " Maximise quality reviews, ratings, and response time for parents "
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "images/check-mark.png" }),
	                            " Drive / create thought leadership to impact your brand. "
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { "class": "flexrow" },
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "rowheadtitle" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "rtitle" },
	                        "Efficiency "
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "rowheadshowimg" },
	                        _react2.default.createElement(
	                          "div",
	                          { "class": "showimg" },
	                          _react2.default.createElement("img", { src: "/images/enga_graph_2.png" })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "rpara" },
	                        _react2.default.createElement(
	                          "ul",
	                          { "class": "rparalist" },
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "images/check-mark.png" }),
	                            "Higher Growth, ROI & Savings on spends."
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "images/check-mark.png" }),
	                            "Explore benefits & scholarships from curated partners for your institution. "
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "images/check-mark.png" }),
	                            "Evolutionary / new collaborations to grow brand value & earnings!"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "images/check-mark.png" }),
	                            "Choose & follow institutions you benchmark with for free."
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { "class": "flexrow" },
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bgflower rightside" },
	                      _react2.default.createElement("img", { src: "/images/flower.png" })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "rowheadtitle" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "rtitle" },
	                        "Elevate"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "rowheadshowimg" },
	                        _react2.default.createElement(
	                          "div",
	                          { "class": "showimg" },
	                          _react2.default.createElement("img", { src: "/images/rocket.png" })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "rpara" },
	                        _react2.default.createElement(
	                          "ul",
	                          { "class": "rparalist" },
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "images/check-mark.png" }),
	                            " Explore best suited options to upskill yourself & team @ WiseConnect "
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "images/check-mark.png" }),
	                            " Frequently showcase success of your institution to target audience (Yourself & team for individuals)  "
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "images/check-mark.png" }),
	                            " Create followers well in advance of turning them into prospects.  "
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "images/check-mark.png" }),
	                            " Increase Brand visibility & presence by active participation @ Portal    "
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { "class": "col-lg-12 col-sm-12" },
	            _react2.default.createElement(
	              "div",
	              { "class": "slider70width benefitsfromourpartners" },
	              _react2.default.createElement(
	                "div",
	                { "class": "sectionboldtitle" },
	                "Benefit from our curated partners"
	              ),
	              _react2.default.createElement(
	                _reactSlick2.default,
	                settings_partners,
	                _react2.default.createElement(
	                  "div",
	                  { "class": "sliderbgpadded slider_partners" },
	                  _react2.default.createElement("img", { src: "/images/sliders/partners/slider_1.png" })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { "class": "sliderbgpadded slider_partners" },
	                  _react2.default.createElement("img", { src: "/images/sliders/partners/slider_2.png" })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { "class": "sliderbgpadded slider_partners" },
	                  _react2.default.createElement("img", { src: "/images/sliders/partners/slider_3.png" })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { "class": "sliderbgpadded slider_partners" },
	                  _react2.default.createElement("img", { src: "/images/sliders/partners/slider_4.png" })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { "class": "sliderbgpadded slider_partners" },
	                  _react2.default.createElement("img", { src: "/images/sliders/partners/slider_5.png" })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { "class": "sliderbgpadded slider_partners" },
	                  _react2.default.createElement("img", { src: "/images/sliders/partners/slider_6.png" })
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { "class": "col-lg-12 col-sm-12" },
	            _react2.default.createElement(
	              "div",
	              { "class": "sliderfullwidth" },
	              _react2.default.createElement(
	                "div",
	                { "class": "slider_text" },
	                "Access all important metrics with our ",
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  "comprehensive dashboard"
	                )
	              ),
	              _react2.default.createElement(
	                _reactSlick2.default,
	                settings_dashboards,
	                _react2.default.createElement(
	                  "div",
	                  { "class": "sliderbgpadded" },
	                  _react2.default.createElement("img", { src: "/images/sliders/slider_1.png" })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { "class": "sliderbgpadded" },
	                  _react2.default.createElement("img", { src: "/images/sliders/slider_2.png" })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { "class": "sliderbgpadded" },
	                  _react2.default.createElement("img", { src: "/images/sliders/slider_3.png" })
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { "class": "col-lg-12 col-sm-12 yelbg", style: { backgroundImage: "url('/images/yelloartline.png')" } },
	            _react2.default.createElement(
	              "div",
	              { "class": "new_plan_section mobileonly" },
	              _react2.default.createElement(
	                "div",
	                { "class": "colored_centered" },
	                "Get ",
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  "Started"
	                )
	              ),
	              this.state.schoolpreschoolselected && _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                  "div",
	                  { "class": "newpricing" },
	                  _react2.default.createElement(
	                    "div",
	                    { "class": "fixedbar" },
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "headofit" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flx planfeatures" },
	                        "Features"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flx plantitle magic" },
	                        "Magic"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flx plantitle standard " },
	                        "Standard"
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { "class": "scrollingview" },
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bodyofit" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack featureitem" },
	                        "24x 7 visibility for Target Audience with:"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bodyofit" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack featureitem" },
	                        "Professional  digital presence"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bodyofit" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack featureitem" },
	                        "Post your Ad in landing page"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bodyofit" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack featureitem" },
	                        "Visiblity and respond to review / ratings "
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bodyofit" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack featureitem" },
	                        "Upload Pictures on page"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement(
	                          "span",
	                          null,
	                          "3 Free"
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement(
	                          "span",
	                          null,
	                          "Upto 15"
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bodyofit" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack featureitem" },
	                        "Upload video on page"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bodyofit" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack featureitem" },
	                        "Direct interaction with parents "
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bodyofit" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack featureitem" },
	                        "Featured in Trending Now"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bodyofit" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack featureitem" },
	                        "Collaborative social media support"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bodyofit" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack featureitem" },
	                        "Verified partner stamp "
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bodyofit" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack featureitem" },
	                        "Receive Leads & enquires"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bodyofit" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack featureitem" },
	                        "Benchmark to your peers / competitors "
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bodyofit" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack featureitem" },
	                        "Build your brand & thought leadership."
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bodyofit" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack featureitem" },
	                        "Ads & newsletter promotion @ special prices"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bodyofit" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack featureitem" },
	                        "Free benefits of INR 50K+ + from curated partner support"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bodyofit" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack featureitem" },
	                        "Scope for collaborative & customised services"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bodyofit" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack featureitem" },
	                        "Pricing & benefits @ WiseConnect"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bodyofit" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack featureitem" },
	                        "Data & analytics to accelerate growth"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement(
	                          "span",
	                          null,
	                          "Partly Free"
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bodyofit" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack featureitem" },
	                        "Access to Skill building / self-development "
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement(
	                          "span",
	                          null,
	                          "Partly Free"
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bodyofit" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack featureitem" },
	                        " ",
	                        _react2.default.createElement(
	                          "div",
	                          { "class": "flxblack featureitem" },
	                          "*BeWise annual subscription only"
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement(
	                          "div",
	                          { "class": "viewpricing" },
	                          this.state.isMagicPriceClikedView && _react2.default.createElement(
	                            "div",
	                            null,
	                            _react2.default.createElement(
	                              "span",
	                              { "class": "stricked" },
	                              "Rs. 29999"
	                            ),
	                            _react2.default.createElement(
	                              "span",
	                              null,
	                              "Rs. 24999/-"
	                            )
	                          ),
	                          !this.state.isMagicPriceClikedView && _react2.default.createElement(
	                            "span",
	                            { onClick: this.showMagicPrice },
	                            "view price"
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        "FREE"
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { "class": "colored_centered" },
	                  " ",
	                  _react2.default.createElement(
	                    "a",
	                    { href: "/institution_signup", "class": "btn new-btn-blue-large" },
	                    "Sign Up Now!"
	                  ),
	                  " "
	                )
	              ),
	              this.state.otherselected && _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                  "div",
	                  { "class": "newpricing" },
	                  _react2.default.createElement(
	                    "div",
	                    { "class": "fixedbar" },
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "headofit" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flx planfeatures" },
	                        "Features"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flx plantitle magic" },
	                        "Value"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flx plantitle standard " },
	                        "Standard"
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { "class": "scrollingview" },
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bodyofit" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack featureitem" },
	                        "24x 7 visibility for Target Audience with"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bodyofit" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack featureitem" },
	                        "Professional  digital presence"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bodyofit" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack featureitem" },
	                        "Visiblity and respond to review / ratings "
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bodyofit" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack featureitem" },
	                        "Use page as own Web Page in marketing"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bodyofit" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack featureitem" },
	                        "Upload Pictures on page"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bodyofit" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack featureitem" },
	                        "Upload video on page"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bodyofit" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack featureitem" },
	                        "Direct interaction with parents "
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bodyofit" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack featureitem" },
	                        "Featured in Trending Now"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bodyofit" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack featureitem" },
	                        "Verified partner stamp"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bodyofit" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack featureitem" },
	                        "Receive Leads & enquires"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bodyofit" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack featureitem" },
	                        "Benchmark to your peers / competitors"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bodyofit" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack featureitem" },
	                        "Free benefits of INR 25K+ + from curated partner support"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bodyofit" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack featureitem" },
	                        "Ads & newsletter promotion @ special prices "
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bodyofit" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack featureitem" },
	                        "Scope for collaborative & customised services"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bodyofit" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack featureitem" },
	                        "Data & analytics to accelerate growth"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement(
	                          "span",
	                          null,
	                          "Partly Free"
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bodyofit" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack featureitem" },
	                        "Pricing & benefits @ WiseConnect"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement(
	                          "span",
	                          null,
	                          "Partly Free"
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bodyofit" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack featureitem" },
	                        "*Annual Subscription Fees"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement(
	                          "div",
	                          { "class": "viewpricing" },
	                          this.state.isValuePriceClikedView && _react2.default.createElement(
	                            "span",
	                            null,
	                            "Rs. 12499/-"
	                          ),
	                          !this.state.isValuePriceClikedView && _react2.default.createElement(
	                            "span",
	                            { onClick: this.showValuePrice },
	                            "view price"
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        "FREE"
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { "class": "colored_centered" },
	                  " ",
	                  _react2.default.createElement(
	                    "a",
	                    { href: "/individual_signup", "class": "btn new-btn-blue-large" },
	                    "Sign Up Now!"
	                  ),
	                  " "
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { "class": "plan_section desktop" },
	              _react2.default.createElement(
	                "div",
	                { "class": "colored_centered" },
	                "Get ",
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  "Started"
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { "class": "planbox" },
	                this.state.schoolpreschoolselected && _react2.default.createElement(
	                  "div",
	                  { "class": "newtable" },
	                  _react2.default.createElement(
	                    "table",
	                    { width: "100%", cellSpacing: 2, cellPadding: 2 },
	                    _react2.default.createElement(
	                      "tr",
	                      null,
	                      _react2.default.createElement(
	                        "td",
	                        { width: "50%" },
	                        "\xA0"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { width: "25%" },
	                        _react2.default.createElement(
	                          "span",
	                          { "class": "s_plantitle" },
	                          "Standard"
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { width: "25%" },
	                        _react2.default.createElement(
	                          "span",
	                          { "class": "v_plantitle" },
	                          "Magic"
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      null,
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "plbbolder", width: "50%" },
	                        "24x 7 visibility for Target Audience with"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { width: "25%" },
	                        "\xA0"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "bluebgtd", width: "25%" },
	                        "\xA0"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      null,
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "plb", width: "50%" },
	                        "Professional  digital presence"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "25%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "bluebgtd", width: "25%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      null,
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "plb", width: "50%" },
	                        "Post your Ad in landing page"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "25%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "bluebgtd", width: "25%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      null,
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "plb", width: "50%" },
	                        "Visiblity and respond to review / ratings"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "25%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "bluebgtd", width: "25%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      null,
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "plb", width: "50%" },
	                        "Use page as own Web Page in marketing"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "25%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "bluebgtd", width: "25%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      null,
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "plb", width: "50%" },
	                        "Upload Pictures on page"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "25%" },
	                        _react2.default.createElement(
	                          "span",
	                          { "class": "plantext" },
	                          "3 Free"
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "bluebgtd", width: "25%" },
	                        _react2.default.createElement(
	                          "span",
	                          { "class": "plantext" },
	                          "Upto 15"
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      null,
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "plb", width: "50%" },
	                        "Direct interaction with parents "
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "25%" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "bluebgtd", width: "25%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      null,
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "plb", width: "50%" },
	                        "Featured in Trending Now"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "25%" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "bluebgtd", width: "25%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      null,
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "plb", width: "50%" },
	                        "Collaborative social media support"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "25%" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "bluebgtd", width: "25%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      null,
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "plb", width: "50%" },
	                        "Verified partner stamp "
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "25%" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "bluebgtd", width: "25%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      null,
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "plbbolder", width: "50%" },
	                        "Receive Leads & enquires "
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "25%" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "bluebgtd", width: "25%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      null,
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "plbbolder", width: "50%" },
	                        "Benchmark to your peers / competitors"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "25%" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "bluebgtd", width: "25%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      null,
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "plbbolder", width: "50%" },
	                        "Build your brand & thought leadership"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "25%" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "bluebgtd", width: "25%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      null,
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "plbbolder", width: "50%" },
	                        "Free benefits of INR 50K+ + from curated partner support"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "25%" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "bluebgtd", width: "25%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      null,
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "plbbolder", width: "50%" },
	                        "Ads & newsletter promotion @ special prices "
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "25%" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "bluebgtd", width: "25%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      null,
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "plbbolder", width: "50%" },
	                        "Scope for collaborative & customised services "
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "25%" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "bluebgtd", width: "25%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      null,
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "plbbolder", width: "50%" },
	                        "Pricing & benefits @ WiseConnect "
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "25%" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "bluebgtd", width: "25%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      null,
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "plbbolder", width: "50%" },
	                        "Data & analytics to accelerate growth "
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "25%" },
	                        _react2.default.createElement(
	                          "span",
	                          { "class": "plantext" },
	                          "Partly Free"
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "bluebgtd", width: "25%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      null,
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "plbbolder", width: "50%" },
	                        "Access to Skill building / self-development "
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "25%" },
	                        _react2.default.createElement(
	                          "span",
	                          { "class": "plantext" },
	                          "Partly Free"
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "bluebgtd", width: "25%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      null,
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "plbbolder", width: "50%" },
	                        "\xA0"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndpricetd", width: "25%" },
	                        _react2.default.createElement(
	                          "div",
	                          { "class": "viewpricing" },
	                          this.state.isStandardPriceClikedView1 && _react2.default.createElement(
	                            "span",
	                            null,
	                            "FREE"
	                          ),
	                          !this.state.isStandardPriceClikedView1 && _react2.default.createElement(
	                            "span",
	                            { onClick: this.showStandardPrice1 },
	                            "view price"
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "valuepricetd", width: "25%" },
	                        _react2.default.createElement(
	                          "div",
	                          { "class": "viewpricinginblue" },
	                          this.state.isMagicPriceClikedView && _react2.default.createElement(
	                            "div",
	                            null,
	                            _react2.default.createElement(
	                              "div",
	                              null,
	                              _react2.default.createElement(
	                                "span",
	                                { "class": "stricken" },
	                                "Rs. 29999"
	                              ),
	                              _react2.default.createElement(
	                                "span",
	                                null,
	                                _react2.default.createElement(
	                                  "b",
	                                  null,
	                                  " Rs. 24999 /- "
	                                ),
	                                _react2.default.createElement("br", null),
	                                _react2.default.createElement(
	                                  "span",
	                                  { "class": "planinfomsg" },
	                                  "BeWise annual subscription only"
	                                )
	                              )
	                            )
	                          ),
	                          !this.state.isMagicPriceClikedView && _react2.default.createElement(
	                            "span",
	                            { onClick: this.showMagicPrice },
	                            "view price"
	                          )
	                        )
	                      )
	                    )
	                  )
	                ),
	                this.state.otherselected && _react2.default.createElement(
	                  "div",
	                  { "class": "newtable" },
	                  _react2.default.createElement(
	                    "table",
	                    { width: "100%", cellSpacing: 2, cellPadding: 2 },
	                    _react2.default.createElement(
	                      "tr",
	                      null,
	                      _react2.default.createElement(
	                        "td",
	                        { width: "50%" },
	                        "\xA0"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { width: "25%" },
	                        _react2.default.createElement(
	                          "span",
	                          { "class": "s_plantitle" },
	                          "Standard"
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { width: "25%" },
	                        _react2.default.createElement(
	                          "span",
	                          { "class": "v_plantitle" },
	                          "Value"
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      null,
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "plbbolder", width: "50%" },
	                        "24x 7 visibility for Target Audience with"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { width: "25%" },
	                        "\xA0"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "bluebgtd", width: "25%" },
	                        "\xA0"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      null,
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "plb", width: "50%" },
	                        "Professional  digital presence"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "25%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "bluebgtd", width: "25%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      null,
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "plb", width: "50%" },
	                        "Visiblity and respond to review / ratings"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "25%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "bluebgtd", width: "25%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      null,
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "plb", width: "50%" },
	                        "Use page as own Web Page in marketing"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "25%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "bluebgtd", width: "25%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      null,
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "plb", width: "50%" },
	                        "Upload Pictures on page"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "25%" },
	                        _react2.default.createElement(
	                          "span",
	                          { "class": "plantext" },
	                          "2 Free"
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "bluebgtd", width: "25%" },
	                        _react2.default.createElement(
	                          "span",
	                          { "class": "plantext" },
	                          "Upto 10"
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      null,
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "plb", width: "50%" },
	                        "Direct interaction with parents "
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "25%" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "bluebgtd", width: "25%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      null,
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "plb", width: "50%" },
	                        "Featured in Trending Now"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "25%" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "bluebgtd", width: "25%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      null,
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "plb", width: "50%" },
	                        "Verified partner stamp "
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "25%" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "bluebgtd", width: "25%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      null,
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "plbbolder", width: "50%" },
	                        "Receive Leads & enquires "
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "25%" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "bluebgtd", width: "25%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      null,
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "plbbolder", width: "50%" },
	                        "Benchmark to your peers / competitors"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "25%" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "bluebgtd", width: "25%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      null,
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "plbbolder", width: "50%" },
	                        "Free benefits of INR 25K+ + from curated partner support"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "25%" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "bluebgtd", width: "25%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      null,
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "plbbolder", width: "50%" },
	                        "Ads & newsletter promotion @ special prices "
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "25%" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "bluebgtd", width: "25%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      null,
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "plbbolder", width: "50%" },
	                        "Scope for collaborative & customised services "
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "25%" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "bluebgtd", width: "25%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      null,
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "plbbolder", width: "50%" },
	                        "Data & analytics to accelerate growth "
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "25%" },
	                        _react2.default.createElement(
	                          "span",
	                          { "class": "plantext" },
	                          "Partly Free"
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "bluebgtd", width: "25%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      null,
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "plbbolder", width: "50%" },
	                        "Pricing & benefits @ WiseConnect "
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "25%" },
	                        _react2.default.createElement(
	                          "span",
	                          { "class": "plantext" },
	                          "Partly Free"
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "bluebgtd", width: "25%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      null,
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "plbbolder", width: "50%" },
	                        "\xA0"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndpricetd", width: "25%" },
	                        _react2.default.createElement(
	                          "div",
	                          { "class": "viewpricing" },
	                          this.state.isStandardPriceClikedView2 && _react2.default.createElement(
	                            "span",
	                            null,
	                            "FREE"
	                          ),
	                          !this.state.isStandardPriceClikedView2 && _react2.default.createElement(
	                            "span",
	                            { onClick: this.showStandardPrice2 },
	                            "view price"
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "valuepricetd", width: "25%" },
	                        _react2.default.createElement(
	                          "div",
	                          { "class": "viewpricinginblue" },
	                          this.state.isValuePriceClikedView && _react2.default.createElement(
	                            "span",
	                            null,
	                            "Rs. 12499 /- ",
	                            _react2.default.createElement("br", null),
	                            _react2.default.createElement(
	                              "span",
	                              null,
	                              "Annual Subscription Fees"
	                            )
	                          ),
	                          !this.state.isValuePriceClikedView && _react2.default.createElement(
	                            "span",
	                            { onClick: this.showValuePrice },
	                            "view price"
	                          )
	                        )
	                      )
	                    )
	                  )
	                ),
	                this.state.schoolpreschoolselected && _react2.default.createElement(
	                  "div",
	                  { "class": "colored_centered" },
	                  " ",
	                  _react2.default.createElement(
	                    "a",
	                    { href: "/institution_signup", "class": "btn new-btn-blue-large" },
	                    "Sign Up Now!"
	                  ),
	                  " "
	                ),
	                this.state.otherselected && _react2.default.createElement(
	                  "div",
	                  { "class": "colored_centered" },
	                  " ",
	                  _react2.default.createElement(
	                    "a",
	                    { href: "/individual_signup", "class": "btn new-btn-blue-large" },
	                    "Sign Up Now!"
	                  ),
	                  " "
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_Footer2.default, null)
	      );
	    }
	  }]);
	
	  return NewPartnerInstitutionPage;
	}(_react.Component);
	
	exports.default = NewPartnerInstitutionPage;

/***/ },
/* 867 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _HeaderNew = __webpack_require__(358);
	
	var _HeaderNew2 = _interopRequireDefault(_HeaderNew);
	
	var _FooterNew = __webpack_require__(357);
	
	var _FooterNew2 = _interopRequireDefault(_FooterNew);
	
	var _Footer = __webpack_require__(82);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _backArrowDark = __webpack_require__(123);
	
	var _backArrowDark2 = _interopRequireDefault(_backArrowDark);
	
	var _chartImage = __webpack_require__(136);
	
	var _chartImage2 = _interopRequireDefault(_chartImage);
	
	var _miniArrow = __webpack_require__(124);
	
	var _miniArrow2 = _interopRequireDefault(_miniArrow);
	
	var _reactSlick = __webpack_require__(93);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	__webpack_require__(122);
	
	__webpack_require__(121);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _FetchCall = __webpack_require__(4);
	
	var _reactstrap = __webpack_require__(17);
	
	var _ModalHeader = __webpack_require__(102);
	
	var _ModalHeader2 = _interopRequireDefault(_ModalHeader);
	
	var _reactHelmet = __webpack_require__(77);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import { Scrollbar } from 'react-scrollbars-custom';
	
	var CurrencyFormat = __webpack_require__(112);
	
	var benefits = [_react2.default.createElement(
	  "ul",
	  null,
	  _react2.default.createElement(
	    "li",
	    null,
	    "200-word write-up about yourself and services offered on your page."
	  ),
	  _react2.default.createElement(
	    "li",
	    null,
	    "Manage your profile page frequently to improve brand and visibility."
	  ),
	  _react2.default.createElement(
	    "li",
	    null,
	    "Upload up to 8 images on your profile page."
	  ),
	  _react2.default.createElement(
	    "li",
	    null,
	    "Post your social media link(s) on your page."
	  ),
	  _react2.default.createElement(
	    "li",
	    null,
	    "Email interaction with prospective parents."
	  ),
	  _react2.default.createElement(
	    "li",
	    null,
	    "Respond to users on their feedback."
	  ),
	  _react2.default.createElement(
	    "li",
	    null,
	    "Upload videos links to showcase excellence."
	  ),
	  _react2.default.createElement(
	    "li",
	    null,
	    "Publish two articles a year on thought leadership."
	  )
	), _react2.default.createElement(
	  "ul",
	  null,
	  _react2.default.createElement(
	    "li",
	    null,
	    "400-word write-up about yourself and services offered on your page."
	  ),
	  _react2.default.createElement(
	    "li",
	    null,
	    "Manage your profile page frequently to improve brand and visibility."
	  ),
	  _react2.default.createElement(
	    "li",
	    null,
	    "Upload up to 15 images on your profile page."
	  ),
	  _react2.default.createElement(
	    "li",
	    null,
	    "Post your social media link(s) on your page."
	  ),
	  _react2.default.createElement(
	    "li",
	    null,
	    "Drive showcase you in some of our social media."
	  ),
	  _react2.default.createElement(
	    "li",
	    null,
	    "Email interaction with prospective parents."
	  ),
	  _react2.default.createElement(
	    "li",
	    null,
	    "Upload videos links to showcase excellence."
	  ),
	  _react2.default.createElement(
	    "li",
	    null,
	    "Publish two articles a year on thought leadership."
	  )
	)];
	
	var NewPartnerInstitutionPage = function (_Component) {
	  _inherits(NewPartnerInstitutionPage, _Component);
	
	  function NewPartnerInstitutionPage(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, NewPartnerInstitutionPage);
	
	    var _this = _possibleConstructorReturn(this, (NewPartnerInstitutionPage.__proto__ || Object.getPrototypeOf(NewPartnerInstitutionPage)).call(this, props));
	
	    _this.showValuePrice = function () {
	      _this.setState({ isValuePriceClikedView: true });
	    };
	
	    _this.showMagicPrice = function () {
	      _this.setState({ isMagicPriceClikedView: true });
	    };
	
	    _this.showStandardPrice1 = function () {
	      _this.setState({ isStandardPriceClikedView1: true });
	    };
	
	    _this.showStandardPrice2 = function () {
	      _this.setState({ isStandardPriceClikedView2: true });
	    };
	
	    _this.showMagicWcPrice = function () {
	      _this.setState({ isMagicWcPriceClikedView: true });
	    };
	
	    _this.openTab1 = function () {
	      _this.setState({ schoolpreschoolselected: true, otherselected: false });
	      (0, _jquery2.default)("#tab1").addClass('active');
	      (0, _jquery2.default)("#tab2").removeClass('active');
	      (0, _jquery2.default)(".tabby-content-1").removeClass('hidden');
	      (0, _jquery2.default)(".tabby-content-2").addClass('hidden');
	      (0, _jquery2.default)(".tabby-content-1").css('opacity', '1.0');
	    };
	
	    _this.openTab2 = function () {
	      _this.setState({ otherselected: true, schoolpreschoolselected: false });
	      (0, _jquery2.default)("#tab2").addClass('active');
	      (0, _jquery2.default)("#tab1").removeClass('active');
	      (0, _jquery2.default)(".tabby-content-1").addClass('hidden');
	      (0, _jquery2.default)(".tabby-content-2").removeClass('hidden');
	      (0, _jquery2.default)(".tabby-content-2").css('opacity', '1.0');
	    };
	
	    _this.getPlanList = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var planData;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              planData = JSON.stringify({
	                user_type: 1
	              });
	
	
	              (0, _FetchCall.getPlan)(planData).then(function (response) {
	                if (response.status == 1) {
	                  _this.setState({
	                    plan_list2: response.results
	                  });
	                } else {
	                  console.log('else');
	                }
	              });
	
	            case 2:
	            case "end":
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    }));
	
	    _this.handlePlan = function (id) {
	      var plan_info = _this.state.plan_list2.filter(function (o) {
	        return o.id == id;
	      });
	      console.log('plan_info', plan_info);
	      _this.setState({
	        current_plan: plan_info,
	        plan_id: id,
	        offerModal: true,
	        analyticsModal: false
	      });
	      setTimeout(function () {
	        (0, _jquery2.default)(".modal").addClass("in");
	      }, 500);
	    };
	
	    _this.analyticsOffer = function () {
	      _this.setState({
	        offerModal: false,
	        analyticsModal: true
	      });
	      setTimeout(function () {
	        (0, _jquery2.default)(".modal").addClass("in");
	      }, 500);
	    };
	
	    _this.backToOffer = function () {
	      _this.setState({
	        offerModal: true,
	        analyticsModal: false
	      });
	      setTimeout(function () {
	        (0, _jquery2.default)(".modal").addClass("in");
	      }, 500);
	    };
	
	    _this.backToSlide = function () {
	      _this.setState({
	        offerModal: false,
	        analyticsModal: false
	      });
	      setTimeout(function () {
	        (0, _jquery2.default)(".modal").removeClass("in");
	      }, 500);
	    };
	
	    _this.state = {
	      plan_list2: [],
	      current_plan: [],
	      istabmoved: false,
	      schoolpreschoolselected: true,
	      isMagicPriceClikedView: false,
	      isMagicWcPriceClikedView: false,
	      isValuePriceClikedView: false,
	      isStandardPriceClikedView1: false,
	      isStandardPriceClikedView2: false
	    };
	
	    _this.getPlanList();
	
	    _this.type = _this.props.match.params.type;
	
	    _this.slideCustom = _react2.default.createRef();
	    _this.slidepackages = _react2.default.createRef();
	    _this.slideCustom3 = _react2.default.createRef();
	    _this.openTab1 = _this.openTab1.bind(_this);
	    _this.openTab2 = _this.openTab2.bind(_this);
	    _this.showValuePrice = _this.showValuePrice.bind(_this);
	    _this.showMagicPrice = _this.showMagicPrice.bind(_this);
	    _this.showMagicWcPrice = _this.showMagicWcPrice.bind(_this);
	    return _this;
	  }
	
	  _createClass(NewPartnerInstitutionPage, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	
	      if (this.type == 'other') this.openTab2();else this.openTab1();
	
	      var table = document.querySelector('.__table');
	
	      var parents = table.querySelector('.onclick_expcol');
	      console.clear();
	      parents.addEventListener('click', function (el) {
	
	        (0, _jquery2.default)(".onclick_expcol").html((0, _jquery2.default)('.onclick_expcol').html() == '<img src="/images/chevron-up.svg">' ? '<img src="/images/chevron-down.svg">' : '<img src="/images/chevron-up.svg">');
	
	        (0, _jquery2.default)(".child").toggleClass('hidden');
	        /*
	        var classname = parents.getAttribute("data-child");
	        var children = document.querySelector('.' + classname);
	        children.forEach(c => {
	          if (c.className.search("hidden") > -1) {
	            c.className = c.className.replace("hidden", " ");
	          } else {
	            c.className = c.className + ' hidden';
	          }
	        });
	        */
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	
	      var settings = {
	        dots: false,
	        infinite: false,
	        speed: 2000,
	        slidesToShow: 4,
	        slidesToScroll: 4,
	        autoplay: false,
	        autoplaySpeed: 5000,
	        responsive: [{
	          breakpoint: 768,
	          settings: {
	            slidesToShow: 1,
	            centerMode: false, /* set centerMode to false to show complete slide instead of 3 */
	            slidesToScroll: 1
	          }
	        }]
	
	      };
	
	      var plan_settings = {
	
	        dots: false,
	        infinite: true,
	        speed: 1000,
	        slidesToShow: 1,
	        slidesToScroll: 1,
	        autoplay: true,
	        autoplaySpeed: 2000,
	        responsive: [{
	          breakpoint: 768,
	          settings: {
	            slidesToShow: 1,
	            centerMode: false, /* set centerMode to false to show complete slide instead of 3 */
	            slidesToScroll: 1
	          }
	        }]
	
	      };
	
	      var settings_partners = {
	
	        dots: true,
	        infinite: true,
	        speed: 2000,
	        slidesToShow: 3,
	        slidesToScroll: 3,
	        autoplay: false,
	        autoplaySpeed: 3000,
	        arrows: true,
	        responsive: [{
	          breakpoint: 768,
	          settings: {
	            slidesToShow: 1,
	            centerMode: false, /* set centerMode to false to show complete slide instead of 3 */
	            slidesToScroll: 1
	          }
	        }]
	
	      };
	
	      var settings_dashboards = {
	
	        dots: true,
	        infinite: false,
	        speed: 2000,
	        slidesToShow: 1,
	        slidesToScroll: 1,
	        autoplay: false,
	        autoplaySpeed: 5000,
	        responsive: [{
	          breakpoint: 768,
	          settings: {
	            slidesToShow: 1,
	            centerMode: false, /* set centerMode to false to show complete slide instead of 3 */
	            slidesToScroll: 1
	          }
	        }]
	
	      };
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _reactHelmet.Helmet,
	          null,
	          _react2.default.createElement(
	            "title",
	            null,
	            "BeWise Partners Plans- Enhancing Education Together"
	          ),
	          _react2.default.createElement("meta", { name: "description", content: 'Collaborate with us to access customized solutions for the growth of your institution with Bewise. Explore our custom plans that elevate learning and drive success.' })
	        ),
	        _react2.default.createElement(_HeaderNew2.default, {
	          schoolpreschoolselected: this.state.schoolpreschoolselected,
	          otherselected: this.state.otherselected,
	          toggleOpenTab1: this.openTab1,
	          toggleOpenTab2: this.openTab2
	        }),
	        _react2.default.createElement(
	          "div",
	          { "class": "row display-flex-center mainrowheader", style: { marginTop: "85px" } },
	          _react2.default.createElement(
	            "div",
	            { "class": "col-lg-12 col-sm-12 col-md-12 partnerpricepage" },
	            _react2.default.createElement(
	              "div",
	              { "class": "mainpara" },
	              "Welcome to BeWise partner portal, your gateway to ",
	              _react2.default.createElement(
	                "b",
	                null,
	                "growth and success!"
	              ),
	              " Explore and choose amongst the many value-driven and tailor made opportunities that elevate your journey towards success, and one where every click or interaction opens fresh horizons of progress"
	            ),
	            _react2.default.createElement(
	              "div",
	              { "class": "maincontent" },
	              _react2.default.createElement(
	                "div",
	                { "class": "howitworksection" },
	                _react2.default.createElement(
	                  "div",
	                  { "class": "become_text bolder" },
	                  "Become a BeWise partner in just ",
	                  _react2.default.createElement(
	                    "span",
	                    null,
	                    "3 Steps"
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { "class": "threestepboxes desktop" },
	                  _react2.default.createElement(
	                    "div",
	                    { "class": "stepperbox" },
	                    _react2.default.createElement("img", { src: "/images/box1.png" }),
	                    _react2.default.createElement(
	                      "div",
	                      null,
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "he1" },
	                        "Sign up"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "he2" },
	                        "Login and complete verifications"
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { "class": "stepperbox" },
	                    _react2.default.createElement("img", { src: "/images/box2.png" }),
	                    _react2.default.createElement(
	                      "div",
	                      null,
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "he1" },
	                        "Create and Complete Profile"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "he2" },
	                        "Update your organisation details"
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { "class": "stepperbox" },
	                    _react2.default.createElement("img", { src: "/images/box3.png" }),
	                    _react2.default.createElement(
	                      "div",
	                      null,
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "he1" },
	                        "Activate"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "he2" },
	                        "Choose your options & enjoy the benefits"
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { "class": "threestepboxes mobile" },
	                  _react2.default.createElement(
	                    _reactSlick2.default,
	                    settings_dashboards,
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "stepperbox" },
	                      _react2.default.createElement("img", { src: "/images/box1.png" }),
	                      _react2.default.createElement(
	                        "div",
	                        null,
	                        _react2.default.createElement(
	                          "div",
	                          { "class": "he1" },
	                          "Sign up"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { "class": "he2" },
	                          "Login and complete verifications"
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "stepperbox" },
	                      _react2.default.createElement("img", { src: "/images/box2.png" }),
	                      _react2.default.createElement(
	                        "div",
	                        null,
	                        _react2.default.createElement(
	                          "div",
	                          { "class": "he1" },
	                          "Create and Complete Profile"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { "class": "he2" },
	                          "Update your organisation details"
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "stepperbox" },
	                      _react2.default.createElement("img", { src: "/images/box3.png" }),
	                      _react2.default.createElement(
	                        "div",
	                        null,
	                        _react2.default.createElement(
	                          "div",
	                          { "class": "he1" },
	                          "Activate"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { "class": "he2" },
	                          "Choose your options & enjoy the benefits"
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { "class": "chooseyour" },
	                "Choose your ",
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  "business context!"
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { "class": "tabs" },
	                _react2.default.createElement(
	                  "div",
	                  { "class": "tabby-tab" },
	                  _react2.default.createElement("input", { type: "radio", id: "tab-2", name: "tabby-tabs", checked: true }),
	                  _react2.default.createElement(
	                    "label",
	                    { id: "tab1", "for": "tab-2", onClick: this.openTab1 },
	                    _react2.default.createElement(
	                      "span",
	                      null,
	                      "Schools & Pre-Schools"
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { "class": "tabby-tab" },
	                  _react2.default.createElement("input", { type: "radio", id: "tab-3", name: "tabby-tabs" }),
	                  _react2.default.createElement(
	                    "label",
	                    { id: "tab2", "for": "tab-3", onClick: this.openTab2 },
	                    _react2.default.createElement(
	                      "span",
	                      null,
	                      "All Others"
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { "class": "tabc tabby-content-1" },
	                _react2.default.createElement(
	                  "div",
	                  { "class": "chooseyour benefitstitle" },
	                  "Your Benefits"
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { "class": "desktop" },
	                  _react2.default.createElement(
	                    "div",
	                    { "class": "flexrow" },
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bgflower" },
	                      _react2.default.createElement("img", { src: "https://partner.bewise.in/images/flower.png" })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "rowheadtitle" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "rtitle" },
	                        "Engagement"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "rpara" },
	                        _react2.default.createElement(
	                          "ul",
	                          { "class": "rparalist" },
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "24x 7 Digital presence and trust amongst target audience "
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Maximise brand recall amongst prospects / talent"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Directly receive leads and enquiries @ platform "
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Effective & Improved Interaction with all parent community "
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Attract & interact directly with top talent "
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "rowheadshowimg" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "showimg" },
	                        _react2.default.createElement("img", { src: "https://partner.bewise.in/images/excellendex.png" })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { "class": "flexrow" },
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bgflower rightside" },
	                      _react2.default.createElement("img", { src: "https://partner.bewise.in/images/flower.png" })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "rowheadshowimg" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "showimg" },
	                        _react2.default.createElement("img", { src: "https://partner.bewise.in/images/enga_graph_1.png" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "rowheadtitle" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "rtitle" },
	                        "Excellence"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "rpara" },
	                        _react2.default.createElement(
	                          "ul",
	                          { "class": "rparalist" },
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "https://partner.bewise.in/images/check-mark.png" }),
	                            " Data led insights, reports & comparison with peers to accelerate growth"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "https://partner.bewise.in/images/check-mark.png" }),
	                            " Benchmarking Vs institutions - to enable your strategic options. "
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "https://partner.bewise.in/images/check-mark.png" }),
	                            " Maximise quality reviews, ratings, and response time for parents "
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "https://partner.bewise.in/images/check-mark.png" }),
	                            " Drive / create thought leadership to impact your brand. "
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { "class": "flexrow" },
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "rowheadtitle" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "rtitle" },
	                        "Efficiency "
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "rpara" },
	                        _react2.default.createElement(
	                          "ul",
	                          { "class": "rparalist" },
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "https://partner.bewise.in/images/check-mark.png" }),
	                            "Higher Growth, ROI & Savings on spends."
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "https://partner.bewise.in/images/check-mark.png" }),
	                            "Explore benefits & scholarships from curated partners for your institution. "
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "https://partner.bewise.in/images/check-mark.png" }),
	                            "Evolutionary / new collaborations to grow brand value & earnings!"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "https://partner.bewise.in/images/check-mark.png" }),
	                            "Choose & follow institutions you benchmark with for free."
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "rowheadshowimg" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "showimg" },
	                        _react2.default.createElement("img", { src: "https://partner.bewise.in/images/enga_graph_2.png" })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { "class": "flexrow" },
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bgflower rightside" },
	                      _react2.default.createElement("img", { src: "https://partner.bewise.in/images/flower.png" })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "rowheadshowimg" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "showimg" },
	                        _react2.default.createElement("img", { src: "https://partner.bewise.in/images/rocket.png" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "rowheadtitle" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "rtitle" },
	                        "Elevate"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "rpara" },
	                        _react2.default.createElement(
	                          "ul",
	                          { "class": "rparalist" },
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "https://partner.bewise.in/images/check-mark.png" }),
	                            " Explore best suited options to upskill yourself & team @ WiseConnect "
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "https://partner.bewise.in/images/check-mark.png" }),
	                            " Explore need based outsourcing & advisory services. "
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "https://partner.bewise.in/images/check-mark.png" }),
	                            " Frequently showcase success of your institution to target audience (Yourself & team for individuals)  "
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "https://partner.bewise.in/images/check-mark.png" }),
	                            " Create followers well in advance of turning them into prospects.  "
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "https://partner.bewise.in/images/check-mark.png" }),
	                            " Increase Brand visibility & presence by active participation @ Portal    "
	                          )
	                        )
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { "class": "mobile" },
	                  _react2.default.createElement(
	                    "div",
	                    { "class": "flexrow" },
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bgflower" },
	                      _react2.default.createElement("img", { src: "https://partner.bewise.in/images/flower.png" })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "rowheadtitle" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "rtitle" },
	                        "Engagement"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "rowheadshowimg" },
	                        _react2.default.createElement(
	                          "div",
	                          { "class": "showimg" },
	                          _react2.default.createElement("img", { src: "https://partner.bewise.in/images/excellendex.png" })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "rpara" },
	                        _react2.default.createElement(
	                          "ul",
	                          { "class": "rparalist" },
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "24x 7 Digital presence and trust amongst target audience "
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Maximise brand recall amongst prospects / talent"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Directly receive leads and enquiries @ platform "
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Effective & Improved Interaction with all parent community "
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Attract & interact directly with top talent "
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { "class": "flexrow" },
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bgflower rightside" },
	                      _react2.default.createElement("img", { src: "https://partner.bewise.in/images/flower.png" })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "rowheadtitle" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "rtitle" },
	                        "Excellence"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "rowheadshowimg" },
	                        _react2.default.createElement(
	                          "div",
	                          { "class": "showimg" },
	                          _react2.default.createElement("img", { src: "https://partner.bewise.in/images/enga_graph_1.png" })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "rpara" },
	                        _react2.default.createElement(
	                          "ul",
	                          { "class": "rparalist" },
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "https://partner.bewise.in/images/check-mark.png" }),
	                            " Data led insights, reports & comparison with peers to accelerate growth"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "https://partner.bewise.in/images/check-mark.png" }),
	                            " Benchmarking Vs institutions - to enable your strategic options. "
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "https://partner.bewise.in/images/check-mark.png" }),
	                            " Maximise quality reviews, ratings, and response time for parents "
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "https://partner.bewise.in/images/check-mark.png" }),
	                            " Drive / create thought leadership to impact your brand. "
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { "class": "flexrow" },
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "rowheadtitle" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "rtitle" },
	                        "Efficiency "
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "rowheadshowimg" },
	                        _react2.default.createElement(
	                          "div",
	                          { "class": "showimg" },
	                          _react2.default.createElement("img", { src: "https://partner.bewise.in/images/enga_graph_2.png" })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "rpara" },
	                        _react2.default.createElement(
	                          "ul",
	                          { "class": "rparalist" },
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "https://partner.bewise.in/images/check-mark.png" }),
	                            "Higher Growth, ROI & Savings on spends."
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "https://partner.bewise.in/images/check-mark.png" }),
	                            "Explore benefits & scholarships from curated partners for your institution. "
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "https://partner.bewise.in/images/check-mark.png" }),
	                            "Evolutionary / new collaborations to grow brand value & earnings!"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "https://partner.bewise.in/images/check-mark.png" }),
	                            "Choose & follow institutions you benchmark with for free."
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { "class": "flexrow" },
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bgflower rightside" },
	                      _react2.default.createElement("img", { src: "https://partner.bewise.in/images/flower.png" })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "rowheadtitle" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "rtitle" },
	                        "Elevate"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "rowheadshowimg" },
	                        _react2.default.createElement(
	                          "div",
	                          { "class": "showimg" },
	                          _react2.default.createElement("img", { src: "https://partner.bewise.in/images/rocket.png" })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "rpara" },
	                        _react2.default.createElement(
	                          "ul",
	                          { "class": "rparalist" },
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "https://partner.bewise.in/images/check-mark.png" }),
	                            " Explore best suited options to upskill yourself & team @ WiseConnect "
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "https://partner.bewise.in/images/check-mark.png" }),
	                            " Explore need based outsourcing & advisory services. "
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "https://partner.bewise.in/images/check-mark.png" }),
	                            " Frequently showcase success of your institution to target audience (Yourself & team for individuals)  "
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "https://partner.bewise.in/images/check-mark.png" }),
	                            " Create followers well in advance of turning them into prospects.  "
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "https://partner.bewise.in/images/check-mark.png" }),
	                            " Increase Brand visibility & presence by active participation @ Portal    "
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { "class": "tabc tabby-content-2 hidden" },
	                _react2.default.createElement(
	                  "div",
	                  { "class": "chooseyour benefitstitle" },
	                  "Your Benefits"
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { "class": "desktop" },
	                  _react2.default.createElement(
	                    "div",
	                    { "class": "flexrow" },
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bgflower" },
	                      _react2.default.createElement("img", { src: "https://partner.bewise.in/images/flower.png" })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "rowheadtitle" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "rtitle" },
	                        "Engagement"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "rpara" },
	                        _react2.default.createElement(
	                          "ul",
	                          { "class": "rparalist" },
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "24x 7 Digital presence and trust amongst target audience "
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Maximise brand recall amongst prospects / talent"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Directly receive leads and enquiries @ platform "
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Effective & Improved Interaction with all parent community "
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "rowheadshowimg" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "showimg" },
	                        _react2.default.createElement("img", { src: "https://partner.bewise.in/images/excellendex.png" })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { "class": "flexrow" },
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bgflower rightside" },
	                      _react2.default.createElement("img", { src: "https://partner.bewise.in/images/flower.png" })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "rowheadshowimg" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "showimg" },
	                        _react2.default.createElement("img", { src: "https://partner.bewise.in/images/enga_graph_1.png" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "rowheadtitle" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "rtitle" },
	                        "Excellence"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "rpara" },
	                        _react2.default.createElement(
	                          "ul",
	                          { "class": "rparalist" },
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "https://partner.bewise.in/images/check-mark.png" }),
	                            " Data led insights, reports & comparison with peers to accelerate growth"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "https://partner.bewise.in/images/check-mark.png" }),
	                            " Benchmarking Vs institutions - to enable your strategic options. "
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "https://partner.bewise.in/images/check-mark.png" }),
	                            " Maximise quality reviews, ratings, and response time for parents "
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "https://partner.bewise.in/images/check-mark.png" }),
	                            " Drive / create thought leadership to impact your brand. "
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { "class": "flexrow" },
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "rowheadtitle" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "rtitle" },
	                        "Efficiency "
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "rpara" },
	                        _react2.default.createElement(
	                          "ul",
	                          { "class": "rparalist" },
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "images/check-mark.png" }),
	                            "Higher Growth, ROI & Savings on spends."
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "images/check-mark.png" }),
	                            "Explore benefits & scholarships from curated partners for your institution. "
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "images/check-mark.png" }),
	                            "Evolutionary / new collaborations to grow brand value & earnings!"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "images/check-mark.png" }),
	                            "Choose & follow institutions you benchmark with for free."
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "rowheadshowimg" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "showimg" },
	                        _react2.default.createElement("img", { src: "/images/enga_graph_2.png" })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { "class": "flexrow" },
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bgflower rightside" },
	                      _react2.default.createElement("img", { src: "/images/flower.png" })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "rowheadshowimg" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "showimg" },
	                        _react2.default.createElement("img", { src: "/images/rocket.png" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "rowheadtitle" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "rtitle" },
	                        "Elevate"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "rpara" },
	                        _react2.default.createElement(
	                          "ul",
	                          { "class": "rparalist" },
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "images/check-mark.png" }),
	                            " Explore best suited options to upskill yourself & team @ WiseConnect "
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "images/check-mark.png" }),
	                            " Frequently showcase success of your institution to target audience (Yourself & team for individuals)  "
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "images/check-mark.png" }),
	                            " Create followers well in advance of turning them into prospects.  "
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "images/check-mark.png" }),
	                            " Increase Brand visibility & presence by active participation @ Portal  "
	                          )
	                        )
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { "class": "mobile" },
	                  _react2.default.createElement(
	                    "div",
	                    { "class": "flexrow" },
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bgflower" },
	                      _react2.default.createElement("img", { src: "/images/flower.png" })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "rowheadtitle" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "rtitle" },
	                        "Engagement"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "rowheadshowimg" },
	                        _react2.default.createElement(
	                          "div",
	                          { "class": "showimg" },
	                          _react2.default.createElement("img", { src: "/images/excellendex.png" })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "rpara" },
	                        _react2.default.createElement(
	                          "ul",
	                          { "class": "rparalist" },
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "24x 7 Digital presence and trust amongst target audience "
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Maximise brand recall amongst prospects / talent"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Directly receive leads and enquiries @ platform "
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Effective & Improved Interaction with all parent community "
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { "class": "flexrow" },
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bgflower rightside" },
	                      _react2.default.createElement("img", { src: "/images/flower.png" })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "rowheadtitle" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "rtitle" },
	                        "Excellence"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "rowheadshowimg" },
	                        _react2.default.createElement(
	                          "div",
	                          { "class": "showimg" },
	                          _react2.default.createElement("img", { src: "/images/enga_graph_1.png" })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "rpara" },
	                        _react2.default.createElement(
	                          "ul",
	                          { "class": "rparalist" },
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "images/check-mark.png" }),
	                            " Data led insights, reports & comparison with peers to accelerate growth"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "images/check-mark.png" }),
	                            " Benchmarking Vs institutions - to enable your strategic options. "
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "images/check-mark.png" }),
	                            " Maximise quality reviews, ratings, and response time for parents "
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "images/check-mark.png" }),
	                            " Drive / create thought leadership to impact your brand. "
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { "class": "flexrow" },
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "rowheadtitle" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "rtitle" },
	                        "Efficiency "
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "rowheadshowimg" },
	                        _react2.default.createElement(
	                          "div",
	                          { "class": "showimg" },
	                          _react2.default.createElement("img", { src: "/images/enga_graph_2.png" })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "rpara" },
	                        _react2.default.createElement(
	                          "ul",
	                          { "class": "rparalist" },
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "images/check-mark.png" }),
	                            "Higher Growth, ROI & Savings on spends."
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "images/check-mark.png" }),
	                            "Explore benefits & scholarships from curated partners for your institution. "
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "images/check-mark.png" }),
	                            "Evolutionary / new collaborations to grow brand value & earnings!"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "images/check-mark.png" }),
	                            "Choose & follow institutions you benchmark with for free."
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { "class": "flexrow" },
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bgflower rightside" },
	                      _react2.default.createElement("img", { src: "/images/flower.png" })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "rowheadtitle" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "rtitle" },
	                        "Elevate"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "rowheadshowimg" },
	                        _react2.default.createElement(
	                          "div",
	                          { "class": "showimg" },
	                          _react2.default.createElement("img", { src: "/images/rocket.png" })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "rpara" },
	                        _react2.default.createElement(
	                          "ul",
	                          { "class": "rparalist" },
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "images/check-mark.png" }),
	                            " Explore best suited options to upskill yourself & team @ WiseConnect "
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "images/check-mark.png" }),
	                            " Frequently showcase success of your institution to target audience (Yourself & team for individuals)  "
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "images/check-mark.png" }),
	                            " Create followers well in advance of turning them into prospects.  "
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("img", { src: "images/check-mark.png" }),
	                            " Increase Brand visibility & presence by active participation @ Portal    "
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { "class": "col-lg-12 col-sm-12" },
	            _react2.default.createElement(
	              "div",
	              { "class": "slider70width benefitsfromourpartners" },
	              _react2.default.createElement(
	                "div",
	                { "class": "sectionboldtitle" },
	                "Benefit from our curated partners"
	              ),
	              _react2.default.createElement(
	                _reactSlick2.default,
	                settings_partners,
	                _react2.default.createElement(
	                  "div",
	                  { "class": "sliderbgpadded slider_partners" },
	                  _react2.default.createElement("img", { src: "/images/sliders/partners/slider_1.png" })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { "class": "sliderbgpadded slider_partners" },
	                  _react2.default.createElement("img", { src: "/images/sliders/partners/slider_2.png" })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { "class": "sliderbgpadded slider_partners" },
	                  _react2.default.createElement("img", { src: "/images/sliders/partners/slider_3.png" })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { "class": "sliderbgpadded slider_partners" },
	                  _react2.default.createElement("img", { src: "/images/sliders/partners/slider_4.png" })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { "class": "sliderbgpadded slider_partners" },
	                  _react2.default.createElement("img", { src: "/images/sliders/partners/slider_5.png" })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { "class": "sliderbgpadded slider_partners" },
	                  _react2.default.createElement("img", { src: "/images/sliders/partners/slider_6.png" })
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { "class": "col-lg-12 col-sm-12" },
	            _react2.default.createElement(
	              "div",
	              { "class": "sliderfullwidth" },
	              _react2.default.createElement(
	                "div",
	                { "class": "slider_text" },
	                "Access all important metrics with our ",
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  "comprehensive dashboard"
	                )
	              ),
	              _react2.default.createElement(
	                _reactSlick2.default,
	                settings_dashboards,
	                _react2.default.createElement(
	                  "div",
	                  { "class": "sliderbgpadded" },
	                  _react2.default.createElement("img", { src: "/images/sliders/slider_1.png" })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { "class": "sliderbgpadded" },
	                  _react2.default.createElement("img", { src: "/images/sliders/slider_2.png" })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { "class": "sliderbgpadded" },
	                  _react2.default.createElement("img", { src: "/images/sliders/slider_3.png" })
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { "class": "col-lg-12 col-sm-12 yelbg", style: { backgroundImage: "url('/images/yelloartline.png')" } },
	            _react2.default.createElement(
	              "div",
	              { "class": "new_plan_section mobileonly" },
	              _react2.default.createElement(
	                "div",
	                { "class": "colored_centered" },
	                "Get ",
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  "Started"
	                )
	              ),
	              this.state.schoolpreschoolselected && _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                  "div",
	                  { "class": "newpricing" },
	                  _react2.default.createElement(
	                    "div",
	                    { "class": "fixedbar" },
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "headofit" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flx planfeatures" },
	                        "Features"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flx plantitle magic" },
	                        "Magic"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flx plantitle standard " },
	                        "Standard"
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { "class": "scrollingview" },
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bodyofit" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack featureitem" },
	                        "24x 7 visibility for Target Audience with:"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bodyofit" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack featureitem" },
	                        "Professional  digital presence"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bodyofit" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack featureitem" },
	                        "Post your Ad in landing page"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bodyofit" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack featureitem" },
	                        "Visiblity and respond to review / ratings "
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bodyofit" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack featureitem" },
	                        "Upload Pictures on page"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement(
	                          "span",
	                          null,
	                          "3 Free"
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement(
	                          "span",
	                          null,
	                          "Upto 15"
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bodyofit" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack featureitem" },
	                        "Upload video on page"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bodyofit" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack featureitem" },
	                        "Direct interaction with parents "
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bodyofit" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack featureitem" },
	                        "Featured in Trending Now"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bodyofit" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack featureitem" },
	                        "Collaborative social media support"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bodyofit" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack featureitem" },
	                        "Verified partner stamp "
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bodyofit" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack featureitem" },
	                        "Receive Leads & enquires"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bodyofit" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack featureitem" },
	                        "Benchmark to your peers / competitors "
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bodyofit" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack featureitem" },
	                        "Build your brand & thought leadership."
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bodyofit" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack featureitem" },
	                        "Ads & newsletter promotion @ special prices"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bodyofit" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack featureitem" },
	                        "Free benefits of INR 50K+ + from curated partner support"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bodyofit" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack featureitem" },
	                        "Scope for collaborative & customised services"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bodyofit" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack featureitem" },
	                        "Pricing & benefits @ WiseConnect"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bodyofit" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack featureitem" },
	                        "Data & analytics to accelerate growth"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement(
	                          "span",
	                          null,
	                          "Partly Free"
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bodyofit" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack featureitem" },
	                        "Access to Skill building / self-development "
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement(
	                          "span",
	                          null,
	                          "Partly Free"
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bodyofit" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack featureitem" },
	                        " ",
	                        _react2.default.createElement(
	                          "div",
	                          { "class": "flxblack featureitem" },
	                          "*BeWise annual subscription only"
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement(
	                          "div",
	                          { "class": "viewpricing" },
	                          this.state.isMagicPriceClikedView && _react2.default.createElement(
	                            "div",
	                            null,
	                            _react2.default.createElement(
	                              "span",
	                              { "class": "stricked" },
	                              "Rs. 29999"
	                            ),
	                            _react2.default.createElement(
	                              "span",
	                              null,
	                              "Rs. 24999/-"
	                            )
	                          ),
	                          !this.state.isMagicPriceClikedView && _react2.default.createElement(
	                            "span",
	                            { onClick: this.showMagicPrice },
	                            "view price"
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        "FREE"
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { "class": "colored_centered" },
	                  " ",
	                  _react2.default.createElement(
	                    "a",
	                    { href: "/institution_signup", "class": "btn new-btn-blue-large" },
	                    "Sign Up Now!"
	                  ),
	                  " "
	                )
	              ),
	              this.state.otherselected && _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                  "div",
	                  { "class": "newpricing" },
	                  _react2.default.createElement(
	                    "div",
	                    { "class": "fixedbar" },
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "headofit" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flx planfeatures" },
	                        "Features"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flx plantitle magic" },
	                        "Value"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flx plantitle standard " },
	                        "Standard"
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { "class": "scrollingview" },
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bodyofit" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack featureitem" },
	                        "24x 7 visibility for Target Audience with"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bodyofit" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack featureitem" },
	                        "Professional  digital presence"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bodyofit" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack featureitem" },
	                        "Visiblity and respond to review / ratings "
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bodyofit" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack featureitem" },
	                        "Use page as own Web Page in marketing"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bodyofit" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack featureitem" },
	                        "Upload Pictures on page"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bodyofit" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack featureitem" },
	                        "Upload video on page"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bodyofit" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack featureitem" },
	                        "Direct interaction with parents "
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bodyofit" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack featureitem" },
	                        "Featured in Trending Now"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bodyofit" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack featureitem" },
	                        "Verified partner stamp"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bodyofit" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack featureitem" },
	                        "Receive Leads & enquires"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bodyofit" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack featureitem" },
	                        "Benchmark to your peers / competitors"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bodyofit" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack featureitem" },
	                        "Free benefits of INR 25K+ + from curated partner support"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bodyofit" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack featureitem" },
	                        "Ads & newsletter promotion @ special prices "
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bodyofit" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack featureitem" },
	                        "Scope for collaborative & customised services"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bodyofit" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack featureitem" },
	                        "Data & analytics to accelerate growth"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement(
	                          "span",
	                          null,
	                          "Partly Free"
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bodyofit" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack featureitem" },
	                        "Pricing & benefits @ WiseConnect"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement(
	                          "span",
	                          null,
	                          "Partly Free"
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "bodyofit" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack featureitem" },
	                        "*Annual Subscription Fees"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        _react2.default.createElement(
	                          "div",
	                          { "class": "viewpricing" },
	                          this.state.isValuePriceClikedView && _react2.default.createElement(
	                            "span",
	                            null,
	                            "Rs. 12499/-"
	                          ),
	                          !this.state.isValuePriceClikedView && _react2.default.createElement(
	                            "span",
	                            { onClick: this.showValuePrice },
	                            "view price"
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "flxblack planstatus" },
	                        "FREE"
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { "class": "colored_centered" },
	                  " ",
	                  _react2.default.createElement(
	                    "a",
	                    { href: "/individual_signup", "class": "btn new-btn-blue-large" },
	                    "Sign Up Now!"
	                  ),
	                  " "
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { "class": "plan_section desktop" },
	              _react2.default.createElement(
	                "div",
	                { "class": "colored_centered" },
	                "Get ",
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  "Started"
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { "class": "planbox" },
	                this.state.schoolpreschoolselected && _react2.default.createElement(
	                  "div",
	                  { "class": "newtable" },
	                  _react2.default.createElement(
	                    "table",
	                    { width: "100%", cellSpacing: 2, cellPadding: 2, "class": "__table" },
	                    _react2.default.createElement(
	                      "tr",
	                      null,
	                      _react2.default.createElement(
	                        "td",
	                        { width: "50%" },
	                        "\xA0"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { width: "15%" },
	                        _react2.default.createElement(
	                          "span",
	                          { "class": "s_plantitle" },
	                          "Standard"
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { width: "15%" },
	                        _react2.default.createElement(
	                          "span",
	                          { "class": "v_plantitle" },
	                          "Magic"
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { width: "20%" },
	                        _react2.default.createElement(
	                          "span",
	                          { "class": "v_plantitle pluswc" },
	                          "Magic+WC"
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      { "class": "parent", "data-child": "audience_with" },
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "plbbolder", width: "50%" },
	                        "24x 7 visibility for Target Audience ",
	                        _react2.default.createElement(
	                          "span",
	                          { "class": "onclick_expcol" },
	                          _react2.default.createElement("img", { src: "/images/chevron-down.svg" })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { width: "15%" },
	                        "\xA0"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "15%" },
	                        "\xA0"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { width: "20%" },
	                        "\xA0"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      { "class": "child audience_with hidden" },
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "plb", width: "50%" },
	                        "Enhanced digital presence"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "15%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "15%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "20%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      { "class": "child audience_with hidden" },
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "plb", width: "50%" },
	                        "Post your Ad in landing page"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "15%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "15%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "20%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      { "class": "child audience_with hidden" },
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "plb", width: "50%" },
	                        "Visiblity and respond to review / ratings"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "15%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "15%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "20%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      { "class": "child audience_with hidden" },
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "plb", width: "50%" },
	                        "Use page as own Web Page in marketing"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "15%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "15%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "20%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      { "class": "child audience_with hidden" },
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "plb", width: "50%" },
	                        "Upload Pictures on page"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "15%" },
	                        _react2.default.createElement(
	                          "span",
	                          { "class": "plantext" },
	                          "3 Free"
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "15%" },
	                        _react2.default.createElement(
	                          "span",
	                          { "class": "plantext" },
	                          "Upto 15"
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "20%" },
	                        _react2.default.createElement(
	                          "span",
	                          { "class": "plantext" },
	                          "Upto 15"
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      { "class": "child audience_with hidden" },
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "plb", width: "50%" },
	                        "Direct interaction with parents "
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "15%" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "15%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "20%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      { "class": "child audience_with hidden" },
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "plb", width: "50%" },
	                        "Featured in Trending Now"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "15%" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "15%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "20%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      { "class": "child audience_with hidden" },
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "plb", width: "50%" },
	                        "Collaborative social media support"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "15%" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "15%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "20%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      { "class": "child audience_with hidden" },
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "plb", width: "50%" },
	                        "Verified partner stamp "
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "15%" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "15%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "20%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      null,
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "plbbolder", width: "50%" },
	                        "Receive Leads & enquires "
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "15%" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "15%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "20%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      null,
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "plbbolder", width: "50%" },
	                        "Benchmark to your peers / competitors"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "15%" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "15%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "20%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      null,
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "plbbolder", width: "50%" },
	                        "Build your brand & thought leadership"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "15%" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "15%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "20%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      null,
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "plbbolder", width: "50%" },
	                        "Exclusive Benefits from curated partner support"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "15%" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "15%" },
	                        "INR 50K++"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "20%" },
	                        "INR 50K++"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      null,
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "plbbolder", width: "50%" },
	                        "Strengthen brand awareness via exclusive Ads"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "15%" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "15%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "20%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      null,
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "plbbolder", width: "50%" },
	                        "Data & analytics to accelerate growth "
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "15%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "15%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "20%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      null,
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "plbbolder", width: "50%" },
	                        "Access to Skill building / self-development "
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "15%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "15%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "20%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      null,
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "plbbolder", width: "50%" },
	                        "Instant Talent Search and call shortlisted candidates"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "15%" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "15%" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "20%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      null,
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "plbbolder", width: "50%" },
	                        "Post Jobs & receive applications from talent "
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "15%" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "15%" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "20%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      null,
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "plbbolder", width: "50%" },
	                        "Private & direct interaction with candidates / applications "
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "15%" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "15%" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "20%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      null,
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "plbbolder", width: "50%" },
	                        "Full access to Courses / Products / articles @ Portal "
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "15%" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "15%" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "20%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      null,
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "plbbolder", width: "50%" },
	                        "Full access to all curated benefits from our Partners "
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "15%" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "15%" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "20%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      null,
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "plbbolder", width: "50%" },
	                        "Available data analytics, reports & benchmarks. "
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "15%" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "15%" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "20%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      null,
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "plbbolder", width: "50%" },
	                        "Download Resume / CV "
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "15%" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "15%" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "20%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      null,
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "plbbolder", width: "50%" },
	                        "Strengthen brand awareness amongst potential talents"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "15%" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "15%" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "20%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      null,
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "plbbolder", width: "50%" },
	                        "Avail advisory services"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "15%" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "15%" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "20%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      null,
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "plbbolder", width: "50%" },
	                        "Nil retainer fees for hiring candidates"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "15%" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "15%" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "20%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      null,
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "plbbolder", width: "50%" },
	                        "\xA0"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndpricetd", width: "15%" },
	                        _react2.default.createElement(
	                          "div",
	                          { "class": "viewpricing" },
	                          this.state.isStandardPriceClikedView1 && _react2.default.createElement(
	                            "span",
	                            null,
	                            "FREE"
	                          ),
	                          !this.state.isStandardPriceClikedView1 && _react2.default.createElement(
	                            "span",
	                            { onClick: this.showStandardPrice1 },
	                            "view price"
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "valuepricetd", width: "15%" },
	                        _react2.default.createElement(
	                          "div",
	                          { "class": "viewpricinginblue" },
	                          this.state.isMagicPriceClikedView && _react2.default.createElement(
	                            "div",
	                            null,
	                            _react2.default.createElement(
	                              "div",
	                              null,
	                              _react2.default.createElement(
	                                "span",
	                                { "class": "stricken" },
	                                "\u20B9 29999"
	                              ),
	                              _react2.default.createElement(
	                                "span",
	                                null,
	                                _react2.default.createElement(
	                                  "b",
	                                  null,
	                                  " \u20B9 24999 /- "
	                                ),
	                                _react2.default.createElement("br", null),
	                                _react2.default.createElement(
	                                  "span",
	                                  { "class": "planinfomsg" },
	                                  "Annual subscription (BeWise)"
	                                )
	                              )
	                            )
	                          ),
	                          !this.state.isMagicPriceClikedView && _react2.default.createElement(
	                            "span",
	                            { onClick: this.showMagicPrice },
	                            "view price"
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "valuepricetd", width: "20%" },
	                        _react2.default.createElement(
	                          "div",
	                          { "class": "viewpricinginblue pluswc" },
	                          this.state.isMagicWcPriceClikedView && _react2.default.createElement(
	                            "div",
	                            null,
	                            _react2.default.createElement(
	                              "div",
	                              null,
	                              _react2.default.createElement(
	                                "span",
	                                null,
	                                "\u20B9 29999 /- ",
	                                _react2.default.createElement("br", null),
	                                _react2.default.createElement(
	                                  "span",
	                                  { "class": "planinfomsg" },
	                                  "Annual subscription (BeWise + WiseConnect)",
	                                  _react2.default.createElement(
	                                    "a",
	                                    { href: "", "class": "planinfolink" },
	                                    "Benefits of WiseConnect"
	                                  )
	                                )
	                              )
	                            )
	                          ),
	                          !this.state.isMagicWcPriceClikedView && _react2.default.createElement(
	                            "span",
	                            { onClick: this.showMagicWcPrice },
	                            "view price"
	                          )
	                        )
	                      )
	                    )
	                  )
	                ),
	                this.state.otherselected && _react2.default.createElement(
	                  "div",
	                  { "class": "newtable" },
	                  _react2.default.createElement(
	                    "table",
	                    { width: "100%", cellSpacing: 2, cellPadding: 2 },
	                    _react2.default.createElement(
	                      "tr",
	                      null,
	                      _react2.default.createElement(
	                        "td",
	                        { width: "50%" },
	                        "\xA0"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { width: "25%" },
	                        _react2.default.createElement(
	                          "span",
	                          { "class": "s_plantitle" },
	                          "Standard"
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { width: "25%" },
	                        _react2.default.createElement(
	                          "span",
	                          { "class": "v_plantitle" },
	                          "Value"
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { width: "25%" },
	                        _react2.default.createElement(
	                          "span",
	                          { "class": "v_plantitle" },
	                          "Value+WC"
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      null,
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "plbbolder", width: "50%" },
	                        "24x 7 visibility for Target Audience with"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { width: "25%" },
	                        "\xA0"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "bluebgtd", width: "25%" },
	                        "\xA0"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "bluebgtd", width: "25%" },
	                        "\xA0"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      null,
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "plb", width: "50%" },
	                        "Enhanced digital presence"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "25%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "bluebgtd", width: "25%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "bluebgtd", width: "25%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      null,
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "plb", width: "50%" },
	                        "Visiblity and respond to review / ratings"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "25%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "bluebgtd", width: "25%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "bluebgtd", width: "25%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      null,
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "plb", width: "50%" },
	                        "Use page as own Web Page in marketing"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "25%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "bluebgtd", width: "25%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "bluebgtd", width: "25%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      null,
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "plb", width: "50%" },
	                        "Upload Pictures on page"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "25%" },
	                        _react2.default.createElement(
	                          "span",
	                          { "class": "plantext" },
	                          "2 Free"
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "bluebgtd", width: "25%" },
	                        _react2.default.createElement(
	                          "span",
	                          { "class": "plantext" },
	                          "Upto 10"
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "bluebgtd", width: "25%" },
	                        _react2.default.createElement(
	                          "span",
	                          { "class": "plantext" },
	                          "Upto 10"
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      null,
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "plb", width: "50%" },
	                        "Direct interaction with parents "
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "25%" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "bluebgtd", width: "25%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "bluebgtd", width: "25%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      null,
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "plb", width: "50%" },
	                        "Featured in Trending Now"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "25%" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "bluebgtd", width: "25%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "bluebgtd", width: "25%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      null,
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "plb", width: "50%" },
	                        "Verified partner stamp "
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "25%" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "bluebgtd", width: "25%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "bluebgtd", width: "25%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      null,
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "plbbolder", width: "50%" },
	                        "Receive Leads & enquires "
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "25%" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "bluebgtd", width: "25%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "bluebgtd", width: "25%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      null,
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "plbbolder", width: "50%" },
	                        "Benchmark to your peers / competitors"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "25%" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "bluebgtd", width: "25%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "bluebgtd", width: "25%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      null,
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "plbbolder", width: "50%" },
	                        "Exclusive Benefits from curated partner support"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "25%" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "bluebgtd", width: "25%" },
	                        "INR 25K++"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "bluebgtd", width: "25%" },
	                        "INR 25K++"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      null,
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "plbbolder", width: "50%" },
	                        "Strengthen brand awareness via exclusive Ads "
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "25%" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "bluebgtd", width: "25%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "bluebgtd", width: "25%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      null,
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "plbbolder", width: "50%" },
	                        "Scope for collaborative & customised services "
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "25%" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "bluebgtd", width: "25%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "bluebgtd", width: "25%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      null,
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "plbbolder", width: "50%" },
	                        "Data & analytics to accelerate growth "
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndtd", width: "25%" },
	                        _react2.default.createElement(
	                          "span",
	                          { "class": "plantext" },
	                          "Partly Free"
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "bluebgtd", width: "25%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "bluebgtd", width: "25%" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      null,
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "plbbolder", width: "50%" },
	                        "\xA0"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "stndpricetd", width: "25%" },
	                        _react2.default.createElement(
	                          "div",
	                          { "class": "viewpricing" },
	                          this.state.isStandardPriceClikedView2 && _react2.default.createElement(
	                            "span",
	                            null,
	                            "FREE"
	                          ),
	                          !this.state.isStandardPriceClikedView2 && _react2.default.createElement(
	                            "span",
	                            { onClick: this.showStandardPrice2 },
	                            "view price"
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "valuepricetd", width: "25%" },
	                        _react2.default.createElement(
	                          "div",
	                          { "class": "viewpricinginblue" },
	                          this.state.isValuePriceClikedView && _react2.default.createElement(
	                            "span",
	                            null,
	                            "Rs. 12499 /- ",
	                            _react2.default.createElement("br", null),
	                            _react2.default.createElement(
	                              "span",
	                              null,
	                              "Annual Subscription Fees"
	                            )
	                          ),
	                          !this.state.isValuePriceClikedView && _react2.default.createElement(
	                            "span",
	                            { onClick: this.showValuePrice },
	                            "view price"
	                          )
	                        )
	                      )
	                    )
	                  )
	                ),
	                this.state.schoolpreschoolselected && _react2.default.createElement(
	                  "div",
	                  { "class": "colored_centered" },
	                  " ",
	                  _react2.default.createElement(
	                    "a",
	                    { href: "/institution_signup", "class": "btn new-btn-blue-large" },
	                    "Sign Up Now!"
	                  ),
	                  " "
	                ),
	                this.state.otherselected && _react2.default.createElement(
	                  "div",
	                  { "class": "colored_centered" },
	                  " ",
	                  _react2.default.createElement(
	                    "a",
	                    { href: "/individual_signup", "class": "btn new-btn-blue-large" },
	                    "Sign Up Now!"
	                  ),
	                  " "
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_Footer2.default, null)
	      );
	    }
	  }]);
	
	  return NewPartnerInstitutionPage;
	}(_react.Component);
	
	exports.default = NewPartnerInstitutionPage;

/***/ },
/* 868 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Header = __webpack_require__(187);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(82);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var About = function (_Component) {
	  _inherits(About, _Component);
	
	  function About() {
	    _classCallCheck(this, About);
	
	    return _possibleConstructorReturn(this, (About.__proto__ || Object.getPrototypeOf(About)).apply(this, arguments));
	  }
	
	  _createClass(About, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {}
	  }, {
	    key: "render",
	    value: function render() {
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          "div",
	          { className: "container-fluid full-width nopadding" },
	          _react2.default.createElement(
	            "div",
	            { className: "row nomargin" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-sm-12 header-color" },
	              _react2.default.createElement(_Header2.default, null)
	            )
	          ),
	          _react2.default.createElement(
	            "section",
	            { "class": "breadcrumb-area" },
	            _react2.default.createElement(
	              "div",
	              { "class": "container" },
	              _react2.default.createElement(
	                "div",
	                { "class": "row" },
	                _react2.default.createElement(
	                  "div",
	                  { "class": "col-lg-12 col-sm-12 col-xs-12" },
	                  _react2.default.createElement(
	                    "div",
	                    { "class": "left-side pull-left pad10top headng" },
	                    _react2.default.createElement(
	                      "h1",
	                      null,
	                      "About"
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { "class": "about-page" },
	            _react2.default.createElement(
	              "section",
	              { className: "py-4" },
	              _react2.default.createElement(
	                "div",
	                { className: "container" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "row no-margin" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-sm-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "about-wrap mar-btm" },
	                        _react2.default.createElement(
	                          "div",
	                          { "class": "row" },
	                          _react2.default.createElement(
	                            "div",
	                            { "class": "col-md-12" },
	                            _react2.default.createElement(
	                              "div",
	                              { "class": "list-single-main-item-title fl-wrap" },
	                              _react2.default.createElement(
	                                "h3",
	                                null,
	                                "Welcome to  ",
	                                _react2.default.createElement(
	                                  "span",
	                                  null,
	                                  "BeWise"
	                                )
	                              )
	                            ),
	                            _react2.default.createElement(
	                              "p",
	                              null,
	                              "Our inspiration to create BeWise came from our vision to simplify the decision-making process for parents concerning their child's holistic development, besides enabling institutions & Individuals serving these parents', to accelerate their brand building & reach in the high paced & evolving digital landscape."
	                            ),
	                            _react2.default.createElement(
	                              "p",
	                              null,
	                              "Across different cities and countries, the BeWise team is made up of professionals like you who have faced similar challenges to your own, as parents working to help their children succeed in life. Keeping your child enrolled in a progressive ecosystem can be challenging when you're multitasking and prioritizing a range of professional and life responsibilities."
	                            ),
	                            _react2.default.createElement(
	                              "p",
	                              null,
	                              _react2.default.createElement("img", { "class": "abt-banner", src: "https://www.bewise.in/assets/images/aboutus/aboutusbanner.png" })
	                            ),
	                            _react2.default.createElement(
	                              "p",
	                              null,
	                              "A parent must make decisions that have a direct impact on the well-being & growth of their child. Collaboration is needed, along with suggestions based on experience, to ensure that our decision-making is right, appropriate, and tailored to our child's uniqueness. It is BeWise's aim to make a positive impact on the parenting community through consistent improvement over time."
	                            ),
	                            _react2.default.createElement(
	                              "h2",
	                              null,
	                              "Towards the Future"
	                            ),
	                            _react2.default.createElement(
	                              "p",
	                              null,
	                              "We serve both relocating parents & resident parents & help in discovering the best suited option for both the parent & child across all the areas of a child's learning. Fortunately, we have your back from activities to events & this could range from a highly recommended private or public school or any after-school activities of interest, be it a musician, sports coach or a birthday event organizer. We've got you covered keeping your time, budget, schedules, reviews, facilities and localities in mind."
	                            ),
	                            _react2.default.createElement(
	                              "p",
	                              null,
	                              "We endeavour to deliver best outcomes that suit your needs, with best suited features of search engines, social media, and e-commerce all together at one single location with total focus & emphasis for holistic education. By connecting you with parents and partner providers, BeWise will help you maximize value for time, effort, and money. Additionally your experience and inputs will contribute to helping raise the bar for the partner & parent community."
	                            ),
	                            _react2.default.createElement(
	                              "h2",
	                              null,
	                              "\xA0"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_Footer2.default, null)
	      );
	    }
	  }]);
	
	  return About;
	}(_react.Component);
	
	exports.default = About;

/***/ },
/* 869 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Header = __webpack_require__(187);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(82);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _reactstrap = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Faq = function (_Component) {
	  _inherits(Faq, _Component);
	
	  function Faq(props) {
	    _classCallCheck(this, Faq);
	
	    var _this = _possibleConstructorReturn(this, (Faq.__proto__ || Object.getPrototypeOf(Faq)).call(this, props));
	
	    _this.toggle = function (e, event) {
	      e.preventDefault();
	      _this.setState({
	        collapse: _this.state.collapse === Number(event) ? -1 : Number(event),
	        loginPop: false
	      });
	    };
	
	    _this.state = {
	      collapse: -1,
	      loginPop: false
	    };
	    _this.toggle = _this.toggle.bind(_this);
	    return _this;
	  }
	
	  _createClass(Faq, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {}
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var collapse = this.state.collapse;
	
	      var faqArr = [{
	        isGeneral: true,
	        qus: 'What does BeWise offer?',
	        ans: "\n        <p>Parents, in their tireless effort to provide children the best education, fun, \n        skills and training, lean heavily either on personal networks or on web search engines.</p>\n        <p>BeWise is a comprehensive search platform to the parent that helps you with all relevant\n         information / available options and alternatives with filters to help you evaluate the \n         options resourcefully, there by remain wise in your decision making.&nbsp; You will \n         be able to discover, search, filter based on key needs and choose best suited for \n         you and your child across academic and non-academic learning.&nbsp; These includes - \n         <a href=\"https://www.bewise.in/bengaluru/schools/private-schools\">Schools</a>, \n         <a href=\"https://www.bewise.in/bengaluru/pre-schools/kindergarten\">Preschools</a>, \n         <a href=\"https://www.bewise.in/bengaluru/after-school-activity/sports\">After School \n         Activities</a> like <a href=\"https://www.bewise.in/bengaluru/after-school-activity/music\">\n         Music</a>, Sports or extra curriculars, <a href=\"https://www.bewise.in/bengaluru/tuitions/mathematics\">\n         Tuitions</a>, <a href=\"https://www.bewise.in/bengaluru/kids-play-area/indoor\">Play areas</a>\n         , Counsellor support, short and long-term <a href=\"https://www.bewise.in/learning-camps/curated-learning-camps\">\n         Learning camps</a>, Birthday celebration options and latest in education for the young and \n         many more. Bewise aims to be your one stop solution for in helping you discover &amp; \n         manage the learning journey for your child and enable quality outcomes you seek.</p>\n        "
	      }, {
	        isGeneral: true,
	        qus: "I am a parent of a toddler, how can BeWise be helpful for me?",
	        ans: "\n        <p>BeWise helps you&nbsp;find, compare, follow an institution or individual to understand their \n        progress, begin potential exploration / interactions with institutions like pre - \n        schools / schools / afterschool&rsquo;s, play areas, explore \n        <a href=\"https://www.bewise.in/bengaluru/birthday-event/venues\">birthday venues</a>, \n        explore online or offline learning options that is of interest to the child etc.</p>\n        <p>All this at <a href=\"https://www.bewise.in/\">BeWise</a> your one stop platform for \n        child&rsquo;s growth</p>\n        "
	      }, {
	        isGeneral: true,
	        qus: "Is the access to BeWise free?",
	        ans: "\n        <p>Yes, access to BeWise parent portal is free for the entire parent community.</p>\n        "
	      }, {
	        isGeneral: true,
	        qus: "As a parent what benefits do I receive once I signup?",
	        ans: "\n        <p>Your sign up is for free as a parent.</p>\n        <p>You will be able to discover, search, compare and choose across \n        <strong>all learning options</strong> available for your child (Below 15 Y) very \n        easily based on your specific need in the search.&nbsp;</p>\n        <p>For example &ndash; Distance / Fees / Online or offline / At your residence or \n        nearby / Syllabus / Facilities / Reviews / Rankings where available etc.&nbsp;</p>\n        <p>Additionally, you will have easy access to \n        <a href=\"https://www.bewise.in/bengaluru/community-support/articles-blogs\">\n        insightful articles</a>, newsletters, to help you maximise value, signing up for \n        events of interest, free downloads or freebies, getting notified from the institutions \n        you follow and more.&nbsp; We will continue strive &amp; ensure you are updated with \n        quality information and aware of trends that keeps you ahead on the curve.&nbsp; \n        Only you will choose to share your contacts with any &amp; we will not be sharing \n        with any organization or individual and hence none will inundate you with phone \n        calls or spam your mailboxes.</p>\n        "
	      }, {
	        isGeneral: true,
	        qus: "I can't get access to all the data on the institutions, what can I do?",
	        ans: "\n        <p>Not able to access all information, not to worry.&nbsp; You might have just \n        missed the step of being registered at our platform.&nbsp; To get full access to \n        all details of every provider.&nbsp; @BeWise one must follow 4 simple steps of \n        registration.</p>\n        <ol>\n        <li><a href='https://www.bewise.in'>Signup</a> with your mail id, or sign up via Google/Gmail/Facebook</li>\n        <li>Enter relevant and basic information.</li>\n        <li>Confirm with a click on welcome mail sent @ your registered mail id.</li>\n        <li>Log in now and you are ready for search and all the available information will be easily visible during your search.</li>\n        </ol>\n        "
	      }, {
	        isGeneral: true,
	        qus: "What should I do to Rate/ Review an institution from my experience?",
	        ans: "\n        <p><strong>Who can see my reviews?&nbsp; Will my name and details be displayed \n        to all?</strong></p>\n        <p>Only registered users can review / rate an institution.&nbsp; <a href='https://www.bewise.in'>Signup</a> to \n        share your experience &amp; support the entire community with a quality review \n        from your experience which is of absolute value to all parties.&nbsp; Will help \n        another parent make a wise decision for his / her child, besides is an \n        opportunity for organisations / individuals to improve further or stay \n        motivated &amp; serve you even better.&nbsp;&nbsp;&nbsp; Genuine reviews \n        enable every parent to evaluate value &amp; understand challenges in working \n        with an institution / individual.&nbsp;</p>\n        <p>@ BeWise, your review on a scale of 1-5 gets averaged and is a good balance \n        amidst multiple experiences. However, your words used at the feedback / review \n        carry a much higher value / deeper insights / interpretations to everyone \n        reading.&nbsp; 3 Simple handrails to follow for a quality review are:</p>\n        <ul>\n        <li>Provide factual &amp; constructive feedback. Short and specific</li>\n        <li>Good to feedback on overall experience &ndash; not just one specific point.</li>\n        <li>Do review / proofread - once before submitting it.</li>\n        </ul>\n        <p><strong>Can I edit my review?</strong></p>\n        <p>You can edit your review for the next 30 days in case you change your \n        opinion or prefer to rephrase the words. Your rating and comments will \n        immediately show up on the portal, however, will remain anonymous as our \n        objective is not bring out names or grades of your children.</p>\n        <p>Thank you for the time taken to review.</p>\n        "
	      }, {
	        isGeneral: true,
	        qus: "What is compare option? Can I compare any 2 institutions? How to use this?",
	        ans: "\n        <p>Yes &ndash; a parent once registered @ BeWise can leverage this compare option \n        during any search.&nbsp; This tool helps you bring all your choices together in one \n        page, so that your decision making / discussions with relevant folks are supported \n        with quality data.</p>\n        <p>Once signed into BeWise portal, below steps enable you maximise:</p>\n        <ul class='ul-tick'>\n        <li>At every home page of an institution or individual @ BeWise, you will find \n        the compare button on top of the page.</li>\n        <li>When you are on the page, and like an institution or individual, click on \n        this compare button. In doing so, you add this page to your compare list.</li>\n        <li>Repeat process for up to a max of top 3 institutions you like within each \n        of the 8 categories we have listed them under.</li>\n        <li>When ready to review list &ndash; click on your profile icon at top of any \n        page. Scroll down to choose the compare and click on the same.</li>\n        <li>You will be moved to a page where all categories are listed with the number \n        of compare options you chose overtime. Choose and click on category you want to \n        activate compare currently.</li>\n        <li>All added options will show up on this page that narrates your choices &amp; \n        compares parameters that will help you see differences &amp; similarities. \n        Helps you prioritize and enables you choose best suited.</li>\n        <li>You can increase count of comparisons by following steps of deleting an \n        eliminated option &amp; continue adding similar options - as you work through \n        decisions when in the compare option.</li>\n        </ul>\n        "
	      }, {
	        isGeneral: true,
	        qus: "How do I find a school located in my area, what can I do?",
	        ans: "\n        <p>Yes, this is quite easy with the Sharpen Your Search Option \n        available on the portal.</p>\n        <ul class='ul-tick'>\n        <li>Choose sharpen your search option and in filters &ndash; choose location \n        and type name of the locality you want to look up for a specific need.</li>\n        <li>Revise distance pin &amp; move it to the distance you will be comfortable \n        with. Example when you choose MG road, how many Kilometres distance away \n        from MG road you are willing to consider as your area.</li>\n        <li>The list automatically drops to your chosen distances &amp; ta da &ndash; \n        you have list of institutions as per your filter. schools or any other options in learning.</li>\n        <li>We would encourage you to use all the filters that help you get sharper \n        in your search and not just location alone.</li>\n        </ul>\n        <p>Note: online learning does not have certain filters like distance applicable.</p>\n        "
	      }, {
	        isGeneral: true,
	        qus: "Can I subscribe to the articles update from BeWise?",
	        ans: "\n        <p><u>OfCourse, its quite easy! </u></p>\n        <p>Yes, this can be done.&nbsp;</p>\n        <p>Please scroll to the bottom of any page and add your mail id to the subscription \n        list and you will start receiving newsletters as and when published.</p>\n        <p>However, if you are following any specific author, you will automatically \n        receive updates once there is a new article from that author has been published \n        at the BeWise portal.</p>\n        "
	      }, {
	        isGeneral: true,
	        qus: "Can I write an article for BeWise? One that helps the community of parents & will it be \n        published @ BeWise for public read.",
	        ans: "\n        <p>Yes &amp; we welcome your contributions to serve the parent community whole \n        heartedly.&nbsp; We will publish the same once we have aligned with you on the \n        specific details and feel free to reach out to us @ <a href=\"mailto:Contact@bewise.in\">\n        Contact@bewise.in</a>. &nbsp;Our marketing team will stay in touch with you.&nbsp; \n        We look forward to interactions / feedback from you.</p>\n        "
	      }, {
	        isGeneral: true,
	        qus: "What does a follow button do on any page? What does a like button do?",
	        ans: "\n        <p>When you click here, you will receive intimations every time there is any current \n        update made by the institution / individual to their home page, new announcements, \n        issuing of applications etc.</p>\n        <p>Its good when you follow institutions / individuals as you can stay connected \n        to whatever the recent / current events so that you continue to remain updated.&nbsp; \n        Leveraging this option is also good for your child&rsquo;s current school or \n        other services provider as it keeps you abreast on their public announcements or \n        any latest developments which does not reach you through the normal intimation process.</p>\n        <p>Like button that is available is for the institution or other parents to know \n        and receive the feedback that you liked what you saw, although you may not be using \n        their services.</p>\n        <p>In either case &ndash; your contact details will not be shared with the \n        institution as per our privacy policy and you will not receive other non-required \n        mails to SPAM your inbox.</p>\n        "
	      }, {
	        isGeneral: true,
	        qus: "Will you share all or any of our data to suppliers when we browse your portal?",
	        ans: "\n        <p>No.&nbsp; We do not share any data about any parent to the providers.&nbsp; \n        Please refer our <a href='https://www.bewise.in/privacypolicy'>Privacy policy</a> </p>\n        <p>You will decide if you want to share your contact details to the providers \n        when you make that call / write the mail to ensure connections and usage of services</p>\n        "
	      }, {
	        isGeneral: true,
	        qus: "Do you provide guarantee for third-party sites / institutions provided at your portal?",
	        ans: "\n        <p>No.&nbsp; We do not provide any guarantee to any of the third parties in the portal \n        or for anything that we do not own. We are making our best attempt to reduce the pain \n        points that you will likely have when you are trying to reach the providers on your \n        own.&nbsp; Please read our <a href='https://www.bewise.in/termsconditions'>Terms &amp; Conditions </a> and \n        <a href='https://www.bewise.in/privacypolicy'>Privacy policy</a> \n        to ensure our commitments.</p>\n        <p>Having said that, we surely confirm the quality of information provided with our \n        selected <a href=\"https://partner.bewise.in/individual\">partners</a> / curated events / \n        BeWise endorsed partners as indicated on the pages.&nbsp; Our teams are making continuous \n        efforts to increase the reach of such partners and we will continue to improve \n        upon the same as our promise to serve you better.</p>\n        "
	      }, {
	        isGeneral: true,
	        qus: "Parents from which cities can gain the benefits from BeWise?",
	        ans: "\n        <p><a href=\"https://www.bewise.in/\">BeWise</a> is successfully launched in \n        Bangalore &amp; Chennai.</p>\n        <p>Other cities in the pipeline for next 4 months include Hyderabad, Madurai, Coimbatore.</p>\n        "
	      }, {
	        isPartner: true,
	        qus: 'What does BeWise offer for me to be a Partner / Tutor / Coach?',
	        ans: "\n        <p>You are already aware that the education industry in India &amp; Globally has \n        evolved and embraced plenty of changes over the last decade driven by technology \n        (Digital. Mobile, Web, AI etc) &amp; increasing customer expectations, besides \n        learnings from the pandemic.&nbsp; You will agree that this is now changing the \n        approach and options to leverage in reaching, your customer and managing growth.</p>\n        <p>BeWise helps in all your objectives and enables brand presence effectively &amp; \n        efficiently. We help you reach your target audience all through the year and help \n        your organisation take a much larger role in the education industry and the parent \n        community.&nbsp; You will gain substantial benefits &amp; support to growing your \n        brand &amp; business.&nbsp; More details for an \n        <a href=\"https://partner.bewise.in/institution\">Institution Partners</a> &amp; \n        for <a href=\"https://partner.bewise.in/individual\">Individual </a>contributors \n        in the ecosystem</p>\n        <p>Listed are a few benefits to help you thinking.&nbsp;</p>\n        <ul class='ul-tick'>\n        <li>Brand visibility &amp; Brand build with target audience 365 days of every year. \n        The journey for your brand begins even before a parent is thinking about any option, \n        &amp; not just when looking for your specific services.</li>\n        <li>Data driven Insights to help you understand trends in your specific service segment \n        even better and make wise decisions * 365. Business receive access to analytics for\n         this objective when partnered with us.</li>\n        <li>Insights from detailed reviews / ratings / comparisons help you work with \n        feedback and improvements so that you can build the brand you wanted to in the first place.</li>\n        <li>Effective communication on the BeWise portal helps quickly reach information to \n        prospects &amp; customers following you. Prospects can reach you on portal via \n        messages before agreeing to exchange contacts.</li>\n        <li>Leverage value from the new age partnerships we are building so that you \n        can accelerate your business growth &amp; capabilities.</li>\n        <li>BeWise helps you become a thought leader and a brand with the target audience \n        &amp; industry, for businesses who are keen to build brands longer term through \n        quality engagement &amp; content.</li>\n        <li>BeWise will help you in benchmarking efforts to organisations / individuals \n        with the same service offerings 365 days of the year. This will help you understand, \n        learn from &amp; enable a position of strength for yourself.</li>\n        <li>We are launching soon a teachers / coaches recruitment extension to our \n        portal. This is to help every institution in both short term and long-term \n        talent needs, efficiently.&nbsp;</li>\n        </ul>\n        <p>If you wish to speak with our business development team, please write to us \n        <a href=\"mailto:contact@bewise.in\">contact@bewise.in</a> &amp; Team \n        <a href=\"https://www.bewise.in/\">BeWise</a> we will reach out to you for clarifications.</p>\n        "
	      }, {
	        isPartner: true,
	        qus: "What benefits do I receive when advertising in your portal?",
	        ans: "\n        <p>Scope for advertising @ BeWise portal is limited.</p>\n        <p>We have a few banner/s space &amp; tickers which we encourage organisations \n        to use.&nbsp; Benefits when an institution uses these banners are as below \n        (Banners and tickers are at both ends of the portal &ndash; parents view &amp; our partners view)</p>\n        <ol>\n        <li>Grow brand visibility, brand recall &amp; brand recognition</li>\n        <li>Increase traffic to landing page @ BeWise or to your own web page.</li>\n        <li>Showcase any event, either pre or post event based on your objectives. \n        (Example an interschool competition or a victory for the institution in an event)</li>\n        <li>Sharing of specific information to target audience with parents or other \n        institutions (Moving campus / recruitment or enrolment drive etc)</li>\n        </ol>\n        "
	      }, {
	        isPartner: true,
	        qus: "Who will be able to see the parent reviews @ BeWise?  \n        Can we respond to the reviews received directly?  \n        Will you be helping us in getting quality reviews?",
	        ans: "\n        <p>Every registered visitor to the BeWise portal will get visibility to \n        the reviews and comments for any individual or institution.</p>\n        <p>Yes, one can respond to those reviews to the reviewer directly, \n        so that you can maximise in brand build or have an edit in ratings or \n        reviews. Conversion from an average review to a good review can happen \n        with your efforts in working with the feedback &amp; interactions with reviewers.</p>\n        <p>BeWise has the right to delete only inappropriate comments or poor \n        language to help a quality environment within the community, as part \n        of our terms and conditions.</p>\n        <p>We have planned marketing efforts to continuously improve the \n        quantity of reviews from parents and this is a time-consuming process.&nbsp;\n        However, we are willing to help accelerate this for every partner by cocreating \n        value.&nbsp; This would include requests for independent feedback via BeWise \n        from current customers / parents / community and share summarised feedback \n        to help you focus on potential improvement opportunities ahead.&nbsp; \n        Increased reviews would also impact the algorithms which drive higher brand visibility.</p>\n        "
	      }, {
	        isPartner: true,
	        qus: "Who will be uploading correct data in your team?  How fast can this be done?  ",
	        ans: "\n        <p>The registered partner will be uploading all the requested data in the account \n        page you can access after registration.&nbsp; The process is quite simple, and our \n        business development team can guide you if required.&nbsp; The first time go live \n        for a new sign up is 24 hours, however for the next time onwards &ndash; the upload \n        to page is immediate.</p>\n        <p>The entire updating of BeWise portal with quality information can take you \n        anywhere between 15 minutes to an hour depending on quality of time you spend on the same.</p>\n        "
	      }, {
	        isPartner: true,
	        qus: "How often can I update content on our pages?",
	        ans: "\n        <p>There is no restrictions to the number of times one can update content on their page. \n        We encourage everyone to keep this frequent and ensure quality updates so that \n        every parent understands your brand and values even better.</p>\n        "
	      }, {
	        isPartner: true,
	        qus: "Can I get detailed data on everyone browsing for my services in BeWise portal? ",
	        ans: "\n        <p>Our privacy policy does not allow us to share detailed data at an \n        individual level with any organisation.&nbsp; The partner account page will \n        always carry the information on number of visitors / trends / those who \n        have saved your profile and many similar.&nbsp;</p>\n        <p>Once the parent writes to your institution directly or call the number \n        provided for (Possible when you are listed as a BeWise partner), their mail \n        id or phone number enables you to be in touch with them directly to resolve \n        or support the query.</p>\n        "
	      }, {
	        isPartner: true,
	        qus: "Can I cancel my subscription midway of the year?  What is the process of cancellation?",
	        ans: "\n        <p>Yes, a partner can cancel the subscription anytime they choose to as per our \n        <a href='https://partner.bewise.in/termsconditions'>Terms and conditions</a> via the account page and reimbursements \n        will be sent across as per the said policy for the remaining period of contract.</p>\n        "
	      }, {
	        isPartner: true,
	        qus: "Is my subscription auto renewed?",
	        ans: "\n        <p>No, the subscription is not auto renewed, and you will receive an intimation \n        to renew the same and maintain continuity.  Auto renewal option is currently under review.</p>\n        "
	      }, {
	        isPartner: true,
	        qus: "Can I write or send articles about our institution that can be published @ BeWise?",
	        ans: "\n        <p>Yes. Only selected articles, exclusively written for BeWise communities of institutions \n        and parents agreed in advance around preselect topics shall be published at the \n        BeWise portal with support from our marketing teams.&nbsp; These \n        <a href=\"https://www.bewise.in/bengaluru/community-support/articles-blogs\">articles</a> \n        must be on topics that is focussed on value and insights to the parents and parent \n        community.&nbsp; We will also help leaders / authors with a larger reach at other \n        select electronic publications, we work and help build thought leadership and the \n        brand for your institution/ leaders.</p>\n        "
	      }, {
	        isPartner: true,
	        qus: "What data & Insights will I get for my subscription?",
	        ans: "\n        <p>Please click on links provide to understand specific benefits, data &amp; \n        insights you will receive as a partner at the BeWise portal&nbsp;</p>\n        <p>Click here if <a href=\"https://partner.bewise.in/institution\">Institution \n        Partner</a> &amp; If you are <a href=\"https://partner.bewise.in/individual\">Individual \n        Partner</a></p>\n        "
	      }];
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          "div",
	          { className: "container-fluid full-width nopadding" },
	          _react2.default.createElement(
	            "div",
	            { className: "row nomargin" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-sm-12 header-color" },
	              _react2.default.createElement(_Header2.default, null)
	            )
	          ),
	          _react2.default.createElement(
	            "section",
	            { "class": "breadcrumb-area" },
	            _react2.default.createElement(
	              "div",
	              { "class": "container" },
	              _react2.default.createElement(
	                "div",
	                { "class": "row" },
	                _react2.default.createElement(
	                  "div",
	                  { "class": "col-lg-12 col-sm-12 col-xs-12" },
	                  _react2.default.createElement(
	                    "div",
	                    { "class": "left-side pull-left headng" },
	                    _react2.default.createElement(
	                      "h1",
	                      null,
	                      "FAQ's "
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { "class": "about-page" },
	            _react2.default.createElement(
	              "section",
	              { className: "py-4" },
	              _react2.default.createElement(
	                "div",
	                { className: "container" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "row no-margin" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-sm-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "about-page" },
	                        _react2.default.createElement(
	                          "section",
	                          { "class": "custom-sec" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "container" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "about-wrap" },
	                              _react2.default.createElement(
	                                "div",
	                                { className: "container" },
	                                _react2.default.createElement(
	                                  "h4",
	                                  null,
	                                  "For Individual/ Institution"
	                                ),
	                                _react2.default.createElement(
	                                  _reactstrap.Card,
	                                  { className: "panel-group custom-card", style: { marginBottom: '1rem' } },
	                                  faqArr.map(function (item, index) {
	                                    if (item.isPartner) return _react2.default.createElement(
	                                      _react2.default.Fragment,
	                                      null,
	                                      _react2.default.createElement(
	                                        _reactstrap.CardHeader,
	                                        { onClick: function onClick(e) {
	                                            return _this2.toggle(e, index);
	                                          }, "data-event": index, className: "custom-card-heading" },
	                                        _react2.default.createElement(
	                                          "b",
	                                          null,
	                                          item.qus,
	                                          " "
	                                        ),
	                                        collapse !== index ? _react2.default.createElement(
	                                          "span",
	                                          { className: "pull-right" },
	                                          _react2.default.createElement("i", { "class": "fa fa-plus", "aria-hidden": "true" })
	                                        ) : _react2.default.createElement(
	                                          "span",
	                                          { className: "pull-right" },
	                                          _react2.default.createElement("i", { "class": "fa fa-minus", "aria-hidden": "true" })
	                                        )
	                                      ),
	                                      _react2.default.createElement(
	                                        _reactstrap.Collapse,
	                                        { isOpen: collapse === index },
	                                        _react2.default.createElement(
	                                          _reactstrap.CardBody,
	                                          { className: "panel-body" },
	                                          _react2.default.createElement("p", { dangerouslySetInnerHTML: { __html: item.ans } })
	                                        )
	                                      )
	                                    );
	                                  })
	                                ),
	                                _react2.default.createElement(
	                                  "h4",
	                                  null,
	                                  "General"
	                                ),
	                                _react2.default.createElement(
	                                  _reactstrap.Card,
	                                  { className: "panel-group custom-card", style: { marginBottom: '1rem' } },
	                                  faqArr.map(function (item, index) {
	                                    if (item.isGeneral) return _react2.default.createElement(
	                                      _react2.default.Fragment,
	                                      null,
	                                      _react2.default.createElement(
	                                        _reactstrap.CardHeader,
	                                        { onClick: function onClick(e) {
	                                            return _this2.toggle(e, index);
	                                          }, "data-event": index, className: "custom-card-heading" },
	                                        _react2.default.createElement(
	                                          "b",
	                                          null,
	                                          item.qus,
	                                          " "
	                                        ),
	                                        collapse !== index ? _react2.default.createElement(
	                                          "span",
	                                          { className: "pull-right" },
	                                          _react2.default.createElement("i", { "class": "fa fa-plus", "aria-hidden": "true" })
	                                        ) : _react2.default.createElement(
	                                          "span",
	                                          { className: "pull-right" },
	                                          _react2.default.createElement("i", { "class": "fa fa-minus", "aria-hidden": "true" })
	                                        )
	                                      ),
	                                      _react2.default.createElement(
	                                        _reactstrap.Collapse,
	                                        { isOpen: collapse === index },
	                                        _react2.default.createElement(
	                                          _reactstrap.CardBody,
	                                          { className: "panel-body" },
	                                          _react2.default.createElement("p", { dangerouslySetInnerHTML: { __html: item.ans } })
	                                        )
	                                      )
	                                    );
	                                  })
	                                )
	                              )
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_Footer2.default, null)
	      );
	    }
	  }]);
	
	  return Faq;
	}(_react.Component);
	
	exports.default = Faq;

/***/ },
/* 870 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Header = __webpack_require__(187);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(82);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Privacy = function (_Component) {
	  _inherits(Privacy, _Component);
	
	  function Privacy() {
	    _classCallCheck(this, Privacy);
	
	    return _possibleConstructorReturn(this, (Privacy.__proto__ || Object.getPrototypeOf(Privacy)).apply(this, arguments));
	  }
	
	  _createClass(Privacy, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {}
	  }, {
	    key: "render",
	    value: function render() {
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          "div",
	          { className: "container-fluid full-width nopadding" },
	          _react2.default.createElement(
	            "div",
	            { className: "row nomargin" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-sm-12 header-color" },
	              _react2.default.createElement(_Header2.default, null)
	            )
	          ),
	          _react2.default.createElement(
	            "section",
	            { "class": "breadcrumb-area" },
	            _react2.default.createElement(
	              "div",
	              { "class": "container" },
	              _react2.default.createElement(
	                "div",
	                { "class": "row" },
	                _react2.default.createElement(
	                  "div",
	                  { "class": "col-lg-12 col-sm-12 col-xs-12" },
	                  _react2.default.createElement(
	                    "div",
	                    { "class": "left-side pull-left headng" },
	                    _react2.default.createElement(
	                      "h1",
	                      null,
	                      "Privacy Policy "
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { "class": "about-page" },
	            _react2.default.createElement(
	              "section",
	              { className: "py-4" },
	              _react2.default.createElement(
	                "div",
	                { className: "container" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "row no-margin" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-sm-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "privacy-page" },
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "BeWise recognizes the importance of maintaining your privacy. We value your privacy and appreciate your trust in us. This privacy policy is being published in accordance with the provisions of the applicable provisions of laws in India."
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "This policy describes how we treat user information we collect on the Device Support Application (\u201CApp\u201D)/ website (named BeWise.in). This Privacy Policy applies to current and former visitors to our App/ website. By visiting and/or using our App/ website, you agree to this Privacy Policy."
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "This privacy policy was updated in September, 2020."
	                        ),
	                        _react2.default.createElement(
	                          "h5",
	                          null,
	                          "1. General"
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "For the purpose of this Privacy Policy, wherever the context so requires, \u2018you\u2019 or \u2018user\u2019 shall mean any natural or legal person who uses our App/website, browses our website or becomes a member of our website by signing up on BeWise as a user. BeWise allows the user to surf this website without signing up on this website. The term \u201Cwe\u201D, \u201Cus\u201D, \u201Cour\u201D shall mean BeWise and the term \u2018site\u2019 or \u2018website\u2019 refers to",
	                          " ",
	                          _react2.default.createElement(
	                            "a",
	                            { href: "www.bewise.in" },
	                            "www.BeWise.in"
	                          ),
	                          "."
	                        ),
	                        _react2.default.createElement(
	                          "h5",
	                          null,
	                          "2. Information we collect"
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "Depending on your interaction with us (meaning, if you are just browsing our website, or if you have signed up on this website, etc.), we may collect two types of information from you, i.e. \u2018Personal Information\u2019 and \u2018Non-Personal Information\u2019."
	                        ),
	                        _react2.default.createElement(
	                          "h6",
	                          null,
	                          "a) Personal Information"
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "Personal Information is the information that identifies a specific \u2018End User\u2019. When you engage in certain activities on this website/App, such as signing up, posting a review, rating a partner or any other third party listed on our website/App, requesting information about our services or the services of the third party partners listed on our website/App (collectively, \u201CActivities\u201D), we may ask you to provide certain information about yourself or your ward. It is optional for you to engage in an Activity. If you elect to engage in an Activity, we may ask you to provide us with certain personal information about yourself, such as your first and last name, email address, telephone number, child\u2019s name, age, etc. BeWise allows the user to sign up on this website using social networking sites such as Facebook, Instagram, Google accounts and LinkedIn, whereby, the user\u2019s data may be shared by such social networking sites with us."
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "Depending on the activity, some of the information we ask you to provide is identified as mandatory and some is identified as voluntary. If you do not provide the mandatory information for a particular activity that requires it, you will not be permitted to engage in that activity."
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "We use Personal Information to enhance the operation of this website/App, improve our marketing and promotional efforts, analyze website/App use, improve our listings on the website/App, to personalize your experience and to understand how our users, as a whole, use the services and resources provided on our site/App and to provide you a better experience."
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "In addition to this, your Personal Information may be used to troubleshoot, resolve disputes, accomplish administrative tasks, contact you, enforce our agreements with you, including our website Terms and Conditions and this Privacy Policy, comply with applicable law, and cooperate with law enforcement activities."
	                        ),
	                        _react2.default.createElement(
	                          "h6",
	                          null,
	                          "b) Non-Personal Information"
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "Non-Personal Information is the information that does not identify a specific End User. This type of information may include things like the Uniform Resource Locator (\u201CURL\u201D) of the website you visited before coming to our website, the URL of the website you visit after leaving our website, the type of browser you are using and your Internet Protocol (\u201CIP\u201D) address."
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "We use Non-Personal Information to troubleshoot, administer this website/App, analyze trends, gather demographic information, comply with applicable law, and cooperate with law enforcement activities."
	                        ),
	                        _react2.default.createElement(
	                          "h6",
	                          null,
	                          "3. Utilising user\u2019s information"
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "The information/data collected is used for the purposes of understanding the user along with the location the user is from through geolocation platform, to analyse our audience. Collecting this data helps us understand what you are looking from the company, enabling us to deliver improved services."
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "We may use your data for the following general purposes:"
	                        ),
	                        _react2.default.createElement(
	                          "ul",
	                          null,
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            " To contact you in response to a specific enquiry"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            " To improve the services that we provide"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            " To customise the website/App for you"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            " For our internal records"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "To send you promotional emails about products, services, offers and other things we think might be relevant to you."
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "To contact you via email, telephone or mail for market research reasons."
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "h5",
	                          null,
	                          "4. Release of user\u2019s information"
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "We may disclose your information to other entities within BeWise\u2019s company group and its partners, for legitimate business purposes (including operating the services, and providing services to you), in accordance with applicable law. We may also disclose your information to any relevant third-party partners listed on our website/App such as /preschools/ after school activity centers/schools/tuition centres/community support centres, etc. for the purpose of providing appropriate services to you as per your request."
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "We will not sell, trade, distribute or lease your personal information to third parties unless we have your permission or if required to do so by law or in the good faith belief that such disclosure is reasonably necessary to respond to court orders or other legal process."
	                        ),
	                        _react2.default.createElement(
	                          "h5",
	                          null,
	                          "5. Security"
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "We are committed to ensuring that your information is secure, but please note that no method of transmission over the internet, or method of electronic storage, is 100% secure. However, we will always hold your information securely and prevent unauthorised disclosure or access to your information. Further, by providing your information you allow us to share your information with our partner brands/partners for their promotional purposes."
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "For general web browsing, no Personal Information is revealed to us, although certain statistical information is available to us via our internet service provider. This information may include the logical address of the server you are using, the top level domain name from which you access the internet (for example, .com, .in, etc.), the type of browser you are using, the date and time you access our site and the internet address used to link to our site."
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "Some of the above information is used to create summary statistics, which allow us to assess the number of visitors to our site and to identify what pages of our site are accessed most frequently. We use these statistics to help us make our site more user friendly."
	                        ),
	                        _react2.default.createElement(
	                          "h5",
	                          null,
	                          "6. Miscellaneous Privacy Issues"
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "This website/App is not meant to be used directly by children/minors under the age of 18, and/or any person who is not capable of entering into a binding contract. We do not collect or maintain information from anyone known to be under the age of 18, unless such information has been lawfully provided by the parents or guardians of the children and no part of this website/App is designed to directly attract anyone under the age of 18 and/or any person who is not capable of entering into a binding contract. If you are under 18, or are not capable of entering into a binding contract, and still want to use this website/App, you may use BeWise only with the involvement of a parent or guardian."
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "We do not share, transfer, sell or trade children's information."
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "We may provide areas on our website/App where you can publicly post information about yourself and provide reviews and ratings for the individual and institutional partners listed on our website/App. This information may be accessible by other users and may appear on other websites or web searches, and therefore this information is not confidential and could be read, collected, and used by others."
	                        ),
	                        _react2.default.createElement(
	                          "h5",
	                          null,
	                          "7. Links to external sites"
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "Information on our website/App may include some links which may lead to other websites, including those operated and maintained by third parties or such other third-party sites that might be directly or indirectly related to the individual or institutional partners listed on our website/App. BeWise includes these links solely as a convenience to you and the presence of such a link does not imply a responsibility on BeWise for the linked site or an endorsement of the linked site, its operator, or its contents."
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "Please be aware that once you click on the link to one of these sites, you will be subject to that site's privacy policy and not to ours. We recommend that you examine each website's Privacy Policy separately."
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "Apart from this website/App, the users may contact/ connect with BeWise using social networking services such as Facebook, Twitter, LinkedIn and Instagram. When you connect with us using these services, we may collect your personal information to communicate with you. The social networking service will also handle your personal information for its own purposes. These social networking services have their own privacy policies. You can access the privacy policies for these social networking services on their respective websites."
	                        ),
	                        _react2.default.createElement(
	                          "h5",
	                          null,
	                          "8. Cookies"
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "This website uses \u201Ccookie\u201D technology. A cookie is a small piece of data or a small text file stored by the browser on your computer, at the request of our server. We may use cookies to deliver content specific to your interests and to save your personal preferences so you do not have to re- enter them each time you connect to our website \u2013 our cookies are not available to other websites. In particular cookies enable us:"
	                        ),
	                        _react2.default.createElement(
	                          "ul",
	                          { className: "list-dot" },
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "to measure visitor traffic to our website and their usage patterns"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "to identify whether you are signed in to our website"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "to test content on our website and pattern of a user on the website. For instance, 50% of our users might see one piece of content, the other 50% a different piece of content."
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "to store information about your preferences and so allow us to customize our website according to your individual interests"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "to speed up your searches"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "to recognize you when you return to our website"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "You are always free to decline such cookies, if your browser permits, or to ask your browser to indicate when a cookie is being sent. You can also delete cookie files from your computer at your discretion. However, please note that doing this may affect how our website functions. Some pages and services may become unavailable to you."
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "To learn more about cookies and how they are used, visit",
	                          " ",
	                          _react2.default.createElement(
	                            "a",
	                            { href: "http://www.allaboutcookies.org/" },
	                            "http://www.allaboutcookies.org/"
	                          ),
	                          "."
	                        ),
	                        _react2.default.createElement(
	                          "h5",
	                          null,
	                          "9. Advertising cookies"
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "Some of the advertisements you see on BeWise are provided by other organizations. These organizations can use their own anonymous cookies to track how many people have seen a particular ad, or to track how many people have seen it more than once."
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "The entities that generate these cookies have their own privacy policies, and we have no access to read or write these cookies. These organizations may use their cookies to anonymously target advertising to you on other websites, based on your visit to BeWise."
	                        ),
	                        _react2.default.createElement(
	                          "h5",
	                          null,
	                          "10. Electronic communication"
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "There are inherent risks associated with the transmission of information over the internet, including via email. You should be aware of this when sending your personal information to us via email or via our website/App or social media platforms. If this is of concern to you then you may use other methods of communication with us, such as post or telephone (although these also have risks associated with them)."
	                        ),
	                        _react2.default.createElement(
	                          "h5",
	                          null,
	                          "11. Changes to this privacy policy"
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "Please note that the privacy policy may change from time to time. BeWise reserves the right to change this policy at any time. The users registered on this website/App as a member shall be notified of the changes or modifications, if any, done on this policy via their registered email by BeWise."
	                        ),
	                        _react2.default.createElement(
	                          "h5",
	                          null,
	                          "12. Your Acceptance of these terms"
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "By using this website/App, you signify your acceptance of our privacy policy. If you do not agree to this policy, please do not use our website/App. Your continued use of this website/App following the posting of changes to this policy, as and when notified to you, will be deemed your acceptance of those changes."
	                        ),
	                        _react2.default.createElement(
	                          "h5",
	                          null,
	                          "13. Jurisdiction"
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "If you choose to visit this website/App, your visit and any dispute over data privacy is subject to this policy and the terms and conditions of this website/App. In addition to the foregoing, any disputes arising under this policy shall be governed by the laws of India and the courts of Karnataka shall have exclusive jurisdiction in determining such dispute."
	                        ),
	                        _react2.default.createElement(
	                          "h5",
	                          null,
	                          "14. Complaints"
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "If you think BeWise may have breached your privacy, you may contact us to make a complaint and rectify our actions. In order to ensure that we fully understand the nature of your complaint and the outcome you are seeking, we prefer that you make your complaint in writing via email to the below mentioned email address."
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "Further, in accordance with Information Technology Act, 2000 and rules made thereunder, the name and contact details of the grievance officer who can be contacted with respect to any complaints or concerns including those pertaining to breach of BeWise\u2019s Terms & Conditions, and other polices or questions are published as under:"
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "Name: Sethuraman",
	                          _react2.default.createElement("br", null),
	                          "Email Address: ",
	                          _react2.default.createElement(
	                            "a",
	                            { href: "mailto:contact@bewise.in" },
	                            "contact@bewise.in"
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_Footer2.default, null)
	      );
	    }
	  }]);
	
	  return Privacy;
	}(_react.Component);
	
	exports.default = Privacy;

/***/ },
/* 871 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Header = __webpack_require__(187);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(82);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Terms = function (_Component) {
	  _inherits(Terms, _Component);
	
	  function Terms() {
	    _classCallCheck(this, Terms);
	
	    return _possibleConstructorReturn(this, (Terms.__proto__ || Object.getPrototypeOf(Terms)).apply(this, arguments));
	  }
	
	  _createClass(Terms, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {}
	  }, {
	    key: "render",
	    value: function render() {
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          "div",
	          { className: "container-fluid full-width nopadding" },
	          _react2.default.createElement(
	            "div",
	            { className: "row nomargin" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-sm-12 header-color" },
	              _react2.default.createElement(_Header2.default, null)
	            )
	          ),
	          _react2.default.createElement(
	            "section",
	            { "class": "breadcrumb-area" },
	            _react2.default.createElement(
	              "div",
	              { "class": "container" },
	              _react2.default.createElement(
	                "div",
	                { "class": "row" },
	                _react2.default.createElement(
	                  "div",
	                  { "class": "col-lg-12 col-sm-12 col-xs-12" },
	                  _react2.default.createElement(
	                    "div",
	                    { "class": "left-side pull-left headng" },
	                    _react2.default.createElement(
	                      "h1",
	                      null,
	                      "Terms & Conditions"
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { "class": "about-page" },
	            _react2.default.createElement(
	              "section",
	              { className: "py-4" },
	              _react2.default.createElement(
	                "div",
	                { className: "container" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "row no-margin" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-sm-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "privacy-page" },
	                        _react2.default.createElement(
	                          "h5",
	                          null,
	                          " General"
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          _react2.default.createElement(
	                            "a",
	                            { href: "https://www.bewise.in" },
	                            "www.BeWise.in"
	                          ),
	                          " is an online platform and BEWISE App (\u201CApp\u201D) is the mobile application, owned by Wisdom Tech Solutions Private Limited, a private limited company incorporated under the Companies Act, 2013, having its registered office at Karnataka (\u201CCompany\u201D), represented by its members, where such expression shall, unless repugnant to the context thereof, be deemed to include its respective legal heirs, representatives, administrators, permitted successors and assigns."
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "This website/App is an online platform/mobile application that is engaged in the business of providing and facilitating parents make choice around their child\u2019s \u201Ceducation and development\u201D by discovering preschool/daycare/ after school/events/ activity class for their child in and around them. We ensure we provide details of relevant service providers and constantly provide you updates on them. On the other side, if you are an institution or an individual supporting this \u201Cholistic education\u201D, we also understand the pressures of growth and ability to effectively reach target audience, benchmarking, and continuous improvement with feedback which are critical for a sustainable future in a fast-paced digital economy. Hence, we provide them this platform to overcome their problem of right audience through our website and App. "
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "For the purpose of these Terms of Service and Privacy Policy (\u2018",
	                          _react2.default.createElement(
	                            "b",
	                            null,
	                            "Terms"
	                          ),
	                          "\u2019), wherever the context so requires, \u2018you\u2019 or \u2018Registered Service Provider\u2019 shall mean any natural or legal person who becomes a member of this website/App by signing up on this website/App as an Individual Service Provider or an Institutional Service Provider. The term \u201Cwe\u201D, \u201Cus\u201D, \u201Cour\u201D shall mean BeWise and the term \u2018site\u2019 or \u2018website\u2019 refers to ",
	                          _react2.default.createElement(
	                            "a",
	                            { href: "https://www.bewise.in", target: "_blank" },
	                            "www.BeWise.in"
	                          ),
	                          "."
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "The headings of each section in this Agreement are only for the purpose of organizing the various provisions under this Agreement (as defined below) in an orderly manner. These headings shall not be used by either party to interpret the provisions contained with them in any manner. Further, the headings have no legal or contractual value."
	                        ),
	                        _react2.default.createElement(
	                          "h5",
	                          null,
	                          " Acceptance of our Terms"
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "By registering on this website/App as an Individual Service Provider or an Institutional Service Provider, you agree to be bound by the Terms mentioned hereunder. "
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "If you do not want to be bound by our Terms your only option is not to register yourself with BeWise. You understand, agree and acknowledge that these Terms constitute a legally binding agreement between you and BeWise and that your use of BeWise shall indicate your conclusive acceptance of this agreement (\u2018",
	                          _react2.default.createElement(
	                            "b",
	                            null,
	                            "Agreement"
	                          ),
	                          "\u2019). You are requested to read the Terms carefully before you use the services of this site/App."
	                        ),
	                        _react2.default.createElement(
	                          "h5",
	                          null,
	                          "Eligibility"
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "Use of the site/App is available only to persons who can form legally binding contracts under applicable law. Persons who are \u2018incompetent to contract\u2019 within the meaning of the laws applicable to them in their respective jurisdiction are not eligible to use this site/App. You may use this site/App only if your age is over 18 years and you are capable of forming binding contracts under applicable law."
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "BeWise reserves the right to deactivate your account and refuse to provide you with access to the site/App if BeWise discovers that you are under the age of 18 years or otherwise not capable of forming binding contracts. In case of a business entity, you represent that you have the necessary authority to bind the entity to this Agreement."
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "Unless otherwise specified, the materials on this website/App are directed solely at those who access this website/App from India. BeWise makes no representation that any content referred to in the materials on this website/App are appropriate for use, or available outside India. Those who choose to access this site/App from outside India are responsible for compliance with local laws if and to the extent local laws are applicable."
	                        ),
	                        _react2.default.createElement(
	                          "h5",
	                          null,
	                          "Registration"
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "You are required to create an account on the website/App in order to use some of the features and services offered by BeWise, including without limitation listing yourself or your institution on this website/App, posting content, etc. The use of any information you share with us to create your account is governed by the section Privacy Policy of this Agreement. "
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "Upon registering/ signing up as an Individual Service Provider or an Institutional Service Provider (\u2018",
	                          _react2.default.createElement(
	                            "b",
	                            null,
	                            "Registered Service Provider"
	                          ),
	                          "\u2019), you agree to make your contact details available to the public or the users of this website/App. Further, for group of institution, only one institution will be able to avail any trial offer, if any among the group. Post the completion of trial period, other institutions from the group will not be eligible for any trial offer. Further you agree to be contacted by the users of this website/App for availing your services or by the representatives of BeWise or its affiliates for purpose of marketing their services or providing information related to the services offered by them through email and telephone. "
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "You also agree to:"
	                        ),
	                        _react2.default.createElement(
	                          "ul",
	                          null,
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            " provide true, accurate, current and complete information about yourself as prompted by BeWise while signing up on this website/App. "
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            " maintain and promptly update the account related information to keep it true, accurate, current and complete. If you provide any information that is untrue, inaccurate, incomplete, or not current or if BeWise has reasonable grounds to suspect that such information is untrue, inaccurate, not current or not in accordance with this Agreement, or if in the opinion of BeWise, your use of this website/App breaches the terms of the applicable law, or the rights of any person, or is detrimental in any way to BeWise, we will have the right to indefinitely suspend or discontinue your account and refuse to provide you with access to this site/App."
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "You are solely responsible for all activities that occur in your account. You agree to notify us immediately of any unauthorized use of your account in order to enable us to take necessary corrective action. You also agree that you will not allow any third party to use your account for the purpose of transacting in your name on our website/App."
	                        ),
	                        _react2.default.createElement(
	                          "h5",
	                          null,
	                          "Content submitted by Registered Service Providers"
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "BeWise permits the Registered Service Providers to submit and post content related to their individual services and/or institution on this website/App, whereby, the Registered Service Providers agree and allow BeWise to host, share, and/or publish such submissions. You hereby recognize and acknowledge that such information will be publicly made available on our website/App, BeWise does not guarantee any secrecy and confidentiality with respect to any of the content/submissions on this website/App"
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "The Registered Service Providers are solely responsible for their content submissions and the consequences of posting or publishing them on this website/App. In this regard the concerned Registered Service Providers will affirm, represent, and/or warrant that they have the necessary licenses, rights, consents, and permissions to use and authorize BeWise to use all patent, trademark, trade secret, copyright or other proprietary rights in and to any and all content to enable inclusion and use of the content in the manner contemplated by BeWise\u2019s Terms and Conditions and Privacy Policy and these additional Terms."
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "The Registered Service Providers also hereby grant BeWise a non-exclusive license to access their content through website/App and to use, reproduce, distribute, prepare derivative works of, display and perform such content through this website/App and under these Terms of Service. The aforesaid license and permission granted by you to BeWise shall terminate once the concerned Registered Service Providers remove or delete their content from the website/App."
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "With respect to the content submissions on this website/App, the concerned Registered Service Providers also further agree that they shall not submit any content that is copyrighted, protected by trade secret or otherwise subject to third party proprietary rights, including privacy and publicity rights, unless they are the owner of such rights or have permission from their rightful owner to post the content and to grant BeWise all of the license rights granted thereto and they also not publish false content or material that may damage BeWise or any third party and also hereby agree not to submit material that is unlawful, obscene, defamatory, libelous, threatening, pornographic, harassing, hateful, racially or ethnically offensive, or encourages conduct that would be considered a criminal offense, give rise to civil liability, violate any law, or is otherwise inappropriate; post advertisements or solicitations of business, or, impersonate any third party."
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "The Registered Service Provider hereby, for the duration it is listed on this website/App and/or association with BeWise, grants BeWise a worldwide, non-exclusive, royalty-free, sub-licensable and transferable license to use, reproduce, distribute, prepare derivative works of, display, and perform the submitted content in connection with the website/App and its affiliates, including, without limitation, promoting BeWise in any manner, whatsoever."
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "BeWise does not verify the genuineness, accuracy or otherwise endorse any content or any opinion, recommendation, or advice expressed therein, and BeWise hereby expressly disclaims any and all liabilities with respect to the inclusions of the content posted by the Registered Service Providers on this website/App."
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "BeWise does not permit copyright infringing activities and infringement of intellectual property rights on its website/App, and BeWise reserves the right of deletion or removal of any content without prior notice if it comes to BeWise\u2019s knowledge or if it is notified that such content infringes and/or violates any third party\u2019s Trademark, Copyright and/or any other intellectual property right. Consequently, BeWise may also terminate the Registered Service Provider\u2019s access to its website/App."
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "BeWise also reserves the right to decide whether a particular content or material is appropriate and complies with the Terms for violations other than copyright infringement and violations of intellectual property law, including, but not limited to, pornography, obscene or defamatory material, or excessive length."
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "BeWise shall delete or remove such content and/or terminate such violator\u2019s access to this website/App at any time, without any prior notice at its sole discretion for uploading such content in violation of the Terms of this website/App."
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "Registered Service Providers hereby agree and acknowledge that they may be solely liable if their content submissions on this website/App are not genuine, inaccurate, offensive, indecent, or objectionable, and they also agree to waive, and hereby do waive, any legal or equitable rights or remedies they have or may have against BeWise with respect thereto, and agree to indemnify and hold BeWise and its affiliates, harmless to the fullest extent allowed by law regarding all matters related to their content submission on this website/App."
	                        ),
	                        _react2.default.createElement(
	                          "h5",
	                          null,
	                          " Guidelines on Summer Camp or any other similar programs"
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "BeWise shall enter with MoU with the Service Partner for the Summer camp or other programs. The Registered Service Partner shall be bound by the MoU entered therewith mentioning the conduct as well as terms of such programs along with Revenue sharing to the Partner. Such Programs shall be fully carried on by the Registered Service Partner and the liability of failure to conduct such programs shall fall on the Respective Partner. In any case, no liability would fall on BeWise and Registered Service Partner shall indemnify BeWise."
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "Every program shall be made with full ownership, care and skill to ensure effective delivery of the program description as agreed in advance by the Registered Service Partner. BeWise reserves the right to make changes into the program schedule, or content in discussion with the parents and the partner in order to improve the experience for all the stakeholders and learners."
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "You represent and warrant that you own or otherwise control all of the rights to the content that you contribute to this site/App and that use of your content by BeWise will not infringe upon or violate the rights of any third party."
	                        ),
	                        _react2.default.createElement(
	                          "h5",
	                          null,
	                          "  Conduct of the Registered Service Provider"
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "The Registered Service Provider shall, at all times, act in a lawful manner on and with respect to this website/App as long as it is listed/ associated with BeWise. You shall provide your services with the highest level of care, skill and diligence on this website/App and in accordance with best practice in your industry. The Registered Service Provider shall be accountable for the accuracy and the genuineness of the content posted on this website/App and other information provided by him/her to BeWise.It shall be the sole responsibility of the Registered Service Provider to verify and confirm the authenticity of the content and the information provided by the Registered Service Provider."
	                        ),
	                        _react2.default.createElement(
	                          "h5",
	                          null,
	                          " Obligations of the Registered Service Provider"
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "You are bound not to cut, copy, distribute, modify, recreate, reverse engineer, distribute, disseminate, post, publish or create derivative works from, transfer, or sell any information or software obtained from the website/App. With our prior permission limited use may be allowed. For the removal of doubt, it is clarified that unlimited or wholesale reproduction, copying of the content for commercial or non-commercial purposes and unwarranted modification of data and information within the content of the website/App is not permitted."
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "You agree not to access (or attempt to access) this website/App and/or the materials or services by any means other than through the interface that is provided by the website/App. The use of deep-link, robot, spider or other automatic device, program, algorithm or methodology, or any similar or equivalent manual process, to access, acquire, copy or monitor any portion of the website/App or content, or in any way reproduce or circumvent the navigational structure or presentation of the website/App, materials or any content, to obtain or attempt to obtain any materials, documents or information through any means not specifically made available through the website/App."
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "In places where this website/App allows you to post or upload data/information, you undertake to ensure that such material is not offensive and in accordance with applicable laws"
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "You shall not impersonate any other party, create or use an account for anyone other than yourself, provide an email address other than your own, create multiple accounts or business listings except as otherwise authorized by us, or provide or use false information to obtain access to a business\u2019 listing on the website/App that you are not legally entitled to claim. You acknowledge that any false claiming of a business listing may make us or third parties to incur substantial economic damages and losses for which you may be held liable and accountable."
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "We can (and you hereby expressly authorize us to) disclose any information about you to law enforcement or other government officials, as we, in our sole discretion, believe necessary or appropriate in connection with the investigation and/or resolution of possible crimes, especially those that may involve personal injury."
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "You understand that we have the right at all times to disclose any information (including the identity of the persons providing information or materials on the website/App) as necessary to satisfy any law, regulation or valid governmental request. This may include, without limitation, disclosure of the information in connection with investigation of alleged illegal activity or solicitation of illegal activity or in response to a lawful court order."
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "We have no obligation to monitor the materials posted on the website/App. We shall have the right to remove or edit any content that, in our sole discretion, violates, or is alleged to violate, any applicable law or either the spirit or letter of these Terms or for any other reason or no reason if we consider it to be objectionable, in violation of these Terms or otherwise harmful to the website/App or users. Subject to the requirements of applicable law, we are not obligated to return any of your content to you under any circumstances. Any review, which is derogatory, defamatory or hateful and without any substantial evidence (e.g. photograph or video) may be taken down at our sole discretion. Notwithstanding this right, YOU REMAIN SOLELY RESPONSIBLE FOR THE CONTENT OF THE MATERIALS YOU POST ON THE WEBSITE/APP AND IN YOUR PRIVATE MESSAGES/BUSINESS LISTING. In no event shall we assume or have any responsibility or liability for any content posted or for any claims, damages or losses resulting from use of content and/or appearance of content on the website/App. You hereby represent and warrant that you have all necessary rights in and to all content which you provide and all information it contains and that such content shall not infringe any proprietary or other rights of third parties or contain any libelous, tortuous, or otherwise unlawful information."
	                        ),
	                        _react2.default.createElement(
	                          "h5",
	                          null,
	                          " Communications"
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "By using this website/App, it is deemed that you have consented to receiving calls, autodialed and/or pre-recorded message calls, e-mails and SMSs from us at any time with the use of the contact information that has been provided by you for the use of this website/App which is subject to the Privacy Policy. This includes contacting you through information received through other parties. This consent to be contacted is for purposes that include and are not limited to clarification, marketing and promotional calls, e-mails and messages. In case you wish to stop being contacted by us for the same, you may send us an e-mail to that effect at ",
	                          _react2.default.createElement(
	                            "a",
	                            { href: "mailto:contact@bewise.in" },
	                            "contact@bewise.in"
	                          ),
	                          "."
	                        ),
	                        _react2.default.createElement(
	                          "h5",
	                          null,
	                          " Permissions"
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "We or our affiliates responsible for making the software available, may design our website or App in such a manner as to automatically check for updates. Unless your device or any settings do not permit automatic transmission, upgrades or updates, you agree that we, or the applicable software affiliate, may provide notice to you of the availability of such upgrades or updates and automatically push such upgrade or update to your device or computer from time-to-time. You may be required to install certain upgrades or updates to the software in order to continue to access or use the services, or portions thereof (including upgrades or updates designed to correct issues with the services). Any updates or upgrades provided to you by us under these Terms shall be considered part of the services."
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "BeWise has the right, but not the obligation to monitor and edit or remove any content posted by you as your communication. We cannot review all communications made on the Site. However, we reserve the right, but has no obligation, to monitor and edit, modify or delete any communications (or portions thereof) which we on a sole discretion deem inappropriate, offensive or contrary to any of our policy, or that violate theses terms."
	                        ),
	                        _react2.default.createElement(
	                          "h5",
	                          null,
	                          " Charges"
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "For the Service Provider, the website/App for listing their services is subject to charges as mentioned in each of the packages selected by them on a particular period basis (Monthly, Quarterly or Annual). Such charges would be modified based on additional requirement by the Service Provider. Such charges and packages would also be subject to change from time to time with immediate notice."
	                        ),
	                        _react2.default.createElement(
	                          "h5",
	                          null,
	                          "Ranking algorithm"
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "We have a page ranking algorithm for the Service Providers, which is based on many things and also the rating provided by various users of the services of the Service Providers. These ratings do not represent any fixed objective rating or endorsement by BeWise. The ratings keep changing from time to time, basis user experiences & other factors and BeWise will not be liable for these changes. The page ranking alogorithm is proprietary technology and cannot be disclosed in full. Such factors may change from time to time, in order to improve the user experience. BeWise, in no event, will be held responsible for the accuracy and the relevancy of ratings on the website & App, which may also be discontinued without prior notice."
	                        ),
	                        _react2.default.createElement(
	                          "h5",
	                          null,
	                          "Mode of payment"
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "The following payment options are or will be made available on the website/App in the future:"
	                        ),
	                        _react2.default.createElement(
	                          "ul",
	                          null,
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Domestic and international credit cards issued by banks and institutions that are part of the Visa, Master card & Amex Card;"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Visa Debit cards;"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Netbanking/Direct Debit payments from select banks in India. A list of banks is available at the time of \u2018checkout\u2019;"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Payment processing apps like Paytm, Gpay, Razorpay, BHIM, Phonepe, Mobikwik, Yono, Payzapp, Amazon pay etc."
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "As prescribed by the financial institutions issuing the credit or debit cards affiliated with Visa and MasterCard you will required to submit your 16-digit credit card number, card expiry date and 3- digit CVV number (usually on the reverse of the card) when you make your online transaction using your Credit or Debit card. You should also have enrolled your Credit Card with VBV (Verified by Visa) or MSC (MasterCard Secure Code) to complete the transaction. Your credit card or debit card statements will reflect Wisdom Tech Solutions Pvt Ltd. In case of third-party statements including bank and credit card statements, the company name may appear in an abbreviated format. This may or may not be assisted with a phone call with the customer service representative. By placing an order on the website/App, you are agreeing to the terms and conditions and payment policy published in the appropriate section of the website/App or affiliated websites where specifically referred to such affiliated websites."
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "Once payment has been made by the Service Provider, they will receive the SMS or Mail with booking details along with Service/Transaction ID, Login ID, One Time code."
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "As part of cancellation policy, BeWise would be liable to refund proportionate of 3 month of annual payment collected, if the Service Provider cancels the package before the 3rd month of usage post the trial offer period. No amount would be refunded once the Service Provider cancels the selected package post 6th month. This would be subject to exclusive conditions, if any, agreed upon at time of signing into the platform."
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "Transactions on this website/App are secure and protected. Credit card and debit card information is not stored by us and is not taken by us. This information is taken directly by the payment gateway provided who is authorized and is compliant with the regulations and requirements of various banks and institutions and payment franchisees that it is associated with."
	                        ),
	                        _react2.default.createElement(
	                          "h5",
	                          null,
	                          "Intellectual Property Rights"
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "This BeWise website/App has all rights reserved. The original contents of this website/App are copyrighted materials and are subject to the restrictions and protections set forth in the Copyright Act, 1957."
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "Unless we have otherwise agreed, nothing herein gives the Service provider, a right to use any of the website/App\u2019s trade names, trademarks, service marks, logos, domain names, information, questions, answers, solutions, reports and other distinctive brand features, save according to the provisions of this Agreement."
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "All content, except if it relates to the Registered Service Providers, present on this site/App is the exclusive property of BeWise. The software, text, images and graphics used on this site/App belong to BeWise. The material may be downloaded to file or printer for personal use only. Where this material is being issued to others, the source including the URL and copyright status must be acknowledged."
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "The permission to reproduce such copyright material does not extend to any material on this site/App, which may be the property of a third party. This site/App may contain words and phrases, which are copyrighted, trademarked, or registered trademarks; they are the copyright, trademark, or registered trademark of their respective holder(s). Authorization to reproduce such material must be obtained from the respective holders concerned."
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "The Logo is the property of BeWise and may not be used by third parties in a manner that implies that the user is acting on behalf of BeWise when they are not, or where it is linked to aims and activities incompatible with the role and responsibilities of BeWise."
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "BeWise\u2019s logo may be used for events/ programmes/ projects that are funded wholly or in part by BeWise. BeWise\u2019s logo may be used by a third party only with the prior written permission from BeWise, which may be granted only at the sole discretion of BeWise. All rights not expressly granted herein are reserved. Unauthorized use of the materials appearing on this site/App may violate copyright, trademark and other applicable laws, and could result in criminal and/or civil penalties"
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "You may not use any of our intellectual property in any manner that is likely to cause confusion among customers, or in any manner that disparages or discredits us in any way."
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "You further acknowledge that the website/App or services may contain information which is designated as confidential by us and that you shall not disclose such information without our prior written consent."
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "We do not warrant or represent that your use of any content or materials displayed on the website/App will not infringe rights of third parties not affiliated with us. You agree to immediately notify us upon becoming aware of any claim that any content on the website/App or any services infringe upon any intellectual property of any party including but not limited to copyright, trademark, or other contractual, statutory, or common law rights."
	                        ),
	                        _react2.default.createElement(
	                          "h5",
	                          null,
	                          "Lawful usage"
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "You agree and confirm that you will use the services provided by BeWise for lawful purposes only and comply with all applicable laws and regulations while using this site. The Registered Service Provider agrees to provide true, accurate, complete and current information in all instances where such information is requested."
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "BeWise reserves the right to confirm and validate the information and other details provided by you at any point of time. If upon confirmation, your details are found not to be true (wholly or partly), BeWise has the right in its sole discretion to reject the registration and debar you from using the services of BeWise without prior intimation whatsoever."
	                        ),
	                        _react2.default.createElement(
	                          "h5",
	                          null,
	                          " Prohibited usage"
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "The Registered Service Provider shall not while, including, but not limited to, posting any content on this website/App, use this site/App for any of the following purposes:"
	                        ),
	                        _react2.default.createElement(
	                          "ul",
	                          null,
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            " Disseminating any unlawful, harassing, abusive, threatening, harmful, vulgar, obscene, or otherwise objectionable material."
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            " Transmitting material that encourages conduct that results in civil liability or otherwise breaches any relevant laws, regulations or code of practice or constitutes a criminal offence."
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            " Gaining unauthorized access to other computer systems."
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            " Interfering with any other person\u2019s use or enjoyment of this site."
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            " Breaching any applicable laws."
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            " Interfering or disrupting networks or websites connected to this site/App."
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            " Making, transmitting or storing electronic copies of materials protected by copyright without the permission of the respective owner."
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "h5",
	                          null,
	                          " Limitation of Liability and warranty disclaimers"
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "BeWise will not be liable for indirect, special, or consequential damages (or any loss of revenue, profits, or data) arising in connection with this Agreement."
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "BeWise is not liable for any loss resulting from any action taken or reliance made by a user on any information or material posted by you on this website/App (including, without limitation, Service Provider and other third-party information)."
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "The website/App and the Company or any of its agents, servants or assigns shall not be liable for any direct or indirect, willful or otherwise, act or omission that can be attributed to the services of participating Service provider. The website/App and the Company or any of its agent, servant or assigns have no liability whatsoever in case any third party claims, demands, suit, actions, or other proceedings are initiated against the participating Service provider or any of its personnel or any other person engaged by the participating Service Provider in the course of the performance of his services. The website/App and the Company or any of its employees, agent or assignees shall not be held responsible for any negligence, deficiency of service, damage caused by the respective participating Service provider. No corporate entity recommends or endorses the website/ Application platform/portal and/or the offers available on the said platform."
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "In respect of Individual Service Provider who offer their services listed on our platform through a medium (online or otherwise) outside of the host country (in this case outside India), the legal requirement along with taxation implications of the same would be borne by the user and the respective Service Provider. The company is not responsible for any such implications arising from the transaction between both user and Service Provider. "
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "BeWise discounts/offers are promotional offers and shall be subject to the standard terms and conditions and specific terms and conditions. BeWise discounts/offers are issued by the Institutions/Individual Service provider and only such Institutions shall be responsible for, damages, charges, expenses, claims, liabilities and costs suffered by or in respect of a user, caused in whole or in part by the Institutions or which arises out of the goods and/or services provided."
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "In no event will BeWise be liable for damages of any kind, including without limitation, direct, incidental or consequential damages (including, but not limited to, damages for lost profits, business interruption and loss of programs or information) arising out of the use of or inability to use BeWise's website/App, or any information provided by you on this website/App, or any claim attributable to errors, omissions or other inaccuracies in the content or interpretations thereof. "
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "The information submitted by you is believed to be reliable. BeWise disclaims all warranties as to the accuracy, completeness or adequacy of such information."
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "BeWise makes no warranty that: (a) this site/App will meet your requirements; (b) this site/App will be available on an uninterrupted, timely, secure, or error-free basis."
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "The limitations and exclusions in this section apply to the maximum extent permitted by applicable law."
	                        ),
	                        _react2.default.createElement(
	                          "h5",
	                          null,
	                          "Disclaimer for websites that we link to"
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "While we make every effort to ensure that the websites we are associated with or linked to are useful, acceptable and opening them will not be harmful to the computers systems or any other devices (of our clients or subscribers) used for accessing the sites linked on our site, we clearly disclaim and will not accept any responsibility for, including, but not limited to, any of the following with respect to the sites that are listed, featured or sponsored on our portal, including our own."
	                        ),
	                        _react2.default.createElement(
	                          "ul",
	                          null,
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Veracity of the information published on our portal or the sites linked on our portal."
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Advice offered on our portal by other users or experts hired for providing such a service."
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Any malware infection."
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Bandwidth and other technical issues."
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Non-availability of sites linked on our website/App."
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "h5",
	                          null,
	                          "Indemnity"
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "You agree to defend, indemnify and hold harmless BeWise, its affiliates, employees, directors, officers, agents and their successors and assigns from and against any and all claims, liabilities, damages, losses, costs and expenses, including attorney\u2019s fees, caused by or arising out of claims based upon your actions or inactions, which may result in any loss or liability to us or any third party including, but not limited to, posting of obscene, inappropriate or misleading content on this website/App, providing incorrect information while registering on this website/App, breach of any warranties, representations or undertakings or in relation to the non-fulfillment of any of your obligations under this Agreement or arising out of the your violation of any applicable laws, regulations including, but not limited to, intellectual property rights, defamation, violation of rights of privacy or publicity or other rights. Your obligations under this part of this Agreement shall survive the expiry or cessation of this Agreement."
	                        ),
	                        _react2.default.createElement(
	                          "h5",
	                          null,
	                          "Representation and warranties by the Registered Service Providers"
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "The Registered Service Provider represents and warrants that:"
	                        ),
	                        _react2.default.createElement(
	                          "ul",
	                          null,
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "It has the sole right and exclusive authority to post any content pertaining to the services provided by him/her or to represent the institution which is listed by the Registered Service Provider on this website/App."
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "While posting any content on this website/App, the Registered Service Provider does not infringe any patent or copyright, trade secret, trademark, or other proprietary right of any third party available under applicable law."
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "The Registered Service Provider and the information and/or content provided by the Registered Service Provider is true, genuine, accurate and not misleading."
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "The Registered Service Provider has the desired qualifications and expertise with respect to the content and information provided by the Registered Service Provider on this website/App and holds such expertise and qualifications to be listed on this website/App."
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "The Registered Service Provider shall act in a lawful manner on and with respect to this website/App. as long as it is listed/ associated with BeWise."
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "h5",
	                          null,
	                          "Modifications"
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "We reserve the right at all times to discontinue or modify the Terms as and when we deem necessary or desirable. Upon such discontinuance or modification of the Terms, the Registered Service Providers shall be notified via their registered email. Your continued use of this site/App after such modifications being notified to you will constitute acknowledgment and agreement of the modified Terms."
	                        ),
	                        _react2.default.createElement(
	                          "h5",
	                          null,
	                          " Cessation"
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "Without limiting the foregoing, we shall have the right to freeze/ discontinue/ delete the account of the Registered Service Provider in the event of any conduct by the Registered Service Provider, including, but not limited to prohibited acts as listed under the part \u2018Prohibited usage\u2019 of this Agreement, which we, in our sole discretion, consider to be unacceptable, or in the event of any breach by the Registered Service Provider of this Agreement. Any such cessation of this Agreement shall not cancel your obligation or affect any liability that may have arisen under this Agreement."
	                        ),
	                        _react2.default.createElement(
	                          "h5",
	                          null,
	                          " Severability"
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "If any part of this Agreement are determined to be invalid or unenforceable pursuant to applicable laws of India, including, but not limited to, the liability limitations and warranty disclaimers set forth above, then the invalid or unenforceable provision will be deemed to be superseded by a valid, enforceable provision that most closely matches the intent of the original provision and the remainder of this Agreement shall continue to be in effect."
	                        ),
	                        _react2.default.createElement(
	                          "h5",
	                          null,
	                          " Entire Agreement"
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "Unless otherwise specified herein, this Agreement constitutes the entire agreement between you and BeWise and supersedes all previous written and oral agreements between you and BeWise, if any. BeWise\u2019s failure to act with respect to a breach by you or others does not waive its right to act with respect to subsequent or similar breaches."
	                        ),
	                        _react2.default.createElement(
	                          "h5",
	                          null,
	                          " Jurisdiction"
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "If you choose to register on the website/App, your visit and any dispute over data privacy is subject to this Agreement. In addition to the foregoing, any disputes arising under these Terms shall be governed by the laws of India and the courts of Karnataka shall have exclusive jurisdiction in determining such dispute."
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "In case of a dispute, the matter will first be attempted to be resolved by way of mediation by a sole mediator who is a neutral third party and will be selected at the mutual acceptance of a proposed mediator by both parties. Both parties may raise a name for sole mediator and in the case both parties accept the proposed name, the said person shall be appointed sole mediator. In case the parties are not able to reach a consensus within two proposed mediators, the Company reserves the right to decide who the final mediator is. The parties in good faith will attempt to bind by the decision."
	                        ),
	                        _react2.default.createElement(
	                          "h5",
	                          null,
	                          " Contact Information"
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "Questions about the Terms should be sent to us at ",
	                          _react2.default.createElement(
	                            "a",
	                            { href: "mailto:contact@bewise.in" },
	                            "contact@bewise.in"
	                          ),
	                          "."
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_Footer2.default, null)
	      );
	    }
	  }]);
	
	  return Terms;
	}(_react.Component);
	
	exports.default = Terms;

/***/ },
/* 872 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constant = __webpack_require__(21);
	
	var _DomainName = __webpack_require__(119);
	
	var _DomainName2 = _interopRequireDefault(_DomainName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Unsubscribe = function (_Component) {
	    _inherits(Unsubscribe, _Component);
	
	    function Unsubscribe(props) {
	        _classCallCheck(this, Unsubscribe);
	
	        var _this = _possibleConstructorReturn(this, (Unsubscribe.__proto__ || Object.getPrototypeOf(Unsubscribe)).call(this, props));
	
	        _this.handleChange = function (e) {
	            var propName = e.target.name;
	            _this.setState(_defineProperty({}, e.target.name, e.target.value));
	        };
	
	        _this.state = {
	            token: _this.props.match.params.token,
	            succuess: false
	        };
	        return _this;
	    }
	
	    _createClass(Unsubscribe, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            var subscribe = JSON.stringify({
	                token: this.state.token
	            });
	            fetch(_DomainName2.default.register + 'user/auth/unsubscribe', {
	                method: 'POST',
	                mode: 'cors',
	                headers: {
	                    'Content-Type': 'application/json; charset=UTF-8'
	                },
	                body: subscribe
	            }).then(function (response) {
	                return response.json();
	            }).then(function (data) {
	                console.log('Success:', data);
	                if (data.status == 1) {
	                    _this2.setState({
	                        succuess: true
	                    });
	                } else {
	                    var toastr = "";
	                    toastr = window.toastr.error;
	                    toastr(data.msg, {
	                        positionClass: "toast-bottom-center",
	                        containerId: "toast-bottom-center"
	                    });
	                    setTimeout(function () {
	                        window.location.href = '/';
	                    }, 1000);
	                }
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	
	            return _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: '' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row no-margin' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-12' },
	                            this.state.succuess && _react2.default.createElement(
	                                'div',
	                                null,
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'text-center' },
	                                    _react2.default.createElement(
	                                        'a',
	                                        { className: 'subscribepage', href: '/' },
	                                        _react2.default.createElement('img', { src: '/assets/images/bewiselogo.png', alt: 'logo' })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'text-center' },
	                                    _react2.default.createElement(
	                                        'h2',
	                                        null,
	                                        'Thank you'
	                                    ),
	                                    _react2.default.createElement(
	                                        'p',
	                                        null,
	                                        'You have been removed from our newsletter subscriber list. You will not receive any further newsletter email from us.'
	                                    ),
	                                    _react2.default.createElement(
	                                        'p',
	                                        null,
	                                        'Did you unsubscribe by accident? ',
	                                        _react2.default.createElement(
	                                            'a',
	                                            { href: _constant.BASEURL + '#footera' },
	                                            'Re-subscribe'
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'p',
	                                        null,
	                                        _react2.default.createElement(
	                                            'a',
	                                            { href: _constant.BASEURL },
	                                            'Return to Homepage'
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Unsubscribe;
	}(_react.Component);
	
	exports.default = Unsubscribe;

/***/ },
/* 873 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _HeaderNew = __webpack_require__(186);
	
	var _HeaderNew2 = _interopRequireDefault(_HeaderNew);
	
	var _FooterNew = __webpack_require__(185);
	
	var _FooterNew2 = _interopRequireDefault(_FooterNew);
	
	var _Footer = __webpack_require__(82);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _backArrowDark = __webpack_require__(123);
	
	var _backArrowDark2 = _interopRequireDefault(_backArrowDark);
	
	var _chartImage = __webpack_require__(136);
	
	var _chartImage2 = _interopRequireDefault(_chartImage);
	
	var _miniArrow = __webpack_require__(124);
	
	var _miniArrow2 = _interopRequireDefault(_miniArrow);
	
	var _reactSlick = __webpack_require__(93);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	__webpack_require__(122);
	
	__webpack_require__(121);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _FetchCall = __webpack_require__(4);
	
	var _icon = __webpack_require__(215);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _icon3 = __webpack_require__(216);
	
	var _icon4 = _interopRequireDefault(_icon3);
	
	var _icon5 = __webpack_require__(217);
	
	var _icon6 = _interopRequireDefault(_icon5);
	
	var _icon7 = __webpack_require__(218);
	
	var _icon8 = _interopRequireDefault(_icon7);
	
	var _view = __webpack_require__(223);
	
	var _view2 = _interopRequireDefault(_view);
	
	var _view3 = __webpack_require__(224);
	
	var _view4 = _interopRequireDefault(_view3);
	
	var _view5 = __webpack_require__(225);
	
	var _view6 = _interopRequireDefault(_view5);
	
	var _signup = __webpack_require__(222);
	
	var _signup2 = _interopRequireDefault(_signup);
	
	var _cashOnDelivery = __webpack_require__(220);
	
	var _cashOnDelivery2 = _interopRequireDefault(_cashOnDelivery);
	
	var _approve = __webpack_require__(219);
	
	var _approve2 = _interopRequireDefault(_approve);
	
	var _launch = __webpack_require__(221);
	
	var _launch2 = _interopRequireDefault(_launch);
	
	var _reactstrap = __webpack_require__(17);
	
	var _ModalHeader = __webpack_require__(102);
	
	var _ModalHeader2 = _interopRequireDefault(_ModalHeader);
	
	var _reactHelmet = __webpack_require__(77);
	
	var _bannerbgindividual = __webpack_require__(663);
	
	var _bannerbgindividual2 = _interopRequireDefault(_bannerbgindividual);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrencyFormat = __webpack_require__(112);
	
	var benefits = [_react2.default.createElement(
	  "ul",
	  null,
	  _react2.default.createElement(
	    "li",
	    null,
	    "200-word write-up about yourself and services offered on your page."
	  ),
	  _react2.default.createElement(
	    "li",
	    null,
	    "Manage your profile page frequently to improve brand and visibility."
	  ),
	  _react2.default.createElement(
	    "li",
	    null,
	    "Upload up to 8 images on your profile page."
	  ),
	  _react2.default.createElement(
	    "li",
	    null,
	    "Post your social media link(s) on your page."
	  ),
	  _react2.default.createElement(
	    "li",
	    null,
	    "Email interaction with prospective parents."
	  ),
	  _react2.default.createElement(
	    "li",
	    null,
	    "Respond to users on their feedback."
	  ),
	  _react2.default.createElement(
	    "li",
	    null,
	    "Upload videos links to showcase excellence."
	  ),
	  _react2.default.createElement(
	    "li",
	    null,
	    "Publish two articles a year on thought leadership."
	  )
	), _react2.default.createElement(
	  "ul",
	  null,
	  _react2.default.createElement(
	    "li",
	    null,
	    "300-word write-up about yourself and services offered on your page."
	  ),
	  _react2.default.createElement(
	    "li",
	    null,
	    "Manage your profile page frequently to improve brand and visibility."
	  ),
	  _react2.default.createElement(
	    "li",
	    null,
	    "Upload up to 15 images on your profile page."
	  ),
	  _react2.default.createElement(
	    "li",
	    null,
	    "Post your social media link(s) on your page."
	  ),
	  _react2.default.createElement(
	    "li",
	    null,
	    "Drive showcase you in some of our social media."
	  ),
	  _react2.default.createElement(
	    "li",
	    null,
	    "Email interaction with prospective parents."
	  ),
	  _react2.default.createElement(
	    "li",
	    null,
	    "Upload videos links to showcase excellence."
	  ),
	  _react2.default.createElement(
	    "li",
	    null,
	    "Publish two articles a year on thought leadership."
	  )
	)];
	
	var NewLandingPageInd = function (_Component) {
	  _inherits(NewLandingPageInd, _Component);
	
	  function NewLandingPageInd(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, NewLandingPageInd);
	
	    var _this = _possibleConstructorReturn(this, (NewLandingPageInd.__proto__ || Object.getPrototypeOf(NewLandingPageInd)).call(this, props));
	
	    _this.analyticsOffer = function () {
	
	      _this.setState({
	        offerModal: false,
	        analyticsModal: true
	      });
	      setTimeout(function () {
	        (0, _jquery2.default)(".modal").addClass("in");
	      }, 500);
	    };
	
	    _this.backToOffer = function () {
	      _this.setState({
	        offerModal: true,
	        analyticsModal: false
	      });
	      setTimeout(function () {
	        (0, _jquery2.default)(".modal").addClass("in");
	      }, 500);
	    };
	
	    _this.backToSlide = function () {
	      _this.setState({
	        offerModal: false,
	        analyticsModal: false
	      });
	      setTimeout(function () {
	        (0, _jquery2.default)(".modal").removeClass("in");
	      }, 500);
	    };
	
	    _this.getPlanList = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var planData;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              planData = JSON.stringify({
	                user_type: 2
	              });
	
	
	              (0, _FetchCall.getPlan)(planData).then(function (response) {
	                if (response.status == 1) {
	                  _this.setState({
	                    plan_list2: response.results
	                  });
	                } else {
	                  console.log('else');
	                }
	              });
	
	            case 2:
	            case "end":
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    }));
	
	    _this.handlePlan = function (id) {
	      var plan_info = _this.state.plan_list2.filter(function (o) {
	        return o.id == id;
	      });
	      console.log('plan_info', plan_info);
	      //window.$("#bewisestandard").modal("show");
	
	      _this.setState({
	        current_plan: plan_info,
	        plan_id: id,
	        offerModal: true,
	        analyticsModal: false
	      });
	      setTimeout(function () {
	        (0, _jquery2.default)(".modal").addClass("in");
	      }, 500);
	    };
	
	    _this.state = {
	      plan_list2: [],
	      current_plan: []
	    };
	    _this.getPlanList();
	    _this.slideCustom = _react2.default.createRef();
	    _this.slideCustom2 = _react2.default.createRef();
	
	    return _this;
	  }
	
	  _createClass(NewLandingPageInd, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var logged = localStorage.getItem("authentication");
	      var auth_data = JSON.parse(localStorage.getItem("user_data"));
	      console.log('auth_data.role', logged);
	      if (logged == 'true' && auth_data != 'null' && auth_data.role == 1) {
	        window.location.href = '/dashboard/dashboard';
	      } else if (logged == 'true' && auth_data != 'null' && auth_data.role == 3) {
	        window.location.href = '/partner/profile';
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var settings = {
	        dots: false,
	        infinite: false,
	        speed: 2000,
	        slidesToShow: 4,
	        slidesToScroll: 4,
	        autoplay: false,
	        arrows: true,
	        autoplaySpeed: 5000,
	        responsive: [{
	          breakpoint: 768,
	          settings: {
	            slidesToShow: 1,
	            slidesToScroll: 1
	          }
	        }]
	
	      };
	
	      var packages_settings = {
	        dots: false,
	        infinite: false,
	        speed: 2000,
	        slidesToShow: 2,
	        slidesToScroll: 1,
	        initialSlide: 1,
	        autoplay: false,
	        autoplaySpeed: 5000
	      };
	
	      var packages_settings_mobile = {
	        dots: false,
	        infinite: false,
	        speed: 2000,
	        slidesToShow: 1,
	        slidesToScroll: 1,
	        initialSlide: 0,
	        autoplay: false,
	        autoplaySpeed: 5000,
	        responsive: [{
	          breakpoint: 768,
	          settings: {
	            slidesToShow: 1,
	            initialSlide: 0,
	            slidesToScroll: 1
	          }
	        }]
	      };
	
	      var settings_dashboards = {
	
	        dots: false,
	        infinite: false,
	        speed: 2000,
	        slidesToShow: 1,
	        slidesToScroll: 1,
	        autoplay: false,
	        arrows: true,
	        autoplaySpeed: 5000,
	        responsive: [{
	          breakpoint: 768,
	          settings: {
	            slidesToShow: 1,
	            slidesToScroll: 1
	          }
	        }]
	
	      };
	
	      /* <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css" /> */
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _reactHelmet.Helmet,
	          null,
	          _react2.default.createElement(
	            "title",
	            null,
	            "BeWise individual Partners - Enhancing Education Together"
	          ),
	          _react2.default.createElement("meta", { name: "description", content: 'BeWise partners with educators to enhance education. Learn more about our collaborative efforts and programs by visiting our website.' })
	        ),
	        _react2.default.createElement(_HeaderNew2.default, null),
	        _react2.default.createElement(
	          "div",
	          { "class": "row display-flex-center mainrowheader", style: { marginTop: "85px" } },
	          _react2.default.createElement("div", { "class": "col-lg-2 col-sm-1 col-md-1" }),
	          _react2.default.createElement(
	            "div",
	            { "class": "col-lg-8 col-sm-10 col-md-10" },
	            _react2.default.createElement(
	              "div",
	              { "class": "bannersection_ind" },
	              _react2.default.createElement(
	                "div",
	                { "class": "bheader" },
	                "Welcome to ",
	                _react2.default.createElement(
	                  "span",
	                  { className: "bluetext" },
	                  "BeWise"
	                ),
	                " Partner Program"
	              ),
	              _react2.default.createElement(
	                "div",
	                { "class": "bbg" },
	                _react2.default.createElement("img", { src: _bannerbgindividual2.default, className: "bannerbg" })
	              ),
	              _react2.default.createElement(
	                "div",
	                { "class": "biconbox" },
	                _react2.default.createElement(
	                  _reactSlick2.default,
	                  settings,
	                  _react2.default.createElement(
	                    "div",
	                    { "class": "box" },
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "icon" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "image" },
	                        _react2.default.createElement("img", { src: _icon2.default })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "info" },
	                        _react2.default.createElement(
	                          "h3",
	                          { "class": "titlesm" },
	                          "Efficiency"
	                        ),
	                        _react2.default.createElement(
	                          "h4",
	                          { "class": "subtitle" },
	                          "Reaching target audience continuosly with"
	                        ),
	                        _react2.default.createElement(
	                          "ul",
	                          { "class": "boxli" },
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Brand recall"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Returns"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Reach"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Talent access"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Focus on objective"
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement("div", { "class": "space" })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { "class": "box" },
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "icon" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "image" },
	                        _react2.default.createElement("img", { src: _icon4.default })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "info" },
	                        _react2.default.createElement(
	                          "h3",
	                          { "class": "titlesm" },
	                          "Engagement"
	                        ),
	                        _react2.default.createElement(
	                          "h4",
	                          { "class": "subtitle" },
	                          "Continously with target Audience on"
	                        ),
	                        _react2.default.createElement(
	                          "ul",
	                          { "class": "boxli" },
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Brand values"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Leadership and followers"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Attracking talent"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Leveraging feedback"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Reaching events beyond"
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement("div", { "class": "space" })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { "class": "box" },
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "icon" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "image" },
	                        _react2.default.createElement("img", { src: _icon6.default })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "info" },
	                        _react2.default.createElement(
	                          "h3",
	                          { "class": "titlesm" },
	                          "Excellence"
	                        ),
	                        _react2.default.createElement(
	                          "h4",
	                          { "class": "subtitle" },
	                          "New Industry Standards"
	                        ),
	                        _react2.default.createElement(
	                          "ul",
	                          { "class": "boxli" },
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Data based decisions"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Transparency and leadership"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Enrollments 24x7"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Build insights and leadership for commnunity"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Frequently showcase successes to attract the best"
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement("div", { "class": "space" })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { "class": "box" },
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "icon" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "image" },
	                        _react2.default.createElement("img", { src: _icon8.default })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "info" },
	                        _react2.default.createElement(
	                          "h3",
	                          { "class": "titlesm" },
	                          "Enable(ment)"
	                        ),
	                        _react2.default.createElement(
	                          "h4",
	                          { "class": "subtitle" },
	                          "Raise Industry Standards"
	                        ),
	                        _react2.default.createElement(
	                          "ul",
	                          { "class": "boxli" },
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Brand strength 24x7"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Continuous benchmarking & tracking competitiveness"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Connected with trends and quick to customize"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Lead thought leadership for industry"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Attracting talent continuously"
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement("div", { "class": "space" })
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { "class": "packagesection" },
	              _react2.default.createElement(
	                "div",
	                { "class": "planheader" },
	                "BeWise Partner Subscription Packages"
	              ),
	              _react2.default.createElement(
	                "div",
	                { "class": "planbox formobile" },
	                _react2.default.createElement(
	                  _reactSlick2.default,
	                  Object.assign({}, packages_settings_mobile, { ref: this.slidepackages }),
	                  this.state.plan_list2.map(function (item, j) {
	
	                    return _react2.default.createElement(
	                      "div",
	                      { "class": "planBox", style: { minHeight: '500px' } },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "row display-flex-center" },
	                        _react2.default.createElement(
	                          "div",
	                          { "class": "col-lg-6 col-xs-6 col-sm-6 col-md-6 text-right", style: { borderRight: '8px solid' + ("" + item.icon_color) } },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "companyname" },
	                            "BeWise"
	                          ),
	                          _react2.default.createElement(
	                            "div",
	                            { className: "planname", style: { color: "" + item.icon_color } },
	                            item.plan_name
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { "class": "col-lg-6 col-xs-6 col-sm-6 col-md-6 text-left" },
	                          _react2.default.createElement(
	                            "a",
	                            { href: "/individual_signup", className: "btnlike" },
	                            "SignUp"
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "row display-flex-center plandesc" },
	                        _react2.default.createElement(
	                          "div",
	                          { "class": "col-lg-12 col-xs-12 col-sm-12 col-md-12 text-left planinfo", style: { paddingTop: "30px", paddingBottom: "30px" } },
	                          _react2.default.createElement(
	                            "h6",
	                            { style: { color: "" + item.icon_color } },
	                            "Package Details"
	                          ),
	                          _react2.default.createElement("div", { "class": "planbenefits landing-benfits", dangerouslySetInnerHTML: { __html: item.plan_offer } }),
	                          _react2.default.createElement(
	                            "div",
	                            { className: "view-package" },
	                            _react2.default.createElement(
	                              "a",
	                              { onClick: function onClick() {
	                                  return _this3.handlePlan(item.id);
	                                } },
	                              "View More"
	                            )
	                          )
	                        )
	                      )
	                    );
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { "class": "planbox fordesktop" },
	                _react2.default.createElement(
	                  _reactSlick2.default,
	                  Object.assign({}, packages_settings, { ref: this.slidepackages }),
	                  this.state.plan_list2.map(function (item, j) {
	
	                    return _react2.default.createElement(
	                      "div",
	                      { "class": "planBox", style: { minHeight: '500px' } },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "row display-flex-center" },
	                        _react2.default.createElement(
	                          "div",
	                          { "class": "col-lg-3 col-xs-3 col-sm-3 col-md-3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "stamp-img" },
	                            _react2.default.createElement("img", { src: item.baseurl + item.stamp_img })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { "class": "col-lg-5 col-xs-5 col-sm-5 col-md-5 landing-plan-name" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "companyname" },
	                            "BeWise"
	                          ),
	                          _react2.default.createElement(
	                            "div",
	                            { className: "planname", style: { color: "" + item.icon_color } },
	                            item.plan_name
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { "class": "col-lg-4 col-xs-4 col-sm-4 col-md-4" },
	                          _react2.default.createElement(
	                            "a",
	                            { href: "/individual_signup", className: "btnlike" },
	                            "SignUp"
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "row display-flex-center plandesc" },
	                        _react2.default.createElement(
	                          "div",
	                          { "class": "col-lg-12 col-xs-12 col-sm-12 col-md-12 text-left planinfo", style: { paddingTop: "30px", paddingBottom: "30px" } },
	                          _react2.default.createElement(
	                            "h6",
	                            { style: { color: "" + item.icon_color } },
	                            "Package Details"
	                          ),
	                          _react2.default.createElement("div", { "class": "planbenefits landing-benfits", dangerouslySetInnerHTML: { __html: item.plan_offer } }),
	                          _react2.default.createElement(
	                            "div",
	                            { className: "view-package" },
	                            _react2.default.createElement(
	                              "a",
	                              { onClick: function onClick() {
	                                  return _this3.handlePlan(item.id);
	                                } },
	                              "View More"
	                            )
	                          )
	                        )
	                      )
	                    );
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { "class": "howtobesection" },
	              _react2.default.createElement(
	                "div",
	                { "class": "planheader" },
	                "How to be BeWise Partner?"
	              ),
	              _react2.default.createElement(
	                "div",
	                { "class": "stepbox" },
	                _react2.default.createElement(
	                  "ol",
	                  null,
	                  _react2.default.createElement(
	                    "li",
	                    { className: "step1clr" },
	                    _react2.default.createElement(
	                      "p",
	                      { "class": "event-date" },
	                      _react2.default.createElement("img", { src: _signup2.default })
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      { "class": "event-step" },
	                      "Step 1"
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      { "class": "event-description" },
	                      "Click on Sign Up and provide us with required details to partner with BeWise."
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "li",
	                    { className: "step2clr" },
	                    _react2.default.createElement(
	                      "p",
	                      { "class": "event-date" },
	                      _react2.default.createElement("img", { src: _cashOnDelivery2.default })
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      { "class": "event-step" },
	                      "Step 2"
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      { "class": "event-description" },
	                      "Select a Package suitable to your work. Speak to our assigned Sales Team for any support required."
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "li",
	                    { className: "step3clr" },
	                    _react2.default.createElement(
	                      "p",
	                      { "class": "event-date" },
	                      _react2.default.createElement("img", { src: _approve2.default })
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      { "class": "event-step" },
	                      "Step 3"
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      { "class": "event-description" },
	                      "BeWise team will Verify and Validate the details provided."
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "li",
	                    { className: "step4clr" },
	                    _react2.default.createElement(
	                      "p",
	                      { "class": "event-date" },
	                      _react2.default.createElement("img", { src: _launch2.default })
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      { "class": "event-step" },
	                      "Step 4"
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      { "class": "event-description" },
	                      "Access you Account page to input any additional information. Also, Add Branches if you have"
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { "class": "dashboardsection" },
	              _react2.default.createElement(
	                "div",
	                { "class": "dashboardheader" },
	                "Dashboards and Partner Account Page - Sample Views "
	              ),
	              _react2.default.createElement(
	                "div",
	                { "class": "dashboardbox", id: "dashboards" },
	                _react2.default.createElement(
	                  _reactSlick2.default,
	                  Object.assign({}, settings_dashboards, { ref: this.slideCustom2 }),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "dashboardsampleview" },
	                    _react2.default.createElement("img", { src: _view2.default })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "dashboardsampleview" },
	                    _react2.default.createElement("img", { src: _view4.default })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "dashboardsampleview" },
	                    _react2.default.createElement("img", { src: _view6.default })
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement("div", { "class": "col-lg-2 col-sm-1 col-md-1" })
	        ),
	        _react2.default.createElement(
	          _reactstrap.Modal,
	          { isOpen: this.state.analyticsModal, size: "lg" },
	          _react2.default.createElement(
	            _ModalHeader2.default,
	            null,
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-6 mini-arrow", style: { cursor: 'pointer' }, onClick: this.backToOffer },
	              _react2.default.createElement("img", { src: _backArrowDark2.default, alt: "MiniArrow" }),
	              "\xA0\xA0 Back"
	            ),
	            _react2.default.createElement(
	              "button",
	              { type: "button", "class": "close", "data-dismiss": "modal", "aria-label": "Close", onClick: this.backToSlide },
	              _react2.default.createElement("i", { "class": "fa fa-times-circle-o", "aria-hidden": "true" })
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.ModalBody,
	            { className: "sign-upmodal" },
	            this.state.current_plan.length > 0 && _react2.default.createElement(
	              "div",
	              { className: "row" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-sm-8" },
	                _react2.default.createElement(
	                  "h1",
	                  null,
	                  "Analytics that we offer"
	                ),
	                _react2.default.createElement("div", { dangerouslySetInnerHTML: { __html: this.state.current_plan[0].analytics_offer } }),
	                this.state.current_plan[0].analytics_soon && _react2.default.createElement(
	                  "div",
	                  null,
	                  _react2.default.createElement(
	                    "h1",
	                    null,
	                    "Coming Soon"
	                  ),
	                  _react2.default.createElement("div", { dangerouslySetInnerHTML: { __html: this.state.current_plan[0].analytics_soon } })
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-sm-4" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "cardhead" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "img-box" },
	                    _react2.default.createElement("img", { src: this.state.current_plan[0].baseurl + this.state.current_plan[0].icon, alt: "plan icon" })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "img-rightcontent" },
	                    _react2.default.createElement(
	                      "h2",
	                      { style: { borderBottom: "4px solid " + this.state.current_plan[0].icon_color } },
	                      this.state.current_plan[0].site,
	                      _react2.default.createElement("br", null),
	                      this.state.current_plan[0].plan_name
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      null,
	                      _react2.default.createElement(
	                        "a",
	                        { href: "mailto:contact@bewise.in" },
	                        "Email us"
	                      ),
	                      " to receive our launch offers."
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      null,
	                      _react2.default.createElement(
	                        "small",
	                        null,
	                        "Please include your phonenumber for us to call back"
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactstrap.Modal,
	          { isOpen: this.state.offerModal, size: "lg" },
	          _react2.default.createElement(
	            _ModalHeader2.default,
	            null,
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-6 mini-arrow", style: { cursor: 'pointer' }, onClick: this.backToSlide },
	              _react2.default.createElement("img", { src: _backArrowDark2.default, alt: "MiniArrow" }),
	              "\xA0\xA0 Back"
	            ),
	            _react2.default.createElement(
	              "button",
	              { type: "button", "class": "close", "data-dismiss": "modal", "aria-label": "Close", onClick: this.backToSlide },
	              _react2.default.createElement("i", { "class": "fa fa-times-circle-o", "aria-hidden": "true" })
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.ModalBody,
	            { className: "sign-upmodal" },
	            this.state.current_plan.length > 0 && _react2.default.createElement(
	              "div",
	              { className: "row sign-upmodal" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-sm-8" },
	                _react2.default.createElement(
	                  "h1",
	                  null,
	                  "Our Offering"
	                ),
	                _react2.default.createElement("div", { dangerouslySetInnerHTML: { __html: this.state.current_plan[0].plan_offer } }),
	                this.state.current_plan[0].plan_soon && _react2.default.createElement(
	                  "div",
	                  null,
	                  _react2.default.createElement(
	                    "h1",
	                    null,
	                    "Coming Soon"
	                  ),
	                  _react2.default.createElement("div", { dangerouslySetInnerHTML: { __html: this.state.current_plan[0].plan_soon } })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "mini-arrow", style: { cursor: 'pointer' }, onClick: function onClick() {
	                      return _this3.analyticsOffer();
	                    } },
	                  "Analytics offer ",
	                  _react2.default.createElement("img", { src: _miniArrow2.default, alt: "MiniArrow" })
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-sm-4" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "cardhead" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "img-box" },
	                    _react2.default.createElement("img", { src: this.state.current_plan[0].baseurl + this.state.current_plan[0].icon, alt: "plan icon" })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "img-rightcontent" },
	                    _react2.default.createElement(
	                      "h2",
	                      { style: { borderBottom: "4px solid " + this.state.current_plan[0].icon_color } },
	                      this.state.current_plan[0].site,
	                      _react2.default.createElement("br", null),
	                      this.state.current_plan[0].plan_name
	                    ),
	                    _react2.default.createElement(
	                      "h1",
	                      null,
	                      _react2.default.createElement(
	                        "span",
	                        null,
	                        _react2.default.createElement(CurrencyFormat, { value: this.state.current_plan[0].base_price != '' ? this.state.current_plan[0].base_price : 0,
	                          displayType: 'text', thousandSeparator: true, prefix: '₹' })
	                      ),
	                      _react2.default.createElement(
	                        "span",
	                        null,
	                        "/Year"
	                      ),
	                      _react2.default.createElement("br", null),
	                      _react2.default.createElement(
	                        "small",
	                        null,
	                        this.state.current_plan[0].offer_name
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_Footer2.default, null),
	        _react2.default.createElement(
	          "div",
	          { className: "modal fade", id: "bewisestandard", role: "dialog" },
	          _react2.default.createElement(
	            "div",
	            { className: "modal-dialog  modal-lg" },
	            _react2.default.createElement(
	              "div",
	              { className: "modal-content" },
	              _react2.default.createElement(
	                "div",
	                { "class": "modal-header" },
	                _react2.default.createElement("div", { className: "col-md-6 mini-arrow" }),
	                _react2.default.createElement(
	                  "button",
	                  { type: "button", "class": "close", "data-dismiss": "modal", "aria-label": "Close", onClick: function onClick() {
	                      return _this3.backToSlide();
	                    } },
	                  _react2.default.createElement("i", { "class": "fa fa-times-circle-o", "aria-hidden": "true" })
	                )
	              ),
	              this.state.current_plan.length > 0 && _react2.default.createElement(
	                "div",
	                { className: "modal-body sign-upmodal" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "row" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-sm-8" },
	                    _react2.default.createElement(
	                      "h1",
	                      null,
	                      "Our Offering"
	                    ),
	                    _react2.default.createElement("div", { dangerouslySetInnerHTML: { __html: this.state.current_plan[0].plan_offer } }),
	                    this.state.current_plan[0].plan_soon && _react2.default.createElement(
	                      "div",
	                      null,
	                      _react2.default.createElement(
	                        "h1",
	                        null,
	                        "Coming Soon"
	                      ),
	                      _react2.default.createElement("div", { dangerouslySetInnerHTML: { __html: this.state.current_plan[0].plan_soon } })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "mini-arrow", style: { cursor: 'pointer' }, onClick: function onClick() {
	                          return _this3.analyticsOffer();
	                        } },
	                      "Analytics offer ",
	                      _react2.default.createElement("img", { src: _miniArrow2.default, alt: "MiniArrow" })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-sm-4" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "cardhead" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "img-box" },
	                        _react2.default.createElement("img", { src: this.state.current_plan[0].baseurl + this.state.current_plan[0].icon, alt: "plan icon" })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "img-rightcontent" },
	                        _react2.default.createElement(
	                          "h2",
	                          { style: { borderBottom: "4px solid " + this.state.current_plan[0].icon_color } },
	                          this.state.current_plan[0].site,
	                          _react2.default.createElement("br", null),
	                          this.state.current_plan[0].plan_name
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          null,
	                          _react2.default.createElement(
	                            "a",
	                            { href: "mailto:contact@bewise.in" },
	                            "Email us"
	                          ),
	                          " to receive our launch offers."
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          null,
	                          _react2.default.createElement(
	                            "small",
	                            null,
	                            "Please include your phonenumber for us to call back"
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return NewLandingPageInd;
	}(_react.Component);
	
	exports.default = NewLandingPageInd;

/***/ },
/* 874 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _HeaderNew = __webpack_require__(186);
	
	var _HeaderNew2 = _interopRequireDefault(_HeaderNew);
	
	var _FooterNew = __webpack_require__(185);
	
	var _FooterNew2 = _interopRequireDefault(_FooterNew);
	
	var _Footer = __webpack_require__(82);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _backArrowDark = __webpack_require__(123);
	
	var _backArrowDark2 = _interopRequireDefault(_backArrowDark);
	
	var _chartImage = __webpack_require__(136);
	
	var _chartImage2 = _interopRequireDefault(_chartImage);
	
	var _miniArrow = __webpack_require__(124);
	
	var _miniArrow2 = _interopRequireDefault(_miniArrow);
	
	var _reactSlick = __webpack_require__(93);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	__webpack_require__(122);
	
	__webpack_require__(121);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _FetchCall = __webpack_require__(4);
	
	var _icon = __webpack_require__(215);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _icon3 = __webpack_require__(216);
	
	var _icon4 = _interopRequireDefault(_icon3);
	
	var _icon5 = __webpack_require__(217);
	
	var _icon6 = _interopRequireDefault(_icon5);
	
	var _icon7 = __webpack_require__(218);
	
	var _icon8 = _interopRequireDefault(_icon7);
	
	var _view = __webpack_require__(223);
	
	var _view2 = _interopRequireDefault(_view);
	
	var _view3 = __webpack_require__(224);
	
	var _view4 = _interopRequireDefault(_view3);
	
	var _view5 = __webpack_require__(225);
	
	var _view6 = _interopRequireDefault(_view5);
	
	var _signup = __webpack_require__(222);
	
	var _signup2 = _interopRequireDefault(_signup);
	
	var _cashOnDelivery = __webpack_require__(220);
	
	var _cashOnDelivery2 = _interopRequireDefault(_cashOnDelivery);
	
	var _approve = __webpack_require__(219);
	
	var _approve2 = _interopRequireDefault(_approve);
	
	var _launch = __webpack_require__(221);
	
	var _launch2 = _interopRequireDefault(_launch);
	
	var _bannerbg = __webpack_require__(662);
	
	var _bannerbg2 = _interopRequireDefault(_bannerbg);
	
	var _reactstrap = __webpack_require__(17);
	
	var _ModalHeader = __webpack_require__(102);
	
	var _ModalHeader2 = _interopRequireDefault(_ModalHeader);
	
	var _reactHelmet = __webpack_require__(77);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrencyFormat = __webpack_require__(112);
	
	var benefits = [_react2.default.createElement(
	  "ul",
	  null,
	  _react2.default.createElement(
	    "li",
	    null,
	    "200-word write-up about yourself and services offered on your page."
	  ),
	  _react2.default.createElement(
	    "li",
	    null,
	    "Manage your profile page frequently to improve brand and visibility."
	  ),
	  _react2.default.createElement(
	    "li",
	    null,
	    "Upload up to 8 images on your profile page."
	  ),
	  _react2.default.createElement(
	    "li",
	    null,
	    "Post your social media link(s) on your page."
	  ),
	  _react2.default.createElement(
	    "li",
	    null,
	    "Email interaction with prospective parents."
	  ),
	  _react2.default.createElement(
	    "li",
	    null,
	    "Respond to users on their feedback."
	  ),
	  _react2.default.createElement(
	    "li",
	    null,
	    "Upload videos links to showcase excellence."
	  ),
	  _react2.default.createElement(
	    "li",
	    null,
	    "Publish two articles a year on thought leadership."
	  )
	), _react2.default.createElement(
	  "ul",
	  null,
	  _react2.default.createElement(
	    "li",
	    null,
	    "400-word write-up about yourself and services offered on your page."
	  ),
	  _react2.default.createElement(
	    "li",
	    null,
	    "Manage your profile page frequently to improve brand and visibility."
	  ),
	  _react2.default.createElement(
	    "li",
	    null,
	    "Upload up to 15 images on your profile page."
	  ),
	  _react2.default.createElement(
	    "li",
	    null,
	    "Post your social media link(s) on your page."
	  ),
	  _react2.default.createElement(
	    "li",
	    null,
	    "Drive showcase you in some of our social media."
	  ),
	  _react2.default.createElement(
	    "li",
	    null,
	    "Email interaction with prospective parents."
	  ),
	  _react2.default.createElement(
	    "li",
	    null,
	    "Upload videos links to showcase excellence."
	  ),
	  _react2.default.createElement(
	    "li",
	    null,
	    "Publish two articles a year on thought leadership."
	  )
	)];
	
	var NewLandingPageIns = function (_Component) {
	  _inherits(NewLandingPageIns, _Component);
	
	  function NewLandingPageIns(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, NewLandingPageIns);
	
	    var _this = _possibleConstructorReturn(this, (NewLandingPageIns.__proto__ || Object.getPrototypeOf(NewLandingPageIns)).call(this, props));
	
	    _this.analyticsOffer = function () {
	      _this.setState({
	        offerModal: false,
	        analyticsModal: true
	      });
	      setTimeout(function () {
	        (0, _jquery2.default)(".modal").addClass("in");
	      }, 500);
	    };
	
	    _this.backToOffer = function () {
	      _this.setState({
	        offerModal: true,
	        analyticsModal: false
	      });
	      setTimeout(function () {
	        (0, _jquery2.default)(".modal").addClass("in");
	      }, 500);
	    };
	
	    _this.backToSlide = function () {
	      _this.setState({
	        offerModal: false,
	        analyticsModal: false
	      });
	      setTimeout(function () {
	        (0, _jquery2.default)(".modal").removeClass("in");
	      }, 500);
	    };
	
	    _this.getPlanList = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var planData;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              planData = JSON.stringify({
	                user_type: 1
	              });
	
	
	              (0, _FetchCall.getPlan)(planData).then(function (response) {
	                if (response.status == 1) {
	                  _this.setState({
	                    plan_list2: response.results
	                  });
	                } else {
	                  console.log('else');
	                }
	              });
	
	            case 2:
	            case "end":
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    }));
	
	    _this.handlePlan = function (id) {
	      var plan_info = _this.state.plan_list2.filter(function (o) {
	        return o.id == id;
	      });
	      console.log('plan_info', plan_info);
	      _this.setState({
	        current_plan: plan_info,
	        plan_id: id,
	        offerModal: true,
	        analyticsModal: false
	      });
	      setTimeout(function () {
	        (0, _jquery2.default)(".modal").addClass("in");
	      }, 500);
	    };
	
	    _this.analyticsOffer = function () {
	      _this.setState({
	        offerModal: false,
	        analyticsModal: true
	      });
	      setTimeout(function () {
	        (0, _jquery2.default)(".modal").addClass("in");
	      }, 500);
	    };
	
	    _this.backToOffer = function () {
	      _this.setState({
	        offerModal: true,
	        analyticsModal: false
	      });
	      setTimeout(function () {
	        (0, _jquery2.default)(".modal").addClass("in");
	      }, 500);
	    };
	
	    _this.backToSlide = function () {
	      _this.setState({
	        offerModal: false,
	        analyticsModal: false
	      });
	      setTimeout(function () {
	        (0, _jquery2.default)(".modal").removeClass("in");
	      }, 500);
	    };
	
	    _this.state = {
	      plan_list2: [],
	      current_plan: []
	    };
	    _this.getPlanList();
	    _this.slideCustom = _react2.default.createRef();
	    _this.slidepackages = _react2.default.createRef();
	    _this.slideCustom3 = _react2.default.createRef();
	    return _this;
	  }
	
	  _createClass(NewLandingPageIns, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var logged = localStorage.getItem("authentication");
	      var auth_data = JSON.parse(localStorage.getItem("user_data"));
	      console.log('auth_data.role', logged);
	      /*
	      if (logged == 'true' && auth_data != 'null' && auth_data.role == 1) {
	        window.location.href = '/dashboard/dashboard';
	      } else if (logged == 'true' && auth_data != 'null' && auth_data.role == 3) {
	        window.location.href = '/partner/profile';
	      }
	      */
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var settings = {
	        dots: false,
	        infinite: false,
	        speed: 2000,
	        slidesToShow: 4,
	        slidesToScroll: 4,
	        autoplay: false,
	        autoplaySpeed: 5000,
	        responsive: [{
	          breakpoint: 768,
	          settings: {
	            slidesToShow: 1,
	            centerMode: false, /* set centerMode to false to show complete slide instead of 3 */
	            slidesToScroll: 1
	          }
	        }]
	
	      };
	
	      var settings_dashboards = {
	
	        dots: false,
	        infinite: false,
	        speed: 2000,
	        slidesToShow: 1,
	        slidesToScroll: 1,
	        autoplay: false,
	        autoplaySpeed: 5000,
	        responsive: [{
	          breakpoint: 768,
	          settings: {
	            slidesToShow: 1,
	            centerMode: false, /* set centerMode to false to show complete slide instead of 3 */
	            slidesToScroll: 1
	          }
	        }]
	
	      };
	
	      var packages_settings = {
	        dots: false,
	        infinite: false,
	        speed: 2000,
	        slidesToShow: 2,
	        slidesToScroll: 1,
	        initialSlide: 1,
	        autoplay: false,
	        autoplaySpeed: 5000
	      };
	
	      var packages_settings_mobile = {
	        dots: false,
	        infinite: false,
	        speed: 2000,
	        slidesToShow: 1,
	        slidesToScroll: 1,
	        initialSlide: 0,
	        autoplay: false,
	        autoplaySpeed: 5000,
	        responsive: [{
	          breakpoint: 768,
	          settings: {
	            slidesToShow: 1,
	            initialSlide: 0,
	            slidesToScroll: 1
	          }
	        }]
	      };
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _reactHelmet.Helmet,
	          null,
	          _react2.default.createElement(
	            "title",
	            null,
	            "BeWise Institutional Partners - Enhancing Education Together"
	          ),
	          _react2.default.createElement("meta", { name: "description", content: 'BeWise partners with the best schools to provide quality education and a strong foundation for students.' })
	        ),
	        _react2.default.createElement(_HeaderNew2.default, null),
	        _react2.default.createElement(
	          "div",
	          { "class": "row display-flex-center mainrowheader", style: { marginTop: "85px" } },
	          _react2.default.createElement("div", { "class": "col-lg-2 col-sm-2 col-md-2" }),
	          _react2.default.createElement(
	            "div",
	            { "class": "col-lg-8 col-sm-8 col-md-8" },
	            _react2.default.createElement(
	              "div",
	              { "class": "bannersection" },
	              _react2.default.createElement(
	                "div",
	                { "class": "bheader" },
	                "Welcome to ",
	                _react2.default.createElement(
	                  "span",
	                  { className: "bluetext" },
	                  "BeWise"
	                ),
	                " Partner Program"
	              ),
	              _react2.default.createElement(
	                "div",
	                { "class": "bbg" },
	                _react2.default.createElement("img", { src: _bannerbg2.default, className: "bannerbg" })
	              ),
	              _react2.default.createElement(
	                "div",
	                { "class": "biconbox" },
	                _react2.default.createElement(
	                  _reactSlick2.default,
	                  Object.assign({}, settings, { ref: this.slideCustom }),
	                  _react2.default.createElement(
	                    "div",
	                    { "class": "box" },
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "icon" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "image" },
	                        _react2.default.createElement("img", { src: _icon2.default })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "info" },
	                        _react2.default.createElement(
	                          "h3",
	                          { "class": "titlesm" },
	                          "Efficiency"
	                        ),
	                        _react2.default.createElement(
	                          "h4",
	                          { "class": "subtitle" },
	                          "Reaching target audience continuosly with"
	                        ),
	                        _react2.default.createElement(
	                          "ul",
	                          { "class": "boxli" },
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Brand recall"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Returns"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Reach"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Talent access"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Focus on objective"
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement("div", { "class": "space" })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { "class": "box" },
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "icon" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "image" },
	                        _react2.default.createElement("img", { src: _icon4.default })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "info" },
	                        _react2.default.createElement(
	                          "h3",
	                          { "class": "titlesm" },
	                          "Engagement"
	                        ),
	                        _react2.default.createElement(
	                          "h4",
	                          { "class": "subtitle" },
	                          "Continously with target Audience on"
	                        ),
	                        _react2.default.createElement(
	                          "ul",
	                          { "class": "boxli" },
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Brand values"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Leadership and followers"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Attracking talent"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Leveraging feedback"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Reaching events beyond"
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement("div", { "class": "space" })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { "class": "box" },
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "icon" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "image" },
	                        _react2.default.createElement("img", { src: _icon6.default })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "info" },
	                        _react2.default.createElement(
	                          "h3",
	                          { "class": "titlesm" },
	                          "Excellence"
	                        ),
	                        _react2.default.createElement(
	                          "h4",
	                          { "class": "subtitle" },
	                          "New Industry Standards"
	                        ),
	                        _react2.default.createElement(
	                          "ul",
	                          { "class": "boxli" },
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Data based decisions"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Transparency and leadership"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Enrollments 24x7"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Build insights and leadership for commnunity"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Frequently showcase successes to attract the best"
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement("div", { "class": "space" })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { "class": "box" },
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "icon" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "image" },
	                        _react2.default.createElement("img", { src: _icon8.default })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "info" },
	                        _react2.default.createElement(
	                          "h3",
	                          { "class": "titlesm" },
	                          "Enable(ment)"
	                        ),
	                        _react2.default.createElement(
	                          "h4",
	                          { "class": "subtitle" },
	                          "Raise Industry Standards"
	                        ),
	                        _react2.default.createElement(
	                          "ul",
	                          { "class": "boxli" },
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Brand strength 24x7"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Continuous benchmarking & tracking competitiveness"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Connected with trends and quick to customize"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Lead thought leadership for industry"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Attracting talent continuously"
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement("div", { "class": "space" })
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { "class": "packagesection" },
	              _react2.default.createElement(
	                "div",
	                { "class": "planheader" },
	                "BeWise Partner Subscription Packages"
	              ),
	              _react2.default.createElement(
	                "div",
	                { "class": "planbox formobile" },
	                _react2.default.createElement(
	                  _reactSlick2.default,
	                  Object.assign({}, packages_settings_mobile, { ref: this.slidepackages }),
	                  this.state.plan_list2.map(function (item, j) {
	
	                    return _react2.default.createElement(
	                      "div",
	                      { "class": "planBox", style: { minHeight: '500px' } },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "row display-flex-center" },
	                        _react2.default.createElement(
	                          "div",
	                          { "class": "col-lg-6 col-xs-6 col-sm-6 col-md-6 text-right", style: { borderRight: '8px solid' + ("" + item.icon_color) } },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "companyname" },
	                            "BeWise"
	                          ),
	                          _react2.default.createElement(
	                            "div",
	                            { className: "planname", style: { color: "" + item.icon_color } },
	                            item.plan_name
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { "class": "col-lg-6 col-xs-6 col-sm-6 col-md-6 text-left" },
	                          _react2.default.createElement(
	                            "a",
	                            { href: "/institution_signup", className: "btnlike" },
	                            "SignUp"
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "row display-flex-center plandesc" },
	                        _react2.default.createElement(
	                          "div",
	                          { "class": "col-lg-12 col-xs-12 col-sm-12 col-md-12 text-left planinfo", style: { paddingTop: "30px", paddingBottom: "30px" } },
	                          _react2.default.createElement(
	                            "h6",
	                            { style: { color: "" + item.icon_color } },
	                            "Package Details"
	                          ),
	                          _react2.default.createElement("div", { "class": "planbenefits landing-benfits", dangerouslySetInnerHTML: { __html: item.plan_offer } }),
	                          _react2.default.createElement(
	                            "div",
	                            { className: "view-package" },
	                            _react2.default.createElement(
	                              "a",
	                              { onClick: function onClick() {
	                                  return _this3.handlePlan(item.id);
	                                } },
	                              "View More"
	                            )
	                          )
	                        )
	                      )
	                    );
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { "class": "planbox fordesktop" },
	                _react2.default.createElement(
	                  _reactSlick2.default,
	                  Object.assign({}, packages_settings, { ref: this.slidepackages }),
	                  this.state.plan_list2.map(function (item, j) {
	
	                    return _react2.default.createElement(
	                      "div",
	                      { "class": "planBox", style: { minHeight: '500px' } },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "row display-flex-center" },
	                        _react2.default.createElement(
	                          "div",
	                          { "class": "col-lg-3 col-xs-3 col-sm-3 col-md-3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "stamp-img" },
	                            _react2.default.createElement("img", { src: item.baseurl + item.stamp_img })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { "class": "col-lg-5 col-xs-5 col-sm-5 col-md-5 landing-plan-name" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "companyname" },
	                            "BeWise"
	                          ),
	                          _react2.default.createElement(
	                            "div",
	                            { className: "planname", style: { color: "" + item.icon_color } },
	                            item.plan_name
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { "class": "col-lg-4 col-xs-4 col-sm-4 col-md-4" },
	                          _react2.default.createElement(
	                            "a",
	                            { href: "/institution_signup", className: "btnlike" },
	                            "SignUp"
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "row display-flex-center plandesc" },
	                        _react2.default.createElement(
	                          "div",
	                          { "class": "col-lg-12 col-xs-12 col-sm-12 col-md-12 text-left planinfo", style: { paddingTop: "30px", paddingBottom: "30px" } },
	                          _react2.default.createElement(
	                            "h6",
	                            { style: { color: "" + item.icon_color } },
	                            "Package Details"
	                          ),
	                          _react2.default.createElement("div", { "class": "planbenefits landing-benfits", dangerouslySetInnerHTML: { __html: item.plan_offer } }),
	                          _react2.default.createElement(
	                            "div",
	                            { className: "view-package" },
	                            _react2.default.createElement(
	                              "a",
	                              { onClick: function onClick() {
	                                  return _this3.handlePlan(item.id);
	                                } },
	                              "View More"
	                            )
	                          )
	                        )
	                      )
	                    );
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { "class": "howtobesection" },
	              _react2.default.createElement(
	                "div",
	                { "class": "planheader" },
	                "How to be BeWise Partner?"
	              ),
	              _react2.default.createElement(
	                "div",
	                { "class": "stepbox" },
	                _react2.default.createElement(
	                  "ol",
	                  null,
	                  _react2.default.createElement(
	                    "li",
	                    { className: "step1clr" },
	                    _react2.default.createElement(
	                      "p",
	                      { "class": "event-date" },
	                      _react2.default.createElement("img", { src: _signup2.default })
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      { "class": "event-step" },
	                      "Step 1"
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      { "class": "event-description" },
	                      "Click on Sign Up and provide us with required details to partner with BeWise."
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "li",
	                    { className: "step2clr" },
	                    _react2.default.createElement(
	                      "p",
	                      { "class": "event-date" },
	                      _react2.default.createElement("img", { src: _cashOnDelivery2.default })
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      { "class": "event-step" },
	                      "Step 2"
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      { "class": "event-description" },
	                      "Select a Package suitable to your work. Speak to our assigned Sales Team for any support required."
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "li",
	                    { className: "step3clr" },
	                    _react2.default.createElement(
	                      "p",
	                      { "class": "event-date" },
	                      _react2.default.createElement("img", { src: _approve2.default })
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      { "class": "event-step" },
	                      "Step 3"
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      { "class": "event-description" },
	                      "BeWise team will Verify and Validate the details provided."
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "li",
	                    { className: "step4clr" },
	                    _react2.default.createElement(
	                      "p",
	                      { "class": "event-date" },
	                      _react2.default.createElement("img", { src: _launch2.default })
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      { "class": "event-step" },
	                      "Step 4"
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      { "class": "event-description" },
	                      "Access you Account page to input any additional information. Also, Add Branches if you have"
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { "class": "dashboardsection" },
	              _react2.default.createElement(
	                "div",
	                { "class": "dashboardheader" },
	                "Dashboards and Partner Account Page - Sample Views "
	              ),
	              _react2.default.createElement(
	                "div",
	                { "class": "dashboardbox", id: "dashboards" },
	                _react2.default.createElement(
	                  _reactSlick2.default,
	                  Object.assign({}, settings_dashboards, { ref: this.slideCustom2 }),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "dashboardsampleview" },
	                    _react2.default.createElement("img", { src: _view2.default })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "dashboardsampleview" },
	                    _react2.default.createElement("img", { src: _view4.default })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "dashboardsampleview" },
	                    _react2.default.createElement("img", { src: _view6.default })
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement("div", { "class": "col-lg-2 col-sm-2 col-md-2" })
	        ),
	        _react2.default.createElement(
	          _reactstrap.Modal,
	          { isOpen: this.state.offerModal, size: "lg" },
	          _react2.default.createElement(
	            _ModalHeader2.default,
	            null,
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-6 mini-arrow", style: { cursor: 'pointer' }, onClick: this.backToSlide },
	              _react2.default.createElement("img", { src: _backArrowDark2.default, alt: "MiniArrow" }),
	              "\xA0\xA0 Back"
	            ),
	            _react2.default.createElement(
	              "button",
	              { type: "button", "class": "close", "data-dismiss": "modal", "aria-label": "Close", onClick: this.backToSlide },
	              _react2.default.createElement("i", { "class": "fa fa-times-circle-o", "aria-hidden": "true" })
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.ModalBody,
	            { className: "sign-upmodal" },
	            this.state.current_plan.length > 0 && _react2.default.createElement(
	              "div",
	              { className: "row sign-upmodal" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-sm-8" },
	                _react2.default.createElement(
	                  "h1",
	                  null,
	                  "Our Offering"
	                ),
	                _react2.default.createElement("div", { dangerouslySetInnerHTML: { __html: this.state.current_plan[0].plan_offer } }),
	                this.state.current_plan[0].plan_soon && _react2.default.createElement(
	                  "div",
	                  null,
	                  _react2.default.createElement(
	                    "h1",
	                    null,
	                    "Coming Soon"
	                  ),
	                  _react2.default.createElement("div", { dangerouslySetInnerHTML: { __html: this.state.current_plan[0].plan_soon } })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "mini-arrow", style: { cursor: 'pointer' }, onClick: function onClick() {
	                      return _this3.analyticsOffer();
	                    } },
	                  "Analytics offer ",
	                  _react2.default.createElement("img", { src: _miniArrow2.default, alt: "MiniArrow" })
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-sm-4" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "cardhead" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "img-box" },
	                    _react2.default.createElement("img", { src: this.state.current_plan[0].baseurl + this.state.current_plan[0].icon, alt: "plan icon" })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "img-rightcontent" },
	                    _react2.default.createElement(
	                      "h2",
	                      { style: { borderBottom: "4px solid " + this.state.current_plan[0].icon_color } },
	                      this.state.current_plan[0].site,
	                      _react2.default.createElement("br", null),
	                      this.state.current_plan[0].plan_name
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      null,
	                      _react2.default.createElement(
	                        "a",
	                        { href: "mailto:contact@bewise.in" },
	                        "Email us"
	                      ),
	                      " to receive our launch offers."
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      null,
	                      _react2.default.createElement(
	                        "small",
	                        null,
	                        "Please include your phonenumber for us to call back"
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactstrap.Modal,
	          { isOpen: this.state.analyticsModal, size: "lg" },
	          _react2.default.createElement(
	            _ModalHeader2.default,
	            null,
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-6 mini-arrow", style: { cursor: 'pointer' }, onClick: this.backToOffer },
	              _react2.default.createElement("img", { src: _backArrowDark2.default, alt: "MiniArrow" }),
	              "\xA0\xA0 Back"
	            ),
	            _react2.default.createElement(
	              "button",
	              { type: "button", "class": "close", "data-dismiss": "modal", "aria-label": "Close", onClick: this.backToSlide },
	              _react2.default.createElement("i", { "class": "fa fa-times-circle-o", "aria-hidden": "true" })
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.ModalBody,
	            { className: "sign-upmodal" },
	            this.state.current_plan.length > 0 && _react2.default.createElement(
	              "div",
	              { className: "row" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-sm-8" },
	                _react2.default.createElement(
	                  "h1",
	                  null,
	                  "Analytics that we offer"
	                ),
	                _react2.default.createElement("div", { dangerouslySetInnerHTML: { __html: this.state.current_plan[0].analytics_offer } }),
	                this.state.current_plan[0].analytics_soon && _react2.default.createElement(
	                  "div",
	                  null,
	                  _react2.default.createElement(
	                    "h1",
	                    null,
	                    "Coming Soon"
	                  ),
	                  _react2.default.createElement("div", { dangerouslySetInnerHTML: { __html: this.state.current_plan[0].analytics_soon } })
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-sm-4" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "cardhead" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "img-box" },
	                    _react2.default.createElement("img", { src: this.state.current_plan[0].baseurl + this.state.current_plan[0].icon, alt: "plan icon" })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "img-rightcontent" },
	                    _react2.default.createElement(
	                      "h2",
	                      { style: { borderBottom: "4px solid " + this.state.current_plan[0].icon_color } },
	                      this.state.current_plan[0].site,
	                      _react2.default.createElement("br", null),
	                      this.state.current_plan[0].plan_name
	                    ),
	                    _react2.default.createElement(
	                      "h1",
	                      null,
	                      _react2.default.createElement(
	                        "span",
	                        null,
	                        _react2.default.createElement(CurrencyFormat, { value: this.state.current_plan[0].base_price != '' ? this.state.current_plan[0].base_price : 0,
	                          displayType: 'text', thousandSeparator: true, prefix: '₹' })
	                      ),
	                      _react2.default.createElement(
	                        "span",
	                        null,
	                        "/Year"
	                      ),
	                      _react2.default.createElement("br", null),
	                      _react2.default.createElement(
	                        "small",
	                        null,
	                        this.state.current_plan[0].offer_name
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_Footer2.default, null),
	        _react2.default.createElement(
	          "div",
	          { className: "modal fade", id: "bewisestandard", role: "dialog" },
	          _react2.default.createElement(
	            "div",
	            { className: "modal-dialog  modal-lg" },
	            _react2.default.createElement(
	              "div",
	              { className: "modal-content" },
	              _react2.default.createElement(
	                "div",
	                { "class": "modal-header" },
	                _react2.default.createElement("div", { className: "col-md-6 mini-arrow" }),
	                _react2.default.createElement(
	                  "button",
	                  { type: "button", "class": "close", "data-dismiss": "modal", "aria-label": "Close", onClick: function onClick() {
	                      return _this3.backToSlide();
	                    } },
	                  _react2.default.createElement("i", { "class": "fa fa-times-circle-o", "aria-hidden": "true" })
	                )
	              ),
	              this.state.current_plan.length > 0 && _react2.default.createElement(
	                "div",
	                { className: "modal-body sign-upmodal" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "row" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-sm-8" },
	                    _react2.default.createElement(
	                      "h1",
	                      null,
	                      "Our Offering"
	                    ),
	                    _react2.default.createElement("div", { dangerouslySetInnerHTML: { __html: this.state.current_plan[0].plan_offer } }),
	                    this.state.current_plan[0].plan_soon && _react2.default.createElement(
	                      "div",
	                      null,
	                      _react2.default.createElement(
	                        "h1",
	                        null,
	                        "Coming Soon"
	                      ),
	                      _react2.default.createElement("div", { dangerouslySetInnerHTML: { __html: this.state.current_plan[0].plan_soon } })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "mini-arrow", style: { cursor: 'pointer' }, onClick: function onClick() {
	                          return _this3.analyticsOffer();
	                        } },
	                      "Analytics offer ",
	                      _react2.default.createElement("img", { src: _miniArrow2.default, alt: "MiniArrow" })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-sm-4" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "cardhead" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "img-box" },
	                        _react2.default.createElement("img", { src: this.state.current_plan[0].baseurl + this.state.current_plan[0].icon, alt: "plan icon" })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "img-rightcontent" },
	                        _react2.default.createElement(
	                          "h2",
	                          { style: { borderBottom: "4px solid " + this.state.current_plan[0].icon_color } },
	                          this.state.current_plan[0].site,
	                          _react2.default.createElement("br", null),
	                          this.state.current_plan[0].plan_name
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          null,
	                          _react2.default.createElement(
	                            "a",
	                            { href: "mailto:contact@bewise.in" },
	                            "Email us"
	                          ),
	                          " to receive our launch offers."
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          null,
	                          _react2.default.createElement(
	                            "small",
	                            null,
	                            "Please include your phonenumber for us to call back"
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return NewLandingPageIns;
	}(_react.Component);
	
	exports.default = NewLandingPageIns;

/***/ },
/* 875 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _HeaderNew = __webpack_require__(186);
	
	var _HeaderNew2 = _interopRequireDefault(_HeaderNew);
	
	var _FooterNew = __webpack_require__(185);
	
	var _FooterNew2 = _interopRequireDefault(_FooterNew);
	
	var _Footer = __webpack_require__(82);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _backArrowDark = __webpack_require__(123);
	
	var _backArrowDark2 = _interopRequireDefault(_backArrowDark);
	
	var _chartImage = __webpack_require__(136);
	
	var _chartImage2 = _interopRequireDefault(_chartImage);
	
	var _miniArrow = __webpack_require__(124);
	
	var _miniArrow2 = _interopRequireDefault(_miniArrow);
	
	var _reactSlick = __webpack_require__(93);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	__webpack_require__(122);
	
	__webpack_require__(121);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _FetchCall = __webpack_require__(4);
	
	var _icon = __webpack_require__(215);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _icon3 = __webpack_require__(216);
	
	var _icon4 = _interopRequireDefault(_icon3);
	
	var _icon5 = __webpack_require__(217);
	
	var _icon6 = _interopRequireDefault(_icon5);
	
	var _icon7 = __webpack_require__(218);
	
	var _icon8 = _interopRequireDefault(_icon7);
	
	var _view = __webpack_require__(223);
	
	var _view2 = _interopRequireDefault(_view);
	
	var _view3 = __webpack_require__(224);
	
	var _view4 = _interopRequireDefault(_view3);
	
	var _view5 = __webpack_require__(225);
	
	var _view6 = _interopRequireDefault(_view5);
	
	var _signup = __webpack_require__(222);
	
	var _signup2 = _interopRequireDefault(_signup);
	
	var _cashOnDelivery = __webpack_require__(220);
	
	var _cashOnDelivery2 = _interopRequireDefault(_cashOnDelivery);
	
	var _approve = __webpack_require__(219);
	
	var _approve2 = _interopRequireDefault(_approve);
	
	var _launch = __webpack_require__(221);
	
	var _launch2 = _interopRequireDefault(_launch);
	
	var _reactstrap = __webpack_require__(17);
	
	var _ModalHeader = __webpack_require__(102);
	
	var _ModalHeader2 = _interopRequireDefault(_ModalHeader);
	
	var _reactHelmet = __webpack_require__(77);
	
	var _bannerbgindividual = __webpack_require__(663);
	
	var _bannerbgindividual2 = _interopRequireDefault(_bannerbgindividual);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrencyFormat = __webpack_require__(112);
	
	var benefits = [_react2.default.createElement(
	  "ul",
	  null,
	  _react2.default.createElement(
	    "li",
	    null,
	    "200-word write-up about yourself and services offered on your page."
	  ),
	  _react2.default.createElement(
	    "li",
	    null,
	    "Manage your profile page frequently to improve brand and visibility."
	  ),
	  _react2.default.createElement(
	    "li",
	    null,
	    "Upload up to 8 images on your profile page."
	  ),
	  _react2.default.createElement(
	    "li",
	    null,
	    "Post your social media link(s) on your page."
	  ),
	  _react2.default.createElement(
	    "li",
	    null,
	    "Email interaction with prospective parents."
	  ),
	  _react2.default.createElement(
	    "li",
	    null,
	    "Respond to users on their feedback."
	  ),
	  _react2.default.createElement(
	    "li",
	    null,
	    "Upload videos links to showcase excellence."
	  ),
	  _react2.default.createElement(
	    "li",
	    null,
	    "Publish two articles a year on thought leadership."
	  )
	), _react2.default.createElement(
	  "ul",
	  null,
	  _react2.default.createElement(
	    "li",
	    null,
	    "300-word write-up about yourself and services offered on your page."
	  ),
	  _react2.default.createElement(
	    "li",
	    null,
	    "Manage your profile page frequently to improve brand and visibility."
	  ),
	  _react2.default.createElement(
	    "li",
	    null,
	    "Upload up to 15 images on your profile page."
	  ),
	  _react2.default.createElement(
	    "li",
	    null,
	    "Post your social media link(s) on your page."
	  ),
	  _react2.default.createElement(
	    "li",
	    null,
	    "Drive showcase you in some of our social media."
	  ),
	  _react2.default.createElement(
	    "li",
	    null,
	    "Email interaction with prospective parents."
	  ),
	  _react2.default.createElement(
	    "li",
	    null,
	    "Upload videos links to showcase excellence."
	  ),
	  _react2.default.createElement(
	    "li",
	    null,
	    "Publish two articles a year on thought leadership."
	  )
	)];
	
	var PlanIndIns = function (_Component) {
	  _inherits(PlanIndIns, _Component);
	
	  function PlanIndIns(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, PlanIndIns);
	
	    var _this = _possibleConstructorReturn(this, (PlanIndIns.__proto__ || Object.getPrototypeOf(PlanIndIns)).call(this, props));
	
	    _this.analyticsOffer = function () {
	
	      _this.setState({
	        offerModal: false,
	        analyticsModal: true
	      });
	      setTimeout(function () {
	        (0, _jquery2.default)(".modal").addClass("in");
	      }, 500);
	    };
	
	    _this.backToOffer = function () {
	      _this.setState({
	        offerModal: true,
	        analyticsModal: false
	      });
	      setTimeout(function () {
	        (0, _jquery2.default)(".modal").addClass("in");
	      }, 500);
	    };
	
	    _this.backToSlide = function () {
	      _this.setState({
	        offerModal: false,
	        analyticsModal: false
	      });
	      setTimeout(function () {
	        (0, _jquery2.default)(".modal").removeClass("in");
	      }, 500);
	    };
	
	    _this.getPlanList = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var planData;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              planData = JSON.stringify({
	                user_type: 2
	              });
	
	
	              (0, _FetchCall.getPlan)(planData).then(function (response) {
	                if (response.status == 1) {
	                  _this.setState({
	                    plan_list2: response.results
	                  });
	                } else {
	                  console.log('else');
	                }
	              });
	
	            case 2:
	            case "end":
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    }));
	
	    _this.handlePlan = function (id) {
	      var plan_info = _this.state.plan_list2.filter(function (o) {
	        return o.id == id;
	      });
	      console.log('plan_info', plan_info);
	      //window.$("#bewisestandard").modal("show");
	
	      _this.setState({
	        current_plan: plan_info,
	        plan_id: id,
	        offerModal: true,
	        analyticsModal: false
	      });
	      setTimeout(function () {
	        (0, _jquery2.default)(".modal").addClass("in");
	      }, 500);
	    };
	
	    _this.state = {
	      plan_list2: [],
	      current_plan: []
	    };
	    _this.getPlanList();
	    _this.slideCustom = _react2.default.createRef();
	    _this.slideCustom2 = _react2.default.createRef();
	
	    return _this;
	  }
	
	  _createClass(PlanIndIns, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	
	      var logged = localStorage.getItem("authentication");
	      var auth_data = JSON.parse(localStorage.getItem("user_data"));
	      console.log('auth_data.role', logged);
	      if (logged == 'true' && auth_data != 'null' && auth_data.role == 1) {
	        //window.location.href = '/dashboard/dashboard';
	      } else if (logged == 'true' && auth_data != 'null' && auth_data.role == 3) {
	        //window.location.href = '/partner/profile';
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var settings = {
	        dots: false,
	        infinite: false,
	        speed: 2000,
	        slidesToShow: 4,
	        slidesToScroll: 4,
	        autoplay: false,
	        arrows: true,
	        autoplaySpeed: 5000,
	        responsive: [{
	          breakpoint: 768,
	          settings: {
	            slidesToShow: 1,
	            slidesToScroll: 1
	          }
	        }]
	
	      };
	
	      var packages_settings = {
	        dots: false,
	        infinite: false,
	        speed: 2000,
	        slidesToShow: 2,
	        slidesToScroll: 1,
	        initialSlide: 1,
	        autoplay: false,
	        autoplaySpeed: 5000
	      };
	
	      var packages_settings_mobile = {
	        dots: false,
	        infinite: false,
	        speed: 2000,
	        slidesToShow: 1,
	        slidesToScroll: 1,
	        initialSlide: 0,
	        autoplay: false,
	        autoplaySpeed: 5000,
	        responsive: [{
	          breakpoint: 768,
	          settings: {
	            slidesToShow: 1,
	            initialSlide: 0,
	            slidesToScroll: 1
	          }
	        }]
	      };
	
	      var settings_dashboards = {
	
	        dots: false,
	        infinite: false,
	        speed: 2000,
	        slidesToShow: 1,
	        slidesToScroll: 1,
	        autoplay: false,
	        arrows: true,
	        autoplaySpeed: 5000,
	        responsive: [{
	          breakpoint: 768,
	          settings: {
	            slidesToShow: 1,
	            slidesToScroll: 1
	          }
	        }]
	
	      };
	
	      /* <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css" /> */
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _reactHelmet.Helmet,
	          null,
	          _react2.default.createElement(
	            "title",
	            null,
	            "BeWise individual Partners - Enhancing Education Together"
	          ),
	          _react2.default.createElement("meta", { name: "description", content: 'BeWise partners with educators to enhance education. Learn more about our collaborative efforts and programs by visiting our website.' })
	        ),
	        _react2.default.createElement(_HeaderNew2.default, null),
	        _react2.default.createElement(
	          "div",
	          { "class": "row display-flex-center mainrowheader", style: { marginTop: "85px" } },
	          _react2.default.createElement("div", { "class": "col-lg-2 col-sm-1 col-md-1" }),
	          _react2.default.createElement(
	            "div",
	            { "class": "col-lg-8 col-sm-10 col-md-10" },
	            _react2.default.createElement(
	              "div",
	              { "class": "bannersection_ind" },
	              _react2.default.createElement(
	                "div",
	                { "class": "bheader" },
	                "Welcome to ",
	                _react2.default.createElement(
	                  "span",
	                  { className: "bluetext" },
	                  "BeWise"
	                ),
	                " Partner Program"
	              ),
	              _react2.default.createElement(
	                "div",
	                { "class": "bbg" },
	                _react2.default.createElement("img", { src: _bannerbgindividual2.default, className: "bannerbg" })
	              ),
	              _react2.default.createElement(
	                "div",
	                { "class": "biconbox" },
	                _react2.default.createElement(
	                  _reactSlick2.default,
	                  settings,
	                  _react2.default.createElement(
	                    "div",
	                    { "class": "box" },
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "icon" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "image" },
	                        _react2.default.createElement("img", { src: _icon2.default })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "info" },
	                        _react2.default.createElement(
	                          "h3",
	                          { "class": "titlesm" },
	                          "Efficiency"
	                        ),
	                        _react2.default.createElement(
	                          "h4",
	                          { "class": "subtitle" },
	                          "Reaching target audience continuosly with"
	                        ),
	                        _react2.default.createElement(
	                          "ul",
	                          { "class": "boxli" },
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Brand recall"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Returns"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Reach"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Talent access"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Focus on objective"
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement("div", { "class": "space" })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { "class": "box" },
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "icon" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "image" },
	                        _react2.default.createElement("img", { src: _icon4.default })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "info" },
	                        _react2.default.createElement(
	                          "h3",
	                          { "class": "titlesm" },
	                          "Engagement"
	                        ),
	                        _react2.default.createElement(
	                          "h4",
	                          { "class": "subtitle" },
	                          "Continously with target Audience on"
	                        ),
	                        _react2.default.createElement(
	                          "ul",
	                          { "class": "boxli" },
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Brand values"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Leadership and followers"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Attracking talent"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Leveraging feedback"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Reaching events beyond"
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement("div", { "class": "space" })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { "class": "box" },
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "icon" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "image" },
	                        _react2.default.createElement("img", { src: _icon6.default })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "info" },
	                        _react2.default.createElement(
	                          "h3",
	                          { "class": "titlesm" },
	                          "Excellence"
	                        ),
	                        _react2.default.createElement(
	                          "h4",
	                          { "class": "subtitle" },
	                          "New Industry Standards"
	                        ),
	                        _react2.default.createElement(
	                          "ul",
	                          { "class": "boxli" },
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Data based decisions"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Transparency and leadership"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Enrollments 24x7"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Build insights and leadership for commnunity"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Frequently showcase successes to attract the best"
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement("div", { "class": "space" })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { "class": "box" },
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "icon" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "image" },
	                        _react2.default.createElement("img", { src: _icon8.default })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "info" },
	                        _react2.default.createElement(
	                          "h3",
	                          { "class": "titlesm" },
	                          "Enable(ment)"
	                        ),
	                        _react2.default.createElement(
	                          "h4",
	                          { "class": "subtitle" },
	                          "Raise Industry Standards"
	                        ),
	                        _react2.default.createElement(
	                          "ul",
	                          { "class": "boxli" },
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Brand strength 24x7"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Continuous benchmarking & tracking competitiveness"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Connected with trends and quick to customize"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Lead thought leadership for industry"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Attracting talent continuously"
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement("div", { "class": "space" })
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { "class": "packagesection" },
	              _react2.default.createElement(
	                "div",
	                { "class": "planbox" },
	                _react2.default.createElement(
	                  "table",
	                  { "class": "pricing-table-box" },
	                  _react2.default.createElement(
	                    "tbody",
	                    null,
	                    _react2.default.createElement(
	                      "tr",
	                      null,
	                      _react2.default.createElement(
	                        "td",
	                        { width: "40%", "class": "pricing-table-box-text" },
	                        _react2.default.createElement(
	                          "h2",
	                          null,
	                          "PRICING PLANS"
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { width: "15%" },
	                        _react2.default.createElement(
	                          "div",
	                          { "class": "pricing-table-box-item" },
	                          _react2.default.createElement(
	                            "div",
	                            { "class": "pricing-table-box-item-head color2" },
	                            _react2.default.createElement(
	                              "p",
	                              null,
	                              "BeWise Standard"
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "div",
	                            { "class": "pricing-table-box-item-price color2" },
	                            _react2.default.createElement(
	                              "p",
	                              null,
	                              _react2.default.createElement(
	                                "span",
	                                null,
	                                "FREE"
	                              )
	                            )
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { width: "15%" },
	                        _react2.default.createElement(
	                          "div",
	                          { "class": "pricing-table-box-item" },
	                          _react2.default.createElement(
	                            "div",
	                            { "class": "pricing-table-box-item-head bewisemagic" },
	                            _react2.default.createElement(
	                              "p",
	                              null,
	                              "BeWise Value"
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "div",
	                            { "class": "pricing-table-box-item-price color2" },
	                            _react2.default.createElement(
	                              "p",
	                              null,
	                              _react2.default.createElement(
	                                "span",
	                                null,
	                                "Annual Subscription Fee"
	                              )
	                            )
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      { "class": "pricing-table-box-list" },
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "first-row bolder" },
	                        "24x 7 visibility and growth. Build trust with target audience"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "second-row" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "third-row" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      { "class": "pricing-table-box-list" },
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "first-row" },
	                        "\xA0\xA0\xA0\xA0Professional & continious digital presence"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "second-row" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "third-row" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      { "class": "pricing-table-box-list" },
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "first-row" },
	                        "\xA0\xA0\xA0\xA0Continious visibility reviews & ratings to enable growth"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "second-row" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "third-row" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      { "class": "pricing-table-box-list" },
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "first-row" },
	                        "\xA0\xA0\xA0\xA0Page used as web page to drive traffic from your marketing efforts"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "second-row" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "third-row" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      { "class": "pricing-table-box-list" },
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "first-row" },
	                        "\xA0\xA0\xA0\xA0Upload Pictures & Videos"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "second-row" },
	                        "2 Free"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "third-row" },
	                        "Upto 10"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      { "class": "pricing-table-box-list" },
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "first-row" },
	                        "\xA0\xA0\xA0\xA0Direct email & message interaction for parent enqruires/ Feedback"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "second-row" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "third-row" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      { "class": "pricing-table-box-list" },
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "first-row" },
	                        "\xA0\xA0\xA0\xA0Featured in Trending Now."
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "second-row" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "third-row" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      { "class": "pricing-table-box-list" },
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "first-row" },
	                        "\xA0\xA0\xA0\xA0Verified & Supported partner stamp\xA0"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "second-row" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "third-row" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      { "class": "pricing-table-box-list" },
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "first-row bolder" },
	                        "Immediate updates for Leads /enquiries @ BeWise platform"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "second-row" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "third-row" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      { "class": "pricing-table-box-list" },
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "first-row bolder" },
	                        "Benchmark your organisation with your choice of peers / competitors"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "second-row" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "third-row" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      { "class": "pricing-table-box-list" },
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "first-row bolder" },
	                        "Ads & newsletter promotion @ special prices"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "second-row" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "third-row" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      { "class": "pricing-table-box-list" },
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "first-row bolder" },
	                        "Free benefits upto INR 50K + for you & your customers"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "second-row" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "third-row" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      { "class": "pricing-table-box-list" },
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "first-row bolder" },
	                        "Scope for collaborative & customised services to drive growth"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "second-row" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "third-row" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      { "class": "pricing-table-box-list" },
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "first-row bolder" },
	                        "You get data & analytics to help / accelerate growth"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "second-row" },
	                        "Partly Free"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "third-row" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      { "class": "pricing-table-box-list" },
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "first-row bolder" },
	                        "Special benefits @ WiseConnect, our Talent Management support"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "second-row" },
	                        "Partly Free"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "third-row" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      { "class": "pricing-table-box-list" },
	                      _react2.default.createElement("td", { "class": "first-row" }),
	                      _react2.default.createElement(
	                        "td",
	                        { colspan: "2", "class": "third-row" },
	                        _react2.default.createElement(
	                          "div",
	                          { "class": "pricing-table-box-item-purchase" },
	                          _react2.default.createElement(
	                            "a",
	                            { href: "/individual_signup", "class": "btn blue-btn" },
	                            "SIGN UP"
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { "class": "howtobesection" },
	              _react2.default.createElement(
	                "div",
	                { "class": "planheader" },
	                "How to be BeWise Partner?"
	              ),
	              _react2.default.createElement(
	                "div",
	                { "class": "stepbox" },
	                _react2.default.createElement(
	                  "ol",
	                  null,
	                  _react2.default.createElement(
	                    "li",
	                    { className: "step1clr" },
	                    _react2.default.createElement(
	                      "p",
	                      { "class": "event-date" },
	                      _react2.default.createElement("img", { src: _signup2.default })
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      { "class": "event-step" },
	                      "Step 1"
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      { "class": "event-description" },
	                      "Click on Sign Up and provide us with required details to partner with BeWise."
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "li",
	                    { className: "step2clr" },
	                    _react2.default.createElement(
	                      "p",
	                      { "class": "event-date" },
	                      _react2.default.createElement("img", { src: _cashOnDelivery2.default })
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      { "class": "event-step" },
	                      "Step 2"
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      { "class": "event-description" },
	                      "Select a Package suitable to your work. Speak to our assigned Sales Team for any support required."
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "li",
	                    { className: "step3clr" },
	                    _react2.default.createElement(
	                      "p",
	                      { "class": "event-date" },
	                      _react2.default.createElement("img", { src: _approve2.default })
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      { "class": "event-step" },
	                      "Step 3"
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      { "class": "event-description" },
	                      "BeWise team will Verify and Validate the details provided."
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "li",
	                    { className: "step4clr" },
	                    _react2.default.createElement(
	                      "p",
	                      { "class": "event-date" },
	                      _react2.default.createElement("img", { src: _launch2.default })
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      { "class": "event-step" },
	                      "Step 4"
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      { "class": "event-description" },
	                      "Access you Account page to input any additional information. Also, Add Branches if you have"
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { "class": "dashboardsection" },
	              _react2.default.createElement(
	                "div",
	                { "class": "dashboardheader" },
	                "Dashboards and Partner Account Page - Sample Views "
	              ),
	              _react2.default.createElement(
	                "div",
	                { "class": "dashboardbox", id: "dashboards" },
	                _react2.default.createElement(
	                  _reactSlick2.default,
	                  Object.assign({}, settings_dashboards, { ref: this.slideCustom2 }),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "dashboardsampleview" },
	                    _react2.default.createElement("img", { src: _view2.default })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "dashboardsampleview" },
	                    _react2.default.createElement("img", { src: _view4.default })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "dashboardsampleview" },
	                    _react2.default.createElement("img", { src: _view6.default })
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement("div", { "class": "col-lg-2 col-sm-1 col-md-1" })
	        ),
	        _react2.default.createElement(
	          _reactstrap.Modal,
	          { isOpen: this.state.analyticsModal, size: "lg" },
	          _react2.default.createElement(
	            _ModalHeader2.default,
	            null,
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-6 mini-arrow", style: { cursor: 'pointer' }, onClick: this.backToOffer },
	              _react2.default.createElement("img", { src: _backArrowDark2.default, alt: "MiniArrow" }),
	              "\xA0\xA0 Back"
	            ),
	            _react2.default.createElement(
	              "button",
	              { type: "button", "class": "close", "data-dismiss": "modal", "aria-label": "Close", onClick: this.backToSlide },
	              _react2.default.createElement("i", { "class": "fa fa-times-circle-o", "aria-hidden": "true" })
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.ModalBody,
	            { className: "sign-upmodal" },
	            this.state.current_plan.length > 0 && _react2.default.createElement(
	              "div",
	              { className: "row" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-sm-8" },
	                _react2.default.createElement(
	                  "h1",
	                  null,
	                  "Analytics that we offer"
	                ),
	                _react2.default.createElement("div", { dangerouslySetInnerHTML: { __html: this.state.current_plan[0].analytics_offer } }),
	                this.state.current_plan[0].analytics_soon && _react2.default.createElement(
	                  "div",
	                  null,
	                  _react2.default.createElement(
	                    "h1",
	                    null,
	                    "Coming Soon"
	                  ),
	                  _react2.default.createElement("div", { dangerouslySetInnerHTML: { __html: this.state.current_plan[0].analytics_soon } })
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-sm-4" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "cardhead" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "img-box" },
	                    _react2.default.createElement("img", { src: this.state.current_plan[0].baseurl + this.state.current_plan[0].icon, alt: "plan icon" })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "img-rightcontent" },
	                    _react2.default.createElement(
	                      "h2",
	                      { style: { borderBottom: "4px solid " + this.state.current_plan[0].icon_color } },
	                      this.state.current_plan[0].site,
	                      _react2.default.createElement("br", null),
	                      this.state.current_plan[0].plan_name
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      null,
	                      _react2.default.createElement(
	                        "a",
	                        { href: "mailto:contact@bewise.in" },
	                        "Email us"
	                      ),
	                      " to receive our launch offers."
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      null,
	                      _react2.default.createElement(
	                        "small",
	                        null,
	                        "Please include your phonenumber for us to call back"
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactstrap.Modal,
	          { isOpen: this.state.offerModal, size: "lg" },
	          _react2.default.createElement(
	            _ModalHeader2.default,
	            null,
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-6 mini-arrow", style: { cursor: 'pointer' }, onClick: this.backToSlide },
	              _react2.default.createElement("img", { src: _backArrowDark2.default, alt: "MiniArrow" }),
	              "\xA0\xA0 Back"
	            ),
	            _react2.default.createElement(
	              "button",
	              { type: "button", "class": "close", "data-dismiss": "modal", "aria-label": "Close", onClick: this.backToSlide },
	              _react2.default.createElement("i", { "class": "fa fa-times-circle-o", "aria-hidden": "true" })
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.ModalBody,
	            { className: "sign-upmodal" },
	            this.state.current_plan.length > 0 && _react2.default.createElement(
	              "div",
	              { className: "row sign-upmodal" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-sm-8" },
	                _react2.default.createElement(
	                  "h1",
	                  null,
	                  "Our Offering"
	                ),
	                _react2.default.createElement("div", { dangerouslySetInnerHTML: { __html: this.state.current_plan[0].plan_offer } }),
	                this.state.current_plan[0].plan_soon && _react2.default.createElement(
	                  "div",
	                  null,
	                  _react2.default.createElement(
	                    "h1",
	                    null,
	                    "Coming Soon"
	                  ),
	                  _react2.default.createElement("div", { dangerouslySetInnerHTML: { __html: this.state.current_plan[0].plan_soon } })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "mini-arrow", style: { cursor: 'pointer' }, onClick: function onClick() {
	                      return _this3.analyticsOffer();
	                    } },
	                  "Analytics offer ",
	                  _react2.default.createElement("img", { src: _miniArrow2.default, alt: "MiniArrow" })
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-sm-4" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "cardhead" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "img-box" },
	                    _react2.default.createElement("img", { src: this.state.current_plan[0].baseurl + this.state.current_plan[0].icon, alt: "plan icon" })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "img-rightcontent" },
	                    _react2.default.createElement(
	                      "h2",
	                      { style: { borderBottom: "4px solid " + this.state.current_plan[0].icon_color } },
	                      this.state.current_plan[0].site,
	                      _react2.default.createElement("br", null),
	                      this.state.current_plan[0].plan_name
	                    ),
	                    _react2.default.createElement(
	                      "h1",
	                      null,
	                      _react2.default.createElement(
	                        "span",
	                        null,
	                        _react2.default.createElement(CurrencyFormat, { value: this.state.current_plan[0].base_price != '' ? this.state.current_plan[0].base_price : 0,
	                          displayType: 'text', thousandSeparator: true, prefix: '₹' })
	                      ),
	                      _react2.default.createElement(
	                        "span",
	                        null,
	                        "/Year"
	                      ),
	                      _react2.default.createElement("br", null),
	                      _react2.default.createElement(
	                        "small",
	                        null,
	                        this.state.current_plan[0].offer_name
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_Footer2.default, null),
	        _react2.default.createElement(
	          "div",
	          { className: "modal fade", id: "bewisestandard", role: "dialog" },
	          _react2.default.createElement(
	            "div",
	            { className: "modal-dialog  modal-lg" },
	            _react2.default.createElement(
	              "div",
	              { className: "modal-content" },
	              _react2.default.createElement(
	                "div",
	                { "class": "modal-header" },
	                _react2.default.createElement("div", { className: "col-md-6 mini-arrow" }),
	                _react2.default.createElement(
	                  "button",
	                  { type: "button", "class": "close", "data-dismiss": "modal", "aria-label": "Close", onClick: function onClick() {
	                      return _this3.backToSlide();
	                    } },
	                  _react2.default.createElement("i", { "class": "fa fa-times-circle-o", "aria-hidden": "true" })
	                )
	              ),
	              this.state.current_plan.length > 0 && _react2.default.createElement(
	                "div",
	                { className: "modal-body sign-upmodal" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "row" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-sm-8" },
	                    _react2.default.createElement(
	                      "h1",
	                      null,
	                      "Our Offering"
	                    ),
	                    _react2.default.createElement("div", { dangerouslySetInnerHTML: { __html: this.state.current_plan[0].plan_offer } }),
	                    this.state.current_plan[0].plan_soon && _react2.default.createElement(
	                      "div",
	                      null,
	                      _react2.default.createElement(
	                        "h1",
	                        null,
	                        "Coming Soon"
	                      ),
	                      _react2.default.createElement("div", { dangerouslySetInnerHTML: { __html: this.state.current_plan[0].plan_soon } })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "mini-arrow", style: { cursor: 'pointer' }, onClick: function onClick() {
	                          return _this3.analyticsOffer();
	                        } },
	                      "Analytics offer ",
	                      _react2.default.createElement("img", { src: _miniArrow2.default, alt: "MiniArrow" })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-sm-4" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "cardhead" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "img-box" },
	                        _react2.default.createElement("img", { src: this.state.current_plan[0].baseurl + this.state.current_plan[0].icon, alt: "plan icon" })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "img-rightcontent" },
	                        _react2.default.createElement(
	                          "h2",
	                          { style: { borderBottom: "4px solid " + this.state.current_plan[0].icon_color } },
	                          this.state.current_plan[0].site,
	                          _react2.default.createElement("br", null),
	                          this.state.current_plan[0].plan_name
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          null,
	                          _react2.default.createElement(
	                            "a",
	                            { href: "mailto:contact@bewise.in" },
	                            "Email us"
	                          ),
	                          " to receive our launch offers."
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          null,
	                          _react2.default.createElement(
	                            "small",
	                            null,
	                            "Please include your phonenumber for us to call back"
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return PlanIndIns;
	}(_react.Component);
	
	exports.default = PlanIndIns;

/***/ },
/* 876 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _HeaderNew = __webpack_require__(186);
	
	var _HeaderNew2 = _interopRequireDefault(_HeaderNew);
	
	var _FooterNew = __webpack_require__(185);
	
	var _FooterNew2 = _interopRequireDefault(_FooterNew);
	
	var _Footer = __webpack_require__(82);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _backArrowDark = __webpack_require__(123);
	
	var _backArrowDark2 = _interopRequireDefault(_backArrowDark);
	
	var _chartImage = __webpack_require__(136);
	
	var _chartImage2 = _interopRequireDefault(_chartImage);
	
	var _miniArrow = __webpack_require__(124);
	
	var _miniArrow2 = _interopRequireDefault(_miniArrow);
	
	var _reactSlick = __webpack_require__(93);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	__webpack_require__(122);
	
	__webpack_require__(121);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _FetchCall = __webpack_require__(4);
	
	var _icon = __webpack_require__(215);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _icon3 = __webpack_require__(216);
	
	var _icon4 = _interopRequireDefault(_icon3);
	
	var _icon5 = __webpack_require__(217);
	
	var _icon6 = _interopRequireDefault(_icon5);
	
	var _icon7 = __webpack_require__(218);
	
	var _icon8 = _interopRequireDefault(_icon7);
	
	var _view = __webpack_require__(223);
	
	var _view2 = _interopRequireDefault(_view);
	
	var _view3 = __webpack_require__(224);
	
	var _view4 = _interopRequireDefault(_view3);
	
	var _view5 = __webpack_require__(225);
	
	var _view6 = _interopRequireDefault(_view5);
	
	var _signup = __webpack_require__(222);
	
	var _signup2 = _interopRequireDefault(_signup);
	
	var _cashOnDelivery = __webpack_require__(220);
	
	var _cashOnDelivery2 = _interopRequireDefault(_cashOnDelivery);
	
	var _approve = __webpack_require__(219);
	
	var _approve2 = _interopRequireDefault(_approve);
	
	var _launch = __webpack_require__(221);
	
	var _launch2 = _interopRequireDefault(_launch);
	
	var _bannerbg = __webpack_require__(662);
	
	var _bannerbg2 = _interopRequireDefault(_bannerbg);
	
	var _reactstrap = __webpack_require__(17);
	
	var _ModalHeader = __webpack_require__(102);
	
	var _ModalHeader2 = _interopRequireDefault(_ModalHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrencyFormat = __webpack_require__(112);
	
	var PlanPageSchools = function (_Component) {
	  _inherits(PlanPageSchools, _Component);
	
	  function PlanPageSchools(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, PlanPageSchools);
	
	    var _this = _possibleConstructorReturn(this, (PlanPageSchools.__proto__ || Object.getPrototypeOf(PlanPageSchools)).call(this, props));
	
	    _this.analyticsOffer = function () {
	      _this.setState({
	        offerModal: false,
	        analyticsModal: true
	      });
	      setTimeout(function () {
	        (0, _jquery2.default)(".modal").addClass("in");
	      }, 500);
	    };
	
	    _this.backToOffer = function () {
	      _this.setState({
	        offerModal: true,
	        analyticsModal: false
	      });
	      setTimeout(function () {
	        (0, _jquery2.default)(".modal").addClass("in");
	      }, 500);
	    };
	
	    _this.backToSlide = function () {
	      _this.setState({
	        offerModal: false,
	        analyticsModal: false
	      });
	      setTimeout(function () {
	        (0, _jquery2.default)(".modal").removeClass("in");
	      }, 500);
	    };
	
	    _this.getPlanList = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var planData;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              planData = JSON.stringify({
	                user_type: 1
	              });
	
	
	              (0, _FetchCall.getPlan)(planData).then(function (response) {
	                if (response.status == 1) {
	                  _this.setState({
	                    plan_list2: response.results
	                  });
	                } else {
	                  console.log('else');
	                }
	              });
	
	            case 2:
	            case "end":
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    }));
	
	    _this.showPrice1 = function (e) {
	
	      (0, _jquery2.default)("#showPrice1").html('INR 649*/- Per Month <br/> BeWise Pricing as applicable');
	    };
	
	    _this.showPrice2 = function (e) {
	
	      (0, _jquery2.default)("#showPrice2").html('INR 1799*/- Per Month');
	    };
	
	    _this.handlePlan = function (id) {
	      var plan_info = _this.state.plan_list2.filter(function (o) {
	        return o.id == id;
	      });
	      console.log('plan_info', plan_info);
	      _this.setState({
	        current_plan: plan_info,
	        plan_id: id,
	        offerModal: true,
	        analyticsModal: false
	      });
	      setTimeout(function () {
	        (0, _jquery2.default)(".modal").addClass("in");
	      }, 500);
	    };
	
	    _this.analyticsOffer = function () {
	      _this.setState({
	        offerModal: false,
	        analyticsModal: true
	      });
	      setTimeout(function () {
	        (0, _jquery2.default)(".modal").addClass("in");
	      }, 500);
	    };
	
	    _this.backToOffer = function () {
	      _this.setState({
	        offerModal: true,
	        analyticsModal: false
	      });
	      setTimeout(function () {
	        (0, _jquery2.default)(".modal").addClass("in");
	      }, 500);
	    };
	
	    _this.backToSlide = function () {
	      _this.setState({
	        offerModal: false,
	        analyticsModal: false
	      });
	      setTimeout(function () {
	        (0, _jquery2.default)(".modal").removeClass("in");
	      }, 500);
	    };
	
	    _this.state = {
	      plan_list2: [],
	      clickedfromwc: _this.props.match.params.wc ? true : false,
	      current_plan: []
	    };
	
	    //this.cwc = this.props.match.params.wc ? this.props.match.params.wc : '';
	
	    _this.getPlanList();
	    _this.slideCustom = _react2.default.createRef();
	    _this.slidepackages = _react2.default.createRef();
	    _this.slideCustom3 = _react2.default.createRef();
	    return _this;
	  }
	
	  _createClass(PlanPageSchools, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var logged = localStorage.getItem("authentication");
	      var auth_data = JSON.parse(localStorage.getItem("user_data"));
	      console.log('auth_data.role', logged);
	      /*
	      if (logged == 'true' && auth_data != 'null' && auth_data.role == 1) {
	        window.location.href = '/dashboard/dashboard';
	      } else if (logged == 'true' && auth_data != 'null' && auth_data.role == 3) {
	        window.location.href = '/partner/profile';
	      }
	      */
	
	      if (this.state.clickedfromwc) {
	        var element = document.getElementById("wiseconnectpricing");
	        element.scrollIntoView({ behavior: "smooth", block: "start" });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	
	      var settings = {
	        dots: false,
	        infinite: false,
	        speed: 2000,
	        slidesToShow: 4,
	        slidesToScroll: 4,
	        autoplay: false,
	        autoplaySpeed: 5000,
	        responsive: [{
	          breakpoint: 768,
	          settings: {
	            slidesToShow: 1,
	            centerMode: false, /* set centerMode to false to show complete slide instead of 3 */
	            slidesToScroll: 1
	          }
	        }]
	
	      };
	
	      var settings_dashboards = {
	
	        dots: false,
	        infinite: false,
	        speed: 2000,
	        slidesToShow: 1,
	        slidesToScroll: 1,
	        autoplay: false,
	        autoplaySpeed: 5000,
	        responsive: [{
	          breakpoint: 768,
	          settings: {
	            slidesToShow: 1,
	            centerMode: false, /* set centerMode to false to show complete slide instead of 3 */
	            slidesToScroll: 1
	          }
	        }]
	
	      };
	
	      var packages_settings = {
	        dots: false,
	        infinite: false,
	        speed: 2000,
	        slidesToShow: 2,
	        slidesToScroll: 1,
	        initialSlide: 1,
	        autoplay: false,
	        autoplaySpeed: 5000
	      };
	
	      var packages_settings_mobile = {
	        dots: false,
	        infinite: false,
	        speed: 2000,
	        slidesToShow: 1,
	        slidesToScroll: 1,
	        initialSlide: 0,
	        autoplay: false,
	        autoplaySpeed: 5000,
	        responsive: [{
	          breakpoint: 768,
	          settings: {
	            slidesToShow: 1,
	            initialSlide: 0,
	            slidesToScroll: 1
	          }
	        }]
	      };
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(_HeaderNew2.default, null),
	        _react2.default.createElement(
	          "div",
	          { "class": "row display-flex-center mainrowheader", style: { marginTop: "85px" } },
	          _react2.default.createElement("div", { "class": "col-lg-2 col-sm-2 col-md-2" }),
	          _react2.default.createElement(
	            "div",
	            { "class": "col-lg-8 col-sm-8 col-md-8" },
	            _react2.default.createElement(
	              "div",
	              { "class": "bannersection" },
	              _react2.default.createElement(
	                "div",
	                { "class": "bheader" },
	                "Welcome to ",
	                _react2.default.createElement(
	                  "span",
	                  { className: "bluetext" },
	                  "BeWise"
	                ),
	                " Partner Program"
	              ),
	              _react2.default.createElement(
	                "div",
	                { "class": "bbg" },
	                _react2.default.createElement("img", { src: _bannerbg2.default, className: "bannerbg" })
	              ),
	              _react2.default.createElement(
	                "div",
	                { "class": "biconbox" },
	                _react2.default.createElement(
	                  _reactSlick2.default,
	                  Object.assign({}, settings, { ref: this.slideCustom }),
	                  _react2.default.createElement(
	                    "div",
	                    { "class": "box" },
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "icon" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "image" },
	                        _react2.default.createElement("img", { src: _icon2.default })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "info" },
	                        _react2.default.createElement(
	                          "h3",
	                          { "class": "titlesm" },
	                          "Efficiency"
	                        ),
	                        _react2.default.createElement(
	                          "h4",
	                          { "class": "subtitle" },
	                          "Reaching target audience continuosly with"
	                        ),
	                        _react2.default.createElement(
	                          "ul",
	                          { "class": "boxli" },
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Brand recall"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Returns"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Reach"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Talent access"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Focus on objective"
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement("div", { "class": "space" })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { "class": "box" },
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "icon" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "image" },
	                        _react2.default.createElement("img", { src: _icon4.default })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "info" },
	                        _react2.default.createElement(
	                          "h3",
	                          { "class": "titlesm" },
	                          "Engagement"
	                        ),
	                        _react2.default.createElement(
	                          "h4",
	                          { "class": "subtitle" },
	                          "Continously with target Audience on"
	                        ),
	                        _react2.default.createElement(
	                          "ul",
	                          { "class": "boxli" },
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Brand values"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Leadership and followers"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Attracking talent"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Leveraging feedback"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Reaching events beyond"
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement("div", { "class": "space" })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { "class": "box" },
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "icon" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "image" },
	                        _react2.default.createElement("img", { src: _icon6.default })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "info" },
	                        _react2.default.createElement(
	                          "h3",
	                          { "class": "titlesm" },
	                          "Excellence"
	                        ),
	                        _react2.default.createElement(
	                          "h4",
	                          { "class": "subtitle" },
	                          "New Industry Standards"
	                        ),
	                        _react2.default.createElement(
	                          "ul",
	                          { "class": "boxli" },
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Data based decisions"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Transparency and leadership"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Enrollments 24x7"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Build insights and leadership for commnunity"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Frequently showcase successes to attract the best"
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement("div", { "class": "space" })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { "class": "box" },
	                    _react2.default.createElement(
	                      "div",
	                      { "class": "icon" },
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "image" },
	                        _react2.default.createElement("img", { src: _icon8.default })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { "class": "info" },
	                        _react2.default.createElement(
	                          "h3",
	                          { "class": "titlesm" },
	                          "Enable(ment)"
	                        ),
	                        _react2.default.createElement(
	                          "h4",
	                          { "class": "subtitle" },
	                          "Raise Industry Standards"
	                        ),
	                        _react2.default.createElement(
	                          "ul",
	                          { "class": "boxli" },
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Brand strength 24x7"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Continuous benchmarking & tracking competitiveness"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Connected with trends and quick to customize"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Lead thought leadership for industry"
	                          ),
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            "Attracting talent continuously"
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement("div", { "class": "space" })
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { "class": "packagesection" },
	              _react2.default.createElement(
	                "div",
	                { "class": "planbox" },
	                _react2.default.createElement(
	                  "table",
	                  { "class": "pricing-table-box" },
	                  _react2.default.createElement(
	                    "tbody",
	                    null,
	                    _react2.default.createElement(
	                      "tr",
	                      null,
	                      _react2.default.createElement(
	                        "td",
	                        { width: "40%", "class": "pricing-table-box-text" },
	                        _react2.default.createElement(
	                          "h2",
	                          null,
	                          "PRICING PLANS"
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { width: "15%" },
	                        _react2.default.createElement(
	                          "div",
	                          { "class": "pricing-table-box-item" },
	                          _react2.default.createElement(
	                            "div",
	                            { "class": "pricing-table-box-item-head color2" },
	                            _react2.default.createElement(
	                              "p",
	                              null,
	                              "BeWise Standard"
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "div",
	                            { "class": "pricing-table-box-item-price color2" },
	                            _react2.default.createElement(
	                              "p",
	                              null,
	                              _react2.default.createElement(
	                                "span",
	                                null,
	                                "FREE"
	                              )
	                            )
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { width: "15%" },
	                        _react2.default.createElement(
	                          "div",
	                          { "class": "pricing-table-box-item" },
	                          _react2.default.createElement(
	                            "div",
	                            { "class": "pricing-table-box-item-head bewisemagic" },
	                            _react2.default.createElement(
	                              "p",
	                              null,
	                              "BeWise Magic"
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "div",
	                            { "class": "pricing-table-box-item-price color2" },
	                            _react2.default.createElement(
	                              "p",
	                              null,
	                              _react2.default.createElement(
	                                "span",
	                                null,
	                                "Annual Subscription Fee"
	                              )
	                            )
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      { "class": "pricing-table-box-list" },
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "first-row bolder" },
	                        "24x 7 visibility and growth. Build trust with target audience"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "second-row" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "third-row" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      { "class": "pricing-table-box-list" },
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "first-row" },
	                        "\xA0\xA0\xA0\xA0Professional & continious digital presence"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "second-row" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "third-row" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      { "class": "pricing-table-box-list" },
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "first-row" },
	                        "\xA0\xA0\xA0\xA0Continious visibility reviews & ratings to enable growth"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "second-row" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "third-row" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      { "class": "pricing-table-box-list" },
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "first-row" },
	                        "\xA0\xA0\xA0\xA0Upload Pictures & Videos"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "second-row" },
	                        "3 Free"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "third-row" },
	                        "Upto 15"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      { "class": "pricing-table-box-list" },
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "first-row" },
	                        "\xA0\xA0\xA0\xA0Direct email & message interaction for parent enqruires/ Feedback"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "second-row" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "third-row" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      { "class": "pricing-table-box-list" },
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "first-row" },
	                        "\xA0\xA0\xA0\xA0Featured in Trending Now."
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "second-row" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "third-row" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      { "class": "pricing-table-box-list" },
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "first-row" },
	                        "\xA0\xA0\xA0\xA0Collaborative social media supportives - as and when"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "second-row" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "third-row" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      { "class": "pricing-table-box-list" },
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "first-row" },
	                        "\xA0\xA0\xA0\xA0Verified & Supported partner stamp\xA0"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "second-row" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "third-row" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      { "class": "pricing-table-box-list" },
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "first-row" },
	                        "\xA0\xA0\xA0\xA0Post your ad in your School landing page"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "second-row" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "third-row" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      { "class": "pricing-table-box-list" },
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "first-row bolder" },
	                        "Immediate updates for Leads /enquiries @ BeWise platform"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "second-row" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "third-row" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      { "class": "pricing-table-box-list" },
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "first-row bolder" },
	                        "Benchmark your organisation with your choice of peers / competitors"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "second-row" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "third-row" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      { "class": "pricing-table-box-list" },
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "first-row bolder" },
	                        "Build thought leadership and enhance your brand value."
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "second-row" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "third-row" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      { "class": "pricing-table-box-list" },
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "first-row bolder" },
	                        "Ads & newsletter promotion @ special prices"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "second-row" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "third-row" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      { "class": "pricing-table-box-list" },
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "first-row bolder" },
	                        "Free benefits upto INR 50K + for you & your customers"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "second-row" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "third-row" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      { "class": "pricing-table-box-list" },
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "first-row bolder" },
	                        "Scope for collaborative & customised services to drive growth"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "second-row" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "third-row" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      { "class": "pricing-table-box-list" },
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "first-row bolder" },
	                        "Multiple benefits @ WiseConnect, our Talent Management support."
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "second-row" },
	                        _react2.default.createElement("span", { "class": "fa fa-times" })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "third-row" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      { "class": "pricing-table-box-list" },
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "first-row bolder" },
	                        "You get data & analytics to help / accelerate growth"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "second-row" },
	                        "Partly Free"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "third-row" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      { "class": "pricing-table-box-list" },
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "first-row bolder" },
	                        "Easy access to Skill building and self-development for all in team"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "second-row" },
	                        "Partly Free"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { "class": "third-row" },
	                        _react2.default.createElement("span", { "class": "fa fa-check" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tr",
	                      { "class": "pricing-table-box-list" },
	                      _react2.default.createElement("td", { "class": "first-row" }),
	                      _react2.default.createElement(
	                        "td",
	                        { colspan: "2", "class": "third-row" },
	                        _react2.default.createElement(
	                          "div",
	                          { "class": "pricing-table-box-item-purchase" },
	                          _react2.default.createElement(
	                            "a",
	                            { href: "/institution_signup", "class": "btn blue-btn" },
	                            "SIGN UP"
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              this.state.clickedfromwc && _react2.default.createElement(
	                "div",
	                { id: "wiseconnectpricing" },
	                _react2.default.createElement(
	                  "div",
	                  { "class": "dashboardheader" },
	                  "WiseConnect Pricing"
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { "class": "planbox" },
	                  _react2.default.createElement(
	                    "table",
	                    { "class": "pricing-table-box" },
	                    _react2.default.createElement(
	                      "tbody",
	                      null,
	                      _react2.default.createElement(
	                        "tr",
	                        null,
	                        _react2.default.createElement(
	                          "td",
	                          { width: "40%", "class": "pricing-table-box-text" },
	                          _react2.default.createElement(
	                            "h2",
	                            null,
	                            "All Institutions"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "td",
	                          { width: "15%" },
	                          _react2.default.createElement(
	                            "div",
	                            { "class": "pricing-table-box-item" },
	                            _react2.default.createElement(
	                              "div",
	                              { "class": "pricing-table-box-item-head color2" },
	                              _react2.default.createElement(
	                                "p",
	                                null,
	                                "WiseConnect + BeWise"
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "td",
	                          { width: "15%" },
	                          _react2.default.createElement(
	                            "div",
	                            { "class": "pricing-table-box-item" },
	                            _react2.default.createElement(
	                              "div",
	                              { "class": "pricing-table-box-item-head bewisemagic" },
	                              _react2.default.createElement(
	                                "p",
	                                null,
	                                "WiseConnect Exclusive"
	                              )
	                            )
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "tr",
	                        { "class": "pricing-table-box-list" },
	                        _react2.default.createElement(
	                          "td",
	                          { "class": "first-row" },
	                          "Initial Sign Up"
	                        ),
	                        _react2.default.createElement(
	                          "td",
	                          { "class": "second-row" },
	                          "Free"
	                        ),
	                        _react2.default.createElement(
	                          "td",
	                          { "class": "third-row" },
	                          "Free - Restricted access*"
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "tr",
	                        { "class": "pricing-table-box-list" },
	                        _react2.default.createElement(
	                          "td",
	                          { "class": "first-row" },
	                          "All benefits @ BeWise to enable growth"
	                        ),
	                        _react2.default.createElement(
	                          "td",
	                          { "class": "second-row" },
	                          "Yes"
	                        ),
	                        _react2.default.createElement(
	                          "td",
	                          { "class": "third-row" },
	                          "NA"
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "tr",
	                        { "class": "pricing-table-box-list" },
	                        _react2.default.createElement(
	                          "td",
	                          { "class": "first-row" },
	                          "Instant Talent Search @ Portal & reach candidates"
	                        ),
	                        _react2.default.createElement(
	                          "td",
	                          { "class": "second-row" },
	                          "Yes"
	                        ),
	                        _react2.default.createElement(
	                          "td",
	                          { "class": "third-row" },
	                          "Yes"
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "tr",
	                        { "class": "pricing-table-box-list" },
	                        _react2.default.createElement(
	                          "td",
	                          { "class": "first-row" },
	                          "Post Jobs & receive applications @ Portal"
	                        ),
	                        _react2.default.createElement(
	                          "td",
	                          { "class": "second-row" },
	                          "Yes"
	                        ),
	                        _react2.default.createElement(
	                          "td",
	                          { "class": "third-row" },
	                          "Yes"
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "tr",
	                        { "class": "pricing-table-box-list" },
	                        _react2.default.createElement(
	                          "td",
	                          { "class": "first-row" },
	                          "Full access to Courses / Products / articles @ Portal"
	                        ),
	                        _react2.default.createElement(
	                          "td",
	                          { "class": "second-row" },
	                          "Yes"
	                        ),
	                        _react2.default.createElement(
	                          "td",
	                          { "class": "third-row" },
	                          "Yes"
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "tr",
	                        { "class": "pricing-table-box-list" },
	                        _react2.default.createElement(
	                          "td",
	                          { "class": "first-row" },
	                          "Complete access to curated benefits from Partners"
	                        ),
	                        _react2.default.createElement(
	                          "td",
	                          { "class": "second-row" },
	                          "Yes"
	                        ),
	                        _react2.default.createElement(
	                          "td",
	                          { "class": "third-row" },
	                          "Yes"
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "tr",
	                        { "class": "pricing-table-box-list" },
	                        _react2.default.createElement(
	                          "td",
	                          { "class": "first-row" },
	                          "Available data analytics, reports & benchmarks."
	                        ),
	                        _react2.default.createElement(
	                          "td",
	                          { "class": "second-row" },
	                          "Yes"
	                        ),
	                        _react2.default.createElement(
	                          "td",
	                          { "class": "third-row" },
	                          "Yes"
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "tr",
	                        { "class": "pricing-table-box-list" },
	                        _react2.default.createElement(
	                          "td",
	                          { "class": "first-row" },
	                          "Downloading of candidate CV** @ WiseConnect"
	                        ),
	                        _react2.default.createElement(
	                          "td",
	                          { "class": "second-row" },
	                          "Yes"
	                        ),
	                        _react2.default.createElement(
	                          "td",
	                          { "class": "third-row" },
	                          "Yes"
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "tr",
	                        { "class": "pricing-table-box-list" },
	                        _react2.default.createElement(
	                          "td",
	                          { "class": "first-row" },
	                          "Private & direct interaction with candidates / applications"
	                        ),
	                        _react2.default.createElement(
	                          "td",
	                          { "class": "second-row" },
	                          "Yes"
	                        ),
	                        _react2.default.createElement(
	                          "td",
	                          { "class": "third-row" },
	                          "Yes"
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "tr",
	                        { "class": "pricing-table-box-list" },
	                        _react2.default.createElement(
	                          "td",
	                          { "class": "first-row" },
	                          "Ads & newsletter promotion on WiseConnect @ special prices"
	                        ),
	                        _react2.default.createElement(
	                          "td",
	                          { "class": "second-row" },
	                          "Yes"
	                        ),
	                        _react2.default.createElement(
	                          "td",
	                          { "class": "third-row" },
	                          "Yes"
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "tr",
	                        { "class": "pricing-table-box-list" },
	                        _react2.default.createElement(
	                          "td",
	                          { "class": "first-row" },
	                          "Advisory services in WiseConnect @ special prices"
	                        ),
	                        _react2.default.createElement(
	                          "td",
	                          { "class": "second-row" },
	                          "Yes"
	                        ),
	                        _react2.default.createElement(
	                          "td",
	                          { "class": "third-row" },
	                          "Yes"
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "tr",
	                        { "class": "pricing-table-box-list" },
	                        _react2.default.createElement(
	                          "td",
	                          { "class": "first-row" },
	                          "Launch special - No additional or retainer fee on hiring @ WiseConnect"
	                        ),
	                        _react2.default.createElement(
	                          "td",
	                          { "class": "second-row" },
	                          "Yes"
	                        ),
	                        _react2.default.createElement(
	                          "td",
	                          { "class": "third-row" },
	                          "Yes"
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "tr",
	                        null,
	                        _react2.default.createElement(
	                          "td",
	                          { colspan3: true },
	                          "\xA0"
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "tr",
	                        { "class": "pricing-table-box-list" },
	                        _react2.default.createElement(
	                          "td",
	                          { "class": "first-row" },
	                          "Pricing ***  (WiseConnect only and Inclusive of all applicable taxes)"
	                        ),
	                        _react2.default.createElement(
	                          "td",
	                          { "class": "second-row", id: "showPrice1" },
	                          _react2.default.createElement(
	                            "button",
	                            { "class": "btn btn-primary btn-sm", onClick: this.showPrice1 },
	                            "View Pricing"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "td",
	                          { "class": "third-row", id: "showPrice2" },
	                          _react2.default.createElement(
	                            "button",
	                            { "class": "btn btn-primary btn-sm", onClick: this.showPrice2 },
	                            "View Pricing"
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "tr",
	                        { "class": "pricing-table-box-list" },
	                        _react2.default.createElement(
	                          "td",
	                          { "class": "first-row" },
	                          "\xA0"
	                        ),
	                        _react2.default.createElement(
	                          "td",
	                          { "class": "second-row" },
	                          "Billed Annually"
	                        ),
	                        _react2.default.createElement(
	                          "td",
	                          { "class": "third-row" },
	                          "Billed Half yearly"
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "tr",
	                        { "class": "pricing-table-box-list" },
	                        _react2.default.createElement(
	                          "td",
	                          { "class": "first-row" },
	                          "\xA0"
	                        ),
	                        _react2.default.createElement(
	                          "td",
	                          { "class": "second-row" },
	                          "3 Months Free with 1st subscription"
	                        ),
	                        _react2.default.createElement(
	                          "td",
	                          { "class": "third-row" },
	                          "NIL"
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "tr",
	                        { "class": "pricing-table-box-list" },
	                        _react2.default.createElement("td", { "class": "first-row" }),
	                        _react2.default.createElement(
	                          "td",
	                          { "class": "second-row", colspan: "2" },
	                          _react2.default.createElement(
	                            "div",
	                            { "class": "pricing-table-box-item-purchase" },
	                            _react2.default.createElement(
	                              "a",
	                              { href: "/wc_signup", "class": "btn blue-btn" },
	                              "Sign Up"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { "class": "smallnotes" },
	                    "To explore collaboration & other enquiries - please connect @ contact@bewise.in"
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { "class": "help floatright" },
	                    _react2.default.createElement(
	                      "ul",
	                      null,
	                      _react2.default.createElement(
	                        "li",
	                        null,
	                        "* Restricted Access is for 2 weeks with limited visiblity on portal"
	                      ),
	                      _react2.default.createElement(
	                        "li",
	                        null,
	                        "** Limited downloads for non educational instiutions"
	                      ),
	                      _react2.default.createElement(
	                        "li",
	                        null,
	                        "*** Current offer & subject to change with immediate notice"
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { "class": "howtobesection" },
	              _react2.default.createElement(
	                "div",
	                { "class": "planheader" },
	                "How to be BeWise Partner?"
	              ),
	              _react2.default.createElement(
	                "div",
	                { "class": "stepbox" },
	                _react2.default.createElement(
	                  "ol",
	                  null,
	                  _react2.default.createElement(
	                    "li",
	                    { className: "step1clr" },
	                    _react2.default.createElement(
	                      "p",
	                      { "class": "event-date" },
	                      _react2.default.createElement("img", { src: _signup2.default })
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      { "class": "event-step" },
	                      "Step 1"
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      { "class": "event-description" },
	                      "Click on Sign Up and provide us with required details to partner with BeWise."
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "li",
	                    { className: "step2clr" },
	                    _react2.default.createElement(
	                      "p",
	                      { "class": "event-date" },
	                      _react2.default.createElement("img", { src: _cashOnDelivery2.default })
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      { "class": "event-step" },
	                      "Step 2"
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      { "class": "event-description" },
	                      "Select a Package suitable to your work. Speak to our assigned Sales Team for any support required."
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "li",
	                    { className: "step3clr" },
	                    _react2.default.createElement(
	                      "p",
	                      { "class": "event-date" },
	                      _react2.default.createElement("img", { src: _approve2.default })
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      { "class": "event-step" },
	                      "Step 3"
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      { "class": "event-description" },
	                      "BeWise team will Verify and Validate the details provided."
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "li",
	                    { className: "step4clr" },
	                    _react2.default.createElement(
	                      "p",
	                      { "class": "event-date" },
	                      _react2.default.createElement("img", { src: _launch2.default })
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      { "class": "event-step" },
	                      "Step 4"
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      { "class": "event-description" },
	                      "Access you Account page to input any additional information. Also, Add Branches if you have"
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { "class": "dashboardsection" },
	              _react2.default.createElement(
	                "div",
	                { "class": "dashboardheader" },
	                "Dashboards and Partner Account Page - Sample Views "
	              ),
	              _react2.default.createElement(
	                "div",
	                { "class": "dashboardbox", id: "dashboards" },
	                _react2.default.createElement(
	                  _reactSlick2.default,
	                  Object.assign({}, settings_dashboards, { ref: this.slideCustom2 }),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "dashboardsampleview" },
	                    _react2.default.createElement("img", { src: _view2.default })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "dashboardsampleview" },
	                    _react2.default.createElement("img", { src: _view4.default })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "dashboardsampleview" },
	                    _react2.default.createElement("img", { src: _view6.default })
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement("div", { "class": "col-lg-2 col-sm-2 col-md-2" })
	        ),
	        _react2.default.createElement(_Footer2.default, null)
	      );
	    }
	  }]);
	
	  return PlanPageSchools;
	}(_react.Component);
	
	exports.default = PlanPageSchools;

/***/ },
/* 877 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FetchCall = __webpack_require__(4);
	
	__webpack_require__(18);
	
	var _reactNotifications = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Forget = function (_Component) {
	    _inherits(Forget, _Component);
	
	    function Forget(props) {
	        _classCallCheck(this, Forget);
	
	        var _this = _possibleConstructorReturn(this, (Forget.__proto__ || Object.getPrototypeOf(Forget)).call(this, props));
	
	        _this.handleChange = function (e) {
	            var propName = e.target.name;
	            _this.setState(_defineProperty({}, e.target.name, e.target.value));
	        };
	
	        _this.onReqSubmit = function (e) {
	            e.preventDefault();
	            var ins = JSON.stringify({
	                email: _this.state.email_id,
	                type: 3
	            });
	            (0, _FetchCall.ForgotPass)(ins).then(function (res) {
	                var toastr = '';
	                if (res.status === 1) {
	
	                    _reactNotifications.NotificationManager.success('Reset Link is sent to Your Mail ID, please check your inbox.');
	
	                    //this.props.history.push('/');
	                } else {
	                    var er = res.errors[0].msg;
	                    _reactNotifications.NotificationManager.error(er);
	                }
	            });
	        };
	
	        _this.onUpdateSubmit = function (e) {
	            e.preventDefault();
	            e.preventDefault();
	            var ins = JSON.stringify({
	                email: _this.state.email_id,
	                password: _this.state.password,
	                confirm_password: _this.state.confirm_password,
	                token: _this.state.token
	            });
	            (0, _FetchCall.ResetPass)(ins).then(function (res) {
	                var toastr = '';
	                if (res.status === 1) {
	                    _reactNotifications.NotificationManager.success('Reset Password Success!..you will be redirecting to login page');
	                    setTimeout(function () {
	                        window.location.replace('/login');
	                    }, 500);
	                    //this.props.history.push('/');
	                } else {
	                    var er = res.errors[0].msg;
	                    _reactNotifications.NotificationManager.error(er);
	                }
	            });
	        };
	
	        _this.state = {
	            showPassword: false,
	            showCPassword: false,
	            email_id: '',
	            password: '',
	            confirm_password: '',
	            ref: _this.props.match.params.ref,
	            token: _this.props.match.params.token,
	            reset: false,
	            title: 'Forgot'
	        };
	        return _this;
	    }
	
	    _createClass(Forget, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            if (this.state.ref !== undefined) {
	                this.setState({
	                    email_id: this.state.ref,
	                    reset: true,
	                    title: 'Reset'
	                });
	            }
	        }
	    }, {
	        key: 'handleShowPassword',
	        value: function handleShowPassword() {
	            this.setState(function (prevState) {
	                return {
	                    showPassword: !prevState.showPassword
	                };
	            });
	        }
	    }, {
	        key: 'handleShowCPassword',
	        value: function handleShowCPassword() {
	            this.setState(function (prevState) {
	                return {
	                    showCPassword: !prevState.showCPassword
	                };
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'container-fluid' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-5 col-sm-5 login-left hidden-sm hidden-xs' },
	                            _react2.default.createElement(
	                                'h1',
	                                null,
	                                this.state.title,
	                                ' Password ? '
	                            ),
	                            _react2.default.createElement('div', { className: 'img-wrap' })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-7 col-sm-12 login-right' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'login-wrap' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'nav-brand' },
	                                    _react2.default.createElement(
	                                        'h1',
	                                        null,
	                                        'BeWise'
	                                    )
	                                ),
	                                this.state.reset === false ? _react2.default.createElement(
	                                    'form',
	                                    { autoComplete: 'off', className: 'login-form', onSubmit: this.onReqSubmit },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'form-group' },
	                                        _react2.default.createElement('input', { type: 'email',
	                                            name: 'email_id',
	                                            className: 'form-control',
	                                            placeholder: 'Email Id',
	                                            required: 'required',
	                                            onChange: this.handleChange,
	                                            value: this.state.email_id
	                                        })
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'form-group' },
	                                        _react2.default.createElement(
	                                            'button',
	                                            { type: 'submit', className: 'btn login-btn' },
	                                            'Submit'
	                                        )
	                                    )
	                                ) : _react2.default.createElement(
	                                    'form',
	                                    { autoComplete: 'off', className: 'login-form', onSubmit: this.onUpdateSubmit },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'form-group' },
	                                        _react2.default.createElement('input', { type: this.state.showPassword ? 'text' : 'password',
	                                            name: 'password',
	                                            className: 'form-control',
	                                            placeholder: 'Password',
	                                            required: 'required',
	                                            onChange: this.handleChange,
	                                            value: this.state.password
	                                        }),
	                                        _react2.default.createElement('span', {
	                                            toggle: '#password-field',
	                                            className: this.state.showPassword ? 'fa fa-fw fa-eye-slash field-icon plogin' : 'fa fa-fw fa-eye field-icon plogin',
	                                            onClick: function onClick() {
	                                                _this2.handleShowPassword();
	                                            }
	                                        })
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'form-group' },
	                                        _react2.default.createElement('input', { type: this.state.showCPassword ? 'text' : 'password',
	                                            name: 'confirm_password',
	                                            className: 'form-control',
	                                            placeholder: 'Confirm Password',
	                                            required: 'required',
	                                            onChange: this.handleChange,
	                                            value: this.state.confirm_password
	                                        }),
	                                        _react2.default.createElement('span', {
	                                            toggle: '#password-field',
	                                            className: this.state.showCPassword ? 'fa fa-fw fa-eye-slash field-icon plogin' : 'fa fa-fw fa-eye field-icon plogin',
	                                            onClick: function onClick() {
	                                                _this2.handleShowCPassword();
	                                            }
	                                        })
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'form-group' },
	                                        _react2.default.createElement(
	                                            'button',
	                                            { type: 'submit', className: 'btn login-btn' },
	                                            'Submit'
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(_reactNotifications.NotificationContainer, null)
	            );
	        }
	    }]);
	
	    return Forget;
	}(_react.Component);
	
	exports.default = Forget;

/***/ },
/* 878 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FetchCall = __webpack_require__(4);
	
	__webpack_require__(18);
	
	var _reactNotifications = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ForgotExcl = function (_Component) {
	    _inherits(ForgotExcl, _Component);
	
	    function ForgotExcl(props) {
	        _classCallCheck(this, ForgotExcl);
	
	        var _this = _possibleConstructorReturn(this, (ForgotExcl.__proto__ || Object.getPrototypeOf(ForgotExcl)).call(this, props));
	
	        _this.handleChange = function (e) {
	            var propName = e.target.name;
	            _this.setState(_defineProperty({}, e.target.name, e.target.value));
	        };
	
	        _this.onReqSubmit = function (e) {
	            e.preventDefault();
	            var ins = JSON.stringify({
	                email: _this.state.email_id,
	                type: 11
	            });
	            (0, _FetchCall.ForgotPass)(ins).then(function (res) {
	                var toastr = '';
	                if (res.status === 1) {
	
	                    _reactNotifications.NotificationManager.success('Reset Link is sent to Your Mail ID, Please checck your inbox.');
	
	                    //this.props.history.push('/');
	                } else {
	                    var er = res.errors[0].msg;
	                    _reactNotifications.NotificationManager.error(er);
	                }
	            });
	        };
	
	        _this.onUpdateSubmit = function (e) {
	            e.preventDefault();
	            e.preventDefault();
	            var ins = JSON.stringify({
	                email: _this.state.email_id,
	                password: _this.state.password,
	                confirm_password: _this.state.confirm_password,
	                token: _this.state.token
	            });
	            (0, _FetchCall.ResetPass)(ins).then(function (res) {
	                var toastr = '';
	                if (res.status === 1) {
	                    _reactNotifications.NotificationManager.success('Reset Password Success!..you will be redirecting to login page..');
	
	                    setTimeout(function () {
	                        window.location.replace('/excl_login');
	                    }, 500);
	
	                    //this.props.history.push('/excl_login');
	                } else {
	                    var er = res.errors[0].msg;
	                    _reactNotifications.NotificationManager.error(er);
	                }
	            });
	        };
	
	        _this.state = {
	            showPassword: false,
	            showCPassword: false,
	            email_id: '',
	            password: '',
	            confirm_password: '',
	            ref: _this.props.match.params.ref,
	            token: _this.props.match.params.token,
	            reset: false,
	            title: 'Forgot'
	        };
	        return _this;
	    }
	
	    _createClass(ForgotExcl, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            if (this.state.ref !== undefined) {
	                this.setState({
	                    email_id: this.state.ref,
	                    reset: true,
	                    title: 'Reset'
	                });
	            }
	        }
	    }, {
	        key: 'handleShowPassword',
	        value: function handleShowPassword() {
	            this.setState(function (prevState) {
	                return {
	                    showPassword: !prevState.showPassword
	                };
	            });
	        }
	    }, {
	        key: 'handleShowCPassword',
	        value: function handleShowCPassword() {
	            this.setState(function (prevState) {
	                return {
	                    showCPassword: !prevState.showCPassword
	                };
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'container-fluid' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-5 col-sm-5 login-left hidden-sm hidden-xs' },
	                            _react2.default.createElement(
	                                'h1',
	                                null,
	                                this.state.title,
	                                ' Password ? '
	                            ),
	                            _react2.default.createElement('div', { className: 'img-wrap' })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-7 col-sm-12 login-right' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'login-wrap' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'nav-brand' },
	                                    _react2.default.createElement(
	                                        'h1',
	                                        null,
	                                        'BeWise'
	                                    )
	                                ),
	                                this.state.reset === false ? _react2.default.createElement(
	                                    'form',
	                                    { autoComplete: 'off', className: 'login-form', onSubmit: this.onReqSubmit },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'form-group' },
	                                        _react2.default.createElement('input', { type: 'email',
	                                            name: 'email_id',
	                                            className: 'form-control',
	                                            placeholder: 'Email Id',
	                                            required: 'required',
	                                            onChange: this.handleChange,
	                                            value: this.state.email_id
	                                        })
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'form-group' },
	                                        _react2.default.createElement(
	                                            'button',
	                                            { type: 'submit', className: 'btn login-btn' },
	                                            'Submit'
	                                        )
	                                    )
	                                ) : _react2.default.createElement(
	                                    'form',
	                                    { autoComplete: 'off', className: 'login-form', onSubmit: this.onUpdateSubmit },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'form-group' },
	                                        _react2.default.createElement('input', { type: this.state.showPassword ? 'text' : 'password',
	                                            name: 'password',
	                                            className: 'form-control',
	                                            placeholder: 'Password',
	                                            required: 'required',
	                                            onChange: this.handleChange,
	                                            value: this.state.password
	                                        }),
	                                        _react2.default.createElement('span', {
	                                            toggle: '#password-field',
	                                            className: this.state.showPassword ? 'fa fa-fw fa-eye-slash field-icon plogin' : 'fa fa-fw fa-eye field-icon plogin',
	                                            onClick: function onClick() {
	                                                _this2.handleShowPassword();
	                                            }
	                                        })
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'form-group' },
	                                        _react2.default.createElement('input', { type: this.state.showCPassword ? 'text' : 'password',
	                                            name: 'confirm_password',
	                                            className: 'form-control',
	                                            placeholder: 'Confirm Password',
	                                            required: 'required',
	                                            onChange: this.handleChange,
	                                            value: this.state.confirm_password
	                                        }),
	                                        _react2.default.createElement('span', {
	                                            toggle: '#password-field',
	                                            className: this.state.showCPassword ? 'fa fa-fw fa-eye-slash field-icon plogin' : 'fa fa-fw fa-eye field-icon plogin',
	                                            onClick: function onClick() {
	                                                _this2.handleShowCPassword();
	                                            }
	                                        })
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'form-group' },
	                                        _react2.default.createElement(
	                                            'button',
	                                            { type: 'submit', className: 'btn login-btn' },
	                                            'Submit'
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(_reactNotifications.NotificationContainer, null)
	            );
	        }
	    }]);
	
	    return ForgotExcl;
	}(_react.Component);
	
	exports.default = ForgotExcl;

/***/ },
/* 879 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FetchCall = __webpack_require__(4);
	
	var _FetchCall2 = _interopRequireDefault(_FetchCall);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactPlacesAutocomplete = __webpack_require__(132);
	
	var _reactPlacesAutocomplete2 = _interopRequireDefault(_reactPlacesAutocomplete);
	
	var _Autocomplete = __webpack_require__(181);
	
	var _Autocomplete2 = _interopRequireDefault(_Autocomplete);
	
	var _TextField = __webpack_require__(176);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	var _reactGeocode = __webpack_require__(55);
	
	var _reactGeocode2 = _interopRequireDefault(_reactGeocode);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	_reactGeocode2.default.setApiKey("AIzaSyA9MtbfG_zlo64B2lqNMvigTBuXHkagKcE");
	_reactGeocode2.default.setLanguage("en");
	_reactGeocode2.default.setRegion("es");
	_reactGeocode2.default.enableDebug();
	
	var Register = function (_Component) {
	    _inherits(Register, _Component);
	
	    function Register(props) {
	        _classCallCheck(this, Register);
	
	        var _this = _possibleConstructorReturn(this, (Register.__proto__ || Object.getPrototypeOf(Register)).call(this, props));
	
	        _this.getSelect = function () {
	
	            var rows = '';
	            {
	                rows = _this.state.cateList.length > 0 && _this.state.cateList.map(function (item, i) {
	                    return _react2.default.createElement(
	                        'option',
	                        { value: item.category_id, 'data-tokens': item.options.toString() },
	                        item.label
	                    );
	                });
	            }
	
	            return rows;
	        };
	
	        _this.handleChange = function (e) {
	            var propName = e.target.name;
	            _this.setState(_defineProperty({}, e.target.name, e.target.value));
	            if (e.target.value !== '') {
	                _this.clearValidationErr(propName);
	            }
	            if (propName === 'user_type' && e.target.value === '1') {
	                _this.clearValidationErr('organisation_register_number');
	            }
	
	            if (propName === 'user_type' && e.target.value === '2') {
	                _this.setState({
	                    is_org: true,
	                    is_owner: false
	                });
	            } else if (propName === 'user_type' && e.target.value === '1') {
	                _this.setState({
	                    is_org: false,
	                    is_owner: false,
	                    incharge_text: 'In-Charge',
	                    designation: '',
	                    incharge_name: ''
	                });
	            }
	        };
	
	        _this.handleClick = function (e) {
	            console.log(e.target.name);
	            var propName = e.target.name;
	            _this.setState(function (prevState) {
	                return _defineProperty({}, propName, !prevState[propName]);
	            });
	            console.log('sad', e.target.value);
	            if (propName === 'is_owner' && e.target.value === 'false') {
	                _this.setState({
	                    incharge_text: '',
	                    designation: ''
	                });
	            } else if (propName === 'is_owner' && e.target.value === 'true') {
	                _this.setState({
	                    incharge_text: 'In-Charge '
	                });
	            }
	        };
	
	        _this.handleSelect = function (e) {
	            var propName = e.target.name;
	            var value = [].concat(_toConsumableArray(e.target.selectedOptions)).map(function (item) {
	                return item.value;
	            });
	            _this.setState(_defineProperty({}, propName, value));
	            _this.clearValidationErr(propName);
	            console.log('va', value);
	            if (propName === 'social_link' && value[0] === 'fb') {
	                _this.setState({
	                    socialPlace: 'Facebook'
	                });
	            } else if (propName === 'social_link' && value[0] === 'twt') {
	                _this.setState({
	                    socialPlace: 'Twitter'
	                });
	            } else if (propName === 'social_link' && value[0] === 'lnkin') {
	                _this.setState({
	                    socialPlace: 'LinkedIn'
	                });
	            } else if (propName === 'social_link' && value[0] === 'insta') {
	                _this.setState({
	                    socialPlace: 'Instagram'
	                });
	            }
	        };
	
	        _this.handleplaceChange = function (address) {
	            _this.setState({ address: address, pin_code: '', state: '', location: '' });
	        };
	
	        _this.handleplaceSelect = function (address) {
	            _this.setState({ address: address });
	            // this.Geocode_location();
	            _reactGeocode2.default.fromAddress(address).then(function (response) {
	
	                console.log('responsexxxx', response.results[0].address_components);
	
	                var geolen = response.results[0].address_components.length;
	                var pincode = '';
	                var state = '';
	                var city = '';
	                for (var i = 0; i < geolen; i++) {
	
	                    if (response.results[0].address_components[i].types[0] == "postal_code") {
	                        pincode = response.results[0].address_components[i].short_name;
	                    }
	                    if (response.results[0].address_components[i].types[0] == "administrative_area_level_1") {
	                        state = response.results[0].address_components[i].long_name;
	                    }
	                    if (response.results[0].address_components[i].types[0] == "administrative_area_level_2") {
	                        city = response.results[0].address_components[i].long_name;
	                    }
	                }
	
	                console.log('pincode', pincode);
	                console.log('state', state);
	                console.log('city', city);
	                _this.get_location(pincode, state, city);
	            }, function (error) {
	                console.error(error);
	            });
	        };
	
	        _this.handleSubmitFirst = function (e) {
	            e.preventDefault();
	            if (_this.state.password !== _this.state.cpassword) {
	                _this.showValidationErr("cpassword", "New Password and Confirm password Should Match");
	                return false;
	            }
	            if (_this.state.user_type !== '' && _this.state.organisation_type !== '' && _this.state.email_id !== '' && _this.state.state !== '' && _this.state.location !== '' && _this.state.pin_code !== '' && _this.state.address !== '' && _this.state.password !== '') {
	                var socialArr = [_defineProperty({}, _this.state.social_link, _this.state.social_media_link)];
	
	                var ins = '';
	                if (_this.state.user_type == '1') {
	                    ins = JSON.stringify({
	                        user_name: _this.state.user_name,
	                        user_type: _this.state.user_type,
	                        is_owner: _this.state.is_owner,
	                        in_charge: _this.state.incharge,
	                        designation: _this.state.designation,
	                        organisation_name: '',
	                        business_reg_no: '',
	                        business_type: _this.state.organisation_type,
	                        email_id: _this.state.email_id,
	                        phone_number: _this.state.phone_number,
	                        state: _this.state.state,
	                        location: _this.state.location,
	                        pin_code: _this.state.pin_code,
	                        address: _this.state.address,
	                        address2: _this.state.address2,
	                        password: _this.state.password,
	                        cpassword: _this.state.cpassword,
	                        social_media_link: socialArr,
	                        agree: _this.state.agree
	                    });
	                } else {
	                    ins = JSON.stringify({
	                        user_name: _this.state.user_name,
	                        user_type: _this.state.user_type,
	                        is_owner: _this.state.is_owner,
	                        in_charge: _this.state.incharge,
	                        designation: _this.state.designation,
	                        organisation_name: _this.state.organisation_name,
	                        business_reg_no: _this.state.organisation_register_number,
	                        business_type: _this.state.organisation_type,
	                        email_id: _this.state.email_id,
	                        phone_number: _this.state.phone_number,
	                        state: _this.state.state,
	                        location: _this.state.location,
	                        pin_code: _this.state.pin_code,
	                        address: _this.state.address,
	                        address2: _this.state.address2,
	                        password: _this.state.password,
	                        cpassword: _this.state.cpassword,
	                        social_media_link: socialArr,
	                        agree: _this.state.agree
	                    });
	                }
	                (0, _FetchCall.registerVendor)(ins).then(function (res) {
	                    var toastr = '';
	                    if (res.status === 1) {
	                        toastr = window.toastr.success;
	                        toastr('', 'Your Activation link  has been sent your to registered email id please click the link to activate your account.', {
	                            positionClass: "toast-bottom-right",
	                            containerId: "toast-bottom-right"
	                        });
	                        setTimeout(function () {
	                            window.location.reload('/');
	                        }, 2000);
	                    } else {
	                        var er = res.errors[0].msg;
	                        toastr = window.toastr.error; //warning
	                        toastr(er, toastr, {
	                            positionClass: "toast-bottom-right",
	                            containerId: "toast-bottom-right"
	                        });
	                    }
	                });
	            } else {
	                console.log('errors', _this.state.errors);
	                if (_this.state.user_type == "") {
	                    _this.showValidationErr("user_type", "Select User Type");
	                }
	                // if (this.state.organisation_name == "") {
	                //     this.showValidationErr("organisation_name", "Enter Organisation name");
	                // }
	                if (_this.state.organisation_register_number == "" && _this.state.user_type != '1') {
	                    _this.showValidationErr("organisation_register_number", "Enter Organisation Register Number");
	                }
	
	                if (_this.state.organisation_type == "") {
	                    _this.showValidationErr("organisation_type", "Select Organisation Type");
	                }
	                if (_this.state.email_id == "") {
	                    _this.showValidationErr("email_id", "Enter Email id");
	                }
	                if (_this.state.state == "") {
	                    _this.showValidationErr("state", "Enter Select State");
	                }
	                if (_this.state.address == "") {
	                    _this.showValidationErr("address", "Enter Enter Address");
	                }
	                if (_this.state.location == "") {
	                    _this.showValidationErr("location", "Enter Select Location");
	                }
	                if (_this.state.pin_code == "") {
	                    _this.showValidationErr("pin_code", "Enter Enter Pincode");
	                }
	                if (_this.state.address == "") {
	                    _this.showValidationErr("user_statetype", "Enter Enter Address");
	                }
	            }
	        };
	
	        _this.handlePaymentMode = function (e) {
	            _this.setState({
	                paymentMode: e.target.value
	            });
	        };
	
	        _this.handleFile = function (e) {
	            _this.setState(_defineProperty({}, e.target.name, e.target.files[0]));
	            _this.clearValidationErr(e.target.name);
	        };
	
	        _this.getRender = function (params) {
	
	            return _react2.default.createElement(_TextField2.default, Object.assign({}, params, {
	                variant: 'outlined',
	                placeholder: 'Type Category Here'
	            }));
	        };
	
	        _this.onTagsChange = function (event, values) {
	
	            var list = _this.state.cateList;
	            list.map(function (item, i) {
	                item.options = item.options.flat(Infinity);
	            });
	            var finalArr = [];
	            list.map(function (item, i) {
	                var intersection = item.options.filter(function (x) {
	                    return values.includes(x);
	                });
	                if (intersection.length > 0) {
	                    finalArr.push(item.category_id);
	                }
	            });
	
	            _this.setState({
	                organisation_type: finalArr
	            });
	        };
	
	        var queryString = __webpack_require__(1367);
	        var parsed = queryString.parse(props.location.search);
	
	        _this.state = {
	            url_parsed: parsed.partner != undefined ? parsed.partner : 0,
	            register_step1: true,
	            register_step2: false,
	            paymentMode: '',
	            organisation_name: '',
	            user_type: '1',
	            user_name: '',
	            organisation_register_number: '',
	            email_id: '',
	            phone_number: '',
	            organisation_type: '',
	            state: '',
	            location: '',
	            pin_code: '',
	            address: '',
	            password: '',
	            cpassword: '',
	            cheque_image: '',
	            package_type: '',
	            payment_mode: '1',
	            errors: [],
	            address2: 'Test',
	            org_type_list: [],
	            social_media_link: '',
	            is_org: false,
	            is_owner: false,
	            incharge_name: '',
	            incharge_text: 'In-Charge ',
	            social_link: 'lnkin',
	            socialPlace: 'LinkedIn',
	            agree: false,
	            designation: '',
	            cateList: [],
	            autoSuggCate: []
	        };
	        _this.orgList();
	        _this.cateList();
	        // $('.selectpicker').selectpicker('refresh');
	        return _this;
	    }
	
	    _createClass(Register, [{
	        key: 'cateList',
	        value: function () {
	            var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	                var _this2 = this;
	
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                (0, _FetchCall.getCatDrop)(0).then(function (res) {
	                                    if (res.status === 1) {
	                                        var list = res.results;
	                                        list.map(function (item, i) {
	                                            item.options = item.options.flat(Infinity);
	                                        });
	                                        var fiArr = [];
	                                        list.map(function (item, i) {
	                                            fiArr.push(item.options);
	                                        });
	                                        fiArr = fiArr.flat(Infinity);
	                                        _this2.setState({
	                                            cateList: res.results,
	                                            autoSuggCate: fiArr
	                                        });
	                                    }
	                                });
	
	                            case 1:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function cateList() {
	                return _ref3.apply(this, arguments);
	            }
	
	            return cateList;
	        }()
	    }, {
	        key: 'showValidationErr',
	        value: function showValidationErr(elm, msg) {
	            this.setState(function (prevState) {
	                return { errors: [].concat(_toConsumableArray(prevState.errors), [{ elm: elm, msg: msg }]) };
	            });
	        }
	    }, {
	        key: 'clearValidationErr',
	        value: function clearValidationErr(elm) {
	            var _this3 = this;
	
	            this.setState(function (prevState) {
	                var newArr = [];
	                var _iteratorNormalCompletion = true;
	                var _didIteratorError = false;
	                var _iteratorError = undefined;
	
	                try {
	                    for (var _iterator = _this3.state.errors[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                        var err = _step.value;
	
	                        if (elm !== err.elm) {
	                            newArr.push(err);
	                        }
	                    }
	                } catch (err) {
	                    _didIteratorError = true;
	                    _iteratorError = err;
	                } finally {
	                    try {
	                        if (!_iteratorNormalCompletion && _iterator.return) {
	                            _iterator.return();
	                        }
	                    } finally {
	                        if (_didIteratorError) {
	                            throw _iteratorError;
	                        }
	                    }
	                }
	
	                return { errors: newArr };
	            });
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            window.jQuery('.selectpicker').selectpicker('refresh');
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	
	            if (this.state.url_parsed === 'individual') {
	                this.setState({
	                    user_type: '1'
	                });
	            } else if (this.state.url_parsed === 'institutional') {
	                this.setState({
	                    user_type: '2',
	                    is_org: true
	                });
	            }
	        }
	    }, {
	        key: 'componentWillMount',
	        value: function componentWillMount() {}
	    }, {
	        key: 'orgList',
	        value: function () {
	            var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	                var response;
	                return _regenerator2.default.wrap(function _callee2$(_context2) {
	                    while (1) {
	                        switch (_context2.prev = _context2.next) {
	                            case 0:
	                                _context2.next = 2;
	                                return _FetchCall2.default.getSubCategory('0');
	
	                            case 2:
	                                response = _context2.sent;
	
	                                console.log('boeList', response);
	                                if (response) {
	                                    this.setState({ org_type_list: response.results });
	                                }
	
	                            case 5:
	                            case 'end':
	                                return _context2.stop();
	                        }
	                    }
	                }, _callee2, this);
	            }));
	
	            function orgList() {
	                return _ref4.apply(this, arguments);
	            }
	
	            return orgList;
	        }()
	    }, {
	        key: 'Geocode_location',
	        value: function Geocode_location() {
	            var _this4 = this;
	
	            _reactGeocode2.default.fromAddress(this.state.address).then(function (response) {
	
	                console.log('responsexxxx', response.results[0].address_components);
	
	                var geolen = response.results[0].address_components.length;
	                var pincode = '';
	                var state = '';
	                var city = '';
	                for (var i = 0; i < geolen; i++) {
	
	                    if (response.results[0].address_components[i].types[0] == "postal_code") {
	                        pincode = response.results[0].address_components[i].short_name;
	                    }
	                    if (response.results[0].address_components[i].types[0] == "administrative_area_level_1") {
	                        state = response.results[0].address_components[i].long_name;
	                    }
	                    if (response.results[0].address_components[i].types[0] == "administrative_area_level_2") {
	                        city = response.results[0].address_components[i].long_name;
	                    }
	                }
	
	                console.log('pincode', pincode);
	                console.log('state', state);
	                console.log('city', city);
	                _this4.get_location(pincode, state, city);
	            }, function (error) {
	                console.error(error);
	            });
	        }
	    }, {
	        key: 'get_location',
	        value: function get_location(pincode, state, city) {
	            console.log(pincode, state, city);
	            this.setState({
	                pin_code: pincode,
	                state: state,
	                location: city
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this5 = this;
	
	            console.log('registerVendor', this.state.errors);
	            var organisation_nameErr = '';
	            var user_typeErr = '';
	            var organisation_register_numberErr = '';
	            var organisation_typeErr = '';
	            var email_idErr = '';
	            var phone_numberErr = '';
	            var stateErr = '';
	            var locationErr = '';
	            var pin_codeErr = '';
	            var addressErr = '';
	            var passwordErr = '';
	            var cpasswordErr = '';
	            var linkErr = '';
	            var _iteratorNormalCompletion2 = true;
	            var _didIteratorError2 = false;
	            var _iteratorError2 = undefined;
	
	            try {
	                for (var _iterator2 = this.state.errors[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                    var err = _step2.value;
	
	                    if (err.elm == 'user_type') {
	                        user_typeErr = err.msg;
	                    }
	                    if (err.elm == 'organisation_name') {
	                        organisation_nameErr = err.msg;
	                    }
	                    if (err.elm == 'organisation_register_number') {
	                        organisation_register_numberErr = err.msg;
	                    }
	                    if (err.elm == 'organisation_type') {
	                        organisation_typeErr = err.msg;
	                    }
	                    if (err.elm == 'email_id') {
	                        email_idErr = err.msg;
	                    }
	                    if (err.elm == 'state') {
	                        stateErr = err.msg;
	                    }
	                    if (err.elm == 'location') {
	                        locationErr = err.msg;
	                    }
	                    if (err.elm == 'pin_code') {
	                        pin_codeErr = err.msg;
	                    }
	                    if (err.elm == 'address') {
	                        addressErr = err.msg;
	                    }
	                    if (err.elm == 'password') {
	                        passwordErr = err.msg;
	                    }
	                    if (err.elm == 'cpassword') {
	                        cpasswordErr = err.msg;
	                    }
	                }
	            } catch (err) {
	                _didIteratorError2 = true;
	                _iteratorError2 = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                        _iterator2.return();
	                    }
	                } finally {
	                    if (_didIteratorError2) {
	                        throw _iteratorError2;
	                    }
	                }
	            }
	
	            console.log('errror', this.state.errors);
	            return _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'container-fluid' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row dflex' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-4 col-sm-4  login-left register-left-1 hidden-sm hidden-xs' },
	                            _react2.default.createElement(
	                                'h1',
	                                null,
	                                'Sign up'
	                            ),
	                            _react2.default.createElement('div', { className: 'img-wrap' })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-8 col-sm-8 register-right' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'register-form col-md-12 col-xs-12' },
	                                _react2.default.createElement('div', { className: 'nav-brand text-center visible-xs' }),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'formstep-enclose step-1 col-md-12 col-xs-12 pad-no' },
	                                    this.state.register_step1 === true ? _react2.default.createElement(
	                                        'div',
	                                        { className: 'form-step1 col-md-12 col-xs-12 pad-no' },
	                                        _react2.default.createElement(
	                                            'form',
	                                            { onSubmit: this.handleSubmitFirst, className: 'custom-form' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'row select-register' },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group col-md-12' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        'User Type',
	                                                        _react2.default.createElement(
	                                                            'span',
	                                                            { className: 'astrick' },
	                                                            '*'
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement('br', null),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'row' },
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'col-md-12' },
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'd-inline-flex mr-10' },
	                                                                this.state.user_type == '1' ? _react2.default.createElement(
	                                                                    'span',
	                                                                    null,
	                                                                    _react2.default.createElement(
	                                                                        'label',
	                                                                        null,
	                                                                        _react2.default.createElement('input', { type: 'radio', name: 'user_type', checked: this.state.user_type === '1', value: '1', onChange: this.handleChange }),
	                                                                        ' Individual'
	                                                                    ),
	                                                                    ' \xA0\xA0\xA0'
	                                                                ) : _react2.default.createElement(
	                                                                    'span',
	                                                                    null,
	                                                                    _react2.default.createElement(
	                                                                        'label',
	                                                                        null,
	                                                                        _react2.default.createElement('input', { type: 'radio', name: 'user_type', checked: this.state.user_type === '2', value: '2', onChange: this.handleChange }),
	                                                                        ' Organisation '
	                                                                    ),
	                                                                    ' \xA0\xA0'
	                                                                )
	                                                            ),
	                                                            this.state.is_org && _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'd-inline-flex' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    null,
	                                                                    _react2.default.createElement('input', { type: 'checkbox', name: 'is_owner', value: this.state.is_owner, onChange: this.handleClick }),
	                                                                    ' Is this Organisation Owner'
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'small',
	                                                                    { className: 'alert-msg text-danger' },
	                                                                    ' ',
	                                                                    user_typeErr
	                                                                )
	                                                            )
	                                                        )
	                                                    )
	                                                )
	                                            ),
	                                            this.state.is_org && _react2.default.createElement(
	                                                'div',
	                                                { className: 'row' },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group col-md-4' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        this.state.incharge_text,
	                                                        ' Name',
	                                                        _react2.default.createElement(
	                                                            'span',
	                                                            { className: 'astrick' },
	                                                            '*'
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement('input', { type: 'text', name: 'incharge', value: this.state.incharge,
	                                                        onChange: this.handleChange, className: 'form-control' })
	                                                ),
	                                                !this.state.is_owner && _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group col-md-4' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        'Designation',
	                                                        _react2.default.createElement(
	                                                            'span',
	                                                            { className: 'astrick' },
	                                                            '*'
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement('input', { type: 'text', name: 'designation', value: this.state.designation,
	                                                        onChange: this.handleChange, className: 'form-control' })
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'row' },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group col-md-4' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        'User Name',
	                                                        _react2.default.createElement(
	                                                            'span',
	                                                            { className: 'astrick' },
	                                                            '*'
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement('input', { type: 'text', name: 'user_name', value: this.state.user_name,
	                                                        onChange: this.handleChange, className: 'form-control' })
	                                                ),
	                                                this.state.user_type == '2' ? _react2.default.createElement(
	                                                    'div',
	                                                    null,
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'form-group col-md-4' },
	                                                        _react2.default.createElement(
	                                                            'label',
	                                                            null,
	                                                            'Organisation Name',
	                                                            _react2.default.createElement(
	                                                                'span',
	                                                                { className: 'astrick' },
	                                                                '*'
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement('input', { type: 'text', name: 'organisation_name', value: this.state.organisation_name,
	                                                            onChange: this.handleChange, className: 'form-control' }),
	                                                        _react2.default.createElement(
	                                                            'small',
	                                                            { className: 'alert-msg text-danger' },
	                                                            ' ',
	                                                            organisation_nameErr
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'form-group col-md-4' },
	                                                        _react2.default.createElement(
	                                                            'label',
	                                                            null,
	                                                            'Business Register Number',
	                                                            this.state.user_type != '1' ? _react2.default.createElement(
	                                                                'span',
	                                                                { className: 'astrick' },
	                                                                '*'
	                                                            ) : ''
	                                                        ),
	                                                        _react2.default.createElement('input', { type: 'text', name: 'organisation_register_number', value: this.state.organisation_register_number,
	                                                            onChange: this.handleChange, className: 'form-control' }),
	                                                        _react2.default.createElement(
	                                                            'small',
	                                                            { className: 'alert-msg text-danger' },
	                                                            ' ',
	                                                            organisation_register_numberErr
	                                                        )
	                                                    )
	                                                ) : ''
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'row' },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group col-md-4' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        'E-Mail Id',
	                                                        _react2.default.createElement(
	                                                            'span',
	                                                            { className: 'astrick' },
	                                                            '*'
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement('input', { type: 'email', name: 'email_id', value: this.state.email_id,
	                                                        onChange: this.handleChange, className: 'form-control' }),
	                                                    _react2.default.createElement(
	                                                        'small',
	                                                        { className: 'alert-msg text-danger' },
	                                                        ' ',
	                                                        email_idErr
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group col-md-4' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        'Phone Number'
	                                                    ),
	                                                    _react2.default.createElement('input', { type: 'number', name: 'phone_number', value: this.state.phone_number,
	                                                        onChange: this.handleChange, className: 'form-control' }),
	                                                    _react2.default.createElement(
	                                                        'small',
	                                                        { className: 'alert-msg text-danger' },
	                                                        ' ',
	                                                        phone_numberErr
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group col-md-4' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        'Address Line 1',
	                                                        _react2.default.createElement(
	                                                            'span',
	                                                            { className: 'astrick' },
	                                                            '*'
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        _reactPlacesAutocomplete2.default,
	                                                        {
	                                                            value: this.state.address,
	                                                            className: 'form-control',
	                                                            onChange: this.handleplaceChange,
	                                                            onSelect: this.handleplaceSelect
	                                                        },
	                                                        function (_ref5) {
	                                                            var getInputProps = _ref5.getInputProps,
	                                                                suggestions = _ref5.suggestions,
	                                                                getSuggestionItemProps = _ref5.getSuggestionItemProps,
	                                                                loading = _ref5.loading;
	                                                            return _react2.default.createElement(
	                                                                'div',
	                                                                null,
	                                                                _react2.default.createElement('input', Object.assign({}, getInputProps({
	                                                                    placeholder: 'Search Places ...',
	                                                                    className: 'form-control'
	
	                                                                }), {
	                                                                    value: _this5.state.address
	                                                                })),
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    { className: 'autocomplete-dropdown-container',
	                                                                        style: { position: "absolute", zIndex: "999" } },
	                                                                    loading && _react2.default.createElement(
	                                                                        'div',
	                                                                        null,
	                                                                        'Loading...'
	                                                                    ),
	                                                                    suggestions.map(function (suggestion) {
	                                                                        var className = suggestion.active ? 'suggestion-item--active' : 'suggestion-item';
	                                                                        // inline style for demonstration purpose
	                                                                        var style = suggestion.active ? { backgroundColor: '#fafafa', cursor: 'pointer' } : { backgroundColor: '#ffffff', cursor: 'pointer' };
	                                                                        return _react2.default.createElement(
	                                                                            'div',
	                                                                            getSuggestionItemProps(suggestion, {
	                                                                                className: className,
	                                                                                style: style
	                                                                            }),
	                                                                            _react2.default.createElement(
	                                                                                'span',
	                                                                                null,
	                                                                                suggestion.description
	                                                                            )
	                                                                        );
	                                                                    })
	                                                                )
	                                                            );
	                                                        }
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'small',
	                                                        { className: 'alert-msg text-danger' },
	                                                        ' ',
	                                                        addressErr
	                                                    )
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'row' },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group col-md-4' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        'State',
	                                                        _react2.default.createElement(
	                                                            'span',
	                                                            { className: 'astrick' },
	                                                            '*'
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement('input', { type: 'text', name: 'state_name',
	                                                        value: this.state.state,
	                                                        onChange: this.handleChange,
	                                                        className: 'form-control' }),
	                                                    _react2.default.createElement(
	                                                        'small',
	                                                        { className: 'alert-msg text-danger' },
	                                                        ' ',
	                                                        stateErr
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group col-md-4' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        'City',
	                                                        _react2.default.createElement(
	                                                            'span',
	                                                            { className: 'astrick' },
	                                                            '*'
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement('input', { type: 'text', name: 'location',
	                                                        value: this.state.location,
	                                                        onChange: this.handleChange,
	                                                        className: 'form-control' }),
	                                                    _react2.default.createElement(
	                                                        'small',
	                                                        { className: 'alert-msg text-danger' },
	                                                        ' ',
	                                                        locationErr
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group col-md-4' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        'Pincode',
	                                                        _react2.default.createElement(
	                                                            'span',
	                                                            { className: 'astrick' },
	                                                            '*'
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement('input', { type: 'text', name: 'pin_code', className: 'form-control',
	                                                        value: this.state.pin_code,
	                                                        onChange: this.handleChange
	                                                    }),
	                                                    _react2.default.createElement(
	                                                        'small',
	                                                        { className: 'alert-msg text-danger' },
	                                                        ' ',
	                                                        pin_codeErr
	                                                    )
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'row' },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group col-md-4' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        'Category',
	                                                        _react2.default.createElement(
	                                                            'span',
	                                                            { className: 'astrick' },
	                                                            '*'
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(_Autocomplete2.default, {
	                                                        multiple: true,
	                                                        limitTags: 2,
	                                                        id: 'multiple-limit-tags',
	                                                        onChange: this.onTagsChange,
	                                                        options: this.state.autoSuggCate,
	                                                        getOptionLabel: function getOptionLabel(option) {
	                                                            return option;
	                                                        },
	                                                        filterSelectedOptions: true,
	                                                        renderInput: this.getRender
	                                                    }),
	                                                    _react2.default.createElement(
	                                                        'small',
	                                                        { className: 'alert-msg text-danger' },
	                                                        ' ',
	                                                        organisation_typeErr
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group col-md-4' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        'You will Listed under',
	                                                        _react2.default.createElement(
	                                                            'span',
	                                                            { className: 'astrick' },
	                                                            '*'
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'select',
	                                                        {
	                                                            value: this.state.organisation_type,
	                                                            multiple: true,
	                                                            className: 'select-dropdown selectpicker',
	                                                            'data-live-search': 'true', title: 'Choose...',
	                                                            name: 'organisation_type',
	                                                            onChange: this.handleSelect },
	                                                        this.getSelect()
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'small',
	                                                        { className: 'alert-msg text-danger' },
	                                                        ' ',
	                                                        organisation_typeErr
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group col-md-4' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        'Social media '
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'select',
	                                                        { className: 'select-dropdown selectpicker',
	                                                            title: 'Choose...',
	                                                            name: 'social_link',
	                                                            onChange: this.handleSelect,
	                                                            value: this.state.social_link },
	                                                        _react2.default.createElement(
	                                                            'option',
	                                                            { value: 'lnkin' },
	                                                            'LinkedIn '
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'option',
	                                                            { value: 'fb' },
	                                                            'Facebook '
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'option',
	                                                            { value: 'insta' },
	                                                            'Instagram '
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'option',
	                                                            { value: 'twt' },
	                                                            'Twitter '
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'small',
	                                                        { className: 'alert-msg text-danger' },
	                                                        ' ',
	                                                        linkErr
	                                                    )
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'row' },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group col-md-4' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        'Password',
	                                                        _react2.default.createElement(
	                                                            'span',
	                                                            { className: 'astrick' },
	                                                            '*'
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement('input', { id: 'password-field', type: 'password', name: 'password',
	                                                        value: this.state.password,
	                                                        onChange: this.handleChange,
	                                                        className: 'form-control' }),
	                                                    _react2.default.createElement(
	                                                        'small',
	                                                        { className: 'alert-msg text-danger' },
	                                                        ' ',
	                                                        passwordErr
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group col-md-4' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        'Confirm Password',
	                                                        _react2.default.createElement(
	                                                            'span',
	                                                            { className: 'astrick' },
	                                                            '*'
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement('input', { id: 'password-fieldc', type: 'password', name: 'cpassword',
	                                                        value: this.state.cpassword,
	                                                        onChange: this.handleChange,
	                                                        className: 'form-control' }),
	                                                    _react2.default.createElement(
	                                                        'small',
	                                                        { className: 'alert-msg text-danger' },
	                                                        ' ',
	                                                        cpasswordErr
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group col-md-4' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        this.state.socialPlace,
	                                                        ' Link '
	                                                    ),
	                                                    _react2.default.createElement('input', { id: 'social_media_link', type: 'text', name: 'social_media_link',
	                                                        value: this.state.social_media_link,
	                                                        onChange: this.handleChange,
	                                                        className: 'form-control',
	                                                        placeholder: this.state.socialPlace }),
	                                                    _react2.default.createElement(
	                                                        'small',
	                                                        { className: 'alert-msg text-danger' },
	                                                        ' ',
	                                                        linkErr
	                                                    )
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'row' },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'col-md-6 col-xs-6 text-left' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        _react2.default.createElement('input', { type: 'checkbox', className: '', name: 'agree', checked: this.state.agree == true, value: this.state.agree, onClick: this.handleClick }),
	                                                        ' I agree to ',
	                                                        _react2.default.createElement(
	                                                            'a',
	                                                            { href: '#' },
	                                                            'terms of service and privacy policy'
	                                                        )
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'col-md-6 col-xs-6 text-right' },
	                                                    _react2.default.createElement(
	                                                        'button',
	                                                        { type: 'submit', className: 'btn btn-blue btn-rounded next' },
	                                                        'Register'
	                                                    )
	                                                )
	                                            )
	                                        )
	                                    ) : '',
	                                    this.state.register_step2 === true ? _react2.default.createElement(
	                                        'div',
	                                        { className: 'form-step2 col-md-12 col-xs-12 pad-no' },
	                                        _react2.default.createElement(
	                                            'form',
	                                            { action: '#', className: 'custom-form' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'form-group col-md-12' },
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    null,
	                                                    'Our Packages',
	                                                    _react2.default.createElement(
	                                                        'span',
	                                                        { className: 'astrick' },
	                                                        '*'
	                                                    )
	                                                ),
	                                                _react2.default.createElement('br', null),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'col-md-4' },
	                                                    _react2.default.createElement('input', { type: 'radio', name: 'package_type', checked: this.state.package_type === '1', value: '1' }),
	                                                    '\xA0Bronze - INR 2000 / Month'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'col-md-4' },
	                                                    _react2.default.createElement('input', { type: 'radio', name: 'package_type', checked: this.state.package_type === '2', value: '2' }),
	                                                    '\xA0Silver - INR 4500 / Month'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'col-md-4' },
	                                                    _react2.default.createElement('input', { type: 'radio', name: 'package_type', checked: this.state.package_type === '3', value: '3' }),
	                                                    '\xA0Gold - INR 6000 / Month'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'col-md-4' },
	                                                    _react2.default.createElement('input', { type: 'radio', name: 'package_type', checked: this.state.package_type === '4', value: '4' }),
	                                                    '\xA0Platinum - INR 7500 / Month'
	                                                )
	                                            ),
	                                            _react2.default.createElement('div', { className: 'form-group col-md-6' }),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'form-group col-md-12 package-bg' },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'col-md-6' },
	                                                    _react2.default.createElement(
	                                                        'ul',
	                                                        null,
	                                                        _react2.default.createElement(
	                                                            'li',
	                                                            null,
	                                                            '100 Word Write up with Address on site'
	                                                        )
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'col-md-6' },
	                                                    _react2.default.createElement(
	                                                        'ul',
	                                                        null,
	                                                        _react2.default.createElement(
	                                                            'li',
	                                                            null,
	                                                            'Control over content '
	                                                        )
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'col-md-6' },
	                                                    _react2.default.createElement(
	                                                        'ul',
	                                                        null,
	                                                        _react2.default.createElement(
	                                                            'li',
	                                                            null,
	                                                            '1 Photograph or premisis '
	                                                        )
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'col-md-6' },
	                                                    _react2.default.createElement(
	                                                        'ul',
	                                                        null,
	                                                        _react2.default.createElement(
	                                                            'li',
	                                                            null,
	                                                            'Visibility of Cust Ratings'
	                                                        )
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'col-md-6' },
	                                                    _react2.default.createElement(
	                                                        'ul',
	                                                        null,
	                                                        _react2.default.createElement(
	                                                            'li',
	                                                            null,
	                                                            'Number of Visits to site '
	                                                        )
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'col-md-6' },
	                                                    _react2.default.createElement(
	                                                        'ul',
	                                                        null,
	                                                        _react2.default.createElement(
	                                                            'li',
	                                                            null,
	                                                            'Auto access for Content update'
	                                                        )
	                                                    )
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'form-group col-md-12' },
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    null,
	                                                    'Payment Mode',
	                                                    _react2.default.createElement(
	                                                        'span',
	                                                        { className: 'astrick' },
	                                                        '*'
	                                                    )
	                                                ),
	                                                _react2.default.createElement('br', null),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'col-md-4' },
	                                                    _react2.default.createElement('input', { type: 'radio', name: 'payment_mode', checked: this.state.payment_mode === '1', value: '1', onChange: this.handleChange, onClick: this.handlePaymentMode }),
	                                                    '\xA0Online Payments'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'col-md-4' },
	                                                    _react2.default.createElement('input', { type: 'radio', name: 'payment_mode', value: '2', checked: this.state.payment_mode === '2', onChange: this.handleChange, onClick: this.handlePaymentMode }),
	                                                    '\xA0Cheque Collections'
	                                                )
	                                            ),
	                                            this.state.paymentMode === '1' ? _react2.default.createElement(
	                                                'div',
	                                                { className: 'col-md-6 payment-bg' },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group col-md-12 m12' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        'Card Holder Name'
	                                                    ),
	                                                    ' ',
	                                                    _react2.default.createElement('span', { id: 'card-holder-name-info',
	                                                        className: 'info' }),
	                                                    _react2.default.createElement('br', null),
	                                                    _react2.default.createElement('input', { type: 'text', id: 'name', name: 'name', className: 'form-control' })
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group col-md-12 m12' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        'Email'
	                                                    ),
	                                                    ' ',
	                                                    _react2.default.createElement('span', { id: 'email-info', className: 'info' }),
	                                                    _react2.default.createElement('br', null),
	                                                    _react2.default.createElement('input', { type: 'text', id: 'email', name: 'email', className: 'form-control' })
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group col-md-12 m12' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        'Card Number'
	                                                    ),
	                                                    ' ',
	                                                    _react2.default.createElement('span', { id: 'card-number-info',
	                                                        className: 'info' }),
	                                                    _react2.default.createElement('br', null),
	                                                    _react2.default.createElement('input', { type: 'text', id: 'card-number', name: 'card-number', className: 'form-control' })
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group col-md-12 m12' },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'contact-row column-right' },
	                                                        _react2.default.createElement(
	                                                            'label',
	                                                            null,
	                                                            'Expiry Month / Year'
	                                                        ),
	                                                        _react2.default.createElement('span', { id: 'userEmail-info', className: 'info' }),
	                                                        _react2.default.createElement('br', null),
	                                                        _react2.default.createElement(
	                                                            'select',
	                                                            { name: 'month', id: 'month', className: 'form-control', style: { width: '70px', float: "left" } },
	                                                            _react2.default.createElement(
	                                                                'option',
	                                                                { value: '08' },
	                                                                '08'
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'option',
	                                                                { value: '09' },
	                                                                '9'
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'option',
	                                                                { value: '10' },
	                                                                '10'
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'option',
	                                                                { value: '11' },
	                                                                '11'
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'option',
	                                                                { value: '12' },
	                                                                '12'
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'select',
	                                                            { name: 'year', id: 'year', className: 'form-control', style: { width: '120px', marginLeft: '92px' } },
	                                                            _react2.default.createElement(
	                                                                'option',
	                                                                { value: '20' },
	                                                                '2020'
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'option',
	                                                                { value: '21' },
	                                                                '2021'
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'option',
	                                                                { value: '22' },
	                                                                '2022'
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'option',
	                                                                { value: '23' },
	                                                                '2023'
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'option',
	                                                                { value: '24' },
	                                                                '2024'
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'option',
	                                                                { value: '25' },
	                                                                '2025'
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'option',
	                                                                { value: '26' },
	                                                                '2026'
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'option',
	                                                                { value: '27' },
	                                                                '2027'
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'option',
	                                                                { value: '28' },
	                                                                '2028'
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'option',
	                                                                { value: '29' },
	                                                                '2029'
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'option',
	                                                                { value: '30' },
	                                                                '2030'
	                                                            )
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'contact-row form-group  cvv-box' },
	                                                        _react2.default.createElement(
	                                                            'label',
	                                                            null,
	                                                            'CVC'
	                                                        ),
	                                                        ' ',
	                                                        _react2.default.createElement('span', { id: 'cvv-info', className: 'info' }),
	                                                        _react2.default.createElement('br', null),
	                                                        _react2.default.createElement('input', { type: 'text', name: 'cvc', id: 'cvc', className: 'form-control cvv-input' })
	                                                    )
	                                                ),
	                                                _react2.default.createElement('div', null)
	                                            ) : "",
	                                            this.state.paymentMode === '2' ? _react2.default.createElement(
	                                                'div',
	                                                { className: 'form-group col-md-12' },
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    null,
	                                                    'Upload Cheque/ Reciept'
	                                                ),
	                                                _react2.default.createElement('input', { type: 'file',
	                                                    name: 'cheque_image',
	                                                    onChange: this.handleFile }),
	                                                _react2.default.createElement(
	                                                    'small',
	                                                    null,
	                                                    'Note: File format .pdf'
	                                                )
	                                            ) : "",
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'col-md-12 col-xs-12 text-right' },
	                                                _react2.default.createElement(
	                                                    'button',
	                                                    { className: 'btn btn-rounded btn-blue' },
	                                                    'Submit'
	                                                )
	                                            )
	                                        )
	                                    ) : ''
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Register;
	}(_react.Component);
	
	exports.default = Register;

/***/ },
/* 880 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FetchCall = __webpack_require__(4);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _simpleReactValidator = __webpack_require__(28);
	
	var _simpleReactValidator2 = _interopRequireDefault(_simpleReactValidator);
	
	var _reactPlacesAutocomplete = __webpack_require__(132);
	
	var _reactPlacesAutocomplete2 = _interopRequireDefault(_reactPlacesAutocomplete);
	
	var _constant = __webpack_require__(21);
	
	var _Autocomplete = __webpack_require__(181);
	
	var _Autocomplete2 = _interopRequireDefault(_Autocomplete);
	
	var _TextField = __webpack_require__(176);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	var _reactGeocode = __webpack_require__(55);
	
	var _reactGeocode2 = _interopRequireDefault(_reactGeocode);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	_reactGeocode2.default.setApiKey("AIzaSyA9MtbfG_zlo64B2lqNMvigTBuXHkagKcE");
	_reactGeocode2.default.setLanguage("en");
	_reactGeocode2.default.setRegion("es");
	_reactGeocode2.default.enableDebug();
	
	var IndividualComplete = function (_Component) {
	  _inherits(IndividualComplete, _Component);
	
	  function IndividualComplete(props) {
	    _classCallCheck(this, IndividualComplete);
	
	    var _this = _possibleConstructorReturn(this, (IndividualComplete.__proto__ || Object.getPrototypeOf(IndividualComplete)).call(this, props));
	
	    _this.handleFile = function (e) {
	      var propName = e.target.name;
	      var files = e.target.files[0];
	      _this.setState(_defineProperty({}, propName, files));
	    };
	
	    _this.handleSubmit = function (e) {
	      e.preventDefault();
	      if (_this.validator.allValid()) {
	        var _req;
	
	        _this.setState({
	          btnDisable: true
	        });
	        var uploaded = _this.state.uploaded;
	        var doc_name = '';
	        if (uploaded == 0) doc_name = 'idproof';
	        if (uploaded == 1) doc_name = 'qualification';
	        if (uploaded == 2) doc_name = 'user_image';
	        // 
	        var req = (_req = {}, _defineProperty(_req, doc_name, _this.state[doc_name]), _defineProperty(_req, 'token', _this.state.token), _defineProperty(_req, 'partner_id', _this.state.partner_id), _defineProperty(_req, 'partner_name', _this.state.partner_name), _defineProperty(_req, 'email_address', _this.state.email_address), _defineProperty(_req, 'user_name', _this.state.user_name), _defineProperty(_req, 'uploaded', uploaded), _req);
	        if (uploaded == 2) {
	          (0, _FetchCall.indComSignup)(req).then(function (res) {
	            var toastr = '';
	            _this.setState({
	              btnDisable: false
	            });
	            if (res.status === 1) {
	              toastr = window.toastr.success;
	              toastr('', 'Successfully Uploaded, if there are any irregularities in the submitted \n            documents, our team will get in touch with you soon', {
	                positionClass: "toast-bottom-right",
	                containerId: "toast-bottom-right"
	              });
	              setTimeout(function () {
	                window.location.href = res.redirect;
	              }, 2000);
	            } else {
	              var er = res.message;
	              toastr = window.toastr.error; //warning
	              toastr(er, toastr, {
	                positionClass: "toast-bottom-right",
	                containerId: "toast-bottom-right"
	              });
	            }
	          });
	        } else {
	
	          (0, _FetchCall.indUploadDocs)(req).then(function (res) {
	            var toastr = '';
	            _this.setState({
	              btnDisable: false
	            });
	            if (res.status === 1) {
	              _this.setState({
	                uploaded: res.uploaded
	              });
	              toastr = window.toastr.success;
	              toastr('', 'Successfully Uploaded, if there are any irregularities in the submitted \n          document, our team will get in touch with you soon, Please Upload Next Documents', {
	                positionClass: "toast-bottom-right",
	                containerId: "toast-bottom-right"
	              });
	            } else {
	              var er = res.message;
	              toastr = window.toastr.error; //warning
	              toastr(er, toastr, {
	                positionClass: "toast-bottom-right",
	                containerId: "toast-bottom-right"
	              });
	            }
	          });
	        }
	      } else {
	        _this.validator.showMessages();
	        _this.forceUpdate();
	      }
	    };
	
	    _this.state = {
	      uploaded: 0,
	      partner_id: _this.props.match.params.id,
	      token: _this.props.match.params.token,
	      partner_name: '',
	      btnDisable: false,
	      user_name: '',
	      email_address: '',
	      idproof: '',
	      qualification: '',
	      user_image: ''
	    };
	    _this.verifyPage();
	    // $('.selectpicker').selectpicker('refresh');
	    _this.validator = new _simpleReactValidator2.default();
	    return _this;
	  }
	
	  _createClass(IndividualComplete, [{
	    key: 'verifyPage',
	    value: function verifyPage() {
	      var _this2 = this;
	
	      var data = JSON.stringify({
	        login_id: this.props.match.params.id,
	        token: this.props.match.params.token
	      });
	      var toastr = void 0;
	      (0, _FetchCall.indVerifyLink)(data).then(function (response) {
	        if (response.status === 0) {
	          toastr = window.toastr.error; //warning
	          var err = response.errors ? response.errors[0].msg : response.message;
	          toastr(err, {
	            positionClass: "toast-bottom-right",
	            containerId: "toast-bottom-right"
	          });
	          _this2.props.history.push("/login");
	        } else {
	          _this2.setState({
	            partner_name: response.data.partner_name,
	            email_address: response.data.email_id,
	            user_name: response.data.user_name,
	            uploaded: response.uploaded
	          });
	        }
	      });
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {}
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'render',
	    value: function render() {
	      this.validator.purgeFields();
	      var uploaded = this.state.uploaded;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'container-fluid' },
	        _react2.default.createElement(
	          'form',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-6 col-sm-6 sign-bg-login   hidden-xs' },
	              _react2.default.createElement('div', { className: 'shadow-bg' }),
	              _react2.default.createElement(
	                'h1',
	                null,
	                'Welcome to',
	                _react2.default.createElement('br', null),
	                ' BeWise Partner Program'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-6 col-sm-6 signup-right' },
	              _react2.default.createElement(
	                'div',
	                { className: 'inner-right' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-12 col-sm-12' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'right-logo' },
	                      _react2.default.createElement(
	                        'a',
	                        { href: '/individual' },
	                        _react2.default.createElement('img', { src: '/assets/images/bewiselogo.png' })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'form',
	                      { onSubmit: this.handleSubmit },
	                      _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'row' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'col-lg-6 col-md-12' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'form-group' },
	                              _react2.default.createElement(
	                                'label',
	                                null,
	                                'ID Proof ',
	                                _react2.default.createElement(
	                                  'span',
	                                  { 'class': 'astrick' },
	                                  '*'
	                                ),
	                                uploaded > 0 && _react2.default.createElement(
	                                  'span',
	                                  { className: 'uploaded' },
	                                  _react2.default.createElement('i', { 'class': 'fa fa-check', 'aria-hidden': 'true' })
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'custom-select-drop dropdown' },
	                                _react2.default.createElement('input', {
	                                  type: 'file',
	                                  name: 'idproof',
	                                  onChange: this.handleFile,
	                                  className: 'form-control mar-btm',
	                                  accept: 'image/png, image/gif, image/jpeg,application/pdf'
	                                }),
	                                uploaded == 0 && this.validator.message('ID Proof File', this.state.idproof, 'required', { className: 'text-danger' })
	                              )
	                            )
	                          ),
	                          uploaded == 0 && _react2.default.createElement(
	                            'div',
	                            { className: 'col-lg-6 col-md-12' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'form-group' },
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'custom-select-drop dropdown' },
	                                _react2.default.createElement(
	                                  'button',
	                                  { className: 'btn orange-btn', type: 'submit', disabled: this.state.btnDisable },
	                                  'Upload'
	                                )
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'row' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'col-lg-6 col-md-12' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'form-group' },
	                              _react2.default.createElement(
	                                'label',
	                                null,
	                                'Highest Qualification ',
	                                _react2.default.createElement(
	                                  'span',
	                                  { 'class': 'astrick' },
	                                  '*'
	                                ),
	                                uploaded > 1 && _react2.default.createElement(
	                                  'span',
	                                  { className: 'uploaded' },
	                                  _react2.default.createElement('i', { 'class': 'fa fa-check', 'aria-hidden': 'true' })
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'custom-select-drop dropdown' },
	                                _react2.default.createElement('input', {
	                                  type: 'file',
	                                  name: 'qualification',
	                                  onChange: this.handleFile,
	                                  className: 'form-control mar-btm'
	                                }),
	                                uploaded == 1 && this.validator.message('Qualification File', this.state.qualification, 'required', { className: 'text-danger' })
	                              )
	                            )
	                          ),
	                          uploaded == 1 && _react2.default.createElement(
	                            'div',
	                            { className: 'col-lg-6 col-md-12' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'form-group' },
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'custom-select-drop dropdown' },
	                                _react2.default.createElement(
	                                  'button',
	                                  { className: 'btn orange-btn', type: 'submit', disabled: this.state.btnDisable },
	                                  'Uplaod'
	                                )
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'row' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'col-lg-6 col-md-12' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'form-group' },
	                              _react2.default.createElement(
	                                'label',
	                                null,
	                                'Your Photograph ',
	                                _react2.default.createElement(
	                                  'span',
	                                  { 'class': 'astrick' },
	                                  '*'
	                                ),
	                                uploaded > 2 && _react2.default.createElement(
	                                  'span',
	                                  { className: 'uploaded' },
	                                  _react2.default.createElement('i', { 'class': 'fa fa-check', 'aria-hidden': 'true' })
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'custom-select-drop dropdown' },
	                                _react2.default.createElement('input', {
	                                  type: 'file',
	                                  name: 'user_image',
	                                  onChange: this.handleFile,
	                                  className: 'form-control mar-btm'
	                                }),
	                                uploaded == 2 && this.validator.message('Photograph File', this.state.user_image, 'required', { className: 'text-danger' })
	                              )
	                            )
	                          ),
	                          uploaded == 2 && _react2.default.createElement(
	                            'div',
	                            { className: 'col-lg-6 col-md-12' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'form-group' },
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'custom-select-drop dropdown' },
	                                _react2.default.createElement(
	                                  'button',
	                                  { className: 'btn orange-btn', type: 'submit', disabled: this.state.btnDisable },
	                                  'Submit'
	                                )
	                              )
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return IndividualComplete;
	}(_react.Component);
	
	exports.default = IndividualComplete;

/***/ },
/* 881 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FetchCall = __webpack_require__(4);
	
	var _FetchCall2 = _interopRequireDefault(_FetchCall);
	
	var _reactRecaptcha = __webpack_require__(170);
	
	var _reactRecaptcha2 = _interopRequireDefault(_reactRecaptcha);
	
	var _constant = __webpack_require__(21);
	
	var _simpleReactValidator = __webpack_require__(28);
	
	var _simpleReactValidator2 = _interopRequireDefault(_simpleReactValidator);
	
	var _reactPlacesAutocomplete = __webpack_require__(132);
	
	var _reactPlacesAutocomplete2 = _interopRequireDefault(_reactPlacesAutocomplete);
	
	var _constant2 = __webpack_require__(21);
	
	var _Autocomplete = __webpack_require__(181);
	
	var _Autocomplete2 = _interopRequireDefault(_Autocomplete);
	
	var _TextField = __webpack_require__(176);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	var _reactGeocode = __webpack_require__(55);
	
	var _reactGeocode2 = _interopRequireDefault(_reactGeocode);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	_reactGeocode2.default.setApiKey("AIzaSyA9MtbfG_zlo64B2lqNMvigTBuXHkagKcE");
	_reactGeocode2.default.setLanguage("en");
	_reactGeocode2.default.setRegion("es");
	_reactGeocode2.default.enableDebug();
	
	var InstitutionalSignup = function (_Component) {
	  _inherits(InstitutionalSignup, _Component);
	
	  function InstitutionalSignup(props) {
	    var _this2 = this,
	        _this$state;
	
	    _classCallCheck(this, InstitutionalSignup);
	
	    var _this = _possibleConstructorReturn(this, (InstitutionalSignup.__proto__ || Object.getPrototypeOf(InstitutionalSignup)).call(this, props));
	
	    _this.validateMail = function (value, type) {
	      var name = type == 1 ? 'email_id' : 'user_name';
	      var type_name = type == 1 ? 'isEmailValid' : 'isUserValid';
	      var req = JSON.stringify(_defineProperty({}, name, value));
	      var res = (0, _FetchCall.emailExist)(req).then(function (res) {
	        if (res.status === 1) {
	          _this.setState(_defineProperty({}, type_name, false));
	        } else {
	          // return res.status;
	          _this.setState(_defineProperty({}, type_name, true));
	        }
	      });
	    };
	
	    _this.getSelect = function () {
	
	      var rows = '';
	      {
	        rows = _this.state.cateList.length > 0 && _this.state.cateList.map(function (item, i) {
	          return _react2.default.createElement(
	            'option',
	            { value: item.category_id, 'data-tokens': item.options.toString() },
	            item.label
	          );
	        });
	      }
	
	      return rows;
	    };
	
	    _this.getPlanList = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var insdata;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              insdata = JSON.stringify({
	                user_type: 2
	              });
	
	              try {
	                (0, _FetchCall.getPlan)(insdata).then(function (response) {
	                  var list = response.results;
	                  var plan_info = list.filter(function (o) {
	                    return o.id == _this.state.plan_id;
	                  });
	                  console.log('plan_info', plan_info);
	                  if (plan_info.length > 0) {
	                    _this.setState({
	                      package_list: response.results,
	                      plan_price: plan_info[0]['plan_month_disc'],
	                      plan_price_original: plan_info[0]['plan_month_original'],
	                      discount: plan_info[0]['discount'],
	                      discount_amount: plan_info[0]['discount_amount'],
	                      plan_info: plan_info[0]['plan_offer'],
	                      planinfo: plan_info[0]['about_words_count'] + 'Word Write up @ Site about institution' + 'Upto ' + plan_info[0]['image_count'] + ' Images for Uploads @ profile ' + '' + plan_info[0]['plan_access'] + ' access to portal'
	                    });
	                  }
	                  _this.setState({
	                    package_list: response.results
	                  });
	                });
	              } catch (error) {
	                _this.setState({ error: true });
	              }
	
	            case 2:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    }));
	
	    _this.recaptchaLoaded = function (e) {
	      console.log('Successfully loaded');
	    };
	
	    _this.verifyCallback = function (response) {
	      if (response) {
	        _this.setState({
	          isVerified: true
	        });
	      }
	    };
	
	    _this.handleChange = function (e) {
	      var propName = e.target.name;
	      _this.setState(_defineProperty({}, e.target.name, e.target.value));
	
	      if (propName == 'ind_agree') {
	        _this.setState({
	          agree_data: 'checked'
	
	        });
	      }
	      if (e.target.value !== '') {
	        _this.clearValidationErr(propName);
	      }
	      if (propName == 'ind_email_id') {
	        _this.validateMail(e.target.value, 1);
	      }
	      if (propName == 'ind_user_name') {
	        _this.validateMail(e.target.value, 2);
	      }
	      if (propName === 'user_type' && e.target.value === '1') {
	        _this.clearValidationErr('organisation_register_number');
	      }
	      if (propName === 'user_type' && e.target.value === '2') {
	        _this.setState({
	          is_org: true,
	          is_owner: false
	        });
	      } else if (propName === 'user_type' && e.target.value === '1') {
	        _this.setState({
	          is_org: false,
	          is_owner: false,
	          incharge_text: 'In-Charge',
	          designation: '',
	          incharge_name: ''
	        });
	      }
	
	      if (propName === 'plan_id') {
	
	        if (e.target.value == '0') {
	          _this.setState({
	            planinfo_option: false
	          });
	        } else {
	          var plan_id = e.target.value;
	          var plan_info = _this.state.package_list.filter(function (o) {
	            return o.id == plan_id;
	          });
	          var price = parseInt(plan_info[0]['plan_month_disc']);
	          _this.setState({
	            planinfo_option: true,
	            plan_price: price,
	            plan_price_original: plan_info[0]['plan_month_original'],
	            discount: plan_info[0]['discount'],
	            discount_amount: plan_info[0]['discount_amount'],
	            plan_info: plan_info[0]['plan_offer'],
	            planinfo: plan_info[0]['about_words_count'] + 'Word Write up @ Site about institution' + 'Upto ' + plan_info[0]['image_count'] + ' Images for Uploads @ profile ' + '' + plan_info[0]['plan_access'] + ' access to portal'
	          });
	        }
	      }
	    };
	
	    _this.handleClick = function (e) {
	      console.log(e.target.name);
	      var propName = e.target.name;
	      _this.setState(function (prevState) {
	        return _defineProperty({}, propName, !prevState[propName]);
	      });
	      console.log('sad', e.target.value);
	      if (propName === 'is_owner' && e.target.value === 'false') {
	        _this.setState({
	          incharge_text: '',
	          designation: ''
	        });
	      } else if (propName === 'is_owner' && e.target.value === 'true') {
	        _this.setState({
	          incharge_text: 'In-Charge '
	        });
	      }
	    };
	
	    _this.handleSelect = function (e) {
	      var propName = e.target.name;
	      var value = [].concat(_toConsumableArray(e.target.selectedOptions)).map(function (item) {
	        return item.value;
	      });
	      _this.setState(_defineProperty({}, propName, value));
	      _this.clearValidationErr(propName);
	      if (propName === 'ind_social_link' && value[0] === 'fb') {
	        _this.setState({
	          socialPlace: 'Facebook'
	        });
	      } else if (propName === 'ind_social_link' && value[0] === 'twt') {
	        _this.setState({
	          socialPlace: 'Twitter'
	        });
	      } else if (propName === 'ind_social_link' && value[0] === 'lnkin') {
	        _this.setState({
	          socialPlace: 'LinkedIn'
	        });
	      } else if (propName === 'ind_social_link' && value[0] === 'insta') {
	        _this.setState({
	          socialPlace: 'Instagram'
	        });
	      }
	
	      if (propName === 'category_id') {
	        var categoryid = e.target.value;
	        _this.setState({
	          sub_category_id: []
	        });
	        _this.Sub_Cat_type(categoryid);
	      }
	    };
	
	    _this.handleplaceChangeInd = function (ind_address) {
	      _this.setState({ ind_address: ind_address, ind_pin_code: '', ind_state_name: '', ind_location: '' });
	      _this.clearValidationErr('ind_address');
	    };
	
	    _this.handleplaceSelectInd = function (ind_address) {
	      _this.setState({ ind_address: ind_address });
	      _this.clearValidationErr('ind_address');
	      // this.Geocode_location();
	      _reactGeocode2.default.fromAddress(ind_address).then(function (response) {
	
	        var geolen = response.results[0].address_components.length;
	        var pincode = '';
	        var state = '';
	        var city = '';
	        for (var i = 0; i < geolen; i++) {
	
	          if (response.results[0].address_components[i].types[0] == "postal_code") {
	            pincode = response.results[0].address_components[i].short_name;
	          }
	          if (response.results[0].address_components[i].types[0] == "administrative_area_level_1") {
	            state = response.results[0].address_components[i].long_name;
	          }
	          if (response.results[0].address_components[i].types[0] == "locality") {
	            city = response.results[0].address_components[i].long_name;
	          }
	        }
	
	        _this.get_ind_location(pincode, state, city);
	      }, function (error) {
	        console.error(error);
	      });
	    };
	
	    _this.handlecontactdetails = function () {
	      _this.setState({ register_step1: false, register_step2: true });
	    };
	
	    _this.handlePaymentMode = function (e) {
	      _this.setState({
	        paymentMode: e.target.value
	      });
	    };
	
	    _this.handlecontactdetails = function (e) {
	      _this.setState({
	        register_step2: true, register_step1: false
	      });
	    };
	
	    _this.handleFile = function (e) {
	      _this.setState(_defineProperty({}, e.target.name, e.target.files[0]));
	      _this.clearValidationErr(e.target.name);
	    };
	
	    _this.getRender = function (params) {
	
	      return _react2.default.createElement(_TextField2.default, Object.assign({}, params, {
	        variant: 'outlined',
	        placeholder: 'Type Category Here'
	      }));
	    };
	
	    _this.onTagsChange = function (event, values) {
	
	      var list = _this.state.cateList;
	      list.map(function (item, i) {
	        item.options = item.options.flat(Infinity);
	      });
	      var finalArr = [];
	      list.map(function (item, i) {
	        var intersection = item.options.filter(function (x) {
	          return values.includes(x);
	        });
	        if (intersection.length > 0) {
	          finalArr.push(item.category_id);
	        }
	      });
	
	      _this.setState({
	        ind_organisation_type: finalArr,
	        sub_category: values
	      });
	    };
	
	    _this.isPasswordValid = function () {
	      var password = _this.state.ind_password;
	      var paswd = /^(?=.*\d)(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,15}$/;
	      if (password.match(paswd)) {
	        return true;
	      } else {
	        _this.showValidationErr("ind_password", "Min of 8 characters in length – One Capital Letter, One Number, One Character");
	        return false;
	      }
	    };
	
	    _this.isEmailValid = function () {
	      var email = _this.state.ind_email_id;
	      var reg = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
	
	      if (reg.test(email) !== true) {
	        _this.showValidationErr("ind_email_id", "Please Enter Valid Email id");
	        return false;
	      } else {
	        return true;
	      }
	    };
	
	    _this.handleVerifyUser = function (e) {
	
	      var ins = '';
	
	      ins = JSON.stringify({
	        user_id: _this.state.userid,
	        otp: _this.state.otp
	      });
	
	      (0, _FetchCall.verifyVendor)(ins).then(function (res) {
	
	        if (res.status === 1) {
	
	          _this.setState({ otpverified: true });
	        }
	      });
	    };
	
	    _this.handleSubmit = function (e) {
	      e.preventDefault();
	      if (_this.validator.allValid()) {
	        var ins = '';
	        _this.setState({
	          btnDisable: true
	        });
	        ins = JSON.stringify({
	          user_type: 2,
	          social_link: _this.state.social_link,
	          social_media_link: _this.state.ind_social_media_link,
	          sub_category: _this.state.sub_category_id,
	          user_paytype: 2,
	          first_name: _this.state.ind_first_name,
	          last_name: _this.state.ind_last_name,
	          address: _this.state.ind_address,
	          pin_code: _this.state.ind_pin_code,
	          state: _this.state.ind_state_name,
	          location: _this.state.ind_location,
	          email_id: _this.state.ind_email_id,
	          phone_number: _this.state.ind_phone_number,
	          landline_number: _this.state.ind_landline_number,
	          category_id: _this.state.category_id,
	          user_name: _this.state.ind_user_name,
	          password: _this.state.ind_password,
	          cpassword: _this.state.ind_cpassword,
	          agree: _this.state.ind_agree,
	          id_proof: _this.state.id_proof,
	          id_proof_no: _this.state.id_proof_no,
	          qualification: _this.state.qualification,
	          othercomments: _this.state.othercomments,
	          main_category_id: _this.state.category_id
	        });
	
	        var toastr = '';
	        if (!_this.state.isVerified) {
	
	          alert("Please verify the checkbox!");
	
	          return false;
	        }
	        (0, _FetchCall.registerPartnerInd)(ins).then(function (res) {
	
	          if (res.status === 1) {
	
	            _this.setState({
	              signup_form: false,
	              showOTPform: true,
	              userid: res.userid
	            });
	            /*
	            alert("Thanks for partnering with BeWise.Your request has been submitted. A confirmation mail has been sent your mail");
	            setTimeout(function () {
	              window.location.replace('/login');
	            }, 2000);
	             */
	          } else {
	            _this.setState({
	              btnDisable: false
	            });
	            var er = res.errors[0].msg;
	            alert(window.toastr.error);
	          }
	        });
	      } else {
	        _this.validator.showMessages();
	        _this.forceUpdate();
	      }
	    };
	
	    _this.state = (_this$state = {
	      btnDisable: false,
	      signup_form: true,
	      ins_first_next: false,
	      ind_second_next: false,
	      register_step2: false,
	      paymentMode: '',
	      organisation_name: '',
	      user_type: '1',
	      user_name: '',
	      organisation_register_number: '',
	      institution_contact_number: '',
	      institution_email_address: '',
	      email_id: '',
	      phone_number: '',
	      organisation_type: '',
	      state: '',
	      location: '',
	      pin_code: '',
	      address: '',
	      password: '',
	      cpassword: '',
	      cheque_image: '',
	      package_type: '',
	      payment_mode: '1',
	      errors: [],
	      address2: 'Test',
	      org_type_list: [],
	      social_media_link: '',
	      is_org: false,
	      is_owner: false,
	      incharge_name: '',
	      incharge_text: 'In-Charge ',
	      social_link: '',
	      socialPlace: 'LinkedIn',
	      agree: '',
	      designation: '',
	      cateList: [],
	      autoSuggCate: [],
	      state_name: '',
	      ins_first_name: '',
	      ins_last_name: '',
	      owner_type: ''
	    }, _defineProperty(_this$state, 'designation', ''), _defineProperty(_this$state, 'email_address', ''), _defineProperty(_this$state, 'phone_number', ''), _defineProperty(_this$state, 'landline_number', ''), _defineProperty(_this$state, 'ins_user_name', ''), _defineProperty(_this$state, 'ins_password', ''), _defineProperty(_this$state, 'ins_cpassword', ''), _defineProperty(_this$state, 'package_list', []), _defineProperty(_this$state, 'plan_id', localStorage.getItem("plan_id") ? localStorage.getItem("plan_id") : '0'), _defineProperty(_this$state, 'ind_first_name', ''), _defineProperty(_this$state, 'ind_last_name', ''), _defineProperty(_this$state, 'ind_location', ''), _defineProperty(_this$state, 'ind_state_name', ''), _defineProperty(_this$state, 'ind_address', ''), _defineProperty(_this$state, 'ind_pin_code', ''), _defineProperty(_this$state, 'ind_email_id', ''), _defineProperty(_this$state, 'ind_phone_number', ''), _defineProperty(_this$state, 'ind_landline_number', ''), _defineProperty(_this$state, 'ind_social_link', ''), _defineProperty(_this$state, 'ind_social_media_link', ''), _defineProperty(_this$state, 'ind_organisation_type', ''), _defineProperty(_this$state, 'ind_user_name', ''), _defineProperty(_this$state, 'ind_password', ''), _defineProperty(_this$state, 'ind_cpassword', ''), _defineProperty(_this$state, 'ind_agree', ''), _defineProperty(_this$state, 'planinfo_option', true), _defineProperty(_this$state, 'category_List', []), _defineProperty(_this$state, 'categorySubTypeList', []), _defineProperty(_this$state, 'category_id', []), _defineProperty(_this$state, 'sub_category_id', []), _defineProperty(_this$state, 'agree_data', ''), _defineProperty(_this$state, 'plan_price', 0), _defineProperty(_this$state, 'isEmailValid', true), _defineProperty(_this$state, 'isUserValid', true), _defineProperty(_this$state, 'id_proof', 0), _defineProperty(_this$state, 'id_proof_no', ''), _defineProperty(_this$state, 'qualification', 0), _defineProperty(_this$state, 'othercomments', ''), _defineProperty(_this$state, 'isVerified', false), _defineProperty(_this$state, 'id_proof_list', []), _defineProperty(_this$state, 'qualification_list', []), _defineProperty(_this$state, 'location_list', []), _defineProperty(_this$state, 'showPassword', false), _defineProperty(_this$state, 'showCPassword', false), _defineProperty(_this$state, 'showOTPform', false), _defineProperty(_this$state, 'otp', ''), _defineProperty(_this$state, 'userid', ''), _defineProperty(_this$state, 'otpverified', false), _this$state);
	    _this.recaptchaLoaded = _this.recaptchaLoaded.bind(_this);
	    _this.verifyCallback = _this.verifyCallback.bind(_this);
	    _this.orgList();
	    _this.getLocation();
	    _this.cateList();
	    _this.idProofList();
	    _this.qualificationList();
	    _this.categoryList();
	    // $('.selectpicker').selectpicker('refresh');
	    _this.validator = new _simpleReactValidator2.default({
	      validators: {
	        password_custome: { // name the rule
	          message: 'The :attribute must be a Min of 8 characters in length - One Capital Letter, One Number, One Character.',
	          rule: function rule(val, params, validator) {
	            return validator.helpers.testRegex(val, /^(?=.*\d)(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,15}$/) && params.indexOf(val) === -1;
	          },
	          messageReplace: function messageReplace(message, params) {
	            return message.replace(':values', _this.helpers.toSentence(params));
	          }, // optional
	          required: true // optional
	        },
	        confirmpassword: { // name the rule
	          message: 'The :attribute must be Same as Password.',
	          rule: function rule(val, params, validator) {
	            if (val != _this.state.ind_password) {
	              return false;
	            }
	          },
	          messageReplace: function messageReplace(message, params) {
	            return message.replace(':values', _this.helpers.toSentence(params));
	          }, // optional
	          required: true // optional
	        },
	        emailExist: { // name the rule
	          message: 'The :attribute Already Exist.',
	          rule: function rule(val, params, validator) {
	            return _this.state.isEmailValid;
	          },
	          messageReplace: function messageReplace(message, params) {
	            return message.replace(':values', _this.helpers.toSentence(params));
	          }, // optional
	          required: true // optional
	        },
	        userExist: { // name the rule
	          message: 'The :attribute Already Exist.',
	          rule: function rule(val, params, validator) {
	            return _this.state.isUserValid;
	          },
	          messageReplace: function messageReplace(message, params) {
	            return message.replace(':values', _this.helpers.toSentence(params));
	          }, // optional
	          required: true // optional
	        },
	        checkMobile: _constant.MOBILE_REGEX,
	        checkUrl: _constant.URL_REGEX
	      }
	    });
	
	    _this.handleSubmit = _this.handleSubmit.bind(_this);
	
	    return _this;
	  }
	
	  _createClass(InstitutionalSignup, [{
	    key: 'cateList',
	    value: function () {
	      var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	        var _this3 = this;
	
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                (0, _FetchCall.getCatDrop)(0).then(function (res) {
	                  if (res.status === 1) {
	                    var list = res.results;
	                    list.map(function (item, i) {
	                      item.options = item.options.flat(Infinity);
	                    });
	                    var fiArr = [];
	                    list.map(function (item, i) {
	                      fiArr.push(item.options);
	                    });
	                    fiArr = fiArr.flat(Infinity);
	                    _this3.setState({
	                      cateList: res.results,
	                      autoSuggCate: fiArr
	                    });
	                  }
	                });
	
	              case 1:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this);
	      }));
	
	      function cateList() {
	        return _ref3.apply(this, arguments);
	      }
	
	      return cateList;
	    }()
	  }, {
	    key: 'getLocation',
	    value: function () {
	      var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	        var _this4 = this;
	
	        var req;
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                req = JSON.stringify({
	                  url: 'getLocation'
	                });
	
	                (0, _FetchCall.getLocation)(req).then(function (res) {
	                  if (res.status === 1) {
	                    _this4.setState({
	                      location_list: res.results
	                    });
	                  }
	                });
	
	              case 2:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, this);
	      }));
	
	      function getLocation() {
	        return _ref4.apply(this, arguments);
	      }
	
	      return getLocation;
	    }()
	  }, {
	    key: 'categoryList',
	    value: function () {
	      var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee4() {
	        var response;
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                _context4.next = 2;
	                return _FetchCall2.default.getSubCategory('0');
	
	              case 2:
	                response = _context4.sent;
	
	                console.log('AgeList', response);
	                if (response) {
	                  this.setState({ category_List: response.results });
	                }
	
	              case 5:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, this);
	      }));
	
	      function categoryList() {
	        return _ref5.apply(this, arguments);
	      }
	
	      return categoryList;
	    }()
	  }, {
	    key: 'idProofList',
	    value: function () {
	      var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee5() {
	        var response;
	        return _regenerator2.default.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                _context5.next = 2;
	                return _FetchCall2.default.getSchoolListDatas('id_proof');
	
	              case 2:
	                response = _context5.sent;
	
	                console.log('id_proof_list', response);
	                if (response) {
	                  this.setState({ id_proof_list: response.results });
	                }
	
	              case 5:
	              case 'end':
	                return _context5.stop();
	            }
	          }
	        }, _callee5, this);
	      }));
	
	      function idProofList() {
	        return _ref6.apply(this, arguments);
	      }
	
	      return idProofList;
	    }()
	  }, {
	    key: 'qualificationList',
	    value: function () {
	      var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee6() {
	        var response;
	        return _regenerator2.default.wrap(function _callee6$(_context6) {
	          while (1) {
	            switch (_context6.prev = _context6.next) {
	              case 0:
	                _context6.next = 2;
	                return _FetchCall2.default.getSchoolListDatas('qualification');
	
	              case 2:
	                response = _context6.sent;
	
	                console.log('qualification_list', response);
	                if (response) {
	                  this.setState({ qualification_list: response.results });
	                }
	
	              case 5:
	              case 'end':
	                return _context6.stop();
	            }
	          }
	        }, _callee6, this);
	      }));
	
	      function qualificationList() {
	        return _ref7.apply(this, arguments);
	      }
	
	      return qualificationList;
	    }()
	  }, {
	    key: 'showValidationErr',
	    value: function showValidationErr(elm, msg) {
	      this.setState(function (prevState) {
	        return { errors: [].concat(_toConsumableArray(prevState.errors), [{ elm: elm, msg: msg }]) };
	      });
	    }
	  }, {
	    key: 'clearValidationErr',
	    value: function clearValidationErr(elm) {
	      var _this5 = this;
	
	      this.setState(function (prevState) {
	        var newArr = [];
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = _this5.state.errors[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var err = _step.value;
	
	            if (elm !== err.elm) {
	              newArr.push(err);
	            }
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	
	        return { errors: newArr };
	      });
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      window.jQuery('.selectpicker').selectpicker('refresh');
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getPlanList();
	    }
	  }, {
	    key: 'Sub_Cat_type',
	    value: function () {
	      var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(id) {
	        var response;
	        return _regenerator2.default.wrap(function _callee7$(_context7) {
	          while (1) {
	            switch (_context7.prev = _context7.next) {
	              case 0:
	                if (!id) {
	                  _context7.next = 7;
	                  break;
	                }
	
	                _context7.next = 3;
	                return _FetchCall2.default.getSubCategory(id);
	
	              case 3:
	                response = _context7.sent;
	
	                if (response.status == 1) {
	                  this.setState({ categorySubTypeList: response.results, cat_type: true, cat_type1: false, cat_type2: false });
	                } else {
	                  this.setState({
	                    categorySubTypeList: []
	                  });
	                }
	                _context7.next = 8;
	                break;
	
	              case 7:
	                this.setState({
	                  categorySubTypeList: []
	                });
	
	              case 8:
	              case 'end':
	                return _context7.stop();
	            }
	          }
	        }, _callee7, this);
	      }));
	
	      function Sub_Cat_type(_x) {
	        return _ref8.apply(this, arguments);
	      }
	
	      return Sub_Cat_type;
	    }()
	  }, {
	    key: 'handleShowPassword',
	    value: function handleShowPassword() {
	      this.setState(function (prevState) {
	        return {
	          showPassword: !prevState.showPassword
	        };
	      });
	    }
	  }, {
	    key: 'handleShowCPassword',
	    value: function handleShowCPassword() {
	      this.setState(function (prevState) {
	        return {
	          showCPassword: !prevState.showCPassword
	        };
	      });
	    }
	  }, {
	    key: 'orgList',
	    value: function () {
	      var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee8() {
	        var response;
	        return _regenerator2.default.wrap(function _callee8$(_context8) {
	          while (1) {
	            switch (_context8.prev = _context8.next) {
	              case 0:
	                _context8.next = 2;
	                return _FetchCall2.default.getSubCategory('0');
	
	              case 2:
	                response = _context8.sent;
	
	                console.log('boeList', response);
	                if (response) {
	                  this.setState({ org_type_list: response.results });
	                }
	
	              case 5:
	              case 'end':
	                return _context8.stop();
	            }
	          }
	        }, _callee8, this);
	      }));
	
	      function orgList() {
	        return _ref9.apply(this, arguments);
	      }
	
	      return orgList;
	    }()
	  }, {
	    key: 'Geocode_location',
	    value: function Geocode_location() {
	      var _this6 = this;
	
	      _reactGeocode2.default.fromAddress(this.state.address).then(function (response) {
	
	        var geolen = response.results[0].address_components.length;
	        var pincode = '';
	        var state = '';
	        var city = '';
	        for (var i = 0; i < geolen; i++) {
	
	          if (response.results[0].address_components[i].types[0] == "postal_code") {
	            pincode = response.results[0].address_components[i].short_name;
	          }
	          if (response.results[0].address_components[i].types[0] == "administrative_area_level_1") {
	            state = response.results[0].address_components[i].long_name;
	          }
	          if (response.results[0].address_components[i].types[0] == "administrative_area_level_2") {
	            city = response.results[0].address_components[i].long_name;
	          }
	        }
	
	        _this6.get_location(pincode, state, city);
	      }, function (error) {
	        console.error(error);
	      });
	    }
	  }, {
	    key: 'get_location',
	    value: function get_location(pincode, state, city) {
	      console.log(pincode, state, city);
	      this.setState({
	        pin_code: pincode,
	        state: state,
	        location: city
	      });
	    }
	  }, {
	    key: 'get_ind_location',
	    value: function get_ind_location(pincode, state, city) {
	      console.log(pincode, state, city);
	      this.setState({
	        ind_pin_code: pincode,
	        ind_state_name: state,
	        ind_location: city
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this7 = this;
	
	      this.validator.purgeFields();
	      console.log('ind_location', this.state.ind_location);
	      return _react2.default.createElement(
	        'div',
	        { className: 'container-fluid' },
	        _react2.default.createElement(
	          'form',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-6 col-sm-6 sign-bg-login   hidden-xs' },
	              _react2.default.createElement('div', { className: 'shadow-bg' }),
	              _react2.default.createElement(
	                'h1',
	                null,
	                'Welcome to',
	                _react2.default.createElement('br', null),
	                ' BeWise Partner Program'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-6 col-sm-6 signup-right' },
	              _react2.default.createElement(
	                'div',
	                { className: 'inner-right' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-12 col-sm-12' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'right-logo' },
	                      _react2.default.createElement(
	                        'a',
	                        { href: '/individual' },
	                        _react2.default.createElement('img', { src: 'assets/images/bewiselogo.png' })
	                      )
	                    ),
	                    this.state.signup_form === false && this.state.showOTPform === true ? _react2.default.createElement(
	                      'div',
	                      null,
	                      _react2.default.createElement(
	                        'h1',
	                        null,
	                        'Verification'
	                      ),
	                      this.state.otpverified && _react2.default.createElement(
	                        'div',
	                        { 'class': 'aftervrying alert alert-success' },
	                        'Thank you for registering with us and your account has been verified successfully. Please click ',
	                        _react2.default.createElement(
	                          'a',
	                          { href: '/login' },
	                          'here'
	                        ),
	                        ' to login and become bewise partner'
	                      ),
	                      !this.state.otpverified && _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'smalltext' },
	                          'We have sent you an OTP to your registering email id successfully'
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'row' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'col-lg-6 col-md-12' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'form-group' },
	                              _react2.default.createElement(
	                                'label',
	                                null,
	                                'OTP',
	                                _react2.default.createElement(
	                                  'span',
	                                  { className: 'astrick' },
	                                  '(you may have received in your inbox or junk or spam)'
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'custom-select-drop dropdown' },
	                                _react2.default.createElement('input', { type: 'text', name: 'otp',
	                                  value: this.state.otp,
	                                  placeholder: 'OTP',
	                                  onChange: this.handleChange,
	                                  className: 'form-control' }),
	                                this.validator.message('Verification OTP', this.state.otp, 'required', { className: 'text-danger' })
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-12 col-sm-12 text-right' },
	                            _react2.default.createElement(
	                              'button',
	                              { type: 'button', className: 'btn orange-btn', onClick: this.handleVerifyUser },
	                              'Verify'
	                            )
	                          )
	                        )
	                      )
	                    ) : '',
	                    this.state.signup_form === true && this.state.showOTPform === false ? _react2.default.createElement(
	                      'div',
	                      null,
	                      _react2.default.createElement(
	                        'form',
	                        { onSubmit: this.handleSubmit },
	                        _react2.default.createElement(
	                          'h1',
	                          null,
	                          'Individual Details'
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'row' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'col-lg-6 col-md-12' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'form-group' },
	                              _react2.default.createElement(
	                                'label',
	                                null,
	                                'Name ',
	                                _react2.default.createElement('i', { 'class': 'fa fa-info-circle', 'data-toggle': 'tooltip', title: 'Pease make sure only alphabets(no space)', 'aria-hidden': 'true' }),
	                                ' ',
	                                _react2.default.createElement(
	                                  'span',
	                                  { 'class': 'astrick' },
	                                  '*'
	                                )
	                              ),
	                              _react2.default.createElement('input', {
	                                type: 'text',
	                                placeholder: 'Name',
	                                className: 'form-control',
	                                name: 'ind_first_name',
	                                onChange: this.handleChange,
	                                value: this.state.ind_first_name
	                              }),
	                              this.validator.message('Name', this.state.ind_first_name, 'required', { className: 'text-danger' })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'row' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-12 col-md-12' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'form-group' },
	                              _react2.default.createElement(
	                                'label',
	                                null,
	                                'Address',
	                                _react2.default.createElement(
	                                  'span',
	                                  { 'class': 'astrick' },
	                                  '*'
	                                )
	                              ),
	                              _react2.default.createElement(
	                                _reactPlacesAutocomplete2.default,
	                                {
	                                  value: this.state.ind_address,
	                                  className: 'form-control',
	                                  onChange: this.handleplaceChangeInd,
	                                  onSelect: this.handleplaceSelectInd
	                                },
	                                function (_ref10) {
	                                  var getInputProps = _ref10.getInputProps,
	                                      suggestions = _ref10.suggestions,
	                                      getSuggestionItemProps = _ref10.getSuggestionItemProps,
	                                      loading = _ref10.loading;
	                                  return _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    _react2.default.createElement('input', Object.assign({}, getInputProps({
	                                      placeholder: 'Search Places ...',
	                                      className: 'form-control'
	
	                                    }), {
	                                      value: _this7.state.ind_address
	                                    })),
	                                    _react2.default.createElement(
	                                      'div',
	                                      { className: 'autocomplete-dropdown-container',
	                                        style: { position: "absolute", zIndex: "999" } },
	                                      loading && _react2.default.createElement(
	                                        'div',
	                                        null,
	                                        'Loading...'
	                                      ),
	                                      suggestions.map(function (suggestion) {
	                                        var className = suggestion.active ? 'suggestion-item--active' : 'suggestion-item';
	                                        // inline style for demonstration purpose
	                                        var style = suggestion.active ? { backgroundColor: '#fafafa', cursor: 'pointer' } : { backgroundColor: '#ffffff', cursor: 'pointer' };
	                                        return _react2.default.createElement(
	                                          'div',
	                                          getSuggestionItemProps(suggestion, {
	                                            className: className,
	                                            style: style
	                                          }),
	                                          _react2.default.createElement(
	                                            'span',
	                                            null,
	                                            suggestion.description
	                                          )
	                                        );
	                                      })
	                                    )
	                                  );
	                                }
	                              ),
	                              this.validator.message('Address', this.state.ind_address, 'required', { className: 'text-danger' })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'row' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'col-lg-6 col-md-12' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'form-group' },
	                              _react2.default.createElement(
	                                'label',
	                                null,
	                                'City',
	                                _react2.default.createElement(
	                                  'span',
	                                  { 'class': 'astrick' },
	                                  '*'
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'custom-select-drop dropdown' },
	                                _react2.default.createElement(
	                                  'select',
	                                  {
	                                    onChange: this.handleChange,
	                                    name: 'ind_location',
	                                    value: this.state.ind_location,
	                                    className: 'form-control selectpicker', title: 'Select City' },
	                                  this.state.location_list.map(function (item, i) {
	                                    return _react2.default.createElement(
	                                      'option',
	                                      null,
	                                      item.location
	                                    );
	                                  })
	                                ),
	                                this.validator.message('City', this.state.ind_location, 'required', { className: 'text-danger' })
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'col-lg-6 col-md-12' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'form-group' },
	                              _react2.default.createElement(
	                                'label',
	                                null,
	                                'State',
	                                _react2.default.createElement(
	                                  'span',
	                                  { 'class': 'astrick' },
	                                  '*'
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'custom-select-drop dropdown' },
	                                _react2.default.createElement('input', { type: 'text', name: 'ind_state_name',
	                                  value: this.state.ind_state_name,
	                                  placeholder: 'State',
	                                  onChange: this.handleChange,
	                                  className: 'form-control' }),
	                                this.validator.message('State', this.state.ind_state_name, 'required|alpha_space', { className: 'text-danger' })
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'row' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'col-lg-6 col-md-12' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'form-group' },
	                              _react2.default.createElement(
	                                'label',
	                                null,
	                                'Pincode',
	                                _react2.default.createElement(
	                                  'span',
	                                  { 'class': 'astrick' },
	                                  '*'
	                                )
	                              ),
	                              _react2.default.createElement('input', { type: 'number', name: 'ind_pin_code',
	                                className: 'form-control',
	                                placeholder: 'Pincode',
	                                value: this.state.ind_pin_code,
	                                onChange: this.handleChange
	                              }),
	                              this.validator.message('Pincode', this.state.ind_pin_code, 'required|numeric|min:1,num', { className: 'text-danger' })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'col-lg-6 col-md-12' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'form-group' },
	                              _react2.default.createElement(
	                                'label',
	                                null,
	                                'Email Address',
	                                _react2.default.createElement(
	                                  'span',
	                                  { 'class': 'astrick' },
	                                  '*'
	                                )
	                              ),
	                              _react2.default.createElement('input', { type: 'email', name: 'ind_email_id',
	                                value: this.state.ind_email_id,
	                                placeholder: 'Email Address',
	                                onChange: this.handleChange, className: 'form-control' }),
	                              this.validator.message('Email Address', this.state.ind_email_id, 'required|emailExist|email', { className: 'text-danger' })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement('div', { className: 'col-md-12 col-sm-12' }),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'row' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'col-lg-6 col-md-12' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'form-group' },
	                              _react2.default.createElement(
	                                'label',
	                                null,
	                                'Mobile Number',
	                                _react2.default.createElement(
	                                  'span',
	                                  { 'class': 'astrick' },
	                                  '*'
	                                )
	                              ),
	                              _react2.default.createElement('input', { type: 'number', name: 'ind_phone_number',
	                                placeholder: 'Mobile Number',
	                                value: this.state.ind_phone_number,
	                                onChange: this.handleChange, className: 'form-control' }),
	                              this.validator.message('Mobile Number', this.state.ind_phone_number, 'required|checkMobile|min:10|max:60', { className: 'text-danger' })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'col-lg-6 col-md-12' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'form-group' },
	                              _react2.default.createElement(
	                                'label',
	                                null,
	                                'Landline Number'
	                              ),
	                              _react2.default.createElement('input', { type: 'number', name: 'ind_landline_number',
	                                placeholder: 'Landline Number',
	                                value: this.state.ind_landline_number,
	                                onChange: this.handleChange, className: 'form-control' }),
	                              this.validator.message('Landline Number', this.state.ind_landline_number, 'numeric', { className: 'text-danger' })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'row' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'col-lg-6 col-md-12' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'form-group  min-h-unset' },
	                              _react2.default.createElement(
	                                'label',
	                                null,
	                                'Category',
	                                _react2.default.createElement(
	                                  'span',
	                                  { 'class': 'astrick' },
	                                  '*'
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'select',
	                                {
	                                  onChange: this.handleSelect,
	                                  name: 'category_id',
	                                  value: this.state.category_id.toString(),
	                                  className: 'form-control', title: 'Select Category' },
	                                _react2.default.createElement(
	                                  'option',
	                                  { value: '' },
	                                  'Select'
	                                ),
	                                this.state.category_List.length > 0 && this.state.category_List.map(function (item, i) {
	                                  if (item.category_id > 3) {
	                                    return _react2.default.createElement(
	                                      'option',
	                                      { value: item.category_id },
	                                      item.category_name
	                                    );
	                                  }
	                                })
	                              ),
	                              this.validator.message('Category', this.state.category_id, 'required', { className: 'text-danger' })
	                            )
	                          ),
	                          !this.state.category_id.includes('4') && _react2.default.createElement(
	                            'div',
	                            { className: 'col-lg-6 col-md-12' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'form-group' },
	                              _react2.default.createElement(
	                                'label',
	                                null,
	                                'Sub Category',
	                                _react2.default.createElement(
	                                  'span',
	                                  { 'class': 'astrick' },
	                                  '*'
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'select',
	                                {
	                                  onChange: this.handleSelect,
	                                  name: 'sub_category_id',
	                                  value: this.state.sub_category_id,
	                                  className: 'form-control selectpicker',
	                                  multiple: true, title: 'Select' },
	                                this.state.categorySubTypeList.length > 0 && this.state.categorySubTypeList.map(function (item, i) {
	                                  return _react2.default.createElement(
	                                    'option',
	                                    { value: item.category_id, key: i },
	                                    item.category_name
	                                  );
	                                })
	                              ),
	                              this.validator.message('Sub Category', this.state.sub_category_id, 'required', { className: 'text-danger' })
	                            )
	                          ),
	                          this.state.category_id.includes('4') && _react2.default.createElement(
	                            'div',
	                            { className: 'col-lg-6 col-md-12' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'form-group' },
	                              _react2.default.createElement(
	                                'label',
	                                null,
	                                'Sub Category',
	                                _react2.default.createElement(
	                                  'span',
	                                  { 'class': 'astrick' },
	                                  '*'
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'select',
	                                {
	                                  onChange: this.handleSelect,
	                                  name: 'sub_category_id',
	                                  value: this.state.sub_category_id.toString(),
	                                  className: 'form-control',
	                                  title: 'Select' },
	                                _react2.default.createElement(
	                                  'option',
	                                  { value: '' },
	                                  'Select'
	                                ),
	                                this.state.categorySubTypeList.length > 0 && this.state.categorySubTypeList.map(function (item, i) {
	                                  return _react2.default.createElement(
	                                    'option',
	                                    { value: item.category_id, key: i },
	                                    item.category_name
	                                  );
	                                })
	                              ),
	                              this.validator.message('Sub Category', this.state.sub_category_id, 'required', { className: 'text-danger' })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'row' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'col-lg-6 col-md-12' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'form-group' },
	                              _react2.default.createElement(
	                                'label',
	                                null,
	                                'Highest Qualification ',
	                                _react2.default.createElement('i', { 'class': 'fa fa-info-circle', 'data-toggle': 'tooltip', title: 'Certificate upload required only upon confirmation as partner @BeWise', 'aria-hidden': 'true' }),
	                                ' ',
	                                _react2.default.createElement(
	                                  'span',
	                                  { 'class': 'astrick' },
	                                  '*'
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'select',
	                                {
	                                  className: 'form-control selectpicker',
	                                  title: 'Select qualification', name: 'qualification',
	                                  value: this.state.qualification,
	                                  onChange: this.handleSelect },
	                                this.state.qualification_list && this.state.qualification_list.map(function (item, i) {
	                                  return _react2.default.createElement(
	                                    'option',
	                                    { value: item.id },
	                                    item.name
	                                  );
	                                })
	                              ),
	                              this.validator.message('Select Qualification', this.state.qualification, 'required', { className: 'text-danger' })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'row' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'col-lg-12 col-md-12' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'form-group' },
	                              _react2.default.createElement(
	                                'label',
	                                null,
	                                'Other Comments/Information'
	                              ),
	                              _react2.default.createElement('textarea', { type: 'text', name: 'othercomments', value: this.state.othercomments,
	                                onChange: this.handleChange, className: 'form-control' }),
	                              this.validator.message('Other Comments/Information', this.state.othercomments, '', { className: 'text-danger' })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'row mar-top' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-12 col-sm-12' },
	                            _react2.default.createElement(
	                              'h1',
	                              null,
	                              'Login Details'
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'row' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'col-lg-6 col-md-12' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'form-group' },
	                              _react2.default.createElement(
	                                'label',
	                                null,
	                                'User Name',
	                                _react2.default.createElement(
	                                  'span',
	                                  { 'class': 'astrick' },
	                                  '*'
	                                )
	                              ),
	                              _react2.default.createElement('input', { type: 'text', name: 'ind_user_name', value: this.state.ind_user_name,
	                                placeholder: 'User Name',
	                                onChange: this.handleChange, className: 'form-control' }),
	                              this.validator.message('User Name', this.state.ind_user_name, 'required|alpha_num|userExist', { className: 'text-danger' })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement('div', { className: 'col-md-12 col-sm-12' }),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'row' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'col-lg-6 col-md-12' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'form-group' },
	                              _react2.default.createElement(
	                                'label',
	                                null,
	                                'Password',
	                                _react2.default.createElement(
	                                  'span',
	                                  { 'class': 'astrick' },
	                                  '*'
	                                )
	                              ),
	                              _react2.default.createElement('input', { id: 'password-field', type: this.state.showPassword ? 'text' : 'password', name: 'ind_password',
	                                placeholder: 'Password',
	                                value: this.state.ind_password,
	                                onChange: this.handleChange,
	                                className: 'form-control' }),
	                              _react2.default.createElement('span', {
	                                toggle: '#password-field',
	                                className: this.state.showPassword ? 'fa fa-fw fa-eye-slash field-icon' : 'fa fa-fw fa-eye field-icon',
	                                onClick: function onClick() {
	                                  _this7.handleShowPassword();
	                                }
	                              }),
	                              this.validator.message('Password', this.state.ind_password, 'required|password_custome', { className: 'text-danger' })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'col-lg-6 col-md-12' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'form-group' },
	                              _react2.default.createElement(
	                                'label',
	                                null,
	                                'Confirm Password',
	                                _react2.default.createElement(
	                                  'span',
	                                  { 'class': 'astrick' },
	                                  '*'
	                                )
	                              ),
	                              _react2.default.createElement('input', { id: 'password-fieldc', type: this.state.showCPassword ? 'text' : 'password', name: 'ind_cpassword',
	                                placeholder: 'Confirm Password',
	                                value: this.state.ind_cpassword,
	                                onChange: this.handleChange,
	                                className: 'form-control' }),
	                              _react2.default.createElement('span', {
	                                toggle: '#password-field',
	                                className: this.state.showCPassword ? 'fa fa-fw fa-eye-slash field-icon' : 'fa fa-fw fa-eye field-icon',
	                                onClick: function onClick() {
	                                  _this7.handleShowCPassword();
	                                }
	                              }),
	                              this.validator.message('Confirm Password', this.state.ind_cpassword, 'required|confirmpassword', { className: 'text-danger' })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'row' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'col-lg-6 col-md-12' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'form-group' },
	                              _react2.default.createElement(_reactRecaptcha2.default, {
	                                sitekey: _constant.GOOGLE_CAPTCHA_SITE_KEY,
	                                render: 'explicit',
	                                onloadCallback: this.recaptchaLoaded,
	                                verifyCallback: this.verifyCallback
	                              })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-md-12 col-sm-12 pad-hor-no' },
	                          _react2.default.createElement(
	                            'label',
	                            { className: 'custom-checkboxs', style: { marginTop: "10px" } },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              _react2.default.createElement('input', { type: 'checkbox', className: '',
	                                name: 'ind_agree',
	                                value: 'Yes',
	                                onChange: this.handleChange,
	                                checked: this.state.agree_data }),
	                              '\xA0\xA0 I Agree to ',
	                              _react2.default.createElement(
	                                'span',
	                                { style: { color: "#1492E6" } },
	                                _react2.default.createElement(
	                                  'a',
	                                  { href: 'javascript:window.open(\'/termsconditions\', \'termsconditions\', \'width=auto,height=auto\')' },
	                                  'Terms of service'
	                                ),
	                                ' and \xA0',
	                                _react2.default.createElement(
	                                  'a',
	                                  { href: 'javascript:window.open(\'/privacypolicy\', \'privacypolicy\', \'width=auto,height=auto\')', target: '_blank' },
	                                  'Privacy policy'
	                                ),
	                                _react2.default.createElement(
	                                  'span',
	                                  { 'class': 'astrick' },
	                                  '*'
	                                )
	                              )
	                            )
	                          ),
	                          _react2.default.createElement('br', null),
	                          this.validator.message('Agree', this.state.agree_data, 'required', { className: 'text-danger' })
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-md-12 col-sm-12 text-right pad-hor-no' },
	                          _react2.default.createElement(
	                            'button',
	                            { type: 'submit', className: 'btn orange-btn', disabled: this.state.btnDisable
	                            },
	                            this.state.btnDisable ? 'Please Wait...' : 'Submit'
	                          ),
	                          _react2.default.createElement('br', null)
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          null,
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            _react2.default.createElement(
	                              'span',
	                              { className: 'text-left' },
	                              'Our business development team will get in touch with you soon. On successful verification You will be able to login'
	                            )
	                          )
	                        )
	                      )
	                    ) : ''
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return InstitutionalSignup;
	}(_react.Component);
	
	exports.default = InstitutionalSignup;

/***/ },
/* 882 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FetchCall = __webpack_require__(4);
	
	var _FetchCall2 = _interopRequireDefault(_FetchCall);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactRecaptcha = __webpack_require__(170);
	
	var _reactRecaptcha2 = _interopRequireDefault(_reactRecaptcha);
	
	var _constant = __webpack_require__(21);
	
	var _simpleReactValidator = __webpack_require__(28);
	
	var _simpleReactValidator2 = _interopRequireDefault(_simpleReactValidator);
	
	var _reactPlacesAutocomplete = __webpack_require__(132);
	
	var _reactPlacesAutocomplete2 = _interopRequireDefault(_reactPlacesAutocomplete);
	
	var _reactstrap = __webpack_require__(17);
	
	var _constant2 = __webpack_require__(21);
	
	var _Autocomplete = __webpack_require__(181);
	
	var _Autocomplete2 = _interopRequireDefault(_Autocomplete);
	
	var _reactAutosuggest = __webpack_require__(86);
	
	var _reactAutosuggest2 = _interopRequireDefault(_reactAutosuggest);
	
	var _TextField = __webpack_require__(176);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	var _reactGeocode = __webpack_require__(55);
	
	var _reactGeocode2 = _interopRequireDefault(_reactGeocode);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	_reactGeocode2.default.setApiKey("AIzaSyA9MtbfG_zlo64B2lqNMvigTBuXHkagKcE");
	_reactGeocode2.default.setLanguage("en");
	_reactGeocode2.default.setRegion("es");
	_reactGeocode2.default.enableDebug();
	
	var InstitutionalSignup = function (_Component) {
	  _inherits(InstitutionalSignup, _Component);
	
	  function InstitutionalSignup(props) {
	    var _this2 = this,
	        _this$state;
	
	    _classCallCheck(this, InstitutionalSignup);
	
	    var _this = _possibleConstructorReturn(this, (InstitutionalSignup.__proto__ || Object.getPrototypeOf(InstitutionalSignup)).call(this, props));
	
	    _this.onChangeCity = function (event, _ref) {
	      var newValue = _ref.newValue,
	          method = _ref.method;
	
	      _this.setState({
	        location: newValue
	      });
	    };
	
	    _this.shouldRenderSuggestionsCity = function (value, reason) {
	      return value.trim().length > 2;
	    };
	
	    _this.onSuggestionsFetchRequestedCity = function (_ref2) {
	      var value = _ref2.value;
	
	      var val = _this.escapeRegexCharacters(value.trim());
	      var fetch = JSON.stringify({
	        keyword: val
	      });
	      (0, _FetchCall.getCitiesByKeyWord)(fetch).then(function (res) {
	        if (res.status == 1) {
	          _this.setState({
	            suggestionscities: res.list
	          });
	        }
	      });
	    };
	
	    _this.onSuggestionSelectedCity = function (event, _ref3) {
	      var suggestion = _ref3.suggestion,
	          suggestionValue = _ref3.suggestionValue,
	          suggestionIndex = _ref3.suggestionIndex,
	          sectionIndex = _ref3.sectionIndex,
	          method = _ref3.method;
	
	
	      //alert(suggestion.vendor_id);
	      _this.setState({
	        state: suggestion.state
	      });
	    };
	
	    _this.onSuggestionsClearRequestedCity = function () {
	      _this.setState({
	        suggestionscities: []
	      });
	    };
	
	    _this.getSuggestionValueCity = function (suggestion) {
	
	      return suggestion.city;
	    };
	
	    _this.getSelect = function () {
	
	      var rows = '';
	      {
	        rows = _this.state.cateList.length > 0 && _this.state.cateList.map(function (item, i) {
	          return _react2.default.createElement(
	            'option',
	            { value: item.category_id, 'data-tokens': item.options.toString() },
	            item.label
	          );
	        });
	      }
	
	      return rows;
	    };
	
	    _this.getPlanList = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var insdata;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              insdata = JSON.stringify({
	                user_type: 1
	              });
	
	              try {
	                (0, _FetchCall.getPlan)(insdata).then(function (response) {
	                  var list = response.results;
	                  var plan_info = list.filter(function (o) {
	                    return o.id == _this.state.plan_id;
	                  });
	                  console.log('plan_info', _this.state.plan_id);
	                  if (plan_info.length > 0) {
	                    _this.setState({
	                      package_list: response.results,
	                      base_price: plan_info[0]['base_price'],
	                      payable_price: plan_info[0]['plan_price'],
	                      discount_amount: plan_info[0]['discount_amount'],
	                      discount_percent: plan_info[0]['discount_percent'],
	                      plan_info: plan_info[0]['plan_offer']
	                    });
	                  }
	                  _this.setState({
	                    package_list: response.results
	                  });
	                });
	              } catch (error) {
	                _this.setState({ error: true });
	              }
	
	            case 2:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    }));
	
	    _this.toggleChange = function () {
	      _this.setState({
	        agree_data: !_this.state.agree_data
	      });
	    };
	
	    _this.handleChange = function (e) {
	      var propName = e.target.name;
	      _this.setState(_defineProperty({}, e.target.name, e.target.value));
	      if (propName == 'institution_email_address') {
	        _this.setState({ email_address: e.target.value });
	        _this.validateMail(e.target.value, 1);
	      }
	      if (propName == 'email_address') {
	        _this.validateMail(e.target.value, 1);
	      }
	      if (propName == 'ins_user_name') {
	        _this.validateMail(e.target.value, 2);
	      }
	    };
	
	    _this.handleSelect = function (e) {
	      var propName = e.target.name;
	      var value = [].concat(_toConsumableArray(e.target.selectedOptions)).map(function (item) {
	        return item.value;
	      });
	      _this.setState(_defineProperty({}, propName, value));
	      if (propName === 'social_link' && value[0] === 'fb') {
	        _this.setState({
	          socialPlace: 'Facebook'
	        });
	      } else if (propName === 'social_link' && value[0] === 'twt') {
	        _this.setState({
	          socialPlace: 'Twitter'
	        });
	      } else if (propName === 'social_link' && value[0] === 'lnkin') {
	        _this.setState({
	          socialPlace: 'LinkedIn'
	        });
	      } else if (propName === 'social_link' && value[0] === 'insta') {
	        _this.setState({
	          socialPlace: 'Instagram'
	        });
	      }
	
	      if (propName === 'category_id') {
	        var categoryid = e.target.value;
	        _this.Sub_Cat_type(categoryid);
	      }
	
	      if (propName === 'sub_category_id') {
	        _this.setState({ needmorecategory: true });
	      }
	    };
	
	    _this.handleplaceChangeIns = function (address) {
	      _this.setState({ address: address, pin_code: '', state: '', location: '' });
	    };
	
	    _this.handleplaceChangeInd = function (ind_address) {
	      _this.setState({ ind_address: ind_address, ind_pin_code: '', ind_state_name: '', ind_location: '' });
	    };
	
	    _this.handleplaceSelectIns = function (address) {
	      _this.setState({ address: address });
	      _reactGeocode2.default.fromAddress(address).then(function (response) {
	
	        var geolen = response.results[0].address_components.length;
	        var pincode = '';
	        var state = '';
	        var city = '';
	        for (var i = 0; i < geolen; i++) {
	
	          if (response.results[0].address_components[i].types[0] == "postal_code") {
	            pincode = response.results[0].address_components[i].short_name;
	          }
	          if (response.results[0].address_components[i].types[0] == "administrative_area_level_1") {
	            state = response.results[0].address_components[i].long_name;
	          }
	          if (response.results[0].address_components[i].types[0] == "locality") {
	            //city = response.results[0].address_components[i].long_name;
	          }
	        }
	
	        _this.get_location(pincode, state, city);
	      }, function (error) {
	        console.error(error);
	      });
	    };
	
	    _this.handleplaceSelectInd = function (ind_address) {
	      _this.setState({ ind_address: ind_address });
	      _reactGeocode2.default.fromAddress(ind_address).then(function (response) {
	
	        var geolen = response.results[0].address_components.length;
	        var pincode = '';
	        var state = '';
	        var city = '';
	        for (var i = 0; i < geolen; i++) {
	
	          if (response.results[0].address_components[i].types[0] == "postal_code") {
	            pincode = response.results[0].address_components[i].short_name;
	          }
	          if (response.results[0].address_components[i].types[0] == "administrative_area_level_1") {
	            state = response.results[0].address_components[i].long_name;
	          }
	          if (response.results[0].address_components[i].types[0] == "administrative_area_level_2") {
	            //city = response.results[0].address_components[i].long_name;
	          }
	        }
	
	        _this.get_ind_location(pincode, state, city);
	      }, function (error) {
	        console.error(error);
	      });
	    };
	
	    _this.handleFile = function (e) {
	      _this.setState(_defineProperty({}, e.target.name, e.target.files[0]));
	    };
	
	    _this.getRender = function (params) {
	
	      return _react2.default.createElement(_TextField2.default, Object.assign({}, params, {
	        variant: 'outlined',
	        placeholder: 'Type Category Here'
	      }));
	    };
	
	    _this.onTagsChange = function (event, values) {
	
	      var list = _this.state.cateList;
	      list.map(function (item, i) {
	        item.options = item.options.flat(Infinity);
	      });
	      var finalArr = [];
	      list.map(function (item, i) {
	        var intersection = item.options.filter(function (x) {
	          return values.includes(x);
	        });
	        if (intersection.length > 0) {
	          finalArr.push(item.category_id);
	        }
	      });
	
	      _this.setState({
	        organisation_type: finalArr,
	        sub_category: values
	      });
	    };
	
	    _this.handleInsFirstNext = function (e) {
	      e.preventDefault();
	      if (_this.validator.allValid()) {
	        _this.setState({
	          ins_first_next: true,
	          signup_form: false
	        });
	      } else {
	        _this.validator.showMessages();
	        _this.forceUpdate();
	      }
	    };
	
	    _this.handleInsFirstPre = function (e) {
	      e.preventDefault();
	      _this.setState({
	        ins_first_next: false,
	        signup_form: true
	      });
	    };
	
	    _this.handleInsSecondPre = function (e) {
	      e.preventDefault();
	      _this.setState({
	        ins_first_next: true,
	        ins_second_next: false
	      });
	    };
	
	    _this.recaptchaLoaded = function (e) {
	      console.log('Successfully loaded');
	    };
	
	    _this.verifyCallback = function (response) {
	      if (response) {
	        _this.setState({
	          isVerified: true
	        });
	      }
	    };
	
	    _this.handleVerifyUser = function (e) {
	
	      var ins = '';
	
	      ins = JSON.stringify({
	        user_id: _this.state.userid,
	        otp: _this.state.otp
	      });
	
	      (0, _FetchCall.verifyVendor)(ins).then(function (res) {
	
	        if (res.status === 1) {
	
	          _this.setState({ otpverified: true });
	        }
	      });
	    };
	
	    _this.handleSubmit = function (e) {
	      e.preventDefault();
	      if (_this.validator.allValid()) {
	        _this.setState({
	          btnDisable: true
	        });
	        var ins = '';
	        var rowsCount = _this.state.rows.length;
	
	        ins = JSON.stringify({
	          maincatRows: _this.state.rows,
	          subcatRows: _this.state.sub_cat_rows,
	          rowsCount: rowsCount,
	          mid: _this.state.mid,
	          user_type: _this.state.user_type,
	          organisation_name: _this.state.organisation_name,
	          organisation_register_number: _this.state.organisation_register_number,
	          address: _this.state.address,
	          pin_code: _this.state.pin_code,
	          state: _this.state.state,
	          location: _this.state.location,
	          institution_contact_number: _this.state.institution_contact_number,
	          institution_email_address: _this.state.institution_email_address,
	          social_link: _this.state.social_link,
	          social_media_link: _this.state.social_media_link,
	          category_id: _this.state.category_id,
	          first_name: _this.state.ins_first_name,
	          last_name: _this.state.ins_last_name,
	          owner_type: _this.state.owner_type,
	          designation: _this.state.designation,
	          email_id: _this.state.email_address,
	          phone_number: _this.state.phone_number,
	          landline_number: _this.state.landline_number,
	          user_name: _this.state.ins_user_name,
	          password: _this.state.ins_password,
	          cpassword: _this.state.ins_cpassword,
	          plan_id: 0,
	          agree: _this.state.agree,
	          agree_data: _this.state.agree_data,
	          sub_category: _this.state.sub_category_id,
	          user_paytype: 2,
	          main_id: _this.state.main_id,
	          main_type: _this.state.main_type,
	          main_category_id: _this.state.category_id
	        });
	
	        console.log('ins', ins);
	        //return false;
	
	        (0, _FetchCall.registerVendorNew)(ins).then(function (res) {
	          var toastr = '';
	          if (res.status === 1) {
	            /*
	            toastr = window.toastr.success;
	            toastr('', 'Your Activation link  has been sent your to registered email id please click the link to activate your account.', {
	              positionClass: "toast-bottom-right",
	              containerId: "toast-bottom-right"
	            });
	            */
	            _this.setState({
	              showOTPform: true,
	              userid: res.userid
	            });
	            /*
	            setTimeout(function () {
	              window.location.replace('/login');
	            }, 2000);
	            */
	          } else {
	
	            if (res.status === 3) {
	              alert("Error:" + res.message);
	            } else {
	              var er = res.errors[0].msg;
	              /*
	              toastr = window.toastr.error; //warning
	              toastr(er, toastr, {
	                positionClass: "toast-bottom-right",
	                containerId: "toast-bottom-right"
	              });
	              */
	              alert("Error:" + er);
	
	              _this.setState({
	                btnDisable: false
	              });
	            }
	          }
	        });
	      } else {
	        _this.validator.showMessages();
	        _this.forceUpdate();
	      }
	    };
	
	    _this.shouldRenderSuggestions = function (value, reason) {
	      return value.trim().length > 2;
	    };
	
	    _this.onSuggestionsFetchRequested = function (_ref5) {
	      var value = _ref5.value;
	
	      var val = _this.escapeRegexCharacters(value.trim());
	      var fetch = JSON.stringify({
	        keyword: val,
	        url: 'getDataByName'
	      });
	      (0, _FetchCall.signUpApi)(fetch).then(function (res) {
	        if (res.status == 1) {
	          _this.setState({
	            suggestions: res.result
	          });
	        }
	      });
	    };
	
	    _this.onSuggestionSelected = function (event, _ref6) {
	      var suggestion = _ref6.suggestion,
	          suggestionValue = _ref6.suggestionValue,
	          suggestionIndex = _ref6.suggestionIndex,
	          sectionIndex = _ref6.sectionIndex,
	          method = _ref6.method;
	
	
	      //alert(suggestion.vendor_id);
	      _this.setState({
	        mid: suggestion.id
	      });
	    };
	
	    _this.onSuggestionsClearRequested = function () {
	      _this.setState({
	        suggestions: []
	      });
	    };
	
	    _this.getSuggestionValue = function (suggestion) {
	      _this.setState({ confirmModal: true });
	      var currentData = suggestion;
	      currentData.url = 'getDataById';
	      var data = JSON.stringify(currentData);
	      (0, _FetchCall.signUpApi)(data).then(function (res) {
	        if (res.status === 1) {
	          var _data = res.result;
	          var rows = _this.state.rows;
	          rows[0].category_id = _data.main_category;
	          _this.setState({
	            organisation_register_number: _data.registration_no,
	            address: _data.address,
	            location: _data.location,
	            state: _data.state,
	            pin_code: _data.pincode,
	            institution_contact_number: _data.phone_number,
	            institution_email_address: _data.email_id,
	            updateProcess: true,
	            main_id: _data.id,
	            main_type: suggestion.type,
	            sub_category_id: suggestion.sub_link.split(',')
	          });
	          _this.Sub_Cat_type_new(_data.main_category, 0);
	        } else {
	          _this.setState({
	            organisation_register_number: '',
	            address: '',
	            location: '',
	            state: '',
	            pin_code: '',
	            institution_contact_number: '',
	            institution_email_address: '',
	            category_id: '',
	            updateProcess: false,
	            main_id: '',
	            main_type: '',
	            sub_category_id: ''
	          });
	        }
	      });
	      return suggestion.name;
	    };
	
	    _this.onChange = function (event, _ref7) {
	      var newValue = _ref7.newValue,
	          method = _ref7.method;
	
	      _this.setState({
	        organisation_name: newValue
	      });
	      if (newValue.length > 2) {
	        _this.setState({
	          fieldDisable: false
	        });
	      } else {
	        _this.setState({
	          fieldDisable: true
	        });
	      }
	    };
	
	    _this.cancelPop = function () {
	      _this.setState({
	        confirmModal: false,
	        currentData: [],
	        organisation_register_number: '',
	        address: '',
	        location: '',
	        state: '',
	        pin_code: '',
	        institution_contact_number: '',
	        institution_email_address: '',
	        category_id: '',
	        updateProcess: false,
	        main_id: '',
	        main_type: '',
	        sub_category_id: ''
	      });
	    };
	
	    _this.getsuggestData = function () {
	      _this.setState({
	        confirmModal: false
	      });
	    };
	
	    _this.handleChangeMainCat = function (idx) {
	      return function (e) {
	        var _e$target = e.target,
	            name = _e$target.name,
	            value = _e$target.value;
	
	        var rows = [].concat(_toConsumableArray(_this.state.rows));
	
	        var previousValue = rows[idx].category_id;
	        console.log("value", previousValue);
	
	        if (previousValue == value) {
	          alert("Already you have selected as primary category!");
	          return false;
	        } else {
	
	          rows[idx] = _defineProperty({}, name, value);
	          _this.setState({
	            rows: rows
	          });
	
	          _this.Sub_Cat_type_new(value, idx);
	        }
	      };
	    };
	
	    _this.handleChangeCat = function (idx) {
	      return function (e) {
	        var propName = e.target.name;
	        var value = [].concat(_toConsumableArray(e.target.selectedOptions)).map(function (item) {
	          return item.value;
	        });
	        var sub_cat_rows = [].concat(_toConsumableArray(_this.state.sub_cat_rows));
	        sub_cat_rows[idx] = _defineProperty({}, propName, value);
	        _this.setState({
	          sub_cat_rows: sub_cat_rows
	        });
	      };
	    };
	
	    _this.handleAddRow = function () {
	      var item = {
	        category_id: "",
	        sub_category_id: ""
	      };
	      _this.setState({
	        rows: [].concat(_toConsumableArray(_this.state.rows), [item])
	      });
	    };
	
	    _this.handleRemoveRow = function () {
	      _this.setState({
	        rows: _this.state.rows.slice(0, -1)
	      });
	    };
	
	    _this.handleRemoveSpecificRow = function (idx) {
	      return function () {
	        var rows = [].concat(_toConsumableArray(_this.state.rows));
	        rows.splice(idx, 1);
	        _this.setState({ rows: rows });
	      };
	    };
	
	    _this.state = (_this$state = {
	      fieldDisable: true,
	      needmorecategory: false,
	      btnDisable: false,
	      signup_form: true,
	      ins_first_next: false,
	      confirmModal: false,
	      organisation_name: '',
	      user_type: '1',
	      user_name: '',
	      organisation_register_number: '',
	      institution_contact_number: '',
	      institution_email_address: '',
	      email_id: '',
	      phone_number: '',
	      organisation_type: '',
	      state: '',
	      location: '',
	      pin_code: '',
	      address: '',
	      cheque_image: '',
	      org_type_list: [],
	      social_media_link: '',
	      is_org: false,
	      is_owner: false,
	      incharge_name: '',
	      incharge_text: 'In-Charge ',
	      social_link: '',
	      socialPlace: 'LinkedIn',
	      agree: '',
	      cateList: [],
	      autoSuggCate: [],
	      state_name: '',
	      ins_first_name: '',
	      ins_last_name: '',
	      owner_type: '',
	      designation: '',
	      email_address: ''
	    }, _defineProperty(_this$state, 'phone_number', ''), _defineProperty(_this$state, 'landline_number', ''), _defineProperty(_this$state, 'ins_user_name', ''), _defineProperty(_this$state, 'ins_password', ''), _defineProperty(_this$state, 'ins_cpassword', ''), _defineProperty(_this$state, 'package_list', []), _defineProperty(_this$state, 'agree', ''), _defineProperty(_this$state, 'planinfo_option', true), _defineProperty(_this$state, 'category_List', []), _defineProperty(_this$state, 'categorySubTypeList', []), _defineProperty(_this$state, 'category_id', ''), _defineProperty(_this$state, 'sub_category_id', ''), _defineProperty(_this$state, 'agree_data', false), _defineProperty(_this$state, 'plan_price', 0), _defineProperty(_this$state, 'plan_price_original', 0), _defineProperty(_this$state, 'suggestions', []), _defineProperty(_this$state, 'currentData', []), _defineProperty(_this$state, 'location_list', []), _defineProperty(_this$state, 'updateProcess', false), _defineProperty(_this$state, 'isVerified', false), _defineProperty(_this$state, 'isEmailValid', true), _defineProperty(_this$state, 'isUserValid', true), _defineProperty(_this$state, 'main_id', ''), _defineProperty(_this$state, 'main_type', ''), _defineProperty(_this$state, 'showPassword', false), _defineProperty(_this$state, 'showCPassword', false), _defineProperty(_this$state, 'showOTPform', false), _defineProperty(_this$state, 'otp', ''), _defineProperty(_this$state, 'userid', ''), _defineProperty(_this$state, 'otpverified', false), _defineProperty(_this$state, 'mid', 0), _defineProperty(_this$state, 'suggestionscities', []), _defineProperty(_this$state, 'rows', [{}]), _defineProperty(_this$state, 'sub_cat_rows', [{}]), _defineProperty(_this$state, 'categorySubTypeList_0', []), _defineProperty(_this$state, 'categorySubTypeList_1', []), _defineProperty(_this$state, 'categorySubTypeList_2', []), _defineProperty(_this$state, 'categorySubTypeList_3', []), _defineProperty(_this$state, 'categorySubTypeList_4', []), _defineProperty(_this$state, 'categorySubTypeList_5', []), _defineProperty(_this$state, 'categorySubTypeList_6', []), _defineProperty(_this$state, 'categorySubTypeList_7', []), _this$state);
	    _this.getLocation();
	    _this.orgList();
	    _this.cateList();
	    _this.categoryList();
	    _this.validator = new _simpleReactValidator2.default({
	      validators: {
	        password_custome: { // name the rule
	          message: 'The :attribute must be a Min of 8 characters in length - One Capital Letter, One Number, One Character.',
	          rule: function rule(val, params, validator) {
	            return validator.helpers.testRegex(val, /^(?=.*\d)(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,15}$/) && params.indexOf(val) === -1;
	          },
	          messageReplace: function messageReplace(message, params) {
	            return message.replace(':values', _this.helpers.toSentence(params));
	          }, // optional
	          required: true // optional
	        },
	        confirmpassword: { // name the rule
	          message: 'The :attribute must be Same as Password.',
	          rule: function rule(val, params, validator) {
	            if (val != _this.state.ins_password) {
	              return false;
	            }
	          },
	          messageReplace: function messageReplace(message, params) {
	            return message.replace(':values', _this.helpers.toSentence(params));
	          }, // optional
	          required: true // optional
	        },
	        emailExist: { // name the rule
	          message: 'The :attribute Already Exist.',
	          rule: function rule(val, params, validator) {
	            return _this.state.isEmailValid;
	          },
	          messageReplace: function messageReplace(message, params) {
	            return message.replace(':values', _this.helpers.toSentence(params));
	          }, // optional
	          required: true // optional
	        },
	        userExist: { // name the rule
	          message: 'The :attribute Already Exist.',
	          rule: function rule(val, params, validator) {
	            return _this.state.isUserValid;
	          },
	          messageReplace: function messageReplace(message, params) {
	            return message.replace(':values', _this.helpers.toSentence(params));
	          }, // optional
	          required: true // optional
	        },
	        checkMobile: _constant.MOBILE_REGEX,
	        checkUrl: _constant.URL_REGEX
	      }
	    });
	
	    _this.recaptchaLoaded = _this.recaptchaLoaded.bind(_this);
	    _this.verifyCallback = _this.verifyCallback.bind(_this);
	    _this.handleSubmit = _this.handleSubmit.bind(_this);
	    _this.onSuggestionSelectedCity = _this.onSuggestionSelectedCity.bind(_this);
	    _this.handleChangeCat = _this.handleChangeCat.bind(_this);
	    _this.handleChangeMainCat = _this.handleChangeMainCat.bind(_this);
	
	    return _this;
	  }
	
	  //suggestionscities
	
	
	  _createClass(InstitutionalSignup, [{
	    key: 'renderSuggestionCity',
	    value: function renderSuggestionCity(suggestion) {
	      return _react2.default.createElement(
	        'span',
	        null,
	        suggestion.city
	      );
	    }
	  }, {
	    key: 'getLocation',
	    value: function () {
	      var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	        var _this3 = this;
	
	        var req;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                req = JSON.stringify({
	                  url: 'getLocation'
	                });
	
	                (0, _FetchCall.getLocation)(req).then(function (res) {
	                  if (res.status === 1) {
	                    _this3.setState({
	                      location_list: res.results
	                    });
	                  }
	                });
	
	              case 2:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this);
	      }));
	
	      function getLocation() {
	        return _ref8.apply(this, arguments);
	      }
	
	      return getLocation;
	    }()
	  }, {
	    key: 'cateList',
	    value: function () {
	      var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	        var _this4 = this;
	
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                (0, _FetchCall.getCatDrop)(0).then(function (res) {
	                  if (res.status === 1) {
	                    var list = res.results;
	                    list.map(function (item, i) {
	                      item.options = item.options.flat(Infinity);
	                    });
	                    var fiArr = [];
	                    list.map(function (item, i) {
	                      fiArr.push(item.options);
	                    });
	                    fiArr = fiArr.flat(Infinity);
	                    _this4.setState({
	                      cateList: res.results,
	                      autoSuggCate: fiArr
	                    });
	                  }
	                });
	
	              case 1:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, this);
	      }));
	
	      function cateList() {
	        return _ref9.apply(this, arguments);
	      }
	
	      return cateList;
	    }()
	  }, {
	    key: 'categoryList',
	    value: function () {
	      var _ref10 = _asyncToGenerator(_regenerator2.default.mark(function _callee4() {
	        var response;
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                _context4.next = 2;
	                return _FetchCall2.default.getSubCategory('0');
	
	              case 2:
	                response = _context4.sent;
	
	                console.log('AgeList', response);
	                if (response) {
	                  this.setState({ category_List: response.results });
	                } else {
	                  this.setState({
	                    category_List: []
	                  });
	                }
	
	              case 5:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, this);
	      }));
	
	      function categoryList() {
	        return _ref10.apply(this, arguments);
	      }
	
	      return categoryList;
	    }()
	  }, {
	    key: 'Sub_Cat_type',
	    value: function () {
	      var _ref11 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(id) {
	        var response;
	        return _regenerator2.default.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                if (!id) {
	                  _context5.next = 7;
	                  break;
	                }
	
	                _context5.next = 3;
	                return _FetchCall2.default.getSubCategory(id);
	
	              case 3:
	                response = _context5.sent;
	
	                if (response.status == 1) {
	                  this.setState({ categorySubTypeList: response.results, cat_type: true, cat_type1: false, cat_type2: false });
	                } else {
	                  this.setState({
	                    categorySubTypeList: []
	                  });
	                }
	                _context5.next = 8;
	                break;
	
	              case 7:
	                this.setState({
	                  categorySubTypeList: []
	                });
	
	              case 8:
	              case 'end':
	                return _context5.stop();
	            }
	          }
	        }, _callee5, this);
	      }));
	
	      function Sub_Cat_type(_x) {
	        return _ref11.apply(this, arguments);
	      }
	
	      return Sub_Cat_type;
	    }()
	  }, {
	    key: 'Sub_Cat_type_new',
	    value: function () {
	      var _ref12 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(id, index) {
	        var response;
	        return _regenerator2.default.wrap(function _callee6$(_context6) {
	          while (1) {
	            switch (_context6.prev = _context6.next) {
	              case 0:
	                if (!id) {
	                  _context6.next = 5;
	                  break;
	                }
	
	                _context6.next = 3;
	                return _FetchCall2.default.getSubCategory(id);
	
	              case 3:
	                response = _context6.sent;
	
	                if (response.status == 1) {
	                  if (index == 0) {
	                    this.setState({ categorySubTypeList_0: response.results, cat_type: true, cat_type1: false, cat_type2: false });
	                  }
	
	                  if (index == 1) {
	                    this.setState({ categorySubTypeList_1: response.results, cat_type: true, cat_type1: false, cat_type2: false });
	                  }
	                }
	
	              case 5:
	              case 'end':
	                return _context6.stop();
	            }
	          }
	        }, _callee6, this);
	      }));
	
	      function Sub_Cat_type_new(_x2, _x3) {
	        return _ref12.apply(this, arguments);
	      }
	
	      return Sub_Cat_type_new;
	    }()
	  }, {
	    key: 'showValidationErr',
	    value: function showValidationErr(elm, msg) {
	      this.setState(function (prevState) {
	        return { errors: [].concat(_toConsumableArray(prevState.errors), [{ elm: elm, msg: msg }]) };
	      });
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      window.jQuery('.selectpicker').selectpicker('refresh');
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getPlanList();
	    }
	  }, {
	    key: 'handleShowPassword',
	    value: function handleShowPassword() {
	      this.setState(function (prevState) {
	        return {
	          showPassword: !prevState.showPassword
	        };
	      });
	    }
	  }, {
	    key: 'handleShowCPassword',
	    value: function handleShowCPassword() {
	      this.setState(function (prevState) {
	        return {
	          showCPassword: !prevState.showCPassword
	        };
	      });
	    }
	  }, {
	    key: 'orgList',
	    value: function () {
	      var _ref13 = _asyncToGenerator(_regenerator2.default.mark(function _callee7() {
	        var response;
	        return _regenerator2.default.wrap(function _callee7$(_context7) {
	          while (1) {
	            switch (_context7.prev = _context7.next) {
	              case 0:
	                _context7.next = 2;
	                return _FetchCall2.default.getSubCategory('0');
	
	              case 2:
	                response = _context7.sent;
	
	                console.log('boeList', response);
	                if (response) {
	                  this.setState({ org_type_list: response.results });
	                }
	
	              case 5:
	              case 'end':
	                return _context7.stop();
	            }
	          }
	        }, _callee7, this);
	      }));
	
	      function orgList() {
	        return _ref13.apply(this, arguments);
	      }
	
	      return orgList;
	    }()
	  }, {
	    key: 'validateMail',
	    value: function validateMail(value, type) {
	      var _this5 = this;
	
	      var name = type == 1 ? 'email_id' : 'user_name';
	      var type_name = type == 1 ? 'isEmailValid' : 'isUserValid';
	      var req = JSON.stringify(_defineProperty({}, name, value));
	      var res = (0, _FetchCall.emailExist)(req).then(function (res) {
	        if (res.status === 1) {
	          _this5.setState(_defineProperty({}, type_name, false));
	        } else {
	          // return res.status;
	          _this5.setState(_defineProperty({}, type_name, true));
	        }
	      });
	    }
	  }, {
	    key: 'Geocode_location',
	    value: function Geocode_location() {
	      var _this6 = this;
	
	      _reactGeocode2.default.fromAddress(this.state.address).then(function (response) {
	
	        var geolen = response.results[0].address_components.length;
	        var pincode = '';
	        var state = '';
	        var city = '';
	        for (var i = 0; i < geolen; i++) {
	
	          if (response.results[0].address_components[i].types[0] == "postal_code") {
	            pincode = response.results[0].address_components[i].short_name;
	          }
	          if (response.results[0].address_components[i].types[0] == "administrative_area_level_1") {
	            state = response.results[0].address_components[i].long_name;
	          }
	          if (response.results[0].address_components[i].types[0] == "administrative_area_level_2") {
	            city = response.results[0].address_components[i].long_name;
	          }
	        }
	
	        _this6.get_location(pincode, state, city);
	      }, function (error) {
	        console.error(error);
	      });
	    }
	  }, {
	    key: 'get_location',
	    value: function get_location(pincode, state, city) {
	      console.log(pincode, state, city);
	      this.setState({
	        pin_code: pincode,
	        state: state,
	        location: city
	      });
	    }
	  }, {
	    key: 'get_ind_location',
	    value: function get_ind_location(pincode, state, city) {
	      console.log(pincode, state, city);
	      this.setState({
	        ind_pin_code: pincode,
	        ind_state_name: state,
	        ind_location: city
	      });
	    }
	  }, {
	    key: 'escapeRegexCharacters',
	    value: function escapeRegexCharacters(str) {
	      return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	    }
	  }, {
	    key: 'renderSuggestion',
	    value: function renderSuggestion(suggestion) {
	      return _react2.default.createElement(
	        'span',
	        null,
	        suggestion.name
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this7 = this;
	
	      var inputPropscity = {
	        placeholder: "Type City",
	        value: this.state.location,
	        onChange: this.onChangeCity,
	        name: 'location',
	        className: 'form-control'
	      };
	
	      var _state = this.state,
	          value = _state.value,
	          suggestions = _state.suggestions,
	          suggestionscities = _state.suggestionscities;
	
	      this.validator.purgeFields();
	      var plans = this.state.plan_info ? this.state.plan_info.split('\\') : [];
	      plans = plans.filter(function (el) {
	        return el != null && el != '';
	      });
	      var inputProps = {
	        placeholder: "Name of the Institution",
	        value: this.state.organisation_name,
	        onChange: this.onChange,
	        name: 'organisation_name',
	        className: 'form-control'
	      };
	      this.validator.purgeFields();
	      return _react2.default.createElement(
	        'div',
	        { className: 'container-fluid' },
	        _react2.default.createElement(
	          'form',
	          { onSubmit: this.handleSubmit },
	          _react2.default.createElement(
	            _reactstrap.Modal,
	            { isOpen: this.state.confirmModal, className: 'modal-sm custome-modal', style: { top: "20%" } },
	            _react2.default.createElement(
	              _reactstrap.ModalBody,
	              { className: 'p-0' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-md-12' },
	                  _react2.default.createElement(
	                    'h4',
	                    { className: 'text-center' },
	                    'Is this your institution?'
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactstrap.ModalFooter,
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-md-12 text-center' },
	                  _react2.default.createElement(
	                    'button',
	                    { className: 'btn btn-sm btn-default', onClick: this.cancelPop },
	                    'No'
	                  ),
	                  _react2.default.createElement(
	                    'button',
	                    { className: 'btn btn-sm btn-cus-blue', onClick: this.getsuggestData },
	                    'Yes'
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-6 col-sm-6 sign-bg-login   hidden-xs' },
	              _react2.default.createElement('div', { className: 'shadow-bg' }),
	              _react2.default.createElement(
	                'h1',
	                null,
	                'Welcome to',
	                _react2.default.createElement('br', null),
	                ' BeWise Partner Program'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-6 col-sm-6 signup-right' },
	              _react2.default.createElement(
	                'div',
	                { className: 'inner-right' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-12 col-sm-12' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'right-logo' },
	                      _react2.default.createElement(
	                        'a',
	                        { href: '/institution' },
	                        _react2.default.createElement('img', { src: 'assets/images/bewiselogo.png' })
	                      )
	                    ),
	                    this.state.signup_form === false && this.state.showOTPform === true ? _react2.default.createElement(
	                      'div',
	                      null,
	                      _react2.default.createElement(
	                        'h1',
	                        null,
	                        'Verification'
	                      ),
	                      this.state.otpverified && _react2.default.createElement(
	                        'div',
	                        { 'class': 'aftervrying alert alert-success' },
	                        'Thank you for registering with us and your account has been verified successfully. Please click ',
	                        _react2.default.createElement(
	                          'a',
	                          { href: '/login' },
	                          'here'
	                        ),
	                        ' to login and become bewise partner'
	                      ),
	                      !this.state.otpverified && _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'smalltext' },
	                          'We have sent you an OTP to your registering email id successfully'
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'row' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'col-lg-6 col-md-12' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'form-group' },
	                              _react2.default.createElement(
	                                'label',
	                                null,
	                                'OTP',
	                                _react2.default.createElement(
	                                  'span',
	                                  { className: 'astrick' },
	                                  '(you may have received in your inbox or junk or spam)'
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'custom-select-drop dropdown' },
	                                _react2.default.createElement('input', { type: 'text', name: 'otp',
	                                  value: this.state.otp,
	                                  placeholder: 'OTP',
	                                  onChange: this.handleChange,
	                                  className: 'form-control' }),
	                                this.validator.message('Verification OTP', this.state.otp, 'required', { className: 'text-danger' })
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-12 col-sm-12 text-right' },
	                            _react2.default.createElement(
	                              'button',
	                              { type: 'button', className: 'btn orange-btn', onClick: this.handleVerifyUser },
	                              'Verify'
	                            )
	                          )
	                        )
	                      )
	                    ) : '',
	                    this.state.signup_form === true && this.state.showOTPform === false ? _react2.default.createElement(
	                      'div',
	                      null,
	                      _react2.default.createElement(
	                        'h1',
	                        null,
	                        'Institution Details'
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-6 col-md-12' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'form-group' },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              'Name of the Institution  ',
	                              _react2.default.createElement('i', { 'class': 'fa fa-info-circle', 'data-toggle': 'tooltip', title: 'Enter institution name only if not in our list', 'aria-hidden': 'true' }),
	                              ' ',
	                              _react2.default.createElement(
	                                'span',
	                                { className: 'astrick' },
	                                '*'
	                              )
	                            ),
	                            _react2.default.createElement(_reactAutosuggest2.default, {
	                              suggestions: suggestions,
	                              shouldRenderSuggestions: this.shouldRenderSuggestions,
	                              onSuggestionsFetchRequested: this.onSuggestionsFetchRequested,
	                              onSuggestionsClearRequested: this.onSuggestionsClearRequested,
	                              getSuggestionValue: this.getSuggestionValue,
	                              renderSuggestion: this.renderSuggestion,
	                              inputProps: inputProps }),
	                            this.validator.message('Name of the Institution', this.state.organisation_name, 'required', { className: 'text-danger' })
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-md-12 col-sm-12' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'form-group' },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              'Address of the Institution',
	                              _react2.default.createElement(
	                                'span',
	                                { className: 'astrick' },
	                                '*'
	                              )
	                            ),
	                            _react2.default.createElement(
	                              _reactPlacesAutocomplete2.default,
	                              {
	                                value: this.state.address,
	                                className: 'form-control',
	                                onChange: this.handleplaceChangeIns,
	                                onSelect: this.handleplaceSelectIns
	                              },
	                              function (_ref14) {
	                                var getInputProps = _ref14.getInputProps,
	                                    suggestions = _ref14.suggestions,
	                                    getSuggestionItemProps = _ref14.getSuggestionItemProps,
	                                    loading = _ref14.loading;
	                                return _react2.default.createElement(
	                                  'div',
	                                  null,
	                                  _react2.default.createElement('input', Object.assign({}, getInputProps({
	                                    placeholder: 'Search Places ...',
	                                    className: 'form-control',
	                                    id: 'address_ins',
	                                    disabled: _this7.state.fieldDisable
	                                  }), {
	                                    value: _this7.state.address
	                                  })),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'autocomplete-dropdown-container',
	                                      style: { position: "absolute", zIndex: "999" } },
	                                    loading && _react2.default.createElement(
	                                      'div',
	                                      null,
	                                      'Loading...'
	                                    ),
	                                    suggestions.map(function (suggestion) {
	                                      var className = suggestion.active ? 'suggestion-item--active' : 'suggestion-item';
	                                      // inline style for demonstration purpose
	                                      var style = suggestion.active ? { backgroundColor: '#fafafa', cursor: 'pointer' } : { backgroundColor: '#ffffff', cursor: 'pointer' };
	                                      return _react2.default.createElement(
	                                        'div',
	                                        getSuggestionItemProps(suggestion, {
	                                          className: className,
	                                          style: style
	                                        }),
	                                        _react2.default.createElement(
	                                          'span',
	                                          null,
	                                          suggestion.description
	                                        )
	                                      );
	                                    })
	                                  )
	                                );
	                              }
	                            ),
	                            this.validator.message('Address of the Institution', this.state.address, 'required', { className: 'text-danger' })
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-6 col-md-12' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'form-group' },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              'City',
	                              _react2.default.createElement(
	                                'span',
	                                { 'class': 'astrick' },
	                                ' * Please choose from the list '
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'custom-select-drop dropdown' },
	                              _react2.default.createElement(_reactAutosuggest2.default, {
	                                suggestions: suggestionscities,
	                                shouldRenderSuggestions: this.shouldRenderSuggestionsCity,
	                                onSuggestionsFetchRequested: this.onSuggestionsFetchRequestedCity,
	                                onSuggestionsClearRequested: this.onSuggestionsClearRequestedCity,
	                                getSuggestionValue: this.getSuggestionValueCity,
	                                renderSuggestion: this.renderSuggestionCity,
	                                onSuggestionSelected: this.onSuggestionSelectedCity,
	                                inputProps: inputPropscity }),
	                              this.validator.message('City', this.state.location, 'required|alpha_space', { className: 'text-danger' })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-6 col-md-12' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'form-group' },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              'State',
	                              _react2.default.createElement(
	                                'span',
	                                { 'class': 'astrick' },
	                                '*'
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'custom-select-drop dropdown' },
	                              _react2.default.createElement('input', { type: 'text', name: 'state',
	                                value: this.state.state,
	                                placeholder: 'State',
	                                onChange: this.handleChange,
	                                className: 'form-control', id: 'state_ins', disabled: this.state.fieldDisable }),
	                              this.validator.message('State', this.state.state, 'required|alpha_space', { className: 'text-danger' })
	                            )
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-6 col-md-12' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'form-group' },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              'Pincode',
	                              _react2.default.createElement(
	                                'span',
	                                { 'class': 'astrick' },
	                                '*'
	                              )
	                            ),
	                            _react2.default.createElement('input', { type: 'number', name: 'pin_code',
	                              placeholder: 'Pincode',
	                              className: 'form-control',
	                              id: 'pincode_ins',
	                              value: this.state.pin_code,
	                              onChange: this.handleChange,
	                              disabled: this.state.fieldDisable
	                            }),
	                            this.validator.message('Pincode', this.state.pin_code, 'required|numeric|min:1,num', { className: 'text-danger' })
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-6 col-md-12' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'form-group' },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              'Institution Contact Number',
	                              _react2.default.createElement(
	                                'span',
	                                { 'class': 'astrick' },
	                                '*'
	                              )
	                            ),
	                            _react2.default.createElement('input', { type: 'number', className: 'form-control',
	                              name: 'institution_contact_number',
	                              id: 'institution_contact_number',
	                              value: this.state.institution_contact_number,
	                              onChange: this.handleChange,
	                              placeholder: 'Institution Contact Number', disabled: this.state.fieldDisable
	                            }),
	                            this.validator.message('Institution Contact Number', this.state.institution_contact_number, 'required|checkMobile|min:10|max:15', { className: 'text-danger' })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-6 col-md-12' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'form-group' },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              'Institution Email Address',
	                              _react2.default.createElement(
	                                'span',
	                                { 'class': 'astrick' },
	                                '*'
	                              )
	                            ),
	                            _react2.default.createElement('input', { type: 'text', className: 'form-control',
	                              name: 'institution_email_address',
	                              id: 'institution_email_address',
	                              value: this.state.institution_email_address,
	                              onChange: this.handleChange,
	                              placeholder: 'Institution Email Address', disabled: this.state.fieldDisable
	                            }),
	                            this.validator.message('Institution Email Address', this.state.institution_email_address, 'required|email', { className: 'text-danger' })
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row clearfix' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-md-12 column' },
	                          _react2.default.createElement(
	                            'table',
	                            {
	                              className: 'table table-bordered table-hover table-sm',
	                              id: 'tab_logic'
	                            },
	                            _react2.default.createElement(
	                              'thead',
	                              null,
	                              _react2.default.createElement(
	                                'tr',
	                                null,
	                                _react2.default.createElement(
	                                  'th',
	                                  { className: 'text-center' },
	                                  ' # '
	                                ),
	                                _react2.default.createElement(
	                                  'th',
	                                  { className: 'text-center' },
	                                  ' Type '
	                                ),
	                                _react2.default.createElement(
	                                  'th',
	                                  { className: 'text-center' },
	                                  ' Category '
	                                ),
	                                _react2.default.createElement(
	                                  'th',
	                                  { className: 'text-center' },
	                                  ' Subcategory '
	                                ),
	                                _react2.default.createElement('th', null)
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'tbody',
	                              null,
	                              this.state.rows.map(function (item, idx) {
	                                return _react2.default.createElement(
	                                  'tr',
	                                  { id: 'addr0', key: idx },
	                                  _react2.default.createElement(
	                                    'td',
	                                    null,
	                                    idx + 1
	                                  ),
	                                  _react2.default.createElement(
	                                    'td',
	                                    null,
	                                    idx == 0 ? "Primary" : "Secondary"
	                                  ),
	                                  _react2.default.createElement(
	                                    'td',
	                                    null,
	                                    _react2.default.createElement(
	                                      'select',
	                                      {
	                                        onChange: _this7.handleChangeMainCat(idx),
	                                        name: "category_id",
	                                        id: "category_id",
	                                        value: _this7.state.rows[idx].category_id,
	                                        className: 'form-control', title: 'Select Category', disabled: _this7.state.fieldDisable },
	                                      _react2.default.createElement(
	                                        'option',
	                                        { value: '' },
	                                        'Select'
	                                      ),
	                                      _this7.state.category_List.length > 0 && _this7.state.category_List.map(function (item, i) {
	                                        return _react2.default.createElement(
	                                          'option',
	                                          { value: item.category_id },
	                                          item.category_name
	                                        );
	                                      })
	                                    )
	                                  ),
	                                  _react2.default.createElement(
	                                    'td',
	                                    null,
	                                    idx == 0 && _react2.default.createElement(
	                                      'select',
	                                      {
	                                        onChange: _this7.handleChangeCat(idx),
	                                        name: "sub_category_id",
	                                        multiple: true,
	                                        id: "sub_category_id",
	                                        value: _this7.state.rows[idx].sub_category_id,
	                                        className: 'form-control selectpicker', title: 'Select', disabled: _this7.state.fieldDisable },
	                                      _this7.state.categorySubTypeList_0.length > 0 && _this7.state.categorySubTypeList_0.map(function (item, i) {
	                                        return _react2.default.createElement(
	                                          'option',
	                                          { value: item.category_id },
	                                          item.category_name
	                                        );
	                                      })
	                                    ),
	                                    idx == 1 && _react2.default.createElement(
	                                      'select',
	                                      {
	                                        onChange: _this7.handleChangeCat(idx),
	                                        name: "sub_category_id",
	                                        id: "sub_category_id",
	                                        multiple: true,
	                                        value: _this7.state.rows[idx].sub_category_id,
	                                        className: 'form-control selectpicker', title: 'Select', disabled: _this7.state.fieldDisable },
	                                      _this7.state.categorySubTypeList_1.length > 0 && _this7.state.categorySubTypeList_1.map(function (item, i) {
	                                        return _react2.default.createElement(
	                                          'option',
	                                          { value: item.category_id },
	                                          item.category_name
	                                        );
	                                      })
	                                    )
	                                  ),
	                                  _react2.default.createElement(
	                                    'td',
	                                    null,
	                                    idx > 0 && _react2.default.createElement(
	                                      'button',
	                                      {
	                                        className: 'btn btn-outline-danger btn-sm',
	                                        onClick: _this7.handleRemoveSpecificRow(idx)
	                                      },
	                                      'Remove'
	                                    )
	                                  )
	                                );
	                              })
	                            )
	                          ),
	                          this.state.rows.length < 2 && _react2.default.createElement(
	                            'button',
	                            { onClick: this.handleAddRow, className: 'btn btn-primary btn-sm' },
	                            'Add More Category'
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-12 col-sm-12 text-right' },
	                        _react2.default.createElement(
	                          'button',
	                          { type: 'submit', className: 'btn orange-btn', onClick: this.handleInsFirstNext },
	                          'NEXT'
	                        )
	                      )
	                    ) : '',
	                    this.state.ins_first_next === true && this.state.showOTPform === false ? _react2.default.createElement(
	                      'div',
	                      null,
	                      _react2.default.createElement(
	                        'h1',
	                        null,
	                        'Contact  Details'
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-md-6 col-sm-6' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'form-group' },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              'Your Name ',
	                              _react2.default.createElement('i', { 'class': 'fa fa-info-circle', 'data-toggle': 'tooltip', title: 'Pease make sure only alphabets(no space)', 'aria-hidden': 'true' }),
	                              ' ',
	                              _react2.default.createElement(
	                                'span',
	                                { 'class': 'astrick' },
	                                '*'
	                              )
	                            ),
	                            _react2.default.createElement('input', {
	                              type: 'text',
	                              placeholder: 'Name',
	                              name: 'ins_first_name',
	                              value: this.state.ins_first_name,
	                              onChange: this.handleChange,
	                              className: 'form-control'
	                            }),
	                            this.validator.message('Name', this.state.ins_first_name, 'required', { className: 'text-danger' })
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-md-6 col-sm-6' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'form-group' },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              'Are you the owner?',
	                              _react2.default.createElement(
	                                'span',
	                                { 'class': 'astrick' },
	                                '*'
	                              )
	                            ),
	                            _react2.default.createElement('br', null),
	                            _react2.default.createElement('input', { type: 'radio', name: 'owner_type', checked: this.state.owner_type === '1',
	                              value: '1', onChange: this.handleChange }),
	                            ' Yes\xA0\xA0',
	                            _react2.default.createElement('input', { type: 'radio', name: 'owner_type', checked: this.state.owner_type === '2',
	                              value: '2', onChange: this.handleChange }),
	                            ' No \xA0\xA0\xA0'
	                          ),
	                          this.validator.message('owner', this.state.owner_type, 'required', { className: 'text-danger' })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        this.state.owner_type == 2 && _react2.default.createElement(
	                          'div',
	                          { className: 'col-md-6 col-sm-6' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'form-group' },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              'Designation'
	                            ),
	                            _react2.default.createElement('input', {
	                              type: 'text',
	                              placeholder: 'Designation',
	                              className: 'form-control',
	                              name: 'designation',
	                              value: this.state.designation,
	                              onChange: this.handleChange
	                            }),
	                            this.validator.message('Designation', this.state.designation, 'required|alpha_space', { className: 'text-danger' })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-md-6 col-sm-6' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'form-group' },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              'Your Login Id',
	                              _react2.default.createElement(
	                                'span',
	                                { 'class': 'astrick' },
	                                '*'
	                              )
	                            ),
	                            _react2.default.createElement('input', { type: 'text',
	                              placeholder: 'Email Address',
	                              name: 'email_address',
	                              value: this.state.email_address,
	                              onChange: this.handleChange,
	                              className: 'form-control' }),
	                            this.validator.message('Email Address', this.state.email_address, 'required|emailExist|email', { className: 'text-danger' })
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-md-6 col-sm-6' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'form-group' },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              'Mobile Number',
	                              _react2.default.createElement(
	                                'span',
	                                { 'class': 'astrick' },
	                                '*'
	                              )
	                            ),
	                            _react2.default.createElement('input', { type: 'number', name: 'phone_number',
	                              value: this.state.phone_number,
	                              placeholder: 'Mobile Number',
	                              onChange: this.handleChange, className: 'form-control' }),
	                            this.validator.message('Mobile Number', this.state.phone_number, 'required|checkMobile|min:10|max:60', { className: 'text-danger' })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-md-6 col-sm-6' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'form-group' },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              'Landline Number'
	                            ),
	                            _react2.default.createElement('input', { type: 'number', name: 'landline_number',
	                              value: this.state.landline_number,
	                              placeholder: 'Landline Number',
	                              onChange: this.handleChange, className: 'form-control' }),
	                            this.validator.message('Landline Number', this.state.landline_number, 'numeric', { className: 'text-danger' })
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-md-12 col-sm-12' },
	                          _react2.default.createElement(
	                            'h1',
	                            null,
	                            'BeWise Portal Login Details'
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-md-6 col-sm-6' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'form-group' },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              'Your User Name',
	                              _react2.default.createElement(
	                                'span',
	                                { 'class': 'astrick' },
	                                '*'
	                              )
	                            ),
	                            _react2.default.createElement('input', { type: 'text', name: 'ins_user_name', value: this.state.ins_user_name,
	                              placeholder: 'User Name',
	                              onChange: this.handleChange, className: 'form-control' }),
	                            this.validator.message('User Name', this.state.ins_user_name, 'required|alpha_num|userExist', { className: 'text-danger' })
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-md-6 col-sm-6' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'form-group' },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              'Your Password',
	                              _react2.default.createElement(
	                                'span',
	                                { 'class': 'astrick' },
	                                '*'
	                              )
	                            ),
	                            _react2.default.createElement('input', { id: 'password-field', type: this.state.showPassword ? 'text' : 'password',
	                              name: 'ins_password',
	                              value: this.state.ins_password,
	                              placeholder: 'Password',
	                              onChange: this.handleChange,
	                              className: 'form-control' }),
	                            _react2.default.createElement('span', {
	                              toggle: '#password-field',
	                              className: this.state.showPassword ? 'fa fa-fw fa-eye-slash field-icon' : 'fa fa-fw fa-eye field-icon',
	                              onClick: function onClick() {
	                                _this7.handleShowPassword();
	                              }
	                            }),
	                            this.validator.message('Password', this.state.ins_password, 'required|password_custome', { className: 'text-danger' })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-md-6 col-sm-6' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'form-group' },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              'Confirm Password',
	                              _react2.default.createElement(
	                                'span',
	                                { 'class': 'astrick' },
	                                '*'
	                              )
	                            ),
	                            _react2.default.createElement('input', { id: 'password-fieldc', type: this.state.showCPassword ? 'text' : 'password',
	                              name: 'ins_cpassword',
	                              placeholder: 'Confirm Password',
	                              value: this.state.ins_cpassword,
	                              onChange: this.handleChange,
	                              className: 'form-control' }),
	                            _react2.default.createElement('span', {
	                              toggle: '#password-field',
	                              className: this.state.showCPassword ? 'fa fa-fw fa-eye-slash field-icon' : 'fa fa-fw fa-eye field-icon',
	                              onClick: function onClick() {
	                                _this7.handleShowCPassword();
	                              }
	                            }),
	                            this.validator.message('Confirm Password', this.state.ins_cpassword, 'required|confirmpassword', { className: 'text-danger' })
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-12 col-sm-12' },
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'custom-checkboxs', style: { marginTop: "10px" } },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            _react2.default.createElement('input', { type: 'checkbox', className: '', name: 'agree',
	                              value: 'Yes', onChange: this.toggleChange, checked: this.state.agree_data }),
	                            '\xA0\xA0 I Agree to \xA0',
	                            _react2.default.createElement(
	                              'span',
	                              { style: { color: "#1492E6" } },
	                              _react2.default.createElement(
	                                'a',
	                                { href: 'javascript:window.open(\'/privacypolicy\', \'privacypolicy\', \'width=auto,height=auto\')', target: '_blank' },
	                                'Terms of service '
	                              ),
	                              'and \xA0',
	                              _react2.default.createElement(
	                                'a',
	                                { href: 'javascript:window.open(\'/privacypolicy\', \'privacypolicy\', \'width=auto,height=auto\')', target: '_blank' },
	                                'Privacy policy'
	                              ),
	                              _react2.default.createElement(
	                                'span',
	                                { 'class': 'astrick' },
	                                '*'
	                              )
	                            )
	                          )
	                        ),
	                        this.validator.message('Agree', this.state.agree_data, 'accepted', { className: 'text-danger' })
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-12 col-sm-12' },
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'custom-checkboxs', style: { marginTop: "10px" } },
	                          _react2.default.createElement(_reactRecaptcha2.default, {
	                            sitekey: _constant.GOOGLE_CAPTCHA_SITE_KEY,
	                            render: 'explicit',
	                            onloadCallback: this.recaptchaLoaded,
	                            verifyCallback: this.verifyCallback
	                          })
	                        ),
	                        this.validator.message('Google reCaptcha', this.state.isVerified, 'accepted', { className: 'text-danger' })
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-md-6 col-sm-6' },
	                          _react2.default.createElement(
	                            'button',
	                            { type: 'submit', className: 'btn orange-btn',
	                              onClick: this.handleInsFirstPre
	                            },
	                            'BACK'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-md-6 col-sm-6 text-right' },
	                          _react2.default.createElement(
	                            'button',
	                            { type: 'submit', className: 'btn orange-btn',
	                              disabled: this.state.btnDisable
	                            },
	                            this.state.btnDisable ? 'Please Wait...' : 'Submit'
	                          )
	                        )
	                      )
	                    ) : ''
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return InstitutionalSignup;
	}(_react.Component);
	
	exports.default = InstitutionalSignup;

/***/ },
/* 883 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FetchCall = __webpack_require__(4);
	
	var _reactDatepicker = __webpack_require__(279);
	
	var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
	
	__webpack_require__(267);
	
	var _reactJsonToCsv = __webpack_require__(1439);
	
	var _reactJsonToCsv2 = _interopRequireDefault(_reactJsonToCsv);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AllReports = function (_Component) {
	  _inherits(AllReports, _Component);
	
	  function AllReports(props) {
	    _classCallCheck(this, AllReports);
	
	    var _this = _possibleConstructorReturn(this, (AllReports.__proto__ || Object.getPrototypeOf(AllReports)).call(this, props));
	
	    _this.getReports = function () {
	      var req = JSON.stringify({
	        url: 'get_report_drop'
	      });
	      (0, _FetchCall.adminReport)(req).then(function (res) {
	        if (res.status === 1) {
	          _this.setState({
	            report_list: res.list
	          });
	        }
	      });
	    };
	
	    _this.handleChange = function (e) {
	      _this.setState(_defineProperty({}, e.target.name, e.target.value));
	    };
	
	    _this.download = function () {
	      _this.setState({
	        show: false
	      });
	    };
	
	    _this.handleSubmit = function (e) {
	      e.preventDefault();
	      var req = JSON.stringify({
	        report: _this.state.report,
	        start_date: _this.state.start_date,
	        end_date: _this.state.end_date,
	        url: 'get_report'
	      });
	      (0, _FetchCall.adminReport)(req).then(function (res) {
	        if (res.status === 1) {
	          if (res.result.length > 0) {
	            _this.setState({
	              download_report: res.result,
	              show: true
	            });
	          } else {
	            var toastr = '';
	            toastr = window.toastr.warning;
	            toastr('No Data Found', toastr, {
	              positionClass: "toast-bottom-right",
	              containerId: "toast-bottom-right"
	            });
	          }
	        }
	      });
	    };
	
	    _this.state = {
	      report_list: [],
	      download_report: [],
	      show: false
	    };
	    _this.getReports();
	    return _this;
	  }
	
	  _createClass(AllReports, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      window.jQuery('.selectpicker').selectpicker('refresh');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: ' col-md-8 col-xs-8' },
	          _react2.default.createElement(
	            'form',
	            { onSubmit: this.handleSubmit, autoComplete: 'off' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row form-group' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-4' },
	                _react2.default.createElement(
	                  'label',
	                  null,
	                  'Select Report'
	                ),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                  'select',
	                  { className: 'selectpicker form-control', title: 'Select Report',
	                    name: 'report', value: this.state.report, onChange: this.handleChange },
	                  this.state.report_list.map(function (item, i) {
	                    return _react2.default.createElement(
	                      'option',
	                      { value: item.ref_name },
	                      item.report_name
	                    );
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-4 report-date' },
	                _react2.default.createElement(
	                  'label',
	                  null,
	                  'Select From Date'
	                ),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(_reactDatepicker2.default, {
	                  autocomplete: 'off',
	                  onChange: function onChange(date) {
	                    return _this2.setState({ start_date: date });
	                  },
	                  className: 'form-control input-group-date',
	                  selected: this.state.start_date,
	                  name: 'start_date',
	                  id: 'start_date',
	                  dateFormat: 'yyyy-MM-dd',
	                  required: true
	                })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-4 report-date' },
	                _react2.default.createElement(
	                  'label',
	                  null,
	                  'Select To Date'
	                ),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(_reactDatepicker2.default, {
	                  autocomplete: 'off',
	                  onChange: function onChange(date) {
	                    return _this2.setState({ end_date: date });
	                  },
	                  className: 'form-control input-group-date',
	                  selected: this.state.end_date,
	                  name: 'end_date',
	                  id: 'end_date',
	                  dateFormat: 'yyyy-MM-dd',
	                  required: true
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { 'class': 'row form-group' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'col-md-12 text-center' },
	                _react2.default.createElement(
	                  'button',
	                  { className: 'btn btn-primary btn-sm mb-2' },
	                  'Submit'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'row form-group' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-6 text-left' },
	                this.state.download_report.length > 0 && _react2.default.createElement(_reactJsonToCsv2.default, { data: this.state.download_report, className: 'btn btn-success' })
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return AllReports;
	}(_react.Component);
	
	exports.default = AllReports;

/***/ },
/* 884 */
359,
/* 885 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  var bodyRef = _react2.default.createRef();
	  var createPdf = function createPdf() {
	    return props.createPdf(bodyRef.current);
	  };
	  return _react2.default.createElement(
	    "section",
	    { className: "pdf-container" },
	    _react2.default.createElement(
	      "section",
	      { className: "pdf-toolbar", style: { 'float': 'right' } },
	      _react2.default.createElement(
	        "button",
	        { onClick: createPdf, className: "btn btn-green dropdown-toggle btn-arrow" },
	        "Download Invoice"
	      )
	    ),
	    _react2.default.createElement(
	      "section",
	      { className: "pdf-body", ref: bodyRef },
	      props.children
	    )
	  );
	};

/***/ },
/* 886 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var keyList = exports.keyList = Object.keys;
	
	var noop = exports.noop = function noop() {};

/***/ },
/* 887 */
885,
/* 888 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  var bodyRef = _react2.default.createRef();
	  var createPdf = function createPdf() {
	    return props.createPdf(bodyRef.current);
	  };
	  return _react2.default.createElement(
	    "section",
	    { className: "pdf-container" },
	    _react2.default.createElement(
	      "section",
	      { className: "pdf-toolbar", style: { 'float': 'right' } },
	      _react2.default.createElement(
	        "button",
	        { onClick: createPdf, className: "btn btn-green dropdown-toggle btn-arrow" },
	        "Export as PDF"
	      )
	    ),
	    _react2.default.createElement(
	      "section",
	      { className: "pdf-body", ref: bodyRef },
	      props.children
	    )
	  );
	};

/***/ },
/* 889 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _FetchCall2 = _interopRequireDefault(_FetchCall);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import { Editor } from '@tinymce/tinymce-react';
	
	
	var adminAddRole = function (_Component) {
	  _inherits(adminAddRole, _Component);
	
	  function adminAddRole(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, adminAddRole);
	
	    var _this = _possibleConstructorReturn(this, (adminAddRole.__proto__ || Object.getPrototypeOf(adminAddRole)).call(this, props));
	
	    _this.getRoleDetail = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var req;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              req = JSON.stringify({
	                id: _this.id
	              });
	
	              (0, _FetchCall.getRoleDetail)(req).then(function (res) {
	                if (res.status === 1) {
	                  _this.setState({
	                    role: res.data.role,
	                    role_id: res.data.id,
	                    new_read_access: res.data.new_read_access,
	                    new_write_access: res.data.new_write_access,
	                    new_download_access: res.data.new_download_access
	                  });
	                }
	              });
	
	            case 2:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    }));
	    _this.getMenu = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	      var req;
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              req = JSON.stringify({
	                role: 1,
	                url: 'getMenu'
	              });
	
	              (0, _FetchCall.getRoleMenus)(req).then(function (res) {
	                if (res.status === 1) {
	                  _this.setState({
	                    menu_list: res.results
	                  });
	                }
	              });
	
	            case 2:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, _this2);
	    }));
	
	    _this.handleChange = function (e) {
	      var propName = e.target.name;
	      var propValue = e.target.value;
	      if (propName == 'role_name') _this.checkName(propValue);
	      _this.setState(_defineProperty({}, propName, propValue));
	    };
	
	    _this.checkName = function (val) {
	      var req = JSON.stringify({
	        value: val,
	        role_id: _this.state.role_id,
	        role: 1,
	        url: 'checkName'
	      });
	      (0, _FetchCall.adminRoles)(req).then(function (res) {
	        if (res.status === 1) {
	          _this.setState({
	            isNameValid: res.avail
	          });
	        }
	      });
	    };
	
	    _this.submitForm = function (e) {
	
	      var req = JSON.stringify({
	        role_name: _this.state.role_name,
	        role_id: _this.state.role_id,
	        read_access: _this.state.new_read_access,
	        write_access: _this.state.new_write_access,
	        download_access: _this.state.new_download_access
	      });
	
	      console.log(req);
	
	      (0, _FetchCall.saveRole)(req).then(function (res) {
	        var toastr = '';
	        if (res.status === 1) {
	          alert("Successfully updated");
	          _this.setState({ openAdd: false });
	
	          _this.getList();
	        } else {
	
	          alert("error");
	        }
	      });
	    };
	
	    _this.customeChangeCheckBox = function (e, i, id) {
	      var propName = e.target.name;
	
	      var propValue = id;
	      var propData = _this.state[propName];
	
	      if (propData.includes(propValue)) {
	        var _id = propData.indexOf(propValue); // 2
	        propData.splice(_id, 1);
	      } else {
	        propData.push(propValue);
	      }
	      console.log('propData', propData);
	      _this.setState(_defineProperty({}, propName, propData));
	    };
	
	    var url = new URL(window.location.href);
	    var location = url.searchParams.get("location");
	    var auth_data = JSON.parse(localStorage.getItem("user_data"));
	    _this.state = {
	      logged: localStorage.getItem("authentication"),
	      auth_data: JSON.parse(localStorage.getItem("user_data")),
	      location: location ? location : auth_data.access_location ? auth_data.access_location : 'Bengaluru',
	      menu_list: [],
	      role_id: 0,
	      new_read_access: [1],
	      new_write_access: [1],
	      new_download_access: [1]
	    };
	
	    _this.id = _this.props.match.params.id ? _this.props.match.params.id : '';
	
	    if (_this.id != '') _this.getRoleDetail();
	
	    _this.getMenu();
	
	    return _this;
	  }
	
	  _createClass(adminAddRole, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          menu_list = _state.menu_list,
	          new_read_access = _state.new_read_access,
	          new_write_access = _state.new_write_access,
	          new_download_access = _state.new_download_access,
	          role_id = _state.role_id;
	
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'col-lg-12 grid-margin stretch-card' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card-body' },
	                _react2.default.createElement(
	                  'h4',
	                  { 'class': 'card-title' },
	                  'Roles'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'row' },
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'col-lg-12' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'box-shadow-custom' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'form-group col-md-4' },
	                          _react2.default.createElement(
	                            'label',
	                            { className: 'text-capitalize' },
	                            'Role Name',
	                            _react2.default.createElement(
	                              'span',
	                              { className: 'astrick' },
	                              '*'
	                            )
	                          ),
	                          _react2.default.createElement('input', { type: 'text', className: 'form-control', onChange: this.handleChange, name: 'role_name', value: this.state.role })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'form-group col-md-12' },
	                          _react2.default.createElement(
	                            'table',
	                            { className: 'table table-bordered' },
	                            _react2.default.createElement(
	                              'thead',
	                              null,
	                              _react2.default.createElement(
	                                'tr',
	                                null,
	                                _react2.default.createElement(
	                                  'th',
	                                  null,
	                                  'Menu'
	                                ),
	                                _react2.default.createElement(
	                                  'th',
	                                  null,
	                                  'Read Access'
	                                ),
	                                _react2.default.createElement(
	                                  'th',
	                                  null,
	                                  'Write Access'
	                                ),
	                                _react2.default.createElement(
	                                  'th',
	                                  null,
	                                  'Download Access'
	                                )
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'tbody',
	                              null,
	                              menu_list.map(function (item, i) {
	                                var subList = menu_list.filter(function (data) {
	                                  return data.parent_id == item.id;
	                                });
	                                if (item.parent_id == 0) {
	                                  var checkedR = new_read_access.includes(item.id) ? true : false;
	                                  var checkedW = new_write_access.includes(item.id) ? true : false;
	                                  var checkedD = new_download_access.includes(item.id) ? true : false;
	
	                                  return _react2.default.createElement(
	                                    _react2.default.Fragment,
	                                    null,
	                                    _react2.default.createElement(
	                                      'tr',
	                                      null,
	                                      _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        _react2.default.createElement(
	                                          'b',
	                                          null,
	                                          item.menu_name
	                                        )
	                                      ),
	                                      _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        _react2.default.createElement('input', { className: 'form-control checkbox-cus', defaultChecked: checkedR, checked: checkedR,
	                                          type: 'checkbox', name: 'new_read_access', value: item.id, onChange: function onChange(e) {
	                                            return _this3.customeChangeCheckBox(e, i, item.id);
	                                          } })
	                                      ),
	                                      item.is_parent == 0 && _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        _react2.default.createElement('input', { className: 'form-control checkbox-cus', defaultChecked: checkedW, checked: checkedW,
	                                          type: 'checkbox', name: 'new_write_access', value: item.id, onChange: function onChange(e) {
	                                            return _this3.customeChangeCheckBox(e, i, item.id);
	                                          } })
	                                      ),
	                                      item.is_parent == 0 && _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        _react2.default.createElement('input', { className: 'form-control checkbox-cus', defaultChecked: checkedD, checked: checkedW,
	                                          type: 'checkbox', name: 'new_download_access', value: item.id, onChange: function onChange(e) {
	                                            return _this3.customeChangeCheckBox(e, i, item.id);
	                                          } })
	                                      )
	                                    ),
	                                    subList.map(function (sitem, j) {
	                                      var checkedRs = i === 0 ? true : new_read_access.includes(sitem.id) ? true : false;
	                                      var checkedWs = i === 0 ? true : new_write_access.includes(sitem.id) ? true : false;
	                                      var checkedDs = i === 0 ? true : new_download_access.includes(sitem.id) ? true : false;
	                                      var disabled = sitem.menu_name === 'Role' ? true : false;
	                                      return _react2.default.createElement(
	                                        'tr',
	                                        null,
	                                        _react2.default.createElement(
	                                          'td',
	                                          null,
	                                          ' ------- ',
	                                          sitem.menu_name
	                                        ),
	                                        _react2.default.createElement(
	                                          'td',
	                                          null,
	                                          _react2.default.createElement('input', { className: 'form-control checkbox-cus', defaultChecked: checkedRs, checked: checkedRs,
	                                            type: 'checkbox', name: 'new_read_access', value: item.id, onChange: function onChange(e) {
	                                              return _this3.customeChangeCheckBox(e, j, sitem.id);
	                                            } })
	                                        ),
	                                        _react2.default.createElement(
	                                          'td',
	                                          null,
	                                          _react2.default.createElement('input', { className: 'form-control checkbox-cus', defaultChecked: checkedWs, checked: checkedWs,
	                                            type: 'checkbox', name: 'new_write_access', value: item.id, onChange: function onChange(e) {
	                                              return _this3.customeChangeCheckBox(e, j, sitem.id);
	                                            } })
	                                        ),
	                                        _react2.default.createElement(
	                                          'td',
	                                          null,
	                                          _react2.default.createElement('input', { className: 'form-control checkbox-cus', defaultChecked: checkedDs, checked: checkedDs,
	                                            type: 'checkbox', name: 'new_download_access', value: item.id, onChange: function onChange(e) {
	                                              return _this3.customeChangeCheckBox(e, j, sitem.id);
	                                            } })
	                                        )
	                                      );
	                                    })
	                                  );
	                                }
	                              })
	                            )
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-md-12 col-xs-12 btn-bdr' },
	                      _react2.default.createElement(
	                        'button',
	                        { id: 'btnSubmit', className: 'btn btn-primary btn-sm', onClick: this.submitForm },
	                        'Submit'
	                      ),
	                      ' \xA0 ',
	                      _react2.default.createElement(
	                        'a',
	                        { href: '/admin/roles', className: 'btn btn-primary btn-sm' },
	                        'List'
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return adminAddRole;
	}(_react.Component);
	
	exports.default = adminAddRole;

/***/ },
/* 890 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _FetchCall2 = _interopRequireDefault(_FetchCall);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import { Editor } from '@tinymce/tinymce-react';
	
	
	var gst = function (_Component) {
	  _inherits(gst, _Component);
	
	  function gst(props) {
	    _classCallCheck(this, gst);
	
	    var _this = _possibleConstructorReturn(this, (gst.__proto__ || Object.getPrototypeOf(gst)).call(this, props));
	
	    _this.handleChange = function (e) {
	      _this.setState(_defineProperty({}, e.target.name, e.target.value));
	    };
	
	    _this.getGST = function () {
	      var _this$state$auth_data = _this.state.auth_data,
	          login_id = _this$state$auth_data.login_id,
	          role = _this$state$auth_data.role;
	
	      var ins = JSON.stringify({
	        vendor_id: login_id,
	        role: role
	      });
	      (0, _FetchCall.getGST)(ins).then(function (res) {
	        if (res.status == 1) {
	          _this.setState({
	            gst: res.data.gst,
	            cgst: res.data.cgst,
	            sgst: res.data.sgst
	
	          });
	        }
	      });
	    };
	
	    _this.submitForm = function (e) {
	
	      var req = JSON.stringify({
	        gst: _this.state.gst,
	        cgst: _this.state.cgst,
	        sgst: _this.state.sgst,
	        id: 1
	      });
	
	      console.log(req);
	
	      (0, _FetchCall.saveGST)(req).then(function (res) {
	        var toastr = '';
	        if (res.status === 1) {
	          alert("dfdf");
	        } else {
	          alert("error");
	        }
	      });
	    };
	
	    var url = new URL(window.location.href);
	    var location = url.searchParams.get("location");
	    var auth_data = JSON.parse(localStorage.getItem("user_data"));
	    _this.state = {
	      logged: localStorage.getItem("authentication"),
	      auth_data: JSON.parse(localStorage.getItem("user_data")),
	      location: location ? location : auth_data.access_location ? auth_data.access_location : 'Bengaluru',
	      gsts: [],
	      cgst: '',
	      sgst: ''
	    };
	
	    _this.getGST();
	    return _this;
	  }
	
	  _createClass(gst, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	
	      var THIS = this;
	      (0, _jquery2.default)(document).on('click', '.remove_school', function () {
	        var delete_id = (0, _jquery2.default)(this).data("id");
	        THIS.setState({
	          delete_id: delete_id
	        });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'col-lg-12 grid-margin stretch-card' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card-body' },
	                _react2.default.createElement(
	                  'h4',
	                  { 'class': 'card-title' },
	                  'GST (taxes) '
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'row' },
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'col-lg-12' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'box-shadow-custom' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'form-group col-md-4' },
	                          _react2.default.createElement(
	                            'label',
	                            { className: 'text-capitalize' },
	                            'BeWise\'s GST number',
	                            _react2.default.createElement(
	                              'span',
	                              { className: 'astrick' },
	                              '*'
	                            )
	                          ),
	                          _react2.default.createElement('input', { type: 'text', className: 'form-control', onChange: this.handleChange, name: 'gst', value: this.state.gst })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'form-group col-md-4' },
	                          _react2.default.createElement(
	                            'label',
	                            { className: 'text-capitalize' },
	                            'CGST(%)',
	                            _react2.default.createElement(
	                              'span',
	                              { className: 'astrick' },
	                              '*'
	                            )
	                          ),
	                          _react2.default.createElement('input', { type: 'text', className: 'form-control', onChange: this.handleChange, name: 'cgst', value: this.state.cgst })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'form-group col-md-4' },
	                          _react2.default.createElement(
	                            'label',
	                            { className: 'text-capitalize' },
	                            'SGST(%)',
	                            _react2.default.createElement(
	                              'span',
	                              { className: 'astrick' },
	                              '*'
	                            )
	                          ),
	                          _react2.default.createElement('input', { type: 'text', className: 'form-control', onChange: this.handleChange, name: 'sgst', value: this.state.sgst })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-md-12 col-xs-12 btn-bdr' },
	                      _react2.default.createElement(
	                        'button',
	                        { id: 'btnSubmit', className: 'btn btn-primary btn-sm', onClick: this.submitForm },
	                        'Submit'
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return gst;
	}(_react.Component);
	
	exports.default = gst;

/***/ },
/* 891 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _FetchCall2 = _interopRequireDefault(_FetchCall);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import { Editor } from '@tinymce/tinymce-react';
	
	
	var packages = function (_Component) {
	  _inherits(packages, _Component);
	
	  function packages(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, packages);
	
	    var _this = _possibleConstructorReturn(this, (packages.__proto__ || Object.getPrototypeOf(packages)).call(this, props));
	
	    _this.packageList = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var _this$state$auth_data, login_id, role, ins, res;
	
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _this$state$auth_data = _this.state.auth_data, login_id = _this$state$auth_data.login_id, role = _this$state$auth_data.role;
	              ins = JSON.stringify({
	                vendor_id: login_id,
	                role: role,
	                path: window.location.pathname
	              });
	              _context.next = 4;
	              return (0, _FetchCall.getPlanList)(ins);
	
	            case 4:
	              res = _context.sent;
	
	              if (res.status == 1) {
	                _this.setState({
	                  package_list: res.list
	                });
	              }
	
	            case 6:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    }));
	
	    var url = new URL(window.location.href);
	    var location = url.searchParams.get("location");
	    var auth_data = JSON.parse(localStorage.getItem("user_data"));
	    _this.state = {
	      logged: localStorage.getItem("authentication"),
	      auth_data: JSON.parse(localStorage.getItem("user_data")),
	      location: location ? location : auth_data.access_location ? auth_data.access_location : 'Bengaluru',
	      package_list: []
	    };
	    _this.packageList();
	    return _this;
	  }
	
	  _createClass(packages, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	
	      var THIS = this;
	      (0, _jquery2.default)(document).on('click', '.remove_school', function () {
	        var delete_id = (0, _jquery2.default)(this).data("id");
	        THIS.setState({
	          delete_id: delete_id
	        });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var package_list = this.state.package_list;
	
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'col-lg-12 grid-margin stretch-card' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card-body' },
	                _react2.default.createElement(
	                  'h4',
	                  { 'class': 'card-title' },
	                  'Packages'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'float-right' },
	                  _react2.default.createElement(
	                    'button',
	                    { 'class': 'btn btn-primary btn-sm', onClick: this.openAdd },
	                    'Add New'
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'table-responsive pt-3' },
	                  _react2.default.createElement(
	                    'table',
	                    { 'class': 'table table-bordered table-sm' },
	                    _react2.default.createElement(
	                      'thead',
	                      null,
	                      _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'S.No'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Plan name'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Price(INR)'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Type'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Action'
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'tbody',
	                      null,
	                      package_list.map(function (item, i) {
	
	                        return _react2.default.createElement(
	                          'tr',
	                          null,
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            i + 1
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.plan_name
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.plan_price
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.plan_type
	                          ),
	                          _react2.default.createElement('td', { dangerouslySetInnerHTML: { __html: item.action } })
	                        );
	                      })
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return packages;
	}(_react.Component);
	
	exports.default = packages;

/***/ },
/* 892 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _FetchCall2 = _interopRequireDefault(_FetchCall);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import { Editor } from '@tinymce/tinymce-react';
	
	
	var roles = function (_Component) {
	  _inherits(roles, _Component);
	
	  function roles(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, roles);
	
	    var _this = _possibleConstructorReturn(this, (roles.__proto__ || Object.getPrototypeOf(roles)).call(this, props));
	
	    _this.getRoleDetail = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var req;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              req = JSON.stringify({
	                id: _this.state.id
	              });
	
	              (0, _FetchCall.getRoleDetail)(req).then(function (res) {
	                if (res.status === 1) {
	                  _this.setState({
	                    role: res.detail.role,
	                    new_read_access: res.detail.new_read_access,
	                    new_write_access: res.detail.new_write_access,
	                    new_download_access: res.detail.new_download_access
	                  });
	                }
	              });
	
	            case 2:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    }));
	
	    _this.getList = function () {
	      var _this$state$auth_data = _this.state.auth_data,
	          login_id = _this$state$auth_data.login_id,
	          role = _this$state$auth_data.role;
	
	      var ins = JSON.stringify({
	        vendor_id: login_id,
	        role: role
	      });
	      (0, _FetchCall.getRoleListV1)(ins).then(function (res) {
	        if (res.status == 1) {
	          _this.setState({
	            roleList: res.list
	
	          });
	        } else {
	          _this.setState({
	            roleList: []
	          });
	        }
	      });
	    };
	
	    var url = new URL(window.location.href);
	    var location = url.searchParams.get("location");
	    var auth_data = JSON.parse(localStorage.getItem("user_data"));
	    _this.state = {
	      logged: localStorage.getItem("authentication"),
	      auth_data: JSON.parse(localStorage.getItem("user_data")),
	      location: location ? location : auth_data.access_location ? auth_data.access_location : 'Bengaluru',
	      roleList: [],
	      menu_list: [],
	      role_id: 0,
	      openAdd: false
	    };
	
	    _this.getList();
	
	    return _this;
	  }
	
	  _createClass(roles, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	
	      var THIS = this;
	      (0, _jquery2.default)(document).on('click', '.remove_role', function () {
	        var delete_id = (0, _jquery2.default)(this).data("id");
	        THIS.setState({
	          delete_id: delete_id
	        });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          roleList = _state.roleList,
	          menu_list = _state.menu_list;
	
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'col-lg-12 grid-margin stretch-card' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card-body' },
	                _react2.default.createElement(
	                  'h4',
	                  { 'class': 'card-title' },
	                  'Roles'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'float-right' },
	                  _react2.default.createElement(
	                    'a',
	                    { href: '/admin/roles/add', 'class': 'btn btn-primary btn-sm' },
	                    'Add New'
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'table-responsive pt-3' },
	                  _react2.default.createElement(
	                    'table',
	                    { 'class': 'table table-bordered table-sm' },
	                    _react2.default.createElement(
	                      'thead',
	                      null,
	                      _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'S.No'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Role'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Action'
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'tbody',
	                      null,
	                      roleList.map(function (item, i) {
	
	                        return _react2.default.createElement(
	                          'tr',
	                          null,
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            i + 1
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.role
	                          ),
	                          _react2.default.createElement('td', { dangerouslySetInnerHTML: { __html: item.action } })
	                        );
	                      })
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return roles;
	}(_react.Component);
	
	exports.default = roles;

/***/ },
/* 893 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _bsButton;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _reactFileuploadProgress = __webpack_require__(1381);
	
	var _reactFileuploadProgress2 = _interopRequireDefault(_reactFileuploadProgress);
	
	var _constant = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var styles = {
	  progressWrapper: {
	    height: '20px',
	    marginTop: '10px',
	    width: '400px',
	    float: 'left',
	    overflow: 'hidden',
	    backgroundColor: '#f5f5f5',
	    borderRadius: '4px',
	    WebkitBoxShadow: 'inset 0 1px 2px rgba(0,0,0,.1)',
	    boxShadow: 'inset 0 1px 2px rgba(0,0,0,.1)'
	  },
	  progressBar: {
	    float: 'left',
	    width: '0',
	    height: '100%',
	    fontSize: '12px',
	    lineHeight: '20px',
	    color: '#fff',
	    textAlign: 'center',
	    backgroundColor: '#471BF5',
	    WebkitBoxShadow: 'inset 0 -1px 0 rgba(0,0,0,.15)',
	    boxShadow: 'inset 0 -1px 0 rgba(0,0,0,.15)',
	    WebkitTransition: 'width .6s ease',
	    Otransition: 'width .6s ease',
	    transition: 'width .6s ease'
	  },
	  cancelButton: {
	    marginTop: '5px',
	    WebkitAppearance: 'none',
	    padding: 0,
	    cursor: 'pointer',
	    background: '0 0',
	    border: 0,
	    float: 'left',
	    fontSize: '21px',
	    fontWeight: 700,
	    lineHeight: 1,
	    color: '#000',
	    textShadow: '0 1px 0 #fff',
	    filter: 'alpha(opacity=20)',
	    opacity: '.2'
	  },
	
	  bslabel: {
	    display: 'inline-block',
	    maxWidth: '100%',
	    marginBottom: '5px',
	    fontWeight: 700
	  },
	
	  bsHelp: {
	    display: 'block',
	    marginTop: '5px',
	    marginBottom: '10px',
	    color: '#737373'
	  },
	
	  bsButton: (_bsButton = {
	    padding: '1px 5px',
	    fontSize: '12px',
	    lineHeight: '1.5',
	    borderRadius: '3px',
	    color: '#fff',
	    backgroundColor: '#337ab7',
	    borderColor: '#2e6da4',
	    display: 'inline-block'
	  }, _defineProperty(_bsButton, 'padding', '6px 12px'), _defineProperty(_bsButton, 'marginBottom', 0), _defineProperty(_bsButton, 'fontWeight', 400), _defineProperty(_bsButton, 'textAlign', 'center'), _defineProperty(_bsButton, 'whiteSpace', 'nowrap'), _defineProperty(_bsButton, 'verticalAlign', 'middle'), _defineProperty(_bsButton, 'touchAction', 'manipulation'), _defineProperty(_bsButton, 'cursor', 'pointer'), _defineProperty(_bsButton, 'WebkitUserSelect', 'none'), _defineProperty(_bsButton, 'MozUserSelect', 'none'), _defineProperty(_bsButton, 'msUserSelect', 'none'), _defineProperty(_bsButton, 'userSelect', 'none'), _defineProperty(_bsButton, 'backgroundImage', 'none'), _defineProperty(_bsButton, 'border', '1px solid transparent'), _bsButton)
	};
	
	var DEFAULT_START = 0;
	var DEFAULT_LIMIT = 5;
	
	//const pm2 = require('pm2')
	
	var azupload = function (_Component) {
	  _inherits(azupload, _Component);
	
	  function azupload(props) {
	    _classCallCheck(this, azupload);
	
	    var _this = _possibleConstructorReturn(this, (azupload.__proto__ || Object.getPrototypeOf(azupload)).call(this, props));
	
	    _this.listBlob = function () {
	      var _this$state$auth_data = _this.state.auth_data,
	          login_id = _this$state$auth_data.login_id,
	          role = _this$state$auth_data.role;
	
	      var ins = JSON.stringify({});
	      (0, _FetchCall.getBlobList)(ins).then(function (res) {
	        if (res.status == 1) {
	          _this.setState({
	            list: res.result
	          });
	        }
	      });
	    };
	
	    return _this;
	  }
	
	  _createClass(azupload, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {}
	  }, {
	    key: 'customFormRenderer',
	    value: function customFormRenderer(onSubmit) {
	      return _react2.default.createElement(
	        'form',
	        { id: 'customForm', style: { marginBottom: '15px' } },
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'exampleInputFile' },
	          'Upload File'
	        ),
	        _react2.default.createElement('input', { style: { display: 'block' }, type: 'file', name: 'file', id: 'exampleInputFile' }),
	        _react2.default.createElement('input', { type: 'hidden', name: 'teacher_id', value: this.id }),
	        _react2.default.createElement(
	          'button',
	          { type: 'button', 'class': 'btn btn-upload-sm', onClick: onSubmit },
	          'Upload'
	        )
	      );
	    }
	  }, {
	    key: 'formGetter',
	    value: function formGetter() {
	      return new FormData(document.getElementById('customForm'));
	    }
	  }, {
	    key: 'customProgressRenderer',
	    value: function customProgressRenderer(progress, hasError, cancelHandler) {
	      if (hasError || progress > -1) {
	        var barStyle = Object.assign({}, styles.progressBar);
	        barStyle.width = progress + '%';
	
	        var message = _react2.default.createElement(
	          'span',
	          null,
	          barStyle.width
	        );
	        if (hasError) {
	          barStyle.backgroundColor = '#d9534f';
	          message = _react2.default.createElement(
	            'span',
	            { style: { 'color': '#a94442' } },
	            'Failed to upload ...'
	          );
	        }
	        if (progress === 100) {
	          message = _react2.default.createElement(
	            'span',
	            null,
	            'Done'
	          );
	        }
	
	        return _react2.default.createElement(
	          'div',
	          { style: { margin: "20px" } },
	          _react2.default.createElement(
	            'div',
	            { style: styles.progressWrapper },
	            _react2.default.createElement('div', { style: barStyle })
	          ),
	          _react2.default.createElement(
	            'button',
	            { style: styles.cancelButton, onClick: cancelHandler },
	            _react2.default.createElement(
	              'span',
	              null,
	              '\xD7'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: { 'clear': 'left' } },
	            message
	          )
	        );
	      } else {
	        return;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'uploadFile' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'subtitle_popup' },
	              'Uploading picture to Azure Blog Test'
	            ),
	            _react2.default.createElement(
	              'div',
	              { 'class': 'formgroup' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'forminput' },
	                _react2.default.createElement(_reactFileuploadProgress2.default, { key: 'ex2', url: _constant.IMGBASEURL + '/api/az/uploadazblob', method: 'post',
	                  onProgress: function onProgress(e, request, progress) {
	                    console.log('progress', e, request, progress);
	                  },
	                  onLoad: function onLoad(e, request) {
	                    console.log('load', e, request);
	                  },
	                  onError: function onError(e, request) {
	                    console.log('error', e, request);
	                  },
	                  onAbort: function onAbort(e, request) {
	                    console.log('abort', e, request);
	                  },
	                  formGetter: this.formGetter.bind(this),
	                  formRenderer: this.customFormRenderer.bind(this),
	                  progressRenderer: this.customProgressRenderer.bind(this)
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { 'class': 'listfiles' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement('input', { type: 'button', name: 'listbtn', onClick: this.listBlob, value: 'List Files' })
	            ),
	            _react2.default.createElement('div', { 'class': 'list' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return azupload;
	}(_react.Component);
	
	exports.default = azupload;

/***/ },
/* 894 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _FetchCall2 = _interopRequireDefault(_FetchCall);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import { Editor } from '@tinymce/tinymce-react';
	
	
	var bewiseCuratedCamps = function (_Component) {
	  _inherits(bewiseCuratedCamps, _Component);
	
	  function bewiseCuratedCamps(props) {
	    _classCallCheck(this, bewiseCuratedCamps);
	
	    var _this = _possibleConstructorReturn(this, (bewiseCuratedCamps.__proto__ || Object.getPrototypeOf(bewiseCuratedCamps)).call(this, props));
	
	    _this.openAddBox = function () {
	
	      _this.setState({ openedAdd: true });
	    };
	
	    _this.handleChange = function (e) {
	      _this.setState(_defineProperty({}, e.target.name, e.target.value));
	    };
	
	    _this.saveCity = function () {
	
	      var req = JSON.stringify({
	        city: _this.state.city,
	        latitude: _this.state.latitude,
	        longtitude: _this.state.longtitude
	      });
	
	      (0, _FetchCall.saveCity)(req).then(function (response) {
	
	        if (response.status == 1) {
	
	          alert("success");
	          _this.getCityList();
	        } else {
	          alert("error");
	        }
	      });
	    };
	
	    _this.getBeWiseCuratedCampList = function () {
	      var _this$state$auth_data = _this.state.auth_data,
	          login_id = _this$state$auth_data.login_id,
	          role = _this$state$auth_data.role;
	
	      var ins = JSON.stringify({
	        vendor_id: login_id,
	        role: role
	      });
	      (0, _FetchCall.getBeWiseCuratedCampList)(ins).then(function (res) {
	        if (res.status == 1) {
	          _this.setState({
	            camplist: res.data
	
	          });
	        } else {
	          _this.setState({
	            camplist: []
	          });
	        }
	      });
	    };
	
	    var url = new URL(window.location.href);
	    var location = url.searchParams.get("location");
	    var auth_data = JSON.parse(localStorage.getItem("user_data"));
	    _this.state = {
	      logged: localStorage.getItem("authentication"),
	      auth_data: JSON.parse(localStorage.getItem("user_data")),
	      location: location ? location : auth_data.access_location ? auth_data.access_location : 'Bengaluru',
	      camplist: [],
	      openedAdd: false
	    };
	
	    _this.getBeWiseCuratedCampList();
	    return _this;
	  }
	
	  _createClass(bewiseCuratedCamps, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	
	      var THIS = this;
	      (0, _jquery2.default)(document).on('click', '.remove_camp', function () {
	        var delete_id = (0, _jquery2.default)(this).data("id");
	        THIS.setState({
	          delete_id: delete_id
	        });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var camplist = this.state.camplist;
	
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'col-lg-12 grid-margin stretch-card' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card-body' },
	                _react2.default.createElement(
	                  'h4',
	                  { 'class': 'card-title' },
	                  'BeWise Curated Camps'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'row col-lg-12' },
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'pt-3 table-responsive' },
	                    _react2.default.createElement(
	                      'table',
	                      { 'class': 'table table-bordered table-striped table-sm' },
	                      _react2.default.createElement(
	                        'thead',
	                        { 'class': 'thead-dark' },
	                        _react2.default.createElement(
	                          'tr',
	                          null,
	                          _react2.default.createElement(
	                            'th',
	                            null,
	                            _react2.default.createElement(
	                              'strong',
	                              null,
	                              'S.No'
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'th',
	                            null,
	                            _react2.default.createElement(
	                              'strong',
	                              null,
	                              'Camp Name'
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'th',
	                            null,
	                            _react2.default.createElement(
	                              'strong',
	                              null,
	                              'Approval Status'
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'th',
	                            null,
	                            _react2.default.createElement(
	                              'strong',
	                              null,
	                              'Published'
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'th',
	                            null,
	                            _react2.default.createElement(
	                              'strong',
	                              null,
	                              'Action'
	                            )
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'tbody',
	                        null,
	                        camplist.map(function (item, i) {
	
	                          return _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                              'td',
	                              null,
	                              i + 1
	                            ),
	                            _react2.default.createElement(
	                              'td',
	                              null,
	                              item.camp_name
	                            ),
	                            _react2.default.createElement('td', { dangerouslySetInnerHTML: { __html: item.status } }),
	                            _react2.default.createElement('td', { dangerouslySetInnerHTML: { __html: item.published } }),
	                            _react2.default.createElement('td', { 'class': 'actionbtns', dangerouslySetInnerHTML: { __html: item.action } })
	                          );
	                        })
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return bewiseCuratedCamps;
	}(_react.Component);
	
	exports.default = bewiseCuratedCamps;

/***/ },
/* 895 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _FetchCall2 = _interopRequireDefault(_FetchCall);
	
	var _reactGeocode = __webpack_require__(55);
	
	var _reactGeocode2 = _interopRequireDefault(_reactGeocode);
	
	var _tinymceReact = __webpack_require__(69);
	
	var _constant = __webpack_require__(21);
	
	var _reactAutosuggest = __webpack_require__(86);
	
	var _reactAutosuggest2 = _interopRequireDefault(_reactAutosuggest);
	
	var _simpleReactValidator = __webpack_require__(28);
	
	var _simpleReactValidator2 = _interopRequireDefault(_simpleReactValidator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import { Editor } from '@tinymce/tinymce-react';
	
	_reactGeocode2.default.setApiKey("AIzaSyA9MtbfG_zlo64B2lqNMvigTBuXHkagKcE");
	_reactGeocode2.default.setLanguage("en");
	_reactGeocode2.default.setRegion("es");
	_reactGeocode2.default.enableDebug();
	
	var bewiseEditCuratedCamp = function (_Component) {
	    _inherits(bewiseEditCuratedCamp, _Component);
	
	    function bewiseEditCuratedCamp(props) {
	        var _this$state;
	
	        _classCallCheck(this, bewiseEditCuratedCamp);
	
	        var _this = _possibleConstructorReturn(this, (bewiseEditCuratedCamp.__proto__ || Object.getPrototypeOf(bewiseEditCuratedCamp)).call(this, props));
	
	        _initialiseProps.call(_this);
	
	        var qrystr = window.location.search;
	        var urlParams = new URLSearchParams(qrystr);
	        var sid = urlParams.get('sid');
	        _this.state = (_this$state = {
	            formValues: [{ name: "",
	                pid: "",
	                enddate: "",
	                fromdate: "",
	                starttime: "",
	                endtime: "",
	                feeinr: "",
	                feeusd: "",
	                duration: "",
	                days: "",
	                participants: "" }],
	            sid: sid != null ? sid : -1,
	            category_data: [],
	            subcategoriesselected: [],
	            totalcategoryselected: [],
	            preselectsubcategories: [],
	            sub_categorycollected: [],
	            mainvendorcategory: [],
	            subcategory_data: [],
	            AgeList: [],
	            showsuggest: false,
	            suggestions: '',
	            errors: [],
	            about_camp: '',
	            about_partner: '',
	            pageid: '',
	            invities: '',
	            latitude: '',
	            longitude: '',
	            other_rating: '',
	            student_ratio: '',
	            approval_status: '',
	            tution_type: '',
	            vendor_id: '',
	            tutionList: [],
	            attachment_file: [],
	            attachment_file_length: 0,
	            attachment_fileName: [],
	            edit_banner: '',
	            profile_image: '',
	            edit_profile_image: '',
	            edit_brochure: '',
	            delete_array: [],
	            categorySubTypeList: [],
	            sub_type: '',
	            cat_type: false,
	            tempBanner: '',
	            tempProfile: '',
	            tempBrochure: '',
	            has_trail: 0,
	            trail_desc: '',
	            location_list: [],
	            value: '',
	            partner_type: '',
	            prerequisites: '',
	            programs: [],
	            program_duration: [{ name: "" }],
	            program_days: [{ name: "" }],
	            program_names: [{ name: "" }],
	            program_todates: [{ name: "" }],
	            program_fromdates: [{ name: "" }],
	            program_starttime: [{ name: "" }],
	            program_endtime: [{ name: "" }],
	            program_feeinr: [{ name: "" }],
	            program_feeusd: [{ name: "" }]
	        }, _defineProperty(_this$state, 'vendor_id', ''), _defineProperty(_this$state, 'files', []), _defineProperty(_this$state, 'auth_data', JSON.parse(localStorage.getItem("user_data"))), _defineProperty(_this$state, 'user_data', localStorage.getItem('user_data') ? JSON.parse(localStorage.getItem('user_data')) : []), _defineProperty(_this$state, 'authentication', localStorage.getItem('authentication') ? JSON.parse(localStorage.getItem('authentication')) : false), _this$state);
	        _this.validator = new _simpleReactValidator2.default({
	            validators: {
	                checkExist: { // name the rule
	                    message: 'The :attribute field is required.',
	                    rule: function rule(val, params, validator) {
	                        if (val == '' && _this.state.edit_image == '') {
	                            return false;
	                        }
	                    },
	                    messageReplace: function messageReplace(message, params) {
	                        return message.replace(':values', _this.helpers.toSentence(params));
	                    }, // optional
	                    required: true // optional
	                },
	                emailExist_check: { // name the rule
	                    message: 'The :attribute Already Exist.',
	                    rule: function rule(val, params, validator) {
	                        return _this.state.isEmailValid;
	                    },
	                    messageReplace: function messageReplace(message, params) {
	                        return message.replace(':values', _this.helpers.toSentence(params));
	                    }, // optional
	                    required: true // optional
	                },
	                checkMobile: _constant.MOBILE_REGEX,
	                checkUrl: _constant.URL_REGEX
	            }
	        });
	
	        _this.tutionList();
	        _this.camp_id = _this.props.match.params.camp_id ? _this.props.match.params.camp_id : '';
	        if (_this.camp_id !== undefined) {
	            _this.CuratedCampDetails = _this.CuratedCampDetails.bind(_this);
	            _this.CuratedCampDetails(_this.camp_id);
	        }
	
	        _this.loadFile = _this.loadFile.bind(_this);
	        _this.handleEditorChange = _this.handleEditorChange.bind(_this);
	        _this.handleEditorPartnerChange = _this.handleEditorPartnerChange.bind(_this);
	        _this.handleCustomeSelect = _this.handleCustomeSelect.bind(_this);
	        //this.handleSubCatSelect = this.handleSubCatSelect.bind(this);
	
	        _this.handleEditorPrerequisites = _this.handleEditorPrerequisites.bind(_this);
	        _this.handleSubmit = _this.handleSubmit.bind(_this);
	
	        return _this;
	    }
	
	    _createClass(bewiseEditCuratedCamp, [{
	        key: 'deleteCamp',
	        value: function deleteCamp(i, e) {
	            var _this2 = this;
	
	            if (window.confirm("Are you sure?")) {
	
	                var req_c = JSON.stringify({
	                    camp_id: this.camp_id
	                });
	                var THIS = this;
	                var toastr = '';
	                (0, _FetchCall.deleteCamp)(req_c).then(function () {
	                    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(res) {
	                        return _regenerator2.default.wrap(function _callee$(_context) {
	                            while (1) {
	                                switch (_context.prev = _context.next) {
	                                    case 0:
	                                        if (res.status === 1) {
	
	                                            toastr = window.toastr.success;
	                                            toastr('', res.message, {
	                                                positionClass: "toast-bottom-right",
	                                                containerId: "toast-bottom-right"
	                                            });
	                                            _this2.props.history.push('/admincuratedcamps');
	                                        }
	
	                                    case 1:
	                                    case 'end':
	                                        return _context.stop();
	                                }
	                            }
	                        }, _callee, _this2);
	                    }));
	
	                    return function (_x) {
	                        return _ref.apply(this, arguments);
	                    };
	                }());
	            }
	        }
	    }, {
	        key: 'handleChangev1',
	        value: function handleChangev1(i, e) {
	            var formValues = this.state.formValues;
	            formValues[i][e.target.name] = e.target.value;
	            this.setState({ formValues: formValues });
	        }
	    }, {
	        key: 'addFormFieldsv1',
	        value: function addFormFieldsv1() {
	            this.setState({
	                formValues: [].concat(_toConsumableArray(this.state.formValues), [{
	                    pid: "",
	                    name: "",
	                    enddate: "",
	                    fromdate: "",
	                    starttime: "",
	                    feeinr: "",
	                    feeusd: "",
	                    duration: "",
	                    days: "",
	                    participants: "" }])
	            });
	        }
	    }, {
	        key: 'removeFormFieldsv1',
	        value: function removeFormFieldsv1(i) {
	            var formValues = this.state.formValues;
	            formValues.splice(i, 1);
	            this.setState({ formValues: formValues });
	        }
	    }, {
	        key: 'handleEditorChange',
	        value: function handleEditorChange(value, editor) {
	            //console.log(value);
	            this.setState({
	                about_camp: value
	            });
	        }
	    }, {
	        key: 'handleEditorPartnerChange',
	        value: function handleEditorPartnerChange(value, editor) {
	            //console.log(value);
	            this.setState({
	                about_partner: value
	            });
	        }
	    }, {
	        key: 'handleEditorAbout',
	        value: function handleEditorAbout(value, editor) {
	            //console.log(value);
	            this.setState({
	                about_camp: value
	            });
	        }
	    }, {
	        key: 'handleEditorParnter',
	        value: function handleEditorParnter(value, editor) {
	            //console.log(value);
	            this.setState({
	                about_partner: value
	            });
	        }
	    }, {
	        key: 'handleEditorPrerequisites',
	        value: function handleEditorPrerequisites(value, editor) {
	            //console.log(value);
	            this.setState({
	                prerequisites: value
	            });
	        }
	    }, {
	        key: 'CuratedCampDetails',
	        value: function () {
	            var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(camp_id) {
	                var response, data, formValues, i;
	                return _regenerator2.default.wrap(function _callee2$(_context2) {
	                    while (1) {
	                        switch (_context2.prev = _context2.next) {
	                            case 0:
	                                if (!(camp_id != '')) {
	                                    _context2.next = 5;
	                                    break;
	                                }
	
	                                _context2.next = 3;
	                                return _FetchCall2.default.getCuratedCampInfo(camp_id);
	
	                            case 3:
	                                response = _context2.sent;
	
	                                if (response.status === 1) {
	                                    data = response.result;
	
	
	                                    this.setState({
	                                        vendor_id: data.vendor_id,
	                                        camp_name: data.camp_name,
	                                        categories: data.categories.split(","),
	                                        approval_status: data.approval_status,
	                                        published: data.published,
	                                        student_ratio: data.student_ratio,
	                                        tution_type: data.tution_type,
	                                        contact_person: data.contact_person,
	                                        phone_number: data.phone_number,
	                                        email_id: data.email_id,
	                                        prerequisites: data.prerequisites,
	                                        about_camp: data.about,
	                                        about_partner: data.about_partner,
	                                        edit_banner: data.banner ? data.url + data.banner : '',
	                                        edit_profile_image: data.profile_image ? data.url + data.profile_image : '',
	                                        edit_brochure: data.brochure ? data.url + data.brochure : '',
	                                        attachment_file: data.photo_arr,
	                                        edit_photos: data.gallery
	                                    });
	
	                                    formValues = [];
	
	                                    for (i = 0; i < data.program_names.length; i++) {
	                                        formValues.push({
	                                            pid: data.program_ids[i],
	                                            name: data.program_names[i],
	                                            enddate: data.program_todates[i],
	                                            fromdate: data.program_fromdates[i],
	                                            starttime: data.program_starttime[i],
	                                            endtime: data.program_endtime[i],
	                                            feeinr: data.program_feeinr[i],
	                                            feeusd: data.program_feeusd[i],
	                                            duration: data.program_duration[i],
	                                            days: data.program_days[i],
	                                            participants: data.program_noofparticipants[i]
	                                        });
	                                    }
	
	                                    this.setState({ formValues: formValues });
	                                    //this.setState({ programs });
	                                    this.getMainCategoryDataVendor(data.vendor_id);
	                                } else {
	                                    this.props.history.push('/admincuratedcamps');
	                                }
	
	                            case 5:
	                            case 'end':
	                                return _context2.stop();
	                        }
	                    }
	                }, _callee2, this);
	            }));
	
	            function CuratedCampDetails(_x2) {
	                return _ref2.apply(this, arguments);
	            }
	
	            return CuratedCampDetails;
	        }()
	    }, {
	        key: 'tutionList',
	        value: function () {
	            var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	                var response;
	                return _regenerator2.default.wrap(function _callee3$(_context3) {
	                    while (1) {
	                        switch (_context3.prev = _context3.next) {
	                            case 0:
	                                _context3.next = 2;
	                                return _FetchCall2.default.getSchoolListDatas('tution_type');
	
	                            case 2:
	                                response = _context3.sent;
	
	
	                                if (response) {
	                                    this.setState({ tutionList: response.results });
	                                }
	
	                            case 4:
	                            case 'end':
	                                return _context3.stop();
	                        }
	                    }
	                }, _callee3, this);
	            }));
	
	            function tutionList() {
	                return _ref3.apply(this, arguments);
	            }
	
	            return tutionList;
	        }()
	    }, {
	        key: 'getAgelist',
	        value: function () {
	            var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4() {
	                var response;
	                return _regenerator2.default.wrap(function _callee4$(_context4) {
	                    while (1) {
	                        switch (_context4.prev = _context4.next) {
	                            case 0:
	                                _context4.next = 2;
	                                return _FetchCall2.default.getSubCategory('8');
	
	                            case 2:
	                                response = _context4.sent;
	
	
	                                if (response) {
	                                    this.setState({ AgeList: response.results });
	                                }
	
	                            case 4:
	                            case 'end':
	                                return _context4.stop();
	                        }
	                    }
	                }, _callee4, this);
	            }));
	
	            function getAgelist() {
	                return _ref4.apply(this, arguments);
	            }
	
	            return getAgelist;
	        }()
	    }, {
	        key: 'Sub_Cat_type',
	        value: function () {
	            var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5() {
	                var response;
	                return _regenerator2.default.wrap(function _callee5$(_context5) {
	                    while (1) {
	                        switch (_context5.prev = _context5.next) {
	                            case 0:
	                                _context5.next = 2;
	                                return _FetchCall2.default.getSchoolListDatas('age_group');
	
	                            case 2:
	                                response = _context5.sent;
	
	                                if (response.status == 1) {
	                                    this.setState({ categorySubTypeList: response.results, cat_type: true, cat_type1: false, cat_type2: false });
	                                } else {
	                                    this.setState({ cat_type: false });
	                                }
	
	                            case 4:
	                            case 'end':
	                                return _context5.stop();
	                        }
	                    }
	                }, _callee5, this);
	            }));
	
	            function Sub_Cat_type() {
	                return _ref5.apply(this, arguments);
	            }
	
	            return Sub_Cat_type;
	        }()
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	
	            var user_data = localStorage.getItem("user_data");
	            var auth_data = JSON.parse(user_data);
	            var vendor_id = auth_data.login_id;
	            this.setState({ vendor_id: vendor_id });
	        }
	    }, {
	        key: 'UNSAFE_componentWillMount',
	        value: function UNSAFE_componentWillMount() {}
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            window.jQuery('.selectpicker').selectpicker('refresh');
	        }
	    }, {
	        key: 'Geocode_location',
	        value: function Geocode_location() {
	            var _this3 = this;
	
	            var location = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	            _reactGeocode2.default.fromAddress(location ? location : this.state.google_location).then(function (response) {
	                var _response$results$0$g = response.results[0].geometry.location,
	                    lat = _response$results$0$g.lat,
	                    lng = _response$results$0$g.lng;
	
	                if (lat && lng) _this3.get_location(lat, lng);
	            }, function (error) {
	                console.error(error);
	            });
	        }
	    }, {
	        key: 'escapeRegexCharacters',
	        value: function escapeRegexCharacters(str) {
	            return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	        }
	    }, {
	        key: 'getSuggestionValue',
	        value: function getSuggestionValue(suggestion) {
	
	            return suggestion.name;
	        }
	    }, {
	        key: 'renderSuggestion',
	        value: function renderSuggestion(suggestion) {
	            return _react2.default.createElement(
	                'span',
	                null,
	                suggestion.name
	            );
	        }
	    }, {
	        key: 'get_location',
	        value: function get_location(lat, lng) {
	            this.setState({
	                latitude: lat,
	                longitude: lng
	            });
	        }
	    }, {
	        key: 'clearValidationErr',
	        value: function clearValidationErr(elm) {
	            var _this4 = this;
	
	            this.setState(function (prevState) {
	                var newArr = [];
	                var _iteratorNormalCompletion = true;
	                var _didIteratorError = false;
	                var _iteratorError = undefined;
	
	                try {
	                    for (var _iterator = _this4.state.errors[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                        var err = _step.value;
	
	                        if (elm !== err.elm) {
	                            newArr.push(err);
	                        }
	                    }
	                } catch (err) {
	                    _didIteratorError = true;
	                    _iteratorError = err;
	                } finally {
	                    try {
	                        if (!_iteratorNormalCompletion && _iterator.return) {
	                            _iterator.return();
	                        }
	                    } finally {
	                        if (_didIteratorError) {
	                            throw _iteratorError;
	                        }
	                    }
	                }
	
	                return { errors: newArr };
	            });
	        }
	    }, {
	        key: 'remove_img',
	        value: function remove_img() {
	            (0, _jquery2.default)('#edit_image').remove();
	        }
	    }, {
	        key: 'loadFile',
	        value: function loadFile(e) {
	            var files = e.target.files;
	            this.setState({ attachment_file_length: files.length });
	            if (files.length > 0) {
	                (0, _jquery2.default)('.upload-space').addClass('hide');
	                (0, _jquery2.default)('.upload-thumb').removeClass('hide');
	                var fileArra = this.state.attachment_file;
	
	                //console.log('fileArra',fileArra)
	                //var fileThumbArra = this.state.imgThumb;
	                for (var i = 0; i < files.length; i++) {
	                    fileArra.push(e.target.files[i]);
	                    this.setState({
	                        selectedFile: URL.createObjectURL(e.target.files[i]),
	                        attachment_file: fileArra
	                    });
	                }
	                this.clearValidationErr('attachment_file');
	            }
	        }
	    }, {
	        key: 'createSelectItems',
	        value: function createSelectItems(category) {
	            var items = [];
	            var array = this.state.sub_categorycollected;
	
	            if (array[category] != undefined) {
	
	                var arra = array[category];
	                arra.forEach(function (ele, index) {
	                    items.push(_react2.default.createElement(
	                        'option',
	                        { value: ele.category_id },
	                        ele.category_name
	                    ));
	                });
	            }
	
	            return items;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this5 = this;
	
	            var _state = this.state,
	                value = _state.value,
	                suggestions = _state.suggestions,
	                mainvendorcategory = _state.mainvendorcategory,
	                totalcategoryselected = _state.totalcategoryselected,
	                sub_categorycollected = _state.sub_categorycollected;
	            var _state$auth_data = this.state.auth_data,
	                role = _state$auth_data.role,
	                user_name = _state$auth_data.user_name;
	
	
	            var inputProps = {
	                placeholder: "Search for a partner",
	                value: value,
	                class: 'd-search-text form-control',
	                id: 'searchbanner',
	                className: 'form-control',
	                onChange: this.onChange,
	                ref: this.wrapperRef,
	                onClick: function onClick() {
	                    _this5.setState({
	                        showsuggest: true
	                    });
	                }
	            };
	
	            this.validator.purgeFields();
	
	            return _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _react2.default.createElement(
	                    _layout2.default,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { 'class': 'col-lg-12 grid-margin stretch-card' },
	                        _react2.default.createElement(
	                            'div',
	                            { 'class': 'card' },
	                            _react2.default.createElement(
	                                'div',
	                                { 'class': 'card-body' },
	                                _react2.default.createElement(
	                                    'h4',
	                                    { 'class': 'card-title' },
	                                    'BeWise Curated Camps'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'row col-lg-12' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'content-sec col-md-12 col-xs-12 pad-no mar-t-no' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'tab-content' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { id: 'company-info', className: 'tab-pane in active' },
	                                                _react2.default.createElement(
	                                                    'form',
	                                                    { onSubmit: this.handleSubmit, className: 'custom-form invoice-form col-md-12 col-xs-12 legend-form pad-no' },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'box-shadow-custom' },
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'row' },
	                                                            _react2.default.createElement('input', { type: 'hidden', name: 'vendor_id', value: this.state.vendor_id }),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-6' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    null,
	                                                                    'Camp Name ',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('input', { type: 'text', name: 'camp_name',
	                                                                    value: this.state.camp_name,
	                                                                    className: 'form-control', onChange: this.handleChange })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-6' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    null,
	                                                                    'Associate Business Verticals',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    { className: 'custom-select-drop dropdown' },
	                                                                    _react2.default.createElement(
	                                                                        'select',
	                                                                        { className: 'form-control selectpicker',
	                                                                            title: "Select Category",
	                                                                            name: 'categories',
	                                                                            value: this.state.categories,
	                                                                            disabled: true,
	                                                                            required: true
	                                                                        },
	                                                                        mainvendorcategory.map(function (items, j) {
	                                                                            return _react2.default.createElement(
	                                                                                'option',
	                                                                                { value: items.category_name, 'data-cat': items.first_category_id, key: j + '1' },
	                                                                                items.category_name
	                                                                            );
	                                                                        })
	                                                                    )
	                                                                )
	                                                            )
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'box-shadow-custom' },
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'row' },
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'col-md-12 col-xs-12' },
	                                                                _react2.default.createElement(
	                                                                    'span',
	                                                                    { className: 'form-legend' },
	                                                                    'Key Information'
	                                                                )
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-12' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    null,
	                                                                    'Pre Requisites'
	                                                                ),
	                                                                _react2.default.createElement(_tinymceReact.Editor, {
	                                                                    onEditorChange: this.handleEditorPrerequisites,
	                                                                    value: this.state.prerequisites,
	                                                                    apiKey: _constant.TINY_EDITOR,
	                                                                    init: {
	                                                                        height: 200,
	                                                                        plugins: ['lists link image paste'],
	                                                                        toolbar: 'undo redo | formatselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | help'
	                                                                    }
	                                                                })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    null,
	                                                                    'Contact Person ',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('input', { type: 'text', name: 'contact_person', value: this.state.contact_person,
	                                                                    disabled: true, className: 'form-control' }),
	                                                                this.validator.message('Contact Person', this.state.contact_person, 'required', { className: 'text-danger' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    null,
	                                                                    'Contact No ',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('input', { type: 'text', name: 'contact_no', value: this.state.phone_number,
	                                                                    disabled: true, className: 'form-control' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    null,
	                                                                    'Email Id',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('input', { type: 'email', name: 'email_id',
	                                                                    value: this.state.email_id,
	                                                                    onChange: this.handleChange, disabled: true, className: 'form-control' }),
	                                                                this.validator.message('Email Id', this.state.email_id, 'emailExist_check', { className: 'text-danger' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    null,
	                                                                    'Type',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    { className: 'custom-select-drop dropdown' },
	                                                                    _react2.default.createElement(
	                                                                        'select',
	                                                                        {
	                                                                            value: this.state.tution_type,
	
	                                                                            className: 'form-control selectpicker',
	                                                                            name: 'tution_type', title: 'Select' },
	                                                                        this.state.tutionList.length > 0 && this.state.tutionList.map(function (item, i) {
	                                                                            return _react2.default.createElement(
	                                                                                'option',
	                                                                                { value: item.id },
	                                                                                item.name
	                                                                            );
	                                                                        })
	                                                                    )
	                                                                )
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    null,
	                                                                    'Student Ratio ',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    { className: 'custom-select-drop dropdown' },
	                                                                    _react2.default.createElement(
	                                                                        'select',
	                                                                        {
	                                                                            value: this.state.student_ratio,
	                                                                            name: 'student_ratio',
	                                                                            id: 'student_ratio',
	                                                                            disabled: true,
	                                                                            onChange: this.handleSelect,
	                                                                            className: 'form-control selectpicker',
	                                                                            multiple: true, title: 'Select'
	                                                                        },
	                                                                        _react2.default.createElement(
	                                                                            'option',
	                                                                            { value: '1' },
	                                                                            'One to One'
	                                                                        ),
	                                                                        _react2.default.createElement(
	                                                                            'option',
	                                                                            { value: '2' },
	                                                                            'One to Many'
	                                                                        ),
	                                                                        _react2.default.createElement(
	                                                                            'option',
	                                                                            { value: '3' },
	                                                                            'NA'
	                                                                        )
	                                                                    ),
	                                                                    this.validator.message('Student Ratio', this.state.student_ratio, 'required', { className: 'text-danger' })
	                                                                )
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    null,
	                                                                    'Brochure'
	                                                                ),
	                                                                _react2.default.createElement('input', { type: 'file', name: 'brochure', disabled: true, 'class': 'form-control' }),
	                                                                this.state.edit_brochure != '' && this.state.tempBrochure != '' && _react2.default.createElement(
	                                                                    'div',
	                                                                    { 'class': 'col-md-2 col-sm-12 mar-btm', id: 'edit_brochure' },
	                                                                    _react2.default.createElement(
	                                                                        'a',
	                                                                        { href: this.state.tempBrochure },
	                                                                        'View Brochure'
	                                                                    )
	                                                                )
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-6' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    null,
	                                                                    'About The Camp',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement(_tinymceReact.Editor, {
	
	                                                                    value: this.state.about_camp,
	                                                                    apiKey: _constant.TINY_EDITOR,
	                                                                    onEditorChange: this.handleEditorAbout,
	                                                                    init: {
	                                                                        height: 200,
	                                                                        plugins: ['lists link image paste'],
	                                                                        toolbar: 'undo redo | formatselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | help'
	                                                                    }
	                                                                })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-6' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    null,
	                                                                    'About The Partner',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement(_tinymceReact.Editor, {
	
	                                                                    value: this.state.about_partner,
	                                                                    apiKey: _constant.TINY_EDITOR,
	                                                                    onEditorChange: this.handleEditorParnter,
	                                                                    init: {
	                                                                        height: 200,
	                                                                        plugins: ['lists link image paste'],
	                                                                        toolbar: 'undo redo | formatselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | help'
	                                                                    }
	                                                                })
	                                                            )
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'box-shadow-custom', id: 'curatedcampskeyinfo' },
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'row' },
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-12' },
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    { 'class': 'panel panel-default' },
	                                                                    _react2.default.createElement(
	                                                                        'div',
	                                                                        { 'class': 'panel-heading' },
	                                                                        'Program Information'
	                                                                    ),
	                                                                    _react2.default.createElement(
	                                                                        'div',
	                                                                        { 'class': 'panel-body' },
	                                                                        _react2.default.createElement(
	                                                                            'div',
	                                                                            { 'class': 'row parenttoclone' },
	                                                                            this.state.formValues.map(function (element, idx) {
	                                                                                return _react2.default.createElement(
	                                                                                    'div',
	                                                                                    { className: 'row program form-group', style: { paddingTop: "10px" }, key: idx },
	                                                                                    _react2.default.createElement('input', {
	                                                                                        type: 'hidden',
	                                                                                        className: 'form-control',
	                                                                                        name: 'pid', value: element.pid || "", onChange: function onChange(e) {
	                                                                                            return _this5.handleChangev1(idx, e);
	                                                                                        }
	                                                                                    }),
	                                                                                    _react2.default.createElement(
	                                                                                        'div',
	                                                                                        { className: 'form-group col-md-4' },
	                                                                                        _react2.default.createElement(
	                                                                                            'label',
	                                                                                            null,
	                                                                                            'Program Name ',
	                                                                                            _react2.default.createElement(
	                                                                                                'span',
	                                                                                                { className: 'astrick' },
	                                                                                                '*'
	                                                                                            )
	                                                                                        ),
	                                                                                        _react2.default.createElement('input', {
	                                                                                            type: 'text',
	                                                                                            className: 'form-control',
	                                                                                            placeholder: 'Program #' + (idx + 1) + ' name',
	                                                                                            name: 'name', value: element.name || "", onChange: function onChange(e) {
	                                                                                                return _this5.handleChangev1(idx, e);
	                                                                                            }
	                                                                                        })
	                                                                                    ),
	                                                                                    _react2.default.createElement(
	                                                                                        'div',
	                                                                                        { className: 'form-group col-md-4' },
	                                                                                        _react2.default.createElement(
	                                                                                            'label',
	                                                                                            null,
	                                                                                            'Start Date ',
	                                                                                            _react2.default.createElement(
	                                                                                                'span',
	                                                                                                { className: 'astrick' },
	                                                                                                '*'
	                                                                                            )
	                                                                                        ),
	                                                                                        _react2.default.createElement('input', {
	                                                                                            type: 'date',
	                                                                                            className: 'form-control',
	                                                                                            placeholder: 'Program #' + (idx + 1) + ' From Date',
	                                                                                            name: 'fromdate', value: element.fromdate || "", onChange: function onChange(e) {
	                                                                                                return _this5.handleChangev1(idx, e);
	                                                                                            }
	                                                                                        })
	                                                                                    ),
	                                                                                    _react2.default.createElement(
	                                                                                        'div',
	                                                                                        { className: 'form-group col-md-4' },
	                                                                                        _react2.default.createElement(
	                                                                                            'label',
	                                                                                            null,
	                                                                                            'End Date ',
	                                                                                            _react2.default.createElement(
	                                                                                                'span',
	                                                                                                { className: 'astrick' },
	                                                                                                '*'
	                                                                                            )
	                                                                                        ),
	                                                                                        _react2.default.createElement('input', {
	                                                                                            type: 'date',
	                                                                                            className: 'form-control',
	                                                                                            placeholder: 'Program #' + (idx + 1) + ' End Date',
	                                                                                            name: 'enddate', value: element.enddate || "", onChange: function onChange(e) {
	                                                                                                return _this5.handleChangev1(idx, e);
	                                                                                            }
	                                                                                        })
	                                                                                    ),
	                                                                                    _react2.default.createElement(
	                                                                                        'div',
	                                                                                        { className: 'form-group col-md-4' },
	                                                                                        _react2.default.createElement(
	                                                                                            'label',
	                                                                                            null,
	                                                                                            'Start time ',
	                                                                                            _react2.default.createElement(
	                                                                                                'span',
	                                                                                                { className: 'astrick' },
	                                                                                                '*'
	                                                                                            )
	                                                                                        ),
	                                                                                        _react2.default.createElement('input', {
	                                                                                            type: 'time',
	                                                                                            className: 'form-control',
	                                                                                            placeholder: 'Program #' + (idx + 1) + ' Start Time',
	                                                                                            min: '09:00', max: '23:00',
	                                                                                            name: 'starttime', value: element.starttime || "", onChange: function onChange(e) {
	                                                                                                return _this5.handleChangev1(idx, e);
	                                                                                            }
	                                                                                        })
	                                                                                    ),
	                                                                                    _react2.default.createElement(
	                                                                                        'div',
	                                                                                        { className: 'form-group col-md-4' },
	                                                                                        _react2.default.createElement(
	                                                                                            'label',
	                                                                                            null,
	                                                                                            'End Time ',
	                                                                                            _react2.default.createElement(
	                                                                                                'span',
	                                                                                                { className: 'astrick' },
	                                                                                                '*'
	                                                                                            )
	                                                                                        ),
	                                                                                        _react2.default.createElement('input', {
	                                                                                            type: 'time',
	                                                                                            className: 'form-control',
	                                                                                            placeholder: 'Program #' + (idx + 1) + ' End Time',
	                                                                                            min: '09:00', max: '23:00',
	                                                                                            name: 'endtime', value: element.endtime || "", onChange: function onChange(e) {
	                                                                                                return _this5.handleChangev1(idx, e);
	                                                                                            }
	                                                                                        })
	                                                                                    ),
	                                                                                    _react2.default.createElement(
	                                                                                        'div',
	                                                                                        { className: 'form-group col-md-4' },
	                                                                                        _react2.default.createElement(
	                                                                                            'label',
	                                                                                            null,
	                                                                                            'Program Fees (INR) ',
	                                                                                            _react2.default.createElement(
	                                                                                                'span',
	                                                                                                { className: 'astrick' },
	                                                                                                '*'
	                                                                                            )
	                                                                                        ),
	                                                                                        _react2.default.createElement('input', {
	                                                                                            type: 'text',
	                                                                                            className: 'form-control',
	                                                                                            placeholder: 'Fees INR',
	                                                                                            name: 'feeinr', value: element.feeinr || "", onChange: function onChange(e) {
	                                                                                                return _this5.handleChangev1(idx, e);
	                                                                                            }
	                                                                                        })
	                                                                                    ),
	                                                                                    _react2.default.createElement(
	                                                                                        'div',
	                                                                                        { className: 'form-group col-md-4' },
	                                                                                        _react2.default.createElement(
	                                                                                            'label',
	                                                                                            null,
	                                                                                            'Program Fee (USD) ',
	                                                                                            _react2.default.createElement(
	                                                                                                'span',
	                                                                                                { className: 'astrick' },
	                                                                                                '*'
	                                                                                            )
	                                                                                        ),
	                                                                                        _react2.default.createElement('input', {
	                                                                                            type: 'text',
	                                                                                            className: 'form-control',
	                                                                                            placeholder: 'Fees USD',
	                                                                                            name: 'feeusd', value: element.feeusd || "", onChange: function onChange(e) {
	                                                                                                return _this5.handleChangev1(idx, e);
	                                                                                            }
	                                                                                        })
	                                                                                    ),
	                                                                                    _react2.default.createElement(
	                                                                                        'div',
	                                                                                        { className: 'form-group col-md-4' },
	                                                                                        _react2.default.createElement(
	                                                                                            'label',
	                                                                                            null,
	                                                                                            'Duration (Hrs) ',
	                                                                                            _react2.default.createElement(
	                                                                                                'span',
	                                                                                                { className: 'astrick' },
	                                                                                                '*'
	                                                                                            )
	                                                                                        ),
	                                                                                        _react2.default.createElement('input', {
	                                                                                            type: 'text',
	                                                                                            className: 'form-control',
	                                                                                            placeholder: 'Duration',
	                                                                                            name: 'duration', value: element.duration || "", onChange: function onChange(e) {
	                                                                                                return _this5.handleChangev1(idx, e);
	                                                                                            }
	                                                                                        })
	                                                                                    ),
	                                                                                    _react2.default.createElement(
	                                                                                        'div',
	                                                                                        { className: 'form-group col-md-4' },
	                                                                                        _react2.default.createElement(
	                                                                                            'label',
	                                                                                            null,
	                                                                                            'Days per week ',
	                                                                                            _react2.default.createElement(
	                                                                                                'span',
	                                                                                                { className: 'astrick' },
	                                                                                                '*'
	                                                                                            )
	                                                                                        ),
	                                                                                        _react2.default.createElement('input', {
	                                                                                            type: 'number',
	                                                                                            className: 'form-control',
	                                                                                            placeholder: 'Days per week',
	                                                                                            name: 'days', value: element.days || "", onChange: function onChange(e) {
	                                                                                                return _this5.handleChangev1(idx, e);
	                                                                                            }
	                                                                                        })
	                                                                                    ),
	                                                                                    _react2.default.createElement(
	                                                                                        'div',
	                                                                                        { className: 'form-group col-md-4' },
	                                                                                        _react2.default.createElement(
	                                                                                            'label',
	                                                                                            null,
	                                                                                            'No of Participants ',
	                                                                                            _react2.default.createElement(
	                                                                                                'span',
	                                                                                                { className: 'astrick' },
	                                                                                                '*'
	                                                                                            )
	                                                                                        ),
	                                                                                        _react2.default.createElement('input', {
	                                                                                            type: 'number',
	                                                                                            className: 'form-control',
	                                                                                            placeholder: 'No of Participants',
	                                                                                            name: 'participants', value: element.participants || "", onChange: function onChange(e) {
	                                                                                                return _this5.handleChangev1(idx, e);
	                                                                                            }
	                                                                                        })
	                                                                                    ),
	                                                                                    idx > 0 && _react2.default.createElement(
	                                                                                        'div',
	                                                                                        { className: 'form-group col-md-4 text-right' },
	                                                                                        _react2.default.createElement(
	                                                                                            'button',
	                                                                                            { type: 'button', onClick: function onClick() {
	                                                                                                    return _this5.removeFormFieldsv1(idx);
	                                                                                                }, className: 'small btn btn-primary btn-sm' },
	                                                                                            'Remove'
	                                                                                        )
	                                                                                    )
	                                                                                );
	                                                                            })
	                                                                        ),
	                                                                        _react2.default.createElement(
	                                                                            'div',
	                                                                            { 'class': 'form-group' },
	                                                                            _react2.default.createElement(
	                                                                                'button',
	                                                                                { type: 'button', onClick: function onClick() {
	                                                                                        return _this5.addFormFieldsv1();
	                                                                                    }, className: 'small btn btn-primary btn-sm' },
	                                                                                'Add +'
	                                                                            )
	                                                                        )
	                                                                    )
	                                                                )
	                                                            )
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'box-shadow-custom' },
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'row' },
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'col-md-12 col-xs-12' },
	                                                                _react2.default.createElement(
	                                                                    'span',
	                                                                    { className: 'form-legend' },
	                                                                    'Images'
	                                                                )
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    null,
	                                                                    'Partner Profile Image ',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('input', {
	                                                                    type: 'file',
	                                                                    name: 'profile_image',
	                                                                    disabled: true,
	
	                                                                    className: 'form-control'
	                                                                })
	                                                            ),
	                                                            (this.state.edit_profile_image != '' || this.state.tempProfile != '') && _react2.default.createElement(
	                                                                'div',
	                                                                { 'class': 'col-md-2 col-sm-12 mar-btm', id: 'edit_profile_image' },
	                                                                _react2.default.createElement('img', { src: this.state.tempProfile ? this.state.tempProfile : _constant.IMGBASEURL + this.state.edit_profile_image, alt: 'Img', 'class': 'img-thumbnail' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    null,
	                                                                    'Banner Image ',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('input', {
	                                                                    type: 'file',
	                                                                    name: 'banner',
	                                                                    onChange: this.handleFile,
	                                                                    className: 'form-control'
	                                                                })
	                                                            ),
	                                                            (this.state.edit_banner != '' || this.state.tempBanner != '') && _react2.default.createElement(
	                                                                'div',
	                                                                { 'class': 'col-md-2 col-sm-12 mar-btm', id: 'edit_banner' },
	                                                                _react2.default.createElement('img', { src: this.state.tempBanner ? this.state.tempBanner : _constant.IMGBASEURL + this.state.edit_banner, alt: 'Img', 'class': 'img-thumbnail' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { 'class': 'col-md-12 float-left mt-4 p-0' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    null,
	                                                                    'Gallery Images ',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                )
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { 'class': 'col-md-12 float-left mt-4 p-0' },
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    { 'class': 'col-md-12 margin-bottom-mobile-account float-left image-upload' },
	                                                                    _react2.default.createElement(
	                                                                        'div',
	                                                                        { className: 'upload-wizard', style: { height: "255px" } },
	                                                                        _react2.default.createElement(
	                                                                            'div',
	                                                                            { className: 'upload-thumb' },
	                                                                            _react2.default.createElement(
	                                                                                'ul',
	                                                                                { className: 'list-inline' },
	                                                                                this.state.attachment_file.map(function (file_data, index) {
	
	                                                                                    var file_url;
	                                                                                    if (file_data.name) {
	                                                                                        var url = file_data.image_thumb ? file_data.image_thumb : '';
	                                                                                        if (url != '') {
	                                                                                            file_url = file_data.image_thumb;
	                                                                                        } else {
	                                                                                            file_url = URL.createObjectURL(file_data);
	                                                                                        }
	                                                                                        var imgurl = file_url;
	
	                                                                                        // var file_url = URL.createObjectURL(file_data)
	                                                                                        // var file_name = file_data.name
	                                                                                        if (file_data.type === 'application/pdf') {
	                                                                                            var blob = file_url;
	                                                                                            //console.log('blob_url', file_data.name)
	                                                                                            return _react2.default.createElement(
	                                                                                                'li',
	                                                                                                { className: 'previewImg' },
	                                                                                                _react2.default.createElement(
	                                                                                                    'div',
	                                                                                                    { className: 'thumb-img' },
	                                                                                                    _react2.default.createElement('img', {
	                                                                                                        src: file_url,
	                                                                                                        alt: 'image',
	                                                                                                        title: file_data.name
	                                                                                                    })
	                                                                                                )
	                                                                                            );
	                                                                                        } else {
	                                                                                            return _react2.default.createElement(
	                                                                                                'li',
	                                                                                                { className: 'previewImg' },
	                                                                                                _react2.default.createElement(
	                                                                                                    'div',
	                                                                                                    { className: 'thumb-img' },
	                                                                                                    _react2.default.createElement('img', {
	                                                                                                        src: imgurl,
	                                                                                                        alt: 'image',
	                                                                                                        title: file_data.name
	                                                                                                    })
	                                                                                                )
	                                                                                            );
	                                                                                        }
	                                                                                    }
	                                                                                }),
	                                                                                _react2.default.createElement(
	                                                                                    'li',
	                                                                                    { className: 'addMore' },
	                                                                                    _react2.default.createElement('input', {
	                                                                                        type: 'file',
	                                                                                        name: 'imgInp[]',
	                                                                                        disabled: true,
	                                                                                        id: 'imgInp2',
	                                                                                        className: 'add_img',
	                                                                                        multiple: true
	
	                                                                                    }),
	                                                                                    _react2.default.createElement(
	                                                                                        'a',
	                                                                                        { href: 'javascript:;', className: 'add-more' },
	                                                                                        _react2.default.createElement(
	                                                                                            'div',
	                                                                                            null,
	                                                                                            _react2.default.createElement('img', { src: '../../../assets/images/upload-icon.svg', alt: 'icon' }),
	                                                                                            'Add more'
	                                                                                        )
	                                                                                    )
	                                                                                )
	                                                                            )
	                                                                        )
	                                                                    )
	                                                                )
	                                                            )
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'col-md-4 col-xs-4 ' },
	                                                        _react2.default.createElement(
	                                                            'label',
	                                                            null,
	                                                            'Camp Status:'
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'select',
	                                                            { name: 'approval_status', className: 'form-control', onChange: this.handleChange },
	                                                            _react2.default.createElement(
	                                                                'option',
	                                                                { value: '' },
	                                                                'Select Status'
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'option',
	                                                                { value: '1', selected: this.state.approval_status == 1 },
	                                                                'Approved'
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'option',
	                                                                { value: '0', selected: this.state.approval_status == 0 },
	                                                                'Rejected'
	                                                            )
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'col-md-4 col-xs-4 ' },
	                                                        _react2.default.createElement(
	                                                            'label',
	                                                            null,
	                                                            'Published:'
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'select',
	                                                            { name: 'published', className: 'form-control', onChange: this.handleChange },
	                                                            _react2.default.createElement(
	                                                                'option',
	                                                                { value: '' },
	                                                                'Select Status'
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'option',
	                                                                { value: '1', selected: this.state.published == 1 },
	                                                                'Yes'
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'option',
	                                                                { value: '0', selected: this.state.published == 0 },
	                                                                'No'
	                                                            )
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'col-md-12 col-xs-12' },
	                                                        '\xA0'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'col-md-12 col-xs-12 btn-bdr' },
	                                                        _react2.default.createElement(
	                                                            'button',
	                                                            { id: 'btnSubmit', className: 'btn btn-blue' },
	                                                            'Submit'
	                                                        ),
	                                                        '\xA0',
	                                                        _react2.default.createElement(
	                                                            'button',
	                                                            { id: 'btnDelete', className: 'btn btn-blue', onClick: this.deleteCamp },
	                                                            'Delete'
	                                                        )
	                                                    )
	                                                )
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return bewiseEditCuratedCamp;
	}(_react.Component);
	
	var _initialiseProps = function _initialiseProps() {
	    var _this6 = this;
	
	    this.getMainCategoryDataVendor = function () {
	        var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(vendor_id) {
	            var _state$user_data, user_type, login_id, set_id, sid, req_c, THIS;
	
	            return _regenerator2.default.wrap(function _callee7$(_context7) {
	                while (1) {
	                    switch (_context7.prev = _context7.next) {
	                        case 0:
	                            _state$user_data = _this6.state.user_data, user_type = _state$user_data.user_type, login_id = _state$user_data.login_id, set_id = _state$user_data.set_id;
	                            sid = _this6.state.sid != -1 ? _this6.state.sid : set_id;
	                            req_c = JSON.stringify({
	                                partner_id: vendor_id,
	                                sid: 1,
	                                category_id: 0,
	                                url: 'partner_main_category_data'
	                            });
	                            THIS = _this6;
	                            _context7.next = 6;
	                            return (0, _FetchCall.partnerMainCategory)(req_c).then(function () {
	                                var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(res_c) {
	                                    return _regenerator2.default.wrap(function _callee6$(_context6) {
	                                        while (1) {
	                                            switch (_context6.prev = _context6.next) {
	                                                case 0:
	                                                    if (res_c.status === 1) {
	                                                        _this6.setState({
	                                                            sid: sid,
	                                                            mainvendorcategory: res_c.category_data.result
	                                                        });
	                                                    }
	
	                                                case 1:
	                                                case 'end':
	                                                    return _context6.stop();
	                                            }
	                                        }
	                                    }, _callee6, _this6);
	                                }));
	
	                                return function (_x5) {
	                                    return _ref7.apply(this, arguments);
	                                };
	                            }());
	
	                        case 6:
	
	                            _this6.setState({
	                                checking: true
	                            });
	                            setTimeout(function () {
	                                THIS.setState({
	                                    checking: false
	                                });
	                            }, 5000);
	
	                        case 8:
	                        case 'end':
	                            return _context7.stop();
	                    }
	                }
	            }, _callee7, _this6);
	        }));
	
	        return function (_x4) {
	            return _ref6.apply(this, arguments);
	        };
	    }();
	
	    this.getMainCategoryData = _asyncToGenerator(_regenerator2.default.mark(function _callee9() {
	        var _state$user_data2, user_type, login_id, set_id, sid, req_c, THIS;
	
	        return _regenerator2.default.wrap(function _callee9$(_context9) {
	            while (1) {
	                switch (_context9.prev = _context9.next) {
	                    case 0:
	                        _state$user_data2 = _this6.state.user_data, user_type = _state$user_data2.user_type, login_id = _state$user_data2.login_id, set_id = _state$user_data2.set_id;
	                        sid = _this6.state.sid != -1 ? _this6.state.sid : set_id;
	                        req_c = JSON.stringify({
	                            partner_id: login_id,
	                            sid: _this6.state.sid != -1 ? _this6.state.sid : set_id,
	                            category_id: 0,
	                            url: 'partner_main_category_data'
	                        });
	                        THIS = _this6;
	                        _context9.next = 6;
	                        return (0, _FetchCall.partnerMainCategory)(req_c).then(function () {
	                            var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee8(res_c) {
	                                return _regenerator2.default.wrap(function _callee8$(_context8) {
	                                    while (1) {
	                                        switch (_context8.prev = _context8.next) {
	                                            case 0:
	                                                if (res_c.status === 1) {
	                                                    _this6.setState({
	                                                        sid: sid,
	                                                        mainvendorcategory: res_c.category_data.result
	                                                    });
	                                                }
	
	                                            case 1:
	                                            case 'end':
	                                                return _context8.stop();
	                                        }
	                                    }
	                                }, _callee8, _this6);
	                            }));
	
	                            return function (_x6) {
	                                return _ref9.apply(this, arguments);
	                            };
	                        }());
	
	                    case 6:
	
	                        _this6.setState({
	                            checking: true
	                        });
	                        setTimeout(function () {
	                            THIS.setState({
	                                checking: false
	                            });
	                        }, 5000);
	
	                    case 8:
	                    case 'end':
	                        return _context9.stop();
	                }
	            }
	        }, _callee9, _this6);
	    }));
	
	    this.fileSelectedHandler = function (e) {
	        _this6.setState({ files: [].concat(_toConsumableArray(_this6.state.files), _toConsumableArray(e.target.files)) });
	    };
	
	    this.handleProgramNameChange = function (idx) {
	        return function (evt) {
	
	            var newPrograms = _this6.state.program_names.map(function (programs, sidx) {
	
	                if (idx !== sidx) return programs;
	                return Object.assign({}, programs, { name: evt.target.value });
	            });
	
	            _this6.setState({ program_names: newPrograms });
	        };
	    };
	
	    this.handleProgramDuration = function (idx) {
	        return function (evt) {
	            var newPrograms = _this6.state.program_duration.map(function (program, sidx) {
	                if (idx !== sidx) return program;
	                return Object.assign({}, program, { name: evt.target.value });
	            });
	
	            _this6.setState({ program_duration: newPrograms });
	        };
	    };
	
	    this.handleProgramDays = function (idx) {
	        return function (evt) {
	            var newPrograms = _this6.state.program_days.map(function (program, sidx) {
	                if (idx !== sidx) return program;
	                return Object.assign({}, program, { name: evt.target.value });
	            });
	
	            _this6.setState({ program_days: newPrograms });
	        };
	    };
	
	    this.handleProgramFDChange = function (idx) {
	        return function (evt) {
	            var newPrograms = _this6.state.program_fromdates.map(function (program, sidx) {
	                if (idx !== sidx) return program;
	                return Object.assign({}, program, { name: evt.target.value });
	            });
	
	            _this6.setState({ program_fromdates: newPrograms });
	        };
	    };
	
	    this.onChange = function (event, _ref10) {
	        var newValue = _ref10.newValue,
	            method = _ref10.method;
	
	
	        _this6.setState({
	            value: newValue,
	            showsuggest: false
	
	        });
	    };
	
	    this.onSuggestionSelected = function (event, _ref11) {
	        var suggestion = _ref11.suggestion,
	            suggestionValue = _ref11.suggestionValue,
	            suggestionIndex = _ref11.suggestionIndex,
	            sectionIndex = _ref11.sectionIndex,
	            method = _ref11.method;
	
	        (0, _jquery2.default)("#vendor_id").val(suggestion.vendor_id);
	        //alert(suggestion.vendor_id);
	        _this6.setState({
	            login_id: suggestion.vendor_id
	        });
	    };
	
	    this.handleProgramEDChange = function (idx) {
	        return function (evt) {
	            var newPrograms = _this6.state.program_todates.map(function (program, sidx) {
	                if (idx !== sidx) return program;
	                return Object.assign({}, program, { name: evt.target.value });
	            });
	
	            _this6.setState({ program_todates: newPrograms });
	        };
	    };
	
	    this.handleProgramSTChange = function (idx) {
	        return function (evt) {
	            var newPrograms = _this6.state.program_starttime.map(function (program, sidx) {
	                if (idx !== sidx) return program;
	                return Object.assign({}, program, { name: evt.target.value });
	            });
	
	            _this6.setState({ program_starttime: newPrograms });
	        };
	    };
	
	    this.handleProgramETChange = function (idx) {
	        return function (evt) {
	            var newPrograms = _this6.state.program_endtime.map(function (program, sidx) {
	                if (idx !== sidx) return program;
	                return Object.assign({}, program, { name: evt.target.value });
	            });
	
	            _this6.setState({ program_endtime: newPrograms });
	        };
	    };
	
	    this.handleProgramINRChange = function (idx) {
	        return function (evt) {
	            var newPrograms = _this6.state.program_feeinr.map(function (program, sidx) {
	                if (idx !== sidx) return program;
	                return Object.assign({}, program, { name: evt.target.value });
	            });
	
	            _this6.setState({ program_feeinr: newPrograms });
	        };
	    };
	
	    this.handleProgramUSDChange = function (idx) {
	        return function (evt) {
	            var newPrograms = _this6.state.program_feeusd.map(function (program, sidx) {
	                if (idx !== sidx) return program;
	                return Object.assign({}, program, { name: evt.target.value });
	            });
	
	            _this6.setState({ program_feeusd: newPrograms });
	        };
	    };
	
	    this.handleAddProgram = function () {
	        _this6.setState({
	            program_ids: _this6.state.program_ids.concat([{ name: "" }]),
	            program_names: _this6.state.program_names.concat([{ name: "" }]),
	            program_fromdates: _this6.state.program_fromdates.concat([{ name: "" }]),
	            program_todates: _this6.state.program_todates.concat([{ name: "" }]),
	            program_starttime: _this6.state.program_starttime.concat([{ name: "" }]),
	            program_endtime: _this6.state.program_endtime.concat([{ name: "" }]),
	            program_feeinr: _this6.state.program_feeinr.concat([{ name: "" }]),
	            program_feeusd: _this6.state.program_feeusd.concat([{ name: "" }]),
	            program_duration: _this6.state.program_duration.concat([{ name: "" }]),
	            program_days: _this6.state.program_days.concat([{ name: "" }]),
	            program_noofparticipants: _this6.state.program_noofparticipants.concat([{ name: "" }])
	        });
	    };
	
	    this.handleRemoveProgram = function (idx) {
	        return function () {
	            _this6.setState({
	                program_ids: _this6.state.program_ids.filter(function (s, sidx) {
	                    return idx !== sidx;
	                }),
	                program_names: _this6.state.program_names.filter(function (s, sidx) {
	                    return idx !== sidx;
	                }),
	                program_fromdates: _this6.state.program_fromdates.filter(function (s, sidx) {
	                    return idx !== sidx;
	                }),
	                program_todates: _this6.state.program_todates.filter(function (s, sidx) {
	                    return idx !== sidx;
	                }),
	                program_starttime: _this6.state.program_starttime.filter(function (s, sidx) {
	                    return idx !== sidx;
	                }),
	                program_endtime: _this6.state.program_endtime.filter(function (s, sidx) {
	                    return idx !== sidx;
	                }),
	                program_feeinr: _this6.state.program_feeinr.filter(function (s, sidx) {
	                    return idx !== sidx;
	                }),
	                program_feeusd: _this6.state.program_feeusd.filter(function (s, sidx) {
	                    return idx !== sidx;
	                }),
	                program_duration: _this6.state.program_duration.filter(function (s, sidx) {
	                    return idx !== sidx;
	                }),
	                program_days: _this6.state.program_days.filter(function (s, sidx) {
	                    return idx !== sidx;
	                }),
	                program_noofparticipants: _this6.state.program_noofparticipants.filter(function (s, sidx) {
	                    return idx !== sidx;
	                })
	            });
	        };
	    };
	
	    this.LocationDataList = _asyncToGenerator(_regenerator2.default.mark(function _callee10() {
	        var res;
	        return _regenerator2.default.wrap(function _callee10$(_context10) {
	            while (1) {
	                switch (_context10.prev = _context10.next) {
	                    case 0:
	                        _context10.prev = 0;
	                        _context10.next = 3;
	                        return (0, _FetchCall.getLocationList)();
	
	                    case 3:
	                        res = _context10.sent;
	
	                        if (res.status == 1) {
	
	                            _this6.setState({
	                                location_list: res.results,
	                                error: false
	                            });
	                        }
	
	                        _context10.next = 10;
	                        break;
	
	                    case 7:
	                        _context10.prev = 7;
	                        _context10.t0 = _context10['catch'](0);
	
	                        _this6.setState({ error: true });
	
	                    case 10:
	                    case 'end':
	                        return _context10.stop();
	                }
	            }
	        }, _callee10, _this6, [[0, 7]]);
	    }));
	
	    this.validateMail = function (value, catgry, vendr_id, pageid) {
	        var _JSON$stringify;
	
	        var name = 'email_id';
	        var type_name = 'isEmailValid';
	        var req = JSON.stringify((_JSON$stringify = {}, _defineProperty(_JSON$stringify, name, value), _defineProperty(_JSON$stringify, 'category', catgry), _defineProperty(_JSON$stringify, 'vendor_id', vendr_id), _defineProperty(_JSON$stringify, 'pageid', pageid), _JSON$stringify));
	        var res = (0, _FetchCall.emailExist_check)(req).then(function (res) {
	
	            if (res.status === 1) {
	                _this6.setState(_defineProperty({}, type_name, false));
	            } else {
	                // return res.status;
	                _this6.setState(_defineProperty({}, type_name, true));
	            }
	        });
	    };
	
	    this.handleSelect = function (e) {
	        var propName = e.target.name;
	        var value = [].concat(_toConsumableArray(e.target.selectedOptions)).map(function (item) {
	            return item.value;
	        });
	        _this6.Sub_Cat_type(value);
	        _this6.setState(_defineProperty({}, propName, value));
	
	        if (value == 184) {
	            (0, _jquery2.default)("#curatedcampskeyinfo").removeClass('hidden');
	        }
	    };
	
	    this.duplicaterow = function (e) {};
	
	    this.handleSelectCat1 = function (e) {
	        var propName = e.target.name;
	        var value = [].concat(_toConsumableArray(e.target.selectedOptions)).map(function (item) {
	            return item.value;
	        });
	        _this6.setState(_defineProperty({}, propName, value));
	    };
	
	    this.handleChange = function (e) {
	        _this6.setState(_defineProperty({}, e.target.name, e.target.value));
	        _this6.Geocode_location();
	        var propName = e.target.name;
	        // if (propName == 'email_id') {
	        //     this.validateMail(e.target.value, 8, this.state.vendor_id, this.state.pageid);
	        // }
	    };
	
	    this.handleBrochureFile = function (e) {
	        // this.Geocode_location();
	        var propName = e.target.name;
	        var files = e.target.files[0];
	        _this6.setState(_defineProperty({}, propName, files));
	        var reader = new FileReader();
	        var pdf = '';
	        var THIS = _this6;
	        reader.addEventListener("load", function () {
	            // convert image file to base64 string
	            pdf = reader.result;
	            THIS.setState({
	                tempBrochure: reader.result
	            });
	        }, false);
	
	        if (files) {
	            reader.readAsDataURL(files);
	        } else {
	            THIS.setState({
	                tempBrochure: ''
	            });
	        }
	    };
	
	    this.handleFile = function (e) {
	        // this.Geocode_location();
	        var propName = e.target.name;
	        var files = e.target.files[0];
	        _this6.setState(_defineProperty({}, propName, files));
	        var reader = new FileReader();
	        var img = '';
	        var THIS = _this6;
	        reader.addEventListener("load", function () {
	            // convert image file to base64 string
	            img = reader.result;
	            THIS.setState({
	                tempBanner: reader.result
	            });
	        }, false);
	
	        if (files) {
	            reader.readAsDataURL(files);
	        } else {
	            THIS.setState({
	                tempBanner: ''
	            });
	        }
	    };
	
	    this.handleProFile = function (e) {
	        // this.Geocode_location();
	        var propName = e.target.name;
	        var files = e.target.files[0];
	        _this6.setState(_defineProperty({}, propName, files));
	        var reader = new FileReader();
	        var img = '';
	        var THIS = _this6;
	        reader.addEventListener("load", function () {
	            // convert image file to base64 string
	            img = reader.result;
	            THIS.setState({
	                tempProfile: reader.result
	            });
	        }, false);
	
	        if (files) {
	            reader.readAsDataURL(files);
	        } else {
	            THIS.setState({
	                tempProfile: ''
	            });
	        }
	    };
	
	    this.handleFileMultiple = function (e) {
	        _this6.setState(_defineProperty({}, e.target.name, e.target.files));
	    };
	
	    this.handleGallery = function (e) {
	        _this6.setState(_defineProperty({}, e.target.name, e.target.files[0]));
	    };
	
	    this.getSuggestions = function () {
	        var _ref13 = _asyncToGenerator(_regenerator2.default.mark(function _callee11(value) {
	            var escapedValue, list, final;
	            return _regenerator2.default.wrap(function _callee11$(_context11) {
	                while (1) {
	                    switch (_context11.prev = _context11.next) {
	                        case 0:
	                            escapedValue = _this6.escapeRegexCharacters(value.trim());
	                            _context11.next = 3;
	                            return _this6.getSearchListFetch(escapedValue);
	
	                        case 3:
	                            list = _context11.sent;
	                            final = [];
	
	                            if (list.status === 1) {
	                                final = list.list;
	                                _this6.setState({
	                                    searchList: list.list
	                                });
	                            } else {
	                                final = [];
	                            }
	                            return _context11.abrupt('return', final);
	
	                        case 7:
	                        case 'end':
	                            return _context11.stop();
	                    }
	                }
	            }, _callee11, _this6);
	        }));
	
	        return function (_x7) {
	            return _ref13.apply(this, arguments);
	        };
	    }();
	
	    this.getSearchListFetch = function (val) {
	        var data = JSON.stringify({
	            keyword: val,
	            city: 'bengaluru'
	        });
	        return (0, _FetchCall.getSearchList)(data).then(function (response) {
	            return response;
	        });
	    };
	
	    this.shouldRenderSuggestions = function (value, reason) {
	        return value.trim().length > 2;
	    };
	
	    this.searchLink = function (e) {
	        e.preventDefault();
	
	        var search_text = _this6.state.value;
	        if (search_text.length > 3) {
	            //console.log('search_text',search_text)
	            var search = search_text.split(' ').join('+');
	            window.location.replace('/search/' + search);
	        }
	        // localStorage.setItem("searchdata", search_text);
	    };
	
	    this.onSuggestionsFetchRequested = function (_ref14) {
	        var value = _ref14.value;
	
	        _this6.getSuggestions(value).then(function (response) {
	            _this6.setState({
	                suggestions: response
	            });
	        });
	    };
	
	    this.onSuggestionsClearRequested = function () {
	        _this6.setState({
	            login_id: '',
	            suggestions: []
	        });
	    };
	
	    this.handleSubCatSelect = function () {
	        var _ref15 = _asyncToGenerator(_regenerator2.default.mark(function _callee12(e, i, name) {
	            var propName, value, subcategoriesselected;
	            return _regenerator2.default.wrap(function _callee12$(_context12) {
	                while (1) {
	                    switch (_context12.prev = _context12.next) {
	                        case 0:
	                            propName = e.target.name;
	                            value = [].concat(_toConsumableArray(e.target.selectedOptions)).map(function (item) {
	                                return item.value;
	                            });
	                            subcategoriesselected = _this6.state.subcategoriesselected;
	
	                            //subcategoriesselected[propName] = value;
	
	                            subcategoriesselected[i] = value;
	
	                            _this6.setState({ subcategoriesselected: subcategoriesselected });
	
	                        case 5:
	                        case 'end':
	                            return _context12.stop();
	                    }
	                }
	            }, _callee12, _this6);
	        }));
	
	        return function (_x8, _x9, _x10) {
	            return _ref15.apply(this, arguments);
	        };
	    }();
	
	    this.handleCustomeSelect = function () {
	        var _ref16 = _asyncToGenerator(_regenerator2.default.mark(function _callee13(e, name) {
	            var propName, value, category_ids, totalcategoryselected, arrays, cat_arrays, i;
	            return _regenerator2.default.wrap(function _callee13$(_context13) {
	                while (1) {
	                    switch (_context13.prev = _context13.next) {
	                        case 0:
	                            propName = e.target.name;
	                            //alert(e.target.attr('data-cat'));
	
	                            value = [].concat(_toConsumableArray(e.target.selectedOptions)).map(function (item) {
	                                return item.value;
	                            });
	                            category_ids = [].concat(_toConsumableArray(e.target.selectedOptions)).map(function (item) {
	                                return item.getAttribute('data-cat');
	                            });
	                            totalcategoryselected = _this6.state.totalcategoryselected;
	                            arrays = String(value).split(",");
	                            cat_arrays = String(category_ids).split(",");
	
	
	                            for (i = 0; i < arrays.length; i++) {
	                                totalcategoryselected[i] = arrays[i];
	                                _this6.setState({ totalcategoryselected: totalcategoryselected });
	                                _this6.getSubCategory(category_ids[i], i);
	                            }
	
	                            _this6.setState({ totalcategoryselected: totalcategoryselected });
	
	                        case 8:
	                        case 'end':
	                            return _context13.stop();
	                    }
	                }
	            }, _callee13, _this6);
	        }));
	
	        return function (_x11, _x12) {
	            return _ref16.apply(this, arguments);
	        };
	    }();
	
	    this.getSubCategoryEdit = function () {
	        var _ref17 = _asyncToGenerator(_regenerator2.default.mark(function _callee15(cat_id, ind) {
	            var req_c, sub_categorycollected, THIS;
	            return _regenerator2.default.wrap(function _callee15$(_context15) {
	                while (1) {
	                    switch (_context15.prev = _context15.next) {
	                        case 0:
	                            req_c = JSON.stringify({
	                                parent_category: cat_id,
	                                url: 'partner_sub_categories'
	                            });
	                            sub_categorycollected = _this6.state.sub_categorycollected;
	                            THIS = _this6;
	                            _context15.next = 5;
	                            return (0, _FetchCall.partnerSubCategories)(req_c).then(function () {
	                                var _ref18 = _asyncToGenerator(_regenerator2.default.mark(function _callee14(res_c) {
	                                    return _regenerator2.default.wrap(function _callee14$(_context14) {
	                                        while (1) {
	                                            switch (_context14.prev = _context14.next) {
	                                                case 0:
	                                                    if (res_c.status === 1) {
	                                                        sub_categorycollected[ind] = res_c.category_data.result;
	                                                        _this6.setState({ sub_categorycollected: sub_categorycollected });
	                                                    }
	
	                                                case 1:
	                                                case 'end':
	                                                    return _context14.stop();
	                                            }
	                                        }
	                                    }, _callee14, _this6);
	                                }));
	
	                                return function (_x15) {
	                                    return _ref18.apply(this, arguments);
	                                };
	                            }());
	
	                        case 5:
	                        case 'end':
	                            return _context15.stop();
	                    }
	                }
	            }, _callee15, _this6);
	        }));
	
	        return function (_x13, _x14) {
	            return _ref17.apply(this, arguments);
	        };
	    }();
	
	    this.getSubCategory = function () {
	        var _ref19 = _asyncToGenerator(_regenerator2.default.mark(function _callee17(cat_id, ind) {
	            var req_c, sub_categorycollected, THIS;
	            return _regenerator2.default.wrap(function _callee17$(_context17) {
	                while (1) {
	                    switch (_context17.prev = _context17.next) {
	                        case 0:
	                            req_c = JSON.stringify({
	                                parent_category: cat_id,
	                                url: 'partner_sub_categories'
	                            });
	                            sub_categorycollected = _this6.state.sub_categorycollected;
	                            THIS = _this6;
	                            _context17.next = 5;
	                            return (0, _FetchCall.partnerSubCategories)(req_c).then(function () {
	                                var _ref20 = _asyncToGenerator(_regenerator2.default.mark(function _callee16(res_c) {
	                                    return _regenerator2.default.wrap(function _callee16$(_context16) {
	                                        while (1) {
	                                            switch (_context16.prev = _context16.next) {
	                                                case 0:
	                                                    if (res_c.status === 1) {
	                                                        sub_categorycollected[ind] = res_c.category_data.result;
	                                                        _this6.setState({ sub_categorycollected: sub_categorycollected });
	                                                    }
	
	                                                case 1:
	                                                case 'end':
	                                                    return _context16.stop();
	                                            }
	                                        }
	                                    }, _callee16, _this6);
	                                }));
	
	                                return function (_x18) {
	                                    return _ref20.apply(this, arguments);
	                                };
	                            }());
	
	                        case 5:
	                        case 'end':
	                            return _context17.stop();
	                    }
	                }
	            }, _callee17, _this6);
	        }));
	
	        return function (_x16, _x17) {
	            return _ref19.apply(this, arguments);
	        };
	    }();
	
	    this.checkHasSubCategory = function () {
	        var _ref21 = _asyncToGenerator(_regenerator2.default.mark(function _callee18(current_arr, ele) {
	            var checkId, THIS, arr, temp, item;
	            return _regenerator2.default.wrap(function _callee18$(_context18) {
	                while (1) {
	                    switch (_context18.prev = _context18.next) {
	                        case 0:
	                            checkId = ele == 'second_category' ? current_arr.first_category_id : current_arr.second_category_id;
	                            THIS = _this6;
	                            arr = ele == 'second_category' ? current_arr.first_list : current_arr.second_category;
	
	                            console.log('checkId', arr);
	                            temp = arr.filter(function (item) {
	                                return item.is_parent == 1 && checkId.includes(item['category_id'].toString());
	                            });
	
	                            console.log('*** temp', temp);
	
	                            if (!(temp.length === 1)) {
	                                _context18.next = 13;
	                                break;
	                            }
	
	                            item = temp[0];
	
	                            console.log('checkId came inside', item['category_id']);
	                            _context18.next = 11;
	                            return _this6.getCategory(item['category_id'], ele, current_arr);
	
	                        case 11:
	                            current_arr = _context18.sent;
	
	                            current_arr['second_lbl'] = item['category_name'];
	
	                        case 13:
	                            _this6.setState({
	                                checking: true
	                            });
	                            setTimeout(function () {
	                                THIS.setState({
	                                    checking: false
	                                });
	                            }, 500);
	                            return _context18.abrupt('return', current_arr);
	
	                        case 16:
	                        case 'end':
	                            return _context18.stop();
	                    }
	                }
	            }, _callee18, _this6);
	        }));
	
	        return function (_x19, _x20) {
	            return _ref21.apply(this, arguments);
	        };
	    }();
	
	    this.handleChange = function (e) {
	        var propName = e.target.name;
	        _this6.setState(_defineProperty({}, e.target.name, e.target.value));
	    };
	
	    this.handleSubmit = function (e) {
	        e.preventDefault();
	
	        //console.log("nae1", e.target.program_name);
	
	        if (_this6.validator.allValid()) {
	            var insData = {
	                camp_id: _this6.camp_id,
	                approval_status: _this6.state.approval_status,
	                published: _this6.state.published,
	                about: _this6.state.about_camp,
	                camp_name: _this6.state.camp_name,
	                formValues: JSON.stringify(_this6.state.formValues)
	                /*
	                program_names : JSON.stringify(this.state.formValues.name),
	                program_todates: JSON.stringify(this.state.formValues.enddate),
	                program_fromdates: JSON.stringify(this.state.formValues.fromdate),
	                program_starttime: JSON.stringify(this.state.formValues.starttime),
	                program_endtime: JSON.stringify(this.state.formValues.endtime),
	                program_feeinr: JSON.stringify(this.state.formValues.feeinr),
	                program_feeusd: JSON.stringify(this.state.formValues.feeusd),
	                program_duration: JSON.stringify(this.state.formValues.duration),
	                program_days: JSON.stringify(this.state.formValues.days),
	                */
	            };
	
	            console.log('insData', insData);
	
	            // return false;
	            // jQuery("#btnSubmit").attr('disabled', true);
	
	            (0, _FetchCall.UpdateCuratedCampsByAdmin)(insData).then(function (res) {
	                var toastr = '';
	                if (res.status === 1) {
	
	                    toastr = window.toastr.success;
	                    toastr('', res.message, {
	                        positionClass: "toast-bottom-right",
	                        containerId: "toast-bottom-right"
	                    });
	                    _this6.props.history.push('/bewise_curated_list');
	                } else {
	                    (0, _jquery2.default)("#btnSubmit").attr('disabled', false);
	                    toastr = window.toastr.error; //warning
	                    toastr('Error', 'Something went wrong. try again!...', {
	                        positionClass: "toast-bottom-right",
	                        containerId: "toast-bottom-right"
	                    });
	                }
	            });
	        } else {
	            _this6.validator.showMessages();
	            _this6.forceUpdate();
	        }
	    };
	
	    this.removeImage = function (e) {
	        var delete_array = _this6.state.delete_array;
	        delete_array.push(e);
	        var updated = _this6.state.attachment_file.filter(function (item) {
	            return item.name !== e;
	        });
	        _this6.setState({
	            attachment_file: updated,
	            delete_array: delete_array
	        });
	    };
	};
	
	exports.default = bewiseEditCuratedCamp;

/***/ },
/* 896 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _FetchCall2 = _interopRequireDefault(_FetchCall);
	
	var _reactJsPagination = __webpack_require__(33);
	
	var _reactJsPagination2 = _interopRequireDefault(_reactJsPagination);
	
	__webpack_require__(18);
	
	var _reactNotifications = __webpack_require__(16);
	
	var _bewiseloading = __webpack_require__(48);
	
	var _bewiseloading2 = _interopRequireDefault(_bewiseloading);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import { Editor } from '@tinymce/tinymce-react';
	
	//import Pagination from 'rc-pagination';
	
	var bewiseUsers = function (_Component) {
	  _inherits(bewiseUsers, _Component);
	
	  function bewiseUsers(props) {
	    _classCallCheck(this, bewiseUsers);
	
	    var _this = _possibleConstructorReturn(this, (bewiseUsers.__proto__ || Object.getPrototypeOf(bewiseUsers)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var url = new URL(window.location.href);
	    var location = url.searchParams.get("location");
	    var auth_data = JSON.parse(localStorage.getItem("user_data"));
	    _this.state = {
	      logged: localStorage.getItem("authentication"),
	      auth_data: JSON.parse(localStorage.getItem("user_data")),
	      location: location ? location.split('-') : [],
	      bewiseUserList: [],
	      PER_PAGE: 15,
	      total: 0,
	      loading: true,
	      searchby: '',
	      activePage: 0,
	      offset: 0
	    };
	
	    return _this;
	  }
	
	  _createClass(bewiseUsers, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	
	      var THIS = this;
	      (0, _jquery2.default)(document).on('click', '.remove_user', function () {
	        var delete_id = (0, _jquery2.default)(this).data("id");
	        THIS.setState({
	          delete_id: delete_id
	        });
	        THIS.deletUser(delete_id);
	      });
	
	      this.getTotal();
	      this.getList();
	    }
	  }, {
	    key: 'deletUser',
	    value: function deletUser() {
	      var delete_id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	      if (confirm("Are you sure to Deactivate this user?") == true) {
	        var ins = JSON.stringify({
	          id: delete_id,
	          type: 5
	        });
	        (0, _FetchCall.deactivateUser)(ins).then(function (res) {
	          var toastr = '';
	          if (res.status === 1) {
	
	            _reactNotifications.NotificationManager.success(res.message);
	
	            setTimeout(function () {
	              window.location.reload();
	            }, 2000);
	          } else {
	
	            _reactNotifications.NotificationManager.error(res.message);
	          }
	        });
	      }
	    }
	  }, {
	    key: 'handlePageChange',
	    value: function handlePageChange(pageNumber) {
	
	      console.log('active page is ' + pageNumber);
	
	      this.setState({ activePage: pageNumber });
	
	      //this.getTotal('bw_schools');
	      this.getList(pageNumber);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          bewiseUserList = _state.bewiseUserList,
	          exportbtndisabled = _state.exportbtndisabled;
	      var _state2 = this.state,
	          currentPage = _state2.currentPage,
	          PER_PAGE = _state2.PER_PAGE,
	          totalCount = _state2.totalCount,
	          total = _state2.total;
	
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'col-lg-12 grid-margin stretch-card' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card-body' },
	                _react2.default.createElement(
	                  'h4',
	                  { 'class': 'card-title' },
	                  'BeWise Internal Users'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'float-right' },
	                  _react2.default.createElement(
	                    'a',
	                    { href: '/users/bewiseusers/addbewiseuser', 'class': 'btn btn-primary btn-sm' },
	                    'Add'
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'table-responsive pt-3' },
	                  _react2.default.createElement(
	                    'table',
	                    { id: 'tablebw' },
	                    _react2.default.createElement(
	                      'thead',
	                      { 'class': 'thead-dark' },
	                      _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'S.No'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Name'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Email Id'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Role'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Status'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Action'
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'tbody',
	                      null,
	                      bewiseUserList.map(function (item, i) {
	
	                        return _react2.default.createElement(
	                          'tr',
	                          null,
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.s_no
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.user_name
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.email_id
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.role_name
	                          ),
	                          _react2.default.createElement('td', { dangerouslySetInnerHTML: { __html: item.status } }),
	                          _react2.default.createElement('td', { 'class': 'actionbtns', dangerouslySetInnerHTML: { __html: item.action } })
	                        );
	                      })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'text-center' },
	                    _react2.default.createElement(_reactJsPagination2.default, {
	                      activePage: this.state.activePage,
	                      itemsCountPerPage: PER_PAGE,
	                      totalItemsCount: this.state.total,
	                      pageRangeDisplayed: 5,
	                      activeClass: "pagination__link--active",
	                      onChange: this.handlePageChange.bind(this),
	                      prevPageText: 'previous',
	                      nextPageText: 'next'
	                    })
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(_reactNotifications.NotificationContainer, null)
	        )
	      );
	    }
	  }]);
	
	  return bewiseUsers;
	}(_react.Component);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.getTotal = function () {
	    var location = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	
	    var locationselected = location == '' ? _this2.state.location : location;
	
	    var ins = JSON.stringify({
	      location: locationselected,
	      searchby: _this2.state.searchby
	    });
	
	    (0, _FetchCall.getTotalBewiseUsers)(ins).then(function (res) {
	
	      _this2.setState({ loading: true });
	
	      if (res.status == 1) {
	
	        _this2.setState({
	
	          total: res.total
	
	        });
	      }
	    });
	  };
	
	  this.getList = function () {
	    var pageNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	    var location = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	    var _state$auth_data = _this2.state.auth_data,
	        login_id = _state$auth_data.login_id,
	        role = _state$auth_data.role;
	
	
	    _this2.setState({ activePage: pageNumber });
	
	    var newOffset = pageNumber == 1 ? 0 : (pageNumber - 1) * _this2.state.PER_PAGE % _this2.state.total;
	
	    var locationselected = location == '' ? _this2.state.location : location;
	
	    var ins = JSON.stringify({
	      vendor_id: login_id,
	      role: role,
	      location: locationselected,
	      searchby: _this2.state.searchby,
	      perpage: _this2.state.PER_PAGE,
	      year: _this2.state.year,
	      month: _this2.state.month,
	      offset: newOffset
	    });
	
	    (0, _FetchCall.getBewiseUsersPaged)(ins).then(function (res) {
	
	      _this2.setState({ loading: true });
	
	      if (res.status == 1) {
	
	        _this2.setState({ loading: !_this2.state.loading });
	
	        _this2.setState({
	
	          bewiseUserList: res.data
	
	        });
	      } else {
	
	        _this2.setState({ loading: !_this2.state.loading });
	
	        _this2.setState({
	          bewiseUserList: []
	        });
	      }
	    });
	  };
	};
	
	exports.default = bewiseUsers;

/***/ },
/* 897 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _simpleReactValidator = __webpack_require__(28);
	
	var _simpleReactValidator2 = _interopRequireDefault(_simpleReactValidator);
	
	var _FetchCall = __webpack_require__(4);
	
	__webpack_require__(18);
	
	var _reactNotifications = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import { Editor } from '@tinymce/tinymce-react';
	
	
	var bewiseUsersEdit = function (_Component) {
	  _inherits(bewiseUsersEdit, _Component);
	
	  function bewiseUsersEdit(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, bewiseUsersEdit);
	
	    var _this = _possibleConstructorReturn(this, (bewiseUsersEdit.__proto__ || Object.getPrototypeOf(bewiseUsersEdit)).call(this, props));
	
	    _this.RoleDataList = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var res;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.prev = 0;
	              _context.next = 3;
	              return (0, _FetchCall.getRoleListV1)();
	
	            case 3:
	              res = _context.sent;
	
	              if (res.status == 1) {
	                console.log('res.results', res.list);
	                _this.setState({
	                  menu_list: res.list,
	                  error: false
	                });
	              }
	              _context.next = 10;
	              break;
	
	            case 7:
	              _context.prev = 7;
	              _context.t0 = _context['catch'](0);
	
	              _this.setState({ error: true });
	
	            case 10:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2, [[0, 7]]);
	    }));
	
	    _this.handleSelect = function (e) {
	      var propName = e.target.name;
	      var value = [].concat(_toConsumableArray(e.target.selectedOptions)).map(function (item) {
	        return item.value;
	      });
	      _this.setState(_defineProperty({}, propName, value));
	    };
	
	    _this.handleChange = function (e) {
	      _this.setState(_defineProperty({}, e.target.name, e.target.value));
	    };
	
	    _this.getLocation = function () {
	      var req = JSON.stringify({
	        url: 'location_list'
	      });
	      (0, _FetchCall.commonAPI)(req).then(function (res) {
	        if (res.status === 1) {
	          _this.setState({
	            locationList: res.list
	          });
	        }
	      });
	    };
	
	    _this.handleSubmit = function (e) {
	      e.preventDefault();
	      var toastr = '';
	      if (_this.validator.allValid()) {
	        var insert = JSON.stringify({
	          user_name: _this.state.user_name,
	          email_id: _this.state.email_id,
	          password: _this.state.password,
	          location: _this.state.location,
	          role: _this.state.role,
	          login_id: _this.state.login_id ? _this.state.login_id : '',
	          url: 'adduser_data'
	        });
	
	        (0, _FetchCall.adminUser)(insert).then(function (response) {
	          if (response.status == 1) {
	
	            _reactNotifications.NotificationManager.success(response.message);
	
	            setTimeout(function () {
	              window.location.replace('/users/bewiseusers');
	            }, 1000);
	          } else {
	
	            _reactNotifications.NotificationManager.error(response.message);
	
	            setTimeout(function () {}, 1000);
	          }
	        });
	      } else {
	        _this.validator.showMessages();
	        _this.forceUpdate();
	      }
	    };
	
	    _this.state = {
	      menu_list: [],
	      locationList: [],
	      showPassword: false,
	      showCPassword: false,
	      errors: [],
	      user_name: '',
	      email_id: '',
	      location: '',
	      role: '',
	      password: '',
	      confirm_password: '',
	      login_id: _this.props.match.params.id ? _this.props.match.params.id : ''
	    };
	
	    _this.id = _this.props.match.params.id ? _this.props.match.params.id : '';
	
	    _this.validator = new _simpleReactValidator2.default({
	      validators: {
	        confirmpassword: { // name the rule
	          message: 'The :attribute must be Same as Password.',
	          rule: function rule(val, params, validator) {
	            if (val != _this.state.password) {
	              return false;
	            }
	          },
	          messageReplace: function messageReplace(message, params) {
	            return message.replace(':values', _this.helpers.toSentence(params));
	          }, // optional
	          required: true // optional
	        }
	      }
	    });
	
	    return _this;
	  }
	
	  _createClass(bewiseUsersEdit, [{
	    key: 'EditSubuser',
	    value: function EditSubuser() {
	      var _this3 = this;
	
	      var ins = JSON.stringify({
	        login_id: this.id,
	        url: 'editUser'
	      });
	
	      (0, _FetchCall.adminUser)(ins).then(function (res) {
	        if (res.status == 1) {
	          console.log('res', res.data);
	          _this3.setState({
	            user_name: res.data.user_name,
	            email_id: res.data.email_id,
	            location: res.data.city,
	            role: res.data.role
	          });
	        }
	      });
	    }
	  }, {
	    key: 'UNSAFE_componentWillMount',
	    value: function UNSAFE_componentWillMount() {}
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.RoleDataList();
	      this.getLocation();
	      this.EditSubuser();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      window.jQuery('.selectpicker').selectpicker('refresh');
	    }
	  }, {
	    key: 'handleShowPassword',
	    value: function handleShowPassword() {
	      this.setState(function (prevState) {
	        return {
	          showPassword: !prevState.showPassword
	        };
	      });
	    }
	  }, {
	    key: 'handleShowCPassword',
	    value: function handleShowCPassword() {
	      this.setState(function (prevState) {
	        return {
	          showCPassword: !prevState.showCPassword
	        };
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      this.validator.purgeFields();
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'col-12 grid-margin' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card-body' },
	                _react2.default.createElement(
	                  'h4',
	                  { 'class': 'card-title' },
	                  'User - Edit'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { id: 'company-info' },
	                  _react2.default.createElement(
	                    'form',
	                    {
	                      encType: 'multipart/form-data',
	                      method: 'post',
	                      onSubmit: this.handleSubmit,
	                      autoComplete: 'off',
	                      className: 'custom-form invoice-form col-md-12 col-xs-12 legend-form pad-no'
	                    },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'box-shadow-custom' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'form-group col-md-4' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            'Name',
	                            _react2.default.createElement(
	                              'span',
	                              { className: 'astrick' },
	                              '*'
	                            )
	                          ),
	                          _react2.default.createElement('input', {
	
	                            type: 'text',
	                            className: 'form-control',
	                            name: 'user_name',
	                            autocomplete: 'off',
	                            value: this.state.user_name,
	                            onChange: this.handleChange
	                          })
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'form-group col-md-4' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            'Email Id',
	                            _react2.default.createElement(
	                              'span',
	                              { className: 'astrick' },
	                              '*'
	                            )
	                          ),
	                          _react2.default.createElement('input', {
	
	                            type: 'email',
	                            className: 'form-control',
	                            name: 'email_id',
	                            autocomplete: 'off',
	                            value: this.state.email_id,
	                            onChange: this.handleChange
	                          })
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'form-group col-md-4' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            'Location',
	                            _react2.default.createElement(
	                              'span',
	                              { className: 'astrick' },
	                              '*'
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'custom-select-drop dropdown' },
	                            _react2.default.createElement(
	                              'select',
	                              {
	                                name: 'location',
	                                id: 'location',
	                                autocomplete: 'off',
	                                onChange: this.handleSelect,
	                                value: this.state.location,
	                                className: 'form-control selectpicker', title: 'Select' },
	                              this.state.locationList.length > 0 && this.state.locationList.map(function (item, i) {
	                                return _react2.default.createElement(
	                                  'option',
	                                  { value: item.location },
	                                  item.location
	                                );
	                              })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'form-group col-md-4' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            'Role',
	                            _react2.default.createElement(
	                              'span',
	                              { className: 'astrick' },
	                              '*'
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'custom-select-drop dropdown' },
	                            _react2.default.createElement(
	                              'select',
	                              {
	                                name: 'role',
	                                id: 'role',
	                                onChange: this.handleSelect,
	                                value: this.state.role,
	                                autocomplete: 'off',
	                                className: 'form-control selectpicker', title: 'Select' },
	                              this.state.menu_list.length > 0 && this.state.menu_list.map(function (item, i) {
	                                return _react2.default.createElement(
	                                  'option',
	                                  { value: item.id },
	                                  item.role
	                                );
	                              })
	                            )
	                          )
	                        ),
	                        ' ',
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'form-group col-md-4' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            'Password ',
	                            _react2.default.createElement(
	                              'span',
	                              { className: 'astrick' },
	                              '*'
	                            )
	                          ),
	                          _react2.default.createElement('input', {
	                            type: this.state.showPassword ? 'text' : 'password',
	                            name: 'password',
	                            value: this.state.password,
	                            autocomplete: 'off',
	                            onChange: this.handleChange,
	                            className: 'form-control'
	                          }),
	                          _react2.default.createElement('span', {
	                            toggle: '#password-field',
	                            className: this.state.showPassword ? 'fa fa-fw fa-eye-slash field-icon plogin' : 'fa fa-fw fa-eye field-icon plogin',
	                            onClick: function onClick() {
	                              _this4.handleShowPassword();
	                            }
	                          })
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'form-group col-md-4' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            'Confirm Password ',
	                            _react2.default.createElement(
	                              'span',
	                              { className: 'astrick' },
	                              '*'
	                            )
	                          ),
	                          _react2.default.createElement('input', {
	                            type: this.state.showCPassword ? 'text' : 'password',
	                            name: 'confirm_password',
	                            autocomplete: 'off',
	                            value: this.state.confirm_password,
	                            onChange: this.handleChange,
	                            className: 'form-control'
	                          }),
	                          _react2.default.createElement('span', {
	                            toggle: '#password-field',
	                            className: this.state.showCPassword ? 'fa fa-fw fa-eye-slash field-icon plogin' : 'fa fa-fw fa-eye field-icon plogin',
	                            onClick: function onClick() {
	                              _this4.handleShowCPassword();
	                            }
	                          })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-md-12 col-xs-12 btn-bdr' },
	                      _react2.default.createElement(
	                        'button',
	                        { id: 'btnSubmit', className: 'btn btn-primary btn-sm' },
	                        'Submit'
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(_reactNotifications.NotificationContainer, null)
	        )
	      );
	    }
	  }]);
	
	  return bewiseUsersEdit;
	}(_react.Component);
	
	exports.default = bewiseUsersEdit;

/***/ },
/* 898 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _FetchCall2 = _interopRequireDefault(_FetchCall);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import { Editor } from '@tinymce/tinymce-react';
	
	
	var ViewPaymentCamp = function (_Component) {
	    _inherits(ViewPaymentCamp, _Component);
	
	    function ViewPaymentCamp(props) {
	        _classCallCheck(this, ViewPaymentCamp);
	
	        var _this = _possibleConstructorReturn(this, (ViewPaymentCamp.__proto__ || Object.getPrototypeOf(ViewPaymentCamp)).call(this, props));
	
	        _this.handleChange = function (e) {
	            _this.setState(_defineProperty({}, e.target.name, e.target.value));
	        };
	
	        _this.getCuratedPaymentCampList = function () {
	
	            (0, _FetchCall.getCuratedRegistrationList)(_this.camp_id).then(function (res) {
	                if (res.status == 1) {
	                    _this.setState({
	                        paymentlist: res.data
	                    });
	                    //this.datatabledata(res.data);
	                } else {
	                    _this.setState({
	                        paymentlist: []
	                    });
	                }
	            });
	        };
	
	        _this.handleClick = function (reg_id, camp_id) {
	
	            var ins = JSON.stringify({
	                reg_id: reg_id,
	                camp_id: camp_id
	            });
	
	            (0, _FetchCall.sendWelcomeEmailCamp)(ins).then(function (res) {
	                var toastr = '';
	                if (res.status === 1) {
	                    toastr = window.toastr.success;
	                    toastr('success', 'Mail is sent successfully', {
	                        positionClass: "toast-bottom-right",
	                        containerId: "toast-bottom-right"
	                    });
	                } else {
	                    toastr = res.message; //warning
	                    toastr('Error', toastr, {
	                        positionClass: "toast-bottom-right",
	                        containerId: "toast-bottom-right"
	                    });
	                }
	            });
	        };
	
	        var url = new URL(window.location.href);
	        var location = url.searchParams.get("location");
	        var auth_data = JSON.parse(localStorage.getItem("user_data"));
	        _this.state = {
	            logged: localStorage.getItem("authentication"),
	            auth_data: JSON.parse(localStorage.getItem("user_data")),
	            location: location ? location : auth_data.access_location ? auth_data.access_location : 'Bengaluru',
	            paymentlist: [],
	            openedAdd: false
	        };
	        _this.camp_id = _this.props.match.params.camp_id ? _this.props.match.params.camp_id : '';
	        _this.getCuratedPaymentCampList();
	        return _this;
	    }
	
	    _createClass(ViewPaymentCamp, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	
	            var THIS = this;
	            (0, _jquery2.default)(document).on('click', '.remove_item', function () {
	                var delete_id = (0, _jquery2.default)(this).data("id");
	                THIS.setState({
	                    delete_id: delete_id
	                });
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var paymentlist = this.state.paymentlist;
	
	
	            return _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _react2.default.createElement(
	                    _layout2.default,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { 'class': 'col-lg-12 grid-margin stretch-card' },
	                        _react2.default.createElement(
	                            'div',
	                            { 'class': 'card' },
	                            _react2.default.createElement(
	                                'div',
	                                { 'class': 'card-body' },
	                                _react2.default.createElement(
	                                    'h4',
	                                    { 'class': 'card-title' },
	                                    'Curated Camps- Payments and Registrations'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'row col-lg-12' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'pt-3 table-responsive' },
	                                        _react2.default.createElement(
	                                            'table',
	                                            { 'class': 'table table-bordered table-striped table-sm' },
	                                            _react2.default.createElement(
	                                                'thead',
	                                                { 'class': 'thead-dark' },
	                                                _react2.default.createElement(
	                                                    'th',
	                                                    { className: 'tabledata' },
	                                                    'S.No'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'th',
	                                                    { className: 'tabledata' },
	                                                    'Customer'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'th',
	                                                    { className: 'tabledata' },
	                                                    'Date Registered'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'th',
	                                                    { className: 'tabledata' },
	                                                    'Payment Amount'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'th',
	                                                    { className: 'tabledata' },
	                                                    'Payment Status'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'th',
	                                                    { className: 'tabledata' },
	                                                    'Action'
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'tbody',
	                                                null,
	                                                paymentlist.map(function (item, i) {
	
	                                                    var renderpaidlbl = '';
	                                                    if (item.status == 'paid') renderpaidlbl = '<span class="label label-success">Paid</span>';else renderpaidlbl = '<span class="label label-danger">UnPaid</span>';
	
	                                                    return _react2.default.createElement(
	                                                        'tr',
	                                                        null,
	                                                        _react2.default.createElement(
	                                                            'td',
	                                                            null,
	                                                            i + 1
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'td',
	                                                            null,
	                                                            item.firstname
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'td',
	                                                            null,
	                                                            item.created_date
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'td',
	                                                            null,
	                                                            item.amount_paid
	                                                        ),
	                                                        _react2.default.createElement('td', { dangerouslySetInnerHTML: { __html: renderpaidlbl } }),
	                                                        _react2.default.createElement(
	                                                            'td',
	                                                            null,
	                                                            _react2.default.createElement(
	                                                                'button',
	                                                                { 'class': 'btn btn-primary btn-sm', onClick: function onClick() {
	                                                                        return _this2.handleClick(item.reg_id, item.camp_id);
	                                                                    } },
	                                                                'send mail'
	                                                            )
	                                                        )
	                                                    );
	                                                })
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ViewPaymentCamp;
	}(_react.Component);
	
	exports.default = ViewPaymentCamp;

/***/ },
/* 899 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _FetchCall2 = _interopRequireDefault(_FetchCall);
	
	var _chart = __webpack_require__(83);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import { Editor } from '@tinymce/tinymce-react';
	
	var bewisetotal = function (_Component) {
	  _inherits(bewisetotal, _Component);
	
	  function bewisetotal(props) {
	    _classCallCheck(this, bewisetotal);
	
	    var _this = _possibleConstructorReturn(this, (bewisetotal.__proto__ || Object.getPrototypeOf(bewisetotal)).call(this, props));
	
	    _this.getTotalUsers = function () {
	      var _this$state$auth_data = _this.state.auth_data,
	          login_id = _this$state$auth_data.login_id,
	          role = _this$state$auth_data.role;
	
	      var ins = JSON.stringify({
	        vendor_id: login_id,
	        role: role
	      });
	      (0, _FetchCall.getTotalUsers)(ins).then(function (res) {
	        if (res.status == 1) {
	
	          var MeSeData = {
	            labels: ["Schools", "Preschools", "Tuitions", "After Schools", "Learning Camps", "Community Supports", "Events"],
	            datasets: [{
	              label: "Users",
	              data: res.data,
	              backgroundColor: ["#669911", "#669911", "#669911", "#669911", "#669911", "#669911", "#669911"],
	              hoverBackgroundColor: ["#66A2EB", "#FCCE56", "#66A2EB", "#FCCE56", "#66A2EB", "#FCCE56", "#66A2EB"]
	            }]
	          };
	
	          var myChart = new _chart.Chart(document.getElementById('horizontalVerticalChart'), {
	            type: 'horizontalBar',
	            data: MeSeData,
	            options: {
	
	              scales: {
	                xAxes: [{
	                  ticks: {
	                    beginAtZero: true
	                  }
	                }]
	              }
	            }
	          });
	        }
	      });
	    };
	
	    var url = new URL(window.location.href);
	    var location = url.searchParams.get("location");
	    var auth_data = JSON.parse(localStorage.getItem("user_data"));
	    _this.state = {
	      logged: localStorage.getItem("authentication"),
	      auth_data: JSON.parse(localStorage.getItem("user_data")),
	      location: location ? location : auth_data.access_location ? auth_data.access_location : 'Bengaluru',
	      mailList: []
	    };
	
	    _this.getTotalUsers();
	    return _this;
	  }
	
	  _createClass(bewisetotal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	
	      var THIS = this;
	      (0, _jquery2.default)(document).on('click', '.remove_maili', function () {
	        var delete_id = (0, _jquery2.default)(this).data("id");
	        THIS.setState({
	          delete_id: delete_id
	        });
	      });
	
	      //this.setHorizontalVerticalChart(databarhorizontal);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var mailList = this.state.mailList;
	
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'row  mt-3' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'col-xl-12 d-flex grid-margin stretch-card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'card-body' },
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'd-flex flex-wrap justify-content-between' },
	                    _react2.default.createElement(
	                      'h4',
	                      { 'class': 'card-title mb-3' },
	                      'Reports'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'col-6' },
	                      _react2.default.createElement('canvas', { id: 'horizontalVerticalChart' })
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return bewisetotal;
	}(_react.Component);
	
	exports.default = bewisetotal;

/***/ },
/* 900 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _FetchCall2 = _interopRequireDefault(_FetchCall);
	
	var _reactAutosuggest = __webpack_require__(86);
	
	var _reactAutosuggest2 = _interopRequireDefault(_reactAutosuggest);
	
	var _draftJs = __webpack_require__(84);
	
	__webpack_require__(92);
	
	var _draftjsToHtml = __webpack_require__(106);
	
	var _draftjsToHtml2 = _interopRequireDefault(_draftjsToHtml);
	
	var _tinymceReact = __webpack_require__(69);
	
	var _constant = __webpack_require__(21);
	
	var _axios = __webpack_require__(184);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	__webpack_require__(18);
	
	var _reactNotifications = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import { Editor } from '@tinymce/tinymce-react';
	
	//import { Editor } from 'react-draft-wysiwyg';
	
	
	var cmsAddEditInsight = function (_Component) {
	  _inherits(cmsAddEditInsight, _Component);
	
	  function cmsAddEditInsight(props) {
	    _classCallCheck(this, cmsAddEditInsight);
	
	    var _this = _possibleConstructorReturn(this, (cmsAddEditInsight.__proto__ || Object.getPrototypeOf(cmsAddEditInsight)).call(this, props));
	
	    _this.handleChange = function (e) {
	      _this.setState(_defineProperty({}, e.target.name, e.target.value));
	    };
	
	    _this.handleCheck = function (e) {
	      _this.setState(function (prevState) {
	        return {
	          show_upload: !prevState.show_upload
	        };
	      });
	    };
	
	    _this.customChange = function (e, i) {
	      var social_links = _this.state.social_links;
	      if (social_links.length > 0 && social_links[i]) {
	        social_links[i].link = e.target.value;
	      }
	      _this.setState({ social_links: social_links });
	    };
	
	    _this.handleFile = function (e) {
	      var propName = e.target.name;
	      var files = e.target.files[0];
	      _this.setState(_defineProperty({}, propName, files));
	    };
	
	    _this.uploadImageCallBack = function (e) {
	      var propName = e.target.name;
	      var files = e.target.files;
	      _this.setState(_defineProperty({}, propName, files));
	    };
	
	    _this.handleFileMultiple = function (e) {
	      var propName = e.target.name;
	      var files = e.target.files;
	      if (files.length > 2) {
	        files = '';
	        var toastr = window.toastr.error; //warning
	        toastr('', 'Select Article 2 Images Only', {
	          positionClass: "toast-bottom-right",
	          containerId: "toast-bottom-right"
	        });
	      }
	      _this.setState(_defineProperty({}, propName, files));
	    };
	
	    _this.handleSelect = function (e) {
	      var propName = e.target.name;
	      var value = [].concat(_toConsumableArray(e.target.selectedOptions)).map(function (item) {
	        return item.value;
	      });
	      _this.setState(_defineProperty({}, propName, value));
	    };
	
	    _this.getInsightDetail = function () {
	      var ins = JSON.stringify({
	        id: _this.id
	      });
	      (0, _FetchCall.getArticleDetail)(ins).then(function (res) {
	        if (res.status == 1) {
	          var _this$setState6;
	
	          var data = res.detail;
	          _this.setState((_this$setState6 = {
	            insight_id: data.insight_id,
	            insight_title: data.title,
	            related_vertical: data.related_vertical,
	            slug_term: data.slug_term,
	            authorname: data.authorname,
	            category: data.category,
	            insight_desc: data.main_content,
	            social_links: data.social_links ? JSON.parse(data.social_links) : _this.state.social_links,
	            banner_image: data.banner_image ? res.base_url + data.banner_image : '',
	            banner_new: '',
	            gallery_image: data.gallery_image ? res.base_url + data.gallery_image : '',
	            gallery_new: ''
	          }, _defineProperty(_this$setState6, 'related_vertical', data.related_vertical), _defineProperty(_this$setState6, 'about_author', data.about_author), _defineProperty(_this$setState6, 'location', data.location ? data.location.split(',') : []), _defineProperty(_this$setState6, 'insight_content', data.detail_content), _defineProperty(_this$setState6, 'insight_author', data.author_name), _defineProperty(_this$setState6, 'status', data.status), _defineProperty(_this$setState6, 'editorState', _draftJs.EditorState.createWithContent(_draftJs.ContentState.createFromBlockArray((0, _draftJs.convertFromHTML)(res.detail.detail_content)))), _this$setState6));
	
	          _this.setState({
	            consigne: _draftJs.EditorState.createWithContent(_draftJs.ContentState.createFromBlockArray((0, _draftJs.convertFromHTML)(res.detail.detail_content)))
	          });
	        } else {
	          _this.setState({
	            insightDetail: ''
	          });
	        }
	      });
	    };
	
	    _this.onSuggestionsFetchRequested = function (_ref) {
	      var value = _ref.value;
	
	      console.log('came first ', value);
	      var val = _this.escapeRegexCharacters(value.trim());
	      var fetch = JSON.stringify({
	        keyword: val,
	        role: 1
	      });
	      (0, _FetchCall.getAuthorSuggest)(fetch).then(function (res) {
	        if (res.status == 1) {
	          _this.setState({
	            suggestions: res.list
	          });
	        }
	      });
	    };
	
	    _this.onSuggestionsClearRequested = function () {
	      _this.setState({
	        suggestions: []
	      });
	    };
	
	    _this.onSuggestionSelected = function (event, _ref2) {
	      var suggestion = _ref2.suggestion,
	          suggestionValue = _ref2.suggestionValue,
	          suggestionIndex = _ref2.suggestionIndex,
	          sectionIndex = _ref2.sectionIndex,
	          method = _ref2.method;
	
	      (0, _jquery2.default)("#vendor_id").val(suggestion.vendor_id);
	      //alert(suggestion.vendor_id);
	      _this.setState({
	        login_id: suggestion.vendor_id
	      });
	    };
	
	    _this.getSuggestionValue = function (suggestion) {
	      return suggestion.name;
	    };
	
	    _this.onChange = function (event, _ref3) {
	      var newValue = _ref3.newValue,
	          method = _ref3.method;
	
	      _this.setState({
	        insight_author: newValue
	      });
	    };
	
	    _this.getLocation = function () {
	      var req = JSON.stringify({
	        url: 'location_list'
	      });
	      (0, _FetchCall.commonAPI)(req).then(function (res) {
	        if (res.status === 1) {
	          _this.setState({
	            locationList: res.list
	          });
	        }
	      });
	    };
	
	    _this.getBlogCategory = function () {
	      var req = JSON.stringify({
	        site: 'wiseconnect'
	      });
	      (0, _FetchCall.getBlogCategory)(req).then(function (res) {
	        if (res.status === 1) {
	          _this.setState({
	            categorylist: res.list
	          });
	        } else {
	          _this.setState({
	            categorylist: []
	          });
	        }
	      });
	    };
	
	    _this.getBlogBeWiseCategory = function () {
	      var req = JSON.stringify({
	        site: 'bewise'
	      });
	      (0, _FetchCall.getBlogCategory)(req).then(function (res) {
	        if (res.status === 1) {
	          _this.setState({
	            bewisecategorylist: res.list
	          });
	        } else {
	          _this.setState({
	            bewisecategorylist: []
	          });
	        }
	      });
	    };
	
	    _this.approveBlog = function (e) {
	
	      var insert = JSON.stringify({
	        insight_id: _this.state.insight_id,
	        status: 1
	      });
	
	      (0, _FetchCall.approveInsight)(insert).then(function (response) {
	        _this.setState({
	          btnDisable: false
	        });
	        if (response.status == 1) {
	
	          _reactNotifications.NotificationManager.success('Insight is approved successfully..redirecting to list');
	
	          window.location.href = '/cms/insights';
	          //alert("Insight is added");
	        }
	      });
	    };
	
	    _this.handleSubmit = function (e) {
	
	      var insert = {
	        insight_id: _this.state.insight_id,
	        insight_title: _this.state.insight_title,
	        insight_desc: _this.state.insight_desc,
	        slug_term: _this.state.slug_term,
	        about_author: _this.state.about_author,
	        related_vertical: _this.state.related_vertical,
	        location: _this.state.location,
	        insight_content: _this.state.insight_content,
	        social_links: JSON.stringify(_this.state.social_links),
	        insight_author: _this.state.insight_author,
	        category: _this.state.category,
	        featured: _this.state.featured,
	        banner_new: _this.state.banner_new,
	        gallery_new: _this.state.gallery_new
	      };
	      (0, _FetchCall.updateInsights)(insert).then(function (response) {
	        _this.setState({
	          btnDisable: false
	        });
	        if (response.status == 1) {
	          if (_this.state.insight_id == '') _reactNotifications.NotificationManager.success('Insight is added successfully..redirecting to list');else _reactNotifications.NotificationManager.success('Insight is updated successfully..redirecting to list');
	
	          window.location.href = '/cms/insights';
	          //alert("Insight is added");
	        } else {
	          //alert("Issue in adding insight");
	          _reactNotifications.NotificationManager.success('Insight is added successfully..redirecting to list');
	        }
	      });
	    };
	
	    _this.onChangeEditor = function (editorState) {
	      //const contentState = editorState.getCurrentContent();
	      //console.log("plain text", editorState.getCurrentContent().getPlainText());
	
	      var contentState = (0, _draftjsToHtml2.default)((0, _draftJs.convertToRaw)(editorState.getCurrentContent()));
	
	      console.log("html", contentState);
	      //const raw = convertToRaw(contentState);
	      _this.setState({
	        consigne: editorState,
	        insight_content: contentState
	      });
	    };
	
	    _this.state = {
	      logged: localStorage.getItem("authentication"),
	      auth_data: JSON.parse(localStorage.getItem("user_data")),
	      write_permission: true,
	      insight_id: 0,
	      insight_title: '',
	      insight_desc: '',
	      banner_image: '',
	      banner_new: '',
	      gallery_image: '',
	      article_images: '',
	      show_upload: false,
	      articleuploaded: false,
	      gallery_new: '',
	      insight_content: '',
	      insight_author: '',
	      about_author: '',
	      related_vertical: '',
	      social_links: [{ id: "fb", name: 'Facebook', link: "" }, { id: "li", name: 'LinkedIn', link: "" }, { id: "in", name: 'Instagram', link: "" }, { id: "tw", name: 'Twitter', link: "" }],
	      imageList: [],
	      suggestions: [],
	      location: [],
	      locationList: [],
	      categorylist: [],
	      bewisecategorylist: [],
	      btnDisable: false,
	      category: '',
	      featured: 0,
	      editorState: _draftJs.EditorState.createEmpty()
	    };
	    _this.getLocation();
	    _this.handleEditorChange = _this.handleEditorChange.bind(_this);
	    _this.approveBlog = _this.approveBlog.bind(_this);
	    _this.id = _this.props.match.params.id ? _this.props.match.params.id : '';
	    return _this;
	  }
	
	  _createClass(cmsAddEditInsight, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	
	      var THIS = this;
	
	      if (this.id != '') this.getInsightDetail(this.id);
	
	      this.getBlogCategory();
	      this.getBlogBeWiseCategory();
	    }
	  }, {
	    key: 'handleEditorChange',
	    value: function handleEditorChange(value, editor) {
	      this.setState({
	        insight_content: value
	      });
	    }
	  }, {
	    key: 'escapeRegexCharacters',
	    value: function escapeRegexCharacters(str) {
	      return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	    }
	  }, {
	    key: 'renderSuggestion',
	    value: function renderSuggestion(suggestion) {
	      return _react2.default.createElement(
	        'span',
	        null,
	        suggestion.name
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var insightDetail = this.state.insightDetail;
	      var _state = this.state,
	          categorylist = _state.categorylist,
	          suggestions = _state.suggestions,
	          bewisecategorylist = _state.bewisecategorylist;
	
	      var inputProps = {
	        value: this.state.insight_author,
	        onChange: this.onChange,
	        name: 'insight_author',
	        className: 'form-control'
	      };
	
	      var _state2 = this.state,
	          insight_content = _state2.insight_content,
	          editorState = _state2.editorState,
	          consigne = _state2.consigne;
	      var _state$auth_data = this.state.auth_data,
	          login_id = _state$auth_data.login_id,
	          role = _state$auth_data.role;
	
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'col-12 grid-margin' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card-body' },
	                _react2.default.createElement(
	                  'h4',
	                  { 'class': 'card-title' },
	                  'Insights - Add/Edit'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'form-group col-md-3' },
	                      _react2.default.createElement(
	                        'label',
	                        null,
	                        ' Title ',
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'astrick' },
	                          '*'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'form-group col-md-9' },
	                      _react2.default.createElement('input', { name: 'insight_title', className: 'form-control', type: 'text', value: this.state.insight_title,
	                        onChange: this.handleChange })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'form-group col-md-3' },
	                      _react2.default.createElement(
	                        'label',
	                        null,
	                        ' Preferred URL (Never use special characaters as *,@,#,/,+,- and etc, except hyphen(-))'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'form-group col-md-9' },
	                      _react2.default.createElement('input', { name: 'slug_term', className: 'form-control', type: 'text', value: this.state.slug_term,
	                        onChange: this.handleChange })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'form-group col-md-3' },
	                      _react2.default.createElement(
	                        'label',
	                        null,
	                        ' Description ',
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'astrick' },
	                          '*'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'form-group col-md-9' },
	                      _react2.default.createElement('textarea', { name: 'insight_desc', className: 'form-control', rows: 3, value: this.state.insight_desc,
	                        onChange: this.handleChange })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'form-group col-md-3' },
	                      _react2.default.createElement(
	                        'label',
	                        null,
	                        ' Blog related to ',
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'astrick' },
	                          '*'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'form-group col-md-9' },
	                      _react2.default.createElement(
	                        'select',
	                        { 'class': 'form-control', name: 'related_vertical', value: this.state.related_vertical, onChange: this.handleChange },
	                        _react2.default.createElement(
	                          'option',
	                          { value: '' },
	                          'Select'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'tuitionblogs' },
	                          'Tuition Blogs'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'schoolblogs' },
	                          'School Blogs'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'preschoolblogs' },
	                          'Preschool Blogs'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'danceblogs' },
	                          'Dance Blogs'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'sportsblogs' },
	                          'Sports Blogs'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'musicblogs' },
	                          'Music Blogs'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'artblogs' },
	                          'Art Blogs'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'hobbiesblogs' },
	                          'Hobbies Blogs'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'wiseconnectblogs' },
	                          'WiseConnect Blogs'
	                        )
	                      )
	                    )
	                  ),
	                  this.state.related_vertical == 'wiseconnectblogs' && _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'form-group col-md-3' },
	                      _react2.default.createElement(
	                        'label',
	                        null,
	                        ' Choose Category ',
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'astrick' },
	                          '*'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'form-group col-md-9' },
	                      _react2.default.createElement(
	                        'select',
	                        { 'class': 'form-control', name: 'category', value: this.state.category, onChange: this.handleChange },
	                        _react2.default.createElement(
	                          'option',
	                          { value: '' },
	                          'Select'
	                        ),
	                        categorylist.map(function (item, index) {
	
	                          return _react2.default.createElement(
	                            'option',
	                            { value: item.id },
	                            item.name
	                          );
	                        })
	                      )
	                    )
	                  ),
	                  this.state.related_vertical != 'wiseconnectblogs' && _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'form-group col-md-3' },
	                      _react2.default.createElement(
	                        'label',
	                        null,
	                        ' Choose Category ',
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'astrick' },
	                          '*'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'form-group col-md-9' },
	                      _react2.default.createElement(
	                        'select',
	                        { 'class': 'form-control', name: 'category', value: this.state.category, onChange: this.handleChange },
	                        _react2.default.createElement(
	                          'option',
	                          { value: '' },
	                          'Select'
	                        ),
	                        bewisecategorylist.map(function (item, index) {
	
	                          return _react2.default.createElement(
	                            'option',
	                            { value: item.id },
	                            item.name
	                          );
	                        })
	                      )
	                    )
	                  ),
	                  this.state.related_vertical == 'wiseconnectblogs' && _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'form-group col-md-3' },
	                      _react2.default.createElement(
	                        'label',
	                        null,
	                        ' Want to make featured '
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'form-group col-md-9 flexoption' },
	                      _react2.default.createElement('input', { type: 'radio', name: 'featured', value: '1', onChange: this.handleChange }),
	                      ' Yes\xA0',
	                      _react2.default.createElement('input', { type: 'radio', name: 'featured', value: '0', onChange: this.handleChange, checked: true }),
	                      ' No'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'form-group col-md-3' },
	                      _react2.default.createElement(
	                        'label',
	                        null,
	                        ' Blog Banner Image ',
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'astrick' },
	                          '* (prefer .webp format) '
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'form-group col-md-9' },
	                      _react2.default.createElement('input', {
	                        type: 'file',
	                        name: 'gallery_new',
	                        onChange: this.handleFile,
	                        className: 'form-control mar-btm',
	                        accept: 'image/x-png,image/gif,image/jpeg'
	                      })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'form-group col-md-3' },
	                      _react2.default.createElement(
	                        'label',
	                        null,
	                        ' Author Name ',
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'astrick' },
	                          '*'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'form-group col-md-9' },
	                      _react2.default.createElement(_reactAutosuggest2.default, {
	                        suggestions: suggestions,
	                        onSuggestionsFetchRequested: this.onSuggestionsFetchRequested,
	                        onSuggestionsClearRequested: this.onSuggestionsClearRequested,
	                        getSuggestionValue: this.getSuggestionValue,
	                        renderSuggestion: this.renderSuggestion,
	                        inputProps: inputProps })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row', style: { marginBottom: '30px' } },
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'form-group col-md-3' },
	                      _react2.default.createElement(
	                        'label',
	                        null,
	                        ' Content ',
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'astrick' },
	                          '*'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'form-group col-md-9' },
	                      _react2.default.createElement(_tinymceReact.Editor, {
	                        onEditorChange: this.handleEditorChange,
	                        toolbar: {
	                          inline: { inDropdown: true },
	                          list: { inDropdown: true },
	                          textAlign: { inDropdown: true },
	                          link: { inDropdown: true },
	                          history: { inDropdown: true },
	                          image: { uploadCallback: this.uploadImageCallBack, alt: { present: true, mandatory: true } }
	                        },
	                        value: this.state.insight_content,
	                        name: 'insight_content',
	                        apiKey: _constant.TINY_EDITOR,
	                        init: {
	                          height: 300,
	                          theme: "silver",
	                          plugins: ["advlist autolink lists link anchor paste image"],
	                          file_picker_types: "file image media",
	                          toolbar: 'undo redo | formatselect | image| bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | help',
	                          //images_upload_handler: uploadImageCallBackServer
	                          images_upload_handler: function () {
	                            var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee(blobInfo, success, failure) {
	                              var imageFile, _ref5, data;
	
	                              return _regenerator2.default.wrap(function _callee$(_context) {
	                                while (1) {
	                                  switch (_context.prev = _context.next) {
	                                    case 0:
	                                      imageFile = new FormData();
	                                      //imageFile.append("files[]", blobInfo.blob());
	
	                                      imageFile.append('image', blobInfo.blob());
	                                      _context.prev = 2;
	                                      _context.next = 5;
	                                      return _axios2.default.post(_constant.REACT_APP_API_PATH + "az/uploadeditorimage", imageFile);
	
	                                    case 5:
	                                      _ref5 = _context.sent;
	                                      data = _ref5.data;
	
	                                      success(data.data.link);
	                                      _context.next = 14;
	                                      break;
	
	                                    case 10:
	                                      _context.prev = 10;
	                                      _context.t0 = _context['catch'](2);
	
	                                      console.log(_context.t0);
	                                      return _context.abrupt('return');
	
	                                    case 14:
	                                    case 'end':
	                                      return _context.stop();
	                                  }
	                                }
	                              }, _callee, this, [[2, 10]]);
	                            }));
	
	                            function images_upload_handler(_x, _x2, _x3) {
	                              return _ref4.apply(this, arguments);
	                            }
	
	                            return images_upload_handler;
	                          }()
	                        }
	
	                      })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'form-group col-md-3' },
	                      _react2.default.createElement(
	                        'label',
	                        null,
	                        ' Location ',
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'astrick' },
	                          '*'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'form-group col-md-9' },
	                      _react2.default.createElement(
	                        'select',
	                        { className: 'form-control selectpicker', name: 'location', value: this.state.location,
	                          onChange: this.handleSelect, multiple: true, 'data-live-search': 'true',
	                          'data-actions-box': 'true' },
	                        this.state.locationList.map(function (item, i) {
	                          return _react2.default.createElement(
	                            'option',
	                            { value: item.id },
	                            item.location
	                          );
	                        })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row mb-4 text-right' },
	                    _react2.default.createElement(
	                      'button',
	                      { type: 'submit', id: 'btnSubmit',
	                        className: 'btn btn-primary btn-sm', onClick: this.handleSubmit, disabled: this.state.btnDisable, style: { display: "block", margin: "auto" } },
	                      'Submit'
	                    )
	                  ),
	                  this.state.status == 0 && login_id == 1 && _react2.default.createElement(
	                    'div',
	                    { className: 'row mb-4 text-right' },
	                    _react2.default.createElement(
	                      'button',
	                      { type: 'submit', id: 'btnSubmit', onClick: this.approveBlog,
	                        className: 'btn btn-primary btn-sm', style: { display: "block", margin: "auto" } },
	                      'Approve'
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(_reactNotifications.NotificationContainer, null)
	        )
	      );
	    }
	  }]);
	
	  return cmsAddEditInsight;
	}(_react.Component);
	
	/*
	function uploadImageCallBackServer(file) {
	  return new Promise(
	    (resolve, reject) => {
	      const reader = new window.FileReader();
	      const xhr = new XMLHttpRequest(); // eslint-disable-line no-undef
	      //xhr.open('POST', 'https://api.bewise.in/api/campaign/mail/uploadeditorimage');
	      xhr.open('POST', 'https://api.bewise.in/api/campaign/mail/uploadeditorimage');
	      xhr.setRequestHeader('x-auth-token', 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ2ZW5kZXIiOnsiaWQiOiI1ZWJkMTMyOTQwMjJhMjNlMmM1YzA4MzkifSwiaWF0IjoxNTkxMTgwOTA3LCJleHAiOjM2MDAwMDAwMDAxNTkxMTgwMDAwfQ.TKBUep0bss3gqQBK8CkbUuRlO3jRLHEvGTGgm90gLRE');
	      const data = new FormData(); // eslint-disable-line no-undef
	      data.append('image', file);
	      xhr.send(data);
	      xhr.addEventListener('load', () => {
	        const response = JSON.parse(xhr.responseText);
	        resolve(response);
	      });
	      xhr.addEventListener('error', () => {
	        const error = JSON.parse(xhr.responseText);
	        reject(error);
	      });
	    },
	  );
	}
	*/
	
	exports.default = cmsAddEditInsight;

/***/ },
/* 901 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _FetchCall2 = _interopRequireDefault(_FetchCall);
	
	var _reactAutosuggest = __webpack_require__(86);
	
	var _reactAutosuggest2 = _interopRequireDefault(_reactAutosuggest);
	
	var _draftJs = __webpack_require__(84);
	
	__webpack_require__(92);
	
	var _draftjsToHtml = __webpack_require__(106);
	
	var _draftjsToHtml2 = _interopRequireDefault(_draftjsToHtml);
	
	var _tinymceReact = __webpack_require__(69);
	
	var _constant = __webpack_require__(21);
	
	var _axios = __webpack_require__(184);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	__webpack_require__(18);
	
	var _reactNotifications = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import { Editor } from '@tinymce/tinymce-react';
	
	//import { Editor } from 'react-draft-wysiwyg';
	
	
	var cmsAddEditSpecialGuest = function (_Component) {
	  _inherits(cmsAddEditSpecialGuest, _Component);
	
	  function cmsAddEditSpecialGuest(props) {
	    _classCallCheck(this, cmsAddEditSpecialGuest);
	
	    var _this = _possibleConstructorReturn(this, (cmsAddEditSpecialGuest.__proto__ || Object.getPrototypeOf(cmsAddEditSpecialGuest)).call(this, props));
	
	    _this.handleChange = function (e) {
	      _this.setState(_defineProperty({}, e.target.name, e.target.value));
	    };
	
	    _this.handleCheck = function (e) {
	      _this.setState(function (prevState) {
	        return {
	          show_upload: !prevState.show_upload
	        };
	      });
	    };
	
	    _this.customChange = function (e, i) {
	      var social_links = _this.state.social_links;
	      if (social_links.length > 0 && social_links[i]) {
	        social_links[i].link = e.target.value;
	      }
	      _this.setState({ social_links: social_links });
	    };
	
	    _this.handleFile = function (e) {
	      var propName = e.target.name;
	      var files = e.target.files[0];
	      _this.setState(_defineProperty({}, propName, files));
	    };
	
	    _this.uploadImageCallBack = function (e) {
	      var propName = e.target.name;
	      var files = e.target.files;
	      _this.setState(_defineProperty({}, propName, files));
	    };
	
	    _this.handleFileMultiple = function (e) {
	      var propName = e.target.name;
	      var files = e.target.files;
	      if (files.length > 2) {
	        files = '';
	        var toastr = window.toastr.error; //warning
	        toastr('', 'Select Article 2 Images Only', {
	          positionClass: "toast-bottom-right",
	          containerId: "toast-bottom-right"
	        });
	      }
	      _this.setState(_defineProperty({}, propName, files));
	    };
	
	    _this.handleSelect = function (e) {
	      var propName = e.target.name;
	      var value = [].concat(_toConsumableArray(e.target.selectedOptions)).map(function (item) {
	        return item.value;
	      });
	      _this.setState(_defineProperty({}, propName, value));
	    };
	
	    _this.getGuestPageDetail = function () {
	      var ins = JSON.stringify({
	        id: _this.id
	      });
	      (0, _FetchCall.getPageDetail)(ins).then(function (res) {
	        if (res.status == 1) {
	          var data = res.detail;
	          _this.setState({
	            id: data.id,
	            page_title: data.title,
	            slug_term: data.slug_term,
	            social_links: data.social_links ? JSON.parse(data.social_links) : _this.state.social_links,
	            banner_image: data.banner_image ? res.base_url + data.banner_image : '',
	            gallery_image: data.gallery_image ? res.base_url + data.gallery_image : '',
	            status: data.status,
	            editorState: _draftJs.EditorState.createWithContent(_draftJs.ContentState.createFromBlockArray((0, _draftJs.convertFromHTML)(res.detail.detail_content)))
	
	          });
	
	          _this.setState({
	            consigne: _draftJs.EditorState.createWithContent(_draftJs.ContentState.createFromBlockArray((0, _draftJs.convertFromHTML)(res.detail.detail_content)))
	          });
	        } else {
	          _this.setState({
	            insightDetail: ''
	          });
	        }
	      });
	    };
	
	    _this.onChange = function (event, _ref) {
	      var newValue = _ref.newValue,
	          method = _ref.method;
	
	      _this.setState({
	        insight_author: newValue
	      });
	    };
	
	    _this.approvePage = function (e) {
	
	      var insert = JSON.stringify({
	        id: _this.state.id,
	        status: 1
	      });
	
	      (0, _FetchCall.approvePage)(insert).then(function (response) {
	        _this.setState({
	          btnDisable: false
	        });
	        if (response.status == 1) {
	
	          _reactNotifications.NotificationManager.success('The Page is approved successfully..redirecting to list');
	
	          window.location.href = '/cms/specialguests';
	          //alert("Insight is added");
	        }
	      });
	    };
	
	    _this.handleSubmit = function (e) {
	
	      var insert = {
	        id: _this.state.id,
	        page_title: _this.state.page_title,
	        description: _this.state.description,
	        slug_term: _this.state.slug_term,
	        social_links: JSON.stringify(_this.state.social_links),
	        banner_new: _this.state.banner_new,
	        gallery_new: _this.state.gallery_new
	      };
	      (0, _FetchCall.updatePage)(insert).then(function (response) {
	        _this.setState({
	          btnDisable: false
	        });
	        if (response.status == 1) {
	          if (_this.state.insight_id == '') _reactNotifications.NotificationManager.success('Page is added successfully..redirecting to list');else _reactNotifications.NotificationManager.success('Page is updated successfully..redirecting to list');
	
	          window.location.href = '/cms/insights';
	          //alert("Insight is added");
	        } else {
	          //alert("Issue in adding insight");
	          _reactNotifications.NotificationManager.success('Page is added successfully..redirecting to list');
	        }
	      });
	    };
	
	    _this.onChangeEditor = function (editorState) {
	      //const contentState = editorState.getCurrentContent();
	      //console.log("plain text", editorState.getCurrentContent().getPlainText());
	
	      var contentState = (0, _draftjsToHtml2.default)((0, _draftJs.convertToRaw)(editorState.getCurrentContent()));
	
	      console.log("html", contentState);
	      //const raw = convertToRaw(contentState);
	      _this.setState({
	        consigne: editorState,
	        insight_content: contentState
	      });
	    };
	
	    _this.state = {
	      logged: localStorage.getItem("authentication"),
	      auth_data: JSON.parse(localStorage.getItem("user_data")),
	      write_permission: true,
	      id: 0,
	      page_title: '',
	      insight_desc: '',
	      banner_image: '',
	      banner_new: '',
	      gallery_image: '',
	      article_images: '',
	      show_upload: false,
	      articleuploaded: false,
	      gallery_new: '',
	      insight_content: '',
	      insight_author: '',
	      about_author: '',
	      related_vertical: '',
	      social_links: [{ id: "fb", name: 'Facebook', link: "" }, { id: "li", name: 'LinkedIn', link: "" }, { id: "in", name: 'Instagram', link: "" }],
	      imageList: [],
	      suggestions: [],
	      location: [],
	      locationList: [],
	      categorylist: [],
	      btnDisable: false,
	      category: '',
	      featured: 0,
	      editorState: _draftJs.EditorState.createEmpty()
	    };
	    _this.getLocation();
	    _this.handleEditorChange = _this.handleEditorChange.bind(_this);
	    _this.approveBlog = _this.approveBlog.bind(_this);
	    _this.id = _this.props.match.params.id ? _this.props.match.params.id : '';
	    return _this;
	  }
	
	  _createClass(cmsAddEditSpecialGuest, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	
	      var THIS = this;
	
	      if (this.id != '') this.getGuestPageDetail(this.id);
	    }
	  }, {
	    key: 'handleEditorChange',
	    value: function handleEditorChange(value, editor) {
	      this.setState({
	        insight_content: value
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var insightDetail = this.state.insightDetail;
	      var _state = this.state,
	          categorylist = _state.categorylist,
	          suggestions = _state.suggestions;
	
	      var inputProps = {
	        value: this.state.insight_author,
	        onChange: this.onChange,
	        name: 'insight_author',
	        className: 'form-control'
	      };
	
	      var _state2 = this.state,
	          insight_content = _state2.insight_content,
	          editorState = _state2.editorState,
	          consigne = _state2.consigne;
	      var _state$auth_data = this.state.auth_data,
	          login_id = _state$auth_data.login_id,
	          role = _state$auth_data.role;
	
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'col-12 grid-margin' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card-body' },
	                _react2.default.createElement(
	                  'h4',
	                  { 'class': 'card-title' },
	                  'Guest Special Page - Add/Edit'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'form-group col-md-3' },
	                      _react2.default.createElement(
	                        'label',
	                        null,
	                        ' Page Title ',
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'astrick' },
	                          '*'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'form-group col-md-9' },
	                      _react2.default.createElement('input', { name: 'page_title', className: 'form-control', type: 'text', value: this.state.page_title,
	                        onChange: this.handleChange })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'form-group col-md-3' },
	                      _react2.default.createElement(
	                        'label',
	                        null,
	                        ' Preferred URL (Never use special characaters as *,@,#,/,+,- and etc, except hyphen(-))'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'form-group col-md-9' },
	                      _react2.default.createElement('input', { name: 'slug_term', className: 'form-control', type: 'text', value: this.state.slug_term,
	                        onChange: this.handleChange })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'form-group col-md-3' },
	                      _react2.default.createElement(
	                        'label',
	                        null,
	                        ' About info / Description ',
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'astrick' },
	                          '*'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'form-group col-md-9' },
	                      _react2.default.createElement('textarea', { name: 'insight_desc', className: 'form-control', rows: 3, value: this.state.insight_desc,
	                        onChange: this.handleChange })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'form-group col-md-3' },
	                      _react2.default.createElement(
	                        'label',
	                        null,
	                        ' Banner Image ',
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'astrick' },
	                          '* (*.png, .jpp or Better use .webp format) '
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'form-group col-md-9' },
	                      _react2.default.createElement('input', {
	                        type: 'file',
	                        name: 'page_banner',
	                        onChange: this.handleFile,
	                        className: 'form-control mar-btm',
	                        accept: 'image/x-png,image/gif,image/jpeg'
	                      })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row', style: { marginBottom: '30px' } },
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'form-group col-md-3' },
	                      _react2.default.createElement(
	                        'label',
	                        null,
	                        ' Content ',
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'astrick' },
	                          '*'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'form-group col-md-9' },
	                      _react2.default.createElement(_tinymceReact.Editor, {
	                        onEditorChange: this.handleEditorChange,
	                        toolbar: {
	                          inline: { inDropdown: true },
	                          list: { inDropdown: true },
	                          textAlign: { inDropdown: true },
	                          link: { inDropdown: true },
	                          history: { inDropdown: true },
	                          image: { uploadCallback: this.uploadImageCallBack, alt: { present: true, mandatory: true } }
	                        },
	                        value: this.state.insight_content,
	                        name: 'insight_content',
	                        apiKey: _constant.TINY_EDITOR,
	                        init: {
	                          height: 300,
	                          theme: "silver",
	                          plugins: ["advlist autolink lists link anchor paste image"],
	                          file_picker_types: "file image media",
	                          toolbar: 'undo redo | formatselect | image| bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | help',
	                          //images_upload_handler: uploadImageCallBackServer
	                          images_upload_handler: function () {
	                            var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(blobInfo, success, failure) {
	                              var imageFile, _ref3, data;
	
	                              return _regenerator2.default.wrap(function _callee$(_context) {
	                                while (1) {
	                                  switch (_context.prev = _context.next) {
	                                    case 0:
	                                      imageFile = new FormData();
	                                      //imageFile.append("files[]", blobInfo.blob());
	
	                                      imageFile.append('image', blobInfo.blob());
	                                      _context.prev = 2;
	                                      _context.next = 5;
	                                      return _axios2.default.post("https://api.bewise.in/api/campaign/mail/uploadeditorimage", imageFile);
	
	                                    case 5:
	                                      _ref3 = _context.sent;
	                                      data = _ref3.data;
	
	                                      success(data.data.link);
	                                      _context.next = 14;
	                                      break;
	
	                                    case 10:
	                                      _context.prev = 10;
	                                      _context.t0 = _context['catch'](2);
	
	                                      console.log(_context.t0);
	                                      return _context.abrupt('return');
	
	                                    case 14:
	                                    case 'end':
	                                      return _context.stop();
	                                  }
	                                }
	                              }, _callee, this, [[2, 10]]);
	                            }));
	
	                            function images_upload_handler(_x, _x2, _x3) {
	                              return _ref2.apply(this, arguments);
	                            }
	
	                            return images_upload_handler;
	                          }()
	                        }
	
	                      })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row mb-4 text-right' },
	                    _react2.default.createElement(
	                      'button',
	                      { type: 'submit', id: 'btnSubmit',
	                        className: 'btn btn-primary btn-sm', onClick: this.handleSubmit, disabled: this.state.btnDisable, style: { display: "block", margin: "auto" } },
	                      'Submit'
	                    )
	                  ),
	                  this.state.status == 0 && login_id == 1 && _react2.default.createElement(
	                    'div',
	                    { className: 'row mb-4 text-right' },
	                    _react2.default.createElement(
	                      'button',
	                      { type: 'submit', id: 'btnSubmit', onClick: this.approveBlog,
	                        className: 'btn btn-primary btn-sm', style: { display: "block", margin: "auto" } },
	                      'Approve'
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(_reactNotifications.NotificationContainer, null)
	        )
	      );
	    }
	  }]);
	
	  return cmsAddEditSpecialGuest;
	}(_react.Component);
	
	function uploadImageCallBackServer(file) {
	  return new Promise(function (resolve, reject) {
	    var reader = new window.FileReader();
	    var xhr = new XMLHttpRequest(); // eslint-disable-line no-undef
	    //xhr.open('POST', 'https://api.bewise.in/api/campaign/mail/uploadeditorimage');
	    xhr.open('POST', 'https://api.bewise.in/api/campaign/mail/uploadeditorimage');
	    xhr.setRequestHeader('x-auth-token', 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ2ZW5kZXIiOnsiaWQiOiI1ZWJkMTMyOTQwMjJhMjNlMmM1YzA4MzkifSwiaWF0IjoxNTkxMTgwOTA3LCJleHAiOjM2MDAwMDAwMDAxNTkxMTgwMDAwfQ.TKBUep0bss3gqQBK8CkbUuRlO3jRLHEvGTGgm90gLRE');
	    var data = new FormData(); // eslint-disable-line no-undef
	    data.append('image', file);
	    xhr.send(data);
	    xhr.addEventListener('load', function () {
	      var response = JSON.parse(xhr.responseText);
	      resolve(response);
	    });
	    xhr.addEventListener('error', function () {
	      var error = JSON.parse(xhr.responseText);
	      reject(error);
	    });
	  });
	}
	
	exports.default = cmsAddEditSpecialGuest;

/***/ },
/* 902 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _FetchCall2 = _interopRequireDefault(_FetchCall);
	
	var _draftJs = __webpack_require__(84);
	
	var _reactDraftWysiwyg = __webpack_require__(127);
	
	__webpack_require__(92);
	
	var _draftjsToHtml = __webpack_require__(106);
	
	var _draftjsToHtml2 = _interopRequireDefault(_draftjsToHtml);
	
	var _htmlToDraftjs = __webpack_require__(158);
	
	var _htmlToDraftjs2 = _interopRequireDefault(_htmlToDraftjs);
	
	var _upload = __webpack_require__(369);
	
	var _upload2 = _interopRequireDefault(_upload);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import { Editor } from '@tinymce/tinymce-react';
	
	var cmsAddNews = function (_Component) {
	  _inherits(cmsAddNews, _Component);
	
	  function cmsAddNews(props) {
	    var _this$state;
	
	    _classCallCheck(this, cmsAddNews);
	
	    var _this = _possibleConstructorReturn(this, (cmsAddNews.__proto__ || Object.getPrototypeOf(cmsAddNews)).call(this, props));
	
	    _this.saveNews = function () {
	
	      // let contentState = this.state.editorState.getCurrentContent();
	      console.log("when saving..", _this.state.consigne);
	
	      var req = JSON.stringify({
	        news_title: _this.state.news_title,
	        news_content: _this.state.news_content,
	        status: _this.state.status,
	        id: _this.id
	      });
	
	      (0, _FetchCall.saveNews)(req).then(function (response) {
	
	        if (response.status == 1) {
	
	          alert(response.message);
	        } else {
	          alert(response.message);
	        }
	      });
	    };
	
	    _this.getNews = function () {
	      var ins = JSON.stringify({
	        id: _this.id
	      });
	
	      (0, _FetchCall.getNews)(ins).then(function (res) {
	        if (res.status == 1) {
	
	          var blocksFromHtml = (0, _htmlToDraftjs2.default)(res.detail.news_content);
	          var contentBlocks = blocksFromHtml.contentBlocks,
	              entityMap = blocksFromHtml.entityMap;
	
	          var contentState = _draftJs.ContentState.createFromBlockArray(contentBlocks, entityMap);
	          var editorState = _draftJs.EditorState.createWithContent(contentState);
	
	          _this.setState({
	            news_title: res.detail.news_title,
	            news_content: res.detail.news_content,
	            status: res.detail.status,
	            editorState: _draftJs.EditorState.createWithContent(_draftJs.ContentState.createFromBlockArray((0, _draftJs.convertFromHTML)(res.detail.news_content)))
	          });
	
	          _this.setState({
	            consigne: _draftJs.EditorState.createWithContent(_draftJs.ContentState.createFromBlockArray((0, _draftJs.convertFromHTML)(res.detail.news_content)))
	          });
	        }
	      });
	    };
	
	    _this.handleChange = function (e) {
	      _this.setState(_defineProperty({}, e.target.name, e.target.value));
	    };
	
	    _this.onChange = function (editorState) {
	      //const contentState = editorState.getCurrentContent();
	      //console.log("plain text", editorState.getCurrentContent().getPlainText());
	
	      var contentState = (0, _draftjsToHtml2.default)((0, _draftJs.convertToRaw)(editorState.getCurrentContent()));
	
	      console.log("html", contentState);
	      //const raw = convertToRaw(contentState);
	      _this.setState({
	        consigne: editorState,
	        news_content: contentState
	      });
	    };
	
	    _this.state = (_this$state = {
	      errors: [],
	      mailDetail: '',
	      mail_template: '',
	      mail_content: ''
	    }, _defineProperty(_this$state, 'mail_content', ''), _defineProperty(_this$state, 'mail_subject', ''), _defineProperty(_this$state, 'module', ''), _defineProperty(_this$state, 'editorState', _draftJs.EditorState.createEmpty()), _this$state);
	
	    _this.id = _this.props.match.params.id ? _this.props.match.params.id : '';
	    //this.getMail = this.getMail.bind(this);
	    return _this;
	  }
	
	  _createClass(cmsAddNews, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	
	      var THIS = this;
	
	      if (this.id != '') this.getNews(this.id);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          mail_content = _state.mail_content,
	          editorState = _state.editorState,
	          consigne = _state.consigne;
	
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'col-12 grid-margin' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card-body' },
	                _react2.default.createElement(
	                  'h4',
	                  { 'class': 'card-title' },
	                  'News - Add New'
	                ),
	                _react2.default.createElement(
	                  'form',
	                  { 'class': 'form-sample' },
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'col-md-6' },
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'form-group row' },
	                        _react2.default.createElement(
	                          'label',
	                          { 'class': 'col-sm-3 col-form-label' },
	                          'News Title'
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'col-sm-9' },
	                          _react2.default.createElement('input', { type: 'text', 'class': 'form-control', name: 'news_title', value: this.state.news_title, onChange: this.handleChange })
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'col-md-12' },
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'form-group row' },
	                        _react2.default.createElement(
	                          'label',
	                          { 'class': 'col-sm-3 col-form-label' },
	                          'News Content'
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'col-sm-12' },
	                          _react2.default.createElement(_reactDraftWysiwyg.Editor
	                          //defaultEditorState={editorState}
	                          , { value: (0, _draftjsToHtml2.default)((0, _draftJs.convertToRaw)(editorState.getCurrentContent())),
	                            editorState: consigne,
	                            toolbarClassName: 'toolbarClassName',
	                            wrapperClassName: 'wrapperClassName',
	                            editorClassName: 'editorClassName',
	                            onEditorStateChange: this.onChange.bind(this)
	                            //onEditorStateChange={(consigne) => {this.setState({consigne})}}
	                          })
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'col-md-6' },
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'form-group row' },
	                        _react2.default.createElement(
	                          'label',
	                          { 'class': 'col-sm-3 col-form-label' },
	                          'Status'
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'col-sm-9' },
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'form-group row' },
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'form-check form-check-inline' },
	                              _react2.default.createElement('input', { 'class': 'form-check-input', type: 'radio', name: 'status', id: 'inlineRadio1', value: '1', checked: this.state.status === "1", onChange: this.handleChange }),
	                              _react2.default.createElement(
	                                'label',
	                                { 'class': 'form-check-label', 'for': 'inlineRadio1' },
	                                'Publish'
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'form-check form-check-inline' },
	                              _react2.default.createElement('input', { 'class': 'form-check-input', type: 'radio', name: 'status', id: 'inlineRadio2', value: '0', checked: this.state.status === "0", onChange: this.handleChange }),
	                              _react2.default.createElement(
	                                'label',
	                                { 'class': 'form-check-label', 'for': 'inlineRadio2' },
	                                'UnPublish'
	                              )
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'col-md-12' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row mb-4 text-right' },
	                        _react2.default.createElement(
	                          'button',
	                          { type: 'button', id: 'btnSubmit',
	                            className: 'btn btn-primary btn-sm', onClick: this.saveNews, style: { display: "block", margin: "auto" } },
	                          'Submit'
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return cmsAddNews;
	}(_react.Component);
	
	exports.default = cmsAddNews;

/***/ },
/* 903 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _FetchCall2 = _interopRequireDefault(_FetchCall);
	
	var _draftJs = __webpack_require__(84);
	
	var _reactDraftWysiwyg = __webpack_require__(127);
	
	__webpack_require__(92);
	
	var _draftjsToHtml = __webpack_require__(106);
	
	var _draftjsToHtml2 = _interopRequireDefault(_draftjsToHtml);
	
	var _htmlToDraftjs = __webpack_require__(158);
	
	var _htmlToDraftjs2 = _interopRequireDefault(_htmlToDraftjs);
	
	var _upload = __webpack_require__(369);
	
	var _upload2 = _interopRequireDefault(_upload);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import { Editor } from '@tinymce/tinymce-react';
	
	var cmsEditMail = function (_Component) {
	  _inherits(cmsEditMail, _Component);
	
	  function cmsEditMail(props) {
	    var _this$state;
	
	    _classCallCheck(this, cmsEditMail);
	
	    var _this = _possibleConstructorReturn(this, (cmsEditMail.__proto__ || Object.getPrototypeOf(cmsEditMail)).call(this, props));
	
	    _this.saveMail = function () {
	
	      // let contentState = this.state.editorState.getCurrentContent();
	      console.log("when saving..", _this.state.consigne);
	
	      var req = JSON.stringify({
	        mail_template: _this.state.mail_template,
	        mail_subject: _this.state.mail_subject,
	        mail_content: _this.state.mail_content,
	        module: _this.state.module,
	        id: _this.id
	      });
	
	      (0, _FetchCall.saveMail)(req).then(function (response) {
	
	        if (response.status == 1) {
	
	          alert(response.message);
	        } else {
	          alert(response.message);
	        }
	      });
	    };
	
	    _this.getMail = function () {
	      var ins = JSON.stringify({
	        id: _this.id
	      });
	
	      (0, _FetchCall.getMail)(ins).then(function (res) {
	        if (res.status == 1) {
	
	          var blocksFromHtml = (0, _htmlToDraftjs2.default)(res.detail.mail_content);
	          var contentBlocks = blocksFromHtml.contentBlocks,
	              entityMap = blocksFromHtml.entityMap;
	
	          var contentState = _draftJs.ContentState.createFromBlockArray(contentBlocks, entityMap);
	          var editorState = _draftJs.EditorState.createWithContent(contentState);
	
	          _this.setState({
	            mail_template: res.detail.mail_template,
	            mail_subject: res.detail.mail_subject,
	            module: res.detail.module,
	            mail_content: res.detail.mail_content,
	            editorState: _draftJs.EditorState.createWithContent(_draftJs.ContentState.createFromBlockArray((0, _draftJs.convertFromHTML)(res.detail.mail_content)))
	          });
	
	          _this.setState({
	            consigne: _draftJs.EditorState.createWithContent(_draftJs.ContentState.createFromBlockArray((0, _draftJs.convertFromHTML)(res.detail.mail_content)))
	          });
	        }
	      });
	    };
	
	    _this.handleChange = function (e) {
	      _this.setState(_defineProperty({}, e.target.name, e.target.value));
	    };
	
	    _this.onChange = function (editorState) {
	      //const contentState = editorState.getCurrentContent();
	      //console.log("plain text", editorState.getCurrentContent().getPlainText());
	
	      var contentState = (0, _draftjsToHtml2.default)((0, _draftJs.convertToRaw)(editorState.getCurrentContent()));
	
	      console.log("html", contentState);
	      //const raw = convertToRaw(contentState);
	      _this.setState({
	        consigne: editorState,
	        mail_content: contentState
	      });
	    };
	
	    _this.state = (_this$state = {
	      errors: [],
	      mailDetail: '',
	      mail_template: '',
	      mail_content: ''
	    }, _defineProperty(_this$state, 'mail_content', ''), _defineProperty(_this$state, 'mail_subject', ''), _defineProperty(_this$state, 'module', ''), _defineProperty(_this$state, 'editorState', _draftJs.EditorState.createEmpty()), _this$state);
	
	    _this.id = _this.props.match.params.id ? _this.props.match.params.id : '';
	    //this.getMail = this.getMail.bind(this);
	    return _this;
	  }
	
	  _createClass(cmsEditMail, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	
	      var THIS = this;
	
	      this.getMail(this.id);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          mail_content = _state.mail_content,
	          editorState = _state.editorState,
	          consigne = _state.consigne;
	
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'col-12 grid-margin' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card-body' },
	                _react2.default.createElement(
	                  'h4',
	                  { 'class': 'card-title' },
	                  'Mail - Edit'
	                ),
	                _react2.default.createElement(
	                  'form',
	                  { 'class': 'form-sample' },
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'col-md-6' },
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'form-group row' },
	                        _react2.default.createElement(
	                          'label',
	                          { 'class': 'col-sm-3 col-form-label' },
	                          'Template Name'
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'col-sm-9' },
	                          _react2.default.createElement('input', { type: 'text', 'class': 'form-control', name: 'mail_template', value: this.state.mail_template, onChange: this.handleChange })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'col-md-6' },
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'form-group row' },
	                        _react2.default.createElement(
	                          'label',
	                          { 'class': 'col-sm-3 col-form-label' },
	                          'Mail Subject'
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'col-sm-9' },
	                          _react2.default.createElement('input', { type: 'text', 'class': 'form-control', name: 'mail_subject', value: this.state.mail_subject, onChange: this.handleChange })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'col-md-6' },
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'form-group row' },
	                        _react2.default.createElement(
	                          'label',
	                          { 'class': 'col-sm-3 col-form-label' },
	                          'Module'
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'col-sm-9' },
	                          _react2.default.createElement(
	                            'select',
	                            { 'class': 'form-control', name: 'module', value: this.state.module, onChange: this.handleChange },
	                            _react2.default.createElement(
	                              'option',
	                              { value: 'parents' },
	                              'Parent'
	                            ),
	                            _react2.default.createElement(
	                              'option',
	                              { value: 'partners' },
	                              'Partner'
	                            ),
	                            _react2.default.createElement(
	                              'option',
	                              { value: 'otpmessage' },
	                              'OTP Message'
	                            ),
	                            _react2.default.createElement(
	                              'option',
	                              { value: 'partnersubscription' },
	                              'Partner Subscription'
	                            ),
	                            _react2.default.createElement(
	                              'option',
	                              { value: 'payments' },
	                              'Payments'
	                            ),
	                            _react2.default.createElement(
	                              'option',
	                              { value: 'followups' },
	                              'FollowUps'
	                            ),
	                            _react2.default.createElement(
	                              'option',
	                              { value: 'general' },
	                              'General'
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'col-md-12' },
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'form-group row' },
	                        _react2.default.createElement(
	                          'label',
	                          { 'class': 'col-sm-3 col-form-label' },
	                          'Mail Content'
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'col-sm-12' },
	                          _react2.default.createElement(_reactDraftWysiwyg.Editor
	                          //defaultEditorState={editorState}
	                          , { value: (0, _draftjsToHtml2.default)((0, _draftJs.convertToRaw)(editorState.getCurrentContent())),
	                            editorState: consigne,
	                            toolbarClassName: 'toolbarClassName',
	                            wrapperClassName: 'wrapperClassName',
	                            editorClassName: 'editorClassName',
	                            onEditorStateChange: this.onChange.bind(this)
	                            //onEditorStateChange={(consigne) => {this.setState({consigne})}}
	                          })
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'col-md-12' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row mb-4 text-right' },
	                        _react2.default.createElement(
	                          'button',
	                          { type: 'button', id: 'btnSubmit',
	                            className: 'btn btn-primary btn-sm', onClick: this.saveMail, style: { display: "block", margin: "auto" } },
	                          'Submit'
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return cmsEditMail;
	}(_react.Component);
	
	exports.default = cmsEditMail;

/***/ },
/* 904 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _simpleReactValidator = __webpack_require__(28);
	
	var _simpleReactValidator2 = _interopRequireDefault(_simpleReactValidator);
	
	var _FetchCall = __webpack_require__(4);
	
	var _FetchCall2 = _interopRequireDefault(_FetchCall);
	
	var _reactDatepicker = __webpack_require__(279);
	
	var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
	
	__webpack_require__(267);
	
	var _sweetalert = __webpack_require__(174);
	
	var _sweetalert2 = _interopRequireDefault(_sweetalert);
	
	var _tinymceReact = __webpack_require__(69);
	
	var _reactstrap = __webpack_require__(17);
	
	var _constant = __webpack_require__(21);
	
	var _reactTooltip = __webpack_require__(133);
	
	var _reactTooltip2 = _interopRequireDefault(_reactTooltip);
	
	var _event_preview = __webpack_require__(930);
	
	var _event_preview2 = _interopRequireDefault(_event_preview);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import { Editor } from '@tinymce/tinymce-react';
	
	
	//$.DataTable = require('datatables.net')
	
	var tabs = [{
	  name: 'Event Information'
	}, {
	  name: 'Speaker Information'
	}, {
	  name: 'Form Information'
	}, {
	  name: 'CSS Information'
	}, {
	  name: 'FAQ\'s'
	}, {
	  name: 'Email Invite Information'
	}];
	
	var cmsEvents = function (_Component) {
	  _inherits(cmsEvents, _Component);
	
	  function cmsEvents(props) {
	    var _this2 = this,
	        _form_css;
	
	    _classCallCheck(this, cmsEvents);
	
	    var _this = _possibleConstructorReturn(this, (cmsEvents.__proto__ || Object.getPrototypeOf(cmsEvents)).call(this, props));
	
	    _this.eventList = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var _this$state$auth_data, login_id, role, ins, res;
	
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _this$state$auth_data = _this.state.auth_data, login_id = _this$state$auth_data.login_id, role = _this$state$auth_data.role;
	              ins = JSON.stringify({
	                vendor_id: login_id,
	                role: role,
	                path: window.location.pathname,
	                url: 'get_event_list'
	              });
	              _context.next = 4;
	              return (0, _FetchCall.splEvent)(ins);
	
	            case 4:
	              res = _context.sent;
	
	              if (res.status == 1) {
	                _this.setState({
	                  write_permission: res.write_permission
	                });
	                _this.datatabledata(res.list);
	              }
	
	            case 6:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    }));
	
	    _this.editEvent = function (id) {
	      var _JSON$stringify;
	
	      var _this$state$auth_data2 = _this.state.auth_data,
	          login_id = _this$state$auth_data2.login_id,
	          role = _this$state$auth_data2.role;
	
	      var req = JSON.stringify((_JSON$stringify = {
	        event_id: id,
	        role: 1
	      }, _defineProperty(_JSON$stringify, 'role', role), _defineProperty(_JSON$stringify, 'path', '/event_update'), _defineProperty(_JSON$stringify, 'url', 'get_eventByid'), _JSON$stringify));
	      (0, _FetchCall.splEvent)(req).then(function (res) {
	        if (res.status === 1) {
	          var data = res.details;
	          console.log('data.start_date', new Date(data.start_date));
	          _this.setState({
	            event_id: data.id,
	            meta_title: data.meta_title,
	            meta_desc: data.meta_desc,
	            start_date: data.start_date == '0000-00-00 00:00' ? '' : new Date(data.start_date),
	            end_date: data.end_date == '0000-00-00 00:00' ? '' : new Date(data.end_date),
	            c_banner_image: res.img_url + data.banner_image,
	            img_url: res.img_url,
	            event_title: data.event_title,
	            event_content: data.event_content,
	            ticker: data.ticker,
	            email_details: data.email_details ? JSON.parse(data.email_details) : _this.state.email_details,
	            speaker_details: data.speaker_details ? JSON.parse(data.speaker_details) : [],
	            registration_details: data.registration_details ? JSON.parse(data.registration_details) : [],
	            faq_details: data.faq_details ? JSON.parse(data.faq_details) : [],
	            page_css: data.page_css ? JSON.parse(data.page_css) : []
	          });
	        } else {
	          setTimeout(function () {
	            window.location.href = '/event_update';
	          }, 1000);
	        }
	      });
	    };
	
	    _this.handleChange = function (e) {
	      var propName = e.target.name;
	      var propValue = e.target.value;
	      _this.setState(_defineProperty({}, propName, propValue));
	    };
	
	    _this.handleChangeSpeaker = function (e, i) {
	      var type = e.target.type;
	      var propName = e.target.name;
	      var propValue = void 0;
	      if (type == 'text' || type == 'textarea' || type == 'select-one') propValue = e.target.value;
	      if (type == 'file') {
	        propValue = e.target.files[0];
	        var THIS = _this;
	        var reader = new FileReader();
	        if (propValue) reader.readAsDataURL(propValue);
	        reader.addEventListener("load", function () {
	          // convert image file to base64 string
	          var speaker_details = THIS.state.speaker_details;
	          speaker_details[i]['temp_img'] = reader.result;
	          THIS.setState({
	            speaker_details: speaker_details
	          });
	        }, false);
	      }
	      var speaker_details = _this.state.speaker_details;
	      speaker_details[i][propName] = propValue;
	      _this.setState({
	        speaker_details: speaker_details
	      });
	    };
	
	    _this.handleChangeFaq = function (e, i) {
	      var propName = e.target.name;
	      var propValue = e.target.value;
	      var faq_details = _this.state.faq_details;
	      faq_details[i][propName] = propValue;
	      _this.setState({
	        faq_details: faq_details
	      });
	    };
	
	    _this.handleChangeEmail = function (e, i) {
	      var propName = e.target.name;
	      var propValue = e.target.value;
	      var email_details = _this.state.email_details;
	      email_details.data[propName] = propValue;
	      _this.setState({
	        email_details: email_details
	      });
	    };
	
	    _this.handleChangeEmailEditor = function (value, editor) {
	      var email_details = _this.state.email_details;
	      email_details.data[editor.targetElm.name] = value;
	      _this.setState({
	        email_details: email_details
	      });
	    };
	
	    _this.handleFileBanner = function (e) {
	      var propName = e.target.name;
	      var files = e.target.files[0];
	      _this.setState(_defineProperty({}, propName, files));
	      var THIS = _this;
	      var reader = new FileReader();
	      if (files) reader.readAsDataURL(files);
	      reader.addEventListener("load", function () {
	        // convert image file to base64 string
	        // img = reader.result;
	        THIS.setState({
	          tempBanner: reader.result
	        });
	      }, false);
	      // var img = new Image();
	      // img.src = window.URL.createObjectURL(files);
	      // img.onload = function () {
	      //   var width = img.naturalWidth,
	      //     height = img.naturalHeight;
	      //   if (width == 1350 && height == 468)
	      //     THIS.setState({
	      //       [propName]: files
	      //     });
	      //   else
	      //     THIS.setState({
	      //       [propName]: ''
	      //     });
	      //   window.URL.revokeObjectURL(img.src);
	      // };
	    };
	
	    _this.handleEditorChange = function (value, editor) {
	      _this.setState(_defineProperty({}, editor.targetElm.name, value));
	    };
	
	    _this.handleEditorChangeFaq = function (value, editor) {
	      var faq_details = _this.state.faq_details;
	      var id = parseInt(editor.id) - 1;
	      var name = editor.targetElm.name;
	      faq_details[id][name] = value;
	      _this.setState({
	        faq_details: faq_details
	      });
	    };
	
	    _this.handleChangeCss = function (e, type) {
	      var page_css = _this.state.page_css;
	      var propName = e.target.name;
	      var propValue = e.target.value;
	      if (type == 1) {
	        page_css.btn_css[propName] = propValue;
	      }
	      if (type == 2) {
	        page_css.form_css[propName] = propValue;
	      }
	      _this.setState({
	        page_css: page_css
	      });
	    };
	
	    _this.handleFormCheckBox = function () {
	      var registration_details = _this.state.registration_details;
	      registration_details.isForm = !registration_details.isForm;
	      _this.setState({
	        registration_details: registration_details
	      });
	    };
	
	    _this.handleFormChange = function (e, i) {
	      var propName = e.target.name;
	      var propValue = e.target.value;
	      var registration_details = _this.state.registration_details;
	      registration_details.form[i][propName] = propValue;
	      _this.setState({
	        registration_details: registration_details
	      });
	    };
	
	    _this.handleSubmit = function (e, type) {
	      e.preventDefault();
	      if (_this.validator.allValid()) {
	        var formData = new FormData();
	        formData.append('event_id', _this.state.event_id);
	        formData.append('status', type);
	        formData.append('meta_title', _this.state.meta_title);
	        formData.append('meta_desc', _this.state.meta_desc);
	        formData.append('start_date', _this.state.start_date);
	        formData.append('end_date', _this.state.end_date);
	        formData.append('new_banner_image', _this.state.new_banner_image);
	        formData.append('event_title', _this.state.event_title);
	        formData.append('event_content', _this.state.event_content);
	        formData.append('ticker', _this.state.ticker);
	        formData.append('speaker_details', JSON.stringify(_this.state.speaker_details));
	        var spkData = _this.state.speaker_details;
	        if (spkData.length > 0) {
	          for (var i = 0; i < spkData.length; i++) {
	            formData.append('spk_img', spkData[i].spk_img);
	          }
	        }
	        formData.append('registration_details', JSON.stringify(_this.state.registration_details));
	        formData.append('faq_details', JSON.stringify(_this.state.faq_details));
	        formData.append('page_css', JSON.stringify(_this.state.page_css));
	        formData.append('email_details', JSON.stringify(_this.state.email_details));
	        (0, _FetchCall.updateSplEvent)(formData).then(function (response) {
	          var toastr = '';
	          if (response.status === 1) {
	            toastr = window.toastr.success;
	            toastr('Success', response.message, {
	              positionClass: "toast-bottom-right",
	              containerId: "toast-bottom-right"
	            });
	            setTimeout(function () {
	              window.location.href = '/event_update';
	            }, 1000);
	          } else {
	            toastr = window.toastr.error; //warning
	            toastr('', response.message, {
	              positionClass: "toast-bottom-right",
	              containerId: "toast-bottom-right"
	            });
	          }
	        });
	      } else {
	        _this.validator.showMessages();
	        _this.forceUpdate();
	      }
	    };
	
	    _this.addSpeaker = function (e) {
	      e.preventDefault();
	      _this.setState({
	        speaker_details: [].concat(_toConsumableArray(_this.state.speaker_details), [{ spk_title: '', spk_name: "", spk_desc: "", spk_img: "" }])
	      });
	    };
	
	    _this.removeSpeaker = function (e, i) {
	      e.preventDefault();
	      var speaker_details = _this.state.speaker_details;
	      speaker_details.splice(i, 1);
	      _this.setState({ speaker_details: speaker_details });
	    };
	
	    _this.cancelFaq = function (e) {
	      e.preventDefault();
	      _this.setState({ temp_ans: '', temp_ques: '', temp_fid: '' });
	    };
	
	    _this.addFaq = function (e) {
	      e.preventDefault();
	      var _this$state = _this.state,
	          temp_ans = _this$state.temp_ans,
	          temp_fid = _this$state.temp_fid,
	          temp_ques = _this$state.temp_ques,
	          faq_details = _this$state.faq_details;
	
	      if (temp_ques && temp_ans) {
	        if (parseInt(temp_fid) >= 0) {
	          faq_details[temp_fid]['ques'] = temp_ques;
	          faq_details[temp_fid]['ans'] = temp_ans;
	        } else {
	          faq_details.push({
	            ques: temp_ques,
	            ans: temp_ans
	          });
	        }
	        console.log('faq_details', faq_details);
	        _this.setState({ faq_details: faq_details, temp_ans: '', temp_ques: '', temp_fid: '' });
	      } else {
	        var toastr = '';
	        toastr = window.toastr.error; //warning
	        toastr('', 'Question/ Answer Fields Required', {
	          positionClass: "toast-bottom-right",
	          containerId: "toast-bottom-right"
	        });
	      }
	    };
	
	    _this.editFaq = function (e, i) {
	      e.preventDefault();
	      var faq_details = _this.state.faq_details;
	
	      _this.setState({ temp_ans: faq_details[i]['ans'], temp_ques: faq_details[i]['ques'], temp_fid: i });
	    };
	
	    _this.removeFaq = function (e, i) {
	      e.preventDefault();
	      var faq_details = _this.state.faq_details;
	      faq_details.splice(i, 1);
	      _this.setState({ faq_details: faq_details });
	    };
	
	    _this.addFormField = function (e) {
	      e.preventDefault();
	      var registration_details = _this.state.registration_details;
	      registration_details.form.push({
	        lbl_name: '',
	        input_name: '',
	        input_type: '',
	        max_upload: '1'
	      });
	      _this.setState({
	        registration_details: registration_details
	      });
	    };
	
	    _this.removeFormField = function (e, i) {
	      e.preventDefault();
	      var registration_details = _this.state.registration_details;
	      registration_details.form.splice(i, 1);
	      _this.setState({ registration_details: registration_details });
	    };
	
	    var url = new URL(window.location.href);
	    var location = url.searchParams.get("location");
	    var auth_data = JSON.parse(localStorage.getItem("user_data"));
	    _this.state = {
	      logged: localStorage.getItem("authentication"),
	      auth_data: JSON.parse(localStorage.getItem("user_data")),
	      location: location ? location : auth_data.access_location ? auth_data.access_location : 'Bengaluru',
	      event_id: 0,
	      start_date: '',
	      end_date: '',
	      meta_title: '',
	      meta_desc: '',
	      new_banner_image: '',
	      tempBanner: '',
	      img_url: '',
	      event_title: '',
	      event_content: '',
	      ticker: '',
	      speaker_details: [],
	      registration_details: {
	        form: [{
	          lbl_name: 'Name',
	          input_name: 'name',
	          input_type: 'text',
	          max_upload: '1'
	        }, {
	          lbl_name: 'Email Address',
	          input_name: 'email_id',
	          input_type: 'email',
	          max_upload: '1'
	        }, {
	          lbl_name: 'Contact Number',
	          input_name: 'mobile_number',
	          input_type: 'number',
	          max_upload: '1'
	        }],
	        isForm: false
	      },
	      faq_details: [],
	      page_css: {
	        btn_css: {
	          btn_bg_clr: '',
	          btn_hvr_bg_clr: '',
	          btn_font_clr: '',
	          btn_hvr_font_clr: '',
	          btn_hvr_bdr_clr: ''
	        },
	        form_css: (_form_css = {
	          form_title: '',
	          form_title_clr: '',
	          form_bg_clr: ''
	        }, _defineProperty(_form_css, 'form_bg_clr', ''), _defineProperty(_form_css, 'sb_btn_bg_clr', ''), _defineProperty(_form_css, 'sb_btn_value', ''), _defineProperty(_form_css, 'sb_btn_font_clr', ''), _form_css)
	      },
	      email_details: { data: {} },
	      temp_ques: '',
	      temp_ans: '',
	      temp_fid: '',
	      disableBtn: false,
	      collapse: 'head-0'
	    };
	    _this.validator = new _simpleReactValidator2.default();
	    _this.eventList();
	
	    return _this;
	  }
	
	  _createClass(cmsEvents, [{
	    key: 'toggle',
	    value: function toggle(event) {
	      this.setState({
	        collapse: this.state.collapse === event ? -1 : event
	      });
	    }
	  }, {
	    key: 'datatabledata',
	    value: function datatabledata(data) {
	
	      console.log('data', data);
	      this.setState({
	        dataSet: data
	      });
	      this.el = (0, _jquery2.default)(this.el);
	      this.el.DataTable({
	        data: this.state.dataSet,
	        columns: [{ data: 'event_title' }, { data: 'status' }, { data: 'action' }]
	
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var role = this.state.auth_data.role;
	
	      if (role == 1) {
	        this.setState({
	          write_permission: true
	        });
	      }
	      var qrystr = window.location.search;
	      var urlParams = new URLSearchParams(qrystr);
	      var event_id = urlParams.get('id');
	      if (event_id) this.editEvent(event_id);
	      var THIS = this;
	      (0, _jquery2.default)(document).on('click', '.delete_event', function () {
	        var delete_id = (0, _jquery2.default)(this).data("id");
	        THIS.setState({
	          delete_id: delete_id
	        });
	        THIS.deleteEvent(delete_id);
	      });
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {}
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          collapse = _state.collapse,
	          speaker_details = _state.speaker_details,
	          page_css = _state.page_css,
	          registration_details = _state.registration_details,
	          faq_details = _state.faq_details,
	          write_permission = _state.write_permission;
	      var _state$auth_data = this.state.auth_data,
	          login_id = _state$auth_data.login_id,
	          role = _state$auth_data.role;
	      var btn_css = page_css.btn_css,
	          form_css = page_css.form_css;
	
	      var email_details = this.state.email_details.data;
	      this.validator.purgeFields();
	      console.log('email_details', JSON.stringify(this.state.email_details));
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'col-lg-12 grid-margin stretch-card' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card-body' },
	                _react2.default.createElement(
	                  'h4',
	                  { 'class': 'card-title' },
	                  'Events'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'row' },
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'col-lg-12' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'main-content col-md-12 col-xs-12' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'box-shadow-custom spl-event-box' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'row' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-12' },
	                            _react2.default.createElement(
	                              _reactstrap.Card,
	                              { className: 'panel-group custom-card', style: { marginBottom: '1rem' }, key: 'head-0' },
	                              _react2.default.createElement(
	                                _reactstrap.CardHeader,
	                                { onClick: function onClick() {
	                                    return _this3.toggle('head-0');
	                                  }, 'data-event': 'head-0', className: 'custom-card-heading' },
	                                _react2.default.createElement(
	                                  'b',
	                                  null,
	                                  'Event List'
	                                ),
	                                collapse != 'head-0' ? _react2.default.createElement(
	                                  'span',
	                                  { className: 'pull-right' },
	                                  _react2.default.createElement('i', { 'class': 'fa fa-plus', 'aria-hidden': 'true' })
	                                ) : _react2.default.createElement(
	                                  'span',
	                                  { className: 'pull-right' },
	                                  _react2.default.createElement('i', { 'class': 'fa fa-minus', 'aria-hidden': 'true' })
	                                )
	                              ),
	                              _react2.default.createElement(
	                                _reactstrap.Collapse,
	                                { isOpen: collapse == 'head-0' },
	                                _react2.default.createElement(
	                                  _reactstrap.CardBody,
	                                  { className: 'panel-body' },
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'table-responsive content-sec col-md-12 col-xs-12 pad-no mar-t-no' },
	                                    _react2.default.createElement(
	                                      'table',
	                                      { className: 'table table-custom-design table-striped dataTable event-table', ref: function ref(el) {
	                                          return _this3.el = el;
	                                        } },
	                                      _react2.default.createElement(
	                                        'thead',
	                                        { className: '' },
	                                        _react2.default.createElement(
	                                          'tr',
	                                          { role: 'row' },
	                                          _react2.default.createElement(
	                                            'th',
	                                            { className: 'tabledata' },
	                                            'Event Title'
	                                          ),
	                                          _react2.default.createElement(
	                                            'th',
	                                            { className: 'tabledata' },
	                                            'Status'
	                                          ),
	                                          _react2.default.createElement(
	                                            'th',
	                                            { className: 'tabledata' },
	                                            'Action'
	                                          )
	                                        )
	                                      )
	                                    )
	                                  )
	                                )
	                              )
	                            )
	                          )
	                        )
	                      ),
	                      write_permission && _react2.default.createElement(
	                        _react2.default.Fragment,
	                        null,
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'hdr-row' },
	                          _react2.default.createElement(
	                            'h4',
	                            { className: 'fw-sbold mar-t-no' },
	                            'Special Events'
	                          ),
	                          write_permission && this.state.event_id > 0 && _react2.default.createElement(
	                            'div',
	                            { className: 'pull-right' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'dropdown menu-item' },
	                              _react2.default.createElement(
	                                'a',
	                                { href: '/event_update', className: 'btn btn-green dropdown-toggle btn-arrow btn-circle' },
	                                _react2.default.createElement('i', { className: 'fa fa-plus-circle', 'aria-hidden': 'true' }),
	                                ' Add New Event'
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'box-shadow-custom spl-event-box' },
	                          _react2.default.createElement(
	                            'form',
	                            { autoComplete: 'off', id: 'package_form' },
	                            tabs.map(function (item, index) {
	                              console.log('index', index, btn_css);
	                              return _react2.default.createElement(
	                                _reactstrap.Card,
	                                { className: 'panel-group custom-card', style: { marginBottom: '1rem' }, key: index },
	                                _react2.default.createElement(
	                                  _reactstrap.CardHeader,
	                                  { onClick: function onClick() {
	                                      return _this3.toggle(index);
	                                    }, 'data-event': index, className: 'custom-card-heading' },
	                                  _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    item.name
	                                  ),
	                                  collapse !== index ? _react2.default.createElement(
	                                    'span',
	                                    { className: 'pull-right' },
	                                    _react2.default.createElement('i', { 'class': 'fa fa-plus', 'aria-hidden': 'true' })
	                                  ) : _react2.default.createElement(
	                                    'span',
	                                    { className: 'pull-right' },
	                                    _react2.default.createElement('i', { 'class': 'fa fa-minus', 'aria-hidden': 'true' })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  _reactstrap.Collapse,
	                                  { isOpen: collapse === index },
	                                  _react2.default.createElement(
	                                    _reactstrap.CardBody,
	                                    { className: 'panel-body' },
	                                    index === 0 && _react2.default.createElement(
	                                      _react2.default.Fragment,
	                                      null,
	                                      _react2.default.createElement(
	                                        'div',
	                                        { className: 'row' },
	                                        _react2.default.createElement(
	                                          'div',
	                                          { 'class': 'form-group custom-form-group col-md-6' },
	                                          _react2.default.createElement(
	                                            'label',
	                                            null,
	                                            ' Title ',
	                                            _react2.default.createElement(
	                                              'span',
	                                              { className: 'astrick' },
	                                              '*'
	                                            )
	                                          ),
	                                          _react2.default.createElement('input', { type: 'text', className: 'form-control', name: 'event_title',
	                                            value: _this3.state.event_title, onChange: _this3.handleChange }),
	                                          _this3.validator.message('Title', _this3.state.event_title, 'required', { className: 'text-danger' })
	                                        ),
	                                        _react2.default.createElement(
	                                          'div',
	                                          { 'class': 'form-group custom-form-group col-md-6' },
	                                          _react2.default.createElement(
	                                            'label',
	                                            null,
	                                            ' Banner\xA0',
	                                            _react2.default.createElement('i', { 'class': 'fa fa-info-circle info-tool', 'data-tip': true, 'data-for': 'info', 'aria-hidden': 'true' }),
	                                            ' ',
	                                            _react2.default.createElement(
	                                              'span',
	                                              { className: 'astrick' },
	                                              '*'
	                                            ),
	                                            _react2.default.createElement(
	                                              _reactTooltip2.default,
	                                              { id: 'info', place: 'bottom', effect: 'solid', className: 'react_tooltip_backgrnd' },
	                                              _react2.default.createElement(
	                                                'p',
	                                                null,
	                                                'Banner size should be 1350*468'
	                                              )
	                                            )
	                                          ),
	                                          _react2.default.createElement('input', { type: 'file', accept: 'images/*', className: 'form-control', name: 'new_banner_image',
	                                            onChange: _this3.handleFileBanner }),
	                                          _this3.state.event_id == 0 && _this3.validator.message('Banner', _this3.state.new_banner_image, 'required', { className: 'text-danger' })
	                                        ),
	                                        _react2.default.createElement(
	                                          'div',
	                                          { 'class': 'form-group custom-form-group col-md-6 cus-date-sec' },
	                                          _react2.default.createElement(
	                                            'label',
	                                            null,
	                                            ' Start Date ',
	                                            _react2.default.createElement(
	                                              'span',
	                                              { className: 'astrick' },
	                                              '*'
	                                            )
	                                          ),
	                                          _react2.default.createElement(_reactDatepicker2.default, {
	                                            autocomplete: 'off',
	                                            className: 'form-control input-group-date',
	                                            selected: _this3.state.start_date,
	                                            showTimeSelect: true,
	                                            name: 'start_date',
	                                            id: 'start_date',
	                                            timeIntervals: 5,
	                                            dateFormat: 'MMMM d, yyyy HH:mm',
	                                            onChange: function onChange(date) {
	                                              _this3.setState({
	                                                start_date: date
	                                              });
	                                            }
	                                          }),
	                                          _this3.validator.message('Start Date', _this3.state.start_date, 'required', { className: 'text-danger' })
	                                        ),
	                                        _react2.default.createElement(
	                                          'div',
	                                          { 'class': 'form-group custom-form-group col-md-6 cus-date-sec' },
	                                          _react2.default.createElement(
	                                            'label',
	                                            null,
	                                            ' End Date ',
	                                            _react2.default.createElement(
	                                              'span',
	                                              { className: 'astrick' },
	                                              '*'
	                                            )
	                                          ),
	                                          _react2.default.createElement(_reactDatepicker2.default, {
	                                            autocomplete: 'off',
	                                            timeIntervals: 5,
	                                            className: 'form-control input-group-date',
	                                            selected: _this3.state.end_date,
	                                            name: 'end_date',
	                                            id: 'end_date',
	                                            showTimeSelect: true,
	                                            dateFormat: 'MMMM d, yyyy HH:mm',
	                                            onChange: function onChange(date) {
	                                              _this3.setState({
	                                                end_date: date
	                                              });
	                                            }
	                                          }),
	                                          _this3.validator.message('End Date', _this3.state.end_date, 'required', { className: 'text-danger' })
	                                        ),
	                                        _react2.default.createElement(
	                                          'div',
	                                          { 'class': 'form-group custom-form-group col-md-6' },
	                                          _react2.default.createElement(
	                                            'label',
	                                            null,
	                                            ' Meta Title ',
	                                            _react2.default.createElement(
	                                              'span',
	                                              { className: 'astrick' },
	                                              '*'
	                                            )
	                                          ),
	                                          _react2.default.createElement('input', { type: 'text', className: 'form-control', name: 'meta_title',
	                                            value: _this3.state.meta_title, onChange: _this3.handleChange }),
	                                          _this3.validator.message('Meta Title', _this3.state.meta_title, 'required', { className: 'text-danger' })
	                                        ),
	                                        _react2.default.createElement(
	                                          'div',
	                                          { 'class': 'form-group custom-form-group col-md-6' },
	                                          _react2.default.createElement(
	                                            'label',
	                                            null,
	                                            ' Meta Description ',
	                                            _react2.default.createElement(
	                                              'span',
	                                              { className: 'astrick' },
	                                              '*'
	                                            )
	                                          ),
	                                          _react2.default.createElement('textarea', { type: 'text', rows: 2, className: 'form-control', name: 'meta_desc',
	                                            value: _this3.state.meta_desc, onChange: _this3.handleChange }),
	                                          _this3.validator.message('Meta Description', _this3.state.meta_desc, 'required', { className: 'text-danger' })
	                                        ),
	                                        _react2.default.createElement(
	                                          'div',
	                                          { 'class': 'form-group custom-form-group col-md-6' },
	                                          _react2.default.createElement(
	                                            'label',
	                                            null,
	                                            ' Ticker ',
	                                            _react2.default.createElement(
	                                              'span',
	                                              { className: 'astrick' },
	                                              '*'
	                                            )
	                                          ),
	                                          _react2.default.createElement('input', { type: 'text', rows: 2, className: 'form-control', name: 'ticker',
	                                            value: _this3.state.ticker, onChange: _this3.handleChange }),
	                                          _this3.validator.message('Ticker', _this3.state.ticker, 'required', { className: 'text-danger' })
	                                        )
	                                      ),
	                                      _react2.default.createElement(
	                                        'div',
	                                        { className: 'row' },
	                                        _react2.default.createElement(
	                                          'div',
	                                          { 'class': 'form-group custom-form-group col-md-12' },
	                                          _react2.default.createElement(
	                                            'label',
	                                            null,
	                                            ' Event Content ',
	                                            _react2.default.createElement(
	                                              'span',
	                                              { className: 'astrick' },
	                                              '*'
	                                            )
	                                          ),
	                                          _react2.default.createElement(_tinymceReact.Editor, {
	                                            textareaName: 'event_content',
	                                            onEditorChange: _this3.handleEditorChange,
	                                            value: _this3.state.event_content,
	                                            apiKey: _constant.TINY_EDITOR,
	                                            init: {
	                                              height: 500,
	                                              plugins: ['lists link image paste'],
	                                              menubar: 'edit | insert | format',
	                                              toolbar: 'undo redo | formatselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link'
	                                            }
	                                          }),
	                                          _this3.validator.message('Event Content', _this3.state.event_content, 'required', { className: 'text-danger' })
	                                        )
	                                      )
	                                    ),
	                                    index === 1 && _react2.default.createElement(
	                                      _react2.default.Fragment,
	                                      null,
	                                      _react2.default.createElement(
	                                        'div',
	                                        { className: 'row' },
	                                        _react2.default.createElement(
	                                          'div',
	                                          { className: 'col-md-12' },
	                                          _react2.default.createElement(
	                                            'button',
	                                            { className: 'btn btn-primary btn-sm pull-right',
	                                              onClick: _this3.addSpeaker },
	                                            'Add'
	                                          )
	                                        ),
	                                        speaker_details.map(function (item, i) {
	                                          var cnt = i + 1;
	                                          return _react2.default.createElement(
	                                            _react2.default.Fragment,
	                                            null,
	                                            _react2.default.createElement(
	                                              'div',
	                                              { className: 'row' },
	                                              _react2.default.createElement(
	                                                'div',
	                                                { className: 'form-group custom-form-group col-md-6' },
	                                                _react2.default.createElement(
	                                                  'h4',
	                                                  null,
	                                                  'Speaker ',
	                                                  cnt
	                                                )
	                                              ),
	                                              _react2.default.createElement(
	                                                'div',
	                                                { className: 'form-group custom-form-group col-md-6' },
	                                                _react2.default.createElement(
	                                                  'button',
	                                                  { className: 'btn btn-danger btn-sm pull-right',
	                                                    onClick: function onClick(e) {
	                                                      return _this3.removeSpeaker(e, i);
	                                                    } },
	                                                  'Remove'
	                                                )
	                                              )
	                                            ),
	                                            _react2.default.createElement(
	                                              'div',
	                                              { className: 'row' },
	                                              _react2.default.createElement(
	                                                'div',
	                                                { 'class': 'form-group custom-form-group col-md-6' },
	                                                _react2.default.createElement(
	                                                  'label',
	                                                  null,
	                                                  ' Name ',
	                                                  _react2.default.createElement(
	                                                    'span',
	                                                    { className: 'astrick' },
	                                                    '*'
	                                                  )
	                                                ),
	                                                _react2.default.createElement(
	                                                  'div',
	                                                  { className: 'row' },
	                                                  _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'col-md-3' },
	                                                    _react2.default.createElement(
	                                                      'select',
	                                                      { title: 'Select', onChange: function onChange(e) {
	                                                          return _this3.handleChangeSpeaker(e, i);
	                                                        },
	                                                        className: 'selectpicker form-control', name: 'spk_title',
	                                                        value: item.spk_title },
	                                                      _react2.default.createElement(
	                                                        'option',
	                                                        { value: 'Mr.' },
	                                                        'Mr.'
	                                                      ),
	                                                      _react2.default.createElement(
	                                                        'option',
	                                                        { value: 'Ms.' },
	                                                        'Ms.'
	                                                      ),
	                                                      _react2.default.createElement(
	                                                        'option',
	                                                        { value: 'Dr.' },
	                                                        'Dr.'
	                                                      ),
	                                                      _react2.default.createElement(
	                                                        'option',
	                                                        { value: 'Prof.' },
	                                                        'Prof.'
	                                                      )
	                                                    ),
	                                                    _this3.validator.message('', item.spk_title, 'required', { className: 'text-danger' })
	                                                  ),
	                                                  _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'col-md-9' },
	                                                    _react2.default.createElement('input', { type: 'text', className: 'form-control', name: 'spk_name',
	                                                      value: item.spk_name, onChange: function onChange(e) {
	                                                        return _this3.handleChangeSpeaker(e, i);
	                                                      } }),
	                                                    _this3.validator.message('Name', item.spk_name, 'required', { className: 'text-danger' })
	                                                  )
	                                                )
	                                              ),
	                                              _react2.default.createElement(
	                                                'div',
	                                                { 'class': 'form-group custom-form-group col-md-6' },
	                                                _react2.default.createElement(
	                                                  'label',
	                                                  null,
	                                                  ' Profile Image ',
	                                                  _react2.default.createElement(
	                                                    'span',
	                                                    { className: 'astrick' },
	                                                    '*'
	                                                  )
	                                                ),
	                                                _react2.default.createElement('input', { type: 'file', className: 'form-control', name: 'spk_img',
	                                                  onChange: function onChange(e) {
	                                                    return _this3.handleChangeSpeaker(e, i);
	                                                  } }),
	                                                _this3.state.event_id == 0 && _this3.validator.message('Profile Image', item.spk_img, 'required', { className: 'text-danger' })
	                                              ),
	                                              _react2.default.createElement(
	                                                'div',
	                                                { 'class': 'form-group custom-form-group col-md-6' },
	                                                _react2.default.createElement(
	                                                  'label',
	                                                  null,
	                                                  ' Short Description ',
	                                                  _react2.default.createElement(
	                                                    'span',
	                                                    { className: 'astrick' },
	                                                    '*'
	                                                  )
	                                                ),
	                                                _react2.default.createElement('textarea', { type: 'text', rows: 3, className: 'form-control', name: 'spk_desc',
	                                                  value: item.spk_desc, onChange: function onChange(e) {
	                                                    return _this3.handleChangeSpeaker(e, i);
	                                                  } }),
	                                                _this3.validator.message('Short Description', item.spk_desc, 'required', { className: 'text-danger' })
	                                              )
	                                            )
	                                          );
	                                        })
	                                      )
	                                    ),
	                                    index === 2 && _react2.default.createElement(
	                                      _react2.default.Fragment,
	                                      null,
	                                      _react2.default.createElement(
	                                        'div',
	                                        { className: 'row' },
	                                        _react2.default.createElement(
	                                          'div',
	                                          { 'class': 'form-group custom-form-group col-md-3' },
	                                          _react2.default.createElement(
	                                            'label',
	                                            null,
	                                            ' Is Form Required ',
	                                            _react2.default.createElement(
	                                              'span',
	                                              { className: 'astrick' },
	                                              '*'
	                                            )
	                                          )
	                                        ),
	                                        _react2.default.createElement(
	                                          'div',
	                                          { 'class': 'form-group custom-form-group col-md-2' },
	                                          _react2.default.createElement('input', { type: 'checkbox', name: 'isform', checked: registration_details.isForm,
	                                            className: 'form-control checkbox-cus', onClick: _this3.handleFormCheckBox })
	                                        ),
	                                        _react2.default.createElement(
	                                          'div',
	                                          { className: 'form-group custom-form-group col-md-7' },
	                                          _react2.default.createElement(
	                                            'button',
	                                            { className: 'btn btn-primary btn-sm pull-right',
	                                              onClick: _this3.addFormField },
	                                            'Add'
	                                          )
	                                        )
	                                      ),
	                                      registration_details.isForm && _react2.default.createElement(
	                                        'div',
	                                        { className: 'row' },
	                                        _react2.default.createElement(
	                                          'div',
	                                          { className: 'form-group custom-form-group col-md-12 table' },
	                                          _react2.default.createElement(
	                                            'table',
	                                            { className: 'table table-bordered' },
	                                            _react2.default.createElement(
	                                              'tr',
	                                              null,
	                                              _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Label Name'
	                                              ),
	                                              _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Input Name'
	                                              ),
	                                              _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Type'
	                                              ),
	                                              _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Max Upload Count'
	                                              ),
	                                              _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Action'
	                                              )
	                                            ),
	                                            registration_details.form.map(function (item, i) {
	                                              return _react2.default.createElement(
	                                                'tr',
	                                                { className: 'cu-row' },
	                                                _react2.default.createElement(
	                                                  'td',
	                                                  null,
	                                                  _react2.default.createElement('input', { type: 'text', className: 'form-control', disabled: i < 3,
	                                                    name: 'lbl_name', onChange: function onChange(e) {
	                                                      return _this3.handleFormChange(e, i);
	                                                    }, value: item.lbl_name })
	                                                ),
	                                                _react2.default.createElement(
	                                                  'td',
	                                                  null,
	                                                  _react2.default.createElement('input', { type: 'text', className: 'form-control', name: 'input_name',
	                                                    onChange: function onChange(e) {
	                                                      return _this3.handleFormChange(e, i);
	                                                    }, value: item.input_name, disabled: i < 3 })
	                                                ),
	                                                _react2.default.createElement(
	                                                  'td',
	                                                  null,
	                                                  _react2.default.createElement(
	                                                    'select',
	                                                    { className: 'form-control selectpicker', value: item.input_type,
	                                                      onChange: function onChange(e) {
	                                                        return _this3.handleFormChange(e, i);
	                                                      }, name: 'input_type', title: 'Select',
	                                                      disabled: i < 3 },
	                                                    _react2.default.createElement(
	                                                      'option',
	                                                      { value: 'text' },
	                                                      'Text'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                      'option',
	                                                      { value: 'email' },
	                                                      'Email'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                      'option',
	                                                      { value: 'number' },
	                                                      'Number'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                      'option',
	                                                      { value: 'file' },
	                                                      'Files'
	                                                    )
	                                                  )
	                                                ),
	                                                _react2.default.createElement(
	                                                  'td',
	                                                  null,
	                                                  _react2.default.createElement('input', { type: 'text', className: 'form-control', name: 'max_upload',
	                                                    onChange: function onChange(e) {
	                                                      return _this3.handleFormChange(e, i);
	                                                    }, value: item.max_upload,
	                                                    disabled: item.input_type != 'file' || i < 3 })
	                                                ),
	                                                _react2.default.createElement(
	                                                  'td',
	                                                  null,
	                                                  i > 2 && _react2.default.createElement(
	                                                    'button',
	                                                    { className: 'btn btn-danger btn-sm pull-right',
	                                                      onClick: function onClick(e) {
	                                                        return _this3.removeFormField(e, i);
	                                                      } },
	                                                    _react2.default.createElement('i', { 'class': 'fa fa-trash', 'aria-hidden': 'true' })
	                                                  )
	                                                )
	                                              );
	                                            })
	                                          )
	                                        )
	                                      )
	                                    ),
	                                    index === 3 && registration_details.isForm && _react2.default.createElement(
	                                      _react2.default.Fragment,
	                                      null,
	                                      _react2.default.createElement(
	                                        'div',
	                                        { className: 'row' },
	                                        _react2.default.createElement(
	                                          'div',
	                                          { className: 'form-group custom-form-group col-md-12' },
	                                          _react2.default.createElement(
	                                            'h4',
	                                            null,
	                                            'Top Button CSS'
	                                          )
	                                        )
	                                      ),
	                                      _react2.default.createElement(
	                                        'div',
	                                        { className: 'row' },
	                                        _react2.default.createElement(
	                                          'div',
	                                          { 'class': 'form-group custom-form-group col-md-4' },
	                                          _react2.default.createElement(
	                                            'label',
	                                            null,
	                                            ' BG Color ',
	                                            _react2.default.createElement(
	                                              'span',
	                                              { className: 'astrick' },
	                                              '*'
	                                            )
	                                          ),
	                                          _react2.default.createElement('input', { type: 'color', className: 'form-control', name: 'btn_bg_clr',
	                                            value: btn_css.btn_bg_clr, onChange: function onChange(e) {
	                                              return _this3.handleChangeCss(e, 1);
	                                            } }),
	                                          _this3.validator.message('BG Color', btn_css.btn_bg_clr, 'required', { className: 'text-danger' })
	                                        ),
	                                        _react2.default.createElement(
	                                          'div',
	                                          { 'class': 'form-group custom-form-group col-md-4' },
	                                          _react2.default.createElement(
	                                            'label',
	                                            null,
	                                            ' Hover BG Color ',
	                                            _react2.default.createElement(
	                                              'span',
	                                              { className: 'astrick' },
	                                              '*'
	                                            )
	                                          ),
	                                          _react2.default.createElement('input', { type: 'color', className: 'form-control', name: 'btn_hvr_bg_clr',
	                                            value: btn_css.btn_hvr_bg_clr, onChange: function onChange(e) {
	                                              return _this3.handleChangeCss(e, 1);
	                                            } }),
	                                          _this3.validator.message('Hover BG Color', btn_css.btn_hvr_bg_clr, 'required', { className: 'text-danger' })
	                                        ),
	                                        _react2.default.createElement(
	                                          'div',
	                                          { 'class': 'form-group custom-form-group col-md-4' },
	                                          _react2.default.createElement(
	                                            'label',
	                                            null,
	                                            ' Font Color ',
	                                            _react2.default.createElement(
	                                              'span',
	                                              { className: 'astrick' },
	                                              '*'
	                                            )
	                                          ),
	                                          _react2.default.createElement('input', { type: 'color', className: 'form-control', name: 'btn_font_clr',
	                                            value: btn_css.btn_font_clr, onChange: function onChange(e) {
	                                              return _this3.handleChangeCss(e, 1);
	                                            } }),
	                                          _this3.validator.message('Font Color', btn_css.btn_font_clr, 'required', { className: 'text-danger' })
	                                        ),
	                                        _react2.default.createElement(
	                                          'div',
	                                          { 'class': 'form-group custom-form-group col-md-4' },
	                                          _react2.default.createElement(
	                                            'label',
	                                            null,
	                                            ' Hover Font Color ',
	                                            _react2.default.createElement(
	                                              'span',
	                                              { className: 'astrick' },
	                                              '*'
	                                            )
	                                          ),
	                                          _react2.default.createElement('input', { type: 'color', className: 'form-control', name: 'btn_hvr_font_clr',
	                                            value: btn_css.btn_hvr_font_clr, onChange: function onChange(e) {
	                                              return _this3.handleChangeCss(e, 1);
	                                            } }),
	                                          _this3.validator.message('Hover Font Color', btn_css.btn_hvr_font_clr, 'required', { className: 'text-danger' })
	                                        ),
	                                        _react2.default.createElement(
	                                          'div',
	                                          { 'class': 'form-group custom-form-group col-md-4' },
	                                          _react2.default.createElement(
	                                            'label',
	                                            null,
	                                            ' Hover Border Color ',
	                                            _react2.default.createElement(
	                                              'span',
	                                              { className: 'astrick' },
	                                              '*'
	                                            )
	                                          ),
	                                          _react2.default.createElement('input', { type: 'color', className: 'form-control', name: 'btn_hvr_bdr_clr',
	                                            value: btn_css.btn_hvr_bdr_clr, onChange: function onChange(e) {
	                                              return _this3.handleChangeCss(e, 1);
	                                            } }),
	                                          _this3.validator.message('Hover Border Color', btn_css.btn_hvr_bdr_clr, 'required', { className: 'text-danger' })
	                                        )
	                                      ),
	                                      _react2.default.createElement(
	                                        'div',
	                                        { className: 'row' },
	                                        _react2.default.createElement(
	                                          'div',
	                                          { className: 'form-group custom-form-group col-md-12' },
	                                          _react2.default.createElement(
	                                            'h4',
	                                            null,
	                                            'Registration Form'
	                                          )
	                                        )
	                                      ),
	                                      _react2.default.createElement(
	                                        'div',
	                                        { className: 'row' },
	                                        _react2.default.createElement(
	                                          'div',
	                                          { 'class': 'form-group custom-form-group col-md-4' },
	                                          _react2.default.createElement(
	                                            'label',
	                                            null,
	                                            ' Form Title ',
	                                            _react2.default.createElement(
	                                              'span',
	                                              { className: 'astrick' },
	                                              '*'
	                                            )
	                                          ),
	                                          _react2.default.createElement('input', { type: 'text', className: 'form-control', name: 'form_title',
	                                            value: form_css.form_title, onChange: function onChange(e) {
	                                              return _this3.handleChangeCss(e, 2);
	                                            } }),
	                                          _this3.validator.message('Form Title', form_css.form_title, 'required', { className: 'text-danger' })
	                                        ),
	                                        _react2.default.createElement(
	                                          'div',
	                                          { 'class': 'form-group custom-form-group col-md-4' },
	                                          _react2.default.createElement(
	                                            'label',
	                                            null,
	                                            ' Font Color ',
	                                            _react2.default.createElement(
	                                              'span',
	                                              { className: 'astrick' },
	                                              '*'
	                                            )
	                                          ),
	                                          _react2.default.createElement('input', { type: 'color', className: 'form-control', name: 'form_title_clr',
	                                            value: form_css.form_title_clr, onChange: function onChange(e) {
	                                              return _this3.handleChangeCss(e, 2);
	                                            } }),
	                                          _this3.validator.message('Font Color', form_css.form_title_clr, 'required', { className: 'text-danger' })
	                                        ),
	                                        _react2.default.createElement(
	                                          'div',
	                                          { 'class': 'form-group custom-form-group col-md-4' },
	                                          _react2.default.createElement(
	                                            'label',
	                                            null,
	                                            ' Form BG Color ',
	                                            _react2.default.createElement(
	                                              'span',
	                                              { className: 'astrick' },
	                                              '*'
	                                            )
	                                          ),
	                                          _react2.default.createElement('input', { type: 'color', className: 'form-control', name: 'form_bg_clr',
	                                            value: form_css.form_bg_clr, onChange: function onChange(e) {
	                                              return _this3.handleChangeCss(e, 2);
	                                            } }),
	                                          _this3.validator.message('Form BG Color', form_css.form_bg_clr, 'required', { className: 'text-danger' })
	                                        ),
	                                        _react2.default.createElement(
	                                          'div',
	                                          { 'class': 'form-group custom-form-group col-md-4' },
	                                          _react2.default.createElement(
	                                            'label',
	                                            null,
	                                            ' Button BG Color ',
	                                            _react2.default.createElement(
	                                              'span',
	                                              { className: 'astrick' },
	                                              '*'
	                                            )
	                                          ),
	                                          _react2.default.createElement('input', { type: 'color', className: 'form-control', name: 'sb_btn_bg_clr',
	                                            value: form_css.sb_btn_bg_clr, onChange: function onChange(e) {
	                                              return _this3.handleChangeCss(e, 2);
	                                            } }),
	                                          _this3.validator.message('Button BG Color', form_css.sb_btn_bg_clr, 'required', { className: 'text-danger' })
	                                        ),
	                                        _react2.default.createElement(
	                                          'div',
	                                          { 'class': 'form-group custom-form-group col-md-4' },
	                                          _react2.default.createElement(
	                                            'label',
	                                            null,
	                                            ' Button Font Color ',
	                                            _react2.default.createElement(
	                                              'span',
	                                              { className: 'astrick' },
	                                              '*'
	                                            )
	                                          ),
	                                          _react2.default.createElement('input', { type: 'color', className: 'form-control', name: 'sb_btn_font_clr',
	                                            value: form_css.sb_btn_font_clr, onChange: function onChange(e) {
	                                              return _this3.handleChangeCss(e, 2);
	                                            } }),
	                                          _this3.validator.message('Button BG Color', form_css.sb_btn_font_clr, 'required', { className: 'text-danger' })
	                                        )
	                                      )
	                                    ),
	                                    index === 4 && _react2.default.createElement(
	                                      _react2.default.Fragment,
	                                      null,
	                                      _react2.default.createElement(
	                                        'div',
	                                        { className: 'row' },
	                                        _react2.default.createElement(
	                                          'div',
	                                          { className: 'row' },
	                                          _react2.default.createElement(
	                                            'div',
	                                            { className: 'form-group custom-form-group col-md-12 table' },
	                                            _react2.default.createElement(
	                                              'table',
	                                              { className: 'table table-bordered' },
	                                              _react2.default.createElement(
	                                                'tbody',
	                                                null,
	                                                _react2.default.createElement(
	                                                  'tr',
	                                                  null,
	                                                  _react2.default.createElement(
	                                                    'th',
	                                                    null,
	                                                    'No'
	                                                  ),
	                                                  _react2.default.createElement(
	                                                    'th',
	                                                    null,
	                                                    'Question'
	                                                  ),
	                                                  _react2.default.createElement(
	                                                    'th',
	                                                    { style: { width: '15%' } },
	                                                    'Action'
	                                                  )
	                                                )
	                                              ),
	                                              _react2.default.createElement(
	                                                'tbody',
	                                                null,
	                                                faq_details.map(function (item, i) {
	                                                  var cnt = i + 1;
	                                                  return _react2.default.createElement(
	                                                    'tr',
	                                                    null,
	                                                    _react2.default.createElement(
	                                                      'td',
	                                                      null,
	                                                      cnt
	                                                    ),
	                                                    _react2.default.createElement(
	                                                      'td',
	                                                      null,
	                                                      item.ques
	                                                    ),
	                                                    _react2.default.createElement(
	                                                      'td',
	                                                      null,
	                                                      _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'row' },
	                                                        _react2.default.createElement(
	                                                          'div',
	                                                          { className: 'col-md-6' },
	                                                          _react2.default.createElement(
	                                                            'button',
	                                                            { className: 'btn btn-primary btn-sm pull-right',
	                                                              onClick: function onClick(e) {
	                                                                return _this3.editFaq(e, i);
	                                                              } },
	                                                            _react2.default.createElement('i', { 'class': 'fa fa-edit', 'aria-hidden': 'true' })
	                                                          )
	                                                        ),
	                                                        _react2.default.createElement(
	                                                          'div',
	                                                          { className: 'col-md-6' },
	                                                          _react2.default.createElement(
	                                                            'button',
	                                                            { className: 'btn btn-danger btn-sm pull-right',
	                                                              onClick: function onClick(e) {
	                                                                return _this3.removeFaq(e, i);
	                                                              } },
	                                                            _react2.default.createElement('i', { 'class': 'fa fa-times', 'aria-hidden': 'true' })
	                                                          )
	                                                        )
	                                                      )
	                                                    )
	                                                  );
	                                                })
	                                              )
	                                            )
	                                          )
	                                        ),
	                                        _react2.default.createElement(
	                                          'div',
	                                          { className: 'row' },
	                                          _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'form-group custom-form-group col-md-12' },
	                                            _react2.default.createElement(
	                                              'label',
	                                              null,
	                                              ' Question ',
	                                              _react2.default.createElement(
	                                                'span',
	                                                { className: 'astrick' },
	                                                '*'
	                                              )
	                                            ),
	                                            _react2.default.createElement('input', { type: 'text', className: 'form-control', name: 'temp_ques',
	                                              value: _this3.state.temp_ques, onChange: _this3.handleChange }),
	                                            _react2.default.createElement(
	                                              'label',
	                                              null,
	                                              ' Answer ',
	                                              _react2.default.createElement(
	                                                'span',
	                                                { className: 'astrick' },
	                                                '*'
	                                              )
	                                            ),
	                                            _react2.default.createElement(_tinymceReact.Editor, {
	                                              textareaName: 'temp_ans',
	                                              onEditorChange: _this3.handleEditorChange,
	                                              value: _this3.state.temp_ans,
	                                              apiKey: _constant.TINY_EDITOR,
	                                              init: {
	                                                height: 300,
	                                                plugins: ['lists link image paste'],
	                                                menubar: 'edit | insert | format',
	                                                toolbar: 'undo redo | formatselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link'
	                                              }
	                                            })
	                                          )
	                                        ),
	                                        _react2.default.createElement(
	                                          'div',
	                                          { className: 'row' },
	                                          _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'form-group custom-form-group col-md-12' },
	                                            _react2.default.createElement(
	                                              'button',
	                                              { className: 'btn btn-danger btn-sm pull-right',
	                                                onClick: _this3.cancelFaq },
	                                              _react2.default.createElement('i', { 'class': 'fa fa-times', 'aria-hidden': 'true' })
	                                            ),
	                                            _react2.default.createElement(
	                                              'button',
	                                              { className: 'btn btn-primary btn-sm pull-right', style: { marginRight: '20px' },
	                                                onClick: _this3.addFaq },
	                                              _react2.default.createElement('i', { 'class': 'fa fa-check', 'aria-hidden': 'true' })
	                                            )
	                                          )
	                                        )
	                                      )
	                                    ),
	                                    index === 5 && registration_details.isForm && _react2.default.createElement(
	                                      _react2.default.Fragment,
	                                      null,
	                                      _react2.default.createElement(
	                                        'div',
	                                        { className: 'row' },
	                                        _react2.default.createElement(
	                                          'div',
	                                          { 'class': 'form-group custom-form-group col-md-6' },
	                                          _react2.default.createElement(
	                                            'label',
	                                            null,
	                                            ' Subject ',
	                                            _react2.default.createElement(
	                                              'span',
	                                              { className: 'astrick' },
	                                              '*'
	                                            )
	                                          ),
	                                          _react2.default.createElement('input', { type: 'text', className: 'form-control', name: 'subject',
	                                            value: email_details.subject, onChange: _this3.handleChangeEmail }),
	                                          _this3.validator.message('Title', email_details.subject, 'required', { className: 'text-danger' })
	                                        ),
	                                        _react2.default.createElement(
	                                          'div',
	                                          { 'class': 'form-group custom-form-group col-md-6 cus-date-sec' },
	                                          _react2.default.createElement(
	                                            'label',
	                                            null,
	                                            ' Event Date Time ',
	                                            _react2.default.createElement(
	                                              'span',
	                                              { className: 'astrick' },
	                                              '*'
	                                            )
	                                          ),
	                                          _react2.default.createElement(_reactDatepicker2.default, {
	                                            autocomplete: 'off',
	                                            className: 'form-control input-group-date',
	                                            selected: email_details.eventdate ? new Date(email_details.eventdate) : '',
	                                            name: 'eventdate',
	                                            id: 'eventdate',
	                                            showTimeSelect: true,
	                                            dateFormat: 'MMMM d, yyyy HH:mm',
	                                            onChange: function onChange(date) {
	                                              var email_details = _this3.state.email_details;
	                                              email_details.data['eventdate'] = date;
	                                              _this3.setState({
	                                                email_details: email_details
	                                              });
	                                            }
	                                          }),
	                                          _this3.validator.message('Event Date', email_details.eventdate, 'required', { className: 'text-danger' })
	                                        ),
	                                        _react2.default.createElement(
	                                          'div',
	                                          { 'class': 'form-group custom-form-group col-md-6' },
	                                          _react2.default.createElement(
	                                            'label',
	                                            null,
	                                            ' Duration',
	                                            _react2.default.createElement(
	                                              'span',
	                                              { className: 'astrick' },
	                                              '*'
	                                            )
	                                          ),
	                                          _react2.default.createElement('input', { type: 'text', className: 'form-control', name: 'duration', placeholder: 'HH:MM',
	                                            value: email_details.duration, onChange: _this3.handleChangeEmail }),
	                                          _this3.validator.message('Duration', email_details.duration, 'required', { className: 'text-danger' })
	                                        ),
	                                        _react2.default.createElement(
	                                          'div',
	                                          { 'class': 'form-group custom-form-group col-md-6' },
	                                          _react2.default.createElement(
	                                            'label',
	                                            null,
	                                            ' Calender Title',
	                                            _react2.default.createElement(
	                                              'span',
	                                              { className: 'astrick' },
	                                              '*'
	                                            )
	                                          ),
	                                          _react2.default.createElement('input', { type: 'text', className: 'form-control', name: 'calender_title',
	                                            value: email_details.calender_title, onChange: _this3.handleChangeEmail }),
	                                          _this3.validator.message('Calender Title', email_details.calender_title, 'required', { className: 'text-danger' })
	                                        ),
	                                        _react2.default.createElement(
	                                          'div',
	                                          { 'class': 'form-group custom-form-group col-md-6' },
	                                          _react2.default.createElement(
	                                            'label',
	                                            null,
	                                            ' Calender Short Description ',
	                                            _react2.default.createElement(
	                                              'span',
	                                              { className: 'astrick' },
	                                              '*'
	                                            )
	                                          ),
	                                          _react2.default.createElement('textarea', { type: 'text', rows: 2, className: 'form-control', name: 'calender_desc',
	                                            value: email_details.calender_desc, onChange: _this3.handleChangeEmail }),
	                                          _this3.validator.message('Calender Short Description', email_details.calender_desc, 'required', { className: 'text-danger' })
	                                        ),
	                                        _react2.default.createElement(
	                                          'div',
	                                          { 'class': 'form-group custom-form-group col-md-6' },
	                                          _react2.default.createElement(
	                                            'label',
	                                            null,
	                                            ' URL ',
	                                            _react2.default.createElement(
	                                              'span',
	                                              { className: 'astrick' },
	                                              '*'
	                                            )
	                                          ),
	                                          _react2.default.createElement('input', { type: 'text', className: 'form-control', name: 'event_url',
	                                            value: email_details.event_url, onChange: _this3.handleChangeEmail }),
	                                          _this3.validator.message('Ticker', email_details.event_url, 'required', { className: 'text-danger' })
	                                        )
	                                      ),
	                                      _react2.default.createElement(
	                                        'div',
	                                        { className: 'row' },
	                                        _react2.default.createElement(
	                                          'div',
	                                          { 'class': 'form-group custom-form-group col-md-12' },
	                                          _react2.default.createElement(
	                                            'label',
	                                            null,
	                                            ' Email Body ',
	                                            _react2.default.createElement(
	                                              'span',
	                                              { className: 'astrick' },
	                                              '*'
	                                            )
	                                          ),
	                                          _react2.default.createElement(_tinymceReact.Editor, {
	                                            textareaName: 'mail_body',
	                                            onEditorChange: _this3.handleChangeEmailEditor,
	                                            value: email_details.mail_body,
	                                            apiKey: _constant.TINY_EDITOR,
	                                            init: {
	                                              height: 500,
	                                              plugins: ['lists link image paste'],
	                                              menubar: 'edit | insert | format',
	                                              toolbar: 'undo redo | formatselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link'
	                                            }
	                                          }),
	                                          _this3.validator.message('Email Body', email_details.mail_body, 'required', { className: 'text-danger' })
	                                        )
	                                      )
	                                    )
	                                  )
	                                )
	                              );
	                            }),
	                            _react2.default.createElement(
	                              _reactstrap.Card,
	                              { className: 'panel-group custom-card', style: { marginBottom: '1rem' }, key: 'preview' },
	                              _react2.default.createElement(
	                                _reactstrap.CardHeader,
	                                { onClick: function onClick() {
	                                    return _this3.toggle('preview');
	                                  }, 'data-event': 'preview', className: 'custom-card-heading' },
	                                _react2.default.createElement(
	                                  'b',
	                                  null,
	                                  'Preview'
	                                ),
	                                collapse != 'preview' ? _react2.default.createElement(
	                                  'span',
	                                  { className: 'pull-right' },
	                                  _react2.default.createElement('i', { 'class': 'fa fa-plus', 'aria-hidden': 'true' })
	                                ) : _react2.default.createElement(
	                                  'span',
	                                  { className: 'pull-right' },
	                                  _react2.default.createElement('i', { 'class': 'fa fa-minus', 'aria-hidden': 'true' })
	                                )
	                              ),
	                              _react2.default.createElement(
	                                _reactstrap.Collapse,
	                                { isOpen: collapse == 'preview' },
	                                _react2.default.createElement(
	                                  _reactstrap.CardBody,
	                                  { className: 'panel-body' },
	                                  _react2.default.createElement(_event_preview2.default, { eData: this.state })
	                                )
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'row mb-4' },
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-12' },
	                                role == 1 && _react2.default.createElement(
	                                  'button',
	                                  { type: 'submit', onClick: function onClick(e) {
	                                      return _this3.handleSubmit(e, 1);
	                                    }, disabled: this.state.disableBtn,
	                                    className: 'btn btn-primary btn-sm pull-right' },
	                                  'Submit'
	                                ),
	                                _react2.default.createElement(
	                                  'button',
	                                  { type: 'submit', onClick: function onClick(e) {
	                                      return _this3.handleSubmit(e, 2);
	                                    }, style: { marginRight: '20px' }, disabled: this.state.disableBtn,
	                                    className: 'btn btn-primary btn-sm pull-right' },
	                                  'Save'
	                                )
	                              )
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'deleteEvent',
	    value: function deleteEvent() {
	      var _this4 = this;
	
	      var delete_id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	      (0, _sweetalert2.default)({
	        title: "Are you sure to Disable Event?",
	        text: "",
	        icon: "warning",
	        buttons: true,
	        dangerMode: true
	      }).then(function (willDelete) {
	        if (willDelete) {
	          var ins = JSON.stringify({
	            event_id: delete_id ? delete_id : _this4.state.delete_id,
	            role: _this4.state.role,
	            url: 'remove_event'
	          });
	          (0, _FetchCall.splEvent)(ins).then(function (res) {
	            var toastr = '';
	            if (res.status === 1) {
	              toastr = window.toastr.success;
	              toastr('', res.message, {
	                positionClass: "toast-bottom-right",
	                containerId: "toast-bottom-right"
	              });
	              setTimeout(function () {
	                window.location.reload();
	              }, 2000);
	            } else {
	              toastr = window.toastr.error; //warning
	              toastr('', res.message, {
	                positionClass: "toast-bottom-right",
	                containerId: "toast-bottom-right"
	              });
	            }
	          });
	        }
	      });
	    }
	  }]);
	
	  return cmsEvents;
	}(_react.Component);
	
	exports.default = cmsEvents;

/***/ },
/* 905 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _reactJsPagination = __webpack_require__(33);
	
	var _reactJsPagination2 = _interopRequireDefault(_reactJsPagination);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import { Editor } from '@tinymce/tinymce-react';
	
	var cmsInsights = function (_Component) {
	  _inherits(cmsInsights, _Component);
	
	  function cmsInsights(props) {
	    _classCallCheck(this, cmsInsights);
	
	    var _this = _possibleConstructorReturn(this, (cmsInsights.__proto__ || Object.getPrototypeOf(cmsInsights)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var url = new URL(window.location.href);
	    var location = url.searchParams.get("location");
	    var auth_data = JSON.parse(localStorage.getItem("user_data"));
	    _this.state = {
	      logged: localStorage.getItem("authentication"),
	      auth_data: JSON.parse(localStorage.getItem("user_data")),
	      location: '',
	      mailList: [],
	      searchby: '',
	      activePage: 0,
	      tablename: 'bw_insight_content',
	      PER_PAGE: 15,
	      offset: 0,
	      total: 0,
	      loading: true
	    };
	
	    _this.getList();
	    return _this;
	  }
	
	  _createClass(cmsInsights, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	
	      var THIS = this;
	      (0, _jquery2.default)(document).on('click', '.remove_insight', function () {
	        var delete_id = (0, _jquery2.default)(this).data("id");
	
	        if (confirm("You are sure to delete?") == true) {
	
	          var ins = JSON.stringify({
	            id: delete_id,
	            table: 'insight'
	          });
	
	          (0, _FetchCall.removethisItem)(ins).then(function (res) {
	
	            THIS.getTotal();
	            THIS.getList();
	          });
	        }
	      });
	
	      this.getTotal();
	      this.getList();
	    }
	  }, {
	    key: 'handlePageChange',
	    value: function handlePageChange(pageNumber) {
	      this.setState({ activePage: pageNumber });
	      this.getList(pageNumber);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          mailList = _state.mailList,
	          currentPage = _state.currentPage,
	          PER_PAGE = _state.PER_PAGE,
	          total = _state.total,
	          exportbtndisabled = _state.exportbtndisabled;
	
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'col-lg-12 grid-margin stretch-card' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card-body' },
	                _react2.default.createElement(
	                  'h4',
	                  { 'class': 'card-title' },
	                  'Articles'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'float-right' },
	                  _react2.default.createElement(
	                    'a',
	                    { href: '/cms/insights/addinsight', 'class': 'btn btn-primary btn-sm' },
	                    'Add New'
	                  )
	                ),
	                _react2.default.createElement(
	                  'p',
	                  { 'class': 'card-description' },
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'cityselection' },
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'leftaligned bwlabel' },
	                      'City'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'leftaligned' },
	                      _react2.default.createElement(
	                        'select',
	                        { name: 'location', 'class': 'form-control', onChange: function onChange(e) {
	                            return _this2.handleSelect(e);
	                          },
	                          value: this.state.location },
	                        _react2.default.createElement(
	                          'option',
	                          { value: '' },
	                          'select city'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: '1' },
	                          'Bengaluru'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: '12' },
	                          'Chennai'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: '27' },
	                          'Hosur'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'leftaligned bwlabel' },
	                      'Search'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'leftaligned' },
	                      _react2.default.createElement('input', { type: 'text', name: 'searchby', 'class': 'form-control form-control-sm', onChange: this.handleChange })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'leftaligned' },
	                      _react2.default.createElement(
	                        'button',
	                        { 'class': 'btn btn-primary btn-sm', onClick: this.searchBy },
	                        'Go'
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'table-responsive pt-3' },
	                  _react2.default.createElement(
	                    'table',
	                    { id: 'tablebw' },
	                    _react2.default.createElement(
	                      'thead',
	                      { 'class': 'thead-dark' },
	                      _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'S.No'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Blog Title'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Category'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Blog For/From'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Date'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Author'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Status'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Action'
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'tbody',
	                      null,
	                      mailList.map(function (item, i) {
	
	                        return _react2.default.createElement(
	                          'tr',
	                          null,
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.s_no
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.title
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.category_name == 0 ? "None" : item.category_name
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.blogfor
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.updated_date
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.author
	                          ),
	                          _react2.default.createElement('td', { dangerouslySetInnerHTML: { __html: item.status } }),
	                          _react2.default.createElement('td', { dangerouslySetInnerHTML: { __html: item.action } })
	                        );
	                      })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'text-center' },
	                    _react2.default.createElement(_reactJsPagination2.default, {
	                      activePage: this.state.activePage,
	                      itemsCountPerPage: PER_PAGE,
	                      totalItemsCount: this.state.total,
	                      pageRangeDisplayed: 5,
	                      activeClass: "pagination__link--active",
	                      onChange: this.handlePageChange.bind(this),
	                      prevPageText: 'previous',
	                      nextPageText: 'next'
	                    })
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return cmsInsights;
	}(_react.Component);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this3 = this;
	
	  this.getTotal = function () {
	    var location = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	
	    var locationselected = location == '' ? _this3.state.location : location;
	
	    var ins = JSON.stringify({
	      vertical: _this3.state.tablename,
	      location: locationselected,
	      searchby: _this3.state.searchby
	    });
	
	    (0, _FetchCall.getTotal)(ins).then(function (res) {
	
	      _this3.setState({ loading: true });
	
	      if (res.status == 1) {
	
	        _this3.setState({
	
	          total: res.total
	
	        });
	      }
	    });
	  };
	
	  this.generateThumbnails = function () {
	
	    (0, _FetchCall.generateThumbnails)().then(function (res) {
	
	      if (res.status == 1) {
	        alert("All generated");
	      } else {
	        console.log(res.message);
	      }
	    });
	  };
	
	  this.getList = function () {
	    var pageNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	    var location = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	    var _state$auth_data = _this3.state.auth_data,
	        login_id = _state$auth_data.login_id,
	        role = _state$auth_data.role;
	
	
	    _this3.setState({ activePage: pageNumber });
	
	    var newOffset = pageNumber == 1 ? 0 : (pageNumber - 1) * _this3.state.PER_PAGE % _this3.state.total;
	
	    var locationselected = location == '' ? _this3.state.location : location;
	
	    var ins = JSON.stringify({
	      vendor_id: login_id,
	      role: role,
	      location: locationselected,
	      searchby: _this3.state.searchby,
	      perpage: _this3.state.PER_PAGE,
	      offset: newOffset
	    });
	
	    (0, _FetchCall.getInsightListPaged)(ins).then(function (res) {
	
	      _this3.setState({ loading: true });
	
	      if (res.status == 1) {
	
	        _this3.setState({ loading: !_this3.state.loading });
	
	        _this3.setState({
	
	          mailList: res.data
	
	        });
	      } else {
	
	        _this3.setState({ loading: !_this3.state.loading });
	
	        _this3.setState({
	          mailList: []
	        });
	      }
	    });
	  };
	
	  this.handleSelect = function (e) {
	    _this3.setState({ location: e.target.value, activePage: 1 });
	    _this3.getTotal(e.target.value);
	    _this3.getList(1, e.target.value);
	  };
	
	  this.handleChange = function (e) {
	    _this3.setState(_defineProperty({}, e.target.name, e.target.value));
	  };
	
	  this.searchBy = function (e) {
	
	    _this3.setState({ loading: true, activePage: 1 });
	    _this3.getTotal();
	    _this3.getList(1);
	  };
	};
	
	exports.default = cmsInsights;

/***/ },
/* 906 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _FetchCall2 = _interopRequireDefault(_FetchCall);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import { Editor } from '@tinymce/tinymce-react';
	
	
	var cmsMails = function (_Component) {
	  _inherits(cmsMails, _Component);
	
	  function cmsMails(props) {
	    _classCallCheck(this, cmsMails);
	
	    var _this = _possibleConstructorReturn(this, (cmsMails.__proto__ || Object.getPrototypeOf(cmsMails)).call(this, props));
	
	    _this.getList = function () {
	      var _this$state$auth_data = _this.state.auth_data,
	          login_id = _this$state$auth_data.login_id,
	          role = _this$state$auth_data.role;
	
	      var ins = JSON.stringify({
	        vendor_id: login_id,
	        role: role
	      });
	      (0, _FetchCall.getMailList)(ins).then(function (res) {
	        if (res.status == 1) {
	          _this.setState({
	            mailList: res.data
	
	          });
	        } else {
	          _this.setState({
	            mailList: []
	          });
	        }
	      });
	    };
	
	    var url = new URL(window.location.href);
	    var location = url.searchParams.get("location");
	    var auth_data = JSON.parse(localStorage.getItem("user_data"));
	    _this.state = {
	      logged: localStorage.getItem("authentication"),
	      auth_data: JSON.parse(localStorage.getItem("user_data")),
	      location: location ? location : auth_data.access_location ? auth_data.access_location : 'Bengaluru',
	      mailList: []
	    };
	
	    _this.getList();
	    return _this;
	  }
	
	  _createClass(cmsMails, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	
	      var THIS = this;
	      (0, _jquery2.default)(document).on('click', '.remove_maili', function () {
	        var delete_id = (0, _jquery2.default)(this).data("id");
	        THIS.setState({
	          delete_id: delete_id
	        });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var mailList = this.state.mailList;
	
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'col-lg-12 grid-margin stretch-card' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card-body' },
	                _react2.default.createElement(
	                  'h4',
	                  { 'class': 'card-title' },
	                  'Mails'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'float-right' },
	                  _react2.default.createElement(
	                    'a',
	                    { href: '/cms/addmail', 'class': 'btn btn-primary btn-sm' },
	                    'Add New'
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'table-responsive pt-3' },
	                  _react2.default.createElement(
	                    'table',
	                    { id: 'tablebw' },
	                    _react2.default.createElement(
	                      'thead',
	                      { 'class': 'thead-dark' },
	                      _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'S.No'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Template'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Date'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'By'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Status'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Action'
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'tbody',
	                      null,
	                      mailList.map(function (item, i) {
	
	                        return _react2.default.createElement(
	                          'tr',
	                          null,
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            i + 1
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.mail_template
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.created_date
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.created_by
	                          ),
	                          _react2.default.createElement('td', { dangerouslySetInnerHTML: { __html: item.status } }),
	                          _react2.default.createElement('td', { dangerouslySetInnerHTML: { __html: item.action } })
	                        );
	                      })
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return cmsMails;
	}(_react.Component);
	
	exports.default = cmsMails;

/***/ },
/* 907 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _FetchCall2 = _interopRequireDefault(_FetchCall);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import { Editor } from '@tinymce/tinymce-react';
	
	
	var cmsNews = function (_Component) {
	  _inherits(cmsNews, _Component);
	
	  function cmsNews(props) {
	    _classCallCheck(this, cmsNews);
	
	    var _this = _possibleConstructorReturn(this, (cmsNews.__proto__ || Object.getPrototypeOf(cmsNews)).call(this, props));
	
	    _this.getNewsList = function () {
	      var _this$state$auth_data = _this.state.auth_data,
	          login_id = _this$state$auth_data.login_id,
	          role = _this$state$auth_data.role;
	
	      var ins = JSON.stringify({
	        vendor_id: login_id,
	        role: role
	      });
	      (0, _FetchCall.getNewsList)(ins).then(function (res) {
	        if (res.status == 1) {
	          _this.setState({
	            newsList: res.data
	
	          });
	        } else {
	          _this.setState({
	            newsList: []
	          });
	        }
	      });
	    };
	
	    var url = new URL(window.location.href);
	    var location = url.searchParams.get("location");
	    var auth_data = JSON.parse(localStorage.getItem("user_data"));
	    _this.state = {
	      logged: localStorage.getItem("authentication"),
	      auth_data: JSON.parse(localStorage.getItem("user_data")),
	      location: location ? location : auth_data.access_location ? auth_data.access_location : 'Bengaluru',
	      newsList: []
	    };
	
	    _this.getNewsList();
	    return _this;
	  }
	
	  _createClass(cmsNews, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	
	      var THIS = this;
	      (0, _jquery2.default)(document).on('click', '.remove_maili', function () {
	        var delete_id = (0, _jquery2.default)(this).data("id");
	        THIS.setState({
	          delete_id: delete_id
	        });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var newsList = this.state.newsList;
	
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'col-lg-12 grid-margin stretch-card' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card-body' },
	                _react2.default.createElement(
	                  'h4',
	                  { 'class': 'card-title' },
	                  'BeWise News'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'float-right' },
	                  _react2.default.createElement(
	                    'a',
	                    { href: '/cms/news/addnews', 'class': 'btn btn-primary btn-sm' },
	                    'Add New'
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'table-responsive pt-3' },
	                  _react2.default.createElement(
	                    'table',
	                    { id: 'tablebw' },
	                    _react2.default.createElement(
	                      'thead',
	                      { 'class': 'thead-dark' },
	                      _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'S.No'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'News Title'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Date'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'By'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Status'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Action'
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'tbody',
	                      null,
	                      newsList.map(function (item, i) {
	
	                        return _react2.default.createElement(
	                          'tr',
	                          null,
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            i + 1
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.news_title
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.created_date
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.created_by
	                          ),
	                          _react2.default.createElement('td', { dangerouslySetInnerHTML: { __html: item.status } }),
	                          _react2.default.createElement('td', { dangerouslySetInnerHTML: { __html: item.action } })
	                        );
	                      })
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return cmsNews;
	}(_react.Component);
	
	exports.default = cmsNews;

/***/ },
/* 908 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _FetchCall2 = _interopRequireDefault(_FetchCall);
	
	var _draftJs = __webpack_require__(84);
	
	var _reactDraftWysiwyg = __webpack_require__(127);
	
	__webpack_require__(92);
	
	var _draftjsToHtml = __webpack_require__(106);
	
	var _draftjsToHtml2 = _interopRequireDefault(_draftjsToHtml);
	
	var _htmlToDraftjs = __webpack_require__(158);
	
	var _htmlToDraftjs2 = _interopRequireDefault(_htmlToDraftjs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import { Editor } from '@tinymce/tinymce-react';
	
	var cmsSiteContents = function (_Component) {
	  _inherits(cmsSiteContents, _Component);
	
	  function cmsSiteContents(props) {
	    _classCallCheck(this, cmsSiteContents);
	
	    var _this = _possibleConstructorReturn(this, (cmsSiteContents.__proto__ || Object.getPrototypeOf(cmsSiteContents)).call(this, props));
	
	    _this.openAddBox = function () {
	
	      _this.setState({ openedAdd: !_this.state.openedAdd });
	    };
	
	    _this.deleteCMSContent = function (delete_id) {
	
	      var ins = JSON.stringify({
	        delete_id: delete_id
	      });
	      (0, _FetchCall.removeCMSSiteContent)(ins).then(function (res) {
	        if (res.status == 1) {
	
	          alert(res.message);
	          _this.getList();
	        } else {
	          alert(res.message);
	        }
	      });
	    };
	
	    _this.getList = function () {
	      var _this$state$auth_data = _this.state.auth_data,
	          login_id = _this$state$auth_data.login_id,
	          role = _this$state$auth_data.role;
	
	      var ins = JSON.stringify({
	        vendor_id: login_id,
	        role: role,
	        location: _this.state.location
	      });
	      (0, _FetchCall.getCMSSiteList)(ins).then(function (res) {
	        if (res.status == 1) {
	          _this.setState({
	            cmssiteList: res.data
	
	          });
	        } else {
	          _this.setState({
	            cmssiteList: []
	          });
	        }
	      });
	    };
	
	    _this.saveSiteContent = function () {
	
	      var req = JSON.stringify({
	        name: _this.state.name,
	        site_content: _this.state.site_content,
	        type: _this.state.type,
	        order: _this.state.order
	      });
	
	      (0, _FetchCall.saveSiteContent)(req).then(function (response) {
	
	        if (response.status == 1) {
	
	          alert(response.message);
	          _this.getList();
	        } else {
	          alert(response.message);
	        }
	      });
	    };
	
	    _this.handleChange = function (e) {
	      _this.setState(_defineProperty({}, e.target.name, e.target.value));
	    };
	
	    _this.onChange = function (editorState) {
	      //const contentState = editorState.getCurrentContent();
	      //console.log("plain text", editorState.getCurrentContent().getPlainText());
	
	      var contentState = (0, _draftjsToHtml2.default)((0, _draftJs.convertToRaw)(editorState.getCurrentContent()));
	
	      console.log("html", contentState);
	      //const raw = convertToRaw(contentState);
	      _this.setState({
	        consigne: editorState,
	        site_content: contentState
	      });
	    };
	
	    var url = new URL(window.location.href);
	    var location = url.searchParams.get("location");
	    var auth_data = JSON.parse(localStorage.getItem("user_data"));
	    _this.state = {
	      logged: localStorage.getItem("authentication"),
	      auth_data: JSON.parse(localStorage.getItem("user_data")),
	      location: location ? location : auth_data.access_location ? auth_data.access_location : 'Bengaluru',
	      cmssiteList: [],
	      openedAdd: false,
	      consigne: '',
	      editorState: _draftJs.EditorState.createEmpty()
	    };
	
	    _this.getList();
	    return _this;
	  }
	
	  _createClass(cmsSiteContents, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	
	      var THIS = this;
	      (0, _jquery2.default)(document).on('click', '.remove_cms', function () {
	        var delete_id = (0, _jquery2.default)(this).data("id");
	
	        if (confirm("Are your sure?") === true) {
	
	          THIS.deleteCMSContent(delete_id);
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          cmssiteList = _state.cmssiteList,
	          consigne = _state.consigne,
	          editorState = _state.editorState;
	
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'col-lg-12 grid-margin stretch-card' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card-body' },
	                _react2.default.createElement(
	                  'h4',
	                  { 'class': 'card-title' },
	                  'WebSite General Text Contents'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'float-right' },
	                  _react2.default.createElement(
	                    'button',
	                    { 'class': 'btn btn-primary btn-sm', onClick: this.openAddBox },
	                    'Add New'
	                  )
	                ),
	                this.state.openedAdd && _react2.default.createElement(
	                  'form',
	                  null,
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'row col-lg-12' },
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'form-group' },
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'form-row' },
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'form-group col-md-3' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            ' Name ',
	                            _react2.default.createElement(
	                              'span',
	                              { className: 'astrick' },
	                              '*'
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'form-group col-md-9' },
	                          _react2.default.createElement('input', { type: 'text', 'class': 'form-control', name: 'name', onChange: this.handleChange })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'form-row' },
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'form-group col-md-3' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            ' Content ',
	                            _react2.default.createElement(
	                              'span',
	                              { className: 'astrick' },
	                              '*'
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'form-group col-md-9' },
	                          _react2.default.createElement(_reactDraftWysiwyg.Editor
	                          //defaultEditorState={editorState}
	                          , { value: (0, _draftjsToHtml2.default)((0, _draftJs.convertToRaw)(editorState.getCurrentContent())),
	                            editorState: consigne,
	                            toolbarClassName: 'toolbarClassName',
	                            wrapperClassName: 'wrapperClassName',
	                            editorClassName: 'editorClassName',
	                            onEditorStateChange: this.onChange.bind(this)
	                            //onEditorStateChange={(consigne) => {this.setState({consigne})}}
	                          })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'form-row' },
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'form-group col-md-3' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            'Type'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'form-group col-md-9' },
	                          _react2.default.createElement(
	                            'select',
	                            { name: 'type', 'class': 'form-control', onChange: this.handleChange },
	                            _react2.default.createElement(
	                              'option',
	                              { value: 'ticker' },
	                              'Ticker'
	                            ),
	                            _react2.default.createElement(
	                              'option',
	                              { value: 'text' },
	                              'Only a Static Text'
	                            ),
	                            _react2.default.createElement(
	                              'option',
	                              { value: 'notification' },
	                              'Notification'
	                            ),
	                            _react2.default.createElement(
	                              'option',
	                              { value: 'comingsoon' },
	                              'comingsoon'
	                            ),
	                            _react2.default.createElement(
	                              'option',
	                              { value: 'warning' },
	                              'Warning'
	                            )
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'form-row' },
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'form-group col-md-3' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            'Order'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'form-group col-md-9' },
	                          _react2.default.createElement('input', { type: 'text', 'class': 'form-control', name: 'order', onChange: this.handleChange })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'form-group row' },
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'col-sm-10' },
	                          _react2.default.createElement(
	                            'button',
	                            { type: 'button', onClick: this.saveSiteContent, 'class': 'btn btn-primary btn-sm' },
	                            'Save'
	                          )
	                        )
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'table-responsive pt-3' },
	                  _react2.default.createElement(
	                    'table',
	                    { id: 'tablebw' },
	                    _react2.default.createElement(
	                      'thead',
	                      { 'class': 'thead-dark' },
	                      _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'S.No'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Name'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Type'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Status'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Action'
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'tbody',
	                      null,
	                      cmssiteList.map(function (item, i) {
	
	                        return _react2.default.createElement(
	                          'tr',
	                          null,
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            i + 1
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.name
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.type
	                          ),
	                          _react2.default.createElement('td', { dangerouslySetInnerHTML: { __html: item.status } }),
	                          _react2.default.createElement('td', { dangerouslySetInnerHTML: { __html: item.action } })
	                        );
	                      })
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return cmsSiteContents;
	}(_react.Component);
	
	exports.default = cmsSiteContents;

/***/ },
/* 909 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import { Editor } from '@tinymce/tinymce-react';
	
	
	var cmsSpecialGuests = function (_Component) {
	  _inherits(cmsSpecialGuests, _Component);
	
	  function cmsSpecialGuests(props) {
	    _classCallCheck(this, cmsSpecialGuests);
	
	    var _this = _possibleConstructorReturn(this, (cmsSpecialGuests.__proto__ || Object.getPrototypeOf(cmsSpecialGuests)).call(this, props));
	
	    _this.getSpecialPageList = function () {
	      var _this$state$auth_data = _this.state.auth_data,
	          login_id = _this$state$auth_data.login_id,
	          role = _this$state$auth_data.role;
	
	      var ins = JSON.stringify({
	        vendor_id: login_id,
	        role: role
	      });
	      (0, _FetchCall.getSpecialPageList)(ins).then(function (res) {
	        if (res.status == 1) {
	          _this.setState({
	            pageList: res.data
	
	          });
	        } else {
	          _this.setState({
	            pageList: []
	          });
	        }
	      });
	    };
	
	    var url = new URL(window.location.href);
	    var location = url.searchParams.get("location");
	    var auth_data = JSON.parse(localStorage.getItem("user_data"));
	    _this.state = {
	      logged: localStorage.getItem("authentication"),
	      auth_data: JSON.parse(localStorage.getItem("user_data")),
	      location: location ? location : auth_data.access_location ? auth_data.access_location : 'Bengaluru',
	      pageList: []
	    };
	
	    _this.getSpecialPageList();
	    return _this;
	  }
	
	  _createClass(cmsSpecialGuests, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	
	      var THIS = this;
	      (0, _jquery2.default)(document).on('click', '.remove_maili', function () {
	        var delete_id = (0, _jquery2.default)(this).data("id");
	        THIS.setState({
	          delete_id: delete_id
	        });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var pageList = this.state.pageList;
	
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'col-lg-12 grid-margin stretch-card' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card-body' },
	                _react2.default.createElement(
	                  'h4',
	                  { 'class': 'card-title' },
	                  'BeWise Special Promoted Pages'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'float-right' },
	                  _react2.default.createElement(
	                    'a',
	                    { href: '/cms/news/addnews', 'class': 'btn btn-primary btn-sm' },
	                    'Add New'
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'table-responsive pt-3' },
	                  _react2.default.createElement(
	                    'table',
	                    { id: 'tablebw' },
	                    _react2.default.createElement(
	                      'thead',
	                      { 'class': 'thead-dark' },
	                      _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'S.No'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Page Title'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Date'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'By'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Status'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Action'
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'tbody',
	                      null,
	                      pageList.map(function (item, i) {
	
	                        return _react2.default.createElement(
	                          'tr',
	                          null,
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            i + 1
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.page_title
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.created_date
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.created_by
	                          ),
	                          _react2.default.createElement('td', { dangerouslySetInnerHTML: { __html: item.status } }),
	                          _react2.default.createElement('td', { dangerouslySetInnerHTML: { __html: item.action } })
	                        );
	                      })
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return cmsSpecialGuests;
	}(_react.Component);
	
	exports.default = cmsSpecialGuests;

/***/ },
/* 910 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FetchCall = __webpack_require__(4);
	
	var _universalCookie = __webpack_require__(135);
	
	var _universalCookie2 = _interopRequireDefault(_universalCookie);
	
	var _reactRecaptcha = __webpack_require__(170);
	
	var _reactRecaptcha2 = _interopRequireDefault(_reactRecaptcha);
	
	var _constant = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CourseLogin = function (_Component) {
	    _inherits(CourseLogin, _Component);
	
	    function CourseLogin(props) {
	        _classCallCheck(this, CourseLogin);
	
	        var cookies = new _universalCookie2.default();
	
	        var _this = _possibleConstructorReturn(this, (CourseLogin.__proto__ || Object.getPrototypeOf(CourseLogin)).call(this, props));
	
	        _this.recaptchaLoaded = function (e) {
	            console.log('Successfully loaded');
	        };
	
	        _this.verifyCallback = function (response) {
	            if (response) {
	                _this.setState({
	                    isVerified: true,
	                    disabled: false
	                });
	            }
	        };
	
	        _this.handleChange = function (e) {
	            _this.setState(_defineProperty({}, e.target.name, e.target.value));
	        };
	
	        _this.handleChangeOtp = function (e) {
	            _this.setState(_defineProperty({}, e.target.name, e.target.value.slice(0, e.target.maxLength)));
	        };
	
	        _this.handleSubmitLogin = function (e) {
	            e.preventDefault();
	
	            var ins = JSON.stringify({
	                email_id: _this.state.email_id,
	                password: _this.state.password
	            });
	            (0, _FetchCall.LoginCourse)(ins).then(function (res) {
	                if (res.status === 1) {
	
	                    console.log(JSON.stringify(res.auth_data));
	
	                    localStorage.setItem('user_data', JSON.stringify(res.auth_data));
	                    localStorage.setItem('role', JSON.stringify(res.auth_data));
	                    localStorage.setItem('authentication', true);
	                    _this.setState({ logged: true, nouser: false });
	
	                    setTimeout(function () {
	                        window.location.replace("/courses/dashboard");
	                    }, 1000);
	                } else {
	                    _this.setState({ nouser: true });
	                }
	            });
	        };
	
	        _this.state = {
	            email_id: '',
	            password: '',
	            otp: '',
	            verify_otp: true,
	            auth_data: '',
	            user_id: '',
	            logged: false,
	            phone_number: '',
	            isVerified: false,
	            showPassword: false,
	            disabled: true,
	            role: "",
	            otp_check: cookies.get('otpVerified') ? cookies.get('otpVerified') : false
	        };
	        _this.recaptchaLoaded = _this.recaptchaLoaded.bind(_this);
	        _this.verifyCallback = _this.verifyCallback.bind(_this);
	        return _this;
	    }
	
	    _createClass(CourseLogin, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	
	            var logged = localStorage.getItem("authentication");
	            var auth_data = JSON.parse(localStorage.getItem("user_data"));
	            console.log('auth_data.role', logged);
	
	            if (logged === 'true' && auth_data !== 'null') {
	                window.location.href = '/courses/dashboard';
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	
	            return _react2.default.createElement(
	                'div',
	                { 'class': 'container-fluid page-body-wrapper full-page-wrapper' },
	                _react2.default.createElement(
	                    'div',
	                    { 'class': 'content-wrapper d-flex align-items-center auth px-0' },
	                    _react2.default.createElement(
	                        'div',
	                        { 'class': 'row w-100 mx-0' },
	                        _react2.default.createElement(
	                            'div',
	                            { 'class': 'col-lg-4 mx-auto' },
	                            _react2.default.createElement(
	                                'div',
	                                { 'class': 'auth-form-light text-left py-5 px-4 px-sm-5' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'brand-logo' },
	                                    _react2.default.createElement('img', { src: '../../images/bewiseLogo.png', alt: 'BeWise Logo' })
	                                ),
	                                _react2.default.createElement(
	                                    'h4',
	                                    null,
	                                    'Hello! let\'s get started'
	                                ),
	                                _react2.default.createElement(
	                                    'h6',
	                                    { 'class': 'font-weight-light' },
	                                    'Sign in to manage courses.'
	                                ),
	                                _react2.default.createElement(
	                                    'form',
	                                    { 'class': 'pt-3', onSubmit: this.handleSubmitLogin, autoComplete: 'off', className: 'login-form', action: '#' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'form-group' },
	                                        _react2.default.createElement('input', { type: 'email', name: 'email_id', 'class': 'form-control form-control-lg', id: 'email_id', placeholder: 'Email Id', onChange: this.handleChange })
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'form-group' },
	                                        _react2.default.createElement('input', { type: 'password', name: 'password', 'class': 'form-control form-control-lg', id: 'password', placeholder: 'Password', onChange: this.handleChange })
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'form-group' },
	                                        _react2.default.createElement(_reactRecaptcha2.default, {
	                                            sitekey: _constant.GOOGLE_CAPTCHA_SITE_KEY,
	                                            render: 'explicit',
	                                            onloadCallback: this.recaptchaLoaded,
	                                            verifyCallback: this.verifyCallback
	                                        })
	                                    ),
	                                    !this.state.nouser && this.state.logged && _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'alert alert-success', role: 'alert' },
	                                        'Successful. You are logged in.'
	                                    ),
	                                    this.state.nouser && _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'alert alert-danger', role: 'alert' },
	                                        'User does not exist. Please Sign Up or Contact @BeWise'
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'mt-3' },
	                                        _react2.default.createElement(
	                                            'button',
	                                            { type: 'submit', className: 'btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn' },
	                                            'SIGN IN'
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'my-2 d-flex justify-content-between align-items-center' },
	                                        _react2.default.createElement('div', { 'class': 'form-check' })
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return CourseLogin;
	}(_react.Component);
	
	exports.default = CourseLogin;

/***/ },
/* 911 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _courselayout = __webpack_require__(188);
	
	var _courselayout2 = _interopRequireDefault(_courselayout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _reactstrap = __webpack_require__(17);
	
	__webpack_require__(18);
	
	var _reactNotifications = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import { Editor } from '@tinymce/tinymce-react';
	
	
	var courseDashboard = function (_Component) {
	    _inherits(courseDashboard, _Component);
	
	    function courseDashboard(props) {
	        _classCallCheck(this, courseDashboard);
	
	        var _this = _possibleConstructorReturn(this, (courseDashboard.__proto__ || Object.getPrototypeOf(courseDashboard)).call(this, props));
	
	        _this.smallPreview = function (e) {
	            _this.setState({ smallpreview: true });
	        };
	
	        _this.cancelPop1 = function (e) {
	            _this.setState({ smallpreview: false });
	        };
	
	        _this.cancelPop2 = function (e) {
	            _this.setState({ detailpreview: false });
	        };
	
	        _this.detailPreview = function (e) {
	            _this.setState({ detailpreview: true });
	        };
	
	        _this.handleFile = function (e) {
	            var propName = e.target.name;
	            var files = e.target.files[0];
	            _this.setState(_defineProperty({}, propName, files));
	        };
	
	        _this.handleChange = function (e) {
	            var propName = e.target.name;
	            var propValue = e.target.value;
	
	            _this.setState(_defineProperty({}, propName, propValue));
	        };
	
	        _this.submitCourse = function (e) {
	            var id = _this.state.auth_data.id;
	
	
	            var req = {
	                provider_id: id,
	                course_name: _this.state.course_name,
	                course_description: _this.state.course_desc,
	                course_duration_hrs: _this.state.dur_hrs,
	                course_duration_months: _this.state.dur_months,
	                course_duration_years: _this.state.dur_years,
	                course_duration_days: _this.state.dur_days,
	                course_eligibility: _this.state.course_eligibility,
	                course_category: _this.state.course_category,
	                course_level_category: _this.state.course_level_category,
	                course_certification: _this.state.course_certificate_for,
	                course_certification_other: _this.state.course_certificate_for_others,
	                course_fee: _this.state.course_fee_value,
	                course_fee_currency: _this.state.course_fee_currency,
	                course_fee_per: _this.state.course_fee_per,
	
	                course_moreinfo_phone: _this.state.course_moreinfo_phone,
	                course_moreinfo_email: _this.state.course_moreinfo_email,
	                course_apply_url: _this.state.apply_url,
	                course_banner: _this.state.course_banner,
	                course_brochure: _this.state.course_brochure,
	                course_certification_banner: _this.state.course_certification_banner,
	                course_type: _this.state.course_type
	            };
	
	            (0, _FetchCall.saveCourse)(req).then(function (res) {
	
	                if (res.status === 1) {
	                    //alert("Courses added");
	                    _reactNotifications.NotificationManager.success(res.message);
	                    setTimeout(function () {
	                        window.location.replace('/courses/listcourses');
	                    }, 1000);
	                } else {
	                    //alert("error");
	                    _reactNotifications.NotificationManager.error(res.message);
	                }
	            });
	        };
	
	        _this.state = {
	            logged: localStorage.getItem("authentication"),
	            auth_data: JSON.parse(localStorage.getItem("user_data")),
	            course_brochure: '',
	            smallpreview: false,
	            detailpreview: false,
	            course_certificate_for_others: '',
	            course_apply_url: '',
	            course_fee_value: 0,
	            course_fee_currency: '',
	            course_fee_per: ''
	        };
	        return _this;
	    }
	
	    _createClass(courseDashboard, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {}
	    }, {
	        key: 'render',
	        value: function render() {
	
	            return _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _react2.default.createElement(
	                    _courselayout2.default,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { 'class': 'row ' },
	                        _react2.default.createElement(
	                            'div',
	                            { 'class': 'col-xl-12  nopadding' },
	                            _react2.default.createElement(
	                                'div',
	                                { 'class': 'wallpaper', style: { backgroundImage: 'url(\'../assets/books.jpg\')' } },
	                                _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'courseslogan' },
	                                    _react2.default.createElement(
	                                        'h3',
	                                        null,
	                                        'List your course'
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        null,
	                                        'Help teachers learn and upskill with your courses'
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { 'class': 'addformcourse' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'boxedform' },
	                                    _react2.default.createElement(
	                                        'h3',
	                                        null,
	                                        'Tell us about your course'
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'form-row' },
	                                        _react2.default.createElement(
	                                            'label',
	                                            null,
	                                            'Course name'
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'form-group' },
	                                            _react2.default.createElement('input', { type: 'text', name: 'course_name', 'class': 'inputcls', onChange: this.handleChange })
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'form-row' },
	                                        _react2.default.createElement(
	                                            'label',
	                                            null,
	                                            'Course description'
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'form-group' },
	                                            _react2.default.createElement('textarea', { name: 'course_desc', 'class': 'inputcls', rows: '5', onChange: this.handleChange })
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'form-row' },
	                                        _react2.default.createElement(
	                                            'label',
	                                            null,
	                                            'Course Category'
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'form-group' },
	                                            _react2.default.createElement(
	                                                'select',
	                                                { name: 'course_level_category', 'class': 'inputcls selectlist', onChange: this.handleChange },
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: '' },
	                                                    'Select Category'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'Entry Level' },
	                                                    'Entry Level'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'Intermediate' },
	                                                    'Intermediate'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'Leadership' },
	                                                    'Leadership'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'Principals' },
	                                                    'Principals'
	                                                )
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'form-row' },
	                                        _react2.default.createElement(
	                                            'label',
	                                            null,
	                                            'Course Type'
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'form-group' },
	                                            _react2.default.createElement(
	                                                'select',
	                                                { name: 'course_type', 'class': 'inputcls selectlist', onChange: this.handleChange },
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: '' },
	                                                    'Select Type'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'free' },
	                                                    'Free'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'paid' },
	                                                    'Paid'
	                                                )
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'form-row' },
	                                        _react2.default.createElement(
	                                            'label',
	                                            null,
	                                            'Course Fee '
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'form-group' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { 'class': 'durationflx' },
	                                                _react2.default.createElement(
	                                                    'select',
	                                                    { name: 'course_fee_currency', 'class': 'inputcls selectlist', onChange: this.handleChange },
	                                                    _react2.default.createElement(
	                                                        'option',
	                                                        { value: '' },
	                                                        'Select Currency'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'option',
	                                                        { value: 'Rs.' },
	                                                        'Indian Rupee'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'option',
	                                                        { value: '$.' },
	                                                        'US Dollar'
	                                                    )
	                                                ),
	                                                _react2.default.createElement('input', { type: 'text', name: 'course_fee_value', 'class': 'inputcls', placeholder: 'Price', onChange: this.handleChange }),
	                                                _react2.default.createElement(
	                                                    'select',
	                                                    { name: 'course_fee_per', 'class': 'inputcls selectlist', onChange: this.handleChange },
	                                                    _react2.default.createElement(
	                                                        'option',
	                                                        { value: '' },
	                                                        'Fee per?'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'option',
	                                                        { value: 'per year' },
	                                                        'Per Year'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'option',
	                                                        { value: 'per month' },
	                                                        'Per month'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'option',
	                                                        { value: 'full course' },
	                                                        'for full course'
	                                                    )
	                                                )
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'form-row' },
	                                        _react2.default.createElement(
	                                            'label',
	                                            null,
	                                            'Course Duration'
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'form-group' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { 'class': 'durationflx' },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { 'class': 'insbox' },
	                                                    _react2.default.createElement('input', { type: 'text', name: 'dur_years', 'class': 'inputcls', onChange: this.handleChange }),
	                                                    ' years'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { 'class': 'insbox' },
	                                                    _react2.default.createElement('input', { type: 'text', name: 'dur_months', 'class': 'inputcls', onChange: this.handleChange }),
	                                                    ' months'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { 'class': 'insbox' },
	                                                    _react2.default.createElement('input', { type: 'text', name: 'dur_days', 'class': 'inputcls', onChange: this.handleChange }),
	                                                    ' days'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { 'class': 'insbox' },
	                                                    _react2.default.createElement('input', { type: 'text', name: 'dur_hrs', 'class': 'inputcls', onChange: this.handleChange }),
	                                                    ' hrs'
	                                                )
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'form-row' },
	                                        _react2.default.createElement(
	                                            'label',
	                                            null,
	                                            'Starting Date '
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'form-group' },
	                                            _react2.default.createElement('input', { type: 'date', name: 'course_start_date', 'class': 'inputcls', onChange: this.handleChange })
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'form-row' },
	                                        _react2.default.createElement(
	                                            'label',
	                                            null,
	                                            'Course Domain'
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'form-group' },
	                                            _react2.default.createElement(
	                                                'select',
	                                                { name: 'course_category', 'class': 'inputcls selectlist', onChange: this.handleChange },
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'Graduate in Education (BA / B.SC etc.)' },
	                                                    'Graduate in Education (BA / B.SC etc.)'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'Post Graduate (MA /M.Sc etc)' },
	                                                    'Post Graduate (MA /M.Sc etc)'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'Engineering Graduate' },
	                                                    'Engineering Graduate'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'Diploma In Education' },
	                                                    'Diploma In Education'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'Bachelors Degree in Education (B.Ed)' },
	                                                    'Bachelors Degree in Education (B.Ed)'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'Masters Degree in Education (M.Ed)' },
	                                                    'Masters Degree in Education (M.Ed)'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'Doctorate (Phd)' },
	                                                    'Doctorate (Phd)'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'Bachelor of Elementray Education (B.EL.Ed)' },
	                                                    'Bachelor of Elementray Education (B.EL.Ed)'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'Bachelor of Arts & Education (BA. B.Ed)' },
	                                                    'Bachelor of Arts & Education (BA. B.Ed)'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'Diploma in Elementary Education (D.EL.Ed)' },
	                                                    'Diploma in Elementary Education (D.EL.Ed)'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'Bachelor of Physical Education (B.P.Ed)' },
	                                                    'Bachelor of Physical Education (B.P.Ed)'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'Master of Philosophy in Education (M.Phil)' },
	                                                    'Master of Philosophy in Education (M.Phil)'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'Bachelor of Library Science (B.Lib)' },
	                                                    'Bachelor of Library Science (B.Lib)'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'Bachelor of Library & Information Sciences (B.Lib.I.Sc)' },
	                                                    'Bachelor of Library & Information Sciences (B.Lib.I.Sc)'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'Masters in Library & Information Sciences (M.Lib.I.Sc)' },
	                                                    'Masters in Library & Information Sciences (M.Lib.I.Sc)'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'Bachelor of Fine Arts (BFA)' },
	                                                    'Bachelor of Fine Arts (BFA)'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'Diploma Program in Special Education (DESCE-MR / DSE / MRW / DHLS etc)' },
	                                                    'Diploma Program in Special Education (DESCE-MR / DSE / MRW / DHLS etc)'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'Post Graduate Diploma in Special Education' },
	                                                    'Post Graduate Diploma in Special Education'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'Graduate in Special Education  (B.Ed - Spl Education)' },
	                                                    'Graduate in Special Education  (B.Ed - Spl Education)'
	                                                )
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'form-row' },
	                                        _react2.default.createElement(
	                                            'label',
	                                            null,
	                                            'Course Image or Banner (if any) '
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'form-group' },
	                                            _react2.default.createElement('input', { type: 'file', name: 'course_banner', 'class': 'inputcls', onChange: this.handleFile })
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'form-row' },
	                                        _react2.default.createElement(
	                                            'label',
	                                            null,
	                                            'Brochure (if any) '
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'form-group' },
	                                            _react2.default.createElement('input', { type: 'file', name: 'course_brochure', 'class': 'inputcls', onChange: this.handleFile })
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'form-row' },
	                                        _react2.default.createElement(
	                                            'label',
	                                            null,
	                                            'Certification for '
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'form-group' },
	                                            _react2.default.createElement(
	                                                'select',
	                                                { name: 'course_certificate_for', 'class': 'inputcls selectlist', onChange: this.handleChange },
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'Central Teachers Eligibliity Test (CTET)' },
	                                                    'Central Teachers Eligibliity Test (CTET)'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'National Eligibility Test (NET / UGC-NET)' },
	                                                    'National Eligibility Test (NET / UGC-NET)'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'Basic Training Certificates' },
	                                                    'Basic Training Certificates'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'Primary Teachers Certificates' },
	                                                    'Primary Teachers Certificates'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'Teachers Training Certificates' },
	                                                    'Teachers Training Certificates'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'Teacher Eligiblity Test (TET)' },
	                                                    'Teacher Eligiblity Test (TET)'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'State Teachers Eligiblity Test (STET)' },
	                                                    'State Teachers Eligiblity Test (STET)'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'Certificate course in Library Sciences' },
	                                                    'Certificate course in Library Sciences'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'Certificate course in Drawing teacher training' },
	                                                    'Certificate course in Drawing teacher training'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'Certificate in Care giving program' },
	                                                    'Certificate in Care giving program'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'Certificate program in Special Education' },
	                                                    'Certificate program in Special Education'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'Certicate Courses in Dance' },
	                                                    'Certicate Courses in Dance'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'Certicate Courses in Arts' },
	                                                    'Certicate Courses in Arts'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'Certificate Courses in Sports' },
	                                                    'Certificate Courses in Sports'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'Certificate Courses in Music & Dance' },
	                                                    'Certificate Courses in Music & Dance'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'Others' },
	                                                    'Others'
	                                                )
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'form-row' },
	                                        _react2.default.createElement(
	                                            'label',
	                                            null,
	                                            'Certification (if Others) '
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'form-group' },
	                                            _react2.default.createElement('input', { type: 'text', name: 'course_certificate_for_others', 'class': 'inputcls', onChange: this.handleChange })
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'form-row' },
	                                        _react2.default.createElement(
	                                            'label',
	                                            null,
	                                            'Certification Sample Preview (if any) '
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'form-group' },
	                                            _react2.default.createElement('input', { type: 'file', name: 'course_certification_banner', 'class': 'inputcls', onChange: this.handleFile })
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'form-row' },
	                                        _react2.default.createElement(
	                                            'label',
	                                            null,
	                                            'Who is eligible? '
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'form-group' },
	                                            _react2.default.createElement('textarea', { name: 'course_eligibility', 'class': 'inputcls', rows: '3', onChange: this.handleChange })
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'form-row' },
	                                        _react2.default.createElement(
	                                            'label',
	                                            null,
	                                            'Contacts'
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'form-group flex flexalignbase' },
	                                            _react2.default.createElement('input', { type: 'text', name: 'course_moreinfo_phone', placeholder: 'Phonenumber', 'class': 'inputcls', onChange: this.handleChange }),
	                                            '\xA0',
	                                            _react2.default.createElement('input', { type: 'email', name: 'course_moreinfo_email', placeholder: 'Email Address', 'class': 'inputcls', onChange: this.handleChange })
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'form-row' },
	                                        _react2.default.createElement(
	                                            'label',
	                                            null,
	                                            'Application URL (Enrollment for this course)'
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'form-group' },
	                                            _react2.default.createElement('input', { type: 'text', name: 'apply_url', 'class': 'inputcls', onChange: this.handleChange })
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'form-row actionbuttons' },
	                                        _react2.default.createElement('input', { type: 'button', name: 'smallpreview', 'class': 'btn-main', value: 'Preview -Thumbnail', onClick: this.smallPreview }),
	                                        '\xA0',
	                                        _react2.default.createElement('input', { type: 'button', name: 'detailpreview', 'class': 'btn-main', value: 'Preview -Detail', onClick: this.detailPreview }),
	                                        '\xA0',
	                                        _react2.default.createElement('input', { type: 'button', name: 'submit', 'class': 'btn-main', value: 'Submit', onClick: this.submitCourse })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'spacer' },
	                                    '\xA0'
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactstrap.Modal,
	                        { isOpen: this.state.smallpreview, className: 'modalpopup' },
	                        _react2.default.createElement(
	                            _reactstrap.ModalHeader,
	                            null,
	                            'Thumbnail view'
	                        ),
	                        _react2.default.createElement(
	                            _reactstrap.ModalBody,
	                            { className: 'p-0' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: "courserow" },
	                                _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'courseicon' },
	                                    _react2.default.createElement('img', { src: "/images/courseicon.png" })
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'courseinfo' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'courseinfo_title' },
	                                        this.state.course_name
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'courseinfo_ins' },
	                                        'Provider Name'
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactstrap.ModalFooter,
	                            null,
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'row' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-12 text-center' },
	                                    _react2.default.createElement(
	                                        'button',
	                                        { className: 'btn btn-sm btn-default', onClick: this.cancelPop1 },
	                                        'Close'
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactstrap.Modal,
	                        { isOpen: this.state.detailpreview, className: 'modalpopup previewcoursedetail' },
	                        _react2.default.createElement(
	                            _reactstrap.ModalHeader,
	                            null,
	                            'Detail view'
	                        ),
	                        _react2.default.createElement(
	                            _reactstrap.ModalBody,
	                            { className: 'p-0' },
	                            _react2.default.createElement(
	                                'div',
	                                { 'class': 'course_detail' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'courseimg' },
	                                    _react2.default.createElement('img', { src: "/images/coursebg.png" })
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'course_title' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'courseinfo_title' },
	                                        this.state.course_name
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'courseinfo_desc' },
	                                        this.state.course_desc
	                                    )
	                                ),
	                                _react2.default.createElement('div', { 'class': 'divider' }),
	                                _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'coursedetailtitle' },
	                                    'Course Detail'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'courseduration' },
	                                    _react2.default.createElement('img', { src: "/images/clock.png" }),
	                                    ' ',
	                                    this.state.course_duration_hrs,
	                                    ' Hours'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'coursecertificates' },
	                                    _react2.default.createElement('img', { src: "/images/certificate.png" }),
	                                    ' Completion Certificate'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'courseapplybutton' },
	                                    _react2.default.createElement(
	                                        'a',
	                                        { href: this.state.course_apply_url, 'class': 'btn btn-main' },
	                                        'Apply to course'
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactstrap.ModalFooter,
	                            null,
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'row' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-12 text-center' },
	                                    _react2.default.createElement(
	                                        'button',
	                                        { className: 'btn btn-sm btn-default', onClick: this.cancelPop2 },
	                                        'Close'
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(_reactNotifications.NotificationContainer, null)
	                )
	            );
	        }
	    }]);
	
	    return courseDashboard;
	}(_react.Component);
	
	exports.default = courseDashboard;

/***/ },
/* 912 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _courselayout = __webpack_require__(188);
	
	var _courselayout2 = _interopRequireDefault(_courselayout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _chart = __webpack_require__(83);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import { Editor } from '@tinymce/tinymce-react';
	
	var doughnutPieOptions = {
	    responsive: true,
	    animation: {
	        animateScale: true,
	        animateRotate: true
	    }
	};
	
	var optionsN = {
	    scales: {
	        yAxes: [{
	            ticks: {
	                beginAtZero: true
	            }
	        }]
	
	    }
	};
	
	var courseDashboard = function (_Component) {
	    _inherits(courseDashboard, _Component);
	
	    function courseDashboard(props) {
	        _classCallCheck(this, courseDashboard);
	
	        var _this = _possibleConstructorReturn(this, (courseDashboard.__proto__ || Object.getPrototypeOf(courseDashboard)).call(this, props));
	
	        _this.setVisitors = function (data) {
	
	            var ctx = document.getElementById('barChartVisitors');
	            var myChart = new _chart.Chart(ctx, {
	                type: 'bar',
	                data: data,
	                options: optionsN
	            });
	        };
	
	        _this.setLike = function (data) {
	
	            var ctx = document.getElementById('barChartLikeFollows');
	            var myChart = new _chart.Chart(ctx, {
	                type: 'bar',
	                data: data,
	                options: optionsN
	            });
	        };
	
	        _this.setAfterschoolChart = function (data) {
	
	            var ctx = document.getElementById('afterschoolChart');
	            var myChart = new _chart.Chart(ctx, {
	                type: 'doughnut',
	                data: data,
	                options: doughnutPieOptions
	            });
	        };
	
	        _this.setTuitionChart = function (data) {
	
	            var ctx = document.getElementById('tuitionChart');
	            var myChart = new _chart.Chart(ctx, {
	                type: 'doughnut',
	                data: data,
	                options: doughnutPieOptions
	            });
	        };
	
	        _this.setSchoolChart = function (data) {
	
	            var ctx = document.getElementById('schoolChart');
	            var myChart = new _chart.Chart(ctx, {
	                type: 'doughnut',
	                data: data,
	                options: doughnutPieOptions
	            });
	        };
	
	        _this.setPreschoolChart = function (data) {
	
	            var ctx = document.getElementById('preschoolChart');
	            var myChart = new _chart.Chart(ctx, {
	                type: 'doughnut',
	                data: data,
	                options: doughnutPieOptions
	            });
	        };
	
	        _this.setcampChart = function (data) {
	
	            var ctx = document.getElementById('campChart');
	            var myChart = new _chart.Chart(ctx, {
	                type: 'doughnut',
	                data: data,
	                options: doughnutPieOptions
	            });
	        };
	
	        _this.setcommunityChart = function (data) {
	
	            var ctx = document.getElementById('communityChart');
	            var myChart = new _chart.Chart(ctx, {
	                type: 'doughnut',
	                data: data,
	                options: doughnutPieOptions
	            });
	        };
	
	        _this.setbirthdayChart = function (data) {
	
	            var ctx = document.getElementById('birthdayChart');
	            var myChart = new _chart.Chart(ctx, {
	                type: 'doughnut',
	                data: data,
	                options: doughnutPieOptions
	            });
	        };
	
	        _this.state = {
	            auth_data: JSON.parse(localStorage.getItem("user_data")),
	            school_data: []
	        };
	        return _this;
	    }
	
	    _createClass(courseDashboard, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            var req = {
	                url: 'school_data'
	            };
	
	            (0, _FetchCall.adminDashboard)(JSON.stringify(req)).then(function (response) {
	                if (response.status === 1) {
	                    _this2.setSchoolChart(response.result);
	                }
	            });
	
	            this.setState({ user_name: this.state.auth_data.user_name, role: this.state.auth_data.role });
	
	            req.url = 'like_follow_chart';
	            (0, _FetchCall.adminDashboard)(JSON.stringify(req)).then(function (response) {
	
	                if (response.status === 1) {
	                    _this2.setLike(response.result);
	                }
	            });
	
	            req.url = 'vistors_chart';
	            (0, _FetchCall.adminDashboard)(JSON.stringify(req)).then(function (response) {
	
	                if (response.status === 1) {
	                    _this2.setVisitors(response.result);
	                }
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	
	            return _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _react2.default.createElement(
	                    _courselayout2.default,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { 'class': 'row  mt-3' },
	                        _react2.default.createElement(
	                            'div',
	                            { 'class': 'col-xl-6 d-flex grid-margin stretch-card' },
	                            _react2.default.createElement(
	                                'div',
	                                { 'class': 'card' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'card-body' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'd-flex flex-wrap justify-content-between' },
	                                        _react2.default.createElement(
	                                            'strong',
	                                            null,
	                                            ' Hi, Welcome.  you can add your courses here.'
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return courseDashboard;
	}(_react.Component);
	
	exports.default = courseDashboard;

/***/ },
/* 913 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _courselayout = __webpack_require__(188);
	
	var _courselayout2 = _interopRequireDefault(_courselayout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _reactstrap = __webpack_require__(17);
	
	__webpack_require__(18);
	
	var _reactNotifications = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import { Editor } from '@tinymce/tinymce-react';
	
	
	var editCourse = function (_Component) {
	    _inherits(editCourse, _Component);
	
	    function editCourse(props) {
	        _classCallCheck(this, editCourse);
	
	        var _this = _possibleConstructorReturn(this, (editCourse.__proto__ || Object.getPrototypeOf(editCourse)).call(this, props));
	
	        _this.smallPreview = function (e) {
	            _this.setState({ smallpreview: true });
	        };
	
	        _this.cancelPop1 = function (e) {
	            _this.setState({ smallpreview: false });
	        };
	
	        _this.cancelPop2 = function (e) {
	            _this.setState({ detailpreview: false });
	        };
	
	        _this.detailPreview = function (e) {
	            _this.setState({ detailpreview: true });
	        };
	
	        _this.handleFile = function (e) {
	            var propName = e.target.name;
	            var files = e.target.files[0];
	            _this.setState(_defineProperty({}, propName, files));
	        };
	
	        _this.handleChange = function (e) {
	            var propName = e.target.name;
	            var propValue = e.target.value;
	
	            _this.setState(_defineProperty({}, propName, propValue));
	        };
	
	        _this.submitCourse = function (e) {
	            var id = _this.state.auth_data.id;
	
	
	            var req = {
	                id: _this.id,
	                provider_id: id,
	                course_name: _this.state.course_name,
	                course_description: _this.state.course_description,
	                course_duration_hrs: _this.state.course_duration_hrs,
	                course_duration_months: _this.state.course_duration_months,
	                course_duration_years: _this.state.course_duration_years,
	                course_duration_days: _this.state.course_duration_days,
	                course_eligibility: _this.state.course_eligibility,
	                course_category: _this.state.course_category,
	                course_level_category: _this.state.course_level_category,
	                course_certification: _this.state.course_certificate_for,
	                course_certification_other: _this.state.course_certificate_for_others,
	
	                course_fee: _this.state.course_fee,
	                course_fee_currency: _this.state.course_fee_currency,
	                course_fee_per: _this.state.course_fee_per,
	
	                course_moreinfo_phone: _this.state.course_moreinfo_phone,
	                course_moreinfo_email: _this.state.course_moreinfo_email,
	                course_apply_url: _this.state.course_apply_url,
	                course_banner: _this.state.course_banner,
	                course_brochure: _this.state.course_brochure,
	                course_type: _this.state.course_type
	            };
	
	            (0, _FetchCall.updateCourse)(req).then(function (res) {
	
	                if (res.status === 1) {
	                    //alert("Courses added");
	                    _reactNotifications.NotificationManager.success(res.message);
	                    setTimeout(function () {
	                        window.location.replace('/courses/listcourses');
	                    }, 1000);
	                } else {
	                    //alert("error");
	                    _reactNotifications.NotificationManager.error(res.message);
	                }
	            });
	        };
	
	        _this.state = {
	            logged: localStorage.getItem("authentication"),
	            auth_data: JSON.parse(localStorage.getItem("user_data")),
	            course_brochure: '',
	            smallpreview: false,
	            detailpreview: false,
	            course_certificate_for_others: '',
	            course_apply_url: ''
	        };
	        _this.getCourse = _this.getCourse.bind(_this);
	
	        _this.id = _this.props.match.params.id;
	        return _this;
	    }
	
	    _createClass(editCourse, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	
	            this.getCourse();
	        }
	    }, {
	        key: 'getCourse',
	        value: function getCourse() {
	            var _this2 = this;
	
	            var req = JSON.stringify({
	                id: this.id
	            });
	
	            (0, _FetchCall.getCourseById)(req).then(function (res) {
	                if (res.status == 1) {
	                    var data = res.detail;
	                    _this2.setState({
	                        course_name: data.course_name,
	                        course_description: data.course_description,
	                        course_duration_hrs: data.course_duration_hrs,
	                        course_duration_months: data.course_duration_months,
	                        course_duration_years: data.course_duration_years,
	                        course_duration_days: data.course_duration_days,
	                        course_eligibility: data.course_eligibility,
	                        course_category: data.course_category,
	                        course_level_category: data.course_level_category,
	                        course_certification: data.course_certificate_for,
	                        course_certification_other: data.course_certificate_for_others,
	                        course_fee: data.course_fee,
	                        course_fee_currency: data.course_fee_currency,
	                        course_fee_per: data.course_fee_per,
	                        course_moreinfo_phone: data.course_moreinfo_phone,
	                        course_moreinfo_email: data.course_moreinfo_email,
	                        course_apply_url: data.course_apply_url,
	                        course_banner: data.course_banner,
	                        course_brochure: data.course_brochure,
	                        course_type: data.course_type
	
	                    });
	                }
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	
	            return _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _react2.default.createElement(
	                    _courselayout2.default,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { 'class': 'row ' },
	                        _react2.default.createElement(
	                            'div',
	                            { 'class': 'col-xl-12  nopadding' },
	                            _react2.default.createElement(
	                                'div',
	                                { 'class': 'wallpaper', style: { backgroundImage: 'url(\'../../assets/books.jpg\')' } },
	                                _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'courseslogan' },
	                                    _react2.default.createElement(
	                                        'h3',
	                                        null,
	                                        'List your course'
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        null,
	                                        'Help teachers learn and upskill with your courses'
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { 'class': 'addformcourse' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'boxedform' },
	                                    _react2.default.createElement(
	                                        'h3',
	                                        null,
	                                        'Tell us about your course'
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'form-row' },
	                                        _react2.default.createElement(
	                                            'label',
	                                            null,
	                                            'Course name'
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'form-group' },
	                                            _react2.default.createElement('input', { type: 'text', name: 'course_name', 'class': 'inputcls', value: this.state.course_name, onChange: this.handleChange })
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'form-row' },
	                                        _react2.default.createElement(
	                                            'label',
	                                            null,
	                                            'Course description'
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'form-group' },
	                                            _react2.default.createElement('textarea', { name: 'course_description', value: this.state.course_description, 'class': 'inputcls', rows: '5', onChange: this.handleChange })
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'form-row' },
	                                        _react2.default.createElement(
	                                            'label',
	                                            null,
	                                            'Course Category'
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'form-group' },
	                                            _react2.default.createElement(
	                                                'select',
	                                                { name: 'course_level_category', 'class': 'inputcls selectlist', value: this.state.course_level_category, onChange: this.handleChange },
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: '' },
	                                                    'Select Category'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'Entry Level' },
	                                                    'Entry Level'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'Intermediate' },
	                                                    'Intermediate'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'Leadership' },
	                                                    'Leadership'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'Principals' },
	                                                    'Principals'
	                                                )
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'form-row' },
	                                        _react2.default.createElement(
	                                            'label',
	                                            null,
	                                            'Course Type'
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'form-group' },
	                                            _react2.default.createElement(
	                                                'select',
	                                                { name: 'course_type', 'class': 'inputcls selectlist', value: this.state.course_type, onChange: this.handleChange },
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: '' },
	                                                    'Select Type'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'free' },
	                                                    'Free'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'paid' },
	                                                    'Paid'
	                                                )
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'form-row' },
	                                        _react2.default.createElement(
	                                            'label',
	                                            null,
	                                            'Course Fee '
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'form-group' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { 'class': 'durationflx' },
	                                                _react2.default.createElement(
	                                                    'select',
	                                                    { name: 'course_fee_currency', 'class': 'inputcls selectlist', value: this.state.course_fee_currency, onChange: this.handleChange },
	                                                    _react2.default.createElement(
	                                                        'option',
	                                                        { value: '' },
	                                                        'Select Currency'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'option',
	                                                        { value: 'Rs.' },
	                                                        'Indian Rupee'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'option',
	                                                        { value: '$.' },
	                                                        'US Dollar'
	                                                    )
	                                                ),
	                                                _react2.default.createElement('input', { type: 'text', name: 'course_fee', 'class': 'inputcls', value: this.state.course_fee, placeholder: 'Price', onChange: this.handleChange }),
	                                                _react2.default.createElement(
	                                                    'select',
	                                                    { name: 'course_fee_per', 'class': 'inputcls selectlist', value: this.state.course_fee_per, onChange: this.handleChange },
	                                                    _react2.default.createElement(
	                                                        'option',
	                                                        { value: '' },
	                                                        'Fee per?'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'option',
	                                                        { value: 'per year' },
	                                                        'Per Year'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'option',
	                                                        { value: 'per month' },
	                                                        'Per month'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'option',
	                                                        { value: 'full course' },
	                                                        'for full course'
	                                                    )
	                                                )
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'form-row' },
	                                        _react2.default.createElement(
	                                            'label',
	                                            null,
	                                            'Course Duration'
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'form-group' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { 'class': 'durationflx' },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { 'class': 'insbox' },
	                                                    _react2.default.createElement('input', { type: 'text', name: 'course_duration_years', value: this.state.course_duration_years, 'class': 'inputcls', onChange: this.handleChange }),
	                                                    ' years'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { 'class': 'insbox' },
	                                                    _react2.default.createElement('input', { type: 'text', name: 'course_duration_months', value: this.state.course_duration_months, 'class': 'inputcls', onChange: this.handleChange }),
	                                                    ' months'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { 'class': 'insbox' },
	                                                    _react2.default.createElement('input', { type: 'text', name: 'course_duration_hrs', value: this.state.course_duration_hrs, 'class': 'inputcls', onChange: this.handleChange }),
	                                                    ' days'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { 'class': 'insbox' },
	                                                    _react2.default.createElement('input', { type: 'text', name: 'course_duration_days', value: this.state.course_duration_days, 'class': 'inputcls', onChange: this.handleChange }),
	                                                    ' hrs'
	                                                )
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'form-row' },
	                                        _react2.default.createElement(
	                                            'label',
	                                            null,
	                                            'Starting Date '
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'form-group' },
	                                            _react2.default.createElement('input', { type: 'date', name: 'course_start_date', 'class': 'inputcls', value: this.state.course_start_date, onChange: this.handleChange })
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'form-row' },
	                                        _react2.default.createElement(
	                                            'label',
	                                            null,
	                                            'Category'
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'form-group' },
	                                            _react2.default.createElement(
	                                                'select',
	                                                { name: 'course_category', 'class': 'inputcls selectlist', value: this.state.course_category, onChange: this.handleChange },
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'Graduate in Education (BA / B.SC etc.)' },
	                                                    'Graduate in Education (BA / B.SC etc.)'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'Post Graduate (MA /M.Sc etc)' },
	                                                    'Post Graduate (MA /M.Sc etc)'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'Engineering Graduate' },
	                                                    'Engineering Graduate'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'Diploma In Education' },
	                                                    'Diploma In Education'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'Bachelors Degree in Education (B.Ed)' },
	                                                    'Bachelors Degree in Education (B.Ed)'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'Masters Degree in Education (M.Ed)' },
	                                                    'Masters Degree in Education (M.Ed)'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'Doctorate (Phd)' },
	                                                    'Doctorate (Phd)'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'Bachelor of Elementray Education (B.EL.Ed)' },
	                                                    'Bachelor of Elementray Education (B.EL.Ed)'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'Bachelor of Arts & Education (BA. B.Ed)' },
	                                                    'Bachelor of Arts & Education (BA. B.Ed)'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'Diploma in Elementary Education (D.EL.Ed)' },
	                                                    'Diploma in Elementary Education (D.EL.Ed)'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'Bachelor of Physical Education (B.P.Ed)' },
	                                                    'Bachelor of Physical Education (B.P.Ed)'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'Master of Philosophy in Education (M.Phil)' },
	                                                    'Master of Philosophy in Education (M.Phil)'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'Bachelor of Library Science (B.Lib)' },
	                                                    'Bachelor of Library Science (B.Lib)'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'Bachelor of Library & Information Sciences (B.Lib.I.Sc)' },
	                                                    'Bachelor of Library & Information Sciences (B.Lib.I.Sc)'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'Masters in Library & Information Sciences (M.Lib.I.Sc)' },
	                                                    'Masters in Library & Information Sciences (M.Lib.I.Sc)'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'Bachelor of Fine Arts (BFA)' },
	                                                    'Bachelor of Fine Arts (BFA)'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'Diploma Program in Special Education (DESCE-MR / DSE / MRW / DHLS etc)' },
	                                                    'Diploma Program in Special Education (DESCE-MR / DSE / MRW / DHLS etc)'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'Post Graduate Diploma in Special Education' },
	                                                    'Post Graduate Diploma in Special Education'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'Graduate in Special Education  (B.Ed - Spl Education)' },
	                                                    'Graduate in Special Education  (B.Ed - Spl Education)'
	                                                )
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'form-row' },
	                                        _react2.default.createElement(
	                                            'label',
	                                            null,
	                                            'Course Image or Banner (if any) '
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'form-group' },
	                                            _react2.default.createElement('input', { type: 'file', name: 'course_banner', 'class': 'inputcls', onChange: this.handleFile })
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'form-row' },
	                                        _react2.default.createElement(
	                                            'label',
	                                            null,
	                                            'Brochure (if any) '
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'form-group' },
	                                            _react2.default.createElement('input', { type: 'file', name: 'course_brochure', 'class': 'inputcls', onChange: this.handleFile })
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'form-row' },
	                                        _react2.default.createElement(
	                                            'label',
	                                            null,
	                                            'Certificate for '
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'form-group' },
	                                            _react2.default.createElement(
	                                                'select',
	                                                { name: 'course_certificate_for', 'class': 'inputcls selectlist', value: this.state.course_certificate_for, onChange: this.handleChange },
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'Central Teachers Eligibliity Test (CTET)' },
	                                                    'Central Teachers Eligibliity Test (CTET)'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'National Eligibility Test (NET / UGC-NET)' },
	                                                    'National Eligibility Test (NET / UGC-NET)'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'Basic Training Certificates' },
	                                                    'Basic Training Certificates'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'Primary Teachers Certificates' },
	                                                    'Primary Teachers Certificates'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'Teachers Training Certificates' },
	                                                    'Teachers Training Certificates'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'Teacher Eligiblity Test (TET)' },
	                                                    'Teacher Eligiblity Test (TET)'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'State Teachers Eligiblity Test (STET)' },
	                                                    'State Teachers Eligiblity Test (STET)'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'Certificate course in Library Sciences' },
	                                                    'Certificate course in Library Sciences'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'Certificate course in Drawing teacher training' },
	                                                    'Certificate course in Drawing teacher training'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'Certificate in Care giving program' },
	                                                    'Certificate in Care giving program'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'Certificate program in Special Education' },
	                                                    'Certificate program in Special Education'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'Certicate Courses in Dance' },
	                                                    'Certicate Courses in Dance'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'Certicate Courses in Arts' },
	                                                    'Certicate Courses in Arts'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'Certificate Courses in Sports' },
	                                                    'Certificate Courses in Sports'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'Certificate Courses in Music & Dance' },
	                                                    'Certificate Courses in Music & Dance'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'Others' },
	                                                    'Others'
	                                                )
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'form-row' },
	                                        _react2.default.createElement(
	                                            'label',
	                                            null,
	                                            'Certificate for if Others '
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'form-group' },
	                                            _react2.default.createElement('input', { type: 'text', name: 'course_certificate_for_others', value: this.state.course_certificate_for_others, 'class': 'inputcls', onChange: this.handleChange })
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'form-row' },
	                                        _react2.default.createElement(
	                                            'label',
	                                            null,
	                                            'Who is eligible? '
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'form-group' },
	                                            _react2.default.createElement('textarea', { name: 'course_eligibility', 'class': 'inputcls', rows: '3', value: this.state.course_eligibility, onChange: this.handleChange })
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'form-row' },
	                                        _react2.default.createElement(
	                                            'label',
	                                            null,
	                                            'Contacts'
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'form-group flex flexalignbase' },
	                                            _react2.default.createElement('input', { type: 'text', name: 'course_moreinfo_phone', placeholder: 'Phonenumber', value: this.state.course_moreinfo_phone, 'class': 'inputcls', onChange: this.handleChange }),
	                                            '\xA0',
	                                            _react2.default.createElement('input', { type: 'email', name: 'course_moreinfo_email', placeholder: 'Email Address', value: this.state.course_moreinfo_email, 'class': 'inputcls', onChange: this.handleChange })
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'form-row' },
	                                        _react2.default.createElement(
	                                            'label',
	                                            null,
	                                            'Application URL (Enrollment for this course)'
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'form-group' },
	                                            _react2.default.createElement('input', { type: 'text', name: 'course_apply_url', 'class': 'inputcls', value: this.state.course_apply_url, onChange: this.handleChange })
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'form-row actionbuttons' },
	                                        _react2.default.createElement('input', { type: 'button', name: 'smallpreview', 'class': 'btn-main', value: 'Preview -Thumbnail', onClick: this.smallPreview }),
	                                        '\xA0',
	                                        _react2.default.createElement('input', { type: 'button', name: 'detailpreview', 'class': 'btn-main', value: 'Preview -Detail', onClick: this.detailPreview }),
	                                        '\xA0',
	                                        _react2.default.createElement('input', { type: 'button', name: 'submit', 'class': 'btn-main', value: 'Submit', onClick: this.submitCourse })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'spacer' },
	                                    '\xA0'
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactstrap.Modal,
	                        { isOpen: this.state.smallpreview, className: 'modalpopup' },
	                        _react2.default.createElement(
	                            _reactstrap.ModalHeader,
	                            null,
	                            'Thumbnail view'
	                        ),
	                        _react2.default.createElement(
	                            _reactstrap.ModalBody,
	                            { className: 'p-0' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: "courserow" },
	                                _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'courseicon' },
	                                    _react2.default.createElement('img', { src: "/images/courseicon.png" })
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'courseinfo' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'courseinfo_title' },
	                                        this.state.course_name
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'courseinfo_ins' },
	                                        'Provider Name'
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactstrap.ModalFooter,
	                            null,
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'row' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-12 text-center' },
	                                    _react2.default.createElement(
	                                        'button',
	                                        { className: 'btn btn-sm btn-default', onClick: this.cancelPop1 },
	                                        'Close'
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactstrap.Modal,
	                        { isOpen: this.state.detailpreview, className: 'modalpopup previewcoursedetail' },
	                        _react2.default.createElement(
	                            _reactstrap.ModalHeader,
	                            null,
	                            'Detail view'
	                        ),
	                        _react2.default.createElement(
	                            _reactstrap.ModalBody,
	                            { className: 'p-0' },
	                            _react2.default.createElement(
	                                'div',
	                                { 'class': 'course_detail' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'courseimg' },
	                                    _react2.default.createElement('img', { src: "/images/coursebg.png" })
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'course_title' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'courseinfo_title' },
	                                        this.state.course_name
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'courseinfo_desc' },
	                                        this.state.course_desc
	                                    )
	                                ),
	                                _react2.default.createElement('div', { 'class': 'divider' }),
	                                _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'coursedetailtitle' },
	                                    'Course Detail'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'courseduration' },
	                                    _react2.default.createElement('img', { src: "/images/clock.png" }),
	                                    ' ',
	                                    this.state.course_duration_hrs,
	                                    ' Hours'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'coursecertificates' },
	                                    _react2.default.createElement('img', { src: "/images/certificate.png" }),
	                                    ' Completion Certificate'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'courseapplybutton' },
	                                    _react2.default.createElement(
	                                        'a',
	                                        { href: this.state.course_apply_url, 'class': 'btn btn-main' },
	                                        'Apply to course'
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactstrap.ModalFooter,
	                            null,
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'row' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-12 text-center' },
	                                    _react2.default.createElement(
	                                        'button',
	                                        { className: 'btn btn-sm btn-default', onClick: this.cancelPop2 },
	                                        'Close'
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(_reactNotifications.NotificationContainer, null)
	                )
	            );
	        }
	    }]);
	
	    return editCourse;
	}(_react.Component);
	
	exports.default = editCourse;

/***/ },
/* 914 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _courselayout = __webpack_require__(188);
	
	var _courselayout2 = _interopRequireDefault(_courselayout);
	
	var _FetchCall = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import { Editor } from '@tinymce/tinymce-react';
	
	var ListCourse = function (_Component) {
	    _inherits(ListCourse, _Component);
	
	    function ListCourse(props) {
	        _classCallCheck(this, ListCourse);
	
	        var _this = _possibleConstructorReturn(this, (ListCourse.__proto__ || Object.getPrototypeOf(ListCourse)).call(this, props));
	
	        _this.getCourses = function (e) {
	
	            var req = JSON.stringify({
	                id: _this.state.id
	            });
	            (0, _FetchCall.getCoursesbyUser)(req).then(function (res) {
	                if (res.status === 1) {
	                    _this.setState({
	                        list: res.list
	
	                    });
	                }
	            });
	        };
	
	        _this.state = {
	            auth_data: JSON.parse(localStorage.getItem("user_data")),
	            list: []
	        };
	        return _this;
	    }
	
	    _createClass(ListCourse, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.getCourses();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var list = this.state.list;
	
	            return _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _react2.default.createElement(
	                    _courselayout2.default,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { 'class': 'row ' },
	                        _react2.default.createElement(
	                            'div',
	                            { 'class': 'col-xl-12  nopadding' },
	                            _react2.default.createElement(
	                                'div',
	                                { 'class': 'wallpaper', style: { backgroundImage: 'url(\'../assets/books.jpg\')' } },
	                                _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'courseslogan' },
	                                    _react2.default.createElement(
	                                        'h3',
	                                        null,
	                                        'List your course'
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        null,
	                                        'Help teachers learn and upskill with your courses'
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { 'class': 'listcourses' },
	                                _react2.default.createElement(
	                                    'ul',
	                                    { 'class': 'coursesgrid' },
	                                    list.map(function (item, index) {
	
	                                        return _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            _react2.default.createElement(
	                                                'div',
	                                                { 'class': 'crname' },
	                                                item.course_name
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { 'class': 'crdetail' },
	                                                'Type:',
	                                                _react2.default.createElement(
	                                                    'b',
	                                                    null,
	                                                    item.course_type
	                                                ),
	                                                '\xA0|\xA0Category:',
	                                                _react2.default.createElement(
	                                                    'b',
	                                                    null,
	                                                    item.course_category
	                                                ),
	                                                '\xA0',
	                                                item.course_type == 'paid' && _react2.default.createElement(
	                                                    'div',
	                                                    null,
	                                                    'Course Fee:',
	                                                    _react2.default.createElement(
	                                                        'b',
	                                                        null,
	                                                        item.course_fee_currency,
	                                                        item.course_fee
	                                                    )
	                                                ),
	                                                item.course_status == 1 && _react2.default.createElement(
	                                                    'div',
	                                                    { 'class': 'green' },
	                                                    'Approved'
	                                                ),
	                                                item.course_status == 0 && _react2.default.createElement(
	                                                    'div',
	                                                    { 'class': 'orange' },
	                                                    'Waiting for approval'
	                                                ),
	                                                item.course_status == 2 && _react2.default.createElement(
	                                                    'div',
	                                                    { 'class': 'red' },
	                                                    'Rejected'
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { 'class': 'editbtn' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    null,
	                                                    'Views(',
	                                                    item.course_views,
	                                                    ')'
	                                                ),
	                                                ' \xA0|\xA0',
	                                                _react2.default.createElement(
	                                                    'a',
	                                                    { href: "/courses/editcourse/" + item.id },
	                                                    'Edit'
	                                                )
	                                            )
	                                        );
	                                    })
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ListCourse;
	}(_react.Component);
	
	exports.default = ListCourse;

/***/ },
/* 915 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BeWise_CourseSideBar = function (_Component) {
	    _inherits(BeWise_CourseSideBar, _Component);
	
	    function BeWise_CourseSideBar(props) {
	        _classCallCheck(this, BeWise_CourseSideBar);
	
	        var _this = _possibleConstructorReturn(this, (BeWise_CourseSideBar.__proto__ || Object.getPrototypeOf(BeWise_CourseSideBar)).call(this, props));
	
	        _this.state = {
	            user_name: '',
	            logged: localStorage.getItem("authentication"),
	            auth_data: JSON.parse(localStorage.getItem("user_data"))
	        };
	
	        return _this;
	    }
	
	    _createClass(BeWise_CourseSideBar, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	
	            this.setState({ user_name: this.state.auth_data.user_name, role: this.state.auth_data.role });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	
	            return _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _react2.default.createElement(
	                    'nav',
	                    { 'class': 'sidebar sidebar-offcanvas', id: 'sidebar' },
	                    _react2.default.createElement(
	                        'ul',
	                        { 'class': 'nav' },
	                        _react2.default.createElement(
	                            'li',
	                            { 'class': 'nav-item' },
	                            _react2.default.createElement(
	                                'div',
	                                { 'class': 'd-flex sidebar-profile' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'sidebar-profile-image' },
	                                    _react2.default.createElement('img', { src: '/images/faces/face29.png', alt: 'image' }),
	                                    _react2.default.createElement('span', { 'class': 'sidebar-status-indicator' })
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'sidebar-profile-name' },
	                                    _react2.default.createElement(
	                                        'p',
	                                        { 'class': 'sidebar-designation' },
	                                        'welcome',
	                                        _react2.default.createElement(
	                                            'span',
	                                            { 'class': 'loggeduserdisplay' },
	                                            this.state.user_name
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            { 'class': 'nav-item' },
	                            _react2.default.createElement(
	                                'a',
	                                { 'class': 'nav-link', 'data-toggle': 'collapse', href: '#dashboard', 'aria-expanded': 'false', 'aria-controls': 'form-elements' },
	                                _react2.default.createElement('i', { 'class': 'typcn typcn-film menu-icon' }),
	                                _react2.default.createElement(
	                                    'span',
	                                    { 'class': 'menu-title' },
	                                    'Dashboard'
	                                ),
	                                _react2.default.createElement('i', { 'class': 'menu-arrow' })
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { 'class': 'collapse', id: 'dashboard' },
	                                _react2.default.createElement(
	                                    'ul',
	                                    { 'class': 'nav flex-column sub-menu' },
	                                    _react2.default.createElement(
	                                        'li',
	                                        { 'class': 'nav-item' },
	                                        _react2.default.createElement(
	                                            'a',
	                                            { 'class': 'nav-link', id: 'dashboard', href: '/courses/dashboard' },
	                                            'Dashboard'
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'li',
	                                        { 'class': 'nav-item' },
	                                        _react2.default.createElement(
	                                            'a',
	                                            { 'class': 'nav-link', id: 'addcourse', href: '/courses/addcourse' },
	                                            'Add a course'
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'li',
	                                        { 'class': 'nav-item' },
	                                        _react2.default.createElement(
	                                            'a',
	                                            { 'class': 'nav-link', id: 'listcourses', href: '/courses/listcourses' },
	                                            'List courses'
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return BeWise_CourseSideBar;
	}(_react.Component);
	
	exports.default = BeWise_CourseSideBar;

/***/ },
/* 916 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _FetchCall2 = _interopRequireDefault(_FetchCall);
	
	var _draftJs = __webpack_require__(84);
	
	var _tinymceReact = __webpack_require__(69);
	
	var _constant = __webpack_require__(21);
	
	var _axios = __webpack_require__(184);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import { Editor } from '@tinymce/tinymce-react';
	
	var customMails = function (_Component) {
	  _inherits(customMails, _Component);
	
	  function customMails(props) {
	    _classCallCheck(this, customMails);
	
	    var _this = _possibleConstructorReturn(this, (customMails.__proto__ || Object.getPrototypeOf(customMails)).call(this, props));
	
	    _this.sendMail = function () {
	
	      // let contentState = this.state.editorState.getCurrentContent();
	      console.log("when saving..", _this.state.consigne);
	
	      var req = JSON.stringify({
	        mail_name: _this.state.mail_template,
	        mail_subject: _this.state.mail_subject,
	        mail_content: _this.state.mail_content,
	        to: _this.state.to,
	        email_address: _this.state.email_address
	      });
	
	      (0, _FetchCall.sendCustomMail)(req).then(function (response) {
	
	        if (response.status == 1) {
	
	          alert(response.message);
	        } else {
	          alert(response.message);
	        }
	      });
	    };
	
	    _this.uploadImageCallBack = function (e) {
	      var propName = e.target.name;
	      var files = e.target.files;
	      _this.setState(_defineProperty({}, propName, files));
	    };
	
	    _this.handleChange = function (e) {
	
	      _this.setState(_defineProperty({}, e.target.name, e.target.value));
	      if (e.target.name == 'to' && e.target.value == 'individual') {
	        _this.setState({ ifthisemailaddress: true });
	      }
	    };
	
	    _this.state = {
	      errors: [],
	      mailDetail: '',
	      mail_name: '',
	      mail_content: '',
	      mail_subject: '',
	      email_address: '',
	      ifthisemailaddress: false,
	      to: '',
	      editorState: _draftJs.EditorState.createEmpty()
	    };
	
	    _this.id = _this.props.match.params.id ? _this.props.match.params.id : '';
	    //this.getMail = this.getMail.bind(this);
	    _this.sendMail = _this.sendMail.bind(_this);
	    _this.handleEditorChange = _this.handleEditorChange.bind(_this);
	    return _this;
	  }
	
	  _createClass(customMails, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'handleEditorChange',
	    value: function handleEditorChange(value, editor) {
	      this.setState({
	        mail_content: value
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          mail_content = _state.mail_content,
	          editorState = _state.editorState,
	          consigne = _state.consigne,
	          ifthisemailaddress = _state.ifthisemailaddress;
	
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'col-12 grid-margin' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card-body' },
	                _react2.default.createElement(
	                  'h4',
	                  { 'class': 'card-title' },
	                  'Mail - Edit'
	                ),
	                _react2.default.createElement(
	                  'form',
	                  { 'class': 'form-sample' },
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'col-md-6' },
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'form-group row' },
	                        _react2.default.createElement(
	                          'label',
	                          { 'class': 'col-sm-3 col-form-label' },
	                          'Mail Name'
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'col-sm-9' },
	                          _react2.default.createElement('input', { type: 'text', 'class': 'form-control', name: 'mail_name', value: this.state.mail_name, onChange: this.handleChange })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'col-md-6' },
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'form-group row' },
	                        _react2.default.createElement(
	                          'label',
	                          { 'class': 'col-sm-3 col-form-label' },
	                          'Mail Subject'
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'col-sm-9' },
	                          _react2.default.createElement('input', { type: 'text', 'class': 'form-control', name: 'mail_subject', value: this.state.mail_subject, onChange: this.handleChange })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'col-md-6' },
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'form-group row' },
	                        _react2.default.createElement(
	                          'label',
	                          { 'class': 'col-sm-3 col-form-label' },
	                          'To'
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'col-sm-9' },
	                          _react2.default.createElement(
	                            'select',
	                            { 'class': 'form-control', name: 'to', value: this.state.to, onChange: this.handleChange },
	                            _react2.default.createElement(
	                              'option',
	                              { value: 'parents' },
	                              'Parent'
	                            ),
	                            _react2.default.createElement(
	                              'option',
	                              { value: 'partners' },
	                              'Partner'
	                            ),
	                            _react2.default.createElement(
	                              'option',
	                              { value: 'teachers' },
	                              'Teachers'
	                            ),
	                            _react2.default.createElement(
	                              'option',
	                              { value: 'individual' },
	                              'Individual Mail id'
	                            )
	                          )
	                        )
	                      )
	                    ),
	                    ifthisemailaddress && _react2.default.createElement(
	                      'div',
	                      { 'class': 'col-md-6' },
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'form-group row' },
	                        _react2.default.createElement(
	                          'label',
	                          { 'class': 'col-sm-3 col-form-label' },
	                          'Email Address'
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'col-sm-9' },
	                          _react2.default.createElement('input', { type: 'text', 'class': 'form-control', name: 'email_address', value: this.state.email_address, onChange: this.handleChange })
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'col-md-12' },
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'form-group row' },
	                        _react2.default.createElement(
	                          'label',
	                          { 'class': 'col-sm-3 col-form-label' },
	                          'Mail Content'
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'col-sm-12' },
	                          _react2.default.createElement(_tinymceReact.Editor, {
	                            onEditorChange: this.handleEditorChange,
	                            toolbar: {
	                              inline: { inDropdown: true },
	                              list: { inDropdown: true },
	                              textAlign: { inDropdown: true },
	                              link: { inDropdown: true },
	                              history: { inDropdown: true },
	                              image: { uploadCallback: this.uploadImageCallBack, alt: { present: true, mandatory: true } }
	                            },
	                            value: this.state.insight_content,
	                            name: 'insight_content',
	                            apiKey: _constant.TINY_EDITOR,
	                            init: {
	                              height: 300,
	                              theme: "silver",
	                              plugins: ["advlist autolink lists link anchor paste image"],
	                              file_picker_types: "file image media",
	                              toolbar: 'undo redo | formatselect | image| bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | help',
	                              //images_upload_handler: uploadImageCallBackServer
	                              images_upload_handler: function () {
	                                var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(blobInfo, success, failure) {
	                                  var imageFile, _ref2, data;
	
	                                  return _regenerator2.default.wrap(function _callee$(_context) {
	                                    while (1) {
	                                      switch (_context.prev = _context.next) {
	                                        case 0:
	                                          imageFile = new FormData();
	                                          //imageFile.append("files[]", blobInfo.blob());
	
	                                          imageFile.append('image', blobInfo.blob());
	                                          _context.prev = 2;
	                                          _context.next = 5;
	                                          return _axios2.default.post("https://api.bewise.in/api/campaign/mail/uploadeditorimage", imageFile);
	
	                                        case 5:
	                                          _ref2 = _context.sent;
	                                          data = _ref2.data;
	
	                                          success(data.data.link);
	                                          _context.next = 14;
	                                          break;
	
	                                        case 10:
	                                          _context.prev = 10;
	                                          _context.t0 = _context['catch'](2);
	
	                                          console.log(_context.t0);
	                                          return _context.abrupt('return');
	
	                                        case 14:
	                                        case 'end':
	                                          return _context.stop();
	                                      }
	                                    }
	                                  }, _callee, this, [[2, 10]]);
	                                }));
	
	                                function images_upload_handler(_x, _x2, _x3) {
	                                  return _ref.apply(this, arguments);
	                                }
	
	                                return images_upload_handler;
	                              }()
	                            }
	
	                          })
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'col-md-12' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row mb-4 text-right' },
	                        _react2.default.createElement(
	                          'button',
	                          { type: 'button', id: 'btnSubmit',
	                            className: 'btn btn-primary btn-sm', onClick: this.sendMail, style: { display: "block", margin: "auto" } },
	                          'Submit'
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return customMails;
	}(_react.Component);
	
	exports.default = customMails;

/***/ },
/* 917 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _chart = __webpack_require__(83);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var doughnutPieOptions = {
	  responsive: true,
	  animation: {
	    animateScale: true,
	    animateRotate: true
	  }
	};
	
	var optionsN = {
	  scales: {
	    yAxes: [{
	      ticks: {
	        beginAtZero: true
	      }
	    }]
	
	  }
	};
	
	var dashboard = function (_Component) {
	  _inherits(dashboard, _Component);
	
	  function dashboard(props) {
	    _classCallCheck(this, dashboard);
	
	    var _this = _possibleConstructorReturn(this, (dashboard.__proto__ || Object.getPrototypeOf(dashboard)).call(this, props));
	
	    _this.setVisitors = function (data) {
	
	      var ctx = document.getElementById('barChartVisitors');
	      new _chart.Chart(ctx, {
	        type: 'bar',
	        data: data,
	        options: optionsN
	      });
	    };
	
	    _this.setLike = function (data) {
	
	      var ctx = document.getElementById('barChartLikeFollows');
	      new _chart.Chart(ctx, {
	        type: 'bar',
	        data: data,
	        options: optionsN
	      });
	    };
	
	    _this.setAfterschoolChart = function (data) {
	
	      var ctx = document.getElementById('afterschoolChart');
	      new _chart.Chart(ctx, {
	        type: 'doughnut',
	        data: data,
	        options: doughnutPieOptions
	      });
	    };
	
	    _this.setTuitionChart = function (data) {
	
	      var ctx = document.getElementById('tuitionChart');
	      new _chart.Chart(ctx, {
	        type: 'doughnut',
	        data: data,
	        options: doughnutPieOptions
	      });
	    };
	
	    _this.setSchoolChart = function (data) {
	
	      var ctx = document.getElementById('schoolChart');
	      new _chart.Chart(ctx, {
	        type: 'doughnut',
	        data: data,
	        options: doughnutPieOptions
	      });
	    };
	
	    _this.setPreschoolChart = function (data) {
	
	      var ctx = document.getElementById('preschoolChart');
	      new _chart.Chart(ctx, {
	        type: 'doughnut',
	        data: data,
	        options: doughnutPieOptions
	      });
	    };
	
	    _this.setcampChart = function (data) {
	
	      var ctx = document.getElementById('campChart');
	      new _chart.Chart(ctx, {
	        type: 'doughnut',
	        data: data,
	        options: doughnutPieOptions
	      });
	    };
	
	    _this.setcommunityChart = function (data) {
	
	      var ctx = document.getElementById('communityChart');
	      new _chart.Chart(ctx, {
	        type: 'doughnut',
	        data: data,
	        options: doughnutPieOptions
	      });
	    };
	
	    _this.setbirthdayChart = function (data) {
	
	      var ctx = document.getElementById('birthdayChart');
	      new _chart.Chart(ctx, {
	        type: 'doughnut',
	        data: data,
	        options: doughnutPieOptions
	      });
	    };
	
	    _this.state = {
	      auth_data: JSON.parse(localStorage.getItem("user_data")),
	      school_data: [],
	      schoolcounts: 0,
	      tuitioncounts: 0,
	      preschoolcount: 0,
	      afacount: 0,
	      learningcampscount: 0
	    };
	    return _this;
	  }
	
	  _createClass(dashboard, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var req = {
	        url: 'school_data'
	      };
	
	      (0, _FetchCall.adminDashboard)(JSON.stringify(req)).then(function (response) {
	        if (response.status === 1) {
	          _this2.setSchoolChart(response.result);
	        }
	      });
	
	      (0, _FetchCall.schoolCount)().then(function (response) {
	
	        _this2.setState({ schoolcounts: response.total });
	      });
	
	      (0, _FetchCall.tuitionCount)().then(function (response) {
	
	        _this2.setState({ tuitioncounts: response.total });
	      });
	
	      (0, _FetchCall.preschoolCount)().then(function (response) {
	
	        _this2.setState({ preschoolcount: response.total });
	      });
	
	      (0, _FetchCall.afaCount)().then(function (response) {
	
	        _this2.setState({ afacount: response.total });
	      });
	
	      (0, _FetchCall.learningcampCount)().then(function (response) {
	
	        _this2.setState({ learningcampscount: response.total });
	      });
	
	      req.url = 'like_follow_chart';
	      (0, _FetchCall.adminDashboard)(JSON.stringify(req)).then(function (response) {
	
	        if (response.status === 1) {
	          _this2.setLike(response.result);
	        }
	      });
	
	      req.url = 'vistors_chart';
	      (0, _FetchCall.adminDashboard)(JSON.stringify(req)).then(function (response) {
	
	        if (response.status === 1) {
	          _this2.setVisitors(response.result);
	        }
	      });
	
	      this.setState({ user_name: this.state.auth_data.user_name, role: this.state.auth_data.role });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'row  mt-3' },
	            this.state.role === 1 && _react2.default.createElement(
	              'div',
	              { 'class': 'col-lg-12 d-flex grid-margin stretch-card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'card-body' },
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'd-flex flex-wrap justify-content-between' },
	                    _react2.default.createElement(
	                      'h4',
	                      { 'class': 'card-title mb-3' },
	                      'Visual Reports'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'col-12' },
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'col-md-3 mb-3' },
	                          _react2.default.createElement(
	                            'button',
	                            { type: 'button', 'class': 'btn btn-primary w-100 align-items-stretch d-flex' },
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'text text-left py-2' },
	                              _react2.default.createElement(
	                                'h2',
	                                null,
	                                this.state.schoolcounts
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                null,
	                                _react2.default.createElement(
	                                  'span',
	                                  { 'class': 'vr_btntext' },
	                                  'Schools'
	                                ),
	                                _react2.default.createElement(
	                                  'span',
	                                  { 'class': 'text-right' },
	                                  _react2.default.createElement(
	                                    'a',
	                                    { 'class': 'reportlinks', href: '/dashboard/dashboard/bewisetotal' },
	                                    'click to view more reports'
	                                  )
	                                )
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'col-md-3 mb-3' },
	                          _react2.default.createElement(
	                            'button',
	                            { type: 'button', 'class': 'btn btn-primary w-100 align-items-stretch d-flex' },
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'text text-left py-2' },
	                              _react2.default.createElement(
	                                'h2',
	                                null,
	                                this.state.tuitioncounts
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                null,
	                                _react2.default.createElement(
	                                  'span',
	                                  { 'class': 'vr_btntext' },
	                                  'Tuitions'
	                                ),
	                                _react2.default.createElement(
	                                  'span',
	                                  { 'class': 'text-right' },
	                                  _react2.default.createElement(
	                                    'a',
	                                    { 'class': 'reportlinks', href: '/dashboard/dashboard/bewisetotal' },
	                                    'click to view more reports'
	                                  )
	                                )
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'col-md-3 mb-3' },
	                          _react2.default.createElement(
	                            'button',
	                            { type: 'button', 'class': 'btn btn-primary w-100 align-items-stretch d-flex' },
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'text text-left py-2' },
	                              _react2.default.createElement(
	                                'h2',
	                                null,
	                                this.state.preschoolcount
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                null,
	                                _react2.default.createElement(
	                                  'span',
	                                  { 'class': 'vr_btntext' },
	                                  'Preschools'
	                                ),
	                                _react2.default.createElement(
	                                  'span',
	                                  { 'class': 'text-right' },
	                                  _react2.default.createElement(
	                                    'a',
	                                    { 'class': 'reportlinks', href: '/dashboard/dashboard/bewisetotal' },
	                                    'click to view more reports'
	                                  )
	                                )
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'col-md-3 mb-3' },
	                          _react2.default.createElement(
	                            'button',
	                            { type: 'button', 'class': 'btn btn-primary w-100 align-items-stretch d-flex' },
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'text text-left py-2' },
	                              _react2.default.createElement(
	                                'h2',
	                                null,
	                                this.state.afacount
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                null,
	                                _react2.default.createElement(
	                                  'span',
	                                  { 'class': 'vr_btntext' },
	                                  'Afterschool Activities'
	                                ),
	                                _react2.default.createElement(
	                                  'span',
	                                  { 'class': 'text-right' },
	                                  _react2.default.createElement(
	                                    'a',
	                                    { 'class': 'reportlinks', href: '/dashboard/dashboard/bewisetotal' },
	                                    'click to view more reports'
	                                  )
	                                )
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'col-md-3 mb-3' },
	                          _react2.default.createElement(
	                            'button',
	                            { type: 'button', 'class': 'btn btn-primary w-100 align-items-stretch d-flex' },
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'text text-left py-2' },
	                              _react2.default.createElement(
	                                'h2',
	                                null,
	                                this.state.learningcampscount
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                null,
	                                _react2.default.createElement(
	                                  'span',
	                                  { 'class': 'vr_btntext' },
	                                  'Learning Camps'
	                                ),
	                                _react2.default.createElement(
	                                  'span',
	                                  { 'class': 'text-right' },
	                                  _react2.default.createElement(
	                                    'a',
	                                    { 'class': 'reportlinks', href: '/dashboard/dashboard/bewisetotal' },
	                                    'click to view more reports'
	                                  )
	                                )
	                              )
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { 'class': 'col-xl-6 d-flex grid-margin stretch-card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'card-body' },
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'd-flex flex-wrap justify-content-between' },
	                    _react2.default.createElement(
	                      'h4',
	                      { 'class': 'card-title mb-3' },
	                      'Visitors'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'col-12' },
	                      _react2.default.createElement('canvas', { id: 'barChartVisitors' })
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { 'class': 'col-xl-6 d-flex grid-margin stretch-card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'card-body' },
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'd-flex flex-wrap justify-content-between' },
	                    _react2.default.createElement(
	                      'h4',
	                      { 'class': 'card-title mb-3' },
	                      'Likes & Follows'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'col-12' },
	                      _react2.default.createElement('canvas', { id: 'barChartLikeFollows' })
	                    )
	                  )
	                )
	              )
	            ),
	            this.state.role === 1 && _react2.default.createElement(
	              'div',
	              { 'class': 'col-lg-12 d-flex grid-margin stretch-card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'card-body' },
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'd-flex flex-wrap justify-content-between' },
	                    _react2.default.createElement(
	                      'h4',
	                      { 'class': 'card-title mb-3' },
	                      'Waiting for Approvals'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'table-responsive' },
	                    _react2.default.createElement(
	                      'table',
	                      { 'class': 'table' },
	                      _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                          'tr',
	                          null,
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'd-flex' },
	                              _react2.default.createElement(
	                                'div',
	                                null,
	                                _react2.default.createElement(
	                                  'div',
	                                  null,
	                                  ' Testes article'
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'font-weight-bold mt-1' },
	                                  'Article'
	                                )
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            'By',
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'font-weight-bold  mt-1' },
	                              'Udya'
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            'Status',
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'font-weight-bold text-success  mt-1' },
	                              'waiting for approval'
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            'Created Date',
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'font-weight-bold  mt-1' },
	                              '31 Jan 2023'
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            _react2.default.createElement(
	                              'a',
	                              { href: '/cms/insights/edit-blog/8', 'class': 'btn btn-sm btn-secondary' },
	                              'action'
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            this.state.role === 3 && _react2.default.createElement(
	              'div',
	              { 'class': 'col-lg-12 d-flex grid-margin stretch-card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'card-body' },
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'd-flex flex-wrap justify-content-between' },
	                    _react2.default.createElement(
	                      'h4',
	                      { 'class': 'card-title mb-3' },
	                      'Latest Leads'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'table-responsive' },
	                    _react2.default.createElement(
	                      'table',
	                      { 'class': 'table' },
	                      _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                          'tr',
	                          null,
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'd-flex' },
	                              _react2.default.createElement(
	                                'div',
	                                null,
	                                _react2.default.createElement(
	                                  'div',
	                                  null,
	                                  ' From : Test user'
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'font-weight-bold mt-1' },
	                                  'Parent'
	                                )
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            'Created Date',
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'font-weight-bold  mt-1' },
	                              '31 Jan 2023'
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            _react2.default.createElement(
	                              'a',
	                              { href: '#', 'class': 'btn btn-sm btn-secondary' },
	                              'view'
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return dashboard;
	}(_react.Component);
	
	exports.default = dashboard;

/***/ },
/* 918 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var dashboardNew = function (_Component) {
	    _inherits(dashboardNew, _Component);
	
	    function dashboardNew(props) {
	        _classCallCheck(this, dashboardNew);
	
	        var _this = _possibleConstructorReturn(this, (dashboardNew.__proto__ || Object.getPrototypeOf(dashboardNew)).call(this, props));
	
	        _this.state = {
	            school_data: []
	        };
	        return _this;
	    }
	
	    _createClass(dashboardNew, [{
	        key: 'render',
	        value: function render() {
	
	            return _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _react2.default.createElement(
	                    _layout2.default,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { 'class': 'row  mt-3' },
	                        _react2.default.createElement(
	                            'div',
	                            { 'class': 'col-lg-12 grid-margin stretch-card' },
	                            _react2.default.createElement(
	                                'div',
	                                { 'class': 'card' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'card-body' },
	                                    _react2.default.createElement(
	                                        'h4',
	                                        { 'class': 'card-title' },
	                                        'Reports'
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'flexrowitems' },
	                                        _react2.default.createElement('div', { 'class': 'mockup_report_1' })
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return dashboardNew;
	}(_react.Component);
	
	exports.default = dashboardNew;

/***/ },
/* 919 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _chart = __webpack_require__(83);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var doughnutPieOptions = {
	  responsive: true,
	  animation: {
	    animateScale: true,
	    animateRotate: true
	  }
	};
	
	var dashboardV1 = function (_Component) {
	  _inherits(dashboardV1, _Component);
	
	  function dashboardV1(props) {
	    _classCallCheck(this, dashboardV1);
	
	    var _this = _possibleConstructorReturn(this, (dashboardV1.__proto__ || Object.getPrototypeOf(dashboardV1)).call(this, props));
	
	    _this.handleChange = function (e) {
	      _this.setState(_defineProperty({}, e.target.name, e.target.value));
	    };
	
	    _this.setAfterschoolChart = function (data) {
	
	      var ctx = document.getElementById('afterschoolChart');
	      new _chart.Chart(ctx, {
	        type: 'doughnut',
	        data: data,
	        options: doughnutPieOptions
	      });
	    };
	
	    _this.setTuitionChart = function (data) {
	
	      var ctx = document.getElementById('tuitionChart');
	      new _chart.Chart(ctx, {
	        type: 'doughnut',
	        data: data,
	        options: doughnutPieOptions
	      });
	    };
	
	    _this.setSchoolChart = function (data) {
	
	      var ctx = document.getElementById('schoolChart');
	      new _chart.Chart(ctx, {
	        type: 'doughnut',
	        data: data,
	        options: doughnutPieOptions
	      });
	    };
	
	    _this.setPreschoolChart = function (data) {
	
	      var ctx = document.getElementById('preschoolChart');
	      new _chart.Chart(ctx, {
	        type: 'doughnut',
	        data: data,
	        options: doughnutPieOptions
	      });
	    };
	
	    _this.setcampChart = function (data) {
	
	      var ctx = document.getElementById('campChart');
	      new _chart.Chart(ctx, {
	        type: 'doughnut',
	        data: data,
	        options: doughnutPieOptions
	      });
	    };
	
	    _this.setcommunityChart = function (data) {
	
	      var ctx = document.getElementById('communityChart');
	      new _chart.Chart(ctx, {
	        type: 'doughnut',
	        data: data,
	        options: doughnutPieOptions
	      });
	    };
	
	    _this.setbirthdayChart = function (data) {
	
	      var ctx = document.getElementById('birthdayChart');
	      new _chart.Chart(ctx, {
	        type: 'doughnut',
	        data: data,
	        options: doughnutPieOptions
	      });
	    };
	
	    _this.state = {
	      school_data: []
	    };
	    _this.findbest = _this.findbest.bind(_this);
	    return _this;
	  }
	
	  _createClass(dashboardV1, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var req = {
	        url: 'school_data'
	      };
	
	      (0, _FetchCall.adminDashboard)(JSON.stringify(req)).then(function (response) {
	        if (response.status === 1) {
	          _this2.setSchoolChart(response.result);
	        }
	      });
	
	      var req_t = {
	        url: 'tuition_data'
	      };
	
	      (0, _FetchCall.adminDashboard)(JSON.stringify(req_t)).then(function (response) {
	        if (response.status === 1) {
	          _this2.setTuitionChart(response.result);
	        }
	      });
	
	      var req_pre = {
	        url: 'preschool_data'
	      };
	
	      (0, _FetchCall.adminDashboard)(JSON.stringify(req_pre)).then(function (response) {
	        if (response.status === 1) {
	          _this2.setPreschoolChart(response.result);
	        }
	      });
	
	      var req_afa = {
	        url: 'afterschool_data'
	      };
	
	      (0, _FetchCall.adminDashboard)(JSON.stringify(req_afa)).then(function (response) {
	        if (response.status === 1) {
	          _this2.setAfterschoolChart(response.result);
	        }
	      });
	
	      var req_camp = {
	        url: 'camp_data'
	      };
	
	      (0, _FetchCall.adminDashboard)(JSON.stringify(req_camp)).then(function (response) {
	        if (response.status === 1) {
	          _this2.setcampChart(response.result);
	        }
	      });
	
	      var req_com = {
	        url: 'community_data'
	      };
	
	      (0, _FetchCall.adminDashboard)(JSON.stringify(req_com)).then(function (response) {
	        if (response.status === 1) {
	          _this2.setcommunityChart(response.result);
	        }
	      });
	
	      var req_birthday = {
	        url: 'birthday_data'
	      };
	
	      (0, _FetchCall.adminDashboard)(JSON.stringify(req_birthday)).then(function (response) {
	        if (response.status === 1) {
	          _this2.setbirthdayChart(response.result);
	        }
	      });
	    }
	  }, {
	    key: 'findbest',
	    value: function findbest() {
	      var _this3 = this;
	
	      var req = {
	        keyword: this.state.keyword
	      };
	
	      (0, _FetchCall.showresultssearch)(JSON.stringify(req)).then(function (response) {
	        if (response.status === 1) {
	          _this3.setState({ results: response.results });
	        } else {
	          _this3.setState({ results: [] });
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'row  mt-3' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'col-xl-8 d-flex grid-margin stretch-card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'card-body' },
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'd-flex flex-wrap justify-content-between' },
	                    _react2.default.createElement(
	                      'h4',
	                      { 'class': 'card-title mb-3' },
	                      'Vertical User Info'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'col-12' },
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'col-lg-12' },
	                          _react2.default.createElement(
	                            'ul',
	                            { 'class': 'nav nav-tabs' },
	                            _react2.default.createElement(
	                              'li',
	                              null,
	                              _react2.default.createElement(
	                                'a',
	                                { 'data-toggle': 'tab', href: '#home' },
	                                'School'
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'li',
	                              null,
	                              _react2.default.createElement(
	                                'a',
	                                { 'data-toggle': 'tab', href: '#preschoolCharts' },
	                                'Preschool'
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'li',
	                              null,
	                              _react2.default.createElement(
	                                'a',
	                                { 'data-toggle': 'tab', href: '#tuitionCharts' },
	                                'Tuitions'
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'li',
	                              null,
	                              _react2.default.createElement(
	                                'a',
	                                { 'data-toggle': 'tab', href: '#afaCharts' },
	                                'After School'
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'li',
	                              null,
	                              _react2.default.createElement(
	                                'a',
	                                { 'data-toggle': 'tab', href: '#learnincampsCharts' },
	                                'Learning Camps'
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'li',
	                              null,
	                              _react2.default.createElement(
	                                'a',
	                                { 'data-toggle': 'tab', href: '#communityCharts' },
	                                'Community Supports'
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'li',
	                              null,
	                              _react2.default.createElement(
	                                'a',
	                                { 'data-toggle': 'tab', href: '#brithdayChart' },
	                                'Birthday Events'
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'tab-content' },
	                            _react2.default.createElement(
	                              'div',
	                              { id: 'home', 'class': 'tab-pane fade in active' },
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'chartdisblock' },
	                                _react2.default.createElement('canvas', { id: 'schoolChart' })
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                null,
	                                _react2.default.createElement(
	                                  'a',
	                                  { href: '/vertical/school' },
	                                  'Go to page'
	                                )
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { id: 'preschoolCharts', 'class': 'tab-pane fade' },
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'chartdisblock' },
	                                _react2.default.createElement('canvas', { id: 'preschoolChart' })
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                null,
	                                _react2.default.createElement(
	                                  'a',
	                                  { href: '/vertical/preschool' },
	                                  'Go to page'
	                                )
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { id: 'tuitionCharts', 'class': 'tab-pane fade' },
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'chartdisblock' },
	                                _react2.default.createElement('canvas', { id: 'tuitionChart' })
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                null,
	                                _react2.default.createElement(
	                                  'a',
	                                  { href: '/vertical/tuitions' },
	                                  'Go to page'
	                                )
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { id: 'afaCharts', 'class': 'tab-pane fade' },
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'chartdisblock' },
	                                _react2.default.createElement('canvas', { id: 'afterschoolChart' })
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                null,
	                                _react2.default.createElement(
	                                  'a',
	                                  { href: '/vertical/afterschool' },
	                                  'Go to page'
	                                )
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { id: 'learnincampsCharts', 'class': 'tab-pane fade' },
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'chartdisblock' },
	                                _react2.default.createElement('canvas', { id: 'campChart' })
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                null,
	                                _react2.default.createElement(
	                                  'a',
	                                  { href: '/vertical/learningcamps' },
	                                  'Go to page'
	                                )
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { id: 'communityCharts', 'class': 'tab-pane fade' },
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'chartdisblock' },
	                                _react2.default.createElement('canvas', { id: 'communityChart' })
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                null,
	                                _react2.default.createElement(
	                                  'a',
	                                  { href: '/vertical/communitysupport' },
	                                  'Go to page'
	                                )
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { id: 'brithdayChart', 'class': 'tab-pane fade' },
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'chartdisblock' },
	                                _react2.default.createElement('canvas', { id: 'birthdayChart' })
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                null,
	                                _react2.default.createElement(
	                                  'a',
	                                  { href: '/vertical/birthdayevents' },
	                                  'Go to page'
	                                )
	                              )
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { 'class': 'col-xl-4 d-flex grid-margin stretch-card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'card-body' },
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'd-flex flex-wrap justify-content-between' },
	                    _react2.default.createElement(
	                      'h4',
	                      { 'class': 'card-title mb-3' },
	                      'Payments'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'col-12' },
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'mb-5' },
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'mr-1' },
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'text-info mb-1' },
	                            'Total Payments Received'
	                          ),
	                          _react2.default.createElement(
	                            'h2',
	                            { 'class': 'mb-2 mt-2 font-weight-bold' },
	                            'INR 2,87,493'
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'font-weight-bold' },
	                            'Since Last 6 Months'
	                          )
	                        ),
	                        _react2.default.createElement('hr', null)
	                      ),
	                      _react2.default.createElement('canvas', { id: 'barChartStacked' })
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { 'class': 'col-xl-3 d-flex grid-margin stretch-card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'card-body' },
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'd-flex flex-wrap justify-content-between' },
	                    _react2.default.createElement(
	                      'h4',
	                      { 'class': 'card-title mb-3' },
	                      'Recent Payments Made'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'col-12' },
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'col-sm-12' },
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'd-flex justify-content-between mb-4' },
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'font-weight-medium' },
	                              'Customer Name'
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'font-weight-medium' },
	                              'This Month'
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'd-flex justify-content-between mb-4' },
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'text-secondary font-weight-medium' },
	                              'AIMS Institute'
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'small' },
	                              '19999 INR'
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { 'class': 'col-xl-4 d-flex grid-margin stretch-card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'card-body' },
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'd-flex flex-wrap justify-content-between' },
	                    _react2.default.createElement(
	                      'h4',
	                      { 'class': 'card-title mb-3' },
	                      'Recent Leads'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'row' },
	                    _react2.default.createElement('div', { 'class': 'col-12' })
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { 'class': 'col-xl-4 d-flex grid-margin stretch-card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'card-body' },
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'd-flex flex-wrap justify-content-between' },
	                    _react2.default.createElement(
	                      'h4',
	                      { 'class': 'card-title mb-3' },
	                      'Recent Enquiries'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'row' },
	                    _react2.default.createElement('div', { 'class': 'col-12' })
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { 'class': 'col-lg-12 d-flex grid-margin stretch-card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'card-body' },
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'd-flex flex-wrap justify-content-between' },
	                    _react2.default.createElement(
	                      'h4',
	                      { 'class': 'card-title mb-3' },
	                      'Find and Get Detailed Report'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'col-12' },
	                      _react2.default.createElement('input', { type: 'text', name: 'keyword', 'class': 'form-input-cls', onChange: this.handleChange, placeholder: 'Type any text' }),
	                      ' ',
	                      _react2.default.createElement(
	                        'button',
	                        { 'class': 'btn btn-primary btn-sm', onClick: this.findbest },
	                        'Find'
	                      )
	                    ),
	                    this.state.results && this.state.results.length > 0 && _react2.default.createElement(
	                      'div',
	                      { 'class': 'col-12' },
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'results' },
	                        _react2.default.createElement(
	                          'div',
	                          null,
	                          'We found below partners /institutions '
	                        ),
	                        _react2.default.createElement(
	                          'ul',
	                          { 'class': 'result_items' },
	                          this.state.results.map(function (item, index) {
	
	                            return _react2.default.createElement(
	                              'li',
	                              null,
	                              _react2.default.createElement(
	                                'a',
	                                { href: "/dashboard/singlereport/" + item.vendor_id, target: '_blank' },
	                                item.organisation_name
	                              )
	                            );
	                          })
	                        )
	                      )
	                    ),
	                    this.state.results && this.state.results.length === 0 && _react2.default.createElement(
	                      'div',
	                      { 'class': 'results' },
	                      'No data'
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { 'class': 'col-lg-12 d-flex grid-margin stretch-card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'card-body' },
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'd-flex flex-wrap justify-content-between' },
	                    _react2.default.createElement(
	                      'h4',
	                      { 'class': 'card-title mb-3' },
	                      'Recent Artiles published (5)'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'table-responsive' },
	                    _react2.default.createElement(
	                      'table',
	                      { 'class': 'table' },
	                      _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                          'tr',
	                          null,
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'd-flex' },
	                              _react2.default.createElement('img', { 'class': 'img-sm rounded-circle mb-md-0 mr-2', src: 'images/faces/face31.png', alt: 'profile' }),
	                              _react2.default.createElement(
	                                'div',
	                                null,
	                                _react2.default.createElement(
	                                  'div',
	                                  null,
	                                  ' Best Sports in Bengaluru'
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'font-weight-bold mt-1' },
	                                  'Articles'
	                                )
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            'By',
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'font-weight-bold  mt-1' },
	                              'Arpita'
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            'Status',
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'font-weight-bold text-success  mt-1' },
	                              'waiting for approval'
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            'Created Date',
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'font-weight-bold  mt-1' },
	                              '07 Nov 2019'
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            _react2.default.createElement(
	                              'button',
	                              { type: 'button', 'class': 'btn btn-sm btn-secondary' },
	                              'edit actions'
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return dashboardV1;
	}(_react.Component);
	
	exports.default = dashboardV1;

/***/ },
/* 920 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _reactJsPagination = __webpack_require__(33);
	
	var _reactJsPagination2 = _interopRequireDefault(_reactJsPagination);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import Pagination from 'rc-pagination';
	
	
	var afterschoolList = function (_Component) {
	  _inherits(afterschoolList, _Component);
	
	  function afterschoolList(props) {
	    _classCallCheck(this, afterschoolList);
	
	    var _this = _possibleConstructorReturn(this, (afterschoolList.__proto__ || Object.getPrototypeOf(afterschoolList)).call(this, props));
	
	    _this.getTotal = function () {
	      var location = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	
	      var ins = JSON.stringify({
	        vertical: 'afterschool'
	      });
	
	      (0, _FetchCall.getTotalDuplicates)(ins).then(function (res) {
	
	        _this.setState({ loading: true });
	
	        if (res.status == 1) {
	
	          _this.setState({
	
	            total: res.total
	
	          });
	        }
	      });
	    };
	
	    _this.getDuplicateList = function () {
	      var pageNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	
	
	      _this.setState({ activePage: pageNumber });
	
	      var newOffset = pageNumber == 1 ? 0 : (pageNumber - 1) * _this.state.PER_PAGE % _this.state.total;
	
	      var req = JSON.stringify({
	        vertical: 'afterschool',
	        perpage: _this.state.PER_PAGE,
	        offset: newOffset
	      });
	      (0, _FetchCall.getDuplicatesPaged)(req).then(function (res) {
	        if (res.status == 1) {
	          _this.setState({
	            list: res.list
	
	          });
	        } else {
	          _this.setState({
	            list: []
	          });
	        }
	      });
	    };
	
	    _this.state = {
	      logged: localStorage.getItem("authentication"),
	      list: [],
	      PER_PAGE: 15,
	      total: 0,
	      loading: true,
	      searchby: '',
	      activePage: 1,
	      offset: 0
	    };
	
	    return _this;
	  }
	
	  _createClass(afterschoolList, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	
	      var THIS = this;
	      this.getTotal();
	      this.getDuplicateList();
	    }
	  }, {
	    key: 'handlePageChange',
	    value: function handlePageChange(pageNumber) {
	
	      console.log('active page is ' + pageNumber);
	
	      this.setState({ activePage: pageNumber });
	
	      //this.getTotal('bw_schools');
	      this.getDuplicateList(pageNumber);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var list = this.state.list;
	      var _state = this.state,
	          currentPage = _state.currentPage,
	          PER_PAGE = _state.PER_PAGE,
	          totalCount = _state.totalCount,
	          total = _state.total;
	
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'col-lg-12 grid-margin stretch-card' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card-body' },
	                _react2.default.createElement(
	                  'h4',
	                  { 'class': 'card-title' },
	                  'Duplicates - Afterschool Activities'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'table-responsive pt-3' },
	                  _react2.default.createElement(
	                    'table',
	                    { 'class': 'table table-bordered table-striped' },
	                    _react2.default.createElement(
	                      'thead',
	                      { 'class': 'thead-dark' },
	                      _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'S.No'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'School Name'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'City'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Action'
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'tbody',
	                      null,
	                      list.map(function (item, i) {
	
	                        return _react2.default.createElement(
	                          'tr',
	                          null,
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            i + 1
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.organisation_name
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.location
	                          ),
	                          _react2.default.createElement('td', { 'class': 'actionbtns', dangerouslySetInnerHTML: { __html: item.action } })
	                        );
	                      })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'text-center' },
	                  _react2.default.createElement(_reactJsPagination2.default, {
	                    activePage: this.state.activePage,
	                    itemsCountPerPage: PER_PAGE,
	                    totalItemsCount: this.state.total,
	                    pageRangeDisplayed: 5,
	                    activeClass: "pagination__link--active",
	                    onChange: this.handlePageChange.bind(this),
	                    prevPageText: 'previous',
	                    nextPageText: 'next'
	                  })
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return afterschoolList;
	}(_react.Component);
	
	exports.default = afterschoolList;

/***/ },
/* 921 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _reactJsPagination = __webpack_require__(33);
	
	var _reactJsPagination2 = _interopRequireDefault(_reactJsPagination);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import Pagination from 'rc-pagination';
	
	
	var communityList = function (_Component) {
	  _inherits(communityList, _Component);
	
	  function communityList(props) {
	    _classCallCheck(this, communityList);
	
	    var _this = _possibleConstructorReturn(this, (communityList.__proto__ || Object.getPrototypeOf(communityList)).call(this, props));
	
	    _this.getTotal = function () {
	      var location = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	
	      var ins = JSON.stringify({
	        vertical: 'community'
	      });
	
	      (0, _FetchCall.getTotalDuplicates)(ins).then(function (res) {
	
	        _this.setState({ loading: true });
	
	        if (res.status == 1) {
	
	          _this.setState({
	
	            total: res.total
	
	          });
	        }
	      });
	    };
	
	    _this.getDuplicateList = function () {
	      var pageNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	
	
	      _this.setState({ activePage: pageNumber });
	
	      var newOffset = pageNumber == 1 ? 0 : (pageNumber - 1) * _this.state.PER_PAGE % _this.state.total;
	
	      var req = JSON.stringify({
	        vertical: 'community',
	        perpage: _this.state.PER_PAGE,
	        offset: newOffset
	      });
	      (0, _FetchCall.getDuplicatesPaged)(req).then(function (res) {
	        if (res.status == 1) {
	          _this.setState({
	            list: res.list
	
	          });
	        } else {
	          _this.setState({
	            list: []
	          });
	        }
	      });
	    };
	
	    _this.state = {
	      logged: localStorage.getItem("authentication"),
	      list: [],
	      PER_PAGE: 15,
	      total: 0,
	      loading: true,
	      searchby: '',
	      activePage: 1,
	      offset: 0
	    };
	
	    return _this;
	  }
	
	  _createClass(communityList, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	
	      var THIS = this;
	      this.getTotal();
	      this.getDuplicateList();
	    }
	  }, {
	    key: 'handlePageChange',
	    value: function handlePageChange(pageNumber) {
	
	      console.log('active page is ' + pageNumber);
	
	      this.setState({ activePage: pageNumber });
	
	      //this.getTotal('bw_schools');
	      this.getDuplicateList(pageNumber);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var list = this.state.list;
	      var _state = this.state,
	          currentPage = _state.currentPage,
	          PER_PAGE = _state.PER_PAGE,
	          totalCount = _state.totalCount,
	          total = _state.total;
	
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'col-lg-12 grid-margin stretch-card' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card-body' },
	                _react2.default.createElement(
	                  'h4',
	                  { 'class': 'card-title' },
	                  'Duplicates - Community'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'table-responsive pt-3' },
	                  _react2.default.createElement(
	                    'table',
	                    { 'class': 'table table-bordered table-striped' },
	                    _react2.default.createElement(
	                      'thead',
	                      { 'class': 'thead-dark' },
	                      _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'S.No'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'School Name'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'City'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Action'
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'tbody',
	                      null,
	                      list.map(function (item, i) {
	
	                        return _react2.default.createElement(
	                          'tr',
	                          null,
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            i + 1
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.organisation_name
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.location
	                          ),
	                          _react2.default.createElement('td', { 'class': 'actionbtns', dangerouslySetInnerHTML: { __html: item.action } })
	                        );
	                      })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'text-center' },
	                  _react2.default.createElement(_reactJsPagination2.default, {
	                    activePage: this.state.activePage,
	                    itemsCountPerPage: PER_PAGE,
	                    totalItemsCount: this.state.total,
	                    pageRangeDisplayed: 5,
	                    activeClass: "pagination__link--active",
	                    onChange: this.handlePageChange.bind(this),
	                    prevPageText: 'previous',
	                    nextPageText: 'next'
	                  })
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return communityList;
	}(_react.Component);
	
	exports.default = communityList;

/***/ },
/* 922 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _reactJsPagination = __webpack_require__(33);
	
	var _reactJsPagination2 = _interopRequireDefault(_reactJsPagination);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import Pagination from 'rc-pagination';
	
	
	var kidsplayareaList = function (_Component) {
	  _inherits(kidsplayareaList, _Component);
	
	  function kidsplayareaList(props) {
	    _classCallCheck(this, kidsplayareaList);
	
	    var _this = _possibleConstructorReturn(this, (kidsplayareaList.__proto__ || Object.getPrototypeOf(kidsplayareaList)).call(this, props));
	
	    _this.getTotal = function () {
	      var location = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	
	      var ins = JSON.stringify({
	        vertical: 'kidsplayarea'
	      });
	
	      (0, _FetchCall.getTotalDuplicates)(ins).then(function (res) {
	
	        _this.setState({ loading: true });
	
	        if (res.status == 1) {
	
	          _this.setState({
	
	            total: res.total
	
	          });
	        }
	      });
	    };
	
	    _this.getDuplicateList = function () {
	      var pageNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	
	
	      _this.setState({ activePage: pageNumber });
	
	      var newOffset = pageNumber == 1 ? 0 : (pageNumber - 1) * _this.state.PER_PAGE % _this.state.total;
	
	      var req = JSON.stringify({
	        vertical: 'kidsplayarea',
	        perpage: _this.state.PER_PAGE,
	        offset: newOffset
	      });
	      (0, _FetchCall.getDuplicatesPaged)(req).then(function (res) {
	        if (res.status == 1) {
	          _this.setState({
	            list: res.list
	
	          });
	        } else {
	          _this.setState({
	            list: []
	          });
	        }
	      });
	    };
	
	    _this.state = {
	      logged: localStorage.getItem("authentication"),
	      list: [],
	      PER_PAGE: 15,
	      total: 0,
	      loading: true,
	      searchby: '',
	      activePage: 1,
	      offset: 0
	    };
	
	    return _this;
	  }
	
	  _createClass(kidsplayareaList, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	
	      var THIS = this;
	      this.getTotal();
	      this.getDuplicateList();
	    }
	  }, {
	    key: 'handlePageChange',
	    value: function handlePageChange(pageNumber) {
	
	      console.log('active page is ' + pageNumber);
	
	      this.setState({ activePage: pageNumber });
	
	      //this.getTotal('bw_schools');
	      this.getDuplicateList(pageNumber);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var list = this.state.list;
	      var _state = this.state,
	          currentPage = _state.currentPage,
	          PER_PAGE = _state.PER_PAGE,
	          totalCount = _state.totalCount,
	          total = _state.total;
	
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'col-lg-12 grid-margin stretch-card' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card-body' },
	                _react2.default.createElement(
	                  'h4',
	                  { 'class': 'card-title' },
	                  'Duplicates - Kids Play Area'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'table-responsive pt-3' },
	                  _react2.default.createElement(
	                    'table',
	                    { 'class': 'table table-bordered table-striped' },
	                    _react2.default.createElement(
	                      'thead',
	                      { 'class': 'thead-dark' },
	                      _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'S.No'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'School Name'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'City'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Action'
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'tbody',
	                      null,
	                      list.map(function (item, i) {
	
	                        return _react2.default.createElement(
	                          'tr',
	                          null,
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            i + 1
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.organisation_name
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.location
	                          ),
	                          _react2.default.createElement('td', { 'class': 'actionbtns', dangerouslySetInnerHTML: { __html: item.action } })
	                        );
	                      })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'text-center' },
	                  _react2.default.createElement(_reactJsPagination2.default, {
	                    activePage: this.state.activePage,
	                    itemsCountPerPage: PER_PAGE,
	                    totalItemsCount: this.state.total,
	                    pageRangeDisplayed: 5,
	                    activeClass: "pagination__link--active",
	                    onChange: this.handlePageChange.bind(this),
	                    prevPageText: 'previous',
	                    nextPageText: 'next'
	                  })
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return kidsplayareaList;
	}(_react.Component);
	
	exports.default = kidsplayareaList;

/***/ },
/* 923 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _reactJsPagination = __webpack_require__(33);
	
	var _reactJsPagination2 = _interopRequireDefault(_reactJsPagination);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import Pagination from 'rc-pagination';
	
	
	var learningcampsList = function (_Component) {
	  _inherits(learningcampsList, _Component);
	
	  function learningcampsList(props) {
	    _classCallCheck(this, learningcampsList);
	
	    var _this = _possibleConstructorReturn(this, (learningcampsList.__proto__ || Object.getPrototypeOf(learningcampsList)).call(this, props));
	
	    _this.getTotal = function () {
	      var location = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	
	      var ins = JSON.stringify({
	        vertical: 'learningcamps'
	      });
	
	      (0, _FetchCall.getTotalDuplicates)(ins).then(function (res) {
	
	        _this.setState({ loading: true });
	
	        if (res.status == 1) {
	
	          _this.setState({
	
	            total: res.total
	
	          });
	        }
	      });
	    };
	
	    _this.getDuplicateList = function () {
	      var pageNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	
	
	      _this.setState({ activePage: pageNumber });
	
	      var newOffset = pageNumber == 1 ? 0 : (pageNumber - 1) * _this.state.PER_PAGE % _this.state.total;
	
	      var req = JSON.stringify({
	        vertical: 'learningcamps',
	        perpage: _this.state.PER_PAGE,
	        offset: newOffset
	      });
	      (0, _FetchCall.getDuplicatesPaged)(req).then(function (res) {
	        if (res.status == 1) {
	          _this.setState({
	            list: res.list
	
	          });
	        } else {
	          _this.setState({
	            list: []
	          });
	        }
	      });
	    };
	
	    _this.state = {
	      logged: localStorage.getItem("authentication"),
	      list: [],
	      PER_PAGE: 15,
	      total: 0,
	      loading: true,
	      searchby: '',
	      activePage: 1,
	      offset: 0
	    };
	
	    return _this;
	  }
	
	  _createClass(learningcampsList, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	
	      var THIS = this;
	      this.getTotal();
	      this.getDuplicateList();
	    }
	  }, {
	    key: 'handlePageChange',
	    value: function handlePageChange(pageNumber) {
	
	      console.log('active page is ' + pageNumber);
	
	      this.setState({ activePage: pageNumber });
	
	      //this.getTotal('bw_schools');
	      this.getDuplicateList(pageNumber);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var list = this.state.list;
	      var _state = this.state,
	          currentPage = _state.currentPage,
	          PER_PAGE = _state.PER_PAGE,
	          totalCount = _state.totalCount,
	          total = _state.total;
	
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'col-lg-12 grid-margin stretch-card' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card-body' },
	                _react2.default.createElement(
	                  'h4',
	                  { 'class': 'card-title' },
	                  'Duplicates - Learning camps'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'table-responsive pt-3' },
	                  _react2.default.createElement(
	                    'table',
	                    { 'class': 'table table-bordered table-striped' },
	                    _react2.default.createElement(
	                      'thead',
	                      { 'class': 'thead-dark' },
	                      _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'S.No'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'School Name'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'City'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Action'
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'tbody',
	                      null,
	                      list.map(function (item, i) {
	
	                        return _react2.default.createElement(
	                          'tr',
	                          null,
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            i + 1
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.organisation_name
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.location
	                          ),
	                          _react2.default.createElement('td', { 'class': 'actionbtns', dangerouslySetInnerHTML: { __html: item.action } })
	                        );
	                      })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'text-center' },
	                  _react2.default.createElement(_reactJsPagination2.default, {
	                    activePage: this.state.activePage,
	                    itemsCountPerPage: PER_PAGE,
	                    totalItemsCount: this.state.total,
	                    pageRangeDisplayed: 5,
	                    activeClass: "pagination__link--active",
	                    onChange: this.handlePageChange.bind(this),
	                    prevPageText: 'previous',
	                    nextPageText: 'next'
	                  })
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return learningcampsList;
	}(_react.Component);
	
	exports.default = learningcampsList;

/***/ },
/* 924 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _reactJsPagination = __webpack_require__(33);
	
	var _reactJsPagination2 = _interopRequireDefault(_reactJsPagination);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import Pagination from 'rc-pagination';
	
	
	var preSchoolList = function (_Component) {
	  _inherits(preSchoolList, _Component);
	
	  function preSchoolList(props) {
	    _classCallCheck(this, preSchoolList);
	
	    var _this = _possibleConstructorReturn(this, (preSchoolList.__proto__ || Object.getPrototypeOf(preSchoolList)).call(this, props));
	
	    _this.getTotal = function () {
	      var location = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	
	      var ins = JSON.stringify({
	        vertical: 'preschool'
	      });
	
	      (0, _FetchCall.getTotalDuplicates)(ins).then(function (res) {
	
	        _this.setState({ loading: true });
	
	        if (res.status == 1) {
	
	          _this.setState({
	
	            total: res.total
	
	          });
	        }
	      });
	    };
	
	    _this.getDuplicateList = function () {
	      var pageNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	
	
	      _this.setState({ activePage: pageNumber });
	
	      var newOffset = pageNumber == 1 ? 0 : (pageNumber - 1) * _this.state.PER_PAGE % _this.state.total;
	
	      var req = JSON.stringify({
	        vertical: 'preschool',
	        perpage: _this.state.PER_PAGE,
	        offset: newOffset
	      });
	      (0, _FetchCall.getDuplicatesPaged)(req).then(function (res) {
	        if (res.status == 1) {
	          _this.setState({
	            list: res.list
	
	          });
	        } else {
	          _this.setState({
	            list: []
	          });
	        }
	      });
	    };
	
	    _this.state = {
	      logged: localStorage.getItem("authentication"),
	      list: [],
	      PER_PAGE: 15,
	      total: 0,
	      loading: true,
	      searchby: '',
	      activePage: 1,
	      offset: 0
	    };
	
	    return _this;
	  }
	
	  _createClass(preSchoolList, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	
	      var THIS = this;
	      this.getTotal();
	      this.getDuplicateList();
	    }
	  }, {
	    key: 'handlePageChange',
	    value: function handlePageChange(pageNumber) {
	
	      console.log('active page is ' + pageNumber);
	
	      this.setState({ activePage: pageNumber });
	
	      //this.getTotal('bw_schools');
	      this.getDuplicateList(pageNumber);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var list = this.state.list;
	      var _state = this.state,
	          currentPage = _state.currentPage,
	          PER_PAGE = _state.PER_PAGE,
	          totalCount = _state.totalCount,
	          total = _state.total;
	
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'col-lg-12 grid-margin stretch-card' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card-body' },
	                _react2.default.createElement(
	                  'h4',
	                  { 'class': 'card-title' },
	                  'Duplicates - PreSchool'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'table-responsive pt-3' },
	                  _react2.default.createElement(
	                    'table',
	                    { 'class': 'table table-bordered table-striped' },
	                    _react2.default.createElement(
	                      'thead',
	                      { 'class': 'thead-dark' },
	                      _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'S.No'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'School Name'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'City'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Action'
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'tbody',
	                      null,
	                      list.map(function (item, i) {
	
	                        return _react2.default.createElement(
	                          'tr',
	                          null,
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            i + 1
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.organisation_name
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.location
	                          ),
	                          _react2.default.createElement('td', { 'class': 'actionbtns', dangerouslySetInnerHTML: { __html: item.action } })
	                        );
	                      })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'text-center' },
	                  _react2.default.createElement(_reactJsPagination2.default, {
	                    activePage: this.state.activePage,
	                    itemsCountPerPage: PER_PAGE,
	                    totalItemsCount: this.state.total,
	                    pageRangeDisplayed: 5,
	                    activeClass: "pagination__link--active",
	                    onChange: this.handlePageChange.bind(this),
	                    prevPageText: 'previous',
	                    nextPageText: 'next'
	                  })
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return preSchoolList;
	}(_react.Component);
	
	exports.default = preSchoolList;

/***/ },
/* 925 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _reactJsPagination = __webpack_require__(33);
	
	var _reactJsPagination2 = _interopRequireDefault(_reactJsPagination);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import Pagination from 'rc-pagination';
	
	
	var schoolList = function (_Component) {
	  _inherits(schoolList, _Component);
	
	  function schoolList(props) {
	    _classCallCheck(this, schoolList);
	
	    var _this = _possibleConstructorReturn(this, (schoolList.__proto__ || Object.getPrototypeOf(schoolList)).call(this, props));
	
	    _this.getTotal = function () {
	      var location = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	
	      var ins = JSON.stringify({
	        vertical: 'school'
	      });
	
	      (0, _FetchCall.getTotalDuplicates)(ins).then(function (res) {
	
	        _this.setState({ loading: true });
	
	        if (res.status == 1) {
	
	          _this.setState({
	
	            total: res.total
	
	          });
	        }
	      });
	    };
	
	    _this.getDuplicateList = function () {
	      var pageNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	
	
	      _this.setState({ activePage: pageNumber });
	
	      var newOffset = pageNumber == 1 ? 0 : (pageNumber - 1) * _this.state.PER_PAGE % _this.state.total;
	
	      var req = JSON.stringify({
	        vertical: 'school',
	        perpage: _this.state.PER_PAGE,
	        offset: newOffset
	      });
	      (0, _FetchCall.getDuplicatesPaged)(req).then(function (res) {
	        if (res.status == 1) {
	          _this.setState({
	            list: res.list
	
	          });
	        } else {
	          _this.setState({
	            list: []
	          });
	        }
	      });
	    };
	
	    _this.state = {
	      logged: localStorage.getItem("authentication"),
	      list: [],
	      PER_PAGE: 15,
	      total: 0,
	      loading: true,
	      searchby: '',
	      activePage: 1,
	      offset: 0
	    };
	
	    return _this;
	  }
	
	  _createClass(schoolList, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	
	      var THIS = this;
	
	      (0, _jquery2.default)(document).on('click', '.removedup', function () {
	
	        var delete_id = (0, _jquery2.default)(this).data("id");
	        if (confirm("You are sure to delete?") == true) {
	
	          var ins = JSON.stringify({
	            id: delete_id,
	            table: 'school'
	          });
	
	          (0, _FetchCall.removethisItem)(ins).then(function (res) {
	
	            alert(res.message);
	            THIS.getTotal();
	            THIS.getDuplicateList();
	          });
	        }
	      });
	
	      this.getTotal();
	      this.getDuplicateList();
	    }
	  }, {
	    key: 'handlePageChange',
	    value: function handlePageChange(pageNumber) {
	
	      console.log('active page is ' + pageNumber);
	
	      this.setState({ activePage: pageNumber });
	
	      //this.getTotal('bw_schools');
	      this.getDuplicateList(pageNumber);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var list = this.state.list;
	      var _state = this.state,
	          currentPage = _state.currentPage,
	          PER_PAGE = _state.PER_PAGE,
	          totalCount = _state.totalCount,
	          total = _state.total;
	
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'col-lg-12 grid-margin stretch-card' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card-body' },
	                _react2.default.createElement(
	                  'h4',
	                  { 'class': 'card-title' },
	                  'Duplicates - School - (',
	                  this.state.total,
	                  ')'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'table-responsive pt-3' },
	                  _react2.default.createElement(
	                    'table',
	                    { 'class': 'table table-bordered table-striped' },
	                    _react2.default.createElement(
	                      'thead',
	                      { 'class': 'thead-dark' },
	                      _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'S.No'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'School Name'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'City'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Update Date'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Path term'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Action'
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'tbody',
	                      null,
	                      list.map(function (item, i) {
	
	                        return _react2.default.createElement(
	                          'tr',
	                          null,
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            i + 1
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.organisation_name
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.location
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.updated_date
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.path_term
	                          ),
	                          _react2.default.createElement('td', { 'class': 'actionbtns', dangerouslySetInnerHTML: { __html: item.action } })
	                        );
	                      })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'text-center' },
	                  _react2.default.createElement(_reactJsPagination2.default, {
	                    activePage: this.state.activePage,
	                    itemsCountPerPage: PER_PAGE,
	                    totalItemsCount: this.state.total,
	                    pageRangeDisplayed: 5,
	                    activeClass: "pagination__link--active",
	                    onChange: this.handlePageChange.bind(this),
	                    prevPageText: 'previous',
	                    nextPageText: 'next'
	                  })
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return schoolList;
	}(_react.Component);
	
	exports.default = schoolList;

/***/ },
/* 926 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _reactJsPagination = __webpack_require__(33);
	
	var _reactJsPagination2 = _interopRequireDefault(_reactJsPagination);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import Pagination from 'rc-pagination';
	
	
	var tuitionList = function (_Component) {
	  _inherits(tuitionList, _Component);
	
	  function tuitionList(props) {
	    _classCallCheck(this, tuitionList);
	
	    var _this = _possibleConstructorReturn(this, (tuitionList.__proto__ || Object.getPrototypeOf(tuitionList)).call(this, props));
	
	    _this.getTotal = function () {
	      var location = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	
	      var ins = JSON.stringify({
	        vertical: 'tuition'
	      });
	
	      (0, _FetchCall.getTotalDuplicates)(ins).then(function (res) {
	
	        _this.setState({ loading: true });
	
	        if (res.status == 1) {
	
	          _this.setState({
	
	            total: res.total
	
	          });
	        }
	      });
	    };
	
	    _this.getDuplicateList = function () {
	      var pageNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	
	
	      _this.setState({ activePage: pageNumber });
	
	      var newOffset = pageNumber == 1 ? 0 : (pageNumber - 1) * _this.state.PER_PAGE % _this.state.total;
	
	      var req = JSON.stringify({
	        vertical: 'tuition',
	        perpage: _this.state.PER_PAGE,
	        offset: newOffset
	      });
	      (0, _FetchCall.getDuplicatesPaged)(req).then(function (res) {
	        if (res.status == 1) {
	          _this.setState({
	            list: res.list
	
	          });
	        } else {
	          _this.setState({
	            list: []
	          });
	        }
	      });
	    };
	
	    _this.state = {
	      logged: localStorage.getItem("authentication"),
	      list: [],
	      PER_PAGE: 15,
	      total: 0,
	      loading: true,
	      searchby: '',
	      activePage: 1,
	      offset: 0
	    };
	
	    return _this;
	  }
	
	  _createClass(tuitionList, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	
	      var THIS = this;
	
	      (0, _jquery2.default)(document).on('click', '.removedup', function () {
	
	        var delete_id = (0, _jquery2.default)(this).data("id");
	        if (confirm("You are sure to delete?") == true) {
	
	          var ins = JSON.stringify({
	            id: delete_id,
	            table: 'tuition'
	          });
	
	          (0, _FetchCall.removethisItem)(ins).then(function (res) {
	
	            alert(res.message);
	            THIS.getTotal();
	            THIS.getDuplicateList();
	          });
	        }
	      });
	
	      this.getTotal();
	      this.getDuplicateList();
	    }
	  }, {
	    key: 'handlePageChange',
	    value: function handlePageChange(pageNumber) {
	
	      console.log('active page is ' + pageNumber);
	
	      this.setState({ activePage: pageNumber });
	
	      //this.getTotal('bw_schools');
	      this.getDuplicateList(pageNumber);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var list = this.state.list;
	      var _state = this.state,
	          currentPage = _state.currentPage,
	          PER_PAGE = _state.PER_PAGE,
	          totalCount = _state.totalCount,
	          total = _state.total;
	
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'col-lg-12 grid-margin stretch-card' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card-body' },
	                _react2.default.createElement(
	                  'h4',
	                  { 'class': 'card-title' },
	                  'Duplicates - Tuitions (',
	                  this.state.total,
	                  ')'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'table-responsive pt-3' },
	                  _react2.default.createElement(
	                    'table',
	                    { 'class': 'table table-bordered table-striped' },
	                    _react2.default.createElement(
	                      'thead',
	                      { 'class': 'thead-dark' },
	                      _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'S.No'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'School Name'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'City'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Update Date'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Path term'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Action'
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'tbody',
	                      null,
	                      list.map(function (item, i) {
	
	                        return _react2.default.createElement(
	                          'tr',
	                          null,
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            i + 1
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.organisation_name
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.location
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.updated_date
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.path_term
	                          ),
	                          _react2.default.createElement('td', { 'class': 'actionbtns', dangerouslySetInnerHTML: { __html: item.action } })
	                        );
	                      })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'text-center' },
	                  _react2.default.createElement(_reactJsPagination2.default, {
	                    activePage: this.state.activePage,
	                    itemsCountPerPage: PER_PAGE,
	                    totalItemsCount: this.state.total,
	                    pageRangeDisplayed: 5,
	                    activeClass: "pagination__link--active",
	                    onChange: this.handlePageChange.bind(this),
	                    prevPageText: 'previous',
	                    nextPageText: 'next'
	                  })
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return tuitionList;
	}(_react.Component);
	
	exports.default = tuitionList;

/***/ },
/* 927 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _FetchCall2 = _interopRequireDefault(_FetchCall);
	
	var _reactAutosuggest = __webpack_require__(86);
	
	var _reactAutosuggest2 = _interopRequireDefault(_reactAutosuggest);
	
	var _reactDraftWysiwyg = __webpack_require__(127);
	
	__webpack_require__(92);
	
	var _simpleReactValidator = __webpack_require__(28);
	
	var _simpleReactValidator2 = _interopRequireDefault(_simpleReactValidator);
	
	__webpack_require__(18);
	
	var _reactNotifications = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var editPackage = function (_Component) {
	  _inherits(editPackage, _Component);
	
	  function editPackage(props) {
	    _classCallCheck(this, editPackage);
	
	    var _this = _possibleConstructorReturn(this, (editPackage.__proto__ || Object.getPrototypeOf(editPackage)).call(this, props));
	
	    _this.handleCustomeChange = function (e) {
	      var propName = e.target.name;
	      var files = e.target.value;
	      var restriction = _this.state.restriction;
	      restriction[propName] = files;
	      _this.setState({
	        restriction: restriction
	      });
	    };
	
	    _this.package_detail = function (package_id) {
	      var _this$state$auth_data = _this.state.auth_data,
	          login_id = _this$state$auth_data.login_id,
	          role = _this$state$auth_data.role;
	
	      var ins = JSON.stringify({
	        vendor_id: login_id,
	        role: role,
	        path: '/package_list',
	        package_id: package_id
	      });
	      (0, _FetchCall.getPackageDetail)(ins).then(function (res) {
	        if (res.status == 1) {
	          var data = res.details;
	          _this.setState({
	            package_id: data.id,
	            plan_name: data.plan_name,
	            our_offers: data.plan_offer,
	            our_offers_soon: data.plan_soon,
	            analytics_offers: data.analytics_offer,
	            analytics_offers_soon: data.analytics_soon,
	            base_price: data.base_price,
	            discount_percent: data.discount_percent,
	            offer_name: data.offer_name,
	            discount_amount: data.discount_amount,
	            plan_price: data.plan_price,
	            about_words: data.about_words_count,
	            image_counts: data.image_count,
	            current_icon: data.icon ? res.base_url + data.icon : '',
	            head_bottom_color: data.icon_color,
	            restriction: data.restriction ? JSON.parse(data.restriction) : {},
	            plan_type: data.plan_type,
	            write_permission: res.write_permission
	          });
	          _this.updatePrice(data.base_price, data.discount_percent, data.discount_amount, data.plan_price);
	        } else {
	          window.location.href = '/package_list';
	        }
	      });
	    };
	
	    _this.handleChange = function (e) {
	      _this.setState(_defineProperty({}, e.target.name, e.target.value));
	    };
	
	    _this.handleCheck = function (e) {
	      _this.setState(function (prevState) {
	        return {
	          show_upload: !prevState.show_upload
	        };
	      });
	    };
	
	    _this.customChange = function (e, i) {
	      var social_links = _this.state.social_links;
	      if (social_links.length > 0 && social_links[i]) {
	        social_links[i].link = e.target.value;
	      }
	      _this.setState({ social_links: social_links });
	    };
	
	    _this.handleFile = function (e) {
	      var propName = e.target.name;
	      var files = e.target.files[0];
	      _this.setState(_defineProperty({}, propName, files));
	    };
	
	    _this.handleFileMultiple = function (e) {
	      var propName = e.target.name;
	      var files = e.target.files;
	      if (files.length > 2) {
	        files = '';
	        var toastr = window.toastr.error; //warning
	        toastr('', 'Select Article 2 Images Only', {
	          positionClass: "toast-bottom-right",
	          containerId: "toast-bottom-right"
	        });
	      }
	      _this.setState(_defineProperty({}, propName, files));
	    };
	
	    _this.handleSelect = function (e) {
	      var propName = e.target.name;
	      var value = [].concat(_toConsumableArray(e.target.selectedOptions)).map(function (item) {
	        return item.value;
	      });
	      _this.setState(_defineProperty({}, propName, value));
	    };
	
	    _this.onSuggestionsFetchRequested = function (_ref) {
	      var value = _ref.value;
	
	      console.log('came first ', value);
	      var val = _this.escapeRegexCharacters(value.trim());
	      var fetch = JSON.stringify({
	        keyword: val,
	        role: 1
	      });
	      (0, _FetchCall.getAuthorSuggest)(fetch).then(function (res) {
	        if (res.status == 1) {
	          _this.setState({
	            suggestions: res.list
	          });
	        }
	      });
	    };
	
	    _this.onSuggestionsClearRequested = function () {
	      _this.setState({
	        suggestions: []
	      });
	    };
	
	    _this.getSuggestionValue = function (suggestion) {
	      return suggestion.name;
	    };
	
	    _this.onChange = function (event, _ref2) {
	      var newValue = _ref2.newValue,
	          method = _ref2.method;
	
	      _this.setState({
	        insight_author: newValue
	      });
	    };
	
	    _this.handleSubmit = function (e) {
	      _this.setState({
	        btnValue: 'Please Wait...'
	      });
	      e.preventDefault();
	      if (_this.validator.allValid()) {
	        var toastr = '';
	        var insert = {
	          package_id: _this.state.package_id,
	          plan_name: _this.state.plan_name,
	          our_offers: _this.state.our_offers,
	          our_offers_soon: _this.state.our_offers_soon,
	          analytics_offers: _this.state.analytics_offers,
	          analytics_offers_soon: _this.state.analytics_offers_soon,
	          base_price: _this.state.base_price,
	          discount_percent: _this.state.discount_percent,
	          offer_name: _this.state.offer_name,
	          discount_amount: _this.state.discount_amount,
	          plan_price: _this.state.plan_price,
	          about_words: _this.state.about_words,
	          image_counts: _this.state.image_counts,
	          new_icon: _this.state.new_icon,
	          head_bottom_color: _this.state.head_bottom_color,
	          plan_type: _this.state.plan_type,
	          restriction: JSON.stringify(_this.state.restriction)
	        };
	        (0, _FetchCall.updatePackageData)(insert).then(function (response) {
	          if (response.status == 1) {
	            Notification.success(response.message);
	            setTimeout(function () {
	              window.location.href = '/package_list';
	            }, 1000);
	          } else {
	            _this.setState({
	              btnValue: 'Update Package'
	            });
	            Notification.error(response.message);
	            setTimeout(function () {}, 1000);
	          }
	        });
	      } else {
	        _this.validator.showMessages();
	        _this.forceUpdate();
	      }
	    };
	
	    _this.state = {
	      logged: localStorage.getItem("authentication"),
	      auth_data: JSON.parse(localStorage.getItem("user_data")),
	      write_permission: true,
	      package_id: 0,
	      plan_name: '',
	      our_offers: '<ul><li>Edit Here</li></ul>',
	      our_offers_soon: '<ul><li>Edit Here</li></ul>',
	      analytics_offers: '<ul><li>Edit Here</li></ul>',
	      analytics_offers_soon: '<ul><li>Edit Here</li></ul>',
	      base_price: '',
	      discount_percent: '',
	      offer_name: '',
	      discount_amount: '',
	      plan_price: '',
	      about_words: '',
	      image_counts: '',
	      new_icon: '',
	      current_icon: '',
	      head_bottom_color: '',
	      plan_type: '',
	      plan_type_list: [],
	      restriction: {},
	      btnValue: 'Update Package'
	    };
	    _this.id = _this.props.match.params.id ? _this.props.match.params.id : '';
	    _this.validator = new _simpleReactValidator2.default();
	    _this.package_detail = _this.package_detail.bind(_this);
	    _this.getpackageTypeList = _this.getpackageTypeList.bind(_this);
	    return _this;
	  }
	
	  _createClass(editPackage, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	
	      var THIS = this;
	
	      this.package_detail(this.id);
	      this.getpackageTypeList();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      window.jQuery('.selectpicker').selectpicker('refresh');
	    }
	  }, {
	    key: 'getpackageTypeList',
	    value: function getpackageTypeList() {
	      var _this2 = this;
	
	      (0, _FetchCall.getPackageType)(JSON.stringify({ role: 1 })).then(function (res) {
	        if (res.status === 1) {
	          _this2.setState({
	            plan_type_list: res.list
	          });
	        }
	      });
	    }
	  }, {
	    key: 'handleEditorChangeoffer',
	    value: function handleEditorChangeoffer(value, editor) {
	      this.setState({
	        our_offers: value
	      });
	    }
	  }, {
	    key: 'handleEditorChangeofferSoon',
	    value: function handleEditorChangeofferSoon(value, editor) {
	      this.setState({
	        our_offers_soon: value
	      });
	    }
	  }, {
	    key: 'handleEditorChangeanalytics',
	    value: function handleEditorChangeanalytics(value, editor) {
	      this.setState({
	        analytics_offers: value
	      });
	    }
	  }, {
	    key: 'handleEditorChangeanalyticsSoon',
	    value: function handleEditorChangeanalyticsSoon(value, editor) {
	      this.setState({
	        analytics_offers_soon: value
	      });
	    }
	  }, {
	    key: 'handleEditorChange',
	    value: function handleEditorChange(value, editor) {
	      console.log(value);
	      this.setState({
	        insight_content: value
	      });
	    }
	  }, {
	    key: 'escapeRegexCharacters',
	    value: function escapeRegexCharacters(str) {
	      return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	    }
	  }, {
	    key: 'renderSuggestion',
	    value: function renderSuggestion(suggestion) {
	      return _react2.default.createElement(
	        'span',
	        null,
	        suggestion.name
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var restriction = this.state.restriction;
	
	      console.log(restriction);
	      this.validator.purgeFields();
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'col-12 grid-margin' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card-body' },
	                _react2.default.createElement(
	                  'h4',
	                  { 'class': 'card-title' },
	                  'Package - Edit'
	                ),
	                _react2.default.createElement(
	                  'form',
	                  { onSubmit: this.handleSubmit, id: 'package_form' },
	                  _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'form-group col-md-3' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          ' Package Type ',
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'astrick' },
	                            '*'
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'form-group col-md-9' },
	                        _react2.default.createElement(
	                          'select',
	                          { className: 'form-control selectpicker', name: 'plan_type',
	                            value: this.state.plan_type,
	                            onChange: this.handleChange,
	                            title: 'Select' },
	                          this.state.plan_type_list.map(function (item, i) {
	                            return _react2.default.createElement(
	                              'option',
	                              { value: item.id },
	                              item.name
	                            );
	                          })
	                        ),
	                        this.validator.message('Package Type', this.state.plan_type, 'required', { className: 'text-danger' })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'form-group col-md-3' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          ' Package Name ',
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'astrick' },
	                            '*'
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'form-group col-md-9' },
	                        _react2.default.createElement('input', { name: 'plan_name', className: 'form-control', type: 'text', value: this.state.plan_name,
	                          onChange: this.handleChange }),
	                        this.validator.message('Package Name', this.state.plan_name, 'required', { className: 'text-danger' })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'form-group col-md-3' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          ' Package Color ',
	                          _react2.default.createElement(
	                            'small',
	                            null,
	                            '(Name of the color or code)'
	                          ),
	                          ' ',
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'astrick' },
	                            '*'
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'form-group col-md-9' },
	                        _react2.default.createElement('input', { name: 'head_bottom_color',
	                          className: 'form-control',
	                          placeholder: 'Ex: Black or #000',
	                          type: 'text', value: this.state.head_bottom_color,
	                          onChange: this.handleChange }),
	                        this.validator.message('Package Color', this.state.head_bottom_color, 'required', { className: 'text-danger' })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'form-group col-md-3' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          ' Base Price ',
	                          _react2.default.createElement(
	                            'small',
	                            null,
	                            '(INR)'
	                          ),
	                          ' ',
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'astrick' },
	                            '*'
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'form-group col-md-9' },
	                        _react2.default.createElement('input', { name: 'base_price',
	                          className: 'form-control',
	                          placeholder: '0',
	                          step: '0.01', min: '0', type: 'number',
	                          value: this.state.base_price,
	                          onChange: this.handleChange }),
	                        this.validator.message('Base Price', this.state.base_price, 'required', { className: 'text-danger' })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'form-group col-md-3' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          ' Offer Name',
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'astrick' },
	                            '*'
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'form-group col-md-9' },
	                        _react2.default.createElement('input', { name: 'discount_percent',
	                          className: 'form-control', type: 'text',
	                          value: this.state.offer_name,
	                          onChange: this.handleChange }),
	                        this.validator.message('Offer Name', this.state.offer_name, '', { className: 'text-danger' })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'form-group col-md-3' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          ' Discount ',
	                          _react2.default.createElement(
	                            'small',
	                            null,
	                            '(%)'
	                          ),
	                          ' ',
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'astrick' },
	                            '*'
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'form-group col-md-9' },
	                        _react2.default.createElement('input', { name: 'discount_percent',
	                          className: 'form-control',
	                          placeholder: '0',
	                          step: '0.01', min: '0', max: '100', type: 'number',
	                          value: this.state.discount_percent,
	                          onChange: this.handleChange }),
	                        this.validator.message('Discount', this.state.discount_percent, 'required', { className: 'text-danger' })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'form-group col-md-3' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          ' Discount ',
	                          _react2.default.createElement(
	                            'small',
	                            null,
	                            '(INR)'
	                          ),
	                          ' ',
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'astrick' },
	                            '*'
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'form-group col-md-9' },
	                        _react2.default.createElement('input', { name: 'discount_amount',
	                          className: 'form-control',
	                          placeholder: '0',
	                          step: '0.01', min: '0', type: 'number',
	                          value: this.state.discount_amount,
	                          onChange: this.handleChange })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'form-group col-md-3' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          ' Plan Price ',
	                          _react2.default.createElement(
	                            'small',
	                            null,
	                            '(INR)'
	                          ),
	                          ' ',
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'astrick' },
	                            '*'
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'form-group col-md-9' },
	                        _react2.default.createElement('input', { name: 'plan_price',
	                          className: 'form-control',
	                          placeholder: '0',
	                          step: '0.01', min: '0', type: 'number',
	                          value: this.state.plan_price,
	                          onChange: this.handleChange })
	                      )
	                    ),
	                    this.state.current_icon && _react2.default.createElement(
	                      'div',
	                      { className: 'row', style: { marginBottom: '30px' } },
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'form-group col-md-3' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          'Current Plan Icon ',
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'astrick' },
	                            '*'
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'form-group col-md-9' },
	                        _react2.default.createElement('img', { src: this.state.current_icon, alt: 'banner', width: '100px', height: '100px' })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'form-group col-md-3' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          ' Plan Icon ',
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'astrick' },
	                            '*'
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'form-group col-md-9' },
	                        _react2.default.createElement('input', {
	                          type: 'file',
	                          name: 'new_icon',
	                          onChange: this.handleFile,
	                          className: 'form-control mar-btm',
	                          accept: 'image/x-png,image/gif,image/jpeg,image/svg'
	                        }),
	                        !this.state.current_icon && this.validator.message('Icon', this.state.new_icon, 'required', { className: 'text-danger' })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row', style: { marginBottom: '30px' } },
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'form-group col-md-3' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          ' Our Offers ',
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'astrick' },
	                            '*'
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'form-group col-md-9' },
	                        _react2.default.createElement(_reactDraftWysiwyg.Editor, {
	                          onEditorChange: this.handleEditorChangeoffer,
	                          wrapperClassName: 'wrapper-class',
	                          editorClassName: 'editor-class',
	                          toolbarClassName: 'toolbar-class'
	
	                        }),
	                        this.validator.message('Our Offers', this.state.our_offers, 'required', { className: 'text-danger' })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row', style: { marginBottom: '30px' } },
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'form-group col-md-3' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          ' Our Offers Soon',
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'astrick' },
	                            '*'
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'form-group col-md-9' },
	                        _react2.default.createElement(_reactDraftWysiwyg.Editor, {
	                          onEditorChange: this.handleEditorChangeofferSoon,
	                          wrapperClassName: 'wrapper-class',
	                          editorClassName: 'editor-class',
	                          toolbarClassName: 'toolbar-class'
	
	                        })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row', style: { marginBottom: '30px' } },
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'form-group col-md-3' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          'Analytics Offer',
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'astrick' },
	                            '*'
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'form-group col-md-9' },
	                        _react2.default.createElement(_reactDraftWysiwyg.Editor, {
	                          onEditorChange: this.handleEditorChangeanalytics,
	                          wrapperClassName: 'wrapper-class',
	                          editorClassName: 'editor-class',
	                          toolbarClassName: 'toolbar-class'
	
	                        }),
	                        this.validator.message('Analytics Offer', this.state.analytics_offers, 'required', { className: 'text-danger' })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row', style: { marginBottom: '30px' } },
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'form-group col-md-3' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          'Analytics Offer Soon',
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'astrick' },
	                            '*'
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'form-group col-md-9' },
	                        _react2.default.createElement(_reactDraftWysiwyg.Editor, {
	                          onEditorChange: this.handleEditorChangeanalyticsSoon,
	                          value: this.state.analytics_offers_soon
	
	                        })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'form-group col-md-12' },
	                        _react2.default.createElement(
	                          'h4',
	                          null,
	                          'Restrictions'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'form-group col-md-3' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          ' Allowed Image Counts ',
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'astrick' },
	                            '*'
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'form-group col-md-3' },
	                        _react2.default.createElement('input', { name: 'image_counts',
	                          className: 'form-control',
	                          step: '1', min: '0', type: 'number',
	                          value: this.state.image_counts,
	                          onChange: this.handleChange }),
	                        this.validator.message('Image Counts', this.state.image_counts, 'required', { className: 'text-danger' })
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'form-group col-md-3' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          ' Allowed Words Counts ',
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'astrick' },
	                            '*'
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'form-group col-md-3' },
	                        _react2.default.createElement('input', { name: 'about_words',
	                          className: 'form-control',
	                          step: '1', min: '0', type: 'number',
	                          value: this.state.about_words,
	                          onChange: this.handleChange }),
	                        this.validator.message('Words Counts', this.state.about_words, 'required', { className: 'text-danger' })
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'form-group col-md-3' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          ' Allowed Articles Counts/ Year ',
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'astrick' },
	                            '*'
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'form-group col-md-3' },
	                        _react2.default.createElement('input', { name: 'art_count',
	                          className: 'form-control',
	                          step: '1', min: '0', type: 'number',
	                          value: restriction.art_count,
	                          onChange: this.handleCustomeChange }),
	                        this.validator.message('Article', restriction.art_count, 'required', { className: 'text-danger' })
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'form-group col-md-3' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          ' Download Reports ',
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'astrick' },
	                            '*'
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'form-group col-md-3' },
	                        _react2.default.createElement('input', { type: 'radio', className: '', name: 'download_report', onChange: this.handleCustomeChange, value: true,
	                          checked: restriction.download_report == 'true' }),
	                        ' Yes \xA0',
	                        _react2.default.createElement('input', { type: 'radio', className: '', name: 'download_report', onChange: this.handleCustomeChange, value: false,
	                          checked: restriction.download_report == 'false' }),
	                        ' No',
	                        this.validator.message('Download Reports', restriction.download_report, 'required', { className: 'text-danger' })
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'form-group col-md-3' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          ' Banner Space ',
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'astrick' },
	                            '*'
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'form-group col-md-3' },
	                        _react2.default.createElement('input', { type: 'radio', className: '', name: 'banner_space', onChange: this.handleCustomeChange, value: true,
	                          checked: restriction.banner_space == 'true' }),
	                        ' Yes \xA0',
	                        _react2.default.createElement('input', { type: 'radio', className: '', name: 'banner_space', onChange: this.handleCustomeChange, value: false,
	                          checked: restriction.banner_space == 'false' }),
	                        ' No',
	                        this.validator.message('Banner Space', restriction.banner_space, 'required', { className: 'text-danger' })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'form-group col-md-12' },
	                        _react2.default.createElement(
	                          'table',
	                          { className: 'table table-brodered' },
	                          _react2.default.createElement(
	                            'tbody',
	                            null,
	                            _react2.default.createElement(
	                              'tr',
	                              null,
	                              _react2.default.createElement(
	                                'th',
	                                null,
	                                'Leads'
	                              ),
	                              _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement('input', { type: 'radio', className: '', name: 'rep_leads', onChange: this.handleCustomeChange, value: true,
	                                  checked: restriction.rep_leads == 'true' }),
	                                ' Yes \xA0',
	                                _react2.default.createElement('input', { type: 'radio', className: '', name: 'rep_leads', onChange: this.handleCustomeChange, value: false,
	                                  checked: restriction.rep_leads == 'false' }),
	                                ' No',
	                                this.validator.message('Leads', restriction.rep_leads, 'required', { className: 'text-danger' })
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'tr',
	                              null,
	                              _react2.default.createElement(
	                                'th',
	                                null,
	                                'WiseConnect (Post a job and Talent Search)'
	                              ),
	                              _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement('input', { type: 'radio', className: '', name: 'rep_wiseconnect', onChange: this.handleCustomeChange, value: true,
	                                  checked: restriction.rep_wiseconnect == 'true' }),
	                                ' Yes \xA0',
	                                _react2.default.createElement('input', { type: 'radio', className: '', name: 'rep_wiseconnect', onChange: this.handleCustomeChange, value: false,
	                                  checked: restriction.rep_wiseconnect == 'false' }),
	                                ' No',
	                                this.validator.message('WiseConnect', restriction.rep_wiseconnect, 'required', { className: 'text-danger' })
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'tr',
	                              null,
	                              _react2.default.createElement(
	                                'th',
	                                null,
	                                'User Ratings and Trends'
	                              ),
	                              _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement('input', { type: 'radio', className: '', name: 'rep_rating_trending', onChange: this.handleCustomeChange, value: true,
	                                  checked: restriction.rep_rating_trending == 'true' }),
	                                ' Yes \xA0',
	                                _react2.default.createElement('input', { type: 'radio', className: '', name: 'rep_rating_trending', onChange: this.handleCustomeChange, value: false,
	                                  checked: restriction.rep_rating_trending == 'false' }),
	                                ' No',
	                                this.validator.message('User Ratings and Trends', restriction.rep_rating_trending, 'required', { className: 'text-danger' })
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'tr',
	                              null,
	                              _react2.default.createElement(
	                                'th',
	                                null,
	                                'Number of visitors and unique visitors'
	                              ),
	                              _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement('input', { type: 'radio', className: '', name: 'rep_visitor', onChange: this.handleCustomeChange, value: true,
	                                  checked: restriction.rep_visitor == 'true' }),
	                                ' Yes \xA0',
	                                _react2.default.createElement('input', { type: 'radio', className: '', name: 'rep_visitor', onChange: this.handleCustomeChange, value: false,
	                                  checked: restriction.rep_visitor == 'false' }),
	                                ' No',
	                                this.validator.message('Image Counts', restriction.rep_visitor, 'required', { className: 'text-danger' })
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'tr',
	                              null,
	                              _react2.default.createElement(
	                                'th',
	                                null,
	                                'Number of users who have liked and following'
	                              ),
	                              _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement('input', { type: 'radio', className: '', name: 'rep_likeflw', onChange: this.handleCustomeChange, value: true,
	                                  checked: restriction.rep_likeflw == 'true' }),
	                                ' Yes \xA0',
	                                _react2.default.createElement('input', { type: 'radio', className: '', name: 'rep_likeflw', onChange: this.handleCustomeChange, value: false,
	                                  checked: restriction.rep_likeflw == 'false' }),
	                                ' No',
	                                this.validator.message('Image Counts', restriction.rep_likeflw, 'required', { className: 'text-danger' })
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'tr',
	                              null,
	                              _react2.default.createElement(
	                                'th',
	                                null,
	                                'User locations visiting'
	                              ),
	                              _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement('input', { type: 'radio', className: '', name: 'rep_location', onChange: this.handleCustomeChange, value: true,
	                                  checked: restriction.rep_location == 'true' }),
	                                ' Yes \xA0',
	                                _react2.default.createElement('input', { type: 'radio', className: '', name: 'rep_location', onChange: this.handleCustomeChange, value: false,
	                                  checked: restriction.rep_location == 'false' }),
	                                ' No',
	                                this.validator.message('User locations visiting', restriction.rep_location, 'required', { className: 'text-danger' })
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'tr',
	                              null,
	                              _react2.default.createElement(
	                                'th',
	                                null,
	                                'Overall customer rating vs Average rating of other service providers\u200B'
	                              ),
	                              _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement('input', { type: 'radio', className: '', name: 'rep_rating', onChange: this.handleCustomeChange, value: true,
	                                  checked: restriction.rep_rating == 'true' }),
	                                ' Yes \xA0',
	                                _react2.default.createElement('input', { type: 'radio', className: '', name: 'rep_rating', onChange: this.handleCustomeChange, value: false,
	                                  checked: restriction.rep_rating == 'false' }),
	                                ' No',
	                                this.validator.message('Rating', restriction.rep_rating, 'required', { className: 'text-danger' })
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'tr',
	                              null,
	                              _react2.default.createElement(
	                                'th',
	                                null,
	                                'Variance in Registered vs Non-Registered Users'
	                              ),
	                              _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement('input', { type: 'radio', className: '', name: 'rep_user', onChange: this.handleCustomeChange, value: true,
	                                  checked: restriction.rep_user == 'true' }),
	                                ' Yes \xA0',
	                                _react2.default.createElement('input', { type: 'radio', className: '', name: 'rep_user', onChange: this.handleCustomeChange, value: false,
	                                  checked: restriction.rep_user == 'false' }),
	                                ' No',
	                                this.validator.message('Variance User', restriction.rep_user, 'required', { className: 'text-danger' })
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'tr',
	                              null,
	                              _react2.default.createElement(
	                                'th',
	                                null,
	                                'Number of users - Wishlist'
	                              ),
	                              _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement('input', { type: 'radio', className: '', name: 'rep_wishlist', onChange: this.handleCustomeChange, value: true,
	                                  checked: restriction.rep_wishlist == 'true' }),
	                                ' Yes \xA0',
	                                _react2.default.createElement('input', { type: 'radio', className: '', name: 'rep_wishlist', onChange: this.handleCustomeChange, value: false,
	                                  checked: restriction.rep_wishlist == 'false' }),
	                                ' No',
	                                this.validator.message('Wishlist', restriction.rep_wishlist, 'required', { className: 'text-danger' })
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'tr',
	                              null,
	                              _react2.default.createElement(
	                                'th',
	                                null,
	                                'Number of users - Viewed Video uploaded'
	                              ),
	                              _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement('input', { type: 'radio', className: '', name: 'rep_video_view', onChange: this.handleCustomeChange, value: true,
	                                  checked: restriction.rep_video_view == 'true' }),
	                                ' Yes \xA0',
	                                _react2.default.createElement('input', { type: 'radio', className: '', name: 'rep_video_view', onChange: this.handleCustomeChange, value: false,
	                                  checked: restriction.rep_video_view == 'false' }),
	                                ' No',
	                                this.validator.message('Viewed Video uploaded', restriction.rep_video_view, 'required', { className: 'text-danger' })
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'tr',
	                              null,
	                              _react2.default.createElement(
	                                'th',
	                                null,
	                                'Number of users - Viewed Article published'
	                              ),
	                              _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement('input', { type: 'radio', className: '', name: 'rep_view_art', onChange: this.handleCustomeChange, value: true,
	                                  checked: restriction.rep_view_art == 'true' }),
	                                ' Yes \xA0',
	                                _react2.default.createElement('input', { type: 'radio', className: '', name: 'rep_view_art', onChange: this.handleCustomeChange, value: false,
	                                  checked: restriction.rep_view_art == 'false' }),
	                                ' No',
	                                this.validator.message('Viewed Article published', restriction.rep_view_art, 'required', { className: 'text-danger' })
	                              )
	                            )
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row mb-4' },
	                      _react2.default.createElement(
	                        'button',
	                        { type: 'submit', id: 'btnSubmit',
	                          className: 'btn btn-primary btn-sm', style: { display: "block", margin: "auto" } },
	                        this.state.btnValue
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(_reactNotifications.NotificationContainer, null)
	        )
	      );
	    }
	  }]);
	
	  return editPackage;
	}(_react.Component);
	
	exports.default = editPackage;

/***/ },
/* 928 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _FetchCall2 = _interopRequireDefault(_FetchCall);
	
	var _reactJsPagination = __webpack_require__(33);
	
	var _reactJsPagination2 = _interopRequireDefault(_reactJsPagination);
	
	var _bewiseloading = __webpack_require__(48);
	
	var _bewiseloading2 = _interopRequireDefault(_bewiseloading);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import { Editor } from '@tinymce/tinymce-react';
	
	//import Pagination from 'rc-pagination';
	
	var enquiriesList = function (_Component) {
	  _inherits(enquiriesList, _Component);
	
	  function enquiriesList(props) {
	    _classCallCheck(this, enquiriesList);
	
	    var _this = _possibleConstructorReturn(this, (enquiriesList.__proto__ || Object.getPrototypeOf(enquiriesList)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var url = new URL(window.location.href);
	    var location = url.searchParams.get("location");
	    var auth_data = JSON.parse(localStorage.getItem("user_data"));
	    _this.state = {
	      logged: localStorage.getItem("authentication"),
	      auth_data: JSON.parse(localStorage.getItem("user_data")),
	      location: location ? location : auth_data.access_location ? auth_data.access_location : 'Bengaluru',
	      PER_PAGE: 15,
	      total: 0,
	      loading: true,
	      searchby: '',
	      activePage: 0,
	      offset: 0,
	      leads: [{ name: "",
	        enddate: "",
	        fromdate: "",
	        starttime: "",
	        feeinr: "",
	        feeusd: "",
	        duration: "",
	        days: "" }]
	    };
	
	    return _this;
	  }
	
	  _createClass(enquiriesList, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	
	      var THIS = this;
	      (0, _jquery2.default)(document).on('click', '.remove_maili', function () {
	        var delete_id = (0, _jquery2.default)(this).data("id");
	        THIS.setState({
	          delete_id: delete_id
	        });
	      });
	
	      this.getTotal('leads');
	      this.getList();
	    }
	  }, {
	    key: 'handlePageChange',
	    value: function handlePageChange(pageNumber) {
	
	      console.log('active page is ' + pageNumber);
	
	      this.setState({ activePage: pageNumber });
	
	      //this.getTotal('bw_schools');
	      this.getList(pageNumber);
	    }
	  }, {
	    key: 'openDetail',
	    value: function openDetail(id) {
	      window.location = '/enquiry/enquiryDetail/' + id;
	    }
	  }, {
	    key: 'remove',
	    value: function remove(id) {
	
	      var toastr = '';
	      (0, _jquery2.default)(this).attr('disabled', false);
	
	      toastr = window.toastr.error; //warning
	      toastr('Success', 'Lead is removed', {
	        positionClass: "toast-bottom-right",
	        containerId: "toast-bottom-right"
	      });
	    }
	  }, {
	    key: 'discard',
	    value: function discard(id) {
	      var _this2 = this;
	
	      if (confirm("Are you sure you want to delete this lead?")) {
	
	        var toastr = '';
	        (0, _jquery2.default)(this).attr('disabled', false);
	
	        var req = JSON.stringify({
	          lead_id: id
	        });
	
	        (0, _FetchCall.removelead)(req).then(function (res) {
	
	          _this2.leadList();
	
	          toastr = window.toastr.error; //warning
	          toastr('Success', 'Lead is discarded', {
	            positionClass: "toast-bottom-right",
	            containerId: "toast-bottom-right"
	          });
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var leads = this.state.leads;
	      var _state = this.state,
	          currentPage = _state.currentPage,
	          PER_PAGE = _state.PER_PAGE,
	          totalCount = _state.totalCount,
	          total = _state.total;
	
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'col-lg-12 grid-margin stretch-card' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card-body' },
	                _react2.default.createElement(
	                  'h4',
	                  { 'class': 'card-title' },
	                  'Enquiries (BeWise Exclusive partners and Vertical pages)'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'table-responsive pt-3' },
	                  _react2.default.createElement(
	                    'table',
	                    { 'class': 'table table-bordered table-sm' },
	                    _react2.default.createElement(
	                      'thead',
	                      { 'class': 'thead-dark' },
	                      _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          'S.No'
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          'First Name'
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          'Last Name'
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          'Date'
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          'Source'
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          'Mobile Number'
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          'Action'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'tbody',
	                      null,
	                      leads.length > 0 && leads.map(function (lead, i) {
	
	                        return _react2.default.createElement(
	                          'tr',
	                          null,
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            i + 1
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            lead.firstname
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            lead.lastname
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            lead.createdAt
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            lead.source
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            lead.mobilenumber
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            _react2.default.createElement(
	                              'span',
	                              { 'class': 'cursorpointer', onClick: function onClick() {
	                                  return _this3.openDetail(lead.id);
	                                } },
	                              _react2.default.createElement('i', { 'class': 'eye-button fa fa-eye', title: 'View' })
	                            ),
	                            '\xA0\xA0\xA0\xA0',
	                            _react2.default.createElement(
	                              'span',
	                              { 'class': 'cursorpointer', onClick: function onClick() {
	                                  return _this3.discard(lead.id);
	                                } },
	                              _react2.default.createElement('i', { 'class': 'fa fa-trash', title: 'Trash' })
	                            )
	                          )
	                        );
	                      }),
	                      leads.length == 0 && _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                          'td',
	                          { colSpan: '6' },
	                          'No data'
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'text-center' },
	                    _react2.default.createElement(_reactJsPagination2.default, {
	                      activePage: this.state.activePage,
	                      itemsCountPerPage: PER_PAGE,
	                      totalItemsCount: this.state.total,
	                      pageRangeDisplayed: 5,
	                      activeClass: "pagination__link--active",
	                      onChange: this.handlePageChange.bind(this),
	                      prevPageText: 'previous',
	                      nextPageText: 'next'
	                    })
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return enquiriesList;
	}(_react.Component);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this4 = this;
	
	  this.getTotal = function (source) {
	    var _state$auth_data = _this4.state.auth_data,
	        login_id = _state$auth_data.login_id,
	        role = _state$auth_data.role;
	
	
	    var locationselected = location == '' ? _this4.state.location : location;
	
	    var ins = JSON.stringify({
	      source: source
	    });
	
	    (0, _FetchCall.getTotalEnquiries)(ins).then(function (res) {
	
	      _this4.setState({ loading: true });
	
	      if (res.status == 1) {
	
	        _this4.setState({
	
	          total: res.total
	
	        });
	      }
	    });
	  };
	
	  this.getList = function () {
	    var pageNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	    var _state$auth_data2 = _this4.state.auth_data,
	        login_id = _state$auth_data2.login_id,
	        role = _state$auth_data2.role;
	
	
	    _this4.setState({ activePage: pageNumber });
	
	    var newOffset = pageNumber == 1 ? 0 : (pageNumber - 1) * _this4.state.PER_PAGE % _this4.state.total;
	
	    var locationselected = location == '' ? _this4.state.location : location;
	
	    var ins = JSON.stringify({
	      source: _this4.state.source,
	      perpage: _this4.state.PER_PAGE,
	      offset: newOffset
	    });
	
	    (0, _FetchCall.getEnquiries)(ins).then(function (res) {
	
	      _this4.setState({ loading: true });
	
	      if (res.status == 1) {
	
	        _this4.setState({ loading: !_this4.state.loading });
	
	        var newLeads = res.leads.map(function (lead) {
	          return {
	            "id": lead.id,
	            "firstname": lead.firstname,
	            "lastname": lead.lastname,
	            "source": lead.source,
	            "mobilenumber": lead.mobilenumber,
	            "email": lead.email,
	            "createdAt": new Intl.DateTimeFormat('en-US', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).format(lead.created_date)
	          };
	        });
	
	        _this4.setState({ leads: newLeads });
	      } else {
	
	        _this4.setState({ loading: !_this4.state.loading });
	
	        _this4.setState({
	          leads: []
	        });
	      }
	    });
	  };
	};
	
	exports.default = enquiriesList;

/***/ },
/* 929 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _FetchCall2 = _interopRequireDefault(_FetchCall);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var enquiryDetail = function (_Component) {
	    _inherits(enquiryDetail, _Component);
	
	    function enquiryDetail(props) {
	        _classCallCheck(this, enquiryDetail);
	
	        var _this = _possibleConstructorReturn(this, (enquiryDetail.__proto__ || Object.getPrototypeOf(enquiryDetail)).call(this, props));
	
	        _this.handleChange = function (e) {
	            _this.setState(_defineProperty({}, e.target.name, e.target.value));
	        };
	
	        _this.state = {
	            lead: "",
	            openModal: false,
	            checkMailContent: false,
	            fetchedPartnerListHTML: '',
	            lead_data: [],
	            maillist: [],
	            partnerlist: [],
	            manualpartnerlist: [],
	            partners_f: [],
	            created_date: "",
	            confirmnodataregret: false,
	            distance: '',
	            modetype: '',
	            auth_data: JSON.parse(localStorage.getItem("user_data")),
	            user_data: localStorage.getItem('user_data') ? JSON.parse(localStorage.getItem('user_data')) : [],
	            authentication: localStorage.getItem('authentication') ? JSON.parse(localStorage.getItem('authentication')) : false
	        };
	
	        _this.lead_id = _this.props.match.params.id ? _this.props.match.params.id : '';
	        if (_this.lead_id !== undefined) {
	
	            _this.enquiryDetail(_this.lead_id);
	        }
	
	        _this.enquiryDetail = _this.enquiryDetail.bind(_this);
	
	        return _this;
	    }
	
	    _createClass(enquiryDetail, [{
	        key: 'enquiryDetail',
	        value: function () {
	            var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(lead_id) {
	                var response, _setState, cat_detail, subcategory;
	
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                _context.next = 2;
	                                return _FetchCall2.default.getEnqDetail(lead_id);
	
	                            case 2:
	                                response = _context.sent;
	
	                                if (!(response.status === 1)) {
	                                    _context.next = 15;
	                                    break;
	                                }
	
	                                this.setState((_setState = {
	                                    lead_id: response.detail.id,
	                                    lead_number: response.detail.lead_number,
	                                    firstname: response.detail.firstname,
	                                    lead_status: response.detail.lead_status,
	                                    city: response.detail.city,
	                                    lastname: response.detail.lastname,
	                                    email: response.detail.email,
	                                    grades: response.detail.grades,
	                                    subcategory: response.detail.subcategory,
	                                    subcategory_text: response.detail.subcategory_text,
	                                    mobilenumber: response.detail.mobilenumber,
	                                    created_date: new Intl.DateTimeFormat('en-US', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).format(response.detail.created_date),
	                                    lead_data: response.detail.lead_data ? JSON.parse(response.detail.lead_data) : [],
	                                    location: response.detail.location
	                                }, _defineProperty(_setState, 'city', response.detail.city), _defineProperty(_setState, 'lead_vertical', response.detail.lead_vertical), _defineProperty(_setState, 'accepttakingcalls', response.detail.accepttakingcalls), _defineProperty(_setState, 'searchkey', response.detail.searchkey), _defineProperty(_setState, 'user_id', response.detail.user_id), _setState));
	
	                                if (!response.detail.searchkey) {
	                                    _context.next = 15;
	                                    break;
	                                }
	
	                                _context.next = 8;
	                                return _FetchCall2.default.getCategoryDetail(response.detail.searchkey);
	
	                            case 8:
	                                cat_detail = _context.sent;
	
	                                if (!(cat_detail.status === 1)) {
	                                    _context.next = 15;
	                                    break;
	                                }
	
	                                this.setState({ subvertical: cat_detail.results[0].category_name });
	
	                                _context.next = 13;
	                                return _FetchCall2.default.getCategoryDetail(response.detail.subcategory);
	
	                            case 13:
	                                subcategory = _context.sent;
	
	                                if (subcategory.status === 1) {
	                                    this.setState({ subcategory_text: subcategory.results[0].category_name });
	                                }
	
	                            case 15:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function enquiryDetail(_x) {
	                return _ref.apply(this, arguments);
	            }
	
	            return enquiryDetail;
	        }()
	    }, {
	        key: 'renderUsers',
	        value: function renderUsers() {
	            var userList = [];
	
	            for (var i = 0; i < this.state.partnerlist.length; i++) {
	
	                userList.push(_react2.default.createElement(
	                    'tr',
	                    { 'class': 'table-info' },
	                    _react2.default.createElement(
	                        'td',
	                        null,
	                        _react2.default.createElement(
	                            'a',
	                            { href: this.state.partnerlist[i].partner_link == null ? "#" : "https://bewise.in" + this.state.partnerlist[i].partner_link, target: '_blank' },
	                            this.state.partnerlist[i].partner_name
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        null,
	                        ' ',
	                        this.state.partnerlist[i].seen == 1 ? "Yes" : "No"
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        null,
	                        this.state.partnerlist[i].seen_mobilenumber == 1 ? "Yes" : "No"
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        null,
	                        ' ',
	                        this.state.partnerlist[i].seen_emailid == 1 ? "Yes" : "No"
	                    )
	                ));
	            }
	
	            return userList;
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	
	            var user_data = localStorage.getItem("user_data");
	            var auth_data = JSON.parse(user_data);
	            var vendor_id = auth_data.login_id;
	            this.setState({ vendor_id: vendor_id });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _state = this.state,
	                lead_id = _state.lead_id,
	                lead_number = _state.lead_number,
	                lead_status = _state.lead_status,
	                email = _state.email,
	                mobilenumber = _state.mobilenumber,
	                lead_data = _state.lead_data,
	                firstname = _state.firstname,
	                lastname = _state.lastname,
	                lead_vertical = _state.lead_vertical,
	                grades = _state.grades,
	                searchkey = _state.searchkey,
	                subcategory_text = _state.subcategory_text,
	                subvertical = _state.subvertical,
	                subcategory = _state.subcategory,
	                location = _state.location,
	                city = _state.city,
	                accepttakingcalls = _state.accepttakingcalls,
	                created_date = _state.created_date,
	                partnerlist = _state.partnerlist,
	                manualpartnerlist = _state.manualpartnerlist,
	                message = _state.message,
	                user_id = _state.user_id;
	
	
	            return _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _react2.default.createElement(
	                    _layout2.default,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { 'class': 'col-lg-12 grid-margin stretch-card' },
	                        _react2.default.createElement(
	                            'div',
	                            { 'class': 'card' },
	                            _react2.default.createElement(
	                                'div',
	                                { 'class': 'card-body' },
	                                _react2.default.createElement(
	                                    'h4',
	                                    { 'class': 'card-title' },
	                                    'Enquiries '
	                                ),
	                                _react2.default.createElement(
	                                    'a',
	                                    { href: '/enquiry/enquiries', 'class': 'btn btn-sm btn-primary' },
	                                    'Back to list'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'leadpage' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'd-flex justify-content-between align-items-center py-3' },
	                                        _react2.default.createElement(
	                                            'h2',
	                                            { 'class': 'h5 mb-0' },
	                                            _react2.default.createElement('a', { href: '#', 'class': 'text-muted' }),
	                                            ' Lead Ref# :',
	                                            lead_number
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'row' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'col-lg-8' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { 'class': 'card mb-4' },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { 'class': 'card-body' },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { 'class': 'mb-3 d-flex justify-content-between' },
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            null,
	                                                            _react2.default.createElement(
	                                                                'span',
	                                                                { 'class': 'me-3' },
	                                                                'Created Date: ',
	                                                                created_date,
	                                                                '\xA0'
	                                                            )
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        null,
	                                                        _react2.default.createElement(
	                                                            'label',
	                                                            null,
	                                                            'Enquiry Detail'
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { 'class': 'enqinfoblock' },
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                null,
	                                                                'Name: ',
	                                                                _react2.default.createElement(
	                                                                    'span',
	                                                                    null,
	                                                                    firstname,
	                                                                    ' ',
	                                                                    lastname
	                                                                )
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                null,
	                                                                'Mobilenumber: ',
	                                                                _react2.default.createElement(
	                                                                    'span',
	                                                                    null,
	                                                                    mobilenumber
	                                                                )
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                null,
	                                                                'Email: ',
	                                                                _react2.default.createElement(
	                                                                    'span',
	                                                                    null,
	                                                                    email
	                                                                )
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                null,
	                                                                'Message: ',
	                                                                _react2.default.createElement(
	                                                                    'span',
	                                                                    null,
	                                                                    message
	                                                                )
	                                                            )
	                                                        )
	                                                    )
	                                                )
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return enquiryDetail;
	}(_react.Component);
	
	exports.default = enquiryDetail;

/***/ },
/* 930 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(17);
	
	__webpack_require__(1266);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EventPreview = function (_Component) {
	  _inherits(EventPreview, _Component);
	
	  function EventPreview(props) {
	    _classCallCheck(this, EventPreview);
	
	    var _this = _possibleConstructorReturn(this, (EventPreview.__proto__ || Object.getPrototypeOf(EventPreview)).call(this, props));
	
	    _this.state = {
	      event: [],
	      collapse: -1
	    };
	    return _this;
	  }
	
	  _createClass(EventPreview, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'toggle',
	    value: function toggle(event) {
	      this.setState({
	        collapse: this.state.collapse === event ? -1 : event
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      console.log('nextProps', nextProps);
	      if (nextProps.eData) {
	        this.setState({
	          event: nextProps.eData
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          event = _state.event,
	          collapse = _state.collapse;
	      var registration_details = event.registration_details,
	          page_css = event.page_css,
	          speaker_details = event.speaker_details,
	          faq_details = event.faq_details;
	
	      var btnCss = page_css ? page_css.btn_css : [];
	      var form_css = page_css ? page_css.form_css : [];
	      console.log('speaker_details', event);
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          'style',
	          null,
	          btnCss && '  a.com-event-reg-btn{\n                            background-color: ' + btnCss.btn_bg_clr + ' !important;\n                            color:' + btnCss.btn_font_clr + ' !important;\n                        }\n                        a.com-event-reg-btn:hover{\n                            background-color: ' + btnCss.btn_hvr_bg_clr + ' !important;\n                            border-color: ' + btnCss.btn_hvr_bdr_clr + ' !important;\n                            color: ' + btnCss.btn_hvr_font_clr + ' !important;\n                            text-decoration: none;\n                        }\n                  ',
	          form_css && '  .bevents-container .event-reg-title p{\n                            color:' + form_css.form_title_clr + ' !important;\n                            text-transform: capitalize;\n                        }\n                        .bevents-container .event-reg{\n                            background-color: ' + form_css.form_bg_clr + ' !important;\n                            color: ' + form_css.form_bg_clr + ' !important;\n                        }\n                        .bevents-container .event-reg .event-resgiter-btn{\n                            background-color: ' + form_css.sb_btn_bg_clr + ' !important;\n                            color: ' + form_css.sb_btn_font_clr + ' !important;\n                            border-color: ' + form_css.sb_btn_bg_clr + ' !important;\n                            font-weight: 600;\n                        }\n                '
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'tranparent-header-custom-inner' },
	          _react2.default.createElement(
	            'div',
	            { className: 'container-fluid' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row align-items-center header-custom' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-lg-10 col-md-6 col-12' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'bewise-logo active' },
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      null,
	                      _react2.default.createElement(
	                        'a',
	                        { className: 'logo-text', href: '/', target: '_blank' },
	                        _react2.default.createElement('img', { src: '/assets/images/bewiselogo.png', style: { width: "130px", marginRight: "2px" } })
	                      )
	                    )
	                  )
	                )
	              ),
	              registration_details && registration_details.isForm && _react2.default.createElement(
	                'div',
	                { className: 'col-lg-2 col-md-6 text-right mobile-position event-header-cus' },
	                _react2.default.createElement(
	                  'a',
	                  { href: 'javascript:;', className: 'btn btn-lg com-event-reg-btn' },
	                  'Register'
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'section',
	          { className: '' },
	          _react2.default.createElement(
	            'div',
	            { className: 'event-com-ban-sec' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-12 com-banner' },
	                (event.tempBanner || event.c_banner_image) && _react2.default.createElement('img', { src: event.tempBanner ? event.tempBanner : event.c_banner_image, alt: 'Event Banner',
	                  height: 468 })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'section',
	          { 'class': 'container p-0', style: { width: '100%' } },
	          _react2.default.createElement(
	            'div',
	            { className: 'bevents-page' },
	            _react2.default.createElement(
	              'div',
	              { className: 'bevents-container' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  {
	                    className: registration_details && registration_details.isForm ? 'col-md-8' : 'col-md-12' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-md-12' },
	                      _react2.default.createElement(
	                        'h3',
	                        null,
	                        _react2.default.createElement(
	                          'b',
	                          null,
	                          event.event_title
	                        )
	                      ),
	                      _react2.default.createElement('div', { className: '',
	                        dangerouslySetInnerHTML: { __html: event.event_content } })
	                    )
	                  )
	                ),
	                registration_details && registration_details.isForm && _react2.default.createElement(
	                  'div',
	                  { className: 'col-md-4' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'event-reg' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'event-reg-container' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-12' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-md-12 event-reg-title' },
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            form_css.form_title
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'event-reg-form' },
	                          _react2.default.createElement(
	                            'form',
	                            { onSubmit: function onSubmit() {
	                                alert('This is preview Form');
	                              }, autoComplete: 'off' },
	                            registration_details.form.map(function (item, i) {
	                              var condition = item.input_type == 'email' ? 'required|emailExist_check' : 'required';
	                              console.log('condition', condition);
	                              return _react2.default.createElement(
	                                _react2.default.Fragment,
	                                null,
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'col-md-12', style: { marginBottom: '48px' } },
	                                  item.input_type == 'file' ? _react2.default.createElement('input', { type: item.input_type, placeholder: item.lbl_name,
	                                    className: 'cus-file-field form-control', name: item.input_name,
	                                    onChange: function onChange(e) {
	                                      return _this2.handleFile(e, item.max_upload);
	                                    },
	                                    multiple: true }) : _react2.default.createElement('input', { type: item.input_type, placeholder: item.lbl_name,
	                                    className: 'form-control', name: item.input_name,
	                                    onChange: _this2.handleChange,
	                                    value: _this2.state[item.input_name] })
	                                )
	                              );
	                            }),
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'col-md-12' },
	                              _react2.default.createElement(
	                                'button',
	                                { className: 'btn btn-sm btn-secondary event-resgiter-btn',
	                                  disabled: true },
	                                'Submit'
	                              )
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-12', style: { marginTop: '32px', padding: '0' } },
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      'Please cross-check your SPAM mailbox, just in case our invite is not on your primary mailbox.'
	                    )
	                  )
	                )
	              ),
	              speaker_details && speaker_details.length > 0 && _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-12' },
	                    _react2.default.createElement(
	                      'h3',
	                      null,
	                      'Know about our keynote speaker:'
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row' },
	                  speaker_details.map(function (item, i) {
	                    return _react2.default.createElement(
	                      'div',
	                      { className: 'col-md-12' },
	                      _react2.default.createElement(
	                        'h4',
	                        null,
	                        item.spk_title ? item.spk_title : '',
	                        ' ',
	                        item.spk_name
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          _react2.default.createElement('img', { src: item.temp_img ? item.temp_img : event.img_url + item.spk_img,
	                            alt: 'Image of ' + item.spk_name, width: '200px',
	                            style: { float: 'left', paddingRight: '15px' } })
	                        ),
	                        _react2.default.createElement('p', { className: 'text-justify',
	                          dangerouslySetInnerHTML: { __html: item.spk_desc } })
	                      )
	                    );
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                'h3',
	                null,
	                'FAQ\u2019s '
	              ),
	              faq_details && _react2.default.createElement(
	                _reactstrap.Card,
	                { className: 'panel-group custom-card', style: { marginBottom: '1rem' } },
	                faq_details.map(function (item, index) {
	                  return _react2.default.createElement(
	                    _react2.default.Fragment,
	                    null,
	                    _react2.default.createElement(
	                      _reactstrap.CardHeader,
	                      { onClick: function onClick() {
	                          return _this2.toggle('f-' + index);
	                        }, 'data-event': 'f-' + index, className: 'custom-card-heading' },
	                      _react2.default.createElement(
	                        'b',
	                        null,
	                        item.ques,
	                        ' '
	                      ),
	                      collapse !== 'f-' + index ? _react2.default.createElement(
	                        'span',
	                        { className: 'pull-right' },
	                        _react2.default.createElement('i', { 'class': 'fa fa-plus', 'aria-hidden': 'true' })
	                      ) : _react2.default.createElement(
	                        'span',
	                        { className: 'pull-right' },
	                        _react2.default.createElement('i', { 'class': 'fa fa-minus', 'aria-hidden': 'true' })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactstrap.Collapse,
	                      { isOpen: collapse === 'f-' + index },
	                      _react2.default.createElement(
	                        _reactstrap.CardBody,
	                        { className: 'panel-body' },
	                        _react2.default.createElement('p', { dangerouslySetInnerHTML: { __html: item.ans } })
	                      )
	                    )
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'BeWise is a one\u2013stop platform that enables parents make easy, informed and efficient choices about the pre-school, school, and after-school institutions and individuals they want their children to be associated with, with access to deep information, reviews and ratings. To know more about us, ',
	                _react2.default.createElement(
	                  'a',
	                  { href: '/', target: '_blank' },
	                  _react2.default.createElement(
	                    'b',
	                    null,
	                    'click here'
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return EventPreview;
	}(_react.Component);
	
	exports.default = EventPreview;

/***/ },
/* 931 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _tinymceReact = __webpack_require__(69);
	
	var _constant = __webpack_require__(21);
	
	var _reactJsPagination = __webpack_require__(33);
	
	var _reactJsPagination2 = _interopRequireDefault(_reactJsPagination);
	
	var _reactstrap = __webpack_require__(17);
	
	__webpack_require__(18);
	
	var _reactNotifications = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import { Editor } from '@tinymce/tinymce-react';
	
	//import Pagination from 'rc-pagination';
	
	var AuroScholars = function (_Component) {
	  _inherits(AuroScholars, _Component);
	
	  function AuroScholars(props) {
	    _classCallCheck(this, AuroScholars);
	
	    var _this = _possibleConstructorReturn(this, (AuroScholars.__proto__ || Object.getPrototypeOf(AuroScholars)).call(this, props));
	
	    _this.getTotal = function () {
	
	      (0, _FetchCall.getTotalAuroSubscribers)().then(function (res) {
	
	        _this.setState({ loading: true });
	
	        if (res.status == 1) {
	
	          _this.setState({
	
	            total: res.total
	
	          });
	        }
	      });
	    };
	
	    _this.getList = function () {
	      var pageNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	      var location = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	      var _this$state$auth_data = _this.state.auth_data,
	          login_id = _this$state$auth_data.login_id,
	          role = _this$state$auth_data.role;
	
	
	      _this.setState({ activePage: pageNumber });
	
	      var newOffset = pageNumber == 1 ? 0 : (pageNumber - 1) * _this.state.PER_PAGE % _this.state.total;
	
	      var locationselected = location == '' ? _this.state.location : location;
	
	      var ins = JSON.stringify({
	        perpage: _this.state.PER_PAGE,
	        year: _this.state.year,
	        month: _this.state.month,
	        offset: newOffset
	      });
	
	      (0, _FetchCall.getAuroScholarPaged)(ins).then(function (res) {
	
	        _this.setState({ loading: true });
	
	        if (res.status == 1) {
	
	          _this.setState({ loading: !_this.state.loading });
	
	          var aset = res.list.map(function (as) {
	            return {
	              "id": as.id,
	              "email": as.email_id,
	              "name": as.name,
	              "studentId": as.student_id,
	              "auro_status": as.auro_status,
	              "createdAt": new Intl.DateTimeFormat('en-US', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).format(as.created_date)
	            };
	          });
	
	          _this.setState({ list: aset });
	        } else {
	
	          _this.setState({ loading: !_this.state.loading });
	
	          _this.setState({
	            list: []
	          });
	        }
	      });
	    };
	
	    _this.confirmSend = function () {
	
	      var ins = JSON.stringify({
	        subject: _this.state.subject,
	        mail_content: _this.state.mail_content
	      });
	
	      (0, _FetchCall.processReminderMail)(ins).then(function (res) {});
	    };
	
	    _this.state = {
	      logged: localStorage.getItem("authentication"),
	      auth_data: JSON.parse(localStorage.getItem("user_data")),
	      category_data: [], collapse: 0, modalReply: false,
	      current_comment: '', current_rid: 0, current_eid: '',
	      PER_PAGE: 15,
	      total: 0,
	      loading: true,
	      openpopup: false,
	      list: [],
	      exportbtndisabled: false,
	      thisExportBtnText: 'Export'
	    };
	
	    _this.getTotal = _this.getTotal.bind(_this);
	    _this.getList = _this.getList.bind(_this);
	    _this.sendCustomMailAuro = _this.sendCustomMailAuro.bind(_this);
	    _this.handleEditorChange = _this.handleEditorChange.bind(_this);
	
	    return _this;
	  }
	
	  _createClass(AuroScholars, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	
	      var THIS = this;
	      (0, _jquery2.default)(document).on('click', '.dlte', function () {
	        var _this2 = this;
	
	        var delete_id = (0, _jquery2.default)(this).data("id");
	
	        if (confirm("You are sure to delete?") == true) {
	
	          var ins = JSON.stringify({
	            id: delete_id,
	            table: 'auroscholars'
	          });
	
	          (0, _FetchCall.removethisItem)(ins).then(function (res) {
	
	            if (res.status == 1) {
	              _reactNotifications.NotificationManager.success('Removed successfully');
	            } else {
	              _reactNotifications.NotificationManager.error('Issue in removing');
	            }
	            _this2.getTotal('leads');
	            _this2.getList();
	          });
	        }
	      });
	
	      this.getTotal();
	      this.getList();
	    }
	  }, {
	    key: 'sendCustomMailAuro',
	    value: function sendCustomMailAuro() {
	
	      this.setState({ openpopup: true });
	    }
	  }, {
	    key: 'handlePageChange',
	    value: function handlePageChange(pageNumber) {
	
	      console.log('active page is ' + pageNumber);
	
	      this.setState({ activePage: pageNumber });
	
	      //this.getTotal('bw_schools');
	      this.getList(pageNumber);
	    }
	  }, {
	    key: 'handleEditorChange',
	    value: function handleEditorChange(value, editor) {
	      this.setState({
	        mail_content: value
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var list = this.state.list;
	      var _state = this.state,
	          currentPage = _state.currentPage,
	          PER_PAGE = _state.PER_PAGE,
	          totalCount = _state.totalCount,
	          total = _state.total,
	          exportbtndisabled = _state.exportbtndisabled;
	
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'col-12 grid-margin' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card-body' },
	                _react2.default.createElement(
	                  'h4',
	                  { 'class': 'card-title' },
	                  'List'
	                ),
	                _react2.default.createElement(
	                  'button',
	                  { 'class': 'btn btn-main', onClick: this.sendCustomMailAuro },
	                  'Send Reminder Mail'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'table-responsive pt-3' },
	                  _react2.default.createElement(
	                    'table',
	                    { 'class': 'table table-bordered table-sm' },
	                    _react2.default.createElement(
	                      'thead',
	                      { 'class': 'thead-dark' },
	                      _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          'S.No'
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          'Name'
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          'Email'
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          'Student Id'
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          'Auro Signup'
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          'Date'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'tbody',
	                      null,
	                      list.length > 0 && list.map(function (asitem, i) {
	
	                        return _react2.default.createElement(
	                          'tr',
	                          null,
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            i + 1
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            asitem.name
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            asitem.email
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            asitem.studentId
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            { className: asitem.auro_status == 'success' ? "success" : "failure" },
	                            asitem.auro_status
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            asitem.createdAt
	                          )
	                        );
	                      }),
	                      list.length == 0 && _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                          'td',
	                          { colSpan: '6' },
	                          'No data'
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'text-center' },
	                    _react2.default.createElement(_reactJsPagination2.default, {
	                      activePage: this.state.activePage,
	                      itemsCountPerPage: PER_PAGE,
	                      totalItemsCount: this.state.total,
	                      pageRangeDisplayed: 5,
	                      activeClass: "pagination__link--active",
	                      onChange: this.handlePageChange.bind(this),
	                      prevPageText: 'previous',
	                      nextPageText: 'next'
	                    })
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(_reactNotifications.NotificationContainer, null),
	          _react2.default.createElement(
	            _reactstrap.Modal,
	            { isOpen: this.state.openpopup, size: 'lg', className: 'modal-lg-60' },
	            _react2.default.createElement(
	              _reactstrap.ModalHeader,
	              null,
	              'Custom Mail'
	            ),
	            _react2.default.createElement(
	              _reactstrap.ModalBody,
	              null,
	              _react2.default.createElement(
	                'div',
	                { 'class': 'label_item' },
	                'Subject: ',
	                _react2.default.createElement('input', { type: 'text', name: 'subject', 'class': 'form-control', onChange: this.handleChange })
	              ),
	              _react2.default.createElement(
	                'div',
	                { 'class': 'label_item' },
	                'To:  All subscribed users'
	              ),
	              _react2.default.createElement(
	                'div',
	                { 'class': 'label_item' },
	                'Message:'
	              ),
	              _react2.default.createElement(
	                'div',
	                { 'class': 'partnerlist' },
	                _react2.default.createElement(_tinymceReact.Editor, {
	                  onEditorChange: this.handleEditorChange,
	                  toolbar: {
	                    inline: { inDropdown: true },
	                    list: { inDropdown: true },
	                    textAlign: { inDropdown: true },
	                    link: { inDropdown: true },
	                    history: { inDropdown: true },
	                    image: { uploadCallback: this.uploadImageCallBack, alt: { present: true, mandatory: true } }
	                  },
	                  value: this.state.mail_content,
	                  name: 'mail_content',
	                  apiKey: _constant.TINY_EDITOR,
	                  init: {
	                    height: 300,
	                    theme: "silver",
	                    plugins: ["advlist autolink lists link anchor paste image"],
	                    toolbar: 'undo redo | formatselect | image| bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | help'
	
	                  }
	                })
	              ),
	              _react2.default.createElement(
	                'div',
	                { id: 'submittosend', 'class': 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'col-md-12' },
	                  _react2.default.createElement(
	                    'button',
	                    { 'class': 'btn btn-primary btn-sm', onClick: function onClick() {
	                        return _this3.confirmSend();
	                      } },
	                    'Send'
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(_reactstrap.ModalFooter, null)
	          )
	        )
	      );
	    }
	  }]);
	
	  return AuroScholars;
	}(_react.Component);
	
	exports.default = AuroScholars;

/***/ },
/* 932 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _constant = __webpack_require__(21);
	
	var _reactstrap = __webpack_require__(17);
	
	var _footerpreview = __webpack_require__(137);
	
	var _footerpreview2 = _interopRequireDefault(_footerpreview);
	
	var _previewheader = __webpack_require__(140);
	
	var _previewheader2 = _interopRequireDefault(_previewheader);
	
	var _headerimage = __webpack_require__(138);
	
	var _headerimage2 = _interopRequireDefault(_headerimage);
	
	var _leftmenuimage = __webpack_require__(139);
	
	var _leftmenuimage2 = _interopRequireDefault(_leftmenuimage);
	
	var _rightmenuimage = __webpack_require__(141);
	
	var _rightmenuimage2 = _interopRequireDefault(_rightmenuimage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var exclusiveParterView = function (_Component) {
	    _inherits(exclusiveParterView, _Component);
	
	    function exclusiveParterView(props) {
	        _classCallCheck(this, exclusiveParterView);
	
	        var _this = _possibleConstructorReturn(this, (exclusiveParterView.__proto__ || Object.getPrototypeOf(exclusiveParterView)).call(this, props));
	
	        _this.sendNotePopup = function () {
	            _this.setState({ sendMessage: true });
	        };
	
	        _this.approveit = function () {
	
	            var insData = JSON.stringify({
	                login_id: _this.state.login_id,
	                approved: 1
	            });
	
	            (0, _FetchCall.changeStatusExclPart)(insData).then(function (response) {
	
	                var toastr = '';
	                if (response.status === 1) {
	                    alert("Approved successfully");
	                } else {
	                    alert("error disapproving");
	                }
	            });
	        };
	
	        _this.disapproveit = function () {
	
	            var insData = JSON.stringify({
	                login_id: _this.state.login_id,
	                approved: 0
	            });
	
	            (0, _FetchCall.changeStatusExclPart)(insData).then(function (response) {
	
	                var toastr = '';
	                if (response.status === 1) {
	                    alert("Disapproved successfully");
	                } else {
	                    alert("error disapproving");
	                }
	            });
	        };
	
	        _this.sendaMessage = function () {
	
	            var insData = JSON.stringify({
	                login_id: _this.state.login_id,
	                message: _this.state.message
	            });
	
	            (0, _FetchCall.sendAdminMessage)(insData).then(function (response) {
	
	                var toastr = '';
	                if (response.status === 1) {
	                    alert("Message is sent successfully");
	                } else {
	                    alert("error sending a message");
	                }
	            });
	        };
	
	        _this.handleChange = function (e) {
	            var propName = e.target.name;
	            _this.setState(_defineProperty({}, e.target.name, e.target.value));
	        };
	
	        _this.cancelPop1 = function () {
	            _this.setState({
	                sendMessage: false
	            });
	        };
	
	        _this.cancelPop2 = function () {
	            _this.setState({
	                detailedpreview: false
	            });
	        };
	
	        _this.preview = function () {
	            _this.setState({ detailedpreview: true });
	        };
	
	        _this.handleSubmit = function (e) {
	
	            e.preventDefault();
	
	            //console.log("nae1", e.target.program_name);
	
	            var insData = {
	                camp_id: _this.camp_id,
	                status: 1
	            };
	
	            console.log('insData', insData);
	        };
	
	        var qrystr = window.location.search;
	        var urlParams = new URLSearchParams(qrystr);
	
	        var id = urlParams.get('id');
	
	        _this.state = {
	            sendMessage: false,
	            detailedpreview: false,
	            banners: '',
	            auth_data: JSON.parse(localStorage.getItem("user_data")),
	            user_data: localStorage.getItem('user_data') ? JSON.parse(localStorage.getItem('user_data')) : [],
	            authentication: localStorage.getItem('authentication') ? JSON.parse(localStorage.getItem('authentication')) : false
	        };
	
	        _this.id = _this.props.match.params.id ? _this.props.match.params.id : '';
	        _this.type = _this.props.match.params.type ? _this.props.match.params.type : '';
	
	        _this.exclusivePartnerShipEntry(_this.id, _this.type);
	
	        return _this;
	    }
	
	    _createClass(exclusiveParterView, [{
	        key: 'exclusivePartnerShipEntry',
	        value: function () {
	            var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(id, type) {
	                var _this2 = this;
	
	                var req;
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                req = JSON.stringify({
	                                    id: id
	                                });
	
	                                (0, _FetchCall.getExclPtnrsEntryById)(req).then(function (response) {
	
	                                    if (response.status === 1) {
	
	                                        var data = response.result;
	
	                                        _this2.setState({ approval_status: "Pending" });
	                                        _this2.setState({ login_id: data.login_id });
	                                        _this2.setState({ emailaddress: data.emailaddress });
	                                        _this2.setState({ approvedstatus: data.approved });
	                                        _this2.setState({ banners: data.banners != null ? data.banners : '' });
	
	                                        if (data.approved == 1) {
	                                            _this2.setState({ approval_status: "Approved" });
	                                        }
	                                        if (data.approved == 2) {
	                                            _this2.setState({ approval_status: "Disapproved" });
	                                        }
	                                        _this2.setState(response.result);
	                                    }
	                                });
	
	                            case 2:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function exclusivePartnerShipEntry(_x, _x2) {
	                return _ref.apply(this, arguments);
	            }
	
	            return exclusivePartnerShipEntry;
	        }()
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	
	            var user_data = localStorage.getItem("user_data");
	            var auth_data = JSON.parse(user_data);
	        }
	    }, {
	        key: 'UNSAFE_componentWillMount',
	        value: function UNSAFE_componentWillMount() {}
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            window.jQuery('.selectpicker').selectpicker('refresh');
	        }
	    }, {
	        key: 'deleteEntry',
	        value: function deleteEntry(i, e) {
	            var _this3 = this;
	
	            if (window.confirm("Are you sure?")) {
	
	                var req_c = JSON.stringify({
	                    camp_id: this.camp_id
	                });
	                var THIS = this;
	                var toastr = '';
	                (0, _FetchCall.deleteEntry)(req_c).then(function () {
	                    var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(res) {
	                        return _regenerator2.default.wrap(function _callee2$(_context2) {
	                            while (1) {
	                                switch (_context2.prev = _context2.next) {
	                                    case 0:
	                                        if (res.status === 1) {
	                                            alert(res.message);
	                                            _this3.props.history.push('/users/exclusivepartners');
	                                        }
	
	                                    case 1:
	                                    case 'end':
	                                        return _context2.stop();
	                                }
	                            }
	                        }, _callee2, _this3);
	                    }));
	
	                    return function (_x3) {
	                        return _ref2.apply(this, arguments);
	                    };
	                }());
	            }
	        }
	    }, {
	        key: 'escapeRegexCharacters',
	        value: function escapeRegexCharacters(str) {
	            return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _state$auth_data = this.state.auth_data,
	                role = _state$auth_data.role,
	                user_name = _state$auth_data.user_name;
	            //console.log(this.state.banner);
	
	            var _state = this.state,
	                banners = _state.banners,
	                banners_b2b = _state.banners_b2b;
	            //console.log(banners);
	
	            var offer1 = _constant.IMGBASEURL + 'uploads/' + this.state.offerimage1;
	            var offer2 = _constant.IMGBASEURL + 'uploads/' + this.state.offerimage2;
	
	            return _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _react2.default.createElement(
	                    _layout2.default,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { 'class': 'col-12 grid-margin' },
	                        _react2.default.createElement(
	                            'div',
	                            { 'class': 'card' },
	                            _react2.default.createElement(
	                                'div',
	                                { 'class': 'card-body' },
	                                _react2.default.createElement(
	                                    'h4',
	                                    { 'class': 'card-title' },
	                                    'Exclusive Partnership Management - View/Manage'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'content-sec col-md-12 col-xs-12 pad-no mar-t-no' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'tab-content' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { id: 'company-info', className: 'tab-pane in active' },
	                                            _react2.default.createElement(
	                                                'form',
	                                                { onSubmit: this.handleSubmit, className: 'custom-form invoice-form col-md-12 col-xs-12 legend-form pad-no', method: 'post' },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'box-shadow-custom' },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'row' },
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'form-group col-md-6' },
	                                                            _react2.default.createElement(
	                                                                'label',
	                                                                null,
	                                                                'Name ',
	                                                                _react2.default.createElement(
	                                                                    'span',
	                                                                    { className: 'astrick' },
	                                                                    '*'
	                                                                )
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                null,
	                                                                this.state.name
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'form-group col-md-6' },
	                                                            _react2.default.createElement(
	                                                                'label',
	                                                                null,
	                                                                'Type ',
	                                                                _react2.default.createElement(
	                                                                    'span',
	                                                                    { className: 'astrick' },
	                                                                    '*'
	                                                                )
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                null,
	                                                                this.state.optiontoshow == 'both' ? "B2B/B2C" : this.state.optiontoshow == 'onlypartners' ? "B2B" : "B2C"
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'form-group col-md-6' },
	                                                            _react2.default.createElement(
	                                                                'label',
	                                                                null,
	                                                                'Address '
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                null,
	                                                                this.state.address
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'form-group col-md-6' },
	                                                            _react2.default.createElement(
	                                                                'label',
	                                                                null,
	                                                                'Email Address '
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                null,
	                                                                this.state.emailaddress
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'form-group col-md-6' },
	                                                            _react2.default.createElement(
	                                                                'label',
	                                                                null,
	                                                                'Website '
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                null,
	                                                                this.state.website
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'form-group col-md-12' },
	                                                            _react2.default.createElement(
	                                                                'label',
	                                                                null,
	                                                                'Description '
	                                                            ),
	                                                            this.state.optiontoshow == 'onlypartners' && _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: this.state.description_b2b } }),
	                                                            this.state.optiontoshow != 'onlypartners' && _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: this.state.description } })
	                                                        )
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'box-shadow-custom' },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'row' },
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'col-md-12 col-xs-12' },
	                                                            _react2.default.createElement(
	                                                                'span',
	                                                                { className: 'form-legend' },
	                                                                'Exclusive Offers'
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { 'class': 'containerrow' },
	                                                            (this.state.offerimage1 == null || this.state.offerimage1 == '') && _react2.default.createElement(
	                                                                'div',
	                                                                { 'class': 'offer_row borderwithcolor1' },
	                                                                'No offers entered'
	                                                            ),
	                                                            this.state.offerimage1 != null && this.state.offerimage1 != '' && _react2.default.createElement(
	                                                                'div',
	                                                                { 'class': 'offer_row borderwithcolor1' },
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    { 'class': 'offer_left_img', style: { width: "200px" } },
	                                                                    _react2.default.createElement('img', { src: _constant.IMGBASEURL + 'uploads/' + this.state.offerimage1 })
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    { 'class': 'offer_right_text' },
	                                                                    _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: this.state.offer1desc } })
	                                                                )
	                                                            )
	                                                        )
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'box-shadow-custom' },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'row' },
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'col-md-12 col-xs-12' },
	                                                            _react2.default.createElement(
	                                                                'span',
	                                                                { className: 'form-legend' },
	                                                                'Media Information'
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'form-group col-md-6' },
	                                                            _react2.default.createElement(
	                                                                'label',
	                                                                null,
	                                                                'Logo'
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'logoimg', style: { width: "200px" } },
	                                                                _react2.default.createElement('img', { src: _constant.IMGBASEURL + 'uploads/' + this.state.logo })
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'form-group col-md-6' },
	                                                            _react2.default.createElement(
	                                                                'label',
	                                                                null,
	                                                                'Banner'
	                                                            ),
	                                                            this.state.optiontoshow == 'onlypartners' && _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'bannerimg', style: { width: "200px" } },
	                                                                banners_b2b != null && banners_b2b != '' && _react2.default.createElement('img', { style: { width: "100%" }, src: _constant.IMGBASEURL + 'uploads/' + this.state.banners_b2b })
	                                                            ),
	                                                            this.state.optiontoshow != 'onlypartners' && _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'bannerimg', style: { width: "200px" } },
	                                                                banners != null && banners != '' && _react2.default.createElement('img', { style: { width: "100%" }, src: _constant.IMGBASEURL + 'uploads/' + this.state.banners })
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'form-group col-md-4' },
	                                                            _react2.default.createElement(
	                                                                'label',
	                                                                null,
	                                                                'Brochure/Samples'
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'brochurefile' },
	                                                                this.state.optiontoshow == 'onlypartners' && _react2.default.createElement(
	                                                                    'div',
	                                                                    null,
	                                                                    this.state.brochures_b2b != '' && this.state.brochures_b2b != null && _react2.default.createElement(
	                                                                        'a',
	                                                                        { href: _constant.IMGBASEURL + 'uploads/' + this.state.brochures_b2b, target: '_blank' },
	                                                                        _react2.default.createElement('img', { src: _constant.IMGBASEURL + 'uploads/' + this.state.brochures_b2b_thumb, style: { width: "200px" }, className: 'fileicon' })
	                                                                    ),
	                                                                    (this.state.brochures_b2b == '' || this.state.brochures_b2b == null) && _react2.default.createElement(
	                                                                        'div',
	                                                                        null,
	                                                                        'None Uploaded'
	                                                                    )
	                                                                ),
	                                                                this.state.optiontoshow != 'onlypartners' && _react2.default.createElement(
	                                                                    'div',
	                                                                    null,
	                                                                    this.state.file1 != '' && this.state.file1 != null && _react2.default.createElement(
	                                                                        'a',
	                                                                        { href: _constant.IMGBASEURL + 'uploads/' + this.state.file1, target: '_blank' },
	                                                                        _react2.default.createElement('img', { src: _constant.IMGBASEURL + 'uploads/' + this.state.thumb1, style: { width: "200px" }, className: 'fileicon' })
	                                                                    )
	                                                                )
	                                                            )
	                                                        )
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'box-shadow-custom' },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'row' },
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'col-md-12 col-xs-12' },
	                                                            _react2.default.createElement(
	                                                                'span',
	                                                                { className: 'form-legend' },
	                                                                'Social Media'
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'form-group col-md-6' },
	                                                            _react2.default.createElement(
	                                                                'label',
	                                                                null,
	                                                                'Facebook'
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'logoimg' },
	                                                                this.state.facebook
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'form-group col-md-6' },
	                                                            _react2.default.createElement(
	                                                                'label',
	                                                                null,
	                                                                'Twitter'
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'bannerimg' },
	                                                                this.state.twitter
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'form-group col-md-4' },
	                                                            _react2.default.createElement(
	                                                                'label',
	                                                                null,
	                                                                'Instagram'
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'brochurefile' },
	                                                                this.state.instagram
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'form-group col-md-4' },
	                                                            _react2.default.createElement(
	                                                                'label',
	                                                                null,
	                                                                'Linkedin'
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'brochurefile' },
	                                                                this.state.linkedin
	                                                            )
	                                                        )
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'box-shadow-custom' },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'row' },
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'col-md-12 col-xs-12' },
	                                                            _react2.default.createElement(
	                                                                'b',
	                                                                null,
	                                                                'Status :'
	                                                            ),
	                                                            ' ',
	                                                            this.state.approval_status
	                                                        )
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'row' },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'col-md-6 col-xs-12' },
	                                                        _react2.default.createElement(
	                                                            'button',
	                                                            { id: 'btnSubmit1', className: this.state.approvedstatus == '' || this.state.approvedstatus == 0 ? "btn btn-blue" : "btn btn-blue hidden", onClick: this.approveit },
	                                                            'Approve'
	                                                        ),
	                                                        '\xA0',
	                                                        _react2.default.createElement(
	                                                            'button',
	                                                            { id: 'btnSubmit2', className: this.state.approvedstatus == 2 || this.state.approvedstatus == 0 ? "btn btn-blue hidden" : "btn btn-blue", onClick: this.disapproveit },
	                                                            'OnHold'
	                                                        ),
	                                                        '\xA0',
	                                                        _react2.default.createElement(
	                                                            'button',
	                                                            { id: 'btnSubmit3', className: "btn btn-blue", onClick: this.preview },
	                                                            'Preview'
	                                                        ),
	                                                        '\xA0',
	                                                        _react2.default.createElement(
	                                                            'button',
	                                                            { id: 'btnSendNotes', className: 'btn btn-blue', onClick: this.sendNotePopup },
	                                                            'Send Message'
	                                                        ),
	                                                        '\xA0',
	                                                        _react2.default.createElement(
	                                                            'button',
	                                                            { id: 'btnDelete', className: 'btn btn-blue', onClick: this.deleteEntry },
	                                                            'Delete'
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'col-md-6 col-xs-12 text-right ' },
	                                                        _react2.default.createElement(
	                                                            'a',
	                                                            { href: '/exclusive_partnerships' },
	                                                            'Back to List'
	                                                        )
	                                                    )
	                                                )
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactstrap.Modal,
	                        { isOpen: this.state.sendMessage, className: 'modalpopup' },
	                        _react2.default.createElement(
	                            _reactstrap.ModalHeader,
	                            null,
	                            'Send a message'
	                        ),
	                        _react2.default.createElement(
	                            _reactstrap.ModalBody,
	                            { className: 'p-0' },
	                            _react2.default.createElement(
	                                'div',
	                                { 'class': 'form-group' },
	                                _react2.default.createElement(
	                                    'label',
	                                    null,
	                                    'To: '
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    _react2.default.createElement(
	                                        'b',
	                                        null,
	                                        '\xA0',
	                                        this.state.name
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'notemessage' },
	                                    'Message will be sent to this email address :',
	                                    this.state.emailaddress
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { 'class': 'form-group' },
	                                _react2.default.createElement(
	                                    'label',
	                                    null,
	                                    'Message: '
	                                ),
	                                _react2.default.createElement('textarea', { name: 'message', 'class': 'form-control', rows: '6', onChange: this.handleChange })
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { 'class': 'form-group' },
	                                _react2.default.createElement('br', null),
	                                _react2.default.createElement(
	                                    'button',
	                                    { 'class': 'btn btn-primary btn-sm', onClick: this.sendaMessage },
	                                    'Send'
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactstrap.ModalFooter,
	                            null,
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'row' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-12 text-center' },
	                                    _react2.default.createElement(
	                                        'button',
	                                        { className: 'btn btn-sm btn-default', onClick: this.cancelPop1 },
	                                        'Close'
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactstrap.Modal,
	                        { size: 'lg', isOpen: this.state.detailedpreview, className: 'modalpopup' },
	                        _react2.default.createElement(
	                            _reactstrap.ModalHeader,
	                            null,
	                            'Preview - Detail Page View'
	                        ),
	                        _react2.default.createElement(
	                            _reactstrap.ModalBody,
	                            { className: 'p-0 detailedpreview' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'row' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-lg-12 col-sm-12 col-md-12 col-xs-12 no-padding' },
	                                    _react2.default.createElement('img', { src: _headerimage2.default, 'class': 'headerimagewidth' })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'row' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-lg-12 col-sm-12 col-md-12 col-xs-12 no-padding' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'row' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'col-lg-2 col-sm-12 col-md-12 col-xs-12 no-padding' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { 'class': 'per20 logobox' },
	                                                _react2.default.createElement('img', { src: _constant.IMGBASEURL + "uploads/" + this.state.logo, 'class': 'orgphoto' })
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'col-lg-10 col-sm-12 col-md-12 col-xs-12 no-padding' },
	                                            _react2.default.createElement(
	                                                'a',
	                                                { href: '#', target: '_blank' },
	                                                _react2.default.createElement('img', { src: _constant.IMGBASEURL + "uploads/" + this.state.banners, 'class': 'bannerimage' })
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'row' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'col-lg-2 leftmenu' },
	                                            _react2.default.createElement('img', { src: _leftmenuimage2.default, 'class': 'leftmenuimg' })
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'col-lg-8' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { 'class': 'onDemandInfo', id: 'onDemandInfo' },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { id: 'description_section' },
	                                                    _react2.default.createElement(
	                                                        'h3',
	                                                        null,
	                                                        'About Us'
	                                                    ),
	                                                    _react2.default.createElement('div', { 'class': 'aboutinfo', dangerouslySetInnerHTML: { __html: this.state.description } })
	                                                ),
	                                                _react2.default.createElement('br', null),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { id: 'exclusive_offers_section' },
	                                                    _react2.default.createElement(
	                                                        'h3',
	                                                        null,
	                                                        'Exclusive Offers'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { 'class': 'offer_row borderwithcolor1' },
	                                                        this.state.offerimage1 != '' && this.state.offerimage1 != null && _react2.default.createElement(
	                                                            'div',
	                                                            { 'class': 'offer_left_img' },
	                                                            _react2.default.createElement('img', { src: "https://api.bewise.in/uploads/" + this.state.offerimage1 })
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { 'class': 'offer_right_text' },
	                                                            _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: this.state.offer1desc } })
	                                                        )
	                                                    ),
	                                                    this.state.contenttype == 'bewisecustom' && _react2.default.createElement(
	                                                        'button',
	                                                        { name: 'participate', 'class': 'btn btn-primary' },
	                                                        'Participate'
	                                                    ),
	                                                    this.state.contenttype == 'href' && _react2.default.createElement(
	                                                        'div',
	                                                        null,
	                                                        _react2.default.createElement(
	                                                            'a',
	                                                            { href: this.state.link },
	                                                            this.state.clicktext
	                                                        )
	                                                    ),
	                                                    this.state.contenttype == 'btn' && _react2.default.createElement(
	                                                        'div',
	                                                        null,
	                                                        _react2.default.createElement(
	                                                            'a',
	                                                            { href: this.state.link, 'class': 'btn btn-primary btn-sm' },
	                                                            this.state.clicktext
	                                                        )
	                                                    )
	                                                ),
	                                                _react2.default.createElement('br', null),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { id: 'video_section' },
	                                                    _react2.default.createElement(
	                                                        'h3',
	                                                        null,
	                                                        'Videos'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { 'class': 'row n5v3k' },
	                                                        this.state.video != '' && this.state.video != null && _react2.default.createElement(
	                                                            'div',
	                                                            { 'class': 'container' },
	                                                            _react2.default.createElement(
	                                                                'video',
	                                                                { width: '320', height: '240', controls: true },
	                                                                _react2.default.createElement('source', { src: this.state.video, type: 'video/mp4' }),
	                                                                'Your browser does not support the video tag.'
	                                                            )
	                                                        ),
	                                                        this.state.videourl !== '' && this.state.videourl != null && _react2.default.createElement(
	                                                            'div',
	                                                            { 'class': 'container' },
	                                                            _react2.default.createElement('iframe', { width: '420', height: '315', src: "https://www.youtube.com/embed/" + this.state.videourl })
	                                                        )
	                                                    )
	                                                ),
	                                                _react2.default.createElement('br', null),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { id: 'contactinfo_section' },
	                                                    _react2.default.createElement(
	                                                        'h3',
	                                                        null,
	                                                        'Contact Info'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { 'class': 'col-lg-8 col-sm-12 col-md-12 col-xs-12 text-left' },
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { 'class': 'per100 text-left' },
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { 'class': 'bs_social' },
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    null,
	                                                                    ' Email Address: ',
	                                                                    _react2.default.createElement(
	                                                                        'b',
	                                                                        null,
	                                                                        this.state.emailaddress
	                                                                    ),
	                                                                    ' '
	                                                                ),
	                                                                _react2.default.createElement('br', null),
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    null,
	                                                                    ' Website: ',
	                                                                    _react2.default.createElement(
	                                                                        'b',
	                                                                        null,
	                                                                        _react2.default.createElement(
	                                                                            'a',
	                                                                            { target: '_blank', href: this.state.website },
	                                                                            this.state.website
	                                                                        )
	                                                                    ),
	                                                                    ' '
	                                                                ),
	                                                                _react2.default.createElement('br', null),
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    null,
	                                                                    ' Contact Number: ',
	                                                                    _react2.default.createElement(
	                                                                        'b',
	                                                                        null,
	                                                                        this.state.contact_number
	                                                                    ),
	                                                                    ' '
	                                                                ),
	                                                                _react2.default.createElement('br', null)
	                                                            )
	                                                        )
	                                                    )
	                                                ),
	                                                _react2.default.createElement('br', null),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { id: 'review_section' },
	                                                    _react2.default.createElement(
	                                                        'h3',
	                                                        { 'class': 'review_head' },
	                                                        'Review',
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { 'class': 'floatright' },
	                                                            _react2.default.createElement(
	                                                                'small',
	                                                                { 'class': 'pointer' },
	                                                                _react2.default.createElement('i', { 'class': 'fa fa-plus', 'aria-hidden': 'true' })
	                                                            )
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { 'class': 'reviewinfo' },
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { 'class': 'col-md-12' },
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { 'class': 'detailBox' },
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    { 'class': 'form-comments' },
	                                                                    _react2.default.createElement(
	                                                                        'p',
	                                                                        null,
	                                                                        'Click here to view Comments!...'
	                                                                    )
	                                                                )
	                                                            )
	                                                        )
	                                                    )
	                                                ),
	                                                _react2.default.createElement('br', null)
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'col-lg-2 rightmenu' },
	                                            _react2.default.createElement('img', { src: _rightmenuimage2.default, 'class': 'rightmenuimg' })
	                                        )
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { 'class': 'row' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'col-md-12 footerp' },
	                                    _react2.default.createElement('img', { src: _footerpreview2.default, 'class': 'headerimagewidth' })
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactstrap.ModalFooter,
	                            null,
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'row' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-12 text-center' },
	                                    _react2.default.createElement(
	                                        'button',
	                                        { className: 'btn btn-sm btn-default', onClick: this.cancelPop2 },
	                                        'Close'
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return exclusiveParterView;
	}(_react.Component);
	
	exports.default = exclusiveParterView;

/***/ },
/* 933 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _constant = __webpack_require__(21);
	
	var _reactstrap = __webpack_require__(17);
	
	var _footerpreview = __webpack_require__(137);
	
	var _footerpreview2 = _interopRequireDefault(_footerpreview);
	
	var _previewheader = __webpack_require__(140);
	
	var _previewheader2 = _interopRequireDefault(_previewheader);
	
	var _headerimage = __webpack_require__(138);
	
	var _headerimage2 = _interopRequireDefault(_headerimage);
	
	var _leftmenuimage = __webpack_require__(139);
	
	var _leftmenuimage2 = _interopRequireDefault(_leftmenuimage);
	
	var _rightmenuimage = __webpack_require__(141);
	
	var _rightmenuimage2 = _interopRequireDefault(_rightmenuimage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var exclusiveParterView = function (_Component) {
	    _inherits(exclusiveParterView, _Component);
	
	    function exclusiveParterView(props) {
	        _classCallCheck(this, exclusiveParterView);
	
	        var _this = _possibleConstructorReturn(this, (exclusiveParterView.__proto__ || Object.getPrototypeOf(exclusiveParterView)).call(this, props));
	
	        _this.sendNotePopup = function () {
	            _this.setState({ sendMessage: true });
	        };
	
	        _this.approveit = function () {
	
	            var insData = JSON.stringify({
	                login_id: _this.state.login_id,
	                approved: 1
	            });
	
	            (0, _FetchCall.changeStatusExclPart)(insData).then(function (response) {
	
	                var toastr = '';
	                if (response.status === 1) {
	                    alert("Approved successfully");
	                } else {
	                    alert("error disapproving");
	                }
	            });
	        };
	
	        _this.disapproveit = function () {
	
	            var insData = JSON.stringify({
	                login_id: _this.state.login_id,
	                approved: 0
	            });
	
	            (0, _FetchCall.changeStatusExclPart)(insData).then(function (response) {
	
	                var toastr = '';
	                if (response.status === 1) {
	                    alert("Disapproved successfully");
	                } else {
	                    alert("error disapproving");
	                }
	            });
	        };
	
	        _this.sendaMessage = function () {
	
	            var insData = JSON.stringify({
	                login_id: _this.state.login_id,
	                message: _this.state.message
	            });
	
	            (0, _FetchCall.sendAdminMessage)(insData).then(function (response) {
	
	                var toastr = '';
	                if (response.status === 1) {
	                    alert("Message is sent successfully");
	                } else {
	                    alert("error sending a message");
	                }
	            });
	        };
	
	        _this.handleChange = function (e) {
	            var propName = e.target.name;
	            _this.setState(_defineProperty({}, e.target.name, e.target.value));
	        };
	
	        _this.cancelPop1 = function () {
	            _this.setState({
	                sendMessage: false
	            });
	        };
	
	        _this.cancelPop2 = function () {
	            _this.setState({
	                detailedpreview: false
	            });
	        };
	
	        _this.preview = function () {
	            _this.setState({ detailedpreview: true });
	        };
	
	        _this.handleSubmit = function (e) {
	
	            e.preventDefault();
	
	            //console.log("nae1", e.target.program_name);
	
	            var insData = {
	                camp_id: _this.camp_id,
	                status: 1
	            };
	
	            console.log('insData', insData);
	        };
	
	        var qrystr = window.location.search;
	        var urlParams = new URLSearchParams(qrystr);
	
	        var id = urlParams.get('id');
	
	        _this.state = {
	            sendMessage: false,
	            detailedpreview: false,
	            banners: '',
	            auth_data: JSON.parse(localStorage.getItem("user_data")),
	            user_data: localStorage.getItem('user_data') ? JSON.parse(localStorage.getItem('user_data')) : [],
	            authentication: localStorage.getItem('authentication') ? JSON.parse(localStorage.getItem('authentication')) : false
	        };
	
	        _this.id = _this.props.match.params.id ? _this.props.match.params.id : '';
	
	        _this.exclusivePartnerShipEntryB2B(_this.id);
	
	        return _this;
	    }
	
	    _createClass(exclusiveParterView, [{
	        key: 'exclusivePartnerShipEntryB2B',
	        value: function () {
	            var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(id) {
	                var _this2 = this;
	
	                var req;
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                req = JSON.stringify({
	                                    id: id
	                                });
	
	                                (0, _FetchCall.getExclPtnrsEntryById)(req).then(function (response) {
	
	                                    if (response.status === 1) {
	
	                                        var data = response.result;
	
	                                        _this2.setState({ approval_status: "Pending" });
	                                        _this2.setState({ login_id: data.login_id });
	                                        _this2.setState({ emailaddress: data.emailaddress });
	                                        _this2.setState({ approvedstatus: data.approved });
	                                        _this2.setState({ banners: data.banners != null ? data.banners : '' });
	
	                                        if (data.approved == 1) {
	                                            _this2.setState({ approval_status: "Approved" });
	                                        }
	                                        if (data.approved == 2) {
	                                            _this2.setState({ approval_status: "Disapproved" });
	                                        }
	                                        _this2.setState(response.result);
	                                    }
	                                });
	
	                            case 2:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function exclusivePartnerShipEntryB2B(_x) {
	                return _ref.apply(this, arguments);
	            }
	
	            return exclusivePartnerShipEntryB2B;
	        }()
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	
	            var user_data = localStorage.getItem("user_data");
	            var auth_data = JSON.parse(user_data);
	        }
	    }, {
	        key: 'UNSAFE_componentWillMount',
	        value: function UNSAFE_componentWillMount() {}
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            window.jQuery('.selectpicker').selectpicker('refresh');
	        }
	    }, {
	        key: 'deleteEntry',
	        value: function deleteEntry(i, e) {
	            var _this3 = this;
	
	            if (window.confirm("Are you sure?")) {
	
	                var req_c = JSON.stringify({
	                    camp_id: this.camp_id
	                });
	                var THIS = this;
	                var toastr = '';
	                (0, _FetchCall.deleteEntry)(req_c).then(function () {
	                    var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(res) {
	                        return _regenerator2.default.wrap(function _callee2$(_context2) {
	                            while (1) {
	                                switch (_context2.prev = _context2.next) {
	                                    case 0:
	                                        if (res.status === 1) {
	                                            alert(res.message);
	                                            _this3.props.history.push('/users/exclusivepartners');
	                                        }
	
	                                    case 1:
	                                    case 'end':
	                                        return _context2.stop();
	                                }
	                            }
	                        }, _callee2, _this3);
	                    }));
	
	                    return function (_x2) {
	                        return _ref2.apply(this, arguments);
	                    };
	                }());
	            }
	        }
	    }, {
	        key: 'escapeRegexCharacters',
	        value: function escapeRegexCharacters(str) {
	            return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _state$auth_data = this.state.auth_data,
	                role = _state$auth_data.role,
	                user_name = _state$auth_data.user_name;
	            //console.log(this.state.banner);
	
	            var _state = this.state,
	                banners = _state.banners,
	                banners_b2b = _state.banners_b2b;
	            //console.log(banners);
	
	            var offer1 = _constant.IMGBASEURL + 'uploads/' + this.state.offerimage1;
	            var offer2 = _constant.IMGBASEURL + 'uploads/' + this.state.offerimage2;
	
	            return _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _react2.default.createElement(
	                    _layout2.default,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { 'class': 'col-12 grid-margin' },
	                        _react2.default.createElement(
	                            'div',
	                            { 'class': 'card' },
	                            _react2.default.createElement(
	                                'div',
	                                { 'class': 'card-body' },
	                                _react2.default.createElement(
	                                    'h4',
	                                    { 'class': 'card-title' },
	                                    'Exclusive Partnership Management - View/Manage'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'content-sec col-md-12 col-xs-12 pad-no mar-t-no' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'tab-content' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { id: 'company-info', className: 'tab-pane in active' },
	                                            _react2.default.createElement(
	                                                'form',
	                                                { onSubmit: this.handleSubmit, className: 'custom-form invoice-form col-md-12 col-xs-12 legend-form pad-no', method: 'post' },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'box-shadow-custom' },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'row' },
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'form-group col-md-6' },
	                                                            _react2.default.createElement(
	                                                                'label',
	                                                                null,
	                                                                'Name ',
	                                                                _react2.default.createElement(
	                                                                    'span',
	                                                                    { className: 'astrick' },
	                                                                    '*'
	                                                                )
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                null,
	                                                                this.state.name
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'form-group col-md-6' },
	                                                            _react2.default.createElement(
	                                                                'label',
	                                                                null,
	                                                                'Type ',
	                                                                _react2.default.createElement(
	                                                                    'span',
	                                                                    { className: 'astrick' },
	                                                                    '*'
	                                                                )
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                null,
	                                                                this.state.optiontoshow == 'both' ? "B2B/B2C" : this.state.optiontoshow == 'onlypartners' ? "B2B" : "B2C"
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'form-group col-md-6' },
	                                                            _react2.default.createElement(
	                                                                'label',
	                                                                null,
	                                                                'Address '
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                null,
	                                                                this.state.address
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'form-group col-md-6' },
	                                                            _react2.default.createElement(
	                                                                'label',
	                                                                null,
	                                                                'Email Address '
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                null,
	                                                                this.state.emailaddress
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'form-group col-md-6' },
	                                                            _react2.default.createElement(
	                                                                'label',
	                                                                null,
	                                                                'Website '
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                null,
	                                                                this.state.website
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'form-group col-md-12' },
	                                                            _react2.default.createElement(
	                                                                'label',
	                                                                null,
	                                                                'Description '
	                                                            ),
	                                                            _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: this.state.description_b2b } })
	                                                        )
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'box-shadow-custom' },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'row' },
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'col-md-12 col-xs-12' },
	                                                            _react2.default.createElement(
	                                                                'span',
	                                                                { className: 'form-legend' },
	                                                                'Exclusive Offers'
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { 'class': 'containerrow' },
	                                                            (this.state.offerimage1 == null || this.state.offerimage1 == '') && _react2.default.createElement(
	                                                                'div',
	                                                                { 'class': 'offer_row borderwithcolor1' },
	                                                                'No offers entered'
	                                                            ),
	                                                            this.state.offerimage1 != null && this.state.offerimage1 != '' && _react2.default.createElement(
	                                                                'div',
	                                                                { 'class': 'offer_row borderwithcolor1' },
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    { 'class': 'offer_left_img', style: { width: "200px" } },
	                                                                    _react2.default.createElement('img', { src: _constant.IMGBASEURL + 'uploads/' + this.state.offerimage1 })
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    { 'class': 'offer_right_text' },
	                                                                    _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: this.state.offer1desc_b2b } })
	                                                                )
	                                                            )
	                                                        )
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'box-shadow-custom' },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'row' },
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'col-md-12 col-xs-12' },
	                                                            _react2.default.createElement(
	                                                                'span',
	                                                                { className: 'form-legend' },
	                                                                'Media Information'
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'form-group col-md-6' },
	                                                            _react2.default.createElement(
	                                                                'label',
	                                                                null,
	                                                                'Logo'
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'logoimg', style: { width: "200px" } },
	                                                                _react2.default.createElement('img', { src: _constant.IMGBASEURL + 'uploads/' + this.state.logo })
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'form-group col-md-6' },
	                                                            _react2.default.createElement(
	                                                                'label',
	                                                                null,
	                                                                'Banner'
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'bannerimg', style: { width: "200px" } },
	                                                                _react2.default.createElement('img', { style: { width: "100%" }, src: _constant.IMGBASEURL + 'uploads/' + this.state.banners_b2b })
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'form-group col-md-4' },
	                                                            _react2.default.createElement(
	                                                                'label',
	                                                                null,
	                                                                'Brochure/Samples'
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'brochurefile' },
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    null,
	                                                                    this.state.brochures_b2b != '' && this.state.brochures_b2b != null && _react2.default.createElement(
	                                                                        'a',
	                                                                        { href: _constant.IMGBASEURL + 'uploads/' + this.state.brochures_b2b, target: '_blank' },
	                                                                        _react2.default.createElement('img', { src: _constant.IMGBASEURL + 'uploads/' + this.state.brochures_b2b_thumb, style: { width: "200px" }, className: 'fileicon' })
	                                                                    ),
	                                                                    (this.state.brochures_b2b == '' || this.state.brochures_b2b == null) && _react2.default.createElement(
	                                                                        'div',
	                                                                        null,
	                                                                        'None Uploaded'
	                                                                    )
	                                                                )
	                                                            )
	                                                        )
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'box-shadow-custom' },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'row' },
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'col-md-12 col-xs-12' },
	                                                            _react2.default.createElement(
	                                                                'span',
	                                                                { className: 'form-legend' },
	                                                                'Social Media'
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'form-group col-md-6' },
	                                                            _react2.default.createElement(
	                                                                'label',
	                                                                null,
	                                                                'Facebook'
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'logoimg' },
	                                                                this.state.facebook
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'form-group col-md-6' },
	                                                            _react2.default.createElement(
	                                                                'label',
	                                                                null,
	                                                                'Twitter'
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'bannerimg' },
	                                                                this.state.twitter
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'form-group col-md-4' },
	                                                            _react2.default.createElement(
	                                                                'label',
	                                                                null,
	                                                                'Instagram'
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'brochurefile' },
	                                                                this.state.instagram
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'form-group col-md-4' },
	                                                            _react2.default.createElement(
	                                                                'label',
	                                                                null,
	                                                                'Linkedin'
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'brochurefile' },
	                                                                this.state.linkedin
	                                                            )
	                                                        )
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'box-shadow-custom' },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'row' },
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'col-md-12 col-xs-12' },
	                                                            _react2.default.createElement(
	                                                                'b',
	                                                                null,
	                                                                'Status :'
	                                                            ),
	                                                            ' ',
	                                                            this.state.approval_status
	                                                        )
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'row' },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'col-md-6 col-xs-12' },
	                                                        _react2.default.createElement(
	                                                            'button',
	                                                            { id: 'btnSubmit1', className: this.state.approvedstatus == '' || this.state.approvedstatus == 0 ? "btn btn-blue" : "btn btn-blue hidden", onClick: this.approveit },
	                                                            'Approve'
	                                                        ),
	                                                        '\xA0',
	                                                        _react2.default.createElement(
	                                                            'button',
	                                                            { id: 'btnSubmit2', className: this.state.approvedstatus == 2 || this.state.approvedstatus == 0 ? "btn btn-blue hidden" : "btn btn-blue", onClick: this.disapproveit },
	                                                            'OnHold'
	                                                        ),
	                                                        '\xA0',
	                                                        _react2.default.createElement(
	                                                            'button',
	                                                            { id: 'btnSubmit3', className: "btn btn-blue", onClick: this.preview },
	                                                            'Preview'
	                                                        ),
	                                                        '\xA0',
	                                                        _react2.default.createElement(
	                                                            'button',
	                                                            { id: 'btnSendNotes', className: 'btn btn-blue', onClick: this.sendNotePopup },
	                                                            'Send Message'
	                                                        ),
	                                                        '\xA0',
	                                                        _react2.default.createElement(
	                                                            'button',
	                                                            { id: 'btnDelete', className: 'btn btn-blue', onClick: this.deleteEntry },
	                                                            'Delete'
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'col-md-6 col-xs-12 text-right ' },
	                                                        _react2.default.createElement(
	                                                            'a',
	                                                            { href: '/exclusive_partnerships' },
	                                                            'Back to List'
	                                                        )
	                                                    )
	                                                )
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactstrap.Modal,
	                        { isOpen: this.state.sendMessage, className: 'modalpopup' },
	                        _react2.default.createElement(
	                            _reactstrap.ModalHeader,
	                            null,
	                            'Send a message'
	                        ),
	                        _react2.default.createElement(
	                            _reactstrap.ModalBody,
	                            { className: 'p-0' },
	                            _react2.default.createElement(
	                                'div',
	                                { 'class': 'form-group' },
	                                _react2.default.createElement(
	                                    'label',
	                                    null,
	                                    'To: '
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    _react2.default.createElement(
	                                        'b',
	                                        null,
	                                        '\xA0',
	                                        this.state.name
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'notemessage' },
	                                    'Message will be sent to this email address :',
	                                    this.state.emailaddress
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { 'class': 'form-group' },
	                                _react2.default.createElement(
	                                    'label',
	                                    null,
	                                    'Message: '
	                                ),
	                                _react2.default.createElement('textarea', { name: 'message', 'class': 'form-control', rows: '6', onChange: this.handleChange })
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { 'class': 'form-group' },
	                                _react2.default.createElement('br', null),
	                                _react2.default.createElement(
	                                    'button',
	                                    { 'class': 'btn btn-primary btn-sm', onClick: this.sendaMessage },
	                                    'Send'
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactstrap.ModalFooter,
	                            null,
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'row' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-12 text-center' },
	                                    _react2.default.createElement(
	                                        'button',
	                                        { className: 'btn btn-sm btn-default', onClick: this.cancelPop1 },
	                                        'Close'
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactstrap.Modal,
	                        { size: 'lg', isOpen: this.state.detailedpreview, className: 'modalpopup' },
	                        _react2.default.createElement(
	                            _reactstrap.ModalHeader,
	                            null,
	                            'Preview - Detail Page View'
	                        ),
	                        _react2.default.createElement(
	                            _reactstrap.ModalBody,
	                            { className: 'p-0 detailedpreview' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'row' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-lg-12 col-sm-12 col-md-12 col-xs-12 no-padding' },
	                                    _react2.default.createElement('img', { src: _headerimage2.default, 'class': 'headerimagewidth' })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'row' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-lg-12 col-sm-12 col-md-12 col-xs-12 no-padding' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'row' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'col-lg-2 col-sm-12 col-md-12 col-xs-12 no-padding' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { 'class': 'per20 logobox' },
	                                                _react2.default.createElement('img', { src: _constant.IMGBASEURL + "uploads/" + this.state.logo, 'class': 'orgphoto' })
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'col-lg-10 col-sm-12 col-md-12 col-xs-12 no-padding' },
	                                            _react2.default.createElement(
	                                                'a',
	                                                { href: '#', target: '_blank' },
	                                                _react2.default.createElement('img', { src: _constant.IMGBASEURL + "uploads/" + this.state.banners, 'class': 'bannerimage' })
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'row' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'col-lg-2 leftmenu' },
	                                            _react2.default.createElement('img', { src: _leftmenuimage2.default, 'class': 'leftmenuimg' })
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'col-lg-8' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { 'class': 'onDemandInfo', id: 'onDemandInfo' },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { id: 'description_section' },
	                                                    _react2.default.createElement(
	                                                        'h3',
	                                                        null,
	                                                        'About Us'
	                                                    ),
	                                                    _react2.default.createElement('div', { 'class': 'aboutinfo', dangerouslySetInnerHTML: { __html: this.state.description } })
	                                                ),
	                                                _react2.default.createElement('br', null),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { id: 'exclusive_offers_section' },
	                                                    _react2.default.createElement(
	                                                        'h3',
	                                                        null,
	                                                        'Exclusive Offers'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { 'class': 'offer_row borderwithcolor1' },
	                                                        this.state.offerimage1 != '' && this.state.offerimage1 != null && _react2.default.createElement(
	                                                            'div',
	                                                            { 'class': 'offer_left_img' },
	                                                            _react2.default.createElement('img', { src: "https://api.bewise.in/uploads/" + this.state.offerimage1 })
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { 'class': 'offer_right_text' },
	                                                            _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: this.state.offer1desc } })
	                                                        )
	                                                    ),
	                                                    this.state.contenttype == 'bewisecustom' && _react2.default.createElement(
	                                                        'button',
	                                                        { name: 'participate', 'class': 'btn btn-primary' },
	                                                        'Participate'
	                                                    ),
	                                                    this.state.contenttype == 'href' && _react2.default.createElement(
	                                                        'div',
	                                                        null,
	                                                        _react2.default.createElement(
	                                                            'a',
	                                                            { href: this.state.link },
	                                                            this.state.clicktext
	                                                        )
	                                                    ),
	                                                    this.state.contenttype == 'btn' && _react2.default.createElement(
	                                                        'div',
	                                                        null,
	                                                        _react2.default.createElement(
	                                                            'a',
	                                                            { href: this.state.link, 'class': 'btn btn-primary btn-sm' },
	                                                            this.state.clicktext
	                                                        )
	                                                    )
	                                                ),
	                                                _react2.default.createElement('br', null),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { id: 'video_section' },
	                                                    _react2.default.createElement(
	                                                        'h3',
	                                                        null,
	                                                        'Videos'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { 'class': 'row n5v3k' },
	                                                        this.state.video != '' && this.state.video != null && _react2.default.createElement(
	                                                            'div',
	                                                            { 'class': 'container' },
	                                                            _react2.default.createElement(
	                                                                'video',
	                                                                { width: '320', height: '240', controls: true },
	                                                                _react2.default.createElement('source', { src: this.state.video, type: 'video/mp4' }),
	                                                                'Your browser does not support the video tag.'
	                                                            )
	                                                        ),
	                                                        this.state.videourl !== '' && this.state.videourl != null && _react2.default.createElement(
	                                                            'div',
	                                                            { 'class': 'container' },
	                                                            _react2.default.createElement('iframe', { width: '420', height: '315', src: "https://www.youtube.com/embed/" + this.state.videourl })
	                                                        )
	                                                    )
	                                                ),
	                                                _react2.default.createElement('br', null),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { id: 'contactinfo_section' },
	                                                    _react2.default.createElement(
	                                                        'h3',
	                                                        null,
	                                                        'Contact Info'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { 'class': 'col-lg-8 col-sm-12 col-md-12 col-xs-12 text-left' },
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { 'class': 'per100 text-left' },
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { 'class': 'bs_social' },
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    null,
	                                                                    ' Email Address: ',
	                                                                    _react2.default.createElement(
	                                                                        'b',
	                                                                        null,
	                                                                        this.state.emailaddress
	                                                                    ),
	                                                                    ' '
	                                                                ),
	                                                                _react2.default.createElement('br', null),
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    null,
	                                                                    ' Website: ',
	                                                                    _react2.default.createElement(
	                                                                        'b',
	                                                                        null,
	                                                                        _react2.default.createElement(
	                                                                            'a',
	                                                                            { target: '_blank', href: this.state.website },
	                                                                            this.state.website
	                                                                        )
	                                                                    ),
	                                                                    ' '
	                                                                ),
	                                                                _react2.default.createElement('br', null),
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    null,
	                                                                    ' Contact Number: ',
	                                                                    _react2.default.createElement(
	                                                                        'b',
	                                                                        null,
	                                                                        this.state.contact_number
	                                                                    ),
	                                                                    ' '
	                                                                ),
	                                                                _react2.default.createElement('br', null)
	                                                            )
	                                                        )
	                                                    )
	                                                ),
	                                                _react2.default.createElement('br', null),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { id: 'review_section' },
	                                                    _react2.default.createElement(
	                                                        'h3',
	                                                        { 'class': 'review_head' },
	                                                        'Review',
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { 'class': 'floatright' },
	                                                            _react2.default.createElement(
	                                                                'small',
	                                                                { 'class': 'pointer' },
	                                                                _react2.default.createElement('i', { 'class': 'fa fa-plus', 'aria-hidden': 'true' })
	                                                            )
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { 'class': 'reviewinfo' },
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { 'class': 'col-md-12' },
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { 'class': 'detailBox' },
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    { 'class': 'form-comments' },
	                                                                    _react2.default.createElement(
	                                                                        'p',
	                                                                        null,
	                                                                        'Click here to view Comments!...'
	                                                                    )
	                                                                )
	                                                            )
	                                                        )
	                                                    )
	                                                ),
	                                                _react2.default.createElement('br', null)
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'col-lg-2 rightmenu' },
	                                            _react2.default.createElement('img', { src: _rightmenuimage2.default, 'class': 'rightmenuimg' })
	                                        )
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { 'class': 'row' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'col-md-12 footerp' },
	                                    _react2.default.createElement('img', { src: _footerpreview2.default, 'class': 'headerimagewidth' })
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactstrap.ModalFooter,
	                            null,
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'row' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-12 text-center' },
	                                    _react2.default.createElement(
	                                        'button',
	                                        { className: 'btn btn-sm btn-default', onClick: this.cancelPop2 },
	                                        'Close'
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return exclusiveParterView;
	}(_react.Component);
	
	exports.default = exclusiveParterView;

/***/ },
/* 934 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _constant = __webpack_require__(21);
	
	var _reactstrap = __webpack_require__(17);
	
	var _footerpreview = __webpack_require__(137);
	
	var _footerpreview2 = _interopRequireDefault(_footerpreview);
	
	var _previewheader = __webpack_require__(140);
	
	var _previewheader2 = _interopRequireDefault(_previewheader);
	
	var _headerimage = __webpack_require__(138);
	
	var _headerimage2 = _interopRequireDefault(_headerimage);
	
	var _leftmenuimage = __webpack_require__(139);
	
	var _leftmenuimage2 = _interopRequireDefault(_leftmenuimage);
	
	var _rightmenuimage = __webpack_require__(141);
	
	var _rightmenuimage2 = _interopRequireDefault(_rightmenuimage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var exclusiveParterView = function (_Component) {
	    _inherits(exclusiveParterView, _Component);
	
	    function exclusiveParterView(props) {
	        _classCallCheck(this, exclusiveParterView);
	
	        var _this = _possibleConstructorReturn(this, (exclusiveParterView.__proto__ || Object.getPrototypeOf(exclusiveParterView)).call(this, props));
	
	        _this.sendNotePopup = function () {
	            _this.setState({ sendMessage: true });
	        };
	
	        _this.approveit = function () {
	
	            var insData = JSON.stringify({
	                login_id: _this.state.login_id,
	                approved: 1
	            });
	
	            (0, _FetchCall.changeStatusExclPart)(insData).then(function (response) {
	
	                var toastr = '';
	                if (response.status === 1) {
	                    alert("Approved successfully");
	                } else {
	                    alert("error disapproving");
	                }
	            });
	        };
	
	        _this.disapproveit = function () {
	
	            var insData = JSON.stringify({
	                login_id: _this.state.login_id,
	                approved: 0
	            });
	
	            (0, _FetchCall.changeStatusExclPart)(insData).then(function (response) {
	
	                var toastr = '';
	                if (response.status === 1) {
	                    alert("Disapproved successfully");
	                } else {
	                    alert("error disapproving");
	                }
	            });
	        };
	
	        _this.sendaMessage = function () {
	
	            var insData = JSON.stringify({
	                login_id: _this.state.login_id,
	                message: _this.state.message
	            });
	
	            (0, _FetchCall.sendAdminMessage)(insData).then(function (response) {
	
	                var toastr = '';
	                if (response.status === 1) {
	                    alert("Message is sent successfully");
	                } else {
	                    alert("error sending a message");
	                }
	            });
	        };
	
	        _this.handleChange = function (e) {
	            var propName = e.target.name;
	            _this.setState(_defineProperty({}, e.target.name, e.target.value));
	        };
	
	        _this.cancelPop1 = function () {
	            _this.setState({
	                sendMessage: false
	            });
	        };
	
	        _this.cancelPop2 = function () {
	            _this.setState({
	                detailedpreview: false
	            });
	        };
	
	        _this.preview = function () {
	            _this.setState({ detailedpreview: true });
	        };
	
	        _this.handleSubmit = function (e) {
	
	            e.preventDefault();
	
	            //console.log("nae1", e.target.program_name);
	
	            var insData = {
	                camp_id: _this.camp_id,
	                status: 1
	            };
	
	            console.log('insData', insData);
	        };
	
	        var qrystr = window.location.search;
	        var urlParams = new URLSearchParams(qrystr);
	
	        var id = urlParams.get('id');
	
	        _this.state = {
	            sendMessage: false,
	            detailedpreview: false,
	            banners: '',
	            auth_data: JSON.parse(localStorage.getItem("user_data")),
	            user_data: localStorage.getItem('user_data') ? JSON.parse(localStorage.getItem('user_data')) : [],
	            authentication: localStorage.getItem('authentication') ? JSON.parse(localStorage.getItem('authentication')) : false
	        };
	
	        _this.id = _this.props.match.params.id ? _this.props.match.params.id : '';
	
	        _this.exclusivePartnerShipEntryB2C(_this.id);
	
	        return _this;
	    }
	
	    _createClass(exclusiveParterView, [{
	        key: 'exclusivePartnerShipEntryB2C',
	        value: function () {
	            var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(id, type) {
	                var _this2 = this;
	
	                var req;
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                req = JSON.stringify({
	                                    id: id
	                                });
	
	                                (0, _FetchCall.getExclPtnrsEntryById)(req).then(function (response) {
	
	                                    if (response.status === 1) {
	
	                                        var data = response.result;
	
	                                        _this2.setState({ approval_status: "Pending" });
	                                        _this2.setState({ login_id: data.login_id });
	                                        _this2.setState({ emailaddress: data.emailaddress });
	                                        _this2.setState({ approvedstatus: data.approved });
	                                        _this2.setState({ banners: data.banners != null ? data.banners : '' });
	
	                                        if (data.approved == 1) {
	                                            _this2.setState({ approval_status: "Approved" });
	                                        }
	                                        if (data.approved == 2) {
	                                            _this2.setState({ approval_status: "Disapproved" });
	                                        }
	                                        _this2.setState(response.result);
	                                    }
	                                });
	
	                            case 2:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function exclusivePartnerShipEntryB2C(_x, _x2) {
	                return _ref.apply(this, arguments);
	            }
	
	            return exclusivePartnerShipEntryB2C;
	        }()
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	
	            var user_data = localStorage.getItem("user_data");
	            var auth_data = JSON.parse(user_data);
	        }
	    }, {
	        key: 'UNSAFE_componentWillMount',
	        value: function UNSAFE_componentWillMount() {}
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            window.jQuery('.selectpicker').selectpicker('refresh');
	        }
	    }, {
	        key: 'deleteEntry',
	        value: function deleteEntry(i, e) {
	            var _this3 = this;
	
	            if (window.confirm("Are you sure?")) {
	
	                var req_c = JSON.stringify({
	                    camp_id: this.camp_id
	                });
	                var THIS = this;
	                var toastr = '';
	                (0, _FetchCall.deleteEntry)(req_c).then(function () {
	                    var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(res) {
	                        return _regenerator2.default.wrap(function _callee2$(_context2) {
	                            while (1) {
	                                switch (_context2.prev = _context2.next) {
	                                    case 0:
	                                        if (res.status === 1) {
	                                            alert(res.message);
	                                            _this3.props.history.push('/users/exclusivepartners');
	                                        }
	
	                                    case 1:
	                                    case 'end':
	                                        return _context2.stop();
	                                }
	                            }
	                        }, _callee2, _this3);
	                    }));
	
	                    return function (_x3) {
	                        return _ref2.apply(this, arguments);
	                    };
	                }());
	            }
	        }
	    }, {
	        key: 'escapeRegexCharacters',
	        value: function escapeRegexCharacters(str) {
	            return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _state$auth_data = this.state.auth_data,
	                role = _state$auth_data.role,
	                user_name = _state$auth_data.user_name;
	            //console.log(this.state.banner);
	
	            var _state = this.state,
	                banners = _state.banners,
	                banners_b2b = _state.banners_b2b;
	            //console.log(banners);
	
	            var offer1 = _constant.IMGBASEURL + 'uploads/' + this.state.offerimage1;
	            var offer2 = _constant.IMGBASEURL + 'uploads/' + this.state.offerimage2;
	
	            return _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _react2.default.createElement(
	                    _layout2.default,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { 'class': 'col-12 grid-margin' },
	                        _react2.default.createElement(
	                            'div',
	                            { 'class': 'card' },
	                            _react2.default.createElement(
	                                'div',
	                                { 'class': 'card-body' },
	                                _react2.default.createElement(
	                                    'h4',
	                                    { 'class': 'card-title' },
	                                    'Exclusive Partnership Management - View/Manage'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'content-sec col-md-12 col-xs-12 pad-no mar-t-no' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'tab-content' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { id: 'company-info', className: 'tab-pane in active' },
	                                            _react2.default.createElement(
	                                                'form',
	                                                { onSubmit: this.handleSubmit, className: 'custom-form invoice-form col-md-12 col-xs-12 legend-form pad-no', method: 'post' },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'box-shadow-custom' },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'row' },
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'form-group col-md-6' },
	                                                            _react2.default.createElement(
	                                                                'label',
	                                                                null,
	                                                                'Name ',
	                                                                _react2.default.createElement(
	                                                                    'span',
	                                                                    { className: 'astrick' },
	                                                                    '*'
	                                                                )
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                null,
	                                                                this.state.name
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'form-group col-md-6' },
	                                                            _react2.default.createElement(
	                                                                'label',
	                                                                null,
	                                                                'Type ',
	                                                                _react2.default.createElement(
	                                                                    'span',
	                                                                    { className: 'astrick' },
	                                                                    '*'
	                                                                )
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                null,
	                                                                this.state.optiontoshow == 'both' ? "B2B/B2C" : this.state.optiontoshow == 'onlypartners' ? "B2B" : "B2C"
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'form-group col-md-6' },
	                                                            _react2.default.createElement(
	                                                                'label',
	                                                                null,
	                                                                'Address '
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                null,
	                                                                this.state.address
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'form-group col-md-6' },
	                                                            _react2.default.createElement(
	                                                                'label',
	                                                                null,
	                                                                'Email Address '
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                null,
	                                                                this.state.emailaddress
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'form-group col-md-6' },
	                                                            _react2.default.createElement(
	                                                                'label',
	                                                                null,
	                                                                'Website '
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                null,
	                                                                this.state.website
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'form-group col-md-12' },
	                                                            _react2.default.createElement(
	                                                                'label',
	                                                                null,
	                                                                'Description '
	                                                            ),
	                                                            this.state.optiontoshow == 'onlypartners' && _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: this.state.description_b2b } }),
	                                                            this.state.optiontoshow != 'onlypartners' && _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: this.state.description } })
	                                                        )
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'box-shadow-custom' },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'row' },
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'col-md-12 col-xs-12' },
	                                                            _react2.default.createElement(
	                                                                'span',
	                                                                { className: 'form-legend' },
	                                                                'Exclusive Offers'
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { 'class': 'containerrow' },
	                                                            (this.state.offerimage1 == null || this.state.offerimage1 == '') && _react2.default.createElement(
	                                                                'div',
	                                                                { 'class': 'offer_row borderwithcolor1' },
	                                                                'No offers entered'
	                                                            ),
	                                                            this.state.offerimage1 != null && this.state.offerimage1 != '' && _react2.default.createElement(
	                                                                'div',
	                                                                { 'class': 'offer_row borderwithcolor1' },
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    { 'class': 'offer_left_img', style: { width: "200px" } },
	                                                                    _react2.default.createElement('img', { src: _constant.IMGBASEURL + 'uploads/' + this.state.offerimage1 })
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    { 'class': 'offer_right_text' },
	                                                                    _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: this.state.offer1desc } })
	                                                                )
	                                                            )
	                                                        )
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'box-shadow-custom' },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'row' },
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'col-md-12 col-xs-12' },
	                                                            _react2.default.createElement(
	                                                                'span',
	                                                                { className: 'form-legend' },
	                                                                'Media Information'
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'form-group col-md-6' },
	                                                            _react2.default.createElement(
	                                                                'label',
	                                                                null,
	                                                                'Logo'
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'logoimg', style: { width: "200px" } },
	                                                                _react2.default.createElement('img', { src: _constant.IMGBASEURL + 'uploads/' + this.state.logo })
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'form-group col-md-6' },
	                                                            _react2.default.createElement(
	                                                                'label',
	                                                                null,
	                                                                'Banner'
	                                                            ),
	                                                            this.state.optiontoshow == 'onlypartners' && _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'bannerimg', style: { width: "200px" } },
	                                                                banners_b2b != null && banners_b2b != '' && _react2.default.createElement('img', { style: { width: "100%" }, src: _constant.IMGBASEURL + 'uploads/' + this.state.banners_b2b })
	                                                            ),
	                                                            this.state.optiontoshow != 'onlypartners' && _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'bannerimg', style: { width: "200px" } },
	                                                                banners != null && banners != '' && _react2.default.createElement('img', { style: { width: "100%" }, src: _constant.IMGBASEURL + 'uploads/' + this.state.banners })
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'form-group col-md-4' },
	                                                            _react2.default.createElement(
	                                                                'label',
	                                                                null,
	                                                                'Brochure/Samples'
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'brochurefile' },
	                                                                this.state.optiontoshow == 'onlypartners' && _react2.default.createElement(
	                                                                    'div',
	                                                                    null,
	                                                                    this.state.brochures_b2b != '' && this.state.brochures_b2b != null && _react2.default.createElement(
	                                                                        'a',
	                                                                        { href: _constant.IMGBASEURL + 'uploads/' + this.state.brochures_b2b, target: '_blank' },
	                                                                        _react2.default.createElement('img', { src: _constant.IMGBASEURL + 'uploads/' + this.state.brochures_b2b_thumb, style: { width: "200px" }, className: 'fileicon' })
	                                                                    ),
	                                                                    (this.state.brochures_b2b == '' || this.state.brochures_b2b == null) && _react2.default.createElement(
	                                                                        'div',
	                                                                        null,
	                                                                        'None Uploaded'
	                                                                    )
	                                                                ),
	                                                                this.state.optiontoshow != 'onlypartners' && _react2.default.createElement(
	                                                                    'div',
	                                                                    null,
	                                                                    this.state.file1 != '' && this.state.file1 != null && _react2.default.createElement(
	                                                                        'a',
	                                                                        { href: _constant.IMGBASEURL + 'uploads/' + this.state.file1, target: '_blank' },
	                                                                        _react2.default.createElement('img', { src: _constant.IMGBASEURL + 'uploads/' + this.state.thumb1, style: { width: "200px" }, className: 'fileicon' })
	                                                                    )
	                                                                )
	                                                            )
	                                                        )
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'box-shadow-custom' },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'row' },
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'col-md-12 col-xs-12' },
	                                                            _react2.default.createElement(
	                                                                'span',
	                                                                { className: 'form-legend' },
	                                                                'Social Media'
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'form-group col-md-6' },
	                                                            _react2.default.createElement(
	                                                                'label',
	                                                                null,
	                                                                'Facebook'
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'logoimg' },
	                                                                this.state.facebook
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'form-group col-md-6' },
	                                                            _react2.default.createElement(
	                                                                'label',
	                                                                null,
	                                                                'Twitter'
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'bannerimg' },
	                                                                this.state.twitter
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'form-group col-md-4' },
	                                                            _react2.default.createElement(
	                                                                'label',
	                                                                null,
	                                                                'Instagram'
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'brochurefile' },
	                                                                this.state.instagram
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'form-group col-md-4' },
	                                                            _react2.default.createElement(
	                                                                'label',
	                                                                null,
	                                                                'Linkedin'
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'brochurefile' },
	                                                                this.state.linkedin
	                                                            )
	                                                        )
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'box-shadow-custom' },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'row' },
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'col-md-12 col-xs-12' },
	                                                            _react2.default.createElement(
	                                                                'b',
	                                                                null,
	                                                                'Status :'
	                                                            ),
	                                                            ' ',
	                                                            this.state.approval_status
	                                                        )
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'row' },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'col-md-6 col-xs-12' },
	                                                        _react2.default.createElement(
	                                                            'button',
	                                                            { id: 'btnSubmit1', className: this.state.approvedstatus == '' || this.state.approvedstatus == 0 ? "btn btn-blue" : "btn btn-blue hidden", onClick: this.approveit },
	                                                            'Approve'
	                                                        ),
	                                                        '\xA0',
	                                                        _react2.default.createElement(
	                                                            'button',
	                                                            { id: 'btnSubmit2', className: this.state.approvedstatus == 2 || this.state.approvedstatus == 0 ? "btn btn-blue hidden" : "btn btn-blue", onClick: this.disapproveit },
	                                                            'OnHold'
	                                                        ),
	                                                        '\xA0',
	                                                        _react2.default.createElement(
	                                                            'button',
	                                                            { id: 'btnSubmit3', className: "btn btn-blue", onClick: this.preview },
	                                                            'Preview'
	                                                        ),
	                                                        '\xA0',
	                                                        _react2.default.createElement(
	                                                            'button',
	                                                            { id: 'btnSendNotes', className: 'btn btn-blue', onClick: this.sendNotePopup },
	                                                            'Send Message'
	                                                        ),
	                                                        '\xA0',
	                                                        _react2.default.createElement(
	                                                            'button',
	                                                            { id: 'btnDelete', className: 'btn btn-blue', onClick: this.deleteEntry },
	                                                            'Delete'
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'col-md-6 col-xs-12 text-right ' },
	                                                        _react2.default.createElement(
	                                                            'a',
	                                                            { href: '/exclusive_partnerships' },
	                                                            'Back to List'
	                                                        )
	                                                    )
	                                                )
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactstrap.Modal,
	                        { isOpen: this.state.sendMessage, className: 'modalpopup' },
	                        _react2.default.createElement(
	                            _reactstrap.ModalHeader,
	                            null,
	                            'Send a message'
	                        ),
	                        _react2.default.createElement(
	                            _reactstrap.ModalBody,
	                            { className: 'p-0' },
	                            _react2.default.createElement(
	                                'div',
	                                { 'class': 'form-group' },
	                                _react2.default.createElement(
	                                    'label',
	                                    null,
	                                    'To: '
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    _react2.default.createElement(
	                                        'b',
	                                        null,
	                                        '\xA0',
	                                        this.state.name
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'notemessage' },
	                                    'Message will be sent to this email address :',
	                                    this.state.emailaddress
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { 'class': 'form-group' },
	                                _react2.default.createElement(
	                                    'label',
	                                    null,
	                                    'Message: '
	                                ),
	                                _react2.default.createElement('textarea', { name: 'message', 'class': 'form-control', rows: '6', onChange: this.handleChange })
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { 'class': 'form-group' },
	                                _react2.default.createElement('br', null),
	                                _react2.default.createElement(
	                                    'button',
	                                    { 'class': 'btn btn-primary btn-sm', onClick: this.sendaMessage },
	                                    'Send'
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactstrap.ModalFooter,
	                            null,
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'row' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-12 text-center' },
	                                    _react2.default.createElement(
	                                        'button',
	                                        { className: 'btn btn-sm btn-default', onClick: this.cancelPop1 },
	                                        'Close'
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactstrap.Modal,
	                        { size: 'lg', isOpen: this.state.detailedpreview, className: 'modalpopup' },
	                        _react2.default.createElement(
	                            _reactstrap.ModalHeader,
	                            null,
	                            'Preview - Detail Page View'
	                        ),
	                        _react2.default.createElement(
	                            _reactstrap.ModalBody,
	                            { className: 'p-0 detailedpreview' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'row' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-lg-12 col-sm-12 col-md-12 col-xs-12 no-padding' },
	                                    _react2.default.createElement('img', { src: _headerimage2.default, 'class': 'headerimagewidth' })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'row' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-lg-12 col-sm-12 col-md-12 col-xs-12 no-padding' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'row' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'col-lg-2 col-sm-12 col-md-12 col-xs-12 no-padding' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { 'class': 'per20 logobox' },
	                                                _react2.default.createElement('img', { src: _constant.IMGBASEURL + "uploads/" + this.state.logo, 'class': 'orgphoto' })
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'col-lg-10 col-sm-12 col-md-12 col-xs-12 no-padding' },
	                                            _react2.default.createElement(
	                                                'a',
	                                                { href: '#', target: '_blank' },
	                                                _react2.default.createElement('img', { src: _constant.IMGBASEURL + "uploads/" + this.state.banners, 'class': 'bannerimage' })
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'row' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'col-lg-2 leftmenu' },
	                                            _react2.default.createElement('img', { src: _leftmenuimage2.default, 'class': 'leftmenuimg' })
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'col-lg-8' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { 'class': 'onDemandInfo', id: 'onDemandInfo' },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { id: 'description_section' },
	                                                    _react2.default.createElement(
	                                                        'h3',
	                                                        null,
	                                                        'About Us'
	                                                    ),
	                                                    _react2.default.createElement('div', { 'class': 'aboutinfo', dangerouslySetInnerHTML: { __html: this.state.description } })
	                                                ),
	                                                _react2.default.createElement('br', null),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { id: 'exclusive_offers_section' },
	                                                    _react2.default.createElement(
	                                                        'h3',
	                                                        null,
	                                                        'Exclusive Offers'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { 'class': 'offer_row borderwithcolor1' },
	                                                        this.state.offerimage1 != '' && this.state.offerimage1 != null && _react2.default.createElement(
	                                                            'div',
	                                                            { 'class': 'offer_left_img' },
	                                                            _react2.default.createElement('img', { src: "https://api.bewise.in/uploads/" + this.state.offerimage1 })
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { 'class': 'offer_right_text' },
	                                                            _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: this.state.offer1desc } })
	                                                        )
	                                                    ),
	                                                    this.state.contenttype == 'bewisecustom' && _react2.default.createElement(
	                                                        'button',
	                                                        { name: 'participate', 'class': 'btn btn-primary' },
	                                                        'Participate'
	                                                    ),
	                                                    this.state.contenttype == 'href' && _react2.default.createElement(
	                                                        'div',
	                                                        null,
	                                                        _react2.default.createElement(
	                                                            'a',
	                                                            { href: this.state.link },
	                                                            this.state.clicktext
	                                                        )
	                                                    ),
	                                                    this.state.contenttype == 'btn' && _react2.default.createElement(
	                                                        'div',
	                                                        null,
	                                                        _react2.default.createElement(
	                                                            'a',
	                                                            { href: this.state.link, 'class': 'btn btn-primary btn-sm' },
	                                                            this.state.clicktext
	                                                        )
	                                                    )
	                                                ),
	                                                _react2.default.createElement('br', null),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { id: 'video_section' },
	                                                    _react2.default.createElement(
	                                                        'h3',
	                                                        null,
	                                                        'Videos'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { 'class': 'row n5v3k' },
	                                                        this.state.video != '' && this.state.video != null && _react2.default.createElement(
	                                                            'div',
	                                                            { 'class': 'container' },
	                                                            _react2.default.createElement(
	                                                                'video',
	                                                                { width: '320', height: '240', controls: true },
	                                                                _react2.default.createElement('source', { src: this.state.video, type: 'video/mp4' }),
	                                                                'Your browser does not support the video tag.'
	                                                            )
	                                                        ),
	                                                        this.state.videourl !== '' && this.state.videourl != null && _react2.default.createElement(
	                                                            'div',
	                                                            { 'class': 'container' },
	                                                            _react2.default.createElement('iframe', { width: '420', height: '315', src: "https://www.youtube.com/embed/" + this.state.videourl })
	                                                        )
	                                                    )
	                                                ),
	                                                _react2.default.createElement('br', null),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { id: 'contactinfo_section' },
	                                                    _react2.default.createElement(
	                                                        'h3',
	                                                        null,
	                                                        'Contact Info'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { 'class': 'col-lg-8 col-sm-12 col-md-12 col-xs-12 text-left' },
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { 'class': 'per100 text-left' },
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { 'class': 'bs_social' },
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    null,
	                                                                    ' Email Address: ',
	                                                                    _react2.default.createElement(
	                                                                        'b',
	                                                                        null,
	                                                                        this.state.emailaddress
	                                                                    ),
	                                                                    ' '
	                                                                ),
	                                                                _react2.default.createElement('br', null),
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    null,
	                                                                    ' Website: ',
	                                                                    _react2.default.createElement(
	                                                                        'b',
	                                                                        null,
	                                                                        _react2.default.createElement(
	                                                                            'a',
	                                                                            { target: '_blank', href: this.state.website },
	                                                                            this.state.website
	                                                                        )
	                                                                    ),
	                                                                    ' '
	                                                                ),
	                                                                _react2.default.createElement('br', null),
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    null,
	                                                                    ' Contact Number: ',
	                                                                    _react2.default.createElement(
	                                                                        'b',
	                                                                        null,
	                                                                        this.state.contact_number
	                                                                    ),
	                                                                    ' '
	                                                                ),
	                                                                _react2.default.createElement('br', null)
	                                                            )
	                                                        )
	                                                    )
	                                                ),
	                                                _react2.default.createElement('br', null),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { id: 'review_section' },
	                                                    _react2.default.createElement(
	                                                        'h3',
	                                                        { 'class': 'review_head' },
	                                                        'Review',
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { 'class': 'floatright' },
	                                                            _react2.default.createElement(
	                                                                'small',
	                                                                { 'class': 'pointer' },
	                                                                _react2.default.createElement('i', { 'class': 'fa fa-plus', 'aria-hidden': 'true' })
	                                                            )
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { 'class': 'reviewinfo' },
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { 'class': 'col-md-12' },
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { 'class': 'detailBox' },
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    { 'class': 'form-comments' },
	                                                                    _react2.default.createElement(
	                                                                        'p',
	                                                                        null,
	                                                                        'Click here to view Comments!...'
	                                                                    )
	                                                                )
	                                                            )
	                                                        )
	                                                    )
	                                                ),
	                                                _react2.default.createElement('br', null)
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'col-lg-2 rightmenu' },
	                                            _react2.default.createElement('img', { src: _rightmenuimage2.default, 'class': 'rightmenuimg' })
	                                        )
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { 'class': 'row' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'col-md-12 footerp' },
	                                    _react2.default.createElement('img', { src: _footerpreview2.default, 'class': 'headerimagewidth' })
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactstrap.ModalFooter,
	                            null,
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'row' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-12 text-center' },
	                                    _react2.default.createElement(
	                                        'button',
	                                        { className: 'btn btn-sm btn-default', onClick: this.cancelPop2 },
	                                        'Close'
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return exclusiveParterView;
	}(_react.Component);
	
	exports.default = exclusiveParterView;

/***/ },
/* 935 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _FetchCall2 = _interopRequireDefault(_FetchCall);
	
	__webpack_require__(18);
	
	var _reactNotifications = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import { Editor } from '@tinymce/tinymce-react';
	
	
	var exclusivePartnerList = function (_Component) {
	  _inherits(exclusivePartnerList, _Component);
	
	  function exclusivePartnerList(props) {
	    _classCallCheck(this, exclusivePartnerList);
	
	    var _this = _possibleConstructorReturn(this, (exclusivePartnerList.__proto__ || Object.getPrototypeOf(exclusivePartnerList)).call(this, props));
	
	    _this.getList = function () {
	      var _this$state$auth_data = _this.state.auth_data,
	          login_id = _this$state$auth_data.login_id,
	          role = _this$state$auth_data.role;
	
	      var req = JSON.stringify({
	        role: role,
	        path: window.location.pathname,
	        location: _this.state.location,
	        year: _this.state.year,
	        month: _this.state.month
	      });
	      (0, _FetchCall.getExclusivePartnersPaged)(req).then(function (res) {
	        if (res.status == 1) {
	          _this.setState({
	            exclpartnerList: res.data
	
	          });
	        } else {
	          _this.setState({
	            exclpartnerList: []
	          });
	        }
	      });
	    };
	
	    var url = new URL(window.location.href);
	    var location = url.searchParams.get("location");
	    var auth_data = JSON.parse(localStorage.getItem("user_data"));
	    _this.state = {
	      logged: localStorage.getItem("authentication"),
	      auth_data: JSON.parse(localStorage.getItem("user_data")),
	      location: location ? location.split('-') : [],
	      exclpartnerList: []
	    };
	
	    _this.getList();
	    return _this;
	  }
	
	  _createClass(exclusivePartnerList, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	
	      var THIS = this;
	      (0, _jquery2.default)(document).on('click', '.remove_exclpartners', function () {
	        var delete_id = (0, _jquery2.default)(this).data("id");
	        THIS.deleteUser(delete_id);
	      });
	    }
	  }, {
	    key: 'deleteUser',
	    value: function deleteUser() {
	      var delete_id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	      if (confirm("Are you sure to remove this user and info?") == true) {
	        var ins = JSON.stringify({
	          id: delete_id
	        });
	        (0, _FetchCall.removeExclUser)(ins).then(function (res) {
	          var toastr = '';
	          if (res.status === 1) {
	
	            _reactNotifications.NotificationManager.success(res.message);
	
	            setTimeout(function () {
	              window.location.reload();
	            }, 2000);
	          } else {
	
	            _reactNotifications.NotificationManager.error(res.message);
	          }
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var exclpartnerList = this.state.exclpartnerList;
	
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'col-lg-12 grid-margin stretch-card' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card-body' },
	                _react2.default.createElement(
	                  'h4',
	                  { 'class': 'card-title' },
	                  'Exclusive Partners'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'float-right' },
	                  _react2.default.createElement(
	                    'a',
	                    { href: '/users/exclusivepartners/add', 'class': 'btn btn-primary btn-sm' },
	                    'Add'
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'table-responsive pt-3' },
	                  _react2.default.createElement(
	                    'table',
	                    { 'class': 'table table-bordered table-striped' },
	                    _react2.default.createElement(
	                      'thead',
	                      { 'class': 'thead-dark' },
	                      _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'S.No'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Name'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Email Id'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Type'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Created Date'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Action'
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'tbody',
	                      null,
	                      exclpartnerList.map(function (item, i) {
	
	                        return _react2.default.createElement(
	                          'tr',
	                          null,
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            i + 1
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.user_name
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.email_id
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.optiontoshow == 'both' ? "B2B/B2C" : item.optiontoshow == 'onlyparents' ? 'B2C' : item.optiontoshow == 'onlypartners' ? 'B2B' : 'undefined'
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.date
	                          ),
	                          _react2.default.createElement('td', { 'class': 'actionbtns exclusivepartnrs', dangerouslySetInnerHTML: { __html: item.action } })
	                        );
	                      })
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(_reactNotifications.NotificationContainer, null)
	        )
	      );
	    }
	  }]);
	
	  return exclusivePartnerList;
	}(_react.Component);
	
	exports.default = exclusivePartnerList;

/***/ },
/* 936 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _FetchCall2 = _interopRequireDefault(_FetchCall);
	
	var _reactAutosuggest = __webpack_require__(86);
	
	var _reactAutosuggest2 = _interopRequireDefault(_reactAutosuggest);
	
	var _reactDraftWysiwyg = __webpack_require__(127);
	
	__webpack_require__(92);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import { Editor } from '@tinymce/tinymce-react';
	
	var exclusiveUserEdit = function (_Component) {
	  _inherits(exclusiveUserEdit, _Component);
	
	  function exclusiveUserEdit(props) {
	    _classCallCheck(this, exclusiveUserEdit);
	
	    var _this = _possibleConstructorReturn(this, (exclusiveUserEdit.__proto__ || Object.getPrototypeOf(exclusiveUserEdit)).call(this, props));
	
	    _this.handleChange = function (e) {
	      var propName = e.target.name;
	      _this.setState(_defineProperty({}, e.target.name, e.target.value));
	      _this.clearValidationErr(propName);
	    };
	
	    _this.handleSelect = function (e) {
	      var propName = e.target.name;
	      var value = [].concat(_toConsumableArray(e.target.selectedOptions)).map(function (item) {
	        return item.value;
	      });
	
	      _this.setState(_defineProperty({}, propName, value));
	      _this.clearValidationErr(propName);
	    };
	
	    _this.handleSubmit = function (e) {
	      e.preventDefault();
	      var toastr = '';
	      if (_this.state.user_name != '' && _this.state.email_id != '' && _this.state.password != '' && _this.state.confirm_password != '' && _this.state.password == _this.state.confirm_password) {
	
	        var insert = JSON.stringify({
	          user_name: _this.state.user_name,
	          email_id: _this.state.email_id,
	          password: _this.state.password,
	          optiontoshow: _this.state.optiontoshow,
	          role: 11,
	          login_id: _this.state.login_id ? _this.state.login_id : ''
	        });
	
	        (0, _FetchCall.AddExclUserData)(insert).then(function (response) {
	          if (response.status == 1) {
	            alert("Added");
	            setTimeout(function () {
	              window.location.replace('/users/exclusivepartners');
	            }, 1000);
	          } else {
	            alert("Error adding");
	            setTimeout(function () {}, 1000);
	          }
	        });
	      } else {
	        if (_this.state.user_name === '') {
	          _this.showValidationErr('user_name', 'Enter name');
	        }
	        if (_this.state.email_id === '') {
	          _this.showValidationErr('email_id', 'Enter Email Id');
	        }
	
	        if (_this.state.password === '') {
	          _this.showValidationErr('password', 'Enter Password');
	        }
	        if (_this.state.confirm_password === '') {
	          _this.showValidationErr('confirm_password', 'Enter Confirm Password');
	        }
	        if (_this.state.password != _this.state.confirm_password) {
	          _this.showValidationErr('confirm_password', 'Password Miss Match');
	        }
	      }
	    };
	
	    _this.state = {
	      menu_list: [],
	      showPassword: false,
	      showCPassword: false,
	      errors: [],
	      user_name: '',
	      email_id: '',
	      role: '',
	      password: '',
	      confirm_password: '',
	      login_id: _this.props.match.params.id ? _this.props.match.params.id : ''
	    };
	    return _this;
	  }
	
	  _createClass(exclusiveUserEdit, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	
	      this.EditSubuser();
	    }
	  }, {
	    key: 'handleShowPassword',
	    value: function handleShowPassword() {
	      this.setState(function (prevState) {
	        return {
	          showPassword: !prevState.showPassword
	        };
	      });
	    }
	  }, {
	    key: 'handleShowCPassword',
	    value: function handleShowCPassword() {
	      this.setState(function (prevState) {
	        return {
	          showCPassword: !prevState.showCPassword
	        };
	      });
	    }
	  }, {
	    key: 'EditSubuser',
	    value: function EditSubuser() {
	      var _this2 = this;
	
	      var ins = JSON.stringify({
	        login_id: this.state.login_id
	      });
	      if (this.state.login_id != '') {
	        (0, _FetchCall.editExclUser)(ins).then(function (res) {
	          if (res.status == 1) {
	            console.log('res', res.data);
	            _this2.setState({
	              user_name: res.data.user_name,
	              email_id: res.data.email_id,
	              role: res.data.role
	            });
	          }
	        });
	      }
	    }
	  }, {
	    key: 'UNSAFE_componentWillMount',
	    value: function UNSAFE_componentWillMount() {}
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      window.jQuery('.selectpicker').selectpicker('refresh');
	    }
	  }, {
	    key: 'showValidationErr',
	    value: function showValidationErr(elm, msg) {
	      this.setState(function (prevState) {
	        return {
	          errors: [].concat(_toConsumableArray(prevState.errors), [{ elm: elm, msg: msg }])
	        };
	      });
	    }
	  }, {
	    key: 'clearValidationErr',
	    value: function clearValidationErr(elm) {
	      var _this3 = this;
	
	      this.setState(function (prevState) {
	        var newArr = [];
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = _this3.state.errors[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var err = _step.value;
	
	            if (elm !== err.elm) {
	              newArr.push(err);
	            }
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	
	        return { errors: newArr };
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var user_nameErr = null,
	          email_idErr = null,
	          roleErr = null,
	          passwordErr = null,
	          confirm_passwordErr = null;
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;
	
	      try {
	        for (var _iterator2 = this.state.errors[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          var err = _step2.value;
	
	          if (err.elm === 'user_name') {
	            user_nameErr = err.msg;
	          }
	          if (err.elm === 'email_id') {
	            email_idErr = err.msg;
	          }
	          if (err.elm === 'role') {
	            roleErr = err.msg;
	          }
	          if (err.elm === 'password') {
	            passwordErr = err.msg;
	          }
	          if (err.elm === 'confirm_password') {
	            confirm_passwordErr = err.msg;
	          }
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2.return) {
	            _iterator2.return();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'col-12 grid-margin' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card-body' },
	                _react2.default.createElement(
	                  'h4',
	                  { 'class': 'card-title' },
	                  'User - Edit'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { id: 'company-info' },
	                  _react2.default.createElement(
	                    'form',
	                    {
	                      encType: 'multipart/form-data',
	                      method: 'post',
	                      onSubmit: this.handleSubmit,
	                      autoComplete: 'off',
	                      className: 'custom-form invoice-form col-md-12 col-xs-12 legend-form pad-no'
	                    },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'box-shadow-custom' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'form-group col-md-4' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            'Name.',
	                            _react2.default.createElement(
	                              'span',
	                              { className: 'astrick' },
	                              '*'
	                            )
	                          ),
	                          _react2.default.createElement('input', {
	
	                            type: 'text',
	                            className: 'form-control',
	                            name: 'user_name',
	                            value: this.state.user_name,
	                            onChange: this.handleChange
	                          }),
	                          _react2.default.createElement(
	                            'small',
	                            { className: 'alert-msg text-danger' },
	                            user_nameErr ? user_nameErr : ''
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'form-group col-md-4' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            'Email Id',
	                            _react2.default.createElement(
	                              'span',
	                              { className: 'astrick' },
	                              '*'
	                            )
	                          ),
	                          _react2.default.createElement('input', {
	
	                            type: 'email',
	                            className: 'form-control',
	                            name: 'email_id',
	                            value: this.state.email_id,
	                            onChange: this.handleChange
	                          }),
	                          _react2.default.createElement(
	                            'small',
	                            { className: 'alert-msg text-danger' },
	                            email_idErr ? email_idErr : ''
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'form-group col-md-4' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            'Role',
	                            _react2.default.createElement(
	                              'span',
	                              { className: 'astrick' },
	                              '*'
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'custom-select-drop dropdown' },
	                            _react2.default.createElement('input', { type: 'hidden', name: 'role', value: '11' }),
	                            'Exclusive Partnership',
	                            _react2.default.createElement('br', null)
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'form-group col-md-4' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            'Password ',
	                            _react2.default.createElement(
	                              'span',
	                              { className: 'astrick' },
	                              '*'
	                            )
	                          ),
	                          _react2.default.createElement('input', {
	                            type: this.state.showPassword ? 'text' : 'password',
	                            name: 'password',
	                            value: this.state.password,
	                            onChange: this.handleChange,
	                            className: 'form-control'
	                          }),
	                          _react2.default.createElement('span', {
	                            toggle: '#password-field',
	                            className: this.state.showPassword ? 'fa fa-fw fa-eye-slash field-icon plogin' : 'fa fa-fw fa-eye field-icon plogin',
	                            onClick: function onClick() {
	                              _this4.handleShowPassword();
	                            }
	                          })
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'form-group col-md-4' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            'Confirm Password ',
	                            _react2.default.createElement(
	                              'span',
	                              { className: 'astrick' },
	                              '*'
	                            )
	                          ),
	                          _react2.default.createElement('input', {
	                            type: this.state.showCPassword ? 'text' : 'password',
	                            name: 'confirm_password',
	                            value: this.state.confirm_password,
	                            onChange: this.handleChange,
	                            className: 'form-control'
	                          }),
	                          _react2.default.createElement('span', {
	                            toggle: '#password-field',
	                            className: this.state.showCPassword ? 'fa fa-fw fa-eye-slash field-icon plogin' : 'fa fa-fw fa-eye field-icon plogin',
	                            onClick: function onClick() {
	                              _this4.handleShowCPassword();
	                            }
	                          })
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'form-group col-md-4' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            'Type ',
	                            _react2.default.createElement(
	                              'span',
	                              { className: 'astrick' },
	                              '*'
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'select',
	                            { name: 'optiontoshow', 'class': 'inputcls', onChange: this.handleChange },
	                            _react2.default.createElement(
	                              'option',
	                              { value: 'onlypartners' },
	                              'B2B'
	                            ),
	                            _react2.default.createElement(
	                              'option',
	                              { value: 'onlyparents' },
	                              'B2C'
	                            ),
	                            _react2.default.createElement(
	                              'option',
	                              { value: 'both' },
	                              'B2B and B2C'
	                            )
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-md-12 col-xs-12 btn-bdr' },
	                      _react2.default.createElement(
	                        'button',
	                        { id: 'btnSubmit', className: 'btn btn-primary btn-sm' },
	                        'Submit'
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return exclusiveUserEdit;
	}(_react.Component);
	
	exports.default = exclusiveUserEdit;

/***/ },
/* 937 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = LoadingSpinner;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function LoadingSpinner() {
	  return _react2.default.createElement(
	    "div",
	    { className: "spinner-container" },
	    _react2.default.createElement("div", { className: "loading-spinner" })
	  );
	}

/***/ },
/* 938 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _LoadingSpinner = __webpack_require__(937);
	
	var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);
	
	var _FetchCall = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import { Editor } from '@tinymce/tinymce-react';
	
	
	var exclusivePartnerDashboard = function (_Component) {
	  _inherits(exclusivePartnerDashboard, _Component);
	
	  function exclusivePartnerDashboard(props) {
	    _classCallCheck(this, exclusivePartnerDashboard);
	
	    var _this = _possibleConstructorReturn(this, (exclusivePartnerDashboard.__proto__ || Object.getPrototypeOf(exclusivePartnerDashboard)).call(this, props));
	
	    _this.getEntry = function (user_data) {
	
	      var req = JSON.stringify({
	        login_id: user_data.login_id
	      });
	      (0, _FetchCall.getExclPtnrsEntry)(req).then(function (res) {
	        if (res.status === 1) {
	
	          _this.setState({ loading: false });
	
	          _this.setState({ list: res.results });
	
	          /*
	          this.setState({
	            name: res.result.name,
	            logo:res.result.logo,
	            term:res.result.term,
	            approved:res.result.approved,
	            created_date:res.result.created_date,
	            notes_seen:res.result.notes_seen,
	            optiontoshow:res.result.optiontoshow,
	            description:(res.result.description==null)?"":res.result.description
	          })
	          */
	        } else {
	          _this.setState({ loading: false });
	          _this.setState({ isreco: false });
	        }
	      });
	    };
	
	    _this.state = {
	      isreco: true,
	      loading: true,
	      list: [],
	      auth_data: JSON.parse(localStorage.getItem("user_data")),
	      user_data: localStorage.getItem('user_data') ? JSON.parse(localStorage.getItem('user_data')) : []
	
	    };
	    return _this;
	  }
	
	  _createClass(exclusivePartnerDashboard, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var user_data = this.state.user_data;
	
	
	      this.getEntry(user_data);
	    }
	  }, {
	    key: 'goEdit',
	    value: function goEdit(id, optiontoshow) {
	
	      if (optiontoshow == 'both') window.location = '/exclusiveparnter/edit_excl/' + id;else if (optiontoshow == 'onlyparents') window.location = '/exclusiveparnter/edit_excl_parent/' + id;else if (optiontoshow == 'onlypartners') window.location = '/exclusiveparnter/edit_excl_partner/' + id;
	    }
	  }, {
	    key: 'goRemove',
	    value: function goRemove(id) {
	
	      if (confirm("You are sure you want to remove?")) {
	        var user_data = this.state.user_data;
	
	        var req = JSON.stringify({
	          id: id
	        });
	
	        (0, _FetchCall.removeExclPtnrsEntry)(req).then(function (res) {
	
	          if (res.status === 1) {
	
	            alert("Removed successfully");
	            window.location.reload();
	            /*
	              let toastr = '';
	            toastr = window.toastr.success;
	            toastr('Partnership entry has now been removed', {
	              positionClass: "toast-bottom-right",
	              containerId: "toast-bottom-right"
	            });
	            */
	            //this.setState({isreco:false});
	          }
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var created_date = new Intl.DateTimeFormat('en-US', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).format(this.state.created_date);
	      var isLoading = this.state.loading;
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          isLoading ? _react2.default.createElement(_LoadingSpinner2.default, null) : _react2.default.createElement(
	            'div',
	            { 'class': 'row mt-3' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'col-xl-6 d-flex grid-margin stretch-card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'card-body' },
	                  _react2.default.createElement(
	                    'h4',
	                    { 'class': 'card-title mb-3' },
	                    'Exclusive Partnership Entries'
	                  ),
	                  this.state.list.map(function (item, i) {
	
	                    return _react2.default.createElement(
	                      'div',
	                      { 'class': 'entryrow' },
	                      item.optiontoshow == 'onlyparents' && _react2.default.createElement(
	                        'div',
	                        { 'class': 'smallnotesleft' },
	                        'You have created an entry for ',
	                        _react2.default.createElement(
	                          'strong',
	                          null,
	                          'B2C'
	                        )
	                      ),
	                      item.optiontoshow == 'onlypartners' && _react2.default.createElement(
	                        'div',
	                        { 'class': 'smallnotesleft' },
	                        'You have created an entry for ',
	                        _react2.default.createElement(
	                          'strong',
	                          null,
	                          'B2B'
	                        )
	                      ),
	                      item.optiontoshow == 'both' && _react2.default.createElement(
	                        'div',
	                        { 'class': 'smallnotesleft' },
	                        'You have created an entry for ',
	                        _react2.default.createElement(
	                          'strong',
	                          null,
	                          'B2B and B2C'
	                        )
	                      ),
	                      (item.name == '' || item.name == null) && _react2.default.createElement(
	                        'div',
	                        { 'class': 'no_heading' },
	                        _react2.default.createElement(
	                          'i',
	                          null,
	                          'Name is empty, Please click \'Edit\' to add'
	                        )
	                      ),
	                      (item.name != '' || item.name != null) && _react2.default.createElement(
	                        'div',
	                        { 'class': 'p_heading' },
	                        item.name
	                      ),
	                      item.optiontoshow == 'both' && item.b2b_approved == 0 && _react2.default.createElement(
	                        'div',
	                        { 'class': 'approvalstatus waiting' },
	                        'B2B - waiting for approval'
	                      ),
	                      item.optiontoshow == 'both' && item.b2b_approved == 1 && _react2.default.createElement(
	                        'div',
	                        { 'class': 'approvalstatus approved' },
	                        'B2B - Approved'
	                      ),
	                      item.optiontoshow == 'both' && item.b2c_approved == 0 && _react2.default.createElement(
	                        'div',
	                        { 'class': 'approvalstatus waiting' },
	                        'B2C - waiting for approval'
	                      ),
	                      item.optiontoshow == 'both' && item.b2c_approved == 1 && _react2.default.createElement(
	                        'div',
	                        { 'class': 'approvalstatus approved' },
	                        'B2C - Approved'
	                      ),
	                      item.optiontoshow == 'onlyparents' && item.approved == 1 && _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'blockstatus' },
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'approvalstatus approved' },
	                            'B2C - Approved'
	                          )
	                        )
	                      ),
	                      item.optiontoshow == 'onlyparents' && item.approved == 0 && _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'blockstatus' },
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'approvalstatus waiting' },
	                            'B2C - waiting for approval'
	                          )
	                        )
	                      ),
	                      item.optiontoshow == 'onlypartners' && item.approved == 1 && _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'blockstatus' },
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'approvalstatus approved' },
	                            'B2B - Approved'
	                          )
	                        )
	                      ),
	                      item.optiontoshow == 'onlypartners' && item.approved == 0 && _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'blockstatus' },
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'approvalstatus waiting' },
	                            'B2B - waiting for approval'
	                          )
	                        )
	                      ),
	                      item.savedonly == 1 && _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'blockstatus' },
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'approvalstatus approved' },
	                            'Saved Only'
	                          )
	                        )
	                      ),
	                      item.fresh == 1 && _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'no_heading' },
	                          _react2.default.createElement(
	                            'i',
	                            null,
	                            'It is your fresh account, Please click Edit button to add more info onto your page'
	                          )
	                        )
	                      ),
	                      item.fresh == 0 && item.savedonly == 0 && item.approved == 0 && item.name != '' && item.name != null && _react2.default.createElement(
	                        'div',
	                        { 'class': 'approvalstatus waiting' },
	                        'Waiting for approval'
	                      ),
	                      item.fresh == 0 && item.savedonly == 0 && item.approved == 0 && (item.name == '' || item.name == null) && _react2.default.createElement(
	                        'div',
	                        { 'class': 'approvalstatus red' },
	                        'require more information for approval, Click \'Edit\''
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'floatrightf' },
	                        _react2.default.createElement(
	                          'button',
	                          { 'class': 'btn btn-primary btn-sm', onClick: function onClick() {
	                              return _this2.goEdit(item.id, item.optiontoshow);
	                            } },
	                          'Edit'
	                        ),
	                        '\xA0',
	                        _react2.default.createElement(
	                          'button',
	                          { 'class': 'btn btn-primary btn-sm', onClick: function onClick() {
	                              return _this2.goRemove(item.id);
	                            } },
	                          'Remove'
	                        )
	                      ),
	                      item.optiontoshow == 'onlyparents' && _react2.default.createElement(
	                        'div',
	                        { style: { paddingTop: "30px" } },
	                        _react2.default.createElement(
	                          'p',
	                          { 'class': 'actionnote' },
	                          'Your page has been created for Parents. Click "Create" to add for partners, ignore if already created.'
	                        ),
	                        _react2.default.createElement(
	                          'a',
	                          { href: '/exclusiveparnter/create_excl_partner', className: "btn btn-primary btn-sm" },
	                          'Create B2B'
	                        )
	                      ),
	                      item.optiontoshow == 'onlypartners' && _react2.default.createElement(
	                        'div',
	                        { style: { paddingTop: "30px" } },
	                        _react2.default.createElement(
	                          'p',
	                          { 'class': 'actionnote' },
	                          'Your page has been created for Partners. Click "Create" to add for parents, ignore if already created.'
	                        ),
	                        _react2.default.createElement(
	                          'a',
	                          { href: '/exclusiveparnter/create_excl_parent', className: "btn btn-primary btn-sm" },
	                          'Create B2C'
	                        )
	                      )
	                    );
	                  }),
	                  this.state.list.length == 0 && _react2.default.createElement(
	                    'div',
	                    { 'class': 'nodata' },
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'nodatainfo1' },
	                      'No Info to edit'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'nodatainfoblue' },
	                      _react2.default.createElement(
	                        'b',
	                        null,
	                        'Please click ',
	                        _react2.default.createElement(
	                          'i',
	                          null,
	                          'CREATE'
	                        ),
	                        ' button on the left side section'
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            this.state.isreco == false && _react2.default.createElement(
	              'div',
	              { 'class': 'col-md-6 desktoponly' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'card-body' },
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'card-title' },
	                    'Partnership'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'a',
	                      { href: '/exclusiveparnter/create_excl', className: "btn btn-primary btn-sm" },
	                      'Create'
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return exclusivePartnerDashboard;
	}(_react.Component);
	
	exports.default = exclusivePartnerDashboard;

/***/ },
/* 939 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _reactShare = __webpack_require__(211);
	
	var _reactstrap = __webpack_require__(17);
	
	var _tinymceReact = __webpack_require__(69);
	
	var _constant = __webpack_require__(21);
	
	var _reactSlick = __webpack_require__(93);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _head = __webpack_require__(248);
	
	var _head2 = _interopRequireDefault(_head);
	
	var _foot = __webpack_require__(247);
	
	var _foot2 = _interopRequireDefault(_foot);
	
	var _constant2 = __webpack_require__(21);
	
	var _FetchCall = __webpack_require__(4);
	
	var _universalCookie = __webpack_require__(135);
	
	var _universalCookie2 = _interopRequireDefault(_universalCookie);
	
	var _footerpreview = __webpack_require__(137);
	
	var _footerpreview2 = _interopRequireDefault(_footerpreview);
	
	var _previewheader = __webpack_require__(140);
	
	var _previewheader2 = _interopRequireDefault(_previewheader);
	
	var _pdf = __webpack_require__(308);
	
	var _pdf2 = _interopRequireDefault(_pdf);
	
	var _word = __webpack_require__(309);
	
	var _word2 = _interopRequireDefault(_word);
	
	var _xls = __webpack_require__(310);
	
	var _xls2 = _interopRequireDefault(_xls);
	
	var _headerimage = __webpack_require__(138);
	
	var _headerimage2 = _interopRequireDefault(_headerimage);
	
	var _leftmenuimage = __webpack_require__(139);
	
	var _leftmenuimage2 = _interopRequireDefault(_leftmenuimage);
	
	var _rightmenuimage = __webpack_require__(141);
	
	var _rightmenuimage2 = _interopRequireDefault(_rightmenuimage);
	
	__webpack_require__(18);
	
	var _reactNotifications = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	{/*import { Player } from 'video-react';*/}
	
	//import { Editor } from '@tinymce/tinymce-react';
	
	var exclusivePartnerEdit = function (_Component) {
	  _inherits(exclusivePartnerEdit, _Component);
	
	  function exclusivePartnerEdit(props) {
	    var _this$state;
	
	    _classCallCheck(this, exclusivePartnerEdit);
	
	    var cookies = new _universalCookie2.default();
	
	    var _this = _possibleConstructorReturn(this, (exclusivePartnerEdit.__proto__ || Object.getPrototypeOf(exclusivePartnerEdit)).call(this, props));
	
	    _this.makeMessageRead = function (login_id) {
	      var req = JSON.stringify({
	        login_id: login_id
	      });
	      (0, _FetchCall.makeMessageRead)(req).then(function (res) {
	        if (res.status === 1) {
	          _this.setState({ notes_seen: true });
	        }
	      });
	    };
	
	    _this.checkRemovalBigBanner = function () {
	
	      var req = JSON.stringify({
	        id: _this.state.id
	      });
	      (0, _FetchCall.removalItemBigBanner)(req).then(function (res) {
	        if (res.status === 1) {
	          _this.setState({ bigbannerremoved: true });
	        } else {
	          _this.setState({ bigbannerremoved: false });
	        }
	      });
	    };
	
	    _this.checkRemovalVideo = function () {
	
	      var req = JSON.stringify({
	        id: _this.state.id
	      });
	      (0, _FetchCall.removalItemVideo)(req).then(function (res) {
	        if (res.status === 1) {
	          _this.setState({ videoremoved: true });
	        } else {
	          _this.setState({ videoremoved: false });
	        }
	      });
	    };
	
	    _this.getEntry = function (id) {
	      var user_data = _this.state.user_data;
	
	
	      var req = JSON.stringify({
	        id: id
	      });
	      (0, _FetchCall.getExclPtnrsEntryB2B)(req).then(function (res) {
	        if (res.status === 1) {
	          _this.setState({
	            name: res.result.name,
	            logo: res.result.logo != null ? res.result.logo : _this.state.logo,
	            banner: res.result.banners != null ? res.result.banners : '',
	            gallery: res.result.gallery != null ? res.result.gallery : '',
	            brochure: res.result.brochure != null ? res.result.brochure : '',
	            brochures: res.result.brochure != null ? res.result.brochure : '',
	            videos: res.result.videos != null ? res.result.videos : '',
	            videourl: res.result.videourl,
	            approved: res.result.approved,
	            created_date: res.result.created_date,
	            facebook: res.result.facebook,
	            twitter: res.result.twitter,
	            instagram: res.result.instagram,
	            linkedin: res.result.linkedin,
	            emailaddress: res.result.emailaddress,
	            contact_number: res.result.contact_number,
	            website: res.result.website,
	            address: res.result.address,
	            description: res.result.description,
	            promotion_link: res.result.promotion_link,
	            promotion_image: res.result.promotion_image != null ? res.result.promotion_image : '',
	            contenttype: res.result.contenttype,
	            link: res.result.link,
	            clicktext: res.result.clicktext,
	            offerimage1: res.result.offerimage1 != null ? res.result.offerimage1 : '',
	            offerimage2: res.result.offerimage2 != null ? res.result.offerimage2 : '',
	            offerimage3: res.result.offerimage3 != null ? res.result.offerimage3 : '',
	            offer1desc: res.result.offer1desc,
	            offer2desc: res.result.offer2desc,
	            offer3desc: res.result.offer3desc,
	            optiontoshow: res.result.optiontoshow,
	            notes_webmaster: res.result.notes_webmaster,
	            notes_timesent: res.result.notes_timesent,
	            notes_seen: res.result.notes_seen,
	            description_b2b: res.result.description_b2b,
	            banners_b2b: res.result.banners_b2b != null ? res.result.banners_b2b : '',
	            offerimage_b2b: res.result.offerimage_b2b,
	            offerdesc_b2b: res.result.offerdesc_b2b,
	            brochures_b2b: res.result.brochures_b2b,
	            contact_number_b2b: res.result.contact_number_b2b,
	            emailaddress_b2b: res.result.emailaddress_b2b
	          });
	
	          if (res.result.notes_seen == 0) {
	            _this.makeMessageRead(user_data.login_id);
	          }
	        } else {
	          _this.setState({ isreco: false });
	        }
	      });
	    };
	
	    _this.cancelPop1 = function () {
	      _this.setState({
	        thumbpreview: false
	      });
	    };
	
	    _this.cancelPopb2c = function () {
	      _this.setState({
	        thumbpreviewb2c: false
	      });
	    };
	
	    _this.cancelPopb2b = function () {
	      _this.setState({
	        thumbpreviewb2b: false
	      });
	    };
	
	    _this.cancelPop2 = function () {
	      _this.setState({
	        detailedpreview: false
	      });
	    };
	
	    _this.cancelPopDetailB2B = function () {
	      _this.setState({
	        detailedpreviewb2b: false
	      });
	    };
	
	    _this.cancelPopDetailB2C = function () {
	      _this.setState({
	        detailedpreviewb2c: false
	      });
	    };
	
	    _this.handleChange = function (e) {
	      var propName = e.target.name;
	      _this.setState(_defineProperty({}, e.target.name, e.target.value));
	    };
	
	    _this.onFileChange = function (event) {
	
	      // Update the state
	      _this.setState({ selectedFile: event.target.files[0] });
	    };
	
	    _this.handleFileSinglePdf1 = function (event) {
	
	      // Update the state
	      _this.setState({ brochure1: event.target.files[0] });
	    };
	
	    _this.handleFileSingleThumb1 = function (event) {
	
	      // Update the state
	      _this.setState({ thumb1: event.target.files[0] });
	    };
	
	    _this.handleFileSingleThumb2 = function (event) {
	
	      // Update the state
	      _this.setState({ thumb2: event.target.files[0] });
	    };
	
	    _this.handleFileSinglePdf2 = function (event) {
	
	      // Update the state
	      _this.setState({ brochure2: event.target.files[0] });
	    };
	
	    _this.onMultipleFileChange = function (event) {
	
	      // Update the state
	      _this.setState({ selectedFiles: event.target.files });
	    };
	
	    _this.handleFileMultiplePdfs = function (e) {
	      var propName = e.target.name;
	      var files = e.target.files;
	
	      if (files.length > 3) {
	        files = '';
	        var toastr = window.toastr.error; //warning
	        toastr('', 'Select 5 Pdfs Only', {
	          positionClass: "toast-bottom-right",
	          containerId: "toast-bottom-right"
	        });
	      }
	      _this.setState(_defineProperty({}, propName, files));
	    };
	
	    _this.handleFileMultipleGallery = function (e) {
	      var propName = e.target.name;
	      var files = e.target.files;
	
	      _this.setState({
	        gallery: files
	      });
	    };
	
	    _this.handleFileMultiple = function (e) {
	      var propName = e.target.name;
	      var files = e.target.files;
	
	      if (files.length > 3) {
	        files = '';
	        var toastr = window.toastr.error; //warning
	        toastr('', 'Select 3 Images Only', {
	          positionClass: "toast-bottom-right",
	          containerId: "toast-bottom-right"
	        });
	      }
	      _this.setState({
	        banner: files
	      });
	    };
	
	    _this.onFileVideoUpload = function (event) {
	
	      var toastr = '';
	      // Details of the uploaded file
	      var _this$state$user_data = _this.state.user_data,
	          user_type = _this$state$user_data.user_type,
	          login_id = _this$state$user_data.login_id;
	
	      var formData = new FormData();
	
	      formData.append('user_type', user_type);
	      formData.append('login_id', login_id);
	      formData.append('videos', _this.state.selectedFile);
	      formData.append('id', _this.state.id);
	
	      (0, _FetchCall.uploadVideo)(formData).then(function (response) {
	
	        if (response.status == 1) {
	
	          _reactNotifications.NotificationManager.success('File is saved successfully');
	        } else {
	
	          _reactNotifications.NotificationManager.error('There is an issue');
	        }
	      });
	    };
	
	    _this.onFileUploadImage = function (event) {
	
	      var toastr = '';
	      // Details of the uploaded file
	      var _this$state$user_data2 = _this.state.user_data,
	          user_type = _this$state$user_data2.user_type,
	          login_id = _this$state$user_data2.login_id;
	
	      var formData = new FormData();
	
	      formData.append('user_type', user_type);
	      formData.append('login_id', login_id);
	      formData.append('image', _this.state.selectedFile);
	      formData.append('id', _this.state.id);
	
	      (0, _FetchCall.uploadImage)(formData).then(function (response) {
	
	        if (response.status == 1) {
	
	          _reactNotifications.NotificationManager.success('File is saved successfully');
	        } else {
	
	          _reactNotifications.NotificationManager.error('There is an issue');
	        }
	      });
	    };
	
	    _this.onFileUploadImage1 = function (event) {
	
	      var toastr = '';
	      // Details of the uploaded file
	      var _this$state$user_data3 = _this.state.user_data,
	          user_type = _this$state$user_data3.user_type,
	          login_id = _this$state$user_data3.login_id;
	
	      var formData = new FormData();
	
	      formData.append('user_type', user_type);
	      formData.append('login_id', login_id);
	      formData.append('image', _this.state.selectedFile);
	      formData.append('whichoffer', 'offerimage1');
	      formData.append('id', _this.state.id);
	
	      (0, _FetchCall.uploadImage)(formData).then(function (response) {
	
	        if (response.status == 1) {
	
	          _reactNotifications.NotificationManager.success('File is saved successfully');
	        } else {
	
	          _reactNotifications.NotificationManager.error('There is an issue');
	        }
	      });
	    };
	
	    _this.onFileUploadImage2 = function (event) {
	
	      var toastr = '';
	      // Details of the uploaded file
	      var _this$state$user_data4 = _this.state.user_data,
	          user_type = _this$state$user_data4.user_type,
	          login_id = _this$state$user_data4.login_id;
	
	      var formData = new FormData();
	
	      formData.append('user_type', user_type);
	      formData.append('login_id', login_id);
	      formData.append('image', _this.state.selectedFile);
	      formData.append('whichoffer', 'offerimage2');
	      formData.append('id', _this.state.id);
	
	      (0, _FetchCall.uploadImage)(formData).then(function (response) {
	
	        if (response.status == 1) {
	
	          _reactNotifications.NotificationManager.success('File is saved successfully');
	        } else {
	
	          _reactNotifications.NotificationManager.error('There is an issue');
	        }
	      });
	    };
	
	    _this.onFileUploadImage3 = function (event) {
	
	      var toastr = '';
	      // Details of the uploaded file
	      var _this$state$user_data5 = _this.state.user_data,
	          user_type = _this$state$user_data5.user_type,
	          login_id = _this$state$user_data5.login_id;
	
	      var formData = new FormData();
	
	      formData.append('user_type', user_type);
	      formData.append('login_id', login_id);
	      formData.append('image', _this.state.selectedFile);
	      formData.append('whichoffer', 'offerimage3');
	      formData.append('id', _this.state.id);
	
	      (0, _FetchCall.uploadImage)(formData).then(function (response) {
	
	        if (response.status == 1) {
	
	          _reactNotifications.NotificationManager.success('File is saved successfully');
	        } else {
	
	          _reactNotifications.NotificationManager.error('There is an issue');
	        }
	      });
	    };
	
	    _this.onFileUploadLogo = function (event) {
	
	      var toastr = '';
	      // Details of the uploaded file
	      var _this$state$user_data6 = _this.state.user_data,
	          user_type = _this$state$user_data6.user_type,
	          login_id = _this$state$user_data6.login_id;
	
	      var formData = new FormData();
	
	      formData.append('user_type', user_type);
	      formData.append('login_id', login_id);
	      formData.append('logo', _this.state.selectedFile);
	      formData.append('id', _this.state.id);
	
	      (0, _FetchCall.uploadLogo)(formData).then(function (response) {
	
	        if (response.status == 1) {
	
	          _reactNotifications.NotificationManager.success('File is saved successfully');
	
	          _this.setState({ logo: response.file });
	        } else {
	
	          _reactNotifications.NotificationManager.error('There is an issue');
	        }
	      });
	    };
	
	    _this.onFileUploadBannerB2b = function (event) {
	
	      var toastr = '';
	      // Details of the uploaded file
	      var _this$state$user_data7 = _this.state.user_data,
	          user_type = _this$state$user_data7.user_type,
	          login_id = _this$state$user_data7.login_id;
	
	      var formData = new FormData();
	      formData.append('user_type', user_type);
	      formData.append('login_id', login_id);
	      formData.append('id', _this.state.id);
	
	      var banner_data = _this.state.banner;
	
	      for (var i = 0; i < banner_data.length; i++) {
	        formData.append('banners_b2b', banner_data[i]);
	      }
	
	      (0, _FetchCall.uploadBannerB2b)(formData).then(function (response) {
	
	        if (response.status == 1) {
	
	          _reactNotifications.NotificationManager.success('File is saved successfully');
	          //alert(response.files);
	          _this.setState({ banners_b2b: response.files });
	        } else {
	
	          _reactNotifications.NotificationManager.error('There is an issue');
	        }
	      });
	    };
	
	    _this.onFileUploadBanner = function (event) {
	
	      var toastr = '';
	      // Details of the uploaded file
	      var _this$state$user_data8 = _this.state.user_data,
	          user_type = _this$state$user_data8.user_type,
	          login_id = _this$state$user_data8.login_id;
	
	      var formData = new FormData();
	      formData.append('user_type', user_type);
	      formData.append('login_id', login_id);
	      formData.append('id', _this.state.id);
	
	      var banner_data = _this.state.banner;
	
	      for (var i = 0; i < banner_data.length; i++) {
	        formData.append('banner', banner_data[i]);
	      }
	
	      (0, _FetchCall.uploadBanner)(formData).then(function (response) {
	
	        if (response.status == 1) {
	
	          _reactNotifications.NotificationManager.success('File is saved successfully');
	          //alert(response.files);
	          _this.setState({ banner: response.files });
	        } else {
	
	          _reactNotifications.NotificationManager.error('There is an issue');
	        }
	      });
	    };
	
	    _this.onFileUploadGallery = function (event) {
	
	      var toastr = '';
	      // Details of the uploaded file
	      var _this$state$user_data9 = _this.state.user_data,
	          user_type = _this$state$user_data9.user_type,
	          login_id = _this$state$user_data9.login_id;
	
	      var formData = new FormData();
	      formData.append('user_type', user_type);
	      formData.append('login_id', login_id);
	      formData.append('id', _this.state.id);
	
	      var gallery_data = _this.state.gallery;
	
	      for (var i = 0; i < gallery_data.length; i++) {
	        formData.append('gallery', gallery_data[i]);
	      }
	
	      (0, _FetchCall.uploadGallery)(formData).then(function (response) {
	
	        if (response.status == 1) {
	
	          _reactNotifications.NotificationManager.success('File is saved successfully');
	          //alert(response.files);
	          _this.setState({ gallery: response.files });
	        } else {
	          _reactNotifications.NotificationManager.error('There is an issue');
	        }
	      });
	    };
	
	    _this.onFileUploadBrochureThumb2 = function (event) {
	
	      var toastr = '';
	      // Details of the uploaded file
	      var _this$state$user_data10 = _this.state.user_data,
	          user_type = _this$state$user_data10.user_type,
	          login_id = _this$state$user_data10.login_id;
	
	      var formData = new FormData();
	
	      formData.append('user_type', user_type);
	      formData.append('login_id', login_id);
	      formData.append('thumb2', _this.state.selectedFile);
	      formData.append('id', _this.state.id);
	
	      (0, _FetchCall.uploadThumb2)(formData).then(function (response) {
	
	        if (response.status == 1) {
	
	          _reactNotifications.NotificationManager.success('File is saved successfully');
	          _this.setState({ thumb1: response.file });
	        } else {
	
	          _reactNotifications.NotificationManager.error('There is an issue');
	        }
	      });
	    };
	
	    _this.onFileUploadBrochureThumb1 = function (event) {
	
	      var toastr = '';
	      // Details of the uploaded file
	      var _this$state$user_data11 = _this.state.user_data,
	          user_type = _this$state$user_data11.user_type,
	          login_id = _this$state$user_data11.login_id;
	
	      var formData = new FormData();
	
	      formData.append('user_type', user_type);
	      formData.append('login_id', login_id);
	      formData.append('thumb1', _this.state.selectedFile);
	      formData.append('id', _this.state.id);
	
	      (0, _FetchCall.uploadThumb1)(formData).then(function (response) {
	
	        if (response.status == 1) {
	
	          _reactNotifications.NotificationManager.success('File is saved successfully');
	
	          _this.setState({ thumb1: response.file });
	        } else {
	
	          _reactNotifications.NotificationManager.error('There is an issue');
	        }
	      });
	    };
	
	    _this.onFileUploadBrochure2 = function (event) {
	
	      var toastr = '';
	      // Details of the uploaded file
	      var _this$state$user_data12 = _this.state.user_data,
	          user_type = _this$state$user_data12.user_type,
	          login_id = _this$state$user_data12.login_id;
	
	      var formData = new FormData();
	
	      formData.append('user_type', user_type);
	      formData.append('login_id', login_id);
	      formData.append('file2', _this.state.selectedFile);
	      formData.append('id', _this.state.id);
	
	      (0, _FetchCall.uploadFile2)(formData).then(function (response) {
	
	        if (response.status == 1) {
	
	          _reactNotifications.NotificationManager.success('File is saved successfully');
	
	          _this.setState({ file1: response.file });
	        } else {
	          _reactNotifications.NotificationManager.error('There is an issue');
	        }
	      });
	    };
	
	    _this.onFileUploadBrochure1 = function (event) {
	
	      var toastr = '';
	      // Details of the uploaded file
	      var _this$state$user_data13 = _this.state.user_data,
	          user_type = _this$state$user_data13.user_type,
	          login_id = _this$state$user_data13.login_id;
	
	      var formData = new FormData();
	
	      formData.append('user_type', user_type);
	      formData.append('login_id', login_id);
	      formData.append('file1', _this.state.selectedFile);
	      formData.append('id', _this.state.id);
	
	      (0, _FetchCall.uploadFile1)(formData).then(function (response) {
	
	        if (response.status == 1) {
	
	          _reactNotifications.NotificationManager.success('File is saved successfully');
	
	          _this.setState({ file1: response.file });
	        } else {
	
	          _reactNotifications.NotificationManager.error('There is an issue');
	        }
	      });
	    };
	
	    _this.onFileUploadBrochure = function (event) {
	
	      var toastr = '';
	      // Details of the uploaded file
	
	      var formData = new FormData();
	      var _this$state$user_data14 = _this.state.user_data,
	          user_type = _this$state$user_data14.user_type,
	          login_id = _this$state$user_data14.login_id;
	
	
	      formData.append('user_type', user_type);
	      formData.append('login_id', login_id);
	      formData.append('id', _this.state.id);
	
	      var brochure_data = _this.state.brochure;
	
	      for (var i = 0; i < brochure_data.length; i++) {
	        formData.append('brochure', brochure_data[i]);
	      }
	
	      (0, _FetchCall.uploadBrochure)(formData).then(function (response) {
	
	        if (response.status == 1) {
	
	          _reactNotifications.NotificationManager.success('File is saved successfully');
	        } else {
	
	          _reactNotifications.NotificationManager.error('There is an issue');
	        }
	      });
	    };
	
	    _this.state = (_this$state = {
	      name: '',
	      description: '',
	      website: '',
	      contact_number: '',
	      address: '',
	      emailaddress: '',
	      facebook: '',
	      clicktext: '',
	      link: '',
	      thumbpreview: false,
	      detailedpreview: false,
	      submitted: false,
	      selectedFile: null,
	      banner: '',
	      brochure: '',
	      brochures: '',
	      gallery: '',
	      logo: '',
	      offerimage1: '',
	      banners_b2b: '',
	      offerimage2: '',
	      offerimage3: '',
	      offer1desc: '',
	      offer2desc: ''
	    }, _defineProperty(_this$state, 'contact_number', ''), _defineProperty(_this$state, 'offer3desc', ''), _defineProperty(_this$state, 'optiontoshow', 'both'), _defineProperty(_this$state, 'user_data', localStorage.getItem('user_data') ? JSON.parse(localStorage.getItem('user_data')) : []), _defineProperty(_this$state, 'authentication', localStorage.getItem('authentication') ? JSON.parse(localStorage.getItem('authentication')) : false), _defineProperty(_this$state, 'user_type', 99), _defineProperty(_this$state, 'saved', false), _defineProperty(_this$state, 'bigbannerremoved', false), _defineProperty(_this$state, 'videoremoved', false), _defineProperty(_this$state, 'videos', ''), _defineProperty(_this$state, 'id', _this.props.match.params.id ? _this.props.match.params.id : ''), _this$state);
	
	    _this.submission = _this.submission.bind(_this);
	    _this.onFileUploadBanner = _this.onFileUploadBanner.bind(_this);
	    _this.onFileUploadBannerB2b = _this.onFileUploadBannerB2b.bind(_this);
	
	    _this.onFileUploadBrochure = _this.onFileUploadBrochure.bind(_this);
	    _this.onFileUploadGallery = _this.onFileUploadGallery.bind(_this);
	    _this.onFileVideoUpload = _this.onFileVideoUpload.bind(_this);
	
	    _this.handleChangeDescription = _this.handleChangeDescription.bind(_this);
	
	    _this.handleChangeDescriptionB2C = _this.handleChangeDescriptionB2C.bind(_this);
	    _this.handleChangeDescriptionB2B = _this.handleChangeDescriptionB2B.bind(_this);
	    _this.handleChangeofferdescB2b = _this.handleChangeofferdescB2b.bind(_this);
	    _this.handleChangeoffer1desc = _this.handleChangeoffer1desc.bind(_this);
	    _this.handleChangeoffer2desc = _this.handleChangeoffer2desc.bind(_this);
	    _this.handleChangeoffer3desc = _this.handleChangeoffer3desc.bind(_this);
	
	    _this.onFileUploadBrochureThumb1 = _this.onFileUploadBrochureThumb1.bind(_this);
	    _this.onFileUploadBrochureThumb2 = _this.onFileUploadBrochureThumb2.bind(_this);
	
	    _this.onFileUploadBrochure1 = _this.onFileUploadBrochure1.bind(_this);
	    _this.onFileUploadBrochure2 = _this.onFileUploadBrochure2.bind(_this);
	
	    _this.id = _this.props.match.params.id ? _this.props.match.params.id : '';
	    return _this;
	  }
	
	  _createClass(exclusivePartnerEdit, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var user_data = this.state.user_data;
	
	      this.getEntry(this.id);
	    }
	  }, {
	    key: 'handleChangeDescription',
	    value: function handleChangeDescription(value, editor) {
	      //console.log(value);
	      this.setState({
	        description: value
	      });
	    }
	  }, {
	    key: 'handleChangeDescriptionB2B',
	    value: function handleChangeDescriptionB2B(value, editor) {
	      //console.log(value);
	      this.setState({
	        description_b2b: value
	      });
	    }
	  }, {
	    key: 'handleChangeDescriptionB2C',
	    value: function handleChangeDescriptionB2C(value, editor) {
	      //console.log(value);
	      this.setState({
	        description: value
	      });
	    }
	  }, {
	    key: 'handleChangeoffer1desc',
	    value: function handleChangeoffer1desc(value, editor) {
	      //console.log(value);
	      this.setState({
	        offer1desc: value
	      });
	    }
	  }, {
	    key: 'handleChangeoffer2desc',
	    value: function handleChangeoffer2desc(value, editor) {
	      //console.log(value);
	      this.setState({
	        offer2desc: value
	      });
	    }
	  }, {
	    key: 'handleChangeofferdescB2b',
	    value: function handleChangeofferdescB2b(value, editor) {
	      //console.log(value);
	      this.setState({
	        offerdesc_b2b: value
	      });
	    }
	  }, {
	    key: 'handleChangeoffer3desc',
	    value: function handleChangeoffer3desc(value, editor) {
	      //console.log(value);
	      this.setState({
	        offer3desc: value
	      });
	    }
	  }, {
	    key: 'savefornow',
	    value: function savefornow() {
	      var _this2 = this;
	
	      var toastr = '';
	
	      var _state$user_data = this.state.user_data,
	          user_type = _state$user_data.user_type,
	          login_id = _state$user_data.login_id;
	
	
	      if (this.state.name == '' || this.state.description == '') {
	
	        _reactNotifications.NotificationManager.error('To Save, atleast we need your basic info. Please make sure you have added');
	      } else {
	
	        /*
	        let downloable_content={
	                            contenttype:this.state.contenttype,
	                            clicktext:this.state.clicktext,
	                            link:this.state.link};
	        */
	
	        var req = JSON.stringify({
	
	          id: this.state.id,
	          user_type: user_type,
	          login_id: login_id,
	          name: this.state.name,
	          description: this.state.description,
	          website: this.state.website,
	          contact_number: this.state.contact_number,
	          address: this.state.address,
	          emailaddress: this.state.emailaddress,
	          facebook: this.state.facebook,
	          clicktext: this.state.clicktext,
	          link: this.state.link,
	          offer2desc: this.state.offer2desc,
	          offer1desc: this.state.offer1desc,
	          optiontoshow: this.state.optiontoshow,
	          contenttype: this.state.contenttype,
	          promotion_link: this.state.promotion_link,
	          twitter: this.state.twitter,
	          instagram: this.state.instagram,
	          linkedin: this.state.linkedin,
	          description_b2b: this.state.description_b2b,
	          banners_b2b: this.state.banners_b2b,
	          offerimage_b2b: this.state.offerimage_b2b,
	          offerdesc_b2b: this.state.offerdesc_b2b,
	          brochures_b2b: this.state.brochures_b2b,
	          contact_number_b2b: this.state.contact_number_b2b,
	          emailaddress_b2b: this.state.emailaddress_b2b,
	          approved: 0
	        });
	
	        (0, _FetchCall.saveEntry)(req).then(function (response) {
	
	          if (response.status == 1) {
	
	            _this2.setState({ id: response.lastinsertId });
	
	            _reactNotifications.NotificationManager.success('Partnership update has now been saved');
	          } else {
	
	            _reactNotifications.NotificationManager.error('There is an issue uploading file');
	          }
	        });
	      }
	    }
	  }, {
	    key: 'submission',
	    value: function submission() {
	      var _this3 = this;
	
	      var toastr = '';
	
	      if (this.state.logo == '' || this.state.logo == 'defaultlogo.png' || this.state.banner == '' || this.state.name == '' || this.state.description == '') {
	
	        _reactNotifications.NotificationManager.error('Please make sure you provide all required minimum data such as logo, banner , name and description');
	      } else {
	        var _state$user_data2 = this.state.user_data,
	            user_type = _state$user_data2.user_type,
	            login_id = _state$user_data2.login_id;
	
	
	        var req = JSON.stringify({
	          id: this.state.id,
	          user_type: user_type,
	          login_id: login_id,
	          name: this.state.name,
	          description: this.state.description,
	          website: this.state.website,
	          address: this.state.address,
	          emailaddress: this.state.emailaddress,
	          contact_number: this.state.contact_number,
	          facebook: this.state.facebook,
	          clicktext: this.state.clicktext,
	          link: this.state.link,
	          offer2desc: this.state.offer2desc,
	          offer1desc: this.state.offer1desc,
	          optiontoshow: this.state.optiontoshow,
	          contenttype: this.state.contenttype,
	          promotion_link: this.state.promotion_link,
	          twitter: this.state.twitter,
	          instagram: this.state.instagram,
	          videourl: this.state.videourl,
	          linkedin: this.state.linkedin,
	          description_b2b: this.state.description_b2b,
	          banners_b2b: this.state.banners_b2b,
	          offerimage_b2b: this.state.offerimage_b2b,
	          offerdesc_b2b: this.state.offerdesc_b2b,
	          brochures_b2b: this.state.brochures_b2b,
	          contact_number_b2b: this.state.contact_number_b2b,
	          emailaddress_b2b: this.state.emailaddress_b2b
	        });
	
	        (0, _FetchCall.submitEntry)(req).then(function (response) {
	
	          if (response.status == 1) {
	
	            _reactNotifications.NotificationManager.success('Submitted successfully');
	            _this3.setState({ submitted: true });
	          } else {
	
	            _reactNotifications.NotificationManager.error('There is an issue');
	          }
	        });
	      }
	    }
	  }, {
	    key: 'showthumbnail',
	    value: function showthumbnail() {
	      this.setState({ thumbpreview: true });
	    }
	  }, {
	    key: 'showthumbnailb2b',
	    value: function showthumbnailb2b() {
	      this.setState({ thumbpreviewb2b: true });
	    }
	  }, {
	    key: 'showthumbnailb2c',
	    value: function showthumbnailb2c() {
	      this.setState({ thumbpreviewb2c: true });
	    }
	  }, {
	    key: 'showdetailed',
	    value: function showdetailed() {
	      this.setState({ detailedpreview: true });
	    }
	  }, {
	    key: 'showdetailedb2b',
	    value: function showdetailedb2b() {
	      this.setState({ detailedpreviewb2b: true });
	    }
	  }, {
	    key: 'showdetailedb2c',
	    value: function showdetailedb2c() {
	      this.setState({ detailedpreviewb2c: true });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var gallerysettings = {
	        dots: false,
	        infinite: false,
	        speed: 500,
	        slidesToShow: 3,
	        slidesToScroll: 3,
	        responsive: [{
	          breakpoint: 768,
	          settings: {
	            slidesToShow: 1,
	            centerMode: false, /* set centerMode to false to show complete slide instead of 3 */
	            slidesToScroll: 1
	          }
	        }]
	      };
	
	      var _state = this.state,
	          description_b2b = _state.description_b2b,
	          offerimage_b2b = _state.offerimage_b2b,
	          offerdesc_b2b = _state.offerdesc_b2b,
	          brochures_b2b = _state.brochures_b2b,
	          contact_number_b2b = _state.contact_number_b2b,
	          emailaddress_b2b = _state.emailaddress_b2b;
	
	
	      var banners_b2b = this.state.banners_b2b != '' ? this.state.banners_b2b.toString().split(",") : '';
	
	      var banners = this.state.banner != '' ? this.state.banner.toString().split(",") : '';
	      var gallery = this.state.gallery.toString().split(",");
	      var sliders = '';
	      //const sliders = this.state.banner.split(",");
	      var galleries = this.state.gallery.split(",");
	      //const IMG_URL = 'http://localhost:5005/';
	
	      var offer1 = _constant2.IMGBASEURL + 'uploads/' + this.state.offerimage1;
	      var offer2 = _constant2.IMGBASEURL + 'uploads/' + this.state.offerimage2;
	      var offer3 = _constant2.IMGBASEURL + 'uploads/' + this.state.offerimage3;
	
	      var offer1desc = this.state.offer1desc;
	      var offer2desc = this.state.offer2desc;
	      var offer3desc = this.state.offer3desc;
	
	      var brochures = this.state.brochures.split(",");
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'col-lg-12 grid-margin stretch-card' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card-body' },
	                _react2.default.createElement(
	                  'h4',
	                  { 'class': 'card-title' },
	                  'Exclusive Partnerships - Edit'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'row' },
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'col-lg-12' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'main-content col-md-12 col-xs-12' },
	                      this.state.submitted && _react2.default.createElement(
	                        'div',
	                        { 'class': 'aftersubmitmessage' },
	                        'Partnership update has now been resubmitted for review @ BeWise. Thank you for your partnership and we remain greatful.'
	                      ),
	                      !this.state.submitted && _react2.default.createElement(
	                        _react2.default.Fragment,
	                        null,
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'row' },
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'col-md-12 col-sm-12 col-xs-12' },
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'card' },
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'card-body' },
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'card-title' },
	                                  'Profile Information'
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'input-group input-group-sm' },
	                                  _react2.default.createElement('input', { type: 'text', name: 'name', 'class': 'form-control input-sm', placeholder: 'Name', value: this.state.name, onChange: this.handleChange })
	                                ),
	                                _react2.default.createElement('br', null),
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'input-group input-group-sm' },
	                                  _react2.default.createElement('input', { type: 'text', name: 'address', 'class': 'form-control input-lg', placeholder: 'Address', onChange: this.handleChange, value: this.state.address })
	                                ),
	                                _react2.default.createElement('br', null),
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'input-group input-group-sm' },
	                                  _react2.default.createElement('input', { type: 'email', name: 'emailaddress', 'class': 'form-control input-sm', placeholder: 'Email Address', onChange: this.handleChange, value: this.state.emailaddress })
	                                ),
	                                _react2.default.createElement('br', null),
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'input-group input-group-sm' },
	                                  _react2.default.createElement('input', { type: 'text', name: 'website', 'class': 'form-control input-sm', placeholder: 'Web Site', onChange: this.handleChange, value: this.state.website })
	                                ),
	                                _react2.default.createElement('br', null),
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'input-group input-group-sm' },
	                                  _react2.default.createElement('input', { type: 'text', name: 'contact_number', 'class': 'form-control input-sm', placeholder: 'Contact Number', onChange: this.handleChange, value: this.state.contact_number })
	                                ),
	                                _react2.default.createElement('br', null)
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'row' },
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'col-md-12 col-sm-12 col-xs-12' },
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'card' },
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'card-body' },
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'card-title' },
	                                  'Logo (png) (Common for B2B and B2C)'
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': ' input-group-sm' },
	                                  _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'row' },
	                                    _react2.default.createElement(
	                                      'div',
	                                      { 'class': 'col-md-6 col-sm-6 col-xs-12' },
	                                      _react2.default.createElement('input', { type: 'file', name: 'logo', 'class': 'form-control input-sm', placeholder: 'Logo', onChange: this.onFileChange })
	                                    ),
	                                    _react2.default.createElement(
	                                      'div',
	                                      { 'class': 'col-md-6 col-sm-6 col-xs-12' },
	                                      _react2.default.createElement(
	                                        'button',
	                                        { 'class': 'btn btn-primary btn-sm', onClick: this.onFileUploadLogo },
	                                        'Upload!'
	                                      )
	                                    )
	                                  ),
	                                  this.state.logo != '' && _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'existingmedia' },
	                                    _react2.default.createElement('img', { src: _constant2.IMGBASEURL + "uploads/" + this.state.logo })
	                                  )
	                                ),
	                                _react2.default.createElement('br', null)
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'row' },
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'col-md-6 col-sm-12 col-xs-12' },
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'card cssb2c' },
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'card-body' },
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'card-title' },
	                                  'About Info (B2C)'
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'input-group' },
	                                  _react2.default.createElement(_tinymceReact.Editor, {
	                                    onEditorChange: this.handleChangeDescriptionB2C,
	                                    value: this.state.description,
	                                    apiKey: _constant.TINY_EDITOR,
	                                    init: {
	                                      height: 300,
	                                      plugins: ['lists link image paste'],
	                                      toolbar: 'undo redo | formatselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | help'
	                                    }
	                                  })
	                                )
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'col-md-6 col-sm-12 col-xs-12' },
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'card cssb2b' },
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'card-body' },
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'card-title' },
	                                  'About Info (B2B)'
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'input-group' },
	                                  _react2.default.createElement(_tinymceReact.Editor, {
	                                    onEditorChange: this.handleChangeDescriptionB2B,
	                                    value: this.state.description_b2b,
	                                    apiKey: _constant.TINY_EDITOR,
	                                    init: {
	                                      height: 300,
	                                      plugins: ['lists link image paste'],
	                                      toolbar: 'undo redo | formatselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | help'
	                                    }
	                                  })
	                                )
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'row' },
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'col-md-6 col-sm-6 col-xs-12' },
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'card cssb2c' },
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'card-body' },
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'card-title' },
	                                  'Medias (B2C)'
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'input-group-sm' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { 'for': 'banner' },
	                                    'Big Banner (980x364)'
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'row' },
	                                    _react2.default.createElement(
	                                      'div',
	                                      { 'class': 'col-md-6 col-sm-6 col-xs-12' },
	                                      _react2.default.createElement('input', { type: 'file', id: 'banner', name: 'banner', multiple: true, 'class': 'form-control input-sm', placeholder: 'Banner', onChange: this.handleFileMultiple })
	                                    ),
	                                    _react2.default.createElement(
	                                      'div',
	                                      { 'class': 'col-md-6 col-sm-6 col-xs-12' },
	                                      _react2.default.createElement(
	                                        'button',
	                                        { 'class': 'btn btn-primary btn-sm', onClick: this.onFileUploadBanner },
	                                        'Upload!'
	                                      )
	                                    )
	                                  ),
	                                  banners != '' && _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'existingmedia' },
	                                    _react2.default.createElement(
	                                      'div',
	                                      { 'class': 'bimage' },
	                                      _react2.default.createElement('img', { src: _constant2.IMGBASEURL + "uploads/" + banners })
	                                    ),
	                                    _react2.default.createElement(
	                                      'span',
	                                      null,
	                                      _react2.default.createElement(
	                                        'button',
	                                        { 'class': 'btn btn-danger btn-sm', onClick: this.checkRemovalBigBanner },
	                                        'Remove'
	                                      )
	                                    )
	                                  )
	                                ),
	                                _react2.default.createElement('br', null),
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': ' input-group-sm' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { 'for': 'video' },
	                                    'Video (.mp4)'
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'row' },
	                                    _react2.default.createElement(
	                                      'div',
	                                      { 'class': 'col-md-6 col-sm-6 col-xs-12' },
	                                      _react2.default.createElement('input', { type: 'file', name: 'video', 'class': 'form-control input-sm', placeholder: 'Video', onChange: this.onFileChange })
	                                    ),
	                                    _react2.default.createElement(
	                                      'div',
	                                      { 'class': 'col-md-6 col-sm-6 col-xs-12' },
	                                      _react2.default.createElement(
	                                        'button',
	                                        { 'class': 'btn btn-primary btn-sm', onClick: this.onFileVideoUpload },
	                                        'Upload!'
	                                      )
	                                    )
	                                  ),
	                                  this.state.videos != '' && this.state.videos != null && _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'existingmedia' },
	                                    _react2.default.createElement(
	                                      'video',
	                                      { width: '320', height: '240', controls: true },
	                                      _react2.default.createElement('source', { src: _constant2.IMGBASEURL + "uploads/" + this.state.videos, type: 'video/mp4' })
	                                    ),
	                                    _react2.default.createElement(
	                                      'span',
	                                      null,
	                                      _react2.default.createElement(
	                                        'button',
	                                        { 'class': 'btn btn-danger btn-sm', onClick: this.checkRemovalVideo },
	                                        'Remove'
	                                      )
	                                    )
	                                  )
	                                ),
	                                _react2.default.createElement('br', null),
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': ' input-group-sm' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { 'for': 'video' },
	                                    'YouTube Video'
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'row' },
	                                    _react2.default.createElement(
	                                      'div',
	                                      { 'class': 'col-md-6 col-sm-6 col-xs-12' },
	                                      _react2.default.createElement('input', { type: 'text', name: 'videourl', value: this.state.videourl, 'class': 'form-control input-sm', placeholder: 'Video', onChange: this.handleChange })
	                                    )
	                                  ),
	                                  this.state.videourl != '' && this.state.videourl != null && _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'existingmedia' },
	                                    _react2.default.createElement(
	                                      'video',
	                                      { width: '320', height: '240', controls: true },
	                                      _react2.default.createElement('source', { src: this.state.videourl, type: 'video/mp4' })
	                                    )
	                                  )
	                                )
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'card cssb2c' },
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'card-body' },
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'card-title' },
	                                  'Sample Brochure or Magazine (B2C)'
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'borderedrow' },
	                                  _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'input-group-sm' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      { 'for': 'brochure' },
	                                      'Document File (pdf)'
	                                    ),
	                                    _react2.default.createElement(
	                                      'div',
	                                      { 'class': 'row' },
	                                      _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'col-md-6 col-sm-6 col-xs-12' },
	                                        _react2.default.createElement('input', { type: 'file', name: 'brochure1', id: 'brochure1', 'class': 'form-control input-sm', placeholder: 'Brochure', onChange: this.onFileChange })
	                                      ),
	                                      _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'col-md-6 col-sm-6 col-xs-12' },
	                                        _react2.default.createElement(
	                                          'button',
	                                          { 'class': 'btn btn-primary btn-sm', onClick: this.onFileUploadBrochure1 },
	                                          'Upload!'
	                                        )
	                                      )
	                                    )
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { 'class': ' input-group-sm' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      { 'for': 'brochure' },
	                                      'Thumbnail (jpg or png)'
	                                    ),
	                                    _react2.default.createElement(
	                                      'div',
	                                      { 'class': 'row' },
	                                      _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'col-md-6 col-sm-6 col-xs-12' },
	                                        _react2.default.createElement('input', { type: 'file', name: 'thumb1', id: 'thumb1', 'class': 'form-control input-sm', placeholder: 'Thumbnail', onChange: this.onFileChange })
	                                      ),
	                                      _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'col-md-6 col-sm-6 col-xs-12' },
	                                        _react2.default.createElement(
	                                          'button',
	                                          { 'class': 'btn btn-primary btn-sm', onClick: this.onFileUploadBrochureThumb1 },
	                                          'Upload!'
	                                        )
	                                      )
	                                    )
	                                  )
	                                )
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'col-md-6 col-sm-6 col-xs-12' },
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'card cssb2b' },
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'card-body' },
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'card-title' },
	                                  'Medias (B2B)'
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'input-group-sm' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { 'for': 'banner' },
	                                    'Big Banner (980x364)'
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'row' },
	                                    _react2.default.createElement(
	                                      'div',
	                                      { 'class': 'col-md-6 col-sm-6 col-xs-12' },
	                                      _react2.default.createElement('input', { type: 'file', id: 'banners_b2b', name: 'banners_b2b', multiple: true, 'class': 'form-control input-sm', placeholder: 'Banner', onChange: this.handleFileMultiple })
	                                    ),
	                                    _react2.default.createElement(
	                                      'div',
	                                      { 'class': 'col-md-6 col-sm-6 col-xs-12' },
	                                      _react2.default.createElement(
	                                        'button',
	                                        { 'class': 'btn btn-primary btn-sm', onClick: this.onFileUploadBannerB2b },
	                                        'Upload!'
	                                      )
	                                    )
	                                  ),
	                                  banners_b2b !== '' && _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'existingmedia' },
	                                    _react2.default.createElement(
	                                      'div',
	                                      { 'class': 'bimage' },
	                                      _react2.default.createElement('img', { src: _constant2.IMGBASEURL + "uploads/" + banners_b2b })
	                                    ),
	                                    _react2.default.createElement(
	                                      'span',
	                                      null,
	                                      _react2.default.createElement(
	                                        'button',
	                                        { 'class': 'btn btn-danger btn-sm', onClick: this.checkBigBannerRemovalB2B },
	                                        'Remove'
	                                      )
	                                    )
	                                  )
	                                ),
	                                _react2.default.createElement('br', null),
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': ' input-group-sm' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { 'for': 'video' },
	                                    'Video (.mp4)'
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'row' },
	                                    _react2.default.createElement(
	                                      'div',
	                                      { 'class': 'col-md-6 col-sm-6 col-xs-12' },
	                                      _react2.default.createElement('input', { type: 'file', name: 'videos_b2b', 'class': 'form-control input-sm', placeholder: 'Video', onChange: this.onFileChange })
	                                    ),
	                                    _react2.default.createElement(
	                                      'div',
	                                      { 'class': 'col-md-6 col-sm-6 col-xs-12' },
	                                      _react2.default.createElement(
	                                        'button',
	                                        { 'class': 'btn btn-primary btn-sm', onClick: this.onFileVideoUpload },
	                                        'Upload!'
	                                      )
	                                    )
	                                  ),
	                                  this.state.videos_b2b != '' && this.state.videos_b2b != null && _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'existingmedia' },
	                                    _react2.default.createElement(
	                                      'video',
	                                      { width: '320', height: '240', controls: true },
	                                      _react2.default.createElement('source', { src: _constant2.IMGBASEURL + "uploads/" + this.state.videos_b2b, type: 'video/mp4' })
	                                    ),
	                                    _react2.default.createElement(
	                                      'span',
	                                      null,
	                                      _react2.default.createElement(
	                                        'button',
	                                        { 'class': 'btn btn-danger btn-sm', onClick: this.checkVideoRemovalB2B },
	                                        'Remove'
	                                      )
	                                    )
	                                  )
	                                ),
	                                _react2.default.createElement('br', null),
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': ' input-group-sm' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { 'for': 'video' },
	                                    'YouTube Video'
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'row' },
	                                    _react2.default.createElement(
	                                      'div',
	                                      { 'class': 'col-md-6 col-sm-6 col-xs-12' },
	                                      _react2.default.createElement('input', { type: 'text', name: 'videourl_b2b', value: this.state.videourl_b2b, 'class': 'form-control input-sm', placeholder: 'Video', onChange: this.handleChange })
	                                    )
	                                  ),
	                                  this.state.videourl_b2b != '' && this.state.videourl_b2b != null && _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'existingmedia' },
	                                    _react2.default.createElement(
	                                      'video',
	                                      { width: '320', height: '240', controls: true },
	                                      _react2.default.createElement('source', { src: this.state.videourl_b2b, type: 'video/mp4' })
	                                    )
	                                  )
	                                )
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'card cssb2b' },
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'card-body' },
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'card-title' },
	                                  'Sample Brochure or Magazine (B2B)'
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'borderedrow' },
	                                  _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'input-group-sm' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      { 'for': 'brochure' },
	                                      'Document File (pdf)'
	                                    ),
	                                    _react2.default.createElement(
	                                      'div',
	                                      { 'class': 'row' },
	                                      _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'col-md-6 col-sm-6 col-xs-12' },
	                                        _react2.default.createElement('input', { type: 'file', name: 'brochure_b2b', id: 'brochure_b2b', 'class': 'form-control input-sm', placeholder: 'Brochure', onChange: this.onFileChange })
	                                      ),
	                                      _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'col-md-6 col-sm-6 col-xs-12' },
	                                        _react2.default.createElement(
	                                          'button',
	                                          { 'class': 'btn btn-primary btn-sm', onClick: this.onFileUploadBrochureB2b },
	                                          'Upload!'
	                                        )
	                                      )
	                                    )
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { 'class': ' input-group-sm' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      { 'for': 'brochure' },
	                                      'Thumbnail (jpg or png)'
	                                    ),
	                                    _react2.default.createElement(
	                                      'div',
	                                      { 'class': 'row' },
	                                      _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'col-md-6 col-sm-6 col-xs-12' },
	                                        _react2.default.createElement('input', { type: 'file', name: 'thumb_b2b', id: 'thumb_b2b', 'class': 'form-control input-sm', placeholder: 'Thumbnail', onChange: this.onFileChange })
	                                      ),
	                                      _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'col-md-6 col-sm-6 col-xs-12' },
	                                        _react2.default.createElement(
	                                          'button',
	                                          { 'class': 'btn btn-primary btn-sm', onClick: this.onFileUploadBrochureThumbB2b },
	                                          'Upload!'
	                                        )
	                                      )
	                                    )
	                                  )
	                                )
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'row' },
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'col-md-6 col-sm-12 col-xs-12' },
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'card cssb2c' },
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'card-body' },
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'card-title' },
	                                  'Exclusive Offers (B2C)'
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'row' },
	                                  _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'col-lg-12 col-sm-12' },
	                                    _react2.default.createElement(
	                                      'div',
	                                      { 'class': 'input-group input-group-sm' },
	                                      _react2.default.createElement(
	                                        'label',
	                                        { 'for': 'brochure' },
	                                        'Thumbnail Image for the offer (.jpg, .gif and .png) (Leave blank if not applicable)'
	                                      ),
	                                      _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'row' },
	                                        _react2.default.createElement(
	                                          'div',
	                                          { 'class': 'col-md-6 col-sm-6 col-xs-12' },
	                                          _react2.default.createElement('input', { type: 'file', name: 'offerimage1', 'class': 'form-control input-sm', placeholder: 'Image', onChange: this.onFileChange })
	                                        ),
	                                        _react2.default.createElement(
	                                          'div',
	                                          { 'class': 'col-md-6 col-sm-6 col-xs-12' },
	                                          _react2.default.createElement(
	                                            'button',
	                                            { 'class': 'btn btn-primary btn-sm', onClick: this.onFileUploadImage1 },
	                                            'Upload!'
	                                          )
	                                        )
	                                      ),
	                                      this.state.offerimage1 != '' && this.state.offerimage1 != null && _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'existingmedia' },
	                                        _react2.default.createElement('img', { src: _constant2.IMGBASEURL + "uploads/" + this.state.offerimage1 })
	                                      ),
	                                      _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'row' },
	                                        _react2.default.createElement(
	                                          'div',
	                                          { 'class': 'col-md-12 col-sm-12 col-xs-12' },
	                                          _react2.default.createElement(
	                                            'label',
	                                            { 'for': 'brochure' },
	                                            'Description'
	                                          ),
	                                          _react2.default.createElement(_tinymceReact.Editor, {
	                                            onEditorChange: this.handleChangeoffer1desc,
	                                            value: this.state.offer1desc,
	                                            apiKey: _constant.TINY_EDITOR,
	                                            init: {
	                                              height: 400,
	                                              plugins: ['lists link image paste'],
	                                              toolbar: 'undo redo | formatselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | help'
	                                            }
	                                          })
	                                        )
	                                      )
	                                    )
	                                  )
	                                )
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'col-md-6 col-sm-12 col-xs-12' },
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'card cssb2b' },
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'card-body' },
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'card-title' },
	                                  'Exclusive Offers (B2B)'
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'row' },
	                                  _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'col-lg-12 col-sm-12' },
	                                    _react2.default.createElement(
	                                      'div',
	                                      { 'class': 'input-group input-group-sm' },
	                                      _react2.default.createElement(
	                                        'label',
	                                        { 'for': 'brochure' },
	                                        'Thumbnail Image for the offer (.jpg, .gif and .png) (Leave blank if not applicable)'
	                                      ),
	                                      _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'row' },
	                                        _react2.default.createElement(
	                                          'div',
	                                          { 'class': 'col-md-6 col-sm-6 col-xs-12' },
	                                          _react2.default.createElement('input', { type: 'file', name: 'offerimage_b2b', 'class': 'form-control input-sm', placeholder: 'Image', onChange: this.onFileChange })
	                                        ),
	                                        _react2.default.createElement(
	                                          'div',
	                                          { 'class': 'col-md-6 col-sm-6 col-xs-12' },
	                                          _react2.default.createElement(
	                                            'button',
	                                            { 'class': 'btn btn-primary btn-sm', onClick: this.onFileUploadImage1 },
	                                            'Upload!'
	                                          )
	                                        )
	                                      ),
	                                      this.state.offerimage_b2b != '' && this.state.offerimage_b2b != null && _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'existingmedia' },
	                                        _react2.default.createElement('img', { src: _constant2.IMGBASEURL + "uploads/" + this.state.offerimage_b2b })
	                                      ),
	                                      _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'row' },
	                                        _react2.default.createElement(
	                                          'div',
	                                          { 'class': 'col-md-12 col-sm-12 col-xs-12' },
	                                          _react2.default.createElement(
	                                            'label',
	                                            { 'for': 'brochure' },
	                                            'Description'
	                                          ),
	                                          _react2.default.createElement(_tinymceReact.Editor, {
	                                            onEditorChange: this.handleChangeofferdescB2b,
	                                            value: this.state.offerdesc_b2b,
	                                            apiKey: _constant.TINY_EDITOR,
	                                            init: {
	                                              height: 400,
	                                              plugins: ['lists link image paste'],
	                                              toolbar: 'undo redo | formatselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | help'
	                                            }
	                                          })
	                                        )
	                                      )
	                                    )
	                                  )
	                                )
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'row' },
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'col-md-12 col-sm-12 col-xs-12' },
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'card' },
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'card-body' },
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'card-title' },
	                                  'Social Media (Common for Both B2B and B2C)'
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'input-group input-group-sm' },
	                                  _react2.default.createElement('input', { type: 'text', name: 'facebook', 'class': 'form-control input-sm', placeholder: 'Facebook', value: this.state.facebook, onChange: this.handleChange })
	                                ),
	                                _react2.default.createElement('br', null),
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'input-group input-group-sm' },
	                                  _react2.default.createElement('input', { type: 'text', name: 'instagram', 'class': 'form-control input-sm', placeholder: 'Instagram', value: this.state.instagram, onChange: this.handleChange })
	                                ),
	                                _react2.default.createElement('br', null),
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'input-group input-group-sm' },
	                                  _react2.default.createElement('input', { type: 'text', name: 'linkedin', 'class': 'form-control input-sm', placeholder: 'LinkedIn', value: this.state.linkedin, onChange: this.handleChange })
	                                )
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'row' },
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'col-md-12 col-sm-12 col-xs-12' },
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'card' },
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'card-body' },
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'card-title' },
	                                  'Message from BeWise Team'
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'row' },
	                                  _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'col-lg-3 col-sm-12' },
	                                    new Intl.DateTimeFormat('en-US', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).format(this.state.notes_senttime)
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'col-lg-9 col-sm-12' },
	                                    _react2.default.createElement(
	                                      'div',
	                                      { 'class': 'messagebox' },
	                                      this.state.notes_webmaster
	                                    )
	                                  )
	                                )
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'row' },
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'col-md-12 col-sm-12 col-xs-12' },
	                            (this.state.optiontoshow == 'both' || this.state.optiontoshow == 'onlypartners') && _react2.default.createElement(
	                              'span',
	                              null,
	                              '\xA0',
	                              _react2.default.createElement(
	                                'button',
	                                { type: 'button', 'class': 'btn btn-primary', onClick: function onClick() {
	                                    return _this4.showthumbnailb2b();
	                                  } },
	                                'Thumbnail Preview (B2B)'
	                              )
	                            ),
	                            (this.state.optiontoshow == 'both' || this.state.optiontoshow == 'onlyparents') && _react2.default.createElement(
	                              'span',
	                              null,
	                              '\xA0',
	                              _react2.default.createElement(
	                                'button',
	                                { type: 'button', 'class': 'btn btn-primary', onClick: function onClick() {
	                                    return _this4.showthumbnailb2c();
	                                  } },
	                                'Thumbnail Preview (B2C)'
	                              )
	                            ),
	                            (this.state.optiontoshow == 'both' || this.state.optiontoshow == 'onlypartners') && _react2.default.createElement(
	                              'span',
	                              null,
	                              '\xA0',
	                              _react2.default.createElement(
	                                'button',
	                                { type: 'button', 'class': 'btn btn-primary', onClick: function onClick() {
	                                    return _this4.showdetailedb2b();
	                                  } },
	                                'Detailed Preview (B2B)'
	                              )
	                            ),
	                            (this.state.optiontoshow == 'both' || this.state.optiontoshow == 'onlyparents') && _react2.default.createElement(
	                              'span',
	                              null,
	                              '\xA0',
	                              _react2.default.createElement(
	                                'button',
	                                { type: 'button', 'class': 'btn btn-primary', onClick: function onClick() {
	                                    return _this4.showdetailedb2c();
	                                  } },
	                                'Detailed Preview (B2C)'
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'row' },
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'col-md-12 col-sm-12 col-xs-12' },
	                            (this.state.b2b_approved == 1 || this.state.b2c_approved == 1) && _react2.default.createElement(
	                              'button',
	                              { type: 'button', 'class': 'btn btn-info', onClick: function onClick() {
	                                  return _this4.savefornow();
	                                } },
	                              'Save'
	                            ),
	                            '\xA0',
	                            _react2.default.createElement(
	                              'button',
	                              { type: 'button', 'class': 'btn btn-success', onClick: function onClick() {
	                                  return _this4.submission();
	                                } },
	                              'Submit for Approval'
	                            )
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _reactstrap.Modal,
	                        { isOpen: this.state.thumbpreviewb2b, className: 'modalpopup w33' },
	                        _react2.default.createElement(
	                          _reactstrap.ModalHeader,
	                          null,
	                          'Preview B2B'
	                        ),
	                        _react2.default.createElement(
	                          _reactstrap.ModalBody,
	                          { className: 'p-0' },
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'row col-md-12' },
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'col-md-12 mb-12' },
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'exclprtrs-container' },
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'topLogo' },
	                                  this.state.logo == '' && _react2.default.createElement('img', { src: "https://api.bewise.in/uploads/defaultlogo.png", width: '150' }),
	                                  this.state.logo != '' && _react2.default.createElement('img', { src: "https://api.bewise.in/uploads/" + this.state.logo, alt: 'LeverageEdu - Logo', width: '100px' })
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'middleContExcl' },
	                                  _react2.default.createElement(
	                                    'h5',
	                                    null,
	                                    this.state.name
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    _react2.default.createElement(
	                                      'button',
	                                      { 'class': 'btn btn-primary', 'data-id': '65' },
	                                      'view more'
	                                    )
	                                  )
	                                )
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          _reactstrap.ModalFooter,
	                          null,
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'col-md-12 text-center' },
	                              _react2.default.createElement(
	                                'button',
	                                { className: 'btn btn-sm btn-default', onClick: this.cancelPopb2b },
	                                'Close'
	                              )
	                            )
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _reactstrap.Modal,
	                        { isOpen: this.state.thumbpreviewb2c, className: 'modalpopup w33' },
	                        _react2.default.createElement(
	                          _reactstrap.ModalHeader,
	                          null,
	                          'Preview B2C'
	                        ),
	                        _react2.default.createElement(
	                          _reactstrap.ModalBody,
	                          { className: 'p-0' },
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'row col-md-12' },
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'col-md-12 mb-12' },
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'exclprtrs-container' },
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'topLogo' },
	                                  this.state.logo == '' && _react2.default.createElement('img', { src: "https://api.bewise.in/uploads/defaultlogo.png", width: '150' }),
	                                  this.state.logo != '' && _react2.default.createElement('img', { src: "https://api.bewise.in/uploads/" + this.state.logo, alt: 'LeverageEdu - Logo', width: '100px' })
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'middleContExcl' },
	                                  _react2.default.createElement(
	                                    'h5',
	                                    null,
	                                    this.state.name
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    _react2.default.createElement(
	                                      'button',
	                                      { 'class': 'btn btn-primary', 'data-id': '65' },
	                                      'view more'
	                                    )
	                                  )
	                                )
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          _reactstrap.ModalFooter,
	                          null,
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'col-md-12 text-center' },
	                              _react2.default.createElement(
	                                'button',
	                                { className: 'btn btn-sm btn-default', onClick: this.cancelPopb2c },
	                                'Close'
	                              )
	                            )
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _reactstrap.Modal,
	                        { size: 'lg', isOpen: this.state.detailedpreviewb2b, className: 'modalpopup' },
	                        _react2.default.createElement(
	                          _reactstrap.ModalHeader,
	                          null,
	                          'Preview - Detail Page View - B2B'
	                        ),
	                        _react2.default.createElement(
	                          _reactstrap.ModalBody,
	                          { className: 'p-0 detailedpreview' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'col-lg-12 col-sm-12 col-md-12 col-xs-12 no-padding' },
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'row' },
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'col-lg-12 col-sm-12 col-md-12 col-xs-12 no-padding' },
	                                  _react2.default.createElement(
	                                    'a',
	                                    { href: '#', target: '_blank' },
	                                    _react2.default.createElement('img', { src: _constant2.IMGBASEURL + "uploads/" + this.state.banners_b2b, 'class': 'bannerimage' })
	                                  )
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'row' },
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'col-lg-12' },
	                                  _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'onDemandInfo', id: 'onDemandInfo' },
	                                    _react2.default.createElement(
	                                      'div',
	                                      { id: 'description_section' },
	                                      _react2.default.createElement(
	                                        'h3',
	                                        null,
	                                        'About Us'
	                                      ),
	                                      _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'aboutinfo_fleft' },
	                                        _react2.default.createElement(
	                                          'div',
	                                          { 'class': 'per20 logobox' },
	                                          _react2.default.createElement('img', { src: _constant2.IMGBASEURL + 'uploads/' + this.state.logo, className: 'orgphoto' })
	                                        ),
	                                        _react2.default.createElement('div', { 'class': 'aboutinfo', dangerouslySetInnerHTML: { __html: this.state.description_b2b } })
	                                      )
	                                    ),
	                                    _react2.default.createElement('br', null),
	                                    _react2.default.createElement(
	                                      'div',
	                                      { id: 'exclusive_offers_section' },
	                                      _react2.default.createElement(
	                                        'h3',
	                                        null,
	                                        'Exclusive Offers'
	                                      ),
	                                      _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'offer_row borderwithcolor1' },
	                                        this.state.offerimage_b2b != '' && _react2.default.createElement(
	                                          'div',
	                                          { 'class': 'offer_left_img' },
	                                          _react2.default.createElement('img', { src: "https://api.bewise.in/uploads/" + this.state.offerimage_b2b })
	                                        ),
	                                        _react2.default.createElement(
	                                          'div',
	                                          { 'class': 'offer_right_text' },
	                                          _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: this.state.offerdesc_b2b } })
	                                        )
	                                      ),
	                                      this.state.contenttype == 'bewisecustom' && _react2.default.createElement(
	                                        'button',
	                                        { name: 'participate', 'class': 'btn btn-primary' },
	                                        'Participate'
	                                      ),
	                                      this.state.contenttype == 'href' && _react2.default.createElement(
	                                        'div',
	                                        null,
	                                        _react2.default.createElement(
	                                          'a',
	                                          { href: this.state.link },
	                                          this.state.clicktext
	                                        )
	                                      ),
	                                      this.state.contenttype == 'btn' && _react2.default.createElement(
	                                        'div',
	                                        null,
	                                        _react2.default.createElement(
	                                          'a',
	                                          { href: this.state.link, 'class': 'btn btn-primary btn-sm' },
	                                          this.state.clicktext
	                                        )
	                                      )
	                                    ),
	                                    _react2.default.createElement('br', null),
	                                    _react2.default.createElement(
	                                      'div',
	                                      { id: 'video_section' },
	                                      _react2.default.createElement(
	                                        'h3',
	                                        null,
	                                        'Videos'
	                                      ),
	                                      _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'row n5v3k' },
	                                        this.state.video != '' && this.state.video != null && _react2.default.createElement(
	                                          'div',
	                                          { 'class': 'container' },
	                                          _react2.default.createElement(
	                                            'video',
	                                            { width: '320', height: '240', controls: true },
	                                            _react2.default.createElement('source', { src: this.state.video, type: 'video/mp4' }),
	                                            'Your browser does not support the video tag.'
	                                          )
	                                        ),
	                                        this.state.videourl !== '' && this.state.videourl != null && _react2.default.createElement(
	                                          'div',
	                                          { 'class': 'container' },
	                                          _react2.default.createElement('iframe', { height: '320', width: '240', src: this.state.videourl })
	                                        )
	                                      )
	                                    ),
	                                    _react2.default.createElement('br', null),
	                                    _react2.default.createElement(
	                                      'div',
	                                      { id: 'contactinfo_section' },
	                                      _react2.default.createElement(
	                                        'h3',
	                                        null,
	                                        'Contact Info'
	                                      ),
	                                      _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'col-lg-8 col-sm-12 col-md-12 col-xs-12 text-left' },
	                                        _react2.default.createElement(
	                                          'div',
	                                          { 'class': 'per100 text-left' },
	                                          _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'bs_social' },
	                                            _react2.default.createElement(
	                                              'div',
	                                              null,
	                                              ' Email Address: ',
	                                              _react2.default.createElement(
	                                                'b',
	                                                null,
	                                                this.state.emailaddress
	                                              ),
	                                              ' '
	                                            ),
	                                            _react2.default.createElement('br', null),
	                                            _react2.default.createElement(
	                                              'div',
	                                              null,
	                                              ' Website: ',
	                                              _react2.default.createElement(
	                                                'b',
	                                                null,
	                                                _react2.default.createElement(
	                                                  'a',
	                                                  { target: '_blank', href: this.state.website },
	                                                  this.state.website
	                                                )
	                                              ),
	                                              ' '
	                                            ),
	                                            _react2.default.createElement('br', null),
	                                            _react2.default.createElement(
	                                              'div',
	                                              null,
	                                              ' Contact Number: ',
	                                              _react2.default.createElement(
	                                                'b',
	                                                null,
	                                                this.state.contact_number
	                                              ),
	                                              ' '
	                                            ),
	                                            _react2.default.createElement('br', null)
	                                          )
	                                        )
	                                      )
	                                    ),
	                                    _react2.default.createElement('br', null),
	                                    _react2.default.createElement(
	                                      'div',
	                                      { id: 'review_section' },
	                                      _react2.default.createElement(
	                                        'h3',
	                                        { 'class': 'review_head' },
	                                        'Review',
	                                        _react2.default.createElement(
	                                          'div',
	                                          { 'class': 'floatright' },
	                                          _react2.default.createElement(
	                                            'small',
	                                            { 'class': 'pointer' },
	                                            _react2.default.createElement('i', { 'class': 'fa fa-plus', 'aria-hidden': 'true' })
	                                          )
	                                        )
	                                      ),
	                                      _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'reviewinfo' },
	                                        _react2.default.createElement(
	                                          'div',
	                                          { 'class': 'col-md-12' },
	                                          _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'detailBox' },
	                                            _react2.default.createElement(
	                                              'div',
	                                              { 'class': 'form-comments' },
	                                              _react2.default.createElement(
	                                                'p',
	                                                null,
	                                                'Click here to view Comments!...'
	                                              )
	                                            )
	                                          )
	                                        )
	                                      )
	                                    ),
	                                    _react2.default.createElement('br', null)
	                                  )
	                                )
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          _reactstrap.ModalFooter,
	                          null,
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'col-md-12 text-center' },
	                              _react2.default.createElement(
	                                'button',
	                                { className: 'btn btn-sm btn-default', onClick: this.cancelPopDetailB2B },
	                                'Close'
	                              )
	                            )
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _reactstrap.Modal,
	                        { size: 'lg', isOpen: this.state.detailedpreviewb2c, className: 'modalpopup' },
	                        _react2.default.createElement(
	                          _reactstrap.ModalHeader,
	                          null,
	                          'Preview - Detail Page View - B2C'
	                        ),
	                        _react2.default.createElement(
	                          _reactstrap.ModalBody,
	                          { className: 'p-0 detailedpreview' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'col-lg-12 col-sm-12 col-md-12 col-xs-12 no-padding' },
	                              _react2.default.createElement('img', { src: _headerimage2.default, 'class': 'headerimagewidth' })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'col-lg-12 col-sm-12 col-md-12 col-xs-12 no-padding' },
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'row' },
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'col-lg-2 col-sm-12 col-md-12 col-xs-12 no-padding' },
	                                  _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'per20 logobox' },
	                                    _react2.default.createElement('img', { src: _constant2.IMGBASEURL + "uploads/" + this.state.logo, 'class': 'orgphoto' })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'col-lg-10 col-sm-12 col-md-12 col-xs-12 no-padding' },
	                                  _react2.default.createElement(
	                                    'a',
	                                    { href: '#', target: '_blank' },
	                                    _react2.default.createElement('img', { src: _constant2.IMGBASEURL + "uploads/" + this.state.banner, 'class': 'bannerimage' })
	                                  )
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'row' },
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'col-lg-2 leftmenu' },
	                                  _react2.default.createElement('img', { src: _leftmenuimage2.default, 'class': 'leftmenuimg' })
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'col-lg-8' },
	                                  _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'onDemandInfo', id: 'onDemandInfo' },
	                                    _react2.default.createElement(
	                                      'div',
	                                      { id: 'description_section' },
	                                      _react2.default.createElement(
	                                        'h3',
	                                        null,
	                                        'About Us'
	                                      ),
	                                      _react2.default.createElement('div', { 'class': 'aboutinfo', dangerouslySetInnerHTML: { __html: this.state.description } })
	                                    ),
	                                    _react2.default.createElement('br', null),
	                                    _react2.default.createElement(
	                                      'div',
	                                      { id: 'exclusive_offers_section' },
	                                      _react2.default.createElement(
	                                        'h3',
	                                        null,
	                                        'Exclusive Offers'
	                                      ),
	                                      _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'offer_row borderwithcolor1' },
	                                        this.state.offerimage1 != '' && _react2.default.createElement(
	                                          'div',
	                                          { 'class': 'offer_left_img' },
	                                          _react2.default.createElement('img', { src: "https://api.bewise.in/uploads/" + this.state.offerimage1 })
	                                        ),
	                                        _react2.default.createElement(
	                                          'div',
	                                          { 'class': 'offer_right_text' },
	                                          _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: this.state.offer1desc } })
	                                        )
	                                      ),
	                                      this.state.contenttype == 'bewisecustom' && _react2.default.createElement(
	                                        'button',
	                                        { name: 'participate', 'class': 'btn btn-primary' },
	                                        'Participate'
	                                      ),
	                                      this.state.contenttype == 'href' && _react2.default.createElement(
	                                        'div',
	                                        null,
	                                        _react2.default.createElement(
	                                          'a',
	                                          { href: this.state.link },
	                                          this.state.clicktext
	                                        )
	                                      ),
	                                      this.state.contenttype == 'btn' && _react2.default.createElement(
	                                        'div',
	                                        null,
	                                        _react2.default.createElement(
	                                          'a',
	                                          { href: this.state.link, 'class': 'btn btn-primary btn-sm' },
	                                          this.state.clicktext
	                                        )
	                                      )
	                                    ),
	                                    _react2.default.createElement('br', null),
	                                    _react2.default.createElement(
	                                      'div',
	                                      { id: 'video_section' },
	                                      _react2.default.createElement(
	                                        'h3',
	                                        null,
	                                        'Videos'
	                                      ),
	                                      _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'row n5v3k' },
	                                        this.state.video != '' && this.state.video != null && _react2.default.createElement(
	                                          'div',
	                                          { 'class': 'container' },
	                                          _react2.default.createElement(
	                                            'video',
	                                            { width: '320', height: '240', controls: true },
	                                            _react2.default.createElement('source', { src: this.state.video, type: 'video/mp4' }),
	                                            'Your browser does not support the video tag.'
	                                          )
	                                        ),
	                                        this.state.videourl !== '' && this.state.videourl != null && _react2.default.createElement(
	                                          'div',
	                                          { 'class': 'container' },
	                                          _react2.default.createElement('iframe', { height: '320', width: '240', src: this.state.videourl })
	                                        )
	                                      )
	                                    ),
	                                    _react2.default.createElement('br', null),
	                                    _react2.default.createElement(
	                                      'div',
	                                      { id: 'contactinfo_section' },
	                                      _react2.default.createElement(
	                                        'h3',
	                                        null,
	                                        'Contact Info'
	                                      ),
	                                      _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'col-lg-8 col-sm-12 col-md-12 col-xs-12 text-left' },
	                                        _react2.default.createElement(
	                                          'div',
	                                          { 'class': 'per100 text-left' },
	                                          _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'bs_social' },
	                                            _react2.default.createElement(
	                                              'div',
	                                              null,
	                                              ' Email Address: ',
	                                              _react2.default.createElement(
	                                                'b',
	                                                null,
	                                                this.state.emailaddress
	                                              ),
	                                              ' '
	                                            ),
	                                            _react2.default.createElement('br', null),
	                                            _react2.default.createElement(
	                                              'div',
	                                              null,
	                                              ' Website: ',
	                                              _react2.default.createElement(
	                                                'b',
	                                                null,
	                                                _react2.default.createElement(
	                                                  'a',
	                                                  { target: '_blank', href: this.state.website },
	                                                  this.state.website
	                                                )
	                                              ),
	                                              ' '
	                                            ),
	                                            _react2.default.createElement('br', null),
	                                            _react2.default.createElement(
	                                              'div',
	                                              null,
	                                              ' Contact Number: ',
	                                              _react2.default.createElement(
	                                                'b',
	                                                null,
	                                                this.state.contact_number
	                                              ),
	                                              ' '
	                                            ),
	                                            _react2.default.createElement('br', null)
	                                          )
	                                        )
	                                      )
	                                    ),
	                                    _react2.default.createElement('br', null),
	                                    _react2.default.createElement(
	                                      'div',
	                                      { id: 'review_section' },
	                                      _react2.default.createElement(
	                                        'h3',
	                                        { 'class': 'review_head' },
	                                        'Review',
	                                        _react2.default.createElement(
	                                          'div',
	                                          { 'class': 'floatright' },
	                                          _react2.default.createElement(
	                                            'small',
	                                            { 'class': 'pointer' },
	                                            _react2.default.createElement('i', { 'class': 'fa fa-plus', 'aria-hidden': 'true' })
	                                          )
	                                        )
	                                      ),
	                                      _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'reviewinfo' },
	                                        _react2.default.createElement(
	                                          'div',
	                                          { 'class': 'col-md-12' },
	                                          _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'detailBox' },
	                                            _react2.default.createElement(
	                                              'div',
	                                              { 'class': 'form-comments' },
	                                              _react2.default.createElement(
	                                                'p',
	                                                null,
	                                                'Click here to view Comments!...'
	                                              )
	                                            )
	                                          )
	                                        )
	                                      )
	                                    ),
	                                    _react2.default.createElement('br', null)
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'col-lg-2 rightmenu' },
	                                  _react2.default.createElement('img', { src: _rightmenuimage2.default, 'class': 'rightmenuimg' })
	                                )
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'row' },
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'col-md-12 footerp' },
	                              _react2.default.createElement('img', { src: _footerpreview2.default, 'class': 'headerimagewidth' })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          _reactstrap.ModalFooter,
	                          null,
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'col-md-12 text-center' },
	                              _react2.default.createElement(
	                                'button',
	                                { className: 'btn btn-sm btn-default', onClick: this.cancelPopDetailB2C },
	                                'Close'
	                              )
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(_reactNotifications.NotificationContainer, null)
	        )
	      );
	    }
	  }]);
	
	  return exclusivePartnerEdit;
	}(_react.Component);
	
	exports.default = exclusivePartnerEdit;

/***/ },
/* 940 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _reactShare = __webpack_require__(211);
	
	var _reactstrap = __webpack_require__(17);
	
	var _tinymceReact = __webpack_require__(69);
	
	var _constant = __webpack_require__(21);
	
	var _reactSlick = __webpack_require__(93);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _head = __webpack_require__(248);
	
	var _head2 = _interopRequireDefault(_head);
	
	var _foot = __webpack_require__(247);
	
	var _foot2 = _interopRequireDefault(_foot);
	
	var _constant2 = __webpack_require__(21);
	
	var _FetchCall = __webpack_require__(4);
	
	var _universalCookie = __webpack_require__(135);
	
	var _universalCookie2 = _interopRequireDefault(_universalCookie);
	
	var _footerpreview = __webpack_require__(137);
	
	var _footerpreview2 = _interopRequireDefault(_footerpreview);
	
	var _previewheader = __webpack_require__(140);
	
	var _previewheader2 = _interopRequireDefault(_previewheader);
	
	var _headerimage = __webpack_require__(138);
	
	var _headerimage2 = _interopRequireDefault(_headerimage);
	
	var _leftmenuimage = __webpack_require__(139);
	
	var _leftmenuimage2 = _interopRequireDefault(_leftmenuimage);
	
	var _rightmenuimage = __webpack_require__(141);
	
	var _rightmenuimage2 = _interopRequireDefault(_rightmenuimage);
	
	var _pdf = __webpack_require__(308);
	
	var _pdf2 = _interopRequireDefault(_pdf);
	
	var _word = __webpack_require__(309);
	
	var _word2 = _interopRequireDefault(_word);
	
	var _xls = __webpack_require__(310);
	
	var _xls2 = _interopRequireDefault(_xls);
	
	__webpack_require__(18);
	
	var _reactNotifications = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import { Editor } from '@tinymce/tinymce-react';
	
	
	var exclusivePartnerParentEdit = function (_Component) {
	  _inherits(exclusivePartnerParentEdit, _Component);
	
	  function exclusivePartnerParentEdit(props) {
	    _classCallCheck(this, exclusivePartnerParentEdit);
	
	    var cookies = new _universalCookie2.default();
	
	    var _this = _possibleConstructorReturn(this, (exclusivePartnerParentEdit.__proto__ || Object.getPrototypeOf(exclusivePartnerParentEdit)).call(this, props));
	
	    _this.makeMessageRead = function (login_id) {
	      var req = JSON.stringify({
	        login_id: login_id
	      });
	      (0, _FetchCall.makeMessageRead)(req).then(function (res) {
	        if (res.status === 1) {
	          _this.setState({ notes_seen: true });
	        }
	      });
	    };
	
	    _this.getEntry = function (id) {
	
	      var req = JSON.stringify({
	        id: id
	      });
	      (0, _FetchCall.getExclPtnrsEntryB2B)(req).then(function (res) {
	        if (res.status === 1) {
	          _this.setState({
	            name: res.result.name,
	            logo: res.result.logo != null ? res.result.logo : '',
	            banner: res.result.banners != null ? res.result.banners : '',
	            gallery: res.result.gallery != null ? res.result.gallery : '',
	            brochure: res.result.brochure != null ? res.result.brochure : '',
	            brochures: res.result.brochure != null ? res.result.brochure : '',
	            videos: res.result.videos != null ? res.result.videos : '',
	            approved: res.result.approved,
	            created_date: res.result.created_date,
	            facebook: res.result.facebook,
	            twitter: res.result.twitter,
	            instagram: res.result.instagram,
	            inkedin: res.result.linkedin,
	            emailaddress: res.result.emailaddress,
	            contact_number: res.result.contact_number,
	            website: res.result.website,
	            address: res.result.address,
	            description: res.result.description,
	            promotion_link: res.result.promotion_link,
	            promotion_image: res.result.promotion_image != null ? res.result.promotion_image : '',
	            contenttype: res.result.contenttype,
	            link: res.result.link,
	            clicktext: res.result.clicktext,
	            offerimage1: res.result.offerimage1 != null ? res.result.offerimage1 : '',
	            offerimage2: res.result.offerimage2 != null ? res.result.offerimage2 : '',
	            offerimage3: res.result.offerimage3 != null ? res.result.offerimage3 : '',
	            offer1desc: res.result.offer1desc,
	            offer2desc: res.result.offer2desc,
	            offer3desc: res.result.offer3desc,
	            optiontoshow: res.result.optiontoshow,
	            notes_webmaster: res.result.notes_webmaster,
	            notes_timesent: res.result.notes_timesent,
	            notes_seen: res.result.notes_seen
	          });
	        } else {
	          _this.setState({ isreco: false });
	        }
	      });
	    };
	
	    _this.cancelPop1 = function () {
	      _this.setState({
	        thumbpreview: false
	      });
	    };
	
	    _this.cancelPop2 = function () {
	      _this.setState({
	        detailedpreview: false
	      });
	    };
	
	    _this.handleChange = function (e) {
	      var propName = e.target.name;
	      _this.setState(_defineProperty({}, e.target.name, e.target.value));
	    };
	
	    _this.onFileChange = function (event) {
	
	      // Update the state
	      _this.setState({ selectedFile: event.target.files[0] });
	    };
	
	    _this.handleFileSinglePdf1 = function (event) {
	
	      // Update the state
	      _this.setState({ brochure1: event.target.files[0] });
	    };
	
	    _this.handleFileSingleThumb1 = function (event) {
	
	      // Update the state
	      _this.setState({ thumb1: event.target.files[0] });
	    };
	
	    _this.handleFileSingleThumb2 = function (event) {
	
	      // Update the state
	      _this.setState({ thumb2: event.target.files[0] });
	    };
	
	    _this.handleFileSinglePdf2 = function (event) {
	
	      // Update the state
	      _this.setState({ brochure2: event.target.files[0] });
	    };
	
	    _this.onMultipleFileChange = function (event) {
	
	      // Update the state
	      _this.setState({ selectedFiles: event.target.files });
	    };
	
	    _this.handleFileMultiplePdfs = function (e) {
	      var propName = e.target.name;
	      var files = e.target.files;
	
	      if (files.length > 3) {
	        files = '';
	        var toastr = window.toastr.error; //warning
	        toastr('', 'Select 5 Pdfs Only', {
	          positionClass: "toast-bottom-right",
	          containerId: "toast-bottom-right"
	        });
	      }
	      _this.setState(_defineProperty({}, propName, files));
	    };
	
	    _this.handleFileMultipleGallery = function (e) {
	      var propName = e.target.name;
	      var files = e.target.files;
	
	      _this.setState({
	        gallery: files
	      });
	    };
	
	    _this.handleFileMultiple = function (e) {
	      var propName = e.target.name;
	      var files = e.target.files;
	
	      if (files.length > 3) {
	        files = '';
	        var toastr = window.toastr.error; //warning
	        toastr('', 'Select 3 Images Only', {
	          positionClass: "toast-bottom-right",
	          containerId: "toast-bottom-right"
	        });
	      }
	      _this.setState({
	        banner: files
	      });
	    };
	
	    _this.onFileVideoUpload = function (event) {
	
	      var toastr = '';
	      // Details of the uploaded file
	      var _this$state$user_data = _this.state.user_data,
	          user_type = _this$state$user_data.user_type,
	          login_id = _this$state$user_data.login_id;
	
	      var formData = new FormData();
	
	      formData.append('user_type', user_type);
	      formData.append('login_id', login_id);
	      formData.append('videos', _this.state.selectedFile);
	      formData.append('id', _this.state.id);
	
	      (0, _FetchCall.uploadVideo)(formData).then(function (response) {
	
	        if (response.status == 1) {
	
	          _reactNotifications.NotificationManager.success('Video is saved successfully');
	        } else {
	
	          _reactNotifications.NotificationManager.error('There is an issue uploading file');
	        }
	      });
	    };
	
	    _this.onFileUploadImage = function (event) {
	
	      var toastr = '';
	      // Details of the uploaded file
	      var _this$state$user_data2 = _this.state.user_data,
	          user_type = _this$state$user_data2.user_type,
	          login_id = _this$state$user_data2.login_id;
	
	      var formData = new FormData();
	
	      formData.append('user_type', user_type);
	      formData.append('login_id', login_id);
	      formData.append('image', _this.state.selectedFile);
	      formData.append('id', _this.state.id);
	
	      (0, _FetchCall.uploadImage)(formData).then(function (response) {
	
	        if (response.status == 1) {
	
	          _reactNotifications.NotificationManager.success('Image is saved successfully');
	        } else {
	
	          _reactNotifications.NotificationManager.error('There is an issue uploading file');
	        }
	      });
	    };
	
	    _this.onFileUploadImage1 = function (event) {
	
	      var toastr = '';
	      // Details of the uploaded file
	      var _this$state$user_data3 = _this.state.user_data,
	          user_type = _this$state$user_data3.user_type,
	          login_id = _this$state$user_data3.login_id;
	
	      var formData = new FormData();
	
	      formData.append('user_type', user_type);
	      formData.append('login_id', login_id);
	      formData.append('image', _this.state.selectedFile);
	      formData.append('whichoffer', 'offerimage1');
	      formData.append('id', _this.state.id);
	
	      (0, _FetchCall.uploadImage)(formData).then(function (response) {
	
	        if (response.status == 1) {
	
	          _reactNotifications.NotificationManager.success('Image is saved successfully');
	        } else {
	
	          _reactNotifications.NotificationManager.error('There is an issue uploading file');
	        }
	      });
	    };
	
	    _this.onFileUploadImage2 = function (event) {
	
	      var toastr = '';
	      // Details of the uploaded file
	      var _this$state$user_data4 = _this.state.user_data,
	          user_type = _this$state$user_data4.user_type,
	          login_id = _this$state$user_data4.login_id;
	
	      var formData = new FormData();
	
	      formData.append('user_type', user_type);
	      formData.append('login_id', login_id);
	      formData.append('image', _this.state.selectedFile);
	      formData.append('whichoffer', 'offerimage2');
	      formData.append('id', _this.state.id);
	
	      (0, _FetchCall.uploadImage)(formData).then(function (response) {
	
	        if (response.status == 1) {
	
	          _reactNotifications.NotificationManager.success('Image is saved successfully');
	        } else {
	          _reactNotifications.NotificationManager.error('There is an issue uploading file');
	        }
	      });
	    };
	
	    _this.onFileUploadImage3 = function (event) {
	
	      var toastr = '';
	      // Details of the uploaded file
	      var _this$state$user_data5 = _this.state.user_data,
	          user_type = _this$state$user_data5.user_type,
	          login_id = _this$state$user_data5.login_id;
	
	      var formData = new FormData();
	
	      formData.append('user_type', user_type);
	      formData.append('login_id', login_id);
	      formData.append('image', _this.state.selectedFile);
	      formData.append('whichoffer', 'offerimage3');
	      formData.append('id', _this.state.id);
	
	      (0, _FetchCall.uploadImage)(formData).then(function (response) {
	
	        if (response.status == 1) {
	
	          _reactNotifications.NotificationManager.success('Image is saved successfully');
	        } else {
	          _reactNotifications.NotificationManager.error('There is an issue uploading file');
	        }
	      });
	    };
	
	    _this.onFileUploadLogo = function (event) {
	
	      var toastr = '';
	      // Details of the uploaded file
	      var _this$state$user_data6 = _this.state.user_data,
	          user_type = _this$state$user_data6.user_type,
	          login_id = _this$state$user_data6.login_id;
	
	      var formData = new FormData();
	
	      formData.append('user_type', user_type);
	      formData.append('login_id', login_id);
	      formData.append('logo', _this.state.selectedFile);
	      formData.append('id', _this.state.id);
	
	      (0, _FetchCall.uploadLogo)(formData).then(function (response) {
	
	        if (response.status == 1) {
	
	          if (response.id != '') {
	            _this.setState({ id: response.id });
	          }
	
	          _reactNotifications.NotificationManager.success('Logo saved successfully');
	          /*
	          toastr = window.toastr.success;
	          toastr('Logo saved successfully', {
	            positionClass: "toast-bottom-right",
	            containerId: "toast-bottom-right"
	          });*/
	
	          _this.setState({ logo: response.file });
	        } else {
	          _reactNotifications.NotificationManager.error('There is an issue uploading file');
	        }
	      });
	    };
	
	    _this.onFileUploadBanner = function (event) {
	
	      var toastr = '';
	      // Details of the uploaded file
	      var _this$state$user_data7 = _this.state.user_data,
	          user_type = _this$state$user_data7.user_type,
	          login_id = _this$state$user_data7.login_id;
	
	      var formData = new FormData();
	      formData.append('user_type', user_type);
	      formData.append('login_id', login_id);
	      formData.append('id', _this.state.id);
	
	      var banner_data = _this.state.banner;
	
	      for (var i = 0; i < banner_data.length; i++) {
	        formData.append('banner', banner_data[i]);
	      }
	
	      (0, _FetchCall.uploadBanner)(formData).then(function (response) {
	
	        if (response.status == 1) {
	
	          if (response.id != '') {
	            _this.setState({ id: response.id });
	          }
	
	          _reactNotifications.NotificationManager.success('Logo saved successfully');
	          //alert(response.files);
	          _this.setState({ banner: response.files });
	        } else {
	
	          _reactNotifications.NotificationManager.error('There is an issue uploading file');
	        }
	      });
	    };
	
	    _this.onFileUploadGallery = function (event) {
	
	      var toastr = '';
	      // Details of the uploaded file
	      var _this$state$user_data8 = _this.state.user_data,
	          user_type = _this$state$user_data8.user_type,
	          login_id = _this$state$user_data8.login_id;
	
	      var formData = new FormData();
	      formData.append('user_type', user_type);
	      formData.append('login_id', login_id);
	      formData.append('id', _this.state.id);
	
	      var gallery_data = _this.state.gallery;
	
	      for (var i = 0; i < gallery_data.length; i++) {
	        formData.append('gallery', gallery_data[i]);
	      }
	
	      (0, _FetchCall.uploadGallery)(formData).then(function (response) {
	
	        if (response.status == 1) {
	
	          _reactNotifications.NotificationManager.success('Gallery Image saved successfully');
	          //alert(response.files);
	          if (response.id != '') {
	            _this.setState({ id: response.id });
	          }
	          _this.setState({ gallery: response.files });
	        } else {
	
	          _reactNotifications.NotificationManager.error('There is an issue uploading file');
	        }
	      });
	    };
	
	    _this.onFileUploadBrochureThumb2 = function (event) {
	
	      var toastr = '';
	      // Details of the uploaded file
	      var _this$state$user_data9 = _this.state.user_data,
	          user_type = _this$state$user_data9.user_type,
	          login_id = _this$state$user_data9.login_id;
	
	      var formData = new FormData();
	
	      formData.append('user_type', user_type);
	      formData.append('login_id', login_id);
	      formData.append('thumb2', _this.state.selectedFile);
	      formData.append('id', _this.state.id);
	
	      (0, _FetchCall.uploadThumb2)(formData).then(function (response) {
	
	        if (response.status == 1) {
	
	          if (response.id != '') {
	            _this.setState({ id: response.id });
	          }
	
	          _reactNotifications.NotificationManager.success('Thumb 2 saved successfully');
	
	          _this.setState({ thumb1: response.file });
	        } else {
	
	          _reactNotifications.NotificationManager.error('There is an issue uploading file');
	        }
	      });
	    };
	
	    _this.onFileUploadBrochureThumb1 = function (event) {
	
	      var toastr = '';
	      // Details of the uploaded file
	      var _this$state$user_data10 = _this.state.user_data,
	          user_type = _this$state$user_data10.user_type,
	          login_id = _this$state$user_data10.login_id;
	
	      var formData = new FormData();
	
	      formData.append('user_type', user_type);
	      formData.append('login_id', login_id);
	      formData.append('thumb1', _this.state.selectedFile);
	      formData.append('id', _this.state.id);
	
	      (0, _FetchCall.uploadThumb1)(formData).then(function (response) {
	
	        if (response.status == 1) {
	
	          if (response.id != '') {
	            _this.setState({ id: response.id });
	          }
	
	          _reactNotifications.NotificationManager.success('Thumb 1 saved successfully');
	          _this.setState({ thumb1: response.file });
	        } else {
	
	          _reactNotifications.NotificationManager.error('There is an issue uploading file');
	        }
	      });
	    };
	
	    _this.onFileUploadBrochure2 = function (event) {
	
	      var toastr = '';
	      // Details of the uploaded file
	      var _this$state$user_data11 = _this.state.user_data,
	          user_type = _this$state$user_data11.user_type,
	          login_id = _this$state$user_data11.login_id;
	
	      var formData = new FormData();
	
	      formData.append('user_type', user_type);
	      formData.append('login_id', login_id);
	      formData.append('file2', _this.state.selectedFile);
	      formData.append('id', _this.state.id);
	
	      (0, _FetchCall.uploadFile2)(formData).then(function (response) {
	
	        if (response.status == 1) {
	
	          if (response.id != '') {
	            _this.setState({ id: response.id });
	          }
	
	          _reactNotifications.NotificationManager.success('File 2 saved successfully');
	
	          _this.setState({ file1: response.file });
	        } else {
	          _reactNotifications.NotificationManager.error('There is an issue uploading file');
	        }
	      });
	    };
	
	    _this.onFileUploadBrochure1 = function (event) {
	
	      var toastr = '';
	      // Details of the uploaded file
	      var _this$state$user_data12 = _this.state.user_data,
	          user_type = _this$state$user_data12.user_type,
	          login_id = _this$state$user_data12.login_id;
	
	      var formData = new FormData();
	
	      formData.append('user_type', user_type);
	      formData.append('login_id', login_id);
	      formData.append('file1', _this.state.selectedFile);
	      formData.append('id', _this.state.id);
	
	      (0, _FetchCall.uploadFile1)(formData).then(function (response) {
	
	        if (response.status == 1) {
	
	          if (response.id != '') {
	            _this.setState({ id: response.id });
	          }
	          _reactNotifications.NotificationManager.success('File 1 saved successfully');
	
	          _this.setState({ file1: response.file });
	        } else {
	          _reactNotifications.NotificationManager.error('There is an issue uploading file');
	        }
	      });
	    };
	
	    _this.onFileUploadBrochure = function (event) {
	
	      var toastr = '';
	      // Details of the uploaded file
	
	      var formData = new FormData();
	      var _this$state$user_data13 = _this.state.user_data,
	          user_type = _this$state$user_data13.user_type,
	          login_id = _this$state$user_data13.login_id;
	
	
	      formData.append('user_type', user_type);
	      formData.append('login_id', login_id);
	      formData.append('id', _this.state.id);
	
	      var brochure_data = _this.state.brochure;
	
	      for (var i = 0; i < brochure_data.length; i++) {
	        formData.append('brochure', brochure_data[i]);
	      }
	
	      (0, _FetchCall.uploadBrochure)(formData).then(function (response) {
	
	        if (response.status == 1) {
	
	          if (response.id != '') {
	            _this.setState({ id: response.id });
	          }
	
	          _reactNotifications.NotificationManager.success('Brochure saved successfully');
	        } else {
	          _reactNotifications.NotificationManager.error('There is an issue uploading file');
	        }
	      });
	    };
	
	    _this.state = {
	      thumbpreview: false,
	      detailedpreview: false,
	      submitted: false,
	      selectedFile: null,
	      banner: '',
	      brochure: '',
	      brochures: '',
	      gallery: '',
	      offerimage1: '',
	      offerimage2: '',
	      offerimage3: '',
	      offer1desc: '',
	      offer2desc: '',
	      contact_number: '',
	      offer3desc: '',
	      optiontoshow: 'onlyparents',
	      user_data: localStorage.getItem('user_data') ? JSON.parse(localStorage.getItem('user_data')) : [],
	      authentication: localStorage.getItem('authentication') ? JSON.parse(localStorage.getItem('authentication')) : false,
	      user_type: 99,
	      videos: '',
	      logo: 'defaultlogo.png',
	      id: _this.props.match.params.id ? _this.props.match.params.id : ''
	    };
	
	    _this.submission = _this.submission.bind(_this);
	    _this.onFileUploadBanner = _this.onFileUploadBanner.bind(_this);
	    _this.onFileUploadBrochure = _this.onFileUploadBrochure.bind(_this);
	    _this.onFileUploadGallery = _this.onFileUploadGallery.bind(_this);
	    _this.onFileVideoUpload = _this.onFileVideoUpload.bind(_this);
	
	    _this.handleChangeDescription = _this.handleChangeDescription.bind(_this);
	    _this.handleChangeoffer1desc = _this.handleChangeoffer1desc.bind(_this);
	    _this.handleChangeoffer2desc = _this.handleChangeoffer2desc.bind(_this);
	
	    _this.onFileUploadBrochureThumb1 = _this.onFileUploadBrochureThumb1.bind(_this);
	    _this.onFileUploadBrochureThumb2 = _this.onFileUploadBrochureThumb2.bind(_this);
	
	    _this.onFileUploadBrochure1 = _this.onFileUploadBrochure1.bind(_this);
	    _this.onFileUploadBrochure2 = _this.onFileUploadBrochure2.bind(_this);
	    _this.id = _this.props.match.params.id ? _this.props.match.params.id : '';
	    return _this;
	  }
	
	  _createClass(exclusivePartnerParentEdit, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var user_data = this.state.user_data;
	
	      if (this.id != '') this.getEntry(this.id);
	    }
	  }, {
	    key: 'handleChangeDescription',
	    value: function handleChangeDescription(value, editor) {
	      //console.log(value);
	      this.setState({
	        description: value
	      });
	    }
	  }, {
	    key: 'handleChangeoffer1desc',
	    value: function handleChangeoffer1desc(value, editor) {
	      //console.log(value);
	      this.setState({
	        offer1desc: value
	      });
	    }
	  }, {
	    key: 'handleChangeoffer2desc',
	    value: function handleChangeoffer2desc(value, editor) {
	      //console.log(value);
	      this.setState({
	        offer2desc: value
	      });
	    }
	  }, {
	    key: 'savefornow',
	    value: function savefornow() {
	
	      var toastr = '';
	
	      var _state$user_data = this.state.user_data,
	          user_type = _state$user_data.user_type,
	          login_id = _state$user_data.login_id;
	
	      /*
	      let downloable_content={
	                          contenttype:this.state.contenttype,
	                          clicktext:this.state.clicktext,
	                          link:this.state.link};
	      */
	
	      var req = JSON.stringify({
	        id: this.state.id,
	        user_type: user_type,
	        login_id: login_id,
	        name: this.state.name,
	        description: this.state.description,
	        website: this.state.website,
	        contact_number: this.state.contact_number,
	        address: this.state.address,
	        emailaddress: this.state.emailaddress,
	        facebook: this.state.facebook,
	        clicktext: this.state.clicktext,
	        link: this.state.link,
	        offer2desc: this.state.offer2desc,
	        offer1desc: this.state.offer1desc,
	        optiontoshow: this.state.optiontoshow,
	        contenttype: this.state.contenttype,
	        promotion_link: this.state.promotion_link,
	        twitter: this.state.twitter,
	        instagram: this.state.instagram,
	        inkedin: this.state.linkedin,
	        approved: 0
	      });
	
	      if (this.id != '') {
	
	        (0, _FetchCall.updateEntry)(req).then(function (response) {
	
	          if (response.status == 1) {
	
	            _reactNotifications.NotificationManager.success('Partnership update has now been saved');
	          } else {
	            _reactNotifications.NotificationManager.error('There is an issue uploading file');
	          }
	        });
	      } else {
	        (0, _FetchCall.saveEntry)(req).then(function (response) {
	
	          if (response.status == 1) {
	
	            _reactNotifications.NotificationManager.success('Partnership update has now been saved');
	          } else {
	
	            _reactNotifications.NotificationManager.error('There is an issue uploading file');
	          }
	        });
	      }
	    }
	  }, {
	    key: 'submission',
	    value: function submission() {
	      var _this2 = this;
	
	      var toastr = '';
	
	      if (this.state.logo == '' || this.state.logo == 'defaultlogo.png' || this.state.banner == '' || this.state.name == '' || this.state.description == '') {
	
	        _reactNotifications.NotificationManager.error('Please make sure you provide all required minimum data such as logo, banner , name and description');
	      } else {
	        var _state$user_data2 = this.state.user_data,
	            user_type = _state$user_data2.user_type,
	            login_id = _state$user_data2.login_id;
	
	
	        var req = JSON.stringify({
	          id: this.state.id,
	          user_type: user_type,
	          login_id: login_id,
	          name: this.state.name,
	          description: this.state.description,
	          website: this.state.website,
	          address: this.state.address,
	          emailaddress: this.state.emailaddress,
	          contact_number: this.state.contact_number,
	          facebook: this.state.facebook,
	          clicktext: this.state.clicktext,
	          link: this.state.link,
	          offer2desc: this.state.offer2desc,
	          offer1desc: this.state.offer1desc,
	          optiontoshow: this.state.optiontoshow,
	          contenttype: this.state.contenttype,
	          promotion_link: this.state.promotion_link,
	          twitter: this.state.twitter,
	          instagram: this.state.instagram,
	          inkedin: this.state.linkedin
	        });
	
	        (0, _FetchCall.submitEntry)(req).then(function (response) {
	
	          if (response.status == 1) {
	
	            _reactNotifications.NotificationManager.success('Update success');
	            _this2.setState({ submitted: true });
	          } else {
	
	            _reactNotifications.NotificationManager.error('There is an issue uploading file');
	          }
	        });
	      }
	    }
	  }, {
	    key: 'showthumbnail',
	    value: function showthumbnail() {
	      this.setState({ thumbpreview: true });
	    }
	  }, {
	    key: 'showdetailed',
	    value: function showdetailed() {
	      this.setState({ detailedpreview: true });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var gallerysettings = {
	        dots: false,
	        infinite: false,
	        speed: 500,
	        slidesToShow: 3,
	        slidesToScroll: 3,
	        responsive: [{
	          breakpoint: 768,
	          settings: {
	            slidesToShow: 1,
	            centerMode: false, /* set centerMode to false to show complete slide instead of 3 */
	            slidesToScroll: 1
	          }
	        }]
	      };
	
	      var banners = this.state.banner != '' ? this.state.banner.toString().split(",") : '';
	      var gallery = this.state.gallery.toString().split(",");
	      var sliders = '';
	      //const sliders = this.state.banner.split(",");
	      var galleries = this.state.gallery != '' ? this.state.gallery.toString().split(",") : '';
	      //const IMG_URL = 'http://localhost:5005/';
	
	      var offer1 = this.state.offerimage1 != '' ? _constant2.IMGBASEURL + 'uploads/' + this.state.offerimage1 : '';
	      var offer2 = this.state.offerimage2 != '' ? _constant2.IMGBASEURL + 'uploads/' + this.state.offerimage2 : '';
	      var offer3 = this.state.offerimage3 != '' ? _constant2.IMGBASEURL + 'uploads/' + this.state.offerimage3 : '';
	
	      var offer1desc = this.state.offer1desc;
	      var offer2desc = this.state.offer2desc;
	      var offer3desc = this.state.offer3desc;
	
	      var brochures = this.state.brochures.split(",");
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'col-lg-12 grid-margin stretch-card' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card-body' },
	                _react2.default.createElement(
	                  'h4',
	                  { 'class': 'card-title' },
	                  'Exclusive Partnerships - Edit'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'row' },
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'col-lg-12' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'main-content col-md-12 col-xs-12' },
	                      this.state.submitted == true && _react2.default.createElement(
	                        'div',
	                        { 'class': 'aftersubmitmessage' },
	                        'Partnership update has now been resubmitted for review @ BeWise. Thank you for your partnership and we remain greatful.'
	                      ),
	                      this.state.submitted == false && _react2.default.createElement(
	                        _react2.default.Fragment,
	                        null,
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'row' },
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'col-md-6 col-sm-6 col-xs-12' },
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'card' },
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'card-body' },
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'card-title' },
	                                  'Profile Information'
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'input-group input-group-sm' },
	                                  _react2.default.createElement('input', { type: 'text', name: 'name', 'class': 'form-control input-sm', placeholder: 'Name', value: this.state.name, onChange: this.handleChange })
	                                ),
	                                _react2.default.createElement('br', null),
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'input-group input-group-sm' },
	                                  _react2.default.createElement('input', { type: 'text', name: 'address', 'class': 'form-control input-lg', placeholder: 'Address', onChange: this.handleChange, value: this.state.address })
	                                ),
	                                _react2.default.createElement('br', null),
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'input-group input-group-sm' },
	                                  _react2.default.createElement('input', { type: 'email', name: 'emailaddress', 'class': 'form-control input-sm', placeholder: 'Email Address', onChange: this.handleChange, value: this.state.emailaddress })
	                                ),
	                                _react2.default.createElement('br', null),
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'input-group input-group-sm' },
	                                  _react2.default.createElement('input', { type: 'text', name: 'website', 'class': 'form-control input-sm', placeholder: 'Web Site', onChange: this.handleChange, value: this.state.website })
	                                ),
	                                _react2.default.createElement('br', null),
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'input-group input-group-sm' },
	                                  _react2.default.createElement('input', { type: 'text', name: 'contact_number', 'class': 'form-control input-sm', placeholder: 'Contact Number', onChange: this.handleChange, value: this.state.contact_number })
	                                ),
	                                _react2.default.createElement('br', null),
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'input-group' },
	                                  _react2.default.createElement(_tinymceReact.Editor, {
	                                    onEditorChange: this.handleChangeDescription,
	                                    value: this.state.description,
	                                    apiKey: _constant.TINY_EDITOR,
	                                    init: {
	                                      height: 300,
	                                      plugins: ['lists link image paste'],
	                                      toolbar: 'undo redo | formatselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | help'
	                                    }
	                                  })
	                                )
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'col-md-6 col-sm-6 col-xs-12' },
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'card' },
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'card-body' },
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'card-title' },
	                                  'Medias'
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': ' input-group-sm' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { 'for': 'logo' },
	                                    'Logo (png)'
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'row' },
	                                    _react2.default.createElement(
	                                      'div',
	                                      { 'class': 'col-md-6 col-sm-6 col-xs-12' },
	                                      _react2.default.createElement('input', { type: 'file', name: 'logo', 'class': 'form-control input-sm', placeholder: 'Logo', onChange: this.onFileChange })
	                                    ),
	                                    _react2.default.createElement(
	                                      'div',
	                                      { 'class': 'col-md-6 col-sm-6 col-xs-12' },
	                                      _react2.default.createElement(
	                                        'button',
	                                        { 'class': 'btn btn-primary btn-sm', onClick: this.onFileUploadLogo },
	                                        'Upload!'
	                                      )
	                                    )
	                                  ),
	                                  this.state.logo != '' && _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'existingmedia' },
	                                    _react2.default.createElement('img', { src: _constant2.IMGBASEURL + "uploads/" + this.state.logo })
	                                  )
	                                ),
	                                _react2.default.createElement('br', null),
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'input-group-sm' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { 'for': 'banner' },
	                                    'Brand Banner (980x1028)'
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'row' },
	                                    _react2.default.createElement(
	                                      'div',
	                                      { 'class': 'col-md-6 col-sm-6 col-xs-12' },
	                                      _react2.default.createElement('input', { type: 'file', id: 'banner', name: 'banner', multiple: true, 'class': 'form-control input-sm', placeholder: 'Banner', onChange: this.handleFileMultiple })
	                                    ),
	                                    _react2.default.createElement(
	                                      'div',
	                                      { 'class': 'col-md-6 col-sm-6 col-xs-12' },
	                                      _react2.default.createElement(
	                                        'button',
	                                        { 'class': 'btn btn-primary btn-sm', onClick: this.onFileUploadBanner },
	                                        'Upload!'
	                                      )
	                                    )
	                                  ),
	                                  this.state.banner != '' && _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'existingmedia' },
	                                    _react2.default.createElement(
	                                      'div',
	                                      { 'class': 'bimage' },
	                                      _react2.default.createElement('img', { src: _constant2.IMGBASEURL + "uploads/" + this.state.banner })
	                                    )
	                                  )
	                                ),
	                                _react2.default.createElement('br', null),
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': ' input-group-sm' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { 'for': 'video' },
	                                    'Video (.mp4)'
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'row' },
	                                    _react2.default.createElement(
	                                      'div',
	                                      { 'class': 'col-md-6 col-sm-6 col-xs-12' },
	                                      _react2.default.createElement('input', { type: 'file', name: 'video', 'class': 'form-control input-sm', placeholder: 'Video', onChange: this.onFileChange })
	                                    ),
	                                    _react2.default.createElement(
	                                      'div',
	                                      { 'class': 'col-md-6 col-sm-6 col-xs-12' },
	                                      _react2.default.createElement(
	                                        'button',
	                                        { 'class': 'btn btn-primary btn-sm', onClick: this.onFileVideoUpload },
	                                        'Upload!'
	                                      )
	                                    )
	                                  ),
	                                  this.state.videos != '' && _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'existingmedia' },
	                                    _react2.default.createElement(
	                                      'video',
	                                      { width: '320', height: '240', controls: true },
	                                      _react2.default.createElement('source', { src: _constant2.IMGBASEURL + "uploads/" + this.state.videos, type: 'video/mp4' })
	                                    )
	                                  )
	                                ),
	                                _react2.default.createElement('br', null)
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'card ' },
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'card-body' },
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'card-title' },
	                                  'Sample Brochure or Magazine in pdf'
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'borderedrow' },
	                                  _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'input-group-sm' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      { 'for': 'brochure' },
	                                      'File 1 (pdf)'
	                                    ),
	                                    _react2.default.createElement(
	                                      'div',
	                                      { 'class': 'row' },
	                                      _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'col-md-6 col-sm-6 col-xs-12' },
	                                        _react2.default.createElement('input', { type: 'file', name: 'brochure1', id: 'brochure1', 'class': 'form-control input-sm', placeholder: 'Brochure', onChange: this.onFileChange })
	                                      ),
	                                      _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'col-md-6 col-sm-6 col-xs-12' },
	                                        _react2.default.createElement(
	                                          'button',
	                                          { 'class': 'btn btn-primary btn-sm', onClick: this.onFileUploadBrochure1 },
	                                          'Upload!'
	                                        )
	                                      )
	                                    )
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { 'class': ' input-group-sm' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      { 'for': 'brochure' },
	                                      'Thumbnail 1 (jpg or png)'
	                                    ),
	                                    _react2.default.createElement(
	                                      'div',
	                                      { 'class': 'row' },
	                                      _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'col-md-6 col-sm-6 col-xs-12' },
	                                        _react2.default.createElement('input', { type: 'file', name: 'thumb1', id: 'thumb1', 'class': 'form-control input-sm', placeholder: 'Thumbnail', onChange: this.onFileChange })
	                                      ),
	                                      _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'col-md-6 col-sm-6 col-xs-12' },
	                                        _react2.default.createElement(
	                                          'button',
	                                          { 'class': 'btn btn-primary btn-sm', onClick: this.onFileUploadBrochureThumb1 },
	                                          'Upload!'
	                                        )
	                                      )
	                                    )
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'borderedrow' },
	                                  _react2.default.createElement(
	                                    'div',
	                                    { 'class': ' input-group-sm' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      { 'for': 'brochure' },
	                                      'File 2 (pdf)'
	                                    ),
	                                    _react2.default.createElement(
	                                      'div',
	                                      { 'class': 'row' },
	                                      _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'col-md-6 col-sm-6 col-xs-12' },
	                                        _react2.default.createElement('input', { type: 'file', name: 'brochure2', id: 'brochure2', 'class': 'form-control input-sm', placeholder: 'Brochure', onChange: this.onFileChange })
	                                      ),
	                                      _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'col-md-6 col-sm-6 col-xs-12' },
	                                        _react2.default.createElement(
	                                          'button',
	                                          { 'class': 'btn btn-primary btn-sm', onClick: this.onFileUploadBrochure2 },
	                                          'Upload!'
	                                        )
	                                      )
	                                    )
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { 'class': ' input-group-sm' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      { 'for': 'brochure' },
	                                      'Thumbnail 2 (jpg or png)'
	                                    ),
	                                    _react2.default.createElement(
	                                      'div',
	                                      { 'class': 'row' },
	                                      _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'col-md-6 col-sm-6 col-xs-12' },
	                                        _react2.default.createElement('input', { type: 'file', name: 'thumb2', id: 'thumb2', multiple: true, 'class': 'form-control input-sm', placeholder: 'Thumbnail', onChange: this.onFileChange })
	                                      ),
	                                      _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'col-md-6 col-sm-6 col-xs-12' },
	                                        _react2.default.createElement(
	                                          'button',
	                                          { 'class': 'btn btn-primary btn-sm', onClick: this.onFileUploadBrochureThumb2 },
	                                          'Upload!'
	                                        )
	                                      )
	                                    )
	                                  )
	                                )
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'row' },
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'col-md-12 col-sm-12 col-xs-12' },
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'card' },
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'card-body' },
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'card-title' },
	                                  'Customer Downloads'
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'row' },
	                                  _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'col-lg-12 col-sm-12' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      { 'class': 'radio-inline' },
	                                      _react2.default.createElement('input', { 'class': 'form-check-input', type: 'radio', name: 'contenttype', id: 'contenttype1', checked: this.state.contenttype === "btn", value: 'btn', onChange: this.handleChange }),
	                                      ' Button'
	                                    ),
	                                    _react2.default.createElement(
	                                      'label',
	                                      { 'class': 'radio-inline' },
	                                      _react2.default.createElement('input', { 'class': 'form-check-input', type: 'radio', checked: this.state.contenttype === "href", name: 'contenttype', id: 'contenttype2', value: 'href', onChange: this.handleChange }),
	                                      ' Hyperlink'
	                                    )
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'row' },
	                                  _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'col-lg-4 col-sm-12' },
	                                    _react2.default.createElement(
	                                      'div',
	                                      { 'class': ' input-group-sm' },
	                                      _react2.default.createElement(
	                                        'label',
	                                        { 'for': 'brochure' },
	                                        'Click Text'
	                                      ),
	                                      _react2.default.createElement('input', { type: 'text', name: 'clicktext', 'class': 'form-control input-sm', value: this.state.clicktext, onChange: this.handleChange })
	                                    )
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'col-lg-8 col-sm-12' },
	                                    _react2.default.createElement(
	                                      'div',
	                                      { 'class': 'input-group-sm' },
	                                      _react2.default.createElement(
	                                        'label',
	                                        { 'for': 'brochure' },
	                                        'Link (an HTTP url that is available to download any resources)'
	                                      ),
	                                      _react2.default.createElement('input', { type: 'text', name: 'link', 'class': 'form-control input-sm', value: this.state.link, onChange: this.handleChange })
	                                    )
	                                  )
	                                )
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'row' },
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'col-md-12 col-sm-12 col-xs-12' },
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'card' },
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'card-body' },
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'card-title' },
	                                  'Exclusive Offers'
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'row' },
	                                  _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'col-lg-6 col-sm-12' },
	                                    _react2.default.createElement(
	                                      'div',
	                                      { 'class': 'input-group input-group-sm' },
	                                      _react2.default.createElement(
	                                        'label',
	                                        { 'for': 'brochure' },
	                                        'Image 1(.jpg, .gif and .png)'
	                                      ),
	                                      _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'row' },
	                                        _react2.default.createElement(
	                                          'div',
	                                          { 'class': 'col-md-6 col-sm-6 col-xs-12' },
	                                          _react2.default.createElement('input', { type: 'file', name: 'offerimage1', 'class': 'form-control input-sm', placeholder: 'Image', onChange: this.onFileChange })
	                                        ),
	                                        _react2.default.createElement(
	                                          'div',
	                                          { 'class': 'col-md-6 col-sm-6 col-xs-12' },
	                                          _react2.default.createElement(
	                                            'button',
	                                            { 'class': 'btn btn-primary btn-sm', onClick: this.onFileUploadImage1 },
	                                            'Upload!'
	                                          )
	                                        )
	                                      ),
	                                      this.state.offerimage1 != '' && _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'existingmedia' },
	                                        _react2.default.createElement('img', { src: _constant2.IMGBASEURL + "uploads/" + this.state.offerimage1 })
	                                      ),
	                                      _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'row' },
	                                        _react2.default.createElement(
	                                          'div',
	                                          { 'class': 'col-md-12 col-sm-12 col-xs-12' },
	                                          _react2.default.createElement(
	                                            'label',
	                                            { 'for': 'brochure' },
	                                            'Description'
	                                          ),
	                                          _react2.default.createElement(_tinymceReact.Editor, {
	                                            onEditorChange: this.handleChangeoffer1desc,
	                                            value: this.state.offer1desc,
	                                            apiKey: _constant.TINY_EDITOR,
	                                            init: {
	                                              height: 400,
	                                              plugins: ['lists link image paste'],
	                                              toolbar: 'undo redo | formatselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | help'
	                                            }
	                                          })
	                                        )
	                                      )
	                                    )
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'col-lg-6 col-sm-12' },
	                                    _react2.default.createElement(
	                                      'div',
	                                      { 'class': 'input-group input-group-sm' },
	                                      _react2.default.createElement(
	                                        'label',
	                                        { 'for': 'brochure' },
	                                        'Image 2(.jpg, .gif and .png)'
	                                      ),
	                                      _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'row' },
	                                        _react2.default.createElement(
	                                          'div',
	                                          { 'class': 'col-md-6 col-sm-6 col-xs-12' },
	                                          _react2.default.createElement('input', { type: 'file', name: 'offerimage2', 'class': 'form-control input-sm', placeholder: 'Image', onChange: this.onFileChange })
	                                        ),
	                                        _react2.default.createElement(
	                                          'div',
	                                          { 'class': 'col-md-6 col-sm-6 col-xs-12' },
	                                          _react2.default.createElement(
	                                            'button',
	                                            { 'class': 'btn btn-primary btn-sm', onClick: this.onFileUploadImage2 },
	                                            'Upload!'
	                                          )
	                                        )
	                                      ),
	                                      this.state.offerimage2 != '' && _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'existingmedia' },
	                                        _react2.default.createElement('img', { src: _constant2.IMGBASEURL + "uploads/" + this.state.offerimage2 })
	                                      ),
	                                      _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'row' },
	                                        _react2.default.createElement(
	                                          'div',
	                                          { 'class': 'col-md-12 col-sm-12 col-xs-12' },
	                                          _react2.default.createElement(
	                                            'label',
	                                            { 'for': 'brochure' },
	                                            'Description'
	                                          ),
	                                          _react2.default.createElement(_tinymceReact.Editor, {
	                                            onEditorChange: this.handleChangeoffer2desc,
	                                            value: this.state.offer2desc,
	                                            apiKey: _constant.TINY_EDITOR,
	                                            init: {
	                                              height: 400,
	                                              plugins: ['lists link image paste'],
	                                              toolbar: 'undo redo | formatselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | help'
	                                            }
	                                          })
	                                        )
	                                      )
	                                    )
	                                  )
	                                )
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'row' },
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'col-md-6 col-sm-6 col-xs-12' },
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'card' },
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'card-body' },
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'card-title' },
	                                  'Embedded Content (html code or script)'
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'row' },
	                                  _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'col-lg-12 col-sm-12' },
	                                    _react2.default.createElement(
	                                      'div',
	                                      { 'class': 'input-group' },
	                                      _react2.default.createElement('textarea', { name: 'embedded', 'class': 'form-control', placeholder: 'Embedded', rows: '8' })
	                                    )
	                                  )
	                                )
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'col-md-6 col-sm-6 col-xs-12' },
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'card' },
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'card-body' },
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'card-title' },
	                                  'Social Media'
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'input-group input-group-sm' },
	                                  _react2.default.createElement('input', { type: 'text', name: 'facebook', 'class': 'form-control input-sm', placeholder: 'Facebook', value: this.state.facebook, onChange: this.handleChange })
	                                ),
	                                _react2.default.createElement('br', null),
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'input-group input-group-sm' },
	                                  _react2.default.createElement('input', { type: 'text', name: 'twitter', 'class': 'form-control input-lg', placeholder: 'Twitter', value: this.state.twitter, onChange: this.handleChange })
	                                ),
	                                _react2.default.createElement('br', null),
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'input-group input-group-sm' },
	                                  _react2.default.createElement('input', { type: 'text', name: 'instagram', 'class': 'form-control input-sm', placeholder: 'Instagram', value: this.state.instagram, onChange: this.handleChange })
	                                ),
	                                _react2.default.createElement('br', null),
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'input-group input-group-sm' },
	                                  _react2.default.createElement('input', { type: 'text', name: 'linkedin', 'class': 'form-control input-sm', placeholder: 'LinkedIn', value: this.state.linkedin, onChange: this.handleChange })
	                                )
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'row' },
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'col-md-12 col-sm-12 col-xs-12' },
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'card' },
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'card-body' },
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'col-md-12' },
	                                  _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'form-check' },
	                                    _react2.default.createElement('input', { 'class': 'form-check-input', type: 'radio', name: 'optiontoshow', id: 'optiontoshowat1', checked: true, value: 'onlyparents', onChange: this.handleChange }),
	                                    _react2.default.createElement(
	                                      'label',
	                                      { 'class': 'form-check-label', 'for': 'optiontoshowat1' },
	                                      'Exclusive partnership is only for BeWise Parents (B2C)'
	                                    )
	                                  )
	                                )
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'row' },
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'col-md-12 col-sm-12 col-xs-12' },
	                            _react2.default.createElement(
	                              'button',
	                              { type: 'button', 'class': 'btn btn-primary', onClick: function onClick() {
	                                  return _this3.savefornow();
	                                } },
	                              'Save'
	                            ),
	                            '\xA0',
	                            _react2.default.createElement(
	                              'button',
	                              { type: 'button', 'class': 'btn btn-primary', onClick: function onClick() {
	                                  return _this3.submission();
	                                } },
	                              'Submit for Approval'
	                            ),
	                            '\xA0',
	                            _react2.default.createElement(
	                              'button',
	                              { type: 'button', 'class': 'btn btn-primary', onClick: function onClick() {
	                                  return _this3.showthumbnail();
	                                } },
	                              'Thumbnail Preview'
	                            ),
	                            '\xA0',
	                            _react2.default.createElement(
	                              'button',
	                              { type: 'button', 'class': 'btn btn-primary', onClick: function onClick() {
	                                  return _this3.showdetailed();
	                                } },
	                              'Detailed Preview'
	                            )
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _reactstrap.Modal,
	                        { isOpen: this.state.thumbpreview, className: 'modalpopup' },
	                        _react2.default.createElement(
	                          _reactstrap.ModalHeader,
	                          null,
	                          'Preview'
	                        ),
	                        _react2.default.createElement(
	                          _reactstrap.ModalBody,
	                          { className: 'p-0' },
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'homeexlprts' },
	                            _react2.default.createElement(
	                              'a',
	                              { href: '#', target: '_blank' },
	                              this.state.logo == '' && _react2.default.createElement('img', { src: _constant2.BASEURL + "uploads/defaultlogo.png", width: '150px' }),
	                              this.state.logo != '' && _react2.default.createElement('img', { src: _constant2.BASEURL + "uploads/" + this.state.logo, width: '150px' })
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              null,
	                              _react2.default.createElement(
	                                'span',
	                                null,
	                                this.state.name
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          _reactstrap.ModalFooter,
	                          null,
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'col-md-12 text-center' },
	                              _react2.default.createElement(
	                                'button',
	                                { className: 'btn btn-sm btn-default', onClick: this.cancelPop1 },
	                                'Close'
	                              )
	                            )
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _reactstrap.Modal,
	                        { size: 'lg', isOpen: this.state.detailedpreview, className: 'modalpopup' },
	                        _react2.default.createElement(
	                          _reactstrap.ModalHeader,
	                          null,
	                          'Preview - Detail Page View'
	                        ),
	                        _react2.default.createElement(
	                          _reactstrap.ModalBody,
	                          { className: 'p-0 detailedpreview' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'col-lg-12 col-sm-12 col-md-12 col-xs-12 no-padding' },
	                              _react2.default.createElement('img', { src: _headerimage2.default, 'class': 'headerimagewidth' })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'col-lg-12 col-sm-12 col-md-12 col-xs-12 no-padding' },
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'row' },
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'col-lg-2 col-sm-12 col-md-12 col-xs-12 no-padding' },
	                                  _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'per20 logobox' },
	                                    _react2.default.createElement('img', { src: _constant2.IMGBASEURL + "uploads/" + this.state.logo, 'class': 'orgphoto' })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'col-lg-10 col-sm-12 col-md-12 col-xs-12 no-padding' },
	                                  _react2.default.createElement(
	                                    'a',
	                                    { href: '#', target: '_blank' },
	                                    _react2.default.createElement('img', { src: _constant2.IMGBASEURL + "uploads/" + this.state.banner, 'class': 'bannerimage' })
	                                  )
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'row' },
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'col-lg-2 leftmenu' },
	                                  _react2.default.createElement('img', { src: _leftmenuimage2.default, 'class': 'leftmenuimg' })
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'col-lg-8' },
	                                  _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'onDemandInfo', id: 'onDemandInfo' },
	                                    _react2.default.createElement(
	                                      'div',
	                                      { id: 'description_section' },
	                                      _react2.default.createElement(
	                                        'h3',
	                                        null,
	                                        'About Us'
	                                      ),
	                                      _react2.default.createElement('div', { 'class': 'aboutinfo', dangerouslySetInnerHTML: { __html: this.state.description } })
	                                    ),
	                                    _react2.default.createElement('br', null),
	                                    _react2.default.createElement(
	                                      'div',
	                                      { id: 'exclusive_offers_section' },
	                                      _react2.default.createElement(
	                                        'h3',
	                                        null,
	                                        'Exclusive Offers'
	                                      ),
	                                      _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'containerrow' },
	                                        _react2.default.createElement(
	                                          'div',
	                                          null,
	                                          'No Offers'
	                                        )
	                                      )
	                                    ),
	                                    _react2.default.createElement('br', null),
	                                    _react2.default.createElement(
	                                      'div',
	                                      { id: 'brochure_section' },
	                                      _react2.default.createElement(
	                                        'h3',
	                                        null,
	                                        'Brochures/Samples'
	                                      ),
	                                      _react2.default.createElement(
	                                        'div',
	                                        null,
	                                        'N/A'
	                                      )
	                                    ),
	                                    _react2.default.createElement('br', null),
	                                    _react2.default.createElement(
	                                      'div',
	                                      { id: 'video_section' },
	                                      _react2.default.createElement(
	                                        'h3',
	                                        null,
	                                        'Videos'
	                                      ),
	                                      _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'row n5v3k' },
	                                        _react2.default.createElement(
	                                          'div',
	                                          { 'class': 'container' },
	                                          'Video not available in preview'
	                                        )
	                                      )
	                                    ),
	                                    _react2.default.createElement('br', null),
	                                    _react2.default.createElement(
	                                      'div',
	                                      { id: 'contactinfo_section' },
	                                      _react2.default.createElement(
	                                        'h3',
	                                        null,
	                                        'Contact Info'
	                                      ),
	                                      _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'col-lg-8 col-sm-12 col-md-12 col-xs-12 text-left' },
	                                        _react2.default.createElement(
	                                          'div',
	                                          { 'class': 'per100 text-left' },
	                                          _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'bs_social' },
	                                            _react2.default.createElement(
	                                              'div',
	                                              null,
	                                              ' Email Address: ',
	                                              _react2.default.createElement(
	                                                'b',
	                                                null,
	                                                this.state.email
	                                              ),
	                                              ' '
	                                            ),
	                                            _react2.default.createElement('br', null),
	                                            _react2.default.createElement(
	                                              'div',
	                                              null,
	                                              ' Website: ',
	                                              _react2.default.createElement(
	                                                'b',
	                                                null,
	                                                _react2.default.createElement(
	                                                  'a',
	                                                  { target: '_blank', href: this.state.website },
	                                                  this.state.website
	                                                )
	                                              ),
	                                              ' '
	                                            ),
	                                            _react2.default.createElement('br', null),
	                                            _react2.default.createElement(
	                                              'div',
	                                              null,
	                                              ' Contact Number: ',
	                                              _react2.default.createElement('b', null),
	                                              ' '
	                                            ),
	                                            _react2.default.createElement('br', null)
	                                          )
	                                        )
	                                      )
	                                    ),
	                                    _react2.default.createElement('br', null),
	                                    _react2.default.createElement(
	                                      'div',
	                                      { id: 'review_section' },
	                                      _react2.default.createElement(
	                                        'h3',
	                                        { 'class': 'review_head' },
	                                        'Review',
	                                        _react2.default.createElement(
	                                          'div',
	                                          { 'class': 'floatright' },
	                                          _react2.default.createElement(
	                                            'small',
	                                            { 'class': 'pointer' },
	                                            _react2.default.createElement('i', { 'class': 'fa fa-plus', 'aria-hidden': 'true' })
	                                          )
	                                        )
	                                      ),
	                                      _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'reviewinfo' },
	                                        _react2.default.createElement(
	                                          'div',
	                                          { 'class': 'col-md-12' },
	                                          _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'detailBox' },
	                                            _react2.default.createElement(
	                                              'div',
	                                              { 'class': 'form-comments' },
	                                              _react2.default.createElement(
	                                                'p',
	                                                null,
	                                                'Click here to view Comments!...'
	                                              )
	                                            )
	                                          )
	                                        )
	                                      )
	                                    ),
	                                    _react2.default.createElement('br', null)
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'col-lg-2 rightmenu' },
	                                  _react2.default.createElement('img', { src: _rightmenuimage2.default, 'class': 'rightmenuimg' })
	                                )
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'row' },
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'col-md-12 footerp' },
	                              _react2.default.createElement('img', { src: _footerpreview2.default, 'class': 'headerimagewidth' })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          _reactstrap.ModalFooter,
	                          null,
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'col-md-12 text-center' },
	                              _react2.default.createElement(
	                                'button',
	                                { className: 'btn btn-sm btn-default', onClick: this.cancelPop2 },
	                                'Close'
	                              )
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(_reactNotifications.NotificationContainer, null)
	        )
	      );
	    }
	  }]);
	
	  return exclusivePartnerParentEdit;
	}(_react.Component);
	
	exports.default = exclusivePartnerParentEdit;

/***/ },
/* 941 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _reactShare = __webpack_require__(211);
	
	var _reactstrap = __webpack_require__(17);
	
	var _tinymceReact = __webpack_require__(69);
	
	var _constant = __webpack_require__(21);
	
	var _reactSlick = __webpack_require__(93);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _head = __webpack_require__(248);
	
	var _head2 = _interopRequireDefault(_head);
	
	var _foot = __webpack_require__(247);
	
	var _foot2 = _interopRequireDefault(_foot);
	
	var _constant2 = __webpack_require__(21);
	
	var _FetchCall = __webpack_require__(4);
	
	var _universalCookie = __webpack_require__(135);
	
	var _universalCookie2 = _interopRequireDefault(_universalCookie);
	
	var _footerpreview = __webpack_require__(137);
	
	var _footerpreview2 = _interopRequireDefault(_footerpreview);
	
	var _previewheader = __webpack_require__(140);
	
	var _previewheader2 = _interopRequireDefault(_previewheader);
	
	var _pdf = __webpack_require__(308);
	
	var _pdf2 = _interopRequireDefault(_pdf);
	
	var _word = __webpack_require__(309);
	
	var _word2 = _interopRequireDefault(_word);
	
	var _xls = __webpack_require__(310);
	
	var _xls2 = _interopRequireDefault(_xls);
	
	var _headerimage = __webpack_require__(138);
	
	var _headerimage2 = _interopRequireDefault(_headerimage);
	
	var _leftmenuimage = __webpack_require__(139);
	
	var _leftmenuimage2 = _interopRequireDefault(_leftmenuimage);
	
	var _rightmenuimage = __webpack_require__(141);
	
	var _rightmenuimage2 = _interopRequireDefault(_rightmenuimage);
	
	__webpack_require__(18);
	
	var _reactNotifications = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import { Editor } from '@tinymce/tinymce-react';
	
	
	var exclusivePartnerEdit = function (_Component) {
	  _inherits(exclusivePartnerEdit, _Component);
	
	  function exclusivePartnerEdit(props) {
	    _classCallCheck(this, exclusivePartnerEdit);
	
	    var cookies = new _universalCookie2.default();
	
	    var _this = _possibleConstructorReturn(this, (exclusivePartnerEdit.__proto__ || Object.getPrototypeOf(exclusivePartnerEdit)).call(this, props));
	
	    _this.makeMessageRead = function (login_id) {
	      var req = JSON.stringify({
	        login_id: login_id
	      });
	      (0, _FetchCall.makeMessageRead)(req).then(function (res) {
	        if (res.status === 1) {
	          _this.setState({ notes_seen: true });
	        }
	      });
	    };
	
	    _this.getEntry = function (id) {
	
	      var req = JSON.stringify({
	        id: id
	      });
	      (0, _FetchCall.getExclPtnrsEntryB2B)(req).then(function (res) {
	        if (res.status === 1) {
	          _this.setState({
	            name: res.result.name,
	            logo: res.result.logo != null ? res.result.logo : _this.state.logo,
	            banner: res.result.banners != null ? res.result.banners : '',
	            gallery: res.result.gallery != null ? res.result.gallery : '',
	            brochure: res.result.brochure != null ? res.result.brochure : '',
	            brochures: res.result.brochure != null ? res.result.brochure : '',
	            videos: res.result.videos != null ? res.result.videos : '',
	            approved: res.result.approved,
	            created_date: res.result.created_date,
	            facebook: res.result.facebook,
	            twitter: res.result.twitter,
	            instagram: res.result.instagram,
	            linkedin: res.result.linkedin,
	            emailaddress: res.result.emailaddress,
	            contact_number: res.result.contact_number,
	            website: res.result.website,
	            address: res.result.address,
	            description: res.result.description != null ? res.result.description : '',
	            promotion_link: res.result.promotion_link,
	            promotion_image: res.result.promotion_image != null ? res.result.promotion_image : '',
	            contenttype: res.result.contenttype,
	            link: res.result.link,
	            clicktext: res.result.clicktext,
	            offerimage1: res.result.offerimage1 != null ? res.result.offerimage1 : '',
	            offerimage2: res.result.offerimage2 != null ? res.result.offerimage2 : '',
	            offerimage3: res.result.offerimage3 != null ? res.result.offerimage3 : '',
	            offer1desc: res.result.offer1desc,
	            offer2desc: res.result.offer2desc,
	            offer3desc: res.result.offer3desc,
	            optiontoshow: res.result.optiontoshow,
	            notes_webmaster: res.result.notes_webmaster,
	            notes_timesent: res.result.notes_timesent,
	            notes_seen: res.result.notes_seen,
	            description_b2b: res.result.description_b2b,
	            banners_b2b: res.result.banners_b2b != null ? res.result.banners_b2b : '',
	            offerimage_b2b: res.result.offerimage_b2b,
	            offerdesc_b2b: res.result.offerdesc_b2b,
	            brochures_b2b: res.result.brochures_b2b,
	            contact_number_b2b: res.result.contact_number_b2b,
	            emailaddress_b2b: res.result.emailaddress_b2b
	
	          });
	        } else {
	          _this.setState({ isreco: false });
	        }
	      });
	    };
	
	    _this.cancelPop1 = function () {
	      _this.setState({
	        thumbpreview: false
	      });
	    };
	
	    _this.cancelPop2 = function () {
	      _this.setState({
	        detailedpreview: false
	      });
	    };
	
	    _this.handleChange = function (e) {
	      var propName = e.target.name;
	      _this.setState(_defineProperty({}, e.target.name, e.target.value));
	    };
	
	    _this.onFileChange = function (event) {
	
	      // Update the state
	      _this.setState({ selectedFile: event.target.files[0] });
	    };
	
	    _this.handleFileSinglePdf1 = function (event) {
	
	      // Update the state
	      _this.setState({ brochure1: event.target.files[0] });
	    };
	
	    _this.handleFileSingleThumb1 = function (event) {
	
	      // Update the state
	      _this.setState({ thumb1: event.target.files[0] });
	    };
	
	    _this.handleFileSingleThumb2 = function (event) {
	
	      // Update the state
	      _this.setState({ thumb2: event.target.files[0] });
	    };
	
	    _this.handleFileSinglePdf2 = function (event) {
	
	      // Update the state
	      _this.setState({ brochure2: event.target.files[0] });
	    };
	
	    _this.onMultipleFileChange = function (event) {
	
	      // Update the state
	      _this.setState({ selectedFiles: event.target.files });
	    };
	
	    _this.handleFileMultiplePdfs = function (e) {
	      var propName = e.target.name;
	      var files = e.target.files;
	
	      if (files.length > 3) {
	        files = '';
	        var toastr = window.toastr.error; //warning
	        toastr('', 'Select 5 Pdfs Only', {
	          positionClass: "toast-bottom-right",
	          containerId: "toast-bottom-right"
	        });
	      }
	      _this.setState(_defineProperty({}, propName, files));
	    };
	
	    _this.handleFileMultipleGallery = function (e) {
	      var propName = e.target.name;
	      var files = e.target.files;
	
	      _this.setState({
	        gallery: files
	      });
	    };
	
	    _this.handleFileMultiple = function (e) {
	      var propName = e.target.name;
	      var files = e.target.files;
	
	      if (files.length > 3) {
	        files = '';
	        var toastr = window.toastr.error; //warning
	        toastr('', 'Select 3 Images Only', {
	          positionClass: "toast-bottom-right",
	          containerId: "toast-bottom-right"
	        });
	      }
	      _this.setState({
	        banner: files
	      });
	    };
	
	    _this.onFileVideoUpload = function (event) {
	
	      var toastr = '';
	      // Details of the uploaded file
	      var _this$state$user_data = _this.state.user_data,
	          user_type = _this$state$user_data.user_type,
	          login_id = _this$state$user_data.login_id;
	
	      var formData = new FormData();
	
	      formData.append('user_type', user_type);
	      formData.append('login_id', login_id);
	      formData.append('videos', _this.state.selectedFile);
	      formData.append('id', _this.state.id);
	
	      (0, _FetchCall.uploadVideo)(formData).then(function (response) {
	
	        if (response.status == 1) {
	
	          if (response.id != '') {
	            _this.setState({ id: response.id });
	          }
	
	          _reactNotifications.NotificationManager.success('Video is saved successfully');
	        } else {
	
	          _reactNotifications.NotificationManager.error('There is an issue uploading file');
	        }
	      });
	    };
	
	    _this.onFileUploadImage = function (event) {
	
	      var toastr = '';
	      // Details of the uploaded file
	      var _this$state$user_data2 = _this.state.user_data,
	          user_type = _this$state$user_data2.user_type,
	          login_id = _this$state$user_data2.login_id;
	
	      var formData = new FormData();
	
	      formData.append('user_type', user_type);
	      formData.append('login_id', login_id);
	      formData.append('image', _this.state.selectedFile);
	      formData.append('id', _this.state.id);
	
	      (0, _FetchCall.uploadImage)(formData).then(function (response) {
	
	        if (response.status == 1) {
	
	          if (response.id != '') {
	            _this.setState({ id: response.id });
	          }
	
	          _reactNotifications.NotificationManager.success('Image is saved successfully');
	        } else {
	
	          _reactNotifications.NotificationManager.error('There is an issue uploading file');
	        }
	      });
	    };
	
	    _this.onFileUploadImage1 = function (event) {
	
	      var toastr = '';
	      // Details of the uploaded file
	      var _this$state$user_data3 = _this.state.user_data,
	          user_type = _this$state$user_data3.user_type,
	          login_id = _this$state$user_data3.login_id;
	
	      var formData = new FormData();
	
	      formData.append('user_type', user_type);
	      formData.append('login_id', login_id);
	      formData.append('image', _this.state.selectedFile);
	      formData.append('whichoffer', 'offerimage1');
	      formData.append('id', _this.state.id);
	
	      (0, _FetchCall.uploadImage)(formData).then(function (response) {
	
	        if (response.status == 1) {
	
	          if (response.id != '') {
	            _this.setState({ id: response.id });
	          }
	
	          _reactNotifications.NotificationManager.success('Image saved successfully');
	        } else {
	
	          _reactNotifications.NotificationManager.error('There is an issue uploading file');
	        }
	      });
	    };
	
	    _this.onFileUploadImage2 = function (event) {
	
	      var toastr = '';
	      // Details of the uploaded file
	      var _this$state$user_data4 = _this.state.user_data,
	          user_type = _this$state$user_data4.user_type,
	          login_id = _this$state$user_data4.login_id;
	
	      var formData = new FormData();
	
	      formData.append('user_type', user_type);
	      formData.append('login_id', login_id);
	      formData.append('image', _this.state.selectedFile);
	      formData.append('whichoffer', 'offerimage2');
	      formData.append('id', _this.state.id);
	
	      (0, _FetchCall.uploadImage)(formData).then(function (response) {
	
	        if (response.status == 1) {
	
	          if (response.id != '') {
	            _this.setState({ id: response.id });
	          }
	
	          _reactNotifications.NotificationManager.success('Image saved successfully');
	        } else {
	
	          _reactNotifications.NotificationManager.error('There is an issue uploading file');
	        }
	      });
	    };
	
	    _this.onFileUploadImage3 = function (event) {
	
	      var toastr = '';
	      // Details of the uploaded file
	      var _this$state$user_data5 = _this.state.user_data,
	          user_type = _this$state$user_data5.user_type,
	          login_id = _this$state$user_data5.login_id;
	
	      var formData = new FormData();
	
	      formData.append('user_type', user_type);
	      formData.append('login_id', login_id);
	      formData.append('image', _this.state.selectedFile);
	      formData.append('whichoffer', 'offerimage3');
	      formData.append('id', _this.state.id);
	
	      (0, _FetchCall.uploadImage)(formData).then(function (response) {
	
	        if (response.status == 1) {
	
	          if (response.id != '') {
	            _this.setState({ id: response.id });
	          }
	
	          _reactNotifications.NotificationManager.success('Image 3 saved successfully');
	        } else {
	
	          _reactNotifications.NotificationManager.error('There is an issue uploading file');
	        }
	      });
	    };
	
	    _this.onFileUploadLogo = function (event) {
	
	      var toastr = '';
	      // Details of the uploaded file
	      var _this$state$user_data6 = _this.state.user_data,
	          user_type = _this$state$user_data6.user_type,
	          login_id = _this$state$user_data6.login_id;
	
	      var formData = new FormData();
	
	      formData.append('user_type', user_type);
	      formData.append('login_id', login_id);
	      formData.append('logo', _this.state.selectedFile);
	      formData.append('id', _this.state.id);
	
	      (0, _FetchCall.uploadLogo)(formData).then(function (response) {
	
	        if (response.status == 1) {
	
	          if (response.id != '') {
	            _this.setState({ id: response.id });
	          }
	
	          _reactNotifications.NotificationManager.success('Logo saved successfully');
	
	          _this.setState({ logo: response.file });
	        } else {
	
	          _reactNotifications.NotificationManager.error('There is an issue uploading file');
	        }
	      });
	    };
	
	    _this.onFileUploadBanner = function (event) {
	
	      var toastr = '';
	      // Details of the uploaded file
	      var _this$state$user_data7 = _this.state.user_data,
	          user_type = _this$state$user_data7.user_type,
	          login_id = _this$state$user_data7.login_id;
	
	      var formData = new FormData();
	      formData.append('user_type', user_type);
	      formData.append('login_id', login_id);
	      formData.append('id', _this.state.id);
	      var banner_data = _this.state.banner;
	
	      if (_this.state.optiontoshow == 'onlypartners') {
	
	        for (var i = 0; i < banner_data.length; i++) {
	          formData.append('banners_b2b', banner_data[i]);
	        }
	
	        (0, _FetchCall.uploadBannerB2b)(formData).then(function (response) {
	
	          if (response.status == 1) {
	
	            _reactNotifications.NotificationManager.success('File is saved successfully');
	            //alert(response.files);
	            _this.setState({ banners_b2b: response.files });
	          } else {
	
	            _reactNotifications.NotificationManager.error('There is an issue');
	          }
	        });
	      } else {
	
	        for (var _i = 0; _i < banner_data.length; _i++) {
	          formData.append('banner', banner_data[_i]);
	        }
	
	        (0, _FetchCall.uploadBanner)(formData).then(function (response) {
	
	          if (response.status == 1) {
	
	            if (response.id != '') {
	              _this.setState({ id: response.id });
	            }
	            _reactNotifications.NotificationManager.success('Banner saved successfully');
	            _this.setState({ banner: response.files });
	          } else {
	
	            _reactNotifications.NotificationManager.error('There is an issue uploading file');
	          }
	        });
	      }
	    };
	
	    _this.onFileUploadGallery = function (event) {
	
	      var toastr = '';
	      // Details of the uploaded file
	      var _this$state$user_data8 = _this.state.user_data,
	          user_type = _this$state$user_data8.user_type,
	          login_id = _this$state$user_data8.login_id;
	
	      var formData = new FormData();
	      formData.append('user_type', user_type);
	      formData.append('login_id', login_id);
	      formData.append('id', _this.state.id);
	
	      var gallery_data = _this.state.gallery;
	
	      for (var i = 0; i < gallery_data.length; i++) {
	        formData.append('gallery', gallery_data[i]);
	      }
	
	      (0, _FetchCall.uploadGallery)(formData).then(function (response) {
	
	        if (response.status == 1) {
	
	          if (response.id != '') {
	            _this.setState({ id: response.id });
	          }
	          _reactNotifications.NotificationManager.success('Image saved successfully');
	          //alert(response.files);
	          _this.setState({ gallery: response.files });
	        } else {
	
	          _reactNotifications.NotificationManager.error('There is an issue uploading file');
	        }
	      });
	    };
	
	    _this.onFileUploadBrochureThumb = function (event) {
	
	      var toastr = '';
	      // Details of the uploaded file
	      var _this$state$user_data9 = _this.state.user_data,
	          user_type = _this$state$user_data9.user_type,
	          login_id = _this$state$user_data9.login_id;
	
	      var formData = new FormData();
	
	      formData.append('user_type', user_type);
	      formData.append('login_id', login_id);
	      formData.append('thumb2', _this.state.selectedFile);
	      formData.append('id', _this.state.id);
	      formData.append('mode', _this.state.optiontoshow);
	
	      (0, _FetchCall.uploadThumbNew)(formData).then(function (response) {
	
	        if (response.status == 1) {
	
	          if (response.id != '') {
	            _this.setState({ id: response.id });
	          }
	
	          _reactNotifications.NotificationManager.success('Brochure thumbnail is saved successfully');
	
	          _this.setState({ thumb1: response.file });
	        } else {
	
	          _reactNotifications.NotificationManager.error('There is an issue uploading file');
	        }
	      });
	    };
	
	    _this.onFileUploadBrochureThumb2 = function (event) {
	
	      var toastr = '';
	      // Details of the uploaded file
	      var _this$state$user_data10 = _this.state.user_data,
	          user_type = _this$state$user_data10.user_type,
	          login_id = _this$state$user_data10.login_id;
	
	      var formData = new FormData();
	
	      formData.append('user_type', user_type);
	      formData.append('login_id', login_id);
	      formData.append('thumb2', _this.state.selectedFile);
	      formData.append('id', _this.state.id);
	
	      (0, _FetchCall.uploadThumb2)(formData).then(function (response) {
	
	        if (response.status == 1) {
	
	          if (response.id != '') {
	            _this.setState({ id: response.id });
	          }
	
	          _reactNotifications.NotificationManager.success('Brochure saved successfully');
	
	          _this.setState({ thumb1: response.file });
	        } else {
	
	          _reactNotifications.NotificationManager.error('There is an issue uploading file');
	        }
	      });
	    };
	
	    _this.onFileUploadBrochureThumb1 = function (event) {
	
	      var toastr = '';
	      // Details of the uploaded file
	      var _this$state$user_data11 = _this.state.user_data,
	          user_type = _this$state$user_data11.user_type,
	          login_id = _this$state$user_data11.login_id;
	
	      var formData = new FormData();
	
	      formData.append('user_type', user_type);
	      formData.append('login_id', login_id);
	      formData.append('thumb1', _this.state.selectedFile);
	      formData.append('id', _this.state.id);
	
	      (0, _FetchCall.uploadThumb1)(formData).then(function (response) {
	
	        if (response.status == 1) {
	
	          if (response.id != '') {
	            _this.setState({ id: response.id });
	          }
	          _reactNotifications.NotificationManager.success('Brochure Thumb saved successfully');
	
	          _this.setState({ thumb1: response.file });
	        } else {
	
	          _reactNotifications.NotificationManager.error('There is an issue uploading file');
	        }
	      });
	    };
	
	    _this.onFileUploadBrochure2 = function (event) {
	
	      var toastr = '';
	      // Details of the uploaded file
	      var _this$state$user_data12 = _this.state.user_data,
	          user_type = _this$state$user_data12.user_type,
	          login_id = _this$state$user_data12.login_id;
	
	      var formData = new FormData();
	
	      formData.append('user_type', user_type);
	      formData.append('login_id', login_id);
	      formData.append('file2', _this.state.selectedFile);
	      formData.append('id', _this.state.id);
	
	      (0, _FetchCall.uploadFile2)(formData).then(function (response) {
	
	        if (response.status == 1) {
	
	          if (response.id != '') {
	            _this.setState({ id: response.id });
	          }
	
	          _reactNotifications.NotificationManager.success('Brochure 2 saved successfully');
	
	          _this.setState({ file1: response.file });
	        } else {
	
	          _reactNotifications.NotificationManager.error('There is an issue uploading file');
	        }
	      });
	    };
	
	    _this.onFileUploadBrochure1 = function (event) {
	
	      var toastr = '';
	      // Details of the uploaded file
	      var _this$state$user_data13 = _this.state.user_data,
	          user_type = _this$state$user_data13.user_type,
	          login_id = _this$state$user_data13.login_id;
	
	      var formData = new FormData();
	
	      formData.append('user_type', user_type);
	      formData.append('login_id', login_id);
	      formData.append('file1', _this.state.selectedFile);
	      formData.append('id', _this.state.id);
	      formData.append('mode', _this.state.optiontoshow);
	
	      (0, _FetchCall.uploadFile1)(formData).then(function (response) {
	
	        if (response.status == 1) {
	
	          if (response.id != '') {
	            _this.setState({ id: response.id });
	          }
	          _reactNotifications.NotificationManager.success('Brochure 1 saved successfully');
	
	          _this.setState({ file1: response.file });
	        } else {
	
	          _reactNotifications.NotificationManager.error('There is an issue uploading file');
	        }
	      });
	    };
	
	    _this.onFileUploadBrochure = function (event) {
	
	      var toastr = '';
	      // Details of the uploaded file
	
	      var formData = new FormData();
	      var _this$state$user_data14 = _this.state.user_data,
	          user_type = _this$state$user_data14.user_type,
	          login_id = _this$state$user_data14.login_id;
	
	
	      formData.append('user_type', user_type);
	      formData.append('login_id', login_id);
	      formData.append('id', _this.state.id);
	      formData.append('mode', _this.state.optiontoshow);
	      formData.append('brochure', _this.state.selectedFile);
	
	      (0, _FetchCall.uploadBrochureNew)(formData).then(function (response) {
	
	        if (response.status == 1) {
	
	          if (response.id != '') {
	            _this.setState({ id: response.id });
	          }
	
	          _reactNotifications.NotificationManager.success('Brochure saved successfully');
	        } else {
	
	          _reactNotifications.NotificationManager.error('There is an issue uploading file');
	        }
	      });
	    };
	
	    _this.state = {
	      thumbpreview: false,
	      detailedpreview: false,
	      submitted: false,
	      selectedFile: null,
	      banner: '',
	      brochure: '',
	      brochures: '',
	      gallery: '',
	      offerimage1: '',
	      offerimage2: '',
	      offerimage3: '',
	      offer1desc: '',
	      offer2desc: '',
	      contact_number: '',
	      offer3desc: '',
	      optiontoshow: 'onlypartners',
	      user_data: localStorage.getItem('user_data') ? JSON.parse(localStorage.getItem('user_data')) : [],
	      authentication: localStorage.getItem('authentication') ? JSON.parse(localStorage.getItem('authentication')) : false,
	      user_type: 99,
	      videos: '',
	      logo: 'defaultlogo.png',
	      id: _this.props.match.params.id ? _this.props.match.params.id : ''
	    };
	
	    _this.submission = _this.submission.bind(_this);
	    _this.onFileUploadBanner = _this.onFileUploadBanner.bind(_this);
	    _this.onFileUploadBrochure = _this.onFileUploadBrochure.bind(_this);
	    _this.onFileUploadGallery = _this.onFileUploadGallery.bind(_this);
	    _this.onFileVideoUpload = _this.onFileVideoUpload.bind(_this);
	
	    _this.handleChangeDescription = _this.handleChangeDescription.bind(_this);
	    _this.handleChangeoffer1desc = _this.handleChangeoffer1desc.bind(_this);
	    _this.handleChangeoffer2desc = _this.handleChangeoffer2desc.bind(_this);
	
	    _this.onFileUploadBrochureThumb1 = _this.onFileUploadBrochureThumb1.bind(_this);
	    _this.onFileUploadBrochureThumb2 = _this.onFileUploadBrochureThumb2.bind(_this);
	
	    _this.onFileUploadBrochure1 = _this.onFileUploadBrochure1.bind(_this);
	    _this.onFileUploadBrochure2 = _this.onFileUploadBrochure2.bind(_this);
	
	    _this.id = _this.props.match.params.id ? _this.props.match.params.id : '';
	    return _this;
	  }
	
	  _createClass(exclusivePartnerEdit, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var user_data = this.state.user_data;
	
	      if (this.id != '') this.getEntry(this.id);
	    }
	  }, {
	    key: 'handleChangeDescription',
	    value: function handleChangeDescription(value, editor) {
	      //console.log(value);
	      this.setState({
	        description: value
	      });
	    }
	  }, {
	    key: 'handleChangeoffer1desc',
	    value: function handleChangeoffer1desc(value, editor) {
	      //console.log(value);
	      this.setState({
	        offer1desc: value
	      });
	    }
	  }, {
	    key: 'handleChangeoffer2desc',
	    value: function handleChangeoffer2desc(value, editor) {
	      //console.log(value);
	      this.setState({
	        offer2desc: value
	      });
	    }
	  }, {
	    key: 'savefornow',
	    value: function savefornow() {
	
	      var toastr = '';
	
	      var _state$user_data = this.state.user_data,
	          user_type = _state$user_data.user_type,
	          login_id = _state$user_data.login_id;
	
	      /*
	      let downloable_content={
	                          contenttype:this.state.contenttype,
	                          clicktext:this.state.clicktext,
	                          link:this.state.link};
	      */
	
	      var req = JSON.stringify({
	        id: this.id,
	        user_type: user_type,
	        login_id: login_id,
	        name: this.state.name,
	        description: this.state.description,
	        website: this.state.website,
	        contact_number: this.state.contact_number,
	        address: this.state.address,
	        emailaddress: this.state.emailaddress,
	        facebook: this.state.facebook,
	        clicktext: this.state.clicktext,
	        link: this.state.link,
	        offer2desc: this.state.offer2desc,
	        offer1desc: this.state.offer1desc,
	        optiontoshow: this.state.optiontoshow,
	        contenttype: this.state.contenttype,
	        promotion_link: this.state.promotion_link,
	        twitter: this.state.twitter,
	        instagram: this.state.instagram,
	        linkedin: this.state.linkedin,
	        approved: 0
	      });
	
	      (0, _FetchCall.saveEntry)(req).then(function (response) {
	
	        if (response.status == 1) {
	
	          _reactNotifications.NotificationManager.success('saved successfully');
	        } else {
	
	          _reactNotifications.NotificationManager.error('There is an issue uploading file');
	        }
	      });
	    }
	  }, {
	    key: 'submission',
	    value: function submission() {
	      var _this2 = this;
	
	      var toastr = '';
	      console.log("logo", this.state.logo);
	      console.log("banner", this.state.banner);
	      console.log("name", this.state.name);
	      console.log("desc", this.state.description);
	
	      if (this.state.logo == '' || this.state.logo == 'defaultlogo.png' || this.state.banner == '' || this.state.name == '' || this.state.description == '') {
	
	        _reactNotifications.NotificationManager.error('Please make sure you provide all required minimum data such as logo, banner , name and description');
	      } else {
	        var _state$user_data2 = this.state.user_data,
	            user_type = _state$user_data2.user_type,
	            login_id = _state$user_data2.login_id;
	
	
	        var req = JSON.stringify({
	          id: this.id,
	          user_type: user_type,
	          login_id: login_id,
	          name: this.state.name,
	          description: this.state.description,
	          website: this.state.website,
	          address: this.state.address,
	          emailaddress: this.state.emailaddress,
	          contact_number: this.state.contact_number,
	          facebook: this.state.facebook,
	          clicktext: this.state.clicktext,
	          link: this.state.link,
	          offer2desc: this.state.offer2desc,
	          offer1desc: this.state.offer1desc,
	          optiontoshow: this.state.optiontoshow,
	          contenttype: this.state.contenttype,
	          promotion_link: this.state.promotion_link,
	          twitter: this.state.twitter,
	          instagram: this.state.instagram,
	          linkedin: this.state.linkedin
	        });
	
	        (0, _FetchCall.submitEntry)(req).then(function (response) {
	
	          if (response.status == 1) {
	
	            _reactNotifications.NotificationManager.success('submitted successfully');
	
	            _this2.setState({ submitted: true });
	          } else {
	
	            _reactNotifications.NotificationManager.error('There is an issue uploading file');
	          }
	        });
	      }
	    }
	  }, {
	    key: 'showthumbnail',
	    value: function showthumbnail() {
	      this.setState({ thumbpreview: true });
	    }
	  }, {
	    key: 'showdetailed',
	    value: function showdetailed() {
	      this.setState({ detailedpreview: true });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var gallerysettings = {
	        dots: false,
	        infinite: false,
	        speed: 500,
	        slidesToShow: 3,
	        slidesToScroll: 3,
	        responsive: [{
	          breakpoint: 768,
	          settings: {
	            slidesToShow: 1,
	            centerMode: false, /* set centerMode to false to show complete slide instead of 3 */
	            slidesToScroll: 1
	          }
	        }]
	      };
	
	      var banners = this.state.banner != '' ? this.state.banner.toString().split(",") : '';
	      var gallery = this.state.gallery.toString().split(",");
	      var sliders = '';
	      //const sliders = this.state.banner.split(",");
	      var galleries = this.state.gallery != '' ? this.state.gallery.toString().split(",") : '';
	      //const IMG_URL = 'http://localhost:5005/';
	
	      var offer1 = this.state.offerimage1 != '' ? _constant2.IMGBASEURL + 'uploads/' + this.state.offerimage1 : '';
	      var offer2 = this.state.offerimage2 != '' ? _constant2.IMGBASEURL + 'uploads/' + this.state.offerimage2 : '';
	      var offer3 = this.state.offerimage3 != '' ? _constant2.IMGBASEURL + 'uploads/' + this.state.offerimage3 : '';
	
	      var offer1desc = this.state.offer1desc;
	      var offer2desc = this.state.offer2desc;
	      var offer3desc = this.state.offer3desc;
	
	      var brochures = this.state.brochures.split(",");
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'col-lg-12 grid-margin stretch-card' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card-body' },
	                _react2.default.createElement(
	                  'h4',
	                  { 'class': 'card-title' },
	                  'Exclusive Partnerships - B2B Content - Management'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'row' },
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'col-lg-12' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'main-content col-md-12 col-xs-12' },
	                      this.state.submitted == true && _react2.default.createElement(
	                        'div',
	                        { 'class': 'aftersubmitmessage' },
	                        'Partnership update has now been resubmitted for review @ BeWise. Thank you for your partnership and we remain greatful.'
	                      ),
	                      this.state.submitted == false && _react2.default.createElement(
	                        _react2.default.Fragment,
	                        null,
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'row' },
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'col-md-6 col-sm-6 col-xs-12' },
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'card' },
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'card-body' },
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'card-title' },
	                                  'Profile Information'
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'input-group input-group-sm' },
	                                  _react2.default.createElement('input', { type: 'text', name: 'name', 'class': 'form-control input-sm', placeholder: 'Name', value: this.state.name, onChange: this.handleChange })
	                                ),
	                                _react2.default.createElement('br', null),
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'input-group input-group-sm' },
	                                  _react2.default.createElement('input', { type: 'text', name: 'address', 'class': 'form-control input-lg', placeholder: 'Address', onChange: this.handleChange, value: this.state.address })
	                                ),
	                                _react2.default.createElement('br', null),
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'input-group input-group-sm' },
	                                  _react2.default.createElement('input', { type: 'email', name: 'emailaddress', 'class': 'form-control input-sm', placeholder: 'Email Address', onChange: this.handleChange, value: this.state.emailaddress })
	                                ),
	                                _react2.default.createElement('br', null),
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'input-group input-group-sm' },
	                                  _react2.default.createElement('input', { type: 'text', name: 'website', 'class': 'form-control input-sm', placeholder: 'Web Site', onChange: this.handleChange, value: this.state.website })
	                                ),
	                                _react2.default.createElement('br', null),
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'input-group input-group-sm' },
	                                  _react2.default.createElement('input', { type: 'text', name: 'contact_number', 'class': 'form-control input-sm', placeholder: 'Contact Number', onChange: this.handleChange, value: this.state.contact_number })
	                                ),
	                                _react2.default.createElement('br', null),
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'card-title' },
	                                  'Description'
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'input-group' },
	                                  _react2.default.createElement(_tinymceReact.Editor, {
	                                    onEditorChange: this.handleChangeDescription,
	                                    value: this.state.description,
	                                    apiKey: _constant.TINY_EDITOR,
	                                    init: {
	                                      height: 300,
	                                      plugins: ['lists link image paste'],
	                                      toolbar: 'undo redo | formatselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | help'
	                                    }
	                                  })
	                                )
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'col-md-6 col-sm-6 col-xs-12' },
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'card' },
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'card-body' },
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'card-title' },
	                                  'Medias'
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': ' input-group-sm' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { 'for': 'logo' },
	                                    'Logo (png)'
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'row' },
	                                    _react2.default.createElement(
	                                      'div',
	                                      { 'class': 'col-md-6 col-sm-6 col-xs-12' },
	                                      _react2.default.createElement('input', { type: 'file', name: 'logo', 'class': 'form-control input-sm', placeholder: 'Logo', onChange: this.onFileChange })
	                                    ),
	                                    _react2.default.createElement(
	                                      'div',
	                                      { 'class': 'col-md-6 col-sm-6 col-xs-12' },
	                                      _react2.default.createElement(
	                                        'button',
	                                        { 'class': 'btn btn-primary btn-sm', onClick: this.onFileUploadLogo },
	                                        'Upload!'
	                                      )
	                                    )
	                                  ),
	                                  this.state.logo != '' && _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'existingmedia' },
	                                    _react2.default.createElement('img', { src: _constant2.IMGBASEURL + "uploads/" + this.state.logo })
	                                  )
	                                ),
	                                _react2.default.createElement('br', null),
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'input-group-sm' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { 'for': 'banner' },
	                                    'Brand Banner (980x1028)'
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'row' },
	                                    _react2.default.createElement(
	                                      'div',
	                                      { 'class': 'col-md-6 col-sm-6 col-xs-12' },
	                                      _react2.default.createElement('input', { type: 'file', id: 'banner', name: 'banner', multiple: true, 'class': 'form-control input-sm', placeholder: 'Banner', onChange: this.handleFileMultiple })
	                                    ),
	                                    _react2.default.createElement(
	                                      'div',
	                                      { 'class': 'col-md-6 col-sm-6 col-xs-12' },
	                                      _react2.default.createElement(
	                                        'button',
	                                        { 'class': 'btn btn-primary btn-sm', onClick: this.onFileUploadBanner },
	                                        'Upload!'
	                                      )
	                                    )
	                                  ),
	                                  this.state.optiontoshow == 'onlypartners' && this.state.banners_b2b != '' && _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'existingmedia' },
	                                    _react2.default.createElement(
	                                      'div',
	                                      { 'class': 'bimage' },
	                                      _react2.default.createElement('img', { src: _constant2.IMGBASEURL + "uploads/" + this.state.banners_b2b })
	                                    )
	                                  ),
	                                  this.state.optiontoshow != 'onlypartners' && this.state.banner != '' && _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'existingmedia' },
	                                    _react2.default.createElement(
	                                      'div',
	                                      { 'class': 'bimage' },
	                                      _react2.default.createElement('img', { src: _constant2.IMGBASEURL + "uploads/" + this.state.banner })
	                                    )
	                                  )
	                                ),
	                                _react2.default.createElement('br', null),
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': ' input-group-sm' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { 'for': 'video' },
	                                    'Video (.mp4)'
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'row' },
	                                    _react2.default.createElement(
	                                      'div',
	                                      { 'class': 'col-md-6 col-sm-6 col-xs-12' },
	                                      _react2.default.createElement('input', { type: 'file', name: 'video', 'class': 'form-control input-sm', placeholder: 'Video', onChange: this.onFileChange })
	                                    ),
	                                    _react2.default.createElement(
	                                      'div',
	                                      { 'class': 'col-md-6 col-sm-6 col-xs-12' },
	                                      _react2.default.createElement(
	                                        'button',
	                                        { 'class': 'btn btn-primary btn-sm', onClick: this.onFileVideoUpload },
	                                        'Upload!'
	                                      )
	                                    )
	                                  ),
	                                  this.state.videos != '' && _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'existingmedia' },
	                                    _react2.default.createElement(
	                                      'video',
	                                      { width: '320', height: '240', controls: true },
	                                      _react2.default.createElement('source', { src: _constant2.IMGBASEURL + "uploads/" + this.state.videos, type: 'video/mp4' })
	                                    )
	                                  )
	                                ),
	                                _react2.default.createElement('br', null)
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'card ' },
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'card-body' },
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'card-title' },
	                                  'Sample Brochure or Magazine in pdf'
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'borderedrow' },
	                                  _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'input-group-sm' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      { 'for': 'brochure' },
	                                      'File (pdf)'
	                                    ),
	                                    _react2.default.createElement(
	                                      'div',
	                                      { 'class': 'row' },
	                                      _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'col-md-6 col-sm-6 col-xs-12' },
	                                        _react2.default.createElement('input', { type: 'file', name: 'brochure', id: 'brochure1', 'class': 'form-control input-sm', placeholder: 'Brochure', onChange: this.onFileChange })
	                                      ),
	                                      _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'col-md-6 col-sm-6 col-xs-12' },
	                                        _react2.default.createElement(
	                                          'button',
	                                          { 'class': 'btn btn-primary btn-sm', onClick: this.onFileUploadBrochure },
	                                          'Upload!'
	                                        )
	                                      )
	                                    )
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { 'class': ' input-group-sm' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      { 'for': 'brochure' },
	                                      'Thumbnail (jpg or png)'
	                                    ),
	                                    _react2.default.createElement(
	                                      'div',
	                                      { 'class': 'row' },
	                                      _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'col-md-6 col-sm-6 col-xs-12' },
	                                        _react2.default.createElement('input', { type: 'file', name: 'thumb1', id: 'thumb1', 'class': 'form-control input-sm', placeholder: 'Thumbnail', onChange: this.onFileChange })
	                                      ),
	                                      _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'col-md-6 col-sm-6 col-xs-12' },
	                                        _react2.default.createElement(
	                                          'button',
	                                          { 'class': 'btn btn-primary btn-sm', onClick: this.onFileUploadBrochureThumb },
	                                          'Upload!'
	                                        )
	                                      )
	                                    )
	                                  )
	                                )
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'row' },
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'col-md-12 col-sm-12 col-xs-12' },
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'card' },
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'card-body' },
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'card-title' },
	                                  'Customer Downloads'
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'row' },
	                                  _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'col-lg-12 col-sm-12' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      { 'class': 'radio-inline' },
	                                      _react2.default.createElement('input', { 'class': 'form-check-input', type: 'radio', name: 'contenttype', id: 'contenttype1', checked: this.state.contenttype === "btn", value: 'btn', onChange: this.handleChange }),
	                                      ' Button'
	                                    ),
	                                    _react2.default.createElement(
	                                      'label',
	                                      { 'class': 'radio-inline' },
	                                      _react2.default.createElement('input', { 'class': 'form-check-input', type: 'radio', checked: this.state.contenttype === "href", name: 'contenttype', id: 'contenttype2', value: 'href', onChange: this.handleChange }),
	                                      ' Hyperlink'
	                                    )
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'row' },
	                                  _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'col-lg-4 col-sm-12' },
	                                    _react2.default.createElement(
	                                      'div',
	                                      { 'class': ' input-group-sm' },
	                                      _react2.default.createElement(
	                                        'label',
	                                        { 'for': 'brochure' },
	                                        'Click Text'
	                                      ),
	                                      _react2.default.createElement('input', { type: 'text', name: 'clicktext', 'class': 'form-control input-sm', value: this.state.clicktext, onChange: this.handleChange })
	                                    )
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'col-lg-8 col-sm-12' },
	                                    _react2.default.createElement(
	                                      'div',
	                                      { 'class': 'input-group-sm' },
	                                      _react2.default.createElement(
	                                        'label',
	                                        { 'for': 'brochure' },
	                                        'Link (an HTTP url that is available to download any resources)'
	                                      ),
	                                      _react2.default.createElement('input', { type: 'text', name: 'link', 'class': 'form-control input-sm', value: this.state.link, onChange: this.handleChange })
	                                    )
	                                  )
	                                )
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'row' },
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'col-md-12 col-sm-12 col-xs-12' },
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'card' },
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'card-body' },
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'card-title' },
	                                  'Exclusive Offers'
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'row' },
	                                  _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'col-lg-6 col-sm-12' },
	                                    _react2.default.createElement(
	                                      'div',
	                                      { 'class': 'input-group input-group-sm' },
	                                      _react2.default.createElement(
	                                        'label',
	                                        { 'for': 'brochure' },
	                                        'Image 1(.jpg, .gif and .png)'
	                                      ),
	                                      _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'row' },
	                                        _react2.default.createElement(
	                                          'div',
	                                          { 'class': 'col-md-6 col-sm-6 col-xs-12' },
	                                          _react2.default.createElement('input', { type: 'file', name: 'offerimage1', 'class': 'form-control input-sm', placeholder: 'Image', onChange: this.onFileChange })
	                                        ),
	                                        _react2.default.createElement(
	                                          'div',
	                                          { 'class': 'col-md-6 col-sm-6 col-xs-12' },
	                                          _react2.default.createElement(
	                                            'button',
	                                            { 'class': 'btn btn-primary btn-sm', onClick: this.onFileUploadImage1 },
	                                            'Upload!'
	                                          )
	                                        )
	                                      ),
	                                      this.state.offerimage1 != '' && _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'existingmedia' },
	                                        _react2.default.createElement('img', { src: _constant2.IMGBASEURL + "uploads/" + this.state.offerimage1 })
	                                      ),
	                                      _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'row' },
	                                        _react2.default.createElement(
	                                          'div',
	                                          { 'class': 'col-md-12 col-sm-12 col-xs-12' },
	                                          _react2.default.createElement(
	                                            'label',
	                                            { 'for': 'brochure' },
	                                            'Description'
	                                          ),
	                                          _react2.default.createElement(_tinymceReact.Editor, {
	                                            onEditorChange: this.handleChangeoffer1desc,
	                                            value: this.state.offer1desc,
	                                            apiKey: _constant.TINY_EDITOR,
	                                            init: {
	                                              height: 400,
	                                              plugins: ['lists link image paste'],
	                                              toolbar: 'undo redo | formatselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | help'
	                                            }
	                                          })
	                                        )
	                                      )
	                                    )
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'col-lg-6 col-sm-12' },
	                                    _react2.default.createElement(
	                                      'div',
	                                      { 'class': 'input-group input-group-sm' },
	                                      _react2.default.createElement(
	                                        'label',
	                                        { 'for': 'brochure' },
	                                        'Image 2(.jpg, .gif and .png)'
	                                      ),
	                                      _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'row' },
	                                        _react2.default.createElement(
	                                          'div',
	                                          { 'class': 'col-md-6 col-sm-6 col-xs-12' },
	                                          _react2.default.createElement('input', { type: 'file', name: 'offerimage2', 'class': 'form-control input-sm', placeholder: 'Image', onChange: this.onFileChange })
	                                        ),
	                                        _react2.default.createElement(
	                                          'div',
	                                          { 'class': 'col-md-6 col-sm-6 col-xs-12' },
	                                          _react2.default.createElement(
	                                            'button',
	                                            { 'class': 'btn btn-primary btn-sm', onClick: this.onFileUploadImage2 },
	                                            'Upload!'
	                                          )
	                                        )
	                                      ),
	                                      this.state.offerimage2 != '' && _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'existingmedia' },
	                                        _react2.default.createElement('img', { src: _constant2.IMGBASEURL + "uploads/" + this.state.offerimage2 })
	                                      ),
	                                      _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'row' },
	                                        _react2.default.createElement(
	                                          'div',
	                                          { 'class': 'col-md-12 col-sm-12 col-xs-12' },
	                                          _react2.default.createElement(
	                                            'label',
	                                            { 'for': 'brochure' },
	                                            'Description'
	                                          ),
	                                          _react2.default.createElement(_tinymceReact.Editor, {
	                                            onEditorChange: this.handleChangeoffer2desc,
	                                            value: this.state.offer2desc,
	                                            apiKey: _constant.TINY_EDITOR,
	                                            init: {
	                                              height: 400,
	                                              plugins: ['lists link image paste'],
	                                              toolbar: 'undo redo | formatselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | help'
	                                            }
	                                          })
	                                        )
	                                      )
	                                    )
	                                  )
	                                )
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'row' },
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'col-md-6 col-sm-6 col-xs-12' },
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'card' },
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'card-body' },
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'card-title' },
	                                  'Embedded Content (html code or script)'
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'row' },
	                                  _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'col-lg-12 col-sm-12' },
	                                    _react2.default.createElement(
	                                      'div',
	                                      { 'class': 'input-group' },
	                                      _react2.default.createElement('textarea', { name: 'embedded', 'class': 'form-control', placeholder: 'Embedded', rows: '8' })
	                                    )
	                                  )
	                                )
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'col-md-6 col-sm-6 col-xs-12' },
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'card' },
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'card-body' },
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'card-title' },
	                                  'Social Media'
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'input-group input-group-sm' },
	                                  _react2.default.createElement('input', { type: 'text', name: 'facebook', 'class': 'form-control input-sm', placeholder: 'Facebook', value: this.state.facebook, onChange: this.handleChange })
	                                ),
	                                _react2.default.createElement('br', null),
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'input-group input-group-sm' },
	                                  _react2.default.createElement('input', { type: 'text', name: 'instagram', 'class': 'form-control input-sm', placeholder: 'Instagram', value: this.state.instagram, onChange: this.handleChange })
	                                ),
	                                _react2.default.createElement('br', null),
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'input-group input-group-sm' },
	                                  _react2.default.createElement('input', { type: 'text', name: 'linkedin', 'class': 'form-control input-sm', placeholder: 'LinkedIn', value: this.state.linkedin, onChange: this.handleChange })
	                                )
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'row' },
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'col-md-12 col-sm-12 col-xs-12' },
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'card' },
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'card-body' },
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'col-md-12' },
	                                  _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'form-check' },
	                                    _react2.default.createElement('input', { 'class': 'form-check-input', type: 'radio', name: 'optiontoshow', id: 'optiontoshowat2', checked: true, value: 'onlypartners', onChange: this.handleChange }),
	                                    _react2.default.createElement(
	                                      'label',
	                                      { 'class': 'form-check-label', 'for': 'optiontoshowat2' },
	                                      'Exclusive partnership is only for BeWise Partners (B2B)'
	                                    )
	                                  )
	                                )
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'row' },
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'col-md-12 col-sm-12 col-xs-12' },
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'card' },
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'card-body' },
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'card-title' },
	                                  'Message from BeWise Team'
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'row' },
	                                  _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'col-lg-3 col-sm-12' },
	                                    new Intl.DateTimeFormat('en-US', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).format(this.state.notes_senttime)
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'col-lg-9 col-sm-12' },
	                                    _react2.default.createElement(
	                                      'div',
	                                      { 'class': 'messagebox' },
	                                      this.state.notes_webmaster
	                                    )
	                                  )
	                                )
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'row' },
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'col-md-12 col-sm-12 col-xs-12' },
	                            _react2.default.createElement(
	                              'button',
	                              { type: 'button', 'class': 'btn btn-primary', onClick: function onClick() {
	                                  return _this3.savefornow();
	                                } },
	                              'Save'
	                            ),
	                            '\xA0',
	                            _react2.default.createElement(
	                              'button',
	                              { type: 'button', 'class': 'btn btn-primary', onClick: function onClick() {
	                                  return _this3.submission();
	                                } },
	                              'Submit for Approval'
	                            ),
	                            '\xA0',
	                            _react2.default.createElement(
	                              'button',
	                              { type: 'button', 'class': 'btn btn-primary', onClick: function onClick() {
	                                  return _this3.showthumbnail();
	                                } },
	                              'Thumbnail Preview'
	                            ),
	                            '\xA0',
	                            _react2.default.createElement(
	                              'button',
	                              { type: 'button', 'class': 'btn btn-primary', onClick: function onClick() {
	                                  return _this3.showdetailed();
	                                } },
	                              'Detailed Preview'
	                            )
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _reactstrap.Modal,
	                        { isOpen: this.state.thumbpreview, className: 'modalpopup' },
	                        _react2.default.createElement(
	                          _reactstrap.ModalHeader,
	                          null,
	                          'Preview'
	                        ),
	                        _react2.default.createElement(
	                          _reactstrap.ModalBody,
	                          { className: 'p-0' },
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'cardi horizontal' },
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'cardi-image' },
	                              _react2.default.createElement('img', { src: _constant2.BASEURL + "/uploads/" + this.state.logo })
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'cardi-stacked' },
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'cardi-content' },
	                                _react2.default.createElement(
	                                  'h3',
	                                  null,
	                                  this.state.name
	                                ),
	                                _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: this.state.description } }),
	                                _react2.default.createElement(
	                                  'button',
	                                  { 'class': 'btn btn-primary btn-sm' },
	                                  'view more'
	                                )
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          _reactstrap.ModalFooter,
	                          null,
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'col-md-12 text-center' },
	                              _react2.default.createElement(
	                                'button',
	                                { className: 'btn btn-sm btn-default', onClick: this.cancelPop1 },
	                                'Close'
	                              )
	                            )
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _reactstrap.Modal,
	                        { size: 'lg', isOpen: this.state.detailedpreview, className: 'modalpopup' },
	                        _react2.default.createElement(
	                          _reactstrap.ModalHeader,
	                          null,
	                          'Preview - Detail Page View'
	                        ),
	                        _react2.default.createElement(
	                          _reactstrap.ModalBody,
	                          { className: 'p-0 detailedpreview' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'col-lg-12 col-sm-12 col-md-12 col-xs-12 no-padding' },
	                              _react2.default.createElement('img', { src: _headerimage2.default, 'class': 'headerimagewidth' })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'col-lg-12 col-sm-12 col-md-12 col-xs-12 no-padding' },
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'row' },
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'col-lg-2 col-sm-12 col-md-12 col-xs-12 no-padding' },
	                                  _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'per20 logobox' },
	                                    _react2.default.createElement('img', { src: _constant2.IMGBASEURL + "uploads/" + this.state.logo, 'class': 'orgphoto' })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'col-lg-10 col-sm-12 col-md-12 col-xs-12 no-padding' },
	                                  _react2.default.createElement(
	                                    'a',
	                                    { href: '#', target: '_blank' },
	                                    _react2.default.createElement('img', { src: _constant2.IMGBASEURL + "uploads/" + this.state.banner, 'class': 'bannerimage' })
	                                  )
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'row' },
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'col-lg-2 leftmenu' },
	                                  _react2.default.createElement('img', { src: _leftmenuimage2.default, 'class': 'leftmenuimg' })
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'col-lg-8' },
	                                  _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'onDemandInfo', id: 'onDemandInfo' },
	                                    _react2.default.createElement(
	                                      'div',
	                                      { id: 'description_section' },
	                                      _react2.default.createElement(
	                                        'h3',
	                                        null,
	                                        'About Us'
	                                      ),
	                                      _react2.default.createElement('div', { 'class': 'aboutinfo', dangerouslySetInnerHTML: { __html: this.state.description } })
	                                    ),
	                                    _react2.default.createElement('br', null),
	                                    _react2.default.createElement(
	                                      'div',
	                                      { id: 'exclusive_offers_section' },
	                                      _react2.default.createElement(
	                                        'h3',
	                                        null,
	                                        'Exclusive Offers'
	                                      ),
	                                      _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'containerrow' },
	                                        _react2.default.createElement(
	                                          'div',
	                                          null,
	                                          'No Offers'
	                                        )
	                                      )
	                                    ),
	                                    _react2.default.createElement('br', null),
	                                    _react2.default.createElement(
	                                      'div',
	                                      { id: 'brochure_section' },
	                                      _react2.default.createElement(
	                                        'h3',
	                                        null,
	                                        'Brochures/Samples'
	                                      ),
	                                      _react2.default.createElement(
	                                        'div',
	                                        null,
	                                        'N/A'
	                                      )
	                                    ),
	                                    _react2.default.createElement('br', null),
	                                    _react2.default.createElement(
	                                      'div',
	                                      { id: 'video_section' },
	                                      _react2.default.createElement(
	                                        'h3',
	                                        null,
	                                        'Videos'
	                                      ),
	                                      _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'row n5v3k' },
	                                        _react2.default.createElement(
	                                          'div',
	                                          { 'class': 'container' },
	                                          'Video not available in preview'
	                                        )
	                                      )
	                                    ),
	                                    _react2.default.createElement('br', null),
	                                    _react2.default.createElement(
	                                      'div',
	                                      { id: 'contactinfo_section' },
	                                      _react2.default.createElement(
	                                        'h3',
	                                        null,
	                                        'Contact Info'
	                                      ),
	                                      _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'col-lg-8 col-sm-12 col-md-12 col-xs-12 text-left' },
	                                        _react2.default.createElement(
	                                          'div',
	                                          { 'class': 'per100 text-left' },
	                                          _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'bs_social' },
	                                            _react2.default.createElement(
	                                              'div',
	                                              null,
	                                              ' Email Address: ',
	                                              _react2.default.createElement(
	                                                'b',
	                                                null,
	                                                this.state.email
	                                              ),
	                                              ' '
	                                            ),
	                                            _react2.default.createElement('br', null),
	                                            _react2.default.createElement(
	                                              'div',
	                                              null,
	                                              ' Website: ',
	                                              _react2.default.createElement(
	                                                'b',
	                                                null,
	                                                _react2.default.createElement(
	                                                  'a',
	                                                  { target: '_blank', href: this.state.website },
	                                                  this.state.website
	                                                )
	                                              ),
	                                              ' '
	                                            ),
	                                            _react2.default.createElement('br', null),
	                                            _react2.default.createElement(
	                                              'div',
	                                              null,
	                                              ' Contact Number: ',
	                                              _react2.default.createElement('b', null),
	                                              ' '
	                                            ),
	                                            _react2.default.createElement('br', null)
	                                          )
	                                        )
	                                      )
	                                    ),
	                                    _react2.default.createElement('br', null),
	                                    _react2.default.createElement(
	                                      'div',
	                                      { id: 'review_section' },
	                                      _react2.default.createElement(
	                                        'h3',
	                                        { 'class': 'review_head' },
	                                        'Review',
	                                        _react2.default.createElement(
	                                          'div',
	                                          { 'class': 'floatright' },
	                                          _react2.default.createElement(
	                                            'small',
	                                            { 'class': 'pointer' },
	                                            _react2.default.createElement('i', { 'class': 'fa fa-plus', 'aria-hidden': 'true' })
	                                          )
	                                        )
	                                      ),
	                                      _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'reviewinfo' },
	                                        _react2.default.createElement(
	                                          'div',
	                                          { 'class': 'col-md-12' },
	                                          _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'detailBox' },
	                                            _react2.default.createElement(
	                                              'div',
	                                              { 'class': 'form-comments' },
	                                              _react2.default.createElement(
	                                                'p',
	                                                null,
	                                                'Click here to view Comments!...'
	                                              )
	                                            )
	                                          )
	                                        )
	                                      )
	                                    ),
	                                    _react2.default.createElement('br', null)
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'col-lg-2 rightmenu' },
	                                  _react2.default.createElement('img', { src: _rightmenuimage2.default, 'class': 'rightmenuimg' })
	                                )
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'row' },
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'col-md-12 footerp' },
	                              _react2.default.createElement('img', { src: _footerpreview2.default, 'class': 'headerimagewidth' })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          _reactstrap.ModalFooter,
	                          null,
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'col-md-12 text-center' },
	                              _react2.default.createElement(
	                                'button',
	                                { className: 'btn btn-sm btn-default', onClick: this.cancelPop2 },
	                                'Close'
	                              )
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(_reactNotifications.NotificationContainer, null)
	        )
	      );
	    }
	  }]);
	
	  return exclusivePartnerEdit;
	}(_react.Component);
	
	exports.default = exclusivePartnerEdit;

/***/ },
/* 942 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _FetchCall2 = _interopRequireDefault(_FetchCall);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import { Editor } from '@tinymce/tinymce-react';
	
	
	var generalCities = function (_Component) {
	  _inherits(generalCities, _Component);
	
	  function generalCities(props) {
	    _classCallCheck(this, generalCities);
	
	    var _this = _possibleConstructorReturn(this, (generalCities.__proto__ || Object.getPrototypeOf(generalCities)).call(this, props));
	
	    _this.openAddBox = function () {
	
	      _this.setState({ openedAdd: true });
	    };
	
	    _this.handleChange = function (e) {
	      _this.setState(_defineProperty({}, e.target.name, e.target.value));
	    };
	
	    _this.saveCity = function () {
	
	      var req = JSON.stringify({
	        city: _this.state.city,
	        latitude: _this.state.latitude,
	        longtitude: _this.state.longtitude
	      });
	
	      (0, _FetchCall.saveCity)(req).then(function (response) {
	
	        if (response.status == 1) {
	
	          alert("success");
	          _this.getCityList();
	        } else {
	          alert("error");
	        }
	      });
	    };
	
	    _this.getCityList = function () {
	      var _this$state$auth_data = _this.state.auth_data,
	          login_id = _this$state$auth_data.login_id,
	          role = _this$state$auth_data.role;
	
	      var ins = JSON.stringify({
	        vendor_id: login_id,
	        role: role
	      });
	      (0, _FetchCall.getCityList)(ins).then(function (res) {
	        if (res.status == 1) {
	          _this.setState({
	            arealist: res.list
	
	          });
	        } else {
	          _this.setState({
	            arealist: []
	          });
	        }
	      });
	    };
	
	    var url = new URL(window.location.href);
	    var location = url.searchParams.get("location");
	    var auth_data = JSON.parse(localStorage.getItem("user_data"));
	    _this.state = {
	      logged: localStorage.getItem("authentication"),
	      auth_data: JSON.parse(localStorage.getItem("user_data")),
	      location: location ? location : auth_data.access_location ? auth_data.access_location : 'Bengaluru',
	      arealist: [],
	      openedAdd: false
	    };
	
	    _this.getCityList();
	    return _this;
	  }
	
	  _createClass(generalCities, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	
	      var THIS = this;
	      (0, _jquery2.default)(document).on('click', '.remove_school', function () {
	        var delete_id = (0, _jquery2.default)(this).data("id");
	        THIS.setState({
	          delete_id: delete_id
	        });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var arealist = this.state.arealist;
	
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'col-lg-12 grid-margin stretch-card' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card-body' },
	                _react2.default.createElement(
	                  'h4',
	                  { 'class': 'card-title' },
	                  'City'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'float-right' },
	                  _react2.default.createElement(
	                    'button',
	                    { 'class': 'btn btn-primary btn-sm', onClick: this.openAddBox },
	                    'Add New'
	                  )
	                ),
	                this.state.openedAdd && _react2.default.createElement(
	                  'form',
	                  null,
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'row col-lg-12' },
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'form-group' },
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'form-row' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          'City name'
	                        ),
	                        _react2.default.createElement('input', { type: 'text', 'class': 'form-control', name: 'city', onChange: this.handleChange })
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'form-row' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          'Latitude'
	                        ),
	                        _react2.default.createElement('input', { type: 'text', 'class': 'form-control', name: 'latitude', onChange: this.handleChange })
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'form-row' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          'Longtitude'
	                        ),
	                        _react2.default.createElement('input', { type: 'text', 'class': 'form-control', name: 'longtitude', onChange: this.handleChange })
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'form-group row' },
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'col-sm-10' },
	                          _react2.default.createElement(
	                            'button',
	                            { type: 'button', onClick: this.saveCity, 'class': 'btn btn-primary' },
	                            'Save'
	                          )
	                        )
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'row col-lg-12' },
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'pt-3 table-responsive' },
	                    _react2.default.createElement(
	                      'table',
	                      { 'class': 'table table-bordered table-striped table-sm' },
	                      _react2.default.createElement(
	                        'thead',
	                        { 'class': 'thead-dark' },
	                        _react2.default.createElement(
	                          'tr',
	                          null,
	                          _react2.default.createElement(
	                            'th',
	                            null,
	                            _react2.default.createElement(
	                              'strong',
	                              null,
	                              'S.No'
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'th',
	                            null,
	                            _react2.default.createElement(
	                              'strong',
	                              null,
	                              'City'
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'th',
	                            null,
	                            _react2.default.createElement(
	                              'strong',
	                              null,
	                              'Latitude'
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'th',
	                            null,
	                            _react2.default.createElement(
	                              'strong',
	                              null,
	                              'Longtitude'
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'th',
	                            null,
	                            _react2.default.createElement(
	                              'strong',
	                              null,
	                              'Action'
	                            )
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'tbody',
	                        null,
	                        arealist.map(function (item, i) {
	
	                          return _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                              'td',
	                              null,
	                              i + 1
	                            ),
	                            _react2.default.createElement(
	                              'td',
	                              null,
	                              item.city
	                            ),
	                            _react2.default.createElement(
	                              'td',
	                              null,
	                              item.latitude
	                            ),
	                            _react2.default.createElement(
	                              'td',
	                              null,
	                              item.longtitude
	                            ),
	                            _react2.default.createElement('td', { 'class': 'actionbtns', dangerouslySetInnerHTML: { __html: item.action } })
	                          );
	                        })
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return generalCities;
	}(_react.Component);
	
	exports.default = generalCities;

/***/ },
/* 943 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _FetchCall2 = _interopRequireDefault(_FetchCall);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import { Editor } from '@tinymce/tinymce-react';
	
	
	var generalContacts = function (_Component) {
	  _inherits(generalContacts, _Component);
	
	  function generalContacts(props) {
	    _classCallCheck(this, generalContacts);
	
	    var _this = _possibleConstructorReturn(this, (generalContacts.__proto__ || Object.getPrototypeOf(generalContacts)).call(this, props));
	
	    _this.saveContact = function () {
	
	      alert("Saved");
	    };
	
	    _this.getContacts = function () {
	      var _this$state$auth_data = _this.state.auth_data,
	          login_id = _this$state$auth_data.login_id,
	          role = _this$state$auth_data.role;
	
	      var ins = JSON.stringify({
	        vendor_id: login_id,
	        role: role
	      });
	      (0, _FetchCall.getContacts)(ins).then(function (res) {
	        if (res.status == 1) {
	          _this.setState({
	            contacts: res.data
	
	          });
	        } else {
	          _this.setState({
	            contacts: []
	          });
	        }
	      });
	    };
	
	    var url = new URL(window.location.href);
	    var location = url.searchParams.get("location");
	    var auth_data = JSON.parse(localStorage.getItem("user_data"));
	    _this.state = {
	      logged: localStorage.getItem("authentication"),
	      auth_data: JSON.parse(localStorage.getItem("user_data")),
	      location: location ? location : auth_data.access_location ? auth_data.access_location : 'Bengaluru',
	      contacts: [],
	      openedAdd: false
	    };
	
	    _this.getContacts();
	    return _this;
	  }
	
	  _createClass(generalContacts, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	
	      var THIS = this;
	      (0, _jquery2.default)(document).on('click', '.remove_school', function () {
	        var delete_id = (0, _jquery2.default)(this).data("id");
	        THIS.setState({
	          delete_id: delete_id
	        });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var contacts = this.state.contacts;
	
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'col-lg-12 grid-margin stretch-card' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card-body' },
	                _react2.default.createElement(
	                  'h4',
	                  { 'class': 'card-title' },
	                  'Contacts'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'form-group col-md-3' },
	                      _react2.default.createElement(
	                        'label',
	                        null,
	                        ' Sitename '
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'form-group col-md-9' },
	                      _react2.default.createElement('input', { name: 'site_name', className: 'form-control', type: 'text', value: contacts.site_name,
	                        onChange: this.handleChange })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'form-group col-md-3' },
	                      _react2.default.createElement(
	                        'label',
	                        null,
	                        ' EmailID '
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'form-group col-md-9' },
	                      _react2.default.createElement('input', { name: 'emailid', className: 'form-control', type: 'text', value: contacts.emailid,
	                        onChange: this.handleChange })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'form-group col-md-3' },
	                      _react2.default.createElement(
	                        'label',
	                        null,
	                        ' Address'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'form-group col-md-9' },
	                      _react2.default.createElement('textarea', { name: 'address', className: 'form-control', type: 'text', value: contacts.address,
	                        onChange: this.handleChange })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'form-group col-md-3' },
	                      _react2.default.createElement(
	                        'label',
	                        null,
	                        ' Mobilenumber '
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'form-group col-md-9' },
	                      _react2.default.createElement('input', { name: 'mobilenumber', className: 'form-control', type: 'text', value: contacts.mobilenumber,
	                        onChange: this.handleChange })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row mb-4 text-right' },
	                    _react2.default.createElement(
	                      'button',
	                      { type: 'submit', id: 'btnSubmit',
	                        className: 'btn btn-primary btn-sm', onClick: this.saveContact, disabled: this.state.btnDisable, style: { display: "block", margin: "auto" } },
	                      'Submit'
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return generalContacts;
	}(_react.Component);
	
	exports.default = generalContacts;

/***/ },
/* 944 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _FetchCall2 = _interopRequireDefault(_FetchCall);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import { Editor } from '@tinymce/tinymce-react';
	
	
	var generalImages = function (_Component) {
	  _inherits(generalImages, _Component);
	
	  function generalImages(props) {
	    _classCallCheck(this, generalImages);
	
	    var _this = _possibleConstructorReturn(this, (generalImages.__proto__ || Object.getPrototypeOf(generalImages)).call(this, props));
	
	    _this.openAddBox = function () {
	
	      _this.setState({ openedAdd: true });
	    };
	
	    _this.getImagesList = function () {
	      var _this$state$auth_data = _this.state.auth_data,
	          login_id = _this$state$auth_data.login_id,
	          role = _this$state$auth_data.role;
	
	      var ins = JSON.stringify({
	        vendor_id: login_id,
	        role: role
	      });
	      (0, _FetchCall.getImagesList)(ins).then(function (res) {
	        if (res.status == 1) {
	          _this.setState({
	            imagesList: res.data
	
	          });
	        } else {
	          _this.setState({
	            imagesList: []
	          });
	        }
	      });
	    };
	
	    var url = new URL(window.location.href);
	    var location = url.searchParams.get("location");
	    var auth_data = JSON.parse(localStorage.getItem("user_data"));
	    _this.state = {
	      logged: localStorage.getItem("authentication"),
	      auth_data: JSON.parse(localStorage.getItem("user_data")),
	      location: location ? location : auth_data.access_location ? auth_data.access_location : 'Bengaluru',
	      imagesList: [],
	      openedAdd: false
	    };
	
	    _this.getImagesList();
	    return _this;
	  }
	
	  _createClass(generalImages, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	
	      var THIS = this;
	      (0, _jquery2.default)(document).on('click', '.remove_school', function () {
	        var delete_id = (0, _jquery2.default)(this).data("id");
	        THIS.setState({
	          delete_id: delete_id
	        });
	      });
	
	      (0, _jquery2.default)(document).on('click', '.stamp_it', function () {
	
	        var item_id = (0, _jquery2.default)(this).data("id");
	
	        THIS.openInfo(item_id);
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var imagesList = this.state.imagesList;
	
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'col-lg-12 grid-margin stretch-card' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card-body' },
	                _react2.default.createElement(
	                  'h4',
	                  { 'class': 'card-title' },
	                  'Images'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'float-right' },
	                  _react2.default.createElement(
	                    'button',
	                    { 'class': 'btn btn-inverse-primary', onClick: this.openAddBox },
	                    'Add New'
	                  )
	                ),
	                this.state.openedAdd && _react2.default.createElement(
	                  'div',
	                  { 'class': 'row col-lg-12' },
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'form-group' },
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'form-row' },
	                      _react2.default.createElement(
	                        'label',
	                        null,
	                        'Image name'
	                      ),
	                      _react2.default.createElement('input', { type: 'text', 'class': 'form-control', name: 'name' })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'form-row' },
	                      _react2.default.createElement(
	                        'label',
	                        null,
	                        'Choose image'
	                      ),
	                      _react2.default.createElement('input', { type: 'file', 'class': 'form-control', name: 'image' })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'form-row' },
	                      _react2.default.createElement(
	                        'button',
	                        { 'class': 'btn btn-primary btn-sm' },
	                        'Upload Image'
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'row col-lg-12' },
	                  imagesList.map(function (item, i) {
	
	                    return _react2.default.createElement(
	                      'div',
	                      { 'class': 'bordered' },
	                      _react2.default.createElement(
	                        'h4',
	                        null,
	                        _react2.default.createElement(
	                          'b',
	                          null,
	                          item.name
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'imagebox' },
	                        _react2.default.createElement('img', { src: item.imagepath, width: '200' })
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement('br', null),
	                        _react2.default.createElement(
	                          'button',
	                          { 'class': 'btn btn-primary btn-sm' },
	                          'Copy URL'
	                        )
	                      )
	                    );
	                  })
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return generalImages;
	}(_react.Component);
	
	exports.default = generalImages;

/***/ },
/* 945 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _FetchCall2 = _interopRequireDefault(_FetchCall);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import { Editor } from '@tinymce/tinymce-react';
	
	
	var generalLocalities = function (_Component) {
	  _inherits(generalLocalities, _Component);
	
	  function generalLocalities(props) {
	    _classCallCheck(this, generalLocalities);
	
	    var _this = _possibleConstructorReturn(this, (generalLocalities.__proto__ || Object.getPrototypeOf(generalLocalities)).call(this, props));
	
	    _this.openAddBox = function () {
	
	      _this.setState({ openedAdd: true });
	    };
	
	    _this.getAreaNamesList = function () {
	      var _this$state$auth_data = _this.state.auth_data,
	          login_id = _this$state$auth_data.login_id,
	          role = _this$state$auth_data.role;
	
	      var ins = JSON.stringify({
	        vendor_id: login_id,
	        role: role
	      });
	      (0, _FetchCall.getAreaNamesList)(ins).then(function (res) {
	        if (res.status == 1) {
	          _this.setState({
	            arealist: res.list
	
	          });
	        } else {
	          _this.setState({
	            arealist: []
	          });
	        }
	      });
	    };
	
	    var url = new URL(window.location.href);
	    var location = url.searchParams.get("location");
	    var auth_data = JSON.parse(localStorage.getItem("user_data"));
	    _this.state = {
	      logged: localStorage.getItem("authentication"),
	      auth_data: JSON.parse(localStorage.getItem("user_data")),
	      location: location ? location : auth_data.access_location ? auth_data.access_location : 'Bengaluru',
	      arealist: [],
	      openedAdd: false
	    };
	
	    _this.getAreaNamesList();
	    return _this;
	  }
	
	  _createClass(generalLocalities, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	
	      var THIS = this;
	      (0, _jquery2.default)(document).on('click', '.remove_school', function () {
	        var delete_id = (0, _jquery2.default)(this).data("id");
	        THIS.setState({
	          delete_id: delete_id
	        });
	      });
	
	      (0, _jquery2.default)(document).on('click', '.stamp_it', function () {
	
	        var item_id = (0, _jquery2.default)(this).data("id");
	
	        THIS.openInfo(item_id);
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var arealist = this.state.arealist;
	
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'col-lg-12 grid-margin stretch-card' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card-body' },
	                _react2.default.createElement(
	                  'h4',
	                  { 'class': 'card-title' },
	                  'Localities'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'float-right' },
	                  _react2.default.createElement(
	                    'button',
	                    { 'class': 'btn btn-primary btn-sm', onClick: this.openAddBox },
	                    'Add New'
	                  )
	                ),
	                this.state.openedAdd && _react2.default.createElement(
	                  'div',
	                  { 'class': 'row col-lg-12' },
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'form-group' },
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'form-row' },
	                      _react2.default.createElement(
	                        'label',
	                        null,
	                        'Image name'
	                      ),
	                      _react2.default.createElement('input', { type: 'text', 'class': 'form-control', name: 'name' })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'form-row' },
	                      _react2.default.createElement(
	                        'label',
	                        null,
	                        'Choose image'
	                      ),
	                      _react2.default.createElement('input', { type: 'file', 'class': 'form-control', name: 'image' })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'form-row' },
	                      _react2.default.createElement(
	                        'button',
	                        { 'class': 'btn btn-primary btn-sm' },
	                        'Upload Image'
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'row col-lg-12' },
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'pt-3 table-responsive' },
	                    _react2.default.createElement(
	                      'table',
	                      { id: 'tablebw' },
	                      _react2.default.createElement(
	                        'thead',
	                        { 'class': 'thead-dark' },
	                        _react2.default.createElement(
	                          'tr',
	                          null,
	                          _react2.default.createElement(
	                            'th',
	                            null,
	                            _react2.default.createElement(
	                              'strong',
	                              null,
	                              'S.No'
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'th',
	                            null,
	                            _react2.default.createElement(
	                              'strong',
	                              null,
	                              'Area Name'
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'th',
	                            null,
	                            _react2.default.createElement(
	                              'strong',
	                              null,
	                              'City'
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'th',
	                            null,
	                            _react2.default.createElement(
	                              'strong',
	                              null,
	                              'Latitude'
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'th',
	                            null,
	                            _react2.default.createElement(
	                              'strong',
	                              null,
	                              'Longtitude'
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'th',
	                            null,
	                            _react2.default.createElement(
	                              'strong',
	                              null,
	                              'Action'
	                            )
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'tbody',
	                        null,
	                        arealist.map(function (item, i) {
	
	                          return _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                              'td',
	                              null,
	                              i + 1
	                            ),
	                            _react2.default.createElement(
	                              'td',
	                              null,
	                              item.area_name
	                            ),
	                            _react2.default.createElement(
	                              'td',
	                              null,
	                              item.city
	                            ),
	                            _react2.default.createElement(
	                              'td',
	                              null,
	                              item.latitude
	                            ),
	                            _react2.default.createElement(
	                              'td',
	                              null,
	                              item.longtitude
	                            ),
	                            _react2.default.createElement('td', { dangerouslySetInnerHTML: { __html: item.action } })
	                          );
	                        })
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return generalLocalities;
	}(_react.Component);
	
	exports.default = generalLocalities;

/***/ },
/* 946 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InstagramIcon = function (_Component) {
	  _inherits(InstagramIcon, _Component);
	
	  function InstagramIcon(props) {
	    _classCallCheck(this, InstagramIcon);
	
	    var _this = _possibleConstructorReturn(this, (InstagramIcon.__proto__ || Object.getPrototypeOf(InstagramIcon)).call(this, props));
	
	    _this.state = {};
	
	    return _this;
	  }
	
	  _createClass(InstagramIcon, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var THIS = this;
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {}
	  }, {
	    key: "render",
	    value: function render() {
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement("img", { src: "/assets/icons/instagram.png", alt: "instagram", title: "instagram" })
	      );
	    }
	  }]);
	
	  return InstagramIcon;
	}(_react.Component);
	
	exports.default = InstagramIcon;

/***/ },
/* 947 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _FetchCall2 = _interopRequireDefault(_FetchCall);
	
	var _draftJs = __webpack_require__(84);
	
	__webpack_require__(92);
	
	var _draftjsToHtml = __webpack_require__(106);
	
	var _draftjsToHtml2 = _interopRequireDefault(_draftjsToHtml);
	
	var _htmlToDraftjs = __webpack_require__(158);
	
	var _htmlToDraftjs2 = _interopRequireDefault(_htmlToDraftjs);
	
	var _tinymceReact = __webpack_require__(69);
	
	var _constant = __webpack_require__(21);
	
	var _axios = __webpack_require__(184);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import { Editor } from '@tinymce/tinymce-react';
	
	//import { Editor } from 'react-draft-wysiwyg';
	
	
	var leadDetail = function (_Component) {
	  _inherits(leadDetail, _Component);
	
	  function leadDetail(props) {
	    _classCallCheck(this, leadDetail);
	
	    var _this = _possibleConstructorReturn(this, (leadDetail.__proto__ || Object.getPrototypeOf(leadDetail)).call(this, props));
	
	    _this.handleChange = function (e) {
	      _this.setState(_defineProperty({}, e.target.name, e.target.value));
	    };
	
	    _this.handleSubmit = function (e) {};
	
	    _this.state = {
	      lead: "",
	      openModal: false,
	      checkMailContent: false,
	      fetchedPartnerListHTML: '',
	      lead_data: [],
	      maillist: [],
	      partnerlist: [],
	      manualpartnerlist: [],
	      partners_f: [],
	      created_date: "",
	      confirmnodataregret: false,
	      distance: '',
	      modetype: '',
	      auth_data: JSON.parse(localStorage.getItem("user_data")),
	      user_data: localStorage.getItem('user_data') ? JSON.parse(localStorage.getItem('user_data')) : [],
	      authentication: localStorage.getItem('authentication') ? JSON.parse(localStorage.getItem('authentication')) : false
	    };
	
	    _this.lead_id = _this.props.match.params.id ? _this.props.match.params.id : '';
	    if (_this.lead_id !== undefined) {
	
	      _this.leadDetail(_this.lead_id);
	      _this.partnerLeadInfo(_this.lead_id);
	    }
	    _this.renderUsers = _this.renderUsers.bind(_this);
	    _this.leadDetail = _this.leadDetail.bind(_this);
	    _this.getMailinfo = _this.getMailinfo.bind(_this);
	    _this.domanualprocess = _this.domanualprocess.bind(_this);
	    _this.handleEditorChange = _this.handleEditorChange.bind(_this);
	    _this.confirmPush = _this.confirmPush.bind(_this);
	    _this.doregretprocess = _this.doregretprocess.bind(_this);
	
	    return _this;
	  }
	
	  _createClass(leadDetail, [{
	    key: 'doregretprocess',
	    value: function doregretprocess(lead_id) {
	      var _this2 = this;
	
	      var req = JSON.stringify({
	        lead_id: lead_id,
	        firstname: this.state.firstname,
	        lastname: this.state.lastname,
	        email: this.state.email
	      });
	
	      (0, _FetchCall.bringNoDateMail)(req).then(function (response) {
	        if (response.status === 1) {
	
	          _this2.setState({ loading: false, regret_mailcontent: response.mail_content, confirmnodataregret: true });
	        }
	      });
	    }
	  }, {
	    key: 'confirmRegretSend',
	    value: function confirmRegretSend(lead_id) {
	
	      var req = JSON.stringify({
	        lead_id: lead_id,
	        mail_content: this.state.mail_content,
	        email: this.state.email
	      });
	
	      (0, _FetchCall.sendRegretNoData)(req).then(function (response) {
	        if (response.status === 1) {
	
	          alert("mail is sent");
	        } else {
	          alert("mail is not sent");
	        }
	      });
	    }
	  }, {
	    key: 'domanualprocess',
	    value: function domanualprocess(lead_id) {
	      var _this3 = this;
	
	      (0, _jquery2.default)("#responsemessage").html("");
	
	      var req = JSON.stringify({
	        lead_id: lead_id,
	        distance: this.state.distance,
	        type: this.state.modetype
	      });
	
	      (0, _FetchCall.checkpushLead)(req).then(function (response) {
	        if (response.status === 1) {
	
	          (0, _jquery2.default)("#manualbtnsection").addClass('hidden');
	
	          if (response.manualpartnerlist.length > 0) {
	            _this3.setState({
	              manualpartnerlist: response.manualpartnerlist,
	              mail_content: response.mail_content,
	              partners_f: response.manualpartnerlist,
	              openModal: true
	            });
	          } else {
	            (0, _jquery2.default)("#responsemessage").html("No partners found..");
	          }
	        } else {
	          (0, _jquery2.default)("#manualbtnsection").removeClass('hidden');
	          _this3.setState({
	            openModal: false
	          });
	        }
	      });
	    }
	  }, {
	    key: 'confirmPush',
	    value: function confirmPush() {
	      var _this4 = this;
	
	      var req = JSON.stringify({
	        lead_id: this.props.match.params.id,
	        distance: this.state.distance,
	        type: this.state.modetype
	      });
	      this.setState({ loading: true });
	      (0, _FetchCall.confirmLead)(req).then(function (response) {
	        if (response.status === 1) {
	
	          (0, _jquery2.default)("#manualcreatlead").addClass('hidden');
	          _this4.setState({
	            loading: false,
	            checkMailContent: true
	          });
	        } else {
	
	          _this4.setState({
	            loading: false,
	            checkMailContent: false
	          });
	        }
	      });
	    }
	  }, {
	    key: 'getMailinfo',
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var _this5 = this;
	
	        var req;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                req = JSON.stringify({
	                  lead_id: this.lead_id
	                });
	
	
	                (0, _jquery2.default)("#showmailinfoBtn").addClass('hidden');
	
	                (0, _FetchCall.getMailInfo)(req).then(function (response) {
	                  if (response.status === 1) {
	                    _this5.setState({
	                      maillist: response.list
	                    });
	                  } else {
	
	                    (0, _jquery2.default)("#showmailinfoBtn").removeClass('hidden');
	                    _this5.setState({
	                      maillist: []
	                    });
	                  }
	                });
	
	              case 3:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function getMailinfo() {
	        return _ref.apply(this, arguments);
	      }
	
	      return getMailinfo;
	    }()
	  }, {
	    key: 'processmanuallead',
	    value: function processmanuallead(lead_id) {
	
	      var req = JSON.stringify({
	        lead_id: lead_id
	      });
	
	      (0, _FetchCall.checkpushLead)(req).then(function (response) {
	        if (response.status === 1) {
	
	          (0, _jquery2.default)("#manualcreatlead").addClass('hidden');
	
	          var toastr = '';
	          toastr = window.toastr.success;
	          toastr('', 'Lead has been created, Customer and Partner will receive lead information via email. Please reload this page', {
	            positionClass: "toast-bottom-right",
	            containerId: "toast-bottom-right"
	          });
	        } else {
	          var _toastr = '';
	          _toastr = window.toastr.error;
	          _toastr('', 'Lead is not created due to some technical issue in the server', {
	            positionClass: "toast-bottom-right",
	            containerId: "toast-bottom-right"
	          });
	        }
	      });
	    }
	  }, {
	    key: 'confirmSend',
	    value: function confirmSend(lead_id) {
	
	      var req = JSON.stringify({
	        lead_id: lead_id,
	        mail_content: this.state.mail_content,
	        partners_f: this.state.partners_f
	      });
	
	      (0, _FetchCall.createLeadManual)(req).then(function (response) {
	        if (response.status === 1) {
	
	          (0, _jquery2.default)("#mailcontent_section").hide();
	          (0, _jquery2.default)("#manualprocesssection").hide();
	          (0, _jquery2.default)(".returnmessage").addClass('green');
	          (0, _jquery2.default)(".returnmessage").html("Lead has been created, Customer and Partner will receive lead information via email. Please reload this page");
	        } else {
	          (0, _jquery2.default)(".returnmessage").addClass('red');
	          (0, _jquery2.default)(".returnmessage").html("sorry..some technical issue");
	        }
	      });
	    }
	  }, {
	    key: 'partnerLeadInfo',
	    value: function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(lead_id) {
	        var _this6 = this;
	
	        var req;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                req = JSON.stringify({
	                  lead_id: lead_id
	                });
	
	
	                (0, _FetchCall.getPartnerLeadInfo)(req).then(function (response) {
	                  if (response.status === 1) {
	                    _this6.setState({
	                      partnerlist: response.list
	                    });
	                  } else {
	                    _this6.setState({
	                      partnerlist: []
	                    });
	                  }
	                });
	
	              case 2:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this);
	      }));
	
	      function partnerLeadInfo(_x) {
	        return _ref2.apply(this, arguments);
	      }
	
	      return partnerLeadInfo;
	    }()
	  }, {
	    key: 'leadDetail',
	    value: function () {
	      var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(lead_id) {
	        var response, _setState, cat_detail, subcategory;
	
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                _context3.next = 2;
	                return _FetchCall2.default.getLeadDetail(lead_id);
	
	              case 2:
	                response = _context3.sent;
	
	                if (!(response.status === 1)) {
	                  _context3.next = 15;
	                  break;
	                }
	
	                this.setState((_setState = {
	                  lead_id: response.detail.id,
	                  lead_number: response.detail.lead_number,
	                  firstname: response.detail.firstname,
	                  lead_status: response.detail.lead_status,
	                  city: response.detail.city,
	                  lastname: response.detail.lastname,
	                  email: response.detail.email,
	                  grades: response.detail.grades,
	                  subcategory: response.detail.subcategory,
	                  subcategory_text: response.detail.subcategory_text,
	                  mobilenumber: response.detail.mobilenumber,
	                  created_date: new Intl.DateTimeFormat('en-US', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).format(response.detail.created_date),
	                  lead_data: response.detail.lead_data ? JSON.parse(response.detail.lead_data) : [],
	                  location: response.detail.location
	                }, _defineProperty(_setState, 'city', response.detail.city), _defineProperty(_setState, 'lead_vertical', response.detail.lead_vertical), _defineProperty(_setState, 'accepttakingcalls', response.detail.accepttakingcalls), _defineProperty(_setState, 'searchkey', response.detail.searchkey), _defineProperty(_setState, 'user_id', response.detail.user_id), _setState));
	
	                if (!response.detail.searchkey) {
	                  _context3.next = 15;
	                  break;
	                }
	
	                _context3.next = 8;
	                return _FetchCall2.default.getCategoryDetail(response.detail.searchkey);
	
	              case 8:
	                cat_detail = _context3.sent;
	
	                if (!(cat_detail.status === 1)) {
	                  _context3.next = 15;
	                  break;
	                }
	
	                this.setState({ subvertical: cat_detail.results[0].category_name });
	
	                _context3.next = 13;
	                return _FetchCall2.default.getCategoryDetail(response.detail.subcategory);
	
	              case 13:
	                subcategory = _context3.sent;
	
	                if (subcategory.status === 1) {
	                  this.setState({ subcategory_text: subcategory.results[0].category_name });
	                }
	
	              case 15:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, this);
	      }));
	
	      function leadDetail(_x2) {
	        return _ref3.apply(this, arguments);
	      }
	
	      return leadDetail;
	    }()
	  }, {
	    key: 'renderUsers',
	    value: function renderUsers() {
	      var userList = [];
	
	      for (var i = 0; i < this.state.partnerlist.length; i++) {
	
	        userList.push(_react2.default.createElement(
	          'tr',
	          { 'class': 'table-info' },
	          _react2.default.createElement(
	            'td',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: this.state.partnerlist[i].partner_link == null ? "#" : "https://bewise.in" + this.state.partnerlist[i].partner_link, target: '_blank' },
	              this.state.partnerlist[i].partner_name
	            )
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            ' ',
	            this.state.partnerlist[i].seen == 1 ? "Yes" : "No"
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            this.state.partnerlist[i].seen_mobilenumber == 1 ? "Yes" : "No"
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            ' ',
	            this.state.partnerlist[i].seen_emailid == 1 ? "Yes" : "No"
	          )
	        ));
	      }
	
	      return userList;
	    }
	  }, {
	    key: 'handleEditorChange',
	    value: function handleEditorChange(value, editor) {
	      this.setState({
	        mail_content: value
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	
	      var user_data = localStorage.getItem("user_data");
	      var auth_data = JSON.parse(user_data);
	      var vendor_id = auth_data.login_id;
	      var role = auth_data.role;
	      this.setState({ vendor_id: vendor_id, role: role });
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      // window.jQuery('.selectpicker').selectpicker('refresh')
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this7 = this;
	
	      var _state = this.state,
	          lead_id = _state.lead_id,
	          lead_number = _state.lead_number,
	          lead_status = _state.lead_status,
	          email = _state.email,
	          mobilenumber = _state.mobilenumber,
	          lead_data = _state.lead_data,
	          firstname = _state.firstname,
	          lastname = _state.lastname,
	          lead_vertical = _state.lead_vertical,
	          grades = _state.grades,
	          searchkey = _state.searchkey,
	          subcategory_text = _state.subcategory_text,
	          subvertical = _state.subvertical,
	          subcategory = _state.subcategory,
	          location = _state.location,
	          city = _state.city,
	          accepttakingcalls = _state.accepttakingcalls,
	          created_date = _state.created_date,
	          partnerlist = _state.partnerlist,
	          manualpartnerlist = _state.manualpartnerlist,
	          user_id = _state.user_id;
	
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'col-lg-12 grid-margin stretch-card' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card-body' },
	                _react2.default.createElement(
	                  'h4',
	                  { 'class': 'card-title' },
	                  'Leads '
	                ),
	                _react2.default.createElement(
	                  'a',
	                  { href: '/leads/leadlist', 'class': 'btn btn-sm btn-primary' },
	                  'Back to list'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'leadpage' },
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'd-flex justify-content-between align-items-center py-3' },
	                    _react2.default.createElement(
	                      'h2',
	                      { 'class': 'h5 mb-0' },
	                      _react2.default.createElement('a', { href: '#', 'class': 'text-muted' }),
	                      ' Lead Ref# :',
	                      lead_number
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'col-lg-8' },
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'card mb-4' },
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'card-body' },
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'mb-3 d-flex justify-content-between' },
	                            _react2.default.createElement(
	                              'div',
	                              null,
	                              _react2.default.createElement(
	                                'span',
	                                { 'class': 'me-3' },
	                                'Created Date: ',
	                                created_date,
	                                '\xA0'
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'd-flex' },
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'exportbox' },
	                                _react2.default.createElement(
	                                  'ul',
	                                  { 'class': 'dropdown-menu dropdown-menu-end' },
	                                  _react2.default.createElement(
	                                    'li',
	                                    null,
	                                    _react2.default.createElement(
	                                      'a',
	                                      { 'class': 'dropdown-item', href: '#' },
	                                      _react2.default.createElement('i', { 'class': 'bi bi-printer' }),
	                                      ' Print'
	                                    )
	                                  )
	                                )
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'table',
	                            { 'class': 'table table-borderless' },
	                            _react2.default.createElement(
	                              'tbody',
	                              null,
	                              _react2.default.createElement(
	                                'tr',
	                                null,
	                                _react2.default.createElement(
	                                  'td',
	                                  null,
	                                  _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      'Vertical'
	                                    ),
	                                    _react2.default.createElement(
	                                      'div',
	                                      null,
	                                      lead_vertical
	                                    ),
	                                    _react2.default.createElement('br', null)
	                                  ),
	                                  searchkey != null && _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      'Category'
	                                    ),
	                                    _react2.default.createElement(
	                                      'div',
	                                      null,
	                                      subvertical
	                                    ),
	                                    _react2.default.createElement('br', null)
	                                  ),
	                                  subcategory != null && _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      'Subcategory'
	                                    ),
	                                    _react2.default.createElement(
	                                      'div',
	                                      null,
	                                      subcategory_text
	                                    ),
	                                    _react2.default.createElement('br', null)
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      'City'
	                                    ),
	                                    _react2.default.createElement(
	                                      'div',
	                                      null,
	                                      city
	                                    )
	                                  ),
	                                  _react2.default.createElement('br', null),
	                                  _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      'Locality'
	                                    ),
	                                    _react2.default.createElement(
	                                      'div',
	                                      null,
	                                      location
	                                    )
	                                  ),
	                                  _react2.default.createElement('br', null),
	                                  _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      'Opt for Calling'
	                                    ),
	                                    accepttakingcalls == 'listing' && _react2.default.createElement(
	                                      'div',
	                                      null,
	                                      'Opt not for receiving calls'
	                                    ),
	                                    accepttakingcalls == 'no' && _react2.default.createElement(
	                                      'div',
	                                      null,
	                                      'Opt not for receiving calls'
	                                    )
	                                  ),
	                                  _react2.default.createElement('br', null),
	                                  _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      'Other Vertical Attributes chosen'
	                                    ),
	                                    _react2.default.createElement(
	                                      'div',
	                                      { 'class': 'borderbox' },
	                                      lead_vertical == 'tuitions' && _react2.default.createElement(
	                                        'ul',
	                                        null,
	                                        _react2.default.createElement(
	                                          'li',
	                                          null,
	                                          'Grade: ',
	                                          _react2.default.createElement(
	                                            'b',
	                                            null,
	                                            grades
	                                          )
	                                        ),
	                                        _react2.default.createElement(
	                                          'li',
	                                          null,
	                                          'Board of Education: ',
	                                          _react2.default.createElement(
	                                            'b',
	                                            null,
	                                            lead_data.lead_board
	                                          )
	                                        ),
	                                        _react2.default.createElement(
	                                          'li',
	                                          null,
	                                          'Learning Location: ',
	                                          _react2.default.createElement(
	                                            'b',
	                                            null,
	                                            lead_data.lead_mode
	                                          )
	                                        ),
	                                        _react2.default.createElement(
	                                          'li',
	                                          null,
	                                          'User prefers to work with: ',
	                                          _react2.default.createElement(
	                                            'b',
	                                            null,
	                                            lead_data.lead_premisestype
	                                          )
	                                        )
	                                      ),
	                                      lead_vertical == 'school' && _react2.default.createElement(
	                                        'ul',
	                                        null,
	                                        _react2.default.createElement(
	                                          'li',
	                                          null,
	                                          'Grade: ',
	                                          _react2.default.createElement(
	                                            'b',
	                                            null,
	                                            lead_data.lead_grades
	                                          )
	                                        ),
	                                        _react2.default.createElement(
	                                          'li',
	                                          null,
	                                          'Board of Study: ',
	                                          _react2.default.createElement(
	                                            'b',
	                                            null,
	                                            lead_data.lead_board
	                                          )
	                                        ),
	                                        _react2.default.createElement(
	                                          'li',
	                                          null,
	                                          'Learning Location: ',
	                                          _react2.default.createElement(
	                                            'b',
	                                            null,
	                                            lead_data.lead_mode
	                                          )
	                                        ),
	                                        _react2.default.createElement(
	                                          'li',
	                                          null,
	                                          'User prefers to work with: ',
	                                          _react2.default.createElement(
	                                            'b',
	                                            null,
	                                            lead_data.lead_premisestype
	                                          )
	                                        )
	                                      ),
	                                      lead_vertical == 'schools' && _react2.default.createElement(
	                                        'ul',
	                                        null,
	                                        _react2.default.createElement(
	                                          'li',
	                                          null,
	                                          'Grade: ',
	                                          _react2.default.createElement(
	                                            'b',
	                                            null,
	                                            lead_data.lead_grades
	                                          )
	                                        ),
	                                        _react2.default.createElement(
	                                          'li',
	                                          null,
	                                          'Board of Study: ',
	                                          _react2.default.createElement(
	                                            'b',
	                                            null,
	                                            lead_data.lead_board
	                                          )
	                                        ),
	                                        _react2.default.createElement(
	                                          'li',
	                                          null,
	                                          'Learning Location: ',
	                                          _react2.default.createElement(
	                                            'b',
	                                            null,
	                                            lead_data.lead_mode
	                                          )
	                                        ),
	                                        _react2.default.createElement(
	                                          'li',
	                                          null,
	                                          'User prefers to work with: ',
	                                          _react2.default.createElement(
	                                            'b',
	                                            null,
	                                            lead_data.lead_premisestype
	                                          )
	                                        )
	                                      ),
	                                      lead_vertical == 'preschools' && _react2.default.createElement(
	                                        'div',
	                                        null,
	                                        'No information'
	                                      ),
	                                      lead_vertical == 'music' && _react2.default.createElement(
	                                        'ul',
	                                        null,
	                                        _react2.default.createElement(
	                                          'li',
	                                          null,
	                                          'Learning Location: ',
	                                          _react2.default.createElement(
	                                            'b',
	                                            null,
	                                            lead_data.lead_mode
	                                          )
	                                        ),
	                                        _react2.default.createElement(
	                                          'li',
	                                          null,
	                                          'User prefers to work with: ',
	                                          _react2.default.createElement(
	                                            'b',
	                                            null,
	                                            lead_data.lead_premisestype
	                                          )
	                                        )
	                                      ),
	                                      lead_vertical == 'sports' && _react2.default.createElement(
	                                        'ul',
	                                        null,
	                                        _react2.default.createElement(
	                                          'li',
	                                          null,
	                                          'Learning Location: ',
	                                          _react2.default.createElement(
	                                            'b',
	                                            null,
	                                            lead_data.lead_mode
	                                          )
	                                        ),
	                                        _react2.default.createElement(
	                                          'li',
	                                          null,
	                                          'User prefers to work with: ',
	                                          _react2.default.createElement(
	                                            'b',
	                                            null,
	                                            lead_data.lead_premisestype
	                                          )
	                                        )
	                                      ),
	                                      lead_vertical == 'dance' && _react2.default.createElement(
	                                        'ul',
	                                        null,
	                                        _react2.default.createElement(
	                                          'li',
	                                          null,
	                                          'Dance Type: ',
	                                          _react2.default.createElement(
	                                            'b',
	                                            null,
	                                            lead_data.lead_sporttype
	                                          )
	                                        ),
	                                        _react2.default.createElement(
	                                          'li',
	                                          null,
	                                          'Learning Location: ',
	                                          _react2.default.createElement(
	                                            'b',
	                                            null,
	                                            lead_data.lead_mode
	                                          )
	                                        ),
	                                        _react2.default.createElement(
	                                          'li',
	                                          null,
	                                          'User prefers to work with: ',
	                                          _react2.default.createElement(
	                                            'b',
	                                            null,
	                                            lead_data.lead_premisestype
	                                          )
	                                        )
	                                      ),
	                                      lead_vertical == 'creativearts' && _react2.default.createElement(
	                                        'ul',
	                                        null,
	                                        _react2.default.createElement(
	                                          'li',
	                                          null,
	                                          'Learning Location: ',
	                                          _react2.default.createElement(
	                                            'b',
	                                            null,
	                                            lead_data.lead_mode
	                                          )
	                                        ),
	                                        _react2.default.createElement(
	                                          'li',
	                                          null,
	                                          'User prefers to work with: ',
	                                          _react2.default.createElement(
	                                            'b',
	                                            null,
	                                            lead_data.lead_premisestype
	                                          )
	                                        )
	                                      ),
	                                      lead_vertical == 'hobbies' && _react2.default.createElement(
	                                        'ul',
	                                        null,
	                                        _react2.default.createElement(
	                                          'li',
	                                          null,
	                                          'Learning Location: ',
	                                          _react2.default.createElement(
	                                            'b',
	                                            null,
	                                            lead_data.lead_mode
	                                          )
	                                        ),
	                                        _react2.default.createElement(
	                                          'li',
	                                          null,
	                                          'User prefers to work with: ',
	                                          _react2.default.createElement(
	                                            'b',
	                                            null,
	                                            lead_data.lead_premisestype
	                                          )
	                                        )
	                                      ),
	                                      lead_vertical == 'mindandskills' && _react2.default.createElement(
	                                        'ul',
	                                        null,
	                                        _react2.default.createElement(
	                                          'li',
	                                          null,
	                                          'Learning Location: ',
	                                          _react2.default.createElement(
	                                            'b',
	                                            null,
	                                            lead_data.lead_mode
	                                          )
	                                        ),
	                                        _react2.default.createElement(
	                                          'li',
	                                          null,
	                                          'User prefers to work with: ',
	                                          _react2.default.createElement(
	                                            'b',
	                                            null,
	                                            lead_data.lead_premisestype
	                                          )
	                                        )
	                                      )
	                                    )
	                                  )
	                                )
	                              )
	                            )
	                          ),
	                          this.state.role == 1 && _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              'Partners Details'
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'container-fluid' },
	                              _react2.default.createElement(
	                                'div',
	                                null,
	                                this.state.partnerlist.length > 0 && _react2.default.createElement(
	                                  'table',
	                                  { 'class': 'table table-striped table-sm' },
	                                  _react2.default.createElement(
	                                    'tr',
	                                    { 'class': 'table-success' },
	                                    _react2.default.createElement(
	                                      'th',
	                                      { scope: 'col' },
	                                      'Partner'
	                                    ),
	                                    _react2.default.createElement(
	                                      'th',
	                                      { scope: 'col' },
	                                      'Lead seen'
	                                    ),
	                                    _react2.default.createElement(
	                                      'th',
	                                      { scope: 'col' },
	                                      'Mobile no seen'
	                                    ),
	                                    _react2.default.createElement(
	                                      'th',
	                                      { scope: 'col' },
	                                      'Email Id seen'
	                                    )
	                                  ),
	                                  this.renderUsers()
	                                ),
	                                this.state.partnerlist.length == 0 && _react2.default.createElement(
	                                  'div',
	                                  { id: 'manualcreatlead' },
	                                  'As there may be an issue processing the lead in the server or in algorithm, Please click below to see and send regret mail with partners'
	                                ),
	                                _react2.default.createElement('br', null),
	                                this.state.partnerlist.length == 0 && _react2.default.createElement(
	                                  'div',
	                                  { id: 'manualcreatleadoption' },
	                                  _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    'Select distance you want to fetch'
	                                  ),
	                                  _react2.default.createElement(
	                                    'select',
	                                    { name: 'distance', onChange: this.handleChange },
	                                    _react2.default.createElement(
	                                      'option',
	                                      { value: '' },
	                                      'Auto'
	                                    ),
	                                    _react2.default.createElement(
	                                      'option',
	                                      { value: '15' },
	                                      '15'
	                                    ),
	                                    _react2.default.createElement(
	                                      'option',
	                                      { value: '20' },
	                                      '20'
	                                    ),
	                                    _react2.default.createElement(
	                                      'option',
	                                      { value: '25' },
	                                      '25'
	                                    ),
	                                    _react2.default.createElement(
	                                      'option',
	                                      { value: '30' },
	                                      '30'
	                                    )
	                                  ),
	                                  _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    'Select type/mode you want to fetch from'
	                                  ),
	                                  _react2.default.createElement(
	                                    'select',
	                                    { name: 'modetype', onChange: this.handleChange },
	                                    _react2.default.createElement(
	                                      'option',
	                                      { value: '' },
	                                      'Auto'
	                                    ),
	                                    _react2.default.createElement(
	                                      'option',
	                                      { value: 'online' },
	                                      'Online'
	                                    ),
	                                    _react2.default.createElement(
	                                      'option',
	                                      { value: 'premises' },
	                                      'Premises'
	                                    ),
	                                    _react2.default.createElement(
	                                      'option',
	                                      { value: 'home' },
	                                      'Home'
	                                    )
	                                  )
	                                ),
	                                _react2.default.createElement('br', null),
	                                this.state.role == 1 && this.state.partnerlist.length == 0 && _react2.default.createElement(
	                                  'div',
	                                  { id: 'manualbtnsection' },
	                                  _react2.default.createElement(
	                                    'button',
	                                    { 'class': 'btn btn-primary btn-sm processpush', onClick: function onClick() {
	                                        return _this7.domanualprocess(_this7.lead_id);
	                                      } },
	                                    'Check if any partners found within the range of distance'
	                                  )
	                                ),
	                                _react2.default.createElement('br', null),
	                                _react2.default.createElement('br', null)
	                              ),
	                              _react2.default.createElement('div', { 'class': 'responsemessage', id: 'responsemessage' }),
	                              _react2.default.createElement('br', null),
	                              _react2.default.createElement('br', null),
	                              accepttakingcalls == 'listing' && _react2.default.createElement(
	                                'div',
	                                null,
	                                'This user chosen option to directly call the tutors/coach/teachers suggested by BeWise'
	                              )
	                            )
	                          ),
	                          this.state.role == 1 && !this.state.openModal && _react2.default.createElement(
	                            'div',
	                            { id: 'manualbtnsection' },
	                            _react2.default.createElement(
	                              'button',
	                              { 'class': 'btn btn-primary btn-sm processpush', onClick: function onClick() {
	                                  return _this7.domanualprocess(_this7.lead_id);
	                                } },
	                              'Manual process to check Mail content'
	                            )
	                          ),
	                          this.state.role == 1 && !this.state.openModal && _react2.default.createElement(
	                            'div',
	                            { id: 'manualbtnsection' },
	                            _react2.default.createElement(
	                              'button',
	                              { 'class': 'btn btn-primary btn-sm processpush', onClick: function onClick() {
	                                  return _this7.doregretprocess(_this7.lead_id);
	                                } },
	                              'No Data - Send Regret Mail'
	                            )
	                          ),
	                          this.state.role == 1 && this.state.openModal && _react2.default.createElement(
	                            'div',
	                            { 'class': 'manualprocesssection', id: 'manualprocesssection' },
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'partnerlist' },
	                              manualpartnerlist.length > 0 && _react2.default.createElement(
	                                'table',
	                                { 'class': 'table table-striped table-sm' },
	                                _react2.default.createElement(
	                                  'tr',
	                                  { 'class': 'table-success' },
	                                  _react2.default.createElement(
	                                    'th',
	                                    { scope: 'col' },
	                                    'Partner Name'
	                                  ),
	                                  _react2.default.createElement(
	                                    'th',
	                                    { scope: 'col' },
	                                    'City'
	                                  ),
	                                  _react2.default.createElement(
	                                    'th',
	                                    { scope: 'col' },
	                                    'Address'
	                                  )
	                                ),
	                                manualpartnerlist.map(function (partner, i) {
	
	                                  return _react2.default.createElement(
	                                    'tr',
	                                    { 'class': 'table-info' },
	                                    _react2.default.createElement(
	                                      'td',
	                                      null,
	                                      _react2.default.createElement(
	                                        'a',
	                                        { href: partner.partner_link == null ? "#" : "https://bewise.in" + partner.partner_link, target: '_blank' },
	                                        partner.partner_name
	                                      )
	                                    ),
	                                    _react2.default.createElement(
	                                      'td',
	                                      null,
	                                      partner.partner_city
	                                    ),
	                                    _react2.default.createElement(
	                                      'td',
	                                      null,
	                                      partner.partner_address
	                                    )
	                                  );
	                                })
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'row', id: 'submittoconfirm' },
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'col-md-12' },
	                                _react2.default.createElement(
	                                  'button',
	                                  { 'class': 'btn btn-primary btn-sm', onClick: this.confirmPush },
	                                  'I confirm and send an email to the customer'
	                                )
	                              )
	                            )
	                          ),
	                          this.state.loading && _react2.default.createElement(
	                            'div',
	                            null,
	                            'loading please wait.....'
	                          ),
	                          !this.state.loading && this.state.confirmnodataregret && _react2.default.createElement(
	                            'div',
	                            { 'class': 'regret_mailcontent_section', id: 'regret_mailcontent_section' },
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'partnerlist' },
	                              _react2.default.createElement(_tinymceReact.Editor, {
	                                onEditorChange: this.handleEditorChange,
	                                toolbar: {
	                                  inline: { inDropdown: true },
	                                  list: { inDropdown: true },
	                                  textAlign: { inDropdown: true },
	                                  link: { inDropdown: true },
	                                  history: { inDropdown: true },
	                                  image: { uploadCallback: this.uploadImageCallBack, alt: { present: true, mandatory: true } }
	                                },
	                                value: this.state.regret_mailcontent,
	                                name: 'regret_mailcontent',
	                                apiKey: _constant.TINY_EDITOR,
	                                init: {
	                                  height: 300,
	                                  theme: "silver",
	                                  plugins: ["advlist autolink lists link anchor paste image"],
	                                  toolbar: 'undo redo | formatselect | image| bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | help'
	
	                                }
	
	                              })
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { id: 'submittosend', 'class': 'row' },
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'col-md-12' },
	                                _react2.default.createElement(
	                                  'button',
	                                  { 'class': 'btn btn-primary btn-sm', onClick: function onClick() {
	                                      return _this7.confirmRegretSend(_this7.lead_id);
	                                    } },
	                                  'Send'
	                                )
	                              )
	                            )
	                          ),
	                          !this.state.loading && this.state.checkMailContent && _react2.default.createElement(
	                            'div',
	                            { 'class': 'mailcontent_section', id: 'mailcontent_section' },
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'partnerlist' },
	                              _react2.default.createElement(_tinymceReact.Editor, {
	                                onEditorChange: this.handleEditorChange,
	                                toolbar: {
	                                  inline: { inDropdown: true },
	                                  list: { inDropdown: true },
	                                  textAlign: { inDropdown: true },
	                                  link: { inDropdown: true },
	                                  history: { inDropdown: true },
	                                  image: { uploadCallback: this.uploadImageCallBack, alt: { present: true, mandatory: true } }
	                                },
	                                value: this.state.mail_content,
	                                name: 'mail_content',
	                                apiKey: _constant.TINY_EDITOR,
	                                init: {
	                                  height: 300,
	                                  theme: "silver",
	                                  plugins: ["advlist autolink lists link anchor paste image"],
	                                  toolbar: 'undo redo | formatselect | image| bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | help'
	
	                                }
	
	                              })
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { id: 'submittosend', 'class': 'row' },
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'col-md-12' },
	                                _react2.default.createElement(
	                                  'button',
	                                  { 'class': 'btn btn-primary btn-sm', onClick: function onClick() {
	                                      return _this7.confirmSend(_this7.lead_id);
	                                    } },
	                                  'Send'
	                                )
	                              )
	                            )
	                          ),
	                          _react2.default.createElement('div', { 'class': 'returnmessage', id: 'returnmessage' })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'col-lg-4' },
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'card mb-4' },
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'card-body' },
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'card-header' },
	                            ' ',
	                            _react2.default.createElement(
	                              'span',
	                              { 'class': 'me-3' },
	                              'Customer Info'
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                              'strong',
	                              null,
	                              firstname,
	                              ' ',
	                              lastname
	                            ),
	                            _react2.default.createElement('br', null)
	                          ),
	                          accepttakingcalls == 'call' && _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'btnaction' },
	                              'Email: ',
	                              email == '' ? 'none' : email
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'btnaction' },
	                              'Phone : ',
	                              mobilenumber == '' ? 'none' : mobilenumber
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'btnaction' },
	                              'BeWise User ID : ',
	                              user_id == 0 ? 'Not Defined' : user_id,
	                              ' ',
	                              user_id == 0 && _react2.default.createElement(
	                                'button',
	                                { 'class': 'btn btn-primary btn-sm', o: true },
	                                'Create User'
	                              )
	                            )
	                          )
	                        )
	                      ),
	                      this.state.role == 1 && _react2.default.createElement(
	                        'div',
	                        { 'class': 'card mb-4' },
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'card-body' },
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'card-header' },
	                            ' ',
	                            _react2.default.createElement(
	                              'span',
	                              { 'class': 'me-3' },
	                              'Mail Info'
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'row' },
	                            this.state.maillist.length > 0 && _react2.default.createElement(
	                              'div',
	                              { 'class': 'mailinfo' },
	                              this.state.maillist.map(function (maillog, idx) {
	                                return _react2.default.createElement(
	                                  'div',
	                                  null,
	                                  maillog.subject,
	                                  ' - ',
	                                  maillog.to,
	                                  ' - ',
	                                  _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    maillog.info == 'success' ? "Success" : "Invalid EmailId"
	                                  ),
	                                  ' '
	                                );
	                              })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'button',
	                            { 'class': 'btn btn-primary btn-sm', id: 'showmailinfoBtn', onClick: this.getMailinfo },
	                            'Click to view'
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return leadDetail;
	}(_react.Component);
	
	exports.default = leadDetail;

/***/ },
/* 948 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _FetchCall2 = _interopRequireDefault(_FetchCall);
	
	var _reactJsPagination = __webpack_require__(33);
	
	var _reactJsPagination2 = _interopRequireDefault(_reactJsPagination);
	
	var _bewiseloading = __webpack_require__(48);
	
	var _bewiseloading2 = _interopRequireDefault(_bewiseloading);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import { Editor } from '@tinymce/tinymce-react';
	
	//import Pagination from 'rc-pagination';
	
	var leadList = function (_Component) {
	  _inherits(leadList, _Component);
	
	  function leadList(props) {
	    _classCallCheck(this, leadList);
	
	    var _this = _possibleConstructorReturn(this, (leadList.__proto__ || Object.getPrototypeOf(leadList)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var url = new URL(window.location.href);
	    var location = url.searchParams.get("location");
	    var auth_data = JSON.parse(localStorage.getItem("user_data"));
	    _this.state = {
	      logged: localStorage.getItem("authentication"),
	      auth_data: JSON.parse(localStorage.getItem("user_data")),
	      location: location ? location : auth_data.access_location ? auth_data.access_location : 'Bengaluru',
	      PER_PAGE: 15,
	      total: 0,
	      loading: true,
	      searchby: '',
	      activePage: 0,
	      offset: 0,
	      leads: [{ name: "",
	        enddate: "",
	        fromdate: "",
	        starttime: "",
	        feeinr: "",
	        feeusd: "",
	        duration: "",
	        days: "" }]
	    };
	
	    return _this;
	  }
	
	  _createClass(leadList, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	
	      var dataOfUser = this.state.auth_data;
	
	      var allowedtoacess = dataOfUser.upgraded == 1 ? true : dataOfUser.current_plan != 5 && dataOfUser.current_plan != 0 && dataOfUser.current_plan != 1 ? true : false;
	      this.setState({ allowedtoacess: allowedtoacess });
	
	      var THIS = this;
	      (0, _jquery2.default)(document).on('click', '.remove_maili', function () {
	        var delete_id = (0, _jquery2.default)(this).data("id");
	        THIS.setState({
	          delete_id: delete_id
	        });
	      });
	
	      this.getTotal('leads');
	      this.getList();
	    }
	  }, {
	    key: 'handlePageChange',
	    value: function handlePageChange(pageNumber) {
	
	      console.log('active page is ' + pageNumber);
	
	      this.setState({ activePage: pageNumber });
	
	      //this.getTotal('bw_schools');
	      this.getList(pageNumber);
	    }
	  }, {
	    key: 'openDetail',
	    value: function openDetail(id) {
	      window.location = '/leads/leadDetail/' + id;
	    }
	  }, {
	    key: 'remove',
	    value: function remove(id) {
	
	      var toastr = '';
	      (0, _jquery2.default)(this).attr('disabled', false);
	
	      toastr = window.toastr.error; //warning
	      toastr('Success', 'Lead is removed', {
	        positionClass: "toast-bottom-right",
	        containerId: "toast-bottom-right"
	      });
	    }
	  }, {
	    key: 'discard',
	    value: function discard(id) {
	      var _this2 = this;
	
	      if (confirm("Are you sure you want to delete this lead?")) {
	
	        var toastr = '';
	        (0, _jquery2.default)(this).attr('disabled', false);
	
	        var req = JSON.stringify({
	          lead_id: id
	        });
	
	        (0, _FetchCall.removelead)(req).then(function (res) {
	
	          _this2.leadList();
	
	          toastr = window.toastr.error; //warning
	          toastr('Success', 'Lead is discarded', {
	            positionClass: "toast-bottom-right",
	            containerId: "toast-bottom-right"
	          });
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var leads = this.state.leads;
	      var _state = this.state,
	          currentPage = _state.currentPage,
	          PER_PAGE = _state.PER_PAGE,
	          totalCount = _state.totalCount,
	          total = _state.total,
	          allowedtoacess = _state.allowedtoacess;
	
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'col-lg-12 grid-margin stretch-card' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card-body' },
	                _react2.default.createElement(
	                  'h4',
	                  { 'class': 'card-title' },
	                  'Leads'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'middlesection' },
	                  !allowedtoacess && _react2.default.createElement(
	                    'div',
	                    { 'class': 'overlay' },
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      'Please subscribe or upgrade'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: !allowedtoacess ? "table-responsive pt-3 blurred" : "table-responsive pt-3" },
	                    _react2.default.createElement(
	                      'table',
	                      { 'class': 'table table-bordered table-sm' },
	                      _react2.default.createElement(
	                        'thead',
	                        { 'class': 'thead-dark' },
	                        _react2.default.createElement(
	                          'tr',
	                          null,
	                          _react2.default.createElement(
	                            'th',
	                            null,
	                            'S.No'
	                          ),
	                          _react2.default.createElement(
	                            'th',
	                            null,
	                            'First Name'
	                          ),
	                          _react2.default.createElement(
	                            'th',
	                            null,
	                            'Last Name'
	                          ),
	                          _react2.default.createElement(
	                            'th',
	                            null,
	                            'Date'
	                          ),
	                          _react2.default.createElement(
	                            'th',
	                            null,
	                            'Vertical'
	                          ),
	                          _react2.default.createElement(
	                            'th',
	                            null,
	                            'City'
	                          ),
	                          _react2.default.createElement(
	                            'th',
	                            null,
	                            'Sent Partner Info?'
	                          ),
	                          _react2.default.createElement(
	                            'th',
	                            null,
	                            'Action'
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'tbody',
	                        null,
	                        leads.length > 0 && leads.map(function (lead, i) {
	
	                          return _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                              'td',
	                              null,
	                              i + 1
	                            ),
	                            _react2.default.createElement(
	                              'td',
	                              null,
	                              lead.firstname
	                            ),
	                            _react2.default.createElement(
	                              'td',
	                              null,
	                              lead.lastname
	                            ),
	                            _react2.default.createElement(
	                              'td',
	                              null,
	                              lead.createdAt
	                            ),
	                            _react2.default.createElement(
	                              'td',
	                              null,
	                              lead.vertical
	                            ),
	                            _react2.default.createElement(
	                              'td',
	                              null,
	                              lead.city
	                            ),
	                            _react2.default.createElement('td', { dangerouslySetInnerHTML: { __html: lead.ispartnersent } }),
	                            _react2.default.createElement(
	                              'td',
	                              null,
	                              _react2.default.createElement(
	                                'span',
	                                { 'class': 'cursorpointer', onClick: function onClick() {
	                                    return _this3.openDetail(lead.id);
	                                  } },
	                                _react2.default.createElement('i', { 'class': 'eye-button fa fa-eye', title: 'View' })
	                              ),
	                              '\xA0\xA0\xA0\xA0',
	                              _react2.default.createElement(
	                                'span',
	                                { 'class': 'cursorpointer', onClick: function onClick() {
	                                    return _this3.discard(lead.id);
	                                  } },
	                                _react2.default.createElement('i', { 'class': 'fa fa-trash', title: 'Trash' })
	                              )
	                            )
	                          );
	                        }),
	                        leads.length == 0 && _react2.default.createElement(
	                          'tr',
	                          null,
	                          _react2.default.createElement(
	                            'td',
	                            { colSpan: '6' },
	                            'No data'
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'text-center' },
	                      _react2.default.createElement(_reactJsPagination2.default, {
	                        activePage: this.state.activePage,
	                        itemsCountPerPage: PER_PAGE,
	                        totalItemsCount: this.state.total,
	                        pageRangeDisplayed: 5,
	                        activeClass: "pagination__link--active",
	                        onChange: this.handlePageChange.bind(this),
	                        prevPageText: 'previous',
	                        nextPageText: 'next'
	                      })
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return leadList;
	}(_react.Component);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this4 = this;
	
	  this.getTotal = function (vertical) {
	    var location = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	    var _state$auth_data = _this4.state.auth_data,
	        login_id = _state$auth_data.login_id,
	        role = _state$auth_data.role;
	
	
	    var locationselected = location == '' ? _this4.state.location : location;
	
	    var ins = JSON.stringify({
	      vendor_id: login_id,
	      role: role,
	      vertical: vertical,
	      location: locationselected,
	      searchby: _this4.state.searchby
	    });
	
	    (0, _FetchCall.getTotalLeads)(ins).then(function (res) {
	
	      _this4.setState({ loading: true });
	
	      if (res.status == 1) {
	
	        _this4.setState({
	
	          total: res.total
	
	        });
	      }
	    });
	  };
	
	  this.getList = function () {
	    var pageNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	    var location = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	    var _state$auth_data2 = _this4.state.auth_data,
	        login_id = _state$auth_data2.login_id,
	        role = _state$auth_data2.role;
	
	
	    _this4.setState({ activePage: pageNumber });
	
	    var newOffset = pageNumber == 1 ? 0 : (pageNumber - 1) * _this4.state.PER_PAGE % _this4.state.total;
	
	    var locationselected = location == '' ? _this4.state.location : location;
	
	    var ins = JSON.stringify({
	      vendor_id: login_id,
	      role: role,
	      location: locationselected,
	      searchby: _this4.state.searchby,
	      perpage: _this4.state.PER_PAGE,
	      year: _this4.state.year,
	      month: _this4.state.month,
	      offset: newOffset
	    });
	
	    (0, _FetchCall.getLeads)(ins).then(function (res) {
	
	      _this4.setState({ loading: true });
	
	      if (res.status == 1) {
	
	        _this4.setState({ loading: !_this4.state.loading });
	
	        var newLeads = res.leads.map(function (lead) {
	          return {
	            "id": lead.id,
	            "firstname": lead.firstname,
	            "lastname": lead.lastname,
	            "vertical": lead.lead_vertical,
	            "searchkey": lead.searchkey,
	            "location": lead.location,
	            "city": lead.city,
	            "mobilenumber": lead.mobilenumber,
	            "ispartnersent": lead.ispartnersent,
	            "status": lead.lead_status,
	            "email": lead.email,
	            "createdAt": new Intl.DateTimeFormat('en-US', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).format(lead.created_date)
	          };
	        });
	
	        _this4.setState({ leads: newLeads });
	      } else {
	
	        _this4.setState({ loading: !_this4.state.loading });
	
	        _this4.setState({
	          leads: []
	        });
	      }
	    });
	  };
	};
	
	exports.default = leadList;

/***/ },
/* 949 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _FetchCall2 = _interopRequireDefault(_FetchCall);
	
	var _chart = __webpack_require__(83);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import { Editor } from '@tinymce/tinymce-react';
	
	
	var doughnutPieOptions = {
	    responsive: true,
	    animation: {
	        animateScale: true,
	        animateRotate: true
	    }
	};
	
	var leadStats = function (_Component) {
	    _inherits(leadStats, _Component);
	
	    function leadStats(props) {
	        _classCallCheck(this, leadStats);
	
	        var _this = _possibleConstructorReturn(this, (leadStats.__proto__ || Object.getPrototypeOf(leadStats)).call(this, props));
	
	        _this.handleChange = function (e) {
	            _this.setState(_defineProperty({}, e.target.name, e.target.value));
	        };
	
	        _this.setLeadChart_1 = function (data) {
	
	            var ctx = document.getElementById('chartitem_1');
	            var myChart = new _chart.Chart(ctx, {
	                type: 'doughnut',
	                data: data,
	                options: doughnutPieOptions
	            });
	
	            myChart.canvas.parentNode.style.width = '500px';
	        };
	
	        _this.setLeadChart_2 = function (data) {
	
	            var ctx = document.getElementById('chartitem_2');
	            var myChart = new _chart.Chart(ctx, {
	                type: 'doughnut',
	                data: data,
	                options: doughnutPieOptions
	            });
	
	            myChart.canvas.parentNode.style.width = '500px';
	        };
	
	        _this.state = {
	            textresults_quicklead: [],
	            textresults_direct: [],
	            totalAvgQ: 0,
	            totalAvgD: 0,
	            auth_data: JSON.parse(localStorage.getItem("user_data")),
	            user_data: localStorage.getItem('user_data') ? JSON.parse(localStorage.getItem('user_data')) : [],
	            authentication: localStorage.getItem('authentication') ? JSON.parse(localStorage.getItem('authentication')) : false
	        };
	
	        _this.showResults = _this.showResults.bind(_this);
	        _this.handleChange = _this.handleChange.bind(_this);
	
	        return _this;
	    }
	
	    _createClass(leadStats, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            var user_data = localStorage.getItem("user_data");
	            var auth_data = JSON.parse(user_data);
	            var vendor_id = auth_data.login_id;
	            var role = auth_data.role;
	            this.setState({ vendor_id: vendor_id, role: role });
	
	            var req_com = {
	                url: 'leadchartthru'
	            };
	
	            (0, _FetchCall.leadCharts)(JSON.stringify(req_com)).then(function (response) {
	                if (response.status === 1) {
	                    _this2.setLeadChart_1(response.result);
	                }
	            });
	
	            var req_com_sixmonths = {
	                url: 'leadcharts_by6months'
	            };
	
	            (0, _FetchCall.leadCharts)(JSON.stringify(req_com_sixmonths)).then(function (response) {
	                if (response.status === 1) {
	                    _this2.setLeadChart_2(response.result);
	                }
	            });
	
	            var req_com_quicklead = {
	                url: 'leadcharts_quickleads'
	            };
	            (0, _FetchCall.leadreportstext)(JSON.stringify(req_com_quicklead)).then(function (response) {
	                if (response.status === 1) {
	                    _this2.setState({ textresults_quicklead: response.result, totalAvgQ: response.totalAvgQ });
	                }
	            });
	
	            var req_com_direct = {
	                url: 'leadcharts_direct'
	            };
	            (0, _FetchCall.leadreportstext)(JSON.stringify(req_com_direct)).then(function (response) {
	                if (response.status === 1) {
	                    _this2.setState({ textresults_direct: response.result, totalAvgD: response.totalAvgD });
	                }
	            });
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            // window.jQuery('.selectpicker').selectpicker('refresh')
	        }
	    }, {
	        key: 'showResults',
	        value: function showResults() {
	            var _this3 = this;
	
	            var req_com_quicklead = {
	                url: 'leadcharts_quickleads',
	                fromDate: this.state.fromDate,
	                toDate: this.state.toDate
	            };
	            (0, _FetchCall.leadreportstext)(JSON.stringify(req_com_quicklead)).then(function (response) {
	                if (response.status === 1) {
	                    _this3.setState({ textresults_quicklead: response.result, totalAvgQ: response.totalAvgQ });
	                }
	            });
	
	            var req_com_direct = {
	                url: 'leadcharts_direct',
	                fromDate: this.state.fromDate,
	                toDate: this.state.toDate
	            };
	            (0, _FetchCall.leadreportstext)(JSON.stringify(req_com_direct)).then(function (response) {
	                if (response.status === 1) {
	                    _this3.setState({ textresults_direct: response.result, totalAvgD: response.totalAvgD });
	                }
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _state = this.state,
	                user_id = _state.user_id,
	                textresults_quicklead = _state.textresults_quicklead,
	                textresults_direct = _state.textresults_direct,
	                totalAvgQ = _state.totalAvgQ,
	                totalAvgD = _state.totalAvgD;
	
	
	            return _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _react2.default.createElement(
	                    _layout2.default,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { 'class': 'col-lg-12 grid-margin stretch-card' },
	                        _react2.default.createElement(
	                            'div',
	                            { 'class': 'card' },
	                            _react2.default.createElement(
	                                'div',
	                                { 'class': 'card-body' },
	                                _react2.default.createElement(
	                                    'h4',
	                                    { 'class': 'card-title' },
	                                    'Leads '
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'chartblock' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'chartitemflexed' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'chartblock_title' },
	                                            'Weekly Leads Statistics'
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'charblock_chart' },
	                                            _react2.default.createElement('canvas', { id: 'chartitem_1' })
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'chartitemflexed' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'chartblock_title' },
	                                            'Last 6 months Leads Statistics'
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'charblock_chart' },
	                                            _react2.default.createElement('canvas', { id: 'chartitem_2' })
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'avgstats' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'flexed-align-btm padding20' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'timeDateSelection' },
	                                            _react2.default.createElement(
	                                                'label',
	                                                null,
	                                                'Select From Date'
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { 'class': 'dateSelection' },
	                                                _react2.default.createElement('input', { type: 'date', name: 'fromDate', 'class': 'inputcls', onChange: this.handleChange })
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'timeDateSelection' },
	                                            _react2.default.createElement(
	                                                'label',
	                                                null,
	                                                'Select To Date'
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { 'class': 'dateSelection' },
	                                                _react2.default.createElement('input', { type: 'date', name: 'toDate', 'class': 'inputcls', onChange: this.handleChange })
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'timeDateSelection' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { 'class': 'dateSelection' },
	                                                _react2.default.createElement('input', { type: 'button', name: 'submit', 'class': 'btn btn-primary', value: 'GO', onClick: this.showResults })
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'textbasedReports' },
	                                        _react2.default.createElement(
	                                            'h3',
	                                            null,
	                                            'Leads Generated From using mini form (articles/verticals)'
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'titlelineup' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { 'class': 'itemlinedup-flexed-head' },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { 'class': 'itemvalue_lead_total' },
	                                                    _react2.default.createElement(
	                                                        'b',
	                                                        null,
	                                                        'Visit'
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { 'class': 'itemvalue_lead_type' },
	                                                    _react2.default.createElement(
	                                                        'b',
	                                                        null,
	                                                        'Page Type'
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { 'class': 'itemvalue_lead_from' },
	                                                    _react2.default.createElement(
	                                                        'b',
	                                                        null,
	                                                        'Page Link'
	                                                    )
	                                                )
	                                            )
	                                        ),
	                                        textresults_quicklead.map(function (item, index) {
	
	                                            return _react2.default.createElement(
	                                                'div',
	                                                { 'class': 'titlelineup' },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { 'class': 'itemlinedup-flexed' },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { 'class': 'itemvalue_lead_total' },
	                                                        item.total
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { 'class': 'itemvalue_lead_type' },
	                                                        item.pagetype
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { 'class': 'itemvalue_lead_from' },
	                                                        item.pagefrom,
	                                                        ' ',
	                                                        _react2.default.createElement(
	                                                            'a',
	                                                            { href: item.pagefrom, target: '_blank' },
	                                                            'view page'
	                                                        )
	                                                    )
	                                                )
	                                            );
	                                        })
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'textbasedReports' },
	                                        _react2.default.createElement(
	                                            'h3',
	                                            null,
	                                            'Leads Generated by clicking Links from Footers and Advertisements'
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'titlelineup' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { 'class': 'itemlinedup-flexed-head' },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { 'class': 'itemvalue_lead_total' },
	                                                    _react2.default.createElement(
	                                                        'b',
	                                                        null,
	                                                        'Visit'
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { 'class': 'itemvalue_lead_type' },
	                                                    _react2.default.createElement(
	                                                        'b',
	                                                        null,
	                                                        'Page Type'
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { 'class': 'itemvalue_lead_from' },
	                                                    _react2.default.createElement(
	                                                        'b',
	                                                        null,
	                                                        'Page Link'
	                                                    )
	                                                )
	                                            )
	                                        ),
	                                        textresults_direct.map(function (item, index) {
	
	                                            return _react2.default.createElement(
	                                                'div',
	                                                { 'class': 'titlelineup' },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { 'class': 'itemlinedup-flexed' },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { 'class': 'itemvalue_lead_total' },
	                                                        item.total
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { 'class': 'itemvalue_lead_type' },
	                                                        item.pagetype
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { 'class': 'itemvalue_lead_from' },
	                                                        item.pagefrom,
	                                                        ' ',
	                                                        _react2.default.createElement(
	                                                            'a',
	                                                            { href: item.pagefrom, target: '_blank' },
	                                                            'view page'
	                                                        )
	                                                    )
	                                                )
	                                            );
	                                        })
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return leadStats;
	}(_react.Component);
	
	exports.default = leadStats;

/***/ },
/* 950 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FetchCall = __webpack_require__(4);
	
	var _universalCookie = __webpack_require__(135);
	
	var _universalCookie2 = _interopRequireDefault(_universalCookie);
	
	var _reactRecaptcha = __webpack_require__(170);
	
	var _reactRecaptcha2 = _interopRequireDefault(_reactRecaptcha);
	
	var _constant = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LoginV2 = function (_Component) {
	    _inherits(LoginV2, _Component);
	
	    function LoginV2(props) {
	        _classCallCheck(this, LoginV2);
	
	        var cookies = new _universalCookie2.default();
	
	        var _this = _possibleConstructorReturn(this, (LoginV2.__proto__ || Object.getPrototypeOf(LoginV2)).call(this, props));
	
	        _this.recaptchaLoaded = function (e) {
	            console.log('Successfully loaded');
	        };
	
	        _this.verifyCallback = function (response) {
	            if (response) {
	                _this.setState({
	                    isVerified: true,
	                    disabled: false
	                });
	            }
	        };
	
	        _this.handleChange = function (e) {
	            _this.setState(_defineProperty({}, e.target.name, e.target.value));
	        };
	
	        _this.handleChangeOtp = function (e) {
	            _this.setState(_defineProperty({}, e.target.name, e.target.value.slice(0, e.target.maxLength)));
	        };
	
	        _this.handleSubmitLogin = function (e) {
	            e.preventDefault();
	
	            var ins = JSON.stringify({
	                email_id: _this.state.email_id,
	                password: _this.state.password
	            });
	            (0, _FetchCall.LoginBeWise)(ins).then(function (res) {
	                if (res.status === 1) {
	
	                    console.log(JSON.stringify(res.auth_data));
	
	                    localStorage.setItem('user_data', JSON.stringify(res.auth_data));
	                    localStorage.setItem('access', JSON.stringify(res.auth_data.access));
	
	                    localStorage.setItem('organisation', JSON.stringify(res.auth_data.organisation));
	                    localStorage.setItem('organisation_place', JSON.stringify(res.auth_data.organisation_place));
	
	                    localStorage.setItem('is_completed', res.auth_data.is_completd);
	                    localStorage.setItem('is_active', res.auth_data.is_active);
	                    localStorage.setItem('show_pop', res.auth_data.current_plan === 0 ? true : false);
	                    localStorage.setItem('authentication', true);
	                    _this.setState({ logged: true, nouser: false, role: res.auth_data.role === 1 ? "Administrator" : res.auth_data.role === 3 ? "Partner" : "BeWise Team" });
	
	                    if (res.auth_data.role === 3) {
	
	                        setTimeout(function () {
	                            window.location.replace("/partner/dashboard");
	                        }, 1000);
	                    } else if (res.auth_data.role === 11) {
	
	                        setTimeout(function () {
	                            window.location.replace("/exclusiveparnter/dashboard");
	                        }, 1000);
	                    } else {
	                        setTimeout(function () {
	                            window.location.replace("/dashboard/dashboard");
	                        }, 1000);
	                    }
	                } else {
	                    var error_mgs = res.msg;
	                    _this.setState({ nouser: true, msg: error_mgs });
	                }
	            });
	        };
	
	        _this.state = {
	            email_id: '',
	            password: '',
	            otp: '',
	            verify_otp: true,
	            auth_data: '',
	            user_id: '',
	            logged: false,
	            phone_number: '',
	            isVerified: false,
	            showPassword: false,
	            disabled: true,
	            role: "",
	            otp_check: cookies.get('otpVerified') ? cookies.get('otpVerified') : false
	        };
	        _this.recaptchaLoaded = _this.recaptchaLoaded.bind(_this);
	        _this.verifyCallback = _this.verifyCallback.bind(_this);
	        return _this;
	    }
	
	    _createClass(LoginV2, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var logged = localStorage.getItem("authentication");
	            var auth_data = JSON.parse(localStorage.getItem("user_data"));
	            console.log('auth_data.role', logged);
	
	            if (logged === 'true' && auth_data !== 'null' && auth_data.role === 1) {
	                window.location.href = '/dashboard/dashboard';
	            } else if (logged === 'true' && auth_data !== 'null' && auth_data.role === 3) {
	                window.location.href = '/partner/profile';
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	
	            return _react2.default.createElement(
	                'div',
	                { 'class': 'container-fluid page-body-wrapper full-page-wrapper' },
	                _react2.default.createElement(
	                    'div',
	                    { 'class': 'content-wrapper d-flex align-items-center auth px-0' },
	                    _react2.default.createElement(
	                        'div',
	                        { 'class': 'row w-100 mx-0' },
	                        _react2.default.createElement(
	                            'div',
	                            { 'class': 'col-lg-4 mx-auto' },
	                            _react2.default.createElement(
	                                'div',
	                                { 'class': 'auth-form-light text-left py-5 px-4 px-sm-5' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'brand-logo' },
	                                    _react2.default.createElement('img', { src: '../../images/bewiseLogo.png', alt: 'BeWise Logo' })
	                                ),
	                                _react2.default.createElement(
	                                    'h4',
	                                    null,
	                                    'Hello! let\'s get started'
	                                ),
	                                _react2.default.createElement(
	                                    'h6',
	                                    { 'class': 'font-weight-light' },
	                                    'Sign in to continue.'
	                                ),
	                                _react2.default.createElement(
	                                    'form',
	                                    { 'class': 'pt-3', onSubmit: this.handleSubmitLogin, autoComplete: 'off', className: 'login-form', action: '#' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'form-group' },
	                                        _react2.default.createElement('input', { type: 'email', name: 'email_id', 'class': 'form-control form-control-lg', id: 'email_id', placeholder: 'Email Id', onChange: this.handleChange })
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'form-group' },
	                                        _react2.default.createElement('input', { type: 'password', name: 'password', 'class': 'form-control form-control-lg', id: 'password', placeholder: 'Password', onChange: this.handleChange })
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'form-group' },
	                                        _react2.default.createElement(_reactRecaptcha2.default, {
	                                            sitekey: _constant.GOOGLE_CAPTCHA_SITE_KEY,
	                                            render: 'explicit',
	                                            onloadCallback: this.recaptchaLoaded,
	                                            verifyCallback: this.verifyCallback
	                                        })
	                                    ),
	                                    !this.state.nouser && this.state.logged && _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'alert alert-success', role: 'alert' },
	                                        'Successful. You are logged in as ',
	                                        this.state.role
	                                    ),
	                                    this.state.nouser && _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'alert alert-danger', role: 'alert' },
	                                        this.state.msg
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'mt-3' },
	                                        _react2.default.createElement(
	                                            'button',
	                                            { type: 'submit', className: 'btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn' },
	                                            'SIGN IN'
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'my-2 d-flex justify-content-between align-items-center' },
	                                        _react2.default.createElement('div', { 'class': 'form-check' }),
	                                        _react2.default.createElement(
	                                            'a',
	                                            { href: '/forgot', 'class': 'auth-link text-black' },
	                                            'Forgot password?'
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return LoginV2;
	}(_react.Component);
	
	exports.default = LoginV2;

/***/ },
/* 951 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FetchCall = __webpack_require__(4);
	
	var _universalCookie = __webpack_require__(135);
	
	var _universalCookie2 = _interopRequireDefault(_universalCookie);
	
	var _reactRecaptcha = __webpack_require__(170);
	
	var _reactRecaptcha2 = _interopRequireDefault(_reactRecaptcha);
	
	var _constant = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LoginV2 = function (_Component) {
	    _inherits(LoginV2, _Component);
	
	    function LoginV2(props) {
	        _classCallCheck(this, LoginV2);
	
	        var cookies = new _universalCookie2.default();
	
	        var _this = _possibleConstructorReturn(this, (LoginV2.__proto__ || Object.getPrototypeOf(LoginV2)).call(this, props));
	
	        _this.recaptchaLoaded = function (e) {
	            console.log('Successfully loaded');
	        };
	
	        _this.verifyCallback = function (response) {
	            if (response) {
	                _this.setState({
	                    isVerified: true,
	                    disabled: false
	                });
	            }
	        };
	
	        _this.handleChange = function (e) {
	            _this.setState(_defineProperty({}, e.target.name, e.target.value));
	        };
	
	        _this.handleChangeOtp = function (e) {
	            _this.setState(_defineProperty({}, e.target.name, e.target.value.slice(0, e.target.maxLength)));
	        };
	
	        _this.handleSubmitLogin = function (e) {
	            e.preventDefault();
	
	            var ins = JSON.stringify({
	                email_id: _this.state.email_id,
	                password: _this.state.password
	            });
	            (0, _FetchCall.LoginBeWise)(ins).then(function (res) {
	                if (res.status === 1) {
	
	                    console.log(JSON.stringify(res.auth_data));
	
	                    localStorage.setItem('user_data', JSON.stringify(res.auth_data));
	                    localStorage.setItem('access', JSON.stringify(res.auth_data.access));
	
	                    localStorage.setItem('organisation', JSON.stringify(res.auth_data.organisation));
	                    localStorage.setItem('organisation_place', JSON.stringify(res.auth_data.organisation_place));
	
	                    localStorage.setItem('is_completed', res.auth_data.is_completd);
	                    localStorage.setItem('is_active', res.auth_data.is_active);
	                    localStorage.setItem('show_pop', res.auth_data.current_plan === 0 ? true : false);
	                    localStorage.setItem('authentication', true);
	                    _this.setState({ logged: true, nouser: false, role: res.auth_data.role === 1 ? "Administrator" : res.auth_data.role === 3 ? "Partner" : "BeWise Team" });
	
	                    if (res.auth_data.role === 3) {
	
	                        setTimeout(function () {
	                            window.location.replace("/partner/dashboard");
	                        }, 1000);
	                    } else if (res.auth_data.role === 11) {
	
	                        setTimeout(function () {
	                            window.location.replace("/exclusiveparnter/dashboard");
	                        }, 1000);
	                    } else {
	                        setTimeout(function () {
	                            window.location.replace("/dashboard/dashboard");
	                        }, 1000);
	                    }
	                } else {
	                    var error_mgs = res.msg;
	                    _this.setState({ nouser: true, msg: error_mgs });
	                }
	            });
	        };
	
	        _this.state = {
	            email_id: '',
	            password: '',
	            otp: '',
	            verify_otp: true,
	            auth_data: '',
	            user_id: '',
	            logged: false,
	            phone_number: '',
	            isVerified: false,
	            showPassword: false,
	            disabled: true,
	            role: "",
	            otp_check: cookies.get('otpVerified') ? cookies.get('otpVerified') : false
	        };
	        _this.recaptchaLoaded = _this.recaptchaLoaded.bind(_this);
	        _this.verifyCallback = _this.verifyCallback.bind(_this);
	        return _this;
	    }
	
	    _createClass(LoginV2, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var logged = localStorage.getItem("authentication");
	            var auth_data = JSON.parse(localStorage.getItem("user_data"));
	            console.log('auth_data.role', logged);
	
	            if (logged === 'true' && auth_data !== 'null' && auth_data.role === 1) {
	                window.location.href = '/dashboard/dashboard';
	            } else if (logged === 'true' && auth_data !== 'null' && auth_data.role === 3) {
	                window.location.href = '/partner/profile';
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	
	            return _react2.default.createElement(
	                'div',
	                { 'class': 'container-fluid page-body-wrapper full-page-wrapper' },
	                _react2.default.createElement(
	                    'div',
	                    { 'class': 'content-wrapper d-flex align-items-center auth px-0' },
	                    _react2.default.createElement(
	                        'div',
	                        { 'class': 'row w-100 mx-0' },
	                        _react2.default.createElement(
	                            'div',
	                            { 'class': 'col-lg-4 mx-auto' },
	                            _react2.default.createElement(
	                                'div',
	                                { 'class': 'auth-form-light text-left py-5 px-4 px-sm-5' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'brand-logo' },
	                                    _react2.default.createElement('img', { src: '../../images/bewiseLogo.png', alt: 'BeWise Logo' })
	                                ),
	                                _react2.default.createElement(
	                                    'h4',
	                                    null,
	                                    'Hello! let\'s get started'
	                                ),
	                                _react2.default.createElement(
	                                    'h6',
	                                    { 'class': 'font-weight-light' },
	                                    'Sign in to continue.'
	                                ),
	                                _react2.default.createElement(
	                                    'form',
	                                    { 'class': 'pt-3', onSubmit: this.handleSubmitLogin, autoComplete: 'off', className: 'login-form', action: '#' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'form-group' },
	                                        _react2.default.createElement('input', { type: 'email', name: 'email_id', 'class': 'form-control form-control-lg', id: 'email_id', placeholder: 'Email Id', onChange: this.handleChange })
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'form-group' },
	                                        _react2.default.createElement('input', { type: 'password', name: 'password', 'class': 'form-control form-control-lg', id: 'password', placeholder: 'Password', onChange: this.handleChange })
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'form-group' },
	                                        _react2.default.createElement(_reactRecaptcha2.default, {
	                                            sitekey: _constant.GOOGLE_CAPTCHA_SITE_KEY,
	                                            render: 'explicit',
	                                            onloadCallback: this.recaptchaLoaded,
	                                            verifyCallback: this.verifyCallback
	                                        })
	                                    ),
	                                    !this.state.nouser && this.state.logged && _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'alert alert-success', role: 'alert' },
	                                        'Successful. You are logged in as ',
	                                        this.state.role
	                                    ),
	                                    this.state.nouser && _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'alert alert-danger', role: 'alert' },
	                                        this.state.msg
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'mt-3' },
	                                        _react2.default.createElement(
	                                            'button',
	                                            { type: 'submit', className: 'btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn' },
	                                            'SIGN IN'
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'my-2 d-flex justify-content-between align-items-center' },
	                                        _react2.default.createElement('div', { 'class': 'form-check' }),
	                                        _react2.default.createElement(
	                                            'a',
	                                            { href: '/forgot_excl', 'class': 'auth-link text-black' },
	                                            'Forgot password?'
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return LoginV2;
	}(_react.Component);
	
	exports.default = LoginV2;

/***/ },
/* 952 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NotFound = function (_Component) {
	    _inherits(NotFound, _Component);
	
	    function NotFound() {
	        _classCallCheck(this, NotFound);
	
	        return _possibleConstructorReturn(this, (NotFound.__proto__ || Object.getPrototypeOf(NotFound)).apply(this, arguments));
	    }
	
	    _createClass(NotFound, [{
	        key: "render",
	        value: function render() {
	
	            return _react2.default.createElement(
	                "div",
	                { "class": "notfound" },
	                "404 Page not found"
	            );
	        }
	    }]);
	
	    return NotFound;
	}(_react.Component);
	
	exports.default = NotFound;

/***/ },
/* 953 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _bewiseloading = __webpack_require__(48);
	
	var _bewiseloading2 = _interopRequireDefault(_bewiseloading);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import Partnerlayout from './Partnerlayout';
	
	
	var parentDetail = function (_Component) {
	    _inherits(parentDetail, _Component);
	
	    function parentDetail(props) {
	        _classCallCheck(this, parentDetail);
	
	        var _this = _possibleConstructorReturn(this, (parentDetail.__proto__ || Object.getPrototypeOf(parentDetail)).call(this, props));
	
	        _this.state = {
	            user_id: _this.props.match.params.id,
	            child_data: []
	        };
	        return _this;
	    }
	
	    _createClass(parentDetail, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            var userinfo = JSON.stringify({
	                user_id: this.state.user_id
	            });
	
	            (0, _FetchCall.getUserInfo)(userinfo).then(function (response) {
	                if (response.status == 1) {
	                    var data = response.results[0];
	                    _this2.setState({
	                        first_name: data.first_name,
	                        last_name: data.last_name,
	                        email_id: data.email_id,
	                        mobile_no: data.mobile_no,
	                        child_name: data.child_name,
	                        age: data.child_age,
	                        user_type: data.login_type,
	                        child_data: data.child_data
	                    });
	                } else {
	                    console.log(response.status);
	                }
	            });
	        }
	    }, {
	        key: 'UNSAFE_componentWillMount',
	        value: function UNSAFE_componentWillMount() {}
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {}
	    }, {
	        key: 'render',
	        value: function render() {
	
	            return _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _react2.default.createElement(
	                    _layout2.default,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { 'class': 'row' },
	                        _react2.default.createElement(
	                            'div',
	                            { 'class': 'col-md-12' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'content-top col-md-12 col-xs-12' },
	                                _react2.default.createElement(
	                                    'h3',
	                                    null,
	                                    'Partner Info'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-12 col-xs-12' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'partnerinfoclass' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { id: 'company-info', className: 'tab-pane active' },
	                                        _react2.default.createElement(
	                                            'form',
	                                            { className: 'custom-form invoice-form col-md-12 col-xs-12 legend-form pad-no' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'box-shadow-custom' },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'row' },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'form-group col-md-4' },
	                                                        _react2.default.createElement(
	                                                            'label',
	                                                            null,
	                                                            'First Name'
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'p',
	                                                            { className: 'p14' },
	                                                            this.state.first_name
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'form-group col-md-4' },
	                                                        _react2.default.createElement(
	                                                            'label',
	                                                            null,
	                                                            'Last Name'
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'p',
	                                                            { className: 'p14' },
	                                                            this.state.last_name
	                                                        )
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'row' },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'form-group col-md-4' },
	                                                        _react2.default.createElement(
	                                                            'label',
	                                                            null,
	                                                            'Email Id'
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'p',
	                                                            { className: 'p14' },
	                                                            _react2.default.createElement(
	                                                                'a',
	                                                                { mailto: '#' },
	                                                                this.state.email_id
	                                                            )
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'form-group col-md-4' },
	                                                        _react2.default.createElement(
	                                                            'label',
	                                                            null,
	                                                            'Mobile Number'
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'p',
	                                                            { className: 'p14' },
	                                                            this.state.mobile_no
	                                                        )
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'row' },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'form-group col-md-12' },
	                                                        _react2.default.createElement(
	                                                            'label',
	                                                            null,
	                                                            'Child Details'
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'table',
	                                                            { className: 'table' },
	                                                            _react2.default.createElement(
	                                                                'thead',
	                                                                null,
	                                                                _react2.default.createElement(
	                                                                    'tr',
	                                                                    null,
	                                                                    _react2.default.createElement(
	                                                                        'td',
	                                                                        null,
	                                                                        'Name'
	                                                                    ),
	                                                                    _react2.default.createElement(
	                                                                        'td',
	                                                                        null,
	                                                                        'Age'
	                                                                    ),
	                                                                    _react2.default.createElement(
	                                                                        'td',
	                                                                        null,
	                                                                        'City'
	                                                                    ),
	                                                                    _react2.default.createElement(
	                                                                        'td',
	                                                                        null,
	                                                                        'School'
	                                                                    )
	                                                                )
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'thead',
	                                                                null,
	                                                                this.state.child_data.map(function (items, i) {
	                                                                    return _react2.default.createElement(
	                                                                        'tr',
	                                                                        null,
	                                                                        _react2.default.createElement(
	                                                                            'td',
	                                                                            null,
	                                                                            items.child_name ? items.child_name : '-'
	                                                                        ),
	                                                                        _react2.default.createElement(
	                                                                            'td',
	                                                                            null,
	                                                                            items.child_age ? items.child_age : '-'
	                                                                        ),
	                                                                        _react2.default.createElement(
	                                                                            'td',
	                                                                            null,
	                                                                            items.child_city ? items.child_city : '-'
	                                                                        ),
	                                                                        _react2.default.createElement(
	                                                                            'td',
	                                                                            null,
	                                                                            items.child_scl ? items.child_scl : '-'
	                                                                        )
	                                                                    );
	                                                                })
	                                                            )
	                                                        )
	                                                    )
	                                                )
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return parentDetail;
	}(_react.Component);
	
	exports.default = parentDetail;

/***/ },
/* 954 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _reactstrap = __webpack_require__(17);
	
	var _FetchCall = __webpack_require__(4);
	
	var _FetchCall2 = _interopRequireDefault(_FetchCall);
	
	var _reactJsPagination = __webpack_require__(33);
	
	var _reactJsPagination2 = _interopRequireDefault(_reactJsPagination);
	
	var _bewiseloading = __webpack_require__(48);
	
	var _bewiseloading2 = _interopRequireDefault(_bewiseloading);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import { Editor } from '@tinymce/tinymce-react';
	
	//import Pagination from 'rc-pagination';
	
	var parentList = function (_Component) {
	  _inherits(parentList, _Component);
	
	  function parentList(props) {
	    _classCallCheck(this, parentList);
	
	    var _this = _possibleConstructorReturn(this, (parentList.__proto__ || Object.getPrototypeOf(parentList)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var url = new URL(window.location.href);
	    var location = url.searchParams.get("location");
	    var auth_data = JSON.parse(localStorage.getItem("user_data"));
	    _this.state = {
	      confirmModal: false,
	      logged: localStorage.getItem("authentication"),
	      auth_data: JSON.parse(localStorage.getItem("user_data")),
	      location: localStorage.getItem("location") ? localStorage.getItem("location") : 'Bengaluru',
	      parentList: [],
	      exportbtndisabled: false,
	      thisExportBtnText: 'Export',
	      PER_PAGE: 15,
	      total: 0,
	      loading: true,
	      searchby: '',
	      activePage: 0,
	      offset: 0,
	      monthList: [{ no: 1, mon: 'Jan' }, { no: 2, mon: 'Feb' }, { no: 3, mon: 'Mar' }, { no: 4, mon: 'Apr' }, { no: 5, mon: 'May' }, { no: 6, mon: 'Jun' }, { no: 7, mon: 'Jul' }, { no: 8, mon: 'Aug' }, { no: 9, mon: 'Sep' }, { no: 10, mon: 'Oct' }, { no: 11, mon: 'Nov' }, { no: 12, mon: 'Dec' }]
	    };
	
	    return _this;
	  }
	
	  _createClass(parentList, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	
	      var THIS = this;
	
	      (0, _jquery2.default)(document).on('click', '.remove_user', function () {
	        var delete_id = (0, _jquery2.default)(this).data("id");
	        THIS.setState({
	          delete_id: delete_id
	        });
	        THIS.deletUser(delete_id);
	      });
	      (0, _jquery2.default)(document).on('click', '.activate_user', function () {
	        var add_id = (0, _jquery2.default)(this).data("id");
	        THIS.setState({
	          add_id: add_id
	        });
	        THIS.activateUser(add_id);
	      });
	
	      (0, _jquery2.default)(document).on('click', '.sendotp_user', function () {
	        var add_id = (0, _jquery2.default)(this).data("id");
	
	        THIS.sendOTPUser(add_id);
	      });
	
	      this.getTotal('parents');
	      this.getList();
	    }
	  }, {
	    key: 'sendOTPUser',
	    value: function sendOTPUser() {
	      var add_id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	      alert("OTP sent");
	    }
	  }, {
	    key: 'activateUser',
	    value: function activateUser() {
	      var add_id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	      if (confirm("Are you sure to Activate this user?") === true) {
	        var ins = JSON.stringify({
	          id: add_id,
	          type: 4
	        });
	        (0, _FetchCall.activateUser)(ins).then(function (res) {
	          var toastr = '';
	          if (res.status === 1) {
	            alert("Activated");
	            setTimeout(function () {
	              window.location.reload();
	            }, 2000);
	          } else {
	            alert("Error!");
	          }
	        });
	      }
	    }
	  }, {
	    key: 'deletUser',
	    value: function deletUser() {
	      var delete_id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	      if (confirm("Are you sure to Deactivate this user?") === true) {
	        var ins = JSON.stringify({
	          id: delete_id,
	          type: 4
	        });
	        (0, _FetchCall.deactivateUser)(ins).then(function (res) {
	
	          if (res.status === 1) {
	            alert("Deactivated");
	            setTimeout(function () {
	              window.location.reload();
	            }, 2000);
	          } else {
	            alert("Error removing");
	          }
	        });
	      }
	    }
	  }, {
	    key: 'handlePageChange',
	    value: function handlePageChange(pageNumber) {
	
	      console.log('active page is ' + pageNumber);
	
	      this.setState({ activePage: pageNumber });
	
	      //this.getTotal('bw_schools');
	      this.getList(pageNumber);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          parentList = _state.parentList,
	          exportbtndisabled = _state.exportbtndisabled;
	      var _state2 = this.state,
	          currentPage = _state2.currentPage,
	          PER_PAGE = _state2.PER_PAGE,
	          totalCount = _state2.totalCount,
	          total = _state2.total;
	
	      var year = 2019;
	      var years = Array.from(new Array(10), function (val, index) {
	        return index + year;
	      });
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'col-lg-12 grid-margin stretch-card' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card-body' },
	                _react2.default.createElement(
	                  'h4',
	                  { 'class': 'card-title' },
	                  'Parents'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'float-right' },
	                  '\xA0',
	                  _react2.default.createElement(
	                    'button',
	                    { disabled: exportbtndisabled, 'class': 'btn btn-primary btn-sm', onClick: function onClick() {
	                        return _this2.exportExcel();
	                      } },
	                    this.state.thisExportBtnText
	                  ),
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'p',
	                  { 'class': 'card-description' },
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'cityselection' },
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'leftaligned' },
	                      _react2.default.createElement(
	                        'select',
	                        { name: 'location', 'class': 'form-control', onChange: function onChange(e) {
	                            return _this2.handleChangeN(e);
	                          },
	                          value: this.state.location },
	                        _react2.default.createElement(
	                          'option',
	                          { value: '' },
	                          'select city'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'Bengaluru' },
	                          'Bengaluru'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'Chennai' },
	                          'Chennai'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'Indore' },
	                          'Indore'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'Hosur' },
	                          'Hosur'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'Coimbatore' },
	                          'Coimbatore'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'Madurai' },
	                          'Madurai'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'Mysore' },
	                          'Mysore'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'Mumbai' },
	                          'Mumbai'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'Kolkata' },
	                          'Kolkata'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'New Delhi' },
	                          'New Delhi'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'Jaipur' },
	                          'Jaipur'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'Chandigarh' },
	                          'Chandigarh'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'Pune' },
	                          'Pune'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'Kochi' },
	                          'Kochi'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'Indore' },
	                          'Indore'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'Noida' },
	                          'Noida'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'Agra' },
	                          'Agra'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'Puducherry' },
	                          'Puducherry'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'Tiruchirappalli' },
	                          'Tiruchirappalli'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'leftaligned' },
	                      _react2.default.createElement(
	                        'select',
	                        { className: 'form-control selectpicker', onChange: this.handleChangeN,
	                          name: 'year', title: 'Select Years', value: this.state.year },
	                        _react2.default.createElement(
	                          'option',
	                          { value: '' },
	                          'Select Year'
	                        ),
	                        years.map(function (item, i) {
	                          return _react2.default.createElement(
	                            'option',
	                            { value: item },
	                            item
	                          );
	                        })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'leftaligned' },
	                      _react2.default.createElement(
	                        'select',
	                        { className: 'form-control selectpicker', onChange: this.handleChangeN,
	                          name: 'month', title: 'Select Month', value: this.state.month },
	                        _react2.default.createElement(
	                          'option',
	                          { value: '' },
	                          'Select Month'
	                        ),
	                        this.state.monthList.map(function (item, i) {
	                          return _react2.default.createElement(
	                            'option',
	                            { value: item.no },
	                            item.mon
	                          );
	                        })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'leftaligned' },
	                      _react2.default.createElement(
	                        'button',
	                        { 'class': 'btn btn-primary btn-sm', onClick: this.filterShow },
	                        'show'
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'table-responsive pt-3' },
	                  _react2.default.createElement(
	                    'table',
	                    { id: 'tablebw' },
	                    _react2.default.createElement(
	                      'thead',
	                      { 'class': 'thead-dark' },
	                      _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'S.No'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Update Date'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'First Name'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Last Name'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Email Id'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Mobile number'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'City'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Status'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Action'
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'tbody',
	                      null,
	                      parentList.map(function (item, i) {
	
	                        return _react2.default.createElement(
	                          'tr',
	                          null,
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            i + 1
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.created_date
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.first_name
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.last_name
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.email_id
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.mobile_no
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.city
	                          ),
	                          _react2.default.createElement('td', { dangerouslySetInnerHTML: { __html: item.status } }),
	                          _react2.default.createElement('td', { dangerouslySetInnerHTML: { __html: item.action } })
	                        );
	                      }),
	                      parentList.length == 0 && _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                          'td',
	                          { colspan: '9' },
	                          'No data'
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'text-center' },
	                    _react2.default.createElement(_reactJsPagination2.default, {
	                      activePage: this.state.activePage,
	                      itemsCountPerPage: PER_PAGE,
	                      totalItemsCount: this.state.total,
	                      pageRangeDisplayed: 5,
	                      activeClass: "pagination__link--active",
	                      onChange: this.handlePageChange.bind(this),
	                      prevPageText: 'previous',
	                      nextPageText: 'next'
	                    })
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return parentList;
	}(_react.Component);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this3 = this;
	
	  this.getTotal = function (vertical) {
	    var location = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	
	    var locationselected = location == '' ? _this3.state.location : location;
	
	    var ins = JSON.stringify({
	      vertical: vertical,
	      location: locationselected,
	      searchby: _this3.state.searchby
	    });
	
	    (0, _FetchCall.getTotalParents)(ins).then(function (res) {
	
	      _this3.setState({ loading: true });
	
	      if (res.status == 1) {
	
	        _this3.setState({
	
	          total: res.total
	
	        });
	      }
	    });
	  };
	
	  this.handleChangeN = function (e) {
	    _this3.setState(_defineProperty({}, e.target.name, e.target.value));
	  };
	
	  this.filterShow = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	    var _state$auth_data, login_id, role, ins;
	
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            _state$auth_data = _this3.state.auth_data, login_id = _state$auth_data.login_id, role = _state$auth_data.role;
	            ins = JSON.stringify({
	              login_id: login_id,
	              role: role,
	              location: _this3.state.location,
	              year: _this3.state.year,
	              month: _this3.state.month
	            });
	
	            (0, _FetchCall.getParentsPaged)(ins).then(function (res) {
	              if (res.status == 1) {
	                _this3.setState({
	                  parentList: res.user_list
	
	                });
	              } else {
	                _this3.setState({
	                  parentList: []
	                });
	              }
	            });
	
	          case 3:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, _this3);
	  }));
	
	  this.exportExcel = function (e) {
	    _this3.userExport();
	  };
	
	  this.userExport = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	    var req, res;
	    return _regenerator2.default.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            _context2.prev = 0;
	            req = JSON.stringify({
	              location: _this3.state.location,
	              year: _this3.state.year,
	              month: _this3.state.month
	            });
	            _context2.next = 4;
	            return (0, _FetchCall.userExport)(req);
	
	          case 4:
	            res = _context2.sent;
	
	            if (res.status == 1) {
	              window.open(res.path);
	              // window.location.href(res.path)
	            }
	            _context2.next = 11;
	            break;
	
	          case 8:
	            _context2.prev = 8;
	            _context2.t0 = _context2['catch'](0);
	
	            _this3.setState({ error: true });
	
	          case 11:
	          case 'end':
	            return _context2.stop();
	        }
	      }
	    }, _callee2, _this3, [[0, 8]]);
	  }));
	
	  this.getList = function () {
	    var pageNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	    var location = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	    var _state$auth_data2 = _this3.state.auth_data,
	        login_id = _state$auth_data2.login_id,
	        role = _state$auth_data2.role;
	
	
	    _this3.setState({ activePage: pageNumber });
	
	    var newOffset = pageNumber == 1 ? 0 : (pageNumber - 1) * _this3.state.PER_PAGE % _this3.state.total;
	
	    var locationselected = location == '' ? _this3.state.location : location;
	
	    var ins = JSON.stringify({
	      vendor_id: login_id,
	      role: role,
	      location: locationselected,
	      searchby: _this3.state.searchby,
	      perpage: _this3.state.PER_PAGE,
	      year: _this3.state.year,
	      month: _this3.state.month,
	      offset: newOffset
	    });
	
	    (0, _FetchCall.getParentsPaged)(ins).then(function (res) {
	
	      _this3.setState({ loading: true });
	
	      if (res.status == 1) {
	
	        _this3.setState({ loading: !_this3.state.loading });
	
	        _this3.setState({
	
	          parentList: res.user_list
	
	        });
	      } else {
	
	        _this3.setState({ loading: !_this3.state.loading });
	
	        _this3.setState({
	          parentList: []
	        });
	      }
	    });
	  };
	};
	
	exports.default = parentList;

/***/ },
/* 955 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _bewiseloading = __webpack_require__(48);
	
	var _bewiseloading2 = _interopRequireDefault(_bewiseloading);
	
	var _FetchCall = __webpack_require__(4);
	
	__webpack_require__(18);
	
	var _reactNotifications = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import Partnerlayout from './Partnerlayout';
	
	
	var partnerDetail = function (_Component) {
	  _inherits(partnerDetail, _Component);
	
	  function partnerDetail(props) {
	    _classCallCheck(this, partnerDetail);
	
	    var _this = _possibleConstructorReturn(this, (partnerDetail.__proto__ || Object.getPrototypeOf(partnerDetail)).call(this, props));
	
	    _this.getCurrentPlanList = function () {
	      var insdata = JSON.stringify({
	        user_type: 1,
	        partner_id: _this.state.login_id,
	        role: 3,
	        url: 'getPartnerPlanV1'
	      });
	      (0, _FetchCall.partnerSubscription)(insdata).then(function (response) {
	        if (response.status === 1) {
	          console.log("RR", response);
	          _this.setState({
	            package_list: response.plan_list,
	            upgradeList: response.upgrade_list,
	            cgst_per: response.tax_data.cgst,
	            sgst_per: response.tax_data.sgst,
	            coupon_id: response.coupon_data.coupon_id,
	            coupon_per_or: response.coupon_data.coupon_per,
	            coupon_amount_or: response.coupon_data.coupon_amount,
	            partner_name: response.partner.name, partner_email: response.partner.email, partner_address: response.partner.address
	          });
	        }
	      });
	    };
	
	    _this.updatePrice = function (e) {
	
	      var propName = e.target.name;
	      _this.setState(_defineProperty({}, e.target.name, e.target.value));
	
	      var optbannerprice = e.target.value;
	      var sub_total = _this.state.sub_total;
	      console.log(optbannerprice);
	      console.log(sub_total);
	      var total = sub_total + parseFloat(optbannerprice);
	      _this.setState({
	        total: total
	      });
	    };
	
	    _this.showprice = function (e) {
	
	      var value = e.target.value;
	      //console.log(value);
	      //var value = this.state.nplan_id;
	      console.log(value);
	      console.log(_this.state.planlist[value]);
	      var data = _this.state.planlist;
	      var plan_name = data[value].plan_name;
	      var plan_id = data[value].id;
	      var period = _this.state.period;
	
	      if (period == 183) {
	        // base_price = parseFloat(temp) > 0 ? parseFloat(data[0].base_price) + 1 : parseFloat(data[0].base_price);
	        var plan_price = data[value].price_six;
	        var sub_total = data[value].price_six;
	        var total = data[value].price_six;
	      } else {
	        var plan_price = data[value].base_price;
	        var sub_total = data[value].base_price;
	        var total = data[value].base_price;
	      }
	
	      //var plan_price = data[value].base_price;
	      //var sub_total = data[value].base_price;
	      //var total = data[value].base_price;
	      var discount = data[value].discount_amount;
	
	      var req = JSON.stringify({
	        vendor_id: _this.state.vendor_id
	      });
	
	      (0, _FetchCall.getDiscountNew)(req).then(function (res) {
	
	        console.log(res);
	
	        if (res.status === 1) {
	          var discnt = parseInt(res.data[0].discount);
	        } else {
	          var discnt = 0;
	        }
	
	        if (discnt > 0) {
	
	          discount = plan_price * (discnt / 100);
	          total = plan_price - discount;
	        }
	
	        if (_this.state.optbanners == 'yes') {
	          var costofbanners = parseInt(_this.state.optbannerprice);
	          total = total + costofbanners;
	        }
	
	        _this.setState({
	          showprice: true,
	          discount_amount: discount,
	          discount_per: discnt,
	          discount: discount,
	          plan_name: plan_name,
	          plan_id: plan_id,
	          plan_price: plan_price,
	          sub_total: sub_total,
	          total: total
	        });
	      });
	    };
	
	    _this.getStampList = function () {
	      var req = JSON.stringify({
	        url: 'getStampList'
	      });
	      (0, _FetchCall.adminUser)(req).then(function (res) {
	        if (res.status === 1) {
	          _this.setState({
	            stamp_list: res.list
	          });
	        }
	      });
	    };
	
	    _this.importSchool = function () {
	      window.$("#import-modal").modal("show");
	    };
	
	    _this.handleChange = function (e) {
	      var propName = e.target.name;
	      _this.setState(_defineProperty({}, e.target.name, e.target.value));
	      if (propName == 'optbanners' && e.target.value == 'no') {
	        _this.setState({ opener: false });
	      } else {
	        _this.setState({ opener: true });
	        //this.showprice();
	      }
	      _this.clearValidationErr(propName);
	    };
	
	    _this.handleRejectSubmit = function (e) {
	      e.preventDefault();
	
	      if (_this.state.reject_reason != "") {
	        var userinfo = JSON.stringify({
	          set_id: _this.state.set_id,
	          vendor_id: _this.state.vendor_id,
	          login_id: _this.state.login_id,
	          category_id: _this.state.category_id,
	          email_id: _this.state.email_id,
	          reject_reason: _this.state.reject_reason
	        });
	
	        (0, _FetchCall.rejectVendorInfo)(userinfo).then(function (response) {
	          var toastr = "";
	          if (response.status == 1) {
	
	            _reactNotifications.NotificationManager.success('Success');
	
	            setTimeout(function () {
	              window.location.replace("/users/partners");
	            }, 1000);
	          } else {
	
	            _reactNotifications.NotificationManager.error(response.errors[0].msg);
	          }
	        });
	      } else {
	        if (_this.state.reject_reason == "") {
	          _this.showValidationErr("reject_reason", "Enter Reason for Reject");
	        }
	      }
	    };
	
	    _this.handleChangeRadio = function (e) {
	      var propsName = e.target.name;
	      var propsValue = e.target.value;
	      _this.setState(_defineProperty({}, propsName, propsValue));
	    };
	
	    _this.copyit = function (e) {
	
	      navigator.clipboard.writeText(_this.state.short_url);
	      alert("url is copied into your clipboard");
	    };
	
	    _this.handlePaymentLink = function (e) {
	
	      _this.setState({ loading: false });
	
	      window.$("#payment-modal").modal("show");
	
	      //payment-modal
	
	      /*
	       let req = JSON.stringify({
	         amount: "1500",
	         order_id: 1250
	       });
	        getPayLink(req).then((res) => {
	          console.log(res);
	         
	       });
	        */
	
	      console.log("loading..", _this.state.loading);
	    };
	
	    _this.customeChange = function (e) {
	      var THIS = _this;
	      var value = e.target.value;
	      var i = _this.state.plan_id;
	
	      var propsName = e.target.name;
	      var upgradeList = _this.state.upgradeList;
	      if (propsName == 'is_check') {
	        value = upgradeList[i].is_check == false || upgradeList[i].is_check == 'false' ? true : false;
	      }
	      _this.setState({
	        checking: true
	      });
	      upgradeList[i][propsName] = value;
	      if (upgradeList[i].nplan_id && upgradeList[i].period == undefined) upgradeList[i]['period'] = 365;
	
	      _this.setPrice(upgradeList[i].nplan_id, upgradeList[i].period, upgradeList, i);
	
	      var fdata = upgradeList.filter(function (item) {
	        return item.is_check === true && item.nplanid != 0 && parseInt(item.period) > 0;
	      });
	      if (fdata.length === 0) _this.setState({
	        basesubtotal: 0, subtotal: 0, discount_per: 0, discount_amount: 0,
	        sgst_amount: 0, cgst_amount: 0, totalpayable: 0, totalselected: 0
	      });
	      setTimeout(function () {
	        THIS.setState({
	          checking: false
	        });
	      }, 500);
	    };
	
	    _this.generatePayLink = function (e) {
	
	      var formatamount_1 = Number(_this.state.total).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
	      var formatamount_2 = formatamount_1.replace(",", "");
	      var formatamount = formatamount_2.replace(".", "");
	      var amount = formatamount_1;
	      var rzamount = formatamount;
	      var name = _this.state.organisation_name;
	      var email_id = _this.state.email_id;
	      var contact = _this.state.phone_number;
	      var description = 'Plan Upgrade - Partner Program';
	      var plan_name = _this.state.plan_name;
	      var period = _this.state.period;
	      var vendor_id = _this.state.vendor_id;
	      var plan_id = _this.state.plan_id;
	      var generated_by = _this.state.generated_by;
	      var discount_amount = _this.state.discount_amount;
	      var discount_per = _this.state.discount_per;
	
	      var optbannerprice = _this.state.optbannerprice;
	      var optbanners = _this.state.optbanners;
	      var optbannerperiod = _this.state.optbannerperiod;
	
	      var order_id = Date.now();
	
	      var req = JSON.stringify({
	        amount: amount,
	        rzamount: rzamount,
	        name: name,
	        email: email_id,
	        contact: contact,
	        description: description,
	        period: period,
	        plan_name: plan_name,
	        vendor_id: vendor_id,
	        plan_id: plan_id,
	        generated_by: generated_by,
	        discount_amount: discount_amount,
	        discount_per: discount_per,
	        order_id: order_id
	      });
	
	      _this.setState({ generated: false, loading: true });
	
	      (0, _FetchCall.getPayLink)(req).then(function (res) {
	
	        if (res.status == 1) {
	
	          var data = res.result;
	
	          var _req = JSON.stringify({
	            id: data.id,
	            short_url: data.short_url,
	            vendor_id: _this.state.vendor_id,
	            plan_id: _this.state.plan_id,
	            plan_name: _this.state.plan_name,
	            email: _this.state.email_id,
	            amount: data.amount,
	            period: _this.state.period,
	            discount_amount: _this.state.discount_amount,
	            discount_per: _this.state.discount_per,
	            order_id: order_id,
	            generated_by: _this.state.generated_by,
	            customer_name: _this.state.organisation_name,
	            customer_email: data.customer.email,
	            optbannerprice: _this.state.optbannerprice,
	            optbanners: _this.state.optbanners,
	            optbannerperiod: _this.state.optbannerperiod
	          });
	
	          (0, _FetchCall.savePayLink)(_req).then(function (payres) {
	
	            console.log(payres);
	
	            var data = payres;
	
	            _this.setState({
	              generated: true,
	              loading: false,
	              short_url: data.short_url,
	              email_id: data.customer_email,
	              name: data.customer_name
	            });
	          });
	        }
	      });
	    };
	
	    _this.sendMail_PaymentLink = function (e) {
	
	      var req = JSON.stringify({
	        to: _this.state.email_id,
	        url: _this.state.short_url,
	        customer_name: _this.state.name,
	        vendor_id: _this.state.vendor_id
	      });
	
	      (0, _FetchCall.sendMailPayLink)(req).then(function (res) {
	
	        if (res.status == 1) {
	
	          _reactNotifications.NotificationManager.success('Mail has been sent');
	        }
	      });
	    };
	
	    _this.handleSubmitCurated = function (e) {
	      e.preventDefault();
	      var userinfo = JSON.stringify({
	        vendor_id: _this.state.vendor_id,
	        login_id: _this.state.login_id,
	        set_id: _this.state.set_id,
	        category_id: _this.state.category_id,
	        email_id: _this.state.email_id
	      });
	      (0, _FetchCall.approveVendorInfoCurated)(userinfo).then(function (response) {
	        var toastr = "";
	        if (response.status == 1) {
	          _reactNotifications.NotificationManager.success('Partner Info Approved');
	        } else {
	          _reactNotifications.NotificationManager.error('There is an issue');
	        }
	      });
	    };
	
	    _this.handleSubmit = function (e) {
	      e.preventDefault();
	      var userinfo = JSON.stringify({
	        vendor_id: _this.state.vendor_id,
	        login_id: _this.state.login_id,
	        set_id: _this.state.set_id,
	        category_id: _this.state.category_id,
	        email_id: _this.state.email_id
	      });
	      (0, _FetchCall.approveVendorInfo)(userinfo).then(function (response) {
	        var toastr = "";
	        if (response.status == 1) {
	
	          _reactNotifications.NotificationManager.success('Partner Info Approved');
	        } else {
	
	          _reactNotifications.NotificationManager.error('There is an issue');
	        }
	      });
	    };
	
	    _this.handleSendResponse = function (type) {
	      var userinfo = JSON.stringify({
	        vendor_id: _this.state.vendor_id,
	        set_id: _this.state.set_id,
	        login_id: _this.state.login_id,
	        category_id: _this.state.category_id,
	        email_id: _this.state.email_id,
	        parnter_name: _this.state.partner_name,
	        type: type
	      });
	      (0, _FetchCall.indResponse)(userinfo).then(function (response) {
	        var toastr = "";
	        if (response.status == 1) {
	
	          _reactNotifications.NotificationManager.success('Partner Response Send Success');
	
	          // this.props.history.push("/vendorlist");
	        } else {
	          _reactNotifications.NotificationManager.error('There is an issue');
	        }
	      });
	    };
	
	    _this.handleStampForm = function (e) {
	      e.preventDefault();
	      var req = JSON.stringify({
	        vendor_id: _this.state.vendor_id,
	        url: 'saveStamp',
	        stamp_id: _this.state.nstamp_id
	      });
	      (0, _FetchCall.adminUser)(req).then(function (res) {
	        var toastr = '';
	        if (res.status === 1) {
	          toastr = window.toastr.success;
	          toastr('', 'Stamp Updated Success', {
	            positionClass: "toast-bottom-right",
	            containerId: "toast-bottom-right"
	          });
	          setTimeout(function () {
	            window.location.replace("/vendorlist");
	          }, 1000);
	        } else {
	          toastr = window.toastr.error; //warning
	          toastr('Update Failed', toastr, {
	            positionClass: "toast-bottom-right",
	            containerId: "toast-bottom-right"
	          });
	        }
	      });
	    };
	
	    _this.state = {
	      logged: localStorage.getItem("authentication"),
	      auth_data: JSON.parse(localStorage.getItem("user_data")),
	      vendor_id: _this.props.match.params.id,
	      category_id: "",
	      errors: [],
	      reject_reason: "",
	      generated_by: "",
	      data: [],
	      keyinfo: [],
	      photos_arr: [],
	      stamp_list: [],
	      package_list: [],
	      planlist: [],
	      period: 0,
	      stamp_id: 0,
	      nstamp_id: 0,
	      generated: false,
	      loading: false,
	      showprice: false,
	      short_url: '',
	      discount: 0,
	      email_id: '',
	      nplan_id: '',
	      write_permission: true,
	      opener: false,
	      leads: [{ name: "",
	        enddate: "",
	        fromdate: "",
	        starttime: "",
	        feeinr: "",
	        feeusd: "",
	        duration: "",
	        days: "" }]
	    };
	    _this.getStampList();
	    _this.generatePayLink = _this.generatePayLink.bind(_this);
	    _this.getPlanList();
	
	    _this.openDiscountBlock = _this.openDiscountBlock.bind(_this);
	    _this.getCurrentPlanList = _this.getCurrentPlanList.bind(_this);
	    _this.handlePaymentLink = _this.handlePaymentLink.bind(_this);
	    _this.showprice = _this.showprice.bind(_this);
	    _this.updatePrice = _this.updatePrice.bind(_this);
	    _this.getPlanList = _this.getPlanList.bind(_this);
	
	    return _this;
	  }
	
	  _createClass(partnerDetail, [{
	    key: 'leadList',
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(partnerId) {
	        var _this2 = this;
	
	        var insdata;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                insdata = JSON.stringify({
	                  login_id: this.state.login_id
	                });
	
	                (0, _FetchCall.getLeadsByPartner)(insdata).then(function (response) {
	
	                  if (response.status === 1) {
	
	                    var newLeads = response.leads.map(function (lead) {
	                      return {
	                        "id": lead.id,
	                        "firstname": lead.firstname,
	                        "lastname": lead.lastname,
	                        "vertical": lead.lead_vertical,
	                        "searchkey": lead.searchkey,
	                        "location": lead.location,
	                        "mobilenumber": lead.mobilenumber,
	                        "status": lead.lead_status,
	                        "email": lead.email,
	                        "createdAt": new Intl.DateTimeFormat('en-US', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).format(lead.created_date)
	                      };
	                    });
	
	                    _this2.setState({ leads: newLeads });
	                  }
	                });
	
	              case 2:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function leadList(_x) {
	        return _ref.apply(this, arguments);
	      }
	
	      return leadList;
	    }()
	  }, {
	    key: 'getPlanList',
	    value: function getPlanList() {
	      var _this3 = this;
	
	      var planData = JSON.stringify({
	        user_type: 1
	      });
	      (0, _FetchCall.getPlan)(planData).then(function (response) {
	        if (response.status == 1) {
	          _this3.setState({
	            planlist: response.results
	          });
	        }
	      });
	    }
	  }, {
	    key: 'openDiscountBlock',
	    value: function openDiscountBlock() {
	      var _this4 = this;
	
	      var ins = JSON.stringify({
	        vendor_id: this.state.vendor_id
	      });
	
	      (0, _FetchCall.checkDiscountInfo)(ins).then(function (res) {
	        if (res.status == 1) {
	
	          if (res.result.length > 0) {
	            //open modal
	
	            var data = res.result[0];
	            _this4.setState({ id: data.id, vendor_id: data.vendor_id, discount: data.discount });
	          } else {
	            _this4.setState({ id: 0, discount: 5 });
	          }
	
	          window.$("#discount-modal").modal("show");
	        } else {
	
	          _reactNotifications.NotificationManager.error('Issue');
	        }
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this5 = this;
	
	      var userinfo = JSON.stringify({
	        vendor_id: this.state.vendor_id
	      });
	
	      var user_data = localStorage.getItem("user_data");
	      var auth_data = JSON.parse(user_data);
	      var generated_by = auth_data.login_id;
	      this.setState({ generated_by: generated_by });
	
	      var role = this.state.auth_data.role;
	
	      var req = JSON.stringify({
	        url: "getVendorInformation",
	        role: role,
	        path: '/vendorlist',
	        vendor_id: this.state.vendor_id
	      });
	      (0, _FetchCall.commonAPI)(req).then(function (res) {
	        if (res.status === 1) {
	          var stamp_id = res.results ? res.results.stamp_id : 0;
	          _this5.setState({
	            write_permission: true,
	            data: res.results,
	            stamp_id: stamp_id,
	            nstamp_id: stamp_id == 0 ? 3 : 0,
	            keyinfo: res.results.extra ? res.results.extra : [],
	            photos_arr: res.results.photo_arr
	          });
	        }
	      });
	      (0, _FetchCall.getVendorInfo)(userinfo).then(function (response) {
	        if (response.status == 1) {
	          var _this5$setState;
	
	          var data = response.results[0];
	          _this5.setState((_this5$setState = {
	            user_type: data.user_type == 1 ? "Institutional" : "Individual",
	            user_paytype: data.user_paytype == 1 ? "Paid" : "Free",
	            vendor_id: data.vendor_id,
	            set_id: data.set_id,
	            login_id: data.login_id,
	            reg_process: data.reg_process,
	            partner_name: data.first_name + " " + data.last_name,
	            email_id: data.email_id,
	            user_name: data.user_name,
	            organisation_name: data.organisation_name,
	            organisation_register_number: data.organisation_register_number,
	            institution_email_address: data.institution_email_address,
	            phone_number: data.phone_number,
	            institution_contact_number: data.institution_contact_number,
	            state: data.state,
	            location: data.location,
	            pin_code: data.pin_code,
	            address: data.address,
	            status: data.status,
	            created_date: data.created_date,
	            usertype: data.user_type,
	            plan_name: data.plan_name,
	            category_id: data.category_id ? data.category_id.split(",") : [],
	            plan_category_id: data.plan_category_id,
	            plan_month: data.plan_month,
	            about_words_count: data.about_words_count,
	            image_count: data.image_count,
	            registration_no: data.registration_no,
	            organization_name: data.organization_name,
	            owner_name: data.owner_name,
	            school_board_of_education: data.school_board_of_education,
	            school_sub_types: data.school_sub_types,
	            school_sub_type: data.school_sub_type,
	            preschool_schoolType: data.preschool_schoolType,
	            playarea_age_group: data.playarea_age_group,
	            playarea_sub_type: data.playarea_sub_type,
	            hobbies_cate: data.hobbies_cate,
	            hobbies_subcatgory: data.hobbies_subcatgory,
	            hobbies_sub_type: data.hobbies_sub_type,
	            tutions_cate: data.tutions_cate,
	            languages: data.languages,
	            tutor_name: data.tutor_name,
	            event_type: data.event_type,
	            invities: data.invities,
	            camp_sub_type: data.camp_sub_type,
	            commmunity_type: data.commmunity_type,
	            service: data.service,
	            designation: data.designation,
	            email_id_info: data.email_id_info,
	            phone_number_info: data.phone_number_info,
	            landline_number_info: data.landline_number_info,
	            address_info: data.address_info,
	            location_name: data.location_name,
	            area: data.area,
	            state_name: data.state_name,
	            country: data.country,
	            pincode: data.pincode,
	            google_location: data.google_location,
	            website: data.website,
	            about: data.about,
	            key_words: data.key_words,
	            category: data.category,
	            admission_link: data.admission_link,
	            admission_process: data.admission_process,
	            application_fees: data.application_fees,
	            required_documents: data.required_documents,
	            school_type: data.school_type,
	            classification: data.classification,
	            grade_to: data.grade_to,
	            grade: data.grade,
	            from_time: data.from_time,
	            from_time_cate: data.from_time_cate,
	            to_time: data.to_time,
	            to_time_cate: data.to_time_cate,
	            min_age: data.min_age,
	            instruction_lang: data.instruction_lang,
	            student_ratio: data.student_ratio,
	            establishment_year: data.establishment_year,
	            amenities: data.amenities,
	            average_fees: data.average_fees,
	            class_fee: data.class_fee,
	            class_fee_type: data.class_fee_type,
	            other_fees: data.other_fees,
	            admission_fees: data.admission_fees,
	            isrefund: data.isrefund == 1 ? "Yes" : "No",
	            board_of_education: data.board_of_education,
	            no_of_teachers: data.no_of_teachers,
	            // photos_arr: data.photo_arr,
	            url: data.url,
	            images: data.images,
	            entry_fees: data.entry_fees,
	            std_ratio: data.std_ratio,
	            tution_type: data.tution_type,
	            age_group: data.age_group,
	            class_frequency: data.class_frequency,
	            class_range: data.class_range
	          }, _defineProperty(_this5$setState, 'area', data.area), _defineProperty(_this5$setState, 'facebook', data.facebook), _defineProperty(_this5$setState, 'twitter', data.twitter), _defineProperty(_this5$setState, 'payment_name', data.mode_of_payment), _defineProperty(_this5$setState, 'apporve_status', data.status == 1 ? "Approved" : "Pending or Waiting for Approval"), _defineProperty(_this5$setState, 'reject_reason', data.reject_reason), _defineProperty(_this5$setState, 'amount', data.amount), _defineProperty(_this5$setState, 'discount', data.discount), _defineProperty(_this5$setState, 'discount_amount', data.discount_amount), _defineProperty(_this5$setState, 'plan_price_original', data.plan_price_original), _defineProperty(_this5$setState, 'id_proof', data.id_proof), _defineProperty(_this5$setState, 'id_proof_no', data.id_proof_no), _defineProperty(_this5$setState, 'qualification', data.qualification), _defineProperty(_this5$setState, 'othercomments', data.othercomments), _defineProperty(_this5$setState, 'plan_id', data.plan_id), _defineProperty(_this5$setState, 'reg_status', data.reg_status), _this5$setState));
	
	          _this5.getCurrentPlanList();
	
	          _this5.leadList(_this5.props.match.params.id);
	        } else {
	          console.log(response.status);
	        }
	      });
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {}
	  }, {
	    key: 'showValidationErr',
	    value: function showValidationErr(elm, msg) {
	      this.setState(function (prevState) {
	        return {
	          errors: [].concat(_toConsumableArray(prevState.errors), [{ elm: elm, msg: msg }])
	        };
	      });
	    }
	  }, {
	    key: 'clearValidationErr',
	    value: function clearValidationErr(elm) {
	      var _this6 = this;
	
	      this.setState(function (prevState) {
	        var newArr = [];
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = _this6.state.errors[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var err = _step.value;
	
	            if (elm !== err.elm) {
	              newArr.push(err);
	            }
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	
	        return { errors: newArr };
	      });
	    }
	  }, {
	    key: 'openDetail',
	    value: function openDetail(id) {
	      window.location = '/leads/leadDetail/' + id;
	    }
	  }, {
	    key: 'gallery_image',
	    value: function gallery_image() {
	      var _this7 = this;
	
	      var photos = this.state.photos_arr !== undefined ? this.state.photos_arr : [];
	      var rows = "";
	      if (photos.length > 0) {
	        rows = photos.map(function (photos, index) {
	          if (photos.name) return _react2.default.createElement(
	            'div',
	            { 'class': 'col-md-4 float-left mt-4 p-0' },
	            _react2.default.createElement('img', {
	              src: _this7.state.url + photos.name,
	              alt: 'Img',
	              'class': 'img-thumbnail'
	            })
	          );
	        });
	      } else {
	        rows = "";
	      }
	      return rows;
	    }
	  }, {
	    key: 'set',
	    value: function set() {
	      var _this8 = this;
	
	      var ins = JSON.stringify({
	        vendor_id: this.state.vendor_id,
	        discount: this.state.discount
	      });
	      (0, _FetchCall.creatediscount)(ins).then(function (res) {
	        if (res.status == 1) {
	          var toastr = '';
	
	          _reactNotifications.NotificationManager.success('Successfully created');
	
	          window.$("#discount-modal").modal("hide");
	          _this8.el.destroy();
	          _this8.getList();
	        } else {
	
	          _reactNotifications.NotificationManager.error('Cant be applied');
	
	          window.$("#discount-modal").modal("hide");
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this9 = this;
	
	      var _state = this.state,
	          data = _state.data,
	          keyinfo = _state.keyinfo,
	          leads = _state.leads;
	
	      data.access = data.access ? data.access : [];
	      var reasonErr = null;
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;
	
	      try {
	        for (var _iterator2 = this.state.errors[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          var err = _step2.value;
	
	          if (err.elm === "reject_reason") {
	            reasonErr = err.msg;
	          }
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2.return) {
	            _iterator2.return();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'row' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'col-md-12' },
	              _react2.default.createElement(
	                'div',
	                { className: 'content-top col-md-12 col-xs-12' },
	                _react2.default.createElement(
	                  'h3',
	                  null,
	                  'Partner Info'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-12 col-xs-12' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'partnerinfoclass' },
	                  _react2.default.createElement(
	                    'div',
	                    { id: 'company-info', className: '' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'box-shadow-custom' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'form-group col-md-4' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            'Partner Type'
	                          ),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            data.partner_type
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'form-group col-md-4' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            'Payment Type'
	                          ),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            data.user_paytype
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'form-group col-md-4' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            'Name'
	                          ),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            data.partner_name
	                          )
	                        ),
	                        data.user_type == "1" && _react2.default.createElement(
	                          _react2.default.Fragment,
	                          null,
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'form-group col-md-4' },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              'Name of the Institution'
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              data.organisation_name
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'form-group col-md-4' },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              'Business Regn Number'
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              data.registration_no
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'form-group col-md-4' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            'Address'
	                          ),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            data.address
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'form-group col-md-4' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            'City'
	                          ),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            data.location
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'form-group col-md-4' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            'State'
	                          ),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            data.state
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'form-group col-md-4' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            'Pincode'
	                          ),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            data.pin_code
	                          )
	                        ),
	                        data.user_type == "1" && _react2.default.createElement(
	                          _react2.default.Fragment,
	                          null,
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'form-group col-md-4' },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              'Institution Contact Number'
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              data.institution_contact_number
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'form-group col-md-4' },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              'Institution Email Address'
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              data.institution_email_address
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'form-group col-md-4' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            'Email Id'
	                          ),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            data.email_id
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'form-group col-md-4' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            'Phone Number'
	                          ),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            data.phone_number
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'form-group col-md-4' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            'Category'
	                          ),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            data.category_name
	                          )
	                        ),
	                        data.user_type == "2" && _react2.default.createElement(
	                          _react2.default.Fragment,
	                          null,
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'form-group col-md-4' },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              'Identity Proof'
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              this.state.id_proof
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'form-group col-md-4' },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              'ID Number'
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              this.state.id_proof_no
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'form-group col-md-4' },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              'Highest Qualification'
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              this.state.qualification
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'form-group col-md-4' },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              'Comments'
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              this.state.othercomments
	                            )
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'box-shadow-custom pad-reduce' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-md-12 col-xs-12' },
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'form-legend' },
	                            'Payment Information'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'form-group col-md-4' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            'Name of the Package'
	                          ),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            data.plan_name
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'form-group col-md-4' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            'Package Value'
	                          ),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            data.pack_value
	                          )
	                        ),
	                        this.state.discount != 0 && _react2.default.createElement(
	                          'div',
	                          { className: 'form-group col-md-4' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            'Package Discount',
	                            data.discount != 0 && _react2.default.createElement(
	                              _react2.default.Fragment,
	                              null,
	                              '(',
	                              data.discount,
	                              '%)'
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            data.discount_amount
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'form-group col-md-4' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            'Amount Paid'
	                          ),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            data.amount
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'form-group col-md-4' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            'Words Limit'
	                          ),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            data.word_count
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'form-group col-md-4' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            'Upload image limit'
	                          ),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            data.image_count
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'form-group col-md-4' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            'Start Date'
	                          ),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            data.start_date
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'form-group col-md-4' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            'End Date'
	                          ),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            data.end_date
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'box-shadow-custom pad-reduce' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-md-12 col-xs-12' },
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'form-legend' },
	                            'Complete Registration Information'
	                          )
	                        ),
	                        data.registration_no && _react2.default.createElement(
	                          'div',
	                          { className: 'form-group col-md-4' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            'Registration No'
	                          ),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            data.registration_no
	                          )
	                        ),
	                        data.owner_name && _react2.default.createElement(
	                          'div',
	                          { className: 'form-group col-md-4' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            'Owner Name'
	                          ),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            data.owner_name
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'form-group col-md-4' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            'Organization Name'
	                          ),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            data.organisation_name
	                          )
	                        )
	                      )
	                    ),
	                    data.access.includes('1') && _react2.default.createElement(
	                      'div',
	                      { 'class': 'box-shadow-custom pad-reduce' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-md-12 col-xs-12' },
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'form-legend' },
	                            data.category_name,
	                            ' Information'
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'form-group col-md-4' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            'Sub Categories'
	                          ),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            keyinfo.sub_categories ? keyinfo.sub_categories : ''
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'form-group col-md-4' },
	                          _react2.default.createElement(
	                            'label',
	                            { className: 'text-capitalize' },
	                            'Board of Education'
	                          ),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            keyinfo.curriculum
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'form-group col-md-4' },
	                          _react2.default.createElement(
	                            'label',
	                            { className: 'text-capitalize' },
	                            'Campus Type'
	                          ),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            keyinfo.types_school
	                          )
	                        )
	                      )
	                    ),
	                    data.access.includes("2") && _react2.default.createElement(
	                      _react2.default.Fragment,
	                      null,
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'box-shadow-custom pad-reduce' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'row' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-12 col-xs-12' },
	                            _react2.default.createElement(
	                              'span',
	                              { className: 'form-legend' },
	                              data.category_name,
	                              ' Information'
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'form-group col-md-4' },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              'Sub Categories'
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              keyinfo.sub_categories ? keyinfo.sub_categories : ''
	                            )
	                          )
	                        )
	                      )
	                    ),
	                    data.access.includes("3") && _react2.default.createElement(
	                      _react2.default.Fragment,
	                      null,
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'box-shadow-custom pad-reduce' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'row' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-12 col-xs-12' },
	                            _react2.default.createElement(
	                              'span',
	                              { className: 'form-legend' },
	                              data.category_name,
	                              ' Information'
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'row' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'form-group col-md-4' },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              'Sub Categories'
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              keyinfo.sub_categories ? keyinfo.sub_categories : ''
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'form-group col-md-4' },
	                            _react2.default.createElement(
	                              'label',
	                              { className: 'text-capitalize' },
	                              'Catering To Age Group'
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              keyinfo.play_age
	                            )
	                          )
	                        )
	                      )
	                    ),
	                    data.access.includes("4") && _react2.default.createElement(
	                      _react2.default.Fragment,
	                      null,
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'box-shadow-custom pad-reduce' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'row' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-12 col-xs-12' },
	                            _react2.default.createElement(
	                              'span',
	                              { className: 'form-legend' },
	                              data.category_name,
	                              ' Information'
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'row' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'form-group col-md-4' },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              'After School type'
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              keyinfo.fcategory
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'form-group col-md-4' },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              keyinfo.fcategory,
	                              ' type'
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              keyinfo.sub_categories ? keyinfo.sub_categories : ''
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'form-group col-md-4' },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              keyinfo.fcategory,
	                              ' types'
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              keyinfo.sub_categories ? keyinfo.sub_categories : ''
	                            )
	                          )
	                        )
	                      )
	                    ),
	                    data.access.includes("6") && keyinfo.length > 0 && _react2.default.createElement(
	                      _react2.default.Fragment,
	                      null,
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'box-shadow-custom pad-reduce' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'row' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-12 col-xs-12' },
	                            _react2.default.createElement(
	                              'span',
	                              { className: 'form-legend' },
	                              data.category_name,
	                              ' Information'
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'row' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'form-group col-md-4' },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              'Incharge Name '
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              keyinfo.incharge_name
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'form-group col-md-4' },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              'Tutions type'
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              keyinfo.sub_categories ? keyinfo.sub_categories : ''
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'form-group col-md-4' },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              'Languages',
	                              _react2.default.createElement(
	                                'span',
	                                { className: 'astrick' },
	                                '*'
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              keyinfo.sub_types
	                            )
	                          )
	                        )
	                      )
	                    ),
	                    data.access.includes("7") && _react2.default.createElement(
	                      _react2.default.Fragment,
	                      null,
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'box-shadow-custom pad-reduce' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'row' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-12 col-xs-12' },
	                            _react2.default.createElement(
	                              'span',
	                              { className: 'form-legend' },
	                              data.category_name,
	                              ' Information'
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'row' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'form-group col-md-4' },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              'Events type'
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              keyinfo.sub_categories ? keyinfo.sub_categories : ''
	                            )
	                          )
	                        )
	                      )
	                    ),
	                    data.access.includes("8") && _react2.default.createElement(
	                      _react2.default.Fragment,
	                      null,
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'box-shadow-custom pad-reduce' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'row' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-12 col-xs-12' },
	                            _react2.default.createElement(
	                              'span',
	                              { className: 'form-legend' },
	                              data.category_name,
	                              ' Information'
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'row' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'form-group col-md-4' },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              'Child Age Group '
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              keyinfo.sub_categories ? keyinfo.sub_categories : ''
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'form-group col-md-4' },
	                            _react2.default.createElement(
	                              'label',
	                              { className: 'text-capitalize' },
	                              'Type'
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              keyinfo.sub_type
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'form-group col-md-4' },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              'BeWise Curated?'
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              keyinfo.iscurated == 1 ? 'Yes' : 'No'
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'form-group col-md-4' },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              'Approved BeWise Curated?'
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              keyinfo.iscurated_approved == 1 ? 'Yes' : 'No'
	                            )
	                          )
	                        )
	                      )
	                    ),
	                    data.access.includes("121") && _react2.default.createElement(
	                      _react2.default.Fragment,
	                      null,
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'box-shadow-custom pad-reduce' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'row' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-12 col-xs-12' },
	                            _react2.default.createElement(
	                              'span',
	                              { className: 'form-legend' },
	                              data.category_name,
	                              ' Information'
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'row' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'form-group col-md-4' },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              'Community type',
	                              _react2.default.createElement(
	                                'span',
	                                { className: 'astrick' },
	                                '*'
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              keyinfo.sub_categories ? keyinfo.sub_categories : ''
	                            )
	                          ),
	                          _react2.default.createElement(
	                            _react2.default.Fragment,
	                            null,
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'form-group col-md-4' },
	                              _react2.default.createElement(
	                                'label',
	                                null,
	                                'Designation'
	                              ),
	                              _react2.default.createElement(
	                                'p',
	                                null,
	                                keyinfo.designation
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'form-group col-md-4' },
	                              _react2.default.createElement(
	                                'label',
	                                null,
	                                'Service'
	                              ),
	                              _react2.default.createElement(
	                                'p',
	                                null,
	                                keyinfo.service
	                              )
	                            )
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'box-shadow-custom pad-reduce' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-md-12 col-xs-12' },
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'form-legend' },
	                            'Address Information'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'form-group col-md-4' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            'Email Id'
	                          ),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            data.email_id
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'form-group col-md-4' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            'Phone Number'
	                          ),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            data.phone_number
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'form-group col-md-4' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            'Landline Number'
	                          ),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            data.landline_number
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'form-group col-md-4' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            'Address'
	                          ),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            data.address
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'form-group col-md-4' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            'Google Address'
	                          ),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            data.google_location
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'form-group col-md-4' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            'City'
	                          ),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            data.location
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'form-group col-md-4' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            'State'
	                          ),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            data.state
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'form-group col-md-4' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            'Pincode'
	                          ),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            data.pin_code
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'box-shadow-custom' },
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-md-12 col-xs-12' },
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'form-legend' },
	                            'Admission/Fee'
	                          )
	                        ),
	                        (data.access.includes('1') || data.access.includes('2')) && _react2.default.createElement(
	                          _react2.default.Fragment,
	                          null,
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'form-group col-md-4' },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              'Admission Link'
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              data.admission_link
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'form-group col-md-4' },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              'Application Fees (INR)'
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              data.application_fees
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'form-group col-md-4' },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              ' Required Documents'
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              data.required_documents
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'form-group col-md-4' },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              'Other Fees (INR) '
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              this.state.other_fees
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'form-group col-md-4' },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              'Admission Process'
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              data.admission_process
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'form-group col-md-4' },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              'Is Refundable (Admission Fees)'
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              data.is_refund
	                            )
	                          )
	                        ),
	                        (data.access.includes('1') || data.access.includes('2')) && _react2.default.createElement(
	                          _react2.default.Fragment,
	                          null,
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'form-group col-md-4' },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              'Average Annual Fees (INR) '
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              data.average_fees
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'form-group col-md-4' },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              'Recurring Fees (INR) '
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              this.state.admission_fees
	                            )
	                          )
	                        ),
	                        (data.access.includes('4') || data.access.includes('6')) && _react2.default.createElement(
	                          _react2.default.Fragment,
	                          null,
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'form-group col-md-4' },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              'Average Fees (INR) '
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              data.average_fees
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'form-group col-md-4' },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              'Class Fees (INR) '
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'row' },
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'form-group col-md-6' },
	                                _react2.default.createElement(
	                                  'p',
	                                  null,
	                                  data.class_fee
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'form-group col-md-6' },
	                                _react2.default.createElement(
	                                  'p',
	                                  null,
	                                  (data.class_fee_type == '' || data.class_fee_type == '0') && 'NA',
	                                  data.class_fee_type == '2' && 'Per Participant',
	                                  data.has_trail == '1' && 'Per Class'
	                                )
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'form-group col-md-4' },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              'Recurring Fees (INR) '
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              this.state.admission_fees
	                            )
	                          )
	                        ),
	                        (data.access.includes('3') || data.access.includes('121')) && _react2.default.createElement(
	                          _react2.default.Fragment,
	                          null,
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'form-group col-md-4' },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              'Entry Fees (INR)'
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              data.entry_fees
	                            )
	                          )
	                        ),
	                        (data.access.includes('8') || data.access.includes('7')) && _react2.default.createElement(
	                          _react2.default.Fragment,
	                          null,
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'form-group col-md-4' },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              'Entry Fees (INR)'
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              data.event_fee
	                            )
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'box-shadow-custom' },
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-md-12 col-xs-12' },
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'form-legend' },
	                            'Key Information'
	                          )
	                        ),
	                        data.access.includes('1') && _react2.default.createElement(
	                          _react2.default.Fragment,
	                          null,
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'form-group col-md-4' },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              'School type '
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              keyinfo.school_type
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'form-group col-md-4' },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              'Classification '
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              keyinfo.classification
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'form-group col-md-4' },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              'Grade'
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              keyinfo.grades && keyinfo.grades.includes('NA') ? 'NA' : keyinfo.grades
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'form-group col-md-4' },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              'Teacher Student Ratio'
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              keyinfo.std_ratio
	                            )
	                          )
	                        ),
	                        data.access.includes('6') && _react2.default.createElement(
	                          _react2.default.Fragment,
	                          null,
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'form-group col-md-4' },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              'Person Incharge '
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              keyinfo.incharge_name
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'form-group col-md-4' },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              'Board of Education'
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              keyinfo.curriculum
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'form-group col-md-4' },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              'Teaching For Grades '
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              keyinfo.class_range
	                            )
	                          )
	                        ),
	                        (data.access.includes('1') || data.access.includes('6')) && _react2.default.createElement(
	                          _react2.default.Fragment,
	                          null,
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'form-group col-md-4' },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              'Instruction Languages'
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              keyinfo.inst_lang
	                            )
	                          )
	                        ),
	                        data.access.includes('7') && _react2.default.createElement(
	                          _react2.default.Fragment,
	                          null,
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'form-group col-md-4' },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              'Hall Capacity'
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              keyinfo.hall_capcity
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'form-group col-md-4' },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              'Dinning Hall Capacity'
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              keyinfo.dinning_capacity
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'form-group col-md-4' },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              'Car Parking'
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              keyinfo.car_parking_slot
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'form-group col-md-4' },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              'Two Wheeler Parking'
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              keyinfo.two_parking_slot
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'form-group col-md-4' },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              'Operating Hours'
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              keyinfo.timing
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'form-group col-md-4' },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              'Type of Food Served '
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              keyinfo.food
	                            )
	                          )
	                        ),
	                        (data.access.includes('121') || data.access.includes('7')) && _react2.default.createElement(
	                          _react2.default.Fragment,
	                          null,
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'form-group col-md-4' },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              'Mode of Payment '
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              keyinfo.payment
	                            )
	                          )
	                        ),
	                        data.access.includes('121') && _react2.default.createElement(
	                          _react2.default.Fragment,
	                          null,
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'form-group col-md-4' },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              'Designation'
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              keyinfo.designation
	                            )
	                          )
	                        ),
	                        (data.access.includes('8') || data.access.includes('7')) && _react2.default.createElement(
	                          _react2.default.Fragment,
	                          null,
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'form-group col-md-4' },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              'Contact Person '
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              keyinfo.contact_person
	                            )
	                          )
	                        ),
	                        data.access.includes('8') && _react2.default.createElement(
	                          _react2.default.Fragment,
	                          null,
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'form-group col-md-4' },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              'Teacher Student Ratio '
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              keyinfo.learn_opt
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'form-group col-md-4' },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              'When (Date)'
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              keyinfo.when_event
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'form-group col-md-4' },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              'Where'
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              keyinfo.where_event
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'form-group col-md-4' },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              'Registration Info (Email ID)'
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              keyinfo.register_info
	                            )
	                          )
	                        ),
	                        (data.access.includes('1') || data.access.includes('2') || data.access.includes('3')) && _react2.default.createElement(
	                          _react2.default.Fragment,
	                          null,
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'form-group col-md-4' },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              'Amenities '
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              data.facilities
	                            )
	                          )
	                        ),
	                        (data.access.includes('1') || data.access.includes('2') || data.access.includes('3') || data.access.includes('4') || data.access.includes('6')) && _react2.default.createElement(
	                          _react2.default.Fragment,
	                          null,
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'form-group col-md-4' },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              'Timing'
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              keyinfo.time && keyinfo.time.includes('NA') ? 'NA' : keyinfo.time
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'form-group col-md-4' },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              'No Of Teachers'
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              keyinfo.teacher_count
	                            )
	                          )
	                        ),
	                        (data.access.includes('1') || data.access.includes('2') || data.access.includes('3') || data.access.includes('4') || data.access.includes('6') || data.access.includes('121') || data.access.includes('7')) && _react2.default.createElement(
	                          _react2.default.Fragment,
	                          null,
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'form-group col-md-4' },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              'Establishment Year'
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              keyinfo.est_year
	                            )
	                          )
	                        ),
	                        (data.access.includes('1') || data.access.includes('2') || data.access.includes('4')) && _react2.default.createElement(
	                          _react2.default.Fragment,
	                          null,
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'form-group col-md-4' },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              'Min Age of Admission '
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              keyinfo.min_age
	                            )
	                          )
	                        ),
	                        (data.access.includes('4') || data.access.includes('6')) && _react2.default.createElement(
	                          _react2.default.Fragment,
	                          null,
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'form-group col-md-4' },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              'Class Frequency'
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              keyinfo.freq_name
	                            )
	                          )
	                        ),
	                        (data.access.includes('4') || data.access.includes('6') || data.access.includes('8')) && _react2.default.createElement(
	                          _react2.default.Fragment,
	                          null,
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'form-group col-md-4' },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              'Learning Option '
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              keyinfo.learn_opt
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'form-group col-md-4' },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              'Learning Location'
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              keyinfo.learn_loc
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'form-group col-md-4' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            'Website'
	                          ),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            data.website
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'form-group col-md-4' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            'Website Search Keyword'
	                          ),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            data.key_words
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'form-group col-md-12' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            'About'
	                          ),
	                          _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: data.about } })
	                        )
	                      )
	                    ),
	                    (data.idproof_att || data.qualification_att || data.user_image_att) && _react2.default.createElement(
	                      'div',
	                      { 'class': 'box-shadow-custom' },
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-md-12 col-xs-12' },
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'form-legend' },
	                            'Documents uploaded'
	                          )
	                        ),
	                        data.idproof_att && _react2.default.createElement(
	                          'div',
	                          { className: 'form-group col-md-4' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            'ID Proof'
	                          ),
	                          _react2.default.createElement('br', null),
	                          _react2.default.createElement(
	                            'a',
	                            { href: data.url + data.idproof_att, target: '_blank' },
	                            'View'
	                          )
	                        ),
	                        data.qualification_att && _react2.default.createElement(
	                          'div',
	                          { className: 'form-group col-md-4' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            'Qualification Certificate'
	                          ),
	                          _react2.default.createElement('br', null),
	                          _react2.default.createElement(
	                            'a',
	                            { href: data.url + data.idproof_att, target: '_blank' },
	                            'View'
	                          )
	                        ),
	                        data.user_image_att && _react2.default.createElement(
	                          'div',
	                          { className: 'form-group col-md-4' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            'User Image'
	                          ),
	                          _react2.default.createElement('br', null),
	                          _react2.default.createElement(
	                            'a',
	                            { href: data.url + data.user_image_att, target: '_blank' },
	                            'View'
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'box-shadow-custom' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-md-12 col-xs-12' },
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'form-legend' },
	                            'Images'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'form-group col-md-4' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            'Banner Images'
	                          ),
	                          this.state.images && _react2.default.createElement('img', {
	                            src: this.state.url + this.state.images,
	                            alt: 'Img',
	                            'class': 'img-thumbnail'
	                          }),
	                          !this.state.images && _react2.default.createElement(
	                            'div',
	                            null,
	                            'No images'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'col-md-12 float-left mt-4 p-0' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            'Gallery Images'
	                          )
	                        ),
	                        this.gallery_image()
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'box-shadow-custom' },
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-md-12 col-xs-12' },
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'form-legend' },
	                            'Leads (',
	                            leads.length,
	                            ' Total Leads Received)'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-md-12 col-xs-12' },
	                          leads.length > 0 && _react2.default.createElement(
	                            'table',
	                            { 'class': 'table table-bordered table-sm' },
	                            _react2.default.createElement(
	                              'thead',
	                              { 'class': 'thead-dark' },
	                              _react2.default.createElement(
	                                'tr',
	                                null,
	                                _react2.default.createElement(
	                                  'th',
	                                  null,
	                                  'S.No'
	                                ),
	                                _react2.default.createElement(
	                                  'th',
	                                  null,
	                                  'First Name'
	                                ),
	                                _react2.default.createElement(
	                                  'th',
	                                  null,
	                                  'Last Name'
	                                ),
	                                _react2.default.createElement(
	                                  'th',
	                                  null,
	                                  'Date'
	                                ),
	                                _react2.default.createElement(
	                                  'th',
	                                  null,
	                                  'Vertical'
	                                ),
	                                _react2.default.createElement(
	                                  'th',
	                                  null,
	                                  'Action'
	                                )
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'tbody',
	                              null,
	                              leads.map(function (lead, i) {
	
	                                return _react2.default.createElement(
	                                  'tr',
	                                  null,
	                                  _react2.default.createElement(
	                                    'td',
	                                    null,
	                                    i + 1
	                                  ),
	                                  _react2.default.createElement(
	                                    'td',
	                                    null,
	                                    lead.firstname
	                                  ),
	                                  _react2.default.createElement(
	                                    'td',
	                                    null,
	                                    lead.lastname
	                                  ),
	                                  _react2.default.createElement(
	                                    'td',
	                                    null,
	                                    lead.createdAt
	                                  ),
	                                  _react2.default.createElement(
	                                    'td',
	                                    null,
	                                    lead.vertical
	                                  ),
	                                  _react2.default.createElement(
	                                    'td',
	                                    null,
	                                    _react2.default.createElement(
	                                      'button',
	                                      { 'class': 'btn btn-primary btn-sm', onClick: function onClick() {
	                                          return _this9.openDetail(lead.id);
	                                        } },
	                                      'Detail'
	                                    ),
	                                    '\xA0'
	                                  )
	                                );
	                              })
	                            )
	                          ),
	                          leads.length == 0 && _react2.default.createElement(
	                            'div',
	                            { 'class': 'danger' },
	                            'No Leads yet'
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'box-shadow-custom' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-md-12 col-xs-12' },
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'form-legend' },
	                            'Approve Status'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'form-group col-md-4' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            'Approve Status'
	                          ),
	                          _react2.default.createElement(
	                            'p',
	                            { className: this.state.apporve_status },
	                            this.state.reg_process == 3 ? 'Rejected' : this.state.apporve_status
	                          )
	                        ),
	                        this.state.reject_reason && _react2.default.createElement(
	                          'div',
	                          { className: 'form-group col-md-4' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            'Reject Reason'
	                          ),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            this.state.reject_reason
	                          )
	                        )
	                      )
	                    ),
	                    this.state.write_permission && _react2.default.createElement(
	                      _react2.default.Fragment,
	                      null,
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'box-shadow-custom' },
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'row col-md-12' },
	                          (this.state.usertype == 1 || this.state.usertype == 2) && _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-12 col-xs-12 btn-bdr' },
	                            _react2.default.createElement(
	                              'button',
	                              {
	                                id: 'btnSubmit'
	                                // onClick={this.handleRejectSubmit}
	                                , onClick: function onClick() {
	                                  return _this9.importSchool();
	                                },
	                                className: 'btn btn-gray btn-sm reject_btn'
	                              },
	                              'Reject'
	                            ),
	                            this.state.apporve_status != 'Approved' && _react2.default.createElement(
	                              'button',
	                              {
	                                id: 'btnSubmit',
	                                style: { float: "right" },
	                                onClick: this.handleSubmit,
	                                className: 'btn btn-primary btn-sm'
	                              },
	                              'Approve'
	                            ),
	                            _react2.default.createElement(
	                              'button',
	                              {
	                                id: 'btnSubmitDiscount',
	                                style: { float: "right", marginRight: "10px" },
	                                onClick: this.openDiscountBlock,
	                                className: 'btn btn-primary btn-sm'
	                              },
	                              'Set Discount'
	                            ),
	                            _react2.default.createElement(
	                              'button',
	                              {
	                                id: 'btnSubmit',
	                                style: { float: "right", marginRight: "10px" },
	                                onClick: this.handlePaymentLink,
	                                className: 'btn btn-primary btn-sm'
	                              },
	                              'Send Payment Link'
	                            ),
	                            _react2.default.createElement(
	                              'button',
	                              {
	                                id: 'btnSubmitCurated',
	                                style: { float: "right", marginRight: "10px" },
	                                onClick: this.handleSubmitCurated,
	                                className: 'btn btn-primary btn-sm'
	                              },
	                              'Approve BeWise Curated'
	                            )
	                          )
	                        ),
	                        ' '
	                      )
	                    ),
	                    this.state.plan_id == 0 && _react2.default.createElement(
	                      'div',
	                      { className: 'box-shadow-custom mar-top' },
	                      _react2.default.createElement(
	                        'form',
	                        { onSubmit: this.handleStampForm },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'row' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-12 col-xs-12' },
	                            _react2.default.createElement(
	                              'span',
	                              { className: 'form-legend' },
	                              'Stamp'
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-4' },
	                            _react2.default.createElement(
	                              'button',
	                              { className: 'btn btn-primary' },
	                              this.state.nstamp_id ? 'Assign' : 'Unassign'
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { 'class': 'modal fade', role: 'dialog', tabindex: '-1', id: 'import-modal' },
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'modal-dialog modal-md modal-dialog-centered', role: 'document' },
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'modal-content' },
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'modal-header' },
	                      _react2.default.createElement(
	                        'h5',
	                        { 'class': 'modal-title' },
	                        'Reject'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'modal-body' },
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'form-group col-md-12 col-xs-12 pad-no' },
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'col-sm-4 col-xs-12' },
	                          _react2.default.createElement(
	                            'label',
	                            { 'for': 'name' },
	                            'Reject Reason'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'col-sm-8 col-xs-12' },
	                          _react2.default.createElement('textarea', {
	                            className: 'form-control',
	                            rows: '4',
	                            cols: '50',
	                            name: 'reject_reason',
	                            onChange: this.handleChange
	                          }),
	                          _react2.default.createElement(
	                            'small',
	                            { className: 'alert-msg text-danger' },
	                            reasonErr ? reasonErr : ""
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'modal-footer', style: { "border-top": "none" } },
	                      _react2.default.createElement(
	                        'button',
	                        {
	                          type: 'button',
	                          'class': 'btn btn-light',
	                          'data-dismiss': 'modal'
	                        },
	                        'Cancel'
	                      ),
	                      _react2.default.createElement(
	                        'button',
	                        {
	                          type: 'button',
	                          'class': 'btn btn-success',
	                          onClick: this.handleRejectSubmit
	                        },
	                        'Rejected'
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { 'class': 'modal fade', role: 'dialog', tabindex: '-1', id: 'payment-modal' },
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'modal-dialog modal-md modal-dialog-centered', role: 'document' },
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'modal-content' },
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'modal-header' },
	                      _react2.default.createElement(
	                        'h5',
	                        { 'class': 'modal-title' },
	                        'Payment Information'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'modal-body' },
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'paymentblock' },
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          'You are generating new razorpay link with customer info and price!'
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          null,
	                          _react2.default.createElement(
	                            'div',
	                            null,
	                            'Confirm the payment amount and particulars'
	                          ),
	                          _react2.default.createElement('br', null),
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'borderedblock' },
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'form-group row' },
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'col-sm-8' },
	                                'Cost of Banners/premium listing/AD support as agreed'
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'col-sm-4' },
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'form-check-inline' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { 'class': 'form-check-label' },
	                                    _react2.default.createElement('input', { type: 'radio', 'class': 'form-check-input', name: 'optbanners', value: 'yes', onChange: this.handleChange }),
	                                    '\xA0Yes\xA0'
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'form-check-inline' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { 'class': 'form-check-label' },
	                                    _react2.default.createElement('input', { type: 'radio', 'class': 'form-check-input', name: 'optbanners', value: 'no', onChange: this.handleChange }),
	                                    '\xA0No\xA0'
	                                  )
	                                )
	                              )
	                            ),
	                            this.state.opener && _react2.default.createElement(
	                              'div',
	                              { 'class': 'form-group row' },
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'form-group col-md-6' },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  'Enter cost'
	                                ),
	                                _react2.default.createElement('input', { type: 'text', 'class': 'form-control form-input', name: 'optbannerprice', onChange: this.updatePrice })
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'form-group col-md-6' },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  'Select Period'
	                                ),
	                                _react2.default.createElement(
	                                  'select',
	                                  {
	                                    name: 'optbannerperiod',
	                                    onChange: this.handleChange,
	                                    className: 'form-control selectpicker banner_period', title: 'Banner Expiration Period' },
	                                  _react2.default.createElement(
	                                    'option',
	                                    { value: '12' },
	                                    '12 Months'
	                                  ),
	                                  _react2.default.createElement(
	                                    'option',
	                                    { value: '10' },
	                                    '10 Months'
	                                  ),
	                                  _react2.default.createElement(
	                                    'option',
	                                    { value: '8' },
	                                    '8 Months'
	                                  ),
	                                  _react2.default.createElement(
	                                    'option',
	                                    { value: '6' },
	                                    '6 Months'
	                                  ),
	                                  _react2.default.createElement(
	                                    'option',
	                                    { value: '3' },
	                                    '3 Months'
	                                  ),
	                                  _react2.default.createElement(
	                                    'option',
	                                    { value: '2' },
	                                    '2 Months'
	                                  ),
	                                  _react2.default.createElement(
	                                    'option',
	                                    { value: '1' },
	                                    '1 Month'
	                                  )
	                                )
	                              )
	                            )
	                          ),
	                          _react2.default.createElement('br', null),
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'form-row' },
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'form-group col-md-12' },
	                              _react2.default.createElement(
	                                'label',
	                                null,
	                                'Choose the Period'
	                              ),
	                              _react2.default.createElement(
	                                'select',
	                                {
	                                  name: 'period',
	                                  onChange: this.handleChange,
	                                  className: 'form-control selectpicker plan_period', title: 'Period' },
	                                _react2.default.createElement(
	                                  'option',
	                                  { value: '365' },
	                                  '12 Months'
	                                ),
	                                _react2.default.createElement(
	                                  'option',
	                                  { value: '183' },
	                                  '6 Months'
	                                )
	                              )
	                            )
	                          ),
	                          _react2.default.createElement('br', null),
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'form-row' },
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'form-group col-md-12' },
	                              _react2.default.createElement(
	                                'label',
	                                null,
	                                'Choose the Plan'
	                              ),
	                              _react2.default.createElement(
	                                'select',
	                                { title: 'Select', name: 'nplan_id', className: 'form-control', onChange: this.showprice },
	                                _react2.default.createElement(
	                                  'option',
	                                  { value: '' },
	                                  'select'
	                                ),
	                                this.state.package_list.map(function (items, i) {
	                                  {
	
	                                    return _react2.default.createElement(
	                                      'option',
	                                      { value: i },
	                                      items.plan_name
	                                    );
	                                  }
	                                })
	                              )
	                            )
	                          ),
	                          this.state.showprice && _react2.default.createElement(
	                            'div',
	                            { 'class': 'form-row col-md-12' },
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'table-responsive' },
	                              _react2.default.createElement(
	                                'table',
	                                { 'class': 'table table-condensed' },
	                                _react2.default.createElement(
	                                  'thead',
	                                  null,
	                                  _react2.default.createElement(
	                                    'tr',
	                                    null,
	                                    _react2.default.createElement(
	                                      'td',
	                                      null,
	                                      _react2.default.createElement(
	                                        'strong',
	                                        null,
	                                        'Item'
	                                      )
	                                    ),
	                                    _react2.default.createElement(
	                                      'td',
	                                      { 'class': 'text-center' },
	                                      _react2.default.createElement(
	                                        'strong',
	                                        null,
	                                        'Price'
	                                      )
	                                    ),
	                                    _react2.default.createElement(
	                                      'td',
	                                      { 'class': 'text-center' },
	                                      _react2.default.createElement(
	                                        'strong',
	                                        null,
	                                        'Quantity'
	                                      )
	                                    ),
	                                    _react2.default.createElement(
	                                      'td',
	                                      { 'class': 'text-right' },
	                                      _react2.default.createElement(
	                                        'strong',
	                                        null,
	                                        'Totals'
	                                      )
	                                    )
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'tbody',
	                                  null,
	                                  _react2.default.createElement(
	                                    'tr',
	                                    null,
	                                    _react2.default.createElement(
	                                      'td',
	                                      null,
	                                      this.state.plan_name
	                                    ),
	                                    _react2.default.createElement(
	                                      'td',
	                                      { 'class': 'text-center' },
	                                      '\u20B9',
	                                      Number(this.state.plan_price).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
	                                    ),
	                                    _react2.default.createElement(
	                                      'td',
	                                      { 'class': 'text-center' },
	                                      '1'
	                                    ),
	                                    _react2.default.createElement(
	                                      'td',
	                                      { 'class': 'text-right' },
	                                      '\u20B9',
	                                      Number(this.state.plan_price).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
	                                    )
	                                  ),
	                                  _react2.default.createElement(
	                                    'tr',
	                                    null,
	                                    _react2.default.createElement('td', { 'class': 'thick-line' }),
	                                    _react2.default.createElement('td', { 'class': 'thick-line' }),
	                                    _react2.default.createElement(
	                                      'td',
	                                      { 'class': 'thick-line text-center' },
	                                      _react2.default.createElement(
	                                        'strong',
	                                        null,
	                                        'Subtotal'
	                                      )
	                                    ),
	                                    _react2.default.createElement(
	                                      'td',
	                                      { 'class': 'thick-line text-right' },
	                                      '\u20B9',
	                                      Number(this.state.sub_total).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
	                                    )
	                                  ),
	                                  _react2.default.createElement(
	                                    'tr',
	                                    null,
	                                    _react2.default.createElement('td', { 'class': 'no-line' }),
	                                    _react2.default.createElement('td', { 'class': 'no-line' }),
	                                    _react2.default.createElement(
	                                      'td',
	                                      { 'class': 'no-line text-center' },
	                                      _react2.default.createElement(
	                                        'strong',
	                                        null,
	                                        'Discount'
	                                      )
	                                    ),
	                                    _react2.default.createElement(
	                                      'td',
	                                      { 'class': 'no-line text-right' },
	                                      '\u20B9',
	                                      Number(this.state.discount).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
	                                    )
	                                  ),
	                                  this.state.optbanners == 'yes' && _react2.default.createElement(
	                                    'tr',
	                                    null,
	                                    _react2.default.createElement('td', { 'class': 'no-line' }),
	                                    _react2.default.createElement('td', { 'class': 'no-line' }),
	                                    _react2.default.createElement(
	                                      'td',
	                                      { 'class': 'no-line text-center' },
	                                      _react2.default.createElement(
	                                        'strong',
	                                        null,
	                                        'Cost of Banners/Premium listing and etc'
	                                      )
	                                    ),
	                                    _react2.default.createElement(
	                                      'td',
	                                      { 'class': 'no-line text-right' },
	                                      '\u20B9',
	                                      Number(this.state.optbannerprice).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
	                                    )
	                                  ),
	                                  _react2.default.createElement(
	                                    'tr',
	                                    null,
	                                    _react2.default.createElement('td', { 'class': 'no-line' }),
	                                    _react2.default.createElement('td', { 'class': 'no-line' }),
	                                    _react2.default.createElement(
	                                      'td',
	                                      { 'class': 'no-line text-center' },
	                                      _react2.default.createElement(
	                                        'strong',
	                                        null,
	                                        'Total'
	                                      )
	                                    ),
	                                    _react2.default.createElement(
	                                      'td',
	                                      { 'class': 'no-line text-right' },
	                                      '\u20B9',
	                                      Number(this.state.total).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
	                                    )
	                                  )
	                                )
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'form-row' },
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'form-group col-md-12' },
	                              _react2.default.createElement(
	                                'button',
	                                { id: 'genpaylink', 'class': 'btn btn-primary btn-sm', onClick: this.generatePayLink },
	                                'Generate Pay Link'
	                              )
	                            )
	                          ),
	                          this.state.loading && _react2.default.createElement(
	                            'div',
	                            { 'class': 'loadinganimation' },
	                            _react2.default.createElement('img', { src: _bewiseloading2.default })
	                          ),
	                          !this.state.loading && this.state.generated && _react2.default.createElement(
	                            'div',
	                            { 'class': 'form-row' },
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'razresult' },
	                              _react2.default.createElement('input', { type: 'hidden', id: 'short_url', value: this.state.short_url }),
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'paylinkcss' },
	                                this.state.short_url
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'clickcopy', onClick: this.copyit },
	                                _react2.default.createElement('i', { 'class': 'fa fa-clone', 'aria-hidden': 'true' })
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'mailaction' },
	                              _react2.default.createElement(
	                                'p',
	                                null,
	                                'You can send payment link to your or given email address below'
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'form-group' },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  'Email Address:'
	                                ),
	                                _react2.default.createElement('input', { type: 'text', name: 'email_id', 'class': 'form-control', onChange: this.handleChange, value: this.state.email_id })
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'form-group' },
	                                _react2.default.createElement(
	                                  'button',
	                                  { 'class': 'btn btn-primary btn-sm', onClick: this.sendMail_PaymentLink, id: 'clicktosend' },
	                                  'Send'
	                                )
	                              )
	                            )
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'modal-footer' },
	                      _react2.default.createElement(
	                        'button',
	                        { type: 'button', 'class': 'btn btn-light', 'data-dismiss': 'modal' },
	                        'Close'
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { 'class': 'modal fade', role: 'dialog', tabindex: '-1', id: 'discount-modal' },
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'modal-dialog modal-md modal-dialog-centered', role: 'document' },
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'modal-content' },
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'modal-header' },
	                      _react2.default.createElement(
	                        'h5',
	                        { 'class': 'modal-title' },
	                        'Discount Information'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'modal-body' },
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': '' },
	                        this.state.id == 0 && _react2.default.createElement(
	                          'div',
	                          null,
	                          _react2.default.createElement(
	                            'b',
	                            null,
	                            'Not Set Yet'
	                          )
	                        ),
	                        _react2.default.createElement('br', null),
	                        _react2.default.createElement(
	                          'div',
	                          null,
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            'This discount will be applied on upgrading your existing plan in subscription page'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'radiobuttons' },
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'form-check form-check-inline' },
	                            _react2.default.createElement('input', { 'class': 'form-check-input', type: 'radio', name: 'discount', value: '5', checked: this.state.discount === "5", onChange: this.handleChangeRadio }),
	                            _react2.default.createElement(
	                              'label',
	                              { 'class': 'form-check-label featured_label', 'for': 'exampleRadios1' },
	                              '5%'
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'form-check form-check-inline' },
	                            _react2.default.createElement('input', { 'class': 'form-check-input', type: 'radio', name: 'discount', value: '10', checked: this.state.discount === "10", onChange: this.handleChangeRadio }),
	                            _react2.default.createElement(
	                              'label',
	                              { 'class': 'form-check-label featured_label', 'for': 'exampleRadios2' },
	                              '10%'
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'form-check form-check-inline' },
	                            _react2.default.createElement('input', { 'class': 'form-check-input', type: 'radio', name: 'discount', value: '15', checked: this.state.discount === "15", onChange: this.handleChangeRadio }),
	                            _react2.default.createElement(
	                              'label',
	                              { 'class': 'form-check-label featured_label', 'for': 'exampleRadios2' },
	                              '15%'
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'form-check form-check-inline' },
	                            _react2.default.createElement('input', { 'class': 'form-check-input', type: 'radio', name: 'discount', value: '20', checked: this.state.discount === "20", onChange: this.handleChangeRadio }),
	                            _react2.default.createElement(
	                              'label',
	                              { 'class': 'form-check-label featured_label', 'for': 'exampleRadios2' },
	                              '20%'
	                            )
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'modal-footer' },
	                      _react2.default.createElement(
	                        'button',
	                        { type: 'button', 'class': 'btn btn-light', 'data-dismiss': 'modal' },
	                        'Cancel'
	                      ),
	                      this.state.id == 0 && _react2.default.createElement(
	                        'button',
	                        { type: 'button', 'class': 'btn btn-success', onClick: function onClick() {
	                            _this9.set();
	                          } },
	                        'Set'
	                      ),
	                      this.state.id != 0 && _react2.default.createElement(
	                        'button',
	                        { type: 'button', 'class': 'btn btn-success', onClick: function onClick() {
	                            _this9.update();
	                          } },
	                        'Update'
	                      ),
	                      this.state.id != 0 && _react2.default.createElement(
	                        'button',
	                        { type: 'button', 'class': 'btn btn-success', 'data-dismiss': 'modal', 'aria-label': 'Close', onClick: function onClick() {
	                            _this9.listDelDiscount();
	                          } },
	                        'Remove'
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(_reactNotifications.NotificationContainer, null)
	        )
	      );
	    }
	  }]);
	
	  return partnerDetail;
	}(_react.Component);
	
	exports.default = partnerDetail;

/***/ },
/* 956 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _reactAutosuggest = __webpack_require__(86);
	
	var _reactAutosuggest2 = _interopRequireDefault(_reactAutosuggest);
	
	var _reactstrap = __webpack_require__(17);
	
	var _FetchCall = __webpack_require__(4);
	
	var _reactJsPagination = __webpack_require__(33);
	
	var _reactJsPagination2 = _interopRequireDefault(_reactJsPagination);
	
	__webpack_require__(18);
	
	var _reactNotifications = __webpack_require__(16);
	
	var _reactDatepicker = __webpack_require__(279);
	
	var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
	
	__webpack_require__(267);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import { Editor } from '@tinymce/tinymce-react';
	
	//import Pagination from 'rc-pagination';
	
	
	var partnerList = function (_Component) {
	  _inherits(partnerList, _Component);
	
	  function partnerList(props) {
	    _classCallCheck(this, partnerList);
	
	    var _this = _possibleConstructorReturn(this, (partnerList.__proto__ || Object.getPrototypeOf(partnerList)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var url = new URL(window.location.href);
	    var location = url.searchParams.get("location");
	    var auth_data = JSON.parse(localStorage.getItem("user_data"));
	    _this.state = {
	
	      logged: localStorage.getItem("authentication"),
	      auth_data: JSON.parse(localStorage.getItem("user_data")),
	      location: localStorage.getItem("location") ? localStorage.getItem("location") : 'Bengaluru',
	      partnerList: [],
	      exportbtndisabled: false,
	      PER_PAGE: 15,
	      total: 0,
	      loading: true,
	      searchby: '',
	      activePage: 0,
	      offset: 0,
	      thisExportBtnText: 'Export',
	      monthList: [{ no: 1, mon: 'Jan' }, { no: 2, mon: 'Feb' }, { no: 3, mon: 'Mar' }, { no: 4, mon: 'Apr' }, { no: 5, mon: 'May' }, { no: 6, mon: 'Jun' }, { no: 7, mon: 'Jul' }, { no: 8, mon: 'Aug' }, { no: 9, mon: 'Sep' }, { no: 10, mon: 'Oct' }, { no: 11, mon: 'Nov' }, { no: 12, mon: 'Dec' }]
	    };
	
	    return _this;
	  }
	
	  _createClass(partnerList, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	
	      var THIS = this;
	      (0, _jquery2.default)(document).on('click', '.extend', function () {
	        console.log((0, _jquery2.default)(this).attr('id'));
	        THIS.extenPeriod((0, _jquery2.default)(this).attr('id'), '2022-05-09');
	      });
	      (0, _jquery2.default)(document).on('click', '.remove_role', function () {
	        var deact_id = (0, _jquery2.default)(this).data("id");
	        THIS.disapproveuser(deact_id);
	      });
	
	      (0, _jquery2.default)(document).on('click', '.activate', function () {
	        var deact_id = (0, _jquery2.default)(this).data("id");
	        THIS.activateuser(deact_id);
	      });
	
	      (0, _jquery2.default)(document).on('click', '.trash', function () {
	        var trash_id = (0, _jquery2.default)(this).data("id");
	        THIS.trashit(trash_id);
	      });
	
	      (0, _jquery2.default)(document).on('click', '.resetpassword', function () {
	        var trash_id = (0, _jquery2.default)(this).data("id");
	        THIS.sendResetPassword(trash_id);
	      });
	
	      (0, _jquery2.default)(document).on('click', '.setDiscount', function () {
	
	        var item_id = (0, _jquery2.default)(this).data("id");
	
	        THIS.openSetDiscount(item_id);
	      });
	
	      (0, _jquery2.default)(document).on('click', '.sendOTPmail', function () {
	        var add_id = (0, _jquery2.default)(this).data("id");
	
	        THIS.sendOTPMail(add_id);
	      });
	
	      this.getTotal('partners');
	      this.getList();
	    }
	  }, {
	    key: 'extenPeriod',
	    value: function extenPeriod(vendor_id, expire_date) {
	      //let list = this.state.datalist;
	      //let current = list.filter((item => item.vendor_id == id));
	      //if (current.length > 0) {
	      this.setState({
	        confirmModal: true,
	        expire_date: new Date(expire_date),
	        vendor_id: vendor_id
	      });
	      // }
	    }
	  }, {
	    key: 'sendResetPassword',
	    value: function sendResetPassword() {
	      var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	      if (confirm("Are you sure to reset password and send it to their email address?") == true) {
	        var ins = JSON.stringify({
	          id: id
	        });
	        (0, _FetchCall.resetPasswordSend)(ins).then(function (res) {
	
	          if (res.status === 1) {
	
	            _reactNotifications.NotificationManager.success(res.message);
	          } else {
	
	            _reactNotifications.NotificationManager.error(res.message);
	          }
	        });
	      }
	    }
	  }, {
	    key: 'trashit',
	    value: function trashit() {
	      var deact_id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	      if (confirm("Are you sure to move to trash?") == true) {
	        var ins = JSON.stringify({
	          id: deact_id
	        });
	        (0, _FetchCall.movetoTrash)(ins).then(function (res) {
	
	          if (res.status === 1) {
	
	            _reactNotifications.NotificationManager.success(res.message);
	
	            setTimeout(function () {
	              window.location.reload();
	            }, 2000);
	          } else {
	
	            _reactNotifications.NotificationManager.error(res.message);
	          }
	        });
	      }
	    }
	  }, {
	    key: 'activateuser',
	    value: function activateuser() {
	      var activating_id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	      if (confirm("Are you sure to activate this?") == true) {
	        var ins = JSON.stringify({
	          id: activating_id
	        });
	        (0, _FetchCall.activatePartner)(ins).then(function (res) {
	
	          if (res.status === 1) {
	
	            _reactNotifications.NotificationManager.success(res.message);
	
	            setTimeout(function () {
	              window.location.reload();
	            }, 2000);
	          } else {
	
	            _reactNotifications.NotificationManager.error(res.message);
	          }
	        });
	      }
	    }
	  }, {
	    key: 'disapproveuser',
	    value: function disapproveuser() {
	      var deact_id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	      if (confirm("Are you sure to deativate this?") == true) {
	        var ins = JSON.stringify({
	          id: deact_id
	        });
	        (0, _FetchCall.deActivatePartner)(ins).then(function (res) {
	
	          if (res.status === 1) {
	
	            _reactNotifications.NotificationManager.success(res.message);
	
	            setTimeout(function () {
	              window.location.reload();
	            }, 2000);
	          } else {
	
	            _reactNotifications.NotificationManager.error(res.message);
	          }
	        });
	      }
	    }
	  }, {
	    key: 'sendOTPMail',
	    value: function sendOTPMail() {
	      var add_id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	
	      var ins = JSON.stringify({
	        login_id: add_id
	      });
	      (0, _FetchCall.findpartnersendotplink)(ins).then(function (res) {
	        if (res.status == 1) {
	          alert("Verification code is sent");
	        } else {
	
	          alert("Error sending verfication code");
	          return false;
	        }
	      });
	    }
	  }, {
	    key: 'handlePageChange',
	    value: function handlePageChange(pageNumber) {
	
	      console.log('active page is ' + pageNumber);
	
	      this.setState({ activePage: pageNumber });
	
	      //this.getTotal('bw_schools');
	      this.getList(pageNumber);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          partnerList = _state.partnerList,
	          exportbtndisabled = _state.exportbtndisabled;
	      var _state2 = this.state,
	          eventList = _state2.eventList,
	          currentPage = _state2.currentPage,
	          PER_PAGE = _state2.PER_PAGE,
	          totalCount = _state2.totalCount,
	          total = _state2.total;
	
	
	      var year = 2019;
	      var years = Array.from(new Array(10), function (val, index) {
	        return index + year;
	      });
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'col-lg-12 grid-margin stretch-card' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card-body' },
	                _react2.default.createElement(
	                  'h4',
	                  { 'class': 'card-title' },
	                  'Partners'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'float-right' },
	                  _react2.default.createElement(
	                    'button',
	                    { disabled: exportbtndisabled, 'class': 'btn btn-primary btn-sm', onClick: function onClick() {
	                        return _this2.schoolExport();
	                      } },
	                    this.state.thisExportBtnText
	                  ),
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'p',
	                  { 'class': 'card-description' },
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'cityselection' },
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'leftaligned' },
	                      _react2.default.createElement(
	                        'select',
	                        { name: 'location', 'class': 'form-control', onChange: function onChange(e) {
	                            return _this2.handleChangeN(e);
	                          },
	                          value: this.state.location },
	                        _react2.default.createElement(
	                          'option',
	                          { value: '' },
	                          'select city'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'Bengaluru' },
	                          'Bengaluru'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'Chennai' },
	                          'Chennai'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'Indore' },
	                          'Indore'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'Hosur' },
	                          'Hosur'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'Coimbatore' },
	                          'Coimbatore'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'Madurai' },
	                          'Madurai'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'Mysore' },
	                          'Mysore'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'Mumbai' },
	                          'Mumbai'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'Kolkata' },
	                          'Kolkata'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'New Delhi' },
	                          'New Delhi'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'Jaipur' },
	                          'Jaipur'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'Chandigarh' },
	                          'Chandigarh'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'Pune' },
	                          'Pune'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'Kochi' },
	                          'Kochi'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'Indore' },
	                          'Indore'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'Noida' },
	                          'Noida'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'Agra' },
	                          'Agra'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'Puducherry' },
	                          'Puducherry'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'Tiruchirappalli' },
	                          'Tiruchirappalli'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'leftaligned' },
	                      _react2.default.createElement(
	                        'select',
	                        { className: 'form-control selectpicker', onChange: this.handleChangeN,
	                          name: 'year', title: 'Select Years', value: this.state.year },
	                        _react2.default.createElement(
	                          'option',
	                          { value: '' },
	                          'Select Year'
	                        ),
	                        years.map(function (item, i) {
	                          return _react2.default.createElement(
	                            'option',
	                            { value: item },
	                            item
	                          );
	                        })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'leftaligned' },
	                      _react2.default.createElement(
	                        'select',
	                        { className: 'form-control selectpicker', onChange: this.handleChangeN,
	                          name: 'month', title: 'Select Month', value: this.state.month },
	                        _react2.default.createElement(
	                          'option',
	                          { value: '' },
	                          'Select Month'
	                        ),
	                        this.state.monthList.map(function (item, i) {
	                          return _react2.default.createElement(
	                            'option',
	                            { value: item.no },
	                            item.mon
	                          );
	                        })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'leftaligned' },
	                      _react2.default.createElement('input', { type: 'text', name: 'keyword', 'class': 'form-control', placeholder: 'Keyword', onChange: this.handleChangeN })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'leftaligned' },
	                      _react2.default.createElement(
	                        'button',
	                        { 'class': 'btn btn-primary btn-sm', onClick: this.filterShow },
	                        'show'
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'table-responsive pt-3' },
	                  _react2.default.createElement(
	                    'table',
	                    { id: 'tablebw' },
	                    _react2.default.createElement(
	                      'thead',
	                      { 'class': 'thead-dark' },
	                      _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'S.No'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Name'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'City'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Email Id'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Type'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Category'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Created on'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Login'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Account Status'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Action'
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'tbody',
	                      null,
	                      partnerList.length > 0 && partnerList.map(function (item, i) {
	
	                        return _react2.default.createElement(
	                          'tr',
	                          null,
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            i + 1
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.name
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.location
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.email_id
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.user_type
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.category_name
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.created_date
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            { className: item.is_active == 1 ? "green" : item.is_active == 3 ? "orange" : "red" },
	                            item.is_active == 1 ? "Active" : item.is_active == 3 ? "Deactivated" : "Inactive"
	                          ),
	                          _react2.default.createElement('td', { dangerouslySetInnerHTML: { __html: item.status } }),
	                          _react2.default.createElement('td', { 'class': 'actionbtns', dangerouslySetInnerHTML: { __html: item.action } })
	                        );
	                      }),
	                      partnerList.length == 0 && _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                          'td',
	                          { colspan: '9' },
	                          'No data'
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'text-center' },
	                    _react2.default.createElement(_reactJsPagination2.default, {
	                      activePage: this.state.activePage,
	                      itemsCountPerPage: PER_PAGE,
	                      totalItemsCount: this.state.total,
	                      pageRangeDisplayed: 5,
	                      activeClass: "pagination__link--active",
	                      onChange: this.handlePageChange.bind(this),
	                      prevPageText: 'previous',
	                      nextPageText: 'next'
	                    })
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.Modal,
	            { isOpen: this.state.confirmModal, className: '' },
	            _react2.default.createElement(
	              'form',
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'modal-header text-center' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-12' },
	                    _react2.default.createElement(
	                      'h3',
	                      null,
	                      'Extend Expire Date'
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactstrap.ModalBody,
	                { className: '' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row pad-all' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'form-group col-md-6' },
	                    _react2.default.createElement(
	                      'label',
	                      null,
	                      'Current Expire Date',
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'astrick' },
	                        '*'
	                      )
	                    ),
	                    _react2.default.createElement(_reactDatepicker2.default, {
	                      autocomplete: 'off',
	                      className: 'form-control input-group-date',
	                      selected: this.state.expire_date,
	                      name: 'expire_date',
	                      id: 'expire_date',
	                      dateFormat: 'MMMM d, yyyy',
	                      disabled: 'disabled',
	                      required: true
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'form-group col-md-6' },
	                    _react2.default.createElement(
	                      'label',
	                      null,
	                      'Choose Extend Month',
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'astrick' },
	                        '*'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'select',
	                      { className: 'form-control', onChange: this.handleMonth, name: 'add_month' },
	                      _react2.default.createElement(
	                        'option',
	                        { value: '' },
	                        'Select Month'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: '3' },
	                        '3 Months'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: '6' },
	                        '6 Months'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: '9' },
	                        '9 Months'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'form-group col-md-6' },
	                    _react2.default.createElement(
	                      'label',
	                      null,
	                      'New Expire Date',
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'astrick' },
	                        '*'
	                      )
	                    ),
	                    _react2.default.createElement(_reactDatepicker2.default, {
	                      autocomplete: 'off',
	                      className: 'form-control input-group-date',
	                      selected: this.state.new_date,
	                      name: 'new_date',
	                      id: 'new_date',
	                      dateFormat: 'MMMM d, yyyy',
	                      disabled: 'disabled',
	                      required: true
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactstrap.ModalFooter,
	                null,
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-12 pull-right' },
	                    _react2.default.createElement(
	                      'button',
	                      { className: 'btn btn-sm btn-default', onClick: this.cancelPop },
	                      'No'
	                    ),
	                    _react2.default.createElement(
	                      'button',
	                      { type: 'submit', className: 'btn btn-sm btn-success', onClick: this.updateExpire },
	                      'Yes'
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(_reactNotifications.NotificationContainer, null)
	        )
	      );
	    }
	  }]);
	
	  return partnerList;
	}(_react.Component);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this3 = this;
	
	  this.cancelPop = function (e) {
	    e.preventDefault();
	    _this3.setState({
	      confirmModal: false,
	      expire_date: '',
	      vendor_id: 0
	    });
	  };
	
	  this.getTotal = function (vertical) {
	    var location = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	
	    var locationselected = location == '' ? _this3.state.location : location;
	
	    var ins = JSON.stringify({
	      vertical: vertical,
	      location: locationselected,
	      searchby: _this3.state.searchby
	    });
	
	    (0, _FetchCall.getTotalPartners)(ins).then(function (res) {
	
	      _this3.setState({ loading: true });
	
	      if (res.status == 1) {
	
	        _this3.setState({
	
	          total: res.total
	
	        });
	      }
	    });
	  };
	
	  this.handleChangeN = function (e) {
	    _this3.setState(_defineProperty({}, e.target.name, e.target.value));
	
	    localStorage.setItem("location", e.target.value);
	  };
	
	  this.filterShow = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	    var _state$auth_data, login_id, role, ins, instotal;
	
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            _state$auth_data = _this3.state.auth_data, login_id = _state$auth_data.login_id, role = _state$auth_data.role;
	            ins = JSON.stringify({
	              login_id: login_id,
	              role: role,
	              location: _this3.state.location,
	              keyword: _this3.state.keyword,
	              year: _this3.state.year,
	              month: _this3.state.month
	            });
	
	            (0, _FetchCall.getPartnerPaged)(ins).then(function (res) {
	              if (res.status == 1) {
	                _this3.setState({
	                  partnerList: res.data
	
	                });
	              } else {
	                _this3.setState({
	                  partnerList: []
	                });
	              }
	            });
	
	            instotal = JSON.stringify({
	              vertical: 'partners',
	              location: _this3.state.location,
	              searchby: _this3.state.keyword
	            });
	
	
	            (0, _FetchCall.getTotalPartners)(instotal).then(function (res) {
	
	              _this3.setState({ loading: true });
	
	              if (res.status == 1) {
	
	                _this3.setState({
	
	                  total: res.total
	
	                });
	              }
	            });
	
	          case 5:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, _this3);
	  }));
	
	  this.getList = function () {
	    var pageNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	    var location = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	    var _state$auth_data2 = _this3.state.auth_data,
	        login_id = _state$auth_data2.login_id,
	        role = _state$auth_data2.role;
	
	
	    _this3.setState({ activePage: pageNumber });
	
	    var newOffset = pageNumber == 1 ? 0 : (pageNumber - 1) * _this3.state.PER_PAGE % _this3.state.total;
	
	    var locationselected = location == '' ? _this3.state.location : location;
	
	    var ins = JSON.stringify({
	      vendor_id: login_id,
	      role: role,
	      location: locationselected,
	      searchby: _this3.state.searchby,
	      perpage: _this3.state.PER_PAGE,
	      offset: newOffset
	    });
	
	    (0, _FetchCall.getPartnerPaged)(ins).then(function (res) {
	
	      _this3.setState({ loading: true });
	
	      if (res.status == 1) {
	
	        _this3.setState({ loading: !_this3.state.loading });
	
	        _this3.setState({
	
	          partnerList: res.data
	
	        });
	      } else {
	
	        _this3.setState({ loading: !_this3.state.loading });
	
	        _this3.setState({
	          partnerList: []
	        });
	      }
	    });
	  };
	
	  this.handleChange = function (date) {
	    console.log('value', date);
	    _this3.setState({ expire_date: date });
	  };
	
	  this.handleMonth = function (e) {
	    var months = e.target.value;
	    var cur_date = new Date((0, _jquery2.default)('#expire_date').val());
	    var newdate = new Date(cur_date.setMonth(cur_date.getMonth() + parseInt(months)));
	    _this3.setState({
	      new_date: newdate
	    });
	    // console.log('value', date)
	    // this.setState({ new_date: date });
	  };
	
	  this.updateExpire = function (e) {
	    e.preventDefault();
	    var req = JSON.stringify({
	      vendor_id: _this3.state.vendor_id,
	      expire_date: _this3.state.new_date,
	      url: 'updateExpire'
	    });
	    (0, _FetchCall.partnerApi)(req).then(function (res) {
	      //let toastr = '';
	      if (res.status === 1) {
	        //toastr = window.toastr.success;
	        setTimeout(function () {
	          window.location.reload();
	        }, 1000);
	      } else {
	        //toastr = window.toastr.error;
	      }
	    });
	  };
	};
	
	exports.default = partnerList;

/***/ },
/* 957 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _FetchCall2 = _interopRequireDefault(_FetchCall);
	
	var _chart = __webpack_require__(83);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import Partnerlayout from './Partnerlayout';
	
	//import { Editor } from '@tinymce/tinymce-react';
	
	var doughnutPieOptions = {
	  responsive: true,
	  animation: {
	    animateScale: true,
	    animateRotate: true
	  }
	};
	
	var partnerStats = function (_Component) {
	  _inherits(partnerStats, _Component);
	
	  function partnerStats(props) {
	    _classCallCheck(this, partnerStats);
	
	    var _this = _possibleConstructorReturn(this, (partnerStats.__proto__ || Object.getPrototypeOf(partnerStats)).call(this, props));
	
	    _this.state = {
	      school_data: []
	    };
	    return _this;
	  }
	
	  _createClass(partnerStats, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var req = {
	        url: 'school_data'
	      };
	
	      (0, _FetchCall.adminDashboard)(JSON.stringify(req)).then(function (response) {
	        if (response.status === 1) {
	          _this2.setSchoolChart(response.result);
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'row  mt-3' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'col-xl-4 d-flex grid-margin stretch-card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'card-body' },
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'd-flex flex-wrap justify-content-between' },
	                    _react2.default.createElement(
	                      'h4',
	                      { 'class': 'card-title mb-3' },
	                      'Overall Partners Statistics'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'col-12' },
	                      _react2.default.createElement('canvas', { id: 'barChartVisitors' })
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { 'class': 'row' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'col-lg-3 text-center' },
	              _react2.default.createElement(
	                'label',
	                null,
	                'Average of Data Completion'
	              ),
	              _react2.default.createElement('div', { id: 'circleProgress6', 'class': 'progressbar-js-circle rounded p-3' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { 'class': 'col-lg-9 text-center' },
	              _react2.default.createElement(
	                'label',
	                null,
	                'Paid and Unpaid Partners'
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return partnerStats;
	}(_react.Component);
	
	exports.default = partnerStats;

/***/ },
/* 958 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Notification = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(17);
	
	var _FetchCall = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Notification = function (_Component) {
	  _inherits(Notification, _Component);
	
	  function Notification(props) {
	    _classCallCheck(this, Notification);
	
	    var _this = _possibleConstructorReturn(this, (Notification.__proto__ || Object.getPrototypeOf(Notification)).call(this, props));
	
	    _this.getNotification = function () {
	      var req = JSON.stringify({
	        role: 4,
	        partner_id: _this.state.auth_data.partner_id,
	        url: 'get_pnotification'
	      });
	      (0, _FetchCall.pNotification)(req).then(function (res) {
	        if (res.status === 1) {
	          _this.setState({
	            notification_list: res.list
	          });
	        }
	      });
	    };
	
	    _this.dimissNotif = function (index) {
	      var notification_list = _this.state.notification_list;
	      notification_list[index].is_read = 0;
	      _this.setState({
	        notification_list: notification_list
	      });
	      var req = JSON.stringify({
	        role: 4,
	        noti_id: notification_list[index].id,
	        url: 'read_notif'
	      });
	      (0, _FetchCall.pNotification)(req);
	    };
	
	    _this.state = {
	      auth: localStorage.getItem("authentication") ? localStorage.getItem("authentication") : false,
	      auth_data: localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data")) : {},
	      isPartner: false,
	      showNotifi: false,
	      notification_list: []
	    };
	    _this.getNotification();
	    return _this;
	  }
	
	  _createClass(Notification, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var count = this.state.notification_list.filter(function (item) {
	        return item.is_read == 1;
	      }).length;
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'noti-sec' },
	          _react2.default.createElement(
	            _reactstrap.Dropdown,
	            { direction: 'left', isOpen: this.state.showNotifi },
	            _react2.default.createElement(
	              _reactstrap.DropdownToggle,
	              {
	                'data-toggle': 'dropdown',
	                tag: 'span'
	              },
	              _react2.default.createElement(
	                'div',
	                { className: 'pointer' },
	                _react2.default.createElement('i', { 'class': 'fa fa-bell', 'aria-hidden': 'true' }),
	                ' ',
	                count > 0 && _react2.default.createElement(
	                  'span',
	                  { className: 'noti-count' },
	                  count
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactstrap.DropdownMenu,
	              { className: 'noti-drop-sec', container: 'body' },
	              count > 0 ? this.state.notification_list.map(function (item, i) {
	                if (item.is_read == 1) return _react2.default.createElement(
	                  _reactstrap.DropdownItem,
	                  { className: 'noti-list' },
	                  item.text,
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'pull-right', onClick: function onClick() {
	                        return _this2.dimissNotif(i);
	                      } },
	                    _react2.default.createElement('i', { 'class': 'fa fa-times pl-5', 'aria-hidden': 'true' })
	                  )
	                );
	              }) : _react2.default.createElement(
	                _reactstrap.DropdownItem,
	                { className: 'noti-list' },
	                'No items Found'
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Notification;
	}(_react.Component);
	
	exports.Notification = Notification;

/***/ },
/* 959 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Progress_bar = function Progress_bar(_ref) {
	  var bgcolor = _ref.bgcolor,
	      progress = _ref.progress,
	      height = _ref.height;
	
	
	  var Parentdiv = {
	    height: height,
	    width: '100%',
	    backgroundColor: 'whitesmoke',
	    borderRadius: 40,
	    margin: 50
	  };
	
	  var Childdiv = {
	    height: '100%',
	    width: progress + '%',
	    backgroundColor: bgcolor,
	    borderRadius: 40,
	    textAlign: 'right'
	  };
	
	  var progresstext = {
	    padding: 10,
	    color: 'black',
	    fontWeight: 900
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { style: Parentdiv },
	    _react2.default.createElement(
	      'div',
	      { style: Childdiv },
	      _react2.default.createElement(
	        'span',
	        { style: progresstext },
	        progress + '%'
	      )
	    )
	  );
	};
	
	exports.default = Progress_bar;

/***/ },
/* 960 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _reactstrap = __webpack_require__(17);
	
	var _Tabs = __webpack_require__(65);
	
	var _Tabs2 = _interopRequireDefault(_Tabs);
	
	var _TabsPane = __webpack_require__(64);
	
	var _TabsPane2 = _interopRequireDefault(_TabsPane);
	
	var _reactDataTableComponent = __webpack_require__(53);
	
	var _reactDataTableComponent2 = _interopRequireDefault(_reactDataTableComponent);
	
	var _Common = __webpack_require__(145);
	
	var _about_otherV = __webpack_require__(988);
	
	var _about_otherV2 = _interopRequireDefault(_about_otherV);
	
	var _keyinfo_otherV = __webpack_require__(990);
	
	var _keyinfo_otherV2 = _interopRequireDefault(_keyinfo_otherV);
	
	var _admission_otherV = __webpack_require__(989);
	
	var _admission_otherV2 = _interopRequireDefault(_admission_otherV);
	
	var _GalleryV = __webpack_require__(985);
	
	var _GalleryV2 = _interopRequireDefault(_GalleryV);
	
	var _Media = __webpack_require__(986);
	
	var _Media2 = _interopRequireDefault(_Media);
	
	var _VideosV = __webpack_require__(987);
	
	var _VideosV2 = _interopRequireDefault(_VideosV);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import { Editor } from '@tinymce/tinymce-react';
	
	var partnerAccountInfo = function (_Component) {
	  _inherits(partnerAccountInfo, _Component);
	
	  function partnerAccountInfo(props) {
	    _classCallCheck(this, partnerAccountInfo);
	
	    var _this = _possibleConstructorReturn(this, (partnerAccountInfo.__proto__ || Object.getPrototypeOf(partnerAccountInfo)).call(this, props));
	
	    _this.handleChange = function () {
	      console.log("dfgdgfddfdfdfdf");
	      _this.setState({ keyinfodisabled: false });
	    };
	
	    _this.state = {
	      user_data: localStorage.getItem('user_data') ? JSON.parse(localStorage.getItem('user_data')) : [],
	      authentication: localStorage.getItem('authentication') ? JSON.parse(localStorage.getItem('authentication')) : false,
	      first_name: '',
	      last_name: '',
	      keyinfodisabled: true,
	      admissiondisabled: true,
	      mediadisabled: true,
	      gallerydisabled: true,
	      videosdisabled: true
	    };
	
	    _this.getPageData();
	    _this.handleChange = _this.handleChange.bind(_this);
	
	    return _this;
	  }
	
	  _createClass(partnerAccountInfo, [{
	    key: 'getPageData',
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var _this2 = this;
	
	        var _state$user_data, user_type, login_id, set_id, req;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _state$user_data = this.state.user_data, user_type = _state$user_data.user_type, login_id = _state$user_data.login_id, set_id = _state$user_data.set_id;
	                req = JSON.stringify({
	                  user_type: user_type,
	                  login_id: login_id,
	                  sid: set_id,
	                  url: 'getProfileData'
	                });
	
	                (0, _FetchCall.partnerApi)(req).then(function (res) {
	                  if (res.status === 1) {
	                    var data = res.result;
	                    _this2.setState({
	                      first_name: data.first_name,
	                      last_name: data.last_name
	                    });
	                  }
	                });
	
	              case 3:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function getPageData() {
	        return _ref.apply(this, arguments);
	      }
	
	      return getPageData;
	    }()
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      window.jQuery('.selectpicker').selectpicker('refresh');
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          keyinfodisabled = _state.keyinfodisabled,
	          mediadisabled = _state.mediadisabled,
	          admissiondisabled = _state.admissiondisabled,
	          gallerydisabled = _state.gallerydisabled,
	          videosdisabled = _state.videosdisabled;
	
	
	      var childTabs = [{
	        name: "About",
	        id: "About",
	        defaultChecked: true
	      }, {
	        name: "Key Information",
	        id: "keyinfo"
	        //disabled: keyinfodisabled
	      }, {
	        name: "Admission/Fee",
	        id: "Admission"
	        //disabled: admissiondisabled
	      }, {
	        name: "Gallery",
	        id: "gallery"
	        //disabled: gallerydisabled
	      }, {
	        name: "Videos",
	        id: "videos"
	        //disabled: videosdisabled
	      }];
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'col-12 grid-margin' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card-body' },
	                _react2.default.createElement(
	                  'h4',
	                  { 'class': 'card-title' },
	                  'Account Info ',
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    '(What your customer will see)'
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'desktoponly' },
	                  _react2.default.createElement(
	                    _Tabs2.default,
	                    { tabsetName: 'otherinfo', childTabs: childTabs },
	                    _react2.default.createElement(
	                      _TabsPane2.default,
	                      { id: 'About' },
	                      _react2.default.createElement(_about_otherV2.default, { handleChange: this.handleChange })
	                    ),
	                    _react2.default.createElement(
	                      _TabsPane2.default,
	                      { id: 'keyinfo' },
	                      _react2.default.createElement(_keyinfo_otherV2.default, null)
	                    ),
	                    _react2.default.createElement(
	                      _TabsPane2.default,
	                      { id: 'Admission' },
	                      _react2.default.createElement(_admission_otherV2.default, null)
	                    ),
	                    _react2.default.createElement(
	                      _TabsPane2.default,
	                      { id: 'gallery' },
	                      _react2.default.createElement(_GalleryV2.default, null)
	                    ),
	                    _react2.default.createElement(
	                      _TabsPane2.default,
	                      { id: 'videos' },
	                      _react2.default.createElement(_VideosV2.default, null)
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'mobileonly' },
	                  _react2.default.createElement(_about_otherV2.default, null),
	                  _react2.default.createElement(_keyinfo_otherV2.default, null),
	                  _react2.default.createElement(_admission_otherV2.default, null),
	                  _react2.default.createElement(_GalleryV2.default, null),
	                  _react2.default.createElement(_VideosV2.default, null)
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return partnerAccountInfo;
	}(_react.Component);
	
	exports.default = partnerAccountInfo;

/***/ },
/* 961 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _tinymceReact = __webpack_require__(69);
	
	var _constant = __webpack_require__(21);
	
	__webpack_require__(18);
	
	var _reactNotifications = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var partnerAccountInfo = function (_Component) {
	    _inherits(partnerAccountInfo, _Component);
	
	    function partnerAccountInfo(props) {
	        _classCallCheck(this, partnerAccountInfo);
	
	        var _this = _possibleConstructorReturn(this, (partnerAccountInfo.__proto__ || Object.getPrototypeOf(partnerAccountInfo)).call(this, props));
	
	        _this.submitApprovals = function (e) {
	            _reactNotifications.NotificationManager.success("Thank you, We have received your information for approvals.");
	        };
	
	        _this.saveAbout = function (e) {
	
	            var ver_id = (0, _jquery2.default)(e.target).attr('data-vid');
	            var index = (0, _jquery2.default)(e.target).attr('data-index');
	            var vertical = (0, _jquery2.default)(e.target).attr('data-vertical');
	            var _this$state$user_data = _this.state.user_data,
	                user_type = _this$state$user_data.user_type,
	                login_id = _this$state$user_data.login_id,
	                set_id = _this$state$user_data.set_id;
	
	            if (_this.state.about == '') {
	                _reactNotifications.NotificationManager.info("Sorry, We notice you have not changed anything.");
	            } else {
	                var req = JSON.stringify({
	                    ver_id: ver_id,
	                    organisation_name: _this.state.data.organisation_name,
	                    login_id: login_id,
	                    about: _this.state.about,
	                    vertical: vertical
	                });
	
	                (0, _FetchCall.saveAbout)(req).then(function (res) {
	                    if (res.status === 1) {
	                        _reactNotifications.NotificationManager.success("Thank you, Your About information is submitted");
	                    }
	                });
	            }
	
	            //NotificationManager.success("Thank you, Your information is saved");
	        };
	
	        _this.state = {
	            user_data: localStorage.getItem('user_data') ? JSON.parse(localStorage.getItem('user_data')) : [],
	            authentication: localStorage.getItem('authentication') ? JSON.parse(localStorage.getItem('authentication')) : false,
	            first_name: '',
	            last_name: '',
	            page_data: [],
	            dropdown: [],
	            data: [],
	            about: ''
	        };
	        _this.getPageData();
	
	        return _this;
	    }
	
	    _createClass(partnerAccountInfo, [{
	        key: 'getPageData',
	        value: function () {
	            var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	                var _this2 = this;
	
	                var _state$user_data, user_type, login_id, set_id, req;
	
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                _state$user_data = this.state.user_data, user_type = _state$user_data.user_type, login_id = _state$user_data.login_id, set_id = _state$user_data.set_id;
	                                req = JSON.stringify({
	                                    user_type: user_type,
	                                    login_id: login_id,
	                                    sid: set_id,
	                                    url: 'getProfileData'
	                                });
	
	                                (0, _FetchCall.partnerApi)(req).then(function (res) {
	                                    if (res.status === 1) {
	                                        var data = res.result;
	                                        _this2.setState({
	                                            data: data,
	                                            page_data: data.master_data,
	                                            first_name: data.first_name,
	                                            last_name: data.last_name
	                                        });
	                                    }
	                                });
	
	                            case 3:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function getPageData() {
	                return _ref.apply(this, arguments);
	            }
	
	            return getPageData;
	        }()
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {}
	    }, {
	        key: 'handleChangeAbout',
	        value: function handleChangeAbout(value, i) {
	            var page_data = this.state.page_data;
	            page_data[i]['about'] = value;
	            this.setState({ about: value });
	        }
	    }, {
	        key: 'toggleInfo',
	        value: function toggleInfo() {
	            (0, _jquery2.default)(".infoEditBlock").toggleClass('hidden');
	            var THIS = (0, _jquery2.default)('.expandcollapsebtn');
	
	            if (THIS.text() === 'Expand') {
	                THIS.text("Collapse");
	            } else {
	                THIS.text("Expand");
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var _state = this.state,
	                cards = _state.cards,
	                collapse = _state.collapse,
	                data = _state.data,
	                page_data = _state.page_data,
	                pageurl = _state.pageurl;
	
	
	            return _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _react2.default.createElement(
	                    _layout2.default,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { 'class': 'col-12 grid-margin' },
	                        _react2.default.createElement(
	                            'div',
	                            { 'class': 'card' },
	                            _react2.default.createElement(
	                                'div',
	                                { 'class': 'card-body' },
	                                _react2.default.createElement(
	                                    'h4',
	                                    { 'class': 'card-title' },
	                                    'Account Info ',
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        '(What your customer will see)'
	                                    )
	                                ),
	                                page_data.map(function (item, index) {
	                                    return _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'card' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'card-body' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { 'class': 'card-title' },
	                                                item.category_name,
	                                                ' : ',
	                                                _react2.default.createElement(
	                                                    'b',
	                                                    null,
	                                                    data.organisation_name,
	                                                    ' ',
	                                                    _react2.default.createElement(
	                                                        'span',
	                                                        { style: { fontSize: "10px" } },
	                                                        data.set_id == 3 ? "Branch" : ""
	                                                    )
	                                                ),
	                                                ' ',
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { 'class': 'expandcollapsebtn', onClick: _this3.toggleInfo },
	                                                    'Expand'
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { 'class': 'addressline' },
	                                                _react2.default.createElement(
	                                                    'p',
	                                                    { className: 'mar-btm' },
	                                                    data.address
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { 'class': 'infoEditBlock hidden' },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { 'class': 'info-Edit' },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { 'class': 'titleline-noborder' },
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { 'class': 'blocktitle-strip' },
	                                                            'About Info'
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'inputBlockRow' },
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { 'class': 'form-group col-md-12' },
	                                                                _react2.default.createElement(_tinymceReact.Editor, {
	                                                                    onEditorChange: function onEditorChange(e) {
	                                                                        return _this3.handleChangeAbout(e, index);
	                                                                    },
	                                                                    value: item.about,
	                                                                    apiKey: _constant.TINY_EDITOR,
	                                                                    init: {
	                                                                        height: 400,
	                                                                        plugins: ['lists link image paste'],
	                                                                        toolbar: 'undo redo | formatselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | help'
	                                                                    }
	                                                                })
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { 'class': 'submitBlockRow btnalignright' },
	                                                            _react2.default.createElement(
	                                                                'button',
	                                                                { type: 'button', 'data-vertical': item.cid, 'data-index': index, 'data-vid': item.mid, onClick: _this3.saveAbout, id: 'btnSubmit',
	                                                                    className: 'btn btn-primary btn-sm' },
	                                                                'Submit About info'
	                                                            )
	                                                        )
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { 'class': 'info-Edit' },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { 'class': 'titleline-noborder' },
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { 'class': 'blocktitle-strip' },
	                                                            'Key Information'
	                                                        ),
	                                                        _react2.default.createElement('div', { className: 'inputBlockRow' }),
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { 'class': 'submitBlockRow btnalignright' },
	                                                            _react2.default.createElement(
	                                                                'button',
	                                                                { type: 'submit', id: 'btnSubmit',
	                                                                    className: 'btn btn-primary btn-sm' },
	                                                                'Submit Key info'
	                                                            )
	                                                        )
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { 'class': 'info-Edit' },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { 'class': 'titleline-noborder' },
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { 'class': 'blocktitle-strip' },
	                                                            'Admission Information'
	                                                        ),
	                                                        _react2.default.createElement('div', { className: 'inputBlockRow' }),
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { 'class': 'submitBlockRow btnalignright' },
	                                                            _react2.default.createElement(
	                                                                'button',
	                                                                { type: 'submit', id: 'btnSubmit',
	                                                                    className: 'btn btn-primary btn-sm' },
	                                                                'Submit Admission info'
	                                                            )
	                                                        )
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { 'class': 'info-Edit' },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { 'class': 'titleline-noborder' },
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { 'class': 'blocktitle-strip' },
	                                                            'Gallery'
	                                                        ),
	                                                        _react2.default.createElement('div', { className: 'inputBlockRow' }),
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { 'class': 'submitBlockRow btnalignright' },
	                                                            _react2.default.createElement(
	                                                                'button',
	                                                                { type: 'submit', id: 'btnSubmit',
	                                                                    className: 'btn btn-primary btn-sm' },
	                                                                'Submit Gallery info'
	                                                            )
	                                                        )
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { 'class': 'info-Edit' },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { 'class': 'titleline-noborder' },
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { 'class': 'blocktitle-strip' },
	                                                            'Videos'
	                                                        ),
	                                                        _react2.default.createElement('div', { className: 'inputBlockRow' }),
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { 'class': 'submitBlockRow btnalignright' },
	                                                            _react2.default.createElement(
	                                                                'button',
	                                                                { type: 'submit', id: 'btnSubmit',
	                                                                    className: 'btn btn-primary btn-sm' },
	                                                                'Submit Videos info'
	                                                            )
	                                                        )
	                                                    )
	                                                )
	                                            )
	                                        )
	                                    );
	                                })
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return partnerAccountInfo;
	}(_react.Component);
	
	exports.default = partnerAccountInfo;

/***/ },
/* 962 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _reactstrap = __webpack_require__(17);
	
	var _Tabs = __webpack_require__(65);
	
	var _Tabs2 = _interopRequireDefault(_Tabs);
	
	var _TabsPane = __webpack_require__(64);
	
	var _TabsPane2 = _interopRequireDefault(_TabsPane);
	
	var _reactDataTableComponent = __webpack_require__(53);
	
	var _reactDataTableComponent2 = _interopRequireDefault(_reactDataTableComponent);
	
	var _yourarticles = __webpack_require__(965);
	
	var _yourarticles2 = _interopRequireDefault(_yourarticles);
	
	var _uploadyourarticle = __webpack_require__(964);
	
	var _uploadyourarticle2 = _interopRequireDefault(_uploadyourarticle);
	
	var _bewisearticles = __webpack_require__(963);
	
	var _bewisearticles2 = _interopRequireDefault(_bewisearticles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import { Editor } from '@tinymce/tinymce-react';
	
	var childTabs = [{
	    name: "Your Articles",
	    id: "yourarticle",
	    defaultChecked: true
	}, {
	    name: "Upload Your Article",
	    id: "uploadyourarticle"
	}, {
	    name: "BeWise Articles",
	    id: "bewisearticles"
	}];
	
	var partnerArticles = function (_Component) {
	    _inherits(partnerArticles, _Component);
	
	    function partnerArticles(props) {
	        _classCallCheck(this, partnerArticles);
	
	        var _this = _possibleConstructorReturn(this, (partnerArticles.__proto__ || Object.getPrototypeOf(partnerArticles)).call(this, props));
	
	        _this.handleChange = function (e) {
	            _this.setState(_defineProperty({}, e.target.name, e.target.value));
	        };
	
	        _this.state = {
	            logged: localStorage.getItem("authentication"),
	            auth_data: JSON.parse(localStorage.getItem("user_data"))
	        };
	
	        return _this;
	    }
	
	    _createClass(partnerArticles, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {}
	    }, {
	        key: 'render',
	        value: function render() {
	
	            return _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _react2.default.createElement(
	                    _layout2.default,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { 'class': 'col-12 grid-margin' },
	                        _react2.default.createElement(
	                            'div',
	                            { 'class': 'card' },
	                            _react2.default.createElement(
	                                'div',
	                                { 'class': 'card-body' },
	                                _react2.default.createElement(
	                                    'h4',
	                                    { 'class': 'card-title' },
	                                    'Articles'
	                                ),
	                                _react2.default.createElement(
	                                    _Tabs2.default,
	                                    { tabsetName: 'dashboard', childTabs: childTabs },
	                                    _react2.default.createElement(
	                                        _TabsPane2.default,
	                                        { id: 'yourarticles' },
	                                        _react2.default.createElement(_yourarticles2.default, null)
	                                    ),
	                                    _react2.default.createElement(
	                                        _TabsPane2.default,
	                                        { id: 'uploadyourarticle' },
	                                        _react2.default.createElement(_uploadyourarticle2.default, null)
	                                    ),
	                                    _react2.default.createElement(
	                                        _TabsPane2.default,
	                                        { id: 'bewisearticles' },
	                                        _react2.default.createElement(_bewisearticles2.default, null)
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return partnerArticles;
	}(_react.Component);
	
	exports.default = partnerArticles;

/***/ },
/* 963 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FetchCall = __webpack_require__(4);
	
	var _sweetalert = __webpack_require__(174);
	
	var _sweetalert2 = _interopRequireDefault(_sweetalert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var $ = __webpack_require__(5);
	
	var BeWiseArticles = function (_Component) {
	    _inherits(BeWiseArticles, _Component);
	
	    function BeWiseArticles(props) {
	        var _this2 = this;
	
	        _classCallCheck(this, BeWiseArticles);
	
	        var _this = _possibleConstructorReturn(this, (BeWiseArticles.__proto__ || Object.getPrototypeOf(BeWiseArticles)).call(this, props));
	
	        _this.getpageData = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	            var _this$state$user_data, user_type, login_id;
	
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            _this$state$user_data = _this.state.user_data, user_type = _this$state$user_data.user_type, login_id = _this$state$user_data.login_id;
	                            _context.next = 3;
	                            return (0, _FetchCall.beWiseArticles)().then(function (response) {
	                                if (response.status === 1) {
	                                    _this.datatabledata(response.data);
	                                }
	                            });
	
	                        case 3:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, _this2);
	        }));
	
	        _this.state = {
	            user_data: localStorage.getItem('user_data') ? JSON.parse(localStorage.getItem('user_data')) : [],
	            authentication: localStorage.getItem('authentication') ? JSON.parse(localStorage.getItem('authentication')) : false
	        };
	        _this.getpageData();
	        return _this;
	    }
	
	    _createClass(BeWiseArticles, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var THIS = this;
	        }
	    }, {
	        key: 'datatabledata',
	        value: function datatabledata(data) {
	            console.log('data', data);
	            this.setState({
	                dataSet: data
	            });
	            this.el = $(this.el);
	            this.el.DataTable({
	                data: this.state.dataSet,
	                columns: [{ data: 'title' }, { data: 'updated_date' }, { data: 'action' }]
	
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            return _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { 'class': 'box-shadow-custom' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-12' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'table-responsive custom-table-wrap content-sec col-md-12 col-xs-12 pad-no mar-t-no' },
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table dataTable', ref: function ref(el) {
	                                            return _this3.el = el;
	                                        } },
	                                    _react2.default.createElement(
	                                        'thead',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            { role: 'row' },
	                                            _react2.default.createElement(
	                                                'th',
	                                                { className: 'tabledata' },
	                                                'Title'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                { className: 'tabledata' },
	                                                'Date'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                { className: 'tabledata' },
	                                                'Action'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return BeWiseArticles;
	}(_react.Component);
	
	exports.default = BeWiseArticles;

/***/ },
/* 964 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _FetchCall = __webpack_require__(4);
	
	var _FetchCall2 = _interopRequireDefault(_FetchCall);
	
	var _draftJs = __webpack_require__(84);
	
	var _reactDraftWysiwyg = __webpack_require__(127);
	
	__webpack_require__(92);
	
	var _draftjsToHtml = __webpack_require__(106);
	
	var _draftjsToHtml2 = _interopRequireDefault(_draftjsToHtml);
	
	var _htmlToDraftjs = __webpack_require__(158);
	
	var _htmlToDraftjs2 = _interopRequireDefault(_htmlToDraftjs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var $ = __webpack_require__(5);
	
	var UploadArticle = function (_Component) {
	  _inherits(UploadArticle, _Component);
	
	  function UploadArticle(props) {
	    _classCallCheck(this, UploadArticle);
	
	    var _this = _possibleConstructorReturn(this, (UploadArticle.__proto__ || Object.getPrototypeOf(UploadArticle)).call(this, props));
	
	    _this.handleSelect = function (e) {
	      var propName = e.target.name;
	      var value = [].concat(_toConsumableArray(e.target.selectedOptions)).map(function (item) {
	        return item.value;
	      });
	      _this.setState(_defineProperty({}, propName, value));
	    };
	
	    _this.getLocation = function () {
	      var req = JSON.stringify({
	        url: 'location_list'
	      });
	      (0, _FetchCall.commonAPI)(req).then(function (res) {
	        if (res.status === 1) {
	          _this.setState({
	            locationList: res.list
	          });
	        }
	      });
	    };
	
	    _this.handleChange = function (e) {
	      _this.setState(_defineProperty({}, e.target.name, e.target.value));
	    };
	
	    _this.handleCheck = function (e) {
	      _this.setState(function (prevState) {
	        return {
	          show_upload: !prevState.show_upload
	        };
	      });
	    };
	
	    _this.handleSubmit = function (e) {
	      var _this$state$auth_data = _this.state.auth_data,
	          user_type = _this$state$auth_data.user_type,
	          login_id = _this$state$auth_data.login_id;
	
	
	      var insert = {
	        insight_id: _this.state.insight_id,
	        insight_title: _this.state.insight_title,
	        insight_desc: _this.state.insight_desc,
	        related_vertical: _this.state.related_vertical,
	        location: _this.state.location,
	        insight_content: _this.state.insight_content,
	        insight_author: login_id,
	        user_id: login_id,
	        status: 0,
	        banner_new: _this.state.banner_new,
	        gallery_new: _this.state.gallery_new
	      };
	      (0, _FetchCall.updateInsights)(insert).then(function (response) {
	        _this.setState({
	          btnDisable: false
	        });
	        if (response.status == 1) {
	          alert("Insight is added");
	        } else {
	          alert("Issue in adding insight");
	        }
	      });
	    };
	
	    _this.handleFile = function (e) {
	      var propName = e.target.name;
	      var files = e.target.files[0];
	      _this.setState(_defineProperty({}, propName, files));
	    };
	
	    _this.onChangeEditor = function (editorState) {
	      //const contentState = editorState.getCurrentContent();
	      //console.log("plain text", editorState.getCurrentContent().getPlainText());
	
	      var contentState = (0, _draftjsToHtml2.default)((0, _draftJs.convertToRaw)(editorState.getCurrentContent()));
	
	      console.log("html", contentState);
	      //const raw = convertToRaw(contentState);
	      _this.setState({
	        consigne: editorState,
	        insight_content: contentState
	      });
	    };
	
	    var url = new URL(window.location.href);
	    var location = url.searchParams.get("location");
	    _this.state = {
	      logged: localStorage.getItem("authentication"),
	      auth_data: JSON.parse(localStorage.getItem("user_data")),
	      insight_id: 0,
	      insight_title: '',
	      insight_desc: '',
	      banner_image: '',
	      banner_new: '',
	      gallery_image: '',
	      article_images: '',
	      show_upload: false,
	      articleuploaded: false,
	      gallery_new: '',
	      insight_content: '',
	      insight_author: '',
	      about_author: '',
	      related_vertical: '',
	      social_links: [{ id: "fb", name: 'Facebook', link: "" }, { id: "li", name: 'LinkedIn', link: "" }, { id: "in", name: 'Instagram', link: "" }, { id: "tw", name: 'Twitter', link: "" }],
	      imageList: [],
	      suggestions: [],
	      location: [],
	      locationList: [],
	      btnDisable: false,
	      editorState: _draftJs.EditorState.createEmpty()
	    };
	
	    _this.getLocation();
	
	    return _this;
	  }
	
	  _createClass(UploadArticle, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	
	      var THIS = this;
	    }
	  }, {
	    key: 'handleEditorChange',
	    value: function handleEditorChange(value, editor) {
	      console.log(value);
	      this.setState({
	        insight_content: value
	      });
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      //window.jQuery('.selectpicker').selectpicker('refresh');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          insight_content = _state.insight_content,
	          editorState = _state.editorState,
	          consigne = _state.consigne;
	
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          'div',
	          { 'class': 'box-shadow-custom' },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'form-group col-md-3' },
	                _react2.default.createElement(
	                  'label',
	                  null,
	                  ' Title ',
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'astrick' },
	                    '*'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { 'class': 'form-group col-md-9' },
	                _react2.default.createElement('input', { name: 'insight_title', className: 'form-control', type: 'text', value: this.state.insight_title,
	                  onChange: this.handleChange })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'form-group col-md-3' },
	                _react2.default.createElement(
	                  'label',
	                  null,
	                  ' Description ',
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'astrick' },
	                    '*'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { 'class': 'form-group col-md-9' },
	                _react2.default.createElement('textarea', { name: 'insight_desc', className: 'form-control', rows: 3, value: this.state.insight_desc,
	                  onChange: this.handleChange })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'form-group col-md-3' },
	                _react2.default.createElement(
	                  'label',
	                  null,
	                  ' Blog related to ',
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'astrick' },
	                    '*'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { 'class': 'form-group col-md-9' },
	                _react2.default.createElement(
	                  'select',
	                  { 'class': 'form-control', name: 'related_vertical', value: this.state.related_vertical, onChange: this.handleChange },
	                  _react2.default.createElement(
	                    'option',
	                    { value: '' },
	                    'Select'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'tuitionblogs' },
	                    'Tuition Blogs'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'schoolblogs' },
	                    'School Blogs'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'preschoolblogs' },
	                    'Preschool Blogs'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'danceblogs' },
	                    'Dance Blogs'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'sportsblogs' },
	                    'Sports Blogs'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'musicblogs' },
	                    'Music Blogs'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'artblogs' },
	                    'Art Blogs'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'hobbiesblogs' },
	                    'Hobbies Blogs'
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'form-group col-md-3' },
	                _react2.default.createElement(
	                  'label',
	                  null,
	                  ' Blog Banner Image ',
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'astrick' },
	                    '*'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { 'class': 'form-group col-md-9' },
	                _react2.default.createElement('input', {
	                  type: 'file',
	                  name: 'gallery_new',
	                  onChange: this.handleFile,
	                  className: 'form-control mar-btm',
	                  accept: 'image/x-png,image/gif,image/jpeg'
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'row', style: { marginBottom: '30px' } },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'form-group col-md-3' },
	                _react2.default.createElement(
	                  'label',
	                  null,
	                  ' Content ',
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'astrick' },
	                    '*'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { 'class': 'form-group col-md-9' },
	                _react2.default.createElement(_reactDraftWysiwyg.Editor, {
	                  handlePastedText: function handlePastedText() {
	                    return false;
	                  },
	                  value: (0, _draftjsToHtml2.default)((0, _draftJs.convertToRaw)(editorState.getCurrentContent())),
	                  editorState: consigne,
	                  toolbarClassName: 'toolbarClassName',
	                  wrapperClassName: 'wrapperClassName',
	                  editorClassName: 'editorClassName',
	                  onEditorStateChange: this.onChangeEditor.bind(this),
	                  toolbar: {
	                    image: {
	                      previewImage: true,
	                      uploadCallback: uploadImageCallBack,
	                      alt: { present: true, mandatory: false }
	                    }
	                  }
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'form-group col-md-3' },
	                _react2.default.createElement(
	                  'label',
	                  null,
	                  ' Location ',
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'astrick' },
	                    '*'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { 'class': 'form-group col-md-9' },
	                _react2.default.createElement(
	                  'select',
	                  { className: 'form-control selectpicker', name: 'location', value: this.state.location,
	                    onChange: this.handleSelect, multiple: true, 'data-live-search': 'true',
	                    'data-actions-box': 'true' },
	                  this.state.locationList.map(function (item, i) {
	                    return _react2.default.createElement(
	                      'option',
	                      { value: item.id },
	                      item.location
	                    );
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'row mb-4 text-right' },
	              _react2.default.createElement(
	                'button',
	                { type: 'submit', id: 'btnSubmit',
	                  className: 'btn btn-primary btn-sm', onClick: this.handleSubmit, disabled: this.state.btnDisable, style: { display: "block", margin: "auto" } },
	                'Submit'
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return UploadArticle;
	}(_react.Component);
	
	function uploadImageCallBack(file) {
	  return new Promise(function (resolve, reject) {
	    var reader = new window.FileReader();
	    var xhr = new XMLHttpRequest(); // eslint-disable-line no-undef
	    xhr.open('POST', 'https://api.bewise.in/api/campaign/mail/uploadeditorimage');
	    xhr.setRequestHeader('x-auth-token', 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ2ZW5kZXIiOnsiaWQiOiI1ZWJkMTMyOTQwMjJhMjNlMmM1YzA4MzkifSwiaWF0IjoxNTkxMTgwOTA3LCJleHAiOjM2MDAwMDAwMDAxNTkxMTgwMDAwfQ.TKBUep0bss3gqQBK8CkbUuRlO3jRLHEvGTGgm90gLRE');
	    var data = new FormData(); // eslint-disable-line no-undef
	    data.append('image', file);
	    xhr.send(data);
	    xhr.addEventListener('load', function () {
	      var response = JSON.parse(xhr.responseText);
	      resolve(response);
	    });
	    xhr.addEventListener('error', function () {
	      var error = JSON.parse(xhr.responseText);
	      reject(error);
	    });
	  });
	}
	
	exports.default = UploadArticle;

/***/ },
/* 965 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FetchCall = __webpack_require__(4);
	
	var _sweetalert = __webpack_require__(174);
	
	var _sweetalert2 = _interopRequireDefault(_sweetalert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var $ = __webpack_require__(5);
	
	var YourArticles = function (_Component) {
	    _inherits(YourArticles, _Component);
	
	    function YourArticles(props) {
	        var _this2 = this;
	
	        _classCallCheck(this, YourArticles);
	
	        var _this = _possibleConstructorReturn(this, (YourArticles.__proto__ || Object.getPrototypeOf(YourArticles)).call(this, props));
	
	        _this.getpageData = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	            var _this$state$user_data, user_type, login_id, insdata;
	
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            _this$state$user_data = _this.state.user_data, user_type = _this$state$user_data.user_type, login_id = _this$state$user_data.login_id;
	                            insdata = JSON.stringify({
	                                login_id: login_id
	                            });
	                            _context.next = 4;
	                            return (0, _FetchCall.partnerArticles)(insdata).then(function (response) {
	                                if (response.status === 1) {
	                                    _this.datatabledata(response.data);
	                                }
	                            });
	
	                        case 4:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, _this2);
	        }));
	
	        _this.state = {
	            user_data: localStorage.getItem('user_data') ? JSON.parse(localStorage.getItem('user_data')) : [],
	            authentication: localStorage.getItem('authentication') ? JSON.parse(localStorage.getItem('authentication')) : false
	        };
	        _this.getpageData();
	        return _this;
	    }
	
	    _createClass(YourArticles, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var THIS = this;
	        }
	    }, {
	        key: 'datatabledata',
	        value: function datatabledata(data) {
	            console.log('data', data);
	            this.setState({
	                dataSet: data
	            });
	            this.el = $(this.el);
	            this.el.DataTable({
	                data: this.state.dataSet,
	                columns: [{ data: 'title' }, { data: 'updated_date' }, { data: 'status' }, { data: 'action' }]
	
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            return _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { 'class': 'box-shadow-custom' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-12' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'table-responsive custom-table-wrap content-sec col-md-12 col-xs-12 pad-no mar-t-no' },
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table dataTable', ref: function ref(el) {
	                                            return _this3.el = el;
	                                        } },
	                                    _react2.default.createElement(
	                                        'thead',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            { role: 'row' },
	                                            _react2.default.createElement(
	                                                'th',
	                                                { className: 'tabledata' },
	                                                'Title'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                { className: 'tabledata' },
	                                                'Date'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                { className: 'tabledata' },
	                                                'Status'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                { className: 'tabledata' },
	                                                'Action'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return YourArticles;
	}(_react.Component);
	
	exports.default = YourArticles;

/***/ },
/* 966 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FetchCall = __webpack_require__(4);
	
	var _PdfContainer = __webpack_require__(90);
	
	var _PdfContainer2 = _interopRequireDefault(_PdfContainer);
	
	var _DocService = __webpack_require__(89);
	
	var _DocService2 = _interopRequireDefault(_DocService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ComSprtCompare = function (_Component) {
	  _inherits(ComSprtCompare, _Component);
	
	  function ComSprtCompare(props) {
	    _classCallCheck(this, ComSprtCompare);
	
	    var _this = _possibleConstructorReturn(this, (ComSprtCompare.__proto__ || Object.getPrototypeOf(ComSprtCompare)).call(this, props));
	
	    _this.createPdf = function (html) {
	      return _DocService2.default.createPdf(html);
	    };
	
	    console.log('this.props', _this.props);
	    _this.state = {
	      compareData: _this.props.viewData.compareData,
	      ratingData: _this.props.viewData.ratingData,
	      date: _this.props.viewData.date
	    };
	    return _this;
	  }
	
	  _createClass(ComSprtCompare, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          compareData = _state.compareData,
	          ratingData = _state.ratingData;
	
	      console.log('this.state.compareData re', compareData);
	      var dataLen = compareData.length;
	      var scl = dataLen > 0 ? compareData[0].name : '';
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'row invoice-container compare-container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'back-drop' },
	            _react2.default.createElement(
	              'h2',
	              null,
	              'Confidential - Bewise prepared for ' + scl.trim()
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'p',
	              null,
	              'Date : ',
	              this.state.date
	            ),
	            _react2.default.createElement(
	              'table',
	              { className: 'table table-bordered comparetable' },
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Name'
	                ),
	                compareData.map(function (item, i) {
	                  return _react2.default.createElement(
	                    _react2.default.Fragment,
	                    null,
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      item.name
	                    )
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Category'
	                ),
	                compareData.map(function (item, i) {
	                  return _react2.default.createElement(
	                    'td',
	                    null,
	                    item.category
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Mode of Payment'
	                ),
	                compareData.map(function (item, i) {
	                  return _react2.default.createElement(
	                    _react2.default.Fragment,
	                    null,
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      item.payment_name ? item.payment_name : 'NA'
	                    )
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Established Year'
	                ),
	                compareData.map(function (item, i) {
	                  return _react2.default.createElement(
	                    _react2.default.Fragment,
	                    null,
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      item.est_year ? item.est_year : 'NA'
	                    )
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'No of Classes/ Month'
	                ),
	                compareData.map(function (item, i) {
	                  return _react2.default.createElement(
	                    _react2.default.Fragment,
	                    null,
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      item.noclass ? item.noclass : 'NA'
	                    )
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Event Fee'
	                ),
	                compareData.map(function (item, i) {
	                  return _react2.default.createElement(
	                    _react2.default.Fragment,
	                    null,
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      item.avg_fee == 0 || item.avg_fee == 'NA' ? 'NA' : _react2.default.createElement(
	                        'span',
	                        null,
	                        '\u20B9 ',
	                        item.avg_fee
	                      )
	                    )
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  { colSpan: 1 + compareData.length },
	                  'Rating'
	                )
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Covid19 responses'
	                ),
	                ratingData.map(function (item, i) {
	                  return _react2.default.createElement(
	                    'td',
	                    null,
	                    item.covid19
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Quality of Teacher (OR) Counsellor (OR) Comfort with Trainer / Teacher'
	                ),
	                ratingData.map(function (item, i) {
	                  return _react2.default.createElement(
	                    'td',
	                    null,
	                    item.qty_teachers
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Quality of Teaching (OR) Counselling (OR) Method of Teaching / Coaching / Counselling'
	                ),
	                ratingData.map(function (item, i) {
	                  return _react2.default.createElement(
	                    'td',
	                    null,
	                    item.qty_teaching
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Child Safety'
	                ),
	                ratingData.map(function (item, i) {
	                  return _react2.default.createElement(
	                    'td',
	                    null,
	                    item.child_safety
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Facilities & Connectivity (OR) Quality of Connectivity / Campus'
	                ),
	                ratingData.map(function (item, i) {
	                  return _react2.default.createElement(
	                    'td',
	                    null,
	                    item.facilities
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Ontime / Punctuality (OR) Punctuality'
	                ),
	                ratingData.map(function (item, i) {
	                  return _react2.default.createElement(
	                    'td',
	                    null,
	                    item.ontime_punctuality
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Ease of Interaction (OR) Information @ Website'
	                ),
	                ratingData.map(function (item, i) {
	                  return _react2.default.createElement(
	                    'td',
	                    null,
	                    item.qty_intraction
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Overall Rating'
	                ),
	                ratingData.map(function (item, i) {
	                  return _react2.default.createElement(
	                    'td',
	                    null,
	                    item.overall_expirence
	                  );
	                })
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ComSprtCompare;
	}(_react.Component);
	
	exports.default = ComSprtCompare;

/***/ },
/* 967 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FetchCall = __webpack_require__(4);
	
	var _PdfContainer = __webpack_require__(90);
	
	var _PdfContainer2 = _interopRequireDefault(_PdfContainer);
	
	var _DocService = __webpack_require__(89);
	
	var _DocService2 = _interopRequireDefault(_DocService);
	
	var _school_compare = __webpack_require__(973);
	
	var _school_compare2 = _interopRequireDefault(_school_compare);
	
	var _preschool_compare = __webpack_require__(972);
	
	var _preschool_compare2 = _interopRequireDefault(_preschool_compare);
	
	var _hobbies_compare = __webpack_require__(969);
	
	var _hobbies_compare2 = _interopRequireDefault(_hobbies_compare);
	
	var _learning_compare = __webpack_require__(970);
	
	var _learning_compare2 = _interopRequireDefault(_learning_compare);
	
	var _tuition_compare = __webpack_require__(974);
	
	var _tuition_compare2 = _interopRequireDefault(_tuition_compare);
	
	var _events_compare = __webpack_require__(968);
	
	var _events_compare2 = _interopRequireDefault(_events_compare);
	
	var _playarea_compare = __webpack_require__(971);
	
	var _playarea_compare2 = _interopRequireDefault(_playarea_compare);
	
	var _community_support_compare = __webpack_require__(966);
	
	var _community_support_compare2 = _interopRequireDefault(_community_support_compare);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import FetchCall from '../../API/FetchCall';
	
	
	//npm i @progress/kendo-react-pdf@3.5.1-dev.201910161723
	
	//npm i @progress/kendo-drawing
	
	var CompareView = function (_Component) {
	  _inherits(CompareView, _Component);
	
	  function CompareView(props) {
	    _classCallCheck(this, CompareView);
	
	    var _this = _possibleConstructorReturn(this, (CompareView.__proto__ || Object.getPrototypeOf(CompareView)).call(this, props));
	
	    _this.createPdf = function (html) {
	      return _DocService2.default.createPdf(html);
	    };
	
	    var cdata = localStorage.getItem('compare_data');
	    var today = new Date();
	    var dd = String(today.getDate()).padStart(2, '0');
	    var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
	    var yyyy = today.getFullYear();
	    today = dd + '-' + mm + '-' + yyyy;
	    if (!cdata) {
	      window.location.href = '/partner/bench_mark';
	    } else {
	      cdata = JSON.parse(cdata);
	    }
	    console.log('cdata', cdata);
	    _this.state = {
	      compareData: cdata ? cdata.data : [],
	      ratingData: cdata ? cdata.rating : [],
	      compareType: cdata ? cdata.type : 0,
	      orders: [],
	      date: today
	    };
	    return _this;
	  }
	
	  _createClass(CompareView, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'render',
	    value: function render() {
	      var view_data = {
	        compareData: this.state.compareData,
	        ratingData: this.state.ratingData,
	        date: this.state.date,
	        compareType: this.state.compareType
	      };
	      console.log('view_data', view_data);
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'box-shadow-custom' },
	          _react2.default.createElement(
	            _PdfContainer2.default,
	            { createPdf: this.createPdf },
	            this.state.compareType == 1 && _react2.default.createElement(_school_compare2.default, { viewData: view_data }),
	            this.state.compareType == 2 && _react2.default.createElement(_preschool_compare2.default, { viewData: view_data }),
	            this.state.compareType == 3 && _react2.default.createElement(_playarea_compare2.default, { viewData: view_data }),
	            this.state.compareType == 4 && _react2.default.createElement(_hobbies_compare2.default, { viewData: view_data }),
	            this.state.compareType == 8 && _react2.default.createElement(_learning_compare2.default, { viewData: view_data }),
	            this.state.compareType == 6 && _react2.default.createElement(_tuition_compare2.default, { viewData: view_data }),
	            this.state.compareType == 7 && _react2.default.createElement(_events_compare2.default, { viewData: view_data }),
	            this.state.compareType == 121 && _react2.default.createElement(_community_support_compare2.default, { viewData: view_data })
	          )
	        )
	      );
	    }
	  }]);
	
	  return CompareView;
	}(_react.Component);
	
	exports.default = CompareView;

/***/ },
/* 968 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FetchCall = __webpack_require__(4);
	
	var _PdfContainer = __webpack_require__(90);
	
	var _PdfContainer2 = _interopRequireDefault(_PdfContainer);
	
	var _DocService = __webpack_require__(89);
	
	var _DocService2 = _interopRequireDefault(_DocService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EventCompare = function (_Component) {
	  _inherits(EventCompare, _Component);
	
	  function EventCompare(props) {
	    _classCallCheck(this, EventCompare);
	
	    var _this = _possibleConstructorReturn(this, (EventCompare.__proto__ || Object.getPrototypeOf(EventCompare)).call(this, props));
	
	    _this.createPdf = function (html) {
	      return _DocService2.default.createPdf(html);
	    };
	
	    console.log('this.props', _this.props);
	    _this.state = {
	      compareData: _this.props.viewData.compareData,
	      ratingData: _this.props.viewData.ratingData,
	      date: _this.props.viewData.date
	    };
	    return _this;
	  }
	
	  _createClass(EventCompare, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          compareData = _state.compareData,
	          ratingData = _state.ratingData;
	
	      console.log('this.state.compareData re', compareData);
	      var dataLen = compareData.length;
	      var scl = dataLen > 0 ? compareData[0].name : '';
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          'div',
	          { 'class': 'row' },
	          _react2.default.createElement(
	            'div',
	            { 'class': 'hdr-logo-pdf' },
	            _react2.default.createElement('img', { src: '/assets/bewiseLogo.png', width: '100%' })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row invoice-container compare-container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'back-drop' },
	            _react2.default.createElement(
	              'h2',
	              null,
	              'Confidential - Bewise prepared for ' + scl.trim()
	            ),
	            _react2.default.createElement(
	              'div',
	              { id: 'watermark' },
	              _react2.default.createElement('img', { src: '/assets/bewiseLogo.png', width: '100%' })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'p',
	              null,
	              'Date : ',
	              this.state.date
	            ),
	            _react2.default.createElement(
	              'table',
	              { className: 'table table-bordered comparetable' },
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Name'
	                ),
	                compareData.map(function (item, i) {
	                  return _react2.default.createElement(
	                    _react2.default.Fragment,
	                    null,
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      item.name
	                    )
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Category'
	                ),
	                compareData.map(function (item, i) {
	                  return _react2.default.createElement(
	                    'td',
	                    null,
	                    item.category
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Mode of Payment'
	                ),
	                compareData.map(function (item, i) {
	                  return _react2.default.createElement(
	                    _react2.default.Fragment,
	                    null,
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      item.payment_name ? item.payment_name : 'NA'
	                    )
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Food'
	                ),
	                compareData.map(function (item, i) {
	                  return _react2.default.createElement(
	                    _react2.default.Fragment,
	                    null,
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      item.food ? item.food : 'NA'
	                    )
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Hall Capacity'
	                ),
	                compareData.map(function (item, i) {
	                  return _react2.default.createElement(
	                    _react2.default.Fragment,
	                    null,
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      item.hall_capcity ? item.hall_capcity : 'NA'
	                    )
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Car Parking'
	                ),
	                compareData.map(function (item, i) {
	                  return _react2.default.createElement(
	                    _react2.default.Fragment,
	                    null,
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      item.car_parking_slot ? item.car_parking_slot : 'NA'
	                    )
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Two Wheeler Parking'
	                ),
	                compareData.map(function (item, i) {
	                  return _react2.default.createElement(
	                    _react2.default.Fragment,
	                    null,
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      item.two_parking_slot ? item.two_parking_slot : 'NA'
	                    )
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Established Year'
	                ),
	                compareData.map(function (item, i) {
	                  return _react2.default.createElement(
	                    _react2.default.Fragment,
	                    null,
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      item.est_year ? item.est_year : 'NA'
	                    )
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Event Fee'
	                ),
	                compareData.map(function (item, i) {
	                  return _react2.default.createElement(
	                    _react2.default.Fragment,
	                    null,
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      item.event_fee == 0 || item.event_fee == 'NA' ? 'NA' : _react2.default.createElement(
	                        'span',
	                        null,
	                        '\u20B9 ',
	                        item.event_fee
	                      )
	                    )
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  { colSpan: 1 + compareData.length },
	                  'Rating'
	                )
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Covid19 responses'
	                ),
	                ratingData.map(function (item, i) {
	                  return _react2.default.createElement(
	                    'td',
	                    null,
	                    item.covid19
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Quality of service (OR) Comfort with Trainer / Teacher'
	                ),
	                ratingData.map(function (item, i) {
	                  return _react2.default.createElement(
	                    'td',
	                    null,
	                    item.qty_food
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Method of Teaching / Coaching / Counselling'
	                ),
	                ratingData.map(function (item, i) {
	                  return _react2.default.createElement(
	                    'td',
	                    null,
	                    item.qty_method
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Information @ Website (OR) Quality of Connectivity / Campus'
	                ),
	                ratingData.map(function (item, i) {
	                  return _react2.default.createElement(
	                    'td',
	                    null,
	                    item.qty_info_website
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Child Safety'
	                ),
	                ratingData.map(function (item, i) {
	                  return _react2.default.createElement(
	                    'td',
	                    null,
	                    item.child_safety
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Ease of Interaction'
	                ),
	                ratingData.map(function (item, i) {
	                  return _react2.default.createElement(
	                    'td',
	                    null,
	                    item.qty_intraction
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Puntcuality / Connectivity (OR) Puntcuality'
	                ),
	                ratingData.map(function (item, i) {
	                  return _react2.default.createElement(
	                    'td',
	                    null,
	                    item.ontime_punctuality
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Overall Rating'
	                ),
	                ratingData.map(function (item, i) {
	                  return _react2.default.createElement(
	                    'td',
	                    null,
	                    item.overall_expirence
	                  );
	                })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { 'class': 'row' },
	          _react2.default.createElement(
	            'div',
	            { 'class': 'hdr-logo-pdf' },
	            '\xA9 Copyright 2022 BeWise. All Rights Reserved'
	          )
	        )
	      );
	    }
	  }]);
	
	  return EventCompare;
	}(_react.Component);
	
	exports.default = EventCompare;

/***/ },
/* 969 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FetchCall = __webpack_require__(4);
	
	var _PdfContainer = __webpack_require__(90);
	
	var _PdfContainer2 = _interopRequireDefault(_PdfContainer);
	
	var _DocService = __webpack_require__(89);
	
	var _DocService2 = _interopRequireDefault(_DocService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HobbiesCompare = function (_Component) {
	  _inherits(HobbiesCompare, _Component);
	
	  function HobbiesCompare(props) {
	    _classCallCheck(this, HobbiesCompare);
	
	    var _this = _possibleConstructorReturn(this, (HobbiesCompare.__proto__ || Object.getPrototypeOf(HobbiesCompare)).call(this, props));
	
	    _this.createPdf = function (html) {
	      return _DocService2.default.createComparePdf(html);
	    };
	
	    console.log('this.props', _this.props);
	    _this.state = {
	      compareData: _this.props.viewData.compareData,
	      ratingData: _this.props.viewData.ratingData,
	      date: _this.props.viewData.date
	    };
	    return _this;
	  }
	
	  _createClass(HobbiesCompare, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          compareData = _state.compareData,
	          ratingData = _state.ratingData;
	
	      console.log('this.state.compareData re', compareData);
	      var dataLen = compareData.length;
	      var scl = dataLen > 0 ? compareData[0].name : '';
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          'div',
	          { 'class': 'padleftcentered' },
	          _react2.default.createElement(
	            'div',
	            { 'class': 'row' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'hdr-logo-pdf' },
	              _react2.default.createElement('img', { src: '/assets/bewiseLogo.png', width: '100%' })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row invoice-container compare-container' },
	            _react2.default.createElement(
	              'div',
	              { className: 'back-drop' },
	              _react2.default.createElement(
	                'h2',
	                null,
	                'Confidential - Bewise prepared for ' + scl.trim()
	              ),
	              _react2.default.createElement(
	                'div',
	                { id: 'watermark' },
	                _react2.default.createElement('img', { src: '/assets/bewiseLogo.png', width: '100%' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'text-center padding45' },
	                _react2.default.createElement(
	                  'h2',
	                  null,
	                  'Benchmark Compare View'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Date : ',
	                  this.state.date
	                ),
	                _react2.default.createElement(
	                  'table',
	                  { className: 'styled-table' },
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      { width: '250' },
	                      'Name'
	                    ),
	                    compareData.map(function (item, i) {
	                      return _react2.default.createElement(
	                        _react2.default.Fragment,
	                        null,
	                        _react2.default.createElement(
	                          'td',
	                          null,
	                          _react2.default.createElement(
	                            'b',
	                            null,
	                            item.name
	                          )
	                        )
	                      );
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      null,
	                      'Categories'
	                    ),
	                    compareData.map(function (item, i) {
	                      return _react2.default.createElement(
	                        'td',
	                        null,
	                        item.category
	                      );
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      null,
	                      'Sub Categories'
	                    ),
	                    compareData.map(function (item, i) {
	                      return _react2.default.createElement(
	                        'td',
	                        null,
	                        item.sub_categories
	                      );
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      null,
	                      'Class Frequebcy'
	                    ),
	                    compareData.map(function (item, i) {
	                      return _react2.default.createElement(
	                        _react2.default.Fragment,
	                        null,
	                        _react2.default.createElement(
	                          'td',
	                          null,
	                          item.class_frequency ? item.class_frequency : 'NA'
	                        )
	                      );
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      null,
	                      'Learning Option'
	                    ),
	                    compareData.map(function (item, i) {
	                      return _react2.default.createElement(
	                        _react2.default.Fragment,
	                        null,
	                        _react2.default.createElement(
	                          'td',
	                          null,
	                          item.learning_opt ? item.learning_opt : 'NA'
	                        )
	                      );
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      null,
	                      'Timing'
	                    ),
	                    compareData.map(function (item, i) {
	                      return _react2.default.createElement(
	                        _react2.default.Fragment,
	                        null,
	                        _react2.default.createElement(
	                          'td',
	                          null,
	                          item.from_time.includes('NA') || item.to_time.includes('NA') ? 'NA' : item.from_time + ' - ' + item.to_time
	                        )
	                      );
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      null,
	                      'Number of Classes /Month'
	                    ),
	                    compareData.map(function (item, i) {
	                      return _react2.default.createElement(
	                        _react2.default.Fragment,
	                        null,
	                        _react2.default.createElement(
	                          'td',
	                          null,
	                          item.noclass ? item.noclass : 'NA'
	                        )
	                      );
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      null,
	                      'Number Of Traniee'
	                    ),
	                    compareData.map(function (item, i) {
	                      return _react2.default.createElement(
	                        _react2.default.Fragment,
	                        null,
	                        _react2.default.createElement(
	                          'td',
	                          null,
	                          item.number_of_trainee ? item.number_of_trainee : 'NA'
	                        )
	                      );
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      null,
	                      'Established Year'
	                    ),
	                    compareData.map(function (item, i) {
	                      return _react2.default.createElement(
	                        _react2.default.Fragment,
	                        null,
	                        _react2.default.createElement(
	                          'td',
	                          null,
	                          item.est_year ? item.est_year : 'NA'
	                        )
	                      );
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      null,
	                      'Annual Avegrge Fee'
	                    ),
	                    compareData.map(function (item, i) {
	                      return _react2.default.createElement(
	                        _react2.default.Fragment,
	                        null,
	                        _react2.default.createElement(
	                          'td',
	                          null,
	                          item.avg_fee == 0 || item.avg_fee == 'NA' ? 'NA' : _react2.default.createElement(
	                            'span',
	                            null,
	                            '\u20B9 ',
	                            item.avg_fee
	                          )
	                        )
	                      );
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      null,
	                      'Admission Fees'
	                    ),
	                    compareData.map(function (item, i) {
	                      return _react2.default.createElement(
	                        _react2.default.Fragment,
	                        null,
	                        _react2.default.createElement(
	                          'td',
	                          null,
	                          item.admit_fee == 0 || item.admit_fee == 'NA' ? 'NA' : _react2.default.createElement(
	                            'span',
	                            null,
	                            '\u20B9 ',
	                            item.admit_fee
	                          )
	                        )
	                      );
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      { 'class': 'separath', colSpan: 1 + compareData.length },
	                      'Rating'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      null,
	                      'Covid19 Responses'
	                    ),
	                    ratingData.map(function (item, i) {
	                      return _react2.default.createElement(
	                        'td',
	                        null,
	                        item.covid19
	                      );
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      null,
	                      'Quality of Teachers / Coaches (OR) Comfort with Trainer / Teacher'
	                    ),
	                    ratingData.map(function (item, i) {
	                      return _react2.default.createElement(
	                        'td',
	                        null,
	                        item.qty_teachers
	                      );
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      null,
	                      'Quality of Teaching / Coaching (OR) Method of Teaching / Coaching / Counselling'
	                    ),
	                    ratingData.map(function (item, i) {
	                      return _react2.default.createElement(
	                        'td',
	                        null,
	                        item.qty_teaching
	                      );
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      null,
	                      'Information @ Website'
	                    ),
	                    ratingData.map(function (item, i) {
	                      return _react2.default.createElement(
	                        'td',
	                        null,
	                        item.qty_info_website
	                      );
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      null,
	                      'Child Safety'
	                    ),
	                    ratingData.map(function (item, i) {
	                      return _react2.default.createElement(
	                        'td',
	                        null,
	                        item.child_safety
	                      );
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      null,
	                      'Campus & Facilities (OR) Quality of Connectivity / Campus'
	                    ),
	                    ratingData.map(function (item, i) {
	                      return _react2.default.createElement(
	                        'td',
	                        null,
	                        item.campus_facilities
	                      );
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      null,
	                      'Ease of Interaction'
	                    ),
	                    ratingData.map(function (item, i) {
	                      return _react2.default.createElement(
	                        'td',
	                        null,
	                        item.qty_intraction
	                      );
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      null,
	                      'Students per batch'
	                    ),
	                    ratingData.map(function (item, i) {
	                      return _react2.default.createElement(
	                        'td',
	                        null,
	                        item.batch_size
	                      );
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      null,
	                      'Ontime / Punctuality'
	                    ),
	                    ratingData.map(function (item, i) {
	                      return _react2.default.createElement(
	                        'td',
	                        null,
	                        item.ontime_punctuality
	                      );
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      null,
	                      'Overall Rating'
	                    ),
	                    ratingData.map(function (item, i) {
	                      return _react2.default.createElement(
	                        'td',
	                        null,
	                        item.overall_expirence
	                      );
	                    })
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { 'class': 'row' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'hdr-logo-pdf' },
	              '\xA9 Copyright 2022 BeWise. All Rights Reserved'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return HobbiesCompare;
	}(_react.Component);
	
	exports.default = HobbiesCompare;

/***/ },
/* 970 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FetchCall = __webpack_require__(4);
	
	var _PdfContainer = __webpack_require__(90);
	
	var _PdfContainer2 = _interopRequireDefault(_PdfContainer);
	
	var _DocService = __webpack_require__(89);
	
	var _DocService2 = _interopRequireDefault(_DocService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LearningCompare = function (_Component) {
	  _inherits(LearningCompare, _Component);
	
	  function LearningCompare(props) {
	    _classCallCheck(this, LearningCompare);
	
	    var _this = _possibleConstructorReturn(this, (LearningCompare.__proto__ || Object.getPrototypeOf(LearningCompare)).call(this, props));
	
	    _this.createPdf = function (html) {
	      return _DocService2.default.createPdf(html);
	    };
	
	    console.log('this.props', _this.props);
	    _this.state = {
	      compareData: _this.props.viewData.compareData,
	      ratingData: _this.props.viewData.ratingData,
	      date: _this.props.viewData.date
	    };
	    return _this;
	  }
	
	  _createClass(LearningCompare, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          compareData = _state.compareData,
	          ratingData = _state.ratingData;
	
	      console.log('this.state.compareData re', compareData);
	      var dataLen = compareData.length;
	      var scl = dataLen > 0 ? compareData[0].name : '';
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'row invoice-container compare-container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'back-drop' },
	            _react2.default.createElement(
	              'h2',
	              null,
	              'Confidential - Bewise prepared for ' + scl.trim()
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'p',
	              null,
	              'Date : ',
	              this.state.date
	            ),
	            _react2.default.createElement(
	              'table',
	              { className: 'table table-bordered comparetable' },
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Name'
	                ),
	                compareData.map(function (item, i) {
	                  return _react2.default.createElement(
	                    _react2.default.Fragment,
	                    null,
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      item.name
	                    )
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Sub Categories'
	                ),
	                compareData.map(function (item, i) {
	                  return _react2.default.createElement(
	                    'td',
	                    null,
	                    item.sub_categories
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Student Ratio'
	                ),
	                compareData.map(function (item, i) {
	                  return _react2.default.createElement(
	                    _react2.default.Fragment,
	                    null,
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      item.student_ratio
	                    )
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Number of Classes /Month'
	                ),
	                compareData.map(function (item, i) {
	                  return _react2.default.createElement(
	                    _react2.default.Fragment,
	                    null,
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      item.noclass ? item.noclass : 'NA'
	                    )
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Learning Option'
	                ),
	                compareData.map(function (item, i) {
	                  return _react2.default.createElement(
	                    _react2.default.Fragment,
	                    null,
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      item.learning_opt ? item.learning_opt : 'NA'
	                    )
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Fees'
	                ),
	                compareData.map(function (item, i) {
	                  return _react2.default.createElement(
	                    _react2.default.Fragment,
	                    null,
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      item.event_fee == 0 || item.event_fee == 'NA' ? 'NA' : _react2.default.createElement(
	                        'span',
	                        null,
	                        '\u20B9 ',
	                        item.event_fee
	                      )
	                    )
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  { colSpan: 1 + compareData.length },
	                  'Rating'
	                )
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Covid19 responses'
	                ),
	                ratingData.map(function (item, i) {
	                  return _react2.default.createElement(
	                    'td',
	                    null,
	                    item.covid19
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Quality of Teachers / Coaches (OR) Comfort with Trainer / Teacher'
	                ),
	                ratingData.map(function (item, i) {
	                  return _react2.default.createElement(
	                    'td',
	                    null,
	                    item.qty_teachers
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Method of Teaching / Coaching (OR) Method of Teaching / Coaching / Counselling'
	                ),
	                ratingData.map(function (item, i) {
	                  return _react2.default.createElement(
	                    'td',
	                    null,
	                    item.qty_teaching
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Facilities & Connectivity (OR) Quality of Connectivity / Campus'
	                ),
	                ratingData.map(function (item, i) {
	                  return _react2.default.createElement(
	                    'td',
	                    null,
	                    item.campus_facilities
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Child Safety'
	                ),
	                ratingData.map(function (item, i) {
	                  return _react2.default.createElement(
	                    'td',
	                    null,
	                    item.child_safety
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Ease of Interaction (OR) Information @ Website'
	                ),
	                ratingData.map(function (item, i) {
	                  return _react2.default.createElement(
	                    'td',
	                    null,
	                    item.qty_info_website
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Students per batch'
	                ),
	                ratingData.map(function (item, i) {
	                  return _react2.default.createElement(
	                    'td',
	                    null,
	                    item.crowd_size
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Punctuality'
	                ),
	                ratingData.map(function (item, i) {
	                  return _react2.default.createElement(
	                    'td',
	                    null,
	                    item.ontime_punctuality
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Overall Rating'
	                ),
	                ratingData.map(function (item, i) {
	                  return _react2.default.createElement(
	                    'td',
	                    null,
	                    item.overall_expirence
	                  );
	                })
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return LearningCompare;
	}(_react.Component);
	
	exports.default = LearningCompare;

/***/ },
/* 971 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FetchCall = __webpack_require__(4);
	
	var _PdfContainer = __webpack_require__(90);
	
	var _PdfContainer2 = _interopRequireDefault(_PdfContainer);
	
	var _DocService = __webpack_require__(89);
	
	var _DocService2 = _interopRequireDefault(_DocService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import FetchCall from '../../API/FetchCall';
	
	
	//npm i @progress/kendo-react-pdf@3.5.1-dev.201910161723
	
	//npm i @progress/kendo-drawing
	
	var PlayAreaCompare = function (_Component) {
	  _inherits(PlayAreaCompare, _Component);
	
	  function PlayAreaCompare(props) {
	    _classCallCheck(this, PlayAreaCompare);
	
	    var _this = _possibleConstructorReturn(this, (PlayAreaCompare.__proto__ || Object.getPrototypeOf(PlayAreaCompare)).call(this, props));
	
	    _this.createPdf = function (html) {
	      return _DocService2.default.createPdf(html);
	    };
	
	    console.log('this.props', _this.props);
	    _this.state = {
	      compareData: _this.props.viewData.compareData,
	      ratingData: _this.props.viewData.ratingData,
	      date: _this.props.viewData.date
	    };
	    return _this;
	  }
	
	  _createClass(PlayAreaCompare, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          compareData = _state.compareData,
	          ratingData = _state.ratingData;
	
	      console.log('this.state.compareData re', compareData);
	      var dataLen = compareData.length;
	      var scl = dataLen > 0 ? compareData[0].name : '';
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          'div',
	          { 'class': 'row' },
	          _react2.default.createElement(
	            'div',
	            { 'class': 'hdr-logo-pdf' },
	            _react2.default.createElement('img', { src: '/assets/bewiseLogo.png', width: '100%' })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row invoice-container compare-container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'back-drop' },
	            _react2.default.createElement(
	              'h2',
	              null,
	              'Confidential - Bewise prepared for ' + scl.trim()
	            ),
	            _react2.default.createElement(
	              'div',
	              { id: 'watermark' },
	              _react2.default.createElement('img', { src: '/assets/bewiseLogo.png', width: '100%' })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'p',
	              null,
	              'Date : ',
	              this.state.date
	            ),
	            _react2.default.createElement(
	              'table',
	              { className: 'table table-bordered comparetable' },
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Name'
	                ),
	                compareData.map(function (item, i) {
	                  return _react2.default.createElement(
	                    _react2.default.Fragment,
	                    null,
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      item.name
	                    )
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Sub Categories'
	                ),
	                compareData.map(function (item, i) {
	                  return _react2.default.createElement(
	                    _react2.default.Fragment,
	                    null,
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      item.sub_categories
	                    )
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'No of Trainees'
	                ),
	                compareData.map(function (item, i) {
	                  return _react2.default.createElement(
	                    _react2.default.Fragment,
	                    null,
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      item.no_teacher ? item.no_teacher : 'NA'
	                    )
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Facilites'
	                ),
	                compareData.map(function (item, i) {
	                  return _react2.default.createElement(
	                    _react2.default.Fragment,
	                    null,
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      item.facilites
	                    )
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Timing'
	                ),
	                compareData.map(function (item, i) {
	                  return _react2.default.createElement(
	                    _react2.default.Fragment,
	                    null,
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      item.from_time.includes('NA') || item.to_time.includes('NA') ? 'NA' : item.from_time + ' - ' + item.to_time
	                    )
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Established Year'
	                ),
	                compareData.map(function (item, i) {
	                  return _react2.default.createElement(
	                    _react2.default.Fragment,
	                    null,
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      item.est_year ? item.est_year : 'NA'
	                    )
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Minimal Entry Fee'
	                ),
	                compareData.map(function (item, i) {
	                  return _react2.default.createElement(
	                    _react2.default.Fragment,
	                    null,
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      item.entry_fee == 0 || item.entry_fee == 'NA' ? 'NA' : _react2.default.createElement(
	                        'span',
	                        null,
	                        '\u20B9 ',
	                        item.entry_fee
	                      )
	                    )
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  { colSpan: 1 + compareData.length },
	                  'Rating'
	                )
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Covid19 Responses'
	                ),
	                ratingData.map(function (item, i) {
	                  return _react2.default.createElement(
	                    'td',
	                    null,
	                    item.covid19
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Quality of Staff'
	                ),
	                ratingData.map(function (item, i) {
	                  return _react2.default.createElement(
	                    'td',
	                    null,
	                    item.qty_staff
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Cleanliness'
	                ),
	                ratingData.map(function (item, i) {
	                  return _react2.default.createElement(
	                    'td',
	                    null,
	                    item.cleanliness
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Child Safety'
	                ),
	                ratingData.map(function (item, i) {
	                  return _react2.default.createElement(
	                    'td',
	                    null,
	                    item.child_safety
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Child Safety'
	                ),
	                ratingData.map(function (item, i) {
	                  return _react2.default.createElement(
	                    'td',
	                    null,
	                    item.child_safety
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Facilities for parents'
	                ),
	                ratingData.map(function (item, i) {
	                  return _react2.default.createElement(
	                    'td',
	                    null,
	                    item.facilities_parent
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Food Quality'
	                ),
	                ratingData.map(function (item, i) {
	                  return _react2.default.createElement(
	                    'td',
	                    null,
	                    item.food
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Crowd size'
	                ),
	                ratingData.map(function (item, i) {
	                  return _react2.default.createElement(
	                    'td',
	                    null,
	                    item.crowd_size
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Overall Rating'
	                ),
	                ratingData.map(function (item, i) {
	                  return _react2.default.createElement(
	                    'td',
	                    null,
	                    item.overall_expirence
	                  );
	                })
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return PlayAreaCompare;
	}(_react.Component);
	
	exports.default = PlayAreaCompare;

/***/ },
/* 972 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FetchCall = __webpack_require__(4);
	
	var _PdfContainer = __webpack_require__(90);
	
	var _PdfContainer2 = _interopRequireDefault(_PdfContainer);
	
	var _DocService = __webpack_require__(89);
	
	var _DocService2 = _interopRequireDefault(_DocService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import FetchCall from '../../API/FetchCall';
	
	
	//npm i @progress/kendo-react-pdf@3.5.1-dev.201910161723
	
	//npm i @progress/kendo-drawing
	
	var PreSchoolCompare = function (_Component) {
	  _inherits(PreSchoolCompare, _Component);
	
	  function PreSchoolCompare(props) {
	    _classCallCheck(this, PreSchoolCompare);
	
	    var _this = _possibleConstructorReturn(this, (PreSchoolCompare.__proto__ || Object.getPrototypeOf(PreSchoolCompare)).call(this, props));
	
	    _this.createPdf = function (html) {
	      return _DocService2.default.createPdf(html);
	    };
	
	    console.log('this.props', _this.props);
	    _this.state = {
	      compareData: _this.props.viewData.compareData,
	      ratingData: _this.props.viewData.ratingData,
	      date: _this.props.viewData.date
	    };
	    return _this;
	  }
	
	  _createClass(PreSchoolCompare, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          compareData = _state.compareData,
	          ratingData = _state.ratingData;
	
	      console.log('this.state.compareData re', compareData);
	      var dataLen = compareData.length;
	      var scl = dataLen > 0 ? compareData[0].name : '';
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          'div',
	          { 'class': 'row' },
	          _react2.default.createElement(
	            'div',
	            { 'class': 'hdr-logo-pdf' },
	            _react2.default.createElement('img', { src: '/assets/bewiseLogo.png', width: '100%' })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row invoice-container compare-container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'back-drop' },
	            _react2.default.createElement(
	              'h2',
	              null,
	              'Confidential - Bewise prepared for ' + scl.trim()
	            ),
	            _react2.default.createElement(
	              'div',
	              { id: 'watermark' },
	              _react2.default.createElement('img', { src: '/assets/bewiseLogo.png', width: '100%' })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'p',
	              null,
	              'Date : ',
	              this.state.date
	            ),
	            _react2.default.createElement(
	              'table',
	              { className: 'table table-bordered comparetable' },
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Name'
	                ),
	                compareData.map(function (item, i) {
	                  return _react2.default.createElement(
	                    _react2.default.Fragment,
	                    null,
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      item.name
	                    )
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'School Type'
	                ),
	                compareData.map(function (item, i) {
	                  return _react2.default.createElement(
	                    _react2.default.Fragment,
	                    null,
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      item.sub_categories
	                    )
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Facilites'
	                ),
	                compareData.map(function (item, i) {
	                  return _react2.default.createElement(
	                    _react2.default.Fragment,
	                    null,
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      item.facilites
	                    )
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Timing'
	                ),
	                compareData.map(function (item, i) {
	                  return _react2.default.createElement(
	                    _react2.default.Fragment,
	                    null,
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      item.from_time.includes('NA') || item.to_time.includes('NA') ? 'NA' : item.from_time + ' - ' + item.to_time
	                    )
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Established Year'
	                ),
	                compareData.map(function (item, i) {
	                  return _react2.default.createElement(
	                    _react2.default.Fragment,
	                    null,
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      item.est_year ? item.est_year : 'NA'
	                    )
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Documents'
	                ),
	                compareData.map(function (item, i) {
	                  return _react2.default.createElement(
	                    _react2.default.Fragment,
	                    null,
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      item.documents
	                    )
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Indicative Annual Fee'
	                ),
	                compareData.map(function (item, i) {
	                  return _react2.default.createElement(
	                    _react2.default.Fragment,
	                    null,
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      item.avg_fee == 0 || item.avg_fee == 'NA' ? 'NA' : _react2.default.createElement(
	                        'span',
	                        null,
	                        '\u20B9 ',
	                        item.avg_fee
	                      )
	                    )
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Recurring Fees'
	                ),
	                compareData.map(function (item, i) {
	                  return _react2.default.createElement(
	                    _react2.default.Fragment,
	                    null,
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      item.addmission_fee == 0 || item.addmission_fee == 'NA' ? 'NA' : _react2.default.createElement(
	                        'span',
	                        null,
	                        '\u20B9 ',
	                        item.addmission_fee
	                      )
	                    )
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  { colSpan: 1 + compareData.length },
	                  'Rating'
	                )
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Covid19 Responses'
	                ),
	                ratingData.map(function (item, i) {
	                  return _react2.default.createElement(
	                    'td',
	                    null,
	                    item.covid19
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Teachers'
	                ),
	                ratingData.map(function (item, i) {
	                  return _react2.default.createElement(
	                    'td',
	                    null,
	                    item.qty_teachers
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Teaching Methods'
	                ),
	                ratingData.map(function (item, i) {
	                  return _react2.default.createElement(
	                    'td',
	                    null,
	                    item.qty_teaching
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Other Staff Interaction'
	                ),
	                ratingData.map(function (item, i) {
	                  return _react2.default.createElement(
	                    'td',
	                    null,
	                    item.qty_interaction
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Child Safety'
	                ),
	                ratingData.map(function (item, i) {
	                  return _react2.default.createElement(
	                    'td',
	                    null,
	                    item.child_safety
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Information @ Website'
	                ),
	                ratingData.map(function (item, i) {
	                  return _react2.default.createElement(
	                    'td',
	                    null,
	                    item.qty_info_website
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Campus & Facilities'
	                ),
	                ratingData.map(function (item, i) {
	                  return _react2.default.createElement(
	                    'td',
	                    null,
	                    item.facilities
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Transport arrangement'
	                ),
	                ratingData.map(function (item, i) {
	                  return _react2.default.createElement(
	                    'td',
	                    null,
	                    item.transport_arrange
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Teacher : Students Ratio'
	                ),
	                ratingData.map(function (item, i) {
	                  return _react2.default.createElement(
	                    'td',
	                    null,
	                    item.teacher_student_ratio
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Overall Rating'
	                ),
	                ratingData.map(function (item, i) {
	                  return _react2.default.createElement(
	                    'td',
	                    null,
	                    item.overall_expirence
	                  );
	                })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { 'class': 'row' },
	          _react2.default.createElement(
	            'div',
	            { 'class': 'hdr-logo-pdf' },
	            '\xA9 Copyright 2022 BeWise. All Rights Reserved'
	          )
	        )
	      );
	    }
	  }]);
	
	  return PreSchoolCompare;
	}(_react.Component);
	
	exports.default = PreSchoolCompare;

/***/ },
/* 973 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FetchCall = __webpack_require__(4);
	
	var _PdfContainer = __webpack_require__(90);
	
	var _PdfContainer2 = _interopRequireDefault(_PdfContainer);
	
	var _DocService = __webpack_require__(89);
	
	var _DocService2 = _interopRequireDefault(_DocService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import FetchCall from '../../API/FetchCall';
	
	
	//npm i @progress/kendo-react-pdf@3.5.1-dev.201910161723
	
	//npm i @progress/kendo-drawing
	
	var SchoolCompare = function (_Component) {
	  _inherits(SchoolCompare, _Component);
	
	  function SchoolCompare(props) {
	    _classCallCheck(this, SchoolCompare);
	
	    var _this = _possibleConstructorReturn(this, (SchoolCompare.__proto__ || Object.getPrototypeOf(SchoolCompare)).call(this, props));
	
	    _this.createPdf = function (html) {
	      return _DocService2.default.createPdf(html);
	    };
	
	    console.log('this.props', _this.props);
	    _this.state = {
	      compareData: _this.props.viewData.compareData,
	      ratingData: _this.props.viewData.ratingData,
	      date: _this.props.viewData.date
	    };
	    return _this;
	  }
	
	  _createClass(SchoolCompare, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          compareData = _state.compareData,
	          ratingData = _state.ratingData;
	
	      console.log('this.state.compareData re', ratingData);
	      var dataLen = compareData.length;
	      var scl = dataLen > 0 ? compareData[0].name : '';
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          'div',
	          { 'class': 'row' },
	          _react2.default.createElement(
	            'div',
	            { 'class': 'hdr-logo-pdf' },
	            _react2.default.createElement('img', { src: '/assets/bewiseLogo.png', width: '100%' })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row invoice-container compare-container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'back-drop' },
	            _react2.default.createElement(
	              'h2',
	              null,
	              'Confidential - Bewise prepared for ' + scl.trim()
	            ),
	            _react2.default.createElement(
	              'div',
	              { id: 'watermark' },
	              _react2.default.createElement('img', { src: '/assets/bewiseLogo.png', width: '100%' })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row ovrfls' },
	            _react2.default.createElement(
	              'p',
	              null,
	              'Date : ',
	              this.state.date
	            ),
	            _react2.default.createElement(
	              'div',
	              { 'class': 'tableinner' },
	              _react2.default.createElement(
	                'table',
	                { className: 'table table-bordered comparetable' },
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'Name'
	                  ),
	                  compareData.map(function (item, i) {
	                    return _react2.default.createElement(
	                      _react2.default.Fragment,
	                      null,
	                      _react2.default.createElement(
	                        'td',
	                        null,
	                        item.name
	                      )
	                    );
	                  })
	                ),
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'School Type'
	                  ),
	                  compareData.map(function (item, i) {
	                    return _react2.default.createElement(
	                      _react2.default.Fragment,
	                      null,
	                      _react2.default.createElement(
	                        'td',
	                        null,
	                        item.sub_categories
	                      )
	                    );
	                  })
	                ),
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'Board Of Education'
	                  ),
	                  compareData.map(function (item, i) {
	                    return _react2.default.createElement(
	                      _react2.default.Fragment,
	                      null,
	                      _react2.default.createElement(
	                        'td',
	                        null,
	                        item.curriculum
	                      )
	                    );
	                  })
	                ),
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'Type'
	                  ),
	                  compareData.map(function (item, i) {
	                    return _react2.default.createElement(
	                      _react2.default.Fragment,
	                      null,
	                      _react2.default.createElement(
	                        'td',
	                        null,
	                        item.type
	                      )
	                    );
	                  })
	                ),
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'Facilites'
	                  ),
	                  compareData.map(function (item, i) {
	                    return _react2.default.createElement(
	                      _react2.default.Fragment,
	                      null,
	                      _react2.default.createElement(
	                        'td',
	                        null,
	                        item.facilites
	                      )
	                    );
	                  })
	                ),
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'Grades'
	                  ),
	                  compareData.map(function (item, i) {
	                    return _react2.default.createElement(
	                      _react2.default.Fragment,
	                      null,
	                      _react2.default.createElement(
	                        'td',
	                        null,
	                        item.grades.includes('NA') ? 'NA' : item.grades
	                      )
	                    );
	                  })
	                ),
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'Timing'
	                  ),
	                  compareData.map(function (item, i) {
	                    return _react2.default.createElement(
	                      _react2.default.Fragment,
	                      null,
	                      _react2.default.createElement(
	                        'td',
	                        null,
	                        item.from_time.includes('NA') || item.to_time.includes('NA') ? 'NA' : item.from_time + ' - ' + item.to_time
	                      )
	                    );
	                  })
	                ),
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'Instruction Languages'
	                  ),
	                  compareData.map(function (item, i) {
	                    return _react2.default.createElement(
	                      _react2.default.Fragment,
	                      null,
	                      _react2.default.createElement(
	                        'td',
	                        null,
	                        item.inst_lang ? item.inst_lang : 'NA'
	                      )
	                    );
	                  })
	                ),
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'Established Year'
	                  ),
	                  compareData.map(function (item, i) {
	                    return _react2.default.createElement(
	                      _react2.default.Fragment,
	                      null,
	                      _react2.default.createElement(
	                        'td',
	                        null,
	                        item.est_year ? item.est_year : 'NA'
	                      )
	                    );
	                  })
	                ),
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'Documents'
	                  ),
	                  compareData.map(function (item, i) {
	                    return _react2.default.createElement(
	                      _react2.default.Fragment,
	                      null,
	                      _react2.default.createElement(
	                        'td',
	                        null,
	                        item.documents
	                      )
	                    );
	                  })
	                ),
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'Facilities'
	                  ),
	                  compareData.map(function (item, i) {
	                    return _react2.default.createElement(
	                      _react2.default.Fragment,
	                      null,
	                      _react2.default.createElement(
	                        'td',
	                        null,
	                        item.facilites
	                      )
	                    );
	                  })
	                ),
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'Indicative Annual Fee'
	                  ),
	                  compareData.map(function (item, i) {
	                    return _react2.default.createElement(
	                      _react2.default.Fragment,
	                      null,
	                      _react2.default.createElement(
	                        'td',
	                        null,
	                        item.avg_fee == 0 || item.avg_fee == 'NA' ? 'NA' : _react2.default.createElement(
	                          'span',
	                          null,
	                          '\u20B9 ',
	                          item.avg_fee
	                        )
	                      )
	                    );
	                  })
	                ),
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'Recurring Fees'
	                  ),
	                  compareData.map(function (item, i) {
	                    return _react2.default.createElement(
	                      _react2.default.Fragment,
	                      null,
	                      _react2.default.createElement(
	                        'td',
	                        null,
	                        item.addmission_fee == 0 || item.addmission_fee == 'NA' ? 'NA' : _react2.default.createElement(
	                          'span',
	                          null,
	                          '\u20B9 ',
	                          item.addmission_fee
	                        )
	                      )
	                    );
	                  })
	                ),
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'th',
	                    { colSpan: 1 + compareData.length },
	                    'Rating'
	                  )
	                ),
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'Covid19 Responses'
	                  ),
	                  ratingData.map(function (item, i) {
	                    return _react2.default.createElement(
	                      'td',
	                      null,
	                      item.covid19
	                    );
	                  })
	                ),
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'Teachers'
	                  ),
	                  ratingData.map(function (item, i) {
	                    return _react2.default.createElement(
	                      'td',
	                      null,
	                      item.qty_teachers
	                    );
	                  })
	                ),
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'Teaching Methods'
	                  ),
	                  ratingData.map(function (item, i) {
	                    return _react2.default.createElement(
	                      'td',
	                      null,
	                      item.qty_teaching
	                    );
	                  })
	                ),
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'Other Staff Interaction'
	                  ),
	                  ratingData.map(function (item, i) {
	                    return _react2.default.createElement(
	                      'td',
	                      null,
	                      item.qty_interaction
	                    );
	                  })
	                ),
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'Child Safety'
	                  ),
	                  ratingData.map(function (item, i) {
	                    return _react2.default.createElement(
	                      'td',
	                      null,
	                      item.child_safety
	                    );
	                  })
	                ),
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'Information @ Website'
	                  ),
	                  ratingData.map(function (item, i) {
	                    return _react2.default.createElement(
	                      'td',
	                      null,
	                      item.qty_info_website
	                    );
	                  })
	                ),
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'Campus & Facilities'
	                  ),
	                  ratingData.map(function (item, i) {
	                    return _react2.default.createElement(
	                      'td',
	                      null,
	                      item.facilities
	                    );
	                  })
	                ),
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'Transport arrangement'
	                  ),
	                  ratingData.map(function (item, i) {
	                    return _react2.default.createElement(
	                      'td',
	                      null,
	                      item.transport_arrange
	                    );
	                  })
	                ),
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'Teacher : Students Ratio'
	                  ),
	                  ratingData.map(function (item, i) {
	                    return _react2.default.createElement(
	                      'td',
	                      null,
	                      item.teacher_student_ratio
	                    );
	                  })
	                ),
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'Overall Rating'
	                  ),
	                  ratingData.map(function (item, i) {
	                    return _react2.default.createElement(
	                      'td',
	                      null,
	                      item.overall_expirence
	                    );
	                  })
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { 'class': 'row' },
	          _react2.default.createElement(
	            'div',
	            { 'class': 'hdr-logo-pdf' },
	            '\xA9 Copyright 2022 BeWise. All Rights Reserved'
	          )
	        )
	      );
	    }
	  }]);
	
	  return SchoolCompare;
	}(_react.Component);
	
	exports.default = SchoolCompare;

/***/ },
/* 974 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FetchCall = __webpack_require__(4);
	
	var _PdfContainer = __webpack_require__(90);
	
	var _PdfContainer2 = _interopRequireDefault(_PdfContainer);
	
	var _DocService = __webpack_require__(89);
	
	var _DocService2 = _interopRequireDefault(_DocService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TuitionCompare = function (_Component) {
	  _inherits(TuitionCompare, _Component);
	
	  function TuitionCompare(props) {
	    _classCallCheck(this, TuitionCompare);
	
	    var _this = _possibleConstructorReturn(this, (TuitionCompare.__proto__ || Object.getPrototypeOf(TuitionCompare)).call(this, props));
	
	    _this.createPdf = function (html) {
	      return _DocService2.default.createPdf(html);
	    };
	
	    console.log('this.props', _this.props);
	    _this.state = {
	      compareData: _this.props.viewData.compareData,
	      ratingData: _this.props.viewData.ratingData,
	      date: _this.props.viewData.date
	    };
	    return _this;
	  }
	
	  _createClass(TuitionCompare, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          compareData = _state.compareData,
	          ratingData = _state.ratingData;
	
	      console.log('this.state.compareData re', compareData);
	      var dataLen = compareData.length;
	      var scl = dataLen > 0 ? compareData[0].name : '';
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          'div',
	          { 'class': 'row' },
	          _react2.default.createElement(
	            'div',
	            { 'class': 'hdr-logo-pdf' },
	            _react2.default.createElement('img', { src: '/assets/bewiseLogo.png', width: '100%' })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row invoice-container compare-container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'back-drop' },
	            _react2.default.createElement(
	              'h2',
	              null,
	              'Confidential - Bewise prepared for ' + scl.trim()
	            ),
	            _react2.default.createElement(
	              'div',
	              { id: 'watermark' },
	              _react2.default.createElement('img', { src: '/assets/bewiseLogo.png', width: '100%' })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row ovrfls' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'text-center padding45' },
	              _react2.default.createElement(
	                'h2',
	                null,
	                'Benchmark Compare View'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'Date : ',
	                this.state.date
	              ),
	              _react2.default.createElement(
	                'div',
	                { 'class': 'tableinner' },
	                _react2.default.createElement(
	                  'table',
	                  { className: 'styled-table' },
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      null,
	                      'Name'
	                    ),
	                    compareData.map(function (item, i) {
	                      return _react2.default.createElement(
	                        _react2.default.Fragment,
	                        null,
	                        _react2.default.createElement(
	                          'td',
	                          null,
	                          item.name
	                        )
	                      );
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      null,
	                      'Sub Categories'
	                    ),
	                    compareData.map(function (item, i) {
	                      return _react2.default.createElement(
	                        'td',
	                        null,
	                        item.sub_categories
	                      );
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      null,
	                      'Languages'
	                    ),
	                    compareData.map(function (item, i) {
	                      return _react2.default.createElement(
	                        'td',
	                        null,
	                        item.languages ? item.languages : 'NA'
	                      );
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      null,
	                      'Board Of Education'
	                    ),
	                    compareData.map(function (item, i) {
	                      return _react2.default.createElement(
	                        _react2.default.Fragment,
	                        null,
	                        _react2.default.createElement(
	                          'td',
	                          null,
	                          item.curriculum
	                        )
	                      );
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      null,
	                      'Class Frequency'
	                    ),
	                    compareData.map(function (item, i) {
	                      return _react2.default.createElement(
	                        _react2.default.Fragment,
	                        null,
	                        _react2.default.createElement(
	                          'td',
	                          null,
	                          item.class_frequency ? item.class_frequency : 'NA'
	                        )
	                      );
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      null,
	                      'Class'
	                    ),
	                    compareData.map(function (item, i) {
	                      return _react2.default.createElement(
	                        _react2.default.Fragment,
	                        null,
	                        _react2.default.createElement(
	                          'td',
	                          null,
	                          item.class_range ? item.class_range : 'NA'
	                        )
	                      );
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      null,
	                      'Instruction Language'
	                    ),
	                    compareData.map(function (item, i) {
	                      return _react2.default.createElement(
	                        _react2.default.Fragment,
	                        null,
	                        _react2.default.createElement(
	                          'td',
	                          null,
	                          item.instruction_lang ? item.instruction_lang : 'NA'
	                        )
	                      );
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      null,
	                      'Learning Option'
	                    ),
	                    compareData.map(function (item, i) {
	                      return _react2.default.createElement(
	                        _react2.default.Fragment,
	                        null,
	                        _react2.default.createElement(
	                          'td',
	                          null,
	                          item.learning_opt ? item.learning_opt : 'NA'
	                        )
	                      );
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      null,
	                      'Timing'
	                    ),
	                    compareData.map(function (item, i) {
	                      return _react2.default.createElement(
	                        _react2.default.Fragment,
	                        null,
	                        _react2.default.createElement(
	                          'td',
	                          null,
	                          item.from_time.includes('NA') || item.to_time.includes('NA') ? 'NA' : item.from_time + ' - ' + item.to_time
	                        )
	                      );
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      null,
	                      'Number of Classes /Month'
	                    ),
	                    compareData.map(function (item, i) {
	                      return _react2.default.createElement(
	                        _react2.default.Fragment,
	                        null,
	                        _react2.default.createElement(
	                          'td',
	                          null,
	                          item.noclass ? item.noclass : 'NA'
	                        )
	                      );
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      null,
	                      'Number Of Teacher'
	                    ),
	                    compareData.map(function (item, i) {
	                      return _react2.default.createElement(
	                        _react2.default.Fragment,
	                        null,
	                        _react2.default.createElement(
	                          'td',
	                          null,
	                          item.no_teacher ? item.no_teacher : 'NA'
	                        )
	                      );
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      null,
	                      'Established Year'
	                    ),
	                    compareData.map(function (item, i) {
	                      return _react2.default.createElement(
	                        _react2.default.Fragment,
	                        null,
	                        _react2.default.createElement(
	                          'td',
	                          null,
	                          item.est_year ? item.est_year : 'NA'
	                        )
	                      );
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      null,
	                      'Annual Avegrge Fee'
	                    ),
	                    compareData.map(function (item, i) {
	                      return _react2.default.createElement(
	                        _react2.default.Fragment,
	                        null,
	                        _react2.default.createElement(
	                          'td',
	                          null,
	                          item.avg_fee == 0 || item.avg_fee == 'NA' ? 'NA' : _react2.default.createElement(
	                            'span',
	                            null,
	                            '\u20B9 ',
	                            item.avg_fee
	                          )
	                        )
	                      );
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      { 'class': 'separath', colSpan: 1 + compareData.length },
	                      'Rating'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      null,
	                      'Covid19 responses'
	                    ),
	                    ratingData.map(function (item, i) {
	                      return _react2.default.createElement(
	                        'td',
	                        null,
	                        item.covid19
	                      );
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      null,
	                      'Quality of Teacher (OR) Counsellor (OR) Comfort with Trainer / Teacher'
	                    ),
	                    ratingData.map(function (item, i) {
	                      return _react2.default.createElement(
	                        'td',
	                        null,
	                        item.qty_teachers
	                      );
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      null,
	                      'Quality of Teaching (OR) Counselling (OR) Method of Teaching / Coaching / Counselling'
	                    ),
	                    ratingData.map(function (item, i) {
	                      return _react2.default.createElement(
	                        'td',
	                        null,
	                        item.qty_teaching
	                      );
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      null,
	                      'Child Safety'
	                    ),
	                    ratingData.map(function (item, i) {
	                      return _react2.default.createElement(
	                        'td',
	                        null,
	                        item.child_safety
	                      );
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      null,
	                      'Facilities & Connectivity (OR) Quality of Connectivity / Campus'
	                    ),
	                    ratingData.map(function (item, i) {
	                      return _react2.default.createElement(
	                        'td',
	                        null,
	                        item.facilities
	                      );
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      null,
	                      'Ontime / Punctuality (OR) Punctuality'
	                    ),
	                    ratingData.map(function (item, i) {
	                      return _react2.default.createElement(
	                        'td',
	                        null,
	                        item.ontime_punctuality
	                      );
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      null,
	                      'Ease of Interaction (OR) Information @ Website'
	                    ),
	                    ratingData.map(function (item, i) {
	                      return _react2.default.createElement(
	                        'td',
	                        null,
	                        item.qty_intraction
	                      );
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      null,
	                      'Overall Rating'
	                    ),
	                    ratingData.map(function (item, i) {
	                      return _react2.default.createElement(
	                        'td',
	                        null,
	                        item.overall_expirence
	                      );
	                    })
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { 'class': 'row' },
	          _react2.default.createElement(
	            'div',
	            { 'class': 'hdr-logo-pdf' },
	            '\xA9 Copyright 2022 BeWise. All Rights Reserved'
	          )
	        )
	      );
	    }
	  }]);
	
	  return TuitionCompare;
	}(_react.Component);
	
	exports.default = TuitionCompare;

/***/ },
/* 975 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _Tabs = __webpack_require__(65);
	
	var _Tabs2 = _interopRequireDefault(_Tabs);
	
	var _TabsPane = __webpack_require__(64);
	
	var _TabsPane2 = _interopRequireDefault(_TabsPane);
	
	var _simpleReactValidator = __webpack_require__(28);
	
	var _simpleReactValidator2 = _interopRequireDefault(_simpleReactValidator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import { Editor } from '@tinymce/tinymce-react';
	
	var partnerBenchMarking = function (_Component) {
	    _inherits(partnerBenchMarking, _Component);
	
	    function partnerBenchMarking(props) {
	        _classCallCheck(this, partnerBenchMarking);
	
	        var _this = _possibleConstructorReturn(this, (partnerBenchMarking.__proto__ || Object.getPrototypeOf(partnerBenchMarking)).call(this, props));
	
	        _this.getpageData = function () {
	            var _this$state$user_data = _this.state.user_data,
	                login_id = _this$state$user_data.login_id,
	                set_id = _this$state$user_data.set_id;
	
	            var req = JSON.stringify({
	                login_id: login_id,
	                set_id: set_id,
	                role: 3,
	                url: 'get_pcategoryV1'
	            });
	            (0, _FetchCall.benchApi)(req).then(function (res) {
	                if (res.status == 1) {
	                    _this.setState({
	                        category_list: res.category_list,
	                        list: res.list,
	                        pid: res.pid
	                    });
	                }
	            });
	        };
	
	        _this.handleChangeCategory = function (e) {
	            var propName = e.target.name;
	            var propValue = e.target.value;
	
	            _this.setState(_defineProperty({}, propName, propValue));
	
	            var _this$state$user_data2 = _this.state.user_data,
	                login_id = _this$state$user_data2.login_id,
	                set_id = _this$state$user_data2.set_id;
	
	            var sort_list = _this.state.list.filter(function (item) {
	                return item.category == propValue;
	            });
	            var mylist = [];
	            if (sort_list.length > 0) {
	                mylist = sort_list[0].list.filter(function (item) {
	                    return item.vendor_id == login_id && _this.state.pid.includes(item.pid.toString());
	                });
	            }
	            _this.setState({
	                sort_list: sort_list.length > 0 ? sort_list[0].list : [],
	                my_list: mylist
	            });
	        };
	
	        _this.handleChangeOrganisation = function (e) {
	            var propValue = e.target.value;
	
	            _this.setState({
	                current: propValue
	            });
	        };
	
	        _this.handleSelect = function (e) {
	            var propName = e.target.name;
	            var value = [].concat(_toConsumableArray(e.target.selectedOptions)).map(function (item) {
	                return item.value;
	            });
	            if (value.length > 5) {
	                value.shift();
	                alert('Select Maximum 5 Items');
	            }
	            _this.setState(_defineProperty({}, propName, value));
	        };
	
	        _this.handleSubmit = function (e) {
	            e.preventDefault();
	            if (_this.validator.allValid()) {
	                var _this$state$user_data3 = _this.state.user_data,
	                    login_id = _this$state$user_data3.login_id,
	                    set_id = _this$state$user_data3.set_id;
	
	                var req = JSON.stringify({
	                    login_id: login_id,
	                    set_id: set_id,
	                    type: _this.state.type,
	                    current_selected: _this.state.current_selected,
	                    current: _this.state.current,
	                    role: 3,
	                    url: 'generate_pdfV1'
	                });
	                (0, _FetchCall.benchApi)(req).then(function (res) {
	                    if (res.status === 1) {
	                        localStorage.setItem('compare_data', JSON.stringify(res.data));
	                        window.open('/partner/bench_mark_view', '_blank');
	                    } else {
	                        var toastr = '';
	                        toastr = window.toastr.error;
	                        toastr(res.message, {
	                            positionClass: "toast-bottom-right",
	                            containerId: "toast-bottom-right"
	                        });
	                    }
	                });
	            } else {
	                _this.validator.showMessages();
	                _this.forceUpdate();
	            }
	        };
	
	        _this.clearOption = function (e) {
	            e.preventDefault();
	            _this.setState({
	                type: '',
	                current_selected: [],
	                current: ''
	            });
	        };
	
	        _this.state = {
	            user_data: localStorage.getItem('user_data') ? JSON.parse(localStorage.getItem('user_data')) : [],
	            authentication: localStorage.getItem('authentication') ? JSON.parse(localStorage.getItem('authentication')) : false,
	            category_list: [],
	            list: [], my_list: [],
	            pid: [],
	            sort_list: [], current_selected: [], type: '', current: ''
	        };
	        _this.validator = new _simpleReactValidator2.default();
	        _this.getpageData = _this.getpageData.bind(_this);
	        _this.handleChangeCategory = _this.handleChangeCategory.bind(_this);
	        _this.handleChangeOrganisation = _this.handleChangeOrganisation.bind(_this);
	
	        return _this;
	    }
	
	    _createClass(partnerBenchMarking, [{
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            window.jQuery('.selectpicker').selectpicker('refresh');
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.getpageData();
	            window.jQuery('.selectpicker').selectpicker('refresh');
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            this.validator.purgeFields();
	            var _state = this.state,
	                category_list = _state.category_list,
	                sort_list = _state.sort_list,
	                list = _state.list,
	                my_list = _state.my_list;
	
	
	            return _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _react2.default.createElement(
	                    _layout2.default,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { 'class': 'col-12 grid-margin' },
	                        _react2.default.createElement(
	                            'div',
	                            { 'class': 'card' },
	                            _react2.default.createElement(
	                                'div',
	                                { 'class': 'card-body' },
	                                _react2.default.createElement(
	                                    'h4',
	                                    { 'class': 'card-title' },
	                                    'Benchmarking'
	                                ),
	                                list.length == 0 && _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    _react2.default.createElement(
	                                        'b',
	                                        null,
	                                        _react2.default.createElement(
	                                            'i',
	                                            null,
	                                            'Your Account info may be still waiting for approval to use this feature.'
	                                        )
	                                    )
	                                ),
	                                list.length > 0 && _react2.default.createElement(
	                                    'form',
	                                    { onSubmit: this.handleSubmit },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'row' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'form-group col-md-12' },
	                                            _react2.default.createElement(
	                                                'label',
	                                                null,
	                                                'Category',
	                                                _react2.default.createElement('span', { 'class': 'astrick' })
	                                            ),
	                                            _react2.default.createElement(
	                                                'select',
	                                                { className: 'form-control selectpicker', name: 'type', value: this.state.type,
	                                                    title: 'Select Category', onChange: this.handleChangeCategory },
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: '' },
	                                                    'Select Category'
	                                                ),
	                                                category_list.map(function (item, i) {
	                                                    return _react2.default.createElement(
	                                                        'option',
	                                                        { value: item.category_id },
	                                                        item.category_name
	                                                    );
	                                                })
	                                            ),
	                                            this.validator.message('Category', this.state.type, 'required', { className: 'text-danger error-msg' })
	                                        )
	                                    ),
	                                    this.state.type != '' && _react2.default.createElement(
	                                        _react2.default.Fragment,
	                                        null,
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'row' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { 'class': 'form-group col-md-12' },
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    null,
	                                                    'Your Organisation ',
	                                                    _react2.default.createElement('span', { 'class': 'astrick' })
	                                                ),
	                                                _react2.default.createElement(
	                                                    'select',
	                                                    { className: 'form-control selectpicker', name: 'current', value: this.state.current,
	                                                        title: 'Select Your ', onChange: this.handleChangeOrganisation, 'data-live-search': 'true' },
	                                                    _react2.default.createElement(
	                                                        'option',
	                                                        { value: '' },
	                                                        'Select your organisation'
	                                                    ),
	                                                    my_list.map(function (item, i) {
	                                                        return _react2.default.createElement(
	                                                            'option',
	                                                            { value: item.id },
	                                                            item.name
	                                                        );
	                                                    })
	                                                ),
	                                                this.validator.message('Your Organisation', this.state.current, 'required', { className: 'text-danger error-msg' })
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'row' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { 'class': 'form-group col-md-12' },
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    null,
	                                                    'Organisations to Compare',
	                                                    _react2.default.createElement('span', { 'class': 'astrick' })
	                                                ),
	                                                _react2.default.createElement(
	                                                    'select',
	                                                    { className: 'form-control selectpicker', name: 'current_selected', value: this.state.current_selected,
	                                                        multiple: true, title: 'Select', onChange: this.handleSelect, 'data-live-search': 'true' },
	                                                    _react2.default.createElement(
	                                                        'option',
	                                                        { value: '' },
	                                                        'Select Other organisations to compare'
	                                                    ),
	                                                    sort_list.map(function (item, i) {
	                                                        return _react2.default.createElement(
	                                                            'option',
	                                                            { value: item.id },
	                                                            item.name
	                                                        );
	                                                    })
	                                                ),
	                                                this.validator.message('Organisations to Compare', this.state.current_selected, 'required', { className: 'text-danger error-msg' })
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'row' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'form-group col-md-12' },
	                                            _react2.default.createElement(
	                                                'button',
	                                                { className: 'btn btn-primary btn-sm' },
	                                                'Generate'
	                                            ),
	                                            _react2.default.createElement(
	                                                'button',
	                                                { onClick: this.clearOption, className: 'btn btn-primary btn-sm mar-lft' },
	                                                'Clear'
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'h5',
	                                        { className: 'astrick' },
	                                        _react2.default.createElement(
	                                            'b',
	                                            null,
	                                            'Notes'
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'ul',
	                                        null,
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            'To compare the institutes, click on benchmarking tab. Select the category and select the school/preschool and the schools to be compared with. Generate button will generate the comparative information (pdf format).'
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return partnerBenchMarking;
	}(_react.Component);
	
	exports.default = partnerBenchMarking;

/***/ },
/* 976 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _FetchCall = __webpack_require__(4);
	
	var _FetchCall2 = _interopRequireDefault(_FetchCall);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var $ = __webpack_require__(5);
	//$.DataTable = require('datatables.net');
	
	var CuratedCamps = function (_Component) {
	    _inherits(CuratedCamps, _Component);
	
	    function CuratedCamps(props) {
	        _classCallCheck(this, CuratedCamps);
	
	        var _this = _possibleConstructorReturn(this, (CuratedCamps.__proto__ || Object.getPrototypeOf(CuratedCamps)).call(this, props));
	
	        _this.getCuratedCampList = function () {
	            console.log(_this.state.auth_data);
	            var _this$state$auth_data = _this.state.auth_data,
	                login_id = _this$state$auth_data.login_id,
	                role = _this$state$auth_data.role;
	
	            var ins = JSON.stringify({
	                vendor_id: login_id
	            });
	            (0, _FetchCall.getCuratedCampListV2)(ins).then(function (res) {
	                if (res.status == 1) {
	                    _this.setState({
	                        write_permission: res.write_permission,
	                        camplist: res.data
	                    });
	                    _this.datatabledata(res.data);
	                } else {
	                    _this.setState({
	                        camplist: []
	                    });
	                }
	            });
	        };
	
	        _this.deleteScl = function () {
	            var ins = JSON.stringify({
	                id: _this.state.delete_id
	            });
	            (0, _FetchCall.deleteSummerCamp)(ins).then(function (res) {
	                var toastr = '';
	                if (res.status === 1) {
	                    toastr = window.toastr.success;
	                    toastr('success', 'Deleted successfully', {
	                        positionClass: "toast-bottom-right",
	                        containerId: "toast-bottom-right"
	                    });
	                    setTimeout(function () {
	                        window.location.reload();
	                    }, 2000);
	                } else {
	                    toastr = res.message; //warning
	                    toastr('Error', toastr, {
	                        positionClass: "toast-bottom-right",
	                        containerId: "toast-bottom-right"
	                    });
	                }
	            });
	        };
	
	        var url = new URL(window.location.href);
	        var location = url.searchParams.get("location");
	        _this.state = {
	            logged: localStorage.getItem("authentication"),
	            auth_data: JSON.parse(localStorage.getItem("user_data")),
	            write_permission: false,
	            camplist: []
	
	        };
	        _this.getCuratedCampList();
	        return _this;
	    }
	
	    _createClass(CuratedCamps, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	
	            var THIS = this;
	        }
	    }, {
	        key: 'datatabledata',
	        value: function datatabledata(data) {
	
	            this.setState({
	                dataSet: data
	            });
	            this.el = $(this.el);
	            this.el.DataTable({
	                data: this.state.dataSet,
	                orderable: false,
	                columns: [{ data: 's_no' }, { data: 'camp_name' }, { data: 'status' }, { data: 'action' }]
	
	            });
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            //window.jQuery('.selectpicker').selectpicker('refresh');
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { 'class': 'box-shadow-custom' },
	                    _react2.default.createElement(
	                        'small',
	                        null,
	                        'Note: Applicable for only pre agreed customers only.',
	                        _react2.default.createElement(
	                            'a',
	                            { href: 'mailto:anand.k@bewise.in' },
	                            'Contact us'
	                        ),
	                        ' for enquires'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-12 col-xs-12 text-right' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'pull-right' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'dropdown menu-item' },
	                                    _react2.default.createElement(
	                                        'button',
	                                        { className: 'btn btn-green dropdown-toggle btn-arrow btn-circle', 'data-toggle': 'dropdown', 'aria-expanded': 'false' },
	                                        _react2.default.createElement('i', { className: 'fa fa-plus-circle', 'aria-hidden': 'true' }),
	                                        ' Add',
	                                        _react2.default.createElement('span', { className: 'caret' })
	                                    ),
	                                    _react2.default.createElement(
	                                        'ul',
	                                        { className: 'dropdown-menu align-right' },
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            _react2.default.createElement(
	                                                'a',
	                                                { href: '/requestforcurated' },
	                                                'Create Request'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'main-content col-md-12 col-xs-12' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'box-shadow-custom' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'table-responsive content-sec col-md-12 col-xs-12 pad-no mar-t-no' },
	                                    _react2.default.createElement(
	                                        'table',
	                                        { className: 'table table-custom-design table-striped dataTable', ref: function ref(el) {
	                                                return _this2.el = el;
	                                            } },
	                                        _react2.default.createElement(
	                                            'thead',
	                                            null,
	                                            _react2.default.createElement(
	                                                'tr',
	                                                { role: 'row' },
	                                                _react2.default.createElement(
	                                                    'th',
	                                                    { className: 'tabledata' },
	                                                    'S.No'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'th',
	                                                    { className: 'tabledata' },
	                                                    'Camp Name'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'th',
	                                                    { className: 'tabledata' },
	                                                    'Approval Status'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'th',
	                                                    { className: 'tabledata' },
	                                                    'Action'
	                                                )
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { 'class': 'modal fade', role: 'dialog', tabindex: '-1', id: 'checkout-modal' },
	                        _react2.default.createElement(
	                            'div',
	                            { 'class': 'modal-dialog modal-md modal-dialog-centered', role: 'document' },
	                            _react2.default.createElement(
	                                'div',
	                                { 'class': 'modal-content' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'modal-header' },
	                                    _react2.default.createElement(
	                                        'h5',
	                                        { 'class': 'modal-title' },
	                                        'Confirmation'
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'modal-body' },
	                                    _react2.default.createElement(
	                                        'p',
	                                        null,
	                                        'Are you sure want to remove this Camp?'
	                                    ),
	                                    _react2.default.createElement('input', { type: 'hidden', id: 'cart_id' })
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'modal-footer' },
	                                    _react2.default.createElement(
	                                        'button',
	                                        { type: 'button', 'class': 'btn btn-light', 'data-dismiss': 'modal' },
	                                        'Cancel'
	                                    ),
	                                    _react2.default.createElement(
	                                        'button',
	                                        { type: 'button', 'class': 'btn btn-success', 'data-dismiss': 'modal', 'aria-label': 'Close', onClick: function onClick() {
	                                                _this2.deleteScl();
	                                            } },
	                                        'Remove'
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return CuratedCamps;
	}(_react.Component);
	
	exports.default = CuratedCamps;

/***/ },
/* 977 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _constant = __webpack_require__(21);
	
	var _FetchCall = __webpack_require__(4);
	
	var _simpleReactValidator = __webpack_require__(28);
	
	var _simpleReactValidator2 = _interopRequireDefault(_simpleReactValidator);
	
	var _reactAutosuggest = __webpack_require__(86);
	
	var _reactAutosuggest2 = _interopRequireDefault(_reactAutosuggest);
	
	var _reactGeocode = __webpack_require__(55);
	
	var _reactGeocode2 = _interopRequireDefault(_reactGeocode);
	
	var _reactTooltip = __webpack_require__(133);
	
	var _reactTooltip2 = _interopRequireDefault(_reactTooltip);
	
	var _reactPlacesAutocomplete = __webpack_require__(132);
	
	var _reactPlacesAutocomplete2 = _interopRequireDefault(_reactPlacesAutocomplete);
	
	__webpack_require__(18);
	
	var _reactNotifications = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import { Editor } from '@tinymce/tinymce-react';
	
	
	_reactGeocode2.default.setApiKey("AIzaSyA9MtbfG_zlo64B2lqNMvigTBuXHkagKcE");
	_reactGeocode2.default.setLanguage("en");
	_reactGeocode2.default.setRegion("es");
	_reactGeocode2.default.enableDebug();
	
	var partnerBranchAdd = function (_Component) {
	  _inherits(partnerBranchAdd, _Component);
	
	  function partnerBranchAdd(props) {
	    var _this$state;
	
	    _classCallCheck(this, partnerBranchAdd);
	
	    var _this = _possibleConstructorReturn(this, (partnerBranchAdd.__proto__ || Object.getPrototypeOf(partnerBranchAdd)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var qrystr = window.location.search;
	    var urlParams = new URLSearchParams(qrystr);
	    var sid = urlParams.get('sid');
	    var login_id = urlParams.get('login_id');
	
	    _this.state = (_this$state = {
	      user_data: localStorage.getItem('user_data') ? JSON.parse(localStorage.getItem('user_data')) : [],
	      authentication: localStorage.getItem('authentication') ? JSON.parse(localStorage.getItem('authentication')) : false,
	      is_completed: localStorage.getItem('is_completed') ? localStorage.getItem('is_completed') : 0,
	      access: [],
	      sid: sid != null ? sid : -1,
	      main_id: 0,
	      suggestions: [],
	      user_type: 0,
	      spartner_id: 0,
	      btnDisabled: false,
	      registration_no: '',
	      org_name: '',
	      first_name: '',
	      last_name: '',
	      address: '',
	      google_address: '',
	      location: '',
	      state: '',
	      pincode: '',
	      email: '',
	      contact_number: '',
	      landline: '',
	      social_media: '',
	      social_media_link: '',
	      sub_category: [],
	      type_one: [],
	      type_two: [],
	      first_category: [],
	      second_category: [],
	      third_category: [],
	      location_list: [],
	      spartner_list: []
	    }, _defineProperty(_this$state, 'suggestions', []), _defineProperty(_this$state, 'first_type_mul', true), _defineProperty(_this$state, 'second_mult', false), _defineProperty(_this$state, 'third_mult', false), _defineProperty(_this$state, 'lbl_sec_cate', ''), _defineProperty(_this$state, 'lbl_third_cate', ''), _defineProperty(_this$state, 'latitude', ''), _defineProperty(_this$state, 'longitude', ''), _defineProperty(_this$state, 'is_completd', 0), _defineProperty(_this$state, 'main_access', ''), _defineProperty(_this$state, 'main_category', 0), _defineProperty(_this$state, 'button', 'Submit'), _defineProperty(_this$state, 'master_data', []), _defineProperty(_this$state, 'uids', []), _defineProperty(_this$state, 'cids', []), _defineProperty(_this$state, 'cat_list', []), _defineProperty(_this$state, 'selected_cids', []), _defineProperty(_this$state, 'social_link_data', [{ id: "li", name: 'LinkedIn', link: "" }, { id: "fb", name: 'Facebook', link: "" }, { id: "in", name: 'Instagram', link: "" }]), _defineProperty(_this$state, 'autosaveddata', []), _defineProperty(_this$state, 'parent_address', 'madras'), _this$state);
	
	    _this.validator = new _simpleReactValidator2.default({
	      validators: {
	        checkMobile: _constant.MOBILE_REGEX,
	        checkUrl: _constant.URL_REGEX,
	        not_eq_ho: {
	          message: "Address must not be the same as in Head Office",
	          rule: function rule(val, params, validator) {
	            return val == params[0];
	          }
	          /* test dev
	          notsame: {  // name the rule
	            message: 'The :attribute must not be same as in Head Office',
	            rule: (val, params, validator) => {
	              return validator.helpers.testRegex(val,/^(?!0)(?!.*\.$)((1?\d?\d|25[0-5]|2[0-4]\d)(\.|$)){4}$/i) && params.indexOf(val) === -1
	            }
	          }*/
	        } }
	    });
	    _this.getProfileData = _this.getProfileData.bind(_this);
	    _this.getCategories = _this.getCategories.bind(_this);
	    _this.handleCustomSelect = _this.handleCustomSelect.bind(_this);
	    return _this;
	  }
	
	  _createClass(partnerBranchAdd, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	
	      this.getProfileData();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      window.jQuery('.selectpicker').selectpicker('refresh');
	    }
	  }, {
	    key: 'Geocode_location',
	    value: function Geocode_location() {
	      var address = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	      var THIS = this;
	      var add = address ? address : this.state.google_address;
	      _reactGeocode2.default.fromAddress(add).then(function (response) {
	        var _response$results$0$g = response.results[0].geometry.location,
	            lat = _response$results$0$g.lat,
	            lng = _response$results$0$g.lng;
	
	        THIS.setState({
	          latitude: lat,
	          longitude: lng
	        });
	      }, function (error) {
	        console.error(error);
	      });
	    }
	  }, {
	    key: 'escapeRegexCharacters',
	    value: function escapeRegexCharacters(str) {
	      return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	    }
	  }, {
	    key: 'renderSuggestion',
	    value: function renderSuggestion(suggestion) {
	      return _react2.default.createElement(
	        'span',
	        null,
	        suggestion.name
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      this.validator.purgeFields();
	      var _state = this.state,
	          user_type = _state.user_type,
	          user_data = _state.user_data,
	          suggestions = _state.suggestions,
	          cat_list = _state.cat_list;
	
	      var add_type = user_type == 1 ? ' Of the Institution' : '';
	      var type = user_type == 1 ? ' Institution' : '';
	      var inputProps = {
	        value: this.state.org_name ? this.state.org_name : '',
	        onChange: this.onChange,
	        name: 'org_name',
	        className: 'form-control'
	      };
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'col-12 grid-margin' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card-body' },
	                _react2.default.createElement(
	                  'h4',
	                  { 'class': 'card-title' },
	                  'Add a Branch'
	                ),
	                _react2.default.createElement(
	                  'form',
	                  { onSubmit: this.submitForm, autoComplete: 'off' },
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'box-shadow-custom' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'form-group col-md-4' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          'Name of the Institution ',
	                          _react2.default.createElement(
	                            'span',
	                            { 'class': 'astrick' },
	                            '*'
	                          )
	                        ),
	                        _react2.default.createElement(_reactAutosuggest2.default, {
	                          suggestions: suggestions,
	                          shouldRenderSuggestions: this.shouldRenderSuggestions,
	                          onSuggestionsFetchRequested: this.onSuggestionsFetchRequested,
	                          onSuggestionsClearRequested: this.onSuggestionsClearRequested,
	                          getSuggestionValue: this.getSuggestionValue,
	                          renderSuggestion: this.renderSuggestion,
	                          inputProps: inputProps }),
	                        this.validator.message('Name of the Institution', this.state.org_name, 'required', { className: 'text-danger' })
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'form-group col-md-4' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          'Business Registration Number ',
	                          _react2.default.createElement(
	                            'span',
	                            { 'class': 'astrick' },
	                            '*'
	                          )
	                        ),
	                        _react2.default.createElement('input', { type: 'text',
	                          'class': 'form-control', name: 'registration_no',
	                          value: this.state.registration_no,
	                          onKeyUp: this.autoSave,
	                          onChange: this.handleChange }),
	                        this.validator.message('Business Registration Number', this.state.registration_no, 'required|alpha_num', { className: 'text-danger' })
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'form-group col-md-4' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          'Category ',
	                          _react2.default.createElement(
	                            'span',
	                            { 'class': 'astrick' },
	                            '*'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'select',
	                          { className: 'form-control selectpicker',
	                            title: "Select Category",
	                            name: 'selected_cids',
	                            multiple: true,
	                            onChange: this.handleSelect },
	                          cat_list.map(function (item, k) {
	                            return _react2.default.createElement(
	                              'option',
	                              { value: item.category_id },
	                              item.category_name
	                            );
	                          })
	                        ),
	                        this.validator.message('Category', this.state.selected_cids, 'required', { className: 'text-danger' })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'form-group col-md-4' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          'Name ',
	                          _react2.default.createElement(
	                            'span',
	                            { 'class': 'astrick' },
	                            '*'
	                          )
	                        ),
	                        _react2.default.createElement('input', { type: 'text',
	                          'class': 'form-control', name: 'first_name',
	                          value: this.state.first_name,
	                          onKeyUp: this.autoSave,
	                          onChange: this.handleChange }),
	                        this.validator.message('First Name', this.state.first_name, 'required', { className: 'text-danger' })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'form-group col-md-6' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          'Address ',
	                          add_type,
	                          ' ',
	                          _react2.default.createElement(
	                            'span',
	                            { 'class': 'astrick' },
	                            '*'
	                          )
	                        ),
	                        _react2.default.createElement('input', { type: 'text',
	                          'class': 'form-control', name: 'address',
	                          value: this.state.address,
	                          onKeyUp: this.autoSave,
	                          onChange: this.handleChange }),
	                        this.validator.message('Address' + add_type, this.state.address, 'required|not_eq_ho:["' + this.state.temp_org_address + '"]', { className: 'text-danger' })
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'form-group col-md-6' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          'Google Location ',
	                          _react2.default.createElement('i', { 'class': 'fa fa-info-circle info-tool', 'data-tip': true, 'data-for': 'info-goole', 'aria-hidden': 'true' }),
	                          _react2.default.createElement(
	                            _reactTooltip2.default,
	                            { id: 'info-goole', place: 'bottom', effect: 'solid', className: 'react_tooltip_backgrnd' },
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              'Type and Select From Autopopulated List'
	                            )
	                          ),
	                          ' ',
	                          _react2.default.createElement(
	                            'span',
	                            { 'class': 'astrick' },
	                            '*'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          _reactPlacesAutocomplete2.default,
	                          {
	                            value: this.state.google_address,
	                            className: 'form-control',
	                            onChange: this.handleplaceChangeIns,
	                            onSelect: this.handleplaceSelectIns
	                          },
	                          function (_ref) {
	                            var getInputProps = _ref.getInputProps,
	                                suggestions = _ref.suggestions,
	                                getSuggestionItemProps = _ref.getSuggestionItemProps,
	                                loading = _ref.loading;
	                            return _react2.default.createElement(
	                              'div',
	                              null,
	                              _react2.default.createElement('input', Object.assign({}, getInputProps({
	                                placeholder: 'Search Places ...',
	                                className: 'form-control',
	                                id: 'address_ins'
	                              }), {
	                                value: _this2.state.google_address
	                              })),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'autocomplete-dropdown-container',
	                                  style: { position: "absolute", zIndex: "999" } },
	                                loading && _react2.default.createElement(
	                                  'div',
	                                  null,
	                                  'Loading...'
	                                ),
	                                suggestions.map(function (suggestion) {
	                                  var className = suggestion.active ? 'suggestion-item--active' : 'suggestion-item';
	                                  // inline style for demonstration purpose
	                                  var style = suggestion.active ? { backgroundColor: '#fafafa', cursor: 'pointer' } : { backgroundColor: '#ffffff', cursor: 'pointer' };
	                                  return _react2.default.createElement(
	                                    'div',
	                                    getSuggestionItemProps(suggestion, {
	                                      className: className,
	                                      style: style
	                                    }),
	                                    _react2.default.createElement(
	                                      'span',
	                                      null,
	                                      suggestion.description
	                                    )
	                                  );
	                                })
	                              )
	                            );
	                          }
	                        ),
	                        this.validator.message('Google Location', this.state.google_address, 'required', { className: 'text-danger' })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'form-group col-md-4' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          'City ',
	                          _react2.default.createElement(
	                            'span',
	                            { 'class': 'astrick' },
	                            '*'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'select',
	                          { className: 'form-control selectpicker',
	                            title: "Select",
	                            name: 'city',
	                            onChange: this.handleChange,
	                            onKeyUp: this.autoSave,
	                            value: this.state.city },
	                          this.state.location_list.map(function (item, i) {
	                            return _react2.default.createElement(
	                              'option',
	                              { key: i + 'L' },
	                              item.location
	                            );
	                          })
	                        ),
	                        this.validator.message('City', this.state.city, 'required', { className: 'text-danger' })
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'form-group col-md-4' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          'State ',
	                          _react2.default.createElement(
	                            'span',
	                            { 'class': 'astrick' },
	                            '*'
	                          )
	                        ),
	                        _react2.default.createElement('input', { type: 'text',
	                          'class': 'form-control', name: 'state',
	                          value: this.state.state,
	                          onKeyUp: this.autoSave,
	                          onChange: this.handleChange }),
	                        this.validator.message('state', this.state.state, 'required|alpha_num', { className: 'text-danger' })
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'form-group col-md-4' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          'Pincode ',
	                          _react2.default.createElement(
	                            'span',
	                            { 'class': 'astrick' },
	                            '*'
	                          )
	                        ),
	                        _react2.default.createElement('input', { type: 'text',
	                          'class': 'form-control', name: 'pincode',
	                          value: this.state.pincode,
	                          onKeyUp: this.autoSave,
	                          onChange: this.handleChange }),
	                        this.validator.message('pincode', this.state.pincode, 'required|numeric|min:1,num', { className: 'text-danger' })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'form-group col-md-12' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          type,
	                          ' Email Address ',
	                          _react2.default.createElement(
	                            'span',
	                            { 'class': 'astrick' },
	                            '*'
	                          )
	                        ),
	                        _react2.default.createElement('input', { type: 'text',
	                          'class': 'form-control', name: 'email',
	                          value: this.state.email,
	                          onKeyUp: this.autoSave,
	                          onChange: this.handleChange }),
	                        this.validator.message(type + 'Email Address', this.state.email, 'required|email', { className: 'text-danger' })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'form-group col-md-6' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          type,
	                          ' Contact Number ',
	                          _react2.default.createElement(
	                            'span',
	                            { 'class': 'astrick' },
	                            '*'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'phone-wrapper-new' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'form-group col-4' },
	                              _react2.default.createElement('input', { type: 'text', name: 'contact_number_code',
	                                placeholder: '',
	                                onKeyUp: this.autoSave,
	                                value: '+91',
	                                onChange: this.handleChange, className: 'form-control', disabled: true })
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'form-group col-8' },
	                              _react2.default.createElement('input', { type: 'text', name: 'contact_number',
	                                placeholder: '',
	                                onKeyUp: this.autoSave,
	                                value: this.state.contact_number,
	                                onChange: this.handleChange, className: 'form-control' })
	                            )
	                          )
	                        ),
	                        this.validator.message(type + 'Contact Number', this.state.contact_number, 'required|checkMobile|min:10|max:50', { className: 'text-danger' })
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'form-group col-md-6' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          type,
	                          ' Landline '
	                        ),
	                        _react2.default.createElement('input', { type: 'text',
	                          'class': 'form-control', name: 'landline',
	                          value: this.state.landline,
	                          onKeyUp: this.autoSave,
	                          onChange: this.handleChange }),
	                        this.validator.message(type + 'Landline', this.state.landline, 'numeric', { className: 'text-danger' })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'form-group col-md-12' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          ' Social Links ',
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'astrick' },
	                            '*'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'table',
	                          { className: 'table socialtable desktoponly' },
	                          _react2.default.createElement(
	                            'tbody',
	                            null,
	                            _react2.default.createElement(
	                              'tr',
	                              null,
	                              _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                  'b',
	                                  null,
	                                  'Media'
	                                )
	                              ),
	                              this.state.social_link_data.map(function (item, i) {
	                                return _react2.default.createElement(
	                                  'td',
	                                  null,
	                                  item.name
	                                );
	                              })
	                            ),
	                            _react2.default.createElement(
	                              'tr',
	                              null,
	                              _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                  'b',
	                                  null,
	                                  'Link'
	                                ),
	                                ' ',
	                                _react2.default.createElement('i', { 'class': 'fa fa-info-circle info-tool', 'data-tip': true, 'data-for': 'info', 'aria-hidden': 'true' }),
	                                _react2.default.createElement(
	                                  _reactTooltip2.default,
	                                  { id: 'info', place: 'bottom', effect: 'solid', className: 'react_tooltip_backgrnd' },
	                                  _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    'Please start with "https://...."'
	                                  )
	                                )
	                              ),
	                              this.state.social_link_data.map(function (item, i) {
	                                return _react2.default.createElement(
	                                  'td',
	                                  null,
	                                  _react2.default.createElement('input', { type: 'text', className: 'form-control', onChange: function onChange(e) {
	                                      return _this2.customChange(e, i);
	                                    },
	                                    value: item.link }),
	                                  _this2.validator.message(item.name, item.link, 'url', { className: 'text-danger' })
	                                );
	                              })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'table',
	                          { className: 'table socialtable mobileonly' },
	                          _react2.default.createElement(
	                            'tbody',
	                            null,
	                            _react2.default.createElement(
	                              'tr',
	                              null,
	                              _react2.default.createElement(
	                                'th',
	                                null,
	                                _react2.default.createElement(
	                                  'b',
	                                  null,
	                                  'Media'
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'th',
	                                null,
	                                _react2.default.createElement(
	                                  'b',
	                                  null,
	                                  'Link'
	                                )
	                              )
	                            ),
	                            this.state.social_link_data.map(function (item, i) {
	                              return _react2.default.createElement(
	                                'tr',
	                                null,
	                                _react2.default.createElement(
	                                  'td',
	                                  null,
	                                  item.name
	                                ),
	                                _react2.default.createElement(
	                                  'td',
	                                  null,
	                                  _react2.default.createElement('input', { type: 'text', className: 'form-control', onChange: function onChange(e) {
	                                      return _this2.customChange(e, i);
	                                    },
	                                    value: item.link }),
	                                  _this2.validator.message(item.name, item.link, 'url', { className: 'text-danger' })
	                                )
	                              );
	                            })
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'box-shadow-custom' },
	                    _react2.default.createElement(
	                      'h5',
	                      { className: 'astrick' },
	                      _react2.default.createElement(
	                        'b',
	                        null,
	                        'Notes'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'ul',
	                      null,
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        'Please suffix location to the name of the institution when you add a branch or category'
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        'If you need help - please write to us at contact@bewise.in'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'col-md-12 col-xs-12 btn-bdr text-right pad-hor-no mar-btm' },
	                    _react2.default.createElement(
	                      'a',
	                      { href: '/partner/profile', alt: 'back', 'class': 'btn btn-primary btn-sm' },
	                      'Back'
	                    ),
	                    '\xA0',
	                    _react2.default.createElement(
	                      'button',
	                      { type: 'submit', id: 'btnSubmit',
	                        className: 'btn btn-primary btn-sm', disabled: this.state.btnDisabled },
	                      this.state.button
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(_reactNotifications.NotificationContainer, null)
	        )
	      );
	    }
	  }]);
	
	  return partnerBranchAdd;
	}(_react.Component);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this3 = this;
	
	  this.handleCustomSelect = function (e) {
	    var propName = e.target.name;
	    var value = [].concat(_toConsumableArray(e.target.selectedOptions)).map(function (item) {
	      return item.value;
	    });
	    var page_data = _this3.state.selected_cids;
	    page_data[propName] = value;
	    _this3.setState({ page_data: page_data });
	  };
	
	  this.handleplaceChangeIns = function (google_address) {
	    _this3.setState({ google_address: google_address });
	  };
	
	  this.handleplaceSelectIns = function (address) {
	    _this3.setState({ google_address: address });
	  };
	
	  this.getCategories = function (cids) {
	
	    var req = JSON.stringify({
	      cids: cids
	    });
	
	    (0, _FetchCall.fetch_category_by_ids)(req).then(function (res) {
	
	      if (res.status === 1) {
	        var cat_list = res.category_data;
	        _this3.setState({
	          cat_list: cat_list.result
	        });
	      }
	    });
	  };
	
	  this.getProfileData = function () {
	    var _state$user_data = _this3.state.user_data,
	        user_type = _state$user_data.user_type,
	        login_id = _state$user_data.login_id,
	        is_completd = _state$user_data.is_completd,
	        current_category = _state$user_data.current_category,
	        set_id = _state$user_data.set_id;
	
	
	    var req = JSON.stringify({
	      user_type: user_type,
	      login_id: login_id,
	      is_completd: is_completd,
	      category: current_category,
	      sid: _this3.state.sid != -1 ? _this3.state.sid : set_id,
	      url: 'getProfileData'
	    });
	    (0, _FetchCall.partnerApi)(req).then(function (res) {
	      if (res.status === 1) {
	        var data = res.result;
	        _this3.Geocode_location(data.address);
	
	        var social_link_dataw_x_twitter = data.social_link_data ? JSON.parse(data.social_link_data).filter(function (sociallink) {
	          return sociallink.name !== "Twitter";
	        }) : _this3.state.social_link_data;
	
	        if (user_type === 1) {
	
	          _this3.setState({
	            vendor_id: data.vendor_id,
	            registration_no: data.organisation_register_number,
	            org_name: data.organisation_name,
	            temp_org_name: data.organisation_name,
	            first_name: '',
	            last_name: '',
	            address: '',
	            temp_org_address: '',
	            google_address: '',
	            city: data.location,
	            state: data.state,
	            pincode: data.pin_code,
	            email: data.institution_email_address,
	            //social_link_data: social_link_dataw_x_twitter ? JSON.parse(social_link_dataw_x_twitter) : this.state.social_link_data,
	            social_link_data: social_link_dataw_x_twitter,
	            contact_number: data.phone_number,
	            landline: data.landline_number,
	            social_media: data.social_link,
	            social_media_link: data.social_media_link,
	            main_access: data.main_access,
	            is_completd: data.is_completd
	          });
	        } else if (user_type === 2) {
	          _this3.setState({
	            vendor_id: data.vendor_id,
	            main_id: data.main_id ? data.main_id : 0,
	            registration_no: '',
	            org_name: '',
	            first_name: data.first_name,
	            last_name: data.last_name,
	            address: '',
	            google_address: '',
	            city: data.location,
	            state: data.state,
	            pincode: data.pin_code,
	            email: data.email_id,
	            contact_number: data.phone_number,
	            landline: data.landline_number,
	            social_media: data.social_link,
	            social_media_link: data.social_media_link,
	            main_access: data.main_access,
	            is_completd: data.is_completd
	          });
	        }
	        _this3.setState({
	          location_list: res.location,
	          master_data: data.master_data,
	          uids: data.uids,
	          cids: data.cids
	        });
	
	        _this3.getCategories(data.cids);
	      }
	    });
	  };
	
	  this.customChange = function (e, i) {
	    var social_link_data = _this3.state.social_link_data;
	    if (social_link_data.length > 0 && social_link_data[i]) {
	      social_link_data[i].link = e.target.value;
	    }
	    _this3.setState({ social_link_data: social_link_data });
	  };
	
	  this.handlePaste = function (e) {
	    _this3.Geocode_location();
	  };
	
	  this.handleChange = function (e) {
	    var propName = e.target.name;
	    _this3.setState(_defineProperty({}, e.target.name, e.target.value));
	  };
	
	  this.handleSelect = function (e) {
	    var propName = e.target.name;
	    var value = [].concat(_toConsumableArray(e.target.selectedOptions)).map(function (item) {
	      return item.value;
	    });
	    _this3.setState(_defineProperty({}, propName, value));
	  };
	
	  this.shouldRenderSuggestions = function (value, reason) {
	    return value.trim().length > 2;
	  };
	
	  this.onSuggestionsFetchRequested = function (_ref2) {
	    var value = _ref2.value;
	
	    var val = _this3.escapeRegexCharacters(value.trim());
	    var login_id = _this3.state.user_data.login_id;
	    var fetch = JSON.stringify({
	      keyword: val,
	      login_id: login_id,
	      url: 'getDataByName'
	    });
	    (0, _FetchCall.partnerApi)(fetch).then(function (res) {
	      if (res.status == 1) {
	        _this3.setState({
	          suggestions: res.result
	        });
	      }
	    });
	  };
	
	  this.onSuggestionsClearRequested = function () {
	    _this3.setState({
	      suggestions: []
	    });
	  };
	
	  this.getSuggestionValue = function (suggestion) {
	    _this3.setState({ confirmModal: true });
	    var currentData = suggestion;
	    currentData.url = 'getDataById';
	    var data = JSON.stringify(currentData);
	    (0, _FetchCall.partnerApi)(data).then(function (res) {
	      if (res.status === 1) {
	        var _data = res.result;
	        _this3.setState({
	          registration_no: _data.organisation_register_number,
	          address: _data.address,
	          google_address: _data.google_address,
	          city: _data.location,
	          state: _data.state,
	          pincode: _data.pin_code,
	          contact_number: _data.institution_contact_number,
	          email: _data.institution_email_address,
	          social_media: _data.social_link,
	          social_media_link: _data.social_media_link,
	          social_link_data: _data.social_link_data ? JSON.parse(_data.social_link_data) : _this3.state.social_link_data
	        });
	      } else {
	        _this3.setState({
	          registration_no: '',
	          address: '',
	          google_address: '',
	          city: '',
	          state: '',
	          pincode: '',
	          contact_number: '',
	          email: '',
	          social_media: '',
	          social_media_link: '',
	          social_link_data: _this3.state.social_link_data
	        });
	      }
	    });
	    return suggestion.name;
	  };
	
	  this.onChange = function (event, _ref3) {
	    var newValue = _ref3.newValue,
	        method = _ref3.method;
	
	    _this3.setState({
	      org_name: newValue
	    });
	  };
	
	  this.submitForm = function (e) {
	    e.preventDefault();
	    if (_this3.validator.allValid()) {
	      var _state$user_data2 = _this3.state.user_data,
	          user_type = _state$user_data2.user_type,
	          login_id = _state$user_data2.login_id;
	
	      var request = JSON.stringify({
	        vendor_id: _this3.state.vendor_id,
	        user_type: user_type,
	        master_data: _this3.state.master_data,
	        uids: _this3.state.uids,
	        cids: _this3.state.cids,
	        selected_cids: _this3.state.selected_cids,
	        login_id: login_id,
	        is_completd: _this3.state.is_completd,
	        registration_no: _this3.state.registration_no,
	        org_name: _this3.state.org_name,
	        first_name: _this3.state.first_name,
	        last_name: _this3.state.last_name,
	        address: _this3.state.address,
	        google_address: _this3.state.google_address,
	        latitude: _this3.state.latitude,
	        longitude: _this3.state.longitude,
	        city: _this3.state.city,
	        state: _this3.state.state,
	        pincode: _this3.state.pincode,
	        email: _this3.state.email,
	        contact_number: _this3.state.contact_number,
	        landline: _this3.state.landline,
	        social_media: _this3.state.social_media,
	        social_media_link: _this3.state.social_media_link,
	        social_link_data: JSON.stringify(_this3.state.social_link_data),
	        access: _this3.state.access,
	        sub_category: _this3.state.sub_category,
	        main_access: _this3.state.main_access,
	        type_one: _this3.state.type_one,
	        type_two: _this3.state.type_two
	      });
	
	      //console.log(request);
	
	      (0, _FetchCall.partnerAddBranch)(request).then(function (res) {
	        if (res.status === 1) {
	          _reactNotifications.NotificationManager.success(res.message);
	          _this3.setState({ btnDisabled: true });
	          setTimeout(function () {
	            '/partner/profile';
	          }, 1000);
	        } else {
	          _reactNotifications.NotificationManager.error(res.message);
	          _this3.setState({ btnDisabled: false });
	        }
	      });
	    } else {
	      _this3.validator.showMessages();
	      _this3.forceUpdate();
	    }
	  };
	};
	
	exports.default = partnerBranchAdd;

/***/ },
/* 978 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _reactstrap = __webpack_require__(17);
	
	var _Tabs = __webpack_require__(65);
	
	var _Tabs2 = _interopRequireDefault(_Tabs);
	
	var _TabsPane = __webpack_require__(64);
	
	var _TabsPane2 = _interopRequireDefault(_TabsPane);
	
	var _reactDataTableComponent = __webpack_require__(53);
	
	var _reactDataTableComponent2 = _interopRequireDefault(_reactDataTableComponent);
	
	var _branch = __webpack_require__(362);
	
	var _branch2 = _interopRequireDefault(_branch);
	
	var _curatedcamps = __webpack_require__(976);
	
	var _curatedcamps2 = _interopRequireDefault(_curatedcamps);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import { Editor } from '@tinymce/tinymce-react';
	
	var childTabs = [{
	    name: "Branches",
	    id: "branch",
	    defaultChecked: true
	    /*
	    {
	        name: "BeWise Curated Camps",
	        id: "curated",
	    }
	    */
	}];
	
	var partnerBranches = function (_Component) {
	    _inherits(partnerBranches, _Component);
	
	    function partnerBranches(props) {
	        _classCallCheck(this, partnerBranches);
	
	        var _this = _possibleConstructorReturn(this, (partnerBranches.__proto__ || Object.getPrototypeOf(partnerBranches)).call(this, props));
	
	        _this.handleChange = function (e) {
	            _this.setState(_defineProperty({}, e.target.name, e.target.value));
	        };
	
	        _this.state = {
	            logged: localStorage.getItem("authentication"),
	            auth_data: JSON.parse(localStorage.getItem("user_data"))
	        };
	
	        return _this;
	    }
	
	    _createClass(partnerBranches, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {}
	    }, {
	        key: 'render',
	        value: function render() {
	
	            return _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _react2.default.createElement(
	                    _layout2.default,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { 'class': 'col-12 grid-margin' },
	                        _react2.default.createElement(
	                            'div',
	                            { 'class': 'card' },
	                            _react2.default.createElement(
	                                'div',
	                                { 'class': 'card-body' },
	                                _react2.default.createElement(
	                                    'h4',
	                                    { 'class': 'card-title' },
	                                    'Branches'
	                                ),
	                                _react2.default.createElement(
	                                    _Tabs2.default,
	                                    { tabsetName: 'dashboard', childTabs: childTabs },
	                                    _react2.default.createElement(
	                                        _TabsPane2.default,
	                                        { id: 'branch' },
	                                        _react2.default.createElement(_branch2.default, null)
	                                    ),
	                                    _react2.default.createElement(
	                                        _TabsPane2.default,
	                                        { id: 'curated' },
	                                        _react2.default.createElement(_curatedcamps2.default, null)
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return partnerBranches;
	}(_react.Component);
	
	exports.default = partnerBranches;

/***/ },
/* 979 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _chart = __webpack_require__(83);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import { Editor } from '@tinymce/tinymce-react';
	
	var doughnutPieOptions = {
	    responsive: true,
	    animation: {
	        animateScale: true,
	        animateRotate: true
	    }
	};
	
	var optionsN = {
	    scales: {
	        yAxes: [{
	            ticks: {
	                beginAtZero: true
	            }
	        }]
	
	    }
	};
	
	var partnerDashboard = function (_Component) {
	    _inherits(partnerDashboard, _Component);
	
	    function partnerDashboard(props) {
	        _classCallCheck(this, partnerDashboard);
	
	        var _this = _possibleConstructorReturn(this, (partnerDashboard.__proto__ || Object.getPrototypeOf(partnerDashboard)).call(this, props));
	
	        _this.setVisitors = function (data) {
	
	            var ctx = document.getElementById('barChartVisitors');
	            var myChart = new _chart.Chart(ctx, {
	                type: 'bar',
	                data: data,
	                options: optionsN
	            });
	        };
	
	        _this.setLike = function (data) {
	
	            var ctx = document.getElementById('barChartLikeFollows');
	            var myChart = new _chart.Chart(ctx, {
	                type: 'bar',
	                data: data,
	                options: optionsN
	            });
	        };
	
	        _this.setAfterschoolChart = function (data) {
	
	            var ctx = document.getElementById('afterschoolChart');
	            var myChart = new _chart.Chart(ctx, {
	                type: 'doughnut',
	                data: data,
	                options: doughnutPieOptions
	            });
	        };
	
	        _this.setTuitionChart = function (data) {
	
	            var ctx = document.getElementById('tuitionChart');
	            var myChart = new _chart.Chart(ctx, {
	                type: 'doughnut',
	                data: data,
	                options: doughnutPieOptions
	            });
	        };
	
	        _this.setSchoolChart = function (data) {
	
	            var ctx = document.getElementById('schoolChart');
	            var myChart = new _chart.Chart(ctx, {
	                type: 'doughnut',
	                data: data,
	                options: doughnutPieOptions
	            });
	        };
	
	        _this.setPreschoolChart = function (data) {
	
	            var ctx = document.getElementById('preschoolChart');
	            var myChart = new _chart.Chart(ctx, {
	                type: 'doughnut',
	                data: data,
	                options: doughnutPieOptions
	            });
	        };
	
	        _this.setcampChart = function (data) {
	
	            var ctx = document.getElementById('campChart');
	            var myChart = new _chart.Chart(ctx, {
	                type: 'doughnut',
	                data: data,
	                options: doughnutPieOptions
	            });
	        };
	
	        _this.setcommunityChart = function (data) {
	
	            var ctx = document.getElementById('communityChart');
	            var myChart = new _chart.Chart(ctx, {
	                type: 'doughnut',
	                data: data,
	                options: doughnutPieOptions
	            });
	        };
	
	        _this.setbirthdayChart = function (data) {
	
	            var ctx = document.getElementById('birthdayChart');
	            var myChart = new _chart.Chart(ctx, {
	                type: 'doughnut',
	                data: data,
	                options: doughnutPieOptions
	            });
	        };
	
	        _this.state = {
	            auth_data: JSON.parse(localStorage.getItem("user_data")),
	            school_data: [],
	            allowedtoacess: false,
	            haveleads: false,
	            totalleads: 0
	        };
	        return _this;
	    }
	
	    _createClass(partnerDashboard, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            var dataOfUser = this.state.auth_data;
	            var allowedtoacess = dataOfUser.upgraded == 1 ? true : dataOfUser.current_plan != 5 && dataOfUser.current_plan != 0 && dataOfUser.current_plan != 1 ? true : false;
	
	            var req = {
	                url: 'school_data'
	            };
	
	            (0, _FetchCall.adminDashboard)(JSON.stringify(req)).then(function (response) {
	                if (response.status === 1) {
	                    _this2.setSchoolChart(response.result);
	                }
	            });
	
	            this.setState({ allowedtoacess: allowedtoacess, user_name: this.state.auth_data.user_name, role: this.state.auth_data.role });
	
	            req.url = 'like_follow_chart';
	            (0, _FetchCall.adminDashboard)(JSON.stringify(req)).then(function (response) {
	
	                if (response.status === 1) {
	                    _this2.setLike(response.result);
	                }
	            });
	
	            req.url = 'vistors_chart';
	            (0, _FetchCall.adminDashboard)(JSON.stringify(req)).then(function (response) {
	
	                if (response.status === 1) {
	                    _this2.setVisitors(response.result);
	                }
	            });
	
	            if (dataOfUser.role === 3) {
	                this.checkifLeadsReceived();
	            }
	        }
	    }, {
	        key: 'checkifLeadsReceived',
	        value: function checkifLeadsReceived() {
	            var _this3 = this;
	
	            var insdata = JSON.stringify({
	                vendor_id: this.state.auth_data.login_id
	            });
	
	            (0, _FetchCall.checkifLeadsReceived)(insdata).then(function (response) {
	                if (response.status === 1) {
	                    if (response.total > 0) _this3.setState({ haveleads: true, totalleads: response.total });else _this3.setState({ haveleads: false });
	                }
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	
	            return _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _react2.default.createElement(
	                    _layout2.default,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { 'class': 'row  mt-3' },
	                        !this.state.allowedtoacess && this.state.haveleads && _react2.default.createElement(
	                            'div',
	                            { 'class': 'col-xl-12 d-flex grid-margin stretch-card' },
	                            _react2.default.createElement(
	                                'div',
	                                { 'class': 'leadtemptinfo blinking' },
	                                'You have ',
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    this.state.totalleads,
	                                    ' lead(s)'
	                                ),
	                                ' new prospect(s) in your account. Please subscribe and reach out to them directly.'
	                            )
	                        ),
	                        this.state.allowedtoacess && this.state.haveleads && _react2.default.createElement(
	                            'div',
	                            { 'class': 'col-xl-12 d-flex grid-margin stretch-card' },
	                            _react2.default.createElement(
	                                'div',
	                                { 'class': 'leadtemptinfo blinking' },
	                                'You have new ',
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    this.state.totalleads,
	                                    ' prospect(s)'
	                                )
	                            )
	                        ),
	                        this.state.auth_data.fresher == 1 && _react2.default.createElement(
	                            'div',
	                            { 'class': 'fresh_partner_notification' },
	                            'Welcome, This is your fresh account, Please fill in ',
	                            _react2.default.createElement(
	                                'a',
	                                { href: '/partner/accountinfo/' },
	                                'Account info'
	                            ),
	                            ' and submit for approval so that you can see your institution in our respective listings.'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { 'class': 'col-xl-6 d-flex grid-margin stretch-card' },
	                            _react2.default.createElement(
	                                'div',
	                                { 'class': 'card' },
	                                !this.state.allowedtoacess && _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'overlay' },
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        'Please subscribe or upgrade'
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: !this.state.allowedtoacess ? "card-body blurred" : 'card-body' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'd-flex flex-wrap justify-content-between' },
	                                        _react2.default.createElement(
	                                            'h4',
	                                            { 'class': 'card-title mb-3' },
	                                            'Visitors'
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'row' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'col-12' },
	                                            _react2.default.createElement('canvas', { id: 'barChartVisitors' })
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { 'class': 'col-xl-6 d-flex grid-margin stretch-card' },
	                            _react2.default.createElement(
	                                'div',
	                                { 'class': 'card' },
	                                !this.state.allowedtoacess && _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'overlay' },
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        'Please subscribe or upgrade'
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: !this.state.allowedtoacess ? "card-body blurred" : 'card-body' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'd-flex flex-wrap justify-content-between' },
	                                        _react2.default.createElement(
	                                            'h4',
	                                            { 'class': 'card-title mb-3' },
	                                            'Likes & Follows'
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'row' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'col-12' },
	                                            _react2.default.createElement('canvas', { id: 'barChartLikeFollows' })
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return partnerDashboard;
	}(_react.Component);
	
	exports.default = partnerDashboard;

/***/ },
/* 980 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _chart = __webpack_require__(83);
	
	var _ProgressBar = __webpack_require__(959);
	
	var _ProgressBar2 = _interopRequireDefault(_ProgressBar);
	
	var _amcharts3React = __webpack_require__(228);
	
	var _amcharts3React2 = _interopRequireDefault(_amcharts3React);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import { Editor } from '@tinymce/tinymce-react';
	
	var doughnutPieOptions = {
	    responsive: true,
	    animation: {
	        animateScale: true,
	        animateRotate: true
	    }
	};
	
	var optionsN = {
	    scales: {
	        yAxes: [{
	            ticks: {
	                beginAtZero: true
	            }
	        }]
	
	    }
	};
	
	var partnerDashboardV1 = function (_Component) {
	    _inherits(partnerDashboardV1, _Component);
	
	    function partnerDashboardV1(props) {
	        _classCallCheck(this, partnerDashboardV1);
	
	        var _this = _possibleConstructorReturn(this, (partnerDashboardV1.__proto__ || Object.getPrototypeOf(partnerDashboardV1)).call(this, props));
	
	        _this.setReviewGraphs = function (data) {
	
	            var ctx = document.getElementById('barChartReviews');
	            var myChart = new _chart.Chart(ctx, {
	                type: 'bar',
	                data: data,
	                options: optionsN
	            });
	        };
	
	        _this.setVisitors = function (data) {
	
	            var ctx = document.getElementById('barChartVisitors');
	            var myChart = new _chart.Chart(ctx, {
	                type: 'bar',
	                data: data,
	                options: optionsN
	            });
	        };
	
	        _this.setLike = function (data) {
	
	            var ctx = document.getElementById('barChartLikeFollows');
	            var myChart = new _chart.Chart(ctx, {
	                type: 'bar',
	                data: data,
	                options: optionsN
	            });
	        };
	
	        _this.setAfterschoolChart = function (data) {
	
	            var ctx = document.getElementById('afterschoolChart');
	            var myChart = new _chart.Chart(ctx, {
	                type: 'doughnut',
	                data: data,
	                options: doughnutPieOptions
	            });
	        };
	
	        _this.setTuitionChart = function (data) {
	
	            var ctx = document.getElementById('tuitionChart');
	            var myChart = new _chart.Chart(ctx, {
	                type: 'doughnut',
	                data: data,
	                options: doughnutPieOptions
	            });
	        };
	
	        _this.setSchoolChart = function (data) {
	
	            var ctx = document.getElementById('schoolChart');
	            var myChart = new _chart.Chart(ctx, {
	                type: 'doughnut',
	                data: data,
	                options: doughnutPieOptions
	            });
	        };
	
	        _this.setPreschoolChart = function (data) {
	
	            var ctx = document.getElementById('preschoolChart');
	            var myChart = new _chart.Chart(ctx, {
	                type: 'doughnut',
	                data: data,
	                options: doughnutPieOptions
	            });
	        };
	
	        _this.setcampChart = function (data) {
	
	            var ctx = document.getElementById('campChart');
	            var myChart = new _chart.Chart(ctx, {
	                type: 'doughnut',
	                data: data,
	                options: doughnutPieOptions
	            });
	        };
	
	        _this.setcommunityChart = function (data) {
	
	            var ctx = document.getElementById('communityChart');
	            var myChart = new _chart.Chart(ctx, {
	                type: 'doughnut',
	                data: data,
	                options: doughnutPieOptions
	            });
	        };
	
	        _this.setbirthdayChart = function (data) {
	
	            var ctx = document.getElementById('birthdayChart');
	            var myChart = new _chart.Chart(ctx, {
	                type: 'doughnut',
	                data: data,
	                options: doughnutPieOptions
	            });
	        };
	
	        _this.state = {
	            auth_data: JSON.parse(localStorage.getItem("user_data")),
	            school_data: [],
	            allowedtoacess: false,
	            clickedEnqG: false,
	            clickedRevG: false,
	            clickedProfCompl: false
	        };
	
	        _this.LoadGrpah = _this.LoadGrpah.bind(_this);
	        return _this;
	    }
	
	    _createClass(partnerDashboardV1, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            var dataOfUser = this.state.auth_data;
	            var allowedtoacess = dataOfUser.upgraded == 1 ? true : dataOfUser.current_plan != 5 && dataOfUser.current_plan != 0 && dataOfUser.current_plan != 1 ? true : false;
	
	            var req = {
	                url: 'school_data'
	            };
	
	            (0, _FetchCall.adminDashboard)(JSON.stringify(req)).then(function (response) {
	                if (response.status === 1) {
	                    _this2.setSchoolChart(response.result);
	                }
	            });
	
	            this.setState({ allowedtoacess: allowedtoacess, user_name: this.state.auth_data.user_name, role: this.state.auth_data.role });
	
	            req.url = 'like_follow_chart';
	            (0, _FetchCall.adminDashboard)(JSON.stringify(req)).then(function (response) {
	
	                if (response.status === 1) {
	                    _this2.setLike(response.result);
	                }
	            });
	
	            req.url = 'vistors_chart';
	            (0, _FetchCall.adminDashboard)(JSON.stringify(req)).then(function (response) {
	
	                if (response.status === 1) {
	                    _this2.setVisitors(response.result);
	                }
	            });
	        }
	    }, {
	        key: 'LoadGrpah',
	        value: function LoadGrpah(whichgraph) {
	            var _this3 = this;
	
	            var dataOfUser = this.state.auth_data;
	
	            var req = {
	                vendor_id: dataOfUser.login_id,
	                graph: whichgraph
	            };
	
	            if (whichgraph == 'enq') {
	
	                (0, _FetchCall.generateDataGraph)(JSON.stringify(req)).then(function (response) {
	
	                    if (response.status === 1) {
	                        //only text graph
	                        _this3.setState({
	                            clickedEnqG: true,
	                            subtitle: response.graph_data.title,
	                            value: response.graph_data.value,
	                            label: response.graph_data.label
	                        });
	                    }
	                });
	            }
	
	            if (whichgraph == 'rev') {
	
	                (0, _FetchCall.generateDataGraph)(JSON.stringify(req)).then(function (response) {
	
	                    if (response.status === 1) {
	                        _this3.setState({ clickedRevG: true, datasets: response.result.datasets });
	                    }
	                });
	            }
	
	            if (whichgraph == 'profile') {
	
	                this.setState({ clickedProfCompl: true });
	
	                /*
	                generateDataGraph(JSON.stringify(req)).then(response => {
	                     if (response.status === 1) {
	                      this.setState({clickedProfCompl:true, datasets:response.result.datasets});
	                       
	                    }
	                 });
	                */
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this4 = this;
	
	            var config_donut = {
	                "type": "pie",
	                "theme": "none",
	                "dataProvider": this.state.datasets,
	                "valueField": "value",
	                "titleField": "label",
	                "outlineAlpha": 0.4,
	                "depth3D": 15,
	                "balloonText": "[[title]]<br><span style='font-size:14px'><b>[[value]]</b></span>",
	                "angle": 30,
	                "export": {
	                    "enabled": true
	                }
	            };
	
	            return _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _react2.default.createElement(
	                    _layout2.default,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { 'class': 'row  mt-3' },
	                        _react2.default.createElement(
	                            'div',
	                            { 'class': 'col-xl-6 d-flex grid-margin stretch-card' },
	                            _react2.default.createElement(
	                                'div',
	                                { 'class': 'card' },
	                                !this.state.allowedtoacess && _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'overlay' },
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        'Please subscribe or upgrade'
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: !this.state.allowedtoacess ? "card-body blurred" : 'card-body' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'd-flex flex-wrap justify-content-between' },
	                                        _react2.default.createElement(
	                                            'h4',
	                                            { 'class': 'card-title mb-3' },
	                                            'Visitors'
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'row' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'col-12' },
	                                            _react2.default.createElement('canvas', { id: 'barChartVisitors' })
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { 'class': 'col-xl-6 d-flex grid-margin stretch-card' },
	                            _react2.default.createElement(
	                                'div',
	                                { 'class': 'card' },
	                                !this.state.allowedtoacess && _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'overlay' },
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        'Please subscribe or upgrade'
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: !this.state.allowedtoacess ? "card-body blurred" : 'card-body' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'd-flex flex-wrap justify-content-between' },
	                                        _react2.default.createElement(
	                                            'h4',
	                                            { 'class': 'card-title mb-3' },
	                                            'Likes & Follows'
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'row' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'col-12' },
	                                            _react2.default.createElement('canvas', { id: 'barChartLikeFollows' })
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { 'class': 'col-xl-6 d-flex grid-margin stretch-card' },
	                            _react2.default.createElement(
	                                'div',
	                                { 'class': 'card' },
	                                !this.state.allowedtoacess && _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'overlay' },
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        'Please subscribe or upgrade'
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: !this.state.allowedtoacess ? "card-body blurred" : 'card-body' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'd-flex flex-wrap justify-content-between' },
	                                        _react2.default.createElement(
	                                            'h4',
	                                            { 'class': 'card-title mb-3' },
	                                            'Enquiries'
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'row' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'col-12' },
	                                            this.state.clickedEnqG && _react2.default.createElement(
	                                                'div',
	                                                { 'class': 'graphbox' },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { 'class': 'smalltitle' },
	                                                    this.state.subtitle
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { 'class': 'bigvalue' },
	                                                    this.state.value
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { 'class': 'linktogo' },
	                                                    _react2.default.createElement(
	                                                        'a',
	                                                        { href: this.state.link, target: '_blank' },
	                                                        'Click here to view all'
	                                                    )
	                                                )
	                                            ),
	                                            !this.state.clickedEnqG && _react2.default.createElement(
	                                                'div',
	                                                null,
	                                                _react2.default.createElement(
	                                                    'button',
	                                                    { 'class': 'btn btn-primary btn-sm', onClick: function onClick() {
	                                                            return _this4.LoadGrpah("enq");
	                                                        } },
	                                                    'Click to load'
	                                                )
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { 'class': 'col-xl-6 d-flex grid-margin stretch-card' },
	                            _react2.default.createElement(
	                                'div',
	                                { 'class': 'card' },
	                                !this.state.allowedtoacess && _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'overlay' },
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        'Please subscribe or upgrade'
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: !this.state.allowedtoacess ? "card-body blurred" : 'card-body' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'd-flex flex-wrap justify-content-between' },
	                                        _react2.default.createElement(
	                                            'h4',
	                                            { 'class': 'card-title mb-3' },
	                                            'Ratings'
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'row' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'col-12' },
	                                            this.state.clickedRevG && _react2.default.createElement(
	                                                'div',
	                                                { 'class': 'graphbox' },
	                                                _react2.default.createElement(_amcharts3React2.default.React, { style: { width: "100%", height: "500px" }, options: config_donut })
	                                            ),
	                                            !this.state.clickedRevG && _react2.default.createElement(
	                                                'div',
	                                                null,
	                                                _react2.default.createElement(
	                                                    'button',
	                                                    { 'class': 'btn btn-primary btn-sm', onClick: function onClick() {
	                                                            return _this4.LoadGrpah("rev");
	                                                        } },
	                                                    'Click to load'
	                                                )
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { 'class': 'col-xl-6 d-flex grid-margin stretch-card' },
	                            _react2.default.createElement(
	                                'div',
	                                { 'class': 'card' },
	                                !this.state.allowedtoacess && _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'overlay' },
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        'Please subscribe or upgrade'
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: !this.state.allowedtoacess ? "card-body blurred" : 'card-body' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'd-flex flex-wrap justify-content-between' },
	                                        _react2.default.createElement(
	                                            'h4',
	                                            { 'class': 'card-title mb-3' },
	                                            'Profile Completion'
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'row' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'col-12' },
	                                            this.state.clickedProfCompl && _react2.default.createElement(
	                                                'div',
	                                                null,
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    null,
	                                                    'Account completion'
	                                                ),
	                                                _react2.default.createElement(_ProgressBar2.default, {
	                                                    bgcolor: 'orange',
	                                                    progress: '30',
	                                                    height: 30
	                                                }),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    null,
	                                                    'Profile completion'
	                                                ),
	                                                _react2.default.createElement(_ProgressBar2.default, {
	                                                    bgcolor: 'red',
	                                                    progress: '60',
	                                                    height: 30
	                                                })
	                                            ),
	                                            !this.state.clickedProfCompl && _react2.default.createElement(
	                                                'div',
	                                                null,
	                                                _react2.default.createElement(
	                                                    'button',
	                                                    { 'class': 'btn btn-primary btn-sm', onClick: function onClick() {
	                                                            return _this4.LoadGrpah("profile");
	                                                        } },
	                                                    'Click to load'
	                                                )
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { 'class': 'col-xl-6 d-flex grid-margin stretch-card' },
	                            _react2.default.createElement(
	                                'div',
	                                { 'class': 'card' },
	                                !this.state.allowedtoacess && _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'overlay' },
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        'Please subscribe or upgrade'
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: !this.state.allowedtoacess ? "card-body blurred" : 'card-body' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'd-flex flex-wrap justify-content-between' },
	                                        _react2.default.createElement(
	                                            'h4',
	                                            { 'class': 'card-title mb-3' },
	                                            'Fees (percentage view of your chosen category)  '
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'row' },
	                                        _react2.default.createElement('div', { 'class': 'col-12' })
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return partnerDashboardV1;
	}(_react.Component);
	
	exports.default = partnerDashboardV1;

/***/ },
/* 981 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _videoReact = __webpack_require__(1654);
	
	var _reactShare = __webpack_require__(211);
	
	var _reactstrap = __webpack_require__(17);
	
	var _ModalHeader = __webpack_require__(102);
	
	var _ModalHeader2 = _interopRequireDefault(_ModalHeader);
	
	var _instagramicon = __webpack_require__(946);
	
	var _instagramicon2 = _interopRequireDefault(_instagramicon);
	
	var _constant = __webpack_require__(21);
	
	__webpack_require__(1267);
	
	var _close = __webpack_require__(1295);
	
	var _close2 = _interopRequireDefault(_close);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import '~video-react/dist/video-react.css';
	
	var partnerExclusivePartnerShips = function (_Component) {
	  _inherits(partnerExclusivePartnerShips, _Component);
	
	  function partnerExclusivePartnerShips(props) {
	    var _this$state;
	
	    _classCallCheck(this, partnerExclusivePartnerShips);
	
	    var _this = _possibleConstructorReturn(this, (partnerExclusivePartnerShips.__proto__ || Object.getPrototypeOf(partnerExclusivePartnerShips)).call(this, props));
	
	    _this.openEnqForm = function (e) {
	      _this.setState({ detailedpreview: false, openEnqModal: true });
	    };
	
	    _this.handleChange = function (e) {
	      _this.setState(_defineProperty({}, e.target.name, e.target.value));
	    };
	
	    _this.handleSubmitEnquiry = function (e) {
	
	      e.preventDefault();
	
	      var reviewData = JSON.stringify({
	        to_email: _this.state.emailaddress,
	        name: _this.state.name,
	        first_name: _this.state.first_name,
	        last_name: _this.state.last_name,
	        location: _this.state.current_location,
	        any_message: _this.state.any_message,
	        reg_email: _this.state.reg_email,
	        reg_mobile: _this.state.reg_mobile,
	        source: 'exclusivepartnership'
	      });
	
	      (0, _FetchCall.saveExclEnqLead)(reviewData).then(function (response) {
	        if (response.status == 1) {
	
	          _this.setState({ openEnqModal: false });
	
	          alert("Thank you!, Enquiry is successfully registered");
	        }
	      });
	    };
	
	    _this.handleCloseCp = function (e) {
	      _this.setState({ openEnqModal: false });
	    };
	
	    _this.openExclusivePartnerModal = function (e) {
	
	      var exlpartnerid = (0, _jquery2.default)(e.target).attr('data-id');
	
	      _this.setState({ detailedpreview: true });
	
	      var req = JSON.stringify({
	        id: exlpartnerid
	      });
	      (0, _FetchCall.getExclPartnerShipDetailById)(req).then(function (res) {
	        if (res.status === 1) {
	          var data = res.detail[0];
	          _this.setState({
	            id: data.id,
	            login_id: data.login_id,
	            logo: data.logo,
	            name: data.name,
	            address: data.address,
	            emailaddress: data.emailaddress,
	            contact_number: data.contact_number,
	            title: data.name,
	            description: data.description,
	            banners: data.banners != null ? data.banners : '',
	            videos: data.videos,
	            videourl: data.videourl,
	            gallery: data.gallery != null ? data.gallery : '',
	            banner_link: data.banner_link,
	            website: data.website,
	            facebook: data.facebook,
	            twitter: data.twitter,
	            instagram: data.instagram,
	            linkedin: data.linkedin,
	            clicktext: data.clicktext,
	            link: data.link,
	            contenttype: data.contenttype,
	            offerimage1: data.offerimage1,
	            offerimage2: data.offerimage2,
	            offerimage3: data.offerimage3,
	            offer1desc: data.offer1desc,
	            offer3desc: data.offer3desc,
	            offer2desc: data.offer2desc,
	            brochures: data.brochures == null ? '' : data.brochures,
	            file1: data.file1,
	            file2: data.file2,
	            thumb1: data.thumb1,
	            thumb2: data.thumb2,
	            promotion_link: data.promotion_link,
	            promotion_image: data.promotion_image,
	            description_b2b: data.description_b2b,
	            banners_b2b: data.banners_b2b,
	            offerimage_b2b: data.offerimage_b2b,
	            offerdesc_b2b: data.offerdesc_b2b,
	            brochures_b2b: data.brochures_b2b,
	            contact_number_b2b: data.contact_number_b2b,
	            emailaddress_b2b: data.emailaddress_b2b,
	            brochures_b2b_thumb: data.brochures_b2b_thumb,
	            view_count: data.view_count
	          });
	          if (data.id == 20) {
	            _this.setState({ customexoffersmym: true });
	          }
	          if (data.id == 23) {
	            _this.setState({ customexofferslmt: true });
	          }
	          var sliders = data.banners.split(",");
	          var arr2 = [];
	          var imagesArray = {};
	          for (var i = 0; i < sliders.length; i++) {
	            imagesArray['url'] = _constant.AZ_ASSET_PATH + sliders[i];
	            arr2.push(imagesArray);
	          }
	
	          _this.setState({ images: arr2 });
	        }
	      });
	    };
	
	    _this.getExclPrtshipsList = function (page_number) {
	      var req = JSON.stringify({
	        page_number: page_number ? page_number : _this.state.page_number,
	        perpage: _this.state.per_page
	      });
	      (0, _FetchCall.exclprtshipsListPartners)(req).then(function (res) {
	        if (res.status === 1) {
	          var data = res.data;
	          var total_pages = res.total_pages;
	          _this.setState({
	            exclprtshipsList: data,
	            totalPages: total_pages,
	            currentpage: res.currentpage,
	            page_number: res.currentpage,
	            isloading: false
	          });
	          //window.scrollTo(0, 0);
	        }
	      });
	    };
	
	    _this.state = (_this$state = {
	      logged: localStorage.getItem("authentication"),
	      auth_data: JSON.parse(localStorage.getItem("user_data")),
	      exclprtshipsList: [],
	      per_page: 15,
	      page_number: 1,
	      currentpage: 1,
	      detailedpreview: false,
	      offer3desc: '',
	      totalPages: 0,
	      contentList: [],
	      social_links: [],
	      images: [],
	      gallery: '',
	      title: '',
	      content: '',
	      descp: '',
	      base_url: '',
	      banners: '',
	      brochures: ''
	    }, _defineProperty(_this$state, 'gallery', ''), _defineProperty(_this$state, 'author_id', 0), _defineProperty(_this$state, 'view_count', 0), _defineProperty(_this$state, 'city', 'bengaluru'), _this$state);
	
	    _this.getExclPrtshipsList();
	    _this.openExclusivePartnerModal = _this.openExclusivePartnerModal.bind(_this);
	    _this.closePop = _this.closePop.bind(_this);
	    _this.openEnqForm = _this.openEnqForm.bind(_this);
	    _this.handleCloseCp = _this.handleCloseCp.bind(_this);
	    _this.handleSubmitEnquiry = _this.handleSubmitEnquiry.bind(_this);
	    return _this;
	  }
	
	  _createClass(partnerExclusivePartnerShips, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'closePop',
	    value: function closePop() {
	      this.setState({ detailedpreview: false });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var newcommentsParm = {
	        user_id: this.state.user_id,
	        login_id: this.state.login_id,
	        id: this.state.id
	      };
	
	      var gallerysettings = {
	        dots: false,
	        infinite: false,
	        speed: 500,
	        slidesToShow: 3,
	        slidesToScroll: 3,
	        responsive: [{
	          breakpoint: 768,
	          settings: {
	            slidesToShow: 1,
	            centerMode: false, /* set centerMode to false to show complete slide instead of 3 */
	            slidesToScroll: 1
	          }
	        }]
	      };
	
	      var sliders = this.state.banners.split(",");
	      var galleries = this.state.gallery.split(",");
	      //const IMG_URL = 'http://localhost:5005/';
	
	      var offer1 = this.state.offerimage1 != null ? _constant.AZ_ASSET_PATH + 'uploads/' + this.state.offerimage1 : null;
	      var offer2 = this.state.offerimage2 != null ? _constant.AZ_ASSET_PATH + 'uploads/' + this.state.offerimage2 : null;
	      var offer3 = this.state.offerimage3 != null ? _constant.AZ_ASSET_PATH + 'uploads/' + this.state.offerimage3 : null;
	      /*
	      const offer1 = 'https://api.bewise.in/uploads/partner-sujkds.jpg';
	      const offer2 = 'https://api.bewise.in/uploads/partner-sujkds.jpg';
	      const offer3 = 'https://api.bewise.in/uploads/partner-sujkds.jpg';
	      */
	      var offer1desc = this.state.offer1desc;
	      var offer2desc = this.state.offer2desc;
	      var offer3desc = this.state.offer3desc;
	      var offerimage_b2b = this.state.offerimage_b2b;
	      //const offerdesc_b2b = this.state.offerdesc_b2b;
	
	      var brochures = this.state.brochures.split(",");
	
	      var images = JSON.parse(JSON.stringify(this.state.images));
	
	      var banner_link = this.state.banner_link != null ? this.state.banner_link : '#';
	
	      var modalPlacement = 'top';
	
	      var genafflink = '';
	      if (this.state.partner_type == 2) //individual  
	        genafflink = 'https://bewise.lovemytest.com/profile_registration.php?req=newaccount&profile=bmV3X3NjaG9vbA==&pc=BWS12345&pn=' + this.state.name + '&em=' + this.state.emailaddress + '&uuid=' + this.state.login_id;else {
	        genafflink = 'https://bewise.lovemytest.com/profile_registration.php?req=newaccount&profile=bmV3X3NjaG9vbA==&pc=BWS12345&pn=' + this.state.name + '&em=' + this.state.emailaddress + '&uuid=' + this.state.login_id;
	      }
	      var offer3descreplaced = offer3desc != null ? offer3desc.replace('CUSTOMLINK', genafflink) : offer3desc;
	
	      var offerdesc_b2b = this.state.offerdesc_b2b != null ? this.state.offerdesc_b2b.replace('CUSTOMLINK', genafflink) : this.state.offerdesc_b2b;
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'col-12 grid-margin' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card-body' },
	                _react2.default.createElement(
	                  'h4',
	                  { 'class': 'card-title' },
	                  'Exclusive Partnerships'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row col-md-12' },
	                  this.state.exclprtshipsList.map(function (item, i) {
	
	                    return _react2.default.createElement(
	                      'div',
	                      { className: 'col-md-4 mb-5' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'exclprtrs-container' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'topLogo' },
	                          _react2.default.createElement('img', { src: _constant.AZ_ASSET_PATH + item.logo, alt: item.name + ' - Logo', width: '100px' })
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'middleContExcl' },
	                          _react2.default.createElement(
	                            'h5',
	                            null,
	                            item.name.length > 70 ? item.name.substring(0, 70) + '...' : item.name
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                              'button',
	                              { 'class': 'btn btn-primary', onClick: _this2.openExclusivePartnerModal, 'data-id': item.id },
	                              'view more'
	                            )
	                          )
	                        )
	                      )
	                    );
	                  })
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.Modal,
	            { size: 'lg', isOpen: this.state.detailedpreview, className: 'modalpopup' },
	            _react2.default.createElement(
	              _ModalHeader2.default,
	              null,
	              'Exclusive Partnerships - Detail'
	            ),
	            _react2.default.createElement(
	              _reactstrap.ModalBody,
	              { className: 'p-0 detailedpreview' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'onDemandInfo' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-lg-12 col-sm-12 col-md-12 col-xs-12' },
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'width100full' },
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'bannerbox' },
	                        this.state.banners_b2b != null && _react2.default.createElement('img', { src: _constant.AZ_ASSET_PATH + this.state.banners_b2b, 'class': 'bannerimage' }),
	                        this.state.banners_b2b == null && _react2.default.createElement('img', { src: _constant.AZ_ASSET_PATH + this.state.banners, 'class': 'bannerimage' })
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { id: 'description_section' },
	                  _react2.default.createElement(
	                    'h3',
	                    null,
	                    'About Us'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'aboutinfo_fleft' },
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'per20 logobox' },
	                      _react2.default.createElement('img', { src: _constant.AZ_ASSET_PATH + this.state.logo, className: 'orgphoto' })
	                    ),
	                    _react2.default.createElement('div', { 'class': 'aboutinfo', dangerouslySetInnerHTML: { __html: this.state.description_b2b } })
	                  )
	                ),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                  'div',
	                  { id: 'exclusive_offers_section' },
	                  _react2.default.createElement(
	                    'h3',
	                    null,
	                    'Exclusive Offers'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'external_affilates_section' },
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'offer_row borderwithcolor1' },
	                      offerimage_b2b != null && _react2.default.createElement(
	                        'div',
	                        { 'class': 'offer_right_img' },
	                        _react2.default.createElement('img', { src: _constant.AZ_ASSET_PATH + offerimage_b2b })
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'offer_left_text' },
	                        _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: offerdesc_b2b } })
	                      )
	                    ),
	                    _react2.default.createElement('br', null)
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { id: 'brochure_section' },
	                  _react2.default.createElement(
	                    'h3',
	                    null,
	                    'Brochures/Samples'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    null,
	                    this.state.brochures_b2b != '' && this.state.brochures_b2b != null && _react2.default.createElement(
	                      'a',
	                      { href: _constant.AZ_ASSET_PATH + this.state.brochures_b2b, target: '_blank' },
	                      _react2.default.createElement('img', { src: _constant.AZ_ASSET_PATH + this.state.brochures_b2b_thumb, className: 'fileicon' })
	                    )
	                  )
	                ),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                  'div',
	                  { id: 'video_section' },
	                  _react2.default.createElement(
	                    'h3',
	                    null,
	                    'Videos'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row n5v3k' },
	                    this.state.videos !== null && this.state.videos != '' ? _react2.default.createElement(
	                      'div',
	                      { className: 'container' },
	                      _react2.default.createElement(_videoReact.Player, {
	                        playsInline: true,
	                        src: _constant.AZ_ASSET_PATH + this.state.videos + "#t=0.1"
	                      })
	                    ) : _react2.default.createElement(
	                      'div',
	                      { className: 'container' },
	                      'Video not available'
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { id: 'contactinfo_section' },
	                  _react2.default.createElement(
	                    'h3',
	                    null,
	                    'Contact Info'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-lg-8 col-sm-12 col-md-12 col-xs-12 text-left' },
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'per100 text-left' },
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'bs_social' },
	                        _react2.default.createElement(
	                          'div',
	                          null,
	                          ' Email Address: ',
	                          _react2.default.createElement(
	                            'b',
	                            null,
	                            this.state.emailaddress
	                          ),
	                          ' '
	                        ),
	                        _react2.default.createElement('br', null),
	                        this.state.website != '' && _react2.default.createElement(
	                          'div',
	                          null,
	                          ' Website: ',
	                          _react2.default.createElement(
	                            'b',
	                            null,
	                            _react2.default.createElement(
	                              'a',
	                              { href: this.state.website, target: '_blank' },
	                              this.state.website
	                            )
	                          ),
	                          ' '
	                        ),
	                        ' ',
	                        _react2.default.createElement('br', null),
	                        this.state.customexoffersmym && _react2.default.createElement(
	                          'div',
	                          null,
	                          ' Contact Number: ',
	                          _react2.default.createElement(
	                            'b',
	                            null,
	                            '7338178936'
	                          ),
	                          ' '
	                        ),
	                        !this.state.customexoffersmym && _react2.default.createElement(
	                          'div',
	                          null,
	                          ' Contact Number: ',
	                          _react2.default.createElement(
	                            'b',
	                            null,
	                            this.state.contact_number == '' ? 'N/A' : this.state.contact_number
	                          ),
	                          ' '
	                        ),
	                        _react2.default.createElement('br', null),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'social-icons-container' },
	                          _react2.default.createElement(
	                            'a',
	                            { href: this.state.facebook, target: '_blank' },
	                            _react2.default.createElement(_reactShare.FacebookIcon, { size: 32, round: true })
	                          ),
	                          '\xA0',
	                          _react2.default.createElement(
	                            'a',
	                            { href: this.state.instagram, target: '_blank' },
	                            _react2.default.createElement(_instagramicon2.default, { size: 32, round: true })
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      null,
	                      _react2.default.createElement(
	                        'b',
	                        null,
	                        'For an enquiry'
	                      ),
	                      ' \xA0',
	                      _react2.default.createElement(
	                        'button',
	                        { 'class': 'btn btn-primary btn-sm', onClick: this.openEnqForm },
	                        'Click here'
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactstrap.ModalFooter,
	              null,
	              _react2.default.createElement(
	                'button',
	                { onClick: this.closePop, 'class': 'btn btn-primary' },
	                'Close'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.Modal,
	            { isOpen: this.state.openEnqModal, centered: true, size: 'lg', position: modalPlacement, className: 'modalpopup enquiryform' },
	            _react2.default.createElement(
	              _reactstrap.ModalBody,
	              null,
	              _react2.default.createElement(
	                'h4',
	                { 'class': 'csph4' },
	                'Contact ',
	                this.state.name
	              ),
	              _react2.default.createElement(
	                'button',
	                {
	                  className: 'close-btn',
	                  'data-dismiss': 'modal',
	                  'aria-label': 'Close',
	                  onClick: this.handleCloseCp
	                },
	                _react2.default.createElement('img', { src: _close2.default, alt: 'close' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { 'class': 'formbox csp' },
	                _react2.default.createElement(
	                  'form',
	                  {
	                    method: 'post',
	                    onSubmit: this.handleSubmitEnquiry,
	                    autoComplete: 'off',
	                    id: 'loginForm'
	                  },
	                  _react2.default.createElement(
	                    'div',
	                    {
	                      className: 'formgroup has-feedback',
	                      style: { width: '55%', float: 'left' }
	                    },
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'n7tr' },
	                      'First Name'
	                    ),
	                    _react2.default.createElement('input', {
	                      type: 'text',
	                      name: 'first_name',
	                      className: 'form-control', onChange: this.handleChange, required: true
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    {
	                      className: 'formgroup has-feedback',
	                      style: { width: '40%', float: 'right' }
	                    },
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'n7tr' },
	                      'Last Name'
	                    ),
	                    _react2.default.createElement('input', {
	                      type: 'text',
	                      name: 'last_name',
	                      className: 'form-control', onChange: this.handleChange, required: true
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'formgroup has-feedback' },
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'n7tr' },
	                      'Mobile Number'
	                    ),
	                    _react2.default.createElement('input', {
	                      type: 'tel',
	                      name: 'reg_mobile', maxlength: '10', minlength: '10',
	                      className: 'form-control', onChange: this.handleChange, required: true
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'formgroup has-feedback' },
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'n7tr' },
	                      'Email ID'
	                    ),
	                    _react2.default.createElement('input', {
	                      type: 'email',
	                      name: 'reg_email',
	                      className: 'form-control', onChange: this.handleChange, value: this.state.email_id, required: true
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'formgroup has-feedback' },
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'n7tr' },
	                      'Any Message'
	                    ),
	                    _react2.default.createElement('textarea', {
	
	                      name: 'any_message',
	                      value: this.state.any_message, onChange: this.handleChange,
	
	                      className: 'form-control', required: true
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'formgroup has-feedback' },
	                    _react2.default.createElement('input', {
	                      type: 'submit',
	                      name: 'submit',
	                      value: 'Submit',
	                      className: 'submit btn btn-primary btn-block btn-css'
	                    })
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return partnerExclusivePartnerShips;
	}(_react.Component);
	
	exports.default = partnerExclusivePartnerShips;

/***/ },
/* 982 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FetchCall = __webpack_require__(4);
	
	var _PdfContainer = __webpack_require__(887);
	
	var _PdfContainer2 = _interopRequireDefault(_PdfContainer);
	
	var _DocService = __webpack_require__(359);
	
	var _DocService2 = _interopRequireDefault(_DocService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import FetchCall from '../../API/FetchCall';
	
	
	//npm i @progress/kendo-react-pdf@3.5.1-dev.201910161723
	
	//npm i @progress/kendo-drawing
	
	var InvoiceView = function (_Component) {
	  _inherits(InvoiceView, _Component);
	
	  function InvoiceView(props) {
	    _classCallCheck(this, InvoiceView);
	
	    var _this = _possibleConstructorReturn(this, (InvoiceView.__proto__ || Object.getPrototypeOf(InvoiceView)).call(this, props));
	
	    _this.onChange = function (event) {
	      var name = event.target.name;
	      var value = event.target.value;
	      _this.setState(function (state) {
	        state[name] = value;
	        return state;
	      });
	    };
	
	    _this.createPdf = function (html) {
	      return _DocService2.default.createPdf(html);
	    };
	
	    _this.state = {
	      vendor_id: _this.props.match.params.id,
	      orders: [],
	      ordersitems: [],
	      cgst_amount: 0.00,
	      sgst_amount: 0.00
	
	    };
	
	    return _this;
	  }
	
	  _createClass(InvoiceView, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var userinfo = JSON.stringify({
	        vendor_id: this.state.vendor_id
	      });
	      (0, _FetchCall.getInvoiceInfo)(userinfo).then(function (response) {
	        if (response.status == 1) {
	          console.log('response', response);
	          var data = response.results[0];
	          _this2.setState({
	            first_name: data.first_name,
	            organisation_name: data.organisation_name,
	            last_name: data.last_name,
	            email_id: data.email_id,
	            phone_number: data.phone_number,
	            invoice_type: data.invoice_type,
	            location: data.location,
	            state: data.state,
	            address: data.address,
	            pin_code: data.pin_code,
	            plan_name: data.plan_name,
	            created_date: data.created_date,
	            amount: data.amount,
	            discount_amount: data.discount_amount,
	            discount: data.discount,
	            plan_price_original: data.plan_price_original,
	            invoice_no: data.invoice_no,
	            coupon_per: data.coupon_per,
	            coupon_amount: data.coupon_amount,
	            sgst_per: data.sgst_per,
	            cgst_per: data.cgst_per,
	            chart_discount_amount: data.chart_discount_amount,
	            payment_id: data.payment_id,
	            other_description: data.other_description,
	            ordersitems: data.ordersitems,
	            status: data.status
	          });
	        } else {
	          console.log(response.status);
	        }
	      });
	    }
	  }, {
	    key: 'UNSAFE_componentWillMount',
	    value: function UNSAFE_componentWillMount() {}
	  }, {
	    key: 'render',
	    value: function render() {
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'box-shadow-custom' },
	          _react2.default.createElement(
	            _PdfContainer2.default,
	            { createPdf: this.createPdf },
	            _react2.default.createElement(
	              'div',
	              { className: 'row invoice-container' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-12', style: { marginBottom: '32px', marginTop: '25px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-12 text-center' },
	                  _react2.default.createElement(
	                    'h3',
	                    null,
	                    'Tax Invoice'
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-12 text-center' },
	                  _react2.default.createElement('img', { src: '/assets/images/wisdom-logo.png', style: { width: '82px' }, alt: 'logo' })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-8 col-sm-12' },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  " ",
	                  'Wisdom Tech Solutions Private Limited',
	                  _react2.default.createElement('br', null),
	                  'C-6, Gaurav Enclave, 33/1, KHB Main Road, Sultanpalya',
	                  _react2.default.createElement('br', null),
	                  'Bangalore, Karnataka - 560032',
	                  _react2.default.createElement('br', null),
	                  'Contact No - ',
	                  _react2.default.createElement('br', null),
	                  'TAN - BLRW03167D',
	                  _react2.default.createElement('br', null),
	                  'PAN - AACCW6395B'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-4 col-sm-12' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row left-content-invoice' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-sm-6 text-right' },
	                    _react2.default.createElement(
	                      'h6',
	                      null,
	                      'DATE : '
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-sm-6' },
	                    _react2.default.createElement(
	                      'h6',
	                      null,
	                      ' ',
	                      this.state.created_date
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-sm-6  text-right' },
	                    _react2.default.createElement(
	                      'h6',
	                      null,
	                      'INVOICE No : '
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-sm-6' },
	                    _react2.default.createElement(
	                      'h6',
	                      null,
	                      this.state.invoice_no
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-sm-6  text-right' },
	                    _react2.default.createElement(
	                      'h6',
	                      null,
	                      'Place of Supply : '
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-sm-6' },
	                    _react2.default.createElement(
	                      'h6',
	                      null,
	                      this.state.location
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-sm-6  text-right' },
	                    _react2.default.createElement(
	                      'h6',
	                      null,
	                      'State of Supply : '
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-sm-6' },
	                    _react2.default.createElement(
	                      'h6',
	                      null,
	                      this.state.state
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-sm-6  text-right' },
	                    _react2.default.createElement(
	                      'h6',
	                      null,
	                      'Payment Type : '
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-sm-6' },
	                    _react2.default.createElement(
	                      'h6',
	                      null,
	                      ' Razorpay'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-sm-6  text-right' },
	                    _react2.default.createElement(
	                      'h6',
	                      null,
	                      'Reference Number : '
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-sm-6' },
	                    _react2.default.createElement(
	                      'h6',
	                      null,
	                      this.state.payment_id
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-12' },
	                _react2.default.createElement(
	                  'h5',
	                  null,
	                  'BILL TO'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-8 col-sm-12' },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  this.state.first_name,
	                  '  ',
	                  this.state.last_name,
	                  _react2.default.createElement('br', null),
	                  this.state.address,
	                  ' ',
	                  _react2.default.createElement('br', null),
	                  'Contact No - ',
	                  this.state.phone_number,
	                  _react2.default.createElement('br', null),
	                  'GST Number'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-4 col-sm-12' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row left-content-invoice' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-sm-6 text-right' },
	                    _react2.default.createElement(
	                      'h6',
	                      null,
	                      'Terms : '
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-sm-6' },
	                    _react2.default.createElement(
	                      'h6',
	                      null,
	                      ' ',
	                      this.state.invoice_type
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-12' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'back-drop' },
	                  _react2.default.createElement('img', { src: '/assets/dashboard/logo.svg', alt: 'logo' })
	                ),
	                _react2.default.createElement(
	                  'table',
	                  null,
	                  _react2.default.createElement(
	                    'thead',
	                    null,
	                    _react2.default.createElement(
	                      'tr',
	                      null,
	                      _react2.default.createElement(
	                        'th',
	                        null,
	                        'DESCRIPTION'
	                      ),
	                      _react2.default.createElement(
	                        'th',
	                        null,
	                        'QTY '
	                      ),
	                      _react2.default.createElement(
	                        'th',
	                        null,
	                        'AMOUNT'
	                      ),
	                      _react2.default.createElement(
	                        'th',
	                        null,
	                        'CGST'
	                      ),
	                      _react2.default.createElement(
	                        'th',
	                        null,
	                        'SGST'
	                      ),
	                      _react2.default.createElement(
	                        'th',
	                        null,
	                        'Net Amount'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tbody',
	                    null,
	                    this.state.ordersitems.map(function (item, i) {
	                      return _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                          'td',
	                          null,
	                          item.plan_name
	                        ),
	                        _react2.default.createElement(
	                          'td',
	                          null,
	                          '1 '
	                        ),
	                        _react2.default.createElement(
	                          'td',
	                          null,
	                          '\u20B9 ',
	                          item.total
	                        ),
	                        _react2.default.createElement(
	                          'td',
	                          null,
	                          '-'
	                        ),
	                        _react2.default.createElement(
	                          'td',
	                          null,
	                          '-'
	                        ),
	                        _react2.default.createElement(
	                          'td',
	                          { className: 'text-right' },
	                          '\u20B9 ',
	                          parseFloat(item.total).toFixed(2),
	                          ' '
	                        )
	                      );
	                    }),
	                    _react2.default.createElement(
	                      'tr',
	                      null,
	                      _react2.default.createElement('td', { colSpan: '3', rowspan: '7', style: { verticalAlign: "baseline" } }),
	                      _react2.default.createElement(
	                        'td',
	                        { rowspan: '6' },
	                        'Total'
	                      ),
	                      _react2.default.createElement(
	                        'td',
	                        null,
	                        'Sub total '
	                      ),
	                      _react2.default.createElement(
	                        'td',
	                        { className: 'text-right' },
	                        '\u20B9 ',
	                        parseFloat(this.state.amount).toFixed(2),
	                        '  '
	                      )
	                    ),
	                    this.state.discount_amount > 0 && _react2.default.createElement(
	                      'tr',
	                      null,
	                      _react2.default.createElement(
	                        'td',
	                        null,
	                        'Early Bird Offer '
	                      ),
	                      _react2.default.createElement(
	                        'td',
	                        { className: 'text-right' },
	                        '\u20B9 ',
	                        parseFloat(this.state.discount_amount).toFixed(2),
	                        '  '
	                      )
	                    ),
	                    this.state.chart_discount_amount > 0 && _react2.default.createElement(
	                      'tr',
	                      null,
	                      _react2.default.createElement(
	                        'td',
	                        null,
	                        'Offer '
	                      ),
	                      _react2.default.createElement(
	                        'td',
	                        { className: 'text-right' },
	                        '\u20B9 ',
	                        parseFloat(this.state.chart_discount_amount).toFixed(2),
	                        '  '
	                      )
	                    ),
	                    this.state.coupon_per > 0 && _react2.default.createElement(
	                      'tr',
	                      null,
	                      _react2.default.createElement(
	                        'td',
	                        null,
	                        'Coupon Discount (',
	                        this.state.coupon_per,
	                        '%)'
	                      ),
	                      _react2.default.createElement(
	                        'td',
	                        { className: 'text-right' },
	                        '\u20B9 ',
	                        parseFloat(this.state.coupon_amount).toFixed(2),
	                        '  '
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'tr',
	                      null,
	                      _react2.default.createElement(
	                        'td',
	                        null,
	                        'CGST (',
	                        this.state.cgst_per,
	                        '%) '
	                      ),
	                      _react2.default.createElement(
	                        'td',
	                        { className: 'text-right' },
	                        ' ',
	                        parseFloat(this.state.cgst_amount).toFixed(2),
	                        ' '
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'tr',
	                      null,
	                      _react2.default.createElement(
	                        'td',
	                        null,
	                        'SGST (',
	                        this.state.sgst_per,
	                        '%) '
	                      ),
	                      _react2.default.createElement(
	                        'td',
	                        { className: 'text-right' },
	                        ' ',
	                        parseFloat(this.state.sgst_amount).toFixed(2),
	                        ' '
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'tr',
	                      null,
	                      _react2.default.createElement(
	                        'td',
	                        null,
	                        'Total Amount  '
	                      ),
	                      _react2.default.createElement(
	                        'td',
	                        { className: 'text-right' },
	                        '\u20B9 ',
	                        parseFloat(this.state.amount).toFixed(2),
	                        '  '
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'tr',
	                      null,
	                      _react2.default.createElement(
	                        'td',
	                        null,
	                        'Payment Received  '
	                      ),
	                      this.state.payment_id != '' && _react2.default.createElement(
	                        'td',
	                        { className: 'text-right' },
	                        '\u20B9 ',
	                        parseFloat(this.state.amount).toFixed(2)
	                      ),
	                      this.state.payment_id == '' && _react2.default.createElement(
	                        'td',
	                        { className: 'text-right' },
	                        '\u20B9 ',
	                        parseFloat(0).toFixed(2)
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'text-left' },
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    '*This is a computer generated E-mail and does not require a physical copy '
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'text-right' },
	                  _react2.default.createElement(
	                    'h4',
	                    null,
	                    ' ',
	                    _react2.default.createElement(
	                      'b',
	                      null,
	                      this.state.status
	                    ),
	                    ' '
	                  ),
	                  _react2.default.createElement(
	                    'h4',
	                    null,
	                    ' Wisdom Tech Solutions Private Limited   '
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    'Authorised Signatory '
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'text-center' },
	                  _react2.default.createElement(
	                    'h4',
	                    { style: { marginTop: "30px", fontWeight: "bold" } },
	                    'Thank you for the payment! You just made our day        '
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return InvoiceView;
	}(_react.Component);
	
	exports.default = InvoiceView;

/***/ },
/* 983 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _reactstrap = __webpack_require__(17);
	
	var _Tabs = __webpack_require__(65);
	
	var _Tabs2 = _interopRequireDefault(_Tabs);
	
	var _TabsPane = __webpack_require__(64);
	
	var _TabsPane2 = _interopRequireDefault(_TabsPane);
	
	var _reactDataTableComponent = __webpack_require__(53);
	
	var _reactDataTableComponent2 = _interopRequireDefault(_reactDataTableComponent);
	
	var _Common = __webpack_require__(145);
	
	var _tabbedjobposting = __webpack_require__(1002);
	
	var _tabbedjobposting2 = _interopRequireDefault(_tabbedjobposting);
	
	var _tabbedtalentsearch = __webpack_require__(1003);
	
	var _tabbedtalentsearch2 = _interopRequireDefault(_tabbedtalentsearch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import { Editor } from '@tinymce/tinymce-react';
	
	var childTabs = [{
	  name: "Job postings",
	  id: "JobPosting",
	  defaultChecked: true
	}, {
	  name: "Talent Search",
	  id: "TalentSearch"
	}];
	
	var partnerJopPosting = function (_Component) {
	  _inherits(partnerJopPosting, _Component);
	
	  function partnerJopPosting(props) {
	    _classCallCheck(this, partnerJopPosting);
	
	    var _this = _possibleConstructorReturn(this, (partnerJopPosting.__proto__ || Object.getPrototypeOf(partnerJopPosting)).call(this, props));
	
	    _this.handleChange = function (e) {
	      _this.setState(_defineProperty({}, e.target.name, e.target.value));
	    };
	
	    _this.state = {
	      logged: localStorage.getItem("authentication"),
	      auth_data: JSON.parse(localStorage.getItem("user_data"))
	    };
	
	    return _this;
	  }
	
	  _createClass(partnerJopPosting, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'render',
	    value: function render() {
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'col-12 grid-margin' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card-body' },
	                _react2.default.createElement(
	                  'h4',
	                  { 'class': 'card-title' },
	                  'Job Postings'
	                ),
	                _react2.default.createElement(
	                  _Tabs2.default,
	                  { tabsetName: 'otherinfo', childTabs: childTabs },
	                  _react2.default.createElement(
	                    _TabsPane2.default,
	                    { id: 'JobPosting' },
	                    _react2.default.createElement(_tabbedjobposting2.default, null)
	                  ),
	                  _react2.default.createElement(
	                    _TabsPane2.default,
	                    { id: 'TalentSearch' },
	                    _react2.default.createElement(_tabbedtalentsearch2.default, null)
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return partnerJopPosting;
	}(_react.Component);
	
	exports.default = partnerJopPosting;

/***/ },
/* 984 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _reactstrap = __webpack_require__(17);
	
	var _Tabs = __webpack_require__(65);
	
	var _Tabs2 = _interopRequireDefault(_Tabs);
	
	var _TabsPane = __webpack_require__(64);
	
	var _TabsPane2 = _interopRequireDefault(_TabsPane);
	
	var _reactDataTableComponent = __webpack_require__(53);
	
	var _reactDataTableComponent2 = _interopRequireDefault(_reactDataTableComponent);
	
	var _Common = __webpack_require__(145);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import { Editor } from '@tinymce/tinymce-react';
	
	var partnerNews = function (_Component) {
	  _inherits(partnerNews, _Component);
	
	  function partnerNews(props) {
	    _classCallCheck(this, partnerNews);
	
	    var _this = _possibleConstructorReturn(this, (partnerNews.__proto__ || Object.getPrototypeOf(partnerNews)).call(this, props));
	
	    _this.getLatestNews = function () {
	
	      (0, _FetchCall.getLatestNews)().then(function (response) {
	
	        _this.setState({ news: response.data });
	      });
	    };
	
	    _this.handleChange = function (e) {
	      _this.setState(_defineProperty({}, e.target.name, e.target.value));
	    };
	
	    _this.state = {
	      logged: localStorage.getItem("authentication"),
	      auth_data: JSON.parse(localStorage.getItem("user_data")),
	      news: []
	    };
	
	    _this.getLatestNews();
	
	    return _this;
	  }
	
	  _createClass(partnerNews, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'render',
	    value: function render() {
	      var news = this.state.news;
	
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'col-12 grid-margin' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card-body' },
	                _react2.default.createElement(
	                  'h4',
	                  { 'class': 'card-title' },
	                  'News'
	                ),
	                _react2.default.createElement(
	                  'table',
	                  { 'class': 'table table-hover table-forum text-center' },
	                  _react2.default.createElement(
	                    'thead',
	                    null,
	                    _react2.default.createElement(
	                      'tr',
	                      null,
	                      _react2.default.createElement(
	                        'th',
	                        { 'class': 'text-left' },
	                        'Topic'
	                      ),
	                      _react2.default.createElement(
	                        'th',
	                        null,
	                        'Comments'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tbody',
	                    null,
	                    news.length > 0 && news.map(function (news, i) {
	
	                      return _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                          'td',
	                          { 'class': 'text-left' },
	                          _react2.default.createElement(
	                            'a',
	                            { href: '#', 'class': 'font-weight-bold blue-text' },
	                            news.news_title
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'my-2' },
	                            'Author:',
	                            _react2.default.createElement(
	                              'a',
	                              { href: '#', 'class': 'blue-text' },
	                              _react2.default.createElement(
	                                'strong',
	                                null,
	                                'BeWise'
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'span',
	                              null,
	                              ' at 12/12/2021'
	                            ),
	                            _react2.default.createElement('div', null)
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'td',
	                          null,
	                          _react2.default.createElement(
	                            'a',
	                            { href: '#', 'class': 'text-dark' },
	                            _react2.default.createElement(
	                              'span',
	                              null,
	                              '10'
	                            ),
	                            _react2.default.createElement('i', { 'class': 'fas fa-comments ml-1' })
	                          )
	                        )
	                      );
	                    })
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return partnerNews;
	}(_react.Component);
	
	exports.default = partnerNews;

/***/ },
/* 985 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FetchCall = __webpack_require__(4);
	
	var _FetchCall2 = _interopRequireDefault(_FetchCall);
	
	var _simpleReactValidator = __webpack_require__(28);
	
	var _simpleReactValidator2 = _interopRequireDefault(_simpleReactValidator);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactstrap = __webpack_require__(17);
	
	__webpack_require__(18);
	
	var _reactNotifications = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Gallery = function (_Component) {
	  _inherits(Gallery, _Component);
	
	  function Gallery(props) {
	    _classCallCheck(this, Gallery);
	
	    var _this = _possibleConstructorReturn(this, (Gallery.__proto__ || Object.getPrototypeOf(Gallery)).call(this, props));
	
	    _this.getGallery = function () {
	      var _this$state$user_data = _this.state.user_data,
	          user_type = _this$state$user_data.user_type,
	          login_id = _this$state$user_data.login_id,
	          set_id = _this$state$user_data.set_id;
	
	      var req = JSON.stringify({
	        user_type: user_type,
	        login_id: login_id,
	        sid: set_id,
	        url: 'getGalleryNew'
	      });
	      (0, _FetchCall.partnerApi)(req).then(function (response) {
	
	        if (response.status === 1) {
	          var data = response.result;
	          var imagecnt = data.max_gallery;
	          if (data.plan_id == 0) {
	            imagecnt = user_type == 1 ? 8 : 7;
	          }
	          _this.setState({
	            page_data: data.master_data,
	            active_status: response.result.active_status,
	            image_count: imagecnt
	          });
	        }
	      });
	    };
	
	    _this.getgallery = function () {
	      var _this$state$user_data2 = _this.state.user_data,
	          user_type = _this$state$user_data2.user_type,
	          login_id = _this$state$user_data2.login_id,
	          is_completd = _this$state$user_data2.is_completd,
	          current_plan = _this$state$user_data2.current_plan,
	          current_category = _this$state$user_data2.current_category,
	          uid = _this$state$user_data2.uid,
	          branch_id = _this$state$user_data2.branch_id;
	
	      var req = JSON.stringify({
	        user_type: user_type,
	        login_id: login_id,
	        branch_id: branch_id,
	        uid: uid,
	        is_completd: is_completd,
	        category: current_category,
	        url: 'getContactData'
	      });
	      (0, _FetchCall.partnerApi)(req).then(function (response) {
	
	        if (response.status === 1) {
	          var data = response.result;
	          var imagecnt = data.image_count;
	          if (current_plan == 0) {
	            imagecnt = user_type == 1 ? 8 : 7;
	          }
	          _this.setState({
	            attachment_file: data.photo_arr,
	            active_status: data.active_status,
	            main_id: data.main_id ? data.main_id : 0,
	            main_access: data.main_access ? data.main_access : 0,
	            url: data.url,
	            image_count: imagecnt,
	            edit_image: data.banner_image_up
	          });
	        }
	        console.log(_this.state.photos_arr);
	      });
	    };
	
	    _this.removeImage = function (e, index) {
	      var page_data = _this.state.page_data;
	      console.log('delete_array', page_data[index], e);
	      var delete_array = page_data[index].delete_array ? page_data[index].delete_array : [];
	      delete_array.push(e);
	      console.log('delete_array after', page_data[index]);
	      var updated = page_data[index].attachment_file.filter(function (item) {
	        return item.name != e;
	      });
	      page_data[index].delete_array = delete_array;
	      page_data[index].attachment_file = updated;
	      console.log('delete_array main', page_data[index]);
	      _this.setState({
	        page_data: page_data
	      });
	    };
	
	    _this.handleFile = function (e, index) {
	      var propName = e.target.name;
	      var files = e.target.files[0];
	      var page_data = _this.state.page_data;
	      page_data[index]['newimage'] = files;
	      _this.setState({ page_data: page_data });
	      var reader = new FileReader();
	      var img = '';
	      var THIS = _this;
	      reader.addEventListener("load", function () {
	        // convert image file to base64 string
	        img = reader.result;
	        page_data[index]['tempBanner'] = reader.result;
	        THIS.setState({
	          page_data: page_data
	        });
	      }, false);
	
	      if (files) {
	        reader.readAsDataURL(files);
	        console.log('img1', img);
	      } else {
	        page_data[index]['tempBanner'] = '';
	        THIS.setState({
	          page_data: page_data
	        });
	      }
	    };
	
	    _this.submitForm = function (e, index) {
	      e.preventDefault();
	      _this.setState({
	        btnDisabled: true
	      });
	      var _this$state$user_data3 = _this.state.user_data,
	          user_type = _this$state$user_data3.user_type,
	          login_id = _this$state$user_data3.login_id;
	
	      var page_data = _this.state.page_data[index];
	      var request = {
	        user_type: user_type,
	        login_id: login_id,
	        active_status: _this.state.active_status,
	        data: JSON.stringify(page_data),
	        delete_array: page_data.delete_array,
	        images: page_data.newimage,
	        photos: page_data.attachment_file ? page_data.attachment_file : []
	      };
	
	      (0, _FetchCall.updategallery)(request).then(function (res) {
	        var toastr = '';
	        _this.setState({
	          btnDisabled: false
	        });
	        if (res.status === 1) {
	
	          _reactNotifications.NotificationManager.success(res.message);
	          /*
	          setTimeout(function () {
	            window.location.reload();
	          }, 1000);
	          */
	        } else {
	
	          _reactNotifications.NotificationManager.error(res.message);
	        }
	      });
	    };
	
	    _this.state = {
	      user_data: JSON.parse(localStorage.getItem("user_data")),
	      authentication: localStorage.getItem('authentication') ? JSON.parse(localStorage.getItem('authentication')) : false,
	      user_type: 0,
	      access: [],
	      photos_arr: [],
	      delete_array: [],
	      edit_image: '',
	      url: '',
	      image_count: 0,
	      photos_arr_length: 0,
	      showupload: false, imagename: '', newimage: '', removeindex: '',
	      attachment_file: [],
	      attachment_file_length: 0,
	      attachment_fileName: [],
	      tempBanner: '',
	      active_status: 0,
	      main_id: 0,
	      main_access: '',
	      collapse: 0,
	      page_data: [],
	      btnDisabled: false
	    };
	    _this.validator = new _simpleReactValidator2.default({
	      validators: {
	        checkExist: { // name the rule
	          message: 'The :attribute field is required.',
	          rule: function rule(val, params, validator) {
	            if (val == '' && _this.state.edit_image == '') {
	              return false;
	            }
	          },
	          messageReplace: function messageReplace(message, params) {
	            return message.replace(':values', _this.helpers.toSentence(params));
	          }, // optional
	          required: true // optional
	        }
	      }
	    });
	    _this.loadFile = _this.loadFile.bind(_this);
	    _this.getgallery;
	    _this.getGallery();
	    _this.toggle = _this.toggle.bind(_this);
	    return _this;
	  }
	
	  _createClass(Gallery, [{
	    key: 'toggle',
	    value: function toggle(event) {
	      this.setState({
	        collapse: this.state.collapse === Number(event) ? -1 : Number(event)
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.state.authentication == true) {
	        this.setState({
	          access: this.state.user_data.current_category.split(','),
	          user_type: this.state.user_data.user_type
	          // access: [1]
	        });
	      }
	    }
	  }, {
	    key: 'loadFile',
	    value: function loadFile(e, index, image_count) {
	      var files = e.target.files;
	      var page_data = this.state.page_data;
	      this.setState({ attachment_file_length: files.length });
	      if (files.length > 0) {
	        var toastr = window.toastr.warning;
	        var errormsg = 'To upload more than ' + image_count + ' Image, Upgrade your plan';
	        if (files.length <= image_count) {
	          (0, _jquery2.default)('.upload-space').addClass('hide');
	          (0, _jquery2.default)('.upload-thumb').removeClass('hide');
	          var fileArra = page_data[index].attachment_file;
	          var total = fileArra.length + files.length;
	          if (total <= image_count) {
	            var err = '';
	            for (var i = 0; i < files.length; i++) {
	              if (e.target.files[i].size <= 1000000) fileArra.push(e.target.files[i]);else err = 'Image should be less than 1 MB';
	            }
	            page_data[index].attachment_file = fileArra;
	            this.setState({
	              page_data: page_data
	            });
	            if (err) _reactNotifications.NotificationManager.error(err);
	          } else {
	            _reactNotifications.NotificationManager.error(errormsg);
	          }
	        } else {
	          _reactNotifications.NotificationManager.error(errormsg);
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      this.validator.purgeFields();
	      var _state = this.state,
	          access = _state.access,
	          user_type = _state.user_type,
	          collapse = _state.collapse,
	          page_data = _state.page_data;
	
	      console.log('page_data', page_data);
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          'div',
	          { 'class': 'category_block' },
	          _react2.default.createElement(
	            'div',
	            { 'class': 'titleline' },
	            _react2.default.createElement(
	              'h4',
	              null,
	              'Gallery'
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              'Manage your gallery images'
	            )
	          ),
	          page_data.map(function (item, index) {
	            var lbl_banner = item.cid == 8 ? 'Event Poster if any can be uploaded here' : '';
	            return _react2.default.createElement(
	              'div',
	              { className: 'eachblockgap' },
	              _react2.default.createElement(
	                _reactstrap.Card,
	                { className: 'panel-group custom-card', style: { marginBottom: '1rem' }, key: index },
	                _react2.default.createElement(
	                  _reactstrap.CardHeader,
	                  { onClick: function onClick() {
	                      return _this2.toggle(index);
	                    }, 'data-event': index, className: item.set_id != 1 ? "branchcss" : "maincss" },
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'infoBoxColor' },
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'org_item' },
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'label_n' },
	                        'Category:'
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'item_n' },
	                        item.category_name
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'org_item' },
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'label_n' },
	                        'Inst/Org Name:'
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'item_n item_n_name' },
	                        item.organisation_name
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'org_item' },
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'label_n' },
	                        'Sub Category'
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'item_n' },
	                        item.sub_category_name ? item.sub_category_name : ''
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'org_item' },
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'label_n' },
	                        'Type:'
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: item.set_id != 1 ? "item_n branchtext" : "item_n" },
	                        item.set_id != 1 ? "Branch" : "HQ"
	                      )
	                    )
	                  ),
	                  collapse !== index ? _react2.default.createElement(
	                    'div',
	                    { 'class': 'centeredexpcolbtn' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: '' },
	                      _react2.default.createElement('i', { 'class': 'fa fa-plus', 'aria-hidden': 'true' })
	                    )
	                  ) : _react2.default.createElement(
	                    'div',
	                    { 'class': 'centeredexpcolbtn' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: '' },
	                      _react2.default.createElement('i', { 'class': 'fa fa-minus', 'aria-hidden': 'true' })
	                    )
	                  ),
	                  _react2.default.createElement('br', null)
	                ),
	                _react2.default.createElement(
	                  _reactstrap.Collapse,
	                  { isOpen: collapse === index },
	                  _react2.default.createElement(
	                    _reactstrap.CardBody,
	                    { className: 'panel-body' },
	                    _react2.default.createElement(
	                      'h3',
	                      { className: 'page-header' },
	                      item.organisation_name,
	                      ' ',
	                      _react2.default.createElement(
	                        'span',
	                        { style: { fontSize: "10px" } },
	                        _react2.default.createElement(
	                          'b',
	                          null,
	                          item.set_id == 3 ? "Branch" : ""
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      { className: 'mar-btm' },
	                      item.address
	                    ),
	                    item.is_active == 0 ? _react2.default.createElement(
	                      'div',
	                      { className: 'row mar-btm' },
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'form-group col-md-12' },
	                        _react2.default.createElement(
	                          'h3',
	                          { className: 'text-center' },
	                          'Upgrade/Renewal to update the Data'
	                        )
	                      )
	                    ) : _react2.default.createElement(
	                      'form',
	                      { onSubmit: function onSubmit(e) {
	                          return _this2.submitForm(e, index);
	                        } },
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'box-shadow-custom' },
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'row' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'form-group col-md-6 mar-btm', style: { minHeight: 'unset' } },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              'Banner Image ',
	                              lbl_banner && '(' + lbl_banner + ')',
	                              ' ',
	                              _react2.default.createElement(
	                                'span',
	                                { className: 'astrick' },
	                                '* (JPG, PNG in 560X250 pixels)'
	                              )
	                            ),
	                            _react2.default.createElement('input', {
	                              type: 'file',
	                              name: 'newimage',
	                              accept: 'image/x-png,image/gif,image/jpeg',
	                              onChange: function onChange(e) {
	                                return _this2.handleFile(e, index);
	                              },
	                              className: 'form-control mar-btm'
	                            })
	                          ),
	                          (item.edit_image != '' || item.tempBanner != '') && _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-12 pad-hor-no' },
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'col-sm-4', id: 'edit_image' },
	                              _react2.default.createElement('img', { src: item.tempBanner ? item.tempBanner : item.edit_image, alt: 'Img', 'class': 'img-thumbnail' })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'upload-wizard-wrap col-md-12' },
	                            _react2.default.createElement(
	                              'div',
	                              null,
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'col-md-12 float-left mt-4 pad-no' },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  'Gallery Images ',
	                                  _react2.default.createElement(
	                                    'span',
	                                    { className: 'astrick' },
	                                    '* (JPG, PNG in 980X360 pixels)'
	                                  )
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'col-md-12 float-left mt-4 pad-no' },
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'col-md-12 margin-bottom-mobile-account float-left image-upload' },
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'upload-wizard' },
	                                    _react2.default.createElement(
	                                      'div',
	                                      { className: 'upload-thumb' },
	                                      _react2.default.createElement(
	                                        'ul',
	                                        { className: 'list-inline' },
	                                        item.attachment_file.map(function (file_data, i) {
	
	                                          var file_url;
	                                          var url = file_data.image_thumb ? file_data.image_thumb : '';
	                                          if (url != '') {
	                                            file_url = file_data.image_thumb;
	                                          } else {
	                                            file_url = URL.createObjectURL(file_data);
	                                          }
	                                          if (file_data.type === 'application/pdf') {
	                                            return _react2.default.createElement(
	                                              'li',
	                                              { className: 'previewImg' },
	                                              _react2.default.createElement(
	                                                'div',
	                                                { className: 'thumb-img' },
	                                                _react2.default.createElement('img', {
	                                                  src: file_url,
	                                                  alt: 'image',
	                                                  title: file_data.name
	                                                })
	                                              ),
	                                              _react2.default.createElement(
	                                                'a',
	                                                { href: 'javascript:;', className: 'del-btn', onClick: function onClick(e) {
	                                                    _this2.removeImage(file_data.name, index);
	                                                  } },
	                                                _react2.default.createElement('img', {
	                                                  src: '../assets/images/close-icon-white.svg',
	                                                  alt: 'delete'
	                                                })
	                                              )
	                                            );
	                                          } else {
	                                            return _react2.default.createElement(
	                                              'li',
	                                              { className: 'previewImg' },
	                                              _react2.default.createElement(
	                                                'div',
	                                                { className: 'thumb-img' },
	                                                _react2.default.createElement('img', {
	                                                  src: file_url,
	                                                  alt: 'image',
	                                                  title: file_data.name
	                                                })
	                                              ),
	                                              _react2.default.createElement(
	                                                'a',
	                                                {
	                                                  href: 'javascript:;',
	                                                  className: 'del-btn',
	                                                  onClick: function onClick(e) {
	                                                    _this2.removeImage(file_data.name, index);
	                                                  }
	                                                },
	                                                _react2.default.createElement('img', {
	                                                  src: '../assets/images/close-icon-white.svg',
	                                                  alt: 'delete' })
	                                              )
	                                            );
	                                          }
	                                        }),
	                                        item.attachment_file.length <= item.image_count && _react2.default.createElement(
	                                          'li',
	                                          { className: 'addMore' },
	                                          _react2.default.createElement('input', {
	                                            type: 'file',
	                                            name: 'imgInp[]',
	                                            id: 'imgInp2',
	                                            className: 'add_img',
	
	                                            onChange: function onChange(e) {
	                                              return _this2.loadFile(e, index, item.image_count);
	                                            },
	                                            accept: 'image/x-png,image/gif,image/jpeg'
	                                          }),
	                                          _react2.default.createElement(
	                                            'a',
	                                            { href: 'javascript:;', className: 'add-more' },
	                                            _react2.default.createElement(
	                                              'div',
	                                              null,
	                                              _react2.default.createElement('img', { src: '../assets/images/upload-icon.svg', alt: 'icon' }),
	                                              'Add more'
	                                            )
	                                          )
	                                        )
	                                      )
	                                    )
	                                  )
	                                )
	                              )
	                            )
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: '' },
	                        _react2.default.createElement(
	                          'h5',
	                          { className: 'astrick' },
	                          _react2.default.createElement(
	                            'b',
	                            null,
	                            'Notes'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'ul',
	                          null,
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            item.plan_name + ' Upto ' + item.image_count + ' images can be uploaded where each image < 1MB'
	                          ),
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            'Images uploaded in banner and gallery will be published once Admin approves.'
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'col-md-12 col-xs-12 btn-bdr text-right pad-hor-no mar-btm' },
	                        _react2.default.createElement(
	                          'button',
	                          { type: 'submit', id: 'btnSubmit',
	                            className: 'btn btn-primary btn-sm', disabled: _this2.state.btnDisabled },
	                          'Submit Gallery info'
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            );
	          })
	        ),
	        _react2.default.createElement(_reactNotifications.NotificationContainer, null)
	      );
	    }
	  }]);
	
	  return Gallery;
	}(_react.Component);
	
	exports.default = Gallery;

/***/ },
/* 986 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FetchCall = __webpack_require__(4);
	
	var _FetchCall2 = _interopRequireDefault(_FetchCall);
	
	var _simpleReactValidator = __webpack_require__(28);
	
	var _simpleReactValidator2 = _interopRequireDefault(_simpleReactValidator);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactstrap = __webpack_require__(17);
	
	__webpack_require__(18);
	
	var _reactNotifications = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Gallery = function (_Component) {
	  _inherits(Gallery, _Component);
	
	  function Gallery(props) {
	    _classCallCheck(this, Gallery);
	
	    var _this = _possibleConstructorReturn(this, (Gallery.__proto__ || Object.getPrototypeOf(Gallery)).call(this, props));
	
	    _this.getGallery = function () {
	      var _this$state$user_data = _this.state.user_data,
	          user_type = _this$state$user_data.user_type,
	          login_id = _this$state$user_data.login_id,
	          set_id = _this$state$user_data.set_id;
	
	      var req = JSON.stringify({
	        user_type: user_type,
	        login_id: login_id,
	        sid: set_id,
	        url: 'getGalleryNew'
	      });
	      (0, _FetchCall.partnerApi)(req).then(function (response) {
	
	        if (response.status === 1) {
	          var data = response.result;
	          var imagecnt = data.max_gallery;
	          if (data.plan_id == 0) {
	            imagecnt = user_type == 1 ? 8 : 7;
	          }
	          _this.setState({
	            page_data: data.master_data,
	            active_status: response.result.active_status,
	            image_count: imagecnt
	          });
	        }
	      });
	    };
	
	    _this.getgallery = function () {
	      var _this$state$user_data2 = _this.state.user_data,
	          user_type = _this$state$user_data2.user_type,
	          login_id = _this$state$user_data2.login_id,
	          is_completd = _this$state$user_data2.is_completd,
	          current_plan = _this$state$user_data2.current_plan,
	          current_category = _this$state$user_data2.current_category,
	          uid = _this$state$user_data2.uid,
	          branch_id = _this$state$user_data2.branch_id;
	
	      var req = JSON.stringify({
	        user_type: user_type,
	        login_id: login_id,
	        branch_id: branch_id,
	        uid: uid,
	        is_completd: is_completd,
	        category: current_category,
	        url: 'getContactData'
	      });
	      (0, _FetchCall.partnerApi)(req).then(function (response) {
	
	        if (response.status === 1) {
	          var data = response.result;
	          var imagecnt = data.image_count;
	          if (current_plan == 0) {
	            imagecnt = user_type == 1 ? 8 : 7;
	          }
	          _this.setState({
	            attachment_file: data.photo_arr,
	            active_status: data.active_status,
	            main_id: data.main_id ? data.main_id : 0,
	            main_access: data.main_access ? data.main_access : 0,
	            url: data.url,
	            image_count: imagecnt,
	            edit_image: data.banner_image_up
	          });
	        }
	        console.log(_this.state.photos_arr);
	      });
	    };
	
	    _this.removeImage = function (e, index) {
	      var page_data = _this.state.page_data;
	      console.log('delete_array', page_data[index], e);
	      var delete_array = page_data[index].delete_array ? page_data[index].delete_array : [];
	      delete_array.push(e);
	      console.log('delete_array after', page_data[index]);
	      var updated = page_data[index].attachment_file.filter(function (item) {
	        return item.name != e;
	      });
	      page_data[index].delete_array = delete_array;
	      page_data[index].attachment_file = updated;
	      console.log('delete_array main', page_data[index]);
	      _this.setState({
	        page_data: page_data
	      });
	    };
	
	    _this.handleFile = function (e, index) {
	      var propName = e.target.name;
	      var files = e.target.files[0];
	      var page_data = _this.state.page_data;
	      page_data[index]['newimage'] = files;
	      _this.setState({ page_data: page_data });
	      var reader = new FileReader();
	      var img = '';
	      var THIS = _this;
	      reader.addEventListener("load", function () {
	        // convert image file to base64 string
	        img = reader.result;
	        page_data[index]['tempBanner'] = reader.result;
	        THIS.setState({
	          page_data: page_data
	        });
	      }, false);
	
	      if (files) {
	        reader.readAsDataURL(files);
	        console.log('img1', img);
	      } else {
	        page_data[index]['tempBanner'] = '';
	        THIS.setState({
	          page_data: page_data
	        });
	      }
	    };
	
	    _this.submitForm = function (e) {
	      e.preventDefault();
	      _this.setState({
	        btnDisabled: true
	      });
	      var _this$state$user_data3 = _this.state.user_data,
	          user_type = _this$state$user_data3.user_type,
	          login_id = _this$state$user_data3.login_id;
	
	      var page_data = _this.state.page_data;
	      var request = {
	        user_type: user_type,
	        login_id: login_id,
	        active_status: _this.state.active_status,
	        data: JSON.stringify(page_data),
	        delete_array: page_data.delete_array,
	        images: page_data.newimage,
	        photos: page_data.attachment_file ? page_data.attachment_file : []
	      };
	
	      (0, _FetchCall.updategallery)(request).then(function (res) {
	        var toastr = '';
	        _this.setState({
	          btnDisabled: false
	        });
	        if (res.status === 1) {
	
	          _reactNotifications.NotificationManager.success(res.message);
	          /*
	          setTimeout(function () {
	            window.location.reload();
	          }, 1000);
	          */
	        } else {
	
	          _reactNotifications.NotificationManager.error(res.message);
	        }
	      });
	    };
	
	    _this.state = {
	      user_data: JSON.parse(localStorage.getItem("user_data")),
	      authentication: localStorage.getItem('authentication') ? JSON.parse(localStorage.getItem('authentication')) : false,
	      user_type: 0,
	      access: [],
	      photos_arr: [],
	      delete_array: [],
	      edit_image: '',
	      url: '',
	      image_count: 0,
	      photos_arr_length: 0,
	      showupload: false, imagename: '', newimage: '', removeindex: '',
	      attachment_file: [],
	      attachment_file_length: 0,
	      attachment_fileName: [],
	      tempBanner: '',
	      active_status: 0,
	      main_id: 0,
	      main_access: '',
	      collapse: 0,
	      page_data: [],
	      btnDisabled: false
	    };
	    _this.validator = new _simpleReactValidator2.default({
	      validators: {
	        checkExist: { // name the rule
	          message: 'The :attribute field is required.',
	          rule: function rule(val, params, validator) {
	            if (val == '' && _this.state.edit_image == '') {
	              return false;
	            }
	          },
	          messageReplace: function messageReplace(message, params) {
	            return message.replace(':values', _this.helpers.toSentence(params));
	          }, // optional
	          required: true // optional
	        }
	      }
	    });
	    _this.loadFile = _this.loadFile.bind(_this);
	    _this.getgallery;
	    _this.getGallery();
	    _this.toggle = _this.toggle.bind(_this);
	    return _this;
	  }
	
	  _createClass(Gallery, [{
	    key: 'toggle',
	    value: function toggle(event) {
	      this.setState({
	        collapse: this.state.collapse === Number(event) ? -1 : Number(event)
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.state.authentication == true) {
	        this.setState({
	          access: this.state.user_data.current_category.split(','),
	          user_type: this.state.user_data.user_type
	          // access: [1]
	        });
	      }
	    }
	  }, {
	    key: 'loadFile',
	    value: function loadFile(e, index, image_count) {
	      var files = e.target.files;
	      var page_data = this.state.page_data;
	      this.setState({ attachment_file_length: files.length });
	      if (files.length > 0) {
	        var toastr = window.toastr.warning;
	        var errormsg = 'To upload more than ' + image_count + ' Image, Upgrade your plan';
	        if (files.length <= image_count) {
	          (0, _jquery2.default)('.upload-space').addClass('hide');
	          (0, _jquery2.default)('.upload-thumb').removeClass('hide');
	          var fileArra = page_data[index].attachment_file;
	          var total = fileArra.length + files.length;
	          if (total <= image_count) {
	            var err = '';
	            for (var i = 0; i < files.length; i++) {
	              if (e.target.files[i].size <= 1000000) fileArra.push(e.target.files[i]);else err = 'Image should be less than 1 MB';
	            }
	            page_data[index].attachment_file = fileArra;
	            this.setState({
	              page_data: page_data
	            });
	            if (err) _reactNotifications.NotificationManager.error(err);
	          } else {
	            _reactNotifications.NotificationManager.error(errormsg);
	          }
	        } else {
	          _reactNotifications.NotificationManager.error(errormsg);
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      this.validator.purgeFields();
	      var _state = this.state,
	          access = _state.access,
	          user_type = _state.user_type,
	          collapse = _state.collapse,
	          page_data = _state.page_data;
	
	      console.log('page_data', page_data);
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          'div',
	          { 'class': 'category_block' },
	          _react2.default.createElement(
	            'div',
	            { 'class': 'titleline' },
	            _react2.default.createElement(
	              'h4',
	              null,
	              'Media'
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              'Manage all of your images and videos of your institutions'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'form',
	              { onSubmit: function onSubmit(e) {
	                  return _this2.submitForm(e);
	                } },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'box-shadow-custom' },
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'form-group col-md-6 mar-btm', style: { minHeight: 'unset' } },
	                    _react2.default.createElement(
	                      'label',
	                      null,
	                      'Logo/Banner Image ',
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'astrick' },
	                        '* (Webp, JPG, PNG in 300X300 pixels) (size less than or equal to 512KB)'
	                      )
	                    ),
	                    _react2.default.createElement('input', {
	                      type: 'file',
	                      name: 'newimage',
	                      accept: 'image/x-png,image/gif,image/jpeg',
	                      onChange: function onChange(e) {
	                        return _this2.handleFile(e);
	                      },
	                      className: 'form-control mar-btm'
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'upload-wizard-wrap col-md-12' },
	                    _react2.default.createElement(
	                      'div',
	                      null,
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'col-md-12 float-left mt-4 pad-no' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          'Gallery Images ',
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'astrick' },
	                            '* (Webp, JPG, PNG in 980X360 pixels) ((size less than or equal to 1MB)'
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'col-md-12 float-left mt-4 pad-no' },
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'col-md-12 margin-bottom-mobile-account float-left image-upload' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'upload-wizard' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'upload-thumb' },
	                              _react2.default.createElement(
	                                'ul',
	                                { className: 'list-inline' },
	                                _react2.default.createElement(
	                                  'li',
	                                  { className: 'addMore' },
	                                  _react2.default.createElement('input', {
	                                    type: 'file',
	                                    name: 'imgInp[]',
	                                    id: 'imgInp2',
	                                    className: 'add_img',
	
	                                    onChange: function onChange(e) {
	                                      return _this2.loadFile(e);
	                                    },
	                                    accept: 'image/x-png,image/gif,image/jpeg'
	                                  }),
	                                  _react2.default.createElement(
	                                    'a',
	                                    { href: 'javascript:;', className: 'add-more' },
	                                    _react2.default.createElement(
	                                      'div',
	                                      null,
	                                      _react2.default.createElement('img', { src: '../assets/images/upload-icon.svg', alt: 'icon' }),
	                                      'Add more'
	                                    )
	                                  )
	                                )
	                              )
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'videos' },
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'form-group col-md-4' },
	                      _react2.default.createElement(
	                        'label',
	                        null,
	                        ' Video (.mp4) (size less than or equal to 5MB) '
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'form-group col-md-6' },
	                      _react2.default.createElement('input', {
	                        type: 'file',
	                        name: 'video_new',
	                        size: '10024',
	                        onChange: function onChange(e) {
	                          return _this2.handleFile(e);
	                        },
	                        className: 'form-control mar-btm',
	                        accept: 'video/mp4'
	                      })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'col-md-12' },
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'astrick' },
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          'inappropriate videos will be deleted'
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'astrick' },
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          'Uploading video should be within 10MB'
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'astrick' },
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          'Uploading video should be .mp4 format only and not more than 2 minutes.'
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'astrick' },
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          'Video will be displayed on the website after admin\'s approval.'
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { 'class': 'notesgal' },
	                'You can select/deselect to copy the same set of files to below listing'
	              ),
	              _react2.default.createElement(
	                'div',
	                { 'class': 'chooselisting' },
	                page_data.map(function (item, index) {
	
	                  return _react2.default.createElement(
	                    'div',
	                    { 'class': 'optionitem' },
	                    _react2.default.createElement('input', { type: 'checkbox', 'class': '', name: 'chosenlisting[]', value: item.id }),
	                    '\xA0',
	                    _react2.default.createElement(
	                      'b',
	                      null,
	                      item.category_name,
	                      ' '
	                    ),
	                    ' - ',
	                    item.organisation_name
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                'div',
	                { 'class': 'col-md-12 col-xs-12 btn-bdr text-right pad-hor-no mar-btm' },
	                _react2.default.createElement(
	                  'button',
	                  { type: 'submit', id: 'btnSubmit',
	                    className: 'btn btn-primary btn-sm', disabled: this.state.btnDisabled },
	                  'Submit and Proceed next'
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_reactNotifications.NotificationContainer, null)
	      );
	    }
	  }]);
	
	  return Gallery;
	}(_react.Component);
	
	exports.default = Gallery;

/***/ },
/* 987 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FetchCall = __webpack_require__(4);
	
	var _FetchCall2 = _interopRequireDefault(_FetchCall);
	
	var _simpleReactValidator = __webpack_require__(28);
	
	var _simpleReactValidator2 = _interopRequireDefault(_simpleReactValidator);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactstrap = __webpack_require__(17);
	
	__webpack_require__(18);
	
	var _reactNotifications = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Videos = function (_Component) {
	  _inherits(Videos, _Component);
	
	  function Videos(props) {
	    _classCallCheck(this, Videos);
	
	    var _this = _possibleConstructorReturn(this, (Videos.__proto__ || Object.getPrototypeOf(Videos)).call(this, props));
	
	    _this.getVideo = function () {
	      var _this$state$user_data = _this.state.user_data,
	          user_type = _this$state$user_data.user_type,
	          login_id = _this$state$user_data.login_id,
	          set_id = _this$state$user_data.set_id;
	
	      var req = JSON.stringify({
	        user_type: user_type,
	        login_id: login_id,
	        sid: set_id,
	        url: 'getVideoNew'
	      });
	      (0, _FetchCall.partnerApi)(req).then(function (response) {
	        if (response.status === 1) {
	          var data = response.result;
	          _this.setState({
	            active_status: data.active_status,
	            page_data: data.master_data
	          });
	        }
	        console.log(_this.state.photos_arr);
	      });
	    };
	
	    _this.handleFile = function (e, index) {
	      var propName = e.target.name;
	      var files = e.target.files[0];
	      var page_data = _this.state.page_data;
	      page_data[index][propName] = files;
	      _this.setState({ page_data: page_data });
	    };
	
	    _this.submitForm = function (e, index) {
	      e.preventDefault();
	      _this.setState({
	        btnDisabled: true
	      });
	      // console.log(this.state.user_data);
	      // return false;
	      var _this$state$user_data2 = _this.state.user_data,
	          user_type = _this$state$user_data2.user_type,
	          login_id = _this$state$user_data2.login_id;
	
	      var page_data = _this.state.page_data[index];
	
	      if (!page_data.video_new) {
	        _reactNotifications.NotificationManager.error("no video is selected. Please choose any");
	      } else {
	        var request = {
	          user_type: user_type,
	          login_id: login_id,
	          uid: page_data.uid,
	          video_new: page_data.video_new ? page_data.video_new : []
	        };
	
	        (0, _FetchCall.updateVideo)(request).then(function (res) {
	
	          if (res.status === 1) {
	            _reactNotifications.NotificationManager.success('Video Submitted for admin`s Approval!');
	
	            localStorage.setItem('is_completed', 1);
	
	            _this.setState({
	              btnDisabled: false
	            });
	            /*
	            setTimeout(function () {
	              window.location.reload();
	            }, 1000);
	            */
	          } else {
	            _reactNotifications.NotificationManager.error(res.message);
	          }
	        });
	      }
	    };
	
	    _this.state = {
	      user_data: JSON.parse(localStorage.getItem("user_data")),
	      authentication: localStorage.getItem('authentication') ? JSON.parse(localStorage.getItem('authentication')) : false,
	      user_type: 0,
	      exist_video: '',
	      access: [],
	      photos_arr: [],
	      delete_array: [],
	      edit_image: '',
	      url: '',
	      image_count: 0,
	      photos_arr_length: 0,
	      showupload: false, imagename: '', newimage: '', removeindex: '',
	      attachment_file: [],
	      attachment_file_length: 0,
	      attachment_fileName: [],
	      tempBanner: '',
	      active_status: 0,
	      main_id: 0,
	      main_access: '',
	      btnDisabled: false,
	      collapse: 0,
	      page_data: []
	    };
	    _this.validator = new _simpleReactValidator2.default({
	      validators: {
	        checkExist: { // name the rule
	          message: 'The :attribute field is required.',
	          rule: function rule(val, params, validator) {
	            if (val == '' && _this.state.edit_image == '') {
	              return false;
	            }
	          },
	          messageReplace: function messageReplace(message, params) {
	            return message.replace(':values', _this.helpers.toSentence(params));
	          }, // optional
	          required: true // optional
	        }
	      }
	    });
	
	    // this.getgallery();
	    _this.getVideo();
	    _this.toggle = _this.toggle.bind(_this);
	    return _this;
	  }
	
	  _createClass(Videos, [{
	    key: 'toggle',
	    value: function toggle(event) {
	      this.setState({
	        collapse: this.state.collapse === Number(event) ? -1 : Number(event)
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.state.authentication == true) {
	        this.setState({
	          access: this.state.user_data.current_category.split(','),
	          user_type: this.state.user_data.user_type
	          // access: [1]
	        });
	      }
	    }
	    // getgallery = () => {
	    //   const { user_type, login_id, is_completd, current_category } = this.state.user_data;
	    //   let req = JSON.stringify({
	    //     user_type: user_type,
	    //     login_id: login_id,
	    //     is_completd: is_completd,
	    //     category: current_category,
	    //     url: 'getContactData'
	    //   });
	    //   partnerApi(req).then((response) => {
	    //     console.log('response on videos', response);
	    //     if (response.status === 1) {
	    //       let data = response.result;
	    //       if (data.video_path)
	    //         this.setState({
	    //           video_new: '',
	    //           active_status: data.active_status,
	    //           exist_video: data.url + data.video_path,
	    //           main_access: data.main_access ? data.main_access : 0,
	    //         });
	    //     }
	    //     console.log(this.state.photos_arr);
	    //   })onSubmit={(e) => this.submitForm(e, index)
	    // }
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      this.validator.purgeFields();
	      var _state = this.state,
	          access = _state.access,
	          user_type = _state.user_type,
	          page_data = _state.page_data,
	          collapse = _state.collapse;
	
	      console.log('page_data vide', page_data);
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          'div',
	          { 'class': 'category_block' },
	          _react2.default.createElement(
	            'div',
	            { 'class': 'titleline' },
	            _react2.default.createElement(
	              'h4',
	              null,
	              'Videos'
	            )
	          ),
	          page_data.map(function (item, index) {
	            return _react2.default.createElement(
	              'div',
	              { className: 'eachblockgap' },
	              _react2.default.createElement(
	                _reactstrap.Card,
	                { className: 'panel-group custom-card', style: { marginBottom: '1rem' }, key: index },
	                _react2.default.createElement(
	                  _reactstrap.CardHeader,
	                  { onClick: function onClick() {
	                      return _this2.toggle(index);
	                    }, 'data-event': index, className: item.set_id != 1 ? "branchcss" : "maincss" },
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'infoBoxColor' },
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'org_item' },
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'label_n' },
	                        'Category:'
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'item_n' },
	                        item.category_name
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'org_item' },
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'label_n' },
	                        'Inst/Org Name:'
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'item_n item_n_name' },
	                        item.organisation_name
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'org_item' },
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'label_n' },
	                        'Sub Category'
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'item_n' },
	                        item.sub_category_name ? item.sub_category_name : ''
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'org_item' },
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'label_n' },
	                        'Type:'
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: item.set_id != 1 ? "item_n branchtext" : "item_n" },
	                        item.set_id != 1 ? "Branch" : "HQ"
	                      )
	                    )
	                  ),
	                  collapse !== index ? _react2.default.createElement(
	                    'div',
	                    { 'class': 'centeredexpcolbtn' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: '' },
	                      _react2.default.createElement('i', { 'class': 'fa fa-plus', 'aria-hidden': 'true' })
	                    )
	                  ) : _react2.default.createElement(
	                    'div',
	                    { 'class': 'centeredexpcolbtn' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: '' },
	                      _react2.default.createElement('i', { 'class': 'fa fa-minus', 'aria-hidden': 'true' })
	                    )
	                  ),
	                  _react2.default.createElement('br', null)
	                ),
	                _react2.default.createElement(
	                  _reactstrap.Collapse,
	                  { isOpen: collapse === index },
	                  _react2.default.createElement(
	                    _reactstrap.CardBody,
	                    { className: 'panel-body' },
	                    _react2.default.createElement(
	                      'h3',
	                      { className: 'page-header' },
	                      item.organisation_name,
	                      ' ',
	                      _react2.default.createElement(
	                        'span',
	                        { style: { fontSize: "10px" } },
	                        _react2.default.createElement(
	                          'b',
	                          null,
	                          item.set_id == 3 ? "Branch" : ""
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      { className: 'mar-btm' },
	                      item.address
	                    ),
	                    item.is_active == 0 ? _react2.default.createElement(
	                      'div',
	                      { className: 'row mar-btm' },
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'form-group col-md-12' },
	                        _react2.default.createElement(
	                          'h3',
	                          { className: 'text-center' },
	                          'Upgrade/Renewal to update the Data'
	                        )
	                      )
	                    ) : _react2.default.createElement(
	                      'form',
	                      { onSubmit: function onSubmit(e) {
	                          return _this2.submitForm(e, index);
	                        } },
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'box-shadow-custom' },
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'row' },
	                          _react2.default.createElement(
	                            'div',
	                            null,
	                            item.exist_video != '' && _react2.default.createElement(
	                              'div',
	                              { className: 'row' },
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'form-group col-md-4' },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  ' Current Video ',
	                                  _react2.default.createElement(
	                                    'span',
	                                    { className: 'astrick' },
	                                    '*'
	                                  )
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'form-group col-md-6' },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'row' },
	                                  ' ',
	                                  _react2.default.createElement('br', null)
	                                )
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'form-group col-md-4' },
	                              _react2.default.createElement(
	                                'label',
	                                null,
	                                ' Video ',
	                                _react2.default.createElement(
	                                  'span',
	                                  { className: 'astrick' },
	                                  '*'
	                                )
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'form-group col-md-6' },
	                              _react2.default.createElement('input', {
	                                type: 'file',
	                                name: 'video_new',
	                                size: '10024',
	                                onChange: function onChange(e) {
	                                  return _this2.handleFile(e, index);
	                                },
	                                className: 'form-control mar-btm',
	                                accept: 'video/mp4'
	                              })
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'col-md-12' },
	                              _react2.default.createElement(
	                                'span',
	                                { className: 'astrick' },
	                                _react2.default.createElement(
	                                  'li',
	                                  null,
	                                  'inappropriate videos will be deleted'
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'span',
	                                { className: 'astrick' },
	                                _react2.default.createElement(
	                                  'li',
	                                  null,
	                                  'Uploading video should be within 10MB'
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'span',
	                                { className: 'astrick' },
	                                _react2.default.createElement(
	                                  'li',
	                                  null,
	                                  'Uploading video should be .mp4 format only and not more than 2 minutes.'
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'span',
	                                { className: 'astrick' },
	                                _react2.default.createElement(
	                                  'li',
	                                  null,
	                                  'Video will be displayed on the website after admin\'s approval.'
	                                )
	                              )
	                            )
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'col-md-12 col-xs-12 btn-bdr text-right pad-hor-no mar-btm' },
	                        _react2.default.createElement(
	                          'button',
	                          { type: 'submit', id: 'btnSubmit',
	                            className: 'btn btn-primary btn-sm', disabled: _this2.state.btnDisabled },
	                          'Submit Video Info'
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            );
	          })
	        ),
	        _react2.default.createElement(_reactNotifications.NotificationContainer, null)
	      );
	    }
	  }]);
	
	  return Videos;
	}(_react.Component);
	
	exports.default = Videos;

/***/ },
/* 988 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FetchCall = __webpack_require__(4);
	
	var _simpleReactValidator = __webpack_require__(28);
	
	var _simpleReactValidator2 = _interopRequireDefault(_simpleReactValidator);
	
	var _DomainName = __webpack_require__(119);
	
	var _DomainName2 = _interopRequireDefault(_DomainName);
	
	var _tinymceReact = __webpack_require__(69);
	
	var _constant = __webpack_require__(21);
	
	__webpack_require__(18);
	
	var _reactNotifications = __webpack_require__(16);
	
	var _reactstrap = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var About_other = function (_Component) {
	  _inherits(About_other, _Component);
	
	  function About_other(props) {
	    _classCallCheck(this, About_other);
	
	    var _this = _possibleConstructorReturn(this, (About_other.__proto__ || Object.getPrototypeOf(About_other)).call(this, props));
	
	    _this.handleChange = function (e, i) {
	      var propName = e.target.name;
	      var page_data = _this.state.page_data;
	      page_data[i][propName] = e.target.value;
	      _this.setState({ page_data: page_data });
	    };
	
	    _this.handleCheckBoxChange = function (e, i) {
	      var page_data = _this.state.page_data;
	      var propName = e.target.name;
	      if (e.target.checked) {
	        page_data[i][propName] = 1;
	      } else {
	        page_data[i][propName] = 0;
	      }
	      _this.setState({ page_data: page_data });
	    };
	
	    _this.handleSelect = function (e) {
	      var propName = e.target.name;
	      var value = [].concat(_toConsumableArray(e.target.selectedOptions)).map(function (item) {
	        return item.value;
	      });
	      _this.setState(_defineProperty({}, propName, value));
	    };
	
	    _this.handleChangeParent = function (event) {
	      _this.props.handleChange();
	    };
	
	    _this.submitForm = function (e, i) {
	      e.preventDefault();
	      var page_data = _this.state.page_data;
	      var count = _this.countWords(page_data[i].about);
	      if (count > _this.state.maxAbout) {
	
	        _reactNotifications.NotificationManager.error('The about must be less than ' + _this.state.maxAbout + ' words.');
	        return false;
	      }
	      // if (this.validator.allValid()) {
	      var _this$state$user_data = _this.state.user_data,
	          user_type = _this$state$user_data.user_type,
	          login_id = _this$state$user_data.login_id,
	          set_id = _this$state$user_data.set_id;
	
	      var request = JSON.stringify({
	        user_type: user_type,
	        login_id: login_id,
	        sid: set_id,
	        main_access: _this.state.main_access,
	        active_status: _this.state.active_status,
	        data: page_data[i],
	        url: 'updateAbout'
	      });
	      (0, _FetchCall.partnerApi)(request).then(function (res) {
	
	        if (res.status === 1) {
	          //console.log("dfgdgfd");
	          //this.handleChangeParent();
	          _reactNotifications.NotificationManager.success(res.message);
	        } else {
	          _reactNotifications.NotificationManager.error(res.message);
	        }
	      });
	      // } else {
	      //   this.validator.showMessages();
	      //   this.forceUpdate();
	      // }
	    };
	
	    _this.state = {
	      user_data: localStorage.getItem('user_data') ? JSON.parse(localStorage.getItem('user_data')) : [],
	      authentication: localStorage.getItem('authentication') ? JSON.parse(localStorage.getItem('authentication')) : false,
	      about: '',
	      tobecurated: false,
	      main_access: '',
	      maxAbout: 0,
	      page_data: [],
	      user_type: 0,
	      active_status: 0,
	      organisation_name: '',
	      banner_image: '',
	      main_category: '',
	      slug_term: '',
	      address: '',
	      listcategories: [],
	      collapse: 0,
	      pageurl: ''
	    };
	    _this.validator = new _simpleReactValidator2.default();
	    _this.getAbout();
	    _this.toggle = _this.toggle.bind(_this);
	    _this.handleChangeAbout = _this.handleChangeAbout.bind(_this);
	    return _this;
	  }
	
	  _createClass(About_other, [{
	    key: 'toggle',
	    value: function toggle(event) {
	
	      this.setState({
	        collapse: this.state.collapse === Number(event) ? -1 : Number(event)
	      });
	    }
	  }, {
	    key: 'countWords',
	    value: function countWords(str) {
	      str = str.replace(/(^\s*)|(\s*$)/gi, "");
	      str = str.replace(/[ ]{2,}/gi, " ");
	      str = str.replace(/\n /, "\n");
	      return str.split(' ').length;
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'getAbout',
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var _this2 = this;
	
	        var _state$user_data, user_type, login_id, set_id, insdata;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _state$user_data = this.state.user_data, user_type = _state$user_data.user_type, login_id = _state$user_data.login_id, set_id = _state$user_data.set_id;
	                insdata = JSON.stringify({
	                  user_type: user_type,
	                  login_id: login_id,
	                  sid: set_id,
	                  url: 'getAbout'
	                });
	                _context.next = 4;
	                return (0, _FetchCall.partnerApi)(insdata).then(function (response) {
	                  if (response.status === 1) {
	
	                    _this2.setState({
	                      page_data: response.result.master_data,
	                      active_status: response.result.active_status,
	                      maxAbout: 500,
	                      pageurl: response.result.pageurl
	                    });
	                  }
	                });
	
	              case 4:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function getAbout() {
	        return _ref.apply(this, arguments);
	      }
	
	      return getAbout;
	    }()
	  }, {
	    key: 'handleChangeAbout',
	    value: function handleChangeAbout(value, i) {
	      var page_data = this.state.page_data;
	      page_data[i]['about'] = value;
	      this.setState({ page_data: page_data });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          cards = _state.cards,
	          collapse = _state.collapse,
	          page_data = _state.page_data,
	          pageurl = _state.pageurl;
	
	      this.validator.purgeFields();
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          'div',
	          { 'class': 'category_block' },
	          _react2.default.createElement(
	            'div',
	            { 'class': 'titleline' },
	            _react2.default.createElement(
	              'h4',
	              null,
	              'About Info'
	            ),
	            ' ',
	            _react2.default.createElement(
	              'span',
	              null,
	              'Branch Information is copied from Head Office by default, You can edit and update as it may be required'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: '' },
	            page_data.map(function (item, index) {
	              return _react2.default.createElement(
	                'div',
	                { 'class': 'eachblockgap', style: { paddingTop: "20px" } },
	                _react2.default.createElement(
	                  _reactstrap.Card,
	                  { className: 'panel-group custom-card', style: { marginBottom: '1rem' }, key: index },
	                  _react2.default.createElement(
	                    _reactstrap.CardHeader,
	                    { onClick: function onClick() {
	                        return _this3.toggle(index);
	                      }, 'data-event': index, className: item.set_id != 1 ? "branchcss" : "maincss" },
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'infoBoxColor' },
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'org_item' },
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'label_n' },
	                          'Category:'
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'item_n' },
	                          item.category_name
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'org_item' },
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'label_n' },
	                          'Inst/Org Name:'
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'item_n item_n_name' },
	                          item.organisation_name
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'org_item' },
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'label_n' },
	                          'Sub Category'
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'item_n' },
	                          item.sub_category_name ? item.sub_category_name : ''
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'org_item' },
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'label_n' },
	                          'Type:'
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: item.set_id != 1 ? "item_n branchtext" : "item_n" },
	                          item.set_id != 1 ? "Branch" : "HQ"
	                        )
	                      )
	                    ),
	                    collapse !== index ? _react2.default.createElement(
	                      'div',
	                      { 'class': 'centeredexpcolbtn' },
	                      _react2.default.createElement(
	                        'span',
	                        { className: '' },
	                        _react2.default.createElement('i', { 'class': 'fa fa-plus', 'aria-hidden': 'true' })
	                      )
	                    ) : _react2.default.createElement(
	                      'div',
	                      { 'class': 'centeredexpcolbtn' },
	                      _react2.default.createElement(
	                        'span',
	                        { className: '' },
	                        _react2.default.createElement('i', { 'class': 'fa fa-minus', 'aria-hidden': 'true' })
	                      )
	                    ),
	                    _react2.default.createElement('br', null)
	                  ),
	                  _react2.default.createElement(
	                    _reactstrap.Collapse,
	                    { className: collapse === index ? "expanded" : "", isOpen: collapse === index },
	                    _react2.default.createElement(
	                      _reactstrap.CardBody,
	                      { className: 'panel-body' },
	                      _react2.default.createElement(
	                        'h3',
	                        { className: 'page-header' },
	                        item.organisation_name,
	                        ' ',
	                        _react2.default.createElement(
	                          'span',
	                          { style: { fontSize: "10px" } },
	                          _react2.default.createElement(
	                            'b',
	                            null,
	                            item.set_id == 3 ? "Branch" : ""
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'p',
	                        { className: 'mar-btm' },
	                        item.address
	                      ),
	                      item.is_active == 0 ? _react2.default.createElement(
	                        'div',
	                        { className: 'row mar-btm' },
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'form-group col-md-12' },
	                          _react2.default.createElement(
	                            'h3',
	                            { className: 'text-center' },
	                            'Upgrade/Renewal to update the Data'
	                          )
	                        )
	                      ) : _react2.default.createElement(
	                        'form',
	                        { onSubmit: function onSubmit(e) {
	                            return _this3.submitForm(e, index);
	                          } },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'row mar-btm' },
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'form-group col-md-12' },
	                            _react2.default.createElement(_tinymceReact.Editor, {
	                              onEditorChange: function onEditorChange(e) {
	                                return _this3.handleChangeAbout(e, index);
	                              },
	                              value: item.about,
	                              apiKey: _constant.TINY_EDITOR,
	                              init: {
	                                height: 400,
	                                plugins: ['lists link image paste'],
	                                toolbar: 'undo redo | formatselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | help'
	                              }
	                            })
	                          )
	                        ),
	                        item.category_name == 'Learning Camps' ? _react2.default.createElement(
	                          'div',
	                          { className: 'row mar-btm' },
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'form-group col-md-12' },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              'Send as request to be BeWise Curated'
	                            ),
	                            _react2.default.createElement('input', { type: 'checkbox', name: 'iscurated', onChange: function onChange(e) {
	                                return _this3.handleCheckBoxChange(e, index);
	                              } })
	                          )
	                        ) : '',
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'col-md-12 col-xs-12 btn-bdr text-right pad-hor-no mar-btm' },
	                          _react2.default.createElement(
	                            'button',
	                            { type: 'submit', id: 'btnSubmit',
	                              className: 'btn btn-primary btn-sm' },
	                            'Submit About info'
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              );
	            })
	          )
	        ),
	        _react2.default.createElement(_reactNotifications.NotificationContainer, null)
	      );
	    }
	  }]);
	
	  return About_other;
	}(_react.Component);
	
	exports.default = About_other;

/***/ },
/* 989 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FetchCall = __webpack_require__(4);
	
	var _FetchCall2 = _interopRequireDefault(_FetchCall);
	
	var _simpleReactValidator = __webpack_require__(28);
	
	var _simpleReactValidator2 = _interopRequireDefault(_simpleReactValidator);
	
	var _reactNotifications = __webpack_require__(16);
	
	var _reactstrap = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Admission_other = function (_Component) {
	  _inherits(Admission_other, _Component);
	
	  function Admission_other(props) {
	    _classCallCheck(this, Admission_other);
	
	    var _this = _possibleConstructorReturn(this, (Admission_other.__proto__ || Object.getPrototypeOf(Admission_other)).call(this, props));
	
	    _this.handleChange = function (e, index) {
	      var propName = e.target.name;
	      var propValue = e.target.value;
	      var page_data = _this.state.page_data;
	      page_data[index][propName] = propValue;
	      _this.setState({ page_data: page_data });
	    };
	
	    _this.documentHandleSelect = function (e, i) {
	      var propName = e.target.name;
	      var value = [].concat(_toConsumableArray(e.target.selectedOptions)).map(function (item) {
	        return item.value;
	      });
	      var page_data = _this.state.page_data;
	
	      page_data[i][propName] = value;
	      _this.setState({ page_data: page_data });
	    };
	
	    _this.handleSelect = function (e, i) {
	      var propName = e.target.name;
	      var value = [].concat(_toConsumableArray(e.target.selectedOptions)).map(function (item) {
	        return item.value;
	      });
	      var page_data = _this.state.page_data;
	
	      page_data[i][propName] = value;
	      _this.setState({ page_data: page_data });
	    };
	
	    _this.submitForm = function (e, i) {
	      e.preventDefault();
	      _this.setState({
	        btnDisabled: true
	      });
	      if (_this.validator.allValid()) {
	        var _this$state$user_data = _this.state.user_data,
	            user_type = _this$state$user_data.user_type,
	            login_id = _this$state$user_data.login_id,
	            set_id = _this$state$user_data.set_id;
	
	        var request = JSON.stringify({
	          user_type: user_type,
	          login_id: login_id,
	          sid: set_id,
	          active_status: _this.state.active_status,
	          data: _this.state.page_data[i],
	          url: 'updateAdmission'
	        });
	        (0, _FetchCall.partnerApi)(request).then(function (res) {
	
	          if (res.status === 1) {
	            _reactNotifications.NotificationManager.success(res.message);
	
	            _this.setState({
	              btnDisabled: false
	            });
	          } else {
	            _reactNotifications.NotificationManager.error(res.message);
	          }
	        });
	      } else {
	        _this.validator.showMessages();
	        _this.forceUpdate();
	      }
	    };
	
	    _this.state = {
	      user_data: localStorage.getItem('user_data') ? JSON.parse(localStorage.getItem('user_data')) : [],
	      authentication: localStorage.getItem('authentication') ? JSON.parse(localStorage.getItem('authentication')) : false,
	      main_access: '',
	      dropdown: { documents: [] },
	      access: [],
	      documents: [],
	      admission_link: '',
	      admission_process: '',
	      is_refund: '',
	      application_fee: '0',
	      other_fee: '0',
	      average_fee: '0',
	      class_fee: '0',
	      class_fee_type: '0',
	      recurring_fee: '0',
	      active_status: 0,
	      collapse: 0,
	      page_data: [],
	      btnDisabled: true
	    };
	    _this.validator = new _simpleReactValidator2.default();
	    _this.getDropData();
	    _this.getKeyInfo();
	    _this.toggle = _this.toggle.bind(_this);
	    return _this;
	  }
	
	  _createClass(Admission_other, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'getKeyInfo',
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var _this2 = this;
	
	        var _state$user_data, user_type, login_id, set_id, insdata;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _state$user_data = this.state.user_data, user_type = _state$user_data.user_type, login_id = _state$user_data.login_id, set_id = _state$user_data.set_id;
	                insdata = JSON.stringify({
	                  user_type: user_type,
	                  login_id: login_id,
	                  sid: set_id,
	                  url: 'getKeyInfoNew'
	                });
	                _context.next = 4;
	                return (0, _FetchCall.partnerApi)(insdata).then(function (response) {
	                  if (response.status === 1) {
	                    _this2.setState({
	                      btnDisabled: false,
	                      active_status: response.result.active_status,
	                      page_data: response.result.master_data
	                    });
	                  }
	                });
	
	              case 4:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function getKeyInfo() {
	        return _ref.apply(this, arguments);
	      }
	
	      return getKeyInfo;
	    }()
	  }, {
	    key: 'toggle',
	    value: function toggle(event) {
	      this.setState({
	        collapse: this.state.collapse === Number(event) ? -1 : Number(event)
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          access = _state.access,
	          dropdown = _state.dropdown,
	          page_data = _state.page_data,
	          collapse = _state.collapse;
	      var user_type = this.state.user_data.user_type;
	
	      console.log('dropdown.documents', dropdown.documents);
	      this.validator.purgeFields();
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          'div',
	          { 'class': 'category_block' },
	          _react2.default.createElement(
	            'div',
	            { 'class': 'titleline' },
	            _react2.default.createElement(
	              'h4',
	              null,
	              'Admission and Fee Info'
	            )
	          ),
	          page_data.map(function (item, index) {
	            var lbl_annual = item.cid == 6 ? 'Monthly' : 'Annual';
	            var lbl_entry = item.cid == 7 ? 'Charges/Event (Starts From)' : 'Entry Fees';
	            var second_category = item.second_category ? item.second_category.split(',') : [];
	            return _react2.default.createElement(
	              'div',
	              { className: 'eachblockgap' },
	              _react2.default.createElement(
	                'form',
	                { onSubmit: function onSubmit(e) {
	                    return _this3.submitForm(e, index);
	                  } },
	                _react2.default.createElement(
	                  _reactstrap.Card,
	                  { className: 'panel-group custom-card', style: { marginBottom: '1rem' }, key: index },
	                  _react2.default.createElement(
	                    _reactstrap.CardHeader,
	                    { onClick: function onClick() {
	                        return _this3.toggle(index);
	                      }, 'data-event': index, className: 'custom-card-heading' },
	                    _react2.default.createElement(
	                      'b',
	                      null,
	                      item.category_name
	                    ),
	                    _react2.default.createElement(
	                      'small',
	                      null,
	                      item.sub_category_name ? ' - ' + item.sub_category_name : ''
	                    ),
	                    collapse !== index ? _react2.default.createElement(
	                      'span',
	                      { className: 'pull-right' },
	                      _react2.default.createElement('i', { 'class': 'fa fa-plus', 'aria-hidden': 'true' })
	                    ) : _react2.default.createElement(
	                      'span',
	                      { className: 'pull-right' },
	                      _react2.default.createElement('i', { 'class': 'fa fa-minus', 'aria-hidden': 'true' })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactstrap.Collapse,
	                    { isOpen: collapse === index },
	                    _react2.default.createElement(
	                      _reactstrap.CardBody,
	                      { className: 'panel-body' },
	                      _react2.default.createElement(
	                        'h3',
	                        { className: 'page-header' },
	                        item.organisation_name,
	                        ' ',
	                        _react2.default.createElement(
	                          'span',
	                          { style: { fontSize: "10px" } },
	                          _react2.default.createElement(
	                            'b',
	                            null,
	                            item.set_id == 3 ? "Branch" : ""
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'p',
	                        { className: 'mar-btm' },
	                        item.address
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'box-shadow-custom' },
	                        item.is_active == 0 ? _react2.default.createElement(
	                          'div',
	                          { className: 'row mar-btm' },
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'form-group col-md-12' },
	                            _react2.default.createElement(
	                              'h3',
	                              { className: 'text-center' },
	                              'Upgrade/Renewal to update the Data'
	                            )
	                          )
	                        ) : _react2.default.createElement(
	                          'div',
	                          { className: 'container' },
	                          (item.cid == 1 || item.cid == 2) && _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'form-group col-md-12' },
	                              _react2.default.createElement(
	                                'label',
	                                null,
	                                ' Admission Link'
	                              ),
	                              _react2.default.createElement('input', { name: 'admission_link', className: 'form-control', type: 'text', onChange: function onChange(e) {
	                                  return _this3.handleChange(e, index);
	                                }, value: item.admission_link }),
	                              _this3.validator.message('Admission Link', item.admission_link, 'required', { className: 'text-danger error-msg' })
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'form-group col-4' },
	                              _react2.default.createElement(
	                                'label',
	                                null,
	                                ' Average ',
	                                lbl_annual,
	                                ' Fees (INR) ',
	                                _react2.default.createElement(
	                                  'span',
	                                  { 'class': 'astrick' },
	                                  '*'
	                                )
	                              ),
	                              _react2.default.createElement('input', { name: 'average_fee', className: 'form-control', type: 'text', onChange: function onChange(e) {
	                                  return _this3.handleChange(e, index);
	                                }, value: item.average_fee }),
	                              _this3.validator.message('Average ' + lbl_annual + ' Fees', item.average_fee, 'required', { className: 'text - danger error - msg' })
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'form-group col-4' },
	                              _react2.default.createElement(
	                                'label',
	                                null,
	                                ' Recurring Fees (INR)'
	                              ),
	                              _react2.default.createElement('input', { name: 'recurring_fee', className: 'form-control', type: 'text', onChange: function onChange(e) {
	                                  return _this3.handleChange(e, index);
	                                }, value: item.recurring_fee }),
	                              _this3.validator.message('Recurring Fees', item.recurring_fee, 'required', { className: 'text-danger error-msg' })
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'form-group col-4' },
	                              _react2.default.createElement(
	                                'label',
	                                null,
	                                ' Application Fees (INR)'
	                              ),
	                              _react2.default.createElement('input', { name: 'application_fee', className: 'form-control', type: 'text', onChange: function onChange(e) {
	                                  return _this3.handleChange(e, index);
	                                }, value: item.application_fee }),
	                              _this3.validator.message('Application Fees', item.application_fee, 'required', { className: 'text-danger error-msg' })
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'form-group col-4' },
	                              _react2.default.createElement(
	                                'label',
	                                null,
	                                ' Other Fees (INR)'
	                              ),
	                              _react2.default.createElement('input', { name: 'other_fee', className: 'form-control', type: 'text', onChange: function onChange(e) {
	                                  return _this3.handleChange(e, index);
	                                }, value: item.other_fee }),
	                              _this3.validator.message('Other Fees', item.other_fee, 'required', { className: 'text-danger error-msg' })
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'form-group col-4' },
	                              _react2.default.createElement(
	                                'label',
	                                null,
	                                'Is Refundable (Application Fees) ',
	                                _react2.default.createElement(
	                                  'span',
	                                  { 'class': 'astrick' },
	                                  '*'
	                                )
	                              ),
	                              _react2.default.createElement('br', null),
	                              _react2.default.createElement('input', {
	                                type: 'radio',
	                                name: 'is_refund',
	                                checked: item.is_refund === '1',
	                                value: '1',
	                                onChange: function onChange(e) {
	                                  return _this3.handleChange(e, index);
	                                }
	                              }),
	                              ' Yes\xA0\xA0',
	                              _react2.default.createElement('input', {
	                                type: 'radio',
	                                name: 'is_refund',
	                                checked: item.is_refund === '2',
	                                value: '2',
	                                onChange: function onChange(e) {
	                                  return _this3.handleChange(e, index);
	                                }
	                              }),
	                              ' No \xA0\xA0\xA0'
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'form-group col-4' },
	                              _react2.default.createElement(
	                                'label',
	                                null,
	                                ' Required Documents'
	                              ),
	                              _react2.default.createElement(
	                                'select',
	                                {
	                                  className: 'form-control selectpicker',
	                                  multiple: true,
	                                  name: 'documents',
	                                  value: item.documents,
	                                  title: 'Select Documents',
	                                  onChange: function onChange(e) {
	                                    return _this3.documentHandleSelect(e, index);
	                                  } },
	                                dropdown.documents && dropdown.documents.map(function (val, i) {
	                                  return _react2.default.createElement(
	                                    'option',
	                                    { value: val.id, key: i },
	                                    val.document_name
	                                  );
	                                })
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'form-group col-4' },
	                              _react2.default.createElement(
	                                'label',
	                                null,
	                                ' Admission Process'
	                              ),
	                              _react2.default.createElement('textarea', { name: 'admission_process', className: 'form-control', type: 'text', onChange: function onChange(e) {
	                                  return _this3.handleChange(e, index);
	                                }, value: item.admission_process })
	                            )
	                          ),
	                          (item.cid == 4 || item.cid == 6 || item.cid == 8) && _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'form-group col-4' },
	                              _react2.default.createElement(
	                                'label',
	                                null,
	                                ' Average Fees (Monthly INR) ',
	                                _react2.default.createElement(
	                                  'span',
	                                  { 'class': 'astrick' },
	                                  '*'
	                                )
	                              ),
	                              _react2.default.createElement('input', { name: 'average_fee', className: 'form-control', type: 'text', onChange: function onChange(e) {
	                                  return _this3.handleChange(e, index);
	                                }, value: item.average_fee }),
	                              _this3.validator.message('Average ' + lbl_annual + ' Fees', item.average_fee, 'required | numeric', { className: 'text - danger error - msg' })
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'form-group col-4' },
	                              _react2.default.createElement(
	                                'label',
	                                null,
	                                ' Fees (INR)'
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'row' },
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'form-group col-md-6' },
	                                  _react2.default.createElement('input', { name: 'class_fee', className: 'form-control', type: 'text', onChange: function onChange(e) {
	                                      return _this3.handleChange(e, index);
	                                    }, value: item.class_fee })
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'form-group col-md-6' },
	                                  _react2.default.createElement(
	                                    'select',
	                                    {
	                                      value: item.class_fee_type,
	                                      onChange: function onChange(e) {
	                                        return _this3.handleChange(e, index);
	                                      }, className: 'form-control selectpicker',
	                                      name: 'class_fee_type',
	                                      title: 'Select' },
	                                    _react2.default.createElement(
	                                      'option',
	                                      { value: '1' },
	                                      'Per Class'
	                                    ),
	                                    _react2.default.createElement(
	                                      'option',
	                                      { value: '2' },
	                                      'Per Participant'
	                                    ),
	                                    _react2.default.createElement(
	                                      'option',
	                                      { value: '0' },
	                                      'NA'
	                                    )
	                                  )
	                                )
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'form-group col-4' },
	                              _react2.default.createElement(
	                                'label',
	                                null,
	                                ' Recurring Fees (INR)'
	                              ),
	                              _react2.default.createElement('input', { name: 'recurring_fee', className: 'form-control', type: 'text', onChange: function onChange(e) {
	                                  return _this3.handleChange(e, index);
	                                }, value: item.recurring_fee }),
	                              _this3.validator.message('Recurring Fees', item.recurring_fee, 'numeric', { className: 'text-danger error-msg' })
	                            )
	                          ),
	                          (item.cid == 3 || item.cid == 121) && _react2.default.createElement(
	                            'div',
	                            null,
	                            item.cid == 3 && _react2.default.createElement(
	                              'div',
	                              { 'class': 'form-group col-4' },
	                              _react2.default.createElement(
	                                'label',
	                                null,
	                                ' Average Fees (Monthly INR) ',
	                                _react2.default.createElement(
	                                  'span',
	                                  { 'class': 'astrick' },
	                                  '*'
	                                )
	                              ),
	                              _react2.default.createElement('input', { name: 'average_fee', className: 'form-control', type: 'text', onChange: function onChange(e) {
	                                  return _this3.handleChange(e, index);
	                                }, value: item.average_fee }),
	                              _this3.validator.message('Average ' + lbl_annual + ' Fees', item.average_fee, 'required | numeric', { className: 'text - danger error - msg' })
	                            ),
	                            item.cid == 121 && _react2.default.createElement(
	                              'div',
	                              { 'class': 'form-group col-4' },
	                              _react2.default.createElement(
	                                'label',
	                                null,
	                                ' Fees (INR)'
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'row' },
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'form-group col-md-6' },
	                                  _react2.default.createElement('input', { name: 'class_fee', className: 'form-control', type: 'text', onChange: function onChange(e) {
	                                      return _this3.handleChange(e, index);
	                                    }, value: item.class_fee })
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'form-group col-md-6' },
	                                  _react2.default.createElement(
	                                    'select',
	                                    {
	                                      value: item.class_fee_type,
	                                      onChange: function onChange(e) {
	                                        return _this3.handleChange(e, index);
	                                      }, className: 'form-control selectpicker',
	                                      name: 'class_fee_type',
	                                      title: 'Select' },
	                                    _react2.default.createElement(
	                                      'option',
	                                      { value: '1' },
	                                      'Per Class'
	                                    ),
	                                    _react2.default.createElement(
	                                      'option',
	                                      { value: '2' },
	                                      'Per Participant'
	                                    ),
	                                    _react2.default.createElement(
	                                      'option',
	                                      { value: '0' },
	                                      'NA'
	                                    )
	                                  )
	                                )
	                              )
	                            ),
	                            item.cid == 121 && _react2.default.createElement(
	                              'div',
	                              { 'class': 'form-group col-4' },
	                              _react2.default.createElement(
	                                'label',
	                                null,
	                                ' ',
	                                lbl_entry,
	                                ' (INR)'
	                              ),
	                              _react2.default.createElement('input', { name: 'average_fee', className: 'form-control', type: 'text', onChange: function onChange(e) {
	                                  return _this3.handleChange(e, index);
	                                }, value: item.average_fee }),
	                              _this3.validator.message(lbl_entry, item.average_fee, 'numeric', { className: 'text-danger error-msg' })
	                            )
	                          ),
	                          item.cid == 7 && _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'form-group col-4' },
	                              _react2.default.createElement(
	                                'label',
	                                null,
	                                ' Price Start From (INR)'
	                              ),
	                              _react2.default.createElement('input', { name: 'average_fee', className: 'form-control', type: 'text', onChange: function onChange(e) {
	                                  return _this3.handleChange(e, index);
	                                }, value: _this3.state.average_fee }),
	                              _this3.validator.message(lbl_entry, item.average_fee, 'numeric', { className: 'text-danger error-msg' })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'col-md-12 col-xs-12 btn-bdr text-right pad-hor-no mar-btm' },
	                            _react2.default.createElement(
	                              'button',
	                              { type: 'submit', id: 'btnSubmit',
	                                className: 'btn btn-primary btn-sm', disabled: _this3.state.btnDisabled },
	                              'Submit Admission info'
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            );
	          })
	        ),
	        _react2.default.createElement(_reactNotifications.NotificationContainer, null)
	      );
	    }
	  }, {
	    key: 'getDropData',
	    value: function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	        var documents, res1;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                documents = [];
	                _context2.next = 3;
	                return _FetchCall2.default.getSchoolListDatas('documents');
	
	              case 3:
	                res1 = _context2.sent;
	
	                if (res1.status === 1) {
	                  documents = res1.results;
	                }
	                this.setState({
	                  dropdown: {
	                    documents: documents
	                  }
	                });
	
	              case 6:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this);
	      }));
	
	      function getDropData() {
	        return _ref2.apply(this, arguments);
	      }
	
	      return getDropData;
	    }()
	  }]);
	
	  return Admission_other;
	}(_react.Component);
	
	exports.default = Admission_other;

/***/ },
/* 990 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FetchCall = __webpack_require__(4);
	
	var _FetchCall2 = _interopRequireDefault(_FetchCall);
	
	var _constant = __webpack_require__(21);
	
	var _simpleReactValidator = __webpack_require__(28);
	
	var _simpleReactValidator2 = _interopRequireDefault(_simpleReactValidator);
	
	var _multiselectReactDropdown = __webpack_require__(73);
	
	__webpack_require__(18);
	
	var _reactNotifications = __webpack_require__(16);
	
	var _reactstrap = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Keyinfo = function (_Component) {
	  _inherits(Keyinfo, _Component);
	
	  function Keyinfo(props) {
	    _classCallCheck(this, Keyinfo);
	
	    var _this = _possibleConstructorReturn(this, (Keyinfo.__proto__ || Object.getPrototypeOf(Keyinfo)).call(this, props));
	
	    _this.getKeywords = function () {
	      (0, _FetchCall.commonAPI)(JSON.stringify({ url: 'get_site_keywords' })).then(function (res) {
	        if (res.status === 1) {
	          _this.setState({
	            keywordsArr: res.results
	          });
	        }
	      });
	    };
	
	    _this.handleChange = function (e, index) {
	      var propName = e.target.name;
	      var propValue = e.target.value;
	      var page_data = _this.state.page_data;
	      page_data[index][propName] = propValue;
	      _this.setState({ page_data: page_data });
	    };
	
	    _this.handleSelectGradeFrom = function (e, index) {
	      var grade_from = parseInt(e.target.value);
	      var page_data = _this.state.page_data;
	      var grade_to = parseInt(page_data[index].grade_to);
	      if (grade_from >= grade_to) {
	        page_data[index]['grade_from'] = '';
	
	        _reactNotifications.NotificationManager.error('Grade to should be greater than grade from!');
	
	        return false;
	      } else {
	        page_data[index]['grade_from'] = grade_from;
	      }
	      _this.setState({ page_data: page_data });
	    };
	
	    _this.handleSelectGradeto = function (e, index) {
	      var page_data = _this.state.page_data;
	      var grade_from = parseInt(page_data[index].grade_from);
	      var grade_to = parseInt(e.target.value);
	      if (grade_to <= grade_from) {
	
	        page_data[index]['grade_to'] = '';
	
	        _reactNotifications.NotificationManager.error('Grade to should be greater than grade from!');
	      } else {
	        page_data[index]['grade_to'] = grade_to;
	      }
	      _this.setState({ page_data: page_data });
	    };
	
	    _this.handleSelect = function (e, i) {
	      var propName = e.target.name;
	      var value = [].concat(_toConsumableArray(e.target.selectedOptions)).map(function (item) {
	        return item.value;
	      });
	      var page_data = _this.state.page_data;
	      page_data[i][propName] = value;
	      _this.setState({ page_data: page_data });
	    };
	
	    _this.submitForm = function (e, i) {
	      e.preventDefault();
	      var page_data = _this.state.page_data;
	      _this.setState({
	        btnDisabled: true
	      });
	
	      var THIS = _this;
	      console.log('**', _this.validator.getErrorMessages());
	      if (_this.validator.allValid()) {
	        var _this$state$user_data = _this.state.user_data,
	            user_type = _this$state$user_data.user_type,
	            login_id = _this$state$user_data.login_id,
	            set_id = _this$state$user_data.set_id;
	
	        var request = JSON.stringify({
	          user_type: user_type,
	          login_id: login_id,
	          sid: set_id,
	          data: page_data[i],
	          active_status: _this.state.active_status,
	          url: 'updateKeyInfo'
	        });
	        (0, _FetchCall.partnerApi)(request).then(function (res) {
	
	          if (res.status === 1) {
	            //toastr = window.toastr.success;
	            _reactNotifications.NotificationManager.success(res.message);
	
	            _this.setState({
	              btnDisabled: false
	            });
	          } else {
	            //toastr = window.toastr.error;
	            _reactNotifications.NotificationManager.error(res.message);
	            _this.setState({
	              btnDisabled: false
	            });
	          }
	        });
	      } else {
	        _this.validator.showMessages();
	        _reactNotifications.NotificationManager.error("There are a few input fields blank, Please expand and fill the blank");
	        _this.forceUpdate();
	        setTimeout(function () {
	          THIS.setState({
	            checking: false
	          });
	        }, 500);
	      }
	    };
	
	    _this.state = {
	      user_data: localStorage.getItem('user_data') ? JSON.parse(localStorage.getItem('user_data')) : [],
	      authentication: localStorage.getItem('authentication') ? JSON.parse(localStorage.getItem('authentication')) : false,
	      user_type: 0,
	      main_access: '',
	      main_id: '',
	      dropdown: [],
	      access: [],
	      board_of_education: [], //drop
	      type_institute: [], //drop
	      school_type: [], //drop
	      education_system: [], //drop
	      playarea_type: [], //drop
	      camp_type: [], //drop
	      grade_from: [], //drop
	      grade_to: [], //drop
	      time_from: [], //drop
	      time_to: [], //drop
	      time_from_category: [], //drop
	      time_to_category: [], //drop
	      incharge_name: '',
	      teacher_count: '',
	      established_year: '',
	      instruction_language: '',
	      minimum_age: '',
	      has_scholarship: 0,
	      scholarship_desc: '',
	      has_trail: 0,
	      trail_desc: '',
	      facilities: [], //drop
	      learning_option: [], //drop
	      learning_type: [], //drop
	      class_frequency: [], //drop
	      noclass: '',
	      student_ratio: '',
	      contact_person: '',
	      facebook_name: '',
	      twitter_name: '',
	      when: '',
	      where: '',
	      registration_info: '',
	      hall_capacity: '',
	      dinning_hall_capacity: '',
	      car_parking: '',
	      two_parking: '',
	      operating_hrs: '',
	      food: '',
	      payment_type: [], //drop
	      cons_service: [], //drop
	      class_range: [],
	      designation: '',
	      cons_drop: false,
	      website: '',
	      website_keyword: '',
	      active_status: 0,
	      btnDisabled: true,
	      collapse: 0,
	      page_data: [],
	      keywordsArr: [],
	      checking: false
	    };
	    _this.validator = new _simpleReactValidator2.default({
	      validators: {
	        checkMobile: _constant.MOBILE_REGEX,
	        checkUrl: _constant.URL_REGEX
	      }
	    });
	    _this.toggle = _this.toggle.bind(_this);
	    _this.getDropData();_this.getKeyInfo();
	    return _this;
	  }
	
	  _createClass(Keyinfo, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      window.jQuery('.selectpicker').selectpicker('refresh');
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'getKeyInfo',
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var _this2 = this;
	
	        var _state$user_data, user_type, login_id, set_id, insdata, THIS;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _state$user_data = this.state.user_data, user_type = _state$user_data.user_type, login_id = _state$user_data.login_id, set_id = _state$user_data.set_id;
	                insdata = JSON.stringify({
	                  user_type: user_type,
	                  login_id: login_id,
	                  sid: set_id,
	                  url: 'getKeyInfoNew'
	                });
	                THIS = this;
	                _context.next = 5;
	                return (0, _FetchCall.partnerApi)(insdata).then(function (response) {
	                  if (response.status === 1) {
	                    _this2.setState({
	                      btnDisabled: false,
	                      checking: true,
	                      active_status: response.result.active_status,
	                      page_data: response.result.master_data
	                    });
	                    setTimeout(function () {
	                      THIS.setState({
	                        checking: false
	                      });
	                    }, 500);
	                  }
	                });
	
	              case 5:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function getKeyInfo() {
	        return _ref.apply(this, arguments);
	      }
	
	      return getKeyInfo;
	    }()
	  }, {
	    key: 'toggle',
	    value: function toggle(event) {
	      this.setState({
	        collapse: this.state.collapse === Number(event) ? -1 : Number(event)
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          access = _state.access,
	          dropdown = _state.dropdown,
	          cons_drop = _state.cons_drop,
	          user_type = _state.user_type,
	          collapse = _state.collapse,
	          page_data = _state.page_data;
	
	      this.validator.purgeFields();
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          'div',
	          { 'class': 'category_block' },
	          _react2.default.createElement(
	            'div',
	            { 'class': 'titleline' },
	            _react2.default.createElement(
	              'h4',
	              null,
	              'Key Information'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'eachblockgap' },
	            page_data.map(function (item, index) {
	              var ageLable = item.cid == 6 ? 'Teaching For Grades' : 'Min Age of Admission';
	              var learntypeLable = item.cid == 6 || item.cid == 8 ? 'Teacher Student Ratio' : 'Learning Option (Choose applicable)';
	              var learntypeLableOther = item.cid == 6 || item.cid == 8 ? 'Teacher Student Ratio' : 'Learning Option';
	              var keywords = item.website_keyword;
	              return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'form',
	                  { onSubmit: function onSubmit(e) {
	                      return _this3.submitForm(e, index);
	                    } },
	                  _react2.default.createElement(
	                    _reactstrap.Card,
	                    { className: 'panel-group custom-card', style: { marginBottom: '1rem' }, key: index },
	                    _react2.default.createElement(
	                      _reactstrap.CardHeader,
	                      { onClick: function onClick() {
	                          return _this3.toggle(index);
	                        }, 'data-event': index, className: 'custom-card-heading' },
	                      _react2.default.createElement(
	                        'b',
	                        null,
	                        item.category_name
	                      ),
	                      _react2.default.createElement(
	                        'small',
	                        null,
	                        item.sub_category_name ? ' - ' + item.sub_category_name : ''
	                      ),
	                      collapse !== index ? _react2.default.createElement(
	                        'span',
	                        { className: 'pull-right' },
	                        _react2.default.createElement('i', { 'class': 'fa fa-plus', 'aria-hidden': 'true' })
	                      ) : _react2.default.createElement(
	                        'span',
	                        { className: 'pull-right' },
	                        _react2.default.createElement('i', { 'class': 'fa fa-minus', 'aria-hidden': 'true' })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactstrap.Collapse,
	                      { isOpen: collapse === index },
	                      _react2.default.createElement(
	                        _reactstrap.CardBody,
	                        { className: 'panel-body' },
	                        _react2.default.createElement(
	                          'h3',
	                          { className: 'page-header' },
	                          item.organisation_name,
	                          ' ',
	                          _react2.default.createElement(
	                            'span',
	                            { style: { fontSize: "10px" } },
	                            _react2.default.createElement(
	                              'b',
	                              null,
	                              item.set_id == 3 ? "Branch" : ""
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'mar-btm' },
	                          item.address
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'box-shadow-custom' },
	                          item.is_active == 0 ? _react2.default.createElement(
	                            'div',
	                            { className: 'row mar-btm' },
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'form-group col-md-12' },
	                              _react2.default.createElement(
	                                'h3',
	                                { className: 'text-center' },
	                                'Upgrade/Renewal to update the Data'
	                              )
	                            )
	                          ) : _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            item.cid == 6 && _react2.default.createElement(
	                              'div',
	                              { 'class': 'form-group col-md-4' },
	                              _react2.default.createElement(
	                                'label',
	                                null,
	                                'Person Incharge'
	                              ),
	                              _react2.default.createElement('input', { name: 'incharge_name', className: 'form-control', type: 'text', onChange: function onChange(e) {
	                                  return _this3.handleChange(e, index);
	                                }, value: item.incharge_name }),
	                              _this3.validator.message('Person Incharge', item.incharge_name, 'alpha_space', { className: 'text-danger error-msg' })
	                            ),
	                            item.cid == 4 && item.fourthcat_list.length > 0 && _react2.default.createElement(
	                              'div',
	                              { 'class': 'form-group col-md-4' },
	                              _react2.default.createElement(
	                                'label',
	                                null,
	                                ' Sub Category ',
	                                _react2.default.createElement(
	                                  'span',
	                                  { 'class': 'astrick' },
	                                  '*'
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'select',
	                                {
	                                  className: 'form-control selectpicker',
	                                  multiple: true,
	                                  name: 'subtypes',
	                                  value: item.subtypes,
	                                  title: 'Select Sub Category',
	                                  onChange: function onChange(e) {
	                                    return _this3.handleSelect(e, index);
	                                  } },
	                                item.fourthcat_list && item.fourthcat_list.map(function (val, i) {
	                                  return _react2.default.createElement(
	                                    'option',
	                                    { value: val.category_id, key: i },
	                                    val.category_name,
	                                    ' (',
	                                    val.parent,
	                                    ')'
	                                  );
	                                })
	                              ),
	                              _this3.validator.message('Sub Category', item.subtypes, 'required', { className: 'text-danger error-msg' })
	                            ),
	                            (item.cid == 6 || item.cid == 1) && _react2.default.createElement(
	                              'div',
	                              { 'class': 'form-group col-md-4' },
	                              _react2.default.createElement(
	                                'label',
	                                null,
	                                ' Board of Education ',
	                                _react2.default.createElement(
	                                  'span',
	                                  { 'class': 'astrick' },
	                                  '*'
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'select',
	                                {
	                                  className: 'form-control selectpicker',
	                                  multiple: true,
	                                  name: 'board_of_education',
	                                  value: item.board_of_education,
	                                  title: 'Select Board Of Education',
	                                  onChange: function onChange(e) {
	                                    return _this3.handleSelect(e, index);
	                                  } },
	                                dropdown.board_of_education && dropdown.board_of_education.map(function (val, i) {
	                                  return _react2.default.createElement(
	                                    'option',
	                                    { value: val.id, key: i },
	                                    val.name
	                                  );
	                                })
	                              ),
	                              _this3.validator.message('Board Of Education', item.board_of_education, 'required', { className: 'text-danger error-msg' })
	                            ),
	                            item.cid == 1 && _react2.default.createElement(
	                              _react2.default.Fragment,
	                              null,
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'form-group col-md-4' },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  ' Campus Type ',
	                                  _react2.default.createElement(
	                                    'span',
	                                    { 'class': 'astrick' },
	                                    '*'
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'select',
	                                  {
	                                    className: 'form-control selectpicker',
	                                    multiple: true,
	                                    name: 'type_institute',
	                                    value: item.type_institute,
	                                    title: 'Select Campus Type',
	                                    onChange: function onChange(e) {
	                                      return _this3.handleSelect(e, index);
	                                    } },
	                                  dropdown.type_institute && dropdown.type_institute.map(function (val, i) {
	                                    return _react2.default.createElement(
	                                      'option',
	                                      { value: val.id, key: i },
	                                      val.name
	                                    );
	                                  })
	                                ),
	                                _this3.validator.message('Campus Type', item.type_institute, 'required', { className: 'text-danger error-msg' })
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'form-group col-md-4' },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  ' School Type ',
	                                  _react2.default.createElement(
	                                    'span',
	                                    { 'class': 'astrick' },
	                                    '*'
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'select',
	                                  {
	                                    className: 'form-control selectpicker',
	                                    name: 'school_type',
	                                    value: item.school_type,
	                                    title: 'Select School Type ',
	                                    onChange: function onChange(e) {
	                                      return _this3.handleSelect(e, index);
	                                    } },
	                                  dropdown.school_type && dropdown.school_type.map(function (val, i) {
	                                    return _react2.default.createElement(
	                                      'option',
	                                      { value: val.id, key: i },
	                                      val.type_name
	                                    );
	                                  })
	                                ),
	                                _this3.validator.message('School Type', item.school_type, 'required', { className: 'text-danger error-msg' })
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'form-group col-md-4' },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  ' Classfication'
	                                ),
	                                _react2.default.createElement(
	                                  'select',
	                                  {
	                                    className: 'form-control selectpicker',
	                                    name: 'education_system',
	                                    value: item.education_system,
	                                    title: 'Select Classfication',
	                                    onChange: function onChange(e) {
	                                      return _this3.handleSelect(e, index);
	                                    } },
	                                  dropdown.education_system && dropdown.education_system.map(function (val, i) {
	                                    return _react2.default.createElement(
	                                      'option',
	                                      { value: val.id, key: i },
	                                      val.name
	                                    );
	                                  })
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group col-md-4 input-group-cus to-separate' },
	                                _react2.default.createElement(
	                                  'div',
	                                  null,
	                                  _react2.default.createElement(
	                                    'label',
	                                    null,
	                                    'Grades ',
	                                    _react2.default.createElement(
	                                      'span',
	                                      { 'class': 'astrick' },
	                                      '*'
	                                    )
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'custom-select-drop dropdown' },
	                                    _react2.default.createElement(
	                                      'select',
	                                      {
	                                        className: 'form-control selectpicker',
	                                        name: 'grade_from',
	                                        value: item.grade_from,
	                                        title: 'Grade',
	                                        onChange: function onChange(e) {
	                                          return _this3.handleSelectGradeFrom(e, index);
	                                        } },
	                                      dropdown.grades && dropdown.grades.map(function (val, i) {
	                                        return _react2.default.createElement(
	                                          'option',
	                                          { value: val.id, key: i },
	                                          val.name
	                                        );
	                                      })
	                                    )
	                                  ),
	                                  _this3.validator.message('Grade', item.grade_from, 'required', { className: 'text-danger error-msg' })
	                                ),
	                                _react2.default.createElement(
	                                  'span',
	                                  { className: 'to' },
	                                  'to'
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  null,
	                                  _react2.default.createElement(
	                                    'label',
	                                    null,
	                                    '\xA0'
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'custom-select-drop dropdown' },
	                                    _react2.default.createElement(
	                                      'select',
	                                      {
	                                        className: 'form-control selectpicker',
	                                        name: 'grade_to',
	                                        value: item.grade_to,
	                                        title: 'Grade',
	                                        onChange: function onChange(e) {
	                                          return _this3.handleSelectGradeto(e, index);
	                                        } },
	                                      dropdown.grades && dropdown.grades.map(function (val, i) {
	                                        return _react2.default.createElement(
	                                          'option',
	                                          { value: val.id, key: i },
	                                          val.name
	                                        );
	                                      })
	                                    )
	                                  ),
	                                  _this3.validator.message('Grade', item.grade_to, 'required', { className: 'text-danger error-msg' })
	                                )
	                              )
	                            ),
	                            item.cid == 3 && _react2.default.createElement(
	                              'div',
	                              { 'class': 'form-group col-md-4' },
	                              _react2.default.createElement(
	                                'label',
	                                null,
	                                ' Catering To Age Group ',
	                                _react2.default.createElement(
	                                  'span',
	                                  { 'class': 'astrick' },
	                                  '*'
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'select',
	                                {
	                                  className: 'form-control selectpicker',
	                                  multiple: true,
	                                  name: 'playarea_type',
	                                  value: item.playarea_type,
	                                  title: 'Select Type',
	                                  onChange: function onChange(e) {
	                                    return _this3.handleSelect(e, index);
	                                  } },
	                                dropdown.playarea_type && dropdown.playarea_type.map(function (val, i) {
	                                  return _react2.default.createElement(
	                                    'option',
	                                    { value: val.id, key: i },
	                                    val.name
	                                  );
	                                })
	                              ),
	                              _this3.validator.message('Type', item.playarea_type, 'required', { className: 'text-danger error-msg' })
	                            ),
	                            item.cid == 121 && item.cons_drop == true && _react2.default.createElement(
	                              _react2.default.Fragment,
	                              null,
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'form-group col-md-4' },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  ' Designation ',
	                                  _react2.default.createElement(
	                                    'span',
	                                    { 'class': 'astrick' },
	                                    '*'
	                                  )
	                                ),
	                                _react2.default.createElement('input', { name: 'designation', className: 'form-control', type: 'text', onChange: function onChange(e) {
	                                    return _this3.handleChange(e, index);
	                                  }, value: item.designation }),
	                                _this3.validator.message('Designation', item.designation, 'required|alpha_space', { className: 'text-danger error-msg' })
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'form-group col-md-4' },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  ' Service ',
	                                  _react2.default.createElement(
	                                    'span',
	                                    { 'class': 'astrick' },
	                                    '*'
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'select',
	                                  {
	                                    className: 'form-control selectpicker',
	                                    multiple: true,
	                                    name: 'cons_service',
	                                    value: item.cons_service,
	                                    title: 'Select Type',
	                                    onChange: function onChange(e) {
	                                      return _this3.handleSelect(e, index);
	                                    } },
	                                  dropdown.cons_service && dropdown.cons_service.map(function (val, i) {
	                                    return _react2.default.createElement(
	                                      'option',
	                                      { value: val.id, key: i },
	                                      val.service
	                                    );
	                                  })
	                                ),
	                                _this3.validator.message('Service', item.cons_service, 'required', { className: 'text-danger error-msg' })
	                              )
	                            ),
	                            item.cid == 8 && _react2.default.createElement(
	                              'div',
	                              { 'class': 'form-group col-md-4' },
	                              _react2.default.createElement(
	                                'label',
	                                null,
	                                ' Type ',
	                                _react2.default.createElement(
	                                  'span',
	                                  { 'class': 'astrick' },
	                                  '*'
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'select',
	                                {
	                                  className: 'form-control selectpicker',
	                                  multiple: true,
	                                  name: 'camp_type',
	                                  value: item.camp_type,
	                                  title: 'Select Type',
	                                  onChange: function onChange(e) {
	                                    return _this3.handleSelect(e, index);
	                                  } },
	                                dropdown.camp_type && dropdown.camp_type.map(function (val, i) {
	                                  return _react2.default.createElement(
	                                    'option',
	                                    { value: val.id, key: i },
	                                    val.name
	                                  );
	                                })
	                              ),
	                              _this3.validator.message('Type', item.camp_type, 'required', { className: 'text-danger error-msg' })
	                            ),
	                            (item.cid == 1 || item.cid == 2 || item.cid == 3 || item.cid == 4 || item.cid == 6) && _react2.default.createElement(
	                              _react2.default.Fragment,
	                              null,
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group col-md-4 input-group-cus' },
	                                _react2.default.createElement(
	                                  'div',
	                                  null,
	                                  _react2.default.createElement(
	                                    'label',
	                                    null,
	                                    'From Time ',
	                                    _react2.default.createElement(
	                                      'span',
	                                      { 'class': 'astrick' },
	                                      '*'
	                                    )
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'custom-select-drop dropdown' },
	                                    _react2.default.createElement(
	                                      'select',
	                                      {
	                                        className: 'form-control selectpicker',
	                                        name: 'time_from',
	                                        value: item.time_from,
	                                        title: 'Time',
	                                        onChange: function onChange(e) {
	                                          return _this3.handleSelect(e, index);
	                                        } },
	                                      dropdown.timings && dropdown.timings.map(function (val, i) {
	                                        return _react2.default.createElement(
	                                          'option',
	                                          { value: val.id, key: i },
	                                          val.timing
	                                        );
	                                      })
	                                    )
	                                  ),
	                                  _this3.validator.message('Time', item.time_from, 'required', { className: 'text-danger error-msg' })
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  null,
	                                  _react2.default.createElement(
	                                    'label',
	                                    null,
	                                    '\xA0'
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'custom-select-drop dropdown' },
	                                    _react2.default.createElement(
	                                      'select',
	                                      {
	                                        name: 'time_from_category',
	                                        value: item.time_from_category,
	                                        onChange: function onChange(e) {
	                                          return _this3.handleSelect(e, index);
	                                        },
	                                        className: 'form-control selectpicker',
	                                        title: 'Select'
	                                      },
	                                      _react2.default.createElement(
	                                        'option',
	                                        { value: 'AM' },
	                                        'AM'
	                                      ),
	                                      _react2.default.createElement(
	                                        'option',
	                                        { value: 'PM' },
	                                        'PM'
	                                      )
	                                    )
	                                  ),
	                                  _this3.validator.message('Type', item.time_from_category, 'required', { className: 'text-danger error-msg' })
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group col-md-4 input-group-cus' },
	                                _react2.default.createElement(
	                                  'div',
	                                  null,
	                                  _react2.default.createElement(
	                                    'label',
	                                    null,
	                                    'To Time ',
	                                    _react2.default.createElement(
	                                      'span',
	                                      { 'class': 'astrick' },
	                                      '*'
	                                    )
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'custom-select-drop dropdown' },
	                                    _react2.default.createElement(
	                                      'select',
	                                      {
	                                        className: 'form-control selectpicker',
	                                        name: 'time_to',
	                                        value: item.time_to,
	                                        title: 'Time',
	                                        onChange: function onChange(e) {
	                                          return _this3.handleSelect(e, index);
	                                        } },
	                                      dropdown.timings && dropdown.timings.map(function (val, i) {
	                                        return _react2.default.createElement(
	                                          'option',
	                                          { value: val.id, key: i },
	                                          val.timing
	                                        );
	                                      })
	                                    )
	                                  ),
	                                  _this3.validator.message('Time', item.time_to, 'required', { className: 'text-danger error-msg' })
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  null,
	                                  _react2.default.createElement(
	                                    'label',
	                                    null,
	                                    '\xA0'
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'custom-select-drop dropdown' },
	                                    _react2.default.createElement(
	                                      'select',
	                                      {
	                                        name: 'time_to_category',
	                                        value: item.time_to_category,
	                                        onChange: function onChange(e) {
	                                          return _this3.handleSelect(e, index);
	                                        },
	                                        className: 'form-control selectpicker',
	                                        title: 'Select'
	                                      },
	                                      _react2.default.createElement(
	                                        'option',
	                                        { value: 'AM' },
	                                        'AM'
	                                      ),
	                                      _react2.default.createElement(
	                                        'option',
	                                        { value: 'PM', selected: true },
	                                        'PM'
	                                      )
	                                    )
	                                  ),
	                                  _this3.validator.message('Type', item.time_to_category, 'required', { className: 'text-danger error-msg' })
	                                )
	                              )
	                            ),
	                            (item.cid == 2 || item.cid == 3 || item.cid == 4 || item.cid == 6) && _react2.default.createElement(
	                              _react2.default.Fragment,
	                              null,
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'form-group col-md-4' },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  'No Of Teachers',
	                                  user_type != 2 && _react2.default.createElement(
	                                    'span',
	                                    { 'class': 'astrick' },
	                                    '*'
	                                  )
	                                ),
	                                _react2.default.createElement('input', { name: 'teacher_count', className: 'form-control', type: 'text', onChange: function onChange(e) {
	                                    return _this3.handleChange(e, index);
	                                  }, value: item.teacher_count }),
	                                user_type != 2 ? _this3.validator.message('No Of Teachers', item.teacher_count, 'required|alpha_num_dash_space', { className: 'text-danger error-msg' }) : _this3.validator.message('No Of Teachers', item.teacher_count, 'alpha_num_dash_space', { className: 'text-danger error-msg' })
	                              )
	                            ),
	                            (item.cid == 1 || item.cid == 2 || item.cid == 6 || item.cid == 7 || item.cid == 3 || item.cid == 4 || item.cid == 121) && _react2.default.createElement(
	                              _react2.default.Fragment,
	                              null,
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'form-group col-md-4' },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  ' Establishment Year ',
	                                  _react2.default.createElement(
	                                    'span',
	                                    { 'class': 'astrick' },
	                                    '*'
	                                  )
	                                ),
	                                _react2.default.createElement('input', { name: 'established_year', className: 'form-control', type: 'text', onChange: function onChange(e) {
	                                    return _this3.handleChange(e, index);
	                                  }, value: item.established_year }),
	                                _this3.validator.message('Establishment Year', item.established_year, 'required|numeric|min:4|max:4', { className: 'text-danger error-msg' })
	                              )
	                            ),
	                            (item.cid == 1 || item.cid == 6) && _react2.default.createElement(
	                              _react2.default.Fragment,
	                              null,
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'form-group col-md-4' },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  ' Instruction Languages ',
	                                  _react2.default.createElement(
	                                    'span',
	                                    { 'class': 'astrick' },
	                                    '*'
	                                  )
	                                ),
	                                _react2.default.createElement('input', { name: 'instruction_language', className: 'form-control', type: 'text', onChange: function onChange(e) {
	                                    return _this3.handleChange(e, index);
	                                  }, value: item.instruction_language }),
	                                _this3.validator.message('Instruction Languages', item.instruction_language, 'required|alpha_space', { className: 'text-danger error-msg' })
	                              )
	                            ),
	                            (item.cid == 1 || item.cid == 2 || item.cid == 4) && _react2.default.createElement(
	                              _react2.default.Fragment,
	                              null,
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'form-group col-md-4' },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  ' ',
	                                  ageLable,
	                                  ' ',
	                                  _react2.default.createElement(
	                                    'span',
	                                    { 'class': 'astrick' },
	                                    '*'
	                                  )
	                                ),
	                                _react2.default.createElement('input', { name: 'minimum_age', className: 'form-control', type: 'text', onChange: function onChange(e) {
	                                    return _this3.handleChange(e, index);
	                                  }, value: item.minimum_age }),
	                                _this3.validator.message(ageLable, item.minimum_age, 'required', { className: 'text-danger error-msg' })
	                              )
	                            ),
	                            item.cid == 6 && _react2.default.createElement(
	                              _react2.default.Fragment,
	                              null,
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'form-group col-md-4' },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  ' ',
	                                  ageLable,
	                                  ' ',
	                                  _react2.default.createElement(
	                                    'span',
	                                    { 'class': 'astrick' },
	                                    '*'
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'select',
	                                  { className: 'form-control selectpicker', title: 'Select Class Range', multiple: true,
	                                    value: item.minimum_age, name: 'minimum_age',
	                                    onChange: function onChange(e) {
	                                      return _this3.handleSelect(e, index);
	                                    } },
	                                  dropdown.getTuitionCls && dropdown.getTuitionCls.map(function (item, i) {
	                                    return _react2.default.createElement(
	                                      'option',
	                                      { value: item.id },
	                                      item.name
	                                    );
	                                  })
	                                ),
	                                _this3.validator.message(ageLable, item.minimum_age, 'required', { className: 'text-danger error-msg' })
	                              )
	                            ),
	                            (item.cid == 1 || item.cid == 2 || item.cid == 3) && _react2.default.createElement(
	                              'div',
	                              { 'class': 'form-group col-md-4' },
	                              _react2.default.createElement(
	                                'label',
	                                null,
	                                ' Amenities ',
	                                _react2.default.createElement(
	                                  'span',
	                                  { 'class': 'astrick' },
	                                  '*'
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'select',
	                                {
	                                  className: 'form-control selectpicker',
	                                  multiple: true,
	                                  name: 'facilities',
	                                  value: item.facilities,
	                                  title: 'Select Amenities',
	                                  onChange: function onChange(e) {
	                                    return _this3.handleSelect(e, index);
	                                  } },
	                                dropdown.facilities && dropdown.facilities.map(function (val, i) {
	                                  return _react2.default.createElement(
	                                    'option',
	                                    { value: val.id, key: i },
	                                    val.facility
	                                  );
	                                })
	                              ),
	                              _this3.validator.message('Amenities', item.facilities, 'required', { className: 'text-danger error-msg' })
	                            ),
	                            item.cid == 1 && _react2.default.createElement(
	                              'div',
	                              { 'class': 'form-group col-md-4' },
	                              _react2.default.createElement(
	                                'label',
	                                null,
	                                ' Teacher Student Ratio ',
	                                _react2.default.createElement(
	                                  'span',
	                                  { 'class': 'astrick' },
	                                  '*'
	                                )
	                              ),
	                              _react2.default.createElement('input', { name: 'student_ratio', className: 'form-control', type: 'text', onChange: function onChange(e) {
	                                  return _this3.handleChange(e, index);
	                                }, value: item.student_ratio }),
	                              _this3.validator.message('Teacher Student Ratio', item.student_ratio, 'required', { className: 'text-danger error-msg' })
	                            ),
	                            (item.cid == 4 || item.cid == 6 || item.cid == 8) && _react2.default.createElement(
	                              _react2.default.Fragment,
	                              null,
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'form-group col-md-4' },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  ' ',
	                                  learntypeLable,
	                                  ' ',
	                                  !access.includes('8') && _react2.default.createElement(
	                                    'span',
	                                    { 'class': 'astrick' },
	                                    '*'
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'select',
	                                  {
	                                    className: 'form-control selectpicker',
	                                    multiple: true,
	                                    name: 'learning_option',
	                                    value: item.learning_option,
	                                    title: 'Select ' + learntypeLableOther,
	                                    onChange: function onChange(e) {
	                                      return _this3.handleSelect(e, index);
	                                    } },
	                                  dropdown.learning_option && dropdown.learning_option.map(function (val, i) {
	                                    return _react2.default.createElement(
	                                      'option',
	                                      { value: val.id, key: i },
	                                      val.name
	                                    );
	                                  })
	                                ),
	                                !access.includes('8') && _this3.validator.message(learntypeLableOther, item.learning_option, 'required', { className: 'text-danger error-msg' })
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'form-group col-md-4' },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  ' Learning Location ',
	                                  _react2.default.createElement(
	                                    'span',
	                                    { 'class': 'astrick' },
	                                    '*'
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'select',
	                                  {
	                                    className: 'form-control selectpicker',
	                                    multiple: true,
	                                    name: 'learning_type',
	                                    value: item.learning_type,
	                                    title: 'Select Learning Location',
	                                    onChange: function onChange(e) {
	                                      return _this3.handleSelect(e, index);
	                                    } },
	                                  dropdown.learning_type && dropdown.learning_type.map(function (val, i) {
	                                    return _react2.default.createElement(
	                                      'option',
	                                      { value: val.id, key: i },
	                                      val.name
	                                    );
	                                  })
	                                ),
	                                _this3.validator.message('Learning Location', item.learning_type, 'required', { className: 'text-danger error-msg' })
	                              )
	                            ),
	                            (item.cid == 4 || item.cid == 6) && _react2.default.createElement(
	                              _react2.default.Fragment,
	                              null,
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'form-group col-md-4' },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  ' Class Frequency ',
	                                  _react2.default.createElement(
	                                    'span',
	                                    { 'class': 'astrick' },
	                                    '*'
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'select',
	                                  {
	                                    multiple: true,
	                                    className: 'form-control selectpicker',
	                                    name: 'class_frequency',
	                                    value: item.class_frequency,
	                                    title: 'Select Class Frequency',
	                                    onChange: function onChange(e) {
	                                      return _this3.handleSelect(e, index);
	                                    } },
	                                  dropdown.class_frequency && dropdown.class_frequency.map(function (val, i) {
	                                    return _react2.default.createElement(
	                                      'option',
	                                      { value: val.id, key: i },
	                                      val.freq_name
	                                    );
	                                  })
	                                ),
	                                _this3.validator.message('Class Frequency', item.class_frequency, 'required', { className: 'text-danger error-msg' })
	                              )
	                            ),
	                            (item.cid == 7 || item.cid == 8) && _react2.default.createElement(
	                              _react2.default.Fragment,
	                              null,
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'form-group col-md-4' },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  ' Contact Person ',
	                                  _react2.default.createElement(
	                                    'span',
	                                    { 'class': 'astrick' },
	                                    '*'
	                                  )
	                                ),
	                                _react2.default.createElement('input', { name: 'contact_person', className: 'form-control', type: 'text', onChange: function onChange(e) {
	                                    return _this3.handleChange(e, index);
	                                  }, value: item.contact_person }),
	                                _this3.validator.message('Contact Person', item.contact_person, 'required', { className: 'text-danger error-msg' })
	                              )
	                            ),
	                            (item.cid == 4 || item.cid == 6 || item.cid == 7 || item.cid == 8 || item.cid == 121) && _react2.default.createElement(
	                              _react2.default.Fragment,
	                              null,
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'form-group col-md-4' },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  ' No of Class/Month ',
	                                  _react2.default.createElement(
	                                    'span',
	                                    { 'class': 'astrick' },
	                                    '*'
	                                  )
	                                ),
	                                _react2.default.createElement('input', { name: 'noclass', className: 'form-control', type: 'text', onChange: function onChange(e) {
	                                    return _this3.handleChange(e, index);
	                                  }, value: item.noclass }),
	                                _this3.validator.message('No of Class', item.noclass, '', { className: 'text-danger error-msg' })
	                              )
	                            ),
	                            item.cid == 8 && _react2.default.createElement(
	                              _react2.default.Fragment,
	                              null,
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'form-group col-md-4' },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  ' When (Date) ',
	                                  _react2.default.createElement(
	                                    'span',
	                                    { 'class': 'astrick' },
	                                    '*'
	                                  )
	                                ),
	                                _react2.default.createElement('input', { name: 'when', className: 'form-control', type: 'text', onChange: function onChange(e) {
	                                    return _this3.handleChange(e, index);
	                                  }, value: item.when }),
	                                _this3.validator.message('When', item.when, 'required|alpha_num_space', { className: 'text-danger error-msg' })
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'form-group col-md-4' },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  ' Where ',
	                                  _react2.default.createElement(
	                                    'span',
	                                    { 'class': 'astrick' },
	                                    '*'
	                                  )
	                                ),
	                                _react2.default.createElement('input', { name: 'where', className: 'form-control', type: 'text', onChange: function onChange(e) {
	                                    return _this3.handleChange(e, index);
	                                  }, value: item.where }),
	                                _this3.validator.message('Where', item.where, 'required', { className: 'text-danger error-msg' })
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'form-group col-md-4' },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  ' Registration Info (Email ID) ',
	                                  _react2.default.createElement(
	                                    'span',
	                                    { 'class': 'astrick' },
	                                    '*'
	                                  )
	                                ),
	                                _react2.default.createElement('input', { name: 'registration_info', className: 'form-control', type: 'text', onChange: function onChange(e) {
	                                    return _this3.handleChange(e, index);
	                                  }, value: item.registration_info }),
	                                _this3.validator.message('Registration Info ', item.registration_info, 'required', { className: 'text-danger error-msg' })
	                              )
	                            ),
	                            item.cid == 7 && _react2.default.createElement(
	                              _react2.default.Fragment,
	                              null,
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'form-group col-md-4' },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  'Hall Capacity'
	                                ),
	                                _react2.default.createElement('input', { name: 'hall_capacity', className: 'form-control', type: 'text', onChange: function onChange(e) {
	                                    return _this3.handleChange(e, index);
	                                  }, value: item.hall_capacity }),
	                                _this3.validator.message('Hall Capacity', item.hall_capacity, 'alpha_num_space', { className: 'text-danger error-msg' })
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'form-group col-md-4' },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  'Dinning Hall Capacity'
	                                ),
	                                _react2.default.createElement('input', { name: 'dinning_hall_capacity', className: 'form-control', type: 'text', onChange: function onChange(e) {
	                                    return _this3.handleChange(e, index);
	                                  }, value: item.dinning_hall_capacity }),
	                                _this3.validator.message('Dinning Hall Capacity', item.dinning_hall_capacity, 'alpha_num_space', { className: 'text-danger error-msg' })
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'form-group col-md-4' },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  'Car Parking '
	                                ),
	                                _react2.default.createElement('input', { name: 'car_parking', className: 'form-control', type: 'text', onChange: function onChange(e) {
	                                    return _this3.handleChange(e, index);
	                                  }, value: item.car_parking }),
	                                _this3.validator.message('Car Parking', item.car_parking, 'alpha_num_space', { className: 'text-danger error-msg' })
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'form-group col-md-4' },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  'Two Wheeler Parking'
	                                ),
	                                _react2.default.createElement('input', { name: 'two_parking', className: 'form-control', type: 'text', onChange: function onChange(e) {
	                                    return _this3.handleChange(e, index);
	                                  }, value: item.two_parking }),
	                                _this3.validator.message('Two Wheeler Parking', item.two_parking, 'alpha_num_space', { className: 'text-danger error-msg' })
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'form-group col-md-4' },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  'Operating Hours '
	                                ),
	                                _react2.default.createElement('input', { name: 'operating_hrs', className: 'form-control', type: 'text', onChange: function onChange(e) {
	                                    return _this3.handleChange(e, index);
	                                  }, value: item.operating_hrs }),
	                                _this3.validator.message('Operating Hours', item.operating_hrs, 'alpha_num_space', { className: 'text-danger error-msg' })
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'form-group col-md-4' },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  'Type of Food Served ',
	                                  _react2.default.createElement(
	                                    'span',
	                                    { 'class': 'astrick' },
	                                    '*'
	                                  )
	                                ),
	                                _react2.default.createElement('input', { name: 'food', className: 'form-control', type: 'text', onChange: function onChange(e) {
	                                    return _this3.handleChange(e, index);
	                                  }, value: item.food }),
	                                _this3.validator.message('Food ', item.food, 'required|alpha_num_space', { className: 'text-danger error-msg' })
	                              )
	                            ),
	                            (item.cid == 7 || item.cid == 121) && _react2.default.createElement(
	                              _react2.default.Fragment,
	                              null,
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'form-group col-md-4' },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  ' Mode of Payment ',
	                                  _react2.default.createElement(
	                                    'span',
	                                    { 'class': 'astrick' },
	                                    '*'
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'select',
	                                  {
	                                    className: 'form-control selectpicker',
	                                    name: 'payment_type',
	                                    value: item.payment_type,
	                                    title: 'Select Payment',
	                                    onChange: function onChange(e) {
	                                      return _this3.handleSelect(e, index);
	                                    } },
	                                  dropdown.payment_type && dropdown.payment_type.map(function (val, i) {
	                                    return _react2.default.createElement(
	                                      'option',
	                                      { value: val.id, key: i },
	                                      val.payment_name
	                                    );
	                                  })
	                                ),
	                                _this3.validator.message('Mode of Payment', item.payment_type, 'required', { className: 'text-danger error-msg' })
	                              )
	                            ),
	                            item.cid == 1 && _react2.default.createElement(
	                              _react2.default.Fragment,
	                              null,
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'form-group col-md-4' },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  ' Is Scholarship Avail ',
	                                  _react2.default.createElement(
	                                    'span',
	                                    { 'class': 'astrick' },
	                                    '*'
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'select',
	                                  {
	                                    className: 'form-control selectpicker',
	                                    name: 'has_scholarship',
	                                    value: item.has_scholarship,
	                                    title: 'Select',
	                                    onChange: function onChange(e) {
	                                      return _this3.handleSelect(e, index);
	                                    } },
	                                  _react2.default.createElement(
	                                    'option',
	                                    { value: '0' },
	                                    'NA'
	                                  ),
	                                  _react2.default.createElement(
	                                    'option',
	                                    { value: '1' },
	                                    'Yes'
	                                  ),
	                                  _react2.default.createElement(
	                                    'option',
	                                    { value: '2' },
	                                    'No'
	                                  )
	                                ),
	                                _this3.validator.message('Scholarship', item.has_scholarship, 'required', { className: 'text-danger error-msg' })
	                              ),
	                              item.has_scholarship == 1 && _react2.default.createElement(
	                                'div',
	                                { 'class': 'form-group col-md-4' },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  ' Scholarship Description ',
	                                  _react2.default.createElement(
	                                    'span',
	                                    { 'class': 'astrick' },
	                                    '*'
	                                  )
	                                ),
	                                _react2.default.createElement('textarea', { className: 'form-control', name: 'scholarship_desc', onChange: function onChange(e) {
	                                    return _this3.handleChange(e, index);
	                                  }, value: item.scholarship_desc }),
	                                _this3.validator.message('Scholarship Descrption', item.scholarship_desc, 'required', { className: 'text-danger error-msg' })
	                              )
	                            ),
	                            (item.cid == 4 || item.cid == 2 || item.cid == 6 || item.cid == 8) && _react2.default.createElement(
	                              _react2.default.Fragment,
	                              null,
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'form-group col-md-4' },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  ' Is Free Trial Class Avail ',
	                                  _react2.default.createElement(
	                                    'span',
	                                    { 'class': 'astrick' },
	                                    '*'
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'select',
	                                  {
	                                    className: 'form-control selectpicker',
	                                    name: 'has_trail',
	                                    value: item.has_trail,
	                                    title: 'Select',
	                                    onChange: function onChange(e) {
	                                      return _this3.handleSelect(e, index);
	                                    } },
	                                  _react2.default.createElement(
	                                    'option',
	                                    { value: '0' },
	                                    'NA'
	                                  ),
	                                  _react2.default.createElement(
	                                    'option',
	                                    { value: '1' },
	                                    'Yes'
	                                  ),
	                                  _react2.default.createElement(
	                                    'option',
	                                    { value: '2' },
	                                    'No'
	                                  )
	                                ),
	                                _this3.validator.message('Free Trail', item.has_trail, 'required', { className: 'text-danger error-msg' })
	                              ),
	                              item.has_trail == 1 && item.cid != 2 && _react2.default.createElement(
	                                'div',
	                                { 'class': 'form-group col-md-4' },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  ' Free Trail Description ',
	                                  _react2.default.createElement(
	                                    'span',
	                                    { 'class': 'astrick' },
	                                    '*'
	                                  )
	                                ),
	                                _react2.default.createElement('textarea', { className: 'form-control', name: 'trail_desc', onChange: function onChange(e) {
	                                    return _this3.handleChange(e, index);
	                                  }, value: item.trail_desc }),
	                                _this3.validator.message('Free Trail Descrption', item.trail_desc, 'required', { className: 'text-danger error-msg' })
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'form-group col-md-4' },
	                              _react2.default.createElement(
	                                'label',
	                                null,
	                                'Website'
	                              ),
	                              _react2.default.createElement('input', { name: 'website', className: 'form-control', type: 'text', onChange: function onChange(e) {
	                                  return _this3.handleChange(e, index);
	                                }, value: item.website }),
	                              _this3.validator.message('Website', item.website, 'checkUrl', { className: 'text-danger error-msg' })
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'col-md-12 col-xs-12 btn-bdr text-right pad-hor-no mar-btm' },
	                              _react2.default.createElement(
	                                'button',
	                                { type: 'submit', id: 'btnSubmit',
	                                  className: 'btn btn-primary btn-sm' },
	                                'Submit Key info'
	                              )
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              );
	            })
	          )
	        ),
	        _react2.default.createElement(_reactNotifications.NotificationContainer, null)
	      );
	    }
	  }, {
	    key: 'getDropData',
	    value: function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	        var board_of_education, type_institute, school_type, education_system, grades, timings, facilities, playarea_type, learning_option, getTuitionCls, learning_type, class_frequency, camp_type, payment_type, cons_service, res1, res2, res3, res4, res5, res6, res7, res8, res9, res10, res11, res12, res13, res14, res15;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                board_of_education = [], type_institute = [], school_type = [], education_system = [], grades = [], timings = [], facilities = [], playarea_type = [], learning_option = [], getTuitionCls = [], learning_type = [], class_frequency = [], camp_type = [], payment_type = [], cons_service = [];
	                _context2.next = 3;
	                return _FetchCall2.default.getSchoolListDatas('curriculum');
	
	              case 3:
	                res1 = _context2.sent;
	
	                if (res1.status === 1) {
	                  board_of_education = res1.results;
	                }
	                _context2.next = 7;
	                return _FetchCall2.default.getSchoolListDatas('type');
	
	              case 7:
	                res2 = _context2.sent;
	
	                if (res2.status === 1) {
	                  type_institute = res2.results;
	                }
	                _context2.next = 11;
	                return _FetchCall2.default.getSchoolListDatas('school_type');
	
	              case 11:
	                res3 = _context2.sent;
	
	                if (res3.status === 1) {
	                  school_type = res3.results;
	                }
	                _context2.next = 15;
	                return _FetchCall2.default.getSchoolListDatas('education_system');
	
	              case 15:
	                res4 = _context2.sent;
	
	                if (res4.status === 1) {
	                  education_system = res4.results;
	                }
	                _context2.next = 19;
	                return _FetchCall2.default.getSchoolListDatas('grade');
	
	              case 19:
	                res5 = _context2.sent;
	
	                if (res5.status === 1) {
	                  grades = res5.results;
	                }
	                _context2.next = 23;
	                return _FetchCall2.default.getSchoolListDatas('timing');
	
	              case 23:
	                res6 = _context2.sent;
	
	                if (res6.status === 1) {
	                  timings = res6.results;
	                }
	                _context2.next = 27;
	                return _FetchCall2.default.getSchoolListDatas('facilities');
	
	              case 27:
	                res7 = _context2.sent;
	
	                if (res7.status === 1) {
	                  facilities = res7.results;
	                }
	                _context2.next = 31;
	                return _FetchCall2.default.getSchoolListDatas('play_age');
	
	              case 31:
	                res8 = _context2.sent;
	
	                if (res8.status === 1) {
	                  playarea_type = res8.results;
	                }
	                _context2.next = 35;
	                return _FetchCall2.default.getSchoolListDatas('std_ratio');
	
	              case 35:
	                res9 = _context2.sent;
	
	                if (res9.status === 1) {
	                  learning_option = res9.results;
	                }
	                _context2.next = 39;
	                return _FetchCall2.default.getSchoolListDatas('tution_type');
	
	              case 39:
	                res10 = _context2.sent;
	
	                if (res10.status === 1) {
	                  learning_type = res10.results;
	                }
	                _context2.next = 43;
	                return _FetchCall2.default.getSchoolListDatas('class_frequency');
	
	              case 43:
	                res11 = _context2.sent;
	
	                if (res11.status === 1) {
	                  class_frequency = res11.results;
	                }
	                _context2.next = 47;
	                return _FetchCall2.default.getSchoolListDatas('age_group');
	
	              case 47:
	                res12 = _context2.sent;
	
	                if (res12.status === 1) {
	                  camp_type = res12.results;
	                }
	                _context2.next = 51;
	                return _FetchCall2.default.getSchoolListDatas('payment_type');
	
	              case 51:
	                res13 = _context2.sent;
	
	                if (res13.status === 1) {
	                  payment_type = res13.results;
	                }
	                _context2.next = 55;
	                return _FetchCall2.default.getSchoolListDatas('services');
	
	              case 55:
	                res14 = _context2.sent;
	
	                if (res14.status === 1) {
	                  cons_service = res14.results;
	                }
	                _context2.next = 59;
	                return _FetchCall2.default.getSchoolListDatas('tuition_cls');
	
	              case 59:
	                res15 = _context2.sent;
	
	                if (res15.status === 1) {
	                  getTuitionCls = res15.results;
	                }
	                this.setState({
	                  dropdown: {
	                    board_of_education: board_of_education,
	                    type_institute: type_institute,
	                    school_type: school_type,
	                    education_system: education_system,
	                    grades: grades,
	                    timings: timings,
	                    facilities: facilities,
	                    playarea_type: playarea_type,
	                    learning_option: learning_option,
	                    learning_type: learning_type,
	                    class_frequency: class_frequency,
	                    camp_type: camp_type,
	                    payment_type: payment_type,
	                    cons_service: cons_service,
	                    getTuitionCls: getTuitionCls
	                  }
	                });
	
	              case 62:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this);
	      }));
	
	      function getDropData() {
	        return _ref2.apply(this, arguments);
	      }
	
	      return getDropData;
	    }()
	  }]);
	
	  return Keyinfo;
	}(_react.Component);
	
	exports.default = Keyinfo;

/***/ },
/* 991 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var mobilemenuiconfolder = '/assets/images/bottom-menu/';
	var menuionsfolder = '/assets/dashboard/';
	var MAINMENU = exports.MAINMENU = [{
	    menu_name: 'Update Profile',
	    menu_link: '/update_profile',
	    menu_icon: menuionsfolder + 'updateprofile.svg'
	}, {
	    menu_name: 'Subscription Info',
	    menu_link: '/subscription',
	    menu_icon: menuionsfolder + 'payment method.svg'
	}, {
	    menu_name: 'Contact Us',
	    menu_link: 'javascript:;',
	    contact_pop: true,
	    menu_icon: menuionsfolder + 'contactus.svg'
	}, {
	    menu_name: 'Leads',
	    menu_link: '/partnerviewleads',
	    contact_pop: false,
	    menu_icon: menuionsfolder + 'leads.png'
	}];
	var SECONDMENU = exports.SECONDMENU = [{
	    menu_name: 'Account Info',
	    menu_link: '/homepage'
	}, {
	    menu_name: 'Branch – Add/View',
	    menu_link: '/branch',
	    isbranch: true
	}, {
	    menu_name: 'Dashboard',
	    menu_link: '/dashboards'
	}, {
	    menu_name: 'Reports',
	    menu_link: '/reports'
	}, {
	    menu_name: 'Parent Feedback and Interactions',
	    menu_link: '/review'
	}, {
	    menu_name: 'Latest News',
	    menu_link: '/news'
	}, {
	    menu_name: 'Exclusive Partnerships',
	    menu_link: '/exclusive_partnerships'
	}, {
	    menu_name: 'Benchmarking',
	    menu_link: '/bench_mark'
	}, {
	    menu_name: 'Job Posting',
	    menu_link: '/job_posting'
	}];
	var MOBILEMENU = exports.MOBILEMENU = [{
	    menu_name: 'Account Info',
	    menu_link: '/homepage',
	    isbranch: true,
	    menu_icon: mobilemenuiconfolder + 'btm-mn-account.png',
	    menu_icon_active: mobilemenuiconfolder + 'btm-mn-dark-account.png'
	}, {
	    menu_name: 'Dashboard',
	    menu_link: '/dashboards',
	    menu_icon: mobilemenuiconfolder + 'btm-mn-dashboard.png',
	    menu_icon_active: mobilemenuiconfolder + 'btm-mn-dark-dashboard.png'
	}, {
	    menu_name: 'Review',
	    menu_link: '/review',
	    menu_icon: mobilemenuiconfolder + 'btm-mn-feedback.png',
	    menu_icon_active: mobilemenuiconfolder + 'btm-mn-dark-feedback.png'
	}, {
	    menu_name: 'Benchmarking',
	    menu_link: '/bench_mark',
	    menu_icon: mobilemenuiconfolder + 'btm-mn-benchmarking.png',
	    menu_icon_active: mobilemenuiconfolder + 'btm-mn-dark-benchmarking.png'
	}, {
	    menu_name: 'Branch – Add/View',
	    menu_link: '/branch',
	    isbranch: true,
	    menu_icon: mobilemenuiconfolder + 'btm-mn-branch.png',
	    menu_icon_active: mobilemenuiconfolder + 'btm-mn-dark-branch.png'
	}, {
	    menu_name: 'Report',
	    menu_link: '/reports',
	    menu_icon: mobilemenuiconfolder + 'btm-mn-reports.png',
	    menu_icon_active: mobilemenuiconfolder + 'btm-mn-dark-reports.png'
	}, {
	    menu_name: 'Latest News',
	    menu_link: '/news',
	    menu_icon: mobilemenuiconfolder + 'btm-mn-newsarticles.png',
	    menu_icon_active: mobilemenuiconfolder + 'btm-mn-dark-news.png'
	}, {
	    menu_name: 'Excl Partnerships',
	    menu_link: '/exclusive_partnerships',
	    menu_icon: mobilemenuiconfolder + 'btm-mn-exclpartner.png',
	    menu_icon_active: mobilemenuiconfolder + 'btm-mn-dark-exclpartner.png'
	}, {
	    menu_name: 'Job Posting',
	    menu_link: '/job_posting',
	    menu_icon: mobilemenuiconfolder + 'btm-mn-jobposting.png',
	    menu_icon_active: mobilemenuiconfolder + 'btm-mn-dark-jobposting.png'
	}];
	var SECONDMENUMOB = exports.SECONDMENUMOB = [{
	    menu_name: 'Update Profile',
	    menu_link: '/update_profile'
	}, {
	    menu_name: 'Subscription Info',
	    menu_link: '/subscription'
	}, {
	    menu_name: 'Contact Us',
	    menu_link: 'javascript:;',
	    contact_pop: true
	}, {
	    menu_name: 'Log out',
	    menu_link: 'javascript:;',
	    logout: true
	}];

/***/ },
/* 992 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _reactDataTableComponent = __webpack_require__(53);
	
	var _reactDataTableComponent2 = _interopRequireDefault(_reactDataTableComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var $ = __webpack_require__(5);
	
	//$.DataTable = require('datatables.net')
	
	var partnerPaymentLinks = function (_Component) {
	    _inherits(partnerPaymentLinks, _Component);
	
	    function partnerPaymentLinks(props) {
	        var _this2 = this;
	
	        _classCallCheck(this, partnerPaymentLinks);
	
	        var _this = _possibleConstructorReturn(this, (partnerPaymentLinks.__proto__ || Object.getPrototypeOf(partnerPaymentLinks)).call(this, props));
	
	        _this.exportExcel = function (e) {
	            _this.transactionExport();
	        };
	
	        _this.transactionExport = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	            var res;
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            _context.prev = 0;
	                            _context.next = 3;
	                            return (0, _FetchCall.transactionExport)();
	
	                        case 3:
	                            res = _context.sent;
	
	                            if (res.status == 1) {
	                                window.open(res.path);
	                                // window.location.href(res.path)
	                            }
	                            _context.next = 10;
	                            break;
	
	                        case 7:
	                            _context.prev = 7;
	                            _context.t0 = _context['catch'](0);
	
	                            _this.setState({ error: true });
	
	                        case 10:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, _this2, [[0, 7]]);
	        }));
	        _this.UserDataList = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	            var req, res;
	            return _regenerator2.default.wrap(function _callee2$(_context2) {
	                while (1) {
	                    switch (_context2.prev = _context2.next) {
	                        case 0:
	                            _context2.prev = 0;
	                            req = JSON.stringify({ role: 1 });
	                            _context2.next = 4;
	                            return (0, _FetchCall.getRazorPayTransactionList)(req);
	
	                        case 4:
	                            res = _context2.sent;
	
	                            if (res.status == 1) {
	                                console.log('location_list', res.list);
	                                _this.datatabledata(res.list);
	                            }
	
	                            _context2.next = 11;
	                            break;
	
	                        case 8:
	                            _context2.prev = 8;
	                            _context2.t0 = _context2['catch'](0);
	
	                            _this.setState({ error: true });
	
	                        case 11:
	                        case 'end':
	                            return _context2.stop();
	                    }
	                }
	            }, _callee2, _this2, [[0, 8]]);
	        }));
	
	        _this.state = {
	            logged: localStorage.getItem("authentication"),
	            auth_data: JSON.parse(localStorage.getItem("user_data")),
	            dataSet: []
	        };
	        return _this;
	    }
	
	    _createClass(partnerPaymentLinks, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	
	            this.UserDataList();
	        }
	    }, {
	        key: 'datatabledata',
	        value: function datatabledata(data) {
	
	            console.log('data', data);
	            this.setState({
	                dataSet: data
	            });
	            this.el = $(this.el);
	            this.el.DataTable({
	                data: this.state.dataSet,
	                columns: [{ data: 's_no' }, { data: 'transaction_date' }, { data: 'razorpay_payment_id' }, { data: 'name' }, { data: 'user_type' }, { data: 'email_id' }, { data: 'plan_id' }, { data: 'amount' }, { data: 'status' }, { data: 'action' }]
	
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            return _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _react2.default.createElement(
	                    _layout2.default,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { 'class': 'col-12 grid-margin' },
	                        _react2.default.createElement(
	                            'div',
	                            { 'class': 'card' },
	                            _react2.default.createElement(
	                                'div',
	                                { 'class': 'card-body' },
	                                _react2.default.createElement(
	                                    'h4',
	                                    { 'class': 'card-title' },
	                                    'RazorPay PaymentLinks'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'content-top col-md-12 col-xs-12' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'custom-form form-inline col-md-12 col-xs-12 h-small pad-top' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'row' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'hdr-row' },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'pull-right' },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'dropdown menu-item' },
	                                                        _react2.default.createElement(
	                                                            'button',
	                                                            { className: 'btn btn-success btn-sm dropdown-toggle btn-arrow', onClick: this.exportExcel },
	                                                            _react2.default.createElement('i', { className: 'fa fa-file-excel-o', 'aria-hidden': 'true' }),
	                                                            ' Export to Excel'
	                                                        )
	                                                    )
	                                                )
	                                            )
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'main-content col-md-12 col-xs-12' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'box-shadow-custom' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'table-responsive content-sec col-md-12 col-xs-12 pad-no mar-t-no' },
	                                            _react2.default.createElement(
	                                                'table',
	                                                { className: 'table table-custom-design table-striped dataTable', ref: function ref(el) {
	                                                        return _this3.el = el;
	                                                    } },
	                                                _react2.default.createElement(
	                                                    'thead',
	                                                    null,
	                                                    _react2.default.createElement(
	                                                        'tr',
	                                                        null,
	                                                        _react2.default.createElement(
	                                                            'th',
	                                                            { className: 'tabledata' },
	                                                            'S.No'
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'th',
	                                                            { className: 'tabledata' },
	                                                            'Date'
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'th',
	                                                            { className: 'tabledata' },
	                                                            'RazorPay Id'
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'th',
	                                                            { className: 'tabledata' },
	                                                            'Partner Name'
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'th',
	                                                            { className: 'tabledata' },
	                                                            'Type'
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'th',
	                                                            { className: 'tabledata' },
	                                                            'Email Id'
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'th',
	                                                            { className: 'tabledata' },
	                                                            'Package Name'
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'th',
	                                                            { className: 'tabledata' },
	                                                            'Amount'
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'th',
	                                                            { className: 'tabledata' },
	                                                            'Status'
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'th',
	                                                            { className: 'tabledata' },
	                                                            'Action'
	                                                        )
	                                                    )
	                                                )
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return partnerPaymentLinks;
	}(_react.Component);
	
	exports.default = partnerPaymentLinks;

/***/ },
/* 993 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _Tabs = __webpack_require__(65);
	
	var _Tabs2 = _interopRequireDefault(_Tabs);
	
	var _TabsPane = __webpack_require__(64);
	
	var _TabsPane2 = _interopRequireDefault(_TabsPane);
	
	var _overview_profile = __webpack_require__(367);
	
	var _overview_profile2 = _interopRequireDefault(_overview_profile);
	
	var _contact_profile = __webpack_require__(365);
	
	var _contact_profile2 = _interopRequireDefault(_contact_profile);
	
	var _document = __webpack_require__(366);
	
	var _document2 = _interopRequireDefault(_document);
	
	var _password_profile = __webpack_require__(368);
	
	var _password_profile2 = _interopRequireDefault(_password_profile);
	
	var _categoryv = __webpack_require__(364);
	
	var _categoryv2 = _interopRequireDefault(_categoryv);
	
	var _branch = __webpack_require__(362);
	
	var _branch2 = _interopRequireDefault(_branch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import { Editor } from '@tinymce/tinymce-react';
	
	var partnerProfile = function (_Component) {
	  _inherits(partnerProfile, _Component);
	
	  function partnerProfile(props) {
	    _classCallCheck(this, partnerProfile);
	
	    var _this = _possibleConstructorReturn(this, (partnerProfile.__proto__ || Object.getPrototypeOf(partnerProfile)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var qrystr = window.location.search;
	    var urlParams = new URLSearchParams(qrystr);
	    var sid = urlParams.get('sid');
	    _this.state = {
	      auth_data: JSON.parse(localStorage.getItem("user_data")),
	      is_completed: localStorage.getItem("is_completed") ? localStorage.getItem("is_completed") : 0,
	      plan_id: 0,
	      user_type: 0,
	      sid: sid != null ? sid : -1,
	      page_name: '',
	      category_list: []
	    };
	    _this.getPageName();
	    _this.getMainCategory();
	    return _this;
	  }
	
	  _createClass(partnerProfile, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.state.auth_data.current_plan != 0) {
	        this.setState({
	          plan_id: this.state.auth_data.current_plan
	        });
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      window.jQuery('.selectpicker').selectpicker('refresh');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          is_completed = _state.is_completed,
	          auth_data = _state.auth_data;
	
	
	      var childTabs = [{
	        name: "Overview",
	        id: "inst_deta",
	        disabled: this.state.sid == 0 ? true : false,
	        defaultChecked: true
	      }, {
	        name: "Contact Person Details",
	        id: "contact",
	        disabled: this.state.sid == 0 ? true : is_completed == 0 ? true : false
	      }, {
	        name: "Change Password",
	        id: "chan_pass",
	        disabled: this.state.sid == 0 ? true : false
	      }, {
	        name: 'Category',
	        id: "category"
	
	      }, {
	        name: "Branches",
	        id: "branch"
	
	      }];
	      if (auth_data.user_type == 2 && auth_data.isSubpartner == false) {
	        console.log('***auth_data', auth_data);
	        childTabs.push({
	          name: "Documents",
	          id: "docs"
	        });
	      }
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'col-12 grid-margin' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card-body' },
	                _react2.default.createElement(
	                  'h4',
	                  { 'class': 'card-title' },
	                  'Update Profile'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'desktoponly' },
	                  _react2.default.createElement(
	                    _Tabs2.default,
	                    { tabsetName: 'dashboard', childTabs: childTabs },
	                    _react2.default.createElement(
	                      _TabsPane2.default,
	                      { id: 'inst_deta' },
	                      _react2.default.createElement(_overview_profile2.default, null)
	                    ),
	                    _react2.default.createElement(
	                      _TabsPane2.default,
	                      { id: 'contact' },
	                      _react2.default.createElement(_contact_profile2.default, null)
	                    ),
	                    _react2.default.createElement(
	                      _TabsPane2.default,
	                      { id: 'chan_pass' },
	                      _react2.default.createElement(_password_profile2.default, null)
	                    ),
	                    _react2.default.createElement(
	                      _TabsPane2.default,
	                      { id: 'category' },
	                      _react2.default.createElement(_categoryv2.default, null)
	                    ),
	                    _react2.default.createElement(
	                      _TabsPane2.default,
	                      { id: 'branch' },
	                      _react2.default.createElement(_branch2.default, null)
	                    ),
	                    _react2.default.createElement(
	                      _TabsPane2.default,
	                      { id: 'docs' },
	                      _react2.default.createElement(_document2.default, null)
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'mobileonly' },
	                  _react2.default.createElement(_overview_profile2.default, null),
	                  _react2.default.createElement(_contact_profile2.default, null),
	                  _react2.default.createElement(_password_profile2.default, null),
	                  _react2.default.createElement(_categoryv2.default, null),
	                  _react2.default.createElement(_document2.default, null)
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return partnerProfile;
	}(_react.Component);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.getPageName = function () {
	    var _state$auth_data = _this2.state.auth_data,
	        login_id = _state$auth_data.login_id,
	        set_id = _state$auth_data.set_id;
	
	    var sid = _this2.state.sid != -1 ? _this2.state.sid : set_id;
	    if (sid != 0) {
	      var req = JSON.stringify({
	        role: 3,
	        login_id: login_id,
	        sid: _this2.state.sid != -1 ? _this2.state.sid : set_id,
	        url: 'getPageName'
	      });
	      (0, _FetchCall.partnerApi)(req).then(function (res) {
	        if (res.status === 1) {
	          var name = res.name;
	          _this2.setState({
	            page_name: name
	          });
	        }
	      });
	    }
	  };
	
	  this.getMainCategory = function () {
	    var req = JSON.stringify({
	      category_id: 0,
	      user_type: _this2.state.auth_data.user_type,
	      role: 3,
	      url: 'categorydata'
	    });
	    (0, _FetchCall.partnerCategory)(req).then(function (res) {
	      if (res.status === 1) {
	        _this2.setState({
	          category_list: res.scategory_list
	        });
	      }
	    });
	  };
	};
	
	exports.default = partnerProfile;

/***/ },
/* 994 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _Tabs = __webpack_require__(65);
	
	var _Tabs2 = _interopRequireDefault(_Tabs);
	
	var _TabsPane = __webpack_require__(64);
	
	var _TabsPane2 = _interopRequireDefault(_TabsPane);
	
	var _overview_profile = __webpack_require__(367);
	
	var _overview_profile2 = _interopRequireDefault(_overview_profile);
	
	var _contact_profile = __webpack_require__(365);
	
	var _contact_profile2 = _interopRequireDefault(_contact_profile);
	
	var _document = __webpack_require__(366);
	
	var _document2 = _interopRequireDefault(_document);
	
	var _password_profile = __webpack_require__(368);
	
	var _password_profile2 = _interopRequireDefault(_password_profile);
	
	var _categoryv = __webpack_require__(364);
	
	var _categoryv2 = _interopRequireDefault(_categoryv);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import { Editor } from '@tinymce/tinymce-react';
	
	var partnerProfile_new = function (_Component) {
	    _inherits(partnerProfile_new, _Component);
	
	    function partnerProfile_new(props) {
	        _classCallCheck(this, partnerProfile_new);
	
	        var _this = _possibleConstructorReturn(this, (partnerProfile_new.__proto__ || Object.getPrototypeOf(partnerProfile_new)).call(this, props));
	
	        _initialiseProps.call(_this);
	
	        var qrystr = window.location.search;
	        var urlParams = new URLSearchParams(qrystr);
	        var sid = urlParams.get('sid');
	        _this.state = {
	            auth_data: JSON.parse(localStorage.getItem("user_data")),
	            is_completed: localStorage.getItem("is_completed") ? localStorage.getItem("is_completed") : 0,
	            plan_id: 0,
	            user_type: 0,
	            sid: sid != null ? sid : -1,
	            page_name: '',
	            category_list: []
	        };
	        _this.getPageName();
	        _this.getMainCategory();
	        return _this;
	    }
	
	    _createClass(partnerProfile_new, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            if (this.state.auth_data.current_plan != 0) {
	                this.setState({
	                    plan_id: this.state.auth_data.current_plan
	                });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _state = this.state,
	                is_completed = _state.is_completed,
	                auth_data = _state.auth_data;
	
	
	            var childTabs = [{
	                name: "Overview",
	                id: "inst_deta",
	                disabled: this.state.sid == 0 ? true : false
	            }, {
	                name: "Contact Person Details",
	                id: "contact",
	                disabled: this.state.sid == 0 ? true : is_completed == 0 ? true : false
	            }, {
	                name: "Change Password",
	                id: "chan_pass",
	                disabled: this.state.sid == 0 ? true : false
	            }, {
	                name: 'Category',
	                id: "category",
	                defaultChecked: true
	            }];
	            if (auth_data.user_type == 2 && auth_data.isSubpartner == false) {
	                console.log('***auth_data', auth_data);
	                childTabs.push({
	                    name: "Documents",
	                    id: "docs"
	                });
	            }
	
	            return _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _react2.default.createElement(
	                    _layout2.default,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { 'class': 'col-12 grid-margin' },
	                        _react2.default.createElement(
	                            'div',
	                            { 'class': 'card' },
	                            _react2.default.createElement(
	                                'div',
	                                { 'class': 'card-body' },
	                                _react2.default.createElement(
	                                    'h4',
	                                    { 'class': 'card-title' },
	                                    'Update Profile'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'mainblock' },
	                                    _react2.default.createElement(_overview_profile2.default, null),
	                                    _react2.default.createElement(_contact_profile2.default, null),
	                                    _react2.default.createElement(_categoryv2.default, null),
	                                    _react2.default.createElement(_document2.default, null)
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'pad50' },
	                                    _react2.default.createElement(
	                                        'a',
	                                        { href: '/partner/accountinfonew', 'class': 'btn btn-primary' },
	                                        'Proceed Next'
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return partnerProfile_new;
	}(_react.Component);
	
	var _initialiseProps = function _initialiseProps() {
	    var _this2 = this;
	
	    this.getPageName = function () {
	        var _state$auth_data = _this2.state.auth_data,
	            login_id = _state$auth_data.login_id,
	            set_id = _state$auth_data.set_id;
	
	        var sid = _this2.state.sid != -1 ? _this2.state.sid : set_id;
	        if (sid != 0) {
	            var req = JSON.stringify({
	                role: 3,
	                login_id: login_id,
	                sid: _this2.state.sid != -1 ? _this2.state.sid : set_id,
	                url: 'getPageName'
	            });
	            (0, _FetchCall.partnerApi)(req).then(function (res) {
	                if (res.status === 1) {
	                    var name = res.name;
	                    _this2.setState({
	                        page_name: name
	                    });
	                }
	            });
	        }
	    };
	
	    this.getMainCategory = function () {
	        var req = JSON.stringify({
	            category_id: 0,
	            user_type: _this2.state.auth_data.user_type,
	            role: 3,
	            url: 'categorydata'
	        });
	        (0, _FetchCall.partnerCategory)(req).then(function (res) {
	            if (res.status === 1) {
	                _this2.setState({
	                    category_list: res.scategory_list
	                });
	            }
	        });
	    };
	};
	
	exports.default = partnerProfile_new;

/***/ },
/* 995 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _reactstrap = __webpack_require__(17);
	
	var _Tabs = __webpack_require__(65);
	
	var _Tabs2 = _interopRequireDefault(_Tabs);
	
	var _TabsPane = __webpack_require__(64);
	
	var _TabsPane2 = _interopRequireDefault(_TabsPane);
	
	var _reactDataTableComponent = __webpack_require__(53);
	
	var _reactDataTableComponent2 = _interopRequireDefault(_reactDataTableComponent);
	
	var _Common = __webpack_require__(145);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import { Editor } from '@tinymce/tinymce-react';
	
	var customStyles = {
	  headCells: {
	    style: {
	      fontWeight: 'bold'
	    }
	  }
	};
	var childTabs = [{
	  name: "Access From",
	  id: "Ratings",
	  defaultChecked: true
	}, {
	  name: "Access Information",
	  id: "Enquiries"
	}];
	//$.DataTable = require('datatables.net')
	
	var columns_af = [{
	  name: 'City',
	  selector: function selector(row) {
	    return row.location;
	  },
	  sortable: true
	}, {
	  name: 'No of Persons',
	  selector: function selector(row) {
	    return row.count;
	  }
	}, {
	  name: 'Month',
	  selector: function selector(row) {
	    return row.date;
	  }
	}];
	var columns_ai = [{
	  name: 'Type',
	  selector: function selector(row) {
	    return row.name;
	  },
	  sortable: true
	}, {
	  name: 'Counts',
	  selector: function selector(row) {
	    return row.count;
	  }
	}];
	
	var partnerReports = function (_Component) {
	  _inherits(partnerReports, _Component);
	
	  function partnerReports(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, partnerReports);
	
	    var _this = _possibleConstructorReturn(this, (partnerReports.__proto__ || Object.getPrototypeOf(partnerReports)).call(this, props));
	
	    _this.showMTab = function (element) {
	
	      (0, _jquery2.default)('.submenu-list a').each(function () {
	        (0, _jquery2.default)(this).removeClass('active');
	      });
	
	      (0, _jquery2.default)("." + element).addClass("active");
	      (0, _jquery2.default)(".mainblock").removeClass('active').addClass('hidden');
	      (0, _jquery2.default)("#" + element).removeClass('hidden').addClass('active');
	
	      //document.getElementById(element).style.display = 'block';
	    };
	
	    _this.getpageData = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	      var _this$state$auth_data, user_type, login_id, set_id, insdata;
	
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              _this$state$auth_data = _this.state.auth_data, user_type = _this$state$auth_data.user_type, login_id = _this$state$auth_data.login_id, set_id = _this$state$auth_data.set_id;
	              insdata = JSON.stringify({
	                user_type: user_type,
	                login_id: login_id,
	                sid: set_id,
	                url: 'getAbout'
	              });
	              _context2.next = 4;
	              return (0, _FetchCall.partnerApi)(insdata).then(function (response) {
	                if (response.status === 1) {
	                  _this.setState({
	                    category_data: response.result.master_data
	                  });
	                  var data = response.result.master_data;
	                  if (data.length > 0) {
	                    data.map(function () {
	                      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(item, index) {
	                        var userinfo;
	                        return _regenerator2.default.wrap(function _callee$(_context) {
	                          while (1) {
	                            switch (_context.prev = _context.next) {
	                              case 0:
	                                userinfo = JSON.stringify({
	                                  user_id: login_id,
	                                  category: item.cid,
	                                  main_id: item.mid
	                                });
	
	                                (0, _FetchCall.getContactServiceList)(userinfo).then(function (response) {
	                                  if (response.status == 1) {
	                                    item.partner_connect = response.result;
	                                  }
	                                });
	                                (0, _FetchCall.getDeviceAccess)(userinfo).then(function (response) {
	                                  if (response.status == 1) {
	                                    item.access_from = response.result;
	                                  }
	                                });
	                                (0, _FetchCall.getWishList)(userinfo).then(function (response) {
	                                  if (response.status == 1) {
	                                    item.access_info = response.result;
	                                  }
	                                });
	
	                              case 4:
	                              case 'end':
	                                return _context.stop();
	                            }
	                          }
	                        }, _callee, _this2);
	                      }));
	
	                      return function (_x, _x2) {
	                        return _ref2.apply(this, arguments);
	                      };
	                    }());
	                  }
	                  var THIS = _this;
	                  _this.setState({
	                    checking: true
	                  });
	                  setTimeout(function () {
	                    THIS.setState({
	                      checking: false
	                    });
	                  }, 5000);
	                }
	              });
	
	            case 4:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, _this2);
	    }));
	
	    _this.handleChange = function (e) {
	      _this.setState(_defineProperty({}, e.target.name, e.target.value));
	    };
	
	    _this.sendReply = function (row) {
	      _this.setState({
	        modalReply: true,
	        current_comment: row.comments,
	        current_eid: row.email,
	        current_rid: row.id
	      });
	    };
	
	    _this.replyMail = function (e) {
	      e.preventDefault();
	      var req = JSON.stringify({
	        msg: _this.state.new_reply,
	        rid: _this.state.current_rid,
	        toemail: _this.state.current_eid,
	        login_id: _this.state.auth_data.login_id,
	        set_id: _this.state.auth_data.set_id,
	        url: 'reply_service'
	      });
	      (0, _FetchCall.vendorDashboard)(req).then(function (response) {
	        if (response.status === 1) {
	          _this.getpageData();
	          _this.setState({
	            modalReply: false,
	            current_comment: '',
	            current_eid: '',
	            current_rid: 0
	          });
	        }
	      });
	    };
	
	    _this.cancelPop = function (e) {
	      e.preventDefault();
	      _this.setState({
	        modalReply: false,
	        current_comment: '',
	        current_eid: '',
	        current_rid: 0
	      });
	    };
	
	    _this.exportConnect = function (e, item) {
	      e.preventDefault();
	      var req = JSON.stringify({
	        category: item.cid,
	        main_id: item.mid,
	        login_id: _this.state.auth_data.login_id,
	        url: 'connectExport'
	      });
	      (0, _FetchCall.vendorDashboard)(req).then(function (response) {
	        if (response.status === 1) {
	          window.open(response.path);
	        }
	      });
	    };
	
	    _this.exportAccessFrom = function (e, item) {
	      e.preventDefault();
	      var req = JSON.stringify({
	        category: item.cid,
	        main_id: item.mid,
	        login_id: _this.state.auth_data.login_id,
	        url: 'accessFromExport'
	      });
	      (0, _FetchCall.vendorDashboard)(req).then(function (response) {
	        if (response.status === 1) {
	          window.open(response.path);
	        }
	      });
	    };
	
	    _this.exportAccessInfo = function (e, item) {
	      e.preventDefault();
	      var req = JSON.stringify({
	        category: item.cid,
	        main_id: item.mid,
	        login_id: _this.state.auth_data.login_id,
	        url: 'accessInfoExport'
	      });
	      (0, _FetchCall.vendorDashboard)(req).then(function (response) {
	        if (response.status === 1) {
	          window.open(response.path);
	        }
	      });
	    };
	
	    _this.state = {
	      logged: localStorage.getItem("authentication"),
	      auth_data: JSON.parse(localStorage.getItem("user_data")),
	      category_data: [], collapse: 0, modalReply: false,
	      current_comment: '', current_rid: 0, current_eid: ''
	    };
	
	    _this.getpageData();
	    return _this;
	  }
	
	  _createClass(partnerReports, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          category_data = _state.category_data,
	          collapse = _state.collapse;
	
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'col-12 grid-margin' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card-body' },
	                _react2.default.createElement(
	                  'h4',
	                  { 'class': 'card-title' },
	                  'Reports'
	                ),
	                category_data.length > 0 && _react2.default.createElement(
	                  _Tabs2.default,
	                  { tabsetName: 'Comments', tabClassName: 'custom-tab', childTabs: childTabs },
	                  _react2.default.createElement(
	                    _TabsPane2.default,
	                    { id: 'Ratings' },
	                    category_data.map(function (item, index) {
	                      return _react2.default.createElement(
	                        _reactstrap.Card,
	                        { className: 'panel-group custom-card', style: { marginBottom: '1rem' }, key: index },
	                        _react2.default.createElement(
	                          _reactstrap.CardHeader,
	                          { onClick: function onClick() {
	                              return _this3.toggle(index);
	                            }, 'data-event': index, className: 'custom-card-heading' },
	                          _react2.default.createElement(
	                            'b',
	                            null,
	                            item.category_name
	                          ),
	                          _react2.default.createElement(
	                            'small',
	                            null,
	                            item.sub_category_name ? ' - ' + item.sub_category_name : ''
	                          ),
	                          collapse !== index ? _react2.default.createElement(
	                            'span',
	                            { className: 'pull-right' },
	                            _react2.default.createElement('i', { 'class': 'fa fa-plus', 'aria-hidden': 'true' })
	                          ) : _react2.default.createElement(
	                            'span',
	                            { className: 'pull-right' },
	                            _react2.default.createElement('i', { 'class': 'fa fa-minus', 'aria-hidden': 'true' })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          _reactstrap.Collapse,
	                          { isOpen: collapse === index },
	                          _react2.default.createElement(
	                            _reactstrap.CardBody,
	                            { className: 'panel-body' },
	                            item.is_active == 0 ? _react2.default.createElement(
	                              'div',
	                              { className: 'row mar-btm' },
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'form-group col-md-12' },
	                                _react2.default.createElement(
	                                  'h3',
	                                  { className: 'text-center' },
	                                  'Upgrade/Renewal to update the Data'
	                                )
	                              )
	                            ) : _react2.default.createElement(
	                              'div',
	                              null,
	                              item.access_from && item.access_from.length > 0 && _react2.default.createElement(
	                                'button',
	                                { className: 'btn btn-sm btn-success pull-right', onClick: function onClick(e) {
	                                    return _this3.exportAccessFrom(e, item);
	                                  } },
	                                'Export'
	                              ),
	                              _react2.default.createElement(_reactDataTableComponent2.default, {
	                                title: '',
	                                columns: columns_af,
	                                data: item.access_from,
	                                pagination: true,
	                                customStyles: customStyles,
	                                loading: "please wait ..it is processing",
	                                noDataComponent: ' Not enough data to provide this info' //or your component
	                                , paginationComponentOptions: { noRowsPerPage: true }
	                              })
	                            )
	                          )
	                        )
	                      );
	                    })
	                  ),
	                  _react2.default.createElement(
	                    _TabsPane2.default,
	                    { id: 'Enquiries' },
	                    category_data.map(function (item, index) {
	                      return _react2.default.createElement(
	                        _reactstrap.Card,
	                        { className: 'panel-group custom-card', style: { marginBottom: '1rem' }, key: index },
	                        _react2.default.createElement(
	                          _reactstrap.CardHeader,
	                          { onClick: function onClick() {
	                              return _this3.toggle(index);
	                            }, 'data-event': index, className: 'custom-card-heading' },
	                          _react2.default.createElement(
	                            'b',
	                            null,
	                            item.category_name
	                          ),
	                          _react2.default.createElement(
	                            'small',
	                            null,
	                            item.sub_category_name ? ' - ' + item.sub_category_name : ''
	                          ),
	                          collapse !== index ? _react2.default.createElement(
	                            'span',
	                            { className: 'pull-right' },
	                            _react2.default.createElement('i', { 'class': 'fa fa-plus', 'aria-hidden': 'true' })
	                          ) : _react2.default.createElement(
	                            'span',
	                            { className: 'pull-right' },
	                            _react2.default.createElement('i', { 'class': 'fa fa-minus', 'aria-hidden': 'true' })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          _reactstrap.Collapse,
	                          { isOpen: collapse === index },
	                          _react2.default.createElement(
	                            _reactstrap.CardBody,
	                            { className: 'panel-body' },
	                            item.is_active == 0 ? _react2.default.createElement(
	                              'div',
	                              { className: 'row mar-btm' },
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'form-group col-md-12' },
	                                _react2.default.createElement(
	                                  'h3',
	                                  { className: 'text-center' },
	                                  'Upgrade/Renewal to update the Data'
	                                )
	                              )
	                            ) : _react2.default.createElement(
	                              'div',
	                              null,
	                              item.access_info && item.access_info.length > 0 && _react2.default.createElement(
	                                'button',
	                                { className: 'btn btn-sm btn-success pull-right', onClick: function onClick(e) {
	                                    return _this3.exportAccessInfo(e, item);
	                                  } },
	                                'Export'
	                              ),
	                              _react2.default.createElement(_reactDataTableComponent2.default, {
	                                title: '',
	                                columns: columns_ai,
	                                data: item.access_info,
	
	                                loading: "please wait ..it is processing",
	                                customStyles: customStyles
	                                //paginationComponentOptions={{ noRowsPerPage: true }}
	                              })
	                            )
	                          )
	                        )
	                      );
	                    })
	                  )
	                ),
	                category_data.length == 0 && _react2.default.createElement(
	                  'div',
	                  null,
	                  'Please wait...loading...'
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'toggle',
	    value: function toggle(event) {
	      this.setState({
	        collapse: this.state.collapse === Number(event) ? -1 : Number(event)
	      });
	    }
	  }]);
	
	  return partnerReports;
	}(_react.Component);
	
	exports.default = partnerReports;

/***/ },
/* 996 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _reactstrap = __webpack_require__(17);
	
	var _Tabs = __webpack_require__(65);
	
	var _Tabs2 = _interopRequireDefault(_Tabs);
	
	var _TabsPane = __webpack_require__(64);
	
	var _TabsPane2 = _interopRequireDefault(_TabsPane);
	
	var _reactDataTableComponent = __webpack_require__(53);
	
	var _reactDataTableComponent2 = _interopRequireDefault(_reactDataTableComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import { Editor } from '@tinymce/tinymce-react';
	
	var childTabs = [{
	  name: "Parent Reviews",
	  id: "Reviews",
	  defaultChecked: true
	}, {
	  name: "Parent Ratings",
	  id: "Ratings"
	}, {
	  name: "Partner Connect",
	  id: "Enquiries"
	}];
	
	var customStyles = {
	  headCells: {
	    style: {
	      fontWeight: 'bold'
	    }
	  }
	};
	
	var partnerReview = function (_Component) {
	  _inherits(partnerReview, _Component);
	
	  function partnerReview(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, partnerReview);
	
	    var _this = _possibleConstructorReturn(this, (partnerReview.__proto__ || Object.getPrototypeOf(partnerReview)).call(this, props));
	
	    _this.showMTab = function (element) {
	
	      (0, _jquery2.default)('.submenu-list a').each(function () {
	        (0, _jquery2.default)(this).removeClass('active');
	      });
	
	      (0, _jquery2.default)("." + element).addClass("active");
	      (0, _jquery2.default)(".mainblock").removeClass('active').addClass('hidden');
	      (0, _jquery2.default)("#" + element).removeClass('hidden').addClass('active');
	
	      //document.getElementById(element).style.display = 'block';
	    };
	
	    _this.getpageData = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	      var _this$state$auth_data, user_type, login_id, set_id, insdata;
	
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              _this$state$auth_data = _this.state.auth_data, user_type = _this$state$auth_data.user_type, login_id = _this$state$auth_data.login_id, set_id = _this$state$auth_data.set_id;
	              insdata = JSON.stringify({
	                user_type: user_type,
	                login_id: login_id,
	                sid: set_id,
	                url: 'getAbout'
	              });
	              _context2.next = 4;
	              return (0, _FetchCall.partnerApi)(insdata).then(function (response) {
	                if (response.status === 1) {
	                  _this.setState({
	                    checking: false,
	                    category_data: response.result.master_data
	                  });
	                  var data = response.result.master_data;
	                  if (data.length > 0) {
	                    data.map(function () {
	                      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(item, index) {
	                        var userinfo;
	                        return _regenerator2.default.wrap(function _callee$(_context) {
	                          while (1) {
	                            switch (_context.prev = _context.next) {
	                              case 0:
	                                console.log('item.mid', item.mid);
	                                userinfo = JSON.stringify({
	                                  vendor_id: login_id,
	                                  category: item.cid,
	                                  main_id: item.mid
	                                });
	
	
	                                (0, _FetchCall.getCommentList)(userinfo).then(function (response) {
	                                  if (response.status == 1) {
	                                    item.comments = response.results;
	                                  }
	                                });
	                                (0, _FetchCall.getRatingList)(userinfo).then(function (response) {
	                                  if (response.status == 1) {
	                                    var school = response.data[0].schoolrating[0];
	                                    var preschool = response.data[0].preschoolrating[0];
	                                    var playarea = response.data[0].playarearating[0];
	                                    var hobbies = response.data[0].hobbiesarating[0];
	                                    var tution = response.data[0].tutionrating[0];
	                                    var camp = response.data[0].camprating[0];
	                                    var advice = response.data[0].advicerating[0];
	                                    var event = response.data[0].eventrating[0];
	
	                                    item.school_child_safety = school ? school.school_child_safety : '0.0';
	                                    item.school_covid19 = school ? school.school_covid19 : '0.0';
	                                    item.school_facilities = school ? school.school_facilities : '0.0';
	                                    item.school_food = school ? school.school_food : '0.0';
	                                    item.school_infrastructure = school ? school.school_infrastructure : '0.0';
	                                    item.school_overall_expirence = school ? school.school_overall_expirence : '0.0';
	                                    item.school_qty_info_website = school ? school.school_qty_info_website : '0.0';
	                                    item.school_qty_interaction = school ? school.school_qty_interaction : '0.0';
	                                    item.school_qty_teachers = school ? school.school_qty_teachers : '0.0';
	                                    item.school_qty_teaching = school ? school.school_qty_teaching : '0.0';
	                                    item.school_teacher_student_ratio = school ? school.school_teacher_student_ratio : '0.0';
	                                    item.school_transport_arrange = school ? school.school_transport_arrange : '0.0';
	                                    item.school_rating = school ? school.school_rating : false, item.preschool_child_safety = preschool ? preschool.preschool_child_safety : '0.0';
	                                    item.preschool_covid19 = preschool ? preschool.preschool_covid19 : '0.0';
	                                    item.preschool_facilities = preschool ? preschool.preschool_facilities : '0.0';
	                                    item.preschool_food = preschool ? preschool.preschool_food : '0.0';
	                                    item.preschool_infrastructure = preschool ? preschool.preschool_infrastructure : '0.0';
	                                    item.preschool_overall_expirence = preschool ? preschool.preschool_overall_expirence : '0.0';
	                                    item.preschool_qty_info_website = preschool ? preschool.preschool_qty_info_website : '0.0';
	                                    item.preschool_qty_interaction = preschool ? preschool.preschool_qty_interaction : '0.0';
	                                    item.preschool_qty_teachers = preschool ? preschool.preschool_qty_teachers : '0.0';
	                                    item.preschool_qty_teaching = preschool ? preschool.preschool_qty_teaching : '0.0';
	                                    item.preschool_teacher_student_ratio = preschool ? preschool.preschool_teacher_student_ratio : '0.0';
	                                    item.preschool_transport_arrange = preschool ? preschool.preschool_transport_arrange : '0.0';
	                                    item.preschool_rating = preschool ? preschool.preschool_rating : false, item.playarea_child_safety = playarea ? playarea.playarea_child_safety : '0.0';
	                                    item.playarea_cleanliness = playarea ? playarea.playarea_cleanliness : '0.0';
	                                    item.playarea_covid19 = playarea ? playarea.playarea_covid19 : '0.0';
	                                    item.playarea_crowd_size = playarea ? playarea.playarea_crowd_size : '0.0';
	                                    item.playarea_facilities_location = playarea ? playarea.playarea_facilities_location : '0.0';
	                                    item.playarea_facilities_parent = playarea ? playarea.playarea_facilities_parent : '0.0';
	                                    item.playarea_food = playarea ? playarea.playarea_food : '0.0';
	                                    item.playarea_overall_expirence = playarea ? playarea.playarea_overall_expirence : '0.0';
	                                    item.playarea_qty_info_website = playarea ? playarea.playarea_qty_info_website : '0.0';
	                                    item.playarea_qty_staff = playarea ? playarea.playarea_qty_staff : '0.0';
	                                    item.playarea_rating = playarea ? playarea.playarea_rating : false, item.hobbies_covid19 = hobbies ? hobbies.hobbies_covid19 : '0.0';
	                                    item.hobbies_qty_teachers = hobbies ? hobbies.hobbies_qty_teachers : '0.0';
	                                    item.hobbies_qty_teaching = hobbies ? hobbies.hobbies_qty_teaching : '0.0';
	                                    item.hobbies_qty_info_website = hobbies ? hobbies.hobbies_qty_info_website : '0.0';
	                                    item.hobbies_child_safety = hobbies ? hobbies.hobbies_child_safety : '0.0';
	                                    item.hobbies_facilities_parent = hobbies ? hobbies.hobbies_facilities_parent : '0.0';
	                                    item.hobbies_campus_facilities = hobbies ? hobbies.hobbies_campus_facilities : '0.0';
	                                    item.hobbies_qty_intraction = hobbies ? hobbies.hobbies_qty_intraction : '0.0';
	                                    item.hobbies_batch_size = hobbies ? hobbies.hobbies_batch_size : '0.0';
	                                    item.hobbies_overall_expirence = hobbies ? hobbies.hobbies_overall_expirence : '0.0';
	                                    item.hobbies_rating = hobbies ? hobbies.hobbies_rating : false, item.tution_covid19 = tution ? tution.tution_covid19 : '0.0';
	                                    item.tution_qty_teachers = tution ? tution.tution_qty_teachers : '0.0';
	                                    item.tution_qty_teaching = tution ? tution.tution_qty_teaching : '0.0';
	                                    item.tution_child_safety = tution ? tution.tution_child_safety : '0.0';
	                                    item.tution_facilities = tution ? tution.tution_facilities : '0.0';
	                                    item.tution_ontime_punctuality = tution ? tution.tution_ontime_punctuality : '0.0';
	                                    item.tution_overall_expirence = tution ? tution.tution_overall_expirence : '0.0';
	                                    item.tution_rating = tution ? tution.tution_rating : false, item.advice_covid19 = advice ? advice.advice_covid19 : '0.0';
	                                    item.advice_qty_teachers = advice ? advice.advice_qty_teachers : '0.0';
	                                    item.advice_qty_teaching = advice ? advice.advice_qty_teaching : '0.0';
	                                    item.advice_child_safety = advice ? advice.advice_child_safety : '0.0';
	                                    item.advice_facilities = advice ? advice.advice_facilities : '0.0';
	                                    item.advice_ontime_punctuality = advice ? advice.advice_ontime_punctuality : '0.0';
	                                    item.advice_overall_expirence = advice ? advice.advice_overall_expirence : '0.0';
	                                    item.advice_rating = advice ? advice.advice_rating : false, item.camp_covid19 = camp ? camp.camp_covid19 : '0.0';
	                                    item.camp_qty_teachers = camp ? camp.camp_qty_teachers : '0.0';
	                                    item.camp_qty_teaching = camp ? camp.camp_qty_teaching : '0.0';
	                                    item.camp_qty_food = camp ? camp.camp_qty_food : '0.0';
	                                    item.camp_campus_facilities = camp ? camp.camp_campus_facilities : '0.0';
	                                    item.camp_child_safety = camp ? camp.camp_child_safety : '0.0';
	                                    item.camp_facilities_parents = camp ? camp.camp_facilities_parents : '0.0';
	                                    item.camp_qty_info_website = camp ? camp.camp_qty_info_website : '0.0';
	                                    item.camp_crowd_size = camp ? camp.camp_crowd_size : '0.0';
	                                    item.camp_infrastructure = camp ? camp.camp_infrastructure : '0.0';
	                                    item.camp_transport_arrange = camp ? camp.camp_transport_arrange : '0.0';
	                                    item.camp_overall_expirence = camp ? camp.camp_overall_expirence : '0.0';
	                                    item.camp_rating = camp ? camp.camp_rating : false, item.event_covid19 = event ? event.event_covid19 : '0.0';
	                                    item.event_qty_food = event ? event.event_qty_food : '0.0';
	                                    item.event_qty_info_website = event ? event.event_qty_info_website : '0.0';
	                                    item.event_ontime_punctuality = event ? event.event_ontime_punctuality : '0.0';
	                                    item.event_overall_expirence = event ? event.event_overall_expirence : '0.0';
	                                    item.event_rating = event ? event.event_rating : false;
	                                  }
	                                });
	
	                              case 4:
	                              case 'end':
	                                return _context.stop();
	                            }
	                          }
	                        }, _callee, _this2);
	                      }));
	
	                      return function (_x, _x2) {
	                        return _ref2.apply(this, arguments);
	                      };
	                    }());
	                  }
	                  var THIS = _this;
	                  _this.setState({
	                    checking: false
	                  });
	                  setTimeout(function () {
	                    THIS.setState({
	                      checking: true
	                    });
	                  }, 5000);
	                }
	              });
	
	            case 4:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, _this2);
	    }));
	
	    _this.handleChange = function (e) {
	      _this.setState(_defineProperty({}, e.target.name, e.target.value));
	    };
	
	    _this.toggle = function (e, event) {
	      e.preventDefault();
	      _this.setState({
	        collapse: _this.state.collapse === Number(event) ? -1 : Number(event),
	        loginPop: false
	      });
	    };
	
	    _this.state = {
	      logged: localStorage.getItem("authentication"),
	      auth_data: JSON.parse(localStorage.getItem("user_data")),
	      category_data: [], collapse: 0, checking: false, modalReply: false, modalReplyEnq: false,
	      current_comment: '', current_rid: 0, current_eid: ''
	    };
	    _this.getpageData();
	    _this.toggle = _this.toggle.bind(_this);
	    return _this;
	  }
	
	  _createClass(partnerReview, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // this.CommentList();
	      // this.EnquiriesList();
	      // this.RatingList()
	
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          category_data = _state.category_data,
	          collapse = _state.collapse;
	
	      var columns_pc = [{
	        name: 'Name',
	        selector: function selector(row) {
	          return row.name;
	        },
	        sortable: true
	      }, {
	        name: 'Email',
	        selector: function selector(row) {
	          return row.name;
	        },
	        wrap: true,
	        sortable: true,
	        format: function format(row) {
	          return row.email.length > 200 ? row.email.slice(0, 200) + '...' : row.email;
	        }
	      }, _defineProperty({
	        name: 'Date',
	        selector: function selector(row) {
	          return row.name;
	        }
	      }, 'selector', 'month'), {
	        name: 'Message',
	        selector: function selector(row) {
	          return row.comments;
	        },
	        wrap: true,
	        sortable: true,
	        format: function format(row) {
	          return row.comments.length > 200 ? row.comments.slice(0, 200) + '...' : row.comments;
	        }
	      }, {
	        name: 'Status',
	        selector: function selector(row) {
	          return row.status;
	        },
	        cell: function cell(row) {
	          return row.status == 0 ? _react2.default.createElement(
	            'span',
	            { 'class': 'label label-primary pointer', onClick: function onClick() {
	                return _this3.sendReplyEnq(row);
	              } },
	            'Reply'
	          ) : _react2.default.createElement(
	            'span',
	            { 'class': 'label label-success' },
	            'Replied'
	          );
	        }
	      }];
	      var columns_comments = [{
	        name: 'Date Posted',
	        selector: function selector(row) {
	          return row.date;
	        },
	        sortable: true
	      }, {
	        name: 'Name',
	        selector: function selector(row) {
	          return row.name;
	        }
	      }, {
	        name: 'Email id',
	        selector: function selector(row) {
	          return row.email;
	        },
	        wrap: true,
	        sortable: true,
	        format: function format(row) {
	          return row.email && row.email.length > 200 ? row.email.slice(0, 200) + '...' : row.email;
	        }
	      }, {
	        name: 'Comments',
	        selector: function selector(row) {
	          return row.comments;
	        },
	        wrap: true,
	        sortable: true,
	        format: function format(row) {
	          return row.comments && row.comments.length > 200 ? row.comments.slice(0, 200) + '...' : row.comments;
	        }
	      }, {
	        name: 'Status',
	        selector: function selector(row) {
	          return row.status;
	        },
	        cell: function cell(row) {
	          return row.status == 0 ? _react2.default.createElement(
	            'span',
	            { 'class': 'label label-primary pointer', onClick: function onClick() {
	                return _this3.sendReply(row);
	              } },
	            'Reply'
	          ) : _react2.default.createElement(
	            'span',
	            { 'class': 'label label-success' },
	            'Replied'
	          );
	        }
	      }, {
	        name: 'Replied',
	        selector: function selector(row) {
	          return row.reply_comments;
	        },
	        wrap: true,
	        sortable: true,
	        format: function format(row) {
	          return row.reply_comments && row.reply_comments.length > 200 ? row.reply_comments.slice(0, 200) + '...' : row.reply_comments;
	        }
	      }];
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'col-12 grid-margin' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card-body' },
	                _react2.default.createElement(
	                  'h4',
	                  { 'class': 'card-title' },
	                  'Parent Feedback and Interactions'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'desktoponly' },
	                  _react2.default.createElement(
	                    _Tabs2.default,
	                    { tabsetName: 'Comments', childTabs: childTabs },
	                    _react2.default.createElement(
	                      _TabsPane2.default,
	                      { id: 'Reviews' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          _reactstrap.Modal,
	                          { isOpen: this.state.modalReply },
	                          _react2.default.createElement(
	                            'form',
	                            { onSubmit: this.replyMail },
	                            _react2.default.createElement(
	                              _reactstrap.ModalHeader,
	                              null,
	                              _react2.default.createElement(
	                                'h3',
	                                null,
	                                'Send Response'
	                              )
	                            ),
	                            _react2.default.createElement(
	                              _reactstrap.ModalBody,
	                              { className: 'p-0' },
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'row' },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'col-md-12 form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    null,
	                                    'Message'
	                                  ),
	                                  _react2.default.createElement('textarea', { className: 'form-control', value: this.state.current_comment })
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'col-md-12 form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    null,
	                                    'Reply'
	                                  ),
	                                  _react2.default.createElement('textarea', { rows: 5, className: 'form-control', required: true,
	                                    onChange: this.handleChange, name: 'new_reply', value: this.state.new_reply })
	                                )
	                              )
	                            ),
	                            _react2.default.createElement(
	                              _reactstrap.ModalFooter,
	                              null,
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'row' },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'col-md-12' },
	                                  _react2.default.createElement(
	                                    'button',
	                                    { className: 'btn btn-sm btn-default', onClick: this.cancelPop },
	                                    'Close'
	                                  ),
	                                  _react2.default.createElement(
	                                    'button',
	                                    { type: 'submit', className: 'btn btn-sm btn-success' },
	                                    'Reply'
	                                  )
	                                )
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-md-12 mar-btm-60' },
	                          category_data.map(function (item, index) {
	                            return _react2.default.createElement(
	                              _reactstrap.Card,
	                              { className: 'panel-group custom-card', style: { marginBottom: '1rem' }, key: index },
	                              _react2.default.createElement(
	                                _reactstrap.CardHeader,
	                                { onClick: function onClick(e) {
	                                    return _this3.toggle(e, index);
	                                  }, 'data-event': index, className: 'custom-card-heading' },
	                                _react2.default.createElement(
	                                  'b',
	                                  null,
	                                  item.category_name
	                                ),
	                                _react2.default.createElement(
	                                  'small',
	                                  null,
	                                  item.sub_category_name ? ' - ' + item.sub_category_name : ''
	                                ),
	                                collapse !== index ? _react2.default.createElement(
	                                  'span',
	                                  { className: 'pull-right' },
	                                  _react2.default.createElement('i', { 'class': 'fa fa-plus', 'aria-hidden': 'true' })
	                                ) : _react2.default.createElement(
	                                  'span',
	                                  { className: 'pull-right' },
	                                  _react2.default.createElement('i', { 'class': 'fa fa-minus', 'aria-hidden': 'true' })
	                                )
	                              ),
	                              _react2.default.createElement(
	                                _reactstrap.Collapse,
	                                { isOpen: collapse === index },
	                                _react2.default.createElement(
	                                  _reactstrap.CardBody,
	                                  { className: 'panel-body' },
	                                  item.is_active == 0 ? _react2.default.createElement(
	                                    'div',
	                                    { className: 'row mar-btm' },
	                                    _react2.default.createElement(
	                                      'div',
	                                      { 'class': 'form-group col-md-12' },
	                                      _react2.default.createElement(
	                                        'h3',
	                                        { className: 'text-center' },
	                                        'Upgrade/Renewal to update the Data'
	                                      )
	                                    )
	                                  ) : _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    item.comments && item.comments.length > 0 && _react2.default.createElement(
	                                      'button',
	                                      { className: 'btn btn-sm btn-success pull-right', onClick: function onClick(e) {
	                                          return _this3.exportComment(e, item);
	                                        } },
	                                      'Export'
	                                    ),
	                                    _react2.default.createElement(_reactDataTableComponent2.default, {
	                                      title: '',
	                                      columns: columns_comments,
	                                      data: item.comments,
	                                      pagination: true,
	                                      customStyles: customStyles,
	                                      paginationComponentOptions: { noRowsPerPage: true }
	                                    })
	                                  )
	                                )
	                              )
	                            );
	                          })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _TabsPane2.default,
	                      { id: 'Ratings' },
	                      category_data.map(function (item, index) {
	                        return _react2.default.createElement(
	                          _reactstrap.Card,
	                          { className: 'panel-group custom-card', style: { marginBottom: '1rem' }, key: index },
	                          _react2.default.createElement(
	                            _reactstrap.CardHeader,
	                            { onClick: function onClick(e) {
	                                return _this3.toggle(e, index);
	                              }, 'data-event': index, className: 'custom-card-heading' },
	                            _react2.default.createElement(
	                              'b',
	                              null,
	                              item.category_name
	                            ),
	                            _react2.default.createElement(
	                              'small',
	                              null,
	                              item.sub_category_name ? ' - ' + item.sub_category_name : ''
	                            ),
	                            collapse !== index ? _react2.default.createElement(
	                              'span',
	                              { className: 'pull-right' },
	                              _react2.default.createElement('i', { 'class': 'fa fa-plus', 'aria-hidden': 'true' })
	                            ) : _react2.default.createElement(
	                              'span',
	                              { className: 'pull-right' },
	                              _react2.default.createElement('i', { 'class': 'fa fa-minus', 'aria-hidden': 'true' })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            _reactstrap.Collapse,
	                            { isOpen: collapse === index },
	                            _react2.default.createElement(
	                              _reactstrap.CardBody,
	                              { className: 'panel-body' },
	                              item.is_active == 0 ? _react2.default.createElement(
	                                'div',
	                                { className: 'row mar-btm' },
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'form-group col-md-12' },
	                                  _react2.default.createElement(
	                                    'h3',
	                                    { className: 'text-center' },
	                                    'Upgrade/Renewal to update the Data'
	                                  )
	                                )
	                              ) : _this3.state.checking && _react2.default.createElement(
	                                'div',
	                                { className: 'table-responsive custom-table-wrap content-sec col-md-12 col-xs-12 pad-no mar-t-no' },
	                                _react2.default.createElement(
	                                  'table',
	                                  { className: 'table dataTable' },
	                                  _react2.default.createElement(
	                                    'thead',
	                                    null,
	                                    _react2.default.createElement(
	                                      'tr',
	                                      null,
	                                      item.preschool_rating === true || item.school_rating === true ? _react2.default.createElement(
	                                        _react2.default.Fragment,
	                                        null,
	                                        _react2.default.createElement(
	                                          'th',
	                                          null,
	                                          'Covid19 Responses/ Precautions'
	                                        ),
	                                        _react2.default.createElement(
	                                          'th',
	                                          null,
	                                          'Child Safety @ premises'
	                                        ),
	                                        _react2.default.createElement(
	                                          'th',
	                                          null,
	                                          'Quality of Teachers'
	                                        ),
	                                        _react2.default.createElement(
	                                          'th',
	                                          null,
	                                          'Quality of information in website'
	                                        ),
	                                        _react2.default.createElement(
	                                          'th',
	                                          null,
	                                          'Quality of Teaching'
	                                        ),
	                                        _react2.default.createElement(
	                                          'th',
	                                          null,
	                                          'Campus & Facilities'
	                                        ),
	                                        _react2.default.createElement(
	                                          'th',
	                                          null,
	                                          'Quality of Interaction with other staff '
	                                        ),
	                                        _react2.default.createElement(
	                                          'th',
	                                          null,
	                                          'Transport arrangements'
	                                        ),
	                                        _react2.default.createElement(
	                                          'th',
	                                          null,
	                                          'Food at Campus'
	                                        ),
	                                        _react2.default.createElement(
	                                          'th',
	                                          null,
	                                          'Teacher to Students ratio'
	                                        ),
	                                        _react2.default.createElement(
	                                          'th',
	                                          null,
	                                          'Infrastructure'
	                                        ),
	                                        _react2.default.createElement(
	                                          'th',
	                                          null,
	                                          'Overall Ratings / Experience'
	                                        )
	                                      ) : '',
	                                      item.playarea_rating === true ? _react2.default.createElement(
	                                        _react2.default.Fragment,
	                                        null,
	                                        _react2.default.createElement(
	                                          'th',
	                                          null,
	                                          'Covid19 Responses/ Precautions'
	                                        ),
	                                        _react2.default.createElement(
	                                          'th',
	                                          null,
	                                          'Quality of food '
	                                        ),
	                                        _react2.default.createElement(
	                                          'th',
	                                          null,
	                                          'Quality of Staff'
	                                        ),
	                                        _react2.default.createElement(
	                                          'th',
	                                          null,
	                                          'Facilities @ location'
	                                        ),
	                                        _react2.default.createElement(
	                                          'th',
	                                          null,
	                                          'Cleanliness'
	                                        ),
	                                        _react2.default.createElement(
	                                          'th',
	                                          null,
	                                          'Quality of information @ Website'
	                                        ),
	                                        _react2.default.createElement(
	                                          'th',
	                                          null,
	                                          'Child Safety @ premises'
	                                        ),
	                                        _react2.default.createElement(
	                                          'th',
	                                          null,
	                                          'Fair Crowd size'
	                                        ),
	                                        _react2.default.createElement(
	                                          'th',
	                                          null,
	                                          'Facilities for parents @ Wait'
	                                        ),
	                                        _react2.default.createElement(
	                                          'th',
	                                          null,
	                                          'Overall Ratings / Experience'
	                                        )
	                                      ) : '',
	                                      item.hobbies_rating === true ? _react2.default.createElement(
	                                        _react2.default.Fragment,
	                                        null,
	                                        _react2.default.createElement(
	                                          'th',
	                                          null,
	                                          'Covid19 Responses/ Precautions'
	                                        ),
	                                        _react2.default.createElement(
	                                          'th',
	                                          null,
	                                          'Facilities for Parents @ Wait / Quality of Online Connection'
	                                        ),
	                                        _react2.default.createElement(
	                                          'th',
	                                          null,
	                                          'Quality of Teachers / Coaches'
	                                        ),
	                                        _react2.default.createElement(
	                                          'th',
	                                          null,
	                                          'Campus & Facilities'
	                                        ),
	                                        _react2.default.createElement(
	                                          'th',
	                                          null,
	                                          'Quality of Teaching / Coaching'
	                                        ),
	                                        _react2.default.createElement(
	                                          'th',
	                                          null,
	                                          'Quality of interaction with other staff'
	                                        ),
	                                        _react2.default.createElement(
	                                          'th',
	                                          null,
	                                          'Quality of information provided @ Website'
	                                        ),
	                                        _react2.default.createElement(
	                                          'th',
	                                          null,
	                                          'Student size per batch '
	                                        ),
	                                        _react2.default.createElement(
	                                          'th',
	                                          null,
	                                          'Child Safety @ premises'
	                                        ),
	                                        _react2.default.createElement(
	                                          'th',
	                                          null,
	                                          'Overall Ratings / Experience'
	                                        )
	                                      ) : '',
	                                      item.tution_rating === true || item.advice_rating === true ? _react2.default.createElement(
	                                        _react2.default.Fragment,
	                                        null,
	                                        _react2.default.createElement(
	                                          'th',
	                                          null,
	                                          'Covid19 Responses/ Precautions'
	                                        ),
	                                        _react2.default.createElement(
	                                          'th',
	                                          null,
	                                          'Campus & Facilities / Quality of Online Connection'
	                                        ),
	                                        _react2.default.createElement(
	                                          'th',
	                                          null,
	                                          'Quality of Teachers / Coaches / Counsellors (Capabilities)'
	                                        ),
	                                        _react2.default.createElement(
	                                          'th',
	                                          null,
	                                          'Ontime / Punctuality'
	                                        ),
	                                        _react2.default.createElement(
	                                          'th',
	                                          null,
	                                          'Quality of Teaching / Coaching / Counselling (Content)'
	                                        ),
	                                        _react2.default.createElement(
	                                          'th',
	                                          null,
	                                          'Overall Ratings / Experience'
	                                        ),
	                                        _react2.default.createElement(
	                                          'th',
	                                          null,
	                                          'Child Safety @ location'
	                                        )
	                                      ) : '',
	                                      item.camp_rating === true ? _react2.default.createElement(
	                                        _react2.default.Fragment,
	                                        null,
	                                        _react2.default.createElement(
	                                          'th',
	                                          null,
	                                          'Covid19 Responses/ Precautions'
	                                        ),
	                                        _react2.default.createElement(
	                                          'th',
	                                          null,
	                                          'Facilities for parents @ Wait'
	                                        ),
	                                        _react2.default.createElement(
	                                          'th',
	                                          null,
	                                          'Quality of Teachers / Coaches (Capabilities)'
	                                        ),
	                                        _react2.default.createElement(
	                                          'th',
	                                          null,
	                                          'Quality of information @ Website / Posters'
	                                        ),
	                                        _react2.default.createElement(
	                                          'th',
	                                          null,
	                                          'Quality of Teaching / Coaching (Content)'
	                                        ),
	                                        _react2.default.createElement(
	                                          'th',
	                                          null,
	                                          'Fair Crowd size'
	                                        ),
	                                        _react2.default.createElement(
	                                          'th',
	                                          null,
	                                          'Quality of food'
	                                        ),
	                                        _react2.default.createElement(
	                                          'th',
	                                          null,
	                                          'Infrastructure '
	                                        ),
	                                        _react2.default.createElement(
	                                          'th',
	                                          null,
	                                          'Campus & Facilities / Quality of Online Connection'
	                                        ),
	                                        _react2.default.createElement(
	                                          'th',
	                                          null,
	                                          'Transport arrangements'
	                                        ),
	                                        _react2.default.createElement(
	                                          'th',
	                                          null,
	                                          'Child Safety @ premisis'
	                                        ),
	                                        _react2.default.createElement(
	                                          'th',
	                                          null,
	                                          'Overall Ratings / Experience'
	                                        )
	                                      ) : ''
	                                    )
	                                  ),
	                                  _react2.default.createElement(
	                                    'tbody',
	                                    null,
	                                    _react2.default.createElement(
	                                      'tr',
	                                      { style: { 'background': '#ffffff' } },
	                                      item.preschool_rating === true ? _react2.default.createElement(
	                                        _react2.default.Fragment,
	                                        null,
	                                        _react2.default.createElement(
	                                          'td',
	                                          null,
	                                          item.preschool_covid19
	                                        ),
	                                        _react2.default.createElement(
	                                          'td',
	                                          null,
	                                          item.preschool_child_safety
	                                        ),
	                                        _react2.default.createElement(
	                                          'td',
	                                          null,
	                                          item.preschool_qty_teachers
	                                        ),
	                                        _react2.default.createElement(
	                                          'td',
	                                          null,
	                                          item.preschool_qty_info_website
	                                        ),
	                                        _react2.default.createElement(
	                                          'td',
	                                          null,
	                                          item.preschool_qty_teaching
	                                        ),
	                                        _react2.default.createElement(
	                                          'td',
	                                          null,
	                                          item.preschool_facilities
	                                        ),
	                                        _react2.default.createElement(
	                                          'td',
	                                          null,
	                                          item.preschool_qty_interaction
	                                        ),
	                                        _react2.default.createElement(
	                                          'td',
	                                          null,
	                                          item.preschool_transport_arrange
	                                        ),
	                                        _react2.default.createElement(
	                                          'td',
	                                          null,
	                                          item.preschool_food
	                                        ),
	                                        _react2.default.createElement(
	                                          'td',
	                                          null,
	                                          item.preschool_teacher_student_ratio
	                                        ),
	                                        _react2.default.createElement(
	                                          'td',
	                                          null,
	                                          item.preschool_infrastructure
	                                        ),
	                                        _react2.default.createElement(
	                                          'td',
	                                          null,
	                                          item.preschool_overall_expirence
	                                        )
	                                      ) : ''
	                                    ),
	                                    _react2.default.createElement(
	                                      'tr',
	                                      { style: { 'background': '#ffffff' } },
	                                      item.school_rating === true ? _react2.default.createElement(
	                                        _react2.default.Fragment,
	                                        null,
	                                        _react2.default.createElement(
	                                          'td',
	                                          null,
	                                          item.school_covid19
	                                        ),
	                                        _react2.default.createElement(
	                                          'td',
	                                          null,
	                                          item.school_child_safety
	                                        ),
	                                        _react2.default.createElement(
	                                          'td',
	                                          null,
	                                          item.school_qty_teachers
	                                        ),
	                                        _react2.default.createElement(
	                                          'td',
	                                          null,
	                                          item.school_qty_info_website
	                                        ),
	                                        _react2.default.createElement(
	                                          'td',
	                                          null,
	                                          item.school_qty_teaching
	                                        ),
	                                        _react2.default.createElement(
	                                          'td',
	                                          null,
	                                          item.school_facilities
	                                        ),
	                                        _react2.default.createElement(
	                                          'td',
	                                          null,
	                                          item.school_qty_interaction
	                                        ),
	                                        _react2.default.createElement(
	                                          'td',
	                                          null,
	                                          item.school_transport_arrange
	                                        ),
	                                        _react2.default.createElement(
	                                          'td',
	                                          null,
	                                          item.school_food
	                                        ),
	                                        _react2.default.createElement(
	                                          'td',
	                                          null,
	                                          item.school_teacher_student_ratio
	                                        ),
	                                        _react2.default.createElement(
	                                          'td',
	                                          null,
	                                          item.school_infrastructure
	                                        ),
	                                        _react2.default.createElement(
	                                          'td',
	                                          null,
	                                          item.school_overall_expirence
	                                        )
	                                      ) : ''
	                                    ),
	                                    _react2.default.createElement(
	                                      'tr',
	                                      { style: { 'background': '#ffffff' } },
	                                      item.playarea_rating === true ? _react2.default.createElement(
	                                        _react2.default.Fragment,
	                                        null,
	                                        _react2.default.createElement(
	                                          'td',
	                                          null,
	                                          item.playarea_covid19
	                                        ),
	                                        _react2.default.createElement(
	                                          'td',
	                                          null,
	                                          item.playarea_child_safety
	                                        ),
	                                        _react2.default.createElement(
	                                          'td',
	                                          null,
	                                          item.playarea_overall_expirence
	                                        ),
	                                        _react2.default.createElement(
	                                          'td',
	                                          null,
	                                          item.playarea_food
	                                        ),
	                                        _react2.default.createElement(
	                                          'td',
	                                          null,
	                                          item.playarea_qty_staff
	                                        ),
	                                        _react2.default.createElement(
	                                          'td',
	                                          null,
	                                          item.playarea_facilities_location
	                                        ),
	                                        _react2.default.createElement(
	                                          'td',
	                                          null,
	                                          item.playarea_cleanliness
	                                        ),
	                                        _react2.default.createElement(
	                                          'td',
	                                          null,
	                                          item.playarea_qty_info_website
	                                        ),
	                                        _react2.default.createElement(
	                                          'td',
	                                          null,
	                                          item.playarea_crowd_size
	                                        ),
	                                        _react2.default.createElement(
	                                          'td',
	                                          null,
	                                          item.playarea_facilities_parent
	                                        )
	                                      ) : ''
	                                    ),
	                                    _react2.default.createElement(
	                                      'tr',
	                                      { style: { 'background': '#ffffff' } },
	                                      item.hobbies_rating === true ? _react2.default.createElement(
	                                        _react2.default.Fragment,
	                                        null,
	                                        _react2.default.createElement(
	                                          'td',
	                                          null,
	                                          item.hobbies_covid19
	                                        ),
	                                        _react2.default.createElement(
	                                          'td',
	                                          null,
	                                          item.hobbies_facilities_parent
	                                        ),
	                                        _react2.default.createElement(
	                                          'td',
	                                          null,
	                                          item.hobbies_qty_teachers
	                                        ),
	                                        _react2.default.createElement(
	                                          'td',
	                                          null,
	                                          item.hobbies_campus_facilities
	                                        ),
	                                        _react2.default.createElement(
	                                          'td',
	                                          null,
	                                          item.hobbies_qty_teaching
	                                        ),
	                                        _react2.default.createElement(
	                                          'td',
	                                          null,
	                                          item.hobbies_qty_intraction
	                                        ),
	                                        _react2.default.createElement(
	                                          'td',
	                                          null,
	                                          item.hobbies_qty_info_website
	                                        ),
	                                        _react2.default.createElement(
	                                          'td',
	                                          null,
	                                          item.hobbies_batch_size
	                                        ),
	                                        _react2.default.createElement(
	                                          'td',
	                                          null,
	                                          item.hobbies_child_safety
	                                        ),
	                                        _react2.default.createElement(
	                                          'td',
	                                          null,
	                                          item.hobbies_covid19
	                                        )
	                                      ) : ''
	                                    ),
	                                    _react2.default.createElement(
	                                      'tr',
	                                      { style: { 'background': '#ffffff' } },
	                                      item.tution_rating === true ? _react2.default.createElement(
	                                        _react2.default.Fragment,
	                                        null,
	                                        _react2.default.createElement(
	                                          'td',
	                                          null,
	                                          item.tution_covid19
	                                        ),
	                                        _react2.default.createElement(
	                                          'td',
	                                          null,
	                                          item.tution_facilities
	                                        ),
	                                        _react2.default.createElement(
	                                          'td',
	                                          null,
	                                          item.tution_qty_teachers
	                                        ),
	                                        _react2.default.createElement(
	                                          'td',
	                                          null,
	                                          item.tution_ontime_punctuality
	                                        ),
	                                        _react2.default.createElement(
	                                          'td',
	                                          null,
	                                          item.tution_qty_teaching
	                                        ),
	                                        _react2.default.createElement(
	                                          'td',
	                                          null,
	                                          item.tution_overall_expirence
	                                        ),
	                                        _react2.default.createElement(
	                                          'td',
	                                          null,
	                                          item.tution_child_safety
	                                        )
	                                      ) : ''
	                                    ),
	                                    _react2.default.createElement(
	                                      'tr',
	                                      { style: { 'background': '#ffffff' } },
	                                      _this3.state.camp_rating === true ? _react2.default.createElement(
	                                        _react2.default.Fragment,
	                                        null,
	                                        _react2.default.createElement(
	                                          'td',
	                                          null,
	                                          item.camp_covid19
	                                        ),
	                                        _react2.default.createElement(
	                                          'td',
	                                          null,
	                                          item.camp_facilities_parents
	                                        ),
	                                        _react2.default.createElement(
	                                          'td',
	                                          null,
	                                          item.camp_qty_teachers
	                                        ),
	                                        _react2.default.createElement(
	                                          'td',
	                                          null,
	                                          item.camp_qty_info_website
	                                        ),
	                                        _react2.default.createElement(
	                                          'td',
	                                          null,
	                                          item.camp_qty_teaching
	                                        ),
	                                        _react2.default.createElement(
	                                          'td',
	                                          null,
	                                          item.camp_crowd_size
	                                        ),
	                                        _react2.default.createElement(
	                                          'td',
	                                          null,
	                                          item.camp_qty_food
	                                        ),
	                                        _react2.default.createElement(
	                                          'td',
	                                          null,
	                                          item.camp_infrastructure
	                                        ),
	                                        _react2.default.createElement(
	                                          'td',
	                                          null,
	                                          item.camp_campus_facilities
	                                        ),
	                                        _react2.default.createElement(
	                                          'td',
	                                          null,
	                                          item.camp_transport_arrange
	                                        ),
	                                        _react2.default.createElement(
	                                          'td',
	                                          null,
	                                          item.camp_child_safety
	                                        ),
	                                        _react2.default.createElement(
	                                          'td',
	                                          null,
	                                          item.camp_overall_expirence
	                                        )
	                                      ) : ''
	                                    ),
	                                    _react2.default.createElement(
	                                      'tr',
	                                      { style: { 'background': '#ffffff' } },
	                                      item.event_rating === true ? _react2.default.createElement(
	                                        _react2.default.Fragment,
	                                        null,
	                                        _react2.default.createElement(
	                                          'td',
	                                          null,
	                                          item.event_covid19
	                                        ),
	                                        _react2.default.createElement(
	                                          'td',
	                                          null,
	                                          item.event_covid19
	                                        ),
	                                        _react2.default.createElement(
	                                          'td',
	                                          null,
	                                          item.event_covid19
	                                        ),
	                                        _react2.default.createElement(
	                                          'td',
	                                          null,
	                                          item.event_covid19
	                                        ),
	                                        _react2.default.createElement(
	                                          'td',
	                                          null,
	                                          item.event_covid19
	                                        )
	                                      ) : ''
	                                    ),
	                                    _react2.default.createElement(
	                                      'tr',
	                                      { style: { 'background': '#ffffff' } },
	                                      item.advice_rating === true ? _react2.default.createElement(
	                                        _react2.default.Fragment,
	                                        null,
	                                        _react2.default.createElement(
	                                          'td',
	                                          null,
	                                          item.advice_covid19
	                                        ),
	                                        _react2.default.createElement(
	                                          'td',
	                                          null,
	                                          item.advice_facilities
	                                        ),
	                                        _react2.default.createElement(
	                                          'td',
	                                          null,
	                                          item.advice_qty_teachers
	                                        ),
	                                        _react2.default.createElement(
	                                          'td',
	                                          null,
	                                          item.advice_ontime_punctuality
	                                        ),
	                                        _react2.default.createElement(
	                                          'td',
	                                          null,
	                                          item.advice_qty_teaching
	                                        ),
	                                        _react2.default.createElement(
	                                          'td',
	                                          null,
	                                          item.advice_overall_expirence
	                                        ),
	                                        _react2.default.createElement(
	                                          'td',
	                                          null,
	                                          item.advice_child_safety
	                                        )
	                                      ) : ''
	                                    )
	                                  )
	                                )
	                              )
	                            )
	                          )
	                        );
	                      })
	                    ),
	                    _react2.default.createElement(
	                      _TabsPane2.default,
	                      { id: 'Enquiries' },
	                      _react2.default.createElement(
	                        _reactstrap.Modal,
	                        { isOpen: this.state.modalReplyEnq },
	                        _react2.default.createElement(
	                          'form',
	                          { onSubmit: this.replyMailEnq },
	                          _react2.default.createElement(
	                            _reactstrap.ModalHeader,
	                            null,
	                            _react2.default.createElement(
	                              'h3',
	                              null,
	                              'Send Response'
	                            )
	                          ),
	                          _react2.default.createElement(
	                            _reactstrap.ModalBody,
	                            { className: 'p-0' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'row' },
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-12 form-group' },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  'Message'
	                                ),
	                                _react2.default.createElement('textarea', { className: 'form-control', value: this.state.current_comment })
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-12 form-group' },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  'Reply'
	                                ),
	                                _react2.default.createElement('textarea', { rows: 5, className: 'form-control', required: true,
	                                  onChange: this.handleChange, name: 'new_reply', value: this.state.new_reply })
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            _reactstrap.ModalFooter,
	                            null,
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'row' },
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-12' },
	                                _react2.default.createElement(
	                                  'button',
	                                  { className: 'btn btn-sm btn-default', onClick: this.cancelPop },
	                                  'Close'
	                                ),
	                                _react2.default.createElement(
	                                  'button',
	                                  { type: 'submit', className: 'btn btn-sm btn-success' },
	                                  'Reply'
	                                )
	                              )
	                            )
	                          )
	                        )
	                      ),
	                      category_data.map(function (item, index) {
	                        return _react2.default.createElement(
	                          _reactstrap.Card,
	                          { className: 'panel-group custom-card', style: { marginBottom: '1rem' }, key: index },
	                          _react2.default.createElement(
	                            _reactstrap.CardHeader,
	                            { onClick: function onClick(e) {
	                                return _this3.toggle(e, index);
	                              }, 'data-event': index, className: 'custom-card-heading' },
	                            _react2.default.createElement(
	                              'b',
	                              null,
	                              item.category_name
	                            ),
	                            _react2.default.createElement(
	                              'small',
	                              null,
	                              item.sub_category_name ? ' - ' + item.sub_category_name : ''
	                            ),
	                            collapse !== index ? _react2.default.createElement(
	                              'span',
	                              { className: 'pull-right' },
	                              _react2.default.createElement('i', { 'class': 'fa fa-plus', 'aria-hidden': 'true' })
	                            ) : _react2.default.createElement(
	                              'span',
	                              { className: 'pull-right' },
	                              _react2.default.createElement('i', { 'class': 'fa fa-minus', 'aria-hidden': 'true' })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            _reactstrap.Collapse,
	                            { isOpen: collapse === index },
	                            _react2.default.createElement(
	                              _reactstrap.CardBody,
	                              { className: 'panel-body' },
	                              item.is_active == 0 ? _react2.default.createElement(
	                                'div',
	                                { className: 'row mar-btm' },
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'form-group col-md-12' },
	                                  _react2.default.createElement(
	                                    'h3',
	                                    { className: 'text-center' },
	                                    'Upgrade/Renewal to update the Data'
	                                  )
	                                )
	                              ) : _react2.default.createElement(
	                                'div',
	                                null,
	                                item.partner_connect && item.partner_connect.length > 0 && _react2.default.createElement(
	                                  'button',
	                                  { className: 'btn btn-sm btn-success pull-right', onClick: function onClick(e) {
	                                      return _this3.exportConnect(e, item);
	                                    } },
	                                  'Export'
	                                ),
	                                _react2.default.createElement(_reactDataTableComponent2.default, {
	                                  title: '',
	                                  columns: columns_pc,
	                                  data: item.partner_connect,
	                                  pagination: true,
	                                  customStyles: customStyles,
	                                  paginationComponentOptions: { noRowsPerPage: true }
	                                })
	                              )
	                            )
	                          )
	                        );
	                      })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'box-shadow-custom' },
	                  _react2.default.createElement(
	                    'h5',
	                    { className: 'astrick' },
	                    _react2.default.createElement(
	                      'b',
	                      null,
	                      'Notes'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'ul',
	                    null,
	                    _react2.default.createElement(
	                      'li',
	                      null,
	                      'Parent feedback and interactions tab gives the details of visitors / parents who have given their ratings / feedback and reply option is provided to reply them (optional). (same can be exported)'
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return partnerReview;
	}(_react.Component);
	
	exports.default = partnerReview;

/***/ },
/* 997 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FetchCall = __webpack_require__(4);
	
	var _simpleReactValidator = __webpack_require__(28);
	
	var _simpleReactValidator2 = _interopRequireDefault(_simpleReactValidator);
	
	var _constant = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrencyFormat = __webpack_require__(112);
	
	var Renewal = function (_Component) {
	  _inherits(Renewal, _Component);
	
	  function Renewal(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, Renewal);
	
	    var _this = _possibleConstructorReturn(this, (Renewal.__proto__ || Object.getPrototypeOf(Renewal)).call(this, props));
	
	    _this.getcurrentPlan = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var insdata;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              insdata = JSON.stringify({
	                user_type: _this.state.auth_data.user_type,
	                vendor_id: _this.state.auth_data.login_id,
	                url: 'getCurrentPlan'
	              });
	
	              (0, _FetchCall.partnerApi)(insdata).then(function (response) {
	                if (response.status === 1) {
	                  var data = response.results;
	                  var diffTime = Math.abs(new Date(data.expire) - new Date());
	                  var daysLeft = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
	                  console.log('daysLeft', daysLeft);
	                  var date = data.start_date ? new Date(data.start_date) : '';
	                  var enddate = data.end_date ? new Date(data.end_date) : '';
	                  var final_date = date ? date.getDate() + "-" + (date.getMonth() + 1) + "-" + date.getFullYear() : '';
	                  var end_date = enddate ? enddate.getDate() + "-" + (enddate.getMonth() + 1) + "-" + enddate.getFullYear() : '';
	                  _this.setState({
	                    pname: data.plan_name,
	                    payment_date: final_date,
	                    expire: data.expire,
	                    enddate: end_date,
	                    planamount: data.plan_amount,
	                    payable_amt: data.current_price,
	                    planid: data.planid,
	                    is_active: daysLeft > 1 ? true : false
	                  });
	                }
	              });
	
	            case 2:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    }));
	    _this.getPlanList = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	      var planData;
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              try {
	                planData = JSON.stringify({
	                  user_type: _this.state.auth_data.user_type
	                });
	
	
	                (0, _FetchCall.getPlan)(planData).then(function (response) {
	                  if (response.status == 1) {
	                    var current_plan = _this.state.auth_data.current_plan;
	
	                    var filtered = response.results.filter(function (item) {
	                      return item.id == current_plan;
	                    });
	                    if (filtered.length > 0) {
	                      var data = filtered[0];
	                      _this.setState({
	                        discamt: data.discount_amount,
	                        plan_price: data.discount_amount,
	                        payable_amt: data.plan_price,
	                        originalprice: data.base_price
	                      });
	                    }
	                  } else {
	                    console.log('else');
	                  }
	                });
	              } catch (error) {
	                _this.setState({ error: true });
	              }
	
	            case 1:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, _this2);
	    }));
	
	    _this.displayRazorpay = function () {
	      var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(e) {
	        var res, ins;
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                e.preventDefault();
	
	                if (!_this.validator.allValid()) {
	                  _context3.next = 12;
	                  break;
	                }
	
	                _context3.next = 4;
	                return _this.loadScript("https://checkout.razorpay.com/v1/checkout.js");
	
	              case 4:
	                res = _context3.sent;
	
	                if (res) {
	                  _context3.next = 8;
	                  break;
	                }
	
	                alert("Razorpay SDK failed to load. Are you online?");
	                return _context3.abrupt('return');
	
	              case 8:
	                ins = JSON.stringify({
	                  amount: _this.state.payable_amt
	                });
	
	                (0, _FetchCall.CreatePay)(ins).then(function (res) {
	                  _this.setState({
	                    amount: res.amount,
	                    order_id: res.id,
	                    currency: res.currency
	                  });
	                  _this.payinfo();
	                });
	                _context3.next = 14;
	                break;
	
	              case 12:
	                _this.validator.showMessages();
	                _this.forceUpdate();
	
	              case 14:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this2);
	      }));
	
	      return function (_x) {
	        return _ref3.apply(this, arguments);
	      };
	    }();
	
	    _this.state = {
	      logged: localStorage.getItem("authentication"),
	      auth_data: JSON.parse(localStorage.getItem("user_data")),
	      pname: '', planselect: false, errors: [],
	      planlist: [], upgradeplanid: '', planid: 0, plan_price: '', discamt: '', originalprice: '',
	      is_active: false, expire: '', payable_amt: 0
	
	    };
	    _this.validator = new _simpleReactValidator2.default();
	    _this.getcurrentPlan();
	    _this.getPlanList();
	    return _this;
	  }
	
	  _createClass(Renewal, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      //window.jQuery('.selectpicker').selectpicker('refresh');
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'render',
	    value: function render() {
	
	      console.log('sate', this.state.planlist);
	      this.validator.purgeFields();
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          'div',
	          { 'class': 'box-shadow-custom' },
	          _react2.default.createElement(
	            'div',
	            { 'class': 'row' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'form-group min-h-unset col-md-6' },
	              _react2.default.createElement(
	                'label',
	                null,
	                'Package Name : \xA0\xA0'
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                this.state.pname
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { 'class': 'row' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'form-group min-h-unset col-md-6' },
	              _react2.default.createElement(
	                'label',
	                null,
	                'Status : \xA0\xA0'
	              ),
	              this.state.is_active ? _react2.default.createElement(
	                'span',
	                { className: 'label label-primary' },
	                'Active'
	              ) : _react2.default.createElement(
	                'span',
	                { className: 'label label-danger' },
	                'Expired'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { 'class': 'row' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'form-group min-h-unset col-md-6' },
	              _react2.default.createElement(
	                'label',
	                null,
	                'Expire Date : \xA0\xA0'
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                this.state.enddate
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { 'class': 'row' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'form-group min-h-unset col-md-6' },
	              _react2.default.createElement(
	                'label',
	                null,
	                'Payable Amount : \xA0\xA0'
	              ),
	              _react2.default.createElement(CurrencyFormat, { value: this.state.payable_amt ? this.state.payable_amt : '0',
	                displayType: 'text', thousandSeparator: true, prefix: '₹' })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { 'class': 'row' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'form-group col-md-6' },
	              _react2.default.createElement(
	                'button',
	                { type: 'submit', className: 'btn btn-primary', onClick: this.displayRazorpay },
	                'PAY'
	              )
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'payinfo',
	    value: function payinfo() {
	      var This = this;
	      var payment_data;
	      var options = {
	        key: _constant.RAZORPAY_LIVE, // Enter the Key ID generated from the Dashboard
	        amount: this.state.amount.toString(),
	        currency: this.state.currency,
	        name: this.state.auth_data.first_name,
	        description: "Renewal - Partner Program",
	        // image: { logo },
	        // order_id: this.state.order_id,
	        handler: function () {
	          var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(response) {
	            var data;
	            return _regenerator2.default.wrap(function _callee4$(_context4) {
	              while (1) {
	                switch (_context4.prev = _context4.next) {
	                  case 0:
	                    console.log('response', response);
	                    This.handlePaySubmit(response);
	                    payment_data = response.razorpay_payment_id;
	                    data = {
	                      // orderCreationId: this.state.order_id,
	                      razorpayPaymentId: response.razorpay_payment_id,
	                      razorpayOrderId: response.razorpay_order_id,
	                      razorpaySignature: response.razorpay_signature
	                    };
	                    //  const result = await axios.post("/payment/success", data);
	
	                  case 4:
	                  case 'end':
	                    return _context4.stop();
	                }
	              }
	            }, _callee4, this);
	          }));
	
	          function handler(_x2) {
	            return _ref4.apply(this, arguments);
	          }
	
	          return handler;
	        }(),
	        prefill: {
	          name: this.state.auth_data.first_name,
	          email: this.state.auth_data.email_address,
	          contact: this.state.auth_data.phone_number
	        },
	        notes: {
	          address: this.state.auth_data.address
	        },
	        theme: {
	          color: "#61dafb"
	        }
	      };
	      var paymentObject = new window.Razorpay(options);
	      paymentObject.open();
	    }
	  }, {
	    key: 'loadScript',
	    value: function loadScript(src) {
	      return new Promise(function (resolve) {
	        var script = document.createElement("script");
	        script.src = src;
	        script.onload = function () {
	          resolve(true);
	        };
	        script.onerror = function () {
	          resolve(false);
	        };
	        document.body.appendChild(script);
	      });
	    }
	  }, {
	    key: 'handlePaySubmit',
	    value: function handlePaySubmit(response) {
	      var razorpay_payment_id = response.razorpay_payment_id;
	
	      if (razorpay_payment_id != '') {
	        var ins = '';
	        ins = JSON.stringify({
	          razorpay_payment_id: response.razorpay_payment_id,
	          razorpay_order_id: response.razorpay_payment_id,
	          razorpay_signature: response.razorpay_signature,
	          amount: this.state.payable_amt,
	          user_type: this.state.auth_data.user_type,
	          user_paytype: 1,
	          expire: this.state.expire,
	          discount: this.state.discamt ? this.state.discamt : 0,
	          discount_amount: this.state.plan_price ? this.state.plan_price : 0,
	          plan_price_original: this.state.originalprice ? this.state.originalprice : 0,
	          login_id: this.state.auth_data.login_id,
	          is_active: this.state.is_active,
	          plan_id: this.state.planid,
	          url: 'plan_renewal'
	        });
	
	        (0, _FetchCall.partnerApi)(ins).then(function (res) {
	          var toastr = '';
	          if (res.status === 1) {
	            toastr = window.toastr.success;
	            toastr('', 'Your plan has been upgraded.', {
	              positionClass: "toast-bottom-right",
	              containerId: "toast-bottom-right"
	            });
	            setTimeout(function () {
	              window.location.reload();
	            }, 2000);
	          } else {
	            var er = res.errors[0].msg;
	            toastr = window.toastr.error; //warning
	            toastr(er, toastr, {
	              positionClass: "toast-bottom-right",
	              containerId: "toast-bottom-right"
	            });
	          }
	        });
	      } else {
	        var toastr = '';
	        toastr = window.toastr.error; //warning
	        toastr('', 'Failed to Pay', {
	          positionClass: "toast-bottom-right",
	          containerId: "toast-bottom-right"
	        });
	      }
	    }
	  }]);
	
	  return Renewal;
	}(_react.Component);
	
	exports.default = Renewal;

/***/ },
/* 998 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FetchCall = __webpack_require__(4);
	
	var _simpleReactValidator = __webpack_require__(28);
	
	var _simpleReactValidator2 = _interopRequireDefault(_simpleReactValidator);
	
	var _constant = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Upgrade = function (_Component) {
	  _inherits(Upgrade, _Component);
	
	  function Upgrade(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, Upgrade);
	
	    var _this = _possibleConstructorReturn(this, (Upgrade.__proto__ || Object.getPrototypeOf(Upgrade)).call(this, props));
	
	    _this.getCurrentPlanList = function () {
	      var _this$state$auth_data = _this.state.auth_data,
	          user_type = _this$state$auth_data.user_type,
	          login_id = _this$state$auth_data.login_id;
	
	      var insdata = JSON.stringify({
	        user_type: user_type,
	        partner_id: login_id,
	        role: 3,
	        url: 'getPartnerPlanV1'
	      });
	      (0, _FetchCall.partnerSubscription)(insdata).then(function (response) {
	        if (response.status === 1) {
	          console.log("RR", response);
	          _this.setState({
	            package_list: response.plan_list,
	            upgradeList: response.upgrade_list,
	            cgst_per: response.tax_data.cgst,
	            sgst_per: response.tax_data.sgst,
	            coupon_id: response.coupon_data.coupon_id,
	            coupon_per_or: response.coupon_data.coupon_per,
	            coupon_amount_or: response.coupon_data.coupon_amount,
	            partner_name: response.partner.name, partner_email: response.partner.email, partner_address: response.partner.address
	          });
	        }
	      });
	    };
	
	    _this.handleChange = function (e) {
	      var period = e.target.value;
	      var nplanid = _this.state.upgradeplanid;
	      _this.setState(_defineProperty({}, e.target.name, period));
	      _this.setPrice(nplanid, period);
	    };
	
	    _this.handleplanchange = function (e) {
	      var _this$setState2;
	
	      var list = _this.state.planlist;
	      var nplanid = e.target.value;
	      var data = list.filter(function (item) {
	        return item.id == nplanid;
	      });
	      _this.setState((_this$setState2 = {}, _defineProperty(_this$setState2, e.target.name, nplanid), _defineProperty(_this$setState2, 'plan_ndesc', data[0].other_description), _this$setState2));
	
	      var period = _this.state.plan_period;
	      if (period) _this.setPrice(nplanid, period);
	    };
	
	    _this.customeChangeCheckBox = function (e, i, parent_id) {
	
	      var value = e.target.value;
	      var propsName = e.target.name;
	      var upgradeList = _this.state.upgradeList;
	      var booleanvalue = false;
	
	      var ele = document.getElementsByClassName('tobechecked_' + parent_id);
	      for (var k = 0; k < ele.length; k++) {
	        if (ele[k].type == 'checkbox') {
	          if (ele[k].checked) {
	            ele[k].setAttribute('checked', false);
	            ele[k].checked = false;
	            booleanvalue = false;
	          } else {
	            ele[k].setAttribute('checked', true);
	            ele[k].checked = true;
	            booleanvalue = true;
	          }
	        }
	
	        var indexatr = ele[k].getAttribute('data-index');
	        upgradeList[indexatr]['is_check'] = booleanvalue;
	      }
	
	      if (propsName == 'is_check') {
	        value = upgradeList[i].is_check == false || upgradeList[i].is_check == 'false' ? true : false;
	      }
	
	      if (value) upgradeList[i][propsName] = false;else upgradeList[i][propsName] = true;
	
	      upgradeList[i][propsName] = value;
	      if (upgradeList[i].nplan_id && upgradeList[i].period == undefined) upgradeList[i]['period'] = 365;
	
	      _this.setPrice(upgradeList[i].nplan_id, upgradeList[i].period, upgradeList, i);
	
	      var fdata = upgradeList.filter(function (item) {
	        return item.is_check === true && item.nplanid != 0 && parseInt(item.period) > 0;
	      });
	      if (fdata.length === 0) _this.setState({
	        basesubtotal: 0, subtotal: 0, discount_per: 0, discount_amount: 0, chart_discount: 0, chart_discount_amount: 0,
	        sgst_amount: 0, cgst_amount: 0, totalpayable: 0, totalselected: 0
	      });
	    };
	
	    _this.customeChangeCheckOthers = function (e, i, parent_id, checkbox_id) {
	      var THIS = _this;
	      var value = e.target.value;
	      var propsName = e.target.name;
	      var upgradeList = _this.state.upgradeList;
	      console.log("array", upgradeList);
	      var booleanvalue = false;
	      //check if any parent exist
	      var eleparent = document.getElementsByClassName('chk_' + parent_id);
	      for (var k = 0; k < eleparent.length; k++) {
	        if (eleparent[k].checked) {
	          eleparent[k].checked = false;
	          booleanvalue = false;
	          eleparent[k].setAttribute('checked', false);
	        } else {
	          eleparent[k].checked = true;
	          eleparent[k].setAttribute('checked', true);
	          booleanvalue = true;
	        }
	        var indexatr = eleparent[k].getAttribute('data-index');
	        upgradeList[indexatr]['is_check'] = booleanvalue;
	      }
	
	      var elecurrent = document.getElementsByClassName('chk_' + checkbox_id);
	      var booleanvalue2 = false;
	      var ele = document.getElementsByClassName('tobechecked_' + parent_id);
	      for (var l = 0; l < ele.length; l++) {
	
	        if (ele[l].type == 'checkbox' && ele[l].id != checkbox_id) {
	          if (ele[l].checked) {
	            ele[l].setAttribute('checked', false);
	            ele[l].checked = false;
	            booleanvalue2 = false;
	          } else {
	            ele[l].setAttribute('checked', true);
	            ele[l].checked = true;
	            booleanvalue2 = true;
	          }
	        }
	        var indexatr = ele[l].getAttribute('data-index');
	        upgradeList[indexatr]['is_check'] = booleanvalue;
	      }
	
	      if (propsName == 'is_check') {
	        value = upgradeList[i].is_check == false || upgradeList[i].is_check == 'false' ? true : false;
	      }
	
	      if (value) upgradeList[i][propsName] = false;else upgradeList[i][propsName] = true;
	      _this.setState({
	        checking: true
	      });
	      if (upgradeList[i].nplan_id && upgradeList[i].period == undefined) upgradeList[i]['period'] = 365;
	      _this.setPrice(upgradeList[i].nplan_id, upgradeList[i].period, upgradeList, i);
	
	      var fdata = upgradeList.filter(function (item) {
	        return item.is_check === true && item.nplanid != 0 && parseInt(item.period) > 0;
	      });
	      if (fdata.length === 0) _this.setState({
	        basesubtotal: 0, subtotal: 0, discount_per: 0, discount_amount: 0,
	        sgst_amount: 0, cgst_amount: 0, totalpayable: 0, totalselected: 0
	      });
	      setTimeout(function () {
	        THIS.setState({
	          checking: false
	        });
	      }, 1000);
	    };
	
	    _this.customeChange = function (e, i) {
	      var THIS = _this;
	      var value = e.target.value;
	      var propsName = e.target.name;
	      var upgradeList = _this.state.upgradeList;
	      if (propsName == 'is_check') {
	        value = upgradeList[i].is_check == false || upgradeList[i].is_check == 'false' ? true : false;
	      }
	      _this.setState({
	        checking: true
	      });
	      upgradeList[i][propsName] = value;
	      if (upgradeList[i].nplan_id && upgradeList[i].period == undefined) upgradeList[i]['period'] = 365;
	
	      _this.setPrice(upgradeList[i].nplan_id, upgradeList[i].period, upgradeList, i);
	
	      var fdata = upgradeList.filter(function (item) {
	        return item.is_check === true && item.nplanid != 0 && parseInt(item.period) > 0;
	      });
	      if (fdata.length === 0) _this.setState({
	        basesubtotal: 0, subtotal: 0, discount_per: 0, discount_amount: 0,
	        sgst_amount: 0, cgst_amount: 0, totalpayable: 0, totalselected: 0
	      });
	      setTimeout(function () {
	        THIS.setState({
	          checking: false
	        });
	      }, 500);
	    };
	
	    _this.setPrice = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(plan_id, period, upgradeList, i) {
	        var selected_plan, list, data, plan_price, base_price, discount_amount, discount_percent, temp, final_data, _this$state$auth_data2, user_type, login_id;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                console.log('setprice', plan_id, period, upgradeList, i);
	                selected_plan = plan_id;
	                list = _this.state.planlist;
	
	                console.log("selected plan", selected_plan);
	                data = list.filter(function (item) {
	                  return item.id == selected_plan;
	                });
	
	                console.log("plannnnn", data);
	                plan_price = data[0].plan_price;
	                base_price = data[0].base_price;
	                discount_amount = data[0].discount_amount;
	                discount_percent = data[0].discount_percent;
	
	                if (period == 183) {
	                  temp = parseFloat(data[0].base_price) % 2;
	                  // base_price = parseFloat(temp) > 0 ? parseFloat(data[0].base_price) + 1 : parseFloat(data[0].base_price);
	
	                  base_price = data[0].price_six;
	                  plan_price = data[0].price_six;
	                  discount_percent = 0;
	                  discount_amount = 0;
	                }
	                console.log('plan_price', plan_price);
	                console.log('base_price', base_price);
	                console.log('discount_amount', discount_amount);
	                console.log('discount_percent', discount_percent);
	                console.log('discount_percent', _this.state.planid);
	
	                if (!(upgradeList[i].cplan_id == 0)) {
	                  _context.next = 24;
	                  break;
	                }
	
	                upgradeList[i].plan_price = Math.round(plan_price);
	                upgradeList[i].base_price = Math.round(base_price);
	                upgradeList[i].discamt = discount_amount;
	                upgradeList[i].discount_percent = discount_percent;
	                upgradeList[i].other_description = '(Bewise ' + data[0].plan_name + ' - ' + upgradeList[i].cplan_name + ')';
	                // this.setState({
	                //   plan_price: Math.round(plan_price),
	                //   originalprice: base_price,
	                //   discamt: discount_amount,
	                //   discount: discount_percent,
	                //   other_description: `(Bewise ${data[0].plan_name} - ${upgradeList[i].cplan_name})`,
	                // });
	                _context.next = 32;
	                break;
	
	              case 24:
	                _context.next = 26;
	                return _this.getProrate(plan_price, period, upgradeList, i);
	
	              case 26:
	                final_data = _context.sent;
	
	                upgradeList[i].plan_price = Math.round(final_data.plan_price);
	                upgradeList[i].base_price = final_data.base_price;
	                upgradeList[i].discamt = final_data.discamt;
	                upgradeList[i].discount_percent = final_data.discount_percent;
	                upgradeList[i].other_description = '(Bewise ' + data[0].plan_name + ' - ' + _this.state.curren_plname + ')';
	
	              case 32:
	                upgradeList[i].new_plname = 'Bewise ' + data[0].plan_name;
	
	                //special discount
	                _this$state$auth_data2 = _this.state.auth_data, user_type = _this$state$auth_data2.user_type, login_id = _this$state$auth_data2.login_id;
	
	                if (login_id == 1026) {
	                  upgradeList[i].base_price = upgradeList[i].base_price - 750;
	                  upgradeList[i].plan_price = upgradeList[i].plan_price - 750;
	                }
	
	                _this.setState({
	                  upgradeList: upgradeList
	                });
	                console.log("upgradelist", upgradeList);
	
	                _this.calculateAmount(upgradeList);
	
	              case 38:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x, _x2, _x3, _x4) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.calculateAmount = function (upgradeList) {
	      var data = upgradeList;
	      var selected_count = 0;
	      var fdata = data.filter(function (item) {
	        return item.is_check === true && item.nplanid != 0 && parseInt(item.period) > 0;
	      });
	      selected_count = fdata.length;
	      var subtotal = 0,
	          osubtotal = 0;
	      var total_discount_per = 0;
	      var basesubtotal = 0,
	          cgst_amount = 0,
	          sgst_amount = 0,
	          total_payable = 0,
	          chart_discount = 0,
	          chart_discount_amount = 0;
	      if (selected_count > 0) {
	        fdata.map(function (item, i) {
	          subtotal = subtotal + item.plan_price;
	          basesubtotal = basesubtotal + item.base_price;
	        });
	        osubtotal = subtotal;
	        var total_discount_amt = basesubtotal - subtotal;
	        var postDis = parseFloat(basesubtotal) - parseFloat(total_discount_amt);
	        total_discount_per = Math.round(100 * ((parseFloat(basesubtotal) - postDis) / parseFloat(basesubtotal)));
	        var coupon_amount = 0,
	            coupon_per = 0,
	            coupon_applied = false;
	        var chartCalc = _this.calculateChartAmount(fdata);
	        chart_discount_amount = chartCalc.total_discount;
	        subtotal = parseFloat(subtotal) - parseFloat(chartCalc.total_discount);
	        chart_discount = Math.round(100 * ((parseFloat(osubtotal) - subtotal) / parseFloat(osubtotal)));
	        osubtotal = subtotal;
	        if (selected_count >= 1 && (_this.state.coupon_amount_or > 0 || _this.state.coupon_per_or > 0)) {
	          if (_this.state.coupon_amount_or > 0) {
	            var temptotal = subtotal;
	            subtotal = subtotal - parseFloat(_this.state.coupon_amount_or);
	            var postCoup = parseFloat(temptotal) - parseFloat(_this.state.coupon_amount_or);
	            coupon_amount = _this.state.coupon_amount_or;
	            coupon_per = (100 * ((parseFloat(temptotal) - postCoup) / parseFloat(temptotal))).toFixed(2);
	          }
	          if (_this.state.coupon_per_or > 0) {
	            coupon_per = _this.state.coupon_per_or;
	            coupon_amount = (subtotal * parseFloat(_this.state.coupon_per_or) / 100).toFixed(2);
	            subtotal = subtotal - parseFloat(coupon_amount);
	          }
	          coupon_applied = true;
	        }
	        if (_this.state.cgst_per > 0) {
	          cgst_amount = (subtotal * parseFloat(_this.state.cgst_per) / 100).toFixed(2);
	        }
	        if (_this.state.sgst_per > 0) {
	          sgst_amount = (subtotal * parseFloat(_this.state.sgst_per) / 100).toFixed(2);
	        }
	        total_payable = parseFloat(sgst_amount) + parseFloat(cgst_amount) + parseFloat(subtotal);
	
	        _this.setState({
	          basesubtotal: basesubtotal, subtotal: osubtotal,
	          chart_discount_amount: chart_discount_amount, chart_discount: chart_discount,
	          discount_per: total_discount_per, discount_amount: total_discount_amt,
	          sgst_amount: sgst_amount, cgst_amount: cgst_amount, totalpayable: Math.round(total_payable),
	          totalselected: selected_count, coupon_amount: coupon_amount, coupon_per: coupon_per
	        });
	      }
	    };
	
	    _this.displayRazorpay = function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(e) {
	        var res, ins;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                e.preventDefault();
	
	                if (!_this.validator.allValid()) {
	                  _context2.next = 12;
	                  break;
	                }
	
	                _context2.next = 4;
	                return _this.loadScript("https://checkout.razorpay.com/v1/checkout.js");
	
	              case 4:
	                res = _context2.sent;
	
	                if (res) {
	                  _context2.next = 8;
	                  break;
	                }
	
	                alert("Razorpay SDK failed to load. Are you online?");
	                return _context2.abrupt('return');
	
	              case 8:
	                ins = JSON.stringify({
	                  amount: _this.state.totalpayable
	                });
	
	                (0, _FetchCall.CreatePay)(ins).then(function (res) {
	                  _this.setState({
	                    amount: res.amount,
	                    order_id: res.id,
	                    currency: res.currency
	                  });
	                  _this.payinfo();
	                });
	                _context2.next = 14;
	                break;
	
	              case 12:
	                _this.validator.showMessages();
	                _this.forceUpdate();
	
	              case 14:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }));
	
	      return function (_x5) {
	        return _ref2.apply(this, arguments);
	      };
	    }();
	
	    _this.handlePaySubmit = function (response) {
	      var razorpay_payment_id = response.razorpay_payment_id;
	
	      if (razorpay_payment_id != '') {
	        var ins = '';
	        var upgradeList = _this.state.upgradeList.filter(function (item) {
	          return item.is_check === true && item.nplanid != 0 && parseInt(item.period) > 0;
	        });
	        ins = JSON.stringify({
	          razorpay_payment_id: response.razorpay_payment_id,
	          razorpay_order_id: response.razorpay_payment_id,
	          razorpay_signature: response.razorpay_signature,
	          basesubtotal: _this.state.basesubtotal,
	          subtotal: _this.state.subtotal,
	          discount_per: _this.state.discount_per,
	          coupon_id: _this.state.coupon_applied ? _this.state.coupon_id : 0,
	          discount_amount: _this.state.discount_amount, coupon_per: _this.state.coupon_per,
	          coupon_amount: _this.state.coupon_amount, sgst_per: _this.state.sgst_per,
	          cgst_per: _this.state.cgst_per, sgst_amount: _this.state.sgst_amount,
	          cgst_amount: _this.state.cgst_amount, totalpayable: _this.state.totalpayable, totalselected: _this.state.totalselected,
	          chart_discount_amount: _this.state.chart_discount_amount,
	          chart_discount: _this.state.chart_discount,
	          user_type: _this.state.auth_data.user_type,
	          user_paytype: 1,
	          upgradeList: upgradeList,
	          invoice_type: 2,
	          login_id: _this.state.auth_data.login_id,
	          url: 'updatevendorplan',
	          role: 3
	        });
	        // console.log('update values', JSON.parse(ins));
	        // return false;
	        (0, _FetchCall.partnerSubscription)(ins).then(function (res) {
	          var toastr = '';
	          if (res.status === 1) {
	            toastr = window.toastr.success;
	            toastr('', 'Your plan has been upgraded.', {
	              positionClass: "toast-bottom-right",
	              containerId: "toast-bottom-right"
	            });
	            _this.state.auth_data.is_active = 1;
	            localStorage.setItem('user_data', JSON.stringify(_this.state.auth_data));
	            localStorage.setItem('is_active', 1);
	            setTimeout(function () {
	              window.location.reload();
	            }, 2000);
	          } else {
	            var er = res.message;
	            toastr = window.toastr.error; //warning
	            toastr(er, toastr, {
	              positionClass: "toast-bottom-right",
	              containerId: "toast-bottom-right"
	            });
	          }
	        });
	      } else {
	        var toastr = '';
	        toastr = window.toastr.error; //warning
	        toastr('', 'Failed to Pay', {
	          positionClass: "toast-bottom-right",
	          containerId: "toast-bottom-right"
	        });
	      }
	    };
	
	    _this.state = {
	      logged: localStorage.getItem("authentication"),
	      auth_data: JSON.parse(localStorage.getItem("user_data")),
	      chart_data: [],
	      package_list: [],
	      upgradeList: [],
	      pname: '', planselect: false, errors: [],
	      basesubtotal: 0, subtotal: 0, discount_per: 0, discount_amount: 0, coupon_per: 0, chart_discount: 0, chart_discount_amount: 0,
	      coupon_amount: 0, sgst_per: 0, cgst_per: 0, sgst_amount: 0, cgst_amount: 0, totalpayable: 0, totalselected: 0,
	      partner_name: '', partner_email: '', partner_address: '', coupon_per_or: 0, coupon_amount_or: 0,
	      coupon_applied: false
	      // planlist: [], upgradeplanid: '', planid: 0, plan_price: '', discamt: '', originalprice: '',
	      // curren_plname: '', new_plname: '', other_description: '', plan_period: '', plan_ndesc: '',
	    };
	    _this.validator = new _simpleReactValidator2.default();
	    _this.getPlanList();
	    _this.getChartData();
	    _this.getCurrentPlanList();
	
	    return _this;
	  }
	
	  _createClass(Upgrade, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      window.jQuery('.selectpicker').selectpicker('refresh');
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.jQuery('.selectpicker').selectpicker('refresh');
	    }
	  }, {
	    key: 'getPlanList',
	    value: function getPlanList() {
	      var _this3 = this;
	
	      var planData = JSON.stringify({
	        user_type: this.state.auth_data.user_type
	      });
	      (0, _FetchCall.getPlan)(planData).then(function (response) {
	        if (response.status == 1) {
	          _this3.setState({
	            planlist: response.results
	          });
	        }
	      });
	    }
	  }, {
	    key: 'getChartData',
	    value: function getChartData() {
	      var _this4 = this;
	
	      var planData = JSON.stringify({
	        user_type: this.state.auth_data.user_type,
	        role: 3,
	        url: 'getPriceChart'
	      });
	      (0, _FetchCall.partnerSubscription)(planData).then(function (response) {
	        if (response.status == 1) {
	          console.log('response.results', response.results);
	          _this4.setState({
	            chart_data: response.results ? response.results : []
	          });
	        }
	      });
	    }
	  }, {
	    key: 'getProrate',
	    value: function () {
	      var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(planprice, period, upgradeList, i) {
	        var last_paid, expire, startdate, totalDays, today, diffTimeUsed, daysUsed, oldperday, newoldprice, payableamout;
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                last_paid = parseFloat(upgradeList[i].last_paid);
	                expire = upgradeList[i].end_date != '0000-00-00' ? new Date(upgradeList[i].end_date) : new Date();
	                startdate = upgradeList[i].start_date != '0000-00-00' ? new Date(upgradeList[i].start_date) : new Date();
	                totalDays = period;
	                today = new Date();
	                diffTimeUsed = Math.abs(startdate - today);
	                daysUsed = Math.ceil(diffTimeUsed / (1000 * 60 * 60 * 24));
	                oldperday = last_paid / totalDays;
	                newoldprice = last_paid - oldperday * daysUsed;
	                payableamout = Math.round(planprice - newoldprice);
	                return _context3.abrupt('return', {
	                  plan_price: payableamout,
	                  base_price: payableamout,
	                  discamt: 0,
	                  discount_percent: 0
	                });
	
	              case 11:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, this);
	      }));
	
	      function getProrate(_x6, _x7, _x8, _x9) {
	        return _ref3.apply(this, arguments);
	      }
	
	      return getProrate;
	    }()
	  }, {
	    key: 'calculateChartAmount',
	    value: function calculateChartAmount(items) {
	      items = items.filter(function (data) {
	        return data.period == '365';
	      });
	      console.log('items', items);
	      var discount_amount = 0,
	          total_amount = 0,
	          total_sub = 0,
	          total_discount = 0;
	      var chart_data = this.state.chart_data;
	      var planlist = this.state.planlist;
	      var vertical_count = items.length;
	      var branch_result = items.reduce(function (r, a) {
	        r[a.set_id] = r[a.set_id] || [];
	        r[a.set_id].push(a);
	        return r;
	      }, Object.create(null));
	      var branch_count = Object.keys(branch_result).length;
	      var arr = [];
	      planlist.map(function (item, i) {
	        var temp = items.filter(function (idata) {
	          return idata.nplan_id == item.id;
	        });
	        arr.push({
	          plan_id: item.id,
	          count: temp.length
	        });
	      });
	      var maxPeak = arr.reduce(function (p, c) {
	        return p.count > c.count ? p : c;
	      });
	      var calcData = chart_data.filter(function (data) {
	        return data.package_id == maxPeak.plan_id;
	      });
	      if (calcData.length > 0) {
	        calcData = calcData[0];
	        if (calcData.price_chart) {
	          var type = _typeof(calcData.price_chart);
	          if (type == 'string') calcData.price_chart = JSON.parse(calcData.price_chart);
	          var branchIndex = calcData.price_chart.cols.findIndex(function (object) {
	            return branch_count >= object.minVal && branch_count <= object.maxVal;
	          });
	          console.log('** branchIndex', branchIndex);
	
	          var _loop = function _loop(key) {
	            var tp1 = 0,
	                tp2 = 0;
	            var vlen = branch_result[key].length;
	            console.log('** vlen', vlen);
	            var arrTemp = branch_result[key];
	            vlen = vlen - 1;
	            tp1 = parseFloat(calcData.price_chart.rows[vlen].rcolVal[branchIndex]);
	            if (branchIndex > 0) {
	              tp2 = parseFloat(calcData.price_chart.rows[vlen].rcolVal[0]);
	              tp1 = parseFloat(calcData.price_chart.rows[vlen].rcolVal[branchIndex]);
	            }
	            console.log('** %', tp2, tp1);
	            var subtotal = 0;
	            arrTemp.map(function (cdata, i) {
	              subtotal = subtotal + cdata.plan_price;
	            });
	            total_amount = total_amount + subtotal;
	            console.log('subtotal 1', subtotal);
	            if (branchIndex > 0) {
	              if (tp2 > 0) {
	                var d1 = subtotal * parseFloat(tp2) / 100;
	                total_discount = total_discount + d1;
	                subtotal = subtotal - d1;
	              }
	            }
	            console.log('subtotal 2', subtotal);
	            if (tp1 > 0) {
	              var d2 = subtotal * parseFloat(tp1) / 100;
	              total_discount = total_discount + d2;
	              subtotal = subtotal - d2;
	            }
	            total_sub = total_sub + subtotal;
	          };
	
	          var _iteratorNormalCompletion = true;
	          var _didIteratorError = false;
	          var _iteratorError = undefined;
	
	          try {
	            for (var _iterator = Object.keys(branch_result)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	              var key = _step.value;
	
	              _loop(key);
	            }
	          } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	              }
	            } finally {
	              if (_didIteratorError) {
	                throw _iteratorError;
	              }
	            }
	          }
	
	          console.log('subtotal 5', total_amount, total_discount, total_sub);
	          // let tempVlen = calcData.price_chart.rows.length;
	          // if (vertical_count >= tempVlen) {
	          //   vertical_count = tempVlen;
	          // }
	          // let verticalIndex = vertical_count - 1;
	          // const discountPercent = calcData.price_chart.rows[verticalIndex].rcolVal[branchIndex];
	          // let total = 0;
	          // items.map((data, i) => {
	          //   total = total + data.plan_price;
	          // })
	          // if (discountPercent > 0)
	          //   discount_amount = ((total) * parseFloat(discountPercent) / 100).toFixed(2);
	          // console.log('calcData.price_chart b', total, discount_amount, discountPercent)
	        }
	      }
	      return { total_amount: total_amount, total_discount: total_discount, total_sub: total_sub };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      this.validator.purgeFields();
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          'div',
	          { 'class': 'box-shadow-custom desktoponly' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'p',
	              { className: 'alert' },
	              '* Check items to add billing'
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'alert' },
	              '* if you want to delete any of schools / categories / branches, please do so under branches or categories'
	            ),
	            _react2.default.createElement(
	              'div',
	              { 'class': 'col-md-12' },
	              _react2.default.createElement(
	                'table',
	                { className: 'table-responsive content-sec col-md-12 col-xs-12 pad-no mar-t-no' },
	                _react2.default.createElement(
	                  'thead',
	                  null,
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      { width: '10%' },
	                      'Check for Billing'
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      null,
	                      'Name'
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      null,
	                      'Category'
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      null,
	                      'Current Plan'
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      null,
	                      'Select Package'
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      null,
	                      'Period'
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      null,
	                      'Amount'
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'tbody',
	                  null,
	                  this.state.upgradeList.map(function (item, i) {
	                    return _react2.default.createElement(
	                      'tr',
	                      null,
	                      _react2.default.createElement(
	                        'td',
	                        null,
	                        item.parent_id != 0 && item.cplan_id == 0 && _react2.default.createElement('input', { type: 'checkbox', 'data-index': i, id: item.main_id, className: 'form-control checkbox-cus tobechecked_' + item.parent_id + ' chk_' + item.main_id,
	                          name: 'is_check', defaultChecked: item.is_check == true ? true : false, onChange: function onChange(e) {
	                            return _this5.customeChangeCheckOthers(e, i, item.parent_id, item.main_id);
	                          } }),
	                        item.parent_id == 0 && item.cplan_id == 0 && _react2.default.createElement('input', { type: 'checkbox', 'data-index': i, className: 'form-control checkbox-cus tobechecked_' + item.parent_id + ' chk_' + item.main_id,
	                          name: 'is_check', defaultChecked: item.is_check == true ? true : false, onChange: function onChange(e) {
	                            return _this5.customeChangeCheckBox(e, i, item.main_id);
	                          } }),
	                        item.cplan_id != 0 && _react2.default.createElement('input', { type: 'checkbox', 'data-index': i, className: 'form-control checkbox-cus',
	                          name: 'is_check', defaultChecked: item.is_check == true ? true : false, onChange: function onChange(e) {
	                            return _this5.customeChange(e, i);
	                          } })
	                      ),
	                      _react2.default.createElement(
	                        'td',
	                        null,
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          item.organisation_name
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'td',
	                        null,
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          item.category_name
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'td',
	                        null,
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          item.cplan_name
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'td',
	                        null,
	                        _react2.default.createElement(
	                          'select',
	                          { title: 'Select', onChange: function onChange(e) {
	                              return _this5.customeChange(e, i);
	                            }, name: 'nplan_id',
	                            className: 'form-control selectpicker', value: item.nplan_id },
	                          _this5.state.package_list.map(function (items, i) {
	                            {
	                              if (items.id != item.cplan_id && items.id > item.cplan_id) {
	
	                                return _react2.default.createElement(
	                                  'option',
	                                  { value: items.id },
	                                  items.plan_name
	                                );
	                              }
	                            }
	                          })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'td',
	                        null,
	                        item.nplan_id > 0 && _react2.default.createElement(
	                          'select',
	                          {
	                            name: 'period',
	                            value: item.period,
	                            onChange: function onChange(e) {
	                              return _this5.customeChange(e, i);
	                            },
	                            className: 'form-control selectpicker plan_period', title: 'Period' },
	                          _react2.default.createElement(
	                            'option',
	                            { value: '365' },
	                            '12 Months'
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'td',
	                        { className: 'text-right' },
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          item.base_price ? Number(item.base_price).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') : 0
	                        )
	                      )
	                    );
	                  })
	                ),
	                _react2.default.createElement(
	                  'tfoot',
	                  null,
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'td',
	                      { colSpan: '6', className: 'text-right' },
	                      _react2.default.createElement(
	                        'b',
	                        null,
	                        'Total'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { className: 'text-right' },
	                      Number(this.state.basesubtotal).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
	                    )
	                  ),
	                  this.state.discount_amount > 0 && _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'td',
	                      { colSpan: '6', className: 'text-right' },
	                      _react2.default.createElement(
	                        'b',
	                        null,
	                        'Early Bird Offer'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { className: 'text-right' },
	                      Number(this.state.discount_amount).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
	                    )
	                  ),
	                  this.state.chart_discount_amount > 0 && _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'td',
	                      { colSpan: '6', className: 'text-right' },
	                      _react2.default.createElement(
	                        'b',
	                        null,
	                        'Offer'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { className: 'text-right' },
	                      Number(this.state.chart_discount_amount).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'td',
	                      { colSpan: '6', className: 'text-right' },
	                      _react2.default.createElement(
	                        'b',
	                        null,
	                        'Sub Total'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { className: 'text-right' },
	                      Number(this.state.subtotal).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
	                    )
	                  ),
	                  (this.state.coupon_amount_or > 0 || this.state.coupon_per_or > 0) && _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'td',
	                      { colSpan: '6', className: 'text-right' },
	                      _react2.default.createElement(
	                        'b',
	                        null,
	                        'Coupon applied (',
	                        this.state.coupon_per + ' %',
	                        ')'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { className: 'text-right' },
	                      Number(this.state.coupon_amount).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'td',
	                      { colSpan: '6', className: 'text-right' },
	                      _react2.default.createElement(
	                        'b',
	                        null,
	                        'SGST  ',
	                        this.state.sgst_per > 0 && '(' + this.state.sgst_per + '%)'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { className: 'text-right' },
	                      Number(this.state.sgst_amount).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'td',
	                      { colSpan: '6', className: 'text-right' },
	                      _react2.default.createElement(
	                        'b',
	                        null,
	                        'CGST ',
	                        this.state.cgst_per > 0 && '(' + this.state.cgst_per + '%)'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { className: 'text-right' },
	                      Number(this.state.cgst_amount).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'td',
	                      { colSpan: '6', className: 'text-right' },
	                      _react2.default.createElement(
	                        'b',
	                        null,
	                        'Total Payable (\u20B9)'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { className: 'text-right' },
	                      Number(this.state.totalpayable).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          this.state.totalselected > 0 && _react2.default.createElement(
	            'div',
	            { 'class': 'row' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'col-md-12 col-xs-12 btn-bdr text-right pad-hor-no mar-btm' },
	              _react2.default.createElement(
	                'button',
	                { type: 'submit', className: 'btn btn-primary',
	                  onClick: this.displayRazorpay
	                },
	                'SUBMIT'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { 'class': 'mobileonly hidden' },
	          _react2.default.createElement(
	            'div',
	            { 'class': 'box-shadow-custom ' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'p',
	                { className: 'alert' },
	                '* Check items to add billing'
	              ),
	              _react2.default.createElement(
	                'p',
	                { className: 'alert' },
	                '* if you want to delete any of schools / categories / branches, please do so under branches or categories'
	              ),
	              _react2.default.createElement(
	                'div',
	                { 'class': 'col-md-12' },
	                this.state.upgradeList.map(function (item, i) {
	                  return _react2.default.createElement(
	                    'div',
	                    { 'class': 'mobileinvline box-shadow-custom' },
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'foldtl' },
	                      item.parent_id != 0 && item.cplan_id == 0 && _react2.default.createElement('input', { type: 'checkbox', 'data-index': i, id: item.main_id, className: 'form-control checkbox-cus tobechecked_' + item.parent_id + ' chk_' + item.main_id,
	                        name: 'is_check', defaultChecked: item.is_check == true ? true : false, onChange: function onChange(e) {
	                          return _this5.customeChangeCheckOthers(e, i, item.parent_id, item.main_id);
	                        } }),
	                      item.parent_id == 0 && item.cplan_id == 0 && _react2.default.createElement('input', { type: 'checkbox', 'data-index': i, className: 'form-control checkbox-cus tobechecked_' + item.parent_id + ' chk_' + item.main_id,
	                        name: 'is_check', defaultChecked: item.is_check == true ? true : false, onChange: function onChange(e) {
	                          return _this5.customeChangeCheckBox(e, i, item.main_id);
	                        } }),
	                      item.cplan_id != 0 && _react2.default.createElement('input', { type: 'checkbox', 'data-index': i, className: 'form-control checkbox-cus',
	                        name: 'is_check', defaultChecked: item.is_check == true ? true : false, onChange: function onChange(e) {
	                          return _this5.customeChange(e, i);
	                        } }),
	                      ' '
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      null,
	                      _react2.default.createElement(
	                        'b',
	                        null,
	                        'Name :'
	                      ),
	                      ' ',
	                      _react2.default.createElement('br', null),
	                      ' ',
	                      item.organisation_name
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      null,
	                      _react2.default.createElement(
	                        'b',
	                        null,
	                        'Category :'
	                      ),
	                      ' ',
	                      _react2.default.createElement('br', null),
	                      ' ',
	                      item.category_name
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      null,
	                      _react2.default.createElement(
	                        'b',
	                        null,
	                        'Current Plan :'
	                      ),
	                      ' ',
	                      _react2.default.createElement('br', null),
	                      ' ',
	                      item.cplan_name
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      null,
	                      _react2.default.createElement(
	                        'b',
	                        null,
	                        'Select Package :'
	                      ),
	                      ' ',
	                      _react2.default.createElement('br', null),
	                      ' ',
	                      _react2.default.createElement(
	                        'select',
	                        { title: 'Select', onChange: function onChange(e) {
	                            return _this5.customeChange(e, i);
	                          }, name: 'nplan_id',
	                          className: 'form-control selectpicker', value: item.nplan_id },
	                        _this5.state.package_list.map(function (items, i) {
	                          {
	                            if (items.id != item.cplan_id && items.id > item.cplan_id) {
	
	                              return _react2.default.createElement(
	                                'option',
	                                { value: items.id },
	                                items.plan_name
	                              );
	                            }
	                          }
	                        })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      null,
	                      _react2.default.createElement(
	                        'b',
	                        null,
	                        'Period :'
	                      ),
	                      ' ',
	                      _react2.default.createElement('br', null),
	                      ' ',
	                      item.nplan_id > 0 && _react2.default.createElement(
	                        'select',
	                        {
	                          name: 'period',
	                          value: item.period,
	                          onChange: function onChange(e) {
	                            return _this5.customeChange(e, i);
	                          },
	                          className: 'form-control selectpicker plan_period', title: 'Period' },
	                        _react2.default.createElement(
	                          'option',
	                          { value: '365' },
	                          '12 Months'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: '183' },
	                          '6 Months'
	                        )
	                      ),
	                      ' '
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      null,
	                      _react2.default.createElement(
	                        'b',
	                        null,
	                        'Amount :'
	                      ),
	                      ' ',
	                      _react2.default.createElement('br', null),
	                      ' ',
	                      item.base_price ? item.base_price : 0
	                    )
	                  );
	                })
	              ),
	              this.state.totalselected > 0 && _react2.default.createElement(
	                'div',
	                { 'class': 'col-md-12 col-xs-12 btn-bdr text-right pad-hor-no mar-btm' },
	                _react2.default.createElement(
	                  'button',
	                  { type: 'submit', className: 'btn btn-primary',
	                    onClick: this.displayRazorpay
	                  },
	                  'SUBMIT'
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'payinfo',
	    value: function payinfo() {
	      var This = this;
	      var payment_data;
	      var options = {
	        key: _constant.RAZORPAY_TEST, // Enter the Key ID generated from the Dashboard
	        amount: this.state.amount.toString(),
	        currency: this.state.currency,
	        name: this.state.partner_name,
	        description: "Plan Upgrade - Partner Program",
	        // image: { logo },
	        // order_id: this.state.order_id,
	        handler: function () {
	          var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(response) {
	            var data;
	            return _regenerator2.default.wrap(function _callee4$(_context4) {
	              while (1) {
	                switch (_context4.prev = _context4.next) {
	                  case 0:
	                    console.log('response', response);
	                    This.handlePaySubmit(response);
	                    payment_data = response.razorpay_payment_id;
	                    data = {
	                      // orderCreationId: this.state.order_id,
	                      razorpayPaymentId: response.razorpay_payment_id,
	                      razorpayOrderId: response.razorpay_order_id,
	                      razorpaySignature: response.razorpay_signature
	                    };
	                    //  const result = await axios.post("/payment/success", data);
	
	                  case 4:
	                  case 'end':
	                    return _context4.stop();
	                }
	              }
	            }, _callee4, this);
	          }));
	
	          function handler(_x10) {
	            return _ref4.apply(this, arguments);
	          }
	
	          return handler;
	        }(),
	        prefill: {
	          name: this.state.partner_name,
	          email: this.state.partner_email
	        },
	        notes: {
	          address: this.state.partner_address
	        },
	        theme: {
	          color: "#61dafb"
	        }
	      };
	      var paymentObject = new window.Razorpay(options);
	      paymentObject.open();
	    }
	  }, {
	    key: 'loadScript',
	    value: function loadScript(src) {
	      return new Promise(function (resolve) {
	        var script = document.createElement("script");
	        script.src = src;
	        script.onload = function () {
	          resolve(true);
	        };
	        script.onerror = function () {
	          resolve(false);
	        };
	        document.body.appendChild(script);
	      });
	    }
	
	    // handlePaySubmit = () => {
	
	  }]);
	
	  return Upgrade;
	}(_react.Component);
	
	exports.default = Upgrade;

/***/ },
/* 999 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FetchCall = __webpack_require__(4);
	
	var _simpleReactValidator = __webpack_require__(28);
	
	var _simpleReactValidator2 = _interopRequireDefault(_simpleReactValidator);
	
	var _constant = __webpack_require__(21);
	
	var _reactstrap = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/*
	const bewisevalue = {
	
	    plan_name:"BeWise Value",
	    plan_base_price:12499, //12499
	    plan_final_price:12499,
	    plan_duration:12,
	    plan_duration_period:'month(s)',
	    plan_discount:0,
	    plan_total_price:(12499-0),
	    plan_sdesc:'',
	    plan_modal:"bewisevalue"
	}
	*/
	var bewisevalue = {
	
	  plan_name: "BeWise Value",
	  plan_base_price: 12499, //12499
	  plan_final_price: 12499,
	  plan_duration: 12,
	  plan_duration_period: 'month(s)',
	  plan_discount: 0,
	  plan_total_price: 12499 - 0,
	  plan_sdesc: '',
	  plan_modal: "bewisevalue"
	};
	
	var bewisemagic = {
	
	  plan_name: "BeWise Magic",
	  plan_base_price: 19999,
	  plan_final_price: 19999,
	  plan_duration: 12,
	  plan_duration_period: 'month(s)',
	  plan_discount: 0,
	  plan_total_price: 19999 - 0,
	  plan_sdesc: '',
	  plan_modal: "bewisemagic"
	};
	
	var bewisevalueaddon = {
	
	  plan_name: "Addon - Branch",
	  plan_base_price: 6250,
	  plan_final_price: 6250,
	  plan_duration: 12,
	  plan_duration_period: 'month(s)',
	  plan_discount: 0,
	  plan_total_price: 6250 - 0,
	  plan_sdesc: '',
	  plan_modal: "bewisevalueaddon"
	};
	
	var bewisemagicaddon = {
	
	  plan_name: "Addon - Branch",
	  plan_base_price: 9999,
	  plan_final_price: 9999,
	  plan_duration: 12,
	  plan_duration_period: 'month(s)',
	  plan_discount: 0,
	  plan_total_price: 9999 - 0,
	  plan_sdesc: '',
	  plan_modal: "bewisemagicaddon" //50% discount from 19999 baseprice
	};
	
	var wiseconnect = {
	
	  plan_name: "WiseConnect",
	  plan_base_price: 699,
	  plan_final_price: 8388,
	  plan_duration: 12,
	  plan_duration_period: 'month(s)',
	  plan_sdesc: '',
	  plan_discount: 8388,
	  plan_total_price: 8388 - 8388,
	  plan_modal: "wiseconnect"
	
	};
	
	var wiseconnectexclusive = {
	
	  plan_name: "WiseConnect Exclusive",
	  plan_base_price: 1299,
	  plan_final_price: 7794,
	  plan_duration: 6,
	  plan_duration_period: 'month(s)',
	  plan_sdesc: '',
	  plan_discount: 0,
	  plan_total_price: 7794 - 0,
	  plan_modal: "wiseconnectexclusive"
	};
	
	var UpgradeV1 = function (_Component) {
	  _inherits(UpgradeV1, _Component);
	
	  function UpgradeV1(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, UpgradeV1);
	
	    var _this = _possibleConstructorReturn(this, (UpgradeV1.__proto__ || Object.getPrototypeOf(UpgradeV1)).call(this, props));
	
	    _this.subscribeTrail = function () {
	
	      var insdata = JSON.stringify({
	        user_type: _this.state.auth_data.user_type,
	        vendor_id: _this.state.auth_data.login_id,
	        code: _this.state.code
	      });
	
	      (0, _FetchCall.checkAndsubscribeWiseConnect)(insdata).then(function (response) {
	        if (response.status === 1) {
	          _this.setState({ wc_success: true, wc_error: false, wc_success_message: response.message });
	        } else {
	          _this.setState({ wc_error: true, wc_success: false, wc_error_message: response.message });
	        }
	      });
	    };
	
	    _this.getSpecialDiscount = function () {
	      var insdata = JSON.stringify({
	        uid: _this.state.auth_data.uid
	      });
	      (0, _FetchCall.getSpecialDiscount)(insdata).then(function (response) {
	        if (response.status === 1) {
	          _this.setState({ special_discount: response.special_discount_formatted });
	        }
	      });
	    };
	
	    _this.getAddonList = function () {
	      var insdata = JSON.stringify({
	        vendor_id: _this.state.auth_data.login_id,
	        url: 'getAddonList'
	      });
	      (0, _FetchCall.getAddonList)(insdata).then(function (response) {
	        if (response.status === 1) {
	          _this.setState({ addonlist: response.list });
	        }
	      });
	    };
	
	    _this.getcurrentPlan = function () {
	      var insdata = JSON.stringify({
	        user_type: _this.state.auth_data.user_type,
	        vendor_id: _this.state.auth_data.login_id,
	        url: 'getCurrentPlanV1'
	      });
	      (0, _FetchCall.partnerSubscription)(insdata).then(function (response) {
	        if (response.status === 1) {
	          var isupgraded = response.upgraded;
	
	          if (isupgraded == 1) {
	
	            _this.getSubscriptions();
	          }
	          _this.setState({ upgraded: isupgraded });
	        }
	      });
	    };
	
	    _this.getSubscriptions = function () {
	
	      var insdata = JSON.stringify({
	        vendor_id: _this.state.auth_data.login_id
	      });
	      (0, _FetchCall.getPartnerSubscriptions)(insdata).then(function (response) {
	        if (response.status === 1) {
	          _this.setState({ subscriptionList: response.list });
	        } else {
	          _this.setState({ subscriptionList: [] });
	        }
	      });
	    };
	
	    _this.openPlanPop = function (modalid) {
	      if (modalid == 'wiseconnect') _this.setState({ openPopupPlanWc: true });
	
	      if (modalid == 'wiseconnectexclusive') _this.setState({ openPopupPlanWcExcl: true });
	
	      if (modalid == 'bewisevalue') _this.setState({ openPopupPlanBv: true });
	
	      if (modalid == 'bewisemagic') _this.setState({ openPopupPlanMg: true });
	
	      if (modalid == 'bewisevalueaddon') _this.setState({ openPopupAddOn: true });
	
	      if (modalid == 'bewisemagicaddon') _this.setState({ openPopupAddOn: true });
	    };
	
	    _this.handleChange = function (e) {
	      var propName = e.target.name;
	      var propValue = e.target.value;
	      _this.setState(_defineProperty({}, propName, propValue));
	    };
	
	    _this.displayRazorpay = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(e) {
	        var res, ins;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                e.preventDefault();
	
	                if (!_this.validator.allValid()) {
	                  _context.next = 12;
	                  break;
	                }
	
	                _context.next = 4;
	                return _this.loadScript("https://checkout.razorpay.com/v1/checkout.js");
	
	              case 4:
	                res = _context.sent;
	
	                if (res) {
	                  _context.next = 8;
	                  break;
	                }
	
	                alert("Razorpay SDK failed to load. Are you online?");
	                return _context.abrupt('return');
	
	              case 8:
	                ins = JSON.stringify({
	                  amount: _this.state.totalpayable
	                });
	
	                (0, _FetchCall.CreatePay)(ins).then(function (res) {
	                  _this.setState({
	                    amount: res.amount,
	                    order_id: res.id,
	                    currency: res.currency
	                  });
	                  _this.payinfo();
	                });
	                _context.next = 14;
	                break;
	
	              case 12:
	                _this.validator.showMessages();
	                _this.forceUpdate();
	
	              case 14:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.handlePaySubmit = function (response) {
	      var razorpay_payment_id = response.razorpay_payment_id;
	
	      if (razorpay_payment_id != '') {
	        var ins = '';
	        //let upgradeList = this.state.upgradeList.filter((item) => (item.is_check === true && item.nplanid != 0 && parseInt(item.period) > 0));
	        var upgradeList = _this.state.package_list;
	
	        if (_this.state.planname != 'bewisevalueaddon' && _this.state.planname != 'bewisemagicaddon') {
	          ins = JSON.stringify({
	            razorpay_payment_id: response.razorpay_payment_id,
	            razorpay_order_id: response.razorpay_payment_id,
	            razorpay_signature: response.razorpay_signature,
	            basesubtotal: _this.state.basesubtotal,
	            subtotal: _this.state.subtotal,
	            discount_per: _this.state.discount_per,
	            coupon_id: _this.state.coupon_applied ? _this.state.coupon_id : 0,
	            discount_amount: _this.state.discount_amount, coupon_per: _this.state.coupon_per,
	            coupon_amount: _this.state.coupon_amount, sgst_per: _this.state.sgst_per,
	            cgst_per: _this.state.cgst_per, sgst_amount: _this.state.sgst_amount,
	            cgst_amount: _this.state.cgst_amount, totalpayable: _this.state.totalpayable, totalselected: _this.state.totalselected,
	            chart_discount_amount: _this.state.chart_discount_amount,
	            chart_discount: _this.state.chart_discount,
	            user_type: _this.state.auth_data.user_type,
	            user_paytype: 1,
	            upgradeList: upgradeList,
	            plan: _this.state.plan_name,
	            upgraded_plan: _this.state.planname,
	            invoice_type: 2,
	            login_id: _this.state.auth_data.login_id,
	            uid: _this.state.auth_data.uid,
	            order_id: _this.state.order_id,
	            email_id: _this.state.auth_data.email_id,
	            first_name: _this.state.auth_data.first_name,
	            last_name: _this.state.auth_data.last_name,
	
	            url: 'upgradeonly',
	            role: 3
	          });
	          console.log('update values', JSON.parse(ins));
	          // return false;
	
	
	          (0, _FetchCall.partnerSubscription)(ins).then(function (res) {
	
	            if (res.status === 1) {
	
	              _this.state.auth_data.is_active = 1;
	              localStorage.setItem('user_data', JSON.stringify(_this.state.auth_data));
	              localStorage.setItem('is_active', 1);
	              _this.setState({ paymentsuccess: true, paymentresponse: response });
	
	              setTimeout(function () {
	                window.location.reload();
	              }, 5000);
	            }
	          });
	        } else {
	
	          ins = JSON.stringify({
	            razorpay_payment_id: response.razorpay_payment_id,
	            razorpay_order_id: response.razorpay_payment_id,
	            razorpay_signature: response.razorpay_signature,
	            basesubtotal: _this.state.basesubtotal,
	            subtotal: _this.state.subtotal,
	            discount_per: _this.state.discount_per,
	            coupon_id: _this.state.coupon_applied ? _this.state.coupon_id : 0,
	            discount_amount: _this.state.discount_amount, coupon_per: _this.state.coupon_per,
	            coupon_amount: _this.state.coupon_amount, sgst_per: _this.state.sgst_per,
	            cgst_per: _this.state.cgst_per, sgst_amount: _this.state.sgst_amount,
	            cgst_amount: _this.state.cgst_amount, totalpayable: _this.state.totalpayable, totalselected: _this.state.totalselected,
	            chart_discount_amount: _this.state.chart_discount_amount,
	            chart_discount: _this.state.chart_discount,
	            user_type: _this.state.auth_data.user_type,
	            user_paytype: 1,
	            upgradeList: upgradeList,
	            plan: _this.state.plan_name,
	            upgraded_plan: _this.state.planname,
	            invoice_type: 2,
	            login_id: _this.state.auth_data.login_id,
	            uid: _this.state.auth_data.uid,
	            order_id: _this.state.order_id,
	
	            email_id: _this.state.auth_data.email_id,
	            first_name: _this.state.auth_data.first_name,
	            last_name: _this.state.auth_data.last_name,
	
	            url: 'upgradeonly'
	          });
	          console.log('update values', JSON.parse(ins));
	          // return false;
	
	
	          (0, _FetchCall.partnerSubscription)(ins).then(function (res) {
	
	            if (res.status === 1) {
	
	              _this.state.auth_data.is_active = 1;
	              localStorage.setItem('user_data', JSON.stringify(_this.state.auth_data));
	              localStorage.setItem('is_active', 1);
	              _this.setState({ paymentsuccess: true, paymentresponse: response });
	
	              setTimeout(function () {
	                window.location.reload();
	              }, 5000);
	            }
	          });
	        }
	      } else {
	        alert("error ");
	        console.log(response.error);
	      }
	    };
	
	    _this.handlePaySubmitDummy = function (response) {
	      var razorpay_payment_id = "XYZ00001";
	      var razorpay_signature = "SIG2343434";
	
	      if (razorpay_payment_id != '') {
	        var ins = '';
	        //let upgradeList = this.state.upgradeList.filter((item) => (item.is_check === true && item.nplanid != 0 && parseInt(item.period) > 0));
	        var upgradeList = _this.state.package_list;
	        ins = JSON.stringify({
	          razorpay_payment_id: razorpay_payment_id,
	          razorpay_order_id: razorpay_payment_id,
	          razorpay_signature: razorpay_signature,
	          basesubtotal: _this.state.basesubtotal,
	          subtotal: _this.state.subtotal,
	          discount_amount: _this.state.discount_amount,
	          totalpayable: _this.state.totalpayable,
	          user_type: _this.state.auth_data.user_type,
	          user_paytype: 1,
	          upgradeList: upgradeList,
	          plan: _this.state.plan,
	          invoice_type: 2,
	          login_id: _this.state.auth_data.login_id,
	          url: 'upgradeonly',
	          role: 3
	        });
	        // console.log('update values', JSON.parse(ins));
	        // return false;
	        (0, _FetchCall.partnerSubscription)(ins).then(function (res) {
	          var toastr = '';
	          if (res.status === 1) {
	            alert("updated");
	            /*
	            toastr = window.toastr.success;
	            toastr('', 'Your plan has been upgraded.', {
	              positionClass: "toast-bottom-right",
	              containerId: "toast-bottom-right"
	            });
	            this.state.auth_data.is_active = 1;
	            localStorage.setItem('user_data', JSON.stringify(this.state.auth_data));
	            localStorage.setItem('is_active', 1);
	            setTimeout(function () {
	              window.location.reload();
	            }, 2000);
	            */
	          } else {
	            var er = res.message;
	            alert("not updated");
	            /*
	            toastr = window.toastr.error; //warning
	            toastr(er, toastr, {
	              positionClass: "toast-bottom-right",
	              containerId: "toast-bottom-right"
	            });
	            */
	          }
	        });
	      } else {
	        var toastr = '';
	        alert("error ");
	        /*
	        toastr = window.toastr.error; //warning
	        toastr('', 'Failed to Pay', {
	          positionClass: "toast-bottom-right",
	          containerId: "toast-bottom-right"
	        });
	        */
	      }
	    };
	
	    _this.state = {
	      logged: localStorage.getItem("authentication"),
	      auth_data: JSON.parse(localStorage.getItem("user_data")),
	      chart_data: [],
	      upgradeClicked: true,
	      planselected: false,
	      package_list: [],
	      upgradeList: [],
	      subscriptionList: [],
	      paymentsuccess: false,
	      addonlist: [],
	      plan: '',
	      order_id: 0,
	      special_discount: 0,
	      special_discount_view: 0,
	      paymentresponse: [],
	      pname: '', planselect: false, errors: [],
	      basesubtotal: 0, subtotal: 0, discount_per: 0, discount_amount: 0, coupon_per: 0, chart_discount: 0, chart_discount_amount: 0,
	      coupon_amount: 0, sgst_per: 0, cgst_per: 0, sgst_amount: 0, cgst_amount: 0, totalpayable: 0, totalselected: 0,
	      partner_name: '', partner_email: '', partner_address: '', coupon_per_or: 0, coupon_amount_or: 0,
	      coupon_applied: false
	      // planlist: [], upgradeplanid: '', planid: 0, plan_price: '', discamt: '', originalprice: '',
	      // curren_plname: '', new_plname: '', other_description: '', plan_period: '', plan_ndesc: '',
	    };
	    _this.validator = new _simpleReactValidator2.default();
	    //this.getPlanList();
	    //this.getChartData();
	    //this.getCurrentPlanList();
	
	    _this.showForm = _this.showForm.bind(_this);
	    _this.openPopupPlanStandard = _this.openPopupPlanStandard.bind(_this);
	    _this.cancelPop1 = _this.cancelPop1.bind(_this);
	    _this.cancelPopAddon = _this.cancelPopAddon.bind(_this);
	    _this.cancelPopWc = _this.cancelPopWc.bind(_this);
	    _this.cancelPopBv = _this.cancelPopBv.bind(_this);
	    _this.cancelPopWcExcl = _this.cancelPopWcExcl.bind(_this);
	    _this.executeUpgradeList = _this.executeUpgradeList.bind(_this);
	    _this.handlePaySubmitDummy = _this.handlePaySubmitDummy.bind(_this);
	    _this.handlePaySubmit = _this.handlePaySubmit.bind(_this);
	    _this.getSubscriptions = _this.getSubscriptions.bind(_this);
	    _this.subscribeTrail = _this.subscribeTrail.bind(_this);
	    _this.getAddonList = _this.getAddonList.bind(_this);
	    _this.getSpecialDiscount = _this.getSpecialDiscount.bind(_this);
	
	    return _this;
	  }
	
	  _createClass(UpgradeV1, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.jQuery('.selectpicker').selectpicker('refresh');
	      this.getcurrentPlan();
	      this.getAddonList();
	      this.getSpecialDiscount();
	    }
	  }, {
	    key: 'openPopupPlanStandard',
	    value: function openPopupPlanStandard() {
	      this.setState({ openPopupPlanStandard: true });
	    }
	  }, {
	    key: 'cancelPop1',
	    value: function cancelPop1() {
	      this.setState({ openPopupPlanStandard: false });
	    }
	  }, {
	    key: 'cancelPopAddon',
	    value: function cancelPopAddon() {
	      this.setState({ openPopupAddOn: false });
	    }
	  }, {
	    key: 'cancelPopBv',
	    value: function cancelPopBv() {
	      this.setState({ openPopupPlanBv: false });
	    }
	  }, {
	    key: 'cancelPopWc',
	    value: function cancelPopWc() {
	      this.setState({ openPopupPlanWc: false });
	    }
	  }, {
	    key: 'cancelPopWcExcl',
	    value: function cancelPopWcExcl() {
	      this.setState({ openPopupPlanWcExcl: false });
	    }
	  }, {
	    key: 'showForm',
	    value: function showForm() {
	
	      this.setState({ upgradeClicked: true });
	    }
	  }, {
	    key: 'executeUpgradeList',
	    value: function executeUpgradeList(e) {
	
	      var keyselected = e.target.value;
	
	      this.setState({ planselected: true, planname: keyselected });
	
	      if (keyselected == 'bwvwc') {
	        var pk = [];
	        pk.push(bewisevalue, wiseconnect);
	
	        var total = bewisevalue.plan_total_price + wiseconnect.plan_total_price;
	        var discount_amount = total * this.state.special_discount;
	
	        var discount_amount_view = new Intl.NumberFormat('en-IN', {
	          style: 'currency',
	          currency: 'INR'
	        }).format(discount_amount);
	
	        var discounted_total = total - discount_amount;
	
	        var discounted_total_view = new Intl.NumberFormat('en-IN', {
	          style: 'currency',
	          currency: 'INR'
	        }).format(discounted_total);
	
	        var subtotal_view = new Intl.NumberFormat('en-IN', {
	          style: 'currency',
	          currency: 'INR'
	        }).format(total);
	
	        this.setState({ package_list: pk,
	          plan_name: bewisevalue.plan_name + "+" + wiseconnect.plan_name,
	          special_discount_view: discount_amount_view,
	          subtotal: total,
	          subtotal_view: subtotal_view,
	          total: discounted_total,
	          total_view: discounted_total_view,
	          totalpayable: discounted_total });
	
	        //this.setState({package_list:pk, total: (bewisevalue.plan_total_price+wiseconnect.plan_total_price), subtotal:(bewisevalue.plan_total_price+wiseconnect.plan_total_price), totalpayable:(bewisevalue.plan_total_price+wiseconnect.plan_total_price)});
	      }
	
	      if (keyselected == 'bwmwc') {
	        var _pk = [];
	        _pk.push(bewisemagic, wiseconnect);
	        this.setState({ package_list: _pk,
	          plan_name: bewisevalue.plan_name + "+" + wiseconnect.plan_name,
	          total: bewisemagic.plan_total_price + wiseconnect.plan_total_price, subtotal: bewisemagic.plan_total_price + wiseconnect.plan_total_price, totalpayable: bewisemagic.plan_total_price + wiseconnect.plan_total_price });
	      }
	
	      if (keyselected == 'wconly') {
	        var _pk2 = [];
	        _pk2.push(wiseconnectexclusive);
	        this.setState({ package_list: _pk2, plan_name: wiseconnectexclusive.plan_name, subtotal: wiseconnectexclusive.plan_total_price, total: wiseconnectexclusive.plan_total_price, totalpayable: wiseconnectexclusive.plan_total_price });
	      }
	      if (this.state.addonlist.length > 0) {
	
	        if (keyselected == 'bwv') {
	          var _pk3 = [];
	          _pk3.push(bewisevalue);
	          _pk3.push(bewisevalueaddon);
	
	          var _total = bewisevalue.plan_total_price + bewisevalueaddon.plan_total_price;
	          var _discount_amount = _total * this.state.special_discount;
	
	          var discount_amount_view = new Intl.NumberFormat('en-IN', {
	            style: 'currency',
	            currency: 'INR'
	          }).format(_discount_amount);
	
	          var _discounted_total = _total - _discount_amount;
	
	          var discounted_total_view = new Intl.NumberFormat('en-IN', {
	            style: 'currency',
	            currency: 'INR'
	          }).format(_discounted_total);
	
	          var subtotal_view = new Intl.NumberFormat('en-IN', {
	            style: 'currency',
	            currency: 'INR'
	          }).format(_total);
	
	          this.setState({ order_id: this.state.addonlist[0].order_id,
	            package_list: _pk3,
	            plan_name: bewisevalue.plan_name + "+" + bewisevalueaddon.plan_name,
	            special_discount_view: discount_amount_view,
	            subtotal: _total,
	            subtotal_view: subtotal_view,
	            total: _discounted_total,
	            total_view: discounted_total_view,
	            totalpayable: _discounted_total });
	        }
	
	        if (keyselected == 'bwvwc') {
	          var _pk4 = [];
	          _pk4.push(bewisevalue, bewisevalueaddon, wiseconnect);
	
	          var _total2 = bewisevalue.plan_total_price + wiseconnect.plan_total_price + bewisevalueaddon.plan_total_price;
	          var _discount_amount2 = _total2 * this.state.special_discount;
	          var discount_amount_view = new Intl.NumberFormat('en-IN', {
	            style: 'currency',
	            currency: 'INR'
	          }).format(_discount_amount2);
	
	          var _discounted_total2 = _total2 - _discount_amount2;
	
	          var discounted_total_view = new Intl.NumberFormat('en-IN', {
	            style: 'currency',
	            currency: 'INR'
	          }).format(_discounted_total2);
	
	          var subtotal_view = new Intl.NumberFormat('en-IN', {
	            style: 'currency',
	            currency: 'INR'
	          }).format(_total2);
	
	          this.setState({ order_id: this.state.addonlist[0].order_id,
	            package_list: _pk4,
	            plan_name: bewisevalue.plan_name + "+" + bewisemagicaddon.plan_name + "+" + wiseconnect.plan_name,
	            special_discount_view: discount_amount_view,
	            subtotal: _total2,
	            subtotal_view: subtotal_view,
	            total: _discounted_total2,
	            total_view: discounted_total_view,
	            totalpayable: _discounted_total2 });
	        }
	
	        if (keyselected == 'bwmwc') {
	
	          var _pk5 = [];
	          _pk5.push(bewisemagic, bewisemagicaddon, wiseconnect);
	
	          var _total3 = bewisemagic.plan_total_price + wiseconnect.plan_total_price + bewisemagicaddon.plan_total_price;
	          var _discount_amount3 = _total3 * this.state.special_discount;
	          var discount_amount_view = new Intl.NumberFormat('en-IN', {
	            style: 'currency',
	            currency: 'INR'
	          }).format(_discount_amount3);
	
	          var _discounted_total3 = _total3 - _discount_amount3;
	
	          var discounted_total_view = new Intl.NumberFormat('en-IN', {
	            style: 'currency',
	            currency: 'INR'
	          }).format(_discounted_total3);
	
	          var subtotal_view = new Intl.NumberFormat('en-IN', {
	            style: 'currency',
	            currency: 'INR'
	          }).format(_total3);
	
	          this.setState({ order_id: this.state.addonlist[0].order_id,
	            package_list: _pk5,
	            plan_name: bewisemagic.plan_name + "+" + bewisemagicaddon.plan_name + "+" + wiseconnect.plan_name,
	            special_discount_view: discount_amount_view,
	            subtotal: _total3,
	            subtotal_view: subtotal_view,
	            total: _discounted_total3,
	            total_view: discounted_total_view,
	            totalpayable: _discounted_total3 });
	        }
	
	        if (keyselected == 'bwm') {
	          var _pk6 = [];
	          _pk6.push(bewisemagic);
	          _pk6.push(bewisemagicaddon);
	
	          var _total4 = bewisemagic.plan_total_price + bewisemagicaddon.plan_total_price;
	          var _discount_amount4 = _total4 * this.state.special_discount;
	
	          var discount_amount_view = new Intl.NumberFormat('en-IN', {
	            style: 'currency',
	            currency: 'INR'
	          }).format(_discount_amount4);
	
	          var _discounted_total4 = _total4 - _discount_amount4;
	
	          var discounted_total_view = new Intl.NumberFormat('en-IN', {
	            style: 'currency',
	            currency: 'INR'
	          }).format(_discounted_total4);
	
	          var subtotal_view = new Intl.NumberFormat('en-IN', {
	            style: 'currency',
	            currency: 'INR'
	          }).format(_total4);
	
	          this.setState({ order_id: this.state.addonlist[0].order_id,
	            package_list: _pk6,
	            plan_name: bewisemagic.plan_name + "+" + bewisemagicaddon.plan_name,
	            special_discount_view: discount_amount_view,
	            subtotal: _total4,
	            subtotal_view: subtotal_view,
	            total: _discounted_total4,
	            total_view: discounted_total_view,
	            totalpayable: _discounted_total4 });
	          /*
	          this.setState({order_id:this.state.addonlist[0].order_id, package_list:pk, 
	                        subtotal:(bewisemagic.plan_total_price+bewisemagicaddon.plan_total_price), 
	                        total:(bewisemagic.plan_total_price+bewisemagicaddon.plan_total_price), 
	                        totalpayable:(bewisemagic.plan_total_price+bewisemagicaddon.plan_total_price)});
	                        */
	        }
	      } else {
	
	        if (keyselected == 'bwm') {
	          var _pk7 = [];
	          _pk7.push(bewisemagic);
	
	          var _total5 = bewisemagic.plan_total_price;
	          var _discount_amount5 = _total5 * this.state.special_discount;
	
	          var discount_amount_view = new Intl.NumberFormat('en-IN', {
	            style: 'currency',
	            currency: 'INR'
	          }).format(_discount_amount5);
	
	          var _discounted_total5 = _total5 - _discount_amount5;
	
	          var discounted_total_view = new Intl.NumberFormat('en-IN', {
	            style: 'currency',
	            currency: 'INR'
	          }).format(_discounted_total5);
	
	          var subtotal_view = new Intl.NumberFormat('en-IN', {
	            style: 'currency',
	            currency: 'INR'
	          }).format(_total5);
	
	          this.setState({ package_list: _pk7,
	            plan_name: bewisemagic.plan_name,
	            special_discount_view: discount_amount_view,
	            subtotal: _total5,
	            subtotal_view: subtotal_view,
	            total: _discounted_total5,
	            total_view: discounted_total_view,
	            totalpayable: _discounted_total5 });
	
	          //this.setState({package_list:pk, subtotal:(bewisemagic.plan_total_price), total:(bewisemagic.plan_total_price), totalpayable:(bewisemagic.plan_total_price)});
	        }
	
	        if (keyselected == 'bwvwc') {
	          var _pk8 = [];
	          _pk8.push(bewisevalue, wiseconnect);
	          this.setState({ package_list: _pk8, plan_name: bewisevalue.plan_name + "+" + wiseconnect.plan_name, total: bewisevalue.plan_total_price + wiseconnect.plan_total_price, subtotal: bewisevalue.plan_total_price + wiseconnect.plan_total_price, totalpayable: bewisevalue.plan_total_price + wiseconnect.plan_total_price });
	        }
	
	        if (keyselected == 'bwv') {
	          var _pk9 = [];
	          _pk9.push(bewisevalue);
	
	          var _total6 = bewisevalue.plan_total_price;
	          var _discount_amount6 = _total6 * this.state.special_discount;
	
	          var discount_amount_view = new Intl.NumberFormat('en-IN', {
	            style: 'currency',
	            currency: 'INR'
	          }).format(_discount_amount6);
	
	          var _discounted_total6 = _total6 - _discount_amount6;
	
	          var discounted_total_view = new Intl.NumberFormat('en-IN', {
	            style: 'currency',
	            currency: 'INR'
	          }).format(_discounted_total6);
	
	          var subtotal_view = new Intl.NumberFormat('en-IN', {
	            style: 'currency',
	            currency: 'INR'
	          }).format(_total6);
	
	          this.setState({ package_list: _pk9,
	            plan_name: bewisevalue.plan_name,
	            special_discount_view: discount_amount_view,
	            subtotal: _total6,
	            subtotal_view: subtotal_view,
	            total: _discounted_total6,
	            total_view: discounted_total_view,
	            totalpayable: _discounted_total6 });
	
	          //this.setState({package_list:pk, subtotal:(bewisevalue.plan_total_price), total:(bewisevalue.plan_total_price), totalpayable:(bewisevalue.plan_total_price)});
	        }
	      }
	
	      /*
	      if(keyselected=='bewisemagicaddon'){
	        pk.push(bewisemagicaddon);
	        this.setState({order_id:this.state.addonlist[0].order_id, package_list:pk, subtotal:(bewisemagicaddon.plan_total_price), total:(bewisemagicaddon.plan_total_price), totalpayable:(bewisemagicaddon.plan_total_price)});
	      }
	       if(keyselected=='bewisevalueaddon'){
	        pk.push(bewisevalueaddon);
	        this.setState({order_id:this.state.addonlist[0].order_id,package_list:pk, subtotal:(bewisevalueaddon.plan_total_price), total:(bewisevalueaddon.plan_total_price), totalpayable:(bewisevalueaddon.plan_total_price)});
	      }
	      */
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          package_list = _state.package_list,
	          planname = _state.planname,
	          subscriptionList = _state.subscriptionList,
	          addonlist = _state.addonlist,
	          paymentresponse = _state.paymentresponse;
	
	
	      console.log("list", addonlist);
	
	      this.validator.purgeFields();
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          'div',
	          { 'class': 'box-shadow-custom' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'col-md-12' },
	              this.state.paymentsuccess && _react2.default.createElement(
	                'div',
	                { 'class': 'success_section' },
	                _react2.default.createElement(
	                  'h1',
	                  null,
	                  'Payment Successful'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Thank you for your payment! Your payment has been processed successfully.'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Payment ID: ',
	                  _react2.default.createElement(
	                    'b',
	                    null,
	                    paymentresponse.razorpay_payment_id
	                  )
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'You can now access your purchase immediately.'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'If you have any questions, please do not hesitate to contact us.'
	                )
	              ),
	              this.state.upgraded == 1 && _react2.default.createElement(
	                'div',
	                { 'class': 'planupgradeblockwhite' },
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'planlist_title' },
	                  'Subscribed Plan and Packages'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'planlist desktoponly' },
	                  _react2.default.createElement(
	                    'table',
	                    { className: 'table table-responsive tablefullwidth' },
	                    _react2.default.createElement(
	                      'tr',
	                      null,
	                      _react2.default.createElement(
	                        'th',
	                        { width: '30%' },
	                        'Plan'
	                      ),
	                      _react2.default.createElement(
	                        'th',
	                        null,
	                        'Start Date'
	                      ),
	                      _react2.default.createElement(
	                        'th',
	                        null,
	                        'Expires on'
	                      ),
	                      _react2.default.createElement(
	                        'th',
	                        null,
	                        'Day(s) Left'
	                      )
	                    ),
	                    subscriptionList.map(function (item, index) {
	
	                      var diffTime = Math.abs(new Date(item.plan_end_date) - new Date(item.plan_start_date));
	                      var daysLeft = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
	
	                      return _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                          'td',
	                          null,
	                          item.plan_name
	                        ),
	                        _react2.default.createElement(
	                          'td',
	                          null,
	                          item.plan_start_date
	                        ),
	                        _react2.default.createElement(
	                          'td',
	                          null,
	                          item.plan_end_date
	                        ),
	                        _react2.default.createElement(
	                          'td',
	                          null,
	                          daysLeft,
	                          ' day(s) to renewal'
	                        )
	                      );
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'planlist mobileonly' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'tablefullwidth' },
	                    subscriptionList.map(function (item, index) {
	
	                      var diffTime = Math.abs(new Date(item.plan_end_date) - new Date(item.plan_start_date));
	                      var daysLeft = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
	
	                      return _react2.default.createElement(
	                        'ul',
	                        null,
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          'Plan   : ',
	                          item.plan_name
	                        ),
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          'Start Date :',
	                          item.plan_start_date
	                        ),
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          'Expires on :',
	                          item.plan_end_date
	                        ),
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          'Day(s) Left : ',
	                          daysLeft,
	                          ' day(s) to renewal'
	                        )
	                      );
	                    })
	                  )
	                )
	              ),
	              !this.state.paymentsuccess && this.state.upgraded == 0 && _react2.default.createElement(
	                'div',
	                { 'class': 'planupgradeblock' },
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'currentPlab' },
	                  'You are currently subscribed under ',
	                  _react2.default.createElement(
	                    'span',
	                    { 'class': 'planname' },
	                    'BeWise Standard'
	                  ),
	                  ' ( ',
	                  _react2.default.createElement(
	                    'span',
	                    { 'class': 'planpoplink', onClick: this.openPopupPlanStandard },
	                    'click to view plan detail'
	                  ),
	                  ' ) as current plan. Upgrade to the other premium plans to obtain more features and benefits.'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'blocktitle' },
	                  'Upgrade'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'blocknotes' },
	                  'BeWise Offers below plans for upgrade, Please choose a plan given in the dropdown'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'upgradeForm' },
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'chooseitem' },
	                    this.state.auth_data.user_type == 1 && _react2.default.createElement(
	                      'select',
	                      { name: 'upgradeplan', 'class': 'form-control upgradeplan', onChange: this.executeUpgradeList },
	                      _react2.default.createElement(
	                        'option',
	                        { value: '' },
	                        'Select a Plan'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'bwm' },
	                        'BeWise Magic'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'bwmwc' },
	                        'BeWise Magic + WiseConnect'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'wconly' },
	                        'WiseConnect Only'
	                      )
	                    ),
	                    this.state.auth_data.user_type != 1 && _react2.default.createElement(
	                      'select',
	                      { name: 'upgradeplan', 'class': 'form-control upgradeplan', onChange: this.executeUpgradeList },
	                      _react2.default.createElement(
	                        'option',
	                        { value: '' },
	                        'Select a Plan'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'bwv' },
	                        'BeWise Value'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'bwvwc' },
	                        'BeWise Value + WiseConnect'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'wconly' },
	                        'WiseConnect Only'
	                      )
	                    ),
	                    _react2.default.createElement('br', null),
	                    this.state.planselected && _react2.default.createElement(
	                      'div',
	                      { 'class': 'itemcart' },
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'planlist mobileonly' },
	                        package_list.map(function (item, index) {
	
	                          return _react2.default.createElement(
	                            'ul',
	                            null,
	                            _react2.default.createElement(
	                              'li',
	                              null,
	                              item.plan_name,
	                              ' ',
	                              _react2.default.createElement('br', null),
	                              _react2.default.createElement(
	                                'span',
	                                { 'class': 'smldesc' },
	                                item.plan_sdesc
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'li',
	                              { 'class': 'textlink', onClick: function onClick() {
	                                  return _this3.openPlanPop(item.plan_modal);
	                                } },
	                              'Click Here'
	                            ),
	                            _react2.default.createElement(
	                              'li',
	                              null,
	                              item.plan_duration,
	                              ' ',
	                              item.plan_duration_period
	                            ),
	                            _react2.default.createElement(
	                              'li',
	                              null,
	                              'Rs.',
	                              item.plan_final_price
	                            ),
	                            planname == 'bwvwc' && _react2.default.createElement(
	                              'li',
	                              null,
	                              'Rs.',
	                              item.plan_discount
	                            ),
	                            _react2.default.createElement(
	                              'li',
	                              { style: { textAlign: "right" } },
	                              'Rs.',
	                              item.plan_total_price
	                            )
	                          );
	                        })
	                      ),
	                      _react2.default.createElement(
	                        'table',
	                        { className: 'table table-responsive tablefullwidth desktoponly' },
	                        _react2.default.createElement(
	                          'tr',
	                          null,
	                          _react2.default.createElement(
	                            'th',
	                            { width: '30%' },
	                            'Plan'
	                          ),
	                          _react2.default.createElement(
	                            'th',
	                            null,
	                            'Plan Detail'
	                          ),
	                          _react2.default.createElement(
	                            'th',
	                            null,
	                            'Period'
	                          ),
	                          _react2.default.createElement(
	                            'th',
	                            null,
	                            'Cost'
	                          ),
	                          planname == 'bwvwc' && _react2.default.createElement(
	                            'th',
	                            null,
	                            'Discount (Amount)'
	                          ),
	                          _react2.default.createElement(
	                            'th',
	                            { style: { textAlign: "right" } },
	                            'Price'
	                          )
	                        ),
	                        package_list.map(function (item, index) {
	
	                          return _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                              'td',
	                              null,
	                              item.plan_name,
	                              ' ',
	                              _react2.default.createElement('br', null),
	                              _react2.default.createElement(
	                                'span',
	                                { 'class': 'smldesc' },
	                                item.plan_sdesc
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'td',
	                              { 'class': 'textlink', onClick: function onClick() {
	                                  return _this3.openPlanPop(item.plan_modal);
	                                } },
	                              'Click Here'
	                            ),
	                            _react2.default.createElement(
	                              'td',
	                              null,
	                              item.plan_duration,
	                              ' ',
	                              item.plan_duration_period
	                            ),
	                            _react2.default.createElement(
	                              'td',
	                              null,
	                              'Rs.',
	                              item.plan_final_price
	                            ),
	                            planname == 'bwvwc' && _react2.default.createElement(
	                              'td',
	                              null,
	                              'Rs.',
	                              item.plan_discount
	                            ),
	                            _react2.default.createElement(
	                              'td',
	                              { style: { textAlign: "right" } },
	                              'Rs.',
	                              item.plan_total_price
	                            )
	                          );
	                        })
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'floatrightbillbox' },
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'billbox' },
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'bill_line_flex' },
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'billlabel' },
	                              'Sub Total'
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'billrate' },
	                              this.state.subtotal_view
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'bill_line_flex' },
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'billlabel' },
	                              'Special Discount'
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'billrate' },
	                              this.state.special_discount_view
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'bill_line_flex' },
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'billlabel' },
	                              'Total'
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'billrate' },
	                              this.state.total_view
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'bill_confirm' },
	                            _react2.default.createElement(
	                              'button',
	                              { type: 'submit', className: 'btn btn-primary btn-sm',
	                                onClick: this.displayRazorpay },
	                              'Confirm and Subscribe'
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                ),
	                this.state.auth_data.user_type != 2 && _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement('br', null),
	                  _react2.default.createElement('br', null),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'wscoffer' },
	                    'If you have received Code for WiseConnect, Please enter here'
	                  ),
	                  _react2.default.createElement('br', null),
	                  _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement('input', { type: 'text', name: 'code', id: 'wccode', 'class': 'wscofferinputs', onChange: this.handleChange }),
	                    ' \xA0',
	                    _react2.default.createElement(
	                      'button',
	                      { 'class': 'btn btn-primary', onClick: this.subscribeTrail },
	                      'Submit'
	                    ),
	                    ' '
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'resultmessage' },
	                    this.state.wc_error && _react2.default.createElement(
	                      'div',
	                      { 'class': 'error15' },
	                      this.state.wc_error_message
	                    ),
	                    this.state.wc_success && _react2.default.createElement(
	                      'div',
	                      { 'class': 'success15' },
	                      this.state.wc_success_message
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactstrap.Modal,
	          { size: 'lg', isOpen: this.state.openPopupAddOn, className: 'modalpopup' },
	          _react2.default.createElement(
	            _reactstrap.ModalHeader,
	            null,
	            'BeWise Value Addon Branch'
	          ),
	          _react2.default.createElement(
	            _reactstrap.ModalBody,
	            { className: 'p-0 detailedpreview' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'planbox', style: { margin: "60px" } },
	              'Applicable to BeWise Value'
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.ModalFooter,
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-12 text-center' },
	                _react2.default.createElement(
	                  'button',
	                  { className: 'btn btn-sm btn-default', onClick: this.cancelPopAddon },
	                  'Close'
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactstrap.Modal,
	          { size: 'lg', isOpen: this.state.openPopupPlanStandard, className: 'modalpopup' },
	          _react2.default.createElement(
	            _reactstrap.ModalHeader,
	            null,
	            'BeWise Standard'
	          ),
	          _react2.default.createElement(
	            _reactstrap.ModalBody,
	            { className: 'p-0 detailedpreview' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'planbox', style: { margin: "60px" } },
	              _react2.default.createElement(
	                'table',
	                { 'class': 'pricing-table-box' },
	                _react2.default.createElement(
	                  'tbody',
	                  null,
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'td',
	                      { width: '40%', 'class': 'pricing-table-box-text' },
	                      _react2.default.createElement(
	                        'h2',
	                        null,
	                        'PRICING PLANS'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { width: '15%' },
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'pricing-table-box-item' },
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'pricing-table-box-item-head color2' },
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            'BeWise Standard'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'pricing-table-box-item-price color2' },
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            _react2.default.createElement(
	                              'span',
	                              null,
	                              'FREE'
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    { 'class': 'pricing-table-box-list' },
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'first-row bolder' },
	                      '24x 7 visibility and growth. Build trust with target audience'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'second-row' },
	                      _react2.default.createElement('span', { 'class': 'fa fa-check' })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    { 'class': 'pricing-table-box-list' },
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'first-row' },
	                      '\xA0\xA0\xA0\xA0Professional & continious digital presence'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'second-row' },
	                      _react2.default.createElement('span', { 'class': 'fa fa-check' })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    { 'class': 'pricing-table-box-list' },
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'first-row' },
	                      '\xA0\xA0\xA0\xA0Continious visibility reviews & ratings to enable growth'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'second-row' },
	                      _react2.default.createElement('span', { 'class': 'fa fa-check' })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    { 'class': 'pricing-table-box-list' },
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'first-row' },
	                      '\xA0\xA0\xA0\xA0Upload Pictures & Videos'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'second-row' },
	                      '3 Free'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    { 'class': 'pricing-table-box-list' },
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'first-row' },
	                      '\xA0\xA0\xA0\xA0Direct email & message interaction for parent enqruires/ Feedback'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'second-row' },
	                      _react2.default.createElement('span', { 'class': 'fa fa-times' })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    { 'class': 'pricing-table-box-list' },
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'first-row' },
	                      '\xA0\xA0\xA0\xA0Featured in Trending Now.'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'second-row' },
	                      _react2.default.createElement('span', { 'class': 'fa fa-times' })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    { 'class': 'pricing-table-box-list' },
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'first-row' },
	                      '\xA0\xA0\xA0\xA0Collaborative social media supportives - as and when'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'second-row' },
	                      _react2.default.createElement('span', { 'class': 'fa fa-times' })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    { 'class': 'pricing-table-box-list' },
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'first-row' },
	                      '\xA0\xA0\xA0\xA0Verified & Supported partner stamp\xA0'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'second-row' },
	                      _react2.default.createElement('span', { 'class': 'fa fa-times' })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    { 'class': 'pricing-table-box-list' },
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'first-row' },
	                      '\xA0\xA0\xA0\xA0Post your ad in your School landing page'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'second-row' },
	                      _react2.default.createElement('span', { 'class': 'fa fa-times' })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    { 'class': 'pricing-table-box-list' },
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'first-row bolder' },
	                      'Immediate updates for Leads /enquiries @ BeWise platform'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'second-row' },
	                      _react2.default.createElement('span', { 'class': 'fa fa-times' })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    { 'class': 'pricing-table-box-list' },
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'first-row bolder' },
	                      'Benchmark your organisation with your choice of peers / competitors'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'second-row' },
	                      _react2.default.createElement('span', { 'class': 'fa fa-times' })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    { 'class': 'pricing-table-box-list' },
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'first-row bolder' },
	                      'Build thought leadership and enhance your brand value.'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'second-row' },
	                      _react2.default.createElement('span', { 'class': 'fa fa-times' })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    { 'class': 'pricing-table-box-list' },
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'first-row bolder' },
	                      'Ads & newsletter promotion @ special prices'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'second-row' },
	                      _react2.default.createElement('span', { 'class': 'fa fa-times' })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    { 'class': 'pricing-table-box-list' },
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'first-row bolder' },
	                      'Free benefits upto INR 50K + for you & your customers'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'second-row' },
	                      _react2.default.createElement('span', { 'class': 'fa fa-times' })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    { 'class': 'pricing-table-box-list' },
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'first-row bolder' },
	                      'Scope for collaborative & customised services to drive growth'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'second-row' },
	                      _react2.default.createElement('span', { 'class': 'fa fa-times' })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    { 'class': 'pricing-table-box-list' },
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'first-row bolder' },
	                      'Multiple benefits @ WiseConnect, our Talent Management support.'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'second-row' },
	                      _react2.default.createElement('span', { 'class': 'fa fa-times' })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    { 'class': 'pricing-table-box-list' },
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'first-row bolder' },
	                      'You get data & analytics to help / accelerate growth'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'second-row' },
	                      'Partly Free'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    { 'class': 'pricing-table-box-list' },
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'first-row bolder' },
	                      'Easy access to Skill building and self-development for all in team'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'second-row' },
	                      'Partly Free'
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.ModalFooter,
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-12 text-center' },
	                _react2.default.createElement(
	                  'button',
	                  { className: 'btn btn-sm btn-default', onClick: this.cancelPop1 },
	                  'Close'
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactstrap.Modal,
	          { size: 'lg', isOpen: this.state.openPopupPlanBv, className: 'modalpopup' },
	          _react2.default.createElement(
	            _reactstrap.ModalHeader,
	            null,
	            'BeWise Value'
	          ),
	          _react2.default.createElement(
	            _reactstrap.ModalBody,
	            { className: 'p-0 detailedpreview' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'planbox', style: { margin: "60px" } },
	              _react2.default.createElement(
	                'table',
	                { 'class': 'pricing-table-box' },
	                _react2.default.createElement(
	                  'tbody',
	                  null,
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'td',
	                      { width: '40%', 'class': 'pricing-table-box-text' },
	                      _react2.default.createElement(
	                        'h2',
	                        null,
	                        'PRICING PLANS'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { width: '15%' },
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'pricing-table-box-item' },
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'pricing-table-box-item-head bewisemagic' },
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            'BeWise Value'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'pricing-table-box-item-price color2' },
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            _react2.default.createElement(
	                              'span',
	                              null,
	                              'Annual Subscription Fee'
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    { 'class': 'pricing-table-box-list' },
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'first-row bolder' },
	                      '24x 7 visibility and growth. Build trust with target audience'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'third-row' },
	                      _react2.default.createElement('span', { 'class': 'fa fa-check' })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    { 'class': 'pricing-table-box-list' },
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'first-row' },
	                      '\xA0\xA0\xA0\xA0Professional & continious digital presence'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'third-row' },
	                      _react2.default.createElement('span', { 'class': 'fa fa-check' })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    { 'class': 'pricing-table-box-list' },
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'first-row' },
	                      '\xA0\xA0\xA0\xA0Continious visibility reviews & ratings to enable growth'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'third-row' },
	                      _react2.default.createElement('span', { 'class': 'fa fa-check' })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    { 'class': 'pricing-table-box-list' },
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'first-row' },
	                      '\xA0\xA0\xA0\xA0Upload Pictures & Videos'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'third-row' },
	                      'Upto 15'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    { 'class': 'pricing-table-box-list' },
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'first-row' },
	                      '\xA0\xA0\xA0\xA0Direct email & message interaction for parent enqruires/ Feedback'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'third-row' },
	                      _react2.default.createElement('span', { 'class': 'fa fa-check' })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    { 'class': 'pricing-table-box-list' },
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'first-row' },
	                      '\xA0\xA0\xA0\xA0Featured in Trending Now.'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'third-row' },
	                      _react2.default.createElement('span', { 'class': 'fa fa-check' })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    { 'class': 'pricing-table-box-list' },
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'first-row' },
	                      '\xA0\xA0\xA0\xA0Collaborative social media supportives - as and when'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'third-row' },
	                      _react2.default.createElement('span', { 'class': 'fa fa-check' })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    { 'class': 'pricing-table-box-list' },
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'first-row' },
	                      '\xA0\xA0\xA0\xA0Verified & Supported partner stamp\xA0'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'third-row' },
	                      _react2.default.createElement('span', { 'class': 'fa fa-check' })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    { 'class': 'pricing-table-box-list' },
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'first-row' },
	                      '\xA0\xA0\xA0\xA0Post your ad in your School landing page'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'third-row' },
	                      _react2.default.createElement('span', { 'class': 'fa fa-check' })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    { 'class': 'pricing-table-box-list' },
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'first-row bolder' },
	                      'Immediate updates for Leads /enquiries @ BeWise platform'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'third-row' },
	                      _react2.default.createElement('span', { 'class': 'fa fa-check' })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    { 'class': 'pricing-table-box-list' },
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'first-row bolder' },
	                      'Benchmark your organisation with your choice of peers / competitors'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'third-row' },
	                      _react2.default.createElement('span', { 'class': 'fa fa-check' })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    { 'class': 'pricing-table-box-list' },
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'first-row bolder' },
	                      'Build thought leadership and enhance your brand value.'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'third-row' },
	                      _react2.default.createElement('span', { 'class': 'fa fa-check' })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    { 'class': 'pricing-table-box-list' },
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'first-row bolder' },
	                      'Ads & newsletter promotion @ special prices'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'third-row' },
	                      _react2.default.createElement('span', { 'class': 'fa fa-check' })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    { 'class': 'pricing-table-box-list' },
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'first-row bolder' },
	                      'Free benefits upto INR 50K + for you & your customers'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'third-row' },
	                      _react2.default.createElement('span', { 'class': 'fa fa-check' })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    { 'class': 'pricing-table-box-list' },
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'first-row bolder' },
	                      'Scope for collaborative & customised services to drive growth'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'third-row' },
	                      _react2.default.createElement('span', { 'class': 'fa fa-check' })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    { 'class': 'pricing-table-box-list' },
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'first-row bolder' },
	                      'Multiple benefits @ WiseConnect, our Talent Management support.'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'third-row' },
	                      _react2.default.createElement('span', { 'class': 'fa fa-check' })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    { 'class': 'pricing-table-box-list' },
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'first-row bolder' },
	                      'You get data & analytics to help / accelerate growth'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'third-row' },
	                      _react2.default.createElement('span', { 'class': 'fa fa-check' })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    { 'class': 'pricing-table-box-list' },
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'first-row bolder' },
	                      'Easy access to Skill building and self-development for all in team'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'third-row' },
	                      _react2.default.createElement('span', { 'class': 'fa fa-check' })
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.ModalFooter,
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-12 text-center' },
	                _react2.default.createElement(
	                  'button',
	                  { className: 'btn btn-sm btn-default', onClick: this.cancelPopBv },
	                  'Close'
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactstrap.Modal,
	          { size: 'lg', isOpen: this.state.openPopupPlanWc, className: 'modalpopup' },
	          _react2.default.createElement(
	            _reactstrap.ModalHeader,
	            null,
	            'WiseConnect'
	          ),
	          _react2.default.createElement(
	            _reactstrap.ModalBody,
	            { className: 'p-0 detailedpreview' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'planbox', style: { margin: "60px" } },
	              _react2.default.createElement(
	                'table',
	                { 'class': 'pricing-table-box' },
	                _react2.default.createElement(
	                  'tbody',
	                  null,
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'td',
	                      { width: '40%', 'class': 'pricing-table-box-text' },
	                      _react2.default.createElement(
	                        'h2',
	                        null,
	                        'All Institutions'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { width: '15%' },
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'pricing-table-box-item' },
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'pricing-table-box-item-head color2' },
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            'WiseConnect + BeWise'
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    { 'class': 'pricing-table-box-list' },
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'first-row' },
	                      'Initial Sign Up'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'second-row' },
	                      'Free'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    { 'class': 'pricing-table-box-list' },
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'first-row' },
	                      'All benefits @ BeWise to enable growth'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'second-row' },
	                      'Yes'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    { 'class': 'pricing-table-box-list' },
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'first-row' },
	                      'Instant Talent Search @ Portal & reach candidates'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'second-row' },
	                      'Yes'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    { 'class': 'pricing-table-box-list' },
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'first-row' },
	                      'Post Jobs & receive applications @ Portal'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'second-row' },
	                      'Yes'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    { 'class': 'pricing-table-box-list' },
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'first-row' },
	                      'Full access to Courses / Products / articles @ Portal'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'second-row' },
	                      'Yes'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    { 'class': 'pricing-table-box-list' },
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'first-row' },
	                      'Complete access to curated benefits from Partners'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'second-row' },
	                      'Yes'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    { 'class': 'pricing-table-box-list' },
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'first-row' },
	                      'Available data analytics, reports & benchmarks.'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'second-row' },
	                      'Yes'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    { 'class': 'pricing-table-box-list' },
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'first-row' },
	                      'Downloading of candidate CV** @ WiseConnect'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'second-row' },
	                      'Yes'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    { 'class': 'pricing-table-box-list' },
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'first-row' },
	                      'Private & direct interaction with candidates / applications'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'second-row' },
	                      'Yes'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    { 'class': 'pricing-table-box-list' },
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'first-row' },
	                      'Ads & newsletter promotion on WiseConnect @ special prices'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'second-row' },
	                      'Yes'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    { 'class': 'pricing-table-box-list' },
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'first-row' },
	                      'Advisory services in WiseConnect @ special prices'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'second-row' },
	                      'Yes'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    { 'class': 'pricing-table-box-list' },
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'first-row' },
	                      'Launch special - No additional or retainer fee on hiring @ WiseConnect'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'second-row' },
	                      'Yes'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'td',
	                      { colspan3: true },
	                      '\xA0'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    { 'class': 'pricing-table-box-list' },
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'first-row' },
	                      'Pricing ***  (WiseConnect only and Inclusive of all applicable taxes)'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'second-row', id: 'showPrice1' },
	                      _react2.default.createElement(
	                        'button',
	                        { 'class': 'btn btn-primary btn-sm', onClick: this.showPrice1 },
	                        'View Pricing'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    { 'class': 'pricing-table-box-list' },
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'first-row' },
	                      '\xA0'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'second-row' },
	                      'Billed Annually'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    { 'class': 'pricing-table-box-list' },
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'first-row' },
	                      '\xA0'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'second-row' },
	                      '3 Months Free with 1st subscription'
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.ModalFooter,
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-12 text-center' },
	                _react2.default.createElement(
	                  'button',
	                  { className: 'btn btn-sm btn-default', onClick: this.cancelPopWc },
	                  'Close'
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactstrap.Modal,
	          { size: 'lg', isOpen: this.state.openPopupPlanWcExcl, className: 'modalpopup' },
	          _react2.default.createElement(
	            _reactstrap.ModalHeader,
	            null,
	            'WiseConnect Exclusive'
	          ),
	          _react2.default.createElement(
	            _reactstrap.ModalBody,
	            { className: 'p-0 detailedpreview' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'planbox', style: { margin: "60px" } },
	              _react2.default.createElement(
	                'table',
	                { 'class': 'pricing-table-box' },
	                _react2.default.createElement(
	                  'tbody',
	                  null,
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'td',
	                      { width: '40%', 'class': 'pricing-table-box-text' },
	                      _react2.default.createElement(
	                        'h2',
	                        null,
	                        'All Institutions'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { width: '15%' },
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'pricing-table-box-item' },
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'pricing-table-box-item-head bewisemagic' },
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            'WiseConnect Exclusive'
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    { 'class': 'pricing-table-box-list' },
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'first-row' },
	                      'Initial Sign Up'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'third-row' },
	                      'Free - Restricted access*'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    { 'class': 'pricing-table-box-list' },
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'first-row' },
	                      'All benefits @ BeWise to enable growth'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'third-row' },
	                      'NA'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    { 'class': 'pricing-table-box-list' },
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'first-row' },
	                      'Instant Talent Search @ Portal & reach candidates'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'third-row' },
	                      'Yes'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    { 'class': 'pricing-table-box-list' },
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'first-row' },
	                      'Post Jobs & receive applications @ Portal'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'third-row' },
	                      'Yes'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    { 'class': 'pricing-table-box-list' },
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'first-row' },
	                      'Full access to Courses / Products / articles @ Portal'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'third-row' },
	                      'Yes'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    { 'class': 'pricing-table-box-list' },
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'first-row' },
	                      'Complete access to curated benefits from Partners'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'third-row' },
	                      'Yes'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    { 'class': 'pricing-table-box-list' },
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'first-row' },
	                      'Available data analytics, reports & benchmarks.'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'third-row' },
	                      'Yes'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    { 'class': 'pricing-table-box-list' },
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'first-row' },
	                      'Downloading of candidate CV** @ WiseConnect'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'third-row' },
	                      'Yes'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    { 'class': 'pricing-table-box-list' },
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'first-row' },
	                      'Private & direct interaction with candidates / applications'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'third-row' },
	                      'Yes'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    { 'class': 'pricing-table-box-list' },
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'first-row' },
	                      'Ads & newsletter promotion on WiseConnect @ special prices'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'third-row' },
	                      'Yes'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    { 'class': 'pricing-table-box-list' },
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'first-row' },
	                      'Advisory services in WiseConnect @ special prices'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'third-row' },
	                      'Yes'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    { 'class': 'pricing-table-box-list' },
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'first-row' },
	                      'Launch special - No additional or retainer fee on hiring @ WiseConnect'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'third-row' },
	                      'Yes'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'td',
	                      { colspan3: true },
	                      '\xA0'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    { 'class': 'pricing-table-box-list' },
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'first-row' },
	                      'Pricing ***  (WiseConnect only and Inclusive of all applicable taxes)'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'third-row', id: 'showPrice2' },
	                      _react2.default.createElement(
	                        'button',
	                        { 'class': 'btn btn-primary btn-sm', onClick: this.showPrice2 },
	                        'View Pricing'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    { 'class': 'pricing-table-box-list' },
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'first-row' },
	                      '\xA0'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'third-row' },
	                      'Billed Half yearly'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    { 'class': 'pricing-table-box-list' },
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'first-row' },
	                      '\xA0'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { 'class': 'third-row' },
	                      'NIL'
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.ModalFooter,
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-12 text-center' },
	                _react2.default.createElement(
	                  'button',
	                  { className: 'btn btn-sm btn-default', onClick: this.cancelPopWcExcl },
	                  'Close'
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'payinfo',
	    value: function payinfo() {
	      var This = this;
	      var payment_data;
	      var options = {
	        key: _constant.RAZORPAY_TEST, // Enter the Key ID generated from the Dashboard
	        amount: this.state.amount.toString(),
	        currency: this.state.currency,
	        name: this.state.partner_name,
	        description: "Plan Upgrade - Partner Program",
	        // image: { logo },
	        // order_id: this.state.order_id,
	        handler: function () {
	          var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(response) {
	            var data;
	            return _regenerator2.default.wrap(function _callee2$(_context2) {
	              while (1) {
	                switch (_context2.prev = _context2.next) {
	                  case 0:
	                    console.log('response', response);
	                    This.handlePaySubmit(response);
	                    payment_data = response.razorpay_payment_id;
	                    data = {
	                      // orderCreationId: this.state.order_id,
	                      razorpayPaymentId: response.razorpay_payment_id,
	                      razorpayOrderId: response.razorpay_order_id,
	                      razorpaySignature: response.razorpay_signature
	                    };
	                    //  const result = await axios.post("/payment/success", data);
	
	                  case 4:
	                  case 'end':
	                    return _context2.stop();
	                }
	              }
	            }, _callee2, this);
	          }));
	
	          function handler(_x2) {
	            return _ref2.apply(this, arguments);
	          }
	
	          return handler;
	        }(),
	        prefill: {
	          name: this.state.partner_name,
	          email: this.state.partner_email
	        },
	        notes: {
	          address: this.state.partner_address
	        },
	        theme: {
	          color: "#61dafb"
	        }
	      };
	      var paymentObject = new window.Razorpay(options);
	      paymentObject.open();
	    }
	  }, {
	    key: 'loadScript',
	    value: function loadScript(src) {
	      return new Promise(function (resolve) {
	        var script = document.createElement("script");
	        script.src = src;
	        script.onload = function () {
	          resolve(true);
	        };
	        script.onerror = function () {
	          resolve(false);
	        };
	        document.body.appendChild(script);
	      });
	    }
	
	    // handlePaySubmit = () => {
	
	
	    // handlePaySubmit = () => {
	
	  }]);
	
	  return UpgradeV1;
	}(_react.Component);
	
	exports.default = UpgradeV1;

/***/ },
/* 1000 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _reactstrap = __webpack_require__(17);
	
	var _Tabs = __webpack_require__(65);
	
	var _Tabs2 = _interopRequireDefault(_Tabs);
	
	var _TabsPane = __webpack_require__(64);
	
	var _TabsPane2 = _interopRequireDefault(_TabsPane);
	
	var _reactDataTableComponent = __webpack_require__(53);
	
	var _reactDataTableComponent2 = _interopRequireDefault(_reactDataTableComponent);
	
	var _Common = __webpack_require__(145);
	
	var _upgrade = __webpack_require__(998);
	
	var _upgrade2 = _interopRequireDefault(_upgrade);
	
	var _renewal = __webpack_require__(997);
	
	var _renewal2 = _interopRequireDefault(_renewal);
	
	var _invoice = __webpack_require__(363);
	
	var _invoice2 = _interopRequireDefault(_invoice);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import { Editor } from '@tinymce/tinymce-react';
	
	var partnerSubscriptionInfo = function (_Component) {
	  _inherits(partnerSubscriptionInfo, _Component);
	
	  function partnerSubscriptionInfo(props) {
	    _classCallCheck(this, partnerSubscriptionInfo);
	
	    var _this = _possibleConstructorReturn(this, (partnerSubscriptionInfo.__proto__ || Object.getPrototypeOf(partnerSubscriptionInfo)).call(this, props));
	
	    _this.showMTab = function (element) {
	
	      (0, _jquery2.default)('.submenu-list a').each(function () {
	        (0, _jquery2.default)(this).removeClass('active');
	      });
	
	      (0, _jquery2.default)("." + element).addClass("active");
	      (0, _jquery2.default)(".mainblock").removeClass('active').addClass('hidden');
	      (0, _jquery2.default)("#" + element).removeClass('hidden').addClass('active');
	
	      //document.getElementById(element).style.display = 'block';
	    };
	
	    _this.state = {
	      user_data: localStorage.getItem('user_data') ? JSON.parse(localStorage.getItem('user_data')) : [],
	      authentication: localStorage.getItem('authentication') ? JSON.parse(localStorage.getItem('authentication')) : false
	    };
	
	    return _this;
	  }
	
	  _createClass(partnerSubscriptionInfo, [{
	    key: 'render',
	    value: function render() {
	      var current_plan = this.state.user_data.current_plan;
	
	      var childTabs = [{
	        name: "Upgrade",
	        id: "upgrade",
	        defaultChecked: current_plan != 0 ? true : false
	      }, {
	        name: "Renewal",
	        id: "ranewal",
	        disabled: true
	        // disabled: (current_plan == 0) ? true : false
	      }, {
	        name: "Invoice",
	        id: "invoice",
	        defaultChecked: current_plan == 0 ? true : false
	      }];
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'col-12 grid-margin' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card-body' },
	                _react2.default.createElement(
	                  'h4',
	                  { 'class': 'card-title' },
	                  'Subscription'
	                ),
	                _react2.default.createElement(
	                  _Tabs2.default,
	                  { tabsetName: 'Subscribe', tabClassName: 'custom-tab', childTabs: childTabs },
	                  _react2.default.createElement(
	                    _TabsPane2.default,
	                    { id: 'upgrade' },
	                    _react2.default.createElement(_upgrade2.default, null)
	                  ),
	                  _react2.default.createElement(
	                    _TabsPane2.default,
	                    { id: 'ranewal' },
	                    _react2.default.createElement(_renewal2.default, null)
	                  ),
	                  _react2.default.createElement(
	                    _TabsPane2.default,
	                    { id: 'invoice' },
	                    _react2.default.createElement(_invoice2.default, null)
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return partnerSubscriptionInfo;
	}(_react.Component);
	
	exports.default = partnerSubscriptionInfo;

/***/ },
/* 1001 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _Tabs = __webpack_require__(65);
	
	var _Tabs2 = _interopRequireDefault(_Tabs);
	
	var _TabsPane = __webpack_require__(64);
	
	var _TabsPane2 = _interopRequireDefault(_TabsPane);
	
	var _upgradeV = __webpack_require__(999);
	
	var _upgradeV2 = _interopRequireDefault(_upgradeV);
	
	var _invoice = __webpack_require__(363);
	
	var _invoice2 = _interopRequireDefault(_invoice);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var partnerSubscriptionInfov1 = function (_Component) {
	  _inherits(partnerSubscriptionInfov1, _Component);
	
	  function partnerSubscriptionInfov1(props) {
	    _classCallCheck(this, partnerSubscriptionInfov1);
	
	    var _this = _possibleConstructorReturn(this, (partnerSubscriptionInfov1.__proto__ || Object.getPrototypeOf(partnerSubscriptionInfov1)).call(this, props));
	
	    _this.showMTab = function (element) {
	
	      (0, _jquery2.default)('.submenu-list a').each(function () {
	        (0, _jquery2.default)(this).removeClass('active');
	      });
	
	      (0, _jquery2.default)("." + element).addClass("active");
	      (0, _jquery2.default)(".mainblock").removeClass('active').addClass('hidden');
	      (0, _jquery2.default)("#" + element).removeClass('hidden').addClass('active');
	
	      //document.getElementById(element).style.display = 'block';
	    };
	
	    _this.state = {
	      user_data: localStorage.getItem('user_data') ? JSON.parse(localStorage.getItem('user_data')) : [],
	      authentication: localStorage.getItem('authentication') ? JSON.parse(localStorage.getItem('authentication')) : false
	    };
	
	    return _this;
	  }
	
	  _createClass(partnerSubscriptionInfov1, [{
	    key: 'render',
	    value: function render() {
	      var current_plan = this.state.user_data.current_plan;
	
	      var childTabs = [{
	        name: "Upgrade",
	        id: "upgrade",
	        defaultChecked: true
	      },
	      /*
	      {
	        name: "Renewal",
	        id: "ranewal",
	        disabled: true
	        // disabled: (current_plan == 0) ? true : false
	      },*/
	      {
	        name: "Invoice",
	        id: "invoice",
	        defaultChecked: false
	      }];
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'col-12 grid-margin' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card-body' },
	                _react2.default.createElement(
	                  'h4',
	                  { 'class': 'card-title' },
	                  'Subscription'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'desktoponly' },
	                  _react2.default.createElement(
	                    _Tabs2.default,
	                    { tabsetName: 'Subscribe', tabClassName: 'custom-tab', childTabs: childTabs },
	                    _react2.default.createElement(
	                      _TabsPane2.default,
	                      { id: 'upgrade' },
	                      _react2.default.createElement(_upgradeV2.default, null)
	                    ),
	                    _react2.default.createElement(
	                      _TabsPane2.default,
	                      { id: 'invoice' },
	                      _react2.default.createElement(_invoice2.default, null)
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'mobileonly' },
	                  _react2.default.createElement(_upgradeV2.default, null)
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return partnerSubscriptionInfov1;
	}(_react.Component);
	
	exports.default = partnerSubscriptionInfov1;

/***/ },
/* 1002 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FetchCall = __webpack_require__(4);
	
	var _simpleReactValidator = __webpack_require__(28);
	
	var _simpleReactValidator2 = _interopRequireDefault(_simpleReactValidator);
	
	var _reactstrap = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var JobPosting = function (_Component) {
	  _inherits(JobPosting, _Component);
	
	  function JobPosting(props) {
	    _classCallCheck(this, JobPosting);
	
	    return _possibleConstructorReturn(this, (JobPosting.__proto__ || Object.getPrototypeOf(JobPosting)).call(this, props));
	  }
	
	  _createClass(JobPosting, [{
	    key: 'render',
	    value: function render() {
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: '' },
	          _react2.default.createElement(
	            'h3',
	            { className: 'page-header' },
	            'Job Posting'
	          )
	        )
	      );
	    }
	  }]);
	
	  return JobPosting;
	}(_react.Component);
	
	exports.default = JobPosting;

/***/ },
/* 1003 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FetchCall = __webpack_require__(4);
	
	var _simpleReactValidator = __webpack_require__(28);
	
	var _simpleReactValidator2 = _interopRequireDefault(_simpleReactValidator);
	
	var _reactstrap = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TalentSearch = function (_Component) {
	  _inherits(TalentSearch, _Component);
	
	  function TalentSearch(props) {
	    _classCallCheck(this, TalentSearch);
	
	    var _this = _possibleConstructorReturn(this, (TalentSearch.__proto__ || Object.getPrototypeOf(TalentSearch)).call(this, props));
	
	    _this.handleChange = function (e) {
	      _this.setState(_defineProperty({}, e.target.name, e.target.value));
	    };
	
	    _this.findatalent = function () {
	
	      var req = JSON.stringify({
	        subject: _this.state.subject,
	        experience: _this.state.experience,
	        city: _this.state.city
	      });
	
	      (0, _FetchCall.findTeachers)(req).then(function (res) {
	        if (res.status === 1) {
	          _this.setState({
	            teachersList: res.results
	          });
	        }
	      });
	    };
	
	    _this.state = {
	      logged: localStorage.getItem("authentication"),
	      auth_data: JSON.parse(localStorage.getItem("user_data")),
	      write_permission: true,
	      subject: '',
	      experience: '',
	      city: '',
	      teachersList: []
	    };
	
	    _this.findatalent = _this.findatalent.bind(_this);
	
	    return _this;
	  }
	
	  _createClass(TalentSearch, [{
	    key: 'render',
	    value: function render() {
	      var teachersList = this.state.teachersList;
	
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: '' },
	          _react2.default.createElement(
	            'h3',
	            { className: 'page-header' },
	            'Talent Search'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Coming soon'
	          )
	        )
	      );
	    }
	  }]);
	
	  return TalentSearch;
	}(_react.Component);
	
	exports.default = TalentSearch;

/***/ },
/* 1004 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _reactDataTableComponent = __webpack_require__(53);
	
	var _reactDataTableComponent2 = _interopRequireDefault(_reactDataTableComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var $ = __webpack_require__(5);
	
	//$.DataTable = require('datatables.net')
	
	
	var partnerTransactions = function (_Component) {
	    _inherits(partnerTransactions, _Component);
	
	    function partnerTransactions(props) {
	        var _this2 = this;
	
	        _classCallCheck(this, partnerTransactions);
	
	        var _this = _possibleConstructorReturn(this, (partnerTransactions.__proto__ || Object.getPrototypeOf(partnerTransactions)).call(this, props));
	
	        _this.exportExcel = function (e) {
	            _this.transactionExport();
	        };
	
	        _this.transactionExport = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	            var res;
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            _context.prev = 0;
	                            _context.next = 3;
	                            return (0, _FetchCall.transactionExport)();
	
	                        case 3:
	                            res = _context.sent;
	
	                            if (res.status == 1) {
	                                window.open(res.path);
	                                // window.location.href(res.path)
	                            }
	                            _context.next = 10;
	                            break;
	
	                        case 7:
	                            _context.prev = 7;
	                            _context.t0 = _context['catch'](0);
	
	                            _this.setState({ error: true });
	
	                        case 10:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, _this2, [[0, 7]]);
	        }));
	        _this.UserDataList = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	            var req, res;
	            return _regenerator2.default.wrap(function _callee2$(_context2) {
	                while (1) {
	                    switch (_context2.prev = _context2.next) {
	                        case 0:
	                            _context2.prev = 0;
	                            req = JSON.stringify({ role: 1 });
	                            _context2.next = 4;
	                            return (0, _FetchCall.getTransactionList)(req);
	
	                        case 4:
	                            res = _context2.sent;
	
	                            if (res.status == 1) {
	                                console.log('location_list', res.list);
	                                _this.datatabledata(res.list);
	                            }
	
	                            _context2.next = 11;
	                            break;
	
	                        case 8:
	                            _context2.prev = 8;
	                            _context2.t0 = _context2['catch'](0);
	
	                            _this.setState({ error: true });
	
	                        case 11:
	                        case 'end':
	                            return _context2.stop();
	                    }
	                }
	            }, _callee2, _this2, [[0, 8]]);
	        }));
	
	        _this.state = {
	            logged: localStorage.getItem("authentication"),
	            auth_data: JSON.parse(localStorage.getItem("user_data")),
	            dataSet: []
	        };
	        return _this;
	    }
	
	    _createClass(partnerTransactions, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	
	            this.UserDataList();
	        }
	    }, {
	        key: 'datatabledata',
	        value: function datatabledata(data) {
	
	            console.log('data', data);
	            this.setState({
	                dataSet: data
	            });
	            this.el = $(this.el);
	            this.el.DataTable({
	                data: this.state.dataSet,
	                columns: [{ data: 's_no' }, { data: 'created_date' }, { data: 'razorpay_payment_id' }, { data: 'invoice_no' }, { data: 'name' }, { data: 'user_type' }, { data: 'email_id' }, { data: 'plan_id' }, { data: 'amount' }, { data: 'action' }]
	
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            return _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _react2.default.createElement(
	                    _layout2.default,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { 'class': 'col-12 grid-margin' },
	                        _react2.default.createElement(
	                            'div',
	                            { 'class': 'card' },
	                            _react2.default.createElement(
	                                'div',
	                                { 'class': 'card-body' },
	                                _react2.default.createElement(
	                                    'h4',
	                                    { 'class': 'card-title' },
	                                    'Transactions'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'content-top col-md-12 col-xs-12' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'custom-form form-inline col-md-12 col-xs-12 h-small pad-top' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'row' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'hdr-row' },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'pull-right' },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'dropdown menu-item' },
	                                                        _react2.default.createElement(
	                                                            'button',
	                                                            { className: 'btn btn-success btn-sm dropdown-toggle btn-arrow', onClick: this.exportExcel },
	                                                            _react2.default.createElement('i', { className: 'fa fa-file-excel-o', 'aria-hidden': 'true' }),
	                                                            ' Export to Excel'
	                                                        )
	                                                    )
	                                                )
	                                            )
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'main-content col-md-12 col-xs-12' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'box-shadow-custom' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'table-responsive content-sec col-md-12 col-xs-12 pad-no mar-t-no' },
	                                            _react2.default.createElement(
	                                                'table',
	                                                { className: 'table table-custom-design table-striped dataTable', ref: function ref(el) {
	                                                        return _this3.el = el;
	                                                    } },
	                                                _react2.default.createElement(
	                                                    'thead',
	                                                    null,
	                                                    _react2.default.createElement(
	                                                        'tr',
	                                                        null,
	                                                        _react2.default.createElement(
	                                                            'th',
	                                                            { className: 'tabledata' },
	                                                            'S.No'
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'th',
	                                                            { className: 'tabledata' },
	                                                            'Date'
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'th',
	                                                            { className: 'tabledata' },
	                                                            'RazorPay Id'
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'th',
	                                                            { className: 'tabledata' },
	                                                            'Invoice'
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'th',
	                                                            { className: 'tabledata' },
	                                                            'Partner Name'
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'th',
	                                                            { className: 'tabledata' },
	                                                            'Type'
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'th',
	                                                            { className: 'tabledata' },
	                                                            'Email Id'
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'th',
	                                                            { className: 'tabledata' },
	                                                            'Package Name'
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'th',
	                                                            { className: 'tabledata' },
	                                                            'Amount'
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'th',
	                                                            { className: 'tabledata' },
	                                                            'Action'
	                                                        )
	                                                    )
	                                                )
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return partnerTransactions;
	}(_react.Component);
	
	exports.default = partnerTransactions;

/***/ },
/* 1005 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import jQuery from 'jquery';
	
	
	var $ = __webpack_require__(5);
	
	var paymentInfo = function (_Component) {
	    _inherits(paymentInfo, _Component);
	
	    function paymentInfo(props) {
	        _classCallCheck(this, paymentInfo);
	
	        var _this = _possibleConstructorReturn(this, (paymentInfo.__proto__ || Object.getPrototypeOf(paymentInfo)).call(this, props));
	
	        _this.handleChange = function (e) {
	            _this.setState(_defineProperty({}, e.target.name, e.target.value));
	        };
	
	        _this.fetchPaymentDetail = function (e) {
	
	            var ins = JSON.stringify({
	                payment_id: _this.state.payment_id
	
	            });
	
	            (0, _FetchCall.getPaymentInfo)(ins).then(function (res) {
	                if (res.status == 1) {
	                    _this.setState({ response: res.results });
	                }
	            });
	        };
	
	        _this.state = {
	            dataSet: [],
	            response: {}
	        };
	        return _this;
	    }
	
	    _createClass(paymentInfo, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {}
	    }, {
	        key: 'UNSAFE_componentWillMount',
	        value: function UNSAFE_componentWillMount() {}
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            window.jQuery('.selectpicker').selectpicker('refresh');
	            // jQuery("#currency_selected").val(4);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var response = this.state.response;
	
	
	            return _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _react2.default.createElement(
	                    _layout2.default,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { 'class': 'col-lg-12 grid-margin stretch-card' },
	                        _react2.default.createElement(
	                            'div',
	                            { 'class': 'card' },
	                            _react2.default.createElement(
	                                'div',
	                                { 'class': 'card-body' },
	                                _react2.default.createElement(
	                                    'h4',
	                                    { 'class': 'card-title' },
	                                    'Payment Transactions'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'main-content col-md-12 col-xs-12' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'box-shadow-custom' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            null,
	                                            _react2.default.createElement('input', { type: 'text', name: 'payment_id', 'class': 'inputcls', placeholder: 'Enter Payment ID', onChange: this.handleChange })
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': '' },
	                                            _react2.default.createElement(
	                                                'button',
	                                                { onClick: this.fetchPaymentDetail, 'class': 'btn btn-main' },
	                                                'Fetch'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { id: 'info' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                null,
	                                                _react2.default.createElement(
	                                                    'ul',
	                                                    null,
	                                                    _react2.default.createElement(
	                                                        'li',
	                                                        null,
	                                                        'Amount : ',
	                                                        response.amount
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'li',
	                                                        null,
	                                                        'Product : ',
	                                                        response.description
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'li',
	                                                        null,
	                                                        'Payment ID : ',
	                                                        response.id
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'li',
	                                                        null,
	                                                        'Card Id : ',
	                                                        response.card_id
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'li',
	                                                        null,
	                                                        'Status: ',
	                                                        response.status
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'li',
	                                                        null,
	                                                        'Contact: ',
	                                                        response.contact
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'li',
	                                                        null,
	                                                        'Method: ',
	                                                        response.method
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'li',
	                                                        null,
	                                                        'Created At: ',
	                                                        response.created_at
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'li',
	                                                        null,
	                                                        'Currency: ',
	                                                        response.currency
	                                                    )
	                                                )
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return paymentInfo;
	}(_react.Component);
	
	exports.default = paymentInfo;

/***/ },
/* 1006 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _FetchCall2 = _interopRequireDefault(_FetchCall);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import { Editor } from '@tinymce/tinymce-react';
	
	
	var paymentsLinks = function (_Component) {
	  _inherits(paymentsLinks, _Component);
	
	  function paymentsLinks(props) {
	    _classCallCheck(this, paymentsLinks);
	
	    var _this = _possibleConstructorReturn(this, (paymentsLinks.__proto__ || Object.getPrototypeOf(paymentsLinks)).call(this, props));
	
	    _this.getList = function () {
	      var _this$state$auth_data = _this.state.auth_data,
	          login_id = _this$state$auth_data.login_id,
	          role = _this$state$auth_data.role;
	
	      var ins = JSON.stringify({
	        vendor_id: login_id,
	        role: role,
	        location: _this.state.location
	      });
	      (0, _FetchCall.getRazorPayTransactionListV1)(ins).then(function (res) {
	        if (res.status == 1) {
	          _this.setState({
	            paymentLinkList: res.user_list
	
	          });
	        } else {
	          _this.setState({
	            paymentLinkList: []
	          });
	        }
	      });
	    };
	
	    var url = new URL(window.location.href);
	    var location = url.searchParams.get("location");
	    var auth_data = JSON.parse(localStorage.getItem("user_data"));
	    _this.state = {
	      logged: localStorage.getItem("authentication"),
	      auth_data: JSON.parse(localStorage.getItem("user_data")),
	      location: location ? location : auth_data.access_location ? auth_data.access_location : 'Bengaluru',
	      paymentLinkList: []
	    };
	
	    _this.getList();
	    return _this;
	  }
	
	  _createClass(paymentsLinks, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	
	      var THIS = this;
	      (0, _jquery2.default)(document).on('click', '.remove_school', function () {
	        var delete_id = (0, _jquery2.default)(this).data("id");
	        THIS.setState({
	          delete_id: delete_id
	        });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var paymentLinkList = this.state.paymentLinkList;
	
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'col-lg-12 grid-margin stretch-card' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card-body' },
	                _react2.default.createElement(
	                  'h4',
	                  { 'class': 'card-title' },
	                  'Razorpay PaymentLinks'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'table-responsive pt-3' },
	                  _react2.default.createElement(
	                    'table',
	                    { 'class': 'table table-bordered' },
	                    _react2.default.createElement(
	                      'thead',
	                      null,
	                      _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'S.No'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Date'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Payment ID'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Partner name'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Type'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Package Chosen'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Amount'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Status'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Action'
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'tbody',
	                      null,
	                      paymentLinkList.map(function (item, i) {
	
	                        return _react2.default.createElement(
	                          'tr',
	                          null,
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            i + 1
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.transaction_date
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.razorpay_payment_id
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.name
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.user_type
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.plan_id
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.amount
	                          ),
	                          _react2.default.createElement('td', { dangerouslySetInnerHTML: { __html: item.status } }),
	                          _react2.default.createElement('td', { dangerouslySetInnerHTML: { __html: item.action } })
	                        );
	                      })
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return paymentsLinks;
	}(_react.Component);
	
	exports.default = paymentsLinks;

/***/ },
/* 1007 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _FetchCall2 = _interopRequireDefault(_FetchCall);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import { Editor } from '@tinymce/tinymce-react';
	
	
	var paymentsLinksDetail = function (_Component) {
	    _inherits(paymentsLinksDetail, _Component);
	
	    function paymentsLinksDetail(props) {
	        _classCallCheck(this, paymentsLinksDetail);
	
	        var _this = _possibleConstructorReturn(this, (paymentsLinksDetail.__proto__ || Object.getPrototypeOf(paymentsLinksDetail)).call(this, props));
	
	        _this.getCurrentPlanList = function () {
	
	            var insdata = JSON.stringify({
	                user_type: 2,
	                partner_id: _this.state.vendor_id,
	                role: 3,
	                url: 'getPartnerPlanV1'
	            });
	            (0, _FetchCall.partnerSubscription)(insdata).then(function (response) {
	                if (response.status === 1) {
	                    _this.setState({
	                        package_list: response.plan_list,
	                        upgradeList: response.upgrade_list,
	                        cgst_per: response.tax_data.cgst,
	                        sgst_per: response.tax_data.sgst,
	                        coupon_id: response.coupon_data.coupon_id,
	                        coupon_per_or: response.coupon_data.coupon_per,
	                        coupon_amount_or: response.coupon_data.coupon_amount,
	                        partner_name: response.partner.name, partner_email: response.partner.email, partner_address: response.partner.address
	                    });
	                }
	            });
	        };
	
	        _this.handlePaySubmit = function () {
	            var razorpay_payment_id = _this.state.payment_id;
	
	            if (razorpay_payment_id != '') {
	                var ins = '';
	                var upgradeList = _this.state.upgradeList.filter(function (item) {
	                    return item.is_check === true && item.nplanid != 0 && parseInt(item.period) > 0;
	                });
	                ins = JSON.stringify({
	                    razorpay_payment_id: _this.state.payment_id,
	                    razorpay_order_id: _this.state.order_id,
	                    razorpay_signature: _this.state.razorpay_signature,
	                    basesubtotal: Number.parseFloat(_this.state.amount).toFixed(2),
	                    subtotal: Number.parseFloat(_this.state.amount).toFixed(2),
	                    discount_per: _this.state.discount_per,
	                    discount_amount: _this.state.discount_amount,
	                    coupon_per: 0.00,
	                    totalpayable: Number.parseFloat(_this.state.amount).toFixed(2),
	                    user_type: 2,
	                    period: _this.state.period,
	                    user_paytype: 1,
	                    invoice_type: 2,
	                    upgradeList: upgradeList,
	                    login_id: _this.state.vendor_id,
	                    url: 'updatevendorplan',
	                    role: 3
	                });
	                console.log('update values', JSON.parse(ins));
	                return false;
	                (0, _FetchCall.partnerSubscriptionAfterRazorPayLinks)(ins).then(function (res) {
	                    var toastr = '';
	                    if (res.status === 1) {
	                        toastr = window.toastr.success;
	                        toastr('', 'Subscription and Upgradation has been successfully done.', {
	                            positionClass: "toast-bottom-right",
	                            containerId: "toast-bottom-right"
	                        });
	                    } else {
	                        var er = res.message;
	                        toastr = window.toastr.error; //warning
	                        toastr(er, toastr, {
	                            positionClass: "toast-bottom-right",
	                            containerId: "toast-bottom-right"
	                        });
	                    }
	                });
	            } else {
	                var toastr = '';
	                toastr = window.toastr.error; //warning
	                toastr('', 'Failed to process', {
	                    positionClass: "toast-bottom-right",
	                    containerId: "toast-bottom-right"
	                });
	            }
	        };
	
	        _this.state = {
	            detail: {},
	            upgradeList: []
	        };
	
	        _this.id = _this.props.match.params.id ? _this.props.match.params.id : '';
	        _this.getPaymentDetail = _this.getPaymentDetail.bind(_this);
	        return _this;
	    }
	
	    _createClass(paymentsLinksDetail, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	
	            this.getPaymentDetail();
	            this.getCurrentPlanList();
	        }
	    }, {
	        key: 'getPaymentDetail',
	        value: function () {
	            var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	                var _this2 = this;
	
	                var req;
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                req = JSON.stringify({
	                                    id: this.id
	                                });
	
	
	                                (0, _FetchCall.getPaymentLinkInfoDetail)(req).then(function (response) {
	                                    if (response.status === 1) {
	                                        _this2.setState({
	                                            detail: response.detail,
	                                            vendor_id: response.detail.vendor_id
	                                        });
	                                    } else {
	                                        _this2.setState({
	                                            detail: {}
	                                        });
	                                    }
	                                });
	
	                            case 2:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function getPaymentDetail() {
	                return _ref.apply(this, arguments);
	            }
	
	            return getPaymentDetail;
	        }()
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {}
	
	        // handlePaySubmit = () => {
	
	    }, {
	        key: 'render',
	        value: function render() {
	
	            var created_date = new Intl.DateTimeFormat('en-US', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).format(this.state.detail.created_date);
	
	            var amount_formatted = this.state.detail.amount / 100;
	
	            var amount = new Intl.NumberFormat('en-IN', {
	                style: 'currency',
	                currency: 'INR'
	            }).format(amount_formatted);
	
	            return _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _react2.default.createElement(
	                    _layout2.default,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { 'class': 'col-lg-12 grid-margin stretch-card' },
	                        _react2.default.createElement(
	                            'div',
	                            { 'class': 'card' },
	                            _react2.default.createElement(
	                                'div',
	                                { 'class': 'card-body' },
	                                _react2.default.createElement(
	                                    'h4',
	                                    { 'class': 'card-title' },
	                                    'Payment Detail'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'box-shadow-custom' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'row' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'col-lg-8' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { 'class': 'card mb-4' },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { 'class': 'card-header' },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { 'class': 'card-title' },
	                                                        'Payment Info'
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { 'class': 'card-body' },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { 'class': 'paymentinfo' },
	                                                        _react2.default.createElement(
	                                                            'ul',
	                                                            null,
	                                                            _react2.default.createElement(
	                                                                'li',
	                                                                null,
	                                                                'Payment Gateway: ',
	                                                                _react2.default.createElement(
	                                                                    'b',
	                                                                    null,
	                                                                    'RAZORPAY Payment Links'
	                                                                )
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'li',
	                                                                null,
	                                                                'Date Paid: ',
	                                                                _react2.default.createElement(
	                                                                    'b',
	                                                                    null,
	                                                                    created_date
	                                                                )
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'li',
	                                                                null,
	                                                                'Payment Link: ',
	                                                                _react2.default.createElement(
	                                                                    'b',
	                                                                    null,
	                                                                    this.state.detail.short_url
	                                                                )
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'li',
	                                                                null,
	                                                                'Generated By: ',
	                                                                _react2.default.createElement(
	                                                                    'b',
	                                                                    null,
	                                                                    this.state.detail.whogenerated
	                                                                )
	                                                            )
	                                                        )
	                                                    )
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'col-lg-4' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { 'class': 'card mb-4' },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { 'class': 'card-header' },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { 'class': 'card-title' },
	                                                        'Amount'
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { 'class': 'card-body' },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { 'class': 'amountpaid' },
	                                                        amount
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        null,
	                                                        'Discount: ',
	                                                        _react2.default.createElement(
	                                                            'b',
	                                                            null,
	                                                            '\u20B9',
	                                                            Number(180).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
	                                                        )
	                                                    )
	                                                )
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'row' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'col-lg-4 paymentinfo' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { 'class': 'card mb-4' },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { 'class': 'card-header' },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { 'class': 'card-title' },
	                                                        'Partner Info'
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { 'class': 'card-body' },
	                                                    _react2.default.createElement(
	                                                        'ul',
	                                                        null,
	                                                        _react2.default.createElement(
	                                                            'li',
	                                                            null,
	                                                            _react2.default.createElement(
	                                                                'b',
	                                                                null,
	                                                                this.state.detail.partner_name
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'li',
	                                                            null,
	                                                            this.state.detail.partner_first_name,
	                                                            ' ',
	                                                            this.state.detail.partner_last_name
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'li',
	                                                            null,
	                                                            'Email: ',
	                                                            this.state.detail.partner_email
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'li',
	                                                            null,
	                                                            'Ph: ',
	                                                            this.state.detail.partner_phone
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'li',
	                                                            null,
	                                                            'Address: ',
	                                                            this.state.detail.partner_address
	                                                        )
	                                                    )
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'col-lg-4 paymentinfo' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { 'class': 'card mb-4' },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { 'class': 'card-header' },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { 'class': 'card-title' },
	                                                        'Plan Info'
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { 'class': 'card-body' },
	                                                    _react2.default.createElement(
	                                                        'ul',
	                                                        null,
	                                                        _react2.default.createElement(
	                                                            'li',
	                                                            null,
	                                                            _react2.default.createElement(
	                                                                'b',
	                                                                null,
	                                                                this.state.detail.plan_name
	                                                            )
	                                                        )
	                                                    )
	                                                )
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'row' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'col-md-12' },
	                                            _react2.default.createElement(
	                                                'button',
	                                                { 'class': 'btn btn-primary', onClick: this.handleSubscribe },
	                                                'Approve and Upgrade'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return paymentsLinksDetail;
	}(_react.Component);
	
	exports.default = paymentsLinksDetail;

/***/ },
/* 1008 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _FetchCall2 = _interopRequireDefault(_FetchCall);
	
	__webpack_require__(18);
	
	var _reactNotifications = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import { Editor } from '@tinymce/tinymce-react';
	
	
	var promoCodes = function (_Component) {
	  _inherits(promoCodes, _Component);
	
	  function promoCodes(props) {
	    _classCallCheck(this, promoCodes);
	
	    var _this = _possibleConstructorReturn(this, (promoCodes.__proto__ || Object.getPrototypeOf(promoCodes)).call(this, props));
	
	    _this.getPartner = function () {
	
	      var ins = JSON.stringify({
	        role: 1,
	        url: 'getPartnerList'
	      });
	      (0, _FetchCall.promodata)(ins).then(function (res) {
	        if (res.status == 1) {
	          _this.setState({
	            parnter_list: res.plist
	          });
	        } else {
	          // window.location.href = '/promo_list';
	        }
	      });
	    };
	
	    _this.openAddBox = function () {
	
	      _this.setState({ openedAdd: true });
	    };
	
	    _this.handleChange = function (e) {
	      _this.setState(_defineProperty({}, e.target.name, e.target.value));
	    };
	
	    _this.savePromo = function () {
	
	      var insert = JSON.stringify({
	        promo_id: _this.state.promo_id,
	        promo_code: _this.state.promo_code,
	        partner_id: _this.state.partner_id,
	        promo_type: _this.state.promo_type,
	        promo_benefit: _this.state.promo_benefit,
	        promo_usable: _this.state.promo_usable,
	        url: 'update_promocode',
	        role: 1
	      });
	      (0, _FetchCall.promodata)(insert).then(function (response) {
	        if (response.status == 1) {
	          _this.setState({ openedAdd: false });
	          _this.getPromoList();
	        } else {
	          alert("saving error");
	        }
	      });
	    };
	
	    _this.getPromoList = function () {
	      var _this$state$auth_data = _this.state.auth_data,
	          login_id = _this$state$auth_data.login_id,
	          role = _this$state$auth_data.role;
	
	      var ins = JSON.stringify({
	        vendor_id: login_id,
	        role: role
	      });
	      (0, _FetchCall.getPromoCodeList)(ins).then(function (res) {
	        if (res.status == 1) {
	          _this.setState({
	            promolist: res.list
	
	          });
	        } else {
	          _this.setState({
	            promolist: []
	          });
	        }
	      });
	    };
	
	    var url = new URL(window.location.href);
	    var location = url.searchParams.get("location");
	    var auth_data = JSON.parse(localStorage.getItem("user_data"));
	    _this.state = {
	      logged: localStorage.getItem("authentication"),
	      auth_data: JSON.parse(localStorage.getItem("user_data")),
	      location: location ? location : auth_data.access_location ? auth_data.access_location : 'Bengaluru',
	      promolist: [],
	      openedAdd: false,
	      promo_id: 0,
	      promo_code: '',
	      promo_type: '1',
	      promo_benefit: '',
	      promo_usable: 0,
	      partner_id: '',
	      parnter_list: []
	    };
	
	    _this.getPromoList();
	    _this.getPartner();
	    return _this;
	  }
	
	  _createClass(promoCodes, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	
	      var THIS = this;
	      (0, _jquery2.default)(document).on('click', '.delete_promo', function () {
	        var delete_id = (0, _jquery2.default)(this).data("id");
	        THIS.setState({
	          delete_id: delete_id
	        });
	        THIS.deletePackage(delete_id);
	      });
	    }
	  }, {
	    key: 'deletePackage',
	    value: function deletePackage() {
	      var delete_id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	      if (confirm("Are you sure to Delete Promo Code?") == true) {
	
	        var ins = JSON.stringify({
	          promo_id: delete_id ? delete_id : this.state.delete_id,
	          role: 1,
	          url: 'delete_promocode'
	        });
	        (0, _FetchCall.promodata)(ins).then(function (res) {
	          if (res.status === 1) {
	            _reactNotifications.NotificationManager.success(res.message);
	            setTimeout(function () {
	              window.location.reload();
	            }, 1000);
	          } else {
	            _reactNotifications.NotificationManager.error(res.message);
	          }
	        });
	      }
	      return false;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var promolist = this.state.promolist;
	
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'col-lg-12 grid-margin stretch-card' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card-body' },
	                _react2.default.createElement(
	                  'h4',
	                  { 'class': 'card-title' },
	                  'Promocodes'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'float-right' },
	                  _react2.default.createElement(
	                    'button',
	                    { 'class': 'btn btn-primary btn-sm', onClick: this.openAddBox },
	                    'Add New'
	                  )
	                ),
	                this.state.openedAdd && _react2.default.createElement(
	                  'form',
	                  null,
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'row col-lg-12' },
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'form-group' },
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'form-row' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          'Partner'
	                        ),
	                        _react2.default.createElement(
	                          'select',
	                          { className: 'form-control selectpicker', 'data-live-search': 'true', name: 'partner_id',
	                            value: this.state.partner_id,
	                            title: 'Select',
	                            onChange: this.handleChange },
	                          this.state.parnter_list.map(function (item, i) {
	                            return _react2.default.createElement(
	                              'option',
	                              { value: item.login_id, key: i },
	                              item.pname + '/ ' + item.user_name
	                            );
	                          })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'form-row' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          ' Promo Benefit ',
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'astrick' },
	                            '*'
	                          )
	                        ),
	                        _react2.default.createElement('input', { name: 'promo_benefit', className: 'form-control', type: 'text', value: this.state.promo_benefit,
	                          onChange: this.handleChange })
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'form-row' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          ' Type ',
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'astrick' },
	                            '*'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'select',
	                          { name: 'promo_type', className: 'form-control selectpicker',
	                            value: this.state.promo_type, onChange: this.handleChange },
	                          _react2.default.createElement(
	                            'option',
	                            { value: '1' },
	                            '%'
	                          ),
	                          _react2.default.createElement(
	                            'option',
	                            { value: '2' },
	                            '\u20B9'
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'form-group row' },
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'col-sm-10' },
	                          _react2.default.createElement(
	                            'button',
	                            { type: 'button', onClick: this.savePromo, 'class': 'btn btn-primary' },
	                            'Save'
	                          )
	                        )
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'row col-lg-12' },
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'pt-3 table-responsive' },
	                    _react2.default.createElement(
	                      'table',
	                      { 'class': 'table table-bordered table-striped table-sm' },
	                      _react2.default.createElement(
	                        'thead',
	                        { 'class': 'thead-dark' },
	                        _react2.default.createElement(
	                          'tr',
	                          null,
	                          _react2.default.createElement(
	                            'th',
	                            null,
	                            _react2.default.createElement(
	                              'strong',
	                              null,
	                              'S.No'
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'th',
	                            null,
	                            _react2.default.createElement(
	                              'strong',
	                              null,
	                              'Partner'
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'th',
	                            null,
	                            _react2.default.createElement(
	                              'strong',
	                              null,
	                              'Benefit'
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'th',
	                            null,
	                            _react2.default.createElement(
	                              'strong',
	                              null,
	                              'Action'
	                            )
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'tbody',
	                        null,
	                        promolist.map(function (item, i) {
	
	                          return _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                              'td',
	                              null,
	                              i + 1
	                            ),
	                            _react2.default.createElement(
	                              'td',
	                              null,
	                              item.pname
	                            ),
	                            _react2.default.createElement(
	                              'td',
	                              null,
	                              item.benefit
	                            ),
	                            _react2.default.createElement('td', { 'class': 'actionbtns', dangerouslySetInnerHTML: { __html: item.action } })
	                          );
	                        })
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(_reactNotifications.NotificationContainer, null)
	        )
	      );
	    }
	  }]);
	
	  return promoCodes;
	}(_react.Component);
	
	exports.default = promoCodes;

/***/ },
/* 1009 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _FetchCall2 = _interopRequireDefault(_FetchCall);
	
	var _amcharts3React = __webpack_require__(228);
	
	var _amcharts3React2 = _interopRequireDefault(_amcharts3React);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Generate random data
	function generateData() {
	  var firstDate = new Date();
	
	  var dataProvider = [];
	
	  for (var i = 0; i < 100; ++i) {
	
	    var date = new Date(firstDate.getTime());
	
	    date.setDate(i);
	
	    dataProvider.push({
	      date: date,
	      value: Math.floor(Math.random() * 100)
	    });
	  }
	
	  return dataProvider;
	}
	
	var reportV2 = function (_Component) {
	  _inherits(reportV2, _Component);
	
	  function reportV2(props) {
	    _classCallCheck(this, reportV2);
	
	    var _this = _possibleConstructorReturn(this, (reportV2.__proto__ || Object.getPrototypeOf(reportV2)).call(this, props));
	
	    _this.state = {
	      timer: null,
	      dataProvider: generateData()
	    };
	    return _this;
	  }
	
	  _createClass(reportV2, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.setState({
	        // Update the chart dataProvider every 3 seconds
	        timer: setInterval(function () {
	          _this2.setState({
	            dataProvider: generateData()
	          });
	        }, 3000)
	      });
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearInterval(this.state.timer);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      var config_xy = {
	        "type": "xy",
	        "theme": "none",
	        "marginRight": 80,
	        "dataDateFormat": "YYYY-MM-DD",
	        "startDuration": 1.5,
	        "trendLines": [],
	        "balloon": {
	          "adjustBorderColor": false,
	          "shadowAlpha": 0,
	          "fixedPosition": true
	        },
	        "graphs": [{
	          "balloonText": "<div style='margin:5px;'><b>[[x]]</b><br>y:<b>[[y]]</b><br>value:<b>[[value]]</b></div>",
	          "bullet": "diamond",
	          "maxBulletSize": 25,
	          "lineAlpha": 0.8,
	          "lineThickness": 2,
	          "lineColor": "#b0de09",
	          "fillAlphas": 0,
	          "xField": "date",
	          "yField": "ay",
	          "valueField": "aValue"
	        }, {
	          "balloonText": "<div style='margin:5px;'><b>[[x]]</b><br>y:<b>[[y]]</b><br>value:<b>[[value]]</b></div>",
	          "bullet": "round",
	          "maxBulletSize": 25,
	          "lineAlpha": 0.8,
	          "lineThickness": 2,
	          "lineColor": "#fcd202",
	          "fillAlphas": 0,
	          "xField": "date",
	          "yField": "by",
	          "valueField": "bValue"
	        }],
	        "valueAxes": [{
	          "id": "ValueAxis-1",
	          "axisAlpha": 0
	        }, {
	          "id": "ValueAxis-2",
	          "axisAlpha": 0,
	          "position": "bottom"
	        }],
	        "allLabels": [],
	        "titles": [],
	        "dataProvider": [{
	          "date": 1,
	          "ay": 6.5,
	          "by": 2.2,
	          "aValue": 15,
	          "bValue": 10
	        }, {
	          "date": 2,
	          "ay": 12.3,
	          "by": 4.9,
	          "aValue": 8,
	          "bValue": 3
	        }, {
	          "date": 3,
	          "ay": 12.3,
	          "by": 5.1,
	          "aValue": 16,
	          "bValue": 4
	        }, {
	          "date": 5,
	          "ay": 2.9,
	          "aValue": 9
	        }, {
	          "date": 7,
	          "by": 8.3,
	          "bValue": 13
	        }, {
	          "date": 10,
	          "ay": 2.8,
	          "by": 13.3,
	          "aValue": 9,
	          "bValue": 13
	        }, {
	          "date": 12,
	          "ay": 3.5,
	          "by": 6.1,
	          "aValue": 5,
	          "bValue": 2
	        }, {
	          "date": 13,
	          "ay": 5.1,
	          "aValue": 10
	        }, {
	          "date": 15,
	          "ay": 6.7,
	          "by": 10.5,
	          "aValue": 3,
	          "bValue": 10
	        }, {
	          "date": 16,
	          "ay": 8,
	          "by": 12.3,
	          "aValue": 5,
	          "bValue": 13
	        }, {
	          "date": 20,
	          "by": 4.5,
	          "bValue": 11
	        }, {
	          "date": 22,
	          "ay": 9.7,
	          "by": 15,
	          "aValue": 15,
	          "bValue": 10
	        }, {
	          "date": 23,
	          "ay": 10.4,
	          "by": 10.8,
	          "aValue": 1,
	          "bValue": 11
	        }, {
	          "date": 24,
	          "ay": 1.7,
	          "by": 19,
	          "aValue": 12,
	          "bValue": 3
	        }],
	
	        "export": {
	          "enabled": true
	        },
	
	        "chartScrollbar": {
	          "offset": 15,
	          "scrollbarHeight": 5
	        },
	
	        "chartCursor": {
	          "pan": true,
	          "cursorAlpha": 0,
	          "valueLineAlpha": 0
	        }
	      };
	
	      var config_donut = {
	        "type": "pie",
	        "theme": "none",
	        "dataProvider": [{
	          "country": "Lithuania",
	          "value": 260
	        }, {
	          "country": "Ireland",
	          "value": 201
	        }, {
	          "country": "Germany",
	          "value": 65
	        }, {
	          "country": "Australia",
	          "value": 39
	        }, {
	          "country": "UK",
	          "value": 19
	        }, {
	          "country": "Latvia",
	          "value": 10
	        }],
	        "valueField": "value",
	        "titleField": "country",
	        "outlineAlpha": 0.4,
	        "depth3D": 15,
	        "balloonText": "[[title]]<br><span style='font-size:14px'><b>[[value]]</b> ([[percents]]%)</span>",
	        "angle": 30,
	        "export": {
	          "enabled": true
	        }
	      };
	
	      var config = {
	        "type": "serial",
	        "theme": "light",
	        "dataProvider": [{
	          "country": "USA",
	          "visits": 2025
	        }, {
	          "country": "China",
	          "visits": 1882
	        }, {
	          "country": "Japan",
	          "visits": 1809
	        }, {
	          "country": "Germany",
	          "visits": 1322
	        }, {
	          "country": "UK",
	          "visits": 1122
	        }, {
	          "country": "France",
	          "visits": 1114
	        }, {
	          "country": "India",
	          "visits": 984
	        }, {
	          "country": "Spain",
	          "visits": 711
	        }, {
	          "country": "Netherlands",
	          "visits": 665
	        }, {
	          "country": "Russia",
	          "visits": 580
	        }, {
	          "country": "South Korea",
	          "visits": 443
	        }, {
	          "country": "Canada",
	          "visits": 441
	        }, {
	          "country": "Brazil",
	          "visits": 395
	        }],
	        "valueAxes": [{
	          "gridColor": "#393999",
	          "gridAlpha": 0.2,
	          "dashLength": 0
	        }],
	        "gridAboveGraphs": true,
	        "startDuration": 1,
	        "graphs": [{
	          "balloonText": "[[category]]: <b>[[value]]</b>",
	          "fillAlphas": 0.8,
	          "lineAlpha": 0.2,
	          "type": "column",
	          "valueField": "visits"
	        }],
	        "chartCursor": {
	          "categoryBalloonEnabled": false,
	          "cursorAlpha": 0,
	          "zoomable": false
	        },
	        "categoryField": "country",
	        "categoryAxis": {
	          "gridPosition": "start",
	          "gridAlpha": 0,
	          "tickPosition": "start",
	          "tickLength": 20
	        },
	        "export": {
	          "enabled": true
	        }
	
	      };
	
	      var config_enq_report = {
	        "type": "serial",
	        "theme": "light",
	        "dataProvider": [{
	          "month": "Jan",
	          "enquiries": 40
	        }, {
	          "month": "Feb",
	          "enquiries": 20
	        }, {
	          "month": "Mar",
	          "enquiries": 18
	        }, {
	          "month": "Apr",
	          "enquiries": 15
	        }, {
	          "month": "May",
	          "enquiries": 25
	        }],
	
	        "valueAxes": [{
	          "gridColor": "#EAE35E",
	          "gridAlpha": 0.2,
	          "dashLength": 0
	        }],
	        "gridAboveGraphs": true,
	        "startDuration": 1,
	        "graphs": [{
	          "balloonText": "[[category]]: <b>[[value]]</b>",
	          "fillAlphas": 0.8,
	          "fillColors": "#0766AD",
	          "lineAlpha": 0.2,
	          "type": "column",
	          "valueField": "enquiries"
	        }],
	        "chartCursor": {
	          "categoryBalloonEnabled": false,
	          "cursorAlpha": 0,
	          "zoomable": false
	        },
	        "categoryField": "month",
	        "categoryAxis": {
	          "gridPosition": "start",
	          "gridAlpha": 0,
	          "tickPosition": "start",
	          "tickLength": 20
	        },
	        "export": {
	          "enabled": false
	        }
	      };
	
	      var config_visits_month = {
	        "type": "serial",
	        "theme": "light",
	        "dataProvider": [{
	          "month": "Jan",
	          "visits": 40
	        }, {
	          "month": "Feb",
	          "visits": 20
	        }, {
	          "month": "Mar",
	          "visits": 18
	        }, {
	          "month": "Apr",
	          "visits": 15
	        }, {
	          "month": "May",
	          "visits": 5
	        }, {
	          "month": "Jun",
	          "visits": 50
	        }, {
	          "month": "July",
	          "visits": 35
	        }, {
	          "month": "Aug",
	          "visits": 12
	        }, {
	          "month": "Sep",
	          "visits": 98
	        }, {
	          "month": "Oct",
	          "visits": 4
	        }, {
	          "month": "Nov",
	          "visits": 46
	        }, {
	          "month": "Dec",
	          "visits": 33
	        }],
	
	        "valueAxes": [{
	          "gridColor": "#EAE35E",
	          "gridAlpha": 0.2,
	          "dashLength": 0
	        }],
	        "gridAboveGraphs": true,
	        "startDuration": 1,
	        "graphs": [{
	          "balloonText": "[[category]]: <b>[[value]]</b>",
	          "fillAlphas": 0.6,
	          "fillColors": "#0766AD",
	          "lineAlpha": 0.3,
	          "type": "column",
	          "valueField": "visits"
	        }],
	        "chartCursor": {
	          "categoryBalloonEnabled": false,
	          "cursorAlpha": 0,
	          "zoomable": false
	        },
	        "categoryField": "month",
	        "categoryAxis": {
	          "gridPosition": "start",
	          "gridAlpha": 0,
	          "tickPosition": "start",
	          "tickLength": 20
	        },
	        "export": {
	          "enabled": false
	        }
	      };
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'row  mt-3' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'col-xl-12 d-flex grid-margin stretch-card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'card-body' },
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'd-flex flex-wrap justify-content-between' },
	                    _react2.default.createElement(
	                      'h4',
	                      { 'class': 'card-title mb-3' },
	                      'Visual Reports'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'col-6' },
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'graphtitle' },
	                        'Visits By Month 2023'
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'innerchart' },
	                        _react2.default.createElement(_amcharts3React2.default.React, { style: { width: "100%", height: "500px" }, options: config_visits_month })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'col-6' },
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'graphtitle' },
	                        'Sample Title'
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'innerchart' },
	                        _react2.default.createElement(_amcharts3React2.default.React, { style: { width: "100%", height: "500px" }, options: config_donut })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'col-6' },
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'graphtitle' },
	                        'Monthly View Your Page visit'
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'innerchart' },
	                        _react2.default.createElement(_amcharts3React2.default.React, { style: { width: "100%", height: "500px" }, options: config_xy })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'col-6' },
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'graphtitle' },
	                        'Enquiry Report per month'
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'innerchart' },
	                        _react2.default.createElement(_amcharts3React2.default.React, { style: { width: "100%", height: "500px" }, options: config_enq_report })
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return reportV2;
	}(_react.Component);
	
	exports.default = reportV2;

/***/ },
/* 1010 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _FetchCall2 = _interopRequireDefault(_FetchCall);
	
	var _amcharts3React = __webpack_require__(228);
	
	var _amcharts3React2 = _interopRequireDefault(_amcharts3React);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Generate random data
	function generateData() {
	  var firstDate = new Date();
	
	  var dataProvider = [];
	
	  for (var i = 0; i < 100; ++i) {
	
	    var date = new Date(firstDate.getTime());
	
	    date.setDate(i);
	
	    dataProvider.push({
	      date: date,
	      value: Math.floor(Math.random() * 100)
	    });
	  }
	
	  return dataProvider;
	}
	
	var ReportV3 = function (_Component) {
	  _inherits(ReportV3, _Component);
	
	  function ReportV3(props) {
	    _classCallCheck(this, ReportV3);
	
	    var _this = _possibleConstructorReturn(this, (ReportV3.__proto__ || Object.getPrototypeOf(ReportV3)).call(this, props));
	
	    _this.state = {
	      timer: null,
	      dataProvider: generateData()
	    };
	    return _this;
	  }
	
	  _createClass(ReportV3, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.setState({
	        // Update the chart dataProvider every 3 seconds
	        timer: setInterval(function () {
	          _this2.setState({
	            dataProvider: generateData()
	          });
	        }, 3000)
	      });
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearInterval(this.state.timer);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      var config_xy = {
	        "type": "xy",
	        "theme": "none",
	        "marginRight": 80,
	        "dataDateFormat": "YYYY-MM-DD",
	        "startDuration": 1.5,
	        "trendLines": [],
	        "balloon": {
	          "adjustBorderColor": false,
	          "shadowAlpha": 0,
	          "fixedPosition": true
	        },
	        "graphs": [{
	          "balloonText": "<div style='margin:5px;'><b>[[x]]</b><br>y:<b>[[y]]</b><br>value:<b>[[value]]</b></div>",
	          "bullet": "diamond",
	          "maxBulletSize": 25,
	          "lineAlpha": 0.8,
	          "lineThickness": 2,
	          "lineColor": "#b0de09",
	          "fillAlphas": 0,
	          "xField": "date",
	          "yField": "ay",
	          "valueField": "aValue"
	        }, {
	          "balloonText": "<div style='margin:5px;'><b>[[x]]</b><br>y:<b>[[y]]</b><br>value:<b>[[value]]</b></div>",
	          "bullet": "round",
	          "maxBulletSize": 25,
	          "lineAlpha": 0.8,
	          "lineThickness": 2,
	          "lineColor": "#fcd202",
	          "fillAlphas": 0,
	          "xField": "date",
	          "yField": "by",
	          "valueField": "bValue"
	        }],
	        "valueAxes": [{
	          "id": "ValueAxis-1",
	          "axisAlpha": 0
	        }, {
	          "id": "ValueAxis-2",
	          "axisAlpha": 0,
	          "position": "bottom"
	        }],
	        "allLabels": [],
	        "titles": [],
	        "dataProvider": [{
	          "date": 1,
	          "ay": 6.5,
	          "by": 2.2,
	          "aValue": 15,
	          "bValue": 10
	        }, {
	          "date": 2,
	          "ay": 12.3,
	          "by": 4.9,
	          "aValue": 8,
	          "bValue": 3
	        }, {
	          "date": 3,
	          "ay": 12.3,
	          "by": 5.1,
	          "aValue": 16,
	          "bValue": 4
	        }, {
	          "date": 5,
	          "ay": 2.9,
	          "aValue": 9
	        }, {
	          "date": 7,
	          "by": 8.3,
	          "bValue": 13
	        }, {
	          "date": 10,
	          "ay": 2.8,
	          "by": 13.3,
	          "aValue": 9,
	          "bValue": 13
	        }, {
	          "date": 12,
	          "ay": 3.5,
	          "by": 6.1,
	          "aValue": 5,
	          "bValue": 2
	        }, {
	          "date": 13,
	          "ay": 5.1,
	          "aValue": 10
	        }, {
	          "date": 15,
	          "ay": 6.7,
	          "by": 10.5,
	          "aValue": 3,
	          "bValue": 10
	        }, {
	          "date": 16,
	          "ay": 8,
	          "by": 12.3,
	          "aValue": 5,
	          "bValue": 13
	        }, {
	          "date": 20,
	          "by": 4.5,
	          "bValue": 11
	        }, {
	          "date": 22,
	          "ay": 9.7,
	          "by": 15,
	          "aValue": 15,
	          "bValue": 10
	        }, {
	          "date": 23,
	          "ay": 10.4,
	          "by": 10.8,
	          "aValue": 1,
	          "bValue": 11
	        }, {
	          "date": 24,
	          "ay": 1.7,
	          "by": 19,
	          "aValue": 12,
	          "bValue": 3
	        }],
	
	        "export": {
	          "enabled": true
	        },
	
	        "chartScrollbar": {
	          "offset": 15,
	          "scrollbarHeight": 5
	        },
	
	        "chartCursor": {
	          "pan": true,
	          "cursorAlpha": 0,
	          "valueLineAlpha": 0
	        }
	      };
	
	      var config_donut = {
	        "type": "pie",
	        "theme": "none",
	        "dataProvider": [{
	          "country": "Bengaluru",
	          "value": 260
	        }, {
	          "country": "Chennai",
	          "value": 65
	        }, {
	          "country": "Coimbatore",
	          "value": 0
	        }, {
	          "country": "Mumbai",
	          "value": 0
	        }, {
	          "country": "New Delhi",
	          "value": 1
	        }, {
	          "country": "Mysore",
	          "value": 8
	        }],
	        "valueField": "value",
	        "titleField": "country",
	        "outlineAlpha": 0.4,
	        "depth3D": 15,
	        "balloonText": "[[title]]<br><span style='font-size:14px'><b>[[value]]</b> ([[percents]]%)</span>",
	        "angle": 30,
	        "export": {
	          "enabled": true
	        }
	      };
	
	      var config = {
	        "type": "serial",
	        "theme": "light",
	        "dataProvider": [{
	          "country": "USA",
	          "visits": 2025
	        }, {
	          "country": "China",
	          "visits": 1882
	        }, {
	          "country": "Japan",
	          "visits": 1809
	        }, {
	          "country": "Germany",
	          "visits": 1322
	        }, {
	          "country": "UK",
	          "visits": 1122
	        }, {
	          "country": "France",
	          "visits": 1114
	        }, {
	          "country": "India",
	          "visits": 984
	        }, {
	          "country": "Spain",
	          "visits": 711
	        }, {
	          "country": "Netherlands",
	          "visits": 665
	        }, {
	          "country": "Russia",
	          "visits": 580
	        }, {
	          "country": "South Korea",
	          "visits": 443
	        }, {
	          "country": "Canada",
	          "visits": 441
	        }, {
	          "country": "Brazil",
	          "visits": 395
	        }],
	        "valueAxes": [{
	          "gridColor": "#393999",
	          "gridAlpha": 0.2,
	          "dashLength": 0
	        }],
	        "gridAboveGraphs": true,
	        "startDuration": 1,
	        "graphs": [{
	          "balloonText": "[[category]]: <b>[[value]]</b>",
	          "fillAlphas": 0.8,
	          "lineAlpha": 0.2,
	          "type": "column",
	          "valueField": "visits"
	        }],
	        "chartCursor": {
	          "categoryBalloonEnabled": false,
	          "cursorAlpha": 0,
	          "zoomable": false
	        },
	        "categoryField": "country",
	        "categoryAxis": {
	          "gridPosition": "start",
	          "gridAlpha": 0,
	          "tickPosition": "start",
	          "tickLength": 20
	        },
	        "export": {
	          "enabled": true
	        }
	
	      };
	
	      var config_enq_report = {
	        "type": "serial",
	        "theme": "light",
	        "dataProvider": [{
	          "month": "Jan",
	          "enquiries": 40
	        }, {
	          "month": "Feb",
	          "enquiries": 20
	        }, {
	          "month": "Mar",
	          "enquiries": 18
	        }, {
	          "month": "Apr",
	          "enquiries": 15
	        }, {
	          "month": "May",
	          "enquiries": 25
	        }],
	
	        "valueAxes": [{
	          "gridColor": "#EAE35E",
	          "gridAlpha": 0.2,
	          "dashLength": 0
	        }],
	        "gridAboveGraphs": true,
	        "startDuration": 1,
	        "graphs": [{
	          "balloonText": "[[category]]: <b>[[value]]</b>",
	          "fillAlphas": 0.8,
	          "fillColors": "#0766AD",
	          "lineAlpha": 0.2,
	          "type": "column",
	          "valueField": "enquiries"
	        }],
	        "chartCursor": {
	          "categoryBalloonEnabled": false,
	          "cursorAlpha": 0,
	          "zoomable": false
	        },
	        "categoryField": "month",
	        "categoryAxis": {
	          "gridPosition": "start",
	          "gridAlpha": 0,
	          "tickPosition": "start",
	          "tickLength": 20
	        },
	        "export": {
	          "enabled": false
	        }
	      };
	
	      var config_visits_month = {
	        "type": "serial",
	        "theme": "light",
	        "dataProvider": [{
	          "month": "Jan",
	          "visits": 40
	        }, {
	          "month": "Feb",
	          "visits": 20
	        }, {
	          "month": "Mar",
	          "visits": 18
	        }, {
	          "month": "Apr",
	          "visits": 15
	        }, {
	          "month": "May",
	          "visits": 5
	        }, {
	          "month": "Jun",
	          "visits": 50
	        }, {
	          "month": "July",
	          "visits": 35
	        }, {
	          "month": "Aug",
	          "visits": 12
	        }, {
	          "month": "Sep",
	          "visits": 98
	        }, {
	          "month": "Oct",
	          "visits": 4
	        }, {
	          "month": "Nov",
	          "visits": 46
	        }, {
	          "month": "Dec",
	          "visits": 33
	        }],
	
	        "valueAxes": [{
	          "gridColor": "#EAE35E",
	          "gridAlpha": 0.2,
	          "dashLength": 0
	        }],
	        "gridAboveGraphs": true,
	        "startDuration": 1,
	        "graphs": [{
	          "balloonText": "[[category]]: <b>[[value]]</b>",
	          "fillAlphas": 0.6,
	          "fillColors": "#0766AD",
	          "lineAlpha": 0.3,
	          "type": "column",
	          "valueField": "visits"
	        }],
	        "chartCursor": {
	          "categoryBalloonEnabled": false,
	          "cursorAlpha": 0,
	          "zoomable": false
	        },
	        "categoryField": "month",
	        "categoryAxis": {
	          "gridPosition": "start",
	          "gridAlpha": 0,
	          "tickPosition": "start",
	          "tickLength": 20
	        },
	        "export": {
	          "enabled": false
	        }
	      };
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'row  mt-3' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'col-xl-12 d-flex grid-margin stretch-card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'card-body' },
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'd-flex flex-wrap justify-content-between' },
	                    _react2.default.createElement(
	                      'h4',
	                      { 'class': 'card-title mb-3' },
	                      'Visual Reports'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'col-6' },
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'graphtitle' },
	                        'Visits By Month 2023'
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'innerchart' },
	                        _react2.default.createElement(_amcharts3React2.default.React, { style: { width: "100%", height: "500px" }, options: config_visits_month })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'col-6' },
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'graphtitle' },
	                        'Sample Title'
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'innerchart' },
	                        _react2.default.createElement(_amcharts3React2.default.React, { style: { width: "100%", height: "500px" }, options: config_donut })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'col-6' },
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'graphtitle' },
	                        'Monthly View Your Page visit'
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'innerchart' },
	                        _react2.default.createElement(_amcharts3React2.default.React, { style: { width: "100%", height: "500px" }, options: config_xy })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'col-6' },
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'graphtitle' },
	                        'Enquiry Report per month'
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'innerchart' },
	                        _react2.default.createElement(_amcharts3React2.default.React, { style: { width: "100%", height: "500px" }, options: config_enq_report })
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ReportV3;
	}(_react.Component);
	
	exports.default = ReportV3;

/***/ },
/* 1011 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _All_reports = __webpack_require__(883);
	
	var _All_reports2 = _interopRequireDefault(_All_reports);
	
	var _FetchCall = __webpack_require__(4);
	
	var _chart = __webpack_require__(83);
	
	var _Tabs = __webpack_require__(65);
	
	var _Tabs2 = _interopRequireDefault(_Tabs);
	
	var _TabsPane = __webpack_require__(64);
	
	var _TabsPane2 = _interopRequireDefault(_TabsPane);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var doughnutPieOptions = {
	  responsive: true,
	  animation: {
	    animateScale: true,
	    animateRotate: true
	  }
	};
	
	var childTabs = [{
	  name: "All Reports",
	  id: "all_reports",
	  defaultChecked: true
	}];
	
	var reports = function (_Component) {
	  _inherits(reports, _Component);
	
	  function reports(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, reports);
	
	    var _this = _possibleConstructorReturn(this, (reports.__proto__ || Object.getPrototypeOf(reports)).call(this, props));
	
	    _this.exportCSPExcel = function (e) {
	      _this.CSPExport();
	    };
	
	    _this.CSPExport = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var res;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.prev = 0;
	              _context.next = 3;
	              return (0, _FetchCall.CSPExport)();
	
	            case 3:
	              res = _context.sent;
	
	              if (res.status === 1) {
	                window.open(res.path);
	                // window.location.href(res.path)
	              }
	              _context.next = 10;
	              break;
	
	            case 7:
	              _context.prev = 7;
	              _context.t0 = _context['catch'](0);
	
	              _this.setState({ error: true });
	
	            case 10:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2, [[0, 7]]);
	    }));
	
	    _this.exportDAFExcel = function (e) {
	      _this.DAFExport();
	    };
	
	    _this.DAFExport = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	      var res;
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              _context2.prev = 0;
	              _context2.next = 3;
	              return (0, _FetchCall.DAFExport)();
	
	            case 3:
	              res = _context2.sent;
	
	              if (res.status === 1) {
	                window.open(res.path);
	                // window.location.href(res.path)
	              }
	              _context2.next = 10;
	              break;
	
	            case 7:
	              _context2.prev = 7;
	              _context2.t0 = _context2['catch'](0);
	
	              _this.setState({ error: true });
	
	            case 10:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, _this2, [[0, 7]]);
	    }));
	
	    _this.exportWishExcel = function (e) {
	      _this.WishExport();
	    };
	
	    _this.WishExport = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	      var res;
	      return _regenerator2.default.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              _context3.prev = 0;
	              _context3.next = 3;
	              return (0, _FetchCall.WishExport)();
	
	            case 3:
	              res = _context3.sent;
	
	              if (res.status === 1) {
	                window.open(res.path);
	                // window.location.href(res.path)
	              }
	              _context3.next = 10;
	              break;
	
	            case 7:
	              _context3.prev = 7;
	              _context3.t0 = _context3['catch'](0);
	
	              _this.setState({ error: true });
	
	            case 10:
	            case 'end':
	              return _context3.stop();
	          }
	        }
	      }, _callee3, _this2, [[0, 7]]);
	    }));
	
	    _this.exportRatingExcel = function (e) {
	      _this.RatingExport();
	    };
	
	    _this.RatingExport = _asyncToGenerator(_regenerator2.default.mark(function _callee4() {
	      var res;
	      return _regenerator2.default.wrap(function _callee4$(_context4) {
	        while (1) {
	          switch (_context4.prev = _context4.next) {
	            case 0:
	              _context4.prev = 0;
	              _context4.next = 3;
	              return (0, _FetchCall.RatingExport)();
	
	            case 3:
	              res = _context4.sent;
	
	              if (res.status === 1) {
	                window.open(res.path);
	                // window.location.href(res.path)
	              }
	              _context4.next = 10;
	              break;
	
	            case 7:
	              _context4.prev = 7;
	              _context4.t0 = _context4['catch'](0);
	
	              _this.setState({ error: true });
	
	            case 10:
	            case 'end':
	              return _context4.stop();
	          }
	        }
	      }, _callee4, _this2, [[0, 7]]);
	    }));
	
	    _this.setAfterschoolChart = function (data) {
	
	      var ctx = document.getElementById('afterschoolChart');
	      new _chart.Chart(ctx, {
	        type: 'doughnut',
	        data: data,
	        options: doughnutPieOptions
	      });
	    };
	
	    _this.setTuitionChart = function (data) {
	
	      var ctx = document.getElementById('tuitionChart');
	      new _chart.Chart(ctx, {
	        type: 'doughnut',
	        data: data,
	        options: doughnutPieOptions
	      });
	    };
	
	    _this.setSchoolChart = function (data) {
	
	      var ctx = document.getElementById('schoolChart');
	      new _chart.Chart(ctx, {
	        type: 'doughnut',
	        data: data,
	        options: doughnutPieOptions
	      });
	    };
	
	    _this.setPreschoolChart = function (data) {
	
	      var ctx = document.getElementById('preschoolChart');
	      new _chart.Chart(ctx, {
	        type: 'doughnut',
	        data: data,
	        options: doughnutPieOptions
	      });
	    };
	
	    _this.setcampChart = function (data) {
	
	      var ctx = document.getElementById('campChart');
	      new _chart.Chart(ctx, {
	        type: 'doughnut',
	        data: data,
	        options: doughnutPieOptions
	      });
	    };
	
	    _this.setcommunityChart = function (data) {
	
	      var ctx = document.getElementById('communityChart');
	      new _chart.Chart(ctx, {
	        type: 'doughnut',
	        data: data,
	        options: doughnutPieOptions
	      });
	    };
	
	    _this.setbirthdayChart = function (data) {
	
	      var ctx = document.getElementById('birthdayChart');
	      new _chart.Chart(ctx, {
	        type: 'doughnut',
	        data: data,
	        options: doughnutPieOptions
	      });
	    };
	
	    _this.state = {
	      school_data: []
	    };
	    return _this;
	  }
	
	  _createClass(reports, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	
	      var req = {
	        url: 'service_provider_report'
	      };
	      (0, _FetchCall.adminDashboard)(JSON.stringify(req)).then(function (response) {
	        if (response.status === 1) {
	          //this.datatabledata(response.result);
	        }
	      });
	      req.url = 'wishlist_report';
	      (0, _FetchCall.adminDashboard)(JSON.stringify(req)).then(function (response) {
	        if (response.status === 1) {
	          //this.datatableenqdata2(response.result);
	        }
	      });
	
	      req.url = 'device_report';
	      (0, _FetchCall.adminDashboard)(JSON.stringify(req)).then(function (response) {
	        if (response.status === 1) {
	          //this.datatableenqdata(response.result);
	        }
	      });
	
	      req.url = 'rating_report';
	      (0, _FetchCall.adminDashboard)(JSON.stringify(req)).then(function (response) {
	        if (response.status === 1) {
	          console.log('response', response);
	          var rating = [].concat(_toConsumableArray(response.school), _toConsumableArray(response.preschool), _toConsumableArray(response.playarea), _toConsumableArray(response.hobbies), _toConsumableArray(response.event), _toConsumableArray(response.camp), _toConsumableArray(response.tutions), _toConsumableArray(response.advice));
	
	          console.log('response', rating);
	          //this.datatableenqdata3(rating);
	        }
	      });
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      window.jQuery('.selectpicker').selectpicker('refresh');
	      // jQuery("#currency_selected").val(4);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'row  mt-3' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'col-xl-12 d-flex grid-margin stretch-card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'card-body' },
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'd-flex flex-wrap justify-content-between' },
	                    _react2.default.createElement(
	                      'h4',
	                      { 'class': 'card-title mb-3' },
	                      'Reports'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'col-12' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'tab-content' },
	                        _react2.default.createElement(
	                          _Tabs2.default,
	                          { tabsetName: 'Comments', childTabs: childTabs },
	                          _react2.default.createElement(
	                            _TabsPane2.default,
	                            { id: 'all_reports' },
	                            _react2.default.createElement(_All_reports2.default, null)
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return reports;
	}(_react.Component);
	
	exports.default = reports;

/***/ },
/* 1012 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _FetchCall2 = _interopRequireDefault(_FetchCall);
	
	var _sweetalert = __webpack_require__(174);
	
	var _sweetalert2 = _interopRequireDefault(_sweetalert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import { Editor } from '@tinymce/tinymce-react';
	
	
	var resourcesList = function (_Component) {
	  _inherits(resourcesList, _Component);
	
	  function resourcesList(props) {
	    _classCallCheck(this, resourcesList);
	
	    var _this = _possibleConstructorReturn(this, (resourcesList.__proto__ || Object.getPrototypeOf(resourcesList)).call(this, props));
	
	    _this.openAddBox = function () {
	
	      _this.setState({ openedAdd: true });
	    };
	
	    _this.handleChange = function (e) {
	      _this.setState(_defineProperty({}, e.target.name, e.target.value));
	    };
	
	    _this.saveResource = function () {
	
	      var insert = {
	        resource_id: _this.state.resource_id,
	        resource_category: _this.state.resource_category,
	        resource_title: _this.state.resource_title,
	        resource_banner: _this.state.resource_banner,
	        resource_attchment: _this.state.resource_attchment
	      };
	      (0, _FetchCall.updateResource)(insert).then(function (response) {
	        if (response.status == 1) {
	          _this.setState({ openedAdd: false });
	          _this.getResourceList();
	        } else {
	          alert("Saving error");
	        }
	      });
	    };
	
	    _this.getResourceList = function () {
	      var _this$state$auth_data = _this.state.auth_data,
	          login_id = _this$state$auth_data.login_id,
	          role = _this$state$auth_data.role;
	
	      var ins = JSON.stringify({
	        vendor_id: login_id,
	        role: role
	      });
	      (0, _FetchCall.getResourceList)(ins).then(function (res) {
	        if (res.status == 1) {
	          _this.setState({
	            resourceslist: res.list
	
	          });
	        } else {
	          _this.setState({
	            resourceslist: []
	          });
	        }
	      });
	    };
	
	    var url = new URL(window.location.href);
	    var location = url.searchParams.get("location");
	    var auth_data = JSON.parse(localStorage.getItem("user_data"));
	    _this.state = {
	      logged: localStorage.getItem("authentication"),
	      auth_data: JSON.parse(localStorage.getItem("user_data")),
	      location: location ? location : auth_data.access_location ? auth_data.access_location : 'Bengaluru',
	      resource_id: 0,
	      resource_title: '',
	      resource_banner: '',
	      resource_category: '',
	      resource_attchment: '',
	      old_resource_banner: '',
	      old_resource_attchment: '',
	      resourceslist: [],
	      openedAdd: false
	    };
	
	    _this.getResourceList();
	
	    return _this;
	  }
	
	  _createClass(resourcesList, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	
	      var THIS = this;
	      (0, _jquery2.default)(document).on('click', '.remove_resource', function () {
	        var delete_id = (0, _jquery2.default)(this).data("id");
	        THIS.setState({
	          delete_id: delete_id
	        });
	      });
	    }
	  }, {
	    key: 'deleteResource',
	    value: function deleteResource() {
	      var _this2 = this;
	
	      var delete_id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	      (0, _sweetalert2.default)({
	        title: "Are you sure to Delete Resource?",
	        text: "",
	        icon: "warning",
	        buttons: true,
	        dangerMode: true
	      }).then(function (willDelete) {
	        if (willDelete) {
	          var ins = JSON.stringify({
	            resource_id: delete_id ? delete_id : _this2.state.delete_id,
	            role: 1,
	            url: 'delete_resource'
	          });
	          (0, _FetchCall.eventResource)(ins).then(function (res) {
	            var toastr = '';
	            if (res.status === 1) {
	              toastr = window.toastr.success;
	              toastr('', res.message, {
	                positionClass: "toast-bottom-right",
	                containerId: "toast-bottom-right"
	              });
	              setTimeout(function () {
	                window.location.reload();
	              }, 1000);
	            } else {
	              toastr = window.toastr.error; //warning
	              toastr('', res.message, {
	                positionClass: "toast-bottom-right",
	                containerId: "toast-bottom-right"
	              });
	            }
	          });
	        }
	      });
	      return false;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var resourceslist = this.state.resourceslist;
	
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'col-lg-12 grid-margin stretch-card' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card-body' },
	                _react2.default.createElement(
	                  'h4',
	                  { 'class': 'card-title' },
	                  'Resources'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'float-right' },
	                  _react2.default.createElement(
	                    'button',
	                    { 'class': 'btn btn-primary btn-sm', onClick: this.openAddBox },
	                    'Add New'
	                  )
	                ),
	                this.state.openedAdd && _react2.default.createElement(
	                  'form',
	                  null,
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'row col-lg-12' },
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'form-group' },
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'form-row' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          'Category'
	                        ),
	                        _react2.default.createElement(
	                          'select',
	                          { className: 'form-control selectpicker',
	                            onChange: this.handleChange,
	                            title: 'Select Category',
	                            name: 'resource_category',
	                            value: this.state.resource_category },
	                          _react2.default.createElement(
	                            'option',
	                            { value: '1' },
	                            '2 \u2013 5 years'
	                          ),
	                          _react2.default.createElement(
	                            'option',
	                            { value: '2' },
	                            '6 \u2013 9 years old'
	                          ),
	                          _react2.default.createElement(
	                            'option',
	                            { value: '3' },
	                            '9 \u2013 11  years'
	                          ),
	                          _react2.default.createElement(
	                            'option',
	                            { value: '4' },
	                            '12 \u2013 15 years'
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'form-row' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          ' Title ',
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'astrick' },
	                            '*'
	                          )
	                        ),
	                        _react2.default.createElement('input', { name: 'resource_title', className: 'form-control', type: 'text', value: this.state.resource_title,
	                          onChange: this.handleChange })
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'form-row' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          ' Resource to Download ',
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'astrick' },
	                            '*'
	                          )
	                        ),
	                        _react2.default.createElement('input', { name: 'resource_attchment', className: 'form-control', type: 'file',
	                          onChange: this.handleFile })
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'form-group row' },
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'col-sm-10' },
	                          _react2.default.createElement(
	                            'button',
	                            { type: 'button', onClick: this.saveResource, 'class': 'btn btn-primary' },
	                            'Save'
	                          )
	                        )
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'row col-lg-12' },
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'pt-3 table-responsive' },
	                    _react2.default.createElement(
	                      'table',
	                      { 'class': 'table table-bordered table-striped table-sm' },
	                      _react2.default.createElement(
	                        'thead',
	                        { 'class': 'thead-dark' },
	                        _react2.default.createElement(
	                          'tr',
	                          null,
	                          _react2.default.createElement(
	                            'th',
	                            null,
	                            _react2.default.createElement(
	                              'strong',
	                              null,
	                              'S.No'
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'th',
	                            null,
	                            _react2.default.createElement(
	                              'strong',
	                              null,
	                              'Category'
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'th',
	                            null,
	                            _react2.default.createElement(
	                              'strong',
	                              null,
	                              'Title'
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'th',
	                            null,
	                            _react2.default.createElement(
	                              'strong',
	                              null,
	                              'Downloads'
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'th',
	                            null,
	                            _react2.default.createElement(
	                              'strong',
	                              null,
	                              'Action'
	                            )
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'tbody',
	                        null,
	                        resourceslist.map(function (item, i) {
	
	                          return _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                              'td',
	                              null,
	                              i + 1
	                            ),
	                            _react2.default.createElement(
	                              'td',
	                              null,
	                              item.category
	                            ),
	                            _react2.default.createElement(
	                              'td',
	                              null,
	                              item.title
	                            ),
	                            _react2.default.createElement(
	                              'td',
	                              null,
	                              item.downloads
	                            ),
	                            _react2.default.createElement('td', { 'class': 'actionbtns', dangerouslySetInnerHTML: { __html: item.action } })
	                          );
	                        })
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return resourcesList;
	}(_react.Component);
	
	exports.default = resourcesList;

/***/ },
/* 1013 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//const pm2 = require('pm2')
	
	var RestartApp = function (_Component) {
	  _inherits(RestartApp, _Component);
	
	  function RestartApp(props) {
	    _classCallCheck(this, RestartApp);
	
	    return _possibleConstructorReturn(this, (RestartApp.__proto__ || Object.getPrototypeOf(RestartApp)).call(this, props));
	  }
	
	  _createClass(RestartApp, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {}
	  }, {
	    key: 'restartapp',
	    value: function restartapp() {
	
	      //pm2.restart(1);
	      alert("Restarted");
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'button',
	            { onClick: this.restartapp },
	            'Restart now'
	          )
	        )
	      );
	    }
	  }]);
	
	  return RestartApp;
	}(_react.Component);
	
	exports.default = RestartApp;

/***/ },
/* 1014 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _FetchCall = __webpack_require__(4);
	
	__webpack_require__(18);
	
	var _reactNotifications = __webpack_require__(16);
	
	var _constant = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable jsx-a11y/accessible-emoji */
	
	
	var IMGURL = "https://api.bewise.in/uploads/";
	
	var BeWise_SideBar = function (_Component) {
	  _inherits(BeWise_SideBar, _Component);
	
	  function BeWise_SideBar(props) {
	    _classCallCheck(this, BeWise_SideBar);
	
	    var _this = _possibleConstructorReturn(this, (BeWise_SideBar.__proto__ || Object.getPrototypeOf(BeWise_SideBar)).call(this, props));
	
	    _this.state = {
	      user_name: '',
	      logged: localStorage.getItem("authentication"),
	      auth_data: JSON.parse(localStorage.getItem("user_data")),
	      iswiseconnectsubscribed: true,
	      wcallowedtoacess: true,
	      wcneedextension: false,
	      haveleads: false,
	      totalleads: 0
	    };
	
	    _this.checkifLeadsReceived = _this.checkifLeadsReceived.bind(_this);
	
	    return _this;
	  }
	
	  _createClass(BeWise_SideBar, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var dataOfUser = this.state.auth_data;
	      var allowedtoacess = dataOfUser.upgraded == 1 ? true : dataOfUser.current_plan != 5 && dataOfUser.current_plan != 0 && dataOfUser.current_plan != 1 ? true : false;
	      this.setState({ user_name: this.state.auth_data.user_name, role: this.state.auth_data.role, allowedtoacess: allowedtoacess });
	
	      if (dataOfUser.user_type === 1) {
	        this.checkifWcSubscribedTrial();
	      }
	
	      if (dataOfUser.role === 3) {
	        this.checkifLeadsReceived();
	      }
	    }
	  }, {
	    key: 'checkifLeadsReceived',
	    value: function checkifLeadsReceived() {
	      var _this2 = this;
	
	      var insdata = JSON.stringify({
	        vendor_id: this.state.auth_data.login_id
	      });
	
	      (0, _FetchCall.checkifLeadsReceived)(insdata).then(function (response) {
	        if (response.status === 1) {
	          if (response.total > 0) _this2.setState({ haveleads: true, totalleads: response.total });else _this2.setState({ haveleads: false });
	        }
	      });
	    }
	  }, {
	    key: 'checkifWcSubscribedTrial',
	    value: function checkifWcSubscribedTrial() {
	      var _this3 = this;
	
	      var insdata = JSON.stringify({
	        vendor_id: this.state.auth_data.login_id
	      });
	
	      (0, _FetchCall.checkifWcSubscribedTrial)(insdata).then(function (response) {
	        if (response.status === 1) {
	          _this3.setState({ wcallowedtoacess: true });
	        } else {
	
	          var dataOfUser = _this3.state.auth_data;
	
	          if (dataOfUser.upgraded_plan == "bwvwc") {
	            _this3.setState({ wcallowedtoacess: true });
	          } else {
	            _this3.setState({ wcallowedtoacess: false });
	          }
	        }
	      });
	    }
	  }, {
	    key: 'showNoaccess',
	    value: function showNoaccess() {
	
	      _reactNotifications.NotificationManager.error('Please subscribe or upgrade your subscription');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      var profilepicture = this.state.auth_data.profilepicture ? this.state.auth_data.profilepicture : '';
	
	      //console.log(profilepicture)
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          'nav',
	          { 'class': 'sidebar sidebar-offcanvas', id: 'sidebar' },
	          _react2.default.createElement(
	            'ul',
	            { 'class': 'nav' },
	            _react2.default.createElement(
	              'li',
	              { 'class': 'nav-item' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'd-flex sidebar-profile' },
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'sidebar-profile-image' },
	                  (profilepicture == undefined || profilepicture == '') && _react2.default.createElement('i', { 'class': 'fa fa-user', 'aria-hidden': 'true' }),
	                  profilepicture != undefined && profilepicture != '' && _react2.default.createElement('img', { src: _constant.AZ_ASSET_PATH + profilepicture, alt: 'image' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'sidebar-profile-name' },
	                  _react2.default.createElement(
	                    'p',
	                    { 'class': 'sidebar-designation' },
	                    'welcome',
	                    _react2.default.createElement(
	                      'span',
	                      { 'class': 'loggeduserdisplay' },
	                      this.state.user_name
	                    )
	                  )
	                )
	              )
	            ),
	            this.state.role == 10 && _react2.default.createElement(
	              _react2.default.Fragment,
	              null,
	              _react2.default.createElement(
	                'li',
	                { 'class': 'nav-item' },
	                _react2.default.createElement(
	                  'a',
	                  { 'class': 'nav-link', 'data-toggle': 'collapse', href: '#dashboard', 'aria-expanded': 'false', 'aria-controls': 'form-elements' },
	                  _react2.default.createElement('i', { 'class': 'typcn typcn-film menu-icon' }),
	                  _react2.default.createElement(
	                    'span',
	                    { 'class': 'menu-title' },
	                    'Dashboard'
	                  ),
	                  _react2.default.createElement('i', { 'class': 'menu-arrow' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'collapse', id: 'dashboard' },
	                  _react2.default.createElement(
	                    'ul',
	                    { 'class': 'nav flex-column sub-menu' },
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'dashboard', href: '/dashboard/dashboard' },
	                        'Dashboard'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'reportsparents', href: '/dashboard/reportsparents' },
	                        'Report (Parents)'
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                { 'class': 'nav-item' },
	                _react2.default.createElement(
	                  'a',
	                  { 'class': 'nav-link', 'data-toggle': 'collapse', href: '#categories', 'aria-expanded': 'false', 'aria-controls': 'form-elements' },
	                  _react2.default.createElement('i', { 'class': 'typcn typcn-film menu-icon' }),
	                  _react2.default.createElement(
	                    'span',
	                    { 'class': 'menu-title' },
	                    'Verticals'
	                  ),
	                  _react2.default.createElement('i', { 'class': 'menu-arrow' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'collapse', id: 'categories' },
	                  _react2.default.createElement(
	                    'ul',
	                    { 'class': 'nav flex-column sub-menu' },
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'school', href: '/vertical/school' },
	                        'Schools'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'preschool', href: '/vertical/preschool' },
	                        'Preschools'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'tuitions', href: '/vertical/tuitions' },
	                        'Tuitions'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'afterschoolactivities', href: '/vertical/afterschoolactivities' },
	                        'After School Activities'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'kidsplayarea', href: '/vertical/kidsplayarea' },
	                        'Kids Play Area'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'learningcamps', href: '/vertical/learningcamps' },
	                        'Learning Camps'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'communitysupports', href: '/vertical/communitysupports' },
	                        'Community Supports'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'birthdayevents', href: '/vertical/birthdayevents' },
	                        'Birthday Events'
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                { 'class': 'nav-item' },
	                _react2.default.createElement(
	                  'a',
	                  { 'class': 'nav-link', 'data-toggle': 'collapse', href: '#leads', 'aria-expanded': 'false', 'aria-controls': 'leads' },
	                  _react2.default.createElement('i', { 'class': 'typcn typcn-group-outline menu-icon' }),
	                  _react2.default.createElement(
	                    'span',
	                    { 'class': 'menu-title' },
	                    'Leads'
	                  ),
	                  _react2.default.createElement('i', { 'class': 'menu-arrow' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'collapse', id: 'leads' },
	                  _react2.default.createElement(
	                    'ul',
	                    { 'class': 'nav flex-column sub-menu' },
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      ' ',
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'leadlist', href: '/leads/leadlist' },
	                        ' List '
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            this.state.role != 1 && this.state.role != 2 && this.state.role != 3 && this.state.role != 11 && this.state.role != 10 && this.state.role != 15 && _react2.default.createElement(
	              _react2.default.Fragment,
	              null,
	              _react2.default.createElement(
	                'li',
	                { 'class': 'nav-item' },
	                _react2.default.createElement(
	                  'a',
	                  { 'class': 'nav-link', 'data-toggle': 'collapse', href: '#dashboard', 'aria-expanded': 'false', 'aria-controls': 'form-elements' },
	                  _react2.default.createElement('i', { 'class': 'typcn typcn-film menu-icon' }),
	                  _react2.default.createElement(
	                    'span',
	                    { 'class': 'menu-title' },
	                    'Dashboard'
	                  ),
	                  _react2.default.createElement('i', { 'class': 'menu-arrow' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'collapse', id: 'dashboard' },
	                  _react2.default.createElement(
	                    'ul',
	                    { 'class': 'nav flex-column sub-menu' },
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'dashboard', href: '/dashboard/dashboard' },
	                        'Dashboard'
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                { 'class': 'nav-item' },
	                _react2.default.createElement(
	                  'a',
	                  { 'class': 'nav-link', 'data-toggle': 'collapse', href: '#categories', 'aria-expanded': 'false', 'aria-controls': 'form-elements' },
	                  _react2.default.createElement('i', { 'class': 'typcn typcn-film menu-icon' }),
	                  _react2.default.createElement(
	                    'span',
	                    { 'class': 'menu-title' },
	                    'Verticals'
	                  ),
	                  _react2.default.createElement('i', { 'class': 'menu-arrow' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'collapse', id: 'categories' },
	                  _react2.default.createElement(
	                    'ul',
	                    { 'class': 'nav flex-column sub-menu' },
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'school', href: '/vertical/school' },
	                        'Schools'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'preschool', href: '/vertical/preschool' },
	                        'Preschools'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'tuitions', href: '/vertical/tuitions' },
	                        'Tuitions'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'afterschoolactivities', href: '/vertical/afterschoolactivities' },
	                        'After School Activities'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'kidsplayarea', href: '/vertical/kidsplayarea' },
	                        'Kids Play Area'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'learningcamps', href: '/vertical/learningcamps' },
	                        'Learning Camps'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'communitysupports', href: '/vertical/communitysupports' },
	                        'Community Supports'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'birthdayevents', href: '/vertical/birthdayevents' },
	                        'Birthday Events'
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                { 'class': 'nav-item' },
	                _react2.default.createElement(
	                  'a',
	                  { 'class': 'nav-link', 'data-toggle': 'collapse', href: '#tables', 'aria-expanded': 'false', 'aria-controls': 'tables' },
	                  _react2.default.createElement('i', { 'class': 'typcn typcn-th-small-outline menu-icon' }),
	                  _react2.default.createElement(
	                    'span',
	                    { 'class': 'menu-title' },
	                    'Content Management'
	                  ),
	                  _react2.default.createElement('i', { 'class': 'menu-arrow' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'collapse', id: 'tables' },
	                  _react2.default.createElement(
	                    'ul',
	                    { 'class': 'nav flex-column sub-menu' },
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      ' ',
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'insights', href: '/cms/insights' },
	                        'Articles'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      ' ',
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'events', href: '/cms/events' },
	                        'Events'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      ' ',
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'sitecontents', href: '/cms/sitecontents' },
	                        'Site Contents'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      ' ',
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'mails', href: '/cms/mails' },
	                        'Mail Contents'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      ' ',
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'websiteads', href: '/cms/websiteads' },
	                        ' Website Ads '
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                { 'class': 'nav-item' },
	                _react2.default.createElement(
	                  'a',
	                  { 'class': 'nav-link', 'data-toggle': 'collapse', href: '#duplicates', 'aria-expanded': 'false', 'aria-controls': 'duplicates' },
	                  _react2.default.createElement('i', { 'class': 'typcn typcn-group-outline menu-icon' }),
	                  _react2.default.createElement(
	                    'span',
	                    { 'class': 'menu-title' },
	                    'Duplicates'
	                  ),
	                  _react2.default.createElement('i', { 'class': 'menu-arrow' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'collapse', id: 'duplicates' },
	                  _react2.default.createElement(
	                    'ul',
	                    { 'class': 'nav flex-column sub-menu' },
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      ' ',
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'duplicateinschool', href: '/duplicates/duplicateinschool' },
	                        ' School '
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      ' ',
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'duplicateinpreschool', href: '/duplicates/duplicateinpreschool' },
	                        ' Preschool '
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      ' ',
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'duplicateintuition', href: '/duplicates/duplicateintuition' },
	                        ' Tuition '
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      ' ',
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'duplicateinafterschool', href: '/duplicates/duplicateinafterschool' },
	                        ' After School Activities '
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      ' ',
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'duplicateinkidsplayarea', href: '/duplicates/duplicateinkidsplayarea' },
	                        ' Kids Play Area '
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      ' ',
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'duplicateinlearningcamps', href: '/duplicates/duplicateinlearningcamps' },
	                        ' Learning Camps '
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      ' ',
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'duplicateincommunity', href: '/duplicates/duplicateincommunity' },
	                        ' Community '
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                { 'class': 'nav-item' },
	                _react2.default.createElement(
	                  'a',
	                  { 'class': 'nav-link', 'data-toggle': 'collapse', href: '#leads', 'aria-expanded': 'false', 'aria-controls': 'leads' },
	                  _react2.default.createElement('i', { 'class': 'typcn typcn-group-outline menu-icon' }),
	                  _react2.default.createElement(
	                    'span',
	                    { 'class': 'menu-title' },
	                    'Leads'
	                  ),
	                  _react2.default.createElement('i', { 'class': 'menu-arrow' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'collapse', id: 'leads' },
	                  _react2.default.createElement(
	                    'ul',
	                    { 'class': 'nav flex-column sub-menu' },
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      ' ',
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'leadlist', href: '/leads/leadlist' },
	                        ' List '
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                { 'class': 'nav-item' },
	                _react2.default.createElement(
	                  'a',
	                  { 'class': 'nav-link', 'data-toggle': 'collapse', href: '#wiseconnect', 'aria-expanded': 'false', 'aria-controls': 'wiseconnect' },
	                  _react2.default.createElement('i', { 'class': 'typcn typcn-group-outline menu-icon' }),
	                  _react2.default.createElement(
	                    'span',
	                    { 'class': 'menu-title' },
	                    'WiseConnect'
	                  ),
	                  _react2.default.createElement('i', { 'class': 'menu-arrow' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'collapse', id: 'wiseconnect' },
	                  _react2.default.createElement(
	                    'ul',
	                    { 'class': 'nav flex-column sub-menu' },
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      ' ',
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'subscriberslist', href: '/wiseconnect/subscriberslist' },
	                        ' Subscribers List '
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            this.state.role == 1 && _react2.default.createElement(
	              _react2.default.Fragment,
	              null,
	              _react2.default.createElement(
	                'li',
	                { 'class': 'nav-item' },
	                _react2.default.createElement(
	                  'a',
	                  { 'class': 'nav-link', 'data-toggle': 'collapse', href: '#dashboard', 'aria-expanded': 'false', 'aria-controls': 'form-elements' },
	                  _react2.default.createElement('i', { 'class': 'typcn typcn-film menu-icon' }),
	                  _react2.default.createElement(
	                    'span',
	                    { 'class': 'menu-title' },
	                    'Dashboard'
	                  ),
	                  _react2.default.createElement('i', { 'class': 'menu-arrow' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'collapse', id: 'dashboard' },
	                  _react2.default.createElement(
	                    'ul',
	                    { 'class': 'nav flex-column sub-menu' },
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'dashboard', href: '/dashboard/dashboard' },
	                        'Dashboard'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'reports', href: '/dashboard/reports' },
	                        'Reports'
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                { 'class': 'nav-item' },
	                _react2.default.createElement(
	                  'a',
	                  { 'class': 'nav-link', 'data-toggle': 'collapse', href: '#categories', 'aria-expanded': 'false', 'aria-controls': 'form-elements' },
	                  _react2.default.createElement('i', { 'class': 'typcn typcn-film menu-icon' }),
	                  _react2.default.createElement(
	                    'span',
	                    { 'class': 'menu-title' },
	                    'Verticals'
	                  ),
	                  _react2.default.createElement('i', { 'class': 'menu-arrow' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'collapse', id: 'categories' },
	                  _react2.default.createElement(
	                    'ul',
	                    { 'class': 'nav flex-column sub-menu' },
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'school', href: '/vertical/school' },
	                        'Schools'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'preschool', href: '/vertical/preschool' },
	                        'Preschools'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'tuitions', href: '/vertical/tuitions' },
	                        'Tuitions'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'afterschoolactivities', href: '/vertical/afterschoolactivities' },
	                        'After School Activities'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'kidsplayarea', href: '/vertical/kidsplayarea' },
	                        'Kids Play Area'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'learningcamps', href: '/vertical/learningcamps' },
	                        'Learning Camps'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'communitysupports', href: '/vertical/communitysupports' },
	                        'Community Supports'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'birthdayevents', href: '/vertical/birthdayevents' },
	                        'Birthday Events'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      ' ',
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'bewisecuratedcamps', href: '/admin/bewisecuratedcamps' },
	                        ' BeWise Curated Camps '
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                { 'class': 'nav-item' },
	                _react2.default.createElement(
	                  'a',
	                  { 'class': 'nav-link', 'data-toggle': 'collapse', href: '#users', 'aria-expanded': 'false', 'aria-controls': 'ui-basic' },
	                  _react2.default.createElement('i', { 'class': 'typcn typcn-briefcase menu-icon' }),
	                  _react2.default.createElement(
	                    'span',
	                    { 'class': 'menu-title' },
	                    'User Management'
	                  ),
	                  _react2.default.createElement('i', { 'class': 'menu-arrow' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'collapse', id: 'users' },
	                  _react2.default.createElement(
	                    'ul',
	                    { 'class': 'nav flex-column sub-menu' },
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      ' ',
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'partners', href: '/users/partners' },
	                        'Partners'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      ' ',
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'parents', href: '/users/parents' },
	                        'Parents'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      ' ',
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'exclusivepartners', href: '/users/exclusivepartners' },
	                        'Exclusive Partnerships'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      ' ',
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'bewiseusers', href: '/users/bewiseusers' },
	                        'BeWise Users'
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                { 'class': 'nav-item' },
	                _react2.default.createElement(
	                  'a',
	                  { 'class': 'nav-link', 'data-toggle': 'collapse', href: '#charts', 'aria-expanded': 'false', 'aria-controls': 'charts' },
	                  _react2.default.createElement('i', { 'class': 'fa fa-money menu-icon' }),
	                  _react2.default.createElement(
	                    'span',
	                    { 'class': 'menu-title' },
	                    'Payments'
	                  ),
	                  _react2.default.createElement('i', { 'class': 'menu-arrow' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'collapse', id: 'charts' },
	                  _react2.default.createElement(
	                    'ul',
	                    { 'class': 'nav flex-column sub-menu' },
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      ' ',
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'transactions', href: '/payments/transactions' },
	                        'Transactions'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      ' ',
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'paymentlinks', href: '/payments/paymentlinks' },
	                        'RazorPay PaymentLinks'
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                { 'class': 'nav-item' },
	                _react2.default.createElement(
	                  'a',
	                  { 'class': 'nav-link', 'data-toggle': 'collapse', href: '#tables', 'aria-expanded': 'false', 'aria-controls': 'tables' },
	                  _react2.default.createElement('i', { 'class': 'typcn typcn-th-small-outline menu-icon' }),
	                  _react2.default.createElement(
	                    'span',
	                    { 'class': 'menu-title' },
	                    'Content Management'
	                  ),
	                  _react2.default.createElement('i', { 'class': 'menu-arrow' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'collapse', id: 'tables' },
	                  _react2.default.createElement(
	                    'ul',
	                    { 'class': 'nav flex-column sub-menu' },
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      ' ',
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'insights', href: '/cms/insights' },
	                        'Articles'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      ' ',
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'events', href: '/cms/events' },
	                        'Events'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      ' ',
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'sitecontents', href: '/cms/sitecontents' },
	                        'Site Contents'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      ' ',
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'mails', href: '/cms/mails' },
	                        'Mail Contents'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      ' ',
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'websiteads', href: '/cms/websiteads' },
	                        ' Website Ads '
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                { 'class': 'nav-item' },
	                _react2.default.createElement(
	                  'a',
	                  { 'class': 'nav-link', 'data-toggle': 'collapse', href: '#duplicates', 'aria-expanded': 'false', 'aria-controls': 'duplicates' },
	                  _react2.default.createElement('i', { 'class': 'typcn typcn-group-outline menu-icon' }),
	                  _react2.default.createElement(
	                    'span',
	                    { 'class': 'menu-title' },
	                    'Duplicates'
	                  ),
	                  _react2.default.createElement('i', { 'class': 'menu-arrow' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'collapse', id: 'duplicates' },
	                  _react2.default.createElement(
	                    'ul',
	                    { 'class': 'nav flex-column sub-menu' },
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      ' ',
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'duplicateinschool', href: '/duplicates/duplicateinschool' },
	                        ' School '
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      ' ',
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'duplicateinpreschool', href: '/duplicates/duplicateinpreschool' },
	                        ' Preschool '
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      ' ',
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'duplicateintuition', href: '/duplicates/duplicateintuition' },
	                        ' Tuition '
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      ' ',
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'duplicateinafterschool', href: '/duplicates/duplicateinafterschool' },
	                        ' After School Activities '
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      ' ',
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'duplicateinkidsplayarea', href: '/duplicates/duplicateinkidsplayarea' },
	                        ' Kids Play Area '
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      ' ',
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'duplicateinlearningcamps', href: '/duplicates/duplicateinlearningcamps' },
	                        ' Learning Camps '
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      ' ',
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'duplicateincommunity', href: '/duplicates/duplicateincommunity' },
	                        ' Community '
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                { 'class': 'nav-item' },
	                _react2.default.createElement(
	                  'a',
	                  { 'class': 'nav-link', 'data-toggle': 'collapse', href: '#leads', 'aria-expanded': 'false', 'aria-controls': 'leads' },
	                  _react2.default.createElement('i', { 'class': 'typcn typcn-group-outline menu-icon' }),
	                  _react2.default.createElement(
	                    'span',
	                    { 'class': 'menu-title' },
	                    'Leads'
	                  ),
	                  _react2.default.createElement('i', { 'class': 'menu-arrow' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'collapse', id: 'leads' },
	                  _react2.default.createElement(
	                    'ul',
	                    { 'class': 'nav flex-column sub-menu' },
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      ' ',
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'leadlist', href: '/leads/leadlist' },
	                        ' List '
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      ' ',
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'stats', href: '/leads/stats' },
	                        ' Stats '
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                { 'class': 'nav-item' },
	                _react2.default.createElement(
	                  'a',
	                  { 'class': 'nav-link', 'data-toggle': 'collapse', href: '#enquiries', 'aria-expanded': 'false', 'aria-controls': 'leads' },
	                  _react2.default.createElement('i', { 'class': 'typcn typcn-group-outline menu-icon' }),
	                  _react2.default.createElement(
	                    'span',
	                    { 'class': 'menu-title' },
	                    'Enquiries'
	                  ),
	                  _react2.default.createElement('i', { 'class': 'menu-arrow' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'collapse', id: 'enquiries' },
	                  _react2.default.createElement(
	                    'ul',
	                    { 'class': 'nav flex-column sub-menu' },
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      ' ',
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'leadlist', href: '/enquiry/enquiries' },
	                        ' List '
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                { 'class': 'nav-item' },
	                _react2.default.createElement(
	                  'a',
	                  { 'class': 'nav-link', 'data-toggle': 'collapse', href: '#wiseconnect', 'aria-expanded': 'false', 'aria-controls': 'wiseconnect' },
	                  _react2.default.createElement('i', { 'class': 'typcn typcn-group-outline menu-icon' }),
	                  _react2.default.createElement(
	                    'span',
	                    { 'class': 'menu-title' },
	                    'WiseConnect'
	                  ),
	                  _react2.default.createElement('i', { 'class': 'menu-arrow' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'collapse', id: 'wiseconnect' },
	                  _react2.default.createElement(
	                    'ul',
	                    { 'class': 'nav flex-column sub-menu' },
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      ' ',
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'registeredusers', href: '/wiseconnect/registeredusers' },
	                        ' Registered Users '
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      ' ',
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'newslettersubscribers', href: '/wiseconnect/newslettersubscribers' },
	                        ' Newsletter Subscibers '
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      ' ',
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'courses', href: '/wiseconnect/courses' },
	                        ' Courses '
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      ' ',
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'othercourses', href: '/wiseconnect/othercourses' },
	                        ' Other Courses '
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      ' ',
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'jobs', href: '/wiseconnect/jobs' },
	                        'Jobs'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      ' ',
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'externalblogs', href: '/wiseconnect/externalblogs' },
	                        'External Blogs'
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                { 'class': 'nav-item' },
	                _react2.default.createElement(
	                  'a',
	                  { 'class': 'nav-link', 'data-toggle': 'collapse', href: '#excsingups', 'aria-expanded': 'false', 'aria-controls': 'excsingups' },
	                  _react2.default.createElement('i', { 'class': 'typcn typcn-group-outline menu-icon' }),
	                  _react2.default.createElement(
	                    'span',
	                    { 'class': 'menu-title' },
	                    'Exclusive Signups'
	                  ),
	                  _react2.default.createElement('i', { 'class': 'menu-arrow' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'collapse', id: 'excsingups' },
	                  _react2.default.createElement(
	                    'ul',
	                    { 'class': 'nav flex-column sub-menu' },
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      ' ',
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'auroscholars', href: '/exclsignups/auroscholars' },
	                        ' AuroScholar '
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                { 'class': 'nav-item' },
	                _react2.default.createElement(
	                  'a',
	                  { 'class': 'nav-link', 'data-toggle': 'collapse', href: '#general', 'aria-expanded': 'false', 'aria-controls': 'general' },
	                  _react2.default.createElement('i', { 'class': 'typcn typcn-info-outline menu-icon' }),
	                  _react2.default.createElement(
	                    'span',
	                    { 'class': 'menu-title' },
	                    'Universal Content'
	                  ),
	                  _react2.default.createElement('i', { 'class': 'menu-arrow' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'collapse', id: 'general' },
	                  _react2.default.createElement(
	                    'ul',
	                    { 'class': 'nav flex-column sub-menu' },
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      ' ',
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'localities', href: '/general/localities' },
	                        ' Localities '
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      ' ',
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'cities', href: '/general/cities' },
	                        ' Cities '
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      ' ',
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'contacts', href: '/general/contacts' },
	                        ' Contacts '
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      ' ',
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'images', href: '/general/images' },
	                        ' Images '
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                { 'class': 'nav-item' },
	                _react2.default.createElement(
	                  'a',
	                  { 'class': 'nav-link', 'data-toggle': 'collapse', href: '#settings', 'aria-expanded': 'false', 'aria-controls': 'settings' },
	                  _react2.default.createElement('i', { 'class': 'typcn typcn-cog-outline menu-icon' }),
	                  _react2.default.createElement(
	                    'span',
	                    { 'class': 'menu-title' },
	                    'Admin Access'
	                  ),
	                  _react2.default.createElement('i', { 'class': 'menu-arrow' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'collapse', id: 'settings' },
	                  _react2.default.createElement(
	                    'ul',
	                    { 'class': 'nav flex-column sub-menu' },
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      ' ',
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'roles', href: '/admin/roles' },
	                        ' Role '
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      ' ',
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'gst', href: '/admin/gst' },
	                        ' GST '
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      ' ',
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'packages', href: '/admin/packages' },
	                        ' Packages '
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      ' ',
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'promocode', href: '/admin/promocode' },
	                        ' Promo Codes '
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      ' ',
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'eventresources', href: '/admin/eventresources' },
	                        ' Event Resources '
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      ' ',
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'custommails', href: '/admin/custommails' },
	                        ' Send Mail '
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                { 'class': 'nav-item' },
	                _react2.default.createElement(
	                  'a',
	                  { 'class': 'nav-link', 'data-toggle': 'collapse', href: '#trash', 'aria-expanded': 'false', 'aria-controls': 'trash' },
	                  _react2.default.createElement('i', { 'class': 'typcn typcn-trash menu-icon' }),
	                  _react2.default.createElement(
	                    'span',
	                    { 'class': 'menu-title' },
	                    'Trash'
	                  ),
	                  _react2.default.createElement('i', { 'class': 'menu-arrow' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'collapse', id: 'trash' },
	                  _react2.default.createElement(
	                    'ul',
	                    { 'class': 'nav flex-column sub-menu' },
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      ' ',
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'trash', href: '/trash/partners' },
	                        ' Partners '
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            this.state.role == 3 && _react2.default.createElement(
	              _react2.default.Fragment,
	              null,
	              _react2.default.createElement(
	                'li',
	                { 'class': 'nav-item' },
	                _react2.default.createElement(
	                  'a',
	                  { 'class': 'nav-link', 'data-toggle': 'collapse', href: '#dashboard', 'aria-expanded': 'false', 'aria-controls': 'form-elements' },
	                  _react2.default.createElement('i', { 'class': 'typcn typcn-film menu-icon' }),
	                  _react2.default.createElement(
	                    'span',
	                    { 'class': 'menu-title' },
	                    'Dashboard'
	                  ),
	                  _react2.default.createElement('i', { 'class': 'menu-arrow' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'collapse', id: 'dashboard' },
	                  _react2.default.createElement(
	                    'ul',
	                    { 'class': 'nav flex-column sub-menu' },
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'dashboard', href: '/partner/dashboard' },
	                        'Dashboard'
	                      )
	                    ),
	                    this.state.allowedtoacess && _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'reports', href: '/partner/reports' },
	                        'Reports'
	                      )
	                    ),
	                    !this.state.allowedtoacess && _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item', onClick: this.showNoaccess },
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'reports', href: '#' },
	                        'Reports'
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                { 'class': 'nav-item' },
	                _react2.default.createElement(
	                  'a',
	                  { 'class': 'nav-link', 'data-toggle': 'collapse', href: '#categories', 'aria-expanded': 'false', 'aria-controls': 'form-elements' },
	                  _react2.default.createElement('i', { 'class': 'typcn typcn-film menu-icon' }),
	                  _react2.default.createElement(
	                    'span',
	                    { 'class': 'menu-title' },
	                    'My Account'
	                  ),
	                  _react2.default.createElement('i', { 'class': 'menu-arrow' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'collapse', id: 'categories' },
	                  _react2.default.createElement(
	                    'ul',
	                    { 'class': 'nav flex-column sub-menu' },
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'profile', href: '/partner/profile' },
	                        'Profile'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'accountinfo', href: '/partner/accountinfo' },
	                        'Account info'
	                      )
	                    ),
	                    this.state.allowedtoacess && _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      ' ',
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'benchmarking', href: '/partner/benchmarking' },
	                        'Benchmarking'
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                { 'class': 'nav-item' },
	                _react2.default.createElement(
	                  'a',
	                  { 'class': 'nav-link', 'data-toggle': 'collapse', href: '#users', 'aria-expanded': 'false', 'aria-controls': 'ui-basic' },
	                  _react2.default.createElement('i', { 'class': 'typcn typcn-briefcase menu-icon' }),
	                  _react2.default.createElement(
	                    'span',
	                    { 'class': 'menu-title' },
	                    'Subscriptions'
	                  ),
	                  _react2.default.createElement('i', { 'class': 'menu-arrow' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'collapse', id: 'users' },
	                  _react2.default.createElement(
	                    'ul',
	                    { 'class': 'nav flex-column sub-menu' },
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      ' ',
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'subscriptioninfo', href: '/partner/subscriptioninfo' },
	                        'Subscription info'
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                { 'class': 'nav-item' },
	                _react2.default.createElement(
	                  'a',
	                  { 'class': 'nav-link', 'data-toggle': 'collapse', href: '#leads', 'aria-expanded': 'false', 'aria-controls': 'leads' },
	                  _react2.default.createElement('i', { 'class': 'typcn typcn-group-outline menu-icon' }),
	                  _react2.default.createElement(
	                    'span',
	                    { 'class': 'menu-title' },
	                    'Leads'
	                  ),
	                  _react2.default.createElement('i', { 'class': 'menu-arrow' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'collapse', id: 'leads' },
	                  _react2.default.createElement(
	                    'ul',
	                    { 'class': 'nav flex-column sub-menu' },
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      ' ',
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'leadlist', href: '/leads/leadlist' },
	                        ' List '
	                      )
	                    )
	                  )
	                )
	              ),
	              !this.state.allowedtoacess && _react2.default.createElement(
	                'li',
	                { 'class': 'nav-item', onClick: this.showNoaccess },
	                _react2.default.createElement(
	                  'a',
	                  { 'class': 'nav-link', id: 'review', href: '#' },
	                  _react2.default.createElement('i', { 'class': 'typcn typcn-pen menu-icon' }),
	                  _react2.default.createElement(
	                    'span',
	                    { 'class': 'menu-title' },
	                    'Parents Feedback'
	                  )
	                )
	              ),
	              this.state.allowedtoacess && _react2.default.createElement(
	                'li',
	                { 'class': 'nav-item' },
	                _react2.default.createElement(
	                  'a',
	                  { 'class': 'nav-link', id: 'review', href: '/partner/review' },
	                  _react2.default.createElement('i', { 'class': 'typcn typcn-pen menu-icon' }),
	                  _react2.default.createElement(
	                    'span',
	                    { 'class': 'menu-title' },
	                    'Parents Feedback'
	                  )
	                )
	              ),
	              !this.state.allowedtoacess && _react2.default.createElement(
	                'li',
	                { 'class': 'nav-item', onClick: this.showNoaccess },
	                ' ',
	                _react2.default.createElement(
	                  'a',
	                  { 'class': 'nav-link', id: 'exclusivepartnerships', href: '#' },
	                  _react2.default.createElement('i', { 'class': 'typcn typcn-starburst menu-icon' }),
	                  _react2.default.createElement(
	                    'span',
	                    { 'class': 'menu-title' },
	                    'Curated Partnerships'
	                  )
	                )
	              ),
	              this.state.allowedtoacess && _react2.default.createElement(
	                'li',
	                { 'class': 'nav-item' },
	                ' ',
	                _react2.default.createElement(
	                  'a',
	                  { 'class': 'nav-link', id: 'exclusivepartnerships', href: '/partner/exclusivepartnerships' },
	                  _react2.default.createElement('i', { 'class': 'typcn typcn-starburst menu-icon' }),
	                  _react2.default.createElement(
	                    'span',
	                    { 'class': 'menu-title' },
	                    'Curated Partnerships'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                { 'class': 'nav-item' },
	                ' ',
	                _react2.default.createElement(
	                  'a',
	                  { 'class': 'nav-link', id: 'articles', href: '/partner/articles' },
	                  _react2.default.createElement('i', { 'class': 'typcn typcn-document-text menu-icon' }),
	                  _react2.default.createElement(
	                    'span',
	                    { 'class': 'menu-title' },
	                    'Articles'
	                  )
	                )
	              ),
	              this.state.iswiseconnectsubscribed && _react2.default.createElement(
	                'li',
	                { 'class': 'nav-item' },
	                _react2.default.createElement(
	                  'a',
	                  { 'class': 'nav-link', 'data-toggle': 'collapse', href: '#wiseconnect', 'aria-expanded': 'false', 'aria-controls': 'wiseconnect' },
	                  _react2.default.createElement('i', { 'class': 'typcn typcn-th-small-outline menu-icon' }),
	                  _react2.default.createElement(
	                    'span',
	                    { 'class': 'menu-title' },
	                    'WiseConnect'
	                  ),
	                  _react2.default.createElement('i', { 'class': 'menu-arrow' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'collapse', id: 'wiseconnect' },
	                  !this.state.wcallowedtoacess && _react2.default.createElement(
	                    'span',
	                    { 'class': 'upgradetextinfo' },
	                    'Please subscribe or upgrade your subscription'
	                  ),
	                  this.state.wcallowedtoacess && _react2.default.createElement(
	                    'ul',
	                    { 'class': 'nav flex-column sub-menu' },
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      ' ',
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'wcdashboard', href: '/partner/wcdashboard' },
	                        'Dashboard'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      ' ',
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'wcpostajob', href: '/partner/wcpostajob' },
	                        'Post job'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      ' ',
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'wctalentsearch', href: '/partner/wctalentsearch' },
	                        'Talent Search'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      ' ',
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'wcadvisory', href: '/partner/wcadvisory' },
	                        'Advisory'
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            this.state.role == 11 && _react2.default.createElement(
	              _react2.default.Fragment,
	              null,
	              _react2.default.createElement(
	                'li',
	                { 'class': 'nav-item' },
	                _react2.default.createElement(
	                  'a',
	                  { 'class': 'nav-link', 'data-toggle': 'collapse', href: '#dashboard', 'aria-expanded': 'false', 'aria-controls': 'form-elements' },
	                  _react2.default.createElement('i', { 'class': 'typcn typcn-film menu-icon' }),
	                  _react2.default.createElement(
	                    'span',
	                    { 'class': 'menu-title' },
	                    'Dashboard'
	                  ),
	                  _react2.default.createElement('i', { 'class': 'menu-arrow' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'collapse', id: 'dashboard' },
	                  _react2.default.createElement(
	                    'ul',
	                    { 'class': 'nav flex-column sub-menu' },
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'dashboard', href: '/exclusiveparnter/dashboard' },
	                        'Dashboard'
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            this.state.role == 15 && _react2.default.createElement(
	              _react2.default.Fragment,
	              null,
	              _react2.default.createElement(
	                'li',
	                { 'class': 'nav-item' },
	                _react2.default.createElement(
	                  'a',
	                  { 'class': 'nav-link', 'data-toggle': 'collapse', href: '#categories', 'aria-expanded': 'false', 'aria-controls': 'form-elements' },
	                  _react2.default.createElement('i', { 'class': 'typcn typcn-film menu-icon' }),
	                  _react2.default.createElement(
	                    'span',
	                    { 'class': 'menu-title' },
	                    'Verticals'
	                  ),
	                  _react2.default.createElement('i', { 'class': 'menu-arrow' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'collapse', id: 'categories' },
	                  _react2.default.createElement(
	                    'ul',
	                    { 'class': 'nav flex-column sub-menu' },
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'school', href: '/vertical/school' },
	                        'Schools'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'preschool', href: '/vertical/preschool' },
	                        'Preschools'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'tuitions', href: '/vertical/tuitions' },
	                        'Tuitions'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'afterschoolactivities', href: '/vertical/afterschoolactivities' },
	                        'After School Activities'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'kidsplayarea', href: '/vertical/kidsplayarea' },
	                        'Kids Play Area'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'learningcamps', href: '/vertical/learningcamps' },
	                        'Learning Camps'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'communitysupports', href: '/vertical/communitysupports' },
	                        'Community Supports'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'birthdayevents', href: '/vertical/birthdayevents' },
	                        'Birthday Events'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      ' ',
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'bewisecuratedcamps', href: '/admin/bewisecuratedcamps' },
	                        ' BeWise Curated Camps '
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                { 'class': 'nav-item' },
	                _react2.default.createElement(
	                  'a',
	                  { 'class': 'nav-link', 'data-toggle': 'collapse', href: '#wiseconnect', 'aria-expanded': 'false', 'aria-controls': 'wiseconnect' },
	                  _react2.default.createElement('i', { 'class': 'typcn typcn-group-outline menu-icon' }),
	                  _react2.default.createElement(
	                    'span',
	                    { 'class': 'menu-title' },
	                    'WiseConnect'
	                  ),
	                  _react2.default.createElement('i', { 'class': 'menu-arrow' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'collapse', id: 'wiseconnect' },
	                  _react2.default.createElement(
	                    'ul',
	                    { 'class': 'nav flex-column sub-menu' },
	                    _react2.default.createElement(
	                      'li',
	                      { 'class': 'nav-item' },
	                      ' ',
	                      _react2.default.createElement(
	                        'a',
	                        { 'class': 'nav-link', id: 'registeredusers', href: '/wiseconnect/registeredusers' },
	                        ' Registered Users '
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_reactNotifications.NotificationContainer, null)
	      );
	    }
	  }]);
	
	  return BeWise_SideBar;
	}(_react.Component);
	
	exports.default = BeWise_SideBar;

/***/ },
/* 1015 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _PdfContainerReports = __webpack_require__(888);
	
	var _PdfContainerReports2 = _interopRequireDefault(_PdfContainerReports);
	
	var _DocService = __webpack_require__(359);
	
	var _DocService2 = _interopRequireDefault(_DocService);
	
	var _chart = __webpack_require__(83);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import { Editor } from '@tinymce/tinymce-react';
	
	var optionsN = {
	    scales: {
	        yAxes: [{
	            ticks: {
	                beginAtZero: true
	            }
	        }]
	
	    }
	};
	
	var singleReport = function (_Component) {
	    _inherits(singleReport, _Component);
	
	    function singleReport(props) {
	        _classCallCheck(this, singleReport);
	
	        var _this = _possibleConstructorReturn(this, (singleReport.__proto__ || Object.getPrototypeOf(singleReport)).call(this, props));
	
	        _this.handleChange = function (e) {
	            _this.setState(_defineProperty({}, e.target.name, e.target.value));
	        };
	
	        _this.setLeads = function (data) {
	
	            var ctx = document.getElementById('barChartLeads');
	            new _chart.Chart(ctx, {
	                type: 'bar',
	                data: data,
	                options: optionsN
	            });
	        };
	
	        _this.setLike = function (data) {
	
	            var ctx = document.getElementById('barChartLikeFollows');
	            new _chart.Chart(ctx, {
	                type: 'bar',
	                data: data,
	                options: optionsN
	            });
	        };
	
	        _this.setReviews = function (data) {
	
	            var ctx = document.getElementById('barChartReviews');
	            new _chart.Chart(ctx, {
	                type: 'bar',
	                data: data,
	                options: optionsN
	            });
	        };
	
	        _this.setEnquiries = function (data) {
	
	            var ctx = document.getElementById('barChartEnquiries');
	            new _chart.Chart(ctx, {
	                type: 'bar',
	                data: data,
	                options: optionsN
	            });
	        };
	
	        _this.createPdf = function (html) {
	            return _DocService2.default.createPdf(html);
	        };
	
	        _this.state = {
	            school_data: [],
	            vendor_id: _this.props.match.params.id
	        };
	
	        return _this;
	    }
	
	    _createClass(singleReport, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            var userinfo = JSON.stringify({
	                vendor_id: this.state.vendor_id
	            });
	
	            (0, _FetchCall.getVendorInfo)(userinfo).then(function (response) {
	                if (response.status === 1) {
	                    var data = response.results[0];
	
	                    var req = {
	                        url: 'school_data'
	                    };
	
	                    req.user_id = data.login_id;
	                    req.category = data.category_id;
	                    req.url = 'like_follow_chart';
	                    (0, _FetchCall.vendorDashboard)(JSON.stringify(req)).then(function (response) {
	
	                        if (response.status === 1) {
	                            _this2.setLike(response.result);
	                        }
	                    });
	
	                    req.url = 'leads';
	                    (0, _FetchCall.vendorDashboard)(JSON.stringify(req)).then(function (response) {
	
	                        if (response.status === 1) {
	                            _this2.setLeads(response.result);
	                        }
	                    });
	
	                    req.url = 'rating_chart';
	                    (0, _FetchCall.vendorDashboard)(JSON.stringify(req)).then(function (response) {
	
	                        if (response.status === 1) {
	                            _this2.setReviews(response.result);
	                        }
	                    });
	
	                    req.url = 'enquiries';
	                    (0, _FetchCall.vendorDashboard)(JSON.stringify(req)).then(function (response) {
	
	                        if (response.status === 1) {
	                            _this2.setEnquiries(response.result);
	                        }
	                    });
	                }
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	
	            return _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _react2.default.createElement(
	                    _layout2.default,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { 'class': 'row  mt-3' },
	                        _react2.default.createElement(
	                            'div',
	                            { 'class': 'col-xl-12 d-flex grid-margin stretch-card' },
	                            _react2.default.createElement(
	                                'div',
	                                { 'class': 'card' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'card-body' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'd-flex flex-wrap justify-content-between' },
	                                        _react2.default.createElement(
	                                            'h4',
	                                            { 'class': 'card-title mb-3' },
	                                            'Full Report - Partner/Institutions'
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'row' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'col-12' },
	                                            _react2.default.createElement(
	                                                _PdfContainerReports2.default,
	                                                { createPdf: this.createPdf },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { 'class': 'row' },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { 'class': 'col-xl-6 d-flex grid-margin stretch-card' },
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { 'class': 'card' },
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { 'class': 'card-body' },
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    { 'class': 'd-flex flex-wrap justify-content-between' },
	                                                                    _react2.default.createElement(
	                                                                        'h4',
	                                                                        { 'class': 'card-title mb-3' },
	                                                                        'Likes and Follows'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    { 'class': 'row' },
	                                                                    _react2.default.createElement(
	                                                                        'div',
	                                                                        { 'class': 'col-12' },
	                                                                        _react2.default.createElement('canvas', { id: 'barChartLikeFollows' })
	                                                                    )
	                                                                )
	                                                            )
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { 'class': 'col-xl-6 d-flex grid-margin stretch-card' },
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { 'class': 'card' },
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { 'class': 'card-body' },
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    { 'class': 'd-flex flex-wrap justify-content-between' },
	                                                                    _react2.default.createElement(
	                                                                        'h4',
	                                                                        { 'class': 'card-title mb-3' },
	                                                                        'Reviews'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    { 'class': 'row' },
	                                                                    _react2.default.createElement(
	                                                                        'div',
	                                                                        { 'class': 'col-12' },
	                                                                        _react2.default.createElement('canvas', { id: 'barChartReviews' })
	                                                                    )
	                                                                )
	                                                            )
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { 'class': 'col-xl-6 d-flex grid-margin stretch-card' },
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { 'class': 'card' },
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { 'class': 'card-body' },
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    { 'class': 'd-flex flex-wrap justify-content-between' },
	                                                                    _react2.default.createElement(
	                                                                        'h4',
	                                                                        { 'class': 'card-title mb-3' },
	                                                                        'Leads'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    { 'class': 'row' },
	                                                                    _react2.default.createElement(
	                                                                        'div',
	                                                                        { 'class': 'col-12' },
	                                                                        _react2.default.createElement('canvas', { id: 'barChartLeads' })
	                                                                    )
	                                                                )
	                                                            )
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { 'class': 'col-xl-6 d-flex grid-margin stretch-card' },
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { 'class': 'card' },
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { 'class': 'card-body' },
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    { 'class': 'd-flex flex-wrap justify-content-between' },
	                                                                    _react2.default.createElement(
	                                                                        'h4',
	                                                                        { 'class': 'card-title mb-3' },
	                                                                        'Enquiries'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    { 'class': 'row' },
	                                                                    _react2.default.createElement(
	                                                                        'div',
	                                                                        { 'class': 'col-12' },
	                                                                        _react2.default.createElement('canvas', { id: 'barChartEnquiries' })
	                                                                    )
	                                                                )
	                                                            )
	                                                        )
	                                                    )
	                                                )
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return singleReport;
	}(_react.Component);
	
	exports.default = singleReport;

/***/ },
/* 1016 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _FetchCall2 = _interopRequireDefault(_FetchCall);
	
	var _PdfContainer = __webpack_require__(885);
	
	var _PdfContainer2 = _interopRequireDefault(_PdfContainer);
	
	var _DocService = __webpack_require__(884);
	
	var _DocService2 = _interopRequireDefault(_DocService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var transactionDetail = function (_Component) {
	  _inherits(transactionDetail, _Component);
	
	  function transactionDetail(props) {
	    _classCallCheck(this, transactionDetail);
	
	    var _this = _possibleConstructorReturn(this, (transactionDetail.__proto__ || Object.getPrototypeOf(transactionDetail)).call(this, props));
	
	    _this.onChange = function (event) {
	      var name = event.target.name;
	      var value = event.target.value;
	      _this.setState(function (state) {
	        state[name] = value;
	        return state;
	      });
	    };
	
	    _this.createPdf = function (html) {
	      return _DocService2.default.createPdf(html);
	    };
	
	    _this.state = {
	      vendor_id: _this.props.match.params.id,
	      orders: []
	    };
	
	    return _this;
	  }
	
	  _createClass(transactionDetail, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var userinfo = JSON.stringify({
	        vendor_id: this.state.vendor_id
	      });
	      (0, _FetchCall.getInvoiceInfo)(userinfo).then(function (response) {
	        if (response.status == 1) {
	          console.log('response', response);
	          var data = response.results[0];
	          _this2.setState({
	            first_name: data.first_name,
	            organisation_name: data.organisation_name,
	            last_name: data.last_name,
	            email_id: data.email_id,
	            phone_number: data.phone_number,
	            invoice_type: data.invoice_type,
	            location: data.location,
	            state: data.state,
	            address: data.address,
	            pin_code: data.pin_code,
	            plan_name: data.plan_name,
	            created_date: data.created_date,
	            amount: data.amount,
	            discount_amount: data.discount_amount,
	            discount: data.discount,
	            plan_price_original: data.plan_price_original,
	            invoice_no: data.invoice_no,
	            coupon_per: data.coupon_per,
	            coupon_amount: data.coupon_amount,
	            sgst_per: data.sgst_per,
	            sgst_amount: data.sgst_amount,
	            chart_discount_amount: data.chart_discount_amount,
	            cgst_per: data.cgst_per,
	            cgst_amount: data.cgst_amount,
	            payment_id: data.payment_id,
	            start_date: data.start_date,
	            end_date: data.end_date,
	            other_description: data.other_description,
	            orders: data.orders
	          });
	        } else {
	          console.log(response.status);
	        }
	      });
	    }
	  }, {
	    key: 'UNSAFE_componentWillMount',
	    value: function UNSAFE_componentWillMount() {}
	  }, {
	    key: 'render',
	    value: function render() {
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'col-lg-12 grid-margin stretch-card' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card-body' },
	                _react2.default.createElement(
	                  'h4',
	                  { 'class': 'card-title' },
	                  'Detail of #',
	                  this.state.vendor_id
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'box-shadow-custom' },
	                  _react2.default.createElement(
	                    _PdfContainer2.default,
	                    { createPdf: this.createPdf },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row invoice-container' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12', style: { marginBottom: '32px', marginTop: '25px' } },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-6 text-right' },
	                          _react2.default.createElement(
	                            'h3',
	                            null,
	                            'Tax Invoice'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-6 text-right' },
	                          _react2.default.createElement('img', { src: '/assets/images/wisdom-logo.png', style: { width: '82px' }, alt: 'logo' })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-8 col-sm-12' },
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          " ",
	                          'Wisdom Tech Solutions Private Limited',
	                          _react2.default.createElement('br', null),
	                          'C-6, Gaurav Enclave, 33/1, KHB Main Road, Sultanpalya',
	                          _react2.default.createElement('br', null),
	                          'Bangalore, Karnataka - 560032',
	                          _react2.default.createElement('br', null),
	                          'Contact No - ',
	                          _react2.default.createElement('br', null),
	                          'TAN - BLRW03167D',
	                          _react2.default.createElement('br', null),
	                          'PAN - AACCW6395B'
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-4 col-sm-12' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'row left-content-invoice' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'col-sm-6 text-right' },
	                            _react2.default.createElement(
	                              'h6',
	                              null,
	                              'DATE : '
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'col-sm-6' },
	                            _react2.default.createElement(
	                              'h6',
	                              null,
	                              ' ',
	                              this.state.created_date
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'col-sm-6  text-right' },
	                            _react2.default.createElement(
	                              'h6',
	                              null,
	                              'INVOICE No : '
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'col-sm-6' },
	                            _react2.default.createElement(
	                              'h6',
	                              null,
	                              this.state.invoice_no
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'col-sm-6  text-right' },
	                            _react2.default.createElement(
	                              'h6',
	                              null,
	                              'Place of Supply : '
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'col-sm-6' },
	                            _react2.default.createElement(
	                              'h6',
	                              null,
	                              this.state.location
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'col-sm-6  text-right' },
	                            _react2.default.createElement(
	                              'h6',
	                              null,
	                              'State of Supply : '
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'col-sm-6' },
	                            _react2.default.createElement(
	                              'h6',
	                              null,
	                              this.state.state
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'col-sm-6  text-right' },
	                            _react2.default.createElement(
	                              'h6',
	                              null,
	                              'Payment Type : '
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'col-sm-6' },
	                            _react2.default.createElement(
	                              'h6',
	                              null,
	                              ' Razorpay'
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'col-sm-6  text-right' },
	                            _react2.default.createElement(
	                              'h6',
	                              null,
	                              'Reference Number : '
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'col-sm-6' },
	                            _react2.default.createElement(
	                              'h6',
	                              null,
	                              this.state.payment_id
	                            )
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12' },
	                        _react2.default.createElement(
	                          'h5',
	                          null,
	                          'BILL TO'
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-8 col-sm-12' },
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          this.state.first_name,
	                          '  ',
	                          this.state.last_name,
	                          _react2.default.createElement('br', null),
	                          this.state.address,
	                          ' ',
	                          _react2.default.createElement('br', null),
	                          'Contact No - ',
	                          this.state.phone_number,
	                          _react2.default.createElement('br', null),
	                          'GST Number'
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-4 col-sm-12' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'row left-content-invoice' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'col-sm-6 text-right' },
	                            _react2.default.createElement(
	                              'h6',
	                              null,
	                              'Terms : '
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'col-sm-6' },
	                            _react2.default.createElement(
	                              'h6',
	                              null,
	                              ' ',
	                              this.state.invoice_type
	                            )
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'back-drop' },
	                          _react2.default.createElement('img', { src: '/assets/dashboard/logo.svg', alt: 'logo' })
	                        ),
	                        _react2.default.createElement(
	                          'table',
	                          null,
	                          _react2.default.createElement(
	                            'thead',
	                            null,
	                            _react2.default.createElement(
	                              'tr',
	                              null,
	                              _react2.default.createElement(
	                                'th',
	                                null,
	                                'DESCRIPTION'
	                              ),
	                              _react2.default.createElement(
	                                'th',
	                                null,
	                                'QTY '
	                              ),
	                              _react2.default.createElement(
	                                'th',
	                                null,
	                                'AMOUNT'
	                              ),
	                              _react2.default.createElement(
	                                'th',
	                                null,
	                                'Duration'
	                              ),
	                              _react2.default.createElement(
	                                'th',
	                                null,
	                                'CGST'
	                              ),
	                              _react2.default.createElement(
	                                'th',
	                                null,
	                                'SGST'
	                              ),
	                              _react2.default.createElement(
	                                'th',
	                                null,
	                                'Net Amount'
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'tbody',
	                            null,
	                            this.state.orders.map(function (item, i) {
	                              return _react2.default.createElement(
	                                'tr',
	                                null,
	                                _react2.default.createElement(
	                                  'td',
	                                  null,
	                                  _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    item.organisation_name
	                                  ),
	                                  ' ',
	                                  _react2.default.createElement('br', null),
	                                  item.description,
	                                  ' - ',
	                                  item.category_name,
	                                  ' '
	                                ),
	                                _react2.default.createElement(
	                                  'td',
	                                  null,
	                                  '1 '
	                                ),
	                                _react2.default.createElement(
	                                  'td',
	                                  null,
	                                  '\u20B9 ',
	                                  item.base_price
	                                ),
	                                _react2.default.createElement(
	                                  'td',
	                                  null,
	                                  item.start_date + ' - ' + item.end_date
	                                ),
	                                _react2.default.createElement(
	                                  'td',
	                                  null,
	                                  '-'
	                                ),
	                                _react2.default.createElement(
	                                  'td',
	                                  null,
	                                  '-'
	                                ),
	                                _react2.default.createElement(
	                                  'td',
	                                  { className: 'text-right' },
	                                  '\u20B9 ',
	                                  parseFloat(item.base_price).toFixed(2),
	                                  ' '
	                                )
	                              );
	                            }),
	                            _react2.default.createElement(
	                              'tr',
	                              null,
	                              _react2.default.createElement('td', { colSpan: '4', rowspan: '7', style: { verticalAlign: "baseline" } }),
	                              _react2.default.createElement(
	                                'td',
	                                { rowspan: '8' },
	                                'Total'
	                              ),
	                              _react2.default.createElement(
	                                'td',
	                                null,
	                                'Sub total '
	                              ),
	                              _react2.default.createElement(
	                                'td',
	                                { className: 'text-right' },
	                                '\u20B9 ',
	                                parseFloat(this.state.plan_price_original).toFixed(2),
	                                '  '
	                              )
	                            ),
	                            this.state.discount_amount > 0 && _react2.default.createElement(
	                              'tr',
	                              null,
	                              _react2.default.createElement(
	                                'td',
	                                null,
	                                'Early Bird Offer '
	                              ),
	                              _react2.default.createElement(
	                                'td',
	                                { className: 'text-right' },
	                                '\u20B9 ',
	                                parseFloat(this.state.discount_amount).toFixed(2),
	                                '  '
	                              )
	                            ),
	                            this.state.chart_discount_amount > 0 && _react2.default.createElement(
	                              'tr',
	                              null,
	                              _react2.default.createElement(
	                                'td',
	                                null,
	                                'Offer '
	                              ),
	                              _react2.default.createElement(
	                                'td',
	                                { className: 'text-right' },
	                                '\u20B9 ',
	                                parseFloat(this.state.chart_discount_amount).toFixed(2),
	                                '  '
	                              )
	                            ),
	                            this.state.coupon_per > 0 && _react2.default.createElement(
	                              'tr',
	                              null,
	                              _react2.default.createElement(
	                                'td',
	                                null,
	                                'Coupon Discount (',
	                                this.state.coupon_per,
	                                '%)'
	                              ),
	                              _react2.default.createElement(
	                                'td',
	                                { className: 'text-right' },
	                                '\u20B9 ',
	                                parseFloat(this.state.coupon_amount).toFixed(2),
	                                '  '
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'tr',
	                              null,
	                              _react2.default.createElement(
	                                'td',
	                                null,
	                                'CGST (',
	                                this.state.cgst_per,
	                                '%) '
	                              ),
	                              _react2.default.createElement(
	                                'td',
	                                { className: 'text-right' },
	                                ' ',
	                                parseFloat(this.state.cgst_amount).toFixed(2),
	                                ' '
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'tr',
	                              null,
	                              _react2.default.createElement(
	                                'td',
	                                null,
	                                'SGST (',
	                                this.state.sgst_per,
	                                '%) '
	                              ),
	                              _react2.default.createElement(
	                                'td',
	                                { className: 'text-right' },
	                                ' ',
	                                parseFloat(this.state.sgst_amount).toFixed(2),
	                                ' '
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'tr',
	                              null,
	                              _react2.default.createElement(
	                                'td',
	                                null,
	                                'Total Amount  '
	                              ),
	                              _react2.default.createElement(
	                                'td',
	                                { className: 'text-right' },
	                                '\u20B9 ',
	                                parseFloat(this.state.amount).toFixed(2),
	                                '  '
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'tr',
	                              null,
	                              _react2.default.createElement(
	                                'td',
	                                null,
	                                'Payment Received  '
	                              ),
	                              _react2.default.createElement(
	                                'td',
	                                { className: 'text-right' },
	                                '\u20B9 ',
	                                parseFloat(this.state.amount).toFixed(2)
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'text-left' },
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            '*This is a computer generated E-mail and doesn\u2019t require a physical copy '
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'text-right' },
	                          _react2.default.createElement(
	                            'h4',
	                            null,
	                            ' ',
	                            _react2.default.createElement(
	                              'b',
	                              null,
	                              'PAID'
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'h4',
	                            null,
	                            ' Wisdom Tech Solutions Private Limited    '
	                          ),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            'Authorised Signatory '
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'text-center' },
	                          _react2.default.createElement(
	                            'h4',
	                            { style: { marginTop: "30px", fontWeight: "bold" } },
	                            'Thank you for the payment! You just made our day              '
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return transactionDetail;
	}(_react.Component);
	
	exports.default = transactionDetail;

/***/ },
/* 1017 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _FetchCall2 = _interopRequireDefault(_FetchCall);
	
	var _reactJsPagination = __webpack_require__(33);
	
	var _reactJsPagination2 = _interopRequireDefault(_reactJsPagination);
	
	var _bewiseloading = __webpack_require__(48);
	
	var _bewiseloading2 = _interopRequireDefault(_bewiseloading);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import { Editor } from '@tinymce/tinymce-react';
	
	//import Pagination from 'rc-pagination';
	
	var paymentTransactions = function (_Component) {
	  _inherits(paymentTransactions, _Component);
	
	  function paymentTransactions(props) {
	    _classCallCheck(this, paymentTransactions);
	
	    var _this = _possibleConstructorReturn(this, (paymentTransactions.__proto__ || Object.getPrototypeOf(paymentTransactions)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var url = new URL(window.location.href);
	    var location = url.searchParams.get("location");
	    var auth_data = JSON.parse(localStorage.getItem("user_data"));
	    _this.state = {
	      logged: localStorage.getItem("authentication"),
	      auth_data: JSON.parse(localStorage.getItem("user_data")),
	      location: location ? location : auth_data.access_location ? auth_data.access_location : 'Bengaluru',
	      paymentList: [],
	      PER_PAGE: 15,
	      total: 0,
	      loading: true,
	      searchby: '',
	      activePage: 0,
	      offset: 0
	    };
	
	    return _this;
	  }
	
	  _createClass(paymentTransactions, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	
	      var THIS = this;
	      (0, _jquery2.default)(document).on('click', '.remove_school', function () {
	        var delete_id = (0, _jquery2.default)(this).data("id");
	        THIS.setState({
	          delete_id: delete_id
	        });
	      });
	
	      this.getTotal('transactions');
	      this.getList();
	    }
	  }, {
	    key: 'handlePageChange',
	    value: function handlePageChange(pageNumber) {
	
	      console.log('active page is ' + pageNumber);
	
	      this.setState({ activePage: pageNumber });
	
	      //this.getTotal('bw_schools');
	      this.getList(pageNumber);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var paymentList = this.state.paymentList;
	      var _state = this.state,
	          currentPage = _state.currentPage,
	          PER_PAGE = _state.PER_PAGE,
	          totalCount = _state.totalCount,
	          total = _state.total;
	
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'col-lg-12 grid-margin stretch-card' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card-body' },
	                _react2.default.createElement(
	                  'h4',
	                  { 'class': 'card-title' },
	                  'Payment Transactions'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'table-responsive pt-3' },
	                  _react2.default.createElement(
	                    'table',
	                    { id: 'tablebw' },
	                    _react2.default.createElement(
	                      'thead',
	                      null,
	                      _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'S.No'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Date'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Payment ID'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Partner name'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Type'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Package Chosen'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Amount'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Status'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Action'
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'tbody',
	                      null,
	                      paymentList.map(function (item, i) {
	
	                        return _react2.default.createElement(
	                          'tr',
	                          null,
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.s_no
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.transaction_date
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.razorpay_payment_id
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.name
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.user_type
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.plan_id
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.amount
	                          ),
	                          _react2.default.createElement('td', { dangerouslySetInnerHTML: { __html: item.status } }),
	                          _react2.default.createElement('td', { dangerouslySetInnerHTML: { __html: item.action } })
	                        );
	                      })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'text-center' },
	                    _react2.default.createElement(_reactJsPagination2.default, {
	                      activePage: this.state.activePage,
	                      itemsCountPerPage: PER_PAGE,
	                      totalItemsCount: this.state.total,
	                      pageRangeDisplayed: 5,
	                      activeClass: "pagination__link--active",
	                      onChange: this.handlePageChange.bind(this),
	                      prevPageText: 'previous',
	                      nextPageText: 'next'
	                    })
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return paymentTransactions;
	}(_react.Component);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.getTotal = function (vertical) {
	    var location = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	
	    var locationselected = location == '' ? _this2.state.location : location;
	
	    var ins = JSON.stringify({
	      vertical: vertical,
	      location: locationselected,
	      searchby: _this2.state.searchby
	    });
	
	    (0, _FetchCall.getTotalTransactions)(ins).then(function (res) {
	
	      _this2.setState({ loading: true });
	
	      if (res.status == 1) {
	
	        _this2.setState({
	
	          total: res.total
	
	        });
	      }
	    });
	  };
	
	  this.getList = function () {
	    var pageNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	    var location = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	    var _state$auth_data = _this2.state.auth_data,
	        login_id = _state$auth_data.login_id,
	        role = _state$auth_data.role;
	
	
	    _this2.setState({ activePage: pageNumber });
	
	    var newOffset = pageNumber == 1 ? 0 : (pageNumber - 1) * _this2.state.PER_PAGE % _this2.state.total;
	
	    var locationselected = location == '' ? _this2.state.location : location;
	
	    var ins = JSON.stringify({
	      vendor_id: login_id,
	      role: role,
	      location: locationselected,
	      searchby: _this2.state.searchby,
	      perpage: _this2.state.PER_PAGE,
	      year: _this2.state.year,
	      month: _this2.state.month,
	      offset: newOffset
	    });
	
	    (0, _FetchCall.getTransactionListV1)(ins).then(function (res) {
	
	      _this2.setState({ loading: true });
	
	      if (res.status == 1) {
	
	        _this2.setState({ loading: !_this2.state.loading });
	
	        _this2.setState({
	
	          paymentList: res.list
	
	        });
	      } else {
	
	        _this2.setState({ loading: !_this2.state.loading });
	
	        _this2.setState({
	          paymentList: []
	        });
	      }
	    });
	  };
	};
	
	exports.default = paymentTransactions;

/***/ },
/* 1018 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _reactJsPagination = __webpack_require__(33);
	
	var _reactJsPagination2 = _interopRequireDefault(_reactJsPagination);
	
	__webpack_require__(18);
	
	var _reactNotifications = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import { Editor } from '@tinymce/tinymce-react';
	
	//import Pagination from 'rc-pagination';
	
	
	var partnerListTrashed = function (_Component) {
	  _inherits(partnerListTrashed, _Component);
	
	  function partnerListTrashed(props) {
	    _classCallCheck(this, partnerListTrashed);
	
	    var _this = _possibleConstructorReturn(this, (partnerListTrashed.__proto__ || Object.getPrototypeOf(partnerListTrashed)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var url = new URL(window.location.href);
	    var location = url.searchParams.get("location");
	    var auth_data = JSON.parse(localStorage.getItem("user_data"));
	    _this.state = {
	      logged: localStorage.getItem("authentication"),
	      auth_data: JSON.parse(localStorage.getItem("user_data")),
	      location: location ? location : auth_data.access_location ? auth_data.access_location : 'Bengaluru',
	      partnerList: [],
	      exportbtndisabled: false,
	      PER_PAGE: 15,
	      total: 0,
	      loading: true,
	      searchby: '',
	      activePage: 0,
	      offset: 0,
	      thisExportBtnText: 'Export',
	      monthList: [{ no: 1, mon: 'Jan' }, { no: 2, mon: 'Feb' }, { no: 3, mon: 'Mar' }, { no: 4, mon: 'Apr' }, { no: 5, mon: 'May' }, { no: 6, mon: 'Jun' }, { no: 7, mon: 'Jul' }, { no: 8, mon: 'Aug' }, { no: 9, mon: 'Sep' }, { no: 10, mon: 'Oct' }, { no: 11, mon: 'Nov' }, { no: 12, mon: 'Dec' }]
	    };
	
	    return _this;
	  }
	
	  _createClass(partnerListTrashed, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	
	      var THIS = this;
	
	      (0, _jquery2.default)(document).on('click', '.restoretrash', function () {
	        var trash_id = (0, _jquery2.default)(this).data("id");
	        THIS.restoretrashit(trash_id);
	      });
	
	      this.getTotalTrashed('partners');
	      this.getListTrashed();
	    }
	  }, {
	    key: 'restoretrashit',
	    value: function restoretrashit() {
	      var deact_id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	      if (confirm("Are you sure to restore?") == true) {
	        var ins = JSON.stringify({
	          id: deact_id
	        });
	        (0, _FetchCall.restoreTrash)(ins).then(function (res) {
	
	          if (res.status === 1) {
	
	            _reactNotifications.NotificationManager.success(res.message);
	
	            setTimeout(function () {
	              window.location.reload();
	            }, 2000);
	          } else {
	
	            _reactNotifications.NotificationManager.error(res.message);
	          }
	        });
	      }
	    }
	  }, {
	    key: 'handlePageChange',
	    value: function handlePageChange(pageNumber) {
	
	      console.log('active page is ' + pageNumber);
	
	      this.setState({ activePage: pageNumber });
	
	      //this.getTotal('bw_schools');
	      this.getList(pageNumber);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          partnerList = _state.partnerList,
	          exportbtndisabled = _state.exportbtndisabled;
	      var _state2 = this.state,
	          eventList = _state2.eventList,
	          currentPage = _state2.currentPage,
	          PER_PAGE = _state2.PER_PAGE,
	          totalCount = _state2.totalCount,
	          total = _state2.total;
	
	
	      var year = 2019;
	      var years = Array.from(new Array(10), function (val, index) {
	        return index + year;
	      });
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'col-lg-12 grid-margin stretch-card' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card-body' },
	                _react2.default.createElement(
	                  'h4',
	                  { 'class': 'card-title' },
	                  'Trashed Partner Info'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'table-responsive pt-3' },
	                  _react2.default.createElement(
	                    'table',
	                    { id: 'tablebw' },
	                    _react2.default.createElement(
	                      'thead',
	                      { 'class': 'thead-dark' },
	                      _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'S.No'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Name'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Email Id'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Type'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Category'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Created on'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Status'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Action'
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'tbody',
	                      null,
	                      partnerList.length > 0 && partnerList.map(function (item, i) {
	
	                        return _react2.default.createElement(
	                          'tr',
	                          null,
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.s_no
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.name
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.email_id
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.user_type
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.category_name
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.created_date
	                          ),
	                          _react2.default.createElement('td', { dangerouslySetInnerHTML: { __html: item.status } }),
	                          _react2.default.createElement('td', { 'class': 'actionbtns', dangerouslySetInnerHTML: { __html: item.action } })
	                        );
	                      }),
	                      partnerList.length == 0 && _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                          'td',
	                          { colspan: '5' },
	                          'No data'
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'text-center' },
	                    _react2.default.createElement(_reactJsPagination2.default, {
	                      activePage: this.state.activePage,
	                      itemsCountPerPage: PER_PAGE,
	                      totalItemsCount: this.state.total,
	                      pageRangeDisplayed: 5,
	                      activeClass: "pagination__link--active",
	                      onChange: this.handlePageChange.bind(this),
	                      prevPageText: 'previous',
	                      nextPageText: 'next'
	                    })
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(_reactNotifications.NotificationContainer, null)
	        )
	      );
	    }
	  }]);
	
	  return partnerListTrashed;
	}(_react.Component);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.getTotalTrashed = function (vertical) {
	    var location = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	
	    var locationselected = location == '' ? _this2.state.location : location;
	
	    var ins = JSON.stringify({
	      vertical: vertical,
	      location: locationselected,
	      searchby: _this2.state.searchby
	    });
	
	    (0, _FetchCall.getTotalPartnersTrashed)(ins).then(function (res) {
	
	      _this2.setState({ loading: true });
	
	      if (res.status == 1) {
	
	        _this2.setState({
	
	          total: res.total
	
	        });
	      }
	    });
	  };
	
	  this.handleChangeN = function (e) {
	    _this2.setState(_defineProperty({}, e.target.name, e.target.value));
	  };
	
	  this.filterShow = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	    var _state$auth_data, login_id, role, ins;
	
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            _state$auth_data = _this2.state.auth_data, login_id = _state$auth_data.login_id, role = _state$auth_data.role;
	            ins = JSON.stringify({
	              login_id: login_id,
	              role: role,
	              location: _this2.state.location,
	              year: _this2.state.year,
	              month: _this2.state.month
	            });
	
	            (0, _FetchCall.getPartnerPagedTrashed)(ins).then(function (res) {
	              if (res.status == 1) {
	                _this2.setState({
	                  partnerList: res.data
	
	                });
	              } else {
	                _this2.setState({
	                  partnerList: []
	                });
	              }
	            });
	
	          case 3:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, _this2);
	  }));
	
	  this.getListTrashed = function () {
	    var pageNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	    var location = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	    var _state$auth_data2 = _this2.state.auth_data,
	        login_id = _state$auth_data2.login_id,
	        role = _state$auth_data2.role;
	
	
	    _this2.setState({ activePage: pageNumber });
	
	    var newOffset = pageNumber == 1 ? 0 : (pageNumber - 1) * _this2.state.PER_PAGE % _this2.state.total;
	
	    var locationselected = location == '' ? _this2.state.location : location;
	
	    var ins = JSON.stringify({
	      vendor_id: login_id,
	      role: role,
	      location: locationselected,
	      searchby: _this2.state.searchby,
	      perpage: _this2.state.PER_PAGE,
	      offset: newOffset
	    });
	
	    (0, _FetchCall.getPartnerPagedTrashed)(ins).then(function (res) {
	
	      _this2.setState({ loading: true });
	
	      if (res.status == 1) {
	
	        _this2.setState({ loading: !_this2.state.loading });
	
	        _this2.setState({
	
	          partnerList: res.data
	
	        });
	      } else {
	
	        _this2.setState({ loading: !_this2.state.loading });
	
	        _this2.setState({
	          partnerList: []
	        });
	      }
	    });
	  };
	};
	
	exports.default = partnerListTrashed;

/***/ },
/* 1019 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _FetchCall2 = _interopRequireDefault(_FetchCall);
	
	var _reactJsPagination = __webpack_require__(33);
	
	var _reactJsPagination2 = _interopRequireDefault(_reactJsPagination);
	
	var _bewiseloading = __webpack_require__(48);
	
	var _bewiseloading2 = _interopRequireDefault(_bewiseloading);
	
	__webpack_require__(18);
	
	var _reactNotifications = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var verticalAFA = function (_Component) {
	  _inherits(verticalAFA, _Component);
	
	  function verticalAFA(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, verticalAFA);
	
	    var _this = _possibleConstructorReturn(this, (verticalAFA.__proto__ || Object.getPrototypeOf(verticalAFA)).call(this, props));
	
	    _this.getTotal = function () {
	      var location = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	
	      var locationselected = location === '' ? _this.state.location : location;
	
	      var ins = JSON.stringify({
	        vertical: _this.state.tablename,
	        location: locationselected,
	        searchby: _this.state.searchby
	      });
	
	      (0, _FetchCall.getTotal)(ins).then(function (res) {
	
	        _this.setState({ loading: true });
	
	        if (res.status === 1) {
	
	          _this.setState({
	
	            total: res.total
	
	          });
	        }
	      });
	    };
	
	    _this.handleChangeCheckBox = function (event) {
	
	      var newArray = [].concat(_toConsumableArray(_this.state.toapprove), [event.target.value]);
	      if (!event.target.checked) {
	        //if (this.state.toapprove.includes(event.target.value)) {
	        newArray = newArray.filter(function (day) {
	          return day !== event.target.value;
	        });
	        //} 
	      }
	      _this.setState({
	        toapprove: newArray
	      });
	      //console.log(event.target.checked);
	      //console.log(newArray);
	      //console.log(newArray.length);
	      if (newArray.length > 0) _this.setState({ clickedbulkapproval: true });else _this.setState({ clickedbulkapproval: false });
	    };
	
	    _this.bulkApproval = function (e) {
	
	      console.log(_this.state.toapprove);
	
	      var ins = JSON.stringify({
	        vertical: 'afa',
	        ids: _this.state.toapprove
	      });
	
	      (0, _FetchCall.approveBulk)(ins).then(function (res) {
	
	        //console.log(res.message);
	        _reactNotifications.NotificationManager.success(res.message);
	      });
	    };
	
	    _this.getList = function () {
	      var pageNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	      var location = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	      var _this$state$auth_data = _this.state.auth_data,
	          login_id = _this$state$auth_data.login_id,
	          role = _this$state$auth_data.role;
	
	
	      _this.setState({ activePage: pageNumber });
	
	      var newOffset = pageNumber === 1 ? 0 : (pageNumber - 1) * _this.state.PER_PAGE % _this.state.total;
	
	      var locationselected = location === '' ? _this.state.location : location;
	
	      var ins = JSON.stringify({
	        vendor_id: login_id,
	        role: role,
	        location: locationselected,
	        searchby: _this.state.searchby,
	        perpage: _this.state.PER_PAGE,
	        offset: newOffset
	      });
	
	      _this.setState({ loading: true });
	
	      (0, _FetchCall.getAFAPaged)(ins).then(function (res) {
	        if (res.status === 1) {
	
	          _this.setState({ loading: !_this.state.loading });
	          _this.setState({
	
	            afaList: res.data
	
	          });
	        } else {
	
	          _this.setState({ loading: !_this.state.loading });
	
	          _this.setState({
	            afaList: []
	          });
	        }
	      });
	    };
	
	    _this.handleSelect = function (e) {
	      _this.setState({ location: e.target.value, activePage: 1 });
	      localStorage.setItem("location", e.target.value);
	      _this.getTotal(e.target.value);
	      _this.getList(1, e.target.value);
	    };
	
	    _this.handleChange = function (e) {
	      _this.setState(_defineProperty({}, e.target.name, e.target.value));
	    };
	
	    _this.searchBy = function (e) {
	
	      _this.setState({ loading: true, activePage: 1 });
	      _this.getTotal();
	      _this.getList(1);
	    };
	
	    _this.schoolExport = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var req, res;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	
	              _this.setState({ exportbtndisabled: true, thisExportBtnText: "exporting..." });
	
	              _context.prev = 1;
	              req = JSON.stringify({
	                location: _this.state.location
	              });
	              _context.next = 5;
	              return (0, _FetchCall.exportSchool)(req);
	
	            case 5:
	              res = _context.sent;
	
	              if (res.status === 1) {
	
	                _this.setState({ exportbtndisabled: false, thisExportBtnText: "Export" });
	                console.log('location_list', res);
	                console.log('location_list', res.path);
	                window.open(res.path);
	
	                // this.setState({
	                //   subscribe_list: res.results,
	                // });
	              }
	
	              _context.next = 12;
	              break;
	
	            case 9:
	              _context.prev = 9;
	              _context.t0 = _context['catch'](1);
	
	              _this.setState({ error: true });
	
	            case 12:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2, [[1, 9]]);
	    }));
	
	    var url = new URL(window.location.href);
	    _this.state = {
	      logged: localStorage.getItem("authentication"),
	      auth_data: JSON.parse(localStorage.getItem("user_data")),
	      location: localStorage.getItem("location") ? localStorage.getItem("location") : 'Bengaluru',
	      afaList: [],
	      categoryTypeList: [],
	      searchby: '',
	      activePage: 0,
	      tablename: 'bw_hobby_interest',
	      offset: 0,
	      PER_PAGE: 15,
	      total: 0,
	      loading: true,
	      exportbtndisabled: false,
	      thisExportBtnText: 'Export',
	      clickedbulkapproval: false,
	      toapprove: []
	    };
	
	    _this.Cat_type();
	    _this.handleSelect = _this.handleSelect.bind(_this);
	    _this.handleChangeCheckBox = _this.handleChangeCheckBox.bind(_this);
	    return _this;
	  }
	
	  _createClass(verticalAFA, [{
	    key: 'Cat_type',
	    value: function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	        var response;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _context2.next = 2;
	                return _FetchCall2.default.getSubCategory('4');
	
	              case 2:
	                response = _context2.sent;
	
	                console.log('categoryTypeList', response);
	                if (response) {
	                  this.setState({ categoryTypeList: response.results });
	                }
	
	              case 5:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this);
	      }));
	
	      function Cat_type() {
	        return _ref2.apply(this, arguments);
	      }
	
	      return Cat_type;
	    }()
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	
	      var THIS = this;
	      (0, _jquery2.default)(document).on('click', '.remove_school', function () {
	        var delete_id = (0, _jquery2.default)(this).data("id");
	
	        if (confirm("You are sure to delete?") === true) {
	
	          var ins = JSON.stringify({
	            id: delete_id,
	            table: 'afa'
	          });
	
	          (0, _FetchCall.removethisItem)(ins).then(function (res) {
	
	            THIS.getTotal();
	            THIS.getList();
	          });
	        }
	      });
	
	      this.getTotal();
	      this.getList();
	    }
	  }, {
	    key: 'handlePageChange',
	    value: function handlePageChange(pageNumber) {
	      this.setState({ activePage: pageNumber });
	      this.getList(pageNumber);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          afaList = _state.afaList,
	          PER_PAGE = _state.PER_PAGE;
	
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'col-lg-12 grid-margin stretch-card' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card-body' },
	                _react2.default.createElement(
	                  'h4',
	                  { 'class': 'card-title' },
	                  'After School Activities'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'float-right' },
	                  _react2.default.createElement(
	                    'button',
	                    { className: 'btn btn-primary btn-sm dropdown-toggle btn-arrow btn-circle', 'data-toggle': 'dropdown', 'aria-expanded': 'false' },
	                    _react2.default.createElement('i', { className: 'fa fa-plus-circle', 'aria-hidden': 'true' }),
	                    ' Add',
	                    _react2.default.createElement('span', { className: 'caret' })
	                  ),
	                  _react2.default.createElement(
	                    'ul',
	                    { className: 'dropdown-menu align-right' },
	                    _react2.default.createElement(
	                      _react2.default.Fragment,
	                      null,
	                      this.state.categoryTypeList.length > 0 && this.state.categoryTypeList.map(function (item, i) {
	                        return _react2.default.createElement(
	                          'li',
	                          null,
	                          _react2.default.createElement(
	                            'a',
	                            { href: 'afterschoolactivities/add/' + item.category_id + '/' + item.category_name.toLowerCase() },
	                            item.category_name
	                          )
	                        );
	                      }),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'a',
	                          { href: 'javascript:void(0)', onClick: function onClick() {
	                              return _this3.importSchool();
	                            } },
	                          'Import'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        'a',
	                        { href: 'javascript:void(0)', onClick: function onClick() {
	                            return _this3.afterschoolExport();
	                          } },
	                        'Export'
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'p',
	                  { 'class': 'card-description' },
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'cityselection' },
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'leftaligned bwlabel' },
	                      'City'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'leftaligned' },
	                      _react2.default.createElement(
	                        'select',
	                        { name: 'location', 'class': 'form-control', onChange: function onChange(e) {
	                            return _this3.handleSelect(e);
	                          },
	                          value: this.state.location },
	                        _react2.default.createElement(
	                          'option',
	                          { value: '' },
	                          'select city'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'Bengaluru' },
	                          'Bengaluru'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'Chennai' },
	                          'Chennai'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'Hyderabad' },
	                          'Hyderabad'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'Coimbatore' },
	                          'Coimbatore'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'Hosur' },
	                          'Hosur'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'Indore' },
	                          'Indore'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'Others' },
	                          'Others'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'leftaligned bwlabel' },
	                      'Search'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'leftaligned' },
	                      _react2.default.createElement('input', { type: 'text', name: 'searchby', 'class': 'form-control form-control-sm', onChange: this.handleChange })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'leftaligned' },
	                      _react2.default.createElement(
	                        'button',
	                        { 'class': 'btn btn-primary btn-sm', onClick: this.searchBy },
	                        'Go'
	                      )
	                    )
	                  )
	                ),
	                this.state.loading && _react2.default.createElement(
	                  'div',
	                  { id: 'loader' },
	                  _react2.default.createElement('img', { src: _bewiseloading2.default, width: '60px', alt: 'loader' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'table-responsive pt-3' },
	                  this.state.clickedbulkapproval && _react2.default.createElement(
	                    'div',
	                    { 'class': 'showbtnapproval' },
	                    _react2.default.createElement(
	                      'button',
	                      { onClick: this.bulkApproval, name: 'bulkapproval', 'class': 'btn btn-primary btn-sm' },
	                      'Approve selected schools'
	                    ),
	                    _react2.default.createElement('br', null)
	                  ),
	                  !this.state.loading && _react2.default.createElement(
	                    'table',
	                    { id: 'tablebw' },
	                    _react2.default.createElement(
	                      'thead',
	                      null,
	                      _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Approval'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'S.No'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Updated On'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'By'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Name'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'City'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Email Id'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Status'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Action'
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'tbody',
	                      null,
	                      afaList.map(function (item, i) {
	
	                        return _react2.default.createElement(
	                          'tr',
	                          null,
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            ' ',
	                            item.actualstatus === 0 && _react2.default.createElement('input', { type: 'checkbox', name: 'toapprove[]', value: item.id, onChange: _this3.handleChangeCheckBox })
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.s_no
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.updated_date
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.updatedby
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.organisation_name
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.location
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.email_id
	                          ),
	                          _react2.default.createElement('td', { dangerouslySetInnerHTML: { __html: item.status } }),
	                          _react2.default.createElement('td', { dangerouslySetInnerHTML: { __html: item.action } })
	                        );
	                      })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'text-center' },
	                    _react2.default.createElement(_reactJsPagination2.default, {
	                      activePage: this.state.activePage,
	                      itemsCountPerPage: PER_PAGE,
	                      totalItemsCount: this.state.total,
	                      pageRangeDisplayed: 5,
	                      activeClass: "pagination__link--active",
	                      onChange: this.handlePageChange.bind(this),
	                      prevPageText: 'previous',
	                      nextPageText: 'next'
	                    })
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return verticalAFA;
	}(_react.Component);
	
	exports.default = verticalAFA;

/***/ },
/* 1020 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _FetchCall2 = _interopRequireDefault(_FetchCall);
	
	var _reactstrap = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import { Editor } from '@tinymce/tinymce-react';
	
	
	var verticalAFADetail = function (_Component) {
	    _inherits(verticalAFADetail, _Component);
	
	    function verticalAFADetail(props) {
	        _classCallCheck(this, verticalAFADetail);
	
	        var _this = _possibleConstructorReturn(this, (verticalAFADetail.__proto__ || Object.getPrototypeOf(verticalAFADetail)).call(this, props));
	
	        _this.handleChange = function (e) {
	            _this.setState(_defineProperty({}, e.target.name, e.target.value));
	        };
	
	        _this.handleCreateSubmit = function (e) {
	            e.preventDefault();
	
	            var subData = JSON.stringify({
	                id: _this.id,
	                user_type: 1,
	                table: 'bw_hobby_interest',
	                plan: _this.state.plan,
	                organisation_name: _this.state.organisation_name,
	                username: _this.state.username,
	                amount: _this.state.amount,
	                first_name: _this.state.first_name,
	                last_name: _this.state.last_name,
	                razorpay_payment_id: _this.state.razorpay_payment_id,
	                enddate: _this.state.enddate
	            });
	            // jQuery("#btnSubmit").attr('disabled', true);
	
	            (0, _FetchCall.CheckCreatePartner)(subData).then(function (res) {
	                var toastr = '';
	                if (res.status === 1) {
	                    toastr = window.toastr.success;
	                    toastr('', res.message, {
	                        positionClass: "toast-bottom-right",
	                        containerId: "toast-bottom-right"
	                    });
	                    window.location.href = document.referrer;
	                } else {
	                    (0, _jquery2.default)("#btnSubmit").attr('disabled', false);
	                    toastr = window.toastr.error; //warning
	                    toastr('Error', 'Something went wrong. try again!...', {
	                        positionClass: "toast-bottom-right",
	                        containerId: "toast-bottom-right"
	                    });
	                }
	            });
	        };
	
	        _this.state = {
	            name_parm: _this.props.match.params.type,
	            infoDetails: [],
	            partnercreation: false
	        };
	        _this.id = _this.props.match.params.id;
	        _this.type = _this.props.match.params.type;
	        _this.openPartnerCreate = _this.openPartnerCreate.bind(_this);
	        _this.infoDetails = _this.infoDetails.bind(_this);
	        return _this;
	    }
	
	    _createClass(verticalAFADetail, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            console.log(this.props);
	            this.infoDetails();
	        }
	    }, {
	        key: 'getPageTitle',
	        value: function getPageTitle(title) {
	            var activityTitle = '';
	            switch (title) {
	                case "tution":
	                    activityTitle = 'Tution Info';
	                    break;
	
	                case "music":
	                    activityTitle = 'Music Info';
	                    break;
	
	                case "sports":
	                    activityTitle = 'Sports Info';
	                    break;
	
	                case "dance":
	                    activityTitle = 'Dance Info';
	                    break;
	
	                case "drawing":
	                    activityTitle = 'Drawing Info';
	                    break;
	                case "yoga":
	                    activityTitle = 'Yoga Info';
	                    break;
	
	                default:
	                    activityTitle = title;
	            }
	            return activityTitle;
	        }
	    }, {
	        key: 'UNSAFE_componentWillMount',
	        value: function UNSAFE_componentWillMount() {}
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {}
	    }, {
	        key: 'infoDetails',
	        value: function () {
	            var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	                var response, data;
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                _context.next = 2;
	                                return _FetchCall2.default.getCreativeActivitiesInfo(this.id);
	
	                            case 2:
	                                response = _context.sent;
	
	                                if (!response) {
	                                    _context.next = 8;
	                                    break;
	                                }
	
	                                data = response.data;
	
	                                this.setState({
	                                    infoDetails: data,
	                                    url: data.url,
	                                    photos_arr: data.photo_arr
	                                });
	
	                                _context.next = 9;
	                                break;
	
	                            case 8:
	                                return _context.abrupt('return', _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    'Error'
	                                ));
	
	                            case 9:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function infoDetails() {
	                return _ref.apply(this, arguments);
	            }
	
	            return infoDetails;
	        }()
	    }, {
	        key: 'gallery_image',
	        value: function gallery_image() {
	            var _this2 = this;
	
	            var photos = this.state.photos_arr !== undefined ? this.state.photos_arr : [];
	            var rows = "";
	            if (photos.length > 0) {
	                rows = photos.map(function (photos, index) {
	                    if (photos.name) return _react2.default.createElement(
	                        'div',
	                        { 'class': 'col-md-4 float-left mt-4 p-0' },
	                        _react2.default.createElement('img', { style: { 'width': '70%' }, src: _this2.state.url + photos.name, alt: 'Img', 'class': 'img-thumbnail' })
	                    );
	                });
	            } else {
	                rows = "";
	            }
	            return rows;
	        }
	    }, {
	        key: 'openPartnerCreate',
	        value: function openPartnerCreate() {
	            this.setState({ partnercreation: true });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var infoDetails = this.state.infoDetails;
	
	            console.log('infoDetails', this.state);
	            console.log('activityTitle', this.state.activityTitle);
	
	            return _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _react2.default.createElement(
	                    _layout2.default,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { 'class': 'col-lg-12 grid-margin stretch-card' },
	                        _react2.default.createElement(
	                            'div',
	                            { 'class': 'card' },
	                            _react2.default.createElement(
	                                'div',
	                                { 'class': 'card-body' },
	                                _react2.default.createElement(
	                                    'h4',
	                                    { 'class': 'card-title' },
	                                    infoDetails.organisation_name,
	                                    ' - View'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'pt-3 detailsection' },
	                                    _react2.default.createElement(
	                                        'form',
	                                        { className: 'custom-form invoice-form col-md-12 col-xs-12 legend-form pad-no' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'box-shadow-custom' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'row' },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group col-md-4' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        'Registration No.'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'p',
	                                                        null,
	                                                        infoDetails.registration_no
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group col-md-4' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        { className: 'text-capitalize' },
	                                                        'Sports Academy Name '
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'p',
	                                                        null,
	                                                        infoDetails.organisation_name
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group col-md-4' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        { className: 'text-capitalize' },
	                                                        'Sub Categories'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'p',
	                                                        null,
	                                                        infoDetails.sub_categories
	                                                    )
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'box-shadow-custom' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'row' },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'col-md-12 col-xs-12' },
	                                                    _react2.default.createElement(
	                                                        'span',
	                                                        { className: 'form-legend' },
	                                                        'Address Information'
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group col-md-4' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        'Email Id'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'p',
	                                                        null,
	                                                        infoDetails.email_id
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group col-md-4' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        'Phone Number'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'p',
	                                                        null,
	                                                        infoDetails.phone_number
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group col-md-4' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        'Website'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'p',
	                                                        null,
	                                                        infoDetails.website
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group col-md-4' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        'State'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'p',
	                                                        null,
	                                                        infoDetails.state
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group col-md-4' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        'Location'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'p',
	                                                        null,
	                                                        infoDetails.location
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group col-md-4' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        'Country'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'p',
	                                                        null,
	                                                        infoDetails.country
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group col-md-4' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        'Area'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'p',
	                                                        null,
	                                                        infoDetails.area
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group col-md-4' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        'Pincode'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'p',
	                                                        null,
	                                                        infoDetails.pincode
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group col-md-4' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        'Address'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'p',
	                                                        null,
	                                                        infoDetails.address
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group col-md-4' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        'Google Location Address'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'p',
	                                                        null,
	                                                        infoDetails.google_location
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group col-md-12' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        'About'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'p',
	                                                        null,
	                                                        infoDetails.about
	                                                    )
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'box-shadow-custom' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'row' },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'col-md-12 col-xs-12' },
	                                                    _react2.default.createElement(
	                                                        'span',
	                                                        { className: 'form-legend' },
	                                                        'Key Information'
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group col-md-4' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        'Type'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'p',
	                                                        null,
	                                                        infoDetails.typname
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group col-md-4' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        'Class Frequency'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'p',
	                                                        null,
	                                                        infoDetails.class_frequency
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group col-md-4 input-group-cus' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        'Age Group'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'p',
	                                                        null,
	                                                        infoDetails.min_age
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group col-md-4' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        'Number of Coaches'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'p',
	                                                        null,
	                                                        infoDetails.number_of_trainee
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group col-md-4 input-group-cus' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        'From Timing'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'p',
	                                                        null,
	                                                        infoDetails.dfrom_time
	                                                    ),
	                                                    _react2.default.createElement('div', null)
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group col-md-4 input-group-cus' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        'To Timing'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'p',
	                                                        null,
	                                                        infoDetails.dto_time
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group col-md-4' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        'Establishment Year '
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'p',
	                                                        null,
	                                                        infoDetails.establishment_Year
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group col-md-4' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        'Average Fees(INR) '
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'p',
	                                                        null,
	                                                        infoDetails.avg_anual_fee
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group col-md-4' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        'Admission Fees '
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'p',
	                                                        null,
	                                                        infoDetails.addmission_fee
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group col-md-4' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        'Student Ratio'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'p',
	                                                        null,
	                                                        infoDetails.stdratio
	                                                    )
	                                                ),
	                                                infoDetails.vendor_id == 1 && _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group col-md-4' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        'Partner Type'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'p',
	                                                        null,
	                                                        infoDetails.partner_type == 1 ? 'Institution' : 'Individual'
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group col-md-4' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        'Website Search Keywords'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'p',
	                                                        null,
	                                                        infoDetails.keywords
	                                                    )
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'box-shadow-custom' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'row' },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'col-md-12 col-xs-12' },
	                                                    _react2.default.createElement(
	                                                        'span',
	                                                        { className: 'form-legend' },
	                                                        'Images'
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group col-md-12' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        'Banner'
	                                                    )
	                                                ),
	                                                infoDetails.images && _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group col-md-4' },
	                                                    _react2.default.createElement('img', { style: { 'width': '70%' }, src: infoDetails.url + infoDetails.images, alt: 'Img', 'class': 'img-thumbnail' })
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { 'class': 'col-md-12 float-left mt-4 p-0' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        'Gallery Images'
	                                                    )
	                                                ),
	                                                this.gallery_image()
	                                            )
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'row' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'col-md-12' },
	                                        _react2.default.createElement(
	                                            'button',
	                                            { 'class': 'btn btn-primary btn-sm', onClick: this.openPartnerCreate },
	                                            'Create Partner'
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    _reactstrap.Modal,
	                                    { isOpen: this.state.partnercreation, size: 'lg', className: 'partnercreation-pop' },
	                                    _react2.default.createElement(
	                                        _reactstrap.ModalBody,
	                                        { className: 'p-0' },
	                                        _react2.default.createElement(
	                                            _reactstrap.Row,
	                                            { className: 'pv-section' },
	                                            _react2.default.createElement(
	                                                _reactstrap.Col,
	                                                { className: '', md: '12' },
	                                                _react2.default.createElement(
	                                                    'h3',
	                                                    null,
	                                                    'Partner Creation Info'
	                                                ),
	                                                _react2.default.createElement('br', null),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { 'class': 'form-row' },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { 'class': 'form-group col-md-6' },
	                                                        _react2.default.createElement(
	                                                            'label',
	                                                            { 'for': 'inputEmail4' },
	                                                            'Organization Name'
	                                                        ),
	                                                        _react2.default.createElement('input', { type: 'text', 'class': 'form-control', id: 'organisation_name', name: 'organisation_name', placeholder: 'Organization Name', onChange: this.handleChange })
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { 'class': 'form-group col-md-6' },
	                                                        _react2.default.createElement(
	                                                            'label',
	                                                            { 'for': 'inputPassword4' },
	                                                            'Username'
	                                                        ),
	                                                        _react2.default.createElement('input', { type: 'text', 'class': 'form-control', id: 'username', name: 'username', placeholder: 'Username', onChange: this.handleChange })
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { 'class': 'form-row' },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { 'class': 'form-group col-md-6' },
	                                                        _react2.default.createElement(
	                                                            'label',
	                                                            { 'for': 'inputAddress' },
	                                                            'First Name'
	                                                        ),
	                                                        _react2.default.createElement('input', { type: 'text', 'class': 'form-control', id: 'first_name', name: 'first_name', placeholder: 'First Name', onChange: this.handleChange })
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { 'class': 'form-group col-md-6' },
	                                                        _react2.default.createElement(
	                                                            'label',
	                                                            { 'for': 'inputAddress2' },
	                                                            'Last Name'
	                                                        ),
	                                                        _react2.default.createElement('input', { type: 'text', 'class': 'form-control', id: 'last_name', name: 'last_name', placeholder: 'Last Name', onChange: this.handleChange })
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { 'class': 'form-row' },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { 'class': 'form-group col-md-6' },
	                                                        _react2.default.createElement(
	                                                            'label',
	                                                            { 'for': 'inputAddress' },
	                                                            'Amount Received'
	                                                        ),
	                                                        _react2.default.createElement('input', { type: 'text', 'class': 'form-control', id: 'amountrecevied', name: 'amount', placeholder: 'Amount', onChange: this.handleChange })
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { 'class': 'form-group col-md-6' },
	                                                        _react2.default.createElement(
	                                                            'label',
	                                                            { 'for': 'inputAddress2' },
	                                                            'Payment Link'
	                                                        ),
	                                                        _react2.default.createElement('input', { type: 'text', 'class': 'form-control', id: 'razorpay_payment_id', name: 'razorpay_payment_id', placeholder: 'Payment Link', onChange: this.handleChange })
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { 'class': 'form-row' },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { 'class': 'form-group col-md-4' },
	                                                        _react2.default.createElement(
	                                                            'label',
	                                                            { 'for': 'inputState' },
	                                                            'Extend'
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'select',
	                                                            { id: 'inputState', 'class': 'form-control', name: 'enddate', onChange: this.handleChange },
	                                                            _react2.default.createElement(
	                                                                'option',
	                                                                { selected: true },
	                                                                'Choose...'
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'option',
	                                                                { value: '2023-06-30' },
	                                                                'June 2023'
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'option',
	                                                                { value: '2023-07-31' },
	                                                                'July 2023'
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'option',
	                                                                { value: '2023-08-30' },
	                                                                'August 2023'
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'option',
	                                                                { value: '2023-09-31' },
	                                                                'Sep 2023'
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'option',
	                                                                { value: '2023-10-30' },
	                                                                'Oct 2023'
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'option',
	                                                                { value: '2023-11-31' },
	                                                                'Nov 2023'
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'option',
	                                                                { value: '2023-12-30' },
	                                                                'Dec 2023'
	                                                            )
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { 'class': 'form-group col-md-4' },
	                                                        _react2.default.createElement(
	                                                            'label',
	                                                            { 'for': 'inputState' },
	                                                            'Plan'
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'select',
	                                                            { id: 'inputState', 'class': 'form-control', name: 'plan', onChange: this.handleChange },
	                                                            _react2.default.createElement(
	                                                                'option',
	                                                                { selected: true },
	                                                                'Choose...'
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'option',
	                                                                { value: '3' },
	                                                                'Value Pro'
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'option',
	                                                                { value: '4' },
	                                                                'Magic'
	                                                            )
	                                                        )
	                                                    )
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactstrap.Row,
	                                            { className: 'pv-section' },
	                                            _react2.default.createElement(
	                                                _reactstrap.Col,
	                                                { className: '', md: '12' },
	                                                _react2.default.createElement(
	                                                    'button',
	                                                    { className: 'btn btn-sm btn-primary custome-submit', onClick: this.handleCreateSubmit },
	                                                    'Submit'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'button',
	                                                    { className: 'btn btn-sm btn-defult custome-submit', style: { marginLeft: '10px' },
	                                                        onClick: function onClick() {
	                                                            _this3.setState({ partnercreation: false });
	                                                        } },
	                                                    'Close'
	                                                )
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return verticalAFADetail;
	}(_react.Component);
	
	exports.default = verticalAFADetail;

/***/ },
/* 1021 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _FetchCall2 = _interopRequireDefault(_FetchCall);
	
	var _constant = __webpack_require__(21);
	
	var _reactGeocode = __webpack_require__(55);
	
	var _reactGeocode2 = _interopRequireDefault(_reactGeocode);
	
	var _simpleReactValidator = __webpack_require__(28);
	
	var _simpleReactValidator2 = _interopRequireDefault(_simpleReactValidator);
	
	var _reactstrap = __webpack_require__(17);
	
	var _multiselectReactDropdown = __webpack_require__(73);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	_reactGeocode2.default.setApiKey("AIzaSyA9MtbfG_zlo64B2lqNMvigTBuXHkagKcE");
	_reactGeocode2.default.setLanguage("en");
	_reactGeocode2.default.setRegion("es");
	_reactGeocode2.default.enableDebug();
	
	var verticalAFAEdit = function (_Component) {
	    _inherits(verticalAFAEdit, _Component);
	
	    function verticalAFAEdit(props) {
	        var _this2 = this;
	
	        _classCallCheck(this, verticalAFAEdit);
	
	        var _this = _possibleConstructorReturn(this, (verticalAFAEdit.__proto__ || Object.getPrototypeOf(verticalAFAEdit)).call(this, props));
	
	        _this.LocationDataList = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	            var res;
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            _context.prev = 0;
	                            _context.next = 3;
	                            return (0, _FetchCall.getLocationList)();
	
	                        case 3:
	                            res = _context.sent;
	
	                            if (res.status === 1) {
	                                console.log('location_list', res.results);
	
	                                _this.setState({
	                                    location_list: res.results,
	                                    error: false
	                                });
	                            }
	
	                            _context.next = 10;
	                            break;
	
	                        case 7:
	                            _context.prev = 7;
	                            _context.t0 = _context['catch'](0);
	
	                            _this.setState({ error: true });
	
	                        case 10:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, _this2, [[0, 7]]);
	        }));
	
	        _this.getKeywords = function () {
	            (0, _FetchCall.commonAPI)(JSON.stringify({ url: 'get_site_keywords', vertical: 'afterschool' })).then(function (res) {
	                if (res.status === 1) {
	                    _this.setState({
	                        keywordsArr: res.results
	                    });
	                }
	            });
	        };
	
	        _this.handleSelect = function (e) {
	            var propName = e.target.name;
	            var value = [].concat(_toConsumableArray(e.target.selectedOptions)).map(function (item) {
	                return item.value;
	            });
	
	            _this.setState(_defineProperty({}, propName, value));
	            console.log('in', propName);
	            // marshall_arts_other 
	            if (propName === 'sub_type') {
	                var filterValue = value.filter(function (item) {
	                    return item === 'others';
	                });
	                console.log('filterValue', filterValue);
	                if (filterValue[0] === 'others') {
	                    _this.setState({
	                        marshall_arts_other: true
	                    });
	                    console.log('in');
	                } else {
	                    console.log('out');
	                    _this.setState({ marshall_arts_other: false, type_other: '' });
	                }
	            }
	        };
	
	        _this.handleSelectSports = function (e) {
	            var propName = e.target.name;
	            var value = [].concat(_toConsumableArray(e.target.selectedOptions)).map(function (item) {
	                return item.value;
	            });
	            _this.setState(_defineProperty({}, propName, value));
	            _this.Sub_Cat_type(value);
	        };
	
	        _this.handleSelectCat1 = function (e) {
	            var propName = e.target.name;
	            var value = [].concat(_toConsumableArray(e.target.selectedOptions)).map(function (item) {
	                return item.value;
	            });
	            _this.setState(_defineProperty({}, propName, value));
	
	            _this.Sub_Cattype1(value);
	        };
	
	        _this.handleSelectCat2 = function (e) {
	            var propName = e.target.name;
	            var value = [].concat(_toConsumableArray(e.target.selectedOptions)).map(function (item) {
	                return item.value;
	            });
	            _this.setState(_defineProperty({}, propName, value));
	
	            _this.Sub_Cattype2(value);
	        };
	
	        _this.handleSelectClassFreq = function (e) {
	            var propName = e.target.name;
	            var value = [].concat(_toConsumableArray(e.target.selectedOptions)).map(function (item) {
	                return item.value;
	            });
	            _this.setState(_defineProperty({}, propName, value));
	        };
	
	        _this.validateMail = function (value, catgry, vendr_id, pageid) {
	            var type_name = 'isEmailValid';
	            var req = JSON.stringify({
	                email_id: value,
	                category: catgry,
	                vendor_id: vendr_id,
	                pageid: pageid
	            });
	            (0, _FetchCall.emailExist_check)(req).then(function (res) {
	                console.log('valuee', res);
	                if (res.status === 1) {
	                    _this.setState(_defineProperty({}, type_name, false));
	                } else {
	                    // return res.status;
	                    _this.setState(_defineProperty({}, type_name, true));
	                }
	            });
	        };
	
	        _this.handleNumberChange = function (e) {
	            var regexp = /^[0-9\b]+$/;
	            var Mnumber = e.target.value;
	
	            if (e.target.value === '' || regexp.test(e.target.value)) {
	                _this.setState(_defineProperty({}, e.target.name, Mnumber));
	            }
	            _this.Geocode_location();
	        };
	
	        _this.handleChange = function (e) {
	            _this.setState(_defineProperty({}, e.target.name, e.target.value));
	            if (e.target.name === 'google_location') _this.Geocode_location();
	            // const propName = e.target.name;
	            // if (propName === 'email_id') {
	            //     this.validateMail(e.target.value, 4, this.state.vendor_id,this.state.pageid);
	            // }
	            // const propName = e.target.name;
	            // if (propName === 'google_location') {
	            // this.Geocode_location();
	            // }
	        };
	
	        _this.onSelect = function (selectedList) {
	            var keywords = [];
	            selectedList.map(function (item, i) {
	                keywords.push(item);
	            });
	            _this.setState({
	                keywords: keywords
	            });
	        };
	
	        _this.onRemove = function (selectedList, removedItem) {
	            var keywords = [];
	            selectedList.map(function (item, i) {
	                keywords.push(item);
	            });
	            _this.setState({
	                keywords: keywords
	            });
	        };
	
	        _this.handleFile = function (e) {
	            // this.Geocode_location();
	            var propName = e.target.name;
	            var files = e.target.files[0];
	            _this.setState(_defineProperty({}, propName, files));
	            var reader = new FileReader();
	            var img = '';
	            var THIS = _this;
	            reader.addEventListener("load", function () {
	                // convert image file to base64 string
	                img = reader.result;
	                THIS.setState({
	                    tempBanner: reader.result
	                });
	            }, false);
	
	            if (files) {
	                reader.readAsDataURL(files);
	            } else {
	                THIS.setState({
	                    tempBanner: ''
	                });
	            }
	        };
	
	        _this.handleFileMultiple = function (e) {
	            _this.setState(_defineProperty({}, e.target.name, e.target.files));
	        };
	
	        _this.removeImage = function (e) {
	            var delete_array = _this.state.delete_array;
	            delete_array.push(e);
	            var updated = _this.state.attachment_file.filter(function (item) {
	                return item.name !== e;
	            });
	            _this.setState({
	                attachment_file: updated,
	                delete_array: delete_array
	            });
	        };
	
	        _this.handlePreview = function (e) {
	            e.preventDefault();
	            if (_this.validator.allValid()) {
	                _this.setState({
	                    preview: true
	                });
	            } else {
	                _this.validator.showMessages();
	                _this.forceUpdate();
	            }
	        };
	
	        _this.preview = function () {
	            var subcate = _this.state.categoryTypeList.map(function (item) {
	                return _this.state.sub_categories.includes(item.category_id.toString()) ? item.category_name : '';
	            });
	            subcate = subcate.filter(function (n) {
	                return n;
	            }).toString();
	            var ttype = _this.state.tutionList.map(function (item) {
	                return _this.state.tution_type.includes(item.id.toString()) ? item.name : '';
	            });
	            ttype = ttype.filter(function (n) {
	                return n;
	            }).toString();
	            var loptions = _this.state.std_ratio.map(function (item) {
	                if (item === 1) {
	                    return 'One to One';
	                }
	                if (item === 2) {
	                    return 'One to Many';
	                }
	                if (item === 3) {
	                    return 'NA';
	                }
	            });
	            loptions = loptions.filter(function (n) {
	                return n;
	            }).toString();
	            //console.log(this.state.class_frequency);
	            //console.log(this.state.ClassList);
	
	            var clsfreq = _this.state.ClassList.map(function (item) {
	                return _this.state.class_frequency.includes(item.id.toString()) ? item.freq_name : '';
	            });
	
	            //clsfreq = clsfreq.filter(n => n).toString();
	            //console.log("class", clsfreq);
	
	            var from_time = _this.state.timingList.map(function (item) {
	                if (item.id === _this.state.from_time) return item.timing;
	            });
	            from_time = from_time.filter(function (n) {
	                return n;
	            }).toString();
	            var to_time = _this.state.timingList.map(function (item) {
	                if (item.id === _this.state.to_time) return item.timing;
	            });
	            to_time = to_time.filter(function (n) {
	                return n;
	            }).toString();
	            return _react2.default.createElement(
	                _reactstrap.Modal,
	                { isOpen: _this.state.preview, size: 'lg', className: 'preview-pop' },
	                _react2.default.createElement(
	                    _reactstrap.ModalBody,
	                    { className: 'p-0' },
	                    _react2.default.createElement(
	                        _reactstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactstrap.Col,
	                            { md: '12' },
	                            _react2.default.createElement('img', { src: '/assets/images/user-header.png', className: 'preview-header' })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactstrap.Row,
	                        { className: 'pv-banner' },
	                        _react2.default.createElement(
	                            _reactstrap.Col,
	                            { className: 'pv-banner-bg', md: '12' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'title-section' },
	                                _react2.default.createElement(
	                                    'p',
	                                    { className: 'banner-title' },
	                                    _this.state.organisation_name
	                                ),
	                                _react2.default.createElement(
	                                    'p',
	                                    { className: 'banner-address' },
	                                    _this.state.address
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactstrap.Row,
	                        { className: 'pv-section' },
	                        _react2.default.createElement(
	                            _reactstrap.Col,
	                            { className: '', md: '12' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'title-section' },
	                                _react2.default.createElement(
	                                    'h4',
	                                    null,
	                                    'About the School'
	                                ),
	                                _react2.default.createElement(
	                                    'p',
	                                    { className: '' },
	                                    _this.state.about
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactstrap.Row,
	                        { className: 'pv-section' },
	                        _react2.default.createElement(
	                            _reactstrap.Col,
	                            { className: '', md: '12' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'title-section' },
	                                _react2.default.createElement(
	                                    'h4',
	                                    null,
	                                    'Key Information'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'row' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-4' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'type-n7ngd' },
	                                            _react2.default.createElement(
	                                                'b',
	                                                null,
	                                                'Sub Category'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'key-po' },
	                                            _react2.default.createElement(
	                                                'p',
	                                                null,
	                                                subcate
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-4' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'type-n7ngd' },
	                                            _react2.default.createElement(
	                                                'b',
	                                                null,
	                                                'Number of Coach'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'key-po' },
	                                            _react2.default.createElement(
	                                                'p',
	                                                null,
	                                                _this.state.number_of_trainee
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-4' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'type-n7ngd' },
	                                            _react2.default.createElement(
	                                                'b',
	                                                null,
	                                                'Timing'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'key-po' },
	                                            _react2.default.createElement(
	                                                'p',
	                                                null,
	                                                from_time === 'NA' || to_time === 'NA' ? 'NA' : from_time + ' ' + _this.state.from_time_cate + ' - ' + to_time + ' ' + _this.state.to_time_cate
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-4' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'type-n7ngd' },
	                                            _react2.default.createElement(
	                                                'b',
	                                                null,
	                                                'Type'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'key-po' },
	                                            _react2.default.createElement(
	                                                'p',
	                                                null,
	                                                ttype
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-4' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'type-n7ngd' },
	                                            _react2.default.createElement(
	                                                'b',
	                                                null,
	                                                'Class Frequency'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'key-po' },
	                                            _react2.default.createElement(
	                                                'p',
	                                                null,
	                                                clsfreq
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-4' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'type-n7ngd' },
	                                            _react2.default.createElement(
	                                                'b',
	                                                null,
	                                                'Age Group'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'key-po' },
	                                            _react2.default.createElement(
	                                                'p',
	                                                null,
	                                                _this.state.min_age
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-4' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'type-n7ngd' },
	                                            _react2.default.createElement(
	                                                'b',
	                                                null,
	                                                'Establishment Year'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'key-po' },
	                                            _react2.default.createElement(
	                                                'p',
	                                                null,
	                                                _this.state.establishment_Year
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-4' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'type-n7ngd' },
	                                            _react2.default.createElement(
	                                                'b',
	                                                null,
	                                                'Avg Fee'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'key-po' },
	                                            _react2.default.createElement(
	                                                'p',
	                                                null,
	                                                parseFloat(_this.state.avg_anual_fee) > 0 ? _this.state.avg_anual_fee + '/Month' : 'NA'
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-4' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'type-n7ngd' },
	                                            _react2.default.createElement(
	                                                'b',
	                                                null,
	                                                'Admission Fee'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'key-po' },
	                                            _react2.default.createElement(
	                                                'p',
	                                                null,
	                                                'Rs.',
	                                                parseFloat(_this.state.addmission_fee) > 0 ? '' + _this.state.addmission_fee : 'NA'
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-4' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'type-n7ngd' },
	                                            _react2.default.createElement(
	                                                'b',
	                                                null,
	                                                'Learning Options'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'key-po' },
	                                            _react2.default.createElement(
	                                                'p',
	                                                null,
	                                                loptions
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-4' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'type-n7ngd' },
	                                            _react2.default.createElement(
	                                                'b',
	                                                null,
	                                                'Free Trial Class'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'key-po' },
	                                            _react2.default.createElement(
	                                                'p',
	                                                null,
	                                                _this.state.has_trail === 0 ? 'NA' : _this.state.has_trail === 1 ? 'Yes, ' : 'No',
	                                                _this.state.has_trail === 1 && ' ' + _this.state.trail_desc
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactstrap.Row,
	                        { className: 'pv-section' },
	                        _react2.default.createElement(
	                            _reactstrap.Col,
	                            { className: '', md: '12' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'title-section' },
	                                _react2.default.createElement(
	                                    'h4',
	                                    null,
	                                    'Gallery'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'row' },
	                                    _this.state.attachment_file.map(function (item) {
	                                        if (item.image_thumb) {
	                                            return _react2.default.createElement(
	                                                'div',
	                                                { className: 'col-md-4' },
	                                                _react2.default.createElement('img', { src: item.image_thumb, className: 'preview-image' })
	                                            );
	                                        } else if (item.name) {
	                                            var file_url = URL.createObjectURL(item);
	                                            return _react2.default.createElement(
	                                                'div',
	                                                { className: 'col-md-4' },
	                                                _react2.default.createElement('img', { src: file_url, className: 'preview-image' })
	                                            );
	                                        }
	                                    }),
	                                    _this.state.attachment_file.length === 0 && _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-4' },
	                                        'No Gallery Images Found'
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactstrap.Row,
	                        { className: 'pv-section' },
	                        _react2.default.createElement(
	                            _reactstrap.Col,
	                            { className: '', md: '12' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'title-section' },
	                                _react2.default.createElement(
	                                    'h4',
	                                    null,
	                                    'Contact Information'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'row' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-4' },
	                                        'Email Id : ',
	                                        _this.state.email_id
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-4' },
	                                        'Contact : ',
	                                        _this.state.phone_number
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-4' },
	                                        'Website : ',
	                                        _this.state.website
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactstrap.Row,
	                        { className: 'pv-section' },
	                        _react2.default.createElement(
	                            _reactstrap.Col,
	                            { className: '', md: '12' },
	                            _react2.default.createElement(
	                                'button',
	                                { className: 'btn btn-sm btn-primary custome-submit', onClick: _this.handleSubmit },
	                                _this.state.edited && (_this.state.role === 1 || _this.state.login_id === 936) ? 'Approve' : 'Submit'
	                            ),
	                            _this.state.edited && (_this.state.role === 1 || _this.state.login_id === 936) && _react2.default.createElement(
	                                'button',
	                                { className: 'btn btn-sm btn-danger custome-submit', style: { marginLeft: '10px' },
	                                    onClick: _this.handleReject },
	                                'Reject'
	                            ),
	                            _react2.default.createElement(
	                                'button',
	                                { className: 'btn btn-sm btn-defult custome-submit', style: { marginLeft: '10px' },
	                                    onClick: function onClick() {
	                                        _this.setState({ preview: false });
	                                    } },
	                                'Close'
	                            )
	                        )
	                    )
	                )
	            );
	        };
	
	        _this.handleReject = function (e) {
	            e.preventDefault();
	            var req = JSON.stringify({
	                id: _this.token
	            });
	            var toastr = '';
	            (0, _FetchCall.hobbiesReject)(req).then(function (res) {
	                if (res.status === 1) {
	                    alert("Rejected");
	                    window.location.href = document.referrer;
	                }
	            });
	        };
	
	        _this.handleSubmit = function (e) {
	            e.preventDefault();
	            if (_this.validator.allValid()) {
	                var insData = {
	                    id: _this.token ? _this.token : '',
	                    about: _this.state.about,
	                    admit_fee: _this.state.addmission_fee,
	                    address: _this.state.address,
	                    area: _this.state.area,
	                    avg_fee: _this.state.avg_anual_fee,
	                    category: _this.state.category,
	                    class_frequency: _this.state.class_frequency,
	                    country: _this.state.country,
	                    email_id: _this.state.email_id,
	                    est_year: _this.state.establishment_Year,
	                    google_location: _this.state.google_location,
	                    location: _this.state.location,
	                    min_age: _this.state.min_age,
	                    std_ratio: _this.state.std_ratio,
	                    // modeofpayment: this.state.modeofpayment,
	                    number_of_trainee: _this.state.number_of_trainee,
	                    organisation_name: _this.state.organisation_name,
	                    phone_number: _this.state.phone_number,
	                    images: _this.state.images,
	                    photos: _this.state.attachment_file,
	                    pincode: _this.state.pincode,
	                    registration_no: _this.state.registration_no,
	                    state: _this.state.state,
	                    sub_categories: _this.state.sub_categories,
	                    sub_types: _this.state.sub_types,
	                    sub_type: _this.state.sub_type,
	                    timing: _this.state.timing,
	                    video_leaning: _this.state.video_leaning,
	                    website: _this.state.website,
	                    tution_type: _this.state.tution_type,
	                    partner_type: _this.state.partner_type,
	                    other_info: _this.state.other_info,
	                    login_id: _this.state.login_id,
	                    latitude: _this.state.latitude,
	                    longitude: _this.state.longitude,
	                    other_rating: _this.state.other_rating,
	                    from_time: _this.state.from_time,
	                    to_time: _this.state.to_time,
	                    from_time_cate: _this.state.from_time_cate,
	                    to_time_cate: _this.state.to_time_cate,
	
	                    from_time_morning: _this.state.from_time_morning,
	                    from_time_morning_cate: _this.state.from_time_morning_cate,
	                    from_time_evening: _this.state.from_time_evening,
	                    from_time_evening_cate: _this.state.from_time_evening_cate,
	
	                    to_time_morning: _this.state.to_time_morning,
	                    to_time_morning_cate: _this.state.to_time_morning_cate,
	                    to_time_evening: _this.state.to_time_evening,
	                    to_time_evening_cate: _this.state.to_time_evening_cate,
	
	                    keywords: _this.state.keywords ? _this.state.keywords.join(';') : '',
	                    delete_array: _this.state.delete_array,
	                    has_trail: _this.state.has_trail,
	                    trail_desc: _this.state.trail_desc,
	                    role: _this.state.role
	                    // jQuery("#btnSubmit").attr('disabled', true);
	                };(0, _FetchCall.AddSports)(insData).then(function (res) {
	                    var toastr = '';
	                    if (res.status === 1) {
	                        alert("Successfully added");
	                        window.location.href = document.referrer;
	                    } else {
	                        (0, _jquery2.default)("#btnSubmit").attr('disabled', false);
	                        alert("Error");
	                    }
	                });
	            } else {
	                _this.validator.showMessages();
	                _this.forceUpdate();
	            }
	        };
	
	        _this.state = {
	            type_of_orgainsation: _this.props.match.params.type,
	            sub_type: [],
	            pageid: '',
	            location: 'Bengaluru',
	            video_leaning: '',
	            class_frequency: '',
	            modeofpayment: '',
	            categoryTypeList: [],
	            categorySubTypeList: [],
	            timingList: [],
	            timing: '',
	            std_ratio: [],
	            ClassList: [],
	            mopList: [],
	            sub_categories: '',
	            sub_types: [],
	            noCategory: true,
	            category: _this.props.match.params.id,
	            name_parm: _this.props.match.params.type,
	            categorySubTypeList1: [],
	            latitude: '',
	            longitude: '',
	            other_rating: '',
	            tutionList: [],
	            tution_type: '',
	            attachment_file: [],
	            attachment_file_length: 0,
	            attachment_fileName: [],
	            from_time: '',
	            from_time_cate: 'AM',
	            to_time: '',
	            to_time_cate: 'AM',
	            edit_image: '',
	            delete_array: [],
	            keywords: '',
	            location_list: [],
	            tempBanner: '',
	            has_trail: 0,
	            trail_desc: '',
	            partner_type: '',
	            preview: false,
	            edited_data: [],
	            keywordsArr: [],
	            edited: false
	        };
	        _this.validator = new _simpleReactValidator2.default({
	            validators: {
	                checkExist: { // name the rule
	                    message: 'The :attribute field is required.',
	                    rule: function rule(val, params, validator) {
	                        if (val === '' && _this.state.edit_image === '') {
	                            return false;
	                        }
	                    },
	                    messageReplace: function messageReplace(message, params) {
	                        return message.replace(':values', _this.helpers.toSentence(params));
	                    }, // optional
	                    required: true // optional
	                },
	                emailExist_check: { // name the rule
	                    message: 'The :attribute Already Exist.',
	                    rule: function rule(val, params, validator) {
	                        return _this.state.isEmailValid;
	                    },
	                    messageReplace: function messageReplace(message, params) {
	                        return message.replace(':values', _this.helpers.toSentence(params));
	                    }, // optional
	                    required: true // optional
	                },
	                checkMobile: _constant.MOBILE_REGEX,
	                checkUrl: _constant.URL_REGEX
	            }
	        });
	        _this.id = _this.props.match.params.id;
	        _this.token = _this.props.match.params.token;
	        _this.type = _this.props.match.params.type;
	        if (_this.token) {
	            _this.infoDetails = _this.infoDetails.bind(_this);
	            _this.infoDetails();
	        }
	        _this.loadFile = _this.loadFile.bind(_this);
	        _this.handleSelectClassFreq = _this.handleSelectClassFreq.bind(_this);
	
	        _this.getKeywords();
	        _this.Cat_type();_this.tutionList();_this.getclass_frequency();_this.gettiming();_this.getpayment_type();
	        return _this;
	    }
	
	    _createClass(verticalAFAEdit, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.LocationDataList();
	            var user_data = localStorage.getItem("user_data");
	            var auth_data = JSON.parse(user_data);
	            var vendor_id = auth_data.login_id;
	            this.setState({
	                login_id: vendor_id,
	                role: auth_data.role
	            });
	        }
	    }, {
	        key: 'infoDetails',
	        value: function () {
	            var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	                var response, data, edited_data;
	                return _regenerator2.default.wrap(function _callee2$(_context2) {
	                    while (1) {
	                        switch (_context2.prev = _context2.next) {
	                            case 0:
	                                _context2.next = 2;
	                                return (0, _FetchCall.hobbiesEdit)(JSON.stringify({ id: this.token }));
	
	                            case 2:
	                                response = _context2.sent;
	
	                                if (response) {
	                                    data = response.data, edited_data = response.original;
	
	                                    this.setState({
	                                        about: data.about,
	                                        pageid: data.id,
	                                        addmission_fee: data.admit_fee,
	                                        address: data.address,
	                                        area: data.area,
	                                        avg_anual_fee: data.avg_fee,
	                                        class_frequency: data.class_frequency.split(','),
	                                        country: data.country,
	                                        email_id: data.email_id,
	                                        establishment_Year: data.est_year,
	                                        google_location: data.google_location,
	                                        location: data.location,
	                                        min_age: data.min_age,
	                                        modeofpayment: data.modeofpayment,
	                                        number_of_trainee: data.number_of_trainee,
	                                        organisation_name: data.organisation_name,
	                                        phone_number: data.phone_number,
	                                        pincode: data.pincode,
	                                        std_ratio: data.std_ratio.split(','),
	                                        registration_no: data.registration_no,
	                                        state: data.state,
	                                        sub_categories: data.sub_categories.split(','),
	                                        sub_types: data.sub_types.split(','),
	                                        sub_type: data.sub_type.split(','),
	                                        timing: data.time,
	                                        video_leaning: data.video_leaning,
	                                        website: data.website,
	                                        tution_type: data.tution_type.split(','),
	                                        partner_type: data.partner_type,
	                                        other_info: data.other_info,
	                                        cat_type1: data.sub_type ? true : false,
	                                        cat_type: data.type2 ? true : false,
	                                        attachment_file: data.photo_arr,
	                                        edit_image: data.images ? data.url + data.images : '',
	                                        edit_photos: data.photos,
	                                        photos: data.photos,
	                                        images: data.images,
	                                        keywords: data.keywords ? data.keywords.split(';') : [],
	
	                                        from_time: data.from_time,
	                                        to_time: data.to_time,
	                                        from_time_cate: data.from_time_cate,
	                                        to_time_cate: data.to_time_cate,
	
	                                        from_time_morning: data.from_time_morning,
	                                        from_time_morning_cate: data.from_time_morning_cate,
	                                        from_time_evening: data.from_time_evening,
	                                        from_time_evening_cate: data.from_time_evening_cate,
	
	                                        to_time_morning: data.to_time_morning,
	                                        to_time_morning_cate: data.to_time_morning_cate,
	                                        to_time_evening: data.to_time_evening,
	                                        to_time_evening_cate: data.to_time_evening_cate,
	
	                                        has_trail: data.has_trail,
	                                        trail_desc: data.trail_desc,
	                                        longitude: data.longitude,
	                                        latitude: data.latitude,
	                                        other_rating: data.other_rating,
	                                        edited: data.edited,
	                                        edited_data: edited_data
	                                    });
	                                    this.Sub_Cat_type(data.sub_categories);
	                                    this.Geocode_location(data.google_location);
	                                }
	
	                            case 4:
	                            case 'end':
	                                return _context2.stop();
	                        }
	                    }
	                }, _callee2, this);
	            }));
	
	            function infoDetails() {
	                return _ref2.apply(this, arguments);
	            }
	
	            return infoDetails;
	        }()
	    }, {
	        key: 'tutionList',
	        value: function () {
	            var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	                var response;
	                return _regenerator2.default.wrap(function _callee3$(_context3) {
	                    while (1) {
	                        switch (_context3.prev = _context3.next) {
	                            case 0:
	                                _context3.next = 2;
	                                return _FetchCall2.default.getSchoolListDatas('tution_type');
	
	                            case 2:
	                                response = _context3.sent;
	
	                                console.log(response);
	                                if (response) {
	                                    this.setState({ tutionList: response.results });
	                                }
	
	                            case 5:
	                            case 'end':
	                                return _context3.stop();
	                        }
	                    }
	                }, _callee3, this);
	            }));
	
	            function tutionList() {
	                return _ref3.apply(this, arguments);
	            }
	
	            return tutionList;
	        }()
	    }, {
	        key: 'Cat_type',
	        value: function () {
	            var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4() {
	                var response;
	                return _regenerator2.default.wrap(function _callee4$(_context4) {
	                    while (1) {
	                        switch (_context4.prev = _context4.next) {
	                            case 0:
	                                console.log('categoryTypeList', this.props.match.params.id);
	                                _context4.next = 3;
	                                return _FetchCall2.default.getSubCategory(this.props.match.params.id);
	
	                            case 3:
	                                response = _context4.sent;
	
	                                if (response.status === 1) {
	                                    this.setState({ categoryTypeList: response.results });
	                                } else {
	                                    console.log('noCategory', 'in');
	                                    this.setState({ noCategory: false });
	                                }
	
	                            case 5:
	                            case 'end':
	                                return _context4.stop();
	                        }
	                    }
	                }, _callee4, this);
	            }));
	
	            function Cat_type() {
	                return _ref4.apply(this, arguments);
	            }
	
	            return Cat_type;
	        }()
	    }, {
	        key: 'Sub_Cat_type',
	        value: function () {
	            var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(id) {
	                var response;
	                return _regenerator2.default.wrap(function _callee5$(_context5) {
	                    while (1) {
	                        switch (_context5.prev = _context5.next) {
	                            case 0:
	                                if (!(id !== '')) {
	                                    _context5.next = 7;
	                                    break;
	                                }
	
	                                _context5.next = 3;
	                                return _FetchCall2.default.getSubCategory(id);
	
	                            case 3:
	                                response = _context5.sent;
	
	                                if (response.status === 1) {
	                                    this.setState({ categorySubTypeList: response.results, cat_type: true, cat_type1: false, cat_type2: false });
	                                } else {
	                                    this.setState({ categorySubTypeList: [], sub_types: [], cat_type: false, cat_type1: false, cat_type2: false });
	                                }
	                                _context5.next = 8;
	                                break;
	
	                            case 7:
	                                this.setState({ categorySubTypeList: [], sub_types: [], cat_type: false, cat_type1: false, cat_type2: false });
	
	                            case 8:
	                            case 'end':
	                                return _context5.stop();
	                        }
	                    }
	                }, _callee5, this);
	            }));
	
	            function Sub_Cat_type(_x) {
	                return _ref5.apply(this, arguments);
	            }
	
	            return Sub_Cat_type;
	        }()
	    }, {
	        key: 'Sub_Cattype1',
	        value: function () {
	            var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(id) {
	                var response;
	                return _regenerator2.default.wrap(function _callee6$(_context6) {
	                    while (1) {
	                        switch (_context6.prev = _context6.next) {
	                            case 0:
	                                if (!(id !== '')) {
	                                    _context6.next = 7;
	                                    break;
	                                }
	
	                                _context6.next = 3;
	                                return _FetchCall2.default.getSubCategory(id);
	
	                            case 3:
	                                response = _context6.sent;
	
	                                if (response.status === 1) {
	                                    this.setState({ categorySubTypeList1: response.results, cat_type1: true, cat_type2: false });
	                                } else {
	                                    this.setState({ categorySubTypeList1: [], sub_type: [], cat_type1: false, cat_type2: false });
	                                }
	                                _context6.next = 8;
	                                break;
	
	                            case 7:
	                                this.setState({ categorySubTypeList1: [], sub_type: [], cat_type1: false, cat_type2: false });
	
	                            case 8:
	                            case 'end':
	                                return _context6.stop();
	                        }
	                    }
	                }, _callee6, this);
	            }));
	
	            function Sub_Cattype1(_x2) {
	                return _ref6.apply(this, arguments);
	            }
	
	            return Sub_Cattype1;
	        }()
	    }, {
	        key: 'getclass_frequency',
	        value: function () {
	            var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee7() {
	                var response;
	                return _regenerator2.default.wrap(function _callee7$(_context7) {
	                    while (1) {
	                        switch (_context7.prev = _context7.next) {
	                            case 0:
	                                _context7.next = 2;
	                                return _FetchCall2.default.getSchoolListDatas('class_frequency');
	
	                            case 2:
	                                response = _context7.sent;
	
	                                console.log(response);
	                                if (response.status === 1) {
	                                    this.setState({ ClassList: response.results });
	                                }
	
	                            case 5:
	                            case 'end':
	                                return _context7.stop();
	                        }
	                    }
	                }, _callee7, this);
	            }));
	
	            function getclass_frequency() {
	                return _ref7.apply(this, arguments);
	            }
	
	            return getclass_frequency;
	        }()
	    }, {
	        key: 'gettiming',
	        value: function () {
	            var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee8() {
	                var response;
	                return _regenerator2.default.wrap(function _callee8$(_context8) {
	                    while (1) {
	                        switch (_context8.prev = _context8.next) {
	                            case 0:
	                                _context8.next = 2;
	                                return _FetchCall2.default.getSchoolListDatas('timing');
	
	                            case 2:
	                                response = _context8.sent;
	
	                                console.log(response);
	                                if (response) {
	                                    this.setState({ timingList: response.results });
	                                }
	
	                            case 5:
	                            case 'end':
	                                return _context8.stop();
	                        }
	                    }
	                }, _callee8, this);
	            }));
	
	            function gettiming() {
	                return _ref8.apply(this, arguments);
	            }
	
	            return gettiming;
	        }()
	    }, {
	        key: 'getpayment_type',
	        value: function () {
	            var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee9() {
	                var response;
	                return _regenerator2.default.wrap(function _callee9$(_context9) {
	                    while (1) {
	                        switch (_context9.prev = _context9.next) {
	                            case 0:
	                                _context9.next = 2;
	                                return _FetchCall2.default.getSchoolListDatas('payment_type');
	
	                            case 2:
	                                response = _context9.sent;
	
	                                console.log(response);
	                                if (response) {
	                                    this.setState({ mopList: response.results });
	                                }
	
	                            case 5:
	                            case 'end':
	                                return _context9.stop();
	                        }
	                    }
	                }, _callee9, this);
	            }));
	
	            function getpayment_type() {
	                return _ref9.apply(this, arguments);
	            }
	
	            return getpayment_type;
	        }()
	    }, {
	        key: 'UNSAFE_componentWillMount',
	        value: function UNSAFE_componentWillMount() {}
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            window.jQuery('.selectpicker').selectpicker('refresh');
	        }
	    }, {
	        key: 'Geocode_location',
	        value: function Geocode_location() {
	            var _this3 = this;
	
	            var location = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	            _reactGeocode2.default.fromAddress(location ? location : this.state.google_location).then(function (response) {
	                var _response$results$0$g = response.results[0].geometry.location,
	                    lat = _response$results$0$g.lat,
	                    lng = _response$results$0$g.lng;
	
	                if (lat && lng) _this3.get_location(lat, lng);
	            }, function (error) {
	                console.error(error);
	            });
	        }
	    }, {
	        key: 'get_location',
	        value: function get_location(lat, lng) {
	            this.setState({
	                latitude: lat,
	                longitude: lng
	            });
	        }
	    }, {
	        key: 'remove_img',
	        value: function remove_img() {
	            (0, _jquery2.default)('#edit_image').remove();
	        }
	    }, {
	        key: 'loadFile',
	        value: function loadFile(e) {
	            var files = e.target.files;
	            this.setState({ attachment_file_length: files.length });
	            if (files.length > 0) {
	                (0, _jquery2.default)('.upload-space').addClass('hide');
	                (0, _jquery2.default)('.upload-thumb').removeClass('hide');
	                var fileArra = this.state.attachment_file;
	
	                //console.log('fileArra',fileArra)
	                //var fileThumbArra = this.state.imgThumb;
	                for (var i = 0; i < files.length; i++) {
	                    fileArra.push(e.target.files[i]);
	                    this.setState({
	                        selectedFile: URL.createObjectURL(e.target.files[i]),
	                        attachment_file: fileArra
	                    });
	                }
	                //   this.clearValidationErr('attachment_file');
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this4 = this;
	
	            var _state = this.state,
	                edited_data = _state.edited_data,
	                edited = _state.edited;
	
	            this.validator.purgeFields();
	
	            return _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _react2.default.createElement(
	                    _layout2.default,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { 'class': 'col-lg-12 grid-margin stretch-card' },
	                        _react2.default.createElement(
	                            'div',
	                            { 'class': 'card' },
	                            _react2.default.createElement(
	                                'div',
	                                { 'class': 'card-body' },
	                                _react2.default.createElement(
	                                    'h4',
	                                    { 'class': 'card-title' },
	                                    'After School Activities Info Management'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'row' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'content-sec col-md-12 col-xs-12 pad-no mar-t-no' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'tab-content' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { id: 'company-info', className: 'tab-pane in active' },
	                                                _react2.default.createElement(
	                                                    'form',
	                                                    { onSubmit: this.handlePreview, className: 'custom-form invoice-form col-md-12 col-xs-12 legend-form pad-no' },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'box-shadow-custom' },
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'row' },
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    null,
	                                                                    'Partner Type',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    { className: 'custom-select-drop dropdown' },
	                                                                    _react2.default.createElement(
	                                                                        'select',
	                                                                        {
	                                                                            value: this.state.partner_type,
	                                                                            onChange: this.handleSelect, className: 'form-control selectpicker',
	                                                                            name: 'partner_type',
	                                                                            title: 'Select' },
	                                                                        _react2.default.createElement(
	                                                                            'option',
	                                                                            { value: '1' },
	                                                                            'Institution'
	                                                                        ),
	                                                                        _react2.default.createElement(
	                                                                            'option',
	                                                                            { value: '2' },
	                                                                            'Individuals'
	                                                                        )
	                                                                    ),
	                                                                    this.validator.message('Type', this.state.partner_type, 'required', { className: 'text-danger' })
	                                                                )
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.registration_no !== this.state.registration_no && 'edited-field' },
	                                                                    'Registration No ',
	                                                                    this.state.user_type === 1 && _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    ),
	                                                                    ' '
	                                                                ),
	                                                                _react2.default.createElement('input', { type: 'text', name: 'registration_no',
	                                                                    value: this.state.registration_no,
	                                                                    onChange: this.handleChange, className: 'form-control' }),
	                                                                this.state.user_type === 1 && this.validator.message('Registration No', this.state.registration_no, 'required', { className: 'text-danger' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.organisation_name !== this.state.organisation_name && 'edited-field' },
	                                                                    'Academy Name ',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('input', { type: 'text', name: 'organisation_name',
	                                                                    value: this.state.organisation_name,
	                                                                    onChange: this.handleChange, className: 'form-control' }),
	                                                                this.validator.message(this.state.name_parm + 'Academy Name', this.state.organisation_name, 'required', { className: 'text-danger' })
	                                                            ),
	                                                            this.state.noCategory !== false && _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.sub_categories !== this.state.sub_categories && 'edited-field' },
	                                                                    'Sub-Categories ',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    { className: 'custom-select-drop dropdown' },
	                                                                    _react2.default.createElement(
	                                                                        'select',
	                                                                        {
	                                                                            multiple: true,
	                                                                            value: this.state.sub_categories,
	                                                                            onChange: this.handleSelectSports,
	                                                                            name: 'sub_categories',
	                                                                            'data-live-search': 'true',
	                                                                            className: 'form-control selectpicker',
	                                                                            title: 'Select' },
	                                                                        this.state.categoryTypeList.length > 0 && this.state.categoryTypeList.map(function (item, i) {
	                                                                            return _react2.default.createElement(
	                                                                                'option',
	                                                                                { value: item.category_id },
	                                                                                item.category_name
	                                                                            );
	                                                                        })
	                                                                    ),
	                                                                    this.validator.message(this.state.name_parm, this.state.sub_categories, 'required', { className: 'text-danger' })
	                                                                )
	                                                            ),
	                                                            this.state.cat_type === true && _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.sub_types !== this.state.sub_types && 'edited-field' },
	                                                                    'Type',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    { className: 'custom-select-drop dropdown' },
	                                                                    _react2.default.createElement(
	                                                                        'select',
	                                                                        {
	                                                                            multiple: true,
	                                                                            onChange: this.handleSelectCat1,
	                                                                            name: 'sub_types',
	                                                                            className: 'form-control selectpicker',
	                                                                            title: 'Select',
	                                                                            value: this.state.sub_types
	                                                                        },
	                                                                        this.state.categorySubTypeList.length > 0 && this.state.categorySubTypeList.map(function (item, i) {
	                                                                            return _react2.default.createElement(
	                                                                                'option',
	                                                                                { value: item.category_id },
	                                                                                item.category_name
	                                                                            );
	                                                                        })
	                                                                    ),
	                                                                    this.validator.message(this.state.name_parm + ' Type', this.state.sub_types, 'required', { className: 'text-danger' })
	                                                                )
	                                                            ),
	                                                            this.state.cat_type1 === true && _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.sub_type !== this.state.sub_type && 'edited-field' },
	                                                                    _react2.default.createElement('span', { className: 'astrick' })
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    { className: 'custom-select-drop dropdown' },
	                                                                    _react2.default.createElement(
	                                                                        'select',
	                                                                        {
	                                                                            multiple: true,
	                                                                            value: this.state.sub_type,
	                                                                            onChange: this.handleSelectCat2,
	                                                                            name: 'sub_type',
	                                                                            className: 'form-control selectpicker',
	                                                                            title: 'Select'
	                                                                        },
	                                                                        this.state.categorySubTypeList1.length > 0 && this.state.categorySubTypeList1.map(function (item, i) {
	                                                                            return _react2.default.createElement(
	                                                                                'option',
	                                                                                { value: item.category_id },
	                                                                                item.category_name
	                                                                            );
	                                                                        })
	                                                                    ),
	                                                                    this.validator.message('Type', this.state.sub_type, 'required', { className: 'text-danger' })
	                                                                )
	                                                            )
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'box-shadow-custom' },
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'row' },
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'col-md-12 col-xs-12' },
	                                                                _react2.default.createElement(
	                                                                    'span',
	                                                                    { className: 'form-legend' },
	                                                                    'Address Information'
	                                                                )
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.email_id !== this.state.email_id && 'edited-field' },
	                                                                    'Email Id ',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('input', { type: 'text', name: 'email_id',
	                                                                    value: this.state.email_id,
	                                                                    onChange: this.handleChange, className: 'form-control' }),
	                                                                this.validator.message('Email Id', this.state.email_id, 'emailExist_check', { className: 'text-danger' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.phone_number !== this.state.phone_number && 'edited-field' },
	                                                                    'Phone Number ',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('input', { type: 'text', name: 'phone_number',
	                                                                    value: this.state.phone_number,
	                                                                    onChange: this.handleChange, className: 'form-control' }),
	                                                                this.validator.message('Phone Number', this.state.phone_number, '', { className: 'text-danger' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.website !== this.state.website && 'edited-field' },
	                                                                    'Website ',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('input', { type: 'text', name: 'website',
	                                                                    value: this.state.website,
	                                                                    onChange: this.handleChange, className: 'form-control' }),
	                                                                this.validator.message('Website', this.state.website, '', { className: 'text-danger' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.state !== this.state.state && 'edited-field' },
	                                                                    'State ',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('input', { type: 'text', name: 'state',
	                                                                    value: this.state.state,
	                                                                    onChange: this.handleChange, className: 'form-control' }),
	                                                                this.validator.message('State', this.state.state, 'required', { className: 'text-danger' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.location !== this.state.location && 'edited-field' },
	                                                                    'Location ',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'select',
	                                                                    {
	                                                                        name: 'location',
	                                                                        id: 'location',
	                                                                        onChange: this.handleSelect,
	                                                                        value: this.state.location,
	                                                                        className: 'form-control selectpicker',
	                                                                        title: 'Select'
	                                                                    },
	                                                                    this.state.location_list.length > 0 && this.state.location_list.map(function (item, i) {
	                                                                        return _react2.default.createElement(
	                                                                            'option',
	                                                                            { value: item.location },
	                                                                            item.location
	                                                                        );
	                                                                    })
	                                                                ),
	                                                                this.validator.message('Location', this.state.location, 'required', { className: 'text-danger' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.pincode !== this.state.pincode && 'edited-field' },
	                                                                    'Pincode',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('input', { type: 'text', name: 'pincode',
	                                                                    value: this.state.pincode,
	                                                                    onChange: this.handleChange, className: 'form-control' }),
	                                                                this.validator.message('Pincode', this.state.pincode, 'required', { className: 'text-danger' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.address !== this.state.address && 'edited-field' },
	                                                                    'Address',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('input', { type: 'text', name: 'address',
	                                                                    value: this.state.address,
	                                                                    onChange: this.handleChange, className: 'form-control' }),
	                                                                this.validator.message('Address', this.state.address, 'required', { className: 'text-danger' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.google_location !== this.state.google_location && 'edited-field' },
	                                                                    'Google Location Address',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('input', { type: 'text', name: 'google_location',
	                                                                    value: this.state.google_location,
	                                                                    onChange: this.handleChange, className: 'form-control' }),
	                                                                this.validator.message('Google Location', this.state.google_location, 'required', { className: 'text-danger' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.latitude !== this.state.latitude && 'edited-field' },
	                                                                    'Latitude',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('input', {
	                                                                    type: 'text',
	                                                                    name: 'latitude',
	                                                                    value: this.state.latitude,
	                                                                    onChange: this.handleChange,
	
	                                                                    className: 'form-control'
	                                                                }),
	                                                                this.validator.message('Latitude', this.state.latitude, 'required', { className: 'text-danger' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.longitude !== this.state.longitude && 'edited-field' },
	                                                                    'Longitude',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('input', {
	                                                                    type: 'text',
	                                                                    name: 'longitude',
	                                                                    value: this.state.longitude,
	                                                                    onChange: this.handleChange,
	
	                                                                    className: 'form-control'
	                                                                }),
	                                                                this.validator.message('Longitude', this.state.longitude, 'required', { className: 'text-danger' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.other_rating !== this.state.other_rating && 'edited-field' },
	                                                                    'Google Rating',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('input', {
	                                                                    type: 'number',
	                                                                    step: '0.01',
	                                                                    name: 'other_rating',
	                                                                    value: this.state.other_rating,
	                                                                    onChange: this.handleChange,
	                                                                    max: '5',
	                                                                    className: 'form-control'
	                                                                }),
	                                                                this.validator.message('Google Rating', this.state.other_rating, 'required', { className: 'text-danger' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-12' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.about !== this.state.about && 'edited-field' },
	                                                                    'About',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('textarea', { type: 'text', name: 'about',
	                                                                    value: this.state.about,
	                                                                    onChange: this.handleChange, className: 'form-control' }),
	                                                                this.validator.message('About', this.state.about, 'required', { className: 'text-danger' })
	                                                            )
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'box-shadow-custom' },
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'row' },
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'col-md-12 col-xs-12' },
	                                                                _react2.default.createElement(
	                                                                    'span',
	                                                                    { className: 'form-legend' },
	                                                                    'Key Information'
	                                                                )
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.tution_type !== this.state.tution_type && 'edited-field' },
	                                                                    'Type',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    { className: 'custom-select-drop dropdown' },
	                                                                    _react2.default.createElement(
	                                                                        'select',
	                                                                        { multiple: true,
	                                                                            value: this.state.tution_type,
	                                                                            onChange: this.handleSelect, className: 'form-control selectpicker',
	                                                                            name: 'tution_type',
	                                                                            title: 'Select' },
	                                                                        this.state.tutionList.length > 0 && this.state.tutionList.map(function (item, i) {
	                                                                            return _react2.default.createElement(
	                                                                                'option',
	                                                                                { value: item.id },
	                                                                                item.name
	                                                                            );
	                                                                        })
	                                                                    ),
	                                                                    this.validator.message('Type', this.state.tution_type, 'required', { className: 'text-danger' })
	                                                                )
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.class_frequency !== this.state.class_frequency && 'edited-field' },
	                                                                    'Class Frequency',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    { className: 'custom-select-drop dropdown' },
	                                                                    _react2.default.createElement(
	                                                                        'select',
	                                                                        {
	                                                                            multiple: true,
	                                                                            value: this.state.class_frequency,
	                                                                            onChange: this.handleSelectClassFreq,
	                                                                            name: 'class_frequency',
	                                                                            placeholder: 'select',
	                                                                            className: 'form-control selectpicker',
	                                                                            title: 'Select' },
	                                                                        this.state.ClassList.length > 0 && this.state.ClassList.map(function (item, i) {
	                                                                            return _react2.default.createElement(
	                                                                                'option',
	                                                                                { value: item.id },
	                                                                                item.freq_name
	                                                                            );
	                                                                        })
	                                                                    ),
	                                                                    this.validator.message('Class Frequency', this.state.class_frequency, 'required', { className: 'text-danger' })
	                                                                )
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4 input-group-cus' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.min_age !== this.state.min_age && 'edited-field' },
	                                                                    'Age Group',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('input', { type: 'text', name: 'min_age',
	                                                                    onChange: this.handleChange,
	                                                                    value: this.state.min_age,
	                                                                    placeholder: '4 to 17 years',
	                                                                    className: 'form-control' }),
	                                                                this.validator.message('Age Group', this.state.min_age, 'required', { className: 'text-danger' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.number_of_trainee !== this.state.number_of_trainee && 'edited-field' },
	                                                                    'Number of Coaches',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('input', { type: 'text', name: 'number_of_trainee',
	                                                                    onChange: this.handleChange,
	
	                                                                    value: this.state.number_of_trainee,
	                                                                    className: 'form-control' }),
	                                                                this.validator.message('Number of Coaches', this.state.number_of_trainee, 'required', { className: 'text-danger' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-8 input-group-cus' },
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    null,
	                                                                    '\xA0'
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    null,
	                                                                    '\xA0'
	                                                                )
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4 input-group-cus' },
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    null,
	                                                                    _react2.default.createElement(
	                                                                        'label',
	                                                                        {
	                                                                            className: edited && (edited_data.from_time !== this.state.from_time || edited_data.from_time_cate !== this.state.from_time_cate) && 'edited-field' },
	                                                                        'Morning - From Timing'
	                                                                    ),
	                                                                    _react2.default.createElement(
	                                                                        'div',
	                                                                        { className: 'custom-select-drop dropdown' },
	                                                                        _react2.default.createElement(
	                                                                            'select',
	                                                                            {
	                                                                                className: 'form-control selectpicker',
	                                                                                onChange: this.handleSelect,
	                                                                                value: this.state.from_time_morning,
	                                                                                name: 'from_time_morning',
	                                                                                title: 'Select'
	                                                                            },
	                                                                            this.state.timingList.length > 0 && this.state.timingList.map(function (item, i) {
	                                                                                return _react2.default.createElement(
	                                                                                    'option',
	                                                                                    { value: item.id },
	                                                                                    item.timing
	                                                                                );
	                                                                            })
	                                                                        ),
	                                                                        this.validator.message('Timing', this.state.from_time, 'required', { className: 'text-danger' })
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    null,
	                                                                    _react2.default.createElement(
	                                                                        'label',
	                                                                        null,
	                                                                        '\xA0'
	                                                                    ),
	                                                                    _react2.default.createElement(
	                                                                        'div',
	                                                                        { className: 'custom-select-drop dropdown' },
	                                                                        _react2.default.createElement(
	                                                                            'select',
	                                                                            {
	                                                                                className: 'form-control selectpicker',
	                                                                                onChange: this.handleSelect,
	                                                                                value: this.state.from_time_morning_cate,
	                                                                                name: 'from_time_morning_cate'
	                                                                            },
	                                                                            _react2.default.createElement(
	                                                                                'option',
	                                                                                { value: 'AM' },
	                                                                                'AM'
	                                                                            ),
	                                                                            _react2.default.createElement(
	                                                                                'option',
	                                                                                { value: 'PM' },
	                                                                                'PM'
	                                                                            )
	                                                                        )
	                                                                    )
	                                                                )
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4 input-group-cus' },
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    null,
	                                                                    _react2.default.createElement(
	                                                                        'label',
	                                                                        {
	                                                                            className: edited && (edited_data.to_time !== this.state.to_time || edited_data.to_time_cate !== this.state.to_time_cate) && 'edited-field' },
	                                                                        'Evening - From Timing'
	                                                                    ),
	                                                                    _react2.default.createElement(
	                                                                        'div',
	                                                                        { className: 'custom-select-drop dropdown' },
	                                                                        _react2.default.createElement(
	                                                                            'select',
	                                                                            {
	                                                                                className: 'form-control selectpicker',
	                                                                                onChange: this.handleSelect,
	                                                                                value: this.state.from_time_evening,
	                                                                                name: 'from_time_evening',
	                                                                                title: 'Select'
	                                                                            },
	                                                                            this.state.timingList.length > 0 && this.state.timingList.map(function (item, i) {
	                                                                                return _react2.default.createElement(
	                                                                                    'option',
	                                                                                    { value: item.id },
	                                                                                    item.timing
	                                                                                );
	                                                                            })
	                                                                        ),
	                                                                        this.validator.message('Timing', this.state.to_time, 'required', { className: 'text-danger' })
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    null,
	                                                                    _react2.default.createElement(
	                                                                        'label',
	                                                                        null,
	                                                                        '\xA0'
	                                                                    ),
	                                                                    _react2.default.createElement(
	                                                                        'div',
	                                                                        { className: 'custom-select-drop dropdown' },
	                                                                        _react2.default.createElement(
	                                                                            'select',
	                                                                            {
	                                                                                className: 'form-control selectpicker',
	                                                                                onChange: this.handleSelect,
	                                                                                value: this.state.from_time_evening_cate,
	                                                                                name: 'from_time_evening_cate'
	                                                                            },
	                                                                            _react2.default.createElement(
	                                                                                'option',
	                                                                                { value: 'AM' },
	                                                                                'AM'
	                                                                            ),
	                                                                            _react2.default.createElement(
	                                                                                'option',
	                                                                                { value: 'PM' },
	                                                                                'PM'
	                                                                            )
	                                                                        )
	                                                                    )
	                                                                )
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4 input-group-cus' },
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    null,
	                                                                    _react2.default.createElement(
	                                                                        'label',
	                                                                        {
	                                                                            className: edited && (edited_data.from_time !== this.state.from_time || edited_data.from_time_cate !== this.state.from_time_cate) && 'edited-field' },
	                                                                        'Day - From Timing'
	                                                                    ),
	                                                                    _react2.default.createElement(
	                                                                        'div',
	                                                                        { className: 'custom-select-drop dropdown' },
	                                                                        _react2.default.createElement(
	                                                                            'select',
	                                                                            {
	                                                                                className: 'form-control selectpicker',
	                                                                                onChange: this.handleSelect,
	                                                                                value: this.state.from_time,
	                                                                                name: 'from_time',
	                                                                                title: 'Select'
	                                                                            },
	                                                                            this.state.timingList.length > 0 && this.state.timingList.map(function (item, i) {
	                                                                                return _react2.default.createElement(
	                                                                                    'option',
	                                                                                    { value: item.id },
	                                                                                    item.timing
	                                                                                );
	                                                                            })
	                                                                        ),
	                                                                        this.validator.message('Timing', this.state.from_time, 'required', { className: 'text-danger' })
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    null,
	                                                                    _react2.default.createElement(
	                                                                        'label',
	                                                                        null,
	                                                                        '\xA0'
	                                                                    ),
	                                                                    _react2.default.createElement(
	                                                                        'div',
	                                                                        { className: 'custom-select-drop dropdown' },
	                                                                        _react2.default.createElement(
	                                                                            'select',
	                                                                            {
	                                                                                className: 'form-control selectpicker',
	                                                                                onChange: this.handleSelect,
	                                                                                value: this.state.from_time_cate,
	                                                                                name: 'from_time_cate'
	                                                                            },
	                                                                            _react2.default.createElement(
	                                                                                'option',
	                                                                                { value: 'AM' },
	                                                                                'AM'
	                                                                            ),
	                                                                            _react2.default.createElement(
	                                                                                'option',
	                                                                                { value: 'PM' },
	                                                                                'PM'
	                                                                            )
	                                                                        )
	                                                                    )
	                                                                )
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4 input-group-cus' },
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    null,
	                                                                    _react2.default.createElement(
	                                                                        'label',
	                                                                        {
	                                                                            className: edited && (edited_data.to_time !== this.state.to_time || edited_data.to_time_cate !== this.state.to_time_cate) && 'edited-field' },
	                                                                        'Morning - To Timing'
	                                                                    ),
	                                                                    _react2.default.createElement(
	                                                                        'div',
	                                                                        { className: 'custom-select-drop dropdown' },
	                                                                        _react2.default.createElement(
	                                                                            'select',
	                                                                            {
	                                                                                className: 'form-control selectpicker',
	                                                                                onChange: this.handleSelect,
	                                                                                value: this.state.to_time_morning,
	                                                                                name: 'to_time_morning',
	                                                                                title: 'Select'
	                                                                            },
	                                                                            this.state.timingList.length > 0 && this.state.timingList.map(function (item, i) {
	                                                                                return _react2.default.createElement(
	                                                                                    'option',
	                                                                                    { value: item.id },
	                                                                                    item.timing
	                                                                                );
	                                                                            })
	                                                                        ),
	                                                                        this.validator.message('Timing', this.state.to_time, 'required', { className: 'text-danger' })
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    null,
	                                                                    _react2.default.createElement(
	                                                                        'label',
	                                                                        null,
	                                                                        '\xA0'
	                                                                    ),
	                                                                    _react2.default.createElement(
	                                                                        'div',
	                                                                        { className: 'custom-select-drop dropdown' },
	                                                                        _react2.default.createElement(
	                                                                            'select',
	                                                                            {
	                                                                                className: 'form-control selectpicker',
	                                                                                onChange: this.handleSelect,
	                                                                                value: this.state.to_time_morning_cate,
	                                                                                name: 'to_time_morning_cate'
	                                                                            },
	                                                                            _react2.default.createElement(
	                                                                                'option',
	                                                                                { value: 'AM' },
	                                                                                'AM'
	                                                                            ),
	                                                                            _react2.default.createElement(
	                                                                                'option',
	                                                                                { value: 'PM' },
	                                                                                'PM'
	                                                                            )
	                                                                        )
	                                                                    )
	                                                                )
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4 input-group-cus' },
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    null,
	                                                                    _react2.default.createElement(
	                                                                        'label',
	                                                                        {
	                                                                            className: edited && (edited_data.from_time !== this.state.from_time || edited_data.from_time_cate !== this.state.from_time_cate) && 'edited-field' },
	                                                                        'Evening - To Timing'
	                                                                    ),
	                                                                    _react2.default.createElement(
	                                                                        'div',
	                                                                        { className: 'custom-select-drop dropdown' },
	                                                                        _react2.default.createElement(
	                                                                            'select',
	                                                                            {
	                                                                                className: 'form-control selectpicker',
	                                                                                onChange: this.handleSelect,
	                                                                                value: this.state.to_time_evening,
	                                                                                name: 'to_time_evening',
	                                                                                title: 'Select'
	                                                                            },
	                                                                            this.state.timingList.length > 0 && this.state.timingList.map(function (item, i) {
	                                                                                return _react2.default.createElement(
	                                                                                    'option',
	                                                                                    { value: item.id },
	                                                                                    item.timing
	                                                                                );
	                                                                            })
	                                                                        ),
	                                                                        this.validator.message('Timing', this.state.from_time, 'required', { className: 'text-danger' })
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    null,
	                                                                    _react2.default.createElement(
	                                                                        'label',
	                                                                        null,
	                                                                        '\xA0'
	                                                                    ),
	                                                                    _react2.default.createElement(
	                                                                        'div',
	                                                                        { className: 'custom-select-drop dropdown' },
	                                                                        _react2.default.createElement(
	                                                                            'select',
	                                                                            {
	                                                                                className: 'form-control selectpicker',
	                                                                                onChange: this.handleSelect,
	                                                                                value: this.state.to_time_evening_cate,
	                                                                                name: 'to_time_evening_cate'
	                                                                            },
	                                                                            _react2.default.createElement(
	                                                                                'option',
	                                                                                { value: 'AM' },
	                                                                                'AM'
	                                                                            ),
	                                                                            _react2.default.createElement(
	                                                                                'option',
	                                                                                { value: 'PM' },
	                                                                                'PM'
	                                                                            )
	                                                                        )
	                                                                    )
	                                                                )
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4 input-group-cus' },
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    null,
	                                                                    _react2.default.createElement(
	                                                                        'label',
	                                                                        {
	                                                                            className: edited && (edited_data.to_time !== this.state.to_time || edited_data.to_time_cate !== this.state.to_time_cate) && 'edited-field' },
	                                                                        'Day - To Timing'
	                                                                    ),
	                                                                    _react2.default.createElement(
	                                                                        'div',
	                                                                        { className: 'custom-select-drop dropdown' },
	                                                                        _react2.default.createElement(
	                                                                            'select',
	                                                                            {
	                                                                                className: 'form-control selectpicker',
	                                                                                onChange: this.handleSelect,
	                                                                                value: this.state.to_time,
	                                                                                name: 'to_time',
	                                                                                title: 'Select'
	                                                                            },
	                                                                            this.state.timingList.length > 0 && this.state.timingList.map(function (item, i) {
	                                                                                return _react2.default.createElement(
	                                                                                    'option',
	                                                                                    { value: item.id },
	                                                                                    item.timing
	                                                                                );
	                                                                            })
	                                                                        ),
	                                                                        this.validator.message('Timing', this.state.to_time, 'required', { className: 'text-danger' })
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    null,
	                                                                    _react2.default.createElement(
	                                                                        'label',
	                                                                        null,
	                                                                        '\xA0'
	                                                                    ),
	                                                                    _react2.default.createElement(
	                                                                        'div',
	                                                                        { className: 'custom-select-drop dropdown' },
	                                                                        _react2.default.createElement(
	                                                                            'select',
	                                                                            {
	                                                                                className: 'form-control selectpicker',
	                                                                                onChange: this.handleSelect,
	                                                                                value: this.state.to_time_cate,
	                                                                                name: 'to_time_cate'
	                                                                            },
	                                                                            _react2.default.createElement(
	                                                                                'option',
	                                                                                { value: 'AM' },
	                                                                                'AM'
	                                                                            ),
	                                                                            _react2.default.createElement(
	                                                                                'option',
	                                                                                { value: 'PM' },
	                                                                                'PM'
	                                                                            )
	                                                                        )
	                                                                    )
	                                                                )
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.est_year !== this.state.establishment_Year && 'edited-field' },
	                                                                    'Establishment Year ',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('input', { type: 'text', name: 'establishment_Year',
	                                                                    value: this.state.establishment_Year,
	                                                                    onChange: this.handleChange, className: 'form-control' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.avg_fee !== this.state.avg_anual_fee && 'edited-field' },
	                                                                    'Average Fees(INR) ',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('input', { type: 'text', name: 'avg_anual_fee',
	                                                                    value: this.state.avg_anual_fee,
	                                                                    onChange: this.handleChange, className: 'form-control' }),
	                                                                this.validator.message('Average Fees', this.state.avg_anual_fee, 'required', { className: 'text-danger' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.admit_fee !== this.state.addmission_fee && 'edited-field' },
	                                                                    'Admission Fees ',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('input', { type: 'text', name: 'addmission_fee',
	                                                                    value: this.state.addmission_fee,
	                                                                    onChange: this.handleChange, className: 'form-control' }),
	                                                                this.validator.message('Admission Fees', this.state.addmission_fee, 'required', { className: 'text-danger' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.std_ratio !== this.state.std_ratio && 'edited-field' },
	                                                                    'Student Ratio',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    { className: 'custom-select-drop dropdown' },
	                                                                    _react2.default.createElement(
	                                                                        'select',
	                                                                        {
	                                                                            value: this.state.std_ratio,
	                                                                            name: 'std_ratio',
	                                                                            id: 'std_ratio',
	                                                                            onChange: this.handleSelect,
	                                                                            className: 'form-control selectpicker',
	                                                                            multiple: true,
	                                                                            title: 'Select'
	                                                                        },
	                                                                        _react2.default.createElement(
	                                                                            'option',
	                                                                            { value: '1' },
	                                                                            'One to One'
	                                                                        ),
	                                                                        _react2.default.createElement(
	                                                                            'option',
	                                                                            { value: '2' },
	                                                                            'One to Many'
	                                                                        ),
	                                                                        _react2.default.createElement(
	                                                                            'option',
	                                                                            { value: '3' },
	                                                                            'NA'
	                                                                        )
	                                                                    ),
	                                                                    this.validator.message('Admission Fees', this.state.addmission_fee, 'required', { className: 'text-danger' })
	                                                                )
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { 'class': 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.has_trail !== this.state.has_trail && 'edited-field' },
	                                                                    'Is Free Trial Available? ',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { 'class': 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'select',
	                                                                    {
	                                                                        className: 'form-control selectpicker',
	                                                                        name: 'has_trail',
	                                                                        value: this.state.has_trail,
	                                                                        title: 'Select',
	                                                                        onChange: this.handleSelect },
	                                                                    _react2.default.createElement(
	                                                                        'option',
	                                                                        { value: '0' },
	                                                                        'NA'
	                                                                    ),
	                                                                    _react2.default.createElement(
	                                                                        'option',
	                                                                        { value: '1' },
	                                                                        'Yes'
	                                                                    ),
	                                                                    _react2.default.createElement(
	                                                                        'option',
	                                                                        { value: '2' },
	                                                                        'No'
	                                                                    )
	                                                                ),
	                                                                this.validator.message('Free Trial', this.state.has_trail, 'required', { className: 'text-danger error-msg' })
	                                                            ),
	                                                            this.state.has_trail === 1 && _react2.default.createElement(
	                                                                'div',
	                                                                { 'class': 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.trail_desc !== this.state.trail_desc && 'edited-field' },
	                                                                    'Free Trial Description ',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { 'class': 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('textarea', { className: 'form-control', name: 'trail_desc', onChange: this.handleChange, value: this.state.trail_desc }),
	                                                                this.validator.message('Free Trial Descrption', this.state.trail_desc, 'required', { className: 'text-danger error-msg' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.keywords !== this.state.keywords && 'edited-field' },
	                                                                    'Keywords',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement(_multiselectReactDropdown.Multiselect, {
	                                                                    isObject: false,
	                                                                    options: this.state.keywordsArr // Options to display in the dropdown
	                                                                    , selectedValues: this.state.keywords // Preselected value to persist in dropdown
	                                                                    , onSelect: this.onSelect // Function will trigger on select event
	                                                                    , onRemove: this.onRemove // Function will trigger on remove event
	                                                                })
	                                                            )
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'box-shadow-custom' },
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'row' },
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'col-md-12 col-xs-12' },
	                                                                _react2.default.createElement(
	                                                                    'span',
	                                                                    { className: 'form-legend' },
	                                                                    'Images'
	                                                                )
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.images !== this.state.images && 'edited-field' },
	                                                                    'Banner Image ',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('input', {
	                                                                    type: 'file',
	                                                                    name: 'images',
	                                                                    onChange: this.handleFile,
	                                                                    className: 'form-control'
	                                                                })
	                                                            ),
	                                                            (this.state.edit_image !== '' || this.state.tempBanner !== '') && _react2.default.createElement(
	                                                                'div',
	                                                                { 'class': 'col-md-2 col-sm-12 mar-btm', id: 'edit_image' },
	                                                                _react2.default.createElement('img', { src: this.state.tempBanner ? this.state.tempBanner : this.state.edit_image, alt: 'Img', 'class': 'img-thumbnail' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { 'class': 'col-md-12 float-left mt-4 p-0' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.photos !== this.state.photos && 'edited-field' },
	                                                                    'Gallery Images ',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                )
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { 'class': 'col-md-12 float-left mt-4 p-0' },
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    { 'class': 'col-md-12 margin-bottom-mobile-account float-left image-upload' },
	                                                                    _react2.default.createElement(
	                                                                        'div',
	                                                                        { className: 'upload-wizard' },
	                                                                        _react2.default.createElement(
	                                                                            'div',
	                                                                            { className: 'upload-thumb' },
	                                                                            _react2.default.createElement(
	                                                                                'ul',
	                                                                                { className: 'list-inline' },
	                                                                                this.state.attachment_file.map(function (file_data, index) {
	
	                                                                                    var file_url;
	                                                                                    if (file_data.name) {
	                                                                                        var url = file_data.image_thumb ? file_data.image_thumb : '';
	                                                                                        if (url !== '') {
	                                                                                            file_url = file_data.image_thumb;
	                                                                                        } else {
	                                                                                            file_url = URL.createObjectURL(file_data);
	                                                                                        }
	                                                                                        // var file_url = URL.createObjectURL(file_data)
	                                                                                        // var file_name = file_data.name
	                                                                                        if (file_data.type === 'application/pdf') {
	                                                                                            var blob = file_url;
	                                                                                            //console.log('blob_url', file_data.name)
	                                                                                            return _react2.default.createElement(
	                                                                                                'li',
	                                                                                                { className: 'previewImg' },
	                                                                                                _react2.default.createElement(
	                                                                                                    'div',
	                                                                                                    { className: 'thumb-img' },
	                                                                                                    _react2.default.createElement('img', {
	                                                                                                        src: file_url,
	                                                                                                        alt: 'image',
	                                                                                                        title: file_data.name
	                                                                                                    })
	                                                                                                ),
	                                                                                                _react2.default.createElement(
	                                                                                                    'a',
	                                                                                                    { href: 'javascript:;', className: 'del-btn', onClick: function onClick() {
	                                                                                                            _this4.removeImage(file_data.name);
	                                                                                                        } },
	                                                                                                    _react2.default.createElement('img', {
	                                                                                                        src: '../../../assets/images/close-icon-white.svg',
	                                                                                                        alt: 'delete'
	                                                                                                    })
	                                                                                                )
	                                                                                            );
	                                                                                        } else {
	                                                                                            return _react2.default.createElement(
	                                                                                                'li',
	                                                                                                { className: 'previewImg' },
	                                                                                                _react2.default.createElement(
	                                                                                                    'div',
	                                                                                                    { className: 'thumb-img' },
	                                                                                                    _react2.default.createElement('img', {
	                                                                                                        src: file_url,
	                                                                                                        alt: 'image',
	                                                                                                        title: file_data.name
	                                                                                                    })
	                                                                                                ),
	                                                                                                _react2.default.createElement(
	                                                                                                    'a',
	                                                                                                    {
	                                                                                                        href: 'javascript:;',
	                                                                                                        className: 'del-btn',
	                                                                                                        onClick: function onClick() {
	                                                                                                            _this4.removeImage(file_data.name);
	                                                                                                        }
	                                                                                                    },
	                                                                                                    _react2.default.createElement('img', {
	                                                                                                        src: '../../../assets/images/close-icon-white.svg',
	                                                                                                        alt: 'delete'
	                                                                                                    })
	                                                                                                )
	                                                                                            );
	                                                                                        }
	                                                                                    }
	                                                                                }),
	                                                                                _react2.default.createElement(
	                                                                                    'li',
	                                                                                    { className: 'addMore' },
	                                                                                    _react2.default.createElement('input', {
	                                                                                        type: 'file',
	                                                                                        name: 'imgInp[]',
	                                                                                        id: 'imgInp2',
	                                                                                        className: 'add_img',
	                                                                                        multiple: true,
	                                                                                        onChange: this.loadFile.bind(this),
	                                                                                        accept: 'image/x-png,image/gif,image/jpeg'
	                                                                                    }),
	                                                                                    _react2.default.createElement(
	                                                                                        'a',
	                                                                                        { href: 'javascript:;', className: 'add-more' },
	                                                                                        _react2.default.createElement(
	                                                                                            'div',
	                                                                                            null,
	                                                                                            _react2.default.createElement('img', { src: '../../../assets/images/upload-icon.svg', alt: 'icon' }),
	                                                                                            'Add more'
	                                                                                        )
	                                                                                    )
	                                                                                )
	                                                                            )
	                                                                        )
	                                                                    ),
	                                                                    this.validator.message('gallery images', this.state.attachment_file, '', { className: 'text-danger error-msg' })
	                                                                )
	                                                            )
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'col-md-12 col-xs-12 btn-bdr' },
	                                                        _react2.default.createElement(
	                                                            'button',
	                                                            { id: 'btnSubmit', className: 'btn btn-blue' },
	                                                            'Preview'
	                                                        )
	                                                    )
	                                                )
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    this.preview()
	                )
	            );
	        }
	    }]);
	
	    return verticalAFAEdit;
	}(_react.Component);
	
	exports.default = verticalAFAEdit;

/***/ },
/* 1022 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _FetchCall2 = _interopRequireDefault(_FetchCall);
	
	var _reactJsPagination = __webpack_require__(33);
	
	var _reactJsPagination2 = _interopRequireDefault(_reactJsPagination);
	
	var _bewiseloading = __webpack_require__(48);
	
	var _bewiseloading2 = _interopRequireDefault(_bewiseloading);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import Pagination from 'rc-pagination';
	
	var verticalCamps = function (_Component) {
	  _inherits(verticalCamps, _Component);
	
	  function verticalCamps(props) {
	    _classCallCheck(this, verticalCamps);
	
	    var _this = _possibleConstructorReturn(this, (verticalCamps.__proto__ || Object.getPrototypeOf(verticalCamps)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var url = new URL(window.location.href);
	    var location = url.searchParams.get("location");
	    var auth_data = JSON.parse(localStorage.getItem("user_data"));
	
	    _this.state = {
	      logged: localStorage.getItem("authentication"),
	      auth_data: JSON.parse(localStorage.getItem("user_data")),
	      location: localStorage.getItem("location") ? localStorage.getItem("location") : 'Bengaluru',
	      campList: [],
	      PER_PAGE: 15,
	      total: 0,
	      loading: true,
	      searchby: '',
	      activePage: 0,
	      offset: 0,
	      exportbtndisabled: false,
	      thisExportBtnText: 'Export'
	    };
	
	    _this.handleSelect = _this.handleSelect.bind(_this);
	    //this.getList();
	    return _this;
	  }
	
	  _createClass(verticalCamps, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	
	      var THIS = this;
	      (0, _jquery2.default)(document).on('click', '.remove_school', function () {
	        var delete_id = (0, _jquery2.default)(this).data("id");
	
	        var ins = JSON.stringify({
	          id: delete_id,
	          table: 'camp'
	        });
	
	        (0, _FetchCall.removethisItem)(ins).then(function (res) {
	
	          alert(res.message);
	          THIS.getTotal('bw_sesonal_camp');
	          THIS.getList();
	        });
	      });
	
	      this.getTotal('bw_sesonal_camp');
	      this.getList();
	    }
	  }, {
	    key: 'handlePageChange',
	    value: function handlePageChange(pageNumber) {
	
	      console.log('active page is ' + pageNumber);
	
	      this.setState({ activePage: pageNumber });
	
	      //this.getTotal('bw_schools');
	      this.getList(pageNumber);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          campList = _state.campList,
	          currentPage = _state.currentPage,
	          PER_PAGE = _state.PER_PAGE,
	          totalCount = _state.totalCount,
	          total = _state.total,
	          exportbtndisabled = _state.exportbtndisabled;
	
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'col-lg-12 grid-margin stretch-card' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card-body' },
	                _react2.default.createElement(
	                  'h4',
	                  { 'class': 'card-title' },
	                  'Learning Camps'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'float-right' },
	                  _react2.default.createElement(
	                    'a',
	                    { href: '/vertical/learningcamps/add', 'class': 'btn btn-primary btn-sm' },
	                    'Add'
	                  ),
	                  ' \xA0',
	                  _react2.default.createElement(
	                    'button',
	                    { disabled: exportbtndisabled, 'class': 'btn btn-primary btn-sm', onClick: function onClick() {
	                        return _this2.schoolExport();
	                      } },
	                    this.state.thisExportBtnText
	                  ),
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'p',
	                  { 'class': 'card-description' },
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'cityselection' },
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'leftaligned bwlabel' },
	                      'City'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'leftaligned' },
	                      _react2.default.createElement(
	                        'select',
	                        { name: 'location', 'class': 'form-control', onChange: function onChange(e) {
	                            return _this2.handleSelect(e);
	                          },
	                          value: this.state.location },
	                        _react2.default.createElement(
	                          'option',
	                          { value: '' },
	                          'select city'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'Bengaluru' },
	                          'Bengaluru'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'Chennai' },
	                          'Chennai'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'Hyderabad' },
	                          'Hyderabad'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'Coimbatore' },
	                          'Coimbatore'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'Hosur' },
	                          'Hosur'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'Indore' },
	                          'Indore'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'Others' },
	                          'Others'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'leftaligned bwlabel' },
	                      'Search'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'leftaligned' },
	                      _react2.default.createElement('input', { type: 'text', name: 'searchby', 'class': 'form-control form-control-sm', onChange: this.handleChange })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'leftaligned' },
	                      _react2.default.createElement(
	                        'button',
	                        { 'class': 'btn btn-primary btn-sm', onClick: this.searchBy },
	                        'Go'
	                      )
	                    )
	                  )
	                ),
	                this.state.loading && _react2.default.createElement(
	                  'div',
	                  { id: 'loader' },
	                  _react2.default.createElement('img', { src: _bewiseloading2.default, width: '60px' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'pt-3' },
	                  !this.state.loading && _react2.default.createElement(
	                    'table',
	                    { id: 'tablebw' },
	                    _react2.default.createElement(
	                      'thead',
	                      { 'class': 'thead-dark' },
	                      _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'S.No'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Updated On'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'By'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Name'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'City'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Email Id'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Status'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Action'
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'tbody',
	                      null,
	                      campList.map(function (item, i) {
	
	                        return _react2.default.createElement(
	                          'tr',
	                          null,
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.s_no
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.updated_date
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.updatedby
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.organisation_name
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.location
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.email_id
	                          ),
	                          _react2.default.createElement('td', { dangerouslySetInnerHTML: { __html: item.status } }),
	                          _react2.default.createElement('td', { 'class': 'actionbtns', dangerouslySetInnerHTML: { __html: item.action } })
	                        );
	                      })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'text-center' },
	                    _react2.default.createElement(_reactJsPagination2.default, {
	                      activePage: this.state.activePage,
	                      itemsCountPerPage: PER_PAGE,
	                      totalItemsCount: this.state.total,
	                      pageRangeDisplayed: 5,
	                      activeClass: "pagination__link--active",
	                      onChange: this.handlePageChange.bind(this),
	                      prevPageText: 'previous',
	                      nextPageText: 'next'
	                    })
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return verticalCamps;
	}(_react.Component);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this3 = this;
	
	  this.getTotal = function (vertical) {
	    var location = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	
	    var locationselected = location == '' ? _this3.state.location : location;
	
	    var ins = JSON.stringify({
	      vertical: vertical,
	      location: locationselected,
	      searchby: _this3.state.searchby
	    });
	
	    (0, _FetchCall.getTotal)(ins).then(function (res) {
	
	      _this3.setState({ loading: true });
	
	      if (res.status == 1) {
	
	        _this3.setState({
	
	          total: res.total
	
	        });
	      }
	    });
	  };
	
	  this.getList = function () {
	    var pageNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	    var location = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	    var _state$auth_data = _this3.state.auth_data,
	        login_id = _state$auth_data.login_id,
	        role = _state$auth_data.role;
	
	
	    _this3.setState({ activePage: pageNumber });
	
	    var newOffset = pageNumber == 1 ? 0 : (pageNumber - 1) * _this3.state.PER_PAGE % _this3.state.total;
	
	    var locationselected = location == '' ? _this3.state.location : location;
	
	    var ins = JSON.stringify({
	      vendor_id: login_id,
	      role: role,
	      location: locationselected,
	      searchby: _this3.state.searchby,
	      perpage: _this3.state.PER_PAGE,
	      offset: newOffset
	    });
	
	    (0, _FetchCall.getCampsPaged)(ins).then(function (res) {
	
	      _this3.setState({ loading: true });
	
	      if (res.status == 1) {
	
	        _this3.setState({ loading: !_this3.state.loading });
	
	        _this3.setState({
	
	          campList: res.data
	
	        });
	      } else {
	
	        _this3.setState({ loading: !_this3.state.loading });
	
	        _this3.setState({
	          campList: []
	        });
	      }
	    });
	  };
	
	  this.handleChange = function (e) {
	    _this3.setState(_defineProperty({}, e.target.name, e.target.value));
	  };
	
	  this.searchBy = function (e) {
	
	    _this3.setState({ loading: true, activePage: 1 });
	
	    _this3.getTotal('bw_schools');
	    _this3.getList(1);
	  };
	
	  this.handleSelect = function (e) {
	
	    _this3.setState({ location: e.target.value, activePage: 1 });
	    localStorage.setItem("location", e.target.value);
	    _this3.getTotal('bw_schools', e.target.value);
	    _this3.getList(1, e.target.value);
	  };
	
	  this.schoolExport = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	    var req, res;
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	
	            _this3.setState({ exportbtndisabled: true, thisExportBtnText: "exporting..." });
	
	            _context.prev = 1;
	            req = JSON.stringify({
	              location: _this3.state.location
	            });
	            _context.next = 5;
	            return (0, _FetchCall.exportSchool)(req);
	
	          case 5:
	            res = _context.sent;
	
	            if (res.status == 1) {
	
	              _this3.setState({ exportbtndisabled: false, thisExportBtnText: "Export" });
	              console.log('location_list', res);
	              console.log('location_list', res.path);
	              window.open(res.path);
	
	              // this.setState({
	              //   subscribe_list: res.results,
	              // });
	            }
	
	            _context.next = 12;
	            break;
	
	          case 9:
	            _context.prev = 9;
	            _context.t0 = _context['catch'](1);
	
	            _this3.setState({ error: true });
	
	          case 12:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, _this3, [[1, 9]]);
	  }));
	};
	
	exports.default = verticalCamps;

/***/ },
/* 1023 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _FetchCall2 = _interopRequireDefault(_FetchCall);
	
	var _reactstrap = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import { Editor } from '@tinymce/tinymce-react';
	
	
	var verticalCampsDetail = function (_Component) {
	    _inherits(verticalCampsDetail, _Component);
	
	    function verticalCampsDetail(props) {
	        _classCallCheck(this, verticalCampsDetail);
	
	        var _this = _possibleConstructorReturn(this, (verticalCampsDetail.__proto__ || Object.getPrototypeOf(verticalCampsDetail)).call(this, props));
	
	        _this.state = {
	            infoDetails: []
	        };
	        _this.id = _this.props.match.params.id;
	        _this.type = _this.props.match.params.type;
	        _this.infoDetails = _this.infoDetails.bind(_this);
	
	        return _this;
	    }
	
	    _createClass(verticalCampsDetail, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            console.log(this.props);
	            this.infoDetails();
	        }
	    }, {
	        key: 'getPageTitle',
	        value: function getPageTitle(title) {
	            var activityTitle = '';
	            switch (title) {
	                case "tution":
	                    activityTitle = 'Tution Info';
	                    break;
	
	                case "music":
	                    activityTitle = 'Music Info';
	                    break;
	
	                case "sports":
	                    activityTitle = 'Sports Info';
	                    break;
	
	                case "dance":
	                    activityTitle = 'Dance Info';
	                    break;
	
	                case "drawing":
	                    activityTitle = 'Drawing Info';
	                    break;
	                case "yoga":
	                    activityTitle = 'Yoga Info';
	                    break;
	
	                default:
	                    activityTitle = title;
	            }
	            return activityTitle;
	        }
	    }, {
	        key: 'UNSAFE_componentWillMount',
	        value: function UNSAFE_componentWillMount() {}
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {}
	    }, {
	        key: 'infoDetails',
	        value: function () {
	            var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	                var response, data;
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                _context.next = 2;
	                                return _FetchCall2.default.getCampInfo(this.id);
	
	                            case 2:
	                                response = _context.sent;
	
	                                if (!response) {
	                                    _context.next = 8;
	                                    break;
	                                }
	
	                                data = response.data;
	
	                                this.setState({
	                                    infoDetails: data,
	                                    url: data.url,
	                                    photos_arr: data.photo_arr
	                                });
	
	                                _context.next = 9;
	                                break;
	
	                            case 8:
	                                return _context.abrupt('return', _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    'Error'
	                                ));
	
	                            case 9:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function infoDetails() {
	                return _ref.apply(this, arguments);
	            }
	
	            return infoDetails;
	        }()
	    }, {
	        key: 'gallery_image',
	        value: function gallery_image() {
	            var _this2 = this;
	
	            var photos = this.state.photos_arr !== undefined ? this.state.photos_arr : [];
	            var rows = "";
	            if (photos.length > 0) {
	                rows = photos.map(function (photos, index) {
	                    if (photos.name) return _react2.default.createElement(
	                        'div',
	                        { 'class': 'col-md-4 float-left mt-4 p-0' },
	                        _react2.default.createElement('img', { src: _this2.state.url + photos.name, alt: 'Img', 'class': 'img-thumbnail' })
	                    );
	                });
	            } else {
	                rows = "";
	            }
	            return rows;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var infoDetails = this.state.infoDetails;
	
	            console.log('infoDetails', this.state);
	            console.log('activityTitle', this.state.activityTitle);
	
	            var type = '';
	            switch (infoDetails.invities) {
	                case "0_to_3":
	                    type = '0 to 3 Yrs';break;
	                case "4_to_8":
	                    type = '4 to 8 Yrs';break;
	                case "9_to_12":
	                    type = '9 to 12 Yrs';break;
	                case "13_to_15":
	                    type = '13 to 15 Yrs';break;
	                default:
	                    type = infoDetails.invities;
	            }
	            var stdRa = '';
	            if (infoDetails.student_ratio == 1) {
	                stdRa = 'One to One';
	            } else if (infoDetails.student_ratio == 2) {
	                stdRa = 'One to Many';
	            }
	
	            return _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _react2.default.createElement(
	                    _layout2.default,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { 'class': 'col-lg-12 grid-margin stretch-card' },
	                        _react2.default.createElement(
	                            'div',
	                            { 'class': 'card' },
	                            _react2.default.createElement(
	                                'div',
	                                { 'class': 'card-body' },
	                                _react2.default.createElement(
	                                    'h4',
	                                    { 'class': 'card-title' },
	                                    infoDetails.camp_name,
	                                    ' - View'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'pt-3 detailsection' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { id: 'company-info', className: 'tab-pane active' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'box-shadow-custom' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'row' },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group col-md-4' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        'Registration No.'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'p',
	                                                        null,
	                                                        infoDetails.registration_no
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group col-md-4' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        'Camp Name '
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'p',
	                                                        null,
	                                                        infoDetails.camp_name
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group col-md-4' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        'Invitees'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'p',
	                                                        null,
	                                                        infoDetails.invities
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group col-md-4' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        'sub type'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'p',
	                                                        null,
	                                                        infoDetails.subtype
	                                                    )
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'box-shadow-custom' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'row' },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'col-md-12 col-xs-12' },
	                                                    _react2.default.createElement(
	                                                        'span',
	                                                        { className: 'form-legend' },
	                                                        'Key Information'
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group col-md-4' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        'Contact Person'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'p',
	                                                        null,
	                                                        infoDetails.contact_person
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group col-md-4' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        'Contact No.'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'p',
	                                                        null,
	                                                        infoDetails.phone_number
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group col-md-4' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        'Email Id'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'p',
	                                                        null,
	                                                        infoDetails.email_id
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group col-md-4' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        'Type'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'p',
	                                                        null,
	                                                        infoDetails.tution_type
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group col-md-4' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        'Student Ratio'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'p',
	                                                        null,
	                                                        infoDetails.student_ratio
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group col-md-4' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        'Website'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'p',
	                                                        null,
	                                                        infoDetails.website
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group col-md-4' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        'Facebook'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'p',
	                                                        null,
	                                                        infoDetails.facebook
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group col-md-4' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        'Twitter'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'p',
	                                                        null,
	                                                        infoDetails.twitter
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group col-md-4' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        'Fee - based on activity '
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'p',
	                                                        null,
	                                                        infoDetails.event_fee
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group col-md-4' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        'When '
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'p',
	                                                        null,
	                                                        infoDetails.when
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group col-md-4' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        'Registration Info'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'p',
	                                                        null,
	                                                        infoDetails.registeration
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group col-md-4' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        'Website Search Keywords'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'p',
	                                                        null,
	                                                        infoDetails.keywords
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group col-md-4' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        'Where '
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'p',
	                                                        null,
	                                                        infoDetails.where
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group col-md-4' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        'Google Location '
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'p',
	                                                        null,
	                                                        infoDetails.google_location
	                                                    )
	                                                ),
	                                                infoDetails.vendor_id == 1 && _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group col-md-4' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        'Partner Type'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'p',
	                                                        null,
	                                                        infoDetails.partner_type == 1 ? 'Institution' : 'Individual'
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group col-md-12' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        'About'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'p',
	                                                        null,
	                                                        infoDetails.about_camp
	                                                    )
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'box-shadow-custom' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'row' },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'col-md-12 col-xs-12' },
	                                                    _react2.default.createElement(
	                                                        'span',
	                                                        { className: 'form-legend' },
	                                                        'Images'
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group col-md-4' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        'Banner '
	                                                    ),
	                                                    infoDetails.images && _react2.default.createElement('img', { src: infoDetails.url + infoDetails.images, alt: 'Img', 'class': 'img-thumbnail' })
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { 'class': 'col-md-12 float-left mt-4 p-0' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        'Gallery Images'
	                                                    )
	                                                ),
	                                                this.gallery_image()
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return verticalCampsDetail;
	}(_react.Component);
	
	exports.default = verticalCampsDetail;

/***/ },
/* 1024 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _FetchCall2 = _interopRequireDefault(_FetchCall);
	
	var _constant = __webpack_require__(21);
	
	var _reactstrap = __webpack_require__(17);
	
	var _reactGeocode = __webpack_require__(55);
	
	var _reactGeocode2 = _interopRequireDefault(_reactGeocode);
	
	var _multiselectReactDropdown = __webpack_require__(73);
	
	var _simpleReactValidator = __webpack_require__(28);
	
	var _simpleReactValidator2 = _interopRequireDefault(_simpleReactValidator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import { Editor } from '@tinymce/tinymce-react';
	
	
	var url = _constant.BASEURL;
	_reactGeocode2.default.setApiKey("AIzaSyA9MtbfG_zlo64B2lqNMvigTBuXHkagKcE");
	_reactGeocode2.default.setLanguage("en");
	_reactGeocode2.default.setRegion("es");
	_reactGeocode2.default.enableDebug();
	
	var verticalCampsEdit = function (_Component) {
	    _inherits(verticalCampsEdit, _Component);
	
	    function verticalCampsEdit(props) {
	        var _this2 = this;
	
	        _classCallCheck(this, verticalCampsEdit);
	
	        var _this = _possibleConstructorReturn(this, (verticalCampsEdit.__proto__ || Object.getPrototypeOf(verticalCampsEdit)).call(this, props));
	
	        _this.LocationDataList = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	            var res;
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            _context.prev = 0;
	                            _context.next = 3;
	                            return (0, _FetchCall.getLocationList)();
	
	                        case 3:
	                            res = _context.sent;
	
	                            if (res.status == 1) {
	                                console.log('location_list', res.results);
	
	                                _this.setState({
	                                    location_list: res.results,
	                                    error: false
	                                });
	                            }
	
	                            _context.next = 10;
	                            break;
	
	                        case 7:
	                            _context.prev = 7;
	                            _context.t0 = _context['catch'](0);
	
	                            _this.setState({ error: true });
	
	                        case 10:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, _this2, [[0, 7]]);
	        }));
	
	        _this.getKeywords = function () {
	            (0, _FetchCall.commonAPI)(JSON.stringify({ url: 'get_site_keywords', vertical: 'camp' })).then(function (res) {
	                if (res.status === 1) {
	                    _this.setState({
	                        keywordsArr: res.results
	                    });
	                }
	            });
	        };
	
	        _this.handleSelect = function (e) {
	            var propName = e.target.name;
	            var value = [].concat(_toConsumableArray(e.target.selectedOptions)).map(function (item) {
	                return item.value;
	            });
	
	            _this.setState(_defineProperty({}, propName, value));
	            console.log('in', propName);
	            // marshall_arts_other 
	            if (propName === 'sub_type') {
	                var filterValue = value.filter(function (item) {
	                    return item === 'others';
	                });
	                console.log('filterValue', filterValue);
	                if (filterValue[0] === 'others') {
	                    _this.setState({
	                        marshall_arts_other: true
	                    });
	                    console.log('in');
	                } else {
	                    console.log('out');
	                    _this.setState({ marshall_arts_other: false, type_other: '' });
	                }
	            }
	        };
	
	        _this.handleSelectSports = function (e) {
	            var propName = e.target.name;
	            var value = [].concat(_toConsumableArray(e.target.selectedOptions)).map(function (item) {
	                return item.value;
	            });
	            _this.setState(_defineProperty({}, propName, value));
	            // console.log('filterValue', value)
	
	            // let filterValue = value.filter(item => item === 42)
	
	            _this.Sub_Cat_type(value);
	
	            // if (value[0] == 42 || value[0] == 76 || value[0] == 77) {
	            //     // this.Sub_Cat_type(value[0]);
	            //     this.setState({
	            //         // cat_type: true,
	            //     })
	            // } else {
	            //     // console.log('1');
	            //     this.setState({ cat_type: false, others_sports: '', sub_type: '' });
	            // }
	        };
	
	        _this.handleSelectCat1 = function (e) {
	            var propName = e.target.name;
	            var value = [].concat(_toConsumableArray(e.target.selectedOptions)).map(function (item) {
	                return item.value;
	            });
	            _this.setState(_defineProperty({}, propName, value));
	
	            _this.Sub_Cattype1(value);
	        };
	
	        _this.handleSelectCat2 = function (e) {
	            var propName = e.target.name;
	            var value = [].concat(_toConsumableArray(e.target.selectedOptions)).map(function (item) {
	                return item.value;
	            });
	            _this.setState(_defineProperty({}, propName, value));
	
	            _this.Sub_Cattype2(value);
	        };
	
	        _this.validateMail = function (value, catgry, vendr_id, pageid) {
	            var name = 'email_id';
	            var type_name = 'isEmailValid';
	            var req = JSON.stringify({
	                email_id: value,
	                category: catgry,
	                vendor_id: vendr_id,
	                pageid: pageid
	            });
	            var res = (0, _FetchCall.emailExist_check)(req).then(function (res) {
	                console.log('valuee', res);
	                if (res.status === 1) {
	                    _this.setState(_defineProperty({}, type_name, false));
	                } else {
	                    // return res.status;
	                    _this.setState(_defineProperty({}, type_name, true));
	                }
	            });
	        };
	
	        _this.handleNumberChange = function (e) {
	            var regexp = /^[0-9\b]+$/;
	            var Mnumber = e.target.value;
	
	            if (e.target.value === '' || regexp.test(e.target.value)) {
	                _this.setState(_defineProperty({}, e.target.name, Mnumber));
	            }
	            _this.Geocode_location();
	        };
	
	        _this.handleChange = function (e) {
	            _this.setState(_defineProperty({}, e.target.name, e.target.value));
	            if (e.target.name == 'google_location') _this.Geocode_location();
	            var propName = e.target.name;
	            // if (propName == 'email_id') {
	            //     this.validateMail(e.target.value, 4, this.state.vendor_id,this.state.pageid);
	            // }
	            // const propName = e.target.name;
	            // if (propName == 'google_location') {
	            // this.Geocode_location();
	            // }
	        };
	
	        _this.onSelect = function (selectedList) {
	            var keywords = [];
	            selectedList.map(function (item, i) {
	                keywords.push(item);
	            });
	            _this.setState({
	                keywords: keywords
	            });
	        };
	
	        _this.onRemove = function (selectedList, removedItem) {
	            var keywords = [];
	            selectedList.map(function (item, i) {
	                keywords.push(item);
	            });
	            _this.setState({
	                keywords: keywords
	            });
	        };
	
	        _this.handleFile = function (e) {
	            // this.Geocode_location();
	            var propName = e.target.name;
	            var files = e.target.files[0];
	            _this.setState(_defineProperty({}, propName, files));
	            var reader = new FileReader();
	            var img = '';
	            var THIS = _this;
	            reader.addEventListener("load", function () {
	                // convert image file to base64 string
	                img = reader.result;
	                THIS.setState({
	                    tempBanner: reader.result
	                });
	            }, false);
	
	            if (files) {
	                reader.readAsDataURL(files);
	            } else {
	                THIS.setState({
	                    tempBanner: ''
	                });
	            }
	        };
	
	        _this.handleFileMultiple = function (e) {
	            _this.setState(_defineProperty({}, e.target.name, e.target.files));
	        };
	
	        _this.removeImage = function (e) {
	            var delete_array = _this.state.delete_array;
	            delete_array.push(e);
	            var updated = _this.state.attachment_file.filter(function (item) {
	                return item.name !== e;
	            });
	            _this.setState({
	                attachment_file: updated,
	                delete_array: delete_array
	            });
	        };
	
	        _this.handlePreview = function (e) {
	            e.preventDefault();
	            if (_this.validator.allValid()) {
	                _this.setState({
	                    preview: true
	                });
	            } else {
	                _this.validator.showMessages();
	                _this.forceUpdate();
	            }
	        };
	
	        _this.preview = function () {
	            var subcate = _this.state.categoryTypeList.map(function (item) {
	                return _this.state.sub_categories.includes(item.category_id.toString()) ? item.category_name : '';
	            });
	            subcate = subcate.filter(function (n) {
	                return n;
	            }).toString();
	            var ttype = _this.state.tutionList.map(function (item) {
	                return _this.state.tution_type.includes(item.id.toString()) ? item.name : '';
	            });
	            ttype = ttype.filter(function (n) {
	                return n;
	            }).toString();
	            var loptions = _this.state.std_ratio.map(function (item) {
	                if (item == 1) {
	                    return 'One to One';
	                }
	                if (item == 2) {
	                    return 'One to Many';
	                }
	                if (item == 3) {
	                    return 'NA';
	                }
	            });
	            loptions = loptions.filter(function (n) {
	                return n;
	            }).toString();
	            var clsfreq = _this.state.ClassList.map(function (item) {
	                if (_this.state.class_frequency == item.id.toString()) return item.freq_name;
	            });
	            var from_time = _this.state.timingList.map(function (item) {
	                if (item.id == _this.state.from_time) return item.timing;
	            });
	            from_time = from_time.filter(function (n) {
	                return n;
	            }).toString();
	            var to_time = _this.state.timingList.map(function (item) {
	                if (item.id == _this.state.to_time) return item.timing;
	            });
	            to_time = to_time.filter(function (n) {
	                return n;
	            }).toString();
	            return _react2.default.createElement(
	                _reactstrap.Modal,
	                { isOpen: _this.state.preview, size: 'lg', className: 'preview-pop' },
	                _react2.default.createElement(
	                    _reactstrap.ModalBody,
	                    { className: 'p-0' },
	                    _react2.default.createElement(
	                        _reactstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactstrap.Col,
	                            { md: '12' },
	                            _react2.default.createElement('img', { src: '/assets/images/user-header.png', className: 'preview-header' })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactstrap.Row,
	                        { className: 'pv-banner' },
	                        _react2.default.createElement(
	                            _reactstrap.Col,
	                            { className: 'pv-banner-bg', md: '12' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'title-section' },
	                                _react2.default.createElement(
	                                    'p',
	                                    { className: 'banner-title' },
	                                    _this.state.organisation_name
	                                ),
	                                _react2.default.createElement(
	                                    'p',
	                                    { className: 'banner-address' },
	                                    _this.state.address
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactstrap.Row,
	                        { className: 'pv-section' },
	                        _react2.default.createElement(
	                            _reactstrap.Col,
	                            { className: '', md: '12' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'title-section' },
	                                _react2.default.createElement(
	                                    'h4',
	                                    null,
	                                    'About the School'
	                                ),
	                                _react2.default.createElement(
	                                    'p',
	                                    { className: '' },
	                                    _this.state.about
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactstrap.Row,
	                        { className: 'pv-section' },
	                        _react2.default.createElement(
	                            _reactstrap.Col,
	                            { className: '', md: '12' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'title-section' },
	                                _react2.default.createElement(
	                                    'h4',
	                                    null,
	                                    'Key Information'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'row' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-4' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'type-n7ngd' },
	                                            _react2.default.createElement(
	                                                'b',
	                                                null,
	                                                'Sub Category'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'key-po' },
	                                            _react2.default.createElement(
	                                                'p',
	                                                null,
	                                                subcate
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-4' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'type-n7ngd' },
	                                            _react2.default.createElement(
	                                                'b',
	                                                null,
	                                                'Number of Coach'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'key-po' },
	                                            _react2.default.createElement(
	                                                'p',
	                                                null,
	                                                _this.state.number_of_trainee
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-4' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'type-n7ngd' },
	                                            _react2.default.createElement(
	                                                'b',
	                                                null,
	                                                'Timing'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'key-po' },
	                                            _react2.default.createElement(
	                                                'p',
	                                                null,
	                                                from_time == 'NA' || to_time == 'NA' ? 'NA' : from_time + ' ' + _this.state.from_time_cate + ' - ' + to_time + ' ' + _this.state.to_time_cate
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-4' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'type-n7ngd' },
	                                            _react2.default.createElement(
	                                                'b',
	                                                null,
	                                                'Type'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'key-po' },
	                                            _react2.default.createElement(
	                                                'p',
	                                                null,
	                                                ttype
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-4' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'type-n7ngd' },
	                                            _react2.default.createElement(
	                                                'b',
	                                                null,
	                                                'Class Frequency'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'key-po' },
	                                            _react2.default.createElement(
	                                                'p',
	                                                null,
	                                                clsfreq
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-4' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'type-n7ngd' },
	                                            _react2.default.createElement(
	                                                'b',
	                                                null,
	                                                'Age Group'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'key-po' },
	                                            _react2.default.createElement(
	                                                'p',
	                                                null,
	                                                _this.state.min_age
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-4' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'type-n7ngd' },
	                                            _react2.default.createElement(
	                                                'b',
	                                                null,
	                                                'Establishment Year'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'key-po' },
	                                            _react2.default.createElement(
	                                                'p',
	                                                null,
	                                                _this.state.establishment_Year
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-4' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'type-n7ngd' },
	                                            _react2.default.createElement(
	                                                'b',
	                                                null,
	                                                'Avg Fee'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'key-po' },
	                                            _react2.default.createElement(
	                                                'p',
	                                                null,
	                                                parseFloat(_this.state.avg_anual_fee) > 0 ? _this.state.avg_anual_fee + '/Month' : 'NA'
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-4' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'type-n7ngd' },
	                                            _react2.default.createElement(
	                                                'b',
	                                                null,
	                                                'Admission Fee'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'key-po' },
	                                            _react2.default.createElement(
	                                                'p',
	                                                null,
	                                                parseFloat(_this.state.admit_fee) > 0 ? '' + _this.state.admit_fee : 'NA'
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-4' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'type-n7ngd' },
	                                            _react2.default.createElement(
	                                                'b',
	                                                null,
	                                                'Learning Options'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'key-po' },
	                                            _react2.default.createElement(
	                                                'p',
	                                                null,
	                                                loptions
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-4' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'type-n7ngd' },
	                                            _react2.default.createElement(
	                                                'b',
	                                                null,
	                                                'Free Trial Class'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'key-po' },
	                                            _react2.default.createElement(
	                                                'p',
	                                                null,
	                                                _this.state.has_trail == 0 ? 'NA' : _this.state.has_trail == 1 ? 'Yes, ' : 'No',
	                                                _this.state.has_trail == 1 && ' ' + _this.state.trail_desc
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactstrap.Row,
	                        { className: 'pv-section' },
	                        _react2.default.createElement(
	                            _reactstrap.Col,
	                            { className: '', md: '12' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'title-section' },
	                                _react2.default.createElement(
	                                    'h4',
	                                    null,
	                                    'Gallery'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'row' },
	                                    _this.state.attachment_file.map(function (item) {
	                                        if (item.image_thumb) {
	                                            return _react2.default.createElement(
	                                                'div',
	                                                { className: 'col-md-4' },
	                                                _react2.default.createElement('img', { src: item.image_thumb, className: 'preview-image' })
	                                            );
	                                        } else if (item.name) {
	                                            var file_url = URL.createObjectURL(item);
	                                            return _react2.default.createElement(
	                                                'div',
	                                                { className: 'col-md-4' },
	                                                _react2.default.createElement('img', { src: file_url, className: 'preview-image' })
	                                            );
	                                        }
	                                    }),
	                                    _this.state.attachment_file.length === 0 && _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-4' },
	                                        'No Gallery Images Found'
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactstrap.Row,
	                        { className: 'pv-section' },
	                        _react2.default.createElement(
	                            _reactstrap.Col,
	                            { className: '', md: '12' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'title-section' },
	                                _react2.default.createElement(
	                                    'h4',
	                                    null,
	                                    'Contact Information'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'row' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-4' },
	                                        'Email Id : ',
	                                        _this.state.email_id
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-4' },
	                                        'Contact : ',
	                                        _this.state.phone_number
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-4' },
	                                        'Website : ',
	                                        _this.state.website
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactstrap.Row,
	                        { className: 'pv-section' },
	                        _react2.default.createElement(
	                            _reactstrap.Col,
	                            { className: '', md: '12' },
	                            _react2.default.createElement(
	                                'button',
	                                { className: 'btn btn-sm btn-primary custome-submit', onClick: _this.handleSubmit },
	                                _this.state.edited && (_this.state.role == 1 || _this.state.login_id == 936) ? 'Approve' : 'Submit'
	                            ),
	                            _this.state.edited && (_this.state.role == 1 || _this.state.login_id == 936) && _react2.default.createElement(
	                                'button',
	                                { className: 'btn btn-sm btn-danger custome-submit', style: { marginLeft: '10px' },
	                                    onClick: _this.handleReject },
	                                'Reject'
	                            ),
	                            _react2.default.createElement(
	                                'button',
	                                { className: 'btn btn-sm btn-defult custome-submit', style: { marginLeft: '10px' },
	                                    onClick: function onClick() {
	                                        _this.setState({ preview: false });
	                                    } },
	                                'Close'
	                            )
	                        )
	                    )
	                )
	            );
	        };
	
	        _this.handleReject = function (e) {
	            e.preventDefault();
	            var req = JSON.stringify({
	                id: _this.token
	            });
	            var toastr = '';
	            (0, _FetchCall.hobbiesReject)(req).then(function (res) {
	                if (res.status === 1) {
	                    toastr = window.toastr.success;
	                    toastr('success', {
	                        positionClass: "toast-bottom-right",
	                        containerId: "toast-bottom-right"
	                    });
	                    window.location.href = document.referrer;
	                }
	            });
	        };
	
	        _this.handleSubmit = function (e) {
	            e.preventDefault();
	            if (_this.validator.allValid()) {
	                var insData = {
	                    id: _this.token ? _this.token : '',
	                    about: _this.state.about,
	                    admit_fee: _this.state.addmission_fee,
	                    address: _this.state.address,
	                    area: _this.state.area,
	                    avg_fee: _this.state.avg_anual_fee,
	                    category: _this.state.category,
	                    class_frequency: _this.state.class_frequency,
	                    country: _this.state.country,
	                    email_id: _this.state.email_id,
	                    est_year: _this.state.establishment_Year,
	                    google_location: _this.state.google_location,
	                    location: _this.state.location,
	                    min_age: _this.state.min_age,
	                    std_ratio: _this.state.std_ratio,
	                    // modeofpayment: this.state.modeofpayment,
	                    number_of_trainee: _this.state.number_of_trainee,
	                    organisation_name: _this.state.organisation_name,
	                    phone_number: _this.state.phone_number,
	                    images: _this.state.images,
	                    photos: _this.state.attachment_file,
	                    pincode: _this.state.pincode,
	                    registration_no: _this.state.registration_no,
	                    state: _this.state.state,
	                    sub_categories: _this.state.sub_categories,
	                    sub_types: _this.state.sub_types,
	                    sub_type: _this.state.sub_type,
	                    timing: _this.state.timing,
	                    video_leaning: _this.state.video_leaning,
	                    website: _this.state.website,
	                    tution_type: _this.state.tution_type,
	                    partner_type: _this.state.partner_type,
	                    other_info: _this.state.other_info,
	                    login_id: _this.state.login_id,
	                    latitude: _this.state.latitude,
	                    longitude: _this.state.longitude,
	                    other_rating: _this.state.other_rating,
	                    from_time: _this.state.from_time,
	                    to_time: _this.state.to_time,
	                    from_time_cate: _this.state.from_time_cate,
	                    to_time_cate: _this.state.to_time_cate,
	                    keywords: _this.state.keywords ? _this.state.keywords.join(';') : '',
	                    delete_array: _this.state.delete_array,
	                    has_trail: _this.state.has_trail,
	                    trail_desc: _this.state.trail_desc,
	                    role: _this.state.role
	                    // jQuery("#btnSubmit").attr('disabled', true);
	                };(0, _FetchCall.AddSports)(insData).then(function (res) {
	                    var toastr = '';
	                    if (res.status === 1) {
	                        toastr = window.toastr.success;
	                        toastr('success', 'created success!..', {
	                            positionClass: "toast-bottom-right",
	                            containerId: "toast-bottom-right"
	                        });
	                        //window.location.href = document.referrer;
	                    } else {
	                        (0, _jquery2.default)("#btnSubmit").attr('disabled', false);
	                        toastr = window.toastr.error; //warning
	                        toastr('Error', 'Something went wrong. try again!...', {
	                            positionClass: "toast-bottom-right",
	                            containerId: "toast-bottom-right"
	                        });
	                    }
	                });
	            } else {
	                _this.validator.showMessages();
	                _this.forceUpdate();
	            }
	        };
	
	        _this.state = {
	            type_of_orgainsation: _this.props.match.params.type,
	            sub_type: [],
	            pageid: '',
	            location: 'Bengaluru',
	            video_leaning: '',
	            class_frequency: '',
	            modeofpayment: '',
	            categoryTypeList: [],
	            categorySubTypeList: [],
	            timingList: [],
	            timing: '',
	            std_ratio: [],
	            ClassList: [],
	            mopList: [],
	            sub_categories: '',
	            sub_types: [],
	            noCategory: true,
	            category: _this.props.match.params.id,
	            name_parm: _this.props.match.params.type,
	            categorySubTypeList1: [],
	            latitude: '',
	            longitude: '',
	            other_rating: '',
	            tutionList: [],
	            tution_type: '',
	            attachment_file: [],
	            attachment_file_length: 0,
	            attachment_fileName: [],
	            from_time: '',
	            from_time_cate: 'AM',
	            to_time: '',
	            to_time_cate: 'AM',
	            edit_image: '',
	            delete_array: [],
	            keywords: '',
	            location_list: [],
	            tempBanner: '',
	            has_trail: 0,
	            trail_desc: '',
	            partner_type: '',
	            preview: false,
	            edited_data: [],
	            keywordsArr: [],
	            edited: false
	        };
	        _this.validator = new _simpleReactValidator2.default({
	            validators: {
	                checkExist: { // name the rule
	                    message: 'The :attribute field is required.',
	                    rule: function rule(val, params, validator) {
	                        if (val == '' && _this.state.edit_image == '') {
	                            return false;
	                        }
	                    },
	                    messageReplace: function messageReplace(message, params) {
	                        return message.replace(':values', _this.helpers.toSentence(params));
	                    }, // optional
	                    required: true // optional
	                },
	                emailExist_check: { // name the rule
	                    message: 'The :attribute Already Exist.',
	                    rule: function rule(val, params, validator) {
	                        return _this.state.isEmailValid;
	                    },
	                    messageReplace: function messageReplace(message, params) {
	                        return message.replace(':values', _this.helpers.toSentence(params));
	                    }, // optional
	                    required: true // optional
	                },
	                checkMobile: _constant.MOBILE_REGEX,
	                checkUrl: _constant.URL_REGEX
	            }
	        });
	        _this.id = _this.props.match.params.id;
	        _this.token = _this.props.match.params.token;
	        _this.type = _this.props.match.params.type;
	        if (_this.token) {
	            _this.infoDetails = _this.infoDetails.bind(_this);
	            _this.infoDetails();
	        }
	        _this.loadFile = _this.loadFile.bind(_this);
	        _this.getKeywords();
	        _this.Cat_type();_this.tutionList();_this.getclass_frequency();_this.gettiming();_this.getpayment_type();
	        return _this;
	    }
	
	    _createClass(verticalCampsEdit, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.LocationDataList();
	            var user_data = localStorage.getItem("user_data");
	            var auth_data = JSON.parse(user_data);
	            var vendor_id = auth_data.login_id;
	            this.setState({
	                login_id: vendor_id,
	                role: auth_data.role
	            });
	        }
	    }, {
	        key: 'infoDetails',
	        value: function () {
	            var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	                var response, data, edited_data;
	                return _regenerator2.default.wrap(function _callee2$(_context2) {
	                    while (1) {
	                        switch (_context2.prev = _context2.next) {
	                            case 0:
	                                _context2.next = 2;
	                                return (0, _FetchCall.hobbiesEdit)(JSON.stringify({ id: this.token }));
	
	                            case 2:
	                                response = _context2.sent;
	
	                                if (response) {
	                                    data = response.data, edited_data = response.original;
	
	                                    this.setState({
	                                        about: data.about,
	                                        pageid: data.id,
	                                        addmission_fee: data.admit_fee,
	                                        address: data.address,
	                                        area: data.area,
	                                        avg_anual_fee: data.avg_fee,
	                                        class_frequency: data.class_frequency.split(','),
	                                        country: data.country,
	                                        email_id: data.email_id,
	                                        establishment_Year: data.est_year,
	                                        google_location: data.google_location,
	                                        location: data.location,
	                                        min_age: data.min_age,
	                                        modeofpayment: data.modeofpayment,
	                                        number_of_trainee: data.number_of_trainee,
	                                        organisation_name: data.organisation_name,
	                                        phone_number: data.phone_number,
	                                        pincode: data.pincode,
	                                        std_ratio: data.std_ratio.split(','),
	                                        registration_no: data.registration_no,
	                                        state: data.state,
	                                        sub_categories: data.sub_categories.split(','),
	                                        sub_types: data.sub_types.split(','),
	                                        sub_type: data.sub_type.split(','),
	                                        timing: data.time,
	                                        video_leaning: data.video_leaning,
	                                        website: data.website,
	                                        tution_type: data.tution_type,
	                                        partner_type: data.partner_type,
	                                        other_info: data.other_info,
	                                        cat_type1: data.sub_type ? true : false,
	                                        cat_type: data.type2 ? true : false,
	                                        attachment_file: data.photo_arr,
	                                        edit_image: data.images ? data.url + data.images : '',
	                                        edit_photos: data.photos,
	                                        photos: data.photos,
	                                        images: data.images,
	                                        keywords: data.keywords ? data.keywords.split(';') : [],
	                                        from_time: data.from_time,
	                                        to_time: data.to_time,
	                                        from_time_cate: data.from_time_cate,
	                                        to_time_cate: data.to_time_cate,
	                                        has_trail: data.has_trail,
	                                        trail_desc: data.trail_desc,
	                                        longitude: data.longitude,
	                                        latitude: data.latitude,
	                                        other_rating: data.other_rating,
	                                        edited: data.edited,
	                                        edited_data: edited_data
	                                    });
	                                    this.Sub_Cat_type(data.sub_categories);
	                                    this.Geocode_location(data.google_location);
	                                }
	
	                            case 4:
	                            case 'end':
	                                return _context2.stop();
	                        }
	                    }
	                }, _callee2, this);
	            }));
	
	            function infoDetails() {
	                return _ref2.apply(this, arguments);
	            }
	
	            return infoDetails;
	        }()
	    }, {
	        key: 'tutionList',
	        value: function () {
	            var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	                var response;
	                return _regenerator2.default.wrap(function _callee3$(_context3) {
	                    while (1) {
	                        switch (_context3.prev = _context3.next) {
	                            case 0:
	                                _context3.next = 2;
	                                return _FetchCall2.default.getSchoolListDatas('tution_type');
	
	                            case 2:
	                                response = _context3.sent;
	
	                                console.log(response);
	                                if (response) {
	                                    this.setState({ tutionList: response.results });
	                                }
	
	                            case 5:
	                            case 'end':
	                                return _context3.stop();
	                        }
	                    }
	                }, _callee3, this);
	            }));
	
	            function tutionList() {
	                return _ref3.apply(this, arguments);
	            }
	
	            return tutionList;
	        }()
	    }, {
	        key: 'Cat_type',
	        value: function () {
	            var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4() {
	                var response;
	                return _regenerator2.default.wrap(function _callee4$(_context4) {
	                    while (1) {
	                        switch (_context4.prev = _context4.next) {
	                            case 0:
	                                console.log('categoryTypeList', this.props.match.params.id);
	                                _context4.next = 3;
	                                return _FetchCall2.default.getSubCategory(this.props.match.params.id);
	
	                            case 3:
	                                response = _context4.sent;
	
	                                if (response.status == 1) {
	                                    this.setState({ categoryTypeList: response.results });
	                                } else {
	                                    console.log('noCategory', 'in');
	                                    this.setState({ noCategory: false });
	                                }
	
	                            case 5:
	                            case 'end':
	                                return _context4.stop();
	                        }
	                    }
	                }, _callee4, this);
	            }));
	
	            function Cat_type() {
	                return _ref4.apply(this, arguments);
	            }
	
	            return Cat_type;
	        }()
	    }, {
	        key: 'Sub_Cat_type',
	        value: function () {
	            var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(id) {
	                var response;
	                return _regenerator2.default.wrap(function _callee5$(_context5) {
	                    while (1) {
	                        switch (_context5.prev = _context5.next) {
	                            case 0:
	                                if (!(id != '')) {
	                                    _context5.next = 7;
	                                    break;
	                                }
	
	                                _context5.next = 3;
	                                return _FetchCall2.default.getSubCategory(id);
	
	                            case 3:
	                                response = _context5.sent;
	
	                                if (response.status == 1) {
	                                    this.setState({ categorySubTypeList: response.results, cat_type: true, cat_type1: false, cat_type2: false });
	                                } else {
	                                    this.setState({ categorySubTypeList: [], sub_types: [], cat_type: false, cat_type1: false, cat_type2: false });
	                                }
	                                _context5.next = 8;
	                                break;
	
	                            case 7:
	                                this.setState({ categorySubTypeList: [], sub_types: [], cat_type: false, cat_type1: false, cat_type2: false });
	
	                            case 8:
	                            case 'end':
	                                return _context5.stop();
	                        }
	                    }
	                }, _callee5, this);
	            }));
	
	            function Sub_Cat_type(_x) {
	                return _ref5.apply(this, arguments);
	            }
	
	            return Sub_Cat_type;
	        }()
	    }, {
	        key: 'Sub_Cattype1',
	        value: function () {
	            var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(id) {
	                var response;
	                return _regenerator2.default.wrap(function _callee6$(_context6) {
	                    while (1) {
	                        switch (_context6.prev = _context6.next) {
	                            case 0:
	                                if (!(id != '')) {
	                                    _context6.next = 7;
	                                    break;
	                                }
	
	                                _context6.next = 3;
	                                return _FetchCall2.default.getSubCategory(id);
	
	                            case 3:
	                                response = _context6.sent;
	
	                                if (response.status == 1) {
	                                    this.setState({ categorySubTypeList1: response.results, cat_type1: true, cat_type2: false });
	                                } else {
	                                    this.setState({ categorySubTypeList1: [], sub_type: [], cat_type1: false, cat_type2: false });
	                                }
	                                _context6.next = 8;
	                                break;
	
	                            case 7:
	                                this.setState({ categorySubTypeList1: [], sub_type: [], cat_type1: false, cat_type2: false });
	
	                            case 8:
	                            case 'end':
	                                return _context6.stop();
	                        }
	                    }
	                }, _callee6, this);
	            }));
	
	            function Sub_Cattype1(_x2) {
	                return _ref6.apply(this, arguments);
	            }
	
	            return Sub_Cattype1;
	        }()
	    }, {
	        key: 'getclass_frequency',
	        value: function () {
	            var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee7() {
	                var response;
	                return _regenerator2.default.wrap(function _callee7$(_context7) {
	                    while (1) {
	                        switch (_context7.prev = _context7.next) {
	                            case 0:
	                                _context7.next = 2;
	                                return _FetchCall2.default.getSchoolListDatas('class_frequency');
	
	                            case 2:
	                                response = _context7.sent;
	
	                                console.log(response);
	                                if (response.status == 1) {
	                                    this.setState({ ClassList: response.results });
	                                }
	
	                            case 5:
	                            case 'end':
	                                return _context7.stop();
	                        }
	                    }
	                }, _callee7, this);
	            }));
	
	            function getclass_frequency() {
	                return _ref7.apply(this, arguments);
	            }
	
	            return getclass_frequency;
	        }()
	    }, {
	        key: 'gettiming',
	        value: function () {
	            var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee8() {
	                var response;
	                return _regenerator2.default.wrap(function _callee8$(_context8) {
	                    while (1) {
	                        switch (_context8.prev = _context8.next) {
	                            case 0:
	                                _context8.next = 2;
	                                return _FetchCall2.default.getSchoolListDatas('timing');
	
	                            case 2:
	                                response = _context8.sent;
	
	                                console.log(response);
	                                if (response) {
	                                    this.setState({ timingList: response.results });
	                                }
	
	                            case 5:
	                            case 'end':
	                                return _context8.stop();
	                        }
	                    }
	                }, _callee8, this);
	            }));
	
	            function gettiming() {
	                return _ref8.apply(this, arguments);
	            }
	
	            return gettiming;
	        }()
	    }, {
	        key: 'getpayment_type',
	        value: function () {
	            var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee9() {
	                var response;
	                return _regenerator2.default.wrap(function _callee9$(_context9) {
	                    while (1) {
	                        switch (_context9.prev = _context9.next) {
	                            case 0:
	                                _context9.next = 2;
	                                return _FetchCall2.default.getSchoolListDatas('payment_type');
	
	                            case 2:
	                                response = _context9.sent;
	
	                                console.log(response);
	                                if (response) {
	                                    this.setState({ mopList: response.results });
	                                }
	
	                            case 5:
	                            case 'end':
	                                return _context9.stop();
	                        }
	                    }
	                }, _callee9, this);
	            }));
	
	            function getpayment_type() {
	                return _ref9.apply(this, arguments);
	            }
	
	            return getpayment_type;
	        }()
	    }, {
	        key: 'UNSAFE_componentWillMount',
	        value: function UNSAFE_componentWillMount() {}
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            //window.jQuery('.selectpicker').selectpicker('refresh');
	        }
	    }, {
	        key: 'Geocode_location',
	        value: function Geocode_location() {
	            var _this3 = this;
	
	            var location = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	            _reactGeocode2.default.fromAddress(location ? location : this.state.google_location).then(function (response) {
	                var _response$results$0$g = response.results[0].geometry.location,
	                    lat = _response$results$0$g.lat,
	                    lng = _response$results$0$g.lng;
	
	                if (lat && lng) _this3.get_location(lat, lng);
	            }, function (error) {
	                console.error(error);
	            });
	        }
	    }, {
	        key: 'get_location',
	        value: function get_location(lat, lng) {
	            this.setState({
	                latitude: lat,
	                longitude: lng
	            });
	        }
	    }, {
	        key: 'remove_img',
	        value: function remove_img() {
	            (0, _jquery2.default)('#edit_image').remove();
	        }
	    }, {
	        key: 'loadFile',
	        value: function loadFile(e) {
	            var files = e.target.files;
	            this.setState({ attachment_file_length: files.length });
	            if (files.length > 0) {
	                (0, _jquery2.default)('.upload-space').addClass('hide');
	                (0, _jquery2.default)('.upload-thumb').removeClass('hide');
	                var fileArra = this.state.attachment_file;
	
	                //console.log('fileArra',fileArra)
	                //var fileThumbArra = this.state.imgThumb;
	                for (var i = 0; i < files.length; i++) {
	                    fileArra.push(e.target.files[i]);
	                    this.setState({
	                        selectedFile: URL.createObjectURL(e.target.files[i]),
	                        attachment_file: fileArra
	                    });
	                }
	                //   this.clearValidationErr('attachment_file');
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this4 = this;
	
	            var _state = this.state,
	                edited_data = _state.edited_data,
	                edited = _state.edited;
	
	            this.validator.purgeFields();
	
	            return _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _react2.default.createElement(
	                    _layout2.default,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { 'class': 'col-lg-12 grid-margin stretch-card' },
	                        _react2.default.createElement(
	                            'div',
	                            { 'class': 'card' },
	                            _react2.default.createElement(
	                                'div',
	                                { 'class': 'card-body' },
	                                _react2.default.createElement(
	                                    'h4',
	                                    { 'class': 'card-title' },
	                                    'Tuition Info Management'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'row' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'content-sec col-md-12 col-xs-12 pad-no mar-t-no' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: '' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { id: 'company-info', className: 'tab-pane active' },
	                                                _react2.default.createElement(
	                                                    'form',
	                                                    { onSubmit: this.handlePreview, className: 'custom-form invoice-form col-md-12 col-xs-12 legend-form pad-no' },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'box-shadow-custom' },
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'row' },
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    null,
	                                                                    'Partner Type',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    { className: 'custom-select-drop dropdown' },
	                                                                    _react2.default.createElement(
	                                                                        'select',
	                                                                        {
	                                                                            value: this.state.partner_type,
	                                                                            onChange: this.handleSelect, className: 'form-control selectpicker',
	                                                                            name: 'partner_type',
	                                                                            title: 'Select' },
	                                                                        _react2.default.createElement(
	                                                                            'option',
	                                                                            { value: '1' },
	                                                                            'Institution'
	                                                                        ),
	                                                                        _react2.default.createElement(
	                                                                            'option',
	                                                                            { value: '2' },
	                                                                            'Individuals'
	                                                                        )
	                                                                    ),
	                                                                    this.validator.message('Type', this.state.partner_type, 'required', { className: 'text-danger' })
	                                                                )
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.registration_no != this.state.registration_no && 'edited-field' },
	                                                                    'Registration No ',
	                                                                    this.state.user_type == 1 && _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    ),
	                                                                    ' '
	                                                                ),
	                                                                _react2.default.createElement('input', { type: 'text', name: 'registration_no',
	                                                                    value: this.state.registration_no,
	                                                                    onChange: this.handleChange, className: 'form-control' }),
	                                                                this.state.user_type == 1 && this.validator.message('Registration No', this.state.registration_no, 'required', { className: 'text-danger' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.organisation_name != this.state.organisation_name && 'edited-field' },
	                                                                    this.state.name_parm,
	                                                                    ' Academy Name ',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('input', { type: 'text', name: 'organisation_name',
	                                                                    value: this.state.organisation_name,
	                                                                    onChange: this.handleChange, className: 'form-control' }),
	                                                                this.validator.message(this.state.name_parm + 'Academy Name', this.state.organisation_name, 'required', { className: 'text-danger' })
	                                                            ),
	                                                            this.state.noCategory !== false && _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.sub_categories != this.state.sub_categories && 'edited-field' },
	                                                                    this.state.name_parm,
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    { className: 'custom-select-drop dropdown' },
	                                                                    _react2.default.createElement(
	                                                                        'select',
	                                                                        {
	                                                                            multiple: true,
	                                                                            value: this.state.sub_categories,
	                                                                            onChange: this.handleSelectSports,
	                                                                            name: 'sub_categories',
	                                                                            'data-live-search': 'true',
	                                                                            className: 'form-control selectpicker',
	                                                                            title: 'Select' },
	                                                                        this.state.categoryTypeList.length > 0 && this.state.categoryTypeList.map(function (item, i) {
	                                                                            return _react2.default.createElement(
	                                                                                'option',
	                                                                                { value: item.category_id },
	                                                                                item.category_name
	                                                                            );
	                                                                        })
	                                                                    )
	                                                                )
	                                                            ),
	                                                            this.state.cat_type == true && _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.sub_types != this.state.sub_types && 'edited-field' },
	                                                                    this.state.name_parm,
	                                                                    ' Type',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    { className: 'custom-select-drop dropdown' },
	                                                                    _react2.default.createElement(
	                                                                        'select',
	                                                                        {
	                                                                            multiple: true,
	                                                                            onChange: this.handleSelectCat1,
	                                                                            name: 'sub_types',
	                                                                            className: 'form-control selectpicker',
	                                                                            title: 'Select',
	                                                                            value: this.state.sub_types
	                                                                        },
	                                                                        this.state.categorySubTypeList.length > 0 && this.state.categorySubTypeList.map(function (item, i) {
	                                                                            return _react2.default.createElement(
	                                                                                'option',
	                                                                                { value: item.category_id },
	                                                                                item.category_name
	                                                                            );
	                                                                        })
	                                                                    ),
	                                                                    this.validator.message(this.state.name_parm + ' Type', this.state.sub_types, 'required', { className: 'text-danger' })
	                                                                )
	                                                            ),
	                                                            this.state.cat_type1 == true && _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.sub_type != this.state.sub_type && 'edited-field' },
	                                                                    _react2.default.createElement('span', { className: 'astrick' })
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    { className: 'custom-select-drop dropdown' },
	                                                                    _react2.default.createElement(
	                                                                        'select',
	                                                                        {
	                                                                            multiple: true,
	                                                                            value: this.state.sub_type,
	                                                                            onChange: this.handleSelectCat2,
	                                                                            name: 'sub_type',
	                                                                            className: 'form-control selectpicker',
	                                                                            title: 'Select'
	                                                                        },
	                                                                        this.state.categorySubTypeList1.length > 0 && this.state.categorySubTypeList1.map(function (item, i) {
	                                                                            return _react2.default.createElement(
	                                                                                'option',
	                                                                                { value: item.category_id },
	                                                                                item.category_name
	                                                                            );
	                                                                        })
	                                                                    ),
	                                                                    this.validator.message('Type', this.state.sub_type, 'required', { className: 'text-danger' })
	                                                                )
	                                                            )
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'box-shadow-custom' },
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'row' },
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'col-md-12 col-xs-12' },
	                                                                _react2.default.createElement(
	                                                                    'span',
	                                                                    { className: 'form-legend' },
	                                                                    'Address Information'
	                                                                )
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.email_id != this.state.email_id && 'edited-field' },
	                                                                    'Email Id ',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('input', { type: 'text', name: 'email_id',
	                                                                    value: this.state.email_id,
	                                                                    onChange: this.handleChange, className: 'form-control' }),
	                                                                this.validator.message('Email Id', this.state.email_id, 'emailExist_check', { className: 'text-danger' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.phone_number != this.state.phone_number && 'edited-field' },
	                                                                    'Phone Number ',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('input', { type: 'text', name: 'phone_number',
	                                                                    value: this.state.phone_number,
	                                                                    onChange: this.handleChange, className: 'form-control' }),
	                                                                this.validator.message('Phone Number', this.state.phone_number, '', { className: 'text-danger' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.website != this.state.website && 'edited-field' },
	                                                                    'Website ',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('input', { type: 'text', name: 'website',
	                                                                    value: this.state.website,
	                                                                    onChange: this.handleChange, className: 'form-control' }),
	                                                                this.validator.message('Website', this.state.website, '', { className: 'text-danger' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.state != this.state.state && 'edited-field' },
	                                                                    'State ',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('input', { type: 'text', name: 'state',
	                                                                    value: this.state.state,
	                                                                    onChange: this.handleChange, className: 'form-control' }),
	                                                                this.validator.message('State', this.state.state, 'required', { className: 'text-danger' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.location != this.state.location && 'edited-field' },
	                                                                    'Location ',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'select',
	                                                                    {
	                                                                        name: 'location',
	                                                                        id: 'location',
	                                                                        onChange: this.handleSelect,
	                                                                        value: this.state.location,
	                                                                        className: 'form-control selectpicker',
	                                                                        title: 'Select'
	                                                                    },
	                                                                    this.state.location_list.length > 0 && this.state.location_list.map(function (item, i) {
	                                                                        return _react2.default.createElement(
	                                                                            'option',
	                                                                            { value: item.location },
	                                                                            item.location
	                                                                        );
	                                                                    })
	                                                                ),
	                                                                this.validator.message('Location', this.state.location, 'required', { className: 'text-danger' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.pincode != this.state.pincode && 'edited-field' },
	                                                                    'Pincode',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('input', { type: 'text', name: 'pincode',
	                                                                    value: this.state.pincode,
	                                                                    onChange: this.handleChange, className: 'form-control' }),
	                                                                this.validator.message('Pincode', this.state.pincode, 'required', { className: 'text-danger' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.address != this.state.address && 'edited-field' },
	                                                                    'Address',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('input', { type: 'text', name: 'address',
	                                                                    value: this.state.address,
	                                                                    onChange: this.handleChange, className: 'form-control' }),
	                                                                this.validator.message('Address', this.state.address, 'required', { className: 'text-danger' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.google_location != this.state.google_location && 'edited-field' },
	                                                                    'Google Location Address',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('input', { type: 'text', name: 'google_location',
	                                                                    value: this.state.google_location,
	                                                                    onChange: this.handleChange, className: 'form-control' }),
	                                                                this.validator.message('Google Location', this.state.google_location, 'required', { className: 'text-danger' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.latitude != this.state.latitude && 'edited-field' },
	                                                                    'Latitude',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('input', {
	                                                                    type: 'text',
	                                                                    name: 'latitude',
	                                                                    value: this.state.latitude,
	                                                                    onChange: this.handleChange,
	
	                                                                    className: 'form-control'
	                                                                }),
	                                                                this.validator.message('Latitude', this.state.latitude, 'required', { className: 'text-danger' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.longitude != this.state.longitude && 'edited-field' },
	                                                                    'Longitude',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('input', {
	                                                                    type: 'text',
	                                                                    name: 'longitude',
	                                                                    value: this.state.longitude,
	                                                                    onChange: this.handleChange,
	
	                                                                    className: 'form-control'
	                                                                }),
	                                                                this.validator.message('Longitude', this.state.longitude, 'required', { className: 'text-danger' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.other_rating != this.state.other_rating && 'edited-field' },
	                                                                    'Google Rating',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('input', {
	                                                                    type: 'number',
	                                                                    step: '0.01',
	                                                                    name: 'other_rating',
	                                                                    value: this.state.other_rating,
	                                                                    onChange: this.handleChange,
	                                                                    max: '5',
	                                                                    className: 'form-control'
	                                                                }),
	                                                                this.validator.message('Google Rating', this.state.other_rating, 'required', { className: 'text-danger' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-12' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.about != this.state.about && 'edited-field' },
	                                                                    'About',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('textarea', { type: 'text', name: 'about',
	                                                                    value: this.state.about,
	                                                                    onChange: this.handleChange, className: 'form-control' }),
	                                                                this.validator.message('About', this.state.about, 'required', { className: 'text-danger' })
	                                                            )
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'box-shadow-custom' },
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'row' },
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'col-md-12 col-xs-12' },
	                                                                _react2.default.createElement(
	                                                                    'span',
	                                                                    { className: 'form-legend' },
	                                                                    'Key Information'
	                                                                )
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.tution_type != this.state.tution_type && 'edited-field' },
	                                                                    'Type',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    { className: 'custom-select-drop dropdown' },
	                                                                    _react2.default.createElement(
	                                                                        'select',
	                                                                        {
	                                                                            value: this.state.tution_type,
	                                                                            onChange: this.handleSelect, className: 'form-control selectpicker',
	                                                                            name: 'tution_type',
	                                                                            title: 'Select' },
	                                                                        this.state.tutionList.length > 0 && this.state.tutionList.map(function (item, i) {
	                                                                            return _react2.default.createElement(
	                                                                                'option',
	                                                                                { value: item.id },
	                                                                                item.name
	                                                                            );
	                                                                        })
	                                                                    ),
	                                                                    this.validator.message('Type', this.state.tution_type, 'required', { className: 'text-danger' })
	                                                                )
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.class_frequency != this.state.class_frequency && 'edited-field' },
	                                                                    'Class Frequency',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    { className: 'custom-select-drop dropdown' },
	                                                                    _react2.default.createElement(
	                                                                        'select',
	                                                                        {
	                                                                            multiple: true,
	                                                                            value: this.state.class_frequency,
	                                                                            onChange: this.handleSelect,
	                                                                            name: 'class_frequency',
	                                                                            placeholder: 'select',
	                                                                            className: 'form-control selectpicker',
	                                                                            title: 'Select' },
	                                                                        this.state.ClassList.length > 0 && this.state.ClassList.map(function (item, i) {
	                                                                            return _react2.default.createElement(
	                                                                                'option',
	                                                                                { value: item.id },
	                                                                                item.freq_name
	                                                                            );
	                                                                        })
	                                                                    ),
	                                                                    this.validator.message('Class Frequency', this.state.class_frequency, 'required', { className: 'text-danger' })
	                                                                )
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4 input-group-cus' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.min_age != this.state.min_age && 'edited-field' },
	                                                                    'Age Group',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('input', { type: 'text', name: 'min_age',
	                                                                    onChange: this.handleChange,
	                                                                    value: this.state.min_age,
	                                                                    placeholder: '4 to 17 years',
	                                                                    className: 'form-control' }),
	                                                                this.validator.message('Age Group', this.state.min_age, 'required', { className: 'text-danger' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.number_of_trainee != this.state.number_of_trainee && 'edited-field' },
	                                                                    'Number of Coaches',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('input', { type: 'text', name: 'number_of_trainee',
	                                                                    onChange: this.handleChange,
	
	                                                                    value: this.state.number_of_trainee,
	                                                                    className: 'form-control' }),
	                                                                this.validator.message('Number of Coaches', this.state.number_of_trainee, 'required', { className: 'text-danger' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4 input-group-cus' },
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    null,
	                                                                    _react2.default.createElement(
	                                                                        'label',
	                                                                        {
	                                                                            className: edited && (edited_data.from_time != this.state.from_time || edited_data.from_time_cate != this.state.from_time_cate) && 'edited-field' },
	                                                                        'From Timing'
	                                                                    ),
	                                                                    _react2.default.createElement(
	                                                                        'div',
	                                                                        { className: 'custom-select-drop dropdown' },
	                                                                        _react2.default.createElement(
	                                                                            'select',
	                                                                            {
	                                                                                className: 'form-control selectpicker',
	                                                                                onChange: this.handleSelect,
	                                                                                value: this.state.from_time,
	                                                                                name: 'from_time',
	                                                                                title: 'Select'
	                                                                            },
	                                                                            this.state.timingList.length > 0 && this.state.timingList.map(function (item, i) {
	                                                                                return _react2.default.createElement(
	                                                                                    'option',
	                                                                                    { value: item.id },
	                                                                                    item.timing
	                                                                                );
	                                                                            })
	                                                                        ),
	                                                                        this.validator.message('Timing', this.state.from_time, 'required', { className: 'text-danger' })
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    null,
	                                                                    _react2.default.createElement(
	                                                                        'label',
	                                                                        null,
	                                                                        '\xA0'
	                                                                    ),
	                                                                    _react2.default.createElement(
	                                                                        'div',
	                                                                        { className: 'custom-select-drop dropdown' },
	                                                                        _react2.default.createElement(
	                                                                            'select',
	                                                                            {
	                                                                                className: 'form-control selectpicker',
	                                                                                onChange: this.handleSelect,
	                                                                                value: this.state.from_time_cate,
	                                                                                name: 'from_time_cate'
	                                                                            },
	                                                                            _react2.default.createElement(
	                                                                                'option',
	                                                                                { value: 'AM' },
	                                                                                'AM'
	                                                                            ),
	                                                                            _react2.default.createElement(
	                                                                                'option',
	                                                                                { value: 'PM' },
	                                                                                'PM'
	                                                                            )
	                                                                        )
	                                                                    )
	                                                                )
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4 input-group-cus' },
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    null,
	                                                                    _react2.default.createElement(
	                                                                        'label',
	                                                                        {
	                                                                            className: edited && (edited_data.to_time != this.state.to_time || edited_data.to_time_cate != this.state.to_time_cate) && 'edited-field' },
	                                                                        'To Timing'
	                                                                    ),
	                                                                    _react2.default.createElement(
	                                                                        'div',
	                                                                        { className: 'custom-select-drop dropdown' },
	                                                                        _react2.default.createElement(
	                                                                            'select',
	                                                                            {
	                                                                                className: 'form-control selectpicker',
	                                                                                onChange: this.handleSelect,
	                                                                                value: this.state.to_time,
	                                                                                name: 'to_time',
	                                                                                title: 'Select'
	                                                                            },
	                                                                            this.state.timingList.length > 0 && this.state.timingList.map(function (item, i) {
	                                                                                return _react2.default.createElement(
	                                                                                    'option',
	                                                                                    { value: item.id },
	                                                                                    item.timing
	                                                                                );
	                                                                            })
	                                                                        ),
	                                                                        this.validator.message('Timing', this.state.to_time, 'required', { className: 'text-danger' })
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    null,
	                                                                    _react2.default.createElement(
	                                                                        'label',
	                                                                        null,
	                                                                        '\xA0'
	                                                                    ),
	                                                                    _react2.default.createElement(
	                                                                        'div',
	                                                                        { className: 'custom-select-drop dropdown' },
	                                                                        _react2.default.createElement(
	                                                                            'select',
	                                                                            {
	                                                                                className: 'form-control selectpicker',
	                                                                                onChange: this.handleSelect,
	                                                                                value: this.state.to_time_cate,
	                                                                                name: 'to_time_cate'
	                                                                            },
	                                                                            _react2.default.createElement(
	                                                                                'option',
	                                                                                { value: 'AM' },
	                                                                                'AM'
	                                                                            ),
	                                                                            _react2.default.createElement(
	                                                                                'option',
	                                                                                { value: 'PM' },
	                                                                                'PM'
	                                                                            )
	                                                                        )
	                                                                    )
	                                                                )
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.est_year != this.state.establishment_Year && 'edited-field' },
	                                                                    'Establishment Year ',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('input', { type: 'text', name: 'establishment_Year',
	                                                                    value: this.state.establishment_Year,
	                                                                    onChange: this.handleChange, className: 'form-control' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.avg_fee != this.state.avg_anual_fee && 'edited-field' },
	                                                                    'Average Fees(INR) ',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('input', { type: 'text', name: 'avg_anual_fee',
	                                                                    value: this.state.avg_anual_fee,
	                                                                    onChange: this.handleChange, className: 'form-control' }),
	                                                                this.validator.message('Average Fees', this.state.avg_anual_fee, 'required', { className: 'text-danger' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.admit_fee != this.state.addmission_fee && 'edited-field' },
	                                                                    'Admission Fees ',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('input', { type: 'text', name: 'addmission_fee',
	                                                                    value: this.state.addmission_fee,
	                                                                    onChange: this.handleChange, className: 'form-control' }),
	                                                                this.validator.message('Admission Fees', this.state.addmission_fee, 'required', { className: 'text-danger' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.std_ratio != this.state.std_ratio && 'edited-field' },
	                                                                    'Student Ratio',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    { className: 'custom-select-drop dropdown' },
	                                                                    _react2.default.createElement(
	                                                                        'select',
	                                                                        {
	                                                                            value: this.state.std_ratio,
	                                                                            name: 'std_ratio',
	                                                                            id: 'std_ratio',
	                                                                            onChange: this.handleSelect,
	                                                                            className: 'form-control selectpicker',
	                                                                            multiple: true,
	                                                                            title: 'Select'
	                                                                        },
	                                                                        _react2.default.createElement(
	                                                                            'option',
	                                                                            { value: '1' },
	                                                                            'One to One'
	                                                                        ),
	                                                                        _react2.default.createElement(
	                                                                            'option',
	                                                                            { value: '2' },
	                                                                            'One to Many'
	                                                                        ),
	                                                                        _react2.default.createElement(
	                                                                            'option',
	                                                                            { value: '3' },
	                                                                            'NA'
	                                                                        )
	                                                                    ),
	                                                                    this.validator.message('Admission Fees', this.state.addmission_fee, 'required', { className: 'text-danger' })
	                                                                )
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { 'class': 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.has_trail != this.state.has_trail && 'edited-field' },
	                                                                    'Is Free Trial Available? ',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { 'class': 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'select',
	                                                                    {
	                                                                        className: 'form-control selectpicker',
	                                                                        name: 'has_trail',
	                                                                        value: this.state.has_trail,
	                                                                        title: 'Select',
	                                                                        onChange: this.handleSelect },
	                                                                    _react2.default.createElement(
	                                                                        'option',
	                                                                        { value: '0' },
	                                                                        'NA'
	                                                                    ),
	                                                                    _react2.default.createElement(
	                                                                        'option',
	                                                                        { value: '1' },
	                                                                        'Yes'
	                                                                    ),
	                                                                    _react2.default.createElement(
	                                                                        'option',
	                                                                        { value: '2' },
	                                                                        'No'
	                                                                    )
	                                                                ),
	                                                                this.validator.message('Free Trial', this.state.has_trail, 'required', { className: 'text-danger error-msg' })
	                                                            ),
	                                                            this.state.has_trail == 1 && _react2.default.createElement(
	                                                                'div',
	                                                                { 'class': 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.trail_desc != this.state.trail_desc && 'edited-field' },
	                                                                    'Free Trial Description ',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { 'class': 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('textarea', { className: 'form-control', name: 'trail_desc', onChange: this.handleChange, value: this.state.trail_desc }),
	                                                                this.validator.message('Free Trial Descrption', this.state.trail_desc, 'required', { className: 'text-danger error-msg' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.keywords != this.state.keywords && 'edited-field' },
	                                                                    'Keywords',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement(_multiselectReactDropdown.Multiselect, {
	                                                                    isObject: false,
	                                                                    options: this.state.keywordsArr // Options to display in the dropdown
	                                                                    , selectedValues: this.state.keywords // Preselected value to persist in dropdown
	                                                                    , onSelect: this.onSelect // Function will trigger on select event
	                                                                    , onRemove: this.onRemove // Function will trigger on remove event
	                                                                })
	                                                            )
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'box-shadow-custom' },
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'row' },
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'col-md-12 col-xs-12' },
	                                                                _react2.default.createElement(
	                                                                    'span',
	                                                                    { className: 'form-legend' },
	                                                                    'Images'
	                                                                )
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.images != this.state.images && 'edited-field' },
	                                                                    'Banner Image ',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('input', {
	                                                                    type: 'file',
	                                                                    name: 'images',
	                                                                    onChange: this.handleFile,
	                                                                    className: 'form-control'
	                                                                })
	                                                            ),
	                                                            (this.state.edit_image != '' || this.state.tempBanner != '') && _react2.default.createElement(
	                                                                'div',
	                                                                { 'class': 'col-md-2 col-sm-12 mar-btm', id: 'edit_image' },
	                                                                _react2.default.createElement('img', { src: this.state.tempBanner ? this.state.tempBanner : this.state.edit_image, alt: 'Img', 'class': 'img-thumbnail' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { 'class': 'col-md-12 float-left mt-4 p-0' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.photos != this.state.photos && 'edited-field' },
	                                                                    'Gallery Images ',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                )
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { 'class': 'col-md-12 float-left mt-4 p-0' },
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    { 'class': 'col-md-12 margin-bottom-mobile-account float-left image-upload' },
	                                                                    _react2.default.createElement(
	                                                                        'div',
	                                                                        { className: 'upload-wizard' },
	                                                                        _react2.default.createElement(
	                                                                            'div',
	                                                                            { className: 'upload-thumb' },
	                                                                            _react2.default.createElement(
	                                                                                'ul',
	                                                                                { className: 'list-inline' },
	                                                                                this.state.attachment_file.map(function (file_data, index) {
	
	                                                                                    var file_url;
	                                                                                    if (file_data.name) {
	                                                                                        var _url = file_data.image_thumb ? file_data.image_thumb : '';
	                                                                                        if (_url != '') {
	                                                                                            file_url = file_data.image_thumb;
	                                                                                        } else {
	                                                                                            file_url = URL.createObjectURL(file_data);
	                                                                                        }
	                                                                                        // var file_url = URL.createObjectURL(file_data)
	                                                                                        // var file_name = file_data.name
	                                                                                        if (file_data.type === 'application/pdf') {
	                                                                                            var blob = file_url;
	                                                                                            //console.log('blob_url', file_data.name)
	                                                                                            return _react2.default.createElement(
	                                                                                                'li',
	                                                                                                { className: 'previewImg' },
	                                                                                                _react2.default.createElement(
	                                                                                                    'div',
	                                                                                                    { className: 'thumb-img' },
	                                                                                                    _react2.default.createElement('img', {
	                                                                                                        src: file_url,
	                                                                                                        alt: 'image',
	                                                                                                        title: file_data.name
	                                                                                                    })
	                                                                                                ),
	                                                                                                _react2.default.createElement(
	                                                                                                    'a',
	                                                                                                    { href: 'javascript:;', className: 'del-btn', onClick: function onClick() {
	                                                                                                            _this4.removeImage(file_data.name);
	                                                                                                        } },
	                                                                                                    _react2.default.createElement('img', {
	                                                                                                        src: '../../../assets/images/close-icon-white.svg',
	                                                                                                        alt: 'delete'
	                                                                                                    })
	                                                                                                )
	                                                                                            );
	                                                                                        } else {
	                                                                                            return _react2.default.createElement(
	                                                                                                'li',
	                                                                                                { className: 'previewImg' },
	                                                                                                _react2.default.createElement(
	                                                                                                    'div',
	                                                                                                    { className: 'thumb-img' },
	                                                                                                    _react2.default.createElement('img', {
	                                                                                                        src: file_url,
	                                                                                                        alt: 'image',
	                                                                                                        title: file_data.name
	                                                                                                    })
	                                                                                                ),
	                                                                                                _react2.default.createElement(
	                                                                                                    'a',
	                                                                                                    {
	                                                                                                        href: 'javascript:;',
	                                                                                                        className: 'del-btn',
	                                                                                                        onClick: function onClick() {
	                                                                                                            _this4.removeImage(file_data.name);
	                                                                                                        }
	                                                                                                    },
	                                                                                                    _react2.default.createElement('img', {
	                                                                                                        src: '../../../assets/images/close-icon-white.svg',
	                                                                                                        alt: 'delete'
	                                                                                                    })
	                                                                                                )
	                                                                                            );
	                                                                                        }
	                                                                                    }
	                                                                                }),
	                                                                                _react2.default.createElement(
	                                                                                    'li',
	                                                                                    { className: 'addMore' },
	                                                                                    _react2.default.createElement('input', {
	                                                                                        type: 'file',
	                                                                                        name: 'imgInp[]',
	                                                                                        id: 'imgInp2',
	                                                                                        className: 'add_img',
	                                                                                        multiple: true,
	                                                                                        onChange: this.loadFile.bind(this),
	                                                                                        accept: 'image/x-png,image/gif,image/jpeg'
	                                                                                    }),
	                                                                                    _react2.default.createElement(
	                                                                                        'a',
	                                                                                        { href: 'javascript:;', className: 'add-more' },
	                                                                                        _react2.default.createElement(
	                                                                                            'div',
	                                                                                            null,
	                                                                                            _react2.default.createElement('img', { src: '../../../assets/images/upload-icon.svg', alt: 'icon' }),
	                                                                                            'Add more'
	                                                                                        )
	                                                                                    )
	                                                                                )
	                                                                            )
	                                                                        )
	                                                                    ),
	                                                                    this.validator.message('gallery images', this.state.attachment_file, '', { className: 'text-danger error-msg' })
	                                                                )
	                                                            )
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'col-md-12 col-xs-12 btn-bdr' },
	                                                        _react2.default.createElement(
	                                                            'button',
	                                                            { id: 'btnSubmit', className: 'btn btn-primary btn-sm' },
	                                                            'Preview'
	                                                        )
	                                                    )
	                                                )
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    this.preview()
	                )
	            );
	        }
	    }]);
	
	    return verticalCampsEdit;
	}(_react.Component);
	
	exports.default = verticalCampsEdit;

/***/ },
/* 1025 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _FetchCall2 = _interopRequireDefault(_FetchCall);
	
	var _reactJsPagination = __webpack_require__(33);
	
	var _reactJsPagination2 = _interopRequireDefault(_reactJsPagination);
	
	var _bewiseloading = __webpack_require__(48);
	
	var _bewiseloading2 = _interopRequireDefault(_bewiseloading);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var verticalCommunity = function (_Component) {
	  _inherits(verticalCommunity, _Component);
	
	  function verticalCommunity(props) {
	    var _this2 = this,
	        _this$state;
	
	    _classCallCheck(this, verticalCommunity);
	
	    var _this = _possibleConstructorReturn(this, (verticalCommunity.__proto__ || Object.getPrototypeOf(verticalCommunity)).call(this, props));
	
	    _this.getTotal = function () {
	      var location = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	
	      var locationselected = location == '' ? _this.state.location : location;
	
	      var ins = JSON.stringify({
	        vertical: _this.state.tablename,
	        location: locationselected,
	        searchby: _this.state.searchby
	      });
	
	      (0, _FetchCall.getTotal)(ins).then(function (res) {
	
	        _this.setState({ loading: true });
	
	        if (res.status == 1) {
	
	          _this.setState({
	
	            total: res.total
	
	          });
	        }
	      });
	    };
	
	    _this.getList = function () {
	      var pageNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	      var location = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	      var _this$state$auth_data = _this.state.auth_data,
	          login_id = _this$state$auth_data.login_id,
	          role = _this$state$auth_data.role;
	
	
	      _this.setState({ activePage: pageNumber });
	
	      var newOffset = pageNumber == 1 ? 0 : (pageNumber - 1) * _this.state.PER_PAGE % _this.state.total;
	
	      var locationselected = location == '' ? _this.state.location : location;
	
	      var ins = JSON.stringify({
	        vendor_id: login_id,
	        role: role,
	        location: locationselected,
	        searchby: _this.state.searchby,
	        perpage: _this.state.PER_PAGE,
	        offset: newOffset
	      });
	
	      (0, _FetchCall.getCommunityPaged)(ins).then(function (res) {
	
	        _this.setState({ loading: true });
	
	        if (res.status == 1) {
	
	          _this.setState({ loading: !_this.state.loading });
	
	          _this.setState({
	
	            commList: res.data
	
	          });
	        } else {
	
	          _this.setState({ loading: !_this.state.loading });
	
	          _this.setState({
	            commList: []
	          });
	        }
	      });
	    };
	
	    _this.handleSelect = function (e) {
	      _this.setState({ location: e.target.value, activePage: 1 });
	      localStorage.setItem("location", e.target.value);
	      _this.getTotal(e.target.value);
	      _this.getList(1, e.target.value);
	    };
	
	    _this.handleChange = function (e) {
	      _this.setState(_defineProperty({}, e.target.name, e.target.value));
	    };
	
	    _this.searchBy = function (e) {
	
	      _this.setState({ loading: true, activePage: 1 });
	      _this.getTotal();
	      _this.getList(1);
	    };
	
	    _this.schoolExport = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var req, res;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	
	              _this.setState({ exportbtndisabled: true, thisExportBtnText: "exporting..." });
	
	              _context.prev = 1;
	              req = JSON.stringify({
	                location: _this.state.location
	              });
	              _context.next = 5;
	              return (0, _FetchCall.exportSchool)(req);
	
	            case 5:
	              res = _context.sent;
	
	              if (res.status == 1) {
	
	                _this.setState({ exportbtndisabled: false, thisExportBtnText: "Export" });
	                console.log('location_list', res);
	                console.log('location_list', res.path);
	                window.open(res.path);
	
	                // this.setState({
	                //   subscribe_list: res.results,
	                // });
	              }
	
	              _context.next = 12;
	              break;
	
	            case 9:
	              _context.prev = 9;
	              _context.t0 = _context['catch'](1);
	
	              _this.setState({ error: true });
	
	            case 12:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2, [[1, 9]]);
	    }));
	
	    var auth_data = JSON.parse(localStorage.getItem("user_data"));
	    _this.state = (_this$state = {
	      logged: localStorage.getItem("authentication"),
	      auth_data: JSON.parse(localStorage.getItem("user_data")),
	      location: localStorage.getItem("location") ? localStorage.getItem("location") : 'Bengaluru',
	      commList: [],
	      loading: true,
	      searchby: '',
	      activePage: 0,
	      tablename: 'bw_advice_community',
	      PER_PAGE: 15,
	      offset: 0,
	      total: 0
	    }, _defineProperty(_this$state, 'loading', true), _defineProperty(_this$state, 'exportbtndisabled', false), _defineProperty(_this$state, 'thisExportBtnText', 'Export'), _this$state);
	
	    _this.handleSelect = _this.handleSelect.bind(_this);
	    return _this;
	  }
	
	  _createClass(verticalCommunity, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	
	      var THIS = this;
	      (0, _jquery2.default)(document).on('click', '.remove_school', function () {
	        var delete_id = (0, _jquery2.default)(this).data("id");
	
	        if (confirm("You are sure to delete?") == true) {
	
	          var ins = JSON.stringify({
	            id: delete_id,
	            table: 'commnunity'
	          });
	
	          (0, _FetchCall.removethisItem)(ins).then(function (res) {
	
	            THIS.getTotal();
	            THIS.getList();
	          });
	        }
	      });
	
	      this.getTotal();
	      this.getList();
	    }
	  }, {
	    key: 'handlePageChange',
	    value: function handlePageChange(pageNumber) {
	      this.setState({ activePage: pageNumber });
	      this.getList(pageNumber);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          commList = _state.commList,
	          currentPage = _state.currentPage,
	          PER_PAGE = _state.PER_PAGE,
	          total = _state.total,
	          exportbtndisabled = _state.exportbtndisabled;
	
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'col-lg-12 grid-margin stretch-card' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card-body' },
	                _react2.default.createElement(
	                  'h4',
	                  { 'class': 'card-title' },
	                  'Community Supports'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'float-right' },
	                  _react2.default.createElement(
	                    'a',
	                    { href: '/vertical/communitysupports/add', 'class': 'btn btn-primary btn-sm' },
	                    'Add'
	                  ),
	                  ' \xA0',
	                  _react2.default.createElement(
	                    'button',
	                    { disabled: exportbtndisabled, 'class': 'btn btn-primary btn-sm', onClick: function onClick() {
	                        return _this3.schoolExport();
	                      } },
	                    this.state.thisExportBtnText
	                  ),
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'p',
	                  { 'class': 'card-description' },
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'cityselection' },
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'leftaligned bwlabel' },
	                      'City'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'leftaligned' },
	                      _react2.default.createElement(
	                        'select',
	                        { name: 'location', 'class': 'form-control', onChange: function onChange(e) {
	                            return _this3.handleSelect(e);
	                          },
	                          value: this.state.location },
	                        _react2.default.createElement(
	                          'option',
	                          { value: '' },
	                          'select city'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'Bengaluru' },
	                          'Bengaluru'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'Chennai' },
	                          'Chennai'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'Hyderabad' },
	                          'Hyderabad'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'Coimbatore' },
	                          'Coimbatore'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'Hosur' },
	                          'Hosur'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'Indore' },
	                          'Indore'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'Others' },
	                          'Others'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'leftaligned bwlabel' },
	                      'Search'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'leftaligned' },
	                      _react2.default.createElement('input', { type: 'text', name: 'searchby', 'class': 'form-control form-control-sm', onChange: this.handleChange })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'leftaligned' },
	                      _react2.default.createElement(
	                        'button',
	                        { 'class': 'btn btn-primary btn-sm', onClick: this.searchBy },
	                        'Go'
	                      )
	                    )
	                  )
	                ),
	                this.state.loading && _react2.default.createElement(
	                  'div',
	                  { id: 'loader' },
	                  _react2.default.createElement('img', { src: _bewiseloading2.default, width: '60px' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'table-responsive pt-3' },
	                  !this.state.loading && _react2.default.createElement(
	                    'table',
	                    { id: 'tablebw' },
	                    _react2.default.createElement(
	                      'thead',
	                      { 'class': 'thead-dark' },
	                      _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'S.No'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Updated On'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'By'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Name'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'City'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Email Id'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Status'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Action'
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'tbody',
	                      null,
	                      commList.map(function (item, i) {
	
	                        return _react2.default.createElement(
	                          'tr',
	                          null,
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.s_no
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.updated_date
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.updatedby
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.organisation_name
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.location
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.email_id
	                          ),
	                          _react2.default.createElement('td', { dangerouslySetInnerHTML: { __html: item.status } }),
	                          _react2.default.createElement('td', { 'class': 'actionbtns', dangerouslySetInnerHTML: { __html: item.action } })
	                        );
	                      })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'text-center' },
	                    _react2.default.createElement(_reactJsPagination2.default, {
	                      activePage: this.state.activePage,
	                      itemsCountPerPage: PER_PAGE,
	                      totalItemsCount: this.state.total,
	                      pageRangeDisplayed: 5,
	                      activeClass: "pagination__link--active",
	                      onChange: this.handlePageChange.bind(this),
	                      prevPageText: 'previous',
	                      nextPageText: 'next'
	                    })
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return verticalCommunity;
	}(_react.Component);
	
	exports.default = verticalCommunity;

/***/ },
/* 1026 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _FetchCall2 = _interopRequireDefault(_FetchCall);
	
	var _reactstrap = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import { Editor } from '@tinymce/tinymce-react';
	
	
	var verticalCommunityDetail = function (_Component) {
	    _inherits(verticalCommunityDetail, _Component);
	
	    function verticalCommunityDetail(props) {
	        _classCallCheck(this, verticalCommunityDetail);
	
	        var _this = _possibleConstructorReturn(this, (verticalCommunityDetail.__proto__ || Object.getPrototypeOf(verticalCommunityDetail)).call(this, props));
	
	        _this.state = {
	            partyDetails: [],
	            photos_arr: []
	        };
	        _this.id = _this.props.match.params.id;
	        _this.type = _this.props.match.params.type;
	        _this.getEventsInfo = _this.getEventsInfo.bind(_this);
	        _this.getEventsInfo();
	
	        return _this;
	    }
	
	    _createClass(verticalCommunityDetail, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.getEventsInfo();
	        }
	    }, {
	        key: 'UNSAFE_componentWillMount',
	        value: function UNSAFE_componentWillMount() {}
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {}
	    }, {
	        key: 'getEventsInfo',
	        value: function () {
	            var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	                var response, data;
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                _context.next = 2;
	                                return _FetchCall2.default.getAdviceInfo(this.id, this.type);
	
	                            case 2:
	                                response = _context.sent;
	
	                                if (!response) {
	                                    _context.next = 8;
	                                    break;
	                                }
	
	                                data = response.data;
	
	                                this.setState({
	                                    partyDetails: data,
	                                    url: data.url,
	                                    photos_arr: data.photo_arr
	                                });
	
	                                _context.next = 9;
	                                break;
	
	                            case 8:
	                                return _context.abrupt('return', _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    'Error'
	                                ));
	
	                            case 9:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function getEventsInfo() {
	                return _ref.apply(this, arguments);
	            }
	
	            return getEventsInfo;
	        }()
	    }, {
	        key: 'gallery_image',
	        value: function gallery_image() {
	            var _this2 = this;
	
	            var photos = this.state.photos_arr !== undefined ? this.state.photos_arr : [];
	            var rows = "";
	            if (photos.length > 0) {
	                rows = photos.map(function (photos, index) {
	                    if (photos.name) return _react2.default.createElement(
	                        'div',
	                        { 'class': 'col-md-4 float-left mt-4 p-0' },
	                        _react2.default.createElement('img', { src: _this2.state.url + photos.name, alt: 'Img', 'class': 'img-thumbnail' })
	                    );
	                });
	            } else {
	                rows = "";
	            }
	            return rows;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var partyDetails = this.state.partyDetails;
	
	            console.log('partyDetails', this.state);
	            var entatainer = '';
	            if (this.type === 'supplier') {
	                switch (partyDetails.entatainer) {
	                    case "1":
	                        entatainer = 'Birthday party';
	                        break;
	                    case "2":
	                        entatainer = 'Dj';
	                    case "1,2":
	                        entatainer = 'Birthday party, Dj';
	                        break;
	                    default:
	                        entatainer = partyDetails.entatainer;
	                }
	            }
	
	            return _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _react2.default.createElement(
	                    _layout2.default,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { 'class': 'col-lg-12 grid-margin stretch-card' },
	                        _react2.default.createElement(
	                            'div',
	                            { 'class': 'card' },
	                            _react2.default.createElement(
	                                'div',
	                                { 'class': 'card-body' },
	                                _react2.default.createElement(
	                                    'h4',
	                                    { 'class': 'card-title' },
	                                    partyDetails.name,
	                                    ' - View'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'pt-3 detailsection' },
	                                    _react2.default.createElement(
	                                        'form',
	                                        { className: 'custom-form invoice-form col-md-12 col-xs-12 legend-form pad-no' },
	                                        partyDetails.category_id == 122 ? _react2.default.createElement(
	                                            'div',
	                                            { className: 'box-shadow-custom' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'row' },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group col-md-4' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        'Counselor Center'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'p',
	                                                        null,
	                                                        partyDetails.name
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group col-md-4' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        'Designation'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'p',
	                                                        null,
	                                                        partyDetails.designation
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group col-md-4' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        'Service'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'p',
	                                                        null,
	                                                        partyDetails.service
	                                                    )
	                                                )
	                                            )
	                                        ) : '',
	                                        partyDetails.category_id == 123 ? _react2.default.createElement(
	                                            'div',
	                                            { className: 'box-shadow-custom' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'row' },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group col-md-4' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        'Nannies Center'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'p',
	                                                        null,
	                                                        partyDetails.name
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group col-md-4' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        'Age Group'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'p',
	                                                        null,
	                                                        partyDetails.age_grp
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group col-md-4' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        'Time'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'p',
	                                                        null,
	                                                        partyDetails.nannies_time
	                                                    )
	                                                )
	                                            )
	                                        ) : '',
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'box-shadow-custom' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'row' },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'col-md-12 col-xs-12' },
	                                                    _react2.default.createElement(
	                                                        'span',
	                                                        { className: 'form-legend' },
	                                                        'Information'
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group col-md-4' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        'Email Id'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'p',
	                                                        null,
	                                                        partyDetails.email_id
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group col-md-4' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        'Phone No.'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'p',
	                                                        null,
	                                                        partyDetails.phone_number
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group col-md-4' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        'Website '
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'p',
	                                                        null,
	                                                        partyDetails.website
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group col-md-4' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        'Location'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'p',
	                                                        null,
	                                                        partyDetails.location
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group col-md-4' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        'Facebook'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'p',
	                                                        null,
	                                                        partyDetails.facebook
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group col-md-4' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        'Twitter'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'p',
	                                                        null,
	                                                        partyDetails.twitter
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group col-md-4' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        'Mode of Payment'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'p',
	                                                        null,
	                                                        partyDetails.payment_name
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group col-md-4' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        'Year Established'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'p',
	                                                        null,
	                                                        partyDetails.est_year
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group col-md-4' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        'Website Search Keywords'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'p',
	                                                        null,
	                                                        partyDetails.keywords
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group col-md-4' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        'Address'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'p',
	                                                        null,
	                                                        partyDetails.address
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group col-md-4' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        'Google location Address'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'p',
	                                                        null,
	                                                        partyDetails.google_location
	                                                    )
	                                                ),
	                                                partyDetails.vendor_id == 1 && _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group col-md-4' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        'Partner Type'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'p',
	                                                        null,
	                                                        partyDetails.partner_type == 1 ? 'Institution' : 'Individual'
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group col-md-12' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        'About'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'p',
	                                                        null,
	                                                        partyDetails.about
	                                                    )
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'box-shadow-custom' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'row' },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'col-md-12 col-xs-12' },
	                                                    _react2.default.createElement(
	                                                        'span',
	                                                        { className: 'form-legend' },
	                                                        'Images'
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group col-md-4' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        'Banner '
	                                                    ),
	                                                    partyDetails.images && _react2.default.createElement('img', { src: partyDetails.url + partyDetails.images, alt: 'Img', 'class': 'img-thumbnail' })
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { 'class': 'col-md-12 float-left mt-4 p-0' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        'Gallery Images'
	                                                    )
	                                                ),
	                                                this.gallery_image()
	                                            )
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'row' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'col-md-12' },
	                                        _react2.default.createElement(
	                                            'button',
	                                            { 'class': 'btn btn-primary btn-sm', onClick: this.openPartnerCreate },
	                                            'Create Partner'
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    _reactstrap.Modal,
	                                    { isOpen: this.state.partnercreation, size: 'lg', className: 'partnercreation-pop' },
	                                    _react2.default.createElement(
	                                        _reactstrap.ModalBody,
	                                        { className: 'p-0' },
	                                        _react2.default.createElement(
	                                            _reactstrap.Row,
	                                            { className: 'pv-section' },
	                                            _react2.default.createElement(
	                                                _reactstrap.Col,
	                                                { className: '', md: '12' },
	                                                _react2.default.createElement(
	                                                    'h3',
	                                                    null,
	                                                    'Partner Creation Info'
	                                                ),
	                                                _react2.default.createElement('br', null),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { 'class': 'form-row' },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { 'class': 'form-group col-md-6' },
	                                                        _react2.default.createElement(
	                                                            'label',
	                                                            { 'for': 'inputEmail4' },
	                                                            'Organization Name'
	                                                        ),
	                                                        _react2.default.createElement('input', { type: 'text', 'class': 'form-control', id: 'organisation_name', name: 'organisation_name', placeholder: 'Organization Name', onChange: this.handleChange })
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { 'class': 'form-group col-md-6' },
	                                                        _react2.default.createElement(
	                                                            'label',
	                                                            { 'for': 'inputPassword4' },
	                                                            'Username'
	                                                        ),
	                                                        _react2.default.createElement('input', { type: 'text', 'class': 'form-control', id: 'username', name: 'username', placeholder: 'Username', onChange: this.handleChange })
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { 'class': 'form-row' },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { 'class': 'form-group col-md-6' },
	                                                        _react2.default.createElement(
	                                                            'label',
	                                                            { 'for': 'inputAddress' },
	                                                            'First Name'
	                                                        ),
	                                                        _react2.default.createElement('input', { type: 'text', 'class': 'form-control', id: 'first_name', name: 'first_name', placeholder: 'First Name', onChange: this.handleChange })
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { 'class': 'form-group col-md-6' },
	                                                        _react2.default.createElement(
	                                                            'label',
	                                                            { 'for': 'inputAddress2' },
	                                                            'Last Name'
	                                                        ),
	                                                        _react2.default.createElement('input', { type: 'text', 'class': 'form-control', id: 'last_name', name: 'last_name', placeholder: 'Last Name', onChange: this.handleChange })
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { 'class': 'form-row' },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { 'class': 'form-group col-md-6' },
	                                                        _react2.default.createElement(
	                                                            'label',
	                                                            { 'for': 'inputAddress' },
	                                                            'Amount Received'
	                                                        ),
	                                                        _react2.default.createElement('input', { type: 'text', 'class': 'form-control', id: 'amountrecevied', name: 'amount', placeholder: 'Amount', onChange: this.handleChange })
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { 'class': 'form-group col-md-6' },
	                                                        _react2.default.createElement(
	                                                            'label',
	                                                            { 'for': 'inputAddress2' },
	                                                            'Payment Link'
	                                                        ),
	                                                        _react2.default.createElement('input', { type: 'text', 'class': 'form-control', id: 'razorpay_payment_id', name: 'razorpay_payment_id', placeholder: 'Payment Link', onChange: this.handleChange })
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { 'class': 'form-row' },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { 'class': 'form-group col-md-4' },
	                                                        _react2.default.createElement(
	                                                            'label',
	                                                            { 'for': 'inputState' },
	                                                            'Extend'
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'select',
	                                                            { id: 'inputState', 'class': 'form-control', name: 'enddate', onChange: this.handleChange },
	                                                            _react2.default.createElement(
	                                                                'option',
	                                                                { selected: true },
	                                                                'Choose...'
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'option',
	                                                                { value: '2023-06-30' },
	                                                                'June 2023'
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'option',
	                                                                { value: '2023-07-31' },
	                                                                'July 2023'
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'option',
	                                                                { value: '2023-08-30' },
	                                                                'August 2023'
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'option',
	                                                                { value: '2023-09-31' },
	                                                                'Sep 2023'
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'option',
	                                                                { value: '2023-10-30' },
	                                                                'Oct 2023'
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'option',
	                                                                { value: '2023-11-31' },
	                                                                'Nov 2023'
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'option',
	                                                                { value: '2023-12-30' },
	                                                                'Dec 2023'
	                                                            )
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { 'class': 'form-group col-md-4' },
	                                                        _react2.default.createElement(
	                                                            'label',
	                                                            { 'for': 'inputState' },
	                                                            'Plan'
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'select',
	                                                            { id: 'inputState', 'class': 'form-control', name: 'plan', onChange: this.handleChange },
	                                                            _react2.default.createElement(
	                                                                'option',
	                                                                { selected: true },
	                                                                'Choose...'
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'option',
	                                                                { value: '3' },
	                                                                'Value Pro'
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'option',
	                                                                { value: '4' },
	                                                                'Magic'
	                                                            )
	                                                        )
	                                                    )
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactstrap.Row,
	                                            { className: 'pv-section' },
	                                            _react2.default.createElement(
	                                                _reactstrap.Col,
	                                                { className: '', md: '12' },
	                                                _react2.default.createElement(
	                                                    'button',
	                                                    { className: 'btn btn-sm btn-primary custome-submit', onClick: this.handleCreateSubmit },
	                                                    'Submit'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'button',
	                                                    { className: 'btn btn-sm btn-defult custome-submit', style: { marginLeft: '10px' },
	                                                        onClick: function onClick() {
	                                                            _this3.setState({ partnercreation: false });
	                                                        } },
	                                                    'Close'
	                                                )
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return verticalCommunityDetail;
	}(_react.Component);
	
	exports.default = verticalCommunityDetail;

/***/ },
/* 1027 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _FetchCall2 = _interopRequireDefault(_FetchCall);
	
	var _constant = __webpack_require__(21);
	
	var _reactstrap = __webpack_require__(17);
	
	var _reactGeocode = __webpack_require__(55);
	
	var _reactGeocode2 = _interopRequireDefault(_reactGeocode);
	
	var _multiselectReactDropdown = __webpack_require__(73);
	
	var _simpleReactValidator = __webpack_require__(28);
	
	var _simpleReactValidator2 = _interopRequireDefault(_simpleReactValidator);
	
	__webpack_require__(18);
	
	var _reactNotifications = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import { Editor } from '@tinymce/tinymce-react';
	
	
	_reactGeocode2.default.setApiKey("AIzaSyA9MtbfG_zlo64B2lqNMvigTBuXHkagKcE");
	_reactGeocode2.default.setLanguage("en");
	_reactGeocode2.default.setRegion("es");
	_reactGeocode2.default.enableDebug();
	var services = [{ "id": 1, "service": "Student Placement Counselling" }, { "id": 2, "service": "Learning Disability and Attention Deficit" }, { "id": 11, "service": "Higher Education Counselling" }, { "id": 12, "service": "Career Counselling" }, { "id": 13, "service": "Study Abroad Counselling" }, { "id": 14, "service": "Teen Counselling" }, { "id": 15, "service": "Child Counselling" }, { "id": 16, "service": "NA" }];
	var Payments = [{ "id": 1, "payment_name": "Cash" }, { "id": 2, "payment_name": "Card" }, { "id": 3, "payment_name": "Cheque" }, { "id": 4, "payment_name": "Online Payments" }, { "id": 5, "payment_name": "NA" }];
	var AgeGroup = [{ "id": 1, "name": "0 to 3 yrs" }, { "id": 2, "name": "4 to 8 yrs" }];
	var timings = [{ "id": 3, "name": "Part Time" }, { "id": 4, "name": "Full Time" }];
	
	var locations = [{ "id": 1, "location": "Bengaluru", "latitude": "12.9716", "longitude": "77.5946", "status": 1, "sort_order": 1 }, { "id": 12, "location": "Chennai", "latitude": "13.0569", "longitude": "80.2425", "status": 1, "sort_order": 2 }, { "id": 11, "location": "Coimbatore", "latitude": "11.0168", "longitude": "76.9558", "status": 1, "sort_order": 3 }, { "id": 2, "location": "Hyderabad", "latitude": "17.3850", "longitude": "78.4867", "status": 1, "sort_order": 4 }, { "id": 27, "location": "Hosur", "latitude": "12.7409", "longitude": "77.8253", "status": 1, "sort_order": 4 }, { "id": 24, "location": "Madurai", "latitude": "9.9252", "longitude": "78.1198", "status": 1, "sort_order": 5 }, { "id": 13, "location": "Mumbai", "latitude": "19.0760", "longitude": "72.8777", "status": 1, "sort_order": 7 }, { "id": 15, "location": "Kolkata", "latitude": "22.5726", "longitude": "88.3639", "status": 1, "sort_order": 8 }, { "id": 16, "location": "New Delhi", "latitude": "28.6139", "longitude": "77.2090", "status": 1, "sort_order": 9 }, { "id": 17, "location": "Jaipur", "latitude": "26.9124", "longitude": "75.7873", "status": 1, "sort_order": 10 }, { "id": 18, "location": "Chandigarh", "latitude": "30.7333", "longitude": "76.7794", "status": 1, "sort_order": 11 }, { "id": 19, "location": "Pune", "latitude": "18.5204", "longitude": "73.8567", "status": 1, "sort_order": 12 }, { "id": 20, "location": "Kochi", "latitude": "9.9312", "longitude": "76.2673", "status": 1, "sort_order": 13 }, { "id": 21, "location": "Noida", "latitude": "28.5355", "longitude": "77.3910", "status": 1, "sort_order": 14 }, { "id": 22, "location": "Agra", "latitude": "27.1767", "longitude": "78.0081", "status": 1, "sort_order": 15 }, { "id": 23, "location": "Puducherry", "latitude": "11.9416", "longitude": "79.8083", "status": 1, "sort_order": 16 }, { "id": 25, "location": "Tiruchirappalli", "latitude": "10.7905", "longitude": "78.7047", "status": 1, "sort_order": 17 }, { "id": 26, "location": "Indore", "latitude": "22.719568", "longitude": "75.857727", "status": 1, "sort_order": 18 }];
	
	var verticalCommunityEdit = function (_Component) {
	    _inherits(verticalCommunityEdit, _Component);
	
	    function verticalCommunityEdit(props) {
	        _classCallCheck(this, verticalCommunityEdit);
	
	        var _this = _possibleConstructorReturn(this, (verticalCommunityEdit.__proto__ || Object.getPrototypeOf(verticalCommunityEdit)).call(this, props));
	
	        _this.getKeywords = function () {
	            (0, _FetchCall.commonAPI)(JSON.stringify({ url: 'get_site_keywords', vertical: 'community' })).then(function (res) {
	                if (res.status === 1) {
	                    _this.setState({
	                        keywordsArr: res.results
	                    });
	                }
	            });
	        };
	
	        _this.validateMail = function (value, catgry, vendr_id, pageid) {
	            var _JSON$stringify;
	
	            var name = 'email_id';
	            var type_name = 'isEmailValid';
	            var req = JSON.stringify((_JSON$stringify = {}, _defineProperty(_JSON$stringify, name, value), _defineProperty(_JSON$stringify, 'category', catgry), _defineProperty(_JSON$stringify, 'vendor_id', vendr_id), _defineProperty(_JSON$stringify, 'pageid', pageid), _JSON$stringify));
	            var res = (0, _FetchCall.emailExist_check)(req).then(function (res) {
	                console.log('valuee', res);
	                if (res.status === 1) {
	                    _this.setState(_defineProperty({}, type_name, false));
	                } else {
	                    // return res.status;
	                    _this.setState(_defineProperty({}, type_name, true));
	                }
	            });
	        };
	
	        _this.handleSelect = function (e) {
	            var propName = e.target.name;
	            var value = [].concat(_toConsumableArray(e.target.selectedOptions)).map(function (item) {
	                return item.value;
	            });
	
	            _this.setState(_defineProperty({}, propName, value));
	        };
	
	        _this.handleChange = function (e) {
	            _this.setState(_defineProperty({}, e.target.name, e.target.value));
	            _this.clearValidationErr(e.target.name);
	            if (e.target.name == 'google_location') _this.Geocode_location();
	            var propName = e.target.name;
	            // if (propName == 'email_id') {
	            //     this.validateMail(e.target.value, 121, this.state.vendor_id, this.state.pageid);
	            // }
	        };
	
	        _this.onSelect = function (selectedList) {
	            var keywords = [];
	            selectedList.map(function (item, i) {
	                keywords.push(item);
	            });
	            _this.setState({
	                keywords: keywords
	            });
	        };
	
	        _this.onRemove = function (selectedList, removedItem) {
	            var keywords = [];
	            selectedList.map(function (item, i) {
	                keywords.push(item);
	            });
	            _this.setState({
	                keywords: keywords
	            });
	        };
	
	        _this.handleFile = function (e) {
	            // this.Geocode_location();
	            var propName = e.target.name;
	            var files = e.target.files[0];
	            _this.setState(_defineProperty({}, propName, files));
	            var reader = new FileReader();
	            var img = '';
	            var THIS = _this;
	            reader.addEventListener("load", function () {
	                // convert image file to base64 string
	                img = reader.result;
	                THIS.setState({
	                    tempBanner: reader.result
	                });
	            }, false);
	
	            if (files) {
	                reader.readAsDataURL(files);
	            } else {
	                THIS.setState({
	                    tempBanner: ''
	                });
	            }
	        };
	
	        _this.handleFileMultiple = function (e) {
	            _this.setState(_defineProperty({}, e.target.name, e.target.files));
	        };
	
	        _this.removeImage = function (e) {
	            var delete_array = _this.state.delete_array;
	            delete_array.push(e);
	            var updated = _this.state.attachment_file.filter(function (item) {
	                return item.name !== e;
	            });
	            _this.setState({
	                attachment_file: updated,
	                delete_array: delete_array
	            });
	        };
	
	        _this.handlePreview = function (e) {
	            e.preventDefault();
	            if (_this.validator.allValid()) {
	                _this.setState({
	                    preview: true
	                });
	            } else {
	                _this.validator.showMessages();
	                _this.forceUpdate();
	            }
	        };
	
	        _this.preview = function () {
	            return _react2.default.createElement(
	                _reactstrap.Modal,
	                { isOpen: _this.state.preview, size: 'lg', className: 'preview-pop' },
	                _react2.default.createElement(
	                    _reactstrap.ModalBody,
	                    { className: 'p-0' },
	                    _react2.default.createElement(
	                        _reactstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactstrap.Col,
	                            { md: '12' },
	                            _react2.default.createElement('img', { src: '/assets/images/user-header.png', className: 'preview-header' })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactstrap.Row,
	                        { className: 'pv-banner' },
	                        _react2.default.createElement(
	                            _reactstrap.Col,
	                            { className: 'pv-banner-bg', md: '12' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'title-section' },
	                                _react2.default.createElement(
	                                    'p',
	                                    { className: 'banner-title' },
	                                    _this.state.name
	                                ),
	                                _react2.default.createElement(
	                                    'p',
	                                    { className: 'banner-address' },
	                                    _this.state.address
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactstrap.Row,
	                        { className: 'pv-section' },
	                        _react2.default.createElement(
	                            _reactstrap.Col,
	                            { className: '', md: '12' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'title-section' },
	                                _react2.default.createElement(
	                                    'h4',
	                                    null,
	                                    'About the School'
	                                ),
	                                _react2.default.createElement(
	                                    'p',
	                                    { className: '' },
	                                    _this.state.about_school
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactstrap.Row,
	                        { className: 'pv-section' },
	                        _react2.default.createElement(
	                            _reactstrap.Col,
	                            { className: '', md: '12' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'title-section' },
	                                _react2.default.createElement(
	                                    'h4',
	                                    null,
	                                    'Key Information'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'row' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-4' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'type-n7ngd' },
	                                            _react2.default.createElement(
	                                                'b',
	                                                null,
	                                                'Email Id'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'key-po' },
	                                            _react2.default.createElement(
	                                                'p',
	                                                null,
	                                                _this.state.email_id
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-4' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'type-n7ngd' },
	                                            _react2.default.createElement(
	                                                'b',
	                                                null,
	                                                'Mode of Payment'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'key-po' },
	                                            _react2.default.createElement(
	                                                'p',
	                                                null,
	                                                _this.state.mopList.map(function (item) {
	                                                    if (item.id == _this.state.mode_of_payment) {
	                                                        return item.payment_name;
	                                                    }
	                                                })
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-4' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'type-n7ngd' },
	                                            _react2.default.createElement(
	                                                'b',
	                                                null,
	                                                'Establishment Year'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'key-po' },
	                                            _react2.default.createElement(
	                                                'p',
	                                                null,
	                                                _this.state.established_year
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-4' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'type-n7ngd' },
	                                            _react2.default.createElement(
	                                                'b',
	                                                null,
	                                                'Avg Fee'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'key-po' },
	                                            _react2.default.createElement(
	                                                'p',
	                                                null,
	                                                parseFloat(_this.state.avg_anual_fee) > 0 ? _this.state.avg_anual_fee + '/Month' : 'NA'
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-4' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'type-n7ngd' },
	                                            _react2.default.createElement(
	                                                'b',
	                                                null,
	                                                'Facebook'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'key-po' },
	                                            _react2.default.createElement(
	                                                'p',
	                                                null,
	                                                _this.state.facebook
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-4' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'type-n7ngd' },
	                                            _react2.default.createElement(
	                                                'b',
	                                                null,
	                                                'Twitter'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'key-po' },
	                                            _react2.default.createElement(
	                                                'p',
	                                                null,
	                                                _this.state.twitter
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-4' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'type-n7ngd' },
	                                            _react2.default.createElement(
	                                                'b',
	                                                null,
	                                                'Phone No'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'key-po' },
	                                            _react2.default.createElement(
	                                                'p',
	                                                null,
	                                                _this.state.phone_number
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactstrap.Row,
	                        { className: 'pv-section' },
	                        _react2.default.createElement(
	                            _reactstrap.Col,
	                            { className: '', md: '12' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'title-section' },
	                                _react2.default.createElement(
	                                    'h4',
	                                    null,
	                                    'Gallery'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'row' },
	                                    _this.state.attachment_file.map(function (item) {
	                                        console.log('********', item);
	                                        if (item.image_thumb) {
	                                            return _react2.default.createElement(
	                                                'div',
	                                                { className: 'col-md-4' },
	                                                _react2.default.createElement('img', { src: item.image_thumb, className: 'preview-image' })
	                                            );
	                                        } else if (item.name) {
	                                            var file_url = URL.createObjectURL(item);
	                                            return _react2.default.createElement(
	                                                'div',
	                                                { className: 'col-md-4' },
	                                                _react2.default.createElement('img', { src: file_url, className: 'preview-image' })
	                                            );
	                                        }
	                                    }),
	                                    _this.state.attachment_file.length === 0 && _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-4' },
	                                        'No Gallery Images Found'
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactstrap.Row,
	                        { className: 'pv-section' },
	                        _react2.default.createElement(
	                            _reactstrap.Col,
	                            { className: '', md: '12' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'title-section' },
	                                _react2.default.createElement(
	                                    'h4',
	                                    null,
	                                    'Contact Information'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'row' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-4' },
	                                        'Email Id : ',
	                                        _this.state.email_id
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-4' },
	                                        'Contact : ',
	                                        _this.state.phone_number
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-4' },
	                                        'Website : ',
	                                        _this.state.website
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactstrap.Row,
	                        { className: 'pv-section' },
	                        _react2.default.createElement(
	                            _reactstrap.Col,
	                            { className: '', md: '12' },
	                            _react2.default.createElement(
	                                'button',
	                                { className: 'btn btn-sm btn-primary custome-submit', onClick: _this.handleSubmit },
	                                _this.state.edited && _this.state.role == 1 ? 'Approve' : 'Submit'
	                            ),
	                            _this.state.edited && _this.state.role == 1 && _react2.default.createElement(
	                                'button',
	                                { className: 'btn btn-sm btn-danger custome-submit', style: { marginLeft: '10px' },
	                                    onClick: _this.handleReject },
	                                'Reject'
	                            ),
	                            _react2.default.createElement(
	                                'button',
	                                { className: 'btn btn-sm btn-defult custome-submit', style: { marginLeft: '10px' },
	                                    onClick: function onClick() {
	                                        _this.setState({ preview: false });
	                                    } },
	                                'Close'
	                            )
	                        )
	                    )
	                )
	            );
	        };
	
	        _this.handleReject = function (e) {
	            e.preventDefault();
	            var req = JSON.stringify({
	                id: _this.state.getId
	            });
	            var toastr = '';
	            (0, _FetchCall.communityReject)(req).then(function (res) {
	                if (res.status === 1) {
	                    toastr = window.toastr.success;
	                    toastr('success', {
	                        positionClass: "toast-bottom-right",
	                        containerId: "toast-bottom-right"
	                    });
	                    window.location.href = document.referrer;
	                }
	            });
	        };
	
	        _this.handleSubmit = function (e) {
	            e.preventDefault();
	            if (_this.validator.allValid()) {
	                var subData = {
	                    login_id: _this.state.login_id,
	                    designation: _this.state.designation,
	                    service: _this.state.service,
	                    name: _this.state.name,
	                    age_grp: _this.state.age_group,
	                    address: _this.state.address,
	                    email_id: _this.state.email_id,
	                    phone_no: _this.state.phone_number,
	                    website: _this.state.website,
	                    location: _this.state.location,
	                    google_location: _this.state.google_location,
	                    fb: _this.state.facebook,
	                    twitter: _this.state.twitter,
	                    mop: _this.state.mode_of_payment,
	                    established_year: _this.state.established_year,
	                    time: _this.state.time,
	                    about: _this.state.about,
	                    images: _this.state.images,
	                    category: _this.state.category,
	                    getId: _this.state.getId,
	                    photos: _this.state.attachment_file,
	                    latitude: _this.state.latitude,
	                    longitude: _this.state.longitude,
	                    other_rating: _this.state.other_rating,
	                    sub_category: 122,
	                    keywords: _this.state.keywords ? _this.state.keywords.join(';') : '',
	                    delete_array: _this.state.delete_array,
	                    partner_type: _this.state.partner_type,
	                    role: _this.state.role
	                    // jQuery("#btnSubmit").attr('disabled', true);
	                };(0, _FetchCall.AddNannier)(subData).then(function (res) {
	
	                    if (res.status === 1) {
	
	                        _reactNotifications.NotificationManager.success(res.message);
	                        window.location.href = document.referrer;
	                    } else {
	                        (0, _jquery2.default)("#btnSubmit").attr('disabled', false);
	
	                        _reactNotifications.NotificationManager.error('Something went wrong. try again!...');
	                    }
	                });
	            } else {
	                _this.validator.showMessages();
	                _this.forceUpdate();
	            }
	        };
	
	        _this.state = {
	            vendor_id: 1,
	            pageid: '',
	            category: 121,
	            about: '',
	            address: '',
	            age_group: '',
	            designation: '',
	            service: '',
	            email_id: '',
	            errors: [],
	            established_year: '',
	            facebook: '',
	            google_location: '',
	            images: '',
	            location: 'Bengaluru',
	            mode_of_payment: '',
	            name: '',
	            phone_number: '',
	            time: 3,
	            twitter: '',
	            website: '',
	            mopList: Payments,
	            ageGroup: AgeGroup,
	            timeList: timings,
	            getService: services,
	            getId: _this.props.match.params.id ? _this.props.match.params.id : '',
	            latitude: '',
	            longitude: '',
	            other_rating: '',
	            categoryTypeList: [],
	            subTypes: false,
	            sub_category: '',
	            attachment_file: [],
	            attachment_file_length: 0,
	            attachment_fileName: [],
	            delete_array: [],
	            edit_image: '',
	            tempBanner: '',
	            partner_type: '',
	            preview: false,
	            edited_data: [],
	            keywordsArr: [],
	            edited: false,
	            location_list: locations
	        };
	        _this.validator = new _simpleReactValidator2.default({
	            validators: {
	                checkExist: { // name the rule
	                    message: 'The :attribute field is required.',
	                    rule: function rule(val, params, validator) {
	                        if (val == '' && _this.state.edit_image == '') {
	                            return false;
	                        }
	                    },
	                    messageReplace: function messageReplace(message, params) {
	                        return message.replace(':values', _this.helpers.toSentence(params));
	                    }, // optional
	                    required: true // optional
	                },
	                emailExist_check: { // name the rule
	                    message: 'The :attribute Already Exist.',
	                    rule: function rule(val, params, validator) {
	                        return _this.state.isEmailValid;
	                    },
	                    messageReplace: function messageReplace(message, params) {
	                        return message.replace(':values', _this.helpers.toSentence(params));
	                    }, // optional
	                    required: true // optional
	                },
	                checkMobile: _constant.MOBILE_REGEX,
	                checkUrl: _constant.URL_REGEX
	            }
	        });
	        _this.getKeywords();
	        //this.getpayment_type(); 
	        //this.getNanniesList(); 
	        //this.getService();
	        _this.loadFile = _this.loadFile.bind(_this);
	        return _this;
	    }
	
	    _createClass(verticalCommunityEdit, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            if (this.state.getId) {
	                this.getevent();
	            }
	            console.log(this.props.match.params.nadd);
	            if (this.props.match.params.nadd == 122) {
	
	                this.Cat_type();
	            }
	            var user_data = localStorage.getItem("user_data");
	            var auth_data = JSON.parse(user_data);
	            var vendor_id = auth_data.login_id;
	            this.setState({
	                login_id: vendor_id,
	                role: auth_data.role
	            });
	        }
	    }, {
	        key: 'getevent',
	        value: function () {
	            var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	                var response, data, edited_data;
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                _context.next = 2;
	                                return (0, _FetchCall.communityEdit)(JSON.stringify({ id: this.state.getId }));
	
	                            case 2:
	                                response = _context.sent;
	
	                                // console.log(response);
	                                if (response.status == 1) {
	                                    data = response.data, edited_data = response.original;
	
	                                    this.setState({
	                                        pageid: data.id,
	                                        designation: data.designation,
	                                        service: data.service != null ? data.service.toString().split(',') : [],
	                                        name: data.name,
	                                        address: data.address,
	                                        email_id: data.email_id,
	                                        phone_number: data.phone_no,
	                                        website: data.website,
	                                        location: data.location,
	                                        google_location: data.google_location,
	                                        facebook: data.fb,
	                                        twitter: data.twitter,
	                                        mode_of_payment: data.mop,
	                                        established_year: data.established_year,
	                                        time: data.time,
	                                        about: data.about,
	                                        images: data.images,
	                                        photos: data.photos,
	                                        other_rating: data.other_rating,
	                                        longitude: data.longitude,
	                                        latitude: data.latitude,
	                                        sub_category: data.sub_category.toString().split(','),
	                                        keywords: data.keywords ? data.keywords.split(';') : [],
	                                        attachment_file: data.photo_arr,
	                                        edit_image: data.images ? data.url + data.images : '',
	                                        partner_type: data.partner_type,
	                                        edited: data.edited,
	                                        edited_data: edited_data
	                                    });
	                                    this.Geocode_location(data.google_location);
	                                }
	
	                            case 4:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function getevent() {
	                return _ref.apply(this, arguments);
	            }
	
	            return getevent;
	        }()
	    }, {
	        key: 'Cat_type',
	        value: function () {
	            var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	                var response;
	                return _regenerator2.default.wrap(function _callee2$(_context2) {
	                    while (1) {
	                        switch (_context2.prev = _context2.next) {
	                            case 0:
	                                _context2.next = 2;
	                                return _FetchCall2.default.getSubCategory(this.props.match.params.nadd);
	
	                            case 2:
	                                response = _context2.sent;
	
	                                if (response.status == 1) {
	                                    this.setState({ categoryTypeList: response.results, subTypes: true });
	                                } else {
	                                    this.setState({ noCategory: false, subTypes: false });
	                                }
	
	                            case 4:
	                            case 'end':
	                                return _context2.stop();
	                        }
	                    }
	                }, _callee2, this);
	            }));
	
	            function Cat_type() {
	                return _ref2.apply(this, arguments);
	            }
	
	            return Cat_type;
	        }()
	    }, {
	        key: 'getpayment_type',
	        value: function () {
	            var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	                var response;
	                return _regenerator2.default.wrap(function _callee3$(_context3) {
	                    while (1) {
	                        switch (_context3.prev = _context3.next) {
	                            case 0:
	                                _context3.next = 2;
	                                return _FetchCall2.default.getSchoolListDatas('payment_type');
	
	                            case 2:
	                                response = _context3.sent;
	
	                                // console.log(response);
	                                if (response) {
	                                    this.setState({ mopList: response.results });
	                                }
	
	                            case 4:
	                            case 'end':
	                                return _context3.stop();
	                        }
	                    }
	                }, _callee3, this);
	            }));
	
	            function getpayment_type() {
	                return _ref3.apply(this, arguments);
	            }
	
	            return getpayment_type;
	        }()
	    }, {
	        key: 'getNanniesList',
	        value: function () {
	            var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4() {
	                var response;
	                return _regenerator2.default.wrap(function _callee4$(_context4) {
	                    while (1) {
	                        switch (_context4.prev = _context4.next) {
	                            case 0:
	                                _context4.next = 2;
	                                return _FetchCall2.default.getNanniesList('nannies');
	
	                            case 2:
	                                response = _context4.sent;
	
	                                // console.log(response);
	                                if (response) {
	                                    this.setState({ ageGroup: response.results, timeList: response.time });
	                                }
	
	                            case 4:
	                            case 'end':
	                                return _context4.stop();
	                        }
	                    }
	                }, _callee4, this);
	            }));
	
	            function getNanniesList() {
	                return _ref4.apply(this, arguments);
	            }
	
	            return getNanniesList;
	        }()
	    }, {
	        key: 'getService',
	        value: function () {
	            var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5() {
	                var response;
	                return _regenerator2.default.wrap(function _callee5$(_context5) {
	                    while (1) {
	                        switch (_context5.prev = _context5.next) {
	                            case 0:
	                                _context5.next = 2;
	                                return _FetchCall2.default.getSchoolListDatas('services');
	
	                            case 2:
	                                response = _context5.sent;
	
	                                // console.log(response);
	                                if (response) {
	                                    this.setState({ getService: response.results });
	                                }
	
	                            case 4:
	                            case 'end':
	                                return _context5.stop();
	                        }
	                    }
	                }, _callee5, this);
	            }));
	
	            function getService() {
	                return _ref5.apply(this, arguments);
	            }
	
	            return getService;
	        }()
	    }, {
	        key: 'UNSAFE_componentWillMount',
	        value: function UNSAFE_componentWillMount() {}
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            window.jQuery('.selectpicker').selectpicker('refresh');
	        }
	    }, {
	        key: 'showValidationErr',
	        value: function showValidationErr(elm, msg) {
	            this.setState(function (prevState) {
	                return { errors: [].concat(_toConsumableArray(prevState.errors), [{ elm: elm, msg: msg }]) };
	            });
	        }
	    }, {
	        key: 'clearValidationErr',
	        value: function clearValidationErr(elm) {
	            var _this2 = this;
	
	            this.setState(function (prevState) {
	                var newArr = [];
	                var _iteratorNormalCompletion = true;
	                var _didIteratorError = false;
	                var _iteratorError = undefined;
	
	                try {
	                    for (var _iterator = _this2.state.errors[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                        var err = _step.value;
	
	                        if (elm !== err.elm) {
	                            newArr.push(err);
	                        }
	                    }
	                } catch (err) {
	                    _didIteratorError = true;
	                    _iteratorError = err;
	                } finally {
	                    try {
	                        if (!_iteratorNormalCompletion && _iterator.return) {
	                            _iterator.return();
	                        }
	                    } finally {
	                        if (_didIteratorError) {
	                            throw _iteratorError;
	                        }
	                    }
	                }
	
	                return { errors: newArr };
	            });
	        }
	    }, {
	        key: 'Geocode_location',
	        value: function Geocode_location() {
	            var _this3 = this;
	
	            var location = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	            _reactGeocode2.default.fromAddress(location ? location : this.state.google_location).then(function (response) {
	                var _response$results$0$g = response.results[0].geometry.location,
	                    lat = _response$results$0$g.lat,
	                    lng = _response$results$0$g.lng;
	
	                if (lat && lng) _this3.get_location(lat, lng);
	            }, function (error) {
	                console.error(error);
	            });
	        }
	    }, {
	        key: 'get_location',
	        value: function get_location(lat, lng) {
	            this.setState({
	                latitude: lat,
	                longitude: lng
	            });
	        }
	    }, {
	        key: 'remove_img',
	        value: function remove_img() {
	            (0, _jquery2.default)('#edit_image').remove();
	        }
	    }, {
	        key: 'loadFile',
	        value: function loadFile(e) {
	            var files = e.target.files;
	            this.setState({ attachment_file_length: files.length });
	            if (files.length > 0) {
	                (0, _jquery2.default)('.upload-space').addClass('hide');
	                (0, _jquery2.default)('.upload-thumb').removeClass('hide');
	                var fileArra = this.state.attachment_file;
	
	                //console.log('fileArra',fileArra)
	                //var fileThumbArra = this.state.imgThumb;
	                for (var i = 0; i < files.length; i++) {
	                    fileArra.push(e.target.files[i]);
	                    this.setState({
	                        selectedFile: URL.createObjectURL(e.target.files[i]),
	                        attachment_file: fileArra
	                    });
	                }
	                this.clearValidationErr('attachment_file');
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this4 = this;
	
	            var _state = this.state,
	                edited_data = _state.edited_data,
	                edited = _state.edited;
	
	            this.validator.purgeFields();
	
	            return _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _react2.default.createElement(
	                    _layout2.default,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { 'class': 'col-lg-12 grid-margin stretch-card' },
	                        _react2.default.createElement(
	                            'div',
	                            { 'class': 'card' },
	                            _react2.default.createElement(
	                                'div',
	                                { 'class': 'card-body' },
	                                _react2.default.createElement(
	                                    'h4',
	                                    { 'class': 'card-title' },
	                                    'Community Info Management'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'row' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'content-sec col-md-12 col-xs-12 pad-no mar-t-no' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: '' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { id: 'company-info', className: 'tab-pane active' },
	                                                _react2.default.createElement(
	                                                    'form',
	                                                    { onSubmit: this.handlePreview, className: 'custom-form invoice-form col-md-12 col-xs-12 legend-form pad-no' },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'box-shadow-custom' },
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'row' },
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    null,
	                                                                    'Partner Type',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    { className: 'custom-select-drop dropdown' },
	                                                                    _react2.default.createElement(
	                                                                        'select',
	                                                                        {
	                                                                            value: this.state.partner_type,
	                                                                            onChange: this.handleSelect, className: 'form-control selectpicker',
	                                                                            name: 'partner_type',
	                                                                            title: 'Select' },
	                                                                        _react2.default.createElement(
	                                                                            'option',
	                                                                            { value: '1' },
	                                                                            'Institution'
	                                                                        ),
	                                                                        _react2.default.createElement(
	                                                                            'option',
	                                                                            { value: '2' },
	                                                                            'Individuals'
	                                                                        )
	                                                                    ),
	                                                                    this.validator.message('Type', this.state.partner_type, 'required', { className: 'text-danger' })
	                                                                )
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.name != this.state.name && 'edited-field' },
	                                                                    'Counselor Center',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('input', { type: 'text', name: 'name',
	                                                                    value: this.state.name,
	                                                                    placeholder: 'Name',
	                                                                    onChange: this.handleChange, className: 'form-control' }),
	                                                                this.validator.message('Counselor Center', this.state.name, 'required', { className: 'text-danger' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.designation != this.state.designation && 'edited-field' },
	                                                                    'Designation',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('input', { type: 'text', name: 'designation',
	                                                                    value: this.state.designation,
	                                                                    placeholder: 'Your role',
	                                                                    onChange: this.handleChange, className: 'form-control' }),
	                                                                this.validator.message('Designation', this.state.designation, 'required', { className: 'text-danger' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.service != this.state.service && 'edited-field' },
	                                                                    'Service',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    { className: 'custom-select-drop dropdown' },
	                                                                    _react2.default.createElement(
	                                                                        'select',
	                                                                        {
	                                                                            multiple: true,
	                                                                            value: this.state.service,
	                                                                            name: 'service',
	                                                                            id: 'service',
	                                                                            onChange: this.handleSelect,
	                                                                            className: 'form-control selectpicker',
	                                                                            title: 'Select'
	                                                                        },
	                                                                        this.state.getService.length > 0 && this.state.getService.map(function (item, i) {
	                                                                            return _react2.default.createElement(
	                                                                                'option',
	                                                                                { value: item.id },
	                                                                                item.service
	                                                                            );
	                                                                        })
	                                                                    ),
	                                                                    this.validator.message('Service', this.state.service, 'required', { className: 'text-danger' })
	                                                                )
	                                                            )
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'box-shadow-custom' },
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'row' },
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'col-md-12 col-xs-12' },
	                                                                _react2.default.createElement(
	                                                                    'span',
	                                                                    { className: 'form-legend' },
	                                                                    'Information'
	                                                                )
	                                                            ),
	                                                            '                                                                                                                ',
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.address != this.state.address && 'edited-field' },
	                                                                    'Address',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('input', { type: 'text', name: 'address', value: this.state.address,
	                                                                    onChange: this.handleChange, className: 'form-control' }),
	                                                                this.validator.message('Address', this.state.address, 'required', { className: 'text-danger' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.email_id != this.state.email_id && 'edited-field' },
	                                                                    'Email Id',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('input', { type: 'text', name: 'email_id',
	                                                                    value: this.state.email_id,
	                                                                    onChange: this.handleChange, className: 'form-control' }),
	                                                                this.validator.message('Email Id', this.state.email_id, 'emailExist_check', { className: 'text-danger' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.phone_no != this.state.phone_number && 'edited-field' },
	                                                                    'Phone No ',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('input', {
	                                                                    type: 'text',
	                                                                    name: 'phone_number',
	                                                                    value: this.state.phone_number,
	                                                                    onChange: this.handleChange, className: 'form-control' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.website != this.state.website && 'edited-field' },
	                                                                    'Website ',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('input', { name: 'website',
	                                                                    value: this.state.website,
	                                                                    onChange: this.handleChange, className: 'form-control' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.location != this.state.location && 'edited-field' },
	                                                                    'Location',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'select',
	                                                                    {
	                                                                        name: 'location',
	                                                                        id: 'location',
	                                                                        onChange: this.handleSelect,
	                                                                        value: this.state.location,
	                                                                        className: 'form-control selectpicker'
	                                                                    },
	                                                                    this.state.location_list.length > 0 && this.state.location_list.map(function (item, i) {
	                                                                        return _react2.default.createElement(
	                                                                            'option',
	                                                                            { value: item.location },
	                                                                            item.location
	                                                                        );
	                                                                    })
	                                                                ),
	                                                                this.validator.message('Location', this.state.location, 'required', { className: 'text-danger' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.google_location != this.state.google_location && 'edited-field' },
	                                                                    'Google location Address',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('input', { type: 'text', name: 'google_location',
	                                                                    value: this.state.google_location,
	                                                                    onChange: this.handleChange, className: 'form-control' }),
	                                                                this.validator.message('Google location', this.state.google_location, 'required', { className: 'text-danger' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.latitude != this.state.latitude && 'edited-field' },
	                                                                    'Latitude',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('input', {
	                                                                    type: 'text',
	                                                                    name: 'latitude',
	                                                                    value: this.state.latitude,
	                                                                    onChange: this.handleChange,
	
	                                                                    className: 'form-control'
	                                                                }),
	                                                                this.validator.message('Latitude', this.state.latitude, 'required', { className: 'text-danger' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.longitude != this.state.longitude && 'edited-field' },
	                                                                    'Longitude',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('input', {
	                                                                    type: 'text',
	                                                                    name: 'longitude',
	                                                                    value: this.state.longitude,
	                                                                    onChange: this.handleChange,
	
	                                                                    className: 'form-control'
	                                                                }),
	                                                                this.validator.message('Longitude', this.state.longitude, 'required', { className: 'text-danger' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.other_rating != this.state.other_rating && 'edited-field' },
	                                                                    'Google Rating',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('input', {
	                                                                    type: 'number',
	                                                                    step: '0.01',
	                                                                    name: 'other_rating',
	                                                                    value: this.state.other_rating,
	                                                                    onChange: this.handleChange,
	                                                                    max: '5',
	                                                                    className: 'form-control'
	                                                                }),
	                                                                this.validator.message('Google Rating', this.state.other_rating, 'required', { className: 'text-danger' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.fb != this.state.facebook && 'edited-field' },
	                                                                    'Facebook',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('input', { type: 'text', name: 'facebook',
	                                                                    value: this.state.facebook,
	                                                                    onChange: this.handleChange, className: 'form-control' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.twitter != this.state.twitter && 'edited-field' },
	                                                                    'Twitter',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('input', { type: 'text', name: 'twitter',
	                                                                    value: this.state.twitter,
	                                                                    onChange: this.handleChange, className: 'form-control' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.mop != this.state.mode_of_payment && 'edited-field' },
	                                                                    'Mode of Payment',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    { className: 'custom-select-drop dropdown' },
	                                                                    _react2.default.createElement(
	                                                                        'select',
	                                                                        {
	                                                                            value: this.state.mode_of_payment,
	                                                                            name: 'mode_of_payment',
	                                                                            id: 'mode_of_payment',
	                                                                            onChange: this.handleSelect,
	                                                                            multiple: 'multiple',
	                                                                            className: 'form-control selectpicker', title: 'Select'
	                                                                        },
	                                                                        this.state.mopList.length > 0 && this.state.mopList.map(function (item, i) {
	                                                                            return _react2.default.createElement(
	                                                                                'option',
	                                                                                { value: item.id },
	                                                                                item.payment_name
	                                                                            );
	                                                                        })
	                                                                    ),
	                                                                    this.validator.message('Mode of Payment', this.state.mode_of_payment, 'required', { className: 'text-danger' })
	                                                                )
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.established_year != this.state.established_year && 'edited-field' },
	                                                                    'Established Year ',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('input', { type: 'text', name: 'established_year',
	                                                                    value: this.state.established_year,
	                                                                    onChange: this.handleChange, className: 'form-control' }),
	                                                                this.validator.message('Established Year', this.state.established_year, '', { className: 'text-danger' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.about != this.state.about && 'edited-field' },
	                                                                    'About',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('textarea', { type: 'text', value: this.state.about, name: 'about',
	                                                                    onChange: this.handleChange, className: 'form-control' }),
	                                                                this.validator.message('About', this.state.about, 'required', { className: 'text-danger' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.keywords != this.state.keywords && 'edited-field' },
	                                                                    'Keywords',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement(_multiselectReactDropdown.Multiselect, {
	                                                                    isObject: false,
	                                                                    options: this.state.keywordsArr // Options to display in the dropdown
	                                                                    , selectedValues: this.state.keywords // Preselected value to persist in dropdown
	                                                                    , onSelect: this.onSelect // Function will trigger on select event
	                                                                    , onRemove: this.onRemove // Function will trigger on remove event
	                                                                }),
	                                                                this.validator.message('Website Search Keywords', this.state.keywords, 'required', { className: 'text-danger' })
	                                                            )
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'box-shadow-custom' },
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'row' },
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'col-md-12 col-xs-12' },
	                                                                _react2.default.createElement(
	                                                                    'span',
	                                                                    { className: 'form-legend' },
	                                                                    'Images'
	                                                                )
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.images != this.state.images && 'edited-field' },
	                                                                    'Banner Image ',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('input', {
	                                                                    type: 'file',
	                                                                    name: 'images',
	                                                                    onChange: this.handleFile,
	                                                                    className: 'form-control'
	                                                                })
	                                                            ),
	                                                            (this.state.edit_image != '' || this.state.tempBanner != '') && _react2.default.createElement(
	                                                                'div',
	                                                                { 'class': 'col-md-2 col-sm-12 mar-btm', id: 'edit_image' },
	                                                                _react2.default.createElement('img', { src: this.state.tempBanner ? this.state.tempBanner : this.state.edit_image, alt: 'Img', 'class': 'img-thumbnail' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { 'class': 'col-md-12 float-left mt-4 p-0' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.photos != this.state.photos && 'edited-field' },
	                                                                    'Gallery Images ',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                )
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { 'class': 'col-md-12 float-left mt-4 p-0' },
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    { 'class': 'col-md-12 margin-bottom-mobile-account float-left image-upload' },
	                                                                    _react2.default.createElement(
	                                                                        'div',
	                                                                        { className: 'upload-wizard' },
	                                                                        _react2.default.createElement(
	                                                                            'div',
	                                                                            { className: 'upload-thumb' },
	                                                                            _react2.default.createElement(
	                                                                                'ul',
	                                                                                { className: 'list-inline' },
	                                                                                this.state.attachment_file.map(function (file_data, index) {
	
	                                                                                    var file_url;
	                                                                                    if (file_data.name) {
	                                                                                        var url = file_data.image_thumb ? file_data.image_thumb : '';
	                                                                                        if (url != '') {
	                                                                                            file_url = file_data.image_thumb;
	                                                                                        } else {
	                                                                                            file_url = URL.createObjectURL(file_data);
	                                                                                        }
	                                                                                        // var file_url = URL.createObjectURL(file_data)
	                                                                                        // var file_name = file_data.name
	                                                                                        if (file_data.type === 'application/pdf') {
	                                                                                            var blob = file_url;
	                                                                                            //console.log('blob_url', file_data.name)
	                                                                                            return _react2.default.createElement(
	                                                                                                'li',
	                                                                                                { className: 'previewImg' },
	                                                                                                _react2.default.createElement(
	                                                                                                    'div',
	                                                                                                    { className: 'thumb-img' },
	                                                                                                    _react2.default.createElement('img', {
	                                                                                                        src: file_url,
	                                                                                                        alt: 'image',
	                                                                                                        title: file_data.name
	                                                                                                    })
	                                                                                                ),
	                                                                                                _react2.default.createElement(
	                                                                                                    'a',
	                                                                                                    { href: 'javascript:;', className: 'del-btn', onClick: function onClick() {
	                                                                                                            _this4.removeImage(file_data.name);
	                                                                                                        } },
	                                                                                                    _react2.default.createElement('img', {
	                                                                                                        src: '../../../assets/images/close-icon-white.svg',
	                                                                                                        alt: 'delete'
	                                                                                                    })
	                                                                                                )
	                                                                                            );
	                                                                                        } else {
	                                                                                            return _react2.default.createElement(
	                                                                                                'li',
	                                                                                                { className: 'previewImg' },
	                                                                                                _react2.default.createElement(
	                                                                                                    'div',
	                                                                                                    { className: 'thumb-img' },
	                                                                                                    _react2.default.createElement('img', {
	                                                                                                        src: file_url,
	                                                                                                        alt: 'image',
	                                                                                                        title: file_data.name
	                                                                                                    })
	                                                                                                ),
	                                                                                                _react2.default.createElement(
	                                                                                                    'a',
	                                                                                                    {
	                                                                                                        href: 'javascript:;',
	                                                                                                        className: 'del-btn',
	                                                                                                        onClick: function onClick() {
	                                                                                                            _this4.removeImage(file_data.name);
	                                                                                                        }
	                                                                                                    },
	                                                                                                    _react2.default.createElement('img', {
	                                                                                                        src: '../../../assets/images/close-icon-white.svg',
	                                                                                                        alt: 'delete'
	                                                                                                    })
	                                                                                                )
	                                                                                            );
	                                                                                        }
	                                                                                    }
	                                                                                }),
	                                                                                _react2.default.createElement(
	                                                                                    'li',
	                                                                                    { className: 'addMore' },
	                                                                                    _react2.default.createElement('input', {
	                                                                                        type: 'file',
	                                                                                        name: 'imgInp[]',
	                                                                                        id: 'imgInp2',
	                                                                                        className: 'add_img',
	                                                                                        multiple: true,
	                                                                                        onChange: this.loadFile.bind(this),
	                                                                                        accept: 'image/x-png,image/gif,image/jpeg'
	                                                                                    }),
	                                                                                    _react2.default.createElement(
	                                                                                        'a',
	                                                                                        { href: 'javascript:;', className: 'add-more' },
	                                                                                        _react2.default.createElement(
	                                                                                            'div',
	                                                                                            null,
	                                                                                            _react2.default.createElement('img', { src: '../../../assets/images/upload-icon.svg', alt: 'icon' }),
	                                                                                            'Add more'
	                                                                                        )
	                                                                                    )
	                                                                                )
	                                                                            )
	                                                                        )
	                                                                    )
	                                                                )
	                                                            )
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'col-md-12 col-xs-12 btn-bdr' },
	                                                        _react2.default.createElement(
	                                                            'button',
	                                                            { id: 'btnSubmit', className: 'btn btn-primary btn-sm' },
	                                                            'Preview'
	                                                        )
	                                                    )
	                                                )
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    this.preview(),
	                    _react2.default.createElement(_reactNotifications.NotificationContainer, null)
	                )
	            );
	        }
	    }]);
	
	    return verticalCommunityEdit;
	}(_react.Component);
	
	exports.default = verticalCommunityEdit;

/***/ },
/* 1028 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _FetchCall2 = _interopRequireDefault(_FetchCall);
	
	var _reactJsPagination = __webpack_require__(33);
	
	var _reactJsPagination2 = _interopRequireDefault(_reactJsPagination);
	
	var _bewiseloading = __webpack_require__(48);
	
	var _bewiseloading2 = _interopRequireDefault(_bewiseloading);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import { Editor } from '@tinymce/tinymce-react';
	
	//import ReactPaginate from 'react-paginate';
	
	//import Pagination from 'rc-pagination';
	
	var verticalEvents = function (_Component) {
	  _inherits(verticalEvents, _Component);
	
	  function verticalEvents(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, verticalEvents);
	
	    var _this = _possibleConstructorReturn(this, (verticalEvents.__proto__ || Object.getPrototypeOf(verticalEvents)).call(this, props));
	
	    _this.getTotal = function (vertical) {
	      var location = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	
	      var locationselected = location == '' ? _this.state.location : location;
	
	      var ins = JSON.stringify({
	        vertical: vertical,
	        location: locationselected,
	        searchby: _this.state.searchby
	      });
	
	      (0, _FetchCall.getTotal)(ins).then(function (res) {
	
	        _this.setState({ loading: true });
	
	        if (res.status == 1) {
	
	          _this.setState({
	
	            total: res.total
	
	          });
	        }
	      });
	    };
	
	    _this.getList = function () {
	      var pageNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	      var location = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	      var _this$state$auth_data = _this.state.auth_data,
	          login_id = _this$state$auth_data.login_id,
	          role = _this$state$auth_data.role;
	
	
	      _this.setState({ activePage: pageNumber });
	
	      var newOffset = pageNumber == 1 ? 0 : (pageNumber - 1) * _this.state.PER_PAGE % _this.state.total;
	
	      var locationselected = location == '' ? _this.state.location : location;
	
	      var ins = JSON.stringify({
	        vendor_id: login_id,
	        role: role,
	        location: locationselected,
	        searchby: _this.state.searchby,
	        perpage: _this.state.PER_PAGE,
	        offset: newOffset
	      });
	
	      (0, _FetchCall.getEventsPaged)(ins).then(function (res) {
	
	        _this.setState({ loading: true });
	
	        if (res.status == 1) {
	
	          _this.setState({ loading: !_this.state.loading });
	
	          _this.setState({
	
	            eventList: res.data
	
	          });
	        } else {
	
	          _this.setState({ loading: !_this.state.loading });
	
	          _this.setState({
	            eventList: []
	          });
	        }
	      });
	    };
	
	    _this.handleChange = function (e) {
	      _this.setState(_defineProperty({}, e.target.name, e.target.value));
	    };
	
	    _this.searchBy = function (e) {
	
	      _this.setState({ loading: true, activePage: 1 });
	
	      _this.getTotal('bw_schools');
	      _this.getList(1);
	    };
	
	    _this.handleSelect = function (e) {
	
	      _this.setState({ location: e.target.value, activePage: 1 });
	      localStorage.setItem("location", e.target.value);
	      _this.getTotal('bw_schools', e.target.value);
	      _this.getList(1, e.target.value);
	    };
	
	    _this.schoolExport = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var req, res;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	
	              _this.setState({ exportbtndisabled: true, thisExportBtnText: "exporting..." });
	
	              _context.prev = 1;
	              req = JSON.stringify({
	                location: _this.state.location
	              });
	              _context.next = 5;
	              return (0, _FetchCall.exportSchool)(req);
	
	            case 5:
	              res = _context.sent;
	
	              if (res.status == 1) {
	
	                _this.setState({ exportbtndisabled: false, thisExportBtnText: "Export" });
	                console.log('location_list', res);
	                console.log('location_list', res.path);
	                window.open(res.path);
	
	                // this.setState({
	                //   subscribe_list: res.results,
	                // });
	              }
	
	              _context.next = 12;
	              break;
	
	            case 9:
	              _context.prev = 9;
	              _context.t0 = _context['catch'](1);
	
	              _this.setState({ error: true });
	
	            case 12:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2, [[1, 9]]);
	    }));
	
	    var url = new URL(window.location.href);
	    //var location = url.searchParams.get("location");
	    var auth_data = JSON.parse(localStorage.getItem("user_data"));
	    _this.state = {
	      logged: localStorage.getItem("authentication"),
	      auth_data: JSON.parse(localStorage.getItem("user_data")),
	      location: localStorage.getItem("location") ? localStorage.getItem("location") : 'Bengaluru',
	      eventList: [],
	      PER_PAGE: 15,
	      total: 0,
	      loading: true,
	      searchby: '',
	      activePage: 0,
	      offset: 0,
	      exportbtndisabled: false,
	      thisExportBtnText: 'Export'
	    };
	
	    //this.handlePageChange = this.handlePageChange.bind(this);
	    _this.handleSelect = _this.handleSelect.bind(_this);
	    //this.getList = this.getList.bind(this);
	
	
	    return _this;
	  }
	
	  _createClass(verticalEvents, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	
	      var THIS = this;
	      (0, _jquery2.default)(document).on('click', '.remove_school', function () {
	
	        var delete_id = (0, _jquery2.default)(this).data("id");
	        if (confirm("You are sure to delete?") == true) {
	
	          var ins = JSON.stringify({
	            id: delete_id,
	            table: 'school'
	          });
	
	          (0, _FetchCall.removethisItem)(ins).then(function (res) {
	
	            alert(res.message);
	            THIS.getTotal('bw_events');
	            THIS.getList();
	          });
	        }
	      });
	
	      /*
	      $(document).on('click', '.stamp_it', function () {
	         var item_id = $(this).data("id");
	         THIS.openInfo(item_id);
	        
	      }); */
	
	      this.getTotal('bw_events');
	      this.getList();
	    }
	  }, {
	    key: 'handlePageChange',
	    value: function handlePageChange(pageNumber) {
	
	      console.log('active page is ' + pageNumber);
	
	      this.setState({ activePage: pageNumber });
	
	      //this.getTotal('bw_schools');
	      this.getList(pageNumber);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          eventList = _state.eventList,
	          currentPage = _state.currentPage,
	          PER_PAGE = _state.PER_PAGE,
	          totalCount = _state.totalCount,
	          total = _state.total,
	          exportbtndisabled = _state.exportbtndisabled;
	
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'col-lg-12 grid-margin stretch-card' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card-body' },
	                _react2.default.createElement(
	                  'h4',
	                  { 'class': 'card-title' },
	                  'Birthday Events'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'float-right' },
	                  _react2.default.createElement(
	                    'a',
	                    { href: '/vertical/birthdayevents/add', 'class': 'btn btn-primary btn-sm' },
	                    'Add'
	                  ),
	                  ' \xA0',
	                  _react2.default.createElement(
	                    'button',
	                    { disabled: exportbtndisabled, 'class': 'btn btn-primary btn-sm', onClick: function onClick() {
	                        return _this3.schoolExport();
	                      } },
	                    this.state.thisExportBtnText
	                  ),
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'p',
	                  { 'class': 'card-description' },
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'cityselection' },
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'leftaligned bwlabel' },
	                      'City'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'leftaligned' },
	                      _react2.default.createElement(
	                        'select',
	                        { name: 'location', 'class': 'form-control', onChange: function onChange(e) {
	                            return _this3.handleSelect(e);
	                          },
	                          value: this.state.location },
	                        _react2.default.createElement(
	                          'option',
	                          { value: '' },
	                          'select city'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'Bengaluru' },
	                          'Bengaluru'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'Chennai' },
	                          'Chennai'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'Hyderabad' },
	                          'Hyderabad'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'Coimbatore' },
	                          'Coimbatore'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'Hosur' },
	                          'Hosur'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'Indore' },
	                          'Indore'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'Others' },
	                          'Others'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'leftaligned bwlabel' },
	                      'Search'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'leftaligned' },
	                      _react2.default.createElement('input', { type: 'text', name: 'searchby', 'class': 'form-control form-control-sm', onChange: this.handleChange })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'leftaligned' },
	                      _react2.default.createElement(
	                        'button',
	                        { 'class': 'btn btn-primary btn-sm', onClick: this.searchBy },
	                        'Go'
	                      )
	                    )
	                  )
	                ),
	                this.state.loading && _react2.default.createElement(
	                  'div',
	                  { id: 'loader' },
	                  _react2.default.createElement('img', { src: _bewiseloading2.default, width: '60px' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'pt-3' },
	                  !this.state.loading && _react2.default.createElement(
	                    'table',
	                    { id: 'tablebw' },
	                    _react2.default.createElement(
	                      'thead',
	                      { 'class': 'thead-dark' },
	                      _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                          'th',
	                          { width: '2%' },
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'S.No'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          { width: '5%' },
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Date'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          { width: '5%' },
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Name'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          { width: '5%' },
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Email Id'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          { width: '5%' },
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Status'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          { width: '10%' },
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Action'
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'tbody',
	                      null,
	                      eventList.map(function (item, i) {
	
	                        return _react2.default.createElement(
	                          'tr',
	                          null,
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.s_no
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.updated_date
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.name
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.email_id
	                          ),
	                          _react2.default.createElement('td', { dangerouslySetInnerHTML: { __html: item.status } }),
	                          _react2.default.createElement('td', { 'class': 'actionbtns', dangerouslySetInnerHTML: { __html: item.action } })
	                        );
	                      })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'text-center' },
	                    _react2.default.createElement(_reactJsPagination2.default, {
	                      activePage: this.state.activePage,
	                      itemsCountPerPage: PER_PAGE,
	                      totalItemsCount: this.state.total,
	                      pageRangeDisplayed: 5,
	                      activeClass: "pagination__link--active",
	                      onChange: this.handlePageChange.bind(this),
	                      prevPageText: 'previous',
	                      nextPageText: 'next'
	                    })
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return verticalEvents;
	}(_react.Component);
	
	exports.default = verticalEvents;

/***/ },
/* 1029 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _FetchCall2 = _interopRequireDefault(_FetchCall);
	
	var _reactstrap = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import { Editor } from '@tinymce/tinymce-react';
	
	
	var verticalEventsDetail = function (_Component) {
	    _inherits(verticalEventsDetail, _Component);
	
	    function verticalEventsDetail(props) {
	        _classCallCheck(this, verticalEventsDetail);
	
	        var _this = _possibleConstructorReturn(this, (verticalEventsDetail.__proto__ || Object.getPrototypeOf(verticalEventsDetail)).call(this, props));
	
	        _this.state = {
	            partyDetails: []
	        };
	        _this.id = _this.props.match.params.id;
	        _this.type = _this.props.match.params.type;
	        _this.getEventsInfo = _this.getEventsInfo.bind(_this);
	        _this.getEventsInfo();
	
	        return _this;
	    }
	
	    _createClass(verticalEventsDetail, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.getEventsInfo();
	        }
	    }, {
	        key: 'UNSAFE_componentWillMount',
	        value: function UNSAFE_componentWillMount() {}
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {}
	    }, {
	        key: 'getEventsInfo',
	        value: function () {
	            var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	                var response, data;
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                _context.next = 2;
	                                return _FetchCall2.default.getEventsInfo(this.id, this.type);
	
	                            case 2:
	                                response = _context.sent;
	
	                                if (!response) {
	                                    _context.next = 8;
	                                    break;
	                                }
	
	                                data = response.data;
	
	                                this.setState({
	                                    partyDetails: data,
	                                    url: data.url,
	                                    photos_arr: data.photo_arr
	                                });
	
	                                _context.next = 9;
	                                break;
	
	                            case 8:
	                                return _context.abrupt('return', _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    'Error'
	                                ));
	
	                            case 9:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function getEventsInfo() {
	                return _ref.apply(this, arguments);
	            }
	
	            return getEventsInfo;
	        }()
	    }, {
	        key: 'gallery_image',
	        value: function gallery_image() {
	            var _this2 = this;
	
	            var photos = this.state.photos_arr !== undefined ? this.state.photos_arr : [];
	            var rows = "";
	            if (photos.length > 0) {
	                rows = photos.map(function (photos, index) {
	                    if (photos.name) return _react2.default.createElement(
	                        'div',
	                        { 'class': 'col-md-4 float-left mt-4 p-0' },
	                        _react2.default.createElement('img', { src: _this2.state.url + photos.name, alt: 'Img', 'class': 'img-thumbnail' })
	                    );
	                });
	            } else {
	                rows = "";
	            }
	            return rows;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var partyDetails = this.state.partyDetails;
	
	            console.log('partyDetails', this.state);
	            var entatainer = '';
	            if (this.type === 'supplier') {
	                switch (partyDetails.entatainer) {
	                    case "1":
	                        entatainer = 'Birthday party';
	                        break;
	                    case "2":
	                        entatainer = 'Dj';
	                    case "1,2":
	                        entatainer = 'Birthday party, Dj';
	                        break;
	                    default:
	                        entatainer = partyDetails.entatainer;
	                }
	            }
	
	            return _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _react2.default.createElement(
	                    _layout2.default,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { 'class': 'col-lg-12 grid-margin stretch-card' },
	                        _react2.default.createElement(
	                            'div',
	                            { 'class': 'card' },
	                            _react2.default.createElement(
	                                'div',
	                                { 'class': 'card-body' },
	                                _react2.default.createElement(
	                                    'h4',
	                                    { 'class': 'card-title' },
	                                    partyDetails.name,
	                                    ' - View'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'pt-3 detailsection' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { id: 'company-info', className: 'tab-pane fade in active' },
	                                        _react2.default.createElement(
	                                            'form',
	                                            { className: 'custom-form invoice-form col-md-12 col-xs-12 legend-form pad-no' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'box-shadow-custom' },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'row' },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'form-group col-md-4' },
	                                                        _react2.default.createElement(
	                                                            'label',
	                                                            null,
	                                                            'Registration No.'
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'p',
	                                                            null,
	                                                            partyDetails.registration_no
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'form-group col-md-4' },
	                                                        _react2.default.createElement(
	                                                            'label',
	                                                            null,
	                                                            'Name'
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'p',
	                                                            null,
	                                                            partyDetails.name
	                                                        )
	                                                    )
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'box-shadow-custom' },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'row' },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'col-md-12 col-xs-12' },
	                                                        _react2.default.createElement(
	                                                            'span',
	                                                            { className: 'form-legend' },
	                                                            'Key Information'
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'form-group col-md-4' },
	                                                        _react2.default.createElement(
	                                                            'label',
	                                                            null,
	                                                            'Contact Person'
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'p',
	                                                            null,
	                                                            partyDetails.contact_person
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'form-group col-md-4' },
	                                                        _react2.default.createElement(
	                                                            'label',
	                                                            null,
	                                                            'Email Id'
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'p',
	                                                            null,
	                                                            partyDetails.email_id
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'form-group col-md-4' },
	                                                        _react2.default.createElement(
	                                                            'label',
	                                                            null,
	                                                            'Phone No.'
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'p',
	                                                            null,
	                                                            partyDetails.phone_number
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'form-group col-md-4' },
	                                                        _react2.default.createElement(
	                                                            'label',
	                                                            null,
	                                                            'State'
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'p',
	                                                            null,
	                                                            partyDetails.state
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'form-group col-md-4' },
	                                                        _react2.default.createElement(
	                                                            'label',
	                                                            null,
	                                                            'Location'
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'p',
	                                                            null,
	                                                            partyDetails.location
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'form-group col-md-4' },
	                                                        _react2.default.createElement(
	                                                            'label',
	                                                            null,
	                                                            'Website'
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'p',
	                                                            null,
	                                                            partyDetails.website
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'form-group col-md-4' },
	                                                        _react2.default.createElement(
	                                                            'label',
	                                                            null,
	                                                            'Facebook'
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'p',
	                                                            null,
	                                                            partyDetails.facebook
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'form-group col-md-4' },
	                                                        _react2.default.createElement(
	                                                            'label',
	                                                            null,
	                                                            'Type'
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'p',
	                                                            null,
	                                                            partyDetails.typname
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'form-group col-md-4' },
	                                                        _react2.default.createElement(
	                                                            'label',
	                                                            null,
	                                                            'Twitter'
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'p',
	                                                            null,
	                                                            partyDetails.twitter
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'form-group col-md-4' },
	                                                        _react2.default.createElement(
	                                                            'label',
	                                                            null,
	                                                            'Avg Price '
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'p',
	                                                            null,
	                                                            partyDetails.event_fee
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'form-group col-md-4' },
	                                                        _react2.default.createElement(
	                                                            'label',
	                                                            null,
	                                                            'Established Year '
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'p',
	                                                            null,
	                                                            partyDetails.est_year
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'form-group col-md-4' },
	                                                        _react2.default.createElement(
	                                                            'label',
	                                                            null,
	                                                            'Pincode'
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'p',
	                                                            null,
	                                                            partyDetails.pincode
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'form-group col-md-4' },
	                                                        _react2.default.createElement(
	                                                            'label',
	                                                            null,
	                                                            'Modes of Payment'
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'p',
	                                                            null,
	                                                            partyDetails.mod_payment
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'form-group col-md-4' },
	                                                        _react2.default.createElement(
	                                                            'label',
	                                                            null,
	                                                            'Food'
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'p',
	                                                            null,
	                                                            partyDetails.food
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'form-group col-md-4' },
	                                                        _react2.default.createElement(
	                                                            'label',
	                                                            null,
	                                                            'Hall Capacity'
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'p',
	                                                            null,
	                                                            partyDetails.hall_capcity
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'form-group col-md-4' },
	                                                        _react2.default.createElement(
	                                                            'label',
	                                                            null,
	                                                            'Dinning Hall Capacity'
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'p',
	                                                            null,
	                                                            partyDetails.dinning_capacity
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'form-group col-md-4' },
	                                                        _react2.default.createElement(
	                                                            'label',
	                                                            null,
	                                                            'Car Parking'
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'p',
	                                                            null,
	                                                            partyDetails.car_parking_slot
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'form-group col-md-4' },
	                                                        _react2.default.createElement(
	                                                            'label',
	                                                            null,
	                                                            'Two Wheeler Parking'
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'p',
	                                                            null,
	                                                            partyDetails.two_parking_slot
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'form-group col-md-4' },
	                                                        _react2.default.createElement(
	                                                            'label',
	                                                            null,
	                                                            'Address'
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'p',
	                                                            null,
	                                                            partyDetails.address
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'form-group col-md-4' },
	                                                        _react2.default.createElement(
	                                                            'label',
	                                                            null,
	                                                            'Google Location Address'
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'p',
	                                                            null,
	                                                            partyDetails.google_location
	                                                        )
	                                                    ),
	                                                    partyDetails.vendor_id == 1 && _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'form-group col-md-4' },
	                                                        _react2.default.createElement(
	                                                            'label',
	                                                            null,
	                                                            'Partner Type'
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'p',
	                                                            null,
	                                                            partyDetails.partner_type == 1 ? 'Institution' : 'Individual'
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'form-group col-md-4' },
	                                                        _react2.default.createElement(
	                                                            'label',
	                                                            null,
	                                                            'Operating hours'
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'p',
	                                                            null,
	                                                            partyDetails.timing
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'form-group col-md-12' },
	                                                        _react2.default.createElement(
	                                                            'label',
	                                                            null,
	                                                            'About'
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'p',
	                                                            null,
	                                                            partyDetails.about
	                                                        )
	                                                    )
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'box-shadow-custom' },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'row' },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'col-md-12 col-xs-12' },
	                                                        _react2.default.createElement(
	                                                            'span',
	                                                            { className: 'form-legend' },
	                                                            'Other Information'
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'form-group col-md-4' },
	                                                        _react2.default.createElement(
	                                                            'label',
	                                                            null,
	                                                            'Other Info '
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'p',
	                                                            null,
	                                                            partyDetails.other_info
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'form-group col-md-4' },
	                                                        _react2.default.createElement(
	                                                            'label',
	                                                            null,
	                                                            'Website Search Keywords'
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'p',
	                                                            null,
	                                                            partyDetails.keywords
	                                                        )
	                                                    )
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'box-shadow-custom' },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'row' },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'col-md-12 col-xs-12' },
	                                                        _react2.default.createElement(
	                                                            'span',
	                                                            { className: 'form-legend' },
	                                                            'Images'
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'form-group col-md-4' },
	                                                        _react2.default.createElement(
	                                                            'label',
	                                                            null,
	                                                            'Banner '
	                                                        ),
	                                                        partyDetails.images && _react2.default.createElement('img', { src: partyDetails.url + partyDetails.images, alt: 'Img', 'class': 'img-thumbnail' })
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { 'class': 'col-md-12 float-left mt-4 p-0' },
	                                                        _react2.default.createElement(
	                                                            'label',
	                                                            null,
	                                                            'Gallery Images'
	                                                        )
	                                                    ),
	                                                    this.gallery_image()
	                                                )
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return verticalEventsDetail;
	}(_react.Component);
	
	exports.default = verticalEventsDetail;

/***/ },
/* 1030 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _FetchCall2 = _interopRequireDefault(_FetchCall);
	
	var _constant = __webpack_require__(21);
	
	var _reactstrap = __webpack_require__(17);
	
	var _reactGeocode = __webpack_require__(55);
	
	var _reactGeocode2 = _interopRequireDefault(_reactGeocode);
	
	var _multiselectReactDropdown = __webpack_require__(73);
	
	var _simpleReactValidator = __webpack_require__(28);
	
	var _simpleReactValidator2 = _interopRequireDefault(_simpleReactValidator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import { Editor } from '@tinymce/tinymce-react';
	
	
	var url = _constant.BASEURL;
	_reactGeocode2.default.setApiKey("AIzaSyA9MtbfG_zlo64B2lqNMvigTBuXHkagKcE");
	_reactGeocode2.default.setLanguage("en");
	_reactGeocode2.default.setRegion("es");
	_reactGeocode2.default.enableDebug();
	
	var verticalEventsEdit = function (_Component) {
	    _inherits(verticalEventsEdit, _Component);
	
	    function verticalEventsEdit(props) {
	        var _this2 = this;
	
	        _classCallCheck(this, verticalEventsEdit);
	
	        var _this = _possibleConstructorReturn(this, (verticalEventsEdit.__proto__ || Object.getPrototypeOf(verticalEventsEdit)).call(this, props));
	
	        _this.validateMail = function (value, catgry, vendr_id, pageid) {
	            var _JSON$stringify;
	
	            var name = 'email_id';
	            var type_name = 'isEmailValid';
	            var req = JSON.stringify((_JSON$stringify = {}, _defineProperty(_JSON$stringify, name, value), _defineProperty(_JSON$stringify, 'category', catgry), _defineProperty(_JSON$stringify, 'vendor_id', vendr_id), _defineProperty(_JSON$stringify, 'pageid', pageid), _JSON$stringify));
	            var res = (0, _FetchCall.emailExist_check)(req).then(function (res) {
	                console.log('valuee', res);
	                if (res.status === 1) {
	                    _this.setState(_defineProperty({}, type_name, false));
	                } else {
	                    // return res.status;
	                    _this.setState(_defineProperty({}, type_name, true));
	                }
	            });
	        };
	
	        _this.getKeywords = function () {
	            (0, _FetchCall.commonAPI)(JSON.stringify({ url: 'get_site_keywords' })).then(function (res) {
	                if (res.status === 1) {
	                    _this.setState({
	                        keywordsArr: res.results
	                    });
	                }
	            });
	        };
	
	        _this.LocationDataList = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	            var res;
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            _context.prev = 0;
	                            _context.next = 3;
	                            return (0, _FetchCall.getLocationList)();
	
	                        case 3:
	                            res = _context.sent;
	
	                            if (res.status == 1) {
	                                console.log('location_list', res.results);
	
	                                _this.setState({
	                                    location_list: res.results,
	                                    error: false
	                                });
	                            }
	
	                            _context.next = 10;
	                            break;
	
	                        case 7:
	                            _context.prev = 7;
	                            _context.t0 = _context['catch'](0);
	
	                            _this.setState({ error: true });
	
	                        case 10:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, _this2, [[0, 7]]);
	        }));
	
	        _this.handleSelect = function (e) {
	            var propName = e.target.name;
	            var value = [].concat(_toConsumableArray(e.target.selectedOptions)).map(function (item) {
	                return item.value;
	            });
	
	            _this.setState(_defineProperty({}, propName, value));
	        };
	
	        _this.handleChange = function (e) {
	            _this.setState(_defineProperty({}, e.target.name, e.target.value));
	            if (e.target.name == 'google_location') _this.Geocode_location();
	            var propName = e.target.name;
	            // if (propName == 'email_id') {
	            //     this.validateMail(e.target.value, 7, this.state.vendor_id, this.state.pageid);
	            // }
	        };
	
	        _this.onSelect = function (selectedList) {
	            var keywords = [];
	            selectedList.map(function (item, i) {
	                keywords.push(item);
	            });
	            _this.setState({
	                keywords: keywords
	            });
	        };
	
	        _this.onRemove = function (selectedList, removedItem) {
	            var keywords = [];
	            selectedList.map(function (item, i) {
	                keywords.push(item);
	            });
	            _this.setState({
	                keywords: keywords
	            });
	        };
	
	        _this.handleFile = function (e) {
	            // this.Geocode_location();
	            var propName = e.target.name;
	            var files = e.target.files[0];
	            _this.setState(_defineProperty({}, propName, files));
	            var reader = new FileReader();
	            var img = '';
	            var THIS = _this;
	            reader.addEventListener("load", function () {
	                // convert image file to base64 string
	                img = reader.result;
	                THIS.setState({
	                    tempBanner: reader.result
	                });
	            }, false);
	
	            if (files) {
	                reader.readAsDataURL(files);
	            } else {
	                THIS.setState({
	                    tempBanner: ''
	                });
	            }
	        };
	
	        _this.handleFileMultiple = function (e) {
	            _this.setState(_defineProperty({}, e.target.name, e.target.files));
	        };
	
	        _this.removeImage = function (e) {
	            var delete_array = _this.state.delete_array;
	            delete_array.push(e);
	            var updated = _this.state.attachment_file.filter(function (item) {
	                return item.name !== e;
	            });
	            _this.setState({
	                attachment_file: updated,
	                delete_array: delete_array
	            });
	        };
	
	        _this.handlePreview = function (e) {
	            e.preventDefault();
	            if (_this.validator.allValid()) {
	                _this.setState({
	                    preview: true
	                });
	            } else {
	                _this.validator.showMessages();
	                _this.forceUpdate();
	            }
	        };
	
	        _this.preview = function () {
	            return _react2.default.createElement(
	                _reactstrap.Modal,
	                { isOpen: _this.state.preview, size: 'lg', className: 'preview-pop' },
	                _react2.default.createElement(
	                    _reactstrap.ModalBody,
	                    { className: 'p-0' },
	                    _react2.default.createElement(
	                        _reactstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactstrap.Col,
	                            { md: '12' },
	                            _react2.default.createElement('img', { src: '/assets/images/user-header.png', className: 'preview-header' })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactstrap.Row,
	                        { className: 'pv-banner' },
	                        _react2.default.createElement(
	                            _reactstrap.Col,
	                            { className: 'pv-banner-bg', md: '12' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'title-section' },
	                                _react2.default.createElement(
	                                    'p',
	                                    { className: 'banner-title' },
	                                    _this.state.org_name
	                                ),
	                                _react2.default.createElement(
	                                    'p',
	                                    { className: 'banner-address' },
	                                    _this.state.address
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactstrap.Row,
	                        { className: 'pv-section' },
	                        _react2.default.createElement(
	                            _reactstrap.Col,
	                            { className: '', md: '12' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'title-section' },
	                                _react2.default.createElement(
	                                    'h4',
	                                    null,
	                                    'About'
	                                ),
	                                _react2.default.createElement(
	                                    'p',
	                                    { className: '' },
	                                    _this.state.about
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactstrap.Row,
	                        { className: 'pv-section' },
	                        _react2.default.createElement(
	                            _reactstrap.Col,
	                            { className: '', md: '12' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'title-section' },
	                                _react2.default.createElement(
	                                    'h4',
	                                    null,
	                                    'Key Information'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'row' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-4' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'type-n7ngd' },
	                                            _react2.default.createElement(
	                                                'b',
	                                                null,
	                                                'Contact Person'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'key-po' },
	                                            _react2.default.createElement(
	                                                'p',
	                                                null,
	                                                _this.state.contact_person
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-4' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'type-n7ngd' },
	                                            _react2.default.createElement(
	                                                'b',
	                                                null,
	                                                'Email Id'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'key-po' },
	                                            _react2.default.createElement(
	                                                'p',
	                                                null,
	                                                _this.state.email_id
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-4' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'type-n7ngd' },
	                                            _react2.default.createElement(
	                                                'b',
	                                                null,
	                                                'Avg Fee'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'key-po' },
	                                            _react2.default.createElement(
	                                                'p',
	                                                null,
	                                                parseFloat(_this.state.avg_fee) > 0 ? '' + _this.state.avg_fee : 'NA'
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-4' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'type-n7ngd' },
	                                            _react2.default.createElement(
	                                                'b',
	                                                null,
	                                                'Year Established'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'key-po' },
	                                            _react2.default.createElement(
	                                                'p',
	                                                null,
	                                                _this.state.est_year
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-4' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'type-n7ngd' },
	                                            _react2.default.createElement(
	                                                'b',
	                                                null,
	                                                'Mode of Payment'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'key-po' },
	                                            _react2.default.createElement(
	                                                'p',
	                                                null,
	                                                ' ',
	                                                _this.state.mopList.map(function (item) {
	                                                    if (item.id == _this.state.modeofpayment) {
	                                                        return item.payment_name;
	                                                    }
	                                                })
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-4' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'type-n7ngd' },
	                                            _react2.default.createElement(
	                                                'b',
	                                                null,
	                                                'Operating hours'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'key-po' },
	                                            _react2.default.createElement(
	                                                'p',
	                                                null,
	                                                _this.state.timing
	                                            )
	                                        )
	                                    ),
	                                    _this.state.category == 110 && _react2.default.createElement(
	                                        _react2.default.Fragment,
	                                        null,
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'col-md-4' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'type-n7ngd' },
	                                                _react2.default.createElement(
	                                                    'b',
	                                                    null,
	                                                    'Food '
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'key-po' },
	                                                _react2.default.createElement(
	                                                    'p',
	                                                    null,
	                                                    _this.state.food
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'col-md-4' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'type-n7ngd' },
	                                                _react2.default.createElement(
	                                                    'b',
	                                                    null,
	                                                    'Hall Capacity'
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'key-po' },
	                                                _react2.default.createElement(
	                                                    'p',
	                                                    null,
	                                                    _this.state.hall_capacity
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'col-md-4' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'type-n7ngd' },
	                                                _react2.default.createElement(
	                                                    'b',
	                                                    null,
	                                                    'Dinning Hall Capacity'
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'key-po' },
	                                                _react2.default.createElement(
	                                                    'p',
	                                                    null,
	                                                    _this.state.dinning_hall_capacity
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'col-md-4' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'type-n7ngd' },
	                                                _react2.default.createElement(
	                                                    'b',
	                                                    null,
	                                                    'Car Parking'
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'key-po' },
	                                                _react2.default.createElement(
	                                                    'p',
	                                                    null,
	                                                    _this.state.car_parking
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'col-md-4' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'type-n7ngd' },
	                                                _react2.default.createElement(
	                                                    'b',
	                                                    null,
	                                                    'Two Wheeler Parking'
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'key-po' },
	                                                _react2.default.createElement(
	                                                    'p',
	                                                    null,
	                                                    _this.state.two_wheeler_parking
	                                                )
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-4' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'type-n7ngd' },
	                                            _react2.default.createElement(
	                                                'b',
	                                                null,
	                                                'Facebook'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'key-po' },
	                                            _react2.default.createElement(
	                                                'p',
	                                                null,
	                                                _this.state.facebook
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-4' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'type-n7ngd' },
	                                            _react2.default.createElement(
	                                                'b',
	                                                null,
	                                                'Twitter'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'key-po' },
	                                            _react2.default.createElement(
	                                                'p',
	                                                null,
	                                                _this.state.twitter
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-4' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'type-n7ngd' },
	                                            _react2.default.createElement(
	                                                'b',
	                                                null,
	                                                'Phone No'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'key-po' },
	                                            _react2.default.createElement(
	                                                'p',
	                                                null,
	                                                _this.state.phone_number
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactstrap.Row,
	                        { className: 'pv-section' },
	                        _react2.default.createElement(
	                            _reactstrap.Col,
	                            { className: '', md: '12' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'title-section' },
	                                _react2.default.createElement(
	                                    'h4',
	                                    null,
	                                    'Gallery'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'row' },
	                                    _this.state.attachment_file.map(function (item) {
	                                        console.log('********', item);
	                                        if (item.image_thumb) {
	                                            return _react2.default.createElement(
	                                                'div',
	                                                { className: 'col-md-4' },
	                                                _react2.default.createElement('img', { src: item.image_thumb, className: 'preview-image' })
	                                            );
	                                        } else if (item.name) {
	                                            var file_url = URL.createObjectURL(item);
	                                            return _react2.default.createElement(
	                                                'div',
	                                                { className: 'col-md-4' },
	                                                _react2.default.createElement('img', { src: file_url, className: 'preview-image' })
	                                            );
	                                        }
	                                    }),
	                                    _this.state.attachment_file.length === 0 && _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-4' },
	                                        'No Gallery Images Found'
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactstrap.Row,
	                        { className: 'pv-section' },
	                        _react2.default.createElement(
	                            _reactstrap.Col,
	                            { className: '', md: '12' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'title-section' },
	                                _react2.default.createElement(
	                                    'h4',
	                                    null,
	                                    'Contact Information'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'row' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-4' },
	                                        'Email Id : ',
	                                        _this.state.email_id
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-4' },
	                                        'Contact : ',
	                                        _this.state.phone_number
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-4' },
	                                        'Website : ',
	                                        _this.state.website
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactstrap.Row,
	                        { className: 'pv-section' },
	                        _react2.default.createElement(
	                            _reactstrap.Col,
	                            { className: '', md: '12' },
	                            _react2.default.createElement(
	                                'button',
	                                { className: 'btn btn-sm btn-primary custome-submit', onClick: _this.handleSubmit },
	                                _this.state.edited && _this.state.role == 1 ? 'Approve' : 'Submit'
	                            ),
	                            _this.state.edited && _this.state.role == 1 && _react2.default.createElement(
	                                'button',
	                                { className: 'btn btn-sm btn-danger custome-submit', style: { marginLeft: '10px' },
	                                    onClick: _this.handleReject },
	                                'Reject'
	                            ),
	                            _react2.default.createElement(
	                                'button',
	                                { className: 'btn btn-sm btn-defult custome-submit', style: { marginLeft: '10px' },
	                                    onClick: function onClick() {
	                                        _this.setState({ preview: false });
	                                    } },
	                                'Close'
	                            )
	                        )
	                    )
	                )
	            );
	        };
	
	        _this.handleReject = function (e) {
	            e.preventDefault();
	            var req = JSON.stringify({
	                id: _this.state.getId
	            });
	            var toastr = '';
	            (0, _FetchCall.eventReject)(req).then(function (res) {
	                if (res.status === 1) {
	                    toastr = window.toastr.success;
	                    toastr('success', {
	                        positionClass: "toast-bottom-right",
	                        containerId: "toast-bottom-right"
	                    });
	                    window.location.href = document.referrer;
	                }
	            });
	        };
	
	        _this.handleSubmit = function (e) {
	            e.preventDefault();
	            if (_this.validator.allValid()) {
	                var indData = {
	                    getId: _this.state.getId,
	                    registration_no: _this.state.registration_no,
	                    org_name: _this.state.org_name,
	                    sub_categories: _this.state.sub_categories,
	                    contact_person: _this.state.contact_person,
	                    email_id: _this.state.email_id,
	                    phone_number: _this.state.phone_number,
	                    website: _this.state.website,
	                    facebook: _this.state.facebook,
	                    tution_type: _this.state.tution_type,
	                    twitter: _this.state.twitter,
	                    event_fee: _this.state.avg_fee,
	                    google_location: _this.state.google_location,
	                    address: _this.state.address,
	                    pincode: _this.state.pincode,
	                    mod_payment: _this.state.modeofpayment,
	                    food: _this.state.food,
	                    hall_capcity: _this.state.hall_capacity,
	                    dinning_capacity: _this.state.dinning_hall_capacity,
	                    car_parking_slot: _this.state.car_parking,
	                    two_parking_slot: _this.state.two_wheeler_parking,
	                    about: _this.state.about,
	                    timing: _this.state.timing,
	                    other_info: _this.state.other_info,
	                    images: _this.state.images,
	                    photos: _this.state.attachment_file,
	                    login_id: _this.state.login_id,
	                    category: _this.state.category,
	                    location: _this.state.location,
	                    state: _this.state.state,
	                    est_year: _this.state.est_year,
	                    latitude: _this.state.latitude,
	                    longitude: _this.state.longitude,
	                    other_rating: _this.state.other_rating,
	                    keywords: _this.state.keywords ? _this.state.keywords.join(';') : '',
	                    delete_array: _this.state.delete_array,
	                    partner_type: _this.state.partner_type,
	                    role: _this.state.role
	                    // jQuery("#btnSubmit").attr('disabled', true);
	                };(0, _FetchCall.AddSuppliers)(indData).then(function (res) {
	                    var toastr = '';
	                    if (res.status === 1) {
	                        alert("Created successfully");
	
	                        window.location.href = document.referrer;
	                    } else {
	                        (0, _jquery2.default)("#btnSubmit").attr('disabled', false);
	                        alert("Error");
	                    }
	                });
	            } else {
	                _this.validator.showMessages();
	                _this.forceUpdate();
	            }
	        };
	
	        _this.state = {
	            vendor_id: 1,
	            pageid: '',
	            categoryTypeList: [],
	            subCategory: false,
	            modeofpayment: '1',
	            registration_no: '',
	            org_name: '',
	            sub_categories: '',
	            contact_person: '',
	            email_id: '',
	            phone_number: '',
	            website: '',
	            facebook: '',
	            twitter: '',
	            event_fee: '',
	            google_location: '',
	            address: '',
	            pincode: '',
	            mod_payment: '',
	            food: '',
	            hall_capcity: '',
	            dinning_capacity: '',
	            car_parking_slot: '',
	            two_parking_slot: '',
	            about: '',
	            timing: '',
	            other_info: '',
	            images: '',
	            photos: '',
	            location: 'Bengaluru',
	            state: '',
	            est_year: '',
	            venueTypeList: [],
	            mopList: [],
	            category: _this.props.match.params.ids,
	            getId: _this.props.match.params.seditid ? _this.props.match.params.seditid : '',
	            latitude: '',
	            longitude: '',
	            other_rating: '',
	            tution_type: '',
	            tutionList: [],
	            typeListBool: false,
	            attachment_file: [],
	            attachment_file_length: 0,
	            attachment_fileName: [],
	            edit_image: '',
	            delete_array: [],
	            location_list: [],
	            tempBanner: '',
	            partner_type: '',
	            preview: false,
	            edited_data: [],
	            keywordsArr: [],
	            edited: false
	        };
	        _this.validator = new _simpleReactValidator2.default({
	            validators: {
	                checkExist: { // name the rule
	                    message: 'The :attribute field is required.',
	                    rule: function rule(val, params, validator) {
	                        if (val == '' && _this.state.edit_image == '') {
	                            return false;
	                        }
	                    },
	                    messageReplace: function messageReplace(message, params) {
	                        return message.replace(':values', _this.helpers.toSentence(params));
	                    }, // optional
	                    required: true // optional
	                },
	                emailExist_check: { // name the rule
	                    message: 'The :attribute Already Exist.',
	                    rule: function rule(val, params, validator) {
	                        return _this.state.isEmailValid;
	                    },
	                    messageReplace: function messageReplace(message, params) {
	                        return message.replace(':values', _this.helpers.toSentence(params));
	                    }, // optional
	                    required: true // optional
	                },
	                checkMobile: _constant.MOBILE_REGEX,
	                checkUrl: _constant.URL_REGEX
	            }
	        });
	        _this.loadFile = _this.loadFile.bind(_this);
	        _this.Cat_type();_this.tutionList();_this.venue_type();_this.getpayment_type();_this.getKeywords();
	        return _this;
	    }
	
	    _createClass(verticalEventsEdit, [{
	        key: 'tutionList',
	        value: function () {
	            var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	                var response;
	                return _regenerator2.default.wrap(function _callee2$(_context2) {
	                    while (1) {
	                        switch (_context2.prev = _context2.next) {
	                            case 0:
	                                _context2.next = 2;
	                                return _FetchCall2.default.getSchoolListDatas('tution_type');
	
	                            case 2:
	                                response = _context2.sent;
	
	                                console.log(response);
	                                if (response) {
	                                    this.setState({ tutionList: response.results });
	                                }
	
	                            case 5:
	                            case 'end':
	                                return _context2.stop();
	                        }
	                    }
	                }, _callee2, this);
	            }));
	
	            function tutionList() {
	                return _ref2.apply(this, arguments);
	            }
	
	            return tutionList;
	        }()
	    }, {
	        key: 'getpayment_type',
	        value: function () {
	            var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	                var response;
	                return _regenerator2.default.wrap(function _callee3$(_context3) {
	                    while (1) {
	                        switch (_context3.prev = _context3.next) {
	                            case 0:
	                                _context3.next = 2;
	                                return _FetchCall2.default.getSchoolListDatas('payment_type');
	
	                            case 2:
	                                response = _context3.sent;
	
	                                console.log(response);
	                                if (response.status == 1) {
	                                    this.setState({ mopList: response.results });
	                                }
	
	                            case 5:
	                            case 'end':
	                                return _context3.stop();
	                        }
	                    }
	                }, _callee3, this);
	            }));
	
	            function getpayment_type() {
	                return _ref3.apply(this, arguments);
	            }
	
	            return getpayment_type;
	        }()
	    }, {
	        key: 'Cat_type',
	        value: function () {
	            var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4() {
	                var response;
	                return _regenerator2.default.wrap(function _callee4$(_context4) {
	                    while (1) {
	                        switch (_context4.prev = _context4.next) {
	                            case 0:
	                                _context4.next = 2;
	                                return _FetchCall2.default.getSubCategory('4');
	
	                            case 2:
	                                response = _context4.sent;
	
	                                // console.log('categoryTypeList', response);
	                                if (response.status == 1) {
	                                    this.setState({ categoryTypeList: response.results });
	                                }
	
	                            case 4:
	                            case 'end':
	                                return _context4.stop();
	                        }
	                    }
	                }, _callee4, this);
	            }));
	
	            function Cat_type() {
	                return _ref4.apply(this, arguments);
	            }
	
	            return Cat_type;
	        }()
	    }, {
	        key: 'venue_type',
	        value: function () {
	            var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5() {
	                var response;
	                return _regenerator2.default.wrap(function _callee5$(_context5) {
	                    while (1) {
	                        switch (_context5.prev = _context5.next) {
	                            case 0:
	                                _context5.next = 2;
	                                return _FetchCall2.default.getSubCategory('110');
	
	                            case 2:
	                                response = _context5.sent;
	
	                                // console.log('categoryTypeList', response);
	                                if (response.status == 1) {
	                                    this.setState({ venueTypeList: response.results });
	                                }
	
	                            case 4:
	                            case 'end':
	                                return _context5.stop();
	                        }
	                    }
	                }, _callee5, this);
	            }));
	
	            function venue_type() {
	                return _ref5.apply(this, arguments);
	            }
	
	            return venue_type;
	        }()
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.LocationDataList();
	            if (this.state.getId) {
	                this.getevent();
	            }
	            var user_data = localStorage.getItem("user_data");
	            var auth_data = JSON.parse(user_data);
	            var vendor_id = auth_data.login_id;
	            this.setState({
	                login_id: vendor_id,
	                role: auth_data.role
	            });
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            window.jQuery('.selectpicker').selectpicker('refresh');
	        }
	    }, {
	        key: 'getevent',
	        value: function () {
	            var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee6() {
	                var response, _setState, data, edited_data;
	
	                return _regenerator2.default.wrap(function _callee6$(_context6) {
	                    while (1) {
	                        switch (_context6.prev = _context6.next) {
	                            case 0:
	                                _context6.next = 2;
	                                return (0, _FetchCall.eventEdit)(JSON.stringify({ id: this.state.getId }));
	
	                            case 2:
	                                response = _context6.sent;
	
	                                // console.log(response);
	                                if (response.status == 1) {
	                                    data = response.data, edited_data = response.original;
	
	                                    this.setState((_setState = {
	                                        registration_no: data.registration_no,
	                                        pageid: data.id,
	                                        org_name: data.org_name,
	                                        sub_categories: data.sub_categories.split(','),
	                                        contact_person: data.contact_person,
	                                        email_id: data.email_id,
	                                        tution_type: data.tution_type
	                                    }, _defineProperty(_setState, 'email_id', data.email_id), _defineProperty(_setState, 'phone_number', data.phone_number), _defineProperty(_setState, 'website', data.website), _defineProperty(_setState, 'facebook', data.facebook), _defineProperty(_setState, 'twitter', data.twitter), _defineProperty(_setState, 'avg_fee', data.event_fee), _defineProperty(_setState, 'google_location', data.google_location), _defineProperty(_setState, 'address', data.address), _defineProperty(_setState, 'pincode', data.pincode), _defineProperty(_setState, 'modeofpayment', data.mod_payment), _defineProperty(_setState, 'food', data.food != '' ? data.food : ''), _defineProperty(_setState, 'hall_capacity', data.hall_capcity != undefined ? data.hall_capcity : ''), _defineProperty(_setState, 'dinning_hall_capacity', data.dinning_capacity != undefined ? data.dinning_capacity : ''), _defineProperty(_setState, 'car_parking', data.car_parking_slot != undefined ? data.car_parking_slot : ''), _defineProperty(_setState, 'two_wheeler_parking', data.two_parking_slot != undefined ? data.two_parking_slot : ''), _defineProperty(_setState, 'about', data.about), _defineProperty(_setState, 'timing', data.timing), _defineProperty(_setState, 'other_info', data.other_info), _defineProperty(_setState, 'images', data.images), _defineProperty(_setState, 'category', data.category), _defineProperty(_setState, 'location', data.location), _defineProperty(_setState, 'state', data.state), _defineProperty(_setState, 'est_year', data.est_year), _defineProperty(_setState, 'attachment_file', data.photo_arr), _defineProperty(_setState, 'edit_image', data.images ? data.url + data.images : ''), _defineProperty(_setState, 'edit_photos', data.photos), _defineProperty(_setState, 'photos', data.photos), _defineProperty(_setState, 'images', data.images), _defineProperty(_setState, 'keywords', data.keywords ? data.keywords.split(';') : []), _defineProperty(_setState, 'from_time', data.from_time), _defineProperty(_setState, 'to_time', data.to_time), _defineProperty(_setState, 'from_time_cate', data.from_time_cate), _defineProperty(_setState, 'to_time_cate', data.to_time_cate), _defineProperty(_setState, 'longitude', data.longitude), _defineProperty(_setState, 'latitude', data.latitude), _defineProperty(_setState, 'other_rating', data.other_rating), _defineProperty(_setState, 'partner_type', data.partner_type), _defineProperty(_setState, 'edited', data.edited), _defineProperty(_setState, 'edited_data', edited_data), _setState));
	                                    this.Geocode_location(data.google_location);
	                                }
	
	                            case 4:
	                            case 'end':
	                                return _context6.stop();
	                        }
	                    }
	                }, _callee6, this);
	            }));
	
	            function getevent() {
	                return _ref6.apply(this, arguments);
	            }
	
	            return getevent;
	        }()
	    }, {
	        key: 'UNSAFE_componentWillMount',
	        value: function UNSAFE_componentWillMount() {}
	    }, {
	        key: 'Geocode_location',
	        value: function Geocode_location() {
	            var _this3 = this;
	
	            var location = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	            _reactGeocode2.default.fromAddress(location ? location : this.state.google_location).then(function (response) {
	                var _response$results$0$g = response.results[0].geometry.location,
	                    lat = _response$results$0$g.lat,
	                    lng = _response$results$0$g.lng;
	
	                if (lat && lng) _this3.get_location(lat, lng);
	            }, function (error) {
	                console.error(error);
	            });
	        }
	    }, {
	        key: 'get_location',
	        value: function get_location(lat, lng) {
	            this.setState({
	                latitude: lat,
	                longitude: lng
	            });
	        }
	    }, {
	        key: 'remove_img',
	        value: function remove_img() {
	            (0, _jquery2.default)('#edit_image').remove();
	        }
	    }, {
	        key: 'loadFile',
	        value: function loadFile(e) {
	            var files = e.target.files;
	            this.setState({ attachment_file_length: files.length });
	            if (files.length > 0) {
	                (0, _jquery2.default)('.upload-space').addClass('hide');
	                (0, _jquery2.default)('.upload-thumb').removeClass('hide');
	                var fileArra = this.state.attachment_file;
	
	                //console.log('fileArra',fileArra)
	                //var fileThumbArra = this.state.imgThumb;
	                for (var i = 0; i < files.length; i++) {
	                    fileArra.push(e.target.files[i]);
	                    this.setState({
	                        selectedFile: URL.createObjectURL(e.target.files[i]),
	                        attachment_file: fileArra
	                    });
	                }
	                this.clearValidationErr('attachment_file');
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this4 = this;
	
	            var _state = this.state,
	                edited_data = _state.edited_data,
	                edited = _state.edited;
	
	            this.validator.purgeFields();
	
	            return _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _react2.default.createElement(
	                    _layout2.default,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { 'class': 'col-lg-12 grid-margin stretch-card' },
	                        _react2.default.createElement(
	                            'div',
	                            { 'class': 'card' },
	                            _react2.default.createElement(
	                                'div',
	                                { 'class': 'card-body' },
	                                _react2.default.createElement(
	                                    'h4',
	                                    { 'class': 'card-title' },
	                                    'Tuition Info Management'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'row' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'content-sec col-md-12 col-xs-12 pad-no mar-t-no' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: '' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { id: 'company-info', className: 'tab-pane active' },
	                                                _react2.default.createElement(
	                                                    'form',
	                                                    { onSubmit: this.handlePreview, className: 'custom-form invoice-form col-md-12 col-xs-12 legend-form pad-no' },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'box-shadow-custom' },
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'row' },
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    null,
	                                                                    'Partner Type',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    { className: 'custom-select-drop dropdown' },
	                                                                    _react2.default.createElement(
	                                                                        'select',
	                                                                        {
	                                                                            value: this.state.partner_type,
	                                                                            onChange: this.handleSelect, className: 'form-control selectpicker',
	                                                                            name: 'partner_type',
	                                                                            title: 'Select' },
	                                                                        _react2.default.createElement(
	                                                                            'option',
	                                                                            { value: '1' },
	                                                                            'Institution'
	                                                                        ),
	                                                                        _react2.default.createElement(
	                                                                            'option',
	                                                                            { value: '2' },
	                                                                            'Individuals'
	                                                                        )
	                                                                    ),
	                                                                    this.validator.message('Type', this.state.partner_type, 'required', { className: 'text-danger' })
	                                                                )
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.registration_no != this.state.registration_no && 'edited-field' },
	                                                                    'Registration No ',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('input', { type: 'text', name: 'registration_no', value: this.state.registration_no,
	                                                                    onChange: this.handleChange, className: 'form-control' }),
	                                                                this.validator.message('Registration No', this.state.registration_no, 'required', { className: 'text-danger' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.org_name != this.state.org_name && 'edited-field' },
	                                                                    'Name',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('input', { type: 'text', name: 'org_name',
	                                                                    value: this.state.org_name,
	                                                                    onChange: this.handleChange, className: 'form-control' }),
	                                                                this.validator.message('Name', this.state.org_name, 'required', { className: 'text-danger' })
	                                                            )
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'box-shadow-custom' },
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'row' },
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'col-md-12 col-xs-12' },
	                                                                _react2.default.createElement(
	                                                                    'span',
	                                                                    { className: 'form-legend' },
	                                                                    'Key Information'
	                                                                )
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.contact_person != this.state.contact_person && 'edited-field' },
	                                                                    'Contact Person',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('input', { type: 'text', name: 'contact_person', value: this.state.contact_person,
	                                                                    onChange: this.handleChange, className: 'form-control' }),
	                                                                this.validator.message('Contact Person', this.state.contact_person, 'required', { className: 'text-danger' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.email_id != this.state.email_id && 'edited-field' },
	                                                                    'Email Id ',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('input', { type: 'text', name: 'email_id',
	                                                                    value: this.state.email_id,
	                                                                    onChange: this.handleChange, className: 'form-control' }),
	                                                                this.validator.message('Email Id', this.state.email_id, 'emailExist_check', { className: 'text-danger' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.phone_number != this.state.phone_number && 'edited-field' },
	                                                                    'Phone No ',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('input', { type: 'text', name: 'phone_number',
	                                                                    value: this.state.phone_number,
	                                                                    onChange: this.handleChange, className: 'form-control' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.state != this.state.state && 'edited-field' },
	                                                                    'State',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('input', { type: 'text', name: 'state',
	                                                                    value: this.state.state,
	                                                                    onChange: this.handleChange, className: 'form-control' }),
	                                                                this.validator.message('State', this.state.state, 'required', { className: 'text-danger' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.location != this.state.location && 'edited-field' },
	                                                                    'Location',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'select',
	                                                                    {
	                                                                        name: 'location',
	                                                                        id: 'location',
	                                                                        onChange: this.handleSelect,
	                                                                        value: this.state.location,
	                                                                        className: 'form-control selectpicker',
	                                                                        title: 'Select'
	                                                                    },
	                                                                    this.state.location_list.length > 0 && this.state.location_list.map(function (item, i) {
	                                                                        return _react2.default.createElement(
	                                                                            'option',
	                                                                            { value: item.location },
	                                                                            item.location
	                                                                        );
	                                                                    })
	                                                                ),
	                                                                this.validator.message('Location', this.state.location, 'required', { className: 'text-danger' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.website != this.state.website && 'edited-field' },
	                                                                    'Website',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('input', { type: 'text', name: 'website',
	                                                                    value: this.state.website,
	                                                                    onChange: this.handleChange, className: 'form-control' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.facebook != this.state.facebook && 'edited-field' },
	                                                                    'Facebook',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('input', { type: 'text', name: 'facebook',
	                                                                    value: this.state.facebook,
	                                                                    onChange: this.handleChange, className: 'form-control' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.tution_type != this.state.tution_type && 'edited-field' },
	                                                                    'Type',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    { className: 'custom-select-drop dropdown' },
	                                                                    _react2.default.createElement(
	                                                                        'select',
	                                                                        {
	                                                                            value: this.state.tution_type,
	                                                                            onChange: this.handleSelect, className: 'form-control selectpicker',
	                                                                            name: 'tution_type', title: 'Select' },
	                                                                        this.state.tutionList.length > 0 && this.state.tutionList.map(function (item, i) {
	                                                                            return _react2.default.createElement(
	                                                                                'option',
	                                                                                { value: item.id },
	                                                                                item.name
	                                                                            );
	                                                                        })
	                                                                    ),
	                                                                    this.validator.message('Type', this.state.tution_type, 'required', { className: 'text-danger' })
	                                                                )
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.twitter != this.state.twitter && 'edited-field' },
	                                                                    'Twitter',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('input', { type: 'text', name: 'twitter',
	                                                                    value: this.state.twitter,
	                                                                    onChange: this.handleChange, className: 'form-control' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.avg_fee != this.state.avg_fee && 'edited-field' },
	                                                                    'Avg Price ',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('input', { type: 'text', name: 'avg_fee', value: this.state.avg_fee,
	                                                                    onChange: this.handleChange, className: 'form-control' }),
	                                                                this.validator.message('Avg Price', this.state.avg_fee, 'required', { className: 'text-danger' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.est_year != this.state.est_year && 'edited-field' },
	                                                                    'Established Year ',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('input', { type: 'text', name: 'est_year', value: this.state.est_year,
	                                                                    onChange: this.handleChange, className: 'form-control' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.address != this.state.address && 'edited-field' },
	                                                                    'Address',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('input', { type: 'text', name: 'address',
	                                                                    value: this.state.address,
	                                                                    onChange: this.handleChange, className: 'form-control' }),
	                                                                this.validator.message('Address', this.state.address, 'required', { className: 'text-danger' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.google_location != this.state.google_location && 'edited-field' },
	                                                                    'Google Location Address',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('input', { type: 'text', name: 'google_location', value: this.state.google_location,
	                                                                    onChange: this.handleChange, className: 'form-control' }),
	                                                                this.validator.message('Google Location', this.state.google_location, 'required', { className: 'text-danger' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.latitude != this.state.latitude && 'edited-field' },
	                                                                    'Latitude',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('input', {
	                                                                    type: 'text',
	                                                                    name: 'latitude',
	                                                                    value: this.state.latitude,
	                                                                    onChange: this.handleChange,
	
	                                                                    className: 'form-control'
	                                                                }),
	                                                                this.validator.message('Latitude', this.state.latitude, 'required', { className: 'text-danger' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.longitude != this.state.longitude && 'edited-field' },
	                                                                    'Longitude',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('input', {
	                                                                    type: 'text',
	                                                                    name: 'longitude',
	                                                                    value: this.state.longitude,
	                                                                    onChange: this.handleChange,
	
	                                                                    className: 'form-control'
	                                                                }),
	                                                                this.validator.message('Longitude', this.state.longitude, 'required', { className: 'text-danger' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.other_rating != this.state.other_rating && 'edited-field' },
	                                                                    'Google Rating',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('input', {
	                                                                    type: 'number',
	                                                                    step: '0.01',
	                                                                    name: 'other_rating',
	                                                                    value: this.state.other_rating,
	                                                                    onChange: this.handleChange,
	                                                                    max: '5',
	                                                                    className: 'form-control'
	                                                                }),
	                                                                this.validator.message('Google Rating', this.state.other_rating, 'required', { className: 'text-danger' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.pincode != this.state.pincode && 'edited-field' },
	                                                                    'Pincode',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('input', { type: 'text', name: 'pincode',
	                                                                    value: this.state.pincode,
	                                                                    onChange: this.handleChange, className: 'form-control' }),
	                                                                this.validator.message('Pincode', this.state.pincode, 'required', { className: 'text-danger' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.mod_payment != this.state.modeofpayment && 'edited-field' },
	                                                                    'Mode of Payment',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    { className: 'custom-select-drop dropdown' },
	                                                                    _react2.default.createElement(
	                                                                        'select',
	                                                                        {
	                                                                            value: this.state.modeofpayment,
	                                                                            name: 'modeofpayment',
	                                                                            id: 'modeofpayment',
	                                                                            onChange: this.handleSelect,
	                                                                            className: 'form-control selectpicker',
	                                                                            title: 'Select'
	                                                                        },
	                                                                        this.state.mopList.length > 0 && this.state.mopList.map(function (item, i) {
	                                                                            return _react2.default.createElement(
	                                                                                'option',
	                                                                                { value: item.id },
	                                                                                item.payment_name
	                                                                            );
	                                                                        })
	                                                                    ),
	                                                                    this.validator.message('Mode of Payment', this.state.modeofpayment, 'required', { className: 'text-danger' })
	                                                                )
	                                                            ),
	                                                            this.state.category == 110 ? _react2.default.createElement(
	                                                                'span',
	                                                                null,
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    { className: 'form-group col-md-4' },
	                                                                    _react2.default.createElement(
	                                                                        'label',
	                                                                        {
	                                                                            className: edited && edited_data.food != this.state.food && 'edited-field' },
	                                                                        'Food ',
	                                                                        _react2.default.createElement(
	                                                                            'span',
	                                                                            { className: 'astrick' },
	                                                                            '*'
	                                                                        )
	                                                                    ),
	                                                                    _react2.default.createElement('input', { type: 'text', name: 'food',
	                                                                        value: this.state.food,
	                                                                        placeholder: 'Veg and Non Veg',
	                                                                        onChange: this.handleChange, className: 'form-control' }),
	                                                                    this.validator.message('Food', this.state.food, 'required', { className: 'text-danger' })
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    { className: 'form-group col-md-4' },
	                                                                    _react2.default.createElement(
	                                                                        'label',
	                                                                        {
	                                                                            className: edited && edited_data.hall_capacity != this.state.hall_capacity && 'edited-field' },
	                                                                        'Hall Capacity ',
	                                                                        _react2.default.createElement(
	                                                                            'span',
	                                                                            { className: 'astrick' },
	                                                                            '*'
	                                                                        )
	                                                                    ),
	                                                                    _react2.default.createElement('input', { type: 'text', name: 'hall_capacity',
	                                                                        value: this.state.hall_capacity,
	                                                                        placeholder: '40 - 2000',
	                                                                        onChange: this.handleChange, className: 'form-control' }),
	                                                                    this.validator.message('Hall Capacity', this.state.hall_capacity, 'required', { className: 'text-danger' })
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    { className: 'form-group col-md-4' },
	                                                                    _react2.default.createElement(
	                                                                        'label',
	                                                                        {
	                                                                            className: edited && edited_data.dinning_capacity != this.state.dinning_hall_capacity && 'edited-field' },
	                                                                        'Dinning Hall Capacity',
	                                                                        _react2.default.createElement(
	                                                                            'span',
	                                                                            { className: 'astrick' },
	                                                                            '*'
	                                                                        )
	                                                                    ),
	                                                                    _react2.default.createElement('input', { type: 'text', name: 'dinning_hall_capacity',
	                                                                        value: this.state.dinning_hall_capacity,
	                                                                        placeholder: '500',
	                                                                        onChange: this.handleChange, className: 'form-control' }),
	                                                                    this.validator.message('Dinning Hall Capacity', this.state.dinning_hall_capacity, 'required', { className: 'text-danger' })
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    { className: 'form-group col-md-4' },
	                                                                    _react2.default.createElement(
	                                                                        'label',
	                                                                        {
	                                                                            className: edited && edited_data.car_parking_slot != this.state.car_parking && 'edited-field' },
	                                                                        'Car Parking',
	                                                                        _react2.default.createElement(
	                                                                            'span',
	                                                                            { className: 'astrick' },
	                                                                            '*'
	                                                                        )
	                                                                    ),
	                                                                    _react2.default.createElement('input', { type: 'text', name: 'car_parking',
	                                                                        value: this.state.car_parking,
	                                                                        placeholder: '60',
	                                                                        onChange: this.handleChange, className: 'form-control' }),
	                                                                    this.validator.message('Dinning Hall Capacity', this.state.car_parking, 'required', { className: 'text-danger' })
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    { className: 'form-group col-md-4' },
	                                                                    _react2.default.createElement(
	                                                                        'label',
	                                                                        {
	                                                                            className: edited && edited_data.two_parking_slot != this.state.two_wheeler_parking && 'edited-field' },
	                                                                        'Two Wheeler Parking',
	                                                                        _react2.default.createElement(
	                                                                            'span',
	                                                                            { className: 'astrick' },
	                                                                            '*'
	                                                                        )
	                                                                    ),
	                                                                    _react2.default.createElement('input', { type: 'text', name: 'two_wheeler_parking',
	                                                                        value: this.state.two_wheeler_parking,
	                                                                        placeholder: '190',
	                                                                        onChange: this.handleChange, className: 'form-control' }),
	                                                                    this.validator.message('Two Wheeler Parking', this.state.two_wheeler_parking, 'required', { className: 'text-danger' })
	                                                                )
	                                                            ) : '',
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.timing != this.state.timing && 'edited-field' },
	                                                                    'Operating hours',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('input', { type: 'text', name: 'timing',
	                                                                    value: this.state.timing,
	                                                                    onChange: this.handleChange, className: 'form-control' }),
	                                                                this.validator.message('Operating hours', this.state.timing, 'required', { className: 'text-danger' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.about != this.state.about && 'edited-field' },
	                                                                    'About',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('textarea', { type: 'text', name: 'about',
	                                                                    value: this.state.about,
	                                                                    onChange: this.handleChange, className: 'form-control' }),
	                                                                this.validator.message('About', this.state.about, 'required', { className: 'text-danger' })
	                                                            )
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'box-shadow-custom' },
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'row' },
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'col-md-12 col-xs-12' },
	                                                                _react2.default.createElement(
	                                                                    'span',
	                                                                    { className: 'form-legend' },
	                                                                    'Other Information'
	                                                                )
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.keywords != this.state.keywords && 'edited-field' },
	                                                                    'Keywords',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement(_multiselectReactDropdown.Multiselect, {
	                                                                    isObject: false,
	                                                                    options: this.state.keywordsArr // Options to display in the dropdown
	                                                                    , selectedValues: this.state.keywords // Preselected value to persist in dropdown
	                                                                    , onSelect: this.onSelect // Function will trigger on select event
	                                                                    , onRemove: this.onRemove // Function will trigger on remove event
	                                                                })
	                                                            )
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'box-shadow-custom' },
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'row' },
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'col-md-12 col-xs-12' },
	                                                                _react2.default.createElement(
	                                                                    'span',
	                                                                    { className: 'form-legend' },
	                                                                    'Images'
	                                                                )
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.images != this.state.images && 'edited-field' },
	                                                                    'Banner Image ',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('input', {
	                                                                    type: 'file',
	                                                                    name: 'images',
	                                                                    onChange: this.handleFile,
	                                                                    className: 'form-control'
	                                                                }),
	                                                                this.validator.message('Banner Image', this.state.images, '', { className: 'text-danger error-msg' })
	                                                            ),
	                                                            (this.state.edit_image != '' || this.state.tempBanner != '') && _react2.default.createElement(
	                                                                'div',
	                                                                { 'class': 'col-md-2 col-sm-12 mar-btm', id: 'edit_image' },
	                                                                _react2.default.createElement('img', { src: this.state.tempBanner ? this.state.tempBanner : this.state.edit_image, alt: 'Img', 'class': 'img-thumbnail' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { 'class': 'col-md-12 float-left mt-4 p-0' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.photos != this.state.photos && 'edited-field' },
	                                                                    'Gallery Images ',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                )
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { 'class': 'col-md-12 float-left mt-4 p-0' },
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    { 'class': 'col-md-12 margin-bottom-mobile-account float-left image-upload' },
	                                                                    _react2.default.createElement(
	                                                                        'div',
	                                                                        { className: 'upload-wizard' },
	                                                                        _react2.default.createElement(
	                                                                            'div',
	                                                                            { className: 'upload-thumb' },
	                                                                            _react2.default.createElement(
	                                                                                'ul',
	                                                                                { className: 'list-inline' },
	                                                                                this.state.attachment_file.map(function (file_data, index) {
	
	                                                                                    var file_url;
	                                                                                    if (file_data.name) {
	                                                                                        var _url = file_data.image_thumb ? file_data.image_thumb : '';
	                                                                                        if (_url != '') {
	                                                                                            file_url = file_data.image_thumb;
	                                                                                        } else {
	                                                                                            file_url = URL.createObjectURL(file_data);
	                                                                                        }
	
	                                                                                        // var file_url = URL.createObjectURL(file_data)
	                                                                                        // var file_name = file_data.name
	                                                                                        if (file_data.type === 'application/pdf') {
	                                                                                            var blob = file_url;
	                                                                                            //console.log('blob_url', file_data.name)
	                                                                                            return _react2.default.createElement(
	                                                                                                'li',
	                                                                                                { className: 'previewImg' },
	                                                                                                _react2.default.createElement(
	                                                                                                    'div',
	                                                                                                    { className: 'thumb-img' },
	                                                                                                    _react2.default.createElement('img', {
	                                                                                                        src: file_url,
	                                                                                                        alt: 'image',
	                                                                                                        title: file_data.name
	                                                                                                    })
	                                                                                                ),
	                                                                                                _react2.default.createElement(
	                                                                                                    'a',
	                                                                                                    {
	                                                                                                        href: 'javascript:;',
	                                                                                                        className: 'del-btn',
	                                                                                                        onClick: function onClick() {
	                                                                                                            _this4.removeImage(file_data.name);
	                                                                                                        }
	                                                                                                    },
	                                                                                                    _react2.default.createElement('img', {
	                                                                                                        src: '../../../assets/images/close-icon-white.svg',
	                                                                                                        alt: 'delete'
	                                                                                                    })
	                                                                                                )
	                                                                                            );
	                                                                                        } else {
	                                                                                            return _react2.default.createElement(
	                                                                                                'li',
	                                                                                                { className: 'previewImg' },
	                                                                                                _react2.default.createElement(
	                                                                                                    'div',
	                                                                                                    { className: 'thumb-img' },
	                                                                                                    _react2.default.createElement('img', {
	                                                                                                        src: file_url,
	                                                                                                        alt: 'image',
	                                                                                                        title: file_data.name
	                                                                                                    })
	                                                                                                ),
	                                                                                                _react2.default.createElement(
	                                                                                                    'a',
	                                                                                                    {
	                                                                                                        href: 'javascript:;',
	                                                                                                        className: 'del-btn',
	                                                                                                        onClick: function onClick() {
	                                                                                                            _this4.removeImage(file_data.name);
	                                                                                                        }
	                                                                                                    },
	                                                                                                    _react2.default.createElement('img', {
	                                                                                                        src: '../../../assets/images/close-icon-white.svg',
	                                                                                                        alt: 'delete'
	                                                                                                    })
	                                                                                                )
	                                                                                            );
	                                                                                        }
	                                                                                    }
	                                                                                }),
	                                                                                _react2.default.createElement(
	                                                                                    'li',
	                                                                                    { className: 'addMore' },
	                                                                                    _react2.default.createElement('input', {
	                                                                                        type: 'file',
	                                                                                        name: 'imgInp[]',
	                                                                                        id: 'imgInp2',
	                                                                                        className: 'add_img',
	                                                                                        multiple: true,
	                                                                                        onChange: this.loadFile.bind(this),
	                                                                                        accept: 'image/x-png,image/gif,image/jpeg'
	                                                                                    }),
	                                                                                    _react2.default.createElement(
	                                                                                        'a',
	                                                                                        { href: 'javascript:;', className: 'add-more' },
	                                                                                        _react2.default.createElement(
	                                                                                            'div',
	                                                                                            null,
	                                                                                            _react2.default.createElement('img', { src: '../../../assets/images/upload-icon.svg', alt: 'icon' }),
	                                                                                            'Add more'
	                                                                                        )
	                                                                                    )
	                                                                                )
	                                                                            )
	                                                                        )
	                                                                    )
	                                                                ),
	                                                                this.validator.message('gallery images', this.state.attachment_file, '', { className: 'text-danger error-msg' })
	                                                            )
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'col-md-12 col-xs-12 btn-bdr' },
	                                                        _react2.default.createElement(
	                                                            'button',
	                                                            { className: 'btn btn-primary btn-sm' },
	                                                            'Preview'
	                                                        )
	                                                    )
	                                                )
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    this.preview()
	                )
	            );
	        }
	    }]);
	
	    return verticalEventsEdit;
	}(_react.Component);
	
	exports.default = verticalEventsEdit;

/***/ },
/* 1031 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _FetchCall2 = _interopRequireDefault(_FetchCall);
	
	var _reactJsPagination = __webpack_require__(33);
	
	var _reactJsPagination2 = _interopRequireDefault(_reactJsPagination);
	
	var _bewiseloading = __webpack_require__(48);
	
	var _bewiseloading2 = _interopRequireDefault(_bewiseloading);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var verticalKidsPlayArea = function (_Component) {
	  _inherits(verticalKidsPlayArea, _Component);
	
	  function verticalKidsPlayArea(props) {
	    var _this2 = this,
	        _this$state;
	
	    _classCallCheck(this, verticalKidsPlayArea);
	
	    var _this = _possibleConstructorReturn(this, (verticalKidsPlayArea.__proto__ || Object.getPrototypeOf(verticalKidsPlayArea)).call(this, props));
	
	    _this.getTotal = function () {
	      var location = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	
	      var locationselected = location == '' ? _this.state.location : location;
	
	      var ins = JSON.stringify({
	        vertical: _this.state.tablename,
	        location: locationselected,
	        searchby: _this.state.searchby
	      });
	
	      (0, _FetchCall.getTotal)(ins).then(function (res) {
	
	        _this.setState({ loading: true });
	
	        if (res.status == 1) {
	
	          _this.setState({
	
	            total: res.total
	
	          });
	        }
	      });
	    };
	
	    _this.getList = function () {
	      var pageNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	      var location = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	      var _this$state$auth_data = _this.state.auth_data,
	          login_id = _this$state$auth_data.login_id,
	          role = _this$state$auth_data.role;
	
	
	      _this.setState({ activePage: pageNumber });
	
	      var newOffset = pageNumber == 1 ? 0 : (pageNumber - 1) * _this.state.PER_PAGE % _this.state.total;
	
	      var locationselected = location == '' ? _this.state.location : location;
	
	      var ins = JSON.stringify({
	        vendor_id: login_id,
	        role: role,
	        location: locationselected,
	        searchby: _this.state.searchby,
	        perpage: _this.state.PER_PAGE,
	        offset: newOffset
	      });
	
	      (0, _FetchCall.getKidsPlayAreaPaged)(ins).then(function (res) {
	
	        _this.setState({ loading: true });
	
	        if (res.status == 1) {
	
	          _this.setState({ loading: !_this.state.loading });
	
	          _this.setState({
	
	            commList: res.data
	
	          });
	        } else {
	
	          _this.setState({ loading: !_this.state.loading });
	
	          _this.setState({
	            commList: []
	          });
	        }
	      });
	    };
	
	    _this.handleSelect = function (e) {
	      _this.setState({ location: e.target.value, activePage: 1 });
	      _this.getTotal(e.target.value);
	      _this.getList(1, e.target.value);
	    };
	
	    _this.handleChange = function (e) {
	      _this.setState(_defineProperty({}, e.target.name, e.target.value));
	    };
	
	    _this.searchBy = function (e) {
	
	      _this.setState({ loading: true, activePage: 1 });
	      _this.getTotal();
	      _this.getList(1);
	    };
	
	    _this.schoolExport = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var req, res;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	
	              _this.setState({ exportbtndisabled: true, thisExportBtnText: "exporting..." });
	
	              _context.prev = 1;
	              req = JSON.stringify({
	                location: _this.state.location
	              });
	              _context.next = 5;
	              return (0, _FetchCall.exportSchool)(req);
	
	            case 5:
	              res = _context.sent;
	
	              if (res.status == 1) {
	
	                _this.setState({ exportbtndisabled: false, thisExportBtnText: "Export" });
	                console.log('location_list', res);
	                console.log('location_list', res.path);
	                window.open(res.path);
	
	                // this.setState({
	                //   subscribe_list: res.results,
	                // });
	              }
	
	              _context.next = 12;
	              break;
	
	            case 9:
	              _context.prev = 9;
	              _context.t0 = _context['catch'](1);
	
	              _this.setState({ error: true });
	
	            case 12:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2, [[1, 9]]);
	    }));
	
	    var auth_data = JSON.parse(localStorage.getItem("user_data"));
	    _this.state = (_this$state = {
	      logged: localStorage.getItem("authentication"),
	      auth_data: JSON.parse(localStorage.getItem("user_data")),
	      location: 'Bengaluru',
	      commList: [],
	      loading: true,
	      searchby: '',
	      activePage: 0,
	      tablename: 'bw_play_area',
	      PER_PAGE: 15,
	      offset: 0,
	      total: 0
	    }, _defineProperty(_this$state, 'loading', true), _defineProperty(_this$state, 'exportbtndisabled', false), _defineProperty(_this$state, 'thisExportBtnText', 'Export'), _this$state);
	
	    _this.handleSelect = _this.handleSelect.bind(_this);
	    return _this;
	  }
	
	  _createClass(verticalKidsPlayArea, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	
	      var THIS = this;
	      (0, _jquery2.default)(document).on('click', '.remove_school', function () {
	        var delete_id = (0, _jquery2.default)(this).data("id");
	
	        if (confirm("You are sure to delete?") == true) {
	
	          var ins = JSON.stringify({
	            id: delete_id,
	            table: 'kidsplayarea'
	          });
	
	          (0, _FetchCall.removethisItem)(ins).then(function (res) {
	
	            THIS.getTotal();
	            THIS.getList();
	          });
	        }
	      });
	
	      this.getTotal();
	      this.getList();
	    }
	  }, {
	    key: 'handlePageChange',
	    value: function handlePageChange(pageNumber) {
	      this.setState({ activePage: pageNumber });
	      this.getList(pageNumber);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          commList = _state.commList,
	          currentPage = _state.currentPage,
	          PER_PAGE = _state.PER_PAGE,
	          total = _state.total,
	          exportbtndisabled = _state.exportbtndisabled;
	
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'col-lg-12 grid-margin stretch-card' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card-body' },
	                _react2.default.createElement(
	                  'h4',
	                  { 'class': 'card-title' },
	                  'Kids Play Area'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'float-right' },
	                  _react2.default.createElement(
	                    'a',
	                    { href: '/vertical/kidsplayarea/add', 'class': 'btn btn-primary btn-sm' },
	                    'Add'
	                  ),
	                  ' \xA0',
	                  _react2.default.createElement(
	                    'button',
	                    { disabled: exportbtndisabled, 'class': 'btn btn-primary btn-sm', onClick: function onClick() {
	                        return _this3.schoolExport();
	                      } },
	                    this.state.thisExportBtnText
	                  ),
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'p',
	                  { 'class': 'card-description' },
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'cityselection' },
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'leftaligned bwlabel' },
	                      'City'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'leftaligned' },
	                      _react2.default.createElement(
	                        'select',
	                        { name: 'location', 'class': 'form-control', onChange: function onChange(e) {
	                            return _this3.handleSelect(e);
	                          },
	                          value: this.state.location },
	                        _react2.default.createElement(
	                          'option',
	                          { value: '' },
	                          'select city'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'Bengaluru' },
	                          'Bengaluru'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'Chennai' },
	                          'Chennai'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'Hyderabad' },
	                          'Hyderabad'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'Coimbatore' },
	                          'Coimbatore'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'Hosur' },
	                          'Hosur'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'Indore' },
	                          'Indore'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'Others' },
	                          'Others'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'leftaligned bwlabel' },
	                      'Search'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'leftaligned' },
	                      _react2.default.createElement('input', { type: 'text', name: 'searchby', 'class': 'form-control form-control-sm', onChange: this.handleChange })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'leftaligned' },
	                      _react2.default.createElement(
	                        'button',
	                        { 'class': 'btn btn-primary btn-sm', onClick: this.searchBy },
	                        'Go'
	                      )
	                    )
	                  )
	                ),
	                this.state.loading && _react2.default.createElement(
	                  'div',
	                  { id: 'loader' },
	                  _react2.default.createElement('img', { src: _bewiseloading2.default, width: '60px' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'table-responsive pt-3' },
	                  !this.state.loading && _react2.default.createElement(
	                    'table',
	                    { id: 'tablebw' },
	                    _react2.default.createElement(
	                      'thead',
	                      { 'class': 'thead-dark' },
	                      _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'S.No'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Updated On'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'By'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Name'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'City'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Email Id'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Status'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Action'
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'tbody',
	                      null,
	                      commList.map(function (item, i) {
	
	                        return _react2.default.createElement(
	                          'tr',
	                          null,
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.s_no
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.updated_date
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.updatedby
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.organisation_name
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.location
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.email_id
	                          ),
	                          _react2.default.createElement('td', { dangerouslySetInnerHTML: { __html: item.status } }),
	                          _react2.default.createElement('td', { 'class': 'actionbtns', dangerouslySetInnerHTML: { __html: item.action } })
	                        );
	                      })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'text-center' },
	                    _react2.default.createElement(_reactJsPagination2.default, {
	                      activePage: this.state.activePage,
	                      itemsCountPerPage: PER_PAGE,
	                      totalItemsCount: this.state.total,
	                      pageRangeDisplayed: 5,
	                      activeClass: "pagination__link--active",
	                      onChange: this.handlePageChange.bind(this),
	                      prevPageText: 'previous',
	                      nextPageText: 'next'
	                    })
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return verticalKidsPlayArea;
	}(_react.Component);
	
	exports.default = verticalKidsPlayArea;

/***/ },
/* 1032 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _FetchCall2 = _interopRequireDefault(_FetchCall);
	
	var _constant = __webpack_require__(21);
	
	var _reactstrap = __webpack_require__(17);
	
	var _reactGeocode = __webpack_require__(55);
	
	var _reactGeocode2 = _interopRequireDefault(_reactGeocode);
	
	var _multiselectReactDropdown = __webpack_require__(73);
	
	var _simpleReactValidator = __webpack_require__(28);
	
	var _simpleReactValidator2 = _interopRequireDefault(_simpleReactValidator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import { Editor } from '@tinymce/tinymce-react';
	
	
	_reactGeocode2.default.setApiKey("AIzaSyA9MtbfG_zlo64B2lqNMvigTBuXHkagKcE");
	_reactGeocode2.default.setLanguage("en");
	_reactGeocode2.default.setRegion("es");
	_reactGeocode2.default.enableDebug();
	
	var verticalKidsPlayAreaEdit = function (_Component) {
	  _inherits(verticalKidsPlayAreaEdit, _Component);
	
	  function verticalKidsPlayAreaEdit(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, verticalKidsPlayAreaEdit);
	
	    var _this = _possibleConstructorReturn(this, (verticalKidsPlayAreaEdit.__proto__ || Object.getPrototypeOf(verticalKidsPlayAreaEdit)).call(this, props));
	
	    _this.getKeywords = function () {
	      (0, _FetchCall.commonAPI)(JSON.stringify({ url: 'get_site_keywords', vertical: 'kidsplayarea' })).then(function (res) {
	        if (res.status === 1) {
	          _this.setState({
	            keywordsArr: res.results
	          });
	        }
	      });
	    };
	
	    _this.LocationDataList = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var res;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.prev = 0;
	              _context.next = 3;
	              return (0, _FetchCall.getLocationList)();
	
	            case 3:
	              res = _context.sent;
	
	              if (res.status == 1) {
	                console.log('location_list', res.results);
	
	                _this.setState({
	                  location_list: res.results,
	                  error: false
	                });
	              }
	
	              _context.next = 10;
	              break;
	
	            case 7:
	              _context.prev = 7;
	              _context.t0 = _context['catch'](0);
	
	              _this.setState({ error: true });
	
	            case 10:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2, [[0, 7]]);
	    }));
	
	    _this.removeImage = function (e) {
	      var delete_array = _this.state.delete_array;
	      delete_array.push(e);
	      var updated = _this.state.attachment_file.filter(function (item) {
	        return item.name !== e;
	      });
	      _this.setState({
	        attachment_file: updated,
	        delete_array: delete_array
	      });
	    };
	
	    _this.handleChange = function (e) {
	      var propName = e.target.name;
	      _this.setState(_defineProperty({}, e.target.name, e.target.value));
	      _this.clearValidationErr(propName);
	      // if (propName == 'google_location') {
	      //   this.Geocode_location();
	      //   }
	      if (e.target.name == 'google_location') _this.Geocode_location();
	      // if (propName == 'email_id') {
	      //   this.validateMail(e.target.value, 3, this.state.vendor_id, this.state.pageid);
	      // }
	    };
	
	    _this.onSelect = function (selectedList) {
	      var keywords = [];
	      selectedList.map(function (item, i) {
	        keywords.push(item);
	      });
	      _this.setState({
	        keywords: keywords
	      });
	    };
	
	    _this.onRemove = function (selectedList, removedItem) {
	      var keywords = [];
	      selectedList.map(function (item, i) {
	        keywords.push(item);
	      });
	      _this.setState({
	        keywords: keywords
	      });
	    };
	
	    _this.validateMail = function (value, catgry, vendr_id, pageid) {
	      var _JSON$stringify;
	
	      var name = 'email_id';
	      var type_name = 'isEmailValid';
	      var req = JSON.stringify((_JSON$stringify = {}, _defineProperty(_JSON$stringify, name, value), _defineProperty(_JSON$stringify, 'category', catgry), _defineProperty(_JSON$stringify, 'vendor_id', vendr_id), _defineProperty(_JSON$stringify, 'pageid', pageid), _JSON$stringify));
	      var res = (0, _FetchCall.emailExist_check)(req).then(function (res) {
	        console.log('valuee', res);
	        if (res.status === 1) {
	          _this.setState(_defineProperty({}, type_name, false));
	        } else {
	          // return res.status;
	          _this.setState(_defineProperty({}, type_name, true));
	        }
	      });
	    };
	
	    _this.handleNumberChange = function (e) {
	      var regexp = /^[0-9\b]+$/;
	      var Mnumber = e.target.value;
	
	      if (e.target.value === '' || regexp.test(e.target.value)) {
	        _this.setState(_defineProperty({}, e.target.name, Mnumber));
	      }
	      _this.Geocode_location();
	    };
	
	    _this.handleFile = function (e) {
	      // this.Geocode_location();
	      var propName = e.target.name;
	      var files = e.target.files[0];
	      _this.setState(_defineProperty({}, propName, files));
	      var reader = new FileReader();
	      var img = '';
	      var THIS = _this;
	      reader.addEventListener("load", function () {
	        // convert image file to base64 string
	        img = reader.result;
	        THIS.setState({
	          tempBanner: reader.result
	        });
	      }, false);
	
	      if (files) {
	        reader.readAsDataURL(files);
	      } else {
	        THIS.setState({
	          tempBanner: ''
	        });
	      }
	    };
	
	    _this.handleFileMultiple = function (e) {
	      _this.setState(_defineProperty({}, e.target.name, e.target.files));
	    };
	
	    _this.handleSelect = function (e) {
	      var propName = e.target.name;
	      var value = [].concat(_toConsumableArray(e.target.selectedOptions)).map(function (item) {
	        return item.value;
	      });
	      _this.Sub_Cat_type(value);
	      _this.setState(_defineProperty({}, propName, value));
	      _this.clearValidationErr(propName);
	    };
	
	    _this.handleSelectCat1 = function (e) {
	      var propName = e.target.name;
	      var value = [].concat(_toConsumableArray(e.target.selectedOptions)).map(function (item) {
	        return item.value;
	      });
	      _this.setState(_defineProperty({}, propName, value));
	    };
	
	    _this.handlePreview = function (e) {
	      e.preventDefault();
	      if (_this.validator.allValid()) {
	        _this.setState({
	          preview: true
	        });
	      } else {
	        _this.validator.showMessages();
	        _this.forceUpdate();
	      }
	    };
	
	    _this.preview = function () {
	      var from_time = _this.state.timingList.map(function (item) {
	        if (item.id == _this.state.from_time) return item.timing;
	      });
	      from_time = from_time.filter(function (n) {
	        return n;
	      }).toString();
	      var to_time = _this.state.timingList.map(function (item) {
	        if (item.id == _this.state.to_time) return item.timing;
	      });
	      to_time = to_time.filter(function (n) {
	        return n;
	      }).toString();
	      return _react2.default.createElement(
	        _reactstrap.Modal,
	        { isOpen: _this.state.preview, size: 'lg', className: 'preview-pop' },
	        _react2.default.createElement(
	          _reactstrap.ModalBody,
	          { className: 'p-0' },
	          _react2.default.createElement(
	            _reactstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactstrap.Col,
	              { md: '12' },
	              _react2.default.createElement('img', { src: '/assets/images/user-header.png', className: 'preview-header' })
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.Row,
	            { className: 'pv-banner' },
	            _react2.default.createElement(
	              _reactstrap.Col,
	              { className: 'pv-banner-bg', md: '12' },
	              _react2.default.createElement(
	                'div',
	                { className: 'title-section' },
	                _react2.default.createElement(
	                  'p',
	                  { className: 'banner-title' },
	                  _this.state.playarea_name
	                ),
	                _react2.default.createElement(
	                  'p',
	                  { className: 'banner-address' },
	                  _this.state.address
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.Row,
	            { className: 'pv-section' },
	            _react2.default.createElement(
	              _reactstrap.Col,
	              { className: '', md: '12' },
	              _react2.default.createElement(
	                'div',
	                { className: 'title-section' },
	                _react2.default.createElement(
	                  'h4',
	                  null,
	                  'About'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  { className: '' },
	                  _this.state.about_playarea
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.Row,
	            { className: 'pv-section' },
	            _react2.default.createElement(
	              _reactstrap.Col,
	              { className: '', md: '12' },
	              _react2.default.createElement(
	                'div',
	                { className: 'title-section' },
	                _react2.default.createElement(
	                  'h4',
	                  null,
	                  'Key Information'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-4' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'type-n7ngd' },
	                      _react2.default.createElement(
	                        'b',
	                        null,
	                        'Timing'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'key-po' },
	                      _react2.default.createElement(
	                        'p',
	                        null,
	                        from_time == 'NA' || to_time == 'NA' ? 'NA' : from_time + ' ' + _this.state.from_time_cate + ' - ' + to_time + ' ' + _this.state.to_time_cate
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-4' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'type-n7ngd' },
	                      _react2.default.createElement(
	                        'b',
	                        null,
	                        'Number of Trainees'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'key-po' },
	                      _react2.default.createElement(
	                        'p',
	                        null,
	                        _this.state.no_of_support_staff
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-4' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'type-n7ngd' },
	                      _react2.default.createElement(
	                        'b',
	                        null,
	                        'Minimal Entry Fee'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'key-po' },
	                      _react2.default.createElement(
	                        'p',
	                        null,
	                        _this.state.entry_fee
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-4' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'type-n7ngd' },
	                      _react2.default.createElement(
	                        'b',
	                        null,
	                        'Establishment Year'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'key-po' },
	                      _react2.default.createElement(
	                        'p',
	                        null,
	                        _this.state.establishment_year
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.Row,
	            { className: 'pv-section' },
	            _react2.default.createElement(
	              _reactstrap.Col,
	              { className: '', md: '12' },
	              _react2.default.createElement(
	                'div',
	                { className: 'title-section' },
	                _react2.default.createElement(
	                  'h4',
	                  null,
	                  'Amenities'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row' },
	                  _this.state.facilities.map(function (item) {
	                    var fac_data = _this.state.facilitiesList.filter(function (data) {
	                      return data.id == item;
	                    });
	                    if (fac_data.length > 0) {
	                      return _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-4' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: '' },
	                          fac_data[0].facility
	                        )
	                      );
	                    }
	                  })
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.Row,
	            { className: 'pv-section' },
	            _react2.default.createElement(
	              _reactstrap.Col,
	              { className: '', md: '12' },
	              _react2.default.createElement(
	                'div',
	                { className: 'title-section' },
	                _react2.default.createElement(
	                  'h4',
	                  null,
	                  'Gallery'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row' },
	                  _this.state.attachment_file.map(function (item) {
	                    if (item.image_thumb) {
	                      return _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-4' },
	                        _react2.default.createElement('img', { src: item.image_thumb, className: 'preview-image' })
	                      );
	                    } else if (item.name) {
	                      var file_url = URL.createObjectURL(item);
	                      return _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-4' },
	                        _react2.default.createElement('img', { src: file_url, className: 'preview-image' })
	                      );
	                    }
	                  }),
	                  _this.state.attachment_file.length === 0 && _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-4' },
	                    'No Gallery Images Found'
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.Row,
	            { className: 'pv-section' },
	            _react2.default.createElement(
	              _reactstrap.Col,
	              { className: '', md: '12' },
	              _react2.default.createElement(
	                'div',
	                { className: 'title-section' },
	                _react2.default.createElement(
	                  'h4',
	                  null,
	                  'Fees Structure'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-12' },
	                    'Minimal Entry Fee : ',
	                    _this.state.entry_fee > 0 ? _this.state.entry_fee : 'NA'
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.Row,
	            { className: 'pv-section' },
	            _react2.default.createElement(
	              _reactstrap.Col,
	              { className: '', md: '12' },
	              _react2.default.createElement(
	                'div',
	                { className: 'title-section' },
	                _react2.default.createElement(
	                  'h4',
	                  null,
	                  'Contact Information'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-4' },
	                    'Email Id : ',
	                    _this.state.email_id
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-4' },
	                    'Contact : ',
	                    _this.state.phone_number
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-4' },
	                    'Website : ',
	                    _this.state.website
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.Row,
	            { className: 'pv-section' },
	            _react2.default.createElement(
	              _reactstrap.Col,
	              { className: '', md: '12' },
	              _react2.default.createElement(
	                'button',
	                { className: 'btn btn-sm btn-primary custome-submit', onClick: _this.handleSubmit },
	                _this.state.edited && _this.state.role == 1 ? 'Approve' : 'Submit'
	              ),
	              _this.state.edited && _this.state.role == 1 && _react2.default.createElement(
	                'button',
	                { className: 'btn btn-sm btn-danger custome-submit', style: { marginLeft: '10px' },
	                  onClick: _this.handleReject },
	                'Reject'
	              ),
	              _react2.default.createElement(
	                'button',
	                { className: 'btn btn-sm btn-defult custome-submit', style: { marginLeft: '10px' },
	                  onClick: function onClick() {
	                    _this.setState({ preview: false });
	                  } },
	                'Close'
	              )
	            )
	          )
	        )
	      );
	    };
	
	    _this.handleReject = function (e) {
	      e.preventDefault();
	      var req = JSON.stringify({
	        id: _this.id
	      });
	      var toastr = '';
	      (0, _FetchCall.playareaReject)(req).then(function (res) {
	        if (res.status === 1) {
	          alert("success");
	          window.location.href = document.referrer;
	        }
	      });
	    };
	
	    _this.handleSubmit = function (e) {
	      e.preventDefault();
	      if (_this.validator.allValid()) {
	        var insData = {
	          id: _this.id ? _this.id : '',
	          login_id: _this.state.vendor_id,
	          registration_no: _this.state.registration_no,
	          area: _this.state.area,
	          organisation_name: _this.state.playarea_name,
	          sub_categories: _this.state.age_group,
	          email_id: _this.state.email_id,
	          phone_number: _this.state.phone_number,
	          land_line: _this.state.phone_number,
	          website: _this.state.website,
	          about: _this.state.about_playarea,
	          state: _this.state.state,
	          location: _this.state.location,
	          country: _this.state.country,
	          pincode: _this.state.pin_code,
	          address: _this.state.address,
	          google_location: _this.state.google_location,
	          no_teacher: _this.state.no_of_support_staff,
	          est_year: _this.state.establishment_year,
	          facilites: _this.state.facilities,
	          opening_time: _this.state.timing,
	          // mode_of_payment: this.state.modeofpayment,
	          owner_name: _this.state.ownerName,
	          entry_fee: _this.state.entry_fee,
	          images: _this.state.images,
	          photos: _this.state.attachment_file,
	          latitude: _this.state.latitude,
	          longitude: _this.state.longitude,
	          other_rating: _this.state.other_rating,
	          from_time: _this.state.from_time,
	          to_time: _this.state.to_time,
	          to_time_cate: _this.state.to_time_cate,
	          from_time_cate: _this.state.from_time_cate,
	          delete_array: _this.state.delete_array,
	          keywords: _this.state.keywords ? _this.state.keywords.join(';') : '',
	          sub_type: _this.state.sub_type,
	          role: _this.state.role
	          // jQuery("#btnSubmit").attr('disabled', true);
	        };(0, _FetchCall.addPlayArea)(insData).then(function (res) {
	          var toastr = '';
	          if (res.status === 1) {
	
	            alert("created success!..");
	            window.location.href = document.referrer;
	          } else {
	            (0, _jquery2.default)("#btnSubmit").attr('disabled', false);
	            alert("Something went wrong. try again!...");
	          }
	        });
	      } else {
	        _this.validator.showMessages();
	        _this.forceUpdate();
	      }
	    };
	
	    _this.state = {
	      errors: [],
	      pageid: '',
	      registration_no: '',
	      area: '',
	      facilitiesList: [],
	      playarea_name: '',
	      age_group: '',
	      email_id: '',
	      phone_number: '',
	      landline_number: '',
	      website: '',
	      about_playarea: '',
	      state: '',
	      location: 'Bengaluru',
	      country: '',
	      pin_code: '',
	      address: '',
	      price_per_hour: '',
	      google_location: '',
	      no_of_support_staff: '',
	      establishment_year: '',
	      facilities: [],
	      timing: '',
	      modeofpayment: '',
	      categoryTypeList: [],
	      timingList: [],
	      mopList: [],
	      photos: '',
	      latitude: '',
	      longitude: '',
	      other_rating: '',
	      attachment_file: [],
	      attachment_file_length: 0,
	      attachment_fileName: [],
	      from_time: '',
	      from_time_cate: 'AM',
	      to_time: '',
	      to_time_cate: 'AM',
	      edit_image: '',
	      delete_array: [],
	      location_list: [],
	      categorySubTypeList: [],
	      cat_type: false,
	      sub_type: '',
	      tempBanner: '',
	      preview: false,
	      edited_data: [],
	      keywordsArr: [],
	      edited: false
	    };
	    _this.validator = new _simpleReactValidator2.default({
	      validators: {
	        checkExist: { // name the rule
	          message: 'The :attribute field is required.',
	          rule: function rule(val, params, validator) {
	            if (val == '' && _this.state.edit_image == '') {
	              return false;
	            }
	          },
	          messageReplace: function messageReplace(message, params) {
	            return message.replace(':values', _this.helpers.toSentence(params));
	          }, // optional
	          required: true // optional
	        },
	        emailExist_check: { // name the rule
	          message: 'The :attribute Already Exist.',
	          rule: function rule(val, params, validator) {
	            return _this.state.isEmailValid;
	          },
	          messageReplace: function messageReplace(message, params) {
	            return message.replace(':values', _this.helpers.toSentence(params));
	          }, // optional
	          required: true // optional
	        },
	        checkMobile: _constant.MOBILE_REGEX,
	        checkUrl: _constant.URL_REGEX
	      }
	    });
	    _this.id = _this.props.match.params.id;
	    _this.loadFile = _this.loadFile.bind(_this);
	
	    if (_this.id !== undefined) {
	      _this.getPlayAreaInfo = _this.getPlayAreaInfo.bind(_this);
	      _this.getPlayAreaInfo();
	    }
	    _this.getKeywords();
	    _this.Cat_type();_this.getfacilities();_this.gettiming();_this.getpayment_type();
	    _this.Sub_Cat_type();
	    return _this;
	  }
	
	  _createClass(verticalKidsPlayAreaEdit, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var user_data = localStorage.getItem("user_data");
	      var auth_data = JSON.parse(user_data);
	      var vendor_id = auth_data.login_id;
	      this.setState({
	        vendor_id: vendor_id,
	        role: auth_data.role
	      });
	
	      this.LocationDataList();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      window.jQuery('.selectpicker').selectpicker('refresh');
	    }
	  }, {
	    key: 'getPlayAreaInfo',
	    value: function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	        var response, data, edited_data;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _context2.next = 2;
	                return (0, _FetchCall.playareaEdit)(JSON.stringify({ id: this.id }));
	
	              case 2:
	                response = _context2.sent;
	
	                console.log(response);
	                if (response.status === 1) {
	                  data = response.data, edited_data = response.original;
	
	                  this.setState({
	                    registration_no: data.registration_no,
	                    pageid: data.id,
	                    area: data.area,
	                    playarea_name: data.organisation_name,
	                    age_group: data.sub_categories.split(','),
	                    email_id: data.email_id,
	                    phone_number: data.phone_number,
	                    landline_number: data.land_line,
	                    website: data.website,
	                    about_playarea: data.about,
	                    state: data.state,
	                    location: data.location,
	                    country: data.country,
	                    pin_code: data.pincode,
	                    address: data.address,
	                    ownerName: data.owner_name,
	                    google_location: data.google_location,
	                    no_of_support_staff: data.no_teacher,
	                    establishment_year: data.est_year,
	                    facilities: data.facilites.split(','),
	                    entry_fee: data.entry_fee,
	                    edit_image: data.images ? data.url + data.images : '',
	                    photos: data.photos,
	                    images: data.images,
	                    edit_photos: data.photos,
	                    keywords: data.keywords ? data.keywords.split(';') : [],
	                    from_time: data.from_time,
	                    to_time: data.to_time,
	                    from_time_cate: data.from_time_cate,
	                    to_time_cate: data.to_time_cate,
	                    attachment_file: data.photo_arr,
	                    other_rating: data.other_rating,
	                    latitude: data.latitude,
	                    longitude: data.longitude,
	                    sub_type: data.sub_type.split(','),
	                    edited: data.edited,
	                    edited_data: edited_data
	                  });
	                  this.Geocode_location(data.google_location);
	                } else {
	                  window.location.href = document.referrer;
	                }
	
	              case 5:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this);
	      }));
	
	      function getPlayAreaInfo() {
	        return _ref2.apply(this, arguments);
	      }
	
	      return getPlayAreaInfo;
	    }()
	  }, {
	    key: 'Cat_type',
	    value: function () {
	      var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	        var response;
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                _context3.next = 2;
	                return _FetchCall2.default.getSubCategory('3');
	
	              case 2:
	                response = _context3.sent;
	
	                console.log('categoryTypeList', response);
	                if (response) {
	                  this.setState({ categoryTypeList: response.results });
	                }
	
	              case 5:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, this);
	      }));
	
	      function Cat_type() {
	        return _ref3.apply(this, arguments);
	      }
	
	      return Cat_type;
	    }()
	  }, {
	    key: 'getfacilities',
	    value: function () {
	      var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4() {
	        var response;
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                _context4.next = 2;
	                return _FetchCall2.default.getSchoolListDatas('facilities');
	
	              case 2:
	                response = _context4.sent;
	
	                console.log(response);
	                if (response) {
	                  this.setState({ facilitiesList: response.results });
	                }
	
	              case 5:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, this);
	      }));
	
	      function getfacilities() {
	        return _ref4.apply(this, arguments);
	      }
	
	      return getfacilities;
	    }()
	  }, {
	    key: 'gettiming',
	    value: function () {
	      var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5() {
	        var response;
	        return _regenerator2.default.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                _context5.next = 2;
	                return _FetchCall2.default.getSchoolListDatas('timing');
	
	              case 2:
	                response = _context5.sent;
	
	                console.log(response);
	                if (response) {
	                  this.setState({ timingList: response.results });
	                }
	
	              case 5:
	              case 'end':
	                return _context5.stop();
	            }
	          }
	        }, _callee5, this);
	      }));
	
	      function gettiming() {
	        return _ref5.apply(this, arguments);
	      }
	
	      return gettiming;
	    }()
	  }, {
	    key: 'getpayment_type',
	    value: function () {
	      var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee6() {
	        var response;
	        return _regenerator2.default.wrap(function _callee6$(_context6) {
	          while (1) {
	            switch (_context6.prev = _context6.next) {
	              case 0:
	                _context6.next = 2;
	                return _FetchCall2.default.getSchoolListDatas('payment_type');
	
	              case 2:
	                response = _context6.sent;
	
	                console.log(response);
	                if (response) {
	                  this.setState({ mopList: response.results });
	                }
	
	              case 5:
	              case 'end':
	                return _context6.stop();
	            }
	          }
	        }, _callee6, this);
	      }));
	
	      function getpayment_type() {
	        return _ref6.apply(this, arguments);
	      }
	
	      return getpayment_type;
	    }()
	  }, {
	    key: 'Sub_Cat_type',
	    value: function () {
	      var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee7() {
	        var response;
	        return _regenerator2.default.wrap(function _callee7$(_context7) {
	          while (1) {
	            switch (_context7.prev = _context7.next) {
	              case 0:
	                _context7.next = 2;
	                return _FetchCall2.default.getSchoolListDatas('play_age');
	
	              case 2:
	                response = _context7.sent;
	
	                if (response.status == 1) {
	                  this.setState({ categorySubTypeList: response.results, cat_type: true });
	                } else {
	                  this.setState({ cat_type: false });
	                }
	
	              case 4:
	              case 'end':
	                return _context7.stop();
	            }
	          }
	        }, _callee7, this);
	      }));
	
	      function Sub_Cat_type() {
	        return _ref7.apply(this, arguments);
	      }
	
	      return Sub_Cat_type;
	    }()
	  }, {
	    key: 'showValidationErr',
	    value: function showValidationErr(elm, msg) {
	      this.setState(function (prevState) {
	        return {
	          errors: [].concat(_toConsumableArray(prevState.errors), [{ elm: elm, msg: msg }])
	        };
	      });
	    }
	  }, {
	    key: 'clearValidationErr',
	    value: function clearValidationErr(elm) {
	      var _this3 = this;
	
	      this.setState(function (prevState) {
	        var newArr = [];
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = _this3.state.errors[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var err = _step.value;
	
	            if (elm !== err.elm) {
	              newArr.push(err);
	            }
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	
	        return { errors: newArr };
	      });
	    }
	  }, {
	    key: 'remove_img',
	    value: function remove_img() {
	      (0, _jquery2.default)('#edit_image').remove();
	    }
	  }, {
	    key: 'loadFile',
	    value: function loadFile(e) {
	      var files = e.target.files;
	      this.setState({ attachment_file_length: files.length });
	      if (files.length > 0) {
	        (0, _jquery2.default)('.upload-space').addClass('hide');
	        (0, _jquery2.default)('.upload-thumb').removeClass('hide');
	        var fileArra = this.state.attachment_file;
	
	        //console.log('fileArra',fileArra)
	        //var fileThumbArra = this.state.imgThumb;
	        for (var i = 0; i < files.length; i++) {
	          fileArra.push(e.target.files[i]);
	          this.setState({
	            selectedFile: URL.createObjectURL(e.target.files[i]),
	            attachment_file: fileArra
	          });
	        }
	        this.clearValidationErr('attachment_file');
	      }
	    }
	  }, {
	    key: 'Geocode_location',
	    value: function Geocode_location() {
	      var _this4 = this;
	
	      var location = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	      _reactGeocode2.default.fromAddress(location ? location : this.state.google_location).then(function (response) {
	        var _response$results$0$g = response.results[0].geometry.location,
	            lat = _response$results$0$g.lat,
	            lng = _response$results$0$g.lng;
	
	        if (lat && lng) _this4.get_location(lat, lng);
	      }, function (error) {
	        console.error(error);
	      });
	    }
	  }, {
	    key: 'get_location',
	    value: function get_location(lat, lng) {
	      this.setState({
	        latitude: lat,
	        longitude: lng
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var _state = this.state,
	          edited_data = _state.edited_data,
	          edited = _state.edited;
	
	      this.validator.purgeFields();
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'col-lg-12 grid-margin stretch-card' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card-body' },
	                _react2.default.createElement(
	                  'h4',
	                  { 'class': 'card-title' },
	                  'Kids Play Area Info Management'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'content-sec col-md-12 col-xs-12 pad-no mar-t-no' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'tab-content' },
	                      _react2.default.createElement(
	                        'div',
	                        { id: 'company-info', className: 'tab-pane active' },
	                        _react2.default.createElement(
	                          'form',
	                          {
	                            method: 'post',
	                            onSubmit: this.handlePreview,
	                            autoComplete: 'off',
	                            className: 'custom-form invoice-form col-md-12 col-xs-12 legend-form pad-no'
	                          },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'box-shadow-custom' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'row' },
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group col-md-4' },
	                                _react2.default.createElement(
	                                  'label',
	                                  {
	                                    className: edited && edited_data.registration_no != this.state.registration_no && 'edited-field' },
	                                  'Registration No ',
	                                  this.state.user_type == 1 && _react2.default.createElement(
	                                    'span',
	                                    { className: 'astrick' },
	                                    '*'
	                                  )
	                                ),
	                                _react2.default.createElement('input', {
	                                  type: 'text',
	                                  className: 'form-control',
	                                  name: 'registration_no',
	                                  value: this.state.registration_no,
	                                  onChange: this.handleChange
	                                }),
	                                this.state.user_type == 1 && this.validator.message('Registration No', this.state.registration_no, 'required', { className: 'text-danger' })
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group col-md-4' },
	                                _react2.default.createElement(
	                                  'label',
	                                  {
	                                    className: edited && edited_data.owner_name != this.state.ownerName && 'edited-field' },
	                                  'Owner Name ',
	                                  this.state.user_type == 1 && _react2.default.createElement(
	                                    'span',
	                                    { className: 'astrick' },
	                                    '*'
	                                  )
	                                ),
	                                _react2.default.createElement('input', {
	                                  type: 'text',
	                                  className: 'form-control',
	                                  name: 'ownerName',
	                                  value: this.state.ownerName,
	                                  onChange: this.handleChange
	                                }),
	                                this.state.user_type == 1 && this.validator.message('Owner Name', this.state.ownerName, 'required', { className: 'text-danger' })
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group col-md-4' },
	                                _react2.default.createElement(
	                                  'label',
	                                  {
	                                    className: edited && edited_data.organisation_name != this.state.playarea_name && 'edited-field' },
	                                  'Organization Name ',
	                                  _react2.default.createElement(
	                                    'span',
	                                    { className: 'astrick' },
	                                    '*'
	                                  )
	                                ),
	                                _react2.default.createElement('input', {
	                                  type: 'text',
	                                  name: 'playarea_name',
	                                  value: this.state.playarea_name,
	                                  onChange: this.handleChange,
	                                  className: 'form-control'
	                                }),
	                                this.state.user_type == 1 && this.validator.message('Organization Name', this.state.playarea_name, 'required', { className: 'text-danger' })
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group col-md-4' },
	                                _react2.default.createElement(
	                                  'label',
	                                  {
	                                    className: edited && edited_data.sub_categories != this.state.age_group && 'edited-field' },
	                                  'Play Options',
	                                  _react2.default.createElement(
	                                    'span',
	                                    { className: 'astrick' },
	                                    '*'
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'custom-select-drop dropdown' },
	                                  _react2.default.createElement(
	                                    'select',
	                                    {
	                                      multiple: true,
	                                      className: 'form-control selectpicker',
	                                      onChange: this.handleSelect,
	                                      name: 'age_group',
	                                      value: this.state.age_group
	                                    },
	                                    this.state.categoryTypeList.length > 0 && this.state.categoryTypeList.map(function (item, i) {
	                                      return _react2.default.createElement(
	                                        'option',
	                                        { value: item.category_id },
	                                        item.category_name
	                                      );
	                                    })
	                                  ),
	                                  this.validator.message('Play Options', this.state.age_group, 'required', { className: 'text-danger' })
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group col-md-4' },
	                                _react2.default.createElement(
	                                  'label',
	                                  {
	                                    className: edited && edited_data.sub_type != this.state.sub_type && 'edited-field' },
	                                  ' Catering to Age group',
	                                  _react2.default.createElement(
	                                    'span',
	                                    { className: 'astrick' },
	                                    '*'
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'custom-select-drop dropdown' },
	                                  _react2.default.createElement(
	                                    'select',
	                                    {
	                                      multiple: true,
	                                      onChange: this.handleSelectCat1,
	                                      name: 'sub_type',
	                                      value: this.state.sub_type,
	                                      className: 'form-control selectpicker' },
	                                    this.state.categorySubTypeList.length > 0 && this.state.categorySubTypeList.map(function (item, i) {
	                                      return _react2.default.createElement(
	                                        'option',
	                                        { value: item.id },
	                                        item.name
	                                      );
	                                    })
	                                  ),
	                                  this.validator.message('Catering to Age group', this.state.sub_type, 'required', { className: 'text-danger' })
	                                )
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'box-shadow-custom' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'row' },
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-12 col-xs-12' },
	                                _react2.default.createElement(
	                                  'span',
	                                  { className: 'form-legend' },
	                                  'Address Information'
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group col-md-4' },
	                                _react2.default.createElement(
	                                  'label',
	                                  {
	                                    className: edited && edited_data.email_id != this.state.email_id && 'edited-field' },
	                                  'Email Id',
	                                  _react2.default.createElement(
	                                    'span',
	                                    { className: 'astrick' },
	                                    '*'
	                                  )
	                                ),
	                                _react2.default.createElement('input', {
	                                  type: 'text',
	                                  name: 'email_id',
	                                  value: this.state.email_id,
	                                  onChange: this.handleChange,
	                                  className: 'form-control'
	                                }),
	                                this.validator.message('Email Id', this.state.email_id, 'emailExist_check', { className: 'text-danger' })
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group col-md-4' },
	                                _react2.default.createElement(
	                                  'label',
	                                  {
	                                    className: edited && edited_data.phone_number != this.state.phone_number && 'edited-field' },
	                                  'Phone Number',
	                                  _react2.default.createElement(
	                                    'span',
	                                    { className: 'astrick' },
	                                    '*'
	                                  )
	                                ),
	                                _react2.default.createElement('input', {
	                                  type: 'text',
	                                  name: 'phone_number',
	                                  value: this.state.phone_number,
	                                  onChange: this.handleChange,
	                                  className: 'form-control'
	                                }),
	                                this.validator.message('Phone Number', this.state.phone_number, '', { className: 'text-danger' })
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group col-md-4' },
	                                _react2.default.createElement(
	                                  'label',
	                                  {
	                                    className: edited && edited_data.land_line != this.state.landline_number && 'edited-field' },
	                                  'Landline Number',
	                                  _react2.default.createElement(
	                                    'span',
	                                    { className: 'astrick' },
	                                    '*'
	                                  )
	                                ),
	                                _react2.default.createElement('input', {
	                                  type: 'text',
	                                  name: 'landline_number',
	                                  value: this.state.landline_number,
	                                  onChange: this.handleChange,
	                                  className: 'form-control', maxLength: '12'
	                                }),
	                                this.validator.message('Landline Number', this.state.landline_number, '', { className: 'text-danger' })
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group col-md-4' },
	                                _react2.default.createElement(
	                                  'label',
	                                  {
	                                    className: edited && edited_data.website != this.state.website && 'edited-field' },
	                                  'Website',
	                                  _react2.default.createElement(
	                                    'span',
	                                    { className: 'astrick' },
	                                    '*'
	                                  )
	                                ),
	                                _react2.default.createElement('input', {
	                                  type: 'text',
	                                  name: 'website',
	                                  value: this.state.website,
	                                  onChange: this.handleChange,
	                                  className: 'form-control'
	                                }),
	                                this.validator.message('Website', this.state.website, '', { className: 'text-danger' })
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group col-md-4' },
	                                _react2.default.createElement(
	                                  'label',
	                                  {
	                                    className: edited && edited_data.state != this.state.state && 'edited-field' },
	                                  'State',
	                                  _react2.default.createElement(
	                                    'span',
	                                    { className: 'astrick' },
	                                    '*'
	                                  )
	                                ),
	                                _react2.default.createElement('input', {
	                                  type: 'text',
	                                  name: 'state',
	                                  value: this.state.state,
	                                  onChange: this.handleChange,
	                                  className: 'form-control'
	                                }),
	                                this.validator.message('State', this.state.state, 'required', { className: 'text-danger' })
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group col-md-4' },
	                                _react2.default.createElement(
	                                  'label',
	                                  {
	                                    className: edited && edited_data.location != this.state.location && 'edited-field' },
	                                  'Location',
	                                  _react2.default.createElement(
	                                    'span',
	                                    { className: 'astrick' },
	                                    '*'
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'select',
	                                  {
	                                    name: 'location',
	                                    id: 'location',
	                                    onChange: this.handleSelect,
	                                    value: this.state.location,
	                                    className: 'form-control selectpicker'
	                                    // multiple
	                                  },
	                                  this.state.location_list.length > 0 && this.state.location_list.map(function (item, i) {
	                                    return _react2.default.createElement(
	                                      'option',
	                                      { value: item.location },
	                                      item.location
	                                    );
	                                  })
	                                ),
	                                this.validator.message('Location', this.state.location, 'required', { className: 'text-danger' })
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group col-md-4' },
	                                _react2.default.createElement(
	                                  'label',
	                                  {
	                                    className: edited && edited_data.pincode != this.state.pin_code && 'edited-field' },
	                                  'Pincode',
	                                  _react2.default.createElement(
	                                    'span',
	                                    { className: 'astrick' },
	                                    '*'
	                                  )
	                                ),
	                                _react2.default.createElement('input', {
	                                  type: 'text',
	                                  name: 'pin_code',
	                                  value: this.state.pin_code,
	                                  onChange: this.handleChange,
	                                  className: 'form-control'
	                                }),
	                                this.validator.message('Pincode', this.state.pin_code, 'required', { className: 'text-danger' })
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group col-md-4' },
	                                _react2.default.createElement(
	                                  'label',
	                                  {
	                                    className: edited && edited_data.address != this.state.address && 'edited-field' },
	                                  'Address',
	                                  _react2.default.createElement(
	                                    'span',
	                                    { className: 'astrick' },
	                                    '*'
	                                  )
	                                ),
	                                _react2.default.createElement('input', {
	                                  type: 'text',
	                                  name: 'address',
	                                  value: this.state.address,
	                                  onChange: this.handleChange,
	                                  className: 'form-control'
	                                }),
	                                this.validator.message('Address', this.state.address, 'required', { className: 'text-danger' })
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group col-md-4' },
	                                _react2.default.createElement(
	                                  'label',
	                                  {
	                                    className: edited && edited_data.google_location != this.state.google_location && 'edited-field' },
	                                  'Google Location Address',
	                                  _react2.default.createElement(
	                                    'span',
	                                    { className: 'astrick' },
	                                    '*'
	                                  )
	                                ),
	                                _react2.default.createElement('input', {
	                                  type: 'text',
	                                  name: 'google_location',
	                                  value: this.state.google_location,
	                                  onChange: this.handleChange,
	                                  className: 'form-control'
	                                }),
	                                this.validator.message('Google Location', this.state.google_location, 'required', { className: 'text-danger' })
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group col-md-4' },
	                                _react2.default.createElement(
	                                  'label',
	                                  {
	                                    className: edited && edited_data.latitude != this.state.latitude && 'edited-field' },
	                                  'Latitude',
	                                  _react2.default.createElement(
	                                    'span',
	                                    { className: 'astrick' },
	                                    '*'
	                                  )
	                                ),
	                                _react2.default.createElement('input', {
	                                  type: 'text',
	                                  name: 'latitude',
	                                  value: this.state.latitude,
	                                  onChange: this.handleChange,
	
	                                  className: 'form-control'
	                                }),
	                                this.validator.message('Latitude', this.state.latitude, 'required', { className: 'text-danger' })
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group col-md-4' },
	                                _react2.default.createElement(
	                                  'label',
	                                  {
	                                    className: edited && edited_data.longitude != this.state.longitude && 'edited-field' },
	                                  'Longitude',
	                                  _react2.default.createElement(
	                                    'span',
	                                    { className: 'astrick' },
	                                    '*'
	                                  )
	                                ),
	                                _react2.default.createElement('input', {
	                                  type: 'text',
	                                  name: 'longitude',
	                                  value: this.state.longitude,
	                                  onChange: this.handleChange,
	
	                                  className: 'form-control'
	                                }),
	                                this.validator.message('Longitude', this.state.longitude, 'required', { className: 'text-danger' })
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group col-md-4' },
	                                _react2.default.createElement(
	                                  'label',
	                                  {
	                                    className: edited && edited_data.other_rating != this.state.other_rating && 'edited-field' },
	                                  'Google Rating',
	                                  _react2.default.createElement(
	                                    'span',
	                                    { className: 'astrick' },
	                                    '*'
	                                  )
	                                ),
	                                _react2.default.createElement('input', {
	                                  type: 'number',
	                                  step: '0.01',
	                                  name: 'other_rating',
	                                  value: this.state.other_rating,
	                                  onChange: this.handleChange,
	                                  max: '5',
	                                  className: 'form-control'
	                                }),
	                                this.validator.message('Google Rating', this.state.other_rating, 'required', { className: 'text-danger' })
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group col-md-4' },
	                                _react2.default.createElement(
	                                  'label',
	                                  {
	                                    className: edited && edited_data.about != this.state.about_playarea && 'edited-field' },
	                                  'About the School',
	                                  _react2.default.createElement(
	                                    'span',
	                                    { className: 'astrick' },
	                                    '*'
	                                  )
	                                ),
	                                _react2.default.createElement('textarea', {
	                                  type: 'text',
	                                  name: 'about_playarea',
	                                  value: this.state.about_playarea,
	                                  onChange: this.handleChange,
	                                  className: 'form-control'
	                                }),
	                                this.validator.message('About', this.state.about_playarea, 'required', { className: 'text-danger' })
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'box-shadow-custom' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'row' },
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-12 col-xs-12' },
	                                _react2.default.createElement(
	                                  'span',
	                                  { className: 'form-legend' },
	                                  'Key Information'
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group col-md-4' },
	                                _react2.default.createElement(
	                                  'label',
	                                  {
	                                    className: edited && edited_data.facilities != this.state.facilities && 'edited-field' },
	                                  'Facilities',
	                                  _react2.default.createElement(
	                                    'span',
	                                    { className: 'astrick' },
	                                    '*'
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'custom-select-drop dropdown' },
	                                  _react2.default.createElement(
	                                    'select',
	                                    {
	                                      multiple: true,
	                                      name: 'facilities',
	                                      id: 'facilities',
	                                      onChange: this.handleSelect,
	                                      className: 'form-control selectpicker',
	                                      value: this.state.facilities,
	                                      title: 'Select'
	                                    },
	                                    this.state.facilitiesList.length > 0 && this.state.facilitiesList.map(function (item, i) {
	                                      return _react2.default.createElement(
	                                        'option',
	                                        { value: item.id },
	                                        item.facility
	                                      );
	                                    })
	                                  ),
	                                  this.validator.message('Facilities', this.state.facilities, 'required', { className: 'text-danger' })
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group col-md-4 input-group-cus' },
	                                _react2.default.createElement(
	                                  'div',
	                                  null,
	                                  _react2.default.createElement(
	                                    'label',
	                                    {
	                                      className: edited && (edited_data.from_time != this.state.from_time || edited_data.from_time_cate != this.state.from_time_cate) && 'edited-field' },
	                                    'From Timing'
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'custom-select-drop dropdown' },
	                                    _react2.default.createElement(
	                                      'select',
	                                      {
	                                        className: 'form-control selectpicker',
	                                        onChange: this.handleSelect,
	                                        value: this.state.from_time,
	                                        name: 'from_time',
	                                        title: 'Select'
	                                      },
	                                      this.state.timingList.length > 0 && this.state.timingList.map(function (item, i) {
	                                        return _react2.default.createElement(
	                                          'option',
	                                          { value: item.id },
	                                          item.timing
	                                        );
	                                      })
	                                    ),
	                                    this.validator.message('Timing', this.state.from_time, 'required', { className: 'text-danger' })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  null,
	                                  _react2.default.createElement(
	                                    'label',
	                                    null,
	                                    '\xA0'
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'custom-select-drop dropdown' },
	                                    _react2.default.createElement(
	                                      'select',
	                                      {
	                                        className: 'form-control selectpicker',
	                                        onChange: this.handleSelect,
	                                        value: this.state.from_time_cate,
	                                        name: 'from_time_cate'
	                                      },
	                                      _react2.default.createElement(
	                                        'option',
	                                        { value: 'AM' },
	                                        'AM'
	                                      ),
	                                      _react2.default.createElement(
	                                        'option',
	                                        { value: 'PM' },
	                                        'PM'
	                                      )
	                                    )
	                                  )
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group col-md-4 input-group-cus' },
	                                _react2.default.createElement(
	                                  'div',
	                                  null,
	                                  _react2.default.createElement(
	                                    'label',
	                                    {
	                                      className: edited && (edited_data.to_time != this.state.to_time || edited_data.to_time_cate != this.state.to_time_cate) && 'edited-field' },
	                                    'To Timing'
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'custom-select-drop dropdown' },
	                                    _react2.default.createElement(
	                                      'select',
	                                      {
	                                        className: 'form-control selectpicker',
	                                        onChange: this.handleSelect,
	                                        value: this.state.to_time,
	                                        name: 'to_time',
	                                        title: 'Select'
	                                      },
	                                      this.state.timingList.length > 0 && this.state.timingList.map(function (item, i) {
	                                        return _react2.default.createElement(
	                                          'option',
	                                          { value: item.id },
	                                          item.timing
	                                        );
	                                      })
	                                    ),
	                                    this.validator.message('Timing', this.state.to_time, 'required', { className: 'text-danger' })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  null,
	                                  _react2.default.createElement(
	                                    'label',
	                                    null,
	                                    '\xA0'
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'custom-select-drop dropdown' },
	                                    _react2.default.createElement(
	                                      'select',
	                                      {
	                                        className: 'form-control selectpicker',
	                                        onChange: this.handleSelect,
	                                        value: this.state.to_time_cate,
	                                        name: 'to_time_cate',
	                                        required: true
	                                      },
	                                      _react2.default.createElement(
	                                        'option',
	                                        { value: 'AM' },
	                                        'AM'
	                                      ),
	                                      _react2.default.createElement(
	                                        'option',
	                                        { value: 'PM' },
	                                        'PM'
	                                      )
	                                    )
	                                  )
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group col-md-4' },
	                                _react2.default.createElement(
	                                  'label',
	                                  {
	                                    className: edited && edited_data.no_teacher != this.state.no_of_support_staff && 'edited-field' },
	                                  'Number of Trainees',
	                                  _react2.default.createElement(
	                                    'span',
	                                    { className: 'astrick' },
	                                    '*'
	                                  )
	                                ),
	                                _react2.default.createElement('input', {
	                                  type: 'text',
	                                  name: 'no_of_support_staff',
	                                  value: this.state.no_of_support_staff,
	                                  onChange: this.handleChange,
	                                  className: 'form-control'
	                                })
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group col-md-4' },
	                                _react2.default.createElement(
	                                  'label',
	                                  {
	                                    className: edited && edited_data.est_year != this.state.establishment_year && 'edited-field' },
	                                  'Establishment Year',
	                                  _react2.default.createElement(
	                                    'span',
	                                    { className: 'astrick' },
	                                    '*'
	                                  )
	                                ),
	                                _react2.default.createElement('input', {
	                                  type: 'text',
	                                  name: 'establishment_year',
	                                  value: this.state.establishment_year,
	                                  onChange: this.handleChange,
	                                  className: 'form-control'
	                                })
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group col-md-4' },
	                                _react2.default.createElement(
	                                  'label',
	                                  {
	                                    className: edited && edited_data.entry_fee != this.state.entry_fee && 'edited-field' },
	                                  'Minimal Entry Fee',
	                                  _react2.default.createElement(
	                                    'span',
	                                    { className: 'astrick' },
	                                    '*'
	                                  )
	                                ),
	                                _react2.default.createElement('input', {
	                                  type: 'number',
	                                  name: 'entry_fee',
	                                  value: this.state.entry_fee,
	                                  onChange: this.handleChange,
	                                  className: 'form-control'
	                                }),
	                                this.validator.message('Minimal Entry Fees', this.state.entry_fee, 'required', { className: 'text-danger' })
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group col-md-4' },
	                                _react2.default.createElement(
	                                  'label',
	                                  {
	                                    className: edited && edited_data.keywords != this.state.keywords && 'edited-field' },
	                                  'Keywords'
	                                ),
	                                _react2.default.createElement(_multiselectReactDropdown.Multiselect, {
	                                  isObject: false,
	                                  options: this.state.keywordsArr // Options to display in the dropdown
	                                  , selectedValues: this.state.keywords // Preselected value to persist in dropdown
	                                  , onSelect: this.onSelect // Function will trigger on select event
	                                  , onRemove: this.onRemove // Function will trigger on remove event
	                                })
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'box-shadow-custom' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'row' },
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-12 col-xs-12' },
	                                _react2.default.createElement(
	                                  'span',
	                                  { className: 'form-legend' },
	                                  'Images'
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group col-md-4' },
	                                _react2.default.createElement(
	                                  'label',
	                                  {
	                                    className: edited && edited_data.images != this.state.images && 'edited-field' },
	                                  'Banner Images ',
	                                  _react2.default.createElement(
	                                    'span',
	                                    { className: 'astrick' },
	                                    '*'
	                                  )
	                                ),
	                                _react2.default.createElement('input', {
	                                  type: 'file',
	                                  name: 'images',
	                                  onChange: this.handleFile,
	                                  className: 'form-control'
	                                })
	                              ),
	                              (this.state.edit_image != '' || this.state.tempBanner != '') && _react2.default.createElement(
	                                'div',
	                                { 'class': 'col-md-2 col-sm-12 mar-btm', id: 'edit_image' },
	                                _react2.default.createElement('img', { src: this.state.tempBanner ? this.state.tempBanner : this.state.edit_image, alt: 'Img', 'class': 'img-thumbnail' })
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'col-md-12 float-left mt-4 p-0' },
	                                _react2.default.createElement(
	                                  'label',
	                                  {
	                                    className: edited && edited_data.photos != this.state.photos && 'edited-field' },
	                                  'Gallery Images ',
	                                  _react2.default.createElement(
	                                    'span',
	                                    { className: 'astrick' },
	                                    '*'
	                                  )
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'col-md-12 float-left mt-4 p-0' },
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'col-md-12 margin-bottom-mobile-account float-left image-upload' },
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'upload-wizard' },
	                                    _react2.default.createElement(
	                                      'div',
	                                      { className: 'upload-thumb' },
	                                      _react2.default.createElement(
	                                        'ul',
	                                        { className: 'list-inline' },
	                                        this.state.attachment_file.map(function (file_data, index) {
	
	                                          var file_url;
	                                          if (file_data.name) {
	                                            var url = file_data.image_thumb ? file_data.image_thumb : '';
	                                            if (url != '') {
	                                              file_url = file_data.image_thumb;
	                                            } else {
	                                              file_url = URL.createObjectURL(file_data);
	                                            }
	
	                                            // var file_url = URL.createObjectURL(file_data)
	                                            // var file_name = file_data.name
	                                            if (file_data.type === 'application/pdf') {
	                                              var blob = file_url;
	                                              //console.log('blob_url', file_data.name)
	                                              return _react2.default.createElement(
	                                                'li',
	                                                { className: 'previewImg' },
	                                                _react2.default.createElement(
	                                                  'div',
	                                                  { className: 'thumb-img' },
	                                                  _react2.default.createElement('img', {
	                                                    src: file_url,
	                                                    alt: 'image',
	                                                    title: file_data.name
	                                                  })
	                                                ),
	                                                _react2.default.createElement(
	                                                  'a',
	                                                  { href: 'javascript:;', className: 'del-btn', onClick: function onClick() {
	                                                      _this5.removeImage(file_data.name);
	                                                    } },
	                                                  _react2.default.createElement('img', {
	                                                    src: '../assets/images/close-icon-white.svg',
	                                                    alt: 'delete'
	                                                  })
	                                                )
	                                              );
	                                            } else {
	                                              return _react2.default.createElement(
	                                                'li',
	                                                { className: 'previewImg' },
	                                                _react2.default.createElement(
	                                                  'div',
	                                                  { className: 'thumb-img' },
	                                                  _react2.default.createElement('img', {
	                                                    src: file_url,
	                                                    alt: 'image',
	                                                    title: file_data.name
	                                                  })
	                                                ),
	                                                _react2.default.createElement(
	                                                  'a',
	                                                  {
	                                                    href: 'javascript:;',
	                                                    className: 'del-btn',
	                                                    onClick: function onClick() {
	                                                      _this5.removeImage(file_data.name);
	                                                    }
	                                                  },
	                                                  _react2.default.createElement('img', {
	                                                    src: '../assets/images/close-icon-white.svg',
	                                                    alt: 'delete'
	                                                  })
	                                                )
	                                              );
	                                            }
	                                          }
	                                        }),
	                                        _react2.default.createElement(
	                                          'li',
	                                          { className: 'addMore' },
	                                          _react2.default.createElement('input', {
	                                            type: 'file',
	                                            name: 'imgInp[]',
	                                            id: 'imgInp2',
	                                            className: 'add_img',
	                                            multiple: true,
	                                            onChange: this.loadFile.bind(this),
	                                            accept: 'image/x-png,image/gif,image/jpeg'
	                                          }),
	                                          _react2.default.createElement(
	                                            'a',
	                                            { href: 'javascript:;', className: 'add-more' },
	                                            _react2.default.createElement(
	                                              'div',
	                                              null,
	                                              _react2.default.createElement('img', { src: '../assets/images/upload-icon.svg', alt: 'icon' }),
	                                              'Add more'
	                                            )
	                                          )
	                                        )
	                                      )
	                                    )
	                                  )
	                                ),
	                                this.validator.message('gallery images', this.state.attachment_file, '', { className: 'text-danger error-msg' })
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-12 col-xs-12 btn-bdr' },
	                            _react2.default.createElement(
	                              'button',
	                              { id: 'btnSubmit', className: 'btn btn-blue' },
	                              'Preview'
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          this.preview()
	        )
	      );
	    }
	  }]);
	
	  return verticalKidsPlayAreaEdit;
	}(_react.Component);
	
	exports.default = verticalKidsPlayAreaEdit;

/***/ },
/* 1033 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _reactJsPagination = __webpack_require__(33);
	
	var _reactJsPagination2 = _interopRequireDefault(_reactJsPagination);
	
	var _bewiseloading = __webpack_require__(48);
	
	var _bewiseloading2 = _interopRequireDefault(_bewiseloading);
	
	__webpack_require__(18);
	
	var _reactNotifications = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var verticalPreSchool = function (_Component) {
	  _inherits(verticalPreSchool, _Component);
	
	  function verticalPreSchool(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, verticalPreSchool);
	
	    var _this = _possibleConstructorReturn(this, (verticalPreSchool.__proto__ || Object.getPrototypeOf(verticalPreSchool)).call(this, props));
	
	    _this.getTotal = function () {
	      var location = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	
	      var locationselected = location === '' ? _this.state.location : location;
	
	      var ins = JSON.stringify({
	        vertical: _this.state.tablename,
	        location: locationselected,
	        searchby: _this.state.searchby
	      });
	
	      (0, _FetchCall.getTotal)(ins).then(function (res) {
	
	        if (res.status === 1) {
	
	          _this.setState({
	
	            total: res.total
	
	          });
	        }
	      });
	    };
	
	    _this.getList = function () {
	      var pageNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	      var location = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	      var _this$state$auth_data = _this.state.auth_data,
	          login_id = _this$state$auth_data.login_id,
	          role = _this$state$auth_data.role;
	
	
	      _this.setState({ activePage: pageNumber });
	
	      var newOffset = pageNumber === 1 ? 0 : (pageNumber - 1) * _this.state.PER_PAGE % _this.state.total;
	
	      var locationselected = location === '' ? _this.state.location : location;
	
	      var ins = JSON.stringify({
	        vendor_id: login_id,
	        role: role,
	        location: locationselected,
	        searchby: _this.state.searchby,
	        perpage: _this.state.PER_PAGE,
	        offset: newOffset
	      });
	
	      (0, _FetchCall.getPreSchoolsPaged)(ins).then(function (res) {
	
	        _this.setState({ loading: true });
	
	        if (res.status === 1) {
	
	          _this.setState({ loading: false });
	
	          _this.setState({
	
	            preschoolList: res.data
	
	          });
	        } else {
	
	          _this.setState({ loading: false });
	
	          _this.setState({
	            preschoolList: []
	          });
	        }
	      });
	    };
	
	    _this.handleSelect = function (e) {
	      _this.setState({ location: e.target.value, activePage: 1 });
	      localStorage.setItem("location", e.target.value);
	      _this.getTotal(e.target.value);
	      _this.getList(1, e.target.value);
	    };
	
	    _this.handleChange = function (e) {
	      _this.setState(_defineProperty({}, e.target.name, e.target.value));
	    };
	
	    _this.handleChangeCheckBox = function (event) {
	
	      _this.setState({ clickedbulkapproval: true });
	      var newArray = [].concat(_toConsumableArray(_this.state.toapprove), [event.target.value]);
	      if (_this.state.toapprove.includes(event.target.value)) {
	        newArray = newArray.filter(function (day) {
	          return day !== event.target.value;
	        });
	      }
	      _this.setState({
	        toapprove: newArray
	      });
	    };
	
	    _this.bulkApproval = function (e) {
	
	      console.log(_this.state.toapprove);
	
	      var ins = JSON.stringify({
	        vertical: 'preschools',
	        ids: _this.state.toapprove
	      });
	
	      (0, _FetchCall.approveBulk)(ins).then(function (res) {
	
	        //console.log(res.message);
	        _reactNotifications.NotificationManager.success(res.message);
	      });
	    };
	
	    _this.searchBy = function (e) {
	
	      _this.setState({ loading: true, activePage: 1 });
	      _this.getTotal();
	      _this.getList(1);
	    };
	
	    _this.schoolExport = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var req, res;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	
	              _this.setState({ exportbtndisabled: true, thisExportBtnText: "exporting..." });
	
	              _context.prev = 1;
	              req = JSON.stringify({
	                location: _this.state.location
	              });
	              _context.next = 5;
	              return (0, _FetchCall.exportSchool)(req);
	
	            case 5:
	              res = _context.sent;
	
	              if (res.status === 1) {
	
	                _this.setState({ exportbtndisabled: false, thisExportBtnText: "Export" });
	                console.log('location_list', res);
	                console.log('location_list', res.path);
	                window.open(res.path);
	
	                // this.setState({
	                //   subscribe_list: res.results,
	                // });
	              }
	
	              _context.next = 12;
	              break;
	
	            case 9:
	              _context.prev = 9;
	              _context.t0 = _context['catch'](1);
	
	              _this.setState({ error: true });
	
	            case 12:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2, [[1, 9]]);
	    }));
	
	
	    _this.state = {
	      logged: localStorage.getItem("authentication"),
	      auth_data: JSON.parse(localStorage.getItem("user_data")),
	      location: localStorage.getItem("location") ? localStorage.getItem("location") : 'Bengaluru',
	      tablename: 'bw_pre_schools',
	      preschoolList: [],
	      PER_PAGE: 15,
	      searchby: '',
	      activePage: 0,
	      offset: 0,
	      total: 0,
	      loading: true,
	      exportbtndisabled: false,
	      thisExportBtnText: 'Export',
	      clickedbulkapproval: false,
	      toapprove: []
	    };
	
	    _this.handleSelect = _this.handleSelect.bind(_this);
	    //this.getList = this.getList.bind(this);
	    return _this;
	  }
	
	  _createClass(verticalPreSchool, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	
	      var THIS = this;
	
	      (0, _jquery2.default)(document).on('click', '.remove_school', function () {
	
	        var delete_id = (0, _jquery2.default)(this).data("id");
	        if (confirm("You are sure to delete?") === true) {
	
	          var ins = JSON.stringify({
	            id: delete_id,
	            table: 'preschool'
	          });
	
	          (0, _FetchCall.removethisItem)(ins).then(function (res) {
	
	            THIS.getTotal();
	            THIS.getList();
	          });
	        }
	      });
	
	      this.getTotal();
	      this.getList();
	    }
	  }, {
	    key: 'handlePageChange',
	    value: function handlePageChange(pageNumber) {
	
	      console.log('active page is ' + pageNumber);
	      this.setState({ activePage: pageNumber });
	      //this.getTotal('bw_schools');
	      this.getList(pageNumber);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          preschoolList = _state.preschoolList,
	          PER_PAGE = _state.PER_PAGE,
	          exportbtndisabled = _state.exportbtndisabled;
	
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'col-lg-12 grid-margin stretch-card' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card-body' },
	                _react2.default.createElement(
	                  'h4',
	                  { 'class': 'card-title' },
	                  'Pre Schools'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'float-right' },
	                  _react2.default.createElement(
	                    'a',
	                    { href: '/vertical/preschool/add', 'class': 'btn btn-primary btn-sm' },
	                    'Add'
	                  ),
	                  ' \xA0',
	                  _react2.default.createElement(
	                    'button',
	                    { disabled: exportbtndisabled, 'class': 'btn btn-primary btn-sm', onClick: function onClick() {
	                        return _this3.schoolExport();
	                      } },
	                    this.state.thisExportBtnText
	                  ),
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'p',
	                  { 'class': 'card-description' },
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'cityselection' },
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'leftaligned bwlabel' },
	                      'City'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'leftaligned' },
	                      _react2.default.createElement(
	                        'select',
	                        { name: 'location', 'class': 'form-control', onChange: function onChange(e) {
	                            return _this3.handleSelect(e);
	                          },
	                          value: this.state.location },
	                        _react2.default.createElement(
	                          'option',
	                          { value: '' },
	                          'select city'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'Bengaluru' },
	                          'Bengaluru'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'Chennai' },
	                          'Chennai'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'Hyderabad' },
	                          'Hyderabad'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'Coimbatore' },
	                          'Coimbatore'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'Hosur' },
	                          'Hosur'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'Indore' },
	                          'Indore'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'Others' },
	                          'Others'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'leftaligned bwlabel' },
	                      'Search'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'leftaligned' },
	                      _react2.default.createElement('input', { type: 'text', name: 'searchby', 'class': 'form-control form-control-sm', onChange: this.handleChange })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'leftaligned' },
	                      _react2.default.createElement(
	                        'button',
	                        { 'class': 'btn btn-primary btn-sm', onClick: this.searchBy },
	                        'Go'
	                      )
	                    )
	                  )
	                ),
	                this.state.loading && _react2.default.createElement(
	                  'div',
	                  { id: 'loader' },
	                  _react2.default.createElement('img', { src: _bewiseloading2.default, width: '60px', alt: 'loader' })
	                ),
	                this.state.clickedbulkapproval && _react2.default.createElement(
	                  'div',
	                  { 'class': 'showbtnapproval' },
	                  _react2.default.createElement(
	                    'button',
	                    { onClick: this.bulkApproval, name: 'bulkapproval', 'class': 'btn btn-primary btn-sm' },
	                    'Approve selected schools'
	                  ),
	                  _react2.default.createElement('br', null)
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'table-responsive pt-3' },
	                  !this.state.loading && _react2.default.createElement(
	                    'table',
	                    { id: 'tablebw' },
	                    _react2.default.createElement(
	                      'thead',
	                      { 'class': 'thead-dark' },
	                      _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          'Select'
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'S.No'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Updated On'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'By'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Preschool name'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Type'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Email Id'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Status'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Action'
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'tbody',
	                      null,
	                      preschoolList.map(function (item, i) {
	
	                        return _react2.default.createElement(
	                          'tr',
	                          null,
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            ' ',
	                            item.actualstatus === 0 && _react2.default.createElement('input', { type: 'checkbox', name: 'toapprove[]', value: item.id, onChange: _this3.handleChangeCheckBox })
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.s_no
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.updated_date
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.updatedby
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.schoolName
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.schoolType
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.email_id
	                          ),
	                          _react2.default.createElement('td', { dangerouslySetInnerHTML: { __html: item.status } }),
	                          _react2.default.createElement('td', { 'class': 'actionbtns', dangerouslySetInnerHTML: { __html: item.action } })
	                        );
	                      })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'text-center' },
	                    _react2.default.createElement(_reactJsPagination2.default, {
	                      activePage: this.state.activePage,
	                      itemsCountPerPage: PER_PAGE,
	                      totalItemsCount: this.state.total,
	                      pageRangeDisplayed: 5,
	                      activeClass: "pagination__link--active",
	                      onChange: this.handlePageChange.bind(this),
	                      prevPageText: 'previous',
	                      nextPageText: 'next'
	                    })
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(_reactNotifications.NotificationContainer, null)
	        )
	      );
	    }
	  }]);
	
	  return verticalPreSchool;
	}(_react.Component);
	
	exports.default = verticalPreSchool;

/***/ },
/* 1034 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _FetchCall2 = _interopRequireDefault(_FetchCall);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var verticalPreSchoolDetail = function (_Component) {
	  _inherits(verticalPreSchoolDetail, _Component);
	
	  function verticalPreSchoolDetail(props) {
	    _classCallCheck(this, verticalPreSchoolDetail);
	
	    var _this = _possibleConstructorReturn(this, (verticalPreSchoolDetail.__proto__ || Object.getPrototypeOf(verticalPreSchoolDetail)).call(this, props));
	
	    _this.state = {
	      schoolDetails: '',
	      photos_arr: []
	    };
	    _this.id = _this.props.match.params.id;
	    _this.getPreSchoolInfo = _this.getPreSchoolInfo.bind(_this);
	    _this.getPreSchoolInfo();
	
	    return _this;
	  }
	
	  _createClass(verticalPreSchoolDetail, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      console.log(this.props);
	    }
	  }, {
	    key: 'UNSAFE_componentWillMount',
	    value: function UNSAFE_componentWillMount() {}
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {}
	  }, {
	    key: 'getPreSchoolInfo',
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var response, data;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.next = 2;
	                return _FetchCall2.default.getPreSchoolDetails(this.id);
	
	              case 2:
	                response = _context.sent;
	
	                console.log(response);
	
	                if (!response) {
	                  _context.next = 9;
	                  break;
	                }
	
	                data = response.data;
	
	                this.setState({
	                  schoolDetails: data,
	                  url: data.url,
	                  photos_arr: data.photo_arr
	                });
	
	                _context.next = 10;
	                break;
	
	              case 9:
	                return _context.abrupt('return', _react2.default.createElement(
	                  'div',
	                  null,
	                  'Error'
	                ));
	
	              case 10:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function getPreSchoolInfo() {
	        return _ref.apply(this, arguments);
	      }
	
	      return getPreSchoolInfo;
	    }()
	  }, {
	    key: 'gallery_image',
	    value: function gallery_image() {
	      var _this2 = this;
	
	      var photos = this.state.photos_arr !== undefined ? this.state.photos_arr : [];
	      var rows = "";
	      if (photos.length > 0) {
	        rows = photos.map(function (photos, index) {
	          if (photos.name) return _react2.default.createElement(
	            'div',
	            { 'class': 'col-md-4 float-left mt-4 p-0' },
	            _react2.default.createElement('img', { src: _this2.state.url + photos.name, alt: 'Img', 'class': 'img-thumbnail' })
	          );
	          return;
	        });
	      } else {
	        rows = "";
	      }
	      return rows;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var schoolDetails = this.state.schoolDetails;
	
	      console.log('schoolDetails', this.state);
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'col-lg-12 grid-margin stretch-card' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card-body' },
	                _react2.default.createElement(
	                  'h4',
	                  { 'class': 'card-title' },
	                  schoolDetails.schoolName,
	                  ' - View'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'pt-3 detailsection' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'box-shadow-custom' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-group col-md-4' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          'Registration No'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          schoolDetails.registration_no ? schoolDetails.registration_no : 'NA'
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-group col-md-4' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          'Owner Name'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          schoolDetails.owner_name ? schoolDetails.owner_name : 'NA'
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-group col-md-4' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          'Organization Name'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          schoolDetails.schoolName
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-group col-md-4' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          'Organization type'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          schoolDetails.sub_categories
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'box-shadow-custom' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-12 col-xs-12' },
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'form-legend' },
	                          'Address Information'
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-group col-md-4' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          'Email Id'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          schoolDetails.email_id
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-group col-md-4' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          'Phone Number'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          schoolDetails.phone_number
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-group col-md-4' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          'State'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          schoolDetails.state
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-group col-md-4' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          'Location'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          schoolDetails.location
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-group col-md-4' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          'Pincode'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          schoolDetails.pincode
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-group col-md-4' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          'Address'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          schoolDetails.address
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-group col-md-4' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          'Google Location Address'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          schoolDetails.google_location
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-group col-md-12' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          'About the School'
	                        ),
	                        _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: schoolDetails.about_school } })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'box-shadow-custom' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-12 col-xs-12' },
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'form-legend' },
	                          'Key Information'
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-group col-md-4' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          'Facilities'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          schoolDetails.facilites
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-group col-md-4' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          'From Timing'
	                        ),
	                        schoolDetails.from_time ? _react2.default.createElement(
	                          'p',
	                          null,
	                          schoolDetails.from_time,
	                          ' '
	                        ) : _react2.default.createElement(
	                          'p',
	                          null,
	                          '--'
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-group col-md-4 ' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          'To Timing'
	                        ),
	                        schoolDetails.to_time ? _react2.default.createElement(
	                          'p',
	                          null,
	                          ' ',
	                          schoolDetails.to_time,
	                          ' '
	                        ) : _react2.default.createElement(
	                          'p',
	                          null,
	                          '--'
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-group col-md-4' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          'Number of Teachers'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          schoolDetails.number_of_teachers
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-group col-md-4' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          'Establishment Year'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          schoolDetails.est_year
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-group col-md-4' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          'Website'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          schoolDetails.website
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-group col-md-4' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          'Website Search Keywords'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          schoolDetails.keywords
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'box-shadow-custom' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-12 col-xs-12' },
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'form-legend' },
	                          'Admission Details'
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-group col-md-4' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          'Application Fees'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          schoolDetails.processing_fee
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-group col-md-4' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          ' Documents '
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          schoolDetails.document_name
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-group col-md-4' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          'Admission Process'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          schoolDetails.admission_process
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-group col-md-4' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          'Admission Link'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          schoolDetails.admission_link
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-group col-md-4' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          'Indicative Annual Fee(INR)'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          schoolDetails.avg_fee
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-group col-md-4' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          'Other Fees'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          schoolDetails.other_fee
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-group col-md-4' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          'Admission Fees'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          schoolDetails.admit_fee
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-group col-md-4' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          'Is Refundable (Admission Fees)'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          schoolDetails.isrefund === 1 ? 'Yes' : 'No'
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'box-shadow-custom' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-12 col-xs-12' },
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'form-legend' },
	                          'Images'
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-group col-md-4' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          'Banner Images'
	                        ),
	                        schoolDetails.images && _react2.default.createElement('img', { src: schoolDetails.url + schoolDetails.images, alt: 'Img', 'class': 'img-thumbnail' })
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'col-md-12 float-left mt-4 p-0' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          'Gallery Images'
	                        )
	                      ),
	                      this.gallery_image()
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return verticalPreSchoolDetail;
	}(_react.Component);
	
	exports.default = verticalPreSchoolDetail;

/***/ },
/* 1035 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _FetchCall2 = _interopRequireDefault(_FetchCall);
	
	var _constant = __webpack_require__(21);
	
	var _reactstrap = __webpack_require__(17);
	
	var _reactGeocode = __webpack_require__(55);
	
	var _reactGeocode2 = _interopRequireDefault(_reactGeocode);
	
	var _multiselectReactDropdown = __webpack_require__(73);
	
	var _simpleReactValidator = __webpack_require__(28);
	
	var _simpleReactValidator2 = _interopRequireDefault(_simpleReactValidator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import { Editor } from '@tinymce/tinymce-react';
	
	
	_reactGeocode2.default.setApiKey("AIzaSyA9MtbfG_zlo64B2lqNMvigTBuXHkagKcE");
	_reactGeocode2.default.setLanguage("en");
	_reactGeocode2.default.setRegion("es");
	_reactGeocode2.default.enableDebug();
	
	var FacilitesArray = [{ "id": 1, "facility": "CCTV" }, { "id": 2, "facility": "AC Classes" }, { "id": 3, "facility": "Transportation" }, { "id": 4, "facility": "Food and Snacks" }, { "id": 5, "facility": "Outdoor Play area" }, { "id": 6, "facility": "NA" }];
	var TimingsArray = [{ "id": 1, "timing": "01:00" }, { "id": 2, "timing": "01:30" }, { "id": 3, "timing": "02:00" }, { "id": 4, "timing": "02:30" }, { "id": 5, "timing": "03:00" }, { "id": 6, "timing": "03:30" }, { "id": 7, "timing": "04:00" }, { "id": 8, "timing": "04:30" }, { "id": 9, "timing": "05:00" }, { "id": 10, "timing": "05:30" }, { "id": 11, "timing": "06:00" }, { "id": 12, "timing": "06:30" }, { "id": 13, "timing": "07:00" }, { "id": 14, "timing": "07:30" }, { "id": 15, "timing": "08:00" }, { "id": 16, "timing": "08:30" }, { "id": 17, "timing": "09:00" }, { "id": 18, "timing": "09:30" }, { "id": 19, "timing": "10:00" }, { "id": 20, "timing": "10:30" }, { "id": 21, "timing": "11:00" }, { "id": 22, "timing": "11:30" }, { "id": 23, "timing": "12:00" }, { "id": 24, "timing": "12:30" }, { "id": 25, "timing": "NA" }];
	var PaymentArray = [{ "id": 1, "payment_name": "Cash" }, { "id": 2, "payment_name": "Card" }, { "id": 3, "payment_name": "Cheque" }, { "id": 4, "payment_name": "Online Payments" }, { "id": 5, "payment_name": "NA" }];
	var BoeArray = [{ "id": 1, "name": "Boarding" }, { "id": 2, "name": "Home Schools" }, { "id": 3, "name": "IB" }, { "id": 4, "name": "Public Schools" }, { "id": 5, "name": "IGCSE" }, { "id": 6, "name": "CBSE" }, { "id": 7, "name": "Special Needs" }, { "id": 8, "name": "NA" }];
	
	var verticalPreSchoolEdit = function (_Component) {
	  _inherits(verticalPreSchoolEdit, _Component);
	
	  function verticalPreSchoolEdit(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, verticalPreSchoolEdit);
	
	    var _this = _possibleConstructorReturn(this, (verticalPreSchoolEdit.__proto__ || Object.getPrototypeOf(verticalPreSchoolEdit)).call(this, props));
	
	    _this.validateMail = function (value, catgry, vendr_id, pageid) {
	      var _JSON$stringify;
	
	      var name = 'email_id';
	      var type_name = 'isEmailValid';
	      var req = JSON.stringify((_JSON$stringify = {}, _defineProperty(_JSON$stringify, name, value), _defineProperty(_JSON$stringify, 'category', catgry), _defineProperty(_JSON$stringify, 'vendor_id', vendr_id), _defineProperty(_JSON$stringify, 'pageid', pageid), _JSON$stringify));
	      (0, _FetchCall.emailExist_check)(req).then(function (res) {
	        console.log('valuee', res);
	        if (res.status === 1) {
	          _this.setState(_defineProperty({}, type_name, false));
	        } else {
	          // return res.status;
	          _this.setState(_defineProperty({}, type_name, true));
	        }
	      });
	    };
	
	    _this.getKeywords = function () {
	      (0, _FetchCall.commonAPI)(JSON.stringify({ url: 'get_site_keywords', vertical: 'preschool' })).then(function (res) {
	        if (res.status === 1) {
	          _this.setState({
	            keywordsArr: res.results
	          });
	        }
	      });
	    };
	
	    _this.handleChange = function (e) {
	      var propName = e.target.name;
	      _this.setState(_defineProperty({}, e.target.name, e.target.value));
	      _this.clearValidationErr(propName);
	      if (e.target.name === 'google_location') _this.Geocode_location();
	    };
	
	    _this.onSelect = function (selectedList) {
	      var keywords = [];
	      selectedList.forEach(function (item, i) {
	        keywords.push(item);
	      });
	      _this.setState({
	        keywords: keywords
	      });
	    };
	
	    _this.onRemove = function (selectedList, removedItem) {
	      var keywords = [];
	      selectedList.forEach(function (item, i) {
	        keywords.push(item);
	      });
	      _this.setState({
	        keywords: keywords
	      });
	    };
	
	    _this.getSclList = function () {
	      (0, _FetchCall.sclList)().then(function (res) {
	        if (res.status === 1) {
	          _this.setState({
	            sclList: res.list
	          });
	        }
	      });
	    };
	
	    _this.handleFile = function (e) {
	      // this.Geocode_location();
	      var propName = e.target.name;
	      var files = e.target.files[0];
	      _this.setState(_defineProperty({}, propName, files));
	      var reader = new FileReader();
	      var THIS = _this;
	      reader.addEventListener("load", function () {
	        // convert image file to base64 string
	        THIS.setState({
	          tempBanner: reader.result
	        });
	      }, false);
	
	      if (files) {
	        reader.readAsDataURL(files);
	      } else {
	        THIS.setState({
	          tempBanner: ''
	        });
	      }
	    };
	
	    _this.handleFileMultiple = function (e) {
	      _this.setState(_defineProperty({}, e.target.name, e.target.files));
	    };
	
	    _this.handleSelect = function (e) {
	      var propName = e.target.name;
	      var value = [].concat(_toConsumableArray(e.target.selectedOptions)).map(function (item) {
	        return item.value;
	      });
	
	      _this.setState(_defineProperty({}, propName, value));
	    };
	
	    _this.LocationDataList = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var res;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.prev = 0;
	              _context.next = 3;
	              return (0, _FetchCall.getLocationList)();
	
	            case 3:
	              res = _context.sent;
	
	              if (res.status === 1) {
	                console.log('location_list', res.results);
	
	                _this.setState({
	                  location_list: res.results,
	                  error: false
	                });
	              }
	
	              _context.next = 10;
	              break;
	
	            case 7:
	              _context.prev = 7;
	              _context.t0 = _context['catch'](0);
	
	              _this.setState({ error: true });
	
	            case 10:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2, [[0, 7]]);
	    }));
	
	    _this.removeImage = function (e) {
	      var delete_array = _this.state.delete_array;
	      delete_array.push(e);
	      var updated = _this.state.attachment_file.filter(function (item) {
	        return item.name !== e;
	      });
	      _this.setState({
	        attachment_file: updated,
	        delete_array: delete_array
	      });
	    };
	
	    _this.handlePreview = function (e) {
	      e.preventDefault();
	      if (_this.validator.allValid()) {
	        _this.setState({
	          preview: true
	        });
	      } else {
	        _this.validator.showMessages();
	        _this.forceUpdate();
	      }
	    };
	
	    _this.preview = function () {
	      var from_time = _this.state.timingList.map(function (item) {
	        if (item.id === _this.state.from_time) return item.timing;
	        return;
	      });
	      from_time = from_time.filter(function (n) {
	        return n;
	      }).toString();
	      var to_time = _this.state.timingList.map(function (item) {
	        if (item.id === _this.state.to_time) return item.timing;
	        return;
	      });
	      to_time = to_time.filter(function (n) {
	        return n;
	      }).toString();
	      return _react2.default.createElement(
	        _reactstrap.Modal,
	        { isOpen: _this.state.preview, size: 'lg', className: 'preview-pop' },
	        _react2.default.createElement(
	          _reactstrap.ModalBody,
	          { className: '' },
	          _react2.default.createElement(
	            _reactstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactstrap.Col,
	              { md: '12' },
	              _react2.default.createElement('img', { src: '/assets/images/user-header.png', className: 'preview-header', alt: 'preview header' })
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.Row,
	            { className: 'pv-banner' },
	            _react2.default.createElement(
	              _reactstrap.Col,
	              { className: 'pv-banner-bg', md: '12' },
	              _react2.default.createElement(
	                'div',
	                { className: 'title-section' },
	                _react2.default.createElement(
	                  'p',
	                  { className: 'banner-title' },
	                  _this.state.schoolName
	                ),
	                _react2.default.createElement(
	                  'p',
	                  { className: 'banner-address' },
	                  _this.state.address
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.Row,
	            { className: 'pv-section' },
	            _react2.default.createElement(
	              _reactstrap.Col,
	              { className: '', md: '12' },
	              _react2.default.createElement(
	                'div',
	                { className: 'title-section' },
	                _react2.default.createElement(
	                  'h4',
	                  null,
	                  'About the School'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  { className: '' },
	                  _this.state.about_school
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.Row,
	            { className: 'pv-section' },
	            _react2.default.createElement(
	              _reactstrap.Col,
	              { className: '', md: '12' },
	              _react2.default.createElement(
	                'div',
	                { className: 'title-section' },
	                _react2.default.createElement(
	                  'h4',
	                  null,
	                  'Key Information'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-4' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'type-n7ngd' },
	                      _react2.default.createElement(
	                        'b',
	                        null,
	                        'Establishment Year'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'key-po' },
	                      _react2.default.createElement(
	                        'p',
	                        null,
	                        _this.state.establishment_Year
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-4' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'type-n7ngd' },
	                      _react2.default.createElement(
	                        'b',
	                        null,
	                        'Number of Teachers'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'key-po' },
	                      _react2.default.createElement(
	                        'p',
	                        null,
	                        _this.state.number_of_teachers
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-4' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'type-n7ngd' },
	                      _react2.default.createElement(
	                        'b',
	                        null,
	                        'Timing'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'key-po' },
	                      _react2.default.createElement(
	                        'p',
	                        null,
	                        from_time === 'NA' || to_time === 'NA' ? 'NA' : from_time + ' ' + _this.state.from_time_cate + ' - ' + to_time + ' ' + _this.state.to_time_cate
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-4' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'type-n7ngd' },
	                      _react2.default.createElement(
	                        'b',
	                        null,
	                        'Is Refundable (Admission Fees)'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'key-po' },
	                      _react2.default.createElement(
	                        'p',
	                        null,
	                        _this.state.isrefund === 1 ? 'Yes' : 'No'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-4' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'type-n7ngd' },
	                      _react2.default.createElement(
	                        'b',
	                        null,
	                        'Min Age of Admission'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'key-po' },
	                      _react2.default.createElement(
	                        'p',
	                        null,
	                        _this.state.min_age
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-4' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'type-n7ngd' },
	                      _react2.default.createElement(
	                        'b',
	                        null,
	                        'Is Trial class Available'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'key-po' },
	                      _react2.default.createElement(
	                        'p',
	                        null,
	                        _this.state.has_trial === 0 ? 'NA' : _this.state.has_scholarship === 1 ? 'Yes' : 'No'
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.Row,
	            { className: 'pv-section' },
	            _react2.default.createElement(
	              _reactstrap.Col,
	              { className: '', md: '12' },
	              _react2.default.createElement(
	                'div',
	                { className: 'title-section' },
	                _react2.default.createElement(
	                  'h4',
	                  null,
	                  'Amenities'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row' },
	                  _this.state.facilities.map(function (item) {
	                    var fac_data = _this.state.facilitiesList.filter(function (data) {
	                      return data.id === item;
	                    });
	                    if (fac_data.length > 0) {
	                      return _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-4' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: '' },
	                          fac_data[0].facility
	                        )
	                      );
	                    }
	                    return;
	                  })
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.Row,
	            { className: 'pv-section' },
	            _react2.default.createElement(
	              _reactstrap.Col,
	              { className: '', md: '12' },
	              _react2.default.createElement(
	                'div',
	                { className: 'title-section' },
	                _react2.default.createElement(
	                  'h4',
	                  null,
	                  'Gallery'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row' },
	                  _this.state.attachment_file.map(function (item) {
	                    console.log('********', item);
	                    if (item.image_thumb) {
	                      return _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-4' },
	                        _react2.default.createElement('img', { src: item.image_thumb, className: 'preview-image', alt: 'preview' })
	                      );
	                    } else if (item.name) {
	                      var file_url = URL.createObjectURL(item);
	                      return _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-4' },
	                        _react2.default.createElement('img', { src: file_url, className: 'preview-image', alt: 'preview' })
	                      );
	                    }
	                    return;
	                  }),
	                  _this.state.attachment_file.length === 0 && _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-4' },
	                    'No Gallery Images Found'
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.Row,
	            { className: 'pv-section' },
	            _react2.default.createElement(
	              _reactstrap.Col,
	              { className: '', md: '12' },
	              _react2.default.createElement(
	                'div',
	                { className: 'title-section' },
	                _react2.default.createElement(
	                  'h4',
	                  null,
	                  'Fees Structure'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-4' },
	                    'Indicative Annual Fee : ',
	                    _this.state.avg_anual_fee > 0 ? _this.state.avg_anual_fee : 'NA'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-4' },
	                    'Recurring Fees : ',
	                    _this.state.addmission_fee > 0 ? _this.state.addmission_fee : 'NA'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-4' },
	                    'Other Fees : ',
	                    _this.state.other_fee > 0 ? _this.state.other_fee : 'NA'
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.Row,
	            { className: 'pv-section' },
	            _react2.default.createElement(
	              _reactstrap.Col,
	              { className: '', md: '12' },
	              _react2.default.createElement(
	                'div',
	                { className: 'title-section' },
	                _react2.default.createElement(
	                  'h4',
	                  null,
	                  'Admission Details'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-6' },
	                    'Admission Link : ',
	                    _this.state.admission_link ? _react2.default.createElement(
	                      'a',
	                      { href: _this.state.admission_link },
	                      'Link'
	                    ) : 'NA'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-6' },
	                    'Admission Process : ',
	                    _this.state.admission_process
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.Row,
	            { className: 'pv-section' },
	            _react2.default.createElement(
	              _reactstrap.Col,
	              { className: '', md: '12' },
	              _react2.default.createElement(
	                'div',
	                { className: 'title-section' },
	                _react2.default.createElement(
	                  'h4',
	                  null,
	                  'Required Documents'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row' },
	                  _this.state.required_document.map(function (item) {
	                    var redoc_data = _this.state.documnets_drop.filter(function (data) {
	                      return data.id === item;
	                    });
	                    if (redoc_data.length > 0) {
	                      return _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-4' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: '' },
	                          redoc_data[0].document_name
	                        )
	                      );
	                    }
	                    return;
	                  })
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.Row,
	            { className: 'pv-section' },
	            _react2.default.createElement(
	              _reactstrap.Col,
	              { className: '', md: '12' },
	              _react2.default.createElement(
	                'div',
	                { className: 'title-section' },
	                _react2.default.createElement(
	                  'h4',
	                  null,
	                  'Contact Information'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-4' },
	                    'Email Id : ',
	                    _this.state.email_id
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-4' },
	                    'Contact : ',
	                    _this.state.phone_number
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-4' },
	                    'Website : ',
	                    _this.state.website
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.Row,
	            { className: 'pv-section' },
	            _react2.default.createElement(
	              _reactstrap.Col,
	              { className: '', md: '12' },
	              _react2.default.createElement(
	                'button',
	                { className: 'btn btn-sm btn-primary custome-submit', onClick: _this.handleSubmit },
	                _this.state.edited && _this.state.role === 1 ? 'Approve' : 'Submit'
	              ),
	              _this.state.edited && _this.state.role === 1 && _react2.default.createElement(
	                'button',
	                { className: 'btn btn-sm btn-danger custome-submit', style: { marginLeft: '10px' },
	                  onClick: _this.handleReject },
	                'Reject'
	              ),
	              _react2.default.createElement(
	                'button',
	                { className: 'btn btn-sm btn-defult custome-submit', style: { marginLeft: '10px' },
	                  onClick: function onClick() {
	                    _this.setState({ preview: false });
	                  } },
	                'Close'
	              )
	            )
	          )
	        )
	      );
	    };
	
	    _this.handleReject = function (e) {
	      e.preventDefault();
	      var req = JSON.stringify({
	        id: _this.state.getId
	      });
	      var toastr = '';
	      (0, _FetchCall.presclReject)(req).then(function (res) {
	        if (res.status === 1) {
	          toastr = window.toastr.success;
	          toastr('success', {
	            positionClass: "toast-bottom-right",
	            containerId: "toast-bottom-right"
	          });
	          window.location.href = document.referrer;
	        }
	      });
	    };
	
	    _this.handleSubmit = function (e) {
	      e.preventDefault();
	      console.log('**', _this.validator.getErrorMessages());
	      if (_this.validator.allValid()) {
	
	        var insData = {
	          getid: _this.state.getId ? _this.state.getId : '',
	          login_id: _this.state.login_id,
	          registration_no: _this.state.registration_no,
	          owner_name: _this.state.ownerName,
	          organisation_name: _this.state.schoolName,
	          sub_categories: _this.state.schoolType,
	          email_id: _this.state.email_id,
	          phone_number: _this.state.phone_number,
	          // fax_number: this.state.fax_number,
	          state: _this.state.state,
	          website: _this.state.website,
	          location: _this.state.location,
	          address: _this.state.address,
	          country: _this.state.country,
	          pincode: _this.state.pincode,
	          about: _this.state.about_school,
	          google_location: _this.state.google_location,
	          number_of_teachers: _this.state.number_of_teachers,
	          edu_type: _this.state.board_of_education,
	          timing: _this.state.opening_timimg,
	          // paymnet: this.state.mode_of_payment,
	          est_year: _this.state.establishment_Year,
	          amenities: _this.state.facilities,
	          avg_fee: _this.state.avg_anual_fee,
	          other_fee: _this.state.other_fee,
	          processing_fee: _this.state.processing_fee,
	          admission_process: _this.state.admission_process,
	          addmission_fee: _this.state.addmission_fee,
	          admission_link: _this.state.admission_link,
	          required_document: _this.state.required_document,
	          is_refund: _this.state.isrefund,
	          images: _this.state.images,
	          photos: _this.state.attachment_file,
	          latitude: _this.state.latitude,
	          longitude: _this.state.longitude,
	          from_time: _this.state.from_time,
	          to_time: _this.state.to_time,
	          delete_array: _this.state.delete_array,
	          from_time_cate: _this.state.from_time_cate,
	          to_time_cate: _this.state.to_time_cate,
	          keywords: _this.state.keywords ? _this.state.keywords.join(';') : '',
	          other_rating: _this.state.other_rating,
	          min_age: _this.state.min_age,
	          has_trial: _this.state.has_trial,
	          scl_link: _this.state.scl_link,
	          role: _this.state.role
	
	          // jQuery("#btnSubmit").attr('disabled', true);
	        };(0, _FetchCall.addPreschool)(insData).then(function (res) {
	          if (res.status === 1) {
	            alert("Success");
	            window.location.href = document.referrer;
	          } else {
	            (0, _jquery2.default)("#btnSubmit").attr('disabled', false);
	            alert("Error in saving");
	          }
	        });
	      } else {
	        _this.validator.showMessages();
	        _this.forceUpdate();
	      }
	    };
	
	    _this.state = {
	      errors: [],
	      ownerName: '',
	      pageid: '',
	      isrefund: '',
	      user_type: 0,
	      registration_no: '',
	      schoolName: '',
	      email_id: '',
	      phone_number: '',
	      // landline_number: '',
	      fax_number: '123',
	      website: '',
	      state: '',
	      location: 'Bengaluru',
	      pincode: '',
	      country: '',
	      address: '',
	      about_school: '',
	      google_location: '',
	      schoolType: [],
	      board_of_education: '',
	      opening_timimg: '1',
	      number_of_teachers: '',
	      establishment_Year: '',
	      avg_anual_fee: '',
	      other_fee: '',
	      addmission_fee: '',
	      admission_link: '',
	      processing_fee: '',
	      required_document: [],
	      admission_process: '',
	      facilities: [],
	      photos: '',
	      images: '',
	      facilitiesList: FacilitesArray,
	      boeList: BoeArray,
	      timingList: TimingsArray,
	      mopList: PaymentArray,
	      documnets_drop: [],
	      categoryTypeList: [{
	        "category_id": 16,
	        "category_name": "Kindergarten",
	        "is_parent": 0,
	        "parent": "Pre-Schools"
	      }, {
	        "category_id": 17,
	        "category_name": "Montessori",
	        "is_parent": 0,
	        "parent": "Pre-Schools"
	      }, {
	        "category_id": 18,
	        "category_name": "Play Group",
	        "is_parent": 0,
	        "parent": "Pre-Schools"
	      }, {
	        "category_id": 20,
	        "category_name": "Special Needs",
	        "is_parent": 0,
	        "parent": "Pre-Schools"
	      }, {
	        "category_id": 175,
	        "category_name": "Day care or Creche",
	        "is_parent": 0,
	        "parent": "Pre-Schools"
	      }],
	      getId: _this.props.match.params.id ? _this.props.match.params.id : '',
	      latitude: '',
	      longitude: '',
	      other_rating: '',
	      attachment_file: [],
	      attachment_file_length: 0,
	      attachment_fileName: [],
	      from_time: '',
	      from_time_cate: 'AM',
	      to_time: '',
	      to_time_cate: 'AM',
	      delete_array: [],
	      keywords: '',
	      edit_image: '',
	      tempBanner: '',
	      location_list: [{
	        "id": 1,
	        "location": "Bengaluru",
	        "latitude": "12.9716",
	        "longitude": "77.5946",
	        "status": 1,
	        "sort_order": 1
	      }, {
	        "id": 12,
	        "location": "Chennai",
	        "latitude": "13.0569",
	        "longitude": "80.2425",
	        "status": 1,
	        "sort_order": 2
	      }, {
	        "id": 11,
	        "location": "Coimbatore",
	        "latitude": "11.0168",
	        "longitude": "76.9558",
	        "status": 1,
	        "sort_order": 3
	      }, { "id": 27, "location": "Hosur", "latitude": "12.7409", "longitude": "77.8253", "status": 1, "sort_order": 4 }, {
	        "id": 2,
	        "location": "Hyderabad",
	        "latitude": "17.3850",
	        "longitude": "78.4867",
	        "status": 1,
	        "sort_order": 4
	      }, {
	        "id": 24,
	        "location": "Madurai",
	        "latitude": "9.9252",
	        "longitude": "78.1198",
	        "status": 1,
	        "sort_order": 5
	      }, {
	        "id": 13,
	        "location": "Mumbai",
	        "latitude": "19.0760",
	        "longitude": "72.8777",
	        "status": 1,
	        "sort_order": 7
	      }, {
	        "id": 15,
	        "location": "Kolkata",
	        "latitude": "22.5726",
	        "longitude": "88.3639",
	        "status": 1,
	        "sort_order": 8
	      }, {
	        "id": 16,
	        "location": "New Delhi",
	        "latitude": "28.6139",
	        "longitude": "77.2090",
	        "status": 1,
	        "sort_order": 9
	      }, {
	        "id": 17,
	        "location": "Jaipur",
	        "latitude": "26.9124",
	        "longitude": "75.7873",
	        "status": 1,
	        "sort_order": 10
	      }, {
	        "id": 18,
	        "location": "Chandigarh",
	        "latitude": "30.7333",
	        "longitude": "76.7794",
	        "status": 1,
	        "sort_order": 11
	      }, {
	        "id": 19,
	        "location": "Pune",
	        "latitude": "18.5204",
	        "longitude": "73.8567",
	        "status": 1,
	        "sort_order": 12
	      }, {
	        "id": 20,
	        "location": "Kochi",
	        "latitude": "9.9312",
	        "longitude": "76.2673",
	        "status": 1,
	        "sort_order": 13
	      }, {
	        "id": 21,
	        "location": "Noida",
	        "latitude": "28.5355",
	        "longitude": "77.3910",
	        "status": 1,
	        "sort_order": 14
	      }, {
	        "id": 22,
	        "location": "Agra",
	        "latitude": "27.1767",
	        "longitude": "78.0081",
	        "status": 1,
	        "sort_order": 15
	      }, {
	        "id": 23,
	        "location": "Puducherry",
	        "latitude": "11.9416",
	        "longitude": "79.8083",
	        "status": 1,
	        "sort_order": 16
	      }, {
	        "id": 25,
	        "location": "Tiruchirappalli",
	        "latitude": "10.7905",
	        "longitude": "78.7047",
	        "status": 1,
	        "sort_order": 17
	      }, { "id": 26, "location": "Indore", "latitude": "22.719568", "longitude": "75.857727", "status": 1, "sort_order": 18 }],
	      min_age: '',
	      has_trial: 2,
	      sclList: [],
	      has_scl: 2,
	      scl_link: 0,
	      preview: false,
	      edited_data: [],
	      keywordsArr: [],
	      edited: false
	    };
	    _this.validator = new _simpleReactValidator2.default({
	      validators: {
	        checkExist: { // name the rule
	          message: 'The :attribute field is required.',
	          rule: function rule(val, params, validator) {
	            if (val === '' && _this.state.edit_image === '') {
	              return false;
	            }
	          },
	          messageReplace: function messageReplace(message, params) {
	            return message.replace(':values', _this.helpers.toSentence(params));
	          }, // optional
	          required: true // optional
	        },
	        emailExist_check: { // name the rule
	          message: 'The :attribute Already Exist.',
	          rule: function rule(val, params, validator) {
	            return _this.state.isEmailValid;
	          },
	          messageReplace: function messageReplace(message, params) {
	            return message.replace(':values', _this.helpers.toSentence(params));
	          }, // optional
	          required: true // optional
	        },
	        checkMobile: _constant.MOBILE_REGEX,
	        checkUrl: _constant.URL_REGEX
	      }
	    });
	
	    // this.Cat_type();
	    return _this;
	  }
	
	  _createClass(verticalPreSchoolEdit, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	
	      this.getSclList();
	      this.getKeywords();
	      //this.gettiming(); 
	      //this.getboe(); 
	      this.getdocuments();
	      //this.getfacilities();
	      //this.getpayment_type(); 
	
	      var user_data = localStorage.getItem("user_data");
	      var auth_data = JSON.parse(user_data);
	      this.setState({
	        login_id: auth_data.login_id,
	        role: auth_data.role
	      });
	      if (this.state.getId) {
	        this.getPreSchoolInfo();
	      }
	
	      //this.LocationDataList();
	    }
	  }, {
	    key: 'getPreSchoolInfo',
	    value: function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	        var response, data, edited_data;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _context2.next = 2;
	                return (0, _FetchCall.presclEdit)(JSON.stringify({ id: this.state.getId }));
	
	              case 2:
	                response = _context2.sent;
	
	                console.log(response);
	                if (response.status === 1) {
	                  data = response.data, edited_data = response.original;
	
	                  this.setState({
	                    registration_no: data.registration_no,
	                    pageid: data.id,
	                    ownerName: data.owner_name,
	                    schoolName: data.organisation_name,
	                    sub_categories: data.sub_categories.split(','),
	                    email_id: data.email_id,
	                    phone_number: data.phone_number,
	                    fax_number: data.fax_number,
	                    state: data.state,
	                    website: data.website,
	                    location: data.location,
	                    address: data.address,
	                    country: data.country,
	                    pincode: data.pincode,
	                    about_school: data.about,
	                    google_location: data.google_location,
	                    number_of_teachers: data.number_of_teachers,
	                    board_of_education: data.edu_type,
	                    establishment_Year: data.est_year,
	                    facilities: data.amenities.split(','),
	                    avg_anual_fee: data.avg_fee,
	                    other_fee: data.other_fee,
	                    processing_fee: data.processing_fee,
	                    admission_process: data.admission_process === '' ? 'NA' : data.admission_process,
	                    addmission_fee: data.admit_fee,
	                    admission_link: data.admission_link,
	                    required_document: data.required_document.split(','),
	                    isrefund: data.is_refund,
	                    attachment_file: data.photo_arr,
	                    photos: data.photos,
	                    images: data.images,
	                    edit_image: data.images ? data.url + data.images : '',
	                    keywords: data.keywords ? data.keywords.split(';') : [],
	                    from_time: data.from_time,
	                    to_time: data.to_time,
	                    from_time_cate: data.from_time_cate,
	                    to_time_cate: data.to_time_cate,
	                    latitude: data.latitude ? data.latitude : '',
	                    longitude: data.longitude ? data.longitude : '',
	                    other_rating: data.other_rating ? data.other_rating : 0,
	                    schoolType: data.sub_categories.split(','),
	                    min_age: data.min_age,
	                    has_trial: data.has_trial,
	                    has_scl: data.scl_id === 0 ? 2 : 1,
	                    scl_link: data.scl_id,
	                    edited: data.edited,
	                    edited_data: edited_data
	                  });
	                  this.Geocode_location(data.google_location);
	                }
	
	              case 5:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this);
	      }));
	
	      function getPreSchoolInfo() {
	        return _ref2.apply(this, arguments);
	      }
	
	      return getPreSchoolInfo;
	    }()
	  }, {
	    key: 'UNSAFE_componentWillMount',
	    value: function UNSAFE_componentWillMount() {}
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      window.jQuery('.selectpicker').selectpicker('refresh');
	    }
	  }, {
	    key: 'Cat_type',
	    value: function () {
	      var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	        var response;
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                _context3.next = 2;
	                return _FetchCall2.default.getSubCategory('2');
	
	              case 2:
	                response = _context3.sent;
	
	                console.log('categoryTypeList', response);
	                if (response) {
	                  this.setState({ categoryTypeList: response.results });
	                }
	
	              case 5:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, this);
	      }));
	
	      function Cat_type() {
	        return _ref3.apply(this, arguments);
	      }
	
	      return Cat_type;
	    }()
	  }, {
	    key: 'getboe',
	    value: function () {
	      var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4() {
	        var response;
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                _context4.next = 2;
	                return _FetchCall2.default.getSchoolListDatas('boe');
	
	              case 2:
	                response = _context4.sent;
	
	                console.log('boeList', response);
	                if (response) {
	                  this.setState({ boeList: response.results });
	                }
	
	              case 5:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, this);
	      }));
	
	      function getboe() {
	        return _ref4.apply(this, arguments);
	      }
	
	      return getboe;
	    }()
	  }, {
	    key: 'getdocuments',
	    value: function () {
	      var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5() {
	        var response;
	        return _regenerator2.default.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                _context5.next = 2;
	                return _FetchCall2.default.getSchoolListDatas('documents');
	
	              case 2:
	                response = _context5.sent;
	
	                console.log(response);
	                if (response) {
	                  this.setState({ documnets_drop: response.results });
	                }
	
	              case 5:
	              case 'end':
	                return _context5.stop();
	            }
	          }
	        }, _callee5, this);
	      }));
	
	      function getdocuments() {
	        return _ref5.apply(this, arguments);
	      }
	
	      return getdocuments;
	    }()
	  }, {
	    key: 'getpayment_type',
	    value: function () {
	      var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee6() {
	        var response;
	        return _regenerator2.default.wrap(function _callee6$(_context6) {
	          while (1) {
	            switch (_context6.prev = _context6.next) {
	              case 0:
	                _context6.next = 2;
	                return _FetchCall2.default.getSchoolListDatas('payment_type');
	
	              case 2:
	                response = _context6.sent;
	
	                console.log(response);
	                if (response) {
	                  this.setState({ mopList: response.results });
	                }
	
	              case 5:
	              case 'end':
	                return _context6.stop();
	            }
	          }
	        }, _callee6, this);
	      }));
	
	      function getpayment_type() {
	        return _ref6.apply(this, arguments);
	      }
	
	      return getpayment_type;
	    }()
	  }, {
	    key: 'getfacilities',
	    value: function () {
	      var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee7() {
	        var response;
	        return _regenerator2.default.wrap(function _callee7$(_context7) {
	          while (1) {
	            switch (_context7.prev = _context7.next) {
	              case 0:
	                _context7.next = 2;
	                return _FetchCall2.default.getSchoolListDatas('facilities');
	
	              case 2:
	                response = _context7.sent;
	
	                console.log(response);
	                if (response) {
	                  this.setState({ facilitiesList: response.results });
	                }
	
	              case 5:
	              case 'end':
	                return _context7.stop();
	            }
	          }
	        }, _callee7, this);
	      }));
	
	      function getfacilities() {
	        return _ref7.apply(this, arguments);
	      }
	
	      return getfacilities;
	    }()
	  }, {
	    key: 'gettiming',
	    value: function () {
	      var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee8() {
	        var response;
	        return _regenerator2.default.wrap(function _callee8$(_context8) {
	          while (1) {
	            switch (_context8.prev = _context8.next) {
	              case 0:
	                _context8.next = 2;
	                return _FetchCall2.default.getSchoolListDatas('timing');
	
	              case 2:
	                response = _context8.sent;
	
	                console.log(response);
	                if (response) {
	                  this.setState({ timingList: response.results });
	                }
	
	              case 5:
	              case 'end':
	                return _context8.stop();
	            }
	          }
	        }, _callee8, this);
	      }));
	
	      function gettiming() {
	        return _ref8.apply(this, arguments);
	      }
	
	      return gettiming;
	    }()
	  }, {
	    key: 'clearValidationErr',
	    value: function clearValidationErr(elm) {
	      var _this3 = this;
	
	      this.setState(function (prevState) {
	        var newArr = [];
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = _this3.state.errors[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var err = _step.value;
	
	            if (elm !== err.elm) {
	              newArr.push(err);
	            }
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	
	        return { errors: newArr };
	      });
	    }
	  }, {
	    key: 'Geocode_location',
	    value: function Geocode_location() {
	      var _this4 = this;
	
	      var location = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	      _reactGeocode2.default.fromAddress(location ? location : this.state.google_location).then(function (response) {
	        var _response$results$0$g = response.results[0].geometry.location,
	            lat = _response$results$0$g.lat,
	            lng = _response$results$0$g.lng;
	
	        console.log(lat, lng);
	        if (lat && lng) _this4.get_location(lat, lng);
	      }, function (error) {
	        console.error(error);
	      });
	    }
	  }, {
	    key: 'get_location',
	    value: function get_location(lat, lng) {
	      this.setState({
	        latitude: lat,
	        longitude: lng
	      });
	    }
	  }, {
	    key: 'remove_img',
	    value: function remove_img() {
	      (0, _jquery2.default)('#edit_image').remove();
	    }
	  }, {
	    key: 'loadFile',
	    value: function loadFile(e) {
	      var files = e.target.files;
	      this.setState({ attachment_file_length: files.length });
	      if (files.length > 0) {
	        (0, _jquery2.default)('.upload-space').addClass('hide');
	        (0, _jquery2.default)('.upload-thumb').removeClass('hide');
	        var fileArra = this.state.attachment_file;
	
	        //console.log('fileArra',fileArra)
	        //var fileThumbArra = this.state.imgThumb;
	        for (var i = 0; i < files.length; i++) {
	          fileArra.push(e.target.files[i]);
	          this.setState({
	            selectedFile: URL.createObjectURL(e.target.files[i]),
	            attachment_file: fileArra
	          });
	        }
	        this.clearValidationErr('attachment_file');
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var _state = this.state,
	          edited_data = _state.edited_data,
	          edited = _state.edited;
	
	      this.validator.purgeFields();
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'col-lg-12 grid-margin stretch-card' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card-body' },
	                _react2.default.createElement(
	                  'h4',
	                  { 'class': 'card-title' },
	                  'Pre-Schools Info Management'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'content-sec col-md-12 col-xs-12 pad-no mar-t-no' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: '' },
	                      _react2.default.createElement(
	                        'div',
	                        { id: 'company-info', className: 'tab-pane active' },
	                        _react2.default.createElement(
	                          'form',
	                          {
	                            method: 'post',
	                            onSubmit: this.handlePreview,
	                            autoComplete: 'off',
	                            className: 'custom-form invoice-form col-md-12 col-xs-12 legend-form pad-no'
	                          },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'box-shadow-custom' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'row' },
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group col-md-4' },
	                                _react2.default.createElement(
	                                  'label',
	                                  {
	                                    className: edited && edited_data.registration_no !== this.state.registration_no && 'edited-field' },
	                                  'Registration No ',
	                                  this.state.user_type === 1 && _react2.default.createElement(
	                                    'span',
	                                    { className: 'astrick' },
	                                    '*'
	                                  )
	                                ),
	                                _react2.default.createElement('input', {
	
	                                  type: 'text',
	                                  className: 'form-control',
	                                  name: 'registration_no',
	                                  value: this.state.registration_no,
	                                  onChange: this.handleChange
	                                }),
	                                this.state.user_type == 1 && this.validator.message('Registration No', this.state.registration_no, 'required', { className: 'text-danger' })
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group col-md-4' },
	                                _react2.default.createElement(
	                                  'label',
	                                  {
	                                    className: edited && edited_data.owner_name !== this.state.ownerName && 'edited-field' },
	                                  'Owner Name ',
	                                  this.state.user_type === 1 && _react2.default.createElement(
	                                    'span',
	                                    { className: 'astrick' },
	                                    '*'
	                                  )
	                                ),
	                                _react2.default.createElement('input', {
	                                  type: 'text',
	                                  className: 'form-control',
	                                  name: 'ownerName',
	                                  value: this.state.ownerName,
	                                  onChange: this.handleChange
	                                }),
	                                this.state.user_type === 1 && this.validator.message('Owner Name', this.state.ownerName, 'required', { className: 'text-danger' })
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group col-md-4' },
	                                _react2.default.createElement(
	                                  'label',
	                                  {
	                                    className: edited && edited_data.organisation_name !== this.state.schoolName && 'edited-field' },
	                                  'Organization Name ',
	                                  _react2.default.createElement(
	                                    'span',
	                                    { className: 'astrick' },
	                                    '*'
	                                  )
	                                ),
	                                _react2.default.createElement('input', {
	
	                                  type: 'text',
	                                  name: 'schoolName',
	                                  value: this.state.schoolName,
	                                  onChange: this.handleChange,
	                                  className: 'form-control'
	                                }),
	                                this.state.user_type === 1 && this.validator.message('Organization Name', this.state.schoolName, 'required', { className: 'text-danger' })
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group col-md-4' },
	                                _react2.default.createElement(
	                                  'label',
	                                  {
	                                    className: edited && edited_data.sub_categories !== this.state.schoolType && 'edited-field' },
	                                  'Organization type',
	                                  _react2.default.createElement(
	                                    'span',
	                                    { className: 'astrick' },
	                                    '*'
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'custom-select-drop dropdown' },
	                                  _react2.default.createElement(
	                                    'select',
	                                    {
	                                      multiple: true,
	                                      className: 'form-control selectpicker',
	                                      onChange: this.handleSelect,
	                                      name: 'schoolType',
	                                      value: this.state.schoolType
	                                    },
	                                    this.state.categoryTypeList.length > 0 && this.state.categoryTypeList.map(function (item, i) {
	                                      return _react2.default.createElement(
	                                        'option',
	                                        { value: item.category_id },
	                                        item.category_name
	                                      );
	                                    })
	                                  ),
	                                  this.validator.message('Organization type', this.state.schoolType, 'required', { className: 'text-danger' })
	                                )
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'box-shadow-custom' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'row' },
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-12 col-xs-12' },
	                                _react2.default.createElement(
	                                  'span',
	                                  { className: 'form-legend' },
	                                  'Address Information'
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group col-md-4' },
	                                _react2.default.createElement(
	                                  'label',
	                                  {
	                                    className: edited && edited_data.email_id !== this.state.email_id && 'edited-field' },
	                                  'Email Id',
	                                  _react2.default.createElement(
	                                    'span',
	                                    { className: 'astrick' },
	                                    '*'
	                                  )
	                                ),
	                                _react2.default.createElement('input', {
	
	                                  type: 'text',
	                                  name: 'email_id',
	                                  value: this.state.email_id,
	                                  onChange: this.handleChange,
	                                  className: 'form-control'
	                                }),
	                                this.validator.message('Email Id', this.state.email_id, 'emailExist_check', { className: 'text-danger' })
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group col-md-4' },
	                                _react2.default.createElement(
	                                  'label',
	                                  {
	                                    className: edited && edited_data.phone_number !== this.state.phone_number && 'edited-field' },
	                                  'Phone Number',
	                                  _react2.default.createElement(
	                                    'span',
	                                    { className: 'astrick' },
	                                    '*'
	                                  )
	                                ),
	                                _react2.default.createElement('input', {
	                                  type: 'text',
	                                  name: 'phone_number',
	                                  value: this.state.phone_number,
	                                  onChange: this.handleChange,
	                                  className: 'form-control'
	                                }),
	                                this.validator.message('Phone Number', this.state.phone_number, '', { className: 'text-danger' })
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group col-md-4' },
	                                _react2.default.createElement(
	                                  'label',
	                                  {
	                                    className: edited && edited_data.state !== this.state.state && 'edited-field' },
	                                  'State',
	                                  _react2.default.createElement(
	                                    'span',
	                                    { className: 'astrick' },
	                                    '*'
	                                  )
	                                ),
	                                _react2.default.createElement('input', {
	                                  type: 'text',
	                                  name: 'state',
	                                  value: this.state.state,
	                                  onChange: this.handleChange,
	                                  className: 'form-control'
	                                }),
	                                this.validator.message('State', this.state.state, 'required', { className: 'text-danger' })
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group col-md-4' },
	                                _react2.default.createElement(
	                                  'label',
	                                  {
	                                    className: edited && edited_data.location !== this.state.location && 'edited-field' },
	                                  'Location',
	                                  _react2.default.createElement(
	                                    'span',
	                                    { className: 'astrick' },
	                                    '*'
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'select',
	                                  {
	                                    name: 'location',
	                                    id: 'location',
	                                    onChange: this.handleSelect,
	                                    value: this.state.location,
	                                    className: 'form-control selectpicker'
	                                  },
	                                  this.state.location_list.length > 0 && this.state.location_list.map(function (item, i) {
	                                    return _react2.default.createElement(
	                                      'option',
	                                      { value: item.location },
	                                      item.location
	                                    );
	                                  })
	                                ),
	                                this.validator.message('Location', this.state.location, 'required', { className: 'text-danger' })
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group col-md-4' },
	                                _react2.default.createElement(
	                                  'label',
	                                  {
	                                    className: edited && edited_data.pincode !== this.state.pincode && 'edited-field' },
	                                  'Pincode',
	                                  _react2.default.createElement(
	                                    'span',
	                                    { className: 'astrick' },
	                                    '*'
	                                  )
	                                ),
	                                _react2.default.createElement('input', {
	
	                                  type: 'text',
	                                  name: 'pincode',
	                                  value: this.state.pincode,
	                                  onChange: this.handleChange,
	                                  className: 'form-control'
	                                }),
	                                this.validator.message('Pincode', this.state.pincode, 'required', { className: 'text-danger' })
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group col-md-4' },
	                                _react2.default.createElement(
	                                  'label',
	                                  {
	                                    className: edited && edited_data.address !== this.state.address && 'edited-field' },
	                                  'Address',
	                                  _react2.default.createElement(
	                                    'span',
	                                    { className: 'astrick' },
	                                    '*'
	                                  )
	                                ),
	                                _react2.default.createElement('input', {
	                                  type: 'text',
	                                  name: 'address',
	                                  value: this.state.address,
	                                  onChange: this.handleChange,
	                                  className: 'form-control'
	                                }),
	                                this.validator.message('Address', this.state.address, 'required', { className: 'text-danger' })
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group col-md-4' },
	                                _react2.default.createElement(
	                                  'label',
	                                  {
	                                    className: edited && edited_data.google_location !== this.state.google_location && 'edited-field' },
	                                  'Google Location Address',
	                                  _react2.default.createElement(
	                                    'span',
	                                    { className: 'astrick' },
	                                    '*'
	                                  )
	                                ),
	                                _react2.default.createElement('input', {
	                                  type: 'text',
	                                  name: 'google_location',
	                                  value: this.state.google_location,
	                                  onChange: this.handleChange,
	
	                                  className: 'form-control'
	                                }),
	                                this.validator.message('Google Location Address', this.state.google_location, 'required', { className: 'text-danger' })
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group col-md-4' },
	                                _react2.default.createElement(
	                                  'label',
	                                  {
	                                    className: edited && edited_data.latitude !== this.state.latitude && 'edited-field' },
	                                  'Latitude',
	                                  _react2.default.createElement(
	                                    'span',
	                                    { className: 'astrick' },
	                                    '*'
	                                  )
	                                ),
	                                _react2.default.createElement('input', {
	                                  type: 'text',
	                                  name: 'latitude',
	                                  value: this.state.latitude,
	                                  onChange: this.handleChange,
	
	                                  className: 'form-control'
	                                }),
	                                this.validator.message('Latitude', this.state.latitude, 'required', { className: 'text-danger' })
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group col-md-4' },
	                                _react2.default.createElement(
	                                  'label',
	                                  {
	                                    className: edited && edited_data.longitude !== this.state.longitude && 'edited-field' },
	                                  'Longitude',
	                                  _react2.default.createElement(
	                                    'span',
	                                    { className: 'astrick' },
	                                    '*'
	                                  )
	                                ),
	                                _react2.default.createElement('input', {
	                                  type: 'text',
	                                  name: 'longitude',
	                                  value: this.state.longitude,
	                                  onChange: this.handleChange,
	
	                                  className: 'form-control'
	                                }),
	                                this.validator.message('Longitude', this.state.longitude, 'required', { className: 'text-danger' })
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group col-md-4' },
	                                _react2.default.createElement(
	                                  'label',
	                                  {
	                                    className: edited && edited_data.about !== this.state.about_school && 'edited-field' },
	                                  'About the School',
	                                  _react2.default.createElement(
	                                    'span',
	                                    { className: 'astrick' },
	                                    '*'
	                                  )
	                                ),
	                                _react2.default.createElement('textarea', {
	                                  type: 'text',
	                                  name: 'about_school',
	                                  value: this.state.about_school,
	                                  onChange: this.handleChange,
	                                  className: 'form-control'
	                                }),
	                                this.validator.message('About the School', this.state.about_school, 'required', { className: 'text-danger' })
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group col-md-4' },
	                                _react2.default.createElement(
	                                  'label',
	                                  {
	                                    className: edited && edited_data.other_rating !== this.state.other_rating && 'edited-field' },
	                                  'Google Rating',
	                                  _react2.default.createElement(
	                                    'span',
	                                    { className: 'astrick' },
	                                    '*'
	                                  )
	                                ),
	                                _react2.default.createElement('input', {
	                                  type: 'text',
	                                  step: '0.01',
	                                  name: 'other_rating',
	                                  value: this.state.other_rating,
	                                  onChange: this.handleChange,
	                                  max: '5',
	                                  className: 'form-control'
	                                }),
	                                this.validator.message('Google Rating', this.state.other_rating, 'required', { className: 'text-danger' })
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'box-shadow-custom' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'row' },
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-12 col-xs-12' },
	                                _react2.default.createElement(
	                                  'span',
	                                  { className: 'form-legend' },
	                                  'Key Information'
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group col-md-4' },
	                                _react2.default.createElement(
	                                  'label',
	                                  {
	                                    className: edited && edited_data.amenities !== this.state.facilities && 'edited-field' },
	                                  'Facilities',
	                                  _react2.default.createElement(
	                                    'span',
	                                    { className: 'astrick' },
	                                    '*'
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'custom-select-drop dropdown' },
	                                  _react2.default.createElement(
	                                    'select',
	                                    {
	                                      multiple: true,
	                                      name: 'facilities',
	                                      id: 'facilities',
	                                      value: this.state.facilities,
	                                      className: 'form-control selectpicker',
	                                      onChange: this.handleSelect
	                                      // data-live-search="true"
	
	                                    },
	                                    this.state.facilitiesList.length > 0 && this.state.facilitiesList.map(function (item, i) {
	                                      return _react2.default.createElement(
	                                        'option',
	                                        { value: item.id },
	                                        item.facility
	                                      );
	                                    })
	                                  ),
	                                  this.validator.message('Facilities', this.state.facilities, 'required', { className: 'text-danger' })
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group col-md-4 input-group-cus' },
	                                _react2.default.createElement(
	                                  'div',
	                                  null,
	                                  _react2.default.createElement(
	                                    'label',
	                                    {
	                                      className: edited && (edited_data.from_time !== this.state.from_time || edited_data.from_time_cate !== this.state.from_time_cate) && 'edited-field' },
	                                    'From Timing'
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'custom-select-drop dropdown' },
	                                    _react2.default.createElement(
	                                      'select',
	                                      {
	                                        className: 'form-control selectpicker',
	                                        onChange: this.handleSelect,
	                                        value: this.state.from_time,
	                                        name: 'from_time',
	                                        title: 'Select Time'
	                                      },
	                                      this.state.timingList.length > 0 && this.state.timingList.map(function (item, i) {
	                                        return _react2.default.createElement(
	                                          'option',
	                                          { value: item.id },
	                                          item.timing
	                                        );
	                                      })
	                                    )
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  null,
	                                  _react2.default.createElement(
	                                    'label',
	                                    null,
	                                    '\xA0'
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'custom-select-drop dropdown' },
	                                    _react2.default.createElement(
	                                      'select',
	                                      {
	                                        className: 'form-control selectpicker',
	                                        onChange: this.handleSelect,
	                                        value: this.state.from_time_cate,
	                                        name: 'from_time_cate'
	                                      },
	                                      _react2.default.createElement(
	                                        'option',
	                                        { value: 'AM' },
	                                        'AM'
	                                      ),
	                                      _react2.default.createElement(
	                                        'option',
	                                        { value: 'PM' },
	                                        'PM'
	                                      )
	                                    )
	                                  )
	                                ),
	                                this.validator.message('From Timing', this.state.from_time, 'required', { className: 'text-danger' })
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group col-md-4 input-group-cus' },
	                                _react2.default.createElement(
	                                  'div',
	                                  null,
	                                  _react2.default.createElement(
	                                    'label',
	                                    {
	                                      className: edited && (edited_data.to_time !== this.state.to_time || edited_data.to_time_cate !== this.state.to_time_cate) && 'edited-field' },
	                                    'To Timing'
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'custom-select-drop dropdown' },
	                                    _react2.default.createElement(
	                                      'select',
	                                      {
	                                        className: 'form-control selectpicker',
	                                        onChange: this.handleSelect,
	                                        value: this.state.to_time,
	                                        name: 'to_time',
	                                        title: 'Select Time'
	                                      },
	                                      this.state.timingList.length > 0 && this.state.timingList.map(function (item, i) {
	                                        return _react2.default.createElement(
	                                          'option',
	                                          { value: item.id },
	                                          item.timing
	                                        );
	                                      })
	                                    )
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  null,
	                                  _react2.default.createElement(
	                                    'label',
	                                    null,
	                                    '\xA0'
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'custom-select-drop dropdown' },
	                                    _react2.default.createElement(
	                                      'select',
	                                      {
	                                        className: 'form-control selectpicker',
	                                        onChange: this.handleSelect,
	                                        value: this.state.to_time_cate,
	                                        name: 'to_time_cate'
	                                      },
	                                      _react2.default.createElement(
	                                        'option',
	                                        { value: 'AM' },
	                                        'AM'
	                                      ),
	                                      _react2.default.createElement(
	                                        'option',
	                                        { value: 'PM' },
	                                        'PM'
	                                      )
	                                    )
	                                  )
	                                ),
	                                this.validator.message('To Timing', this.state.to_time, 'required', { className: 'text-danger' })
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group col-md-4' },
	                                _react2.default.createElement(
	                                  'label',
	                                  {
	                                    className: edited && edited_data.number_of_teachers !== this.state.number_of_teachers && 'edited-field' },
	                                  'Number of Teachers',
	                                  _react2.default.createElement(
	                                    'span',
	                                    { className: 'astrick' },
	                                    '*'
	                                  )
	                                ),
	                                _react2.default.createElement('input', {
	                                  type: 'text',
	                                  name: 'number_of_teachers',
	                                  value: this.state.number_of_teachers,
	                                  onChange: this.handleChange,
	                                  className: 'form-control'
	                                }),
	                                this.validator.message('Number of Teachers', this.state.number_of_teachers, 'required', { className: 'text-danger' })
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group col-md-4' },
	                                _react2.default.createElement(
	                                  'label',
	                                  {
	                                    className: edited && edited_data.est_year !== this.state.establishment_Year && 'edited-field' },
	                                  'Establishment Year',
	                                  _react2.default.createElement(
	                                    'span',
	                                    { className: 'astrick' },
	                                    '*'
	                                  )
	                                ),
	                                _react2.default.createElement('input', {
	
	                                  type: 'text',
	                                  name: 'establishment_Year',
	                                  value: this.state.establishment_Year,
	                                  onChange: this.handleChange,
	                                  className: 'form-control'
	                                }),
	                                this.validator.message('Establishment Year', this.state.establishment_Year, '', { className: 'text-danger' })
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group col-md-4' },
	                                _react2.default.createElement(
	                                  'label',
	                                  {
	                                    className: edited && edited_data.min_age !== this.state.min_age && 'edited-field' },
	                                  'Min Age of Admission'
	                                ),
	                                _react2.default.createElement('input', {
	
	                                  type: 'text',
	                                  name: 'min_age',
	
	                                  value: this.state.min_age,
	                                  onChange: this.handleChange,
	                                  className: 'form-control'
	                                }),
	                                this.validator.message('Min Age of Admission', this.state.min_age, 'required', { className: 'text-danger' })
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'form-group col-md-4' },
	                                _react2.default.createElement(
	                                  'label',
	                                  {
	                                    className: edited && edited_data.has_trial !== this.state.has_trial && 'edited-field' },
	                                  'Is Trial Class Available?',
	                                  _react2.default.createElement(
	                                    'span',
	                                    { 'class': 'astrick' },
	                                    '*'
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'select',
	                                  {
	                                    className: 'form-control selectpicker',
	                                    name: 'has_trial',
	                                    value: this.state.has_trial,
	                                    title: 'Select',
	                                    onChange: this.handleSelect },
	                                  _react2.default.createElement(
	                                    'option',
	                                    { value: '1' },
	                                    'Yes'
	                                  ),
	                                  _react2.default.createElement(
	                                    'option',
	                                    { value: '2' },
	                                    'No'
	                                  )
	                                ),
	                                this.validator.message('Trial Class', this.state.has_trial, 'required', { className: 'text-danger error-msg' })
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'form-group col-md-4' },
	                                _react2.default.createElement(
	                                  'label',
	                                  {
	                                    className: edited && edited_data.has_scl !== this.state.has_scl && 'edited-field' },
	                                  'Is Pre School has School',
	                                  _react2.default.createElement(
	                                    'span',
	                                    { 'class': 'astrick' },
	                                    '*'
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'select',
	                                  {
	                                    className: 'form-control selectpicker',
	                                    name: 'has_scl',
	                                    value: this.state.has_scl,
	                                    title: 'Select',
	                                    onChange: this.handleSelect },
	                                  _react2.default.createElement(
	                                    'option',
	                                    { value: '1' },
	                                    'Yes'
	                                  ),
	                                  _react2.default.createElement(
	                                    'option',
	                                    { value: '2' },
	                                    'No'
	                                  )
	                                ),
	                                this.validator.message('School', this.state.has_scl, 'required', { className: 'text-danger error-msg' })
	                              ),
	                              this.state.has_scl === 1 && _react2.default.createElement(
	                                'div',
	                                { 'class': 'form-group col-md-4' },
	                                _react2.default.createElement(
	                                  'label',
	                                  {
	                                    className: edited && edited_data.scl_id !== this.state.scl_link && 'edited-field' },
	                                  'Select School',
	                                  _react2.default.createElement(
	                                    'span',
	                                    { 'class': 'astrick' },
	                                    '*'
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'select',
	                                  {
	                                    className: 'form-control selectpicker',
	                                    name: 'scl_link',
	                                    value: this.state.scl_link,
	                                    title: 'Select', 'data-live-search': 'true',
	                                    onChange: this.handleSelect },
	                                  this.state.sclList.map(function (item, i) {
	                                    return _react2.default.createElement(
	                                      'option',
	                                      { value: item.id },
	                                      item.name
	                                    );
	                                  })
	                                ),
	                                this.validator.message('School', this.state.scl_link, 'required', { className: 'text-danger error-msg' })
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group col-md-4' },
	                                _react2.default.createElement(
	                                  'label',
	                                  {
	                                    className: edited && edited_data.website !== this.state.website && 'edited-field' },
	                                  'Website',
	                                  _react2.default.createElement(
	                                    'span',
	                                    { className: 'astrick' },
	                                    '*'
	                                  )
	                                ),
	                                _react2.default.createElement('input', {
	
	                                  type: 'text',
	                                  name: 'website',
	                                  value: this.state.website,
	                                  onChange: this.handleChange,
	                                  className: 'form-control'
	                                }),
	                                this.validator.message('Website', this.state.website, '', { className: 'text-danger' })
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group col-md-4' },
	                                _react2.default.createElement(
	                                  'label',
	                                  {
	                                    className: edited && edited_data.keywords !== this.state.keywords && 'edited-field' },
	                                  'Keywords'
	                                ),
	                                _react2.default.createElement(_multiselectReactDropdown.Multiselect, {
	                                  isObject: false,
	                                  options: this.state.keywordsArr // Options to display in the dropdown
	                                  , selectedValues: this.state.keywords // Preselected value to persist in dropdown
	                                  , onSelect: this.onSelect // Function will trigger on select event
	                                  , onRemove: this.onRemove // Function will trigger on remove event
	                                })
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'box-shadow-custom' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'row' },
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-12 col-xs-12' },
	                                _react2.default.createElement(
	                                  'span',
	                                  { className: 'form-legend' },
	                                  'Admission Details'
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group col-md-4' },
	                                _react2.default.createElement(
	                                  'label',
	                                  {
	                                    className: edited && edited_data.admission_link !== this.state.admission_link && 'edited-field' },
	                                  'Admission Link ',
	                                  _react2.default.createElement(
	                                    'span',
	                                    { className: 'astrick' },
	                                    '*'
	                                  )
	                                ),
	                                _react2.default.createElement('input', {
	                                  type: 'text',
	                                  name: 'admission_link',
	                                  value: this.state.admission_link,
	                                  onChange: this.handleChange,
	                                  className: 'form-control'
	                                }),
	                                this.validator.message('Admission Link', this.state.admission_link, '', { className: 'text-danger' })
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group col-md-4' },
	                                _react2.default.createElement(
	                                  'label',
	                                  {
	                                    className: edited && edited_data.processing_fee !== this.state.processing_fee && 'edited-field' },
	                                  'Application Fees ',
	                                  _react2.default.createElement(
	                                    'span',
	                                    { className: 'astrick' },
	                                    '*'
	                                  )
	                                ),
	                                _react2.default.createElement('input', {
	                                  type: 'text',
	                                  name: 'processing_fee',
	                                  value: this.state.processing_fee,
	                                  onChange: this.handleChange,
	                                  className: 'form-control'
	                                }),
	                                this.validator.message('Application Fees', this.state.processing_fee, '', { className: 'text-danger' })
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group col-md-4' },
	                                _react2.default.createElement(
	                                  'label',
	                                  {
	                                    className: edited && edited_data.required_document !== this.state.required_document && 'edited-field' },
	                                  'Documents '
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'custom-select-drop dropdown' },
	                                  _react2.default.createElement(
	                                    'select',
	                                    {
	                                      multiple: true,
	                                      name: 'required_document',
	                                      onChange: this.handleSelect,
	                                      value: this.state.required_document,
	                                      className: 'form-control selectpicker'
	                                    },
	                                    this.state.documnets_drop.length > 0 && this.state.documnets_drop.map(function (item, i) {
	                                      return _react2.default.createElement(
	                                        'option',
	                                        { value: item.id },
	                                        item.document_name
	                                      );
	                                    })
	                                  ),
	                                  _react2.default.createElement('br', null),
	                                  this.validator.message('Documents', this.state.required_document, 'required', { className: 'text-danger' })
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group col-md-4' },
	                                _react2.default.createElement(
	                                  'label',
	                                  {
	                                    className: edited && edited_data.admission_process !== this.state.admission_process && 'edited-field' },
	                                  'Admission Process'
	                                ),
	                                _react2.default.createElement('textarea', {
	                                  name: 'admission_process',
	                                  value: this.state.admission_process,
	                                  onChange: this.handleChange,
	                                  className: 'form-control'
	                                }),
	                                this.validator.message('Admission Process', this.state.admission_process, 'required', { className: 'text-danger' })
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group col-md-4' },
	                                _react2.default.createElement(
	                                  'label',
	                                  {
	                                    className: edited && edited_data.avg_fee !== this.state.avg_anual_fee && 'edited-field' },
	                                  'Indicative Annual Fee(INR)',
	                                  _react2.default.createElement(
	                                    'span',
	                                    { className: 'astrick' },
	                                    '*'
	                                  )
	                                ),
	                                _react2.default.createElement('input', {
	                                  type: 'text',
	                                  name: 'avg_anual_fee',
	                                  value: this.state.avg_anual_fee,
	                                  onChange: this.handleChange,
	                                  className: 'form-control'
	                                }),
	                                this.validator.message('Indicative Annual Fee', this.state.avg_anual_fee, 'required', { className: 'text-danger' })
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group col-md-4' },
	                                _react2.default.createElement(
	                                  'label',
	                                  {
	                                    className: edited && edited_data.other_fee !== this.state.other_fee && 'edited-field' },
	                                  'Other Fees ',
	                                  _react2.default.createElement(
	                                    'span',
	                                    { className: 'astrick' },
	                                    '*'
	                                  )
	                                ),
	                                _react2.default.createElement('input', {
	                                  type: 'text',
	                                  name: 'other_fee',
	                                  value: this.state.other_fee,
	                                  onChange: this.handleChange,
	                                  className: 'form-control'
	                                }),
	                                this.validator.message('Other Fees', this.state.other_fee, 'required', { className: 'text-danger' })
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group col-md-4' },
	                                _react2.default.createElement(
	                                  'label',
	                                  {
	                                    className: edited && edited_data.admit_fee !== this.state.addmission_fee && 'edited-field' },
	                                  'Admission Fees ',
	                                  _react2.default.createElement(
	                                    'span',
	                                    { className: 'astrick' },
	                                    '*'
	                                  )
	                                ),
	                                _react2.default.createElement('input', {
	                                  type: 'text',
	                                  name: 'addmission_fee',
	                                  value: this.state.addmission_fee,
	                                  onChange: this.handleChange,
	                                  className: 'form-control'
	                                }),
	                                this.validator.message('Admission Fees', this.state.addmission_fee, 'required', { className: 'text-danger' })
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group col-md-4' },
	                                _react2.default.createElement(
	                                  'label',
	                                  {
	                                    className: edited && edited_data.is_refund !== this.state.isrefund && 'edited-field' },
	                                  'Is Refundable (Admission Fees)',
	                                  _react2.default.createElement(
	                                    'span',
	                                    { className: 'astrick' },
	                                    '*'
	                                  )
	                                ),
	                                _react2.default.createElement('br', null),
	                                _react2.default.createElement('input', {
	                                  type: 'radio',
	                                  name: 'isrefund',
	                                  value: '1',
	                                  checked: this.state.isrefund === 1,
	                                  onChange: this.handleChange
	                                }),
	                                'Yes\xA0\xA0',
	                                _react2.default.createElement('input', {
	                                  type: 'radio',
	                                  value: '2',
	                                  name: 'isrefund',
	                                  checked: this.state.isrefund === 2,
	                                  onChange: this.handleChange
	                                }),
	                                'No',
	                                this.validator.message('Is Refundable', this.state.isrefund, 'required', { className: 'text-danger' })
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'box-shadow-custom' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'row' },
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-12 col-xs-12' },
	                                _react2.default.createElement(
	                                  'span',
	                                  { className: 'form-legend' },
	                                  'Images'
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group col-md-4' },
	                                _react2.default.createElement(
	                                  'label',
	                                  {
	                                    className: edited && edited_data.images !== this.state.images && 'edited-field' },
	                                  'Banner Image ',
	                                  _react2.default.createElement(
	                                    'span',
	                                    { className: 'astrick' },
	                                    '*'
	                                  )
	                                ),
	                                _react2.default.createElement('input', {
	                                  type: 'file',
	                                  name: 'images',
	                                  onChange: this.handleFile,
	                                  className: 'form-control'
	                                }),
	                                this.validator.message('Banner Image', this.state.images, '', { className: 'text-danger error-msg' })
	                              ),
	                              (this.state.edit_image !== '' || this.state.tempBanner !== '') && _react2.default.createElement(
	                                'div',
	                                { 'class': 'col-md-2 col-sm-12 mar-btm', id: 'edit_image' },
	                                _react2.default.createElement('img', { src: this.state.tempBanner ? this.state.tempBanner : this.state.edit_image, alt: 'Img', 'class': 'img-thumbnail' })
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'col-md-12 float-left mt-4 p-0' },
	                                _react2.default.createElement(
	                                  'label',
	                                  {
	                                    className: edited && edited_data.photos !== this.state.photos && 'edited-field' },
	                                  'Gallery Images ',
	                                  _react2.default.createElement(
	                                    'span',
	                                    { className: 'astrick' },
	                                    '*'
	                                  )
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'col-md-12 float-left mt-4 p-0' },
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'col-md-12 margin-bottom-mobile-account float-left image-upload' },
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'upload-wizard' },
	                                    _react2.default.createElement(
	                                      'div',
	                                      { className: 'upload-thumb' },
	                                      _react2.default.createElement(
	                                        'ul',
	                                        { className: 'list-inline' },
	                                        this.state.attachment_file.map(function (file_data, index) {
	
	                                          var file_url;
	                                          if (file_data.name) {
	                                            var url = file_data.image_thumb ? file_data.image_thumb : '';
	                                            if (url !== '') {
	                                              file_url = file_data.image_thumb;
	                                            } else {
	                                              file_url = URL.createObjectURL(file_data);
	                                            }
	
	                                            // var file_url = URL.createObjectURL(file_data)
	                                            // var file_name = file_data.name
	                                            if (file_data.type === 'application/pdf') {
	                                              return _react2.default.createElement(
	                                                'li',
	                                                { className: 'previewImg' },
	                                                _react2.default.createElement(
	                                                  'div',
	                                                  { className: 'thumb-img' },
	                                                  _react2.default.createElement('img', {
	                                                    src: file_url,
	                                                    alt: 'preview',
	                                                    title: file_data.name
	                                                  })
	                                                ),
	                                                _react2.default.createElement(
	                                                  'a',
	                                                  { href: 'javascript:;', className: 'del-btn', onClick: function onClick() {
	                                                      _this5.removeImage(file_data.name);
	                                                    } },
	                                                  _react2.default.createElement('img', {
	                                                    src: '../../../assets/images/close-icon-white.svg',
	                                                    alt: 'delete'
	                                                  })
	                                                )
	                                              );
	                                            } else {
	                                              return _react2.default.createElement(
	                                                'li',
	                                                { className: 'previewImg' },
	                                                _react2.default.createElement(
	                                                  'div',
	                                                  { className: 'thumb-img' },
	                                                  _react2.default.createElement('img', {
	                                                    src: file_url,
	                                                    alt: 'preview',
	                                                    title: file_data.name
	                                                  })
	                                                ),
	                                                _react2.default.createElement(
	                                                  'a',
	                                                  {
	                                                    href: 'javascript:;',
	                                                    className: 'del-btn',
	                                                    onClick: function onClick() {
	                                                      _this5.removeImage(file_data.name);
	                                                    }
	                                                  },
	                                                  _react2.default.createElement('img', {
	                                                    src: '../../../assets/images/close-icon-white.svg',
	                                                    alt: 'delete'
	                                                  })
	                                                )
	                                              );
	                                            }
	                                          }
	                                          return;
	                                        }),
	                                        _react2.default.createElement(
	                                          'li',
	                                          { className: 'addMore' },
	                                          _react2.default.createElement('input', {
	                                            type: 'file',
	                                            name: 'imgInp[]',
	                                            id: 'imgInp2',
	                                            className: 'add_img',
	                                            multiple: true,
	                                            onChange: this.loadFile.bind(this),
	                                            accept: 'image/x-png,image/gif,image/jpeg'
	                                          }),
	                                          _react2.default.createElement(
	                                            'a',
	                                            { href: 'javascript:;', className: 'add-more' },
	                                            _react2.default.createElement(
	                                              'div',
	                                              null,
	                                              _react2.default.createElement('img', { src: '../../../assets/images/upload-icon.svg', alt: 'icon' }),
	                                              'Add more'
	                                            )
	                                          )
	                                        )
	                                      )
	                                    )
	                                  )
	                                ),
	                                this.validator.message('gallery images', this.state.attachment_file, '', { className: 'text-danger error-msg' })
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-12 col-xs-12 btn-bdr' },
	                            _react2.default.createElement(
	                              'button',
	                              { id: 'btnSubmit', className: 'btn btn-primary btn-sm' },
	                              'Preview'
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          this.preview()
	        )
	      );
	    }
	  }]);
	
	  return verticalPreSchoolEdit;
	}(_react.Component);
	
	exports.default = verticalPreSchoolEdit;

/***/ },
/* 1036 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _reactJsPagination = __webpack_require__(33);
	
	var _reactJsPagination2 = _interopRequireDefault(_reactJsPagination);
	
	var _bewiseloading = __webpack_require__(48);
	
	var _bewiseloading2 = _interopRequireDefault(_bewiseloading);
	
	__webpack_require__(18);
	
	var _reactNotifications = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var verticalSchool = function (_Component) {
	  _inherits(verticalSchool, _Component);
	
	  function verticalSchool(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, verticalSchool);
	
	    var _this = _possibleConstructorReturn(this, (verticalSchool.__proto__ || Object.getPrototypeOf(verticalSchool)).call(this, props));
	
	    _this.getTotal = function (vertical) {
	      var location = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	
	      var locationselected = location === '' ? _this.state.location : location;
	
	      var ins = JSON.stringify({
	        vertical: vertical,
	        location: locationselected,
	        searchby: _this.state.searchby
	      });
	
	      (0, _FetchCall.getTotal)(ins).then(function (res) {
	
	        if (res.status === 1) {
	
	          _this.setState({
	
	            total: res.total
	
	          });
	        }
	      });
	    };
	
	    _this.getList = function () {
	      var pageNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	      var location = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	      var _this$state$auth_data = _this.state.auth_data,
	          login_id = _this$state$auth_data.login_id,
	          role = _this$state$auth_data.role;
	
	
	      _this.setState({ activePage: pageNumber });
	
	      var newOffset = pageNumber === 1 ? 0 : (pageNumber - 1) * _this.state.PER_PAGE % _this.state.total;
	
	      var locationselected = location === '' ? _this.state.location : location;
	
	      var ins = JSON.stringify({
	        vendor_id: login_id,
	        role: role,
	        location: locationselected,
	        searchby: _this.state.searchby,
	        perpage: _this.state.PER_PAGE,
	        offset: newOffset
	      });
	
	      (0, _FetchCall.getSchoolsPaged)(ins).then(function (res) {
	
	        _this.setState({ loading: true });
	
	        if (res.status === 1) {
	
	          _this.setState({ loading: false });
	
	          _this.setState({
	
	            schoolList: res.data
	
	          });
	        } else {
	
	          _this.setState({ loading: false });
	
	          _this.setState({
	            schoolList: []
	          });
	        }
	      });
	    };
	
	    _this.handleChange = function (e) {
	      _this.setState(_defineProperty({}, e.target.name, e.target.value));
	    };
	
	    _this.handleChangeCheckBox = function (event) {
	
	      _this.setState({ clickedbulkapproval: true });
	      var newArray = [].concat(_toConsumableArray(_this.state.toapprove), [event.target.value]);
	      if (_this.state.toapprove.includes(event.target.value)) {
	        newArray = newArray.filter(function (day) {
	          return day !== event.target.value;
	        });
	      }
	      _this.setState({
	        toapprove: newArray
	      });
	    };
	
	    _this.bulkApproval = function (e) {
	
	      console.log(_this.state.toapprove);
	
	      var ins = JSON.stringify({
	        vertical: 'schools',
	        ids: _this.state.toapprove
	      });
	
	      (0, _FetchCall.approveBulk)(ins).then(function (res) {
	
	        //console.log(res.message);
	        _reactNotifications.NotificationManager.success(res.message);
	      });
	    };
	
	    _this.searchBy = function (e) {
	
	      _this.setState({ loading: true, activePage: 1 });
	
	      _this.getTotal('bw_schools');
	      _this.getList(1);
	    };
	
	    _this.handleSelect = function (e) {
	
	      _this.setState({ location: e.target.value, activePage: 1 });
	
	      localStorage.setItem("location", e.target.value);
	
	      _this.getTotal('bw_schools', e.target.value);
	      _this.getList(1, e.target.value);
	    };
	
	    _this.schoolExport = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var req, res;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	
	              _this.setState({ exportbtndisabled: true, thisExportBtnText: "exporting..." });
	
	              _context.prev = 1;
	              req = JSON.stringify({
	                location: _this.state.location
	              });
	              _context.next = 5;
	              return (0, _FetchCall.exportSchool)(req);
	
	            case 5:
	              res = _context.sent;
	
	              if (res.status === 1) {
	
	                _this.setState({ exportbtndisabled: false, thisExportBtnText: "Export" });
	                console.log('location_list', res);
	                console.log('location_list', res.path);
	                window.open(res.path);
	
	                // this.setState({
	                //   subscribe_list: res.results,
	                // });
	              }
	
	              _context.next = 12;
	              break;
	
	            case 9:
	              _context.prev = 9;
	              _context.t0 = _context['catch'](1);
	
	              _this.setState({ error: true });
	
	            case 12:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2, [[1, 9]]);
	    }));
	
	    var url = new URL(window.location.href);
	    _this.state = {
	      logged: localStorage.getItem("authentication"),
	      auth_data: JSON.parse(localStorage.getItem("user_data")),
	      location: localStorage.getItem("location") ? localStorage.getItem("location") : 'Bengaluru',
	      schoolList: [],
	      PER_PAGE: 15,
	      total: 0,
	      loading: true,
	      searchby: '',
	      activePage: 0,
	      offset: 0,
	      exportbtndisabled: false,
	      thisExportBtnText: 'Export',
	      clickedbulkapproval: false,
	      toapprove: []
	    };
	
	    //this.handlePageChange = this.handlePageChange.bind(this);
	    _this.handleSelect = _this.handleSelect.bind(_this);
	    _this.getList = _this.getList.bind(_this);
	    _this.handleChangeCheckBox = _this.handleChangeCheckBox.bind(_this);
	    return _this;
	  }
	
	  _createClass(verticalSchool, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	
	      var THIS = this;
	      (0, _jquery2.default)(document).on('click', '.remove_school', function () {
	
	        var delete_id = (0, _jquery2.default)(this).data("id");
	        if (confirm("You are sure to delete?") === true) {
	
	          var ins = JSON.stringify({
	            id: delete_id,
	            table: 'school'
	          });
	
	          (0, _FetchCall.removethisItem)(ins).then(function (res) {
	
	            alert(res.message);
	            THIS.getTotal('bw_schools');
	            THIS.getList();
	          });
	        }
	      });
	
	      /*
	      $(document).on('click', '.stamp_it', function () {
	         var item_id = $(this).data("id");
	         THIS.openInfo(item_id);
	        
	      }); */
	
	      this.getTotal('bw_schools');
	      this.getList();
	    }
	  }, {
	    key: 'handlePageChange',
	    value: function handlePageChange(pageNumber) {
	
	      console.log('active page is ' + pageNumber);
	
	      this.setState({ activePage: pageNumber });
	
	      //this.getTotal('bw_schools');
	      this.getList(pageNumber);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          schoolList = _state.schoolList,
	          PER_PAGE = _state.PER_PAGE,
	          exportbtndisabled = _state.exportbtndisabled;
	
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'col-lg-12 grid-margin stretch-card' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card-body' },
	                _react2.default.createElement(
	                  'h4',
	                  { 'class': 'card-title' },
	                  'Schools'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'float-right' },
	                  _react2.default.createElement(
	                    'a',
	                    { href: '/vertical/school/add', 'class': 'btn btn-primary btn-sm' },
	                    'Add'
	                  ),
	                  ' \xA0',
	                  _react2.default.createElement(
	                    'button',
	                    { disabled: exportbtndisabled, 'class': 'btn btn-primary btn-sm', onClick: function onClick() {
	                        return _this3.schoolExport();
	                      } },
	                    this.state.thisExportBtnText
	                  ),
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'p',
	                  { 'class': 'card-description' },
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'cityselection' },
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'leftaligned bwlabel' },
	                      'City'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'leftaligned' },
	                      _react2.default.createElement(
	                        'select',
	                        { name: 'location', 'class': 'form-control', onChange: function onChange(e) {
	                            return _this3.handleSelect(e);
	                          },
	                          value: this.state.location },
	                        _react2.default.createElement(
	                          'option',
	                          { value: '' },
	                          'select city'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'Bengaluru' },
	                          'Bengaluru'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'Chennai' },
	                          'Chennai'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'Hyderabad' },
	                          'Hyderabad'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'Coimbatore' },
	                          'Coimbatore'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'Hosur' },
	                          'Hosur'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'Indore' },
	                          'Indore'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'Others' },
	                          'Others'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'leftaligned bwlabel' },
	                      'Search'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'leftaligned' },
	                      _react2.default.createElement('input', { type: 'text', name: 'searchby', 'class': 'form-control form-control-sm', onChange: this.handleChange })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'leftaligned' },
	                      _react2.default.createElement(
	                        'button',
	                        { 'class': 'btn btn-primary btn-sm', onClick: this.searchBy },
	                        'Go'
	                      )
	                    )
	                  )
	                ),
	                this.state.loading && _react2.default.createElement(
	                  'div',
	                  { id: 'loader' },
	                  _react2.default.createElement('img', { src: _bewiseloading2.default, width: '60px', alt: 'loader' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'pt-3' },
	                  this.state.clickedbulkapproval && _react2.default.createElement(
	                    'div',
	                    { 'class': 'showbtnapproval' },
	                    _react2.default.createElement(
	                      'button',
	                      { onClick: this.bulkApproval, name: 'bulkapproval', 'class': 'btn btn-primary btn-sm' },
	                      'Approve selected schools'
	                    ),
	                    _react2.default.createElement('br', null)
	                  ),
	                  !this.state.loading && _react2.default.createElement(
	                    'table',
	                    { id: 'tablebw' },
	                    '  ',
	                    _react2.default.createElement(
	                      'thead',
	                      null,
	                      _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          'Select'
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'S.No'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Date'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'School name'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Paid Partner'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Email Id'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Status'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Updated By'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Action'
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'tbody',
	                      null,
	                      schoolList.map(function (item, i) {
	
	                        return _react2.default.createElement(
	                          'tr',
	                          null,
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            ' ',
	                            item.actualstatus === 0 && _react2.default.createElement('input', { type: 'checkbox', name: 'toapprove[]', value: item.id, onChange: _this3.handleChangeCheckBox })
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.s_no
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.updated_date
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.schoolName
	                          ),
	                          _react2.default.createElement('td', { dangerouslySetInnerHTML: { __html: item.partnerProfile } }),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.email_id
	                          ),
	                          _react2.default.createElement('td', { dangerouslySetInnerHTML: { __html: item.status } }),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.updatedby
	                          ),
	                          _react2.default.createElement('td', { 'class': 'actionbtns', dangerouslySetInnerHTML: { __html: item.action } })
	                        );
	                      })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'text-center' },
	                    _react2.default.createElement(_reactJsPagination2.default, {
	                      activePage: this.state.activePage,
	                      itemsCountPerPage: PER_PAGE,
	                      totalItemsCount: this.state.total,
	                      pageRangeDisplayed: 5,
	                      activeClass: "pagination__link--active",
	                      onChange: this.handlePageChange.bind(this),
	                      prevPageText: 'previous',
	                      nextPageText: 'next'
	                    })
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(_reactNotifications.NotificationContainer, null)
	        )
	      );
	    }
	  }]);
	
	  return verticalSchool;
	}(_react.Component);
	
	exports.default = verticalSchool;

/***/ },
/* 1037 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _reactstrap = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var verticalSchoolDetail = function (_Component) {
	  _inherits(verticalSchoolDetail, _Component);
	
	  function verticalSchoolDetail(props) {
	    _classCallCheck(this, verticalSchoolDetail);
	
	    var _this = _possibleConstructorReturn(this, (verticalSchoolDetail.__proto__ || Object.getPrototypeOf(verticalSchoolDetail)).call(this, props));
	
	    _this.getSchool = function () {
	      var ins = JSON.stringify({
	        id: _this.id
	      });
	      (0, _FetchCall.getSchoolDetail)(ins).then(function (res) {
	        if (res.status === 1) {
	          _this.setState({
	            schoolDetail: res.data
	
	          });
	        } else {
	          _this.setState({
	            schoolDetail: ''
	          });
	        }
	      });
	    };
	
	    var url = new URL(window.location.href);
	    var location = url.searchParams.get("location");
	    var auth_data = JSON.parse(localStorage.getItem("user_data"));
	    _this.state = {
	      logged: localStorage.getItem("authentication"),
	      auth_data: JSON.parse(localStorage.getItem("user_data")),
	      location: location ? location : auth_data.access_location ? auth_data.access_location : 'Bengaluru',
	      schoolDetail: ''
	    };
	
	    _this.id = _this.props.match.params.id ? _this.props.match.params.id : '';
	    return _this;
	  }
	
	  _createClass(verticalSchoolDetail, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	
	      this.getSchool(this.id);
	    }
	  }, {
	    key: 'gallery_image',
	    value: function gallery_image() {
	      var _this2 = this;
	
	      var photos = this.state.photos_arr !== undefined ? this.state.photos_arr : [];
	      var rows = "";
	      if (photos.length > 0) {
	        rows = photos.map(function (photos) {
	          if (photos.name) {
	            return _react2.default.createElement(
	              'div',
	              { 'class': 'col-md-4 float-left mt-4 p-0' },
	              _react2.default.createElement('img', { src: _this2.state.url + photos.name, alt: 'Img', 'class': 'img-thumbnail' })
	            );
	          }
	          return;
	        });
	      } else {
	        rows = "";
	      }
	      return rows;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var schoolDetail = this.state.schoolDetail;
	
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'col-lg-12 grid-margin stretch-card' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card-body' },
	                _react2.default.createElement(
	                  'h4',
	                  { 'class': 'card-title' },
	                  schoolDetail.organisation_name,
	                  ' - View'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'pt-3 detailsection' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'box-shadow-custom' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-12 col-xs-12' },
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'form-legend bottom-bordered' },
	                          _react2.default.createElement(
	                            'h3',
	                            null,
	                            'Primary Information'
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-group col-md-4' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          'Registration No'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          schoolDetail.registration_no
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-group col-md-4' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          'Owner Name'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          schoolDetail.ownerName
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-group col-md-4' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          'Organization Name'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          schoolDetail.schoolName
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-group col-md-4' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          'Type of School'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          schoolDetail.sub_cate_boe
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-group col-md-4' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          'Board of Education'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          schoolDetail.sub_types_names
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-group col-md-4' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          'Campus Type'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          schoolDetail.sub_type_names
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'box-shadow-custom' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-12 col-xs-12' },
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'form-legend' },
	                          _react2.default.createElement(
	                            'h3',
	                            null,
	                            'Address Information'
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-group col-md-4' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          'Email Id'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          schoolDetail.email_id
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-group col-md-4' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          'Phone Number'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          schoolDetail.phone_number
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-group col-md-4' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          'Landline Number'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          schoolDetail.landline_number
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-group col-md-4' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          'Website'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          schoolDetail.website
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-group col-md-4' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          'State'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          schoolDetail.state
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-group col-md-4' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          'Location'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          schoolDetail.location
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-group col-md-4' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          'Country'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          schoolDetail.country
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-group col-md-4' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          'Pincode'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          schoolDetail.pincode
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-group col-md-4' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          'Address'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          schoolDetail.address
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-group col-md-4' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          'Google Location Address'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          schoolDetail.google_location
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-group col-md-12' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          'About the School'
	                        ),
	                        _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: schoolDetail.about_school } })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'box-shadow-custom' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-12 col-xs-12' },
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'form-legend' },
	                          _react2.default.createElement(
	                            'h3',
	                            null,
	                            'Key Information'
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-group col-md-4' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          'School type'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          schoolDetail.scltype
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-group col-md-4' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          'Classification'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          schoolDetail.cls_name
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-group col-md-4 input-group-cus' },
	                        _react2.default.createElement(
	                          'div',
	                          null,
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            'Grade From/ To'
	                          ),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            schoolDetail.grade
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          null,
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            '\xA0'
	                          ),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            schoolDetail.grade_to
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-group col-md-4 input-group-cus' },
	                        _react2.default.createElement(
	                          'div',
	                          null,
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            'From Timing'
	                          ),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            schoolDetail.dfrom_time
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-group col-md-4 input-group-cus' },
	                        _react2.default.createElement(
	                          'div',
	                          null,
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            'To Timing'
	                          ),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            schoolDetail.dto_time
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-group col-md-4' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          'Min Age of Admission'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          schoolDetail.min_age
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-group col-md-4' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          'Instruction Language'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          schoolDetail.instruction_lang
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-group col-md-4' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          'Student Ratio'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          schoolDetail.teacher_student_ratio
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-group col-md-4' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          'Establishment Year'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          schoolDetail.establishment_Year
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-group col-md-4' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          'Amenities '
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          schoolDetail.facilites
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-group col-md-4' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          'Indicative Annual Fee(INR)'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          schoolDetail.avg_anual_fee
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-group col-md-4' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          'Other Fees'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          schoolDetail.other_fee
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-group col-md-4' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          'Admission Fees'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          schoolDetail.addmission_fee
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-group col-md-4' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          'Is Refundable (Admission Fees)'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          schoolDetail.is_refund === 1 ? 'Yes' : 'No'
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'box-shadow-custom' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-12 col-xs-12' },
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'form-legend' },
	                          'Admission Details'
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-group col-md-4' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          'Admission Link'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          schoolDetail.admission_link
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-group col-md-4' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          'Application Fees'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          schoolDetail.processing_fee
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-group col-md-4' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          'Required Documents '
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          schoolDetail.document_name
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-group col-md-4' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          'Admission Process'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          schoolDetail.admission_process
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-group col-md-4' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          'Website Search Keywords'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          schoolDetail.keywords
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'box-shadow-custom' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-12 col-xs-12' },
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'form-legend' },
	                          'Images'
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-group col-md-4' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          'Banner Images'
	                        ),
	                        schoolDetail.images && _react2.default.createElement('img', { src: schoolDetail.url + schoolDetail.images, alt: 'Img', 'class': 'img-thumbnail' })
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'col-md-12 float-left mt-4 p-0' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          'Gallery Images'
	                        )
	                      ),
	                      this.gallery_image()
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactstrap.Col,
	                    { className: '', md: '12' },
	                    _react2.default.createElement(
	                      'button',
	                      { className: 'btn btn-sm btn-primary custome-submit', onClick: this.handleSubmit },
	                      this.state.edited && this.state.role === 1 ? 'Approve' : 'Submit'
	                    ),
	                    this.state.edited && this.state.role === 1 && _react2.default.createElement(
	                      'button',
	                      { className: 'btn btn-sm btn-danger custome-submit', style: { marginLeft: '10px' },
	                        onClick: this.handleReject },
	                      'Reject'
	                    ),
	                    _react2.default.createElement(
	                      'button',
	                      { className: 'btn btn-sm btn-defult custome-submit', style: { marginLeft: '10px' },
	                        onClick: function onClick() {
	                          _this3.setState({ preview: false });
	                        } },
	                      'Close'
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return verticalSchoolDetail;
	}(_react.Component);
	
	exports.default = verticalSchoolDetail;

/***/ },
/* 1038 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _FetchCall2 = _interopRequireDefault(_FetchCall);
	
	var _constant = __webpack_require__(21);
	
	var _reactstrap = __webpack_require__(17);
	
	var _reactGeocode = __webpack_require__(55);
	
	var _reactGeocode2 = _interopRequireDefault(_reactGeocode);
	
	var _multiselectReactDropdown = __webpack_require__(73);
	
	var _simpleReactValidator = __webpack_require__(28);
	
	var _simpleReactValidator2 = _interopRequireDefault(_simpleReactValidator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	_reactGeocode2.default.setApiKey("AIzaSyA9MtbfG_zlo64B2lqNMvigTBuXHkagKcE");
	_reactGeocode2.default.setLanguage("en");
	_reactGeocode2.default.setRegion("es");
	_reactGeocode2.default.enableDebug();
	var schooltypes = [{ "id": 1, "type_name": "Government" }, { "id": 2, "type_name": "Private" }, { "id": 3, "type_name": "NA" }];
	var type = [{ "id": 1, "name": "Regular" }, { "id": 2, "name": "Boarding" }, { "id": 3, "name": "NA" }];
	var curriculam = [{ "id": 1, "name": "State Board / Matriculation" }, { "id": 2, "name": "CBSE" }, { "id": 3, "name": "ICSE" }, { "id": 4, "name": "IGCSE" }, { "id": 5, "name": "IB" }, { "id": 6, "name": "NIOS" }, { "id": 7, "name": "NA" }];
	var boe = [{ "category_id": 12, "category_name": "Open School", "is_parent": 0, "parent": "Schools" }, { "category_id": 133, "category_name": "Special Needs", "is_parent": 0, "parent": "Schools" }, { "category_id": 142, "category_name": "Public School", "is_parent": 0, "parent": "Schools" }, { "category_id": 143, "category_name": "Private School", "is_parent": 0, "parent": "Schools" }, { "category_id": 144, "category_name": "Boarding School", "is_parent": 0, "parent": "Schools" }, { "category_id": 145, "category_name": "International School", "is_parent": 0, "parent": "Schools" }, { "category_id": 147, "category_name": "Alternative School", "is_parent": 0, "parent": "Schools" }, { "category_id": 174, "category_name": "E-School", "is_parent": 0, "parent": "Schools" }];
	var locations = [{ "id": 1, "location": "Bengaluru", "latitude": "12.9716", "longitude": "77.5946", "status": 1, "sort_order": 1 }, { "id": 12, "location": "Chennai", "latitude": "13.0569", "longitude": "80.2425", "status": 1, "sort_order": 2 }, { "id": 11, "location": "Coimbatore", "latitude": "11.0168", "longitude": "76.9558", "status": 1, "sort_order": 3 }, { "id": 2, "location": "Hyderabad", "latitude": "17.3850", "longitude": "78.4867", "status": 1, "sort_order": 4 }, { "id": 24, "location": "Madurai", "latitude": "9.9252", "longitude": "78.1198", "status": 1, "sort_order": 5 }, { "id": 13, "location": "Mumbai", "latitude": "19.0760", "longitude": "72.8777", "status": 1, "sort_order": 7 }, { "id": 15, "location": "Kolkata", "latitude": "22.5726", "longitude": "88.3639", "status": 1, "sort_order": 8 }, { "id": 16, "location": "New Delhi", "latitude": "28.6139", "longitude": "77.2090", "status": 1, "sort_order": 9 }, { "id": 17, "location": "Jaipur", "latitude": "26.9124", "longitude": "75.7873", "status": 1, "sort_order": 10 }, { "id": 18, "location": "Chandigarh", "latitude": "30.7333", "longitude": "76.7794", "status": 1, "sort_order": 11 }, { "id": 19, "location": "Pune", "latitude": "18.5204", "longitude": "73.8567", "status": 1, "sort_order": 12 }, { "id": 20, "location": "Kochi", "latitude": "9.9312", "longitude": "76.2673", "status": 1, "sort_order": 13 }, { "id": 21, "location": "Noida", "latitude": "28.5355", "longitude": "77.3910", "status": 1, "sort_order": 14 }, { "id": 22, "location": "Agra", "latitude": "27.1767", "longitude": "78.0081", "status": 1, "sort_order": 15 }, { "id": 23, "location": "Puducherry", "latitude": "11.9416", "longitude": "79.8083", "status": 1, "sort_order": 16 }, { "id": 25, "location": "Tiruchirappalli", "latitude": "10.7905", "longitude": "78.7047", "status": 1, "sort_order": 17 }, { "id": 27, "location": "Hosur", "latitude": "12.7409", "longitude": "77.8253", "status": 1, "sort_order": 4 }, { "id": 26, "location": "Indore", "latitude": "22.719568", "longitude": "75.857727", "status": 1, "sort_order": 18 }];
	var classifications = [{ "id": 1, "name": "Co-Ed" }, { "id": 2, "name": "Boys" }, { "id": 3, "name": "Girls" }, { "id": 4, "name": "NA" }];
	var documents = [{ "id": 1, "document_name": "Birth Certificate" }, { "id": 2, "document_name": "Residential Proof" }, { "id": 3, "document_name": "Aadhar Card" }, { "id": 4, "document_name": "Passport Size Photos" }, { "id": 5, "document_name": "Immunization Certificate" }, { "id": 6, "document_name": "NA" }];
	var amenetis = [{ "id": 1, "facility": "CCTV" }, { "id": 2, "facility": "AC Classes" }, { "id": 3, "facility": "Transportation" }, { "id": 4, "facility": "Food and Snacks" }, { "id": 5, "facility": "Outdoor Play area" }, { "id": 7, "facility": "Library" }, { "id": 6, "facility": "NA" }];
	var timings = [{ "id": 1, "timing": "01:00" }, { "id": 2, "timing": "01:30" }, { "id": 3, "timing": "02:00" }, { "id": 4, "timing": "02:30" }, { "id": 5, "timing": "03:00" }, { "id": 6, "timing": "03:30" }, { "id": 7, "timing": "04:00" }, { "id": 8, "timing": "04:30" }, { "id": 9, "timing": "05:00" }, { "id": 10, "timing": "05:30" }, { "id": 11, "timing": "06:00" }, { "id": 12, "timing": "06:30" }, { "id": 13, "timing": "07:00" }, { "id": 14, "timing": "07:30" }, { "id": 15, "timing": "08:00" }, { "id": 16, "timing": "08:30" }, { "id": 17, "timing": "09:00" }, { "id": 18, "timing": "09:30" }, { "id": 19, "timing": "10:00" }, { "id": 20, "timing": "10:30" }, { "id": 21, "timing": "11:00" }, { "id": 22, "timing": "11:30" }, { "id": 23, "timing": "12:00" }, { "id": 24, "timing": "12:30" }, { "id": 25, "timing": "NA" }];
	var grades = [{ "id": 1, "name": "Grade 1" }, { "id": 2, "name": "Grade 2" }, { "id": 3, "name": "Grade 3" }, { "id": 4, "name": "Grade 4" }, { "id": 5, "name": "Grade 5" }, { "id": 6, "name": "Grade 6" }, { "id": 7, "name": "Grade 7" }, { "id": 8, "name": "Grade 8" }, { "id": 9, "name": "Grade 9" }, { "id": 10, "name": "Grade 10" }, { "id": 11, "name": "Grade 11" }, { "id": 12, "name": "Grade 12" }, { "id": 13, "name": "NA" }];
	var mops = [{ "id": 1, "payment_name": "Cash" }, { "id": 2, "payment_name": "Card" }, { "id": 3, "payment_name": "Cheque" }, { "id": 4, "payment_name": "Online Payments" }, { "id": 5, "payment_name": "NA" }];
	var classfrequencies = [{ "id": 1, "freq_name": "Daily" }, { "id": 2, "freq_name": "Weekly" }, { "id": 3, "freq_name": "Monthly" }, { "id": 4, "freq_name": "NA" }];
	
	var verticalSchool = function (_Component) {
	  _inherits(verticalSchool, _Component);
	
	  function verticalSchool(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, verticalSchool);
	
	    var _this = _possibleConstructorReturn(this, (verticalSchool.__proto__ || Object.getPrototypeOf(verticalSchool)).call(this, props));
	    // alert(MOBILE_REGEX)
	
	
	    _this.getKeywords = function () {
	      (0, _FetchCall.commonAPI)(JSON.stringify({ url: 'get_site_keywords', vertical: 'school' })).then(function (res) {
	        if (res.status === 1) {
	          _this.setState({
	            keywordsArr: res.results
	          });
	        }
	      });
	    };
	
	    _this.getPresclList = function () {
	      (0, _FetchCall.preSclList)().then(function (res) {
	        if (res.status === 1) {
	          _this.setState({
	            preSclList: res.list
	          });
	        }
	      });
	    };
	
	    _this.LocationDataList = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var res;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.prev = 0;
	              _context.next = 3;
	              return (0, _FetchCall.getLocationList)();
	
	            case 3:
	              res = _context.sent;
	
	              if (res.status === 1) {
	                console.log('location_list', res.results);
	
	                _this.setState({
	                  location_list: res.results,
	                  error: false
	                });
	              }
	
	              _context.next = 10;
	              break;
	
	            case 7:
	              _context.prev = 7;
	              _context.t0 = _context['catch'](0);
	
	              _this.setState({ error: true });
	
	            case 10:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2, [[0, 7]]);
	    }));
	
	    _this.removeImage = function (e) {
	      var delete_array = _this.state.delete_array;
	      delete_array.push(e);
	      var updated = _this.state.attachment_file.filter(function (item) {
	        return item.name !== e;
	      });
	
	      _this.setState({
	        attachment_file: updated,
	        delete_array: delete_array
	      });
	    };
	
	    _this.refreshSelectPreSchools = function (e) {
	      console.log("testing");
	      _this.getPresclList();
	    };
	
	    _this.handleChange = function (e) {
	      _this.setState(_defineProperty({}, e.target.name, e.target.value));
	      if (e.target.name === 'google_location') _this.Geocode_location();
	    };
	
	    _this.handleChangeName = function (e) {
	      if (e.target.value !== '') _this.validateNameAndUrl(e.target.value);
	    };
	
	    _this.validateMail = function (value, catgry, vendr_id, pageid) {
	      var _JSON$stringify;
	
	      var name = 'email_id';
	      var type_name = 'isEmailValid';
	      var req = JSON.stringify((_JSON$stringify = {}, _defineProperty(_JSON$stringify, name, value), _defineProperty(_JSON$stringify, 'category', catgry), _defineProperty(_JSON$stringify, 'vendor_id', vendr_id), _JSON$stringify));
	      (0, _FetchCall.emailExist_check)(req).then(function (res) {
	        console.log('valuee', res);
	        if (res.status === 1) {
	          _this.setState(_defineProperty({}, type_name, false));
	        } else {
	          // return res.status;
	          _this.setState(_defineProperty({}, type_name, true));
	        }
	      });
	    };
	
	    _this.handleNumberChange = function (e) {
	      var regexp = /^[0-9\b]+$/;
	      var Mnumber = e.target.value;
	
	      if (e.target.value === '' || regexp.test(e.target.value)) {
	        _this.setState(_defineProperty({}, e.target.name, Mnumber));
	      }
	      _this.Geocode_location();
	    };
	
	    _this.isEmailValid = function () {
	      var email = _this.state.email_id;
	      var reg = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
	
	      if (reg.test(email) !== true) {
	        _this.showValidationErr("email_id", "Please Enter Valid Email id");
	        return false;
	      } else {
	        _this.clearValidationErr("email_id");
	        return true;
	      }
	    };
	
	    _this.handlePaste = function (e) {
	      _this.Geocode_location();
	    };
	
	    _this.handleFile = function (e) {
	      // this.Geocode_location();
	      var propName = e.target.name;
	      var files = e.target.files[0];
	      _this.setState(_defineProperty({}, propName, files));
	      var reader = new FileReader();
	      var THIS = _this;
	      reader.addEventListener("load", function () {
	        // convert image file to base64 string
	        THIS.setState({
	          tempBanner: reader.result
	        });
	      }, false);
	
	      if (files) {
	        reader.readAsDataURL(files);
	      } else {
	        THIS.setState({
	          tempBanner: ''
	        });
	      }
	    };
	
	    _this.handleFileMultiple = function (e) {
	      _this.setState(_defineProperty({}, e.target.name, e.target.files));
	    };
	
	    _this.handleSelectGradeFrom = function (e) {
	      var grade_from = parseInt(e.target.value, 10);
	      var grade_to = parseInt(_this.state.grade_to, 10);
	      if (grade_from >= grade_to) {
	        _this.setState({
	          grade: ''
	        });
	        var toastr = '';
	        toastr = window.toastr.error;
	        toastr('', 'Grade From should be lesser than grade to! ', {
	          positionClass: "toast-bottom-right",
	          containerId: "toast-bottom-right"
	        });
	        return false;
	      }
	      var propName = e.target.name;
	      var value = [].concat(_toConsumableArray(e.target.selectedOptions)).map(function (item) {
	        return item.value;
	      });
	      _this.setState(_defineProperty({}, propName, value));
	    };
	
	    _this.handleSelectGradeto = function (e) {
	      var grade_from = parseInt(_this.state.grade, 10);
	      var grade_to = parseInt(e.target.value, 10);
	      if (grade_to <= grade_from) {
	        _this.setState({
	          grade_to: ''
	        });
	        var toastr = '';
	        toastr = window.toastr.error;
	        toastr('', 'Grade to should be greater than grade from! ', {
	          positionClass: "toast-bottom-right",
	          containerId: "toast-bottom-right"
	        });
	        return false;
	      }
	      var propName = e.target.name;
	      var value = [].concat(_toConsumableArray(e.target.selectedOptions)).map(function (item) {
	        return item.value;
	      });
	      console.log(propName, value);
	      _this.Sub_Cat_type(value);
	      _this.setState(_defineProperty({}, propName, value));
	    };
	
	    _this.handleSelect = function (e) {
	      var propName = e.target.name;
	      var value = [].concat(_toConsumableArray(e.target.selectedOptions)).map(function (item) {
	        return item.value;
	      });
	      console.log(propName, value);
	      _this.Sub_Cat_type(value);
	
	      _this.setState(_defineProperty({}, propName, value));
	    };
	
	    _this.onSelect = function (selectedList) {
	      var keywords = [];
	      selectedList.forEach(function (item, i) {
	        keywords.push(item);
	      });
	      _this.setState({
	        keywords: keywords
	      });
	    };
	
	    _this.onRemove = function (selectedList, removedItem) {
	      var keywords = [];
	      selectedList.forEach(function (item, i) {
	        keywords.push(item);
	      });
	      _this.setState({
	        keywords: keywords
	      });
	    };
	
	    _this.handleSelectCat1 = function (e) {
	      var propName = e.target.name;
	      var value = [].concat(_toConsumableArray(e.target.selectedOptions)).map(function (item) {
	        return item.value;
	      });
	      _this.setState(_defineProperty({}, propName, value));
	    };
	
	    _this.handlePreview = function (e) {
	      e.preventDefault();
	      if (_this.validator.allValid()) {
	        _this.setState({
	          preview: true
	        });
	      } else {
	        _this.validator.showMessages();
	        _this.forceUpdate();
	      }
	    };
	
	    _this.preview = function () {
	      var boe = _this.state.categorySubTypeList.map(function (item) {
	        return _this.state.sub_types.includes(item.id.toString()) ? item.name : '';
	      });
	      boe = boe.filter(function (n) {
	        return n;
	      }).toString();
	      var grade_from = _this.state.gradeList.map(function (item) {
	        if (item.id === _this.state.grade) return item.name;
	      });
	      grade_from = grade_from.filter(function (n) {
	        return n;
	      }).toString();
	      var grade_to = _this.state.gradeList.map(function (item) {
	        if (item.id === _this.state.grade_to) return item.name;
	      });
	      grade_to = grade_to.filter(function (n) {
	        return n;
	      }).toString();
	      var from_time = _this.state.timingList.map(function (item) {
	        if (item.id === _this.state.from_time) return item.timing;
	      });
	      from_time = from_time.filter(function (n) {
	        return n;
	      }).toString();
	      var to_time = _this.state.timingList.map(function (item) {
	        if (item.id === _this.state.to_time) return item.timing;
	      });
	      to_time = to_time.filter(function (n) {
	        return n;
	      }).toString();
	      return _react2.default.createElement(
	        _reactstrap.Modal,
	        { isOpen: _this.state.preview, size: 'lg', className: 'preview-pop' },
	        _react2.default.createElement(
	          _reactstrap.ModalBody,
	          { className: '' },
	          _react2.default.createElement(
	            _reactstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactstrap.Col,
	              { md: '12' },
	              _react2.default.createElement('img', { src: '/assets/images/user-header.png', className: 'preview-header', alt: 'header' })
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.Row,
	            { className: 'pv-banner' },
	            _react2.default.createElement(
	              _reactstrap.Col,
	              { className: 'pv-banner-bg', md: '12' },
	              _react2.default.createElement(
	                'div',
	                { className: 'title-section' },
	                _react2.default.createElement(
	                  'p',
	                  { className: 'banner-title' },
	                  _this.state.schoolName
	                ),
	                _react2.default.createElement(
	                  'p',
	                  { className: 'banner-address' },
	                  _this.state.address
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.Row,
	            { className: 'pv-section' },
	            _react2.default.createElement(
	              _reactstrap.Col,
	              { className: '', md: '12' },
	              _react2.default.createElement(
	                'div',
	                { className: 'title-section' },
	                _react2.default.createElement(
	                  'h4',
	                  null,
	                  'About the School'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  { className: '' },
	                  _this.state.about_school
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.Row,
	            { className: 'pv-section' },
	            _react2.default.createElement(
	              _reactstrap.Col,
	              { className: '', md: '12' },
	              _react2.default.createElement(
	                'div',
	                { className: 'title-section' },
	                _react2.default.createElement(
	                  'h4',
	                  null,
	                  'Key Information'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-4' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'type-n7ngd' },
	                      _react2.default.createElement(
	                        'b',
	                        null,
	                        'School Type'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'key-po' },
	                      _this.state.boeList.map(function (item) {
	                        if (item.category_id === _this.state.board_of_education) {
	                          return item.category_name;
	                        }
	                      })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-4' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'type-n7ngd' },
	                      _react2.default.createElement(
	                        'b',
	                        null,
	                        'Board Of Education'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'key-po' },
	                      _react2.default.createElement(
	                        'p',
	                        null,
	                        boe
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-4' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'type-n7ngd' },
	                      _react2.default.createElement(
	                        'b',
	                        null,
	                        'Grades'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'key-po' },
	                      _react2.default.createElement(
	                        'p',
	                        null,
	                        grade_from === 'NA' || grade_to === 'NA' ? 'NA' : grade_from + ' - ' + grade_to
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-4' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'type-n7ngd' },
	                      _react2.default.createElement(
	                        'b',
	                        null,
	                        'Min Age of Admission'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'key-po' },
	                      _react2.default.createElement(
	                        'p',
	                        null,
	                        _this.state.min_age
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-4' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'type-n7ngd' },
	                      _react2.default.createElement(
	                        'b',
	                        null,
	                        'Establishment Year'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'key-po' },
	                      _react2.default.createElement(
	                        'p',
	                        null,
	                        _this.state.establishment_Year
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-4' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'type-n7ngd' },
	                      _react2.default.createElement(
	                        'b',
	                        null,
	                        'Landline Number'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'key-po' },
	                      _react2.default.createElement(
	                        'p',
	                        null,
	                        _this.state.landline_number
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-4' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'type-n7ngd' },
	                      _react2.default.createElement(
	                        'b',
	                        null,
	                        'School Timing'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'key-po' },
	                      _react2.default.createElement(
	                        'p',
	                        null,
	                        from_time === 'NA' || to_time === 'NA' ? 'NA' : from_time + ' ' + _this.state.from_time_cate + ' - ' + to_time + ' ' + _this.state.to_time_cate
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-4' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'type-n7ngd' },
	                      _react2.default.createElement(
	                        'b',
	                        null,
	                        'Location'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'key-po' },
	                      _react2.default.createElement(
	                        'p',
	                        null,
	                        _this.state.location
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-4' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'type-n7ngd' },
	                      _react2.default.createElement(
	                        'b',
	                        null,
	                        'Teacher:Student Ratio'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'key-po' },
	                      _react2.default.createElement(
	                        'p',
	                        null,
	                        _this.state.stdRatio
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-4' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'type-n7ngd' },
	                      _react2.default.createElement(
	                        'b',
	                        null,
	                        'Is Refundable (Admission Fees)'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'key-po' },
	                      _react2.default.createElement(
	                        'p',
	                        null,
	                        _this.state.isrefund === 1 ? 'Yes' : 'No'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-4' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'type-n7ngd' },
	                      _react2.default.createElement(
	                        'b',
	                        null,
	                        'Scholarship Facility'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'key-po' },
	                      _react2.default.createElement(
	                        'p',
	                        null,
	                        _this.state.has_scholarship === 0 ? 'NA' : _this.state.has_scholarship === 1 ? 'Yes, ' : 'No',
	                        '\xA0',
	                        _this.state.has_scholarship === 1 && _this.state.scholarship_desc
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.Row,
	            { className: 'pv-section' },
	            _react2.default.createElement(
	              _reactstrap.Col,
	              { className: '', md: '12' },
	              _react2.default.createElement(
	                'div',
	                { className: 'title-section' },
	                _react2.default.createElement(
	                  'h4',
	                  null,
	                  'Amenities'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row' },
	                  _this.state.facilities.map(function (item) {
	                    var fac_data = _this.state.facilitiesList.filter(function (data) {
	                      return data.id === item;
	                    });
	                    if (fac_data.length > 0) {
	                      return _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-4' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: '' },
	                          fac_data[0].facility
	                        )
	                      );
	                    }
	                  })
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.Row,
	            { className: 'pv-section' },
	            _react2.default.createElement(
	              _reactstrap.Col,
	              { className: '', md: '12' },
	              _react2.default.createElement(
	                'div',
	                { className: 'title-section' },
	                _react2.default.createElement(
	                  'h4',
	                  null,
	                  'Gallery'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row' },
	                  _this.state.attachment_file.map(function (item) {
	                    console.log('********', item);
	                    if (item.image_thumb) {
	                      return _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-4' },
	                        _react2.default.createElement('img', { src: item.image_thumb, className: 'preview-image', alt: 'preview' })
	                      );
	                    } else if (item.name) {
	                      var file_url = URL.createObjectURL(item);
	                      return _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-4' },
	                        _react2.default.createElement('img', { src: file_url, className: 'preview-image', alt: 'preview' })
	                      );
	                    }
	                  }),
	                  _this.state.attachment_file.length === 0 && _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-4' },
	                    'No Gallery Images Found'
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.Row,
	            { className: 'pv-section' },
	            _react2.default.createElement(
	              _reactstrap.Col,
	              { className: '', md: '12' },
	              _react2.default.createElement(
	                'div',
	                { className: 'title-section' },
	                _react2.default.createElement(
	                  'h4',
	                  null,
	                  'Fees Structure'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-4' },
	                    'Indicative Annual Fee : ',
	                    _this.state.avg_anual_fee > 0 ? _this.state.avg_anual_fee : 'NA'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-4' },
	                    'Recurring Fees : ',
	                    _this.state.addmission_fee > 0 ? _this.state.addmission_fee : 'NA'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-4' },
	                    'Other Fees : ',
	                    _this.state.other_fee > 0 ? _this.state.other_fee : 'NA'
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.Row,
	            { className: 'pv-section' },
	            _react2.default.createElement(
	              _reactstrap.Col,
	              { className: '', md: '12' },
	              _react2.default.createElement(
	                'div',
	                { className: 'title-section' },
	                _react2.default.createElement(
	                  'h4',
	                  null,
	                  'Admission Details'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-6' },
	                    'Admission Link : ',
	                    _this.state.admission_link ? _react2.default.createElement(
	                      'a',
	                      { href: _this.state.admission_link },
	                      'Link'
	                    ) : 'NA'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-6' },
	                    'Admission Process : ',
	                    _this.state.admission_process
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.Row,
	            { className: 'pv-section' },
	            _react2.default.createElement(
	              _reactstrap.Col,
	              { className: '', md: '12' },
	              _react2.default.createElement(
	                'div',
	                { className: 'title-section' },
	                _react2.default.createElement(
	                  'h4',
	                  null,
	                  'Required Documents'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row' },
	                  _this.state.required_document.map(function (item) {
	                    var redoc_data = _this.state.documentList.filter(function (data) {
	                      return data.id === item;
	                    });
	                    if (redoc_data.length > 0) {
	                      return _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-4' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: '' },
	                          redoc_data[0].document_name
	                        )
	                      );
	                    }
	                  })
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.Row,
	            { className: 'pv-section' },
	            _react2.default.createElement(
	              _reactstrap.Col,
	              { className: '', md: '12' },
	              _react2.default.createElement(
	                'div',
	                { className: 'title-section' },
	                _react2.default.createElement(
	                  'h4',
	                  null,
	                  'Contact Information'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-4' },
	                    'Email Id : ',
	                    _this.state.email_id
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-4' },
	                    'Contact : ',
	                    _this.state.phone_number
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-4' },
	                    'Website : ',
	                    _this.state.website
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.Row,
	            { className: 'pv-section' },
	            _react2.default.createElement(
	              _reactstrap.Col,
	              { className: '', md: '12' },
	              _react2.default.createElement(
	                'button',
	                { className: 'btn btn-sm btn-primary custome-submit', onClick: _this.handleSubmit },
	                _this.state.edited && _this.state.role === 1 ? 'Approve' : 'Submit'
	              ),
	              _this.state.edited && _this.state.role === 1 && _react2.default.createElement(
	                'button',
	                { className: 'btn btn-sm btn-danger custome-submit', style: { marginLeft: '10px' },
	                  onClick: _this.handleReject },
	                'Reject'
	              ),
	              _react2.default.createElement(
	                'button',
	                { className: 'btn btn-sm btn-defult custome-submit', style: { marginLeft: '10px' },
	                  onClick: function onClick() {
	                    _this.setState({ preview: false });
	                  } },
	                'Close'
	              )
	            )
	          )
	        )
	      );
	    };
	
	    _this.handleSubmit = function (e) {
	      e.preventDefault();
	      if (_this.validator.allValid()) {
	        var ins = {
	          id: _this.id ? _this.id : '',
	          about: _this.state.about_school,
	          admit_fee: _this.state.addmission_fee,
	          address: _this.state.address,
	          admit_link: _this.state.admission_link,
	          admit_process: _this.state.admission_process,
	          avg_fee: _this.state.avg_anual_fee,
	          sub_categories: _this.state.board_of_education,
	          sub_types: _this.state.sub_types,
	          sub_type: _this.state.sub_type,
	          bof: _this.state.board_of_education,
	          classification: _this.state.classification,
	          country: _this.state.country,
	          email_id: _this.state.email_id,
	          est_year: _this.state.establishment_Year,
	          facilites: _this.state.facilities,
	          fax_number: _this.state.fax_number,
	          google_location: _this.state.google_location,
	          grade: _this.state.grade,
	          grade_to: _this.state.grade_to,
	          images: _this.state.images,
	          inst_lang: _this.state.instruction_lang,
	          is_refund: _this.state.isrefund,
	          landline_no: _this.state.landline_number,
	          location: _this.state.location,
	          min_age: _this.state.min_age,
	          teacher_student_ratio: _this.state.stdRatio,
	          // mop: this.state.mode_of_payment,
	          other_fee: _this.state.other_fee,
	          owner_name: _this.state.ownerName,
	          phone_number: _this.state.phone_number,
	          photos: _this.state.attachment_file ? _this.state.attachment_file : '',
	          pincode: _this.state.pincode,
	          process_fee: _this.state.processing_fee,
	          registration_no: _this.state.registration_no,
	          documents: _this.state.required_document,
	          organisation_name: _this.state.schoolName,
	          school_type: _this.state.schoolType,
	          timing: _this.state.school_timimg,
	          state: _this.state.state,
	          website: _this.state.website,
	          latitude: _this.state.latitude,
	          longitude: _this.state.longitude,
	          other_rating: _this.state.other_rating,
	          from_time: _this.state.from_time,
	          to_time: _this.state.to_time,
	          from_time_cate: _this.state.from_time_cate,
	          to_time_cate: _this.state.to_time_cate,
	          keywords: _this.state.keywords ? _this.state.keywords.join(';') : '',
	          delete_array: _this.state.delete_array,
	          has_scholarship: _this.state.has_scholarship,
	          scholarship_desc: _this.state.scholarship_desc,
	          login_id: _this.state.login_id,
	          prescl_link: _this.state.prescl_link,
	          role: _this.state.role,
	          admission_open: _this.state.admission_open,
	          admission_closed: _this.state.admission_closed,
	          seats_in: _this.state.seats_in,
	          current_vacancies: _this.state.current_vacancies
	        };
	
	        (0, _FetchCall.createSchool)(ins).then(function (res) {
	          if (res.status === 1) {
	            alert("Saved successfully");
	            window.location.href = document.referrer;
	          } else {
	            (0, _jquery2.default)("#btnSubmit").attr('disabled', false);
	            alert("Error in saving");
	          }
	        });
	      } else {
	        _this.validator.showMessages();
	        _this.forceUpdate();
	      }
	    };
	
	    _this.handleReject = function (e) {
	      e.preventDefault();
	      var req = JSON.stringify({
	        id: _this.state.pageid
	      });
	      var toastr = '';
	      (0, _FetchCall.sclReject)(req).then(function (res) {
	        if (res.status === 1) {
	          toastr = window.toastr.success;
	          toastr('success', {
	            positionClass: "toast-bottom-right",
	            containerId: "toast-bottom-right"
	          });
	          window.location.href = document.referrer;
	        }
	      });
	    };
	
	    _this.state = {
	      errors: [],
	      ownerName: '',
	      pageid: '',
	      registration_no: '',
	      user_type: 0,
	      schoolName: '',
	      email_id: '',
	      phone_number: '',
	      organisation_name: '',
	      landline_number: '',
	      website: '',
	      state: '',
	      location: 'Bengaluru',
	      pincode: '',
	      address: '',
	      about_school: '',
	      google_location: '',
	      classification: '',
	      board_of_education: '',
	      grade: '',
	      grade_to: '',
	      schoolType: '',
	      school_timimg: '',
	      mode_of_payment: '',
	      min_age: '',
	      instruction_lang: '',
	      establishment_Year: '',
	      facilities: [],
	      sub_types: [],
	      avg_anual_fee: '',
	      other_fee: '',
	      addmission_fee: '',
	      admission_link: '',
	      processing_fee: '',
	      required_document: [],
	      admission_process: '',
	      images: '',
	      photos: '',
	      timingList: timings,
	      from_time_id: '',
	      categorySubTypeList: curriculam,
	      boeList: boe,
	      ClassList: classfrequencies,
	      documentList: documents,
	      classificationList: classifications,
	      facilitiesList: amenetis,
	      schooltypeList: schooltypes,
	      mopList: mops,
	      gradeList: grades,
	      latitude: '',
	      longitude: '',
	      other_rating: '',
	      stdRatio: '',
	      attachment_file: [],
	      attachment_file_length: 0,
	      attachment_fileName: [],
	      from_time: '',
	      from_time_cate: 'AM',
	      to_time: '',
	      to_time_cate: 'AM',
	      edit_photos: '',
	      delete_array: [],
	      location_list: locations,
	      edit_image: '',
	      categorySubTypesList: type,
	      tempBanner: '',
	      has_scholarship: 0,
	      scholarship_desc: '',
	      preSclList: [],
	      has_prescl: 2,
	      prescl_link: 0,
	      preview: false,
	      edited_data: [],
	      keywordsArr: [],
	      edited: false,
	      admission_open: '',
	      admission_closed: '',
	      seats_in: '',
	      current_vacancies: '',
	      duplicateverified: false
	    };
	
	    _this.getKeywords();_this.getPresclList();
	    _this.id = _this.props.match.params.id;
	    if (_this.id !== undefined) {
	      console.log('here came the id', _this.id);
	      _this.getSchoolInfo = _this.getSchoolInfo.bind(_this);
	      _this.getSchoolInfo();
	    }
	    _this.validator = new _simpleReactValidator2.default({
	      validators: {
	        checkExist: { // name the rule
	          message: 'The :attribute field is required.',
	          rule: function rule(val, params, validator) {
	            if (val === '' && _this.state.edit_image === '') {
	              return false;
	            }
	          },
	          messageReplace: function messageReplace(message, params) {
	            return message.replace(':values', _this.helpers.toSentence(params));
	          }, // optional
	          required: true // optional
	        },
	        emailExist_check: { // name the rule
	          message: 'The :attribute Already Exist.',
	          rule: function rule(val, params, validator) {
	            return _this.state.isEmailValid;
	          },
	          messageReplace: function messageReplace(message, params) {
	            return message.replace(':values', _this.helpers.toSentence(params));
	          }, // optional
	          required: true // optional
	        },
	        checkMobile: _constant.MOBILE_REGEX,
	        checkUrl: _constant.URL_REGEX
	      }
	    });
	
	    _this.loadFile = _this.loadFile.bind(_this);
	    return _this;
	  }
	
	  _createClass(verticalSchool, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      //this.LocationDataList();
	      var user_data = localStorage.getItem("user_data");
	      var auth_data = JSON.parse(user_data);
	      var vendor_id = auth_data.login_id;
	      this.setState({
	        login_id: vendor_id,
	        role: auth_data.role
	      });
	
	      //this.gettiming(); 
	      //this.getboe(); 
	      //this.getclass_frequency(); 
	      //this.getdocuments();
	      //this.geteducation_system(); 
	      //this.getfacilities(); 
	      //this.getpayment_type(); 
	      //this.getschool_type();
	      //this.grade(); 
	      //this.Sub_Cat_type(); 
	      //this.Sub_Cat_types();
	    }
	  }, {
	    key: 'remove_img',
	    value: function remove_img() {
	      (0, _jquery2.default)('#edit_image').remove();
	    }
	  }, {
	    key: 'loadFile',
	    value: function loadFile(e) {
	      var files = e.target.files;
	      this.setState({ attachment_file_length: files.length });
	      if (files.length > 0) {
	        (0, _jquery2.default)('.upload-space').addClass('hide');
	        (0, _jquery2.default)('.upload-thumb').removeClass('hide');
	        var fileArra = this.state.attachment_file;
	
	        //console.log('fileArra',fileArra)
	        //var fileThumbArra = this.state.imgThumb;
	        for (var i = 0; i < files.length; i++) {
	          fileArra.push(e.target.files[i]);
	          this.setState({
	            selectedFile: URL.createObjectURL(e.target.files[i]),
	            attachment_file: fileArra
	          });
	        }
	        this.clearValidationErr('attachment_file');
	      }
	    }
	  }, {
	    key: 'getSchoolInfo',
	    value: function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	        var response, data, edited_data;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _context2.next = 2;
	                return (0, _FetchCall.sclEdit)(JSON.stringify({ id: this.id }));
	
	              case 2:
	                response = _context2.sent;
	
	                console.log(response);
	                if (response.status === 1) {
	                  data = response.data, edited_data = response.original;
	
	                  console.log('here the reci data ', data);
	                  this.setState({
	                    ownerName: data.owner_name,
	                    registration_no: data.registration_no,
	                    pageid: data.id,
	                    schoolName: data.organisation_name,
	                    email_id: data.email_id,
	                    phone_number: data.phone_number,
	                    landline_number: data.landline_no,
	                    website: data.website,
	                    state: data.state,
	                    location: data.location,
	                    pincode: data.pincode,
	                    address: data.address,
	                    country: data.country,
	                    isrefund: data.is_refund,
	                    about_school: data.about,
	                    google_location: data.google_location,
	                    schoolType: data.school_type,
	                    classification: data.classification,
	                    board_of_education: data.sub_categories.split(','),
	                    grade: data.grade,
	                    grade_to: data.grade_to,
	                    min_age: data.min_age,
	                    instruction_lang: data.inst_lang,
	                    establishment_Year: data.est_year,
	                    facilities: data.facilites.split(','),
	                    avg_anual_fee: data.avg_fee,
	                    other_fee: data.other_fee,
	                    addmission_fee: data.admit_fee,
	                    admission_link: data.admit_link,
	                    processing_fee: data.process_fee,
	                    required_document: data.documents.split(','),
	                    stdRatio: data.teacher_student_ratio,
	                    admission_process: data.admit_process,
	                    attachment_file: data.photo_arr,
	                    photos: data.photos,
	                    edit_image: data.images ? data.url + data.images : '',
	                    images: data.images,
	                    keywords: data.keywords ? data.keywords.split(';') : [],
	                    from_time: data.from_time,
	                    to_time: data.to_time,
	                    from_time_cate: data.from_time_cate,
	                    to_time_cate: data.to_time_cate,
	                    sub_types: data.sub_types.split(','),
	                    sub_type: data.sub_type.split(','),
	                    // categorySubTypeList: data.subtype_arr,
	                    latitude: data.latitude,
	                    longitude: data.longitude,
	                    other_rating: data.other_rating,
	                    has_scholarship: data.has_scholarship,
	                    scholarship_desc: data.scholarship_desc,
	                    has_prescl: data.prescl_id === 0 ? 2 : 1,
	                    prescl_link: data.prescl_id,
	                    edited: data.edited,
	                    edited_data: edited_data,
	
	                    admission_open: data.admission_open,
	                    admission_closed: data.admission_closed,
	                    seats_in: data.seats_in,
	                    current_vacancies: data.current_vacancies
	
	                  });
	                  this.Geocode_location(data.google_location);
	                } else {
	                  this.props.history.push('/schoolsList');
	                }
	
	              case 5:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this);
	      }));
	
	      function getSchoolInfo() {
	        return _ref2.apply(this, arguments);
	      }
	
	      return getSchoolInfo;
	    }()
	  }, {
	    key: 'grade',
	    value: function () {
	      var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	        var response;
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                _context3.next = 2;
	                return _FetchCall2.default.getSchoolListDatas('grade');
	
	              case 2:
	                response = _context3.sent;
	
	                console.log(response);
	                if (response) {
	                  this.setState({ gradeList: response.results });
	                }
	
	              case 5:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, this);
	      }));
	
	      function grade() {
	        return _ref3.apply(this, arguments);
	      }
	
	      return grade;
	    }()
	  }, {
	    key: 'gettiming',
	    value: function () {
	      var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4() {
	        var response;
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                _context4.next = 2;
	                return _FetchCall2.default.getSchoolListDatas('timing');
	
	              case 2:
	                response = _context4.sent;
	
	                console.log(response);
	                if (response) {
	                  this.setState({ timingList: response.results });
	                }
	
	              case 5:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, this);
	      }));
	
	      function gettiming() {
	        return _ref4.apply(this, arguments);
	      }
	
	      return gettiming;
	    }()
	  }, {
	    key: 'getboe',
	    value: function () {
	      var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5() {
	        var response;
	        return _regenerator2.default.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                _context5.next = 2;
	                return _FetchCall2.default.getSubCategory('1');
	
	              case 2:
	                response = _context5.sent;
	
	                console.log('boeList', response);
	                if (response) {
	                  this.setState({ boeList: response.results });
	                }
	
	              case 5:
	              case 'end':
	                return _context5.stop();
	            }
	          }
	        }, _callee5, this);
	      }));
	
	      function getboe() {
	        return _ref5.apply(this, arguments);
	      }
	
	      return getboe;
	    }()
	  }, {
	    key: 'getclass_frequency',
	    value: function () {
	      var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee6() {
	        var response;
	        return _regenerator2.default.wrap(function _callee6$(_context6) {
	          while (1) {
	            switch (_context6.prev = _context6.next) {
	              case 0:
	                _context6.next = 2;
	                return _FetchCall2.default.getSchoolListDatas('class_frequency');
	
	              case 2:
	                response = _context6.sent;
	
	                console.log(response);
	                if (response) {
	                  this.setState({ ClassList: response.results });
	                }
	
	              case 5:
	              case 'end':
	                return _context6.stop();
	            }
	          }
	        }, _callee6, this);
	      }));
	
	      function getclass_frequency() {
	        return _ref6.apply(this, arguments);
	      }
	
	      return getclass_frequency;
	    }()
	  }, {
	    key: 'getdocuments',
	    value: function () {
	      var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee7() {
	        var response;
	        return _regenerator2.default.wrap(function _callee7$(_context7) {
	          while (1) {
	            switch (_context7.prev = _context7.next) {
	              case 0:
	                _context7.next = 2;
	                return _FetchCall2.default.getSchoolListDatas('documents');
	
	              case 2:
	                response = _context7.sent;
	
	                console.log(response);
	                if (response) {
	                  this.setState({ documentList: response.results });
	                }
	
	              case 5:
	              case 'end':
	                return _context7.stop();
	            }
	          }
	        }, _callee7, this);
	      }));
	
	      function getdocuments() {
	        return _ref7.apply(this, arguments);
	      }
	
	      return getdocuments;
	    }()
	  }, {
	    key: 'geteducation_system',
	    value: function () {
	      var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee8() {
	        var response;
	        return _regenerator2.default.wrap(function _callee8$(_context8) {
	          while (1) {
	            switch (_context8.prev = _context8.next) {
	              case 0:
	                _context8.next = 2;
	                return _FetchCall2.default.getSchoolListDatas('education_system');
	
	              case 2:
	                response = _context8.sent;
	
	                console.log(response);
	                if (response) {
	                  this.setState({ classificationList: response.results });
	                }
	
	              case 5:
	              case 'end':
	                return _context8.stop();
	            }
	          }
	        }, _callee8, this);
	      }));
	
	      function geteducation_system() {
	        return _ref8.apply(this, arguments);
	      }
	
	      return geteducation_system;
	    }()
	  }, {
	    key: 'getfacilities',
	    value: function () {
	      var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee9() {
	        var response;
	        return _regenerator2.default.wrap(function _callee9$(_context9) {
	          while (1) {
	            switch (_context9.prev = _context9.next) {
	              case 0:
	                _context9.next = 2;
	                return _FetchCall2.default.getSchoolListDatas('facilities');
	
	              case 2:
	                response = _context9.sent;
	
	                console.log(response);
	                if (response) {
	                  this.setState({ facilitiesList: response.results });
	                }
	
	              case 5:
	              case 'end':
	                return _context9.stop();
	            }
	          }
	        }, _callee9, this);
	      }));
	
	      function getfacilities() {
	        return _ref9.apply(this, arguments);
	      }
	
	      return getfacilities;
	    }()
	  }, {
	    key: 'getschool_type',
	    value: function () {
	      var _ref10 = _asyncToGenerator(_regenerator2.default.mark(function _callee10() {
	        var response;
	        return _regenerator2.default.wrap(function _callee10$(_context10) {
	          while (1) {
	            switch (_context10.prev = _context10.next) {
	              case 0:
	                _context10.next = 2;
	                return _FetchCall2.default.getSchoolListDatas('school_type');
	
	              case 2:
	                response = _context10.sent;
	
	                console.log(response);
	                if (response) {
	                  this.setState({ schooltypeList: response.results });
	                }
	
	              case 5:
	              case 'end':
	                return _context10.stop();
	            }
	          }
	        }, _callee10, this);
	      }));
	
	      function getschool_type() {
	        return _ref10.apply(this, arguments);
	      }
	
	      return getschool_type;
	    }()
	  }, {
	    key: 'getpayment_type',
	    value: function () {
	      var _ref11 = _asyncToGenerator(_regenerator2.default.mark(function _callee11() {
	        var response;
	        return _regenerator2.default.wrap(function _callee11$(_context11) {
	          while (1) {
	            switch (_context11.prev = _context11.next) {
	              case 0:
	                _context11.next = 2;
	                return _FetchCall2.default.getSchoolListDatas('payment_type');
	
	              case 2:
	                response = _context11.sent;
	
	                console.log(response);
	                if (response) {
	                  this.setState({ mopList: response.results });
	                }
	
	              case 5:
	              case 'end':
	                return _context11.stop();
	            }
	          }
	        }, _callee11, this);
	      }));
	
	      function getpayment_type() {
	        return _ref11.apply(this, arguments);
	      }
	
	      return getpayment_type;
	    }()
	  }, {
	    key: 'Sub_Cat_type',
	    value: function () {
	      var _ref12 = _asyncToGenerator(_regenerator2.default.mark(function _callee12() {
	        var response;
	        return _regenerator2.default.wrap(function _callee12$(_context12) {
	          while (1) {
	            switch (_context12.prev = _context12.next) {
	              case 0:
	                _context12.next = 2;
	                return _FetchCall2.default.getSchoolListDatas('curriculum');
	
	              case 2:
	                response = _context12.sent;
	
	                if (response.status === 1) {
	                  this.setState({ categorySubTypeList: response.results, cat_type: true, cat_type1: false, cat_type2: false });
	                } else {
	                  this.setState({ cat_type: false });
	                }
	
	              case 4:
	              case 'end':
	                return _context12.stop();
	            }
	          }
	        }, _callee12, this);
	      }));
	
	      function Sub_Cat_type() {
	        return _ref12.apply(this, arguments);
	      }
	
	      return Sub_Cat_type;
	    }()
	  }, {
	    key: 'Sub_Cat_types',
	    value: function () {
	      var _ref13 = _asyncToGenerator(_regenerator2.default.mark(function _callee13() {
	        var response;
	        return _regenerator2.default.wrap(function _callee13$(_context13) {
	          while (1) {
	            switch (_context13.prev = _context13.next) {
	              case 0:
	                _context13.next = 2;
	                return _FetchCall2.default.getSchoolListDatas('type');
	
	              case 2:
	                response = _context13.sent;
	
	                if (response.status === 1) {
	                  this.setState({ categorySubTypesList: response.results, cat_type: true, cat_type1: false, cat_type2: false });
	                } else {
	                  this.setState({ cat_type: false });
	                }
	
	              case 4:
	              case 'end':
	                return _context13.stop();
	            }
	          }
	        }, _callee13, this);
	      }));
	
	      function Sub_Cat_types() {
	        return _ref13.apply(this, arguments);
	      }
	
	      return Sub_Cat_types;
	    }()
	  }, {
	    key: 'UNSAFE_componentWillMount',
	    value: function UNSAFE_componentWillMount() {}
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      window.jQuery('.selectpicker').selectpicker('refresh');
	    }
	  }, {
	    key: 'validateNameAndUrl',
	    value: function validateNameAndUrl() {
	      var _this3 = this;
	
	      var ins = JSON.stringify({
	        name: this.state.schoolName,
	        id: this.id,
	        vertical: 'schools'
	      });
	
	      (0, _FetchCall.checkDuplicateUrl)(ins).then(function (res) {
	
	        if (res.status === 1) {
	
	          _this3.setState({ duplicateverified: true });
	        } else {
	
	          _this3.setState({ duplicateverified: false });
	        }
	
	        (0, _jquery2.default)(".resultant").html(res.resultant);
	      });
	    }
	  }, {
	    key: 'islengthvalidate',
	    value: function islengthvalidate(value, ctrl) {
	      if (ctrl === 1) {
	        console.log("length", value.length);
	        if (value.length !== 10) {
	          this.showValidationErr("phone_number", "Phone Number should be 10 digits");
	          return false;
	        } else {
	          this.clearValidationErr("phone_number");
	          return true;
	        }
	      } else {
	        if (value.length <= 11) {
	          this.showValidationErr("landline_no", "Landline number should be 12 digits");
	          return false;
	        } else {
	          this.clearValidationErr("landline_no");
	          return true;
	        }
	      }
	    }
	  }, {
	    key: 'showValidationErr',
	    value: function showValidationErr(elm, msg) {
	      console.log(elm, msg);
	      this.setState(function (prevState) {
	        return { errors: [].concat(_toConsumableArray(prevState.errors), [{ elm: elm, msg: msg }]) };
	      });
	    }
	  }, {
	    key: 'clearValidationErr',
	    value: function clearValidationErr(elm) {
	      var _this4 = this;
	
	      this.setState(function (prevState) {
	        var newArr = [];
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = _this4.state.errors[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var err = _step.value;
	
	            if (elm !== err.elm) {
	              newArr.push(err);
	            }
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	
	        return { errors: newArr };
	      });
	    }
	  }, {
	    key: 'Geocode_location',
	    value: function Geocode_location() {
	      var _this5 = this;
	
	      var location = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	      _reactGeocode2.default.fromAddress(location ? location : this.state.google_location).then(function (response) {
	        var _response$results$0$g = response.results[0].geometry.location,
	            lat = _response$results$0$g.lat,
	            lng = _response$results$0$g.lng;
	
	        if (lat && lng) _this5.get_location(lat, lng);
	      }, function (error) {
	        console.error(error);
	      });
	    }
	
	    /*
	    checkUrlDuplicate= (e) => {
	        
	       if(this.state.schoolName==''){
	         $(".verifiedurl").removeClass('greentext').addClass('redtext').html('Please enter organisation name');
	        }else{
	          let ins = JSON.stringify({
	          name: this.state.schoolName,
	          id:this.id,
	          vertical:'schools'
	        });
	         checkifduplicateExist(ins).then((res) => {
	             if(res.status==1){
	                this.setState({duplicate: true });
	               $(".verifiedurl").removeClass('greentext').addClass('redtext').html('URL not available');
	             }else{
	               this.setState({duplicate: false });
	              $(".verifiedurl").removeClass('redtext').addClass('greentext').html('URL available');
	            }
	         });
	     
	       }
	     }
	    */
	
	  }, {
	    key: 'get_location',
	    value: function get_location(lat, lng) {
	      this.setState({
	        latitude: lat,
	        longitude: lng
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this6 = this;
	
	      this.validator.purgeFields();
	      var _state = this.state,
	          edited = _state.edited,
	          edited_data = _state.edited_data;
	
	      console.log('edit_image', this.state.edit_image);
	
	      console.log('tempBanner', this.state.tempBanner);
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'col-lg-12 grid-margin stretch-card' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card-body' },
	                _react2.default.createElement(
	                  'h4',
	                  { 'class': 'card-title' },
	                  'School - Add'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'row' },
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'col-lg-12' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'main-content col-md-12 col-xs-12' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'content-sec col-md-12 col-xs-12 pad-no mar-t-no' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'tab-content' },
	                          _react2.default.createElement(
	                            'div',
	                            { id: 'company-info', className: 'tabactive' },
	                            _react2.default.createElement(
	                              'form',
	                              {
	                                encType: 'multipart/form-data',
	                                method: 'post',
	                                onSubmit: this.handlePreview,
	                                autoComplete: 'off',
	                                className: 'custom-form invoice-form col-md-12 col-xs-12 legend-form pad-no'
	                              },
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'box-shadow-custom' },
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'row' },
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'form-group col-md-8' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      { className: edited && edited_data.organisation_name !== this.state.schoolName && 'edited-field' },
	                                      'Organization Name ',
	                                      _react2.default.createElement(
	                                        'span',
	                                        { className: 'astrick' },
	                                        '*'
	                                      )
	                                    ),
	                                    _react2.default.createElement('input', {
	
	                                      type: 'text',
	                                      name: 'schoolName',
	                                      value: this.state.schoolName,
	                                      onChange: this.handleChange,
	                                      onKeyUp: this.handleChangeName,
	                                      className: 'form-control'
	                                    }),
	                                    _react2.default.createElement('div', null),
	                                    this.state.user_type >= 1 && this.validator.message('Organization Name', this.state.schoolName, 'required', { className: 'text-danger' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'col-md-8' },
	                                    _react2.default.createElement('div', { 'class': 'resultant' })
	                                  )
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'box-shadow-custom' },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'row' },
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'form-group col-md-4' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      { className: edited && edited_data.registration_no !== this.state.registration_no && 'edited-field' },
	                                      'Registration No ',
	                                      this.state.user_type === 1 && _react2.default.createElement(
	                                        'span',
	                                        { className: 'astrick' },
	                                        '*'
	                                      )
	                                    ),
	                                    _react2.default.createElement('input', {
	                                      type: 'text',
	                                      className: 'form-control',
	                                      name: 'registration_no',
	                                      value: this.state.registration_no,
	                                      onChange: this.handleChange
	                                    }),
	                                    this.state.user_type === 1 ? this.validator.message('Registration No', this.state.registration_no, 'required', { className: 'text-danger' }) : this.validator.message('Registration No', this.state.registration_no, '', { className: 'text-danger' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'form-group col-md-4' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      { className: edited && edited_data.owner_name !== this.state.ownerName && 'edited-field' },
	                                      'Owner Name ',
	                                      this.state.user_type === 1 && _react2.default.createElement(
	                                        'span',
	                                        { className: 'astrick' },
	                                        '*'
	                                      )
	                                    ),
	                                    _react2.default.createElement('input', {
	
	                                      type: 'text',
	                                      className: 'form-control',
	                                      name: 'ownerName',
	                                      value: this.state.ownerName,
	                                      onChange: this.handleChange
	                                    }),
	                                    this.state.user_type === 1 ? this.validator.message('Owner Name', this.state.ownerName, 'required', { className: 'text-danger' }) : this.validator.message('Owner Name', this.state.ownerName, '', { className: 'text-danger' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'form-group col-md-4' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      { className: edited && edited_data.sub_categories !== this.state.board_of_education && 'edited-field' },
	                                      'Type of School',
	                                      _react2.default.createElement(
	                                        'span',
	                                        { className: 'astrick' },
	                                        '*'
	                                      )
	                                    ),
	                                    _react2.default.createElement(
	                                      'div',
	                                      { className: 'custom-select-drop dropdown' },
	                                      _react2.default.createElement(
	                                        'select',
	                                        {
	                                          name: 'board_of_education',
	                                          id: 'board_of_education',
	                                          onChange: this.handleSelect,
	                                          value: this.state.board_of_education,
	                                          className: 'form-control selectpicker',
	                                          multiple: true
	                                        },
	                                        this.state.boeList.length > 0 && this.state.boeList.map(function (item, i) {
	                                          return _react2.default.createElement(
	                                            'option',
	                                            { value: item.category_id },
	                                            item.category_name
	                                          );
	                                        })
	                                      ),
	                                      this.validator.message('Type of School', this.state.board_of_education, 'required', { className: 'text-danger' })
	                                    )
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'form-group col-md-4' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      {
	                                        className: edited && edited_data.sub_types !== this.state.sub_types && 'edited-field' },
	                                      'Board Of Education ',
	                                      _react2.default.createElement(
	                                        'span',
	                                        { className: 'astrick' },
	                                        '*'
	                                      )
	                                    ),
	                                    _react2.default.createElement(
	                                      'div',
	                                      { className: 'custom-select-drop dropdown' },
	                                      _react2.default.createElement(
	                                        'select',
	                                        {
	                                          multiple: true,
	                                          onChange: this.handleSelectCat1,
	                                          name: 'sub_types',
	                                          value: this.state.sub_types,
	                                          className: 'form-control selectpicker' },
	                                        this.state.categorySubTypeList.length > 0 && this.state.categorySubTypeList.map(function (item, i) {
	                                          return _react2.default.createElement(
	                                            'option',
	                                            { value: item.id },
	                                            item.name
	                                          );
	                                        })
	                                      ),
	                                      this.validator.message('Board Of Education', this.state.sub_types, 'required', { className: 'text-danger' })
	                                    )
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'form-group col-md-4' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      { className: edited && edited_data.sub_type !== this.state.sub_type && 'edited-field' },
	                                      'Campus Type',
	                                      _react2.default.createElement(
	                                        'span',
	                                        { className: 'astrick' },
	                                        '*'
	                                      )
	                                    ),
	                                    _react2.default.createElement(
	                                      'div',
	                                      { className: 'custom-select-drop dropdown' },
	                                      _react2.default.createElement(
	                                        'select',
	                                        {
	                                          multiple: true,
	                                          onChange: this.handleSelectCat1,
	                                          name: 'sub_type',
	                                          value: this.state.sub_type,
	                                          className: 'form-control selectpicker' },
	                                        this.state.categorySubTypesList.length > 0 && this.state.categorySubTypesList.map(function (item, i) {
	                                          return _react2.default.createElement(
	                                            'option',
	                                            { value: item.id },
	                                            item.name
	                                          );
	                                        })
	                                      ),
	                                      this.validator.message('Campus Type', this.state.sub_type, 'required', { className: 'text-danger' })
	                                    )
	                                  )
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'box-shadow-custom' },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'row' },
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-12 col-xs-12' },
	                                    _react2.default.createElement(
	                                      'span',
	                                      { className: 'form-legend' },
	                                      'Address Information'
	                                    )
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'form-group col-md-4' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      { className: edited && edited_data.email_id !== this.state.email_id && 'edited-field' },
	                                      'Email Id',
	                                      _react2.default.createElement(
	                                        'span',
	                                        { className: 'astrick' },
	                                        '*'
	                                      )
	                                    ),
	                                    _react2.default.createElement('input', {
	                                      type: 'text',
	                                      name: 'email_id',
	                                      value: this.state.email_id,
	                                      onChange: this.handleChange,
	                                      className: 'form-control'
	                                    }),
	                                    this.validator.message('Email Id', this.state.email_id, 'emailExist_check', { className: 'text-danger' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'form-group col-md-4' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      { className: edited && edited_data.phone_number !== this.state.phone_number && 'edited-field' },
	                                      'Phone Number',
	                                      _react2.default.createElement(
	                                        'span',
	                                        { className: 'astrick' },
	                                        '*'
	                                      )
	                                    ),
	                                    _react2.default.createElement('input', {
	                                      type: 'text',
	                                      name: 'phone_number',
	                                      value: this.state.phone_number,
	                                      onChange: this.handleChange,
	                                      className: 'form-control'
	                                    }),
	                                    this.validator.message('Phone Number', this.state.phone_number, '', { className: 'text-danger' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'form-group col-md-4' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      { className: edited && edited_data.landline_no !== this.state.landline_number && 'edited-field' },
	                                      'Landline Number',
	                                      _react2.default.createElement(
	                                        'span',
	                                        { className: 'astrick' },
	                                        '*'
	                                      )
	                                    ),
	                                    _react2.default.createElement('input', {
	                                      type: 'text',
	                                      name: 'landline_number',
	                                      value: this.state.landline_number,
	                                      onChange: this.handleChange,
	                                      className: 'form-control landline_number', maxlength: '12'
	                                    }),
	                                    this.validator.message('Landline Number', this.state.landline_number, '', { className: 'text-danger' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'form-group col-md-4' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      { className: edited && edited_data.website !== this.state.website && 'edited-field' },
	                                      'Website',
	                                      _react2.default.createElement(
	                                        'span',
	                                        { className: 'astrick' },
	                                        '*'
	                                      )
	                                    ),
	                                    _react2.default.createElement('input', {
	                                      type: 'text',
	                                      name: 'website',
	                                      value: this.state.website,
	                                      onChange: this.handleChange,
	                                      className: 'form-control'
	                                    }),
	                                    this.validator.message('Website', this.state.website, '', { className: 'text-danger' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'form-group col-md-4' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      { className: edited && edited_data.state !== this.state.state && 'edited-field' },
	                                      'State',
	                                      _react2.default.createElement(
	                                        'span',
	                                        { className: 'astrick' },
	                                        '*'
	                                      )
	                                    ),
	                                    _react2.default.createElement('input', {
	                                      type: 'text',
	                                      name: 'state',
	                                      value: this.state.state,
	                                      onChange: this.handleChange,
	                                      className: 'form-control'
	                                    }),
	                                    this.validator.message('State', this.state.state, 'required', { className: 'text-danger' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'form-group col-md-4' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      { className: edited && edited_data.location !== this.state.location && 'edited-field' },
	                                      'Location',
	                                      _react2.default.createElement(
	                                        'span',
	                                        { className: 'astrick' },
	                                        '*'
	                                      )
	                                    ),
	                                    _react2.default.createElement(
	                                      'select',
	                                      {
	                                        name: 'location',
	                                        id: 'location',
	                                        onChange: this.handleSelect,
	                                        value: this.state.location,
	                                        className: 'form-control selectpicker'
	                                      },
	                                      this.state.location_list.length > 0 && this.state.location_list.map(function (item, i) {
	                                        return _react2.default.createElement(
	                                          'option',
	                                          { value: item.location },
	                                          item.location
	                                        );
	                                      })
	                                    ),
	                                    this.validator.message('Location', this.state.location, 'required', { className: 'text-danger' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'form-group col-md-4' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      { className: edited && edited_data.pincode !== this.state.pincode && 'edited-field' },
	                                      'Pincode',
	                                      _react2.default.createElement(
	                                        'span',
	                                        { className: 'astrick' },
	                                        '*'
	                                      )
	                                    ),
	                                    _react2.default.createElement('input', {
	                                      type: 'text',
	                                      name: 'pincode',
	                                      value: this.state.pincode,
	                                      onChange: this.handleNumberChange,
	                                      className: 'form-control'
	                                    }),
	                                    this.validator.message('Pincode', this.state.pincode, 'required', { className: 'text-danger' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'form-group col-md-4' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      { className: edited && edited_data.address !== this.state.address && 'edited-field' },
	                                      'Address',
	                                      _react2.default.createElement(
	                                        'span',
	                                        { className: 'astrick' },
	                                        '*'
	                                      )
	                                    ),
	                                    _react2.default.createElement('input', {
	                                      type: 'text',
	                                      name: 'address',
	                                      value: this.state.address,
	                                      onChange: this.handleChange,
	                                      className: 'form-control'
	                                    }),
	                                    this.validator.message('Address', this.state.address, 'required', { className: 'text-danger' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'form-group col-md-4' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      { className: edited && edited_data.google_location !== this.state.google_location && 'edited-field' },
	                                      'Google Location Address',
	                                      _react2.default.createElement(
	                                        'span',
	                                        { className: 'astrick' },
	                                        '*'
	                                      )
	                                    ),
	                                    _react2.default.createElement('input', {
	                                      type: 'text',
	                                      name: 'google_location',
	                                      value: this.state.google_location,
	                                      onChange: this.handleChange,
	                                      onPaste: this.handlePaste,
	                                      className: 'form-control'
	                                    }),
	                                    this.validator.message('Google Location', this.state.google_location, 'required', { className: 'text-danger' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'form-group col-md-4' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      { className: edited && edited_data.latitude !== this.state.latitude && 'edited-field' },
	                                      'Latitude',
	                                      _react2.default.createElement(
	                                        'span',
	                                        { className: 'astrick' },
	                                        '*'
	                                      )
	                                    ),
	                                    _react2.default.createElement('input', {
	                                      type: 'text',
	                                      name: 'latitude',
	                                      value: this.state.latitude,
	                                      onChange: this.handleChange,
	
	                                      className: 'form-control'
	                                    }),
	                                    this.validator.message('Latitude', this.state.latitude, 'required', { className: 'text-danger' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'form-group col-md-4' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      { className: edited && edited_data.longitude !== this.state.longitude && 'edited-field' },
	                                      'Longitude',
	                                      _react2.default.createElement(
	                                        'span',
	                                        { className: 'astrick' },
	                                        '*'
	                                      )
	                                    ),
	                                    _react2.default.createElement('input', {
	                                      type: 'text',
	                                      name: 'longitude',
	                                      value: this.state.longitude,
	                                      onChange: this.handleChange,
	
	                                      className: 'form-control'
	                                    }),
	                                    this.validator.message('Longitude', this.state.longitude, 'required', { className: 'text-danger' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'form-group col-md-4' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      { className: edited && edited_data.other_rating !== this.state.other_rating && 'edited-field' },
	                                      'Google Rating',
	                                      _react2.default.createElement(
	                                        'span',
	                                        { className: 'astrick' },
	                                        '*'
	                                      )
	                                    ),
	                                    _react2.default.createElement('input', {
	                                      type: 'number',
	                                      step: '0.01',
	                                      name: 'other_rating',
	                                      value: this.state.other_rating,
	                                      onChange: this.handleChange,
	                                      max: '5',
	                                      className: 'form-control'
	                                    }),
	                                    this.validator.message('Google Rating', this.state.other_rating, 'required', { className: 'text-danger' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'form-group col-md-12' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      { className: edited && edited_data.about !== this.state.about_school && 'edited-field' },
	                                      'About the School',
	                                      _react2.default.createElement(
	                                        'span',
	                                        { className: 'astrick' },
	                                        '*'
	                                      )
	                                    ),
	                                    _react2.default.createElement('textarea', {
	                                      style: { 'height': '300px' },
	                                      type: 'text',
	                                      name: 'about_school',
	                                      value: this.state.about_school,
	                                      onChange: this.handleChange,
	                                      className: 'form-control'
	                                    }),
	                                    this.validator.message('About', this.state.about_school, 'required', { className: 'text-danger' })
	                                  )
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'box-shadow-custom' },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'row' },
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-12 col-xs-12' },
	                                    _react2.default.createElement(
	                                      'span',
	                                      { className: 'form-legend' },
	                                      'Key Information'
	                                    )
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'form-group col-md-4' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      { className: edited && edited_data.school_type !== this.state.schoolType && 'edited-field' },
	                                      'School type',
	                                      _react2.default.createElement(
	                                        'span',
	                                        { className: 'astrick' },
	                                        '*'
	                                      )
	                                    ),
	                                    _react2.default.createElement(
	                                      'div',
	                                      {
	                                        name: 'school_type',
	                                        id: 'schoolType',
	                                        className: 'custom-select-drop dropdown'
	                                      },
	                                      _react2.default.createElement(
	                                        'select',
	                                        {
	                                          name: 'schoolType', id: 'schoolType',
	                                          value: this.state.schoolType,
	                                          onChange: this.handleChange, defaultValue: 0,
	                                          className: 'form-control selectpicker',
	                                          title: 'Select'
	                                        },
	                                        this.state.schooltypeList.length > 0 && this.state.schooltypeList.map(function (item, i) {
	                                          return _react2.default.createElement(
	                                            'option',
	                                            { value: item.id },
	                                            item.type_name
	                                          );
	                                        })
	                                      ),
	                                      this.validator.message('School type', this.state.schoolType, 'required', { className: 'text-danger' })
	                                    )
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'form-group col-md-4' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      { className: edited && edited_data.classification !== this.state.classification && 'edited-field' },
	                                      'Classification',
	                                      _react2.default.createElement(
	                                        'span',
	                                        { className: 'astrick' },
	                                        '*'
	                                      )
	                                    ),
	                                    _react2.default.createElement(
	                                      'div',
	                                      { className: 'custom-select-drop dropdown' },
	                                      _react2.default.createElement(
	                                        'select',
	                                        {
	                                          name: 'classification',
	                                          id: 'classification',
	                                          value: this.state.classification,
	                                          onChange: this.handleSelect,
	                                          className: 'form-control selectpicker',
	                                          title: 'Select'
	                                        },
	                                        this.state.classificationList.length > 0 && this.state.classificationList.map(function (item, i) {
	                                          return _react2.default.createElement(
	                                            'option',
	                                            { value: item.id },
	                                            item.name
	                                          );
	                                        })
	                                      ),
	                                      this.validator.message('Classification', this.state.classification, 'required', { className: 'text-danger' })
	                                    )
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'form-group col-md-4 input-group-cus' },
	                                    _react2.default.createElement(
	                                      'div',
	                                      null,
	                                      _react2.default.createElement(
	                                        'label',
	                                        {
	                                          className: edited && (edited_data.grade !== this.state.grade || edited_data.grade_to !== this.state.grade_to) && 'edited-field' },
	                                        'Grades From/ To'
	                                      ),
	                                      _react2.default.createElement(
	                                        'div',
	                                        { className: 'custom-select-drop dropdown' },
	                                        _react2.default.createElement(
	                                          'select',
	                                          {
	                                            name: 'grade',
	                                            id: 'grade',
	                                            onChange: this.handleSelectGradeFrom,
	                                            value: this.state.grade,
	                                            className: 'form-control selectpicker',
	                                            title: 'Select'
	                                          },
	                                          this.state.gradeList.length > 0 && this.state.gradeList.map(function (item, i) {
	                                            return _react2.default.createElement(
	                                              'option',
	                                              { value: item.id },
	                                              ' ',
	                                              item.name
	                                            );
	                                          })
	                                        ),
	                                        this.validator.message('Grades', this.state.grade, 'required', { className: 'text-danger' })
	                                      )
	                                    ),
	                                    _react2.default.createElement(
	                                      'div',
	                                      null,
	                                      _react2.default.createElement(
	                                        'label',
	                                        null,
	                                        '\xA0'
	                                      ),
	                                      _react2.default.createElement(
	                                        'div',
	                                        { className: 'custom-select-drop dropdown' },
	                                        _react2.default.createElement(
	                                          'select',
	                                          {
	                                            name: 'grade_to',
	                                            id: 'gradeto',
	                                            value: this.state.grade_to,
	                                            onChange: this.handleSelectGradeto,
	                                            className: 'form-control selectpicker',
	                                            title: 'Select'
	                                          },
	                                          this.state.gradeList.length > 0 && this.state.gradeList.map(function (item, i) {
	                                            return _react2.default.createElement(
	                                              'option',
	                                              { value: item.id },
	                                              ' ',
	                                              item.name
	                                            );
	                                          })
	                                        ),
	                                        this.validator.message('Grades', this.state.grade_to, 'required', { className: 'text-danger' })
	                                      )
	                                    )
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'form-group col-md-4 input-group-cus' },
	                                    _react2.default.createElement(
	                                      'div',
	                                      null,
	                                      _react2.default.createElement(
	                                        'label',
	                                        {
	                                          className: edited && (edited_data.from_time !== this.state.from_time || edited_data.from_time_cate !== this.state.from_time_cate) && 'edited-field' },
	                                        'From Timing'
	                                      ),
	                                      _react2.default.createElement(
	                                        'div',
	                                        { className: 'custom-select-drop dropdown' },
	                                        _react2.default.createElement(
	                                          'select',
	                                          {
	                                            className: 'form-control selectpicker',
	                                            onChange: this.handleSelect,
	                                            value: this.state.from_time,
	                                            name: 'from_time',
	                                            title: 'Select'
	                                          },
	                                          this.state.timingList.length > 0 && this.state.timingList.map(function (item, i) {
	                                            return _react2.default.createElement(
	                                              'option',
	                                              { value: item.id },
	                                              item.timing
	                                            );
	                                          })
	                                        ),
	                                        this.validator.message('Timing', this.state.from_time, 'required', { className: 'text-danger' })
	                                      )
	                                    ),
	                                    _react2.default.createElement(
	                                      'div',
	                                      null,
	                                      _react2.default.createElement(
	                                        'label',
	                                        null,
	                                        '\xA0'
	                                      ),
	                                      _react2.default.createElement(
	                                        'div',
	                                        { className: 'custom-select-drop dropdown' },
	                                        _react2.default.createElement(
	                                          'select',
	                                          {
	                                            className: 'form-control selectpicker',
	                                            onChange: this.handleSelect,
	                                            value: this.state.from_time_cate,
	                                            name: 'from_time_cate'
	                                          },
	                                          _react2.default.createElement(
	                                            'option',
	                                            { value: 'AM' },
	                                            'AM'
	                                          ),
	                                          _react2.default.createElement(
	                                            'option',
	                                            { value: 'PM' },
	                                            'PM'
	                                          )
	                                        )
	                                      )
	                                    )
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'form-group col-md-4 input-group-cus' },
	                                    _react2.default.createElement(
	                                      'div',
	                                      null,
	                                      _react2.default.createElement(
	                                        'label',
	                                        {
	                                          className: edited && (edited_data.to_time !== this.state.to_time || edited_data.to_time_cate !== this.state.to_time_cate) && 'edited-field' },
	                                        'To Timing   '
	                                      ),
	                                      _react2.default.createElement(
	                                        'div',
	                                        { className: 'custom-select-drop dropdown' },
	                                        _react2.default.createElement(
	                                          'select',
	                                          {
	                                            className: 'form-control selectpicker',
	                                            onChange: this.handleSelect,
	                                            value: this.state.to_time,
	                                            name: 'to_time',
	                                            title: 'Select'
	                                          },
	                                          this.state.timingList.length > 0 && this.state.timingList.map(function (item, i) {
	                                            return _react2.default.createElement(
	                                              'option',
	                                              { value: item.id },
	                                              item.timing
	                                            );
	                                          })
	                                        ),
	                                        this.validator.message('Timing', this.state.to_time, 'required', { className: 'text-danger' })
	                                      )
	                                    ),
	                                    _react2.default.createElement(
	                                      'div',
	                                      null,
	                                      _react2.default.createElement(
	                                        'label',
	                                        null,
	                                        '\xA0'
	                                      ),
	                                      _react2.default.createElement(
	                                        'div',
	                                        { className: 'custom-select-drop dropdown' },
	                                        _react2.default.createElement(
	                                          'select',
	                                          {
	                                            className: 'form-control selectpicker',
	                                            onChange: this.handleSelect,
	                                            value: this.state.to_time_cate,
	                                            name: 'to_time_cate'
	                                          },
	                                          _react2.default.createElement(
	                                            'option',
	                                            { value: 'AM' },
	                                            'AM'
	                                          ),
	                                          _react2.default.createElement(
	                                            'option',
	                                            { value: 'PM' },
	                                            'PM'
	                                          )
	                                        )
	                                      )
	                                    )
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'form-group col-md-4' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      { className: edited && edited_data.min_age !== this.state.min_age && 'edited-field' },
	                                      'Min Age of Admission'
	                                    ),
	                                    _react2.default.createElement('input', {
	
	                                      type: 'text',
	                                      name: 'min_age',
	                                      value: this.state.min_age,
	                                      onChange: this.handleChange,
	                                      className: 'form-control'
	                                    }),
	                                    this.validator.message('Min Age of Admission', this.state.min_age, 'required', { className: 'text-danger' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'form-group col-md-4' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      {
	                                        className: edited && edited_data.inst_lang !== this.state.instruction_lang && 'edited-field' },
	                                      'Instruction Language'
	                                    ),
	                                    _react2.default.createElement('input', {
	                                      type: 'text',
	                                      name: 'instruction_lang',
	                                      value: this.state.instruction_lang,
	                                      onChange: this.handleChange,
	                                      className: 'form-control'
	                                    }),
	                                    this.validator.message('Instruction Language', this.state.instruction_lang, 'required', { className: 'text-danger' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'form-group col-md-4' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      {
	                                        className: edited && edited_data.teacher_student_ratio !== this.state.stdRatio && 'edited-field' },
	                                      'Teacher:Student Ratio'
	                                    ),
	                                    _react2.default.createElement('input', {
	                                      type: 'text',
	                                      name: 'stdRatio',
	                                      placeholder: 'ex:- 1:28',
	                                      value: this.state.stdRatio,
	                                      onChange: this.handleChange,
	                                      className: 'form-control'
	                                    }),
	                                    this.validator.message('Teacher:Student Ratio', this.state.stdRatio, 'required', { className: 'text-danger' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'form-group col-md-4' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      {
	                                        className: edited && edited_data.est_year !== this.state.establishment_Year && 'edited-field' },
	                                      'Establishment Year',
	                                      _react2.default.createElement(
	                                        'span',
	                                        { className: 'astrick' },
	                                        '*'
	                                      )
	                                    ),
	                                    _react2.default.createElement('input', {
	                                      type: 'text',
	                                      name: 'establishment_Year',
	                                      value: this.state.establishment_Year,
	                                      onChange: this.handleChange,
	                                      className: 'form-control'
	                                    }),
	                                    this.validator.message('Establishment Year', this.state.establishment_Year, '', { className: 'text-danger' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'form-group col-md-4' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      {
	                                        className: edited && edited_data.facilites !== this.state.facilities && 'edited-field' },
	                                      'Amenities'
	                                    ),
	                                    _react2.default.createElement(
	                                      'div',
	                                      { className: 'custom-select-drop dropdown' },
	                                      _react2.default.createElement(
	                                        'select',
	                                        {
	                                          multiple: true,
	                                          name: 'facilities',
	                                          id: 'facilities',
	                                          onChange: this.handleSelect,
	                                          value: this.state.facilities,
	                                          className: 'form-control selectpicker',
	                                          title: 'Select'
	                                        },
	                                        this.state.facilitiesList.length > 0 && this.state.facilitiesList.map(function (item, i) {
	                                          return _react2.default.createElement(
	                                            'option',
	                                            { value: item.id },
	                                            item.facility
	                                          );
	                                        })
	                                      ),
	                                      this.validator.message('Amenities', this.state.facilities, 'required', { className: 'text-danger' })
	                                    )
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'form-group col-md-4' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      {
	                                        className: edited && edited_data.has_scholarship !== this.state.has_scholarship && 'edited-field' },
	                                      ' Is Scholarship Avail ',
	                                      _react2.default.createElement(
	                                        'span',
	                                        { 'class': 'astrick' },
	                                        '*'
	                                      )
	                                    ),
	                                    _react2.default.createElement(
	                                      'select',
	                                      {
	                                        className: 'form-control selectpicker',
	                                        name: 'has_scholarship',
	                                        value: this.state.has_scholarship,
	                                        title: 'Select',
	                                        onChange: this.handleSelect },
	                                      _react2.default.createElement(
	                                        'option',
	                                        { value: '0' },
	                                        'NA'
	                                      ),
	                                      _react2.default.createElement(
	                                        'option',
	                                        { value: '1' },
	                                        'Yes'
	                                      ),
	                                      _react2.default.createElement(
	                                        'option',
	                                        { value: '2' },
	                                        'No'
	                                      )
	                                    ),
	                                    this.validator.message('Scholarship', this.state.has_scholarship, 'required', { className: 'text-danger error-msg' })
	                                  ),
	                                  this.state.has_scholarship === 1 && _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'form-group col-md-4' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      {
	                                        className: edited && edited_data.scholarship_desc !== this.state.scholarship_desc && 'edited-field' },
	                                      ' Scholarship Description ',
	                                      _react2.default.createElement(
	                                        'span',
	                                        { 'class': 'astrick' },
	                                        '*'
	                                      )
	                                    ),
	                                    _react2.default.createElement('textarea', { className: 'form-control', name: 'scholarship_desc', onChange: this.handleChange, value: this.state.scholarship_desc }),
	                                    this.validator.message('Scholarship Descrption', this.state.scholarship_desc, 'required', { className: 'text-danger error-msg' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'form-group col-md-4' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      {
	                                        className: edited && edited_data.prescl_id !== this.state.prescl_link && 'edited-field' },
	                                      ' Is School has Preschool',
	                                      _react2.default.createElement(
	                                        'span',
	                                        { 'class': 'astrick' },
	                                        '*'
	                                      )
	                                    ),
	                                    _react2.default.createElement(
	                                      'select',
	                                      {
	                                        className: 'form-control selectpicker',
	                                        name: 'has_prescl',
	                                        value: this.state.has_prescl,
	                                        title: 'Select',
	                                        onChange: this.handleSelect },
	                                      _react2.default.createElement(
	                                        'option',
	                                        { value: '1' },
	                                        'Yes'
	                                      ),
	                                      _react2.default.createElement(
	                                        'option',
	                                        { value: '2' },
	                                        'No'
	                                      )
	                                    ),
	                                    this.validator.message('Preschool', this.state.has_prescl, 'required', { className: 'text-danger error-msg' })
	                                  ),
	                                  this.state.has_prescl === 1 && _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'form-group col-md-4' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      {
	                                        className: edited && edited_data.prescl_id !== this.state.prescl_link && 'edited-field' },
	                                      ' Select Preschool',
	                                      _react2.default.createElement(
	                                        'span',
	                                        { 'class': 'astrick' },
	                                        '*'
	                                      )
	                                    ),
	                                    _react2.default.createElement(
	                                      'select',
	                                      {
	                                        className: 'form-control selectpicker',
	                                        name: 'prescl_link',
	                                        value: this.state.prescl_link,
	                                        title: 'Select', 'data-live-search': 'true',
	                                        onChange: this.handleSelect },
	                                      this.state.preSclList.map(function (item, i) {
	                                        return _react2.default.createElement(
	                                          'option',
	                                          { value: item.id },
	                                          item.name
	                                        );
	                                      })
	                                    ),
	                                    this.validator.message('Preschool', this.state.prescl_link, 'required', { className: 'text-danger error-msg' }),
	                                    _react2.default.createElement(
	                                      'span',
	                                      null,
	                                      'If no match found, Please go ',
	                                      _react2.default.createElement(
	                                        'a',
	                                        { href: '/vertical/preschool/add', target: '_blank' },
	                                        'here'
	                                      ),
	                                      ' and add preschool and click ',
	                                      _react2.default.createElement(
	                                        'span',
	                                        { onClick: this.refreshSelectPreSchools },
	                                        'here'
	                                      ),
	                                      ' to refresh the list'
	                                    )
	                                  )
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'box-shadow-custom' },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'row' },
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-12 col-xs-12' },
	                                    _react2.default.createElement(
	                                      'span',
	                                      { className: 'form-legend' },
	                                      'Admission Details'
	                                    )
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'form-group col-md-4' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      'Annual Admission Timeline From'
	                                    ),
	                                    _react2.default.createElement(
	                                      'div',
	                                      { className: 'custom-select-drop dropdown' },
	                                      _react2.default.createElement(
	                                        'select',
	                                        {
	                                          name: 'admission_open',
	                                          id: 'admission_open',
	                                          className: 'form-control'
	                                          // data-live-search="true"
	                                          , value: this.state.admission_open,
	                                          onChange: this.handleSelect,
	                                          title: 'Select'
	                                        },
	                                        _react2.default.createElement(
	                                          'option',
	                                          { value: '' },
	                                          'Select'
	                                        ),
	                                        _react2.default.createElement(
	                                          'option',
	                                          { value: 'January' },
	                                          'January'
	                                        ),
	                                        _react2.default.createElement(
	                                          'option',
	                                          { value: 'February' },
	                                          'February'
	                                        ),
	                                        _react2.default.createElement(
	                                          'option',
	                                          { value: 'March' },
	                                          'March'
	                                        ),
	                                        _react2.default.createElement(
	                                          'option',
	                                          { value: 'April' },
	                                          'April'
	                                        ),
	                                        _react2.default.createElement(
	                                          'option',
	                                          { value: 'May' },
	                                          'May'
	                                        ),
	                                        _react2.default.createElement(
	                                          'option',
	                                          { value: 'June' },
	                                          'June'
	                                        ),
	                                        _react2.default.createElement(
	                                          'option',
	                                          { value: 'July' },
	                                          'July'
	                                        ),
	                                        _react2.default.createElement(
	                                          'option',
	                                          { value: 'August' },
	                                          'August'
	                                        ),
	                                        _react2.default.createElement(
	                                          'option',
	                                          { value: 'September' },
	                                          'September'
	                                        ),
	                                        _react2.default.createElement(
	                                          'option',
	                                          { value: 'October' },
	                                          'October'
	                                        ),
	                                        _react2.default.createElement(
	                                          'option',
	                                          { value: 'November' },
	                                          'November'
	                                        ),
	                                        _react2.default.createElement(
	                                          'option',
	                                          { value: 'December' },
	                                          'December'
	                                        )
	                                      )
	                                    )
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'form-group col-md-4' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      'Annual Admission Timeline To'
	                                    ),
	                                    _react2.default.createElement(
	                                      'div',
	                                      { className: 'custom-select-drop dropdown' },
	                                      _react2.default.createElement(
	                                        'select',
	                                        {
	                                          name: 'admission_closed',
	                                          id: 'admission_closed',
	                                          className: 'form-control'
	                                          // data-live-search="true"
	                                          , value: this.state.admission_closed,
	                                          onChange: this.handleSelect,
	                                          title: 'Select'
	                                        },
	                                        _react2.default.createElement(
	                                          'option',
	                                          { value: '' },
	                                          'Select'
	                                        ),
	                                        _react2.default.createElement(
	                                          'option',
	                                          { value: 'January' },
	                                          'January'
	                                        ),
	                                        _react2.default.createElement(
	                                          'option',
	                                          { value: 'February' },
	                                          'February'
	                                        ),
	                                        _react2.default.createElement(
	                                          'option',
	                                          { value: 'March' },
	                                          'March'
	                                        ),
	                                        _react2.default.createElement(
	                                          'option',
	                                          { value: 'April' },
	                                          'April'
	                                        ),
	                                        _react2.default.createElement(
	                                          'option',
	                                          { value: 'May' },
	                                          'May'
	                                        ),
	                                        _react2.default.createElement(
	                                          'option',
	                                          { value: 'June' },
	                                          'June'
	                                        ),
	                                        _react2.default.createElement(
	                                          'option',
	                                          { value: 'July' },
	                                          'July'
	                                        ),
	                                        _react2.default.createElement(
	                                          'option',
	                                          { value: 'August' },
	                                          'August'
	                                        ),
	                                        _react2.default.createElement(
	                                          'option',
	                                          { value: 'September' },
	                                          'September'
	                                        ),
	                                        _react2.default.createElement(
	                                          'option',
	                                          { value: 'October' },
	                                          'October'
	                                        ),
	                                        _react2.default.createElement(
	                                          'option',
	                                          { value: 'November' },
	                                          'November'
	                                        ),
	                                        _react2.default.createElement(
	                                          'option',
	                                          { value: 'December' },
	                                          'December'
	                                        )
	                                      )
	                                    )
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'form-group col-md-4' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      {
	                                        className: edited && edited_data.admit_link !== this.state.admission_link && 'edited-field' },
	                                      'Admission Link ',
	                                      _react2.default.createElement(
	                                        'span',
	                                        { className: 'astrick' },
	                                        '*'
	                                      )
	                                    ),
	                                    _react2.default.createElement('input', {
	                                      type: 'text',
	                                      name: 'admission_link',
	                                      value: this.state.admission_link,
	                                      onChange: this.handleChange,
	                                      className: 'form-control'
	                                    }),
	                                    this.validator.message('Admission Link', this.state.admission_link, '', { className: 'text-danger' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'form-group col-md-4' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      {
	                                        className: edited && edited_data.avg_fee !== this.state.avg_anual_fee && 'edited-field' },
	                                      'Indicative Annual Fee(INR)',
	                                      _react2.default.createElement(
	                                        'span',
	                                        { className: 'astrick' },
	                                        '*'
	                                      )
	                                    ),
	                                    _react2.default.createElement('input', {
	                                      type: 'text',
	                                      name: 'avg_anual_fee',
	                                      value: this.state.avg_anual_fee,
	                                      onChange: this.handleChange,
	                                      className: 'form-control',
	                                      placeholder: 'Enter in K\'s'
	                                    }),
	                                    this.validator.message('Indicative Annual Fee', this.state.avg_anual_fee, 'required', { className: 'text-danger' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'form-group col-md-4' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      {
	                                        className: edited && edited_data.other_fee !== this.state.other_fee && 'edited-field' },
	                                      'Other Fees ',
	                                      _react2.default.createElement(
	                                        'span',
	                                        { className: 'astrick' },
	                                        '*'
	                                      )
	                                    ),
	                                    _react2.default.createElement('input', {
	                                      type: 'text',
	                                      name: 'other_fee',
	                                      value: this.state.other_fee,
	                                      onChange: this.handleChange,
	                                      className: 'form-control'
	                                    }),
	                                    this.validator.message('Other Fees', this.state.other_fee, 'required', { className: 'text-danger' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'form-group col-md-4' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      {
	                                        className: edited && edited_data.admit_fee !== this.state.addmission_fee && 'edited-field' },
	                                      'Admission Fees ',
	                                      _react2.default.createElement(
	                                        'span',
	                                        { className: 'astrick' },
	                                        '*'
	                                      )
	                                    ),
	                                    _react2.default.createElement('input', {
	                                      type: 'text',
	                                      name: 'addmission_fee',
	                                      value: this.state.addmission_fee,
	                                      onChange: this.handleChange,
	                                      className: 'form-control'
	                                    }),
	                                    this.validator.message('Admission Fees', this.state.addmission_fee, 'required', { className: 'text-danger' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'form-group col-md-4' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      {
	                                        className: edited && edited_data.is_refund !== this.state.isrefund && 'edited-field' },
	                                      'Is Refundable (Admission Fees)',
	                                      _react2.default.createElement(
	                                        'span',
	                                        { className: 'astrick' },
	                                        '*'
	                                      )
	                                    ),
	                                    _react2.default.createElement('br', null),
	                                    _react2.default.createElement('input', {
	                                      type: 'radio',
	                                      value: '1',
	                                      name: 'isrefund',
	                                      onClick: this.handleChange,
	                                      checked: this.state.isrefund === 1
	                                    }),
	                                    'Yes\xA0\xA0',
	                                    _react2.default.createElement('input', {
	                                      type: 'radio',
	                                      name: 'isrefund',
	                                      value: '0',
	                                      checked: this.state.isrefund === 0,
	                                      onClick: this.handleChange
	                                    }),
	                                    'No',
	                                    this.validator.message('Is Refundable', this.state.isrefund, 'required', { className: 'text-danger' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'form-group col-md-4' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      {
	                                        className: edited && edited_data.process_fee !== this.state.processing_fee && 'edited-field' },
	                                      'Application Fees ',
	                                      _react2.default.createElement(
	                                        'span',
	                                        { className: 'astrick' },
	                                        '*'
	                                      )
	                                    ),
	                                    _react2.default.createElement('input', {
	                                      type: 'text',
	                                      name: 'processing_fee',
	                                      value: this.state.processing_fee,
	                                      onChange: this.handleChange,
	                                      className: 'form-control'
	                                    }),
	                                    this.validator.message('Application Fees', this.state.processing_fee, 'required', { className: 'text-danger' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'form-group col-md-4' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      'Current Vacancies for admissions'
	                                    ),
	                                    _react2.default.createElement(
	                                      'div',
	                                      { className: 'custom-select-drop dropdown' },
	                                      _react2.default.createElement(
	                                        'select',
	                                        {
	                                          name: 'current_vacancies',
	                                          id: 'current_vacancies',
	                                          className: 'form-control'
	                                          // data-live-search="true"
	                                          , value: this.state.current_vacancies,
	                                          onChange: this.handleSelect,
	                                          title: 'Select'
	                                        },
	                                        _react2.default.createElement(
	                                          'option',
	                                          { value: '' },
	                                          'Select'
	                                        ),
	                                        _react2.default.createElement(
	                                          'option',
	                                          { value: 'available' },
	                                          'Available'
	                                        ),
	                                        _react2.default.createElement(
	                                          'option',
	                                          { value: 'closed' },
	                                          'Closed'
	                                        ),
	                                        _react2.default.createElement(
	                                          'option',
	                                          { value: 'infonotavailable' },
	                                          'Info not available'
	                                        )
	                                      )
	                                    )
	                                  ),
	                                  this.state.current_vacancies === 'available' && _react2.default.createElement(
	                                    'div',
	                                    { className: 'form-group col-md-4' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      'Seats available in grades'
	                                    ),
	                                    _react2.default.createElement(
	                                      'div',
	                                      { className: 'custom-select-drop dropdown' },
	                                      _react2.default.createElement(
	                                        'select',
	                                        {
	                                          multiple: true,
	                                          name: 'seats_in',
	                                          id: 'seats_in',
	                                          className: 'form-control'
	                                          // data-live-search="true"
	                                          , value: this.state.seats_in,
	                                          onChange: this.handleSelect,
	                                          title: 'Select'
	                                        },
	                                        _react2.default.createElement(
	                                          'option',
	                                          { value: 'KG' },
	                                          'KG'
	                                        ),
	                                        _react2.default.createElement(
	                                          'option',
	                                          { value: '1st' },
	                                          '1st'
	                                        ),
	                                        _react2.default.createElement(
	                                          'option',
	                                          { value: '2nd' },
	                                          '2nd'
	                                        ),
	                                        _react2.default.createElement(
	                                          'option',
	                                          { value: '3rd' },
	                                          '3rd'
	                                        ),
	                                        _react2.default.createElement(
	                                          'option',
	                                          { value: '4th' },
	                                          '4th'
	                                        ),
	                                        _react2.default.createElement(
	                                          'option',
	                                          { value: '5th' },
	                                          '5th'
	                                        ),
	                                        _react2.default.createElement(
	                                          'option',
	                                          { value: '6th' },
	                                          '6th'
	                                        ),
	                                        _react2.default.createElement(
	                                          'option',
	                                          { value: '7th' },
	                                          '7th'
	                                        ),
	                                        _react2.default.createElement(
	                                          'option',
	                                          { value: '8th' },
	                                          '8th'
	                                        ),
	                                        _react2.default.createElement(
	                                          'option',
	                                          { value: '9th' },
	                                          '9th'
	                                        ),
	                                        _react2.default.createElement(
	                                          'option',
	                                          { value: '10th' },
	                                          '10th'
	                                        ),
	                                        _react2.default.createElement(
	                                          'option',
	                                          { value: '11th' },
	                                          '11th'
	                                        ),
	                                        _react2.default.createElement(
	                                          'option',
	                                          { value: '12th' },
	                                          '12th'
	                                        )
	                                      )
	                                    )
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'form-group col-md-4' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      {
	                                        className: edited && edited_data.documents !== this.state.required_document && 'edited-field' },
	                                      'Required Documents'
	                                    ),
	                                    _react2.default.createElement(
	                                      'div',
	                                      { className: 'custom-select-drop dropdown' },
	                                      _react2.default.createElement(
	                                        'select',
	                                        {
	                                          multiple: true,
	                                          name: 'required_document',
	                                          id: 'required_document',
	                                          className: 'form-control selectpicker'
	                                          // data-live-search="true"
	                                          , value: this.state.required_document,
	                                          onChange: this.handleSelect,
	                                          title: 'Select'
	                                        },
	                                        this.state.documentList.length > 0 && this.state.documentList.map(function (item, i) {
	                                          return _react2.default.createElement(
	                                            'option',
	                                            { value: item.id },
	                                            item.document_name
	                                          );
	                                        })
	                                      ),
	                                      this.validator.message('Documents', this.state.required_document, 'required', { className: 'text-danger' })
	                                    )
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'form-group col-md-4' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      {
	                                        className: edited && edited_data.admit_process !== this.state.admission_process && 'edited-field' },
	                                      'Admission Process'
	                                    ),
	                                    _react2.default.createElement('textarea', {
	                                      name: 'admission_process',
	                                      value: this.state.admission_process,
	                                      onChange: this.handleChange,
	                                      className: 'form-control'
	                                    }),
	                                    this.validator.message('Admission Process', this.state.admission_process, 'required', { className: 'text-danger' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'form-group col-md-4' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      {
	                                        className: edited && edited_data.keywords !== this.state.keywords && 'edited-field' },
	                                      'Keywords',
	                                      edited && edited_data.keywords !== this.state.keywords && _react2.default.createElement(
	                                        'span',
	                                        { className: 'astrick edited' },
	                                        '*'
	                                      )
	                                    ),
	                                    _react2.default.createElement(_multiselectReactDropdown.Multiselect, {
	                                      isObject: false,
	                                      options: this.state.keywordsArr // Options to display in the dropdown
	                                      , selectedValues: this.state.keywords // Preselected value to persist in dropdown
	                                      , onSelect: this.onSelect // Function will trigger on select event
	                                      , onRemove: this.onRemove // Function will trigger on remove event
	                                    })
	                                  )
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'box-shadow-custom' },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'row' },
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-12 col-xs-12' },
	                                    _react2.default.createElement(
	                                      'span',
	                                      { className: 'form-legend' },
	                                      'Images'
	                                    )
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'form-group col-md-4' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      { className: edited && edited_data.images !== this.state.images && 'edited-field' },
	                                      'Banner Images ',
	                                      _react2.default.createElement(
	                                        'span',
	                                        { className: 'astrick' },
	                                        '*'
	                                      )
	                                    ),
	                                    _react2.default.createElement('input', {
	                                      type: 'file',
	                                      name: 'images',
	                                      onChange: this.handleFile,
	                                      className: 'form-control'
	                                    }),
	                                    this.validator.message('Banner Image', this.state.images, '', { className: 'text-danger error-msg' })
	                                  ),
	                                  (this.state.edit_image !== '' || this.state.tempBanner !== '') && _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'col-md-2 col-sm-12 mar-btm', id: 'edit_image' },
	                                    _react2.default.createElement('img', { src: this.state.tempBanner ? this.state.tempBanner : this.state.edit_image, alt: 'Banner', 'class': 'img-thumbnail' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'col-md-12 float-left mt-4 p-0' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      {
	                                        className: edited && edited_data.photos !== this.state.photos && 'edited-field' },
	                                      'Gallery Images ',
	                                      _react2.default.createElement(
	                                        'span',
	                                        { className: 'astrick' },
	                                        '*'
	                                      )
	                                    )
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'col-md-12 float-left mt-4 p-0' },
	                                    _react2.default.createElement(
	                                      'div',
	                                      { 'class': 'col-md-12 margin-bottom-mobile-account float-left image-upload' },
	                                      _react2.default.createElement(
	                                        'div',
	                                        { className: 'upload-wizard' },
	                                        _react2.default.createElement(
	                                          'div',
	                                          { className: 'upload-thumb' },
	                                          _react2.default.createElement(
	                                            'ul',
	                                            { className: 'list-inline' },
	                                            this.state.attachment_file.map(function (file_data, index) {
	
	                                              var file_url;
	                                              if (file_data.name) {
	                                                var url = file_data.image_thumb ? file_data.image_thumb : '';
	                                                if (url !== '') {
	                                                  file_url = file_data.image_thumb;
	                                                } else {
	                                                  file_url = URL.createObjectURL(file_data);
	                                                }
	                                                if (file_data.type === 'application/pdf') {
	                                                  console.log('blob_url', file_url.names);
	                                                  return _react2.default.createElement(
	                                                    'li',
	                                                    { className: 'previewImg' },
	                                                    _react2.default.createElement(
	                                                      'div',
	                                                      { className: 'thumb-img' },
	                                                      _react2.default.createElement('img', {
	                                                        src: file_url,
	                                                        alt: 'preview',
	                                                        title: file_data.name
	                                                      })
	                                                    ),
	                                                    _react2.default.createElement(
	                                                      'a',
	                                                      { href: 'javascript:;', className: 'del-btn', onClick: function onClick() {
	                                                          _this6.removeImage(file_data.name);
	                                                        } },
	                                                      _react2.default.createElement('img', {
	                                                        src: '../../../assets/images/close-icon-white.svg',
	                                                        alt: 'delete'
	                                                      })
	                                                    )
	                                                  );
	                                                } else {
	                                                  return _react2.default.createElement(
	                                                    'li',
	                                                    { className: 'previewImg' },
	                                                    _react2.default.createElement(
	                                                      'div',
	                                                      { className: 'thumb-img' },
	                                                      _react2.default.createElement('img', {
	                                                        src: file_url,
	                                                        alt: 'preview',
	                                                        title: file_data.name
	                                                      })
	                                                    ),
	                                                    _react2.default.createElement(
	                                                      'a',
	                                                      {
	                                                        href: 'javascript:;',
	                                                        className: 'del-btn',
	                                                        onClick: function onClick() {
	                                                          _this6.removeImage(file_data.name);
	                                                        }
	                                                      },
	                                                      _react2.default.createElement('img', {
	                                                        src: '../../../assets/images/close-icon-white.svg',
	                                                        alt: 'delete'
	                                                      })
	                                                    )
	                                                  );
	                                                }
	                                              } else {
	                                                return undefined;
	                                              }
	                                            }),
	                                            _react2.default.createElement(
	                                              'li',
	                                              { className: 'addMore' },
	                                              _react2.default.createElement('input', {
	                                                type: 'file',
	                                                name: 'imgInp[]',
	                                                id: 'imgInp2',
	                                                className: 'add_img',
	                                                multiple: true,
	                                                onChange: this.loadFile.bind(this),
	                                                accept: 'image/x-png,image/gif,image/jpeg'
	                                              }),
	                                              _react2.default.createElement(
	                                                'a',
	                                                { href: 'javascript:;', className: 'add-more' },
	                                                _react2.default.createElement(
	                                                  'div',
	                                                  null,
	                                                  _react2.default.createElement('img', { src: '../../../assets/images/upload-icon.svg', alt: 'icon' }),
	                                                  'Add more'
	                                                )
	                                              )
	                                            )
	                                          )
	                                        )
	                                      )
	                                    ),
	                                    this.validator.message('gallery images', this.state.attachment_file, '', { className: 'text-danger error-msg' })
	                                  )
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-12 col-xs-12 btn-bdr' },
	                                _react2.default.createElement(
	                                  'button',
	                                  { id: 'btnSubmit', className: 'btn btn-primary btn-sm' },
	                                  'Preview'
	                                )
	                              )
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          this.preview()
	        )
	      );
	    }
	  }]);
	
	  return verticalSchool;
	}(_react.Component);
	
	exports.default = verticalSchool;

/***/ },
/* 1039 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _FetchCall2 = _interopRequireDefault(_FetchCall);
	
	var _reactstrap = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var verticalTuitionDetail = function (_Component) {
	    _inherits(verticalTuitionDetail, _Component);
	
	    function verticalTuitionDetail(props) {
	        _classCallCheck(this, verticalTuitionDetail);
	
	        var _this = _possibleConstructorReturn(this, (verticalTuitionDetail.__proto__ || Object.getPrototypeOf(verticalTuitionDetail)).call(this, props));
	
	        _this.handleChange = function (e) {
	            _this.setState(_defineProperty({}, e.target.name, e.target.value));
	        };
	
	        _this.handleCreateSubmit = function (e) {
	            e.preventDefault();
	
	            var subData = JSON.stringify({
	                id: _this.id,
	                user_type: 2,
	                table: 'bw_tutions',
	                plan: _this.state.plan,
	                organisation_name: _this.state.organisation_name,
	                username: _this.state.username,
	                amount: _this.state.amount,
	                first_name: _this.state.first_name,
	                last_name: _this.state.last_name,
	                razorpay_payment_id: _this.state.razorpay_payment_id,
	                enddate: _this.state.enddate
	            });
	            // jQuery("#btnSubmit").attr('disabled', true);
	
	            (0, _FetchCall.CheckCreatePartner)(subData).then(function (res) {
	                var toastr = '';
	                if (res.status === 1) {
	                    toastr = window.toastr.success;
	                    toastr('', res.message, {
	                        positionClass: "toast-bottom-right",
	                        containerId: "toast-bottom-right"
	                    });
	                    window.location.href = document.referrer;
	                } else {
	                    (0, _jquery2.default)("#btnSubmit").attr('disabled', false);
	                    toastr = window.toastr.error; //warning
	                    toastr('Error', 'Something went wrong. try again!...', {
	                        positionClass: "toast-bottom-right",
	                        containerId: "toast-bottom-right"
	                    });
	                }
	            });
	        };
	
	        _this.state = {
	            infoDetails: [],
	            partnercreation: false
	        };
	        _this.id = _this.props.match.params.id;
	        _this.type = _this.props.match.params.type;
	        _this.infoDetails = _this.infoDetails.bind(_this);
	
	        _this.openPartnerCreate = _this.openPartnerCreate.bind(_this);
	        return _this;
	    }
	
	    _createClass(verticalTuitionDetail, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            console.log(this.props);
	            this.infoDetails();
	        }
	    }, {
	        key: 'getPageTitle',
	        value: function getPageTitle(title) {
	            var activityTitle = '';
	            switch (title) {
	                case "1":
	                    activityTitle = 'Tution Info';
	                    break;
	
	                case "music":
	                    activityTitle = 'Music Info';
	                    break;
	
	                case "sports":
	                    activityTitle = 'Sports Info';
	                    break;
	
	                case "dance":
	                    activityTitle = 'Dance Info';
	                    break;
	
	                case "drawing":
	                    activityTitle = 'Drawing Info';
	                    break;
	                case "yoga":
	                    activityTitle = 'Yoga Info';
	                    break;
	
	                default:
	                    activityTitle = title;
	            }
	            return activityTitle;
	        }
	    }, {
	        key: 'UNSAFE_componentWillMount',
	        value: function UNSAFE_componentWillMount() {}
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {}
	    }, {
	        key: 'infoDetails',
	        value: function () {
	            var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	                var response, data;
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                _context.next = 2;
	                                return _FetchCall2.default.getTutionsInfo(this.id);
	
	                            case 2:
	                                response = _context.sent;
	
	                                if (!response) {
	                                    _context.next = 8;
	                                    break;
	                                }
	
	                                data = response.data;
	
	                                this.setState({
	                                    infoDetails: data,
	                                    url: data.url,
	                                    photos_arr: data.photo_arr
	                                });
	
	                                _context.next = 9;
	                                break;
	
	                            case 8:
	                                return _context.abrupt('return', _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    'Error'
	                                ));
	
	                            case 9:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function infoDetails() {
	                return _ref.apply(this, arguments);
	            }
	
	            return infoDetails;
	        }()
	    }, {
	        key: 'gallery_image',
	        value: function gallery_image() {
	            var _this2 = this;
	
	            var photos = this.state.photos_arr !== undefined ? this.state.photos_arr : [];
	            var rows = "";
	            if (photos.length > 0) {
	                rows = photos.map(function (photos, index) {
	                    if (photos.name) return _react2.default.createElement(
	                        'div',
	                        { 'class': 'col-md-4 float-left mt-4 p-0' },
	                        _react2.default.createElement('img', { src: _this2.state.url + photos.name, alt: 'Img', 'class': 'img-thumbnail' })
	                    );
	                    return;
	                });
	            } else {
	                rows = "";
	            }
	            return rows;
	        }
	    }, {
	        key: 'openPartnerCreate',
	        value: function openPartnerCreate() {
	            this.setState({ partnercreation: true });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var infoDetails = this.state.infoDetails;
	
	            console.log('infoDetails', this.state);
	            console.log('activityTitle', this.state.activityTitle);
	
	            return _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _react2.default.createElement(
	                    _layout2.default,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { 'class': 'col-lg-12 grid-margin stretch-card' },
	                        _react2.default.createElement(
	                            'div',
	                            { 'class': 'card' },
	                            _react2.default.createElement(
	                                'div',
	                                { 'class': 'card-body' },
	                                _react2.default.createElement(
	                                    'h4',
	                                    { 'class': 'card-title' },
	                                    infoDetails.tution_name,
	                                    ' - View'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'pt-3 detailsection' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'box-shadow-custom' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'row' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'form-group col-md-4' },
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    null,
	                                                    'Registartion No.'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'p',
	                                                    null,
	                                                    infoDetails.registration_no
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'form-group col-md-4' },
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    null,
	                                                    'Owner Name'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'p',
	                                                    null,
	                                                    infoDetails.owner_name
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'form-group col-md-4' },
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    null,
	                                                    'Organization Name'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'p',
	                                                    null,
	                                                    infoDetails.tution_name
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'form-group col-md-4' },
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    null,
	                                                    'Incharge Name '
	                                                ),
	                                                _react2.default.createElement(
	                                                    'p',
	                                                    null,
	                                                    infoDetails.tutor_name
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'form-group col-md-4' },
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    null,
	                                                    'Subject'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'p',
	                                                    null,
	                                                    infoDetails.sub_categories
	                                                )
	                                            ),
	                                            infoDetails.languages ? _react2.default.createElement(
	                                                'div',
	                                                { className: 'form-group col-md-4' },
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    null,
	                                                    'Languages'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'p',
	                                                    null,
	                                                    infoDetails.languages
	                                                )
	                                            ) : ''
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'box-shadow-custom' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'row' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'col-md-12 col-xs-12' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { className: 'form-legend' },
	                                                    'Address Information'
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'form-group col-md-4' },
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    null,
	                                                    'Email Id'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'p',
	                                                    null,
	                                                    infoDetails.email_id
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'form-group col-md-4' },
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    null,
	                                                    'Phone Number'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'p',
	                                                    null,
	                                                    infoDetails.phone_number
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'form-group col-md-4' },
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    null,
	                                                    'Landline Number'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'p',
	                                                    null,
	                                                    infoDetails.landline_number
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'form-group col-md-4' },
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    null,
	                                                    'Website'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'p',
	                                                    null,
	                                                    infoDetails.website
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'form-group col-md-4' },
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    null,
	                                                    'State'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'p',
	                                                    null,
	                                                    infoDetails.state
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'form-group col-md-4' },
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    null,
	                                                    'Location'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'p',
	                                                    null,
	                                                    infoDetails.location
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'form-group col-md-4' },
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    null,
	                                                    'Pincode'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'p',
	                                                    null,
	                                                    infoDetails.pincode
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'form-group col-md-4' },
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    null,
	                                                    'Address'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'p',
	                                                    null,
	                                                    infoDetails.address
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'form-group col-md-4' },
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    null,
	                                                    'Area'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'p',
	                                                    null,
	                                                    infoDetails.area
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'form-group col-md-4' },
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    null,
	                                                    'Country'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'p',
	                                                    null,
	                                                    infoDetails.country
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'form-group col-md-4' },
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    null,
	                                                    'Google Location Address'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'p',
	                                                    null,
	                                                    infoDetails.google_location
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'form-group col-md-12' },
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    null,
	                                                    'About the Tution'
	                                                ),
	                                                _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: infoDetails.about_tution } })
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'box-shadow-custom' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'row' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'col-md-12 col-xs-12' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { className: 'form-legend' },
	                                                    'Key Information'
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'form-group col-md-4' },
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    null,
	                                                    'Tution Type'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'p',
	                                                    null,
	                                                    infoDetails.tution_type
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'form-group col-md-4' },
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    null,
	                                                    'Board Of Education'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'p',
	                                                    null,
	                                                    infoDetails.bof
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'form-group col-md-4' },
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    null,
	                                                    'Class Frequency'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'p',
	                                                    null,
	                                                    infoDetails.class_freq
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'form-group col-md-4' },
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    null,
	                                                    'Class Range'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'p',
	                                                    null,
	                                                    infoDetails.class_range
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'form-group col-md-4' },
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    null,
	                                                    'Number of Teachers'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'p',
	                                                    null,
	                                                    infoDetails.number_of_teachers
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'form-group col-md-4' },
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    null,
	                                                    'Instruction Language'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'p',
	                                                    null,
	                                                    infoDetails.instruction_lang
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'form-group col-md-4 input-group-cus' },
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    null,
	                                                    'From Timing'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'p',
	                                                    null,
	                                                    infoDetails.dfrom_time
	                                                ),
	                                                _react2.default.createElement('div', null)
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'form-group col-md-4 input-group-cus' },
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    null,
	                                                    'To Timing'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'p',
	                                                    null,
	                                                    infoDetails.dto_time
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'form-group col-md-4' },
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    null,
	                                                    'Establishment Year '
	                                                ),
	                                                _react2.default.createElement(
	                                                    'p',
	                                                    null,
	                                                    infoDetails.establishment_Year
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'form-group col-md-4' },
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    null,
	                                                    'Average Fees(INR) '
	                                                ),
	                                                _react2.default.createElement(
	                                                    'p',
	                                                    null,
	                                                    infoDetails.avg_anual_fee
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'form-group col-md-4' },
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    null,
	                                                    'Admission Fees '
	                                                ),
	                                                _react2.default.createElement(
	                                                    'p',
	                                                    null,
	                                                    infoDetails.addmission_fee
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'form-group col-md-4' },
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    null,
	                                                    'Student Ratio'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'p',
	                                                    null,
	                                                    infoDetails.std_ratio
	                                                )
	                                            ),
	                                            infoDetails.vendor_id === 1 && _react2.default.createElement(
	                                                'div',
	                                                { className: 'form-group col-md-4' },
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    null,
	                                                    'Partner Type'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'p',
	                                                    null,
	                                                    infoDetails.partner_type === 1 ? 'Institution' : 'Individual'
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'form-group col-md-4' },
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    null,
	                                                    'Website Search Keywords'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'p',
	                                                    null,
	                                                    infoDetails.keywords
	                                                )
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'box-shadow-custom' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'row' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'col-md-12 col-xs-12' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { className: 'form-legend' },
	                                                    'Images'
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'form-group col-md-4' },
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    null,
	                                                    'Banner '
	                                                ),
	                                                infoDetails.images && _react2.default.createElement('img', { src: infoDetails.url + infoDetails.images, alt: 'Img', 'class': 'img-thumbnail' })
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { 'class': 'col-md-12 float-left mt-4 p-0' },
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    null,
	                                                    'Gallery Images'
	                                                )
	                                            ),
	                                            this.gallery_image()
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'row' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'col-md-12' },
	                                        _react2.default.createElement(
	                                            'button',
	                                            { 'class': 'btn btn-primary btn-sm', onClick: this.openPartnerCreate },
	                                            'Create Partner'
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    _reactstrap.Modal,
	                                    { isOpen: this.state.partnercreation, size: 'lg', className: 'partnercreation-pop' },
	                                    _react2.default.createElement(
	                                        _reactstrap.ModalBody,
	                                        { className: 'p-0' },
	                                        _react2.default.createElement(
	                                            _reactstrap.Row,
	                                            { className: 'pv-section' },
	                                            _react2.default.createElement(
	                                                _reactstrap.Col,
	                                                { className: '', md: '12' },
	                                                _react2.default.createElement(
	                                                    'h3',
	                                                    null,
	                                                    'Partner Creation Info'
	                                                ),
	                                                _react2.default.createElement('br', null),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { 'class': 'form-row' },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { 'class': 'form-group col-md-6' },
	                                                        _react2.default.createElement(
	                                                            'label',
	                                                            { 'for': 'inputEmail4' },
	                                                            'Organization Name'
	                                                        ),
	                                                        _react2.default.createElement('input', { type: 'text', 'class': 'form-control', id: 'organisation_name', name: 'organisation_name', placeholder: 'Organization Name', onChange: this.handleChange })
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { 'class': 'form-group col-md-6' },
	                                                        _react2.default.createElement(
	                                                            'label',
	                                                            { 'for': 'inputPassword4' },
	                                                            'Username'
	                                                        ),
	                                                        _react2.default.createElement('input', { type: 'text', 'class': 'form-control', id: 'username', name: 'username', placeholder: 'Username', onChange: this.handleChange })
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { 'class': 'form-row' },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { 'class': 'form-group col-md-6' },
	                                                        _react2.default.createElement(
	                                                            'label',
	                                                            { 'for': 'inputAddress' },
	                                                            'First Name'
	                                                        ),
	                                                        _react2.default.createElement('input', { type: 'text', 'class': 'form-control', id: 'first_name', name: 'first_name', placeholder: 'First Name', onChange: this.handleChange })
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { 'class': 'form-group col-md-6' },
	                                                        _react2.default.createElement(
	                                                            'label',
	                                                            { 'for': 'inputAddress2' },
	                                                            'Last Name'
	                                                        ),
	                                                        _react2.default.createElement('input', { type: 'text', 'class': 'form-control', id: 'last_name', name: 'last_name', placeholder: 'Last Name', onChange: this.handleChange })
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { 'class': 'form-row' },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { 'class': 'form-group col-md-6' },
	                                                        _react2.default.createElement(
	                                                            'label',
	                                                            { 'for': 'inputAddress' },
	                                                            'Amount Received'
	                                                        ),
	                                                        _react2.default.createElement('input', { type: 'text', 'class': 'form-control', id: 'amountrecevied', name: 'amount', placeholder: 'Amount', onChange: this.handleChange })
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { 'class': 'form-group col-md-6' },
	                                                        _react2.default.createElement(
	                                                            'label',
	                                                            { 'for': 'inputAddress2' },
	                                                            'Payment Link'
	                                                        ),
	                                                        _react2.default.createElement('input', { type: 'text', 'class': 'form-control', id: 'razorpay_payment_id', name: 'razorpay_payment_id', placeholder: 'Payment Link', onChange: this.handleChange })
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { 'class': 'form-row' },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { 'class': 'form-group col-md-4' },
	                                                        _react2.default.createElement(
	                                                            'label',
	                                                            { 'for': 'inputState' },
	                                                            'Extend'
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'select',
	                                                            { id: 'inputState', 'class': 'form-control', name: 'enddate', onChange: this.handleChange },
	                                                            _react2.default.createElement(
	                                                                'option',
	                                                                { selected: true },
	                                                                'Choose...'
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'option',
	                                                                { value: '2023-06-30' },
	                                                                'June 2023'
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'option',
	                                                                { value: '2023-07-31' },
	                                                                'July 2023'
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'option',
	                                                                { value: '2023-08-30' },
	                                                                'August 2023'
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'option',
	                                                                { value: '2023-09-31' },
	                                                                'Sep 2023'
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'option',
	                                                                { value: '2023-10-30' },
	                                                                'Oct 2023'
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'option',
	                                                                { value: '2023-11-31' },
	                                                                'Nov 2023'
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'option',
	                                                                { value: '2023-12-30' },
	                                                                'Dec 2023'
	                                                            )
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { 'class': 'form-group col-md-4' },
	                                                        _react2.default.createElement(
	                                                            'label',
	                                                            { 'for': 'inputState' },
	                                                            'Plan'
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'select',
	                                                            { id: 'inputState', 'class': 'form-control', name: 'plan', onChange: this.handleChange },
	                                                            _react2.default.createElement(
	                                                                'option',
	                                                                { selected: true },
	                                                                'Choose...'
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'option',
	                                                                { value: '3' },
	                                                                'Value Pro'
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'option',
	                                                                { value: '4' },
	                                                                'Magic'
	                                                            )
	                                                        )
	                                                    )
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactstrap.Row,
	                                            { className: 'pv-section' },
	                                            _react2.default.createElement(
	                                                _reactstrap.Col,
	                                                { className: '', md: '12' },
	                                                _react2.default.createElement(
	                                                    'button',
	                                                    { className: 'btn btn-sm btn-primary custome-submit', onClick: this.handleCreateSubmit },
	                                                    'Submit'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'button',
	                                                    { className: 'btn btn-sm btn-defult custome-submit', style: { marginLeft: '10px' },
	                                                        onClick: function onClick() {
	                                                            _this3.setState({ partnercreation: false });
	                                                        } },
	                                                    'Close'
	                                                )
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return verticalTuitionDetail;
	}(_react.Component);
	
	exports.default = verticalTuitionDetail;

/***/ },
/* 1040 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _FetchCall2 = _interopRequireDefault(_FetchCall);
	
	var _constant = __webpack_require__(21);
	
	var _reactstrap = __webpack_require__(17);
	
	var _reactGeocode = __webpack_require__(55);
	
	var _reactGeocode2 = _interopRequireDefault(_reactGeocode);
	
	var _multiselectReactDropdown = __webpack_require__(73);
	
	var _simpleReactValidator = __webpack_require__(28);
	
	var _simpleReactValidator2 = _interopRequireDefault(_simpleReactValidator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import { Editor } from '@tinymce/tinymce-react';
	
	
	_reactGeocode2.default.setApiKey("AIzaSyA9MtbfG_zlo64B2lqNMvigTBuXHkagKcE");
	_reactGeocode2.default.setLanguage("en");
	_reactGeocode2.default.setRegion("es");
	_reactGeocode2.default.enableDebug();
	
	var tuition_cls = [{ "id": 1, "name": "Class 1" }, { "id": 2, "name": "Class 2" }, { "id": 3, "name": "Class 3" }, { "id": 4, "name": "Class 4" }, { "id": 5, "name": "Class 5" }, { "id": 6, "name": "Class 6" }, { "id": 7, "name": "Class 7" }, { "id": 8, "name": "Class 8" }, { "id": 9, "name": "Class 9" }, { "id": 10, "name": "Class 10" }, { "id": 11, "name": "Class 11" }, { "id": 12, "name": "Class 12" }, { "id": 13, "name": "JEE" }, { "id": 14, "name": "NEET" }, { "id": 15, "name": "GATE" }];
	var class_freq = [{ "id": 1, "freq_name": "Daily" }, { "id": 2, "freq_name": "Weekly" }, { "id": 3, "freq_name": "Monthly" }, { "id": 4, "freq_name": "NA" }];
	
	var verticalTuitionEdit = function (_Component) {
	    _inherits(verticalTuitionEdit, _Component);
	
	    function verticalTuitionEdit(props) {
	        var _this2 = this;
	
	        _classCallCheck(this, verticalTuitionEdit);
	
	        var _this = _possibleConstructorReturn(this, (verticalTuitionEdit.__proto__ || Object.getPrototypeOf(verticalTuitionEdit)).call(this, props));
	
	        _this.LocationDataList = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	            var res;
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            _context.prev = 0;
	                            _context.next = 3;
	                            return (0, _FetchCall.getLocationList)();
	
	                        case 3:
	                            res = _context.sent;
	
	                            if (res.status === 1) {
	                                console.log('location_list', res.results);
	
	                                _this.setState({
	                                    location_list: res.results,
	                                    error: false
	                                });
	                            }
	
	                            _context.next = 10;
	                            break;
	
	                        case 7:
	                            _context.prev = 7;
	                            _context.t0 = _context['catch'](0);
	
	                            _this.setState({ error: true });
	
	                        case 10:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, _this2, [[0, 7]]);
	        }));
	
	        _this.validateMail = function (value, catgry, vendr_id, pageid) {
	            var _JSON$stringify;
	
	            var name = 'email_id';
	            var type_name = 'isEmailValid';
	            var req = JSON.stringify((_JSON$stringify = {}, _defineProperty(_JSON$stringify, name, value), _defineProperty(_JSON$stringify, 'category', catgry), _defineProperty(_JSON$stringify, 'vendor_id', vendr_id), _defineProperty(_JSON$stringify, 'pageid', pageid), _JSON$stringify));
	            (0, _FetchCall.emailExist_check)(req).then(function (res) {
	                console.log('valuee', res);
	                if (res.status === 1) {
	                    _this.setState(_defineProperty({}, type_name, false));
	                } else {
	                    // return res.status;
	                    _this.setState(_defineProperty({}, type_name, true));
	                }
	            });
	        };
	
	        _this.getKeywords = function () {
	            (0, _FetchCall.commonAPI)(JSON.stringify({ url: 'get_site_keywords', vertical: 'tuition' })).then(function (res) {
	                if (res.status === 1) {
	                    _this.setState({
	                        keywordsArr: res.results
	                    });
	                }
	            });
	        };
	
	        _this.onSelect = function (selectedList) {
	            var keywords = [];
	            selectedList.forEach(function (item, i) {
	                keywords.push(item);
	            });
	            _this.setState({
	                keywords: keywords
	            });
	        };
	
	        _this.onRemove = function (selectedList, removedItem) {
	            var keywords = [];
	            selectedList.forEach(function (item, i) {
	                keywords.push(item);
	            });
	            _this.setState({
	                keywords: keywords
	            });
	        };
	
	        _this.handleSelect = function (e) {
	            var propName = e.target.name;
	            var value = [].concat(_toConsumableArray(e.target.selectedOptions)).map(function (item) {
	                return item.value;
	            });
	
	            _this.setState(_defineProperty({}, propName, value));
	
	            if (propName === 'subject') {
	                var filterValue = value.filter(function (item) {
	                    return item === '101';
	                });
	                console.log('filterValue', filterValue);
	                if (filterValue[0] === '101') {
	                    _this.setState({
	                        languages: true,
	                        languages_: ''
	                    });
	                } else {
	                    _this.setState({ languages: false, sub_type: '' });
	                }
	            }
	        };
	
	        _this.handleChange = function (e) {
	            _this.setState(_defineProperty({}, e.target.name, e.target.value));
	            if (e.target.name === 'google_location') _this.Geocode_location();
	        };
	
	        _this.handleFile = function (e) {
	            // this.Geocode_location();
	            var propName = e.target.name;
	            var files = e.target.files[0];
	            _this.setState(_defineProperty({}, propName, files));
	            var reader = new FileReader();
	            var THIS = _this;
	            reader.addEventListener("load", function () {
	                // convert image file to base64 string
	                THIS.setState({
	                    tempBanner: reader.result
	                });
	            }, false);
	
	            if (files) {
	                reader.readAsDataURL(files);
	            } else {
	                THIS.setState({
	                    tempBanner: ''
	                });
	            }
	        };
	
	        _this.handleFileMultiple = function (e) {
	            _this.setState(_defineProperty({}, e.target.name, e.target.files));
	        };
	
	        _this.removeImage = function (e) {
	            var delete_array = _this.state.delete_array;
	            delete_array.push(e);
	            var updated = _this.state.attachment_file.filter(function (item) {
	                return item.name !== e;
	            });
	            _this.setState({
	                attachment_file: updated,
	                delete_array: delete_array
	            });
	        };
	
	        _this.handlePreview = function (e) {
	            e.preventDefault();
	            if (_this.validator.allValid()) {
	                _this.setState({
	                    preview: true
	                });
	            } else {
	                _this.validator.showMessages();
	                _this.forceUpdate();
	            }
	        };
	
	        _this.preview = function () {
	            var subcate = _this.state.subjectList.map(function (item) {
	                return _this.state.subject.includes(item.category_id.toString()) ? item.category_name : '';
	            });
	            subcate = subcate.filter(function (n) {
	                return n;
	            }).toString();
	            var lang = _this.state.languageList.map(function (item) {
	                return _this.state.languages_.includes(item.category_id.toString()) ? item.category_name : '';
	            });
	            lang = lang.filter(function (n) {
	                return n;
	            }).toString();
	            var ttype = _this.state.tutionList.map(function (item) {
	                return _this.state.tution_type.includes(item.id.toString()) ? item.name : '';
	            });
	            ttype = ttype.filter(function (n) {
	                return n;
	            }).toString();
	            var boe = _this.state.boeList.map(function (item) {
	                return _this.state.board_of_education.includes(item.id.toString()) ? item.name : '';
	            });
	            boe = boe.filter(function (n) {
	                return n;
	            }).toString();
	            var cls = _this.state.getTuitionCls.map(function (item) {
	                return _this.state.class_range.includes(item.id.toString()) ? item.name : '';
	            });
	            cls = cls.filter(function (n) {
	                return n;
	            }).toString();
	            var loptions = _this.state.std_ratio.map(function (item) {
	                if (item === 1) {
	                    return 'One to One';
	                }
	                if (item === 2) {
	                    return 'One to Many';
	                }
	                if (item === 3) {
	                    return 'NA';
	                }
	                return;
	            });
	            loptions = loptions.filter(function (n) {
	                return n;
	            }).toString();
	            var clsfreq = _this.state.ClassList.map(function (item) {
	                if (_this.state.class_frequency === item.id.toString()) return item.freq_name;
	                return;
	            });
	            var from_time = _this.state.timingList.map(function (item) {
	                if (item.id === _this.state.from_time) return item.timing;
	                return;
	            });
	            from_time = from_time.filter(function (n) {
	                return n;
	            }).toString();
	            var to_time = _this.state.timingList.map(function (item) {
	                if (item.id === _this.state.to_time) return item.timing;
	                return;
	            });
	            to_time = to_time.filter(function (n) {
	                return n;
	            }).toString();
	            return _react2.default.createElement(
	                _reactstrap.Modal,
	                { isOpen: _this.state.preview, size: 'lg', className: 'preview-pop' },
	                _react2.default.createElement(
	                    _reactstrap.ModalBody,
	                    { className: '' },
	                    _react2.default.createElement(
	                        _reactstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactstrap.Col,
	                            { md: '12' },
	                            _react2.default.createElement('img', { src: '/assets/images/user-header.png', className: 'preview-header', alt: 'preview' })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactstrap.Row,
	                        { className: 'pv-banner' },
	                        _react2.default.createElement(
	                            _reactstrap.Col,
	                            { className: 'pv-banner-bg', md: '12' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'title-section' },
	                                _react2.default.createElement(
	                                    'p',
	                                    { className: 'banner-title' },
	                                    _this.state.organisation_name
	                                ),
	                                _react2.default.createElement(
	                                    'p',
	                                    { className: 'banner-address' },
	                                    _this.state.address
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactstrap.Row,
	                        { className: 'pv-section' },
	                        _react2.default.createElement(
	                            _reactstrap.Col,
	                            { className: '', md: '12' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'title-section' },
	                                _react2.default.createElement(
	                                    'h4',
	                                    null,
	                                    'About the School'
	                                ),
	                                _react2.default.createElement(
	                                    'p',
	                                    { className: '' },
	                                    _this.state.about
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactstrap.Row,
	                        { className: 'pv-section' },
	                        _react2.default.createElement(
	                            _reactstrap.Col,
	                            { className: '', md: '12' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'title-section' },
	                                _react2.default.createElement(
	                                    'h4',
	                                    null,
	                                    'Key Information'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'row' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-4' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'type-n7ngd' },
	                                            _react2.default.createElement(
	                                                'b',
	                                                null,
	                                                'Class'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'key-po' },
	                                            _react2.default.createElement(
	                                                'p',
	                                                null,
	                                                cls
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-4' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'type-n7ngd' },
	                                            _react2.default.createElement(
	                                                'b',
	                                                null,
	                                                'Avg Fee'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'key-po' },
	                                            _react2.default.createElement(
	                                                'p',
	                                                null,
	                                                parseFloat(_this.state.avg_anual_fee) > 0 ? _this.state.avg_anual_fee + '/Month' : 'NA'
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-4' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'type-n7ngd' },
	                                            _react2.default.createElement(
	                                                'b',
	                                                null,
	                                                'Learning at'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'key-po' },
	                                            _react2.default.createElement(
	                                                'p',
	                                                null,
	                                                ttype
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-4' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'type-n7ngd' },
	                                            _react2.default.createElement(
	                                                'b',
	                                                null,
	                                                'Board of Education'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'key-po' },
	                                            _react2.default.createElement(
	                                                'p',
	                                                null,
	                                                boe
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-4' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'type-n7ngd' },
	                                            _react2.default.createElement(
	                                                'b',
	                                                null,
	                                                'Instruction language'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'key-po' },
	                                            _react2.default.createElement(
	                                                'p',
	                                                null,
	                                                _this.state.instruction_lang
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-4' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'type-n7ngd' },
	                                            _react2.default.createElement(
	                                                'b',
	                                                null,
	                                                'Subject'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'key-po' },
	                                            _react2.default.createElement(
	                                                'p',
	                                                null,
	                                                subcate
	                                            )
	                                        )
	                                    ),
	                                    lang && _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-4' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'type-n7ngd' },
	                                            _react2.default.createElement(
	                                                'b',
	                                                null,
	                                                'Languages'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'key-po' },
	                                            _react2.default.createElement(
	                                                'p',
	                                                null,
	                                                lang
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-4' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'type-n7ngd' },
	                                            _react2.default.createElement(
	                                                'b',
	                                                null,
	                                                'No of Staff'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'key-po' },
	                                            _react2.default.createElement(
	                                                'p',
	                                                null,
	                                                _this.state.number_of_teachers
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-4' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'type-n7ngd' },
	                                            _react2.default.createElement(
	                                                'b',
	                                                null,
	                                                'Timing'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'key-po' },
	                                            _react2.default.createElement(
	                                                'p',
	                                                null,
	                                                from_time === 'NA' || to_time === 'NA' ? 'NA' : from_time + ' ' + _this.state.from_time_cate + ' - ' + to_time + ' ' + _this.state.to_time_cate
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-4' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'type-n7ngd' },
	                                            _react2.default.createElement(
	                                                'b',
	                                                null,
	                                                'Establishment Year'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'key-po' },
	                                            _react2.default.createElement(
	                                                'p',
	                                                null,
	                                                _this.state.establishment_Year
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-4' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'type-n7ngd' },
	                                            _react2.default.createElement(
	                                                'b',
	                                                null,
	                                                'Student Ratio'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'key-po' },
	                                            _react2.default.createElement(
	                                                'p',
	                                                null,
	                                                loptions
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-4' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'type-n7ngd' },
	                                            _react2.default.createElement(
	                                                'b',
	                                                null,
	                                                'Class Frequency'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'key-po' },
	                                            _react2.default.createElement(
	                                                'p',
	                                                null,
	                                                clsfreq
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-4' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'type-n7ngd' },
	                                            _react2.default.createElement(
	                                                'b',
	                                                null,
	                                                'Free Trial Class'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'key-po' },
	                                            _react2.default.createElement(
	                                                'p',
	                                                null,
	                                                _this.state.has_trail === 0 ? 'NA' : _this.state.has_trail === 1 ? 'Yes, ' : 'No',
	                                                _this.state.has_trail === 1 && ' ' + _this.state.trail_desc
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactstrap.Row,
	                        { className: 'pv-section' },
	                        _react2.default.createElement(
	                            _reactstrap.Col,
	                            { className: '', md: '12' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'title-section' },
	                                _react2.default.createElement(
	                                    'h4',
	                                    null,
	                                    'Gallery'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'row' },
	                                    _this.state.attachment_file.map(function (item) {
	                                        if (item.image_thumb) {
	                                            return _react2.default.createElement(
	                                                'div',
	                                                { className: 'col-md-4' },
	                                                _react2.default.createElement('img', { src: item.image_thumb, className: 'preview-image', alt: 'preview' })
	                                            );
	                                        } else if (item.name) {
	                                            var file_url = URL.createObjectURL(item);
	                                            return _react2.default.createElement(
	                                                'div',
	                                                { className: 'col-md-4' },
	                                                _react2.default.createElement('img', { src: file_url, className: 'preview-image', alt: 'preview' })
	                                            );
	                                        }
	                                    }),
	                                    _this.state.attachment_file.length === 0 && _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-4' },
	                                        'No Gallery Images Found'
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactstrap.Row,
	                        { className: 'pv-section' },
	                        _react2.default.createElement(
	                            _reactstrap.Col,
	                            { className: '', md: '12' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'title-section' },
	                                _react2.default.createElement(
	                                    'h4',
	                                    null,
	                                    'Contact Information'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'row' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-4' },
	                                        'Email Id : ',
	                                        _this.state.email_id
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-4' },
	                                        'Contact : ',
	                                        _this.state.phone_number
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-4' },
	                                        'Website : ',
	                                        _this.state.website
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactstrap.Row,
	                        { className: 'pv-section' },
	                        _react2.default.createElement(
	                            _reactstrap.Col,
	                            { className: '', md: '12' },
	                            _react2.default.createElement(
	                                'button',
	                                { className: 'btn btn-sm btn-primary custome-submit', onClick: _this.handleSubmit },
	                                _this.state.edited && (_this.state.role === 1 || _this.state.login_id === 936) ? 'Approve' : 'Submit'
	                            ),
	                            _this.state.edited && (_this.state.role === 1 || _this.state.login_id === 936) && _react2.default.createElement(
	                                'button',
	                                { className: 'btn btn-sm btn-danger custome-submit', style: { marginLeft: '10px' },
	                                    onClick: _this.handleReject },
	                                'Reject'
	                            ),
	                            _react2.default.createElement(
	                                'button',
	                                { className: 'btn btn-sm btn-defult custome-submit', style: { marginLeft: '10px' },
	                                    onClick: function onClick() {
	                                        _this.setState({ preview: false });
	                                    } },
	                                'Close'
	                            )
	                        )
	                    )
	                )
	            );
	        };
	
	        _this.handleReject = function (e) {
	            e.preventDefault();
	            var req = JSON.stringify({
	                id: _this.state.getId
	            });
	            var toastr = '';
	            (0, _FetchCall.tuitionReject)(req).then(function (res) {
	                if (res.status === 1) {
	                    toastr = window.toastr.success;
	                    toastr('success', {
	                        positionClass: "toast-bottom-right",
	                        containerId: "toast-bottom-right"
	                    });
	                    window.location.href = document.referrer;
	                }
	            });
	        };
	
	        _this.handleSubmit = function (e) {
	            e.preventDefault();
	            if (_this.validator.allValid()) {
	                var insData = {
	                    gid: _this.state.getId,
	                    login_id: _this.state.login_id,
	                    owner_name: _this.state.owner_name,
	                    tution_name: _this.state.tution_name,
	                    email_id: _this.state.email_id,
	                    phone_number: _this.state.phone_number,
	                    landline_number: _this.state.landline_number,
	                    website: _this.state.website,
	                    state: _this.state.state,
	                    location: _this.state.location,
	                    pincode: _this.state.pincode,
	                    address: _this.state.address,
	                    about: _this.state.about_tution,
	                    google_location: _this.state.google_location,
	                    sub_categories: _this.state.subject,
	                    no_teacher: _this.state.number_of_teachers,
	                    opening_time: _this.state.timing,
	                    instruction_lang: _this.state.instruction_lang,
	                    est_year: _this.state.establishment_Year,
	                    avg_fee: _this.state.avg_anual_fee,
	                    admit_fee: _this.state.addmission_fee,
	                    area: _this.state.area,
	                    incharge_name: _this.state.tutor_name,
	                    tution_type: _this.state.tution_type,
	                    class_range: _this.state.class_range,
	                    bof: _this.state.board_of_education,
	                    class_freq: _this.state.class_frequency,
	                    country: _this.state.country,
	                    images: _this.state.images,
	                    languages: _this.state.languages_,
	                    registration_no: _this.state.registration_no,
	                    photos: _this.state.attachment_file,
	                    latitude: _this.state.latitude,
	                    longitude: _this.state.longitude,
	                    std_ratio: _this.state.std_ratio,
	                    from_time: _this.state.from_time,
	                    to_time: _this.state.to_time,
	                    keywords: _this.state.keywords ? _this.state.keywords.join(';') : '',
	                    from_time_cate: _this.state.from_time_cate,
	                    to_time_cate: _this.state.to_time_cate,
	                    delete_array: _this.state.delete_array,
	                    has_trail: _this.state.has_trail,
	                    trail_desc: _this.state.trail_desc,
	                    other_rating: _this.state.other_rating,
	                    partner_type: _this.state.partner_type,
	                    role: _this.state.role
	                    // jQuery("#btnSubmit").attr('disabled', true);
	                };(0, _FetchCall.AddTutions)(insData).then(function (res) {
	                    if (res.status === 1) {
	                        alert("Saved successfully");
	                        window.location.href = document.referrer;
	                    } else {
	                        (0, _jquery2.default)("#btnSubmit").attr('disabled', false);
	                        alert("Error in saving");
	                    }
	                });
	            } else {
	                _this.validator.showMessages();
	                _this.forceUpdate();
	            }
	        };
	
	        _this.state = {
	            vendor_id: 1,
	            pageid: '',
	            owner_name: '',
	            tution_name: '',
	            email_id: '',
	            languages_: [],
	            phone_number: '',
	            landline_number: '',
	            fax_number: '',
	            website: '',
	            state: '',
	            std_ratio: [],
	            location: '',
	            pincode: '',
	            address: '',
	            about_tution: '',
	            google_location: '',
	            subject: [],
	            languageList: [],
	            grade: '',
	            number_of_teachers: '',
	            timing: '',
	            instruction_lang: '',
	            establishment_Year: '',
	            avg_anual_fee: '',
	            addmission_fee: '',
	            area: '',
	            tutor_name: '',
	            tution_type: [],
	            class_range: [],
	            board_of_education: [],
	            class_frequency: '',
	            country: '',
	            images: '',
	            photos: '',
	            timingList: [],
	            boeList: [],
	            tutionList: [],
	            subjectList: [],
	            ClassList: class_freq,
	            mopList: [],
	            languages: false,
	            getId: _this.props.match.params.id ? _this.props.match.params.id : '',
	            latitude: '',
	            longitude: '',
	            other_rating: '',
	            attachment_file: [],
	            attachment_file_length: 0,
	            attachment_fileName: [],
	            from_time: '',
	            from_time_cate: 'AM',
	            to_time: '',
	            to_time_cate: 'AM',
	            edit_image: '',
	            delete_array: [],
	            location_list: [],
	            keywords: [],
	            tempBanner: '',
	            has_trail: 0,
	            trail_desc: '',
	            partner_type: '',
	            preview: false,
	            edited_data: [],
	            getTuitionCls: tuition_cls,
	            keywordsArr: [],
	            edited: false
	        };
	        _this.validator = new _simpleReactValidator2.default({
	            validators: {
	                checkExist: { // name the rule
	                    message: 'The :attribute field is required.',
	                    rule: function rule(val, params, validator) {
	                        if (val === '' && _this.state.edit_image === '') {
	                            return false;
	                        }
	                    },
	                    messageReplace: function messageReplace(message, params) {
	                        return message.replace(':values', _this.helpers.toSentence(params));
	                    }, // optional
	                    required: true // optional
	                },
	                emailExist_check: { // name the rule
	                    message: 'The :attribute Already Exist.',
	                    rule: function rule(val, params, validator) {
	                        return _this.state.isEmailValid;
	                    },
	                    messageReplace: function messageReplace(message, params) {
	                        return message.replace(':values', _this.helpers.toSentence(params));
	                    }, // optional
	                    required: true // optional
	                },
	                checkMobile: _constant.MOBILE_REGEX,
	                checkUrl: _constant.URL_REGEX
	            }
	        });
	        _this.loadFile = _this.loadFile.bind(_this);
	        //this.getTuitionCls(); 
	        _this.getKeywords();
	        _this.gettiming();_this.tutionList();_this.getSubject();_this.getlang();_this.getboe();
	        //this.getclass_frequency(); 
	        _this.getpayment_type();
	        _this.getschool_type();
	        return _this;
	    }
	
	    _createClass(verticalTuitionEdit, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.LocationDataList();
	            var user_data = localStorage.getItem("user_data");
	            var auth_data = JSON.parse(user_data);
	            var vendor_id = auth_data.login_id;
	            this.setState({
	                login_id: vendor_id,
	                role: auth_data.role
	            });
	
	            if (this.state.getId) {
	                this.getTutionsInfo();
	            }
	        }
	    }, {
	        key: 'getTutionsInfo',
	        value: function () {
	            var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	                var response, data, edited_data;
	                return _regenerator2.default.wrap(function _callee2$(_context2) {
	                    while (1) {
	                        switch (_context2.prev = _context2.next) {
	                            case 0:
	                                _context2.next = 2;
	                                return (0, _FetchCall.tuitionEdit)(JSON.stringify({ id: this.state.getId }));
	
	                            case 2:
	                                response = _context2.sent;
	
	                                // console.log(response);
	                                if (response.status === 1) {
	                                    data = response.data, edited_data = response.original;
	
	                                    this.setState({
	                                        owner_name: data.owner_name,
	                                        pageid: data.id,
	                                        tution_name: data.tution_name,
	                                        email_id: data.email_id,
	                                        phone_number: data.phone_number,
	                                        landline_number: data.landline_number,
	                                        website: data.website,
	                                        state: data.state,
	                                        location: data.location,
	                                        pincode: data.pincode,
	                                        address: data.address,
	                                        about_tution: data.about,
	                                        std_ratio: data.std_ratio.split(','),
	                                        google_location: data.google_location,
	                                        subject: data.sub_categories.split(','),
	                                        number_of_teachers: data.no_teacher,
	                                        instruction_lang: data.instruction_lang,
	                                        establishment_Year: data.est_year,
	                                        avg_anual_fee: data.avg_fee,
	                                        addmission_fee: data.admit_fee,
	                                        area: data.area,
	                                        tutor_name: data.incharge_name,
	                                        tution_type: data.tution_type ? data.tution_type.split(',') : [],
	                                        class_range: data.class_range ? data.class_range.split(',') : [],
	                                        board_of_education: data.bof ? data.bof.split(',') : [],
	                                        class_frequency: data.class_freq ? data.class_freq.split(',') : [],
	                                        country: data.country,
	                                        images: data.images,
	                                        photos: data.photos,
	                                        languages_: data.languages ? data.languages.split(',') : [],
	                                        languages: data.languages ? true : false,
	                                        registration_no: data.registration_no,
	                                        attachment_file: data.photo_arr,
	                                        edit_image: data.images ? data.url + data.images : '',
	                                        edit_photos: data.photos,
	                                        keywords: data.keywords ? data.keywords.split(';') : [],
	                                        from_time: data.from_time,
	                                        to_time: data.to_time,
	                                        from_time_cate: data.from_time_cate,
	                                        to_time_cate: data.to_time_cate,
	                                        has_trail: data.has_trail,
	                                        trail_desc: data.trail_desc,
	                                        other_rating: data.other_rating,
	                                        longitude: data.longitude,
	                                        latitude: data.latitude,
	                                        partner_type: data.partner_type,
	                                        edited: data.edited,
	                                        edited_data: edited_data
	                                    });
	                                    this.Geocode_location(data.google_location);
	                                }
	
	                            case 4:
	                            case 'end':
	                                return _context2.stop();
	                        }
	                    }
	                }, _callee2, this);
	            }));
	
	            function getTutionsInfo() {
	                return _ref2.apply(this, arguments);
	            }
	
	            return getTutionsInfo;
	        }()
	    }, {
	        key: 'tutionList',
	        value: function () {
	            var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	                var response;
	                return _regenerator2.default.wrap(function _callee3$(_context3) {
	                    while (1) {
	                        switch (_context3.prev = _context3.next) {
	                            case 0:
	                                _context3.next = 2;
	                                return _FetchCall2.default.getSchoolListDatas('tution_type');
	
	                            case 2:
	                                response = _context3.sent;
	
	                                console.log(response);
	                                if (response) {
	                                    this.setState({ tutionList: response.results });
	                                }
	
	                            case 5:
	                            case 'end':
	                                return _context3.stop();
	                        }
	                    }
	                }, _callee3, this);
	            }));
	
	            function tutionList() {
	                return _ref3.apply(this, arguments);
	            }
	
	            return tutionList;
	        }()
	    }, {
	        key: 'gettiming',
	        value: function () {
	            var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4() {
	                var response;
	                return _regenerator2.default.wrap(function _callee4$(_context4) {
	                    while (1) {
	                        switch (_context4.prev = _context4.next) {
	                            case 0:
	                                _context4.next = 2;
	                                return _FetchCall2.default.getSchoolListDatas('timing');
	
	                            case 2:
	                                response = _context4.sent;
	
	                                console.log(response);
	                                if (response) {
	                                    this.setState({ timingList: response.results });
	                                }
	
	                            case 5:
	                            case 'end':
	                                return _context4.stop();
	                        }
	                    }
	                }, _callee4, this);
	            }));
	
	            function gettiming() {
	                return _ref4.apply(this, arguments);
	            }
	
	            return gettiming;
	        }()
	    }, {
	        key: 'getSubject',
	        value: function () {
	            var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5() {
	                var response;
	                return _regenerator2.default.wrap(function _callee5$(_context5) {
	                    while (1) {
	                        switch (_context5.prev = _context5.next) {
	                            case 0:
	                                _context5.next = 2;
	                                return _FetchCall2.default.getSubCategory('6');
	
	                            case 2:
	                                response = _context5.sent;
	
	                                console.log('subjectList', response);
	                                if (response) {
	                                    this.setState({ subjectList: response.results });
	                                }
	
	                            case 5:
	                            case 'end':
	                                return _context5.stop();
	                        }
	                    }
	                }, _callee5, this);
	            }));
	
	            function getSubject() {
	                return _ref5.apply(this, arguments);
	            }
	
	            return getSubject;
	        }()
	    }, {
	        key: 'getboe',
	        value: function () {
	            var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee6() {
	                var response;
	                return _regenerator2.default.wrap(function _callee6$(_context6) {
	                    while (1) {
	                        switch (_context6.prev = _context6.next) {
	                            case 0:
	                                _context6.next = 2;
	                                return _FetchCall2.default.getSchoolListDatas('curriculum');
	
	                            case 2:
	                                response = _context6.sent;
	
	                                console.log('boeList', response);
	                                if (response) {
	                                    this.setState({ boeList: response.results });
	                                }
	
	                            case 5:
	                            case 'end':
	                                return _context6.stop();
	                        }
	                    }
	                }, _callee6, this);
	            }));
	
	            function getboe() {
	                return _ref6.apply(this, arguments);
	            }
	
	            return getboe;
	        }()
	    }, {
	        key: 'getlang',
	        value: function () {
	            var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee7() {
	                var response;
	                return _regenerator2.default.wrap(function _callee7$(_context7) {
	                    while (1) {
	                        switch (_context7.prev = _context7.next) {
	                            case 0:
	                                _context7.next = 2;
	                                return _FetchCall2.default.getSubCategory('101');
	
	                            case 2:
	                                response = _context7.sent;
	
	                                if (response) {
	                                    this.setState({ languageList: response.results });
	                                }
	
	                            case 4:
	                            case 'end':
	                                return _context7.stop();
	                        }
	                    }
	                }, _callee7, this);
	            }));
	
	            function getlang() {
	                return _ref7.apply(this, arguments);
	            }
	
	            return getlang;
	        }()
	    }, {
	        key: 'getclass_frequency',
	        value: function () {
	            var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee8() {
	                var response;
	                return _regenerator2.default.wrap(function _callee8$(_context8) {
	                    while (1) {
	                        switch (_context8.prev = _context8.next) {
	                            case 0:
	                                _context8.next = 2;
	                                return _FetchCall2.default.getSchoolListDatas('class_frequency');
	
	                            case 2:
	                                response = _context8.sent;
	
	                                if (response) {
	                                    this.setState({ ClassList: response.results });
	                                }
	
	                            case 4:
	                            case 'end':
	                                return _context8.stop();
	                        }
	                    }
	                }, _callee8, this);
	            }));
	
	            function getclass_frequency() {
	                return _ref8.apply(this, arguments);
	            }
	
	            return getclass_frequency;
	        }()
	    }, {
	        key: 'getTuitionCls',
	        value: function () {
	            var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee9() {
	                var response;
	                return _regenerator2.default.wrap(function _callee9$(_context9) {
	                    while (1) {
	                        switch (_context9.prev = _context9.next) {
	                            case 0:
	                                _context9.next = 2;
	                                return _FetchCall2.default.getSchoolListDatas('tuition_cls');
	
	                            case 2:
	                                response = _context9.sent;
	
	                                if (response) {
	                                    this.setState({ getTuitionCls: response.results });
	                                }
	
	                            case 4:
	                            case 'end':
	                                return _context9.stop();
	                        }
	                    }
	                }, _callee9, this);
	            }));
	
	            function getTuitionCls() {
	                return _ref9.apply(this, arguments);
	            }
	
	            return getTuitionCls;
	        }()
	    }, {
	        key: 'getschool_type',
	        value: function () {
	            var _ref10 = _asyncToGenerator(_regenerator2.default.mark(function _callee10() {
	                var response;
	                return _regenerator2.default.wrap(function _callee10$(_context10) {
	                    while (1) {
	                        switch (_context10.prev = _context10.next) {
	                            case 0:
	                                _context10.next = 2;
	                                return _FetchCall2.default.getSchoolListDatas('school_type');
	
	                            case 2:
	                                response = _context10.sent;
	
	                                console.log(response);
	                                if (response) {
	                                    this.setState({ schooltypeList: response.results });
	                                }
	
	                            case 5:
	                            case 'end':
	                                return _context10.stop();
	                        }
	                    }
	                }, _callee10, this);
	            }));
	
	            function getschool_type() {
	                return _ref10.apply(this, arguments);
	            }
	
	            return getschool_type;
	        }()
	    }, {
	        key: 'getpayment_type',
	        value: function () {
	            var _ref11 = _asyncToGenerator(_regenerator2.default.mark(function _callee11() {
	                var response;
	                return _regenerator2.default.wrap(function _callee11$(_context11) {
	                    while (1) {
	                        switch (_context11.prev = _context11.next) {
	                            case 0:
	                                _context11.next = 2;
	                                return _FetchCall2.default.getSchoolListDatas('payment_type');
	
	                            case 2:
	                                response = _context11.sent;
	
	                                console.log(response);
	                                if (response) {
	                                    this.setState({ mopList: response.results });
	                                }
	
	                            case 5:
	                            case 'end':
	                                return _context11.stop();
	                        }
	                    }
	                }, _callee11, this);
	            }));
	
	            function getpayment_type() {
	                return _ref11.apply(this, arguments);
	            }
	
	            return getpayment_type;
	        }()
	    }, {
	        key: 'UNSAFE_componentWillMount',
	        value: function UNSAFE_componentWillMount() {}
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            window.jQuery('.selectpicker').selectpicker('refresh');
	        }
	    }, {
	        key: 'Geocode_location',
	        value: function Geocode_location() {
	            var _this3 = this;
	
	            var location = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	            _reactGeocode2.default.fromAddress(location ? location : this.state.google_location).then(function (response) {
	                var _response$results$0$g = response.results[0].geometry.location,
	                    lat = _response$results$0$g.lat,
	                    lng = _response$results$0$g.lng;
	
	                if (lat && lng) _this3.get_location(lat, lng);
	            }, function (error) {
	                console.error(error);
	            });
	        }
	    }, {
	        key: 'get_location',
	        value: function get_location(lat, lng) {
	            this.setState({
	                latitude: lat,
	                longitude: lng
	            });
	        }
	    }, {
	        key: 'remove_img',
	        value: function remove_img() {
	            (0, _jquery2.default)('#edit_image').remove();
	        }
	    }, {
	        key: 'loadFile',
	        value: function loadFile(e) {
	            var files = e.target.files;
	            this.setState({ attachment_file_length: files.length });
	            if (files.length > 0) {
	                (0, _jquery2.default)('.upload-space').addClass('hide');
	                (0, _jquery2.default)('.upload-thumb').removeClass('hide');
	                var fileArra = this.state.attachment_file;
	
	                //console.log('fileArra',fileArra)
	                //var fileThumbArra = this.state.imgThumb;
	                for (var i = 0; i < files.length; i++) {
	                    fileArra.push(e.target.files[i]);
	                    this.setState({
	                        selectedFile: URL.createObjectURL(e.target.files[i]),
	                        attachment_file: fileArra
	                    });
	                }
	                //   this.clearValidationErr('attachment_file');
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this4 = this;
	
	            var _state = this.state,
	                edited_data = _state.edited_data,
	                edited = _state.edited;
	
	            var languages = this.state.languages;
	            this.validator.purgeFields();
	
	            return _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _react2.default.createElement(
	                    _layout2.default,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { 'class': 'col-lg-12 grid-margin stretch-card' },
	                        _react2.default.createElement(
	                            'div',
	                            { 'class': 'card' },
	                            _react2.default.createElement(
	                                'div',
	                                { 'class': 'card-body' },
	                                _react2.default.createElement(
	                                    'h4',
	                                    { 'class': 'card-title' },
	                                    'Tuition Info Management'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'row' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'content-sec col-md-12 col-xs-12 pad-no mar-t-no' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: '' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { id: 'company-info', className: 'tab-pane active' },
	                                                _react2.default.createElement(
	                                                    'form',
	                                                    { onSubmit: this.handlePreview, className: 'custom-form invoice-form col-md-12 col-xs-12 legend-form pad-no' },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'box-shadow-custom' },
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'row' },
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    null,
	                                                                    'Partner Type',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    { className: 'custom-select-drop dropdown' },
	                                                                    _react2.default.createElement(
	                                                                        'select',
	                                                                        {
	                                                                            value: this.state.partner_type,
	                                                                            onChange: this.handleSelect, className: 'form-control selectpicker',
	                                                                            name: 'partner_type',
	                                                                            title: 'Select' },
	                                                                        _react2.default.createElement(
	                                                                            'option',
	                                                                            { value: '1' },
	                                                                            'Institution'
	                                                                        ),
	                                                                        _react2.default.createElement(
	                                                                            'option',
	                                                                            { value: '2' },
	                                                                            'Individuals'
	                                                                        )
	                                                                    ),
	                                                                    this.validator.message('Type', this.state.partner_type, 'required', { className: 'text-danger' })
	                                                                )
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.registration_no !== this.state.registration_no && 'edited-field' },
	                                                                    'Registration No ',
	                                                                    this.state.user_type === 1 && _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('input', { type: 'text',
	
	                                                                    value: this.state.registration_no,
	                                                                    onChange: this.handleChange,
	                                                                    name: 'registration_no', className: 'form-control' }),
	                                                                this.state.user_type === 1 && this.validator.message('Registration No', this.state.registration_no, 'required', { className: 'text-danger' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.owner_name !== this.state.ownerName && 'edited-field' },
	                                                                    'Owner Name  ',
	                                                                    this.state.user_type === 1 && _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('input', { type: 'text',
	
	                                                                    value: this.state.owner_name,
	                                                                    onChange: this.handleChange,
	                                                                    name: 'owner_name', className: 'form-control' }),
	                                                                this.state.user_type === 1 && this.validator.message('Owner Name', this.state.ownerName, 'required', { className: 'text-danger' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.tution_name !== this.state.tution_name && 'edited-field' },
	                                                                    'Organization Name',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('input', { type: 'text',
	
	                                                                    value: this.state.tution_name,
	                                                                    onChange: this.handleChange,
	                                                                    name: 'tution_name', className: 'form-control' }),
	                                                                this.validator.message('Organization Name', this.state.tution_name, 'required', { className: 'text-danger' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.incharge_name !== this.state.tutor_name && 'edited-field' },
	                                                                    'Incharge Name ',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('input', { type: 'text',
	
	                                                                    value: this.state.tutor_name,
	                                                                    onChange: this.handleChange,
	                                                                    name: 'tutor_name', className: 'form-control' }),
	                                                                this.validator.message('Incharge Name', this.state.tutor_name, 'required', { className: 'text-danger' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.sub_categories !== this.state.subject && 'edited-field' },
	                                                                    'Subject',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    { className: 'custom-select-drop dropdown' },
	                                                                    _react2.default.createElement(
	                                                                        'select',
	                                                                        {
	                                                                            value: this.state.subject,
	                                                                            onChange: this.handleSelect,
	                                                                            multiple: true,
	                                                                            className: 'form-control selectpicker', name: 'subject', title: 'Select' },
	                                                                        this.state.subjectList.length > 0 && this.state.subjectList.map(function (item, i) {
	                                                                            return _react2.default.createElement(
	                                                                                'option',
	                                                                                { value: item.category_id },
	                                                                                item.category_name
	                                                                            );
	                                                                        })
	                                                                    ),
	                                                                    this.validator.message('Subject', this.state.subject, 'required', { className: 'text-danger' })
	                                                                )
	                                                            ),
	                                                            languages === true && _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.languages !== this.state.languages_ && 'edited-field' },
	                                                                    'Languages',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    { className: 'custom-select-drop dropdown' },
	                                                                    _react2.default.createElement(
	                                                                        'select',
	                                                                        {
	                                                                            value: this.state.languages_,
	                                                                            onChange: this.handleSelect,
	                                                                            multiple: true,
	                                                                            className: 'form-control selectpicker',
	                                                                            name: 'languages_',
	                                                                            title: 'Select' },
	                                                                        this.state.languageList.length > 0 && this.state.languageList.map(function (item, i) {
	                                                                            return _react2.default.createElement(
	                                                                                'option',
	                                                                                { value: item.category_id },
	                                                                                item.category_name
	                                                                            );
	                                                                        })
	                                                                    ),
	                                                                    this.validator.message('Languages', this.state.languages_, 'required', { className: 'text-danger' })
	                                                                )
	                                                            )
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'box-shadow-custom' },
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'row' },
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'col-md-12 col-xs-12' },
	                                                                _react2.default.createElement(
	                                                                    'span',
	                                                                    { className: 'form-legend' },
	                                                                    'Address Information'
	                                                                )
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.email_id !== this.state.email_id && 'edited-field' },
	                                                                    'Email Id',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('input', { type: 'text',
	                                                                    value: this.state.email_id,
	                                                                    onChange: this.handleChange,
	                                                                    name: 'email_id', className: 'form-control', required: true }),
	                                                                this.validator.message('Email Id', this.state.email_id, 'emailExist_check', { className: 'text-danger' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.phone_number !== this.state.phone_number && 'edited-field' },
	                                                                    'Phone Number',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('input', { type: 'text',
	                                                                    value: this.state.phone_number,
	                                                                    onChange: this.handleChange, name: 'phone_number', className: 'form-control', required: true }),
	                                                                this.validator.message('Phone Number', this.state.phone_number, '', { className: 'text-danger' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.landline_number !== this.state.landline_number && 'edited-field' },
	                                                                    'Landline Number',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('input', { type: 'text',
	                                                                    value: this.state.landline_number,
	                                                                    onChange: this.handleChange, name: 'landline_number', className: 'form-control' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.website !== this.state.website && 'edited-field' },
	                                                                    'Website',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('input', { type: 'text',
	                                                                    value: this.state.website,
	                                                                    onChange: this.handleChange, name: 'website', className: 'form-control' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.state !== this.state.state && 'edited-field' },
	                                                                    'State',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('input', { type: 'text',
	                                                                    value: this.state.state,
	                                                                    onChange: this.handleChange, name: 'state', className: 'form-control' }),
	                                                                this.validator.message('State', this.state.state, 'required', { className: 'text-danger' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.state !== this.state.state && 'edited-field' },
	                                                                    'Location',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'select',
	                                                                    {
	                                                                        name: 'location',
	                                                                        id: 'location',
	                                                                        onChange: this.handleSelect,
	                                                                        value: this.state.location,
	                                                                        className: 'form-control selectpicker',
	                                                                        title: 'Select'
	                                                                    },
	                                                                    this.state.location_list.length > 0 && this.state.location_list.map(function (item, i) {
	                                                                        return _react2.default.createElement(
	                                                                            'option',
	                                                                            { value: item.location },
	                                                                            item.location
	                                                                        );
	                                                                    })
	                                                                ),
	                                                                this.validator.message('Location', this.state.location, 'required', { className: 'text-danger' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.pincode !== this.state.pincode && 'edited-field' },
	                                                                    'Pincode',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('input', { type: 'text',
	                                                                    value: this.state.pincode,
	                                                                    onChange: this.handleChange, name: 'pincode', className: 'form-control' }),
	                                                                this.validator.message('Pincode', this.state.pincode, 'required', { className: 'text-danger' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.address !== this.state.address && 'edited-field' },
	                                                                    'Address',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('input', { type: 'text',
	                                                                    value: this.state.address,
	                                                                    onChange: this.handleChange, name: 'address', className: 'form-control' }),
	                                                                this.validator.message('Address', this.state.address, 'required', { className: 'text-danger' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.google_location !== this.state.google_location && 'edited-field' },
	                                                                    'Google Location Address',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('input', { type: 'text',
	                                                                    value: this.state.google_location,
	                                                                    onChange: this.handleChange, name: 'google_location', className: 'form-control' }),
	                                                                this.validator.message('Google Location', this.state.google_location, 'required', { className: 'text-danger' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.latitude !== this.state.latitude && 'edited-field' },
	                                                                    'Latitude',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('input', {
	                                                                    type: 'text',
	                                                                    name: 'latitude',
	                                                                    value: this.state.latitude,
	                                                                    onChange: this.handleChange,
	
	                                                                    className: 'form-control'
	                                                                }),
	                                                                this.validator.message('Latitude', this.state.latitude, 'required', { className: 'text-danger' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.longitude !== this.state.longitude && 'edited-field' },
	                                                                    'Longitude',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('input', {
	                                                                    type: 'text',
	                                                                    name: 'longitude',
	                                                                    value: this.state.longitude,
	                                                                    onChange: this.handleChange,
	
	                                                                    className: 'form-control'
	                                                                }),
	                                                                this.validator.message('Longitude', this.state.longitude, 'required', { className: 'text-danger' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.other_rating !== this.state.other_rating && 'edited-field' },
	                                                                    'Google Rating',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('input', {
	                                                                    type: 'number',
	                                                                    step: '0.01',
	                                                                    name: 'other_rating',
	                                                                    value: this.state.other_rating,
	                                                                    onChange: this.handleChange,
	                                                                    max: '5',
	                                                                    className: 'form-control'
	                                                                }),
	                                                                this.validator.message('Google Rating', this.state.other_rating, 'required', { className: 'text-danger' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-12' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.about !== this.state.about_tution && 'edited-field' },
	                                                                    'About the Tution',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('textarea', { type: 'text',
	                                                                    value: this.state.about_tution,
	                                                                    onChange: this.handleChange, name: 'about_tution', className: 'form-control' }),
	                                                                this.validator.message('About', this.state.about_tution, 'required', { className: 'text-danger' })
	                                                            )
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'box-shadow-custom' },
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'row' },
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'col-md-12 col-xs-12' },
	                                                                _react2.default.createElement(
	                                                                    'span',
	                                                                    { className: 'form-legend' },
	                                                                    'Key Information'
	                                                                )
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.tution_type !== this.state.tution_type && 'edited-field' },
	                                                                    'Tution Type',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    { className: 'custom-select-drop dropdown' },
	                                                                    _react2.default.createElement(
	                                                                        'select',
	                                                                        {
	                                                                            value: this.state.tution_type,
	                                                                            multiple: true,
	                                                                            onChange: this.handleSelect, className: 'form-control selectpicker',
	                                                                            name: 'tution_type', title: 'Select' },
	                                                                        this.state.tutionList.length > 0 && this.state.tutionList.map(function (item, i) {
	                                                                            return _react2.default.createElement(
	                                                                                'option',
	                                                                                { value: item.id },
	                                                                                item.name
	                                                                            );
	                                                                        })
	                                                                    ),
	                                                                    this.validator.message('Tution Type', this.state.tution_type, 'required', { className: 'text-danger' })
	                                                                )
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.bof !== this.state.board_of_education && 'edited-field' },
	                                                                    'Board Of Education',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    { className: 'custom-select-drop dropdown' },
	                                                                    _react2.default.createElement(
	                                                                        'select',
	                                                                        {
	                                                                            value: this.state.board_of_education,
	                                                                            onChange: this.handleSelect, className: 'form-control selectpicker',
	                                                                            name: 'board_of_education', multiple: true, title: 'Select' },
	                                                                        this.state.boeList.length > 0 && this.state.boeList.map(function (item, i) {
	                                                                            return _react2.default.createElement(
	                                                                                'option',
	                                                                                { value: item.id },
	                                                                                item.name
	                                                                            );
	                                                                        })
	                                                                    ),
	                                                                    this.validator.message('Board Of Education', this.state.board_of_education, 'required', { className: 'text-danger' })
	                                                                )
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.class_freq !== this.state.class_frequency && 'edited-field' },
	                                                                    'Class Frequency',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    { className: 'custom-select-drop dropdown' },
	                                                                    _react2.default.createElement(
	                                                                        'select',
	                                                                        {
	                                                                            multiple: true,
	                                                                            value: this.state.class_frequency,
	                                                                            onChange: this.handleSelect, className: 'form-control selectpicker',
	                                                                            name: 'class_frequency', title: 'Select' },
	                                                                        this.state.ClassList.length > 0 && this.state.ClassList.map(function (item, i) {
	                                                                            return _react2.default.createElement(
	                                                                                'option',
	                                                                                { value: item.id },
	                                                                                item.freq_name
	                                                                            );
	                                                                        })
	                                                                    ),
	                                                                    this.validator.message('Class Frequency', this.state.class_frequency, 'required', { className: 'text-danger' })
	                                                                )
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.class_range !== this.state.class_range && 'edited-field' },
	                                                                    'Class Range',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'select',
	                                                                    { className: 'form-control selectpicker', title: 'Select Class Range', multiple: true,
	                                                                        value: this.state.class_range, name: 'class_range',
	                                                                        onChange: this.handleSelect },
	                                                                    this.state.getTuitionCls.map(function (item, i) {
	                                                                        return _react2.default.createElement(
	                                                                            'option',
	                                                                            { value: item.id },
	                                                                            item.name
	                                                                        );
	                                                                    })
	                                                                ),
	                                                                this.validator.message('Class Range', this.state.class_range, 'required', { className: 'text-danger' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.no_teacher !== this.state.number_of_teachers && 'edited-field' },
	                                                                    'Number of Teachers',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('input', { type: 'text',
	                                                                    value: this.state.number_of_teachers,
	                                                                    onChange: this.handleChange, className: 'form-control', name: 'number_of_teachers' }),
	                                                                this.validator.message('Number of Teachers', this.state.number_of_teachers, 'required', { className: 'text-danger' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.instruction_lang !== this.state.instruction_lang && 'edited-field' },
	                                                                    'Instruction Language'
	                                                                ),
	                                                                _react2.default.createElement('input', { type: 'text',
	                                                                    value: this.state.instruction_lang,
	                                                                    onChange: this.handleChange, name: 'instruction_lang', className: 'form-control' }),
	                                                                this.validator.message('Instruction Language', this.state.instruction_lang, 'required', { className: 'text-danger' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4 input-group-cus' },
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    null,
	                                                                    _react2.default.createElement(
	                                                                        'label',
	                                                                        {
	                                                                            className: edited && (edited_data.from_time !== this.state.from_time || edited_data.from_time_cate !== this.state.from_time_cate) && 'edited-field' },
	                                                                        'From Timing'
	                                                                    ),
	                                                                    _react2.default.createElement(
	                                                                        'div',
	                                                                        { className: 'custom-select-drop dropdown' },
	                                                                        _react2.default.createElement(
	                                                                            'select',
	                                                                            {
	                                                                                className: 'form-control selectpicker',
	                                                                                onChange: this.handleSelect,
	                                                                                value: this.state.from_time,
	                                                                                name: 'from_time',
	                                                                                title: 'Select'
	                                                                            },
	                                                                            this.state.timingList.length > 0 && this.state.timingList.map(function (item, i) {
	                                                                                return _react2.default.createElement(
	                                                                                    'option',
	                                                                                    { value: item.id },
	                                                                                    item.timing
	                                                                                );
	                                                                            })
	                                                                        ),
	                                                                        this.validator.message('Timing', this.state.from_time, 'required', { className: 'text-danger' })
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    null,
	                                                                    _react2.default.createElement(
	                                                                        'label',
	                                                                        null,
	                                                                        '\xA0'
	                                                                    ),
	                                                                    _react2.default.createElement(
	                                                                        'div',
	                                                                        { className: 'custom-select-drop dropdown' },
	                                                                        _react2.default.createElement(
	                                                                            'select',
	                                                                            {
	                                                                                className: 'form-control selectpicker',
	                                                                                onChange: this.handleSelect,
	                                                                                value: this.state.from_time_cate,
	                                                                                name: 'from_time_cate'
	                                                                            },
	                                                                            _react2.default.createElement(
	                                                                                'option',
	                                                                                { value: 'AM' },
	                                                                                'AM'
	                                                                            ),
	                                                                            _react2.default.createElement(
	                                                                                'option',
	                                                                                { value: 'PM' },
	                                                                                'PM'
	                                                                            )
	                                                                        )
	                                                                    )
	                                                                )
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4 input-group-cus' },
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    null,
	                                                                    _react2.default.createElement(
	                                                                        'label',
	                                                                        {
	                                                                            className: edited && (edited_data.to_time !== this.state.to_time || edited_data.to_time_cate !== this.state.to_time_cate) && 'edited-field' },
	                                                                        'To Timing'
	                                                                    ),
	                                                                    _react2.default.createElement(
	                                                                        'div',
	                                                                        { className: 'custom-select-drop dropdown' },
	                                                                        _react2.default.createElement(
	                                                                            'select',
	                                                                            {
	                                                                                className: 'form-control selectpicker',
	                                                                                onChange: this.handleSelect,
	                                                                                value: this.state.to_time,
	                                                                                name: 'to_time',
	                                                                                title: 'Select'
	                                                                            },
	                                                                            this.state.timingList.length > 0 && this.state.timingList.map(function (item, i) {
	                                                                                return _react2.default.createElement(
	                                                                                    'option',
	                                                                                    { value: item.id },
	                                                                                    item.timing
	                                                                                );
	                                                                            })
	                                                                        ),
	                                                                        this.validator.message('Timing', this.state.to_time, 'required', { className: 'text-danger' })
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    null,
	                                                                    _react2.default.createElement(
	                                                                        'label',
	                                                                        null,
	                                                                        '\xA0'
	                                                                    ),
	                                                                    _react2.default.createElement(
	                                                                        'div',
	                                                                        { className: 'custom-select-drop dropdown' },
	                                                                        _react2.default.createElement(
	                                                                            'select',
	                                                                            {
	                                                                                className: 'form-control selectpicker',
	                                                                                onChange: this.handleSelect,
	                                                                                value: this.state.to_time_cate,
	                                                                                name: 'to_time_cate'
	                                                                            },
	                                                                            _react2.default.createElement(
	                                                                                'option',
	                                                                                { value: 'AM' },
	                                                                                'AM'
	                                                                            ),
	                                                                            _react2.default.createElement(
	                                                                                'option',
	                                                                                { value: 'PM' },
	                                                                                'PM'
	                                                                            )
	                                                                        )
	                                                                    )
	                                                                )
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.est_year !== this.state.establishment_Year && 'edited-field' },
	                                                                    'Establishment Year ',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('input', { type: 'text',
	                                                                    value: this.state.establishment_Year,
	                                                                    onChange: this.handleChange, name: 'establishment_Year', className: 'form-control' }),
	                                                                this.validator.message('Establishment Year', this.state.establishment_Year, '', { className: 'text-danger' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.avg_fee !== this.state.avg_anual_fee && 'edited-field' },
	                                                                    'Average Fees(INR) ',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('input', { type: 'text',
	                                                                    value: this.state.avg_anual_fee,
	                                                                    onChange: this.handleChange, name: 'avg_anual_fee', className: 'form-control' }),
	                                                                this.validator.message('Average Fees', this.state.avg_anual_fee, 'required', { className: 'text-danger' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.admit_fee !== this.state.addmission_fee && 'edited-field' },
	                                                                    'Admission Fees ',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('input', { type: 'text',
	                                                                    value: this.state.addmission_fee,
	                                                                    onChange: this.handleChange, name: 'addmission_fee', className: 'form-control' }),
	                                                                this.validator.message('Admission Fees', this.state.addmission_fee, 'required', { className: 'text-danger' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.std_ratio !== this.state.std_ratio && 'edited-field' },
	                                                                    'Student Ratio',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    { className: 'custom-select-drop dropdown' },
	                                                                    _react2.default.createElement(
	                                                                        'select',
	                                                                        {
	                                                                            value: this.state.std_ratio,
	                                                                            name: 'std_ratio',
	                                                                            id: 'std_ratio',
	                                                                            onChange: this.handleSelect,
	                                                                            className: 'form-control selectpicker',
	                                                                            multiple: true,
	                                                                            title: 'Select'
	                                                                        },
	                                                                        _react2.default.createElement(
	                                                                            'option',
	                                                                            { value: '1' },
	                                                                            'One to One'
	                                                                        ),
	                                                                        _react2.default.createElement(
	                                                                            'option',
	                                                                            { value: '2' },
	                                                                            'One to Many'
	                                                                        ),
	                                                                        _react2.default.createElement(
	                                                                            'option',
	                                                                            { value: '3' },
	                                                                            'NA'
	                                                                        )
	                                                                    ),
	                                                                    this.validator.message('Student Ratio', this.state.std_ratio, 'required', { className: 'text-danger' })
	                                                                )
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { 'class': 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.has_trail !== this.state.has_trail && 'edited-field' },
	                                                                    'Is Free Trial Available? ',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { 'class': 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'select',
	                                                                    {
	                                                                        className: 'form-control selectpicker',
	                                                                        name: 'has_trail',
	                                                                        value: this.state.has_trail,
	                                                                        title: 'Select',
	                                                                        onChange: this.handleSelect },
	                                                                    _react2.default.createElement(
	                                                                        'option',
	                                                                        { value: '0' },
	                                                                        'NA'
	                                                                    ),
	                                                                    _react2.default.createElement(
	                                                                        'option',
	                                                                        { value: '1' },
	                                                                        'Yes'
	                                                                    ),
	                                                                    _react2.default.createElement(
	                                                                        'option',
	                                                                        { value: '2' },
	                                                                        'No'
	                                                                    )
	                                                                ),
	                                                                this.validator.message('Free Trial', this.state.has_trail, 'required', { className: 'text-danger error-msg' })
	                                                            ),
	                                                            this.state.has_trail === 1 && _react2.default.createElement(
	                                                                'div',
	                                                                { 'class': 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.trail_desc !== this.state.trail_desc && 'edited-field' },
	                                                                    'Free Trial Description ',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { 'class': 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('textarea', { className: 'form-control', name: 'trail_desc', onChange: this.handleChange, value: this.state.trail_desc }),
	                                                                this.validator.message('Free Trial Descrption', this.state.trail_desc, 'required', { className: 'text-danger error-msg' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.keywords !== this.state.keywords && 'edited-field' },
	                                                                    'Keywords',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement(_multiselectReactDropdown.Multiselect, {
	                                                                    isObject: false,
	                                                                    options: this.state.keywordsArr // Options to display in the dropdown
	                                                                    , selectedValues: this.state.keywords // Preselected value to persist in dropdown
	                                                                    , onSelect: this.onSelect // Function will trigger on select event
	                                                                    , onRemove: this.onRemove // Function will trigger on remove event
	                                                                })
	                                                            )
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'box-shadow-custom' },
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'row' },
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'col-md-12 col-xs-12' },
	                                                                _react2.default.createElement(
	                                                                    'span',
	                                                                    { className: 'form-legend' },
	                                                                    'Images'
	                                                                )
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'form-group col-md-4' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.images !== this.state.images && 'edited-field' },
	                                                                    'Banner Image ',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement('input', {
	                                                                    type: 'file',
	                                                                    name: 'images',
	                                                                    onChange: this.handleFile,
	                                                                    className: 'form-control'
	                                                                }),
	                                                                this.validator.message('Banner Image', this.state.images, '', { className: 'text-danger error-msg' })
	                                                            ),
	                                                            (this.state.edit_image !== '' || this.state.tempBanner !== '') && _react2.default.createElement(
	                                                                'div',
	                                                                { 'class': 'col-md-2 col-sm-12 mar-btm', id: 'edit_image' },
	                                                                _react2.default.createElement('img', { src: this.state.tempBanner ? this.state.tempBanner : this.state.edit_image, alt: 'Img', 'class': 'img-thumbnail' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { 'class': 'col-md-12 float-left mt-4 p-0' },
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    {
	                                                                        className: edited && edited_data.photos !== this.state.photos && 'edited-field' },
	                                                                    'Gallery Images ',
	                                                                    _react2.default.createElement(
	                                                                        'span',
	                                                                        { className: 'astrick' },
	                                                                        '*'
	                                                                    )
	                                                                )
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { 'class': 'col-md-12 float-left mt-4 p-0' },
	                                                                _react2.default.createElement(
	                                                                    'div',
	                                                                    { 'class': 'col-md-12 margin-bottom-mobile-account float-left image-upload' },
	                                                                    _react2.default.createElement(
	                                                                        'div',
	                                                                        { className: 'upload-wizard' },
	                                                                        _react2.default.createElement(
	                                                                            'div',
	                                                                            { className: 'upload-thumb' },
	                                                                            _react2.default.createElement(
	                                                                                'ul',
	                                                                                { className: 'list-inline' },
	                                                                                this.state.attachment_file.map(function (file_data, index) {
	
	                                                                                    var file_url;
	                                                                                    if (file_data.name) {
	                                                                                        var url = file_data.image_thumb ? file_data.image_thumb : '';
	                                                                                        if (url !== '') {
	                                                                                            file_url = file_data.image_thumb;
	                                                                                        } else {
	                                                                                            file_url = URL.createObjectURL(file_data);
	                                                                                        }
	                                                                                        // var file_url = URL.createObjectURL(file_data)
	                                                                                        // var file_name = file_data.name
	                                                                                        if (file_data.type === 'application/pdf') {
	                                                                                            return _react2.default.createElement(
	                                                                                                'li',
	                                                                                                { className: 'previewImg' },
	                                                                                                _react2.default.createElement(
	                                                                                                    'div',
	                                                                                                    { className: 'thumb-img' },
	                                                                                                    _react2.default.createElement('img', {
	                                                                                                        src: file_url,
	                                                                                                        alt: 'preview',
	                                                                                                        title: file_data.name
	                                                                                                    })
	                                                                                                ),
	                                                                                                _react2.default.createElement(
	                                                                                                    'a',
	                                                                                                    { href: 'javascript:;', className: 'del-btn', onClick: function onClick() {
	                                                                                                            _this4.removeImage(file_data.name);
	                                                                                                        } },
	                                                                                                    _react2.default.createElement('img', {
	                                                                                                        src: '../assets/images/close-icon-white.svg',
	                                                                                                        alt: 'delete'
	                                                                                                    })
	                                                                                                )
	                                                                                            );
	                                                                                        } else {
	                                                                                            return _react2.default.createElement(
	                                                                                                'li',
	                                                                                                { className: 'previewImg' },
	                                                                                                _react2.default.createElement(
	                                                                                                    'div',
	                                                                                                    { className: 'thumb-img' },
	                                                                                                    _react2.default.createElement('img', {
	                                                                                                        src: file_url,
	                                                                                                        alt: 'preview',
	                                                                                                        title: file_data.name
	                                                                                                    })
	                                                                                                ),
	                                                                                                _react2.default.createElement(
	                                                                                                    'a',
	                                                                                                    {
	                                                                                                        href: 'javascript:;',
	                                                                                                        className: 'del-btn',
	                                                                                                        onClick: function onClick() {
	                                                                                                            _this4.removeImage(file_data.name);
	                                                                                                        }
	                                                                                                    },
	                                                                                                    _react2.default.createElement('img', {
	                                                                                                        src: '../assets/images/close-icon-white.svg',
	                                                                                                        alt: 'delete'
	                                                                                                    })
	                                                                                                )
	                                                                                            );
	                                                                                        }
	                                                                                    }
	                                                                                    return;
	                                                                                }),
	                                                                                _react2.default.createElement(
	                                                                                    'li',
	                                                                                    { className: 'addMore' },
	                                                                                    _react2.default.createElement('input', {
	                                                                                        type: 'file',
	                                                                                        name: 'imgInp[]',
	                                                                                        id: 'imgInp2',
	                                                                                        className: 'add_img',
	                                                                                        multiple: true,
	                                                                                        onChange: this.loadFile.bind(this),
	                                                                                        accept: 'image/x-png,image/gif,image/jpeg'
	                                                                                    }),
	                                                                                    _react2.default.createElement(
	                                                                                        'a',
	                                                                                        { href: 'javascript:;', className: 'add-more' },
	                                                                                        _react2.default.createElement(
	                                                                                            'div',
	                                                                                            null,
	                                                                                            _react2.default.createElement('img', { src: '../assets/images/upload-icon.svg', alt: 'icon' }),
	                                                                                            'Add more'
	                                                                                        )
	                                                                                    )
	                                                                                )
	                                                                            )
	                                                                        )
	                                                                    )
	                                                                )
	                                                            )
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'col-md-12 col-xs-12 btn-bdr' },
	                                                        _react2.default.createElement(
	                                                            'button',
	                                                            { className: 'btn btn-primary btn-sm' },
	                                                            'Preview'
	                                                        )
	                                                    )
	                                                )
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    this.preview()
	                )
	            );
	        }
	    }]);
	
	    return verticalTuitionEdit;
	}(_react.Component);
	
	exports.default = verticalTuitionEdit;

/***/ },
/* 1041 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _reactJsPagination = __webpack_require__(33);
	
	var _reactJsPagination2 = _interopRequireDefault(_reactJsPagination);
	
	var _bewiseloading = __webpack_require__(48);
	
	var _bewiseloading2 = _interopRequireDefault(_bewiseloading);
	
	__webpack_require__(18);
	
	var _reactNotifications = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var verticalTuitions = function (_Component) {
	  _inherits(verticalTuitions, _Component);
	
	  function verticalTuitions(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, verticalTuitions);
	
	    var _this = _possibleConstructorReturn(this, (verticalTuitions.__proto__ || Object.getPrototypeOf(verticalTuitions)).call(this, props));
	
	    _this.getTotal = function () {
	      var location = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	
	      var locationselected = location === '' ? _this.state.location : location;
	
	      var ins = JSON.stringify({
	        vertical: _this.state.tablename,
	        location: locationselected,
	        searchby: _this.state.searchby
	      });
	
	      (0, _FetchCall.getTotal)(ins).then(function (res) {
	
	        _this.setState({ loading: true });
	
	        if (res.status === 1) {
	
	          _this.setState({
	
	            total: res.total
	
	          });
	        }
	      });
	    };
	
	    _this.getList = function () {
	      var pageNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	      var location = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	      var _this$state$auth_data = _this.state.auth_data,
	          login_id = _this$state$auth_data.login_id,
	          role = _this$state$auth_data.role;
	
	
	      _this.setState({ activePage: pageNumber });
	
	      var newOffset = pageNumber === 1 ? 0 : pageNumber * _this.state.PER_PAGE % _this.state.total;
	
	      var locationselected = location === '' ? _this.state.location : location;
	
	      var ins = JSON.stringify({
	        vendor_id: login_id,
	        role: role,
	        location: locationselected,
	        searchby: _this.state.searchby,
	        perpage: _this.state.PER_PAGE,
	        offset: newOffset
	      });
	
	      (0, _FetchCall.getTuitionsPaged)(ins).then(function (res) {
	
	        _this.setState({ loading: true });
	
	        if (res.status === 1) {
	
	          _this.setState({ loading: !_this.state.loading });
	
	          _this.setState({
	
	            tuitionList: res.data
	
	          });
	        } else {
	
	          _this.setState({ loading: !_this.state.loading });
	
	          _this.setState({
	            tuitionList: []
	          });
	        }
	      });
	    };
	
	    _this.handleSelect = function (e) {
	      _this.setState({ location: e.target.value, activePage: 1 });
	      localStorage.setItem("location", e.target.value);
	      //this.getTotal(e.target.value);
	      //this.getList(1, e.target.value);
	    };
	
	    _this.handleChange = function (e) {
	      _this.setState(_defineProperty({}, e.target.name, e.target.value));
	    };
	
	    _this.searchBy = function (e) {
	
	      _this.setState({ activePage: 1 });
	      _this.getTotal('bw_schools');
	      _this.getList(1);
	    };
	
	    _this.handleChangeCheckBox = function (event) {
	
	      _this.setState({ clickedbulkapproval: true });
	      var newArray = [].concat(_toConsumableArray(_this.state.toapprove), [event.target.value]);
	      if (_this.state.toapprove.includes(event.target.value)) {
	        newArray = newArray.filter(function (day) {
	          return day !== event.target.value;
	        });
	      }
	      _this.setState({
	        toapprove: newArray
	      });
	    };
	
	    _this.bulkApproval = function (e) {
	
	      console.log(_this.state.toapprove);
	
	      var ins = JSON.stringify({
	        vertical: 'tuitions',
	        ids: _this.state.toapprove
	      });
	
	      (0, _FetchCall.approveBulk)(ins).then(function (res) {
	
	        //console.log(res.message);
	        _reactNotifications.NotificationManager.success(res.message);
	      });
	    };
	
	    _this.schoolExport = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var req, res;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	
	              _this.setState({ exportbtndisabled: true, thisExportBtnText: "exporting..." });
	
	              _context.prev = 1;
	              req = JSON.stringify({
	                location: _this.state.location
	              });
	              _context.next = 5;
	              return (0, _FetchCall.exportSchool)(req);
	
	            case 5:
	              res = _context.sent;
	
	              if (res.status === 1) {
	
	                _this.setState({ exportbtndisabled: false, thisExportBtnText: "Export" });
	                console.log('location_list', res);
	                console.log('location_list', res.path);
	                window.open(res.path);
	
	                // this.setState({
	                //   subscribe_list: res.results,
	                // });
	              }
	
	              _context.next = 12;
	              break;
	
	            case 9:
	              _context.prev = 9;
	              _context.t0 = _context['catch'](1);
	
	              _this.setState({ error: true });
	
	            case 12:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2, [[1, 9]]);
	    }));
	
	
	    _this.state = {
	      logged: localStorage.getItem("authentication"),
	      auth_data: JSON.parse(localStorage.getItem("user_data")),
	      location: localStorage.getItem("location") ? localStorage.getItem("location") : 'Bengaluru',
	      tuitionList: [],
	      loading: true,
	      searchby: '',
	      activePage: 0,
	      tablename: 'bw_tutions',
	      PER_PAGE: 15,
	      offset: 0,
	      total: 0,
	      exportbtndisabled: false,
	      thisExportBtnText: 'Export',
	      clickedbulkapproval: false,
	      toapprove: []
	    };
	
	    _this.handleSelect = _this.handleSelect.bind(_this);
	    return _this;
	  }
	
	  _createClass(verticalTuitions, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	
	      var THIS = this;
	      (0, _jquery2.default)(document).on('click', '.remove_school', function () {
	        var delete_id = (0, _jquery2.default)(this).data("id");
	
	        if (confirm("You are sure to delete?") === true) {
	
	          var ins = JSON.stringify({
	            id: delete_id,
	            table: 'tutions'
	          });
	
	          (0, _FetchCall.removethisItem)(ins).then(function (res) {
	
	            THIS.getTotal();
	            THIS.getList();
	          });
	        }
	      });
	
	      this.getTotal('bw_tutions');
	      this.getList();
	    }
	  }, {
	    key: 'handlePageChange',
	    value: function handlePageChange(pageNumber) {
	      this.setState({ activePage: pageNumber });
	      this.getList(pageNumber);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          tuitionList = _state.tuitionList,
	          PER_PAGE = _state.PER_PAGE,
	          exportbtndisabled = _state.exportbtndisabled;
	
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'col-lg-12 grid-margin stretch-card' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card-body' },
	                _react2.default.createElement(
	                  'h4',
	                  { 'class': 'card-title' },
	                  'Tuitions'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'float-right' },
	                  _react2.default.createElement(
	                    'a',
	                    { href: '/vertical/tuition/add', 'class': 'btn btn-primary btn-sm' },
	                    'Add'
	                  ),
	                  ' \xA0',
	                  _react2.default.createElement(
	                    'button',
	                    { disabled: exportbtndisabled, 'class': 'btn btn-primary btn-sm', onClick: function onClick() {
	                        return _this3.schoolExport();
	                      } },
	                    this.state.thisExportBtnText
	                  ),
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'p',
	                  { 'class': 'card-description' },
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'cityselection' },
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'leftaligned bwlabel' },
	                      'City'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'leftaligned' },
	                      _react2.default.createElement(
	                        'select',
	                        { name: 'location', 'class': 'form-control', onChange: function onChange(e) {
	                            return _this3.handleSelect(e);
	                          },
	                          value: this.state.location },
	                        _react2.default.createElement(
	                          'option',
	                          { value: '' },
	                          'select city'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'Bengaluru' },
	                          'Bengaluru'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'Chennai' },
	                          'Chennai'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'Hyderabad' },
	                          'Hyderabad'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'Coimbatore' },
	                          'Coimbatore'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'Hosur' },
	                          'Hosur'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'Indore' },
	                          'Indore'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'Others' },
	                          'Others'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'leftaligned bwlabel' },
	                      'Search'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'leftaligned' },
	                      _react2.default.createElement('input', { type: 'text', name: 'searchby', 'class': 'form-control form-control-sm', onChange: this.handleChange })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'leftaligned' },
	                      _react2.default.createElement(
	                        'button',
	                        { 'class': 'btn btn-primary btn-sm', onClick: this.searchBy },
	                        'Go'
	                      )
	                    )
	                  )
	                ),
	                this.state.loading && _react2.default.createElement(
	                  'div',
	                  { id: 'loader' },
	                  _react2.default.createElement('img', { src: _bewiseloading2.default, width: '60px', alt: 'loader' })
	                ),
	                this.state.clickedbulkapproval && _react2.default.createElement(
	                  'div',
	                  { 'class': 'showbtnapproval' },
	                  _react2.default.createElement(
	                    'button',
	                    { onClick: this.bulkApproval, name: 'bulkapproval', 'class': 'btn btn-primary btn-sm' },
	                    'Approve selected schools'
	                  ),
	                  _react2.default.createElement('br', null)
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'table-responsive pt-3' },
	                  !this.state.loading && _react2.default.createElement(
	                    'table',
	                    { id: 'tablebw' },
	                    _react2.default.createElement(
	                      'thead',
	                      null,
	                      _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          'Select'
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'S.No'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Updated On'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'By'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Name'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'City'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Email Id'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Status'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Action'
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'tbody',
	                      null,
	                      tuitionList.map(function (item, i) {
	
	                        return _react2.default.createElement(
	                          'tr',
	                          null,
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            ' ',
	                            item.actualstatus === 0 && _react2.default.createElement('input', { type: 'checkbox', name: 'toapprove[]', value: item.id, onChange: _this3.handleChangeCheckBox })
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            i + 1
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.updated_date
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.updatedby
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.tution_name
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.location
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            item.email_id
	                          ),
	                          _react2.default.createElement('td', { dangerouslySetInnerHTML: { __html: item.status } }),
	                          _react2.default.createElement('td', { dangerouslySetInnerHTML: { __html: item.action }, 'class': 'actionbtns' })
	                        );
	                      })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'text-center' },
	                    _react2.default.createElement(_reactJsPagination2.default, {
	                      activePage: this.state.activePage,
	                      itemsCountPerPage: PER_PAGE,
	                      totalItemsCount: this.state.total,
	                      pageRangeDisplayed: 5,
	                      activeClass: "pagination__link--active",
	                      onChange: this.handlePageChange.bind(this),
	                      prevPageText: 'previous',
	                      nextPageText: 'next'
	                    })
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(_reactNotifications.NotificationContainer, null)
	        )
	      );
	    }
	  }]);
	
	  return verticalTuitions;
	}(_react.Component);
	
	exports.default = verticalTuitions;

/***/ },
/* 1042 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _FetchCall2 = _interopRequireDefault(_FetchCall);
	
	var _constant = __webpack_require__(21);
	
	var _reactGeocode = __webpack_require__(55);
	
	var _reactGeocode2 = _interopRequireDefault(_reactGeocode);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	__webpack_require__(18);
	
	var _reactNotifications = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	_reactGeocode2.default.setApiKey("AIzaSyA9MtbfG_zlo64B2lqNMvigTBuXHkagKcE");
	_reactGeocode2.default.setLanguage("en");
	_reactGeocode2.default.setRegion("es");
	_reactGeocode2.default.enableDebug();
	
	var cmsWebAds = function (_Component) {
	  _inherits(cmsWebAds, _Component);
	
	  function cmsWebAds(props) {
	    _classCallCheck(this, cmsWebAds);
	
	    var _this = _possibleConstructorReturn(this, (cmsWebAds.__proto__ || Object.getPrototypeOf(cmsWebAds)).call(this, props));
	
	    _this.handleChange = function (e) {
	      var propName = e.target.name;
	      _this.setState(_defineProperty({}, e.target.name, e.target.value));
	    };
	
	    _this.handleFileMultiple = function (e) {
	      var propName = e.target.name;
	      var files = e.target.files;
	      if (files.length > 3) {
	        files = '';
	        var toastr = window.toastr.error; //warning
	        toastr('', 'Select 3 Images Only', {
	          positionClass: "toast-bottom-right",
	          containerId: "toast-bottom-right"
	        });
	      }
	      _this.setState(_defineProperty({}, propName, files));
	    };
	
	    _this.onFileUploadBanner = function (event) {
	
	      var toastr = '';
	      // Details of the uploaded file
	      var formData = new FormData();
	      var banner_data = _this.state.adbanner;
	
	      for (var i = 0; i < banner_data.length; i++) {
	        formData.append('adbanner', banner_data[i]);
	      }
	
	      (0, _FetchCall.uploadOtherAd)(formData).then(function (response) {
	
	        if (response.status == 1) {
	
	          _reactNotifications.NotificationManager.success('Image uploaded');
	          _this.setState({ adbanner: response.files });
	        } else {
	          _reactNotifications.NotificationManager.error('Error in Image uploading');
	          //alert("Error in Image uploading");
	        }
	      });
	    };
	
	    _this.state = {
	      lead: "",
	      lead_data: [],
	      partnerlist: [],
	      ads: [],
	      created_date: "",
	      aid: '',
	      display_in: 'all',
	      display_mode: 'web',
	      display_position: 'R1',
	      adstatus: "1",
	      auth_data: JSON.parse(localStorage.getItem("user_data")),
	      user_data: localStorage.getItem('user_data') ? JSON.parse(localStorage.getItem('user_data')) : [],
	      authentication: localStorage.getItem('authentication') ? JSON.parse(localStorage.getItem('authentication')) : false
	    };
	
	    _this.onFileUploadBanner = _this.onFileUploadBanner.bind(_this);
	    _this.getOtherAds = _this.getOtherAds.bind(_this);
	    _this.removeAd = _this.removeAd.bind(_this);
	    return _this;
	  }
	
	  _createClass(cmsWebAds, [{
	    key: 'getOtherAds',
	    value: function getOtherAds() {
	      var _this2 = this;
	
	      (0, _FetchCall.getWebsiteAds)().then(function (response) {
	        if (response.status === 1) {
	          _this2.setState({
	            ads: response.list
	          });
	        } else {
	          _this2.setState({
	            ads: []
	          });
	        }
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	
	      var user_data = localStorage.getItem("user_data");
	      var auth_data = JSON.parse(user_data);
	      var vendor_id = auth_data.login_id;
	      this.setState({ vendor_id: vendor_id });
	      this.getOtherAds();
	    }
	  }, {
	    key: 'removeAd',
	    value: function removeAd(ad_id) {
	      var _this3 = this;
	
	      var toastr = '';
	
	      var req = JSON.stringify({
	        aid: ad_id
	      });
	
	      (0, _FetchCall.deleteOtherAdEntry)(req).then(function (response) {
	
	        if (response.status == 1) {
	
	          _this3.getOtherAds();
	
	          toastr = window.toastr.success;
	          toastr('Ad is removed successfully', {
	            positionClass: "toast-bottom-right",
	            containerId: "toast-bottom-right"
	          });
	        }
	      });
	    }
	  }, {
	    key: 'genWebp',
	    value: function genWebp(ad_id) {
	
	      var toastr = '';
	
	      var req = JSON.stringify({
	        aid: ad_id
	      });
	
	      (0, _FetchCall.makeWebP)(req).then(function (response) {
	
	        if (response.status == 1) {
	
	          alert("Created");
	        }
	      });
	    }
	  }, {
	    key: 'savead',
	    value: function savead() {
	      var _this4 = this;
	
	      var toastr = '';
	
	      var req = JSON.stringify({
	        aid: this.state.aid,
	        adfilepath: this.state.adbanner,
	        adname: this.state.adname,
	        link: this.state.link,
	        adstatus: this.state.adstatus,
	        display_in: this.state.display_in,
	        display_mode: this.state.display_mode,
	        expiration: this.state.expiration,
	        display_position: this.state.display_position
	      });
	
	      (0, _FetchCall.submitAdsEntryOther)(req).then(function (response) {
	
	        if (response.status == 1) {
	
	          alert("Ad is saved");
	
	          _this4.getOtherAds();
	        } else {
	
	          alert("Error saving Ad");
	        }
	      });
	    }
	  }, {
	    key: 'showImage',
	    value: function showImage(image) {}
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var ads = this.state.ads;
	      //const IMGBASEURL = 'http://localhost:5005/';
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'col-lg-12 grid-margin stretch-card' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card-body' },
	                _react2.default.createElement(
	                  'h4',
	                  { 'class': 'card-title' },
	                  'Advertisements'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'row' },
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'col-md-12 col-sm-12 col-xs-12' },
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'panel panel-default' },
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'panel-heading clearfix' },
	                        _react2.default.createElement('i', { 'class': 'icon-calendar' }),
	                        _react2.default.createElement(
	                          'h4',
	                          { 'class': 'panel-title' },
	                          'List of Ads'
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'panel-body' },
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'tablerow' },
	                          _react2.default.createElement(
	                            'table',
	                            { 'class': 'table table-bordered table-sm' },
	                            _react2.default.createElement(
	                              'thead',
	                              { 'class': 'thead-dark' },
	                              _react2.default.createElement(
	                                'tr',
	                                null,
	                                _react2.default.createElement(
	                                  'th',
	                                  null,
	                                  'Ad Title'
	                                ),
	                                _react2.default.createElement(
	                                  'th',
	                                  null,
	                                  'Ad Image'
	                                ),
	                                _react2.default.createElement(
	                                  'th',
	                                  null,
	                                  'Ad Date'
	                                ),
	                                _react2.default.createElement(
	                                  'th',
	                                  null,
	                                  'Ad Status'
	                                ),
	                                _react2.default.createElement(
	                                  'th',
	                                  null,
	                                  'Display Mode'
	                                ),
	                                _react2.default.createElement(
	                                  'th',
	                                  null,
	                                  'Expire on'
	                                ),
	                                _react2.default.createElement(
	                                  'th',
	                                  null,
	                                  'Display In'
	                                ),
	                                _react2.default.createElement(
	                                  'th',
	                                  null,
	                                  'Position'
	                                ),
	                                _react2.default.createElement(
	                                  'th',
	                                  null,
	                                  'Action'
	                                )
	                              )
	                            ),
	                            ads.map(function (ad, i) {
	
	                              return _react2.default.createElement(
	                                'tr',
	                                null,
	                                _react2.default.createElement(
	                                  'td',
	                                  null,
	                                  ad.adname
	                                ),
	                                _react2.default.createElement(
	                                  'td',
	                                  null,
	                                  _react2.default.createElement(
	                                    'button',
	                                    { onClick: function onClick() {
	                                        return _this5.showImage('' + _constant.IMGBASEURL + "uploads/" + ad.adfilepath + '');
	                                      } },
	                                    'Clike to view'
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'td',
	                                  null,
	                                  new Date(Number(ad.created_at)).toString().substring(4, 15)
	                                ),
	                                _react2.default.createElement(
	                                  'td',
	                                  null,
	                                  ad.adstatus == 1 ? "Active" : "Inactive"
	                                ),
	                                _react2.default.createElement(
	                                  'td',
	                                  null,
	                                  ad.display_mode
	                                ),
	                                _react2.default.createElement(
	                                  'td',
	                                  null,
	                                  ad.expiration
	                                ),
	                                _react2.default.createElement(
	                                  'td',
	                                  null,
	                                  ad.display_in == 'tuitionblog' ? 'Blogs of Tuitions' : ad.display_in == 'schoolblog' ? 'Blogs of School' : ad.display_in == 'afterschoolblog' ? 'Blogs of After School' : ad.display_in == 'defaultblog' ? 'Default in Blogs' : ad.display_in
	                                ),
	                                _react2.default.createElement(
	                                  'td',
	                                  null,
	                                  ad.display_position
	                                ),
	                                _react2.default.createElement(
	                                  'td',
	                                  null,
	                                  _react2.default.createElement(
	                                    'button',
	                                    { 'class': 'btn btn-primary btn-sm', onClick: function onClick() {
	                                        return _this5.removeAd(ad.aid);
	                                      } },
	                                    'Remove'
	                                  ),
	                                  '\xA0',
	                                  _react2.default.createElement(
	                                    'button',
	                                    { 'class': 'btn btn-primary btn-sm', onClick: function onClick() {
	                                        return _this5.genWebp(ad.aid);
	                                      } },
	                                    'Webp'
	                                  )
	                                )
	                              );
	                            }),
	                            ads.length == 0 && _react2.default.createElement(
	                              'tr',
	                              null,
	                              _react2.default.createElement(
	                                'td',
	                                { colSpan: '5' },
	                                'No data'
	                              )
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement('hr', null),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'row form' },
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'col-md-12 col-sm-12 col-xs-12' },
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'panel panel-default' },
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'panel-heading clearfix' },
	                        _react2.default.createElement('i', { 'class': 'icon-calendar' }),
	                        _react2.default.createElement(
	                          'h4',
	                          { 'class': 'panel-title' },
	                          'Create Ad'
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'panel-body' },
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'row p-3' },
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'col-lg-4 col-sm-12' },
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'input-group input-group-sm' },
	                              _react2.default.createElement(
	                                'label',
	                                { 'for': 'brochure' },
	                                'Ad Name'
	                              ),
	                              _react2.default.createElement('input', { type: 'text', name: 'adname', 'class': 'form-control input-sm', onChange: this.handleChange })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'col-lg-8 col-sm-12' },
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'input-group input-group-sm' },
	                              _react2.default.createElement(
	                                'label',
	                                { 'for': 'brochure' },
	                                'Hyperlink to click'
	                              ),
	                              _react2.default.createElement('input', { type: 'text', name: 'link', 'class': 'form-control input-sm', onChange: this.handleChange })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement('br', null),
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'row p-3' },
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'col-md-4' },
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'input-group input-group-sm' },
	                              _react2.default.createElement(
	                                'label',
	                                { 'for': 'brochure' },
	                                'Display in'
	                              ),
	                              _react2.default.createElement(
	                                'select',
	                                { name: 'display_in', 'class': 'form-control input-sm', onChange: this.handleChange },
	                                _react2.default.createElement(
	                                  'option',
	                                  { value: 'all' },
	                                  'BeWise Website'
	                                ),
	                                _react2.default.createElement(
	                                  'option',
	                                  { value: 'tuitionblogs' },
	                                  'Tuition related Blog Pages'
	                                ),
	                                _react2.default.createElement(
	                                  'option',
	                                  { value: 'schoolblogs' },
	                                  'School related Blog Pages'
	                                ),
	                                _react2.default.createElement(
	                                  'option',
	                                  { value: 'skillblogs' },
	                                  'Skill related blog pages (yoga, abacus,vedic math, balvihar, coding ..etc)'
	                                ),
	                                _react2.default.createElement(
	                                  'option',
	                                  { value: 'danceblogs' },
	                                  'Dance related blog pages (kathak, bharathanatyam, kucchipudi, odissi ..etc)'
	                                ),
	                                _react2.default.createElement(
	                                  'option',
	                                  { value: 'sportsblogs' },
	                                  'Sports related blog pages (football, tennis, cricket, swimming..etc)'
	                                ),
	                                _react2.default.createElement(
	                                  'option',
	                                  { value: 'musicblogs' },
	                                  'Music related blog pages (vocal and Instruments)'
	                                ),
	                                _react2.default.createElement(
	                                  'option',
	                                  { value: 'artsblogs' },
	                                  'Arts related blog pages (drawing, pottery and arts & crafts)'
	                                ),
	                                _react2.default.createElement(
	                                  'option',
	                                  { value: 'hobbiesblogs' },
	                                  'Hobbies related blog pages (cooking, story telling and quiz)'
	                                ),
	                                _react2.default.createElement(
	                                  'option',
	                                  { value: 'defaultblog' },
	                                  'Default Blog Pages'
	                                ),
	                                _react2.default.createElement(
	                                  'option',
	                                  { value: 'listing' },
	                                  'All Vertical listing Pages'
	                                ),
	                                _react2.default.createElement(
	                                  'option',
	                                  { value: 'school' },
	                                  'School Listing Page'
	                                ),
	                                _react2.default.createElement(
	                                  'option',
	                                  { value: 'preschool' },
	                                  'Preschool Listing Page'
	                                ),
	                                _react2.default.createElement(
	                                  'option',
	                                  { value: 'afterschool' },
	                                  'After School Listing Page'
	                                ),
	                                _react2.default.createElement(
	                                  'option',
	                                  { value: 'tuition' },
	                                  'Tuition Listing Page'
	                                ),
	                                _react2.default.createElement(
	                                  'option',
	                                  { value: 'camps' },
	                                  'Learning Camps Listing Page'
	                                ),
	                                _react2.default.createElement(
	                                  'option',
	                                  { value: 'kidsplayarea' },
	                                  'Kids Play Area Listing Page'
	                                ),
	                                _react2.default.createElement(
	                                  'option',
	                                  { value: 'community' },
	                                  'Community Support Listing Page'
	                                )
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'col-md-3' },
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'input-group input-group-sm' },
	                              _react2.default.createElement(
	                                'label',
	                                { 'for': 'brochure' },
	                                'Display Position'
	                              ),
	                              _react2.default.createElement(
	                                'select',
	                                { name: 'display_position', 'class': 'form-control input-sm', onChange: this.handleChange },
	                                _react2.default.createElement(
	                                  'option',
	                                  { value: 'R1' },
	                                  'Right SideBar Position #1'
	                                ),
	                                _react2.default.createElement(
	                                  'option',
	                                  { value: 'R2' },
	                                  'Right SideBar Position #2'
	                                ),
	                                _react2.default.createElement(
	                                  'option',
	                                  { value: 'BT' },
	                                  'Bottom'
	                                ),
	                                _react2.default.createElement(
	                                  'option',
	                                  { value: 'TOP' },
	                                  'Top'
	                                )
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'col-md-3' },
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'input-group input-group-sm' },
	                              _react2.default.createElement(
	                                'label',
	                                { 'for': 'brochure' },
	                                'Display Mode'
	                              ),
	                              _react2.default.createElement(
	                                'select',
	                                { name: 'display_mode', 'class': 'form-control input-sm', onChange: this.handleChange },
	                                _react2.default.createElement(
	                                  'option',
	                                  { value: 'web' },
	                                  'Web'
	                                ),
	                                _react2.default.createElement(
	                                  'option',
	                                  { value: 'mobile' },
	                                  'Mobile'
	                                )
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'row p-3' },
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'col-md-4' },
	                            _react2.default.createElement(
	                              'label',
	                              { 'for': 'brochure' },
	                              'Ad Status'
	                            ),
	                            _react2.default.createElement('br', null),
	                            _react2.default.createElement(
	                              'label',
	                              { 'class': 'radio-inline' },
	                              _react2.default.createElement('input', { type: 'radio', name: 'adstatus', value: '1', onChange: this.handleChange, checked: true }),
	                              'Enabled'
	                            ),
	                            _react2.default.createElement(
	                              'label',
	                              { 'class': 'radio-inline' },
	                              _react2.default.createElement('input', { type: 'radio', name: 'adstatus', value: '0', onChange: this.handleChange }),
	                              'Disabled'
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'col-md-4' },
	                            _react2.default.createElement(
	                              'label',
	                              { 'for': 'brochure' },
	                              'Expiration'
	                            ),
	                            _react2.default.createElement('input', { type: 'date', name: 'expiration', 'class': 'form-control input-sm', onChange: this.handleChange })
	                          )
	                        ),
	                        _react2.default.createElement('br', null),
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'row p-3' },
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'col-lg-4 col-sm-12' },
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'input-group input-group-sm' },
	                              _react2.default.createElement(
	                                'label',
	                                { 'for': 'banner' },
	                                'Ad Banner (112 \xD7 600 OR 468 x 60 in px)(jpgs)'
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'row' },
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'col-md-6 col-sm-6 col-xs-12' },
	                                  _react2.default.createElement('input', { type: 'file', name: 'adbanner', multiple: true, 'class': 'form-control input-sm', placeholder: 'Ad Banners', onChange: this.handleFileMultiple })
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'col-md-6 col-sm-6 col-xs-12' },
	                                  _react2.default.createElement(
	                                    'button',
	                                    { 'class': 'btn btn-primary btn-sm', onClick: this.onFileUploadBanner },
	                                    'Upload!'
	                                  )
	                                )
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement('br', null),
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'row' },
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'col-md-12 col-sm-12 col-xs-12' },
	                            _react2.default.createElement(
	                              'button',
	                              { type: 'button', 'class': 'btn btn-primary', onClick: function onClick() {
	                                  return _this5.savead();
	                                } },
	                              'Save Ad'
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return cmsWebAds;
	}(_react.Component);
	
	exports.default = cmsWebAds;

/***/ },
/* 1043 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	__webpack_require__(18);
	
	var _reactNotifications = __webpack_require__(16);
	
	var _reactRangeslider = __webpack_require__(79);
	
	var _reactRangeslider2 = _interopRequireDefault(_reactRangeslider);
	
	__webpack_require__(66);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import { Editor } from '@tinymce/tinymce-react';
	
	var Addblog = function (_Component) {
	  _inherits(Addblog, _Component);
	
	  function Addblog(props) {
	    _classCallCheck(this, Addblog);
	
	    var _this = _possibleConstructorReturn(this, (Addblog.__proto__ || Object.getPrototypeOf(Addblog)).call(this, props));
	
	    _this.handleChangeHorizontal = function (value) {
	      _this.setState({
	        salary_range_forthisjob: value
	      });
	    };
	
	    _this.handleChange = function (e) {
	      _this.setState(_defineProperty({}, e.target.name, e.target.value));
	
	      if (e.target.value == 'Other') {
	        _this.setState(_defineProperty({}, e.target.name + "_other_disabled", false));
	      }
	    };
	
	    _this.handleSubmit = function (e) {
	
	      var req = JSON.stringify({
	
	        blog_title: _this.state.blog_title,
	        blog_url: _this.state.blog_url,
	        blog_status: _this.state.blog_status
	
	      });
	
	      (0, _FetchCall.postanextblog)(req).then(function (response) {
	
	        if (response.status == 1) {
	
	          _reactNotifications.NotificationManager.success('Posted successfully', 'Post an external article');
	        } else {
	
	          _reactNotifications.NotificationManager.error('Error posting', 'Post an external article');
	        }
	      });
	    };
	
	    _this.state = {
	      logged: localStorage.getItem("authentication"),
	      auth_data: JSON.parse(localStorage.getItem("user_data")),
	      category_data: [], collapse: 0, modalReply: false,
	      current_comment: '', current_rid: 0, current_eid: '',
	      PER_PAGE: 15,
	      total: 0,
	      loading: true,
	      list: [],
	      salary_range_forthisjob: 15000,
	      organisation_place: '',
	      organisation: '',
	      job_role_other_disabled: true,
	      job_subject_teaching_other_disabled: true,
	      expected_qualification_other_disabled: true,
	      examcertifications_other_disabled: true,
	      skillsrequired_other_disabled: true
	    };
	
	    _this.cancelPop = _this.cancelPop.bind(_this);
	    _this.handleChange = _this.handleChange.bind(_this);
	
	    return _this;
	  }
	
	  _createClass(Addblog, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	
	      var THIS = this;
	    }
	  }, {
	    key: 'cancelPop',
	    value: function cancelPop() {
	      this.setState({ blockinstopenmodal: false });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          value = _state.value,
	          suggestions = _state.suggestions,
	          pickedones = _state.pickedones;
	      var _state2 = this.state,
	          salary_range_forthisjob = _state2.salary_range_forthisjob,
	          vertical = _state2.vertical;
	
	      var horizontalLabels = {
	        12000: '12k',
	        400000: '4L'
	      };
	
	      var formatkg = function formatkg(value) {
	        return value;
	      };
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'col-12 grid-margin' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card-body' },
	                _react2.default.createElement(
	                  'h4',
	                  { 'class': 'card-title' },
	                  'External Blog - Add'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'postajobform wc' },
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup end_date_option', id: 'end_date_option' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Blog Title '
	                    ),
	                    _react2.default.createElement('input', { type: 'text', 'class': 'form-control forminputcls', id: 'organisation', name: 'blog_title', onChange: this.handleChange })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup end_date_option', id: 'end_date_option' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Blog External URL '
	                    ),
	                    _react2.default.createElement('input', { type: 'text', 'class': 'form-control forminputcls', id: 'job_title', name: 'blog_url', onChange: this.handleChange })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup end_date_option', id: 'end_date_option' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Status'
	                    ),
	                    _react2.default.createElement(
	                      'select',
	                      { name: 'blog_status', 'class': 'formselectinputcls', onChange: this.handleChange },
	                      _react2.default.createElement(
	                        'option',
	                        { value: '' },
	                        'Select'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: '1' },
	                        'Active'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: '0' },
	                        'InActive'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup text-center paddingtop20' },
	                    _react2.default.createElement(
	                      'button',
	                      { type: 'button', name: 'postablog', 'class': 'btn btn-primary', onClick: this.handleSubmit },
	                      'Submit'
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(_reactNotifications.NotificationContainer, null)
	        )
	      );
	    }
	  }]);
	
	  return Addblog;
	}(_react.Component);
	
	exports.default = Addblog;

/***/ },
/* 1044 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	__webpack_require__(18);
	
	var _reactNotifications = __webpack_require__(16);
	
	var _reactRangeslider = __webpack_require__(79);
	
	var _reactRangeslider2 = _interopRequireDefault(_reactRangeslider);
	
	__webpack_require__(66);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import { Editor } from '@tinymce/tinymce-react';
	
	var AddcourseIns = function (_Component) {
	  _inherits(AddcourseIns, _Component);
	
	  function AddcourseIns(props) {
	    _classCallCheck(this, AddcourseIns);
	
	    var _this = _possibleConstructorReturn(this, (AddcourseIns.__proto__ || Object.getPrototypeOf(AddcourseIns)).call(this, props));
	
	    _this.handleChangeHorizontal = function (value) {
	      _this.setState({
	        salary_range_forthisjob: value
	      });
	    };
	
	    _this.handleChange = function (e) {
	      _this.setState(_defineProperty({}, e.target.name, e.target.value));
	
	      if (e.target.value == 'Other') {
	        _this.setState(_defineProperty({}, e.target.name + "_other_disabled", false));
	      }
	    };
	
	    _this.handleSubmit = function (e) {
	
	      var req = JSON.stringify({
	        name: _this.state.name,
	        url: _this.state.url
	      });
	
	      (0, _FetchCall.postajob)(req).then(function (response) {
	
	        if (response.status == 1) {
	
	          _reactNotifications.NotificationManager.success('Posted job successfully', 'Post a job');
	        } else {
	
	          _reactNotifications.NotificationManager.error('Error posting a job', 'Post a job');
	        }
	      });
	    };
	
	    _this.state = {
	      logged: localStorage.getItem("authentication"),
	      auth_data: JSON.parse(localStorage.getItem("user_data")),
	      category_data: [], collapse: 0, modalReply: false,
	      current_comment: '', current_rid: 0, current_eid: '',
	      PER_PAGE: 15,
	      total: 0,
	      loading: true,
	      list: []
	    };
	
	    _this.cancelPop = _this.cancelPop.bind(_this);
	    _this.handleChange = _this.handleChange.bind(_this);
	
	    return _this;
	  }
	
	  _createClass(AddcourseIns, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	
	      var THIS = this;
	    }
	  }, {
	    key: 'cancelPop',
	    value: function cancelPop() {
	      this.setState({ blockinstopenmodal: false });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          value = _state.value,
	          suggestions = _state.suggestions,
	          pickedones = _state.pickedones;
	
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'col-12 grid-margin' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card-body' },
	                _react2.default.createElement(
	                  'h4',
	                  { 'class': 'card-title' },
	                  'Course - Add'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'postajobform wc' },
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup end_date_option', id: 'end_date_option' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Name '
	                    ),
	                    _react2.default.createElement('input', { type: 'text', 'class': 'form-control forminputcls', id: 'name', name: 'name', onChange: this.handleChange })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup end_date_option', id: 'end_date_option' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Description '
	                    ),
	                    _react2.default.createElement('input', { type: 'text', 'class': 'form-control forminputcls', id: 'url', name: 'url', onChange: this.handleChange })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup end_date_option', id: 'end_date_option' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Duration '
	                    ),
	                    _react2.default.createElement('input', { type: 'text', 'class': 'form-control forminputcls', id: 'url', name: 'url', onChange: this.handleChange })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup end_date_option', id: 'end_date_option' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Applying URL '
	                    ),
	                    _react2.default.createElement('input', { type: 'text', 'class': 'form-control forminputcls', id: 'url', name: 'url', onChange: this.handleChange })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup text-center paddingtop20' },
	                    _react2.default.createElement(
	                      'button',
	                      { type: 'button', name: 'postajob', 'class': 'btn btn-primary', onClick: this.handleSubmit },
	                      'Submit'
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(_reactNotifications.NotificationContainer, null)
	        )
	      );
	    }
	  }]);
	
	  return AddcourseIns;
	}(_react.Component);
	
	exports.default = AddcourseIns;

/***/ },
/* 1045 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	__webpack_require__(18);
	
	var _reactNotifications = __webpack_require__(16);
	
	var _multiselectReactDropdown = __webpack_require__(73);
	
	var _reactRangeslider = __webpack_require__(79);
	
	var _reactRangeslider2 = _interopRequireDefault(_reactRangeslider);
	
	__webpack_require__(66);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import { Editor } from '@tinymce/tinymce-react';
	
	var Addjob = function (_Component) {
	  _inherits(Addjob, _Component);
	
	  function Addjob(props) {
	    _classCallCheck(this, Addjob);
	
	    var _this = _possibleConstructorReturn(this, (Addjob.__proto__ || Object.getPrototypeOf(Addjob)).call(this, props));
	
	    _this.handleChangeHorizontal = function (value) {
	      _this.setState({
	        salary_range_forthisjob: value
	      });
	    };
	
	    _this.handleChange = function (e) {
	      _this.setState(_defineProperty({}, e.target.name, e.target.value));
	
	      if (e.target.value == 'Other') {
	        _this.setState(_defineProperty({}, e.target.name + "_other_disabled", false));
	      }
	    };
	
	    _this.handleSubmit = function (e) {
	
	      var auth_data = JSON.parse(localStorage.getItem("user_data"));
	      /*
	      let req = JSON.stringify({
	          user_id:1,
	          job_title: this.state.job_title,
	          job_category: this.state.job_category,
	          job_description: this.state.job_description,
	          job_gender:this.state.job_gender,
	          organisation:this.state.organisation,
	          organisation_place:auth_data.organisation_place,
	          open_date: this.state.open_date,
	          closing_date: this.state.closing_date,
	          job_location: this.state.job_location,
	          salary_range_forthisjob: this.state.salary_range_forthisjob,
	          language_preferred: this.state.language_preferred,
	          expected_qualification: this.state.expected_qualification,
	          skillsrequired: this.state.skillsrequired,
	          job_role: this.state.job_role,
	          job_subject_teaching: this.state.job_subject_teaching,
	          job_experience: this.state.job_experience,
	          examcertifications: this.state.examcertifications,
	          expected_qualification_other: this.state.expected_qualification_other,
	          skillsrequired_other: this.state.skillsrequired_other,
	          job_role_other: this.state.job_role_other,
	          job_subject_teaching_other: this.state.job_subject_teaching_other,
	          examcertifications_other: this.state.examcertifications_other
	       })
	      */
	      var req = {
	        user_id: 1,
	        job_title: _this.state.job_title,
	        job_category: _this.state.job_category,
	        job_description: _this.state.job_description,
	        job_gender: _this.state.job_gender,
	        organisation: _this.state.organisation,
	        organisation_place: auth_data.organisation_place,
	        open_date: _this.state.open_date,
	        closing_date: _this.state.closing_date,
	        job_location: _this.state.job_location,
	        salary_range_forthisjob: _this.state.salary_range_forthisjob,
	        language_preferred: _this.state.language_preferred,
	        expected_qualification: _this.state.expected_qualification,
	        skillsrequired: _this.state.skillsrequired,
	        job_role: _this.state.job_role,
	        job_subject_teaching: _this.state.job_subject_teaching,
	        job_experience: _this.state.job_experience,
	        examcertifications: _this.state.examcertifications,
	        expected_qualification_other: _this.state.expected_qualification_other,
	        skillsrequired_other: _this.state.skillsrequired_other,
	        job_role_other: _this.state.job_role_other,
	        job_subject_teaching_other: _this.state.job_subject_teaching_other,
	        examcertifications_other: _this.state.examcertifications_other
	
	      };
	
	      (0, _FetchCall.postajob)(req).then(function (response) {
	
	        if (response.status == 1) {
	
	          _reactNotifications.NotificationManager.success('Posted job successfully', 'Post a job');
	        } else {
	
	          _reactNotifications.NotificationManager.error('Error posting a job', 'Post a job');
	        }
	      });
	    };
	
	    _this.onSelect = function (selectedList) {
	      var keywords = [];
	      selectedList.map(function (item, i) {
	        keywords.push(item);
	      });
	      _this.setState({
	        language_preferred: keywords.toString()
	      });
	    };
	
	    _this.onRemove = function (selectedList, removedItem) {
	      var keywords = [];
	      selectedList.map(function (item, i) {
	        keywords.push(item);
	      });
	      _this.setState({
	        language_preferred: keywords.toString()
	      });
	    };
	
	    _this.onSelectExpectedQualification = function (selectedList) {
	      var keywords = [];
	      selectedList.map(function (item, i) {
	        keywords.push(item);
	      });
	      _this.setState({
	        expected_qualification: keywords.toString()
	      });
	    };
	
	    _this.onRemoveExpQualification = function (selectedList, removedItem) {
	      var keywords = [];
	      selectedList.map(function (item, i) {
	        keywords.push(item);
	      });
	      _this.setState({
	        expected_qualification: keywords.toString()
	      });
	    };
	
	    _this.onSelectExamCertificaitons = function (selectedList) {
	      var keywords = [];
	      selectedList.map(function (item, i) {
	        keywords.push(item);
	      });
	      _this.setState({
	        examcertifications: keywords.toString()
	      });
	    };
	
	    _this.onRemoveExamCertifications = function (selectedList, removedItem) {
	      var keywords = [];
	      selectedList.map(function (item, i) {
	        keywords.push(item);
	      });
	      _this.setState({
	        examcertifications: keywords.toString()
	      });
	    };
	
	    _this.onSelectSkillRequired = function (selectedList) {
	      var keywords = [];
	      selectedList.map(function (item, i) {
	        keywords.push(item);
	      });
	      _this.setState({
	        skillsrequired: keywords.toString()
	      });
	    };
	
	    _this.onRemoveSkillRequired = function (selectedList, removedItem) {
	      var keywords = [];
	      selectedList.map(function (item, i) {
	        keywords.push(item);
	      });
	      _this.setState({
	        skillsrequired: keywords.toString()
	      });
	    };
	
	    _this.state = {
	      logged: localStorage.getItem("authentication"),
	      auth_data: JSON.parse(localStorage.getItem("user_data")),
	      category_data: [], collapse: 0, modalReply: false,
	      current_comment: '', current_rid: 0, current_eid: '',
	      PER_PAGE: 15,
	      total: 0,
	      loading: true,
	      list: [],
	      salary_range_forthisjob: 15000,
	      organisation_place: '',
	      organisation: '',
	      job_role_other_disabled: true,
	      job_subject_teaching_other_disabled: true,
	      expected_qualification_other_disabled: true,
	      examcertifications_other_disabled: true,
	      skillsrequired_other_disabled: true
	    };
	
	    _this.cancelPop = _this.cancelPop.bind(_this);
	    _this.handleChange = _this.handleChange.bind(_this);
	
	    return _this;
	  }
	
	  _createClass(Addjob, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	
	      var THIS = this;
	    }
	  }, {
	    key: 'cancelPop',
	    value: function cancelPop() {
	      this.setState({ blockinstopenmodal: false });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          value = _state.value,
	          suggestions = _state.suggestions,
	          pickedones = _state.pickedones;
	      var _state2 = this.state,
	          salary_range_forthisjob = _state2.salary_range_forthisjob,
	          vertical = _state2.vertical;
	
	      var horizontalLabels = {
	        12000: '12k',
	        400000: '4L'
	      };
	
	      var expected_qualification_arr = ["Graduate in Education (BA / B.SC etc.)", "Post Graduate (MA /M.Sc etc)", "Engeneering Graduate", "Diploma In Education", "Bachelors Degree in Education (B.Ed)", "Masters Degree in Education (M.Ed)", "Doctorate (Phd)", "Bachelor of Elementray Education (B.EL.Ed)", "Bachelor of Arts & Education (BA. B.Ed)", "Diploma in Elementary Education (D.EL.Ed)", "Bachelor of Physical Education (B.P.Ed)", "Master of Philosophy in Education (M.Phil)", "Bachelor of Library Science (B.Lib)", "Bachelor of Library & Information Sciences (B.Lib.I.Sc)", "Masters in Library & Information Sciences (M.Lib.I.Sc)", "Bachelor of Fine Arts (BFA)", "Diploma Program in Special Education (DESCE-MR / DSE / MRW / DHLS etc)", "Post Graduate Diploma in Special Education", "Graduate in Special Education  (B.Ed - Spl Education)", "Other"];
	
	      var language_preferred_arr = ['English', 'Hindi', 'Tamil', 'Kannada', 'Telugu', 'Urdhu', 'Malayalam'];
	
	      var examcertifications_arr = ["None", "Central Teachers Eligibliity Test (CTET)", "National Eligibility Test (NET / UGC-NET)", "Basic Training Certificates", "Primary Teachers Certificates", "Teachers Training Certificates", "Teacher Eligiblity Test (TET)", "State Teachers Eligiblity Test (STET)", "Certificate course in Library Sciences", "Certificate course in Drawing teacher training", "Certificate in Care giving program", "Certificate program in Special Education", "Certicate Courses in Dance", "Certicate Courses in Arts", "Certificate Courses in Sports", "Certificate Courses in Music & Dance", "Other"];
	
	      var skillsrequired_arr = ["Expertise in specific subjects of teaching", "Written and verbal communication", "Ability to adapt to different situations", "Knowledge of teaching software and tools", "Ability to teach students experiencing challenge with learning", "Time management skills", "Innovative training strategies", "Flexibility to modify training principles", "Classroom management", "Leadership", "Conflict management", "Collaborative & Interpersonal skills", "Creative", "Financial Management", "Human Resource Management", "Curriculam Development", "School Policy Knowledge", "Understanding & Implementation of NEP requirements", "Other"];
	
	      var formatkg = function formatkg(value) {
	        return value;
	      };
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'col-12 grid-margin' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card-body' },
	                _react2.default.createElement(
	                  'h4',
	                  { 'class': 'card-title' },
	                  'Job - Add'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'postajobform wc' },
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup end_date_option', id: 'end_date_option' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Organisation '
	                    ),
	                    _react2.default.createElement('input', { type: 'text', 'class': 'form-control forminputcls', id: 'organisation', name: 'organisation', onChange: this.handleChange })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup end_date_option', id: 'end_date_option' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Job title '
	                    ),
	                    _react2.default.createElement('input', { type: 'text', 'class': 'form-control forminputcls', id: 'job_title', name: 'job_title', onChange: this.handleChange })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Job Description '
	                    ),
	                    _react2.default.createElement('textarea', { 'class': 'form-control forminputcls', name: 'job_description', id: 'job_description', placeholder: 'Description', rows: '10', onChange: this.handleChange })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup end_date_option', id: 'end_date_option' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Job role'
	                    ),
	                    _react2.default.createElement(
	                      'select',
	                      { name: 'job_role', 'class': 'formselectinputcls', onChange: this.handleChange },
	                      _react2.default.createElement(
	                        'option',
	                        { value: '' },
	                        'Select Role'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Pre Primary Teacher' },
	                        'Pre Primary Teacher'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Primary Teacher' },
	                        'Primary Teacher'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Secondary Teacher' },
	                        'Secondary Teacher'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Senior Secondary Teacher' },
	                        'Senior Secondary Teacher'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Special Educator' },
	                        'Special Educator'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Libraian' },
	                        'Libraian'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Physial Education Teacher' },
	                        'Physial Education Teacher'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Counsellor' },
	                        'Counsellor'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Administrator' },
	                        'Administrator'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Accountant' },
	                        'Accountant'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Marketing' },
	                        'Marketing'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Music / Dance Teacher' },
	                        'Music / Dance Teacher'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Other' },
	                        'Other'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup end_date_option', id: 'end_date_option' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Job Role - If Other '
	                    ),
	                    _react2.default.createElement('input', { type: 'text', 'class': 'form-control forminputcls', id: 'job_role_other', disabled: this.state.job_role_other_disabled, name: 'job_role_other', onChange: this.handleChange })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup end_date_option', id: 'end_date_option' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Gender'
	                    ),
	                    _react2.default.createElement(
	                      'select',
	                      { name: 'job_gender', 'class': 'formselectinputcls', onChange: this.handleChange },
	                      _react2.default.createElement(
	                        'option',
	                        { value: '' },
	                        'Select Gender'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Male' },
	                        'Male'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Female' },
	                        'Female'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Other' },
	                        'Other'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Not a constraint' },
	                        'Not a constraint'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup end_date_option', id: 'end_date_option' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Role Type'
	                    ),
	                    _react2.default.createElement(
	                      'select',
	                      { name: 'job_category', 'class': 'formselectinputcls', onChange: this.handleChange },
	                      _react2.default.createElement(
	                        'option',
	                        { value: '' },
	                        'Select Role Type'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Full Time' },
	                        'Full Time'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Part Time' },
	                        'Part Time'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Contractual' },
	                        'Contractual'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Temporary' },
	                        'Temporary'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Internship' },
	                        'Internship'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup end_date_option', id: 'end_date_option' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Subject Of Teaching'
	                    ),
	                    _react2.default.createElement(
	                      'select',
	                      { name: 'job_subject_teaching', 'class': 'formselectinputcls', onChange: this.handleChange },
	                      _react2.default.createElement(
	                        'option',
	                        { value: '' },
	                        'Select Subject'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Biology' },
	                        'Biology'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Science' },
	                        'Science'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Maths' },
	                        'Maths'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Physics' },
	                        'Physics'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Chemistry' },
	                        'Chemistry'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Art' },
	                        'Art'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'History' },
	                        'History'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Economics' },
	                        'Economics'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Computer Science' },
	                        'Computer Science'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Phyisical Education' },
	                        'Phyisical Education'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Librarian' },
	                        'Librarian'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Humanities' },
	                        'Humanities'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Geography' },
	                        'Geography'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Civics' },
	                        'Civics'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'English' },
	                        'English'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Hindi' },
	                        'Hindi'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Tamil' },
	                        'Tamil'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Kannada' },
	                        'Kannada'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Telugu' },
	                        'Telugu'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Marathi' },
	                        'Marathi'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'French' },
	                        'French'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Spanish' },
	                        'Spanish'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'German' },
	                        'German'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Reglion and Religious Studies' },
	                        'Reglion and Religious Studies'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Visual Arts' },
	                        'Visual Arts'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Robotics & Coding' },
	                        'Robotics & Coding'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Other' },
	                        'Other'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup end_date_option', id: 'end_date_option' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Subject Of Teaching - If Other '
	                    ),
	                    _react2.default.createElement('input', { type: 'text', 'class': 'form-control forminputcls', id: 'job_subject_teaching_other', disabled: this.state.job_subject_teaching_other_disabled, name: 'job_subject_teaching_other', onChange: this.handleChange })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup end_date_option', id: 'end_date_option' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Experience Required '
	                    ),
	                    _react2.default.createElement(
	                      'select',
	                      { name: 'job_experience', 'class': 'formselectinputcls', onChange: this.handleChange },
	                      _react2.default.createElement(
	                        'option',
	                        { value: '' },
	                        '---Select---'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Freshers' },
	                        'Freshers'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: '0-3 Years' },
	                        '0-3 Years'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: '4-5 years' },
	                        '4-5 years'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: '5-10 years' },
	                        '5-10 years'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: '10-15 years' },
	                        '10-15 years'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: '15+ years' },
	                        '15+ years'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup end_date_option', id: 'end_date_option' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Anticipated joining '
	                    ),
	                    _react2.default.createElement(
	                      'select',
	                      { name: 'joining', 'class': 'formselectinputcls', onChange: this.handleChange },
	                      _react2.default.createElement(
	                        'option',
	                        { value: '' },
	                        '---Select---'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Immediate' },
	                        'Immediate'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: '15 Days' },
	                        '15 Days'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: '1 month' },
	                        '1 month'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: '2 months' },
	                        '2 months'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: '3 months' },
	                        '3 months'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Job Opening Date '
	                    ),
	                    _react2.default.createElement('input', { type: 'date', 'class': 'form-control forminputcls', id: 'open_date', name: 'open_date', onChange: this.handleChange })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Job Closing Date '
	                    ),
	                    _react2.default.createElement('input', { type: 'date', 'class': 'form-control forminputcls', id: 'closing_date', name: 'closing_date', onChange: this.handleChange })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup end_date_option', id: 'end_date_option' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Job Location '
	                    ),
	                    _react2.default.createElement(
	                      'select',
	                      { name: 'job_location', 'class': 'formselectinputcls', onChange: this.handleChange },
	                      _react2.default.createElement(
	                        'option',
	                        { value: '' },
	                        'Select'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'In Campus' },
	                        'In Campus'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Hybrid' },
	                        'Hybrid'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Remote' },
	                        'Remote'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup end_date_option', id: 'end_date_option' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Salary Range for this Job'
	                    ),
	                    ' ',
	                    _react2.default.createElement(
	                      'div',
	                      { id: 'salaryText', 'class': 'salaryText' },
	                      '\u20B9 ',
	                      formatkg(salary_range_forthisjob)
	                    ),
	                    _react2.default.createElement(_reactRangeslider2.default, {
	                      min: 10000,
	                      max: 400000,
	                      value: salary_range_forthisjob,
	                      labels: horizontalLabels,
	                      format: formatkg,
	                      step: 1000,
	                      handleLabel: salary_range_forthisjob,
	                      onChange: this.handleChangeHorizontal
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup end_date_option', id: 'end_date_option' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Languages preferred '
	                    ),
	                    _react2.default.createElement(_multiselectReactDropdown.Multiselect, {
	                      className: 'formselectinputcls',
	                      isObject: false,
	                      options: language_preferred_arr // Options to display in the dropdown
	                      , onSelect: this.onSelect // Function will trigger on select event
	                      , onRemove: this.onRemove // Function will trigger on remove event
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Expected Qualification '
	                    ),
	                    _react2.default.createElement(_multiselectReactDropdown.Multiselect, {
	                      className: 'formselectinputcls',
	                      isObject: false,
	                      options: expected_qualification_arr // Options to display in the dropdown
	                      , onSelect: this.onSelectExpectedQualification // Function will trigger on select event
	                      , onRemove: this.onRemoveExpQualification // Function will trigger on remove event
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup end_date_option', id: 'end_date_option' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Expected Qualification - If Other '
	                    ),
	                    _react2.default.createElement('input', { type: 'text', 'class': 'form-control forminputcls', id: 'expected_qualification_other', name: 'expected_qualification_other', disabled: this.state.expected_qualification_other_disabled, onChange: this.handleChange })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Certifications Required  '
	                    ),
	                    _react2.default.createElement(_multiselectReactDropdown.Multiselect, {
	                      className: 'formselectinputcls',
	                      isObject: false,
	                      options: examcertifications_arr // Options to display in the dropdown
	                      , onSelect: this.onSelectExamCertificaitons // Function will trigger on select event
	                      , onRemove: this.onRemoveExamCertifications // Function will trigger on remove event
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup end_date_option', id: 'end_date_option' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Certifications - If Other '
	                    ),
	                    _react2.default.createElement('input', { type: 'text', 'class': 'form-control forminputcls', id: 'examcertifications_other', name: 'examcertifications_other', disabled: this.state.examcertifications_other_disabled, onChange: this.handleChange })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Skills required '
	                    ),
	                    _react2.default.createElement(_multiselectReactDropdown.Multiselect, {
	                      className: 'formselectinputcls',
	                      isObject: false,
	                      options: skillsrequired_arr // Options to display in the dropdown
	                      , onSelect: this.onSelectSkillRequired // Function will trigger on select event
	                      , onRemove: this.onRemoveSkillRequired // Function will trigger on remove event
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup end_date_option', id: 'end_date_option' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Skills required - If Other '
	                    ),
	                    _react2.default.createElement('input', { type: 'text', 'class': 'form-control forminputcls', id: 'skillsrequired_other', name: 'skillsrequired_other', disabled: this.state.skillsrequired_other_disabled, onChange: this.handleChange })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup text-center paddingtop20' },
	                    _react2.default.createElement(
	                      'button',
	                      { type: 'button', name: 'postajob', 'class': 'btn-main', onClick: this.handleSubmit },
	                      'Submit'
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(_reactNotifications.NotificationContainer, null)
	        )
	      );
	    }
	  }]);
	
	  return Addjob;
	}(_react.Component);
	
	exports.default = Addjob;

/***/ },
/* 1046 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	__webpack_require__(18);
	
	var _reactNotifications = __webpack_require__(16);
	
	var _reactRangeslider = __webpack_require__(79);
	
	var _reactRangeslider2 = _interopRequireDefault(_reactRangeslider);
	
	__webpack_require__(66);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import { Editor } from '@tinymce/tinymce-react';
	
	var Addothercourse = function (_Component) {
	  _inherits(Addothercourse, _Component);
	
	  function Addothercourse(props) {
	    _classCallCheck(this, Addothercourse);
	
	    var _this = _possibleConstructorReturn(this, (Addothercourse.__proto__ || Object.getPrototypeOf(Addothercourse)).call(this, props));
	
	    _this.handleChangeHorizontal = function (value) {
	      _this.setState({
	        salary_range_forthisjob: value
	      });
	    };
	
	    _this.handleChange = function (e) {
	      _this.setState(_defineProperty({}, e.target.name, e.target.value));
	
	      if (e.target.value == 'Other') {
	        _this.setState(_defineProperty({}, e.target.name + "_other_disabled", false));
	      }
	    };
	
	    _this.handleSubmit = function (e) {
	
	      var req = JSON.stringify({
	        name: _this.state.name,
	        url: _this.state.url
	      });
	
	      (0, _FetchCall.postajob)(req).then(function (response) {
	
	        if (response.status == 1) {
	
	          _reactNotifications.NotificationManager.success('Posted job successfully', 'Post a job');
	        } else {
	
	          _reactNotifications.NotificationManager.error('Error posting a job', 'Post a job');
	        }
	      });
	    };
	
	    _this.state = {
	      logged: localStorage.getItem("authentication"),
	      auth_data: JSON.parse(localStorage.getItem("user_data")),
	      category_data: [], collapse: 0, modalReply: false,
	      current_comment: '', current_rid: 0, current_eid: '',
	      PER_PAGE: 15,
	      total: 0,
	      loading: true,
	      list: []
	    };
	
	    _this.cancelPop = _this.cancelPop.bind(_this);
	    _this.handleChange = _this.handleChange.bind(_this);
	
	    return _this;
	  }
	
	  _createClass(Addothercourse, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	
	      var THIS = this;
	    }
	  }, {
	    key: 'cancelPop',
	    value: function cancelPop() {
	      this.setState({ blockinstopenmodal: false });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          value = _state.value,
	          suggestions = _state.suggestions,
	          pickedones = _state.pickedones;
	
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'col-12 grid-margin' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card-body' },
	                _react2.default.createElement(
	                  'h4',
	                  { 'class': 'card-title' },
	                  'Other Course - Add'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'postajobform wc' },
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup end_date_option', id: 'end_date_option' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Name '
	                    ),
	                    _react2.default.createElement('input', { type: 'text', 'class': 'form-control forminputcls', id: 'name', name: 'name', onChange: this.handleChange })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup end_date_option', id: 'end_date_option' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'URL '
	                    ),
	                    _react2.default.createElement('input', { type: 'text', 'class': 'form-control forminputcls', id: 'url', name: 'url', onChange: this.handleChange })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup text-center paddingtop20' },
	                    _react2.default.createElement(
	                      'button',
	                      { type: 'button', name: 'postajob', 'class': 'btn btn-primary', onClick: this.handleSubmit },
	                      'Submit'
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(_reactNotifications.NotificationContainer, null)
	        )
	      );
	    }
	  }]);
	
	  return Addothercourse;
	}(_react.Component);
	
	exports.default = Addothercourse;

/***/ },
/* 1047 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	__webpack_require__(18);
	
	var _reactNotifications = __webpack_require__(16);
	
	var _reactRangeslider = __webpack_require__(79);
	
	var _reactRangeslider2 = _interopRequireDefault(_reactRangeslider);
	
	__webpack_require__(66);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import { Editor } from '@tinymce/tinymce-react';
	
	var WcAdvisory = function (_Component) {
	  _inherits(WcAdvisory, _Component);
	
	  function WcAdvisory(props) {
	    _classCallCheck(this, WcAdvisory);
	
	    var _this = _possibleConstructorReturn(this, (WcAdvisory.__proto__ || Object.getPrototypeOf(WcAdvisory)).call(this, props));
	
	    _this.handleChangeHorizontal = function (value) {
	      _this.setState({
	        salary_range_forthisjob: value
	      });
	    };
	
	    _this.handleChange = function (e) {
	      _this.setState(_defineProperty({}, e.target.name, e.target.value));
	
	      if (e.target.value == 'Other') {
	        _this.setState(_defineProperty({}, e.target.name + "_other_disabled", false));
	      }
	    };
	
	    _this.handleSubmit = function (e) {
	      var _JSON$stringify;
	
	      var req = JSON.stringify((_JSON$stringify = {
	        user_id: _this.state.user_id,
	        job_title: _this.state.job_title,
	        job_category: _this.state.job_category,
	        job_description: _this.state.job_description,
	        open_date: _this.state.open_date,
	        closing_date: _this.state.closing_date,
	        job_location: _this.state.job_location,
	        salary_range_forthisjob: _this.state.salary_range_forthisjob,
	        language_preferred: _this.state.language_preferred
	      }, _defineProperty(_JSON$stringify, 'job_description', _this.state.job_description), _defineProperty(_JSON$stringify, 'expected_qualification', _this.state.expected_qualification), _defineProperty(_JSON$stringify, 'skillsrequired', _this.state.skillsrequired), _defineProperty(_JSON$stringify, 'job_role', _this.state.job_role), _defineProperty(_JSON$stringify, 'job_subject_teaching', _this.state.job_subject_teaching), _defineProperty(_JSON$stringify, 'job_experience', _this.state.job_experience), _defineProperty(_JSON$stringify, 'examcertifications', _this.state.examcertifications), _defineProperty(_JSON$stringify, 'expected_qualification_other', _this.state.expected_qualification_other), _defineProperty(_JSON$stringify, 'skillsrequired_other', _this.state.skillsrequired_other), _defineProperty(_JSON$stringify, 'job_role_other', _this.state.job_role_other), _defineProperty(_JSON$stringify, 'job_subject_teaching_other', _this.state.job_subject_teaching_other), _defineProperty(_JSON$stringify, 'examcertifications_other', _this.state.examcertifications_other), _JSON$stringify));
	
	      (0, _FetchCall.postajob)(req).then(function (response) {
	
	        if (response.status == 1) {
	
	          _reactNotifications.NotificationManager.success('Posted job successfully', 'Post a job');
	        } else {
	
	          _reactNotifications.NotificationManager.error('Error posting a job', 'Post a job');
	        }
	      });
	    };
	
	    _this.state = {
	      logged: localStorage.getItem("authentication"),
	      auth_data: JSON.parse(localStorage.getItem("user_data")),
	      category_data: [], collapse: 0, modalReply: false,
	      current_comment: '', current_rid: 0, current_eid: '',
	      PER_PAGE: 15,
	      total: 0,
	      loading: true,
	      list: [],
	      exportbtndisabled: false,
	      thisExportBtnText: 'Export',
	      blockinstopenmodal: false,
	      suggestions: [],
	      institute: '',
	      pickedones: [],
	      pickedinstIds: [],
	      salary_range_forthisjob: 15000,
	
	      job_role_other_disabled: true,
	      job_subject_teaching_other_disabled: true,
	      expected_qualification_other_disabled: true,
	      examcertifications_other_disabled: true,
	      skillsrequired_other_disabled: true
	    };
	
	    _this.cancelPop = _this.cancelPop.bind(_this);
	    _this.handleChange = _this.handleChange.bind(_this);
	
	    return _this;
	  }
	
	  _createClass(WcAdvisory, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	
	      var THIS = this;
	    }
	  }, {
	    key: 'cancelPop',
	    value: function cancelPop() {
	      this.setState({ blockinstopenmodal: false });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          value = _state.value,
	          suggestions = _state.suggestions,
	          pickedones = _state.pickedones;
	
	
	      var formatkg = function formatkg(value) {
	        return value;
	      };
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'col-12 grid-margin' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card-body' },
	                _react2.default.createElement(
	                  'div',
	                  { id: 'overlayadvisory' },
	                  ' ',
	                  _react2.default.createElement(
	                    'div',
	                    { id: 'overlayimg' },
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'heading' },
	                      'Coming soon'
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'tilebox' },
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'adv_block' },
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'wc-column c100 bgforcourse semibordered', style: { backgroundImage: 'url(\'/images/patternbg.png\')' } },
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'course_h3title' },
	                        'Support services we offer'
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'course_desc' },
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          'Elevate your and your institution\'s potential with our exclusive bespoke services, meticulously crafted to fuel the professional development of educational institutions and teachers. Our personalized offerings streamline processes, focusing on speed and efficiency to help your institution execute its vision with precision. Whether nurturing your teaching staff\'s talents, innovating your curriculum, or enhancing overall performance, our bespoke services are the catalyst for transformation. '
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          'Join us to redefine education and experience the profound impact of our platform on your institution\'s growth and educator success.'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'flexby4' },
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'flexby4_item', style: { backgroundImage: 'url(\'/images/advisory/1.png\')' } },
	                        _react2.default.createElement(
	                          'span',
	                          null,
	                          'Relocation support'
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'flexby4_item', style: { backgroundImage: 'url(\'/images/advisory/2.png\')' } },
	                        _react2.default.createElement(
	                          'span',
	                          null,
	                          'Reference Checks/ Assessment support'
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'flexby4_item', style: { backgroundImage: 'url(\'/images/advisory/3.png\')' } },
	                        _react2.default.createElement(
	                          'span',
	                          null,
	                          'Improve Org Profile - attract talent'
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'flexby4_item', style: { backgroundImage: 'url(\'/images/advisory/4.png\')' } },
	                        _react2.default.createElement(
	                          'span',
	                          null,
	                          'Advertising & newsletter promos'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'flexby4' },
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'flexby4_item', style: { backgroundImage: 'url(\'/images/advisory/5.png\')' } },
	                        _react2.default.createElement(
	                          'span',
	                          null,
	                          'Curated Partnerships for growth'
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'flexby4_item', style: { backgroundImage: 'url(\'/images/advisory/6.png\')' } },
	                        _react2.default.createElement(
	                          'span',
	                          null,
	                          'Outsourcing'
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'flexby4_item', style: { backgroundImage: 'url(\'/images/advisory/7.png\')' } },
	                        _react2.default.createElement(
	                          'span',
	                          null,
	                          'Thought leadership - Write blog / article'
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'flexby4_item', style: { backgroundImage: 'url(\'/images/advisory/8.png\')' } },
	                        _react2.default.createElement(
	                          'span',
	                          null,
	                          'Leadership trainings and team building'
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(_reactNotifications.NotificationContainer, null)
	        )
	      );
	    }
	  }]);
	
	  return WcAdvisory;
	}(_react.Component);
	
	exports.default = WcAdvisory;

/***/ },
/* 1048 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	__webpack_require__(18);
	
	var _reactNotifications = __webpack_require__(16);
	
	var _jsHtml2pdf = __webpack_require__(1312);
	
	var _jsHtml2pdf2 = _interopRequireDefault(_jsHtml2pdf);
	
	var _jszip = __webpack_require__(1326);
	
	var _jszip2 = _interopRequireDefault(_jszip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import { Editor } from '@tinymce/tinymce-react';
	
	var Wcapplicants = function (_Component) {
	  _inherits(Wcapplicants, _Component);
	
	  function Wcapplicants(props) {
	    _classCallCheck(this, Wcapplicants);
	
	    var _this = _possibleConstructorReturn(this, (Wcapplicants.__proto__ || Object.getPrototypeOf(Wcapplicants)).call(this, props));
	
	    _this.generatePDF = function (e) {
	
	      var getTeacherID = (0, _jquery2.default)(e.target).attr('data-teacher_id');
	
	      var req = JSON.stringify({
	        teacher_id: getTeacherID
	      });
	
	      (0, _FetchCall.generatePdfHtml)(req).then(function (response) {
	
	        if (response.status == 1) {
	
	          var html = response.html;
	
	          var options = { margin: 5, filename: 'profile_wiseconnect' + getTeacherID + '.pdf', html2canvas: { scale: 2 }, jsPDF: { unit: 'mm', format: 'a4', orientation: 'p' } };
	          var exporter = new _jsHtml2pdf2.default(html, options);
	          exporter.getPdf(true);
	        }
	      });
	    };
	
	    _this.handleAction = function (e) {
	
	      var thisaction = (0, _jquery2.default)(e.target);
	      //alert(thisaction);
	      thisaction.find('dropdown-content').addClass('show');
	    };
	
	    _this.handleClick = function (e) {
	      alert(e.target);
	      (0, _jquery2.default)(e.target).parent().find('select_wrap').toggleClass("active");
	    };
	
	    _this.showListNew = function (e) {
	
	      (0, _jquery2.default)(".btn-plain").removeClass('active');
	
	      var thisaction = (0, _jquery2.default)(e.target);
	      thisaction.addClass('active');
	
	      var req = JSON.stringify({
	        job_id: _this.job_id,
	        status: 'Applied'
	      });
	
	      (0, _FetchCall.getApplicants)(req).then(function (response) {
	
	        if (response.status == 1) {
	
	          _this.setState({ applicants: response.list });
	          //NotificationManager.success('Changed Status Successfully',  'Change Status - Job Applicant');
	        } else {
	
	          _reactNotifications.NotificationManager.error('Sorry no data found..', 'Job Applicants');
	          _this.setState({ applicants: [] });
	        }
	      });
	    };
	
	    _this.showListStandBy = function (e) {
	
	      (0, _jquery2.default)(".btn-plain").removeClass('active');
	
	      var thisaction = (0, _jquery2.default)(e.target);
	      thisaction.addClass('active');
	
	      var req = JSON.stringify({
	        job_id: _this.job_id,
	        status: 'On-Hold'
	      });
	
	      (0, _FetchCall.getApplicants)(req).then(function (response) {
	
	        if (response.status == 1) {
	
	          //NotificationManager.success('Changed Status Successfully',  'Change Status - Job Applicant');
	          _this.setState({ applicants: response.list });
	        } else {
	
	          _reactNotifications.NotificationManager.error('Sorry no data found..', 'Job Applicants');
	          _this.setState({ applicants: [] });
	        }
	      });
	    };
	
	    _this.showListShorlisted = function (e) {
	
	      (0, _jquery2.default)(".btn-plain").removeClass('active');
	
	      var thisaction = (0, _jquery2.default)(e.target);
	      thisaction.addClass('active');
	
	      var req = JSON.stringify({
	        job_id: _this.job_id,
	        status: 'Shortlisted'
	      });
	
	      (0, _FetchCall.getApplicants)(req).then(function (response) {
	
	        if (response.status == 1) {
	
	          _this.setState({ applicants: response.list });
	          //NotificationManager.success('Changed Status Successfully',  'Change Status - Job Applicant');
	        } else {
	
	          _reactNotifications.NotificationManager.error('Sorry no data found..', 'Job Applicants');
	          _this.setState({ applicants: [] });
	        }
	      });
	    };
	
	    _this.handleChange = function (e) {
	      _this.setState(_defineProperty({}, e.target.name, e.target.value));
	
	      if (e.target.value == 'Other') {
	        _this.setState(_defineProperty({}, e.target.name + "_other_disabled", false));
	      }
	    };
	
	    _this.state = {
	      logged: localStorage.getItem("authentication"),
	      auth_data: JSON.parse(localStorage.getItem("user_data")),
	      category_data: [], collapse: 0, modalReply: false,
	      current_comment: '', current_rid: 0, current_eid: '',
	      applicants: [],
	      zipFile: null,
	      detail: []
	    };
	    _this.getApplicants = _this.getApplicants.bind(_this);
	    _this.showListStandBy = _this.showListStandBy.bind(_this);
	    _this.showListShorlisted = _this.showListShorlisted.bind(_this);
	    //this.downloadZipFile = this.downloadZipFile.bind(this);
	    _this.job_id = _this.props.match.params.jobid;
	    return _this;
	  }
	
	  _createClass(Wcapplicants, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	
	      var THIS = this;
	      var auth_data = JSON.parse(localStorage.getItem("user_data"));
	      var user_id = auth_data.login_id;
	
	      (0, _jquery2.default)(document).on('click', '.default_option', function () {
	        (0, _jquery2.default)(this).parent().toggleClass("active");
	      });
	
	      (0, _jquery2.default)(document).on('click', '.select_ul li', function () {
	
	        var currentele = (0, _jquery2.default)(this).html();
	
	        //alert($(this).attr('data-applicant'));
	        var applicant_id = (0, _jquery2.default)(this).attr('data-applicant');
	        var job_id = (0, _jquery2.default)(this).attr('data-job_id');
	        var status = (0, _jquery2.default)(this).attr('data-status');
	
	        var req = JSON.stringify({
	          applicant_id: applicant_id,
	          job_id: job_id,
	          status: status,
	          user_id: user_id
	        });
	
	        (0, _FetchCall.saveJobStatus)(req).then(function (response) {
	
	          if (response.status == 1) {
	
	            _reactNotifications.NotificationManager.success('Changed Status Successfully', 'Change Status - Job Applicant');
	          } else {
	
	            _reactNotifications.NotificationManager.error('Error saving..', 'Change Status - Job Applicant');
	          }
	        });
	
	        (0, _jquery2.default)(".default_option li").html(currentele);
	        (0, _jquery2.default)(this).parents(".select_wrap").removeClass("active");
	      });
	
	      this.getApplicants();
	      this.getJobDetail();
	    }
	  }, {
	    key: 'generateZip',
	    value: function generateZip() {
	
	      var zip = new _jszip2.default();
	      zip.file("Hello.txt", "Hello World\n");
	      zip.generateAsync({ type: "blob" }).then(function (content) {
	        // see FileSaver.js
	        //saveAs(content, "example.zip");
	      });
	    }
	  }, {
	    key: 'getJobDetail',
	    value: function getJobDetail() {
	      var _this2 = this;
	
	      var req = JSON.stringify({
	        job_id: this.job_id
	      });
	
	      (0, _FetchCall.getJobDetail)(req).then(function (response) {
	
	        if (response.status == 1) {
	          _this2.setState({ detail: response.detail });
	          //NotificationManager.success('Changed Status Successfully',  'Change Status - Job Applicant');
	        } else {
	
	          _this2.setState({ detail: [] });
	        }
	      });
	    }
	  }, {
	    key: 'getApplicants',
	    value: function getApplicants() {
	      var _this3 = this;
	
	      var req = JSON.stringify({
	        job_id: this.job_id,
	        status: 'Applied'
	      });
	
	      (0, _FetchCall.getApplicants)(req).then(function (response) {
	
	        if (response.status == 1) {
	          _this3.setState({ applicants: response.list });
	          //NotificationManager.success('Changed Status Successfully',  'Change Status - Job Applicant');
	        } else {
	
	          _this3.setState({ applicants: [] });
	        }
	      });
	    }
	  }, {
	    key: 'cancelPop',
	    value: function cancelPop() {
	      this.setState({ blockinstopenmodal: false });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _state = this.state,
	          applicants = _state.applicants,
	          detail = _state.detail;
	
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'col-12 grid-margin' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card-body' },
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'boxtitle' },
	                  _react2.default.createElement('img', { src: '../../../images/profile/about.png' }),
	                  'View Applicants'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'content-section  borderedbox' },
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'flexbtns ' },
	                    _react2.default.createElement(
	                      'button',
	                      { 'class': 'btn-plain active', onClick: this.showListNew },
	                      'New Applicants'
	                    ),
	                    ' \xA0',
	                    _react2.default.createElement(
	                      'button',
	                      { 'class': 'btn-plain', onClick: this.showListShorlisted },
	                      'Shortlisted Applicants'
	                    ),
	                    ' \xA0 ',
	                    _react2.default.createElement(
	                      'button',
	                      { 'class': 'btn-plain', onClick: this.showListStandBy },
	                      'On-Hold Applicants'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'topsection' },
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'flex noapps' },
	                      _react2.default.createElement('img', { src: '../../../images/ins/applicant.png', 'class': 'icons' }),
	                      ' ',
	                      applicants.length,
	                      ' Applicants : ',
	                      _react2.default.createElement(
	                        'a',
	                        { href: "/partner/wiseconnect/viewjob/" + this.job_id, 'class': 'spantext' },
	                        ' ',
	                        detail.job_title
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'content-section contentmiddle borderedbox' },
	                  applicants.length > 0 && _react2.default.createElement(
	                    'div',
	                    { 'class': 'flexbtns' },
	                    _react2.default.createElement(
	                      'button',
	                      { 'class': 'btn btn-small bluebtn', onClick: this.generateZip },
	                      'Export All (',
	                      applicants.length,
	                      ') as PDFs (zip)'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'listingsapplicants' },
	                    applicants.length > 0 && applicants.map(function (item, i) {
	
	                      return _react2.default.createElement(
	                        'div',
	                        { 'class': 'eachapplicantrow' },
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'iconbag' },
	                          _react2.default.createElement('img', { src: "../../../images/profile.png" })
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'jobdetail' },
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'jobname' },
	                            item.name
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'jobclass' },
	                            item.aboutme
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'jobattributes tags' },
	                            _react2.default.createElement(
	                              'span',
	                              { 'class': 'tag' },
	                              item.job_category
	                            ),
	                            _react2.default.createElement(
	                              'span',
	                              { 'class': 'tag' },
	                              item.job_experience,
	                              ' year(s)'
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'buttonsec_sm flex' },
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'select_wrap' },
	                            _react2.default.createElement(
	                              'ul',
	                              { 'class': 'default_option' },
	                              _react2.default.createElement(
	                                'li',
	                                { 'class': 'btn-white-full-li' },
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'option pizza' },
	                                  _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    item.applied_job_status
	                                  )
	                                )
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'ul',
	                              { 'class': 'select_ul' },
	                              _react2.default.createElement(
	                                'li',
	                                { 'data-applicant': item.teacher_id, 'data-job_id': item.job_id, 'data-status': 'On-Hold', onClick: _this4.changeStatus },
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'option pizza' },
	                                  _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    'On-Hold'
	                                  )
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'li',
	                                { 'data-applicant': item.teacher_id, 'data-job_id': item.job_id, 'data-status': 'Shortlisted', onClick: _this4.changeStatus },
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'option burger' },
	                                  _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    'Shortlisted'
	                                  )
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'li',
	                                { 'data-applicant': item.teacher_id, 'data-job_id': item.job_id, 'data-status': 'Rejected', onClick: _this4.changeStatus },
	                                _react2.default.createElement(
	                                  'div',
	                                  { 'class': 'option ice' },
	                                  _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    'Rejected'
	                                  )
	                                )
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'alignleft' },
	                          _react2.default.createElement(
	                            'a',
	                            { href: "/partner/wiseconnect/viewprofile/" + item.teacher_id + "/" + _this4.job_id, 'class': 'btn btn-main-full' },
	                            'View Profile'
	                          ),
	                          '\xA0',
	                          _react2.default.createElement(
	                            'button',
	                            { onClick: _this4.generatePDF, 'data-teacher_id': item.teacher_id, 'class': 'btn btn-main-full' },
	                            'Download Profile'
	                          )
	                        )
	                      );
	                    }),
	                    applicants.length == 0 && _react2.default.createElement(
	                      'div',
	                      { 'class': 'nodata' },
	                      'No Data'
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(_reactNotifications.NotificationContainer, null)
	        )
	      );
	    }
	  }]);
	
	  return Wcapplicants;
	}(_react.Component);
	
	exports.default = Wcapplicants;

/***/ },
/* 1049 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _reactJsPagination = __webpack_require__(33);
	
	var _reactJsPagination2 = _interopRequireDefault(_reactJsPagination);
	
	__webpack_require__(18);
	
	var _reactNotifications = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import { Editor } from '@tinymce/tinymce-react';
	
	//import Pagination from 'rc-pagination';
	
	var Blogs = function (_Component) {
	  _inherits(Blogs, _Component);
	
	  function Blogs(props) {
	    _classCallCheck(this, Blogs);
	
	    var _this = _possibleConstructorReturn(this, (Blogs.__proto__ || Object.getPrototypeOf(Blogs)).call(this, props));
	
	    _this.getTotal = function () {
	
	      (0, _FetchCall.getTotalBlogs)().then(function (res) {
	
	        _this.setState({ loading: true });
	
	        if (res.status === 1) {
	
	          _this.setState({
	
	            total: res.total
	
	          });
	        }
	      });
	    };
	
	    _this.getList = function () {
	      var pageNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	      var location = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	      var _this$state$auth_data = _this.state.auth_data,
	          login_id = _this$state$auth_data.login_id,
	          role = _this$state$auth_data.role;
	
	
	      _this.setState({ activePage: pageNumber });
	
	      var newOffset = pageNumber === 1 ? 0 : (pageNumber - 1) * _this.state.PER_PAGE % _this.state.total;
	
	      var ins = JSON.stringify({
	        perpage: _this.state.PER_PAGE,
	        offset: newOffset
	      });
	
	      (0, _FetchCall.getBlogsListPaged)(ins).then(function (res) {
	
	        _this.setState({ loading: true });
	
	        if (res.status === 1) {
	
	          _this.setState({ loading: !_this.state.loading });
	
	          _this.setState({ list: res.list });
	        } else {
	
	          _this.setState({ loading: !_this.state.loading });
	
	          _this.setState({
	            list: []
	          });
	        }
	      });
	    };
	
	    _this.state = {
	      logged: localStorage.getItem("authentication"),
	      auth_data: JSON.parse(localStorage.getItem("user_data")),
	      category_data: [], collapse: 0, modalReply: false,
	      current_comment: '', current_rid: 0, current_eid: '',
	      PER_PAGE: 15,
	      total: 0,
	      loading: true,
	      list: [],
	      exportbtndisabled: false,
	      thisExportBtnText: 'Export'
	    };
	
	    _this.getTotal = _this.getTotal.bind(_this);
	    _this.getList = _this.getList.bind(_this);
	    return _this;
	  }
	
	  _createClass(Blogs, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	
	      //var THIS = this;
	      (0, _jquery2.default)(document).on('click', '.dlte', function () {
	        var _this2 = this;
	
	        var delete_id = (0, _jquery2.default)(this).data("id");
	
	        if (confirm("You are sure to delete?") === true) {
	
	          var ins = JSON.stringify({
	            id: delete_id,
	            table: 'wiseconnectblog'
	          });
	
	          (0, _FetchCall.removethisItem)(ins).then(function (res) {
	
	            if (res.status === 1) {
	              _reactNotifications.NotificationManager.success('Removed successfully');
	            } else {
	              _reactNotifications.NotificationManager.error('Issue in removing');
	            }
	            _this2.getTotal();
	            _this2.getList();
	          });
	        }
	      });
	      this.getTotal();
	      this.getList();
	    }
	  }, {
	    key: 'handlePageChange',
	    value: function handlePageChange(pageNumber) {
	
	      console.log('active page is ' + pageNumber);
	
	      this.setState({ activePage: pageNumber });
	
	      //this.getTotal('bw_schools');
	      this.getList(pageNumber);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var list = this.state.list;
	      var _state = this.state,
	          currentPage = _state.currentPage,
	          PER_PAGE = _state.PER_PAGE,
	          totalCount = _state.totalCount,
	          total = _state.total,
	          exportbtndisabled = _state.exportbtndisabled;
	
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'col-12 grid-margin' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card-body' },
	                _react2.default.createElement(
	                  'h4',
	                  { 'class': 'card-title' },
	                  'External Blogs - WiseConnect'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'float-right' },
	                  _react2.default.createElement(
	                    'a',
	                    { href: '/wiseconnect/addblog', 'class': 'btn btn-primary btn-sm' },
	                    'Add New'
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'table-responsive pt-3' },
	                  _react2.default.createElement(
	                    'table',
	                    { 'class': 'table table-bordered table-sm' },
	                    _react2.default.createElement(
	                      'thead',
	                      { 'class': 'thead-dark' },
	                      _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          'S.No'
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          'Blog title'
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          'Date'
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          'Status'
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          'Action'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'tbody',
	                      null,
	                      list.length > 0 && list.map(function (blog, i) {
	
	                        return _react2.default.createElement(
	                          'tr',
	                          null,
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            i + 1
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            blog.blog_title
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            new Intl.DateTimeFormat('en-US', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).format(blog.created_date)
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            blog.blog_status === 0 ? 'Inactive' : 'Active'
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            _react2.default.createElement(
	                              'a',
	                              { href: "/wiseconnect/editblog/" + blog.id, 'class': 'btn btn-primary btn-sm', 'data-id': blog.id },
	                              'Edit'
	                            ),
	                            '\xA0',
	                            _react2.default.createElement(
	                              'button',
	                              { 'class': 'btn btn-primary btn-sm dlte', 'data-id': blog.id },
	                              'Remove'
	                            )
	                          )
	                        );
	                      }),
	                      list.length === 0 && _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                          'td',
	                          { colSpan: '6' },
	                          'No data'
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'text-center' },
	                    _react2.default.createElement(_reactJsPagination2.default, {
	                      activePage: this.state.activePage,
	                      itemsCountPerPage: PER_PAGE,
	                      totalItemsCount: this.state.total,
	                      pageRangeDisplayed: 5,
	                      activeClass: "pagination__link--active",
	                      onChange: this.handlePageChange.bind(this),
	                      prevPageText: 'previous',
	                      nextPageText: 'next'
	                    })
	                  )
	                )
	              )
	            )
	          ),
	          '  ',
	          _react2.default.createElement(_reactNotifications.NotificationContainer, null)
	        )
	      );
	    }
	  }]);
	
	  return Blogs;
	}(_react.Component);
	
	exports.default = Blogs;

/***/ },
/* 1050 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _reactstrap = __webpack_require__(17);
	
	var _reactDataTableComponent = __webpack_require__(53);
	
	var _reactDataTableComponent2 = _interopRequireDefault(_reactDataTableComponent);
	
	var _reactJsPagination = __webpack_require__(33);
	
	var _reactJsPagination2 = _interopRequireDefault(_reactJsPagination);
	
	var _bewiseloading = __webpack_require__(48);
	
	var _bewiseloading2 = _interopRequireDefault(_bewiseloading);
	
	__webpack_require__(18);
	
	var _reactNotifications = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import { Editor } from '@tinymce/tinymce-react';
	
	//import Pagination from 'rc-pagination';
	
	var Courses = function (_Component) {
	  _inherits(Courses, _Component);
	
	  function Courses(props) {
	    _classCallCheck(this, Courses);
	
	    var _this = _possibleConstructorReturn(this, (Courses.__proto__ || Object.getPrototypeOf(Courses)).call(this, props));
	
	    _this.getTotal = function () {
	      var _this$state$auth_data = _this.state.auth_data,
	          login_id = _this$state$auth_data.login_id,
	          role = _this$state$auth_data.role;
	
	
	      var ins = JSON.stringify({
	        vertical: 'othercourses'
	      });
	
	      (0, _FetchCall.getTotal)(ins).then(function (res) {
	
	        _this.setState({ loading: true });
	
	        if (res.status == 1) {
	
	          _this.setState({
	
	            total: res.total
	
	          });
	        }
	      });
	    };
	
	    _this.getList = function () {
	      var pageNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	      var location = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	      var _this$state$auth_data2 = _this.state.auth_data,
	          login_id = _this$state$auth_data2.login_id,
	          role = _this$state$auth_data2.role;
	
	
	      _this.setState({ activePage: pageNumber });
	
	      var newOffset = pageNumber == 1 ? 0 : (pageNumber - 1) * _this.state.PER_PAGE % _this.state.total;
	
	      var ins = JSON.stringify({
	        perpage: _this.state.PER_PAGE,
	        offset: newOffset
	      });
	
	      (0, _FetchCall.getCoursesListPaged)(ins).then(function (res) {
	
	        _this.setState({ loading: true });
	
	        if (res.status == 1) {
	
	          _this.setState({ loading: !_this.state.loading });
	
	          _this.setState({ list: res.list });
	        } else {
	
	          _this.setState({ loading: !_this.state.loading });
	
	          _this.setState({
	            list: []
	          });
	        }
	      });
	    };
	
	    _this.state = {
	      logged: localStorage.getItem("authentication"),
	      auth_data: JSON.parse(localStorage.getItem("user_data")),
	      category_data: [], collapse: 0, modalReply: false,
	      current_comment: '', current_rid: 0, current_eid: '',
	      PER_PAGE: 15,
	      total: 0,
	      loading: true,
	      list: [],
	      exportbtndisabled: false,
	      thisExportBtnText: 'Export'
	    };
	
	    _this.getTotal = _this.getTotal.bind(_this);
	    _this.getList = _this.getList.bind(_this);
	    return _this;
	  }
	
	  _createClass(Courses, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	
	      var THIS = this;
	      (0, _jquery2.default)(document).on('click', '.dlte', function () {
	        var _this2 = this;
	
	        var delete_id = (0, _jquery2.default)(this).data("id");
	
	        if (confirm("You are sure to delete?") == true) {
	
	          var ins = JSON.stringify({
	            id: delete_id,
	            table: 'wiseconnect'
	          });
	
	          (0, _FetchCall.removethisItem)(ins).then(function (res) {
	
	            if (res.status == 1) {
	              _reactNotifications.NotificationManager.success('Removed successfully');
	            } else {
	              _reactNotifications.NotificationManager.error('Issue in removing');
	            }
	            _this2.getTotal();
	            _this2.getList();
	          });
	        }
	      });
	
	      this.getTotal();
	      this.getList();
	    }
	  }, {
	    key: 'handlePageChange',
	    value: function handlePageChange(pageNumber) {
	
	      console.log('active page is ' + pageNumber);
	
	      this.setState({ activePage: pageNumber });
	
	      //this.getTotal('bw_schools');
	      this.getList(pageNumber);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var list = this.state.list;
	      var _state = this.state,
	          currentPage = _state.currentPage,
	          PER_PAGE = _state.PER_PAGE,
	          totalCount = _state.totalCount,
	          total = _state.total,
	          exportbtndisabled = _state.exportbtndisabled;
	
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'col-12 grid-margin' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card-body' },
	                _react2.default.createElement(
	                  'h4',
	                  { 'class': 'card-title' },
	                  'List'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'float-right' },
	                  _react2.default.createElement(
	                    'a',
	                    { href: '/wiseconnect/createprovider', 'class': 'btn btn-primary btn-sm' },
	                    'Create Provider'
	                  ),
	                  '\xA0',
	                  _react2.default.createElement(
	                    'a',
	                    { href: '/wiseconnect/addcourse', 'class': 'btn btn-primary btn-sm' },
	                    'Add New'
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'table-responsive pt-3' },
	                  _react2.default.createElement(
	                    'table',
	                    { 'class': 'table table-bordered table-sm' },
	                    _react2.default.createElement(
	                      'thead',
	                      { 'class': 'thead-dark' },
	                      _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          'S.No'
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          'Name'
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          'Date'
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          'Provider'
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          'Status'
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          'Action'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'tbody',
	                      null,
	                      list.length > 0 && list.map(function (course, i) {
	
	                        return _react2.default.createElement(
	                          'tr',
	                          null,
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            i + 1
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            course.course_name
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            new Intl.DateTimeFormat('en-US', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).format(course.created_date)
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            course.institute_name
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            course.course_status == 0 ? 'Waiting for approval' : 'Approved'
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            _react2.default.createElement(
	                              'a',
	                              { href: "/wiseconnect/viewcourse/" + course.id, 'class': 'btn btn-primary btn-sm', 'data-id': course.id },
	                              'View'
	                            ),
	                            '\xA0',
	                            _react2.default.createElement(
	                              'button',
	                              { 'class': 'btn btn-primary btn-sm dlte', 'data-id': course.id },
	                              'Remove'
	                            )
	                          )
	                        );
	                      }),
	                      list.length == 0 && _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                          'td',
	                          { colSpan: '6' },
	                          'No data'
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'text-center' },
	                    _react2.default.createElement(_reactJsPagination2.default, {
	                      activePage: this.state.activePage,
	                      itemsCountPerPage: PER_PAGE,
	                      totalItemsCount: this.state.total,
	                      pageRangeDisplayed: 5,
	                      activeClass: "pagination__link--active",
	                      onChange: this.handlePageChange.bind(this),
	                      prevPageText: 'previous',
	                      nextPageText: 'next'
	                    })
	                  )
	                )
	              )
	            )
	          ),
	          '  ',
	          _react2.default.createElement(_reactNotifications.NotificationContainer, null)
	        )
	      );
	    }
	  }]);
	
	  return Courses;
	}(_react.Component);
	
	exports.default = Courses;

/***/ },
/* 1051 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	__webpack_require__(18);
	
	var _reactNotifications = __webpack_require__(16);
	
	var _reactRangeslider = __webpack_require__(79);
	
	var _reactRangeslider2 = _interopRequireDefault(_reactRangeslider);
	
	__webpack_require__(66);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import { Editor } from '@tinymce/tinymce-react';
	
	var CreateProvider = function (_Component) {
	  _inherits(CreateProvider, _Component);
	
	  function CreateProvider(props) {
	    _classCallCheck(this, CreateProvider);
	
	    var _this = _possibleConstructorReturn(this, (CreateProvider.__proto__ || Object.getPrototypeOf(CreateProvider)).call(this, props));
	
	    _this.handleChangeHorizontal = function (value) {
	      _this.setState({
	        salary_range_forthisjob: value
	      });
	    };
	
	    _this.handleChange = function (e) {
	      _this.setState(_defineProperty({}, e.target.name, e.target.value));
	
	      if (e.target.value == 'Other') {
	        _this.setState(_defineProperty({}, e.target.name + "_other_disabled", false));
	      }
	    };
	
	    _this.handleSubmit = function (e) {
	
	      var req = JSON.stringify({
	        name: _this.state.name,
	        email: _this.state.email,
	        password: _this.state.password,
	        status: _this.state.status
	      });
	
	      (0, _FetchCall.createprovider)(req).then(function (response) {
	
	        if (response.status == 1) {
	
	          _reactNotifications.NotificationManager.success('created provider successfully', 'Create Provider');
	
	          setTimeout(function () {
	            window.location.replace('/wiseconnect/listproviders');
	          }, 1000);
	        } else {
	
	          _reactNotifications.NotificationManager.error('Error creating a provider', 'Create Provider');
	        }
	      });
	    };
	
	    _this.state = {
	      logged: localStorage.getItem("authentication"),
	      auth_data: JSON.parse(localStorage.getItem("user_data")),
	      category_data: [], collapse: 0, modalReply: false,
	      current_comment: '', current_rid: 0, current_eid: '',
	      PER_PAGE: 15,
	      total: 0,
	      loading: true,
	      list: []
	    };
	
	    _this.cancelPop = _this.cancelPop.bind(_this);
	    _this.handleChange = _this.handleChange.bind(_this);
	
	    return _this;
	  }
	
	  _createClass(CreateProvider, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	
	      var THIS = this;
	    }
	  }, {
	    key: 'cancelPop',
	    value: function cancelPop() {
	      this.setState({ blockinstopenmodal: false });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          value = _state.value,
	          suggestions = _state.suggestions,
	          pickedones = _state.pickedones;
	
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'col-12 grid-margin' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card-body' },
	                _react2.default.createElement(
	                  'h4',
	                  { 'class': 'card-title' },
	                  'Create Provider'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'postajobform wc' },
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup end_date_option', id: 'end_date_option' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Name '
	                    ),
	                    _react2.default.createElement('input', { type: 'text', 'class': 'form-control forminputcls', id: 'name', name: 'name', onChange: this.handleChange })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup end_date_option', id: 'end_date_option' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Email '
	                    ),
	                    _react2.default.createElement('input', { type: 'email', 'class': 'form-control forminputcls', id: 'email', name: 'email', onChange: this.handleChange })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup end_date_option', id: 'end_date_option' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Password '
	                    ),
	                    _react2.default.createElement('input', { type: 'text', 'class': 'form-control forminputcls', id: 'password', name: 'password', onChange: this.handleChange })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup end_date_option', id: 'end_date_option' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Status '
	                    ),
	                    _react2.default.createElement(
	                      'select',
	                      { name: 'status', 'class': 'form-control selectdropdowns', onChange: this.handleChange },
	                      _react2.default.createElement(
	                        'option',
	                        { value: '' },
	                        'select status'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: '1' },
	                        'Active'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: '0' },
	                        'Inactive'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: '2' },
	                        'Waiting'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup text-center paddingtop20' },
	                    _react2.default.createElement(
	                      'button',
	                      { type: 'button', name: 'postajob', 'class': 'btn btn-primary', onClick: this.handleSubmit },
	                      'Submit'
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(_reactNotifications.NotificationContainer, null)
	        )
	      );
	    }
	  }]);
	
	  return CreateProvider;
	}(_react.Component);
	
	exports.default = CreateProvider;

/***/ },
/* 1052 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	__webpack_require__(18);
	
	var _reactNotifications = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import { Editor } from '@tinymce/tinymce-react';
	
	
	var IMGURL = "https://bewiseblobprod.blob.core.windows.net/assets/bewise/uploads/";
	
	var Wcdashboard = function (_Component) {
	  _inherits(Wcdashboard, _Component);
	
	  function Wcdashboard(props) {
	    _classCallCheck(this, Wcdashboard);
	
	    var _this = _possibleConstructorReturn(this, (Wcdashboard.__proto__ || Object.getPrototypeOf(Wcdashboard)).call(this, props));
	
	    _this.state = {
	      logged: localStorage.getItem("authentication"),
	      auth_data: JSON.parse(localStorage.getItem("user_data")),
	      category_data: [], collapse: 0, modalReply: false,
	      current_comment: '', current_rid: 0, current_eid: '',
	      PER_PAGE: 15,
	      total: 0,
	      loading: true,
	      list: [],
	      exportbtndisabled: false,
	      thisExportBtnText: 'Export',
	      jobList: [],
	
	      totaljobposted: 0,
	      totalapplicants: 0
	    };
	
	    return _this;
	  }
	
	  _createClass(Wcdashboard, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _state$auth_data = this.state.auth_data,
	          login_id = _state$auth_data.login_id,
	          role = _state$auth_data.role,
	          profilepicture = _state$auth_data.profilepicture;
	
	
	      this.user_id = login_id;
	      this.getJobs();
	      this.getTotalApplicants();
	    }
	  }, {
	    key: 'getTotalApplicants',
	    value: function getTotalApplicants() {
	      var _this2 = this;
	
	      var req = JSON.stringify({
	        user_id: this.user_id
	      });
	
	      (0, _FetchCall.getTotalApplicants)(req).then(function (response) {
	
	        if (response.status == 1) {
	
	          _this2.setState({ totalapplicants: response.totalapplicants });
	        }
	      });
	    }
	  }, {
	    key: 'getJobs',
	    value: function getJobs() {
	      var _this3 = this;
	
	      var req = JSON.stringify({
	        user_id: this.user_id
	      });
	
	      (0, _FetchCall.getjobs)(req).then(function (response) {
	
	        if (response.status == 1) {
	
	          _this3.setState({ jobList: response.list, totaljobposted: response.list.length });
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      var profilepicture = this.state.auth_data.profilepicture;
	      var organisation = this.state.auth_data.organisation;
	
	      var _state = this.state,
	          value = _state.value,
	          totaljobposted = _state.totaljobposted,
	          totalapplicants = _state.totalapplicants,
	          suggestions = _state.suggestions,
	          pickedones = _state.pickedones,
	          jobList = _state.jobList;
	
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'col-12 grid-margin' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card-body' },
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'org_name_full_width' },
	                  'Organisation:',
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    organisation
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'content-section contenttop borderedbox' },
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'insprofilephoto' },
	                    _react2.default.createElement('img', { src: IMGURL + profilepicture })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'currentlyhiring purplebox' },
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'textDark' },
	                      'Currently hiring for'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'textDark largNumber' },
	                      totaljobposted
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'textnormal' },
	                      'roles'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'noofapplicants purplebox' },
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'textDark' },
	                      'No of applicants'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'textDark largNumber' },
	                      totalapplicants
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'textnormal' },
	                      'applicants'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'buttonsec_lg' },
	                    _react2.default.createElement(
	                      'div',
	                      null,
	                      _react2.default.createElement(
	                        'a',
	                        { href: '/partner/wcpostajob', 'class': 'btn btn-main-full' },
	                        'Post job'
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'content-section contentmiddle borderedbox' },
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'boxtitle' },
	                    _react2.default.createElement('img', { src: '../../images/profile/about.png' }),
	                    'Your Postings'
	                  ),
	                  jobList.length == 0 && _react2.default.createElement(
	                    'div',
	                    null,
	                    'You have not posted any jobs yet'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'listingsapplicants' },
	                    jobList.map(function (item, i) {
	
	                      return _react2.default.createElement(
	                        'div',
	                        { 'class': 'eachapplicantrow' },
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'iconbag_jobs' },
	                          _react2.default.createElement('img', { src: '../../images/ins/experience.png' })
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'jobdetail' },
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'jobname' },
	                            item.job_title,
	                            ' ',
	                            _react2.default.createElement(
	                              'span',
	                              { className: item.job_status == 3 ? "jobsaved" : "jobactive" },
	                              item.job_status == 3 ? "Draft" : "Active"
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'jobclass' },
	                            item.job_location
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'jobattributes tags' },
	                            _react2.default.createElement(
	                              'span',
	                              { 'class': 'tag' },
	                              item.job_category
	                            ),
	                            _react2.default.createElement(
	                              'span',
	                              { 'class': 'tag' },
	                              item.experience
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'buttonsec_sm' },
	                          _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                              'a',
	                              { href: '/partner/wiseconnect/applicants/' + item.id, 'class': 'btn btn-white-full' },
	                              item.totalapplied,
	                              ' Applicants'
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                              'a',
	                              { href: '/partner/wiseconnect/viewjob/' + item.id, 'class': 'btn btn-main-full' },
	                              'Manage'
	                            )
	                          )
	                        )
	                      );
	                    })
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(_reactNotifications.NotificationContainer, null)
	        )
	      );
	    }
	  }]);
	
	  return Wcdashboard;
	}(_react.Component);
	
	exports.default = Wcdashboard;

/***/ },
/* 1053 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import Html2Pdf from 'js-html2pdf';
	
	//import {useReactToPrint} from 'react-to-print';
	
	var IMG_URL = "http://localhost:5005/"; //"https://api.bewise.in/";
	
	var DownloadProfile = function (_Component) {
	  _inherits(DownloadProfile, _Component);
	
	  function DownloadProfile(props) {
	    _classCallCheck(this, DownloadProfile);
	
	    var _this = _possibleConstructorReturn(this, (DownloadProfile.__proto__ || Object.getPrototypeOf(DownloadProfile)).call(this, props));
	
	    _this.state = {
	      logged: localStorage.getItem("authentication"),
	      auth_data: JSON.parse(localStorage.getItem("user_data"))
	
	    };
	
	    _this.teacher_id = _this.props.match.params.id;
	
	    /*
	    var element = document.getElementById('element-to-print');
	    var opt = {
	     margin:       1,
	     filename:     'myfile.pdf',
	     image:        { type: 'jpeg', quality: 0.98 },
	     html2canvas:  { scale: 2 },
	     jsPDF:        { unit: 'in', format: 'letter', orientation: 'portrait' }
	    };
	    
	    // New Promise-based usage:
	    Html2Pdf().from(element).set(opt).save();
	    */
	
	    return _this;
	  }
	
	  _createClass(DownloadProfile, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	
	      this.generatePdfHtml();
	    }
	  }, {
	    key: 'generatePdfHtml',
	    value: function generatePdfHtml() {
	
	      var req = JSON.stringify({
	        teacher_id: this.teacher_id
	      });
	
	      (0, _FetchCall.generatePdfHtml)(req).then(function (response) {
	
	        if (response.status == 1) {
	
	          /*
	            var html = response.html;
	           var options = { filename: 'my-file.pdf', jsPDF: {unit: 'mm', format: 'a4', orientation: 'p'}};
	           const exporter = new Html2Pdf(html, options);
	           exporter.getPdf(true);
	           */
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          userinfo = _state.userinfo,
	          experiences = _state.experiences,
	          educations = _state.educations;
	
	
	      return _react2.default.createElement(_react2.default.Fragment, null);
	    }
	  }]);
	
	  return DownloadProfile;
	}(_react.Component);
	
	exports.default = DownloadProfile;

/***/ },
/* 1054 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	__webpack_require__(18);
	
	var _reactNotifications = __webpack_require__(16);
	
	var _reactRangeslider = __webpack_require__(79);
	
	var _reactRangeslider2 = _interopRequireDefault(_reactRangeslider);
	
	__webpack_require__(66);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import { Editor } from '@tinymce/tinymce-react';
	
	var Editblog = function (_Component) {
	    _inherits(Editblog, _Component);
	
	    function Editblog(props) {
	        _classCallCheck(this, Editblog);
	
	        var _this = _possibleConstructorReturn(this, (Editblog.__proto__ || Object.getPrototypeOf(Editblog)).call(this, props));
	
	        _this.handleChange = function (e) {
	            _this.setState(_defineProperty({}, e.target.name, e.target.value));
	        };
	
	        _this.handleSubmit = function (e) {
	
	            var req = JSON.stringify({
	
	                blog_title: _this.state.blog_title,
	                blog_url: _this.state.blog_url,
	                blog_status: _this.state.blog_status,
	                blog_id: _this.id
	            });
	
	            (0, _FetchCall.updateablog)(req).then(function (response) {
	
	                if (response.status == 1) {
	
	                    _reactNotifications.NotificationManager.success('Updated successfully', 'Post an external article');
	                } else {
	
	                    _reactNotifications.NotificationManager.error('Error', 'Post an external article');
	                }
	            });
	        };
	
	        _this.state = {
	            logged: localStorage.getItem("authentication"),
	            auth_data: JSON.parse(localStorage.getItem("user_data")),
	            category_data: [], collapse: 0, modalReply: false,
	            current_comment: '', current_rid: 0, current_eid: '',
	            PER_PAGE: 15,
	            total: 0,
	            loading: true,
	            list: [],
	            salary_range_forthisjob: 15000,
	            organisation_place: '',
	            organisation: '',
	            job_role_other_disabled: true,
	            job_subject_teaching_other_disabled: true,
	            expected_qualification_other_disabled: true,
	            examcertifications_other_disabled: true,
	            skillsrequired_other_disabled: true
	        };
	
	        _this.id = _this.props.match.params.id;
	
	        _this.handleChange = _this.handleChange.bind(_this);
	
	        return _this;
	    }
	
	    _createClass(Editblog, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	
	            var THIS = this;
	
	            this.getExtBlog();
	        }
	    }, {
	        key: 'getExtBlog',
	        value: function getExtBlog() {
	            var _this2 = this;
	
	            var req = JSON.stringify({
	                id: this.id
	            });
	
	            (0, _FetchCall.getExtBlogById)(req).then(function (res) {
	                if (res.status == 1) {
	                    var data = res.detail;
	                    _this2.setState({
	                        blog_title: data.blog_title,
	                        blog_url: data.blog_url,
	                        blog_status: data.blog_status
	                    });
	                }
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	
	            return _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _react2.default.createElement(
	                    _layout2.default,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { 'class': 'col-12 grid-margin' },
	                        _react2.default.createElement(
	                            'div',
	                            { 'class': 'card' },
	                            _react2.default.createElement(
	                                'div',
	                                { 'class': 'card-body' },
	                                _react2.default.createElement(
	                                    'h4',
	                                    { 'class': 'card-title' },
	                                    'External Blog - Add'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'postajobform wc' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'formgroup end_date_option', id: 'end_date_option' },
	                                        _react2.default.createElement(
	                                            'label',
	                                            { 'for': 'exampleInputPassword1' },
	                                            'Blog Title '
	                                        ),
	                                        _react2.default.createElement('input', { type: 'text', 'class': 'form-control forminputcls', id: 'blog_title', name: 'blog_title', value: this.state.blog_title, onChange: this.handleChange })
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'formgroup end_date_option', id: 'end_date_option' },
	                                        _react2.default.createElement(
	                                            'label',
	                                            { 'for': 'exampleInputPassword1' },
	                                            'Blog External URL '
	                                        ),
	                                        _react2.default.createElement('input', { type: 'text', 'class': 'form-control forminputcls', id: 'blog_url', name: 'blog_url', value: this.state.blog_url, onChange: this.handleChange })
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'formgroup end_date_option', id: 'end_date_option' },
	                                        _react2.default.createElement(
	                                            'label',
	                                            { 'for': 'exampleInputPassword1' },
	                                            'Status'
	                                        ),
	                                        _react2.default.createElement(
	                                            'select',
	                                            { name: 'blog_status', 'class': 'formselectinputcls', value: this.state.blog_status, onChange: this.handleChange },
	                                            _react2.default.createElement(
	                                                'option',
	                                                { value: '' },
	                                                'Select'
	                                            ),
	                                            _react2.default.createElement(
	                                                'option',
	                                                { value: '1' },
	                                                'Active'
	                                            ),
	                                            _react2.default.createElement(
	                                                'option',
	                                                { value: '0' },
	                                                'InActive'
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'formgroup text-center paddingtop20' },
	                                        _react2.default.createElement(
	                                            'button',
	                                            { type: 'button', name: 'postablog', 'class': 'btn btn-primary', onClick: this.handleSubmit },
	                                            'Submit'
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(_reactNotifications.NotificationContainer, null)
	                )
	            );
	        }
	    }]);
	
	    return Editblog;
	}(_react.Component);
	
	exports.default = Editblog;

/***/ },
/* 1055 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	__webpack_require__(18);
	
	var _reactNotifications = __webpack_require__(16);
	
	var _multiselectReactDropdown = __webpack_require__(73);
	
	var _reactRangeslider = __webpack_require__(79);
	
	var _reactRangeslider2 = _interopRequireDefault(_reactRangeslider);
	
	__webpack_require__(66);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import { Editor } from '@tinymce/tinymce-react';
	
	var Editjob = function (_Component) {
	  _inherits(Editjob, _Component);
	
	  function Editjob(props) {
	    _classCallCheck(this, Editjob);
	
	    var _this = _possibleConstructorReturn(this, (Editjob.__proto__ || Object.getPrototypeOf(Editjob)).call(this, props));
	
	    _this.handleChangeHorizontal = function (value) {
	      _this.setState({
	        salary_range_forthisjob: value
	      });
	    };
	
	    _this.handleChange = function (e) {
	      _this.setState(_defineProperty({}, e.target.name, e.target.value));
	
	      if (e.target.value == 'Other') {
	        _this.setState(_defineProperty({}, e.target.name + "_other_disabled", false));
	      }
	    };
	
	    _this.handleSubmit = function (e) {
	
	      var auth_data = JSON.parse(localStorage.getItem("user_data"));
	
	      var req = JSON.stringify({
	        job_id: _this.job_id,
	        user_id: 1,
	        job_title: _this.state.job_title,
	        job_category: _this.state.job_category,
	        job_description: _this.state.job_description,
	        job_gender: _this.state.job_gender,
	        organisation: _this.state.organisation,
	        open_date: _this.state.open_date,
	        closing_date: _this.state.closing_date,
	        job_location: _this.state.job_location,
	        joining: _this.state.joining,
	        salary_range_forthisjob: _this.state.salary_range_forthisjob,
	        language_preferred: _this.state.language_preferred,
	        expected_qualification: _this.state.expected_qualification,
	        skillsrequired: _this.state.skillsrequired,
	        job_role: _this.state.job_role,
	        job_subject_teaching: _this.state.job_subject_teaching,
	        job_experience: _this.state.job_experience,
	        examcertifications: _this.state.examcertifications,
	        expected_qualification_other: _this.state.expected_qualification_other,
	        skillsrequired_other: _this.state.skillsrequired_other,
	        job_role_other: _this.state.job_role_other,
	        job_subject_teaching_other: _this.state.job_subject_teaching_other,
	        examcertifications_other: _this.state.examcertifications_other
	
	      });
	
	      (0, _FetchCall.updatejob)(req).then(function (response) {
	
	        if (response.status == 1) {
	
	          _reactNotifications.NotificationManager.success('Posted job successfully', 'Post a job');
	        } else {
	
	          _reactNotifications.NotificationManager.error('Error posting a job', 'Post a job');
	        }
	      });
	    };
	
	    _this.onSelect = function (selectedList) {
	      var keywords = [];
	      selectedList.map(function (item, i) {
	        keywords.push(item);
	      });
	      _this.setState({
	        language_preferred: keywords.toString()
	      });
	    };
	
	    _this.onRemove = function (selectedList, removedItem) {
	      var keywords = [];
	      selectedList.map(function (item, i) {
	        keywords.push(item);
	      });
	      _this.setState({
	        language_preferred: keywords.toString()
	      });
	    };
	
	    _this.onSelectExpectedQualification = function (selectedList) {
	      var keywords = [];
	      selectedList.map(function (item, i) {
	        keywords.push(item);
	      });
	      _this.setState({
	        expected_qualification: keywords.toString()
	      });
	    };
	
	    _this.onRemoveExpQualification = function (selectedList, removedItem) {
	      var keywords = [];
	      selectedList.map(function (item, i) {
	        keywords.push(item);
	      });
	      _this.setState({
	        expected_qualification: keywords.toString()
	      });
	    };
	
	    _this.onSelectExamCertificaitons = function (selectedList) {
	      var keywords = [];
	      selectedList.map(function (item, i) {
	        keywords.push(item);
	      });
	      _this.setState({
	        examcertifications: keywords.toString()
	      });
	    };
	
	    _this.onRemoveExamCertifications = function (selectedList, removedItem) {
	      var keywords = [];
	      selectedList.map(function (item, i) {
	        keywords.push(item);
	      });
	      _this.setState({
	        examcertifications: keywords.toString()
	      });
	    };
	
	    _this.onSelectSkillRequired = function (selectedList) {
	      var keywords = [];
	      selectedList.map(function (item, i) {
	        keywords.push(item);
	      });
	      _this.setState({
	        skillsrequired: keywords.toString()
	      });
	    };
	
	    _this.onRemoveSkillRequired = function (selectedList, removedItem) {
	      var keywords = [];
	      selectedList.map(function (item, i) {
	        keywords.push(item);
	      });
	      _this.setState({
	        skillsrequired: keywords.toString()
	      });
	    };
	
	    _this.state = {
	      logged: localStorage.getItem("authentication"),
	      auth_data: JSON.parse(localStorage.getItem("user_data")),
	      category_data: [], collapse: 0, modalReply: false,
	      current_comment: '', current_rid: 0, current_eid: '',
	      PER_PAGE: 15,
	      total: 0,
	      loading: true,
	      job: [],
	      salary_range_forthisjob: 15000,
	      organisation_place: '',
	      organisation: '',
	      job_role_other_disabled: true,
	      job_subject_teaching_other_disabled: true,
	      expected_qualification_other_disabled: true,
	      examcertifications_other_disabled: true,
	      skillsrequired_other_disabled: true
	    };
	
	    _this.job_id = _this.props.match.params.id;
	
	    _this.cancelPop = _this.cancelPop.bind(_this);
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.getJobDetail = _this.getJobDetail.bind(_this);
	
	    return _this;
	  }
	
	  _createClass(Editjob, [{
	    key: 'getJobDetail',
	    value: function getJobDetail() {
	      var _this2 = this;
	
	      var req = JSON.stringify({
	        job_id: this.job_id
	      });
	
	      (0, _FetchCall.getJobDetail)(req).then(function (response) {
	
	        if (response.status == 1) {
	          var _this2$setState;
	
	          _this2.setState((_this2$setState = {
	            job_title: response.detail.job_title,
	            salary_range_forthisjob: response.detail.salary_range_forthisjob,
	            job_category: response.detail.job_category,
	            job_description: response.detail.job_description,
	            job_gender: response.detail.job_gender,
	            organisation: response.detail.organisation,
	            open_date: response.detail.open_date,
	            closing_date: response.detail.closing_date,
	            job_location: response.detail.job_location,
	            joining: response.detail.joining
	          }, _defineProperty(_this2$setState, 'salary_range_forthisjob', response.detail.salary_range_forthisjob), _defineProperty(_this2$setState, 'language_preferred', response.detail.language_preferred), _defineProperty(_this2$setState, 'expected_qualification', response.detail.expected_qualification), _defineProperty(_this2$setState, 'skillsrequired', response.detail.skillsrequired), _defineProperty(_this2$setState, 'job_role', response.detail.job_role), _defineProperty(_this2$setState, 'job_subject_teaching', response.detail.job_subject_teaching), _defineProperty(_this2$setState, 'job_experience', response.detail.job_experience), _defineProperty(_this2$setState, 'examcertifications', response.detail.examcertifications), _defineProperty(_this2$setState, 'expected_qualification_other', response.detail.expected_qualification_other), _defineProperty(_this2$setState, 'skillsrequired_other', response.detail.skillsrequired_other), _defineProperty(_this2$setState, 'job_role_other', response.detail.job_role_other), _defineProperty(_this2$setState, 'job_subject_teaching_other', response.detail.job_subject_teaching_other), _defineProperty(_this2$setState, 'examcertifications_other', response.detail.examcertifications_other), _this2$setState));
	        } else {
	          _this2.setState({ job: [] });
	        }
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	
	      var THIS = this;
	      this.getJobDetail();
	    }
	  }, {
	    key: 'cancelPop',
	    value: function cancelPop() {
	      this.setState({ blockinstopenmodal: false });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          value = _state.value,
	          suggestions = _state.suggestions,
	          pickedones = _state.pickedones;
	      var _state2 = this.state,
	          salary_range_forthisjob = _state2.salary_range_forthisjob,
	          vertical = _state2.vertical;
	
	      var horizontalLabels = {
	        12000: '12k',
	        400000: '4L'
	      };
	
	      var job = this.state.job;
	
	
	      var formatkg = function formatkg(value) {
	        return value;
	      };
	
	      var expected_qualification_arr = ["Graduate in Education (BA / B.SC etc.)", "Post Graduate (MA /M.Sc etc)", "Engeneering Graduate", "Diploma In Education", "Bachelors Degree in Education (B.Ed)", "Masters Degree in Education (M.Ed)", "Doctorate (Phd)", "Bachelor of Elementray Education (B.EL.Ed)", "Bachelor of Arts & Education (BA. B.Ed)", "Diploma in Elementary Education (D.EL.Ed)", "Bachelor of Physical Education (B.P.Ed)", "Master of Philosophy in Education (M.Phil)", "Bachelor of Library Science (B.Lib)", "Bachelor of Library & Information Sciences (B.Lib.I.Sc)", "Masters in Library & Information Sciences (M.Lib.I.Sc)", "Bachelor of Fine Arts (BFA)", "Diploma Program in Special Education (DESCE-MR / DSE / MRW / DHLS etc)", "Post Graduate Diploma in Special Education", "Graduate in Special Education  (B.Ed - Spl Education)", "Other"];
	
	      var language_preferred_arr = ['English', 'Hindi', 'Tamil', 'Kannada', 'Telugu', 'Urdhu', 'Malayalam'];
	
	      var examcertifications_arr = ["None", "Central Teachers Eligibliity Test (CTET)", "National Eligibility Test (NET / UGC-NET)", "Basic Training Certificates", "Primary Teachers Certificates", "Teachers Training Certificates", "Teacher Eligiblity Test (TET)", "State Teachers Eligiblity Test (STET)", "Certificate course in Library Sciences", "Certificate course in Drawing teacher training", "Certificate in Care giving program", "Certificate program in Special Education", "Certicate Courses in Dance", "Certicate Courses in Arts", "Certificate Courses in Sports", "Certificate Courses in Music & Dance", "Other"];
	
	      var skillsrequired_arr = ["Expertise in specific subjects of teaching", "Written and verbal communication", "Ability to adapt to different situations", "Knowledge of teaching software and tools", "Ability to teach students experiencing challenge with learning", "Time management skills", "Innovative training strategies", "Flexibility to modify training principles", "Classroom management", "Leadership", "Conflict management", "Collaborative & Interpersonal skills", "Creative", "Financial Management", "Human Resource Management", "Curriculam Development", "School Policy Knowledge", "Understanding & Implementation of NEP requirements", "Other"];
	
	      var language_preferred = this.state.language_preferred ? this.state.language_preferred.split(",") : [];
	      var examcertifications = this.state.examcertifications ? this.state.examcertifications.split(",") : [];
	      var expected_qualification = this.state.expected_qualification ? this.state.expected_qualification.split(",") : [];
	      var skillsrequired = this.state.skillsrequired ? this.state.skillsrequired.split(",") : [];
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'col-12 grid-margin' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card-body' },
	                _react2.default.createElement(
	                  'h4',
	                  { 'class': 'card-title' },
	                  'Job - Add'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'postajobform wc' },
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup end_date_option', id: 'end_date_option' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Organisation '
	                    ),
	                    _react2.default.createElement('input', { type: 'text', 'class': 'form-control forminputcls', id: 'organisation', name: 'organisation', value: this.state.organisation, onChange: this.handleChange })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup end_date_option', id: 'end_date_option' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Job title '
	                    ),
	                    _react2.default.createElement('input', { type: 'text', 'class': 'form-control forminputcls', id: 'job_title', name: 'job_title', value: this.state.job_title, onChange: this.handleChange })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Job Description '
	                    ),
	                    _react2.default.createElement('textarea', { 'class': 'form-control forminputcls', name: 'job_description', id: 'job_description', value: this.state.job_description, placeholder: 'Description', rows: '10', onChange: this.handleChange })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup end_date_option', id: 'end_date_option' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Job role'
	                    ),
	                    _react2.default.createElement(
	                      'select',
	                      { name: 'job_role', 'class': 'formselectinputcls', value: this.state.job_role, onChange: this.handleChange },
	                      _react2.default.createElement(
	                        'option',
	                        { value: '' },
	                        'Select Role'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Pre Primary Teacher' },
	                        'Pre Primary Teacher'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Primary Teacher' },
	                        'Primary Teacher'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Secondary Teacher' },
	                        'Secondary Teacher'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Senior Secondary Teacher' },
	                        'Senior Secondary Teacher'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Special Educator' },
	                        'Special Educator'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Libraian' },
	                        'Libraian'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Physial Education Teacher' },
	                        'Physial Education Teacher'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Counsellor' },
	                        'Counsellor'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Administrator' },
	                        'Administrator'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Accountant' },
	                        'Accountant'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Marketing' },
	                        'Marketing'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Music / Dance Teacher' },
	                        'Music / Dance Teacher'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Other' },
	                        'Other'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup end_date_option', id: 'end_date_option' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Job Role - If Other '
	                    ),
	                    _react2.default.createElement('input', { type: 'text', 'class': 'form-control forminputcls', id: 'job_role_other', value: this.state.job_role_other, disabled: this.state.job_role_other_disabled, name: 'job_role_other', onChange: this.handleChange })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup end_date_option', id: 'end_date_option' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Role Type'
	                    ),
	                    _react2.default.createElement(
	                      'select',
	                      { name: 'job_category', 'class': 'formselectinputcls', value: this.state.job_category, onChange: this.handleChange },
	                      _react2.default.createElement(
	                        'option',
	                        { value: '' },
	                        'Select Role Type'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Full Time' },
	                        'Full Time'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Part Time' },
	                        'Part Time'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Contractual' },
	                        'Contractual'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Temporary' },
	                        'Temporary'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Internship' },
	                        'Internship'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup end_date_option', id: 'end_date_option' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Subject Of Teaching'
	                    ),
	                    _react2.default.createElement(
	                      'select',
	                      { name: 'job_subject_teaching', 'class': 'formselectinputcls', value: this.state.job_subject_teaching, onChange: this.handleChange },
	                      _react2.default.createElement(
	                        'option',
	                        { value: '' },
	                        'Select Subject'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Biology' },
	                        'Biology'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Science' },
	                        'Science'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Maths' },
	                        'Maths'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Physics' },
	                        'Physics'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Chemistry' },
	                        'Chemistry'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Art' },
	                        'Art'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'History' },
	                        'History'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Economics' },
	                        'Economics'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Computer Science' },
	                        'Computer Science'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Phyisical Education' },
	                        'Phyisical Education'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Librarian' },
	                        'Librarian'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Humanities' },
	                        'Humanities'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Geography' },
	                        'Geography'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Civics' },
	                        'Civics'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'English' },
	                        'English'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Hindi' },
	                        'Hindi'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Tamil' },
	                        'Tamil'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Kannada' },
	                        'Kannada'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Telugu' },
	                        'Telugu'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Marathi' },
	                        'Marathi'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'French' },
	                        'French'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Spanish' },
	                        'Spanish'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'German' },
	                        'German'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Reglion and Religious Studies' },
	                        'Reglion and Religious Studies'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Visual Arts' },
	                        'Visual Arts'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Robotics & Coding' },
	                        'Robotics & Coding'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Other' },
	                        'Other'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup end_date_option', id: 'end_date_option' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Subject Of Teaching - If Other '
	                    ),
	                    _react2.default.createElement('input', { type: 'text', 'class': 'form-control forminputcls', id: 'job_subject_teaching_other', disabled: this.state.job_subject_teaching_other_disabled, name: 'job_subject_teaching_other', onChange: this.handleChange })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup end_date_option', id: 'end_date_option' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Experience Required '
	                    ),
	                    _react2.default.createElement(
	                      'select',
	                      { name: 'job_experience', 'class': 'formselectinputcls', value: this.state.job_experience, onChange: this.handleChange },
	                      _react2.default.createElement(
	                        'option',
	                        { value: '' },
	                        '---Select---'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'freshers' },
	                        'Freshers'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: '1-3' },
	                        '1-3 Years'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: '4-9' },
	                        '4-5 years'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: '10-15' },
	                        '10-15 years'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: '15+' },
	                        '15+ years'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup end_date_option', id: 'end_date_option' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Anticipated joining '
	                    ),
	                    _react2.default.createElement(
	                      'select',
	                      { name: 'joining', 'class': 'formselectinputcls', value: this.state.joining, onChange: this.handleChange },
	                      _react2.default.createElement(
	                        'option',
	                        { value: '' },
	                        '---Select---'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Immediate' },
	                        'Immediate'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: '15 Days' },
	                        '15 Days'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: '1 month' },
	                        '1 month'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: '2 months' },
	                        '2 months'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: '3 months' },
	                        '3 months'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Job Opening Date '
	                    ),
	                    _react2.default.createElement('input', { type: 'date', 'class': 'form-control forminputcls', id: 'open_date', name: 'open_date', value: this.state.open_date, onChange: this.handleChange })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Job Closing Date '
	                    ),
	                    _react2.default.createElement('input', { type: 'date', 'class': 'form-control forminputcls', id: 'closing_date', name: 'closing_date', value: this.state.closing_date, onChange: this.handleChange })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup end_date_option', id: 'end_date_option' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Job Location '
	                    ),
	                    _react2.default.createElement(
	                      'select',
	                      { name: 'job_location', 'class': 'formselectinputcls', value: this.state.job_location, onChange: this.handleChange },
	                      _react2.default.createElement(
	                        'option',
	                        { value: '' },
	                        'Select'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'In Campus' },
	                        'In Campus'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Hybrid' },
	                        'Hybrid'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Remote' },
	                        'Remote'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup end_date_option', id: 'end_date_option' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Salary Range for this Job'
	                    ),
	                    ' ',
	                    _react2.default.createElement(
	                      'div',
	                      { id: 'salaryText', 'class': 'salaryText' },
	                      '\u20B9 ',
	                      formatkg(salary_range_forthisjob)
	                    ),
	                    _react2.default.createElement(_reactRangeslider2.default, {
	                      min: 10000,
	                      max: 400000,
	                      value: this.state.salary_range_forthisjob,
	                      labels: horizontalLabels,
	                      format: formatkg,
	                      step: 1000,
	                      handleLabel: this.state.salary_range_forthisjob,
	                      onChange: this.handleChangeHorizontal
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup end_date_option', id: 'end_date_option' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Languages preferred '
	                    ),
	                    _react2.default.createElement(_multiselectReactDropdown.Multiselect, {
	                      className: 'formselectinputcls',
	                      isObject: false,
	                      selectedValues: language_preferred,
	                      options: language_preferred_arr // Options to display in the dropdown
	                      , onSelect: this.onSelect // Function will trigger on select event
	                      , onRemove: this.onRemove // Function will trigger on remove event
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Expected Qualification '
	                    ),
	                    _react2.default.createElement(_multiselectReactDropdown.Multiselect, {
	                      className: 'formselectinputcls',
	                      isObject: false,
	                      selectedValues: expected_qualification,
	                      options: expected_qualification_arr // Options to display in the dropdown
	                      , onSelect: this.onSelectExpectedQualification // Function will trigger on select event
	                      , onRemove: this.onRemoveExpQualification // Function will trigger on remove event
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup end_date_option', id: 'end_date_option' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Expected Qualification - If Other '
	                    ),
	                    _react2.default.createElement('input', { type: 'text', 'class': 'form-control forminputcls', id: 'expected_qualification_other', name: 'expected_qualification_other', disabled: this.state.expected_qualification_other_disabled, onChange: this.handleChange })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Entrance Examination & Certifications Required  '
	                    ),
	                    _react2.default.createElement(_multiselectReactDropdown.Multiselect, {
	                      className: 'formselectinputcls',
	                      isObject: false,
	                      selectedValues: examcertifications,
	                      options: examcertifications_arr // Options to display in the dropdown
	                      , onSelect: this.onSelectExamCertificaitons // Function will trigger on select event
	                      , onRemove: this.onRemoveExamCertifications // Function will trigger on remove event
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup end_date_option', id: 'end_date_option' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Examination and Certifications - If Other '
	                    ),
	                    _react2.default.createElement('input', { type: 'text', 'class': 'form-control forminputcls', id: 'examcertifications_other', name: 'examcertifications_other', disabled: this.state.examcertifications_other_disabled, onChange: this.handleChange })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Skills required '
	                    ),
	                    _react2.default.createElement(_multiselectReactDropdown.Multiselect, {
	                      className: 'formselectinputcls',
	                      isObject: false,
	                      selectedValues: skillsrequired,
	                      options: skillsrequired_arr // Options to display in the dropdown
	                      , onSelect: this.onSelectSkillRequired // Function will trigger on select event
	                      , onRemove: this.onRemoveSkillRequired // Function will trigger on remove event
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup end_date_option', id: 'end_date_option' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Skills required - If Other '
	                    ),
	                    _react2.default.createElement('input', { type: 'text', 'class': 'form-control forminputcls', id: 'skillsrequired_other', value: this.state.skillsrequired_other, name: 'skillsrequired_other', disabled: this.state.skillsrequired_other_disabled, onChange: this.handleChange })
	                  ),
	                  this.state.auth_data.login_id == 1 && _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'formgroup' },
	                      _react2.default.createElement(
	                        'label',
	                        { 'for': 'exampleInputPassword1' },
	                        'Job Approval '
	                      ),
	                      _react2.default.createElement(
	                        'select',
	                        { name: 'job_approval', 'class': 'formselectinputcls', value: this.state.job_approval, onChange: this.handleChange },
	                        _react2.default.createElement(
	                          'option',
	                          { value: '' },
	                          'Select status'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: '0' },
	                          'Reject'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: '1' },
	                          'Approve'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: '2' },
	                          'On-Hold'
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup text-center paddingtop20' },
	                    _react2.default.createElement(
	                      'button',
	                      { type: 'button', name: 'postajob', 'class': 'btn-main', onClick: this.handleSubmit },
	                      'Update Job'
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(_reactNotifications.NotificationContainer, null)
	        )
	      );
	    }
	  }]);
	
	  return Editjob;
	}(_react.Component);
	
	exports.default = Editjob;

/***/ },
/* 1056 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _reactJsPagination = __webpack_require__(33);
	
	var _reactJsPagination2 = _interopRequireDefault(_reactJsPagination);
	
	__webpack_require__(18);
	
	var _reactNotifications = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import { Editor } from '@tinymce/tinymce-react';
	
	
	//import Pagination from 'rc-pagination';
	
	
	var Jobs = function (_Component) {
	  _inherits(Jobs, _Component);
	
	  function Jobs(props) {
	    _classCallCheck(this, Jobs);
	
	    var _this = _possibleConstructorReturn(this, (Jobs.__proto__ || Object.getPrototypeOf(Jobs)).call(this, props));
	
	    _this.getTotal = function () {
	
	      (0, _FetchCall.getTotalJobs)().then(function (res) {
	
	        _this.setState({ loading: true });
	
	        if (res.status == 1) {
	
	          _this.setState({
	
	            total: res.total
	
	          });
	        }
	      });
	    };
	
	    _this.getList = function () {
	      var pageNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	      var location = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	      var _this$state$auth_data = _this.state.auth_data,
	          login_id = _this$state$auth_data.login_id,
	          role = _this$state$auth_data.role;
	
	
	      _this.setState({ activePage: pageNumber });
	
	      var newOffset = pageNumber == 1 ? 0 : (pageNumber - 1) * _this.state.PER_PAGE % _this.state.total;
	
	      var ins = JSON.stringify({
	        perpage: _this.state.PER_PAGE,
	        offset: newOffset
	      });
	
	      (0, _FetchCall.getJobsListPaged)(ins).then(function (res) {
	
	        _this.setState({ loading: true });
	
	        if (res.status == 1) {
	
	          _this.setState({ loading: !_this.state.loading });
	
	          _this.setState({ list: res.list });
	        } else {
	
	          _this.setState({ loading: !_this.state.loading });
	
	          _this.setState({
	            list: []
	          });
	        }
	      });
	    };
	
	    _this.state = {
	      logged: localStorage.getItem("authentication"),
	      auth_data: JSON.parse(localStorage.getItem("user_data")),
	      category_data: [], collapse: 0, modalReply: false,
	      current_comment: '', current_rid: 0, current_eid: '',
	      PER_PAGE: 15,
	      total: 0,
	      loading: true,
	      list: [],
	      exportbtndisabled: false,
	      thisExportBtnText: 'Export'
	    };
	
	    _this.getTotal = _this.getTotal.bind(_this);
	    _this.getList = _this.getList.bind(_this);
	    return _this;
	  }
	
	  _createClass(Jobs, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	
	      var THIS = this;
	      (0, _jquery2.default)(document).on('click', '.dlte', function () {
	        var _this2 = this;
	
	        var delete_id = (0, _jquery2.default)(this).data("id");
	
	        if (confirm("You are sure to delete?") == true) {
	
	          var ins = JSON.stringify({
	            id: delete_id,
	            table: 'jobs'
	          });
	
	          (0, _FetchCall.removethisItem)(ins).then(function (res) {
	
	            if (res.status == 1) {
	              _reactNotifications.NotificationManager.success('Removed successfully');
	            } else {
	              _reactNotifications.NotificationManager.error('Issue in removing');
	            }
	            _this2.getTotal();
	            _this2.getList();
	          });
	        }
	      });
	
	      this.getTotal();
	      this.getList();
	    }
	  }, {
	    key: 'handlePageChange',
	    value: function handlePageChange(pageNumber) {
	
	      console.log('active page is ' + pageNumber);
	
	      this.setState({ activePage: pageNumber });
	
	      //this.getTotal('bw_schools');
	      this.getList(pageNumber);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var list = this.state.list;
	      var _state = this.state,
	          currentPage = _state.currentPage,
	          PER_PAGE = _state.PER_PAGE,
	          totalCount = _state.totalCount,
	          total = _state.total,
	          exportbtndisabled = _state.exportbtndisabled;
	
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'col-12 grid-margin' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card-body' },
	                _react2.default.createElement(
	                  'h4',
	                  { 'class': 'card-title' },
	                  'Jobs'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'float-right' },
	                  _react2.default.createElement(
	                    'a',
	                    { href: '/wiseconnect/addjob', 'class': 'btn btn-primary btn-sm' },
	                    'Add New'
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'table-responsive pt-3' },
	                  _react2.default.createElement(
	                    'table',
	                    { 'class': 'table table-bordered table-sm' },
	                    _react2.default.createElement(
	                      'thead',
	                      { 'class': 'thead-dark' },
	                      _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          'S.No'
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          'Job title'
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          'Date'
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          'Posted By'
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          'Status'
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          'Action'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'tbody',
	                      null,
	                      list.length > 0 && list.map(function (job, i) {
	
	                        return _react2.default.createElement(
	                          'tr',
	                          null,
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            i + 1
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            job.job_title
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            new Intl.DateTimeFormat('en-US', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).format(job.created_date)
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            job.organisation
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            { className: job.job_status == 0 ? 'inactivecss' : 'activecss' },
	                            job.job_status == 0 ? 'Inactive' : 'Active'
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            _react2.default.createElement(
	                              'a',
	                              { href: "/wiseconnect/editjob/" + job.id, 'class': 'btn btn-primary btn-sm', 'data-id': job.id },
	                              'Edit'
	                            ),
	                            '\xA0',
	                            _react2.default.createElement(
	                              'button',
	                              { 'class': 'btn btn-primary btn-sm dlte', 'data-id': job.id },
	                              'Remove'
	                            )
	                          )
	                        );
	                      }),
	                      list.length == 0 && _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                          'td',
	                          { colSpan: '6' },
	                          'No data'
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'text-center' },
	                    _react2.default.createElement(_reactJsPagination2.default, {
	                      activePage: this.state.activePage,
	                      itemsCountPerPage: PER_PAGE,
	                      totalItemsCount: this.state.total,
	                      pageRangeDisplayed: 5,
	                      activeClass: "pagination__link--active",
	                      onChange: this.handlePageChange.bind(this),
	                      prevPageText: 'previous',
	                      nextPageText: 'next'
	                    })
	                  )
	                )
	              )
	            )
	          ),
	          '  ',
	          _react2.default.createElement(_reactNotifications.NotificationContainer, null)
	        )
	      );
	    }
	  }]);
	
	  return Jobs;
	}(_react.Component);
	
	exports.default = Jobs;

/***/ },
/* 1057 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _reactstrap = __webpack_require__(17);
	
	var _reactDataTableComponent = __webpack_require__(53);
	
	var _reactDataTableComponent2 = _interopRequireDefault(_reactDataTableComponent);
	
	var _reactJsPagination = __webpack_require__(33);
	
	var _reactJsPagination2 = _interopRequireDefault(_reactJsPagination);
	
	var _bewiseloading = __webpack_require__(48);
	
	var _bewiseloading2 = _interopRequireDefault(_bewiseloading);
	
	__webpack_require__(18);
	
	var _reactNotifications = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import { Editor } from '@tinymce/tinymce-react';
	
	//import Pagination from 'rc-pagination';
	
	var newsLetterSubscribersList = function (_Component) {
	  _inherits(newsLetterSubscribersList, _Component);
	
	  function newsLetterSubscribersList(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, newsLetterSubscribersList);
	
	    var _this = _possibleConstructorReturn(this, (newsLetterSubscribersList.__proto__ || Object.getPrototypeOf(newsLetterSubscribersList)).call(this, props));
	
	    _this.getTotal = function (vertical) {
	      var location = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	      var _this$state$auth_data = _this.state.auth_data,
	          login_id = _this$state$auth_data.login_id,
	          role = _this$state$auth_data.role;
	
	
	      var locationselected = location == '' ? _this.state.location : location;
	
	      var ins = JSON.stringify({
	        vendor_id: login_id
	      });
	
	      (0, _FetchCall.getTotalNewsLetterSubscribers)(ins).then(function (res) {
	
	        _this.setState({ loading: true });
	
	        if (res.status == 1) {
	
	          _this.setState({
	
	            total: res.total
	
	          });
	        }
	      });
	    };
	
	    _this.getList = function () {
	      var pageNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	      var location = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	      var _this$state$auth_data2 = _this.state.auth_data,
	          login_id = _this$state$auth_data2.login_id,
	          role = _this$state$auth_data2.role;
	
	
	      _this.setState({ activePage: pageNumber });
	
	      var newOffset = pageNumber == 1 ? 0 : (pageNumber - 1) * _this.state.PER_PAGE % _this.state.total;
	
	      var locationselected = location == '' ? _this.state.location : location;
	
	      var ins = JSON.stringify({
	        perpage: _this.state.PER_PAGE,
	        year: _this.state.year,
	        month: _this.state.month,
	        offset: newOffset
	      });
	
	      (0, _FetchCall.getNewsLetterSubscribersListPaged)(ins).then(function (res) {
	
	        _this.setState({ loading: true });
	
	        if (res.status == 1) {
	
	          _this.setState({ loading: !_this.state.loading });
	
	          var newLeads = res.data.map(function (lead) {
	            return {
	              "id": lead.id,
	              "email": lead.email,
	              "verified": lead.verified,
	              "createdAt": new Intl.DateTimeFormat('en-US', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).format(lead.created_date)
	            };
	          });
	
	          _this.setState({ list: newLeads });
	        } else {
	
	          _this.setState({ loading: !_this.state.loading });
	
	          _this.setState({
	            list: []
	          });
	        }
	      });
	    };
	
	    _this.subscribersExport = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var req, res;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	
	              _this.setState({ exportbtndisabled: true, thisExportBtnText: "exporting..." });
	
	              _context.prev = 1;
	              req = JSON.stringify({
	                location: _this.state.location
	              });
	              _context.next = 5;
	              return (0, _FetchCall.exportWcSubscribers)(req);
	
	            case 5:
	              res = _context.sent;
	
	              if (res.status == 1) {
	
	                _this.setState({ exportbtndisabled: false, thisExportBtnText: "Export" });
	                console.log('location_list', res);
	                console.log('location_list', res.path);
	                window.open(res.path);
	
	                // this.setState({
	                //   subscribe_list: res.results,
	                // });
	              }
	
	              _context.next = 12;
	              break;
	
	            case 9:
	              _context.prev = 9;
	              _context.t0 = _context['catch'](1);
	
	              _this.setState({ error: true });
	
	            case 12:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2, [[1, 9]]);
	    }));
	
	    _this.state = {
	      logged: localStorage.getItem("authentication"),
	      auth_data: JSON.parse(localStorage.getItem("user_data")),
	      category_data: [], collapse: 0, modalReply: false,
	      current_comment: '', current_rid: 0, current_eid: '',
	      PER_PAGE: 15,
	      total: 0,
	      loading: true,
	      list: [],
	      exportbtndisabled: false,
	      thisExportBtnText: 'Export'
	    };
	
	    _this.getTotal = _this.getTotal.bind(_this);
	    _this.getList = _this.getList.bind(_this);
	    return _this;
	  }
	
	  _createClass(newsLetterSubscribersList, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	
	      var THIS = this;
	      (0, _jquery2.default)(document).on('click', '.dlte', function () {
	        var _this3 = this;
	
	        var delete_id = (0, _jquery2.default)(this).data("id");
	
	        if (confirm("You are sure to delete?") == true) {
	
	          var ins = JSON.stringify({
	            id: delete_id,
	            table: 'wiseconnect'
	          });
	
	          (0, _FetchCall.removethisItem)(ins).then(function (res) {
	
	            if (res.status == 1) {
	              _reactNotifications.NotificationManager.success('Removed successfully');
	            } else {
	              _reactNotifications.NotificationManager.error('Issue in removing');
	            }
	            _this3.getTotal('leads');
	            _this3.getList();
	          });
	        }
	      });
	
	      this.getTotal('leads');
	      this.getList();
	    }
	  }, {
	    key: 'handlePageChange',
	    value: function handlePageChange(pageNumber) {
	
	      console.log('active page is ' + pageNumber);
	
	      this.setState({ activePage: pageNumber });
	
	      //this.getTotal('bw_schools');
	      this.getList(pageNumber);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var list = this.state.list;
	      var _state = this.state,
	          currentPage = _state.currentPage,
	          PER_PAGE = _state.PER_PAGE,
	          totalCount = _state.totalCount,
	          total = _state.total,
	          exportbtndisabled = _state.exportbtndisabled;
	
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'col-12 grid-margin' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card-body' },
	                _react2.default.createElement(
	                  'h4',
	                  { 'class': 'card-title' },
	                  'List'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'float-right' },
	                  _react2.default.createElement(
	                    'button',
	                    { disabled: exportbtndisabled, 'class': 'btn btn-primary btn-sm', onClick: function onClick() {
	                        return _this4.subscribersExport();
	                      } },
	                    this.state.thisExportBtnText
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'table-responsive pt-3' },
	                  _react2.default.createElement(
	                    'table',
	                    { 'class': 'table table-bordered table-sm' },
	                    _react2.default.createElement(
	                      'thead',
	                      { 'class': 'thead-dark' },
	                      _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          'S.No'
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          'Email'
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          'Date'
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          'Action'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'tbody',
	                      null,
	                      list.length > 0 && list.map(function (lead, i) {
	
	                        return _react2.default.createElement(
	                          'tr',
	                          null,
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            i + 1
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            lead.email
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            lead.createdAt
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            _react2.default.createElement(
	                              'button',
	                              { 'class': 'btn btn-primary dlte', 'data-id': lead.id },
	                              'Remove'
	                            )
	                          )
	                        );
	                      }),
	                      list.length == 0 && _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                          'td',
	                          { colSpan: '6' },
	                          'No data'
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'text-center' },
	                    _react2.default.createElement(_reactJsPagination2.default, {
	                      activePage: this.state.activePage,
	                      itemsCountPerPage: PER_PAGE,
	                      totalItemsCount: this.state.total,
	                      pageRangeDisplayed: 5,
	                      activeClass: "pagination__link--active",
	                      onChange: this.handlePageChange.bind(this),
	                      prevPageText: 'previous',
	                      nextPageText: 'next'
	                    })
	                  )
	                )
	              )
	            )
	          ),
	          '  ',
	          _react2.default.createElement(_reactNotifications.NotificationContainer, null)
	        )
	      );
	    }
	  }]);
	
	  return newsLetterSubscribersList;
	}(_react.Component);
	
	exports.default = newsLetterSubscribersList;

/***/ },
/* 1058 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _reactstrap = __webpack_require__(17);
	
	var _reactDataTableComponent = __webpack_require__(53);
	
	var _reactDataTableComponent2 = _interopRequireDefault(_reactDataTableComponent);
	
	var _reactJsPagination = __webpack_require__(33);
	
	var _reactJsPagination2 = _interopRequireDefault(_reactJsPagination);
	
	var _bewiseloading = __webpack_require__(48);
	
	var _bewiseloading2 = _interopRequireDefault(_bewiseloading);
	
	__webpack_require__(18);
	
	var _reactNotifications = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import { Editor } from '@tinymce/tinymce-react';
	
	//import Pagination from 'rc-pagination';
	
	var OtherCourses = function (_Component) {
	  _inherits(OtherCourses, _Component);
	
	  function OtherCourses(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, OtherCourses);
	
	    var _this = _possibleConstructorReturn(this, (OtherCourses.__proto__ || Object.getPrototypeOf(OtherCourses)).call(this, props));
	
	    _this.getTotal = function () {
	      var _this$state$auth_data = _this.state.auth_data,
	          login_id = _this$state$auth_data.login_id,
	          role = _this$state$auth_data.role;
	
	
	      var ins = JSON.stringify({
	        vertical: 'othercourses'
	      });
	
	      (0, _FetchCall.getTotal)(ins).then(function (res) {
	
	        _this.setState({ loading: true });
	
	        if (res.status == 1) {
	
	          _this.setState({
	
	            total: res.total
	
	          });
	        }
	      });
	    };
	
	    _this.getList = function () {
	      var pageNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	      var location = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	      var _this$state$auth_data2 = _this.state.auth_data,
	          login_id = _this$state$auth_data2.login_id,
	          role = _this$state$auth_data2.role;
	
	
	      _this.setState({ activePage: pageNumber });
	
	      var newOffset = pageNumber == 1 ? 0 : (pageNumber - 1) * _this.state.PER_PAGE % _this.state.total;
	
	      var ins = JSON.stringify({
	        perpage: _this.state.PER_PAGE,
	        offset: newOffset
	      });
	
	      (0, _FetchCall.getOtherCoursesListPaged)(ins).then(function (res) {
	
	        _this.setState({ loading: true });
	
	        if (res.status == 1) {
	
	          _this.setState({ loading: !_this.state.loading });
	
	          var list = res.list.map(function (course) {
	            return {
	              "id": course.id,
	              "name": course.name,
	              "createdAt": new Intl.DateTimeFormat('en-US', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).format(course.created_date)
	            };
	          });
	
	          _this.setState({ list: list });
	        } else {
	
	          _this.setState({ loading: !_this.state.loading });
	
	          _this.setState({
	            list: []
	          });
	        }
	      });
	    };
	
	    _this.subscribersExport = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var req, res;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	
	              _this.setState({ exportbtndisabled: true, thisExportBtnText: "exporting..." });
	
	              _context.prev = 1;
	              req = JSON.stringify({
	                location: _this.state.location
	              });
	              _context.next = 5;
	              return (0, _FetchCall.exportWcSubscribers)(req);
	
	            case 5:
	              res = _context.sent;
	
	              if (res.status == 1) {
	
	                _this.setState({ exportbtndisabled: false, thisExportBtnText: "Export" });
	                console.log('location_list', res);
	                console.log('location_list', res.path);
	                window.open(res.path);
	
	                // this.setState({
	                //   subscribe_list: res.results,
	                // });
	              }
	
	              _context.next = 12;
	              break;
	
	            case 9:
	              _context.prev = 9;
	              _context.t0 = _context['catch'](1);
	
	              _this.setState({ error: true });
	
	            case 12:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2, [[1, 9]]);
	    }));
	
	    _this.state = {
	      logged: localStorage.getItem("authentication"),
	      auth_data: JSON.parse(localStorage.getItem("user_data")),
	      category_data: [], collapse: 0, modalReply: false,
	      current_comment: '', current_rid: 0, current_eid: '',
	      PER_PAGE: 15,
	      total: 0,
	      loading: true,
	      list: [],
	      exportbtndisabled: false,
	      thisExportBtnText: 'Export'
	    };
	
	    _this.getTotal = _this.getTotal.bind(_this);
	    _this.getList = _this.getList.bind(_this);
	    return _this;
	  }
	
	  _createClass(OtherCourses, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	
	      var THIS = this;
	      (0, _jquery2.default)(document).on('click', '.dlte', function () {
	        var _this3 = this;
	
	        var delete_id = (0, _jquery2.default)(this).data("id");
	
	        if (confirm("You are sure to delete?") == true) {
	
	          var ins = JSON.stringify({
	            id: delete_id,
	            table: 'wiseconnect'
	          });
	
	          (0, _FetchCall.removethisItem)(ins).then(function (res) {
	
	            if (res.status == 1) {
	              _reactNotifications.NotificationManager.success('Removed successfully');
	            } else {
	              _reactNotifications.NotificationManager.error('Issue in removing');
	            }
	            _this3.getTotal();
	            _this3.getList();
	          });
	        }
	      });
	
	      this.getTotal();
	      this.getList();
	    }
	  }, {
	    key: 'handlePageChange',
	    value: function handlePageChange(pageNumber) {
	
	      console.log('active page is ' + pageNumber);
	
	      this.setState({ activePage: pageNumber });
	
	      //this.getTotal('bw_schools');
	      this.getList(pageNumber);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var list = this.state.list;
	      var _state = this.state,
	          currentPage = _state.currentPage,
	          PER_PAGE = _state.PER_PAGE,
	          totalCount = _state.totalCount,
	          total = _state.total,
	          exportbtndisabled = _state.exportbtndisabled;
	
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'col-12 grid-margin' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card-body' },
	                _react2.default.createElement(
	                  'h4',
	                  { 'class': 'card-title' },
	                  'List'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'float-right' },
	                  _react2.default.createElement(
	                    'a',
	                    { href: '/wiseconnect/addothercourse', 'class': 'btn btn-primary btn-sm' },
	                    'Add New'
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'table-responsive pt-3' },
	                  _react2.default.createElement(
	                    'table',
	                    { 'class': 'table table-bordered table-sm' },
	                    _react2.default.createElement(
	                      'thead',
	                      { 'class': 'thead-dark' },
	                      _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          'S.No'
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          'Name'
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          'Date'
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          'Action'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'tbody',
	                      null,
	                      list.length > 0 && list.map(function (lead, i) {
	
	                        return _react2.default.createElement(
	                          'tr',
	                          null,
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            i + 1
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            lead.name
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            lead.createdAt
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            _react2.default.createElement(
	                              'button',
	                              { 'class': 'btn btn-primary btn-sm dlte', 'data-id': lead.id },
	                              'Remove'
	                            )
	                          )
	                        );
	                      }),
	                      list.length == 0 && _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                          'td',
	                          { colSpan: '6' },
	                          'No data'
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'text-center' },
	                    _react2.default.createElement(_reactJsPagination2.default, {
	                      activePage: this.state.activePage,
	                      itemsCountPerPage: PER_PAGE,
	                      totalItemsCount: this.state.total,
	                      pageRangeDisplayed: 5,
	                      activeClass: "pagination__link--active",
	                      onChange: this.handlePageChange.bind(this),
	                      prevPageText: 'previous',
	                      nextPageText: 'next'
	                    })
	                  )
	                )
	              )
	            )
	          ),
	          '  ',
	          _react2.default.createElement(_reactNotifications.NotificationContainer, null)
	        )
	      );
	    }
	  }]);
	
	  return OtherCourses;
	}(_react.Component);
	
	exports.default = OtherCourses;

/***/ },
/* 1059 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	__webpack_require__(18);
	
	var _reactNotifications = __webpack_require__(16);
	
	var _multiselectReactDropdown = __webpack_require__(73);
	
	var _reactstrap = __webpack_require__(17);
	
	var _reactRangeslider = __webpack_require__(79);
	
	var _reactRangeslider2 = _interopRequireDefault(_reactRangeslider);
	
	__webpack_require__(66);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import { Editor } from '@tinymce/tinymce-react';
	
	//import { Importer, ImporterField } from "react-csv-importer";
	
	// theme CSS for React CSV Importer
	//import "react-csv-importer/dist/index.css";
	
	var Wcpostajob = function (_Component) {
	  _inherits(Wcpostajob, _Component);
	
	  function Wcpostajob(props) {
	    _classCallCheck(this, Wcpostajob);
	
	    var _this = _possibleConstructorReturn(this, (Wcpostajob.__proto__ || Object.getPrototypeOf(Wcpostajob)).call(this, props));
	
	    _this.handleChangeHorizontal = function (value) {
	      _this.setState({
	        salary_range_forthisjob: value
	      });
	    };
	
	    _this.handleChange = function (e) {
	      _this.setState(_defineProperty({}, e.target.name, e.target.value));
	
	      if (e.target.value == 'Other') {
	        _this.setState(_defineProperty({}, e.target.name + "_other_disabled", false));
	      }
	    };
	
	    _this.handleSubmit = function (e) {
	
	      var auth_data = JSON.parse(localStorage.getItem("user_data"));
	
	      if (_this.state.job_title == '') {
	        _reactNotifications.NotificationManager.error('Please fill Job Title', 'Post a job', 10000);
	      } else if (_this.state.job_description == '' && _this.state.job_description_pdf == '') {
	        _reactNotifications.NotificationManager.error('Please fill Job Description or upload JD file', 'Post a job');
	      } else {
	
	        var req = {
	          user_id: auth_data.login_id,
	          job_title: _this.state.job_title,
	          job_category: _this.state.job_category,
	          job_description: _this.state.job_description,
	          job_gender: _this.state.job_gender,
	          organisation: auth_data.organisation,
	          organisation_place: auth_data.organisation_place,
	          open_date: _this.state.open_date,
	          closing_date: _this.state.closing_date,
	          job_location: _this.state.job_location,
	          salary_range_forthisjob: _this.state.salary_range_forthisjob,
	          language_preferred: _this.state.language_preferred,
	          expected_qualification: _this.state.expected_qualification,
	          gallery_new: _this.state.gallery_new,
	          job_description_pdf: _this.state.job_description_pdf,
	          job_role: _this.state.job_role,
	          job_subject_teaching: _this.state.job_subject_teaching,
	          job_experience: _this.state.job_experience,
	          examcertifications: _this.state.examcertifications,
	          expected_qualification_other: _this.state.expected_qualification_other,
	          skillsrequired_other: _this.state.skillsrequired_other,
	          job_role_other: _this.state.job_role_other,
	          job_subject_teaching_other: _this.state.job_subject_teaching_other,
	          examcertifications_other: _this.state.examcertifications_other,
	          job_status: 1
	        };
	
	        (0, _FetchCall.postajob)(req).then(function (response) {
	
	          if (response.status == 1) {
	
	            _reactNotifications.NotificationManager.success('Posted successfully, Wiseconnect/BeWise reserves the rights to delete or revise in case of anything inappropriate', 'Post a job');
	          } else {
	
	            _reactNotifications.NotificationManager.error('Error posting a job', 'Post a job');
	          }
	        });
	      }
	    };
	
	    _this.handleSave = function (e) {
	
	      var auth_data = JSON.parse(localStorage.getItem("user_data"));
	
	      var req = {
	        user_id: auth_data.login_id,
	        job_title: _this.state.job_title,
	        job_category: _this.state.job_category,
	        job_description: _this.state.job_description,
	        job_gender: _this.state.job_gender,
	        organisation: auth_data.organisation,
	        organisation_place: auth_data.organisation_place,
	        open_date: _this.state.open_date,
	        closing_date: _this.state.closing_date,
	        job_location: _this.state.job_location,
	        salary_range_forthisjob: _this.state.salary_range_forthisjob,
	        language_preferred: _this.state.language_preferred,
	        expected_qualification: _this.state.expected_qualification,
	        gallery_new: _this.state.gallery_new,
	        job_description_pdf: _this.state.job_description_pdf,
	        job_role: _this.state.job_role,
	        job_subject_teaching: _this.state.job_subject_teaching,
	        job_experience: _this.state.job_experience,
	        examcertifications: _this.state.examcertifications,
	        expected_qualification_other: _this.state.expected_qualification_other,
	        skillsrequired_other: _this.state.skillsrequired_other,
	        job_role_other: _this.state.job_role_other,
	        job_subject_teaching_other: _this.state.job_subject_teaching_other,
	        examcertifications_other: _this.state.examcertifications_other,
	        job_status: 3
	      };
	
	      (0, _FetchCall.postajob)(req).then(function (response) {
	
	        if (response.status == 1) {
	
	          _reactNotifications.NotificationManager.success('Saved successfully', 'Post a job');
	        } else {
	
	          _reactNotifications.NotificationManager.error('Error posting a job', 'Post a job');
	        }
	      });
	    };
	
	    _this.onSelectExpectedQualification = function (selectedList) {
	      var keywords = [];
	      selectedList.map(function (item, i) {
	        keywords.push(item);
	      });
	      _this.setState({
	        expected_qualification: keywords.toString()
	      });
	    };
	
	    _this.onRemoveExpQualification = function (selectedList, removedItem) {
	      var keywords = [];
	      selectedList.map(function (item, i) {
	        keywords.push(item);
	      });
	      _this.setState({
	        expected_qualification: keywords.toString()
	      });
	    };
	
	    _this.handleFile = function (e) {
	      var propName = e.target.name;
	      var files = e.target.files[0];
	      _this.setState(_defineProperty({}, propName, files));
	    };
	
	    _this.onSelect = function (selectedList) {
	      var keywords = [];
	      selectedList.map(function (item, i) {
	        keywords.push(item);
	      });
	      _this.setState({
	        language_preferred: keywords.toString()
	      });
	    };
	
	    _this.onRemove = function (selectedList, removedItem) {
	      var keywords = [];
	      selectedList.map(function (item, i) {
	        keywords.push(item);
	      });
	      _this.setState({
	        language_preferred: keywords.toString()
	      });
	    };
	
	    _this.onSelectExamCertificaitons = function (selectedList) {
	      var keywords = [];
	      selectedList.map(function (item, i) {
	        keywords.push(item);
	      });
	      _this.setState({
	        examcertifications: keywords.toString()
	      });
	    };
	
	    _this.onRemoveExamCertifications = function (selectedList, removedItem) {
	      var keywords = [];
	      selectedList.map(function (item, i) {
	        keywords.push(item);
	      });
	      _this.setState({
	        examcertifications: keywords.toString()
	      });
	    };
	
	    _this.onSelectSkillRequired = function (selectedList) {
	      var keywords = [];
	      selectedList.map(function (item, i) {
	        keywords.push(item);
	      });
	      _this.setState({
	        skillsrequired: keywords.toString()
	      });
	    };
	
	    _this.onRemoveSkillRequired = function (selectedList, removedItem) {
	      var keywords = [];
	      selectedList.map(function (item, i) {
	        keywords.push(item);
	      });
	      _this.setState({
	        skillsrequired: keywords.toString()
	      });
	    };
	
	    _this.state = {
	      logged: localStorage.getItem("authentication"),
	      auth_data: JSON.parse(localStorage.getItem("user_data")),
	      category_data: [], collapse: 0, modalReply: false,
	      current_comment: '', current_rid: 0, current_eid: '',
	      PER_PAGE: 15,
	      total: 0,
	      loading: true,
	      list: [],
	      exportbtndisabled: false,
	      thisExportBtnText: 'Export',
	      blockinstopenmodal: false,
	      suggestions: [],
	      institute: '',
	      pickedones: [],
	      language_preferred: [],
	      pickedinstIds: [],
	      salary_range_forthisjob: 15000,
	      organisation_place: '',
	      organisation: '',
	      job_role_other_disabled: true,
	      job_subject_teaching_other_disabled: true,
	      expected_qualification_other_disabled: true,
	      examcertifications_other_disabled: true,
	      skillsrequired_other_disabled: true,
	      importopen: false,
	      job_title: '',
	      job_description: '',
	      job_description_pdf: ''
	    };
	
	    _this.cancelPop = _this.cancelPop.bind(_this);
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.importopen = _this.importopen.bind(_this);
	    _this.handleFile = _this.handleFile.bind(_this);
	    _this.handleSubmit = _this.handleSubmit.bind(_this);
	
	    return _this;
	  }
	
	  _createClass(Wcpostajob, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	
	      var THIS = this;
	    }
	  }, {
	    key: 'importopen',
	    value: function importopen() {
	      this.setState({ importopen: true });
	    }
	  }, {
	    key: 'cancelPop',
	    value: function cancelPop() {
	      this.setState({ blockinstopenmodal: false });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          value = _state.value,
	          suggestions = _state.suggestions,
	          pickedones = _state.pickedones,
	          language_preferred = _state.language_preferred;
	
	
	      var inputPropsD = {
	        value: this.state.institute,
	        onChange: this.onAutoSuggestChange,
	        name: 'institute',
	        className: 'forminputcls'
	      };
	
	      var _state2 = this.state,
	          salary_range_forthisjob = _state2.salary_range_forthisjob,
	          vertical = _state2.vertical;
	
	      var horizontalLabels = {
	        12000: '12k',
	        400000: '4L'
	      };
	
	      var expected_qualification_arr = ["Graduate in Education (BA / B.SC etc.)", "Post Graduate (MA /M.Sc etc)", "Engeneering Graduate", "Diploma In Education", "Bachelors Degree in Education (B.Ed)", "Masters Degree in Education (M.Ed)", "Doctorate (Phd)", "Bachelor of Elementray Education (B.EL.Ed)", "Bachelor of Arts & Education (BA. B.Ed)", "Diploma in Elementary Education (D.EL.Ed)", "Bachelor of Physical Education (B.P.Ed)", "Master of Philosophy in Education (M.Phil)", "Bachelor of Library Science (B.Lib)", "Bachelor of Library & Information Sciences (B.Lib.I.Sc)", "Masters in Library & Information Sciences (M.Lib.I.Sc)", "Bachelor of Fine Arts (BFA)", "Diploma Program in Special Education (DESCE-MR / DSE / MRW / DHLS etc)", "Post Graduate Diploma in Special Education", "Graduate in Special Education  (B.Ed - Spl Education)", "Other"];
	
	      var language_preferred_arr = ['English', 'Hindi', 'Tamil', 'Kannada', 'Telugu', 'Urdhu', 'Malayalam'];
	
	      var examcertifications_arr = ["None", "Central Teachers Eligibliity Test (CTET)", "National Eligibility Test (NET / UGC-NET)", "Basic Training Certificates", "Primary Teachers Certificates", "Teachers Training Certificates", "Teacher Eligiblity Test (TET)", "State Teachers Eligiblity Test (STET)", "Certificate course in Library Sciences", "Certificate course in Drawing teacher training", "Certificate in Care giving program", "Certificate program in Special Education", "Certicate Courses in Dance", "Certicate Courses in Arts", "Certificate Courses in Sports", "Certificate Courses in Music & Dance", "Other"];
	
	      var skillsrequired_arr = ["Expertise in specific subjects of teaching", "Written and verbal communication", "Ability to adapt to different situations", "Knowledge of teaching software and tools", "Ability to teach students experiencing challenge with learning", "Time management skills", "Innovative training strategies", "Flexibility to modify training principles", "Classroom management", "Leadership", "Conflict management", "Collaborative & Interpersonal skills", "Creative", "Financial Management", "Human Resource Management", "Curriculam Development", "School Policy Knowledge", "Understanding & Implementation of NEP requirements", "Other"];
	
	      var formatkg = function formatkg(value) {
	        return value;
	      };
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'col-12 grid-margin' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card-body' },
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'boxtitle' },
	                  _react2.default.createElement('img', { src: '../../images/profile/about.png' }),
	                  'Post a job'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'importbox' },
	                  _react2.default.createElement(
	                    'button',
	                    { 'class': 'btn btn-primary', onClick: this.importopen },
	                    'Import bulk'
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'postajobform wc' },
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup end_date_option', id: 'end_date_option' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Job title '
	                    ),
	                    _react2.default.createElement('input', { type: 'text', 'class': 'form-control forminputcls', id: 'job_title', name: 'job_title', onChange: this.handleChange })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Job Description '
	                    ),
	                    _react2.default.createElement('textarea', { 'class': 'form-control forminputcls', name: 'job_description', id: 'job_description', placeholder: 'Description', rows: '10', onChange: this.handleChange })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Preferred to upload JD as PDF '
	                    ),
	                    _react2.default.createElement('input', { type: 'file', 'class': 'form-control forminputcls', id: 'job_description_pdf', name: 'job_description_pdf', onChange: this.handleFile })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup end_date_option', id: 'end_date_option' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Job role'
	                    ),
	                    _react2.default.createElement(
	                      'select',
	                      { name: 'job_role', 'class': 'formselectinputcls', onChange: this.handleChange },
	                      _react2.default.createElement(
	                        'option',
	                        { value: '' },
	                        'Select Role'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Pre Primary Teacher' },
	                        'Pre Primary Teacher'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Primary Teacher' },
	                        'Primary Teacher'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Secondary Teacher' },
	                        'Secondary Teacher'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Senior Secondary Teacher' },
	                        'Senior Secondary Teacher'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Special Educator' },
	                        'Special Educator'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Libraian' },
	                        'Libraian'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Physial Education Teacher' },
	                        'Physial Education Teacher'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Counsellor' },
	                        'Counsellor'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Administrator' },
	                        'Administrator'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Accountant' },
	                        'Accountant'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Marketing' },
	                        'Marketing'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Music / Dance Teacher' },
	                        'Music / Dance Teacher'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Other' },
	                        'Other'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup end_date_option', id: 'end_date_option' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Job Role - If Other '
	                    ),
	                    _react2.default.createElement('input', { type: 'text', 'class': 'form-control forminputcls', id: 'job_role_other', disabled: this.state.job_role_other_disabled, name: 'job_role_other', onChange: this.handleChange })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup end_date_option', id: 'end_date_option' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Gender'
	                    ),
	                    _react2.default.createElement(
	                      'select',
	                      { name: 'job_gender', 'class': 'formselectinputcls', onChange: this.handleChange },
	                      _react2.default.createElement(
	                        'option',
	                        { value: '' },
	                        'Select Gender'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Male' },
	                        'Male'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Female' },
	                        'Female'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Other' },
	                        'Other'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Not a constraint' },
	                        'Not a constraint'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup end_date_option', id: 'end_date_option' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Role Type'
	                    ),
	                    _react2.default.createElement(
	                      'select',
	                      { name: 'job_category', 'class': 'formselectinputcls', onChange: this.handleChange },
	                      _react2.default.createElement(
	                        'option',
	                        { value: '' },
	                        'Select Role Type'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Full Time' },
	                        'Full Time'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Part Time' },
	                        'Part Time'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Contractual' },
	                        'Contractual'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Temporary' },
	                        'Temporary'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Internship' },
	                        'Internship'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup end_date_option', id: 'end_date_option' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Subject Of Teaching'
	                    ),
	                    _react2.default.createElement(
	                      'select',
	                      { name: 'job_subject_teaching', 'class': 'formselectinputcls', onChange: this.handleChange },
	                      _react2.default.createElement(
	                        'option',
	                        { value: '' },
	                        'Select Subject'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Biology' },
	                        'Biology'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Science' },
	                        'Science'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Maths' },
	                        'Maths'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Physics' },
	                        'Physics'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Chemistry' },
	                        'Chemistry'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Art' },
	                        'Art'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'History' },
	                        'History'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Economics' },
	                        'Economics'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Computer Science' },
	                        'Computer Science'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Phyisical Education' },
	                        'Phyisical Education'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Librarian' },
	                        'Librarian'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Humanities' },
	                        'Humanities'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Geography' },
	                        'Geography'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Civics' },
	                        'Civics'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'English' },
	                        'English'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Hindi' },
	                        'Hindi'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Tamil' },
	                        'Tamil'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Kannada' },
	                        'Kannada'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Telugu' },
	                        'Telugu'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Marathi' },
	                        'Marathi'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'French' },
	                        'French'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Spanish' },
	                        'Spanish'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'German' },
	                        'German'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Reglion and Religious Studies' },
	                        'Reglion and Religious Studies'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Visual Arts' },
	                        'Visual Arts'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Robotics & Coding' },
	                        'Robotics & Coding'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Other' },
	                        'Other'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup end_date_option', id: 'end_date_option' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Subject Of Teaching - If Other '
	                    ),
	                    _react2.default.createElement('input', { type: 'text', 'class': 'form-control forminputcls', id: 'job_subject_teaching_other', disabled: this.state.job_subject_teaching_other_disabled, name: 'job_subject_teaching_other', onChange: this.handleChange })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup end_date_option', id: 'end_date_option' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Experience Required '
	                    ),
	                    _react2.default.createElement(
	                      'select',
	                      { name: 'job_experience', 'class': 'formselectinputcls', onChange: this.handleChange },
	                      _react2.default.createElement(
	                        'option',
	                        { value: '' },
	                        '---Select---'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'freshers' },
	                        'Freshers'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: '1-3' },
	                        '1-3 Years'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: '4-9' },
	                        '4-9 years'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: '10-15' },
	                        '10-15 years'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: '15+' },
	                        '15+ years'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup end_date_option', id: 'end_date_option' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Anticipated joining '
	                    ),
	                    _react2.default.createElement(
	                      'select',
	                      { name: 'joining', 'class': 'formselectinputcls', onChange: this.handleChange },
	                      _react2.default.createElement(
	                        'option',
	                        { value: '' },
	                        '---Select---'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Immediate' },
	                        'Immediate'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: '15 Days' },
	                        '15 Days'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: '1 month' },
	                        '1 month'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: '2 months' },
	                        '2 months'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: '3 months' },
	                        '3 months'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Job Opening Date '
	                    ),
	                    _react2.default.createElement('input', { type: 'date', 'class': 'form-control forminputcls', id: 'open_date', name: 'open_date', onChange: this.handleChange })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Job Closing Date '
	                    ),
	                    _react2.default.createElement('input', { type: 'date', 'class': 'form-control forminputcls', id: 'closing_date', name: 'closing_date', onChange: this.handleChange })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup end_date_option', id: 'end_date_option' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Job Location '
	                    ),
	                    _react2.default.createElement(
	                      'select',
	                      { name: 'job_location', 'class': 'formselectinputcls', onChange: this.handleChange },
	                      _react2.default.createElement(
	                        'option',
	                        { value: '' },
	                        'Select'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'In Campus' },
	                        'In Campus'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Hybrid' },
	                        'Hybrid'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Remote' },
	                        'Remote'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup end_date_option', id: 'end_date_option' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Salary Range for this Job'
	                    ),
	                    ' ',
	                    _react2.default.createElement(
	                      'div',
	                      { id: 'salaryText', 'class': 'salaryText' },
	                      '\u20B9 ',
	                      formatkg(salary_range_forthisjob)
	                    ),
	                    _react2.default.createElement(_reactRangeslider2.default, {
	                      min: 10000,
	                      max: 400000,
	                      value: salary_range_forthisjob,
	                      labels: horizontalLabels,
	                      format: formatkg,
	                      step: 1000,
	                      handleLabel: salary_range_forthisjob,
	                      onChange: this.handleChangeHorizontal
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup end_date_option', id: 'end_date_option' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Languages preferred '
	                    ),
	                    _react2.default.createElement(_multiselectReactDropdown.Multiselect, {
	                      className: 'formselectinputcls',
	                      isObject: false,
	                      options: language_preferred_arr // Options to display in the dropdown
	                      , onSelect: this.onSelect // Function will trigger on select event
	                      , onRemove: this.onRemove // Function will trigger on remove event
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Expected Qualification '
	                    ),
	                    _react2.default.createElement(_multiselectReactDropdown.Multiselect, {
	                      className: 'formselectinputcls',
	                      isObject: false,
	                      options: expected_qualification_arr // Options to display in the dropdown
	                      , onSelect: this.onSelectExpectedQualification // Function will trigger on select event
	                      , onRemove: this.onRemoveExpQualification // Function will trigger on remove event
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup end_date_option', id: 'end_date_option' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Expected Qualification - If Other '
	                    ),
	                    _react2.default.createElement('input', { type: 'text', 'class': 'form-control forminputcls', id: 'expected_qualification_other', name: 'expected_qualification_other', disabled: this.state.expected_qualification_other_disabled, onChange: this.handleChange })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Entrance Examination & Certifications Required  '
	                    ),
	                    _react2.default.createElement(_multiselectReactDropdown.Multiselect, {
	                      className: 'formselectinputcls',
	                      isObject: false,
	                      options: examcertifications_arr // Options to display in the dropdown
	                      , onSelect: this.onSelectExamCertificaitons // Function will trigger on select event
	                      , onRemove: this.onRemoveExamCertifications // Function will trigger on remove event
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup end_date_option', id: 'end_date_option' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Examination and Certifications - If Other '
	                    ),
	                    _react2.default.createElement('input', { type: 'text', 'class': 'form-control forminputcls', id: 'examcertifications_other', name: 'examcertifications_other', disabled: this.state.examcertifications_other_disabled, onChange: this.handleChange })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Skills required '
	                    ),
	                    _react2.default.createElement(_multiselectReactDropdown.Multiselect, {
	                      className: 'formselectinputcls',
	                      isObject: false,
	                      options: skillsrequired_arr // Options to display in the dropdown
	                      , onSelect: this.onSelectSkillRequired // Function will trigger on select event
	                      , onRemove: this.onRemoveSkillRequired // Function will trigger on remove event
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup end_date_option', id: 'end_date_option' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Skills required - If Other '
	                    ),
	                    _react2.default.createElement('input', { type: 'text', 'class': 'form-control forminputcls', id: 'skillsrequired_other', name: 'skillsrequired_other', disabled: this.state.skillsrequired_other_disabled, onChange: this.handleChange })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup text-center paddingtop20' },
	                    _react2.default.createElement(
	                      'button',
	                      { type: 'button', name: 'postajob', 'class': 'btn-main', onClick: this.handleSave },
	                      'Save as Draft'
	                    ),
	                    '\xA0',
	                    _react2.default.createElement(
	                      'button',
	                      { type: 'button', name: 'postajob', 'class': 'btn-main', onClick: this.handleSubmit },
	                      'Post this job @wiseconnect'
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.Modal,
	            { size: 'lg', style: { maxWidth: '700px', width: '100%' }, isOpen: this.state.importopen, className: 'modalpopup' },
	            _react2.default.createElement(
	              _reactstrap.ModalHeader,
	              null,
	              'Import jobs'
	            ),
	            _react2.default.createElement(_reactstrap.ModalBody, null)
	          ),
	          _react2.default.createElement(_reactNotifications.NotificationContainer, null)
	        )
	      );
	    }
	  }]);
	
	  return Wcpostajob;
	}(_react.Component);
	
	exports.default = Wcpostajob;

/***/ },
/* 1060 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _reactstrap = __webpack_require__(17);
	
	var _reactDataTableComponent = __webpack_require__(53);
	
	var _reactDataTableComponent2 = _interopRequireDefault(_reactDataTableComponent);
	
	var _reactJsPagination = __webpack_require__(33);
	
	var _reactJsPagination2 = _interopRequireDefault(_reactJsPagination);
	
	var _bewiseloading = __webpack_require__(48);
	
	var _bewiseloading2 = _interopRequireDefault(_bewiseloading);
	
	__webpack_require__(18);
	
	var _reactNotifications = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import { Editor } from '@tinymce/tinymce-react';
	
	//import Pagination from 'rc-pagination';
	
	var registeredUsersList = function (_Component) {
	  _inherits(registeredUsersList, _Component);
	
	  function registeredUsersList(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, registeredUsersList);
	
	    var _this = _possibleConstructorReturn(this, (registeredUsersList.__proto__ || Object.getPrototypeOf(registeredUsersList)).call(this, props));
	
	    _this.getTotal = function (vertical) {
	      var location = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	      var _this$state$auth_data = _this.state.auth_data,
	          login_id = _this$state$auth_data.login_id,
	          role = _this$state$auth_data.role;
	
	
	      var locationselected = location == '' ? _this.state.location : location;
	
	      var ins = JSON.stringify({
	        vendor_id: login_id,
	        role: role,
	        vertical: vertical,
	        location: locationselected,
	        searchby: _this.state.searchby
	      });
	
	      (0, _FetchCall.getTotalRegistered)(ins).then(function (res) {
	
	        _this.setState({ loading: true });
	
	        if (res.status == 1) {
	
	          _this.setState({
	
	            total: res.total
	
	          });
	        }
	      });
	    };
	
	    _this.getList = function () {
	      var pageNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	      var location = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	      var _this$state$auth_data2 = _this.state.auth_data,
	          login_id = _this$state$auth_data2.login_id,
	          role = _this$state$auth_data2.role;
	
	
	      _this.setState({ activePage: pageNumber });
	
	      var newOffset = pageNumber == 1 ? 0 : (pageNumber - 1) * _this.state.PER_PAGE % _this.state.total;
	
	      var locationselected = location == '' ? _this.state.location : location;
	
	      var ins = JSON.stringify({
	        perpage: _this.state.PER_PAGE,
	        year: _this.state.year,
	        month: _this.state.month,
	        offset: newOffset
	      });
	
	      (0, _FetchCall.getRegisteredListPaged)(ins).then(function (res) {
	
	        _this.setState({ loading: true });
	
	        if (res.status == 1) {
	
	          _this.setState({ loading: !_this.state.loading });
	
	          var newLeads = res.data.map(function (lead) {
	            return {
	              "id": lead.id,
	              "email": lead.email,
	              "name": lead.name,
	              "phonenumber": lead.phonenumber,
	              "pre_registered": lead.pre_registered,
	              "status": lead.status,
	              "professionalprofile": lead.professionalprofile,
	              "personalprofile": lead.personalprofile,
	              "createdAt": new Intl.DateTimeFormat('en-US', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).format(lead.created_date)
	            };
	          });
	
	          _this.setState({ list: newLeads });
	        } else {
	
	          _this.setState({ loading: !_this.state.loading });
	
	          _this.setState({
	            list: []
	          });
	        }
	      });
	    };
	
	    _this.subscribersExport = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var req, res;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	
	              _this.setState({ exportbtndisabled: true, thisExportBtnText: "exporting..." });
	
	              _context.prev = 1;
	              req = JSON.stringify({
	                location: _this.state.location
	              });
	              _context.next = 5;
	              return (0, _FetchCall.exportWcSubscribers)(req);
	
	            case 5:
	              res = _context.sent;
	
	              if (res.status == 1) {
	
	                _this.setState({ exportbtndisabled: false, thisExportBtnText: "Export" });
	                console.log('location_list', res);
	                console.log('location_list', res.path);
	                window.open(res.path);
	
	                // this.setState({
	                //   subscribe_list: res.results,
	                // });
	              }
	
	              _context.next = 12;
	              break;
	
	            case 9:
	              _context.prev = 9;
	              _context.t0 = _context['catch'](1);
	
	              _this.setState({ error: true });
	
	            case 12:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2, [[1, 9]]);
	    }));
	
	    _this.state = {
	      logged: localStorage.getItem("authentication"),
	      auth_data: JSON.parse(localStorage.getItem("user_data")),
	      category_data: [], collapse: 0, modalReply: false,
	      current_comment: '', current_rid: 0, current_eid: '',
	      PER_PAGE: 15,
	      total: 0,
	      loading: true,
	      list: [],
	      exportbtndisabled: false,
	      thisExportBtnText: 'Export',
	      selected_teacher: '',
	      blocked: false
	    };
	
	    _this.getTotal = _this.getTotal.bind(_this);
	    _this.getList = _this.getList.bind(_this);
	    _this.blockUser = _this.blockUser.bind(_this);
	    _this.cancelModal = _this.cancelModal.bind(_this);
	    _this.submitBlockUser = _this.submitBlockUser.bind(_this);
	
	    return _this;
	  }
	
	  _createClass(registeredUsersList, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	
	      var THIS = this;
	      (0, _jquery2.default)(document).on('click', '.dlte', function () {
	        var _this3 = this;
	
	        var delete_id = (0, _jquery2.default)(this).data("id");
	
	        if (confirm("You are sure to delete?") == true) {
	
	          var ins = JSON.stringify({
	            id: delete_id,
	            table: 'wiseconnect'
	          });
	
	          (0, _FetchCall.removethisItem)(ins).then(function (res) {
	
	            if (res.status == 1) {
	              _reactNotifications.NotificationManager.success('Removed successfully');
	            } else {
	              _reactNotifications.NotificationManager.error('Issue in removing');
	            }
	            _this3.getTotal('leads');
	            _this3.getList();
	          });
	        }
	      });
	
	      this.getTotal('leads');
	      this.getList();
	    }
	  }, {
	    key: 'sendProComFolwup',
	    value: function sendProComFolwup(lead_id) {
	      var _this4 = this;
	
	      var ins = JSON.stringify({
	        lead_id: lead_id
	      });
	
	      (0, _FetchCall.sendProComFollowUp)(ins).then(function (res) {
	
	        _this4.setState({ loading: true });
	
	        if (res.status == 1) {
	
	          _reactNotifications.NotificationManager.success('Profile completion follow-up mail has been sent successfully');
	        } else {
	          _reactNotifications.NotificationManager.error('Profile completion follow-up mail is not sent');
	        }
	      });
	    }
	  }, {
	    key: 'blockUser',
	    value: function blockUser(teacher_id) {
	
	      this.setState({ blockmodal: true, selected_teacher: teacher_id });
	    }
	  }, {
	    key: 'cancelModal',
	    value: function cancelModal() {
	
	      this.setState({ blockmodal: false, selected_teacher: '' });
	    }
	  }, {
	    key: 'unBlockUser',
	    value: function unBlockUser(teacher_id) {
	
	      var ins = JSON.stringify({
	        teacher_id: teacher_id
	      });
	
	      (0, _FetchCall.unBlockThisUser)(ins).then(function (res) {
	
	        if (res.status == 1) {
	          _reactNotifications.NotificationManager.success('Unblocked successfully');
	        } else {
	          _reactNotifications.NotificationManager.error('Issue in unblocking');
	        }
	      });
	    }
	  }, {
	    key: 'submitBlockUser',
	    value: function submitBlockUser() {
	      var _this5 = this;
	
	      var teacher_id = this.state.selected_teacher;
	
	      var ins = JSON.stringify({
	        teacher_id: teacher_id
	      });
	
	      (0, _FetchCall.blockThisUser)(ins).then(function (res) {
	
	        if (res.status == 1) {
	          _this5.setState({ blocked: true });
	        } else {
	          _this5.setState({ blocked: false });
	        }
	      });
	    }
	  }, {
	    key: 'handlePageChange',
	    value: function handlePageChange(pageNumber) {
	
	      console.log('active page is ' + pageNumber);
	
	      this.setState({ activePage: pageNumber });
	
	      //this.getTotal('bw_schools');
	      this.getList(pageNumber);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this6 = this;
	
	      var list = this.state.list;
	      var _state = this.state,
	          currentPage = _state.currentPage,
	          PER_PAGE = _state.PER_PAGE,
	          totalCount = _state.totalCount,
	          total = _state.total,
	          exportbtndisabled = _state.exportbtndisabled;
	
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'col-12 grid-margin' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card-body' },
	                _react2.default.createElement(
	                  'h4',
	                  { 'class': 'card-title' },
	                  'List'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'float-right' },
	                  _react2.default.createElement(
	                    'button',
	                    { disabled: exportbtndisabled, 'class': 'btn btn-primary btn-sm', onClick: function onClick() {
	                        return _this6.subscribersExport();
	                      } },
	                    this.state.thisExportBtnText
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'table-responsive pt-3' },
	                  _react2.default.createElement(
	                    'table',
	                    { 'class': 'table table-bordered table-sm' },
	                    _react2.default.createElement(
	                      'thead',
	                      { 'class': 'thead-dark' },
	                      _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          'S.No'
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          'Name'
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          'Email Id'
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          'Phonenumber'
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          'Date'
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          'Status'
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          'Personal'
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          'Professional'
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          'Early Bird?'
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          'Action'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'tbody',
	                      null,
	                      list.length > 0 && list.map(function (lead, i) {
	
	                        return _react2.default.createElement(
	                          'tr',
	                          null,
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            i + 1
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            lead.name
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            lead.email
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            lead.phonenumber
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            lead.createdAt
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            { className: lead.status == 1 ? "active" : lead.status == 3 ? "blocked" : "inactive" },
	                            _react2.default.createElement(
	                              'b',
	                              null,
	                              lead.status == "1" ? "Active" : lead.status == "3" ? "Blocked" : "Not Verified Yet"
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            _react2.default.createElement(
	                              'b',
	                              null,
	                              lead.personalprofile,
	                              '% complete'
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            _react2.default.createElement(
	                              'b',
	                              null,
	                              lead.professionalprofile,
	                              '% complete'
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            lead.pre_registered == 1 ? "Yes" : "No"
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            _react2.default.createElement(
	                              'a',
	                              { href: "/wiseconnect/viewprofile/" + lead.id, 'class': 'btn btn-primary btn-sm' },
	                              'View'
	                            ),
	                            '\xA0'
	                          )
	                        );
	                      }),
	                      list.length == 0 && _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                          'td',
	                          { colSpan: '6' },
	                          'No data'
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'text-center' },
	                    _react2.default.createElement(_reactJsPagination2.default, {
	                      activePage: this.state.activePage,
	                      itemsCountPerPage: PER_PAGE,
	                      totalItemsCount: this.state.total,
	                      pageRangeDisplayed: 5,
	                      activeClass: "pagination__link--active",
	                      onChange: this.handlePageChange.bind(this),
	                      prevPageText: 'previous',
	                      nextPageText: 'next'
	                    })
	                  )
	                )
	              )
	            )
	          ),
	          '  ',
	          _react2.default.createElement(_reactNotifications.NotificationContainer, null),
	          _react2.default.createElement(
	            _reactstrap.Modal,
	            { size: 'sm', style: { maxWidth: '450px', width: '100%' }, isOpen: this.state.blockmodal, className: 'modalpopup' },
	            _react2.default.createElement(
	              _reactstrap.ModalHeader,
	              null,
	              'Blocking User Access'
	            ),
	            _react2.default.createElement(
	              _reactstrap.ModalBody,
	              null,
	              !this.state.blocked && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'areyousure' },
	                  'Are you sure that you want to block this user access?'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'btnblockflex' },
	                  _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'button',
	                      { 'class': 'btn btn-main', onClick: this.submitBlockUser },
	                      'Yes'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'button',
	                      { 'class': 'btn btn-main', onClick: this.cancelModal },
	                      'No'
	                    )
	                  )
	                )
	              ),
	              this.state.blocked && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'areyousure' },
	                  'Successfully We have blocked this user!'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'btnblockflex' },
	                  _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'button',
	                      { 'class': 'btn btn-main', onClick: this.cancelModal },
	                      'Close'
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return registeredUsersList;
	}(_react.Component);
	
	exports.default = registeredUsersList;

/***/ },
/* 1061 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	var _reactstrap = __webpack_require__(17);
	
	var _reactDataTableComponent = __webpack_require__(53);
	
	var _reactDataTableComponent2 = _interopRequireDefault(_reactDataTableComponent);
	
	var _reactJsPagination = __webpack_require__(33);
	
	var _reactJsPagination2 = _interopRequireDefault(_reactJsPagination);
	
	var _bewiseloading = __webpack_require__(48);
	
	var _bewiseloading2 = _interopRequireDefault(_bewiseloading);
	
	__webpack_require__(18);
	
	var _reactNotifications = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import { Editor } from '@tinymce/tinymce-react';
	
	//import Pagination from 'rc-pagination';
	
	var subscribersList = function (_Component) {
	  _inherits(subscribersList, _Component);
	
	  function subscribersList(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, subscribersList);
	
	    var _this = _possibleConstructorReturn(this, (subscribersList.__proto__ || Object.getPrototypeOf(subscribersList)).call(this, props));
	
	    _this.getTotal = function (vertical) {
	      var location = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	      var _this$state$auth_data = _this.state.auth_data,
	          login_id = _this$state$auth_data.login_id,
	          role = _this$state$auth_data.role;
	
	
	      var locationselected = location == '' ? _this.state.location : location;
	
	      var ins = JSON.stringify({
	        vendor_id: login_id,
	        role: role,
	        vertical: vertical,
	        location: locationselected,
	        searchby: _this.state.searchby
	      });
	
	      (0, _FetchCall.getTotalSubscribers)(ins).then(function (res) {
	
	        _this.setState({ loading: true });
	
	        if (res.status == 1) {
	
	          _this.setState({
	
	            total: res.total
	
	          });
	        }
	      });
	    };
	
	    _this.getList = function () {
	      var pageNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	      var location = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	      var _this$state$auth_data2 = _this.state.auth_data,
	          login_id = _this$state$auth_data2.login_id,
	          role = _this$state$auth_data2.role;
	
	
	      _this.setState({ activePage: pageNumber });
	
	      var newOffset = pageNumber == 1 ? 0 : (pageNumber - 1) * _this.state.PER_PAGE % _this.state.total;
	
	      var locationselected = location == '' ? _this.state.location : location;
	
	      var ins = JSON.stringify({
	        perpage: _this.state.PER_PAGE,
	        year: _this.state.year,
	        month: _this.state.month,
	        offset: newOffset
	      });
	
	      (0, _FetchCall.getSubscribersListPaged)(ins).then(function (res) {
	
	        _this.setState({ loading: true });
	
	        if (res.status == 1) {
	
	          _this.setState({ loading: !_this.state.loading });
	
	          var newLeads = res.data.map(function (lead) {
	            return {
	              "id": lead.id,
	              "email": lead.email,
	              "verified": lead.verified,
	              "createdAt": new Intl.DateTimeFormat('en-US', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).format(lead.created_date)
	            };
	          });
	
	          _this.setState({ list: newLeads });
	        } else {
	
	          _this.setState({ loading: !_this.state.loading });
	
	          _this.setState({
	            list: []
	          });
	        }
	      });
	    };
	
	    _this.subscribersExport = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var req, res;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	
	              _this.setState({ exportbtndisabled: true, thisExportBtnText: "exporting..." });
	
	              _context.prev = 1;
	              req = JSON.stringify({
	                location: _this.state.location
	              });
	              _context.next = 5;
	              return (0, _FetchCall.exportWcSubscribers)(req);
	
	            case 5:
	              res = _context.sent;
	
	              if (res.status == 1) {
	
	                _this.setState({ exportbtndisabled: false, thisExportBtnText: "Export" });
	                console.log('location_list', res);
	                console.log('location_list', res.path);
	                window.open(res.path);
	
	                // this.setState({
	                //   subscribe_list: res.results,
	                // });
	              }
	
	              _context.next = 12;
	              break;
	
	            case 9:
	              _context.prev = 9;
	              _context.t0 = _context['catch'](1);
	
	              _this.setState({ error: true });
	
	            case 12:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2, [[1, 9]]);
	    }));
	
	    _this.state = {
	      logged: localStorage.getItem("authentication"),
	      auth_data: JSON.parse(localStorage.getItem("user_data")),
	      category_data: [], collapse: 0, modalReply: false,
	      current_comment: '', current_rid: 0, current_eid: '',
	      PER_PAGE: 15,
	      total: 0,
	      loading: true,
	      list: [],
	      exportbtndisabled: false,
	      thisExportBtnText: 'Export'
	    };
	
	    _this.getTotal = _this.getTotal.bind(_this);
	    _this.getList = _this.getList.bind(_this);
	    return _this;
	  }
	
	  _createClass(subscribersList, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	
	      var THIS = this;
	      (0, _jquery2.default)(document).on('click', '.dlte', function () {
	        var _this3 = this;
	
	        var delete_id = (0, _jquery2.default)(this).data("id");
	
	        if (confirm("You are sure to delete?") == true) {
	
	          var ins = JSON.stringify({
	            id: delete_id,
	            table: 'wiseconnect'
	          });
	
	          (0, _FetchCall.removethisItem)(ins).then(function (res) {
	
	            if (res.status == 1) {
	              _reactNotifications.NotificationManager.success('Removed successfully');
	            } else {
	              _reactNotifications.NotificationManager.error('Issue in removing');
	            }
	            _this3.getTotal('leads');
	            _this3.getList();
	          });
	        }
	      });
	
	      this.getTotal('leads');
	      this.getList();
	    }
	  }, {
	    key: 'handlePageChange',
	    value: function handlePageChange(pageNumber) {
	
	      console.log('active page is ' + pageNumber);
	
	      this.setState({ activePage: pageNumber });
	
	      //this.getTotal('bw_schools');
	      this.getList(pageNumber);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var list = this.state.list;
	      var _state = this.state,
	          currentPage = _state.currentPage,
	          PER_PAGE = _state.PER_PAGE,
	          totalCount = _state.totalCount,
	          total = _state.total,
	          exportbtndisabled = _state.exportbtndisabled;
	
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'col-12 grid-margin' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card-body' },
	                _react2.default.createElement(
	                  'h4',
	                  { 'class': 'card-title' },
	                  'List'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'float-right' },
	                  _react2.default.createElement(
	                    'button',
	                    { disabled: exportbtndisabled, 'class': 'btn btn-primary btn-sm', onClick: function onClick() {
	                        return _this4.subscribersExport();
	                      } },
	                    this.state.thisExportBtnText
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'table-responsive pt-3' },
	                  _react2.default.createElement(
	                    'table',
	                    { 'class': 'table table-bordered table-sm' },
	                    _react2.default.createElement(
	                      'thead',
	                      { 'class': 'thead-dark' },
	                      _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          'S.No'
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          'Email'
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          'Date'
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          'Action'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'tbody',
	                      null,
	                      list.length > 0 && list.map(function (lead, i) {
	
	                        return _react2.default.createElement(
	                          'tr',
	                          null,
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            i + 1
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            lead.email
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            lead.createdAt
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            _react2.default.createElement(
	                              'button',
	                              { 'class': 'dlte', 'data-id': lead.id },
	                              'Remove'
	                            )
	                          )
	                        );
	                      }),
	                      list.length == 0 && _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                          'td',
	                          { colSpan: '6' },
	                          'No data'
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'text-center' },
	                    _react2.default.createElement(_reactJsPagination2.default, {
	                      activePage: this.state.activePage,
	                      itemsCountPerPage: PER_PAGE,
	                      totalItemsCount: this.state.total,
	                      pageRangeDisplayed: 5,
	                      activeClass: "pagination__link--active",
	                      onChange: this.handlePageChange.bind(this),
	                      prevPageText: 'previous',
	                      nextPageText: 'next'
	                    })
	                  )
	                )
	              )
	            )
	          ),
	          '  ',
	          _react2.default.createElement(_reactNotifications.NotificationContainer, null)
	        )
	      );
	    }
	  }]);
	
	  return subscribersList;
	}(_react.Component);
	
	exports.default = subscribersList;

/***/ },
/* 1062 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	__webpack_require__(18);
	
	var _reactNotifications = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import { Editor } from '@tinymce/tinymce-react';
	
	
	var Talentsearch = function (_Component) {
	    _inherits(Talentsearch, _Component);
	
	    function Talentsearch(props) {
	        _classCallCheck(this, Talentsearch);
	
	        var _this = _possibleConstructorReturn(this, (Talentsearch.__proto__ || Object.getPrototypeOf(Talentsearch)).call(this, props));
	
	        _this.handleChange = function (e) {
	            _this.setState(_defineProperty({}, e.target.name, e.target.value));
	        };
	
	        _this.state = {
	            logged: localStorage.getItem("authentication"),
	            auth_data: JSON.parse(localStorage.getItem("user_data")),
	            category_data: [], collapse: 0, modalReply: false,
	            current_comment: '', current_rid: 0, current_eid: '',
	            talents: [],
	            keyword: '',
	            experience: '',
	            allowedtoacess: false
	        };
	
	        _this.searchGo = _this.searchGo.bind(_this);
	
	        return _this;
	    }
	
	    _createClass(Talentsearch, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	
	            var dataOfUser = this.state.auth_data;
	            var allowedtoacess = dataOfUser.upgraded == 1 ? true : dataOfUser.current_plan != 5 && dataOfUser.current_plan != 0 && dataOfUser.current_plan != 1 ? true : false;
	            this.setState({ allowedtoacess: allowedtoacess });
	            this.getTalents();
	        }
	    }, {
	        key: 'getTalents',
	        value: function getTalents() {
	            var _this2 = this;
	
	            var req = JSON.stringify({});
	
	            (0, _FetchCall.getTalents)(req).then(function (response) {
	
	                if (response.status == 1) {
	                    _this2.setState({ talents: response.list });
	                    //NotificationManager.success('Changed Status Successfully',  'Change Status - Job Applicant');
	                } else {
	
	                    _this2.setState({ talents: [] });
	                }
	            });
	        }
	    }, {
	        key: 'searchGo',
	        value: function searchGo() {
	            var _this3 = this;
	
	            this.setState({ loading: true });
	
	            var req = JSON.stringify({});
	
	            (0, _FetchCall.getTalents)(req).then(function (response) {
	
	                if (response.status == 1) {
	                    _this3.setState({ loading: false, talents: response.list });
	                    //NotificationManager.success('Changed Status Successfully',  'Change Status - Job Applicant');
	                } else {
	
	                    _this3.setState({ loading: false, talents: [] });
	                }
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _state = this.state,
	                list = _state.list,
	                talents = _state.talents;
	
	
	            return _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _react2.default.createElement(
	                    _layout2.default,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { 'class': 'col-12 grid-margin' },
	                        _react2.default.createElement(
	                            'div',
	                            { 'class': 'card' },
	                            !this.state.allowedtoacess && _react2.default.createElement(
	                                'div',
	                                { 'class': 'overlay' },
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    'Please subscribe or upgrade'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: !this.state.allowedtoacess ? "card-body blurred" : 'card-body' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'boxtitle' },
	                                    _react2.default.createElement('img', { src: '../../images/profile/about.png' }),
	                                    'Talent Search ',
	                                    this.state.allowedtoacess
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'simple_filters' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'selectbox' },
	                                        _react2.default.createElement(
	                                            'select',
	                                            { name: 'level', 'class': 'forminputcls pad10', onChange: this.handleChange },
	                                            _react2.default.createElement(
	                                                'option',
	                                                { value: '' },
	                                                'Select Level'
	                                            ),
	                                            _react2.default.createElement(
	                                                'option',
	                                                { value: 'Preschool' },
	                                                'Preschool'
	                                            ),
	                                            _react2.default.createElement(
	                                                'option',
	                                                { value: 'Primary School' },
	                                                'Primary School'
	                                            ),
	                                            _react2.default.createElement(
	                                                'option',
	                                                { value: 'Middle School' },
	                                                'Middle School'
	                                            ),
	                                            _react2.default.createElement(
	                                                'option',
	                                                { value: 'Secondary School' },
	                                                'Secondary School'
	                                            ),
	                                            _react2.default.createElement(
	                                                'option',
	                                                { value: 'Higher Secondary School' },
	                                                'Higher Secondary School'
	                                            ),
	                                            _react2.default.createElement(
	                                                'option',
	                                                { value: 'Leadership' },
	                                                'Leadership'
	                                            ),
	                                            _react2.default.createElement(
	                                                'option',
	                                                { value: 'Administration' },
	                                                'Administration'
	                                            ),
	                                            _react2.default.createElement(
	                                                'option',
	                                                { value: 'Others' },
	                                                'Others'
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'selectbox' },
	                                        _react2.default.createElement(
	                                            'select',
	                                            { name: 'role', 'class': 'forminputcls pad10' },
	                                            _react2.default.createElement(
	                                                'option',
	                                                { value: '' },
	                                                'Select Role'
	                                            ),
	                                            _react2.default.createElement(
	                                                'option',
	                                                { value: 'Pre Primary Teacher' },
	                                                'Pre Primary Teacher'
	                                            ),
	                                            _react2.default.createElement(
	                                                'option',
	                                                { value: 'Primary Teacher' },
	                                                'Primary Teacher'
	                                            ),
	                                            _react2.default.createElement(
	                                                'option',
	                                                { value: 'Secondary Teacher' },
	                                                'Secondary Teacher'
	                                            ),
	                                            _react2.default.createElement(
	                                                'option',
	                                                { value: 'Senior Secondary Teacher' },
	                                                'Senior Secondary Teacher'
	                                            ),
	                                            _react2.default.createElement(
	                                                'option',
	                                                { value: 'Special Educator' },
	                                                'Special Educator'
	                                            ),
	                                            _react2.default.createElement(
	                                                'option',
	                                                { value: 'Libraian' },
	                                                'Libraian'
	                                            ),
	                                            _react2.default.createElement(
	                                                'option',
	                                                { value: 'Physial Education Teacher' },
	                                                'Physial Education Teacher'
	                                            ),
	                                            _react2.default.createElement(
	                                                'option',
	                                                { value: 'Counsellor' },
	                                                'Counsellor'
	                                            ),
	                                            _react2.default.createElement(
	                                                'option',
	                                                { value: 'Administrator' },
	                                                'Administrator'
	                                            ),
	                                            _react2.default.createElement(
	                                                'option',
	                                                { value: 'Accountant' },
	                                                'Accountant'
	                                            ),
	                                            _react2.default.createElement(
	                                                'option',
	                                                { value: 'Marketing' },
	                                                'Marketing'
	                                            ),
	                                            _react2.default.createElement(
	                                                'option',
	                                                { value: 'Music / Dance Teacher' },
	                                                'Music / Dance Teacher'
	                                            ),
	                                            _react2.default.createElement(
	                                                'option',
	                                                { value: 'Other' },
	                                                'Other'
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'selectbox' },
	                                        _react2.default.createElement(
	                                            'select',
	                                            { name: 'role_type', 'class': 'forminputcls pad10' },
	                                            _react2.default.createElement(
	                                                'option',
	                                                { value: '' },
	                                                'Select Role Type'
	                                            ),
	                                            _react2.default.createElement(
	                                                'option',
	                                                { value: 'Full Time' },
	                                                'Full Time'
	                                            ),
	                                            _react2.default.createElement(
	                                                'option',
	                                                { value: 'Part Time' },
	                                                'Part Time'
	                                            ),
	                                            _react2.default.createElement(
	                                                'option',
	                                                { value: 'Contractual' },
	                                                'Contractual'
	                                            ),
	                                            _react2.default.createElement(
	                                                'option',
	                                                { value: 'Temporary' },
	                                                'Temporary'
	                                            ),
	                                            _react2.default.createElement(
	                                                'option',
	                                                { value: 'Internship' },
	                                                'Internship'
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'selectbox' },
	                                        _react2.default.createElement(
	                                            'select',
	                                            { name: 'job_subject_teaching', 'class': 'forminputcls pad10' },
	                                            _react2.default.createElement(
	                                                'option',
	                                                { value: '' },
	                                                'Select Subject of Teaching'
	                                            ),
	                                            _react2.default.createElement(
	                                                'option',
	                                                { value: 'Biology' },
	                                                'Biology'
	                                            ),
	                                            _react2.default.createElement(
	                                                'option',
	                                                { value: 'Science' },
	                                                'Science'
	                                            ),
	                                            _react2.default.createElement(
	                                                'option',
	                                                { value: 'Maths' },
	                                                'Maths'
	                                            ),
	                                            _react2.default.createElement(
	                                                'option',
	                                                { value: 'Physics' },
	                                                'Physics'
	                                            ),
	                                            _react2.default.createElement(
	                                                'option',
	                                                { value: 'Chemistry' },
	                                                'Chemistry'
	                                            ),
	                                            _react2.default.createElement(
	                                                'option',
	                                                { value: 'Art' },
	                                                'Art'
	                                            ),
	                                            _react2.default.createElement(
	                                                'option',
	                                                { value: 'History' },
	                                                'History'
	                                            ),
	                                            _react2.default.createElement(
	                                                'option',
	                                                { value: 'Economics' },
	                                                'Economics'
	                                            ),
	                                            _react2.default.createElement(
	                                                'option',
	                                                { value: 'Computer Science' },
	                                                'Computer Science'
	                                            ),
	                                            _react2.default.createElement(
	                                                'option',
	                                                { value: 'Phyisical Education' },
	                                                'Phyisical Education'
	                                            ),
	                                            _react2.default.createElement(
	                                                'option',
	                                                { value: 'Librarian' },
	                                                'Librarian'
	                                            ),
	                                            _react2.default.createElement(
	                                                'option',
	                                                { value: 'Humanities' },
	                                                'Humanities'
	                                            ),
	                                            _react2.default.createElement(
	                                                'option',
	                                                { value: 'Geography' },
	                                                'Geography'
	                                            ),
	                                            _react2.default.createElement(
	                                                'option',
	                                                { value: 'Civics' },
	                                                'Civics'
	                                            ),
	                                            _react2.default.createElement(
	                                                'option',
	                                                { value: 'English' },
	                                                'English'
	                                            ),
	                                            _react2.default.createElement(
	                                                'option',
	                                                { value: 'Hindi' },
	                                                'Hindi'
	                                            ),
	                                            _react2.default.createElement(
	                                                'option',
	                                                { value: 'Tamil' },
	                                                'Tamil'
	                                            ),
	                                            _react2.default.createElement(
	                                                'option',
	                                                { value: 'Kannada' },
	                                                'Kannada'
	                                            ),
	                                            _react2.default.createElement(
	                                                'option',
	                                                { value: 'Telugu' },
	                                                'Telugu'
	                                            ),
	                                            _react2.default.createElement(
	                                                'option',
	                                                { value: 'Marathi' },
	                                                'Marathi'
	                                            ),
	                                            _react2.default.createElement(
	                                                'option',
	                                                { value: 'French' },
	                                                'French'
	                                            ),
	                                            _react2.default.createElement(
	                                                'option',
	                                                { value: 'Spanish' },
	                                                'Spanish'
	                                            ),
	                                            _react2.default.createElement(
	                                                'option',
	                                                { value: 'German' },
	                                                'German'
	                                            ),
	                                            _react2.default.createElement(
	                                                'option',
	                                                { value: 'Reglion and Religious Studies' },
	                                                'Reglion and Religious Studies'
	                                            ),
	                                            _react2.default.createElement(
	                                                'option',
	                                                { value: 'Visual Arts' },
	                                                'Visual Arts'
	                                            ),
	                                            _react2.default.createElement(
	                                                'option',
	                                                { value: 'Robotics & Coding' },
	                                                'Robotics & Coding'
	                                            ),
	                                            _react2.default.createElement(
	                                                'option',
	                                                { value: 'Other' },
	                                                'Other'
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'gobox' },
	                                        _react2.default.createElement(
	                                            'button',
	                                            { 'class': 'btn btn-main', onClick: this.searchGo },
	                                            'Filter'
	                                        )
	                                    )
	                                ),
	                                !this.state.loading && _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'listingsapplicants' },
	                                    talents.length > 0 && talents.map(function (item, i) {
	
	                                        return _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'eachapplicantrow' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { 'class': 'iconbag' },
	                                                _react2.default.createElement('img', { src: "../../images/profile.png" })
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { 'class': 'jobdetail' },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { 'class': 'jobname' },
	                                                    item.name
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { 'class': 'jobclass' },
	                                                    item.aboutme ? item.aboutme.length > 300 ? item.aboutme.substring(0, 254) + '...' : item.aboutme : ""
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { 'class': 'jobattributes tags' },
	                                                    _react2.default.createElement(
	                                                        'span',
	                                                        { 'class': 'tag' },
	                                                        _react2.default.createElement('img', { src: "../../images/ins/experience.png" }),
	                                                        '\xA0',
	                                                        item.area_of_interests
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'span',
	                                                        { 'class': 'tag' },
	                                                        _react2.default.createElement('img', { src: "../../images/ins/timer.png" }),
	                                                        '\xA0',
	                                                        item.total_years_experiece,
	                                                        ' years exp'
	                                                    )
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { 'class': 'buttonsec_sm' },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    null,
	                                                    _react2.default.createElement(
	                                                        'a',
	                                                        { href: "/partner/wctalentsearch/viewprofile/" + item.id, 'class': 'btn btn-main-full' },
	                                                        'View Profile'
	                                                    )
	                                                )
	                                            )
	                                        );
	                                    }),
	                                    talents.length == 0 && _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'nodata' },
	                                        'No Data'
	                                    )
	                                ),
	                                this.state.loading && _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'blueloading' },
	                                    ' Please wait...it is loading...'
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(_reactNotifications.NotificationContainer, null)
	                )
	            );
	        }
	    }]);
	
	    return Talentsearch;
	}(_react.Component);
	
	exports.default = Talentsearch;

/***/ },
/* 1063 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _reactRouterDom = __webpack_require__(296);
	
	var _FetchCall = __webpack_require__(4);
	
	__webpack_require__(18);
	
	var _reactNotifications = __webpack_require__(16);
	
	__webpack_require__(66);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import { Editor } from '@tinymce/tinymce-react';
	
	//import ReactToPrint from 'react-to-print';
	
	var IMG_URL = "https://api.bewise.in/"; //"https://api.bewise.in/";
	
	var WcUserViewProfile = function (_Component) {
	  _inherits(WcUserViewProfile, _Component);
	
	  function WcUserViewProfile(props) {
	    _classCallCheck(this, WcUserViewProfile);
	
	    var _this = _possibleConstructorReturn(this, (WcUserViewProfile.__proto__ || Object.getPrototypeOf(WcUserViewProfile)).call(this, props));
	
	    _this.handleChangeHorizontal = function (value) {
	      _this.setState({
	        salary_range_forthisjob: value
	      });
	    };
	
	    _this.handleChange = function (e) {
	      _this.setState(_defineProperty({}, e.target.name, e.target.value));
	
	      if (e.target.value == 'Other') {
	        _this.setState(_defineProperty({}, e.target.name + "_other_disabled", false));
	      }
	    };
	
	    _this.state = {
	      logged: localStorage.getItem("authentication"),
	      auth_data: JSON.parse(localStorage.getItem("user_data")),
	      category_data: [], collapse: 0, modalReply: false,
	      current_comment: '', current_rid: 0, current_eid: '',
	      PER_PAGE: 15,
	      total: 0,
	      loading: true,
	      list: [],
	      exportbtndisabled: false,
	      thisExportBtnText: 'Export',
	      blockinstopenmodal: false,
	      suggestions: [],
	      institute: '',
	      pickedones: [],
	      pickedinstIds: [],
	      salary_range_forthisjob: 15000,
	      userinfo: [],
	      experiences: [],
	      educations: [],
	      job_role_other_disabled: true,
	      job_subject_teaching_other_disabled: true,
	      expected_qualification_other_disabled: true,
	      examcertifications_other_disabled: true,
	      skillsrequired_other_disabled: true
	    };
	
	    _this.teacher_id = _this.props.match.params.id;
	
	    return _this;
	  }
	
	  _createClass(WcUserViewProfile, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	
	      var THIS = this;
	
	      this.getProfileData();
	
	      this.getExperiences();
	      this.getEducations();
	    }
	  }, {
	    key: 'getExperiences',
	    value: function getExperiences() {
	      var _this2 = this;
	
	      var req = JSON.stringify({
	        id: this.teacher_id
	      });
	
	      (0, _FetchCall.getExperiences)(req).then(function (response) {
	
	        if (response.status == 1) {
	
	          _this2.setState({ experiences: response.list });
	        } else {
	          _this2.setState({ experiences: [] });
	        }
	      });
	    }
	  }, {
	    key: 'getEducations',
	    value: function getEducations() {
	      var _this3 = this;
	
	      var req = JSON.stringify({
	        id: this.teacher_id
	      });
	
	      (0, _FetchCall.getEducations)(req).then(function (response) {
	
	        if (response.status == 1) {
	
	          _this3.setState({ educations: response.list });
	        } else {
	          _this3.setState({ educations: [] });
	        }
	      });
	    }
	  }, {
	    key: 'getProfileData',
	    value: function getProfileData() {
	      var _this4 = this;
	
	      var req = JSON.stringify({
	        teacher_id: this.teacher_id
	      });
	
	      (0, _FetchCall.getProfileDetail)(req).then(function (response) {
	
	        if (response.status == 1) {
	
	          _this4.setState({ userinfo: response.results[0] });
	        } else {
	          _this4.setState({ userinfo: [] });
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var _state = this.state,
	          userinfo = _state.userinfo,
	          experiences = _state.experiences,
	          educations = _state.educations;
	
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'col-12 grid-margin' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card-body' },
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'wc-column c80' },
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'option-section pdfcontainer job-card-parent', style: { backgroundImage: 'url(\'/images/watermark.png\')' }, ref: function ref(response) {
	                        return _this5.componentRef = response;
	                      } },
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'tophead wc-row' },
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'wc-column c40' },
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'equalflexrow' },
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'wiseconnet_logo' },
	                            _react2.default.createElement('img', { src: '/images/wiseconnect_980.jpg', width: "250px" })
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'middle_text' },
	                            'Teacher Profile'
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'bewise_logo' },
	                            _react2.default.createElement('img', { src: '/images/bewiseLogo.png' })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'borderedboxplain' },
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'boxtitle' },
	                            _react2.default.createElement('img', { src: '../../../../images/profile/about.png' }),
	                            'Personal Info'
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'viewprofile_rowflex' },
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'profilephoto' },
	                              _react2.default.createElement(
	                                'span',
	                                null,
	                                ' ',
	                                _react2.default.createElement('img', { 'class': 'job-card-child profileface', alt: '', src: IMG_URL + userinfo.profilephoto }),
	                                ' '
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'positionbox flexed' },
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'perinfo' },
	                                _react2.default.createElement(
	                                  'span',
	                                  { 'class': 'name' },
	                                  'Name: ',
	                                  _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    userinfo.name
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'span',
	                                  { 'class': 'name' },
	                                  'Email: ',
	                                  _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    userinfo.email_id
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'span',
	                                  { 'class': 'name' },
	                                  'Phonenumber: ',
	                                  _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    userinfo.phonenumber
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'span',
	                                  { 'class': 'name' },
	                                  'Location: ',
	                                  _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    userinfo.location == '' ? "N/A" : userinfo.location
	                                  )
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'carinfo' },
	                                _react2.default.createElement(
	                                  'span',
	                                  { 'class': 'role' },
	                                  'Role: ',
	                                  _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    userinfo.job_role
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'span',
	                                  { 'class': 'role' },
	                                  'Subjects: ',
	                                  _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    userinfo.job_subject_teaching
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'span',
	                                  { 'class': 'role' },
	                                  'Job Level: ',
	                                  _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    userinfo.job_levels
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'span',
	                                  { 'class': 'role' },
	                                  'Total Experience: ',
	                                  _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    userinfo.total_years_experiece,
	                                    ' year(s)'
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'span',
	                                  { 'class': 'role' },
	                                  'Salary Range: ',
	                                  _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    'Rs.',
	                                    userinfo.salary_range
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'span',
	                                  { 'class': 'role' },
	                                  'Area of Interests: ',
	                                  _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    userinfo.area_of_interests
	                                  )
	                                )
	                              )
	                            )
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'wc-column c60' },
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'borderedboxplain' },
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'boxtitle' },
	                            _react2.default.createElement('img', { src: '../../../../images/profile/about.png' }),
	                            'About Me'
	                          ),
	                          _react2.default.createElement('div', { 'class': 'boxdesc', dangerouslySetInnerHTML: { __html: userinfo.aboutme } })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'wc-column c60' },
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'borderedboxplain' },
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'boxtitle' },
	                            _react2.default.createElement('img', { src: '../../../../images/profile/about.png' }),
	                            'Experience'
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'boxdesc' },
	                            experiences.map(function (item, i) {
	
	                              return _react2.default.createElement(
	                                'div',
	                                { 'class': 'flexrowexp' },
	                                _react2.default.createElement(
	                                  'div',
	                                  null,
	                                  item.school
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  null,
	                                  item.start_date,
	                                  '-',
	                                  item.end_date
	                                )
	                              );
	                            })
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'wc-column c60' },
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'borderedboxplain' },
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'boxtitle' },
	                            _react2.default.createElement('img', { src: '../../../../images/profile/about.png' }),
	                            'Education'
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'boxdesc' },
	                            educations.map(function (item, i) {
	
	                              return _react2.default.createElement(
	                                'div',
	                                { 'class': 'flexrowexp' },
	                                _react2.default.createElement(
	                                  'div',
	                                  null,
	                                  item.school
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  null,
	                                  item.degree
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  null,
	                                  item.start_date,
	                                  '-',
	                                  item.end_date
	                                )
	                              );
	                            })
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'equalflexrowbtm' },
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'wiseconnet_url' },
	                          _react2.default.createElement(
	                            'span',
	                            null,
	                            'https://wiseconnect.bewise.in'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'middle_text_copyright' },
	                          'Copyrights @bewise'
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'bewise_url' },
	                          _react2.default.createElement(
	                            'span',
	                            null,
	                            'https://www.bewise.in'
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(_reactNotifications.NotificationContainer, null)
	        )
	      );
	    }
	  }]);
	
	  return WcUserViewProfile;
	}(_react.Component);
	
	exports.default = WcUserViewProfile;

/***/ },
/* 1064 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	__webpack_require__(18);
	
	var _reactNotifications = __webpack_require__(16);
	
	var _reactRangeslider = __webpack_require__(79);
	
	var _reactRangeslider2 = _interopRequireDefault(_reactRangeslider);
	
	__webpack_require__(66);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import { Editor } from '@tinymce/tinymce-react';
	
	var viewcourse = function (_Component) {
	    _inherits(viewcourse, _Component);
	
	    function viewcourse(props) {
	        _classCallCheck(this, viewcourse);
	
	        var _this = _possibleConstructorReturn(this, (viewcourse.__proto__ || Object.getPrototypeOf(viewcourse)).call(this, props));
	
	        _this.unapprovecourse = function (e) {
	
	            var req = JSON.stringify({
	                id: _this.id,
	                status: 0
	            });
	
	            (0, _FetchCall.approvecourse)(req).then(function (response) {
	
	                if (response.status == 1) {
	
	                    _reactNotifications.NotificationManager.success('Unapproved course successfully', 'Course Unapproval');
	
	                    setTimeout(function () {
	                        window.location.replace('/wiseconnect/courses');
	                    }, 1000);
	                } else {
	
	                    _reactNotifications.NotificationManager.error('Error ', 'Course Unapproval');
	                }
	            });
	        };
	
	        _this.rejectcourse = function (e) {
	
	            var req = JSON.stringify({
	                id: _this.id,
	                status: 2
	            });
	
	            (0, _FetchCall.approvecourse)(req).then(function (response) {
	
	                if (response.status == 1) {
	
	                    _reactNotifications.NotificationManager.success('Rejcted successfully', 'Course Approval');
	
	                    setTimeout(function () {
	                        window.location.replace('/wiseconnect/courses');
	                    }, 1000);
	                } else {
	
	                    _reactNotifications.NotificationManager.error('Error ', 'Course Approval');
	                }
	            });
	        };
	
	        _this.approvecourse = function (e) {
	
	            var req = JSON.stringify({
	                id: _this.id,
	                status: 1
	            });
	
	            (0, _FetchCall.approvecourse)(req).then(function (response) {
	
	                if (response.status == 1) {
	
	                    _reactNotifications.NotificationManager.success('Approved course successfully', 'Course Approval');
	
	                    setTimeout(function () {
	                        window.location.replace('/wiseconnect/courses');
	                    }, 1000);
	                } else {
	
	                    _reactNotifications.NotificationManager.error('Error ', 'Course Approval');
	                }
	            });
	        };
	
	        _this.state = {
	            logged: localStorage.getItem("authentication"),
	            auth_data: JSON.parse(localStorage.getItem("user_data")),
	            category_data: [], collapse: 0, modalReply: false,
	            current_comment: '', current_rid: 0, current_eid: '',
	            PER_PAGE: 15,
	            total: 0,
	            loading: true,
	            list: []
	        };
	        _this.id = _this.props.match.params.id;
	
	        return _this;
	    }
	
	    _createClass(viewcourse, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	
	            var THIS = this;
	
	            this.getCourse();
	        }
	    }, {
	        key: 'getCourse',
	        value: function getCourse() {
	            var _this2 = this;
	
	            var req = JSON.stringify({
	                id: this.id
	            });
	
	            (0, _FetchCall.getCourseById)(req).then(function (res) {
	                if (res.status == 1) {
	                    var data = res.detail;
	                    _this2.setState({
	                        course_name: data.course_name,
	                        course_description: data.course_description,
	                        course_duration_hrs: data.course_duration_hrs,
	                        course_duration_months: data.course_duration_months,
	                        course_duration_years: data.course_duration_years,
	                        course_duration_days: data.course_duration_days,
	                        course_eligibility: data.course_eligibility,
	                        course_category: data.course_category,
	                        course_certification: data.course_certificate_for,
	                        course_certification_other: data.course_certificate_for_others,
	                        course_fee: data.course_fee,
	                        course_fee_currency: data.course_fee_currency,
	                        course_fee_per: data.course_fee_per,
	                        course_moreinfo_phone: data.course_moreinfo_phone,
	                        course_moreinfo_email: data.course_moreinfo_email,
	                        course_apply_url: data.course_apply_url,
	                        course_banner: data.course_banner,
	                        course_brochure: data.course_brochure,
	                        course_status: data.course_status,
	                        course_type: data.course_type
	                    });
	                }
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _state = this.state,
	                value = _state.value,
	                suggestions = _state.suggestions,
	                pickedones = _state.pickedones;
	
	
	            return _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _react2.default.createElement(
	                    _layout2.default,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { 'class': 'col-12 grid-margin' },
	                        _react2.default.createElement(
	                            'div',
	                            { 'class': 'card' },
	                            _react2.default.createElement(
	                                'div',
	                                { 'class': 'card-body' },
	                                _react2.default.createElement(
	                                    'h4',
	                                    { 'class': 'card-title' },
	                                    'Course - View'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'courseinfo' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'rowinfo' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'infoitem' },
	                                            'Course Name: ',
	                                            _react2.default.createElement(
	                                                'span',
	                                                null,
	                                                this.state.course_name
	                                            ),
	                                            ' '
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'infoitem' },
	                                            'Course Desc: ',
	                                            _react2.default.createElement(
	                                                'span',
	                                                null,
	                                                this.state.course_description
	                                            ),
	                                            ' '
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'rowinfo' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'infoitem' },
	                                            'Course Type: ',
	                                            _react2.default.createElement(
	                                                'span',
	                                                null,
	                                                this.state.course_type
	                                            ),
	                                            ' '
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'infoitem' },
	                                            'Course Category: ',
	                                            _react2.default.createElement(
	                                                'span',
	                                                null,
	                                                this.state.course_category
	                                            ),
	                                            ' '
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'rowinfo' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'infoitem' },
	                                            'Course Fee: ',
	                                            _react2.default.createElement(
	                                                'span',
	                                                null,
	                                                this.state.course_fee_currency,
	                                                this.state.course_fee,
	                                                ' ',
	                                                this.state.course_fee_per
	                                            ),
	                                            ' '
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'infoitem' },
	                                            'Eligibility: ',
	                                            _react2.default.createElement(
	                                                'span',
	                                                null,
	                                                this.state.course_eligibility
	                                            ),
	                                            ' '
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'rowinfo' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'infoitem' },
	                                            'Certificate For: ',
	                                            _react2.default.createElement(
	                                                'span',
	                                                null,
	                                                this.state.course_certification
	                                            ),
	                                            ' '
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'infoitem' },
	                                            'Certificate For if Other: ',
	                                            _react2.default.createElement(
	                                                'span',
	                                                null,
	                                                this.state.course_certification_others
	                                            ),
	                                            ' '
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'rowinfo' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'infoitem' },
	                                            'Contact At: ',
	                                            _react2.default.createElement(
	                                                'span',
	                                                null,
	                                                'Ph: ',
	                                                this.state.course_moreinfo_phone,
	                                                ', Email: ',
	                                                this.state.course_moreinfo_email,
	                                                ' '
	                                            ),
	                                            ' '
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'infoitem' },
	                                            '\xA0'
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'rowinfo' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'infoitem' },
	                                            'Banner: ',
	                                            this.state.course_banner != '' ? _react2.default.createElement('img', { src: "http://localhost:5005/" + this.state.course_banner, 'class': 'coursebanner' }) : 'None'
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'infoitem' },
	                                            'Brochure: ',
	                                            _react2.default.createElement(
	                                                'a',
	                                                { href: "http://localhost:5005/" + this.state.course_brochure, target: '_blank' },
	                                                'click here'
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'rowinfo' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'infoitem' },
	                                            'Application URL: ',
	                                            _react2.default.createElement(
	                                                'span',
	                                                null,
	                                                this.state.course_apply_url
	                                            ),
	                                            ' '
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'infoitem' },
	                                            '\xA0'
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'rowinfo' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'infoitem' },
	                                            'Status: ',
	                                            _react2.default.createElement(
	                                                'span',
	                                                null,
	                                                this.state.course_status != 1 ? this.state.course_status == 2 ? "Rejected" : "Waiting for approval" : "Approved"
	                                            ),
	                                            ' '
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'infoitem' },
	                                            '\xA0'
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'rowinfo' },
	                                        this.state.course_status == 0 && _react2.default.createElement(
	                                            'div',
	                                            null,
	                                            _react2.default.createElement(
	                                                'button',
	                                                { name: 'approve', 'class': 'btn btn-primary btn-sm', onClick: this.approvecourse },
	                                                'Approve'
	                                            ),
	                                            '\xA0',
	                                            _react2.default.createElement(
	                                                'button',
	                                                { name: 'reject', 'class': 'btn btn-primary btn-sm', onClick: this.rejectcourse },
	                                                'Reject'
	                                            )
	                                        ),
	                                        this.state.course_status == 1 && _react2.default.createElement(
	                                            'button',
	                                            { name: 'approve', 'class': 'btn btn-primary btn-sm', onClick: this.unapprovecourse },
	                                            'Unapprove'
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(_reactNotifications.NotificationContainer, null)
	                )
	            );
	        }
	    }]);
	
	    return viewcourse;
	}(_react.Component);
	
	exports.default = viewcourse;

/***/ },
/* 1065 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _FetchCall = __webpack_require__(4);
	
	__webpack_require__(18);
	
	var _reactNotifications = __webpack_require__(16);
	
	var _reactstrap = __webpack_require__(17);
	
	var _reactRangeslider = __webpack_require__(79);
	
	var _reactRangeslider2 = _interopRequireDefault(_reactRangeslider);
	
	__webpack_require__(66);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import { Editor } from '@tinymce/tinymce-react';
	
	//import { Importer, ImporterField } from "react-csv-importer";
	
	// theme CSS for React CSV Importer
	//import "react-csv-importer/dist/index.css";
	
	var viewjob = function (_Component) {
	  _inherits(viewjob, _Component);
	
	  function viewjob(props) {
	    _classCallCheck(this, viewjob);
	
	    var _this = _possibleConstructorReturn(this, (viewjob.__proto__ || Object.getPrototypeOf(viewjob)).call(this, props));
	
	    _this.handleChangeHorizontal = function (value) {
	      _this.setState({
	        salary_range_forthisjob: value
	      });
	    };
	
	    _this.handleChange = function (e) {
	      _this.setState(_defineProperty({}, e.target.name, e.target.value));
	
	      if (e.target.value == 'Other') {
	        _this.setState(_defineProperty({}, e.target.name + "_other_disabled", false));
	      }
	    };
	
	    _this.handleSubmit = function (e) {
	
	      var auth_data = JSON.parse(localStorage.getItem("user_data"));
	
	      var req = JSON.stringify({
	        job_id: _this.job_id,
	        user_id: auth_data.user_id,
	        job_title: _this.state.job_title,
	        job_category: _this.state.job_category,
	        job_description: _this.state.job_description,
	        job_gender: _this.state.job_gender,
	        organisation: auth_data.organisation,
	        organisation_place: auth_data.organisation_place,
	        open_date: _this.state.open_date,
	        closing_date: _this.state.closing_date,
	        job_location: _this.state.job_location,
	        salary_range_forthisjob: _this.state.salary_range_forthisjob,
	        language_preferred: _this.state.language_preferred,
	        expected_qualification: _this.state.expected_qualification,
	        skillsrequired: _this.state.skillsrequired,
	        job_role: _this.state.job_role,
	        job_subject_teaching: _this.state.job_subject_teaching,
	        job_experience: _this.state.job_experience,
	        examcertifications: _this.state.examcertifications,
	        expected_qualification_other: _this.state.expected_qualification_other,
	        skillsrequired_other: _this.state.skillsrequired_other,
	        job_role_other: _this.state.job_role_other,
	        job_subject_teaching_other: _this.state.job_subject_teaching_other,
	        examcertifications_other: _this.state.examcertifications_other
	
	      });
	
	      (0, _FetchCall.updatejob)(req).then(function (response) {
	
	        if (response.status == 1) {
	
	          _reactNotifications.NotificationManager.success('Updated job successfully', 'Edit job');
	        } else {
	
	          _reactNotifications.NotificationManager.error('Error updating a job', 'Edit job');
	        }
	      });
	    };
	
	    _this.state = {
	      logged: localStorage.getItem("authentication"),
	      auth_data: JSON.parse(localStorage.getItem("user_data")),
	      category_data: [], collapse: 0, modalReply: false,
	      current_comment: '', current_rid: 0, current_eid: '',
	      PER_PAGE: 15,
	      total: 0,
	      loading: true,
	      list: [],
	      exportbtndisabled: false,
	      thisExportBtnText: 'Export',
	      blockinstopenmodal: false,
	      suggestions: [],
	      institute: '',
	      pickedones: [],
	      pickedinstIds: [],
	      salary_range_forthisjob: 15000,
	      organisation_place: '',
	      organisation: '',
	      job_role_other_disabled: true,
	      job_subject_teaching_other_disabled: true,
	      expected_qualification_other_disabled: true,
	      examcertifications_other_disabled: true,
	      skillsrequired_other_disabled: true,
	      importopen: false,
	      job: []
	    };
	
	    _this.job_id = _this.props.match.params.jobid;
	
	    _this.cancelPop = _this.cancelPop.bind(_this);
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.importopen = _this.importopen.bind(_this);
	
	    return _this;
	  }
	
	  _createClass(viewjob, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	
	      var THIS = this;
	
	      this.getJobDetail();
	    }
	  }, {
	    key: 'getJobDetail',
	    value: function getJobDetail() {
	      var _this2 = this;
	
	      var req = JSON.stringify({
	        job_id: this.job_id
	      });
	
	      (0, _FetchCall.getJobDetail)(req).then(function (response) {
	
	        if (response.status == 1) {
	          _this2.setState({ job: response.detail });
	        } else {
	          _this2.setState({ job: [] });
	        }
	      });
	    }
	  }, {
	    key: 'importopen',
	    value: function importopen() {
	      this.setState({ importopen: true });
	    }
	  }, {
	    key: 'cancelPop',
	    value: function cancelPop() {
	      this.setState({ blockinstopenmodal: false });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var job = this.state.job;
	      var salary_range_forthisjob = this.state.salary_range_forthisjob;
	
	      var horizontalLabels = {
	        12000: '12k',
	        400000: '4L'
	      };
	
	      var formatkg = function formatkg(value) {
	        return value;
	      };
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'col-12 grid-margin' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card-body' },
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'boxtitle' },
	                  _react2.default.createElement('img', { src: '../../../images/profile/about.png' }),
	                  'Edit job'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'importbox' },
	                  _react2.default.createElement(
	                    'button',
	                    { 'class': 'btn btn-primary', onClick: this.importopen },
	                    'Import bulk'
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'postajobform wc' },
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup end_date_option', id: 'end_date_option' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Job title '
	                    ),
	                    _react2.default.createElement('input', { type: 'text', 'class': 'form-control forminputcls', id: 'job_title', name: 'job_title', value: job.job_title, onChange: this.handleChange })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Job Description '
	                    ),
	                    _react2.default.createElement('textarea', { 'class': 'form-control forminputcls', name: 'job_description', id: 'job_description', value: job.job_description, placeholder: 'Description', rows: '10', onChange: this.handleChange })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup end_date_option', id: 'end_date_option' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Job role'
	                    ),
	                    _react2.default.createElement(
	                      'select',
	                      { name: 'job_role', 'class': 'formselectinputcls', value: job.job_role, onChange: this.handleChange },
	                      _react2.default.createElement(
	                        'option',
	                        { value: '' },
	                        'Select Role'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Pre Primary Teacher' },
	                        'Pre Primary Teacher'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Primary Teacher' },
	                        'Primary Teacher'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Secondary Teacher' },
	                        'Secondary Teacher'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Senior Secondary Teacher' },
	                        'Senior Secondary Teacher'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Special Educator' },
	                        'Special Educator'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Libraian' },
	                        'Libraian'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Physial Education Teacher' },
	                        'Physial Education Teacher'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Counsellor' },
	                        'Counsellor'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Administrator' },
	                        'Administrator'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Accountant' },
	                        'Accountant'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Marketing' },
	                        'Marketing'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Music / Dance Teacher' },
	                        'Music / Dance Teacher'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Other' },
	                        'Other'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup end_date_option', id: 'end_date_option' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Job Role - If Other '
	                    ),
	                    _react2.default.createElement('input', { type: 'text', 'class': 'form-control forminputcls', id: 'job_role_other', value: job.job_role_other, disabled: this.state.job_role_other_disabled, name: 'job_role_other', onChange: this.handleChange })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup end_date_option', id: 'end_date_option' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Gender'
	                    ),
	                    _react2.default.createElement(
	                      'select',
	                      { name: 'job_gender', 'class': 'formselectinputcls', value: job.job_gender, onChange: this.handleChange },
	                      _react2.default.createElement(
	                        'option',
	                        { value: '' },
	                        'Select Gender'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Male' },
	                        'Male'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Female' },
	                        'Female'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Other' },
	                        'Other'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Not a constraint' },
	                        'Not a constraint'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup end_date_option', id: 'end_date_option' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Role Type'
	                    ),
	                    _react2.default.createElement(
	                      'select',
	                      { name: 'job_category', value: job.job_category, 'class': 'formselectinputcls', onChange: this.handleChange },
	                      _react2.default.createElement(
	                        'option',
	                        { value: '' },
	                        'Select Role Type'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Full Time' },
	                        'Full Time'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Part Time' },
	                        'Part Time'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Contractual' },
	                        'Contractual'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Temporary' },
	                        'Temporary'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Internship' },
	                        'Internship'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup end_date_option', id: 'end_date_option' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Subject Of Teaching'
	                    ),
	                    _react2.default.createElement(
	                      'select',
	                      { name: 'job_subject_teaching', value: job.job_subject_teaching, 'class': 'formselectinputcls', onChange: this.handleChange },
	                      _react2.default.createElement(
	                        'option',
	                        { value: '' },
	                        'Select Subject'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Biology' },
	                        'Biology'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Science' },
	                        'Science'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Maths' },
	                        'Maths'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Physics' },
	                        'Physics'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Chemistry' },
	                        'Chemistry'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Art' },
	                        'Art'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'History' },
	                        'History'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Economics' },
	                        'Economics'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Computer Science' },
	                        'Computer Science'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Phyisical Education' },
	                        'Phyisical Education'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Librarian' },
	                        'Librarian'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Humanities' },
	                        'Humanities'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Geography' },
	                        'Geography'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Civics' },
	                        'Civics'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'English' },
	                        'English'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Hindi' },
	                        'Hindi'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Tamil' },
	                        'Tamil'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Kannada' },
	                        'Kannada'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Telugu' },
	                        'Telugu'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Marathi' },
	                        'Marathi'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'French' },
	                        'French'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Spanish' },
	                        'Spanish'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'German' },
	                        'German'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Reglion and Religious Studies' },
	                        'Reglion and Religious Studies'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Visual Arts' },
	                        'Visual Arts'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Robotics & Coding' },
	                        'Robotics & Coding'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Other' },
	                        'Other'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup end_date_option', id: 'end_date_option' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Subject Of Teaching - If Other '
	                    ),
	                    _react2.default.createElement('input', { type: 'text', 'class': 'form-control forminputcls', id: 'job_subject_teaching_other', value: job.job_subject_teaching_other, disabled: this.state.job_subject_teaching_other_disabled, name: 'job_subject_teaching_other', onChange: this.handleChange })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup end_date_option', id: 'end_date_option' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Experience Required '
	                    ),
	                    _react2.default.createElement(
	                      'select',
	                      { name: 'job_experience', 'class': 'formselectinputcls', value: job.job_experience, onChange: this.handleChange },
	                      _react2.default.createElement(
	                        'option',
	                        { value: '' },
	                        '---Select---'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Freshers' },
	                        'Freshers'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: '0-3 Years' },
	                        '0-3 Years'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: '4-5 years' },
	                        '4-5 years'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: '5-10 years' },
	                        '5-10 years'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: '10-15 years' },
	                        '10-15 years'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: '15+ years' },
	                        '15+ years'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup end_date_option', id: 'end_date_option' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Anticipated joining '
	                    ),
	                    _react2.default.createElement(
	                      'select',
	                      { name: 'joining', 'class': 'formselectinputcls', value: job.joining, onChange: this.handleChange },
	                      _react2.default.createElement(
	                        'option',
	                        { value: '' },
	                        '---Select---'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Immediate' },
	                        'Immediate'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: '15 Days' },
	                        '15 Days'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: '1 month' },
	                        '1 month'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: '2 months' },
	                        '2 months'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: '3 months' },
	                        '3 months'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Job Opening Date '
	                    ),
	                    _react2.default.createElement('input', { type: 'date', 'class': 'form-control forminputcls', id: 'open_date', value: job.open_date, name: 'open_date', onChange: this.handleChange })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Job Closing Date '
	                    ),
	                    _react2.default.createElement('input', { type: 'date', 'class': 'form-control forminputcls', id: 'closing_date', value: job.closing_date, name: 'closing_date', onChange: this.handleChange })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup end_date_option', id: 'end_date_option' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Job Location '
	                    ),
	                    _react2.default.createElement(
	                      'select',
	                      { name: 'job_location', 'class': 'formselectinputcls', value: job.job_location, onChange: this.handleChange },
	                      _react2.default.createElement(
	                        'option',
	                        { value: '' },
	                        'Select'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'In Campus' },
	                        'In Campus'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Hybrid' },
	                        'Hybrid'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Remote' },
	                        'Remote'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup end_date_option', id: 'end_date_option' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Salary Range for this Job'
	                    ),
	                    _react2.default.createElement(_reactRangeslider2.default, {
	                      min: 10000,
	                      max: 400000,
	                      value: salary_range_forthisjob,
	                      labels: horizontalLabels,
	                      format: formatkg,
	                      step: 1000,
	                      handleLabel: salary_range_forthisjob,
	                      onChange: this.handleChangeHorizontal
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { id: 'salaryText' },
	                    '\u20B9 ',
	                    formatkg(salary_range_forthisjob)
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup end_date_option', id: 'end_date_option' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Languages preferred '
	                    ),
	                    _react2.default.createElement(
	                      'select',
	                      { name: 'language_preferred', multiple: true, multiselect: true, 'class': 'formselectinputcls', onChange: this.handleChange },
	                      _react2.default.createElement(
	                        'option',
	                        { value: '' },
	                        'Select Language'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'English' },
	                        'English'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Hindi' },
	                        'Hindi'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Tamil' },
	                        'Tamil'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Kannada' },
	                        'Kannada'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Telugu' },
	                        'Telugu'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Urdhu' },
	                        'Urdhu'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Malayalam' },
	                        'Malayalam'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Expected Qualification '
	                    ),
	                    _react2.default.createElement(
	                      'select',
	                      { name: 'expected_qualification', multiple: true, 'class': 'formselectinputcls', onChange: this.handleChange },
	                      _react2.default.createElement(
	                        'option',
	                        { value: '' },
	                        'Select Qualification'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Graduate in Education (BA / B.SC etc.)' },
	                        'Graduate in Education (BA / B.SC etc.)'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Post Graduate (MA /M.Sc etc)' },
	                        'Post Graduate (MA /M.Sc etc)'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Engeneering Graduate' },
	                        'Engeneering Graduate'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Diploma In Education' },
	                        'Diploma In Education'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Bachelors Degree in Education (B.Ed)' },
	                        'Bachelors Degree in Education (B.Ed)'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Masters Degree in Education (M.Ed)' },
	                        'Masters Degree in Education (M.Ed)'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Doctorate (Phd)' },
	                        'Doctorate (Phd)'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Bachelor of Elementray Education (B.EL.Ed)' },
	                        'Bachelor of Elementray Education (B.EL.Ed)'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Bachelor of Arts & Education (BA. B.Ed)' },
	                        'Bachelor of Arts & Education (BA. B.Ed)'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Diploma in Elementary Education (D.EL.Ed)' },
	                        'Diploma in Elementary Education (D.EL.Ed)'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Bachelor of Physical Education (B.P.Ed)' },
	                        'Bachelor of Physical Education (B.P.Ed)'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Master of Philosophy in Education (M.Phil)' },
	                        'Master of Philosophy in Education (M.Phil)'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Bachelor of Library Science (B.Lib)' },
	                        'Bachelor of Library Science (B.Lib)'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Bachelor of Library & Information Sciences (B.Lib.I.Sc)' },
	                        'Bachelor of Library & Information Sciences (B.Lib.I.Sc)'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Masters in Library & Information Sciences (M.Lib.I.Sc)' },
	                        'Masters in Library & Information Sciences (M.Lib.I.Sc)'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Bachelor of Fine Arts (BFA)' },
	                        'Bachelor of Fine Arts (BFA)'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Diploma Program in Special Education (DESCE-MR / DSE / MRW / DHLS etc)' },
	                        'Diploma Program in Special Education (DESCE-MR / DSE / MRW / DHLS etc)'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Post Graduate Diploma in Special Education' },
	                        'Post Graduate Diploma in Special Education'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Graduate in Special Education  (B.Ed - Spl Education)' },
	                        'Graduate in Special Education  (B.Ed - Spl Education)'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Other' },
	                        'Other'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup end_date_option', id: 'end_date_option' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Expected Qualification - If Other '
	                    ),
	                    _react2.default.createElement('input', { type: 'text', 'class': 'form-control forminputcls', id: 'expected_qualification_other', name: 'expected_qualification_other', disabled: this.state.expected_qualification_other_disabled, onChange: this.handleChange })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Entrance Examination & Certifications Required  '
	                    ),
	                    _react2.default.createElement(
	                      'select',
	                      { name: 'examcertifications', multiple: true, 'class': 'formselectinputcls', onChange: this.handleChange },
	                      _react2.default.createElement(
	                        'option',
	                        { value: '' },
	                        'Select'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'None' },
	                        'None'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Central Teachers Eligibliity Test (CTET)' },
	                        'Central Teachers Eligibliity Test (CTET)'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'National Eligibility Test (NET / UGC-NET)' },
	                        'National Eligibility Test (NET / UGC-NET)'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Basic Training Certificates' },
	                        'Basic Training Certificates'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Primary Teachers Certificates' },
	                        'Primary Teachers Certificates'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Teachers Training Certificates' },
	                        'Teachers Training Certificates"'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Teacher Eligiblity Test (TET)' },
	                        'Teacher Eligiblity Test (TET)'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'State Teachers Eligiblity Test (STET)' },
	                        'State Teachers Eligiblity Test (STET)'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Certificate course in Library Sciences' },
	                        'Certificate course in Library Sciences'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Certificate course in Drawing teacher training' },
	                        'Certificate course in Drawing teacher training'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Certificate in Care giving program' },
	                        'Certificate in Care giving program'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Certificate program in Special Education' },
	                        'Certificate program in Special Education'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Certicate Courses in Dance' },
	                        'Certicate Courses in Dance'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Certicate Courses in Arts' },
	                        'Certicate Courses in Arts'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Certificate Courses in Sports' },
	                        'Certificate Courses in Sports'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Certificate Courses in Music & Dance' },
	                        'Certificate Courses in Music & Dance'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Other' },
	                        'Other'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup end_date_option', id: 'end_date_option' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Examination and Certifications - If Other '
	                    ),
	                    _react2.default.createElement('input', { type: 'text', 'class': 'form-control forminputcls', id: 'examcertifications_other', name: 'examcertifications_other', disabled: this.state.examcertifications_other_disabled, onChange: this.handleChange })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Skills required '
	                    ),
	                    _react2.default.createElement(
	                      'select',
	                      { name: 'skillsrequired', multiple: true, 'class': 'formselectinputcls', onChange: this.handleChange },
	                      _react2.default.createElement(
	                        'option',
	                        { value: '' },
	                        'Select'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Expertise in specific subjects of teaching' },
	                        'Expertise in specific subjects of teaching'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Written and verbal communication' },
	                        'Written and verbal communication'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Ability to adapt to different situations' },
	                        'Ability to adapt to different situations'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Knowledge of teaching software and tools' },
	                        'Knowledge of teaching software and tools'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Ability to teach students experiencing challenge with learning' },
	                        'Ability to teach students experiencing challenge with learning'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Time management skills' },
	                        'Time management skills'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Innovative training strategies' },
	                        'Innovative training strategies'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Flexibility to modify training principles' },
	                        'Flexibility to modify training principles'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Classroom management' },
	                        'Classroom management'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Leadership' },
	                        'Leadership'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Conflict management' },
	                        'Conflict management'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Collaborative & Interpersonal skills' },
	                        'Collaborative & Interpersonal skills'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Creative' },
	                        'Creative'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Financial Management' },
	                        'Financial Management'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Human Resource Management' },
	                        'Human Resource Management'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Curriculam Development' },
	                        'Curriculam Development'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'School Policy Knowledge' },
	                        'School Policy Knowledge'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Understanding & Implementation of NEP requirements' },
	                        'Understanding & Implementation of NEP requirements'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'Other' },
	                        'Other'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup end_date_option', id: 'end_date_option' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Skills required - If Other '
	                    ),
	                    _react2.default.createElement('input', { type: 'text', 'class': 'form-control forminputcls', id: 'skillsrequired_other', name: 'skillsrequired_other', disabled: this.state.skillsrequired_other_disabled, onChange: this.handleChange })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup end_date_option', id: 'admin_approval_option' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Admin Approvals '
	                    ),
	                    job.job_approval == 0 && _react2.default.createElement(
	                      'div',
	                      null,
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'orangetext' },
	                        'Pending'
	                      )
	                    ),
	                    job.job_approval == 2 && _react2.default.createElement(
	                      'div',
	                      null,
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'redtext' },
	                        'On Hold'
	                      ),
	                      ' ',
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'notesbyadmin' },
	                        _react2.default.createElement(
	                          'b',
	                          null,
	                          'Admin Notes:'
	                        ),
	                        _react2.default.createElement(
	                          'span',
	                          null,
	                          'testestes test test'
	                        )
	                      )
	                    ),
	                    job.job_approval == 1 && _react2.default.createElement(
	                      'div',
	                      null,
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'greentext' },
	                        'Approved'
	                      )
	                    )
	                  ),
	                  job.job_status == 1 && _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup' },
	                    _react2.default.createElement(
	                      'label',
	                      { 'for': 'exampleInputPassword1' },
	                      'Job Status '
	                    ),
	                    _react2.default.createElement(
	                      'select',
	                      { name: 'job_status', 'class': 'formselectinputcls', value: this.state.job_status, onChange: this.handleChange },
	                      _react2.default.createElement(
	                        'option',
	                        { value: '' },
	                        'Select status'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: '1' },
	                        'Open'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: '2' },
	                        'Closed'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: '3' },
	                        'On-Hold'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'formgroup text-center paddingtop20' },
	                    job.submitted == 1 && _react2.default.createElement(
	                      'button',
	                      { type: 'button', name: 'postajob', 'class': 'btn-main', onClick: this.handleSubmit },
	                      'Update'
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.Modal,
	            { size: 'lg', style: { maxWidth: '700px', width: '100%' }, isOpen: this.state.importopen, className: 'modalpopup' },
	            _react2.default.createElement(
	              _reactstrap.ModalHeader,
	              null,
	              'Import jobs'
	            ),
	            _react2.default.createElement(_reactstrap.ModalBody, null)
	          ),
	          _react2.default.createElement(_reactNotifications.NotificationContainer, null)
	        )
	      );
	    }
	  }]);
	
	  return viewjob;
	}(_react.Component);
	
	exports.default = viewjob;

/***/ },
/* 1066 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _layout = __webpack_require__(8);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _reactRouterDom = __webpack_require__(296);
	
	var _FetchCall = __webpack_require__(4);
	
	__webpack_require__(18);
	
	var _reactNotifications = __webpack_require__(16);
	
	__webpack_require__(66);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import { Editor } from '@tinymce/tinymce-react';
	
	//import ReactToPrint from 'react-to-print';
	
	var IMG_URL = "https://api.bewise.in/"; //"https://api.bewise.in/";
	
	var WctalentViewProfile = function (_Component) {
	  _inherits(WctalentViewProfile, _Component);
	
	  function WctalentViewProfile(props) {
	    _classCallCheck(this, WctalentViewProfile);
	
	    var _this = _possibleConstructorReturn(this, (WctalentViewProfile.__proto__ || Object.getPrototypeOf(WctalentViewProfile)).call(this, props));
	
	    _this.handleChangeHorizontal = function (value) {
	      _this.setState({
	        salary_range_forthisjob: value
	      });
	    };
	
	    _this.handleChange = function (e) {
	      _this.setState(_defineProperty({}, e.target.name, e.target.value));
	
	      if (e.target.value == 'Other') {
	        _this.setState(_defineProperty({}, e.target.name + "_other_disabled", false));
	      }
	    };
	
	    _this.state = {
	      logged: localStorage.getItem("authentication"),
	      auth_data: JSON.parse(localStorage.getItem("user_data")),
	      category_data: [], collapse: 0, modalReply: false,
	      current_comment: '', current_rid: 0, current_eid: '',
	      PER_PAGE: 15,
	      total: 0,
	      loading: true,
	      list: [],
	      exportbtndisabled: false,
	      thisExportBtnText: 'Export',
	      blockinstopenmodal: false,
	      suggestions: [],
	      institute: '',
	      pickedones: [],
	      pickedinstIds: [],
	      salary_range_forthisjob: 15000,
	      userinfo: [],
	      experiences: [],
	      educations: [],
	      job_role_other_disabled: true,
	      job_subject_teaching_other_disabled: true,
	      expected_qualification_other_disabled: true,
	      examcertifications_other_disabled: true,
	      skillsrequired_other_disabled: true
	    };
	
	    _this.teacher_id = _this.props.match.params.id;
	    _this.jobid = _this.props.match.params.jobid;
	
	    return _this;
	  }
	
	  _createClass(WctalentViewProfile, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	
	      var THIS = this;
	
	      this.getProfileData();
	
	      this.getExperiences();
	      this.getEducations();
	    }
	  }, {
	    key: 'getExperiences',
	    value: function getExperiences() {
	      var _this2 = this;
	
	      var req = JSON.stringify({
	        id: this.teacher_id
	      });
	
	      (0, _FetchCall.getExperiences)(req).then(function (response) {
	
	        if (response.status == 1) {
	
	          _this2.setState({ experiences: response.list });
	        } else {
	          _this2.setState({ experiences: [] });
	        }
	      });
	    }
	  }, {
	    key: 'getEducations',
	    value: function getEducations() {
	      var _this3 = this;
	
	      var req = JSON.stringify({
	        id: this.teacher_id
	      });
	
	      (0, _FetchCall.getEducations)(req).then(function (response) {
	
	        if (response.status == 1) {
	
	          _this3.setState({ educations: response.list });
	        } else {
	          _this3.setState({ educations: [] });
	        }
	      });
	    }
	  }, {
	    key: 'getProfileData',
	    value: function getProfileData() {
	      var _this4 = this;
	
	      var req = JSON.stringify({
	        teacher_id: this.teacher_id
	      });
	
	      (0, _FetchCall.getProfileDetail)(req).then(function (response) {
	
	        if (response.status == 1) {
	
	          _this4.setState({ userinfo: response.results[0] });
	        } else {
	          _this4.setState({ userinfo: [] });
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var _state = this.state,
	          userinfo = _state.userinfo,
	          experiences = _state.experiences,
	          educations = _state.educations;
	
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _layout2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { 'class': 'col-12 grid-margin' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'card' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'card-body' },
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'wc-column c80' },
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'option-section pdfcontainer job-card-parent', style: { backgroundImage: 'url(\'/images/watermark.png\')' }, ref: function ref(response) {
	                        return _this5.componentRef = response;
	                      } },
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'tophead wc-row' },
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'wc-column c40' },
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'equalflexrow' },
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'wiseconnet_logo' },
	                            _react2.default.createElement('img', { src: '/images/wiseconnect_980.jpg', width: "250px" })
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'middle_text' },
	                            'Teacher Profile'
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'bewise_logo' },
	                            _react2.default.createElement('img', { src: '/images/bewiseLogo.png' })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'borderedboxplain' },
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'boxtitle' },
	                            _react2.default.createElement('img', { src: '../../../../images/profile/about.png' }),
	                            'Personal Info'
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'viewprofile_rowflex' },
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'profilephoto' },
	                              _react2.default.createElement(
	                                'span',
	                                null,
	                                ' ',
	                                _react2.default.createElement('img', { 'class': 'job-card-child profileface', alt: '', src: IMG_URL + userinfo.profilephoto }),
	                                ' '
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { 'class': 'positionbox flexed' },
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'perinfo' },
	                                _react2.default.createElement(
	                                  'span',
	                                  { 'class': 'name' },
	                                  'Name: ',
	                                  _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    userinfo.name
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'span',
	                                  { 'class': 'name' },
	                                  'Email: ',
	                                  _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    userinfo.email_id
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'span',
	                                  { 'class': 'name' },
	                                  'Phonenumber: ',
	                                  _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    userinfo.phonenumber
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'span',
	                                  { 'class': 'name' },
	                                  'Location: ',
	                                  _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    userinfo.location == '' ? "N/A" : userinfo.location
	                                  )
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { 'class': 'carinfo' },
	                                _react2.default.createElement(
	                                  'span',
	                                  { 'class': 'role' },
	                                  'Role: ',
	                                  _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    userinfo.job_role
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'span',
	                                  { 'class': 'role' },
	                                  'Subjects: ',
	                                  _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    userinfo.job_subject_teaching
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'span',
	                                  { 'class': 'role' },
	                                  'Job Level: ',
	                                  _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    userinfo.job_levels
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'span',
	                                  { 'class': 'role' },
	                                  'Total Experience: ',
	                                  _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    userinfo.total_years_experiece,
	                                    ' year(s)'
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'span',
	                                  { 'class': 'role' },
	                                  'Salary Range: ',
	                                  _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    'Rs.',
	                                    userinfo.salary_range
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'span',
	                                  { 'class': 'role' },
	                                  'Area of Interests: ',
	                                  _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    userinfo.area_of_interests
	                                  )
	                                )
	                              )
	                            )
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'wc-column c60' },
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'borderedboxplain' },
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'boxtitle' },
	                            _react2.default.createElement('img', { src: '../../../../images/profile/about.png' }),
	                            'About Me'
	                          ),
	                          _react2.default.createElement('div', { 'class': 'boxdesc', dangerouslySetInnerHTML: { __html: userinfo.aboutme } })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'wc-column c60' },
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'borderedboxplain' },
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'boxtitle' },
	                            _react2.default.createElement('img', { src: '../../../../images/profile/about.png' }),
	                            'Experience'
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'boxdesc' },
	                            experiences.map(function (item, i) {
	
	                              return _react2.default.createElement(
	                                'div',
	                                { 'class': 'flexrowexp' },
	                                _react2.default.createElement(
	                                  'div',
	                                  null,
	                                  item.school
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  null,
	                                  item.start_date,
	                                  '-',
	                                  item.end_date
	                                )
	                              );
	                            })
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'wc-column c60' },
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'borderedboxplain' },
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'boxtitle' },
	                            _react2.default.createElement('img', { src: '../../../../images/profile/about.png' }),
	                            'Education'
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { 'class': 'boxdesc' },
	                            educations.map(function (item, i) {
	
	                              return _react2.default.createElement(
	                                'div',
	                                { 'class': 'flexrowexp' },
	                                _react2.default.createElement(
	                                  'div',
	                                  null,
	                                  item.school
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  null,
	                                  item.degree
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  null,
	                                  item.start_date,
	                                  '-',
	                                  item.end_date
	                                )
	                              );
	                            })
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'equalflexrowbtm' },
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'wiseconnet_url' },
	                          _react2.default.createElement(
	                            'span',
	                            null,
	                            'https://wiseconnect.bewise.in'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'middle_text_copyright' },
	                          'Copyrights @bewise'
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { 'class': 'bewise_url' },
	                          _react2.default.createElement(
	                            'span',
	                            null,
	                            'https://www.bewise.in'
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(_reactNotifications.NotificationContainer, null)
	        )
	      );
	    }
	  }]);
	
	  return WctalentViewProfile;
	}(_react.Component);
	
	exports.default = WctalentViewProfile;

/***/ },
/* 1067 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(43);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _App = __webpack_require__(865);
	
	var _App2 = _interopRequireDefault(_App);
	
	__webpack_require__(1268);
	
	__webpack_require__(1271);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_reactDom2.default.render(_react2.default.createElement(_App2.default, null), document.getElementById('root'));

/***/ },
/* 1068 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {// This method of obtaining a reference to the global object needs to be
	// kept identical to the way it is obtained in runtime.js
	var g =
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this;
	
	// Use `getOwnPropertyNames` because not all browsers support calling
	// `hasOwnProperty` on the global `self` object in a worker. See #183.
	var hadRuntime = g.regeneratorRuntime &&
	  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;
	
	// Save the old regeneratorRuntime in case it needs to be restored later.
	var oldRuntime = hadRuntime && g.regeneratorRuntime;
	
	// Force reevalutation of runtime.js.
	g.regeneratorRuntime = undefined;
	
	module.exports = __webpack_require__(1069);
	
	if (hadRuntime) {
	  // Restore the original runtime.
	  g.regeneratorRuntime = oldRuntime;
	} else {
	  // Remove the global property added by runtime.js.
	  try {
	    delete g.regeneratorRuntime;
	  } catch(e) {
	    g.regeneratorRuntime = undefined;
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1069 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if (typeof global.process === "object" && global.process.domain) {
	      invoke = global.process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1070 */
/***/ function(module, exports) {

	'use strict'
	
	exports.byteLength = byteLength
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray
	
	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array
	
	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i]
	  revLookup[code.charCodeAt(i)] = i
	}
	
	// Support decoding URL-safe base64 strings, as Node.js does.
	// See: https://en.wikipedia.org/wiki/Base64#URL_applications
	revLookup['-'.charCodeAt(0)] = 62
	revLookup['_'.charCodeAt(0)] = 63
	
	function getLens (b64) {
	  var len = b64.length
	
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }
	
	  // Trim off extra bytes after placeholder bytes are found
	  // See: https://github.com/beatgammit/base64-js/issues/42
	  var validLen = b64.indexOf('=')
	  if (validLen === -1) validLen = len
	
	  var placeHoldersLen = validLen === len
	    ? 0
	    : 4 - (validLen % 4)
	
	  return [validLen, placeHoldersLen]
	}
	
	// base64 is 4/3 + up to two characters of the original data
	function byteLength (b64) {
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function _byteLength (b64, validLen, placeHoldersLen) {
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function toByteArray (b64) {
	  var tmp
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	
	  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))
	
	  var curByte = 0
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  var len = placeHoldersLen > 0
	    ? validLen - 4
	    : validLen
	
	  var i
	  for (i = 0; i < len; i += 4) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 18) |
	      (revLookup[b64.charCodeAt(i + 1)] << 12) |
	      (revLookup[b64.charCodeAt(i + 2)] << 6) |
	      revLookup[b64.charCodeAt(i + 3)]
	    arr[curByte++] = (tmp >> 16) & 0xFF
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 2) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 2) |
	      (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 1) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 10) |
	      (revLookup[b64.charCodeAt(i + 1)] << 4) |
	      (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  return arr
	}
	
	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] +
	    lookup[num >> 12 & 0x3F] +
	    lookup[num >> 6 & 0x3F] +
	    lookup[num & 0x3F]
	}
	
	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp =
	      ((uint8[i] << 16) & 0xFF0000) +
	      ((uint8[i + 1] << 8) & 0xFF00) +
	      (uint8[i + 2] & 0xFF)
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}
	
	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 2] +
	      lookup[(tmp << 4) & 0x3F] +
	      '=='
	    )
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 10] +
	      lookup[(tmp >> 4) & 0x3F] +
	      lookup[(tmp << 2) & 0x3F] +
	      '='
	    )
	  }
	
	  return parts.join('')
	}


/***/ },
/* 1071 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ },
/* 1072 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(156);
	var $apply = __webpack_require__(249);
	var actualApply = __webpack_require__(370);
	
	/** @type {import('./applyBind')} */
	module.exports = function applyBind() {
		return actualApply(bind, $apply, arguments);
	};


/***/ },
/* 1073 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./reflectApply')} */
	module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;


/***/ },
/* 1074 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var GetIntrinsic = __webpack_require__(272);
	
	var callBind = __webpack_require__(252);
	
	var $indexOf = callBind(GetIntrinsic('String.prototype.indexOf'));
	
	module.exports = function callBoundIntrinsic(name, allowMissing) {
		var intrinsic = GetIntrinsic(name, !!allowMissing);
		if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
			return callBind(intrinsic);
		}
		return intrinsic;
	};


/***/ },
/* 1075 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(58);
	
	// -- Inlined from fbjs --
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function _invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	var warning = function(){};
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	// /-- Inlined from fbjs --
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillMount`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillReceiveProps`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillUpdate`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillUpdate: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Similar to ReactClassInterface but for static methods.
	   */
	  var ReactClassStaticInterface = {
	    /**
	     * This method is invoked after a component is instantiated and when it
	     * receives new props. Return an object to update state in response to
	     * prop changes. Return null to indicate no change to state.
	     *
	     * If an object is returned, its keys will be merged into the existing state.
	     *
	     * @return {object || null}
	     * @optional
	     */
	    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isAlreadyDefined = name in Constructor;
	      if (isAlreadyDefined) {
	        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
	          ? ReactClassStaticInterface[name]
	          : null;
	
	        _invariant(
	          specPolicy === 'DEFINE_MANY_MERGED',
	          'ReactClass: You are attempting to define ' +
	            '`%s` on your component more than once. This conflict may be ' +
	            'due to a mixin.',
	          name
	        );
	
	        Constructor[name] = createMergedResultFunction(Constructor[name], property);
	
	        return;
	      }
	
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
	        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
	          'Did you mean UNSAFE_componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ },
/* 1076 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var React = __webpack_require__(1);
	var factory = __webpack_require__(1075);
	
	if (typeof React === 'undefined') {
	  throw Error(
	    'create-react-class could not find the React object. If you are using script tags, ' +
	      'make sure that React is being loaded before create-react-class.'
	  );
	}
	
	// Hack to grab NoopUpdateQueue from isomorphic React
	var ReactNoopUpdateQueue = new React.Component().updater;
	
	module.exports = factory(
	  React.Component,
	  React.isValidElement,
	  ReactNoopUpdateQueue
	);


/***/ },
/* 1077 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var isInBrowser = _interopDefault(__webpack_require__(439));
	var _toConsumableArray = _interopDefault(__webpack_require__(103));
	
	// Export javascript style and css style vendor prefixes.
	var js = '';
	var css = '';
	var vendor = '';
	var browser = '';
	var isTouch = isInBrowser && 'ontouchstart' in document.documentElement; // We should not do anything if required serverside.
	
	if (isInBrowser) {
	  // Order matters. We need to check Webkit the last one because
	  // other vendors use to add Webkit prefixes to some properties
	  var jsCssMap = {
	    Moz: '-moz-',
	    ms: '-ms-',
	    O: '-o-',
	    Webkit: '-webkit-'
	  };
	
	  var _document$createEleme = document.createElement('p'),
	      style = _document$createEleme.style;
	
	  var testProp = 'Transform';
	
	  for (var key in jsCssMap) {
	    if (key + testProp in style) {
	      js = key;
	      css = jsCssMap[key];
	      break;
	    }
	  } // Correctly detect the Edge browser.
	
	
	  if (js === 'Webkit' && 'msHyphens' in style) {
	    js = 'ms';
	    css = jsCssMap.ms;
	    browser = 'edge';
	  } // Correctly detect the Safari browser.
	
	
	  if (js === 'Webkit' && '-apple-trailing-word' in style) {
	    vendor = 'apple';
	  }
	}
	/**
	 * Vendor prefix string for the current browser.
	 *
	 * @type {{js: String, css: String, vendor: String, browser: String}}
	 * @api public
	 */
	
	
	var prefix = {
	  js: js,
	  css: css,
	  vendor: vendor,
	  browser: browser,
	  isTouch: isTouch
	};
	
	/**
	 * Test if a keyframe at-rule should be prefixed or not
	 *
	 * @param {String} vendor prefix string for the current browser.
	 * @return {String}
	 * @api public
	 */
	
	function supportedKeyframes(key) {
	  // Keyframes is already prefixed. e.g. key = '@-webkit-keyframes a'
	  if (key[1] === '-') return key; // No need to prefix IE/Edge. Older browsers will ignore unsupported rules.
	  // https://caniuse.com/#search=keyframes
	
	  if (prefix.js === 'ms') return key;
	  return "@" + prefix.css + "keyframes" + key.substr(10);
	}
	
	// https://caniuse.com/#search=appearance
	
	var appearence = {
	  noPrefill: ['appearance'],
	  supportedProperty: function supportedProperty(prop) {
	    if (prop !== 'appearance') return false;
	    if (prefix.js === 'ms') return "-webkit-" + prop;
	    return prefix.css + prop;
	  }
	};
	
	// https://caniuse.com/#search=color-adjust
	
	var colorAdjust = {
	  noPrefill: ['color-adjust'],
	  supportedProperty: function supportedProperty(prop) {
	    if (prop !== 'color-adjust') return false;
	    if (prefix.js === 'Webkit') return prefix.css + "print-" + prop;
	    return prop;
	  }
	};
	
	var regExp = /[-\s]+(.)?/g;
	/**
	 * Replaces the letter with the capital letter
	 *
	 * @param {String} match
	 * @param {String} c
	 * @return {String}
	 * @api private
	 */
	
	function toUpper(match, c) {
	  return c ? c.toUpperCase() : '';
	}
	/**
	 * Convert dash separated strings to camel-cased.
	 *
	 * @param {String} str
	 * @return {String}
	 * @api private
	 */
	
	
	function camelize(str) {
	  return str.replace(regExp, toUpper);
	}
	
	/**
	 * Convert dash separated strings to pascal cased.
	 *
	 * @param {String} str
	 * @return {String}
	 * @api private
	 */
	
	function pascalize(str) {
	  return camelize("-" + str);
	}
	
	// but we can use a longhand property instead.
	// https://caniuse.com/#search=mask
	
	var mask = {
	  noPrefill: ['mask'],
	  supportedProperty: function supportedProperty(prop, style) {
	    if (!/^mask/.test(prop)) return false;
	
	    if (prefix.js === 'Webkit') {
	      var longhand = 'mask-image';
	
	      if (camelize(longhand) in style) {
	        return prop;
	      }
	
	      if (prefix.js + pascalize(longhand) in style) {
	        return prefix.css + prop;
	      }
	    }
	
	    return prop;
	  }
	};
	
	// https://caniuse.com/#search=text-orientation
	
	var textOrientation = {
	  noPrefill: ['text-orientation'],
	  supportedProperty: function supportedProperty(prop) {
	    if (prop !== 'text-orientation') return false;
	
	    if (prefix.vendor === 'apple' && !prefix.isTouch) {
	      return prefix.css + prop;
	    }
	
	    return prop;
	  }
	};
	
	// https://caniuse.com/#search=transform
	
	var transform = {
	  noPrefill: ['transform'],
	  supportedProperty: function supportedProperty(prop, style, options) {
	    if (prop !== 'transform') return false;
	
	    if (options.transform) {
	      return prop;
	    }
	
	    return prefix.css + prop;
	  }
	};
	
	// https://caniuse.com/#search=transition
	
	var transition = {
	  noPrefill: ['transition'],
	  supportedProperty: function supportedProperty(prop, style, options) {
	    if (prop !== 'transition') return false;
	
	    if (options.transition) {
	      return prop;
	    }
	
	    return prefix.css + prop;
	  }
	};
	
	// https://caniuse.com/#search=writing-mode
	
	var writingMode = {
	  noPrefill: ['writing-mode'],
	  supportedProperty: function supportedProperty(prop) {
	    if (prop !== 'writing-mode') return false;
	
	    if (prefix.js === 'Webkit' || prefix.js === 'ms' && prefix.browser !== 'edge') {
	      return prefix.css + prop;
	    }
	
	    return prop;
	  }
	};
	
	// https://caniuse.com/#search=user-select
	
	var userSelect = {
	  noPrefill: ['user-select'],
	  supportedProperty: function supportedProperty(prop) {
	    if (prop !== 'user-select') return false;
	
	    if (prefix.js === 'Moz' || prefix.js === 'ms' || prefix.vendor === 'apple') {
	      return prefix.css + prop;
	    }
	
	    return prop;
	  }
	};
	
	// https://caniuse.com/#search=multicolumn
	// https://github.com/postcss/autoprefixer/issues/491
	// https://github.com/postcss/autoprefixer/issues/177
	
	var breakPropsOld = {
	  supportedProperty: function supportedProperty(prop, style) {
	    if (!/^break-/.test(prop)) return false;
	
	    if (prefix.js === 'Webkit') {
	      var jsProp = "WebkitColumn" + pascalize(prop);
	      return jsProp in style ? prefix.css + "column-" + prop : false;
	    }
	
	    if (prefix.js === 'Moz') {
	      var _jsProp = "page" + pascalize(prop);
	
	      return _jsProp in style ? "page-" + prop : false;
	    }
	
	    return false;
	  }
	};
	
	// See https://github.com/postcss/autoprefixer/issues/324.
	
	var inlineLogicalOld = {
	  supportedProperty: function supportedProperty(prop, style) {
	    if (!/^(border|margin|padding)-inline/.test(prop)) return false;
	    if (prefix.js === 'Moz') return prop;
	    var newProp = prop.replace('-inline', '');
	    return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
	  }
	};
	
	// Camelization is required because we can't test using.
	// CSS syntax for e.g. in FF.
	
	var unprefixed = {
	  supportedProperty: function supportedProperty(prop, style) {
	    return camelize(prop) in style ? prop : false;
	  }
	};
	
	var prefixed = {
	  supportedProperty: function supportedProperty(prop, style) {
	    var pascalized = pascalize(prop); // Return custom CSS variable without prefixing.
	
	    if (prop[0] === '-') return prop; // Return already prefixed value without prefixing.
	
	    if (prop[0] === '-' && prop[1] === '-') return prop;
	    if (prefix.js + pascalized in style) return prefix.css + prop; // Try webkit fallback.
	
	    if (prefix.js !== 'Webkit' && "Webkit" + pascalized in style) return "-webkit-" + prop;
	    return false;
	  }
	};
	
	// https://caniuse.com/#search=scroll-snap
	
	var scrollSnap = {
	  supportedProperty: function supportedProperty(prop) {
	    if (prop.substring(0, 11) !== 'scroll-snap') return false;
	
	    if (prefix.js === 'ms') {
	      return "" + prefix.css + prop;
	    }
	
	    return prop;
	  }
	};
	
	// https://caniuse.com/#search=overscroll-behavior
	
	var overscrollBehavior = {
	  supportedProperty: function supportedProperty(prop) {
	    if (prop !== 'overscroll-behavior') return false;
	
	    if (prefix.js === 'ms') {
	      return prefix.css + "scroll-chaining";
	    }
	
	    return prop;
	  }
	};
	
	var propMap = {
	  'flex-grow': 'flex-positive',
	  'flex-shrink': 'flex-negative',
	  'flex-basis': 'flex-preferred-size',
	  'justify-content': 'flex-pack',
	  order: 'flex-order',
	  'align-items': 'flex-align',
	  'align-content': 'flex-line-pack' // 'align-self' is handled by 'align-self' plugin.
	
	}; // Support old flex spec from 2012.
	
	var flex2012 = {
	  supportedProperty: function supportedProperty(prop, style) {
	    var newProp = propMap[prop];
	    if (!newProp) return false;
	    return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
	  }
	};
	
	var propMap$1 = {
	  flex: 'box-flex',
	  'flex-grow': 'box-flex',
	  'flex-direction': ['box-orient', 'box-direction'],
	  order: 'box-ordinal-group',
	  'align-items': 'box-align',
	  'flex-flow': ['box-orient', 'box-direction'],
	  'justify-content': 'box-pack'
	};
	var propKeys = Object.keys(propMap$1);
	
	var prefixCss = function prefixCss(p) {
	  return prefix.css + p;
	}; // Support old flex spec from 2009.
	
	
	var flex2009 = {
	  supportedProperty: function supportedProperty(prop, style, _ref) {
	    var multiple = _ref.multiple;
	
	    if (propKeys.indexOf(prop) > -1) {
	      var newProp = propMap$1[prop];
	
	      if (!Array.isArray(newProp)) {
	        return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
	      }
	
	      if (!multiple) return false;
	
	      for (var i = 0; i < newProp.length; i++) {
	        if (!(prefix.js + pascalize(newProp[0]) in style)) {
	          return false;
	        }
	      }
	
	      return newProp.map(prefixCss);
	    }
	
	    return false;
	  }
	};
	
	// plugins = [
	//   ...plugins,
	//    breakPropsOld,
	//    inlineLogicalOld,
	//    unprefixed,
	//    prefixed,
	//    scrollSnap,
	//    flex2012,
	//    flex2009
	// ]
	// Plugins without 'noPrefill' value, going last.
	// 'flex-*' plugins should be at the bottom.
	// 'flex2009' going after 'flex2012'.
	// 'prefixed' going after 'unprefixed'
	
	var plugins = [appearence, colorAdjust, mask, textOrientation, transform, transition, writingMode, userSelect, breakPropsOld, inlineLogicalOld, unprefixed, prefixed, scrollSnap, overscrollBehavior, flex2012, flex2009];
	var propertyDetectors = plugins.filter(function (p) {
	  return p.supportedProperty;
	}).map(function (p) {
	  return p.supportedProperty;
	});
	var noPrefill = plugins.filter(function (p) {
	  return p.noPrefill;
	}).reduce(function (a, p) {
	  a.push.apply(a, _toConsumableArray(p.noPrefill));
	  return a;
	}, []);
	
	var el;
	var cache = {};
	
	if (isInBrowser) {
	  el = document.createElement('p'); // We test every property on vendor prefix requirement.
	  // Once tested, result is cached. It gives us up to 70% perf boost.
	  // http://jsperf.com/element-style-object-access-vs-plain-object
	  //
	  // Prefill cache with known css properties to reduce amount of
	  // properties we need to feature test at runtime.
	  // http://davidwalsh.name/vendor-prefix
	
	  var computed = window.getComputedStyle(document.documentElement, '');
	
	  for (var key$1 in computed) {
	    // eslint-disable-next-line no-restricted-globals
	    if (!isNaN(key$1)) cache[computed[key$1]] = computed[key$1];
	  } // Properties that cannot be correctly detected using the
	  // cache prefill method.
	
	
	  noPrefill.forEach(function (x) {
	    return delete cache[x];
	  });
	}
	/**
	 * Test if a property is supported, returns supported property with vendor
	 * prefix if required. Returns `false` if not supported.
	 *
	 * @param {String} prop dash separated
	 * @param {Object} [options]
	 * @return {String|Boolean}
	 * @api public
	 */
	
	
	function supportedProperty(prop, options) {
	  if (options === void 0) {
	    options = {};
	  }
	
	  // For server-side rendering.
	  if (!el) return prop; // Remove cache for benchmark tests or return property from the cache.
	
	  if (("production") !== 'benchmark' && cache[prop] != null) {
	    return cache[prop];
	  } // Check if 'transition' or 'transform' natively supported in browser.
	
	
	  if (prop === 'transition' || prop === 'transform') {
	    options[prop] = prop in el.style;
	  } // Find a plugin for current prefix property.
	
	
	  for (var i = 0; i < propertyDetectors.length; i++) {
	    cache[prop] = propertyDetectors[i](prop, el.style, options); // Break loop, if value found.
	
	    if (cache[prop]) break;
	  } // Reset styles for current property.
	  // Firefox can even throw an error for invalid properties, e.g., "0".
	
	
	  try {
	    el.style[prop] = '';
	  } catch (err) {
	    return false;
	  }
	
	  return cache[prop];
	}
	
	var cache$1 = {};
	var transitionProperties = {
	  transition: 1,
	  'transition-property': 1,
	  '-webkit-transition': 1,
	  '-webkit-transition-property': 1
	};
	var transPropsRegExp = /(^\s*[\w-]+)|, (\s*[\w-]+)(?![^()]*\))/g;
	var el$1;
	/**
	 * Returns prefixed value transition/transform if needed.
	 *
	 * @param {String} match
	 * @param {String} p1
	 * @param {String} p2
	 * @return {String}
	 * @api private
	 */
	
	function prefixTransitionCallback(match, p1, p2) {
	  if (p1 === 'var') return 'var';
	  if (p1 === 'all') return 'all';
	  if (p2 === 'all') return ', all';
	  var prefixedValue = p1 ? supportedProperty(p1) : ", " + supportedProperty(p2);
	  if (!prefixedValue) return p1 || p2;
	  return prefixedValue;
	}
	
	if (isInBrowser) el$1 = document.createElement('p');
	/**
	 * Returns prefixed value if needed. Returns `false` if value is not supported.
	 *
	 * @param {String} property
	 * @param {String} value
	 * @return {String|Boolean}
	 * @api public
	 */
	
	function supportedValue(property, value) {
	  // For server-side rendering.
	  var prefixedValue = value;
	  if (!el$1 || property === 'content') return value; // It is a string or a number as a string like '1'.
	  // We want only prefixable values here.
	  // eslint-disable-next-line no-restricted-globals
	
	  if (typeof prefixedValue !== 'string' || !isNaN(parseInt(prefixedValue, 10))) {
	    return prefixedValue;
	  } // Create cache key for current value.
	
	
	  var cacheKey = property + prefixedValue; // Remove cache for benchmark tests or return value from cache.
	
	  if (("production") !== 'benchmark' && cache$1[cacheKey] != null) {
	    return cache$1[cacheKey];
	  } // IE can even throw an error in some cases, for e.g. style.content = 'bar'.
	
	
	  try {
	    // Test value as it is.
	    el$1.style[property] = prefixedValue;
	  } catch (err) {
	    // Return false if value not supported.
	    cache$1[cacheKey] = false;
	    return false;
	  } // If 'transition' or 'transition-property' property.
	
	
	  if (transitionProperties[property]) {
	    prefixedValue = prefixedValue.replace(transPropsRegExp, prefixTransitionCallback);
	  } else if (el$1.style[property] === '') {
	    // Value with a vendor prefix.
	    prefixedValue = prefix.css + prefixedValue; // Hardcode test to convert "flex" to "-ms-flexbox" for IE10.
	
	    if (prefixedValue === '-ms-flex') el$1.style[property] = '-ms-flexbox'; // Test prefixed value.
	
	    el$1.style[property] = prefixedValue; // Return false if value not supported.
	
	    if (el$1.style[property] === '') {
	      cache$1[cacheKey] = false;
	      return false;
	    }
	  } // Reset styles for current property.
	
	
	  el$1.style[property] = ''; // Write current value to cache.
	
	  cache$1[cacheKey] = prefixedValue;
	  return cache$1[cacheKey];
	}
	
	exports.prefix = prefix;
	exports.supportedKeyframes = supportedKeyframes;
	exports.supportedProperty = supportedProperty;
	exports.supportedValue = supportedValue;


/***/ },
/* 1078 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = assign;
	function assign(target, object) {
	  if (target == null) {
	    throw new TypeError('assign requires that input parameter not be null or undefined');
	  }
	  for (var property in object) {
	    if (Object.prototype.hasOwnProperty.call(object, property)) {
	      ;
	      target[property] = object[property];
	    }
	  }
	  return target;
	}
	module.exports = exports.default;

/***/ },
/* 1079 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _index = _interopRequireDefault(__webpack_require__(1081));
	var _index2 = _interopRequireDefault(__webpack_require__(376));
	var _index3 = _interopRequireDefault(__webpack_require__(377));
	var _index4 = _interopRequireDefault(__webpack_require__(378));
	var _index5 = _interopRequireDefault(__webpack_require__(253));
	var _index6 = _interopRequireDefault(__webpack_require__(373));
	var _index7 = _interopRequireDefault(__webpack_require__(1080));
	var dayPeriodEnum = {
	  am: 'am',
	  pm: 'pm',
	  midnight: 'midnight',
	  noon: 'noon',
	  morning: 'morning',
	  afternoon: 'afternoon',
	  evening: 'evening',
	  night: 'night'
	};
	/*
	 * |     | Unit                           |     | Unit                           |
	 * |-----|--------------------------------|-----|--------------------------------|
	 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
	 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
	 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
	 * |  d  | Day of month                   |  D  | Day of year                    |
	 * |  e  | Local day of week              |  E  | Day of week                    |
	 * |  f  |                                |  F* | Day of week in month           |
	 * |  g* | Modified Julian day            |  G  | Era                            |
	 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
	 * |  i! | ISO day of week                |  I! | ISO week of year               |
	 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
	 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
	 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
	 * |  m  | Minute                         |  M  | Month                          |
	 * |  n  |                                |  N  |                                |
	 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
	 * |  p! | Long localized time            |  P! | Long localized date            |
	 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
	 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
	 * |  s  | Second                         |  S  | Fraction of second             |
	 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
	 * |  u  | Extended year                  |  U* | Cyclic year                    |
	 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
	 * |  w  | Local week of year             |  W* | Week of month                  |
	 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
	 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
	 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
	 *
	 * Letters marked by * are not implemented but reserved by Unicode standard.
	 *
	 * Letters marked by ! are non-standard, but implemented by date-fns:
	 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
	 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
	 *   i.e. 7 for Sunday, 1 for Monday, etc.
	 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
	 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
	 *   `R` is supposed to be used in conjunction with `I` and `i`
	 *   for universal ISO week-numbering date, whereas
	 *   `Y` is supposed to be used in conjunction with `w` and `e`
	 *   for week-numbering date specific to the locale.
	 * - `P` is long localized date format
	 * - `p` is long localized time format
	 */
	
	var formatters = {
	  // Era
	  G: function G(date, token, localize) {
	    var era = date.getUTCFullYear() > 0 ? 1 : 0;
	    switch (token) {
	      // AD, BC
	      case 'G':
	      case 'GG':
	      case 'GGG':
	        return localize.era(era, {
	          width: 'abbreviated'
	        });
	      // A, B
	      case 'GGGGG':
	        return localize.era(era, {
	          width: 'narrow'
	        });
	      // Anno Domini, Before Christ
	      case 'GGGG':
	      default:
	        return localize.era(era, {
	          width: 'wide'
	        });
	    }
	  },
	  // Year
	  y: function y(date, token, localize) {
	    // Ordinal number
	    if (token === 'yo') {
	      var signedYear = date.getUTCFullYear();
	      // Returns 1 for 1 BC (which is year 0 in JavaScript)
	      var year = signedYear > 0 ? signedYear : 1 - signedYear;
	      return localize.ordinalNumber(year, {
	        unit: 'year'
	      });
	    }
	    return _index7.default.y(date, token);
	  },
	  // Local week-numbering year
	  Y: function Y(date, token, localize, options) {
	    var signedWeekYear = (0, _index5.default)(date, options);
	    // Returns 1 for 1 BC (which is year 0 in JavaScript)
	    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
	
	    // Two digit year
	    if (token === 'YY') {
	      var twoDigitYear = weekYear % 100;
	      return (0, _index6.default)(twoDigitYear, 2);
	    }
	
	    // Ordinal number
	    if (token === 'Yo') {
	      return localize.ordinalNumber(weekYear, {
	        unit: 'year'
	      });
	    }
	
	    // Padding
	    return (0, _index6.default)(weekYear, token.length);
	  },
	  // ISO week-numbering year
	  R: function R(date, token) {
	    var isoWeekYear = (0, _index3.default)(date);
	
	    // Padding
	    return (0, _index6.default)(isoWeekYear, token.length);
	  },
	  // Extended year. This is a single number designating the year of this calendar system.
	  // The main difference between `y` and `u` localizers are B.C. years:
	  // | Year | `y` | `u` |
	  // |------|-----|-----|
	  // | AC 1 |   1 |   1 |
	  // | BC 1 |   1 |   0 |
	  // | BC 2 |   2 |  -1 |
	  // Also `yy` always returns the last two digits of a year,
	  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
	  u: function u(date, token) {
	    var year = date.getUTCFullYear();
	    return (0, _index6.default)(year, token.length);
	  },
	  // Quarter
	  Q: function Q(date, token, localize) {
	    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
	    switch (token) {
	      // 1, 2, 3, 4
	      case 'Q':
	        return String(quarter);
	      // 01, 02, 03, 04
	      case 'QQ':
	        return (0, _index6.default)(quarter, 2);
	      // 1st, 2nd, 3rd, 4th
	      case 'Qo':
	        return localize.ordinalNumber(quarter, {
	          unit: 'quarter'
	        });
	      // Q1, Q2, Q3, Q4
	      case 'QQQ':
	        return localize.quarter(quarter, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
	      case 'QQQQQ':
	        return localize.quarter(quarter, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	      // 1st quarter, 2nd quarter, ...
	      case 'QQQQ':
	      default:
	        return localize.quarter(quarter, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // Stand-alone quarter
	  q: function q(date, token, localize) {
	    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
	    switch (token) {
	      // 1, 2, 3, 4
	      case 'q':
	        return String(quarter);
	      // 01, 02, 03, 04
	      case 'qq':
	        return (0, _index6.default)(quarter, 2);
	      // 1st, 2nd, 3rd, 4th
	      case 'qo':
	        return localize.ordinalNumber(quarter, {
	          unit: 'quarter'
	        });
	      // Q1, Q2, Q3, Q4
	      case 'qqq':
	        return localize.quarter(quarter, {
	          width: 'abbreviated',
	          context: 'standalone'
	        });
	      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
	      case 'qqqqq':
	        return localize.quarter(quarter, {
	          width: 'narrow',
	          context: 'standalone'
	        });
	      // 1st quarter, 2nd quarter, ...
	      case 'qqqq':
	      default:
	        return localize.quarter(quarter, {
	          width: 'wide',
	          context: 'standalone'
	        });
	    }
	  },
	  // Month
	  M: function M(date, token, localize) {
	    var month = date.getUTCMonth();
	    switch (token) {
	      case 'M':
	      case 'MM':
	        return _index7.default.M(date, token);
	      // 1st, 2nd, ..., 12th
	      case 'Mo':
	        return localize.ordinalNumber(month + 1, {
	          unit: 'month'
	        });
	      // Jan, Feb, ..., Dec
	      case 'MMM':
	        return localize.month(month, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	      // J, F, ..., D
	      case 'MMMMM':
	        return localize.month(month, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	      // January, February, ..., December
	      case 'MMMM':
	      default:
	        return localize.month(month, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // Stand-alone month
	  L: function L(date, token, localize) {
	    var month = date.getUTCMonth();
	    switch (token) {
	      // 1, 2, ..., 12
	      case 'L':
	        return String(month + 1);
	      // 01, 02, ..., 12
	      case 'LL':
	        return (0, _index6.default)(month + 1, 2);
	      // 1st, 2nd, ..., 12th
	      case 'Lo':
	        return localize.ordinalNumber(month + 1, {
	          unit: 'month'
	        });
	      // Jan, Feb, ..., Dec
	      case 'LLL':
	        return localize.month(month, {
	          width: 'abbreviated',
	          context: 'standalone'
	        });
	      // J, F, ..., D
	      case 'LLLLL':
	        return localize.month(month, {
	          width: 'narrow',
	          context: 'standalone'
	        });
	      // January, February, ..., December
	      case 'LLLL':
	      default:
	        return localize.month(month, {
	          width: 'wide',
	          context: 'standalone'
	        });
	    }
	  },
	  // Local week of year
	  w: function w(date, token, localize, options) {
	    var week = (0, _index4.default)(date, options);
	    if (token === 'wo') {
	      return localize.ordinalNumber(week, {
	        unit: 'week'
	      });
	    }
	    return (0, _index6.default)(week, token.length);
	  },
	  // ISO week of year
	  I: function I(date, token, localize) {
	    var isoWeek = (0, _index2.default)(date);
	    if (token === 'Io') {
	      return localize.ordinalNumber(isoWeek, {
	        unit: 'week'
	      });
	    }
	    return (0, _index6.default)(isoWeek, token.length);
	  },
	  // Day of the month
	  d: function d(date, token, localize) {
	    if (token === 'do') {
	      return localize.ordinalNumber(date.getUTCDate(), {
	        unit: 'date'
	      });
	    }
	    return _index7.default.d(date, token);
	  },
	  // Day of year
	  D: function D(date, token, localize) {
	    var dayOfYear = (0, _index.default)(date);
	    if (token === 'Do') {
	      return localize.ordinalNumber(dayOfYear, {
	        unit: 'dayOfYear'
	      });
	    }
	    return (0, _index6.default)(dayOfYear, token.length);
	  },
	  // Day of week
	  E: function E(date, token, localize) {
	    var dayOfWeek = date.getUTCDay();
	    switch (token) {
	      // Tue
	      case 'E':
	      case 'EE':
	      case 'EEE':
	        return localize.day(dayOfWeek, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	      // T
	      case 'EEEEE':
	        return localize.day(dayOfWeek, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	      // Tu
	      case 'EEEEEE':
	        return localize.day(dayOfWeek, {
	          width: 'short',
	          context: 'formatting'
	        });
	      // Tuesday
	      case 'EEEE':
	      default:
	        return localize.day(dayOfWeek, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // Local day of week
	  e: function e(date, token, localize, options) {
	    var dayOfWeek = date.getUTCDay();
	    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
	    switch (token) {
	      // Numerical value (Nth day of week with current locale or weekStartsOn)
	      case 'e':
	        return String(localDayOfWeek);
	      // Padded numerical value
	      case 'ee':
	        return (0, _index6.default)(localDayOfWeek, 2);
	      // 1st, 2nd, ..., 7th
	      case 'eo':
	        return localize.ordinalNumber(localDayOfWeek, {
	          unit: 'day'
	        });
	      case 'eee':
	        return localize.day(dayOfWeek, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	      // T
	      case 'eeeee':
	        return localize.day(dayOfWeek, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	      // Tu
	      case 'eeeeee':
	        return localize.day(dayOfWeek, {
	          width: 'short',
	          context: 'formatting'
	        });
	      // Tuesday
	      case 'eeee':
	      default:
	        return localize.day(dayOfWeek, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // Stand-alone local day of week
	  c: function c(date, token, localize, options) {
	    var dayOfWeek = date.getUTCDay();
	    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
	    switch (token) {
	      // Numerical value (same as in `e`)
	      case 'c':
	        return String(localDayOfWeek);
	      // Padded numerical value
	      case 'cc':
	        return (0, _index6.default)(localDayOfWeek, token.length);
	      // 1st, 2nd, ..., 7th
	      case 'co':
	        return localize.ordinalNumber(localDayOfWeek, {
	          unit: 'day'
	        });
	      case 'ccc':
	        return localize.day(dayOfWeek, {
	          width: 'abbreviated',
	          context: 'standalone'
	        });
	      // T
	      case 'ccccc':
	        return localize.day(dayOfWeek, {
	          width: 'narrow',
	          context: 'standalone'
	        });
	      // Tu
	      case 'cccccc':
	        return localize.day(dayOfWeek, {
	          width: 'short',
	          context: 'standalone'
	        });
	      // Tuesday
	      case 'cccc':
	      default:
	        return localize.day(dayOfWeek, {
	          width: 'wide',
	          context: 'standalone'
	        });
	    }
	  },
	  // ISO day of week
	  i: function i(date, token, localize) {
	    var dayOfWeek = date.getUTCDay();
	    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
	    switch (token) {
	      // 2
	      case 'i':
	        return String(isoDayOfWeek);
	      // 02
	      case 'ii':
	        return (0, _index6.default)(isoDayOfWeek, token.length);
	      // 2nd
	      case 'io':
	        return localize.ordinalNumber(isoDayOfWeek, {
	          unit: 'day'
	        });
	      // Tue
	      case 'iii':
	        return localize.day(dayOfWeek, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	      // T
	      case 'iiiii':
	        return localize.day(dayOfWeek, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	      // Tu
	      case 'iiiiii':
	        return localize.day(dayOfWeek, {
	          width: 'short',
	          context: 'formatting'
	        });
	      // Tuesday
	      case 'iiii':
	      default:
	        return localize.day(dayOfWeek, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // AM or PM
	  a: function a(date, token, localize) {
	    var hours = date.getUTCHours();
	    var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
	    switch (token) {
	      case 'a':
	      case 'aa':
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	      case 'aaa':
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'abbreviated',
	          context: 'formatting'
	        }).toLowerCase();
	      case 'aaaaa':
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	      case 'aaaa':
	      default:
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // AM, PM, midnight, noon
	  b: function b(date, token, localize) {
	    var hours = date.getUTCHours();
	    var dayPeriodEnumValue;
	    if (hours === 12) {
	      dayPeriodEnumValue = dayPeriodEnum.noon;
	    } else if (hours === 0) {
	      dayPeriodEnumValue = dayPeriodEnum.midnight;
	    } else {
	      dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
	    }
	    switch (token) {
	      case 'b':
	      case 'bb':
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	      case 'bbb':
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'abbreviated',
	          context: 'formatting'
	        }).toLowerCase();
	      case 'bbbbb':
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	      case 'bbbb':
	      default:
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // in the morning, in the afternoon, in the evening, at night
	  B: function B(date, token, localize) {
	    var hours = date.getUTCHours();
	    var dayPeriodEnumValue;
	    if (hours >= 17) {
	      dayPeriodEnumValue = dayPeriodEnum.evening;
	    } else if (hours >= 12) {
	      dayPeriodEnumValue = dayPeriodEnum.afternoon;
	    } else if (hours >= 4) {
	      dayPeriodEnumValue = dayPeriodEnum.morning;
	    } else {
	      dayPeriodEnumValue = dayPeriodEnum.night;
	    }
	    switch (token) {
	      case 'B':
	      case 'BB':
	      case 'BBB':
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	      case 'BBBBB':
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	      case 'BBBB':
	      default:
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // Hour [1-12]
	  h: function h(date, token, localize) {
	    if (token === 'ho') {
	      var hours = date.getUTCHours() % 12;
	      if (hours === 0) hours = 12;
	      return localize.ordinalNumber(hours, {
	        unit: 'hour'
	      });
	    }
	    return _index7.default.h(date, token);
	  },
	  // Hour [0-23]
	  H: function H(date, token, localize) {
	    if (token === 'Ho') {
	      return localize.ordinalNumber(date.getUTCHours(), {
	        unit: 'hour'
	      });
	    }
	    return _index7.default.H(date, token);
	  },
	  // Hour [0-11]
	  K: function K(date, token, localize) {
	    var hours = date.getUTCHours() % 12;
	    if (token === 'Ko') {
	      return localize.ordinalNumber(hours, {
	        unit: 'hour'
	      });
	    }
	    return (0, _index6.default)(hours, token.length);
	  },
	  // Hour [1-24]
	  k: function k(date, token, localize) {
	    var hours = date.getUTCHours();
	    if (hours === 0) hours = 24;
	    if (token === 'ko') {
	      return localize.ordinalNumber(hours, {
	        unit: 'hour'
	      });
	    }
	    return (0, _index6.default)(hours, token.length);
	  },
	  // Minute
	  m: function m(date, token, localize) {
	    if (token === 'mo') {
	      return localize.ordinalNumber(date.getUTCMinutes(), {
	        unit: 'minute'
	      });
	    }
	    return _index7.default.m(date, token);
	  },
	  // Second
	  s: function s(date, token, localize) {
	    if (token === 'so') {
	      return localize.ordinalNumber(date.getUTCSeconds(), {
	        unit: 'second'
	      });
	    }
	    return _index7.default.s(date, token);
	  },
	  // Fraction of second
	  S: function S(date, token) {
	    return _index7.default.S(date, token);
	  },
	  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
	  X: function X(date, token, _localize, options) {
	    var originalDate = options._originalDate || date;
	    var timezoneOffset = originalDate.getTimezoneOffset();
	    if (timezoneOffset === 0) {
	      return 'Z';
	    }
	    switch (token) {
	      // Hours and optional minutes
	      case 'X':
	        return formatTimezoneWithOptionalMinutes(timezoneOffset);
	
	      // Hours, minutes and optional seconds without `:` delimiter
	      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
	      // so this token always has the same output as `XX`
	      case 'XXXX':
	      case 'XX':
	        // Hours and minutes without `:` delimiter
	        return formatTimezone(timezoneOffset);
	
	      // Hours, minutes and optional seconds with `:` delimiter
	      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
	      // so this token always has the same output as `XXX`
	      case 'XXXXX':
	      case 'XXX': // Hours and minutes with `:` delimiter
	      default:
	        return formatTimezone(timezoneOffset, ':');
	    }
	  },
	  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
	  x: function x(date, token, _localize, options) {
	    var originalDate = options._originalDate || date;
	    var timezoneOffset = originalDate.getTimezoneOffset();
	    switch (token) {
	      // Hours and optional minutes
	      case 'x':
	        return formatTimezoneWithOptionalMinutes(timezoneOffset);
	
	      // Hours, minutes and optional seconds without `:` delimiter
	      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
	      // so this token always has the same output as `xx`
	      case 'xxxx':
	      case 'xx':
	        // Hours and minutes without `:` delimiter
	        return formatTimezone(timezoneOffset);
	
	      // Hours, minutes and optional seconds with `:` delimiter
	      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
	      // so this token always has the same output as `xxx`
	      case 'xxxxx':
	      case 'xxx': // Hours and minutes with `:` delimiter
	      default:
	        return formatTimezone(timezoneOffset, ':');
	    }
	  },
	  // Timezone (GMT)
	  O: function O(date, token, _localize, options) {
	    var originalDate = options._originalDate || date;
	    var timezoneOffset = originalDate.getTimezoneOffset();
	    switch (token) {
	      // Short
	      case 'O':
	      case 'OO':
	      case 'OOO':
	        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
	      // Long
	      case 'OOOO':
	      default:
	        return 'GMT' + formatTimezone(timezoneOffset, ':');
	    }
	  },
	  // Timezone (specific non-location)
	  z: function z(date, token, _localize, options) {
	    var originalDate = options._originalDate || date;
	    var timezoneOffset = originalDate.getTimezoneOffset();
	    switch (token) {
	      // Short
	      case 'z':
	      case 'zz':
	      case 'zzz':
	        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
	      // Long
	      case 'zzzz':
	      default:
	        return 'GMT' + formatTimezone(timezoneOffset, ':');
	    }
	  },
	  // Seconds timestamp
	  t: function t(date, token, _localize, options) {
	    var originalDate = options._originalDate || date;
	    var timestamp = Math.floor(originalDate.getTime() / 1000);
	    return (0, _index6.default)(timestamp, token.length);
	  },
	  // Milliseconds timestamp
	  T: function T(date, token, _localize, options) {
	    var originalDate = options._originalDate || date;
	    var timestamp = originalDate.getTime();
	    return (0, _index6.default)(timestamp, token.length);
	  }
	};
	function formatTimezoneShort(offset, dirtyDelimiter) {
	  var sign = offset > 0 ? '-' : '+';
	  var absOffset = Math.abs(offset);
	  var hours = Math.floor(absOffset / 60);
	  var minutes = absOffset % 60;
	  if (minutes === 0) {
	    return sign + String(hours);
	  }
	  var delimiter = dirtyDelimiter || '';
	  return sign + String(hours) + delimiter + (0, _index6.default)(minutes, 2);
	}
	function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
	  if (offset % 60 === 0) {
	    var sign = offset > 0 ? '-' : '+';
	    return sign + (0, _index6.default)(Math.abs(offset) / 60, 2);
	  }
	  return formatTimezone(offset, dirtyDelimiter);
	}
	function formatTimezone(offset, dirtyDelimiter) {
	  var delimiter = dirtyDelimiter || '';
	  var sign = offset > 0 ? '-' : '+';
	  var absOffset = Math.abs(offset);
	  var hours = (0, _index6.default)(Math.floor(absOffset / 60), 2);
	  var minutes = (0, _index6.default)(absOffset % 60, 2);
	  return sign + hours + delimiter + minutes;
	}
	var _default = formatters;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1080 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _index = _interopRequireDefault(__webpack_require__(373));
	/*
	 * |     | Unit                           |     | Unit                           |
	 * |-----|--------------------------------|-----|--------------------------------|
	 * |  a  | AM, PM                         |  A* |                                |
	 * |  d  | Day of month                   |  D  |                                |
	 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
	 * |  m  | Minute                         |  M  | Month                          |
	 * |  s  | Second                         |  S  | Fraction of second             |
	 * |  y  | Year (abs)                     |  Y  |                                |
	 *
	 * Letters marked by * are not implemented but reserved by Unicode standard.
	 */
	
	var formatters = {
	  // Year
	  y: function y(date, token) {
	    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
	    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
	    // |----------|-------|----|-------|-------|-------|
	    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
	    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
	    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
	    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
	    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
	
	    var signedYear = date.getUTCFullYear();
	    // Returns 1 for 1 BC (which is year 0 in JavaScript)
	    var year = signedYear > 0 ? signedYear : 1 - signedYear;
	    return (0, _index.default)(token === 'yy' ? year % 100 : year, token.length);
	  },
	  // Month
	  M: function M(date, token) {
	    var month = date.getUTCMonth();
	    return token === 'M' ? String(month + 1) : (0, _index.default)(month + 1, 2);
	  },
	  // Day of the month
	  d: function d(date, token) {
	    return (0, _index.default)(date.getUTCDate(), token.length);
	  },
	  // AM or PM
	  a: function a(date, token) {
	    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
	    switch (token) {
	      case 'a':
	      case 'aa':
	        return dayPeriodEnumValue.toUpperCase();
	      case 'aaa':
	        return dayPeriodEnumValue;
	      case 'aaaaa':
	        return dayPeriodEnumValue[0];
	      case 'aaaa':
	      default:
	        return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
	    }
	  },
	  // Hour [1-12]
	  h: function h(date, token) {
	    return (0, _index.default)(date.getUTCHours() % 12 || 12, token.length);
	  },
	  // Hour [0-23]
	  H: function H(date, token) {
	    return (0, _index.default)(date.getUTCHours(), token.length);
	  },
	  // Minute
	  m: function m(date, token) {
	    return (0, _index.default)(date.getUTCMinutes(), token.length);
	  },
	  // Second
	  s: function s(date, token) {
	    return (0, _index.default)(date.getUTCSeconds(), token.length);
	  },
	  // Fraction of second
	  S: function S(date, token) {
	    var numberOfDigits = token.length;
	    var milliseconds = date.getUTCMilliseconds();
	    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
	    return (0, _index.default)(fractionalSeconds, token.length);
	  }
	};
	var _default = formatters;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1081 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getUTCDayOfYear;
	var _index = _interopRequireDefault(__webpack_require__(23));
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	var MILLISECONDS_IN_DAY = 86400000;
	function getUTCDayOfYear(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var timestamp = date.getTime();
	  date.setUTCMonth(0, 1);
	  date.setUTCHours(0, 0, 0, 0);
	  var startOfYearTimestamp = date.getTime();
	  var difference = timestamp - startOfYearTimestamp;
	  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
	}
	module.exports = exports.default;

/***/ },
/* 1082 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setUTCISODay;
	var _index = _interopRequireDefault(__webpack_require__(23));
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	var _index3 = _interopRequireDefault(__webpack_require__(30));
	function setUTCISODay(dirtyDate, dirtyDay) {
	  (0, _index2.default)(2, arguments);
	  var day = (0, _index3.default)(dirtyDay);
	  if (day % 7 === 0) {
	    day = day - 7;
	  }
	  var weekStartsOn = 1;
	  var date = (0, _index.default)(dirtyDate);
	  var currentDay = date.getUTCDay();
	  var remainder = day % 7;
	  var dayIndex = (remainder + 7) % 7;
	  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
	  date.setUTCDate(date.getUTCDate() + diff);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 1083 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setUTCISOWeek;
	var _index = _interopRequireDefault(__webpack_require__(30));
	var _index2 = _interopRequireDefault(__webpack_require__(23));
	var _index3 = _interopRequireDefault(__webpack_require__(376));
	var _index4 = _interopRequireDefault(__webpack_require__(14));
	function setUTCISOWeek(dirtyDate, dirtyISOWeek) {
	  (0, _index4.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var isoWeek = (0, _index.default)(dirtyISOWeek);
	  var diff = (0, _index3.default)(date) - isoWeek;
	  date.setUTCDate(date.getUTCDate() - diff * 7);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 1084 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setUTCWeek;
	var _index = _interopRequireDefault(__webpack_require__(30));
	var _index2 = _interopRequireDefault(__webpack_require__(23));
	var _index3 = _interopRequireDefault(__webpack_require__(378));
	var _index4 = _interopRequireDefault(__webpack_require__(14));
	function setUTCWeek(dirtyDate, dirtyWeek, options) {
	  (0, _index4.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var week = (0, _index.default)(dirtyWeek);
	  var diff = (0, _index3.default)(date, options) - week;
	  date.setUTCDate(date.getUTCDate() - diff * 7);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 1085 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfUTCISOWeekYear;
	var _index = _interopRequireDefault(__webpack_require__(377));
	var _index2 = _interopRequireDefault(__webpack_require__(148));
	var _index3 = _interopRequireDefault(__webpack_require__(14));
	function startOfUTCISOWeekYear(dirtyDate) {
	  (0, _index3.default)(1, arguments);
	  var year = (0, _index.default)(dirtyDate);
	  var fourthOfJanuary = new Date(0);
	  fourthOfJanuary.setUTCFullYear(year, 0, 4);
	  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
	  var date = (0, _index2.default)(fourthOfJanuary);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 1086 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfUTCWeekYear;
	var _index = _interopRequireDefault(__webpack_require__(253));
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	var _index3 = _interopRequireDefault(__webpack_require__(149));
	var _index4 = _interopRequireDefault(__webpack_require__(30));
	var _index5 = __webpack_require__(96);
	function startOfUTCWeekYear(dirtyDate, options) {
	  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
	  (0, _index2.default)(1, arguments);
	  var defaultOptions = (0, _index5.getDefaultOptions)();
	  var firstWeekContainsDate = (0, _index4.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
	  var year = (0, _index.default)(dirtyDate, options);
	  var firstWeek = new Date(0);
	  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
	  firstWeek.setUTCHours(0, 0, 0, 0);
	  var date = (0, _index3.default)(firstWeek, options);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 1087 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInCalendarDays;
	var _index = _interopRequireDefault(__webpack_require__(189));
	var _index2 = _interopRequireDefault(__webpack_require__(258));
	var _index3 = _interopRequireDefault(__webpack_require__(14));
	var MILLISECONDS_IN_DAY = 86400000;
	
	/**
	 * @name differenceInCalendarDays
	 * @category Day Helpers
	 * @summary Get the number of calendar days between the given dates.
	 *
	 * @description
	 * Get the number of calendar days between the given dates. This means that the times are removed
	 * from the dates and then the difference in days is calculated.
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of calendar days
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many calendar days are between
	 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
	 * const result = differenceInCalendarDays(
	 *   new Date(2012, 6, 2, 0, 0),
	 *   new Date(2011, 6, 2, 23, 0)
	 * )
	 * //=> 366
	 * // How many calendar days are between
	 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
	 * const result = differenceInCalendarDays(
	 *   new Date(2011, 6, 3, 0, 1),
	 *   new Date(2011, 6, 2, 23, 59)
	 * )
	 * //=> 1
	 */
	function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
	  (0, _index3.default)(2, arguments);
	  var startOfDayLeft = (0, _index2.default)(dirtyDateLeft);
	  var startOfDayRight = (0, _index2.default)(dirtyDateRight);
	  var timestampLeft = startOfDayLeft.getTime() - (0, _index.default)(startOfDayLeft);
	  var timestampRight = startOfDayRight.getTime() - (0, _index.default)(startOfDayRight);
	
	  // Round the number of days to the nearest integer
	  // because the number of milliseconds in a day is not constant
	  // (e.g. it's different in the day of the daylight saving time clock shift)
	  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY);
	}
	module.exports = exports.default;

/***/ },
/* 1088 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInCalendarMonths;
	var _index = _interopRequireDefault(__webpack_require__(23));
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	/**
	 * @name differenceInCalendarMonths
	 * @category Month Helpers
	 * @summary Get the number of calendar months between the given dates.
	 *
	 * @description
	 * Get the number of calendar months between the given dates.
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of calendar months
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many calendar months are between 31 January 2014 and 1 September 2014?
	 * const result = differenceInCalendarMonths(
	 *   new Date(2014, 8, 1),
	 *   new Date(2014, 0, 31)
	 * )
	 * //=> 8
	 */
	function differenceInCalendarMonths(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeft = (0, _index.default)(dirtyDateLeft);
	  var dateRight = (0, _index.default)(dirtyDateRight);
	  var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
	  var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
	  return yearDiff * 12 + monthDiff;
	}
	module.exports = exports.default;

/***/ },
/* 1089 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInCalendarWeeks;
	var _index = _interopRequireDefault(__webpack_require__(260));
	var _index2 = _interopRequireDefault(__webpack_require__(189));
	var _index3 = _interopRequireDefault(__webpack_require__(14));
	var MILLISECONDS_IN_WEEK = 604800000;
	
	/**
	 * @name differenceInCalendarWeeks
	 * @category Week Helpers
	 * @summary Get the number of calendar weeks between the given dates.
	 *
	 * @description
	 * Get the number of calendar weeks between the given dates.
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Number} the number of calendar weeks
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 *
	 * @example
	 * // How many calendar weeks are between 5 July 2014 and 20 July 2014?
	 * const result = differenceInCalendarWeeks(
	 *   new Date(2014, 6, 20),
	 *   new Date(2014, 6, 5)
	 * )
	 * //=> 3
	 *
	 * @example
	 * // If the week starts on Monday,
	 * // how many calendar weeks are between 5 July 2014 and 20 July 2014?
	 * const result = differenceInCalendarWeeks(
	 *   new Date(2014, 6, 20),
	 *   new Date(2014, 6, 5),
	 *   { weekStartsOn: 1 }
	 * )
	 * //=> 2
	 */
	function differenceInCalendarWeeks(dirtyDateLeft, dirtyDateRight, options) {
	  (0, _index3.default)(2, arguments);
	  var startOfWeekLeft = (0, _index.default)(dirtyDateLeft, options);
	  var startOfWeekRight = (0, _index.default)(dirtyDateRight, options);
	  var timestampLeft = startOfWeekLeft.getTime() - (0, _index2.default)(startOfWeekLeft);
	  var timestampRight = startOfWeekRight.getTime() - (0, _index2.default)(startOfWeekRight);
	
	  // Round the number of days to the nearest integer
	  // because the number of milliseconds in a week is not constant
	  // (e.g. it's different in the week of the daylight saving time clock shift)
	  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_WEEK);
	}
	module.exports = exports.default;

/***/ },
/* 1090 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInCalendarYears;
	var _index = _interopRequireDefault(__webpack_require__(23));
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	/**
	 * @name differenceInCalendarYears
	 * @category Year Helpers
	 * @summary Get the number of calendar years between the given dates.
	 *
	 * @description
	 * Get the number of calendar years between the given dates.
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of calendar years
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many calendar years are between 31 December 2013 and 11 February 2015?
	 * const result = differenceInCalendarYears(
	 *   new Date(2015, 1, 11),
	 *   new Date(2013, 11, 31)
	 * )
	 * //=> 2
	 */
	function differenceInCalendarYears(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeft = (0, _index.default)(dirtyDateLeft);
	  var dateRight = (0, _index.default)(dirtyDateRight);
	  return dateLeft.getFullYear() - dateRight.getFullYear();
	}
	module.exports = exports.default;

/***/ },
/* 1091 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfDay;
	var _index = _interopRequireDefault(__webpack_require__(23));
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	/**
	 * @name endOfDay
	 * @category Day Helpers
	 * @summary Return the end of a day for the given date.
	 *
	 * @description
	 * Return the end of a day for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the end of a day
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The end of a day for 2 September 2014 11:55:00:
	 * const result = endOfDay(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Tue Sep 02 2014 23:59:59.999
	 */
	function endOfDay(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  date.setHours(23, 59, 59, 999);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 1092 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfMonth;
	var _index = _interopRequireDefault(__webpack_require__(23));
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	/**
	 * @name endOfMonth
	 * @category Month Helpers
	 * @summary Return the end of a month for the given date.
	 *
	 * @description
	 * Return the end of a month for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the end of a month
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The end of a month for 2 September 2014 11:55:00:
	 * const result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Tue Sep 30 2014 23:59:59.999
	 */
	function endOfMonth(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var month = date.getMonth();
	  date.setFullYear(date.getFullYear(), month + 1, 0);
	  date.setHours(23, 59, 59, 999);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 1093 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfWeek;
	var _index = __webpack_require__(96);
	var _index2 = _interopRequireDefault(__webpack_require__(23));
	var _index3 = _interopRequireDefault(__webpack_require__(30));
	var _index4 = _interopRequireDefault(__webpack_require__(14));
	/**
	 * @name endOfWeek
	 * @category Week Helpers
	 * @summary Return the end of a week for the given date.
	 *
	 * @description
	 * Return the end of a week for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|Number} date - the original date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Date} the end of a week
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 *
	 * @example
	 * // The end of a week for 2 September 2014 11:55:00:
	 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Sat Sep 06 2014 23:59:59.999
	 *
	 * @example
	 * // If the week starts on Monday, the end of the week for 2 September 2014 11:55:00:
	 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
	 * //=> Sun Sep 07 2014 23:59:59.999
	 */
	function endOfWeek(dirtyDate, options) {
	  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
	  (0, _index4.default)(1, arguments);
	  var defaultOptions = (0, _index.getDefaultOptions)();
	  var weekStartsOn = (0, _index3.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
	
	  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
	  }
	  var date = (0, _index2.default)(dirtyDate);
	  var day = date.getDay();
	  var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
	  date.setDate(date.getDate() + diff);
	  date.setHours(23, 59, 59, 999);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 1094 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = format;
	var _index = _interopRequireDefault(__webpack_require__(386));
	var _index2 = _interopRequireDefault(__webpack_require__(390));
	var _index3 = _interopRequireDefault(__webpack_require__(23));
	var _index4 = _interopRequireDefault(__webpack_require__(1079));
	var _index5 = _interopRequireDefault(__webpack_require__(375));
	var _index6 = _interopRequireDefault(__webpack_require__(189));
	var _index7 = __webpack_require__(379);
	var _index8 = _interopRequireDefault(__webpack_require__(30));
	var _index9 = _interopRequireDefault(__webpack_require__(14));
	var _index10 = __webpack_require__(96);
	var _index11 = _interopRequireDefault(__webpack_require__(374));
	// This RegExp consists of three parts separated by `|`:
	// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
	//   (one of the certain letters followed by `o`)
	// - (\w)\1* matches any sequences of the same letter
	// - '' matches two quote characters in a row
	// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
	//   except a single quote symbol, which ends the sequence.
	//   Two quote characters do not end the sequence.
	//   If there is no matching single quote
	//   then the sequence will continue until the end of the string.
	// - . matches any single character unmatched by previous parts of the RegExps
	var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
	
	// This RegExp catches symbols escaped by quotes, and also
	// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
	var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
	var escapedStringRegExp = /^'([^]*?)'?$/;
	var doubleQuoteRegExp = /''/g;
	var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
	
	/**
	 * @name format
	 * @category Common Helpers
	 * @summary Format the date.
	 *
	 * @description
	 * Return the formatted date string in the given format. The result may vary by locale.
	 *
	 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
	 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 *
	 * The characters wrapped between two single quotes characters (') are escaped.
	 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
	 * (see the last example)
	 *
	 * Format of the string is based on Unicode Technical Standard #35:
	 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
	 * with a few additions (see note 7 below the table).
	 *
	 * Accepted patterns:
	 * | Unit                            | Pattern | Result examples                   | Notes |
	 * |---------------------------------|---------|-----------------------------------|-------|
	 * | Era                             | G..GGG  | AD, BC                            |       |
	 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
	 * |                                 | GGGGG   | A, B                              |       |
	 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
	 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
	 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
	 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
	 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
	 * |                                 | yyyyy   | ...                               | 3,5   |
	 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
	 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
	 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
	 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
	 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
	 * |                                 | YYYYY   | ...                               | 3,5   |
	 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
	 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
	 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
	 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
	 * |                                 | RRRRR   | ...                               | 3,5,7 |
	 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
	 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
	 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
	 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
	 * |                                 | uuuuu   | ...                               | 3,5   |
	 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
	 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
	 * |                                 | QQ      | 01, 02, 03, 04                    |       |
	 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
	 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
	 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
	 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
	 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
	 * |                                 | qq      | 01, 02, 03, 04                    |       |
	 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
	 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
	 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
	 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
	 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
	 * |                                 | MM      | 01, 02, ..., 12                   |       |
	 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
	 * |                                 | MMMM    | January, February, ..., December  | 2     |
	 * |                                 | MMMMM   | J, F, ..., D                      |       |
	 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
	 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
	 * |                                 | LL      | 01, 02, ..., 12                   |       |
	 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
	 * |                                 | LLLL    | January, February, ..., December  | 2     |
	 * |                                 | LLLLL   | J, F, ..., D                      |       |
	 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
	 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
	 * |                                 | ww      | 01, 02, ..., 53                   |       |
	 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
	 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
	 * |                                 | II      | 01, 02, ..., 53                   | 7     |
	 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
	 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
	 * |                                 | dd      | 01, 02, ..., 31                   |       |
	 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
	 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
	 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
	 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
	 * |                                 | DDDD    | ...                               | 3     |
	 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
	 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
	 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
	 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
	 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
	 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
	 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
	 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
	 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
	 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
	 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
	 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
	 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
	 * |                                 | ee      | 02, 03, ..., 01                   |       |
	 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
	 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
	 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
	 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
	 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
	 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
	 * |                                 | cc      | 02, 03, ..., 01                   |       |
	 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
	 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
	 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
	 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
	 * | AM, PM                          | a..aa   | AM, PM                            |       |
	 * |                                 | aaa     | am, pm                            |       |
	 * |                                 | aaaa    | a.m., p.m.                        | 2     |
	 * |                                 | aaaaa   | a, p                              |       |
	 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
	 * |                                 | bbb     | am, pm, noon, midnight            |       |
	 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
	 * |                                 | bbbbb   | a, p, n, mi                       |       |
	 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
	 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
	 * |                                 | BBBBB   | at night, in the morning, ...     |       |
	 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
	 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
	 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
	 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
	 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
	 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
	 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
	 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
	 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
	 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
	 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
	 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
	 * | Minute                          | m       | 0, 1, ..., 59                     |       |
	 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
	 * |                                 | mm      | 00, 01, ..., 59                   |       |
	 * | Second                          | s       | 0, 1, ..., 59                     |       |
	 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
	 * |                                 | ss      | 00, 01, ..., 59                   |       |
	 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
	 * |                                 | SS      | 00, 01, ..., 99                   |       |
	 * |                                 | SSS     | 000, 001, ..., 999                |       |
	 * |                                 | SSSS    | ...                               | 3     |
	 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
	 * |                                 | XX      | -0800, +0530, Z                   |       |
	 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
	 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
	 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
	 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
	 * |                                 | xx      | -0800, +0530, +0000               |       |
	 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
	 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
	 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
	 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
	 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
	 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
	 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
	 * | Seconds timestamp               | t       | 512969520                         | 7     |
	 * |                                 | tt      | ...                               | 3,7   |
	 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
	 * |                                 | TT      | ...                               | 3,7   |
	 * | Long localized date             | P       | 04/29/1453                        | 7     |
	 * |                                 | PP      | Apr 29, 1453                      | 7     |
	 * |                                 | PPP     | April 29th, 1453                  | 7     |
	 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
	 * | Long localized time             | p       | 12:00 AM                          | 7     |
	 * |                                 | pp      | 12:00:00 AM                       | 7     |
	 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
	 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
	 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
	 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
	 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
	 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
	 * Notes:
	 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
	 *    are the same as "stand-alone" units, but are different in some languages.
	 *    "Formatting" units are declined according to the rules of the language
	 *    in the context of a date. "Stand-alone" units are always nominative singular:
	 *
	 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
	 *
	 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
	 *
	 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
	 *    the single quote characters (see below).
	 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
	 *    the output will be the same as default pattern for this unit, usually
	 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
	 *    are marked with "2" in the last column of the table.
	 *
	 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
	 *
	 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
	 *
	 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
	 *
	 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
	 *
	 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
	 *
	 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
	 *    The output will be padded with zeros to match the length of the pattern.
	 *
	 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
	 *
	 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
	 *    These tokens represent the shortest form of the quarter.
	 *
	 * 5. The main difference between `y` and `u` patterns are B.C. years:
	 *
	 *    | Year | `y` | `u` |
	 *    |------|-----|-----|
	 *    | AC 1 |   1 |   1 |
	 *    | BC 1 |   1 |   0 |
	 *    | BC 2 |   2 |  -1 |
	 *
	 *    Also `yy` always returns the last two digits of a year,
	 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
	 *
	 *    | Year | `yy` | `uu` |
	 *    |------|------|------|
	 *    | 1    |   01 |   01 |
	 *    | 14   |   14 |   14 |
	 *    | 376  |   76 |  376 |
	 *    | 1453 |   53 | 1453 |
	 *
	 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
	 *    except local week-numbering years are dependent on `options.weekStartsOn`
	 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
	 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
	 *
	 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
	 *    so right now these tokens fall back to GMT timezones.
	 *
	 * 7. These patterns are not in the Unicode Technical Standard #35:
	 *    - `i`: ISO day of week
	 *    - `I`: ISO week of year
	 *    - `R`: ISO week-numbering year
	 *    - `t`: seconds timestamp
	 *    - `T`: milliseconds timestamp
	 *    - `o`: ordinal number modifier
	 *    - `P`: long localized date
	 *    - `p`: long localized time
	 *
	 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
	 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 *
	 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
	 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 *
	 * @param {Date|Number} date - the original date
	 * @param {String} format - the string of tokens
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
	 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
	 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
	 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 * @returns {String} the formatted date string
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `date` must not be Invalid Date
	 * @throws {RangeError} `options.locale` must contain `localize` property
	 * @throws {RangeError} `options.locale` must contain `formatLong` property
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
	 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 * @throws {RangeError} format string contains an unescaped latin alphabet character
	 *
	 * @example
	 * // Represent 11 February 2014 in middle-endian format:
	 * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
	 * //=> '02/11/2014'
	 *
	 * @example
	 * // Represent 2 July 2014 in Esperanto:
	 * import { eoLocale } from 'date-fns/locale/eo'
	 * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
	 *   locale: eoLocale
	 * })
	 * //=> '2-a de julio 2014'
	 *
	 * @example
	 * // Escape string by single quote characters:
	 * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
	 * //=> "3 o'clock"
	 */
	
	function format(dirtyDate, dirtyFormatStr, options) {
	  var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
	  (0, _index9.default)(2, arguments);
	  var formatStr = String(dirtyFormatStr);
	  var defaultOptions = (0, _index10.getDefaultOptions)();
	  var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : _index11.default;
	  var firstWeekContainsDate = (0, _index8.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
	
	  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
	  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
	    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
	  }
	  var weekStartsOn = (0, _index8.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
	
	  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
	  }
	  if (!locale.localize) {
	    throw new RangeError('locale must contain localize property');
	  }
	  if (!locale.formatLong) {
	    throw new RangeError('locale must contain formatLong property');
	  }
	  var originalDate = (0, _index3.default)(dirtyDate);
	  if (!(0, _index.default)(originalDate)) {
	    throw new RangeError('Invalid time value');
	  }
	
	  // Convert the date in system timezone to the same date in UTC+00:00 timezone.
	  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
	  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
	  var timezoneOffset = (0, _index6.default)(originalDate);
	  var utcDate = (0, _index2.default)(originalDate, timezoneOffset);
	  var formatterOptions = {
	    firstWeekContainsDate: firstWeekContainsDate,
	    weekStartsOn: weekStartsOn,
	    locale: locale,
	    _originalDate: originalDate
	  };
	  var result = formatStr.match(longFormattingTokensRegExp).map(function (substring) {
	    var firstCharacter = substring[0];
	    if (firstCharacter === 'p' || firstCharacter === 'P') {
	      var longFormatter = _index5.default[firstCharacter];
	      return longFormatter(substring, locale.formatLong);
	    }
	    return substring;
	  }).join('').match(formattingTokensRegExp).map(function (substring) {
	    // Replace two single quote characters with one single quote character
	    if (substring === "''") {
	      return "'";
	    }
	    var firstCharacter = substring[0];
	    if (firstCharacter === "'") {
	      return cleanEscapedString(substring);
	    }
	    var formatter = _index4.default[firstCharacter];
	    if (formatter) {
	      if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, _index7.isProtectedWeekYearToken)(substring)) {
	        (0, _index7.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
	      }
	      if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, _index7.isProtectedDayOfYearToken)(substring)) {
	        (0, _index7.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
	      }
	      return formatter(utcDate, substring, locale.localize, formatterOptions);
	    }
	    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
	      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
	    }
	    return substring;
	  }).join('');
	  return result;
	}
	function cleanEscapedString(input) {
	  var matched = input.match(escapedStringRegExp);
	  if (!matched) {
	    return input;
	  }
	  return matched[1].replace(doubleQuoteRegExp, "'");
	}
	module.exports = exports.default;

/***/ },
/* 1095 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getDate;
	var _index = _interopRequireDefault(__webpack_require__(23));
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	/**
	 * @name getDate
	 * @category Day Helpers
	 * @summary Get the day of the month of the given date.
	 *
	 * @description
	 * Get the day of the month of the given date.
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the day of month
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which day of the month is 29 February 2012?
	 * const result = getDate(new Date(2012, 1, 29))
	 * //=> 29
	 */
	function getDate(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var dayOfMonth = date.getDate();
	  return dayOfMonth;
	}
	module.exports = exports.default;

/***/ },
/* 1096 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getDay;
	var _index = _interopRequireDefault(__webpack_require__(23));
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	/**
	 * @name getDay
	 * @category Weekday Helpers
	 * @summary Get the day of the week of the given date.
	 *
	 * @description
	 * Get the day of the week of the given date.
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {0|1|2|3|4|5|6} the day of week, 0 represents Sunday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which day of the week is 29 February 2012?
	 * const result = getDay(new Date(2012, 1, 29))
	 * //=> 3
	 */
	function getDay(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var day = date.getDay();
	  return day;
	}
	module.exports = exports.default;

/***/ },
/* 1097 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getDaysInMonth;
	var _index = _interopRequireDefault(__webpack_require__(23));
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	/**
	 * @name getDaysInMonth
	 * @category Month Helpers
	 * @summary Get the number of days in a month of the given date.
	 *
	 * @description
	 * Get the number of days in a month of the given date.
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the number of days in a month
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // How many days are in February 2000?
	 * const result = getDaysInMonth(new Date(2000, 1))
	 * //=> 29
	 */
	function getDaysInMonth(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var year = date.getFullYear();
	  var monthIndex = date.getMonth();
	  var lastDayOfMonth = new Date(0);
	  lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
	  lastDayOfMonth.setHours(0, 0, 0, 0);
	  return lastDayOfMonth.getDate();
	}
	module.exports = exports.default;

/***/ },
/* 1098 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getHours;
	var _index = _interopRequireDefault(__webpack_require__(23));
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	/**
	 * @name getHours
	 * @category Hour Helpers
	 * @summary Get the hours of the given date.
	 *
	 * @description
	 * Get the hours of the given date.
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the hours
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Get the hours of 29 February 2012 11:45:00:
	 * const result = getHours(new Date(2012, 1, 29, 11, 45))
	 * //=> 11
	 */
	function getHours(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var hours = date.getHours();
	  return hours;
	}
	module.exports = exports.default;

/***/ },
/* 1099 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getISOWeek;
	var _index = _interopRequireDefault(__webpack_require__(23));
	var _index2 = _interopRequireDefault(__webpack_require__(259));
	var _index3 = _interopRequireDefault(__webpack_require__(1166));
	var _index4 = _interopRequireDefault(__webpack_require__(14));
	var MILLISECONDS_IN_WEEK = 604800000;
	
	/**
	 * @name getISOWeek
	 * @category ISO Week Helpers
	 * @summary Get the ISO week of the given date.
	 *
	 * @description
	 * Get the ISO week of the given date.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the ISO week
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which week of the ISO-week numbering year is 2 January 2005?
	 * const result = getISOWeek(new Date(2005, 0, 2))
	 * //=> 53
	 */
	function getISOWeek(dirtyDate) {
	  (0, _index4.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var diff = (0, _index2.default)(date).getTime() - (0, _index3.default)(date).getTime();
	
	  // Round the number of days to the nearest integer
	  // because the number of milliseconds in a week is not constant
	  // (e.g. it's different in the week of the daylight saving time clock shift)
	  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
	}
	module.exports = exports.default;

/***/ },
/* 1100 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getISOWeekYear;
	var _index = _interopRequireDefault(__webpack_require__(23));
	var _index2 = _interopRequireDefault(__webpack_require__(259));
	var _index3 = _interopRequireDefault(__webpack_require__(14));
	/**
	 * @name getISOWeekYear
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Get the ISO week-numbering year of the given date.
	 *
	 * @description
	 * Get the ISO week-numbering year of the given date,
	 * which always starts 3 days before the year's first Thursday.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the ISO week-numbering year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which ISO-week numbering year is 2 January 2005?
	 * const result = getISOWeekYear(new Date(2005, 0, 2))
	 * //=> 2004
	 */
	function getISOWeekYear(dirtyDate) {
	  (0, _index3.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var year = date.getFullYear();
	  var fourthOfJanuaryOfNextYear = new Date(0);
	  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
	  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
	  var startOfNextYear = (0, _index2.default)(fourthOfJanuaryOfNextYear);
	  var fourthOfJanuaryOfThisYear = new Date(0);
	  fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
	  fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
	  var startOfThisYear = (0, _index2.default)(fourthOfJanuaryOfThisYear);
	  if (date.getTime() >= startOfNextYear.getTime()) {
	    return year + 1;
	  } else if (date.getTime() >= startOfThisYear.getTime()) {
	    return year;
	  } else {
	    return year - 1;
	  }
	}
	module.exports = exports.default;

/***/ },
/* 1101 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getMinutes;
	var _index = _interopRequireDefault(__webpack_require__(23));
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	/**
	 * @name getMinutes
	 * @category Minute Helpers
	 * @summary Get the minutes of the given date.
	 *
	 * @description
	 * Get the minutes of the given date.
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the minutes
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Get the minutes of 29 February 2012 11:45:05:
	 * const result = getMinutes(new Date(2012, 1, 29, 11, 45, 5))
	 * //=> 45
	 */
	function getMinutes(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var minutes = date.getMinutes();
	  return minutes;
	}
	module.exports = exports.default;

/***/ },
/* 1102 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getMonth;
	var _index = _interopRequireDefault(__webpack_require__(23));
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	/**
	 * @name getMonth
	 * @category Month Helpers
	 * @summary Get the month of the given date.
	 *
	 * @description
	 * Get the month of the given date.
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the month
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which month is 29 February 2012?
	 * const result = getMonth(new Date(2012, 1, 29))
	 * //=> 1
	 */
	function getMonth(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var month = date.getMonth();
	  return month;
	}
	module.exports = exports.default;

/***/ },
/* 1103 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getQuarter;
	var _index = _interopRequireDefault(__webpack_require__(23));
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	/**
	 * @name getQuarter
	 * @category Quarter Helpers
	 * @summary Get the year quarter of the given date.
	 *
	 * @description
	 * Get the year quarter of the given date.
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the quarter
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which quarter is 2 July 2014?
	 * const result = getQuarter(new Date(2014, 6, 2))
	 * //=> 3
	 */
	function getQuarter(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var quarter = Math.floor(date.getMonth() / 3) + 1;
	  return quarter;
	}
	module.exports = exports.default;

/***/ },
/* 1104 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getSeconds;
	var _index = _interopRequireDefault(__webpack_require__(23));
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	/**
	 * @name getSeconds
	 * @category Second Helpers
	 * @summary Get the seconds of the given date.
	 *
	 * @description
	 * Get the seconds of the given date.
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the seconds
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Get the seconds of 29 February 2012 11:45:05.123:
	 * const result = getSeconds(new Date(2012, 1, 29, 11, 45, 5, 123))
	 * //=> 5
	 */
	function getSeconds(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var seconds = date.getSeconds();
	  return seconds;
	}
	module.exports = exports.default;

/***/ },
/* 1105 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getTime;
	var _index = _interopRequireDefault(__webpack_require__(23));
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	/**
	 * @name getTime
	 * @category Timestamp Helpers
	 * @summary Get the milliseconds timestamp of the given date.
	 *
	 * @description
	 * Get the milliseconds timestamp of the given date.
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the timestamp
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Get the timestamp of 29 February 2012 11:45:05.123:
	 * const result = getTime(new Date(2012, 1, 29, 11, 45, 5, 123))
	 * //=> 1330515905123
	 */
	function getTime(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var timestamp = date.getTime();
	  return timestamp;
	}
	module.exports = exports.default;

/***/ },
/* 1106 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getYear;
	var _index = _interopRequireDefault(__webpack_require__(23));
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	/**
	 * @name getYear
	 * @category Year Helpers
	 * @summary Get the year of the given date.
	 *
	 * @description
	 * Get the year of the given date.
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which year is 2 July 2014?
	 * const result = getYear(new Date(2014, 6, 2))
	 * //=> 2014
	 */
	function getYear(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate).getFullYear();
	}
	module.exports = exports.default;

/***/ },
/* 1107 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isAfter;
	var _index = _interopRequireDefault(__webpack_require__(23));
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	/**
	 * @name isAfter
	 * @category Common Helpers
	 * @summary Is the first date after the second one?
	 *
	 * @description
	 * Is the first date after the second one?
	 *
	 * @param {Date|Number} date - the date that should be after the other one to return true
	 * @param {Date|Number} dateToCompare - the date to compare with
	 * @returns {Boolean} the first date is after the second date
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Is 10 July 1989 after 11 February 1987?
	 * const result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
	 * //=> true
	 */
	function isAfter(dirtyDate, dirtyDateToCompare) {
	  (0, _index2.default)(2, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var dateToCompare = (0, _index.default)(dirtyDateToCompare);
	  return date.getTime() > dateToCompare.getTime();
	}
	module.exports = exports.default;

/***/ },
/* 1108 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isBefore;
	var _index = _interopRequireDefault(__webpack_require__(23));
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	/**
	 * @name isBefore
	 * @category Common Helpers
	 * @summary Is the first date before the second one?
	 *
	 * @description
	 * Is the first date before the second one?
	 *
	 * @param {Date|Number} date - the date that should be before the other one to return true
	 * @param {Date|Number} dateToCompare - the date to compare with
	 * @returns {Boolean} the first date is before the second date
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Is 10 July 1989 before 11 February 1987?
	 * const result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
	 * //=> false
	 */
	function isBefore(dirtyDate, dirtyDateToCompare) {
	  (0, _index2.default)(2, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var dateToCompare = (0, _index.default)(dirtyDateToCompare);
	  return date.getTime() < dateToCompare.getTime();
	}
	module.exports = exports.default;

/***/ },
/* 1109 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isEqual;
	var _index = _interopRequireDefault(__webpack_require__(23));
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	/**
	 * @name isEqual
	 * @category Common Helpers
	 * @summary Are the given dates equal?
	 *
	 * @description
	 * Are the given dates equal?
	 *
	 * @param {Date|Number} dateLeft - the first date to compare
	 * @param {Date|Number} dateRight - the second date to compare
	 * @returns {Boolean} the dates are equal
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Are 2 July 2014 06:30:45.000 and 2 July 2014 06:30:45.500 equal?
	 * const result = isEqual(
	 *   new Date(2014, 6, 2, 6, 30, 45, 0),
	 *   new Date(2014, 6, 2, 6, 30, 45, 500)
	 * )
	 * //=> false
	 */
	function isEqual(dirtyLeftDate, dirtyRightDate) {
	  (0, _index2.default)(2, arguments);
	  var dateLeft = (0, _index.default)(dirtyLeftDate);
	  var dateRight = (0, _index.default)(dirtyRightDate);
	  return dateLeft.getTime() === dateRight.getTime();
	}
	module.exports = exports.default;

/***/ },
/* 1110 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSameDay;
	var _index = _interopRequireDefault(__webpack_require__(258));
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	/**
	 * @name isSameDay
	 * @category Day Helpers
	 * @summary Are the given dates in the same day (and year and month)?
	 *
	 * @description
	 * Are the given dates in the same day (and year and month)?
	 *
	 * @param {Date|Number} dateLeft - the first date to check
	 * @param {Date|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same day (and year and month)
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
	 * const result = isSameDay(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 18, 0))
	 * //=> true
	 *
	 * @example
	 * // Are 4 September and 4 October in the same day?
	 * const result = isSameDay(new Date(2014, 8, 4), new Date(2014, 9, 4))
	 * //=> false
	 *
	 * @example
	 * // Are 4 September, 2014 and 4 September, 2015 in the same day?
	 * const result = isSameDay(new Date(2014, 8, 4), new Date(2015, 8, 4))
	 * //=> false
	 */
	function isSameDay(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeftStartOfDay = (0, _index.default)(dirtyDateLeft);
	  var dateRightStartOfDay = (0, _index.default)(dirtyDateRight);
	  return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
	}
	module.exports = exports.default;

/***/ },
/* 1111 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSameMonth;
	var _index = _interopRequireDefault(__webpack_require__(23));
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	/**
	 * @name isSameMonth
	 * @category Month Helpers
	 * @summary Are the given dates in the same month (and year)?
	 *
	 * @description
	 * Are the given dates in the same month (and year)?
	 *
	 * @param {Date|Number} dateLeft - the first date to check
	 * @param {Date|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same month (and year)
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Are 2 September 2014 and 25 September 2014 in the same month?
	 * const result = isSameMonth(new Date(2014, 8, 2), new Date(2014, 8, 25))
	 * //=> true
	 *
	 * @example
	 * // Are 2 September 2014 and 25 September 2015 in the same month?
	 * const result = isSameMonth(new Date(2014, 8, 2), new Date(2015, 8, 25))
	 * //=> false
	 */
	function isSameMonth(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeft = (0, _index.default)(dirtyDateLeft);
	  var dateRight = (0, _index.default)(dirtyDateRight);
	  return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
	}
	module.exports = exports.default;

/***/ },
/* 1112 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSameQuarter;
	var _index = _interopRequireDefault(__webpack_require__(389));
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	/**
	 * @name isSameQuarter
	 * @category Quarter Helpers
	 * @summary Are the given dates in the same quarter (and year)?
	 *
	 * @description
	 * Are the given dates in the same quarter (and year)?
	 *
	 * @param {Date|Number} dateLeft - the first date to check
	 * @param {Date|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same quarter (and year)
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Are 1 January 2014 and 8 March 2014 in the same quarter?
	 * const result = isSameQuarter(new Date(2014, 0, 1), new Date(2014, 2, 8))
	 * //=> true
	 *
	 * @example
	 * // Are 1 January 2014 and 1 January 2015 in the same quarter?
	 * const result = isSameQuarter(new Date(2014, 0, 1), new Date(2015, 0, 1))
	 * //=> false
	 */
	function isSameQuarter(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeftStartOfQuarter = (0, _index.default)(dirtyDateLeft);
	  var dateRightStartOfQuarter = (0, _index.default)(dirtyDateRight);
	  return dateLeftStartOfQuarter.getTime() === dateRightStartOfQuarter.getTime();
	}
	module.exports = exports.default;

/***/ },
/* 1113 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSameYear;
	var _index = _interopRequireDefault(__webpack_require__(23));
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	/**
	 * @name isSameYear
	 * @category Year Helpers
	 * @summary Are the given dates in the same year?
	 *
	 * @description
	 * Are the given dates in the same year?
	 *
	 * @param {Date|Number} dateLeft - the first date to check
	 * @param {Date|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same year
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Are 2 September 2014 and 25 September 2014 in the same year?
	 * const result = isSameYear(new Date(2014, 8, 2), new Date(2014, 8, 25))
	 * //=> true
	 */
	function isSameYear(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeft = (0, _index.default)(dirtyDateLeft);
	  var dateRight = (0, _index.default)(dirtyDateRight);
	  return dateLeft.getFullYear() === dateRight.getFullYear();
	}
	module.exports = exports.default;

/***/ },
/* 1114 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isWithinInterval;
	var _index = _interopRequireDefault(__webpack_require__(23));
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	/**
	 * @name isWithinInterval
	 * @category Interval Helpers
	 * @summary Is the given date within the interval?
	 *
	 * @description
	 * Is the given date within the interval? (Including start and end.)
	 *
	 * @param {Date|Number} date - the date to check
	 * @param {Interval} interval - the interval to check
	 * @returns {Boolean} the date is within the interval
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} The start of an interval cannot be after its end
	 * @throws {RangeError} Date in interval cannot be `Invalid Date`
	 *
	 * @example
	 * // For the date within the interval:
	 * isWithinInterval(new Date(2014, 0, 3), {
	 *   start: new Date(2014, 0, 1),
	 *   end: new Date(2014, 0, 7)
	 * })
	 * //=> true
	 *
	 * @example
	 * // For the date outside of the interval:
	 * isWithinInterval(new Date(2014, 0, 10), {
	 *   start: new Date(2014, 0, 1),
	 *   end: new Date(2014, 0, 7)
	 * })
	 * //=> false
	 *
	 * @example
	 * // For date equal to interval start:
	 * isWithinInterval(date, { start, end: date }) // => true
	 *
	 * @example
	 * // For date equal to interval end:
	 * isWithinInterval(date, { start: date, end }) // => true
	 */
	function isWithinInterval(dirtyDate, interval) {
	  (0, _index2.default)(2, arguments);
	  var time = (0, _index.default)(dirtyDate).getTime();
	  var startTime = (0, _index.default)(interval.start).getTime();
	  var endTime = (0, _index.default)(interval.end).getTime();
	
	  // Throw an exception if start date is after end date or if any date is `Invalid Date`
	  if (!(startTime <= endTime)) {
	    throw new RangeError('Invalid interval');
	  }
	  return time >= startTime && time <= endTime;
	}
	module.exports = exports.default;

/***/ },
/* 1115 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = buildFormatLongFn;
	function buildFormatLongFn(args) {
	  return function () {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    // TODO: Remove String()
	    var width = options.width ? String(options.width) : args.defaultWidth;
	    var format = args.formats[width] || args.formats[args.defaultWidth];
	    return format;
	  };
	}
	module.exports = exports.default;

/***/ },
/* 1116 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = buildLocalizeFn;
	function buildLocalizeFn(args) {
	  return function (dirtyIndex, options) {
	    var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
	    var valuesArray;
	    if (context === 'formatting' && args.formattingValues) {
	      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
	      var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
	      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
	    } else {
	      var _defaultWidth = args.defaultWidth;
	      var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
	      valuesArray = args.values[_width] || args.values[_defaultWidth];
	    }
	    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
	    // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
	    return valuesArray[index];
	  };
	}
	module.exports = exports.default;

/***/ },
/* 1117 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = buildMatchFn;
	function buildMatchFn(args) {
	  return function (string) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var width = options.width;
	    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
	    var matchResult = string.match(matchPattern);
	    if (!matchResult) {
	      return null;
	    }
	    var matchedString = matchResult[0];
	    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
	    var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function (pattern) {
	      return pattern.test(matchedString);
	    }) : findKey(parsePatterns, function (pattern) {
	      return pattern.test(matchedString);
	    });
	    var value;
	    value = args.valueCallback ? args.valueCallback(key) : key;
	    value = options.valueCallback ? options.valueCallback(value) : value;
	    var rest = string.slice(matchedString.length);
	    return {
	      value: value,
	      rest: rest
	    };
	  };
	}
	function findKey(object, predicate) {
	  for (var key in object) {
	    if (object.hasOwnProperty(key) && predicate(object[key])) {
	      return key;
	    }
	  }
	  return undefined;
	}
	function findIndex(array, predicate) {
	  for (var key = 0; key < array.length; key++) {
	    if (predicate(array[key])) {
	      return key;
	    }
	  }
	  return undefined;
	}
	module.exports = exports.default;

/***/ },
/* 1118 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = buildMatchPatternFn;
	function buildMatchPatternFn(args) {
	  return function (string) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var matchResult = string.match(args.matchPattern);
	    if (!matchResult) return null;
	    var matchedString = matchResult[0];
	    var parseResult = string.match(args.parsePattern);
	    if (!parseResult) return null;
	    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
	    value = options.valueCallback ? options.valueCallback(value) : value;
	    var rest = string.slice(matchedString.length);
	    return {
	      value: value,
	      rest: rest
	    };
	  };
	}
	module.exports = exports.default;

/***/ },
/* 1119 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'less than a second',
	    other: 'less than {{count}} seconds'
	  },
	  xSeconds: {
	    one: '1 second',
	    other: '{{count}} seconds'
	  },
	  halfAMinute: 'half a minute',
	  lessThanXMinutes: {
	    one: 'less than a minute',
	    other: 'less than {{count}} minutes'
	  },
	  xMinutes: {
	    one: '1 minute',
	    other: '{{count}} minutes'
	  },
	  aboutXHours: {
	    one: 'about 1 hour',
	    other: 'about {{count}} hours'
	  },
	  xHours: {
	    one: '1 hour',
	    other: '{{count}} hours'
	  },
	  xDays: {
	    one: '1 day',
	    other: '{{count}} days'
	  },
	  aboutXWeeks: {
	    one: 'about 1 week',
	    other: 'about {{count}} weeks'
	  },
	  xWeeks: {
	    one: '1 week',
	    other: '{{count}} weeks'
	  },
	  aboutXMonths: {
	    one: 'about 1 month',
	    other: 'about {{count}} months'
	  },
	  xMonths: {
	    one: '1 month',
	    other: '{{count}} months'
	  },
	  aboutXYears: {
	    one: 'about 1 year',
	    other: 'about {{count}} years'
	  },
	  xYears: {
	    one: '1 year',
	    other: '{{count}} years'
	  },
	  overXYears: {
	    one: 'over 1 year',
	    other: 'over {{count}} years'
	  },
	  almostXYears: {
	    one: 'almost 1 year',
	    other: 'almost {{count}} years'
	  }
	};
	var formatDistance = function formatDistance(token, count, options) {
	  var result;
	  var tokenValue = formatDistanceLocale[token];
	  if (typeof tokenValue === 'string') {
	    result = tokenValue;
	  } else if (count === 1) {
	    result = tokenValue.one;
	  } else {
	    result = tokenValue.other.replace('{{count}}', count.toString());
	  }
	  if (options !== null && options !== void 0 && options.addSuffix) {
	    if (options.comparison && options.comparison > 0) {
	      return 'in ' + result;
	    } else {
	      return result + ' ago';
	    }
	  }
	  return result;
	};
	var _default = formatDistance;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1120 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _index = _interopRequireDefault(__webpack_require__(1115));
	var dateFormats = {
	  full: 'EEEE, MMMM do, y',
	  long: 'MMMM do, y',
	  medium: 'MMM d, y',
	  short: 'MM/dd/yyyy'
	};
	var timeFormats = {
	  full: 'h:mm:ss a zzzz',
	  long: 'h:mm:ss a z',
	  medium: 'h:mm:ss a',
	  short: 'h:mm a'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'at' {{time}}",
	  long: "{{date}} 'at' {{time}}",
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1121 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var formatRelativeLocale = {
	  lastWeek: "'last' eeee 'at' p",
	  yesterday: "'yesterday at' p",
	  today: "'today at' p",
	  tomorrow: "'tomorrow at' p",
	  nextWeek: "eeee 'at' p",
	  other: 'P'
	};
	var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	};
	var _default = formatRelative;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1122 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _index = _interopRequireDefault(__webpack_require__(1116));
	var eraValues = {
	  narrow: ['B', 'A'],
	  abbreviated: ['BC', 'AD'],
	  wide: ['Before Christ', 'Anno Domini']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
	  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter']
	};
	
	// Note: in English, the names of days of the week and months are capitalized.
	// If you are making a new locale based on this one, check if the same is true for the language you're working on.
	// Generally, formatted dates should look like they are in the middle of a sentence,
	// e.g. in Spanish language the weekdays and months should be in the lowercase.
	var monthValues = {
	  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
	  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
	  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
	};
	var dayValues = {
	  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
	  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
	  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
	  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'a',
	    pm: 'p',
	    midnight: 'mi',
	    noon: 'n',
	    morning: 'morning',
	    afternoon: 'afternoon',
	    evening: 'evening',
	    night: 'night'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'midnight',
	    noon: 'noon',
	    morning: 'morning',
	    afternoon: 'afternoon',
	    evening: 'evening',
	    night: 'night'
	  },
	  wide: {
	    am: 'a.m.',
	    pm: 'p.m.',
	    midnight: 'midnight',
	    noon: 'noon',
	    morning: 'morning',
	    afternoon: 'afternoon',
	    evening: 'evening',
	    night: 'night'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'a',
	    pm: 'p',
	    midnight: 'mi',
	    noon: 'n',
	    morning: 'in the morning',
	    afternoon: 'in the afternoon',
	    evening: 'in the evening',
	    night: 'at night'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'midnight',
	    noon: 'noon',
	    morning: 'in the morning',
	    afternoon: 'in the afternoon',
	    evening: 'in the evening',
	    night: 'at night'
	  },
	  wide: {
	    am: 'a.m.',
	    pm: 'p.m.',
	    midnight: 'midnight',
	    noon: 'noon',
	    morning: 'in the morning',
	    afternoon: 'in the afternoon',
	    evening: 'in the evening',
	    night: 'at night'
	  }
	};
	var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
	  var number = Number(dirtyNumber);
	
	  // If ordinal numbers depend on context, for example,
	  // if they are different for different grammatical genders,
	  // use `options.unit`.
	  //
	  // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
	  // 'day', 'hour', 'minute', 'second'.
	
	  var rem100 = number % 100;
	  if (rem100 > 20 || rem100 < 10) {
	    switch (rem100 % 10) {
	      case 1:
	        return number + 'st';
	      case 2:
	        return number + 'nd';
	      case 3:
	        return number + 'rd';
	    }
	  }
	  return number + 'th';
	};
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function argumentCallback(quarter) {
	      return quarter - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1123 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _index = _interopRequireDefault(__webpack_require__(1117));
	var _index2 = _interopRequireDefault(__webpack_require__(1118));
	var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(b|a)/i,
	  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
	  wide: /^(before christ|before common era|anno domini|common era)/i
	};
	var parseEraPatterns = {
	  any: [/^b/i, /^(a|c)/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^q[1234]/i,
	  wide: /^[1234](th|st|nd|rd)? quarter/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[jfmasond]/i,
	  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
	  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
	  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
	};
	var matchDayPatterns = {
	  narrow: /^[smtwf]/i,
	  short: /^(su|mo|tu|we|th|fr|sa)/i,
	  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
	  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
	};
	var parseDayPatterns = {
	  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
	  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
	  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^a/i,
	    pm: /^p/i,
	    midnight: /^mi/i,
	    noon: /^no/i,
	    morning: /morning/i,
	    afternoon: /afternoon/i,
	    evening: /evening/i,
	    night: /night/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index2.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function valueCallback(value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function valueCallback(index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1124 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _index = _interopRequireDefault(__webpack_require__(1119));
	var _index2 = _interopRequireDefault(__webpack_require__(1120));
	var _index3 = _interopRequireDefault(__webpack_require__(1121));
	var _index4 = _interopRequireDefault(__webpack_require__(1122));
	var _index5 = _interopRequireDefault(__webpack_require__(1123));
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary English locale (United States).
	 * @language English
	 * @iso-639-2 eng
	 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
	 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
	 */
	var locale = {
	  code: 'en-US',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 0 /* Sunday */,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1125 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = max;
	var _typeof2 = _interopRequireDefault(__webpack_require__(56));
	var _index = _interopRequireDefault(__webpack_require__(23));
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	/**
	 * @name max
	 * @category Common Helpers
	 * @summary Return the latest of the given dates.
	 *
	 * @description
	 * Return the latest of the given dates.
	 *
	 * @param {Date[]|Number[]} datesArray - the dates to compare
	 * @returns {Date} the latest of the dates
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which of these dates is the latest?
	 * const result = max([
	 *   new Date(1989, 6, 10),
	 *   new Date(1987, 1, 11),
	 *   new Date(1995, 6, 2),
	 *   new Date(1990, 0, 1)
	 * ])
	 * //=> Sun Jul 02 1995 00:00:00
	 */
	function max(dirtyDatesArray) {
	  (0, _index2.default)(1, arguments);
	  var datesArray;
	  // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
	  if (dirtyDatesArray && typeof dirtyDatesArray.forEach === 'function') {
	    datesArray = dirtyDatesArray;
	
	    // If `dirtyDatesArray` is Array-like Object, convert to Array.
	  } else if ((0, _typeof2.default)(dirtyDatesArray) === 'object' && dirtyDatesArray !== null) {
	    datesArray = Array.prototype.slice.call(dirtyDatesArray);
	  } else {
	    // `dirtyDatesArray` is non-iterable, return Invalid Date
	    return new Date(NaN);
	  }
	  var result;
	  datesArray.forEach(function (dirtyDate) {
	    var currentDate = (0, _index.default)(dirtyDate);
	    if (result === undefined || result < currentDate || isNaN(Number(currentDate))) {
	      result = currentDate;
	    }
	  });
	  return result || new Date(NaN);
	}
	module.exports = exports.default;

/***/ },
/* 1126 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = min;
	var _typeof2 = _interopRequireDefault(__webpack_require__(56));
	var _index = _interopRequireDefault(__webpack_require__(23));
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	/**
	 * @name min
	 * @category Common Helpers
	 * @summary Returns the earliest of the given dates.
	 *
	 * @description
	 * Returns the earliest of the given dates.
	 *
	 * @param {Date[]|Number[]} datesArray - the dates to compare
	 * @returns {Date} - the earliest of the dates
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which of these dates is the earliest?
	 * const result = min([
	 *   new Date(1989, 6, 10),
	 *   new Date(1987, 1, 11),
	 *   new Date(1995, 6, 2),
	 *   new Date(1990, 0, 1)
	 * ])
	 * //=> Wed Feb 11 1987 00:00:00
	 */
	function min(dirtyDatesArray) {
	  (0, _index2.default)(1, arguments);
	  var datesArray;
	  // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
	  if (dirtyDatesArray && typeof dirtyDatesArray.forEach === 'function') {
	    datesArray = dirtyDatesArray;
	    // If `dirtyDatesArray` is Array-like Object, convert to Array.
	  } else if ((0, _typeof2.default)(dirtyDatesArray) === 'object' && dirtyDatesArray !== null) {
	    datesArray = Array.prototype.slice.call(dirtyDatesArray);
	  } else {
	    // `dirtyDatesArray` is non-iterable, return Invalid Date
	    return new Date(NaN);
	  }
	  var result;
	  datesArray.forEach(function (dirtyDate) {
	    var currentDate = (0, _index.default)(dirtyDate);
	    if (result === undefined || result > currentDate || isNaN(currentDate.getDate())) {
	      result = currentDate;
	    }
	  });
	  return result || new Date(NaN);
	}
	module.exports = exports.default;

/***/ },
/* 1127 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AMPMMidnightParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	var _createClass2 = _interopRequireDefault(__webpack_require__(19));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(12));
	var _inherits2 = _interopRequireDefault(__webpack_require__(22));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(29));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(24));
	var _Parser2 = __webpack_require__(31);
	var _utils = __webpack_require__(35);
	var AMPMMidnightParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(AMPMMidnightParser, _Parser);
	  var _super = (0, _createSuper2.default)(AMPMMidnightParser);
	  function AMPMMidnightParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, AMPMMidnightParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 80);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['a', 'B', 'H', 'k', 't', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(AMPMMidnightParser, [{
	    key: "parse",
	    value: function parse(dateString, token, match) {
	      switch (token) {
	        case 'b':
	        case 'bb':
	        case 'bbb':
	          return match.dayPeriod(dateString, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.dayPeriod(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        case 'bbbbb':
	          return match.dayPeriod(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        case 'bbbb':
	        default:
	          return match.dayPeriod(dateString, {
	            width: 'wide',
	            context: 'formatting'
	          }) || match.dayPeriod(dateString, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.dayPeriod(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	      }
	    }
	  }, {
	    key: "set",
	    value: function set(date, _flags, value) {
	      date.setUTCHours((0, _utils.dayPeriodEnumToHours)(value), 0, 0, 0);
	      return date;
	    }
	  }]);
	  return AMPMMidnightParser;
	}(_Parser2.Parser);
	exports.AMPMMidnightParser = AMPMMidnightParser;

/***/ },
/* 1128 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AMPMParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	var _createClass2 = _interopRequireDefault(__webpack_require__(19));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(12));
	var _inherits2 = _interopRequireDefault(__webpack_require__(22));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(29));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(24));
	var _Parser2 = __webpack_require__(31);
	var _utils = __webpack_require__(35);
	var AMPMParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(AMPMParser, _Parser);
	  var _super = (0, _createSuper2.default)(AMPMParser);
	  function AMPMParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, AMPMParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 80);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['b', 'B', 'H', 'k', 't', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(AMPMParser, [{
	    key: "parse",
	    value: function parse(dateString, token, match) {
	      switch (token) {
	        case 'a':
	        case 'aa':
	        case 'aaa':
	          return match.dayPeriod(dateString, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.dayPeriod(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        case 'aaaaa':
	          return match.dayPeriod(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        case 'aaaa':
	        default:
	          return match.dayPeriod(dateString, {
	            width: 'wide',
	            context: 'formatting'
	          }) || match.dayPeriod(dateString, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.dayPeriod(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	      }
	    }
	  }, {
	    key: "set",
	    value: function set(date, _flags, value) {
	      date.setUTCHours((0, _utils.dayPeriodEnumToHours)(value), 0, 0, 0);
	      return date;
	    }
	  }]);
	  return AMPMParser;
	}(_Parser2.Parser);
	exports.AMPMParser = AMPMParser;

/***/ },
/* 1129 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DateParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	var _createClass2 = _interopRequireDefault(__webpack_require__(19));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(12));
	var _inherits2 = _interopRequireDefault(__webpack_require__(22));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(29));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(24));
	var _utils = __webpack_require__(35);
	var _Parser2 = __webpack_require__(31);
	var _constants = __webpack_require__(57);
	var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
	var DAYS_IN_MONTH_LEAP_YEAR = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
	
	// Day of the month
	var DateParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(DateParser, _Parser);
	  var _super = (0, _createSuper2.default)(DateParser);
	  function DateParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, DateParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 90);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "subPriority", 1);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['Y', 'R', 'q', 'Q', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(DateParser, [{
	    key: "parse",
	    value: function parse(dateString, token, match) {
	      switch (token) {
	        case 'd':
	          return (0, _utils.parseNumericPattern)(_constants.numericPatterns.date, dateString);
	        case 'do':
	          return match.ordinalNumber(dateString, {
	            unit: 'date'
	          });
	        default:
	          return (0, _utils.parseNDigits)(token.length, dateString);
	      }
	    }
	  }, {
	    key: "validate",
	    value: function validate(date, value) {
	      var year = date.getUTCFullYear();
	      var isLeapYear = (0, _utils.isLeapYearIndex)(year);
	      var month = date.getUTCMonth();
	      if (isLeapYear) {
	        return value >= 1 && value <= DAYS_IN_MONTH_LEAP_YEAR[month];
	      } else {
	        return value >= 1 && value <= DAYS_IN_MONTH[month];
	      }
	    }
	  }, {
	    key: "set",
	    value: function set(date, _flags, value) {
	      date.setUTCDate(value);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    }
	  }]);
	  return DateParser;
	}(_Parser2.Parser);
	exports.DateParser = DateParser;

/***/ },
/* 1130 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DayOfYearParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	var _createClass2 = _interopRequireDefault(__webpack_require__(19));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(12));
	var _inherits2 = _interopRequireDefault(__webpack_require__(22));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(29));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(24));
	var _Parser2 = __webpack_require__(31);
	var _constants = __webpack_require__(57);
	var _utils = __webpack_require__(35);
	var DayOfYearParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(DayOfYearParser, _Parser);
	  var _super = (0, _createSuper2.default)(DayOfYearParser);
	  function DayOfYearParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, DayOfYearParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 90);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "subpriority", 1);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['Y', 'R', 'q', 'Q', 'M', 'L', 'w', 'I', 'd', 'E', 'i', 'e', 'c', 't', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(DayOfYearParser, [{
	    key: "parse",
	    value: function parse(dateString, token, match) {
	      switch (token) {
	        case 'D':
	        case 'DD':
	          return (0, _utils.parseNumericPattern)(_constants.numericPatterns.dayOfYear, dateString);
	        case 'Do':
	          return match.ordinalNumber(dateString, {
	            unit: 'date'
	          });
	        default:
	          return (0, _utils.parseNDigits)(token.length, dateString);
	      }
	    }
	  }, {
	    key: "validate",
	    value: function validate(date, value) {
	      var year = date.getUTCFullYear();
	      var isLeapYear = (0, _utils.isLeapYearIndex)(year);
	      if (isLeapYear) {
	        return value >= 1 && value <= 366;
	      } else {
	        return value >= 1 && value <= 365;
	      }
	    }
	  }, {
	    key: "set",
	    value: function set(date, _flags, value) {
	      date.setUTCMonth(0, value);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    }
	  }]);
	  return DayOfYearParser;
	}(_Parser2.Parser);
	exports.DayOfYearParser = DayOfYearParser;

/***/ },
/* 1131 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DayParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	var _createClass2 = _interopRequireDefault(__webpack_require__(19));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(12));
	var _inherits2 = _interopRequireDefault(__webpack_require__(22));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(29));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(24));
	var _Parser2 = __webpack_require__(31);
	var _index = _interopRequireDefault(__webpack_require__(254));
	// Day of week
	var DayParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(DayParser, _Parser);
	  var _super = (0, _createSuper2.default)(DayParser);
	  function DayParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, DayParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 90);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['D', 'i', 'e', 'c', 't', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(DayParser, [{
	    key: "parse",
	    value: function parse(dateString, token, match) {
	      switch (token) {
	        // Tue
	        case 'E':
	        case 'EE':
	        case 'EEE':
	          return match.day(dateString, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.day(dateString, {
	            width: 'short',
	            context: 'formatting'
	          }) || match.day(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // T
	        case 'EEEEE':
	          return match.day(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // Tu
	        case 'EEEEEE':
	          return match.day(dateString, {
	            width: 'short',
	            context: 'formatting'
	          }) || match.day(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // Tuesday
	        case 'EEEE':
	        default:
	          return match.day(dateString, {
	            width: 'wide',
	            context: 'formatting'
	          }) || match.day(dateString, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.day(dateString, {
	            width: 'short',
	            context: 'formatting'
	          }) || match.day(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	      }
	    }
	  }, {
	    key: "validate",
	    value: function validate(_date, value) {
	      return value >= 0 && value <= 6;
	    }
	  }, {
	    key: "set",
	    value: function set(date, _flags, value, options) {
	      date = (0, _index.default)(date, value, options);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    }
	  }]);
	  return DayParser;
	}(_Parser2.Parser);
	exports.DayParser = DayParser;

/***/ },
/* 1132 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DayPeriodParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	var _createClass2 = _interopRequireDefault(__webpack_require__(19));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(12));
	var _inherits2 = _interopRequireDefault(__webpack_require__(22));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(29));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(24));
	var _Parser2 = __webpack_require__(31);
	var _utils = __webpack_require__(35);
	// in the morning, in the afternoon, in the evening, at night
	var DayPeriodParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(DayPeriodParser, _Parser);
	  var _super = (0, _createSuper2.default)(DayPeriodParser);
	  function DayPeriodParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, DayPeriodParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 80);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['a', 'b', 't', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(DayPeriodParser, [{
	    key: "parse",
	    value: function parse(dateString, token, match) {
	      switch (token) {
	        case 'B':
	        case 'BB':
	        case 'BBB':
	          return match.dayPeriod(dateString, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.dayPeriod(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        case 'BBBBB':
	          return match.dayPeriod(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        case 'BBBB':
	        default:
	          return match.dayPeriod(dateString, {
	            width: 'wide',
	            context: 'formatting'
	          }) || match.dayPeriod(dateString, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.dayPeriod(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	      }
	    }
	  }, {
	    key: "set",
	    value: function set(date, _flags, value) {
	      date.setUTCHours((0, _utils.dayPeriodEnumToHours)(value), 0, 0, 0);
	      return date;
	    }
	  }]);
	  return DayPeriodParser;
	}(_Parser2.Parser);
	exports.DayPeriodParser = DayPeriodParser;

/***/ },
/* 1133 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EraParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	var _createClass2 = _interopRequireDefault(__webpack_require__(19));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(12));
	var _inherits2 = _interopRequireDefault(__webpack_require__(22));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(29));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(24));
	var _Parser2 = __webpack_require__(31);
	var EraParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(EraParser, _Parser);
	  var _super = (0, _createSuper2.default)(EraParser);
	  function EraParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, EraParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 140);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['R', 'u', 't', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(EraParser, [{
	    key: "parse",
	    value: function parse(dateString, token, match) {
	      switch (token) {
	        // AD, BC
	        case 'G':
	        case 'GG':
	        case 'GGG':
	          return match.era(dateString, {
	            width: 'abbreviated'
	          }) || match.era(dateString, {
	            width: 'narrow'
	          });
	        // A, B
	        case 'GGGGG':
	          return match.era(dateString, {
	            width: 'narrow'
	          });
	        // Anno Domini, Before Christ
	        case 'GGGG':
	        default:
	          return match.era(dateString, {
	            width: 'wide'
	          }) || match.era(dateString, {
	            width: 'abbreviated'
	          }) || match.era(dateString, {
	            width: 'narrow'
	          });
	      }
	    }
	  }, {
	    key: "set",
	    value: function set(date, flags, value) {
	      flags.era = value;
	      date.setUTCFullYear(value, 0, 1);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    }
	  }]);
	  return EraParser;
	}(_Parser2.Parser);
	exports.EraParser = EraParser;

/***/ },
/* 1134 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ExtendedYearParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	var _createClass2 = _interopRequireDefault(__webpack_require__(19));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(12));
	var _inherits2 = _interopRequireDefault(__webpack_require__(22));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(29));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(24));
	var _Parser2 = __webpack_require__(31);
	var _utils = __webpack_require__(35);
	var ExtendedYearParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(ExtendedYearParser, _Parser);
	  var _super = (0, _createSuper2.default)(ExtendedYearParser);
	  function ExtendedYearParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, ExtendedYearParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 130);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['G', 'y', 'Y', 'R', 'w', 'I', 'i', 'e', 'c', 't', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(ExtendedYearParser, [{
	    key: "parse",
	    value: function parse(dateString, token) {
	      if (token === 'u') {
	        return (0, _utils.parseNDigitsSigned)(4, dateString);
	      }
	      return (0, _utils.parseNDigitsSigned)(token.length, dateString);
	    }
	  }, {
	    key: "set",
	    value: function set(date, _flags, value) {
	      date.setUTCFullYear(value, 0, 1);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    }
	  }]);
	  return ExtendedYearParser;
	}(_Parser2.Parser);
	exports.ExtendedYearParser = ExtendedYearParser;

/***/ },
/* 1135 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FractionOfSecondParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	var _createClass2 = _interopRequireDefault(__webpack_require__(19));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(12));
	var _inherits2 = _interopRequireDefault(__webpack_require__(22));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(29));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(24));
	var _Parser2 = __webpack_require__(31);
	var _utils = __webpack_require__(35);
	var FractionOfSecondParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(FractionOfSecondParser, _Parser);
	  var _super = (0, _createSuper2.default)(FractionOfSecondParser);
	  function FractionOfSecondParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, FractionOfSecondParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 30);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['t', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(FractionOfSecondParser, [{
	    key: "parse",
	    value: function parse(dateString, token) {
	      var valueCallback = function valueCallback(value) {
	        return Math.floor(value * Math.pow(10, -token.length + 3));
	      };
	      return (0, _utils.mapValue)((0, _utils.parseNDigits)(token.length, dateString), valueCallback);
	    }
	  }, {
	    key: "set",
	    value: function set(date, _flags, value) {
	      date.setUTCMilliseconds(value);
	      return date;
	    }
	  }]);
	  return FractionOfSecondParser;
	}(_Parser2.Parser);
	exports.FractionOfSecondParser = FractionOfSecondParser;

/***/ },
/* 1136 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Hour0To11Parser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	var _createClass2 = _interopRequireDefault(__webpack_require__(19));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(12));
	var _inherits2 = _interopRequireDefault(__webpack_require__(22));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(29));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(24));
	var _Parser2 = __webpack_require__(31);
	var _constants = __webpack_require__(57);
	var _utils = __webpack_require__(35);
	var Hour0To11Parser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(Hour0To11Parser, _Parser);
	  var _super = (0, _createSuper2.default)(Hour0To11Parser);
	  function Hour0To11Parser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, Hour0To11Parser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 70);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['h', 'H', 'k', 't', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(Hour0To11Parser, [{
	    key: "parse",
	    value: function parse(dateString, token, match) {
	      switch (token) {
	        case 'K':
	          return (0, _utils.parseNumericPattern)(_constants.numericPatterns.hour11h, dateString);
	        case 'Ko':
	          return match.ordinalNumber(dateString, {
	            unit: 'hour'
	          });
	        default:
	          return (0, _utils.parseNDigits)(token.length, dateString);
	      }
	    }
	  }, {
	    key: "validate",
	    value: function validate(_date, value) {
	      return value >= 0 && value <= 11;
	    }
	  }, {
	    key: "set",
	    value: function set(date, _flags, value) {
	      var isPM = date.getUTCHours() >= 12;
	      if (isPM && value < 12) {
	        date.setUTCHours(value + 12, 0, 0, 0);
	      } else {
	        date.setUTCHours(value, 0, 0, 0);
	      }
	      return date;
	    }
	  }]);
	  return Hour0To11Parser;
	}(_Parser2.Parser);
	exports.Hour0To11Parser = Hour0To11Parser;

/***/ },
/* 1137 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Hour0to23Parser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	var _createClass2 = _interopRequireDefault(__webpack_require__(19));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(12));
	var _inherits2 = _interopRequireDefault(__webpack_require__(22));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(29));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(24));
	var _Parser2 = __webpack_require__(31);
	var _constants = __webpack_require__(57);
	var _utils = __webpack_require__(35);
	var Hour0to23Parser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(Hour0to23Parser, _Parser);
	  var _super = (0, _createSuper2.default)(Hour0to23Parser);
	  function Hour0to23Parser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, Hour0to23Parser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 70);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['a', 'b', 'h', 'K', 'k', 't', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(Hour0to23Parser, [{
	    key: "parse",
	    value: function parse(dateString, token, match) {
	      switch (token) {
	        case 'H':
	          return (0, _utils.parseNumericPattern)(_constants.numericPatterns.hour23h, dateString);
	        case 'Ho':
	          return match.ordinalNumber(dateString, {
	            unit: 'hour'
	          });
	        default:
	          return (0, _utils.parseNDigits)(token.length, dateString);
	      }
	    }
	  }, {
	    key: "validate",
	    value: function validate(_date, value) {
	      return value >= 0 && value <= 23;
	    }
	  }, {
	    key: "set",
	    value: function set(date, _flags, value) {
	      date.setUTCHours(value, 0, 0, 0);
	      return date;
	    }
	  }]);
	  return Hour0to23Parser;
	}(_Parser2.Parser);
	exports.Hour0to23Parser = Hour0to23Parser;

/***/ },
/* 1138 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Hour1To24Parser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	var _createClass2 = _interopRequireDefault(__webpack_require__(19));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(12));
	var _inherits2 = _interopRequireDefault(__webpack_require__(22));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(29));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(24));
	var _Parser2 = __webpack_require__(31);
	var _constants = __webpack_require__(57);
	var _utils = __webpack_require__(35);
	var Hour1To24Parser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(Hour1To24Parser, _Parser);
	  var _super = (0, _createSuper2.default)(Hour1To24Parser);
	  function Hour1To24Parser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, Hour1To24Parser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 70);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['a', 'b', 'h', 'H', 'K', 't', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(Hour1To24Parser, [{
	    key: "parse",
	    value: function parse(dateString, token, match) {
	      switch (token) {
	        case 'k':
	          return (0, _utils.parseNumericPattern)(_constants.numericPatterns.hour24h, dateString);
	        case 'ko':
	          return match.ordinalNumber(dateString, {
	            unit: 'hour'
	          });
	        default:
	          return (0, _utils.parseNDigits)(token.length, dateString);
	      }
	    }
	  }, {
	    key: "validate",
	    value: function validate(_date, value) {
	      return value >= 1 && value <= 24;
	    }
	  }, {
	    key: "set",
	    value: function set(date, _flags, value) {
	      var hours = value <= 24 ? value % 24 : value;
	      date.setUTCHours(hours, 0, 0, 0);
	      return date;
	    }
	  }]);
	  return Hour1To24Parser;
	}(_Parser2.Parser);
	exports.Hour1To24Parser = Hour1To24Parser;

/***/ },
/* 1139 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Hour1to12Parser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	var _createClass2 = _interopRequireDefault(__webpack_require__(19));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(12));
	var _inherits2 = _interopRequireDefault(__webpack_require__(22));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(29));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(24));
	var _Parser2 = __webpack_require__(31);
	var _constants = __webpack_require__(57);
	var _utils = __webpack_require__(35);
	var Hour1to12Parser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(Hour1to12Parser, _Parser);
	  var _super = (0, _createSuper2.default)(Hour1to12Parser);
	  function Hour1to12Parser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, Hour1to12Parser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 70);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['H', 'K', 'k', 't', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(Hour1to12Parser, [{
	    key: "parse",
	    value: function parse(dateString, token, match) {
	      switch (token) {
	        case 'h':
	          return (0, _utils.parseNumericPattern)(_constants.numericPatterns.hour12h, dateString);
	        case 'ho':
	          return match.ordinalNumber(dateString, {
	            unit: 'hour'
	          });
	        default:
	          return (0, _utils.parseNDigits)(token.length, dateString);
	      }
	    }
	  }, {
	    key: "validate",
	    value: function validate(_date, value) {
	      return value >= 1 && value <= 12;
	    }
	  }, {
	    key: "set",
	    value: function set(date, _flags, value) {
	      var isPM = date.getUTCHours() >= 12;
	      if (isPM && value < 12) {
	        date.setUTCHours(value + 12, 0, 0, 0);
	      } else if (!isPM && value === 12) {
	        date.setUTCHours(0, 0, 0, 0);
	      } else {
	        date.setUTCHours(value, 0, 0, 0);
	      }
	      return date;
	    }
	  }]);
	  return Hour1to12Parser;
	}(_Parser2.Parser);
	exports.Hour1to12Parser = Hour1to12Parser;

/***/ },
/* 1140 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ISODayParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	var _createClass2 = _interopRequireDefault(__webpack_require__(19));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(12));
	var _inherits2 = _interopRequireDefault(__webpack_require__(22));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(29));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(24));
	var _Parser2 = __webpack_require__(31);
	var _utils = __webpack_require__(35);
	var _index = _interopRequireDefault(__webpack_require__(1082));
	// ISO day of week
	var ISODayParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(ISODayParser, _Parser);
	  var _super = (0, _createSuper2.default)(ISODayParser);
	  function ISODayParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, ISODayParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 90);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['y', 'Y', 'u', 'q', 'Q', 'M', 'L', 'w', 'd', 'D', 'E', 'e', 'c', 't', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(ISODayParser, [{
	    key: "parse",
	    value: function parse(dateString, token, match) {
	      var valueCallback = function valueCallback(value) {
	        if (value === 0) {
	          return 7;
	        }
	        return value;
	      };
	      switch (token) {
	        // 2
	        case 'i':
	        case 'ii':
	          // 02
	          return (0, _utils.parseNDigits)(token.length, dateString);
	        // 2nd
	        case 'io':
	          return match.ordinalNumber(dateString, {
	            unit: 'day'
	          });
	        // Tue
	        case 'iii':
	          return (0, _utils.mapValue)(match.day(dateString, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.day(dateString, {
	            width: 'short',
	            context: 'formatting'
	          }) || match.day(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          }), valueCallback);
	        // T
	        case 'iiiii':
	          return (0, _utils.mapValue)(match.day(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          }), valueCallback);
	        // Tu
	        case 'iiiiii':
	          return (0, _utils.mapValue)(match.day(dateString, {
	            width: 'short',
	            context: 'formatting'
	          }) || match.day(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          }), valueCallback);
	        // Tuesday
	        case 'iiii':
	        default:
	          return (0, _utils.mapValue)(match.day(dateString, {
	            width: 'wide',
	            context: 'formatting'
	          }) || match.day(dateString, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.day(dateString, {
	            width: 'short',
	            context: 'formatting'
	          }) || match.day(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          }), valueCallback);
	      }
	    }
	  }, {
	    key: "validate",
	    value: function validate(_date, value) {
	      return value >= 1 && value <= 7;
	    }
	  }, {
	    key: "set",
	    value: function set(date, _flags, value) {
	      date = (0, _index.default)(date, value);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    }
	  }]);
	  return ISODayParser;
	}(_Parser2.Parser);
	exports.ISODayParser = ISODayParser;

/***/ },
/* 1141 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ISOTimezoneParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	var _createClass2 = _interopRequireDefault(__webpack_require__(19));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(12));
	var _inherits2 = _interopRequireDefault(__webpack_require__(22));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(29));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(24));
	var _Parser2 = __webpack_require__(31);
	var _constants = __webpack_require__(57);
	var _utils = __webpack_require__(35);
	// Timezone (ISO-8601)
	var ISOTimezoneParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(ISOTimezoneParser, _Parser);
	  var _super = (0, _createSuper2.default)(ISOTimezoneParser);
	  function ISOTimezoneParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, ISOTimezoneParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 10);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['t', 'T', 'X']);
	    return _this;
	  }
	  (0, _createClass2.default)(ISOTimezoneParser, [{
	    key: "parse",
	    value: function parse(dateString, token) {
	      switch (token) {
	        case 'x':
	          return (0, _utils.parseTimezonePattern)(_constants.timezonePatterns.basicOptionalMinutes, dateString);
	        case 'xx':
	          return (0, _utils.parseTimezonePattern)(_constants.timezonePatterns.basic, dateString);
	        case 'xxxx':
	          return (0, _utils.parseTimezonePattern)(_constants.timezonePatterns.basicOptionalSeconds, dateString);
	        case 'xxxxx':
	          return (0, _utils.parseTimezonePattern)(_constants.timezonePatterns.extendedOptionalSeconds, dateString);
	        case 'xxx':
	        default:
	          return (0, _utils.parseTimezonePattern)(_constants.timezonePatterns.extended, dateString);
	      }
	    }
	  }, {
	    key: "set",
	    value: function set(date, flags, value) {
	      if (flags.timestampIsSet) {
	        return date;
	      }
	      return new Date(date.getTime() - value);
	    }
	  }]);
	  return ISOTimezoneParser;
	}(_Parser2.Parser);
	exports.ISOTimezoneParser = ISOTimezoneParser;

/***/ },
/* 1142 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ISOTimezoneWithZParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	var _createClass2 = _interopRequireDefault(__webpack_require__(19));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(12));
	var _inherits2 = _interopRequireDefault(__webpack_require__(22));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(29));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(24));
	var _Parser2 = __webpack_require__(31);
	var _constants = __webpack_require__(57);
	var _utils = __webpack_require__(35);
	// Timezone (ISO-8601. +00:00 is `'Z'`)
	var ISOTimezoneWithZParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(ISOTimezoneWithZParser, _Parser);
	  var _super = (0, _createSuper2.default)(ISOTimezoneWithZParser);
	  function ISOTimezoneWithZParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, ISOTimezoneWithZParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 10);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['t', 'T', 'x']);
	    return _this;
	  }
	  (0, _createClass2.default)(ISOTimezoneWithZParser, [{
	    key: "parse",
	    value: function parse(dateString, token) {
	      switch (token) {
	        case 'X':
	          return (0, _utils.parseTimezonePattern)(_constants.timezonePatterns.basicOptionalMinutes, dateString);
	        case 'XX':
	          return (0, _utils.parseTimezonePattern)(_constants.timezonePatterns.basic, dateString);
	        case 'XXXX':
	          return (0, _utils.parseTimezonePattern)(_constants.timezonePatterns.basicOptionalSeconds, dateString);
	        case 'XXXXX':
	          return (0, _utils.parseTimezonePattern)(_constants.timezonePatterns.extendedOptionalSeconds, dateString);
	        case 'XXX':
	        default:
	          return (0, _utils.parseTimezonePattern)(_constants.timezonePatterns.extended, dateString);
	      }
	    }
	  }, {
	    key: "set",
	    value: function set(date, flags, value) {
	      if (flags.timestampIsSet) {
	        return date;
	      }
	      return new Date(date.getTime() - value);
	    }
	  }]);
	  return ISOTimezoneWithZParser;
	}(_Parser2.Parser);
	exports.ISOTimezoneWithZParser = ISOTimezoneWithZParser;

/***/ },
/* 1143 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ISOWeekParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	var _createClass2 = _interopRequireDefault(__webpack_require__(19));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(12));
	var _inherits2 = _interopRequireDefault(__webpack_require__(22));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(29));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(24));
	var _Parser2 = __webpack_require__(31);
	var _constants = __webpack_require__(57);
	var _utils = __webpack_require__(35);
	var _index = _interopRequireDefault(__webpack_require__(1083));
	var _index2 = _interopRequireDefault(__webpack_require__(148));
	// ISO week of year
	var ISOWeekParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(ISOWeekParser, _Parser);
	  var _super = (0, _createSuper2.default)(ISOWeekParser);
	  function ISOWeekParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, ISOWeekParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 100);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['y', 'Y', 'u', 'q', 'Q', 'M', 'L', 'w', 'd', 'D', 'e', 'c', 't', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(ISOWeekParser, [{
	    key: "parse",
	    value: function parse(dateString, token, match) {
	      switch (token) {
	        case 'I':
	          return (0, _utils.parseNumericPattern)(_constants.numericPatterns.week, dateString);
	        case 'Io':
	          return match.ordinalNumber(dateString, {
	            unit: 'week'
	          });
	        default:
	          return (0, _utils.parseNDigits)(token.length, dateString);
	      }
	    }
	  }, {
	    key: "validate",
	    value: function validate(_date, value) {
	      return value >= 1 && value <= 53;
	    }
	  }, {
	    key: "set",
	    value: function set(date, _flags, value) {
	      return (0, _index2.default)((0, _index.default)(date, value));
	    }
	  }]);
	  return ISOWeekParser;
	}(_Parser2.Parser);
	exports.ISOWeekParser = ISOWeekParser;

/***/ },
/* 1144 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ISOWeekYearParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	var _createClass2 = _interopRequireDefault(__webpack_require__(19));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(12));
	var _inherits2 = _interopRequireDefault(__webpack_require__(22));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(29));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(24));
	var _Parser2 = __webpack_require__(31);
	var _utils = __webpack_require__(35);
	var _index = _interopRequireDefault(__webpack_require__(148));
	// ISO week-numbering year
	var ISOWeekYearParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(ISOWeekYearParser, _Parser);
	  var _super = (0, _createSuper2.default)(ISOWeekYearParser);
	  function ISOWeekYearParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, ISOWeekYearParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 130);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['G', 'y', 'Y', 'u', 'Q', 'q', 'M', 'L', 'w', 'd', 'D', 'e', 'c', 't', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(ISOWeekYearParser, [{
	    key: "parse",
	    value: function parse(dateString, token) {
	      if (token === 'R') {
	        return (0, _utils.parseNDigitsSigned)(4, dateString);
	      }
	      return (0, _utils.parseNDigitsSigned)(token.length, dateString);
	    }
	  }, {
	    key: "set",
	    value: function set(_date, _flags, value) {
	      var firstWeekOfYear = new Date(0);
	      firstWeekOfYear.setUTCFullYear(value, 0, 4);
	      firstWeekOfYear.setUTCHours(0, 0, 0, 0);
	      return (0, _index.default)(firstWeekOfYear);
	    }
	  }]);
	  return ISOWeekYearParser;
	}(_Parser2.Parser);
	exports.ISOWeekYearParser = ISOWeekYearParser;

/***/ },
/* 1145 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LocalDayParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	var _createClass2 = _interopRequireDefault(__webpack_require__(19));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(12));
	var _inherits2 = _interopRequireDefault(__webpack_require__(22));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(29));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(24));
	var _Parser2 = __webpack_require__(31);
	var _utils = __webpack_require__(35);
	var _index = _interopRequireDefault(__webpack_require__(254));
	// Local day of week
	var LocalDayParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(LocalDayParser, _Parser);
	  var _super = (0, _createSuper2.default)(LocalDayParser);
	  function LocalDayParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, LocalDayParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 90);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'E', 'i', 'c', 't', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(LocalDayParser, [{
	    key: "parse",
	    value: function parse(dateString, token, match, options) {
	      var valueCallback = function valueCallback(value) {
	        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
	        return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
	      };
	      switch (token) {
	        // 3
	        case 'e':
	        case 'ee':
	          // 03
	          return (0, _utils.mapValue)((0, _utils.parseNDigits)(token.length, dateString), valueCallback);
	        // 3rd
	        case 'eo':
	          return (0, _utils.mapValue)(match.ordinalNumber(dateString, {
	            unit: 'day'
	          }), valueCallback);
	        // Tue
	        case 'eee':
	          return match.day(dateString, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.day(dateString, {
	            width: 'short',
	            context: 'formatting'
	          }) || match.day(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // T
	        case 'eeeee':
	          return match.day(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // Tu
	        case 'eeeeee':
	          return match.day(dateString, {
	            width: 'short',
	            context: 'formatting'
	          }) || match.day(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // Tuesday
	        case 'eeee':
	        default:
	          return match.day(dateString, {
	            width: 'wide',
	            context: 'formatting'
	          }) || match.day(dateString, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.day(dateString, {
	            width: 'short',
	            context: 'formatting'
	          }) || match.day(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	      }
	    }
	  }, {
	    key: "validate",
	    value: function validate(_date, value) {
	      return value >= 0 && value <= 6;
	    }
	  }, {
	    key: "set",
	    value: function set(date, _flags, value, options) {
	      date = (0, _index.default)(date, value, options);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    }
	  }]);
	  return LocalDayParser;
	}(_Parser2.Parser);
	exports.LocalDayParser = LocalDayParser;

/***/ },
/* 1146 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LocalWeekParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	var _createClass2 = _interopRequireDefault(__webpack_require__(19));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(12));
	var _inherits2 = _interopRequireDefault(__webpack_require__(22));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(29));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(24));
	var _Parser2 = __webpack_require__(31);
	var _constants = __webpack_require__(57);
	var _utils = __webpack_require__(35);
	var _index = _interopRequireDefault(__webpack_require__(1084));
	var _index2 = _interopRequireDefault(__webpack_require__(149));
	// Local week of year
	var LocalWeekParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(LocalWeekParser, _Parser);
	  var _super = (0, _createSuper2.default)(LocalWeekParser);
	  function LocalWeekParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, LocalWeekParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 100);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(LocalWeekParser, [{
	    key: "parse",
	    value: function parse(dateString, token, match) {
	      switch (token) {
	        case 'w':
	          return (0, _utils.parseNumericPattern)(_constants.numericPatterns.week, dateString);
	        case 'wo':
	          return match.ordinalNumber(dateString, {
	            unit: 'week'
	          });
	        default:
	          return (0, _utils.parseNDigits)(token.length, dateString);
	      }
	    }
	  }, {
	    key: "validate",
	    value: function validate(_date, value) {
	      return value >= 1 && value <= 53;
	    }
	  }, {
	    key: "set",
	    value: function set(date, _flags, value, options) {
	      return (0, _index2.default)((0, _index.default)(date, value, options), options);
	    }
	  }]);
	  return LocalWeekParser;
	}(_Parser2.Parser);
	exports.LocalWeekParser = LocalWeekParser;

/***/ },
/* 1147 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LocalWeekYearParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	var _createClass2 = _interopRequireDefault(__webpack_require__(19));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(12));
	var _inherits2 = _interopRequireDefault(__webpack_require__(22));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(29));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(24));
	var _Parser2 = __webpack_require__(31);
	var _utils = __webpack_require__(35);
	var _index = _interopRequireDefault(__webpack_require__(253));
	var _index2 = _interopRequireDefault(__webpack_require__(149));
	// Local week-numbering year
	var LocalWeekYearParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(LocalWeekYearParser, _Parser);
	  var _super = (0, _createSuper2.default)(LocalWeekYearParser);
	  function LocalWeekYearParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, LocalWeekYearParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 130);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['y', 'R', 'u', 'Q', 'q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(LocalWeekYearParser, [{
	    key: "parse",
	    value: function parse(dateString, token, match) {
	      var valueCallback = function valueCallback(year) {
	        return {
	          year: year,
	          isTwoDigitYear: token === 'YY'
	        };
	      };
	      switch (token) {
	        case 'Y':
	          return (0, _utils.mapValue)((0, _utils.parseNDigits)(4, dateString), valueCallback);
	        case 'Yo':
	          return (0, _utils.mapValue)(match.ordinalNumber(dateString, {
	            unit: 'year'
	          }), valueCallback);
	        default:
	          return (0, _utils.mapValue)((0, _utils.parseNDigits)(token.length, dateString), valueCallback);
	      }
	    }
	  }, {
	    key: "validate",
	    value: function validate(_date, value) {
	      return value.isTwoDigitYear || value.year > 0;
	    }
	  }, {
	    key: "set",
	    value: function set(date, flags, value, options) {
	      var currentYear = (0, _index.default)(date, options);
	      if (value.isTwoDigitYear) {
	        var normalizedTwoDigitYear = (0, _utils.normalizeTwoDigitYear)(value.year, currentYear);
	        date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
	        date.setUTCHours(0, 0, 0, 0);
	        return (0, _index2.default)(date, options);
	      }
	      var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
	      date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
	      date.setUTCHours(0, 0, 0, 0);
	      return (0, _index2.default)(date, options);
	    }
	  }]);
	  return LocalWeekYearParser;
	}(_Parser2.Parser);
	exports.LocalWeekYearParser = LocalWeekYearParser;

/***/ },
/* 1148 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MinuteParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	var _createClass2 = _interopRequireDefault(__webpack_require__(19));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(12));
	var _inherits2 = _interopRequireDefault(__webpack_require__(22));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(29));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(24));
	var _Parser2 = __webpack_require__(31);
	var _constants = __webpack_require__(57);
	var _utils = __webpack_require__(35);
	var MinuteParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(MinuteParser, _Parser);
	  var _super = (0, _createSuper2.default)(MinuteParser);
	  function MinuteParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, MinuteParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 60);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['t', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(MinuteParser, [{
	    key: "parse",
	    value: function parse(dateString, token, match) {
	      switch (token) {
	        case 'm':
	          return (0, _utils.parseNumericPattern)(_constants.numericPatterns.minute, dateString);
	        case 'mo':
	          return match.ordinalNumber(dateString, {
	            unit: 'minute'
	          });
	        default:
	          return (0, _utils.parseNDigits)(token.length, dateString);
	      }
	    }
	  }, {
	    key: "validate",
	    value: function validate(_date, value) {
	      return value >= 0 && value <= 59;
	    }
	  }, {
	    key: "set",
	    value: function set(date, _flags, value) {
	      date.setUTCMinutes(value, 0, 0);
	      return date;
	    }
	  }]);
	  return MinuteParser;
	}(_Parser2.Parser);
	exports.MinuteParser = MinuteParser;

/***/ },
/* 1149 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MonthParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	var _createClass2 = _interopRequireDefault(__webpack_require__(19));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(12));
	var _inherits2 = _interopRequireDefault(__webpack_require__(22));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(29));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(24));
	var _utils = __webpack_require__(35);
	var _Parser2 = __webpack_require__(31);
	var _constants = __webpack_require__(57);
	var MonthParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(MonthParser, _Parser);
	  var _super = (0, _createSuper2.default)(MonthParser);
	  function MonthParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, MonthParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['Y', 'R', 'q', 'Q', 'L', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 110);
	    return _this;
	  }
	  (0, _createClass2.default)(MonthParser, [{
	    key: "parse",
	    value: function parse(dateString, token, match) {
	      var valueCallback = function valueCallback(value) {
	        return value - 1;
	      };
	      switch (token) {
	        // 1, 2, ..., 12
	        case 'M':
	          return (0, _utils.mapValue)((0, _utils.parseNumericPattern)(_constants.numericPatterns.month, dateString), valueCallback);
	        // 01, 02, ..., 12
	        case 'MM':
	          return (0, _utils.mapValue)((0, _utils.parseNDigits)(2, dateString), valueCallback);
	        // 1st, 2nd, ..., 12th
	        case 'Mo':
	          return (0, _utils.mapValue)(match.ordinalNumber(dateString, {
	            unit: 'month'
	          }), valueCallback);
	        // Jan, Feb, ..., Dec
	        case 'MMM':
	          return match.month(dateString, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.month(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // J, F, ..., D
	        case 'MMMMM':
	          return match.month(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // January, February, ..., December
	        case 'MMMM':
	        default:
	          return match.month(dateString, {
	            width: 'wide',
	            context: 'formatting'
	          }) || match.month(dateString, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.month(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	      }
	    }
	  }, {
	    key: "validate",
	    value: function validate(_date, value) {
	      return value >= 0 && value <= 11;
	    }
	  }, {
	    key: "set",
	    value: function set(date, _flags, value) {
	      date.setUTCMonth(value, 1);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    }
	  }]);
	  return MonthParser;
	}(_Parser2.Parser);
	exports.MonthParser = MonthParser;

/***/ },
/* 1150 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.QuarterParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	var _createClass2 = _interopRequireDefault(__webpack_require__(19));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(12));
	var _inherits2 = _interopRequireDefault(__webpack_require__(22));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(29));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(24));
	var _Parser2 = __webpack_require__(31);
	var _utils = __webpack_require__(35);
	var QuarterParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(QuarterParser, _Parser);
	  var _super = (0, _createSuper2.default)(QuarterParser);
	  function QuarterParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, QuarterParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 120);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['Y', 'R', 'q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(QuarterParser, [{
	    key: "parse",
	    value: function parse(dateString, token, match) {
	      switch (token) {
	        // 1, 2, 3, 4
	        case 'Q':
	        case 'QQ':
	          // 01, 02, 03, 04
	          return (0, _utils.parseNDigits)(token.length, dateString);
	        // 1st, 2nd, 3rd, 4th
	        case 'Qo':
	          return match.ordinalNumber(dateString, {
	            unit: 'quarter'
	          });
	        // Q1, Q2, Q3, Q4
	        case 'QQQ':
	          return match.quarter(dateString, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.quarter(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // 1, 2, 3, 4 (narrow quarter; could be not numerical)
	        case 'QQQQQ':
	          return match.quarter(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // 1st quarter, 2nd quarter, ...
	        case 'QQQQ':
	        default:
	          return match.quarter(dateString, {
	            width: 'wide',
	            context: 'formatting'
	          }) || match.quarter(dateString, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.quarter(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	      }
	    }
	  }, {
	    key: "validate",
	    value: function validate(_date, value) {
	      return value >= 1 && value <= 4;
	    }
	  }, {
	    key: "set",
	    value: function set(date, _flags, value) {
	      date.setUTCMonth((value - 1) * 3, 1);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    }
	  }]);
	  return QuarterParser;
	}(_Parser2.Parser);
	exports.QuarterParser = QuarterParser;

/***/ },
/* 1151 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SecondParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	var _createClass2 = _interopRequireDefault(__webpack_require__(19));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(12));
	var _inherits2 = _interopRequireDefault(__webpack_require__(22));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(29));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(24));
	var _Parser2 = __webpack_require__(31);
	var _constants = __webpack_require__(57);
	var _utils = __webpack_require__(35);
	var SecondParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(SecondParser, _Parser);
	  var _super = (0, _createSuper2.default)(SecondParser);
	  function SecondParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, SecondParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 50);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['t', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(SecondParser, [{
	    key: "parse",
	    value: function parse(dateString, token, match) {
	      switch (token) {
	        case 's':
	          return (0, _utils.parseNumericPattern)(_constants.numericPatterns.second, dateString);
	        case 'so':
	          return match.ordinalNumber(dateString, {
	            unit: 'second'
	          });
	        default:
	          return (0, _utils.parseNDigits)(token.length, dateString);
	      }
	    }
	  }, {
	    key: "validate",
	    value: function validate(_date, value) {
	      return value >= 0 && value <= 59;
	    }
	  }, {
	    key: "set",
	    value: function set(date, _flags, value) {
	      date.setUTCSeconds(value, 0);
	      return date;
	    }
	  }]);
	  return SecondParser;
	}(_Parser2.Parser);
	exports.SecondParser = SecondParser;

/***/ },
/* 1152 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.StandAloneLocalDayParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	var _createClass2 = _interopRequireDefault(__webpack_require__(19));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(12));
	var _inherits2 = _interopRequireDefault(__webpack_require__(22));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(29));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(24));
	var _Parser2 = __webpack_require__(31);
	var _utils = __webpack_require__(35);
	var _index = _interopRequireDefault(__webpack_require__(254));
	// Stand-alone local day of week
	var StandAloneLocalDayParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(StandAloneLocalDayParser, _Parser);
	  var _super = (0, _createSuper2.default)(StandAloneLocalDayParser);
	  function StandAloneLocalDayParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, StandAloneLocalDayParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 90);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'E', 'i', 'e', 't', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(StandAloneLocalDayParser, [{
	    key: "parse",
	    value: function parse(dateString, token, match, options) {
	      var valueCallback = function valueCallback(value) {
	        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
	        return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
	      };
	      switch (token) {
	        // 3
	        case 'c':
	        case 'cc':
	          // 03
	          return (0, _utils.mapValue)((0, _utils.parseNDigits)(token.length, dateString), valueCallback);
	        // 3rd
	        case 'co':
	          return (0, _utils.mapValue)(match.ordinalNumber(dateString, {
	            unit: 'day'
	          }), valueCallback);
	        // Tue
	        case 'ccc':
	          return match.day(dateString, {
	            width: 'abbreviated',
	            context: 'standalone'
	          }) || match.day(dateString, {
	            width: 'short',
	            context: 'standalone'
	          }) || match.day(dateString, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	        // T
	        case 'ccccc':
	          return match.day(dateString, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	        // Tu
	        case 'cccccc':
	          return match.day(dateString, {
	            width: 'short',
	            context: 'standalone'
	          }) || match.day(dateString, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	        // Tuesday
	        case 'cccc':
	        default:
	          return match.day(dateString, {
	            width: 'wide',
	            context: 'standalone'
	          }) || match.day(dateString, {
	            width: 'abbreviated',
	            context: 'standalone'
	          }) || match.day(dateString, {
	            width: 'short',
	            context: 'standalone'
	          }) || match.day(dateString, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	      }
	    }
	  }, {
	    key: "validate",
	    value: function validate(_date, value) {
	      return value >= 0 && value <= 6;
	    }
	  }, {
	    key: "set",
	    value: function set(date, _flags, value, options) {
	      date = (0, _index.default)(date, value, options);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    }
	  }]);
	  return StandAloneLocalDayParser;
	}(_Parser2.Parser);
	exports.StandAloneLocalDayParser = StandAloneLocalDayParser;

/***/ },
/* 1153 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.StandAloneMonthParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	var _createClass2 = _interopRequireDefault(__webpack_require__(19));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(12));
	var _inherits2 = _interopRequireDefault(__webpack_require__(22));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(29));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(24));
	var _Parser2 = __webpack_require__(31);
	var _constants = __webpack_require__(57);
	var _utils = __webpack_require__(35);
	var StandAloneMonthParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(StandAloneMonthParser, _Parser);
	  var _super = (0, _createSuper2.default)(StandAloneMonthParser);
	  function StandAloneMonthParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, StandAloneMonthParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 110);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['Y', 'R', 'q', 'Q', 'M', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(StandAloneMonthParser, [{
	    key: "parse",
	    value: function parse(dateString, token, match) {
	      var valueCallback = function valueCallback(value) {
	        return value - 1;
	      };
	      switch (token) {
	        // 1, 2, ..., 12
	        case 'L':
	          return (0, _utils.mapValue)((0, _utils.parseNumericPattern)(_constants.numericPatterns.month, dateString), valueCallback);
	        // 01, 02, ..., 12
	        case 'LL':
	          return (0, _utils.mapValue)((0, _utils.parseNDigits)(2, dateString), valueCallback);
	        // 1st, 2nd, ..., 12th
	        case 'Lo':
	          return (0, _utils.mapValue)(match.ordinalNumber(dateString, {
	            unit: 'month'
	          }), valueCallback);
	        // Jan, Feb, ..., Dec
	        case 'LLL':
	          return match.month(dateString, {
	            width: 'abbreviated',
	            context: 'standalone'
	          }) || match.month(dateString, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	        // J, F, ..., D
	        case 'LLLLL':
	          return match.month(dateString, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	        // January, February, ..., December
	        case 'LLLL':
	        default:
	          return match.month(dateString, {
	            width: 'wide',
	            context: 'standalone'
	          }) || match.month(dateString, {
	            width: 'abbreviated',
	            context: 'standalone'
	          }) || match.month(dateString, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	      }
	    }
	  }, {
	    key: "validate",
	    value: function validate(_date, value) {
	      return value >= 0 && value <= 11;
	    }
	  }, {
	    key: "set",
	    value: function set(date, _flags, value) {
	      date.setUTCMonth(value, 1);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    }
	  }]);
	  return StandAloneMonthParser;
	}(_Parser2.Parser);
	exports.StandAloneMonthParser = StandAloneMonthParser;

/***/ },
/* 1154 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.StandAloneQuarterParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	var _createClass2 = _interopRequireDefault(__webpack_require__(19));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(12));
	var _inherits2 = _interopRequireDefault(__webpack_require__(22));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(29));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(24));
	var _Parser2 = __webpack_require__(31);
	var _utils = __webpack_require__(35);
	var StandAloneQuarterParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(StandAloneQuarterParser, _Parser);
	  var _super = (0, _createSuper2.default)(StandAloneQuarterParser);
	  function StandAloneQuarterParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, StandAloneQuarterParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 120);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['Y', 'R', 'Q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(StandAloneQuarterParser, [{
	    key: "parse",
	    value: function parse(dateString, token, match) {
	      switch (token) {
	        // 1, 2, 3, 4
	        case 'q':
	        case 'qq':
	          // 01, 02, 03, 04
	          return (0, _utils.parseNDigits)(token.length, dateString);
	        // 1st, 2nd, 3rd, 4th
	        case 'qo':
	          return match.ordinalNumber(dateString, {
	            unit: 'quarter'
	          });
	        // Q1, Q2, Q3, Q4
	        case 'qqq':
	          return match.quarter(dateString, {
	            width: 'abbreviated',
	            context: 'standalone'
	          }) || match.quarter(dateString, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	        // 1, 2, 3, 4 (narrow quarter; could be not numerical)
	        case 'qqqqq':
	          return match.quarter(dateString, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	        // 1st quarter, 2nd quarter, ...
	        case 'qqqq':
	        default:
	          return match.quarter(dateString, {
	            width: 'wide',
	            context: 'standalone'
	          }) || match.quarter(dateString, {
	            width: 'abbreviated',
	            context: 'standalone'
	          }) || match.quarter(dateString, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	      }
	    }
	  }, {
	    key: "validate",
	    value: function validate(_date, value) {
	      return value >= 1 && value <= 4;
	    }
	  }, {
	    key: "set",
	    value: function set(date, _flags, value) {
	      date.setUTCMonth((value - 1) * 3, 1);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    }
	  }]);
	  return StandAloneQuarterParser;
	}(_Parser2.Parser);
	exports.StandAloneQuarterParser = StandAloneQuarterParser;

/***/ },
/* 1155 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TimestampMillisecondsParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	var _createClass2 = _interopRequireDefault(__webpack_require__(19));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(12));
	var _inherits2 = _interopRequireDefault(__webpack_require__(22));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(29));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(24));
	var _Parser2 = __webpack_require__(31);
	var _utils = __webpack_require__(35);
	var TimestampMillisecondsParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(TimestampMillisecondsParser, _Parser);
	  var _super = (0, _createSuper2.default)(TimestampMillisecondsParser);
	  function TimestampMillisecondsParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, TimestampMillisecondsParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 20);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", '*');
	    return _this;
	  }
	  (0, _createClass2.default)(TimestampMillisecondsParser, [{
	    key: "parse",
	    value: function parse(dateString) {
	      return (0, _utils.parseAnyDigitsSigned)(dateString);
	    }
	  }, {
	    key: "set",
	    value: function set(_date, _flags, value) {
	      return [new Date(value), {
	        timestampIsSet: true
	      }];
	    }
	  }]);
	  return TimestampMillisecondsParser;
	}(_Parser2.Parser);
	exports.TimestampMillisecondsParser = TimestampMillisecondsParser;

/***/ },
/* 1156 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TimestampSecondsParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	var _createClass2 = _interopRequireDefault(__webpack_require__(19));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(12));
	var _inherits2 = _interopRequireDefault(__webpack_require__(22));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(29));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(24));
	var _Parser2 = __webpack_require__(31);
	var _utils = __webpack_require__(35);
	var TimestampSecondsParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(TimestampSecondsParser, _Parser);
	  var _super = (0, _createSuper2.default)(TimestampSecondsParser);
	  function TimestampSecondsParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, TimestampSecondsParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 40);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", '*');
	    return _this;
	  }
	  (0, _createClass2.default)(TimestampSecondsParser, [{
	    key: "parse",
	    value: function parse(dateString) {
	      return (0, _utils.parseAnyDigitsSigned)(dateString);
	    }
	  }, {
	    key: "set",
	    value: function set(_date, _flags, value) {
	      return [new Date(value * 1000), {
	        timestampIsSet: true
	      }];
	    }
	  }]);
	  return TimestampSecondsParser;
	}(_Parser2.Parser);
	exports.TimestampSecondsParser = TimestampSecondsParser;

/***/ },
/* 1157 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.YearParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	var _createClass2 = _interopRequireDefault(__webpack_require__(19));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(12));
	var _inherits2 = _interopRequireDefault(__webpack_require__(22));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(29));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(24));
	var _Parser2 = __webpack_require__(31);
	var _utils = __webpack_require__(35);
	// From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_Patterns
	// | Year     |     y | yy |   yyy |  yyyy | yyyyy |
	// |----------|-------|----|-------|-------|-------|
	// | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
	// | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
	// | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
	// | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
	// | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
	var YearParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(YearParser, _Parser);
	  var _super = (0, _createSuper2.default)(YearParser);
	  function YearParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, YearParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 130);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['Y', 'R', 'u', 'w', 'I', 'i', 'e', 'c', 't', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(YearParser, [{
	    key: "parse",
	    value: function parse(dateString, token, match) {
	      var valueCallback = function valueCallback(year) {
	        return {
	          year: year,
	          isTwoDigitYear: token === 'yy'
	        };
	      };
	      switch (token) {
	        case 'y':
	          return (0, _utils.mapValue)((0, _utils.parseNDigits)(4, dateString), valueCallback);
	        case 'yo':
	          return (0, _utils.mapValue)(match.ordinalNumber(dateString, {
	            unit: 'year'
	          }), valueCallback);
	        default:
	          return (0, _utils.mapValue)((0, _utils.parseNDigits)(token.length, dateString), valueCallback);
	      }
	    }
	  }, {
	    key: "validate",
	    value: function validate(_date, value) {
	      return value.isTwoDigitYear || value.year > 0;
	    }
	  }, {
	    key: "set",
	    value: function set(date, flags, value) {
	      var currentYear = date.getUTCFullYear();
	      if (value.isTwoDigitYear) {
	        var normalizedTwoDigitYear = (0, _utils.normalizeTwoDigitYear)(value.year, currentYear);
	        date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
	        date.setUTCHours(0, 0, 0, 0);
	        return date;
	      }
	      var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
	      date.setUTCFullYear(year, 0, 1);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    }
	  }]);
	  return YearParser;
	}(_Parser2.Parser);
	exports.YearParser = YearParser;

/***/ },
/* 1158 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.parsers = void 0;
	var _EraParser = __webpack_require__(1133);
	var _YearParser = __webpack_require__(1157);
	var _LocalWeekYearParser = __webpack_require__(1147);
	var _ISOWeekYearParser = __webpack_require__(1144);
	var _ExtendedYearParser = __webpack_require__(1134);
	var _QuarterParser = __webpack_require__(1150);
	var _StandAloneQuarterParser = __webpack_require__(1154);
	var _MonthParser = __webpack_require__(1149);
	var _StandAloneMonthParser = __webpack_require__(1153);
	var _LocalWeekParser = __webpack_require__(1146);
	var _ISOWeekParser = __webpack_require__(1143);
	var _DateParser = __webpack_require__(1129);
	var _DayOfYearParser = __webpack_require__(1130);
	var _DayParser = __webpack_require__(1131);
	var _LocalDayParser = __webpack_require__(1145);
	var _StandAloneLocalDayParser = __webpack_require__(1152);
	var _ISODayParser = __webpack_require__(1140);
	var _AMPMParser = __webpack_require__(1128);
	var _AMPMMidnightParser = __webpack_require__(1127);
	var _DayPeriodParser = __webpack_require__(1132);
	var _Hour1to12Parser = __webpack_require__(1139);
	var _Hour0to23Parser = __webpack_require__(1137);
	var _Hour0To11Parser = __webpack_require__(1136);
	var _Hour1To24Parser = __webpack_require__(1138);
	var _MinuteParser = __webpack_require__(1148);
	var _SecondParser = __webpack_require__(1151);
	var _FractionOfSecondParser = __webpack_require__(1135);
	var _ISOTimezoneWithZParser = __webpack_require__(1142);
	var _ISOTimezoneParser = __webpack_require__(1141);
	var _TimestampSecondsParser = __webpack_require__(1156);
	var _TimestampMillisecondsParser = __webpack_require__(1155);
	/*
	 * |     | Unit                           |     | Unit                           |
	 * |-----|--------------------------------|-----|--------------------------------|
	 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
	 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
	 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
	 * |  d  | Day of month                   |  D  | Day of year                    |
	 * |  e  | Local day of week              |  E  | Day of week                    |
	 * |  f  |                                |  F* | Day of week in month           |
	 * |  g* | Modified Julian day            |  G  | Era                            |
	 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
	 * |  i! | ISO day of week                |  I! | ISO week of year               |
	 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
	 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
	 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
	 * |  m  | Minute                         |  M  | Month                          |
	 * |  n  |                                |  N  |                                |
	 * |  o! | Ordinal number modifier        |  O* | Timezone (GMT)                 |
	 * |  p  |                                |  P  |                                |
	 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
	 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
	 * |  s  | Second                         |  S  | Fraction of second             |
	 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
	 * |  u  | Extended year                  |  U* | Cyclic year                    |
	 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
	 * |  w  | Local week of year             |  W* | Week of month                  |
	 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
	 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
	 * |  z* | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
	 *
	 * Letters marked by * are not implemented but reserved by Unicode standard.
	 *
	 * Letters marked by ! are non-standard, but implemented by date-fns:
	 * - `o` modifies the previous token to turn it into an ordinal (see `parse` docs)
	 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
	 *   i.e. 7 for Sunday, 1 for Monday, etc.
	 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
	 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
	 *   `R` is supposed to be used in conjunction with `I` and `i`
	 *   for universal ISO week-numbering date, whereas
	 *   `Y` is supposed to be used in conjunction with `w` and `e`
	 *   for week-numbering date specific to the locale.
	 */
	var parsers = {
	  G: new _EraParser.EraParser(),
	  y: new _YearParser.YearParser(),
	  Y: new _LocalWeekYearParser.LocalWeekYearParser(),
	  R: new _ISOWeekYearParser.ISOWeekYearParser(),
	  u: new _ExtendedYearParser.ExtendedYearParser(),
	  Q: new _QuarterParser.QuarterParser(),
	  q: new _StandAloneQuarterParser.StandAloneQuarterParser(),
	  M: new _MonthParser.MonthParser(),
	  L: new _StandAloneMonthParser.StandAloneMonthParser(),
	  w: new _LocalWeekParser.LocalWeekParser(),
	  I: new _ISOWeekParser.ISOWeekParser(),
	  d: new _DateParser.DateParser(),
	  D: new _DayOfYearParser.DayOfYearParser(),
	  E: new _DayParser.DayParser(),
	  e: new _LocalDayParser.LocalDayParser(),
	  c: new _StandAloneLocalDayParser.StandAloneLocalDayParser(),
	  i: new _ISODayParser.ISODayParser(),
	  a: new _AMPMParser.AMPMParser(),
	  b: new _AMPMMidnightParser.AMPMMidnightParser(),
	  B: new _DayPeriodParser.DayPeriodParser(),
	  h: new _Hour1to12Parser.Hour1to12Parser(),
	  H: new _Hour0to23Parser.Hour0to23Parser(),
	  K: new _Hour0To11Parser.Hour0To11Parser(),
	  k: new _Hour1To24Parser.Hour1To24Parser(),
	  m: new _MinuteParser.MinuteParser(),
	  s: new _SecondParser.SecondParser(),
	  S: new _FractionOfSecondParser.FractionOfSecondParser(),
	  X: new _ISOTimezoneWithZParser.ISOTimezoneWithZParser(),
	  x: new _ISOTimezoneParser.ISOTimezoneParser(),
	  t: new _TimestampSecondsParser.TimestampSecondsParser(),
	  T: new _TimestampMillisecondsParser.TimestampMillisecondsParser()
	};
	exports.parsers = parsers;

/***/ },
/* 1159 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = parse;
	var _typeof2 = _interopRequireDefault(__webpack_require__(56));
	var _createForOfIteratorHelper2 = _interopRequireDefault(__webpack_require__(695));
	var _index = _interopRequireDefault(__webpack_require__(374));
	var _index2 = _interopRequireDefault(__webpack_require__(390));
	var _index3 = _interopRequireDefault(__webpack_require__(23));
	var _index4 = _interopRequireDefault(__webpack_require__(1078));
	var _index5 = _interopRequireDefault(__webpack_require__(375));
	var _index6 = _interopRequireDefault(__webpack_require__(189));
	var _index7 = __webpack_require__(379);
	var _index8 = _interopRequireDefault(__webpack_require__(30));
	var _index9 = _interopRequireDefault(__webpack_require__(14));
	var _Setter = __webpack_require__(387);
	var _index10 = __webpack_require__(1158);
	var _index11 = __webpack_require__(96);
	// This RegExp consists of three parts separated by `|`:
	// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
	//   (one of the certain letters followed by `o`)
	// - (\w)\1* matches any sequences of the same letter
	// - '' matches two quote characters in a row
	// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
	//   except a single quote symbol, which ends the sequence.
	//   Two quote characters do not end the sequence.
	//   If there is no matching single quote
	//   then the sequence will continue until the end of the string.
	// - . matches any single character unmatched by previous parts of the RegExps
	var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
	
	// This RegExp catches symbols escaped by quotes, and also
	// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
	var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
	var escapedStringRegExp = /^'([^]*?)'?$/;
	var doubleQuoteRegExp = /''/g;
	var notWhitespaceRegExp = /\S/;
	var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
	
	/**
	 * @name parse
	 * @category Common Helpers
	 * @summary Parse the date.
	 *
	 * @description
	 * Return the date parsed from string using the given format string.
	 *
	 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
	 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 *
	 * The characters in the format string wrapped between two single quotes characters (') are escaped.
	 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
	 *
	 * Format of the format string is based on Unicode Technical Standard #35:
	 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
	 * with a few additions (see note 5 below the table).
	 *
	 * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
	 * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
	 *
	 * ```javascript
	 * parse('23 AM', 'HH a', new Date())
	 * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
	 * ```
	 *
	 * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
	 *
	 * Accepted format string patterns:
	 * | Unit                            |Prior| Pattern | Result examples                   | Notes |
	 * |---------------------------------|-----|---------|-----------------------------------|-------|
	 * | Era                             | 140 | G..GGG  | AD, BC                            |       |
	 * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
	 * |                                 |     | GGGGG   | A, B                              |       |
	 * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
	 * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
	 * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
	 * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
	 * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
	 * |                                 |     | yyyyy   | ...                               | 2,4   |
	 * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
	 * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
	 * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
	 * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
	 * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
	 * |                                 |     | YYYYY   | ...                               | 2,4   |
	 * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
	 * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
	 * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
	 * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
	 * |                                 |     | RRRRR   | ...                               | 2,4,5 |
	 * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
	 * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
	 * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
	 * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
	 * |                                 |     | uuuuu   | ...                               | 2,4   |
	 * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
	 * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
	 * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
	 * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
	 * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
	 * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
	 * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
	 * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
	 * |                                 |     | qq      | 01, 02, 03, 04                    |       |
	 * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
	 * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
	 * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
	 * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
	 * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
	 * |                                 |     | MM      | 01, 02, ..., 12                   |       |
	 * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
	 * |                                 |     | MMMM    | January, February, ..., December  | 2     |
	 * |                                 |     | MMMMM   | J, F, ..., D                      |       |
	 * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
	 * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
	 * |                                 |     | LL      | 01, 02, ..., 12                   |       |
	 * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
	 * |                                 |     | LLLL    | January, February, ..., December  | 2     |
	 * |                                 |     | LLLLL   | J, F, ..., D                      |       |
	 * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
	 * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
	 * |                                 |     | ww      | 01, 02, ..., 53                   |       |
	 * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
	 * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
	 * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
	 * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
	 * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
	 * |                                 |     | dd      | 01, 02, ..., 31                   |       |
	 * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
	 * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
	 * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
	 * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
	 * |                                 |     | DDDD    | ...                               | 2     |
	 * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
	 * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
	 * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
	 * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
	 * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
	 * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
	 * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
	 * |                                 |     | iii     | Mon, Tue, Wed, ..., Sun           | 5     |
	 * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
	 * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
	 * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 5     |
	 * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
	 * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
	 * |                                 |     | ee      | 02, 03, ..., 01                   |       |
	 * |                                 |     | eee     | Mon, Tue, Wed, ..., Sun           |       |
	 * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
	 * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
	 * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
	 * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
	 * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
	 * |                                 |     | cc      | 02, 03, ..., 01                   |       |
	 * |                                 |     | ccc     | Mon, Tue, Wed, ..., Sun           |       |
	 * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
	 * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
	 * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
	 * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
	 * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
	 * |                                 |     | aaaaa   | a, p                              |       |
	 * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
	 * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
	 * |                                 |     | bbbbb   | a, p, n, mi                       |       |
	 * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
	 * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
	 * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
	 * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
	 * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
	 * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
	 * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
	 * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
	 * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
	 * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
	 * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
	 * |                                 |     | KK      | 01, 02, ..., 11, 00               |       |
	 * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
	 * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
	 * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
	 * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
	 * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
	 * |                                 |     | mm      | 00, 01, ..., 59                   |       |
	 * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
	 * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
	 * |                                 |     | ss      | 00, 01, ..., 59                   |       |
	 * | Seconds timestamp               |  40 | t       | 512969520                         |       |
	 * |                                 |     | tt      | ...                               | 2     |
	 * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
	 * |                                 |     | SS      | 00, 01, ..., 99                   |       |
	 * |                                 |     | SSS     | 000, 001, ..., 999                |       |
	 * |                                 |     | SSSS    | ...                               | 2     |
	 * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
	 * |                                 |     | TT      | ...                               | 2     |
	 * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
	 * |                                 |     | XX      | -0800, +0530, Z                   |       |
	 * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
	 * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
	 * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
	 * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
	 * |                                 |     | xx      | -0800, +0530, +0000               |       |
	 * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
	 * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
	 * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
	 * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
	 * |                                 |     | PP      | May 29, 1453                      |       |
	 * |                                 |     | PPP     | May 29th, 1453                    |       |
	 * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
	 * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
	 * |                                 |     | pp      | 12:00:00 AM                       |       |
	 * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
	 * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
	 * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
	 * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
	 * Notes:
	 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
	 *    are the same as "stand-alone" units, but are different in some languages.
	 *    "Formatting" units are declined according to the rules of the language
	 *    in the context of a date. "Stand-alone" units are always nominative singular.
	 *    In `format` function, they will produce different result:
	 *
	 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
	 *
	 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
	 *
	 *    `parse` will try to match both formatting and stand-alone units interchangably.
	 *
	 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
	 *    the single quote characters (see below).
	 *    If the sequence is longer than listed in table:
	 *    - for numerical units (`yyyyyyyy`) `parse` will try to match a number
	 *      as wide as the sequence
	 *    - for text units (`MMMMMMMM`) `parse` will try to match the widest variation of the unit.
	 *      These variations are marked with "2" in the last column of the table.
	 *
	 * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
	 *    These tokens represent the shortest form of the quarter.
	 *
	 * 4. The main difference between `y` and `u` patterns are B.C. years:
	 *
	 *    | Year | `y` | `u` |
	 *    |------|-----|-----|
	 *    | AC 1 |   1 |   1 |
	 *    | BC 1 |   1 |   0 |
	 *    | BC 2 |   2 |  -1 |
	 *
	 *    Also `yy` will try to guess the century of two digit year by proximity with `referenceDate`:
	 *
	 *    `parse('50', 'yy', new Date(2018, 0, 1)) //=> Sat Jan 01 2050 00:00:00`
	 *
	 *    `parse('75', 'yy', new Date(2018, 0, 1)) //=> Wed Jan 01 1975 00:00:00`
	 *
	 *    while `uu` will just assign the year as is:
	 *
	 *    `parse('50', 'uu', new Date(2018, 0, 1)) //=> Sat Jan 01 0050 00:00:00`
	 *
	 *    `parse('75', 'uu', new Date(2018, 0, 1)) //=> Tue Jan 01 0075 00:00:00`
	 *
	 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
	 *    except local week-numbering years are dependent on `options.weekStartsOn`
	 *    and `options.firstWeekContainsDate` (compare [setISOWeekYear]{@link https://date-fns.org/docs/setISOWeekYear}
	 *    and [setWeekYear]{@link https://date-fns.org/docs/setWeekYear}).
	 *
	 * 5. These patterns are not in the Unicode Technical Standard #35:
	 *    - `i`: ISO day of week
	 *    - `I`: ISO week of year
	 *    - `R`: ISO week-numbering year
	 *    - `o`: ordinal number modifier
	 *    - `P`: long localized date
	 *    - `p`: long localized time
	 *
	 * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
	 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 *
	 * 7. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
	 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 *
	 * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
	 *    on the given locale.
	 *
	 *    using `en-US` locale: `P` => `MM/dd/yyyy`
	 *    using `en-US` locale: `p` => `hh:mm a`
	 *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
	 *    using `pt-BR` locale: `p` => `HH:mm`
	 *
	 * Values will be assigned to the date in the descending order of its unit's priority.
	 * Units of an equal priority overwrite each other in the order of appearance.
	 *
	 * If no values of higher priority are parsed (e.g. when parsing string 'January 1st' without a year),
	 * the values will be taken from 3rd argument `referenceDate` which works as a context of parsing.
	 *
	 * `referenceDate` must be passed for correct work of the function.
	 * If you're not sure which `referenceDate` to supply, create a new instance of Date:
	 * `parse('02/11/2014', 'MM/dd/yyyy', new Date())`
	 * In this case parsing will be done in the context of the current date.
	 * If `referenceDate` is `Invalid Date` or a value not convertible to valid `Date`,
	 * then `Invalid Date` will be returned.
	 *
	 * The result may vary by locale.
	 *
	 * If `formatString` matches with `dateString` but does not provides tokens, `referenceDate` will be returned.
	 *
	 * If parsing failed, `Invalid Date` will be returned.
	 * Invalid Date is a Date, whose time value is NaN.
	 * Time value of Date: http://es5.github.io/#x15.9.1.1
	 *
	 * @param {String} dateString - the string to parse
	 * @param {String} formatString - the string of tokens
	 * @param {Date|Number} referenceDate - defines values missing from the parsed dateString
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
	 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
	 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
	 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 * @returns {Date} the parsed date
	 * @throws {TypeError} 3 arguments required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
	 * @throws {RangeError} `options.locale` must contain `match` property
	 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 * @throws {RangeError} format string contains an unescaped latin alphabet character
	 *
	 * @example
	 * // Parse 11 February 2014 from middle-endian format:
	 * var result = parse('02/11/2014', 'MM/dd/yyyy', new Date())
	 * //=> Tue Feb 11 2014 00:00:00
	 *
	 * @example
	 * // Parse 28th of February in Esperanto locale in the context of 2010 year:
	 * import eo from 'date-fns/locale/eo'
	 * var result = parse('28-a de februaro', "do 'de' MMMM", new Date(2010, 0, 1), {
	 *   locale: eo
	 * })
	 * //=> Sun Feb 28 2010 00:00:00
	 */
	function parse(dirtyDateString, dirtyFormatString, dirtyReferenceDate, options) {
	  var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
	  (0, _index9.default)(3, arguments);
	  var dateString = String(dirtyDateString);
	  var formatString = String(dirtyFormatString);
	  var defaultOptions = (0, _index11.getDefaultOptions)();
	  var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : _index.default;
	  if (!locale.match) {
	    throw new RangeError('locale must contain match property');
	  }
	  var firstWeekContainsDate = (0, _index8.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
	
	  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
	  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
	    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
	  }
	  var weekStartsOn = (0, _index8.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
	
	  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
	  }
	  if (formatString === '') {
	    if (dateString === '') {
	      return (0, _index3.default)(dirtyReferenceDate);
	    } else {
	      return new Date(NaN);
	    }
	  }
	  var subFnOptions = {
	    firstWeekContainsDate: firstWeekContainsDate,
	    weekStartsOn: weekStartsOn,
	    locale: locale
	  };
	
	  // If timezone isn't specified, it will be set to the system timezone
	  var setters = [new _Setter.DateToSystemTimezoneSetter()];
	  var tokens = formatString.match(longFormattingTokensRegExp).map(function (substring) {
	    var firstCharacter = substring[0];
	    if (firstCharacter in _index5.default) {
	      var longFormatter = _index5.default[firstCharacter];
	      return longFormatter(substring, locale.formatLong);
	    }
	    return substring;
	  }).join('').match(formattingTokensRegExp);
	  var usedTokens = [];
	  var _iterator = (0, _createForOfIteratorHelper2.default)(tokens),
	    _step;
	  try {
	    var _loop = function _loop() {
	      var token = _step.value;
	      if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, _index7.isProtectedWeekYearToken)(token)) {
	        (0, _index7.throwProtectedError)(token, formatString, dirtyDateString);
	      }
	      if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, _index7.isProtectedDayOfYearToken)(token)) {
	        (0, _index7.throwProtectedError)(token, formatString, dirtyDateString);
	      }
	      var firstCharacter = token[0];
	      var parser = _index10.parsers[firstCharacter];
	      if (parser) {
	        var incompatibleTokens = parser.incompatibleTokens;
	        if (Array.isArray(incompatibleTokens)) {
	          var incompatibleToken = usedTokens.find(function (usedToken) {
	            return incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter;
	          });
	          if (incompatibleToken) {
	            throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
	          }
	        } else if (parser.incompatibleTokens === '*' && usedTokens.length > 0) {
	          throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
	        }
	        usedTokens.push({
	          token: firstCharacter,
	          fullToken: token
	        });
	        var parseResult = parser.run(dateString, token, locale.match, subFnOptions);
	        if (!parseResult) {
	          return {
	            v: new Date(NaN)
	          };
	        }
	        setters.push(parseResult.setter);
	        dateString = parseResult.rest;
	      } else {
	        if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
	          throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
	        }
	
	        // Replace two single quote characters with one single quote character
	        if (token === "''") {
	          token = "'";
	        } else if (firstCharacter === "'") {
	          token = cleanEscapedString(token);
	        }
	
	        // Cut token from string, or, if string doesn't match the token, return Invalid Date
	        if (dateString.indexOf(token) === 0) {
	          dateString = dateString.slice(token.length);
	        } else {
	          return {
	            v: new Date(NaN)
	          };
	        }
	      }
	    };
	    for (_iterator.s(); !(_step = _iterator.n()).done;) {
	      var _ret = _loop();
	      if ((0, _typeof2.default)(_ret) === "object") return _ret.v;
	    }
	
	    // Check if the remaining input contains something other than whitespace
	  } catch (err) {
	    _iterator.e(err);
	  } finally {
	    _iterator.f();
	  }
	  if (dateString.length > 0 && notWhitespaceRegExp.test(dateString)) {
	    return new Date(NaN);
	  }
	  var uniquePrioritySetters = setters.map(function (setter) {
	    return setter.priority;
	  }).sort(function (a, b) {
	    return b - a;
	  }).filter(function (priority, index, array) {
	    return array.indexOf(priority) === index;
	  }).map(function (priority) {
	    return setters.filter(function (setter) {
	      return setter.priority === priority;
	    }).sort(function (a, b) {
	      return b.subPriority - a.subPriority;
	    });
	  }).map(function (setterArray) {
	    return setterArray[0];
	  });
	  var date = (0, _index3.default)(dirtyReferenceDate);
	  if (isNaN(date.getTime())) {
	    return new Date(NaN);
	  }
	
	  // Convert the date in system timezone to the same date in UTC+00:00 timezone.
	  var utcDate = (0, _index2.default)(date, (0, _index6.default)(date));
	  var flags = {};
	  var _iterator2 = (0, _createForOfIteratorHelper2.default)(uniquePrioritySetters),
	    _step2;
	  try {
	    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
	      var setter = _step2.value;
	      if (!setter.validate(utcDate, subFnOptions)) {
	        return new Date(NaN);
	      }
	      var result = setter.set(utcDate, flags, subFnOptions);
	      // Result is tuple (date, flags)
	      if (Array.isArray(result)) {
	        utcDate = result[0];
	        (0, _index4.default)(flags, result[1]);
	        // Result is date
	      } else {
	        utcDate = result;
	      }
	    }
	  } catch (err) {
	    _iterator2.e(err);
	  } finally {
	    _iterator2.f();
	  }
	  return utcDate;
	}
	function cleanEscapedString(input) {
	  return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
	}
	module.exports = exports.default;

/***/ },
/* 1160 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = parseISO;
	var _index = __webpack_require__(384);
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	var _index3 = _interopRequireDefault(__webpack_require__(30));
	/**
	 * @name parseISO
	 * @category Common Helpers
	 * @summary Parse ISO string
	 *
	 * @description
	 * Parse the given string in ISO 8601 format and return an instance of Date.
	 *
	 * Function accepts complete ISO 8601 formats as well as partial implementations.
	 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
	 *
	 * If the argument isn't a string, the function cannot parse the string or
	 * the values are invalid, it returns Invalid Date.
	 *
	 * @param {String} argument - the value to convert
	 * @param {Object} [options] - an object with options.
	 * @param {0|1|2} [options.additionalDigits=2] - the additional number of digits in the extended year format
	 * @returns {Date} the parsed date in the local time zone
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 *
	 * @example
	 * // Convert string '2014-02-11T11:30:30' to date:
	 * const result = parseISO('2014-02-11T11:30:30')
	 * //=> Tue Feb 11 2014 11:30:30
	 *
	 * @example
	 * // Convert string '+02014101' to date,
	 * // if the additional number of digits in the extended year format is 1:
	 * const result = parseISO('+02014101', { additionalDigits: 1 })
	 * //=> Fri Apr 11 2014 00:00:00
	 */
	function parseISO(argument, options) {
	  var _options$additionalDi;
	  (0, _index2.default)(1, arguments);
	  var additionalDigits = (0, _index3.default)((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
	  if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) {
	    throw new RangeError('additionalDigits must be 0, 1 or 2');
	  }
	  if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) {
	    return new Date(NaN);
	  }
	  var dateStrings = splitDateString(argument);
	  var date;
	  if (dateStrings.date) {
	    var parseYearResult = parseYear(dateStrings.date, additionalDigits);
	    date = parseDate(parseYearResult.restDateString, parseYearResult.year);
	  }
	  if (!date || isNaN(date.getTime())) {
	    return new Date(NaN);
	  }
	  var timestamp = date.getTime();
	  var time = 0;
	  var offset;
	  if (dateStrings.time) {
	    time = parseTime(dateStrings.time);
	    if (isNaN(time)) {
	      return new Date(NaN);
	    }
	  }
	  if (dateStrings.timezone) {
	    offset = parseTimezone(dateStrings.timezone);
	    if (isNaN(offset)) {
	      return new Date(NaN);
	    }
	  } else {
	    var dirtyDate = new Date(timestamp + time);
	    // js parsed string assuming it's in UTC timezone
	    // but we need it to be parsed in our timezone
	    // so we use utc values to build date in our timezone.
	    // Year values from 0 to 99 map to the years 1900 to 1999
	    // so set year explicitly with setFullYear.
	    var result = new Date(0);
	    result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
	    result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
	    return result;
	  }
	  return new Date(timestamp + time + offset);
	}
	var patterns = {
	  dateTimeDelimiter: /[T ]/,
	  timeZoneDelimiter: /[Z ]/i,
	  timezone: /([Z+-].*)$/
	};
	var dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
	var timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
	var timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
	function splitDateString(dateString) {
	  var dateStrings = {};
	  var array = dateString.split(patterns.dateTimeDelimiter);
	  var timeString;
	
	  // The regex match should only return at maximum two array elements.
	  // [date], [time], or [date, time].
	  if (array.length > 2) {
	    return dateStrings;
	  }
	  if (/:/.test(array[0])) {
	    timeString = array[0];
	  } else {
	    dateStrings.date = array[0];
	    timeString = array[1];
	    if (patterns.timeZoneDelimiter.test(dateStrings.date)) {
	      dateStrings.date = dateString.split(patterns.timeZoneDelimiter)[0];
	      timeString = dateString.substr(dateStrings.date.length, dateString.length);
	    }
	  }
	  if (timeString) {
	    var token = patterns.timezone.exec(timeString);
	    if (token) {
	      dateStrings.time = timeString.replace(token[1], '');
	      dateStrings.timezone = token[1];
	    } else {
	      dateStrings.time = timeString;
	    }
	  }
	  return dateStrings;
	}
	function parseYear(dateString, additionalDigits) {
	  var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
	  var captures = dateString.match(regex);
	  // Invalid ISO-formatted year
	  if (!captures) return {
	    year: NaN,
	    restDateString: ''
	  };
	  var year = captures[1] ? parseInt(captures[1]) : null;
	  var century = captures[2] ? parseInt(captures[2]) : null;
	
	  // either year or century is null, not both
	  return {
	    year: century === null ? year : century * 100,
	    restDateString: dateString.slice((captures[1] || captures[2]).length)
	  };
	}
	function parseDate(dateString, year) {
	  // Invalid ISO-formatted year
	  if (year === null) return new Date(NaN);
	  var captures = dateString.match(dateRegex);
	  // Invalid ISO-formatted string
	  if (!captures) return new Date(NaN);
	  var isWeekDate = !!captures[4];
	  var dayOfYear = parseDateUnit(captures[1]);
	  var month = parseDateUnit(captures[2]) - 1;
	  var day = parseDateUnit(captures[3]);
	  var week = parseDateUnit(captures[4]);
	  var dayOfWeek = parseDateUnit(captures[5]) - 1;
	  if (isWeekDate) {
	    if (!validateWeekDate(year, week, dayOfWeek)) {
	      return new Date(NaN);
	    }
	    return dayOfISOWeekYear(year, week, dayOfWeek);
	  } else {
	    var date = new Date(0);
	    if (!validateDate(year, month, day) || !validateDayOfYearDate(year, dayOfYear)) {
	      return new Date(NaN);
	    }
	    date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
	    return date;
	  }
	}
	function parseDateUnit(value) {
	  return value ? parseInt(value) : 1;
	}
	function parseTime(timeString) {
	  var captures = timeString.match(timeRegex);
	  if (!captures) return NaN; // Invalid ISO-formatted time
	
	  var hours = parseTimeUnit(captures[1]);
	  var minutes = parseTimeUnit(captures[2]);
	  var seconds = parseTimeUnit(captures[3]);
	  if (!validateTime(hours, minutes, seconds)) {
	    return NaN;
	  }
	  return hours * _index.millisecondsInHour + minutes * _index.millisecondsInMinute + seconds * 1000;
	}
	function parseTimeUnit(value) {
	  return value && parseFloat(value.replace(',', '.')) || 0;
	}
	function parseTimezone(timezoneString) {
	  if (timezoneString === 'Z') return 0;
	  var captures = timezoneString.match(timezoneRegex);
	  if (!captures) return 0;
	  var sign = captures[1] === '+' ? -1 : 1;
	  var hours = parseInt(captures[2]);
	  var minutes = captures[3] && parseInt(captures[3]) || 0;
	  if (!validateTimezone(hours, minutes)) {
	    return NaN;
	  }
	  return sign * (hours * _index.millisecondsInHour + minutes * _index.millisecondsInMinute);
	}
	function dayOfISOWeekYear(isoWeekYear, week, day) {
	  var date = new Date(0);
	  date.setUTCFullYear(isoWeekYear, 0, 4);
	  var fourthOfJanuaryDay = date.getUTCDay() || 7;
	  var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
	  date.setUTCDate(date.getUTCDate() + diff);
	  return date;
	}
	
	// Validation functions
	
	// February is null to handle the leap year (using ||)
	var daysInMonths = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
	function isLeapYearIndex(year) {
	  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
	}
	function validateDate(year, month, date) {
	  return month >= 0 && month <= 11 && date >= 1 && date <= (daysInMonths[month] || (isLeapYearIndex(year) ? 29 : 28));
	}
	function validateDayOfYearDate(year, dayOfYear) {
	  return dayOfYear >= 1 && dayOfYear <= (isLeapYearIndex(year) ? 366 : 365);
	}
	function validateWeekDate(_year, week, day) {
	  return week >= 1 && week <= 53 && day >= 0 && day <= 6;
	}
	function validateTime(hours, minutes, seconds) {
	  if (hours === 24) {
	    return minutes === 0 && seconds === 0;
	  }
	  return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
	}
	function validateTimezone(_hours, minutes) {
	  return minutes >= 0 && minutes <= 59;
	}
	module.exports = exports.default;

/***/ },
/* 1161 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setHours;
	var _index = _interopRequireDefault(__webpack_require__(30));
	var _index2 = _interopRequireDefault(__webpack_require__(23));
	var _index3 = _interopRequireDefault(__webpack_require__(14));
	/**
	 * @name setHours
	 * @category Hour Helpers
	 * @summary Set the hours to the given date.
	 *
	 * @description
	 * Set the hours to the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} hours - the hours of the new date
	 * @returns {Date} the new date with the hours set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set 4 hours to 1 September 2014 11:30:00:
	 * const result = setHours(new Date(2014, 8, 1, 11, 30), 4)
	 * //=> Mon Sep 01 2014 04:30:00
	 */
	function setHours(dirtyDate, dirtyHours) {
	  (0, _index3.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var hours = (0, _index.default)(dirtyHours);
	  date.setHours(hours);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 1162 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setMinutes;
	var _index = _interopRequireDefault(__webpack_require__(30));
	var _index2 = _interopRequireDefault(__webpack_require__(23));
	var _index3 = _interopRequireDefault(__webpack_require__(14));
	/**
	 * @name setMinutes
	 * @category Minute Helpers
	 * @summary Set the minutes to the given date.
	 *
	 * @description
	 * Set the minutes to the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} minutes - the minutes of the new date
	 * @returns {Date} the new date with the minutes set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set 45 minutes to 1 September 2014 11:30:40:
	 * const result = setMinutes(new Date(2014, 8, 1, 11, 30, 40), 45)
	 * //=> Mon Sep 01 2014 11:45:40
	 */
	function setMinutes(dirtyDate, dirtyMinutes) {
	  (0, _index3.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var minutes = (0, _index.default)(dirtyMinutes);
	  date.setMinutes(minutes);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 1163 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setQuarter;
	var _index = _interopRequireDefault(__webpack_require__(30));
	var _index2 = _interopRequireDefault(__webpack_require__(23));
	var _index3 = _interopRequireDefault(__webpack_require__(388));
	var _index4 = _interopRequireDefault(__webpack_require__(14));
	/**
	 * @name setQuarter
	 * @category Quarter Helpers
	 * @summary Set the year quarter to the given date.
	 *
	 * @description
	 * Set the year quarter to the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} quarter - the quarter of the new date
	 * @returns {Date} the new date with the quarter set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set the 2nd quarter to 2 July 2014:
	 * const result = setQuarter(new Date(2014, 6, 2), 2)
	 * //=> Wed Apr 02 2014 00:00:00
	 */
	function setQuarter(dirtyDate, dirtyQuarter) {
	  (0, _index4.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var quarter = (0, _index.default)(dirtyQuarter);
	  var oldQuarter = Math.floor(date.getMonth() / 3) + 1;
	  var diff = quarter - oldQuarter;
	  return (0, _index3.default)(date, date.getMonth() + diff * 3);
	}
	module.exports = exports.default;

/***/ },
/* 1164 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setSeconds;
	var _index = _interopRequireDefault(__webpack_require__(30));
	var _index2 = _interopRequireDefault(__webpack_require__(23));
	var _index3 = _interopRequireDefault(__webpack_require__(14));
	/**
	 * @name setSeconds
	 * @category Second Helpers
	 * @summary Set the seconds to the given date.
	 *
	 * @description
	 * Set the seconds to the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} seconds - the seconds of the new date
	 * @returns {Date} the new date with the seconds set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set 45 seconds to 1 September 2014 11:30:40:
	 * const result = setSeconds(new Date(2014, 8, 1, 11, 30, 40), 45)
	 * //=> Mon Sep 01 2014 11:30:45
	 */
	function setSeconds(dirtyDate, dirtySeconds) {
	  (0, _index3.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var seconds = (0, _index.default)(dirtySeconds);
	  date.setSeconds(seconds);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 1165 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setYear;
	var _index = _interopRequireDefault(__webpack_require__(30));
	var _index2 = _interopRequireDefault(__webpack_require__(23));
	var _index3 = _interopRequireDefault(__webpack_require__(14));
	/**
	 * @name setYear
	 * @category Year Helpers
	 * @summary Set the year to the given date.
	 *
	 * @description
	 * Set the year to the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} year - the year of the new date
	 * @returns {Date} the new date with the year set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set year 2013 to 1 September 2014:
	 * const result = setYear(new Date(2014, 8, 1), 2013)
	 * //=> Sun Sep 01 2013 00:00:00
	 */
	function setYear(dirtyDate, dirtyYear) {
	  (0, _index3.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var year = (0, _index.default)(dirtyYear);
	
	  // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
	  if (isNaN(date.getTime())) {
	    return new Date(NaN);
	  }
	  date.setFullYear(year);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 1166 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfISOWeekYear;
	var _index = _interopRequireDefault(__webpack_require__(1100));
	var _index2 = _interopRequireDefault(__webpack_require__(259));
	var _index3 = _interopRequireDefault(__webpack_require__(14));
	/**
	 * @name startOfISOWeekYear
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Return the start of an ISO week-numbering year for the given date.
	 *
	 * @description
	 * Return the start of an ISO week-numbering year,
	 * which always starts 3 days before the year's first Thursday.
	 * The result will be in the local timezone.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the start of an ISO week-numbering year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The start of an ISO week-numbering year for 2 July 2005:
	 * const result = startOfISOWeekYear(new Date(2005, 6, 2))
	 * //=> Mon Jan 03 2005 00:00:00
	 */
	function startOfISOWeekYear(dirtyDate) {
	  (0, _index3.default)(1, arguments);
	  var year = (0, _index.default)(dirtyDate);
	  var fourthOfJanuary = new Date(0);
	  fourthOfJanuary.setFullYear(year, 0, 4);
	  fourthOfJanuary.setHours(0, 0, 0, 0);
	  var date = (0, _index2.default)(fourthOfJanuary);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 1167 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfMonth;
	var _index = _interopRequireDefault(__webpack_require__(23));
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	/**
	 * @name startOfMonth
	 * @category Month Helpers
	 * @summary Return the start of a month for the given date.
	 *
	 * @description
	 * Return the start of a month for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the start of a month
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The start of a month for 2 September 2014 11:55:00:
	 * const result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Mon Sep 01 2014 00:00:00
	 */
	function startOfMonth(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  date.setDate(1);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 1168 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfYear;
	var _index = _interopRequireDefault(__webpack_require__(23));
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	/**
	 * @name startOfYear
	 * @category Year Helpers
	 * @summary Return the start of a year for the given date.
	 *
	 * @description
	 * Return the start of a year for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the start of a year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The start of a year for 2 September 2014 11:55:00:
	 * const result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
	 * //=> Wed Jan 01 2014 00:00:00
	 */
	function startOfYear(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var cleanDate = (0, _index.default)(dirtyDate);
	  var date = new Date(0);
	  date.setFullYear(cleanDate.getFullYear(), 0, 1);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 1169 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subDays;
	var _index = _interopRequireDefault(__webpack_require__(255));
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	var _index3 = _interopRequireDefault(__webpack_require__(30));
	/**
	 * @name subDays
	 * @category Day Helpers
	 * @summary Subtract the specified number of days from the given date.
	 *
	 * @description
	 * Subtract the specified number of days from the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of days to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the days subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 10 days from 1 September 2014:
	 * const result = subDays(new Date(2014, 8, 1), 10)
	 * //=> Fri Aug 22 2014 00:00:00
	 */
	function subDays(dirtyDate, dirtyAmount) {
	  (0, _index2.default)(2, arguments);
	  var amount = (0, _index3.default)(dirtyAmount);
	  return (0, _index.default)(dirtyDate, -amount);
	}
	module.exports = exports.default;

/***/ },
/* 1170 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subHours;
	var _index = _interopRequireDefault(__webpack_require__(380));
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	var _index3 = _interopRequireDefault(__webpack_require__(30));
	/**
	 * @name subHours
	 * @category Hour Helpers
	 * @summary Subtract the specified number of hours from the given date.
	 *
	 * @description
	 * Subtract the specified number of hours from the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of hours to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the hours subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 2 hours from 11 July 2014 01:00:00:
	 * const result = subHours(new Date(2014, 6, 11, 1, 0), 2)
	 * //=> Thu Jul 10 2014 23:00:00
	 */
	function subHours(dirtyDate, dirtyAmount) {
	  (0, _index2.default)(2, arguments);
	  var amount = (0, _index3.default)(dirtyAmount);
	  return (0, _index.default)(dirtyDate, -amount);
	}
	module.exports = exports.default;

/***/ },
/* 1171 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subMinutes;
	var _index = _interopRequireDefault(__webpack_require__(381));
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	var _index3 = _interopRequireDefault(__webpack_require__(30));
	/**
	 * @name subMinutes
	 * @category Minute Helpers
	 * @summary Subtract the specified number of minutes from the given date.
	 *
	 * @description
	 * Subtract the specified number of minutes from the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of minutes to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the minutes subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 30 minutes from 10 July 2014 12:00:00:
	 * const result = subMinutes(new Date(2014, 6, 10, 12, 0), 30)
	 * //=> Thu Jul 10 2014 11:30:00
	 */
	function subMinutes(dirtyDate, dirtyAmount) {
	  (0, _index2.default)(2, arguments);
	  var amount = (0, _index3.default)(dirtyAmount);
	  return (0, _index.default)(dirtyDate, -amount);
	}
	module.exports = exports.default;

/***/ },
/* 1172 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subMonths;
	var _index = _interopRequireDefault(__webpack_require__(30));
	var _index2 = _interopRequireDefault(__webpack_require__(257));
	var _index3 = _interopRequireDefault(__webpack_require__(14));
	/**
	 * @name subMonths
	 * @category Month Helpers
	 * @summary Subtract the specified number of months from the given date.
	 *
	 * @description
	 * Subtract the specified number of months from the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of months to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the months subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 5 months from 1 February 2015:
	 * const result = subMonths(new Date(2015, 1, 1), 5)
	 * //=> Mon Sep 01 2014 00:00:00
	 */
	function subMonths(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, -amount);
	}
	module.exports = exports.default;

/***/ },
/* 1173 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subWeeks;
	var _index = _interopRequireDefault(__webpack_require__(30));
	var _index2 = _interopRequireDefault(__webpack_require__(382));
	var _index3 = _interopRequireDefault(__webpack_require__(14));
	/**
	 * @name subWeeks
	 * @category Week Helpers
	 * @summary Subtract the specified number of weeks from the given date.
	 *
	 * @description
	 * Subtract the specified number of weeks from the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of weeks to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the weeks subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 4 weeks from 1 September 2014:
	 * const result = subWeeks(new Date(2014, 8, 1), 4)
	 * //=> Mon Aug 04 2014 00:00:00
	 */
	function subWeeks(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, -amount);
	}
	module.exports = exports.default;

/***/ },
/* 1174 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subYears;
	var _index = _interopRequireDefault(__webpack_require__(30));
	var _index2 = _interopRequireDefault(__webpack_require__(383));
	var _index3 = _interopRequireDefault(__webpack_require__(14));
	/**
	 * @name subYears
	 * @category Year Helpers
	 * @summary Subtract the specified number of years from the given date.
	 *
	 * @description
	 * Subtract the specified number of years from the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of years to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the years subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 5 years from 1 September 2014:
	 * const result = subYears(new Date(2014, 8, 1), 5)
	 * //=> Tue Sep 01 2009 00:00:00
	 */
	function subYears(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, -amount);
	}
	module.exports = exports.default;

/***/ },
/* 1175 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * This is the web browser implementation of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = __webpack_require__(1176);
	exports.log = log;
	exports.formatArgs = formatArgs;
	exports.save = save;
	exports.load = load;
	exports.useColors = useColors;
	exports.storage = 'undefined' != typeof chrome
	               && 'undefined' != typeof chrome.storage
	                  ? chrome.storage.local
	                  : localstorage();
	
	/**
	 * Colors.
	 */
	
	exports.colors = [
	  'lightseagreen',
	  'forestgreen',
	  'goldenrod',
	  'dodgerblue',
	  'darkorchid',
	  'crimson'
	];
	
	/**
	 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
	 * and the Firebug extension (any Firefox version) are known
	 * to support "%c" CSS customizations.
	 *
	 * TODO: add a `localStorage` variable to explicitly enable/disable colors
	 */
	
	function useColors() {
	  // NB: In an Electron preload script, document will be defined but not fully
	  // initialized. Since we know we're in Chrome, we'll just detect this case
	  // explicitly
	  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
	    return true;
	  }
	
	  // is webkit? http://stackoverflow.com/a/16459606/376773
	  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
	  return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
	    // is firebug? http://stackoverflow.com/a/398120/376773
	    (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
	    // is firefox >= v31?
	    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
	    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
	    // double check webkit in userAgent just in case we are in a worker
	    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
	}
	
	/**
	 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
	 */
	
	exports.formatters.j = function(v) {
	  try {
	    return JSON.stringify(v);
	  } catch (err) {
	    return '[UnexpectedJSONParseError]: ' + err.message;
	  }
	};
	
	
	/**
	 * Colorize log arguments if enabled.
	 *
	 * @api public
	 */
	
	function formatArgs(args) {
	  var useColors = this.useColors;
	
	  args[0] = (useColors ? '%c' : '')
	    + this.namespace
	    + (useColors ? ' %c' : ' ')
	    + args[0]
	    + (useColors ? '%c ' : ' ')
	    + '+' + exports.humanize(this.diff);
	
	  if (!useColors) return;
	
	  var c = 'color: ' + this.color;
	  args.splice(1, 0, c, 'color: inherit')
	
	  // the final "%c" is somewhat tricky, because there could be other
	  // arguments passed either before or after the %c, so we need to
	  // figure out the correct index to insert the CSS into
	  var index = 0;
	  var lastC = 0;
	  args[0].replace(/%[a-zA-Z%]/g, function(match) {
	    if ('%%' === match) return;
	    index++;
	    if ('%c' === match) {
	      // we only are interested in the *last* %c
	      // (the user may have provided their own)
	      lastC = index;
	    }
	  });
	
	  args.splice(lastC, 0, c);
	}
	
	/**
	 * Invokes `console.log()` when available.
	 * No-op when `console.log` is not a "function".
	 *
	 * @api public
	 */
	
	function log() {
	  // this hackery is required for IE8/9, where
	  // the `console.log` function doesn't have 'apply'
	  return 'object' === typeof console
	    && console.log
	    && Function.prototype.apply.call(console.log, console, arguments);
	}
	
	/**
	 * Save `namespaces`.
	 *
	 * @param {String} namespaces
	 * @api private
	 */
	
	function save(namespaces) {
	  try {
	    if (null == namespaces) {
	      exports.storage.removeItem('debug');
	    } else {
	      exports.storage.debug = namespaces;
	    }
	  } catch(e) {}
	}
	
	/**
	 * Load `namespaces`.
	 *
	 * @return {String} returns the previously persisted debug modes
	 * @api private
	 */
	
	function load() {
	  var r;
	  try {
	    r = exports.storage.debug;
	  } catch(e) {}
	
	  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
	  if (!r && typeof process !== 'undefined' && 'env' in process) {
	    r = ({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_USERURL":"https://www.bewise.in/","REACT_APP_TINY_EDITOR":"te4wakzk2tutx8pwzcbikp01f6cqsemlyubqa6juufgdrwmm","REACT_APP_RAZORPAY_LIVE":"rzp_live_B1Rc514TPFi72L","REACT_APP_GOOGLE_CAPTCHA_SITE_KEY":"6Le5HyAqAAAAAPcf0Em_niWQ8eWnVwTIbQdwU0pW","REACT_APP_API_PATH":"https://api.bewise.in/api/","REACT_APP_RAZORPAY_TEST":"rzp_live_B1Rc514TPFi72L","REACT_APP_ASSET_PATH":"https://bewiseblobprod.blob.core.windows.net/assets/bewise/uploads/","REACT_APP_GOOGLE_CAPTCHA_SECRET_KEY":"6Le5HyAqAAAAADaxdwTC-cyLAsOI27illPepM6Wu"}).DEBUG;
	  }
	
	  return r;
	}
	
	/**
	 * Enable namespaces listed in `localStorage.debug` initially.
	 */
	
	exports.enable(load());
	
	/**
	 * Localstorage attempts to return the localstorage.
	 *
	 * This is necessary because safari throws
	 * when a user disables cookies/localstorage
	 * and you attempt to access it.
	 *
	 * @return {LocalStorage}
	 * @api private
	 */
	
	function localstorage() {
	  try {
	    return window.localStorage;
	  } catch (e) {}
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(111)))

/***/ },
/* 1176 */
/***/ function(module, exports, __webpack_require__) {

	
	/**
	 * This is the common logic for both the Node.js and web browser
	 * implementations of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
	exports.coerce = coerce;
	exports.disable = disable;
	exports.enable = enable;
	exports.enabled = enabled;
	exports.humanize = __webpack_require__(1348);
	
	/**
	 * The currently active debug mode names, and names to skip.
	 */
	
	exports.names = [];
	exports.skips = [];
	
	/**
	 * Map of special "%n" handling functions, for the debug "format" argument.
	 *
	 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
	 */
	
	exports.formatters = {};
	
	/**
	 * Previous log timestamp.
	 */
	
	var prevTime;
	
	/**
	 * Select a color.
	 * @param {String} namespace
	 * @return {Number}
	 * @api private
	 */
	
	function selectColor(namespace) {
	  var hash = 0, i;
	
	  for (i in namespace) {
	    hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
	    hash |= 0; // Convert to 32bit integer
	  }
	
	  return exports.colors[Math.abs(hash) % exports.colors.length];
	}
	
	/**
	 * Create a debugger with the given `namespace`.
	 *
	 * @param {String} namespace
	 * @return {Function}
	 * @api public
	 */
	
	function createDebug(namespace) {
	
	  function debug() {
	    // disabled?
	    if (!debug.enabled) return;
	
	    var self = debug;
	
	    // set `diff` timestamp
	    var curr = +new Date();
	    var ms = curr - (prevTime || curr);
	    self.diff = ms;
	    self.prev = prevTime;
	    self.curr = curr;
	    prevTime = curr;
	
	    // turn the `arguments` into a proper Array
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	
	    args[0] = exports.coerce(args[0]);
	
	    if ('string' !== typeof args[0]) {
	      // anything else let's inspect with %O
	      args.unshift('%O');
	    }
	
	    // apply any `formatters` transformations
	    var index = 0;
	    args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
	      // if we encounter an escaped % then don't increase the array index
	      if (match === '%%') return match;
	      index++;
	      var formatter = exports.formatters[format];
	      if ('function' === typeof formatter) {
	        var val = args[index];
	        match = formatter.call(self, val);
	
	        // now we need to remove `args[index]` since it's inlined in the `format`
	        args.splice(index, 1);
	        index--;
	      }
	      return match;
	    });
	
	    // apply env-specific formatting (colors, etc.)
	    exports.formatArgs.call(self, args);
	
	    var logFn = debug.log || exports.log || console.log.bind(console);
	    logFn.apply(self, args);
	  }
	
	  debug.namespace = namespace;
	  debug.enabled = exports.enabled(namespace);
	  debug.useColors = exports.useColors();
	  debug.color = selectColor(namespace);
	
	  // env-specific initialization logic for debug instances
	  if ('function' === typeof exports.init) {
	    exports.init(debug);
	  }
	
	  return debug;
	}
	
	/**
	 * Enables a debug mode by namespaces. This can include modes
	 * separated by a colon and wildcards.
	 *
	 * @param {String} namespaces
	 * @api public
	 */
	
	function enable(namespaces) {
	  exports.save(namespaces);
	
	  exports.names = [];
	  exports.skips = [];
	
	  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
	  var len = split.length;
	
	  for (var i = 0; i < len; i++) {
	    if (!split[i]) continue; // ignore empty strings
	    namespaces = split[i].replace(/\*/g, '.*?');
	    if (namespaces[0] === '-') {
	      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
	    } else {
	      exports.names.push(new RegExp('^' + namespaces + '$'));
	    }
	  }
	}
	
	/**
	 * Disable debug output.
	 *
	 * @api public
	 */
	
	function disable() {
	  exports.enable('');
	}
	
	/**
	 * Returns true if the given mode name is enabled, false otherwise.
	 *
	 * @param {String} name
	 * @return {Boolean}
	 * @api public
	 */
	
	function enabled(name) {
	  var i, len;
	  for (i = 0, len = exports.skips.length; i < len; i++) {
	    if (exports.skips[i].test(name)) {
	      return false;
	    }
	  }
	  for (i = 0, len = exports.names.length; i < len; i++) {
	    if (exports.names[i].test(name)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * Coerce `val`.
	 *
	 * @param {Mixed} val
	 * @return {Mixed}
	 * @api private
	 */
	
	function coerce(val) {
	  if (val instanceof Error) return val.stack || val.message;
	  return val;
	}


/***/ },
/* 1177 */
/***/ function(module, exports, __webpack_require__) {

	var objectKeys = __webpack_require__(592);
	var isArguments = __webpack_require__(1308);
	var is = __webpack_require__(1350);
	var isRegex = __webpack_require__(1310);
	var flags = __webpack_require__(1610);
	var isDate = __webpack_require__(1309);
	
	var getTime = Date.prototype.getTime;
	
	function deepEqual(actual, expected, options) {
	  var opts = options || {};
	
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (opts.strict ? is(actual, expected) : actual === expected) {
	    return true;
	  }
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object', equivalence is determined by ==.
	  if (!actual || !expected || (typeof actual !== 'object' && typeof expected !== 'object')) {
	    return opts.strict ? is(actual, expected) : actual == expected;
	  }
	
	  /*
	   * 7.4. For all other Object pairs, including Array objects, equivalence is
	   * determined by having the same number of owned properties (as verified
	   * with Object.prototype.hasOwnProperty.call), the same set of keys
	   * (although not necessarily the same order), equivalent values for every
	   * corresponding key, and an identical 'prototype' property. Note: this
	   * accounts for both named and indexed properties on Arrays.
	   */
	  // eslint-disable-next-line no-use-before-define
	  return objEquiv(actual, expected, opts);
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer(x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') {
	    return false;
	  }
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') {
	    return false;
	  }
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  /* eslint max-statements: [2, 50] */
	  var i, key;
	  if (typeof a !== typeof b) { return false; }
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b)) { return false; }
	
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) { return false; }
	
	  if (isArguments(a) !== isArguments(b)) { return false; }
	
	  var aIsRegex = isRegex(a);
	  var bIsRegex = isRegex(b);
	  if (aIsRegex !== bIsRegex) { return false; }
	  if (aIsRegex || bIsRegex) {
	    return a.source === b.source && flags(a) === flags(b);
	  }
	
	  if (isDate(a) && isDate(b)) {
	    return getTime.call(a) === getTime.call(b);
	  }
	
	  var aIsBuffer = isBuffer(a);
	  var bIsBuffer = isBuffer(b);
	  if (aIsBuffer !== bIsBuffer) { return false; }
	  if (aIsBuffer || bIsBuffer) { // && would work too, because both are true or both false here
	    if (a.length !== b.length) { return false; }
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) { return false; }
	    }
	    return true;
	  }
	
	  if (typeof a !== typeof b) { return false; }
	
	  try {
	    var ka = objectKeys(a);
	    var kb = objectKeys(b);
	  } catch (e) { // happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates hasOwnProperty)
	  if (ka.length !== kb.length) { return false; }
	
	  // the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  // ~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i]) { return false; }
	  }
	  // equivalent values for every corresponding key, and ~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) { return false; }
	  }
	
	  return true;
	}
	
	module.exports = deepEqual;


/***/ },
/* 1178 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = addClass;
	
	var _hasClass = _interopRequireDefault(__webpack_require__(1179));
	
	/**
	 * Adds a CSS class to a given element.
	 * 
	 * @param element the element
	 * @param className the CSS class name
	 */
	function addClass(element, className) {
	  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + " " + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
	}
	
	module.exports = exports["default"];

/***/ },
/* 1179 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = hasClass;
	
	/**
	 * Checks if a given element has a CSS class.
	 * 
	 * @param element the element
	 * @param className the CSS class name
	 */
	function hasClass(element, className) {
	  if (element.classList) return !!className && element.classList.contains(className);
	  return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
	}
	
	module.exports = exports["default"];

/***/ },
/* 1180 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = removeClass;
	
	function replaceClassName(origClass, classToRemove) {
	  return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
	}
	/**
	 * Removes a CSS class from a given element.
	 * 
	 * @param element the element
	 * @param className the CSS class name
	 */
	
	
	function removeClass(element, className) {
	  if (element.classList) {
	    element.classList.remove(className);
	  } else if (typeof element.className === 'string') {
	    element.className = replaceClassName(element.className, className);
	  } else {
	    element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
	  }
	}
	
	module.exports = exports["default"];

/***/ },
/* 1181 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var BlockMapBuilder = __webpack_require__(151);
	
	var CharacterMetadata = __webpack_require__(70);
	
	var ContentBlock = __webpack_require__(104);
	
	var ContentBlockNode = __webpack_require__(71);
	
	var DraftModifier = __webpack_require__(59);
	
	var EditorState = __webpack_require__(36);
	
	var generateRandomKey = __webpack_require__(85);
	
	var gkx = __webpack_require__(97);
	
	var Immutable = __webpack_require__(27);
	
	var moveBlockInContentState = __webpack_require__(1248);
	
	var experimentalTreeDataSupport = gkx('draft_tree_data_support');
	var ContentBlockRecord = experimentalTreeDataSupport ? ContentBlockNode : ContentBlock;
	var List = Immutable.List,
	    Repeat = Immutable.Repeat;
	var AtomicBlockUtils = {
	  insertAtomicBlock: function insertAtomicBlock(editorState, entityKey, character) {
	    var contentState = editorState.getCurrentContent();
	    var selectionState = editorState.getSelection();
	    var afterRemoval = DraftModifier.removeRange(contentState, selectionState, 'backward');
	    var targetSelection = afterRemoval.getSelectionAfter();
	    var afterSplit = DraftModifier.splitBlock(afterRemoval, targetSelection);
	    var insertionTarget = afterSplit.getSelectionAfter();
	    var asAtomicBlock = DraftModifier.setBlockType(afterSplit, insertionTarget, 'atomic');
	    var charData = CharacterMetadata.create({
	      entity: entityKey
	    });
	    var atomicBlockConfig = {
	      key: generateRandomKey(),
	      type: 'atomic',
	      text: character,
	      characterList: List(Repeat(charData, character.length))
	    };
	    var atomicDividerBlockConfig = {
	      key: generateRandomKey(),
	      type: 'unstyled'
	    };
	
	    if (experimentalTreeDataSupport) {
	      atomicBlockConfig = _objectSpread({}, atomicBlockConfig, {
	        nextSibling: atomicDividerBlockConfig.key
	      });
	      atomicDividerBlockConfig = _objectSpread({}, atomicDividerBlockConfig, {
	        prevSibling: atomicBlockConfig.key
	      });
	    }
	
	    var fragmentArray = [new ContentBlockRecord(atomicBlockConfig), new ContentBlockRecord(atomicDividerBlockConfig)];
	    var fragment = BlockMapBuilder.createFromArray(fragmentArray);
	    var withAtomicBlock = DraftModifier.replaceWithFragment(asAtomicBlock, insertionTarget, fragment);
	    var newContent = withAtomicBlock.merge({
	      selectionBefore: selectionState,
	      selectionAfter: withAtomicBlock.getSelectionAfter().set('hasFocus', true)
	    });
	    return EditorState.push(editorState, newContent, 'insert-fragment');
	  },
	  moveAtomicBlock: function moveAtomicBlock(editorState, atomicBlock, targetRange, insertionMode) {
	    var contentState = editorState.getCurrentContent();
	    var selectionState = editorState.getSelection();
	    var withMovedAtomicBlock;
	
	    if (insertionMode === 'before' || insertionMode === 'after') {
	      var targetBlock = contentState.getBlockForKey(insertionMode === 'before' ? targetRange.getStartKey() : targetRange.getEndKey());
	      withMovedAtomicBlock = moveBlockInContentState(contentState, atomicBlock, targetBlock, insertionMode);
	    } else {
	      var afterRemoval = DraftModifier.removeRange(contentState, targetRange, 'backward');
	      var selectionAfterRemoval = afterRemoval.getSelectionAfter();
	
	      var _targetBlock = afterRemoval.getBlockForKey(selectionAfterRemoval.getFocusKey());
	
	      if (selectionAfterRemoval.getStartOffset() === 0) {
	        withMovedAtomicBlock = moveBlockInContentState(afterRemoval, atomicBlock, _targetBlock, 'before');
	      } else if (selectionAfterRemoval.getEndOffset() === _targetBlock.getLength()) {
	        withMovedAtomicBlock = moveBlockInContentState(afterRemoval, atomicBlock, _targetBlock, 'after');
	      } else {
	        var afterSplit = DraftModifier.splitBlock(afterRemoval, selectionAfterRemoval);
	        var selectionAfterSplit = afterSplit.getSelectionAfter();
	
	        var _targetBlock2 = afterSplit.getBlockForKey(selectionAfterSplit.getFocusKey());
	
	        withMovedAtomicBlock = moveBlockInContentState(afterSplit, atomicBlock, _targetBlock2, 'before');
	      }
	    }
	
	    var newContent = withMovedAtomicBlock.merge({
	      selectionBefore: selectionState,
	      selectionAfter: withMovedAtomicBlock.getSelectionAfter().set('hasFocus', true)
	    });
	    return EditorState.push(editorState, newContent, 'move-block');
	  }
	};
	module.exports = AtomicBlockUtils;

/***/ },
/* 1182 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var findRangesImmutable = __webpack_require__(152);
	
	var getOwnObjectValues = __webpack_require__(409);
	
	var Immutable = __webpack_require__(27);
	
	var List = Immutable.List,
	    Repeat = Immutable.Repeat,
	    Record = Immutable.Record;
	
	var returnTrue = function returnTrue() {
	  return true;
	};
	
	var defaultLeafRange = {
	  start: null,
	  end: null
	};
	var LeafRange = Record(defaultLeafRange);
	var defaultDecoratorRange = {
	  start: null,
	  end: null,
	  decoratorKey: null,
	  leaves: null
	};
	var DecoratorRange = Record(defaultDecoratorRange);
	var BlockTree = {
	  /**
	   * Generate a block tree for a given ContentBlock/decorator pair.
	   */
	  generate: function generate(contentState, block, decorator) {
	    var textLength = block.getLength();
	
	    if (!textLength) {
	      return List.of(new DecoratorRange({
	        start: 0,
	        end: 0,
	        decoratorKey: null,
	        leaves: List.of(new LeafRange({
	          start: 0,
	          end: 0
	        }))
	      }));
	    }
	
	    var leafSets = [];
	    var decorations = decorator ? decorator.getDecorations(block, contentState) : List(Repeat(null, textLength));
	    var chars = block.getCharacterList();
	    findRangesImmutable(decorations, areEqual, returnTrue, function (start, end) {
	      leafSets.push(new DecoratorRange({
	        start: start,
	        end: end,
	        decoratorKey: decorations.get(start),
	        leaves: generateLeaves(chars.slice(start, end).toList(), start)
	      }));
	    });
	    return List(leafSets);
	  },
	  fromJS: function fromJS(_ref) {
	    var leaves = _ref.leaves,
	        other = _objectWithoutPropertiesLoose(_ref, ["leaves"]);
	
	    return new DecoratorRange(_objectSpread({}, other, {
	      leaves: leaves != null ? List(Array.isArray(leaves) ? leaves : getOwnObjectValues(leaves)).map(function (leaf) {
	        return LeafRange(leaf);
	      }) : null
	    }));
	  }
	};
	/**
	 * Generate LeafRange records for a given character list.
	 */
	
	function generateLeaves(characters, offset) {
	  var leaves = [];
	  var inlineStyles = characters.map(function (c) {
	    return c.getStyle();
	  }).toList();
	  findRangesImmutable(inlineStyles, areEqual, returnTrue, function (start, end) {
	    leaves.push(new LeafRange({
	      start: start + offset,
	      end: end + offset
	    }));
	  });
	  return List(leaves);
	}
	
	function areEqual(a, b) {
	  return a === b;
	}
	
	module.exports = BlockTree;

/***/ },
/* 1183 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var Immutable = __webpack_require__(27);
	
	var List = Immutable.List;
	var DELIMITER = '.';
	/**
	 * A CompositeDraftDecorator traverses through a list of DraftDecorator
	 * instances to identify sections of a ContentBlock that should be rendered
	 * in a "decorated" manner. For example, hashtags, mentions, and links may
	 * be intended to stand out visually, be rendered as anchors, etc.
	 *
	 * The list of decorators supplied to the constructor will be used in the
	 * order they are provided. This allows the caller to specify a priority for
	 * string matching, in case of match collisions among decorators.
	 *
	 * For instance, I may have a link with a `#` in its text. Though this section
	 * of text may match our hashtag decorator, it should not be treated as a
	 * hashtag. I should therefore list my link DraftDecorator
	 * before my hashtag DraftDecorator when constructing this composite
	 * decorator instance.
	 *
	 * Thus, when a collision like this is encountered, the earlier match is
	 * preserved and the new match is discarded.
	 */
	
	var CompositeDraftDecorator = /*#__PURE__*/function () {
	  function CompositeDraftDecorator(decorators) {
	    _defineProperty(this, "_decorators", void 0);
	
	    // Copy the decorator array, since we use this array order to determine
	    // precedence of decoration matching. If the array is mutated externally,
	    // we don't want to be affected here.
	    this._decorators = decorators.slice();
	  }
	
	  var _proto = CompositeDraftDecorator.prototype;
	
	  _proto.getDecorations = function getDecorations(block, contentState) {
	    var decorations = Array(block.getText().length).fill(null);
	
	    this._decorators.forEach(function (
	    /*object*/
	    decorator,
	    /*number*/
	    ii) {
	      var counter = 0;
	      var strategy = decorator.strategy;
	
	      var callback = function callback(
	      /*number*/
	      start,
	      /*number*/
	      end) {
	        // Find out if any of our matching range is already occupied
	        // by another decorator. If so, discard the match. Otherwise, store
	        // the component key for rendering.
	        if (canOccupySlice(decorations, start, end)) {
	          occupySlice(decorations, start, end, ii + DELIMITER + counter);
	          counter++;
	        }
	      };
	
	      strategy(block, callback, contentState);
	    });
	
	    return List(decorations);
	  };
	
	  _proto.getComponentForKey = function getComponentForKey(key) {
	    var componentKey = parseInt(key.split(DELIMITER)[0], 10);
	    return this._decorators[componentKey].component;
	  };
	
	  _proto.getPropsForKey = function getPropsForKey(key) {
	    var componentKey = parseInt(key.split(DELIMITER)[0], 10);
	    return this._decorators[componentKey].props;
	  };
	
	  return CompositeDraftDecorator;
	}();
	/**
	 * Determine whether we can occupy the specified slice of the decorations
	 * array.
	 */
	
	
	function canOccupySlice(decorations, start, end) {
	  for (var ii = start; ii < end; ii++) {
	    if (decorations[ii] != null) {
	      return false;
	    }
	  }
	
	  return true;
	}
	/**
	 * Splice the specified component into our decoration array at the desired
	 * range.
	 */
	
	
	function occupySlice(targetArr, start, end, componentKey) {
	  for (var ii = start; ii < end; ii++) {
	    targetArr[ii] = componentKey;
	  }
	}
	
	module.exports = CompositeDraftDecorator;

/***/ },
/* 1184 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	var CharacterMetadata = __webpack_require__(70);
	
	var _require = __webpack_require__(27),
	    Map = _require.Map;
	
	var ContentStateInlineStyle = {
	  add: function add(contentState, selectionState, inlineStyle) {
	    return modifyInlineStyle(contentState, selectionState, inlineStyle, true);
	  },
	  remove: function remove(contentState, selectionState, inlineStyle) {
	    return modifyInlineStyle(contentState, selectionState, inlineStyle, false);
	  }
	};
	
	function modifyInlineStyle(contentState, selectionState, inlineStyle, addOrRemove) {
	  var blockMap = contentState.getBlockMap();
	  var startKey = selectionState.getStartKey();
	  var startOffset = selectionState.getStartOffset();
	  var endKey = selectionState.getEndKey();
	  var endOffset = selectionState.getEndOffset();
	  var newBlocks = blockMap.skipUntil(function (_, k) {
	    return k === startKey;
	  }).takeUntil(function (_, k) {
	    return k === endKey;
	  }).concat(Map([[endKey, blockMap.get(endKey)]])).map(function (block, blockKey) {
	    var sliceStart;
	    var sliceEnd;
	
	    if (startKey === endKey) {
	      sliceStart = startOffset;
	      sliceEnd = endOffset;
	    } else {
	      sliceStart = blockKey === startKey ? startOffset : 0;
	      sliceEnd = blockKey === endKey ? endOffset : block.getLength();
	    }
	
	    var chars = block.getCharacterList();
	    var current;
	
	    while (sliceStart < sliceEnd) {
	      current = chars.get(sliceStart);
	      chars = chars.set(sliceStart, addOrRemove ? CharacterMetadata.applyStyle(current, inlineStyle) : CharacterMetadata.removeStyle(current, inlineStyle));
	      sliceStart++;
	    }
	
	    return block.set('characterList', chars);
	  });
	  return contentState.merge({
	    blockMap: blockMap.merge(newBlocks),
	    selectionBefore: selectionState,
	    selectionAfter: selectionState
	  });
	}
	
	module.exports = ContentStateInlineStyle;

/***/ },
/* 1185 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var UserAgent = __webpack_require__(60);
	
	var findAncestorOffsetKey = __webpack_require__(192);
	
	var getWindowForNode = __webpack_require__(415);
	
	var Immutable = __webpack_require__(27);
	
	var invariant = __webpack_require__(32);
	
	var nullthrows = __webpack_require__(61);
	
	var Map = Immutable.Map;
	// Heavily based on Prosemirror's DOMObserver https://github.com/ProseMirror/prosemirror-view/blob/master/src/domobserver.js
	var DOM_OBSERVER_OPTIONS = {
	  subtree: true,
	  characterData: true,
	  childList: true,
	  characterDataOldValue: false,
	  attributes: false
	}; // IE11 has very broken mutation observers, so we also listen to DOMCharacterDataModified
	
	var USE_CHAR_DATA = UserAgent.isBrowser('IE <= 11');
	
	var DOMObserver = /*#__PURE__*/function () {
	  function DOMObserver(container) {
	    var _this = this;
	
	    _defineProperty(this, "observer", void 0);
	
	    _defineProperty(this, "container", void 0);
	
	    _defineProperty(this, "mutations", void 0);
	
	    _defineProperty(this, "onCharData", void 0);
	
	    this.container = container;
	    this.mutations = Map();
	    var containerWindow = getWindowForNode(container);
	
	    if (containerWindow.MutationObserver && !USE_CHAR_DATA) {
	      this.observer = new containerWindow.MutationObserver(function (mutations) {
	        return _this.registerMutations(mutations);
	      });
	    } else {
	      this.onCharData = function (e) {
	        !(e.target instanceof Node) ?  false ? invariant(false, 'Expected target to be an instance of Node') : invariant(false) : void 0;
	
	        _this.registerMutation({
	          type: 'characterData',
	          target: e.target
	        });
	      };
	    }
	  }
	
	  var _proto = DOMObserver.prototype;
	
	  _proto.start = function start() {
	    if (this.observer) {
	      this.observer.observe(this.container, DOM_OBSERVER_OPTIONS);
	    } else {
	      /* $FlowFixMe[incompatible-call] (>=0.68.0 site=www,mobile) This event
	       * type is not defined by Flow's standard library */
	      this.container.addEventListener('DOMCharacterDataModified', this.onCharData);
	    }
	  };
	
	  _proto.stopAndFlushMutations = function stopAndFlushMutations() {
	    var observer = this.observer;
	
	    if (observer) {
	      this.registerMutations(observer.takeRecords());
	      observer.disconnect();
	    } else {
	      /* $FlowFixMe[incompatible-call] (>=0.68.0 site=www,mobile) This event
	       * type is not defined by Flow's standard library */
	      this.container.removeEventListener('DOMCharacterDataModified', this.onCharData);
	    }
	
	    var mutations = this.mutations;
	    this.mutations = Map();
	    return mutations;
	  };
	
	  _proto.registerMutations = function registerMutations(mutations) {
	    for (var i = 0; i < mutations.length; i++) {
	      this.registerMutation(mutations[i]);
	    }
	  };
	
	  _proto.getMutationTextContent = function getMutationTextContent(mutation) {
	    var type = mutation.type,
	        target = mutation.target,
	        removedNodes = mutation.removedNodes;
	
	    if (type === 'characterData') {
	      // When `textContent` is '', there is a race condition that makes
	      // getting the offsetKey from the target not possible.
	      // These events are also followed by a `childList`, which is the one
	      // we are able to retrieve the offsetKey and apply the '' text.
	      if (target.textContent !== '') {
	        // IE 11 considers the enter keypress that concludes the composition
	        // as an input char. This strips that newline character so the draft
	        // state does not receive spurious newlines.
	        if (USE_CHAR_DATA) {
	          return target.textContent.replace('\n', '');
	        }
	
	        return target.textContent;
	      }
	    } else if (type === 'childList') {
	      if (removedNodes && removedNodes.length) {
	        // `characterData` events won't happen or are ignored when
	        // removing the last character of a leaf node, what happens
	        // instead is a `childList` event with a `removedNodes` array.
	        // For this case the textContent should be '' and
	        // `DraftModifier.replaceText` will make sure the content is
	        // updated properly.
	        return '';
	      } else if (target.textContent !== '') {
	        // Typing Chinese in an empty block in MS Edge results in a
	        // `childList` event with non-empty textContent.
	        // See https://github.com/facebook/draft-js/issues/2082
	        return target.textContent;
	      }
	    }
	
	    return null;
	  };
	
	  _proto.registerMutation = function registerMutation(mutation) {
	    var textContent = this.getMutationTextContent(mutation);
	
	    if (textContent != null) {
	      var offsetKey = nullthrows(findAncestorOffsetKey(mutation.target));
	      this.mutations = this.mutations.set(offsetKey, textContent);
	    }
	  };
	
	  return DOMObserver;
	}();
	
	module.exports = DOMObserver;

/***/ },
/* 1186 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @preventMunge
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	var _assign = __webpack_require__(58);
	
	function _extends() { _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	var DefaultDraftBlockRenderMap = __webpack_require__(263);
	
	var DefaultDraftInlineStyle = __webpack_require__(391);
	
	var DraftEditorCompositionHandler = __webpack_require__(1188);
	
	var DraftEditorContents = __webpack_require__(1190);
	
	var DraftEditorDragHandler = __webpack_require__(1193);
	
	var DraftEditorEditHandler = __webpack_require__(1194);
	
	var flushControlled = __webpack_require__(1195);
	
	var DraftEditorPlaceholder = __webpack_require__(1197);
	
	var DraftEffects = __webpack_require__(394);
	
	var EditorState = __webpack_require__(36);
	
	var React = __webpack_require__(1);
	
	var Scroll = __webpack_require__(268);
	
	var Style = __webpack_require__(198);
	
	var UserAgent = __webpack_require__(60);
	
	var cx = __webpack_require__(108);
	
	var generateRandomKey = __webpack_require__(85);
	
	var getDefaultKeyBinding = __webpack_require__(404);
	
	var getScrollPosition = __webpack_require__(200);
	
	var gkx = __webpack_require__(97);
	
	var invariant = __webpack_require__(32);
	
	var isHTMLElement = __webpack_require__(153);
	
	var nullthrows = __webpack_require__(61);
	
	var isIE = UserAgent.isBrowser('IE'); // IE does not support the `input` event on contentEditable, so we can't
	// observe spellcheck behavior.
	
	var allowSpellCheck = !isIE; // Define a set of handler objects to correspond to each possible `mode`
	// of editor behavior.
	
	var handlerMap = {
	  edit: DraftEditorEditHandler,
	  composite: DraftEditorCompositionHandler,
	  drag: DraftEditorDragHandler,
	  cut: null,
	  render: null
	};
	var didInitODS = false;
	
	var UpdateDraftEditorFlags = /*#__PURE__*/function (_React$Component) {
	  _inheritsLoose(UpdateDraftEditorFlags, _React$Component);
	
	  function UpdateDraftEditorFlags() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = UpdateDraftEditorFlags.prototype;
	
	  _proto.render = function render() {
	    return null;
	  };
	
	  _proto.componentDidMount = function componentDidMount() {
	    this._update();
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate() {
	    this._update();
	  };
	
	  _proto._update = function _update() {
	    var editor = this.props.editor;
	    /**
	     * Sometimes a render triggers a 'focus' or other event, and that will
	     * schedule a second render pass.
	     * In order to make sure the second render pass gets the latest editor
	     * state, we update it here.
	     * Example:
	     * render #1
	     * +
	     * |
	     * | cWU -> Nothing ... latestEditorState = STALE_STATE :(
	     * |
	     * | render -> this.props.editorState = FRESH_STATE
	     * | +         *and* set latestEditorState = FRESH_STATE
	     *   |
	     * | |
	     * | +--> triggers 'focus' event, calling 'handleFocus' with latestEditorState
	     * |                                                +
	     * |                                                |
	     * +>cdU -> latestEditorState = FRESH_STATE         | the 'handleFocus' call schedules render #2
	     *                                                  | with latestEditorState, which is FRESH_STATE
	     *                                                  |
	     * render #2 <--------------------------------------+
	     * +
	     * |
	     * | cwU -> nothing updates
	     * |
	     * | render -> this.props.editorState = FRESH_STATE which was passed in above
	     * |
	     * +>cdU fires and resets latestEditorState = FRESH_STATE
	     * ---
	     * Note that if we don't set latestEditorState in 'render' in the above
	     * diagram, then STALE_STATE gets passed to render #2.
	     */
	
	    editor._latestEditorState = this.props.editorState;
	    /**
	     * The reason we set this 'blockSelectEvents' flag is that  IE will fire a
	     * 'selectionChange' event when we programmatically change the selection,
	     * meaning it would trigger a new select event while we are in the middle
	     * of updating.
	     * We found that the 'selection.addRange' was what triggered the stray
	     * selectionchange event in IE.
	     * To be clear - we have not been able to reproduce specific bugs related
	     * to this stray selection event, but have recorded logs that some
	     * conditions do cause it to get bumped into during editOnSelect.
	     */
	
	    editor._blockSelectEvents = true;
	  };
	
	  return UpdateDraftEditorFlags;
	}(React.Component);
	/**
	 * `DraftEditor` is the root editor component. It composes a `contentEditable`
	 * div, and provides a wide variety of useful function props for managing the
	 * state of the editor. See `DraftEditorProps` for details.
	 */
	
	
	var DraftEditor = /*#__PURE__*/function (_React$Component2) {
	  _inheritsLoose(DraftEditor, _React$Component2);
	
	  /**
	   * Define proxies that can route events to the current handler.
	   */
	  function DraftEditor(props) {
	    var _this;
	
	    _this = _React$Component2.call(this, props) || this;
	
	    _defineProperty(_assertThisInitialized(_this), "_blockSelectEvents", void 0);
	
	    _defineProperty(_assertThisInitialized(_this), "_clipboard", void 0);
	
	    _defineProperty(_assertThisInitialized(_this), "_handler", void 0);
	
	    _defineProperty(_assertThisInitialized(_this), "_dragCount", void 0);
	
	    _defineProperty(_assertThisInitialized(_this), "_internalDrag", void 0);
	
	    _defineProperty(_assertThisInitialized(_this), "_editorKey", void 0);
	
	    _defineProperty(_assertThisInitialized(_this), "_placeholderAccessibilityID", void 0);
	
	    _defineProperty(_assertThisInitialized(_this), "_latestEditorState", void 0);
	
	    _defineProperty(_assertThisInitialized(_this), "_latestCommittedEditorState", void 0);
	
	    _defineProperty(_assertThisInitialized(_this), "_pendingStateFromBeforeInput", void 0);
	
	    _defineProperty(_assertThisInitialized(_this), "_onBeforeInput", void 0);
	
	    _defineProperty(_assertThisInitialized(_this), "_onBlur", void 0);
	
	    _defineProperty(_assertThisInitialized(_this), "_onCharacterData", void 0);
	
	    _defineProperty(_assertThisInitialized(_this), "_onCompositionEnd", void 0);
	
	    _defineProperty(_assertThisInitialized(_this), "_onCompositionStart", void 0);
	
	    _defineProperty(_assertThisInitialized(_this), "_onCopy", void 0);
	
	    _defineProperty(_assertThisInitialized(_this), "_onCut", void 0);
	
	    _defineProperty(_assertThisInitialized(_this), "_onDragEnd", void 0);
	
	    _defineProperty(_assertThisInitialized(_this), "_onDragOver", void 0);
	
	    _defineProperty(_assertThisInitialized(_this), "_onDragStart", void 0);
	
	    _defineProperty(_assertThisInitialized(_this), "_onDrop", void 0);
	
	    _defineProperty(_assertThisInitialized(_this), "_onInput", void 0);
	
	    _defineProperty(_assertThisInitialized(_this), "_onFocus", void 0);
	
	    _defineProperty(_assertThisInitialized(_this), "_onKeyDown", void 0);
	
	    _defineProperty(_assertThisInitialized(_this), "_onKeyPress", void 0);
	
	    _defineProperty(_assertThisInitialized(_this), "_onKeyUp", void 0);
	
	    _defineProperty(_assertThisInitialized(_this), "_onMouseDown", void 0);
	
	    _defineProperty(_assertThisInitialized(_this), "_onMouseUp", void 0);
	
	    _defineProperty(_assertThisInitialized(_this), "_onPaste", void 0);
	
	    _defineProperty(_assertThisInitialized(_this), "_onSelect", void 0);
	
	    _defineProperty(_assertThisInitialized(_this), "editor", void 0);
	
	    _defineProperty(_assertThisInitialized(_this), "editorContainer", void 0);
	
	    _defineProperty(_assertThisInitialized(_this), "focus", void 0);
	
	    _defineProperty(_assertThisInitialized(_this), "blur", void 0);
	
	    _defineProperty(_assertThisInitialized(_this), "setMode", void 0);
	
	    _defineProperty(_assertThisInitialized(_this), "exitCurrentMode", void 0);
	
	    _defineProperty(_assertThisInitialized(_this), "restoreEditorDOM", void 0);
	
	    _defineProperty(_assertThisInitialized(_this), "setClipboard", void 0);
	
	    _defineProperty(_assertThisInitialized(_this), "getClipboard", void 0);
	
	    _defineProperty(_assertThisInitialized(_this), "getEditorKey", void 0);
	
	    _defineProperty(_assertThisInitialized(_this), "update", void 0);
	
	    _defineProperty(_assertThisInitialized(_this), "onDragEnter", void 0);
	
	    _defineProperty(_assertThisInitialized(_this), "onDragLeave", void 0);
	
	    _defineProperty(_assertThisInitialized(_this), "_handleEditorContainerRef", function (node) {
	      _this.editorContainer = node; // Instead of having a direct ref on the child, we'll grab it here.
	      // This is safe as long as the rendered structure is static (which it is).
	      // This lets the child support ref={props.editorRef} without merging refs.
	
	      _this.editor = node !== null ? node.firstChild : null;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "focus", function (scrollPosition) {
	      var editorState = _this.props.editorState;
	      var alreadyHasFocus = editorState.getSelection().getHasFocus();
	      var editorNode = _this.editor;
	
	      if (!editorNode) {
	        // once in a while people call 'focus' in a setTimeout, and the node has
	        // been deleted, so it can be null in that case.
	        return;
	      }
	
	      var scrollParent = Style.getScrollParent(editorNode);
	
	      var _ref = scrollPosition || getScrollPosition(scrollParent),
	          x = _ref.x,
	          y = _ref.y;
	
	      !isHTMLElement(editorNode) ?  false ? invariant(false, 'editorNode is not an HTMLElement') : invariant(false) : void 0;
	      editorNode.focus(); // Restore scroll position
	
	      if (scrollParent === window) {
	        window.scrollTo(x, y);
	      } else {
	        Scroll.setTop(scrollParent, y);
	      } // On Chrome and Safari, calling focus on contenteditable focuses the
	      // cursor at the first character. This is something you don't expect when
	      // you're clicking on an input element but not directly on a character.
	      // Put the cursor back where it was before the blur.
	
	
	      if (!alreadyHasFocus) {
	        _this.update(EditorState.forceSelection(editorState, editorState.getSelection()));
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "blur", function () {
	      var editorNode = _this.editor;
	
	      if (!editorNode) {
	        return;
	      }
	
	      !isHTMLElement(editorNode) ?  false ? invariant(false, 'editorNode is not an HTMLElement') : invariant(false) : void 0;
	      editorNode.blur();
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "setMode", function (mode) {
	      var _this$props = _this.props,
	          onPaste = _this$props.onPaste,
	          onCut = _this$props.onCut,
	          onCopy = _this$props.onCopy;
	
	      var editHandler = _objectSpread({}, handlerMap.edit);
	
	      if (onPaste) {
	        /* $FlowFixMe[incompatible-type] (>=0.117.0 site=www,mobile) This comment
	         * suppresses an error found when Flow v0.117 was deployed. To see the
	         * error delete this comment and run Flow. */
	        editHandler.onPaste = onPaste;
	      }
	
	      if (onCut) {
	        editHandler.onCut = onCut;
	      }
	
	      if (onCopy) {
	        editHandler.onCopy = onCopy;
	      }
	
	      var handler = _objectSpread({}, handlerMap, {
	        edit: editHandler
	      });
	
	      _this._handler = handler[mode];
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "exitCurrentMode", function () {
	      _this.setMode('edit');
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "restoreEditorDOM", function (scrollPosition) {
	      _this.setState({
	        contentsKey: _this.state.contentsKey + 1
	      }, function () {
	        _this.focus(scrollPosition);
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "setClipboard", function (clipboard) {
	      _this._clipboard = clipboard;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "getClipboard", function () {
	      return _this._clipboard;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "update", function (editorState) {
	      _this._latestEditorState = editorState;
	
	      _this.props.onChange(editorState);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onDragEnter", function () {
	      _this._dragCount++;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onDragLeave", function () {
	      _this._dragCount--;
	
	      if (_this._dragCount === 0) {
	        _this.exitCurrentMode();
	      }
	    });
	
	    _this._blockSelectEvents = false;
	    _this._clipboard = null;
	    _this._handler = null;
	    _this._dragCount = 0;
	    _this._editorKey = props.editorKey || generateRandomKey();
	    _this._placeholderAccessibilityID = 'placeholder-' + _this._editorKey;
	    _this._latestEditorState = props.editorState;
	    _this._latestCommittedEditorState = props.editorState;
	    _this._onBeforeInput = _this._buildHandler('onBeforeInput');
	    _this._onBlur = _this._buildHandler('onBlur');
	    _this._onCharacterData = _this._buildHandler('onCharacterData');
	    _this._onCompositionEnd = _this._buildHandler('onCompositionEnd');
	    _this._onCompositionStart = _this._buildHandler('onCompositionStart');
	    _this._onCopy = _this._buildHandler('onCopy');
	    _this._onCut = _this._buildHandler('onCut');
	    _this._onDragEnd = _this._buildHandler('onDragEnd');
	    _this._onDragOver = _this._buildHandler('onDragOver');
	    _this._onDragStart = _this._buildHandler('onDragStart');
	    _this._onDrop = _this._buildHandler('onDrop');
	    _this._onInput = _this._buildHandler('onInput');
	    _this._onFocus = _this._buildHandler('onFocus');
	    _this._onKeyDown = _this._buildHandler('onKeyDown');
	    _this._onKeyPress = _this._buildHandler('onKeyPress');
	    _this._onKeyUp = _this._buildHandler('onKeyUp');
	    _this._onMouseDown = _this._buildHandler('onMouseDown');
	    _this._onMouseUp = _this._buildHandler('onMouseUp');
	    _this._onPaste = _this._buildHandler('onPaste');
	    _this._onSelect = _this._buildHandler('onSelect');
	
	    _this.getEditorKey = function () {
	      return _this._editorKey;
	    };
	
	    if (false) {
	      ['onDownArrow', 'onEscape', 'onLeftArrow', 'onRightArrow', 'onTab', 'onUpArrow'].forEach(function (propName) {
	        if (props.hasOwnProperty(propName)) {
	          // eslint-disable-next-line no-console
	          console.warn("Supplying an `".concat(propName, "` prop to `DraftEditor` has ") + 'been deprecated. If your handler needs access to the keyboard ' + 'event, supply a custom `keyBindingFn` prop that falls back to ' + 'the default one (eg. https://is.gd/wHKQ3W).');
	        }
	      });
	    } // See `restoreEditorDOM()`.
	
	
	    _this.state = {
	      contentsKey: 0
	    };
	    return _this;
	  }
	  /**
	   * Build a method that will pass the event to the specified handler method.
	   * This allows us to look up the correct handler function for the current
	   * editor mode, if any has been specified.
	   */
	
	
	  var _proto2 = DraftEditor.prototype;
	
	  _proto2._buildHandler = function _buildHandler(eventName) {
	    var _this2 = this;
	
	    // Wrap event handlers in `flushControlled`. In sync mode, this is
	    // effectively a no-op. In async mode, this ensures all updates scheduled
	    // inside the handler are flushed before React yields to the browser.
	    return function (e) {
	      if (!_this2.props.readOnly) {
	        var method = _this2._handler && _this2._handler[eventName];
	
	        if (method) {
	          if (flushControlled) {
	            flushControlled(function () {
	              return method(_this2, e);
	            });
	          } else {
	            method(_this2, e);
	          }
	        }
	      }
	    };
	  };
	
	  _proto2._showPlaceholder = function _showPlaceholder() {
	    return !!this.props.placeholder && !this.props.editorState.isInCompositionMode() && !this.props.editorState.getCurrentContent().hasText();
	  };
	
	  _proto2._renderPlaceholder = function _renderPlaceholder() {
	    if (this._showPlaceholder()) {
	      var placeHolderProps = {
	        text: nullthrows(this.props.placeholder),
	        editorState: this.props.editorState,
	        textAlignment: this.props.textAlignment,
	        accessibilityID: this._placeholderAccessibilityID
	      };
	      /* $FlowFixMe[incompatible-type] (>=0.112.0 site=www,mobile) This comment
	       * suppresses an error found when Flow v0.112 was deployed. To see the
	       * error delete this comment and run Flow. */
	
	      return React.createElement(DraftEditorPlaceholder, placeHolderProps);
	    }
	
	    return null;
	  }
	  /**
	   * returns ariaDescribedBy prop with '{{editor_id_placeholder}}' replaced with
	   * the DOM id of the placeholder (if it exists)
	   * @returns aria-describedby attribute value
	   */
	  ;
	
	  _proto2._renderARIADescribedBy = function _renderARIADescribedBy() {
	    var describedBy = this.props.ariaDescribedBy || '';
	    var placeholderID = this._showPlaceholder() ? this._placeholderAccessibilityID : '';
	    return describedBy.replace('{{editor_id_placeholder}}', placeholderID) || undefined;
	  };
	
	  _proto2.render = function render() {
	    var _this$props2 = this.props,
	        blockRenderMap = _this$props2.blockRenderMap,
	        blockRendererFn = _this$props2.blockRendererFn,
	        blockStyleFn = _this$props2.blockStyleFn,
	        customStyleFn = _this$props2.customStyleFn,
	        customStyleMap = _this$props2.customStyleMap,
	        editorState = _this$props2.editorState,
	        preventScroll = _this$props2.preventScroll,
	        readOnly = _this$props2.readOnly,
	        textAlignment = _this$props2.textAlignment,
	        textDirectionality = _this$props2.textDirectionality;
	    var rootClass = cx({
	      'DraftEditor/root': true,
	      'DraftEditor/alignLeft': textAlignment === 'left',
	      'DraftEditor/alignRight': textAlignment === 'right',
	      'DraftEditor/alignCenter': textAlignment === 'center'
	    });
	    var contentStyle = {
	      outline: 'none',
	      // fix parent-draggable Safari bug. #1326
	      userSelect: 'text',
	      WebkitUserSelect: 'text',
	      whiteSpace: 'pre-wrap',
	      wordWrap: 'break-word'
	    }; // The aria-expanded and aria-haspopup properties should only be rendered
	    // for a combobox.
	
	    /* $FlowFixMe[prop-missing] (>=0.68.0 site=www,mobile) This comment
	     * suppresses an error found when Flow v0.68 was deployed. To see the error
	     * delete this comment and run Flow. */
	
	    var ariaRole = this.props.role || 'textbox';
	    var ariaExpanded = ariaRole === 'combobox' ? !!this.props.ariaExpanded : null;
	    var editorContentsProps = {
	      blockRenderMap: blockRenderMap,
	      blockRendererFn: blockRendererFn,
	      blockStyleFn: blockStyleFn,
	      customStyleMap: _objectSpread({}, DefaultDraftInlineStyle, customStyleMap),
	      customStyleFn: customStyleFn,
	      editorKey: this._editorKey,
	      editorState: editorState,
	      preventScroll: preventScroll,
	      textDirectionality: textDirectionality
	    };
	    return React.createElement("div", {
	      className: rootClass
	    }, this._renderPlaceholder(), React.createElement("div", {
	      className: cx('DraftEditor/editorContainer'),
	      ref: this._handleEditorContainerRef
	    }, React.createElement("div", {
	      "aria-activedescendant": readOnly ? null : this.props.ariaActiveDescendantID,
	      "aria-autocomplete": readOnly ? null : this.props.ariaAutoComplete,
	      "aria-controls": readOnly ? null : this.props.ariaControls,
	      "aria-describedby": this._renderARIADescribedBy(),
	      "aria-expanded": readOnly ? null : ariaExpanded,
	      "aria-label": this.props.ariaLabel,
	      "aria-labelledby": this.props.ariaLabelledBy,
	      "aria-multiline": this.props.ariaMultiline,
	      "aria-owns": readOnly ? null : this.props.ariaOwneeID,
	      autoCapitalize: this.props.autoCapitalize,
	      autoComplete: this.props.autoComplete,
	      autoCorrect: this.props.autoCorrect,
	      className: cx({
	        // Chrome's built-in translation feature mutates the DOM in ways
	        // that Draft doesn't expect (ex: adding <font> tags inside
	        // DraftEditorLeaf spans) and causes problems. We add notranslate
	        // here which makes its autotranslation skip over this subtree.
	        notranslate: !readOnly,
	        'public/DraftEditor/content': true
	      }),
	      contentEditable: !readOnly,
	      "data-testid": this.props.webDriverTestID,
	      onBeforeInput: this._onBeforeInput,
	      onBlur: this._onBlur,
	      onCompositionEnd: this._onCompositionEnd,
	      onCompositionStart: this._onCompositionStart,
	      onCopy: this._onCopy,
	      onCut: this._onCut,
	      onDragEnd: this._onDragEnd,
	      onDragEnter: this.onDragEnter,
	      onDragLeave: this.onDragLeave,
	      onDragOver: this._onDragOver,
	      onDragStart: this._onDragStart,
	      onDrop: this._onDrop,
	      onFocus: this._onFocus,
	      onInput: this._onInput,
	      onKeyDown: this._onKeyDown,
	      onKeyPress: this._onKeyPress,
	      onKeyUp: this._onKeyUp,
	      onMouseUp: this._onMouseUp,
	      onPaste: this._onPaste,
	      onSelect: this._onSelect,
	      ref: this.props.editorRef,
	      role: readOnly ? null : ariaRole,
	      spellCheck: allowSpellCheck && this.props.spellCheck,
	      style: contentStyle,
	      suppressContentEditableWarning: true,
	      tabIndex: this.props.tabIndex
	    }, React.createElement(UpdateDraftEditorFlags, {
	      editor: this,
	      editorState: editorState
	    }), React.createElement(DraftEditorContents, _extends({}, editorContentsProps, {
	      key: 'contents' + this.state.contentsKey
	    })))));
	  };
	
	  _proto2.componentDidMount = function componentDidMount() {
	    this._blockSelectEvents = false;
	
	    if (!didInitODS && gkx('draft_ods_enabled')) {
	      didInitODS = true;
	      DraftEffects.initODS();
	    }
	
	    this.setMode('edit');
	    /**
	     * IE has a hardcoded "feature" that attempts to convert link text into
	     * anchors in contentEditable DOM. This breaks the editor's expectations of
	     * the DOM, and control is lost. Disable it to make IE behave.
	     * See: http://blogs.msdn.com/b/ieinternals/archive/2010/09/15/
	     * ie9-beta-minor-change-list.aspx
	     */
	
	    if (isIE) {
	      // editor can be null after mounting
	      // https://stackoverflow.com/questions/44074747/componentdidmount-called-before-ref-callback
	      if (!this.editor) {
	        global.execCommand('AutoUrlDetect', false, false);
	      } else {
	        this.editor.ownerDocument.execCommand('AutoUrlDetect', false, false);
	      }
	    }
	  };
	
	  _proto2.componentDidUpdate = function componentDidUpdate() {
	    this._blockSelectEvents = false;
	    this._latestEditorState = this.props.editorState;
	    this._latestCommittedEditorState = this.props.editorState;
	  }
	  /**
	   * Used via `this.focus()`.
	   *
	   * Force focus back onto the editor node.
	   *
	   * We attempt to preserve scroll position when focusing. You can also pass
	   * a specified scroll position (for cases like `cut` behavior where it should
	   * be restored to a known position).
	   */
	  ;
	
	  return DraftEditor;
	}(React.Component);
	
	_defineProperty(DraftEditor, "defaultProps", {
	  ariaDescribedBy: '{{editor_id_placeholder}}',
	  blockRenderMap: DefaultDraftBlockRenderMap,
	  blockRendererFn: function blockRendererFn() {
	    return null;
	  },
	  blockStyleFn: function blockStyleFn() {
	    return '';
	  },
	  keyBindingFn: getDefaultKeyBinding,
	  readOnly: false,
	  spellCheck: false,
	  stripPastedStyles: false
	});
	
	module.exports = DraftEditor;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1187 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 *
	 * This file is a fork of DraftEditorBlock.react.js and DraftEditorContents.react.js
	 *
	 * This is unstable and not part of the public API and should not be used by
	 * production systems. This file may be update/removed without notice.
	 */
	'use strict';
	
	var _assign = __webpack_require__(58);
	
	function _extends() { _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var DraftEditorNode = __webpack_require__(1196);
	
	var DraftOffsetKey = __webpack_require__(91);
	
	var React = __webpack_require__(1);
	
	var Scroll = __webpack_require__(268);
	
	var Style = __webpack_require__(198);
	
	var getElementPosition = __webpack_require__(431);
	
	var getScrollPosition = __webpack_require__(200);
	
	var getViewportDimensions = __webpack_require__(432);
	
	var Immutable = __webpack_require__(27);
	
	var invariant = __webpack_require__(32);
	
	var isHTMLElement = __webpack_require__(153);
	
	var SCROLL_BUFFER = 10;
	var List = Immutable.List; // we should harden up the bellow flow types to make them more strict
	
	/**
	 * Return whether a block overlaps with either edge of the `SelectionState`.
	 */
	var isBlockOnSelectionEdge = function isBlockOnSelectionEdge(selection, key) {
	  return selection.getAnchorKey() === key || selection.getFocusKey() === key;
	};
	/**
	 * We will use this helper to identify blocks that need to be wrapped but have siblings that
	 * also share the same wrapper element, this way we can do the wrapping once the last sibling
	 * is added.
	 */
	
	
	var shouldNotAddWrapperElement = function shouldNotAddWrapperElement(block, contentState) {
	  var nextSiblingKey = block.getNextSiblingKey();
	  return nextSiblingKey ? contentState.getBlockForKey(nextSiblingKey).getType() === block.getType() : false;
	};
	
	var applyWrapperElementToSiblings = function applyWrapperElementToSiblings(wrapperTemplate, Element, nodes) {
	  var wrappedSiblings = []; // we check back until we find a sibling that does not have same wrapper
	
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = nodes.reverse()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var sibling = _step.value;
	
	      if (sibling.type !== Element) {
	        break;
	      }
	
	      wrappedSiblings.push(sibling);
	    } // we now should remove from acc the wrappedSiblings and add them back under same wrap
	
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator["return"] != null) {
	        _iterator["return"]();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	
	  nodes.splice(nodes.indexOf(wrappedSiblings[0]), wrappedSiblings.length + 1);
	  var childrenIs = wrappedSiblings.reverse();
	  var key = childrenIs[0].key;
	  nodes.push(React.cloneElement(wrapperTemplate, {
	    key: "".concat(key, "-wrap"),
	    'data-offset-key': DraftOffsetKey.encode(key, 0, 0)
	  }, childrenIs));
	  return nodes;
	};
	
	var getDraftRenderConfig = function getDraftRenderConfig(block, blockRenderMap) {
	  var configForType = blockRenderMap.get(block.getType()) || blockRenderMap.get('unstyled');
	  var wrapperTemplate = configForType.wrapper;
	  var Element = configForType.element || blockRenderMap.get('unstyled').element;
	  return {
	    Element: Element,
	    wrapperTemplate: wrapperTemplate
	  };
	};
	
	var getCustomRenderConfig = function getCustomRenderConfig(block, blockRendererFn) {
	  var customRenderer = blockRendererFn(block);
	
	  if (!customRenderer) {
	    return {};
	  }
	
	  var CustomComponent = customRenderer.component,
	      customProps = customRenderer.props,
	      customEditable = customRenderer.editable;
	  return {
	    CustomComponent: CustomComponent,
	    customProps: customProps,
	    customEditable: customEditable
	  };
	};
	
	var getElementPropsConfig = function getElementPropsConfig(block, editorKey, offsetKey, blockStyleFn, customConfig, ref) {
	  var elementProps = {
	    'data-block': true,
	    'data-editor': editorKey,
	    'data-offset-key': offsetKey,
	    key: block.getKey(),
	    ref: ref
	  };
	  var customClass = blockStyleFn(block);
	
	  if (customClass) {
	    elementProps.className = customClass;
	  }
	
	  if (customConfig.customEditable !== undefined) {
	    elementProps = _objectSpread({}, elementProps, {
	      contentEditable: customConfig.customEditable,
	      suppressContentEditableWarning: true
	    });
	  }
	
	  return elementProps;
	};
	
	var DraftEditorBlockNode = /*#__PURE__*/function (_React$Component) {
	  _inheritsLoose(DraftEditorBlockNode, _React$Component);
	
	  function DraftEditorBlockNode() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	
	    _defineProperty(_assertThisInitialized(_this), "wrapperRef", React.createRef());
	
	    return _this;
	  }
	
	  var _proto = DraftEditorBlockNode.prototype;
	
	  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	    var _this$props = this.props,
	        block = _this$props.block,
	        direction = _this$props.direction,
	        tree = _this$props.tree;
	    var isContainerNode = !block.getChildKeys().isEmpty();
	    var blockHasChanged = block !== nextProps.block || tree !== nextProps.tree || direction !== nextProps.direction || isBlockOnSelectionEdge(nextProps.selection, nextProps.block.getKey()) && nextProps.forceSelection; // if we have children at this stage we always re-render container nodes
	    // else if its a root node we avoid re-rendering by checking for block updates
	
	    return isContainerNode || blockHasChanged;
	  }
	  /**
	   * When a block is mounted and overlaps the selection state, we need to make
	   * sure that the cursor is visible to match native behavior. This may not
	   * be the case if the user has pressed `RETURN` or pasted some content, since
	   * programatically creating these new blocks and setting the DOM selection
	   * will miss out on the browser natively scrolling to that position.
	   *
	   * To replicate native behavior, if the block overlaps the selection state
	   * on mount, force the scroll position. Check the scroll state of the scroll
	   * parent, and adjust it to align the entire block to the bottom of the
	   * scroll parent.
	   */
	  ;
	
	  _proto.componentDidMount = function componentDidMount() {
	    var selection = this.props.selection;
	    var endKey = selection.getEndKey();
	
	    if (!selection.getHasFocus() || endKey !== this.props.block.getKey()) {
	      return;
	    }
	
	    var blockNode = this.wrapperRef.current;
	
	    if (!blockNode) {
	      // This Block Node was rendered without a wrapper element.
	      return;
	    }
	
	    var scrollParent = Style.getScrollParent(blockNode);
	    var scrollPosition = getScrollPosition(scrollParent);
	    var scrollDelta;
	
	    if (scrollParent === window) {
	      var nodePosition = getElementPosition(blockNode);
	      var nodeBottom = nodePosition.y + nodePosition.height;
	      var viewportHeight = getViewportDimensions().height;
	      scrollDelta = nodeBottom - viewportHeight;
	
	      if (scrollDelta > 0) {
	        window.scrollTo(scrollPosition.x, scrollPosition.y + scrollDelta + SCROLL_BUFFER);
	      }
	    } else {
	      !isHTMLElement(blockNode) ?  false ? invariant(false, 'blockNode is not an HTMLElement') : invariant(false) : void 0;
	      var htmlBlockNode = blockNode;
	      var blockBottom = htmlBlockNode.offsetHeight + htmlBlockNode.offsetTop;
	      var scrollBottom = scrollParent.offsetHeight + scrollPosition.y;
	      scrollDelta = blockBottom - scrollBottom;
	
	      if (scrollDelta > 0) {
	        Scroll.setTop(scrollParent, Scroll.getTop(scrollParent) + scrollDelta + SCROLL_BUFFER);
	      }
	    }
	  };
	
	  _proto.render = function render() {
	    var _this2 = this;
	
	    var _this$props2 = this.props,
	        block = _this$props2.block,
	        blockRenderMap = _this$props2.blockRenderMap,
	        blockRendererFn = _this$props2.blockRendererFn,
	        blockStyleFn = _this$props2.blockStyleFn,
	        contentState = _this$props2.contentState,
	        decorator = _this$props2.decorator,
	        editorKey = _this$props2.editorKey,
	        editorState = _this$props2.editorState,
	        customStyleFn = _this$props2.customStyleFn,
	        customStyleMap = _this$props2.customStyleMap,
	        direction = _this$props2.direction,
	        forceSelection = _this$props2.forceSelection,
	        selection = _this$props2.selection,
	        tree = _this$props2.tree;
	    var children = null;
	
	    if (block.children.size) {
	      children = block.children.reduce(function (acc, key) {
	        var offsetKey = DraftOffsetKey.encode(key, 0, 0);
	        var child = contentState.getBlockForKey(key);
	        var customConfig = getCustomRenderConfig(child, blockRendererFn);
	        var Component = customConfig.CustomComponent || DraftEditorBlockNode;
	
	        var _getDraftRenderConfig = getDraftRenderConfig(child, blockRenderMap),
	            Element = _getDraftRenderConfig.Element,
	            wrapperTemplate = _getDraftRenderConfig.wrapperTemplate;
	
	        var elementProps = getElementPropsConfig(child, editorKey, offsetKey, blockStyleFn, customConfig, null);
	
	        var childProps = _objectSpread({}, _this2.props, {
	          tree: editorState.getBlockTree(key),
	          blockProps: customConfig.customProps,
	          offsetKey: offsetKey,
	          block: child
	        });
	
	        acc.push(React.createElement(Element, elementProps, React.createElement(Component, childProps)));
	
	        if (!wrapperTemplate || shouldNotAddWrapperElement(child, contentState)) {
	          return acc;
	        } // if we are here it means we are the last block
	        // that has a wrapperTemplate so we should wrap itself
	        // and all other previous siblings that share the same wrapper
	
	
	        applyWrapperElementToSiblings(wrapperTemplate, Element, acc);
	        return acc;
	      }, []);
	    }
	
	    var blockKey = block.getKey();
	    var offsetKey = DraftOffsetKey.encode(blockKey, 0, 0);
	    var customConfig = getCustomRenderConfig(block, blockRendererFn);
	    var Component = customConfig.CustomComponent;
	    var blockNode = Component != null ? React.createElement(Component, _extends({}, this.props, {
	      tree: editorState.getBlockTree(blockKey),
	      blockProps: customConfig.customProps,
	      offsetKey: offsetKey,
	      block: block
	    })) : React.createElement(DraftEditorNode, {
	      block: block,
	      children: children,
	      contentState: contentState,
	      customStyleFn: customStyleFn,
	      customStyleMap: customStyleMap,
	      decorator: decorator,
	      direction: direction,
	      forceSelection: forceSelection,
	      hasSelection: isBlockOnSelectionEdge(selection, blockKey),
	      selection: selection,
	      tree: tree
	    });
	
	    if (block.getParentKey()) {
	      return blockNode;
	    }
	
	    var _getDraftRenderConfig2 = getDraftRenderConfig(block, blockRenderMap),
	        Element = _getDraftRenderConfig2.Element;
	
	    var elementProps = getElementPropsConfig(block, editorKey, offsetKey, blockStyleFn, customConfig, this.wrapperRef); // root block nodes needs to be wrapped
	
	    return React.createElement(Element, elementProps, blockNode);
	  };
	
	  return DraftEditorBlockNode;
	}(React.Component);
	
	module.exports = DraftEditorBlockNode;

/***/ },
/* 1188 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	var DOMObserver = __webpack_require__(1185);
	
	var DraftModifier = __webpack_require__(59);
	
	var DraftOffsetKey = __webpack_require__(91);
	
	var EditorState = __webpack_require__(36);
	
	var Keys = __webpack_require__(197);
	
	var UserAgent = __webpack_require__(60);
	
	var editOnSelect = __webpack_require__(402);
	
	var getContentEditableContainer = __webpack_require__(403);
	
	var getDraftEditorSelection = __webpack_require__(405);
	
	var getEntityKeyForSelection = __webpack_require__(265);
	
	var nullthrows = __webpack_require__(61);
	
	var isIE = UserAgent.isBrowser('IE');
	/**
	 * Millisecond delay to allow `compositionstart` to fire again upon
	 * `compositionend`.
	 *
	 * This is used for Korean input to ensure that typing can continue without
	 * the editor trying to render too quickly. More specifically, Safari 7.1+
	 * triggers `compositionstart` a little slower than Chrome/FF, which
	 * leads to composed characters being resolved and re-render occurring
	 * sooner than we want.
	 */
	
	var RESOLVE_DELAY = 20;
	/**
	 * A handful of variables used to track the current composition and its
	 * resolution status. These exist at the module level because it is not
	 * possible to have compositions occurring in multiple editors simultaneously,
	 * and it simplifies state management with respect to the DraftEditor component.
	 */
	
	var resolved = false;
	var stillComposing = false;
	var domObserver = null;
	
	function startDOMObserver(editor) {
	  if (!domObserver) {
	    domObserver = new DOMObserver(getContentEditableContainer(editor));
	    domObserver.start();
	  }
	}
	
	var DraftEditorCompositionHandler = {
	  /**
	   * A `compositionstart` event has fired while we're still in composition
	   * mode. Continue the current composition session to prevent a re-render.
	   */
	  onCompositionStart: function onCompositionStart(editor) {
	    stillComposing = true;
	    startDOMObserver(editor);
	  },
	
	  /**
	   * Attempt to end the current composition session.
	   *
	   * Defer handling because browser will still insert the chars into active
	   * element after `compositionend`. If a `compositionstart` event fires
	   * before `resolveComposition` executes, our composition session will
	   * continue.
	   *
	   * The `resolved` flag is useful because certain IME interfaces fire the
	   * `compositionend` event multiple times, thus queueing up multiple attempts
	   * at handling the composition. Since handling the same composition event
	   * twice could break the DOM, we only use the first event. Example: Arabic
	   * Google Input Tools on Windows 8.1 fires `compositionend` three times.
	   */
	  onCompositionEnd: function onCompositionEnd(editor) {
	    resolved = false;
	    stillComposing = false;
	    setTimeout(function () {
	      if (!resolved) {
	        DraftEditorCompositionHandler.resolveComposition(editor);
	      }
	    }, RESOLVE_DELAY);
	  },
	  onSelect: editOnSelect,
	
	  /**
	   * In Safari, keydown events may fire when committing compositions. If
	   * the arrow keys are used to commit, prevent default so that the cursor
	   * doesn't move, otherwise it will jump back noticeably on re-render.
	   */
	  onKeyDown: function onKeyDown(editor, e) {
	    if (!stillComposing) {
	      // If a keydown event is received after compositionend but before the
	      // 20ms timer expires (ex: type option-E then backspace, or type A then
	      // backspace in 2-Set Korean), we should immediately resolve the
	      // composition and reinterpret the key press in edit mode.
	      DraftEditorCompositionHandler.resolveComposition(editor);
	
	      editor._onKeyDown(e);
	
	      return;
	    }
	
	    if (e.which === Keys.RIGHT || e.which === Keys.LEFT) {
	      e.preventDefault();
	    }
	  },
	
	  /**
	   * Keypress events may fire when committing compositions. In Firefox,
	   * pressing RETURN commits the composition and inserts extra newline
	   * characters that we do not want. `preventDefault` allows the composition
	   * to be committed while preventing the extra characters.
	   */
	  onKeyPress: function onKeyPress(_editor, e) {
	    if (e.which === Keys.RETURN) {
	      e.preventDefault();
	    }
	  },
	
	  /**
	   * Attempt to insert composed characters into the document.
	   *
	   * If we are still in a composition session, do nothing. Otherwise, insert
	   * the characters into the document and terminate the composition session.
	   *
	   * If no characters were composed -- for instance, the user
	   * deleted all composed characters and committed nothing new --
	   * force a re-render. We also re-render when the composition occurs
	   * at the beginning of a leaf, to ensure that if the browser has
	   * created a new text node for the composition, we will discard it.
	   *
	   * Resetting innerHTML will move focus to the beginning of the editor,
	   * so we update to force it back to the correct place.
	   */
	  resolveComposition: function resolveComposition(editor) {
	    if (stillComposing) {
	      return;
	    }
	
	    var mutations = nullthrows(domObserver).stopAndFlushMutations();
	    domObserver = null;
	    resolved = true;
	    var editorState = EditorState.set(editor._latestEditorState, {
	      inCompositionMode: false
	    });
	    editor.exitCurrentMode();
	
	    if (!mutations.size) {
	      editor.update(editorState);
	      return;
	    } // TODO, check if Facebook still needs this flag or if it could be removed.
	    // Since there can be multiple mutations providing a `composedChars` doesn't
	    // apply well on this new model.
	    // if (
	    //   gkx('draft_handlebeforeinput_composed_text') &&
	    //   editor.props.handleBeforeInput &&
	    //   isEventHandled(
	    //     editor.props.handleBeforeInput(
	    //       composedChars,
	    //       editorState,
	    //       event.timeStamp,
	    //     ),
	    //   )
	    // ) {
	    //   return;
	    // }
	
	
	    var contentState = editorState.getCurrentContent();
	    mutations.forEach(function (composedChars, offsetKey) {
	      var _DraftOffsetKey$decod = DraftOffsetKey.decode(offsetKey),
	          blockKey = _DraftOffsetKey$decod.blockKey,
	          decoratorKey = _DraftOffsetKey$decod.decoratorKey,
	          leafKey = _DraftOffsetKey$decod.leafKey;
	
	      var _editorState$getBlock = editorState.getBlockTree(blockKey).getIn([decoratorKey, 'leaves', leafKey]),
	          start = _editorState$getBlock.start,
	          end = _editorState$getBlock.end;
	
	      var replacementRange = editorState.getSelection().merge({
	        anchorKey: blockKey,
	        focusKey: blockKey,
	        anchorOffset: start,
	        focusOffset: end,
	        isBackward: false
	      });
	      var entityKey = getEntityKeyForSelection(contentState, replacementRange);
	      var currentStyle = contentState.getBlockForKey(blockKey).getInlineStyleAt(start);
	      contentState = DraftModifier.replaceText(contentState, replacementRange, composedChars, currentStyle, entityKey); // We need to update the editorState so the leaf node ranges are properly
	      // updated and multiple mutations are correctly applied.
	
	      editorState = EditorState.set(editorState, {
	        currentContent: contentState
	      });
	    }); // When we apply the text changes to the ContentState, the selection always
	    // goes to the end of the field, but it should just stay where it is
	    // after compositionEnd.
	
	    var documentSelection = getDraftEditorSelection(editorState, getContentEditableContainer(editor));
	    var compositionEndSelectionState = documentSelection.selectionState;
	    editor.restoreEditorDOM(); // See:
	    // - https://github.com/facebook/draft-js/issues/2093
	    // - https://github.com/facebook/draft-js/pull/2094
	    // Apply this fix only in IE for now. We can test it in
	    // other browsers in the future to ensure no regressions
	
	    var editorStateWithUpdatedSelection = isIE ? EditorState.forceSelection(editorState, compositionEndSelectionState) : EditorState.acceptSelection(editorState, compositionEndSelectionState);
	    editor.update(EditorState.push(editorStateWithUpdatedSelection, contentState, 'insert-characters'));
	  }
	};
	module.exports = DraftEditorCompositionHandler;

/***/ },
/* 1189 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	var _assign = __webpack_require__(58);
	
	function _extends() { _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	var DraftEditorBlock = __webpack_require__(392);
	
	var DraftOffsetKey = __webpack_require__(91);
	
	var React = __webpack_require__(1);
	
	var cx = __webpack_require__(108);
	
	var joinClasses = __webpack_require__(1287);
	
	var nullthrows = __webpack_require__(61);
	
	/**
	 * Provide default styling for list items. This way, lists will be styled with
	 * proper counters and indentation even if the caller does not specify
	 * their own styling at all. If more than five levels of nesting are needed,
	 * the necessary CSS classes can be provided via `blockStyleFn` configuration.
	 */
	var getListItemClasses = function getListItemClasses(type, depth, shouldResetCount, direction) {
	  return cx({
	    'public/DraftStyleDefault/unorderedListItem': type === 'unordered-list-item',
	    'public/DraftStyleDefault/orderedListItem': type === 'ordered-list-item',
	    'public/DraftStyleDefault/reset': shouldResetCount,
	    'public/DraftStyleDefault/depth0': depth === 0,
	    'public/DraftStyleDefault/depth1': depth === 1,
	    'public/DraftStyleDefault/depth2': depth === 2,
	    'public/DraftStyleDefault/depth3': depth === 3,
	    'public/DraftStyleDefault/depth4': depth >= 4,
	    'public/DraftStyleDefault/listLTR': direction === 'LTR',
	    'public/DraftStyleDefault/listRTL': direction === 'RTL'
	  });
	};
	/**
	 * `DraftEditorContents` is the container component for all block components
	 * rendered for a `DraftEditor`. It is optimized to aggressively avoid
	 * re-rendering blocks whenever possible.
	 *
	 * This component is separate from `DraftEditor` because certain props
	 * (for instance, ARIA props) must be allowed to update without affecting
	 * the contents of the editor.
	 */
	
	
	var DraftEditorContents = /*#__PURE__*/function (_React$Component) {
	  _inheritsLoose(DraftEditorContents, _React$Component);
	
	  function DraftEditorContents() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = DraftEditorContents.prototype;
	
	  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	    var prevEditorState = this.props.editorState;
	    var nextEditorState = nextProps.editorState;
	    var prevDirectionMap = prevEditorState.getDirectionMap();
	    var nextDirectionMap = nextEditorState.getDirectionMap(); // Text direction has changed for one or more blocks. We must re-render.
	
	    if (prevDirectionMap !== nextDirectionMap) {
	      return true;
	    }
	
	    var didHaveFocus = prevEditorState.getSelection().getHasFocus();
	    var nowHasFocus = nextEditorState.getSelection().getHasFocus();
	
	    if (didHaveFocus !== nowHasFocus) {
	      return true;
	    }
	
	    var nextNativeContent = nextEditorState.getNativelyRenderedContent();
	    var wasComposing = prevEditorState.isInCompositionMode();
	    var nowComposing = nextEditorState.isInCompositionMode(); // If the state is unchanged or we're currently rendering a natively
	    // rendered state, there's nothing new to be done.
	
	    if (prevEditorState === nextEditorState || nextNativeContent !== null && nextEditorState.getCurrentContent() === nextNativeContent || wasComposing && nowComposing) {
	      return false;
	    }
	
	    var prevContent = prevEditorState.getCurrentContent();
	    var nextContent = nextEditorState.getCurrentContent();
	    var prevDecorator = prevEditorState.getDecorator();
	    var nextDecorator = nextEditorState.getDecorator();
	    return wasComposing !== nowComposing || prevContent !== nextContent || prevDecorator !== nextDecorator || nextEditorState.mustForceSelection();
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        blockRenderMap = _this$props.blockRenderMap,
	        blockRendererFn = _this$props.blockRendererFn,
	        blockStyleFn = _this$props.blockStyleFn,
	        customStyleMap = _this$props.customStyleMap,
	        customStyleFn = _this$props.customStyleFn,
	        editorState = _this$props.editorState,
	        editorKey = _this$props.editorKey,
	        preventScroll = _this$props.preventScroll,
	        textDirectionality = _this$props.textDirectionality;
	    var content = editorState.getCurrentContent();
	    var selection = editorState.getSelection();
	    var forceSelection = editorState.mustForceSelection();
	    var decorator = editorState.getDecorator();
	    var directionMap = nullthrows(editorState.getDirectionMap());
	    var blocksAsArray = content.getBlocksAsArray();
	    var processedBlocks = [];
	    var currentDepth = null;
	    var lastWrapperTemplate = null;
	
	    for (var ii = 0; ii < blocksAsArray.length; ii++) {
	      var _block = blocksAsArray[ii];
	
	      var key = _block.getKey();
	
	      var blockType = _block.getType();
	
	      var customRenderer = blockRendererFn(_block);
	      var CustomComponent = void 0,
	          customProps = void 0,
	          customEditable = void 0;
	
	      if (customRenderer) {
	        CustomComponent = customRenderer.component;
	        customProps = customRenderer.props;
	        customEditable = customRenderer.editable;
	      }
	
	      var direction = textDirectionality ? textDirectionality : directionMap.get(key);
	      var offsetKey = DraftOffsetKey.encode(key, 0, 0);
	      var componentProps = {
	        contentState: content,
	        block: _block,
	        blockProps: customProps,
	        blockStyleFn: blockStyleFn,
	        customStyleMap: customStyleMap,
	        customStyleFn: customStyleFn,
	        decorator: decorator,
	        direction: direction,
	        forceSelection: forceSelection,
	        offsetKey: offsetKey,
	        preventScroll: preventScroll,
	        selection: selection,
	        tree: editorState.getBlockTree(key)
	      };
	      var configForType = blockRenderMap.get(blockType) || blockRenderMap.get('unstyled');
	      var wrapperTemplate = configForType.wrapper;
	      var Element = configForType.element || blockRenderMap.get('unstyled').element;
	
	      var depth = _block.getDepth();
	
	      var _className = '';
	
	      if (blockStyleFn) {
	        _className = blockStyleFn(_block);
	      } // List items are special snowflakes, since we handle nesting and
	      // counters manually.
	
	
	      if (Element === 'li') {
	        var shouldResetCount = lastWrapperTemplate !== wrapperTemplate || currentDepth === null || depth > currentDepth;
	        _className = joinClasses(_className, getListItemClasses(blockType, depth, shouldResetCount, direction));
	      }
	
	      var Component = CustomComponent || DraftEditorBlock;
	      var childProps = {
	        className: _className,
	        'data-block': true,
	        'data-editor': editorKey,
	        'data-offset-key': offsetKey,
	        key: key
	      };
	
	      if (customEditable !== undefined) {
	        childProps = _objectSpread({}, childProps, {
	          contentEditable: customEditable,
	          suppressContentEditableWarning: true
	        });
	      }
	
	      var child = React.createElement(Element, childProps,
	      /* $FlowFixMe[incompatible-type] (>=0.112.0 site=www,mobile) This
	       * comment suppresses an error found when Flow v0.112 was deployed. To
	       * see the error delete this comment and run Flow. */
	      React.createElement(Component, _extends({}, componentProps, {
	        key: key
	      })));
	      processedBlocks.push({
	        block: child,
	        wrapperTemplate: wrapperTemplate,
	        key: key,
	        offsetKey: offsetKey
	      });
	
	      if (wrapperTemplate) {
	        currentDepth = _block.getDepth();
	      } else {
	        currentDepth = null;
	      }
	
	      lastWrapperTemplate = wrapperTemplate;
	    } // Group contiguous runs of blocks that have the same wrapperTemplate
	
	
	    var outputBlocks = [];
	
	    for (var _ii = 0; _ii < processedBlocks.length;) {
	      var info = processedBlocks[_ii];
	
	      if (info.wrapperTemplate) {
	        var blocks = [];
	
	        do {
	          blocks.push(processedBlocks[_ii].block);
	          _ii++;
	        } while (_ii < processedBlocks.length && processedBlocks[_ii].wrapperTemplate === info.wrapperTemplate);
	
	        var wrapperElement = React.cloneElement(info.wrapperTemplate, {
	          key: info.key + '-wrap',
	          'data-offset-key': info.offsetKey
	        }, blocks);
	        outputBlocks.push(wrapperElement);
	      } else {
	        outputBlocks.push(info.block);
	        _ii++;
	      }
	    }
	
	    return React.createElement("div", {
	      "data-contents": "true"
	    }, outputBlocks);
	  };
	
	  return DraftEditorContents;
	}(React.Component);
	
	module.exports = DraftEditorContents;

/***/ },
/* 1190 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 */
	'use strict';
	
	var gkx = __webpack_require__(97);
	
	var experimentalTreeDataSupport = gkx('draft_tree_data_support');
	module.exports = experimentalTreeDataSupport ? __webpack_require__(1191) : __webpack_require__(1189);

/***/ },
/* 1191 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 *
	 * This file is a fork of DraftEditorContents.react.js for tree nodes
	 *
	 * This is unstable and not part of the public API and should not be used by
	 * production systems. This file may be update/removed without notice.
	 */
	'use strict';
	
	var _assign = __webpack_require__(58);
	
	function _extends() { _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	var DraftEditorBlockNode = __webpack_require__(1187);
	
	var DraftOffsetKey = __webpack_require__(91);
	
	var React = __webpack_require__(1);
	
	var nullthrows = __webpack_require__(61);
	
	/**
	 * `DraftEditorContents` is the container component for all block components
	 * rendered for a `DraftEditor`. It is optimized to aggressively avoid
	 * re-rendering blocks whenever possible.
	 *
	 * This component is separate from `DraftEditor` because certain props
	 * (for instance, ARIA props) must be allowed to update without affecting
	 * the contents of the editor.
	 */
	var DraftEditorContentsExperimental = /*#__PURE__*/function (_React$Component) {
	  _inheritsLoose(DraftEditorContentsExperimental, _React$Component);
	
	  function DraftEditorContentsExperimental() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = DraftEditorContentsExperimental.prototype;
	
	  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	    var prevEditorState = this.props.editorState;
	    var nextEditorState = nextProps.editorState;
	    var prevDirectionMap = prevEditorState.getDirectionMap();
	    var nextDirectionMap = nextEditorState.getDirectionMap(); // Text direction has changed for one or more blocks. We must re-render.
	
	    if (prevDirectionMap !== nextDirectionMap) {
	      return true;
	    }
	
	    var didHaveFocus = prevEditorState.getSelection().getHasFocus();
	    var nowHasFocus = nextEditorState.getSelection().getHasFocus();
	
	    if (didHaveFocus !== nowHasFocus) {
	      return true;
	    }
	
	    var nextNativeContent = nextEditorState.getNativelyRenderedContent();
	    var wasComposing = prevEditorState.isInCompositionMode();
	    var nowComposing = nextEditorState.isInCompositionMode(); // If the state is unchanged or we're currently rendering a natively
	    // rendered state, there's nothing new to be done.
	
	    if (prevEditorState === nextEditorState || nextNativeContent !== null && nextEditorState.getCurrentContent() === nextNativeContent || wasComposing && nowComposing) {
	      return false;
	    }
	
	    var prevContent = prevEditorState.getCurrentContent();
	    var nextContent = nextEditorState.getCurrentContent();
	    var prevDecorator = prevEditorState.getDecorator();
	    var nextDecorator = nextEditorState.getDecorator();
	    return wasComposing !== nowComposing || prevContent !== nextContent || prevDecorator !== nextDecorator || nextEditorState.mustForceSelection();
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        blockRenderMap = _this$props.blockRenderMap,
	        blockRendererFn = _this$props.blockRendererFn,
	        blockStyleFn = _this$props.blockStyleFn,
	        customStyleMap = _this$props.customStyleMap,
	        customStyleFn = _this$props.customStyleFn,
	        editorState = _this$props.editorState,
	        editorKey = _this$props.editorKey,
	        textDirectionality = _this$props.textDirectionality;
	    var content = editorState.getCurrentContent();
	    var selection = editorState.getSelection();
	    var forceSelection = editorState.mustForceSelection();
	    var decorator = editorState.getDecorator();
	    var directionMap = nullthrows(editorState.getDirectionMap());
	    var blocksAsArray = content.getBlocksAsArray();
	    var rootBlock = blocksAsArray[0];
	    var processedBlocks = [];
	    var nodeBlock = rootBlock;
	
	    while (nodeBlock) {
	      var blockKey = nodeBlock.getKey();
	      var blockProps = {
	        blockRenderMap: blockRenderMap,
	        blockRendererFn: blockRendererFn,
	        blockStyleFn: blockStyleFn,
	        contentState: content,
	        customStyleFn: customStyleFn,
	        customStyleMap: customStyleMap,
	        decorator: decorator,
	        editorKey: editorKey,
	        editorState: editorState,
	        forceSelection: forceSelection,
	        selection: selection,
	        block: nodeBlock,
	        direction: textDirectionality ? textDirectionality : directionMap.get(blockKey),
	        tree: editorState.getBlockTree(blockKey)
	      };
	      var configForType = blockRenderMap.get(nodeBlock.getType()) || blockRenderMap.get('unstyled');
	      var wrapperTemplate = configForType.wrapper;
	      processedBlocks.push({
	        /* $FlowFixMe[incompatible-type] (>=0.112.0 site=www,mobile) This
	         * comment suppresses an error found when Flow v0.112 was deployed. To
	         * see the error delete this comment and run Flow. */
	        block: React.createElement(DraftEditorBlockNode, _extends({
	          key: blockKey
	        }, blockProps)),
	        wrapperTemplate: wrapperTemplate,
	        key: blockKey,
	        offsetKey: DraftOffsetKey.encode(blockKey, 0, 0)
	      });
	      var nextBlockKey = nodeBlock.getNextSiblingKey();
	      nodeBlock = nextBlockKey ? content.getBlockForKey(nextBlockKey) : null;
	    } // Group contiguous runs of blocks that have the same wrapperTemplate
	
	
	    var outputBlocks = [];
	
	    for (var ii = 0; ii < processedBlocks.length;) {
	      var info = processedBlocks[ii];
	
	      if (info.wrapperTemplate) {
	        var blocks = [];
	
	        do {
	          blocks.push(processedBlocks[ii].block);
	          ii++;
	        } while (ii < processedBlocks.length && processedBlocks[ii].wrapperTemplate === info.wrapperTemplate);
	
	        var wrapperElement = React.cloneElement(info.wrapperTemplate, {
	          key: info.key + '-wrap',
	          'data-offset-key': info.offsetKey
	        }, blocks);
	        outputBlocks.push(wrapperElement);
	      } else {
	        outputBlocks.push(info.block);
	        ii++;
	      }
	    }
	
	    return React.createElement("div", {
	      "data-contents": "true"
	    }, outputBlocks);
	  };
	
	  return DraftEditorContentsExperimental;
	}(React.Component);
	
	module.exports = DraftEditorContentsExperimental;

/***/ },
/* 1192 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 *
	 * This is unstable and not part of the public API and should not be used by
	 * production systems. This file may be update/removed without notice.
	 */
	'use strict';
	
	var _assign = __webpack_require__(58);
	
	function _extends() { _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	var DraftOffsetKey = __webpack_require__(91);
	
	var React = __webpack_require__(1);
	
	var UnicodeBidi = __webpack_require__(269);
	
	var UnicodeBidiDirection = __webpack_require__(199);
	
	var DraftEditorDecoratedLeaves = /*#__PURE__*/function (_React$Component) {
	  _inheritsLoose(DraftEditorDecoratedLeaves, _React$Component);
	
	  function DraftEditorDecoratedLeaves() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = DraftEditorDecoratedLeaves.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        block = _this$props.block,
	        children = _this$props.children,
	        contentState = _this$props.contentState,
	        decorator = _this$props.decorator,
	        decoratorKey = _this$props.decoratorKey,
	        direction = _this$props.direction,
	        leafSet = _this$props.leafSet,
	        text = _this$props.text;
	    var blockKey = block.getKey();
	    var leavesForLeafSet = leafSet.get('leaves');
	    var DecoratorComponent = decorator.getComponentForKey(decoratorKey);
	    var decoratorProps = decorator.getPropsForKey(decoratorKey);
	    var decoratorOffsetKey = DraftOffsetKey.encode(blockKey, parseInt(decoratorKey, 10), 0);
	    var decoratedText = text.slice(leavesForLeafSet.first().get('start'), leavesForLeafSet.last().get('end')); // Resetting dir to the same value on a child node makes Chrome/Firefox
	    // confused on cursor movement. See http://jsfiddle.net/d157kLck/3/
	
	    var dir = UnicodeBidiDirection.getHTMLDirIfDifferent(UnicodeBidi.getDirection(decoratedText), direction);
	    return React.createElement(DecoratorComponent, _extends({}, decoratorProps, {
	      contentState: contentState,
	      decoratedText: decoratedText,
	      dir: dir,
	      key: decoratorOffsetKey,
	      entityKey: block.getEntityAt(leafSet.get('start')),
	      offsetKey: decoratorOffsetKey
	    }), children);
	  };
	
	  return DraftEditorDecoratedLeaves;
	}(React.Component);
	
	module.exports = DraftEditorDecoratedLeaves;

/***/ },
/* 1193 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	var DataTransfer = __webpack_require__(428);
	
	var DraftModifier = __webpack_require__(59);
	
	var EditorState = __webpack_require__(36);
	
	var findAncestorOffsetKey = __webpack_require__(192);
	
	var getCorrectDocumentFromNode = __webpack_require__(194);
	
	var getTextContentFromFiles = __webpack_require__(413);
	
	var getUpdatedSelectionState = __webpack_require__(414);
	
	var getWindowForNode = __webpack_require__(415);
	
	var isEventHandled = __webpack_require__(195);
	
	var nullthrows = __webpack_require__(61);
	/**
	 * Get a SelectionState for the supplied mouse event.
	 */
	
	
	function getSelectionForEvent(event, editorState) {
	  var node = null;
	  var offset = null;
	  var eventTargetDocument = getCorrectDocumentFromNode(event.currentTarget);
	  /* $FlowFixMe[prop-missing] (>=0.68.0 site=www,mobile) This comment
	   * suppresses an error found when Flow v0.68 was deployed. To see the error
	   * delete this comment and run Flow. */
	
	  if (typeof eventTargetDocument.caretRangeFromPoint === 'function') {
	    /* $FlowFixMe[incompatible-use] (>=0.68.0 site=www,mobile) This comment
	     * suppresses an error found when Flow v0.68 was deployed. To see the error
	     * delete this comment and run Flow. */
	    var dropRange = eventTargetDocument.caretRangeFromPoint(event.x, event.y);
	    node = dropRange.startContainer;
	    offset = dropRange.startOffset;
	  } else if (event.rangeParent) {
	    node = event.rangeParent;
	    offset = event.rangeOffset;
	  } else {
	    return null;
	  }
	
	  node = nullthrows(node);
	  offset = nullthrows(offset);
	  var offsetKey = nullthrows(findAncestorOffsetKey(node));
	  return getUpdatedSelectionState(editorState, offsetKey, offset, offsetKey, offset);
	}
	
	var DraftEditorDragHandler = {
	  /**
	   * Drag originating from input terminated.
	   */
	  onDragEnd: function onDragEnd(editor) {
	    editor.exitCurrentMode();
	    endDrag(editor);
	  },
	
	  /**
	   * Handle data being dropped.
	   */
	  onDrop: function onDrop(editor, e) {
	    var data = new DataTransfer(e.nativeEvent.dataTransfer);
	    var editorState = editor._latestEditorState;
	    var dropSelection = getSelectionForEvent(e.nativeEvent, editorState);
	    e.preventDefault();
	    editor._dragCount = 0;
	    editor.exitCurrentMode();
	
	    if (dropSelection == null) {
	      return;
	    }
	
	    var files = data.getFiles();
	
	    if (files.length > 0) {
	      if (editor.props.handleDroppedFiles && isEventHandled(editor.props.handleDroppedFiles(dropSelection, files))) {
	        return;
	      }
	      /* $FlowFixMe[incompatible-call] This comment suppresses an error found
	       * DataTransfer was typed. getFiles() returns an array of <Files extends
	       * Blob>, not Blob */
	
	
	      getTextContentFromFiles(files, function (fileText) {
	        fileText && editor.update(insertTextAtSelection(editorState, dropSelection, fileText));
	      });
	      return;
	    }
	
	    var dragType = editor._internalDrag ? 'internal' : 'external';
	
	    if (editor.props.handleDrop && isEventHandled(editor.props.handleDrop(dropSelection, data, dragType))) {// handled
	    } else if (editor._internalDrag) {
	      editor.update(moveText(editorState, dropSelection));
	    } else {
	      editor.update(insertTextAtSelection(editorState, dropSelection, data.getText()));
	    }
	
	    endDrag(editor);
	  }
	};
	
	function endDrag(editor) {
	  editor._internalDrag = false; // Fix issue #1383
	  // Prior to React v16.5.0 onDrop breaks onSelect event:
	  // https://github.com/facebook/react/issues/11379.
	  // Dispatching a mouseup event on DOM node will make it go back to normal.
	
	  var editorNode = editor.editorContainer;
	
	  if (editorNode) {
	    var mouseUpEvent = new MouseEvent('mouseup', {
	      view: getWindowForNode(editorNode),
	      bubbles: true,
	      cancelable: true
	    });
	    editorNode.dispatchEvent(mouseUpEvent);
	  }
	}
	
	function moveText(editorState, targetSelection) {
	  var newContentState = DraftModifier.moveText(editorState.getCurrentContent(), editorState.getSelection(), targetSelection);
	  return EditorState.push(editorState, newContentState, 'insert-fragment');
	}
	/**
	 * Insert text at a specified selection.
	 */
	
	
	function insertTextAtSelection(editorState, selection, text) {
	  var newContentState = DraftModifier.insertText(editorState.getCurrentContent(), selection, text, editorState.getCurrentInlineStyle());
	  return EditorState.push(editorState, newContentState, 'insert-fragment');
	}
	
	module.exports = DraftEditorDragHandler;

/***/ },
/* 1194 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	var UserAgent = __webpack_require__(60);
	
	var onBeforeInput = __webpack_require__(1214);
	
	var onBlur = __webpack_require__(1215);
	
	var onCompositionStart = __webpack_require__(1216);
	
	var onCopy = __webpack_require__(1217);
	
	var onCut = __webpack_require__(1218);
	
	var onDragOver = __webpack_require__(1219);
	
	var onDragStart = __webpack_require__(1220);
	
	var onFocus = __webpack_require__(1221);
	
	var onInput = __webpack_require__(1222);
	
	var onKeyDown = __webpack_require__(1223);
	
	var onPaste = __webpack_require__(1224);
	
	var onSelect = __webpack_require__(402);
	
	var isChrome = UserAgent.isBrowser('Chrome');
	var isFirefox = UserAgent.isBrowser('Firefox');
	var selectionHandler = isChrome || isFirefox ? onSelect : function (e) {};
	var DraftEditorEditHandler = {
	  onBeforeInput: onBeforeInput,
	  onBlur: onBlur,
	  onCompositionStart: onCompositionStart,
	  onCopy: onCopy,
	  onCut: onCut,
	  onDragOver: onDragOver,
	  onDragStart: onDragStart,
	  onFocus: onFocus,
	  onInput: onInput,
	  onKeyDown: onKeyDown,
	  onPaste: onPaste,
	  onSelect: onSelect,
	  // In certain cases, contenteditable on chrome does not fire the onSelect
	  // event, causing problems with cursor positioning. Therefore, the selection
	  // state update handler is added to more events to ensure that the selection
	  // state is always synced with the actual cursor positions.
	  onMouseUp: selectionHandler,
	  onKeyUp: selectionHandler
	};
	module.exports = DraftEditorEditHandler;

/***/ },
/* 1195 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	var ReactDOMComet = __webpack_require__(43);
	
	var flushControlled = ReactDOMComet.unstable_flushControlled;
	module.exports = flushControlled;

/***/ },
/* 1196 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 *
	 * This is unstable and not part of the public API and should not be used by
	 * production systems. This file may be update/removed without notice.
	 */
	'use strict';
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	var DraftEditorDecoratedLeaves = __webpack_require__(1192);
	
	var DraftEditorLeaf = __webpack_require__(393);
	
	var DraftOffsetKey = __webpack_require__(91);
	
	var Immutable = __webpack_require__(27);
	
	var React = __webpack_require__(1);
	
	var cx = __webpack_require__(108);
	
	var List = Immutable.List;
	
	var DraftEditorNode = /*#__PURE__*/function (_React$Component) {
	  _inheritsLoose(DraftEditorNode, _React$Component);
	
	  function DraftEditorNode() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = DraftEditorNode.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        block = _this$props.block,
	        contentState = _this$props.contentState,
	        customStyleFn = _this$props.customStyleFn,
	        customStyleMap = _this$props.customStyleMap,
	        decorator = _this$props.decorator,
	        direction = _this$props.direction,
	        forceSelection = _this$props.forceSelection,
	        hasSelection = _this$props.hasSelection,
	        selection = _this$props.selection,
	        tree = _this$props.tree;
	    var blockKey = block.getKey();
	    var text = block.getText();
	    var lastLeafSet = tree.size - 1;
	    var children = this.props.children || tree.map(function (leafSet, ii) {
	      var decoratorKey = leafSet.get('decoratorKey');
	      var leavesForLeafSet = leafSet.get('leaves');
	      var lastLeaf = leavesForLeafSet.size - 1;
	      var Leaves = leavesForLeafSet.map(function (leaf, jj) {
	        var offsetKey = DraftOffsetKey.encode(blockKey, ii, jj);
	        var start = leaf.get('start');
	        var end = leaf.get('end');
	        return React.createElement(DraftEditorLeaf, {
	          key: offsetKey,
	          offsetKey: offsetKey,
	          block: block,
	          start: start,
	          selection: hasSelection ? selection : null,
	          forceSelection: forceSelection,
	          text: text.slice(start, end),
	          styleSet: block.getInlineStyleAt(start),
	          customStyleMap: customStyleMap,
	          customStyleFn: customStyleFn,
	          isLast: decoratorKey === lastLeafSet && jj === lastLeaf
	        });
	      }).toArray();
	
	      if (!decoratorKey || !decorator) {
	        return Leaves;
	      }
	
	      return React.createElement(DraftEditorDecoratedLeaves, {
	        block: block,
	        children: Leaves,
	        contentState: contentState,
	        decorator: decorator,
	        decoratorKey: decoratorKey,
	        direction: direction,
	        leafSet: leafSet,
	        text: text,
	        key: ii
	      });
	    }).toArray();
	    return React.createElement("div", {
	      "data-offset-key": DraftOffsetKey.encode(blockKey, 0, 0),
	      className: cx({
	        'public/DraftStyleDefault/block': true,
	        'public/DraftStyleDefault/ltr': direction === 'LTR',
	        'public/DraftStyleDefault/rtl': direction === 'RTL'
	      })
	    }, children);
	  };
	
	  return DraftEditorNode;
	}(React.Component);
	
	module.exports = DraftEditorNode;

/***/ },
/* 1197 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(1);
	
	var cx = __webpack_require__(108);
	
	/**
	 * This component is responsible for rendering placeholder text for the
	 * `DraftEditor` component.
	 *
	 * Override placeholder style via CSS.
	 */
	var DraftEditorPlaceholder = /*#__PURE__*/function (_React$Component) {
	  _inheritsLoose(DraftEditorPlaceholder, _React$Component);
	
	  function DraftEditorPlaceholder() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = DraftEditorPlaceholder.prototype;
	
	  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	    return this.props.text !== nextProps.text || this.props.editorState.getSelection().getHasFocus() !== nextProps.editorState.getSelection().getHasFocus();
	  };
	
	  _proto.render = function render() {
	    var hasFocus = this.props.editorState.getSelection().getHasFocus();
	    var className = cx({
	      'public/DraftEditorPlaceholder/root': true,
	      'public/DraftEditorPlaceholder/hasFocus': hasFocus
	    });
	    var contentStyle = {
	      whiteSpace: 'pre-wrap'
	    };
	    return React.createElement("div", {
	      className: className
	    }, React.createElement("div", {
	      className: cx('public/DraftEditorPlaceholder/inner'),
	      id: this.props.accessibilityID,
	      style: contentStyle
	    }, this.props.text));
	  };
	
	  return DraftEditorPlaceholder;
	}(React.Component);
	
	module.exports = DraftEditorPlaceholder;

/***/ },
/* 1198 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var React = __webpack_require__(1);
	
	var UserAgent = __webpack_require__(60);
	
	var invariant = __webpack_require__(32);
	
	var isElement = __webpack_require__(105); // In IE, spans with <br> tags render as two newlines. By rendering a span
	// with only a newline character, we can be sure to render a single line.
	
	
	var useNewlineChar = UserAgent.isBrowser('IE <= 11');
	/**
	 * Check whether the node should be considered a newline.
	 */
	
	function isNewline(node) {
	  return useNewlineChar ? node.textContent === '\n' : node.tagName === 'BR';
	}
	/**
	 * Placeholder elements for empty text content.
	 *
	 * What is this `data-text` attribute, anyway? It turns out that we need to
	 * put an attribute on the lowest-level text node in order to preserve correct
	 * spellcheck handling. If the <span> is naked, Chrome and Safari may do
	 * bizarre things to do the DOM -- split text nodes, create extra spans, etc.
	 * If the <span> has an attribute, this appears not to happen.
	 * See http://jsfiddle.net/9khdavod/ for the failure case, and
	 * http://jsfiddle.net/7pg143f7/ for the fixed case.
	 */
	
	
	var NEWLINE_A = function NEWLINE_A(ref) {
	  return useNewlineChar ? React.createElement("span", {
	    key: "A",
	    "data-text": "true",
	    ref: ref
	  }, '\n') : React.createElement("br", {
	    key: "A",
	    "data-text": "true",
	    ref: ref
	  });
	};
	
	var NEWLINE_B = function NEWLINE_B(ref) {
	  return useNewlineChar ? React.createElement("span", {
	    key: "B",
	    "data-text": "true",
	    ref: ref
	  }, '\n') : React.createElement("br", {
	    key: "B",
	    "data-text": "true",
	    ref: ref
	  });
	};
	
	/**
	 * The lowest-level component in a `DraftEditor`, the text node component
	 * replaces the default React text node implementation. This allows us to
	 * perform custom handling of newline behavior and avoid re-rendering text
	 * nodes with DOM state that already matches the expectations of our immutable
	 * editor state.
	 */
	var DraftEditorTextNode = /*#__PURE__*/function (_React$Component) {
	  _inheritsLoose(DraftEditorTextNode, _React$Component);
	
	  function DraftEditorTextNode(props) {
	    var _this;
	
	    _this = _React$Component.call(this, props) || this; // By flipping this flag, we also keep flipping keys which forces
	    // React to remount this node every time it rerenders.
	
	    _defineProperty(_assertThisInitialized(_this), "_forceFlag", void 0);
	
	    _defineProperty(_assertThisInitialized(_this), "_node", void 0);
	
	    _this._forceFlag = false;
	    return _this;
	  }
	
	  var _proto = DraftEditorTextNode.prototype;
	
	  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	    var node = this._node;
	    var shouldBeNewline = nextProps.children === '';
	    !isElement(node) ?  false ? invariant(false, 'node is not an Element') : invariant(false) : void 0;
	    var elementNode = node;
	
	    if (shouldBeNewline) {
	      return !isNewline(elementNode);
	    }
	
	    return elementNode.textContent !== nextProps.children;
	  };
	
	  _proto.componentDidMount = function componentDidMount() {
	    this._forceFlag = !this._forceFlag;
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate() {
	    this._forceFlag = !this._forceFlag;
	  };
	
	  _proto.render = function render() {
	    var _this2 = this;
	
	    if (this.props.children === '') {
	      return this._forceFlag ? NEWLINE_A(function (ref) {
	        return _this2._node = ref;
	      }) : NEWLINE_B(function (ref) {
	        return _this2._node = ref;
	      });
	    }
	
	    return React.createElement("span", {
	      key: this._forceFlag ? 'A' : 'B',
	      "data-text": "true",
	      ref: function ref(_ref) {
	        return _this2._node = _ref;
	      }
	    }, this.props.children);
	  };
	
	  return DraftEditorTextNode;
	}(React.Component);
	
	module.exports = DraftEditorTextNode;

/***/ },
/* 1199 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	/**
	 * Identify the range to delete from a segmented entity.
	 *
	 * Rules:
	 *
	 *  Example: 'John F. Kennedy'
	 *
	 *   - Deletion from within any non-whitespace (i.e. ['John', 'F.', 'Kennedy'])
	 *     will return the range of that text.
	 *
	 *       'John F. Kennedy' -> 'John F.'
	 *                  ^
	 *
	 *   - Forward deletion of whitespace will remove the following section:
	 *
	 *       'John F. Kennedy' -> 'John Kennedy'
	 *            ^
	 *
	 *   - Backward deletion of whitespace will remove the previous section:
	 *
	 *       'John F. Kennedy' -> 'F. Kennedy'
	 *            ^
	 */
	var DraftEntitySegments = {
	  getRemovalRange: function getRemovalRange(selectionStart, selectionEnd, text, entityStart, direction) {
	    var segments = text.split(' ');
	    segments = segments.map(function (
	    /*string*/
	    segment,
	    /*number*/
	    ii) {
	      if (direction === 'forward') {
	        if (ii > 0) {
	          return ' ' + segment;
	        }
	      } else if (ii < segments.length - 1) {
	        return segment + ' ';
	      }
	
	      return segment;
	    });
	    var segmentStart = entityStart;
	    var segmentEnd;
	    var segment;
	    var removalStart = null;
	    var removalEnd = null;
	
	    for (var jj = 0; jj < segments.length; jj++) {
	      segment = segments[jj];
	      segmentEnd = segmentStart + segment.length; // Our selection overlaps this segment.
	
	      if (selectionStart < segmentEnd && segmentStart < selectionEnd) {
	        if (removalStart !== null) {
	          removalEnd = segmentEnd;
	        } else {
	          removalStart = segmentStart;
	          removalEnd = segmentEnd;
	        }
	      } else if (removalStart !== null) {
	        break;
	      }
	
	      segmentStart = segmentEnd;
	    }
	
	    var entityEnd = entityStart + text.length;
	    var atStart = removalStart === entityStart;
	    var atEnd = removalEnd === entityEnd;
	
	    if (!atStart && atEnd || atStart && !atEnd) {
	      if (direction === 'forward') {
	        if (removalEnd !== entityEnd) {
	          removalEnd++;
	        }
	      } else if (removalStart !== entityStart) {
	        removalStart--;
	      }
	    }
	
	    return {
	      start: removalStart,
	      end: removalEnd
	    };
	  }
	};
	module.exports = DraftEntitySegments;

/***/ },
/* 1200 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var ContentBlock = __webpack_require__(104);
	
	var ContentBlockNode = __webpack_require__(71);
	
	var convertFromHTMLToContentBlocks = __webpack_require__(400);
	
	var generateRandomKey = __webpack_require__(85);
	
	var getSafeBodyFromHTML = __webpack_require__(411);
	
	var gkx = __webpack_require__(97);
	
	var Immutable = __webpack_require__(27);
	
	var sanitizeDraftText = __webpack_require__(423);
	
	var List = Immutable.List,
	    Repeat = Immutable.Repeat;
	var experimentalTreeDataSupport = gkx('draft_tree_data_support');
	var ContentBlockRecord = experimentalTreeDataSupport ? ContentBlockNode : ContentBlock;
	var DraftPasteProcessor = {
	  processHTML: function processHTML(html, blockRenderMap) {
	    return convertFromHTMLToContentBlocks(html, getSafeBodyFromHTML, blockRenderMap);
	  },
	  processText: function processText(textBlocks, character, type) {
	    return textBlocks.reduce(function (acc, textLine, index) {
	      textLine = sanitizeDraftText(textLine);
	      var key = generateRandomKey();
	      var blockNodeConfig = {
	        key: key,
	        type: type,
	        text: textLine,
	        characterList: List(Repeat(character, textLine.length))
	      }; // next block updates previous block
	
	      if (experimentalTreeDataSupport && index !== 0) {
	        var prevSiblingIndex = index - 1; // update previous block
	
	        var previousBlock = acc[prevSiblingIndex] = acc[prevSiblingIndex].merge({
	          nextSibling: key
	        });
	        blockNodeConfig = _objectSpread({}, blockNodeConfig, {
	          prevSibling: previousBlock.getKey()
	        });
	      }
	
	      acc.push(new ContentBlockRecord(blockNodeConfig));
	      return acc;
	    }, []);
	  }
	};
	module.exports = DraftPasteProcessor;

/***/ },
/* 1201 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 *
	 * This is unstable and not part of the public API and should not be used by
	 * production systems. This file may be update/removed without notice.
	 */
	var generateRandomKey = __webpack_require__(85);
	
	var invariant = __webpack_require__(32);
	
	var traverseInDepthOrder = function traverseInDepthOrder(blocks, fn) {
	  var stack = [].concat(blocks).reverse();
	
	  while (stack.length) {
	    var _block = stack.pop();
	
	    fn(_block);
	    var children = _block.children;
	    !Array.isArray(children) ?  false ? invariant(false, 'Invalid tree raw block') : invariant(false) : void 0;
	    stack = stack.concat([].concat(children.reverse()));
	  }
	};
	
	var isListBlock = function isListBlock(block) {
	  if (!(block && block.type)) {
	    return false;
	  }
	
	  var type = block.type;
	  return type === 'unordered-list-item' || type === 'ordered-list-item';
	};
	
	var addDepthToChildren = function addDepthToChildren(block) {
	  if (Array.isArray(block.children)) {
	    block.children = block.children.map(function (child) {
	      return child.type === block.type ? _objectSpread({}, child, {
	        depth: (block.depth || 0) + 1
	      }) : child;
	    });
	  }
	};
	/**
	 * This adapter is intended to be be used as an adapter to draft tree data
	 *
	 * draft state <=====> draft tree state
	 */
	
	
	var DraftTreeAdapter = {
	  /**
	   * Converts from a tree raw state back to draft raw state
	   */
	  fromRawTreeStateToRawState: function fromRawTreeStateToRawState(draftTreeState) {
	    var blocks = draftTreeState.blocks;
	    var transformedBlocks = [];
	    !Array.isArray(blocks) ?  false ? invariant(false, 'Invalid raw state') : invariant(false) : void 0;
	
	    if (!Array.isArray(blocks) || !blocks.length) {
	      return draftTreeState;
	    }
	
	    traverseInDepthOrder(blocks, function (block) {
	      var newBlock = _objectSpread({}, block);
	
	      if (isListBlock(block)) {
	        newBlock.depth = newBlock.depth || 0;
	        addDepthToChildren(block); // if it's a non-leaf node, we don't do anything else
	
	        if (block.children != null && block.children.length > 0) {
	          return;
	        }
	      }
	
	      delete newBlock.children;
	      transformedBlocks.push(newBlock);
	    });
	    draftTreeState.blocks = transformedBlocks;
	    return _objectSpread({}, draftTreeState, {
	      blocks: transformedBlocks
	    });
	  },
	
	  /**
	   * Converts from draft raw state to tree draft state
	   */
	  fromRawStateToRawTreeState: function fromRawStateToRawTreeState(draftState) {
	    var transformedBlocks = [];
	    var parentStack = [];
	    draftState.blocks.forEach(function (block) {
	      var isList = isListBlock(block);
	      var depth = block.depth || 0;
	
	      var treeBlock = _objectSpread({}, block, {
	        children: []
	      });
	
	      if (!isList) {
	        transformedBlocks.push(treeBlock);
	        return;
	      }
	
	      var lastParent = parentStack[0]; // block is non-nested & there are no nested blocks, directly push block
	
	      if (lastParent == null && depth === 0) {
	        transformedBlocks.push(treeBlock); // block is first nested block or previous nested block is at a lower level
	      } else if (lastParent == null || lastParent.depth < depth - 1) {
	        // create new parent block
	        var newParent = {
	          key: generateRandomKey(),
	          text: '',
	          depth: depth - 1,
	          type: block.type,
	          children: [],
	          entityRanges: [],
	          inlineStyleRanges: []
	        };
	        parentStack.unshift(newParent);
	
	        if (depth === 1) {
	          // add as a root-level block
	          transformedBlocks.push(newParent);
	        } else if (lastParent != null) {
	          // depth > 1 => also add as previous parent's child
	          lastParent.children.push(newParent);
	        }
	
	        newParent.children.push(treeBlock);
	      } else if (lastParent.depth === depth - 1) {
	        // add as child of last parent
	        lastParent.children.push(treeBlock);
	      } else {
	        // pop out parents at levels above this one from the parent stack
	        while (lastParent != null && lastParent.depth >= depth) {
	          parentStack.shift();
	          lastParent = parentStack[0];
	        }
	
	        if (depth > 0) {
	          lastParent.children.push(treeBlock);
	        } else {
	          transformedBlocks.push(treeBlock);
	        }
	      }
	    });
	    return _objectSpread({}, draftState, {
	      blocks: transformedBlocks
	    });
	  }
	};
	module.exports = DraftTreeAdapter;

/***/ },
/* 1202 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 *
	 * This is unstable and not part of the public API and should not be used by
	 * production systems. This file may be update/removed without notice.
	 */
	var warning = __webpack_require__(271);
	
	var DraftTreeInvariants = {
	  /**
	   * Check if the block is valid
	   */
	  isValidBlock: function isValidBlock(block, blockMap) {
	    var key = block.getKey(); // is its parent's child
	
	    var parentKey = block.getParentKey();
	
	    if (parentKey != null) {
	      var parent = blockMap.get(parentKey);
	
	      if (!parent.getChildKeys().includes(key)) {
	         false ? warning(true, 'Tree is missing parent -> child pointer on %s', key) : void 0;
	        return false;
	      }
	    } // is its children's parent
	
	
	    var children = block.getChildKeys().map(function (k) {
	      return blockMap.get(k);
	    });
	
	    if (!children.every(function (c) {
	      return c.getParentKey() === key;
	    })) {
	       false ? warning(true, 'Tree is missing child -> parent pointer on %s', key) : void 0;
	      return false;
	    } // is its previous sibling's next sibling
	
	
	    var prevSiblingKey = block.getPrevSiblingKey();
	
	    if (prevSiblingKey != null) {
	      var prevSibling = blockMap.get(prevSiblingKey);
	
	      if (prevSibling.getNextSiblingKey() !== key) {
	         false ? warning(true, "Tree is missing nextSibling pointer on %s's prevSibling", key) : void 0;
	        return false;
	      }
	    } // is its next sibling's previous sibling
	
	
	    var nextSiblingKey = block.getNextSiblingKey();
	
	    if (nextSiblingKey != null) {
	      var nextSibling = blockMap.get(nextSiblingKey);
	
	      if (nextSibling.getPrevSiblingKey() !== key) {
	         false ? warning(true, "Tree is missing prevSibling pointer on %s's nextSibling", key) : void 0;
	        return false;
	      }
	    } // no 2-node cycles
	
	
	    if (nextSiblingKey !== null && prevSiblingKey !== null) {
	      if (prevSiblingKey === nextSiblingKey) {
	         false ? warning(true, 'Tree has a two-node cycle at %s', key) : void 0;
	        return false;
	      }
	    } // if it's a leaf node, it has text but no children
	
	
	    if (block.text != '') {
	      if (block.getChildKeys().size > 0) {
	         false ? warning(true, 'Leaf node %s has children', key) : void 0;
	        return false;
	      }
	    }
	
	    return true;
	  },
	
	  /**
	   * Checks that this is a connected tree on all the blocks
	   * starting from the first block, traversing nextSibling and child pointers
	   * should be a tree (preorder traversal - parent, then children)
	   * num of connected node === number of blocks
	   */
	  isConnectedTree: function isConnectedTree(blockMap) {
	    // exactly one node has no previous sibling + no parent
	    var eligibleFirstNodes = blockMap.toArray().filter(function (block) {
	      return block.getParentKey() == null && block.getPrevSiblingKey() == null;
	    });
	
	    if (eligibleFirstNodes.length !== 1) {
	       false ? warning(true, 'Tree is not connected. More or less than one first node') : void 0;
	      return false;
	    }
	
	    var firstNode = eligibleFirstNodes.shift();
	    var nodesSeen = 0;
	    var currentKey = firstNode.getKey();
	    var visitedStack = [];
	
	    while (currentKey != null) {
	      var currentNode = blockMap.get(currentKey);
	      var childKeys = currentNode.getChildKeys();
	      var nextSiblingKey = currentNode.getNextSiblingKey(); // if the node has children, add parent's next sibling to stack and go to children
	
	      if (childKeys.size > 0) {
	        if (nextSiblingKey != null) {
	          visitedStack.unshift(nextSiblingKey);
	        }
	
	        var children = childKeys.map(function (k) {
	          return blockMap.get(k);
	        });
	
	        var _firstNode = children.find(function (block) {
	          return block.getPrevSiblingKey() == null;
	        });
	
	        if (_firstNode == null) {
	           false ? warning(true, '%s has no first child', currentKey) : void 0;
	          return false;
	        }
	
	        currentKey = _firstNode.getKey(); // TODO(T32490138): Deal with multi-node cycles here
	      } else {
	        if (currentNode.getNextSiblingKey() != null) {
	          currentKey = currentNode.getNextSiblingKey();
	        } else {
	          currentKey = visitedStack.shift();
	        }
	      }
	
	      nodesSeen++;
	    }
	
	    if (nodesSeen !== blockMap.size) {
	       false ? warning(true, 'Tree is not connected. %s nodes were seen instead of %s', nodesSeen, blockMap.size) : void 0;
	      return false;
	    }
	
	    return true;
	  },
	
	  /**
	   * Checks that the block map is a connected tree with valid blocks
	   */
	  isValidTree: function isValidTree(blockMap) {
	    var _this = this;
	
	    var blocks = blockMap.toArray();
	
	    if (!blocks.every(function (block) {
	      return _this.isValidBlock(block, blockMap);
	    })) {
	      return false;
	    }
	
	    return this.isConnectedTree(blockMap);
	  }
	};
	module.exports = DraftTreeInvariants;

/***/ },
/* 1203 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	var UnicodeBidiService = __webpack_require__(1275);
	
	var Immutable = __webpack_require__(27);
	
	var nullthrows = __webpack_require__(61);
	
	var OrderedMap = Immutable.OrderedMap;
	var bidiService;
	var EditorBidiService = {
	  getDirectionMap: function getDirectionMap(content, prevBidiMap) {
	    if (!bidiService) {
	      bidiService = new UnicodeBidiService();
	    } else {
	      bidiService.reset();
	    }
	
	    var blockMap = content.getBlockMap();
	    var nextBidi = blockMap.valueSeq().map(function (block) {
	      return nullthrows(bidiService).getDirection(block.getText());
	    });
	    var bidiMap = OrderedMap(blockMap.keySeq().zip(nextBidi));
	
	    if (prevBidiMap != null && Immutable.is(prevBidiMap, bidiMap)) {
	      return prevBidiMap;
	    }
	
	    return bidiMap;
	  }
	};
	module.exports = EditorBidiService;

/***/ },
/* 1204 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';

/***/ },
/* 1205 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	var DraftModifier = __webpack_require__(59);
	
	var EditorState = __webpack_require__(36);
	
	var getContentStateFragment = __webpack_require__(193);
	
	var nullthrows = __webpack_require__(61);
	
	var clipboard = null;
	/**
	 * Some systems offer a "secondary" clipboard to allow quick internal cut
	 * and paste behavior. For instance, Ctrl+K (cut) and Ctrl+Y (paste).
	 */
	
	var SecondaryClipboard = {
	  cut: function cut(editorState) {
	    var content = editorState.getCurrentContent();
	    var selection = editorState.getSelection();
	    var targetRange = null;
	
	    if (selection.isCollapsed()) {
	      var anchorKey = selection.getAnchorKey();
	      var blockEnd = content.getBlockForKey(anchorKey).getLength();
	
	      if (blockEnd === selection.getAnchorOffset()) {
	        var keyAfter = content.getKeyAfter(anchorKey);
	
	        if (keyAfter == null) {
	          return editorState;
	        }
	
	        targetRange = selection.set('focusKey', keyAfter).set('focusOffset', 0);
	      } else {
	        targetRange = selection.set('focusOffset', blockEnd);
	      }
	    } else {
	      targetRange = selection;
	    }
	
	    targetRange = nullthrows(targetRange); // TODO: This should actually append to the current state when doing
	    // successive ^K commands without any other cursor movement
	
	    clipboard = getContentStateFragment(content, targetRange);
	    var afterRemoval = DraftModifier.removeRange(content, targetRange, 'forward');
	
	    if (afterRemoval === content) {
	      return editorState;
	    }
	
	    return EditorState.push(editorState, afterRemoval, 'remove-range');
	  },
	  paste: function paste(editorState) {
	    if (!clipboard) {
	      return editorState;
	    }
	
	    var newContent = DraftModifier.replaceWithFragment(editorState.getCurrentContent(), editorState.getSelection(), clipboard);
	    return EditorState.push(editorState, newContent, 'insert-fragment');
	  }
	};
	module.exports = SecondaryClipboard;

/***/ },
/* 1206 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	function adjustBlockDepthForContentState(contentState, selectionState, adjustment, maxDepth) {
	  var startKey = selectionState.getStartKey();
	  var endKey = selectionState.getEndKey();
	  var blockMap = contentState.getBlockMap();
	  var blocks = blockMap.toSeq().skipUntil(function (_, k) {
	    return k === startKey;
	  }).takeUntil(function (_, k) {
	    return k === endKey;
	  }).concat([[endKey, blockMap.get(endKey)]]).map(function (block) {
	    var depth = block.getDepth() + adjustment;
	    depth = Math.max(0, Math.min(depth, maxDepth));
	    return block.set('depth', depth);
	  });
	  blockMap = blockMap.merge(blocks);
	  return contentState.merge({
	    blockMap: blockMap,
	    selectionBefore: selectionState,
	    selectionAfter: selectionState
	  });
	}
	
	module.exports = adjustBlockDepthForContentState;

/***/ },
/* 1207 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	var CharacterMetadata = __webpack_require__(70);
	
	function applyEntityToContentBlock(contentBlock, startArg, end, entityKey) {
	  var start = startArg;
	  var characterList = contentBlock.getCharacterList();
	
	  while (start < end) {
	    characterList = characterList.set(start, CharacterMetadata.applyEntity(characterList.get(start), entityKey));
	    start++;
	  }
	
	  return contentBlock.set('characterList', characterList);
	}
	
	module.exports = applyEntityToContentBlock;

/***/ },
/* 1208 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	var applyEntityToContentBlock = __webpack_require__(1207);
	
	var Immutable = __webpack_require__(27);
	
	function applyEntityToContentState(contentState, selectionState, entityKey) {
	  var blockMap = contentState.getBlockMap();
	  var startKey = selectionState.getStartKey();
	  var startOffset = selectionState.getStartOffset();
	  var endKey = selectionState.getEndKey();
	  var endOffset = selectionState.getEndOffset();
	  var newBlocks = blockMap.skipUntil(function (_, k) {
	    return k === startKey;
	  }).takeUntil(function (_, k) {
	    return k === endKey;
	  }).toOrderedMap().merge(Immutable.OrderedMap([[endKey, blockMap.get(endKey)]])).map(function (block, blockKey) {
	    var sliceStart = blockKey === startKey ? startOffset : 0;
	    var sliceEnd = blockKey === endKey ? endOffset : block.getLength();
	    return applyEntityToContentBlock(block, sliceStart, sliceEnd, entityKey);
	  });
	  return contentState.merge({
	    blockMap: blockMap.merge(newBlocks),
	    selectionBefore: selectionState,
	    selectionAfter: selectionState
	  });
	}
	
	module.exports = applyEntityToContentState;

/***/ },
/* 1209 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var ContentBlock = __webpack_require__(104);
	
	var ContentBlockNode = __webpack_require__(71);
	
	var DraftStringKey = __webpack_require__(398);
	
	var encodeEntityRanges = __webpack_require__(1225);
	
	var encodeInlineStyleRanges = __webpack_require__(1226);
	
	var invariant = __webpack_require__(32);
	
	var createRawBlock = function createRawBlock(block, entityStorageMap) {
	  return {
	    key: block.getKey(),
	    text: block.getText(),
	    type: block.getType(),
	    depth: block.getDepth(),
	    inlineStyleRanges: encodeInlineStyleRanges(block),
	    entityRanges: encodeEntityRanges(block, entityStorageMap),
	    data: block.getData().toObject()
	  };
	};
	
	var insertRawBlock = function insertRawBlock(block, entityMap, rawBlocks, blockCacheRef) {
	  if (block instanceof ContentBlock) {
	    rawBlocks.push(createRawBlock(block, entityMap));
	    return;
	  }
	
	  !(block instanceof ContentBlockNode) ?  false ? invariant(false, 'block is not a BlockNode') : invariant(false) : void 0;
	  var parentKey = block.getParentKey();
	
	  var rawBlock = blockCacheRef[block.getKey()] = _objectSpread({}, createRawBlock(block, entityMap), {
	    children: []
	  });
	
	  if (parentKey) {
	    blockCacheRef[parentKey].children.push(rawBlock);
	    return;
	  }
	
	  rawBlocks.push(rawBlock);
	};
	
	var encodeRawBlocks = function encodeRawBlocks(contentState, rawState) {
	  var entityMap = rawState.entityMap;
	  var rawBlocks = [];
	  var blockCacheRef = {};
	  var entityCacheRef = {};
	  var entityStorageKey = 0;
	  contentState.getBlockMap().forEach(function (block) {
	    block.findEntityRanges(function (character) {
	      return character.getEntity() !== null;
	    }, function (start) {
	      var entityKey = block.getEntityAt(start); // Stringify to maintain order of otherwise numeric keys.
	
	      var stringifiedEntityKey = DraftStringKey.stringify(entityKey); // This makes this function resilient to two entities
	      // erroneously having the same key
	
	      if (entityCacheRef[stringifiedEntityKey]) {
	        return;
	      }
	
	      entityCacheRef[stringifiedEntityKey] = entityKey; // we need the `any` casting here since this is a temporary state
	      // where we will later on flip the entity map and populate it with
	      // real entity, at this stage we just need to map back the entity
	      // key used by the BlockNode
	
	      entityMap[stringifiedEntityKey] = "".concat(entityStorageKey);
	      entityStorageKey++;
	    });
	    insertRawBlock(block, entityMap, rawBlocks, blockCacheRef);
	  });
	  return {
	    blocks: rawBlocks,
	    entityMap: entityMap
	  };
	}; // Flip storage map so that our storage keys map to global
	// DraftEntity keys.
	
	
	var encodeRawEntityMap = function encodeRawEntityMap(contentState, rawState) {
	  var blocks = rawState.blocks,
	      entityMap = rawState.entityMap;
	  var rawEntityMap = {};
	  Object.keys(entityMap).forEach(function (key, index) {
	    var entity = contentState.getEntity(DraftStringKey.unstringify(key));
	    rawEntityMap[index] = {
	      type: entity.getType(),
	      mutability: entity.getMutability(),
	      data: entity.getData()
	    };
	  });
	  return {
	    blocks: blocks,
	    entityMap: rawEntityMap
	  };
	};
	
	var convertFromDraftStateToRaw = function convertFromDraftStateToRaw(contentState) {
	  var rawDraftContentState = {
	    entityMap: {},
	    blocks: []
	  }; // add blocks
	
	  rawDraftContentState = encodeRawBlocks(contentState, rawDraftContentState); // add entities
	
	  rawDraftContentState = encodeRawEntityMap(contentState, rawDraftContentState);
	  return rawDraftContentState;
	};
	
	module.exports = convertFromDraftStateToRaw;

/***/ },
/* 1210 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var ContentBlock = __webpack_require__(104);
	
	var ContentBlockNode = __webpack_require__(71);
	
	var ContentState = __webpack_require__(262);
	
	var DraftEntity = __webpack_require__(190);
	
	var DraftTreeAdapter = __webpack_require__(1201);
	
	var DraftTreeInvariants = __webpack_require__(1202);
	
	var SelectionState = __webpack_require__(191);
	
	var createCharacterList = __webpack_require__(1211);
	
	var decodeEntityRanges = __webpack_require__(1212);
	
	var decodeInlineStyleRanges = __webpack_require__(1213);
	
	var generateRandomKey = __webpack_require__(85);
	
	var gkx = __webpack_require__(97);
	
	var Immutable = __webpack_require__(27);
	
	var invariant = __webpack_require__(32);
	
	var experimentalTreeDataSupport = gkx('draft_tree_data_support');
	var List = Immutable.List,
	    Map = Immutable.Map,
	    OrderedMap = Immutable.OrderedMap;
	
	var decodeBlockNodeConfig = function decodeBlockNodeConfig(block, entityMap) {
	  var key = block.key,
	      type = block.type,
	      data = block.data,
	      text = block.text,
	      depth = block.depth;
	  var blockNodeConfig = {
	    text: text,
	    depth: depth || 0,
	    type: type || 'unstyled',
	    key: key || generateRandomKey(),
	    data: Map(data),
	    characterList: decodeCharacterList(block, entityMap)
	  };
	  return blockNodeConfig;
	};
	
	var decodeCharacterList = function decodeCharacterList(block, entityMap) {
	  var text = block.text,
	      rawEntityRanges = block.entityRanges,
	      rawInlineStyleRanges = block.inlineStyleRanges;
	  var entityRanges = rawEntityRanges || [];
	  var inlineStyleRanges = rawInlineStyleRanges || []; // Translate entity range keys to the DraftEntity map.
	
	  return createCharacterList(decodeInlineStyleRanges(text, inlineStyleRanges), decodeEntityRanges(text, entityRanges.filter(function (range) {
	    return entityMap.hasOwnProperty(range.key);
	  }).map(function (range) {
	    return _objectSpread({}, range, {
	      key: entityMap[range.key]
	    });
	  })));
	};
	
	var addKeyIfMissing = function addKeyIfMissing(block) {
	  return _objectSpread({}, block, {
	    key: block.key || generateRandomKey()
	  });
	};
	/**
	 * Node stack is responsible to ensure we traverse the tree only once
	 * in depth order, while also providing parent refs to inner nodes to
	 * construct their links.
	 */
	
	
	var updateNodeStack = function updateNodeStack(stack, nodes, parentRef) {
	  var nodesWithParentRef = nodes.map(function (block) {
	    return _objectSpread({}, block, {
	      parentRef: parentRef
	    });
	  }); // since we pop nodes from the stack we need to insert them in reverse
	
	  return stack.concat(nodesWithParentRef.reverse());
	};
	/**
	 * This will build a tree draft content state by creating the node
	 * reference links into a single tree walk. Each node has a link
	 * reference to "parent", "children", "nextSibling" and "prevSibling"
	 * blockMap will be created using depth ordering.
	 */
	
	
	var decodeContentBlockNodes = function decodeContentBlockNodes(blocks, entityMap) {
	  return blocks // ensure children have valid keys to enable sibling links
	  .map(addKeyIfMissing).reduce(function (blockMap, block, index) {
	    !Array.isArray(block.children) ?  false ? invariant(false, 'invalid RawDraftContentBlock can not be converted to ContentBlockNode') : invariant(false) : void 0; // ensure children have valid keys to enable sibling links
	
	    var children = block.children.map(addKeyIfMissing); // root level nodes
	
	    var contentBlockNode = new ContentBlockNode(_objectSpread({}, decodeBlockNodeConfig(block, entityMap), {
	      prevSibling: index === 0 ? null : blocks[index - 1].key,
	      nextSibling: index === blocks.length - 1 ? null : blocks[index + 1].key,
	      children: List(children.map(function (child) {
	        return child.key;
	      }))
	    })); // push root node to blockMap
	
	    blockMap = blockMap.set(contentBlockNode.getKey(), contentBlockNode); // this stack is used to ensure we visit all nodes respecting depth ordering
	
	    var stack = updateNodeStack([], children, contentBlockNode); // start computing children nodes
	
	    while (stack.length > 0) {
	      // we pop from the stack and start processing this node
	      var node = stack.pop(); // parentRef already points to a converted ContentBlockNode
	
	      var parentRef = node.parentRef;
	      var siblings = parentRef.getChildKeys();
	
	      var _index = siblings.indexOf(node.key);
	
	      var isValidBlock = Array.isArray(node.children);
	
	      if (!isValidBlock) {
	        !isValidBlock ?  false ? invariant(false, 'invalid RawDraftContentBlock can not be converted to ContentBlockNode') : invariant(false) : void 0;
	        break;
	      } // ensure children have valid keys to enable sibling links
	
	
	      var _children = node.children.map(addKeyIfMissing);
	
	      var _contentBlockNode = new ContentBlockNode(_objectSpread({}, decodeBlockNodeConfig(node, entityMap), {
	        parent: parentRef.getKey(),
	        children: List(_children.map(function (child) {
	          return child.key;
	        })),
	        prevSibling: _index === 0 ? null : siblings.get(_index - 1),
	        nextSibling: _index === siblings.size - 1 ? null : siblings.get(_index + 1)
	      })); // push node to blockMap
	
	
	      blockMap = blockMap.set(_contentBlockNode.getKey(), _contentBlockNode); // this stack is used to ensure we visit all nodes respecting depth ordering
	
	      stack = updateNodeStack(stack, _children, _contentBlockNode);
	    }
	
	    return blockMap;
	  }, OrderedMap());
	};
	
	var decodeContentBlocks = function decodeContentBlocks(blocks, entityMap) {
	  return OrderedMap(blocks.map(function (block) {
	    var contentBlock = new ContentBlock(decodeBlockNodeConfig(block, entityMap));
	    return [contentBlock.getKey(), contentBlock];
	  }));
	};
	
	var decodeRawBlocks = function decodeRawBlocks(rawState, entityMap) {
	  var isTreeRawBlock = rawState.blocks.find(function (block) {
	    return Array.isArray(block.children) && block.children.length > 0;
	  });
	  var rawBlocks = experimentalTreeDataSupport && !isTreeRawBlock ? DraftTreeAdapter.fromRawStateToRawTreeState(rawState).blocks : rawState.blocks;
	
	  if (!experimentalTreeDataSupport) {
	    return decodeContentBlocks(isTreeRawBlock ? DraftTreeAdapter.fromRawTreeStateToRawState(rawState).blocks : rawBlocks, entityMap);
	  }
	
	  var blockMap = decodeContentBlockNodes(rawBlocks, entityMap); // in dev mode, check that the tree invariants are met
	
	  if (false) {
	    !DraftTreeInvariants.isValidTree(blockMap) ? process.env.NODE_ENV !== "production" ? invariant(false, 'Should be a valid tree') : invariant(false) : void 0;
	  }
	
	  return blockMap;
	};
	
	var decodeRawEntityMap = function decodeRawEntityMap(rawState) {
	  var rawEntityMap = rawState.entityMap;
	  var entityMap = {}; // TODO: Update this once we completely remove DraftEntity
	
	  Object.keys(rawEntityMap).forEach(function (rawEntityKey) {
	    var _rawEntityMap$rawEnti = rawEntityMap[rawEntityKey],
	        type = _rawEntityMap$rawEnti.type,
	        mutability = _rawEntityMap$rawEnti.mutability,
	        data = _rawEntityMap$rawEnti.data; // get the key reference to created entity
	
	    entityMap[rawEntityKey] = DraftEntity.__create(type, mutability, data || {});
	  });
	  return entityMap;
	};
	
	var convertFromRawToDraftState = function convertFromRawToDraftState(rawState) {
	  !Array.isArray(rawState.blocks) ?  false ? invariant(false, 'invalid RawDraftContentState') : invariant(false) : void 0; // decode entities
	
	  var entityMap = decodeRawEntityMap(rawState); // decode blockMap
	
	  var blockMap = decodeRawBlocks(rawState, entityMap); // create initial selection
	
	  var selectionState = blockMap.isEmpty() ? new SelectionState() : SelectionState.createEmpty(blockMap.first().getKey());
	  return new ContentState({
	    blockMap: blockMap,
	    entityMap: entityMap,
	    selectionBefore: selectionState,
	    selectionAfter: selectionState
	  });
	};
	
	module.exports = convertFromRawToDraftState;

/***/ },
/* 1211 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	var CharacterMetadata = __webpack_require__(70);
	
	var Immutable = __webpack_require__(27);
	
	var List = Immutable.List;
	
	function createCharacterList(inlineStyles, entities) {
	  var characterArray = inlineStyles.map(function (style, ii) {
	    var entity = entities[ii];
	    return CharacterMetadata.create({
	      style: style,
	      entity: entity
	    });
	  });
	  return List(characterArray);
	}
	
	module.exports = createCharacterList;

/***/ },
/* 1212 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	var UnicodeUtils = __webpack_require__(107);
	
	var substr = UnicodeUtils.substr;
	/**
	 * Convert to native JavaScript string lengths to determine ranges.
	 */
	
	function decodeEntityRanges(text, ranges) {
	  var entities = Array(text.length).fill(null);
	
	  if (ranges) {
	    ranges.forEach(function (range) {
	      // Using Unicode-enabled substrings converted to JavaScript lengths,
	      // fill the output array with entity keys.
	      var start = substr(text, 0, range.offset).length;
	      var end = start + substr(text, range.offset, range.length).length;
	
	      for (var ii = start; ii < end; ii++) {
	        entities[ii] = range.key;
	      }
	    });
	  }
	
	  return entities;
	}
	
	module.exports = decodeEntityRanges;

/***/ },
/* 1213 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	var UnicodeUtils = __webpack_require__(107);
	
	var _require = __webpack_require__(27),
	    OrderedSet = _require.OrderedSet;
	
	var substr = UnicodeUtils.substr;
	var EMPTY_SET = OrderedSet();
	/**
	 * Convert to native JavaScript string lengths to determine ranges.
	 */
	
	function decodeInlineStyleRanges(text, ranges) {
	  var styles = Array(text.length).fill(EMPTY_SET);
	
	  if (ranges) {
	    ranges.forEach(function (range) {
	      var cursor = substr(text, 0, range.offset).length;
	      var end = cursor + substr(text, range.offset, range.length).length;
	
	      while (cursor < end) {
	        styles[cursor] = styles[cursor].add(range.style);
	        cursor++;
	      }
	    });
	  }
	
	  return styles;
	}
	
	module.exports = decodeInlineStyleRanges;

/***/ },
/* 1214 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	var DraftModifier = __webpack_require__(59);
	
	var EditorState = __webpack_require__(36);
	
	var UserAgent = __webpack_require__(60);
	
	var getEntityKeyForSelection = __webpack_require__(265);
	
	var isEventHandled = __webpack_require__(195);
	
	var isSelectionAtLeafStart = __webpack_require__(1237);
	
	var nullthrows = __webpack_require__(61);
	
	var setImmediate = __webpack_require__(1290); // When nothing is focused, Firefox regards two characters, `'` and `/`, as
	// commands that should open and focus the "quickfind" search bar. This should
	// *never* happen while a contenteditable is focused, but as of v28, it
	// sometimes does, even when the keypress event target is the contenteditable.
	// This breaks the input. Special case these characters to ensure that when
	// they are typed, we prevent default on the event to make sure not to
	// trigger quickfind.
	
	
	var FF_QUICKFIND_CHAR = "'";
	var FF_QUICKFIND_LINK_CHAR = '/';
	var isFirefox = UserAgent.isBrowser('Firefox');
	
	function mustPreventDefaultForCharacter(character) {
	  return isFirefox && (character == FF_QUICKFIND_CHAR || character == FF_QUICKFIND_LINK_CHAR);
	}
	/**
	 * Replace the current selection with the specified text string, with the
	 * inline style and entity key applied to the newly inserted text.
	 */
	
	
	function replaceText(editorState, text, inlineStyle, entityKey, forceSelection) {
	  var contentState = DraftModifier.replaceText(editorState.getCurrentContent(), editorState.getSelection(), text, inlineStyle, entityKey);
	  return EditorState.push(editorState, contentState, 'insert-characters', forceSelection);
	}
	/**
	 * When `onBeforeInput` executes, the browser is attempting to insert a
	 * character into the editor. Apply this character data to the document,
	 * allowing native insertion if possible.
	 *
	 * Native insertion is encouraged in order to limit re-rendering and to
	 * preserve spellcheck highlighting, which disappears or flashes if re-render
	 * occurs on the relevant text nodes.
	 */
	
	
	function editOnBeforeInput(editor, e) {
	  if (editor._pendingStateFromBeforeInput !== undefined) {
	    editor.update(editor._pendingStateFromBeforeInput);
	    editor._pendingStateFromBeforeInput = undefined;
	  }
	
	  var editorState = editor._latestEditorState;
	  var chars = e.data; // In some cases (ex: IE ideographic space insertion) no character data
	  // is provided. There's nothing to do when this happens.
	
	  if (!chars) {
	    return;
	  } // Allow the top-level component to handle the insertion manually. This is
	  // useful when triggering interesting behaviors for a character insertion,
	  // Simple examples: replacing a raw text ':)' with a smile emoji or image
	  // decorator, or setting a block to be a list item after typing '- ' at the
	  // start of the block.
	
	
	  if (editor.props.handleBeforeInput && isEventHandled(editor.props.handleBeforeInput(chars, editorState, e.timeStamp))) {
	    e.preventDefault();
	    return;
	  } // If selection is collapsed, conditionally allow native behavior. This
	  // reduces re-renders and preserves spellcheck highlighting. If the selection
	  // is not collapsed, we will re-render.
	
	
	  var selection = editorState.getSelection();
	  var selectionStart = selection.getStartOffset();
	  var anchorKey = selection.getAnchorKey();
	
	  if (!selection.isCollapsed()) {
	    e.preventDefault();
	    editor.update(replaceText(editorState, chars, editorState.getCurrentInlineStyle(), getEntityKeyForSelection(editorState.getCurrentContent(), editorState.getSelection()), true));
	    return;
	  }
	
	  var newEditorState = replaceText(editorState, chars, editorState.getCurrentInlineStyle(), getEntityKeyForSelection(editorState.getCurrentContent(), editorState.getSelection()), false); // Bunch of different cases follow where we need to prevent native insertion.
	
	  var mustPreventNative = false;
	
	  if (!mustPreventNative) {
	    // Browsers tend to insert text in weird places in the DOM when typing at
	    // the start of a leaf, so we'll handle it ourselves.
	    mustPreventNative = isSelectionAtLeafStart(editor._latestCommittedEditorState);
	  }
	
	  if (!mustPreventNative) {
	    // Let's say we have a decorator that highlights hashtags. In many cases
	    // we need to prevent native behavior and rerender ourselves --
	    // particularly, any case *except* where the inserted characters end up
	    // anywhere except exactly where you put them.
	    //
	    // Using [] to denote a decorated leaf, some examples:
	    //
	    // 1. 'hi #' and append 'f'
	    // desired rendering: 'hi [#f]'
	    // native rendering would be: 'hi #f' (incorrect)
	    //
	    // 2. 'x [#foo]' and insert '#' before 'f'
	    // desired rendering: 'x #[#foo]'
	    // native rendering would be: 'x [##foo]' (incorrect)
	    //
	    // 3. '[#foobar]' and insert ' ' between 'foo' and 'bar'
	    // desired rendering: '[#foo] bar'
	    // native rendering would be: '[#foo bar]' (incorrect)
	    //
	    // 4. '[#foo]' and delete '#' [won't use this beforeinput codepath though]
	    // desired rendering: 'foo'
	    // native rendering would be: '[foo]' (incorrect)
	    //
	    // 5. '[#foo]' and append 'b'
	    // desired rendering: '[#foob]'
	    // native rendering would be: '[#foob]'
	    // (native insertion here would be ok for decorators like simple spans,
	    // but not more complex decorators. To be safe, we need to prevent it.)
	    //
	    // It is safe to allow native insertion if and only if the full list of
	    // decorator ranges matches what we expect native insertion to give, and
	    // the range lengths have not changed. We don't need to compare the content
	    // because the only possible mutation to consider here is inserting plain
	    // text and decorators can't affect text content.
	    var oldBlockTree = editorState.getBlockTree(anchorKey);
	    var newBlockTree = newEditorState.getBlockTree(anchorKey);
	    mustPreventNative = oldBlockTree.size !== newBlockTree.size || oldBlockTree.zip(newBlockTree).some(function (_ref) {
	      var oldLeafSet = _ref[0],
	          newLeafSet = _ref[1];
	      // selectionStart is guaranteed to be selectionEnd here
	      var oldStart = oldLeafSet.get('start');
	      var adjustedStart = oldStart + (oldStart >= selectionStart ? chars.length : 0);
	      var oldEnd = oldLeafSet.get('end');
	      var adjustedEnd = oldEnd + (oldEnd >= selectionStart ? chars.length : 0);
	      var newStart = newLeafSet.get('start');
	      var newEnd = newLeafSet.get('end');
	      var newDecoratorKey = newLeafSet.get('decoratorKey');
	      return (// Different decorators
	        oldLeafSet.get('decoratorKey') !== newDecoratorKey || // Different number of inline styles
	        oldLeafSet.get('leaves').size !== newLeafSet.get('leaves').size || // Different effective decorator position
	        adjustedStart !== newStart || adjustedEnd !== newEnd || // Decorator already existed and its length changed
	        newDecoratorKey != null && newEnd - newStart !== oldEnd - oldStart
	      );
	    });
	  }
	
	  if (!mustPreventNative) {
	    mustPreventNative = mustPreventDefaultForCharacter(chars);
	  }
	
	  if (!mustPreventNative) {
	    mustPreventNative = nullthrows(newEditorState.getDirectionMap()).get(anchorKey) !== nullthrows(editorState.getDirectionMap()).get(anchorKey);
	  }
	
	  if (mustPreventNative) {
	    e.preventDefault();
	    newEditorState = EditorState.set(newEditorState, {
	      forceSelection: true
	    });
	    editor.update(newEditorState);
	    return;
	  } // We made it all the way! Let the browser do its thing and insert the char.
	
	
	  newEditorState = EditorState.set(newEditorState, {
	    nativelyRenderedContent: newEditorState.getCurrentContent()
	  }); // The native event is allowed to occur. To allow user onChange handlers to
	  // change the inserted text, we wait until the text is actually inserted
	  // before we actually update our state. That way when we rerender, the text
	  // we see in the DOM will already have been inserted properly.
	
	  editor._pendingStateFromBeforeInput = newEditorState;
	  setImmediate(function () {
	    if (editor._pendingStateFromBeforeInput !== undefined) {
	      editor.update(editor._pendingStateFromBeforeInput);
	      editor._pendingStateFromBeforeInput = undefined;
	    }
	  });
	}
	
	module.exports = editOnBeforeInput;

/***/ },
/* 1215 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	var EditorState = __webpack_require__(36);
	
	var containsNode = __webpack_require__(270);
	
	var getActiveElement = __webpack_require__(430);
	
	function editOnBlur(editor, e) {
	  // In a contentEditable element, when you select a range and then click
	  // another active element, this does trigger a `blur` event but will not
	  // remove the DOM selection from the contenteditable.
	  // This is consistent across all browsers, but we prefer that the editor
	  // behave like a textarea, where a `blur` event clears the DOM selection.
	  // We therefore force the issue to be certain, checking whether the active
	  // element is `body` to force it when blurring occurs within the window (as
	  // opposed to clicking to another tab or window).
	  var ownerDocument = e.currentTarget.ownerDocument;
	
	  if ( // This ESLint rule conflicts with `sketchy-null-bool` flow check
	  // eslint-disable-next-line no-extra-boolean-cast
	  !Boolean(editor.props.preserveSelectionOnBlur) && getActiveElement(ownerDocument) === ownerDocument.body) {
	    var _selection = ownerDocument.defaultView.getSelection();
	
	    var editorNode = editor.editor;
	
	    if (_selection.rangeCount === 1 && containsNode(editorNode, _selection.anchorNode) && containsNode(editorNode, _selection.focusNode)) {
	      _selection.removeAllRanges();
	    }
	  }
	
	  var editorState = editor._latestEditorState;
	  var currentSelection = editorState.getSelection();
	
	  if (!currentSelection.getHasFocus()) {
	    return;
	  }
	
	  var selection = currentSelection.set('hasFocus', false);
	  editor.props.onBlur && editor.props.onBlur(e);
	  editor.update(EditorState.acceptSelection(editorState, selection));
	}
	
	module.exports = editOnBlur;

/***/ },
/* 1216 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	var EditorState = __webpack_require__(36);
	/**
	 * The user has begun using an IME input system. Switching to `composite` mode
	 * allows handling composition input and disables other edit behavior.
	 */
	
	
	function editOnCompositionStart(editor, e) {
	  editor.setMode('composite');
	  editor.update(EditorState.set(editor._latestEditorState, {
	    inCompositionMode: true
	  })); // Allow composition handler to interpret the compositionstart event
	
	  editor._onCompositionStart(e);
	}
	
	module.exports = editOnCompositionStart;

/***/ },
/* 1217 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	var getFragmentFromSelection = __webpack_require__(407);
	/**
	 * If we have a selection, create a ContentState fragment and store
	 * it in our internal clipboard. Subsequent paste events will use this
	 * fragment if no external clipboard data is supplied.
	 */
	
	
	function editOnCopy(editor, e) {
	  var editorState = editor._latestEditorState;
	  var selection = editorState.getSelection(); // No selection, so there's nothing to copy.
	
	  if (selection.isCollapsed()) {
	    e.preventDefault();
	    return;
	  }
	
	  editor.setClipboard(getFragmentFromSelection(editor._latestEditorState));
	}
	
	module.exports = editOnCopy;

/***/ },
/* 1218 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	var DraftModifier = __webpack_require__(59);
	
	var EditorState = __webpack_require__(36);
	
	var Style = __webpack_require__(198);
	
	var getFragmentFromSelection = __webpack_require__(407);
	
	var getScrollPosition = __webpack_require__(200);
	
	var isNode = __webpack_require__(1236);
	/**
	 * On `cut` events, native behavior is allowed to occur so that the system
	 * clipboard is set properly. This means that we need to take steps to recover
	 * the editor DOM state after the `cut` has occurred in order to maintain
	 * control of the component.
	 *
	 * In addition, we can keep a copy of the removed fragment, including all
	 * styles and entities, for use as an internal paste.
	 */
	
	
	function editOnCut(editor, e) {
	  var editorState = editor._latestEditorState;
	  var selection = editorState.getSelection();
	  var element = e.target;
	  var scrollPosition; // No selection, so there's nothing to cut.
	
	  if (selection.isCollapsed()) {
	    e.preventDefault();
	    return;
	  } // Track the current scroll position so that it can be forced back in place
	  // after the editor regains control of the DOM.
	
	
	  if (isNode(element)) {
	    var node = element;
	    scrollPosition = getScrollPosition(Style.getScrollParent(node));
	  }
	
	  var fragment = getFragmentFromSelection(editorState);
	  editor.setClipboard(fragment); // Set `cut` mode to disable all event handling temporarily.
	
	  editor.setMode('cut'); // Let native `cut` behavior occur, then recover control.
	
	  setTimeout(function () {
	    editor.restoreEditorDOM(scrollPosition);
	    editor.exitCurrentMode();
	    editor.update(removeFragment(editorState));
	  }, 0);
	}
	
	function removeFragment(editorState) {
	  var newContent = DraftModifier.removeRange(editorState.getCurrentContent(), editorState.getSelection(), 'forward');
	  return EditorState.push(editorState, newContent, 'remove-range');
	}
	
	module.exports = editOnCut;

/***/ },
/* 1219 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	/**
	 * Drag behavior has begun from outside the editor element.
	 */
	function editOnDragOver(editor, e) {
	  editor.setMode('drag');
	  e.preventDefault();
	}
	
	module.exports = editOnDragOver;

/***/ },
/* 1220 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	/**
	 * A `dragstart` event has begun within the text editor component.
	 */
	function editOnDragStart(editor) {
	  editor._internalDrag = true;
	  editor.setMode('drag');
	}
	
	module.exports = editOnDragStart;

/***/ },
/* 1221 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	var EditorState = __webpack_require__(36);
	
	var UserAgent = __webpack_require__(60);
	
	function editOnFocus(editor, e) {
	  var editorState = editor._latestEditorState;
	  var currentSelection = editorState.getSelection();
	
	  if (currentSelection.getHasFocus()) {
	    return;
	  }
	
	  var selection = currentSelection.set('hasFocus', true);
	  editor.props.onFocus && editor.props.onFocus(e); // When the tab containing this text editor is hidden and the user does a
	  // find-in-page in a _different_ tab, Chrome on Mac likes to forget what the
	  // selection was right after sending this focus event and (if you let it)
	  // moves the cursor back to the beginning of the editor, so we force the
	  // selection here instead of simply accepting it in order to preserve the
	  // old cursor position. See https://crbug.com/540004.
	  // But it looks like this is fixed in Chrome 60.0.3081.0.
	  // Other browsers also don't have this bug, so we prefer to acceptSelection
	  // when possible, to ensure that unfocusing and refocusing a Draft editor
	  // doesn't preserve the selection, matching how textareas work.
	
	  if (UserAgent.isBrowser('Chrome < 60.0.3081.0')) {
	    editor.update(EditorState.forceSelection(editorState, selection));
	  } else {
	    editor.update(EditorState.acceptSelection(editorState, selection));
	  }
	}
	
	module.exports = editOnFocus;

/***/ },
/* 1222 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	var DraftModifier = __webpack_require__(59);
	
	var DraftOffsetKey = __webpack_require__(91);
	
	var EditorState = __webpack_require__(36);
	
	var UserAgent = __webpack_require__(60);
	
	var _require = __webpack_require__(401),
	    notEmptyKey = _require.notEmptyKey;
	
	var findAncestorOffsetKey = __webpack_require__(192);
	
	var keyCommandPlainBackspace = __webpack_require__(418);
	
	var nullthrows = __webpack_require__(61);
	
	var isGecko = UserAgent.isEngine('Gecko');
	var DOUBLE_NEWLINE = '\n\n';
	
	function onInputType(inputType, editorState) {
	  switch (inputType) {
	    case 'deleteContentBackward':
	      return keyCommandPlainBackspace(editorState);
	  }
	
	  return editorState;
	}
	/**
	 * This function serves two purposes
	 *
	 * 1. To update the editorState and call onChange method with the new
	 * editorState. This editorState is calculated in editOnBeforeInput but the
	 * onChange method is not called with the new state until this method does it.
	 * It is done to handle a specific case where certain character inputs might
	 * be replaced with something else. E.g. snippets ('rc' might be replaced
	 * with boilerplate code for react component). More information on the
	 * exact problem can be found here -
	 * https://github.com/facebook/draft-js/commit/07892ba479bd4dfc6afd1e0ed179aaf51cd138b1
	 *
	 * 2. intended to handle spellcheck and autocorrect changes,
	 * which occur in the DOM natively without any opportunity to observe or
	 * interpret the changes before they occur.
	 *
	 * The `input` event fires in contentEditable elements reliably for non-IE
	 * browsers, immediately after changes occur to the editor DOM. Since our other
	 * handlers override or otherwise handle cover other varieties of text input,
	 * the DOM state should match the model in all controlled input cases. Thus,
	 * when an `input` change leads to a DOM/model mismatch, the change should be
	 * due to a spellcheck change, and we can incorporate it into our model.
	 */
	
	
	function editOnInput(editor, e) {
	  if (editor._pendingStateFromBeforeInput !== undefined) {
	    editor.update(editor._pendingStateFromBeforeInput);
	    editor._pendingStateFromBeforeInput = undefined;
	  } // at this point editor is not null for sure (after input)
	
	
	  var castedEditorElement = editor.editor;
	  var domSelection = castedEditorElement.ownerDocument.defaultView.getSelection();
	  var anchorNode = domSelection.anchorNode,
	      isCollapsed = domSelection.isCollapsed;
	  var isNotTextOrElementNode = (anchorNode === null || anchorNode === void 0 ? void 0 : anchorNode.nodeType) !== Node.TEXT_NODE && (anchorNode === null || anchorNode === void 0 ? void 0 : anchorNode.nodeType) !== Node.ELEMENT_NODE;
	
	  if (anchorNode == null || isNotTextOrElementNode) {
	    // TODO: (t16149272) figure out context for this change
	    return;
	  }
	
	  if (anchorNode.nodeType === Node.TEXT_NODE && (anchorNode.previousSibling !== null || anchorNode.nextSibling !== null)) {
	    // When typing at the beginning of a visual line, Chrome splits the text
	    // nodes into two. Why? No one knows. This commit is suspicious:
	    // https://chromium.googlesource.com/chromium/src/+/a3b600981286b135632371477f902214c55a1724
	    // To work around, we'll merge the sibling text nodes back into this one.
	    var span = anchorNode.parentNode;
	
	    if (span == null) {
	      // Handle null-parent case.
	      return;
	    }
	
	    anchorNode.nodeValue = span.textContent;
	
	    for (var child = span.firstChild; child != null; child = child.nextSibling) {
	      if (child !== anchorNode) {
	        span.removeChild(child);
	      }
	    }
	  }
	
	  var domText = anchorNode.textContent;
	  var editorState = editor._latestEditorState;
	  var offsetKey = nullthrows(findAncestorOffsetKey(anchorNode));
	
	  var _DraftOffsetKey$decod = DraftOffsetKey.decode(offsetKey),
	      blockKey = _DraftOffsetKey$decod.blockKey,
	      decoratorKey = _DraftOffsetKey$decod.decoratorKey,
	      leafKey = _DraftOffsetKey$decod.leafKey;
	
	  var _editorState$getBlock = editorState.getBlockTree(blockKey).getIn([decoratorKey, 'leaves', leafKey]),
	      start = _editorState$getBlock.start,
	      end = _editorState$getBlock.end;
	
	  var content = editorState.getCurrentContent();
	  var block = content.getBlockForKey(blockKey);
	  var modelText = block.getText().slice(start, end); // Special-case soft newlines here. If the DOM text ends in a soft newline,
	  // we will have manually inserted an extra soft newline in DraftEditorLeaf.
	  // We want to remove this extra newline for the purpose of our comparison
	  // of DOM and model text.
	
	  if (domText.endsWith(DOUBLE_NEWLINE)) {
	    domText = domText.slice(0, -1);
	  } // No change -- the DOM is up to date. Nothing to do here.
	
	
	  if (domText === modelText) {
	    // This can be buggy for some Android keyboards because they don't fire
	    // standard onkeydown/pressed events and only fired editOnInput
	    // so domText is already changed by the browser and ends up being equal
	    // to modelText unexpectedly.
	    // Newest versions of Android support the dom-inputevent-inputtype
	    // and we can use the `inputType` to properly apply the state changes.
	
	    /* $FlowFixMe[prop-missing] inputType is only defined on a draft of a
	     * standard. https://w3c.github.io/input-events/#dom-inputevent-inputtype
	     */
	    var inputType = e.nativeEvent.inputType;
	
	    if (inputType) {
	      var newEditorState = onInputType(inputType, editorState);
	
	      if (newEditorState !== editorState) {
	        editor.restoreEditorDOM();
	        editor.update(newEditorState);
	        return;
	      }
	    }
	
	    return;
	  }
	
	  var selection = editorState.getSelection(); // We'll replace the entire leaf with the text content of the target.
	
	  var targetRange = selection.merge({
	    anchorOffset: start,
	    focusOffset: end,
	    isBackward: false
	  });
	  var entityKey = block.getEntityAt(start);
	  var entity = notEmptyKey(entityKey) ? content.getEntity(entityKey) : null;
	  var entityType = entity != null ? entity.getMutability() : null;
	  var preserveEntity = entityType === 'MUTABLE'; // Immutable or segmented entities cannot properly be handled by the
	  // default browser undo, so we have to use a different change type to
	  // force using our internal undo method instead of falling through to the
	  // native browser undo.
	
	  var changeType = preserveEntity ? 'spellcheck-change' : 'apply-entity';
	  var newContent = DraftModifier.replaceText(content, targetRange, domText, block.getInlineStyleAt(start), preserveEntity ? block.getEntityAt(start) : null);
	  var anchorOffset, focusOffset, startOffset, endOffset;
	
	  if (isGecko) {
	    // Firefox selection does not change while the context menu is open, so
	    // we preserve the anchor and focus values of the DOM selection.
	    anchorOffset = domSelection.anchorOffset;
	    focusOffset = domSelection.focusOffset;
	    startOffset = start + Math.min(anchorOffset, focusOffset);
	    endOffset = startOffset + Math.abs(anchorOffset - focusOffset);
	    anchorOffset = startOffset;
	    focusOffset = endOffset;
	  } else {
	    // Browsers other than Firefox may adjust DOM selection while the context
	    // menu is open, and Safari autocorrect is prone to providing an inaccurate
	    // DOM selection. Don't trust it. Instead, use our existing SelectionState
	    // and adjust it based on the number of characters changed during the
	    // mutation.
	    var charDelta = domText.length - modelText.length;
	    startOffset = selection.getStartOffset();
	    endOffset = selection.getEndOffset();
	    anchorOffset = isCollapsed ? endOffset + charDelta : startOffset;
	    focusOffset = endOffset + charDelta;
	  } // Segmented entities are completely or partially removed when their
	  // text content changes. For this case we do not want any text to be selected
	  // after the change, so we are not merging the selection.
	
	
	  var contentWithAdjustedDOMSelection = newContent.merge({
	    selectionBefore: content.getSelectionAfter(),
	    selectionAfter: selection.merge({
	      anchorOffset: anchorOffset,
	      focusOffset: focusOffset
	    })
	  });
	  editor.update(EditorState.push(editorState, contentWithAdjustedDOMSelection, changeType));
	}
	
	module.exports = editOnInput;

/***/ },
/* 1223 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	var DraftModifier = __webpack_require__(59);
	
	var EditorState = __webpack_require__(36);
	
	var KeyBindingUtil = __webpack_require__(264);
	
	var Keys = __webpack_require__(197);
	
	var SecondaryClipboard = __webpack_require__(1205);
	
	var UserAgent = __webpack_require__(60);
	
	var isEventHandled = __webpack_require__(195);
	
	var keyCommandBackspaceToStartOfLine = __webpack_require__(1239);
	
	var keyCommandBackspaceWord = __webpack_require__(1240);
	
	var keyCommandDeleteWord = __webpack_require__(1241);
	
	var keyCommandInsertNewline = __webpack_require__(1242);
	
	var keyCommandMoveSelectionToEndOfBlock = __webpack_require__(1243);
	
	var keyCommandMoveSelectionToStartOfBlock = __webpack_require__(1244);
	
	var keyCommandPlainBackspace = __webpack_require__(418);
	
	var keyCommandPlainDelete = __webpack_require__(1245);
	
	var keyCommandTransposeCharacters = __webpack_require__(1246);
	
	var keyCommandUndo = __webpack_require__(1247);
	
	var isOptionKeyCommand = KeyBindingUtil.isOptionKeyCommand;
	var isChrome = UserAgent.isBrowser('Chrome');
	/**
	 * Map a `DraftEditorCommand` command value to a corresponding function.
	 */
	
	function onKeyCommand(command, editorState, e) {
	  switch (command) {
	    case 'redo':
	      return EditorState.redo(editorState);
	
	    case 'delete':
	      return keyCommandPlainDelete(editorState);
	
	    case 'delete-word':
	      return keyCommandDeleteWord(editorState);
	
	    case 'backspace':
	      return keyCommandPlainBackspace(editorState);
	
	    case 'backspace-word':
	      return keyCommandBackspaceWord(editorState);
	
	    case 'backspace-to-start-of-line':
	      return keyCommandBackspaceToStartOfLine(editorState, e);
	
	    case 'split-block':
	      return keyCommandInsertNewline(editorState);
	
	    case 'transpose-characters':
	      return keyCommandTransposeCharacters(editorState);
	
	    case 'move-selection-to-start-of-block':
	      return keyCommandMoveSelectionToStartOfBlock(editorState);
	
	    case 'move-selection-to-end-of-block':
	      return keyCommandMoveSelectionToEndOfBlock(editorState);
	
	    case 'secondary-cut':
	      return SecondaryClipboard.cut(editorState);
	
	    case 'secondary-paste':
	      return SecondaryClipboard.paste(editorState);
	
	    default:
	      return editorState;
	  }
	}
	/**
	 * Intercept keydown behavior to handle keys and commands manually, if desired.
	 *
	 * Keydown combinations may be mapped to `DraftCommand` values, which may
	 * correspond to command functions that modify the editor or its contents.
	 *
	 * See `getDefaultKeyBinding` for defaults. Alternatively, the top-level
	 * component may provide a custom mapping via the `keyBindingFn` prop.
	 */
	
	
	function editOnKeyDown(editor, e) {
	  var keyCode = e.which;
	  var editorState = editor._latestEditorState;
	
	  function callDeprecatedHandler(handlerName) {
	    var deprecatedHandler = editor.props[handlerName];
	
	    if (deprecatedHandler) {
	      deprecatedHandler(e);
	      return true;
	    } else {
	      return false;
	    }
	  }
	
	  switch (keyCode) {
	    case Keys.RETURN:
	      e.preventDefault(); // The top-level component may manually handle newline insertion. If
	      // no special handling is performed, fall through to command handling.
	
	      if (editor.props.handleReturn && isEventHandled(editor.props.handleReturn(e, editorState))) {
	        return;
	      }
	
	      break;
	
	    case Keys.ESC:
	      e.preventDefault();
	
	      if (callDeprecatedHandler('onEscape')) {
	        return;
	      }
	
	      break;
	
	    case Keys.TAB:
	      if (callDeprecatedHandler('onTab')) {
	        return;
	      }
	
	      break;
	
	    case Keys.UP:
	      if (callDeprecatedHandler('onUpArrow')) {
	        return;
	      }
	
	      break;
	
	    case Keys.RIGHT:
	      if (callDeprecatedHandler('onRightArrow')) {
	        return;
	      }
	
	      break;
	
	    case Keys.DOWN:
	      if (callDeprecatedHandler('onDownArrow')) {
	        return;
	      }
	
	      break;
	
	    case Keys.LEFT:
	      if (callDeprecatedHandler('onLeftArrow')) {
	        return;
	      }
	
	      break;
	
	    case Keys.SPACE:
	      // Prevent Chrome on OSX behavior where option + space scrolls.
	      if (isChrome && isOptionKeyCommand(e)) {
	        e.preventDefault();
	      }
	
	  }
	
	  var command = editor.props.keyBindingFn(e); // If no command is specified, allow keydown event to continue.
	
	  if (command == null || command === '') {
	    if (keyCode === Keys.SPACE && isChrome && isOptionKeyCommand(e)) {
	      // The default keydown event has already been prevented in order to stop
	      // Chrome from scrolling. Insert a nbsp into the editor as OSX would for
	      // other browsers.
	      var contentState = DraftModifier.replaceText(editorState.getCurrentContent(), editorState.getSelection(), "\xA0");
	      editor.update(EditorState.push(editorState, contentState, 'insert-characters'));
	    }
	
	    return;
	  }
	
	  if (command === 'undo') {
	    // Since undo requires some special updating behavior to keep the editor
	    // in sync, handle it separately.
	    keyCommandUndo(e, editorState, editor.update);
	    return;
	  } // At this point, we know that we're handling a command of some kind, so
	  // we don't want to insert a character following the keydown.
	
	
	  e.preventDefault(); // Allow components higher up the tree to handle the command first.
	
	  if (editor.props.handleKeyCommand && isEventHandled(editor.props.handleKeyCommand(command, editorState, e.timeStamp))) {
	    return;
	  }
	
	  var newState = onKeyCommand(command, editorState, e);
	
	  if (newState !== editorState) {
	    editor.update(newState);
	  }
	}
	
	module.exports = editOnKeyDown;

/***/ },
/* 1224 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	var BlockMapBuilder = __webpack_require__(151);
	
	var CharacterMetadata = __webpack_require__(70);
	
	var DataTransfer = __webpack_require__(428);
	
	var DraftModifier = __webpack_require__(59);
	
	var DraftPasteProcessor = __webpack_require__(1200);
	
	var EditorState = __webpack_require__(36);
	
	var RichTextEditorUtil = __webpack_require__(399);
	
	var getEntityKeyForSelection = __webpack_require__(265);
	
	var getTextContentFromFiles = __webpack_require__(413);
	
	var isEventHandled = __webpack_require__(195);
	
	var splitTextIntoTextBlocks = __webpack_require__(1252);
	/**
	 * Paste content.
	 */
	
	
	function editOnPaste(editor, e) {
	  e.preventDefault();
	  var data = new DataTransfer(e.clipboardData); // Get files, unless this is likely to be a string the user wants inline.
	
	  if (!data.isRichText()) {
	    var files = data.getFiles();
	    var defaultFileText = data.getText();
	
	    if (files.length > 0) {
	      // Allow customized paste handling for images, etc. Otherwise, fall
	      // through to insert text contents into the editor.
	      if (editor.props.handlePastedFiles && isEventHandled(editor.props.handlePastedFiles(files))) {
	        return;
	      }
	      /* $FlowFixMe[incompatible-call] This comment suppresses an error found
	       * DataTransfer was typed. getFiles() returns an array of <Files extends
	       * Blob>, not Blob */
	
	
	      getTextContentFromFiles(files, function (
	      /*string*/
	      fileText) {
	        fileText = fileText || defaultFileText;
	
	        if (!fileText) {
	          return;
	        }
	
	        var editorState = editor._latestEditorState;
	        var blocks = splitTextIntoTextBlocks(fileText);
	        var character = CharacterMetadata.create({
	          style: editorState.getCurrentInlineStyle(),
	          entity: getEntityKeyForSelection(editorState.getCurrentContent(), editorState.getSelection())
	        });
	        var currentBlockType = RichTextEditorUtil.getCurrentBlockType(editorState);
	        var text = DraftPasteProcessor.processText(blocks, character, currentBlockType);
	        var fragment = BlockMapBuilder.createFromArray(text);
	        var withInsertedText = DraftModifier.replaceWithFragment(editorState.getCurrentContent(), editorState.getSelection(), fragment);
	        editor.update(EditorState.push(editorState, withInsertedText, 'insert-fragment'));
	      });
	      return;
	    }
	  }
	
	  var textBlocks = [];
	  var text = data.getText();
	  var html = data.getHTML();
	  var editorState = editor._latestEditorState;
	
	  if (editor.props.formatPastedText) {
	    var _editor$props$formatP = editor.props.formatPastedText(text, html),
	        formattedText = _editor$props$formatP.text,
	        formattedHtml = _editor$props$formatP.html;
	
	    text = formattedText;
	    html = formattedHtml;
	  }
	
	  if (editor.props.handlePastedText && isEventHandled(editor.props.handlePastedText(text, html, editorState))) {
	    return;
	  }
	
	  if (text) {
	    textBlocks = splitTextIntoTextBlocks(text);
	  }
	
	  if (!editor.props.stripPastedStyles) {
	    // If the text from the paste event is rich content that matches what we
	    // already have on the internal clipboard, assume that we should just use
	    // the clipboard fragment for the paste. This will allow us to preserve
	    // styling and entities, if any are present. Note that newlines are
	    // stripped during comparison -- this is because copy/paste within the
	    // editor in Firefox and IE will not include empty lines. The resulting
	    // paste will preserve the newlines correctly.
	    var internalClipboard = editor.getClipboard();
	
	    if (!editor.props.formatPastedText && data.isRichText() && internalClipboard) {
	      var _html;
	
	      if ( // If the editorKey is present in the pasted HTML, it should be safe to
	      // assume this is an internal paste.
	      ((_html = html) === null || _html === void 0 ? void 0 : _html.indexOf(editor.getEditorKey())) !== -1 || // The copy may have been made within a single block, in which case the
	      // editor key won't be part of the paste. In this case, just check
	      // whether the pasted text matches the internal clipboard.
	      textBlocks.length === 1 && internalClipboard.size === 1 && internalClipboard.first().getText() === text) {
	        editor.update(insertFragment(editor._latestEditorState, internalClipboard));
	        return;
	      }
	    } else if (internalClipboard && data.types.includes('com.apple.webarchive') && !data.types.includes('text/html') && areTextBlocksAndClipboardEqual(textBlocks, internalClipboard)) {
	      // Safari does not properly store text/html in some cases.
	      // Use the internalClipboard if present and equal to what is on
	      // the clipboard. See https://bugs.webkit.org/show_bug.cgi?id=19893.
	      editor.update(insertFragment(editor._latestEditorState, internalClipboard));
	      return;
	    } // If there is html paste data, try to parse that.
	
	
	    if (html) {
	      var htmlFragment = DraftPasteProcessor.processHTML(html, editor.props.blockRenderMap);
	
	      if (htmlFragment) {
	        var contentBlocks = htmlFragment.contentBlocks,
	            entityMap = htmlFragment.entityMap;
	
	        if (contentBlocks) {
	          var htmlMap = BlockMapBuilder.createFromArray(contentBlocks);
	          editor.update(insertFragment(editor._latestEditorState, htmlMap, entityMap));
	          return;
	        }
	      }
	    } // Otherwise, create a new fragment from our pasted text. Also
	    // empty the internal clipboard, since it's no longer valid.
	
	
	    editor.setClipboard(null);
	  }
	
	  if (textBlocks.length) {
	    var character = CharacterMetadata.create({
	      style: editorState.getCurrentInlineStyle(),
	      entity: getEntityKeyForSelection(editorState.getCurrentContent(), editorState.getSelection())
	    });
	    var currentBlockType = RichTextEditorUtil.getCurrentBlockType(editorState);
	    var textFragment = DraftPasteProcessor.processText(textBlocks, character, currentBlockType);
	    var textMap = BlockMapBuilder.createFromArray(textFragment);
	    editor.update(insertFragment(editor._latestEditorState, textMap));
	  }
	}
	
	function insertFragment(editorState, fragment, entityMap) {
	  var newContent = DraftModifier.replaceWithFragment(editorState.getCurrentContent(), editorState.getSelection(), fragment); // TODO: merge the entity map once we stop using DraftEntity
	  // like this:
	  // const mergedEntityMap = newContent.getEntityMap().merge(entityMap);
	
	  return EditorState.push(editorState, newContent.set('entityMap', entityMap), 'insert-fragment');
	}
	
	function areTextBlocksAndClipboardEqual(textBlocks, blockMap) {
	  return textBlocks.length === blockMap.size && blockMap.valueSeq().every(function (block, ii) {
	    return block.getText() === textBlocks[ii];
	  });
	}
	
	module.exports = editOnPaste;

/***/ },
/* 1225 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	var DraftStringKey = __webpack_require__(398);
	
	var UnicodeUtils = __webpack_require__(107);
	
	var strlen = UnicodeUtils.strlen;
	/**
	 * Convert to UTF-8 character counts for storage.
	 */
	
	function encodeEntityRanges(block, storageMap) {
	  var encoded = [];
	  block.findEntityRanges(function (character) {
	    return !!character.getEntity();
	  }, function (
	  /*number*/
	  start,
	  /*number*/
	  end) {
	    var text = block.getText();
	    var key = block.getEntityAt(start);
	    encoded.push({
	      offset: strlen(text.slice(0, start)),
	      length: strlen(text.slice(start, end)),
	      // Encode the key as a number for range storage.
	      key: Number(storageMap[DraftStringKey.stringify(key)])
	    });
	  });
	  return encoded;
	}
	
	module.exports = encodeEntityRanges;

/***/ },
/* 1226 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	var UnicodeUtils = __webpack_require__(107);
	
	var findRangesImmutable = __webpack_require__(152);
	
	var areEqual = function areEqual(a, b) {
	  return a === b;
	};
	
	var isTruthy = function isTruthy(a) {
	  return !!a;
	};
	
	var EMPTY_ARRAY = [];
	/**
	 * Helper function for getting encoded styles for each inline style. Convert
	 * to UTF-8 character counts for storage.
	 */
	
	function getEncodedInlinesForType(block, styleList, styleToEncode) {
	  var ranges = []; // Obtain an array with ranges for only the specified style.
	
	  var filteredInlines = styleList.map(function (style) {
	    return style.has(styleToEncode);
	  }).toList();
	  findRangesImmutable(filteredInlines, areEqual, // We only want to keep ranges with nonzero style values.
	  isTruthy, function (start, end) {
	    var text = block.getText();
	    ranges.push({
	      offset: UnicodeUtils.strlen(text.slice(0, start)),
	      length: UnicodeUtils.strlen(text.slice(start, end)),
	      style: styleToEncode
	    });
	  });
	  return ranges;
	}
	/*
	 * Retrieve the encoded arrays of inline styles, with each individual style
	 * treated separately.
	 */
	
	
	function encodeInlineStyleRanges(block) {
	  var styleList = block.getCharacterList().map(function (c) {
	    return c.getStyle();
	  }).toList();
	  var ranges = styleList.flatten().toSet().map(function (style) {
	    return getEncodedInlinesForType(block, styleList, style);
	  });
	  return Array.prototype.concat.apply(EMPTY_ARRAY, ranges.toJS());
	}
	
	module.exports = encodeInlineStyleRanges;

/***/ },
/* 1227 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	var UnicodeUtils = __webpack_require__(107);
	
	var getCorrectDocumentFromNode = __webpack_require__(194);
	
	var getRangeClientRects = __webpack_require__(410);
	
	var invariant = __webpack_require__(32);
	/**
	 * Return the computed line height, in pixels, for the provided element.
	 */
	
	
	function getLineHeightPx(element) {
	  var computed = getComputedStyle(element);
	  var correctDocument = getCorrectDocumentFromNode(element);
	  var div = correctDocument.createElement('div');
	  div.style.fontFamily = computed.fontFamily;
	  div.style.fontSize = computed.fontSize;
	  div.style.fontStyle = computed.fontStyle;
	  div.style.fontWeight = computed.fontWeight;
	  div.style.lineHeight = computed.lineHeight;
	  div.style.position = 'absolute';
	  div.textContent = 'M';
	  var documentBody = correctDocument.body;
	  !documentBody ?  false ? invariant(false, 'Missing document.body') : invariant(false) : void 0; // forced layout here
	
	  documentBody.appendChild(div);
	  var rect = div.getBoundingClientRect();
	  documentBody.removeChild(div);
	  return rect.height;
	}
	/**
	 * Return whether every ClientRect in the provided list lies on the same line.
	 *
	 * We assume that the rects on the same line all contain the baseline, so the
	 * lowest top line needs to be above the highest bottom line (i.e., if you were
	 * to project the rects onto the y-axis, their intersection would be nonempty).
	 *
	 * In addition, we require that no two boxes are lineHeight (or more) apart at
	 * either top or bottom, which helps protect against false positives for fonts
	 * with extremely large glyph heights (e.g., with a font size of 17px, Zapfino
	 * produces rects of height 58px!).
	 */
	
	
	function areRectsOnOneLine(rects, lineHeight) {
	  var minTop = Infinity;
	  var minBottom = Infinity;
	  var maxTop = -Infinity;
	  var maxBottom = -Infinity;
	
	  for (var ii = 0; ii < rects.length; ii++) {
	    var rect = rects[ii];
	
	    if (rect.width === 0 || rect.width === 1) {
	      // When a range starts or ends a soft wrap, many browsers (Chrome, IE,
	      // Safari) include an empty rect on the previous or next line. When the
	      // text lies in a container whose position is not integral (e.g., from
	      // margin: auto), Safari makes these empty rects have width 1 (instead of
	      // 0). Having one-pixel-wide characters seems unlikely (and most browsers
	      // report widths in subpixel precision anyway) so it's relatively safe to
	      // skip over them.
	      continue;
	    }
	
	    minTop = Math.min(minTop, rect.top);
	    minBottom = Math.min(minBottom, rect.bottom);
	    maxTop = Math.max(maxTop, rect.top);
	    maxBottom = Math.max(maxBottom, rect.bottom);
	  }
	
	  return maxTop <= minBottom && maxTop - minTop < lineHeight && maxBottom - minBottom < lineHeight;
	}
	/**
	 * Return the length of a node, as used by Range offsets.
	 */
	
	
	function getNodeLength(node) {
	  // http://www.w3.org/TR/dom/#concept-node-length
	  switch (node.nodeType) {
	    case Node.DOCUMENT_TYPE_NODE:
	      return 0;
	
	    case Node.TEXT_NODE:
	    case Node.PROCESSING_INSTRUCTION_NODE:
	    case Node.COMMENT_NODE:
	      return node.length;
	
	    default:
	      return node.childNodes.length;
	  }
	}
	/**
	 * Given a collapsed range, move the start position backwards as far as
	 * possible while the range still spans only a single line.
	 */
	
	
	function expandRangeToStartOfLine(range) {
	  !range.collapsed ?  false ? invariant(false, 'expandRangeToStartOfLine: Provided range is not collapsed.') : invariant(false) : void 0;
	  range = range.cloneRange();
	  var containingElement = range.startContainer;
	
	  if (containingElement.nodeType !== 1) {
	    containingElement = containingElement.parentNode;
	  }
	
	  var lineHeight = getLineHeightPx(containingElement); // Imagine our text looks like:
	  //   <div><span>once upon a time, there was a <em>boy
	  //   who lived</em> </span><q><strong>under^ the
	  //   stairs</strong> in a small closet.</q></div>
	  // where the caret represents the cursor. First, we crawl up the tree until
	  // the range spans multiple lines (setting the start point to before
	  // "<strong>", then before "<div>"), then at each level we do a search to
	  // find the latest point which is still on a previous line. We'll find that
	  // the break point is inside the span, then inside the <em>, then in its text
	  // node child, the actual break point before "who".
	
	  var bestContainer = range.endContainer;
	  var bestOffset = range.endOffset;
	  range.setStart(range.startContainer, 0);
	
	  while (areRectsOnOneLine(getRangeClientRects(range), lineHeight)) {
	    bestContainer = range.startContainer;
	    bestOffset = range.startOffset;
	    !bestContainer.parentNode ?  false ? invariant(false, 'Found unexpected detached subtree when traversing.') : invariant(false) : void 0;
	    range.setStartBefore(bestContainer);
	
	    if (bestContainer.nodeType === 1 && getComputedStyle(bestContainer).display !== 'inline') {
	      // The start of the line is never in a different block-level container.
	      break;
	    }
	  } // In the above example, range now spans from "<div>" to "under",
	  // bestContainer is <div>, and bestOffset is 1 (index of <q> inside <div>)].
	  // Picking out which child to recurse into here is a special case since we
	  // don't want to check past <q> -- once we find that the final range starts
	  // in <span>, we can look at all of its children (and all of their children)
	  // to find the break point.
	  // At all times, (bestContainer, bestOffset) is the latest single-line start
	  // point that we know of.
	
	
	  var currentContainer = bestContainer;
	  var maxIndexToConsider = bestOffset - 1;
	
	  do {
	    var nodeValue = currentContainer.nodeValue;
	    var ii = maxIndexToConsider;
	
	    for (; ii >= 0; ii--) {
	      if (nodeValue != null && ii > 0 && UnicodeUtils.isSurrogatePair(nodeValue, ii - 1)) {
	        // We're in the middle of a surrogate pair -- skip over so we never
	        // return a range with an endpoint in the middle of a code point.
	        continue;
	      }
	
	      range.setStart(currentContainer, ii);
	
	      if (areRectsOnOneLine(getRangeClientRects(range), lineHeight)) {
	        bestContainer = currentContainer;
	        bestOffset = ii;
	      } else {
	        break;
	      }
	    }
	
	    if (ii === -1 || currentContainer.childNodes.length === 0) {
	      // If ii === -1, then (bestContainer, bestOffset), which is equal to
	      // (currentContainer, 0), was a single-line start point but a start
	      // point before currentContainer wasn't, so the line break seems to
	      // have occurred immediately after currentContainer's start tag
	      //
	      // If currentContainer.childNodes.length === 0, we're already at a
	      // terminal node (e.g., text node) and should return our current best.
	      break;
	    }
	
	    currentContainer = currentContainer.childNodes[ii];
	    maxIndexToConsider = getNodeLength(currentContainer);
	  } while (true);
	
	  range.setStart(bestContainer, bestOffset);
	  return range;
	}
	
	module.exports = expandRangeToStartOfLine;

/***/ },
/* 1228 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	var DraftEntitySegments = __webpack_require__(1199);
	
	var getRangesForDraftEntity = __webpack_require__(1230);
	
	var invariant = __webpack_require__(32);
	/**
	 * Given a SelectionState and a removal direction, determine the entire range
	 * that should be removed from a ContentState. This is based on any entities
	 * within the target, with their `mutability` values taken into account.
	 *
	 * For instance, if we are attempting to remove part of an "immutable" entity
	 * range, the entire entity must be removed. The returned `SelectionState`
	 * will be adjusted accordingly.
	 */
	
	
	function getCharacterRemovalRange(entityMap, startBlock, endBlock, selectionState, direction) {
	  var start = selectionState.getStartOffset();
	  var end = selectionState.getEndOffset();
	  var startEntityKey = startBlock.getEntityAt(start);
	  var endEntityKey = endBlock.getEntityAt(end - 1);
	
	  if (!startEntityKey && !endEntityKey) {
	    return selectionState;
	  }
	
	  var newSelectionState = selectionState;
	
	  if (startEntityKey && startEntityKey === endEntityKey) {
	    newSelectionState = getEntityRemovalRange(entityMap, startBlock, newSelectionState, direction, startEntityKey, true, true);
	  } else if (startEntityKey && endEntityKey) {
	    var startSelectionState = getEntityRemovalRange(entityMap, startBlock, newSelectionState, direction, startEntityKey, false, true);
	    var endSelectionState = getEntityRemovalRange(entityMap, endBlock, newSelectionState, direction, endEntityKey, false, false);
	    newSelectionState = newSelectionState.merge({
	      anchorOffset: startSelectionState.getAnchorOffset(),
	      focusOffset: endSelectionState.getFocusOffset(),
	      isBackward: false
	    });
	  } else if (startEntityKey) {
	    var _startSelectionState = getEntityRemovalRange(entityMap, startBlock, newSelectionState, direction, startEntityKey, false, true);
	
	    newSelectionState = newSelectionState.merge({
	      anchorOffset: _startSelectionState.getStartOffset(),
	      isBackward: false
	    });
	  } else if (endEntityKey) {
	    var _endSelectionState = getEntityRemovalRange(entityMap, endBlock, newSelectionState, direction, endEntityKey, false, false);
	
	    newSelectionState = newSelectionState.merge({
	      focusOffset: _endSelectionState.getEndOffset(),
	      isBackward: false
	    });
	  }
	
	  return newSelectionState;
	}
	
	function getEntityRemovalRange(entityMap, block, selectionState, direction, entityKey, isEntireSelectionWithinEntity, isEntityAtStart) {
	  var start = selectionState.getStartOffset();
	  var end = selectionState.getEndOffset();
	
	  var entity = entityMap.__get(entityKey);
	
	  var mutability = entity.getMutability();
	  var sideToConsider = isEntityAtStart ? start : end; // `MUTABLE` entities can just have the specified range of text removed
	  // directly. No adjustments are needed.
	
	  if (mutability === 'MUTABLE') {
	    return selectionState;
	  } // Find the entity range that overlaps with our removal range.
	
	
	  var entityRanges = getRangesForDraftEntity(block, entityKey).filter(function (range) {
	    return sideToConsider <= range.end && sideToConsider >= range.start;
	  });
	  !(entityRanges.length == 1) ?  false ? invariant(false, 'There should only be one entity range within this removal range.') : invariant(false) : void 0;
	  var entityRange = entityRanges[0]; // For `IMMUTABLE` entity types, we will remove the entire entity range.
	
	  if (mutability === 'IMMUTABLE') {
	    return selectionState.merge({
	      anchorOffset: entityRange.start,
	      focusOffset: entityRange.end,
	      isBackward: false
	    });
	  } // For `SEGMENTED` entity types, determine the appropriate segment to
	  // remove.
	
	
	  if (!isEntireSelectionWithinEntity) {
	    if (isEntityAtStart) {
	      end = entityRange.end;
	    } else {
	      start = entityRange.start;
	    }
	  }
	
	  var removalRange = DraftEntitySegments.getRemovalRange(start, end, block.getText().slice(entityRange.start, entityRange.end), entityRange.start, direction);
	  return selectionState.merge({
	    anchorOffset: removalRange.start,
	    focusOffset: removalRange.end,
	    isBackward: false
	  });
	}
	
	module.exports = getCharacterRemovalRange;

/***/ },
/* 1229 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	var getRangeClientRects = __webpack_require__(410);
	
	/**
	 * Like range.getBoundingClientRect() but normalizes for browser bugs.
	 */
	function getRangeBoundingClientRect(range) {
	  // "Return a DOMRect object describing the smallest rectangle that includes
	  // the first rectangle in list and all of the remaining rectangles of which
	  // the height or width is not zero."
	  // http://www.w3.org/TR/cssom-view/#dom-range-getboundingclientrect
	  var rects = getRangeClientRects(range);
	  var top = 0;
	  var right = 0;
	  var bottom = 0;
	  var left = 0;
	
	  if (rects.length) {
	    // If the first rectangle has 0 width, we use the second, this is needed
	    // because Chrome renders a 0 width rectangle when the selection contains
	    // a line break.
	    if (rects.length > 1 && rects[0].width === 0) {
	      var _rects$ = rects[1];
	      top = _rects$.top;
	      right = _rects$.right;
	      bottom = _rects$.bottom;
	      left = _rects$.left;
	    } else {
	      var _rects$2 = rects[0];
	      top = _rects$2.top;
	      right = _rects$2.right;
	      bottom = _rects$2.bottom;
	      left = _rects$2.left;
	    }
	
	    for (var ii = 1; ii < rects.length; ii++) {
	      var rect = rects[ii];
	
	      if (rect.height !== 0 && rect.width !== 0) {
	        top = Math.min(top, rect.top);
	        right = Math.max(right, rect.right);
	        bottom = Math.max(bottom, rect.bottom);
	        left = Math.min(left, rect.left);
	      }
	    }
	  }
	
	  return {
	    top: top,
	    right: right,
	    bottom: bottom,
	    left: left,
	    width: right - left,
	    height: bottom - top
	  };
	}
	
	module.exports = getRangeBoundingClientRect;

/***/ },
/* 1230 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	var invariant = __webpack_require__(32);
	/**
	 * Obtain the start and end positions of the range that has the
	 * specified entity applied to it.
	 *
	 * Entity keys are applied only to contiguous stretches of text, so this
	 * method searches for the first instance of the entity key and returns
	 * the subsequent range.
	 */
	
	
	function getRangesForDraftEntity(block, key) {
	  var ranges = [];
	  block.findEntityRanges(function (c) {
	    return c.getEntity() === key;
	  }, function (start, end) {
	    ranges.push({
	      start: start,
	      end: end
	    });
	  });
	  !!!ranges.length ?  false ? invariant(false, 'Entity key not found in this range.') : invariant(false) : void 0;
	  return ranges;
	}
	
	module.exports = getRangesForDraftEntity;

/***/ },
/* 1231 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	var getRangeBoundingClientRect = __webpack_require__(1229);
	/**
	 * Return the bounding ClientRect for the visible DOM selection, if any.
	 * In cases where there are no selected ranges or the bounding rect is
	 * temporarily invalid, return null.
	 *
	 * When using from an iframe, you should pass the iframe window object
	 */
	
	
	function getVisibleSelectionRect(global) {
	  var selection = global.getSelection();
	
	  if (!selection.rangeCount) {
	    return null;
	  }
	
	  var range = selection.getRangeAt(0);
	  var boundingRect = getRangeBoundingClientRect(range);
	  var top = boundingRect.top,
	      right = boundingRect.right,
	      bottom = boundingRect.bottom,
	      left = boundingRect.left; // When a re-render leads to a node being removed, the DOM selection will
	  // temporarily be placed on an ancestor node, which leads to an invalid
	  // bounding rect. Discard this state.
	
	  if (top === 0 && right === 0 && bottom === 0 && left === 0) {
	    return null;
	  }
	
	  return boundingRect;
	}
	
	module.exports = getVisibleSelectionRect;

/***/ },
/* 1232 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	var BlockMapBuilder = __webpack_require__(151);
	
	var ContentBlockNode = __webpack_require__(71);
	
	var Immutable = __webpack_require__(27);
	
	var insertIntoList = __webpack_require__(416);
	
	var invariant = __webpack_require__(32);
	
	var randomizeBlockMapKeys = __webpack_require__(421);
	
	var List = Immutable.List;
	
	var updateExistingBlock = function updateExistingBlock(contentState, selectionState, blockMap, fragmentBlock, targetKey, targetOffset) {
	  var mergeBlockData = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 'REPLACE_WITH_NEW_DATA';
	  var targetBlock = blockMap.get(targetKey);
	  var text = targetBlock.getText();
	  var chars = targetBlock.getCharacterList();
	  var finalKey = targetKey;
	  var finalOffset = targetOffset + fragmentBlock.getText().length;
	  var data = null;
	
	  switch (mergeBlockData) {
	    case 'MERGE_OLD_DATA_TO_NEW_DATA':
	      data = fragmentBlock.getData().merge(targetBlock.getData());
	      break;
	
	    case 'REPLACE_WITH_NEW_DATA':
	      data = fragmentBlock.getData();
	      break;
	  }
	
	  var type = targetBlock.getType();
	
	  if (text && type === 'unstyled') {
	    type = fragmentBlock.getType();
	  }
	
	  var newBlock = targetBlock.merge({
	    text: text.slice(0, targetOffset) + fragmentBlock.getText() + text.slice(targetOffset),
	    characterList: insertIntoList(chars, fragmentBlock.getCharacterList(), targetOffset),
	    type: type,
	    data: data
	  });
	  return contentState.merge({
	    blockMap: blockMap.set(targetKey, newBlock),
	    selectionBefore: selectionState,
	    selectionAfter: selectionState.merge({
	      anchorKey: finalKey,
	      anchorOffset: finalOffset,
	      focusKey: finalKey,
	      focusOffset: finalOffset,
	      isBackward: false
	    })
	  });
	};
	/**
	 * Appends text/characterList from the fragment first block to
	 * target block.
	 */
	
	
	var updateHead = function updateHead(block, targetOffset, fragment) {
	  var text = block.getText();
	  var chars = block.getCharacterList(); // Modify head portion of block.
	
	  var headText = text.slice(0, targetOffset);
	  var headCharacters = chars.slice(0, targetOffset);
	  var appendToHead = fragment.first();
	  return block.merge({
	    text: headText + appendToHead.getText(),
	    characterList: headCharacters.concat(appendToHead.getCharacterList()),
	    type: headText ? block.getType() : appendToHead.getType(),
	    data: appendToHead.getData()
	  });
	};
	/**
	 * Appends offset text/characterList from the target block to the last
	 * fragment block.
	 */
	
	
	var updateTail = function updateTail(block, targetOffset, fragment) {
	  // Modify tail portion of block.
	  var text = block.getText();
	  var chars = block.getCharacterList(); // Modify head portion of block.
	
	  var blockSize = text.length;
	  var tailText = text.slice(targetOffset, blockSize);
	  var tailCharacters = chars.slice(targetOffset, blockSize);
	  var prependToTail = fragment.last();
	  return prependToTail.merge({
	    text: prependToTail.getText() + tailText,
	    characterList: prependToTail.getCharacterList().concat(tailCharacters),
	    data: prependToTail.getData()
	  });
	};
	
	var getRootBlocks = function getRootBlocks(block, blockMap) {
	  var headKey = block.getKey();
	  var rootBlock = block;
	  var rootBlocks = []; // sometimes the fragment head block will not be part of the blockMap itself this can happen when
	  // the fragment head is used to update the target block, however when this does not happen we need
	  // to make sure that we include it on the rootBlocks since the first block of a fragment is always a
	  // fragment root block
	
	  if (blockMap.get(headKey)) {
	    rootBlocks.push(headKey);
	  }
	
	  while (rootBlock && rootBlock.getNextSiblingKey()) {
	    var lastSiblingKey = rootBlock.getNextSiblingKey();
	
	    if (!lastSiblingKey) {
	      break;
	    }
	
	    rootBlocks.push(lastSiblingKey);
	    rootBlock = blockMap.get(lastSiblingKey);
	  }
	
	  return rootBlocks;
	};
	
	var updateBlockMapLinks = function updateBlockMapLinks(blockMap, originalBlockMap, targetBlock, fragmentHeadBlock) {
	  return blockMap.withMutations(function (blockMapState) {
	    var targetKey = targetBlock.getKey();
	    var headKey = fragmentHeadBlock.getKey();
	    var targetNextKey = targetBlock.getNextSiblingKey();
	    var targetParentKey = targetBlock.getParentKey();
	    var fragmentRootBlocks = getRootBlocks(fragmentHeadBlock, blockMap);
	    var lastRootFragmentBlockKey = fragmentRootBlocks[fragmentRootBlocks.length - 1];
	
	    if (blockMapState.get(headKey)) {
	      // update the fragment head when it is part of the blockMap otherwise
	      blockMapState.setIn([targetKey, 'nextSibling'], headKey);
	      blockMapState.setIn([headKey, 'prevSibling'], targetKey);
	    } else {
	      // update the target block that had the fragment head contents merged into it
	      blockMapState.setIn([targetKey, 'nextSibling'], fragmentHeadBlock.getNextSiblingKey());
	      blockMapState.setIn([fragmentHeadBlock.getNextSiblingKey(), 'prevSibling'], targetKey);
	    } // update the last root block fragment
	
	
	    blockMapState.setIn([lastRootFragmentBlockKey, 'nextSibling'], targetNextKey); // update the original target next block
	
	    if (targetNextKey) {
	      blockMapState.setIn([targetNextKey, 'prevSibling'], lastRootFragmentBlockKey);
	    } // update fragment parent links
	
	
	    fragmentRootBlocks.forEach(function (blockKey) {
	      return blockMapState.setIn([blockKey, 'parent'], targetParentKey);
	    }); // update targetBlock parent child links
	
	    if (targetParentKey) {
	      var targetParent = blockMap.get(targetParentKey);
	      var originalTargetParentChildKeys = targetParent.getChildKeys();
	      var targetBlockIndex = originalTargetParentChildKeys.indexOf(targetKey);
	      var insertionIndex = targetBlockIndex + 1;
	      var newChildrenKeysArray = originalTargetParentChildKeys.toArray(); // insert fragment children
	
	      newChildrenKeysArray.splice.apply(newChildrenKeysArray, [insertionIndex, 0].concat(fragmentRootBlocks));
	      blockMapState.setIn([targetParentKey, 'children'], List(newChildrenKeysArray));
	    }
	  });
	};
	
	var insertFragment = function insertFragment(contentState, selectionState, blockMap, fragment, targetKey, targetOffset) {
	  var isTreeBasedBlockMap = blockMap.first() instanceof ContentBlockNode;
	  var newBlockArr = [];
	  var fragmentSize = fragment.size;
	  var target = blockMap.get(targetKey);
	  var head = fragment.first();
	  var tail = fragment.last();
	  var finalOffset = tail.getLength();
	  var finalKey = tail.getKey();
	  var shouldNotUpdateFromFragmentBlock = isTreeBasedBlockMap && (!target.getChildKeys().isEmpty() || !head.getChildKeys().isEmpty());
	  blockMap.forEach(function (block, blockKey) {
	    if (blockKey !== targetKey) {
	      newBlockArr.push(block);
	      return;
	    }
	
	    if (shouldNotUpdateFromFragmentBlock) {
	      newBlockArr.push(block);
	    } else {
	      newBlockArr.push(updateHead(block, targetOffset, fragment));
	    } // Insert fragment blocks after the head and before the tail.
	
	
	    fragment // when we are updating the target block with the head fragment block we skip the first fragment
	    // head since its contents have already been merged with the target block otherwise we include
	    // the whole fragment
	    .slice(shouldNotUpdateFromFragmentBlock ? 0 : 1, fragmentSize - 1).forEach(function (fragmentBlock) {
	      return newBlockArr.push(fragmentBlock);
	    }); // update tail
	
	    newBlockArr.push(updateTail(block, targetOffset, fragment));
	  });
	  var updatedBlockMap = BlockMapBuilder.createFromArray(newBlockArr);
	
	  if (isTreeBasedBlockMap) {
	    updatedBlockMap = updateBlockMapLinks(updatedBlockMap, blockMap, target, head);
	  }
	
	  return contentState.merge({
	    blockMap: updatedBlockMap,
	    selectionBefore: selectionState,
	    selectionAfter: selectionState.merge({
	      anchorKey: finalKey,
	      anchorOffset: finalOffset,
	      focusKey: finalKey,
	      focusOffset: finalOffset,
	      isBackward: false
	    })
	  });
	};
	
	var insertFragmentIntoContentState = function insertFragmentIntoContentState(contentState, selectionState, fragmentBlockMap) {
	  var mergeBlockData = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'REPLACE_WITH_NEW_DATA';
	  !selectionState.isCollapsed() ?  false ? invariant(false, '`insertFragment` should only be called with a collapsed selection state.') : invariant(false) : void 0;
	  var blockMap = contentState.getBlockMap();
	  var fragment = randomizeBlockMapKeys(fragmentBlockMap);
	  var targetKey = selectionState.getStartKey();
	  var targetOffset = selectionState.getStartOffset();
	  var targetBlock = blockMap.get(targetKey);
	
	  if (targetBlock instanceof ContentBlockNode) {
	    !targetBlock.getChildKeys().isEmpty() ?  false ? invariant(false, '`insertFragment` should not be called when a container node is selected.') : invariant(false) : void 0;
	  } // When we insert a fragment with a single block we simply update the target block
	  // with the contents of the inserted fragment block
	
	
	  if (fragment.size === 1) {
	    return updateExistingBlock(contentState, selectionState, blockMap, fragment.first(), targetKey, targetOffset, mergeBlockData);
	  }
	
	  return insertFragment(contentState, selectionState, blockMap, fragment, targetKey, targetOffset);
	};
	
	module.exports = insertFragmentIntoContentState;

/***/ },
/* 1233 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	var Immutable = __webpack_require__(27);
	
	var insertIntoList = __webpack_require__(416);
	
	var invariant = __webpack_require__(32);
	
	var Repeat = Immutable.Repeat;
	
	function insertTextIntoContentState(contentState, selectionState, text, characterMetadata) {
	  !selectionState.isCollapsed() ?  false ? invariant(false, '`insertText` should only be called with a collapsed range.') : invariant(false) : void 0;
	  var len = null;
	
	  if (text != null) {
	    len = text.length;
	  }
	
	  if (len == null || len === 0) {
	    return contentState;
	  }
	
	  var blockMap = contentState.getBlockMap();
	  var key = selectionState.getStartKey();
	  var offset = selectionState.getStartOffset();
	  var block = blockMap.get(key);
	  var blockText = block.getText();
	  var newBlock = block.merge({
	    text: blockText.slice(0, offset) + text + blockText.slice(offset, block.getLength()),
	    characterList: insertIntoList(block.getCharacterList(), Repeat(characterMetadata, len).toList(), offset)
	  });
	  var newOffset = offset + len;
	  return contentState.merge({
	    blockMap: blockMap.set(key, newBlock),
	    selectionAfter: selectionState.merge({
	      anchorOffset: newOffset,
	      focusOffset: newOffset
	    })
	  });
	}
	
	module.exports = insertTextIntoContentState;

/***/ },
/* 1234 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	var isElement = __webpack_require__(105);
	
	function isHTMLAnchorElement(node) {
	  if (!node || !node.ownerDocument) {
	    return false;
	  }
	
	  return isElement(node) && node.nodeName === 'A';
	}
	
	module.exports = isHTMLAnchorElement;

/***/ },
/* 1235 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	var isElement = __webpack_require__(105);
	
	function isHTMLImageElement(node) {
	  if (!node || !node.ownerDocument) {
	    return false;
	  }
	
	  return isElement(node) && node.nodeName === 'IMG';
	}
	
	module.exports = isHTMLImageElement;

/***/ },
/* 1236 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	function isInstanceOfNode(target) {
	  // we changed the name because of having duplicate module provider (fbjs)
	  if (!target || !('ownerDocument' in target)) {
	    return false;
	  }
	
	  if ('ownerDocument' in target) {
	    var node = target;
	
	    if (!node.ownerDocument.defaultView) {
	      return node instanceof Node;
	    }
	
	    if (node instanceof node.ownerDocument.defaultView.Node) {
	      return true;
	    }
	  }
	
	  return false;
	}
	
	module.exports = isInstanceOfNode;

/***/ },
/* 1237 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	function isSelectionAtLeafStart(editorState) {
	  var selection = editorState.getSelection();
	  var anchorKey = selection.getAnchorKey();
	  var blockTree = editorState.getBlockTree(anchorKey);
	  var offset = selection.getStartOffset();
	  var isAtStart = false;
	  blockTree.some(function (leafSet) {
	    if (offset === leafSet.get('start')) {
	      isAtStart = true;
	      return true;
	    }
	
	    if (offset < leafSet.get('end')) {
	      return leafSet.get('leaves').some(function (leaf) {
	        var leafStart = leaf.get('start');
	
	        if (offset === leafStart) {
	          isAtStart = true;
	          return true;
	        }
	
	        return false;
	      });
	    }
	
	    return false;
	  });
	  return isAtStart;
	}
	
	module.exports = isSelectionAtLeafStart;

/***/ },
/* 1238 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	var Keys = __webpack_require__(197);
	
	function isSoftNewlineEvent(e) {
	  return e.which === Keys.RETURN && (e.getModifierState('Shift') || e.getModifierState('Alt') || e.getModifierState('Control'));
	}
	
	module.exports = isSoftNewlineEvent;

/***/ },
/* 1239 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	var EditorState = __webpack_require__(36);
	
	var expandRangeToStartOfLine = __webpack_require__(1227);
	
	var getDraftEditorSelectionWithNodes = __webpack_require__(406);
	
	var moveSelectionBackward = __webpack_require__(266);
	
	var removeTextWithStrategy = __webpack_require__(154);
	
	function keyCommandBackspaceToStartOfLine(editorState, e) {
	  var afterRemoval = removeTextWithStrategy(editorState, function (strategyState) {
	    var selection = strategyState.getSelection();
	
	    if (selection.isCollapsed() && selection.getAnchorOffset() === 0) {
	      return moveSelectionBackward(strategyState, 1);
	    }
	
	    var ownerDocument = e.currentTarget.ownerDocument;
	    var domSelection = ownerDocument.defaultView.getSelection(); // getRangeAt can technically throw if there's no selection, but we know
	    // there is one here because text editor has focus (the cursor is a
	    // selection of length 0). Therefore, we don't need to wrap this in a
	    // try-catch block.
	
	    var range = domSelection.getRangeAt(0);
	    range = expandRangeToStartOfLine(range);
	    return getDraftEditorSelectionWithNodes(strategyState, null, range.endContainer, range.endOffset, range.startContainer, range.startOffset).selectionState;
	  }, 'backward');
	
	  if (afterRemoval === editorState.getCurrentContent()) {
	    return editorState;
	  }
	
	  return EditorState.push(editorState, afterRemoval, 'remove-range');
	}
	
	module.exports = keyCommandBackspaceToStartOfLine;

/***/ },
/* 1240 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	var DraftRemovableWord = __webpack_require__(397);
	
	var EditorState = __webpack_require__(36);
	
	var moveSelectionBackward = __webpack_require__(266);
	
	var removeTextWithStrategy = __webpack_require__(154);
	/**
	 * Delete the word that is left of the cursor, as well as any spaces or
	 * punctuation after the word.
	 */
	
	
	function keyCommandBackspaceWord(editorState) {
	  var afterRemoval = removeTextWithStrategy(editorState, function (strategyState) {
	    var selection = strategyState.getSelection();
	    var offset = selection.getStartOffset(); // If there are no words before the cursor, remove the preceding newline.
	
	    if (offset === 0) {
	      return moveSelectionBackward(strategyState, 1);
	    }
	
	    var key = selection.getStartKey();
	    var content = strategyState.getCurrentContent();
	    var text = content.getBlockForKey(key).getText().slice(0, offset);
	    var toRemove = DraftRemovableWord.getBackward(text);
	    return moveSelectionBackward(strategyState, toRemove.length || 1);
	  }, 'backward');
	
	  if (afterRemoval === editorState.getCurrentContent()) {
	    return editorState;
	  }
	
	  return EditorState.push(editorState, afterRemoval, 'remove-range');
	}
	
	module.exports = keyCommandBackspaceWord;

/***/ },
/* 1241 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	var DraftRemovableWord = __webpack_require__(397);
	
	var EditorState = __webpack_require__(36);
	
	var moveSelectionForward = __webpack_require__(420);
	
	var removeTextWithStrategy = __webpack_require__(154);
	/**
	 * Delete the word that is right of the cursor, as well as any spaces or
	 * punctuation before the word.
	 */
	
	
	function keyCommandDeleteWord(editorState) {
	  var afterRemoval = removeTextWithStrategy(editorState, function (strategyState) {
	    var selection = strategyState.getSelection();
	    var offset = selection.getStartOffset();
	    var key = selection.getStartKey();
	    var content = strategyState.getCurrentContent();
	    var text = content.getBlockForKey(key).getText().slice(offset);
	    var toRemove = DraftRemovableWord.getForward(text); // If there are no words in front of the cursor, remove the newline.
	
	    return moveSelectionForward(strategyState, toRemove.length || 1);
	  }, 'forward');
	
	  if (afterRemoval === editorState.getCurrentContent()) {
	    return editorState;
	  }
	
	  return EditorState.push(editorState, afterRemoval, 'remove-range');
	}
	
	module.exports = keyCommandDeleteWord;

/***/ },
/* 1242 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	var DraftModifier = __webpack_require__(59);
	
	var EditorState = __webpack_require__(36);
	
	function keyCommandInsertNewline(editorState) {
	  var contentState = DraftModifier.splitBlock(editorState.getCurrentContent(), editorState.getSelection());
	  return EditorState.push(editorState, contentState, 'split-block');
	}
	
	module.exports = keyCommandInsertNewline;

/***/ },
/* 1243 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	var EditorState = __webpack_require__(36);
	/**
	 * See comment for `moveSelectionToStartOfBlock`.
	 */
	
	
	function keyCommandMoveSelectionToEndOfBlock(editorState) {
	  var selection = editorState.getSelection();
	  var endKey = selection.getEndKey();
	  var content = editorState.getCurrentContent();
	  var textLength = content.getBlockForKey(endKey).getLength();
	  return EditorState.set(editorState, {
	    selection: selection.merge({
	      anchorKey: endKey,
	      anchorOffset: textLength,
	      focusKey: endKey,
	      focusOffset: textLength,
	      isBackward: false
	    }),
	    forceSelection: true
	  });
	}
	
	module.exports = keyCommandMoveSelectionToEndOfBlock;

/***/ },
/* 1244 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	var EditorState = __webpack_require__(36);
	/**
	 * Collapse selection at the start of the first selected block. This is used
	 * for Firefox versions that attempt to navigate forward/backward instead of
	 * moving the cursor. Other browsers are able to move the cursor natively.
	 */
	
	
	function keyCommandMoveSelectionToStartOfBlock(editorState) {
	  var selection = editorState.getSelection();
	  var startKey = selection.getStartKey();
	  return EditorState.set(editorState, {
	    selection: selection.merge({
	      anchorKey: startKey,
	      anchorOffset: 0,
	      focusKey: startKey,
	      focusOffset: 0,
	      isBackward: false
	    }),
	    forceSelection: true
	  });
	}
	
	module.exports = keyCommandMoveSelectionToStartOfBlock;

/***/ },
/* 1245 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	var EditorState = __webpack_require__(36);
	
	var UnicodeUtils = __webpack_require__(107);
	
	var moveSelectionForward = __webpack_require__(420);
	
	var removeTextWithStrategy = __webpack_require__(154);
	/**
	 * Remove the selected range. If the cursor is collapsed, remove the following
	 * character. This operation is Unicode-aware, so removing a single character
	 * will remove a surrogate pair properly as well.
	 */
	
	
	function keyCommandPlainDelete(editorState) {
	  var afterRemoval = removeTextWithStrategy(editorState, function (strategyState) {
	    var selection = strategyState.getSelection();
	    var content = strategyState.getCurrentContent();
	    var key = selection.getAnchorKey();
	    var offset = selection.getAnchorOffset();
	    var charAhead = content.getBlockForKey(key).getText()[offset];
	    return moveSelectionForward(strategyState, charAhead ? UnicodeUtils.getUTF16Length(charAhead, 0) : 1);
	  }, 'forward');
	
	  if (afterRemoval === editorState.getCurrentContent()) {
	    return editorState;
	  }
	
	  var selection = editorState.getSelection();
	  return EditorState.push(editorState, afterRemoval.set('selectionBefore', selection), selection.isCollapsed() ? 'delete-character' : 'remove-range');
	}
	
	module.exports = keyCommandPlainDelete;

/***/ },
/* 1246 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	var DraftModifier = __webpack_require__(59);
	
	var EditorState = __webpack_require__(36);
	
	var getContentStateFragment = __webpack_require__(193);
	/**
	 * Transpose the characters on either side of a collapsed cursor, or
	 * if the cursor is at the end of the block, transpose the last two
	 * characters.
	 */
	
	
	function keyCommandTransposeCharacters(editorState) {
	  var selection = editorState.getSelection();
	
	  if (!selection.isCollapsed()) {
	    return editorState;
	  }
	
	  var offset = selection.getAnchorOffset();
	
	  if (offset === 0) {
	    return editorState;
	  }
	
	  var blockKey = selection.getAnchorKey();
	  var content = editorState.getCurrentContent();
	  var block = content.getBlockForKey(blockKey);
	  var length = block.getLength(); // Nothing to transpose if there aren't two characters.
	
	  if (length <= 1) {
	    return editorState;
	  }
	
	  var removalRange;
	  var finalSelection;
	
	  if (offset === length) {
	    // The cursor is at the end of the block. Swap the last two characters.
	    removalRange = selection.set('anchorOffset', offset - 1);
	    finalSelection = selection;
	  } else {
	    removalRange = selection.set('focusOffset', offset + 1);
	    finalSelection = removalRange.set('anchorOffset', offset + 1);
	  } // Extract the character to move as a fragment. This preserves its
	  // styling and entity, if any.
	
	
	  var movedFragment = getContentStateFragment(content, removalRange);
	  var afterRemoval = DraftModifier.removeRange(content, removalRange, 'backward'); // After the removal, the insertion target is one character back.
	
	  var selectionAfter = afterRemoval.getSelectionAfter();
	  var targetOffset = selectionAfter.getAnchorOffset() - 1;
	  var targetRange = selectionAfter.merge({
	    anchorOffset: targetOffset,
	    focusOffset: targetOffset
	  });
	  var afterInsert = DraftModifier.replaceWithFragment(afterRemoval, targetRange, movedFragment);
	  var newEditorState = EditorState.push(editorState, afterInsert, 'insert-fragment');
	  return EditorState.acceptSelection(newEditorState, finalSelection);
	}
	
	module.exports = keyCommandTransposeCharacters;

/***/ },
/* 1247 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	var EditorState = __webpack_require__(36);
	
	function keyCommandUndo(e, editorState, updateFn) {
	  var undoneState = EditorState.undo(editorState); // If the last change to occur was a spellcheck change, allow the undo
	  // event to fall through to the browser. This allows the browser to record
	  // the unwanted change, which should soon lead it to learn not to suggest
	  // the correction again.
	
	  if (editorState.getLastChangeType() === 'spellcheck-change') {
	    var nativelyRenderedContent = undoneState.getCurrentContent();
	    updateFn(EditorState.set(undoneState, {
	      nativelyRenderedContent: nativelyRenderedContent
	    }));
	    return;
	  } // Otheriwse, manage the undo behavior manually.
	
	
	  e.preventDefault();
	
	  if (!editorState.getNativelyRenderedContent()) {
	    updateFn(undoneState);
	    return;
	  } // Trigger a re-render with the current content state to ensure that the
	  // component tree has up-to-date props for comparison.
	
	
	  updateFn(EditorState.set(editorState, {
	    nativelyRenderedContent: null
	  })); // Wait to ensure that the re-render has occurred before performing
	  // the undo action.
	
	  setTimeout(function () {
	    updateFn(undoneState);
	  }, 0);
	}
	
	module.exports = keyCommandUndo;

/***/ },
/* 1248 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	var ContentBlockNode = __webpack_require__(71);
	
	var getNextDelimiterBlockKey = __webpack_require__(408);
	
	var Immutable = __webpack_require__(27);
	
	var invariant = __webpack_require__(32);
	
	var OrderedMap = Immutable.OrderedMap,
	    List = Immutable.List;
	
	var transformBlock = function transformBlock(key, blockMap, func) {
	  if (!key) {
	    return;
	  }
	
	  var block = blockMap.get(key);
	
	  if (!block) {
	    return;
	  }
	
	  blockMap.set(key, func(block));
	};
	
	var updateBlockMapLinks = function updateBlockMapLinks(blockMap, originalBlockToBeMoved, originalTargetBlock, insertionMode, isExperimentalTreeBlock) {
	  if (!isExperimentalTreeBlock) {
	    return blockMap;
	  } // possible values of 'insertionMode' are: 'after', 'before'
	
	
	  var isInsertedAfterTarget = insertionMode === 'after';
	  var originalBlockKey = originalBlockToBeMoved.getKey();
	  var originalTargetKey = originalTargetBlock.getKey();
	  var originalParentKey = originalBlockToBeMoved.getParentKey();
	  var originalNextSiblingKey = originalBlockToBeMoved.getNextSiblingKey();
	  var originalPrevSiblingKey = originalBlockToBeMoved.getPrevSiblingKey();
	  var newParentKey = originalTargetBlock.getParentKey();
	  var newNextSiblingKey = isInsertedAfterTarget ? originalTargetBlock.getNextSiblingKey() : originalTargetKey;
	  var newPrevSiblingKey = isInsertedAfterTarget ? originalTargetKey : originalTargetBlock.getPrevSiblingKey();
	  return blockMap.withMutations(function (blocks) {
	    // update old parent
	    transformBlock(originalParentKey, blocks, function (block) {
	      var parentChildrenList = block.getChildKeys();
	      return block.merge({
	        children: parentChildrenList["delete"](parentChildrenList.indexOf(originalBlockKey))
	      });
	    }); // update old prev
	
	    transformBlock(originalPrevSiblingKey, blocks, function (block) {
	      return block.merge({
	        nextSibling: originalNextSiblingKey
	      });
	    }); // update old next
	
	    transformBlock(originalNextSiblingKey, blocks, function (block) {
	      return block.merge({
	        prevSibling: originalPrevSiblingKey
	      });
	    }); // update new next
	
	    transformBlock(newNextSiblingKey, blocks, function (block) {
	      return block.merge({
	        prevSibling: originalBlockKey
	      });
	    }); // update new prev
	
	    transformBlock(newPrevSiblingKey, blocks, function (block) {
	      return block.merge({
	        nextSibling: originalBlockKey
	      });
	    }); // update new parent
	
	    transformBlock(newParentKey, blocks, function (block) {
	      var newParentChildrenList = block.getChildKeys();
	      var targetBlockIndex = newParentChildrenList.indexOf(originalTargetKey);
	      var insertionIndex = isInsertedAfterTarget ? targetBlockIndex + 1 : targetBlockIndex !== 0 ? targetBlockIndex - 1 : 0;
	      var newChildrenArray = newParentChildrenList.toArray();
	      newChildrenArray.splice(insertionIndex, 0, originalBlockKey);
	      return block.merge({
	        children: List(newChildrenArray)
	      });
	    }); // update block
	
	    transformBlock(originalBlockKey, blocks, function (block) {
	      return block.merge({
	        nextSibling: newNextSiblingKey,
	        prevSibling: newPrevSiblingKey,
	        parent: newParentKey
	      });
	    });
	  });
	};
	
	var moveBlockInContentState = function moveBlockInContentState(contentState, blockToBeMoved, targetBlock, insertionMode) {
	  !(insertionMode !== 'replace') ?  false ? invariant(false, 'Replacing blocks is not supported.') : invariant(false) : void 0;
	  var targetKey = targetBlock.getKey();
	  var blockKey = blockToBeMoved.getKey();
	  !(blockKey !== targetKey) ?  false ? invariant(false, 'Block cannot be moved next to itself.') : invariant(false) : void 0;
	  var blockMap = contentState.getBlockMap();
	  var isExperimentalTreeBlock = blockToBeMoved instanceof ContentBlockNode;
	  var blocksToBeMoved = [blockToBeMoved];
	  var blockMapWithoutBlocksToBeMoved = blockMap["delete"](blockKey);
	
	  if (isExperimentalTreeBlock) {
	    blocksToBeMoved = [];
	    blockMapWithoutBlocksToBeMoved = blockMap.withMutations(function (blocks) {
	      var nextSiblingKey = blockToBeMoved.getNextSiblingKey();
	      var nextDelimiterBlockKey = getNextDelimiterBlockKey(blockToBeMoved, blocks);
	      blocks.toSeq().skipUntil(function (block) {
	        return block.getKey() === blockKey;
	      }).takeWhile(function (block) {
	        var key = block.getKey();
	        var isBlockToBeMoved = key === blockKey;
	        var hasNextSiblingAndIsNotNextSibling = nextSiblingKey && key !== nextSiblingKey;
	        var doesNotHaveNextSiblingAndIsNotDelimiter = !nextSiblingKey && block.getParentKey() && (!nextDelimiterBlockKey || key !== nextDelimiterBlockKey);
	        return !!(isBlockToBeMoved || hasNextSiblingAndIsNotNextSibling || doesNotHaveNextSiblingAndIsNotDelimiter);
	      }).forEach(function (block) {
	        blocksToBeMoved.push(block);
	        blocks["delete"](block.getKey());
	      });
	    });
	  }
	
	  var blocksBefore = blockMapWithoutBlocksToBeMoved.toSeq().takeUntil(function (v) {
	    return v === targetBlock;
	  });
	  var blocksAfter = blockMapWithoutBlocksToBeMoved.toSeq().skipUntil(function (v) {
	    return v === targetBlock;
	  }).skip(1);
	  var slicedBlocks = blocksToBeMoved.map(function (block) {
	    return [block.getKey(), block];
	  });
	  var newBlocks = OrderedMap();
	
	  if (insertionMode === 'before') {
	    var blockBefore = contentState.getBlockBefore(targetKey);
	    !(!blockBefore || blockBefore.getKey() !== blockToBeMoved.getKey()) ?  false ? invariant(false, 'Block cannot be moved next to itself.') : invariant(false) : void 0;
	    newBlocks = blocksBefore.concat([].concat(slicedBlocks, [[targetKey, targetBlock]]), blocksAfter).toOrderedMap();
	  } else if (insertionMode === 'after') {
	    var blockAfter = contentState.getBlockAfter(targetKey);
	    !(!blockAfter || blockAfter.getKey() !== blockKey) ?  false ? invariant(false, 'Block cannot be moved next to itself.') : invariant(false) : void 0;
	    newBlocks = blocksBefore.concat([[targetKey, targetBlock]].concat(slicedBlocks), blocksAfter).toOrderedMap();
	  }
	
	  return contentState.merge({
	    blockMap: updateBlockMapLinks(newBlocks, blockToBeMoved, targetBlock, insertionMode, isExperimentalTreeBlock),
	    selectionBefore: contentState.getSelectionAfter(),
	    selectionAfter: contentState.getSelectionAfter().merge({
	      anchorKey: blockKey,
	      focusKey: blockKey
	    })
	  });
	};
	
	module.exports = moveBlockInContentState;

/***/ },
/* 1249 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	var ContentBlockNode = __webpack_require__(71);
	
	var getNextDelimiterBlockKey = __webpack_require__(408);
	
	var Immutable = __webpack_require__(27);
	
	var List = Immutable.List,
	    Map = Immutable.Map;
	
	var transformBlock = function transformBlock(key, blockMap, func) {
	  if (!key) {
	    return;
	  }
	
	  var block = blockMap.get(key);
	
	  if (!block) {
	    return;
	  }
	
	  blockMap.set(key, func(block));
	};
	/**
	 * Ancestors needs to be preserved when there are non selected
	 * children to make sure we do not leave any orphans behind
	 */
	
	
	var getAncestorsKeys = function getAncestorsKeys(blockKey, blockMap) {
	  var parents = [];
	
	  if (!blockKey) {
	    return parents;
	  }
	
	  var blockNode = blockMap.get(blockKey);
	
	  while (blockNode && blockNode.getParentKey()) {
	    var parentKey = blockNode.getParentKey();
	
	    if (parentKey) {
	      parents.push(parentKey);
	    }
	
	    blockNode = parentKey ? blockMap.get(parentKey) : null;
	  }
	
	  return parents;
	};
	/**
	 * Get all next delimiter keys until we hit a root delimiter and return
	 * an array of key references
	 */
	
	
	var getNextDelimitersBlockKeys = function getNextDelimitersBlockKeys(block, blockMap) {
	  var nextDelimiters = [];
	
	  if (!block) {
	    return nextDelimiters;
	  }
	
	  var nextDelimiter = getNextDelimiterBlockKey(block, blockMap);
	
	  while (nextDelimiter && blockMap.get(nextDelimiter)) {
	    var _block = blockMap.get(nextDelimiter);
	
	    nextDelimiters.push(nextDelimiter); // we do not need to keep checking all root node siblings, just the first occurance
	
	    nextDelimiter = _block.getParentKey() ? getNextDelimiterBlockKey(_block, blockMap) : null;
	  }
	
	  return nextDelimiters;
	};
	
	var getNextValidSibling = function getNextValidSibling(block, blockMap, originalBlockMap) {
	  if (!block) {
	    return null;
	  } // note that we need to make sure we refer to the original block since this
	  // function is called within a withMutations
	
	
	  var nextValidSiblingKey = originalBlockMap.get(block.getKey()).getNextSiblingKey();
	
	  while (nextValidSiblingKey && !blockMap.get(nextValidSiblingKey)) {
	    nextValidSiblingKey = originalBlockMap.get(nextValidSiblingKey).getNextSiblingKey() || null;
	  }
	
	  return nextValidSiblingKey;
	};
	
	var getPrevValidSibling = function getPrevValidSibling(block, blockMap, originalBlockMap) {
	  if (!block) {
	    return null;
	  } // note that we need to make sure we refer to the original block since this
	  // function is called within a withMutations
	
	
	  var prevValidSiblingKey = originalBlockMap.get(block.getKey()).getPrevSiblingKey();
	
	  while (prevValidSiblingKey && !blockMap.get(prevValidSiblingKey)) {
	    prevValidSiblingKey = originalBlockMap.get(prevValidSiblingKey).getPrevSiblingKey() || null;
	  }
	
	  return prevValidSiblingKey;
	};
	
	var updateBlockMapLinks = function updateBlockMapLinks(blockMap, startBlock, endBlock, originalBlockMap) {
	  return blockMap.withMutations(function (blocks) {
	    // update start block if its retained
	    transformBlock(startBlock.getKey(), blocks, function (block) {
	      return block.merge({
	        nextSibling: getNextValidSibling(block, blocks, originalBlockMap),
	        prevSibling: getPrevValidSibling(block, blocks, originalBlockMap)
	      });
	    }); // update endblock if its retained
	
	    transformBlock(endBlock.getKey(), blocks, function (block) {
	      return block.merge({
	        nextSibling: getNextValidSibling(block, blocks, originalBlockMap),
	        prevSibling: getPrevValidSibling(block, blocks, originalBlockMap)
	      });
	    }); // update start block parent ancestors
	
	    getAncestorsKeys(startBlock.getKey(), originalBlockMap).forEach(function (parentKey) {
	      return transformBlock(parentKey, blocks, function (block) {
	        return block.merge({
	          children: block.getChildKeys().filter(function (key) {
	            return blocks.get(key);
	          }),
	          nextSibling: getNextValidSibling(block, blocks, originalBlockMap),
	          prevSibling: getPrevValidSibling(block, blocks, originalBlockMap)
	        });
	      });
	    }); // update start block next - can only happen if startBlock == endBlock
	
	    transformBlock(startBlock.getNextSiblingKey(), blocks, function (block) {
	      return block.merge({
	        prevSibling: startBlock.getPrevSiblingKey()
	      });
	    }); // update start block prev
	
	    transformBlock(startBlock.getPrevSiblingKey(), blocks, function (block) {
	      return block.merge({
	        nextSibling: getNextValidSibling(block, blocks, originalBlockMap)
	      });
	    }); // update end block next
	
	    transformBlock(endBlock.getNextSiblingKey(), blocks, function (block) {
	      return block.merge({
	        prevSibling: getPrevValidSibling(block, blocks, originalBlockMap)
	      });
	    }); // update end block prev
	
	    transformBlock(endBlock.getPrevSiblingKey(), blocks, function (block) {
	      return block.merge({
	        nextSibling: endBlock.getNextSiblingKey()
	      });
	    }); // update end block parent ancestors
	
	    getAncestorsKeys(endBlock.getKey(), originalBlockMap).forEach(function (parentKey) {
	      transformBlock(parentKey, blocks, function (block) {
	        return block.merge({
	          children: block.getChildKeys().filter(function (key) {
	            return blocks.get(key);
	          }),
	          nextSibling: getNextValidSibling(block, blocks, originalBlockMap),
	          prevSibling: getPrevValidSibling(block, blocks, originalBlockMap)
	        });
	      });
	    }); // update next delimiters all the way to a root delimiter
	
	    getNextDelimitersBlockKeys(endBlock, originalBlockMap).forEach(function (delimiterKey) {
	      return transformBlock(delimiterKey, blocks, function (block) {
	        return block.merge({
	          nextSibling: getNextValidSibling(block, blocks, originalBlockMap),
	          prevSibling: getPrevValidSibling(block, blocks, originalBlockMap)
	        });
	      });
	    }); // if parent (startBlock) was deleted
	
	    if (blockMap.get(startBlock.getKey()) == null && blockMap.get(endBlock.getKey()) != null && endBlock.getParentKey() === startBlock.getKey() && endBlock.getPrevSiblingKey() == null) {
	      var prevSiblingKey = startBlock.getPrevSiblingKey(); // endBlock becomes next sibling of parent's prevSibling
	
	      transformBlock(endBlock.getKey(), blocks, function (block) {
	        return block.merge({
	          prevSibling: prevSiblingKey
	        });
	      });
	      transformBlock(prevSiblingKey, blocks, function (block) {
	        return block.merge({
	          nextSibling: endBlock.getKey()
	        });
	      }); // Update parent for previous parent's children, and children for that parent
	
	      var prevSibling = prevSiblingKey ? blockMap.get(prevSiblingKey) : null;
	      var newParentKey = prevSibling ? prevSibling.getParentKey() : null;
	      startBlock.getChildKeys().forEach(function (childKey) {
	        transformBlock(childKey, blocks, function (block) {
	          return block.merge({
	            parent: newParentKey // set to null if there is no parent
	
	          });
	        });
	      });
	
	      if (newParentKey != null) {
	        var newParent = blockMap.get(newParentKey);
	        transformBlock(newParentKey, blocks, function (block) {
	          return block.merge({
	            children: newParent.getChildKeys().concat(startBlock.getChildKeys())
	          });
	        });
	      } // last child of deleted parent should point to next sibling
	
	
	      transformBlock(startBlock.getChildKeys().find(function (key) {
	        var block = blockMap.get(key);
	        return block.getNextSiblingKey() === null;
	      }), blocks, function (block) {
	        return block.merge({
	          nextSibling: startBlock.getNextSiblingKey()
	        });
	      });
	    }
	  });
	};
	
	var removeRangeFromContentState = function removeRangeFromContentState(contentState, selectionState) {
	  if (selectionState.isCollapsed()) {
	    return contentState;
	  }
	
	  var blockMap = contentState.getBlockMap();
	  var startKey = selectionState.getStartKey();
	  var startOffset = selectionState.getStartOffset();
	  var endKey = selectionState.getEndKey();
	  var endOffset = selectionState.getEndOffset();
	  var startBlock = blockMap.get(startKey);
	  var endBlock = blockMap.get(endKey); // we assume that ContentBlockNode and ContentBlocks are not mixed together
	
	  var isExperimentalTreeBlock = startBlock instanceof ContentBlockNode; // used to retain blocks that should not be deleted to avoid orphan children
	
	  var parentAncestors = [];
	
	  if (isExperimentalTreeBlock) {
	    var endBlockchildrenKeys = endBlock.getChildKeys();
	    var endBlockAncestors = getAncestorsKeys(endKey, blockMap); // endBlock has unselected siblings so we can not remove its ancestors parents
	
	    if (endBlock.getNextSiblingKey()) {
	      parentAncestors = parentAncestors.concat(endBlockAncestors);
	    } // endBlock has children so can not remove this block or any of its ancestors
	
	
	    if (!endBlockchildrenKeys.isEmpty()) {
	      parentAncestors = parentAncestors.concat(endBlockAncestors.concat([endKey]));
	    } // we need to retain all ancestors of the next delimiter block
	
	
	    parentAncestors = parentAncestors.concat(getAncestorsKeys(getNextDelimiterBlockKey(endBlock, blockMap), blockMap));
	  }
	
	  var characterList;
	
	  if (startBlock === endBlock) {
	    characterList = removeFromList(startBlock.getCharacterList(), startOffset, endOffset);
	  } else {
	    characterList = startBlock.getCharacterList().slice(0, startOffset).concat(endBlock.getCharacterList().slice(endOffset));
	  }
	
	  var modifiedStart = startBlock.merge({
	    text: startBlock.getText().slice(0, startOffset) + endBlock.getText().slice(endOffset),
	    characterList: characterList
	  }); // If cursor (collapsed) is at the start of the first child, delete parent
	  // instead of child
	
	  var shouldDeleteParent = isExperimentalTreeBlock && startOffset === 0 && endOffset === 0 && endBlock.getParentKey() === startKey && endBlock.getPrevSiblingKey() == null;
	  var newBlocks = shouldDeleteParent ? Map([[startKey, null]]) : blockMap.toSeq().skipUntil(function (_, k) {
	    return k === startKey;
	  }).takeUntil(function (_, k) {
	    return k === endKey;
	  }).filter(function (_, k) {
	    return parentAncestors.indexOf(k) === -1;
	  }).concat(Map([[endKey, null]])).map(function (_, k) {
	    return k === startKey ? modifiedStart : null;
	  });
	  var updatedBlockMap = blockMap.merge(newBlocks).filter(function (block) {
	    return !!block;
	  }); // Only update tree block pointers if the range is across blocks
	
	  if (isExperimentalTreeBlock && startBlock !== endBlock) {
	    updatedBlockMap = updateBlockMapLinks(updatedBlockMap, startBlock, endBlock, blockMap);
	  }
	
	  return contentState.merge({
	    blockMap: updatedBlockMap,
	    selectionBefore: selectionState,
	    selectionAfter: selectionState.merge({
	      anchorKey: startKey,
	      anchorOffset: startOffset,
	      focusKey: startKey,
	      focusOffset: startOffset,
	      isBackward: false
	    })
	  });
	};
	/**
	 * Maintain persistence for target list when removing characters on the
	 * head and tail of the character list.
	 */
	
	
	var removeFromList = function removeFromList(targetList, startOffset, endOffset) {
	  if (startOffset === 0) {
	    while (startOffset < endOffset) {
	      targetList = targetList.shift();
	      startOffset++;
	    }
	  } else if (endOffset === targetList.count()) {
	    while (endOffset > startOffset) {
	      targetList = targetList.pop();
	      endOffset--;
	    }
	  } else {
	    var head = targetList.slice(0, startOffset);
	    var tail = targetList.slice(endOffset);
	    targetList = head.concat(tail).toList();
	  }
	
	  return targetList;
	};
	
	module.exports = removeRangeFromContentState;

/***/ },
/* 1250 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	var DraftEffects = __webpack_require__(394);
	
	var DraftJsDebugLogging = __webpack_require__(396);
	
	var UserAgent = __webpack_require__(60);
	
	var containsNode = __webpack_require__(270);
	
	var getActiveElement = __webpack_require__(430);
	
	var getCorrectDocumentFromNode = __webpack_require__(194);
	
	var invariant = __webpack_require__(32);
	
	var isElement = __webpack_require__(105);
	
	var isIE = UserAgent.isBrowser('IE');
	
	function getAnonymizedDOM(node, getNodeLabels) {
	  if (!node) {
	    return '[empty]';
	  }
	
	  var anonymized = anonymizeTextWithin(node, getNodeLabels);
	
	  if (anonymized.nodeType === Node.TEXT_NODE) {
	    return anonymized.textContent;
	  }
	
	  !isElement(anonymized) ?  false ? invariant(false, 'Node must be an Element if it is not a text node.') : invariant(false) : void 0;
	  var castedElement = anonymized;
	  return castedElement.outerHTML;
	}
	
	function anonymizeTextWithin(node, getNodeLabels) {
	  var labels = getNodeLabels !== undefined ? getNodeLabels(node) : [];
	
	  if (node.nodeType === Node.TEXT_NODE) {
	    var length = node.textContent.length;
	    return getCorrectDocumentFromNode(node).createTextNode('[text ' + length + (labels.length ? ' | ' + labels.join(', ') : '') + ']');
	  }
	
	  var clone = node.cloneNode();
	
	  if (clone.nodeType === 1 && labels.length) {
	    clone.setAttribute('data-labels', labels.join(', '));
	  }
	
	  var childNodes = node.childNodes;
	
	  for (var ii = 0; ii < childNodes.length; ii++) {
	    clone.appendChild(anonymizeTextWithin(childNodes[ii], getNodeLabels));
	  }
	
	  return clone;
	}
	
	function getAnonymizedEditorDOM(node, getNodeLabels) {
	  // grabbing the DOM content of the Draft editor
	  var currentNode = node; // this should only be used after checking with isElement
	
	  var castedNode = currentNode;
	
	  while (currentNode) {
	    if (isElement(currentNode) && castedNode.hasAttribute('contenteditable')) {
	      // found the Draft editor container
	      return getAnonymizedDOM(currentNode, getNodeLabels);
	    } else {
	      currentNode = currentNode.parentNode;
	      castedNode = currentNode;
	    }
	  }
	
	  return 'Could not find contentEditable parent of node';
	}
	
	function getNodeLength(node) {
	  return node.nodeValue === null ? node.childNodes.length : node.nodeValue.length;
	}
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 */
	
	
	function setDraftEditorSelection(selectionState, node, blockKey, nodeStart, nodeEnd) {
	  // It's possible that the editor has been removed from the DOM but
	  // our selection code doesn't know it yet. Forcing selection in
	  // this case may lead to errors, so just bail now.
	  var documentObject = getCorrectDocumentFromNode(node);
	
	  if (!containsNode(documentObject.documentElement, node)) {
	    return;
	  }
	
	  var selection = documentObject.defaultView.getSelection();
	  var anchorKey = selectionState.getAnchorKey();
	  var anchorOffset = selectionState.getAnchorOffset();
	  var focusKey = selectionState.getFocusKey();
	  var focusOffset = selectionState.getFocusOffset();
	  var isBackward = selectionState.getIsBackward(); // IE doesn't support backward selection. Swap key/offset pairs.
	
	  if (!selection.extend && isBackward) {
	    var tempKey = anchorKey;
	    var tempOffset = anchorOffset;
	    anchorKey = focusKey;
	    anchorOffset = focusOffset;
	    focusKey = tempKey;
	    focusOffset = tempOffset;
	    isBackward = false;
	  }
	
	  var hasAnchor = anchorKey === blockKey && nodeStart <= anchorOffset && nodeEnd >= anchorOffset;
	  var hasFocus = focusKey === blockKey && nodeStart <= focusOffset && nodeEnd >= focusOffset; // If the selection is entirely bound within this node, set the selection
	  // and be done.
	
	  if (hasAnchor && hasFocus) {
	    selection.removeAllRanges();
	    addPointToSelection(selection, node, anchorOffset - nodeStart, selectionState);
	    addFocusToSelection(selection, node, focusOffset - nodeStart, selectionState);
	    return;
	  }
	
	  if (!isBackward) {
	    // If the anchor is within this node, set the range start.
	    if (hasAnchor) {
	      selection.removeAllRanges();
	      addPointToSelection(selection, node, anchorOffset - nodeStart, selectionState);
	    } // If the focus is within this node, we can assume that we have
	    // already set the appropriate start range on the selection, and
	    // can simply extend the selection.
	
	
	    if (hasFocus) {
	      addFocusToSelection(selection, node, focusOffset - nodeStart, selectionState);
	    }
	  } else {
	    // If this node has the focus, set the selection range to be a
	    // collapsed range beginning here. Later, when we encounter the anchor,
	    // we'll use this information to extend the selection.
	    if (hasFocus) {
	      selection.removeAllRanges();
	      addPointToSelection(selection, node, focusOffset - nodeStart, selectionState);
	    } // If this node has the anchor, we may assume that the correct
	    // focus information is already stored on the selection object.
	    // We keep track of it, reset the selection range, and extend it
	    // back to the focus point.
	
	
	    if (hasAnchor) {
	      var storedFocusNode = selection.focusNode;
	      var storedFocusOffset = selection.focusOffset;
	      selection.removeAllRanges();
	      addPointToSelection(selection, node, anchorOffset - nodeStart, selectionState);
	      addFocusToSelection(selection, storedFocusNode, storedFocusOffset, selectionState);
	    }
	  }
	}
	/**
	 * Extend selection towards focus point.
	 */
	
	
	function addFocusToSelection(selection, node, offset, selectionState) {
	  var activeElement = getActiveElement();
	  var extend = selection.extend; // containsNode returns false if node is null.
	  // Let's refine the type of this value out here so flow knows.
	
	  if (extend && node != null && containsNode(activeElement, node)) {
	    // If `extend` is called while another element has focus, an error is
	    // thrown. We therefore disable `extend` if the active element is somewhere
	    // other than the node we are selecting. This should only occur in Firefox,
	    // since it is the only browser to support multiple selections.
	    // See https://bugzilla.mozilla.org/show_bug.cgi?id=921444.
	    // logging to catch bug that is being reported in t16250795
	    if (offset > getNodeLength(node)) {
	      // the call to 'selection.extend' is about to throw
	      DraftJsDebugLogging.logSelectionStateFailure({
	        anonymizedDom: getAnonymizedEditorDOM(node),
	        extraParams: JSON.stringify({
	          offset: offset
	        }),
	        selectionState: JSON.stringify(selectionState.toJS())
	      });
	    } // logging to catch bug that is being reported in t18110632
	
	
	    var nodeWasFocus = node === selection.focusNode;
	
	    try {
	      // Fixes some reports of "InvalidStateError: Failed to execute 'extend' on
	      // 'Selection': This Selection object doesn't have any Ranges."
	      // Note: selection.extend does not exist in IE.
	      if (selection.rangeCount > 0 && selection.extend) {
	        selection.extend(node, offset);
	      }
	    } catch (e) {
	      DraftJsDebugLogging.logSelectionStateFailure({
	        anonymizedDom: getAnonymizedEditorDOM(node, function (n) {
	          var labels = [];
	
	          if (n === activeElement) {
	            labels.push('active element');
	          }
	
	          if (n === selection.anchorNode) {
	            labels.push('selection anchor node');
	          }
	
	          if (n === selection.focusNode) {
	            labels.push('selection focus node');
	          }
	
	          return labels;
	        }),
	        extraParams: JSON.stringify({
	          activeElementName: activeElement ? activeElement.nodeName : null,
	          nodeIsFocus: node === selection.focusNode,
	          nodeWasFocus: nodeWasFocus,
	          selectionRangeCount: selection.rangeCount,
	          selectionAnchorNodeName: selection.anchorNode ? selection.anchorNode.nodeName : null,
	          selectionAnchorOffset: selection.anchorOffset,
	          selectionFocusNodeName: selection.focusNode ? selection.focusNode.nodeName : null,
	          selectionFocusOffset: selection.focusOffset,
	          message: e ? '' + e : null,
	          offset: offset
	        }, null, 2),
	        selectionState: JSON.stringify(selectionState.toJS(), null, 2)
	      }); // allow the error to be thrown -
	      // better than continuing in a broken state
	
	      throw e;
	    }
	  } else {
	    // IE doesn't support extend. This will mean no backward selection.
	    // Extract the existing selection range and add focus to it.
	    // Additionally, clone the selection range. IE11 throws an
	    // InvalidStateError when attempting to access selection properties
	    // after the range is detached.
	    if (node && selection.rangeCount > 0) {
	      var range = selection.getRangeAt(0);
	      range.setEnd(node, offset);
	      selection.addRange(range.cloneRange());
	    }
	  }
	}
	
	function addPointToSelection(selection, node, offset, selectionState) {
	  var range = getCorrectDocumentFromNode(node).createRange(); // logging to catch bug that is being reported in t16250795
	
	  if (offset > getNodeLength(node)) {
	    // in this case we know that the call to 'range.setStart' is about to throw
	    DraftJsDebugLogging.logSelectionStateFailure({
	      anonymizedDom: getAnonymizedEditorDOM(node),
	      extraParams: JSON.stringify({
	        offset: offset
	      }),
	      selectionState: JSON.stringify(selectionState.toJS())
	    });
	    DraftEffects.handleExtensionCausedError();
	  }
	
	  range.setStart(node, offset); // IE sometimes throws Unspecified Error when trying to addRange
	
	  if (isIE) {
	    try {
	      selection.addRange(range);
	    } catch (e) {
	      if (false) {
	        /* eslint-disable-next-line no-console */
	        console.warn('Call to selection.addRange() threw exception: ', e);
	      }
	    }
	  } else {
	    selection.addRange(range);
	  }
	}
	
	module.exports = {
	  setDraftEditorSelection: setDraftEditorSelection,
	  addFocusToSelection: addFocusToSelection
	};

/***/ },
/* 1251 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	var ContentBlockNode = __webpack_require__(71);
	
	var generateRandomKey = __webpack_require__(85);
	
	var Immutable = __webpack_require__(27);
	
	var invariant = __webpack_require__(32);
	
	var modifyBlockForContentState = __webpack_require__(419);
	
	var List = Immutable.List,
	    Map = Immutable.Map;
	
	var transformBlock = function transformBlock(key, blockMap, func) {
	  if (!key) {
	    return;
	  }
	
	  var block = blockMap.get(key);
	
	  if (!block) {
	    return;
	  }
	
	  blockMap.set(key, func(block));
	};
	
	var updateBlockMapLinks = function updateBlockMapLinks(blockMap, originalBlock, belowBlock) {
	  return blockMap.withMutations(function (blocks) {
	    var originalBlockKey = originalBlock.getKey();
	    var belowBlockKey = belowBlock.getKey(); // update block parent
	
	    transformBlock(originalBlock.getParentKey(), blocks, function (block) {
	      var parentChildrenList = block.getChildKeys();
	      var insertionIndex = parentChildrenList.indexOf(originalBlockKey) + 1;
	      var newChildrenArray = parentChildrenList.toArray();
	      newChildrenArray.splice(insertionIndex, 0, belowBlockKey);
	      return block.merge({
	        children: List(newChildrenArray)
	      });
	    }); // update original next block
	
	    transformBlock(originalBlock.getNextSiblingKey(), blocks, function (block) {
	      return block.merge({
	        prevSibling: belowBlockKey
	      });
	    }); // update original block
	
	    transformBlock(originalBlockKey, blocks, function (block) {
	      return block.merge({
	        nextSibling: belowBlockKey
	      });
	    }); // update below block
	
	    transformBlock(belowBlockKey, blocks, function (block) {
	      return block.merge({
	        prevSibling: originalBlockKey
	      });
	    });
	  });
	};
	
	var splitBlockInContentState = function splitBlockInContentState(contentState, selectionState) {
	  !selectionState.isCollapsed() ?  false ? invariant(false, 'Selection range must be collapsed.') : invariant(false) : void 0;
	  var key = selectionState.getAnchorKey();
	  var blockMap = contentState.getBlockMap();
	  var blockToSplit = blockMap.get(key);
	  var text = blockToSplit.getText();
	
	  if (!text) {
	    var blockType = blockToSplit.getType();
	
	    if (blockType === 'unordered-list-item' || blockType === 'ordered-list-item') {
	      return modifyBlockForContentState(contentState, selectionState, function (block) {
	        return block.merge({
	          type: 'unstyled',
	          depth: 0
	        });
	      });
	    }
	  }
	
	  var offset = selectionState.getAnchorOffset();
	  var chars = blockToSplit.getCharacterList();
	  var keyBelow = generateRandomKey();
	  var isExperimentalTreeBlock = blockToSplit instanceof ContentBlockNode;
	  var blockAbove = blockToSplit.merge({
	    text: text.slice(0, offset),
	    characterList: chars.slice(0, offset)
	  });
	  var blockBelow = blockAbove.merge({
	    key: keyBelow,
	    text: text.slice(offset),
	    characterList: chars.slice(offset),
	    data: Map()
	  });
	  var blocksBefore = blockMap.toSeq().takeUntil(function (v) {
	    return v === blockToSplit;
	  });
	  var blocksAfter = blockMap.toSeq().skipUntil(function (v) {
	    return v === blockToSplit;
	  }).rest();
	  var newBlocks = blocksBefore.concat([[key, blockAbove], [keyBelow, blockBelow]], blocksAfter).toOrderedMap();
	
	  if (isExperimentalTreeBlock) {
	    !blockToSplit.getChildKeys().isEmpty() ?  false ? invariant(false, 'ContentBlockNode must not have children') : invariant(false) : void 0;
	    newBlocks = updateBlockMapLinks(newBlocks, blockAbove, blockBelow);
	  }
	
	  return contentState.merge({
	    blockMap: newBlocks,
	    selectionBefore: selectionState,
	    selectionAfter: selectionState.merge({
	      anchorKey: keyBelow,
	      anchorOffset: 0,
	      focusKey: keyBelow,
	      focusOffset: 0,
	      isBackward: false
	    })
	  });
	};
	
	module.exports = splitBlockInContentState;

/***/ },
/* 1252 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @format
	 * 
	 * @emails oncall+draft_js
	 */
	'use strict';
	
	var NEWLINE_REGEX = /\r\n?|\n/g;
	
	function splitTextIntoTextBlocks(text) {
	  return text.split(NEWLINE_REGEX);
	}
	
	module.exports = splitTextIntoTextBlocks;

/***/ },
/* 1253 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright 2004-present Facebook. All Rights Reserved.
	 *
	 * @typechecks
	 * 
	 * @format
	 */
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Based on the rfc4122-compliant solution posted at
	 * http://stackoverflow.com/questions/105034
	 */
	function uuid() {
	  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
	    var r = Math.random() * 16 | 0;
	    var v = c == 'x' ? r : r & 0x3 | 0x8;
	    return v.toString(16);
	  });
	}
	
	module.exports = uuid;

/***/ },
/* 1254 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var callBind = __webpack_require__(251);
	var gOPD = __webpack_require__(125);
	
	var hasProtoAccessor;
	try {
		// eslint-disable-next-line no-extra-parens, no-proto
		hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ ([]).__proto__ === Array.prototype;
	} catch (e) {
		if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') {
			throw e;
		}
	}
	
	// eslint-disable-next-line no-extra-parens
	var desc = !!hasProtoAccessor && gOPD && gOPD(Object.prototype, /** @type {keyof typeof Object.prototype} */ ('__proto__'));
	
	var $Object = Object;
	var $getPrototypeOf = $Object.getPrototypeOf;
	
	/** @type {import('./get')} */
	module.exports = desc && typeof desc.get === 'function'
		? callBind([desc.get])
		: typeof $getPrototypeOf === 'function'
			? /** @type {import('./get')} */ function getDunder(value) {
				// eslint-disable-next-line eqeqeq
				return $getPrototypeOf(value == null ? value : $Object(value));
			}
			: false;


/***/ },
/* 1255 */
/***/ function(module, exports, __webpack_require__) {

	var QueryHandler = __webpack_require__(1257);
	var each = __webpack_require__(424).each;
	
	/**
	 * Represents a single media query, manages it's state and registered handlers for this query
	 *
	 * @constructor
	 * @param {string} query the media query string
	 * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
	 */
	function MediaQuery(query, isUnconditional) {
	    this.query = query;
	    this.isUnconditional = isUnconditional;
	    this.handlers = [];
	    this.mql = window.matchMedia(query);
	
	    var self = this;
	    this.listener = function(mql) {
	        // Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
	        self.mql = mql.currentTarget || mql;
	        self.assess();
	    };
	    this.mql.addListener(this.listener);
	}
	
	MediaQuery.prototype = {
	
	    constuctor : MediaQuery,
	
	    /**
	     * add a handler for this query, triggering if already active
	     *
	     * @param {object} handler
	     * @param {function} handler.match callback for when query is activated
	     * @param {function} [handler.unmatch] callback for when query is deactivated
	     * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
	     * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
	     */
	    addHandler : function(handler) {
	        var qh = new QueryHandler(handler);
	        this.handlers.push(qh);
	
	        this.matches() && qh.on();
	    },
	
	    /**
	     * removes the given handler from the collection, and calls it's destroy methods
	     *
	     * @param {object || function} handler the handler to remove
	     */
	    removeHandler : function(handler) {
	        var handlers = this.handlers;
	        each(handlers, function(h, i) {
	            if(h.equals(handler)) {
	                h.destroy();
	                return !handlers.splice(i,1); //remove from array and exit each early
	            }
	        });
	    },
	
	    /**
	     * Determine whether the media query should be considered a match
	     *
	     * @return {Boolean} true if media query can be considered a match, false otherwise
	     */
	    matches : function() {
	        return this.mql.matches || this.isUnconditional;
	    },
	
	    /**
	     * Clears all handlers and unbinds events
	     */
	    clear : function() {
	        each(this.handlers, function(handler) {
	            handler.destroy();
	        });
	        this.mql.removeListener(this.listener);
	        this.handlers.length = 0; //clear array
	    },
	
	    /*
	        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
	        */
	    assess : function() {
	        var action = this.matches() ? 'on' : 'off';
	
	        each(this.handlers, function(handler) {
	            handler[action]();
	        });
	    }
	};
	
	module.exports = MediaQuery;


/***/ },
/* 1256 */
/***/ function(module, exports, __webpack_require__) {

	var MediaQuery = __webpack_require__(1255);
	var Util = __webpack_require__(424);
	var each = Util.each;
	var isFunction = Util.isFunction;
	var isArray = Util.isArray;
	
	/**
	 * Allows for registration of query handlers.
	 * Manages the query handler's state and is responsible for wiring up browser events
	 *
	 * @constructor
	 */
	function MediaQueryDispatch () {
	    if(!window.matchMedia) {
	        throw new Error('matchMedia not present, legacy browsers require a polyfill');
	    }
	
	    this.queries = {};
	    this.browserIsIncapable = !window.matchMedia('only all').matches;
	}
	
	MediaQueryDispatch.prototype = {
	
	    constructor : MediaQueryDispatch,
	
	    /**
	     * Registers a handler for the given media query
	     *
	     * @param {string} q the media query
	     * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
	     * @param {function} options.match fired when query matched
	     * @param {function} [options.unmatch] fired when a query is no longer matched
	     * @param {function} [options.setup] fired when handler first triggered
	     * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
	     * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
	     */
	    register : function(q, options, shouldDegrade) {
	        var queries         = this.queries,
	            isUnconditional = shouldDegrade && this.browserIsIncapable;
	
	        if(!queries[q]) {
	            queries[q] = new MediaQuery(q, isUnconditional);
	        }
	
	        //normalise to object in an array
	        if(isFunction(options)) {
	            options = { match : options };
	        }
	        if(!isArray(options)) {
	            options = [options];
	        }
	        each(options, function(handler) {
	            if (isFunction(handler)) {
	                handler = { match : handler };
	            }
	            queries[q].addHandler(handler);
	        });
	
	        return this;
	    },
	
	    /**
	     * unregisters a query and all it's handlers, or a specific handler for a query
	     *
	     * @param {string} q the media query to target
	     * @param {object || function} [handler] specific handler to unregister
	     */
	    unregister : function(q, handler) {
	        var query = this.queries[q];
	
	        if(query) {
	            if(handler) {
	                query.removeHandler(handler);
	            }
	            else {
	                query.clear();
	                delete this.queries[q];
	            }
	        }
	
	        return this;
	    }
	};
	
	module.exports = MediaQueryDispatch;


/***/ },
/* 1257 */
/***/ function(module, exports) {

	/**
	 * Delegate to handle a media query being matched and unmatched.
	 *
	 * @param {object} options
	 * @param {function} options.match callback for when the media query is matched
	 * @param {function} [options.unmatch] callback for when the media query is unmatched
	 * @param {function} [options.setup] one-time callback triggered the first time a query is matched
	 * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
	 * @constructor
	 */
	function QueryHandler(options) {
	    this.options = options;
	    !options.deferSetup && this.setup();
	}
	
	QueryHandler.prototype = {
	
	    constructor : QueryHandler,
	
	    /**
	     * coordinates setup of the handler
	     *
	     * @function
	     */
	    setup : function() {
	        if(this.options.setup) {
	            this.options.setup();
	        }
	        this.initialised = true;
	    },
	
	    /**
	     * coordinates setup and triggering of the handler
	     *
	     * @function
	     */
	    on : function() {
	        !this.initialised && this.setup();
	        this.options.match && this.options.match();
	    },
	
	    /**
	     * coordinates the unmatch event for the handler
	     *
	     * @function
	     */
	    off : function() {
	        this.options.unmatch && this.options.unmatch();
	    },
	
	    /**
	     * called when a handler is to be destroyed.
	     * delegates to the destroy or unmatch callbacks, depending on availability.
	     *
	     * @function
	     */
	    destroy : function() {
	        this.options.destroy ? this.options.destroy() : this.off();
	    },
	
	    /**
	     * determines equality by reference.
	     * if object is supplied compare options, if function, compare match callback
	     *
	     * @function
	     * @param {object || function} [target] the target for comparison
	     */
	    equals : function(target) {
	        return this.options === target || this.options.match === target;
	    }
	
	};
	
	module.exports = QueryHandler;


/***/ },
/* 1258 */
/***/ function(module, exports, __webpack_require__) {

	var MediaQueryDispatch = __webpack_require__(1256);
	module.exports = new MediaQueryDispatch();


/***/ },
/* 1259 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./eval')} */
	module.exports = EvalError;


/***/ },
/* 1260 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./range')} */
	module.exports = RangeError;


/***/ },
/* 1261 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./ref')} */
	module.exports = ReferenceError;


/***/ },
/* 1262 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./uri')} */
	module.exports = URIError;


/***/ },
/* 1263 */
18,
/* 1264 */
18,
/* 1265 */
18,
/* 1266 */
18,
/* 1267 */
18,
/* 1268 */
18,
/* 1269 */
18,
/* 1270 */
18,
/* 1271 */
18,
/* 1272 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	var PhotosMimeType = {
	  isImage: function isImage(mimeString) {
	    return getParts(mimeString)[0] === 'image';
	  },
	  isJpeg: function isJpeg(mimeString) {
	    var parts = getParts(mimeString);
	    return PhotosMimeType.isImage(mimeString) && ( // see http://fburl.com/10972194
	    parts[1] === 'jpeg' || parts[1] === 'pjpeg');
	  }
	};
	
	function getParts(mimeString) {
	  return mimeString.split('/');
	}
	
	module.exports = PhotosMimeType;

/***/ },
/* 1273 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 * @stub
	 * 
	 */
	'use strict'; // \u00a1-\u00b1\u00b4-\u00b8\u00ba\u00bb\u00bf
	//             is latin supplement punctuation except fractions and superscript
	//             numbers
	// \u2010-\u2027\u2030-\u205e
	//             is punctuation from the general punctuation block:
	//             weird quotes, commas, bullets, dashes, etc.
	// \u30fb\u3001\u3002\u3008-\u3011\u3014-\u301f
	//             is CJK punctuation
	// \uff1a-\uff1f\uff01-\uff0f\uff3b-\uff40\uff5b-\uff65
	//             is some full-width/half-width punctuation
	// \u2E2E\u061f\u066a-\u066c\u061b\u060c\u060d\uFD3e\uFD3F
	//             is some Arabic punctuation marks
	// \u1801\u0964\u104a\u104b
	//             is misc. other language punctuation marks
	
	var PUNCTUATION = '[.,+*?$|#{}()\'\\^\\-\\[\\]\\\\\\/!@%"~=<>_:;' + "\u30FB\u3001\u3002\u3008-\u3011\u3014-\u301F\uFF1A-\uFF1F\uFF01-\uFF0F" + "\uFF3B-\uFF40\uFF5B-\uFF65\u2E2E\u061F\u066A-\u066C\u061B\u060C\u060D" + "\uFD3E\uFD3F\u1801\u0964\u104A\u104B\u2010-\u2027\u2030-\u205E" + "\xA1-\xB1\xB4-\xB8\xBA\xBB\xBF]";
	module.exports = {
	  getPunctuation: function getPunctuation() {
	    return PUNCTUATION;
	  }
	};

/***/ },
/* 1274 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	'use strict';
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var URI =
	/*#__PURE__*/
	function () {
	  function URI(uri) {
	    _defineProperty(this, "_uri", void 0);
	
	    this._uri = uri;
	  }
	
	  var _proto = URI.prototype;
	
	  _proto.toString = function toString() {
	    return this._uri;
	  };
	
	  return URI;
	}();
	
	module.exports = URI;

/***/ },
/* 1275 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 * 
	 */
	
	/**
	 * Stateful API for text direction detection
	 *
	 * This class can be used in applications where you need to detect the
	 * direction of a sequence of text blocks, where each direction shall be used
	 * as the fallback direction for the next one.
	 *
	 * NOTE: A default direction, if not provided, is set based on the global
	 *       direction, as defined by `UnicodeBidiDirection`.
	 *
	 * == Example ==
	 * ```
	 * var UnicodeBidiService = require('UnicodeBidiService');
	 *
	 * var bidiService = new UnicodeBidiService();
	 *
	 * ...
	 *
	 * bidiService.reset();
	 * for (var para in paragraphs) {
	 *   var dir = bidiService.getDirection(para);
	 *   ...
	 * }
	 * ```
	 *
	 * Part of our implementation of Unicode Bidirectional Algorithm (UBA)
	 * Unicode Standard Annex #9 (UAX9)
	 * http://www.unicode.org/reports/tr9/
	 */
	'use strict';
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var UnicodeBidi = __webpack_require__(269);
	
	var UnicodeBidiDirection = __webpack_require__(199);
	
	var invariant = __webpack_require__(32);
	
	var UnicodeBidiService =
	/*#__PURE__*/
	function () {
	  /**
	   * Stateful class for paragraph direction detection
	   *
	   * @param defaultDir  Default direction of the service
	   */
	  function UnicodeBidiService(defaultDir) {
	    _defineProperty(this, "_defaultDir", void 0);
	
	    _defineProperty(this, "_lastDir", void 0);
	
	    if (!defaultDir) {
	      defaultDir = UnicodeBidiDirection.getGlobalDir();
	    } else {
	      !UnicodeBidiDirection.isStrong(defaultDir) ?  false ? invariant(false, 'Default direction must be a strong direction (LTR or RTL)') : invariant(false) : void 0;
	    }
	
	    this._defaultDir = defaultDir;
	    this.reset();
	  }
	  /**
	   * Reset the internal state
	   *
	   * Instead of creating a new instance, you can just reset() your instance
	   * everytime you start a new loop.
	   */
	
	
	  var _proto = UnicodeBidiService.prototype;
	
	  _proto.reset = function reset() {
	    this._lastDir = this._defaultDir;
	  };
	  /**
	   * Returns the direction of a block of text, and remembers it as the
	   * fall-back direction for the next paragraph.
	   *
	   * @param str  A text block, e.g. paragraph, table cell, tag
	   * @return     The resolved direction
	   */
	
	
	  _proto.getDirection = function getDirection(str) {
	    this._lastDir = UnicodeBidi.getDirection(str, this._lastDir);
	    return this._lastDir;
	  };
	
	  return UnicodeBidiService;
	}();
	
	module.exports = UnicodeBidiService;

/***/ },
/* 1276 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/**
	 * Usage note:
	 * This module makes a best effort to export the same data we would internally.
	 * At Facebook we use a server-generated module that does the parsing and
	 * exports the data for the client to use. We can't rely on a server-side
	 * implementation in open source so instead we make use of an open source
	 * library to do the heavy lifting and then make some adjustments as necessary.
	 * It's likely there will be some differences. Some we can smooth over.
	 * Others are going to be harder.
	 */
	'use strict';
	
	var UAParser = __webpack_require__(1629);
	
	var UNKNOWN = 'Unknown';
	var PLATFORM_MAP = {
	  'Mac OS': 'Mac OS X'
	};
	/**
	 * Convert from UAParser platform name to what we expect.
	 */
	
	function convertPlatformName(name) {
	  return PLATFORM_MAP[name] || name;
	}
	/**
	 * Get the version number in parts. This is very naive. We actually get major
	 * version as a part of UAParser already, which is generally good enough, but
	 * let's get the minor just in case.
	 */
	
	
	function getBrowserVersion(version) {
	  if (!version) {
	    return {
	      major: '',
	      minor: ''
	    };
	  }
	
	  var parts = version.split('.');
	  return {
	    major: parts[0],
	    minor: parts[1]
	  };
	}
	/**
	 * Get the UA data fom UAParser and then convert it to the format we're
	 * expecting for our APIS.
	 */
	
	
	var parser = new UAParser();
	var results = parser.getResult(); // Do some conversion first.
	
	var browserVersionData = getBrowserVersion(results.browser.version);
	var uaData = {
	  browserArchitecture: results.cpu.architecture || UNKNOWN,
	  browserFullVersion: results.browser.version || UNKNOWN,
	  browserMinorVersion: browserVersionData.minor || UNKNOWN,
	  browserName: results.browser.name || UNKNOWN,
	  browserVersion: results.browser.major || UNKNOWN,
	  deviceName: results.device.model || UNKNOWN,
	  engineName: results.engine.name || UNKNOWN,
	  engineVersion: results.engine.version || UNKNOWN,
	  platformArchitecture: results.cpu.architecture || UNKNOWN,
	  platformName: convertPlatformName(results.os.name) || UNKNOWN,
	  platformVersion: results.os.version || UNKNOWN,
	  platformFullVersion: results.os.version || UNKNOWN
	};
	module.exports = uaData;

/***/ },
/* 1277 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	'use strict';
	
	var invariant = __webpack_require__(32);
	
	var componentRegex = /\./;
	var orRegex = /\|\|/;
	var rangeRegex = /\s+\-\s+/;
	var modifierRegex = /^(<=|<|=|>=|~>|~|>|)?\s*(.+)/;
	var numericRegex = /^(\d*)(.*)/;
	/**
	 * Splits input `range` on "||" and returns true if any subrange matches
	 * `version`.
	 *
	 * @param {string} range
	 * @param {string} version
	 * @returns {boolean}
	 */
	
	function checkOrExpression(range, version) {
	  var expressions = range.split(orRegex);
	
	  if (expressions.length > 1) {
	    return expressions.some(function (range) {
	      return VersionRange.contains(range, version);
	    });
	  } else {
	    range = expressions[0].trim();
	    return checkRangeExpression(range, version);
	  }
	}
	/**
	 * Splits input `range` on " - " (the surrounding whitespace is required) and
	 * returns true if version falls between the two operands.
	 *
	 * @param {string} range
	 * @param {string} version
	 * @returns {boolean}
	 */
	
	
	function checkRangeExpression(range, version) {
	  var expressions = range.split(rangeRegex);
	  !(expressions.length > 0 && expressions.length <= 2) ?  false ? invariant(false, 'the "-" operator expects exactly 2 operands') : invariant(false) : void 0;
	
	  if (expressions.length === 1) {
	    return checkSimpleExpression(expressions[0], version);
	  } else {
	    var startVersion = expressions[0],
	        endVersion = expressions[1];
	    !(isSimpleVersion(startVersion) && isSimpleVersion(endVersion)) ?  false ? invariant(false, 'operands to the "-" operator must be simple (no modifiers)') : invariant(false) : void 0;
	    return checkSimpleExpression('>=' + startVersion, version) && checkSimpleExpression('<=' + endVersion, version);
	  }
	}
	/**
	 * Checks if `range` matches `version`. `range` should be a "simple" range (ie.
	 * not a compound range using the " - " or "||" operators).
	 *
	 * @param {string} range
	 * @param {string} version
	 * @returns {boolean}
	 */
	
	
	function checkSimpleExpression(range, version) {
	  range = range.trim();
	
	  if (range === '') {
	    return true;
	  }
	
	  var versionComponents = version.split(componentRegex);
	
	  var _getModifierAndCompon = getModifierAndComponents(range),
	      modifier = _getModifierAndCompon.modifier,
	      rangeComponents = _getModifierAndCompon.rangeComponents;
	
	  switch (modifier) {
	    case '<':
	      return checkLessThan(versionComponents, rangeComponents);
	
	    case '<=':
	      return checkLessThanOrEqual(versionComponents, rangeComponents);
	
	    case '>=':
	      return checkGreaterThanOrEqual(versionComponents, rangeComponents);
	
	    case '>':
	      return checkGreaterThan(versionComponents, rangeComponents);
	
	    case '~':
	    case '~>':
	      return checkApproximateVersion(versionComponents, rangeComponents);
	
	    default:
	      return checkEqual(versionComponents, rangeComponents);
	  }
	}
	/**
	 * Checks whether `a` is less than `b`.
	 *
	 * @param {array<string>} a
	 * @param {array<string>} b
	 * @returns {boolean}
	 */
	
	
	function checkLessThan(a, b) {
	  return compareComponents(a, b) === -1;
	}
	/**
	 * Checks whether `a` is less than or equal to `b`.
	 *
	 * @param {array<string>} a
	 * @param {array<string>} b
	 * @returns {boolean}
	 */
	
	
	function checkLessThanOrEqual(a, b) {
	  var result = compareComponents(a, b);
	  return result === -1 || result === 0;
	}
	/**
	 * Checks whether `a` is equal to `b`.
	 *
	 * @param {array<string>} a
	 * @param {array<string>} b
	 * @returns {boolean}
	 */
	
	
	function checkEqual(a, b) {
	  return compareComponents(a, b) === 0;
	}
	/**
	 * Checks whether `a` is greater than or equal to `b`.
	 *
	 * @param {array<string>} a
	 * @param {array<string>} b
	 * @returns {boolean}
	 */
	
	
	function checkGreaterThanOrEqual(a, b) {
	  var result = compareComponents(a, b);
	  return result === 1 || result === 0;
	}
	/**
	 * Checks whether `a` is greater than `b`.
	 *
	 * @param {array<string>} a
	 * @param {array<string>} b
	 * @returns {boolean}
	 */
	
	
	function checkGreaterThan(a, b) {
	  return compareComponents(a, b) === 1;
	}
	/**
	 * Checks whether `a` is "reasonably close" to `b` (as described in
	 * https://www.npmjs.org/doc/misc/semver.html). For example, if `b` is "1.3.1"
	 * then "reasonably close" is defined as ">= 1.3.1 and < 1.4".
	 *
	 * @param {array<string>} a
	 * @param {array<string>} b
	 * @returns {boolean}
	 */
	
	
	function checkApproximateVersion(a, b) {
	  var lowerBound = b.slice();
	  var upperBound = b.slice();
	
	  if (upperBound.length > 1) {
	    upperBound.pop();
	  }
	
	  var lastIndex = upperBound.length - 1;
	  var numeric = parseInt(upperBound[lastIndex], 10);
	
	  if (isNumber(numeric)) {
	    upperBound[lastIndex] = numeric + 1 + '';
	  }
	
	  return checkGreaterThanOrEqual(a, lowerBound) && checkLessThan(a, upperBound);
	}
	/**
	 * Extracts the optional modifier (<, <=, =, >=, >, ~, ~>) and version
	 * components from `range`.
	 *
	 * For example, given `range` ">= 1.2.3" returns an object with a `modifier` of
	 * `">="` and `components` of `[1, 2, 3]`.
	 *
	 * @param {string} range
	 * @returns {object}
	 */
	
	
	function getModifierAndComponents(range) {
	  var rangeComponents = range.split(componentRegex);
	  var matches = rangeComponents[0].match(modifierRegex);
	  !matches ?  false ? invariant(false, 'expected regex to match but it did not') : invariant(false) : void 0;
	  return {
	    modifier: matches[1],
	    rangeComponents: [matches[2]].concat(rangeComponents.slice(1))
	  };
	}
	/**
	 * Determines if `number` is a number.
	 *
	 * @param {mixed} number
	 * @returns {boolean}
	 */
	
	
	function isNumber(number) {
	  return !isNaN(number) && isFinite(number);
	}
	/**
	 * Tests whether `range` is a "simple" version number without any modifiers
	 * (">", "~" etc).
	 *
	 * @param {string} range
	 * @returns {boolean}
	 */
	
	
	function isSimpleVersion(range) {
	  return !getModifierAndComponents(range).modifier;
	}
	/**
	 * Zero-pads array `array` until it is at least `length` long.
	 *
	 * @param {array} array
	 * @param {number} length
	 */
	
	
	function zeroPad(array, length) {
	  for (var i = array.length; i < length; i++) {
	    array[i] = '0';
	  }
	}
	/**
	 * Normalizes `a` and `b` in preparation for comparison by doing the following:
	 *
	 * - zero-pads `a` and `b`
	 * - marks any "x", "X" or "*" component in `b` as equivalent by zero-ing it out
	 *   in both `a` and `b`
	 * - marks any final "*" component in `b` as a greedy wildcard by zero-ing it
	 *   and all of its successors in `a`
	 *
	 * @param {array<string>} a
	 * @param {array<string>} b
	 * @returns {array<array<string>>}
	 */
	
	
	function normalizeVersions(a, b) {
	  a = a.slice();
	  b = b.slice();
	  zeroPad(a, b.length); // mark "x" and "*" components as equal
	
	  for (var i = 0; i < b.length; i++) {
	    var matches = b[i].match(/^[x*]$/i);
	
	    if (matches) {
	      b[i] = a[i] = '0'; // final "*" greedily zeros all remaining components
	
	      if (matches[0] === '*' && i === b.length - 1) {
	        for (var j = i; j < a.length; j++) {
	          a[j] = '0';
	        }
	      }
	    }
	  }
	
	  zeroPad(b, a.length);
	  return [a, b];
	}
	/**
	 * Returns the numerical -- not the lexicographical -- ordering of `a` and `b`.
	 *
	 * For example, `10-alpha` is greater than `2-beta`.
	 *
	 * @param {string} a
	 * @param {string} b
	 * @returns {number} -1, 0 or 1 to indicate whether `a` is less than, equal to,
	 * or greater than `b`, respectively
	 */
	
	
	function compareNumeric(a, b) {
	  var aPrefix = a.match(numericRegex)[1];
	  var bPrefix = b.match(numericRegex)[1];
	  var aNumeric = parseInt(aPrefix, 10);
	  var bNumeric = parseInt(bPrefix, 10);
	
	  if (isNumber(aNumeric) && isNumber(bNumeric) && aNumeric !== bNumeric) {
	    return compare(aNumeric, bNumeric);
	  } else {
	    return compare(a, b);
	  }
	}
	/**
	 * Returns the ordering of `a` and `b`.
	 *
	 * @param {string|number} a
	 * @param {string|number} b
	 * @returns {number} -1, 0 or 1 to indicate whether `a` is less than, equal to,
	 * or greater than `b`, respectively
	 */
	
	
	function compare(a, b) {
	  !(typeof a === typeof b) ?  false ? invariant(false, '"a" and "b" must be of the same type') : invariant(false) : void 0;
	
	  if (a > b) {
	    return 1;
	  } else if (a < b) {
	    return -1;
	  } else {
	    return 0;
	  }
	}
	/**
	 * Compares arrays of version components.
	 *
	 * @param {array<string>} a
	 * @param {array<string>} b
	 * @returns {number} -1, 0 or 1 to indicate whether `a` is less than, equal to,
	 * or greater than `b`, respectively
	 */
	
	
	function compareComponents(a, b) {
	  var _normalizeVersions = normalizeVersions(a, b),
	      aNormalized = _normalizeVersions[0],
	      bNormalized = _normalizeVersions[1];
	
	  for (var i = 0; i < bNormalized.length; i++) {
	    var result = compareNumeric(aNormalized[i], bNormalized[i]);
	
	    if (result) {
	      return result;
	    }
	  }
	
	  return 0;
	}
	
	var VersionRange = {
	  /**
	   * Checks whether `version` satisfies the `range` specification.
	   *
	   * We support a subset of the expressions defined in
	   * https://www.npmjs.org/doc/misc/semver.html:
	   *
	   *    version   Must match version exactly
	   *    =version  Same as just version
	   *    >version  Must be greater than version
	   *    >=version Must be greater than or equal to version
	   *    <version  Must be less than version
	   *    <=version Must be less than or equal to version
	   *    ~version  Must be at least version, but less than the next significant
	   *              revision above version:
	   *              "~1.2.3" is equivalent to ">= 1.2.3 and < 1.3"
	   *    ~>version Equivalent to ~version
	   *    1.2.x     Must match "1.2.x", where "x" is a wildcard that matches
	   *              anything
	   *    1.2.*     Similar to "1.2.x", but "*" in the trailing position is a
	   *              "greedy" wildcard, so will match any number of additional
	   *              components:
	   *              "1.2.*" will match "1.2.1", "1.2.1.1", "1.2.1.1.1" etc
	   *    *         Any version
	   *    ""        (Empty string) Same as *
	   *    v1 - v2   Equivalent to ">= v1 and <= v2"
	   *    r1 || r2  Passes if either r1 or r2 are satisfied
	   *
	   * @param {string} range
	   * @param {string} version
	   * @returns {boolean}
	   */
	  contains: function contains(range, version) {
	    return checkOrExpression(range.trim(), version.trim());
	  }
	};
	module.exports = VersionRange;

/***/ },
/* 1278 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	var _hyphenPattern = /-(.)/g;
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ },
/* 1279 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	var invariant = __webpack_require__(32);
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	
	
	function toArray(obj) {
	  var length = obj.length; // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
	  // in old versions of Safari).
	
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;
	  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;
	  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;
	  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0; // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {// IE < 9 does not support Array#slice on collections objects
	    }
	  } // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	
	
	  var ret = Array(length);
	
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	
	  return ret;
	}
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	
	
	function hasArrayNature(obj) {
	  return (// not null/false
	    !!obj && ( // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') && // quacks like an array
	    'length' in obj && // not window
	    !('setInterval' in obj) && // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && ( // a real array
	    Array.isArray(obj) || // arguments
	    'callee' in obj || // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	
	
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ },
/* 1280 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	'use strict';
	
	var isWebkit = typeof navigator !== 'undefined' && navigator.userAgent.indexOf('AppleWebKit') > -1;
	/**
	 * Gets the element with the document scroll properties such as `scrollLeft` and
	 * `scrollHeight`. This may differ across different browsers.
	 *
	 * NOTE: The return value can be null if the DOM is not yet ready.
	 *
	 * @param {?DOMDocument} doc Defaults to current document.
	 * @return {?DOMElement}
	 */
	
	function getDocumentScrollElement(doc) {
	  doc = doc || document;
	
	  if (doc.scrollingElement) {
	    return doc.scrollingElement;
	  }
	
	  return !isWebkit && doc.compatMode === 'CSS1Compat' ? doc.documentElement : doc.body;
	}
	
	module.exports = getDocumentScrollElement;

/***/ },
/* 1281 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	var containsNode = __webpack_require__(270);
	/**
	 * Gets an element's bounding rect in pixels relative to the viewport.
	 *
	 * @param {DOMElement} elem
	 * @return {object}
	 */
	
	
	function getElementRect(elem) {
	  var docElem = elem.ownerDocument.documentElement; // FF 2, Safari 3 and Opera 9.5- do not support getBoundingClientRect().
	  // IE9- will throw if the element is not in the document.
	
	  if (!('getBoundingClientRect' in elem) || !containsNode(docElem, elem)) {
	    return {
	      left: 0,
	      right: 0,
	      top: 0,
	      bottom: 0
	    };
	  } // Subtracts clientTop/Left because IE8- added a 2px border to the
	  // <html> element (see http://fburl.com/1493213). IE 7 in
	  // Quicksmode does not report clientLeft/clientTop so there
	  // will be an unaccounted offset of 2px when in quirksmode
	
	
	  var rect = elem.getBoundingClientRect();
	  return {
	    left: Math.round(rect.left) - docElem.clientLeft,
	    right: Math.round(rect.right) - docElem.clientLeft,
	    top: Math.round(rect.top) - docElem.clientTop,
	    bottom: Math.round(rect.bottom) - docElem.clientTop
	  };
	}
	
	module.exports = getElementRect;

/***/ },
/* 1282 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	var camelize = __webpack_require__(1278);
	
	var hyphenate = __webpack_require__(1284);
	
	function asString(value)
	/*?string*/
	{
	  return value == null ? value : String(value);
	}
	
	function getStyleProperty(
	/*DOMNode*/
	node,
	/*string*/
	name)
	/*?string*/
	{
	  var computedStyle; // W3C Standard
	
	  if (window.getComputedStyle) {
	    // In certain cases such as within an iframe in FF3, this returns null.
	    computedStyle = window.getComputedStyle(node, null);
	
	    if (computedStyle) {
	      return asString(computedStyle.getPropertyValue(hyphenate(name)));
	    }
	  } // Safari
	
	
	  if (document.defaultView && document.defaultView.getComputedStyle) {
	    computedStyle = document.defaultView.getComputedStyle(node, null); // A Safari bug causes this to return null for `display: none` elements.
	
	    if (computedStyle) {
	      return asString(computedStyle.getPropertyValue(hyphenate(name)));
	    }
	
	    if (name === 'display') {
	      return 'none';
	    }
	  } // Internet Explorer
	
	
	  if (node.currentStyle) {
	    if (name === 'float') {
	      return asString(node.currentStyle.cssFloat || node.currentStyle.styleFloat);
	    }
	
	    return asString(node.currentStyle[camelize(name)]);
	  }
	
	  return asString(node.style && node.style[camelize(name)]);
	}
	
	module.exports = getStyleProperty;

/***/ },
/* 1283 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	'use strict';
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable.Window && scrollable instanceof scrollable.Window) {
	    return {
	      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
	      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
	    };
	  }
	
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ },
/* 1284 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	var _uppercasePattern = /([A-Z])/g;
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ },
/* 1285 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  var doc = object ? object.ownerDocument || object : document;
	  var defaultView = doc.defaultView || window;
	  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ },
/* 1286 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	var isNode = __webpack_require__(1285);
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	
	
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ },
/* 1287 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @typechecks static-only
	 */
	'use strict';
	/**
	 * Combines multiple className strings into one.
	 */
	
	function joinClasses(className) {
	  var newClassName = className || '';
	  var argLength = arguments.length;
	
	  if (argLength > 1) {
	    for (var index = 1; index < argLength; index++) {
	      var nextClass = arguments[index];
	
	      if (nextClass) {
	        newClassName = (newClassName ? newClassName + ' ' : '') + nextClass;
	      }
	    }
	  }
	
	  return newClassName;
	}
	
	module.exports = joinClasses;

/***/ },
/* 1288 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	/**
	 * Executes the provided `callback` once for each enumerable own property in the
	 * object and constructs a new object from the results. The `callback` is
	 * invoked with three arguments:
	 *
	 *  - the property value
	 *  - the property name
	 *  - the object being traversed
	 *
	 * Properties that are added after the call to `mapObject` will not be visited
	 * by `callback`. If the values of existing properties are changed, the value
	 * passed to `callback` will be the value at the time `mapObject` visits them.
	 * Properties that are deleted before being visited are not visited.
	 *
	 * @grep function objectMap()
	 * @grep function objMap()
	 *
	 * @param {?object} object
	 * @param {function} callback
	 * @param {*} context
	 * @return {?object}
	 */
	
	function mapObject(object, callback, context) {
	  if (!object) {
	    return null;
	  }
	
	  var result = {};
	
	  for (var name in object) {
	    if (hasOwnProperty.call(object, name)) {
	      result[name] = callback.call(context, object[name], name, object);
	    }
	  }
	
	  return result;
	}
	
	module.exports = mapObject;

/***/ },
/* 1289 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @typechecks static-only
	 */
	'use strict';
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 */
	
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ },
/* 1290 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	'use strict'; // setimmediate adds setImmediate to the global. We want to make sure we export
	// the actual function.
	
	__webpack_require__(306);
	
	module.exports = global.setImmediate;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1291 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/facebook.2dc1b175.svg";

/***/ },
/* 1292 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/instagram.ae13bf03.svg";

/***/ },
/* 1293 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/linkedin.e8ae2206.svg";

/***/ },
/* 1294 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/twitter.7d12749b.svg";

/***/ },
/* 1295 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/close.aa4fbc82.svg";

/***/ },
/* 1296 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/menu.ca394ec8.svg";

/***/ },
/* 1297 */
/***/ function(module, exports) {

	'use strict';
	
	/* eslint no-invalid-this: 1 */
	
	var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
	var toStr = Object.prototype.toString;
	var max = Math.max;
	var funcType = '[object Function]';
	
	var concatty = function concatty(a, b) {
	    var arr = [];
	
	    for (var i = 0; i < a.length; i += 1) {
	        arr[i] = a[i];
	    }
	    for (var j = 0; j < b.length; j += 1) {
	        arr[j + a.length] = b[j];
	    }
	
	    return arr;
	};
	
	var slicy = function slicy(arrLike, offset) {
	    var arr = [];
	    for (var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1) {
	        arr[j] = arrLike[i];
	    }
	    return arr;
	};
	
	var joiny = function (arr, joiner) {
	    var str = '';
	    for (var i = 0; i < arr.length; i += 1) {
	        str += arr[i];
	        if (i + 1 < arr.length) {
	            str += joiner;
	        }
	    }
	    return str;
	};
	
	module.exports = function bind(that) {
	    var target = this;
	    if (typeof target !== 'function' || toStr.apply(target) !== funcType) {
	        throw new TypeError(ERROR_MESSAGE + target);
	    }
	    var args = slicy(arguments, 1);
	
	    var bound;
	    var binder = function () {
	        if (this instanceof bound) {
	            var result = target.apply(
	                this,
	                concatty(args, arguments)
	            );
	            if (Object(result) === result) {
	                return result;
	            }
	            return this;
	        }
	        return target.apply(
	            that,
	            concatty(args, arguments)
	        );
	
	    };
	
	    var boundLength = max(0, target.length - args.length);
	    var boundArgs = [];
	    for (var i = 0; i < boundLength; i++) {
	        boundArgs[i] = '$' + i;
	    }
	
	    bound = Function('binder', 'return function (' + joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);
	
	    if (target.prototype) {
	        var Empty = function Empty() {};
	        Empty.prototype = target.prototype;
	        bound.prototype = new Empty();
	        Empty.prototype = null;
	    }
	
	    return bound;
	};


/***/ },
/* 1298 */
/***/ function(module, exports) {

	'use strict';
	
	var functionsHaveNames = function functionsHaveNames() {
		return typeof function f() {}.name === 'string';
	};
	
	var gOPD = Object.getOwnPropertyDescriptor;
	if (gOPD) {
		try {
			gOPD([], 'length');
		} catch (e) {
			// IE 8 has a broken gOPD
			gOPD = null;
		}
	}
	
	functionsHaveNames.functionsHaveConfigurableNames = function functionsHaveConfigurableNames() {
		if (!functionsHaveNames() || !gOPD) {
			return false;
		}
		var desc = gOPD(function () {}, 'name');
		return !!desc && !!desc.configurable;
	};
	
	var $bind = Function.prototype.bind;
	
	functionsHaveNames.boundFunctionsHaveNames = function boundFunctionsHaveNames() {
		return functionsHaveNames() && typeof $bind === 'function' && function f() {}.bind().name !== '';
	};
	
	module.exports = functionsHaveNames;


/***/ },
/* 1299 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./gOPD')} */
	module.exports = Object.getOwnPropertyDescriptor;


/***/ },
/* 1300 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {// @flow
	'use strict';
	
	var key = '__global_unique_id__';
	
	module.exports = function() {
	  return global[key] = (global[key] || 0) + 1;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1301 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var origSymbol = typeof Symbol !== 'undefined' && Symbol;
	var hasSymbolSham = __webpack_require__(436);
	
	/** @type {import('.')} */
	module.exports = function hasNativeSymbols() {
		if (typeof origSymbol !== 'function') { return false; }
		if (typeof Symbol !== 'function') { return false; }
		if (typeof origSymbol('foo') !== 'symbol') { return false; }
		if (typeof Symbol('bar') !== 'symbol') { return false; }
	
		return hasSymbolSham();
	};


/***/ },
/* 1302 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";function _interopDefault(t){return t&&"object"==typeof t&&"default"in t?t.default:t}Object.defineProperty(exports,"__esModule",{value:!0});var resolvePathname=_interopDefault(__webpack_require__(1613)),valueEqual=_interopDefault(__webpack_require__(1643));__webpack_require__(134);var invariant=_interopDefault(__webpack_require__(307));function _extends(){return(_extends=Object.assign||function(t){for(var n=1;n<arguments.length;n++){var e=arguments[n];for(var a in e)Object.prototype.hasOwnProperty.call(e,a)&&(t[a]=e[a])}return t}).apply(this,arguments)}function addLeadingSlash(t){return"/"===t.charAt(0)?t:"/"+t}function stripLeadingSlash(t){return"/"===t.charAt(0)?t.substr(1):t}function hasBasename(t,n){return 0===t.toLowerCase().indexOf(n.toLowerCase())&&-1!=="/?#".indexOf(t.charAt(n.length))}function stripBasename(t,n){return hasBasename(t,n)?t.substr(n.length):t}function stripTrailingSlash(t){return"/"===t.charAt(t.length-1)?t.slice(0,-1):t}function parsePath(t){var n=t||"/",e="",a="",r=n.indexOf("#");-1!==r&&(a=n.substr(r),n=n.substr(0,r));var o=n.indexOf("?");return-1!==o&&(e=n.substr(o),n=n.substr(0,o)),{pathname:n,search:"?"===e?"":e,hash:"#"===a?"":a}}function createPath(t){var n=t.pathname,e=t.search,a=t.hash,r=n||"/";return e&&"?"!==e&&(r+="?"===e.charAt(0)?e:"?"+e),a&&"#"!==a&&(r+="#"===a.charAt(0)?a:"#"+a),r}function createLocation(t,n,e,a){var r;"string"==typeof t?(r=parsePath(t)).state=n:(void 0===(r=_extends({},t)).pathname&&(r.pathname=""),r.search?"?"!==r.search.charAt(0)&&(r.search="?"+r.search):r.search="",r.hash?"#"!==r.hash.charAt(0)&&(r.hash="#"+r.hash):r.hash="",void 0!==n&&void 0===r.state&&(r.state=n));try{r.pathname=decodeURI(r.pathname)}catch(t){throw t instanceof URIError?new URIError('Pathname "'+r.pathname+'" could not be decoded. This is likely caused by an invalid percent-encoding.'):t}return e&&(r.key=e),a?r.pathname?"/"!==r.pathname.charAt(0)&&(r.pathname=resolvePathname(r.pathname,a.pathname)):r.pathname=a.pathname:r.pathname||(r.pathname="/"),r}function locationsAreEqual(t,n){return t.pathname===n.pathname&&t.search===n.search&&t.hash===n.hash&&t.key===n.key&&valueEqual(t.state,n.state)}function createTransitionManager(){var o=null;var a=[];return{setPrompt:function(t){return o=t,function(){o===t&&(o=null)}},confirmTransitionTo:function(t,n,e,a){if(null!=o){var r="function"==typeof o?o(t,n):o;"string"==typeof r?"function"==typeof e?e(r,a):a(!0):a(!1!==r)}else a(!0)},appendListener:function(t){var n=!0;function e(){n&&t.apply(void 0,arguments)}return a.push(e),function(){n=!1,a=a.filter(function(t){return t!==e})}},notifyListeners:function(){for(var t=arguments.length,n=new Array(t),e=0;e<t;e++)n[e]=arguments[e];a.forEach(function(t){return t.apply(void 0,n)})}}}var canUseDOM=!("undefined"==typeof window||!window.document||!window.document.createElement);function getConfirmation(t,n){n(window.confirm(t))}function supportsHistory(){var t=window.navigator.userAgent;return(-1===t.indexOf("Android 2.")&&-1===t.indexOf("Android 4.0")||-1===t.indexOf("Mobile Safari")||-1!==t.indexOf("Chrome")||-1!==t.indexOf("Windows Phone"))&&(window.history&&"pushState"in window.history)}function supportsPopStateOnHashChange(){return-1===window.navigator.userAgent.indexOf("Trident")}function supportsGoWithoutReloadUsingHash(){return-1===window.navigator.userAgent.indexOf("Firefox")}function isExtraneousPopstateEvent(t){return void 0===t.state&&-1===navigator.userAgent.indexOf("CriOS")}var PopStateEvent="popstate",HashChangeEvent="hashchange";function getHistoryState(){try{return window.history.state||{}}catch(t){return{}}}function createBrowserHistory(t){void 0===t&&(t={}),canUseDOM||invariant(!1);var s=window.history,c=supportsHistory(),n=!supportsPopStateOnHashChange(),e=t,a=e.forceRefresh,h=void 0!==a&&a,r=e.getUserConfirmation,u=void 0===r?getConfirmation:r,o=e.keyLength,i=void 0===o?6:o,f=t.basename?stripTrailingSlash(addLeadingSlash(t.basename)):"";function l(t){var n=t||{},e=n.key,a=n.state,r=window.location,o=r.pathname+r.search+r.hash;return f&&(o=stripBasename(o,f)),createLocation(o,a,e)}function d(){return Math.random().toString(36).substr(2,i)}var v=createTransitionManager();function p(t){_extends(T,t),T.length=s.length,v.notifyListeners(T.location,T.action)}function g(t){isExtraneousPopstateEvent(t)||w(l(t.state))}function P(){w(l(getHistoryState()))}var m=!1;function w(n){if(m)m=!1,p();else{v.confirmTransitionTo(n,"POP",u,function(t){t?p({action:"POP",location:n}):function(t){var n=T.location,e=H.indexOf(n.key);-1===e&&(e=0);var a=H.indexOf(t.key);-1===a&&(a=0);var r=e-a;r&&(m=!0,L(r))}(n)})}}var y=l(getHistoryState()),H=[y.key];function x(t){return f+createPath(t)}function L(t){s.go(t)}var O=0;function E(t){1===(O+=t)&&1===t?(window.addEventListener(PopStateEvent,g),n&&window.addEventListener(HashChangeEvent,P)):0===O&&(window.removeEventListener(PopStateEvent,g),n&&window.removeEventListener(HashChangeEvent,P))}var S=!1;var T={length:s.length,action:"POP",location:y,createHref:x,push:function(t,n){var i=createLocation(t,n,d(),T.location);v.confirmTransitionTo(i,"PUSH",u,function(t){if(t){var n=x(i),e=i.key,a=i.state;if(c)if(s.pushState({key:e,state:a},null,n),h)window.location.href=n;else{var r=H.indexOf(T.location.key),o=H.slice(0,r+1);o.push(i.key),H=o,p({action:"PUSH",location:i})}else window.location.href=n}})},replace:function(t,n){var o="REPLACE",i=createLocation(t,n,d(),T.location);v.confirmTransitionTo(i,o,u,function(t){if(t){var n=x(i),e=i.key,a=i.state;if(c)if(s.replaceState({key:e,state:a},null,n),h)window.location.replace(n);else{var r=H.indexOf(T.location.key);-1!==r&&(H[r]=i.key),p({action:o,location:i})}else window.location.replace(n)}})},go:L,goBack:function(){L(-1)},goForward:function(){L(1)},block:function(t){void 0===t&&(t=!1);var n=v.setPrompt(t);return S||(E(1),S=!0),function(){return S&&(S=!1,E(-1)),n()}},listen:function(t){var n=v.appendListener(t);return E(1),function(){E(-1),n()}}};return T}var HashChangeEvent$1="hashchange",HashPathCoders={hashbang:{encodePath:function(t){return"!"===t.charAt(0)?t:"!/"+stripLeadingSlash(t)},decodePath:function(t){return"!"===t.charAt(0)?t.substr(1):t}},noslash:{encodePath:stripLeadingSlash,decodePath:addLeadingSlash},slash:{encodePath:addLeadingSlash,decodePath:addLeadingSlash}};function stripHash(t){var n=t.indexOf("#");return-1===n?t:t.slice(0,n)}function getHashPath(){var t=window.location.href,n=t.indexOf("#");return-1===n?"":t.substring(n+1)}function pushHashPath(t){window.location.hash=t}function replaceHashPath(t){window.location.replace(stripHash(window.location.href)+"#"+t)}function createHashHistory(t){void 0===t&&(t={}),canUseDOM||invariant(!1);var n=window.history,e=(supportsGoWithoutReloadUsingHash(),t),a=e.getUserConfirmation,i=void 0===a?getConfirmation:a,r=e.hashType,o=void 0===r?"slash":r,s=t.basename?stripTrailingSlash(addLeadingSlash(t.basename)):"",c=HashPathCoders[o],h=c.encodePath,u=c.decodePath;function f(){var t=u(getHashPath());return s&&(t=stripBasename(t,s)),createLocation(t)}var l=createTransitionManager();function d(t){_extends(E,t),E.length=n.length,l.notifyListeners(E.location,E.action)}var v=!1,p=null;function g(){var t=getHashPath(),n=h(t);if(t!==n)replaceHashPath(n);else{var e=f(),a=E.location;if(!v&&function(t,n){return t.pathname===n.pathname&&t.search===n.search&&t.hash===n.hash}(a,e))return;if(p===createPath(e))return;p=null,function(n){if(v)v=!1,d();else{l.confirmTransitionTo(n,"POP",i,function(t){t?d({action:"POP",location:n}):function(t){var n=E.location,e=y.lastIndexOf(createPath(n));-1===e&&(e=0);var a=y.lastIndexOf(createPath(t));-1===a&&(a=0);var r=e-a;r&&(v=!0,H(r))}(n)})}}(e)}}var P=getHashPath(),m=h(P);P!==m&&replaceHashPath(m);var w=f(),y=[createPath(w)];function H(t){n.go(t)}var x=0;function L(t){1===(x+=t)&&1===t?window.addEventListener(HashChangeEvent$1,g):0===x&&window.removeEventListener(HashChangeEvent$1,g)}var O=!1;var E={length:n.length,action:"POP",location:w,createHref:function(t){var n=document.querySelector("base"),e="";return n&&n.getAttribute("href")&&(e=stripHash(window.location.href)),e+"#"+h(s+createPath(t))},push:function(t,n){var o=createLocation(t,void 0,void 0,E.location);l.confirmTransitionTo(o,"PUSH",i,function(t){if(t){var n=createPath(o),e=h(s+n);if(getHashPath()!==e){p=n,pushHashPath(e);var a=y.lastIndexOf(createPath(E.location)),r=y.slice(0,a+1);r.push(n),y=r,d({action:"PUSH",location:o})}else d()}})},replace:function(t,n){var r="REPLACE",o=createLocation(t,void 0,void 0,E.location);l.confirmTransitionTo(o,r,i,function(t){if(t){var n=createPath(o),e=h(s+n);getHashPath()!==e&&(p=n,replaceHashPath(e));var a=y.indexOf(createPath(E.location));-1!==a&&(y[a]=n),d({action:r,location:o})}})},go:H,goBack:function(){H(-1)},goForward:function(){H(1)},block:function(t){void 0===t&&(t=!1);var n=l.setPrompt(t);return O||(L(1),O=!0),function(){return O&&(O=!1,L(-1)),n()}},listen:function(t){var n=l.appendListener(t);return L(1),function(){L(-1),n()}}};return E}function clamp(t,n,e){return Math.min(Math.max(t,n),e)}function createMemoryHistory(t){void 0===t&&(t={});var n=t,r=n.getUserConfirmation,e=n.initialEntries,a=void 0===e?["/"]:e,o=n.initialIndex,i=void 0===o?0:o,s=n.keyLength,c=void 0===s?6:s,h=createTransitionManager();function u(t){_extends(g,t),g.length=g.entries.length,h.notifyListeners(g.location,g.action)}function f(){return Math.random().toString(36).substr(2,c)}var l=clamp(i,0,a.length-1),d=a.map(function(t){return createLocation(t,void 0,"string"==typeof t?f():t.key||f())}),v=createPath;function p(t){var n=clamp(g.index+t,0,g.entries.length-1),e=g.entries[n];h.confirmTransitionTo(e,"POP",r,function(t){t?u({action:"POP",location:e,index:n}):u()})}var g={length:d.length,action:"POP",location:d[l],index:l,entries:d,createHref:v,push:function(t,n){var a=createLocation(t,n,f(),g.location);h.confirmTransitionTo(a,"PUSH",r,function(t){if(t){var n=g.index+1,e=g.entries.slice(0);e.length>n?e.splice(n,e.length-n,a):e.push(a),u({action:"PUSH",location:a,index:n,entries:e})}})},replace:function(t,n){var e="REPLACE",a=createLocation(t,n,f(),g.location);h.confirmTransitionTo(a,e,r,function(t){t&&(g.entries[g.index]=a,u({action:e,location:a}))})},go:p,goBack:function(){p(-1)},goForward:function(){p(1)},canGo:function(t){var n=g.index+t;return 0<=n&&n<g.entries.length},block:function(t){return void 0===t&&(t=!1),h.setPrompt(t)},listen:function(t){return h.appendListener(t)}};return g}exports.createBrowserHistory=createBrowserHistory,exports.createHashHistory=createHashHistory,exports.createMemoryHistory=createMemoryHistory,exports.createLocation=createLocation,exports.locationsAreEqual=locationsAreEqual,exports.parsePath=parsePath,exports.createPath=createPath;


/***/ },
/* 1303 */
/***/ function(module, exports) {

	/** @license React v16.13.1
	 * react-is.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
	Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
	function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
	exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
	exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
	exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ },
/* 1304 */
[1664, 1303],
/* 1305 */
/***/ function(module, exports) {

	'use strict';
	
	/* eslint-disable no-var, prefer-template */
	var uppercasePattern = /[A-Z]/g;
	var msPattern = /^ms-/;
	var cache = {};
	
	function toHyphenLower(match) {
	  return '-' + match.toLowerCase()
	}
	
	function hyphenateStyleName(name) {
	  if (cache.hasOwnProperty(name)) {
	    return cache[name]
	  }
	
	  var hName = name.replace(uppercasePattern, toHyphenLower);
	  return (cache[name] = msPattern.test(hName) ? '-' + hName : hName)
	}
	
	module.exports = hyphenateStyleName;


/***/ },
/* 1306 */
/***/ function(module, exports) {

	/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]
	
	  i += d
	
	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0
	
	  value = Math.abs(value)
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = ((value * c) - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128
	}


/***/ },
/* 1307 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	var Mutation = global.MutationObserver || global.WebKitMutationObserver;
	
	var scheduleDrain;
	
	{
	  if (Mutation) {
	    var called = 0;
	    var observer = new Mutation(nextTick);
	    var element = global.document.createTextNode('');
	    observer.observe(element, {
	      characterData: true
	    });
	    scheduleDrain = function () {
	      element.data = (called = ++called % 2);
	    };
	  } else if (!global.setImmediate && typeof global.MessageChannel !== 'undefined') {
	    var channel = new global.MessageChannel();
	    channel.port1.onmessage = nextTick;
	    scheduleDrain = function () {
	      channel.port2.postMessage(0);
	    };
	  } else if ('document' in global && 'onreadystatechange' in global.document.createElement('script')) {
	    scheduleDrain = function () {
	
	      // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	      // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	      var scriptEl = global.document.createElement('script');
	      scriptEl.onreadystatechange = function () {
	        nextTick();
	
	        scriptEl.onreadystatechange = null;
	        scriptEl.parentNode.removeChild(scriptEl);
	        scriptEl = null;
	      };
	      global.document.documentElement.appendChild(scriptEl);
	    };
	  } else {
	    scheduleDrain = function () {
	      setTimeout(nextTick, 0);
	    };
	  }
	}
	
	var draining;
	var queue = [];
	//named nextTick for less confusing stack traces
	function nextTick() {
	  draining = true;
	  var i, oldQueue;
	  var len = queue.length;
	  while (len) {
	    oldQueue = queue;
	    queue = [];
	    i = -1;
	    while (++i < len) {
	      oldQueue[i]();
	    }
	    len = queue.length;
	  }
	  draining = false;
	}
	
	module.exports = immediate;
	function immediate(task) {
	  if (queue.push(task) === 1 && !draining) {
	    scheduleDrain();
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1308 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var hasToStringTag = __webpack_require__(274)();
	var callBound = __webpack_require__(1074);
	
	var $toString = callBound('Object.prototype.toString');
	
	var isStandardArguments = function isArguments(value) {
		if (hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) {
			return false;
		}
		return $toString(value) === '[object Arguments]';
	};
	
	var isLegacyArguments = function isArguments(value) {
		if (isStandardArguments(value)) {
			return true;
		}
		return value !== null &&
			typeof value === 'object' &&
			typeof value.length === 'number' &&
			value.length >= 0 &&
			$toString(value) !== '[object Array]' &&
			$toString(value.callee) === '[object Function]';
	};
	
	var supportsStandardArguments = (function () {
		return isStandardArguments(arguments);
	}());
	
	isStandardArguments.isLegacyArguments = isLegacyArguments; // for tests
	
	module.exports = supportsStandardArguments ? isStandardArguments : isLegacyArguments;


/***/ },
/* 1309 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var callBound = __webpack_require__(371);
	
	var getDay = callBound('Date.prototype.getDay');
	/** @type {import('.')} */
	var tryDateObject = function tryDateGetDayCall(value) {
		try {
			getDay(value);
			return true;
		} catch (e) {
			return false;
		}
	};
	
	/** @type {(value: unknown) => string} */
	var toStr = callBound('Object.prototype.toString');
	var dateClass = '[object Date]';
	var hasToStringTag = __webpack_require__(274)();
	
	/** @type {import('.')} */
	module.exports = function isDateObject(value) {
		if (typeof value !== 'object' || value === null) {
			return false;
		}
		return hasToStringTag ? tryDateObject(value) : toStr(value) === dateClass;
	};


/***/ },
/* 1310 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var callBound = __webpack_require__(371);
	var hasToStringTag = __webpack_require__(274)();
	var hasOwn = __webpack_require__(437);
	var gOPD = __webpack_require__(125);
	
	/** @type {import('.')} */
	var fn;
	
	if (hasToStringTag) {
		/** @type {(receiver: ThisParameterType<typeof RegExp.prototype.exec>, ...args: Parameters<typeof RegExp.prototype.exec>) => ReturnType<typeof RegExp.prototype.exec>} */
		var $exec = callBound('RegExp.prototype.exec');
		/** @type {object} */
		var isRegexMarker = {};
	
		var throwRegexMarker = function () {
			throw isRegexMarker;
		};
		/** @type {{ toString(): never, valueOf(): never, [Symbol.toPrimitive]?(): never }} */
		var badStringifier = {
			toString: throwRegexMarker,
			valueOf: throwRegexMarker
		};
	
		if (typeof Symbol.toPrimitive === 'symbol') {
			badStringifier[Symbol.toPrimitive] = throwRegexMarker;
		}
	
		/** @type {import('.')} */
		// @ts-expect-error TS can't figure out that the $exec call always throws
		// eslint-disable-next-line consistent-return
		fn = function isRegex(value) {
			if (!value || typeof value !== 'object') {
				return false;
			}
	
			// eslint-disable-next-line no-extra-parens
			var descriptor = /** @type {NonNullable<typeof gOPD>} */ (gOPD)(/** @type {{ lastIndex?: unknown }} */ (value), 'lastIndex');
			var hasLastIndexDataProperty = descriptor && hasOwn(descriptor, 'value');
			if (!hasLastIndexDataProperty) {
				return false;
			}
	
			try {
				// eslint-disable-next-line no-extra-parens
				$exec(value, /** @type {string} */ (/** @type {unknown} */ (badStringifier)));
			} catch (e) {
				return e === isRegexMarker;
			}
		};
	} else {
		/** @type {(receiver: ThisParameterType<typeof Object.prototype.toString>, ...args: Parameters<typeof Object.prototype.toString>) => ReturnType<typeof Object.prototype.toString>} */
		var $toString = callBound('Object.prototype.toString');
		/** @const @type {'[object RegExp]'} */
		var regexClass = '[object RegExp]';
	
		/** @type {import('.')} */
		fn = function isRegex(value) {
			// In older browsers, typeof regex incorrectly returns 'function'
			if (!value || (typeof value !== 'object' && typeof value !== 'function')) {
				return false;
			}
	
			return $toString(value) === regexClass;
		};
	}
	
	module.exports = fn;


/***/ },
/* 1311 */
/***/ function(module, exports) {

	module.exports = Array.isArray || function (arr) {
	  return Object.prototype.toString.call(arr) == '[object Array]';
	};


/***/ },
/* 1312 */
/***/ function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory();
		else if(typeof define === 'function' && define.amd)
			define("html2pdf", [], factory);
		else if(typeof exports === 'object')
			exports["html2pdf"] = factory();
		else
			root["html2pdf"] = factory();
	})(typeof self !== 'undefined' ? self : this, function() {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, {
	/******/ 				configurable: false,
	/******/ 				enumerable: true,
	/******/ 				get: getter
	/******/ 			});
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 30);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports) {
	
	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };
	
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	// http://dev.w3.org/csswg/css-color/
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var HEX3 = /^#([a-f0-9]{3})$/i;
	var hex3 = function hex3(value) {
	    var match = value.match(HEX3);
	    if (match) {
	        return [parseInt(match[1][0] + match[1][0], 16), parseInt(match[1][1] + match[1][1], 16), parseInt(match[1][2] + match[1][2], 16), null];
	    }
	    return false;
	};
	
	var HEX6 = /^#([a-f0-9]{6})$/i;
	var hex6 = function hex6(value) {
	    var match = value.match(HEX6);
	    if (match) {
	        return [parseInt(match[1].substring(0, 2), 16), parseInt(match[1].substring(2, 4), 16), parseInt(match[1].substring(4, 6), 16), null];
	    }
	    return false;
	};
	
	var RGB = /^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/;
	var rgb = function rgb(value) {
	    var match = value.match(RGB);
	    if (match) {
	        return [Number(match[1]), Number(match[2]), Number(match[3]), null];
	    }
	    return false;
	};
	
	var RGBA = /^rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d?\.?\d+)\s*\)$/;
	var rgba = function rgba(value) {
	    var match = value.match(RGBA);
	    if (match && match.length > 4) {
	        return [Number(match[1]), Number(match[2]), Number(match[3]), Number(match[4])];
	    }
	    return false;
	};
	
	var fromArray = function fromArray(array) {
	    return [Math.min(array[0], 255), Math.min(array[1], 255), Math.min(array[2], 255), array.length > 3 ? array[3] : null];
	};
	
	var namedColor = function namedColor(name) {
	    var color = NAMED_COLORS[name.toLowerCase()];
	    return color ? color : false;
	};
	
	var Color = function () {
	    function Color(value) {
	        _classCallCheck(this, Color);
	
	        var _ref = Array.isArray(value) ? fromArray(value) : hex3(value) || rgb(value) || rgba(value) || namedColor(value) || hex6(value) || [0, 0, 0, null],
	            _ref2 = _slicedToArray(_ref, 4),
	            r = _ref2[0],
	            g = _ref2[1],
	            b = _ref2[2],
	            a = _ref2[3];
	
	        this.r = r;
	        this.g = g;
	        this.b = b;
	        this.a = a;
	    }
	
	    _createClass(Color, [{
	        key: 'isTransparent',
	        value: function isTransparent() {
	            return this.a === 0;
	        }
	    }, {
	        key: 'toString',
	        value: function toString() {
	            return this.a !== null && this.a !== 1 ? 'rgba(' + this.r + ',' + this.g + ',' + this.b + ',' + this.a + ')' : 'rgb(' + this.r + ',' + this.g + ',' + this.b + ')';
	        }
	    }]);
	
	    return Color;
	}();
	
	exports.default = Color;
	
	
	var NAMED_COLORS = {
	    transparent: [0, 0, 0, 0],
	    aliceblue: [240, 248, 255, null],
	    antiquewhite: [250, 235, 215, null],
	    aqua: [0, 255, 255, null],
	    aquamarine: [127, 255, 212, null],
	    azure: [240, 255, 255, null],
	    beige: [245, 245, 220, null],
	    bisque: [255, 228, 196, null],
	    black: [0, 0, 0, null],
	    blanchedalmond: [255, 235, 205, null],
	    blue: [0, 0, 255, null],
	    blueviolet: [138, 43, 226, null],
	    brown: [165, 42, 42, null],
	    burlywood: [222, 184, 135, null],
	    cadetblue: [95, 158, 160, null],
	    chartreuse: [127, 255, 0, null],
	    chocolate: [210, 105, 30, null],
	    coral: [255, 127, 80, null],
	    cornflowerblue: [100, 149, 237, null],
	    cornsilk: [255, 248, 220, null],
	    crimson: [220, 20, 60, null],
	    cyan: [0, 255, 255, null],
	    darkblue: [0, 0, 139, null],
	    darkcyan: [0, 139, 139, null],
	    darkgoldenrod: [184, 134, 11, null],
	    darkgray: [169, 169, 169, null],
	    darkgreen: [0, 100, 0, null],
	    darkgrey: [169, 169, 169, null],
	    darkkhaki: [189, 183, 107, null],
	    darkmagenta: [139, 0, 139, null],
	    darkolivegreen: [85, 107, 47, null],
	    darkorange: [255, 140, 0, null],
	    darkorchid: [153, 50, 204, null],
	    darkred: [139, 0, 0, null],
	    darksalmon: [233, 150, 122, null],
	    darkseagreen: [143, 188, 143, null],
	    darkslateblue: [72, 61, 139, null],
	    darkslategray: [47, 79, 79, null],
	    darkslategrey: [47, 79, 79, null],
	    darkturquoise: [0, 206, 209, null],
	    darkviolet: [148, 0, 211, null],
	    deeppink: [255, 20, 147, null],
	    deepskyblue: [0, 191, 255, null],
	    dimgray: [105, 105, 105, null],
	    dimgrey: [105, 105, 105, null],
	    dodgerblue: [30, 144, 255, null],
	    firebrick: [178, 34, 34, null],
	    floralwhite: [255, 250, 240, null],
	    forestgreen: [34, 139, 34, null],
	    fuchsia: [255, 0, 255, null],
	    gainsboro: [220, 220, 220, null],
	    ghostwhite: [248, 248, 255, null],
	    gold: [255, 215, 0, null],
	    goldenrod: [218, 165, 32, null],
	    gray: [128, 128, 128, null],
	    green: [0, 128, 0, null],
	    greenyellow: [173, 255, 47, null],
	    grey: [128, 128, 128, null],
	    honeydew: [240, 255, 240, null],
	    hotpink: [255, 105, 180, null],
	    indianred: [205, 92, 92, null],
	    indigo: [75, 0, 130, null],
	    ivory: [255, 255, 240, null],
	    khaki: [240, 230, 140, null],
	    lavender: [230, 230, 250, null],
	    lavenderblush: [255, 240, 245, null],
	    lawngreen: [124, 252, 0, null],
	    lemonchiffon: [255, 250, 205, null],
	    lightblue: [173, 216, 230, null],
	    lightcoral: [240, 128, 128, null],
	    lightcyan: [224, 255, 255, null],
	    lightgoldenrodyellow: [250, 250, 210, null],
	    lightgray: [211, 211, 211, null],
	    lightgreen: [144, 238, 144, null],
	    lightgrey: [211, 211, 211, null],
	    lightpink: [255, 182, 193, null],
	    lightsalmon: [255, 160, 122, null],
	    lightseagreen: [32, 178, 170, null],
	    lightskyblue: [135, 206, 250, null],
	    lightslategray: [119, 136, 153, null],
	    lightslategrey: [119, 136, 153, null],
	    lightsteelblue: [176, 196, 222, null],
	    lightyellow: [255, 255, 224, null],
	    lime: [0, 255, 0, null],
	    limegreen: [50, 205, 50, null],
	    linen: [250, 240, 230, null],
	    magenta: [255, 0, 255, null],
	    maroon: [128, 0, 0, null],
	    mediumaquamarine: [102, 205, 170, null],
	    mediumblue: [0, 0, 205, null],
	    mediumorchid: [186, 85, 211, null],
	    mediumpurple: [147, 112, 219, null],
	    mediumseagreen: [60, 179, 113, null],
	    mediumslateblue: [123, 104, 238, null],
	    mediumspringgreen: [0, 250, 154, null],
	    mediumturquoise: [72, 209, 204, null],
	    mediumvioletred: [199, 21, 133, null],
	    midnightblue: [25, 25, 112, null],
	    mintcream: [245, 255, 250, null],
	    mistyrose: [255, 228, 225, null],
	    moccasin: [255, 228, 181, null],
	    navajowhite: [255, 222, 173, null],
	    navy: [0, 0, 128, null],
	    oldlace: [253, 245, 230, null],
	    olive: [128, 128, 0, null],
	    olivedrab: [107, 142, 35, null],
	    orange: [255, 165, 0, null],
	    orangered: [255, 69, 0, null],
	    orchid: [218, 112, 214, null],
	    palegoldenrod: [238, 232, 170, null],
	    palegreen: [152, 251, 152, null],
	    paleturquoise: [175, 238, 238, null],
	    palevioletred: [219, 112, 147, null],
	    papayawhip: [255, 239, 213, null],
	    peachpuff: [255, 218, 185, null],
	    peru: [205, 133, 63, null],
	    pink: [255, 192, 203, null],
	    plum: [221, 160, 221, null],
	    powderblue: [176, 224, 230, null],
	    purple: [128, 0, 128, null],
	    rebeccapurple: [102, 51, 153, null],
	    red: [255, 0, 0, null],
	    rosybrown: [188, 143, 143, null],
	    royalblue: [65, 105, 225, null],
	    saddlebrown: [139, 69, 19, null],
	    salmon: [250, 128, 114, null],
	    sandybrown: [244, 164, 96, null],
	    seagreen: [46, 139, 87, null],
	    seashell: [255, 245, 238, null],
	    sienna: [160, 82, 45, null],
	    silver: [192, 192, 192, null],
	    skyblue: [135, 206, 235, null],
	    slateblue: [106, 90, 205, null],
	    slategray: [112, 128, 144, null],
	    slategrey: [112, 128, 144, null],
	    snow: [255, 250, 250, null],
	    springgreen: [0, 255, 127, null],
	    steelblue: [70, 130, 180, null],
	    tan: [210, 180, 140, null],
	    teal: [0, 128, 128, null],
	    thistle: [216, 191, 216, null],
	    tomato: [255, 99, 71, null],
	    turquoise: [64, 224, 208, null],
	    violet: [238, 130, 238, null],
	    wheat: [245, 222, 179, null],
	    white: [255, 255, 255, null],
	    whitesmoke: [245, 245, 245, null],
	    yellow: [255, 255, 0, null],
	    yellowgreen: [154, 205, 50, null]
	};
	
	var TRANSPARENT = exports.TRANSPARENT = new Color([0, 0, 0, 0]);
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/* WEBPACK VAR INJECTION */(function(process) {
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.calculateLengthFromValueWithUnit = exports.LENGTH_TYPE = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _NodeContainer = __webpack_require__(4);
	
	var _NodeContainer2 = _interopRequireDefault(_NodeContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var LENGTH_WITH_UNIT = /([\d.]+)(px|r?em|%)/i;
	
	var LENGTH_TYPE = exports.LENGTH_TYPE = {
	    PX: 0,
	    PERCENTAGE: 1
	};
	
	var Length = function () {
	    function Length(value) {
	        _classCallCheck(this, Length);
	
	        this.type = value.substr(value.length - 1) === '%' ? LENGTH_TYPE.PERCENTAGE : LENGTH_TYPE.PX;
	        var parsedValue = parseFloat(value);
	        if (process.env.NODE_ENV !== 'production' && isNaN(parsedValue)) {
	            console.error('Invalid value given for Length: "' + value + '"');
	        }
	        this.value = isNaN(parsedValue) ? 0 : parsedValue;
	    }
	
	    _createClass(Length, [{
	        key: 'isPercentage',
	        value: function isPercentage() {
	            return this.type === LENGTH_TYPE.PERCENTAGE;
	        }
	    }, {
	        key: 'getAbsoluteValue',
	        value: function getAbsoluteValue(parentLength) {
	            return this.isPercentage() ? parentLength * (this.value / 100) : this.value;
	        }
	    }], [{
	        key: 'create',
	        value: function create(v) {
	            return new Length(v);
	        }
	    }]);
	
	    return Length;
	}();
	
	exports.default = Length;
	
	
	var getRootFontSize = function getRootFontSize(container) {
	    var parent = container.parent;
	    return parent ? getRootFontSize(parent) : parseFloat(container.style.font.fontSize);
	};
	
	var calculateLengthFromValueWithUnit = exports.calculateLengthFromValueWithUnit = function calculateLengthFromValueWithUnit(container, value, unit) {
	    switch (unit) {
	        case 'px':
	        case '%':
	            return new Length(value + unit);
	        case 'em':
	        case 'rem':
	            var length = new Length(value);
	            length.value *= unit === 'em' ? parseFloat(container.style.font.fontSize) : getRootFontSize(container);
	            return length;
	        default:
	            // TODO: handle correctly if unknown unit is used
	            return new Length('0');
	    }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/* WEBPACK VAR INJECTION */(function(process) {
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.parseBoundCurves = exports.calculatePaddingBoxPath = exports.calculateBorderBoxPath = exports.parsePathForBorder = exports.parseDocumentSize = exports.calculateContentBox = exports.calculatePaddingBox = exports.parseBounds = exports.Bounds = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Vector = __webpack_require__(9);
	
	var _Vector2 = _interopRequireDefault(_Vector);
	
	var _BezierCurve = __webpack_require__(40);
	
	var _BezierCurve2 = _interopRequireDefault(_BezierCurve);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var TOP = 0;
	var RIGHT = 1;
	var BOTTOM = 2;
	var LEFT = 3;
	
	var H = 0;
	var V = 1;
	
	var Bounds = exports.Bounds = function () {
	    function Bounds(x, y, w, h) {
	        _classCallCheck(this, Bounds);
	
	        this.left = x;
	        this.top = y;
	        this.width = w;
	        this.height = h;
	    }
	
	    _createClass(Bounds, null, [{
	        key: 'fromClientRect',
	        value: function fromClientRect(clientRect, scrollX, scrollY) {
	            return new Bounds(clientRect.left + scrollX, clientRect.top + scrollY, clientRect.width, clientRect.height);
	        }
	    }]);
	
	    return Bounds;
	}();
	
	var parseBounds = exports.parseBounds = function parseBounds(node, scrollX, scrollY) {
	    return Bounds.fromClientRect(node.getBoundingClientRect(), scrollX, scrollY);
	};
	
	var calculatePaddingBox = exports.calculatePaddingBox = function calculatePaddingBox(bounds, borders) {
	    return new Bounds(bounds.left + borders[LEFT].borderWidth, bounds.top + borders[TOP].borderWidth, bounds.width - (borders[RIGHT].borderWidth + borders[LEFT].borderWidth), bounds.height - (borders[TOP].borderWidth + borders[BOTTOM].borderWidth));
	};
	
	var calculateContentBox = exports.calculateContentBox = function calculateContentBox(bounds, padding, borders) {
	    // TODO support percentage paddings
	    var paddingTop = padding[TOP].value;
	    var paddingRight = padding[RIGHT].value;
	    var paddingBottom = padding[BOTTOM].value;
	    var paddingLeft = padding[LEFT].value;
	
	    return new Bounds(bounds.left + paddingLeft + borders[LEFT].borderWidth, bounds.top + paddingTop + borders[TOP].borderWidth, bounds.width - (borders[RIGHT].borderWidth + borders[LEFT].borderWidth + paddingLeft + paddingRight), bounds.height - (borders[TOP].borderWidth + borders[BOTTOM].borderWidth + paddingTop + paddingBottom));
	};
	
	var parseDocumentSize = exports.parseDocumentSize = function parseDocumentSize(document) {
	    var body = document.body;
	    var documentElement = document.documentElement;
	
	    if (!body || !documentElement) {
	        throw new Error(process.env.NODE_ENV !== 'production' ? 'Unable to get document size' : '');
	    }
	    var width = Math.max(Math.max(body.scrollWidth, documentElement.scrollWidth), Math.max(body.offsetWidth, documentElement.offsetWidth), Math.max(body.clientWidth, documentElement.clientWidth));
	
	    var height = Math.max(Math.max(body.scrollHeight, documentElement.scrollHeight), Math.max(body.offsetHeight, documentElement.offsetHeight), Math.max(body.clientHeight, documentElement.clientHeight));
	
	    return new Bounds(0, 0, width, height);
	};
	
	var parsePathForBorder = exports.parsePathForBorder = function parsePathForBorder(curves, borderSide) {
	    switch (borderSide) {
	        case TOP:
	            return createPathFromCurves(curves.topLeftOuter, curves.topLeftInner, curves.topRightOuter, curves.topRightInner);
	        case RIGHT:
	            return createPathFromCurves(curves.topRightOuter, curves.topRightInner, curves.bottomRightOuter, curves.bottomRightInner);
	        case BOTTOM:
	            return createPathFromCurves(curves.bottomRightOuter, curves.bottomRightInner, curves.bottomLeftOuter, curves.bottomLeftInner);
	        case LEFT:
	        default:
	            return createPathFromCurves(curves.bottomLeftOuter, curves.bottomLeftInner, curves.topLeftOuter, curves.topLeftInner);
	    }
	};
	
	var createPathFromCurves = function createPathFromCurves(outer1, inner1, outer2, inner2) {
	    var path = [];
	    if (outer1 instanceof _BezierCurve2.default) {
	        path.push(outer1.subdivide(0.5, false));
	    } else {
	        path.push(outer1);
	    }
	
	    if (outer2 instanceof _BezierCurve2.default) {
	        path.push(outer2.subdivide(0.5, true));
	    } else {
	        path.push(outer2);
	    }
	
	    if (inner2 instanceof _BezierCurve2.default) {
	        path.push(inner2.subdivide(0.5, true).reverse());
	    } else {
	        path.push(inner2);
	    }
	
	    if (inner1 instanceof _BezierCurve2.default) {
	        path.push(inner1.subdivide(0.5, false).reverse());
	    } else {
	        path.push(inner1);
	    }
	
	    return path;
	};
	
	var calculateBorderBoxPath = exports.calculateBorderBoxPath = function calculateBorderBoxPath(curves) {
	    return [curves.topLeftOuter, curves.topRightOuter, curves.bottomRightOuter, curves.bottomLeftOuter];
	};
	
	var calculatePaddingBoxPath = exports.calculatePaddingBoxPath = function calculatePaddingBoxPath(curves) {
	    return [curves.topLeftInner, curves.topRightInner, curves.bottomRightInner, curves.bottomLeftInner];
	};
	
	var parseBoundCurves = exports.parseBoundCurves = function parseBoundCurves(bounds, borders, borderRadius) {
	    var tlh = borderRadius[CORNER.TOP_LEFT][H].getAbsoluteValue(bounds.width);
	    var tlv = borderRadius[CORNER.TOP_LEFT][V].getAbsoluteValue(bounds.height);
	    var trh = borderRadius[CORNER.TOP_RIGHT][H].getAbsoluteValue(bounds.width);
	    var trv = borderRadius[CORNER.TOP_RIGHT][V].getAbsoluteValue(bounds.height);
	    var brh = borderRadius[CORNER.BOTTOM_RIGHT][H].getAbsoluteValue(bounds.width);
	    var brv = borderRadius[CORNER.BOTTOM_RIGHT][V].getAbsoluteValue(bounds.height);
	    var blh = borderRadius[CORNER.BOTTOM_LEFT][H].getAbsoluteValue(bounds.width);
	    var blv = borderRadius[CORNER.BOTTOM_LEFT][V].getAbsoluteValue(bounds.height);
	
	    var factors = [];
	    factors.push((tlh + trh) / bounds.width);
	    factors.push((blh + brh) / bounds.width);
	    factors.push((tlv + blv) / bounds.height);
	    factors.push((trv + brv) / bounds.height);
	    var maxFactor = Math.max.apply(Math, factors);
	
	    if (maxFactor > 1) {
	        tlh /= maxFactor;
	        tlv /= maxFactor;
	        trh /= maxFactor;
	        trv /= maxFactor;
	        brh /= maxFactor;
	        brv /= maxFactor;
	        blh /= maxFactor;
	        blv /= maxFactor;
	    }
	
	    var topWidth = bounds.width - trh;
	    var rightHeight = bounds.height - brv;
	    var bottomWidth = bounds.width - brh;
	    var leftHeight = bounds.height - blv;
	
	    return {
	        topLeftOuter: tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left, bounds.top, tlh, tlv, CORNER.TOP_LEFT) : new _Vector2.default(bounds.left, bounds.top),
	        topLeftInner: tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borders[LEFT].borderWidth, bounds.top + borders[TOP].borderWidth, Math.max(0, tlh - borders[LEFT].borderWidth), Math.max(0, tlv - borders[TOP].borderWidth), CORNER.TOP_LEFT) : new _Vector2.default(bounds.left + borders[LEFT].borderWidth, bounds.top + borders[TOP].borderWidth),
	        topRightOuter: trh > 0 || trv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top, trh, trv, CORNER.TOP_RIGHT) : new _Vector2.default(bounds.left + bounds.width, bounds.top),
	        topRightInner: trh > 0 || trv > 0 ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width + borders[LEFT].borderWidth), bounds.top + borders[TOP].borderWidth, topWidth > bounds.width + borders[LEFT].borderWidth ? 0 : trh - borders[LEFT].borderWidth, trv - borders[TOP].borderWidth, CORNER.TOP_RIGHT) : new _Vector2.default(bounds.left + bounds.width - borders[RIGHT].borderWidth, bounds.top + borders[TOP].borderWidth),
	        bottomRightOuter: brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh, brv, CORNER.BOTTOM_RIGHT) : new _Vector2.default(bounds.left + bounds.width, bounds.top + bounds.height),
	        bottomRightInner: brh > 0 || brv > 0 ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - borders[LEFT].borderWidth), bounds.top + Math.min(rightHeight, bounds.height + borders[TOP].borderWidth), Math.max(0, brh - borders[RIGHT].borderWidth), brv - borders[BOTTOM].borderWidth, CORNER.BOTTOM_RIGHT) : new _Vector2.default(bounds.left + bounds.width - borders[RIGHT].borderWidth, bounds.top + bounds.height - borders[BOTTOM].borderWidth),
	        bottomLeftOuter: blh > 0 || blv > 0 ? getCurvePoints(bounds.left, bounds.top + leftHeight, blh, blv, CORNER.BOTTOM_LEFT) : new _Vector2.default(bounds.left, bounds.top + bounds.height),
	        bottomLeftInner: blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borders[LEFT].borderWidth, bounds.top + leftHeight, Math.max(0, blh - borders[LEFT].borderWidth), blv - borders[BOTTOM].borderWidth, CORNER.BOTTOM_LEFT) : new _Vector2.default(bounds.left + borders[LEFT].borderWidth, bounds.top + bounds.height - borders[BOTTOM].borderWidth)
	    };
	};
	
	var CORNER = {
	    TOP_LEFT: 0,
	    TOP_RIGHT: 1,
	    BOTTOM_RIGHT: 2,
	    BOTTOM_LEFT: 3
	};
	
	var getCurvePoints = function getCurvePoints(x, y, r1, r2, position) {
	    var kappa = 4 * ((Math.sqrt(2) - 1) / 3);
	    var ox = r1 * kappa; // control point offset horizontal
	    var oy = r2 * kappa; // control point offset vertical
	    var xm = x + r1; // x-middle
	    var ym = y + r2; // y-middle
	
	    switch (position) {
	        case CORNER.TOP_LEFT:
	            return new _BezierCurve2.default(new _Vector2.default(x, ym), new _Vector2.default(x, ym - oy), new _Vector2.default(xm - ox, y), new _Vector2.default(xm, y));
	        case CORNER.TOP_RIGHT:
	            return new _BezierCurve2.default(new _Vector2.default(x, y), new _Vector2.default(x + ox, y), new _Vector2.default(xm, ym - oy), new _Vector2.default(xm, ym));
	        case CORNER.BOTTOM_RIGHT:
	            return new _BezierCurve2.default(new _Vector2.default(xm, y), new _Vector2.default(xm, y + oy), new _Vector2.default(x + ox, ym), new _Vector2.default(x, ym));
	        case CORNER.BOTTOM_LEFT:
	        default:
	            return new _BezierCurve2.default(new _Vector2.default(xm, ym), new _Vector2.default(xm - ox, ym), new _Vector2.default(x, y + oy), new _Vector2.default(x, y));
	    }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/* WEBPACK VAR INJECTION */(function(process) {
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Color = __webpack_require__(1);
	
	var _Color2 = _interopRequireDefault(_Color);
	
	var _Util = __webpack_require__(5);
	
	var _background = __webpack_require__(6);
	
	var _border = __webpack_require__(14);
	
	var _borderRadius = __webpack_require__(41);
	
	var _display = __webpack_require__(42);
	
	var _float = __webpack_require__(43);
	
	var _font = __webpack_require__(44);
	
	var _letterSpacing = __webpack_require__(45);
	
	var _lineBreak = __webpack_require__(46);
	
	var _listStyle = __webpack_require__(10);
	
	var _margin = __webpack_require__(47);
	
	var _overflow = __webpack_require__(48);
	
	var _overflowWrap = __webpack_require__(20);
	
	var _padding = __webpack_require__(19);
	
	var _position = __webpack_require__(21);
	
	var _textDecoration = __webpack_require__(13);
	
	var _textShadow = __webpack_require__(49);
	
	var _textTransform = __webpack_require__(22);
	
	var _transform = __webpack_require__(50);
	
	var _visibility = __webpack_require__(51);
	
	var _wordBreak = __webpack_require__(52);
	
	var _zIndex = __webpack_require__(53);
	
	var _Bounds = __webpack_require__(3);
	
	var _Input = __webpack_require__(23);
	
	var _ListItem = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var INPUT_TAGS = ['INPUT', 'TEXTAREA', 'SELECT'];
	
	var NodeContainer = function () {
	    function NodeContainer(node, parent, resourceLoader, index) {
	        var _this = this;
	
	        _classCallCheck(this, NodeContainer);
	
	        this.parent = parent;
	        this.tagName = node.tagName;
	        this.index = index;
	        this.childNodes = [];
	        this.listItems = [];
	        if (typeof node.start === 'number') {
	            this.listStart = node.start;
	        }
	        var defaultView = node.ownerDocument.defaultView;
	        var scrollX = defaultView.pageXOffset;
	        var scrollY = defaultView.pageYOffset;
	        var style = defaultView.getComputedStyle(node, null);
	        var display = (0, _display.parseDisplay)(style.display);
	
	        var IS_INPUT = node.type === 'radio' || node.type === 'checkbox';
	
	        var position = (0, _position.parsePosition)(style.position);
	
	        this.style = {
	            background: IS_INPUT ? _Input.INPUT_BACKGROUND : (0, _background.parseBackground)(style, resourceLoader),
	            border: IS_INPUT ? _Input.INPUT_BORDERS : (0, _border.parseBorder)(style),
	            borderRadius: (node instanceof defaultView.HTMLInputElement || node instanceof HTMLInputElement) && IS_INPUT ? (0, _Input.getInputBorderRadius)(node) : (0, _borderRadius.parseBorderRadius)(style),
	            color: IS_INPUT ? _Input.INPUT_COLOR : new _Color2.default(style.color),
	            display: display,
	            float: (0, _float.parseCSSFloat)(style.float),
	            font: (0, _font.parseFont)(style),
	            letterSpacing: (0, _letterSpacing.parseLetterSpacing)(style.letterSpacing),
	            listStyle: display === _display.DISPLAY.LIST_ITEM ? (0, _listStyle.parseListStyle)(style) : null,
	            lineBreak: (0, _lineBreak.parseLineBreak)(style.lineBreak),
	            margin: (0, _margin.parseMargin)(style),
	            opacity: parseFloat(style.opacity),
	            overflow: INPUT_TAGS.indexOf(node.tagName) === -1 ? (0, _overflow.parseOverflow)(style.overflow) : _overflow.OVERFLOW.HIDDEN,
	            overflowWrap: (0, _overflowWrap.parseOverflowWrap)(style.overflowWrap ? style.overflowWrap : style.wordWrap),
	            padding: (0, _padding.parsePadding)(style),
	            position: position,
	            textDecoration: (0, _textDecoration.parseTextDecoration)(style),
	            textShadow: (0, _textShadow.parseTextShadow)(style.textShadow),
	            textTransform: (0, _textTransform.parseTextTransform)(style.textTransform),
	            transform: (0, _transform.parseTransform)(style),
	            visibility: (0, _visibility.parseVisibility)(style.visibility),
	            wordBreak: (0, _wordBreak.parseWordBreak)(style.wordBreak),
	            zIndex: (0, _zIndex.parseZIndex)(position !== _position.POSITION.STATIC ? style.zIndex : 'auto')
	        };
	
	        if (this.isTransformed()) {
	            // getBoundingClientRect provides values post-transform, we want them without the transformation
	            node.style.transform = 'matrix(1,0,0,1,0,0)';
	        }
	
	        if (display === _display.DISPLAY.LIST_ITEM) {
	            var listOwner = (0, _ListItem.getListOwner)(this);
	            if (listOwner) {
	                var listIndex = listOwner.listItems.length;
	                listOwner.listItems.push(this);
	                this.listIndex = node.hasAttribute('value') && typeof node.value === 'number' ? node.value : listIndex === 0 ? typeof listOwner.listStart === 'number' ? listOwner.listStart : 1 : listOwner.listItems[listIndex - 1].listIndex + 1;
	            }
	        }
	
	        // TODO move bound retrieval for all nodes to a later stage?
	        if (node.tagName === 'IMG') {
	            node.addEventListener('load', function () {
	                _this.bounds = (0, _Bounds.parseBounds)(node, scrollX, scrollY);
	                _this.curvedBounds = (0, _Bounds.parseBoundCurves)(_this.bounds, _this.style.border, _this.style.borderRadius);
	            });
	        }
	        this.image = getImage(node, resourceLoader);
	        this.bounds = IS_INPUT ? (0, _Input.reformatInputBounds)((0, _Bounds.parseBounds)(node, scrollX, scrollY)) : (0, _Bounds.parseBounds)(node, scrollX, scrollY);
	        this.curvedBounds = (0, _Bounds.parseBoundCurves)(this.bounds, this.style.border, this.style.borderRadius);
	
	        if (process.env.NODE_ENV !== 'production') {
	            this.name = '' + node.tagName.toLowerCase() + (node.id ? '#' + node.id : '') + node.className.toString().split(' ').map(function (s) {
	                return s.length ? '.' + s : '';
	            }).join('');
	        }
	    }
	
	    _createClass(NodeContainer, [{
	        key: 'getClipPaths',
	        value: function getClipPaths() {
	            var parentClips = this.parent ? this.parent.getClipPaths() : [];
	            var isClipped = this.style.overflow !== _overflow.OVERFLOW.VISIBLE;
	
	            return isClipped ? parentClips.concat([(0, _Bounds.calculatePaddingBoxPath)(this.curvedBounds)]) : parentClips;
	        }
	    }, {
	        key: 'isInFlow',
	        value: function isInFlow() {
	            return this.isRootElement() && !this.isFloating() && !this.isAbsolutelyPositioned();
	        }
	    }, {
	        key: 'isVisible',
	        value: function isVisible() {
	            return !(0, _Util.contains)(this.style.display, _display.DISPLAY.NONE) && this.style.opacity > 0 && this.style.visibility === _visibility.VISIBILITY.VISIBLE;
	        }
	    }, {
	        key: 'isAbsolutelyPositioned',
	        value: function isAbsolutelyPositioned() {
	            return this.style.position !== _position.POSITION.STATIC && this.style.position !== _position.POSITION.RELATIVE;
	        }
	    }, {
	        key: 'isPositioned',
	        value: function isPositioned() {
	            return this.style.position !== _position.POSITION.STATIC;
	        }
	    }, {
	        key: 'isFloating',
	        value: function isFloating() {
	            return this.style.float !== _float.FLOAT.NONE;
	        }
	    }, {
	        key: 'isRootElement',
	        value: function isRootElement() {
	            return this.parent === null;
	        }
	    }, {
	        key: 'isTransformed',
	        value: function isTransformed() {
	            return this.style.transform !== null;
	        }
	    }, {
	        key: 'isPositionedWithZIndex',
	        value: function isPositionedWithZIndex() {
	            return this.isPositioned() && !this.style.zIndex.auto;
	        }
	    }, {
	        key: 'isInlineLevel',
	        value: function isInlineLevel() {
	            return (0, _Util.contains)(this.style.display, _display.DISPLAY.INLINE) || (0, _Util.contains)(this.style.display, _display.DISPLAY.INLINE_BLOCK) || (0, _Util.contains)(this.style.display, _display.DISPLAY.INLINE_FLEX) || (0, _Util.contains)(this.style.display, _display.DISPLAY.INLINE_GRID) || (0, _Util.contains)(this.style.display, _display.DISPLAY.INLINE_LIST_ITEM) || (0, _Util.contains)(this.style.display, _display.DISPLAY.INLINE_TABLE);
	        }
	    }, {
	        key: 'isInlineBlockOrInlineTable',
	        value: function isInlineBlockOrInlineTable() {
	            return (0, _Util.contains)(this.style.display, _display.DISPLAY.INLINE_BLOCK) || (0, _Util.contains)(this.style.display, _display.DISPLAY.INLINE_TABLE);
	        }
	    }]);
	
	    return NodeContainer;
	}();
	
	exports.default = NodeContainer;
	
	
	var getImage = function getImage(node, resourceLoader) {
	    if (node instanceof node.ownerDocument.defaultView.SVGSVGElement || node instanceof SVGSVGElement) {
	        var s = new XMLSerializer();
	        return resourceLoader.loadImage('data:image/svg+xml,' + encodeURIComponent(s.serializeToString(node)));
	    }
	    switch (node.tagName) {
	        case 'IMG':
	            // $FlowFixMe
	            var img = node;
	            return resourceLoader.loadImage(img.currentSrc || img.src);
	        case 'CANVAS':
	            // $FlowFixMe
	            var canvas = node;
	            return resourceLoader.loadCanvas(canvas);
	        case 'IFRAME':
	            var iframeKey = node.getAttribute('data-html2canvas-internal-iframe-key');
	            if (iframeKey) {
	                return iframeKey;
	            }
	            break;
	    }
	
	    return null;
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var contains = exports.contains = function contains(bit, value) {
	    return (bit & value) !== 0;
	};
	
	var distance = exports.distance = function distance(a, b) {
	    return Math.sqrt(a * a + b * b);
	};
	
	var copyCSSStyles = exports.copyCSSStyles = function copyCSSStyles(style, target) {
	    // Edge does not provide value for cssText
	    for (var i = style.length - 1; i >= 0; i--) {
	        var property = style.item(i);
	        // Safari shows pseudoelements if content is set
	        if (property !== 'content') {
	            target.style.setProperty(property, style.getPropertyValue(property));
	        }
	    }
	    return target;
	};
	
	var SMALL_IMAGE = exports.SMALL_IMAGE = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
	
	/***/ }),
	/* 6 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/* WEBPACK VAR INJECTION */(function(process) {
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.parseBackgroundImage = exports.parseBackground = exports.calculateBackgroundRepeatPath = exports.calculateBackgroundPosition = exports.calculateBackgroungPositioningArea = exports.calculateBackgroungPaintingArea = exports.calculateGradientBackgroundSize = exports.calculateBackgroundSize = exports.BACKGROUND_ORIGIN = exports.BACKGROUND_CLIP = exports.BACKGROUND_SIZE = exports.BACKGROUND_REPEAT = undefined;
	
	var _Color = __webpack_require__(1);
	
	var _Color2 = _interopRequireDefault(_Color);
	
	var _Length = __webpack_require__(2);
	
	var _Length2 = _interopRequireDefault(_Length);
	
	var _Size = __webpack_require__(39);
	
	var _Size2 = _interopRequireDefault(_Size);
	
	var _Vector = __webpack_require__(9);
	
	var _Vector2 = _interopRequireDefault(_Vector);
	
	var _Bounds = __webpack_require__(3);
	
	var _padding = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var BACKGROUND_REPEAT = exports.BACKGROUND_REPEAT = {
	    REPEAT: 0,
	    NO_REPEAT: 1,
	    REPEAT_X: 2,
	    REPEAT_Y: 3
	};
	
	var BACKGROUND_SIZE = exports.BACKGROUND_SIZE = {
	    AUTO: 0,
	    CONTAIN: 1,
	    COVER: 2,
	    LENGTH: 3
	};
	
	var BACKGROUND_CLIP = exports.BACKGROUND_CLIP = {
	    BORDER_BOX: 0,
	    PADDING_BOX: 1,
	    CONTENT_BOX: 2
	};
	
	var BACKGROUND_ORIGIN = exports.BACKGROUND_ORIGIN = BACKGROUND_CLIP;
	
	var AUTO = 'auto';
	
	var BackgroundSize = function BackgroundSize(size) {
	    _classCallCheck(this, BackgroundSize);
	
	    switch (size) {
	        case 'contain':
	            this.size = BACKGROUND_SIZE.CONTAIN;
	            break;
	        case 'cover':
	            this.size = BACKGROUND_SIZE.COVER;
	            break;
	        case 'auto':
	            this.size = BACKGROUND_SIZE.AUTO;
	            break;
	        default:
	            this.value = new _Length2.default(size);
	    }
	};
	
	var calculateBackgroundSize = exports.calculateBackgroundSize = function calculateBackgroundSize(backgroundImage, image, bounds) {
	    var width = 0;
	    var height = 0;
	    var size = backgroundImage.size;
	    if (size[0].size === BACKGROUND_SIZE.CONTAIN || size[0].size === BACKGROUND_SIZE.COVER) {
	        var targetRatio = bounds.width / bounds.height;
	        var currentRatio = image.width / image.height;
	        return targetRatio < currentRatio !== (size[0].size === BACKGROUND_SIZE.COVER) ? new _Size2.default(bounds.width, bounds.width / currentRatio) : new _Size2.default(bounds.height * currentRatio, bounds.height);
	    }
	
	    if (size[0].value) {
	        width = size[0].value.getAbsoluteValue(bounds.width);
	    }
	
	    if (size[0].size === BACKGROUND_SIZE.AUTO && size[1].size === BACKGROUND_SIZE.AUTO) {
	        height = image.height;
	    } else if (size[1].size === BACKGROUND_SIZE.AUTO) {
	        height = width / image.width * image.height;
	    } else if (size[1].value) {
	        height = size[1].value.getAbsoluteValue(bounds.height);
	    }
	
	    if (size[0].size === BACKGROUND_SIZE.AUTO) {
	        width = height / image.height * image.width;
	    }
	
	    return new _Size2.default(width, height);
	};
	
	var calculateGradientBackgroundSize = exports.calculateGradientBackgroundSize = function calculateGradientBackgroundSize(backgroundImage, bounds) {
	    var size = backgroundImage.size;
	    var width = size[0].value ? size[0].value.getAbsoluteValue(bounds.width) : bounds.width;
	    var height = size[1].value ? size[1].value.getAbsoluteValue(bounds.height) : size[0].value ? width : bounds.height;
	
	    return new _Size2.default(width, height);
	};
	
	var AUTO_SIZE = new BackgroundSize(AUTO);
	
	var calculateBackgroungPaintingArea = exports.calculateBackgroungPaintingArea = function calculateBackgroungPaintingArea(curves, clip) {
	    switch (clip) {
	        case BACKGROUND_CLIP.BORDER_BOX:
	            return (0, _Bounds.calculateBorderBoxPath)(curves);
	        case BACKGROUND_CLIP.PADDING_BOX:
	        default:
	            return (0, _Bounds.calculatePaddingBoxPath)(curves);
	    }
	};
	
	var calculateBackgroungPositioningArea = exports.calculateBackgroungPositioningArea = function calculateBackgroungPositioningArea(backgroundOrigin, bounds, padding, border) {
	    var paddingBox = (0, _Bounds.calculatePaddingBox)(bounds, border);
	
	    switch (backgroundOrigin) {
	        case BACKGROUND_ORIGIN.BORDER_BOX:
	            return bounds;
	        case BACKGROUND_ORIGIN.CONTENT_BOX:
	            var paddingLeft = padding[_padding.PADDING_SIDES.LEFT].getAbsoluteValue(bounds.width);
	            var paddingRight = padding[_padding.PADDING_SIDES.RIGHT].getAbsoluteValue(bounds.width);
	            var paddingTop = padding[_padding.PADDING_SIDES.TOP].getAbsoluteValue(bounds.width);
	            var paddingBottom = padding[_padding.PADDING_SIDES.BOTTOM].getAbsoluteValue(bounds.width);
	            return new _Bounds.Bounds(paddingBox.left + paddingLeft, paddingBox.top + paddingTop, paddingBox.width - paddingLeft - paddingRight, paddingBox.height - paddingTop - paddingBottom);
	        case BACKGROUND_ORIGIN.PADDING_BOX:
	        default:
	            return paddingBox;
	    }
	};
	
	var calculateBackgroundPosition = exports.calculateBackgroundPosition = function calculateBackgroundPosition(position, size, bounds) {
	    return new _Vector2.default(position[0].getAbsoluteValue(bounds.width - size.width), position[1].getAbsoluteValue(bounds.height - size.height));
	};
	
	var calculateBackgroundRepeatPath = exports.calculateBackgroundRepeatPath = function calculateBackgroundRepeatPath(background, position, size, backgroundPositioningArea, bounds) {
	    var repeat = background.repeat;
	    switch (repeat) {
	        case BACKGROUND_REPEAT.REPEAT_X:
	            return [new _Vector2.default(Math.round(bounds.left), Math.round(backgroundPositioningArea.top + position.y)), new _Vector2.default(Math.round(bounds.left + bounds.width), Math.round(backgroundPositioningArea.top + position.y)), new _Vector2.default(Math.round(bounds.left + bounds.width), Math.round(size.height + backgroundPositioningArea.top + position.y)), new _Vector2.default(Math.round(bounds.left), Math.round(size.height + backgroundPositioningArea.top + position.y))];
	        case BACKGROUND_REPEAT.REPEAT_Y:
	            return [new _Vector2.default(Math.round(backgroundPositioningArea.left + position.x), Math.round(bounds.top)), new _Vector2.default(Math.round(backgroundPositioningArea.left + position.x + size.width), Math.round(bounds.top)), new _Vector2.default(Math.round(backgroundPositioningArea.left + position.x + size.width), Math.round(bounds.height + bounds.top)), new _Vector2.default(Math.round(backgroundPositioningArea.left + position.x), Math.round(bounds.height + bounds.top))];
	        case BACKGROUND_REPEAT.NO_REPEAT:
	            return [new _Vector2.default(Math.round(backgroundPositioningArea.left + position.x), Math.round(backgroundPositioningArea.top + position.y)), new _Vector2.default(Math.round(backgroundPositioningArea.left + position.x + size.width), Math.round(backgroundPositioningArea.top + position.y)), new _Vector2.default(Math.round(backgroundPositioningArea.left + position.x + size.width), Math.round(backgroundPositioningArea.top + position.y + size.height)), new _Vector2.default(Math.round(backgroundPositioningArea.left + position.x), Math.round(backgroundPositioningArea.top + position.y + size.height))];
	        default:
	            return [new _Vector2.default(Math.round(bounds.left), Math.round(bounds.top)), new _Vector2.default(Math.round(bounds.left + bounds.width), Math.round(bounds.top)), new _Vector2.default(Math.round(bounds.left + bounds.width), Math.round(bounds.height + bounds.top)), new _Vector2.default(Math.round(bounds.left), Math.round(bounds.height + bounds.top))];
	    }
	};
	
	var parseBackground = exports.parseBackground = function parseBackground(style, resourceLoader) {
	    return {
	        backgroundColor: new _Color2.default(style.backgroundColor),
	        backgroundImage: parseBackgroundImages(style, resourceLoader),
	        backgroundClip: parseBackgroundClip(style.backgroundClip),
	        backgroundOrigin: parseBackgroundOrigin(style.backgroundOrigin)
	    };
	};
	
	var parseBackgroundClip = function parseBackgroundClip(backgroundClip) {
	    switch (backgroundClip) {
	        case 'padding-box':
	            return BACKGROUND_CLIP.PADDING_BOX;
	        case 'content-box':
	            return BACKGROUND_CLIP.CONTENT_BOX;
	    }
	    return BACKGROUND_CLIP.BORDER_BOX;
	};
	
	var parseBackgroundOrigin = function parseBackgroundOrigin(backgroundOrigin) {
	    switch (backgroundOrigin) {
	        case 'padding-box':
	            return BACKGROUND_ORIGIN.PADDING_BOX;
	        case 'content-box':
	            return BACKGROUND_ORIGIN.CONTENT_BOX;
	    }
	    return BACKGROUND_ORIGIN.BORDER_BOX;
	};
	
	var parseBackgroundRepeat = function parseBackgroundRepeat(backgroundRepeat) {
	    switch (backgroundRepeat.trim()) {
	        case 'no-repeat':
	            return BACKGROUND_REPEAT.NO_REPEAT;
	        case 'repeat-x':
	        case 'repeat no-repeat':
	            return BACKGROUND_REPEAT.REPEAT_X;
	        case 'repeat-y':
	        case 'no-repeat repeat':
	            return BACKGROUND_REPEAT.REPEAT_Y;
	        case 'repeat':
	            return BACKGROUND_REPEAT.REPEAT;
	    }
	
	    if (process.env.NODE_ENV !== 'production') {
	        console.error('Invalid background-repeat value "' + backgroundRepeat + '"');
	    }
	
	    return BACKGROUND_REPEAT.REPEAT;
	};
	
	var parseBackgroundImages = function parseBackgroundImages(style, resourceLoader) {
	    var sources = parseBackgroundImage(style.backgroundImage).map(function (backgroundImage) {
	        if (backgroundImage.method === 'url') {
	            var key = resourceLoader.loadImage(backgroundImage.args[0]);
	            backgroundImage.args = key ? [key] : [];
	        }
	        return backgroundImage;
	    });
	    var positions = style.backgroundPosition.split(',');
	    var repeats = style.backgroundRepeat.split(',');
	    var sizes = style.backgroundSize.split(',');
	
	    return sources.map(function (source, index) {
	        var size = (sizes[index] || AUTO).trim().split(' ').map(parseBackgroundSize);
	        var position = (positions[index] || AUTO).trim().split(' ').map(parseBackgoundPosition);
	
	        return {
	            source: source,
	            repeat: parseBackgroundRepeat(typeof repeats[index] === 'string' ? repeats[index] : repeats[0]),
	            size: size.length < 2 ? [size[0], AUTO_SIZE] : [size[0], size[1]],
	            position: position.length < 2 ? [position[0], position[0]] : [position[0], position[1]]
	        };
	    });
	};
	
	var parseBackgroundSize = function parseBackgroundSize(size) {
	    return size === 'auto' ? AUTO_SIZE : new BackgroundSize(size);
	};
	
	var parseBackgoundPosition = function parseBackgoundPosition(position) {
	    switch (position) {
	        case 'bottom':
	        case 'right':
	            return new _Length2.default('100%');
	        case 'left':
	        case 'top':
	            return new _Length2.default('0%');
	        case 'auto':
	            return new _Length2.default('0');
	    }
	    return new _Length2.default(position);
	};
	
	var parseBackgroundImage = exports.parseBackgroundImage = function parseBackgroundImage(image) {
	    var whitespace = /^\s$/;
	    var results = [];
	
	    var args = [];
	    var method = '';
	    var quote = null;
	    var definition = '';
	    var mode = 0;
	    var numParen = 0;
	
	    var appendResult = function appendResult() {
	        var prefix = '';
	        if (method) {
	            if (definition.substr(0, 1) === '"') {
	                definition = definition.substr(1, definition.length - 2);
	            }
	
	            if (definition) {
	                args.push(definition.trim());
	            }
	
	            var prefix_i = method.indexOf('-', 1) + 1;
	            if (method.substr(0, 1) === '-' && prefix_i > 0) {
	                prefix = method.substr(0, prefix_i).toLowerCase();
	                method = method.substr(prefix_i);
	            }
	            method = method.toLowerCase();
	            if (method !== 'none') {
	                results.push({
	                    prefix: prefix,
	                    method: method,
	                    args: args
	                });
	            }
	        }
	        args = [];
	        method = definition = '';
	    };
	
	    image.split('').forEach(function (c) {
	        if (mode === 0 && whitespace.test(c)) {
	            return;
	        }
	        switch (c) {
	            case '"':
	                if (!quote) {
	                    quote = c;
	                } else if (quote === c) {
	                    quote = null;
	                }
	                break;
	            case '(':
	                if (quote) {
	                    break;
	                } else if (mode === 0) {
	                    mode = 1;
	                    return;
	                } else {
	                    numParen++;
	                }
	                break;
	            case ')':
	                if (quote) {
	                    break;
	                } else if (mode === 1) {
	                    if (numParen === 0) {
	                        mode = 0;
	                        appendResult();
	                        return;
	                    } else {
	                        numParen--;
	                    }
	                }
	                break;
	
	            case ',':
	                if (quote) {
	                    break;
	                } else if (mode === 0) {
	                    appendResult();
	                    return;
	                } else if (mode === 1) {
	                    if (numParen === 0 && !method.match(/^url$/i)) {
	                        args.push(definition.trim());
	                        definition = '';
	                        return;
	                    }
	                }
	                break;
	        }
	
	        if (mode === 0) {
	            method += c;
	        } else {
	            definition += c;
	        }
	    });
	
	    appendResult();
	    return results;
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))
	
	/***/ }),
	/* 7 */
	/***/ (function(module, exports) {
	
	var g;
	
	// This works in non-strict mode
	g = (function() {
		return this;
	})();
	
	try {
		// This works if eval is allowed (see CSP)
		g = g || Function("return this")() || (1,eval)("this");
	} catch(e) {
		// This works if the window reference is available
		if(typeof window === "object")
			g = window;
	}
	
	// g can still be undefined, but nothing to do about it...
	// We return undefined, instead of nothing here, so it's
	// easier to handle this case. if(!global) { ...}
	
	module.exports = g;
	
	
	/***/ }),
	/* 8 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var PATH = exports.PATH = {
	    VECTOR: 0,
	    BEZIER_CURVE: 1,
	    CIRCLE: 2
	};
	
	/***/ }),
	/* 9 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/* WEBPACK VAR INJECTION */(function(process) {
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _Path = __webpack_require__(8);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Vector = function Vector(x, y) {
	    _classCallCheck(this, Vector);
	
	    this.type = _Path.PATH.VECTOR;
	    this.x = x;
	    this.y = y;
	    if (process.env.NODE_ENV !== 'production') {
	        if (isNaN(x)) {
	            console.error('Invalid x value given for Vector');
	        }
	        if (isNaN(y)) {
	            console.error('Invalid y value given for Vector');
	        }
	    }
	};
	
	exports.default = Vector;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))
	
	/***/ }),
	/* 10 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.parseListStyle = exports.parseListStyleType = exports.LIST_STYLE_TYPE = exports.LIST_STYLE_POSITION = undefined;
	
	var _background = __webpack_require__(6);
	
	var LIST_STYLE_POSITION = exports.LIST_STYLE_POSITION = {
	    INSIDE: 0,
	    OUTSIDE: 1
	};
	
	var LIST_STYLE_TYPE = exports.LIST_STYLE_TYPE = {
	    NONE: -1,
	    DISC: 0,
	    CIRCLE: 1,
	    SQUARE: 2,
	    DECIMAL: 3,
	    CJK_DECIMAL: 4,
	    DECIMAL_LEADING_ZERO: 5,
	    LOWER_ROMAN: 6,
	    UPPER_ROMAN: 7,
	    LOWER_GREEK: 8,
	    LOWER_ALPHA: 9,
	    UPPER_ALPHA: 10,
	    ARABIC_INDIC: 11,
	    ARMENIAN: 12,
	    BENGALI: 13,
	    CAMBODIAN: 14,
	    CJK_EARTHLY_BRANCH: 15,
	    CJK_HEAVENLY_STEM: 16,
	    CJK_IDEOGRAPHIC: 17,
	    DEVANAGARI: 18,
	    ETHIOPIC_NUMERIC: 19,
	    GEORGIAN: 20,
	    GUJARATI: 21,
	    GURMUKHI: 22,
	    HEBREW: 22,
	    HIRAGANA: 23,
	    HIRAGANA_IROHA: 24,
	    JAPANESE_FORMAL: 25,
	    JAPANESE_INFORMAL: 26,
	    KANNADA: 27,
	    KATAKANA: 28,
	    KATAKANA_IROHA: 29,
	    KHMER: 30,
	    KOREAN_HANGUL_FORMAL: 31,
	    KOREAN_HANJA_FORMAL: 32,
	    KOREAN_HANJA_INFORMAL: 33,
	    LAO: 34,
	    LOWER_ARMENIAN: 35,
	    MALAYALAM: 36,
	    MONGOLIAN: 37,
	    MYANMAR: 38,
	    ORIYA: 39,
	    PERSIAN: 40,
	    SIMP_CHINESE_FORMAL: 41,
	    SIMP_CHINESE_INFORMAL: 42,
	    TAMIL: 43,
	    TELUGU: 44,
	    THAI: 45,
	    TIBETAN: 46,
	    TRAD_CHINESE_FORMAL: 47,
	    TRAD_CHINESE_INFORMAL: 48,
	    UPPER_ARMENIAN: 49,
	    DISCLOSURE_OPEN: 50,
	    DISCLOSURE_CLOSED: 51
	};
	
	var parseListStyleType = exports.parseListStyleType = function parseListStyleType(type) {
	    switch (type) {
	        case 'disc':
	            return LIST_STYLE_TYPE.DISC;
	        case 'circle':
	            return LIST_STYLE_TYPE.CIRCLE;
	        case 'square':
	            return LIST_STYLE_TYPE.SQUARE;
	        case 'decimal':
	            return LIST_STYLE_TYPE.DECIMAL;
	        case 'cjk-decimal':
	            return LIST_STYLE_TYPE.CJK_DECIMAL;
	        case 'decimal-leading-zero':
	            return LIST_STYLE_TYPE.DECIMAL_LEADING_ZERO;
	        case 'lower-roman':
	            return LIST_STYLE_TYPE.LOWER_ROMAN;
	        case 'upper-roman':
	            return LIST_STYLE_TYPE.UPPER_ROMAN;
	        case 'lower-greek':
	            return LIST_STYLE_TYPE.LOWER_GREEK;
	        case 'lower-alpha':
	            return LIST_STYLE_TYPE.LOWER_ALPHA;
	        case 'upper-alpha':
	            return LIST_STYLE_TYPE.UPPER_ALPHA;
	        case 'arabic-indic':
	            return LIST_STYLE_TYPE.ARABIC_INDIC;
	        case 'armenian':
	            return LIST_STYLE_TYPE.ARMENIAN;
	        case 'bengali':
	            return LIST_STYLE_TYPE.BENGALI;
	        case 'cambodian':
	            return LIST_STYLE_TYPE.CAMBODIAN;
	        case 'cjk-earthly-branch':
	            return LIST_STYLE_TYPE.CJK_EARTHLY_BRANCH;
	        case 'cjk-heavenly-stem':
	            return LIST_STYLE_TYPE.CJK_HEAVENLY_STEM;
	        case 'cjk-ideographic':
	            return LIST_STYLE_TYPE.CJK_IDEOGRAPHIC;
	        case 'devanagari':
	            return LIST_STYLE_TYPE.DEVANAGARI;
	        case 'ethiopic-numeric':
	            return LIST_STYLE_TYPE.ETHIOPIC_NUMERIC;
	        case 'georgian':
	            return LIST_STYLE_TYPE.GEORGIAN;
	        case 'gujarati':
	            return LIST_STYLE_TYPE.GUJARATI;
	        case 'gurmukhi':
	            return LIST_STYLE_TYPE.GURMUKHI;
	        case 'hebrew':
	            return LIST_STYLE_TYPE.HEBREW;
	        case 'hiragana':
	            return LIST_STYLE_TYPE.HIRAGANA;
	        case 'hiragana-iroha':
	            return LIST_STYLE_TYPE.HIRAGANA_IROHA;
	        case 'japanese-formal':
	            return LIST_STYLE_TYPE.JAPANESE_FORMAL;
	        case 'japanese-informal':
	            return LIST_STYLE_TYPE.JAPANESE_INFORMAL;
	        case 'kannada':
	            return LIST_STYLE_TYPE.KANNADA;
	        case 'katakana':
	            return LIST_STYLE_TYPE.KATAKANA;
	        case 'katakana-iroha':
	            return LIST_STYLE_TYPE.KATAKANA_IROHA;
	        case 'khmer':
	            return LIST_STYLE_TYPE.KHMER;
	        case 'korean-hangul-formal':
	            return LIST_STYLE_TYPE.KOREAN_HANGUL_FORMAL;
	        case 'korean-hanja-formal':
	            return LIST_STYLE_TYPE.KOREAN_HANJA_FORMAL;
	        case 'korean-hanja-informal':
	            return LIST_STYLE_TYPE.KOREAN_HANJA_INFORMAL;
	        case 'lao':
	            return LIST_STYLE_TYPE.LAO;
	        case 'lower-armenian':
	            return LIST_STYLE_TYPE.LOWER_ARMENIAN;
	        case 'malayalam':
	            return LIST_STYLE_TYPE.MALAYALAM;
	        case 'mongolian':
	            return LIST_STYLE_TYPE.MONGOLIAN;
	        case 'myanmar':
	            return LIST_STYLE_TYPE.MYANMAR;
	        case 'oriya':
	            return LIST_STYLE_TYPE.ORIYA;
	        case 'persian':
	            return LIST_STYLE_TYPE.PERSIAN;
	        case 'simp-chinese-formal':
	            return LIST_STYLE_TYPE.SIMP_CHINESE_FORMAL;
	        case 'simp-chinese-informal':
	            return LIST_STYLE_TYPE.SIMP_CHINESE_INFORMAL;
	        case 'tamil':
	            return LIST_STYLE_TYPE.TAMIL;
	        case 'telugu':
	            return LIST_STYLE_TYPE.TELUGU;
	        case 'thai':
	            return LIST_STYLE_TYPE.THAI;
	        case 'tibetan':
	            return LIST_STYLE_TYPE.TIBETAN;
	        case 'trad-chinese-formal':
	            return LIST_STYLE_TYPE.TRAD_CHINESE_FORMAL;
	        case 'trad-chinese-informal':
	            return LIST_STYLE_TYPE.TRAD_CHINESE_INFORMAL;
	        case 'upper-armenian':
	            return LIST_STYLE_TYPE.UPPER_ARMENIAN;
	        case 'disclosure-open':
	            return LIST_STYLE_TYPE.DISCLOSURE_OPEN;
	        case 'disclosure-closed':
	            return LIST_STYLE_TYPE.DISCLOSURE_CLOSED;
	        case 'none':
	        default:
	            return LIST_STYLE_TYPE.NONE;
	    }
	};
	
	var parseListStyle = exports.parseListStyle = function parseListStyle(style) {
	    var listStyleImage = (0, _background.parseBackgroundImage)(style.getPropertyValue('list-style-image'));
	    return {
	        listStyleType: parseListStyleType(style.getPropertyValue('list-style-type')),
	        listStyleImage: listStyleImage.length ? listStyleImage[0] : null,
	        listStylePosition: parseListStylePosition(style.getPropertyValue('list-style-position'))
	    };
	};
	
	var parseListStylePosition = function parseListStylePosition(position) {
	    switch (position) {
	        case 'inside':
	            return LIST_STYLE_POSITION.INSIDE;
	        case 'outside':
	        default:
	            return LIST_STYLE_POSITION.OUTSIDE;
	    }
	};
	
	/***/ }),
	/* 11 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _textTransform = __webpack_require__(22);
	
	var _TextBounds = __webpack_require__(24);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var TextContainer = function () {
	    function TextContainer(text, parent, bounds) {
	        _classCallCheck(this, TextContainer);
	
	        this.text = text;
	        this.parent = parent;
	        this.bounds = bounds;
	    }
	
	    _createClass(TextContainer, null, [{
	        key: 'fromTextNode',
	        value: function fromTextNode(node, parent) {
	            var text = transform(node.data, parent.style.textTransform);
	            return new TextContainer(text, parent, (0, _TextBounds.parseTextBounds)(text, parent, node));
	        }
	    }]);
	
	    return TextContainer;
	}();
	
	exports.default = TextContainer;
	
	
	var CAPITALIZE = /(^|\s|:|-|\(|\))([a-z])/g;
	
	var transform = function transform(text, _transform) {
	    switch (_transform) {
	        case _textTransform.TEXT_TRANSFORM.LOWERCASE:
	            return text.toLowerCase();
	        case _textTransform.TEXT_TRANSFORM.CAPITALIZE:
	            return text.replace(CAPITALIZE, capitalize);
	        case _textTransform.TEXT_TRANSFORM.UPPERCASE:
	            return text.toUpperCase();
	        default:
	            return text;
	    }
	};
	
	function capitalize(m, p1, p2) {
	    if (m.length > 0) {
	        return p1 + p2.toUpperCase();
	    }
	
	    return m;
	}
	
	/***/ }),
	/* 12 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _ForeignObjectRenderer = __webpack_require__(25);
	
	var testRangeBounds = function testRangeBounds(document) {
	    var TEST_HEIGHT = 123;
	
	    if (document.createRange) {
	        var range = document.createRange();
	        if (range.getBoundingClientRect) {
	            var testElement = document.createElement('boundtest');
	            testElement.style.height = TEST_HEIGHT + 'px';
	            testElement.style.display = 'block';
	            document.body.appendChild(testElement);
	
	            range.selectNode(testElement);
	            var rangeBounds = range.getBoundingClientRect();
	            var rangeHeight = Math.round(rangeBounds.height);
	            document.body.removeChild(testElement);
	            if (rangeHeight === TEST_HEIGHT) {
	                return true;
	            }
	        }
	    }
	
	    return false;
	};
	
	// iOS 10.3 taints canvas with base64 images unless crossOrigin = 'anonymous'
	var testBase64 = function testBase64(document, src) {
	    var img = new Image();
	    var canvas = document.createElement('canvas');
	    var ctx = canvas.getContext('2d');
	
	    return new Promise(function (resolve) {
	        // Single pixel base64 image renders fine on iOS 10.3???
	        img.src = src;
	
	        var onload = function onload() {
	            try {
	                ctx.drawImage(img, 0, 0);
	                canvas.toDataURL();
	            } catch (e) {
	                return resolve(false);
	            }
	
	            return resolve(true);
	        };
	
	        img.onload = onload;
	        img.onerror = function () {
	            return resolve(false);
	        };
	
	        if (img.complete === true) {
	            setTimeout(function () {
	                onload();
	            }, 500);
	        }
	    });
	};
	
	var testCORS = function testCORS() {
	    return typeof new Image().crossOrigin !== 'undefined';
	};
	
	var testResponseType = function testResponseType() {
	    return typeof new XMLHttpRequest().responseType === 'string';
	};
	
	var testSVG = function testSVG(document) {
	    var img = new Image();
	    var canvas = document.createElement('canvas');
	    var ctx = canvas.getContext('2d');
	    img.src = 'data:image/svg+xml,<svg xmlns=\'http://www.w3.org/2000/svg\'></svg>';
	
	    try {
	        ctx.drawImage(img, 0, 0);
	        canvas.toDataURL();
	    } catch (e) {
	        return false;
	    }
	    return true;
	};
	
	var isGreenPixel = function isGreenPixel(data) {
	    return data[0] === 0 && data[1] === 255 && data[2] === 0 && data[3] === 255;
	};
	
	var testForeignObject = function testForeignObject(document) {
	    var canvas = document.createElement('canvas');
	    var size = 100;
	    canvas.width = size;
	    canvas.height = size;
	    var ctx = canvas.getContext('2d');
	    ctx.fillStyle = 'rgb(0, 255, 0)';
	    ctx.fillRect(0, 0, size, size);
	
	    var img = new Image();
	    var greenImageSrc = canvas.toDataURL();
	    img.src = greenImageSrc;
	    var svg = (0, _ForeignObjectRenderer.createForeignObjectSVG)(size, size, 0, 0, img);
	    ctx.fillStyle = 'red';
	    ctx.fillRect(0, 0, size, size);
	
	    return (0, _ForeignObjectRenderer.loadSerializedSVG)(svg).then(function (img) {
	        ctx.drawImage(img, 0, 0);
	        var data = ctx.getImageData(0, 0, size, size).data;
	        ctx.fillStyle = 'red';
	        ctx.fillRect(0, 0, size, size);
	
	        var node = document.createElement('div');
	        node.style.backgroundImage = 'url(' + greenImageSrc + ')';
	        node.style.height = size + 'px';
	        // Firefox 55 does not render inline <img /> tags
	        return isGreenPixel(data) ? (0, _ForeignObjectRenderer.loadSerializedSVG)((0, _ForeignObjectRenderer.createForeignObjectSVG)(size, size, 0, 0, node)) : Promise.reject(false);
	    }).then(function (img) {
	        ctx.drawImage(img, 0, 0);
	        // Edge does not render background-images
	        return isGreenPixel(ctx.getImageData(0, 0, size, size).data);
	    }).catch(function (e) {
	        return false;
	    });
	};
	
	var FEATURES = {
	    // $FlowFixMe - get/set properties not yet supported
	    get SUPPORT_RANGE_BOUNDS() {
	        'use strict';
	
	        var value = testRangeBounds(document);
	        Object.defineProperty(FEATURES, 'SUPPORT_RANGE_BOUNDS', { value: value });
	        return value;
	    },
	    // $FlowFixMe - get/set properties not yet supported
	    get SUPPORT_SVG_DRAWING() {
	        'use strict';
	
	        var value = testSVG(document);
	        Object.defineProperty(FEATURES, 'SUPPORT_SVG_DRAWING', { value: value });
	        return value;
	    },
	    // $FlowFixMe - get/set properties not yet supported
	    get SUPPORT_BASE64_DRAWING() {
	        'use strict';
	
	        return function (src) {
	            var _value = testBase64(document, src);
	            Object.defineProperty(FEATURES, 'SUPPORT_BASE64_DRAWING', { value: function value() {
	                    return _value;
	                } });
	            return _value;
	        };
	    },
	    // $FlowFixMe - get/set properties not yet supported
	    get SUPPORT_FOREIGNOBJECT_DRAWING() {
	        'use strict';
	
	        var value = typeof Array.from === 'function' && typeof window.fetch === 'function' ? testForeignObject(document) : Promise.resolve(false);
	        Object.defineProperty(FEATURES, 'SUPPORT_FOREIGNOBJECT_DRAWING', { value: value });
	        return value;
	    },
	    // $FlowFixMe - get/set properties not yet supported
	    get SUPPORT_CORS_IMAGES() {
	        'use strict';
	
	        var value = testCORS();
	        Object.defineProperty(FEATURES, 'SUPPORT_CORS_IMAGES', { value: value });
	        return value;
	    },
	    // $FlowFixMe - get/set properties not yet supported
	    get SUPPORT_RESPONSE_TYPE() {
	        'use strict';
	
	        var value = testResponseType();
	        Object.defineProperty(FEATURES, 'SUPPORT_RESPONSE_TYPE', { value: value });
	        return value;
	    },
	    // $FlowFixMe - get/set properties not yet supported
	    get SUPPORT_CORS_XHR() {
	        'use strict';
	
	        var value = 'withCredentials' in new XMLHttpRequest();
	        Object.defineProperty(FEATURES, 'SUPPORT_CORS_XHR', { value: value });
	        return value;
	    }
	};
	
	exports.default = FEATURES;
	
	/***/ }),
	/* 13 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.parseTextDecoration = exports.TEXT_DECORATION_LINE = exports.TEXT_DECORATION = exports.TEXT_DECORATION_STYLE = undefined;
	
	var _Color = __webpack_require__(1);
	
	var _Color2 = _interopRequireDefault(_Color);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TEXT_DECORATION_STYLE = exports.TEXT_DECORATION_STYLE = {
	    SOLID: 0,
	    DOUBLE: 1,
	    DOTTED: 2,
	    DASHED: 3,
	    WAVY: 4
	};
	
	var TEXT_DECORATION = exports.TEXT_DECORATION = {
	    NONE: null
	};
	
	var TEXT_DECORATION_LINE = exports.TEXT_DECORATION_LINE = {
	    UNDERLINE: 1,
	    OVERLINE: 2,
	    LINE_THROUGH: 3,
	    BLINK: 4
	};
	
	var parseLine = function parseLine(line) {
	    switch (line) {
	        case 'underline':
	            return TEXT_DECORATION_LINE.UNDERLINE;
	        case 'overline':
	            return TEXT_DECORATION_LINE.OVERLINE;
	        case 'line-through':
	            return TEXT_DECORATION_LINE.LINE_THROUGH;
	    }
	    return TEXT_DECORATION_LINE.BLINK;
	};
	
	var parseTextDecorationLine = function parseTextDecorationLine(line) {
	    if (line === 'none') {
	        return null;
	    }
	
	    return line.split(' ').map(parseLine);
	};
	
	var parseTextDecorationStyle = function parseTextDecorationStyle(style) {
	    switch (style) {
	        case 'double':
	            return TEXT_DECORATION_STYLE.DOUBLE;
	        case 'dotted':
	            return TEXT_DECORATION_STYLE.DOTTED;
	        case 'dashed':
	            return TEXT_DECORATION_STYLE.DASHED;
	        case 'wavy':
	            return TEXT_DECORATION_STYLE.WAVY;
	    }
	    return TEXT_DECORATION_STYLE.SOLID;
	};
	
	var parseTextDecoration = exports.parseTextDecoration = function parseTextDecoration(style) {
	    var textDecorationLine = parseTextDecorationLine(style.textDecorationLine ? style.textDecorationLine : style.textDecoration);
	    if (textDecorationLine === null) {
	        return TEXT_DECORATION.NONE;
	    }
	
	    var textDecorationColor = style.textDecorationColor ? new _Color2.default(style.textDecorationColor) : null;
	    var textDecorationStyle = parseTextDecorationStyle(style.textDecorationStyle);
	
	    return {
	        textDecorationLine: textDecorationLine,
	        textDecorationColor: textDecorationColor,
	        textDecorationStyle: textDecorationStyle
	    };
	};
	
	/***/ }),
	/* 14 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.parseBorder = exports.BORDER_SIDES = exports.BORDER_STYLE = undefined;
	
	var _Color = __webpack_require__(1);
	
	var _Color2 = _interopRequireDefault(_Color);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BORDER_STYLE = exports.BORDER_STYLE = {
	    NONE: 0,
	    SOLID: 1
	};
	
	var BORDER_SIDES = exports.BORDER_SIDES = {
	    TOP: 0,
	    RIGHT: 1,
	    BOTTOM: 2,
	    LEFT: 3
	};
	
	var SIDES = Object.keys(BORDER_SIDES).map(function (s) {
	    return s.toLowerCase();
	});
	
	var parseBorderStyle = function parseBorderStyle(style) {
	    switch (style) {
	        case 'none':
	            return BORDER_STYLE.NONE;
	    }
	    return BORDER_STYLE.SOLID;
	};
	
	var parseBorder = exports.parseBorder = function parseBorder(style) {
	    return SIDES.map(function (side) {
	        var borderColor = new _Color2.default(style.getPropertyValue('border-' + side + '-color'));
	        var borderStyle = parseBorderStyle(style.getPropertyValue('border-' + side + '-style'));
	        var borderWidth = parseFloat(style.getPropertyValue('border-' + side + '-width'));
	        return {
	            borderColor: borderColor,
	            borderStyle: borderStyle,
	            borderWidth: isNaN(borderWidth) ? 0 : borderWidth
	        };
	    });
	};
	
	/***/ }),
	/* 15 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var toCodePoints = exports.toCodePoints = function toCodePoints(str) {
	    var codePoints = [];
	    var i = 0;
	    var length = str.length;
	    while (i < length) {
	        var value = str.charCodeAt(i++);
	        if (value >= 0xd800 && value <= 0xdbff && i < length) {
	            var extra = str.charCodeAt(i++);
	            if ((extra & 0xfc00) === 0xdc00) {
	                codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
	            } else {
	                codePoints.push(value);
	                i--;
	            }
	        } else {
	            codePoints.push(value);
	        }
	    }
	    return codePoints;
	};
	
	var fromCodePoint = exports.fromCodePoint = function fromCodePoint() {
	    if (String.fromCodePoint) {
	        return String.fromCodePoint.apply(String, arguments);
	    }
	
	    var length = arguments.length;
	    if (!length) {
	        return '';
	    }
	
	    var codeUnits = [];
	
	    var index = -1;
	    var result = '';
	    while (++index < length) {
	        var codePoint = arguments.length <= index ? undefined : arguments[index];
	        if (codePoint <= 0xffff) {
	            codeUnits.push(codePoint);
	        } else {
	            codePoint -= 0x10000;
	            codeUnits.push((codePoint >> 10) + 0xd800, codePoint % 0x400 + 0xdc00);
	        }
	        if (index + 1 === length || codeUnits.length > 0x4000) {
	            result += String.fromCharCode.apply(String, codeUnits);
	            codeUnits.length = 0;
	        }
	    }
	    return result;
	};
	
	var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
	
	// Use a lookup table to find the index.
	var lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
	for (var i = 0; i < chars.length; i++) {
	    lookup[chars.charCodeAt(i)] = i;
	}
	
	var decode = exports.decode = function decode(base64) {
	    var bufferLength = base64.length * 0.75,
	        len = base64.length,
	        i = void 0,
	        p = 0,
	        encoded1 = void 0,
	        encoded2 = void 0,
	        encoded3 = void 0,
	        encoded4 = void 0;
	
	    if (base64[base64.length - 1] === '=') {
	        bufferLength--;
	        if (base64[base64.length - 2] === '=') {
	            bufferLength--;
	        }
	    }
	
	    var buffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined' && typeof Uint8Array.prototype.slice !== 'undefined' ? new ArrayBuffer(bufferLength) : new Array(bufferLength);
	    var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
	
	    for (i = 0; i < len; i += 4) {
	        encoded1 = lookup[base64.charCodeAt(i)];
	        encoded2 = lookup[base64.charCodeAt(i + 1)];
	        encoded3 = lookup[base64.charCodeAt(i + 2)];
	        encoded4 = lookup[base64.charCodeAt(i + 3)];
	
	        bytes[p++] = encoded1 << 2 | encoded2 >> 4;
	        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
	        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
	    }
	
	    return buffer;
	};
	
	var polyUint16Array = exports.polyUint16Array = function polyUint16Array(buffer) {
	    var length = buffer.length;
	    var bytes = [];
	    for (var _i = 0; _i < length; _i += 2) {
	        bytes.push(buffer[_i + 1] << 8 | buffer[_i]);
	    }
	    return bytes;
	};
	
	var polyUint32Array = exports.polyUint32Array = function polyUint32Array(buffer) {
	    var length = buffer.length;
	    var bytes = [];
	    for (var _i2 = 0; _i2 < length; _i2 += 4) {
	        bytes.push(buffer[_i2 + 3] << 24 | buffer[_i2 + 2] << 16 | buffer[_i2 + 1] << 8 | buffer[_i2]);
	    }
	    return bytes;
	};
	
	/***/ }),
	/* 16 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.createCounterText = exports.inlineListItemElement = exports.getListOwner = undefined;
	
	var _Util = __webpack_require__(5);
	
	var _NodeContainer = __webpack_require__(4);
	
	var _NodeContainer2 = _interopRequireDefault(_NodeContainer);
	
	var _TextContainer = __webpack_require__(11);
	
	var _TextContainer2 = _interopRequireDefault(_TextContainer);
	
	var _listStyle = __webpack_require__(10);
	
	var _Unicode = __webpack_require__(26);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Margin between the enumeration and the list item content
	var MARGIN_RIGHT = 7;
	
	var ancestorTypes = ['OL', 'UL', 'MENU'];
	
	var getListOwner = exports.getListOwner = function getListOwner(container) {
	    var parent = container.parent;
	    if (!parent) {
	        return null;
	    }
	
	    do {
	        var isAncestor = ancestorTypes.indexOf(parent.tagName) !== -1;
	        if (isAncestor) {
	            return parent;
	        }
	        parent = parent.parent;
	    } while (parent);
	
	    return container.parent;
	};
	
	var inlineListItemElement = exports.inlineListItemElement = function inlineListItemElement(node, container, resourceLoader) {
	    var listStyle = container.style.listStyle;
	
	    if (!listStyle) {
	        return;
	    }
	
	    var style = node.ownerDocument.defaultView.getComputedStyle(node, null);
	    var wrapper = node.ownerDocument.createElement('html2canvaswrapper');
	    (0, _Util.copyCSSStyles)(style, wrapper);
	
	    wrapper.style.position = 'absolute';
	    wrapper.style.bottom = 'auto';
	    wrapper.style.display = 'block';
	    wrapper.style.letterSpacing = 'normal';
	
	    switch (listStyle.listStylePosition) {
	        case _listStyle.LIST_STYLE_POSITION.OUTSIDE:
	            wrapper.style.left = 'auto';
	            wrapper.style.right = node.ownerDocument.defaultView.innerWidth - container.bounds.left - container.style.margin[1].getAbsoluteValue(container.bounds.width) + MARGIN_RIGHT + 'px';
	            wrapper.style.textAlign = 'right';
	            break;
	        case _listStyle.LIST_STYLE_POSITION.INSIDE:
	            wrapper.style.left = container.bounds.left - container.style.margin[3].getAbsoluteValue(container.bounds.width) + 'px';
	            wrapper.style.right = 'auto';
	            wrapper.style.textAlign = 'left';
	            break;
	    }
	
	    var text = void 0;
	    var MARGIN_TOP = container.style.margin[0].getAbsoluteValue(container.bounds.width);
	    var styleImage = listStyle.listStyleImage;
	    if (styleImage) {
	        if (styleImage.method === 'url') {
	            var image = node.ownerDocument.createElement('img');
	            image.src = styleImage.args[0];
	            wrapper.style.top = container.bounds.top - MARGIN_TOP + 'px';
	            wrapper.style.width = 'auto';
	            wrapper.style.height = 'auto';
	            wrapper.appendChild(image);
	        } else {
	            var size = parseFloat(container.style.font.fontSize) * 0.5;
	            wrapper.style.top = container.bounds.top - MARGIN_TOP + container.bounds.height - 1.5 * size + 'px';
	            wrapper.style.width = size + 'px';
	            wrapper.style.height = size + 'px';
	            wrapper.style.backgroundImage = style.listStyleImage;
	        }
	    } else if (typeof container.listIndex === 'number') {
	        text = node.ownerDocument.createTextNode(createCounterText(container.listIndex, listStyle.listStyleType, true));
	        wrapper.appendChild(text);
	        wrapper.style.top = container.bounds.top - MARGIN_TOP + 'px';
	    }
	
	    // $FlowFixMe
	    var body = node.ownerDocument.body;
	    body.appendChild(wrapper);
	
	    if (text) {
	        container.childNodes.push(_TextContainer2.default.fromTextNode(text, container));
	        body.removeChild(wrapper);
	    } else {
	        // $FlowFixMe
	        container.childNodes.push(new _NodeContainer2.default(wrapper, container, resourceLoader, 0));
	    }
	};
	
	var ROMAN_UPPER = {
	    integers: [1000, 900, 500, 400, 100, 90, 50, 40, 10, 9, 5, 4, 1],
	    values: ['M', 'CM', 'D', 'CD', 'C', 'XC', 'L', 'XL', 'X', 'IX', 'V', 'IV', 'I']
	};
	
	var ARMENIAN = {
	    integers: [9000, 8000, 7000, 6000, 5000, 4000, 3000, 2000, 1000, 900, 800, 700, 600, 500, 400, 300, 200, 100, 90, 80, 70, 60, 50, 40, 30, 20, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1],
	    values: ['Ք', 'Փ', 'Ւ', 'Ց', 'Ր', 'Տ', 'Վ', 'Ս', 'Ռ', 'Ջ', 'Պ', 'Չ', 'Ո', 'Շ', 'Ն', 'Յ', 'Մ', 'Ճ', 'Ղ', 'Ձ', 'Հ', 'Կ', 'Ծ', 'Խ', 'Լ', 'Ի', 'Ժ', 'Թ', 'Ը', 'Է', 'Զ', 'Ե', 'Դ', 'Գ', 'Բ', 'Ա']
	};
	
	var HEBREW = {
	    integers: [10000, 9000, 8000, 7000, 6000, 5000, 4000, 3000, 2000, 1000, 400, 300, 200, 100, 90, 80, 70, 60, 50, 40, 30, 20, 19, 18, 17, 16, 15, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1],
	    values: ['י׳', 'ט׳', 'ח׳', 'ז׳', 'ו׳', 'ה׳', 'ד׳', 'ג׳', 'ב׳', 'א׳', 'ת', 'ש', 'ר', 'ק', 'צ', 'פ', 'ע', 'ס', 'נ', 'מ', 'ל', 'כ', 'יט', 'יח', 'יז', 'טז', 'טו', 'י', 'ט', 'ח', 'ז', 'ו', 'ה', 'ד', 'ג', 'ב', 'א']
	};
	
	var GEORGIAN = {
	    integers: [10000, 9000, 8000, 7000, 6000, 5000, 4000, 3000, 2000, 1000, 900, 800, 700, 600, 500, 400, 300, 200, 100, 90, 80, 70, 60, 50, 40, 30, 20, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1],
	    values: ['ჵ', 'ჰ', 'ჯ', 'ჴ', 'ხ', 'ჭ', 'წ', 'ძ', 'ც', 'ჩ', 'შ', 'ყ', 'ღ', 'ქ', 'ფ', 'ჳ', 'ტ', 'ს', 'რ', 'ჟ', 'პ', 'ო', 'ჲ', 'ნ', 'მ', 'ლ', 'კ', 'ი', 'თ', 'ჱ', 'ზ', 'ვ', 'ე', 'დ', 'გ', 'ბ', 'ა']
	};
	
	var createAdditiveCounter = function createAdditiveCounter(value, min, max, symbols, fallback, suffix) {
	    if (value < min || value > max) {
	        return createCounterText(value, fallback, suffix.length > 0);
	    }
	
	    return symbols.integers.reduce(function (string, integer, index) {
	        while (value >= integer) {
	            value -= integer;
	            string += symbols.values[index];
	        }
	        return string;
	    }, '') + suffix;
	};
	
	var createCounterStyleWithSymbolResolver = function createCounterStyleWithSymbolResolver(value, codePointRangeLength, isNumeric, resolver) {
	    var string = '';
	
	    do {
	        if (!isNumeric) {
	            value--;
	        }
	        string = resolver(value) + string;
	        value /= codePointRangeLength;
	    } while (value * codePointRangeLength >= codePointRangeLength);
	
	    return string;
	};
	
	var createCounterStyleFromRange = function createCounterStyleFromRange(value, codePointRangeStart, codePointRangeEnd, isNumeric, suffix) {
	    var codePointRangeLength = codePointRangeEnd - codePointRangeStart + 1;
	
	    return (value < 0 ? '-' : '') + (createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, isNumeric, function (codePoint) {
	        return (0, _Unicode.fromCodePoint)(Math.floor(codePoint % codePointRangeLength) + codePointRangeStart);
	    }) + suffix);
	};
	
	var createCounterStyleFromSymbols = function createCounterStyleFromSymbols(value, symbols) {
	    var suffix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '. ';
	
	    var codePointRangeLength = symbols.length;
	    return createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, false, function (codePoint) {
	        return symbols[Math.floor(codePoint % codePointRangeLength)];
	    }) + suffix;
	};
	
	var CJK_ZEROS = 1 << 0;
	var CJK_TEN_COEFFICIENTS = 1 << 1;
	var CJK_TEN_HIGH_COEFFICIENTS = 1 << 2;
	var CJK_HUNDRED_COEFFICIENTS = 1 << 3;
	
	var createCJKCounter = function createCJKCounter(value, numbers, multipliers, negativeSign, suffix, flags) {
	    if (value < -9999 || value > 9999) {
	        return createCounterText(value, _listStyle.LIST_STYLE_TYPE.CJK_DECIMAL, suffix.length > 0);
	    }
	    var tmp = Math.abs(value);
	    var string = suffix;
	
	    if (tmp === 0) {
	        return numbers[0] + string;
	    }
	
	    for (var digit = 0; tmp > 0 && digit <= 4; digit++) {
	        var coefficient = tmp % 10;
	
	        if (coefficient === 0 && (0, _Util.contains)(flags, CJK_ZEROS) && string !== '') {
	            string = numbers[coefficient] + string;
	        } else if (coefficient > 1 || coefficient === 1 && digit === 0 || coefficient === 1 && digit === 1 && (0, _Util.contains)(flags, CJK_TEN_COEFFICIENTS) || coefficient === 1 && digit === 1 && (0, _Util.contains)(flags, CJK_TEN_HIGH_COEFFICIENTS) && value > 100 || coefficient === 1 && digit > 1 && (0, _Util.contains)(flags, CJK_HUNDRED_COEFFICIENTS)) {
	            string = numbers[coefficient] + (digit > 0 ? multipliers[digit - 1] : '') + string;
	        } else if (coefficient === 1 && digit > 0) {
	            string = multipliers[digit - 1] + string;
	        }
	        tmp = Math.floor(tmp / 10);
	    }
	
	    return (value < 0 ? negativeSign : '') + string;
	};
	
	var CHINESE_INFORMAL_MULTIPLIERS = '十百千萬';
	var CHINESE_FORMAL_MULTIPLIERS = '拾佰仟萬';
	var JAPANESE_NEGATIVE = 'マイナス';
	var KOREAN_NEGATIVE = '마이너스 ';
	
	var createCounterText = exports.createCounterText = function createCounterText(value, type, appendSuffix) {
	    var defaultSuffix = appendSuffix ? '. ' : '';
	    var cjkSuffix = appendSuffix ? '、' : '';
	    var koreanSuffix = appendSuffix ? ', ' : '';
	    switch (type) {
	        case _listStyle.LIST_STYLE_TYPE.DISC:
	            return '•';
	        case _listStyle.LIST_STYLE_TYPE.CIRCLE:
	            return '◦';
	        case _listStyle.LIST_STYLE_TYPE.SQUARE:
	            return '◾';
	        case _listStyle.LIST_STYLE_TYPE.DECIMAL_LEADING_ZERO:
	            var string = createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
	            return string.length < 4 ? '0' + string : string;
	        case _listStyle.LIST_STYLE_TYPE.CJK_DECIMAL:
	            return createCounterStyleFromSymbols(value, '〇一二三四五六七八九', cjkSuffix);
	        case _listStyle.LIST_STYLE_TYPE.LOWER_ROMAN:
	            return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, _listStyle.LIST_STYLE_TYPE.DECIMAL, defaultSuffix).toLowerCase();
	        case _listStyle.LIST_STYLE_TYPE.UPPER_ROMAN:
	            return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, _listStyle.LIST_STYLE_TYPE.DECIMAL, defaultSuffix);
	        case _listStyle.LIST_STYLE_TYPE.LOWER_GREEK:
	            return createCounterStyleFromRange(value, 945, 969, false, defaultSuffix);
	        case _listStyle.LIST_STYLE_TYPE.LOWER_ALPHA:
	            return createCounterStyleFromRange(value, 97, 122, false, defaultSuffix);
	        case _listStyle.LIST_STYLE_TYPE.UPPER_ALPHA:
	            return createCounterStyleFromRange(value, 65, 90, false, defaultSuffix);
	        case _listStyle.LIST_STYLE_TYPE.ARABIC_INDIC:
	            return createCounterStyleFromRange(value, 1632, 1641, true, defaultSuffix);
	        case _listStyle.LIST_STYLE_TYPE.ARMENIAN:
	        case _listStyle.LIST_STYLE_TYPE.UPPER_ARMENIAN:
	            return createAdditiveCounter(value, 1, 9999, ARMENIAN, _listStyle.LIST_STYLE_TYPE.DECIMAL, defaultSuffix);
	        case _listStyle.LIST_STYLE_TYPE.LOWER_ARMENIAN:
	            return createAdditiveCounter(value, 1, 9999, ARMENIAN, _listStyle.LIST_STYLE_TYPE.DECIMAL, defaultSuffix).toLowerCase();
	        case _listStyle.LIST_STYLE_TYPE.BENGALI:
	            return createCounterStyleFromRange(value, 2534, 2543, true, defaultSuffix);
	        case _listStyle.LIST_STYLE_TYPE.CAMBODIAN:
	        case _listStyle.LIST_STYLE_TYPE.KHMER:
	            return createCounterStyleFromRange(value, 6112, 6121, true, defaultSuffix);
	        case _listStyle.LIST_STYLE_TYPE.CJK_EARTHLY_BRANCH:
	            return createCounterStyleFromSymbols(value, '子丑寅卯辰巳午未申酉戌亥', cjkSuffix);
	        case _listStyle.LIST_STYLE_TYPE.CJK_HEAVENLY_STEM:
	            return createCounterStyleFromSymbols(value, '甲乙丙丁戊己庚辛壬癸', cjkSuffix);
	        case _listStyle.LIST_STYLE_TYPE.CJK_IDEOGRAPHIC:
	        case _listStyle.LIST_STYLE_TYPE.TRAD_CHINESE_INFORMAL:
	            return createCJKCounter(value, '零一二三四五六七八九', CHINESE_INFORMAL_MULTIPLIERS, '負', cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
	        case _listStyle.LIST_STYLE_TYPE.TRAD_CHINESE_FORMAL:
	            return createCJKCounter(value, '零壹貳參肆伍陸柒捌玖', CHINESE_FORMAL_MULTIPLIERS, '負', cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
	        case _listStyle.LIST_STYLE_TYPE.SIMP_CHINESE_INFORMAL:
	            return createCJKCounter(value, '零一二三四五六七八九', CHINESE_INFORMAL_MULTIPLIERS, '负', cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
	        case _listStyle.LIST_STYLE_TYPE.SIMP_CHINESE_FORMAL:
	            return createCJKCounter(value, '零壹贰叁肆伍陆柒捌玖', CHINESE_FORMAL_MULTIPLIERS, '负', cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
	        case _listStyle.LIST_STYLE_TYPE.JAPANESE_INFORMAL:
	            return createCJKCounter(value, '〇一二三四五六七八九', '十百千万', JAPANESE_NEGATIVE, cjkSuffix, 0);
	        case _listStyle.LIST_STYLE_TYPE.JAPANESE_FORMAL:
	            return createCJKCounter(value, '零壱弐参四伍六七八九', '拾百千万', JAPANESE_NEGATIVE, cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
	        case _listStyle.LIST_STYLE_TYPE.KOREAN_HANGUL_FORMAL:
	            return createCJKCounter(value, '영일이삼사오육칠팔구', '십백천만', KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
	        case _listStyle.LIST_STYLE_TYPE.KOREAN_HANJA_INFORMAL:
	            return createCJKCounter(value, '零一二三四五六七八九', '十百千萬', KOREAN_NEGATIVE, koreanSuffix, 0);
	        case _listStyle.LIST_STYLE_TYPE.KOREAN_HANJA_FORMAL:
	            return createCJKCounter(value, '零壹貳參四五六七八九', '拾百千', KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
	        case _listStyle.LIST_STYLE_TYPE.DEVANAGARI:
	            return createCounterStyleFromRange(value, 0x966, 0x96f, true, defaultSuffix);
	        case _listStyle.LIST_STYLE_TYPE.GEORGIAN:
	            return createAdditiveCounter(value, 1, 19999, GEORGIAN, _listStyle.LIST_STYLE_TYPE.DECIMAL, defaultSuffix);
	        case _listStyle.LIST_STYLE_TYPE.GUJARATI:
	            return createCounterStyleFromRange(value, 0xae6, 0xaef, true, defaultSuffix);
	        case _listStyle.LIST_STYLE_TYPE.GURMUKHI:
	            return createCounterStyleFromRange(value, 0xa66, 0xa6f, true, defaultSuffix);
	        case _listStyle.LIST_STYLE_TYPE.HEBREW:
	            return createAdditiveCounter(value, 1, 10999, HEBREW, _listStyle.LIST_STYLE_TYPE.DECIMAL, defaultSuffix);
	        case _listStyle.LIST_STYLE_TYPE.HIRAGANA:
	            return createCounterStyleFromSymbols(value, 'あいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやゆよらりるれろわゐゑをん');
	        case _listStyle.LIST_STYLE_TYPE.HIRAGANA_IROHA:
	            return createCounterStyleFromSymbols(value, 'いろはにほへとちりぬるをわかよたれそつねならむうゐのおくやまけふこえてあさきゆめみしゑひもせす');
	        case _listStyle.LIST_STYLE_TYPE.KANNADA:
	            return createCounterStyleFromRange(value, 0xce6, 0xcef, true, defaultSuffix);
	        case _listStyle.LIST_STYLE_TYPE.KATAKANA:
	            return createCounterStyleFromSymbols(value, 'アイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワヰヱヲン', cjkSuffix);
	        case _listStyle.LIST_STYLE_TYPE.KATAKANA_IROHA:
	            return createCounterStyleFromSymbols(value, 'イロハニホヘトチリヌルヲワカヨタレソツネナラムウヰノオクヤマケフコエテアサキユメミシヱヒモセス', cjkSuffix);
	        case _listStyle.LIST_STYLE_TYPE.LAO:
	            return createCounterStyleFromRange(value, 0xed0, 0xed9, true, defaultSuffix);
	        case _listStyle.LIST_STYLE_TYPE.MONGOLIAN:
	            return createCounterStyleFromRange(value, 0x1810, 0x1819, true, defaultSuffix);
	        case _listStyle.LIST_STYLE_TYPE.MYANMAR:
	            return createCounterStyleFromRange(value, 0x1040, 0x1049, true, defaultSuffix);
	        case _listStyle.LIST_STYLE_TYPE.ORIYA:
	            return createCounterStyleFromRange(value, 0xb66, 0xb6f, true, defaultSuffix);
	        case _listStyle.LIST_STYLE_TYPE.PERSIAN:
	            return createCounterStyleFromRange(value, 0x6f0, 0x6f9, true, defaultSuffix);
	        case _listStyle.LIST_STYLE_TYPE.TAMIL:
	            return createCounterStyleFromRange(value, 0xbe6, 0xbef, true, defaultSuffix);
	        case _listStyle.LIST_STYLE_TYPE.TELUGU:
	            return createCounterStyleFromRange(value, 0xc66, 0xc6f, true, defaultSuffix);
	        case _listStyle.LIST_STYLE_TYPE.THAI:
	            return createCounterStyleFromRange(value, 0xe50, 0xe59, true, defaultSuffix);
	        case _listStyle.LIST_STYLE_TYPE.TIBETAN:
	            return createCounterStyleFromRange(value, 0xf20, 0xf29, true, defaultSuffix);
	        case _listStyle.LIST_STYLE_TYPE.DECIMAL:
	        default:
	            return createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
	    }
	};
	
	/***/ }),
	/* 17 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Path = __webpack_require__(8);
	
	var _textDecoration = __webpack_require__(13);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var addColorStops = function addColorStops(gradient, canvasGradient) {
	    var maxStop = Math.max.apply(null, gradient.colorStops.map(function (colorStop) {
	        return colorStop.stop;
	    }));
	    var f = 1 / Math.max(1, maxStop);
	    gradient.colorStops.forEach(function (colorStop) {
	        canvasGradient.addColorStop(f * colorStop.stop, colorStop.color.toString());
	    });
	};
	
	var CanvasRenderer = function () {
	    function CanvasRenderer(canvas) {
	        _classCallCheck(this, CanvasRenderer);
	
	        this.canvas = canvas ? canvas : document.createElement('canvas');
	    }
	
	    _createClass(CanvasRenderer, [{
	        key: 'render',
	        value: function render(options) {
	            this.ctx = this.canvas.getContext('2d');
	            this.options = options;
	            this.canvas.width = Math.floor(options.width * options.scale);
	            this.canvas.height = Math.floor(options.height * options.scale);
	            this.canvas.style.width = options.width + 'px';
	            this.canvas.style.height = options.height + 'px';
	
	            this.ctx.scale(this.options.scale, this.options.scale);
	            this.ctx.translate(-options.x, -options.y);
	            this.ctx.textBaseline = 'bottom';
	            options.logger.log('Canvas renderer initialized (' + options.width + 'x' + options.height + ' at ' + options.x + ',' + options.y + ') with scale ' + this.options.scale);
	        }
	    }, {
	        key: 'clip',
	        value: function clip(clipPaths, callback) {
	            var _this = this;
	
	            if (clipPaths.length) {
	                this.ctx.save();
	                clipPaths.forEach(function (path) {
	                    _this.path(path);
	                    _this.ctx.clip();
	                });
	            }
	
	            callback();
	
	            if (clipPaths.length) {
	                this.ctx.restore();
	            }
	        }
	    }, {
	        key: 'drawImage',
	        value: function drawImage(image, source, destination) {
	            this.ctx.drawImage(image, source.left, source.top, source.width, source.height, destination.left, destination.top, destination.width, destination.height);
	        }
	    }, {
	        key: 'drawShape',
	        value: function drawShape(path, color) {
	            this.path(path);
	            this.ctx.fillStyle = color.toString();
	            this.ctx.fill();
	        }
	    }, {
	        key: 'fill',
	        value: function fill(color) {
	            this.ctx.fillStyle = color.toString();
	            this.ctx.fill();
	        }
	    }, {
	        key: 'getTarget',
	        value: function getTarget() {
	            this.canvas.getContext('2d').setTransform(1, 0, 0, 1, 0, 0);
	            return Promise.resolve(this.canvas);
	        }
	    }, {
	        key: 'path',
	        value: function path(_path) {
	            var _this2 = this;
	
	            this.ctx.beginPath();
	            if (Array.isArray(_path)) {
	                _path.forEach(function (point, index) {
	                    var start = point.type === _Path.PATH.VECTOR ? point : point.start;
	                    if (index === 0) {
	                        _this2.ctx.moveTo(start.x, start.y);
	                    } else {
	                        _this2.ctx.lineTo(start.x, start.y);
	                    }
	
	                    if (point.type === _Path.PATH.BEZIER_CURVE) {
	                        _this2.ctx.bezierCurveTo(point.startControl.x, point.startControl.y, point.endControl.x, point.endControl.y, point.end.x, point.end.y);
	                    }
	                });
	            } else {
	                this.ctx.arc(_path.x + _path.radius, _path.y + _path.radius, _path.radius, 0, Math.PI * 2, true);
	            }
	
	            this.ctx.closePath();
	        }
	    }, {
	        key: 'rectangle',
	        value: function rectangle(x, y, width, height, color) {
	            this.ctx.fillStyle = color.toString();
	            this.ctx.fillRect(x, y, width, height);
	        }
	    }, {
	        key: 'renderLinearGradient',
	        value: function renderLinearGradient(bounds, gradient) {
	            var linearGradient = this.ctx.createLinearGradient(bounds.left + gradient.direction.x1, bounds.top + gradient.direction.y1, bounds.left + gradient.direction.x0, bounds.top + gradient.direction.y0);
	
	            addColorStops(gradient, linearGradient);
	            this.ctx.fillStyle = linearGradient;
	            this.ctx.fillRect(bounds.left, bounds.top, bounds.width, bounds.height);
	        }
	    }, {
	        key: 'renderRadialGradient',
	        value: function renderRadialGradient(bounds, gradient) {
	            var _this3 = this;
	
	            var x = bounds.left + gradient.center.x;
	            var y = bounds.top + gradient.center.y;
	
	            var radialGradient = this.ctx.createRadialGradient(x, y, 0, x, y, gradient.radius.x);
	            if (!radialGradient) {
	                return;
	            }
	
	            addColorStops(gradient, radialGradient);
	            this.ctx.fillStyle = radialGradient;
	
	            if (gradient.radius.x !== gradient.radius.y) {
	                // transforms for elliptical radial gradient
	                var midX = bounds.left + 0.5 * bounds.width;
	                var midY = bounds.top + 0.5 * bounds.height;
	                var f = gradient.radius.y / gradient.radius.x;
	                var invF = 1 / f;
	
	                this.transform(midX, midY, [1, 0, 0, f, 0, 0], function () {
	                    return _this3.ctx.fillRect(bounds.left, invF * (bounds.top - midY) + midY, bounds.width, bounds.height * invF);
	                });
	            } else {
	                this.ctx.fillRect(bounds.left, bounds.top, bounds.width, bounds.height);
	            }
	        }
	    }, {
	        key: 'renderRepeat',
	        value: function renderRepeat(path, image, imageSize, offsetX, offsetY) {
	            this.path(path);
	            this.ctx.fillStyle = this.ctx.createPattern(this.resizeImage(image, imageSize), 'repeat');
	            this.ctx.translate(offsetX, offsetY);
	            this.ctx.fill();
	            this.ctx.translate(-offsetX, -offsetY);
	        }
	    }, {
	        key: 'renderTextNode',
	        value: function renderTextNode(textBounds, color, font, textDecoration, textShadows) {
	            var _this4 = this;
	
	            this.ctx.font = [font.fontStyle, font.fontVariant, font.fontWeight, font.fontSize, font.fontFamily].join(' ');
	
	            textBounds.forEach(function (text) {
	                _this4.ctx.fillStyle = color.toString();
	                if (textShadows && text.text.trim().length) {
	                    textShadows.slice(0).reverse().forEach(function (textShadow) {
	                        _this4.ctx.shadowColor = textShadow.color.toString();
	                        _this4.ctx.shadowOffsetX = textShadow.offsetX * _this4.options.scale;
	                        _this4.ctx.shadowOffsetY = textShadow.offsetY * _this4.options.scale;
	                        _this4.ctx.shadowBlur = textShadow.blur;
	
	                        _this4.ctx.fillText(text.text, text.bounds.left, text.bounds.top + text.bounds.height);
	                    });
	                } else {
	                    _this4.ctx.fillText(text.text, text.bounds.left, text.bounds.top + text.bounds.height);
	                }
	
	                if (textDecoration !== null) {
	                    var textDecorationColor = textDecoration.textDecorationColor || color;
	                    textDecoration.textDecorationLine.forEach(function (textDecorationLine) {
	                        switch (textDecorationLine) {
	                            case _textDecoration.TEXT_DECORATION_LINE.UNDERLINE:
	                                // Draws a line at the baseline of the font
	                                // TODO As some browsers display the line as more than 1px if the font-size is big,
	                                // need to take that into account both in position and size
	                                var _options$fontMetrics$ = _this4.options.fontMetrics.getMetrics(font),
	                                    baseline = _options$fontMetrics$.baseline;
	
	                                _this4.rectangle(text.bounds.left, Math.round(text.bounds.top + baseline), text.bounds.width, 1, textDecorationColor);
	                                break;
	                            case _textDecoration.TEXT_DECORATION_LINE.OVERLINE:
	                                _this4.rectangle(text.bounds.left, Math.round(text.bounds.top), text.bounds.width, 1, textDecorationColor);
	                                break;
	                            case _textDecoration.TEXT_DECORATION_LINE.LINE_THROUGH:
	                                // TODO try and find exact position for line-through
	                                var _options$fontMetrics$2 = _this4.options.fontMetrics.getMetrics(font),
	                                    middle = _options$fontMetrics$2.middle;
	
	                                _this4.rectangle(text.bounds.left, Math.ceil(text.bounds.top + middle), text.bounds.width, 1, textDecorationColor);
	                                break;
	                        }
	                    });
	                }
	            });
	        }
	    }, {
	        key: 'resizeImage',
	        value: function resizeImage(image, size) {
	            if (image.width === size.width && image.height === size.height) {
	                return image;
	            }
	
	            var canvas = this.canvas.ownerDocument.createElement('canvas');
	            canvas.width = size.width;
	            canvas.height = size.height;
	            var ctx = canvas.getContext('2d');
	            ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, size.width, size.height);
	            return canvas;
	        }
	    }, {
	        key: 'setOpacity',
	        value: function setOpacity(opacity) {
	            this.ctx.globalAlpha = opacity;
	        }
	    }, {
	        key: 'transform',
	        value: function transform(offsetX, offsetY, matrix, callback) {
	            this.ctx.save();
	            this.ctx.translate(offsetX, offsetY);
	            this.ctx.transform(matrix[0], matrix[1], matrix[2], matrix[3], matrix[4], matrix[5]);
	            this.ctx.translate(-offsetX, -offsetY);
	
	            callback();
	
	            this.ctx.restore();
	        }
	    }]);
	
	    return CanvasRenderer;
	}();
	
	exports.default = CanvasRenderer;
	
	/***/ }),
	/* 18 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Logger = function () {
	    function Logger(enabled, id, start) {
	        _classCallCheck(this, Logger);
	
	        this.enabled = typeof window !== 'undefined' && enabled;
	        this.start = start ? start : Date.now();
	        this.id = id;
	    }
	
	    _createClass(Logger, [{
	        key: 'child',
	        value: function child(id) {
	            return new Logger(this.enabled, id, this.start);
	        }
	
	        // eslint-disable-next-line flowtype/no-weak-types
	
	    }, {
	        key: 'log',
	        value: function log() {
	            if (this.enabled && window.console && window.console.log) {
	                for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	                    args[_key] = arguments[_key];
	                }
	
	                Function.prototype.bind.call(window.console.log, window.console).apply(window.console, [Date.now() - this.start + 'ms', this.id ? 'html2canvas (' + this.id + '):' : 'html2canvas:'].concat([].slice.call(args, 0)));
	            }
	        }
	
	        // eslint-disable-next-line flowtype/no-weak-types
	
	    }, {
	        key: 'error',
	        value: function error() {
	            if (this.enabled && window.console && window.console.error) {
	                for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	                    args[_key2] = arguments[_key2];
	                }
	
	                Function.prototype.bind.call(window.console.error, window.console).apply(window.console, [Date.now() - this.start + 'ms', this.id ? 'html2canvas (' + this.id + '):' : 'html2canvas:'].concat([].slice.call(args, 0)));
	            }
	        }
	    }]);
	
	    return Logger;
	}();
	
	exports.default = Logger;
	
	/***/ }),
	/* 19 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.parsePadding = exports.PADDING_SIDES = undefined;
	
	var _Length = __webpack_require__(2);
	
	var _Length2 = _interopRequireDefault(_Length);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PADDING_SIDES = exports.PADDING_SIDES = {
	    TOP: 0,
	    RIGHT: 1,
	    BOTTOM: 2,
	    LEFT: 3
	};
	
	var SIDES = ['top', 'right', 'bottom', 'left'];
	
	var parsePadding = exports.parsePadding = function parsePadding(style) {
	    return SIDES.map(function (side) {
	        return new _Length2.default(style.getPropertyValue('padding-' + side));
	    });
	};
	
	/***/ }),
	/* 20 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var OVERFLOW_WRAP = exports.OVERFLOW_WRAP = {
	    NORMAL: 0,
	    BREAK_WORD: 1
	};
	
	var parseOverflowWrap = exports.parseOverflowWrap = function parseOverflowWrap(overflow) {
	    switch (overflow) {
	        case 'break-word':
	            return OVERFLOW_WRAP.BREAK_WORD;
	        case 'normal':
	        default:
	            return OVERFLOW_WRAP.NORMAL;
	    }
	};
	
	/***/ }),
	/* 21 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var POSITION = exports.POSITION = {
	    STATIC: 0,
	    RELATIVE: 1,
	    ABSOLUTE: 2,
	    FIXED: 3,
	    STICKY: 4
	};
	
	var parsePosition = exports.parsePosition = function parsePosition(position) {
	    switch (position) {
	        case 'relative':
	            return POSITION.RELATIVE;
	        case 'absolute':
	            return POSITION.ABSOLUTE;
	        case 'fixed':
	            return POSITION.FIXED;
	        case 'sticky':
	            return POSITION.STICKY;
	    }
	
	    return POSITION.STATIC;
	};
	
	/***/ }),
	/* 22 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var TEXT_TRANSFORM = exports.TEXT_TRANSFORM = {
	    NONE: 0,
	    LOWERCASE: 1,
	    UPPERCASE: 2,
	    CAPITALIZE: 3
	};
	
	var parseTextTransform = exports.parseTextTransform = function parseTextTransform(textTransform) {
	    switch (textTransform) {
	        case 'uppercase':
	            return TEXT_TRANSFORM.UPPERCASE;
	        case 'lowercase':
	            return TEXT_TRANSFORM.LOWERCASE;
	        case 'capitalize':
	            return TEXT_TRANSFORM.CAPITALIZE;
	    }
	
	    return TEXT_TRANSFORM.NONE;
	};
	
	/***/ }),
	/* 23 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.reformatInputBounds = exports.inlineSelectElement = exports.inlineTextAreaElement = exports.inlineInputElement = exports.getInputBorderRadius = exports.INPUT_BACKGROUND = exports.INPUT_BORDERS = exports.INPUT_COLOR = undefined;
	
	var _TextContainer = __webpack_require__(11);
	
	var _TextContainer2 = _interopRequireDefault(_TextContainer);
	
	var _background = __webpack_require__(6);
	
	var _border = __webpack_require__(14);
	
	var _Circle = __webpack_require__(58);
	
	var _Circle2 = _interopRequireDefault(_Circle);
	
	var _Vector = __webpack_require__(9);
	
	var _Vector2 = _interopRequireDefault(_Vector);
	
	var _Color = __webpack_require__(1);
	
	var _Color2 = _interopRequireDefault(_Color);
	
	var _Length = __webpack_require__(2);
	
	var _Length2 = _interopRequireDefault(_Length);
	
	var _Bounds = __webpack_require__(3);
	
	var _TextBounds = __webpack_require__(24);
	
	var _Util = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var INPUT_COLOR = exports.INPUT_COLOR = new _Color2.default([42, 42, 42]);
	var INPUT_BORDER_COLOR = new _Color2.default([165, 165, 165]);
	var INPUT_BACKGROUND_COLOR = new _Color2.default([222, 222, 222]);
	var INPUT_BORDER = {
	    borderWidth: 1,
	    borderColor: INPUT_BORDER_COLOR,
	    borderStyle: _border.BORDER_STYLE.SOLID
	};
	var INPUT_BORDERS = exports.INPUT_BORDERS = [INPUT_BORDER, INPUT_BORDER, INPUT_BORDER, INPUT_BORDER];
	var INPUT_BACKGROUND = exports.INPUT_BACKGROUND = {
	    backgroundColor: INPUT_BACKGROUND_COLOR,
	    backgroundImage: [],
	    backgroundClip: _background.BACKGROUND_CLIP.PADDING_BOX,
	    backgroundOrigin: _background.BACKGROUND_ORIGIN.PADDING_BOX
	};
	
	var RADIO_BORDER_RADIUS = new _Length2.default('50%');
	var RADIO_BORDER_RADIUS_TUPLE = [RADIO_BORDER_RADIUS, RADIO_BORDER_RADIUS];
	var INPUT_RADIO_BORDER_RADIUS = [RADIO_BORDER_RADIUS_TUPLE, RADIO_BORDER_RADIUS_TUPLE, RADIO_BORDER_RADIUS_TUPLE, RADIO_BORDER_RADIUS_TUPLE];
	
	var CHECKBOX_BORDER_RADIUS = new _Length2.default('3px');
	var CHECKBOX_BORDER_RADIUS_TUPLE = [CHECKBOX_BORDER_RADIUS, CHECKBOX_BORDER_RADIUS];
	var INPUT_CHECKBOX_BORDER_RADIUS = [CHECKBOX_BORDER_RADIUS_TUPLE, CHECKBOX_BORDER_RADIUS_TUPLE, CHECKBOX_BORDER_RADIUS_TUPLE, CHECKBOX_BORDER_RADIUS_TUPLE];
	
	var getInputBorderRadius = exports.getInputBorderRadius = function getInputBorderRadius(node) {
	    return node.type === 'radio' ? INPUT_RADIO_BORDER_RADIUS : INPUT_CHECKBOX_BORDER_RADIUS;
	};
	
	var inlineInputElement = exports.inlineInputElement = function inlineInputElement(node, container) {
	    if (node.type === 'radio' || node.type === 'checkbox') {
	        if (node.checked) {
	            var size = Math.min(container.bounds.width, container.bounds.height);
	            container.childNodes.push(node.type === 'checkbox' ? [new _Vector2.default(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79), new _Vector2.default(container.bounds.left + size * 0.16, container.bounds.top + size * 0.5549), new _Vector2.default(container.bounds.left + size * 0.27347, container.bounds.top + size * 0.44071), new _Vector2.default(container.bounds.left + size * 0.39694, container.bounds.top + size * 0.5649), new _Vector2.default(container.bounds.left + size * 0.72983, container.bounds.top + size * 0.23), new _Vector2.default(container.bounds.left + size * 0.84, container.bounds.top + size * 0.34085), new _Vector2.default(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79)] : new _Circle2.default(container.bounds.left + size / 4, container.bounds.top + size / 4, size / 4));
	        }
	    } else {
	        inlineFormElement(getInputValue(node), node, container, false);
	    }
	};
	
	var inlineTextAreaElement = exports.inlineTextAreaElement = function inlineTextAreaElement(node, container) {
	    inlineFormElement(node.value, node, container, true);
	};
	
	var inlineSelectElement = exports.inlineSelectElement = function inlineSelectElement(node, container) {
	    var option = node.options[node.selectedIndex || 0];
	    inlineFormElement(option ? option.text || '' : '', node, container, false);
	};
	
	var reformatInputBounds = exports.reformatInputBounds = function reformatInputBounds(bounds) {
	    if (bounds.width > bounds.height) {
	        bounds.left += (bounds.width - bounds.height) / 2;
	        bounds.width = bounds.height;
	    } else if (bounds.width < bounds.height) {
	        bounds.top += (bounds.height - bounds.width) / 2;
	        bounds.height = bounds.width;
	    }
	    return bounds;
	};
	
	var inlineFormElement = function inlineFormElement(value, node, container, allowLinebreak) {
	    var body = node.ownerDocument.body;
	    if (value.length > 0 && body) {
	        var wrapper = node.ownerDocument.createElement('html2canvaswrapper');
	        (0, _Util.copyCSSStyles)(node.ownerDocument.defaultView.getComputedStyle(node, null), wrapper);
	        wrapper.style.position = 'absolute';
	        wrapper.style.left = container.bounds.left + 'px';
	        wrapper.style.top = container.bounds.top + 'px';
	        if (!allowLinebreak) {
	            wrapper.style.whiteSpace = 'nowrap';
	        }
	        var text = node.ownerDocument.createTextNode(value);
	        wrapper.appendChild(text);
	        body.appendChild(wrapper);
	        container.childNodes.push(_TextContainer2.default.fromTextNode(text, container));
	        body.removeChild(wrapper);
	    }
	};
	
	var getInputValue = function getInputValue(node) {
	    var value = node.type === 'password' ? new Array(node.value.length + 1).join('\u2022') : node.value;
	
	    return value.length === 0 ? node.placeholder || '' : value;
	};
	
	/***/ }),
	/* 24 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.parseTextBounds = exports.TextBounds = undefined;
	
	var _Bounds = __webpack_require__(3);
	
	var _textDecoration = __webpack_require__(13);
	
	var _Feature = __webpack_require__(12);
	
	var _Feature2 = _interopRequireDefault(_Feature);
	
	var _Unicode = __webpack_require__(26);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var TextBounds = exports.TextBounds = function TextBounds(text, bounds) {
	    _classCallCheck(this, TextBounds);
	
	    this.text = text;
	    this.bounds = bounds;
	};
	
	var parseTextBounds = exports.parseTextBounds = function parseTextBounds(value, parent, node) {
	    var letterRendering = parent.style.letterSpacing !== 0;
	    var textList = letterRendering ? (0, _Unicode.toCodePoints)(value).map(function (i) {
	        return (0, _Unicode.fromCodePoint)(i);
	    }) : (0, _Unicode.breakWords)(value, parent);
	    var length = textList.length;
	    var defaultView = node.parentNode ? node.parentNode.ownerDocument.defaultView : null;
	    var scrollX = defaultView ? defaultView.pageXOffset : 0;
	    var scrollY = defaultView ? defaultView.pageYOffset : 0;
	    var textBounds = [];
	    var offset = 0;
	    for (var i = 0; i < length; i++) {
	        var text = textList[i];
	        if (parent.style.textDecoration !== _textDecoration.TEXT_DECORATION.NONE || text.trim().length > 0) {
	            if (_Feature2.default.SUPPORT_RANGE_BOUNDS) {
	                textBounds.push(new TextBounds(text, getRangeBounds(node, offset, text.length, scrollX, scrollY)));
	            } else {
	                var replacementNode = node.splitText(text.length);
	                textBounds.push(new TextBounds(text, getWrapperBounds(node, scrollX, scrollY)));
	                node = replacementNode;
	            }
	        } else if (!_Feature2.default.SUPPORT_RANGE_BOUNDS) {
	            node = node.splitText(text.length);
	        }
	        offset += text.length;
	    }
	    return textBounds;
	};
	
	var getWrapperBounds = function getWrapperBounds(node, scrollX, scrollY) {
	    var wrapper = node.ownerDocument.createElement('html2canvaswrapper');
	    wrapper.appendChild(node.cloneNode(true));
	    var parentNode = node.parentNode;
	    if (parentNode) {
	        parentNode.replaceChild(wrapper, node);
	        var bounds = (0, _Bounds.parseBounds)(wrapper, scrollX, scrollY);
	        if (wrapper.firstChild) {
	            parentNode.replaceChild(wrapper.firstChild, wrapper);
	        }
	        return bounds;
	    }
	    return new _Bounds.Bounds(0, 0, 0, 0);
	};
	
	var getRangeBounds = function getRangeBounds(node, offset, length, scrollX, scrollY) {
	    var range = node.ownerDocument.createRange();
	    range.setStart(node, offset);
	    range.setEnd(node, offset + length);
	    return _Bounds.Bounds.fromClientRect(range.getBoundingClientRect(), scrollX, scrollY);
	};
	
	/***/ }),
	/* 25 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ForeignObjectRenderer = function () {
	    function ForeignObjectRenderer(element) {
	        _classCallCheck(this, ForeignObjectRenderer);
	
	        this.element = element;
	    }
	
	    _createClass(ForeignObjectRenderer, [{
	        key: 'render',
	        value: function render(options) {
	            var _this = this;
	
	            this.options = options;
	            this.canvas = document.createElement('canvas');
	            this.ctx = this.canvas.getContext('2d');
	            this.canvas.width = Math.floor(options.width) * options.scale;
	            this.canvas.height = Math.floor(options.height) * options.scale;
	            this.canvas.style.width = options.width + 'px';
	            this.canvas.style.height = options.height + 'px';
	
	            options.logger.log('ForeignObject renderer initialized (' + options.width + 'x' + options.height + ' at ' + options.x + ',' + options.y + ') with scale ' + options.scale);
	            var svg = createForeignObjectSVG(Math.max(options.windowWidth, options.width) * options.scale, Math.max(options.windowHeight, options.height) * options.scale, options.scrollX * options.scale, options.scrollY * options.scale, this.element);
	
	            return loadSerializedSVG(svg).then(function (img) {
	                if (options.backgroundColor) {
	                    _this.ctx.fillStyle = options.backgroundColor.toString();
	                    _this.ctx.fillRect(0, 0, options.width * options.scale, options.height * options.scale);
	                }
	
	                _this.ctx.drawImage(img, -options.x * options.scale, -options.y * options.scale);
	                return _this.canvas;
	            });
	        }
	    }]);
	
	    return ForeignObjectRenderer;
	}();
	
	exports.default = ForeignObjectRenderer;
	var createForeignObjectSVG = exports.createForeignObjectSVG = function createForeignObjectSVG(width, height, x, y, node) {
	    var xmlns = 'http://www.w3.org/2000/svg';
	    var svg = document.createElementNS(xmlns, 'svg');
	    var foreignObject = document.createElementNS(xmlns, 'foreignObject');
	    svg.setAttributeNS(null, 'width', width);
	    svg.setAttributeNS(null, 'height', height);
	
	    foreignObject.setAttributeNS(null, 'width', '100%');
	    foreignObject.setAttributeNS(null, 'height', '100%');
	    foreignObject.setAttributeNS(null, 'x', x);
	    foreignObject.setAttributeNS(null, 'y', y);
	    foreignObject.setAttributeNS(null, 'externalResourcesRequired', 'true');
	    svg.appendChild(foreignObject);
	
	    foreignObject.appendChild(node);
	
	    return svg;
	};
	
	var loadSerializedSVG = exports.loadSerializedSVG = function loadSerializedSVG(svg) {
	    return new Promise(function (resolve, reject) {
	        var img = new Image();
	        img.onload = function () {
	            return resolve(img);
	        };
	        img.onerror = reject;
	
	        img.src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(new XMLSerializer().serializeToString(svg));
	    });
	};
	
	/***/ }),
	/* 26 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.breakWords = exports.fromCodePoint = exports.toCodePoints = undefined;
	
	var _cssLineBreak = __webpack_require__(54);
	
	Object.defineProperty(exports, 'toCodePoints', {
	    enumerable: true,
	    get: function get() {
	        return _cssLineBreak.toCodePoints;
	    }
	});
	Object.defineProperty(exports, 'fromCodePoint', {
	    enumerable: true,
	    get: function get() {
	        return _cssLineBreak.fromCodePoint;
	    }
	});
	
	var _NodeContainer = __webpack_require__(4);
	
	var _NodeContainer2 = _interopRequireDefault(_NodeContainer);
	
	var _overflowWrap = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var breakWords = exports.breakWords = function breakWords(str, parent) {
	    var breaker = (0, _cssLineBreak.LineBreaker)(str, {
	        lineBreak: parent.style.lineBreak,
	        wordBreak: parent.style.overflowWrap === _overflowWrap.OVERFLOW_WRAP.BREAK_WORD ? 'break-word' : parent.style.wordBreak
	    });
	
	    var words = [];
	    var bk = void 0;
	
	    while (!(bk = breaker.next()).done) {
	        words.push(bk.value.slice());
	    }
	
	    return words;
	};
	
	/***/ }),
	/* 27 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/* WEBPACK VAR INJECTION */(function(process) {
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.FontMetrics = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Util = __webpack_require__(5);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SAMPLE_TEXT = 'Hidden Text';
	
	var FontMetrics = exports.FontMetrics = function () {
	    function FontMetrics(document) {
	        _classCallCheck(this, FontMetrics);
	
	        this._data = {};
	        this._document = document;
	    }
	
	    _createClass(FontMetrics, [{
	        key: '_parseMetrics',
	        value: function _parseMetrics(font) {
	            var container = this._document.createElement('div');
	            var img = this._document.createElement('img');
	            var span = this._document.createElement('span');
	
	            var body = this._document.body;
	            if (!body) {
	                throw new Error(process.env.NODE_ENV !== 'production' ? 'No document found for font metrics' : '');
	            }
	
	            container.style.visibility = 'hidden';
	            container.style.fontFamily = font.fontFamily;
	            container.style.fontSize = font.fontSize;
	            container.style.margin = '0';
	            container.style.padding = '0';
	
	            body.appendChild(container);
	
	            img.src = _Util.SMALL_IMAGE;
	            img.width = 1;
	            img.height = 1;
	
	            img.style.margin = '0';
	            img.style.padding = '0';
	            img.style.verticalAlign = 'baseline';
	
	            span.style.fontFamily = font.fontFamily;
	            span.style.fontSize = font.fontSize;
	            span.style.margin = '0';
	            span.style.padding = '0';
	
	            span.appendChild(this._document.createTextNode(SAMPLE_TEXT));
	            container.appendChild(span);
	            container.appendChild(img);
	            var baseline = img.offsetTop - span.offsetTop + 2;
	
	            container.removeChild(span);
	            container.appendChild(this._document.createTextNode(SAMPLE_TEXT));
	
	            container.style.lineHeight = 'normal';
	            img.style.verticalAlign = 'super';
	
	            var middle = img.offsetTop - container.offsetTop + 2;
	
	            body.removeChild(container);
	
	            return { baseline: baseline, middle: middle };
	        }
	    }, {
	        key: 'getMetrics',
	        value: function getMetrics(font) {
	            var key = font.fontFamily + ' ' + font.fontSize;
	            if (this._data[key] === undefined) {
	                this._data[key] = this._parseMetrics(font);
	            }
	
	            return this._data[key];
	        }
	    }]);
	
	    return FontMetrics;
	}();
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))
	
	/***/ }),
	/* 28 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/* WEBPACK VAR INJECTION */(function(process) {
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Proxy = undefined;
	
	var _Feature = __webpack_require__(12);
	
	var _Feature2 = _interopRequireDefault(_Feature);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Proxy = exports.Proxy = function Proxy(src, options) {
	    if (!options.proxy) {
	        return Promise.reject(process.env.NODE_ENV !== 'production' ? 'No proxy defined' : null);
	    }
	    var proxy = options.proxy;
	
	    return new Promise(function (resolve, reject) {
	        var responseType = _Feature2.default.SUPPORT_CORS_XHR && _Feature2.default.SUPPORT_RESPONSE_TYPE ? 'blob' : 'text';
	        var xhr = _Feature2.default.SUPPORT_CORS_XHR ? new XMLHttpRequest() : new XDomainRequest();
	        xhr.onload = function () {
	            if (xhr instanceof XMLHttpRequest) {
	                if (xhr.status === 200) {
	                    if (responseType === 'text') {
	                        resolve(xhr.response);
	                    } else {
	                        var reader = new FileReader();
	                        // $FlowFixMe
	                        reader.addEventListener('load', function () {
	                            return resolve(reader.result);
	                        }, false);
	                        // $FlowFixMe
	                        reader.addEventListener('error', function (e) {
	                            return reject(e);
	                        }, false);
	                        reader.readAsDataURL(xhr.response);
	                    }
	                } else {
	                    reject(process.env.NODE_ENV !== 'production' ? 'Failed to proxy resource ' + src.substring(0, 256) + ' with status code ' + xhr.status : '');
	                }
	            } else {
	                resolve(xhr.responseText);
	            }
	        };
	
	        xhr.onerror = reject;
	        xhr.open('GET', proxy + '?url=' + encodeURIComponent(src) + '&responseType=' + responseType);
	
	        if (responseType !== 'text' && xhr instanceof XMLHttpRequest) {
	            xhr.responseType = responseType;
	        }
	
	        if (options.imageTimeout) {
	            var timeout = options.imageTimeout;
	            xhr.timeout = timeout;
	            xhr.ontimeout = function () {
	                return reject(process.env.NODE_ENV !== 'production' ? 'Timed out (' + timeout + 'ms) proxying ' + src.substring(0, 256) : '');
	            };
	        }
	
	        xhr.send();
	    });
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))
	
	/***/ }),
	/* 29 */
	/***/ (function(module, exports, __webpack_require__) {
	
	/* WEBPACK VAR INJECTION */(function(global) {var __WEBPACK_AMD_DEFINE_RESULT__;var __WEBPACK_AMD_DEFINE_RESULT__;var require;var require;!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define(e):t.jspdf=e()}(this,function(){"use strict";var t="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},e=(function(){function t(t){this.value=t}function e(e){function n(i,o){try{var a=e[i](o),s=a.value;s instanceof t?Promise.resolve(s.value).then(function(t){n("next",t)},function(t){n("throw",t)}):r(a.done?"return":"normal",a.value)}catch(t){r("throw",t)}}function r(t,e){switch(t){case"return":i.resolve({value:e,done:!0});break;case"throw":i.reject(e);break;default:i.resolve({value:e,done:!1})}(i=i.next)?n(i.key,i.arg):o=null}var i,o;this._invoke=function(t,e){return new Promise(function(r,a){var s={key:t,arg:e,resolve:r,reject:a,next:null};o?o=o.next=s:(i=o=s,n(t,e))})},"function"!=typeof e.return&&(this.return=void 0)}"function"==typeof Symbol&&Symbol.asyncIterator&&(e.prototype[Symbol.asyncIterator]=function(){return this}),e.prototype.next=function(t){return this._invoke("next",t)},e.prototype.throw=function(t){return this._invoke("throw",t)},e.prototype.return=function(t){return this._invoke("return",t)}}(),function(e){function n(t){var n={};this.subscribe=function(t,e,r){if("function"!=typeof e)return!1;n.hasOwnProperty(t)||(n[t]={});var i=Math.random().toString(35);return n[t][i]=[e,!!r],i},this.unsubscribe=function(t){for(var e in n)if(n[e][t])return delete n[e][t],!0;return!1},this.publish=function(r){if(n.hasOwnProperty(r)){var i=Array.prototype.slice.call(arguments,1),o=[];for(var a in n[r]){var s=n[r][a];try{s[0].apply(t,i)}catch(t){e.console&&console.error("jsPDF PubSub Error",t.message,t)}s[1]&&o.push(a)}o.length&&o.forEach(this.unsubscribe)}}}function i(c,l,u,h){var f={};"object"===(void 0===c?"undefined":t(c))&&(c=(f=c).orientation,l=f.unit||l,u=f.format||u,h=f.compress||f.compressPdf||h),l=l||"mm",u=u||"a4",c=(""+(c||"P")).toLowerCase();(""+u).toLowerCase();var d,p,m,g,w,y,v,b,x,k=!!h&&"function"==typeof Uint8Array,_=f.textColor||"0 g",C=f.drawColor||"0 G",A=f.fontSize||16,S=f.lineHeight||1.15,q=f.lineWidth||.200025,T=2,P=!1,I=[],E={},O={},F=0,B=[],R=[],D=[],j=[],z=[],N=0,L=0,M=0,U={title:"",subject:"",author:"",keywords:"",creator:""},H={},W=new n(H),X=f.hotfixes||[],V=function(t){return t.toFixed(2)},G=function(t){return t.toFixed(3)},Y=function(t){return("0"+parseInt(t)).slice(-2)},J=function(t){P?B[g].push(t):(M+=t.length+1,j.push(t))},Q=function(){return T++,I[T]=M,J(T+" 0 obj"),T},K=function(t){J("stream"),J(t),J("endstream")},$=function(){var t,n,r,a,s,c,l,u,h,f=[];for(l=e.adler32cs||i.adler32cs,k&&void 0===l&&(k=!1),t=1;t<=F;t++){if(f.push(Q()),u=(w=D[t].width)*p,h=(y=D[t].height)*p,J("<</Type /Page"),J("/Parent 1 0 R"),J("/Resources 2 0 R"),J("/MediaBox [0 0 "+V(u)+" "+V(h)+"]"),W.publish("putPage",{pageNumber:t,page:B[t]}),J("/Contents "+(T+1)+" 0 R"),J(">>"),J("endobj"),n=B[t].join("\n"),Q(),k){for(r=[],a=n.length;a--;)r[a]=n.charCodeAt(a);c=l.from(n),(s=new o(6)).append(new Uint8Array(r)),n=s.flush(),(r=new Uint8Array(n.length+6)).set(new Uint8Array([120,156])),r.set(n,2),r.set(new Uint8Array([255&c,c>>8&255,c>>16&255,c>>24&255]),n.length+2),n=String.fromCharCode.apply(null,r),J("<</Length "+n.length+" /Filter [/FlateDecode]>>")}else J("<</Length "+n.length+">>");K(n),J("endobj")}I[1]=M,J("1 0 obj"),J("<</Type /Pages");var d="/Kids [";for(a=0;a<F;a++)d+=f[a]+" 0 R ";J(d+"]"),J("/Count "+F),J(">>"),J("endobj"),W.publish("postPutPages")},Z=function(t){t.objectNumber=Q(),J("<</BaseFont/"+t.PostScriptName+"/Type/Font"),"string"==typeof t.encoding&&J("/Encoding/"+t.encoding),J("/Subtype/Type1>>"),J("endobj")},tt=function(){for(var t in E)E.hasOwnProperty(t)&&Z(E[t])},et=function(){W.publish("putXobjectDict")},nt=function(){J("/ProcSet [/PDF /Text /ImageB /ImageC /ImageI]"),J("/Font <<");for(var t in E)E.hasOwnProperty(t)&&J("/"+t+" "+E[t].objectNumber+" 0 R");J(">>"),J("/XObject <<"),et(),J(">>")},rt=function(){tt(),W.publish("putResources"),I[2]=M,J("2 0 obj"),J("<<"),nt(),J(">>"),J("endobj"),W.publish("postPutResources")},it=function(){W.publish("putAdditionalObjects");for(var t=0;t<z.length;t++){var e=z[t];I[e.objId]=M,J(e.objId+" 0 obj"),J(e.content),J("endobj")}T+=z.length,W.publish("postPutAdditionalObjects")},ot=function(t,e,n){O.hasOwnProperty(e)||(O[e]={}),O[e][n]=t},at=function(t,e,n,r){var i="F"+(Object.keys(E).length+1).toString(10),o=E[i]={id:i,PostScriptName:t,fontName:e,fontStyle:n,encoding:r,metadata:{}};return ot(i,e,n),W.publish("addFont",o),i},st=function(t,e){var n,r,i,o,a,s,c,l,u;if(e=e||{},i=e.sourceEncoding||"Unicode",a=e.outputEncoding,(e.autoencode||a)&&E[d].metadata&&E[d].metadata[i]&&E[d].metadata[i].encoding&&(o=E[d].metadata[i].encoding,!a&&E[d].encoding&&(a=E[d].encoding),!a&&o.codePages&&(a=o.codePages[0]),"string"==typeof a&&(a=o[a]),a)){for(c=!1,s=[],n=0,r=t.length;n<r;n++)(l=a[t.charCodeAt(n)])?s.push(String.fromCharCode(l)):s.push(t[n]),s[n].charCodeAt(0)>>8&&(c=!0);t=s.join("")}for(n=t.length;void 0===c&&0!==n;)t.charCodeAt(n-1)>>8&&(c=!0),n--;if(!c)return t;for(s=e.noBOM?[]:[254,255],n=0,r=t.length;n<r;n++){if(l=t.charCodeAt(n),(u=l>>8)>>8)throw new Error("Character at position "+n+" of string '"+t+"' exceeds 16bits. Cannot be encoded into UCS-2 BE");s.push(u),s.push(l-(u<<8))}return String.fromCharCode.apply(void 0,s)},ct=function(t,e){return st(t,e).replace(/\\/g,"\\\\").replace(/\(/g,"\\(").replace(/\)/g,"\\)")},lt=function(){J("/Producer (jsPDF "+i.version+")");for(var t in U)U.hasOwnProperty(t)&&U[t]&&J("/"+t.substr(0,1).toUpperCase()+t.substr(1)+" ("+ct(U[t])+")");var e=new Date,n=e.getTimezoneOffset(),r=n<0?"+":"-",o=Math.floor(Math.abs(n/60)),a=Math.abs(n%60),s=[r,Y(o),"'",Y(a),"'"].join("");J(["/CreationDate (D:",e.getFullYear(),Y(e.getMonth()+1),Y(e.getDate()),Y(e.getHours()),Y(e.getMinutes()),Y(e.getSeconds()),s,")"].join(""))},ut=function(){switch(J("/Type /Catalog"),J("/Pages 1 0 R"),b||(b="fullwidth"),b){case"fullwidth":J("/OpenAction [3 0 R /FitH null]");break;case"fullheight":J("/OpenAction [3 0 R /FitV null]");break;case"fullpage":J("/OpenAction [3 0 R /Fit]");break;case"original":J("/OpenAction [3 0 R /XYZ null null 1]");break;default:var t=""+b;"%"===t.substr(t.length-1)&&(b=parseInt(b)/100),"number"==typeof b&&J("/OpenAction [3 0 R /XYZ null null "+V(b)+"]")}switch(x||(x="continuous"),x){case"continuous":J("/PageLayout /OneColumn");break;case"single":J("/PageLayout /SinglePage");break;case"two":case"twoleft":J("/PageLayout /TwoColumnLeft");break;case"tworight":J("/PageLayout /TwoColumnRight")}v&&J("/PageMode /"+v),W.publish("putCatalog")},ht=function(){J("/Size "+(T+1)),J("/Root "+T+" 0 R"),J("/Info "+(T-1)+" 0 R")},ft=function(t,e){var n="string"==typeof e&&e.toLowerCase();if("string"==typeof t){var r=t.toLowerCase();s.hasOwnProperty(r)&&(t=s[r][0]/p,e=s[r][1]/p)}if(Array.isArray(t)&&(e=t[1],t=t[0]),n){switch(n.substr(0,1)){case"l":e>t&&(n="s");break;case"p":t>e&&(n="s")}"s"===n&&(m=t,t=e,e=m)}P=!0,B[++F]=[],D[F]={width:Number(t)||w,height:Number(e)||y},R[F]={},mt(F)},dt=function(){ft.apply(this,arguments),J(V(q*p)+" w"),J(C),0!==N&&J(N+" J"),0!==L&&J(L+" j"),W.publish("addPage",{pageNumber:F})},pt=function(t){t>0&&t<=F&&(B.splice(t,1),D.splice(t,1),g>--F&&(g=F),this.setPage(g))},mt=function(t){t>0&&t<=F&&(g=t,w=D[t].width,y=D[t].height)},gt=function(t,e){var n;switch(t=void 0!==t?t:E[d].fontName,e=void 0!==e?e:E[d].fontStyle,void 0!==t&&(t=t.toLowerCase()),t){case"sans-serif":case"verdana":case"arial":case"helvetica":t="helvetica";break;case"fixed":case"monospace":case"terminal":case"courier":t="courier";break;case"serif":case"cursive":case"fantasy":default:t="times"}try{n=O[t][e]}catch(t){}return n||null==(n=O.times[e])&&(n=O.times.normal),n},wt=function(){P=!1,T=2,M=0,j=[],I=[],z=[],W.publish("buildDocument"),J("%PDF-"+a),$(),it(),rt(),Q(),J("<<"),lt(),J(">>"),J("endobj"),Q(),J("<<"),ut(),J(">>"),J("endobj");var t,e=M,n="0000000000";for(J("xref"),J("0 "+(T+1)),J(n+" 65535 f "),t=1;t<=T;t++){var r=I[t];J("function"==typeof r?(n+I[t]()).slice(-10)+" 00000 n ":(n+I[t]).slice(-10)+" 00000 n ")}return J("trailer"),J("<<"),ht(),J(">>"),J("startxref"),J(""+e),J("%%EOF"),P=!0,j.join("\n")},yt=function(t){var e="S";return"F"===t?e="f":"FD"===t||"DF"===t?e="B":"f"!==t&&"f*"!==t&&"B"!==t&&"B*"!==t||(e=t),e},vt=function(){for(var t=wt(),e=t.length,n=new ArrayBuffer(e),r=new Uint8Array(n);e--;)r[e]=t.charCodeAt(e);return n},bt=function(){return new Blob([vt()],{type:"application/pdf"})},xt=function(t){return t.foo=function(){try{return t.apply(this,arguments)}catch(t){var n=t.stack||"";~n.indexOf(" at ")&&(n=n.split(" at ")[1]);var r="Error in function "+n.split("\n")[0].split("<")[0]+": "+t.message;if(!e.console)throw new Error(r);e.console.error(r,t),e.alert&&alert(r)}},t.foo.bar=t,t.foo}(function(t,n){var i="dataur"===(""+t).substr(0,6)?"data:application/pdf;base64,"+btoa(wt()):0;switch(t){case void 0:return wt();case"save":if(navigator.getUserMedia&&(void 0===e.URL||void 0===e.URL.createObjectURL))return H.output("dataurlnewwindow");r(bt(),n),"function"==typeof r.unload&&e.setTimeout&&setTimeout(r.unload,911);break;case"arraybuffer":return vt();case"blob":return bt();case"bloburi":case"bloburl":return e.URL&&e.URL.createObjectURL(bt())||void 0;case"datauristring":case"dataurlstring":return i;case"dataurlnewwindow":var o=e.open(i);if(o||"undefined"==typeof safari)return o;case"datauri":case"dataurl":return e.document.location.href=i;default:throw new Error('Output type "'+t+'" is not supported.')}}),kt=function(t){return!0===Array.isArray(X)&&X.indexOf(t)>-1};switch(l){case"pt":p=1;break;case"mm":p=72/25.4000508;break;case"cm":p=72/2.54000508;break;case"in":p=72;break;case"px":p=1==kt("px_scaling")?.75:96/72;break;case"pc":case"em":p=12;break;case"ex":p=6;break;default:throw"Invalid unit: "+l}H.internal={pdfEscape:ct,getStyle:yt,getFont:function(){return E[gt.apply(H,arguments)]},getFontSize:function(){return A},getLineHeight:function(){return A*S},write:function(t){J(1===arguments.length?t:Array.prototype.join.call(arguments," "))},getCoordinateString:function(t){return V(t*p)},getVerticalCoordinateString:function(t){return V((y-t)*p)},collections:{},newObject:Q,newAdditionalObject:function(){var t=2*B.length+1,e={objId:t+=z.length,content:""};return z.push(e),e},newObjectDeferred:function(){return T++,I[T]=function(){return M},T},newObjectDeferredBegin:function(t){I[t]=M},putStream:K,events:W,scaleFactor:p,pageSize:{get width(){return w},get height(){return y}},output:function(t,e){return xt(t,e)},getNumberOfPages:function(){return B.length-1},pages:B,out:J,f2:V,getPageInfo:function(t){return{objId:2*(t-1)+3,pageNumber:t,pageContext:R[t]}},getCurrentPageInfo:function(){return{objId:2*(g-1)+3,pageNumber:g,pageContext:R[g]}},getPDFVersion:function(){return a},hasHotfix:kt},H.addPage=function(){return dt.apply(this,arguments),this},H.setPage=function(){return mt.apply(this,arguments),this},H.insertPage=function(t){return this.addPage(),this.movePage(g,t),this},H.movePage=function(t,e){if(t>e){for(var n=B[t],r=D[t],i=R[t],o=t;o>e;o--)B[o]=B[o-1],D[o]=D[o-1],R[o]=R[o-1];B[e]=n,D[e]=r,R[e]=i,this.setPage(e)}else if(t<e){for(var n=B[t],r=D[t],i=R[t],o=t;o<e;o++)B[o]=B[o+1],D[o]=D[o+1],R[o]=R[o+1];B[e]=n,D[e]=r,R[e]=i,this.setPage(e)}return this},H.deletePage=function(){return pt.apply(this,arguments),this},H.setDisplayMode=function(t,e,n){if(b=t,x=e,v=n,-1==[void 0,null,"UseNone","UseOutlines","UseThumbs","FullScreen"].indexOf(n))throw new Error('Page mode must be one of UseNone, UseOutlines, UseThumbs, or FullScreen. "'+n+'" is not recognized.');return this},H.text=function(t,e,n,r,i,o){function a(t){return t=t.split("\t").join(Array(f.TabLen||9).join(" ")),ct(t,r)}"number"==typeof t&&(m=n,n=e,e=t,t=m),"string"==typeof t&&(t=t.match(/[\n\r]/)?t.split(/\r\n|\r|\n/g):[t]),"string"==typeof i&&(o=i,i=null),"string"==typeof r&&(o=r,r=null),"number"==typeof r&&(i=r,r=null);var s="",c="Td";if(i){i*=Math.PI/180;var l=Math.cos(i),u=Math.sin(i);s=[V(l),V(u),V(-1*u),V(l),""].join(" "),c="Tm"}"noBOM"in(r=r||{})||(r.noBOM=!0),"autoencode"in r||(r.autoencode=!0);var h="",g=this.internal.getCurrentPageInfo().pageContext;if(!0===r.stroke?!0!==g.lastTextWasStroke&&(h="1 Tr\n",g.lastTextWasStroke=!0):(g.lastTextWasStroke&&(h="0 Tr\n"),g.lastTextWasStroke=!1),void 0===this._runningPageHeight&&(this._runningPageHeight=0),"string"==typeof t)t=a(t);else{if("[object Array]"!==Object.prototype.toString.call(t))throw new Error('Type of text must be string or Array. "'+t+'" is not recognized.');for(var w=t.concat(),v=[],b=w.length;b--;)v.push(a(w.shift()));if(o){var x,k,C,q=A*S,T=t.map(function(t){return this.getStringUnitWidth(t)*A/p},this);if(C=Math.max.apply(Math,T),"center"===o)x=e-C/2,e-=T[0]/2;else{if("right"!==o)throw new Error('Unrecognized alignment option, use "center" or "right".');x=e-C,e-=T[0]}k=e,t=v[0];for(var P=1,b=v.length;P<b;P++){var I=C-T[P];"center"===o&&(I/=2),t+=") Tj\n"+(x-k+I)+" -"+q+" Td ("+v[P],k=x+I}}else t=v.join(") Tj\nT* (")}var E;return E=V((y-n)*p),J("BT\n/"+d+" "+A+" Tf\n"+A*S+" TL\n"+h+_+"\n"+s+V(e*p)+" "+E+" "+c+"\n("+t+") Tj\nET"),this},H.lstext=function(t,e,n,r){console.warn("jsPDF.lstext is deprecated");for(var i=0,o=t.length;i<o;i++,e+=r)this.text(t[i],e,n);return this},H.line=function(t,e,n,r){return this.lines([[n-t,r-e]],t,e)},H.clip=function(){J("W"),J("S")},H.clip_fixed=function(t){J("evenodd"===t?"W*":"W"),J("n")},H.lines=function(t,e,n,r,i,o){var a,s,c,l,u,h,f,d,g,w,v;for("number"==typeof t&&(m=n,n=e,e=t,t=m),r=r||[1,1],J(G(e*p)+" "+G((y-n)*p)+" m "),a=r[0],s=r[1],l=t.length,w=e,v=n,c=0;c<l;c++)2===(u=t[c]).length?(w=u[0]*a+w,v=u[1]*s+v,J(G(w*p)+" "+G((y-v)*p)+" l")):(h=u[0]*a+w,f=u[1]*s+v,d=u[2]*a+w,g=u[3]*s+v,w=u[4]*a+w,v=u[5]*s+v,J(G(h*p)+" "+G((y-f)*p)+" "+G(d*p)+" "+G((y-g)*p)+" "+G(w*p)+" "+G((y-v)*p)+" c"));return o&&J(" h"),null!==i&&J(yt(i)),this},H.rect=function(t,e,n,r,i){yt(i);return J([V(t*p),V((y-e)*p),V(n*p),V(-r*p),"re"].join(" ")),null!==i&&J(yt(i)),this},H.triangle=function(t,e,n,r,i,o,a){return this.lines([[n-t,r-e],[i-n,o-r],[t-i,e-o]],t,e,[1,1],a,!0),this},H.roundedRect=function(t,e,n,r,i,o,a){var s=4/3*(Math.SQRT2-1);return this.lines([[n-2*i,0],[i*s,0,i,o-o*s,i,o],[0,r-2*o],[0,o*s,-i*s,o,-i,o],[2*i-n,0],[-i*s,0,-i,-o*s,-i,-o],[0,2*o-r],[0,-o*s,i*s,-o,i,-o]],t+i,e,[1,1],a),this},H.ellipse=function(t,e,n,r,i){var o=4/3*(Math.SQRT2-1)*n,a=4/3*(Math.SQRT2-1)*r;return J([V((t+n)*p),V((y-e)*p),"m",V((t+n)*p),V((y-(e-a))*p),V((t+o)*p),V((y-(e-r))*p),V(t*p),V((y-(e-r))*p),"c"].join(" ")),J([V((t-o)*p),V((y-(e-r))*p),V((t-n)*p),V((y-(e-a))*p),V((t-n)*p),V((y-e)*p),"c"].join(" ")),J([V((t-n)*p),V((y-(e+a))*p),V((t-o)*p),V((y-(e+r))*p),V(t*p),V((y-(e+r))*p),"c"].join(" ")),J([V((t+o)*p),V((y-(e+r))*p),V((t+n)*p),V((y-(e+a))*p),V((t+n)*p),V((y-e)*p),"c"].join(" ")),null!==i&&J(yt(i)),this},H.circle=function(t,e,n,r){return this.ellipse(t,e,n,n,r)},H.setProperties=function(t){for(var e in U)U.hasOwnProperty(e)&&t[e]&&(U[e]=t[e]);return this},H.setFontSize=function(t){return A=t,this},H.setFont=function(t,e){return d=gt(t,e),this},H.setFontStyle=H.setFontType=function(t){return d=gt(void 0,t),this},H.getFontList=function(){var t,e,n,r={};for(t in O)if(O.hasOwnProperty(t)){r[t]=n=[];for(e in O[t])O[t].hasOwnProperty(e)&&n.push(e)}return r},H.addFont=function(t,e,n){at(t,e,n,"StandardEncoding")},H.setLineWidth=function(t){return J((t*p).toFixed(2)+" w"),this},H.setDrawColor=function(t,e,n,r){var i;return i=void 0===e||void 0===r&&t===e===n?"string"==typeof t?t+" G":V(t/255)+" G":void 0===r?"string"==typeof t?[t,e,n,"RG"].join(" "):[V(t/255),V(e/255),V(n/255),"RG"].join(" "):"string"==typeof t?[t,e,n,r,"K"].join(" "):[V(t),V(e),V(n),V(r),"K"].join(" "),J(i),this},H.setFillColor=function(e,n,r,i){var o;return void 0===n||void 0===i&&e===n===r?o="string"==typeof e?e+" g":V(e/255)+" g":void 0===i||"object"===(void 0===i?"undefined":t(i))?(o="string"==typeof e?[e,n,r,"rg"].join(" "):[V(e/255),V(n/255),V(r/255),"rg"].join(" "),i&&0===i.a&&(o=["255","255","255","rg"].join(" "))):o="string"==typeof e?[e,n,r,i,"k"].join(" "):[V(e),V(n),V(r),V(i),"k"].join(" "),J(o),this},H.setTextColor=function(t,e,n){if("string"==typeof t&&/^#[0-9A-Fa-f]{6}$/.test(t)){var r=parseInt(t.substr(1),16);t=r>>16&255,e=r>>8&255,n=255&r}return _=0===t&&0===e&&0===n||void 0===e?G(t/255)+" g":[G(t/255),G(e/255),G(n/255),"rg"].join(" "),this},H.CapJoinStyles={0:0,butt:0,but:0,miter:0,1:1,round:1,rounded:1,circle:1,2:2,projecting:2,project:2,square:2,bevel:2},H.setLineCap=function(t){var e=this.CapJoinStyles[t];if(void 0===e)throw new Error("Line cap style of '"+t+"' is not recognized. See or extend .CapJoinStyles property for valid styles");return N=e,J(e+" J"),this},H.setLineJoin=function(t){var e=this.CapJoinStyles[t];if(void 0===e)throw new Error("Line join style of '"+t+"' is not recognized. See or extend .CapJoinStyles property for valid styles");return L=e,J(e+" j"),this},H.output=xt,H.save=function(t){H.output("save",t)};for(var _t in i.API)i.API.hasOwnProperty(_t)&&("events"===_t&&i.API.events.length?function(t,e){var n,r,i;for(i=e.length-1;-1!==i;i--)n=e[i][0],r=e[i][1],t.subscribe.apply(t,[n].concat("function"==typeof r?[r]:r))}(W,i.API.events):H[_t]=i.API[_t]);return function(){for(var t=[["Helvetica","helvetica","normal"],["Helvetica-Bold","helvetica","bold"],["Helvetica-Oblique","helvetica","italic"],["Helvetica-BoldOblique","helvetica","bolditalic"],["Courier","courier","normal"],["Courier-Bold","courier","bold"],["Courier-Oblique","courier","italic"],["Courier-BoldOblique","courier","bolditalic"],["Times-Roman","times","normal"],["Times-Bold","times","bold"],["Times-Italic","times","italic"],["Times-BoldItalic","times","bolditalic"],["ZapfDingbats","zapfdingbats"]],e=0,n=t.length;e<n;e++){var r=at(t[e][0],t[e][1],t[e][2],"StandardEncoding"),i=t[e][0].split("-");ot(r,i[0],i[1]||"")}W.publish("addFonts",{fonts:E,dictionary:O})}(),d="F1",dt(u,c),W.publish("initialized"),H}var a="1.3",s={a0:[2383.94,3370.39],a1:[1683.78,2383.94],a2:[1190.55,1683.78],a3:[841.89,1190.55],a4:[595.28,841.89],a5:[419.53,595.28],a6:[297.64,419.53],a7:[209.76,297.64],a8:[147.4,209.76],a9:[104.88,147.4],a10:[73.7,104.88],b0:[2834.65,4008.19],b1:[2004.09,2834.65],b2:[1417.32,2004.09],b3:[1000.63,1417.32],b4:[708.66,1000.63],b5:[498.9,708.66],b6:[354.33,498.9],b7:[249.45,354.33],b8:[175.75,249.45],b9:[124.72,175.75],b10:[87.87,124.72],c0:[2599.37,3676.54],c1:[1836.85,2599.37],c2:[1298.27,1836.85],c3:[918.43,1298.27],c4:[649.13,918.43],c5:[459.21,649.13],c6:[323.15,459.21],c7:[229.61,323.15],c8:[161.57,229.61],c9:[113.39,161.57],c10:[79.37,113.39],dl:[311.81,623.62],letter:[612,792],"government-letter":[576,756],legal:[612,1008],"junior-legal":[576,360],ledger:[1224,792],tabloid:[792,1224],"credit-card":[153,243]};return i.API={events:[]},i.version="1.x-master", true?!(__WEBPACK_AMD_DEFINE_RESULT__ = (function(){return i}).call(exports, __webpack_require__, exports, module),
					__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"undefined"!=typeof module&&module.exports?module.exports=i:e.jsPDF=i,i}("undefined"!=typeof self&&self||"undefined"!=typeof window&&window||void 0));/**
	 * jsPDF AcroForm Plugin
	 * Copyright (c) 2016 Alexander Weidt, https://github.com/BiggA94
	 *
	 * Licensed under the MIT License.
	 * http://opensource.org/licenses/mit-license
	 */
	(window.AcroForm=function(t){var n=window.AcroForm;n.scale=function(t){return t*(r.internal.scaleFactor/1)},n.antiScale=function(t){return 1/r.internal.scaleFactor*t};var r={fields:[],xForms:[],acroFormDictionaryRoot:null,printedOut:!1,internal:null};e.API.acroformPlugin=r;var i=function(){for(var t in this.acroformPlugin.acroFormDictionaryRoot.Fields){var e=this.acroformPlugin.acroFormDictionaryRoot.Fields[t];e.hasAnnotation&&a.call(this,e)}},o=function(){if(this.acroformPlugin.acroFormDictionaryRoot)throw new Error("Exception while creating AcroformDictionary");this.acroformPlugin.acroFormDictionaryRoot=new n.AcroFormDictionary,this.acroformPlugin.internal=this.internal,this.acroformPlugin.acroFormDictionaryRoot._eventID=this.internal.events.subscribe("postPutResources",l),this.internal.events.subscribe("buildDocument",i),this.internal.events.subscribe("putCatalog",c),this.internal.events.subscribe("postPutPages",u)},a=function(t){var n={type:"reference",object:t};e.API.annotationPlugin.annotations[this.internal.getPageInfo(t.page).pageNumber].push(n)},s=function(t){this.acroformPlugin.printedOut&&(this.acroformPlugin.printedOut=!1,this.acroformPlugin.acroFormDictionaryRoot=null),this.acroformPlugin.acroFormDictionaryRoot||o.call(this),this.acroformPlugin.acroFormDictionaryRoot.Fields.push(t)},c=function(){void 0!==this.acroformPlugin.acroFormDictionaryRoot?this.internal.write("/AcroForm "+this.acroformPlugin.acroFormDictionaryRoot.objId+" 0 R"):console.log("Root missing...")},l=function(){this.internal.events.unsubscribe(this.acroformPlugin.acroFormDictionaryRoot._eventID),delete this.acroformPlugin.acroFormDictionaryRoot._eventID,this.acroformPlugin.printedOut=!0},u=function(t){var e=!t;t||(this.internal.newObjectDeferredBegin(this.acroformPlugin.acroFormDictionaryRoot.objId),this.internal.out(this.acroformPlugin.acroFormDictionaryRoot.getString()));var t=t||this.acroformPlugin.acroFormDictionaryRoot.Kids;for(var r in t){var i=t[r],o=i.Rect;i.Rect&&(i.Rect=n.internal.calculateCoordinates.call(this,i.Rect)),this.internal.newObjectDeferredBegin(i.objId);var a="";if(a+=i.objId+" 0 obj\n",a+="<<\n"+i.getContent(),i.Rect=o,i.hasAppearanceStream&&!i.appearanceStreamContent){var s=n.internal.calculateAppearanceStream.call(this,i);a+="/AP << /N "+s+" >>\n",this.acroformPlugin.xForms.push(s)}if(i.appearanceStreamContent){a+="/AP << ";for(var c in i.appearanceStreamContent){var l=i.appearanceStreamContent[c];if(a+="/"+c+" ",a+="<< ",Object.keys(l).length>=1||Array.isArray(l))for(var r in l)"function"==typeof(u=l[r])&&(u=u.call(this,i)),a+="/"+r+" "+u+" ",this.acroformPlugin.xForms.indexOf(u)>=0||this.acroformPlugin.xForms.push(u);else{var u=l;"function"==typeof u&&(u=u.call(this,i)),a+="/"+r+" "+u+" \n",this.acroformPlugin.xForms.indexOf(u)>=0||this.acroformPlugin.xForms.push(u)}a+=" >>\n"}a+=">>\n"}a+=">>\nendobj\n",this.internal.out(a)}e&&h.call(this,this.acroformPlugin.xForms)},h=function(t){for(var e in t){var n=e,r=t[e];this.internal.newObjectDeferredBegin(r&&r.objId);var i="";i+=r?r.getString():"",this.internal.out(i),delete t[n]}};t.addField=function(t){return t instanceof n.TextField?d.call(this,t):t instanceof n.ChoiceField?p.call(this,t):t instanceof n.Button?f.call(this,t):t instanceof n.ChildClass?s.call(this,t):t&&s.call(this,t),t.page=this.acroformPlugin.internal.getCurrentPageInfo().pageNumber,this};var f=function(t){(t=t||new n.Field).FT="/Btn";var e=t.Ff||0;t.pushbutton&&(e=n.internal.setBitPosition(e,17),delete t.pushbutton),t.radio&&(e=n.internal.setBitPosition(e,16),delete t.radio),t.noToggleToOff&&(e=n.internal.setBitPosition(e,15)),t.Ff=e,s.call(this,t)},d=function(t){(t=t||new n.Field).FT="/Tx";var e=t.Ff||0;t.multiline&&(e|=4096),t.password&&(e|=8192),t.fileSelect&&(e|=1<<20),t.doNotSpellCheck&&(e|=1<<22),t.doNotScroll&&(e|=1<<23),t.Ff=t.Ff||e,s.call(this,t)},p=function(t){var e=t||new n.Field;e.FT="/Ch";var r=e.Ff||0;e.combo&&(r=n.internal.setBitPosition(r,18),delete e.combo),e.edit&&(r=n.internal.setBitPosition(r,19),delete e.edit),e.sort&&(r=n.internal.setBitPosition(r,20),delete e.sort),e.multiSelect&&this.internal.getPDFVersion()>=1.4&&(r=n.internal.setBitPosition(r,22),delete e.multiSelect),e.doNotSpellCheck&&this.internal.getPDFVersion()>=1.4&&(r=n.internal.setBitPosition(r,23),delete e.doNotSpellCheck),e.Ff=r,s.call(this,e)}})(e.API);var n=window.AcroForm;n.internal={},n.createFormXObject=function(t){var e=new n.FormXObject,r=n.Appearance.internal.getHeight(t)||0,i=n.Appearance.internal.getWidth(t)||0;return e.BBox=[0,0,i,r],e},n.Appearance={CheckBox:{createAppearanceStream:function(){return{N:{On:n.Appearance.CheckBox.YesNormal},D:{On:n.Appearance.CheckBox.YesPushDown,Off:n.Appearance.CheckBox.OffPushDown}}},createMK:function(){return"<< /CA (3)>>"},YesPushDown:function(t){var e=n.createFormXObject(t),r="";t.Q=1;var i=n.internal.calculateX(t,"3","ZapfDingbats",50);return r+="0.749023 g\n             0 0 "+n.Appearance.internal.getWidth(t)+" "+n.Appearance.internal.getHeight(t)+" re\n             f\n             BMC\n             q\n             0 0 1 rg\n             /F13 "+i.fontSize+" Tf 0 g\n             BT\n",r+=i.text,r+="ET\n             Q\n             EMC\n",e.stream=r,e},YesNormal:function(t){var e=n.createFormXObject(t),r="";t.Q=1;var i=n.internal.calculateX(t,"3","ZapfDingbats",.9*n.Appearance.internal.getHeight(t));return r+="1 g\n0 0 "+n.Appearance.internal.getWidth(t)+" "+n.Appearance.internal.getHeight(t)+" re\nf\nq\n0 0 1 rg\n0 0 "+(n.Appearance.internal.getWidth(t)-1)+" "+(n.Appearance.internal.getHeight(t)-1)+" re\nW\nn\n0 g\nBT\n/F13 "+i.fontSize+" Tf 0 g\n",r+=i.text,r+="ET\n             Q\n",e.stream=r,e},OffPushDown:function(t){var e=n.createFormXObject(t),r="";return r+="0.749023 g\n            0 0 "+n.Appearance.internal.getWidth(t)+" "+n.Appearance.internal.getHeight(t)+" re\n            f\n",e.stream=r,e}},RadioButton:{Circle:{createAppearanceStream:function(t){var e={D:{Off:n.Appearance.RadioButton.Circle.OffPushDown},N:{}};return e.N[t]=n.Appearance.RadioButton.Circle.YesNormal,e.D[t]=n.Appearance.RadioButton.Circle.YesPushDown,e},createMK:function(){return"<< /CA (l)>>"},YesNormal:function(t){var e=n.createFormXObject(t),r="",i=n.Appearance.internal.getWidth(t)<=n.Appearance.internal.getHeight(t)?n.Appearance.internal.getWidth(t)/4:n.Appearance.internal.getHeight(t)/4;i*=.9;var o=n.Appearance.internal.Bezier_C;return r+="q\n1 0 0 1 "+n.Appearance.internal.getWidth(t)/2+" "+n.Appearance.internal.getHeight(t)/2+" cm\n"+i+" 0 m\n"+i+" "+i*o+" "+i*o+" "+i+" 0 "+i+" c\n-"+i*o+" "+i+" -"+i+" "+i*o+" -"+i+" 0 c\n-"+i+" -"+i*o+" -"+i*o+" -"+i+" 0 -"+i+" c\n"+i*o+" -"+i+" "+i+" -"+i*o+" "+i+" 0 c\nf\nQ\n",e.stream=r,e},YesPushDown:function(t){var e=n.createFormXObject(t),r="",i=n.Appearance.internal.getWidth(t)<=n.Appearance.internal.getHeight(t)?n.Appearance.internal.getWidth(t)/4:n.Appearance.internal.getHeight(t)/4,o=2*(i*=.9),a=o*n.Appearance.internal.Bezier_C,s=i*n.Appearance.internal.Bezier_C;return r+="0.749023 g\n            q\n           1 0 0 1 "+n.Appearance.internal.getWidth(t)/2+" "+n.Appearance.internal.getHeight(t)/2+" cm\n"+o+" 0 m\n"+o+" "+a+" "+a+" "+o+" 0 "+o+" c\n-"+a+" "+o+" -"+o+" "+a+" -"+o+" 0 c\n-"+o+" -"+a+" -"+a+" -"+o+" 0 -"+o+" c\n"+a+" -"+o+" "+o+" -"+a+" "+o+" 0 c\n            f\n            Q\n            0 g\n            q\n            1 0 0 1 "+n.Appearance.internal.getWidth(t)/2+" "+n.Appearance.internal.getHeight(t)/2+" cm\n"+i+" 0 m\n"+i+" "+s+" "+s+" "+i+" 0 "+i+" c\n-"+s+" "+i+" -"+i+" "+s+" -"+i+" 0 c\n-"+i+" -"+s+" -"+s+" -"+i+" 0 -"+i+" c\n"+s+" -"+i+" "+i+" -"+s+" "+i+" 0 c\n            f\n            Q\n",e.stream=r,e},OffPushDown:function(t){var e=n.createFormXObject(t),r="",i=n.Appearance.internal.getWidth(t)<=n.Appearance.internal.getHeight(t)?n.Appearance.internal.getWidth(t)/4:n.Appearance.internal.getHeight(t)/4,o=2*(i*=.9),a=o*n.Appearance.internal.Bezier_C;return r+="0.749023 g\n            q\n 1 0 0 1 "+n.Appearance.internal.getWidth(t)/2+" "+n.Appearance.internal.getHeight(t)/2+" cm\n"+o+" 0 m\n"+o+" "+a+" "+a+" "+o+" 0 "+o+" c\n-"+a+" "+o+" -"+o+" "+a+" -"+o+" 0 c\n-"+o+" -"+a+" -"+a+" -"+o+" 0 -"+o+" c\n"+a+" -"+o+" "+o+" -"+a+" "+o+" 0 c\n            f\n            Q\n",e.stream=r,e}},Cross:{createAppearanceStream:function(t){var e={D:{Off:n.Appearance.RadioButton.Cross.OffPushDown},N:{}};return e.N[t]=n.Appearance.RadioButton.Cross.YesNormal,e.D[t]=n.Appearance.RadioButton.Cross.YesPushDown,e},createMK:function(){return"<< /CA (8)>>"},YesNormal:function(t){var e=n.createFormXObject(t),r="",i=n.Appearance.internal.calculateCross(t);return r+="q\n            1 1 "+(n.Appearance.internal.getWidth(t)-2)+" "+(n.Appearance.internal.getHeight(t)-2)+" re\n            W\n            n\n            "+i.x1.x+" "+i.x1.y+" m\n            "+i.x2.x+" "+i.x2.y+" l\n            "+i.x4.x+" "+i.x4.y+" m\n            "+i.x3.x+" "+i.x3.y+" l\n            s\n            Q\n",e.stream=r,e},YesPushDown:function(t){var e=n.createFormXObject(t),r=n.Appearance.internal.calculateCross(t),i="";return i+="0.749023 g\n            0 0 "+n.Appearance.internal.getWidth(t)+" "+n.Appearance.internal.getHeight(t)+" re\n            f\n            q\n            1 1 "+(n.Appearance.internal.getWidth(t)-2)+" "+(n.Appearance.internal.getHeight(t)-2)+" re\n            W\n            n\n            "+r.x1.x+" "+r.x1.y+" m\n            "+r.x2.x+" "+r.x2.y+" l\n            "+r.x4.x+" "+r.x4.y+" m\n            "+r.x3.x+" "+r.x3.y+" l\n            s\n            Q\n",e.stream=i,e},OffPushDown:function(t){var e=n.createFormXObject(t),r="";return r+="0.749023 g\n            0 0 "+n.Appearance.internal.getWidth(t)+" "+n.Appearance.internal.getHeight(t)+" re\n            f\n",e.stream=r,e}}},createDefaultAppearanceStream:function(t){var e="";return e+="/Helv 0 Tf 0 g"}},n.Appearance.internal={Bezier_C:.551915024494,calculateCross:function(t){var e=n.Appearance.internal.getWidth(t),r=n.Appearance.internal.getHeight(t),i=function(t,e){return t>e?e:t}(e,r);return{x1:{x:(e-i)/2,y:(r-i)/2+i},x2:{x:(e-i)/2+i,y:(r-i)/2},x3:{x:(e-i)/2,y:(r-i)/2},x4:{x:(e-i)/2+i,y:(r-i)/2+i}}}},n.Appearance.internal.getWidth=function(t){return t.Rect[2]},n.Appearance.internal.getHeight=function(t){return t.Rect[3]},n.internal.inherit=function(t,e){t.prototype=Object.create(e.prototype),t.prototype.constructor=t},n.internal.arrayToPdfArray=function(t){if(Array.isArray(t)){var e=" [";for(var n in t)e+=t[n].toString(),e+=n<t.length-1?" ":"";return e+="]"}},n.internal.toPdfString=function(t){return 0!==(t=t||"").indexOf("(")&&(t="("+t),")"!=t.substring(t.length-1)&&(t+="("),t},n.PDFObject=function(){var t;Object.defineProperty(this,"objId",{get:function(){return t||(this.internal?t=this.internal.newObjectDeferred():e.API.acroformPlugin.internal&&(t=e.API.acroformPlugin.internal.newObjectDeferred())),t||console.log("Couldn't create Object ID"),t},configurable:!1})},n.PDFObject.prototype.toString=function(){return this.objId+" 0 R"},n.PDFObject.prototype.getString=function(){var t=this.objId+" 0 obj\n<<";return t+=this.getContent()+">>\n",this.stream&&(t+="stream\n",t+=this.stream,t+="endstream\n"),t+="endobj\n"},n.PDFObject.prototype.getContent=function(){var t="";return t+=function(t){var e="",r=Object.keys(t).filter(function(t){return"content"!=t&&"appearanceStreamContent"!=t&&"_"!=t.substring(0,1)});for(var i in r){var o=r[i],a=t[o];a&&(Array.isArray(a)?e+="/"+o+" "+n.internal.arrayToPdfArray(a)+"\n":a instanceof n.PDFObject?e+="/"+o+" "+a.objId+" 0 R\n":e+="/"+o+" "+a+"\n")}return e}(this)},n.FormXObject=function(){n.PDFObject.call(this),this.Type="/XObject",this.Subtype="/Form",this.FormType=1,this.BBox,this.Matrix,this.Resources="2 0 R",this.PieceInfo;var t;Object.defineProperty(this,"Length",{enumerable:!0,get:function(){return void 0!==t?t.length:0}}),Object.defineProperty(this,"stream",{enumerable:!1,set:function(e){t=e},get:function(){return t||null}})},n.internal.inherit(n.FormXObject,n.PDFObject),n.AcroFormDictionary=function(){n.PDFObject.call(this);var t=[];Object.defineProperty(this,"Kids",{enumerable:!1,configurable:!0,get:function(){return t.length>0?t:void 0}}),Object.defineProperty(this,"Fields",{enumerable:!0,configurable:!0,get:function(){return t}}),this.DA},n.internal.inherit(n.AcroFormDictionary,n.PDFObject),n.Field=function(){n.PDFObject.call(this);var t;Object.defineProperty(this,"Rect",{enumerable:!0,configurable:!1,get:function(){if(t)return t},set:function(e){t=e}});var e="";Object.defineProperty(this,"FT",{enumerable:!0,set:function(t){e=t},get:function(){return e}});var r;Object.defineProperty(this,"T",{enumerable:!0,configurable:!1,set:function(t){r=t},get:function(){if(!r||r.length<1){if(this instanceof n.ChildClass)return;return"(FieldObject"+n.Field.FieldNum+++")"}return"("==r.substring(0,1)&&r.substring(r.length-1)?r:"("+r+")"}});var i;Object.defineProperty(this,"DA",{enumerable:!0,get:function(){if(i)return"("+i+")"},set:function(t){i=t}});var o;Object.defineProperty(this,"DV",{enumerable:!0,configurable:!0,get:function(){if(o)return o},set:function(t){o=t}}),Object.defineProperty(this,"Type",{enumerable:!0,get:function(){return this.hasAnnotation?"/Annot":null}}),Object.defineProperty(this,"Subtype",{enumerable:!0,get:function(){return this.hasAnnotation?"/Widget":null}}),this.BG,Object.defineProperty(this,"hasAnnotation",{enumerable:!1,get:function(){return!!(this.Rect||this.BC||this.BG)}}),Object.defineProperty(this,"hasAppearanceStream",{enumerable:!1,configurable:!0,writable:!0}),Object.defineProperty(this,"page",{enumerable:!1,configurable:!0,writable:!0})},n.Field.FieldNum=0,n.internal.inherit(n.Field,n.PDFObject),n.ChoiceField=function(){n.Field.call(this),this.FT="/Ch",this.Opt=[],this.V="()",this.TI=0,this.combo=!1,Object.defineProperty(this,"edit",{enumerable:!0,set:function(t){1==t?(this._edit=!0,this.combo=!0):this._edit=!1},get:function(){return!!this._edit&&this._edit},configurable:!1}),this.hasAppearanceStream=!0,Object.defineProperty(this,"V",{get:function(){n.internal.toPdfString()}})},n.internal.inherit(n.ChoiceField,n.Field),window.ChoiceField=n.ChoiceField,n.ListBox=function(){n.ChoiceField.call(this)},n.internal.inherit(n.ListBox,n.ChoiceField),window.ListBox=n.ListBox,n.ComboBox=function(){n.ListBox.call(this),this.combo=!0},n.internal.inherit(n.ComboBox,n.ListBox),window.ComboBox=n.ComboBox,n.EditBox=function(){n.ComboBox.call(this),this.edit=!0},n.internal.inherit(n.EditBox,n.ComboBox),window.EditBox=n.EditBox,n.Button=function(){n.Field.call(this),this.FT="/Btn"},n.internal.inherit(n.Button,n.Field),window.Button=n.Button,n.PushButton=function(){n.Button.call(this),this.pushbutton=!0},n.internal.inherit(n.PushButton,n.Button),window.PushButton=n.PushButton,n.RadioButton=function(){n.Button.call(this),this.radio=!0;var t=[];Object.defineProperty(this,"Kids",{enumerable:!0,get:function(){if(t.length>0)return t}}),Object.defineProperty(this,"__Kids",{get:function(){return t}});var e;Object.defineProperty(this,"noToggleToOff",{enumerable:!1,get:function(){return e},set:function(t){e=t}})},n.internal.inherit(n.RadioButton,n.Button),window.RadioButton=n.RadioButton,n.ChildClass=function(t,e){n.Field.call(this),this.Parent=t,this._AppearanceType=n.Appearance.RadioButton.Circle,this.appearanceStreamContent=this._AppearanceType.createAppearanceStream(e),this.F=n.internal.setBitPosition(this.F,3,1),this.MK=this._AppearanceType.createMK(),this.AS="/Off",this._Name=e},n.internal.inherit(n.ChildClass,n.Field),n.RadioButton.prototype.setAppearance=function(t){if("createAppearanceStream"in t&&"createMK"in t)for(var e in this.__Kids){var n=this.__Kids[e];n.appearanceStreamContent=t.createAppearanceStream(n._Name),n.MK=t.createMK()}else console.log("Couldn't assign Appearance to RadioButton. Appearance was Invalid!")},n.RadioButton.prototype.createOption=function(t){var r=this,i=new n.ChildClass(r,t);return this.__Kids.push(i),e.API.addField(i),i},n.CheckBox=function(){Button.call(this),this.appearanceStreamContent=n.Appearance.CheckBox.createAppearanceStream(),this.MK=n.Appearance.CheckBox.createMK(),this.AS="/On",this.V="/On"},n.internal.inherit(n.CheckBox,n.Button),window.CheckBox=n.CheckBox,n.TextField=function(){n.Field.call(this),this.DA=n.Appearance.createDefaultAppearanceStream(),this.F=4;var t;Object.defineProperty(this,"V",{get:function(){return t?"("+t+")":t},enumerable:!0,set:function(e){t=e}});var e;Object.defineProperty(this,"DV",{get:function(){return e?"("+e+")":e},enumerable:!0,set:function(t){e=t}});var r=!1;Object.defineProperty(this,"multiline",{enumerable:!1,get:function(){return r},set:function(t){r=t}});var i=!1;Object.defineProperty(this,"MaxLen",{enumerable:!0,get:function(){return i},set:function(t){i=t}}),Object.defineProperty(this,"hasAppearanceStream",{enumerable:!1,get:function(){return this.V||this.DV}})},n.internal.inherit(n.TextField,n.Field),window.TextField=n.TextField,n.PasswordField=function(){TextField.call(this),Object.defineProperty(this,"password",{value:!0,enumerable:!1,configurable:!1,writable:!1})},n.internal.inherit(n.PasswordField,n.TextField),window.PasswordField=n.PasswordField,n.internal.calculateFontSpace=function(t,e,r){var r=r||"helvetica",i=n.internal.calculateFontSpace.canvas||(n.internal.calculateFontSpace.canvas=document.createElement("canvas"));(s=i.getContext("2d")).save();var o=e+" "+r;s.font=o;var a=s.measureText(t);s.fontcolor="black";var s=i.getContext("2d");return a.height=1.5*s.measureText("3").width,s.restore(),a},n.internal.calculateX=function(t,e,r,i){var i=i||12,r=r||"helvetica",o={text:"",fontSize:""},a=(e=")"==(e="("==e.substr(0,1)?e.substr(1):e).substr(e.length-1)?e.substr(0,e.length-1):e).split(" "),s=i,c=n.Appearance.internal.getHeight(t)||0;c=c<0?-c:c;var l=n.Appearance.internal.getWidth(t)||0;l=l<0?-l:l;s++;t:for(;;){var e="";s--;var u=n.internal.calculateFontSpace("3",s+"px",r).height,h=t.multiline?c-s:(c-u)/2,f=-2,d=h+=2,p=0,m=0,g=0;if(0==s){s=12,e="(...) Tj\n",e+="% Width of Text: "+n.internal.calculateFontSpace(e,"1px").width+", FieldWidth:"+l+"\n";break}g=n.internal.calculateFontSpace(a[0]+" ",s+"px",r).width;var w="",y=0;for(var v in a){w=" "==(w+=a[v]+" ").substr(w.length-1)?w.substr(0,w.length-1):w;var b=parseInt(v);g=n.internal.calculateFontSpace(w+" ",s+"px",r).width;var x=function(t,e,i){if(t+1<a.length){var o=e+" "+a[t+1];return n.internal.calculateFontSpace(o,i+"px",r).width<=l-4}return!1}(b,w,s),k=v>=a.length-1;if(!x||k){if(x||k){if(k)m=b;else if(t.multiline&&(u+2)*(y+2)+2>c)continue t}else{if(!t.multiline)continue t;if((u+2)*(y+2)+2>c)continue t;m=b}for(var _="",C=p;C<=m;C++)_+=a[C]+" ";switch(_=" "==_.substr(_.length-1)?_.substr(0,_.length-1):_,g=n.internal.calculateFontSpace(_,s+"px",r).width,t.Q){case 2:f=l-g-2;break;case 1:f=(l-g)/2;break;case 0:default:f=2}e+=f+" "+d+" Td\n",e+="("+_+") Tj\n",e+=-f+" 0 Td\n",d=-(s+2),g=0,p=m+1,y++,w=""}else w+=" "}break}return o.text=e,o.fontSize=s,o},n.internal.calculateAppearanceStream=function(t){if(t.appearanceStreamContent)return t.appearanceStreamContent;if(t.V||t.DV){var e="",r=t.V||t.DV,i=n.internal.calculateX(t,r);e+="/Tx BMC\nq\n/F1 "+i.fontSize+" Tf\n1 0 0 1 0 0 Tm\n",e+="BT\n",e+=i.text,e+="ET\n",e+="Q\nEMC\n";var o=new n.createFormXObject(t);return o.stream=e,o}},n.internal.calculateCoordinates=function(t,e,r,i){var o={};if(this.internal){var a=function(t){return t*this.internal.scaleFactor};Array.isArray(t)?(t[0]=n.scale(t[0]),t[1]=n.scale(t[1]),t[2]=n.scale(t[2]),t[3]=n.scale(t[3]),o.lowerLeft_X=t[0]||0,o.lowerLeft_Y=a.call(this,this.internal.pageSize.height)-t[3]-t[1]||0,o.upperRight_X=t[0]+t[2]||0,o.upperRight_Y=a.call(this,this.internal.pageSize.height)-t[1]||0):(t=n.scale(t),e=n.scale(e),r=n.scale(r),i=n.scale(i),o.lowerLeft_X=t||0,o.lowerLeft_Y=this.internal.pageSize.height-e||0,o.upperRight_X=t+r||0,o.upperRight_Y=this.internal.pageSize.height-e+i||0)}else Array.isArray(t)?(o.lowerLeft_X=t[0]||0,o.lowerLeft_Y=t[1]||0,o.upperRight_X=t[0]+t[2]||0,o.upperRight_Y=t[1]+t[3]||0):(o.lowerLeft_X=t||0,o.lowerLeft_Y=e||0,o.upperRight_X=t+r||0,o.upperRight_Y=e+i||0);return[o.lowerLeft_X,o.lowerLeft_Y,o.upperRight_X,o.upperRight_Y]},n.internal.calculateColor=function(t,e,n){var r=new Array(3);return r.r=0|t,r.g=0|e,r.b=0|n,r},n.internal.getBitPosition=function(t,e){var n=1;return n<<=e-1,(t=t||0)|n},n.internal.setBitPosition=function(t,e,n){t=t||0;var r=1;if(r<<=e-1,1==(n=n||1))t=t|r;else var t=t&~r;return t},e.API.addHTML=function(t,e,n,r,i){if("undefined"==typeof html2canvas&&"undefined"==typeof rasterizeHTML)throw new Error("You need either https://github.com/niklasvh/html2canvas or https://github.com/cburgmer/rasterizeHTML.js");"number"!=typeof e&&(r=e,i=n),"function"==typeof r&&(i=r,r=null);var o=this.internal,a=o.scaleFactor,s=o.pageSize.width,c=o.pageSize.height;if(r=r||{},r.onrendered=function(t){e=parseInt(e)||0,n=parseInt(n)||0;var o=r.dim||{},l=o.h||0,u=o.w||Math.min(s,t.width/a)-e,h="JPEG";if(r.format&&(h=r.format),t.height>c&&r.pagesplit){var f=function(){for(var r=0;;){var o=document.createElement("canvas");o.width=Math.min(s*a,t.width),o.height=Math.min(c*a,t.height-r),o.getContext("2d").drawImage(t,0,r,t.width,o.height,0,0,o.width,o.height);var l=[o,e,r?0:n,o.width/a,o.height/a,h,null,"SLOW"];if(this.addImage.apply(this,l),(r+=o.height)>=t.height)break;this.addPage()}i(u,r,null,l)}.bind(this);if("CANVAS"===t.nodeName){var d=new Image;d.onload=f,d.src=t.toDataURL("image/png"),t=d}else f()}else{var p=Math.random().toString(35),m=[t,e,n,u,l,h,p,"SLOW"];this.addImage.apply(this,m),i(u,l,p,m)}}.bind(this),"undefined"!=typeof html2canvas&&!r.rstz)return html2canvas(t,r);if("undefined"!=typeof rasterizeHTML){var l="drawDocument";return"string"==typeof t&&(l=/^http/.test(t)?"drawURL":"drawHTML"),r.width=r.width||s*a,rasterizeHTML[l](t,void 0,r).then(function(t){r.onrendered(t.image)},function(t){i(null,t)})}return null},/** @preserve
	 * jsPDF addImage plugin
	 * Copyright (c) 2012 Jason Siefken, https://github.com/siefkenj/
	 *               2013 Chris Dowling, https://github.com/gingerchris
	 *               2013 Trinh Ho, https://github.com/ineedfat
	 *               2013 Edwin Alejandro Perez, https://github.com/eaparango
	 *               2013 Norah Smith, https://github.com/burnburnrocket
	 *               2014 Diego Casorran, https://github.com/diegocr
	 *               2014 James Robb, https://github.com/jamesbrobb
	 *
	 * 
	 */
	function(e){var n=["jpeg","jpg","png"],r=function t(e){var n=this.internal.newObject(),r=this.internal.write,i=this.internal.putStream;if(e.n=n,r("<</Type /XObject"),r("/Subtype /Image"),r("/Width "+e.w),r("/Height "+e.h),e.cs===this.color_spaces.INDEXED?r("/ColorSpace [/Indexed /DeviceRGB "+(e.pal.length/3-1)+" "+("smask"in e?n+2:n+1)+" 0 R]"):(r("/ColorSpace /"+e.cs),e.cs===this.color_spaces.DEVICE_CMYK&&r("/Decode [1 0 1 0 1 0 1 0]")),r("/BitsPerComponent "+e.bpc),"f"in e&&r("/Filter /"+e.f),"dp"in e&&r("/DecodeParms <<"+e.dp+">>"),"trns"in e&&e.trns.constructor==Array){for(var o="",a=0,s=e.trns.length;a<s;a++)o+=e.trns[a]+" "+e.trns[a]+" ";r("/Mask ["+o+"]")}if("smask"in e&&r("/SMask "+(n+1)+" 0 R"),r("/Length "+e.data.length+">>"),i(e.data),r("endobj"),"smask"in e){var c="/Predictor "+e.p+" /Colors 1 /BitsPerComponent "+e.bpc+" /Columns "+e.w,l={w:e.w,h:e.h,cs:"DeviceGray",bpc:e.bpc,dp:c,data:e.smask};"f"in e&&(l.f=e.f),t.call(this,l)}e.cs===this.color_spaces.INDEXED&&(this.internal.newObject(),r("<< /Length "+e.pal.length+">>"),i(this.arrayBufferToBinaryString(new Uint8Array(e.pal))),r("endobj"))},i=function(){var t=this.internal.collections.addImage_images;for(var e in t)r.call(this,t[e])},o=function(){var t,e=this.internal.collections.addImage_images,n=this.internal.write;for(var r in e)n("/I"+(t=e[r]).i,t.n,"0","R")},a=function(t){return t&&"string"==typeof t&&(t=t.toUpperCase()),t in e.image_compression?t:e.image_compression.NONE},s=function(){var t=this.internal.collections.addImage_images;return t||(this.internal.collections.addImage_images=t={},this.internal.events.subscribe("putResources",i),this.internal.events.subscribe("putXobjectDict",o)),t},c=function(t){var e=0;return t&&(e=Object.keys?Object.keys(t).length:function(t){var e=0;for(var n in t)t.hasOwnProperty(n)&&e++;return e}(t)),e},l=function(t){return void 0===t||null===t},u=function(t){return"string"==typeof t&&e.sHashCode(t)},h=function(t){return-1===n.indexOf(t)},f=function(t){return"function"!=typeof e["process"+t.toUpperCase()]},d=function(e){return"object"===(void 0===e?"undefined":t(e))&&1===e.nodeType},p=function(e,n,r){if("IMG"===e.nodeName&&e.hasAttribute("src")){var i=""+e.getAttribute("src");if(!r&&0===i.indexOf("data:image/"))return i;!n&&/\.png(?:[?#].*)?$/i.test(i)&&(n="png")}if("CANVAS"===e.nodeName)var o=e;else{(o=document.createElement("canvas")).width=e.clientWidth||e.width,o.height=e.clientHeight||e.height;var a=o.getContext("2d");if(!a)throw"addImage requires canvas to be supported by browser.";if(r){var s,c,l,u,h,f,d,p,m=Math.PI/180;"object"===(void 0===r?"undefined":t(r))&&(s=r.x,c=r.y,l=r.bg,r=r.angle),p=r*m,u=Math.abs(Math.cos(p)),h=Math.abs(Math.sin(p)),f=o.width,d=o.height,o.width=d*h+f*u,o.height=d*u+f*h,isNaN(s)&&(s=o.width/2),isNaN(c)&&(c=o.height/2),a.clearRect(0,0,o.width,o.height),a.fillStyle=l||"white",a.fillRect(0,0,o.width,o.height),a.save(),a.translate(s,c),a.rotate(p),a.drawImage(e,-f/2,-d/2),a.rotate(-p),a.translate(-s,-c),a.restore()}else a.drawImage(e,0,0,o.width,o.height)}return o.toDataURL("png"==(""+n).toLowerCase()?"image/png":"image/jpeg")},m=function(t,e){var n;if(e)for(var r in e)if(t===e[r].alias){n=e[r];break}return n},g=function(t,e,n){return t||e||(t=-96,e=-96),t<0&&(t=-1*n.w*72/t/this.internal.scaleFactor),e<0&&(e=-1*n.h*72/e/this.internal.scaleFactor),0===t&&(t=e*n.w/n.h),0===e&&(e=t*n.h/n.w),[t,e]},w=function(t,e,n,r,i,o,a){var s=g.call(this,n,r,i),c=this.internal.getCoordinateString,l=this.internal.getVerticalCoordinateString;n=s[0],r=s[1],a[o]=i,this.internal.write("q",c(n),"0 0",c(r),c(t),l(e+r),"cm /I"+i.i,"Do Q")};e.color_spaces={DEVICE_RGB:"DeviceRGB",DEVICE_GRAY:"DeviceGray",DEVICE_CMYK:"DeviceCMYK",CAL_GREY:"CalGray",CAL_RGB:"CalRGB",LAB:"Lab",ICC_BASED:"ICCBased",INDEXED:"Indexed",PATTERN:"Pattern",SEPARATION:"Separation",DEVICE_N:"DeviceN"},e.decode={DCT_DECODE:"DCTDecode",FLATE_DECODE:"FlateDecode",LZW_DECODE:"LZWDecode",JPX_DECODE:"JPXDecode",JBIG2_DECODE:"JBIG2Decode",ASCII85_DECODE:"ASCII85Decode",ASCII_HEX_DECODE:"ASCIIHexDecode",RUN_LENGTH_DECODE:"RunLengthDecode",CCITT_FAX_DECODE:"CCITTFaxDecode"},e.image_compression={NONE:"NONE",FAST:"FAST",MEDIUM:"MEDIUM",SLOW:"SLOW"},e.sHashCode=function(t){return Array.prototype.reduce&&t.split("").reduce(function(t,e){return(t=(t<<5)-t+e.charCodeAt(0))&t},0)},e.isString=function(t){return"string"==typeof t},e.extractInfoFromBase64DataURI=function(t){return/^data:([\w]+?\/([\w]+?));base64,(.+?)$/g.exec(t)},e.supportsArrayBuffer=function(){return"undefined"!=typeof ArrayBuffer&&"undefined"!=typeof Uint8Array},e.isArrayBuffer=function(t){return!!this.supportsArrayBuffer()&&t instanceof ArrayBuffer},e.isArrayBufferView=function(t){return!!this.supportsArrayBuffer()&&("undefined"!=typeof Uint32Array&&(t instanceof Int8Array||t instanceof Uint8Array||"undefined"!=typeof Uint8ClampedArray&&t instanceof Uint8ClampedArray||t instanceof Int16Array||t instanceof Uint16Array||t instanceof Int32Array||t instanceof Uint32Array||t instanceof Float32Array||t instanceof Float64Array))},e.binaryStringToUint8Array=function(t){for(var e=t.length,n=new Uint8Array(e),r=0;r<e;r++)n[r]=t.charCodeAt(r);return n},e.arrayBufferToBinaryString=function(t){if("function"==typeof window.atob)return atob(this.arrayBufferToBase64(t));for(var e=this.isArrayBuffer(t)?t:new Uint8Array(t),n="",r=Math.round(e.byteLength/20480),i=0;i<r;i++)n+=String.fromCharCode.apply(null,e.slice(20480*i,20480*i+20480));return n},e.arrayBufferToBase64=function(t){for(var e,n,r,i,o="",a="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",s=new Uint8Array(t),c=s.byteLength,l=c%3,u=c-l,h=0;h<u;h+=3)e=(258048&(i=s[h]<<16|s[h+1]<<8|s[h+2]))>>12,n=(4032&i)>>6,r=63&i,o+=a[(16515072&i)>>18]+a[e]+a[n]+a[r];return 1==l?(e=(3&(i=s[u]))<<4,o+=a[(252&i)>>2]+a[e]+"=="):2==l&&(e=(1008&(i=s[u]<<8|s[u+1]))>>4,n=(15&i)<<2,o+=a[(64512&i)>>10]+a[e]+a[n]+"="),o},e.createImageInfo=function(t,e,n,r,i,o,a,s,c,l,u,h,f){var d={alias:s,w:e,h:n,cs:r,bpc:i,i:a,data:t};return o&&(d.f=o),c&&(d.dp=c),l&&(d.trns=l),u&&(d.pal=u),h&&(d.smask=h),f&&(d.p=f),d},e.addImage=function(e,r,i,o,g,y,v,b,x){if("string"!=typeof r){var k=y;y=g,g=o,o=i,i=r,r=k}if("object"===(void 0===e?"undefined":t(e))&&!d(e)&&"imageData"in e){var _=e;e=_.imageData,r=_.format||r,i=_.x||i||0,o=_.y||o||0,g=_.w||g,y=_.h||y,v=_.alias||v,b=_.compression||b,x=_.rotation||_.angle||x}if(isNaN(i)||isNaN(o))throw console.error("jsPDF.addImage: Invalid coordinates",arguments),new Error("Invalid coordinates passed to jsPDF.addImage");var C,A=s.call(this);if(!(C=m(e,A))){var S;if(d(e)&&(e=p(e,r,x)),l(v)&&(v=u(e)),!(C=m(v,A))){if(this.isString(e)){var q=this.extractInfoFromBase64DataURI(e);q?(r=q[2],e=atob(q[3])):137===e.charCodeAt(0)&&80===e.charCodeAt(1)&&78===e.charCodeAt(2)&&71===e.charCodeAt(3)&&(r="png")}if(r=(r||"JPEG").toLowerCase(),h(r))throw new Error("addImage currently only supports formats "+n+", not '"+r+"'");if(f(r))throw new Error("please ensure that the plugin for '"+r+"' support is added");if(this.supportsArrayBuffer()&&(e instanceof Uint8Array||(S=e,e=this.binaryStringToUint8Array(e))),!(C=this["process"+r.toUpperCase()](e,c(A),v,a(b),S)))throw new Error("An unkwown error occurred whilst processing the image")}}return w.call(this,i,o,g,y,C,C.i,A),this};var y=function(t){var e,n,r;if(255===!t.charCodeAt(0)||216===!t.charCodeAt(1)||255===!t.charCodeAt(2)||224===!t.charCodeAt(3)||!t.charCodeAt(6)==="J".charCodeAt(0)||!t.charCodeAt(7)==="F".charCodeAt(0)||!t.charCodeAt(8)==="I".charCodeAt(0)||!t.charCodeAt(9)==="F".charCodeAt(0)||0===!t.charCodeAt(10))throw new Error("getJpegSize requires a binary string jpeg file");for(var i=256*t.charCodeAt(4)+t.charCodeAt(5),o=4,a=t.length;o<a;){if(o+=i,255!==t.charCodeAt(o))throw new Error("getJpegSize could not find the size of the image");if(192===t.charCodeAt(o+1)||193===t.charCodeAt(o+1)||194===t.charCodeAt(o+1)||195===t.charCodeAt(o+1)||196===t.charCodeAt(o+1)||197===t.charCodeAt(o+1)||198===t.charCodeAt(o+1)||199===t.charCodeAt(o+1))return n=256*t.charCodeAt(o+5)+t.charCodeAt(o+6),e=256*t.charCodeAt(o+7)+t.charCodeAt(o+8),r=t.charCodeAt(o+9),[e,n,r];o+=2,i=256*t.charCodeAt(o)+t.charCodeAt(o+1)}},v=function(t){if(65496!==(t[0]<<8|t[1]))throw new Error("Supplied data is not a JPEG");for(var e,n,r,i,o=t.length,a=(t[4]<<8)+t[5],s=4;s<o;){if(s+=a,e=b(t,s),a=(e[2]<<8)+e[3],(192===e[1]||194===e[1])&&255===e[0]&&a>7)return e=b(t,s+5),n=(e[2]<<8)+e[3],r=(e[0]<<8)+e[1],i=e[4],{width:n,height:r,numcomponents:i};s+=2}throw new Error("getJpegSizeFromBytes could not find the size of the image")},b=function(t,e){return t.subarray(e,e+5)};e.processJPEG=function(t,e,n,r,i){var o,a=this.color_spaces.DEVICE_RGB,s=this.decode.DCT_DECODE;return this.isString(t)?(o=y(t),this.createImageInfo(t,o[0],o[1],1==o[3]?this.color_spaces.DEVICE_GRAY:a,8,s,e,n)):(this.isArrayBuffer(t)&&(t=new Uint8Array(t)),this.isArrayBufferView(t)?(o=v(t),t=i||this.arrayBufferToBinaryString(t),this.createImageInfo(t,o.width,o.height,1==o.numcomponents?this.color_spaces.DEVICE_GRAY:a,8,s,e,n)):null)},e.processJPG=function(){return this.processJPEG.apply(this,arguments)}}(e.API),/**
	 * jsPDF Annotations PlugIn
	 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
	 *
	 * Licensed under the MIT License.
	 * http://opensource.org/licenses/mit-license
	 */
	function(t){var n={annotations:[],f2:function(t){return t.toFixed(2)},notEmpty:function(t){if(void 0!==t&&""!=t)return!0}};e.API.annotationPlugin=n,e.API.events.push(["addPage",function(t){this.annotationPlugin.annotations[t.pageNumber]=[]}]),t.events.push(["putPage",function(t){for(var e=this.annotationPlugin.annotations[t.pageNumber],r=!1,i=0;i<e.length&&!r;i++)switch((l=e[i]).type){case"link":if(n.notEmpty(l.options.url)||n.notEmpty(l.options.pageNumber)){r=!0;break}case"reference":case"text":case"freetext":r=!0}if(0!=r){this.internal.write("/Annots [");for(var o=this.annotationPlugin.f2,a=this.internal.scaleFactor,s=this.internal.pageSize.height,c=this.internal.getPageInfo(t.pageNumber),i=0;i<e.length;i++){var l=e[i];switch(l.type){case"reference":this.internal.write(" "+l.object.objId+" 0 R ");break;case"text":var u=this.internal.newAdditionalObject(),h=this.internal.newAdditionalObject(),f=l.title||"Note";w="<</Type /Annot /Subtype /Text "+(p="/Rect ["+o(l.bounds.x*a)+" "+o(s-(l.bounds.y+l.bounds.h)*a)+" "+o((l.bounds.x+l.bounds.w)*a)+" "+o((s-l.bounds.y)*a)+"] ")+"/Contents ("+l.contents+")",w+=" /Popup "+h.objId+" 0 R",w+=" /P "+c.objId+" 0 R",w+=" /T ("+f+") >>",u.content=w;var d=u.objId+" 0 R";w="<</Type /Annot /Subtype /Popup "+(p="/Rect ["+o((l.bounds.x+30)*a)+" "+o(s-(l.bounds.y+l.bounds.h)*a)+" "+o((l.bounds.x+l.bounds.w+30)*a)+" "+o((s-l.bounds.y)*a)+"] ")+" /Parent "+d,l.open&&(w+=" /Open true"),w+=" >>",h.content=w,this.internal.write(u.objId,"0 R",h.objId,"0 R");break;case"freetext":var p="/Rect ["+o(l.bounds.x*a)+" "+o((s-l.bounds.y)*a)+" "+o(l.bounds.x+l.bounds.w*a)+" "+o(s-(l.bounds.y+l.bounds.h)*a)+"] ",m=l.color||"#000000";w="<</Type /Annot /Subtype /FreeText "+p+"/Contents ("+l.contents+")",w+=" /DS(font: Helvetica,sans-serif 12.0pt; text-align:left; color:#"+m+")",w+=" /Border [0 0 0]",w+=" >>",this.internal.write(w);break;case"link":if(l.options.name){var g=this.annotations._nameMap[l.options.name];l.options.pageNumber=g.page,l.options.top=g.y}else l.options.top||(l.options.top=0);var p="/Rect ["+o(l.x*a)+" "+o((s-l.y)*a)+" "+o((l.x+l.w)*a)+" "+o((s-(l.y+l.h))*a)+"] ",w="";if(l.options.url)w="<</Type /Annot /Subtype /Link "+p+"/Border [0 0 0] /A <</S /URI /URI ("+l.options.url+") >>";else if(l.options.pageNumber)switch(w="<</Type /Annot /Subtype /Link "+p+"/Border [0 0 0] /Dest ["+(t=this.internal.getPageInfo(l.options.pageNumber)).objId+" 0 R",l.options.magFactor=l.options.magFactor||"XYZ",l.options.magFactor){case"Fit":w+=" /Fit]";break;case"FitH":w+=" /FitH "+l.options.top+"]";break;case"FitV":l.options.left=l.options.left||0,w+=" /FitV "+l.options.left+"]";break;case"XYZ":default:var y=o((s-l.options.top)*a);l.options.left=l.options.left||0,void 0===l.options.zoom&&(l.options.zoom=0),w+=" /XYZ "+l.options.left+" "+y+" "+l.options.zoom+"]"}""!=w&&(w+=" >>",this.internal.write(w))}}this.internal.write("]")}}]),t.createAnnotation=function(t){switch(t.type){case"link":this.link(t.bounds.x,t.bounds.y,t.bounds.w,t.bounds.h,t);break;case"text":case"freetext":this.annotationPlugin.annotations[this.internal.getCurrentPageInfo().pageNumber].push(t)}},t.link=function(t,e,n,r,i){this.annotationPlugin.annotations[this.internal.getCurrentPageInfo().pageNumber].push({x:t,y:e,w:n,h:r,options:i,type:"link"})},t.textWithLink=function(t,e,n,r){var i=this.getTextWidth(t),o=this.internal.getLineHeight()/this.internal.scaleFactor;return this.text(t,e,n),n+=.2*o,this.link(e,n-o,i,o,r),i},t.getTextWidth=function(t){var e=this.internal.getFontSize();return this.getStringUnitWidth(t)*e/this.internal.scaleFactor},t.getLineHeight=function(){return this.internal.getLineHeight()}}(e.API),e.API.autoPrint=function(){var t;return this.internal.events.subscribe("postPutResources",function(){t=this.internal.newObject(),this.internal.write("<< /S/Named /Type/Action /N/Print >>","endobj")}),this.internal.events.subscribe("putCatalog",function(){this.internal.write("/OpenAction "+t+" 0 R")}),this},/**
	 * jsPDF Canvas PlugIn
	 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
	 *
	 * Licensed under the MIT License.
	 * http://opensource.org/licenses/mit-license
	 */
	function(t){t.events.push(["initialized",function(){this.canvas.pdf=this}]),t.canvas={getContext:function(t){return this.pdf.context2d._canvas=this,this.pdf.context2d},style:{}},Object.defineProperty(t.canvas,"width",{get:function(){return this._width},set:function(t){this._width=t,this.getContext("2d").pageWrapX=t+1}}),Object.defineProperty(t.canvas,"height",{get:function(){return this._height},set:function(t){this._height=t,this.getContext("2d").pageWrapY=t+1}})}(e.API),/** ====================================================================
	 * jsPDF Cell plugin
	 * Copyright (c) 2013 Youssef Beddad, youssef.beddad@gmail.com
	 *               2013 Eduardo Menezes de Morais, eduardo.morais@usp.br
	 *               2013 Lee Driscoll, https://github.com/lsdriscoll
	 *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
	 *               2014 James Hall, james@parall.ax
	 *               2014 Diego Casorran, https://github.com/diegocr
	 *
	 * 
	 * ====================================================================
	 */
	function(t){var e,n,r,i,o={x:void 0,y:void 0,w:void 0,h:void 0,ln:void 0},a=1,s=function(t,e,n,r,i){o={x:t,y:e,w:n,h:r,ln:i}},c=function(){return o},l={left:0,top:0,bottom:0};t.setHeaderFunction=function(t){i=t},t.getTextDimensions=function(t){e=this.internal.getFont().fontName,n=this.table_font_size||this.internal.getFontSize(),r=this.internal.getFont().fontStyle;var i,o;(o=document.createElement("font")).id="jsPDFCell";try{o.style.fontStyle=r}catch(t){o.style.fontWeight=r}o.style.fontName=e,o.style.fontSize=n+"pt";try{o.textContent=t}catch(e){o.innerText=t}return document.body.appendChild(o),i={w:(o.offsetWidth+1)*(19.049976/25.4),h:(o.offsetHeight+1)*(19.049976/25.4)},document.body.removeChild(o),i},t.cellAddPage=function(){var t=this.margins||l;this.addPage(),s(t.left,t.top,void 0,void 0),a+=1},t.cellInitialize=function(){o={x:void 0,y:void 0,w:void 0,h:void 0,ln:void 0},a=1},t.cell=function(t,e,n,r,i,o,a){var u=c(),h=!1;if(void 0!==u.ln)if(u.ln===o)t=u.x+u.w,e=u.y;else{var f=this.margins||l;u.y+u.h+r+13>=this.internal.pageSize.height-f.bottom&&(this.cellAddPage(),h=!0,this.printHeaders&&this.tableHeaderRow&&this.printHeaderRow(o,!0)),e=c().y+c().h,h&&(e=23)}if(void 0!==i[0])if(this.printingHeaderRow?this.rect(t,e,n,r,"FD"):this.rect(t,e,n,r),"right"===a){i instanceof Array||(i=[i]);for(var d=0;d<i.length;d++){var p=i[d],m=this.getStringUnitWidth(p)*this.internal.getFontSize();this.text(p,t+n-m-3,e+this.internal.getLineHeight()*(d+1))}}else this.text(i,t+3,e+this.internal.getLineHeight());return s(t,e,n,r,o),this},t.arrayMax=function(t,e){var n,r,i,o=t[0];for(n=0,r=t.length;n<r;n+=1)i=t[n],e?-1===e(o,i)&&(o=i):i>o&&(o=i);return o},t.table=function(e,n,r,i,s){if(!r)throw"No data for PDF table";var c,u,h,f,d,p,m,g,w,y,v=[],b=[],x={},k={},_=[],C=[],A=!1,S=!0,q=12,T=l;if(T.width=this.internal.pageSize.width,s&&(!0===s.autoSize&&(A=!0),!1===s.printHeaders&&(S=!1),s.fontSize&&(q=s.fontSize),s.css&&void 0!==s.css["font-size"]&&(q=16*s.css["font-size"]),s.margins&&(T=s.margins)),this.lnMod=0,o={x:void 0,y:void 0,w:void 0,h:void 0,ln:void 0},a=1,this.printHeaders=S,this.margins=T,this.setFontSize(q),this.table_font_size=q,void 0===i||null===i)v=Object.keys(r[0]);else if(i[0]&&"string"!=typeof i[0]){for(u=0,h=i.length;u<h;u+=1)c=i[u],v.push(c.name),b.push(c.prompt),k[c.name]=c.width*(19.049976/25.4)}else v=i;if(A)for(y=function(t){return t[c]},u=0,h=v.length;u<h;u+=1){for(x[c=v[u]]=r.map(y),_.push(this.getTextDimensions(b[u]||c).w),m=0,f=(p=x[c]).length;m<f;m+=1)d=p[m],_.push(this.getTextDimensions(d).w);k[c]=t.arrayMax(_),_=[]}if(S){P=this.calculateLineHeight(v,k,b.length?b:v);for(u=0,h=v.length;u<h;u+=1)c=v[u],C.push([e,n,k[c],P,String(b.length?b[u]:c)]);this.setTableHeaderRow(C),this.printHeaderRow(1,!1)}for(u=0,h=r.length;u<h;u+=1){var P;for(g=r[u],P=this.calculateLineHeight(v,k,g),m=0,w=v.length;m<w;m+=1)c=v[m],this.cell(e,n,k[c],P,g[c],u+2,c.align)}return this.lastCellPos=o,this.table_x=e,this.table_y=n,this},t.calculateLineHeight=function(t,e,n){for(var r,i=0,o=0;o<t.length;o++){n[r=t[o]]=this.splitTextToSize(String(n[r]),e[r]-3);var a=this.internal.getLineHeight()*n[r].length+3;a>i&&(i=a)}return i},t.setTableHeaderRow=function(t){this.tableHeaderRow=t},t.printHeaderRow=function(t,e){if(!this.tableHeaderRow)throw"Property tableHeaderRow does not exist.";var n,r,o,c;if(this.printingHeaderRow=!0,void 0!==i){var l=i(this,a);s(l[0],l[1],l[2],l[3],-1)}this.setFontStyle("bold");var u=[];for(o=0,c=this.tableHeaderRow.length;o<c;o+=1)this.setFillColor(200,200,200),n=this.tableHeaderRow[o],e&&(this.margins.top=13,n[1]=this.margins&&this.margins.top||0,u.push(n)),r=[].concat(n),this.cell.apply(this,r.concat(t));u.length>0&&this.setTableHeaderRow(u),this.setFontStyle("normal"),this.printingHeaderRow=!1}}(e.API),/**
	 * jsPDF Context2D PlugIn Copyright (c) 2014 Steven Spungin (TwelveTone LLC) steven@twelvetone.tv
	 *
	 * Licensed under the MIT License. http://opensource.org/licenses/mit-license
	 */
	function(t){function e(){this._isStrokeTransparent=!1,this._strokeOpacity=1,this.strokeStyle="#000000",this.fillStyle="#000000",this._isFillTransparent=!1,this._fillOpacity=1,this.font="12pt times",this.textBaseline="alphabetic",this.textAlign="start",this.lineWidth=1,this.lineJoin="miter",this.lineCap="butt",this._transform=[1,0,0,1,0,0],this.globalCompositeOperation="normal",this.globalAlpha=1,this._clip_path=[],this.ignoreClearRect=!1,this.copy=function(t){this._isStrokeTransparent=t._isStrokeTransparent,this._strokeOpacity=t._strokeOpacity,this.strokeStyle=t.strokeStyle,this._isFillTransparent=t._isFillTransparent,this._fillOpacity=t._fillOpacity,this.fillStyle=t.fillStyle,this.font=t.font,this.lineWidth=t.lineWidth,this.lineJoin=t.lineJoin,this.lineCap=t.lineCap,this.textBaseline=t.textBaseline,this.textAlign=t.textAlign,this._fontSize=t._fontSize,this._transform=t._transform.slice(0),this.globalCompositeOperation=t.globalCompositeOperation,this.globalAlpha=t.globalAlpha,this._clip_path=t._clip_path.slice(0),this.ignoreClearRect=t.ignoreClearRect}}t.events.push(["initialized",function(){this.context2d.pdf=this,this.context2d.internal.pdf=this,this.context2d.ctx=new e,this.context2d.ctxStack=[],this.context2d.path=[]}]),t.context2d={pageWrapXEnabled:!1,pageWrapYEnabled:!1,pageWrapX:9999999,pageWrapY:9999999,ctx:new e,f2:function(t){return t.toFixed(2)},fillRect:function(t,e,n,r){if(!this._isFillTransparent()){t=this._wrapX(t),e=this._wrapY(e);var i=this._matrix_map_rect(this.ctx._transform,{x:t,y:e,w:n,h:r});this.pdf.rect(i.x,i.y,i.w,i.h,"f")}},strokeRect:function(t,e,n,r){if(!this._isStrokeTransparent()){t=this._wrapX(t),e=this._wrapY(e);var i=this._matrix_map_rect(this.ctx._transform,{x:t,y:e,w:n,h:r});this.pdf.rect(i.x,i.y,i.w,i.h,"s")}},clearRect:function(t,e,n,r){if(!this.ctx.ignoreClearRect){t=this._wrapX(t),e=this._wrapY(e);var i=this._matrix_map_rect(this.ctx._transform,{x:t,y:e,w:n,h:r});this.save(),this.setFillStyle("#ffffff"),this.pdf.rect(i.x,i.y,i.w,i.h,"f"),this.restore()}},save:function(){this.ctx._fontSize=this.pdf.internal.getFontSize();var t=new e;t.copy(this.ctx),this.ctxStack.push(this.ctx),this.ctx=t},restore:function(){this.ctx=this.ctxStack.pop(),this.setFillStyle(this.ctx.fillStyle),this.setStrokeStyle(this.ctx.strokeStyle),this.setFont(this.ctx.font),this.pdf.setFontSize(this.ctx._fontSize),this.setLineCap(this.ctx.lineCap),this.setLineWidth(this.ctx.lineWidth),this.setLineJoin(this.ctx.lineJoin)},rect:function(t,e,n,r){this.moveTo(t,e),this.lineTo(t+n,e),this.lineTo(t+n,e+r),this.lineTo(t,e+r),this.lineTo(t,e),this.closePath()},beginPath:function(){this.path=[]},closePath:function(){this.path.push({type:"close"})},_getRGBA:function(t){var e,n,r,o;if(!t)return{r:0,g:0,b:0,a:0,style:t};if(this.internal.rxTransparent.test(t))e=0,n=0,r=0,o=0;else{var a=this.internal.rxRgb.exec(t);null!=a?(e=parseInt(a[1]),n=parseInt(a[2]),r=parseInt(a[3]),o=1):null!=(a=this.internal.rxRgba.exec(t))?(e=parseInt(a[1]),n=parseInt(a[2]),r=parseInt(a[3]),o=parseFloat(a[4])):(o=1,"#"!=t.charAt(0)&&((t=i.colorNameToHex(t))||(t="#000000")),4===t.length?(e=t.substring(1,2),e+=e,n=t.substring(2,3),n+=n,r=t.substring(3,4),r+=r):(e=t.substring(1,3),n=t.substring(3,5),r=t.substring(5,7)),e=parseInt(e,16),n=parseInt(n,16),r=parseInt(r,16))}return{r:e,g:n,b:r,a:o,style:t}},setFillStyle:function(t){var e=this._getRGBA(t);this.ctx.fillStyle=t,this.ctx._isFillTransparent=0===e.a,this.ctx._fillOpacity=e.a,this.pdf.setFillColor(e.r,e.g,e.b,{a:e.a}),this.pdf.setTextColor(e.r,e.g,e.b,{a:e.a})},setStrokeStyle:function(t){var e=this._getRGBA(t);this.ctx.strokeStyle=e.style,this.ctx._isStrokeTransparent=0===e.a,this.ctx._strokeOpacity=e.a,0===e.a?this.pdf.setDrawColor(255,255,255):(e.a,this.pdf.setDrawColor(e.r,e.g,e.b))},fillText:function(t,e,n,r){if(!this._isFillTransparent()){e=this._wrapX(e),n=this._wrapY(n);var i=this._matrix_map_point(this.ctx._transform,[e,n]);e=i[0],n=i[1];var o=57.2958*this._matrix_rotation(this.ctx._transform);if(this.ctx._clip_path.length>0){var a;(a=window.outIntercept?"group"===window.outIntercept.type?window.outIntercept.stream:window.outIntercept:this.internal.getCurrentPage()).push("q");var s=this.path;this.path=this.ctx._clip_path,this.ctx._clip_path=[],this._fill(null,!0),this.ctx._clip_path=this.path,this.path=s}var c=1;try{c=this._matrix_decompose(this._getTransform()).scale[0]}catch(t){console.warn(t)}if(c<.01)this.pdf.text(t,e,this._getBaseline(n),null,o);else{var l=this.pdf.internal.getFontSize();this.pdf.setFontSize(l*c),this.pdf.text(t,e,this._getBaseline(n),null,o),this.pdf.setFontSize(l)}this.ctx._clip_path.length>0&&a.push("Q")}},strokeText:function(t,e,n,r){if(!this._isStrokeTransparent()){e=this._wrapX(e),n=this._wrapY(n);var i=this._matrix_map_point(this.ctx._transform,[e,n]);e=i[0],n=i[1];var o=57.2958*this._matrix_rotation(this.ctx._transform);if(this.ctx._clip_path.length>0){var a;(a=window.outIntercept?"group"===window.outIntercept.type?window.outIntercept.stream:window.outIntercept:this.internal.getCurrentPage()).push("q");var s=this.path;this.path=this.ctx._clip_path,this.ctx._clip_path=[],this._fill(null,!0),this.ctx._clip_path=this.path,this.path=s}var c=1;try{c=this._matrix_decompose(this._getTransform()).scale[0]}catch(t){console.warn(t)}if(1===c)this.pdf.text(t,e,this._getBaseline(n),{stroke:!0},o);else{var l=this.pdf.internal.getFontSize();this.pdf.setFontSize(l*c),this.pdf.text(t,e,this._getBaseline(n),{stroke:!0},o),this.pdf.setFontSize(l)}this.ctx._clip_path.length>0&&a.push("Q")}},setFont:function(t){this.ctx.font=t;var e=/\s*(\w+)\s+(\w+)\s+(\w+)\s+([\d\.]+)(px|pt|em)\s+(.*)?/;if(null!=(u=e.exec(t))){var n=u[1],r=u[3],i=u[4],o=u[5],a=u[6];i="px"===o?Math.floor(parseFloat(i)):"em"===o?Math.floor(parseFloat(i)*this.pdf.getFontSize()):Math.floor(parseFloat(i)),this.pdf.setFontSize(i),"bold"===r||"700"===r?this.pdf.setFontStyle("bold"):"italic"===n?this.pdf.setFontStyle("italic"):this.pdf.setFontStyle("normal");var s,c=(f=a).toLowerCase().split(/\s*,\s*/);s=-1!=c.indexOf("arial")?"Arial":-1!=c.indexOf("verdana")?"Verdana":-1!=c.indexOf("helvetica")?"Helvetica":-1!=c.indexOf("sans-serif")?"sans-serif":-1!=c.indexOf("fixed")?"Fixed":-1!=c.indexOf("monospace")?"Monospace":-1!=c.indexOf("terminal")?"Terminal":-1!=c.indexOf("courier")?"Courier":-1!=c.indexOf("times")?"Times":-1!=c.indexOf("cursive")?"Cursive":-1!=c.indexOf("fantasy")?"Fantasy":(c.indexOf("serif"),"Serif");var l;l="bold"===r?"bold":"normal",this.pdf.setFont(s,l)}else{var u=(e=/\s*(\d+)(pt|px|em)\s+([\w "]+)\s*([\w "]+)?/).exec(t);if(null!=u){var h=u[1],f=u[3];(l=u[4])||(l="normal"),h="em"===o?Math.floor(parseFloat(i)*this.pdf.getFontSize()):Math.floor(parseFloat(h)),this.pdf.setFontSize(h),this.pdf.setFont(f,l)}}},setTextBaseline:function(t){this.ctx.textBaseline=t},getTextBaseline:function(){return this.ctx.textBaseline},setTextAlign:function(t){this.ctx.textAlign=t},getTextAlign:function(){return this.ctx.textAlign},setLineWidth:function(t){this.ctx.lineWidth=t,this.pdf.setLineWidth(t)},setLineCap:function(t){this.ctx.lineCap=t,this.pdf.setLineCap(t)},setLineJoin:function(t){this.ctx.lineJoin=t,this.pdf.setLineJoin(t)},moveTo:function(t,e){t=this._wrapX(t),e=this._wrapY(e);var n=this._matrix_map_point(this.ctx._transform,[t,e]),r={type:"mt",x:t=n[0],y:e=n[1]};this.path.push(r)},_wrapX:function(t){return this.pageWrapXEnabled?t%this.pageWrapX:t},_wrapY:function(t){return this.pageWrapYEnabled?(this._gotoPage(this._page(t)),(t-this.lastBreak)%this.pageWrapY):t},transform:function(t,e,n,r,i,o){this.ctx._transform=[t,e,n,r,i,o]},setTransform:function(t,e,n,r,i,o){this.ctx._transform=[t,e,n,r,i,o]},_getTransform:function(){return this.ctx._transform},lastBreak:0,pageBreaks:[],_page:function(t){if(this.pageWrapYEnabled){this.lastBreak=0;for(var e=0,n=0,r=0;r<this.pageBreaks.length;r++)if(t>=this.pageBreaks[r]){e++,0===this.lastBreak&&n++;var i=this.pageBreaks[r]-this.lastBreak;this.lastBreak=this.pageBreaks[r],n+=o=Math.floor(i/this.pageWrapY)}if(0===this.lastBreak){var o=Math.floor(t/this.pageWrapY)+1;n+=o}return n+e}return this.pdf.internal.getCurrentPageInfo().pageNumber},_gotoPage:function(t){},lineTo:function(t,e){t=this._wrapX(t),e=this._wrapY(e);var n=this._matrix_map_point(this.ctx._transform,[t,e]),r={type:"lt",x:t=n[0],y:e=n[1]};this.path.push(r)},bezierCurveTo:function(t,e,n,r,i,o){t=this._wrapX(t),e=this._wrapY(e),n=this._wrapX(n),r=this._wrapY(r),i=this._wrapX(i),o=this._wrapY(o);var a;i=(a=this._matrix_map_point(this.ctx._transform,[i,o]))[0],o=a[1];var s={type:"bct",x1:t=(a=this._matrix_map_point(this.ctx._transform,[t,e]))[0],y1:e=a[1],x2:n=(a=this._matrix_map_point(this.ctx._transform,[n,r]))[0],y2:r=a[1],x:i,y:o};this.path.push(s)},quadraticCurveTo:function(t,e,n,r){t=this._wrapX(t),e=this._wrapY(e),n=this._wrapX(n),r=this._wrapY(r);var i;n=(i=this._matrix_map_point(this.ctx._transform,[n,r]))[0],r=i[1];var o={type:"qct",x1:t=(i=this._matrix_map_point(this.ctx._transform,[t,e]))[0],y1:e=i[1],x:n,y:r};this.path.push(o)},arc:function(t,e,n,r,i,o){if(t=this._wrapX(t),e=this._wrapY(e),!this._matrix_is_identity(this.ctx._transform)){var a=this._matrix_map_point(this.ctx._transform,[t,e]);t=a[0],e=a[1];var s=this._matrix_map_point(this.ctx._transform,[0,0]),c=this._matrix_map_point(this.ctx._transform,[0,n]);n=Math.sqrt(Math.pow(c[0]-s[0],2)+Math.pow(c[1]-s[1],2))}var l={type:"arc",x:t,y:e,radius:n,startAngle:r,endAngle:i,anticlockwise:o};this.path.push(l)},drawImage:function(t,e,n,r,i,o,a,s,c){void 0!==o&&(e=o,n=a,r=s,i=c),e=this._wrapX(e),n=this._wrapY(n);var l,u=this._matrix_map_rect(this.ctx._transform,{x:e,y:n,w:r,h:i}),h=(this._matrix_map_rect(this.ctx._transform,{x:o,y:a,w:s,h:c}),/data:image\/(\w+).*/i.exec(t));l=null!=h?h[1]:"png",this.pdf.addImage(t,l,u.x,u.y,u.w,u.h)},_matrix_multiply:function(t,e){var n=e[0],r=e[1],i=e[2],o=e[3],a=e[4],s=e[5],c=n*t[0]+r*t[2],l=i*t[0]+o*t[2],u=a*t[0]+s*t[2]+t[4];return r=n*t[1]+r*t[3],o=i*t[1]+o*t[3],s=a*t[1]+s*t[3]+t[5],n=c,i=l,a=u,[n,r,i,o,a,s]},_matrix_rotation:function(t){return Math.atan2(t[2],t[0])},_matrix_decompose:function(t){var e=t[0],n=t[1],r=t[2],i=t[3],o=Math.sqrt(e*e+n*n),a=(e/=o)*r+(n/=o)*i;r-=e*a,i-=n*a;var s=Math.sqrt(r*r+i*i);return r/=s,i/=s,a/=s,e*i<n*r&&(e=-e,n=-n,a=-a,o=-o),{scale:[o,0,0,s,0,0],translate:[1,0,0,1,t[4],t[5]],rotate:[e,n,-n,e,0,0],skew:[1,0,a,1,0,0]}},_matrix_map_point:function(t,e){var n=t[0],r=t[1],i=t[2],o=t[3],a=t[4],s=t[5],c=e[0],l=e[1];return[c*n+l*i+a,c*r+l*o+s]},_matrix_map_point_obj:function(t,e){var n=this._matrix_map_point(t,[e.x,e.y]);return{x:n[0],y:n[1]}},_matrix_map_rect:function(t,e){var n=this._matrix_map_point(t,[e.x,e.y]),r=this._matrix_map_point(t,[e.x+e.w,e.y+e.h]);return{x:n[0],y:n[1],w:r[0]-n[0],h:r[1]-n[1]}},_matrix_is_identity:function(t){return 1==t[0]&&(0==t[1]&&(0==t[2]&&(1==t[3]&&(0==t[4]&&0==t[5]))))},rotate:function(t){var e=[Math.cos(t),Math.sin(t),-Math.sin(t),Math.cos(t),0,0];this.ctx._transform=this._matrix_multiply(this.ctx._transform,e)},scale:function(t,e){var n=[t,0,0,e,0,0];this.ctx._transform=this._matrix_multiply(this.ctx._transform,n)},translate:function(t,e){var n=[1,0,0,1,t,e];this.ctx._transform=this._matrix_multiply(this.ctx._transform,n)},stroke:function(){if(this.ctx._clip_path.length>0){var t;(t=window.outIntercept?"group"===window.outIntercept.type?window.outIntercept.stream:window.outIntercept:this.internal.getCurrentPage()).push("q");var e=this.path;this.path=this.ctx._clip_path,this.ctx._clip_path=[],this._stroke(!0),this.ctx._clip_path=this.path,this.path=e,this._stroke(!1),t.push("Q")}else this._stroke(!1)},_stroke:function(t){if(t||!this._isStrokeTransparent()){for(var e=[],n=this.path,r=0;r<n.length;r++){var i=n[r];switch(i.type){case"mt":e.push({start:i,deltas:[],abs:[]});break;case"lt":h=[i.x-n[r-1].x,i.y-n[r-1].y];e[e.length-1].deltas.push(h),e[e.length-1].abs.push(i);break;case"bct":h=[i.x1-n[r-1].x,i.y1-n[r-1].y,i.x2-n[r-1].x,i.y2-n[r-1].y,i.x-n[r-1].x,i.y-n[r-1].y];e[e.length-1].deltas.push(h);break;case"qct":var o=n[r-1].x+2/3*(i.x1-n[r-1].x),a=n[r-1].y+2/3*(i.y1-n[r-1].y),s=i.x+2/3*(i.x1-i.x),c=i.y+2/3*(i.y1-i.y),l=i.x,u=i.y,h=[o-n[r-1].x,a-n[r-1].y,s-n[r-1].x,c-n[r-1].y,l-n[r-1].x,u-n[r-1].y];e[e.length-1].deltas.push(h);break;case"arc":0==e.length&&e.push({start:{x:0,y:0},deltas:[],abs:[]}),e[e.length-1].arc=!0,e[e.length-1].abs.push(i)}}for(r=0;r<e.length;r++){var f;if(f=r==e.length-1?"s":null,e[r].arc)for(var d=e[r].abs,p=0;p<d.length;p++){var m=d[p],g=360*m.startAngle/(2*Math.PI),w=360*m.endAngle/(2*Math.PI),y=m.x,v=m.y;this.internal.arc2(this,y,v,m.radius,g,w,m.anticlockwise,f,t)}else{var y=e[r].start.x,v=e[r].start.y;t?(this.pdf.lines(e[r].deltas,y,v,null,null),this.pdf.clip_fixed()):this.pdf.lines(e[r].deltas,y,v,null,f)}}}},_isFillTransparent:function(){return this.ctx._isFillTransparent||0==this.globalAlpha},_isStrokeTransparent:function(){return this.ctx._isStrokeTransparent||0==this.globalAlpha},fill:function(t){if(this.ctx._clip_path.length>0){var e;(e=window.outIntercept?"group"===window.outIntercept.type?window.outIntercept.stream:window.outIntercept:this.internal.getCurrentPage()).push("q");var n=this.path;this.path=this.ctx._clip_path,this.ctx._clip_path=[],this._fill(t,!0),this.ctx._clip_path=this.path,this.path=n,this._fill(t,!1),e.push("Q")}else this._fill(t,!1)},_fill:function(t,e){if(!this._isFillTransparent()){var r,i="function"==typeof this.pdf.internal.newObject2;r=window.outIntercept?"group"===window.outIntercept.type?window.outIntercept.stream:window.outIntercept:this.internal.getCurrentPage();var o=[],a=window.outIntercept;if(i)switch(this.ctx.globalCompositeOperation){case"normal":case"source-over":break;case"destination-in":case"destination-out":var s=this.pdf.internal.newStreamObject(),c=this.pdf.internal.newObject2();c.push("<</Type /ExtGState"),c.push("/SMask <</S /Alpha /G "+s.objId+" 0 R>>"),c.push(">>");d="MASK"+c.objId;this.pdf.internal.addGraphicsState(d,c.objId);var l="/"+d+" gs";r.splice(0,0,"q"),r.splice(1,0,l),r.push("Q"),window.outIntercept=s;break;default:var u="/"+this.pdf.internal.blendModeMap[this.ctx.globalCompositeOperation.toUpperCase()];u&&this.pdf.internal.out(u+" gs")}var h=this.ctx.globalAlpha;if(this.ctx._fillOpacity<1&&(h=this.ctx._fillOpacity),i){var f=this.pdf.internal.newObject2();f.push("<</Type /ExtGState"),f.push("/CA "+h),f.push("/ca "+h),f.push(">>");var d="GS_O_"+f.objId;this.pdf.internal.addGraphicsState(d,f.objId),this.pdf.internal.out("/"+d+" gs")}for(var p=this.path,m=0;m<p.length;m++){var g=p[m];switch(g.type){case"mt":o.push({start:g,deltas:[],abs:[]});break;case"lt":_=[g.x-p[m-1].x,g.y-p[m-1].y];o[o.length-1].deltas.push(_),o[o.length-1].abs.push(g);break;case"bct":_=[g.x1-p[m-1].x,g.y1-p[m-1].y,g.x2-p[m-1].x,g.y2-p[m-1].y,g.x-p[m-1].x,g.y-p[m-1].y];o[o.length-1].deltas.push(_);break;case"qct":var w=p[m-1].x+2/3*(g.x1-p[m-1].x),y=p[m-1].y+2/3*(g.y1-p[m-1].y),v=g.x+2/3*(g.x1-g.x),b=g.y+2/3*(g.y1-g.y),x=g.x,k=g.y,_=[w-p[m-1].x,y-p[m-1].y,v-p[m-1].x,b-p[m-1].y,x-p[m-1].x,k-p[m-1].y];o[o.length-1].deltas.push(_);break;case"arc":0===o.length&&o.push({deltas:[],abs:[]}),o[o.length-1].arc=!0,o[o.length-1].abs.push(g);break;case"close":o.push({close:!0})}}for(m=0;m<o.length;m++){var C;if(m==o.length-1?(C="f","evenodd"===t&&(C+="*")):C=null,o[m].close)this.pdf.internal.out("h"),this.pdf.internal.out("f");else if(o[m].arc){o[m].start&&this.internal.move2(this,o[m].start.x,o[m].start.y);for(var A=o[m].abs,S=0;S<A.length;S++){var q=A[S];if(void 0!==q.startAngle){var T=360*q.startAngle/(2*Math.PI),P=360*q.endAngle/(2*Math.PI),I=q.x,E=q.y;if(0===S&&this.internal.move2(this,I,E),this.internal.arc2(this,I,E,q.radius,T,P,q.anticlockwise,null,e),S===A.length-1&&o[m].start){var I=o[m].start.x,E=o[m].start.y;this.internal.line2(n,I,E)}}else this.internal.line2(n,q.x,q.y)}}else{var I=o[m].start.x,E=o[m].start.y;e?(this.pdf.lines(o[m].deltas,I,E,null,null),this.pdf.clip_fixed()):this.pdf.lines(o[m].deltas,I,E,null,C)}}window.outIntercept=a}},pushMask:function(){if("function"==typeof this.pdf.internal.newObject2){var t=this.pdf.internal.newStreamObject(),e=this.pdf.internal.newObject2();e.push("<</Type /ExtGState"),e.push("/SMask <</S /Alpha /G "+t.objId+" 0 R>>"),e.push(">>");var n="MASK"+e.objId;this.pdf.internal.addGraphicsState(n,e.objId);var r="/"+n+" gs";this.pdf.internal.out(r)}else console.log("jsPDF v2 not enabled")},clip:function(){if(this.ctx._clip_path.length>0)for(var t=0;t<this.path.length;t++)this.ctx._clip_path.push(this.path[t]);else this.ctx._clip_path=this.path;this.path=[]},measureText:function(t){var e=this.pdf;return{getWidth:function(){var n=e.internal.getFontSize(),r=e.getStringUnitWidth(t)*n/e.internal.scaleFactor;return r*=1.3333},get width(){return this.getWidth(t)}}},_getBaseline:function(t){var e=parseInt(this.pdf.internal.getFontSize()),n=.25*e;switch(this.ctx.textBaseline){case"bottom":return t-n;case"top":return t+e;case"hanging":return t+e-n;case"middle":return t+e/2-n;case"ideographic":return t;case"alphabetic":default:return t}}};var n=t.context2d;Object.defineProperty(n,"fillStyle",{set:function(t){this.setFillStyle(t)},get:function(){return this.ctx.fillStyle}}),Object.defineProperty(n,"strokeStyle",{set:function(t){this.setStrokeStyle(t)},get:function(){return this.ctx.strokeStyle}}),Object.defineProperty(n,"lineWidth",{set:function(t){this.setLineWidth(t)},get:function(){return this.ctx.lineWidth}}),Object.defineProperty(n,"lineCap",{set:function(t){this.setLineCap(t)},get:function(){return this.ctx.lineCap}}),Object.defineProperty(n,"lineJoin",{set:function(t){this.setLineJoin(t)},get:function(){return this.ctx.lineJoin}}),Object.defineProperty(n,"miterLimit",{set:function(t){this.ctx.miterLimit=t},get:function(){return this.ctx.miterLimit}}),Object.defineProperty(n,"textBaseline",{set:function(t){this.setTextBaseline(t)},get:function(){return this.getTextBaseline()}}),Object.defineProperty(n,"textAlign",{set:function(t){this.setTextAlign(t)},get:function(){return this.getTextAlign()}}),Object.defineProperty(n,"font",{set:function(t){this.setFont(t)},get:function(){return this.ctx.font}}),Object.defineProperty(n,"globalCompositeOperation",{set:function(t){this.ctx.globalCompositeOperation=t},get:function(){return this.ctx.globalCompositeOperation}}),Object.defineProperty(n,"globalAlpha",{set:function(t){this.ctx.globalAlpha=t},get:function(){return this.ctx.globalAlpha}}),Object.defineProperty(n,"ignoreClearRect",{set:function(t){this.ctx.ignoreClearRect=t},get:function(){return this.ctx.ignoreClearRect}}),n.internal={},n.internal.rxRgb=/rgb\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/,n.internal.rxRgba=/rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*([\d\.]+)\s*\)/,n.internal.rxTransparent=/transparent|rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*0+\s*\)/,n.internal.arc=function(t,e,n,r,i,o,a,s){for(var c=this.pdf.internal.scaleFactor,l=this.pdf.internal.pageSize.height,u=this.pdf.internal.f2,h=i*(Math.PI/180),f=o*(Math.PI/180),d=this.createArc(r,h,f,a),p=0;p<d.length;p++){var m=d[p];0===p?this.pdf.internal.out([u((m.x1+e)*c),u((l-(m.y1+n))*c),"m",u((m.x2+e)*c),u((l-(m.y2+n))*c),u((m.x3+e)*c),u((l-(m.y3+n))*c),u((m.x4+e)*c),u((l-(m.y4+n))*c),"c"].join(" ")):this.pdf.internal.out([u((m.x2+e)*c),u((l-(m.y2+n))*c),u((m.x3+e)*c),u((l-(m.y3+n))*c),u((m.x4+e)*c),u((l-(m.y4+n))*c),"c"].join(" ")),t._lastPoint={x:e,y:n}}null!==s&&this.pdf.internal.out(this.pdf.internal.getStyle(s))},n.internal.arc2=function(t,e,n,r,i,o,a,s,c){var l=e,u=n;c?(this.arc(t,l,u,r,i,o,a,null),this.pdf.clip_fixed()):this.arc(t,l,u,r,i,o,a,s)},n.internal.move2=function(t,e,n){var r=this.pdf.internal.scaleFactor,i=this.pdf.internal.pageSize.height,o=this.pdf.internal.f2;this.pdf.internal.out([o(e*r),o((i-n)*r),"m"].join(" ")),t._lastPoint={x:e,y:n}},n.internal.line2=function(t,e,n){var r=this.pdf.internal.scaleFactor,i=this.pdf.internal.pageSize.height,o=this.pdf.internal.f2,a={x:e,y:n};this.pdf.internal.out([o(a.x*r),o((i-a.y)*r),"l"].join(" ")),t._lastPoint=a},n.internal.createArc=function(t,e,n,r){var i=2*Math.PI,o=Math.PI/2,a=e;for((a<i||a>i)&&(a%=i),a<0&&(a=i+a);e>n;)e-=i;var s=Math.abs(n-e);s<i&&r&&(s=i-s);for(var c=[],l=r?-1:1,u=a;s>1e-5;){var h=u+l*Math.min(s,o);c.push(this.createSmallArc(t,u,h)),s-=Math.abs(h-u),u=h}return c},n.internal.getCurrentPage=function(){return this.pdf.internal.pages[this.pdf.internal.getCurrentPageInfo().pageNumber]},n.internal.createSmallArc=function(t,e,n){var r=(n-e)/2,i=t*Math.cos(r),o=t*Math.sin(r),a=i,s=-o,c=a*a+s*s,l=c+a*i+s*o,u=4/3*(Math.sqrt(2*c*l)-l)/(a*o-s*i),h=a-u*s,f=s+u*a,d=h,p=-f,m=r+e,g=Math.cos(m),w=Math.sin(m);return{x1:t*Math.cos(e),y1:t*Math.sin(e),x2:h*g-f*w,y2:h*w+f*g,x3:d*g-p*w,y3:d*w+p*g,x4:t*Math.cos(n),y4:t*Math.sin(n)}}}(e.API),/** @preserve
	 * jsPDF fromHTML plugin. BETA stage. API subject to change. Needs browser
	 * Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
	 *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
	 *               2014 Diego Casorran, https://github.com/diegocr
	 *               2014 Daniel Husar, https://github.com/danielhusar
	 *               2014 Wolfgang Gassler, https://github.com/woolfg
	 *               2014 Steven Spungin, https://github.com/flamenco
	 *
	 * 
	 * ====================================================================
	 */
	function(e){var n,r,o,a,s,c,l,u,h,f,d,p,m,g,w,y,v,b,x,k;n=function(){function t(){}return function(e){return t.prototype=e,new t}}(),f=function(t){var e,n,r,i,o,a,s;for(n=0,r=t.length,e=void 0,i=!1,a=!1;!i&&n!==r;)(e=t[n]=t[n].trimLeft())&&(i=!0),n++;for(n=r-1;r&&!a&&-1!==n;)(e=t[n]=t[n].trimRight())&&(a=!0),n--;for(o=/\s+$/g,s=!0,n=0;n!==r;)"\u2028"!=t[n]&&(e=t[n].replace(/\s+/g," "),s&&(e=e.trimLeft()),e&&(s=o.test(e)),t[n]=e),n++;return t},p=function(t){var e,n,r;for(e=void 0,n=(r=t.split(",")).shift();!e&&n;)e=o[n.trim().toLowerCase()],n=r.shift();return e},m=function(t){(t="auto"===t?"0px":t).indexOf("em")>-1&&!isNaN(Number(t.replace("em","")))&&(t=18.719*Number(t.replace("em",""))+"px"),t.indexOf("pt")>-1&&!isNaN(Number(t.replace("pt","")))&&(t=1.333*Number(t.replace("pt",""))+"px");var e;return void 0,16,(e=g[t])?e:void 0!==(e={"xx-small":9,"x-small":11,small:13,medium:16,large:19,"x-large":23,"xx-large":28,auto:0}[{css_line_height_string:t}])?g[t]=e/16:(e=parseFloat(t))?g[t]=e/16:3===(e=t.match(/([\d\.]+)(px)/)).length?g[t]=parseFloat(e[1])/16:g[t]=1},h=function(t){var e,n,r;return r=function(e){var n;return n=function(t){return document.defaultView&&document.defaultView.getComputedStyle?document.defaultView.getComputedStyle(t,null):t.currentStyle?t.currentStyle:t.style}(t),function(t){return t=t.replace(/-\D/g,function(t){return t.charAt(1).toUpperCase()}),n[t]}}(),e={},n=void 0,e["font-family"]=p(r("font-family"))||"times",e["font-style"]=a[r("font-style")]||"normal",e["text-align"]=s[r("text-align")]||"left","bold"===(n=c[r("font-weight")]||"normal")&&("normal"===e["font-style"]?e["font-style"]=n:e["font-style"]=n+e["font-style"]),e["font-size"]=m(r("font-size"))||1,e["line-height"]=m(r("line-height"))||1,e.display="inline"===r("display")?"inline":"block",n="block"===e.display,e["margin-top"]=n&&m(r("margin-top"))||0,e["margin-bottom"]=n&&m(r("margin-bottom"))||0,e["padding-top"]=n&&m(r("padding-top"))||0,e["padding-bottom"]=n&&m(r("padding-bottom"))||0,e["margin-left"]=n&&m(r("margin-left"))||0,e["margin-right"]=n&&m(r("margin-right"))||0,e["padding-left"]=n&&m(r("padding-left"))||0,e["padding-right"]=n&&m(r("padding-right"))||0,e["page-break-before"]=r("page-break-before")||"auto",e.float=l[r("cssFloat")]||"none",e.clear=u[r("clear")]||"none",e.color=r("color"),e},w=function(t,e,n){var r,i,o,a,s;if(o=!1,i=void 0,a=void 0,r=n["#"+t.id])if("function"==typeof r)o=r(t,e);else for(i=0,a=r.length;!o&&i!==a;)o=r[i](t,e),i++;if(r=n[t.nodeName],!o&&r)if("function"==typeof r)o=r(t,e);else for(i=0,a=r.length;!o&&i!==a;)o=r[i](t,e),i++;for(s=t.className?t.className.split(" "):[],i=0;i<s.length;i++)if(r=n["."+s[i]],!o&&r)if("function"==typeof r)o=r(t,e);else for(i=0,a=r.length;!o&&i!==a;)o=r[i](t,e),i++;return o},k=function(t,e){var n,r,i,o,a,s,c,l,u;for(n=[],r=[],i=0,u=t.rows[0].cells.length,c=t.clientWidth;i<u;)l=t.rows[0].cells[i],r[i]={name:l.textContent.toLowerCase().replace(/\s+/g,""),prompt:l.textContent.replace(/\r?\n/g,""),width:l.clientWidth/c*e.pdf.internal.pageSize.width},i++;for(i=1;i<t.rows.length;){for(s=t.rows[i],a={},o=0;o<s.cells.length;)a[r[o].name]=s.cells[o].textContent.replace(/\r?\n/g,""),o++;n.push(a),i++}return{rows:n,headers:r}};var _={SCRIPT:1,STYLE:1,NOSCRIPT:1,OBJECT:1,EMBED:1,SELECT:1},C=1;r=function(e,i,o){var a,s,c,l,u,f,d,p;for(s=e.childNodes,a=void 0,(u="block"===(c=h(e)).display)&&(i.setBlockBoundary(),i.setBlockStyle(c)),l=0,f=s.length;l<f;){if("object"===(void 0===(a=s[l])?"undefined":t(a))){if(i.executeWatchFunctions(a),1===a.nodeType&&"HEADER"===a.nodeName){var m=a,g=i.pdf.margins_doc.top;i.pdf.internal.events.subscribe("addPage",function(t){i.y=g,r(m,i,o),i.pdf.margins_doc.top=i.y+10,i.y+=10},!1)}if(8===a.nodeType&&"#comment"===a.nodeName)~a.textContent.indexOf("ADD_PAGE")&&(i.pdf.addPage(),i.y=i.pdf.margins_doc.top);else if(1!==a.nodeType||_[a.nodeName])if(3===a.nodeType){var v=a.nodeValue;if(a.nodeValue&&"LI"===a.parentNode.nodeName)if("OL"===a.parentNode.parentNode.nodeName)v=C+++". "+v;else{var b=c["font-size"],x=(3-.75*b)*i.pdf.internal.scaleFactor,A=.75*b*i.pdf.internal.scaleFactor,S=1.74*b/i.pdf.internal.scaleFactor;p=function(t,e){this.pdf.circle(t+x,e+A,S,"FD")}}16&a.ownerDocument.body.compareDocumentPosition(a)&&i.addText(v,c)}else"string"==typeof a&&i.addText(a,c);else{var q;if("IMG"===a.nodeName){var T=a.getAttribute("src");q=y[i.pdf.sHashCode(T)||T]}if(q){i.pdf.internal.pageSize.height-i.pdf.margins_doc.bottom<i.y+a.height&&i.y>i.pdf.margins_doc.top&&(i.pdf.addPage(),i.y=i.pdf.margins_doc.top,i.executeWatchFunctions(a));var P=h(a),I=i.x,E=12/i.pdf.internal.scaleFactor,O=(P["margin-left"]+P["padding-left"])*E,F=(P["margin-right"]+P["padding-right"])*E,B=(P["margin-top"]+P["padding-top"])*E,R=(P["margin-bottom"]+P["padding-bottom"])*E;void 0!==P.float&&"right"===P.float?I+=i.settings.width-a.width-F:I+=O,i.pdf.addImage(q,I,i.y+B,a.width,a.height),q=void 0,"right"===P.float||"left"===P.float?(i.watchFunctions.push(function(t,e,n,r){return i.y>=e?(i.x+=t,i.settings.width+=n,!0):!!(r&&1===r.nodeType&&!_[r.nodeName]&&i.x+r.width>i.pdf.margins_doc.left+i.pdf.margins_doc.width)&&(i.x+=t,i.y=e,i.settings.width+=n,!0)}.bind(this,"left"===P.float?-a.width-O-F:0,i.y+a.height+B+R,a.width)),i.watchFunctions.push(function(t,e,n){return!(i.y<t&&e===i.pdf.internal.getNumberOfPages())||1===n.nodeType&&"both"===h(n).clear&&(i.y=t,!0)}.bind(this,i.y+a.height,i.pdf.internal.getNumberOfPages())),i.settings.width-=a.width+O+F,"left"===P.float&&(i.x+=a.width+O+F)):i.y+=a.height+B+R}else if("TABLE"===a.nodeName)d=k(a,i),i.y+=10,i.pdf.table(i.x,i.y,d.rows,d.headers,{autoSize:!1,printHeaders:o.printHeaders,margins:i.pdf.margins_doc,css:h(a)}),i.y=i.pdf.lastCellPos.y+i.pdf.lastCellPos.h+20;else if("OL"===a.nodeName||"UL"===a.nodeName)C=1,w(a,i,o)||r(a,i,o),i.y+=10;else if("LI"===a.nodeName){var D=i.x;i.x+=20/i.pdf.internal.scaleFactor,i.y+=3,w(a,i,o)||r(a,i,o),i.x=D}else"BR"===a.nodeName?(i.y+=c["font-size"]*i.pdf.internal.scaleFactor,i.addText("\u2028",n(c))):w(a,i,o)||r(a,i,o)}}l++}if(o.outY=i.y,u)return i.setBlockBoundary(p)},y={},v=function(t,e,n,r){function i(){e.pdf.internal.events.publish("imagesLoaded"),r(o)}for(var o,a=t.getElementsByTagName("img"),s=a.length,c=0;s--;)!function(t,n,r){if(t){var a=new Image;o=++c,a.crossOrigin="",a.onerror=a.onload=function(){if(a.complete&&(0===a.src.indexOf("data:image/")&&(a.width=n||a.width||0,a.height=r||a.height||0),a.width+a.height)){var o=e.pdf.sHashCode(t)||t;y[o]=y[o]||a}--c||i()},a.src=t}}(a[s].getAttribute("src"),a[s].width,a[s].height);return c||i()},b=function(t,e,n){var i=t.getElementsByTagName("footer");if(i.length>0){i=i[0];var o=e.pdf.internal.write,a=e.y;e.pdf.internal.write=function(){},r(i,e,n);var s=Math.ceil(e.y-a)+5;e.y=a,e.pdf.internal.write=o,e.pdf.margins_doc.bottom+=s;for(var c=function(t){var o=void 0!==t?t.pageNumber:1,a=e.y;e.y=e.pdf.internal.pageSize.height-e.pdf.margins_doc.bottom,e.pdf.margins_doc.bottom-=s;for(var c=i.getElementsByTagName("span"),l=0;l<c.length;++l)(" "+c[l].className+" ").replace(/[\n\t]/g," ").indexOf(" pageCounter ")>-1&&(c[l].innerHTML=o),(" "+c[l].className+" ").replace(/[\n\t]/g," ").indexOf(" totalPages ")>-1&&(c[l].innerHTML="###jsPDFVarTotalPages###");r(i,e,n),e.pdf.margins_doc.bottom+=s,e.y=a},l=i.getElementsByTagName("span"),u=0;u<l.length;++u)(" "+l[u].className+" ").replace(/[\n\t]/g," ").indexOf(" totalPages ")>-1&&e.pdf.internal.events.subscribe("htmlRenderingFinished",e.pdf.putTotalPages.bind(e.pdf,"###jsPDFVarTotalPages###"),!0);e.pdf.internal.events.subscribe("addPage",c,!1),c(),_.FOOTER=1}},x=function(t,e,n,i,o,a){if(!e)return!1;"string"==typeof e||e.parentNode||(e=""+e.innerHTML),"string"==typeof e&&(e=function(t){var e,n,r,i;return r="jsPDFhtmlText"+Date.now().toString()+(1e3*Math.random()).toFixed(0),i="position: absolute !important;clip: rect(1px 1px 1px 1px); /* IE6, IE7 */clip: rect(1px, 1px, 1px, 1px);padding:0 !important;border:0 !important;height: 1px !important;width: 1px !important; top:auto;left:-100px;overflow: hidden;",n=document.createElement("div"),n.style.cssText=i,n.innerHTML='<iframe style="height:1px;width:1px" name="'+r+'" />',document.body.appendChild(n),(e=window.frames[r]).document.open(),e.document.writeln(t),e.document.close(),e.document.body}(e.replace(/<\/?script[^>]*?>/gi,"")));var s,c=new d(t,n,i,o);return v.call(this,e,c,o.elementHandlers,function(t){b(e,c,o.elementHandlers),r(e,c,o.elementHandlers),c.pdf.internal.events.publish("htmlRenderingFinished"),s=c.dispose(),"function"==typeof a?a(s):t&&console.error("jsPDF Warning: rendering issues? provide a callback to fromHTML!")}),s||{x:c.x,y:c.y}},(d=function(t,e,n,r){return this.pdf=t,this.x=e,this.y=n,this.settings=r,this.watchFunctions=[],this.init(),this}).prototype.init=function(){return this.paragraph={text:[],style:[]},this.pdf.internal.write("q")},d.prototype.dispose=function(){return this.pdf.internal.write("Q"),{x:this.x,y:this.y,ready:!0}},d.prototype.executeWatchFunctions=function(t){var e=!1,n=[];if(this.watchFunctions.length>0){for(var r=0;r<this.watchFunctions.length;++r)!0===this.watchFunctions[r](t)?e=!0:n.push(this.watchFunctions[r]);this.watchFunctions=n}return e},d.prototype.splitFragmentsIntoLines=function(t,e){var r,i,o,a,s,c,l,u,h,f,d,p,m,g;for(12,f=this.pdf.internal.scaleFactor,a={},i=void 0,h=void 0,o=void 0,s=void 0,g=void 0,u=void 0,l=void 0,c=void 0,p=[d=[]],r=0,m=this.settings.width;t.length;)if(s=t.shift(),g=e.shift(),s)if(i=g["font-family"],h=g["font-style"],(o=a[i+h])||(o=this.pdf.internal.getFont(i,h).metadata.Unicode,a[i+h]=o),u={widths:o.widths,kerning:o.kerning,fontSize:12*g["font-size"],textIndent:r},l=this.pdf.getStringUnitWidth(s,u)*u.fontSize/f,"\u2028"==s)d=[],p.push(d);else if(r+l>m){for(c=this.pdf.splitTextToSize(s,m,u),d.push([c.shift(),g]);c.length;)d=[[c.shift(),g]],p.push(d);r=this.pdf.getStringUnitWidth(d[0][0],u)*u.fontSize/f}else d.push([s,g]),r+=l;if(void 0!==g["text-align"]&&("center"===g["text-align"]||"right"===g["text-align"]||"justify"===g["text-align"]))for(var w=0;w<p.length;++w){var y=this.pdf.getStringUnitWidth(p[w][0][0],u)*u.fontSize/f;w>0&&(p[w][0][1]=n(p[w][0][1]));var v=m-y;if("right"===g["text-align"])p[w][0][1]["margin-left"]=v;else if("center"===g["text-align"])p[w][0][1]["margin-left"]=v/2;else if("justify"===g["text-align"]){var b=p[w][0][0].split(" ").length-1;p[w][0][1]["word-spacing"]=v/b,w===p.length-1&&(p[w][0][1]["word-spacing"]=0)}}return p},d.prototype.RenderTextFragment=function(t,e){var n,r;r=0,this.pdf.internal.pageSize.height-this.pdf.margins_doc.bottom<this.y+this.pdf.internal.getFontSize()&&(this.pdf.internal.write("ET","Q"),this.pdf.addPage(),this.y=this.pdf.margins_doc.top,this.pdf.internal.write("q","BT 0 g",this.pdf.internal.getCoordinateString(this.x),this.pdf.internal.getVerticalCoordinateString(this.y),e.color,"Td"),r=Math.max(r,e["line-height"],e["font-size"]),this.pdf.internal.write(0,(-12*r).toFixed(2),"Td")),n=this.pdf.internal.getFont(e["font-family"],e["font-style"]);var i=this.getPdfColor(e.color);i!==this.lastTextColor&&(this.pdf.internal.write(i),this.lastTextColor=i),void 0!==e["word-spacing"]&&e["word-spacing"]>0&&this.pdf.internal.write(e["word-spacing"].toFixed(2),"Tw"),this.pdf.internal.write("/"+n.id,(12*e["font-size"]).toFixed(2),"Tf","("+this.pdf.internal.pdfEscape(t)+") Tj"),void 0!==e["word-spacing"]&&this.pdf.internal.write(0,"Tw")},d.prototype.getPdfColor=function(t){var e,n,r,o=/rgb\s*\(\s*(\d+),\s*(\d+),\s*(\d+\s*)\)/.exec(t);if(null!=o?(e=parseInt(o[1]),n=parseInt(o[2]),r=parseInt(o[3])):("#"!=t.charAt(0)&&((t=i.colorNameToHex(t))||(t="#000000")),e=t.substring(1,3),e=parseInt(e,16),n=t.substring(3,5),n=parseInt(n,16),r=t.substring(5,7),r=parseInt(r,16)),"string"==typeof e&&/^#[0-9A-Fa-f]{6}$/.test(e)){var a=parseInt(e.substr(1),16);e=a>>16&255,n=a>>8&255,r=255&a}var s=this.f3;return 0===e&&0===n&&0===r||void 0===n?s(e/255)+" g":[s(e/255),s(n/255),s(r/255),"rg"].join(" ")},d.prototype.f3=function(t){return t.toFixed(3)},d.prototype.renderParagraph=function(t){var e,n,r,i,o,a,s,c,l,u,h,d,p;if(r=f(this.paragraph.text),d=this.paragraph.style,e=this.paragraph.blockstyle,this.paragraph={text:[],style:[],blockstyle:{},priorblockstyle:e},r.join("").trim()){s=this.splitFragmentsIntoLines(r,d),a=void 0,c=void 0,12,n=12/this.pdf.internal.scaleFactor,this.priorMarginBottom=this.priorMarginBottom||0,h=(Math.max((e["margin-top"]||0)-this.priorMarginBottom,0)+(e["padding-top"]||0))*n,u=((e["margin-bottom"]||0)+(e["padding-bottom"]||0))*n,this.priorMarginBottom=e["margin-bottom"]||0,"always"===e["page-break-before"]&&(this.pdf.addPage(),this.y=0,h=((e["margin-top"]||0)+(e["padding-top"]||0))*n),l=this.pdf.internal.write,i=void 0,o=void 0,this.y+=h,l("q","BT 0 g",this.pdf.internal.getCoordinateString(this.x),this.pdf.internal.getVerticalCoordinateString(this.y),"Td");for(var m=0;s.length;){for(c=0,i=0,o=(a=s.shift()).length;i!==o;)a[i][0].trim()&&(c=Math.max(c,a[i][1]["line-height"],a[i][1]["font-size"]),p=7*a[i][1]["font-size"]),i++;var g=0,w=0;for(void 0!==a[0][1]["margin-left"]&&a[0][1]["margin-left"]>0&&(g=(w=this.pdf.internal.getCoordinateString(a[0][1]["margin-left"]))-m,m=w),l(g+Math.max(e["margin-left"]||0,0)*n,(-12*c).toFixed(2),"Td"),i=0,o=a.length;i!==o;)a[i][0]&&this.RenderTextFragment(a[i][0],a[i][1]),i++;if(this.y+=c*n,this.executeWatchFunctions(a[0][1])&&s.length>0){var y=[],v=[];s.forEach(function(t){for(var e=0,n=t.length;e!==n;)t[e][0]&&(y.push(t[e][0]+" "),v.push(t[e][1])),++e}),s=this.splitFragmentsIntoLines(f(y),v),l("ET","Q"),l("q","BT 0 g",this.pdf.internal.getCoordinateString(this.x),this.pdf.internal.getVerticalCoordinateString(this.y),"Td")}}return t&&"function"==typeof t&&t.call(this,this.x-9,this.y-p/2),l("ET","Q"),this.y+=u}},d.prototype.setBlockBoundary=function(t){return this.renderParagraph(t)},d.prototype.setBlockStyle=function(t){return this.paragraph.blockstyle=t},d.prototype.addText=function(t,e){return this.paragraph.text.push(t),this.paragraph.style.push(e)},o={helvetica:"helvetica","sans-serif":"helvetica","times new roman":"times",serif:"times",times:"times",monospace:"courier",courier:"courier"},c={100:"normal",200:"normal",300:"normal",400:"normal",500:"bold",600:"bold",700:"bold",800:"bold",900:"bold",normal:"normal",bold:"bold",bolder:"bold",lighter:"normal"},a={normal:"normal",italic:"italic",oblique:"italic"},s={left:"left",right:"right",center:"center",justify:"justify"},l={none:"none",right:"right",left:"left"},u={none:"none",both:"both"},g={normal:1},e.fromHTML=function(t,e,n,r,i,o){return this.margins_doc=o||{top:0,bottom:0},r||(r={}),r.elementHandlers||(r.elementHandlers={}),x(this,t,isNaN(e)?4:e,isNaN(n)?4:n,r,i)}}(e.API),/** ==================================================================== 
	 * jsPDF JavaScript plugin
	 * Copyright (c) 2013 Youssef Beddad, youssef.beddad@gmail.com
	 * 
	 * 
	 * ====================================================================
	 */
	function(t){var n,r,i;e.API.addJS=function(t){return i=t,this.internal.events.subscribe("postPutResources",function(t){n=this.internal.newObject(),this.internal.write("<< /Names [(EmbeddedJS) "+(n+1)+" 0 R] >>","endobj"),r=this.internal.newObject(),this.internal.write("<< /S /JavaScript /JS (",i,") >>","endobj")}),this.internal.events.subscribe("putCatalog",function(){void 0!==n&&void 0!==r&&this.internal.write("/Names <</JavaScript "+n+" 0 R>>")}),this}}(),/**
	 * jsPDF Outline PlugIn
	 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
	 *
	 * Licensed under the MIT License.
	 * http://opensource.org/licenses/mit-license
	 */
	function(t){t.events.push(["postPutResources",function(){var t=this,e=/^(\d+) 0 obj$/;if(this.outline.root.children.length>0)for(var n=t.outline.render().split(/\r\n/),r=0;r<n.length;r++){var i=n[r],o=e.exec(i);if(null!=o){var a=o[1];t.internal.newObjectDeferredBegin(a)}t.internal.write(i)}if(this.outline.createNamedDestinations){for(var s=this.internal.pages.length,c=[],r=0;r<s;r++){var l=t.internal.newObject();c.push(l);var u=t.internal.getPageInfo(r+1);t.internal.write("<< /D["+u.objId+" 0 R /XYZ null null null]>> endobj")}var h=t.internal.newObject();t.internal.write("<< /Names [ ");for(r=0;r<c.length;r++)t.internal.write("(page_"+(r+1)+")"+c[r]+" 0 R");t.internal.write(" ] >>","endobj");t.internal.newObject();t.internal.write("<< /Dests "+h+" 0 R"),t.internal.write(">>","endobj")}}]),t.events.push(["putCatalog",function(){var t=this;t.outline.root.children.length>0&&(t.internal.write("/Outlines",this.outline.makeRef(this.outline.root)),this.outline.createNamedDestinations&&t.internal.write("/Names "+namesOid+" 0 R"))}]),t.events.push(["initialized",function(){var t=this;t.outline={createNamedDestinations:!1,root:{children:[]}},t.outline.add=function(t,e,n){var r={title:e,options:n,children:[]};return null==t&&(t=this.root),t.children.push(r),r},t.outline.render=function(){return this.ctx={},this.ctx.val="",this.ctx.pdf=t,this.genIds_r(this.root),this.renderRoot(this.root),this.renderItems(this.root),this.ctx.val},t.outline.genIds_r=function(e){e.id=t.internal.newObjectDeferred();for(var n=0;n<e.children.length;n++)this.genIds_r(e.children[n])},t.outline.renderRoot=function(t){this.objStart(t),this.line("/Type /Outlines"),t.children.length>0&&(this.line("/First "+this.makeRef(t.children[0])),this.line("/Last "+this.makeRef(t.children[t.children.length-1]))),this.line("/Count "+this.count_r({count:0},t)),this.objEnd()},t.outline.renderItems=function(e){for(i=0;i<e.children.length;i++){o=e.children[i];this.objStart(o),this.line("/Title "+this.makeString(o.title)),this.line("/Parent "+this.makeRef(e)),i>0&&this.line("/Prev "+this.makeRef(e.children[i-1])),i<e.children.length-1&&this.line("/Next "+this.makeRef(e.children[i+1])),o.children.length>0&&(this.line("/First "+this.makeRef(o.children[0])),this.line("/Last "+this.makeRef(o.children[o.children.length-1])));var n=this.count=this.count_r({count:0},o);if(n>0&&this.line("/Count "+n),o.options&&o.options.pageNumber){var r=t.internal.getPageInfo(o.options.pageNumber);this.line("/Dest ["+r.objId+" 0 R /XYZ 0 "+this.ctx.pdf.internal.pageSize.height+" 0]")}this.objEnd()}for(var i=0;i<e.children.length;i++){var o=e.children[i];this.renderItems(o)}},t.outline.line=function(t){this.ctx.val+=t+"\r\n"},t.outline.makeRef=function(t){return t.id+" 0 R"},t.outline.makeString=function(e){return"("+t.internal.pdfEscape(e)+")"},t.outline.objStart=function(t){this.ctx.val+="\r\n"+t.id+" 0 obj\r\n<<\r\n"},t.outline.objEnd=function(t){this.ctx.val+=">> \r\nendobj\r\n"},t.outline.count_r=function(t,e){for(var n=0;n<e.children.length;n++)t.count++,this.count_r(t,e.children[n]);return t.count}}])}(e.API),/**@preserve
	 *  ====================================================================
	 * jsPDF PNG PlugIn
	 * Copyright (c) 2014 James Robb, https://github.com/jamesbrobb
	 *
	 * 
	 * ====================================================================
	 */
	function(t){var e=function(){return"function"!=typeof PNG||"function"!=typeof s},n=function(e){return e!==t.image_compression.NONE&&r()},r=function(){var t="function"==typeof o;if(!t)throw new Error("requires deflate.js for compression");return t},i=function(e,n,r,i){var s=5,u=f;switch(i){case t.image_compression.FAST:s=3,u=h;break;case t.image_compression.MEDIUM:s=6,u=d;break;case t.image_compression.SLOW:s=9,u=p}e=l(e,n,r,u);var m=new Uint8Array(a(s)),g=c(e),w=new o(s),y=w.append(e),v=w.flush(),b=m.length+y.length+v.length,x=new Uint8Array(b+4);return x.set(m),x.set(y,m.length),x.set(v,m.length+y.length),x[b++]=g>>>24&255,x[b++]=g>>>16&255,x[b++]=g>>>8&255,x[b++]=255&g,t.arrayBufferToBinaryString(x)},a=function(t,e){var n=Math.LOG2E*Math.log(32768)-8<<4|8,r=n<<8;return r|=Math.min(3,(e-1&255)>>1)<<6,r|=0,r+=31-r%31,[n,255&r]},c=function(t,e){for(var n,r=1,i=0,o=t.length,a=0;o>0;){o-=n=o>e?e:o;do{i+=r+=t[a++]}while(--n);r%=65521,i%=65521}return(i<<16|r)>>>0},l=function(t,e,n,r){for(var i,o,a,s=t.length/e,c=new Uint8Array(t.length+s),l=g(),u=0;u<s;u++){if(a=u*e,i=t.subarray(a,a+e),r)c.set(r(i,n,o),a+u);else{for(var h=0,f=l.length,d=[];h<f;h++)d[h]=l[h](i,n,o);var p=w(d.concat());c.set(d[p],a+u)}o=i}return c},u=function(t,e,n){var r=Array.apply([],t);return r.unshift(0),r},h=function(t,e,n){var r,i=[],o=0,a=t.length;for(i[0]=1;o<a;o++)r=t[o-e]||0,i[o+1]=t[o]-r+256&255;return i},f=function(t,e,n){var r,i=[],o=0,a=t.length;for(i[0]=2;o<a;o++)r=n&&n[o]||0,i[o+1]=t[o]-r+256&255;return i},d=function(t,e,n){var r,i,o=[],a=0,s=t.length;for(o[0]=3;a<s;a++)r=t[a-e]||0,i=n&&n[a]||0,o[a+1]=t[a]+256-(r+i>>>1)&255;return o},p=function(t,e,n){var r,i,o,a,s=[],c=0,l=t.length;for(s[0]=4;c<l;c++)r=t[c-e]||0,i=n&&n[c]||0,o=n&&n[c-e]||0,a=m(r,i,o),s[c+1]=t[c]-a+256&255;return s},m=function(t,e,n){var r=t+e-n,i=Math.abs(r-t),o=Math.abs(r-e),a=Math.abs(r-n);return i<=o&&i<=a?t:o<=a?e:n},g=function(){return[u,h,f,d,p]},w=function(t){for(var e,n,r,i=0,o=t.length;i<o;)((e=y(t[i].slice(1)))<n||!n)&&(n=e,r=i),i++;return r},y=function(t){for(var e=0,n=t.length,r=0;e<n;)r+=Math.abs(t[e++]);return r},v=function(e){var n;switch(e){case t.image_compression.FAST:n=11;break;case t.image_compression.MEDIUM:n=13;break;case t.image_compression.SLOW:n=14;break;default:n=12}return n};t.processPNG=function(t,r,o,a,s){var c,l,u,h,f,d,p=this.color_spaces.DEVICE_RGB,m=this.decode.FLATE_DECODE,g=8;if(this.isArrayBuffer(t)&&(t=new Uint8Array(t)),this.isArrayBufferView(t)){if(e())throw new Error("PNG support requires png.js and zlib.js");if(c=new PNG(t),t=c.imgData,g=c.bits,p=c.colorSpace,h=c.colors,-1!==[4,6].indexOf(c.colorType)){if(8===c.bits)for(var w,y=(I=32==c.pixelBitlength?new Uint32Array(c.decodePixels().buffer):16==c.pixelBitlength?new Uint16Array(c.decodePixels().buffer):new Uint8Array(c.decodePixels().buffer)).length,b=new Uint8Array(y*c.colors),x=new Uint8Array(y),k=c.pixelBitlength-c.bits,_=0,C=0;_<y;_++){for(A=I[_],w=0;w<k;)b[C++]=A>>>w&255,w+=c.bits;x[_]=A>>>w&255}if(16===c.bits){for(var A,y=(I=new Uint32Array(c.decodePixels().buffer)).length,b=new Uint8Array(y*(32/c.pixelBitlength)*c.colors),x=new Uint8Array(y*(32/c.pixelBitlength)),S=c.colors>1,_=0,C=0,q=0;_<y;)A=I[_++],b[C++]=A>>>0&255,S&&(b[C++]=A>>>16&255,A=I[_++],b[C++]=A>>>0&255),x[q++]=A>>>16&255;g=8}n(a)?(t=i(b,c.width*c.colors,c.colors,a),d=i(x,c.width,1,a)):(t=b,d=x,m=null)}if(3===c.colorType&&(p=this.color_spaces.INDEXED,f=c.palette,c.transparency.indexed)){for(var T=c.transparency.indexed,P=0,_=0,y=T.length;_<y;++_)P+=T[_];if((P/=255)===y-1&&-1!==T.indexOf(0))u=[T.indexOf(0)];else if(P!==y){for(var I=c.decodePixels(),x=new Uint8Array(I.length),_=0,y=I.length;_<y;_++)x[_]=T[I[_]];d=i(x,c.width,1)}}var E=v(a);return l=m===this.decode.FLATE_DECODE?"/Predictor "+E+" /Colors "+h+" /BitsPerComponent "+g+" /Columns "+c.width:"/Colors "+h+" /BitsPerComponent "+g+" /Columns "+c.width,(this.isArrayBuffer(t)||this.isArrayBufferView(t))&&(t=this.arrayBufferToBinaryString(t)),(d&&this.isArrayBuffer(d)||this.isArrayBufferView(d))&&(d=this.arrayBufferToBinaryString(d)),this.createImageInfo(t,c.width,c.height,p,g,m,r,o,l,u,f,d,E)}throw new Error("Unsupported PNG image data, try using JPEG instead.")}}(e.API),e.API.autoPrint=function(){var t;return this.internal.events.subscribe("postPutResources",function(){t=this.internal.newObject(),this.internal.write("<< /S/Named /Type/Action /N/Print >>","endobj")}),this.internal.events.subscribe("putCatalog",function(){this.internal.write("/OpenAction "+t+" 0 R")}),this},/** @preserve
	 * jsPDF split_text_to_size plugin - MIT license.
	 * Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
	 *               2014 Diego Casorran, https://github.com/diegocr
	 */
	function(t){var e=t.getCharWidthsArray=function(t,e){e||(e={});var n,r,i,o=e.widths?e.widths:this.internal.getFont().metadata.Unicode.widths,a=o.fof?o.fof:1,s=e.kerning?e.kerning:this.internal.getFont().metadata.Unicode.kerning,c=s.fof?s.fof:1,l=0,u=o[0]||a,h=[];for(n=0,r=t.length;n<r;n++)i=t.charCodeAt(n),h.push((o[i]||u)/a+(s[i]&&s[i][l]||0)/c),l=i;return h},n=function(t){for(var e=t.length,n=0;e;)n+=t[--e];return n},r=t.getStringUnitWidth=function(t,r){return n(e.call(this,t,r))},i=function(t,e,n,r){for(var i=[],o=0,a=t.length,s=0;o!==a&&s+e[o]<n;)s+=e[o],o++;i.push(t.slice(0,o));var c=o;for(s=0;o!==a;)s+e[o]>r&&(i.push(t.slice(c,o)),s=0,c=o),s+=e[o],o++;return c!==o&&i.push(t.slice(c,o)),i},o=function(t,o,a){a||(a={});var s,c,l,u,h,f,d=[],p=[d],m=a.textIndent||0,g=0,w=0,y=t.split(" "),v=e(" ",a)[0];if(f=-1===a.lineIndent?y[0].length+2:a.lineIndent||0){var b=Array(f).join(" "),x=[];y.map(function(t){(t=t.split(/\s*\n/)).length>1?x=x.concat(t.map(function(t,e){return(e&&t.length?"\n":"")+t})):x.push(t[0])}),y=x,f=r(b,a)}for(l=0,u=y.length;l<u;l++){var k=0;if(s=y[l],f&&"\n"==s[0]&&(s=s.substr(1),k=1),c=e(s,a),w=n(c),m+g+w>o||k){if(w>o){for(h=i(s,c,o-(m+g),o),d.push(h.shift()),d=[h.pop()];h.length;)p.push([h.shift()]);w=n(c.slice(s.length-d[0].length))}else d=[s];p.push(d),m=w+f,g=v}else d.push(s),m+=g+w,g=v}if(f)_=function(t,e){return(e?b:"")+t.join(" ")};else var _=function(t){return t.join(" ")};return p.map(_)};t.splitTextToSize=function(t,e,n){n||(n={});var r,i=n.fontSize||this.internal.getFontSize(),a=function(t){var e={0:1},n={};if(t.widths&&t.kerning)return{widths:t.widths,kerning:t.kerning};var r=this.internal.getFont(t.fontName,t.fontStyle);return r.metadata.Unicode?{widths:r.metadata.Unicode.widths||e,kerning:r.metadata.Unicode.kerning||n}:{widths:e,kerning:n}}.call(this,n);r=Array.isArray(t)?t:t.split(/\r?\n/);var s=1*this.internal.scaleFactor*e/i;a.textIndent=n.textIndent?1*n.textIndent*this.internal.scaleFactor/i:0,a.lineIndent=n.lineIndent;var c,l,u=[];for(c=0,l=r.length;c<l;c++)u=u.concat(o(r[c],s,a));return u}}(e.API),/** @preserve 
	jsPDF standard_fonts_metrics plugin
	Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
	MIT license.
	*/
	function(t){var e=function(t){for(var e={},n=0;n<"klmnopqrstuvwxyz".length;n++)e["klmnopqrstuvwxyz"[n]]="0123456789abcdef"[n];var r,i,o,a,s={},c=1,l=s,u=[],h="",f="",d=t.length-1;for(n=1;n!=d;)a=t[n],n+=1,"'"==a?r?(o=r.join(""),r=void 0):r=[]:r?r.push(a):"{"==a?(u.push([l,o]),l={},o=void 0):"}"==a?((i=u.pop())[0][i[1]]=l,o=void 0,l=i[0]):"-"==a?c=-1:void 0===o?e.hasOwnProperty(a)?(h+=e[a],o=parseInt(h,16)*c,c=1,h=""):h+=a:e.hasOwnProperty(a)?(f+=e[a],l[o]=parseInt(f,16)*c,c=1,o=void 0,f=""):f+=a;return s},n={codePages:["WinAnsiEncoding"],WinAnsiEncoding:e("{19m8n201n9q201o9r201s9l201t9m201u8m201w9n201x9o201y8o202k8q202l8r202m9p202q8p20aw8k203k8t203t8v203u9v2cq8s212m9t15m8w15n9w2dw9s16k8u16l9u17s9z17x8y17y9y}")},r={Unicode:{Courier:n,"Courier-Bold":n,"Courier-BoldOblique":n,"Courier-Oblique":n,Helvetica:n,"Helvetica-Bold":n,"Helvetica-BoldOblique":n,"Helvetica-Oblique":n,"Times-Roman":n,"Times-Bold":n,"Times-BoldItalic":n,"Times-Italic":n}},i={Unicode:{"Courier-Oblique":e("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),"Times-BoldItalic":e("{'widths'{k3o2q4ycx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2r202m2n2n3m2o3m2p5n202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5n4l4m4m4m4n4m4o4s4p4m4q4m4r4s4s4y4t2r4u3m4v4m4w3x4x5t4y4s4z4s5k3x5l4s5m4m5n3r5o3x5p4s5q4m5r5t5s4m5t3x5u3x5v2l5w1w5x2l5y3t5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q2l6r3m6s3r6t1w6u1w6v3m6w1w6x4y6y3r6z3m7k3m7l3m7m2r7n2r7o1w7p3r7q2w7r4m7s3m7t2w7u2r7v2n7w1q7x2n7y3t202l3mcl4mal2ram3man3mao3map3mar3mas2lat4uau1uav3maw3way4uaz2lbk2sbl3t'fof'6obo2lbp3tbq3mbr1tbs2lbu1ybv3mbz3mck4m202k3mcm4mcn4mco4mcp4mcq5ycr4mcs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz2w203k6o212m6o2dw2l2cq2l3t3m3u2l17s3x19m3m}'kerning'{cl{4qu5kt5qt5rs17ss5ts}201s{201ss}201t{cks4lscmscnscoscpscls2wu2yu201ts}201x{2wu2yu}2k{201ts}2w{4qx5kx5ou5qx5rs17su5tu}2x{17su5tu5ou}2y{4qx5kx5ou5qx5rs17ss5ts}'fof'-6ofn{17sw5tw5ou5qw5rs}7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qs}3v{17su5tu5os5qs}7p{17su5tu}ck{4qu5kt5qt5rs17ss5ts}4l{4qu5kt5qt5rs17ss5ts}cm{4qu5kt5qt5rs17ss5ts}cn{4qu5kt5qt5rs17ss5ts}co{4qu5kt5qt5rs17ss5ts}cp{4qu5kt5qt5rs17ss5ts}6l{4qu5ou5qw5rt17su5tu}5q{ckuclucmucnucoucpu4lu}5r{ckuclucmucnucoucpu4lu}7q{cksclscmscnscoscps4ls}6p{4qu5ou5qw5rt17sw5tw}ek{4qu5ou5qw5rt17su5tu}el{4qu5ou5qw5rt17su5tu}em{4qu5ou5qw5rt17su5tu}en{4qu5ou5qw5rt17su5tu}eo{4qu5ou5qw5rt17su5tu}ep{4qu5ou5qw5rt17su5tu}es{17ss5ts5qs4qu}et{4qu5ou5qw5rt17sw5tw}eu{4qu5ou5qw5rt17ss5ts}ev{17ss5ts5qs4qu}6z{17sw5tw5ou5qw5rs}fm{17sw5tw5ou5qw5rs}7n{201ts}fo{17sw5tw5ou5qw5rs}fp{17sw5tw5ou5qw5rs}fq{17sw5tw5ou5qw5rs}7r{cksclscmscnscoscps4ls}fs{17sw5tw5ou5qw5rs}ft{17su5tu}fu{17su5tu}fv{17su5tu}fw{17su5tu}fz{cksclscmscnscoscps4ls}}}"),"Helvetica-Bold":e("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"),Courier:e("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),"Courier-BoldOblique":e("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),"Times-Bold":e("{'widths'{k3q2q5ncx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2l202m2n2n3m2o3m2p6o202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5x4l4s4m4m4n4s4o4s4p4m4q3x4r4y4s4y4t2r4u3m4v4y4w4m4x5y4y4s4z4y5k3x5l4y5m4s5n3r5o4m5p4s5q4s5r6o5s4s5t4s5u4m5v2l5w1w5x2l5y3u5z3m6k2l6l3m6m3r6n2w6o3r6p2w6q2l6r3m6s3r6t1w6u2l6v3r6w1w6x5n6y3r6z3m7k3r7l3r7m2w7n2r7o2l7p3r7q3m7r4s7s3m7t3m7u2w7v2r7w1q7x2r7y3o202l3mcl4sal2lam3man3mao3map3mar3mas2lat4uau1yav3maw3tay4uaz2lbk2sbl3t'fof'6obo2lbp3rbr1tbs2lbu2lbv3mbz3mck4s202k3mcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3rek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3m3u2l17s4s19m3m}'kerning'{cl{4qt5ks5ot5qy5rw17sv5tv}201t{cks4lscmscnscoscpscls4wv}2k{201ts}2w{4qu5ku7mu5os5qx5ru17su5tu}2x{17su5tu5ou5qs}2y{4qv5kv7mu5ot5qz5ru17su5tu}'fof'-6o7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qu}3v{17su5tu5os5qu}fu{17su5tu5ou5qu}7p{17su5tu5ou5qu}ck{4qt5ks5ot5qy5rw17sv5tv}4l{4qt5ks5ot5qy5rw17sv5tv}cm{4qt5ks5ot5qy5rw17sv5tv}cn{4qt5ks5ot5qy5rw17sv5tv}co{4qt5ks5ot5qy5rw17sv5tv}cp{4qt5ks5ot5qy5rw17sv5tv}6l{17st5tt5ou5qu}17s{ckuclucmucnucoucpu4lu4wu}5o{ckuclucmucnucoucpu4lu4wu}5q{ckzclzcmzcnzcozcpz4lz4wu}5r{ckxclxcmxcnxcoxcpx4lx4wu}5t{ckuclucmucnucoucpu4lu4wu}7q{ckuclucmucnucoucpu4lu}6p{17sw5tw5ou5qu}ek{17st5tt5qu}el{17st5tt5ou5qu}em{17st5tt5qu}en{17st5tt5qu}eo{17st5tt5qu}ep{17st5tt5ou5qu}es{17ss5ts5qu}et{17sw5tw5ou5qu}eu{17sw5tw5ou5qu}ev{17ss5ts5qu}6z{17sw5tw5ou5qu5rs}fm{17sw5tw5ou5qu5rs}fn{17sw5tw5ou5qu5rs}fo{17sw5tw5ou5qu5rs}fp{17sw5tw5ou5qu5rs}fq{17sw5tw5ou5qu5rs}7r{cktcltcmtcntcotcpt4lt5os}fs{17sw5tw5ou5qu5rs}ft{17su5tu5ou5qu}7m{5os}fv{17su5tu5ou5qu}fw{17su5tu5ou5qu}fz{cksclscmscnscoscps4ls}}}"),Helvetica:e("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}"),"Helvetica-BoldOblique":e("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"),"Courier-Bold":e("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),"Times-Italic":e("{'widths'{k3n2q4ycx2l201n3m201o5t201s2l201t2l201u2l201w3r201x3r201y3r2k1t2l2l202m2n2n3m2o3m2p5n202q5t2r1p2s2l2t2l2u3m2v4n2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w4n3x4n3y4n3z3m4k5w4l3x4m3x4n4m4o4s4p3x4q3x4r4s4s4s4t2l4u2w4v4m4w3r4x5n4y4m4z4s5k3x5l4s5m3x5n3m5o3r5p4s5q3x5r5n5s3x5t3r5u3r5v2r5w1w5x2r5y2u5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q1w6r3m6s3m6t1w6u1w6v2w6w1w6x4s6y3m6z3m7k3m7l3m7m2r7n2r7o1w7p3m7q2w7r4m7s2w7t2w7u2r7v2s7w1v7x2s7y3q202l3mcl3xal2ram3man3mao3map3mar3mas2lat4wau1vav3maw4nay4waz2lbk2sbl4n'fof'6obo2lbp3mbq3obr1tbs2lbu1zbv3mbz3mck3x202k3mcm3xcn3xco3xcp3xcq5tcr4mcs3xct3xcu3xcv3xcw2l2m2ucy2lcz2ldl4mdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr4nfs3mft3mfu3mfv3mfw3mfz2w203k6o212m6m2dw2l2cq2l3t3m3u2l17s3r19m3m}'kerning'{cl{5kt4qw}201s{201sw}201t{201tw2wy2yy6q-t}201x{2wy2yy}2k{201tw}2w{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}2x{17ss5ts5os}2y{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}'fof'-6o6t{17ss5ts5qs}7t{5os}3v{5qs}7p{17su5tu5qs}ck{5kt4qw}4l{5kt4qw}cm{5kt4qw}cn{5kt4qw}co{5kt4qw}cp{5kt4qw}6l{4qs5ks5ou5qw5ru17su5tu}17s{2ks}5q{ckvclvcmvcnvcovcpv4lv}5r{ckuclucmucnucoucpu4lu}5t{2ks}6p{4qs5ks5ou5qw5ru17su5tu}ek{4qs5ks5ou5qw5ru17su5tu}el{4qs5ks5ou5qw5ru17su5tu}em{4qs5ks5ou5qw5ru17su5tu}en{4qs5ks5ou5qw5ru17su5tu}eo{4qs5ks5ou5qw5ru17su5tu}ep{4qs5ks5ou5qw5ru17su5tu}es{5ks5qs4qs}et{4qs5ks5ou5qw5ru17su5tu}eu{4qs5ks5qw5ru17su5tu}ev{5ks5qs4qs}ex{17ss5ts5qs}6z{4qv5ks5ou5qw5ru17su5tu}fm{4qv5ks5ou5qw5ru17su5tu}fn{4qv5ks5ou5qw5ru17su5tu}fo{4qv5ks5ou5qw5ru17su5tu}fp{4qv5ks5ou5qw5ru17su5tu}fq{4qv5ks5ou5qw5ru17su5tu}7r{5os}fs{4qv5ks5ou5qw5ru17su5tu}ft{17su5tu5qs}fu{17su5tu5qs}fv{17su5tu5qs}fw{17su5tu5qs}}}"),"Times-Roman":e("{'widths'{k3n2q4ycx2l201n3m201o6o201s2l201t2l201u2l201w2w201x2w201y2w2k1t2l2l202m2n2n3m2o3m2p5n202q6o2r1m2s2l2t2l2u3m2v3s2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v1w3w3s3x3s3y3s3z2w4k5w4l4s4m4m4n4m4o4s4p3x4q3r4r4s4s4s4t2l4u2r4v4s4w3x4x5t4y4s4z4s5k3r5l4s5m4m5n3r5o3x5p4s5q4s5r5y5s4s5t4s5u3x5v2l5w1w5x2l5y2z5z3m6k2l6l2w6m3m6n2w6o3m6p2w6q2l6r3m6s3m6t1w6u1w6v3m6w1w6x4y6y3m6z3m7k3m7l3m7m2l7n2r7o1w7p3m7q3m7r4s7s3m7t3m7u2w7v3k7w1o7x3k7y3q202l3mcl4sal2lam3man3mao3map3mar3mas2lat4wau1vav3maw3say4waz2lbk2sbl3s'fof'6obo2lbp3mbq2xbr1tbs2lbu1zbv3mbz2wck4s202k3mcm4scn4sco4scp4scq5tcr4mcs3xct3xcu3xcv3xcw2l2m2tcy2lcz2ldl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek2wel2wem2wen2weo2wep2weq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr3sfs3mft3mfu3mfv3mfw3mfz3m203k6o212m6m2dw2l2cq2l3t3m3u1w17s4s19m3m}'kerning'{cl{4qs5ku17sw5ou5qy5rw201ss5tw201ws}201s{201ss}201t{ckw4lwcmwcnwcowcpwclw4wu201ts}2k{201ts}2w{4qs5kw5os5qx5ru17sx5tx}2x{17sw5tw5ou5qu}2y{4qs5kw5os5qx5ru17sx5tx}'fof'-6o7t{ckuclucmucnucoucpu4lu5os5rs}3u{17su5tu5qs}3v{17su5tu5qs}7p{17sw5tw5qs}ck{4qs5ku17sw5ou5qy5rw201ss5tw201ws}4l{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cm{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cn{4qs5ku17sw5ou5qy5rw201ss5tw201ws}co{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cp{4qs5ku17sw5ou5qy5rw201ss5tw201ws}6l{17su5tu5os5qw5rs}17s{2ktclvcmvcnvcovcpv4lv4wuckv}5o{ckwclwcmwcnwcowcpw4lw4wu}5q{ckyclycmycnycoycpy4ly4wu5ms}5r{cktcltcmtcntcotcpt4lt4ws}5t{2ktclvcmvcnvcovcpv4lv4wuckv}7q{cksclscmscnscoscps4ls}6p{17su5tu5qw5rs}ek{5qs5rs}el{17su5tu5os5qw5rs}em{17su5tu5os5qs5rs}en{17su5qs5rs}eo{5qs5rs}ep{17su5tu5os5qw5rs}es{5qs}et{17su5tu5qw5rs}eu{17su5tu5qs5rs}ev{5qs}6z{17sv5tv5os5qx5rs}fm{5os5qt5rs}fn{17sv5tv5os5qx5rs}fo{17sv5tv5os5qx5rs}fp{5os5qt5rs}fq{5os5qt5rs}7r{ckuclucmucnucoucpu4lu5os}fs{17sv5tv5os5qx5rs}ft{17ss5ts5qs}fu{17sw5tw5qs}fv{17sw5tw5qs}fw{17ss5ts5qs}fz{ckuclucmucnucoucpu4lu5os5rs}}}"),"Helvetica-Oblique":e("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}")}};t.events.push(["addFont",function(t){var e,n,o;(e=i.Unicode[t.PostScriptName])&&((n=t.metadata.Unicode?t.metadata.Unicode:t.metadata.Unicode={}).widths=e.widths,n.kerning=e.kerning),(o=r.Unicode[t.PostScriptName])&&((n=t.metadata.Unicode?t.metadata.Unicode:t.metadata.Unicode={}).encoding=o,o.codePages&&o.codePages.length&&(t.encoding=o.codePages[0]))}])}(e.API),e.API.addSVG=function(t,e,n,r,i){function o(t,e){var n=e.createElement("style");n.type="text/css",n.styleSheet?n.styleSheet.cssText=t:n.appendChild(e.createTextNode(t)),e.getElementsByTagName("head")[0].appendChild(n)}if(void 0===e||void 0===n)throw new Error("addSVG needs values for 'x' and 'y'");var a=function(t,e){var n=(e.contentWindow||e.contentDocument).document;return n.write(t),n.close(),n.getElementsByTagName("svg")[0]}(t,function(t){var e=t.createElement("iframe");return o(".jsPDF_sillysvg_iframe {display:none;position:absolute;}",t),e.name="childframe",e.setAttribute("width",0),e.setAttribute("height",0),e.setAttribute("frameborder","0"),e.setAttribute("scrolling","no"),e.setAttribute("seamless","seamless"),e.setAttribute("class","jsPDF_sillysvg_iframe"),t.body.appendChild(e),e}(document)),s=[1,1],c=parseFloat(a.getAttribute("width")),l=parseFloat(a.getAttribute("height"));c&&l&&(r&&i?s=[r/c,i/l]:r?s=[r/c,r/c]:i&&(s=[i/l,i/l]));var u,h,f,d,p=a.childNodes;for(u=0,h=p.length;u<h;u++)(f=p[u]).tagName&&"PATH"===f.tagName.toUpperCase()&&((d=function(t){for(var e=parseFloat(t[1]),n=parseFloat(t[2]),r=[],i=3,o=t.length;i<o;)"c"===t[i]?(r.push([parseFloat(t[i+1]),parseFloat(t[i+2]),parseFloat(t[i+3]),parseFloat(t[i+4]),parseFloat(t[i+5]),parseFloat(t[i+6])]),i+=7):"l"===t[i]?(r.push([parseFloat(t[i+1]),parseFloat(t[i+2])]),i+=3):i+=1;return[e,n,r]}(f.getAttribute("d").split(" ")))[0]=d[0]*s[0]+e,d[1]=d[1]*s[1]+n,this.lines.call(this,d[2],d[0],d[1],s));return this},e.API.putTotalPages=function(t){for(var e=new RegExp(t,"g"),n=1;n<=this.internal.getNumberOfPages();n++)for(var r=0;r<this.internal.pages[n].length;r++)this.internal.pages[n][r]=this.internal.pages[n][r].replace(e,this.internal.getNumberOfPages());return this},/** ==================================================================== 
	 * jsPDF XMP metadata plugin
	 * Copyright (c) 2016 Jussi Utunen, u-jussi@suomi24.fi
	 * 
	 * 
	 * ====================================================================
	 */
	function(t){var n="",r="",i="";e.API.addMetadata=function(t,e){return r=e||"http://jspdf.default.namespaceuri/",n=t,this.internal.events.subscribe("postPutResources",function(){if(n){var t='<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"><rdf:Description rdf:about="" xmlns:jspdf="'+r+'"><jspdf:metadata>',e=unescape(encodeURIComponent('<x:xmpmeta xmlns:x="adobe:ns:meta/">')),o=unescape(encodeURIComponent(t)),a=unescape(encodeURIComponent(n)),s=unescape(encodeURIComponent("</jspdf:metadata></rdf:Description></rdf:RDF>")),c=unescape(encodeURIComponent("</x:xmpmeta>")),l=o.length+a.length+s.length+e.length+c.length;i=this.internal.newObject(),this.internal.write("<< /Type /Metadata /Subtype /XML /Length "+l+" >>"),this.internal.write("stream"),this.internal.write(e+o+a+s+c),this.internal.write("endstream"),this.internal.write("endobj")}else i=""}),this.internal.events.subscribe("putCatalog",function(){i&&this.internal.write("/Metadata "+i+" 0 R")}),this}}(),function(t){if(t.URL=t.URL||t.webkitURL,t.Blob&&t.URL)try{return void new Blob}catch(t){}var e=t.BlobBuilder||t.WebKitBlobBuilder||t.MozBlobBuilder||function(t){var e=function(t){return Object.prototype.toString.call(t).match(/^\[object\s(.*)\]$/)[1]},n=function(){this.data=[]},r=function(t,e,n){this.data=t,this.size=t.length,this.type=e,this.encoding=n},i=n.prototype,o=r.prototype,a=t.FileReaderSync,s=function(t){this.code=this[this.name=t]},c="NOT_FOUND_ERR SECURITY_ERR ABORT_ERR NOT_READABLE_ERR ENCODING_ERR NO_MODIFICATION_ALLOWED_ERR INVALID_STATE_ERR SYNTAX_ERR".split(" "),l=c.length,u=t.URL||t.webkitURL||t,h=u.createObjectURL,f=u.revokeObjectURL,d=u,p=t.btoa,m=t.atob,g=t.ArrayBuffer,w=t.Uint8Array,y=/^[\w-]+:\/*\[?[\w\.:-]+\]?(?::[0-9]+)?/;for(r.fake=o.fake=!0;l--;)s.prototype[c[l]]=l+1;return u.createObjectURL||(d=t.URL=function(t){var e,n=document.createElementNS("http://www.w3.org/1999/xhtml","a");return n.href=t,"origin"in n||("data:"===n.protocol.toLowerCase()?n.origin=null:(e=t.match(y),n.origin=e&&e[1])),n}),d.createObjectURL=function(t){var e,n=t.type;return null===n&&(n="application/octet-stream"),t instanceof r?(e="data:"+n,"base64"===t.encoding?e+";base64,"+t.data:"URI"===t.encoding?e+","+decodeURIComponent(t.data):p?e+";base64,"+p(t.data):e+","+encodeURIComponent(t.data)):h?h.call(u,t):void 0},d.revokeObjectURL=function(t){"data:"!==t.substring(0,5)&&f&&f.call(u,t)},i.append=function(t){var n=this.data;if(w&&(t instanceof g||t instanceof w)){for(var i="",o=new w(t),c=0,l=o.length;c<l;c++)i+=String.fromCharCode(o[c]);n.push(i)}else if("Blob"===e(t)||"File"===e(t)){if(!a)throw new s("NOT_READABLE_ERR");var u=new a;n.push(u.readAsBinaryString(t))}else t instanceof r?"base64"===t.encoding&&m?n.push(m(t.data)):"URI"===t.encoding?n.push(decodeURIComponent(t.data)):"raw"===t.encoding&&n.push(t.data):("string"!=typeof t&&(t+=""),n.push(unescape(encodeURIComponent(t))))},i.getBlob=function(t){return arguments.length||(t=null),new r(this.data.join(""),t,"raw")},i.toString=function(){return"[object BlobBuilder]"},o.slice=function(t,e,n){var i=arguments.length;return i<3&&(n=null),new r(this.data.slice(t,i>1?e:this.data.length),n,this.encoding)},o.toString=function(){return"[object Blob]"},o.close=function(){this.size=0,delete this.data},n}(t);t.Blob=function(t,n){var r=n?n.type||"":"",i=new e;if(t)for(var o=0,a=t.length;o<a;o++)Uint8Array&&t[o]instanceof Uint8Array?i.append(t[o].buffer):i.append(t[o]);var s=i.getBlob(r);return!s.slice&&s.webkitSlice&&(s.slice=s.webkitSlice),s};var n=Object.getPrototypeOf||function(t){return t.__proto__};t.Blob.prototype=n(new t.Blob)}("undefined"!=typeof self&&self||"undefined"!=typeof window&&window||(void 0).content||void 0);var r=r||function(t){if(!(void 0===t||"undefined"!=typeof navigator&&/MSIE [1-9]\./.test(navigator.userAgent))){var e=function(){return t.URL||t.webkitURL||t},n=t.document.createElementNS("http://www.w3.org/1999/xhtml","a"),r="download"in n,i=function(t){var e=new MouseEvent("click");t.dispatchEvent(e)},o=/constructor/i.test(t.HTMLElement)||t.safari,a=/CriOS\/[\d]+/.test(navigator.userAgent),s=function(e){(t.setImmediate||t.setTimeout)(function(){throw e},0)},c=function(t){setTimeout(function(){"string"==typeof t?e().revokeObjectURL(t):t.remove()},4e4)},l=function(t,e,n){for(var r=(e=[].concat(e)).length;r--;){var i=t["on"+e[r]];if("function"==typeof i)try{i.call(t,n||t)}catch(t){s(t)}}},u=function(t){return/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(t.type)?new Blob([String.fromCharCode(65279),t],{type:t.type}):t},h=function(s,h,f){f||(s=u(s));var d,p=this,m="application/octet-stream"===s.type,g=function(){l(p,"writestart progress write writeend".split(" "))};if(p.readyState=p.INIT,r)return d=e().createObjectURL(s),void setTimeout(function(){n.href=d,n.download=h,i(n),g(),c(d),p.readyState=p.DONE});!function(){if((a||m&&o)&&t.FileReader){var n=new FileReader;return n.onloadend=function(){var e=a?n.result:n.result.replace(/^data:[^;]*;/,"data:attachment/file;");t.open(e,"_blank")||(t.location.href=e),e=void 0,p.readyState=p.DONE,g()},n.readAsDataURL(s),void(p.readyState=p.INIT)}d||(d=e().createObjectURL(s)),m?t.location.href=d:t.open(d,"_blank")||(t.location.href=d),p.readyState=p.DONE,g(),c(d)}()},f=h.prototype;return"undefined"!=typeof navigator&&navigator.msSaveOrOpenBlob?function(t,e,n){return e=e||t.name||"download",n||(t=u(t)),navigator.msSaveOrOpenBlob(t,e)}:(f.abort=function(){},f.readyState=f.INIT=0,f.WRITING=1,f.DONE=2,f.error=f.onwritestart=f.onprogress=f.onwrite=f.onabort=f.onerror=f.onwriteend=null,function(t,e,n){return new h(t,e||t.name||"download",n)})}}("undefined"!=typeof self&&self||"undefined"!=typeof window&&window||(void 0).content);"undefined"!=typeof module&&module.exports?module.exports.saveAs=r:"undefined"!="function"&&null!==__webpack_require__(65)&&null!==__webpack_require__(66)&&!(__WEBPACK_AMD_DEFINE_RESULT__ = (function(){return r}).call(exports, __webpack_require__, exports, module),
					__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)),function(t,e){ true?module.exports=e():"function"==typeof define?define(e):t.adler32cs=e()}(e,function(){var t="function"==typeof ArrayBuffer&&"function"==typeof Uint8Array,e=null,n=function(){if(!t)return function(){return!1};try{var n={};"function"==typeof n.Buffer&&(e=n.Buffer)}catch(t){}return function(t){return t instanceof ArrayBuffer||null!==e&&t instanceof e}}(),r=null!==e?function(t){return new e(t,"utf8").toString("binary")}:function(t){return unescape(encodeURIComponent(t))},i=function(t,e){for(var n=65535&t,r=t>>>16,i=0,o=e.length;i<o;i++)r=(r+(n=(n+(255&e.charCodeAt(i)))%65521))%65521;return(r<<16|n)>>>0},o=function(t,e){for(var n=65535&t,r=t>>>16,i=0,o=e.length;i<o;i++)r=(r+(n=(n+e[i])%65521))%65521;return(r<<16|n)>>>0},a={},s=a.Adler32=function(){var e=function(t){if(!(this instanceof e))throw new TypeError("Constructor cannot called be as a function.");if(!isFinite(t=null==t?1:+t))throw new Error("First arguments needs to be a finite number.");this.checksum=t>>>0},a=e.prototype={};return a.constructor=e,e.from=function(t){return t.prototype=a,t}(function(t){if(!(this instanceof e))throw new TypeError("Constructor cannot called be as a function.");if(null==t)throw new Error("First argument needs to be a string.");this.checksum=i(1,t.toString())}),e.fromUtf8=function(t){return t.prototype=a,t}(function(t){if(!(this instanceof e))throw new TypeError("Constructor cannot called be as a function.");if(null==t)throw new Error("First argument needs to be a string.");var n=r(t.toString());this.checksum=i(1,n)}),t&&(e.fromBuffer=function(t){return t.prototype=a,t}(function(t){if(!(this instanceof e))throw new TypeError("Constructor cannot called be as a function.");if(!n(t))throw new Error("First argument needs to be ArrayBuffer.");var r=new Uint8Array(t);return this.checksum=o(1,r)})),a.update=function(t){if(null==t)throw new Error("First argument needs to be a string.");return t=t.toString(),this.checksum=i(this.checksum,t)},a.updateUtf8=function(t){if(null==t)throw new Error("First argument needs to be a string.");var e=r(t.toString());return this.checksum=i(this.checksum,e)},t&&(a.updateBuffer=function(t){if(!n(t))throw new Error("First argument needs to be ArrayBuffer.");var e=new Uint8Array(t);return this.checksum=o(this.checksum,e)}),a.clone=function(){return new s(this.checksum)},e}();return a.from=function(t){if(null==t)throw new Error("First argument needs to be a string.");return i(1,t.toString())},a.fromUtf8=function(t){if(null==t)throw new Error("First argument needs to be a string.");var e=r(t.toString());return i(1,e)},t&&(a.fromBuffer=function(t){if(!n(t))throw new Error("First argument need to be ArrayBuffer.");var e=new Uint8Array(t);return o(1,e)}),a});/**
	 * CssColors
	 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
	 *
	 * Licensed under the MIT License.
	 * http://opensource.org/licenses/mit-license
	 */
	var i={};i._colorsTable={aliceblue:"#f0f8ff",antiquewhite:"#faebd7",aqua:"#00ffff",aquamarine:"#7fffd4",azure:"#f0ffff",beige:"#f5f5dc",bisque:"#ffe4c4",black:"#000000",blanchedalmond:"#ffebcd",blue:"#0000ff",blueviolet:"#8a2be2",brown:"#a52a2a",burlywood:"#deb887",cadetblue:"#5f9ea0",chartreuse:"#7fff00",chocolate:"#d2691e",coral:"#ff7f50",cornflowerblue:"#6495ed",cornsilk:"#fff8dc",crimson:"#dc143c",cyan:"#00ffff",darkblue:"#00008b",darkcyan:"#008b8b",darkgoldenrod:"#b8860b",darkgray:"#a9a9a9",darkgreen:"#006400",darkkhaki:"#bdb76b",darkmagenta:"#8b008b",darkolivegreen:"#556b2f",darkorange:"#ff8c00",darkorchid:"#9932cc",darkred:"#8b0000",darksalmon:"#e9967a",darkseagreen:"#8fbc8f",darkslateblue:"#483d8b",darkslategray:"#2f4f4f",darkturquoise:"#00ced1",darkviolet:"#9400d3",deeppink:"#ff1493",deepskyblue:"#00bfff",dimgray:"#696969",dodgerblue:"#1e90ff",firebrick:"#b22222",floralwhite:"#fffaf0",forestgreen:"#228b22",fuchsia:"#ff00ff",gainsboro:"#dcdcdc",ghostwhite:"#f8f8ff",gold:"#ffd700",goldenrod:"#daa520",gray:"#808080",green:"#008000",greenyellow:"#adff2f",honeydew:"#f0fff0",hotpink:"#ff69b4","indianred ":"#cd5c5c",indigo:"#4b0082",ivory:"#fffff0",khaki:"#f0e68c",lavender:"#e6e6fa",lavenderblush:"#fff0f5",lawngreen:"#7cfc00",lemonchiffon:"#fffacd",lightblue:"#add8e6",lightcoral:"#f08080",lightcyan:"#e0ffff",lightgoldenrodyellow:"#fafad2",lightgrey:"#d3d3d3",lightgreen:"#90ee90",lightpink:"#ffb6c1",lightsalmon:"#ffa07a",lightseagreen:"#20b2aa",lightskyblue:"#87cefa",lightslategray:"#778899",lightsteelblue:"#b0c4de",lightyellow:"#ffffe0",lime:"#00ff00",limegreen:"#32cd32",linen:"#faf0e6",magenta:"#ff00ff",maroon:"#800000",mediumaquamarine:"#66cdaa",mediumblue:"#0000cd",mediumorchid:"#ba55d3",mediumpurple:"#9370d8",mediumseagreen:"#3cb371",mediumslateblue:"#7b68ee",mediumspringgreen:"#00fa9a",mediumturquoise:"#48d1cc",mediumvioletred:"#c71585",midnightblue:"#191970",mintcream:"#f5fffa",mistyrose:"#ffe4e1",moccasin:"#ffe4b5",navajowhite:"#ffdead",navy:"#000080",oldlace:"#fdf5e6",olive:"#808000",olivedrab:"#6b8e23",orange:"#ffa500",orangered:"#ff4500",orchid:"#da70d6",palegoldenrod:"#eee8aa",palegreen:"#98fb98",paleturquoise:"#afeeee",palevioletred:"#d87093",papayawhip:"#ffefd5",peachpuff:"#ffdab9",peru:"#cd853f",pink:"#ffc0cb",plum:"#dda0dd",powderblue:"#b0e0e6",purple:"#800080",red:"#ff0000",rosybrown:"#bc8f8f",royalblue:"#4169e1",saddlebrown:"#8b4513",salmon:"#fa8072",sandybrown:"#f4a460",seagreen:"#2e8b57",seashell:"#fff5ee",sienna:"#a0522d",silver:"#c0c0c0",skyblue:"#87ceeb",slateblue:"#6a5acd",slategray:"#708090",snow:"#fffafa",springgreen:"#00ff7f",steelblue:"#4682b4",tan:"#d2b48c",teal:"#008080",thistle:"#d8bfd8",tomato:"#ff6347",turquoise:"#40e0d0",violet:"#ee82ee",wheat:"#f5deb3",white:"#ffffff",whitesmoke:"#f5f5f5",yellow:"#ffff00",yellowgreen:"#9acd32"},i.colorNameToHex=function(t){return t=t.toLowerCase(),void 0!==this._colorsTable[t]&&this._colorsTable[t]};/*
	 Deflate.js - https://github.com/gildas-lormeau/zip.js
	 Copyright (c) 2013 Gildas Lormeau. All rights reserved.
	
	 Redistribution and use in source and binary forms, with or without
	 modification, are permitted provided that the following conditions are met:
	
	 1. Redistributions of source code must retain the above copyright notice,
	 this list of conditions and the following disclaimer.
	
	 2. Redistributions in binary form must reproduce the above copyright 
	 notice, this list of conditions and the following disclaimer in 
	 the documentation and/or other materials provided with the distribution.
	
	 3. The names of the authors may not be used to endorse or promote products
	 derived from this software without specific prior written permission.
	
	 THIS SOFTWARE IS PROVIDED ``AS IS'' AND ANY EXPRESSED OR IMPLIED WARRANTIES,
	 INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
	 FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL JCRAFT,
	 INC. OR ANY CONTRIBUTORS TO THIS SOFTWARE BE LIABLE FOR ANY DIRECT, INDIRECT,
	 INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
	 LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA,
	 OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
	 LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	 NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
	 EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 */
	var o=function(t){function e(){function t(t){var e,n,i,o,a,c,l=r.dyn_tree,u=r.stat_desc.static_tree,h=r.stat_desc.extra_bits,d=r.stat_desc.extra_base,p=r.stat_desc.max_length,m=0;for(o=0;o<=s;o++)t.bl_count[o]=0;for(l[2*t.heap[t.heap_max]+1]=0,e=t.heap_max+1;e<f;e++)(o=l[2*l[2*(n=t.heap[e])+1]+1]+1)>p&&(o=p,m++),l[2*n+1]=o,n>r.max_code||(t.bl_count[o]++,a=0,n>=d&&(a=h[n-d]),c=l[2*n],t.opt_len+=c*(o+a),u&&(t.static_len+=c*(u[2*n+1]+a)));if(0!==m){do{for(o=p-1;0===t.bl_count[o];)o--;t.bl_count[o]--,t.bl_count[o+1]+=2,t.bl_count[p]--,m-=2}while(m>0);for(o=p;0!==o;o--)for(n=t.bl_count[o];0!==n;)(i=t.heap[--e])>r.max_code||(l[2*i+1]!=o&&(t.opt_len+=(o-l[2*i+1])*l[2*i],l[2*i+1]=o),n--)}}function e(t,e){var n=0;do{n|=1&t,t>>>=1,n<<=1}while(--e>0);return n>>>1}function n(t,n,r){var i,o,a,c=[],l=0;for(i=1;i<=s;i++)c[i]=l=l+r[i-1]<<1;for(o=0;o<=n;o++)0!==(a=t[2*o+1])&&(t[2*o]=e(c[a]++,a))}var r=this;r.build_tree=function(e){var i,o,a,s=r.dyn_tree,c=r.stat_desc.static_tree,l=r.stat_desc.elems,u=-1;for(e.heap_len=0,e.heap_max=f,i=0;i<l;i++)0!==s[2*i]?(e.heap[++e.heap_len]=u=i,e.depth[i]=0):s[2*i+1]=0;for(;e.heap_len<2;)s[2*(a=e.heap[++e.heap_len]=u<2?++u:0)]=1,e.depth[a]=0,e.opt_len--,c&&(e.static_len-=c[2*a+1]);for(r.max_code=u,i=Math.floor(e.heap_len/2);i>=1;i--)e.pqdownheap(s,i);a=l;do{i=e.heap[1],e.heap[1]=e.heap[e.heap_len--],e.pqdownheap(s,1),o=e.heap[1],e.heap[--e.heap_max]=i,e.heap[--e.heap_max]=o,s[2*a]=s[2*i]+s[2*o],e.depth[a]=Math.max(e.depth[i],e.depth[o])+1,s[2*i+1]=s[2*o+1]=a,e.heap[1]=a++,e.pqdownheap(s,1)}while(e.heap_len>=2);e.heap[--e.heap_max]=e.heap[1],t(e),n(s,r.max_code,e.bl_count)}}function n(t,e,n,r,i){var o=this;o.static_tree=t,o.extra_bits=e,o.extra_base=n,o.elems=r,o.max_length=i}function r(t,e,n,r,i){var o=this;o.good_length=t,o.max_lazy=e,o.nice_length=n,o.max_chain=r,o.func=i}function i(t,e,n,r){var i=t[2*e],o=t[2*n];return i<o||i==o&&r[e]<=r[n]}function o(){function t(){var t;for(Pt=2*At,Et[Ft-1]=0,t=0;t<Ft-1;t++)Et[t]=0;Vt=z[Gt].max_lazy,Jt=z[Gt].good_length,Qt=z[Gt].nice_length,Xt=z[Gt].max_chain,Mt=0,jt=0,Ht=0,zt=Wt=$-1,Lt=0,Ot=0}function r(){var t;for(t=0;t<h;t++)Kt[2*t]=0;for(t=0;t<c;t++)$t[2*t]=0;for(t=0;t<l;t++)Zt[2*t]=0;Kt[2*d]=1,te.opt_len=te.static_len=0,ae=ce=0}function o(){ee.dyn_tree=Kt,ee.stat_desc=n.static_l_desc,ne.dyn_tree=$t,ne.stat_desc=n.static_d_desc,re.dyn_tree=Zt,re.stat_desc=n.static_bl_desc,ue=0,he=0,le=8,r()}function a(t,e){var n,r,i=-1,o=t[1],a=0,s=7,c=4;for(0===o&&(s=138,c=3),t[2*(e+1)+1]=65535,n=0;n<=e;n++)r=o,o=t[2*(n+1)+1],++a<s&&r==o||(a<c?Zt[2*r]+=a:0!==r?(r!=i&&Zt[2*r]++,Zt[2*p]++):a<=10?Zt[2*m]++:Zt[2*g]++,a=0,i=r,0===o?(s=138,c=3):r==o?(s=6,c=3):(s=7,c=4))}function s(){var t;for(a(Kt,ee.max_code),a($t,ne.max_code),re.build_tree(te),t=l-1;t>=3&&0===Zt[2*e.bl_order[t]+1];t--);return te.opt_len+=3*(t+1)+5+5+4,t}function f(t){te.pending_buf[te.pending++]=t}function O(t){f(255&t),f(t>>>8&255)}function et(t){f(t>>8&255),f(255&t)}function nt(t,e){var n,r=e;he>w-r?(O(ue|=(n=t)<<he&65535),ue=n>>>w-he,he+=r-w):(ue|=t<<he&65535,he+=r)}function rt(t,e){var n=2*t;nt(65535&e[n],65535&e[n+1])}function it(t,e){var n,r,i=-1,o=t[1],a=0,s=7,c=4;for(0===o&&(s=138,c=3),n=0;n<=e;n++)if(r=o,o=t[2*(n+1)+1],!(++a<s&&r==o)){if(a<c)do{rt(r,Zt)}while(0!=--a);else 0!==r?(r!=i&&(rt(r,Zt),a--),rt(p,Zt),nt(a-3,2)):a<=10?(rt(m,Zt),nt(a-3,3)):(rt(g,Zt),nt(a-11,7));a=0,i=r,0===o?(s=138,c=3):r==o?(s=6,c=3):(s=7,c=4)}}function ot(t,n,r){var i;for(nt(t-257,5),nt(n-1,5),nt(r-4,4),i=0;i<r;i++)nt(Zt[2*e.bl_order[i]+1],3);it(Kt,t-1),it($t,n-1)}function at(){16==he?(O(ue),ue=0,he=0):he>=8&&(f(255&ue),ue>>>=8,he-=8)}function st(){nt(Q<<1,3),rt(d,n.static_ltree),at(),1+le+10-he<9&&(nt(Q<<1,3),rt(d,n.static_ltree),at()),le=7}function ct(t,n){var r,i,o;if(te.pending_buf[se+2*ae]=t>>>8&255,te.pending_buf[se+2*ae+1]=255&t,te.pending_buf[ie+ae]=255&n,ae++,0===t?Kt[2*n]++:(ce++,t--,Kt[2*(e._length_code[n]+u+1)]++,$t[2*e.d_code(t)]++),0==(8191&ae)&&Gt>2){for(r=8*ae,i=Mt-jt,o=0;o<c;o++)r+=$t[2*o]*(5+e.extra_dbits[o]);if(r>>>=3,ce<Math.floor(ae/2)&&r<Math.floor(i/2))return!0}return ae==oe-1}function lt(t,n){var r,i,o,a,s=0;if(0!==ae)do{r=te.pending_buf[se+2*s]<<8&65280|255&te.pending_buf[se+2*s+1],i=255&te.pending_buf[ie+s],s++,0===r?rt(i,t):(rt((o=e._length_code[i])+u+1,t),0!==(a=e.extra_lbits[o])&&nt(i-=e.base_length[o],a),r--,rt(o=e.d_code(r),n),0!==(a=e.extra_dbits[o])&&nt(r-=e.base_dist[o],a))}while(s<ae);rt(d,t),le=t[2*d+1]}function ut(){he>8?O(ue):he>0&&f(255&ue),ue=0,he=0}function ht(t,e,n){ut(),le=8,n&&(O(e),O(~e)),te.pending_buf.set(Tt.subarray(t,t+e),te.pending),te.pending+=e}function ft(t,e,n){nt((J<<1)+(n?1:0),3),ht(t,e,!0)}function dt(t,e,i){var o,a,c=0;Gt>0?(ee.build_tree(te),ne.build_tree(te),c=s(),o=te.opt_len+3+7>>>3,(a=te.static_len+3+7>>>3)<=o&&(o=a)):o=a=e+5,e+4<=o&&-1!=t?ft(t,e,i):a==o?(nt((Q<<1)+(i?1:0),3),lt(n.static_ltree,n.static_dtree)):(nt((K<<1)+(i?1:0),3),ot(ee.max_code+1,ne.max_code+1,c+1),lt(Kt,$t)),r(),i&&ut()}function pt(t){dt(jt>=0?jt:-1,Mt-jt,t),jt=Mt,xt.flush_pending()}function mt(){var t,e,n,r;do{if(0===(r=Pt-Ht-Mt)&&0===Mt&&0===Ht)r=At;else if(-1==r)r--;else if(Mt>=At+At-tt){Tt.set(Tt.subarray(At,At+At),0),Ut-=At,Mt-=At,jt-=At,n=t=Ft;do{e=65535&Et[--n],Et[n]=e>=At?e-At:0}while(0!=--t);n=t=At;do{e=65535&It[--n],It[n]=e>=At?e-At:0}while(0!=--t);r+=At}if(0===xt.avail_in)return;t=xt.read_buf(Tt,Mt+Ht,r),(Ht+=t)>=$&&(Ot=255&Tt[Mt],Ot=(Ot<<Dt^255&Tt[Mt+1])&Rt)}while(Ht<tt&&0!==xt.avail_in)}function gt(t){var e,n=65535;for(n>_t-5&&(n=_t-5);;){if(Ht<=1){if(mt(),0===Ht&&t==k)return L;if(0===Ht)break}if(Mt+=Ht,Ht=0,e=jt+n,(0===Mt||Mt>=e)&&(Ht=Mt-e,Mt=e,pt(!1),0===xt.avail_out))return L;if(Mt-jt>=At-tt&&(pt(!1),0===xt.avail_out))return L}return pt(t==A),0===xt.avail_out?t==A?U:L:t==A?H:M}function wt(t){var e,n,r=Xt,i=Mt,o=Wt,a=Mt>At-tt?Mt-(At-tt):0,s=Qt,c=qt,l=Mt+Z,u=Tt[i+o-1],h=Tt[i+o];Wt>=Jt&&(r>>=2),s>Ht&&(s=Ht);do{if(e=t,Tt[e+o]==h&&Tt[e+o-1]==u&&Tt[e]==Tt[i]&&Tt[++e]==Tt[i+1]){i+=2,e++;do{}while(Tt[++i]==Tt[++e]&&Tt[++i]==Tt[++e]&&Tt[++i]==Tt[++e]&&Tt[++i]==Tt[++e]&&Tt[++i]==Tt[++e]&&Tt[++i]==Tt[++e]&&Tt[++i]==Tt[++e]&&Tt[++i]==Tt[++e]&&i<l);if(n=Z-(l-i),i=l-Z,n>o){if(Ut=t,o=n,n>=s)break;u=Tt[i+o-1],h=Tt[i+o]}}}while((t=65535&It[t&c])>a&&0!=--r);return o<=Ht?o:Ht}function yt(t){for(var e,n=0;;){if(Ht<tt){if(mt(),Ht<tt&&t==k)return L;if(0===Ht)break}if(Ht>=$&&(Ot=(Ot<<Dt^255&Tt[Mt+($-1)])&Rt,n=65535&Et[Ot],It[Mt&qt]=Et[Ot],Et[Ot]=Mt),0!==n&&(Mt-n&65535)<=At-tt&&Yt!=b&&(zt=wt(n)),zt>=$)if(e=ct(Mt-Ut,zt-$),Ht-=zt,zt<=Vt&&Ht>=$){zt--;do{Ot=(Ot<<Dt^255&Tt[++Mt+($-1)])&Rt,n=65535&Et[Ot],It[Mt&qt]=Et[Ot],Et[Ot]=Mt}while(0!=--zt);Mt++}else Mt+=zt,zt=0,Ot=255&Tt[Mt],Ot=(Ot<<Dt^255&Tt[Mt+1])&Rt;else e=ct(0,255&Tt[Mt]),Ht--,Mt++;if(e&&(pt(!1),0===xt.avail_out))return L}return pt(t==A),0===xt.avail_out?t==A?U:L:t==A?H:M}function vt(t){for(var e,n,r=0;;){if(Ht<tt){if(mt(),Ht<tt&&t==k)return L;if(0===Ht)break}if(Ht>=$&&(Ot=(Ot<<Dt^255&Tt[Mt+($-1)])&Rt,r=65535&Et[Ot],It[Mt&qt]=Et[Ot],Et[Ot]=Mt),Wt=zt,Nt=Ut,zt=$-1,0!==r&&Wt<Vt&&(Mt-r&65535)<=At-tt&&(Yt!=b&&(zt=wt(r)),zt<=5&&(Yt==v||zt==$&&Mt-Ut>4096)&&(zt=$-1)),Wt>=$&&zt<=Wt){n=Mt+Ht-$,e=ct(Mt-1-Nt,Wt-$),Ht-=Wt-1,Wt-=2;do{++Mt<=n&&(Ot=(Ot<<Dt^255&Tt[Mt+($-1)])&Rt,r=65535&Et[Ot],It[Mt&qt]=Et[Ot],Et[Ot]=Mt)}while(0!=--Wt);if(Lt=0,zt=$-1,Mt++,e&&(pt(!1),0===xt.avail_out))return L}else if(0!==Lt){if((e=ct(0,255&Tt[Mt-1]))&&pt(!1),Mt++,Ht--,0===xt.avail_out)return L}else Lt=1,Mt++,Ht--}return 0!==Lt&&(e=ct(0,255&Tt[Mt-1]),Lt=0),pt(t==A),0===xt.avail_out?t==A?U:L:t==A?H:M}function bt(e){return e.total_in=e.total_out=0,e.msg=null,te.pending=0,te.pending_out=0,kt=V,Ct=k,o(),t(),S}var xt,kt,_t,Ct,At,St,qt,Tt,Pt,It,Et,Ot,Ft,Bt,Rt,Dt,jt,zt,Nt,Lt,Mt,Ut,Ht,Wt,Xt,Vt,Gt,Yt,Jt,Qt,Kt,$t,Zt,te=this,ee=new e,ne=new e,re=new e;te.depth=[];var ie,oe,ae,se,ce,le,ue,he;te.bl_count=[],te.heap=[],Kt=[],$t=[],Zt=[],te.pqdownheap=function(t,e){for(var n=te.heap,r=n[e],o=e<<1;o<=te.heap_len&&(o<te.heap_len&&i(t,n[o+1],n[o],te.depth)&&o++,!i(t,r,n[o],te.depth));)n[e]=n[o],e=o,o<<=1;n[e]=r},te.deflateInit=function(t,e,n,r,i,o){return r||(r=Y),i||(i=B),o||(o=x),t.msg=null,e==y&&(e=6),i<1||i>F||r!=Y||n<9||n>15||e<0||e>9||o<0||o>b?P:(t.dstate=te,St=n,At=1<<St,qt=At-1,Bt=i+7,Ft=1<<Bt,Rt=Ft-1,Dt=Math.floor((Bt+$-1)/$),Tt=new Uint8Array(2*At),It=[],Et=[],oe=1<<i+6,te.pending_buf=new Uint8Array(4*oe),_t=4*oe,se=Math.floor(oe/2),ie=3*oe,Gt=e,Yt=o,bt(t))},te.deflateEnd=function(){return kt!=X&&kt!=V&&kt!=G?P:(te.pending_buf=null,Et=null,It=null,Tt=null,te.dstate=null,kt==V?I:S)},te.deflateParams=function(t,e,n){var r=S;return e==y&&(e=6),e<0||e>9||n<0||n>b?P:(z[Gt].func!=z[e].func&&0!==t.total_in&&(r=t.deflate(_)),Gt!=e&&(Vt=z[Gt=e].max_lazy,Jt=z[Gt].good_length,Qt=z[Gt].nice_length,Xt=z[Gt].max_chain),Yt=n,r)},te.deflateSetDictionary=function(t,e,n){var r,i=n,o=0;if(!e||kt!=X)return P;if(i<$)return S;for(i>At-tt&&(o=n-(i=At-tt)),Tt.set(e.subarray(o,o+i),0),Mt=i,jt=i,Ot=255&Tt[0],Ot=(Ot<<Dt^255&Tt[1])&Rt,r=0;r<=i-$;r++)Ot=(Ot<<Dt^255&Tt[r+($-1)])&Rt,It[r&qt]=Et[Ot],Et[Ot]=r;return S},te.deflate=function(t,e){var n,r,i,o,a;if(e>A||e<0)return P;if(!t.next_out||!t.next_in&&0!==t.avail_in||kt==G&&e!=A)return t.msg=N[T-P],P;if(0===t.avail_out)return t.msg=N[T-E],E;if(xt=t,o=Ct,Ct=e,kt==X&&(r=Y+(St-8<<4)<<8,(i=(Gt-1&255)>>1)>3&&(i=3),r|=i<<6,0!==Mt&&(r|=W),kt=V,et(r+=31-r%31)),0!==te.pending){if(xt.flush_pending(),0===xt.avail_out)return Ct=-1,S}else if(0===xt.avail_in&&e<=o&&e!=A)return xt.msg=N[T-E],E;if(kt==G&&0!==xt.avail_in)return t.msg=N[T-E],E;if(0!==xt.avail_in||0!==Ht||e!=k&&kt!=G){switch(a=-1,z[Gt].func){case R:a=gt(e);break;case D:a=yt(e);break;case j:a=vt(e)}if(a!=U&&a!=H||(kt=G),a==L||a==U)return 0===xt.avail_out&&(Ct=-1),S;if(a==M){if(e==_)st();else if(ft(0,0,!1),e==C)for(n=0;n<Ft;n++)Et[n]=0;if(xt.flush_pending(),0===xt.avail_out)return Ct=-1,S}}return e!=A?S:q}}function a(){var t=this;t.next_in_index=0,t.next_out_index=0,t.avail_in=0,t.total_in=0,t.avail_out=0,t.total_out=0}var s=15,c=30,l=19,u=256,h=u+1+29,f=2*h+1,d=256,p=16,m=17,g=18,w=16,y=-1,v=1,b=2,x=0,k=0,_=1,C=3,A=4,S=0,q=1,T=2,P=-2,I=-3,E=-5,O=[0,1,2,3,4,4,5,5,6,6,6,6,7,7,7,7,8,8,8,8,8,8,8,8,9,9,9,9,9,9,9,9,10,10,10,10,10,10,10,10,10,10,10,10,10,10,10,10,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,0,0,16,17,18,18,19,19,20,20,20,20,21,21,21,21,22,22,22,22,22,22,22,22,23,23,23,23,23,23,23,23,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29];e._length_code=[0,1,2,3,4,5,6,7,8,8,9,9,10,10,11,11,12,12,12,12,13,13,13,13,14,14,14,14,15,15,15,15,16,16,16,16,16,16,16,16,17,17,17,17,17,17,17,17,18,18,18,18,18,18,18,18,19,19,19,19,19,19,19,19,20,20,20,20,20,20,20,20,20,20,20,20,20,20,20,20,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,28],e.base_length=[0,1,2,3,4,5,6,7,8,10,12,14,16,20,24,28,32,40,48,56,64,80,96,112,128,160,192,224,0],e.base_dist=[0,1,2,3,4,6,8,12,16,24,32,48,64,96,128,192,256,384,512,768,1024,1536,2048,3072,4096,6144,8192,12288,16384,24576],e.d_code=function(t){return t<256?O[t]:O[256+(t>>>7)]},e.extra_lbits=[0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0],e.extra_dbits=[0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13],e.extra_blbits=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7],e.bl_order=[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15],n.static_ltree=[12,8,140,8,76,8,204,8,44,8,172,8,108,8,236,8,28,8,156,8,92,8,220,8,60,8,188,8,124,8,252,8,2,8,130,8,66,8,194,8,34,8,162,8,98,8,226,8,18,8,146,8,82,8,210,8,50,8,178,8,114,8,242,8,10,8,138,8,74,8,202,8,42,8,170,8,106,8,234,8,26,8,154,8,90,8,218,8,58,8,186,8,122,8,250,8,6,8,134,8,70,8,198,8,38,8,166,8,102,8,230,8,22,8,150,8,86,8,214,8,54,8,182,8,118,8,246,8,14,8,142,8,78,8,206,8,46,8,174,8,110,8,238,8,30,8,158,8,94,8,222,8,62,8,190,8,126,8,254,8,1,8,129,8,65,8,193,8,33,8,161,8,97,8,225,8,17,8,145,8,81,8,209,8,49,8,177,8,113,8,241,8,9,8,137,8,73,8,201,8,41,8,169,8,105,8,233,8,25,8,153,8,89,8,217,8,57,8,185,8,121,8,249,8,5,8,133,8,69,8,197,8,37,8,165,8,101,8,229,8,21,8,149,8,85,8,213,8,53,8,181,8,117,8,245,8,13,8,141,8,77,8,205,8,45,8,173,8,109,8,237,8,29,8,157,8,93,8,221,8,61,8,189,8,125,8,253,8,19,9,275,9,147,9,403,9,83,9,339,9,211,9,467,9,51,9,307,9,179,9,435,9,115,9,371,9,243,9,499,9,11,9,267,9,139,9,395,9,75,9,331,9,203,9,459,9,43,9,299,9,171,9,427,9,107,9,363,9,235,9,491,9,27,9,283,9,155,9,411,9,91,9,347,9,219,9,475,9,59,9,315,9,187,9,443,9,123,9,379,9,251,9,507,9,7,9,263,9,135,9,391,9,71,9,327,9,199,9,455,9,39,9,295,9,167,9,423,9,103,9,359,9,231,9,487,9,23,9,279,9,151,9,407,9,87,9,343,9,215,9,471,9,55,9,311,9,183,9,439,9,119,9,375,9,247,9,503,9,15,9,271,9,143,9,399,9,79,9,335,9,207,9,463,9,47,9,303,9,175,9,431,9,111,9,367,9,239,9,495,9,31,9,287,9,159,9,415,9,95,9,351,9,223,9,479,9,63,9,319,9,191,9,447,9,127,9,383,9,255,9,511,9,0,7,64,7,32,7,96,7,16,7,80,7,48,7,112,7,8,7,72,7,40,7,104,7,24,7,88,7,56,7,120,7,4,7,68,7,36,7,100,7,20,7,84,7,52,7,116,7,3,8,131,8,67,8,195,8,35,8,163,8,99,8,227,8],n.static_dtree=[0,5,16,5,8,5,24,5,4,5,20,5,12,5,28,5,2,5,18,5,10,5,26,5,6,5,22,5,14,5,30,5,1,5,17,5,9,5,25,5,5,5,21,5,13,5,29,5,3,5,19,5,11,5,27,5,7,5,23,5],n.static_l_desc=new n(n.static_ltree,e.extra_lbits,u+1,h,s),n.static_d_desc=new n(n.static_dtree,e.extra_dbits,0,c,s),n.static_bl_desc=new n(null,e.extra_blbits,0,l,7);var F=9,B=8,R=0,D=1,j=2,z=[new r(0,0,0,0,R),new r(4,4,8,4,D),new r(4,5,16,8,D),new r(4,6,32,32,D),new r(4,4,16,16,j),new r(8,16,32,32,j),new r(8,16,128,128,j),new r(8,32,128,256,j),new r(32,128,258,1024,j),new r(32,258,258,4096,j)],N=["need dictionary","stream end","","","stream error","data error","","buffer error","",""],L=0,M=1,U=2,H=3,W=32,X=42,V=113,G=666,Y=8,J=0,Q=1,K=2,$=3,Z=258,tt=Z+$+1;return a.prototype={deflateInit:function(t,e){var n=this;return n.dstate=new o,e||(e=s),n.dstate.deflateInit(n,t,e)},deflate:function(t){var e=this;return e.dstate?e.dstate.deflate(e,t):P},deflateEnd:function(){var t=this;if(!t.dstate)return P;var e=t.dstate.deflateEnd();return t.dstate=null,e},deflateParams:function(t,e){var n=this;return n.dstate?n.dstate.deflateParams(n,t,e):P},deflateSetDictionary:function(t,e){var n=this;return n.dstate?n.dstate.deflateSetDictionary(n,t,e):P},read_buf:function(t,e,n){var r=this,i=r.avail_in;return i>n&&(i=n),0===i?0:(r.avail_in-=i,t.set(r.next_in.subarray(r.next_in_index,r.next_in_index+i),e),r.next_in_index+=i,r.total_in+=i,i)},flush_pending:function(){var t=this,e=t.dstate.pending;e>t.avail_out&&(e=t.avail_out),0!==e&&(t.next_out.set(t.dstate.pending_buf.subarray(t.dstate.pending_out,t.dstate.pending_out+e),t.next_out_index),t.next_out_index+=e,t.dstate.pending_out+=e,t.total_out+=e,t.avail_out-=e,t.dstate.pending-=e,0===t.dstate.pending&&(t.dstate.pending_out=0))}},function(t){var e=this,n=new a,r=k,i=new Uint8Array(512);void 0===t&&(t=y),n.deflateInit(t),n.next_out=i,e.append=function(t,e){var o,a=[],s=0,c=0,l=0;if(t.length){n.next_in_index=0,n.next_in=t,n.avail_in=t.length;do{if(n.next_out_index=0,n.avail_out=512,n.deflate(r)!=S)throw"deflating: "+n.msg;n.next_out_index&&(512==n.next_out_index?a.push(new Uint8Array(i)):a.push(new Uint8Array(i.subarray(0,n.next_out_index)))),l+=n.next_out_index,e&&n.next_in_index>0&&n.next_in_index!=s&&(e(n.next_in_index),s=n.next_in_index)}while(n.avail_in>0||0===n.avail_out);return o=new Uint8Array(l),a.forEach(function(t){o.set(t,c),c+=t.length}),o}},e.flush=function(){var t,e,r=[],o=0,a=0;do{if(n.next_out_index=0,n.avail_out=512,(t=n.deflate(A))!=q&&t!=S)throw"deflating: "+n.msg;512-n.avail_out>0&&r.push(new Uint8Array(i.subarray(0,n.next_out_index))),a+=n.next_out_index}while(n.avail_in>0||0===n.avail_out);return n.deflateEnd(),e=new Uint8Array(a),r.forEach(function(t){e.set(t,o),o+=t.length}),e}}}();/*
	  html2canvas 0.5.0-beta3 <http://html2canvas.hertzen.com>
	  Copyright (c) 2016 Niklas von Hertzen
	
	  Released under  License
	*/
	!function(t){if(true)module.exports=t();else if("function"==typeof define&&define.amd)define([],t);else{var e;"undefined"!=typeof window?e=window:"undefined"!=typeof global?e=global:"undefined"!=typeof self&&(e=self),e.html2canvas=t()}}(function(){return function t(e,n,r){function i(a,s){if(!n[a]){if(!e[a]){var c="function"==typeof require&&require;if(!s&&c)return require(a,!0);if(o)return o(a,!0);var l=new Error("Cannot find module '"+a+"'");throw l.code="MODULE_NOT_FOUND",l}var u=n[a]={exports:{}};e[a][0].call(u.exports,function(t){var n=e[a][1][t];return i(n||t)},u,u.exports,t,e,n,r)}return n[a].exports}for(var o="function"==typeof require&&require,a=0;a<r.length;a++)i(r[a]);return i}({1:[function(t,e,n){(function(t){!function(r){function i(t){throw RangeError(E[t])}function o(t,e){for(var n=t.length;n--;)t[n]=e(t[n]);return t}function a(t,e){return o(t.split(I),e).join(".")}function s(t){for(var e,n,r=[],i=0,o=t.length;i<o;)(e=t.charCodeAt(i++))>=55296&&e<=56319&&i<o?56320==(64512&(n=t.charCodeAt(i++)))?r.push(((1023&e)<<10)+(1023&n)+65536):(r.push(e),i--):r.push(e);return r}function c(t){return o(t,function(t){var e="";return t>65535&&(e+=B((t-=65536)>>>10&1023|55296),t=56320|1023&t),e+=B(t)}).join("")}function l(t){return t-48<10?t-22:t-65<26?t-65:t-97<26?t-97:b}function u(t,e){return t+22+75*(t<26)-((0!=e)<<5)}function h(t,e,n){var r=0;for(t=n?F(t/C):t>>1,t+=F(t/e);t>O*k>>1;r+=b)t=F(t/O);return F(r+(O+1)*t/(t+_))}function f(t){var e,n,r,o,a,s,u,f,d,p,m=[],g=t.length,w=0,y=S,_=A;for((n=t.lastIndexOf(q))<0&&(n=0),r=0;r<n;++r)t.charCodeAt(r)>=128&&i("not-basic"),m.push(t.charCodeAt(r));for(o=n>0?n+1:0;o<g;){for(a=w,s=1,u=b;o>=g&&i("invalid-input"),((f=l(t.charCodeAt(o++)))>=b||f>F((v-w)/s))&&i("overflow"),w+=f*s,d=u<=_?x:u>=_+k?k:u-_,!(f<d);u+=b)s>F(v/(p=b-d))&&i("overflow"),s*=p;_=h(w-a,e=m.length+1,0==a),F(w/e)>v-y&&i("overflow"),y+=F(w/e),w%=e,m.splice(w++,0,y)}return c(m)}function d(t){var e,n,r,o,a,c,l,f,d,p,m,g,w,y,_,C=[];for(g=(t=s(t)).length,e=S,n=0,a=A,c=0;c<g;++c)(m=t[c])<128&&C.push(B(m));for(r=o=C.length,o&&C.push(q);r<g;){for(l=v,c=0;c<g;++c)(m=t[c])>=e&&m<l&&(l=m);for(l-e>F((v-n)/(w=r+1))&&i("overflow"),n+=(l-e)*w,e=l,c=0;c<g;++c)if((m=t[c])<e&&++n>v&&i("overflow"),m==e){for(f=n,d=b;p=d<=a?x:d>=a+k?k:d-a,!(f<p);d+=b)_=f-p,y=b-p,C.push(B(u(p+_%y,0))),f=F(_/y);C.push(B(u(f,0))),a=h(n,w,r==o),n=0,++r}++n,++e}return C.join("")}var p="object"==typeof n&&n,m="object"==typeof e&&e&&e.exports==p&&e,g="object"==typeof t&&t;g.global!==g&&g.window!==g||(r=g);var w,y,v=2147483647,b=36,x=1,k=26,_=38,C=700,A=72,S=128,q="-",T=/^xn--/,P=/[^ -~]/,I=/\x2E|\u3002|\uFF0E|\uFF61/g,E={overflow:"Overflow: input needs wider integers to process","not-basic":"Illegal input >= 0x80 (not a basic code point)","invalid-input":"Invalid input"},O=b-x,F=Math.floor,B=String.fromCharCode;if(w={version:"1.2.4",ucs2:{decode:s,encode:c},decode:f,encode:d,toASCII:function(t){return a(t,function(t){return P.test(t)?"xn--"+d(t):t})},toUnicode:function(t){return a(t,function(t){return T.test(t)?f(t.slice(4).toLowerCase()):t})}},p&&!p.nodeType)if(m)m.exports=w;else for(y in w)w.hasOwnProperty(y)&&(p[y]=w[y]);else r.punycode=w}(this)}).call(this,"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{}],2:[function(t,e,n){function r(t,e,n){!t.defaultView||e===t.defaultView.pageXOffset&&n===t.defaultView.pageYOffset||t.defaultView.scrollTo(e,n)}function i(t,e){try{e&&(e.width=t.width,e.height=t.height,e.getContext("2d").putImageData(t.getContext("2d").getImageData(0,0,t.width,t.height),0,0))}catch(e){s("Unable to copy canvas content from",t,e)}}function o(t,e){for(var n=3===t.nodeType?document.createTextNode(t.nodeValue):t.cloneNode(!1),r=t.firstChild;r;)!0!==e&&1===r.nodeType&&"SCRIPT"===r.nodeName||n.appendChild(o(r,e)),r=r.nextSibling;return 1===t.nodeType&&(n._scrollTop=t.scrollTop,n._scrollLeft=t.scrollLeft,"CANVAS"===t.nodeName?i(t,n):"TEXTAREA"!==t.nodeName&&"SELECT"!==t.nodeName||(n.value=t.value)),n}function a(t){if(1===t.nodeType){t.scrollTop=t._scrollTop,t.scrollLeft=t._scrollLeft;for(var e=t.firstChild;e;)a(e),e=e.nextSibling}}var s=t("./log");e.exports=function(t,e,n,i,s,c,l){var u=o(t.documentElement,s.javascriptEnabled),h=e.createElement("iframe");return h.className="html2canvas-container",h.style.visibility="hidden",h.style.position="fixed",h.style.left="-10000px",h.style.top="0px",h.style.border="0",h.width=n,h.height=i,h.scrolling="no",e.body.appendChild(h),new Promise(function(e){var n=h.contentWindow.document;h.contentWindow.onload=h.onload=function(){var t=setInterval(function(){n.body.childNodes.length>0&&(a(n.documentElement),clearInterval(t),"view"===s.type&&(h.contentWindow.scrollTo(c,l),!/(iPad|iPhone|iPod)/g.test(navigator.userAgent)||h.contentWindow.scrollY===l&&h.contentWindow.scrollX===c||(n.documentElement.style.top=-l+"px",n.documentElement.style.left=-c+"px",n.documentElement.style.position="absolute")),e(h))},50)},n.open(),n.write("<!DOCTYPE html><html></html>"),r(t,c,l),n.replaceChild(n.adoptNode(u),n.documentElement),n.close()})}},{"./log":13}],3:[function(t,e,n){function r(t){this.r=0,this.g=0,this.b=0,this.a=null;this.fromArray(t)||this.namedColor(t)||this.rgb(t)||this.rgba(t)||this.hex6(t)||this.hex3(t)}r.prototype.darken=function(t){var e=1-t;return new r([Math.round(this.r*e),Math.round(this.g*e),Math.round(this.b*e),this.a])},r.prototype.isTransparent=function(){return 0===this.a},r.prototype.isBlack=function(){return 0===this.r&&0===this.g&&0===this.b},r.prototype.fromArray=function(t){return Array.isArray(t)&&(this.r=Math.min(t[0],255),this.g=Math.min(t[1],255),this.b=Math.min(t[2],255),t.length>3&&(this.a=t[3])),Array.isArray(t)};var i=/^#([a-f0-9]{3})$/i;r.prototype.hex3=function(t){var e=null;return null!==(e=t.match(i))&&(this.r=parseInt(e[1][0]+e[1][0],16),this.g=parseInt(e[1][1]+e[1][1],16),this.b=parseInt(e[1][2]+e[1][2],16)),null!==e};var o=/^#([a-f0-9]{6})$/i;r.prototype.hex6=function(t){var e=null;return null!==(e=t.match(o))&&(this.r=parseInt(e[1].substring(0,2),16),this.g=parseInt(e[1].substring(2,4),16),this.b=parseInt(e[1].substring(4,6),16)),null!==e};var a=/^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/;r.prototype.rgb=function(t){var e=null;return null!==(e=t.match(a))&&(this.r=Number(e[1]),this.g=Number(e[2]),this.b=Number(e[3])),null!==e};var s=/^rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d?\.?\d+)\s*\)$/;r.prototype.rgba=function(t){var e=null;return null!==(e=t.match(s))&&(this.r=Number(e[1]),this.g=Number(e[2]),this.b=Number(e[3]),this.a=Number(e[4])),null!==e},r.prototype.toString=function(){return null!==this.a&&1!==this.a?"rgba("+[this.r,this.g,this.b,this.a].join(",")+")":"rgb("+[this.r,this.g,this.b].join(",")+")"},r.prototype.namedColor=function(t){t=t.toLowerCase();var e=c[t];if(e)this.r=e[0],this.g=e[1],this.b=e[2];else if("transparent"===t)return this.r=this.g=this.b=this.a=0,!0;return!!e},r.prototype.isColor=!0;var c={aliceblue:[240,248,255],antiquewhite:[250,235,215],aqua:[0,255,255],aquamarine:[127,255,212],azure:[240,255,255],beige:[245,245,220],bisque:[255,228,196],black:[0,0,0],blanchedalmond:[255,235,205],blue:[0,0,255],blueviolet:[138,43,226],brown:[165,42,42],burlywood:[222,184,135],cadetblue:[95,158,160],chartreuse:[127,255,0],chocolate:[210,105,30],coral:[255,127,80],cornflowerblue:[100,149,237],cornsilk:[255,248,220],crimson:[220,20,60],cyan:[0,255,255],darkblue:[0,0,139],darkcyan:[0,139,139],darkgoldenrod:[184,134,11],darkgray:[169,169,169],darkgreen:[0,100,0],darkgrey:[169,169,169],darkkhaki:[189,183,107],darkmagenta:[139,0,139],darkolivegreen:[85,107,47],darkorange:[255,140,0],darkorchid:[153,50,204],darkred:[139,0,0],darksalmon:[233,150,122],darkseagreen:[143,188,143],darkslateblue:[72,61,139],darkslategray:[47,79,79],darkslategrey:[47,79,79],darkturquoise:[0,206,209],darkviolet:[148,0,211],deeppink:[255,20,147],deepskyblue:[0,191,255],dimgray:[105,105,105],dimgrey:[105,105,105],dodgerblue:[30,144,255],firebrick:[178,34,34],floralwhite:[255,250,240],forestgreen:[34,139,34],fuchsia:[255,0,255],gainsboro:[220,220,220],ghostwhite:[248,248,255],gold:[255,215,0],goldenrod:[218,165,32],gray:[128,128,128],green:[0,128,0],greenyellow:[173,255,47],grey:[128,128,128],honeydew:[240,255,240],hotpink:[255,105,180],indianred:[205,92,92],indigo:[75,0,130],ivory:[255,255,240],khaki:[240,230,140],lavender:[230,230,250],lavenderblush:[255,240,245],lawngreen:[124,252,0],lemonchiffon:[255,250,205],lightblue:[173,216,230],lightcoral:[240,128,128],lightcyan:[224,255,255],lightgoldenrodyellow:[250,250,210],lightgray:[211,211,211],lightgreen:[144,238,144],lightgrey:[211,211,211],lightpink:[255,182,193],lightsalmon:[255,160,122],lightseagreen:[32,178,170],lightskyblue:[135,206,250],lightslategray:[119,136,153],lightslategrey:[119,136,153],lightsteelblue:[176,196,222],lightyellow:[255,255,224],lime:[0,255,0],limegreen:[50,205,50],linen:[250,240,230],magenta:[255,0,255],maroon:[128,0,0],mediumaquamarine:[102,205,170],mediumblue:[0,0,205],mediumorchid:[186,85,211],mediumpurple:[147,112,219],mediumseagreen:[60,179,113],mediumslateblue:[123,104,238],mediumspringgreen:[0,250,154],mediumturquoise:[72,209,204],mediumvioletred:[199,21,133],midnightblue:[25,25,112],mintcream:[245,255,250],mistyrose:[255,228,225],moccasin:[255,228,181],navajowhite:[255,222,173],navy:[0,0,128],oldlace:[253,245,230],olive:[128,128,0],olivedrab:[107,142,35],orange:[255,165,0],orangered:[255,69,0],orchid:[218,112,214],palegoldenrod:[238,232,170],palegreen:[152,251,152],paleturquoise:[175,238,238],palevioletred:[219,112,147],papayawhip:[255,239,213],peachpuff:[255,218,185],peru:[205,133,63],pink:[255,192,203],plum:[221,160,221],powderblue:[176,224,230],purple:[128,0,128],rebeccapurple:[102,51,153],red:[255,0,0],rosybrown:[188,143,143],royalblue:[65,105,225],saddlebrown:[139,69,19],salmon:[250,128,114],sandybrown:[244,164,96],seagreen:[46,139,87],seashell:[255,245,238],sienna:[160,82,45],silver:[192,192,192],skyblue:[135,206,235],slateblue:[106,90,205],slategray:[112,128,144],slategrey:[112,128,144],snow:[255,250,250],springgreen:[0,255,127],steelblue:[70,130,180],tan:[210,180,140],teal:[0,128,128],thistle:[216,191,216],tomato:[255,99,71],turquoise:[64,224,208],violet:[238,130,238],wheat:[245,222,179],white:[255,255,255],whitesmoke:[245,245,245],yellow:[255,255,0],yellowgreen:[154,205,50]};e.exports=r},{}],4:[function(t,e,n){function r(t,e){var n=k++;if((e=e||{}).logging&&(g.options.logging=!0,g.options.start=Date.now()),e.async=void 0===e.async||e.async,e.allowTaint=void 0!==e.allowTaint&&e.allowTaint,e.removeContainer=void 0===e.removeContainer||e.removeContainer,e.javascriptEnabled=void 0!==e.javascriptEnabled&&e.javascriptEnabled,e.imageTimeout=void 0===e.imageTimeout?1e4:e.imageTimeout,e.renderer="function"==typeof e.renderer?e.renderer:f,e.strict=!!e.strict,"string"==typeof t){if("string"!=typeof e.proxy)return Promise.reject("Proxy must be used when rendering url");var r=null!=e.width?e.width:window.innerWidth,a=null!=e.height?e.height:window.innerHeight;return v(u(t),e.proxy,document,r,a,e).then(function(t){return o(t.contentWindow.document.documentElement,t,e,r,a)})}var s=(void 0===t?[document.documentElement]:t.length?t:[t])[0];return s.setAttribute(x+n,n),i(s.ownerDocument,e,s.ownerDocument.defaultView.innerWidth,s.ownerDocument.defaultView.innerHeight,n).then(function(t){return"function"==typeof e.onrendered&&(g("options.onrendered is deprecated, html2canvas returns a Promise containing the canvas"),e.onrendered(t)),t})}function i(t,e,n,r,i){return y(t,t,n,r,e,t.defaultView.pageXOffset,t.defaultView.pageYOffset).then(function(a){g("Document cloned");var s=x+i,c="["+s+"='"+i+"']";t.querySelector(c).removeAttribute(s);var l=a.contentWindow,u=l.document.querySelector(c);return("function"==typeof e.onclone?Promise.resolve(e.onclone(l.document)):Promise.resolve(!0)).then(function(){return o(u,a,e,n,r)})})}function o(t,e,n,r,i){var o=e.contentWindow,u=new h(o.document),f=new d(n,u),m=b(t),w="view"===n.type?r:c(o.document),y="view"===n.type?i:l(o.document),v=new n.renderer(w,y,f,n,document);return new p(t,v,u,f,n).ready.then(function(){g("Finished rendering");var r;return r="view"===n.type?s(v.canvas,{width:v.canvas.width,height:v.canvas.height,top:0,left:0,x:0,y:0}):t===o.document.body||t===o.document.documentElement||null!=n.canvas?v.canvas:s(v.canvas,{width:null!=n.width?n.width:m.width,height:null!=n.height?n.height:m.height,top:m.top,left:m.left,x:0,y:0}),a(e,n),r})}function a(t,e){e.removeContainer&&(t.parentNode.removeChild(t),g("Cleaned up container"))}function s(t,e){var n=document.createElement("canvas"),r=Math.min(t.width-1,Math.max(0,e.left)),i=Math.min(t.width,Math.max(1,e.left+e.width)),o=Math.min(t.height-1,Math.max(0,e.top)),a=Math.min(t.height,Math.max(1,e.top+e.height));n.width=e.width,n.height=e.height;var s=i-r,c=a-o;return g("Cropping canvas at:","left:",e.left,"top:",e.top,"width:",s,"height:",c),g("Resulting crop with width",e.width,"and height",e.height,"with x",r,"and y",o),n.getContext("2d").drawImage(t,r,o,s,c,e.x,e.y,s,c),n}function c(t){return Math.max(Math.max(t.body.scrollWidth,t.documentElement.scrollWidth),Math.max(t.body.offsetWidth,t.documentElement.offsetWidth),Math.max(t.body.clientWidth,t.documentElement.clientWidth))}function l(t){return Math.max(Math.max(t.body.scrollHeight,t.documentElement.scrollHeight),Math.max(t.body.offsetHeight,t.documentElement.offsetHeight),Math.max(t.body.clientHeight,t.documentElement.clientHeight))}function u(t){var e=document.createElement("a");return e.href=t,e.href=e.href,e}var h=t("./support"),f=t("./renderers/canvas"),d=t("./imageloader"),p=t("./nodeparser"),m=t("./nodecontainer"),g=t("./log"),w=t("./utils"),y=t("./clone"),v=t("./proxy").loadUrlDocument,b=w.getBounds,x="data-html2canvas-node",k=0;r.CanvasRenderer=f,r.NodeContainer=m,r.log=g,r.utils=w;var _="undefined"==typeof document||"function"!=typeof Object.create||"function"!=typeof document.createElement("canvas").getContext?function(){return Promise.reject("No canvas support")}:r;e.exports=_},{"./clone":2,"./imageloader":11,"./log":13,"./nodecontainer":14,"./nodeparser":15,"./proxy":16,"./renderers/canvas":20,"./support":22,"./utils":26}],5:[function(t,e,n){function r(t){if(this.src=t,i("DummyImageContainer for",t),!this.promise||!this.image){i("Initiating DummyImageContainer"),r.prototype.image=new Image;var e=this.image;r.prototype.promise=new Promise(function(t,n){e.onload=t,e.onerror=n,e.src=o(),!0===e.complete&&t(e)})}}var i=t("./log"),o=t("./utils").smallImage;e.exports=r},{"./log":13,"./utils":26}],6:[function(t,e,n){var r=t("./utils").smallImage;e.exports=function(t,e){var n,i,o=document.createElement("div"),a=document.createElement("img"),s=document.createElement("span");o.style.visibility="hidden",o.style.fontFamily=t,o.style.fontSize=e,o.style.margin=0,o.style.padding=0,document.body.appendChild(o),a.src=r(),a.width=1,a.height=1,a.style.margin=0,a.style.padding=0,a.style.verticalAlign="baseline",s.style.fontFamily=t,s.style.fontSize=e,s.style.margin=0,s.style.padding=0,s.appendChild(document.createTextNode("Hidden Text")),o.appendChild(s),o.appendChild(a),n=a.offsetTop-s.offsetTop+1,o.removeChild(s),o.appendChild(document.createTextNode("Hidden Text")),o.style.lineHeight="normal",a.style.verticalAlign="super",i=a.offsetTop-o.offsetTop+1,document.body.removeChild(o),this.baseline=n,this.lineWidth=1,this.middle=i}},{"./utils":26}],7:[function(t,e,n){function r(){this.data={}}var i=t("./font");r.prototype.getMetrics=function(t,e){return void 0===this.data[t+"-"+e]&&(this.data[t+"-"+e]=new i(t,e)),this.data[t+"-"+e]},e.exports=r},{"./font":6}],8:[function(t,e,n){function r(e,n,r){this.image=null,this.src=e;var o=this,a=i(e);this.promise=(n?new Promise(function(t){"about:blank"===e.contentWindow.document.URL||null==e.contentWindow.document.documentElement?e.contentWindow.onload=e.onload=function(){t(e)}:t(e)}):this.proxyLoad(r.proxy,a,r)).then(function(e){return t("./core")(e.contentWindow.document.documentElement,{type:"view",width:e.width,height:e.height,proxy:r.proxy,javascriptEnabled:r.javascriptEnabled,removeContainer:r.removeContainer,allowTaint:r.allowTaint,imageTimeout:r.imageTimeout/2})}).then(function(t){return o.image=t})}var i=t("./utils").getBounds,o=t("./proxy").loadUrlDocument;r.prototype.proxyLoad=function(t,e,n){var r=this.src;return o(r.src,t,r.ownerDocument,e.width,e.height,n)},e.exports=r},{"./core":4,"./proxy":16,"./utils":26}],9:[function(t,e,n){function r(t){this.src=t.value,this.colorStops=[],this.type=null,this.x0=.5,this.y0=.5,this.x1=.5,this.y1=.5,this.promise=Promise.resolve(!0)}r.TYPES={LINEAR:1,RADIAL:2},r.REGEXP_COLORSTOP=/^\s*(rgba?\(\s*\d{1,3},\s*\d{1,3},\s*\d{1,3}(?:,\s*[0-9\.]+)?\s*\)|[a-z]{3,20}|#[a-f0-9]{3,6})(?:\s+(\d{1,3}(?:\.\d+)?)(%|px)?)?(?:\s|$)/i,e.exports=r},{}],10:[function(t,e,n){e.exports=function(t,e){this.src=t,this.image=new Image;var n=this;this.tainted=null,this.promise=new Promise(function(r,i){n.image.onload=r,n.image.onerror=i,e&&(n.image.crossOrigin="anonymous"),n.image.src=t,!0===n.image.complete&&r(n.image)})}},{}],11:[function(t,e,n){function r(t,e){this.link=null,this.options=t,this.support=e,this.origin=this.getOrigin(window.location.href)}var i=t("./log"),o=t("./imagecontainer"),a=t("./dummyimagecontainer"),s=t("./proxyimagecontainer"),c=t("./framecontainer"),l=t("./svgcontainer"),u=t("./svgnodecontainer"),h=t("./lineargradientcontainer"),f=t("./webkitgradientcontainer"),d=t("./utils").bind;r.prototype.findImages=function(t){var e=[];return t.reduce(function(t,e){switch(e.node.nodeName){case"IMG":return t.concat([{args:[e.node.src],method:"url"}]);case"svg":case"IFRAME":return t.concat([{args:[e.node],method:e.node.nodeName}])}return t},[]).forEach(this.addImage(e,this.loadImage),this),e},r.prototype.findBackgroundImage=function(t,e){return e.parseBackgroundImages().filter(this.hasImageBackground).forEach(this.addImage(t,this.loadImage),this),t},r.prototype.addImage=function(t,e){return function(n){n.args.forEach(function(r){this.imageExists(t,r)||(t.splice(0,0,e.call(this,n)),i("Added image #"+t.length,"string"==typeof r?r.substring(0,100):r))},this)}},r.prototype.hasImageBackground=function(t){return"none"!==t.method},r.prototype.loadImage=function(t){if("url"===t.method){var e=t.args[0];return!this.isSVG(e)||this.support.svg||this.options.allowTaint?e.match(/data:image\/.*;base64,/i)?new o(e.replace(/url\(['"]{0,}|['"]{0,}\)$/gi,""),!1):this.isSameOrigin(e)||!0===this.options.allowTaint||this.isSVG(e)?new o(e,!1):this.support.cors&&!this.options.allowTaint&&this.options.useCORS?new o(e,!0):this.options.proxy?new s(e,this.options.proxy):new a(e):new l(e)}return"linear-gradient"===t.method?new h(t):"gradient"===t.method?new f(t):"svg"===t.method?new u(t.args[0],this.support.svg):"IFRAME"===t.method?new c(t.args[0],this.isSameOrigin(t.args[0].src),this.options):new a(t)},r.prototype.isSVG=function(t){return"svg"===t.substring(t.length-3).toLowerCase()||l.prototype.isInline(t)},r.prototype.imageExists=function(t,e){return t.some(function(t){return t.src===e})},r.prototype.isSameOrigin=function(t){return this.getOrigin(t)===this.origin},r.prototype.getOrigin=function(t){var e=this.link||(this.link=document.createElement("a"));return e.href=t,e.href=e.href,e.protocol+e.hostname+e.port},r.prototype.getPromise=function(t){return this.timeout(t,this.options.imageTimeout).catch(function(){return new a(t.src).promise.then(function(e){t.image=e})})},r.prototype.get=function(t){var e=null;return this.images.some(function(n){return(e=n).src===t})?e:null},r.prototype.fetch=function(t){return this.images=t.reduce(d(this.findBackgroundImage,this),this.findImages(t)),this.images.forEach(function(t,e){t.promise.then(function(){i("Succesfully loaded image #"+(e+1),t)},function(n){i("Failed loading image #"+(e+1),t,n)})}),this.ready=Promise.all(this.images.map(this.getPromise,this)),i("Finished searching images"),this},r.prototype.timeout=function(t,e){var n,r=Promise.race([t.promise,new Promise(function(r,o){n=setTimeout(function(){i("Timed out loading image",t),o(t)},e)})]).then(function(t){return clearTimeout(n),t});return r.catch(function(){clearTimeout(n)}),r},e.exports=r},{"./dummyimagecontainer":5,"./framecontainer":8,"./imagecontainer":10,"./lineargradientcontainer":12,"./log":13,"./proxyimagecontainer":17,"./svgcontainer":23,"./svgnodecontainer":24,"./utils":26,"./webkitgradientcontainer":27}],12:[function(t,e,n){function r(t){i.apply(this,arguments),this.type=i.TYPES.LINEAR;var e=r.REGEXP_DIRECTION.test(t.args[0])||!i.REGEXP_COLORSTOP.test(t.args[0]);e?t.args[0].split(/\s+/).reverse().forEach(function(t,e){switch(t){case"left":this.x0=0,this.x1=1;break;case"top":this.y0=0,this.y1=1;break;case"right":this.x0=1,this.x1=0;break;case"bottom":this.y0=1,this.y1=0;break;case"to":var n=this.y0,r=this.x0;this.y0=this.y1,this.x0=this.x1,this.x1=r,this.y1=n;break;case"center":break;default:var i=.01*parseFloat(t,10);if(isNaN(i))break;0===e?(this.y0=i,this.y1=1-this.y0):(this.x0=i,this.x1=1-this.x0)}},this):(this.y0=0,this.y1=1),this.colorStops=t.args.slice(e?1:0).map(function(t){var e=t.match(i.REGEXP_COLORSTOP),n=+e[2],r=0===n?"%":e[3];return{color:new o(e[1]),stop:"%"===r?n/100:null}}),null===this.colorStops[0].stop&&(this.colorStops[0].stop=0),null===this.colorStops[this.colorStops.length-1].stop&&(this.colorStops[this.colorStops.length-1].stop=1),this.colorStops.forEach(function(t,e){null===t.stop&&this.colorStops.slice(e).some(function(n,r){return null!==n.stop&&(t.stop=(n.stop-this.colorStops[e-1].stop)/(r+1)+this.colorStops[e-1].stop,!0)},this)},this)}var i=t("./gradientcontainer"),o=t("./color");r.prototype=Object.create(i.prototype),r.REGEXP_DIRECTION=/^\s*(?:to|left|right|top|bottom|center|\d{1,3}(?:\.\d+)?%?)(?:\s|$)/i,e.exports=r},{"./color":3,"./gradientcontainer":9}],13:[function(t,e,n){var r=function(){r.options.logging&&window.console&&window.console.log&&Function.prototype.bind.call(window.console.log,window.console).apply(window.console,[Date.now()-r.options.start+"ms","html2canvas:"].concat([].slice.call(arguments,0)))};r.options={logging:!1},e.exports=r},{}],14:[function(t,e,n){function r(t,e){this.node=t,this.parent=e,this.stack=null,this.bounds=null,this.borders=null,this.clip=[],this.backgroundClip=[],this.offsetBounds=null,this.visible=null,this.computedStyles=null,this.colors={},this.styles={},this.backgroundImages=null,this.transformData=null,this.transformMatrix=null,this.isPseudoElement=!1,this.opacity=null}function i(t){var e=t.options[t.selectedIndex||0];return e?e.text||"":""}function o(t){if(t&&"matrix"===t[1])return t[2].split(",").map(function(t){return parseFloat(t.trim())});if(t&&"matrix3d"===t[1]){var e=t[2].split(",").map(function(t){return parseFloat(t.trim())});return[e[0],e[1],e[4],e[5],e[12],e[13]]}}function a(t){return-1!==t.toString().indexOf("%")}function s(t){return t.replace("px","")}function c(t){return parseFloat(t)}var l=t("./color"),u=t("./utils"),h=u.getBounds,f=u.parseBackgrounds,d=u.offsetBounds;r.prototype.cloneTo=function(t){t.visible=this.visible,t.borders=this.borders,t.bounds=this.bounds,t.clip=this.clip,t.backgroundClip=this.backgroundClip,t.computedStyles=this.computedStyles,t.styles=this.styles,t.backgroundImages=this.backgroundImages,t.opacity=this.opacity},r.prototype.getOpacity=function(){return null===this.opacity?this.opacity=this.cssFloat("opacity"):this.opacity},r.prototype.assignStack=function(t){this.stack=t,t.children.push(this)},r.prototype.isElementVisible=function(){return this.node.nodeType===Node.TEXT_NODE?this.parent.visible:"none"!==this.css("display")&&"hidden"!==this.css("visibility")&&!this.node.hasAttribute("data-html2canvas-ignore")&&("INPUT"!==this.node.nodeName||"hidden"!==this.node.getAttribute("type"))},r.prototype.css=function(t){return this.computedStyles||(this.computedStyles=this.isPseudoElement?this.parent.computedStyle(this.before?":before":":after"):this.computedStyle(null)),this.styles[t]||(this.styles[t]=this.computedStyles[t])},r.prototype.prefixedCss=function(t){var e=["webkit","moz","ms","o"],n=this.css(t);return void 0===n&&e.some(function(e){return void 0!==(n=this.css(e+t.substr(0,1).toUpperCase()+t.substr(1)))},this),void 0===n?null:n},r.prototype.computedStyle=function(t){return this.node.ownerDocument.defaultView.getComputedStyle(this.node,t)},r.prototype.cssInt=function(t){var e=parseInt(this.css(t),10);return isNaN(e)?0:e},r.prototype.color=function(t){return this.colors[t]||(this.colors[t]=new l(this.css(t)))},r.prototype.cssFloat=function(t){var e=parseFloat(this.css(t));return isNaN(e)?0:e},r.prototype.fontWeight=function(){var t=this.css("fontWeight");switch(parseInt(t,10)){case 401:t="bold";break;case 400:t="normal"}return t},r.prototype.parseClip=function(){var t=this.css("clip").match(this.CLIP);return t?{top:parseInt(t[1],10),right:parseInt(t[2],10),bottom:parseInt(t[3],10),left:parseInt(t[4],10)}:null},r.prototype.parseBackgroundImages=function(){return this.backgroundImages||(this.backgroundImages=f(this.css("backgroundImage")))},r.prototype.cssList=function(t,e){var n=(this.css(t)||"").split(",");return n=n[e||0]||n[0]||"auto",1===(n=n.trim().split(" ")).length&&(n=[n[0],a(n[0])?"auto":n[0]]),n},r.prototype.parseBackgroundSize=function(t,e,n){var r,i,o=this.cssList("backgroundSize",n);if(a(o[0]))r=t.width*parseFloat(o[0])/100;else{if(/contain|cover/.test(o[0])){var s=t.width/t.height,c=e.width/e.height;return s<c^"contain"===o[0]?{width:t.height*c,height:t.height}:{width:t.width,height:t.width/c}}r=parseInt(o[0],10)}return i="auto"===o[0]&&"auto"===o[1]?e.height:"auto"===o[1]?r/e.width*e.height:a(o[1])?t.height*parseFloat(o[1])/100:parseInt(o[1],10),"auto"===o[0]&&(r=i/e.height*e.width),{width:r,height:i}},r.prototype.parseBackgroundPosition=function(t,e,n,r){var i,o,s=this.cssList("backgroundPosition",n);return i=a(s[0])?(t.width-(r||e).width)*(parseFloat(s[0])/100):parseInt(s[0],10),o="auto"===s[1]?i/e.width*e.height:a(s[1])?(t.height-(r||e).height)*parseFloat(s[1])/100:parseInt(s[1],10),"auto"===s[0]&&(i=o/e.height*e.width),{left:i,top:o}},r.prototype.parseBackgroundRepeat=function(t){return this.cssList("backgroundRepeat",t)[0]},r.prototype.parseTextShadows=function(){var t=this.css("textShadow"),e=[];if(t&&"none"!==t)for(var n=t.match(this.TEXT_SHADOW_PROPERTY),r=0;n&&r<n.length;r++){var i=n[r].match(this.TEXT_SHADOW_VALUES);e.push({color:new l(i[0]),offsetX:i[1]?parseFloat(i[1].replace("px","")):0,offsetY:i[2]?parseFloat(i[2].replace("px","")):0,blur:i[3]?i[3].replace("px",""):0})}return e},r.prototype.parseTransform=function(){if(!this.transformData)if(this.hasTransform()){var t=this.parseBounds(),e=this.prefixedCss("transformOrigin").split(" ").map(s).map(c);e[0]+=t.left,e[1]+=t.top,this.transformData={origin:e,matrix:this.parseTransformMatrix()}}else this.transformData={origin:[0,0],matrix:[1,0,0,1,0,0]};return this.transformData},r.prototype.parseTransformMatrix=function(){if(!this.transformMatrix){var t=this.prefixedCss("transform"),e=t?o(t.match(this.MATRIX_PROPERTY)):null;this.transformMatrix=e||[1,0,0,1,0,0]}return this.transformMatrix},r.prototype.parseBounds=function(){return this.bounds||(this.bounds=this.hasTransform()?d(this.node):h(this.node))},r.prototype.hasTransform=function(){return"1,0,0,1,0,0"!==this.parseTransformMatrix().join(",")||this.parent&&this.parent.hasTransform()},r.prototype.getValue=function(){var t=this.node.value||"";return"SELECT"===this.node.tagName?t=i(this.node):"password"===this.node.type&&(t=Array(t.length+1).join("•")),0===t.length?this.node.placeholder||"":t},r.prototype.MATRIX_PROPERTY=/(matrix|matrix3d)\((.+)\)/,r.prototype.TEXT_SHADOW_PROPERTY=/((rgba|rgb)\([^\)]+\)(\s-?\d+px){0,})/g,r.prototype.TEXT_SHADOW_VALUES=/(-?\d+px)|(#.+)|(rgb\(.+\))|(rgba\(.+\))/g,r.prototype.CLIP=/^rect\((\d+)px,? (\d+)px,? (\d+)px,? (\d+)px\)$/,e.exports=r},{"./color":3,"./utils":26}],15:[function(t,e,n){function r(t,e,n,r,i){L("Starting NodeParser"),this.renderer=e,this.options=i,this.range=null,this.support=n,this.renderQueue=[],this.stack=new G(!0,1,t.ownerDocument,null);var o=new U(t,null);if(i.background&&e.rectangle(0,0,e.width,e.height,new V(i.background)),t===t.ownerDocument.documentElement){var a=new U(o.color("backgroundColor").isTransparent()?t.ownerDocument.body:t.ownerDocument.documentElement,null);e.rectangle(0,0,e.width,e.height,a.color("backgroundColor"))}o.visibile=o.isElementVisible(),this.createPseudoHideStyles(t.ownerDocument),this.disableAnimations(t.ownerDocument),this.nodes=R([o].concat(this.getChildren(o)).filter(function(t){return t.visible=t.isElementVisible()}).map(this.getPseudoElements,this)),this.fontMetrics=new X,L("Fetched nodes, total:",this.nodes.length),L("Calculate overflow clips"),this.calculateOverflowClips(),L("Start fetching images"),this.images=r.fetch(this.nodes.filter(q)),this.ready=this.images.ready.then(J(function(){return L("Images loaded, starting parsing"),L("Creating stacking contexts"),this.createStackingContexts(),L("Sorting stacking contexts"),this.sortStackingContexts(this.stack),this.parse(this.stack),L("Render queue created with "+this.renderQueue.length+" items"),new Promise(J(function(t){i.async?"function"==typeof i.async?i.async.call(this,this.renderQueue,t):this.renderQueue.length>0?(this.renderIndex=0,this.asyncRenderer(this.renderQueue,t)):t():(this.renderQueue.forEach(this.paint,this),t())},this))},this))}function i(t){return t.parent&&t.parent.clip.length}function o(t){return t.replace(/(\-[a-z])/g,function(t){return t.toUpperCase().replace("-","")})}function a(){}function s(t,e,n,r){return t.map(function(i,o){if(i.width>0){var a=e.left,s=e.top,c=e.width,l=e.height-t[2].width;switch(o){case 0:l=t[0].width,i.args=h({c1:[a,s],c2:[a+c,s],c3:[a+c-t[1].width,s+l],c4:[a+t[3].width,s+l]},r[0],r[1],n.topLeftOuter,n.topLeftInner,n.topRightOuter,n.topRightInner);break;case 1:a=e.left+e.width-t[1].width,c=t[1].width,i.args=h({c1:[a+c,s],c2:[a+c,s+l+t[2].width],c3:[a,s+l],c4:[a,s+t[0].width]},r[1],r[2],n.topRightOuter,n.topRightInner,n.bottomRightOuter,n.bottomRightInner);break;case 2:s=s+e.height-t[2].width,l=t[2].width,i.args=h({c1:[a+c,s+l],c2:[a,s+l],c3:[a+t[3].width,s],c4:[a+c-t[3].width,s]},r[2],r[3],n.bottomRightOuter,n.bottomRightInner,n.bottomLeftOuter,n.bottomLeftInner);break;case 3:c=t[3].width,i.args=h({c1:[a,s+l+t[2].width],c2:[a,s],c3:[a+c,s+t[0].width],c4:[a+c,s+l]},r[3],r[0],n.bottomLeftOuter,n.bottomLeftInner,n.topLeftOuter,n.topLeftInner)}}return i})}function c(t,e,n,r){var i=(Math.sqrt(2)-1)/3*4,o=n*i,a=r*i,s=t+n,c=e+r;return{topLeft:u({x:t,y:c},{x:t,y:c-a},{x:s-o,y:e},{x:s,y:e}),topRight:u({x:t,y:e},{x:t+o,y:e},{x:s,y:c-a},{x:s,y:c}),bottomRight:u({x:s,y:e},{x:s,y:e+a},{x:t+o,y:c},{x:t,y:c}),bottomLeft:u({x:s,y:c},{x:s-o,y:c},{x:t,y:e+a},{x:t,y:e})}}function l(t,e,n){var r=t.left,i=t.top,o=t.width,a=t.height,s=e[0][0]<o/2?e[0][0]:o/2,l=e[0][1]<a/2?e[0][1]:a/2,u=e[1][0]<o/2?e[1][0]:o/2,h=e[1][1]<a/2?e[1][1]:a/2,f=e[2][0]<o/2?e[2][0]:o/2,d=e[2][1]<a/2?e[2][1]:a/2,p=e[3][0]<o/2?e[3][0]:o/2,m=e[3][1]<a/2?e[3][1]:a/2,g=o-u,w=a-d,y=o-f,v=a-m;return{topLeftOuter:c(r,i,s,l).topLeft.subdivide(.5),topLeftInner:c(r+n[3].width,i+n[0].width,Math.max(0,s-n[3].width),Math.max(0,l-n[0].width)).topLeft.subdivide(.5),topRightOuter:c(r+g,i,u,h).topRight.subdivide(.5),topRightInner:c(r+Math.min(g,o+n[3].width),i+n[0].width,g>o+n[3].width?0:u-n[3].width,h-n[0].width).topRight.subdivide(.5),bottomRightOuter:c(r+y,i+w,f,d).bottomRight.subdivide(.5),bottomRightInner:c(r+Math.min(y,o-n[3].width),i+Math.min(w,a+n[0].width),Math.max(0,f-n[1].width),d-n[2].width).bottomRight.subdivide(.5),bottomLeftOuter:c(r,i+v,p,m).bottomLeft.subdivide(.5),bottomLeftInner:c(r+n[3].width,i+v,Math.max(0,p-n[3].width),m-n[2].width).bottomLeft.subdivide(.5)}}function u(t,e,n,r){var i=function(t,e,n){return{x:t.x+(e.x-t.x)*n,y:t.y+(e.y-t.y)*n}};return{start:t,startControl:e,endControl:n,end:r,subdivide:function(o){var a=i(t,e,o),s=i(e,n,o),c=i(n,r,o),l=i(a,s,o),h=i(s,c,o),f=i(l,h,o);return[u(t,a,l,f),u(f,h,c,r)]},curveTo:function(t){t.push(["bezierCurve",e.x,e.y,n.x,n.y,r.x,r.y])},curveToReversed:function(r){r.push(["bezierCurve",n.x,n.y,e.x,e.y,t.x,t.y])}}}function h(t,e,n,r,i,o,a){var s=[];return e[0]>0||e[1]>0?(s.push(["line",r[1].start.x,r[1].start.y]),r[1].curveTo(s)):s.push(["line",t.c1[0],t.c1[1]]),n[0]>0||n[1]>0?(s.push(["line",o[0].start.x,o[0].start.y]),o[0].curveTo(s),s.push(["line",a[0].end.x,a[0].end.y]),a[0].curveToReversed(s)):(s.push(["line",t.c2[0],t.c2[1]]),s.push(["line",t.c3[0],t.c3[1]])),e[0]>0||e[1]>0?(s.push(["line",i[1].end.x,i[1].end.y]),i[1].curveToReversed(s)):s.push(["line",t.c4[0],t.c4[1]]),s}function f(t,e,n,r,i,o,a){e[0]>0||e[1]>0?(t.push(["line",r[0].start.x,r[0].start.y]),r[0].curveTo(t),r[1].curveTo(t)):t.push(["line",o,a]),(n[0]>0||n[1]>0)&&t.push(["line",i[0].start.x,i[0].start.y])}function d(t){return t.cssInt("zIndex")<0}function p(t){return t.cssInt("zIndex")>0}function m(t){return 0===t.cssInt("zIndex")}function g(t){return-1!==["inline","inline-block","inline-table"].indexOf(t.css("display"))}function w(t){return t instanceof G}function y(t){return t.node.data.trim().length>0}function v(t){return/^(normal|none|0px)$/.test(t.parent.css("letterSpacing"))}function b(t){return["TopLeft","TopRight","BottomRight","BottomLeft"].map(function(e){var n=t.css("border"+e+"Radius").split(" ");return n.length<=1&&(n[1]=n[0]),n.map(O)})}function x(t){return t.nodeType===Node.TEXT_NODE||t.nodeType===Node.ELEMENT_NODE}function k(t){var e=t.css("position");return"auto"!==(-1!==["absolute","relative","fixed"].indexOf(e)?t.css("zIndex"):"auto")}function _(t){return"static"!==t.css("position")}function C(t){return"none"!==t.css("float")}function A(t){return-1!==["inline-block","inline-table"].indexOf(t.css("display"))}function S(t){var e=this;return function(){return!t.apply(e,arguments)}}function q(t){return t.node.nodeType===Node.ELEMENT_NODE}function T(t){return!0===t.isPseudoElement}function P(t){return t.node.nodeType===Node.TEXT_NODE}function I(t){return function(e,n){return e.cssInt("zIndex")+t.indexOf(e)/t.length-(n.cssInt("zIndex")+t.indexOf(n)/t.length)}}function E(t){return t.getOpacity()<1}function O(t){return parseInt(t,10)}function F(t){return t.width}function B(t){return t.node.nodeType!==Node.ELEMENT_NODE||-1===["SCRIPT","HEAD","TITLE","OBJECT","BR","OPTION"].indexOf(t.node.nodeName)}function R(t){return[].concat.apply([],t)}function D(t){var e=t.substr(0,1);return e===t.substr(t.length-1)&&e.match(/'|"/)?t.substr(1,t.length-2):t}function j(t){for(var e,n=[],r=0,i=!1;t.length;)z(t[r])===i?((e=t.splice(0,r)).length&&n.push(M.ucs2.encode(e)),i=!i,r=0):r++,r>=t.length&&(e=t.splice(0,r)).length&&n.push(M.ucs2.encode(e));return n}function z(t){return-1!==[32,13,10,9,45].indexOf(t)}function N(t){return/[^\u0000-\u00ff]/.test(t)}var L=t("./log"),M=t("punycode"),U=t("./nodecontainer"),H=t("./textcontainer"),W=t("./pseudoelementcontainer"),X=t("./fontmetrics"),V=t("./color"),G=t("./stackingcontext"),Y=t("./utils"),J=Y.bind,Q=Y.getBounds,K=Y.parseBackgrounds,$=Y.offsetBounds;r.prototype.calculateOverflowClips=function(){this.nodes.forEach(function(t){if(q(t)){T(t)&&t.appendToDOM(),t.borders=this.parseBorders(t);var e="hidden"===t.css("overflow")?[t.borders.clip]:[],n=t.parseClip();n&&-1!==["absolute","fixed"].indexOf(t.css("position"))&&e.push([["rect",t.bounds.left+n.left,t.bounds.top+n.top,n.right-n.left,n.bottom-n.top]]),t.clip=i(t)?t.parent.clip.concat(e):e,t.backgroundClip="hidden"!==t.css("overflow")?t.clip.concat([t.borders.clip]):t.clip,T(t)&&t.cleanDOM()}else P(t)&&(t.clip=i(t)?t.parent.clip:[]);T(t)||(t.bounds=null)},this)},r.prototype.asyncRenderer=function(t,e,n){n=n||Date.now(),this.paint(t[this.renderIndex++]),t.length===this.renderIndex?e():n+20>Date.now()?this.asyncRenderer(t,e,n):setTimeout(J(function(){this.asyncRenderer(t,e)},this),0)},r.prototype.createPseudoHideStyles=function(t){this.createStyles(t,"."+W.prototype.PSEUDO_HIDE_ELEMENT_CLASS_BEFORE+':before { content: "" !important; display: none !important; }.'+W.prototype.PSEUDO_HIDE_ELEMENT_CLASS_AFTER+':after { content: "" !important; display: none !important; }')},r.prototype.disableAnimations=function(t){this.createStyles(t,"* { -webkit-animation: none !important; -moz-animation: none !important; -o-animation: none !important; animation: none !important; -webkit-transition: none !important; -moz-transition: none !important; -o-transition: none !important; transition: none !important;}")},r.prototype.createStyles=function(t,e){var n=t.createElement("style");n.innerHTML=e,t.body.appendChild(n)},r.prototype.getPseudoElements=function(t){var e=[[t]];if(t.node.nodeType===Node.ELEMENT_NODE){var n=this.getPseudoElement(t,":before"),r=this.getPseudoElement(t,":after");n&&e.push(n),r&&e.push(r)}return R(e)},r.prototype.getPseudoElement=function(t,e){var n=t.computedStyle(e);if(!n||!n.content||"none"===n.content||"-moz-alt-content"===n.content||"none"===n.display)return null;for(var r=D(n.content),i="url"===r.substr(0,3),a=document.createElement(i?"img":"html2canvaspseudoelement"),s=new W(a,t,e),c=n.length-1;c>=0;c--){var l=o(n.item(c));a.style[l]=n[l]}if(a.className=W.prototype.PSEUDO_HIDE_ELEMENT_CLASS_BEFORE+" "+W.prototype.PSEUDO_HIDE_ELEMENT_CLASS_AFTER,i)return a.src=K(r)[0].args[0],[s];var u=document.createTextNode(r);return a.appendChild(u),[s,new H(u,s)]},r.prototype.getChildren=function(t){return R([].filter.call(t.node.childNodes,x).map(function(e){var n=[e.nodeType===Node.TEXT_NODE?new H(e,t):new U(e,t)].filter(B);return e.nodeType===Node.ELEMENT_NODE&&n.length&&"TEXTAREA"!==e.tagName?n[0].isElementVisible()?n.concat(this.getChildren(n[0])):[]:n},this))},r.prototype.newStackingContext=function(t,e){var n=new G(e,t.getOpacity(),t.node,t.parent);t.cloneTo(n),(e?n.getParentStack(this):n.parent.stack).contexts.push(n),t.stack=n},r.prototype.createStackingContexts=function(){this.nodes.forEach(function(t){q(t)&&(this.isRootElement(t)||E(t)||k(t)||this.isBodyWithTransparentRoot(t)||t.hasTransform())?this.newStackingContext(t,!0):q(t)&&(_(t)&&m(t)||A(t)||C(t))?this.newStackingContext(t,!1):t.assignStack(t.parent.stack)},this)},r.prototype.isBodyWithTransparentRoot=function(t){return"BODY"===t.node.nodeName&&t.parent.color("backgroundColor").isTransparent()},r.prototype.isRootElement=function(t){return null===t.parent},r.prototype.sortStackingContexts=function(t){t.contexts.sort(I(t.contexts.slice(0))),t.contexts.forEach(this.sortStackingContexts,this)},r.prototype.parseTextBounds=function(t){return function(e,n,r){if("none"!==t.parent.css("textDecoration").substr(0,4)||0!==e.trim().length){if(this.support.rangeBounds&&!t.parent.hasTransform()){var i=r.slice(0,n).join("").length;return this.getRangeBounds(t.node,i,e.length)}if(t.node&&"string"==typeof t.node.data){var o=t.node.splitText(e.length),a=this.getWrapperBounds(t.node,t.parent.hasTransform());return t.node=o,a}}else this.support.rangeBounds&&!t.parent.hasTransform()||(t.node=t.node.splitText(e.length));return{}}},r.prototype.getWrapperBounds=function(t,e){var n=t.ownerDocument.createElement("html2canvaswrapper"),r=t.parentNode,i=t.cloneNode(!0);n.appendChild(t.cloneNode(!0)),r.replaceChild(n,t);var o=e?$(n):Q(n);return r.replaceChild(i,n),o},r.prototype.getRangeBounds=function(t,e,n){var r=this.range||(this.range=t.ownerDocument.createRange());return r.setStart(t,e),r.setEnd(t,e+n),r.getBoundingClientRect()},r.prototype.parse=function(t){var e=t.contexts.filter(d),n=t.children.filter(q),r=n.filter(S(C)),i=r.filter(S(_)).filter(S(g)),o=n.filter(S(_)).filter(C),s=r.filter(S(_)).filter(g),c=t.contexts.concat(r.filter(_)).filter(m),l=t.children.filter(P).filter(y),u=t.contexts.filter(p);e.concat(i).concat(o).concat(s).concat(c).concat(l).concat(u).forEach(function(t){this.renderQueue.push(t),w(t)&&(this.parse(t),this.renderQueue.push(new a))},this)},r.prototype.paint=function(t){try{t instanceof a?this.renderer.ctx.restore():P(t)?(T(t.parent)&&t.parent.appendToDOM(),this.paintText(t),T(t.parent)&&t.parent.cleanDOM()):this.paintNode(t)}catch(t){if(L(t),this.options.strict)throw t}},r.prototype.paintNode=function(t){w(t)&&(this.renderer.setOpacity(t.opacity),this.renderer.ctx.save(),t.hasTransform()&&this.renderer.setTransform(t.parseTransform())),"INPUT"===t.node.nodeName&&"checkbox"===t.node.type?this.paintCheckbox(t):"INPUT"===t.node.nodeName&&"radio"===t.node.type?this.paintRadio(t):this.paintElement(t)},r.prototype.paintElement=function(t){var e=t.parseBounds();this.renderer.clip(t.backgroundClip,function(){this.renderer.renderBackground(t,e,t.borders.borders.map(F))},this),this.renderer.clip(t.clip,function(){this.renderer.renderBorders(t.borders.borders)},this),this.renderer.clip(t.backgroundClip,function(){switch(t.node.nodeName){case"svg":case"IFRAME":var n=this.images.get(t.node);n?this.renderer.renderImage(t,e,t.borders,n):L("Error loading <"+t.node.nodeName+">",t.node);break;case"IMG":var r=this.images.get(t.node.src);r?this.renderer.renderImage(t,e,t.borders,r):L("Error loading <img>",t.node.src);break;case"CANVAS":this.renderer.renderImage(t,e,t.borders,{image:t.node});break;case"SELECT":case"INPUT":case"TEXTAREA":this.paintFormValue(t)}},this)},r.prototype.paintCheckbox=function(t){var e=t.parseBounds(),n=Math.min(e.width,e.height),r={width:n-1,height:n-1,top:e.top,left:e.left},i=[3,3],o=[i,i,i,i],a=[1,1,1,1].map(function(t){return{color:new V("#A5A5A5"),width:t}}),c=l(r,o,a);this.renderer.clip(t.backgroundClip,function(){this.renderer.rectangle(r.left+1,r.top+1,r.width-2,r.height-2,new V("#DEDEDE")),this.renderer.renderBorders(s(a,r,c,o)),t.node.checked&&(this.renderer.font(new V("#424242"),"normal","normal","bold",n-3+"px","arial"),this.renderer.text("✔",r.left+n/6,r.top+n-1))},this)},r.prototype.paintRadio=function(t){var e=t.parseBounds(),n=Math.min(e.width,e.height)-2;this.renderer.clip(t.backgroundClip,function(){this.renderer.circleStroke(e.left+1,e.top+1,n,new V("#DEDEDE"),1,new V("#A5A5A5")),t.node.checked&&this.renderer.circle(Math.ceil(e.left+n/4)+1,Math.ceil(e.top+n/4)+1,Math.floor(n/2),new V("#424242"))},this)},r.prototype.paintFormValue=function(t){var e=t.getValue();if(e.length>0){var n=t.node.ownerDocument,r=n.createElement("html2canvaswrapper");["lineHeight","textAlign","fontFamily","fontWeight","fontSize","color","paddingLeft","paddingTop","paddingRight","paddingBottom","width","height","borderLeftStyle","borderTopStyle","borderLeftWidth","borderTopWidth","boxSizing","whiteSpace","wordWrap"].forEach(function(e){try{r.style[e]=t.css(e)}catch(t){L("html2canvas: Parse: Exception caught in renderFormValue: "+t.message)}});var i=t.parseBounds();r.style.position="fixed",r.style.left=i.left+"px",r.style.top=i.top+"px",r.textContent=e,n.body.appendChild(r),this.paintText(new H(r.firstChild,t)),n.body.removeChild(r)}},r.prototype.paintText=function(t){t.applyTextTransform();var e=M.ucs2.decode(t.node.data),n=this.options.letterRendering&&!v(t)||N(t.node.data)?e.map(function(t){return M.ucs2.encode([t])}):j(e),r=t.parent.fontWeight(),i=t.parent.css("fontSize"),o=t.parent.css("fontFamily"),a=t.parent.parseTextShadows();this.renderer.font(t.parent.color("color"),t.parent.css("fontStyle"),t.parent.css("fontVariant"),r,i,o),a.length?this.renderer.fontShadow(a[0].color,a[0].offsetX,a[0].offsetY,a[0].blur):this.renderer.clearShadow(),this.renderer.clip(t.parent.clip,function(){n.map(this.parseTextBounds(t),this).forEach(function(e,r){e&&(this.renderer.text(n[r],e.left,e.bottom),this.renderTextDecoration(t.parent,e,this.fontMetrics.getMetrics(o,i)))},this)},this)},r.prototype.renderTextDecoration=function(t,e,n){switch(t.css("textDecoration").split(" ")[0]){case"underline":this.renderer.rectangle(e.left,Math.round(e.top+n.baseline+n.lineWidth),e.width,1,t.color("color"));break;case"overline":this.renderer.rectangle(e.left,Math.round(e.top),e.width,1,t.color("color"));break;case"line-through":this.renderer.rectangle(e.left,Math.ceil(e.top+n.middle+n.lineWidth),e.width,1,t.color("color"))}};var Z={inset:[["darken",.6],["darken",.1],["darken",.1],["darken",.6]]};r.prototype.parseBorders=function(t){var e=t.parseBounds(),n=b(t),r=["Top","Right","Bottom","Left"].map(function(e,n){var r=t.css("border"+e+"Style"),i=t.color("border"+e+"Color");"inset"===r&&i.isBlack()&&(i=new V([255,255,255,i.a]));var o=Z[r]?Z[r][n]:null;return{width:t.cssInt("border"+e+"Width"),color:o?i[o[0]](o[1]):i,args:null}}),i=l(e,n,r);return{clip:this.parseBackgroundClip(t,i,r,n,e),borders:s(r,e,i,n)}},r.prototype.parseBackgroundClip=function(t,e,n,r,i){var o=[];switch(t.css("backgroundClip")){case"content-box":case"padding-box":f(o,r[0],r[1],e.topLeftInner,e.topRightInner,i.left+n[3].width,i.top+n[0].width),f(o,r[1],r[2],e.topRightInner,e.bottomRightInner,i.left+i.width-n[1].width,i.top+n[0].width),f(o,r[2],r[3],e.bottomRightInner,e.bottomLeftInner,i.left+i.width-n[1].width,i.top+i.height-n[2].width),f(o,r[3],r[0],e.bottomLeftInner,e.topLeftInner,i.left+n[3].width,i.top+i.height-n[2].width);break;default:f(o,r[0],r[1],e.topLeftOuter,e.topRightOuter,i.left,i.top),f(o,r[1],r[2],e.topRightOuter,e.bottomRightOuter,i.left+i.width,i.top),f(o,r[2],r[3],e.bottomRightOuter,e.bottomLeftOuter,i.left+i.width,i.top+i.height),f(o,r[3],r[0],e.bottomLeftOuter,e.topLeftOuter,i.left,i.top+i.height)}return o},e.exports=r},{"./color":3,"./fontmetrics":7,"./log":13,"./nodecontainer":14,"./pseudoelementcontainer":18,"./stackingcontext":21,"./textcontainer":25,"./utils":26,punycode:1}],16:[function(t,e,n){function r(t,e,n){var r="withCredentials"in new XMLHttpRequest;if(!e)return Promise.reject("No proxy configured");var s=o(r),l=a(e,t,s);return r?c(l):i(n,l,s).then(function(t){return f(t.content)})}function i(t,e,n){return new Promise(function(r,i){var o=t.createElement("script"),a=function(){delete window.html2canvas.proxy[n],t.body.removeChild(o)};window.html2canvas.proxy[n]=function(t){a(),r(t)},o.src=e,o.onerror=function(t){a(),i(t)},t.body.appendChild(o)})}function o(t){return t?"":"html2canvas_"+Date.now()+"_"+ ++d+"_"+Math.round(1e5*Math.random())}function a(t,e,n){return t+"?url="+encodeURIComponent(e)+(n.length?"&callback=html2canvas.proxy."+n:"")}function s(t){return function(e){var n,r=new DOMParser;try{n=r.parseFromString(e,"text/html")}catch(t){u("DOMParser not supported, falling back to createHTMLDocument"),n=document.implementation.createHTMLDocument("");try{n.open(),n.write(e),n.close()}catch(t){u("createHTMLDocument write not supported, falling back to document.body.innerHTML"),n.body.innerHTML=e}}var i=n.querySelector("base");if(!i||!i.href.host){var o=n.createElement("base");o.href=t,n.head.insertBefore(o,n.head.firstChild)}return n}}var c=t("./xhr"),l=t("./utils"),u=t("./log"),h=t("./clone"),f=l.decode64,d=0;n.Proxy=r,n.ProxyURL=function(t,e,n){var r="crossOrigin"in new Image,s=o(r),c=a(e,t,s);return r?Promise.resolve(c):i(n,c,s).then(function(t){return"data:"+t.type+";base64,"+t.content})},n.loadUrlDocument=function(t,e,n,i,o,a){return new r(t,e,window.document).then(s(t)).then(function(t){return h(t,n,i,o,a,0,0)})}},{"./clone":2,"./log":13,"./utils":26,"./xhr":28}],17:[function(t,e,n){var r=t("./proxy").ProxyURL;e.exports=function(t,e){var n=document.createElement("a");n.href=t,t=n.href,this.src=t,this.image=new Image;var i=this;this.promise=new Promise(function(n,o){i.image.crossOrigin="Anonymous",i.image.onload=n,i.image.onerror=o,new r(t,e,document).then(function(t){i.image.src=t}).catch(o)})}},{"./proxy":16}],18:[function(t,e,n){function r(t,e,n){i.call(this,t,e),this.isPseudoElement=!0,this.before=":before"===n}var i=t("./nodecontainer");r.prototype.cloneTo=function(t){r.prototype.cloneTo.call(this,t),t.isPseudoElement=!0,t.before=this.before},(r.prototype=Object.create(i.prototype)).appendToDOM=function(){this.before?this.parent.node.insertBefore(this.node,this.parent.node.firstChild):this.parent.node.appendChild(this.node),this.parent.node.className+=" "+this.getHideClass()},r.prototype.cleanDOM=function(){this.node.parentNode.removeChild(this.node),this.parent.node.className=this.parent.node.className.replace(this.getHideClass(),"")},r.prototype.getHideClass=function(){return this["PSEUDO_HIDE_ELEMENT_CLASS_"+(this.before?"BEFORE":"AFTER")]},r.prototype.PSEUDO_HIDE_ELEMENT_CLASS_BEFORE="___html2canvas___pseudoelement_before",r.prototype.PSEUDO_HIDE_ELEMENT_CLASS_AFTER="___html2canvas___pseudoelement_after",e.exports=r},{"./nodecontainer":14}],19:[function(t,e,n){function r(t,e,n,r,i){this.width=t,this.height=e,this.images=n,this.options=r,this.document=i}var i=t("./log");r.prototype.renderImage=function(t,e,n,r){var i=t.cssInt("paddingLeft"),o=t.cssInt("paddingTop"),a=t.cssInt("paddingRight"),s=t.cssInt("paddingBottom"),c=n.borders,l=e.width-(c[1].width+c[3].width+i+a),u=e.height-(c[0].width+c[2].width+o+s);this.drawImage(r,0,0,r.image.width||l,r.image.height||u,e.left+i+c[3].width,e.top+o+c[0].width,l,u)},r.prototype.renderBackground=function(t,e,n){e.height>0&&e.width>0&&(this.renderBackgroundColor(t,e),this.renderBackgroundImage(t,e,n))},r.prototype.renderBackgroundColor=function(t,e){var n=t.color("backgroundColor");n.isTransparent()||this.rectangle(e.left,e.top,e.width,e.height,n)},r.prototype.renderBorders=function(t){t.forEach(this.renderBorder,this)},r.prototype.renderBorder=function(t){t.color.isTransparent()||null===t.args||this.drawShape(t.args,t.color)},r.prototype.renderBackgroundImage=function(t,e,n){t.parseBackgroundImages().reverse().forEach(function(r,o,a){switch(r.method){case"url":var s=this.images.get(r.args[0]);s?this.renderBackgroundRepeating(t,e,s,a.length-(o+1),n):i("Error loading background-image",r.args[0]);break;case"linear-gradient":case"gradient":var c=this.images.get(r.value);c?this.renderBackgroundGradient(c,e,n):i("Error loading background-image",r.args[0]);break;case"none":break;default:i("Unknown background-image type",r.args[0])}},this)},r.prototype.renderBackgroundRepeating=function(t,e,n,r,i){var o=t.parseBackgroundSize(e,n.image,r),a=t.parseBackgroundPosition(e,n.image,r,o);switch(t.parseBackgroundRepeat(r)){case"repeat-x":case"repeat no-repeat":this.backgroundRepeatShape(n,a,o,e,e.left+i[3],e.top+a.top+i[0],99999,o.height,i);break;case"repeat-y":case"no-repeat repeat":this.backgroundRepeatShape(n,a,o,e,e.left+a.left+i[3],e.top+i[0],o.width,99999,i);break;case"no-repeat":this.backgroundRepeatShape(n,a,o,e,e.left+a.left+i[3],e.top+a.top+i[0],o.width,o.height,i);break;default:this.renderBackgroundRepeat(n,a,o,{top:e.top,left:e.left},i[3],i[0])}},e.exports=r},{"./log":13}],20:[function(t,e,n){function r(t,e){o.apply(this,arguments),this.canvas=this.options.canvas||this.document.createElement("canvas"),this.options.canvas||(this.canvas.width=t,this.canvas.height=e),this.ctx=this.canvas.getContext("2d"),this.taintCtx=this.document.createElement("canvas").getContext("2d"),this.ctx.textBaseline="bottom",this.variables={},s("Initialized CanvasRenderer with size",t,"x",e)}function i(t){return t.length>0}var o=t("../renderer"),a=t("../lineargradientcontainer"),s=t("../log");(r.prototype=Object.create(o.prototype)).setFillStyle=function(t){return this.ctx.fillStyle="object"==typeof t&&t.isColor?t.toString():t,this.ctx},r.prototype.rectangle=function(t,e,n,r,i){this.setFillStyle(i).fillRect(t,e,n,r)},r.prototype.circle=function(t,e,n,r){this.setFillStyle(r),this.ctx.beginPath(),this.ctx.arc(t+n/2,e+n/2,n/2,0,2*Math.PI,!0),this.ctx.closePath(),this.ctx.fill()},r.prototype.circleStroke=function(t,e,n,r,i,o){this.circle(t,e,n,r),this.ctx.strokeStyle=o.toString(),this.ctx.stroke()},r.prototype.drawShape=function(t,e){this.shape(t),this.setFillStyle(e).fill()},r.prototype.taints=function(t){if(null===t.tainted){this.taintCtx.drawImage(t.image,0,0);try{this.taintCtx.getImageData(0,0,1,1),t.tainted=!1}catch(e){this.taintCtx=document.createElement("canvas").getContext("2d"),t.tainted=!0}}return t.tainted},r.prototype.drawImage=function(t,e,n,r,i,o,a,s,c){this.taints(t)&&!this.options.allowTaint||this.ctx.drawImage(t.image,e,n,r,i,o,a,s,c)},r.prototype.clip=function(t,e,n){this.ctx.save(),t.filter(i).forEach(function(t){this.shape(t).clip()},this),e.call(n),this.ctx.restore()},r.prototype.shape=function(t){return this.ctx.beginPath(),t.forEach(function(t,e){"rect"===t[0]?this.ctx.rect.apply(this.ctx,t.slice(1)):this.ctx[0===e?"moveTo":t[0]+"To"].apply(this.ctx,t.slice(1))},this),this.ctx.closePath(),this.ctx},r.prototype.font=function(t,e,n,r,i,o){this.setFillStyle(t).font=[e,n,r,i,o].join(" ").split(",")[0]},r.prototype.fontShadow=function(t,e,n,r){this.setVariable("shadowColor",t.toString()).setVariable("shadowOffsetY",e).setVariable("shadowOffsetX",n).setVariable("shadowBlur",r)},r.prototype.clearShadow=function(){this.setVariable("shadowColor","rgba(0,0,0,0)")},r.prototype.setOpacity=function(t){this.ctx.globalAlpha=t},r.prototype.setTransform=function(t){this.ctx.translate(t.origin[0],t.origin[1]),this.ctx.transform.apply(this.ctx,t.matrix),this.ctx.translate(-t.origin[0],-t.origin[1])},r.prototype.setVariable=function(t,e){return this.variables[t]!==e&&(this.variables[t]=this.ctx[t]=e),this},r.prototype.text=function(t,e,n){this.ctx.fillText(t,e,n)},r.prototype.backgroundRepeatShape=function(t,e,n,r,i,o,a,s,c){var l=[["line",Math.round(i),Math.round(o)],["line",Math.round(i+a),Math.round(o)],["line",Math.round(i+a),Math.round(s+o)],["line",Math.round(i),Math.round(s+o)]];this.clip([l],function(){this.renderBackgroundRepeat(t,e,n,r,c[3],c[0])},this)},r.prototype.renderBackgroundRepeat=function(t,e,n,r,i,o){var a=Math.round(r.left+e.left+i),s=Math.round(r.top+e.top+o);this.setFillStyle(this.ctx.createPattern(this.resizeImage(t,n),"repeat")),this.ctx.translate(a,s),this.ctx.fill(),this.ctx.translate(-a,-s)},r.prototype.renderBackgroundGradient=function(t,e){if(t instanceof a){var n=this.ctx.createLinearGradient(e.left+e.width*t.x0,e.top+e.height*t.y0,e.left+e.width*t.x1,e.top+e.height*t.y1);t.colorStops.forEach(function(t){n.addColorStop(t.stop,t.color.toString())}),this.rectangle(e.left,e.top,e.width,e.height,n)}},r.prototype.resizeImage=function(t,e){var n=t.image;if(n.width===e.width&&n.height===e.height)return n;var r=document.createElement("canvas");return r.width=e.width,r.height=e.height,r.getContext("2d").drawImage(n,0,0,n.width,n.height,0,0,e.width,e.height),r},e.exports=r},{"../lineargradientcontainer":12,"../log":13,"../renderer":19}],21:[function(t,e,n){function r(t,e,n,r){i.call(this,n,r),this.ownStacking=t,this.contexts=[],this.children=[],this.opacity=(this.parent?this.parent.stack.opacity:1)*e}var i=t("./nodecontainer");(r.prototype=Object.create(i.prototype)).getParentStack=function(t){var e=this.parent?this.parent.stack:null;return e?e.ownStacking?e:e.getParentStack(t):t.stack},e.exports=r},{"./nodecontainer":14}],22:[function(t,e,n){function r(t){this.rangeBounds=this.testRangeBounds(t),this.cors=this.testCORS(),this.svg=this.testSVG()}r.prototype.testRangeBounds=function(t){var e,n,r=!1;return t.createRange&&(e=t.createRange()).getBoundingClientRect&&((n=t.createElement("boundtest")).style.height="123px",n.style.display="block",t.body.appendChild(n),e.selectNode(n),123===e.getBoundingClientRect().height&&(r=!0),t.body.removeChild(n)),r},r.prototype.testCORS=function(){return void 0!==(new Image).crossOrigin},r.prototype.testSVG=function(){var t=new Image,e=document.createElement("canvas"),n=e.getContext("2d");t.src="data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>";try{n.drawImage(t,0,0),e.toDataURL()}catch(t){return!1}return!0},e.exports=r},{}],23:[function(t,e,n){function r(t){this.src=t,this.image=null;var e=this;this.promise=this.hasFabric().then(function(){return e.isInline(t)?Promise.resolve(e.inlineFormatting(t)):i(t)}).then(function(t){return new Promise(function(n){window.html2canvas.svg.fabric.loadSVGFromString(t,e.createCanvas.call(e,n))})})}var i=t("./xhr"),o=t("./utils").decode64;r.prototype.hasFabric=function(){return window.html2canvas.svg&&window.html2canvas.svg.fabric?Promise.resolve():Promise.reject(new Error("html2canvas.svg.js is not loaded, cannot render svg"))},r.prototype.inlineFormatting=function(t){return/^data:image\/svg\+xml;base64,/.test(t)?this.decode64(this.removeContentType(t)):this.removeContentType(t)},r.prototype.removeContentType=function(t){return t.replace(/^data:image\/svg\+xml(;base64)?,/,"")},r.prototype.isInline=function(t){return/^data:image\/svg\+xml/i.test(t)},r.prototype.createCanvas=function(t){var e=this;return function(n,r){var i=new window.html2canvas.svg.fabric.StaticCanvas("c");e.image=i.lowerCanvasEl,i.setWidth(r.width).setHeight(r.height).add(window.html2canvas.svg.fabric.util.groupSVGElements(n,r)).renderAll(),t(i.lowerCanvasEl)}},r.prototype.decode64=function(t){return"function"==typeof window.atob?window.atob(t):o(t)},e.exports=r},{"./utils":26,"./xhr":28}],24:[function(t,e,n){function r(t,e){this.src=t,this.image=null;var n=this;this.promise=e?new Promise(function(e,r){n.image=new Image,n.image.onload=e,n.image.onerror=r,n.image.src="data:image/svg+xml,"+(new XMLSerializer).serializeToString(t),!0===n.image.complete&&e(n.image)}):this.hasFabric().then(function(){return new Promise(function(e){window.html2canvas.svg.fabric.parseSVGDocument(t,n.createCanvas.call(n,e))})})}var i=t("./svgcontainer");r.prototype=Object.create(i.prototype),e.exports=r},{"./svgcontainer":23}],25:[function(t,e,n){function r(t,e){o.call(this,t,e)}function i(t,e,n){if(t.length>0)return e+n.toUpperCase()}var o=t("./nodecontainer");(r.prototype=Object.create(o.prototype)).applyTextTransform=function(){this.node.data=this.transform(this.parent.css("textTransform"))},r.prototype.transform=function(t){var e=this.node.data;switch(t){case"lowercase":return e.toLowerCase();case"capitalize":return e.replace(/(^|\s|:|-|\(|\))([a-z])/g,i);case"uppercase":return e.toUpperCase();default:return e}},e.exports=r},{"./nodecontainer":14}],26:[function(t,e,n){n.smallImage=function(){return"data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"},n.bind=function(t,e){return function(){return t.apply(e,arguments)}},/*
	 * base64-arraybuffer
	 * https://github.com/niklasvh/base64-arraybuffer
	 *
	 * Copyright (c) 2012 Niklas von Hertzen
	 * Licensed under the MIT license.
	 */
	n.decode64=function(t){var e,n,r,i,o,a,s,c="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",l=t.length,u="";for(e=0;e<l;e+=4)o=c.indexOf(t[e])<<2|(n=c.indexOf(t[e+1]))>>4,a=(15&n)<<4|(r=c.indexOf(t[e+2]))>>2,s=(3&r)<<6|(i=c.indexOf(t[e+3])),u+=64===r?String.fromCharCode(o):64===i||-1===i?String.fromCharCode(o,a):String.fromCharCode(o,a,s);return u},n.getBounds=function(t){if(t.getBoundingClientRect){var e=t.getBoundingClientRect(),n=null==t.offsetWidth?e.width:t.offsetWidth;return{top:e.top,bottom:e.bottom||e.top+e.height,right:e.left+n,left:e.left,width:n,height:null==t.offsetHeight?e.height:t.offsetHeight}}return{}},n.offsetBounds=function(t){var e=t.offsetParent?n.offsetBounds(t.offsetParent):{top:0,left:0};return{top:t.offsetTop+e.top,bottom:t.offsetTop+t.offsetHeight+e.top,right:t.offsetLeft+e.left+t.offsetWidth,left:t.offsetLeft+e.left,width:t.offsetWidth,height:t.offsetHeight}},n.parseBackgrounds=function(t){var e,n,r,i,o,a,s,c=[],l=0,u=0,h=function(){e&&('"'===n.substr(0,1)&&(n=n.substr(1,n.length-2)),n&&s.push(n),"-"===e.substr(0,1)&&(i=e.indexOf("-",1)+1)>0&&(r=e.substr(0,i),e=e.substr(i)),c.push({prefix:r,method:e.toLowerCase(),value:o,args:s,image:null})),s=[],e=r=n=o=""};return s=[],e=r=n=o="",t.split("").forEach(function(t){if(!(0===l&&" \r\n\t".indexOf(t)>-1)){switch(t){case'"':a?a===t&&(a=null):a=t;break;case"(":if(a)break;if(0===l)return l=1,void(o+=t);u++;break;case")":if(a)break;if(1===l){if(0===u)return l=0,o+=t,void h();u--}break;case",":if(a)break;if(0===l)return void h();if(1===l&&0===u&&!e.match(/^url$/i))return s.push(n),n="",void(o+=t)}o+=t,0===l?e+=t:n+=t}}),h(),c}},{}],27:[function(t,e,n){function r(t){i.apply(this,arguments),this.type="linear"===t.args[0]?i.TYPES.LINEAR:i.TYPES.RADIAL}var i=t("./gradientcontainer");r.prototype=Object.create(i.prototype),e.exports=r},{"./gradientcontainer":9}],28:[function(t,e,n){e.exports=function(t){return new Promise(function(e,n){var r=new XMLHttpRequest;r.open("GET",t),r.onload=function(){200===r.status?e(r.responseText):n(new Error(r.statusText))},r.onerror=function(){n(new Error("Network Error"))},r.send()})}},{}]},{},[4])(4)}),/*
	# PNG.js
	# Copyright (c) 2011 Devon Govett
	# MIT LICENSE
	# 
	# 
	*/
	function(t){var e;e=function(){function e(t){var e,n,r,i,o,a,s,c,l,u,h,f,d,p,m;for(this.data=t,this.pos=8,this.palette=[],this.imgData=[],this.transparency={},this.animation=null,this.text={},a=null;;){switch(e=this.readUInt32(),u=function(){var t,e;for(e=[],s=t=0;t<4;s=++t)e.push(String.fromCharCode(this.data[this.pos++]));return e}.call(this).join("")){case"IHDR":this.width=this.readUInt32(),this.height=this.readUInt32(),this.bits=this.data[this.pos++],this.colorType=this.data[this.pos++],this.compressionMethod=this.data[this.pos++],this.filterMethod=this.data[this.pos++],this.interlaceMethod=this.data[this.pos++];break;case"acTL":this.animation={numFrames:this.readUInt32(),numPlays:this.readUInt32()||1/0,frames:[]};break;case"PLTE":this.palette=this.read(e);break;case"fcTL":a&&this.animation.frames.push(a),this.pos+=4,a={width:this.readUInt32(),height:this.readUInt32(),xOffset:this.readUInt32(),yOffset:this.readUInt32()},o=this.readUInt16(),i=this.readUInt16()||100,a.delay=1e3*o/i,a.disposeOp=this.data[this.pos++],a.blendOp=this.data[this.pos++],a.data=[];break;case"IDAT":case"fdAT":for("fdAT"===u&&(this.pos+=4,e-=4),t=(null!=a?a.data:void 0)||this.imgData,s=d=0;0<=e?d<e:d>e;s=0<=e?++d:--d)t.push(this.data[this.pos++]);break;case"tRNS":switch(this.transparency={},this.colorType){case 3:if(r=this.palette.length/3,this.transparency.indexed=this.read(e),this.transparency.indexed.length>r)throw new Error("More transparent colors than palette size");if((h=r-this.transparency.indexed.length)>0)for(s=p=0;0<=h?p<h:p>h;s=0<=h?++p:--p)this.transparency.indexed.push(255);break;case 0:this.transparency.grayscale=this.read(e)[0];break;case 2:this.transparency.rgb=this.read(e)}break;case"tEXt":c=(f=this.read(e)).indexOf(0),l=String.fromCharCode.apply(String,f.slice(0,c)),this.text[l]=String.fromCharCode.apply(String,f.slice(c+1));break;case"IEND":return a&&this.animation.frames.push(a),this.colors=function(){switch(this.colorType){case 0:case 3:case 4:return 1;case 2:case 6:return 3}}.call(this),this.hasAlphaChannel=4===(m=this.colorType)||6===m,n=this.colors+(this.hasAlphaChannel?1:0),this.pixelBitlength=this.bits*n,this.colorSpace=function(){switch(this.colors){case 1:return"DeviceGray";case 3:return"DeviceRGB"}}.call(this),void(this.imgData=new Uint8Array(this.imgData));default:this.pos+=e}if(this.pos+=4,this.pos>this.data.length)throw new Error("Incomplete or corrupt PNG file")}}var n,r,i;e.load=function(t,n,r){var i;return"function"==typeof n&&(r=n),(i=new XMLHttpRequest).open("GET",t,!0),i.responseType="arraybuffer",i.onload=function(){var t,o;return t=new Uint8Array(i.response||i.mozResponseArrayBuffer),o=new e(t),"function"==typeof(null!=n?n.getContext:void 0)&&o.render(n),"function"==typeof r?r(o):void 0},i.send(null)},e.prototype.read=function(t){var e,n;for(n=[],e=0;0<=t?e<t:e>t;0<=t?++e:--e)n.push(this.data[this.pos++]);return n},e.prototype.readUInt32=function(){var t,e,n,r;return t=this.data[this.pos++]<<24,e=this.data[this.pos++]<<16,n=this.data[this.pos++]<<8,r=this.data[this.pos++],t|e|n|r},e.prototype.readUInt16=function(){var t,e;return t=this.data[this.pos++]<<8,e=this.data[this.pos++],t|e},e.prototype.decodePixels=function(t){var e,n,r,i,o,a,c,l,u,h,f,d,p,m,g,w,y,v,b,x,k,_,C;if(null==t&&(t=this.imgData),0===t.length)return new Uint8Array(0);for(t=(t=new s(t)).getBytes(),w=(d=this.pixelBitlength/8)*this.width,p=new Uint8Array(w*this.height),a=t.length,g=0,m=0,n=0;m<a;){switch(t[m++]){case 0:for(i=b=0;b<w;i=b+=1)p[n++]=t[m++];break;case 1:for(i=x=0;x<w;i=x+=1)e=t[m++],o=i<d?0:p[n-d],p[n++]=(e+o)%256;break;case 2:for(i=k=0;k<w;i=k+=1)e=t[m++],r=(i-i%d)/d,y=g&&p[(g-1)*w+r*d+i%d],p[n++]=(y+e)%256;break;case 3:for(i=_=0;_<w;i=_+=1)e=t[m++],r=(i-i%d)/d,o=i<d?0:p[n-d],y=g&&p[(g-1)*w+r*d+i%d],p[n++]=(e+Math.floor((o+y)/2))%256;break;case 4:for(i=C=0;C<w;i=C+=1)e=t[m++],r=(i-i%d)/d,o=i<d?0:p[n-d],0===g?y=v=0:(y=p[(g-1)*w+r*d+i%d],v=r&&p[(g-1)*w+(r-1)*d+i%d]),c=o+y-v,l=Math.abs(c-o),h=Math.abs(c-y),f=Math.abs(c-v),u=l<=h&&l<=f?o:h<=f?y:v,p[n++]=(e+u)%256;break;default:throw new Error("Invalid filter algorithm: "+t[m-1])}g++}return p},e.prototype.decodePalette=function(){var t,e,n,r,i,o,a,s,c;for(n=this.palette,o=this.transparency.indexed||[],i=new Uint8Array((o.length||0)+n.length),r=0,t=0,e=a=0,s=n.length;a<s;e=a+=3)i[r++]=n[e],i[r++]=n[e+1],i[r++]=n[e+2],i[r++]=null!=(c=o[t++])?c:255;return i},e.prototype.copyToImageData=function(t,e){var n,r,i,o,a,s,c,l,u,h,f;if(r=this.colors,u=null,n=this.hasAlphaChannel,this.palette.length&&(u=null!=(f=this._decodedPalette)?f:this._decodedPalette=this.decodePalette(),r=4,n=!0),i=t.data||t,l=i.length,a=u||e,o=s=0,1===r)for(;o<l;)c=u?4*e[o/4]:s,h=a[c++],i[o++]=h,i[o++]=h,i[o++]=h,i[o++]=n?a[c++]:255,s=c;else for(;o<l;)c=u?4*e[o/4]:s,i[o++]=a[c++],i[o++]=a[c++],i[o++]=a[c++],i[o++]=n?a[c++]:255,s=c},e.prototype.decode=function(){var t;return t=new Uint8Array(this.width*this.height*4),this.copyToImageData(t,this.decodePixels()),t};try{r=t.document.createElement("canvas"),i=r.getContext("2d")}catch(t){return-1}return n=function(t){var e;return i.width=t.width,i.height=t.height,i.clearRect(0,0,t.width,t.height),i.putImageData(t,0,0),e=new Image,e.src=r.toDataURL(),e},e.prototype.decodeFrames=function(t){var e,r,i,o,a,s,c,l;if(this.animation){for(l=[],r=a=0,s=(c=this.animation.frames).length;a<s;r=++a)e=c[r],i=t.createImageData(e.width,e.height),o=this.decodePixels(new Uint8Array(e.data)),this.copyToImageData(i,o),e.imageData=i,l.push(e.image=n(i));return l}},e.prototype.renderFrame=function(t,e){var n,r,i;return r=this.animation.frames,n=r[e],i=r[e-1],0===e&&t.clearRect(0,0,this.width,this.height),1===(null!=i?i.disposeOp:void 0)?t.clearRect(i.xOffset,i.yOffset,i.width,i.height):2===(null!=i?i.disposeOp:void 0)&&t.putImageData(i.imageData,i.xOffset,i.yOffset),0===n.blendOp&&t.clearRect(n.xOffset,n.yOffset,n.width,n.height),t.drawImage(n.image,n.xOffset,n.yOffset)},e.prototype.animate=function(t){var e,n,r,i,o,a,s=this;return n=0,a=this.animation,i=a.numFrames,r=a.frames,o=a.numPlays,(e=function(){var a,c;if(a=n++%i,c=r[a],s.renderFrame(t,a),i>1&&n/i<o)return s.animation._timeout=setTimeout(e,c.delay)})()},e.prototype.stopAnimation=function(){var t;return clearTimeout(null!=(t=this.animation)?t._timeout:void 0)},e.prototype.render=function(t){var e,n;return t._png&&t._png.stopAnimation(),t._png=this,t.width=this.width,t.height=this.height,e=t.getContext("2d"),this.animation?(this.decodeFrames(e),this.animate(e)):(n=e.createImageData(this.width,this.height),this.copyToImageData(n,this.decodePixels()),e.putImageData(n,0,0))},e}(),t.PNG=e}("undefined"!=typeof window&&window||void 0);/*
	 * Extracted from pdf.js
	 * https://github.com/andreasgal/pdf.js
	 *
	 * Copyright (c) 2011 Mozilla Foundation
	 *
	 * Contributors: Andreas Gal <gal@mozilla.com>
	 *               Chris G Jones <cjones@mozilla.com>
	 *               Shaon Barman <shaon.barman@gmail.com>
	 *               Vivien Nicolas <21@vingtetun.org>
	 *               Justin D'Arcangelo <justindarc@gmail.com>
	 *               Yury Delendik
	 *
	 * 
	 */
	var a=function(){function t(){this.pos=0,this.bufferLength=0,this.eof=!1,this.buffer=null}return t.prototype={ensureBuffer:function(t){var e=this.buffer,n=e?e.byteLength:0;if(t<n)return e;for(var r=512;r<t;)r<<=1;for(var i=new Uint8Array(r),o=0;o<n;++o)i[o]=e[o];return this.buffer=i},getByte:function(){for(var t=this.pos;this.bufferLength<=t;){if(this.eof)return null;this.readBlock()}return this.buffer[this.pos++]},getBytes:function(t){var e=this.pos;if(t){this.ensureBuffer(e+t);for(r=e+t;!this.eof&&this.bufferLength<r;)this.readBlock();var n=this.bufferLength;r>n&&(r=n)}else{for(;!this.eof;)this.readBlock();var r=this.bufferLength}return this.pos=r,this.buffer.subarray(e,r)},lookChar:function(){for(var t=this.pos;this.bufferLength<=t;){if(this.eof)return null;this.readBlock()}return String.fromCharCode(this.buffer[this.pos])},getChar:function(){for(var t=this.pos;this.bufferLength<=t;){if(this.eof)return null;this.readBlock()}return String.fromCharCode(this.buffer[this.pos++])},makeSubStream:function(t,e,n){for(var r=t+e;this.bufferLength<=r&&!this.eof;)this.readBlock();return new Stream(this.buffer,t,e,n)},skip:function(t){t||(t=1),this.pos+=t},reset:function(){this.pos=0}},t}(),s=function(){function t(t){throw new Error(t)}function e(e){var n=0,r=e[n++],i=e[n++];-1!=r&&-1!=i||t("Invalid header in flate stream"),8!=(15&r)&&t("Unknown compression method in flate stream"),((r<<8)+i)%31!=0&&t("Bad FCHECK in flate stream"),32&i&&t("FDICT bit set in flate stream"),this.bytes=e,this.bytesPos=n,this.codeSize=0,this.codeBuf=0,a.call(this)}if("undefined"!=typeof Uint32Array){var n=new Uint32Array([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]),r=new Uint32Array([3,4,5,6,7,8,9,10,65547,65549,65551,65553,131091,131095,131099,131103,196643,196651,196659,196667,262211,262227,262243,262259,327811,327843,327875,327907,258,258,258]),i=new Uint32Array([1,2,3,4,65541,65543,131081,131085,196625,196633,262177,262193,327745,327777,393345,393409,459009,459137,524801,525057,590849,591361,657409,658433,724993,727041,794625,798721,868353,876545]),o=[new Uint32Array([459008,524368,524304,524568,459024,524400,524336,590016,459016,524384,524320,589984,524288,524416,524352,590048,459012,524376,524312,589968,459028,524408,524344,590032,459020,524392,524328,59e4,524296,524424,524360,590064,459010,524372,524308,524572,459026,524404,524340,590024,459018,524388,524324,589992,524292,524420,524356,590056,459014,524380,524316,589976,459030,524412,524348,590040,459022,524396,524332,590008,524300,524428,524364,590072,459009,524370,524306,524570,459025,524402,524338,590020,459017,524386,524322,589988,524290,524418,524354,590052,459013,524378,524314,589972,459029,524410,524346,590036,459021,524394,524330,590004,524298,524426,524362,590068,459011,524374,524310,524574,459027,524406,524342,590028,459019,524390,524326,589996,524294,524422,524358,590060,459015,524382,524318,589980,459031,524414,524350,590044,459023,524398,524334,590012,524302,524430,524366,590076,459008,524369,524305,524569,459024,524401,524337,590018,459016,524385,524321,589986,524289,524417,524353,590050,459012,524377,524313,589970,459028,524409,524345,590034,459020,524393,524329,590002,524297,524425,524361,590066,459010,524373,524309,524573,459026,524405,524341,590026,459018,524389,524325,589994,524293,524421,524357,590058,459014,524381,524317,589978,459030,524413,524349,590042,459022,524397,524333,590010,524301,524429,524365,590074,459009,524371,524307,524571,459025,524403,524339,590022,459017,524387,524323,589990,524291,524419,524355,590054,459013,524379,524315,589974,459029,524411,524347,590038,459021,524395,524331,590006,524299,524427,524363,590070,459011,524375,524311,524575,459027,524407,524343,590030,459019,524391,524327,589998,524295,524423,524359,590062,459015,524383,524319,589982,459031,524415,524351,590046,459023,524399,524335,590014,524303,524431,524367,590078,459008,524368,524304,524568,459024,524400,524336,590017,459016,524384,524320,589985,524288,524416,524352,590049,459012,524376,524312,589969,459028,524408,524344,590033,459020,524392,524328,590001,524296,524424,524360,590065,459010,524372,524308,524572,459026,524404,524340,590025,459018,524388,524324,589993,524292,524420,524356,590057,459014,524380,524316,589977,459030,524412,524348,590041,459022,524396,524332,590009,524300,524428,524364,590073,459009,524370,524306,524570,459025,524402,524338,590021,459017,524386,524322,589989,524290,524418,524354,590053,459013,524378,524314,589973,459029,524410,524346,590037,459021,524394,524330,590005,524298,524426,524362,590069,459011,524374,524310,524574,459027,524406,524342,590029,459019,524390,524326,589997,524294,524422,524358,590061,459015,524382,524318,589981,459031,524414,524350,590045,459023,524398,524334,590013,524302,524430,524366,590077,459008,524369,524305,524569,459024,524401,524337,590019,459016,524385,524321,589987,524289,524417,524353,590051,459012,524377,524313,589971,459028,524409,524345,590035,459020,524393,524329,590003,524297,524425,524361,590067,459010,524373,524309,524573,459026,524405,524341,590027,459018,524389,524325,589995,524293,524421,524357,590059,459014,524381,524317,589979,459030,524413,524349,590043,459022,524397,524333,590011,524301,524429,524365,590075,459009,524371,524307,524571,459025,524403,524339,590023,459017,524387,524323,589991,524291,524419,524355,590055,459013,524379,524315,589975,459029,524411,524347,590039,459021,524395,524331,590007,524299,524427,524363,590071,459011,524375,524311,524575,459027,524407,524343,590031,459019,524391,524327,589999,524295,524423,524359,590063,459015,524383,524319,589983,459031,524415,524351,590047,459023,524399,524335,590015,524303,524431,524367,590079]),9],s=[new Uint32Array([327680,327696,327688,327704,327684,327700,327692,327708,327682,327698,327690,327706,327686,327702,327694,0,327681,327697,327689,327705,327685,327701,327693,327709,327683,327699,327691,327707,327687,327703,327695,0]),5];return e.prototype=Object.create(a.prototype),e.prototype.getBits=function(e){for(var n,r=this.codeSize,i=this.codeBuf,o=this.bytes,a=this.bytesPos;r<e;)void 0===(n=o[a++])&&t("Bad encoding in flate stream"),i|=n<<r,r+=8;return n=i&(1<<e)-1,this.codeBuf=i>>e,this.codeSize=r-=e,this.bytesPos=a,n},e.prototype.getCode=function(e){for(var n=e[0],r=e[1],i=this.codeSize,o=this.codeBuf,a=this.bytes,s=this.bytesPos;i<r;){var c;void 0===(c=a[s++])&&t("Bad encoding in flate stream"),o|=c<<i,i+=8}var l=n[o&(1<<r)-1],u=l>>16,h=65535&l;return(0==i||i<u||0==u)&&t("Bad encoding in flate stream"),this.codeBuf=o>>u,this.codeSize=i-u,this.bytesPos=s,h},e.prototype.generateHuffmanTable=function(t){for(var e=t.length,n=0,r=0;r<e;++r)t[r]>n&&(n=t[r]);for(var i=1<<n,o=new Uint32Array(i),a=1,s=0,c=2;a<=n;++a,s<<=1,c<<=1)for(var l=0;l<e;++l)if(t[l]==a){for(var u=0,h=s,r=0;r<a;++r)u=u<<1|1&h,h>>=1;for(r=u;r<i;r+=c)o[r]=a<<16|l;++s}return[o,n]},e.prototype.readBlock=function(){function e(t,e,n,r,i){for(var o=t.getBits(n)+r;o-- >0;)e[p++]=i}var a=this.getBits(3);if(1&a&&(this.eof=!0),0!=(a>>=1)){var c,l;if(1==a)c=o,l=s;else if(2==a){for(var u=this.getBits(5)+257,h=this.getBits(5)+1,f=this.getBits(4)+4,d=Array(n.length),p=0;p<f;)d[n[p++]]=this.getBits(3);for(var m=this.generateHuffmanTable(d),g=0,p=0,w=u+h,y=new Array(w);p<w;){var v=this.getCode(m);16==v?e(this,y,2,3,g):17==v?e(this,y,3,3,g=0):18==v?e(this,y,7,11,g=0):y[p++]=g=v}c=this.generateHuffmanTable(y.slice(0,u)),l=this.generateHuffmanTable(y.slice(u,w))}else t("Unknown block type in flate stream");for(var b=(O=this.buffer)?O.length:0,x=this.bufferLength;;){var k=this.getCode(c);if(k<256)x+1>=b&&(b=(O=this.ensureBuffer(x+1)).length),O[x++]=k;else{if(256==k)return void(this.bufferLength=x);var _=(k=r[k-=257])>>16;_>0&&(_=this.getBits(_));g=(65535&k)+_;k=this.getCode(l),(_=(k=i[k])>>16)>0&&(_=this.getBits(_));var C=(65535&k)+_;x+g>=b&&(b=(O=this.ensureBuffer(x+g)).length);for(var A=0;A<g;++A,++x)O[x]=O[x-C]}}}else{var S,q=this.bytes,T=this.bytesPos;void 0===(S=q[T++])&&t("Bad block header in flate stream");var P=S;void 0===(S=q[T++])&&t("Bad block header in flate stream"),P|=S<<8,void 0===(S=q[T++])&&t("Bad block header in flate stream");var I=S;void 0===(S=q[T++])&&t("Bad block header in flate stream"),(I|=S<<8)!=(65535&~P)&&t("Bad uncompressed block length in flate stream"),this.codeBuf=0,this.codeSize=0;var E=this.bufferLength,O=this.ensureBuffer(E+P),F=E+P;this.bufferLength=F;for(var B=E;B<F;++B){if(void 0===(S=q[T++])){this.eof=!0;break}O[B]=S}this.bytesPos=T}},e}}();return function(t){var e="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";void 0===t.btoa&&(t.btoa=function(t){var n,r,i,o,a,s=0,c=0,l="",u=[];if(!t)return t;do{n=(a=t.charCodeAt(s++)<<16|t.charCodeAt(s++)<<8|t.charCodeAt(s++))>>18&63,r=a>>12&63,i=a>>6&63,o=63&a,u[c++]=e.charAt(n)+e.charAt(r)+e.charAt(i)+e.charAt(o)}while(s<t.length);l=u.join("");var h=t.length%3;return(h?l.slice(0,h-3):l)+"===".slice(h||3)}),void 0===t.atob&&(t.atob=function(t){var n,r,i,o,a,s,c=0,l=0,u=[];if(!t)return t;t+="";do{n=(s=e.indexOf(t.charAt(c++))<<18|e.indexOf(t.charAt(c++))<<12|(o=e.indexOf(t.charAt(c++)))<<6|(a=e.indexOf(t.charAt(c++))))>>16&255,r=s>>8&255,i=255&s,u[l++]=64==o?String.fromCharCode(n):64==a?String.fromCharCode(n,r):String.fromCharCode(n,r,i)}while(c<t.length);return u.join("")}),Array.prototype.map||(Array.prototype.map=function(t){if(void 0===this||null===this||"function"!=typeof t)throw new TypeError;for(var e=Object(this),n=e.length>>>0,r=new Array(n),i=arguments.length>1?arguments[1]:void 0,o=0;o<n;o++)o in e&&(r[o]=t.call(i,e[o],o,e));return r}),Array.isArray||(Array.isArray=function(t){return"[object Array]"===Object.prototype.toString.call(t)}),Array.prototype.forEach||(Array.prototype.forEach=function(t,e){if(void 0===this||null===this||"function"!=typeof t)throw new TypeError;for(var n=Object(this),r=n.length>>>0,i=0;i<r;i++)i in n&&t.call(e,n[i],i,n)}),Object.keys||(Object.keys=function(){var t=Object.prototype.hasOwnProperty,e=!{toString:null}.propertyIsEnumerable("toString"),n=["toString","toLocaleString","valueOf","hasOwnProperty","isPrototypeOf","propertyIsEnumerable","constructor"],r=n.length;return function(i){if("object"!=typeof i&&("function"!=typeof i||null===i))throw new TypeError;var o,a,s=[];for(o in i)t.call(i,o)&&s.push(o);if(e)for(a=0;a<r;a++)t.call(i,n[a])&&s.push(n[a]);return s}}()),String.prototype.trim||(String.prototype.trim=function(){return this.replace(/^\s+|\s+$/g,"")}),String.prototype.trimLeft||(String.prototype.trimLeft=function(){return this.replace(/^\s+/g,"")}),String.prototype.trimRight||(String.prototype.trimRight=function(){return this.replace(/\s+$/g,"")})}("undefined"!=typeof self&&self||"undefined"!=typeof window&&window||void 0),e});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))
	
	/***/ }),
	/* 30 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _html2pdf = __webpack_require__(31);
	
	var _html2pdf2 = _interopRequireDefault(_html2pdf);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _html2pdf2.default;
	module.exports = exports['default'];
	
	/***/ }),
	/* 31 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	// import dependancies
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	// import plugins
	
	
	// import helper functions
	
	
	var _nativePromiseOnly = __webpack_require__(32);
	
	var _nativePromiseOnly2 = _interopRequireDefault(_nativePromiseOnly);
	
	var _html2canvas = __webpack_require__(35);
	
	var _html2canvas2 = _interopRequireDefault(_html2canvas);
	
	var _jspdf = __webpack_require__(29);
	
	var _jspdf2 = _interopRequireDefault(_jspdf);
	
	__webpack_require__(67);
	
	var _utils = __webpack_require__(69);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Html2Pdf = function () {
	  function Html2Pdf(source) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    _classCallCheck(this, Html2Pdf);
	
	    if (!(this instanceof Html2Pdf)) {
	      return new Html2Pdf(source, options);
	    }
	
	    this.source = '';
	    this.jsPDF = {};
	    this.html2canvas = {};
	    this.image = {};
	    this.margin = [0, 0, 0, 0];
	    this.filename = '';
	    this.pageSize = {};
	    this.enableLinks = false;
	    this.links = [];
	    this._pdf = null;
	    this.javascriptEnabled = false;
	    this.onRendered = function () {};
	
	    if (!!options.jsPDF && _typeof(options.jsPDF) === 'object') {
	      this.jsPDF = options.jsPDF;
	    } else if (Html2Pdf.jsPDF) {
	      this.jsPDF = Html2Pdf.jsPDF;
	    }
	
	    if (!!options.html2canvas && _typeof(options.html2canvas) === 'object') {
	      this.html2canvas = options.html2canvas;
	      if (this.html2canvas.hasOwnProperty('onrendered')) {
	        this.onRendered = this.html2canvas.onrendered;
	        delete this.html2canvas.onrendered;
	      }
	    } else if (Html2Pdf.html2canvas) {
	      this.html2canvas = Html2Pdf.html2canvas;
	    }
	
	    if (!!options.image && _typeof(options.image) === 'object') {
	      this.image = options.image;
	      this.image.type = options.image.type || 'jpeg';
	      this.image.quality = options.image.quality || 0.95;
	    } else if (Html2Pdf.image) {
	      this.image = Html2Pdf.image;
	    }
	
	    if (options.hasOwnProperty('enableLinks')) {
	      this.enableLinks = options.enableLinks;
	    } else if (Html2Pdf.enableLinks) {
	      this.enableLinks = Html2Pdf.enableLinks;
	    }
	
	    if (options.hasOwnProperty('javascriptEnabled')) {
	      this.javascriptEnabled = options.javascriptEnabled;
	    } else if (Html2Pdf.javascriptEnabled) {
	      this.javascriptEnabled = Html2Pdf.javascriptEnabled;
	    }
	
	    if (options.hasOwnProperty('margin')) {
	      if (typeof options.margin === 'number') {
	        this.margin = [options.margin, options.margin, options.margin, options.margin];
	      } else if (Array.isArray(options.margin)) {
	        if (options.margin.length === 2) {
	          this.margin = [options.margin[0], options.margin[1], options.margin[0], options.margin[0]];
	        } else if (options.margin.length === 4) {
	          this.margin = options.margin;
	        }
	      }
	    } else if (Html2Pdf.margin) {
	      this.margin = Html2Pdf.margin;
	    }
	
	    if (options.hasOwnProperty('filename') && typeof options.filename === 'string') {
	      if (options.filename.split('.').pop().toLowerCase() !== 'pdf') {
	        this.filename = options.filename.concat('.pdf');
	      } else {
	        this.filename = options.filename;
	      }
	    } else if (Html2Pdf.filename) {
	      this.filename = Html2Pdf.filename;
	    }
	
	    this.pageSize = _jspdf2.default.getPageSize(this.jsPDF);
	    this.pageSize.inner = {
	      width: this.pageSize.width - this.margin[1] - this.margin[3],
	      height: this.pageSize.height - this.margin[0] - this.margin[2]
	    };
	    this.pageSize.inner.ratio = this.pageSize.inner.height / this.pageSize.inner.width;
	
	    if (options.hasOwnProperty('source')) {
	      source = options.source;
	    }
	
	    if (!source) {
	      console.warn('[Html2Pdf] source element not set (null or undefined)');
	    } else if (typeof source === 'string') {
	      this.source = _utils2.default.createElement('div', { innerHTML: source });
	    } else if ((typeof source === 'undefined' ? 'undefined' : _typeof(source)) === 'object' && source.nodeType === 1) {
	      this.source = _utils2.default.cloneNode(source, this.javascriptEnabled);
	    } else {
	      console.warn('[Html2Pdf] source element not set (invalid source)');
	    }
	  }
	
	  /**
	   * Creates the DOM element container used for generating the PDF file.
	   *
	   * @returns {Element} The DOM element container.
	   * @memberof Html2Pdf
	   */
	
	
	  _createClass(Html2Pdf, [{
	    key: 'createContainer',
	    value: function createContainer() {
	      // Define the CSS styles for the container and its overlay parent.
	      var overlayCSS = {
	        position: 'fixed', overflow: 'hidden', zIndex: 1000,
	        left: 0, right: 0, bottom: 0, top: 0,
	        backgroundColor: 'rgba(0,0,0,0.8)'
	      };
	      var containerCSS = {
	        position: 'absolute', width: this.pageSize.inner.width + this.pageSize.unit,
	        left: 0, right: 0, top: 0, height: 'auto', margin: 'auto',
	        backgroundColor: 'white'
	      };
	
	      // Set the overlay to hidden (could be changed in the future to provide a print preview).
	      overlayCSS.opacity = 0;
	
	      // Create and attach the elements.
	      var overlay = _utils2.default.createElement('div', { class: 'html2pdf__overlay', style: overlayCSS });
	      var container = _utils2.default.createElement('div', { class: 'html2pdf__container', style: containerCSS });
	
	      container.appendChild(this.source);
	      overlay.appendChild(container);
	      document.body.appendChild(overlay);
	
	      // Enable page-breaks.
	      var pageBreaks = this.source.querySelectorAll('.html2pdf__page-break');
	      var pxPageHeight = this.pageSize.inner.height * this.pageSize.k / 72 * 96;
	
	      Array.prototype.forEach.call(pageBreaks, function (el) {
	        el.style.display = 'block';
	        var clientRect = el.getBoundingClientRect();
	
	        el.style.height = pxPageHeight - clientRect.top % pxPageHeight + 'px';
	      });
	
	      // Return the container.
	      return container;
	    }
	  }, {
	    key: 'makeCanvas',
	
	
	    /**
	     * Generates the PDF canvas image of a DOM element.
	     *
	     * @param {Element} container The DOM element containing the HTML to be rendered.
	     * @returns {Promise} The promise containing the HTML canvas
	     * @memberof Html2Pdf
	     */
	    value: function makeCanvas(container) {
	      var _this = this;
	
	      return new _nativePromiseOnly2.default(function (resolve, reject) {
	        try {
	          var overlay = container.parentElement;
	
	          // Get the locations of all hyperlinks.
	          if (_this.enableLinks) {
	            // Find all anchor tags and get the container's bounds for reference.
	            _this.links = [];
	            var links = container.querySelectorAll('a');
	            var containerRect = _utils2.default.unitConvert(container.getBoundingClientRect(), _this.pageSize.k);
	
	            // Treat each client rect as a separate link (for text-wrapping).
	            Array.prototype.forEach.call(links, function (link) {
	              var clientRects = link.getClientRects();
	
	              for (var i = 0; i < clientRects.length; i++) {
	                var clientRect = _utils2.default.unitConvert(clientRects[i], _this.pageSize.k);
	
	                clientRect.left -= containerRect.left;
	                clientRect.top -= containerRect.top;
	                _this.links.push({ el: link, clientRect: clientRect });
	              }
	            });
	          }
	
	          (0, _html2canvas2.default)(container, _this.html2canvas).then(function (canvas) {
	            _this.onRendered(canvas);
	            document.body.removeChild(overlay);
	            resolve(canvas);
	          });
	        } catch (error) {
	          reject(error);
	        }
	      });
	    }
	
	    /**
	     * Generates the jsPDF instance
	     *
	     * @param {HTMLCanvasElement} canvas The HTML canvas element to be used for generating the PDF.
	     * @returns {Promise} The promise containing the jsPDF instance
	     * @memberof Html2Pdf
	     */
	
	  }, {
	    key: 'makePdf',
	    value: function makePdf(canvas) {
	      var _this2 = this;
	
	      this._pdf = null;
	
	      return new _nativePromiseOnly2.default(function (resolve, reject) {
	        try {
	          (function () {
	            // Calculate the number of pages.
	            // let ctx = canvas.getContext('2d');
	            var pxFullHeight = canvas.height;
	            var pxPageHeight = Math.floor(canvas.width * _this2.pageSize.inner.ratio);
	            var nPages = Math.ceil(pxFullHeight / pxPageHeight);
	
	            // Create a one-page canvas to split up the full image.
	            var pageCanvas = document.createElement('canvas');
	            var pageCtx = pageCanvas.getContext('2d');
	            var pageHeight = _this2.pageSize.inner.height;
	
	            pageCanvas.width = canvas.width;
	            pageCanvas.height = pxPageHeight;
	
	            // Initialize the PDF.
	            /* eslint new-cap:off */
	            var pdf = new _jspdf2.default(_this2.jsPDF);
	
	            for (var page = 0; page < nPages; page++) {
	              // Trim the final page to reduce file size.
	              if (page === nPages - 1) {
	                pageCanvas.height = pxFullHeight % pxPageHeight;
	                pageHeight = pageCanvas.height * _this2.pageSize.inner.width / pageCanvas.width;
	              }
	
	              // Display the page.
	              var w = pageCanvas.width;
	              var h = pageCanvas.height;
	
	              pageCtx.fillStyle = 'white';
	              pageCtx.fillRect(0, 0, w, h);
	              pageCtx.drawImage(canvas, 0, page * pxPageHeight, w, h, 0, 0, w, h);
	
	              // Add the page to the PDF.
	              if (page) {
	                pdf.addPage();
	              }
	              var imgData = pageCanvas.toDataURL('image/' + _this2.image.type, _this2.image.quality);
	
	              pdf.addImage(imgData, _this2.image.type, _this2.margin[1], _this2.margin[0], _this2.pageSize.inner.width, pageHeight);
	
	              // Add hyperlinks.
	              if (_this2.enableLinks) {
	                (function () {
	                  var pageTop = page * _this2.pageSize.inner.height;
	
	                  Array.prototype.forEach.call(_this2.links, function (link) {
	                    if (link.clientRect.top > pageTop && link.clientRect.top < pageTop + _this2.pageSize.inner.height) {
	                      var left = _this2.margin[1] + link.clientRect.left;
	                      var top = _this2.margin[0] + link.clientRect.top - pageTop;
	
	                      pdf.link(left, top, link.clientRect.width, link.clientRect.height, { url: link.el.href });
	                    }
	                  }, _this2);
	                })();
	              }
	            }
	            // save the pdf object for future use
	            _this2._pdf = pdf;
	            resolve(_this2._pdf);
	          })();
	        } catch (error) {
	          reject(error);
	        }
	      });
	    }
	  }, {
	    key: 'make',
	    value: function make() {
	      var _this3 = this;
	
	      return new _nativePromiseOnly2.default(function (resolve, reject) {
	        try {
	          // Copy the source element into a PDF-styled container div.
	          var container = _this3.createContainer(_this3.source, _this3.pageSize);
	
	          _this3.makeCanvas(container).then(function (canvas) {
	            _this3.makePdf(canvas).then(function (pdf) {
	              resolve(pdf);
	            });
	          });
	        } catch (error) {
	          reject(error);
	        }
	      });
	    }
	  }, {
	    key: 'getPdf',
	    value: function getPdf(download) {
	      var _this4 = this;
	
	      return new _nativePromiseOnly2.default(function (resolve, reject) {
	        try {
	          if (_this4._pdf) {
	            resolve(_this4._pdf);
	          } else {
	            _this4.make().then(function (pdf) {
	              if (download) {
	                pdf.save(_this4.filename);
	              }
	              resolve(pdf);
	            });
	          }
	        } catch (error) {
	          reject(error);
	        }
	      });
	    }
	  }, {
	    key: 'getDataUri',
	    value: function getDataUri() {
	      var _this5 = this;
	
	      return new _nativePromiseOnly2.default(function (resolve, reject) {
	        try {
	          _this5.getPdf(false).then(function (pdf) {
	            return resolve(pdf.output('datauristring'));
	          });
	        } catch (error) {
	          reject(error);
	        }
	      });
	    }
	  }], [{
	    key: 'getPdf',
	    value: function getPdf(options) {
	      return new Html2Pdf(null, options).getPdf(options.download);
	    }
	  }, {
	    key: 'downloadPdf',
	    value: function downloadPdf(options) {
	      return new Html2Pdf(null, options).getPdf(true);
	    }
	  }, {
	    key: 'getDataUri',
	    value: function getDataUri(options) {
	      return new Html2Pdf(null, options).getDataUri();
	    }
	  }]);
	
	  return Html2Pdf;
	}();
	
	Html2Pdf.margin = [10, 10, 10, 10];
	Html2Pdf.jsPDF = {
	  orientation: 'p',
	  unit: 'mm',
	  format: 'a4'
	};
	Html2Pdf.html2canvas = {
	  scale: 2,
	  logging: false
	};
	Html2Pdf.image = {
	  type: 'jpeg',
	  quality: 0.95
	};
	Html2Pdf.filename = 'file.pdf';
	Html2Pdf.enableLinks = true;
	
	exports.default = Html2Pdf;
	module.exports = exports['default'];
	
	/***/ }),
	/* 32 */
	/***/ (function(module, exports, __webpack_require__) {
	
	/* WEBPACK VAR INJECTION */(function(global, setImmediate) {var __WEBPACK_AMD_DEFINE_RESULT__;/*! Native Promise Only
	    v0.8.1 (c) Kyle Simpson
	    MIT License: http://getify.mit-license.org
	*/
	
	(function UMD(name,context,definition){
		// special form of UMD for polyfilling across evironments
		context[name] = context[name] || definition();
		if (typeof module != "undefined" && module.exports) { module.exports = context[name]; }
		else if (true) { !(__WEBPACK_AMD_DEFINE_RESULT__ = (function $AMD$(){ return context[name]; }).call(exports, __webpack_require__, exports, module),
					__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)); }
	})("Promise",typeof global != "undefined" ? global : this,function DEF(){
		/*jshint validthis:true */
		"use strict";
	
		var builtInProp, cycle, scheduling_queue,
			ToString = Object.prototype.toString,
			timer = (typeof setImmediate != "undefined") ?
				function timer(fn) { return setImmediate(fn); } :
				setTimeout
		;
	
		// dammit, IE8.
		try {
			Object.defineProperty({},"x",{});
			builtInProp = function builtInProp(obj,name,val,config) {
				return Object.defineProperty(obj,name,{
					value: val,
					writable: true,
					configurable: config !== false
				});
			};
		}
		catch (err) {
			builtInProp = function builtInProp(obj,name,val) {
				obj[name] = val;
				return obj;
			};
		}
	
		// Note: using a queue instead of array for efficiency
		scheduling_queue = (function Queue() {
			var first, last, item;
	
			function Item(fn,self) {
				this.fn = fn;
				this.self = self;
				this.next = void 0;
			}
	
			return {
				add: function add(fn,self) {
					item = new Item(fn,self);
					if (last) {
						last.next = item;
					}
					else {
						first = item;
					}
					last = item;
					item = void 0;
				},
				drain: function drain() {
					var f = first;
					first = last = cycle = void 0;
	
					while (f) {
						f.fn.call(f.self);
						f = f.next;
					}
				}
			};
		})();
	
		function schedule(fn,self) {
			scheduling_queue.add(fn,self);
			if (!cycle) {
				cycle = timer(scheduling_queue.drain);
			}
		}
	
		// promise duck typing
		function isThenable(o) {
			var _then, o_type = typeof o;
	
			if (o != null &&
				(
					o_type == "object" || o_type == "function"
				)
			) {
				_then = o.then;
			}
			return typeof _then == "function" ? _then : false;
		}
	
		function notify() {
			for (var i=0; i<this.chain.length; i++) {
				notifyIsolated(
					this,
					(this.state === 1) ? this.chain[i].success : this.chain[i].failure,
					this.chain[i]
				);
			}
			this.chain.length = 0;
		}
	
		// NOTE: This is a separate function to isolate
		// the `try..catch` so that other code can be
		// optimized better
		function notifyIsolated(self,cb,chain) {
			var ret, _then;
			try {
				if (cb === false) {
					chain.reject(self.msg);
				}
				else {
					if (cb === true) {
						ret = self.msg;
					}
					else {
						ret = cb.call(void 0,self.msg);
					}
	
					if (ret === chain.promise) {
						chain.reject(TypeError("Promise-chain cycle"));
					}
					else if (_then = isThenable(ret)) {
						_then.call(ret,chain.resolve,chain.reject);
					}
					else {
						chain.resolve(ret);
					}
				}
			}
			catch (err) {
				chain.reject(err);
			}
		}
	
		function resolve(msg) {
			var _then, self = this;
	
			// already triggered?
			if (self.triggered) { return; }
	
			self.triggered = true;
	
			// unwrap
			if (self.def) {
				self = self.def;
			}
	
			try {
				if (_then = isThenable(msg)) {
					schedule(function(){
						var def_wrapper = new MakeDefWrapper(self);
						try {
							_then.call(msg,
								function $resolve$(){ resolve.apply(def_wrapper,arguments); },
								function $reject$(){ reject.apply(def_wrapper,arguments); }
							);
						}
						catch (err) {
							reject.call(def_wrapper,err);
						}
					})
				}
				else {
					self.msg = msg;
					self.state = 1;
					if (self.chain.length > 0) {
						schedule(notify,self);
					}
				}
			}
			catch (err) {
				reject.call(new MakeDefWrapper(self),err);
			}
		}
	
		function reject(msg) {
			var self = this;
	
			// already triggered?
			if (self.triggered) { return; }
	
			self.triggered = true;
	
			// unwrap
			if (self.def) {
				self = self.def;
			}
	
			self.msg = msg;
			self.state = 2;
			if (self.chain.length > 0) {
				schedule(notify,self);
			}
		}
	
		function iteratePromises(Constructor,arr,resolver,rejecter) {
			for (var idx=0; idx<arr.length; idx++) {
				(function IIFE(idx){
					Constructor.resolve(arr[idx])
					.then(
						function $resolver$(msg){
							resolver(idx,msg);
						},
						rejecter
					);
				})(idx);
			}
		}
	
		function MakeDefWrapper(self) {
			this.def = self;
			this.triggered = false;
		}
	
		function MakeDef(self) {
			this.promise = self;
			this.state = 0;
			this.triggered = false;
			this.chain = [];
			this.msg = void 0;
		}
	
		function Promise(executor) {
			if (typeof executor != "function") {
				throw TypeError("Not a function");
			}
	
			if (this.__NPO__ !== 0) {
				throw TypeError("Not a promise");
			}
	
			// instance shadowing the inherited "brand"
			// to signal an already "initialized" promise
			this.__NPO__ = 1;
	
			var def = new MakeDef(this);
	
			this["then"] = function then(success,failure) {
				var o = {
					success: typeof success == "function" ? success : true,
					failure: typeof failure == "function" ? failure : false
				};
				// Note: `then(..)` itself can be borrowed to be used against
				// a different promise constructor for making the chained promise,
				// by substituting a different `this` binding.
				o.promise = new this.constructor(function extractChain(resolve,reject) {
					if (typeof resolve != "function" || typeof reject != "function") {
						throw TypeError("Not a function");
					}
	
					o.resolve = resolve;
					o.reject = reject;
				});
				def.chain.push(o);
	
				if (def.state !== 0) {
					schedule(notify,def);
				}
	
				return o.promise;
			};
			this["catch"] = function $catch$(failure) {
				return this.then(void 0,failure);
			};
	
			try {
				executor.call(
					void 0,
					function publicResolve(msg){
						resolve.call(def,msg);
					},
					function publicReject(msg) {
						reject.call(def,msg);
					}
				);
			}
			catch (err) {
				reject.call(def,err);
			}
		}
	
		var PromisePrototype = builtInProp({},"constructor",Promise,
			/*configurable=*/false
		);
	
		// Note: Android 4 cannot use `Object.defineProperty(..)` here
		Promise.prototype = PromisePrototype;
	
		// built-in "brand" to signal an "uninitialized" promise
		builtInProp(PromisePrototype,"__NPO__",0,
			/*configurable=*/false
		);
	
		builtInProp(Promise,"resolve",function Promise$resolve(msg) {
			var Constructor = this;
	
			// spec mandated checks
			// note: best "isPromise" check that's practical for now
			if (msg && typeof msg == "object" && msg.__NPO__ === 1) {
				return msg;
			}
	
			return new Constructor(function executor(resolve,reject){
				if (typeof resolve != "function" || typeof reject != "function") {
					throw TypeError("Not a function");
				}
	
				resolve(msg);
			});
		});
	
		builtInProp(Promise,"reject",function Promise$reject(msg) {
			return new this(function executor(resolve,reject){
				if (typeof resolve != "function" || typeof reject != "function") {
					throw TypeError("Not a function");
				}
	
				reject(msg);
			});
		});
	
		builtInProp(Promise,"all",function Promise$all(arr) {
			var Constructor = this;
	
			// spec mandated checks
			if (ToString.call(arr) != "[object Array]") {
				return Constructor.reject(TypeError("Not an array"));
			}
			if (arr.length === 0) {
				return Constructor.resolve([]);
			}
	
			return new Constructor(function executor(resolve,reject){
				if (typeof resolve != "function" || typeof reject != "function") {
					throw TypeError("Not a function");
				}
	
				var len = arr.length, msgs = Array(len), count = 0;
	
				iteratePromises(Constructor,arr,function resolver(idx,msg) {
					msgs[idx] = msg;
					if (++count === len) {
						resolve(msgs);
					}
				},reject);
			});
		});
	
		builtInProp(Promise,"race",function Promise$race(arr) {
			var Constructor = this;
	
			// spec mandated checks
			if (ToString.call(arr) != "[object Array]") {
				return Constructor.reject(TypeError("Not an array"));
			}
	
			return new Constructor(function executor(resolve,reject){
				if (typeof resolve != "function" || typeof reject != "function") {
					throw TypeError("Not a function");
				}
	
				iteratePromises(Constructor,arr,function resolver(idx,msg){
					resolve(msg);
				},reject);
			});
		});
	
		return Promise;
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7), __webpack_require__(33).setImmediate))
	
	/***/ }),
	/* 33 */
	/***/ (function(module, exports, __webpack_require__) {
	
	/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
	            (typeof self !== "undefined" && self) ||
	            window;
	var apply = Function.prototype.apply;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(scope, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// setimmediate attaches itself to the global object
	__webpack_require__(34);
	// On some exotic environments, it's not clear which object `setimmediate` was
	// able to install onto.  Search each possibility in the same order as the
	// `setimmediate` library.
	exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
	                       (typeof global !== "undefined" && global.setImmediate) ||
	                       (this && this.setImmediate);
	exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
	                         (typeof global !== "undefined" && global.clearImmediate) ||
	                         (this && this.clearImmediate);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))
	
	/***/ }),
	/* 34 */
	/***/ (function(module, exports, __webpack_require__) {
	
	/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
	    "use strict";
	
	    if (global.setImmediate) {
	        return;
	    }
	
	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;
	
	    function setImmediate(callback) {
	      // Callback can either be a function or a string
	      if (typeof callback !== "function") {
	        callback = new Function("" + callback);
	      }
	      // Copy function arguments
	      var args = new Array(arguments.length - 1);
	      for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i + 1];
	      }
	      // Store and register the task
	      var task = { callback: callback, args: args };
	      tasksByHandle[nextHandle] = task;
	      registerImmediate(nextHandle);
	      return nextHandle++;
	    }
	
	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }
	
	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	        case 0:
	            callback();
	            break;
	        case 1:
	            callback(args[0]);
	            break;
	        case 2:
	            callback(args[0], args[1]);
	            break;
	        case 3:
	            callback(args[0], args[1], args[2]);
	            break;
	        default:
	            callback.apply(undefined, args);
	            break;
	        }
	    }
	
	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }
	
	    function installNextTickImplementation() {
	        registerImmediate = function(handle) {
	            process.nextTick(function () { runIfPresent(handle); });
	        };
	    }
	
	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function() {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }
	
	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	
	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function(event) {
	            if (event.source === global &&
	                typeof event.data === "string" &&
	                event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	
	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }
	
	        registerImmediate = function(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }
	
	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function(event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };
	
	        registerImmediate = function(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }
	
	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }
	
	    function installSetTimeoutImplementation() {
	        registerImmediate = function(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }
	
	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
	
	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();
	
	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();
	
	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();
	
	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();
	
	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }
	
	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7), __webpack_require__(0)))
	
	/***/ }),
	/* 35 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/* WEBPACK VAR INJECTION */(function(process) {
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _CanvasRenderer = __webpack_require__(17);
	
	var _CanvasRenderer2 = _interopRequireDefault(_CanvasRenderer);
	
	var _Logger = __webpack_require__(18);
	
	var _Logger2 = _interopRequireDefault(_Logger);
	
	var _Window = __webpack_require__(36);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var html2canvas = function html2canvas(element, conf) {
	    var config = conf || {};
	    var logger = new _Logger2.default(typeof config.logging === 'boolean' ? config.logging : true);
	    logger.log('html2canvas ' + "$npm_package_version");
	
	    if (process.env.NODE_ENV !== 'production' && typeof config.onrendered === 'function') {
	        logger.error('onrendered option is deprecated, html2canvas returns a Promise with the canvas as the value');
	    }
	
	    var ownerDocument = element.ownerDocument;
	    if (!ownerDocument) {
	        return Promise.reject('Provided element is not within a Document');
	    }
	    var defaultView = ownerDocument.defaultView;
	
	    var defaultOptions = {
	        async: true,
	        allowTaint: false,
	        backgroundColor: '#ffffff',
	        imageTimeout: 15000,
	        logging: true,
	        proxy: null,
	        removeContainer: true,
	        foreignObjectRendering: false,
	        scale: defaultView.devicePixelRatio || 1,
	        target: new _CanvasRenderer2.default(config.canvas),
	        useCORS: false,
	        windowWidth: defaultView.innerWidth,
	        windowHeight: defaultView.innerHeight,
	        scrollX: defaultView.pageXOffset,
	        scrollY: defaultView.pageYOffset
	    };
	
	    var result = (0, _Window.renderElement)(element, _extends({}, defaultOptions, config), logger);
	
	    if (process.env.NODE_ENV !== 'production') {
	        return result.catch(function (e) {
	            logger.error(e);
	            throw e;
	        });
	    }
	    return result;
	};
	
	html2canvas.CanvasRenderer = _CanvasRenderer2.default;
	
	module.exports = html2canvas;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))
	
	/***/ }),
	/* 36 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/* WEBPACK VAR INJECTION */(function(process) {
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.renderElement = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _Logger = __webpack_require__(18);
	
	var _Logger2 = _interopRequireDefault(_Logger);
	
	var _NodeParser = __webpack_require__(37);
	
	var _Renderer = __webpack_require__(59);
	
	var _Renderer2 = _interopRequireDefault(_Renderer);
	
	var _ForeignObjectRenderer = __webpack_require__(25);
	
	var _ForeignObjectRenderer2 = _interopRequireDefault(_ForeignObjectRenderer);
	
	var _Feature = __webpack_require__(12);
	
	var _Feature2 = _interopRequireDefault(_Feature);
	
	var _Bounds = __webpack_require__(3);
	
	var _Clone = __webpack_require__(62);
	
	var _Font = __webpack_require__(27);
	
	var _Color = __webpack_require__(1);
	
	var _Color2 = _interopRequireDefault(_Color);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var renderElement = exports.renderElement = function renderElement(element, options, logger) {
	    var ownerDocument = element.ownerDocument;
	
	    var windowBounds = new _Bounds.Bounds(options.scrollX, options.scrollY, options.windowWidth, options.windowHeight);
	
	    // http://www.w3.org/TR/css3-background/#special-backgrounds
	    var documentBackgroundColor = ownerDocument.documentElement ? new _Color2.default(getComputedStyle(ownerDocument.documentElement).backgroundColor) : _Color.TRANSPARENT;
	    var bodyBackgroundColor = ownerDocument.body ? new _Color2.default(getComputedStyle(ownerDocument.body).backgroundColor) : _Color.TRANSPARENT;
	
	    var backgroundColor = element === ownerDocument.documentElement ? documentBackgroundColor.isTransparent() ? bodyBackgroundColor.isTransparent() ? options.backgroundColor ? new _Color2.default(options.backgroundColor) : null : bodyBackgroundColor : documentBackgroundColor : options.backgroundColor ? new _Color2.default(options.backgroundColor) : null;
	
	    return (options.foreignObjectRendering ? // $FlowFixMe
	    _Feature2.default.SUPPORT_FOREIGNOBJECT_DRAWING : Promise.resolve(false)).then(function (supportForeignObject) {
	        return supportForeignObject ? function (cloner) {
	            if (process.env.NODE_ENV !== 'production') {
	                logger.log('Document cloned, using foreignObject rendering');
	            }
	
	            return cloner.inlineFonts(ownerDocument).then(function () {
	                return cloner.resourceLoader.ready();
	            }).then(function () {
	                var renderer = new _ForeignObjectRenderer2.default(cloner.documentElement);
	
	                var defaultView = ownerDocument.defaultView;
	                var scrollX = defaultView.pageXOffset;
	                var scrollY = defaultView.pageYOffset;
	
	                var isDocument = element.tagName === 'HTML' || element.tagName === 'BODY';
	
	                var _ref = isDocument ? (0, _Bounds.parseDocumentSize)(ownerDocument) : (0, _Bounds.parseBounds)(element, scrollX, scrollY),
	                    width = _ref.width,
	                    height = _ref.height,
	                    left = _ref.left,
	                    top = _ref.top;
	
	                return renderer.render({
	                    backgroundColor: backgroundColor,
	                    logger: logger,
	                    scale: options.scale,
	                    x: typeof options.x === 'number' ? options.x : left,
	                    y: typeof options.y === 'number' ? options.y : top,
	                    width: typeof options.width === 'number' ? options.width : Math.ceil(width),
	                    height: typeof options.height === 'number' ? options.height : Math.ceil(height),
	                    windowWidth: options.windowWidth,
	                    windowHeight: options.windowHeight,
	                    scrollX: options.scrollX,
	                    scrollY: options.scrollY
	                });
	            });
	        }(new _Clone.DocumentCloner(element, options, logger, true, renderElement)) : (0, _Clone.cloneWindow)(ownerDocument, windowBounds, element, options, logger, renderElement).then(function (_ref2) {
	            var _ref3 = _slicedToArray(_ref2, 3),
	                container = _ref3[0],
	                clonedElement = _ref3[1],
	                resourceLoader = _ref3[2];
	
	            if (process.env.NODE_ENV !== 'production') {
	                logger.log('Document cloned, using computed rendering');
	            }
	
	            var stack = (0, _NodeParser.NodeParser)(clonedElement, resourceLoader, logger);
	            var clonedDocument = clonedElement.ownerDocument;
	
	            if (backgroundColor === stack.container.style.background.backgroundColor) {
	                stack.container.style.background.backgroundColor = _Color.TRANSPARENT;
	            }
	
	            return resourceLoader.ready().then(function (imageStore) {
	                var fontMetrics = new _Font.FontMetrics(clonedDocument);
	                if (process.env.NODE_ENV !== 'production') {
	                    logger.log('Starting renderer');
	                }
	
	                var defaultView = clonedDocument.defaultView;
	                var scrollX = defaultView.pageXOffset;
	                var scrollY = defaultView.pageYOffset;
	
	                var isDocument = clonedElement.tagName === 'HTML' || clonedElement.tagName === 'BODY';
	
	                var _ref4 = isDocument ? (0, _Bounds.parseDocumentSize)(ownerDocument) : (0, _Bounds.parseBounds)(clonedElement, scrollX, scrollY),
	                    width = _ref4.width,
	                    height = _ref4.height,
	                    left = _ref4.left,
	                    top = _ref4.top;
	
	                var renderOptions = {
	                    backgroundColor: backgroundColor,
	                    fontMetrics: fontMetrics,
	                    imageStore: imageStore,
	                    logger: logger,
	                    scale: options.scale,
	                    x: typeof options.x === 'number' ? options.x : left,
	                    y: typeof options.y === 'number' ? options.y : top,
	                    width: typeof options.width === 'number' ? options.width : Math.ceil(width),
	                    height: typeof options.height === 'number' ? options.height : Math.ceil(height)
	                };
	
	                if (Array.isArray(options.target)) {
	                    return Promise.all(options.target.map(function (target) {
	                        var renderer = new _Renderer2.default(target, renderOptions);
	                        return renderer.render(stack);
	                    }));
	                } else {
	                    var renderer = new _Renderer2.default(options.target, renderOptions);
	                    var canvas = renderer.render(stack);
	                    if (options.removeContainer === true) {
	                        if (container.parentNode) {
	                            container.parentNode.removeChild(container);
	                        } else if (process.env.NODE_ENV !== 'production') {
	                            logger.log('Cannot detach cloned iframe as it is not in the DOM anymore');
	                        }
	                    }
	
	                    return canvas;
	                }
	            });
	        });
	    });
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))
	
	/***/ }),
	/* 37 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/* WEBPACK VAR INJECTION */(function(process) {
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.NodeParser = undefined;
	
	var _StackingContext = __webpack_require__(38);
	
	var _StackingContext2 = _interopRequireDefault(_StackingContext);
	
	var _NodeContainer = __webpack_require__(4);
	
	var _NodeContainer2 = _interopRequireDefault(_NodeContainer);
	
	var _TextContainer = __webpack_require__(11);
	
	var _TextContainer2 = _interopRequireDefault(_TextContainer);
	
	var _Input = __webpack_require__(23);
	
	var _ListItem = __webpack_require__(16);
	
	var _listStyle = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NodeParser = exports.NodeParser = function NodeParser(node, resourceLoader, logger) {
	    if (process.env.NODE_ENV !== 'production') {
	        logger.log('Starting node parsing');
	    }
	
	    var index = 0;
	
	    var container = new _NodeContainer2.default(node, null, resourceLoader, index++);
	    var stack = new _StackingContext2.default(container, null, true);
	
	    parseNodeTree(node, container, stack, resourceLoader, index);
	
	    if (process.env.NODE_ENV !== 'production') {
	        logger.log('Finished parsing node tree');
	    }
	
	    return stack;
	};
	
	var IGNORED_NODE_NAMES = ['SCRIPT', 'HEAD', 'TITLE', 'OBJECT', 'BR', 'OPTION'];
	
	var parseNodeTree = function parseNodeTree(node, parent, stack, resourceLoader, index) {
	    if (process.env.NODE_ENV !== 'production' && index > 50000) {
	        throw new Error('Recursion error while parsing node tree');
	    }
	
	    for (var childNode = node.firstChild, nextNode; childNode; childNode = nextNode) {
	        nextNode = childNode.nextSibling;
	        var defaultView = childNode.ownerDocument.defaultView;
	        if (childNode instanceof defaultView.Text || childNode instanceof Text || defaultView.parent && childNode instanceof defaultView.parent.Text) {
	            if (childNode.data.trim().length > 0) {
	                parent.childNodes.push(_TextContainer2.default.fromTextNode(childNode, parent));
	            }
	        } else if (childNode instanceof defaultView.HTMLElement || childNode instanceof HTMLElement || defaultView.parent && childNode instanceof defaultView.parent.HTMLElement) {
	            if (IGNORED_NODE_NAMES.indexOf(childNode.nodeName) === -1) {
	                var container = new _NodeContainer2.default(childNode, parent, resourceLoader, index++);
	                if (container.isVisible()) {
	                    if (childNode.tagName === 'INPUT') {
	                        // $FlowFixMe
	                        (0, _Input.inlineInputElement)(childNode, container);
	                    } else if (childNode.tagName === 'TEXTAREA') {
	                        // $FlowFixMe
	                        (0, _Input.inlineTextAreaElement)(childNode, container);
	                    } else if (childNode.tagName === 'SELECT') {
	                        // $FlowFixMe
	                        (0, _Input.inlineSelectElement)(childNode, container);
	                    } else if (container.style.listStyle && container.style.listStyle.listStyleType !== _listStyle.LIST_STYLE_TYPE.NONE) {
	                        (0, _ListItem.inlineListItemElement)(childNode, container, resourceLoader);
	                    }
	
	                    var SHOULD_TRAVERSE_CHILDREN = childNode.tagName !== 'TEXTAREA';
	                    var treatAsRealStackingContext = createsRealStackingContext(container, childNode);
	                    if (treatAsRealStackingContext || createsStackingContext(container)) {
	                        // for treatAsRealStackingContext:false, any positioned descendants and descendants
	                        // which actually create a new stacking context should be considered part of the parent stacking context
	                        var parentStack = treatAsRealStackingContext || container.isPositioned() ? stack.getRealParentStackingContext() : stack;
	                        var childStack = new _StackingContext2.default(container, parentStack, treatAsRealStackingContext);
	                        parentStack.contexts.push(childStack);
	                        if (SHOULD_TRAVERSE_CHILDREN) {
	                            parseNodeTree(childNode, container, childStack, resourceLoader, index);
	                        }
	                    } else {
	                        stack.children.push(container);
	                        if (SHOULD_TRAVERSE_CHILDREN) {
	                            parseNodeTree(childNode, container, stack, resourceLoader, index);
	                        }
	                    }
	                }
	            }
	        } else if (childNode instanceof defaultView.SVGSVGElement || childNode instanceof SVGSVGElement || defaultView.parent && childNode instanceof defaultView.parent.SVGSVGElement) {
	            var _container = new _NodeContainer2.default(childNode, parent, resourceLoader, index++);
	            var _treatAsRealStackingContext = createsRealStackingContext(_container, childNode);
	            if (_treatAsRealStackingContext || createsStackingContext(_container)) {
	                // for treatAsRealStackingContext:false, any positioned descendants and descendants
	                // which actually create a new stacking context should be considered part of the parent stacking context
	                var _parentStack = _treatAsRealStackingContext || _container.isPositioned() ? stack.getRealParentStackingContext() : stack;
	                var _childStack = new _StackingContext2.default(_container, _parentStack, _treatAsRealStackingContext);
	                _parentStack.contexts.push(_childStack);
	            } else {
	                stack.children.push(_container);
	            }
	        }
	    }
	};
	
	var createsRealStackingContext = function createsRealStackingContext(container, node) {
	    return container.isRootElement() || container.isPositionedWithZIndex() || container.style.opacity < 1 || container.isTransformed() || isBodyWithTransparentRoot(container, node);
	};
	
	var createsStackingContext = function createsStackingContext(container) {
	    return container.isPositioned() || container.isFloating();
	};
	
	var isBodyWithTransparentRoot = function isBodyWithTransparentRoot(container, node) {
	    return node.nodeName === 'BODY' && container.parent instanceof _NodeContainer2.default && container.parent.style.background.backgroundColor.isTransparent();
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))
	
	/***/ }),
	/* 38 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _NodeContainer = __webpack_require__(4);
	
	var _NodeContainer2 = _interopRequireDefault(_NodeContainer);
	
	var _position = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var StackingContext = function () {
	    function StackingContext(container, parent, treatAsRealStackingContext) {
	        _classCallCheck(this, StackingContext);
	
	        this.container = container;
	        this.parent = parent;
	        this.contexts = [];
	        this.children = [];
	        this.treatAsRealStackingContext = treatAsRealStackingContext;
	    }
	
	    _createClass(StackingContext, [{
	        key: 'getOpacity',
	        value: function getOpacity() {
	            return this.parent ? this.container.style.opacity * this.parent.getOpacity() : this.container.style.opacity;
	        }
	    }, {
	        key: 'getRealParentStackingContext',
	        value: function getRealParentStackingContext() {
	            return !this.parent || this.treatAsRealStackingContext ? this : this.parent.getRealParentStackingContext();
	        }
	    }]);
	
	    return StackingContext;
	}();
	
	exports.default = StackingContext;
	
	/***/ }),
	/* 39 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Size = function Size(width, height) {
	    _classCallCheck(this, Size);
	
	    this.width = width;
	    this.height = height;
	};
	
	exports.default = Size;
	
	/***/ }),
	/* 40 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Path = __webpack_require__(8);
	
	var _Vector = __webpack_require__(9);
	
	var _Vector2 = _interopRequireDefault(_Vector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var lerp = function lerp(a, b, t) {
	    return new _Vector2.default(a.x + (b.x - a.x) * t, a.y + (b.y - a.y) * t);
	};
	
	var BezierCurve = function () {
	    function BezierCurve(start, startControl, endControl, end) {
	        _classCallCheck(this, BezierCurve);
	
	        this.type = _Path.PATH.BEZIER_CURVE;
	        this.start = start;
	        this.startControl = startControl;
	        this.endControl = endControl;
	        this.end = end;
	    }
	
	    _createClass(BezierCurve, [{
	        key: 'subdivide',
	        value: function subdivide(t, firstHalf) {
	            var ab = lerp(this.start, this.startControl, t);
	            var bc = lerp(this.startControl, this.endControl, t);
	            var cd = lerp(this.endControl, this.end, t);
	            var abbc = lerp(ab, bc, t);
	            var bccd = lerp(bc, cd, t);
	            var dest = lerp(abbc, bccd, t);
	            return firstHalf ? new BezierCurve(this.start, ab, abbc, dest) : new BezierCurve(dest, bccd, cd, this.end);
	        }
	    }, {
	        key: 'reverse',
	        value: function reverse() {
	            return new BezierCurve(this.end, this.endControl, this.startControl, this.start);
	        }
	    }]);
	
	    return BezierCurve;
	}();
	
	exports.default = BezierCurve;
	
	/***/ }),
	/* 41 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.parseBorderRadius = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _Length = __webpack_require__(2);
	
	var _Length2 = _interopRequireDefault(_Length);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SIDES = ['top-left', 'top-right', 'bottom-right', 'bottom-left'];
	
	var parseBorderRadius = exports.parseBorderRadius = function parseBorderRadius(style) {
	    return SIDES.map(function (side) {
	        var value = style.getPropertyValue('border-' + side + '-radius');
	
	        var _value$split$map = value.split(' ').map(_Length2.default.create),
	            _value$split$map2 = _slicedToArray(_value$split$map, 2),
	            horizontal = _value$split$map2[0],
	            vertical = _value$split$map2[1];
	
	        return typeof vertical === 'undefined' ? [horizontal, horizontal] : [horizontal, vertical];
	    });
	};
	
	/***/ }),
	/* 42 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var DISPLAY = exports.DISPLAY = {
	    NONE: 1 << 0,
	    BLOCK: 1 << 1,
	    INLINE: 1 << 2,
	    RUN_IN: 1 << 3,
	    FLOW: 1 << 4,
	    FLOW_ROOT: 1 << 5,
	    TABLE: 1 << 6,
	    FLEX: 1 << 7,
	    GRID: 1 << 8,
	    RUBY: 1 << 9,
	    SUBGRID: 1 << 10,
	    LIST_ITEM: 1 << 11,
	    TABLE_ROW_GROUP: 1 << 12,
	    TABLE_HEADER_GROUP: 1 << 13,
	    TABLE_FOOTER_GROUP: 1 << 14,
	    TABLE_ROW: 1 << 15,
	    TABLE_CELL: 1 << 16,
	    TABLE_COLUMN_GROUP: 1 << 17,
	    TABLE_COLUMN: 1 << 18,
	    TABLE_CAPTION: 1 << 19,
	    RUBY_BASE: 1 << 20,
	    RUBY_TEXT: 1 << 21,
	    RUBY_BASE_CONTAINER: 1 << 22,
	    RUBY_TEXT_CONTAINER: 1 << 23,
	    CONTENTS: 1 << 24,
	    INLINE_BLOCK: 1 << 25,
	    INLINE_LIST_ITEM: 1 << 26,
	    INLINE_TABLE: 1 << 27,
	    INLINE_FLEX: 1 << 28,
	    INLINE_GRID: 1 << 29
	};
	
	var parseDisplayValue = function parseDisplayValue(display) {
	    switch (display) {
	        case 'block':
	            return DISPLAY.BLOCK;
	        case 'inline':
	            return DISPLAY.INLINE;
	        case 'run-in':
	            return DISPLAY.RUN_IN;
	        case 'flow':
	            return DISPLAY.FLOW;
	        case 'flow-root':
	            return DISPLAY.FLOW_ROOT;
	        case 'table':
	            return DISPLAY.TABLE;
	        case 'flex':
	            return DISPLAY.FLEX;
	        case 'grid':
	            return DISPLAY.GRID;
	        case 'ruby':
	            return DISPLAY.RUBY;
	        case 'subgrid':
	            return DISPLAY.SUBGRID;
	        case 'list-item':
	            return DISPLAY.LIST_ITEM;
	        case 'table-row-group':
	            return DISPLAY.TABLE_ROW_GROUP;
	        case 'table-header-group':
	            return DISPLAY.TABLE_HEADER_GROUP;
	        case 'table-footer-group':
	            return DISPLAY.TABLE_FOOTER_GROUP;
	        case 'table-row':
	            return DISPLAY.TABLE_ROW;
	        case 'table-cell':
	            return DISPLAY.TABLE_CELL;
	        case 'table-column-group':
	            return DISPLAY.TABLE_COLUMN_GROUP;
	        case 'table-column':
	            return DISPLAY.TABLE_COLUMN;
	        case 'table-caption':
	            return DISPLAY.TABLE_CAPTION;
	        case 'ruby-base':
	            return DISPLAY.RUBY_BASE;
	        case 'ruby-text':
	            return DISPLAY.RUBY_TEXT;
	        case 'ruby-base-container':
	            return DISPLAY.RUBY_BASE_CONTAINER;
	        case 'ruby-text-container':
	            return DISPLAY.RUBY_TEXT_CONTAINER;
	        case 'contents':
	            return DISPLAY.CONTENTS;
	        case 'inline-block':
	            return DISPLAY.INLINE_BLOCK;
	        case 'inline-list-item':
	            return DISPLAY.INLINE_LIST_ITEM;
	        case 'inline-table':
	            return DISPLAY.INLINE_TABLE;
	        case 'inline-flex':
	            return DISPLAY.INLINE_FLEX;
	        case 'inline-grid':
	            return DISPLAY.INLINE_GRID;
	    }
	
	    return DISPLAY.NONE;
	};
	
	var setDisplayBit = function setDisplayBit(bit, display) {
	    return bit | parseDisplayValue(display);
	};
	
	var parseDisplay = exports.parseDisplay = function parseDisplay(display) {
	    return display.split(' ').reduce(setDisplayBit, 0);
	};
	
	/***/ }),
	/* 43 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var FLOAT = exports.FLOAT = {
	    NONE: 0,
	    LEFT: 1,
	    RIGHT: 2,
	    INLINE_START: 3,
	    INLINE_END: 4
	};
	
	var parseCSSFloat = exports.parseCSSFloat = function parseCSSFloat(float) {
	    switch (float) {
	        case 'left':
	            return FLOAT.LEFT;
	        case 'right':
	            return FLOAT.RIGHT;
	        case 'inline-start':
	            return FLOAT.INLINE_START;
	        case 'inline-end':
	            return FLOAT.INLINE_END;
	    }
	    return FLOAT.NONE;
	};
	
	/***/ }),
	/* 44 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	
	var parseFontWeight = function parseFontWeight(weight) {
	    switch (weight) {
	        case 'normal':
	            return 400;
	        case 'bold':
	            return 700;
	    }
	
	    var value = parseInt(weight, 10);
	    return isNaN(value) ? 400 : value;
	};
	
	var parseFont = exports.parseFont = function parseFont(style) {
	    var fontFamily = style.fontFamily;
	    var fontSize = style.fontSize;
	    var fontStyle = style.fontStyle;
	    var fontVariant = style.fontVariant;
	    var fontWeight = parseFontWeight(style.fontWeight);
	
	    return {
	        fontFamily: fontFamily,
	        fontSize: fontSize,
	        fontStyle: fontStyle,
	        fontVariant: fontVariant,
	        fontWeight: fontWeight
	    };
	};
	
	/***/ }),
	/* 45 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var parseLetterSpacing = exports.parseLetterSpacing = function parseLetterSpacing(letterSpacing) {
	    if (letterSpacing === 'normal') {
	        return 0;
	    }
	    var value = parseFloat(letterSpacing);
	    return isNaN(value) ? 0 : value;
	};
	
	/***/ }),
	/* 46 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var LINE_BREAK = exports.LINE_BREAK = {
	    NORMAL: 'normal',
	    STRICT: 'strict'
	};
	
	var parseLineBreak = exports.parseLineBreak = function parseLineBreak(wordBreak) {
	    switch (wordBreak) {
	        case 'strict':
	            return LINE_BREAK.STRICT;
	        case 'normal':
	        default:
	            return LINE_BREAK.NORMAL;
	    }
	};
	
	/***/ }),
	/* 47 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.parseMargin = undefined;
	
	var _Length = __webpack_require__(2);
	
	var _Length2 = _interopRequireDefault(_Length);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SIDES = ['top', 'right', 'bottom', 'left'];
	
	var parseMargin = exports.parseMargin = function parseMargin(style) {
	    return SIDES.map(function (side) {
	        return new _Length2.default(style.getPropertyValue('margin-' + side));
	    });
	};
	
	/***/ }),
	/* 48 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var OVERFLOW = exports.OVERFLOW = {
	    VISIBLE: 0,
	    HIDDEN: 1,
	    SCROLL: 2,
	    AUTO: 3
	};
	
	var parseOverflow = exports.parseOverflow = function parseOverflow(overflow) {
	    switch (overflow) {
	        case 'hidden':
	            return OVERFLOW.HIDDEN;
	        case 'scroll':
	            return OVERFLOW.SCROLL;
	        case 'auto':
	            return OVERFLOW.AUTO;
	        case 'visible':
	        default:
	            return OVERFLOW.VISIBLE;
	    }
	};
	
	/***/ }),
	/* 49 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.parseTextShadow = undefined;
	
	var _Color = __webpack_require__(1);
	
	var _Color2 = _interopRequireDefault(_Color);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NUMBER = /^([+-]|\d|\.)$/i;
	
	var parseTextShadow = exports.parseTextShadow = function parseTextShadow(textShadow) {
	    if (textShadow === 'none' || typeof textShadow !== 'string') {
	        return null;
	    }
	
	    var currentValue = '';
	    var isLength = false;
	    var values = [];
	    var shadows = [];
	    var numParens = 0;
	    var color = null;
	
	    var appendValue = function appendValue() {
	        if (currentValue.length) {
	            if (isLength) {
	                values.push(parseFloat(currentValue));
	            } else {
	                color = new _Color2.default(currentValue);
	            }
	        }
	        isLength = false;
	        currentValue = '';
	    };
	
	    var appendShadow = function appendShadow() {
	        if (values.length && color !== null) {
	            shadows.push({
	                color: color,
	                offsetX: values[0] || 0,
	                offsetY: values[1] || 0,
	                blur: values[2] || 0
	            });
	        }
	        values.splice(0, values.length);
	        color = null;
	    };
	
	    for (var i = 0; i < textShadow.length; i++) {
	        var c = textShadow[i];
	        switch (c) {
	            case '(':
	                currentValue += c;
	                numParens++;
	                break;
	            case ')':
	                currentValue += c;
	                numParens--;
	                break;
	            case ',':
	                if (numParens === 0) {
	                    appendValue();
	                    appendShadow();
	                } else {
	                    currentValue += c;
	                }
	                break;
	            case ' ':
	                if (numParens === 0) {
	                    appendValue();
	                } else {
	                    currentValue += c;
	                }
	                break;
	            default:
	                if (currentValue.length === 0 && NUMBER.test(c)) {
	                    isLength = true;
	                }
	                currentValue += c;
	        }
	    }
	
	    appendValue();
	    appendShadow();
	
	    if (shadows.length === 0) {
	        return null;
	    }
	
	    return shadows;
	};
	
	/***/ }),
	/* 50 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.parseTransform = undefined;
	
	var _Length = __webpack_require__(2);
	
	var _Length2 = _interopRequireDefault(_Length);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var toFloat = function toFloat(s) {
	    return parseFloat(s.trim());
	};
	
	var MATRIX = /(matrix|matrix3d)\((.+)\)/;
	
	var parseTransform = exports.parseTransform = function parseTransform(style) {
	    var transform = parseTransformMatrix(style.transform || style.webkitTransform || style.mozTransform ||
	    // $FlowFixMe
	    style.msTransform ||
	    // $FlowFixMe
	    style.oTransform);
	    if (transform === null) {
	        return null;
	    }
	
	    return {
	        transform: transform,
	        transformOrigin: parseTransformOrigin(style.transformOrigin || style.webkitTransformOrigin || style.mozTransformOrigin ||
	        // $FlowFixMe
	        style.msTransformOrigin ||
	        // $FlowFixMe
	        style.oTransformOrigin)
	    };
	};
	
	// $FlowFixMe
	var parseTransformOrigin = function parseTransformOrigin(origin) {
	    if (typeof origin !== 'string') {
	        var v = new _Length2.default('0');
	        return [v, v];
	    }
	    var values = origin.split(' ').map(_Length2.default.create);
	    return [values[0], values[1]];
	};
	
	// $FlowFixMe
	var parseTransformMatrix = function parseTransformMatrix(transform) {
	    if (transform === 'none' || typeof transform !== 'string') {
	        return null;
	    }
	
	    var match = transform.match(MATRIX);
	    if (match) {
	        if (match[1] === 'matrix') {
	            var matrix = match[2].split(',').map(toFloat);
	            return [matrix[0], matrix[1], matrix[2], matrix[3], matrix[4], matrix[5]];
	        } else {
	            var matrix3d = match[2].split(',').map(toFloat);
	            return [matrix3d[0], matrix3d[1], matrix3d[4], matrix3d[5], matrix3d[12], matrix3d[13]];
	        }
	    }
	    return null;
	};
	
	/***/ }),
	/* 51 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var VISIBILITY = exports.VISIBILITY = {
	    VISIBLE: 0,
	    HIDDEN: 1,
	    COLLAPSE: 2
	};
	
	var parseVisibility = exports.parseVisibility = function parseVisibility(visibility) {
	    switch (visibility) {
	        case 'hidden':
	            return VISIBILITY.HIDDEN;
	        case 'collapse':
	            return VISIBILITY.COLLAPSE;
	        case 'visible':
	        default:
	            return VISIBILITY.VISIBLE;
	    }
	};
	
	/***/ }),
	/* 52 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var WORD_BREAK = exports.WORD_BREAK = {
	    NORMAL: 'normal',
	    BREAK_ALL: 'break-all',
	    KEEP_ALL: 'keep-all'
	};
	
	var parseWordBreak = exports.parseWordBreak = function parseWordBreak(wordBreak) {
	    switch (wordBreak) {
	        case 'break-all':
	            return WORD_BREAK.BREAK_ALL;
	        case 'keep-all':
	            return WORD_BREAK.KEEP_ALL;
	        case 'normal':
	        default:
	            return WORD_BREAK.NORMAL;
	    }
	};
	
	/***/ }),
	/* 53 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var parseZIndex = exports.parseZIndex = function parseZIndex(zIndex) {
	    var auto = zIndex === 'auto';
	    return {
	        auto: auto,
	        order: auto ? 0 : parseInt(zIndex, 10)
	    };
	};
	
	/***/ }),
	/* 54 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Util = __webpack_require__(15);
	
	Object.defineProperty(exports, 'toCodePoints', {
	  enumerable: true,
	  get: function get() {
	    return _Util.toCodePoints;
	  }
	});
	Object.defineProperty(exports, 'fromCodePoint', {
	  enumerable: true,
	  get: function get() {
	    return _Util.fromCodePoint;
	  }
	});
	
	var _LineBreak = __webpack_require__(55);
	
	Object.defineProperty(exports, 'LineBreaker', {
	  enumerable: true,
	  get: function get() {
	    return _LineBreak.LineBreaker;
	  }
	});
	
	/***/ }),
	/* 55 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.LineBreaker = exports.inlineBreakOpportunities = exports.lineBreakAtIndex = exports.codePointsToCharacterClasses = exports.UnicodeTrie = exports.BREAK_ALLOWED = exports.BREAK_NOT_ALLOWED = exports.BREAK_MANDATORY = exports.classes = exports.LETTER_NUMBER_MODIFIER = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _Trie = __webpack_require__(56);
	
	var _linebreakTrie = __webpack_require__(57);
	
	var _linebreakTrie2 = _interopRequireDefault(_linebreakTrie);
	
	var _Util = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var LETTER_NUMBER_MODIFIER = exports.LETTER_NUMBER_MODIFIER = 50;
	
	// Non-tailorable Line Breaking Classes
	var BK = 1; //  Cause a line break (after)
	var CR = 2; //  Cause a line break (after), except between CR and LF
	var LF = 3; //  Cause a line break (after)
	var CM = 4; //  Prohibit a line break between the character and the preceding character
	var NL = 5; //  Cause a line break (after)
	var SG = 6; //  Do not occur in well-formed text
	var WJ = 7; //  Prohibit line breaks before and after
	var ZW = 8; //  Provide a break opportunity
	var GL = 9; //  Prohibit line breaks before and after
	var SP = 10; // Enable indirect line breaks
	var ZWJ = 11; // Prohibit line breaks within joiner sequences
	// Break Opportunities
	var B2 = 12; //  Provide a line break opportunity before and after the character
	var BA = 13; //  Generally provide a line break opportunity after the character
	var BB = 14; //  Generally provide a line break opportunity before the character
	var HY = 15; //  Provide a line break opportunity after the character, except in numeric context
	var CB = 16; //   Provide a line break opportunity contingent on additional information
	// Characters Prohibiting Certain Breaks
	var CL = 17; //  Prohibit line breaks before
	var CP = 18; //  Prohibit line breaks before
	var EX = 19; //  Prohibit line breaks before
	var IN = 20; //  Allow only indirect line breaks between pairs
	var NS = 21; //  Allow only indirect line breaks before
	var OP = 22; //  Prohibit line breaks after
	var QU = 23; //  Act like they are both opening and closing
	// Numeric Context
	var IS = 24; //  Prevent breaks after any and before numeric
	var NU = 25; //  Form numeric expressions for line breaking purposes
	var PO = 26; //  Do not break following a numeric expression
	var PR = 27; //  Do not break in front of a numeric expression
	var SY = 28; //  Prevent a break before; and allow a break after
	// Other Characters
	var AI = 29; //  Act like AL when the resolvedEAW is N; otherwise; act as ID
	var AL = 30; //  Are alphabetic characters or symbols that are used with alphabetic characters
	var CJ = 31; //  Treat as NS or ID for strict or normal breaking.
	var EB = 32; //  Do not break from following Emoji Modifier
	var EM = 33; //  Do not break from preceding Emoji Base
	var H2 = 34; //  Form Korean syllable blocks
	var H3 = 35; //  Form Korean syllable blocks
	var HL = 36; //  Do not break around a following hyphen; otherwise act as Alphabetic
	var ID = 37; //  Break before or after; except in some numeric context
	var JL = 38; //  Form Korean syllable blocks
	var JV = 39; //  Form Korean syllable blocks
	var JT = 40; //  Form Korean syllable blocks
	var RI = 41; //  Keep pairs together. For pairs; break before and after other classes
	var SA = 42; //  Provide a line break opportunity contingent on additional, language-specific context analysis
	var XX = 43; //  Have as yet unknown line breaking behavior or unassigned code positions
	
	var classes = exports.classes = {
	    BK: BK,
	    CR: CR,
	    LF: LF,
	    CM: CM,
	    NL: NL,
	    SG: SG,
	    WJ: WJ,
	    ZW: ZW,
	    GL: GL,
	    SP: SP,
	    ZWJ: ZWJ,
	    B2: B2,
	    BA: BA,
	    BB: BB,
	    HY: HY,
	    CB: CB,
	    CL: CL,
	    CP: CP,
	    EX: EX,
	    IN: IN,
	    NS: NS,
	    OP: OP,
	    QU: QU,
	    IS: IS,
	    NU: NU,
	    PO: PO,
	    PR: PR,
	    SY: SY,
	    AI: AI,
	    AL: AL,
	    CJ: CJ,
	    EB: EB,
	    EM: EM,
	    H2: H2,
	    H3: H3,
	    HL: HL,
	    ID: ID,
	    JL: JL,
	    JV: JV,
	    JT: JT,
	    RI: RI,
	    SA: SA,
	    XX: XX
	};
	
	var BREAK_MANDATORY = exports.BREAK_MANDATORY = '!';
	var BREAK_NOT_ALLOWED = exports.BREAK_NOT_ALLOWED = '×';
	var BREAK_ALLOWED = exports.BREAK_ALLOWED = '÷';
	var UnicodeTrie = exports.UnicodeTrie = (0, _Trie.createTrieFromBase64)(_linebreakTrie2.default);
	
	var ALPHABETICS = [AL, HL];
	var HARD_LINE_BREAKS = [BK, CR, LF, NL];
	var SPACE = [SP, ZW];
	var PREFIX_POSTFIX = [PR, PO];
	var LINE_BREAKS = HARD_LINE_BREAKS.concat(SPACE);
	var KOREAN_SYLLABLE_BLOCK = [JL, JV, JT, H2, H3];
	var HYPHEN = [HY, BA];
	
	var codePointsToCharacterClasses = exports.codePointsToCharacterClasses = function codePointsToCharacterClasses(codePoints) {
	    var lineBreak = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'strict';
	
	    var types = [];
	    var indicies = [];
	    var categories = [];
	    codePoints.forEach(function (codePoint, index) {
	        var classType = UnicodeTrie.get(codePoint);
	        if (classType > LETTER_NUMBER_MODIFIER) {
	            categories.push(true);
	            classType -= LETTER_NUMBER_MODIFIER;
	        } else {
	            categories.push(false);
	        }
	
	        if (['normal', 'auto', 'loose'].indexOf(lineBreak) !== -1) {
	            // U+2010, – U+2013, 〜 U+301C, ゠ U+30A0
	            if ([0x2010, 0x2013, 0x301c, 0x30a0].indexOf(codePoint) !== -1) {
	                indicies.push(index);
	                return types.push(CB);
	            }
	        }
	
	        if (classType === CM || classType === ZWJ) {
	            // LB10 Treat any remaining combining mark or ZWJ as AL.
	            if (index === 0) {
	                indicies.push(index);
	                return types.push(AL);
	            }
	
	            // LB9 Do not break a combining character sequence; treat it as if it has the line breaking class of
	            // the base character in all of the following rules. Treat ZWJ as if it were CM.
	            var prev = types[index - 1];
	            if (LINE_BREAKS.indexOf(prev) === -1) {
	                indicies.push(indicies[index - 1]);
	                return types.push(prev);
	            }
	            indicies.push(index);
	            return types.push(AL);
	        }
	
	        indicies.push(index);
	
	        if (classType === CJ) {
	            return types.push(lineBreak === 'strict' ? NS : ID);
	        }
	
	        if (classType === SA) {
	            return types.push(AL);
	        }
	
	        if (classType === AI) {
	            return types.push(AL);
	        }
	
	        // For supplementary characters, a useful default is to treat characters in the range 10000..1FFFD as AL
	        // and characters in the ranges 20000..2FFFD and 30000..3FFFD as ID, until the implementation can be revised
	        // to take into account the actual line breaking properties for these characters.
	        if (classType === XX) {
	            if (codePoint >= 0x20000 && codePoint <= 0x2fffd || codePoint >= 0x30000 && codePoint <= 0x3fffd) {
	                return types.push(ID);
	            } else {
	                return types.push(AL);
	            }
	        }
	
	        types.push(classType);
	    });
	
	    return [indicies, types, categories];
	};
	
	var isAdjacentWithSpaceIgnored = function isAdjacentWithSpaceIgnored(a, b, currentIndex, classTypes) {
	    var current = classTypes[currentIndex];
	    if (Array.isArray(a) ? a.indexOf(current) !== -1 : a === current) {
	        var i = currentIndex;
	        while (i <= classTypes.length) {
	            i++;
	            var next = classTypes[i];
	
	            if (next === b) {
	                return true;
	            }
	
	            if (next !== SP) {
	                break;
	            }
	        }
	    }
	
	    if (current === SP) {
	        var _i = currentIndex;
	
	        while (_i > 0) {
	            _i--;
	            var prev = classTypes[_i];
	
	            if (Array.isArray(a) ? a.indexOf(prev) !== -1 : a === prev) {
	                var n = currentIndex;
	                while (n <= classTypes.length) {
	                    n++;
	                    var _next = classTypes[n];
	
	                    if (_next === b) {
	                        return true;
	                    }
	
	                    if (_next !== SP) {
	                        break;
	                    }
	                }
	            }
	
	            if (prev !== SP) {
	                break;
	            }
	        }
	    }
	    return false;
	};
	
	var previousNonSpaceClassType = function previousNonSpaceClassType(currentIndex, classTypes) {
	    var i = currentIndex;
	    while (i >= 0) {
	        var type = classTypes[i];
	        if (type === SP) {
	            i--;
	        } else {
	            return type;
	        }
	    }
	    return 0;
	};
	
	var _lineBreakAtIndex = function _lineBreakAtIndex(codePoints, classTypes, indicies, index, forbiddenBreaks) {
	    if (indicies[index] === 0) {
	        return BREAK_NOT_ALLOWED;
	    }
	
	    var currentIndex = index - 1;
	    if (Array.isArray(forbiddenBreaks) && forbiddenBreaks[currentIndex] === true) {
	        return BREAK_NOT_ALLOWED;
	    }
	
	    var beforeIndex = currentIndex - 1;
	    var afterIndex = currentIndex + 1;
	    var current = classTypes[currentIndex];
	
	    // LB4 Always break after hard line breaks.
	    // LB5 Treat CR followed by LF, as well as CR, LF, and NL as hard line breaks.
	    var before = beforeIndex >= 0 ? classTypes[beforeIndex] : 0;
	    var next = classTypes[afterIndex];
	
	    if (current === CR && next === LF) {
	        return BREAK_NOT_ALLOWED;
	    }
	
	    if (HARD_LINE_BREAKS.indexOf(current) !== -1) {
	        return BREAK_MANDATORY;
	    }
	
	    // LB6 Do not break before hard line breaks.
	    if (HARD_LINE_BREAKS.indexOf(next) !== -1) {
	        return BREAK_NOT_ALLOWED;
	    }
	
	    // LB7 Do not break before spaces or zero width space.
	    if (SPACE.indexOf(next) !== -1) {
	        return BREAK_NOT_ALLOWED;
	    }
	
	    // LB8 Break before any character following a zero-width space, even if one or more spaces intervene.
	    if (previousNonSpaceClassType(currentIndex, classTypes) === ZW) {
	        return BREAK_ALLOWED;
	    }
	
	    // LB8a Do not break between a zero width joiner and an ideograph, emoji base or emoji modifier.
	    if (UnicodeTrie.get(codePoints[currentIndex]) === ZWJ && (next === ID || next === EB || next === EM)) {
	        return BREAK_NOT_ALLOWED;
	    }
	
	    // LB11 Do not break before or after Word joiner and related characters.
	    if (current === WJ || next === WJ) {
	        return BREAK_NOT_ALLOWED;
	    }
	
	    // LB12 Do not break after NBSP and related characters.
	    if (current === GL) {
	        return BREAK_NOT_ALLOWED;
	    }
	
	    // LB12a Do not break before NBSP and related characters, except after spaces and hyphens.
	    if ([SP, BA, HY].indexOf(current) === -1 && next === GL) {
	        return BREAK_NOT_ALLOWED;
	    }
	
	    // LB13 Do not break before ‘]’ or ‘!’ or ‘;’ or ‘/’, even after spaces.
	    if ([CL, CP, EX, IS, SY].indexOf(next) !== -1) {
	        return BREAK_NOT_ALLOWED;
	    }
	
	    // LB14 Do not break after ‘[’, even after spaces.
	    if (previousNonSpaceClassType(currentIndex, classTypes) === OP) {
	        return BREAK_NOT_ALLOWED;
	    }
	
	    // LB15 Do not break within ‘”[’, even with intervening spaces.
	    if (isAdjacentWithSpaceIgnored(QU, OP, currentIndex, classTypes)) {
	        return BREAK_NOT_ALLOWED;
	    }
	
	    // LB16 Do not break between closing punctuation and a nonstarter (lb=NS), even with intervening spaces.
	    if (isAdjacentWithSpaceIgnored([CL, CP], NS, currentIndex, classTypes)) {
	        return BREAK_NOT_ALLOWED;
	    }
	
	    // LB17 Do not break within ‘——’, even with intervening spaces.
	    if (isAdjacentWithSpaceIgnored(B2, B2, currentIndex, classTypes)) {
	        return BREAK_NOT_ALLOWED;
	    }
	
	    // LB18 Break after spaces.
	    if (current === SP) {
	        return BREAK_ALLOWED;
	    }
	
	    // LB19 Do not break before or after quotation marks, such as ‘ ” ’.
	    if (current === QU || next === QU) {
	        return BREAK_NOT_ALLOWED;
	    }
	
	    // LB20 Break before and after unresolved CB.
	    if (next === CB || current === CB) {
	        return BREAK_ALLOWED;
	    }
	
	    // LB21 Do not break before hyphen-minus, other hyphens, fixed-width spaces, small kana, and other non-starters, or after acute accents.
	    if ([BA, HY, NS].indexOf(next) !== -1 || current === BB) {
	        return BREAK_NOT_ALLOWED;
	    }
	
	    // LB21a Don't break after Hebrew + Hyphen.
	    if (before === HL && HYPHEN.indexOf(current) !== -1) {
	        return BREAK_NOT_ALLOWED;
	    }
	
	    // LB21b Don’t break between Solidus and Hebrew letters.
	    if (current === SY && next === HL) {
	        return BREAK_NOT_ALLOWED;
	    }
	
	    // LB22 Do not break between two ellipses, or between letters, numbers or exclamations and ellipsis.
	    if (next === IN && ALPHABETICS.concat(IN, EX, NU, ID, EB, EM).indexOf(current) !== -1) {
	        return BREAK_NOT_ALLOWED;
	    }
	
	    // LB23 Do not break between digits and letters.
	    if (ALPHABETICS.indexOf(next) !== -1 && current === NU || ALPHABETICS.indexOf(current) !== -1 && next === NU) {
	        return BREAK_NOT_ALLOWED;
	    }
	
	    // LB23a Do not break between numeric prefixes and ideographs, or between ideographs and numeric postfixes.
	    if (current === PR && [ID, EB, EM].indexOf(next) !== -1 || [ID, EB, EM].indexOf(current) !== -1 && next === PO) {
	        return BREAK_NOT_ALLOWED;
	    }
	
	    // LB24 Do not break between numeric prefix/postfix and letters, or between letters and prefix/postfix.
	    if (ALPHABETICS.indexOf(current) !== -1 && PREFIX_POSTFIX.indexOf(next) !== -1 || PREFIX_POSTFIX.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) {
	        return BREAK_NOT_ALLOWED;
	    }
	
	    // LB25 Do not break between the following pairs of classes relevant to numbers:
	    if (
	    // (PR | PO) × ( OP | HY )? NU
	    [PR, PO].indexOf(current) !== -1 && (next === NU || [OP, HY].indexOf(next) !== -1 && classTypes[afterIndex + 1] === NU) ||
	    // ( OP | HY ) × NU
	    [OP, HY].indexOf(current) !== -1 && next === NU ||
	    // NU ×	(NU | SY | IS)
	    current === NU && [NU, SY, IS].indexOf(next) !== -1) {
	        return BREAK_NOT_ALLOWED;
	    }
	
	    // NU (NU | SY | IS)* × (NU | SY | IS | CL | CP)
	    if ([NU, SY, IS, CL, CP].indexOf(next) !== -1) {
	        var prevIndex = currentIndex;
	        while (prevIndex >= 0) {
	            var type = classTypes[prevIndex];
	            if (type === NU) {
	                return BREAK_NOT_ALLOWED;
	            } else if ([SY, IS].indexOf(type) !== -1) {
	                prevIndex--;
	            } else {
	                break;
	            }
	        }
	    }
	
	    // NU (NU | SY | IS)* (CL | CP)? × (PO | PR))
	    if ([PR, PO].indexOf(next) !== -1) {
	        var _prevIndex = [CL, CP].indexOf(current) !== -1 ? beforeIndex : currentIndex;
	        while (_prevIndex >= 0) {
	            var _type = classTypes[_prevIndex];
	            if (_type === NU) {
	                return BREAK_NOT_ALLOWED;
	            } else if ([SY, IS].indexOf(_type) !== -1) {
	                _prevIndex--;
	            } else {
	                break;
	            }
	        }
	    }
	
	    // LB26 Do not break a Korean syllable.
	    if (JL === current && [JL, JV, H2, H3].indexOf(next) !== -1 || [JV, H2].indexOf(current) !== -1 && [JV, JT].indexOf(next) !== -1 || [JT, H3].indexOf(current) !== -1 && next === JT) {
	        return BREAK_NOT_ALLOWED;
	    }
	
	    // LB27 Treat a Korean Syllable Block the same as ID.
	    if (KOREAN_SYLLABLE_BLOCK.indexOf(current) !== -1 && [IN, PO].indexOf(next) !== -1 || KOREAN_SYLLABLE_BLOCK.indexOf(next) !== -1 && current === PR) {
	        return BREAK_NOT_ALLOWED;
	    }
	
	    // LB28 Do not break between alphabetics (“at”).
	    if (ALPHABETICS.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) {
	        return BREAK_NOT_ALLOWED;
	    }
	
	    // LB29 Do not break between numeric punctuation and alphabetics (“e.g.”).
	    if (current === IS && ALPHABETICS.indexOf(next) !== -1) {
	        return BREAK_NOT_ALLOWED;
	    }
	
	    // LB30 Do not break between letters, numbers, or ordinary symbols and opening or closing parentheses.
	    if (ALPHABETICS.concat(NU).indexOf(current) !== -1 && next === OP || ALPHABETICS.concat(NU).indexOf(next) !== -1 && current === CP) {
	        return BREAK_NOT_ALLOWED;
	    }
	
	    // LB30a Break between two regional indicator symbols if and only if there are an even number of regional
	    // indicators preceding the position of the break.
	    if (current === RI && next === RI) {
	        var i = indicies[currentIndex];
	        var count = 1;
	        while (i > 0) {
	            i--;
	            if (classTypes[i] === RI) {
	                count++;
	            } else {
	                break;
	            }
	        }
	        if (count % 2 !== 0) {
	            return BREAK_NOT_ALLOWED;
	        }
	    }
	
	    // LB30b Do not break between an emoji base and an emoji modifier.
	    if (current === EB && next === EM) {
	        return BREAK_NOT_ALLOWED;
	    }
	
	    return BREAK_ALLOWED;
	};
	
	var lineBreakAtIndex = exports.lineBreakAtIndex = function lineBreakAtIndex(codePoints, index) {
	    // LB2 Never break at the start of text.
	    if (index === 0) {
	        return BREAK_NOT_ALLOWED;
	    }
	
	    // LB3 Always break at the end of text.
	    if (index >= codePoints.length) {
	        return BREAK_MANDATORY;
	    }
	
	    var _codePointsToCharacte = codePointsToCharacterClasses(codePoints),
	        _codePointsToCharacte2 = _slicedToArray(_codePointsToCharacte, 2),
	        indicies = _codePointsToCharacte2[0],
	        classTypes = _codePointsToCharacte2[1];
	
	    return _lineBreakAtIndex(codePoints, classTypes, indicies, index);
	};
	
	var cssFormattedClasses = function cssFormattedClasses(codePoints, options) {
	    if (!options) {
	        options = { lineBreak: 'normal', wordBreak: 'normal' };
	    }
	
	    var _codePointsToCharacte3 = codePointsToCharacterClasses(codePoints, options.lineBreak),
	        _codePointsToCharacte4 = _slicedToArray(_codePointsToCharacte3, 3),
	        indicies = _codePointsToCharacte4[0],
	        classTypes = _codePointsToCharacte4[1],
	        isLetterNumber = _codePointsToCharacte4[2];
	
	    if (options.wordBreak === 'break-all' || options.wordBreak === 'break-word') {
	        classTypes = classTypes.map(function (type) {
	            return [NU, AL, SA].indexOf(type) !== -1 ? ID : type;
	        });
	    }
	
	    var forbiddenBreakpoints = options.wordBreak === 'keep-all' ? isLetterNumber.map(function (isLetterNumber, i) {
	        return isLetterNumber && codePoints[i] >= 0x4e00 && codePoints[i] <= 0x9fff;
	    }) : null;
	
	    return [indicies, classTypes, forbiddenBreakpoints];
	};
	
	var inlineBreakOpportunities = exports.inlineBreakOpportunities = function inlineBreakOpportunities(str, options) {
	    var codePoints = (0, _Util.toCodePoints)(str);
	    var output = BREAK_NOT_ALLOWED;
	
	    var _cssFormattedClasses = cssFormattedClasses(codePoints, options),
	        _cssFormattedClasses2 = _slicedToArray(_cssFormattedClasses, 3),
	        indicies = _cssFormattedClasses2[0],
	        classTypes = _cssFormattedClasses2[1],
	        forbiddenBreakpoints = _cssFormattedClasses2[2];
	
	    codePoints.forEach(function (codePoint, i) {
	        output += (0, _Util.fromCodePoint)(codePoint) + (i >= codePoints.length - 1 ? BREAK_MANDATORY : _lineBreakAtIndex(codePoints, classTypes, indicies, i + 1, forbiddenBreakpoints));
	    });
	
	    return output;
	};
	
	var Break = function () {
	    function Break(codePoints, lineBreak, start, end) {
	        _classCallCheck(this, Break);
	
	        this._codePoints = codePoints;
	        this.required = lineBreak === BREAK_MANDATORY;
	        this.start = start;
	        this.end = end;
	    }
	
	    _createClass(Break, [{
	        key: 'slice',
	        value: function slice() {
	            return _Util.fromCodePoint.apply(undefined, _toConsumableArray(this._codePoints.slice(this.start, this.end)));
	        }
	    }]);
	
	    return Break;
	}();
	
	var LineBreaker = exports.LineBreaker = function LineBreaker(str, options) {
	    var codePoints = (0, _Util.toCodePoints)(str);
	
	    var _cssFormattedClasses3 = cssFormattedClasses(codePoints, options),
	        _cssFormattedClasses4 = _slicedToArray(_cssFormattedClasses3, 3),
	        indicies = _cssFormattedClasses4[0],
	        classTypes = _cssFormattedClasses4[1],
	        forbiddenBreakpoints = _cssFormattedClasses4[2];
	
	    var length = codePoints.length;
	    var lastEnd = 0;
	    var nextIndex = 0;
	
	    return {
	        next: function next() {
	            if (nextIndex >= length) {
	                return { done: true };
	            }
	            var lineBreak = BREAK_NOT_ALLOWED;
	            while (nextIndex < length && (lineBreak = _lineBreakAtIndex(codePoints, classTypes, indicies, ++nextIndex, forbiddenBreakpoints)) === BREAK_NOT_ALLOWED) {}
	
	            if (lineBreak !== BREAK_NOT_ALLOWED || nextIndex === length) {
	                var value = new Break(codePoints, lineBreak, lastEnd, nextIndex);
	                lastEnd = nextIndex;
	                return { value: value, done: false };
	            }
	
	            return { done: true };
	        }
	    };
	};
	
	/***/ }),
	/* 56 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Trie = exports.createTrieFromBase64 = exports.UTRIE2_INDEX_2_MASK = exports.UTRIE2_INDEX_2_BLOCK_LENGTH = exports.UTRIE2_OMITTED_BMP_INDEX_1_LENGTH = exports.UTRIE2_INDEX_1_OFFSET = exports.UTRIE2_UTF8_2B_INDEX_2_LENGTH = exports.UTRIE2_UTF8_2B_INDEX_2_OFFSET = exports.UTRIE2_INDEX_2_BMP_LENGTH = exports.UTRIE2_LSCP_INDEX_2_LENGTH = exports.UTRIE2_DATA_MASK = exports.UTRIE2_DATA_BLOCK_LENGTH = exports.UTRIE2_LSCP_INDEX_2_OFFSET = exports.UTRIE2_SHIFT_1_2 = exports.UTRIE2_INDEX_SHIFT = exports.UTRIE2_SHIFT_1 = exports.UTRIE2_SHIFT_2 = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Util = __webpack_require__(15);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/** Shift size for getting the index-2 table offset. */
	var UTRIE2_SHIFT_2 = exports.UTRIE2_SHIFT_2 = 5;
	
	/** Shift size for getting the index-1 table offset. */
	var UTRIE2_SHIFT_1 = exports.UTRIE2_SHIFT_1 = 6 + 5;
	
	/**
	 * Shift size for shifting left the index array values.
	 * Increases possible data size with 16-bit index values at the cost
	 * of compactability.
	 * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
	 */
	var UTRIE2_INDEX_SHIFT = exports.UTRIE2_INDEX_SHIFT = 2;
	
	/**
	 * Difference between the two shift sizes,
	 * for getting an index-1 offset from an index-2 offset. 6=11-5
	 */
	var UTRIE2_SHIFT_1_2 = exports.UTRIE2_SHIFT_1_2 = UTRIE2_SHIFT_1 - UTRIE2_SHIFT_2;
	
	/**
	 * The part of the index-2 table for U+D800..U+DBFF stores values for
	 * lead surrogate code _units_ not code _points_.
	 * Values for lead surrogate code _points_ are indexed with this portion of the table.
	 * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
	 */
	var UTRIE2_LSCP_INDEX_2_OFFSET = exports.UTRIE2_LSCP_INDEX_2_OFFSET = 0x10000 >> UTRIE2_SHIFT_2;
	
	/** Number of entries in a data block. 32=0x20 */
	var UTRIE2_DATA_BLOCK_LENGTH = exports.UTRIE2_DATA_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_2;
	/** Mask for getting the lower bits for the in-data-block offset. */
	var UTRIE2_DATA_MASK = exports.UTRIE2_DATA_MASK = UTRIE2_DATA_BLOCK_LENGTH - 1;
	
	var UTRIE2_LSCP_INDEX_2_LENGTH = exports.UTRIE2_LSCP_INDEX_2_LENGTH = 0x400 >> UTRIE2_SHIFT_2;
	/** Count the lengths of both BMP pieces. 2080=0x820 */
	var UTRIE2_INDEX_2_BMP_LENGTH = exports.UTRIE2_INDEX_2_BMP_LENGTH = UTRIE2_LSCP_INDEX_2_OFFSET + UTRIE2_LSCP_INDEX_2_LENGTH;
	/**
	 * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
	 * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
	 */
	var UTRIE2_UTF8_2B_INDEX_2_OFFSET = exports.UTRIE2_UTF8_2B_INDEX_2_OFFSET = UTRIE2_INDEX_2_BMP_LENGTH;
	var UTRIE2_UTF8_2B_INDEX_2_LENGTH = exports.UTRIE2_UTF8_2B_INDEX_2_LENGTH = 0x800 >> 6; /* U+0800 is the first code point after 2-byte UTF-8 */
	/**
	 * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
	 * Variable length, for code points up to highStart, where the last single-value range starts.
	 * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
	 * (For 0x100000 supplementary code points U+10000..U+10ffff.)
	 *
	 * The part of the index-2 table for supplementary code points starts
	 * after this index-1 table.
	 *
	 * Both the index-1 table and the following part of the index-2 table
	 * are omitted completely if there is only BMP data.
	 */
	var UTRIE2_INDEX_1_OFFSET = exports.UTRIE2_INDEX_1_OFFSET = UTRIE2_UTF8_2B_INDEX_2_OFFSET + UTRIE2_UTF8_2B_INDEX_2_LENGTH;
	
	/**
	 * Number of index-1 entries for the BMP. 32=0x20
	 * This part of the index-1 table is omitted from the serialized form.
	 */
	var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH = exports.UTRIE2_OMITTED_BMP_INDEX_1_LENGTH = 0x10000 >> UTRIE2_SHIFT_1;
	
	/** Number of entries in an index-2 block. 64=0x40 */
	var UTRIE2_INDEX_2_BLOCK_LENGTH = exports.UTRIE2_INDEX_2_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_1_2;
	/** Mask for getting the lower bits for the in-index-2-block offset. */
	var UTRIE2_INDEX_2_MASK = exports.UTRIE2_INDEX_2_MASK = UTRIE2_INDEX_2_BLOCK_LENGTH - 1;
	
	var createTrieFromBase64 = exports.createTrieFromBase64 = function createTrieFromBase64(base64) {
	    var buffer = (0, _Util.decode)(base64);
	    var view32 = Array.isArray(buffer) ? (0, _Util.polyUint32Array)(buffer) : new Uint32Array(buffer);
	    var view16 = Array.isArray(buffer) ? (0, _Util.polyUint16Array)(buffer) : new Uint16Array(buffer);
	    var headerLength = 24;
	
	    var index = view16.slice(headerLength / 2, view32[4] / 2);
	    var data = view32[5] === 2 ? view16.slice((headerLength + view32[4]) / 2) : view32.slice(Math.ceil((headerLength + view32[4]) / 4));
	
	    return new Trie(view32[0], view32[1], view32[2], view32[3], index, data);
	};
	
	var Trie = exports.Trie = function () {
	    function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
	        _classCallCheck(this, Trie);
	
	        this.initialValue = initialValue;
	        this.errorValue = errorValue;
	        this.highStart = highStart;
	        this.highValueIndex = highValueIndex;
	        this.index = index;
	        this.data = data;
	    }
	
	    /**
	     * Get the value for a code point as stored in the Trie.
	     *
	     * @param codePoint the code point
	     * @return the value
	     */
	
	
	    _createClass(Trie, [{
	        key: 'get',
	        value: function get(codePoint) {
	            var ix = void 0;
	            if (codePoint >= 0) {
	                if (codePoint < 0x0d800 || codePoint > 0x0dbff && codePoint <= 0x0ffff) {
	                    // Ordinary BMP code point, excluding leading surrogates.
	                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
	                    // 16 bit data is stored in the index array itself.
	                    ix = this.index[codePoint >> UTRIE2_SHIFT_2];
	                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
	                    return this.data[ix];
	                }
	
	                if (codePoint <= 0xffff) {
	                    // Lead Surrogate Code Point.  A Separate index section is stored for
	                    // lead surrogate code units and code points.
	                    //   The main index has the code unit data.
	                    //   For this function, we need the code point data.
	                    // Note: this expression could be refactored for slightly improved efficiency, but
	                    //       surrogate code points will be so rare in practice that it's not worth it.
	                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET + (codePoint - 0xd800 >> UTRIE2_SHIFT_2)];
	                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
	                    return this.data[ix];
	                }
	
	                if (codePoint < this.highStart) {
	                    // Supplemental code point, use two-level lookup.
	                    ix = UTRIE2_INDEX_1_OFFSET - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH + (codePoint >> UTRIE2_SHIFT_1);
	                    ix = this.index[ix];
	                    ix += codePoint >> UTRIE2_SHIFT_2 & UTRIE2_INDEX_2_MASK;
	                    ix = this.index[ix];
	                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
	                    return this.data[ix];
	                }
	                if (codePoint <= 0x10ffff) {
	                    return this.data[this.highValueIndex];
	                }
	            }
	
	            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
	            return this.errorValue;
	        }
	    }]);
	
	    return Trie;
	}();
	
	/***/ }),
	/* 57 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	module.exports = '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';
	
	/***/ }),
	/* 58 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/* WEBPACK VAR INJECTION */(function(process) {
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _Path = __webpack_require__(8);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Circle = function Circle(x, y, radius) {
	    _classCallCheck(this, Circle);
	
	    this.type = _Path.PATH.CIRCLE;
	    this.x = x;
	    this.y = y;
	    this.radius = radius;
	    if (process.env.NODE_ENV !== 'production') {
	        if (isNaN(x)) {
	            console.error('Invalid x value given for Circle');
	        }
	        if (isNaN(y)) {
	            console.error('Invalid y value given for Circle');
	        }
	        if (isNaN(radius)) {
	            console.error('Invalid radius value given for Circle');
	        }
	    }
	};
	
	exports.default = Circle;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))
	
	/***/ }),
	/* 59 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/* WEBPACK VAR INJECTION */(function(process) {
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Bounds = __webpack_require__(3);
	
	var _Font = __webpack_require__(27);
	
	var _Gradient = __webpack_require__(60);
	
	var _TextContainer = __webpack_require__(11);
	
	var _TextContainer2 = _interopRequireDefault(_TextContainer);
	
	var _background = __webpack_require__(6);
	
	var _border = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Renderer = function () {
	    function Renderer(target, options) {
	        _classCallCheck(this, Renderer);
	
	        this.target = target;
	        this.options = options;
	        target.render(options);
	    }
	
	    _createClass(Renderer, [{
	        key: 'renderNode',
	        value: function renderNode(container) {
	            if (container.isVisible()) {
	                this.renderNodeBackgroundAndBorders(container);
	                this.renderNodeContent(container);
	            }
	        }
	    }, {
	        key: 'renderNodeContent',
	        value: function renderNodeContent(container) {
	            var _this = this;
	
	            var callback = function callback() {
	                if (container.childNodes.length) {
	                    container.childNodes.forEach(function (child) {
	                        if (child instanceof _TextContainer2.default) {
	                            var style = child.parent.style;
	                            _this.target.renderTextNode(child.bounds, style.color, style.font, style.textDecoration, style.textShadow);
	                        } else {
	                            _this.target.drawShape(child, container.style.color);
	                        }
	                    });
	                }
	
	                if (container.image) {
	                    var _image = _this.options.imageStore.get(container.image);
	                    if (_image) {
	                        var contentBox = (0, _Bounds.calculateContentBox)(container.bounds, container.style.padding, container.style.border);
	                        var _width = typeof _image.width === 'number' && _image.width > 0 ? _image.width : contentBox.width;
	                        var _height = typeof _image.height === 'number' && _image.height > 0 ? _image.height : contentBox.height;
	                        if (_width > 0 && _height > 0) {
	                            _this.target.clip([(0, _Bounds.calculatePaddingBoxPath)(container.curvedBounds)], function () {
	                                _this.target.drawImage(_image, new _Bounds.Bounds(0, 0, _width, _height), contentBox);
	                            });
	                        }
	                    }
	                }
	            };
	            var paths = container.getClipPaths();
	            if (paths.length) {
	                this.target.clip(paths, callback);
	            } else {
	                callback();
	            }
	        }
	    }, {
	        key: 'renderNodeBackgroundAndBorders',
	        value: function renderNodeBackgroundAndBorders(container) {
	            var _this2 = this;
	
	            var HAS_BACKGROUND = !container.style.background.backgroundColor.isTransparent() || container.style.background.backgroundImage.length;
	
	            var hasRenderableBorders = container.style.border.some(function (border) {
	                return border.borderStyle !== _border.BORDER_STYLE.NONE && !border.borderColor.isTransparent();
	            });
	
	            var callback = function callback() {
	                var backgroundPaintingArea = (0, _background.calculateBackgroungPaintingArea)(container.curvedBounds, container.style.background.backgroundClip);
	
	                if (HAS_BACKGROUND) {
	                    _this2.target.clip([backgroundPaintingArea], function () {
	                        if (!container.style.background.backgroundColor.isTransparent()) {
	                            _this2.target.fill(container.style.background.backgroundColor);
	                        }
	
	                        _this2.renderBackgroundImage(container);
	                    });
	                }
	
	                container.style.border.forEach(function (border, side) {
	                    if (border.borderStyle !== _border.BORDER_STYLE.NONE && !border.borderColor.isTransparent()) {
	                        _this2.renderBorder(border, side, container.curvedBounds);
	                    }
	                });
	            };
	
	            if (HAS_BACKGROUND || hasRenderableBorders) {
	                var paths = container.parent ? container.parent.getClipPaths() : [];
	                if (paths.length) {
	                    this.target.clip(paths, callback);
	                } else {
	                    callback();
	                }
	            }
	        }
	    }, {
	        key: 'renderBackgroundImage',
	        value: function renderBackgroundImage(container) {
	            var _this3 = this;
	
	            container.style.background.backgroundImage.slice(0).reverse().forEach(function (backgroundImage) {
	                if (backgroundImage.source.method === 'url' && backgroundImage.source.args.length) {
	                    _this3.renderBackgroundRepeat(container, backgroundImage);
	                } else if (/gradient/i.test(backgroundImage.source.method)) {
	                    _this3.renderBackgroundGradient(container, backgroundImage);
	                }
	            });
	        }
	    }, {
	        key: 'renderBackgroundRepeat',
	        value: function renderBackgroundRepeat(container, background) {
	            var image = this.options.imageStore.get(background.source.args[0]);
	            if (image) {
	                var backgroundPositioningArea = (0, _background.calculateBackgroungPositioningArea)(container.style.background.backgroundOrigin, container.bounds, container.style.padding, container.style.border);
	                var backgroundImageSize = (0, _background.calculateBackgroundSize)(background, image, backgroundPositioningArea);
	                var position = (0, _background.calculateBackgroundPosition)(background.position, backgroundImageSize, backgroundPositioningArea);
	                var _path = (0, _background.calculateBackgroundRepeatPath)(background, position, backgroundImageSize, backgroundPositioningArea, container.bounds);
	
	                var _offsetX = Math.round(backgroundPositioningArea.left + position.x);
	                var _offsetY = Math.round(backgroundPositioningArea.top + position.y);
	                this.target.renderRepeat(_path, image, backgroundImageSize, _offsetX, _offsetY);
	            }
	        }
	    }, {
	        key: 'renderBackgroundGradient',
	        value: function renderBackgroundGradient(container, background) {
	            var backgroundPositioningArea = (0, _background.calculateBackgroungPositioningArea)(container.style.background.backgroundOrigin, container.bounds, container.style.padding, container.style.border);
	            var backgroundImageSize = (0, _background.calculateGradientBackgroundSize)(background, backgroundPositioningArea);
	            var position = (0, _background.calculateBackgroundPosition)(background.position, backgroundImageSize, backgroundPositioningArea);
	            var gradientBounds = new _Bounds.Bounds(Math.round(backgroundPositioningArea.left + position.x), Math.round(backgroundPositioningArea.top + position.y), backgroundImageSize.width, backgroundImageSize.height);
	
	            var gradient = (0, _Gradient.parseGradient)(container, background.source, gradientBounds);
	            if (gradient) {
	                switch (gradient.type) {
	                    case _Gradient.GRADIENT_TYPE.LINEAR_GRADIENT:
	                        // $FlowFixMe
	                        this.target.renderLinearGradient(gradientBounds, gradient);
	                        break;
	                    case _Gradient.GRADIENT_TYPE.RADIAL_GRADIENT:
	                        // $FlowFixMe
	                        this.target.renderRadialGradient(gradientBounds, gradient);
	                        break;
	                }
	            }
	        }
	    }, {
	        key: 'renderBorder',
	        value: function renderBorder(border, side, curvePoints) {
	            this.target.drawShape((0, _Bounds.parsePathForBorder)(curvePoints, side), border.borderColor);
	        }
	    }, {
	        key: 'renderStack',
	        value: function renderStack(stack) {
	            var _this4 = this;
	
	            if (stack.container.isVisible()) {
	                var _opacity = stack.getOpacity();
	                if (_opacity !== this._opacity) {
	                    this.target.setOpacity(stack.getOpacity());
	                    this._opacity = _opacity;
	                }
	
	                var _transform = stack.container.style.transform;
	                if (_transform !== null) {
	                    this.target.transform(stack.container.bounds.left + _transform.transformOrigin[0].value, stack.container.bounds.top + _transform.transformOrigin[1].value, _transform.transform, function () {
	                        return _this4.renderStackContent(stack);
	                    });
	                } else {
	                    this.renderStackContent(stack);
	                }
	            }
	        }
	    }, {
	        key: 'renderStackContent',
	        value: function renderStackContent(stack) {
	            var _splitStackingContext = splitStackingContexts(stack),
	                _splitStackingContext2 = _slicedToArray(_splitStackingContext, 5),
	                negativeZIndex = _splitStackingContext2[0],
	                zeroOrAutoZIndexOrTransformedOrOpacity = _splitStackingContext2[1],
	                positiveZIndex = _splitStackingContext2[2],
	                nonPositionedFloats = _splitStackingContext2[3],
	                nonPositionedInlineLevel = _splitStackingContext2[4];
	
	            var _splitDescendants = splitDescendants(stack),
	                _splitDescendants2 = _slicedToArray(_splitDescendants, 2),
	                inlineLevel = _splitDescendants2[0],
	                nonInlineLevel = _splitDescendants2[1];
	
	            // https://www.w3.org/TR/css-position-3/#painting-order
	            // 1. the background and borders of the element forming the stacking context.
	
	
	            this.renderNodeBackgroundAndBorders(stack.container);
	            // 2. the child stacking contexts with negative stack levels (most negative first).
	            negativeZIndex.sort(sortByZIndex).forEach(this.renderStack, this);
	            // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
	            this.renderNodeContent(stack.container);
	            nonInlineLevel.forEach(this.renderNode, this);
	            // 4. All non-positioned floating descendants, in tree order. For each one of these,
	            // treat the element as if it created a new stacking context, but any positioned descendants and descendants
	            // which actually create a new stacking context should be considered part of the parent stacking context,
	            // not this new one.
	            nonPositionedFloats.forEach(this.renderStack, this);
	            // 5. the in-flow, inline-level, non-positioned descendants, including inline tables and inline blocks.
	            nonPositionedInlineLevel.forEach(this.renderStack, this);
	            inlineLevel.forEach(this.renderNode, this);
	            // 6. All positioned, opacity or transform descendants, in tree order that fall into the following categories:
	            //  All positioned descendants with 'z-index: auto' or 'z-index: 0', in tree order.
	            //  For those with 'z-index: auto', treat the element as if it created a new stacking context,
	            //  but any positioned descendants and descendants which actually create a new stacking context should be
	            //  considered part of the parent stacking context, not this new one. For those with 'z-index: 0',
	            //  treat the stacking context generated atomically.
	            //
	            //  All opacity descendants with opacity less than 1
	            //
	            //  All transform descendants with transform other than none
	            zeroOrAutoZIndexOrTransformedOrOpacity.forEach(this.renderStack, this);
	            // 7. Stacking contexts formed by positioned descendants with z-indices greater than or equal to 1 in z-index
	            // order (smallest first) then tree order.
	            positiveZIndex.sort(sortByZIndex).forEach(this.renderStack, this);
	        }
	    }, {
	        key: 'render',
	        value: function render(stack) {
	            var _this5 = this;
	
	            if (this.options.backgroundColor) {
	                this.target.rectangle(this.options.x, this.options.y, this.options.width, this.options.height, this.options.backgroundColor);
	            }
	            this.renderStack(stack);
	            var target = this.target.getTarget();
	            if (process.env.NODE_ENV !== 'production') {
	                return target.then(function (output) {
	                    _this5.options.logger.log('Render completed');
	                    return output;
	                });
	            }
	            return target;
	        }
	    }]);
	
	    return Renderer;
	}();
	
	exports.default = Renderer;
	
	
	var splitDescendants = function splitDescendants(stack) {
	    var inlineLevel = [];
	    var nonInlineLevel = [];
	
	    var length = stack.children.length;
	    for (var i = 0; i < length; i++) {
	        var child = stack.children[i];
	        if (child.isInlineLevel()) {
	            inlineLevel.push(child);
	        } else {
	            nonInlineLevel.push(child);
	        }
	    }
	    return [inlineLevel, nonInlineLevel];
	};
	
	var splitStackingContexts = function splitStackingContexts(stack) {
	    var negativeZIndex = [];
	    var zeroOrAutoZIndexOrTransformedOrOpacity = [];
	    var positiveZIndex = [];
	    var nonPositionedFloats = [];
	    var nonPositionedInlineLevel = [];
	    var length = stack.contexts.length;
	    for (var i = 0; i < length; i++) {
	        var child = stack.contexts[i];
	        if (child.container.isPositioned() || child.container.style.opacity < 1 || child.container.isTransformed()) {
	            if (child.container.style.zIndex.order < 0) {
	                negativeZIndex.push(child);
	            } else if (child.container.style.zIndex.order > 0) {
	                positiveZIndex.push(child);
	            } else {
	                zeroOrAutoZIndexOrTransformedOrOpacity.push(child);
	            }
	        } else {
	            if (child.container.isFloating()) {
	                nonPositionedFloats.push(child);
	            } else {
	                nonPositionedInlineLevel.push(child);
	            }
	        }
	    }
	    return [negativeZIndex, zeroOrAutoZIndexOrTransformedOrOpacity, positiveZIndex, nonPositionedFloats, nonPositionedInlineLevel];
	};
	
	var sortByZIndex = function sortByZIndex(a, b) {
	    if (a.container.style.zIndex.order > b.container.style.zIndex.order) {
	        return 1;
	    } else if (a.container.style.zIndex.order < b.container.style.zIndex.order) {
	        return -1;
	    }
	
	    return a.container.index > b.container.index ? 1 : -1;
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))
	
	/***/ }),
	/* 60 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.transformWebkitRadialGradientArgs = exports.parseGradient = exports.RadialGradient = exports.LinearGradient = exports.RADIAL_GRADIENT_SHAPE = exports.GRADIENT_TYPE = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _NodeContainer = __webpack_require__(4);
	
	var _NodeContainer2 = _interopRequireDefault(_NodeContainer);
	
	var _Angle = __webpack_require__(61);
	
	var _Color = __webpack_require__(1);
	
	var _Color2 = _interopRequireDefault(_Color);
	
	var _Length = __webpack_require__(2);
	
	var _Length2 = _interopRequireDefault(_Length);
	
	var _Util = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SIDE_OR_CORNER = /^(to )?(left|top|right|bottom)( (left|top|right|bottom))?$/i;
	var PERCENTAGE_ANGLES = /^([+-]?\d*\.?\d+)% ([+-]?\d*\.?\d+)%$/i;
	var ENDS_WITH_LENGTH = /(px)|%|( 0)$/i;
	var FROM_TO_COLORSTOP = /^(from|to|color-stop)\((?:([\d.]+)(%)?,\s*)?(.+?)\)$/i;
	var RADIAL_SHAPE_DEFINITION = /^\s*(circle|ellipse)?\s*((?:([\d.]+)(px|r?em|%)\s*(?:([\d.]+)(px|r?em|%))?)|closest-side|closest-corner|farthest-side|farthest-corner)?\s*(?:at\s*(?:(left|center|right)|([\d.]+)(px|r?em|%))\s+(?:(top|center|bottom)|([\d.]+)(px|r?em|%)))?(?:\s|$)/i;
	
	var GRADIENT_TYPE = exports.GRADIENT_TYPE = {
	    LINEAR_GRADIENT: 0,
	    RADIAL_GRADIENT: 1
	};
	
	var RADIAL_GRADIENT_SHAPE = exports.RADIAL_GRADIENT_SHAPE = {
	    CIRCLE: 0,
	    ELLIPSE: 1
	};
	
	var LENGTH_FOR_POSITION = {
	    left: new _Length2.default('0%'),
	    top: new _Length2.default('0%'),
	    center: new _Length2.default('50%'),
	    right: new _Length2.default('100%'),
	    bottom: new _Length2.default('100%')
	};
	
	var LinearGradient = exports.LinearGradient = function LinearGradient(colorStops, direction) {
	    _classCallCheck(this, LinearGradient);
	
	    this.type = GRADIENT_TYPE.LINEAR_GRADIENT;
	    this.colorStops = colorStops;
	    this.direction = direction;
	};
	
	var RadialGradient = exports.RadialGradient = function RadialGradient(colorStops, shape, center, radius) {
	    _classCallCheck(this, RadialGradient);
	
	    this.type = GRADIENT_TYPE.RADIAL_GRADIENT;
	    this.colorStops = colorStops;
	    this.shape = shape;
	    this.center = center;
	    this.radius = radius;
	};
	
	var parseGradient = exports.parseGradient = function parseGradient(container, _ref, bounds) {
	    var args = _ref.args,
	        method = _ref.method,
	        prefix = _ref.prefix;
	
	    if (method === 'linear-gradient') {
	        return parseLinearGradient(args, bounds, !!prefix);
	    } else if (method === 'gradient' && args[0] === 'linear') {
	        // TODO handle correct angle
	        return parseLinearGradient(['to bottom'].concat(transformObsoleteColorStops(args.slice(3))), bounds, !!prefix);
	    } else if (method === 'radial-gradient') {
	        return parseRadialGradient(container, prefix === '-webkit-' ? transformWebkitRadialGradientArgs(args) : args, bounds);
	    } else if (method === 'gradient' && args[0] === 'radial') {
	        return parseRadialGradient(container, transformObsoleteColorStops(transformWebkitRadialGradientArgs(args.slice(1))), bounds);
	    }
	};
	
	var parseColorStops = function parseColorStops(args, firstColorStopIndex, lineLength) {
	    var colorStops = [];
	
	    for (var i = firstColorStopIndex; i < args.length; i++) {
	        var value = args[i];
	        var HAS_LENGTH = ENDS_WITH_LENGTH.test(value);
	        var lastSpaceIndex = value.lastIndexOf(' ');
	        var _color = new _Color2.default(HAS_LENGTH ? value.substring(0, lastSpaceIndex) : value);
	        var _stop = HAS_LENGTH ? new _Length2.default(value.substring(lastSpaceIndex + 1)) : i === firstColorStopIndex ? new _Length2.default('0%') : i === args.length - 1 ? new _Length2.default('100%') : null;
	        colorStops.push({ color: _color, stop: _stop });
	    }
	
	    var absoluteValuedColorStops = colorStops.map(function (_ref2) {
	        var color = _ref2.color,
	            stop = _ref2.stop;
	
	        var absoluteStop = lineLength === 0 ? 0 : stop ? stop.getAbsoluteValue(lineLength) / lineLength : null;
	
	        return {
	            color: color,
	            // $FlowFixMe
	            stop: absoluteStop
	        };
	    });
	
	    var previousColorStop = absoluteValuedColorStops[0].stop;
	    for (var _i = 0; _i < absoluteValuedColorStops.length; _i++) {
	        if (previousColorStop !== null) {
	            var _stop2 = absoluteValuedColorStops[_i].stop;
	            if (_stop2 === null) {
	                var n = _i;
	                while (absoluteValuedColorStops[n].stop === null) {
	                    n++;
	                }
	                var steps = n - _i + 1;
	                var nextColorStep = absoluteValuedColorStops[n].stop;
	                var stepSize = (nextColorStep - previousColorStop) / steps;
	                for (; _i < n; _i++) {
	                    previousColorStop = absoluteValuedColorStops[_i].stop = previousColorStop + stepSize;
	                }
	            } else {
	                previousColorStop = _stop2;
	            }
	        }
	    }
	
	    return absoluteValuedColorStops;
	};
	
	var parseLinearGradient = function parseLinearGradient(args, bounds, hasPrefix) {
	    var angle = (0, _Angle.parseAngle)(args[0]);
	    var HAS_SIDE_OR_CORNER = SIDE_OR_CORNER.test(args[0]);
	    var HAS_DIRECTION = HAS_SIDE_OR_CORNER || angle !== null || PERCENTAGE_ANGLES.test(args[0]);
	    var direction = HAS_DIRECTION ? angle !== null ? calculateGradientDirection(
	    // if there is a prefix, the 0° angle points due East (instead of North per W3C)
	    hasPrefix ? angle - Math.PI * 0.5 : angle, bounds) : HAS_SIDE_OR_CORNER ? parseSideOrCorner(args[0], bounds) : parsePercentageAngle(args[0], bounds) : calculateGradientDirection(Math.PI, bounds);
	    var firstColorStopIndex = HAS_DIRECTION ? 1 : 0;
	
	    // TODO: Fix some inaccuracy with color stops with px values
	    var lineLength = Math.min((0, _Util.distance)(Math.abs(direction.x0) + Math.abs(direction.x1), Math.abs(direction.y0) + Math.abs(direction.y1)), bounds.width * 2, bounds.height * 2);
	
	    return new LinearGradient(parseColorStops(args, firstColorStopIndex, lineLength), direction);
	};
	
	var parseRadialGradient = function parseRadialGradient(container, args, bounds) {
	    var m = args[0].match(RADIAL_SHAPE_DEFINITION);
	    var shape = m && (m[1] === 'circle' || // explicit shape specification
	    m[3] !== undefined && m[5] === undefined) // only one radius coordinate
	    ? RADIAL_GRADIENT_SHAPE.CIRCLE : RADIAL_GRADIENT_SHAPE.ELLIPSE;
	    var radius = {};
	    var center = {};
	
	    if (m) {
	        // Radius
	        if (m[3] !== undefined) {
	            radius.x = (0, _Length.calculateLengthFromValueWithUnit)(container, m[3], m[4]).getAbsoluteValue(bounds.width);
	        }
	
	        if (m[5] !== undefined) {
	            radius.y = (0, _Length.calculateLengthFromValueWithUnit)(container, m[5], m[6]).getAbsoluteValue(bounds.height);
	        }
	
	        // Position
	        if (m[7]) {
	            center.x = LENGTH_FOR_POSITION[m[7].toLowerCase()];
	        } else if (m[8] !== undefined) {
	            center.x = (0, _Length.calculateLengthFromValueWithUnit)(container, m[8], m[9]);
	        }
	
	        if (m[10]) {
	            center.y = LENGTH_FOR_POSITION[m[10].toLowerCase()];
	        } else if (m[11] !== undefined) {
	            center.y = (0, _Length.calculateLengthFromValueWithUnit)(container, m[11], m[12]);
	        }
	    }
	
	    var gradientCenter = {
	        x: center.x === undefined ? bounds.width / 2 : center.x.getAbsoluteValue(bounds.width),
	        y: center.y === undefined ? bounds.height / 2 : center.y.getAbsoluteValue(bounds.height)
	    };
	    var gradientRadius = calculateRadius(m && m[2] || 'farthest-corner', shape, gradientCenter, radius, bounds);
	
	    return new RadialGradient(parseColorStops(args, m ? 1 : 0, Math.min(gradientRadius.x, gradientRadius.y)), shape, gradientCenter, gradientRadius);
	};
	
	var calculateGradientDirection = function calculateGradientDirection(radian, bounds) {
	    var width = bounds.width;
	    var height = bounds.height;
	    var HALF_WIDTH = width * 0.5;
	    var HALF_HEIGHT = height * 0.5;
	    var lineLength = Math.abs(width * Math.sin(radian)) + Math.abs(height * Math.cos(radian));
	    var HALF_LINE_LENGTH = lineLength / 2;
	
	    var x0 = HALF_WIDTH + Math.sin(radian) * HALF_LINE_LENGTH;
	    var y0 = HALF_HEIGHT - Math.cos(radian) * HALF_LINE_LENGTH;
	    var x1 = width - x0;
	    var y1 = height - y0;
	
	    return { x0: x0, x1: x1, y0: y0, y1: y1 };
	};
	
	var parseTopRight = function parseTopRight(bounds) {
	    return Math.acos(bounds.width / 2 / ((0, _Util.distance)(bounds.width, bounds.height) / 2));
	};
	
	var parseSideOrCorner = function parseSideOrCorner(side, bounds) {
	    switch (side) {
	        case 'bottom':
	        case 'to top':
	            return calculateGradientDirection(0, bounds);
	        case 'left':
	        case 'to right':
	            return calculateGradientDirection(Math.PI / 2, bounds);
	        case 'right':
	        case 'to left':
	            return calculateGradientDirection(3 * Math.PI / 2, bounds);
	        case 'top right':
	        case 'right top':
	        case 'to bottom left':
	        case 'to left bottom':
	            return calculateGradientDirection(Math.PI + parseTopRight(bounds), bounds);
	        case 'top left':
	        case 'left top':
	        case 'to bottom right':
	        case 'to right bottom':
	            return calculateGradientDirection(Math.PI - parseTopRight(bounds), bounds);
	        case 'bottom left':
	        case 'left bottom':
	        case 'to top right':
	        case 'to right top':
	            return calculateGradientDirection(parseTopRight(bounds), bounds);
	        case 'bottom right':
	        case 'right bottom':
	        case 'to top left':
	        case 'to left top':
	            return calculateGradientDirection(2 * Math.PI - parseTopRight(bounds), bounds);
	        case 'top':
	        case 'to bottom':
	        default:
	            return calculateGradientDirection(Math.PI, bounds);
	    }
	};
	
	var parsePercentageAngle = function parsePercentageAngle(angle, bounds) {
	    var _angle$split$map = angle.split(' ').map(parseFloat),
	        _angle$split$map2 = _slicedToArray(_angle$split$map, 2),
	        left = _angle$split$map2[0],
	        top = _angle$split$map2[1];
	
	    var ratio = left / 100 * bounds.width / (top / 100 * bounds.height);
	
	    return calculateGradientDirection(Math.atan(isNaN(ratio) ? 1 : ratio) + Math.PI / 2, bounds);
	};
	
	var findCorner = function findCorner(bounds, x, y, closest) {
	    var corners = [{ x: 0, y: 0 }, { x: 0, y: bounds.height }, { x: bounds.width, y: 0 }, { x: bounds.width, y: bounds.height }];
	
	    // $FlowFixMe
	    return corners.reduce(function (stat, corner) {
	        var d = (0, _Util.distance)(x - corner.x, y - corner.y);
	        if (closest ? d < stat.optimumDistance : d > stat.optimumDistance) {
	            return {
	                optimumCorner: corner,
	                optimumDistance: d
	            };
	        }
	
	        return stat;
	    }, {
	        optimumDistance: closest ? Infinity : -Infinity,
	        optimumCorner: null
	    }).optimumCorner;
	};
	
	var calculateRadius = function calculateRadius(extent, shape, center, radius, bounds) {
	    var x = center.x;
	    var y = center.y;
	    var rx = 0;
	    var ry = 0;
	
	    switch (extent) {
	        case 'closest-side':
	            // The ending shape is sized so that that it exactly meets the side of the gradient box closest to the gradient’s center.
	            // If the shape is an ellipse, it exactly meets the closest side in each dimension.
	            if (shape === RADIAL_GRADIENT_SHAPE.CIRCLE) {
	                rx = ry = Math.min(Math.abs(x), Math.abs(x - bounds.width), Math.abs(y), Math.abs(y - bounds.height));
	            } else if (shape === RADIAL_GRADIENT_SHAPE.ELLIPSE) {
	                rx = Math.min(Math.abs(x), Math.abs(x - bounds.width));
	                ry = Math.min(Math.abs(y), Math.abs(y - bounds.height));
	            }
	            break;
	
	        case 'closest-corner':
	            // The ending shape is sized so that that it passes through the corner of the gradient box closest to the gradient’s center.
	            // If the shape is an ellipse, the ending shape is given the same aspect-ratio it would have if closest-side were specified.
	            if (shape === RADIAL_GRADIENT_SHAPE.CIRCLE) {
	                rx = ry = Math.min((0, _Util.distance)(x, y), (0, _Util.distance)(x, y - bounds.height), (0, _Util.distance)(x - bounds.width, y), (0, _Util.distance)(x - bounds.width, y - bounds.height));
	            } else if (shape === RADIAL_GRADIENT_SHAPE.ELLIPSE) {
	                // Compute the ratio ry/rx (which is to be the same as for "closest-side")
	                var c = Math.min(Math.abs(y), Math.abs(y - bounds.height)) / Math.min(Math.abs(x), Math.abs(x - bounds.width));
	                var corner = findCorner(bounds, x, y, true);
	                rx = (0, _Util.distance)(corner.x - x, (corner.y - y) / c);
	                ry = c * rx;
	            }
	            break;
	
	        case 'farthest-side':
	            // Same as closest-side, except the ending shape is sized based on the farthest side(s)
	            if (shape === RADIAL_GRADIENT_SHAPE.CIRCLE) {
	                rx = ry = Math.max(Math.abs(x), Math.abs(x - bounds.width), Math.abs(y), Math.abs(y - bounds.height));
	            } else if (shape === RADIAL_GRADIENT_SHAPE.ELLIPSE) {
	                rx = Math.max(Math.abs(x), Math.abs(x - bounds.width));
	                ry = Math.max(Math.abs(y), Math.abs(y - bounds.height));
	            }
	            break;
	
	        case 'farthest-corner':
	            // Same as closest-corner, except the ending shape is sized based on the farthest corner.
	            // If the shape is an ellipse, the ending shape is given the same aspect ratio it would have if farthest-side were specified.
	            if (shape === RADIAL_GRADIENT_SHAPE.CIRCLE) {
	                rx = ry = Math.max((0, _Util.distance)(x, y), (0, _Util.distance)(x, y - bounds.height), (0, _Util.distance)(x - bounds.width, y), (0, _Util.distance)(x - bounds.width, y - bounds.height));
	            } else if (shape === RADIAL_GRADIENT_SHAPE.ELLIPSE) {
	                // Compute the ratio ry/rx (which is to be the same as for "farthest-side")
	                var _c = Math.max(Math.abs(y), Math.abs(y - bounds.height)) / Math.max(Math.abs(x), Math.abs(x - bounds.width));
	                var _corner = findCorner(bounds, x, y, false);
	                rx = (0, _Util.distance)(_corner.x - x, (_corner.y - y) / _c);
	                ry = _c * rx;
	            }
	            break;
	
	        default:
	            // pixel or percentage values
	            rx = radius.x || 0;
	            ry = radius.y !== undefined ? radius.y : rx;
	            break;
	    }
	
	    return {
	        x: rx,
	        y: ry
	    };
	};
	
	var transformWebkitRadialGradientArgs = exports.transformWebkitRadialGradientArgs = function transformWebkitRadialGradientArgs(args) {
	    var shape = '';
	    var radius = '';
	    var extent = '';
	    var position = '';
	    var idx = 0;
	
	    var POSITION = /^(left|center|right|\d+(?:px|r?em|%)?)(?:\s+(top|center|bottom|\d+(?:px|r?em|%)?))?$/i;
	    var SHAPE_AND_EXTENT = /^(circle|ellipse)?\s*(closest-side|closest-corner|farthest-side|farthest-corner|contain|cover)?$/i;
	    var RADIUS = /^\d+(px|r?em|%)?(?:\s+\d+(px|r?em|%)?)?$/i;
	
	    var matchStartPosition = args[idx].match(POSITION);
	    if (matchStartPosition) {
	        idx++;
	    }
	
	    var matchShapeExtent = args[idx].match(SHAPE_AND_EXTENT);
	    if (matchShapeExtent) {
	        shape = matchShapeExtent[1] || '';
	        extent = matchShapeExtent[2] || '';
	        if (extent === 'contain') {
	            extent = 'closest-side';
	        } else if (extent === 'cover') {
	            extent = 'farthest-corner';
	        }
	        idx++;
	    }
	
	    var matchStartRadius = args[idx].match(RADIUS);
	    if (matchStartRadius) {
	        idx++;
	    }
	
	    var matchEndPosition = args[idx].match(POSITION);
	    if (matchEndPosition) {
	        idx++;
	    }
	
	    var matchEndRadius = args[idx].match(RADIUS);
	    if (matchEndRadius) {
	        idx++;
	    }
	
	    var matchPosition = matchEndPosition || matchStartPosition;
	    if (matchPosition && matchPosition[1]) {
	        position = matchPosition[1] + (/^\d+$/.test(matchPosition[1]) ? 'px' : '');
	        if (matchPosition[2]) {
	            position += ' ' + matchPosition[2] + (/^\d+$/.test(matchPosition[2]) ? 'px' : '');
	        }
	    }
	
	    var matchRadius = matchEndRadius || matchStartRadius;
	    if (matchRadius) {
	        radius = matchRadius[0];
	        if (!matchRadius[1]) {
	            radius += 'px';
	        }
	    }
	
	    if (position && !shape && !radius && !extent) {
	        radius = position;
	        position = '';
	    }
	
	    if (position) {
	        position = 'at ' + position;
	    }
	
	    return [[shape, extent, radius, position].filter(function (s) {
	        return !!s;
	    }).join(' ')].concat(args.slice(idx));
	};
	
	var transformObsoleteColorStops = function transformObsoleteColorStops(args) {
	    return args.map(function (color) {
	        return color.match(FROM_TO_COLORSTOP);
	    })
	    // $FlowFixMe
	    .map(function (v, index) {
	        if (!v) {
	            return args[index];
	        }
	
	        switch (v[1]) {
	            case 'from':
	                return v[4] + ' 0%';
	            case 'to':
	                return v[4] + ' 100%';
	            case 'color-stop':
	                if (v[3] === '%') {
	                    return v[4] + ' ' + v[2];
	                }
	                return v[4] + ' ' + parseFloat(v[2]) * 100 + '%';
	        }
	    });
	};
	
	/***/ }),
	/* 61 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var ANGLE = /([+-]?\d*\.?\d+)(deg|grad|rad|turn)/i;
	
	var parseAngle = exports.parseAngle = function parseAngle(angle) {
	    var match = angle.match(ANGLE);
	
	    if (match) {
	        var value = parseFloat(match[1]);
	        switch (match[2].toLowerCase()) {
	            case 'deg':
	                return Math.PI * value / 180;
	            case 'grad':
	                return Math.PI / 200 * value;
	            case 'rad':
	                return value;
	            case 'turn':
	                return Math.PI * 2 * value;
	        }
	    }
	
	    return null;
	};
	
	/***/ }),
	/* 62 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/* WEBPACK VAR INJECTION */(function(process) {
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.cloneWindow = exports.DocumentCloner = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Bounds = __webpack_require__(3);
	
	var _Proxy = __webpack_require__(28);
	
	var _ResourceLoader = __webpack_require__(63);
	
	var _ResourceLoader2 = _interopRequireDefault(_ResourceLoader);
	
	var _Util = __webpack_require__(5);
	
	var _background = __webpack_require__(6);
	
	var _CanvasRenderer = __webpack_require__(17);
	
	var _CanvasRenderer2 = _interopRequireDefault(_CanvasRenderer);
	
	var _PseudoNodeContent = __webpack_require__(64);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var IGNORE_ATTRIBUTE = 'data-html2canvas-ignore';
	
	var DocumentCloner = exports.DocumentCloner = function () {
	    function DocumentCloner(element, options, logger, copyInline, renderer) {
	        _classCallCheck(this, DocumentCloner);
	
	        this.referenceElement = element;
	        this.scrolledElements = [];
	        this.copyStyles = copyInline;
	        this.inlineImages = copyInline;
	        this.logger = logger;
	        this.options = options;
	        this.renderer = renderer;
	        this.resourceLoader = new _ResourceLoader2.default(options, logger, window);
	        this.pseudoContentData = {
	            counters: {},
	            quoteDepth: 0
	        };
	        // $FlowFixMe
	        this.documentElement = this.cloneNode(element.ownerDocument.documentElement);
	    }
	
	    _createClass(DocumentCloner, [{
	        key: 'inlineAllImages',
	        value: function inlineAllImages(node) {
	            var _this = this;
	
	            if (this.inlineImages && node) {
	                var style = node.style;
	                Promise.all((0, _background.parseBackgroundImage)(style.backgroundImage).map(function (backgroundImage) {
	                    if (backgroundImage.method === 'url') {
	                        return _this.resourceLoader.inlineImage(backgroundImage.args[0]).then(function (img) {
	                            return img && typeof img.src === 'string' ? 'url("' + img.src + '")' : 'none';
	                        }).catch(function (e) {
	                            if (process.env.NODE_ENV !== 'production') {
	                                _this.logger.log('Unable to load image', e);
	                            }
	                        });
	                    }
	                    return Promise.resolve('' + backgroundImage.prefix + backgroundImage.method + '(' + backgroundImage.args.join(',') + ')');
	                })).then(function (backgroundImages) {
	                    if (backgroundImages.length > 1) {
	                        // TODO Multiple backgrounds somehow broken in Chrome
	                        style.backgroundColor = '';
	                    }
	                    style.backgroundImage = backgroundImages.join(',');
	                });
	
	                if (node instanceof HTMLImageElement) {
	                    this.resourceLoader.inlineImage(node.src).then(function (img) {
	                        if (img && node instanceof HTMLImageElement && node.parentNode) {
	                            var parentNode = node.parentNode;
	                            var clonedChild = (0, _Util.copyCSSStyles)(node.style, img.cloneNode(false));
	                            parentNode.replaceChild(clonedChild, node);
	                        }
	                    }).catch(function (e) {
	                        if (process.env.NODE_ENV !== 'production') {
	                            _this.logger.log('Unable to load image', e);
	                        }
	                    });
	                }
	            }
	        }
	    }, {
	        key: 'inlineFonts',
	        value: function inlineFonts(document) {
	            var _this2 = this;
	
	            return Promise.all(Array.from(document.styleSheets).map(function (sheet) {
	                if (sheet.href) {
	                    return fetch(sheet.href).then(function (res) {
	                        return res.text();
	                    }).then(function (text) {
	                        return createStyleSheetFontsFromText(text, sheet.href);
	                    }).catch(function (e) {
	                        if (process.env.NODE_ENV !== 'production') {
	                            _this2.logger.log('Unable to load stylesheet', e);
	                        }
	                        return [];
	                    });
	                }
	                return getSheetFonts(sheet, document);
	            })).then(function (fonts) {
	                return fonts.reduce(function (acc, font) {
	                    return acc.concat(font);
	                }, []);
	            }).then(function (fonts) {
	                return Promise.all(fonts.map(function (font) {
	                    return fetch(font.formats[0].src).then(function (response) {
	                        return response.blob();
	                    }).then(function (blob) {
	                        return new Promise(function (resolve, reject) {
	                            var reader = new FileReader();
	                            reader.onerror = reject;
	                            reader.onload = function () {
	                                // $FlowFixMe
	                                var result = reader.result;
	                                resolve(result);
	                            };
	                            reader.readAsDataURL(blob);
	                        });
	                    }).then(function (dataUri) {
	                        font.fontFace.setProperty('src', 'url("' + dataUri + '")');
	                        return '@font-face {' + font.fontFace.cssText + ' ';
	                    });
	                }));
	            }).then(function (fontCss) {
	                var style = document.createElement('style');
	                style.textContent = fontCss.join('\n');
	                _this2.documentElement.appendChild(style);
	            });
	        }
	    }, {
	        key: 'createElementClone',
	        value: function createElementClone(node) {
	            var _this3 = this;
	
	            if (this.copyStyles && node instanceof HTMLCanvasElement) {
	                var img = node.ownerDocument.createElement('img');
	                try {
	                    img.src = node.toDataURL();
	                    return img;
	                } catch (e) {
	                    if (process.env.NODE_ENV !== 'production') {
	                        this.logger.log('Unable to clone canvas contents, canvas is tainted');
	                    }
	                }
	            }
	
	            if (node instanceof HTMLIFrameElement) {
	                var tempIframe = node.cloneNode(false);
	                var iframeKey = generateIframeKey();
	                tempIframe.setAttribute('data-html2canvas-internal-iframe-key', iframeKey);
	
	                var _parseBounds = (0, _Bounds.parseBounds)(node, 0, 0),
	                    width = _parseBounds.width,
	                    height = _parseBounds.height;
	
	                this.resourceLoader.cache[iframeKey] = getIframeDocumentElement(node, this.options).then(function (documentElement) {
	                    return _this3.renderer(documentElement, {
	                        async: _this3.options.async,
	                        allowTaint: _this3.options.allowTaint,
	                        backgroundColor: '#ffffff',
	                        canvas: null,
	                        imageTimeout: _this3.options.imageTimeout,
	                        logging: _this3.options.logging,
	                        proxy: _this3.options.proxy,
	                        removeContainer: _this3.options.removeContainer,
	                        scale: _this3.options.scale,
	                        foreignObjectRendering: _this3.options.foreignObjectRendering,
	                        useCORS: _this3.options.useCORS,
	                        target: new _CanvasRenderer2.default(),
	                        width: width,
	                        height: height,
	                        x: 0,
	                        y: 0,
	                        windowWidth: documentElement.ownerDocument.defaultView.innerWidth,
	                        windowHeight: documentElement.ownerDocument.defaultView.innerHeight,
	                        scrollX: documentElement.ownerDocument.defaultView.pageXOffset,
	                        scrollY: documentElement.ownerDocument.defaultView.pageYOffset
	                    }, _this3.logger.child(iframeKey));
	                }).then(function (canvas) {
	                    return new Promise(function (resolve, reject) {
	                        var iframeCanvas = document.createElement('img');
	                        iframeCanvas.onload = function () {
	                            return resolve(canvas);
	                        };
	                        iframeCanvas.onerror = reject;
	                        iframeCanvas.src = canvas.toDataURL();
	                        if (tempIframe.parentNode) {
	                            tempIframe.parentNode.replaceChild((0, _Util.copyCSSStyles)(node.ownerDocument.defaultView.getComputedStyle(node), iframeCanvas), tempIframe);
	                        }
	                    });
	                });
	                return tempIframe;
	            }
	
	            if (node instanceof HTMLStyleElement && node.sheet && node.sheet.cssRules) {
	                var css = [].slice.call(node.sheet.cssRules, 0).reduce(function (css, rule) {
	                    try {
	                        if (rule && rule.cssText) {
	                            return css + rule.cssText;
	                        }
	                        return css;
	                    } catch (err) {
	                        _this3.logger.log('Unable to access cssText property', rule.name);
	                        return css;
	                    }
	                }, '');
	                var style = node.cloneNode(false);
	                style.textContent = css;
	                return style;
	            }
	
	            return node.cloneNode(false);
	        }
	    }, {
	        key: 'cloneNode',
	        value: function cloneNode(node) {
	            var clone = node.nodeType === Node.TEXT_NODE ? document.createTextNode(node.nodeValue) : this.createElementClone(node);
	
	            var window = node.ownerDocument.defaultView;
	            var style = node instanceof window.HTMLElement ? window.getComputedStyle(node) : null;
	            var styleBefore = node instanceof window.HTMLElement ? window.getComputedStyle(node, ':before') : null;
	            var styleAfter = node instanceof window.HTMLElement ? window.getComputedStyle(node, ':after') : null;
	
	            if (this.referenceElement === node && clone instanceof window.HTMLElement) {
	                this.clonedReferenceElement = clone;
	            }
	
	            if (clone instanceof window.HTMLBodyElement) {
	                createPseudoHideStyles(clone);
	            }
	
	            var counters = (0, _PseudoNodeContent.parseCounterReset)(style, this.pseudoContentData);
	            var contentBefore = (0, _PseudoNodeContent.resolvePseudoContent)(node, styleBefore, this.pseudoContentData);
	
	            for (var child = node.firstChild; child; child = child.nextSibling) {
	                if (child.nodeType !== Node.ELEMENT_NODE || child.nodeName !== 'SCRIPT' &&
	                // $FlowFixMe
	                !child.hasAttribute(IGNORE_ATTRIBUTE) && (typeof this.options.ignoreElements !== 'function' ||
	                // $FlowFixMe
	                !this.options.ignoreElements(child))) {
	                    if (!this.copyStyles || child.nodeName !== 'STYLE') {
	                        clone.appendChild(this.cloneNode(child));
	                    }
	                }
	            }
	
	            var contentAfter = (0, _PseudoNodeContent.resolvePseudoContent)(node, styleAfter, this.pseudoContentData);
	            (0, _PseudoNodeContent.popCounters)(counters, this.pseudoContentData);
	
	            if (node instanceof window.HTMLElement && clone instanceof window.HTMLElement) {
	                if (styleBefore) {
	                    this.inlineAllImages(inlinePseudoElement(node, clone, styleBefore, contentBefore, PSEUDO_BEFORE));
	                }
	                if (styleAfter) {
	                    this.inlineAllImages(inlinePseudoElement(node, clone, styleAfter, contentAfter, PSEUDO_AFTER));
	                }
	                if (style && this.copyStyles && !(node instanceof HTMLIFrameElement)) {
	                    (0, _Util.copyCSSStyles)(style, clone);
	                }
	                this.inlineAllImages(clone);
	                if (node.scrollTop !== 0 || node.scrollLeft !== 0) {
	                    this.scrolledElements.push([clone, node.scrollLeft, node.scrollTop]);
	                }
	                switch (node.nodeName) {
	                    case 'CANVAS':
	                        if (!this.copyStyles) {
	                            cloneCanvasContents(node, clone);
	                        }
	                        break;
	                    case 'TEXTAREA':
	                    case 'SELECT':
	                        clone.value = node.value;
	                        break;
	                }
	            }
	            return clone;
	        }
	    }]);
	
	    return DocumentCloner;
	}();
	
	var getSheetFonts = function getSheetFonts(sheet, document) {
	    // $FlowFixMe
	    return (sheet.cssRules ? Array.from(sheet.cssRules) : []).filter(function (rule) {
	        return rule.type === CSSRule.FONT_FACE_RULE;
	    }).map(function (rule) {
	        var src = (0, _background.parseBackgroundImage)(rule.style.getPropertyValue('src'));
	        var formats = [];
	        for (var i = 0; i < src.length; i++) {
	            if (src[i].method === 'url' && src[i + 1] && src[i + 1].method === 'format') {
	                var a = document.createElement('a');
	                a.href = src[i].args[0];
	                if (document.body) {
	                    document.body.appendChild(a);
	                }
	
	                var font = {
	                    src: a.href,
	                    format: src[i + 1].args[0]
	                };
	                formats.push(font);
	            }
	        }
	
	        return {
	            // TODO select correct format for browser),
	
	            formats: formats.filter(function (font) {
	                return (/^woff/i.test(font.format)
	                );
	            }),
	            fontFace: rule.style
	        };
	    }).filter(function (font) {
	        return font.formats.length;
	    });
	};
	
	var createStyleSheetFontsFromText = function createStyleSheetFontsFromText(text, baseHref) {
	    var doc = document.implementation.createHTMLDocument('');
	    var base = document.createElement('base');
	    // $FlowFixMe
	    base.href = baseHref;
	    var style = document.createElement('style');
	
	    style.textContent = text;
	    if (doc.head) {
	        doc.head.appendChild(base);
	    }
	    if (doc.body) {
	        doc.body.appendChild(style);
	    }
	
	    return style.sheet ? getSheetFonts(style.sheet, doc) : [];
	};
	
	var restoreOwnerScroll = function restoreOwnerScroll(ownerDocument, x, y) {
	    if (ownerDocument.defaultView && (x !== ownerDocument.defaultView.pageXOffset || y !== ownerDocument.defaultView.pageYOffset)) {
	        ownerDocument.defaultView.scrollTo(x, y);
	    }
	};
	
	var cloneCanvasContents = function cloneCanvasContents(canvas, clonedCanvas) {
	    try {
	        if (clonedCanvas) {
	            clonedCanvas.width = canvas.width;
	            clonedCanvas.height = canvas.height;
	            var ctx = canvas.getContext('2d');
	            var clonedCtx = clonedCanvas.getContext('2d');
	            if (ctx) {
	                clonedCtx.putImageData(ctx.getImageData(0, 0, canvas.width, canvas.height), 0, 0);
	            } else {
	                clonedCtx.drawImage(canvas, 0, 0);
	            }
	        }
	    } catch (e) {}
	};
	
	var inlinePseudoElement = function inlinePseudoElement(node, clone, style, contentItems, pseudoElt) {
	    if (!style || !style.content || style.content === 'none' || style.content === '-moz-alt-content' || style.display === 'none') {
	        return;
	    }
	
	    var anonymousReplacedElement = clone.ownerDocument.createElement('html2canvaspseudoelement');
	    (0, _Util.copyCSSStyles)(style, anonymousReplacedElement);
	
	    if (contentItems) {
	        var len = contentItems.length;
	        for (var i = 0; i < len; i++) {
	            var item = contentItems[i];
	            switch (item.type) {
	                case _PseudoNodeContent.PSEUDO_CONTENT_ITEM_TYPE.IMAGE:
	                    var img = clone.ownerDocument.createElement('img');
	                    img.src = (0, _background.parseBackgroundImage)('url(' + item.value + ')')[0].args[0];
	                    img.style.opacity = '1';
	                    anonymousReplacedElement.appendChild(img);
	                    break;
	                case _PseudoNodeContent.PSEUDO_CONTENT_ITEM_TYPE.TEXT:
	                    anonymousReplacedElement.appendChild(clone.ownerDocument.createTextNode(item.value));
	                    break;
	            }
	        }
	    }
	
	    anonymousReplacedElement.className = PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + ' ' + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
	    clone.className += pseudoElt === PSEUDO_BEFORE ? ' ' + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE : ' ' + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
	    if (pseudoElt === PSEUDO_BEFORE) {
	        clone.insertBefore(anonymousReplacedElement, clone.firstChild);
	    } else {
	        clone.appendChild(anonymousReplacedElement);
	    }
	
	    return anonymousReplacedElement;
	};
	
	var URL_REGEXP = /^url\((.+)\)$/i;
	var PSEUDO_BEFORE = ':before';
	var PSEUDO_AFTER = ':after';
	var PSEUDO_HIDE_ELEMENT_CLASS_BEFORE = '___html2canvas___pseudoelement_before';
	var PSEUDO_HIDE_ELEMENT_CLASS_AFTER = '___html2canvas___pseudoelement_after';
	
	var PSEUDO_HIDE_ELEMENT_STYLE = '{\n    content: "" !important;\n    display: none !important;\n}';
	
	var createPseudoHideStyles = function createPseudoHideStyles(body) {
	    createStyles(body, '.' + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + PSEUDO_BEFORE + PSEUDO_HIDE_ELEMENT_STYLE + '\n         .' + PSEUDO_HIDE_ELEMENT_CLASS_AFTER + PSEUDO_AFTER + PSEUDO_HIDE_ELEMENT_STYLE);
	};
	
	var createStyles = function createStyles(body, styles) {
	    var style = body.ownerDocument.createElement('style');
	    style.innerHTML = styles;
	    body.appendChild(style);
	};
	
	var initNode = function initNode(_ref) {
	    var _ref2 = _slicedToArray(_ref, 3),
	        element = _ref2[0],
	        x = _ref2[1],
	        y = _ref2[2];
	
	    element.scrollLeft = x;
	    element.scrollTop = y;
	};
	
	var generateIframeKey = function generateIframeKey() {
	    return Math.ceil(Date.now() + Math.random() * 10000000).toString(16);
	};
	
	var DATA_URI_REGEXP = /^data:text\/(.+);(base64)?,(.*)$/i;
	
	var getIframeDocumentElement = function getIframeDocumentElement(node, options) {
	    try {
	        return Promise.resolve(node.contentWindow.document.documentElement);
	    } catch (e) {
	        return options.proxy ? (0, _Proxy.Proxy)(node.src, options).then(function (html) {
	            var match = html.match(DATA_URI_REGEXP);
	            if (!match) {
	                return Promise.reject();
	            }
	
	            return match[2] === 'base64' ? window.atob(decodeURIComponent(match[3])) : decodeURIComponent(match[3]);
	        }).then(function (html) {
	            return createIframeContainer(node.ownerDocument, (0, _Bounds.parseBounds)(node, 0, 0)).then(function (cloneIframeContainer) {
	                var cloneWindow = cloneIframeContainer.contentWindow;
	                var documentClone = cloneWindow.document;
	
	                documentClone.open();
	                documentClone.write(html);
	                var iframeLoad = iframeLoader(cloneIframeContainer).then(function () {
	                    return documentClone.documentElement;
	                });
	
	                documentClone.close();
	                return iframeLoad;
	            });
	        }) : Promise.reject();
	    }
	};
	
	var createIframeContainer = function createIframeContainer(ownerDocument, bounds) {
	    var cloneIframeContainer = ownerDocument.createElement('iframe');
	
	    cloneIframeContainer.className = 'html2canvas-container';
	    cloneIframeContainer.style.visibility = 'hidden';
	    cloneIframeContainer.style.position = 'fixed';
	    cloneIframeContainer.style.left = '-10000px';
	    cloneIframeContainer.style.top = '0px';
	    cloneIframeContainer.style.border = '0';
	    cloneIframeContainer.width = bounds.width.toString();
	    cloneIframeContainer.height = bounds.height.toString();
	    cloneIframeContainer.scrolling = 'no'; // ios won't scroll without it
	    cloneIframeContainer.setAttribute(IGNORE_ATTRIBUTE, 'true');
	    if (!ownerDocument.body) {
	        return Promise.reject(process.env.NODE_ENV !== 'production' ? 'Body element not found in Document that is getting rendered' : '');
	    }
	
	    ownerDocument.body.appendChild(cloneIframeContainer);
	
	    return Promise.resolve(cloneIframeContainer);
	};
	
	var iframeLoader = function iframeLoader(cloneIframeContainer) {
	    var cloneWindow = cloneIframeContainer.contentWindow;
	    var documentClone = cloneWindow.document;
	
	    return new Promise(function (resolve, reject) {
	        cloneWindow.onload = cloneIframeContainer.onload = documentClone.onreadystatechange = function () {
	            var interval = setInterval(function () {
	                if (documentClone.body.childNodes.length > 0 && documentClone.readyState === 'complete') {
	                    clearInterval(interval);
	                    resolve(cloneIframeContainer);
	                }
	            }, 50);
	        };
	    });
	};
	
	var cloneWindow = exports.cloneWindow = function cloneWindow(ownerDocument, bounds, referenceElement, options, logger, renderer) {
	    var cloner = new DocumentCloner(referenceElement, options, logger, false, renderer);
	    var scrollX = ownerDocument.defaultView.pageXOffset;
	    var scrollY = ownerDocument.defaultView.pageYOffset;
	
	    return createIframeContainer(ownerDocument, bounds).then(function (cloneIframeContainer) {
	        var cloneWindow = cloneIframeContainer.contentWindow;
	        var documentClone = cloneWindow.document;
	
	        /* Chrome doesn't detect relative background-images assigned in inline <style> sheets when fetched through getComputedStyle
	             if window url is about:blank, we can assign the url to current by writing onto the document
	             */
	
	        var iframeLoad = iframeLoader(cloneIframeContainer).then(function () {
	            cloner.scrolledElements.forEach(initNode);
	            cloneWindow.scrollTo(bounds.left, bounds.top);
	            if (/(iPad|iPhone|iPod)/g.test(navigator.userAgent) && (cloneWindow.scrollY !== bounds.top || cloneWindow.scrollX !== bounds.left)) {
	                documentClone.documentElement.style.top = -bounds.top + 'px';
	                documentClone.documentElement.style.left = -bounds.left + 'px';
	                documentClone.documentElement.style.position = 'absolute';
	            }
	
	            var result = Promise.resolve([cloneIframeContainer, cloner.clonedReferenceElement, cloner.resourceLoader]);
	
	            var onclone = options.onclone;
	
	            return cloner.clonedReferenceElement instanceof cloneWindow.HTMLElement || cloner.clonedReferenceElement instanceof ownerDocument.defaultView.HTMLElement || cloner.clonedReferenceElement instanceof HTMLElement ? typeof onclone === 'function' ? Promise.resolve().then(function () {
	                return onclone(documentClone);
	            }).then(function () {
	                return result;
	            }) : result : Promise.reject(process.env.NODE_ENV !== 'production' ? 'Error finding the ' + referenceElement.nodeName + ' in the cloned document' : '');
	        });
	
	        documentClone.open();
	        documentClone.write(serializeDoctype(document.doctype) + '<html></html>');
	        // Chrome scrolls the parent document for some reason after the write to the cloned window???
	        restoreOwnerScroll(referenceElement.ownerDocument, scrollX, scrollY);
	        documentClone.replaceChild(documentClone.adoptNode(cloner.documentElement), documentClone.documentElement);
	        documentClone.close();
	
	        return iframeLoad;
	    });
	};
	
	var serializeDoctype = function serializeDoctype(doctype) {
	    var str = '';
	    if (doctype) {
	        str += '<!DOCTYPE ';
	        if (doctype.name) {
	            str += doctype.name;
	        }
	
	        if (doctype.internalSubset) {
	            str += doctype.internalSubset;
	        }
	
	        if (doctype.publicId) {
	            str += '"' + doctype.publicId + '"';
	        }
	
	        if (doctype.systemId) {
	            str += '"' + doctype.systemId + '"';
	        }
	
	        str += '>';
	    }
	
	    return str;
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))
	
	/***/ }),
	/* 63 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/* WEBPACK VAR INJECTION */(function(process) {
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ResourceStore = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Feature = __webpack_require__(12);
	
	var _Feature2 = _interopRequireDefault(_Feature);
	
	var _Proxy = __webpack_require__(28);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ResourceLoader = function () {
	    function ResourceLoader(options, logger, window) {
	        _classCallCheck(this, ResourceLoader);
	
	        this.options = options;
	        this._window = window;
	        this.origin = this.getOrigin(window.location.href);
	        this.cache = {};
	        this.logger = logger;
	        this._index = 0;
	    }
	
	    _createClass(ResourceLoader, [{
	        key: 'loadImage',
	        value: function loadImage(src) {
	            var _this = this;
	
	            if (this.hasResourceInCache(src)) {
	                return src;
	            }
	            if (isBlobImage(src)) {
	                this.cache[src] = _loadImage(src, this.options.imageTimeout || 0);
	                return src;
	            }
	
	            if (!isSVG(src) || _Feature2.default.SUPPORT_SVG_DRAWING) {
	                if (this.options.allowTaint === true || isInlineImage(src) || this.isSameOrigin(src)) {
	                    return this.addImage(src, src, false);
	                } else if (!this.isSameOrigin(src)) {
	                    if (typeof this.options.proxy === 'string') {
	                        this.cache[src] = (0, _Proxy.Proxy)(src, this.options).then(function (src) {
	                            return _loadImage(src, _this.options.imageTimeout || 0);
	                        });
	                        return src;
	                    } else if (this.options.useCORS === true && _Feature2.default.SUPPORT_CORS_IMAGES) {
	                        return this.addImage(src, src, true);
	                    }
	                }
	            }
	        }
	    }, {
	        key: 'inlineImage',
	        value: function inlineImage(src) {
	            var _this2 = this;
	
	            if (isInlineImage(src)) {
	                return _loadImage(src, this.options.imageTimeout || 0);
	            }
	            if (this.hasResourceInCache(src)) {
	                return this.cache[src];
	            }
	            if (!this.isSameOrigin(src) && typeof this.options.proxy === 'string') {
	                return this.cache[src] = (0, _Proxy.Proxy)(src, this.options).then(function (src) {
	                    return _loadImage(src, _this2.options.imageTimeout || 0);
	                });
	            }
	
	            return this.xhrImage(src);
	        }
	    }, {
	        key: 'xhrImage',
	        value: function xhrImage(src) {
	            var _this3 = this;
	
	            this.cache[src] = new Promise(function (resolve, reject) {
	                var xhr = new XMLHttpRequest();
	                xhr.onreadystatechange = function () {
	                    if (xhr.readyState === 4) {
	                        if (xhr.status !== 200) {
	                            reject('Failed to fetch image ' + src.substring(0, 256) + ' with status code ' + xhr.status);
	                        } else {
	                            var reader = new FileReader();
	                            reader.addEventListener('load', function () {
	                                // $FlowFixMe
	                                var result = reader.result;
	                                resolve(result);
	                            }, false);
	                            reader.addEventListener('error', function (e) {
	                                return reject(e);
	                            }, false);
	                            reader.readAsDataURL(xhr.response);
	                        }
	                    }
	                };
	                xhr.responseType = 'blob';
	                if (_this3.options.imageTimeout) {
	                    var timeout = _this3.options.imageTimeout;
	                    xhr.timeout = timeout;
	                    xhr.ontimeout = function () {
	                        return reject(process.env.NODE_ENV !== 'production' ? 'Timed out (' + timeout + 'ms) fetching ' + src.substring(0, 256) : '');
	                    };
	                }
	                xhr.open('GET', src, true);
	                xhr.send();
	            }).then(function (src) {
	                return _loadImage(src, _this3.options.imageTimeout || 0);
	            });
	
	            return this.cache[src];
	        }
	    }, {
	        key: 'loadCanvas',
	        value: function loadCanvas(node) {
	            var key = String(this._index++);
	            this.cache[key] = Promise.resolve(node);
	            return key;
	        }
	    }, {
	        key: 'hasResourceInCache',
	        value: function hasResourceInCache(key) {
	            return typeof this.cache[key] !== 'undefined';
	        }
	    }, {
	        key: 'addImage',
	        value: function addImage(key, src, useCORS) {
	            var _this4 = this;
	
	            if (process.env.NODE_ENV !== 'production') {
	                this.logger.log('Added image ' + key.substring(0, 256));
	            }
	
	            var imageLoadHandler = function imageLoadHandler(supportsDataImages) {
	                return new Promise(function (resolve, reject) {
	                    var img = new Image();
	                    img.onload = function () {
	                        return resolve(img);
	                    };
	                    //ios safari 10.3 taints canvas with data urls unless crossOrigin is set to anonymous
	                    if (!supportsDataImages || useCORS) {
	                        img.crossOrigin = 'anonymous';
	                    }
	
	                    img.onerror = reject;
	                    img.src = src;
	                    if (img.complete === true) {
	                        // Inline XML images may fail to parse, throwing an Error later on
	                        setTimeout(function () {
	                            resolve(img);
	                        }, 500);
	                    }
	                    if (_this4.options.imageTimeout) {
	                        var timeout = _this4.options.imageTimeout;
	                        setTimeout(function () {
	                            return reject(process.env.NODE_ENV !== 'production' ? 'Timed out (' + timeout + 'ms) fetching ' + src.substring(0, 256) : '');
	                        }, timeout);
	                    }
	                });
	            };
	
	            this.cache[key] = isInlineBase64Image(src) && !isSVG(src) ? // $FlowFixMe
	            _Feature2.default.SUPPORT_BASE64_DRAWING(src).then(imageLoadHandler) : imageLoadHandler(true);
	            return key;
	        }
	    }, {
	        key: 'isSameOrigin',
	        value: function isSameOrigin(url) {
	            return this.getOrigin(url) === this.origin;
	        }
	    }, {
	        key: 'getOrigin',
	        value: function getOrigin(url) {
	            var link = this._link || (this._link = this._window.document.createElement('a'));
	            link.href = url;
	            link.href = link.href; // IE9, LOL! - http://jsfiddle.net/niklasvh/2e48b/
	            return link.protocol + link.hostname + link.port;
	        }
	    }, {
	        key: 'ready',
	        value: function ready() {
	            var _this5 = this;
	
	            var keys = Object.keys(this.cache);
	            var values = keys.map(function (str) {
	                return _this5.cache[str].catch(function (e) {
	                    if (process.env.NODE_ENV !== 'production') {
	                        _this5.logger.log('Unable to load image', e);
	                    }
	                    return null;
	                });
	            });
	            return Promise.all(values).then(function (images) {
	                if (process.env.NODE_ENV !== 'production') {
	                    _this5.logger.log('Finished loading ' + images.length + ' images', images);
	                }
	                return new ResourceStore(keys, images);
	            });
	        }
	    }]);
	
	    return ResourceLoader;
	}();
	
	exports.default = ResourceLoader;
	
	var ResourceStore = exports.ResourceStore = function () {
	    function ResourceStore(keys, resources) {
	        _classCallCheck(this, ResourceStore);
	
	        this._keys = keys;
	        this._resources = resources;
	    }
	
	    _createClass(ResourceStore, [{
	        key: 'get',
	        value: function get(key) {
	            var index = this._keys.indexOf(key);
	            return index === -1 ? null : this._resources[index];
	        }
	    }]);
	
	    return ResourceStore;
	}();
	
	var INLINE_SVG = /^data:image\/svg\+xml/i;
	var INLINE_BASE64 = /^data:image\/.*;base64,/i;
	var INLINE_IMG = /^data:image\/.*/i;
	
	var isInlineImage = function isInlineImage(src) {
	    return INLINE_IMG.test(src);
	};
	var isInlineBase64Image = function isInlineBase64Image(src) {
	    return INLINE_BASE64.test(src);
	};
	var isBlobImage = function isBlobImage(src) {
	    return src.substr(0, 4) === 'blob';
	};
	
	var isSVG = function isSVG(src) {
	    return src.substr(-3).toLowerCase() === 'svg' || INLINE_SVG.test(src);
	};
	
	var _loadImage = function _loadImage(src, timeout) {
	    return new Promise(function (resolve, reject) {
	        var img = new Image();
	        img.onload = function () {
	            return resolve(img);
	        };
	        img.onerror = reject;
	        img.src = src;
	        if (img.complete === true) {
	            // Inline XML images may fail to parse, throwing an Error later on
	            setTimeout(function () {
	                resolve(img);
	            }, 500);
	        }
	        if (timeout) {
	            setTimeout(function () {
	                return reject(process.env.NODE_ENV !== 'production' ? 'Timed out (' + timeout + 'ms) loading image' : '');
	            }, timeout);
	        }
	    });
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))
	
	/***/ }),
	/* 64 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.parseContent = exports.resolvePseudoContent = exports.popCounters = exports.parseCounterReset = exports.TOKEN_TYPE = exports.PSEUDO_CONTENT_ITEM_TYPE = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _ListItem = __webpack_require__(16);
	
	var _listStyle = __webpack_require__(10);
	
	var PSEUDO_CONTENT_ITEM_TYPE = exports.PSEUDO_CONTENT_ITEM_TYPE = {
	    TEXT: 0,
	    IMAGE: 1
	};
	
	var TOKEN_TYPE = exports.TOKEN_TYPE = {
	    STRING: 0,
	    ATTRIBUTE: 1,
	    URL: 2,
	    COUNTER: 3,
	    COUNTERS: 4,
	    OPENQUOTE: 5,
	    CLOSEQUOTE: 6
	};
	
	var parseCounterReset = exports.parseCounterReset = function parseCounterReset(style, data) {
	    if (!style || !style.counterReset || style.counterReset === 'none') {
	        return [];
	    }
	
	    var counterNames = [];
	    var counterResets = style.counterReset.split(/\s*,\s*/);
	    var lenCounterResets = counterResets.length;
	
	    for (var i = 0; i < lenCounterResets; i++) {
	        var _counterResets$i$spli = counterResets[i].split(/\s+/),
	            _counterResets$i$spli2 = _slicedToArray(_counterResets$i$spli, 2),
	            counterName = _counterResets$i$spli2[0],
	            initialValue = _counterResets$i$spli2[1];
	
	        counterNames.push(counterName);
	        var counter = data.counters[counterName];
	        if (!counter) {
	            counter = data.counters[counterName] = [];
	        }
	        counter.push(parseInt(initialValue || 0, 10));
	    }
	
	    return counterNames;
	};
	
	var popCounters = exports.popCounters = function popCounters(counterNames, data) {
	    var lenCounters = counterNames.length;
	    for (var i = 0; i < lenCounters; i++) {
	        data.counters[counterNames[i]].pop();
	    }
	};
	
	var resolvePseudoContent = exports.resolvePseudoContent = function resolvePseudoContent(node, style, data) {
	    if (!style || !style.content || style.content === 'none' || style.content === '-moz-alt-content' || style.display === 'none') {
	        return null;
	    }
	
	    var tokens = parseContent(style.content);
	
	    var len = tokens.length;
	    var contentItems = [];
	    var s = '';
	
	    // increment the counter (if there is a "counter-increment" declaration)
	    var counterIncrement = style.counterIncrement;
	    if (counterIncrement && counterIncrement !== 'none') {
	        var _counterIncrement$spl = counterIncrement.split(/\s+/),
	            _counterIncrement$spl2 = _slicedToArray(_counterIncrement$spl, 2),
	            counterName = _counterIncrement$spl2[0],
	            incrementValue = _counterIncrement$spl2[1];
	
	        var counter = data.counters[counterName];
	        if (counter) {
	            counter[counter.length - 1] += incrementValue === undefined ? 1 : parseInt(incrementValue, 10);
	        }
	    }
	
	    // build the content string
	    for (var i = 0; i < len; i++) {
	        var token = tokens[i];
	        switch (token.type) {
	            case TOKEN_TYPE.STRING:
	                s += token.value || '';
	                break;
	
	            case TOKEN_TYPE.ATTRIBUTE:
	                if (node instanceof HTMLElement && token.value) {
	                    s += node.getAttribute(token.value) || '';
	                }
	                break;
	
	            case TOKEN_TYPE.COUNTER:
	                var _counter = data.counters[token.name || ''];
	                if (_counter) {
	                    s += formatCounterValue([_counter[_counter.length - 1]], '', token.format);
	                }
	                break;
	
	            case TOKEN_TYPE.COUNTERS:
	                var _counters = data.counters[token.name || ''];
	                if (_counters) {
	                    s += formatCounterValue(_counters, token.glue, token.format);
	                }
	                break;
	
	            case TOKEN_TYPE.OPENQUOTE:
	                s += getQuote(style, true, data.quoteDepth);
	                data.quoteDepth++;
	                break;
	
	            case TOKEN_TYPE.CLOSEQUOTE:
	                data.quoteDepth--;
	                s += getQuote(style, false, data.quoteDepth);
	                break;
	
	            case TOKEN_TYPE.URL:
	                if (s) {
	                    contentItems.push({ type: PSEUDO_CONTENT_ITEM_TYPE.TEXT, value: s });
	                    s = '';
	                }
	                contentItems.push({ type: PSEUDO_CONTENT_ITEM_TYPE.IMAGE, value: token.value || '' });
	                break;
	        }
	    }
	
	    if (s) {
	        contentItems.push({ type: PSEUDO_CONTENT_ITEM_TYPE.TEXT, value: s });
	    }
	
	    return contentItems;
	};
	
	var parseContent = exports.parseContent = function parseContent(content, cache) {
	    if (cache && cache[content]) {
	        return cache[content];
	    }
	
	    var tokens = [];
	    var len = content.length;
	
	    var isString = false;
	    var isEscaped = false;
	    var isFunction = false;
	    var str = '';
	    var functionName = '';
	    var args = [];
	
	    for (var i = 0; i < len; i++) {
	        var c = content.charAt(i);
	
	        switch (c) {
	            case "'":
	            case '"':
	                if (isEscaped) {
	                    str += c;
	                } else {
	                    isString = !isString;
	                    if (!isFunction && !isString) {
	                        tokens.push({ type: TOKEN_TYPE.STRING, value: str });
	                        str = '';
	                    }
	                }
	                break;
	
	            case '\\':
	                if (isEscaped) {
	                    str += c;
	                    isEscaped = false;
	                } else {
	                    isEscaped = true;
	                }
	                break;
	
	            case '(':
	                if (isString) {
	                    str += c;
	                } else {
	                    isFunction = true;
	                    functionName = str;
	                    str = '';
	                    args = [];
	                }
	                break;
	
	            case ')':
	                if (isString) {
	                    str += c;
	                } else if (isFunction) {
	                    if (str) {
	                        args.push(str);
	                    }
	
	                    switch (functionName) {
	                        case 'attr':
	                            if (args.length > 0) {
	                                tokens.push({ type: TOKEN_TYPE.ATTRIBUTE, value: args[0] });
	                            }
	                            break;
	
	                        case 'counter':
	                            if (args.length > 0) {
	                                var counter = {
	                                    type: TOKEN_TYPE.COUNTER,
	                                    name: args[0]
	                                };
	                                if (args.length > 1) {
	                                    counter.format = args[1];
	                                }
	                                tokens.push(counter);
	                            }
	                            break;
	
	                        case 'counters':
	                            if (args.length > 0) {
	                                var _counters2 = {
	                                    type: TOKEN_TYPE.COUNTERS,
	                                    name: args[0]
	                                };
	                                if (args.length > 1) {
	                                    _counters2.glue = args[1];
	                                }
	                                if (args.length > 2) {
	                                    _counters2.format = args[2];
	                                }
	                                tokens.push(_counters2);
	                            }
	                            break;
	
	                        case 'url':
	                            if (args.length > 0) {
	                                tokens.push({ type: TOKEN_TYPE.URL, value: args[0] });
	                            }
	                            break;
	                    }
	
	                    isFunction = false;
	                    str = '';
	                }
	                break;
	
	            case ',':
	                if (isString) {
	                    str += c;
	                } else if (isFunction) {
	                    args.push(str);
	                    str = '';
	                }
	                break;
	
	            case ' ':
	            case '\t':
	                if (isString) {
	                    str += c;
	                } else if (str) {
	                    addOtherToken(tokens, str);
	                    str = '';
	                }
	                break;
	
	            default:
	                str += c;
	        }
	
	        if (c !== '\\') {
	            isEscaped = false;
	        }
	    }
	
	    if (str) {
	        addOtherToken(tokens, str);
	    }
	
	    if (cache) {
	        cache[content] = tokens;
	    }
	
	    return tokens;
	};
	
	var addOtherToken = function addOtherToken(tokens, identifier) {
	    switch (identifier) {
	        case 'open-quote':
	            tokens.push({ type: TOKEN_TYPE.OPENQUOTE });
	            break;
	        case 'close-quote':
	            tokens.push({ type: TOKEN_TYPE.CLOSEQUOTE });
	            break;
	    }
	};
	
	var getQuote = function getQuote(style, isOpening, quoteDepth) {
	    var quotes = style.quotes ? style.quotes.split(/\s+/) : ["'\"'", "'\"'"];
	    var idx = quoteDepth * 2;
	    if (idx >= quotes.length) {
	        idx = quotes.length - 2;
	    }
	    if (!isOpening) {
	        ++idx;
	    }
	    return quotes[idx].replace(/^["']|["']$/g, '');
	};
	
	var formatCounterValue = function formatCounterValue(counter, glue, format) {
	    var len = counter.length;
	    var result = '';
	
	    for (var i = 0; i < len; i++) {
	        if (i > 0) {
	            result += glue || '';
	        }
	        result += (0, _ListItem.createCounterText)(counter[i], (0, _listStyle.parseListStyleType)(format || 'decimal'), false);
	    }
	
	    return result;
	};
	
	/***/ }),
	/* 65 */
	/***/ (function(module, exports) {
	
	module.exports = function() {
		throw new Error("define cannot be used indirect");
	};
	
	
	/***/ }),
	/* 66 */
	/***/ (function(module, exports) {
	
	/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
	module.exports = __webpack_amd_options__;
	
	/* WEBPACK VAR INJECTION */}.call(exports, {}))
	
	/***/ }),
	/* 67 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	__webpack_require__(68);
	
	/***/ }),
	/* 68 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _jspdf = __webpack_require__(29);
	
	var _jspdf2 = _interopRequireDefault(_jspdf);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Get dimensions of a PDF page, as determined by jsPDF.
	_jspdf2.default.getPageSize = function (orientation, unit, format) {
	
	  // Decode options object
	  if (!!orientation && (typeof orientation === 'undefined' ? 'undefined' : _typeof(orientation)) === 'object') {
	    var options = orientation;
	
	    orientation = options.orientation;
	    unit = options.unit || unit;
	    format = options.format || format;
	  }
	
	  // Default options
	  unit = typeof unit === 'string' ? unit : 'mm';
	  format = typeof format === 'string' ? format : 'a4';
	  orientation = typeof orientation === 'string' ? orientation.toLowerCase() : 'p';
	
	  // Size in pt of various paper formats
	  var pageFormats = {
	    'a0': [2383.94, 3370.39],
	    'a1': [1683.78, 2383.94],
	    'a2': [1190.55, 1683.78],
	    'a3': [841.89, 1190.55],
	    'a4': [595.28, 841.89],
	    'a5': [419.53, 595.28],
	    'a6': [297.64, 419.53],
	    'a7': [209.76, 297.64],
	    'a8': [147.40, 209.76],
	    'a9': [104.88, 147.40],
	    'a10': [73.70, 104.88],
	    'b0': [2834.65, 4008.19],
	    'b1': [2004.09, 2834.65],
	    'b2': [1417.32, 2004.09],
	    'b3': [1000.63, 1417.32],
	    'b4': [708.66, 1000.63],
	    'b5': [498.90, 708.66],
	    'b6': [354.33, 498.90],
	    'b7': [249.45, 354.33],
	    'b8': [175.75, 249.45],
	    'b9': [124.72, 175.75],
	    'b10': [87.87, 124.72],
	    'c0': [2599.37, 3676.54],
	    'c1': [1836.85, 2599.37],
	    'c2': [1298.27, 1836.85],
	    'c3': [918.43, 1298.27],
	    'c4': [649.13, 918.43],
	    'c5': [459.21, 649.13],
	    'c6': [323.15, 459.21],
	    'c7': [229.61, 323.15],
	    'c8': [161.57, 229.61],
	    'c9': [113.39, 161.57],
	    'c10': [79.37, 113.39],
	    'dl': [311.81, 623.62],
	    'letter': [612, 792],
	    'government-letter': [576, 756],
	    'legal': [612, 1008],
	    'junior-legal': [576, 360],
	    'ledger': [1224, 792],
	    'tabloid': [792, 1224],
	    'credit-card': [153, 243]
	  };
	
	  var k = 0;
	
	  // Unit conversion
	  switch (unit) {
	    case 'pt':
	      k = 1;
	      break;
	    case 'mm':
	      k = 72 / 25.4;
	      break;
	    case 'cm':
	      k = 72 / 2.54;
	      break;
	    case 'in':
	      k = 72;
	      break;
	    case 'px':
	      k = 72 / 96;
	      break;
	    case 'pc':
	      k = 12;
	      break;
	    case 'em':
	      k = 12;
	      break;
	    case 'ex':
	      k = 6;
	      break;
	    default:
	      throw new Error('[html2pdf] invalid unit: ' + unit);
	  }
	
	  var pageHeight = 0;
	  var pageWidth = 0;
	
	  // Dimensions are stored as user units and converted to points on output
	  if (pageFormats.hasOwnProperty(format)) {
	    pageHeight = pageFormats[format][1] / k;
	    pageWidth = pageFormats[format][0] / k;
	  } else {
	    try {
	      pageHeight = format[1];
	      pageWidth = format[0];
	    } catch (err) {
	      throw new Error('[html2pdf] invalid format: ' + format);
	    }
	  }
	
	  // Handle page orientation
	  if (orientation === 'p' || orientation === 'portrait') {
	    orientation = 'p';
	    if (pageWidth > pageHeight) {
	      var tmp = pageWidth;
	
	      pageWidth = pageHeight;
	      pageHeight = tmp;
	    }
	  } else if (orientation === 'l' || orientation === 'landscape') {
	    orientation = 'l';
	    if (pageHeight > pageWidth) {
	      var _tmp = pageWidth;
	
	      pageWidth = pageHeight;
	      pageHeight = _tmp;
	    }
	  } else {
	    throw new Error('[html2pdf] invalid orientation: ' + orientation);
	  }
	
	  // Return information (k is the unit conversion ratio from pts)
	  return { 'width': pageWidth, 'height': pageHeight, 'unit': unit, 'k': k };
	};
	
	exports.default = _jspdf2.default;
	module.exports = exports['default'];
	
	/***/ }),
	/* 69 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Html2PdfUtils = function () {
	  function Html2PdfUtils() {
	    _classCallCheck(this, Html2PdfUtils);
	  }
	
	  _createClass(Html2PdfUtils, null, [{
	    key: 'createElement',
	
	
	    /**
	     * Creates a DOM element with optional attributes and children elements.
	     *
	     * @static
	     * @param {String} tag The DOM element tag name
	     * @param {any} args The DOM element attributes and / or children nodes
	     * @returns {Element} The DOM element
	     * @memberof Html2PdfUtils
	     */
	    value: function createElement(tag) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var el = document.createElement(tag);
	      var attributes = {};
	
	      // check if there are attributes defined
	      if (args[0].constructor === Object) {
	        attributes = args[0];
	        // ...and remove them from args
	        args = args.slice(1);
	      }
	      // check if HTML style is defined as object
	      if (!!attributes.style && _typeof(attributes.style) === 'object') {
	        // transform the style object into string
	        attributes.style = Object.keys(attributes.style).map(function (key) {
	          return key + ':' + attributes.style[key];
	        }).join(';');
	      }
	      // check if innerHTML is defined
	      if (attributes.hasOwnProperty('innerHTML')) {
	        // ...and delete the original innerHTML property
	        el.innerHTML = attributes.innerHTML;
	        delete attributes.innerHTML;
	      } else {
	        // create HTML element with supplied attributes and children (if any)
	        Array.prototype.forEach.call(args, function (arg) {
	          if (typeof arg === 'string') {
	            el.appendChild(document.createTextNode(arg));
	          } else if (!!arg && (typeof arg === 'undefined' ? 'undefined' : _typeof(arg)) === 'object' && arg.nodeType) {
	            el.appendChild(arg);
	          }
	        });
	      }
	
	      Array.prototype.forEach.call(Object.keys(attributes), function (key) {
	        el.setAttribute(key, attributes[key]);
	      });
	
	      // return the created HTML element
	      return el;
	    }
	
	    /**
	     * Deep-clone a DOM node and preserve contents / properties.
	     *
	     * @static
	     * @param {Element} node The DOM node to clone
	     * @param {Boolean} javascriptEnabled Clone script nodes
	     * @returns {Element} The cloned DOM node
	     * @memberof Html2PdfUtils
	     */
	
	  }, {
	    key: 'cloneNode',
	    value: function cloneNode(node, javascriptEnabled) {
	      // Recursively clone the node.
	      var clone = node.nodeType === 3 ? document.createTextNode(node.nodeValue) : node.cloneNode(false);
	
	      for (var child = node.firstChild; child; child = child.nextSibling) {
	        if (javascriptEnabled === true || child.nodeType !== 1 || child.nodeName !== 'SCRIPT') {
	          clone.appendChild(Html2PdfUtils.cloneNode(child, javascriptEnabled));
	        }
	      }
	
	      if (node.nodeType === 1) {
	        // Preserve contents/properties of special nodes.
	        if (node.nodeName === 'CANVAS') {
	          clone.width = node.width;
	          clone.height = node.height;
	          clone.getContext('2d').drawImage(node, 0, 0);
	        } else if (node.nodeName === 'TEXTAREA' || node.nodeName === 'SELECT') {
	          clone.value = node.value;
	        }
	
	        // Preserve the node's scroll position when it loads.
	        clone.addEventListener('load', function () {
	          clone.scrollTop = node.scrollTop;
	          clone.scrollLeft = node.scrollLeft;
	        }, true);
	      }
	
	      // Return the cloned node.
	      return clone;
	    }
	  }, {
	    key: 'unitConvert',
	    value: function unitConvert(obj, k) {
	      var o = {};
	
	      for (var key in obj) {
	        o[key] = obj[key] * 72 / 96 / k;
	      }
	      return o;
	    }
	  }]);
	
	  return Html2PdfUtils;
	}();
	
	exports.default = Html2PdfUtils;
	module.exports = exports['default'];
	
	/***/ })
	/******/ ]);
	});
	//# sourceMappingURL=html2pdf.js.map

/***/ },
/* 1313 */
/***/ function(module, exports) {

	module.exports = {
		"name": "axios",
		"version": "0.21.4",
		"description": "Promise based HTTP client for the browser and node.js",
		"main": "index.js",
		"scripts": {
			"test": "grunt test",
			"start": "node ./sandbox/server.js",
			"build": "NODE_ENV=production grunt build",
			"preversion": "npm test",
			"version": "npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json",
			"postversion": "git push && git push --tags",
			"examples": "node ./examples/server.js",
			"coveralls": "cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js",
			"fix": "eslint --fix lib/**/*.js"
		},
		"repository": {
			"type": "git",
			"url": "https://github.com/axios/axios.git"
		},
		"keywords": [
			"xhr",
			"http",
			"ajax",
			"promise",
			"node"
		],
		"author": "Matt Zabriskie",
		"license": "MIT",
		"bugs": {
			"url": "https://github.com/axios/axios/issues"
		},
		"homepage": "https://axios-http.com",
		"devDependencies": {
			"coveralls": "^3.0.0",
			"es6-promise": "^4.2.4",
			"grunt": "^1.3.0",
			"grunt-banner": "^0.6.0",
			"grunt-cli": "^1.2.0",
			"grunt-contrib-clean": "^1.1.0",
			"grunt-contrib-watch": "^1.0.0",
			"grunt-eslint": "^23.0.0",
			"grunt-karma": "^4.0.0",
			"grunt-mocha-test": "^0.13.3",
			"grunt-ts": "^6.0.0-beta.19",
			"grunt-webpack": "^4.0.2",
			"istanbul-instrumenter-loader": "^1.0.0",
			"jasmine-core": "^2.4.1",
			"karma": "^6.3.2",
			"karma-chrome-launcher": "^3.1.0",
			"karma-firefox-launcher": "^2.1.0",
			"karma-jasmine": "^1.1.1",
			"karma-jasmine-ajax": "^0.1.13",
			"karma-safari-launcher": "^1.0.0",
			"karma-sauce-launcher": "^4.3.6",
			"karma-sinon": "^1.0.5",
			"karma-sourcemap-loader": "^0.3.8",
			"karma-webpack": "^4.0.2",
			"load-grunt-tasks": "^3.5.2",
			"minimist": "^1.2.0",
			"mocha": "^8.2.1",
			"sinon": "^4.5.0",
			"terser-webpack-plugin": "^4.2.3",
			"typescript": "^4.0.5",
			"url-search-params": "^0.10.0",
			"webpack": "^4.44.2",
			"webpack-dev-server": "^3.11.0"
		},
		"browser": {
			"./lib/adapters/http.js": "./lib/adapters/xhr.js"
		},
		"jsdelivr": "dist/axios.min.js",
		"unpkg": "dist/axios.min.js",
		"typings": "./index.d.ts",
		"dependencies": {
			"follow-redirects": "^1.14.0"
		},
		"bundlesize": [
			{
				"path": "./dist/axios.min.js",
				"threshold": "5kB"
			}
		]
	};

/***/ },
/* 1314 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var CSV_FILE_TYPE = "text/csv;charset=utf-8;";
	var csvDownload = function (_a) {
	    var data = _a.data, _b = _a.filename, filename = _b === void 0 ? "export.csv" : _b, _c = _a.delimiter, delimiter = _c === void 0 ? ";" : _c, headers = _a.headers;
	    var formattedFilename = getFilename(filename);
	    if (data.length === 0) {
	        triggerCsvDownload(headers ? headers.join(delimiter) : "", formattedFilename);
	        return;
	    }
	    var headerKeys = Object.keys(data[0]);
	    var columnNames = headers !== null && headers !== void 0 ? headers : headerKeys;
	    var csv = data.map(function (row) {
	        return headerKeys
	            .map(function (fieldName) { var _a; return JSON.stringify(row[fieldName] === 0 ? 0 : (_a = row[fieldName]) !== null && _a !== void 0 ? _a : ""); })
	            .join(delimiter);
	    });
	    csv.unshift(columnNames.join(delimiter));
	    var csvAsString = csv.join("\r\n");
	    triggerCsvDownload(csvAsString, formattedFilename);
	};
	var triggerCsvDownload = function (csvAsString, fileName) {
	    // BOM support for special characters in Excel
	    var byteOrderMark = "\ufeff";
	    var blob = new Blob([byteOrderMark, csvAsString], {
	        type: CSV_FILE_TYPE,
	    });
	    var link = document.createElement("a");
	    link.href = URL.createObjectURL(blob);
	    link.download = fileName;
	    link.style.display = "none";
	    document.body.appendChild(link);
	    link.click();
	    document.body.removeChild(link);
	};
	var getFilename = function (providedFilename) {
	    return /csv$/i.test(providedFilename)
	        ? providedFilename
	        : "".concat(providedFilename, ".csv");
	};
	exports.default = csvDownload;


/***/ },
/* 1315 */
/***/ function(module, exports, __webpack_require__) {

	var camel2hyphen = __webpack_require__(1623);
	
	var isDimension = function (feature) {
	  var re = /[height|width]$/;
	  return re.test(feature);
	};
	
	var obj2mq = function (obj) {
	  var mq = '';
	  var features = Object.keys(obj);
	  features.forEach(function (feature, index) {
	    var value = obj[feature];
	    feature = camel2hyphen(feature);
	    // Add px to dimension features
	    if (isDimension(feature) && typeof value === 'number') {
	      value = value + 'px';
	    }
	    if (value === true) {
	      mq += feature;
	    } else if (value === false) {
	      mq += 'not ' + feature;
	    } else {
	      mq += '(' + feature + ': ' + value + ')';
	    }
	    if (index < features.length-1) {
	      mq += ' and '
	    }
	  });
	  return mq;
	};
	
	var json2mq = function (query) {
	  var mq = '';
	  if (typeof query === 'string') {
	    return query;
	  }
	  // Handling array of media queries
	  if (query instanceof Array) {
	    query.forEach(function (q, index) {
	      mq += obj2mq(q);
	      if (index < query.length-1) {
	        mq += ', '
	      }
	    });
	    return mq;
	  }
	  // Handling single media query
	  return obj2mq(query);
	};
	
	module.exports = json2mq;

/***/ },
/* 1316 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var hyphenate = __webpack_require__(1305);
	
	function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }
	
	var hyphenate__default = /*#__PURE__*/_interopDefaultLegacy(hyphenate);
	
	/**
	 * Convert camel cased property names to dash separated.
	 */
	
	function convertCase(style) {
	  var converted = {};
	
	  for (var prop in style) {
	    var key = prop.indexOf('--') === 0 ? prop : hyphenate__default['default'](prop);
	    converted[key] = style[prop];
	  }
	
	  if (style.fallbacks) {
	    if (Array.isArray(style.fallbacks)) converted.fallbacks = style.fallbacks.map(convertCase);else converted.fallbacks = convertCase(style.fallbacks);
	  }
	
	  return converted;
	}
	/**
	 * Allow camel cased property names by converting them back to dasherized.
	 */
	
	
	function camelCase() {
	  function onProcessStyle(style) {
	    if (Array.isArray(style)) {
	      // Handle rules like @font-face, which can have multiple styles in an array
	      for (var index = 0; index < style.length; index++) {
	        style[index] = convertCase(style[index]);
	      }
	
	      return style;
	    }
	
	    return convertCase(style);
	  }
	
	  function onChangeValue(value, prop, rule) {
	    if (prop.indexOf('--') === 0) {
	      return value;
	    }
	
	    var hyphenatedProp = hyphenate__default['default'](prop); // There was no camel case in place
	
	    if (prop === hyphenatedProp) return value;
	    rule.prop(hyphenatedProp, value); // Core will ignore that property value we set the proper one above.
	
	    return null;
	  }
	
	  return {
	    onProcessStyle: onProcessStyle,
	    onChangeValue: onChangeValue
	  };
	}
	
	exports.default = camelCase;


/***/ },
/* 1317 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var jss = __webpack_require__(110);
	
	var px = jss.hasCSSTOMSupport && CSS ? CSS.px : 'px';
	var ms = jss.hasCSSTOMSupport && CSS ? CSS.ms : 'ms';
	var percent = jss.hasCSSTOMSupport && CSS ? CSS.percent : '%';
	/**
	 * Generated jss-plugin-default-unit CSS property units
	 */
	
	var defaultUnits = {
	  // Animation properties
	  'animation-delay': ms,
	  'animation-duration': ms,
	  // Background properties
	  'background-position': px,
	  'background-position-x': px,
	  'background-position-y': px,
	  'background-size': px,
	  // Border Properties
	  border: px,
	  'border-bottom': px,
	  'border-bottom-left-radius': px,
	  'border-bottom-right-radius': px,
	  'border-bottom-width': px,
	  'border-left': px,
	  'border-left-width': px,
	  'border-radius': px,
	  'border-right': px,
	  'border-right-width': px,
	  'border-top': px,
	  'border-top-left-radius': px,
	  'border-top-right-radius': px,
	  'border-top-width': px,
	  'border-width': px,
	  'border-block': px,
	  'border-block-end': px,
	  'border-block-end-width': px,
	  'border-block-start': px,
	  'border-block-start-width': px,
	  'border-block-width': px,
	  'border-inline': px,
	  'border-inline-end': px,
	  'border-inline-end-width': px,
	  'border-inline-start': px,
	  'border-inline-start-width': px,
	  'border-inline-width': px,
	  'border-start-start-radius': px,
	  'border-start-end-radius': px,
	  'border-end-start-radius': px,
	  'border-end-end-radius': px,
	  // Margin properties
	  margin: px,
	  'margin-bottom': px,
	  'margin-left': px,
	  'margin-right': px,
	  'margin-top': px,
	  'margin-block': px,
	  'margin-block-end': px,
	  'margin-block-start': px,
	  'margin-inline': px,
	  'margin-inline-end': px,
	  'margin-inline-start': px,
	  // Padding properties
	  padding: px,
	  'padding-bottom': px,
	  'padding-left': px,
	  'padding-right': px,
	  'padding-top': px,
	  'padding-block': px,
	  'padding-block-end': px,
	  'padding-block-start': px,
	  'padding-inline': px,
	  'padding-inline-end': px,
	  'padding-inline-start': px,
	  // Mask properties
	  'mask-position-x': px,
	  'mask-position-y': px,
	  'mask-size': px,
	  // Width and height properties
	  height: px,
	  width: px,
	  'min-height': px,
	  'max-height': px,
	  'min-width': px,
	  'max-width': px,
	  // Position properties
	  bottom: px,
	  left: px,
	  top: px,
	  right: px,
	  inset: px,
	  'inset-block': px,
	  'inset-block-end': px,
	  'inset-block-start': px,
	  'inset-inline': px,
	  'inset-inline-end': px,
	  'inset-inline-start': px,
	  // Shadow properties
	  'box-shadow': px,
	  'text-shadow': px,
	  // Column properties
	  'column-gap': px,
	  'column-rule': px,
	  'column-rule-width': px,
	  'column-width': px,
	  // Font and text properties
	  'font-size': px,
	  'font-size-delta': px,
	  'letter-spacing': px,
	  'text-decoration-thickness': px,
	  'text-indent': px,
	  'text-stroke': px,
	  'text-stroke-width': px,
	  'word-spacing': px,
	  // Motion properties
	  motion: px,
	  'motion-offset': px,
	  // Outline properties
	  outline: px,
	  'outline-offset': px,
	  'outline-width': px,
	  // Perspective properties
	  perspective: px,
	  'perspective-origin-x': percent,
	  'perspective-origin-y': percent,
	  // Transform properties
	  'transform-origin': percent,
	  'transform-origin-x': percent,
	  'transform-origin-y': percent,
	  'transform-origin-z': percent,
	  // Transition properties
	  'transition-delay': ms,
	  'transition-duration': ms,
	  // Alignment properties
	  'vertical-align': px,
	  'flex-basis': px,
	  // Some random properties
	  'shape-margin': px,
	  size: px,
	  gap: px,
	  // Grid properties
	  grid: px,
	  'grid-gap': px,
	  'row-gap': px,
	  'grid-row-gap': px,
	  'grid-column-gap': px,
	  'grid-template-rows': px,
	  'grid-template-columns': px,
	  'grid-auto-rows': px,
	  'grid-auto-columns': px,
	  // Not existing properties.
	  // Used to avoid issues with jss-plugin-expand integration.
	  'box-shadow-x': px,
	  'box-shadow-y': px,
	  'box-shadow-blur': px,
	  'box-shadow-spread': px,
	  'font-line-height': px,
	  'text-shadow-x': px,
	  'text-shadow-y': px,
	  'text-shadow-blur': px
	};
	
	/**
	 * Clones the object and adds a camel cased property version.
	 */
	
	function addCamelCasedVersion(obj) {
	  var regExp = /(-[a-z])/g;
	
	  var replace = function replace(str) {
	    return str[1].toUpperCase();
	  };
	
	  var newObj = {};
	
	  for (var key in obj) {
	    newObj[key] = obj[key];
	    newObj[key.replace(regExp, replace)] = obj[key];
	  }
	
	  return newObj;
	}
	
	var units = addCamelCasedVersion(defaultUnits);
	/**
	 * Recursive deep style passing function
	 */
	
	function iterate(prop, value, options) {
	  if (value == null) return value;
	
	  if (Array.isArray(value)) {
	    for (var i = 0; i < value.length; i++) {
	      value[i] = iterate(prop, value[i], options);
	    }
	  } else if (typeof value === 'object') {
	    if (prop === 'fallbacks') {
	      for (var innerProp in value) {
	        value[innerProp] = iterate(innerProp, value[innerProp], options);
	      }
	    } else {
	      for (var _innerProp in value) {
	        value[_innerProp] = iterate(prop + "-" + _innerProp, value[_innerProp], options);
	      }
	    } // eslint-disable-next-line no-restricted-globals
	
	  } else if (typeof value === 'number' && isNaN(value) === false) {
	    var unit = options[prop] || units[prop]; // Add the unit if available, except for the special case of 0px.
	
	    if (unit && !(value === 0 && unit === px)) {
	      return typeof unit === 'function' ? unit(value).toString() : "" + value + unit;
	    }
	
	    return value.toString();
	  }
	
	  return value;
	}
	/**
	 * Add unit to numeric values.
	 */
	
	
	function defaultUnit(options) {
	  if (options === void 0) {
	    options = {};
	  }
	
	  var camelCasedOptions = addCamelCasedVersion(options);
	
	  function onProcessStyle(style, rule) {
	    if (rule.type !== 'style') return style;
	
	    for (var prop in style) {
	      style[prop] = iterate(prop, style[prop], camelCasedOptions);
	    }
	
	    return style;
	  }
	
	  function onChangeValue(value, prop) {
	    return iterate(prop, value, camelCasedOptions);
	  }
	
	  return {
	    onProcessStyle: onProcessStyle,
	    onChangeValue: onChangeValue
	  };
	}
	
	exports.default = defaultUnit;


/***/ },
/* 1318 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var _extends = __webpack_require__(6);
	var jss = __webpack_require__(110);
	
	function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }
	
	var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
	
	var at = '@global';
	var atPrefix = '@global ';
	
	var GlobalContainerRule =
	/*#__PURE__*/
	function () {
	  function GlobalContainerRule(key, styles, options) {
	    this.type = 'global';
	    this.at = at;
	    this.isProcessed = false;
	    this.key = key;
	    this.options = options;
	    this.rules = new jss.RuleList(_extends__default['default']({}, options, {
	      parent: this
	    }));
	
	    for (var selector in styles) {
	      this.rules.add(selector, styles[selector]);
	    }
	
	    this.rules.process();
	  }
	  /**
	   * Get a rule.
	   */
	
	
	  var _proto = GlobalContainerRule.prototype;
	
	  _proto.getRule = function getRule(name) {
	    return this.rules.get(name);
	  }
	  /**
	   * Create and register rule, run plugins.
	   */
	  ;
	
	  _proto.addRule = function addRule(name, style, options) {
	    var rule = this.rules.add(name, style, options);
	    if (rule) this.options.jss.plugins.onProcessRule(rule);
	    return rule;
	  }
	  /**
	   * Replace rule, run plugins.
	   */
	  ;
	
	  _proto.replaceRule = function replaceRule(name, style, options) {
	    var newRule = this.rules.replace(name, style, options);
	    if (newRule) this.options.jss.plugins.onProcessRule(newRule);
	    return newRule;
	  }
	  /**
	   * Get index of a rule.
	   */
	  ;
	
	  _proto.indexOf = function indexOf(rule) {
	    return this.rules.indexOf(rule);
	  }
	  /**
	   * Generates a CSS string.
	   */
	  ;
	
	  _proto.toString = function toString(options) {
	    return this.rules.toString(options);
	  };
	
	  return GlobalContainerRule;
	}();
	
	var GlobalPrefixedRule =
	/*#__PURE__*/
	function () {
	  function GlobalPrefixedRule(key, style, options) {
	    this.type = 'global';
	    this.at = at;
	    this.isProcessed = false;
	    this.key = key;
	    this.options = options;
	    var selector = key.substr(atPrefix.length);
	    this.rule = options.jss.createRule(selector, style, _extends__default['default']({}, options, {
	      parent: this
	    }));
	  }
	
	  var _proto2 = GlobalPrefixedRule.prototype;
	
	  _proto2.toString = function toString(options) {
	    return this.rule ? this.rule.toString(options) : '';
	  };
	
	  return GlobalPrefixedRule;
	}();
	
	var separatorRegExp = /\s*,\s*/g;
	
	function addScope(selector, scope) {
	  var parts = selector.split(separatorRegExp);
	  var scoped = '';
	
	  for (var i = 0; i < parts.length; i++) {
	    scoped += scope + " " + parts[i].trim();
	    if (parts[i + 1]) scoped += ', ';
	  }
	
	  return scoped;
	}
	
	function handleNestedGlobalContainerRule(rule, sheet) {
	  var options = rule.options,
	      style = rule.style;
	  var rules = style ? style[at] : null;
	  if (!rules) return;
	
	  for (var name in rules) {
	    sheet.addRule(name, rules[name], _extends__default['default']({}, options, {
	      selector: addScope(name, rule.selector)
	    }));
	  }
	
	  delete style[at];
	}
	
	function handlePrefixedGlobalRule(rule, sheet) {
	  var options = rule.options,
	      style = rule.style;
	
	  for (var prop in style) {
	    if (prop[0] !== '@' || prop.substr(0, at.length) !== at) continue;
	    var selector = addScope(prop.substr(at.length), rule.selector);
	    sheet.addRule(selector, style[prop], _extends__default['default']({}, options, {
	      selector: selector
	    }));
	    delete style[prop];
	  }
	}
	/**
	 * Convert nested rules to separate, remove them from original styles.
	 */
	
	
	function jssGlobal() {
	  function onCreateRule(name, styles, options) {
	    if (!name) return null;
	
	    if (name === at) {
	      return new GlobalContainerRule(name, styles, options);
	    }
	
	    if (name[0] === '@' && name.substr(0, atPrefix.length) === atPrefix) {
	      return new GlobalPrefixedRule(name, styles, options);
	    }
	
	    var parent = options.parent;
	
	    if (parent) {
	      if (parent.type === 'global' || parent.options.parent && parent.options.parent.type === 'global') {
	        options.scoped = false;
	      }
	    }
	
	    if (!options.selector && options.scoped === false) {
	      options.selector = name;
	    }
	
	    return null;
	  }
	
	  function onProcessRule(rule, sheet) {
	    if (rule.type !== 'style' || !sheet) return;
	    handleNestedGlobalContainerRule(rule, sheet);
	    handlePrefixedGlobalRule(rule, sheet);
	  }
	
	  return {
	    onCreateRule: onCreateRule,
	    onProcessRule: onProcessRule
	  };
	}
	
	exports.default = jssGlobal;


/***/ },
/* 1319 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var _extends = __webpack_require__(6);
	var warning = __webpack_require__(134);
	
	function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }
	
	var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
	var warning__default = /*#__PURE__*/_interopDefaultLegacy(warning);
	
	var separatorRegExp = /\s*,\s*/g;
	var parentRegExp = /&/g;
	var refRegExp = /\$([\w-]+)/g;
	/**
	 * Convert nested rules to separate, remove them from original styles.
	 */
	
	function jssNested() {
	  // Get a function to be used for $ref replacement.
	  function getReplaceRef(container, sheet) {
	    return function (match, key) {
	      var rule = container.getRule(key) || sheet && sheet.getRule(key);
	
	      if (rule) {
	        return rule.selector;
	      }
	
	       false ? warning__default['default'](false, "[JSS] Could not find the referenced rule \"" + key + "\" in \"" + (container.options.meta || container.toString()) + "\".") : void 0;
	      return key;
	    };
	  }
	
	  function replaceParentRefs(nestedProp, parentProp) {
	    var parentSelectors = parentProp.split(separatorRegExp);
	    var nestedSelectors = nestedProp.split(separatorRegExp);
	    var result = '';
	
	    for (var i = 0; i < parentSelectors.length; i++) {
	      var parent = parentSelectors[i];
	
	      for (var j = 0; j < nestedSelectors.length; j++) {
	        var nested = nestedSelectors[j];
	        if (result) result += ', '; // Replace all & by the parent or prefix & with the parent.
	
	        result += nested.indexOf('&') !== -1 ? nested.replace(parentRegExp, parent) : parent + " " + nested;
	      }
	    }
	
	    return result;
	  }
	
	  function getOptions(rule, container, prevOptions) {
	    // Options has been already created, now we only increase index.
	    if (prevOptions) return _extends__default['default']({}, prevOptions, {
	      index: prevOptions.index + 1
	    });
	    var nestingLevel = rule.options.nestingLevel;
	    nestingLevel = nestingLevel === undefined ? 1 : nestingLevel + 1;
	
	    var options = _extends__default['default']({}, rule.options, {
	      nestingLevel: nestingLevel,
	      index: container.indexOf(rule) + 1 // We don't need the parent name to be set options for chlid.
	
	    });
	
	    delete options.name;
	    return options;
	  }
	
	  function onProcessStyle(style, rule, sheet) {
	    if (rule.type !== 'style') return style;
	    var styleRule = rule;
	    var container = styleRule.options.parent;
	    var options;
	    var replaceRef;
	
	    for (var prop in style) {
	      var isNested = prop.indexOf('&') !== -1;
	      var isNestedConditional = prop[0] === '@';
	      if (!isNested && !isNestedConditional) continue;
	      options = getOptions(styleRule, container, options);
	
	      if (isNested) {
	        var selector = replaceParentRefs(prop, styleRule.selector); // Lazily create the ref replacer function just once for
	        // all nested rules within the sheet.
	
	        if (!replaceRef) replaceRef = getReplaceRef(container, sheet); // Replace all $refs.
	
	        selector = selector.replace(refRegExp, replaceRef);
	        var name = styleRule.key + "-" + prop;
	
	        if ('replaceRule' in container) {
	          // for backward compatibility
	          container.replaceRule(name, style[prop], _extends__default['default']({}, options, {
	            selector: selector
	          }));
	        } else {
	          container.addRule(name, style[prop], _extends__default['default']({}, options, {
	            selector: selector
	          }));
	        }
	      } else if (isNestedConditional) {
	        // Place conditional right after the parent rule to ensure right ordering.
	        container.addRule(prop, {}, options).addRule(styleRule.key, style[prop], {
	          selector: styleRule.selector
	        });
	      }
	
	      delete style[prop];
	    }
	
	    return style;
	  }
	
	  return {
	    onProcessStyle: onProcessStyle
	  };
	}
	
	exports.default = jssNested;


/***/ },
/* 1320 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/**
	 * Sort props by length.
	 */
	function jssPropsSort() {
	  var sort = function sort(prop0, prop1) {
	    if (prop0.length === prop1.length) {
	      return prop0 > prop1 ? 1 : -1;
	    }
	
	    return prop0.length - prop1.length;
	  };
	
	  return {
	    onProcessStyle: function onProcessStyle(style, rule) {
	      if (rule.type !== 'style') return style;
	      var newStyle = {};
	      var props = Object.keys(style).sort(sort);
	
	      for (var i = 0; i < props.length; i++) {
	        newStyle[props[i]] = style[props[i]];
	      }
	
	      return newStyle;
	    }
	  };
	}
	
	exports.default = jssPropsSort;


/***/ },
/* 1321 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var warning = __webpack_require__(134);
	var jss = __webpack_require__(110);
	
	function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }
	
	var warning__default = /*#__PURE__*/_interopDefaultLegacy(warning);
	
	var now = Date.now();
	var fnValuesNs = "fnValues" + now;
	var fnRuleNs = "fnStyle" + ++now;
	
	var functionPlugin = function functionPlugin() {
	  return {
	    onCreateRule: function onCreateRule(name, decl, options) {
	      if (typeof decl !== 'function') return null;
	      var rule = jss.createRule(name, {}, options);
	      rule[fnRuleNs] = decl;
	      return rule;
	    },
	    onProcessStyle: function onProcessStyle(style, rule) {
	      // We need to extract function values from the declaration, so that we can keep core unaware of them.
	      // We need to do that only once.
	      // We don't need to extract functions on each style update, since this can happen only once.
	      // We don't support function values inside of function rules.
	      if (fnValuesNs in rule || fnRuleNs in rule) return style;
	      var fnValues = {};
	
	      for (var prop in style) {
	        var value = style[prop];
	        if (typeof value !== 'function') continue;
	        delete style[prop];
	        fnValues[prop] = value;
	      }
	
	      rule[fnValuesNs] = fnValues;
	      return style;
	    },
	    onUpdate: function onUpdate(data, rule, sheet, options) {
	      var styleRule = rule;
	      var fnRule = styleRule[fnRuleNs]; // If we have a style function, the entire rule is dynamic and style object
	      // will be returned from that function.
	
	      if (fnRule) {
	        // Empty object will remove all currently defined props
	        // in case function rule returns a falsy value.
	        styleRule.style = fnRule(data) || {};
	
	        if (false) {
	          for (var prop in styleRule.style) {
	            if (typeof styleRule.style[prop] === 'function') {
	              process.env.NODE_ENV !== "production" ? warning__default['default'](false, '[JSS] Function values inside function rules are not supported.') : void 0;
	              break;
	            }
	          }
	        }
	      }
	
	      var fnValues = styleRule[fnValuesNs]; // If we have a fn values map, it is a rule with function values.
	
	      if (fnValues) {
	        for (var _prop in fnValues) {
	          styleRule.prop(_prop, fnValues[_prop](data), options);
	        }
	      }
	    }
	  };
	};
	
	exports.default = functionPlugin;


/***/ },
/* 1322 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var vendor = __webpack_require__(1077);
	var jss = __webpack_require__(110);
	
	/**
	 * Add vendor prefix to a property name when needed.
	 */
	
	function jssVendorPrefixer() {
	  function onProcessRule(rule) {
	    if (rule.type === 'keyframes') {
	      var atRule = rule;
	      atRule.at = vendor.supportedKeyframes(atRule.at);
	    }
	  }
	
	  function prefixStyle(style) {
	    for (var prop in style) {
	      var value = style[prop];
	
	      if (prop === 'fallbacks' && Array.isArray(value)) {
	        style[prop] = value.map(prefixStyle);
	        continue;
	      }
	
	      var changeProp = false;
	      var supportedProp = vendor.supportedProperty(prop);
	      if (supportedProp && supportedProp !== prop) changeProp = true;
	      var changeValue = false;
	      var supportedValue = vendor.supportedValue(supportedProp, jss.toCssValue(value));
	      if (supportedValue && supportedValue !== value) changeValue = true;
	
	      if (changeProp || changeValue) {
	        if (changeProp) delete style[prop];
	        style[supportedProp || prop] = supportedValue || value;
	      }
	    }
	
	    return style;
	  }
	
	  function onProcessStyle(style, rule) {
	    if (rule.type !== 'style') return style;
	    return prefixStyle(style);
	  }
	
	  function onChangeValue(value, prop) {
	    return vendor.supportedValue(prop, jss.toCssValue(value)) || value;
	  }
	
	  return {
	    onProcessRule: onProcessRule,
	    onProcessStyle: onProcessStyle,
	    onChangeValue: onChangeValue
	  };
	}
	
	exports.default = jssVendorPrefixer;


/***/ },
/* 1323 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var USE_TYPEDARRAY = (typeof Uint8Array !== "undefined") && (typeof Uint16Array !== "undefined") && (typeof Uint32Array !== "undefined");
	
	var pako = __webpack_require__(1354);
	var utils = __webpack_require__(42);
	var GenericWorker = __webpack_require__(72);
	
	var ARRAY_TYPE = USE_TYPEDARRAY ? "uint8array" : "array";
	
	exports.magic = "\x08\x00";
	
	/**
	 * Create a worker that uses pako to inflate/deflate.
	 * @constructor
	 * @param {String} action the name of the pako function to call : either "Deflate" or "Inflate".
	 * @param {Object} options the options to use when (de)compressing.
	 */
	function FlateWorker(action, options) {
	    GenericWorker.call(this, "FlateWorker/" + action);
	
	    this._pako = null;
	    this._pakoAction = action;
	    this._pakoOptions = options;
	    // the `meta` object from the last chunk received
	    // this allow this worker to pass around metadata
	    this.meta = {};
	}
	
	utils.inherits(FlateWorker, GenericWorker);
	
	/**
	 * @see GenericWorker.processChunk
	 */
	FlateWorker.prototype.processChunk = function (chunk) {
	    this.meta = chunk.meta;
	    if (this._pako === null) {
	        this._createPako();
	    }
	    this._pako.push(utils.transformTo(ARRAY_TYPE, chunk.data), false);
	};
	
	/**
	 * @see GenericWorker.flush
	 */
	FlateWorker.prototype.flush = function () {
	    GenericWorker.prototype.flush.call(this);
	    if (this._pako === null) {
	        this._createPako();
	    }
	    this._pako.push([], true);
	};
	/**
	 * @see GenericWorker.cleanUp
	 */
	FlateWorker.prototype.cleanUp = function () {
	    GenericWorker.prototype.cleanUp.call(this);
	    this._pako = null;
	};
	
	/**
	 * Create the _pako object.
	 * TODO: lazy-loading this object isn't the best solution but it's the
	 * quickest. The best solution is to lazy-load the worker list. See also the
	 * issue #446.
	 */
	FlateWorker.prototype._createPako = function () {
	    this._pako = new pako[this._pakoAction]({
	        raw: true,
	        level: this._pakoOptions.level || -1 // default compression
	    });
	    var self = this;
	    this._pako.onData = function(data) {
	        self.push({
	            data : data,
	            meta : self.meta
	        });
	    };
	};
	
	exports.compressWorker = function (compressionOptions) {
	    return new FlateWorker("Deflate", compressionOptions);
	};
	exports.uncompressWorker = function () {
	    return new FlateWorker("Inflate", {});
	};


/***/ },
/* 1324 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var utils = __webpack_require__(42);
	var GenericWorker = __webpack_require__(72);
	var utf8 = __webpack_require__(160);
	var crc32 = __webpack_require__(276);
	var signature = __webpack_require__(448);
	
	/**
	 * Transform an integer into a string in hexadecimal.
	 * @private
	 * @param {number} dec the number to convert.
	 * @param {number} bytes the number of bytes to generate.
	 * @returns {string} the result.
	 */
	var decToHex = function(dec, bytes) {
	    var hex = "", i;
	    for (i = 0; i < bytes; i++) {
	        hex += String.fromCharCode(dec & 0xff);
	        dec = dec >>> 8;
	    }
	    return hex;
	};
	
	/**
	 * Generate the UNIX part of the external file attributes.
	 * @param {Object} unixPermissions the unix permissions or null.
	 * @param {Boolean} isDir true if the entry is a directory, false otherwise.
	 * @return {Number} a 32 bit integer.
	 *
	 * adapted from http://unix.stackexchange.com/questions/14705/the-zip-formats-external-file-attribute :
	 *
	 * TTTTsstrwxrwxrwx0000000000ADVSHR
	 * ^^^^____________________________ file type, see zipinfo.c (UNX_*)
	 *     ^^^_________________________ setuid, setgid, sticky
	 *        ^^^^^^^^^________________ permissions
	 *                 ^^^^^^^^^^______ not used ?
	 *                           ^^^^^^ DOS attribute bits : Archive, Directory, Volume label, System file, Hidden, Read only
	 */
	var generateUnixExternalFileAttr = function (unixPermissions, isDir) {
	
	    var result = unixPermissions;
	    if (!unixPermissions) {
	        // I can't use octal values in strict mode, hence the hexa.
	        //  040775 => 0x41fd
	        // 0100664 => 0x81b4
	        result = isDir ? 0x41fd : 0x81b4;
	    }
	    return (result & 0xFFFF) << 16;
	};
	
	/**
	 * Generate the DOS part of the external file attributes.
	 * @param {Object} dosPermissions the dos permissions or null.
	 * @param {Boolean} isDir true if the entry is a directory, false otherwise.
	 * @return {Number} a 32 bit integer.
	 *
	 * Bit 0     Read-Only
	 * Bit 1     Hidden
	 * Bit 2     System
	 * Bit 3     Volume Label
	 * Bit 4     Directory
	 * Bit 5     Archive
	 */
	var generateDosExternalFileAttr = function (dosPermissions) {
	    // the dir flag is already set for compatibility
	    return (dosPermissions || 0)  & 0x3F;
	};
	
	/**
	 * Generate the various parts used in the construction of the final zip file.
	 * @param {Object} streamInfo the hash with information about the compressed file.
	 * @param {Boolean} streamedContent is the content streamed ?
	 * @param {Boolean} streamingEnded is the stream finished ?
	 * @param {number} offset the current offset from the start of the zip file.
	 * @param {String} platform let's pretend we are this platform (change platform dependents fields)
	 * @param {Function} encodeFileName the function to encode the file name / comment.
	 * @return {Object} the zip parts.
	 */
	var generateZipParts = function(streamInfo, streamedContent, streamingEnded, offset, platform, encodeFileName) {
	    var file = streamInfo["file"],
	        compression = streamInfo["compression"],
	        useCustomEncoding = encodeFileName !== utf8.utf8encode,
	        encodedFileName = utils.transformTo("string", encodeFileName(file.name)),
	        utfEncodedFileName = utils.transformTo("string", utf8.utf8encode(file.name)),
	        comment = file.comment,
	        encodedComment = utils.transformTo("string", encodeFileName(comment)),
	        utfEncodedComment = utils.transformTo("string", utf8.utf8encode(comment)),
	        useUTF8ForFileName = utfEncodedFileName.length !== file.name.length,
	        useUTF8ForComment = utfEncodedComment.length !== comment.length,
	        dosTime,
	        dosDate,
	        extraFields = "",
	        unicodePathExtraField = "",
	        unicodeCommentExtraField = "",
	        dir = file.dir,
	        date = file.date;
	
	
	    var dataInfo = {
	        crc32 : 0,
	        compressedSize : 0,
	        uncompressedSize : 0
	    };
	
	    // if the content is streamed, the sizes/crc32 are only available AFTER
	    // the end of the stream.
	    if (!streamedContent || streamingEnded) {
	        dataInfo.crc32 = streamInfo["crc32"];
	        dataInfo.compressedSize = streamInfo["compressedSize"];
	        dataInfo.uncompressedSize = streamInfo["uncompressedSize"];
	    }
	
	    var bitflag = 0;
	    if (streamedContent) {
	        // Bit 3: the sizes/crc32 are set to zero in the local header.
	        // The correct values are put in the data descriptor immediately
	        // following the compressed data.
	        bitflag |= 0x0008;
	    }
	    if (!useCustomEncoding && (useUTF8ForFileName || useUTF8ForComment)) {
	        // Bit 11: Language encoding flag (EFS).
	        bitflag |= 0x0800;
	    }
	
	
	    var extFileAttr = 0;
	    var versionMadeBy = 0;
	    if (dir) {
	        // dos or unix, we set the dos dir flag
	        extFileAttr |= 0x00010;
	    }
	    if(platform === "UNIX") {
	        versionMadeBy = 0x031E; // UNIX, version 3.0
	        extFileAttr |= generateUnixExternalFileAttr(file.unixPermissions, dir);
	    } else { // DOS or other, fallback to DOS
	        versionMadeBy = 0x0014; // DOS, version 2.0
	        extFileAttr |= generateDosExternalFileAttr(file.dosPermissions, dir);
	    }
	
	    // date
	    // @see http://www.delorie.com/djgpp/doc/rbinter/it/52/13.html
	    // @see http://www.delorie.com/djgpp/doc/rbinter/it/65/16.html
	    // @see http://www.delorie.com/djgpp/doc/rbinter/it/66/16.html
	
	    dosTime = date.getUTCHours();
	    dosTime = dosTime << 6;
	    dosTime = dosTime | date.getUTCMinutes();
	    dosTime = dosTime << 5;
	    dosTime = dosTime | date.getUTCSeconds() / 2;
	
	    dosDate = date.getUTCFullYear() - 1980;
	    dosDate = dosDate << 4;
	    dosDate = dosDate | (date.getUTCMonth() + 1);
	    dosDate = dosDate << 5;
	    dosDate = dosDate | date.getUTCDate();
	
	    if (useUTF8ForFileName) {
	        // set the unicode path extra field. unzip needs at least one extra
	        // field to correctly handle unicode path, so using the path is as good
	        // as any other information. This could improve the situation with
	        // other archive managers too.
	        // This field is usually used without the utf8 flag, with a non
	        // unicode path in the header (winrar, winzip). This helps (a bit)
	        // with the messy Windows' default compressed folders feature but
	        // breaks on p7zip which doesn't seek the unicode path extra field.
	        // So for now, UTF-8 everywhere !
	        unicodePathExtraField =
	            // Version
	            decToHex(1, 1) +
	            // NameCRC32
	            decToHex(crc32(encodedFileName), 4) +
	            // UnicodeName
	            utfEncodedFileName;
	
	        extraFields +=
	            // Info-ZIP Unicode Path Extra Field
	            "\x75\x70" +
	            // size
	            decToHex(unicodePathExtraField.length, 2) +
	            // content
	            unicodePathExtraField;
	    }
	
	    if(useUTF8ForComment) {
	
	        unicodeCommentExtraField =
	            // Version
	            decToHex(1, 1) +
	            // CommentCRC32
	            decToHex(crc32(encodedComment), 4) +
	            // UnicodeName
	            utfEncodedComment;
	
	        extraFields +=
	            // Info-ZIP Unicode Path Extra Field
	            "\x75\x63" +
	            // size
	            decToHex(unicodeCommentExtraField.length, 2) +
	            // content
	            unicodeCommentExtraField;
	    }
	
	    var header = "";
	
	    // version needed to extract
	    header += "\x0A\x00";
	    // general purpose bit flag
	    header += decToHex(bitflag, 2);
	    // compression method
	    header += compression.magic;
	    // last mod file time
	    header += decToHex(dosTime, 2);
	    // last mod file date
	    header += decToHex(dosDate, 2);
	    // crc-32
	    header += decToHex(dataInfo.crc32, 4);
	    // compressed size
	    header += decToHex(dataInfo.compressedSize, 4);
	    // uncompressed size
	    header += decToHex(dataInfo.uncompressedSize, 4);
	    // file name length
	    header += decToHex(encodedFileName.length, 2);
	    // extra field length
	    header += decToHex(extraFields.length, 2);
	
	
	    var fileRecord = signature.LOCAL_FILE_HEADER + header + encodedFileName + extraFields;
	
	    var dirRecord = signature.CENTRAL_FILE_HEADER +
	        // version made by (00: DOS)
	        decToHex(versionMadeBy, 2) +
	        // file header (common to file and central directory)
	        header +
	        // file comment length
	        decToHex(encodedComment.length, 2) +
	        // disk number start
	        "\x00\x00" +
	        // internal file attributes TODO
	        "\x00\x00" +
	        // external file attributes
	        decToHex(extFileAttr, 4) +
	        // relative offset of local header
	        decToHex(offset, 4) +
	        // file name
	        encodedFileName +
	        // extra field
	        extraFields +
	        // file comment
	        encodedComment;
	
	    return {
	        fileRecord: fileRecord,
	        dirRecord: dirRecord
	    };
	};
	
	/**
	 * Generate the EOCD record.
	 * @param {Number} entriesCount the number of entries in the zip file.
	 * @param {Number} centralDirLength the length (in bytes) of the central dir.
	 * @param {Number} localDirLength the length (in bytes) of the local dir.
	 * @param {String} comment the zip file comment as a binary string.
	 * @param {Function} encodeFileName the function to encode the comment.
	 * @return {String} the EOCD record.
	 */
	var generateCentralDirectoryEnd = function (entriesCount, centralDirLength, localDirLength, comment, encodeFileName) {
	    var dirEnd = "";
	    var encodedComment = utils.transformTo("string", encodeFileName(comment));
	
	    // end of central dir signature
	    dirEnd = signature.CENTRAL_DIRECTORY_END +
	        // number of this disk
	        "\x00\x00" +
	        // number of the disk with the start of the central directory
	        "\x00\x00" +
	        // total number of entries in the central directory on this disk
	        decToHex(entriesCount, 2) +
	        // total number of entries in the central directory
	        decToHex(entriesCount, 2) +
	        // size of the central directory   4 bytes
	        decToHex(centralDirLength, 4) +
	        // offset of start of central directory with respect to the starting disk number
	        decToHex(localDirLength, 4) +
	        // .ZIP file comment length
	        decToHex(encodedComment.length, 2) +
	        // .ZIP file comment
	        encodedComment;
	
	    return dirEnd;
	};
	
	/**
	 * Generate data descriptors for a file entry.
	 * @param {Object} streamInfo the hash generated by a worker, containing information
	 * on the file entry.
	 * @return {String} the data descriptors.
	 */
	var generateDataDescriptors = function (streamInfo) {
	    var descriptor = "";
	    descriptor = signature.DATA_DESCRIPTOR +
	        // crc-32                          4 bytes
	        decToHex(streamInfo["crc32"], 4) +
	        // compressed size                 4 bytes
	        decToHex(streamInfo["compressedSize"], 4) +
	        // uncompressed size               4 bytes
	        decToHex(streamInfo["uncompressedSize"], 4);
	
	    return descriptor;
	};
	
	
	/**
	 * A worker to concatenate other workers to create a zip file.
	 * @param {Boolean} streamFiles `true` to stream the content of the files,
	 * `false` to accumulate it.
	 * @param {String} comment the comment to use.
	 * @param {String} platform the platform to use, "UNIX" or "DOS".
	 * @param {Function} encodeFileName the function to encode file names and comments.
	 */
	function ZipFileWorker(streamFiles, comment, platform, encodeFileName) {
	    GenericWorker.call(this, "ZipFileWorker");
	    // The number of bytes written so far. This doesn't count accumulated chunks.
	    this.bytesWritten = 0;
	    // The comment of the zip file
	    this.zipComment = comment;
	    // The platform "generating" the zip file.
	    this.zipPlatform = platform;
	    // the function to encode file names and comments.
	    this.encodeFileName = encodeFileName;
	    // Should we stream the content of the files ?
	    this.streamFiles = streamFiles;
	    // If `streamFiles` is false, we will need to accumulate the content of the
	    // files to calculate sizes / crc32 (and write them *before* the content).
	    // This boolean indicates if we are accumulating chunks (it will change a lot
	    // during the lifetime of this worker).
	    this.accumulate = false;
	    // The buffer receiving chunks when accumulating content.
	    this.contentBuffer = [];
	    // The list of generated directory records.
	    this.dirRecords = [];
	    // The offset (in bytes) from the beginning of the zip file for the current source.
	    this.currentSourceOffset = 0;
	    // The total number of entries in this zip file.
	    this.entriesCount = 0;
	    // the name of the file currently being added, null when handling the end of the zip file.
	    // Used for the emitted metadata.
	    this.currentFile = null;
	
	
	
	    this._sources = [];
	}
	utils.inherits(ZipFileWorker, GenericWorker);
	
	/**
	 * @see GenericWorker.push
	 */
	ZipFileWorker.prototype.push = function (chunk) {
	
	    var currentFilePercent = chunk.meta.percent || 0;
	    var entriesCount = this.entriesCount;
	    var remainingFiles = this._sources.length;
	
	    if(this.accumulate) {
	        this.contentBuffer.push(chunk);
	    } else {
	        this.bytesWritten += chunk.data.length;
	
	        GenericWorker.prototype.push.call(this, {
	            data : chunk.data,
	            meta : {
	                currentFile : this.currentFile,
	                percent : entriesCount ? (currentFilePercent + 100 * (entriesCount - remainingFiles - 1)) / entriesCount : 100
	            }
	        });
	    }
	};
	
	/**
	 * The worker started a new source (an other worker).
	 * @param {Object} streamInfo the streamInfo object from the new source.
	 */
	ZipFileWorker.prototype.openedSource = function (streamInfo) {
	    this.currentSourceOffset = this.bytesWritten;
	    this.currentFile = streamInfo["file"].name;
	
	    var streamedContent = this.streamFiles && !streamInfo["file"].dir;
	
	    // don't stream folders (because they don't have any content)
	    if(streamedContent) {
	        var record = generateZipParts(streamInfo, streamedContent, false, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
	        this.push({
	            data : record.fileRecord,
	            meta : {percent:0}
	        });
	    } else {
	        // we need to wait for the whole file before pushing anything
	        this.accumulate = true;
	    }
	};
	
	/**
	 * The worker finished a source (an other worker).
	 * @param {Object} streamInfo the streamInfo object from the finished source.
	 */
	ZipFileWorker.prototype.closedSource = function (streamInfo) {
	    this.accumulate = false;
	    var streamedContent = this.streamFiles && !streamInfo["file"].dir;
	    var record = generateZipParts(streamInfo, streamedContent, true, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
	
	    this.dirRecords.push(record.dirRecord);
	    if(streamedContent) {
	        // after the streamed file, we put data descriptors
	        this.push({
	            data : generateDataDescriptors(streamInfo),
	            meta : {percent:100}
	        });
	    } else {
	        // the content wasn't streamed, we need to push everything now
	        // first the file record, then the content
	        this.push({
	            data : record.fileRecord,
	            meta : {percent:0}
	        });
	        while(this.contentBuffer.length) {
	            this.push(this.contentBuffer.shift());
	        }
	    }
	    this.currentFile = null;
	};
	
	/**
	 * @see GenericWorker.flush
	 */
	ZipFileWorker.prototype.flush = function () {
	
	    var localDirLength = this.bytesWritten;
	    for(var i = 0; i < this.dirRecords.length; i++) {
	        this.push({
	            data : this.dirRecords[i],
	            meta : {percent:100}
	        });
	    }
	    var centralDirLength = this.bytesWritten - localDirLength;
	
	    var dirEnd = generateCentralDirectoryEnd(this.dirRecords.length, centralDirLength, localDirLength, this.zipComment, this.encodeFileName);
	
	    this.push({
	        data : dirEnd,
	        meta : {percent:100}
	    });
	};
	
	/**
	 * Prepare the next source to be read.
	 */
	ZipFileWorker.prototype.prepareNextSource = function () {
	    this.previous = this._sources.shift();
	    this.openedSource(this.previous.streamInfo);
	    if (this.isPaused) {
	        this.previous.pause();
	    } else {
	        this.previous.resume();
	    }
	};
	
	/**
	 * @see GenericWorker.registerPrevious
	 */
	ZipFileWorker.prototype.registerPrevious = function (previous) {
	    this._sources.push(previous);
	    var self = this;
	
	    previous.on("data", function (chunk) {
	        self.processChunk(chunk);
	    });
	    previous.on("end", function () {
	        self.closedSource(self.previous.streamInfo);
	        if(self._sources.length) {
	            self.prepareNextSource();
	        } else {
	            self.end();
	        }
	    });
	    previous.on("error", function (e) {
	        self.error(e);
	    });
	    return this;
	};
	
	/**
	 * @see GenericWorker.resume
	 */
	ZipFileWorker.prototype.resume = function () {
	    if(!GenericWorker.prototype.resume.call(this)) {
	        return false;
	    }
	
	    if (!this.previous && this._sources.length) {
	        this.prepareNextSource();
	        return true;
	    }
	    if (!this.previous && !this._sources.length && !this.generatedError) {
	        this.end();
	        return true;
	    }
	};
	
	/**
	 * @see GenericWorker.error
	 */
	ZipFileWorker.prototype.error = function (e) {
	    var sources = this._sources;
	    if(!GenericWorker.prototype.error.call(this, e)) {
	        return false;
	    }
	    for(var i = 0; i < sources.length; i++) {
	        try {
	            sources[i].error(e);
	        } catch(e) {
	            // the `error` exploded, nothing to do
	        }
	    }
	    return true;
	};
	
	/**
	 * @see GenericWorker.lock
	 */
	ZipFileWorker.prototype.lock = function () {
	    GenericWorker.prototype.lock.call(this);
	    var sources = this._sources;
	    for(var i = 0; i < sources.length; i++) {
	        sources[i].lock();
	    }
	};
	
	module.exports = ZipFileWorker;


/***/ },
/* 1325 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var compressions = __webpack_require__(441);
	var ZipFileWorker = __webpack_require__(1324);
	
	/**
	 * Find the compression to use.
	 * @param {String} fileCompression the compression defined at the file level, if any.
	 * @param {String} zipCompression the compression defined at the load() level.
	 * @return {Object} the compression object to use.
	 */
	var getCompression = function (fileCompression, zipCompression) {
	
	    var compressionName = fileCompression || zipCompression;
	    var compression = compressions[compressionName];
	    if (!compression) {
	        throw new Error(compressionName + " is not a valid compression method !");
	    }
	    return compression;
	};
	
	/**
	 * Create a worker to generate a zip file.
	 * @param {JSZip} zip the JSZip instance at the right root level.
	 * @param {Object} options to generate the zip file.
	 * @param {String} comment the comment to use.
	 */
	exports.generateWorker = function (zip, options, comment) {
	
	    var zipFileWorker = new ZipFileWorker(options.streamFiles, comment, options.platform, options.encodeFileName);
	    var entriesCount = 0;
	    try {
	
	        zip.forEach(function (relativePath, file) {
	            entriesCount++;
	            var compression = getCompression(file.options.compression, options.compression);
	            var compressionOptions = file.options.compressionOptions || options.compressionOptions || {};
	            var dir = file.dir, date = file.date;
	
	            file._compressWorker(compression, compressionOptions)
	                .withStreamInfo("file", {
	                    name : relativePath,
	                    dir : dir,
	                    date : date,
	                    comment : file.comment || "",
	                    unixPermissions : file.unixPermissions,
	                    dosPermissions : file.dosPermissions
	                })
	                .pipe(zipFileWorker);
	        });
	        zipFileWorker.entriesCount = entriesCount;
	    } catch (e) {
	        zipFileWorker.error(e);
	    }
	
	    return zipFileWorker;
	};


/***/ },
/* 1326 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	/**
	 * Representation a of zip file in js
	 * @constructor
	 */
	function JSZip() {
	    // if this constructor is used without `new`, it adds `new` before itself:
	    if(!(this instanceof JSZip)) {
	        return new JSZip();
	    }
	
	    if(arguments.length) {
	        throw new Error("The constructor with parameters has been removed in JSZip 3.0, please check the upgrade guide.");
	    }
	
	    // object containing the files :
	    // {
	    //   "folder/" : {...},
	    //   "folder/data.txt" : {...}
	    // }
	    // NOTE: we use a null prototype because we do not
	    // want filenames like "toString" coming from a zip file
	    // to overwrite methods and attributes in a normal Object.
	    this.files = Object.create(null);
	
	    this.comment = null;
	
	    // Where we are in the hierarchy
	    this.root = "";
	    this.clone = function() {
	        var newObj = new JSZip();
	        for (var i in this) {
	            if (typeof this[i] !== "function") {
	                newObj[i] = this[i];
	            }
	        }
	        return newObj;
	    };
	}
	JSZip.prototype = __webpack_require__(1330);
	JSZip.prototype.loadAsync = __webpack_require__(1327);
	JSZip.support = __webpack_require__(98);
	JSZip.defaults = __webpack_require__(442);
	
	// TODO find a better way to handle this version,
	// a require('package.json').version doesn't work with webpack, see #327
	JSZip.version = "3.10.1";
	
	JSZip.loadAsync = function (content, options) {
	    return new JSZip().loadAsync(content, options);
	};
	
	JSZip.external = __webpack_require__(159);
	module.exports = JSZip;


/***/ },
/* 1327 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var utils = __webpack_require__(42);
	var external = __webpack_require__(159);
	var utf8 = __webpack_require__(160);
	var ZipEntries = __webpack_require__(1335);
	var Crc32Probe = __webpack_require__(449);
	var nodejsUtils = __webpack_require__(201);
	
	/**
	 * Check the CRC32 of an entry.
	 * @param {ZipEntry} zipEntry the zip entry to check.
	 * @return {Promise} the result.
	 */
	function checkEntryCRC32(zipEntry) {
	    return new external.Promise(function (resolve, reject) {
	        var worker = zipEntry.decompressed.getContentWorker().pipe(new Crc32Probe());
	        worker.on("error", function (e) {
	            reject(e);
	        })
	            .on("end", function () {
	                if (worker.streamInfo.crc32 !== zipEntry.decompressed.crc32) {
	                    reject(new Error("Corrupted zip : CRC32 mismatch"));
	                } else {
	                    resolve();
	                }
	            })
	            .resume();
	    });
	}
	
	module.exports = function (data, options) {
	    var zip = this;
	    options = utils.extend(options || {}, {
	        base64: false,
	        checkCRC32: false,
	        optimizedBinaryString: false,
	        createFolders: false,
	        decodeFileName: utf8.utf8decode
	    });
	
	    if (nodejsUtils.isNode && nodejsUtils.isStream(data)) {
	        return external.Promise.reject(new Error("JSZip can't accept a stream when loading a zip file."));
	    }
	
	    return utils.prepareContent("the loaded zip file", data, true, options.optimizedBinaryString, options.base64)
	        .then(function (data) {
	            var zipEntries = new ZipEntries(options);
	            zipEntries.load(data);
	            return zipEntries;
	        }).then(function checkCRC32(zipEntries) {
	            var promises = [external.Promise.resolve(zipEntries)];
	            var files = zipEntries.files;
	            if (options.checkCRC32) {
	                for (var i = 0; i < files.length; i++) {
	                    promises.push(checkEntryCRC32(files[i]));
	                }
	            }
	            return external.Promise.all(promises);
	        }).then(function addFiles(results) {
	            var zipEntries = results.shift();
	            var files = zipEntries.files;
	            for (var i = 0; i < files.length; i++) {
	                var input = files[i];
	
	                var unsafeName = input.fileNameStr;
	                var safeName = utils.resolve(input.fileNameStr);
	
	                zip.file(safeName, input.decompressed, {
	                    binary: true,
	                    optimizedBinaryString: true,
	                    date: input.date,
	                    dir: input.dir,
	                    comment: input.fileCommentStr.length ? input.fileCommentStr : null,
	                    unixPermissions: input.unixPermissions,
	                    dosPermissions: input.dosPermissions,
	                    createFolders: options.createFolders
	                });
	                if (!input.dir) {
	                    zip.file(safeName).unsafeOriginalName = unsafeName;
	                }
	            }
	            if (zipEntries.zipComment.length) {
	                zip.comment = zipEntries.zipComment;
	            }
	
	            return zip;
	        });
	};


/***/ },
/* 1328 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var utils = __webpack_require__(42);
	var GenericWorker = __webpack_require__(72);
	
	/**
	 * A worker that use a nodejs stream as source.
	 * @constructor
	 * @param {String} filename the name of the file entry for this stream.
	 * @param {Readable} stream the nodejs stream.
	 */
	function NodejsStreamInputAdapter(filename, stream) {
	    GenericWorker.call(this, "Nodejs stream input adapter for " + filename);
	    this._upstreamEnded = false;
	    this._bindStream(stream);
	}
	
	utils.inherits(NodejsStreamInputAdapter, GenericWorker);
	
	/**
	 * Prepare the stream and bind the callbacks on it.
	 * Do this ASAP on node 0.10 ! A lazy binding doesn't always work.
	 * @param {Stream} stream the nodejs stream to use.
	 */
	NodejsStreamInputAdapter.prototype._bindStream = function (stream) {
	    var self = this;
	    this._stream = stream;
	    stream.pause();
	    stream
	        .on("data", function (chunk) {
	            self.push({
	                data: chunk,
	                meta : {
	                    percent : 0
	                }
	            });
	        })
	        .on("error", function (e) {
	            if(self.isPaused) {
	                this.generatedError = e;
	            } else {
	                self.error(e);
	            }
	        })
	        .on("end", function () {
	            if(self.isPaused) {
	                self._upstreamEnded = true;
	            } else {
	                self.end();
	            }
	        });
	};
	NodejsStreamInputAdapter.prototype.pause = function () {
	    if(!GenericWorker.prototype.pause.call(this)) {
	        return false;
	    }
	    this._stream.pause();
	    return true;
	};
	NodejsStreamInputAdapter.prototype.resume = function () {
	    if(!GenericWorker.prototype.resume.call(this)) {
	        return false;
	    }
	
	    if(this._upstreamEnded) {
	        this.end();
	    } else {
	        this._stream.resume();
	    }
	
	    return true;
	};
	
	module.exports = NodejsStreamInputAdapter;


/***/ },
/* 1329 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var Readable = __webpack_require__(443).Readable;
	
	var utils = __webpack_require__(42);
	utils.inherits(NodejsStreamOutputAdapter, Readable);
	
	/**
	* A nodejs stream using a worker as source.
	* @see the SourceWrapper in http://nodejs.org/api/stream.html
	* @constructor
	* @param {StreamHelper} helper the helper wrapping the worker
	* @param {Object} options the nodejs stream options
	* @param {Function} updateCb the update callback.
	*/
	function NodejsStreamOutputAdapter(helper, options, updateCb) {
	    Readable.call(this, options);
	    this._helper = helper;
	
	    var self = this;
	    helper.on("data", function (data, meta) {
	        if (!self.push(data)) {
	            self._helper.pause();
	        }
	        if(updateCb) {
	            updateCb(meta);
	        }
	    })
	        .on("error", function(e) {
	            self.emit("error", e);
	        })
	        .on("end", function () {
	            self.push(null);
	        });
	}
	
	
	NodejsStreamOutputAdapter.prototype._read = function() {
	    this._helper.resume();
	};
	
	module.exports = NodejsStreamOutputAdapter;


/***/ },
/* 1330 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var utf8 = __webpack_require__(160);
	var utils = __webpack_require__(42);
	var GenericWorker = __webpack_require__(72);
	var StreamHelper = __webpack_require__(451);
	var defaults = __webpack_require__(442);
	var CompressedObject = __webpack_require__(275);
	var ZipObject = __webpack_require__(1337);
	var generate = __webpack_require__(1325);
	var nodejsUtils = __webpack_require__(201);
	var NodejsStreamInputAdapter = __webpack_require__(1328);
	
	
	/**
	 * Add a file in the current folder.
	 * @private
	 * @param {string} name the name of the file
	 * @param {String|ArrayBuffer|Uint8Array|Buffer} data the data of the file
	 * @param {Object} originalOptions the options of the file
	 * @return {Object} the new file.
	 */
	var fileAdd = function(name, data, originalOptions) {
	    // be sure sub folders exist
	    var dataType = utils.getTypeOf(data),
	        parent;
	
	
	    /*
	     * Correct options.
	     */
	
	    var o = utils.extend(originalOptions || {}, defaults);
	    o.date = o.date || new Date();
	    if (o.compression !== null) {
	        o.compression = o.compression.toUpperCase();
	    }
	
	    if (typeof o.unixPermissions === "string") {
	        o.unixPermissions = parseInt(o.unixPermissions, 8);
	    }
	
	    // UNX_IFDIR  0040000 see zipinfo.c
	    if (o.unixPermissions && (o.unixPermissions & 0x4000)) {
	        o.dir = true;
	    }
	    // Bit 4    Directory
	    if (o.dosPermissions && (o.dosPermissions & 0x0010)) {
	        o.dir = true;
	    }
	
	    if (o.dir) {
	        name = forceTrailingSlash(name);
	    }
	    if (o.createFolders && (parent = parentFolder(name))) {
	        folderAdd.call(this, parent, true);
	    }
	
	    var isUnicodeString = dataType === "string" && o.binary === false && o.base64 === false;
	    if (!originalOptions || typeof originalOptions.binary === "undefined") {
	        o.binary = !isUnicodeString;
	    }
	
	
	    var isCompressedEmpty = (data instanceof CompressedObject) && data.uncompressedSize === 0;
	
	    if (isCompressedEmpty || o.dir || !data || data.length === 0) {
	        o.base64 = false;
	        o.binary = true;
	        data = "";
	        o.compression = "STORE";
	        dataType = "string";
	    }
	
	    /*
	     * Convert content to fit.
	     */
	
	    var zipObjectContent = null;
	    if (data instanceof CompressedObject || data instanceof GenericWorker) {
	        zipObjectContent = data;
	    } else if (nodejsUtils.isNode && nodejsUtils.isStream(data)) {
	        zipObjectContent = new NodejsStreamInputAdapter(name, data);
	    } else {
	        zipObjectContent = utils.prepareContent(name, data, o.binary, o.optimizedBinaryString, o.base64);
	    }
	
	    var object = new ZipObject(name, zipObjectContent, o);
	    this.files[name] = object;
	    /*
	    TODO: we can't throw an exception because we have async promises
	    (we can have a promise of a Date() for example) but returning a
	    promise is useless because file(name, data) returns the JSZip
	    object for chaining. Should we break that to allow the user
	    to catch the error ?
	
	    return external.Promise.resolve(zipObjectContent)
	    .then(function () {
	        return object;
	    });
	    */
	};
	
	/**
	 * Find the parent folder of the path.
	 * @private
	 * @param {string} path the path to use
	 * @return {string} the parent folder, or ""
	 */
	var parentFolder = function (path) {
	    if (path.slice(-1) === "/") {
	        path = path.substring(0, path.length - 1);
	    }
	    var lastSlash = path.lastIndexOf("/");
	    return (lastSlash > 0) ? path.substring(0, lastSlash) : "";
	};
	
	/**
	 * Returns the path with a slash at the end.
	 * @private
	 * @param {String} path the path to check.
	 * @return {String} the path with a trailing slash.
	 */
	var forceTrailingSlash = function(path) {
	    // Check the name ends with a /
	    if (path.slice(-1) !== "/") {
	        path += "/"; // IE doesn't like substr(-1)
	    }
	    return path;
	};
	
	/**
	 * Add a (sub) folder in the current folder.
	 * @private
	 * @param {string} name the folder's name
	 * @param {boolean=} [createFolders] If true, automatically create sub
	 *  folders. Defaults to false.
	 * @return {Object} the new folder.
	 */
	var folderAdd = function(name, createFolders) {
	    createFolders = (typeof createFolders !== "undefined") ? createFolders : defaults.createFolders;
	
	    name = forceTrailingSlash(name);
	
	    // Does this folder already exist?
	    if (!this.files[name]) {
	        fileAdd.call(this, name, null, {
	            dir: true,
	            createFolders: createFolders
	        });
	    }
	    return this.files[name];
	};
	
	/**
	* Cross-window, cross-Node-context regular expression detection
	* @param  {Object}  object Anything
	* @return {Boolean}        true if the object is a regular expression,
	* false otherwise
	*/
	function isRegExp(object) {
	    return Object.prototype.toString.call(object) === "[object RegExp]";
	}
	
	// return the actual prototype of JSZip
	var out = {
	    /**
	     * @see loadAsync
	     */
	    load: function() {
	        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
	    },
	
	
	    /**
	     * Call a callback function for each entry at this folder level.
	     * @param {Function} cb the callback function:
	     * function (relativePath, file) {...}
	     * It takes 2 arguments : the relative path and the file.
	     */
	    forEach: function(cb) {
	        var filename, relativePath, file;
	        // ignore warning about unwanted properties because this.files is a null prototype object
	        /* eslint-disable-next-line guard-for-in */
	        for (filename in this.files) {
	            file = this.files[filename];
	            relativePath = filename.slice(this.root.length, filename.length);
	            if (relativePath && filename.slice(0, this.root.length) === this.root) { // the file is in the current root
	                cb(relativePath, file); // TODO reverse the parameters ? need to be clean AND consistent with the filter search fn...
	            }
	        }
	    },
	
	    /**
	     * Filter nested files/folders with the specified function.
	     * @param {Function} search the predicate to use :
	     * function (relativePath, file) {...}
	     * It takes 2 arguments : the relative path and the file.
	     * @return {Array} An array of matching elements.
	     */
	    filter: function(search) {
	        var result = [];
	        this.forEach(function (relativePath, entry) {
	            if (search(relativePath, entry)) { // the file matches the function
	                result.push(entry);
	            }
	
	        });
	        return result;
	    },
	
	    /**
	     * Add a file to the zip file, or search a file.
	     * @param   {string|RegExp} name The name of the file to add (if data is defined),
	     * the name of the file to find (if no data) or a regex to match files.
	     * @param   {String|ArrayBuffer|Uint8Array|Buffer} data  The file data, either raw or base64 encoded
	     * @param   {Object} o     File options
	     * @return  {JSZip|Object|Array} this JSZip object (when adding a file),
	     * a file (when searching by string) or an array of files (when searching by regex).
	     */
	    file: function(name, data, o) {
	        if (arguments.length === 1) {
	            if (isRegExp(name)) {
	                var regexp = name;
	                return this.filter(function(relativePath, file) {
	                    return !file.dir && regexp.test(relativePath);
	                });
	            }
	            else { // text
	                var obj = this.files[this.root + name];
	                if (obj && !obj.dir) {
	                    return obj;
	                } else {
	                    return null;
	                }
	            }
	        }
	        else { // more than one argument : we have data !
	            name = this.root + name;
	            fileAdd.call(this, name, data, o);
	        }
	        return this;
	    },
	
	    /**
	     * Add a directory to the zip file, or search.
	     * @param   {String|RegExp} arg The name of the directory to add, or a regex to search folders.
	     * @return  {JSZip} an object with the new directory as the root, or an array containing matching folders.
	     */
	    folder: function(arg) {
	        if (!arg) {
	            return this;
	        }
	
	        if (isRegExp(arg)) {
	            return this.filter(function(relativePath, file) {
	                return file.dir && arg.test(relativePath);
	            });
	        }
	
	        // else, name is a new folder
	        var name = this.root + arg;
	        var newFolder = folderAdd.call(this, name);
	
	        // Allow chaining by returning a new object with this folder as the root
	        var ret = this.clone();
	        ret.root = newFolder.name;
	        return ret;
	    },
	
	    /**
	     * Delete a file, or a directory and all sub-files, from the zip
	     * @param {string} name the name of the file to delete
	     * @return {JSZip} this JSZip object
	     */
	    remove: function(name) {
	        name = this.root + name;
	        var file = this.files[name];
	        if (!file) {
	            // Look for any folders
	            if (name.slice(-1) !== "/") {
	                name += "/";
	            }
	            file = this.files[name];
	        }
	
	        if (file && !file.dir) {
	            // file
	            delete this.files[name];
	        } else {
	            // maybe a folder, delete recursively
	            var kids = this.filter(function(relativePath, file) {
	                return file.name.slice(0, name.length) === name;
	            });
	            for (var i = 0; i < kids.length; i++) {
	                delete this.files[kids[i].name];
	            }
	        }
	
	        return this;
	    },
	
	    /**
	     * @deprecated This method has been removed in JSZip 3.0, please check the upgrade guide.
	     */
	    generate: function() {
	        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
	    },
	
	    /**
	     * Generate the complete zip file as an internal stream.
	     * @param {Object} options the options to generate the zip file :
	     * - compression, "STORE" by default.
	     * - type, "base64" by default. Values are : string, base64, uint8array, arraybuffer, blob.
	     * @return {StreamHelper} the streamed zip file.
	     */
	    generateInternalStream: function(options) {
	        var worker, opts = {};
	        try {
	            opts = utils.extend(options || {}, {
	                streamFiles: false,
	                compression: "STORE",
	                compressionOptions : null,
	                type: "",
	                platform: "DOS",
	                comment: null,
	                mimeType: "application/zip",
	                encodeFileName: utf8.utf8encode
	            });
	
	            opts.type = opts.type.toLowerCase();
	            opts.compression = opts.compression.toUpperCase();
	
	            // "binarystring" is preferred but the internals use "string".
	            if(opts.type === "binarystring") {
	                opts.type = "string";
	            }
	
	            if (!opts.type) {
	                throw new Error("No output type specified.");
	            }
	
	            utils.checkSupport(opts.type);
	
	            // accept nodejs `process.platform`
	            if(
	                opts.platform === "darwin" ||
	                opts.platform === "freebsd" ||
	                opts.platform === "linux" ||
	                opts.platform === "sunos"
	            ) {
	                opts.platform = "UNIX";
	            }
	            if (opts.platform === "win32") {
	                opts.platform = "DOS";
	            }
	
	            var comment = opts.comment || this.comment || "";
	            worker = generate.generateWorker(this, opts, comment);
	        } catch (e) {
	            worker = new GenericWorker("error");
	            worker.error(e);
	        }
	        return new StreamHelper(worker, opts.type || "string", opts.mimeType);
	    },
	    /**
	     * Generate the complete zip file asynchronously.
	     * @see generateInternalStream
	     */
	    generateAsync: function(options, onUpdate) {
	        return this.generateInternalStream(options).accumulate(onUpdate);
	    },
	    /**
	     * Generate the complete zip file asynchronously.
	     * @see generateInternalStream
	     */
	    generateNodeStream: function(options, onUpdate) {
	        options = options || {};
	        if (!options.type) {
	            options.type = "nodebuffer";
	        }
	        return this.generateInternalStream(options).toNodejsStream(onUpdate);
	    }
	};
	module.exports = out;


/***/ },
/* 1331 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var Uint8ArrayReader = __webpack_require__(446);
	var utils = __webpack_require__(42);
	
	function NodeBufferReader(data) {
	    Uint8ArrayReader.call(this, data);
	}
	utils.inherits(NodeBufferReader, Uint8ArrayReader);
	
	/**
	 * @see DataReader.readData
	 */
	NodeBufferReader.prototype.readData = function(size) {
	    this.checkOffset(size);
	    var result = this.data.slice(this.zero + this.index, this.zero + this.index + size);
	    this.index += size;
	    return result;
	};
	module.exports = NodeBufferReader;


/***/ },
/* 1332 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var DataReader = __webpack_require__(445);
	var utils = __webpack_require__(42);
	
	function StringReader(data) {
	    DataReader.call(this, data);
	}
	utils.inherits(StringReader, DataReader);
	/**
	 * @see DataReader.byteAt
	 */
	StringReader.prototype.byteAt = function(i) {
	    return this.data.charCodeAt(this.zero + i);
	};
	/**
	 * @see DataReader.lastIndexOfSignature
	 */
	StringReader.prototype.lastIndexOfSignature = function(sig) {
	    return this.data.lastIndexOf(sig) - this.zero;
	};
	/**
	 * @see DataReader.readAndCheckSignature
	 */
	StringReader.prototype.readAndCheckSignature = function (sig) {
	    var data = this.readData(4);
	    return sig === data;
	};
	/**
	 * @see DataReader.readData
	 */
	StringReader.prototype.readData = function(size) {
	    this.checkOffset(size);
	    // this will work because the constructor applied the "& 0xff" mask.
	    var result = this.data.slice(this.zero + this.index, this.zero + this.index + size);
	    this.index += size;
	    return result;
	};
	module.exports = StringReader;


/***/ },
/* 1333 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var GenericWorker = __webpack_require__(72);
	var utils = __webpack_require__(42);
	
	/**
	 * A worker which convert chunks to a specified type.
	 * @constructor
	 * @param {String} destType the destination type.
	 */
	function ConvertWorker(destType) {
	    GenericWorker.call(this, "ConvertWorker to " + destType);
	    this.destType = destType;
	}
	utils.inherits(ConvertWorker, GenericWorker);
	
	/**
	 * @see GenericWorker.processChunk
	 */
	ConvertWorker.prototype.processChunk = function (chunk) {
	    this.push({
	        data : utils.transformTo(this.destType, chunk.data),
	        meta : chunk.meta
	    });
	};
	module.exports = ConvertWorker;


/***/ },
/* 1334 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var utils = __webpack_require__(42);
	var GenericWorker = __webpack_require__(72);
	
	/**
	 * A worker which calculate the total length of the data flowing through.
	 * @constructor
	 * @param {String} propName the name used to expose the length
	 */
	function DataLengthProbe(propName) {
	    GenericWorker.call(this, "DataLengthProbe for " + propName);
	    this.propName = propName;
	    this.withStreamInfo(propName, 0);
	}
	utils.inherits(DataLengthProbe, GenericWorker);
	
	/**
	 * @see GenericWorker.processChunk
	 */
	DataLengthProbe.prototype.processChunk = function (chunk) {
	    if(chunk) {
	        var length = this.streamInfo[this.propName] || 0;
	        this.streamInfo[this.propName] = length + chunk.data.length;
	    }
	    GenericWorker.prototype.processChunk.call(this, chunk);
	};
	module.exports = DataLengthProbe;
	


/***/ },
/* 1335 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var readerFor = __webpack_require__(447);
	var utils = __webpack_require__(42);
	var sig = __webpack_require__(448);
	var ZipEntry = __webpack_require__(1336);
	var support = __webpack_require__(98);
	//  class ZipEntries {{{
	/**
	 * All the entries in the zip file.
	 * @constructor
	 * @param {Object} loadOptions Options for loading the stream.
	 */
	function ZipEntries(loadOptions) {
	    this.files = [];
	    this.loadOptions = loadOptions;
	}
	ZipEntries.prototype = {
	    /**
	     * Check that the reader is on the specified signature.
	     * @param {string} expectedSignature the expected signature.
	     * @throws {Error} if it is an other signature.
	     */
	    checkSignature: function(expectedSignature) {
	        if (!this.reader.readAndCheckSignature(expectedSignature)) {
	            this.reader.index -= 4;
	            var signature = this.reader.readString(4);
	            throw new Error("Corrupted zip or bug: unexpected signature " + "(" + utils.pretty(signature) + ", expected " + utils.pretty(expectedSignature) + ")");
	        }
	    },
	    /**
	     * Check if the given signature is at the given index.
	     * @param {number} askedIndex the index to check.
	     * @param {string} expectedSignature the signature to expect.
	     * @return {boolean} true if the signature is here, false otherwise.
	     */
	    isSignature: function(askedIndex, expectedSignature) {
	        var currentIndex = this.reader.index;
	        this.reader.setIndex(askedIndex);
	        var signature = this.reader.readString(4);
	        var result = signature === expectedSignature;
	        this.reader.setIndex(currentIndex);
	        return result;
	    },
	    /**
	     * Read the end of the central directory.
	     */
	    readBlockEndOfCentral: function() {
	        this.diskNumber = this.reader.readInt(2);
	        this.diskWithCentralDirStart = this.reader.readInt(2);
	        this.centralDirRecordsOnThisDisk = this.reader.readInt(2);
	        this.centralDirRecords = this.reader.readInt(2);
	        this.centralDirSize = this.reader.readInt(4);
	        this.centralDirOffset = this.reader.readInt(4);
	
	        this.zipCommentLength = this.reader.readInt(2);
	        // warning : the encoding depends of the system locale
	        // On a linux machine with LANG=en_US.utf8, this field is utf8 encoded.
	        // On a windows machine, this field is encoded with the localized windows code page.
	        var zipComment = this.reader.readData(this.zipCommentLength);
	        var decodeParamType = support.uint8array ? "uint8array" : "array";
	        // To get consistent behavior with the generation part, we will assume that
	        // this is utf8 encoded unless specified otherwise.
	        var decodeContent = utils.transformTo(decodeParamType, zipComment);
	        this.zipComment = this.loadOptions.decodeFileName(decodeContent);
	    },
	    /**
	     * Read the end of the Zip 64 central directory.
	     * Not merged with the method readEndOfCentral :
	     * The end of central can coexist with its Zip64 brother,
	     * I don't want to read the wrong number of bytes !
	     */
	    readBlockZip64EndOfCentral: function() {
	        this.zip64EndOfCentralSize = this.reader.readInt(8);
	        this.reader.skip(4);
	        // this.versionMadeBy = this.reader.readString(2);
	        // this.versionNeeded = this.reader.readInt(2);
	        this.diskNumber = this.reader.readInt(4);
	        this.diskWithCentralDirStart = this.reader.readInt(4);
	        this.centralDirRecordsOnThisDisk = this.reader.readInt(8);
	        this.centralDirRecords = this.reader.readInt(8);
	        this.centralDirSize = this.reader.readInt(8);
	        this.centralDirOffset = this.reader.readInt(8);
	
	        this.zip64ExtensibleData = {};
	        var extraDataSize = this.zip64EndOfCentralSize - 44,
	            index = 0,
	            extraFieldId,
	            extraFieldLength,
	            extraFieldValue;
	        while (index < extraDataSize) {
	            extraFieldId = this.reader.readInt(2);
	            extraFieldLength = this.reader.readInt(4);
	            extraFieldValue = this.reader.readData(extraFieldLength);
	            this.zip64ExtensibleData[extraFieldId] = {
	                id: extraFieldId,
	                length: extraFieldLength,
	                value: extraFieldValue
	            };
	        }
	    },
	    /**
	     * Read the end of the Zip 64 central directory locator.
	     */
	    readBlockZip64EndOfCentralLocator: function() {
	        this.diskWithZip64CentralDirStart = this.reader.readInt(4);
	        this.relativeOffsetEndOfZip64CentralDir = this.reader.readInt(8);
	        this.disksCount = this.reader.readInt(4);
	        if (this.disksCount > 1) {
	            throw new Error("Multi-volumes zip are not supported");
	        }
	    },
	    /**
	     * Read the local files, based on the offset read in the central part.
	     */
	    readLocalFiles: function() {
	        var i, file;
	        for (i = 0; i < this.files.length; i++) {
	            file = this.files[i];
	            this.reader.setIndex(file.localHeaderOffset);
	            this.checkSignature(sig.LOCAL_FILE_HEADER);
	            file.readLocalPart(this.reader);
	            file.handleUTF8();
	            file.processAttributes();
	        }
	    },
	    /**
	     * Read the central directory.
	     */
	    readCentralDir: function() {
	        var file;
	
	        this.reader.setIndex(this.centralDirOffset);
	        while (this.reader.readAndCheckSignature(sig.CENTRAL_FILE_HEADER)) {
	            file = new ZipEntry({
	                zip64: this.zip64
	            }, this.loadOptions);
	            file.readCentralPart(this.reader);
	            this.files.push(file);
	        }
	
	        if (this.centralDirRecords !== this.files.length) {
	            if (this.centralDirRecords !== 0 && this.files.length === 0) {
	                // We expected some records but couldn't find ANY.
	                // This is really suspicious, as if something went wrong.
	                throw new Error("Corrupted zip or bug: expected " + this.centralDirRecords + " records in central dir, got " + this.files.length);
	            } else {
	                // We found some records but not all.
	                // Something is wrong but we got something for the user: no error here.
	                // console.warn("expected", this.centralDirRecords, "records in central dir, got", this.files.length);
	            }
	        }
	    },
	    /**
	     * Read the end of central directory.
	     */
	    readEndOfCentral: function() {
	        var offset = this.reader.lastIndexOfSignature(sig.CENTRAL_DIRECTORY_END);
	        if (offset < 0) {
	            // Check if the content is a truncated zip or complete garbage.
	            // A "LOCAL_FILE_HEADER" is not required at the beginning (auto
	            // extractible zip for example) but it can give a good hint.
	            // If an ajax request was used without responseType, we will also
	            // get unreadable data.
	            var isGarbage = !this.isSignature(0, sig.LOCAL_FILE_HEADER);
	
	            if (isGarbage) {
	                throw new Error("Can't find end of central directory : is this a zip file ? " +
	                                "If it is, see https://stuk.github.io/jszip/documentation/howto/read_zip.html");
	            } else {
	                throw new Error("Corrupted zip: can't find end of central directory");
	            }
	
	        }
	        this.reader.setIndex(offset);
	        var endOfCentralDirOffset = offset;
	        this.checkSignature(sig.CENTRAL_DIRECTORY_END);
	        this.readBlockEndOfCentral();
	
	
	        /* extract from the zip spec :
	            4)  If one of the fields in the end of central directory
	                record is too small to hold required data, the field
	                should be set to -1 (0xFFFF or 0xFFFFFFFF) and the
	                ZIP64 format record should be created.
	            5)  The end of central directory record and the
	                Zip64 end of central directory locator record must
	                reside on the same disk when splitting or spanning
	                an archive.
	         */
	        if (this.diskNumber === utils.MAX_VALUE_16BITS || this.diskWithCentralDirStart === utils.MAX_VALUE_16BITS || this.centralDirRecordsOnThisDisk === utils.MAX_VALUE_16BITS || this.centralDirRecords === utils.MAX_VALUE_16BITS || this.centralDirSize === utils.MAX_VALUE_32BITS || this.centralDirOffset === utils.MAX_VALUE_32BITS) {
	            this.zip64 = true;
	
	            /*
	            Warning : the zip64 extension is supported, but ONLY if the 64bits integer read from
	            the zip file can fit into a 32bits integer. This cannot be solved : JavaScript represents
	            all numbers as 64-bit double precision IEEE 754 floating point numbers.
	            So, we have 53bits for integers and bitwise operations treat everything as 32bits.
	            see https://developer.mozilla.org/en-US/docs/JavaScript/Reference/Operators/Bitwise_Operators
	            and http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-262.pdf section 8.5
	            */
	
	            // should look for a zip64 EOCD locator
	            offset = this.reader.lastIndexOfSignature(sig.ZIP64_CENTRAL_DIRECTORY_LOCATOR);
	            if (offset < 0) {
	                throw new Error("Corrupted zip: can't find the ZIP64 end of central directory locator");
	            }
	            this.reader.setIndex(offset);
	            this.checkSignature(sig.ZIP64_CENTRAL_DIRECTORY_LOCATOR);
	            this.readBlockZip64EndOfCentralLocator();
	
	            // now the zip64 EOCD record
	            if (!this.isSignature(this.relativeOffsetEndOfZip64CentralDir, sig.ZIP64_CENTRAL_DIRECTORY_END)) {
	                // console.warn("ZIP64 end of central directory not where expected.");
	                this.relativeOffsetEndOfZip64CentralDir = this.reader.lastIndexOfSignature(sig.ZIP64_CENTRAL_DIRECTORY_END);
	                if (this.relativeOffsetEndOfZip64CentralDir < 0) {
	                    throw new Error("Corrupted zip: can't find the ZIP64 end of central directory");
	                }
	            }
	            this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir);
	            this.checkSignature(sig.ZIP64_CENTRAL_DIRECTORY_END);
	            this.readBlockZip64EndOfCentral();
	        }
	
	        var expectedEndOfCentralDirOffset = this.centralDirOffset + this.centralDirSize;
	        if (this.zip64) {
	            expectedEndOfCentralDirOffset += 20; // end of central dir 64 locator
	            expectedEndOfCentralDirOffset += 12 /* should not include the leading 12 bytes */ + this.zip64EndOfCentralSize;
	        }
	
	        var extraBytes = endOfCentralDirOffset - expectedEndOfCentralDirOffset;
	
	        if (extraBytes > 0) {
	            // console.warn(extraBytes, "extra bytes at beginning or within zipfile");
	            if (this.isSignature(endOfCentralDirOffset, sig.CENTRAL_FILE_HEADER)) {
	                // The offsets seem wrong, but we have something at the specified offset.
	                // So… we keep it.
	            } else {
	                // the offset is wrong, update the "zero" of the reader
	                // this happens if data has been prepended (crx files for example)
	                this.reader.zero = extraBytes;
	            }
	        } else if (extraBytes < 0) {
	            throw new Error("Corrupted zip: missing " + Math.abs(extraBytes) + " bytes.");
	        }
	    },
	    prepareReader: function(data) {
	        this.reader = readerFor(data);
	    },
	    /**
	     * Read a zip file and create ZipEntries.
	     * @param {String|ArrayBuffer|Uint8Array|Buffer} data the binary string representing a zip file.
	     */
	    load: function(data) {
	        this.prepareReader(data);
	        this.readEndOfCentral();
	        this.readCentralDir();
	        this.readLocalFiles();
	    }
	};
	// }}} end of ZipEntries
	module.exports = ZipEntries;


/***/ },
/* 1336 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var readerFor = __webpack_require__(447);
	var utils = __webpack_require__(42);
	var CompressedObject = __webpack_require__(275);
	var crc32fn = __webpack_require__(276);
	var utf8 = __webpack_require__(160);
	var compressions = __webpack_require__(441);
	var support = __webpack_require__(98);
	
	var MADE_BY_DOS = 0x00;
	var MADE_BY_UNIX = 0x03;
	
	/**
	 * Find a compression registered in JSZip.
	 * @param {string} compressionMethod the method magic to find.
	 * @return {Object|null} the JSZip compression object, null if none found.
	 */
	var findCompression = function(compressionMethod) {
	    for (var method in compressions) {
	        if (!Object.prototype.hasOwnProperty.call(compressions, method)) {
	            continue;
	        }
	        if (compressions[method].magic === compressionMethod) {
	            return compressions[method];
	        }
	    }
	    return null;
	};
	
	// class ZipEntry {{{
	/**
	 * An entry in the zip file.
	 * @constructor
	 * @param {Object} options Options of the current file.
	 * @param {Object} loadOptions Options for loading the stream.
	 */
	function ZipEntry(options, loadOptions) {
	    this.options = options;
	    this.loadOptions = loadOptions;
	}
	ZipEntry.prototype = {
	    /**
	     * say if the file is encrypted.
	     * @return {boolean} true if the file is encrypted, false otherwise.
	     */
	    isEncrypted: function() {
	        // bit 1 is set
	        return (this.bitFlag & 0x0001) === 0x0001;
	    },
	    /**
	     * say if the file has utf-8 filename/comment.
	     * @return {boolean} true if the filename/comment is in utf-8, false otherwise.
	     */
	    useUTF8: function() {
	        // bit 11 is set
	        return (this.bitFlag & 0x0800) === 0x0800;
	    },
	    /**
	     * Read the local part of a zip file and add the info in this object.
	     * @param {DataReader} reader the reader to use.
	     */
	    readLocalPart: function(reader) {
	        var compression, localExtraFieldsLength;
	
	        // we already know everything from the central dir !
	        // If the central dir data are false, we are doomed.
	        // On the bright side, the local part is scary  : zip64, data descriptors, both, etc.
	        // The less data we get here, the more reliable this should be.
	        // Let's skip the whole header and dash to the data !
	        reader.skip(22);
	        // in some zip created on windows, the filename stored in the central dir contains \ instead of /.
	        // Strangely, the filename here is OK.
	        // I would love to treat these zip files as corrupted (see http://www.info-zip.org/FAQ.html#backslashes
	        // or APPNOTE#4.4.17.1, "All slashes MUST be forward slashes '/'") but there are a lot of bad zip generators...
	        // Search "unzip mismatching "local" filename continuing with "central" filename version" on
	        // the internet.
	        //
	        // I think I see the logic here : the central directory is used to display
	        // content and the local directory is used to extract the files. Mixing / and \
	        // may be used to display \ to windows users and use / when extracting the files.
	        // Unfortunately, this lead also to some issues : http://seclists.org/fulldisclosure/2009/Sep/394
	        this.fileNameLength = reader.readInt(2);
	        localExtraFieldsLength = reader.readInt(2); // can't be sure this will be the same as the central dir
	        // the fileName is stored as binary data, the handleUTF8 method will take care of the encoding.
	        this.fileName = reader.readData(this.fileNameLength);
	        reader.skip(localExtraFieldsLength);
	
	        if (this.compressedSize === -1 || this.uncompressedSize === -1) {
	            throw new Error("Bug or corrupted zip : didn't get enough information from the central directory " + "(compressedSize === -1 || uncompressedSize === -1)");
	        }
	
	        compression = findCompression(this.compressionMethod);
	        if (compression === null) { // no compression found
	            throw new Error("Corrupted zip : compression " + utils.pretty(this.compressionMethod) + " unknown (inner file : " + utils.transformTo("string", this.fileName) + ")");
	        }
	        this.decompressed = new CompressedObject(this.compressedSize, this.uncompressedSize, this.crc32, compression, reader.readData(this.compressedSize));
	    },
	
	    /**
	     * Read the central part of a zip file and add the info in this object.
	     * @param {DataReader} reader the reader to use.
	     */
	    readCentralPart: function(reader) {
	        this.versionMadeBy = reader.readInt(2);
	        reader.skip(2);
	        // this.versionNeeded = reader.readInt(2);
	        this.bitFlag = reader.readInt(2);
	        this.compressionMethod = reader.readString(2);
	        this.date = reader.readDate();
	        this.crc32 = reader.readInt(4);
	        this.compressedSize = reader.readInt(4);
	        this.uncompressedSize = reader.readInt(4);
	        var fileNameLength = reader.readInt(2);
	        this.extraFieldsLength = reader.readInt(2);
	        this.fileCommentLength = reader.readInt(2);
	        this.diskNumberStart = reader.readInt(2);
	        this.internalFileAttributes = reader.readInt(2);
	        this.externalFileAttributes = reader.readInt(4);
	        this.localHeaderOffset = reader.readInt(4);
	
	        if (this.isEncrypted()) {
	            throw new Error("Encrypted zip are not supported");
	        }
	
	        // will be read in the local part, see the comments there
	        reader.skip(fileNameLength);
	        this.readExtraFields(reader);
	        this.parseZIP64ExtraField(reader);
	        this.fileComment = reader.readData(this.fileCommentLength);
	    },
	
	    /**
	     * Parse the external file attributes and get the unix/dos permissions.
	     */
	    processAttributes: function () {
	        this.unixPermissions = null;
	        this.dosPermissions = null;
	        var madeBy = this.versionMadeBy >> 8;
	
	        // Check if we have the DOS directory flag set.
	        // We look for it in the DOS and UNIX permissions
	        // but some unknown platform could set it as a compatibility flag.
	        this.dir = this.externalFileAttributes & 0x0010 ? true : false;
	
	        if(madeBy === MADE_BY_DOS) {
	            // first 6 bits (0 to 5)
	            this.dosPermissions = this.externalFileAttributes & 0x3F;
	        }
	
	        if(madeBy === MADE_BY_UNIX) {
	            this.unixPermissions = (this.externalFileAttributes >> 16) & 0xFFFF;
	            // the octal permissions are in (this.unixPermissions & 0x01FF).toString(8);
	        }
	
	        // fail safe : if the name ends with a / it probably means a folder
	        if (!this.dir && this.fileNameStr.slice(-1) === "/") {
	            this.dir = true;
	        }
	    },
	
	    /**
	     * Parse the ZIP64 extra field and merge the info in the current ZipEntry.
	     * @param {DataReader} reader the reader to use.
	     */
	    parseZIP64ExtraField: function() {
	        if (!this.extraFields[0x0001]) {
	            return;
	        }
	
	        // should be something, preparing the extra reader
	        var extraReader = readerFor(this.extraFields[0x0001].value);
	
	        // I really hope that these 64bits integer can fit in 32 bits integer, because js
	        // won't let us have more.
	        if (this.uncompressedSize === utils.MAX_VALUE_32BITS) {
	            this.uncompressedSize = extraReader.readInt(8);
	        }
	        if (this.compressedSize === utils.MAX_VALUE_32BITS) {
	            this.compressedSize = extraReader.readInt(8);
	        }
	        if (this.localHeaderOffset === utils.MAX_VALUE_32BITS) {
	            this.localHeaderOffset = extraReader.readInt(8);
	        }
	        if (this.diskNumberStart === utils.MAX_VALUE_32BITS) {
	            this.diskNumberStart = extraReader.readInt(4);
	        }
	    },
	    /**
	     * Read the central part of a zip file and add the info in this object.
	     * @param {DataReader} reader the reader to use.
	     */
	    readExtraFields: function(reader) {
	        var end = reader.index + this.extraFieldsLength,
	            extraFieldId,
	            extraFieldLength,
	            extraFieldValue;
	
	        if (!this.extraFields) {
	            this.extraFields = {};
	        }
	
	        while (reader.index + 4 < end) {
	            extraFieldId = reader.readInt(2);
	            extraFieldLength = reader.readInt(2);
	            extraFieldValue = reader.readData(extraFieldLength);
	
	            this.extraFields[extraFieldId] = {
	                id: extraFieldId,
	                length: extraFieldLength,
	                value: extraFieldValue
	            };
	        }
	
	        reader.setIndex(end);
	    },
	    /**
	     * Apply an UTF8 transformation if needed.
	     */
	    handleUTF8: function() {
	        var decodeParamType = support.uint8array ? "uint8array" : "array";
	        if (this.useUTF8()) {
	            this.fileNameStr = utf8.utf8decode(this.fileName);
	            this.fileCommentStr = utf8.utf8decode(this.fileComment);
	        } else {
	            var upath = this.findExtraFieldUnicodePath();
	            if (upath !== null) {
	                this.fileNameStr = upath;
	            } else {
	                // ASCII text or unsupported code page
	                var fileNameByteArray =  utils.transformTo(decodeParamType, this.fileName);
	                this.fileNameStr = this.loadOptions.decodeFileName(fileNameByteArray);
	            }
	
	            var ucomment = this.findExtraFieldUnicodeComment();
	            if (ucomment !== null) {
	                this.fileCommentStr = ucomment;
	            } else {
	                // ASCII text or unsupported code page
	                var commentByteArray =  utils.transformTo(decodeParamType, this.fileComment);
	                this.fileCommentStr = this.loadOptions.decodeFileName(commentByteArray);
	            }
	        }
	    },
	
	    /**
	     * Find the unicode path declared in the extra field, if any.
	     * @return {String} the unicode path, null otherwise.
	     */
	    findExtraFieldUnicodePath: function() {
	        var upathField = this.extraFields[0x7075];
	        if (upathField) {
	            var extraReader = readerFor(upathField.value);
	
	            // wrong version
	            if (extraReader.readInt(1) !== 1) {
	                return null;
	            }
	
	            // the crc of the filename changed, this field is out of date.
	            if (crc32fn(this.fileName) !== extraReader.readInt(4)) {
	                return null;
	            }
	
	            return utf8.utf8decode(extraReader.readData(upathField.length - 5));
	        }
	        return null;
	    },
	
	    /**
	     * Find the unicode comment declared in the extra field, if any.
	     * @return {String} the unicode comment, null otherwise.
	     */
	    findExtraFieldUnicodeComment: function() {
	        var ucommentField = this.extraFields[0x6375];
	        if (ucommentField) {
	            var extraReader = readerFor(ucommentField.value);
	
	            // wrong version
	            if (extraReader.readInt(1) !== 1) {
	                return null;
	            }
	
	            // the crc of the comment changed, this field is out of date.
	            if (crc32fn(this.fileComment) !== extraReader.readInt(4)) {
	                return null;
	            }
	
	            return utf8.utf8decode(extraReader.readData(ucommentField.length - 5));
	        }
	        return null;
	    }
	};
	module.exports = ZipEntry;


/***/ },
/* 1337 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var StreamHelper = __webpack_require__(451);
	var DataWorker = __webpack_require__(450);
	var utf8 = __webpack_require__(160);
	var CompressedObject = __webpack_require__(275);
	var GenericWorker = __webpack_require__(72);
	
	/**
	 * A simple object representing a file in the zip file.
	 * @constructor
	 * @param {string} name the name of the file
	 * @param {String|ArrayBuffer|Uint8Array|Buffer} data the data
	 * @param {Object} options the options of the file
	 */
	var ZipObject = function(name, data, options) {
	    this.name = name;
	    this.dir = options.dir;
	    this.date = options.date;
	    this.comment = options.comment;
	    this.unixPermissions = options.unixPermissions;
	    this.dosPermissions = options.dosPermissions;
	
	    this._data = data;
	    this._dataBinary = options.binary;
	    // keep only the compression
	    this.options = {
	        compression : options.compression,
	        compressionOptions : options.compressionOptions
	    };
	};
	
	ZipObject.prototype = {
	    /**
	     * Create an internal stream for the content of this object.
	     * @param {String} type the type of each chunk.
	     * @return StreamHelper the stream.
	     */
	    internalStream: function (type) {
	        var result = null, outputType = "string";
	        try {
	            if (!type) {
	                throw new Error("No output type specified.");
	            }
	            outputType = type.toLowerCase();
	            var askUnicodeString = outputType === "string" || outputType === "text";
	            if (outputType === "binarystring" || outputType === "text") {
	                outputType = "string";
	            }
	            result = this._decompressWorker();
	
	            var isUnicodeString = !this._dataBinary;
	
	            if (isUnicodeString && !askUnicodeString) {
	                result = result.pipe(new utf8.Utf8EncodeWorker());
	            }
	            if (!isUnicodeString && askUnicodeString) {
	                result = result.pipe(new utf8.Utf8DecodeWorker());
	            }
	        } catch (e) {
	            result = new GenericWorker("error");
	            result.error(e);
	        }
	
	        return new StreamHelper(result, outputType, "");
	    },
	
	    /**
	     * Prepare the content in the asked type.
	     * @param {String} type the type of the result.
	     * @param {Function} onUpdate a function to call on each internal update.
	     * @return Promise the promise of the result.
	     */
	    async: function (type, onUpdate) {
	        return this.internalStream(type).accumulate(onUpdate);
	    },
	
	    /**
	     * Prepare the content as a nodejs stream.
	     * @param {String} type the type of each chunk.
	     * @param {Function} onUpdate a function to call on each internal update.
	     * @return Stream the stream.
	     */
	    nodeStream: function (type, onUpdate) {
	        return this.internalStream(type || "nodebuffer").toNodejsStream(onUpdate);
	    },
	
	    /**
	     * Return a worker for the compressed content.
	     * @private
	     * @param {Object} compression the compression object to use.
	     * @param {Object} compressionOptions the options to use when compressing.
	     * @return Worker the worker.
	     */
	    _compressWorker: function (compression, compressionOptions) {
	        if (
	            this._data instanceof CompressedObject &&
	            this._data.compression.magic === compression.magic
	        ) {
	            return this._data.getCompressedWorker();
	        } else {
	            var result = this._decompressWorker();
	            if(!this._dataBinary) {
	                result = result.pipe(new utf8.Utf8EncodeWorker());
	            }
	            return CompressedObject.createWorkerFrom(result, compression, compressionOptions);
	        }
	    },
	    /**
	     * Return a worker for the decompressed content.
	     * @private
	     * @return Worker the worker.
	     */
	    _decompressWorker : function () {
	        if (this._data instanceof CompressedObject) {
	            return this._data.getContentWorker();
	        } else if (this._data instanceof GenericWorker) {
	            return this._data;
	        } else {
	            return new DataWorker(this._data);
	        }
	    }
	};
	
	var removedMethods = ["asText", "asBinary", "asNodeBuffer", "asUint8Array", "asArrayBuffer"];
	var removedFn = function () {
	    throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
	};
	
	for(var i = 0; i < removedMethods.length; i++) {
	    ZipObject.prototype[removedMethods[i]] = removedFn;
	}
	module.exports = ZipObject;


/***/ },
/* 1338 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var immediate = __webpack_require__(1307);
	
	/* istanbul ignore next */
	function INTERNAL() {}
	
	var handlers = {};
	
	var REJECTED = ['REJECTED'];
	var FULFILLED = ['FULFILLED'];
	var PENDING = ['PENDING'];
	
	module.exports = Promise;
	
	function Promise(resolver) {
	  if (typeof resolver !== 'function') {
	    throw new TypeError('resolver must be a function');
	  }
	  this.state = PENDING;
	  this.queue = [];
	  this.outcome = void 0;
	  if (resolver !== INTERNAL) {
	    safelyResolveThenable(this, resolver);
	  }
	}
	
	Promise.prototype["finally"] = function (callback) {
	  if (typeof callback !== 'function') {
	    return this;
	  }
	  var p = this.constructor;
	  return this.then(resolve, reject);
	
	  function resolve(value) {
	    function yes () {
	      return value;
	    }
	    return p.resolve(callback()).then(yes);
	  }
	  function reject(reason) {
	    function no () {
	      throw reason;
	    }
	    return p.resolve(callback()).then(no);
	  }
	};
	Promise.prototype["catch"] = function (onRejected) {
	  return this.then(null, onRejected);
	};
	Promise.prototype.then = function (onFulfilled, onRejected) {
	  if (typeof onFulfilled !== 'function' && this.state === FULFILLED ||
	    typeof onRejected !== 'function' && this.state === REJECTED) {
	    return this;
	  }
	  var promise = new this.constructor(INTERNAL);
	  if (this.state !== PENDING) {
	    var resolver = this.state === FULFILLED ? onFulfilled : onRejected;
	    unwrap(promise, resolver, this.outcome);
	  } else {
	    this.queue.push(new QueueItem(promise, onFulfilled, onRejected));
	  }
	
	  return promise;
	};
	function QueueItem(promise, onFulfilled, onRejected) {
	  this.promise = promise;
	  if (typeof onFulfilled === 'function') {
	    this.onFulfilled = onFulfilled;
	    this.callFulfilled = this.otherCallFulfilled;
	  }
	  if (typeof onRejected === 'function') {
	    this.onRejected = onRejected;
	    this.callRejected = this.otherCallRejected;
	  }
	}
	QueueItem.prototype.callFulfilled = function (value) {
	  handlers.resolve(this.promise, value);
	};
	QueueItem.prototype.otherCallFulfilled = function (value) {
	  unwrap(this.promise, this.onFulfilled, value);
	};
	QueueItem.prototype.callRejected = function (value) {
	  handlers.reject(this.promise, value);
	};
	QueueItem.prototype.otherCallRejected = function (value) {
	  unwrap(this.promise, this.onRejected, value);
	};
	
	function unwrap(promise, func, value) {
	  immediate(function () {
	    var returnValue;
	    try {
	      returnValue = func(value);
	    } catch (e) {
	      return handlers.reject(promise, e);
	    }
	    if (returnValue === promise) {
	      handlers.reject(promise, new TypeError('Cannot resolve promise with itself'));
	    } else {
	      handlers.resolve(promise, returnValue);
	    }
	  });
	}
	
	handlers.resolve = function (self, value) {
	  var result = tryCatch(getThen, value);
	  if (result.status === 'error') {
	    return handlers.reject(self, result.value);
	  }
	  var thenable = result.value;
	
	  if (thenable) {
	    safelyResolveThenable(self, thenable);
	  } else {
	    self.state = FULFILLED;
	    self.outcome = value;
	    var i = -1;
	    var len = self.queue.length;
	    while (++i < len) {
	      self.queue[i].callFulfilled(value);
	    }
	  }
	  return self;
	};
	handlers.reject = function (self, error) {
	  self.state = REJECTED;
	  self.outcome = error;
	  var i = -1;
	  var len = self.queue.length;
	  while (++i < len) {
	    self.queue[i].callRejected(error);
	  }
	  return self;
	};
	
	function getThen(obj) {
	  // Make sure we only access the accessor once as required by the spec
	  var then = obj && obj.then;
	  if (obj && (typeof obj === 'object' || typeof obj === 'function') && typeof then === 'function') {
	    return function appyThen() {
	      then.apply(obj, arguments);
	    };
	  }
	}
	
	function safelyResolveThenable(self, thenable) {
	  // Either fulfill, reject or reject with error
	  var called = false;
	  function onError(value) {
	    if (called) {
	      return;
	    }
	    called = true;
	    handlers.reject(self, value);
	  }
	
	  function onSuccess(value) {
	    if (called) {
	      return;
	    }
	    called = true;
	    handlers.resolve(self, value);
	  }
	
	  function tryToUnwrap() {
	    thenable(onSuccess, onError);
	  }
	
	  var result = tryCatch(tryToUnwrap);
	  if (result.status === 'error') {
	    onError(result.value);
	  }
	}
	
	function tryCatch(func, value) {
	  var out = {};
	  try {
	    out.value = func(value);
	    out.status = 'success';
	  } catch (e) {
	    out.status = 'error';
	    out.value = e;
	  }
	  return out;
	}
	
	Promise.resolve = resolve;
	function resolve(value) {
	  if (value instanceof this) {
	    return value;
	  }
	  return handlers.resolve(new this(INTERNAL), value);
	}
	
	Promise.reject = reject;
	function reject(reason) {
	  var promise = new this(INTERNAL);
	  return handlers.reject(promise, reason);
	}
	
	Promise.all = all;
	function all(iterable) {
	  var self = this;
	  if (Object.prototype.toString.call(iterable) !== '[object Array]') {
	    return this.reject(new TypeError('must be an array'));
	  }
	
	  var len = iterable.length;
	  var called = false;
	  if (!len) {
	    return this.resolve([]);
	  }
	
	  var values = new Array(len);
	  var resolved = 0;
	  var i = -1;
	  var promise = new this(INTERNAL);
	
	  while (++i < len) {
	    allResolver(iterable[i], i);
	  }
	  return promise;
	  function allResolver(value, i) {
	    self.resolve(value).then(resolveFromAll, function (error) {
	      if (!called) {
	        called = true;
	        handlers.reject(promise, error);
	      }
	    });
	    function resolveFromAll(outValue) {
	      values[i] = outValue;
	      if (++resolved === len && !called) {
	        called = true;
	        handlers.resolve(promise, values);
	      }
	    }
	  }
	}
	
	Promise.race = race;
	function race(iterable) {
	  var self = this;
	  if (Object.prototype.toString.call(iterable) !== '[object Array]') {
	    return this.reject(new TypeError('must be an array'));
	  }
	
	  var len = iterable.length;
	  var called = false;
	  if (!len) {
	    return this.resolve([]);
	  }
	
	  var i = -1;
	  var promise = new this(INTERNAL);
	
	  while (++i < len) {
	    resolver(iterable[i]);
	  }
	  return promise;
	  function resolver(value) {
	    self.resolve(value).then(function (response) {
	      if (!called) {
	        called = true;
	        handlers.resolve(promise, response);
	      }
	    }, function (error) {
	      if (!called) {
	        called = true;
	        handlers.reject(promise, error);
	      }
	    });
	  }
	}


/***/ },
/* 1339 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./abs')} */
	module.exports = Math.abs;


/***/ },
/* 1340 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./floor')} */
	module.exports = Math.floor;


/***/ },
/* 1341 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./isNaN')} */
	module.exports = Number.isNaN || function isNaN(a) {
		return a !== a;
	};


/***/ },
/* 1342 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./max')} */
	module.exports = Math.max;


/***/ },
/* 1343 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./min')} */
	module.exports = Math.min;


/***/ },
/* 1344 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./pow')} */
	module.exports = Math.pow;


/***/ },
/* 1345 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./round')} */
	module.exports = Math.round;


/***/ },
/* 1346 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var $isNaN = __webpack_require__(1341);
	
	/** @type {import('./sign')} */
	module.exports = function sign(number) {
		if ($isNaN(number) || number === 0) {
			return number;
		}
		return number < 0 ? -1 : +1;
	};


/***/ },
/* 1347 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./af": 453,
		"./af.js": 453,
		"./ar": 461,
		"./ar-dz": 454,
		"./ar-dz.js": 454,
		"./ar-kw": 455,
		"./ar-kw.js": 455,
		"./ar-ly": 456,
		"./ar-ly.js": 456,
		"./ar-ma": 457,
		"./ar-ma.js": 457,
		"./ar-ps": 458,
		"./ar-ps.js": 458,
		"./ar-sa": 459,
		"./ar-sa.js": 459,
		"./ar-tn": 460,
		"./ar-tn.js": 460,
		"./ar.js": 461,
		"./az": 462,
		"./az.js": 462,
		"./be": 463,
		"./be.js": 463,
		"./bg": 464,
		"./bg.js": 464,
		"./bm": 465,
		"./bm.js": 465,
		"./bn": 467,
		"./bn-bd": 466,
		"./bn-bd.js": 466,
		"./bn.js": 467,
		"./bo": 468,
		"./bo.js": 468,
		"./br": 469,
		"./br.js": 469,
		"./bs": 470,
		"./bs.js": 470,
		"./ca": 471,
		"./ca.js": 471,
		"./cs": 472,
		"./cs.js": 472,
		"./cv": 473,
		"./cv.js": 473,
		"./cy": 474,
		"./cy.js": 474,
		"./da": 475,
		"./da.js": 475,
		"./de": 478,
		"./de-at": 476,
		"./de-at.js": 476,
		"./de-ch": 477,
		"./de-ch.js": 477,
		"./de.js": 478,
		"./dv": 479,
		"./dv.js": 479,
		"./el": 480,
		"./el.js": 480,
		"./en-au": 481,
		"./en-au.js": 481,
		"./en-ca": 482,
		"./en-ca.js": 482,
		"./en-gb": 483,
		"./en-gb.js": 483,
		"./en-ie": 484,
		"./en-ie.js": 484,
		"./en-il": 485,
		"./en-il.js": 485,
		"./en-in": 486,
		"./en-in.js": 486,
		"./en-nz": 487,
		"./en-nz.js": 487,
		"./en-sg": 488,
		"./en-sg.js": 488,
		"./eo": 489,
		"./eo.js": 489,
		"./es": 493,
		"./es-do": 490,
		"./es-do.js": 490,
		"./es-mx": 491,
		"./es-mx.js": 491,
		"./es-us": 492,
		"./es-us.js": 492,
		"./es.js": 493,
		"./et": 494,
		"./et.js": 494,
		"./eu": 495,
		"./eu.js": 495,
		"./fa": 496,
		"./fa.js": 496,
		"./fi": 497,
		"./fi.js": 497,
		"./fil": 498,
		"./fil.js": 498,
		"./fo": 499,
		"./fo.js": 499,
		"./fr": 502,
		"./fr-ca": 500,
		"./fr-ca.js": 500,
		"./fr-ch": 501,
		"./fr-ch.js": 501,
		"./fr.js": 502,
		"./fy": 503,
		"./fy.js": 503,
		"./ga": 504,
		"./ga.js": 504,
		"./gd": 505,
		"./gd.js": 505,
		"./gl": 506,
		"./gl.js": 506,
		"./gom-deva": 507,
		"./gom-deva.js": 507,
		"./gom-latn": 508,
		"./gom-latn.js": 508,
		"./gu": 509,
		"./gu.js": 509,
		"./he": 510,
		"./he.js": 510,
		"./hi": 511,
		"./hi.js": 511,
		"./hr": 512,
		"./hr.js": 512,
		"./hu": 513,
		"./hu.js": 513,
		"./hy-am": 514,
		"./hy-am.js": 514,
		"./id": 515,
		"./id.js": 515,
		"./is": 516,
		"./is.js": 516,
		"./it": 518,
		"./it-ch": 517,
		"./it-ch.js": 517,
		"./it.js": 518,
		"./ja": 519,
		"./ja.js": 519,
		"./jv": 520,
		"./jv.js": 520,
		"./ka": 521,
		"./ka.js": 521,
		"./kk": 522,
		"./kk.js": 522,
		"./km": 523,
		"./km.js": 523,
		"./kn": 524,
		"./kn.js": 524,
		"./ko": 525,
		"./ko.js": 525,
		"./ku": 527,
		"./ku-kmr": 526,
		"./ku-kmr.js": 526,
		"./ku.js": 527,
		"./ky": 528,
		"./ky.js": 528,
		"./lb": 529,
		"./lb.js": 529,
		"./lo": 530,
		"./lo.js": 530,
		"./lt": 531,
		"./lt.js": 531,
		"./lv": 532,
		"./lv.js": 532,
		"./me": 533,
		"./me.js": 533,
		"./mi": 534,
		"./mi.js": 534,
		"./mk": 535,
		"./mk.js": 535,
		"./ml": 536,
		"./ml.js": 536,
		"./mn": 537,
		"./mn.js": 537,
		"./mr": 538,
		"./mr.js": 538,
		"./ms": 540,
		"./ms-my": 539,
		"./ms-my.js": 539,
		"./ms.js": 540,
		"./mt": 541,
		"./mt.js": 541,
		"./my": 542,
		"./my.js": 542,
		"./nb": 543,
		"./nb.js": 543,
		"./ne": 544,
		"./ne.js": 544,
		"./nl": 546,
		"./nl-be": 545,
		"./nl-be.js": 545,
		"./nl.js": 546,
		"./nn": 547,
		"./nn.js": 547,
		"./oc-lnc": 548,
		"./oc-lnc.js": 548,
		"./pa-in": 549,
		"./pa-in.js": 549,
		"./pl": 550,
		"./pl.js": 550,
		"./pt": 552,
		"./pt-br": 551,
		"./pt-br.js": 551,
		"./pt.js": 552,
		"./ro": 553,
		"./ro.js": 553,
		"./ru": 554,
		"./ru.js": 554,
		"./sd": 555,
		"./sd.js": 555,
		"./se": 556,
		"./se.js": 556,
		"./si": 557,
		"./si.js": 557,
		"./sk": 558,
		"./sk.js": 558,
		"./sl": 559,
		"./sl.js": 559,
		"./sq": 560,
		"./sq.js": 560,
		"./sr": 562,
		"./sr-cyrl": 561,
		"./sr-cyrl.js": 561,
		"./sr.js": 562,
		"./ss": 563,
		"./ss.js": 563,
		"./sv": 564,
		"./sv.js": 564,
		"./sw": 565,
		"./sw.js": 565,
		"./ta": 566,
		"./ta.js": 566,
		"./te": 567,
		"./te.js": 567,
		"./tet": 568,
		"./tet.js": 568,
		"./tg": 569,
		"./tg.js": 569,
		"./th": 570,
		"./th.js": 570,
		"./tk": 571,
		"./tk.js": 571,
		"./tl-ph": 572,
		"./tl-ph.js": 572,
		"./tlh": 573,
		"./tlh.js": 573,
		"./tr": 574,
		"./tr.js": 574,
		"./tzl": 575,
		"./tzl.js": 575,
		"./tzm": 577,
		"./tzm-latn": 576,
		"./tzm-latn.js": 576,
		"./tzm.js": 577,
		"./ug-cn": 578,
		"./ug-cn.js": 578,
		"./uk": 579,
		"./uk.js": 579,
		"./ur": 580,
		"./ur.js": 580,
		"./uz": 582,
		"./uz-latn": 581,
		"./uz-latn.js": 581,
		"./uz.js": 582,
		"./vi": 583,
		"./vi.js": 583,
		"./x-pseudo": 584,
		"./x-pseudo.js": 584,
		"./yo": 585,
		"./yo.js": 585,
		"./zh-cn": 586,
		"./zh-cn.js": 586,
		"./zh-hk": 587,
		"./zh-hk.js": 587,
		"./zh-mo": 588,
		"./zh-mo.js": 588,
		"./zh-tw": 589,
		"./zh-tw.js": 589
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 1347;


/***/ },
/* 1348 */
/***/ function(module, exports) {

	/**
	 * Helpers.
	 */
	
	var s = 1000;
	var m = s * 60;
	var h = m * 60;
	var d = h * 24;
	var y = d * 365.25;
	
	/**
	 * Parse or format the given `val`.
	 *
	 * Options:
	 *
	 *  - `long` verbose formatting [false]
	 *
	 * @param {String|Number} val
	 * @param {Object} [options]
	 * @throws {Error} throw an error if val is not a non-empty string or a number
	 * @return {String|Number}
	 * @api public
	 */
	
	module.exports = function(val, options) {
	  options = options || {};
	  var type = typeof val;
	  if (type === 'string' && val.length > 0) {
	    return parse(val);
	  } else if (type === 'number' && isNaN(val) === false) {
	    return options.long ? fmtLong(val) : fmtShort(val);
	  }
	  throw new Error(
	    'val is not a non-empty string or a valid number. val=' +
	      JSON.stringify(val)
	  );
	};
	
	/**
	 * Parse the given `str` and return milliseconds.
	 *
	 * @param {String} str
	 * @return {Number}
	 * @api private
	 */
	
	function parse(str) {
	  str = String(str);
	  if (str.length > 100) {
	    return;
	  }
	  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
	    str
	  );
	  if (!match) {
	    return;
	  }
	  var n = parseFloat(match[1]);
	  var type = (match[2] || 'ms').toLowerCase();
	  switch (type) {
	    case 'years':
	    case 'year':
	    case 'yrs':
	    case 'yr':
	    case 'y':
	      return n * y;
	    case 'days':
	    case 'day':
	    case 'd':
	      return n * d;
	    case 'hours':
	    case 'hour':
	    case 'hrs':
	    case 'hr':
	    case 'h':
	      return n * h;
	    case 'minutes':
	    case 'minute':
	    case 'mins':
	    case 'min':
	    case 'm':
	      return n * m;
	    case 'seconds':
	    case 'second':
	    case 'secs':
	    case 'sec':
	    case 's':
	      return n * s;
	    case 'milliseconds':
	    case 'millisecond':
	    case 'msecs':
	    case 'msec':
	    case 'ms':
	      return n;
	    default:
	      return undefined;
	  }
	}
	
	/**
	 * Short format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtShort(ms) {
	  if (ms >= d) {
	    return Math.round(ms / d) + 'd';
	  }
	  if (ms >= h) {
	    return Math.round(ms / h) + 'h';
	  }
	  if (ms >= m) {
	    return Math.round(ms / m) + 'm';
	  }
	  if (ms >= s) {
	    return Math.round(ms / s) + 's';
	  }
	  return ms + 'ms';
	}
	
	/**
	 * Long format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtLong(ms) {
	  return plural(ms, d, 'day') ||
	    plural(ms, h, 'hour') ||
	    plural(ms, m, 'minute') ||
	    plural(ms, s, 'second') ||
	    ms + ' ms';
	}
	
	/**
	 * Pluralization helper.
	 */
	
	function plural(ms, n, name) {
	  if (ms < n) {
	    return;
	  }
	  if (ms < n * 1.5) {
	    return Math.floor(ms / n) + ' ' + name;
	  }
	  return Math.ceil(ms / n) + ' ' + name + 's';
	}


/***/ },
/* 1349 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var e,t=__webpack_require__(1),i=(e=t)&&"object"==typeof e&&"default"in e?e.default:e;function n(e,t){return(n=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(e,t){return e.__proto__=t,e})(e,t)}function s(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}!function(e,t){void 0===t&&(t={});var i=t.insertAt;if("undefined"!=typeof document){var n=document.head||document.getElementsByTagName("head")[0],s=document.createElement("style");s.type="text/css","top"===i&&n.firstChild?n.insertBefore(s,n.firstChild):n.appendChild(s),s.styleSheet?s.styleSheet.cssText=e:s.appendChild(document.createTextNode(e))}}('.multiSelectContainer,.multiSelectContainer *,.multiSelectContainer :after,.multiSelectContainer :before{box-sizing:border-box}.multiSelectContainer{position:relative;text-align:left;width:100%}.disable_ms{opacity:.5;pointer-events:none}.display-none{display:none}.searchWrapper{border:1px solid #ccc;border-radius:4px;min-height:22px;padding:5px;position:relative}.multiSelectContainer input{background:transparent;border:none;margin-top:3px}.multiSelectContainer input:focus{outline:none}.chip{align-items:center;background:#0096fb;border-radius:11px;color:#fff;display:inline-flex;font-size:13px;line-height:19px;margin-bottom:5px;margin-right:5px;padding:4px 10px}.chip,.singleChip{white-space:nowrap}.singleChip{background:none;border-radius:none;color:inherit}.singleChip i{display:none}.closeIcon{cursor:pointer;float:right;height:13px;margin-left:5px;width:13px}.optionListContainer{background:#fff;border-radius:4px;margin-top:1px;position:absolute;width:100%;z-index:2}.multiSelectContainer ul{border:1px solid #ccc;border-radius:4px;display:block;margin:0;max-height:250px;overflow-y:auto;padding:0}.multiSelectContainer li{padding:10px}.multiSelectContainer li:hover{background:#0096fb;color:#fff;cursor:pointer}.checkbox{margin-right:10px}.disableSelection{opacity:.5;pointer-events:none}.highlightOption{background:#0096fb;color:#fff}.displayBlock{display:block}.displayNone{display:none}.notFound{display:block;padding:10px}.singleSelect{padding-right:20px}li.groupHeading{color:#908e8e;padding:5px 15px;pointer-events:none}li.groupChildEle{padding-left:30px}.icon_down_dir{position:absolute;right:10px;top:50%;transform:translateY(-50%);width:14px}.icon_down_dir:before{content:"\\e803"}.custom-close{display:flex}');var o={circle:"data:image/svg+xml,%3Csvg%20height%3D%22512px%22%20id%3D%22Layer_1%22%20style%3D%22enable-background%3Anew%200%200%20512%20512%3B%22%20version%3D%221.1%22%20viewBox%3D%220%200%20512%20512%22%20width%3D%22512px%22%20xml%3Aspace%3D%22preserve%22%20%20%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20%20%20%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%3Cstyle%20type%3D%22text%2Fcss%22%3E%20%20%20%20%20%20%20%20.st0%7B%20%20%20%20%20%20%20%20%20%20%20%20fill%3A%23fff%3B%20%20%20%20%20%20%20%20%7D%20%3C%2Fstyle%3E%20%20%20%20%3Cg%3E%20%20%20%20%20%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M256%2C33C132.3%2C33%2C32%2C133.3%2C32%2C257c0%2C123.7%2C100.3%2C224%2C224%2C224c123.7%2C0%2C224-100.3%2C224-224C480%2C133.3%2C379.7%2C33%2C256%2C33z%20%20%20%20M364.3%2C332.5c1.5%2C1.5%2C2.3%2C3.5%2C2.3%2C5.6c0%2C2.1-0.8%2C4.2-2.3%2C5.6l-21.6%2C21.7c-1.6%2C1.6-3.6%2C2.3-5.6%2C2.3c-2%2C0-4.1-0.8-5.6-2.3L256%2C289.8%20%20%20l-75.4%2C75.7c-1.5%2C1.6-3.6%2C2.3-5.6%2C2.3c-2%2C0-4.1-0.8-5.6-2.3l-21.6-21.7c-1.5-1.5-2.3-3.5-2.3-5.6c0-2.1%2C0.8-4.2%2C2.3-5.6l75.7-76%20%20%20l-75.9-75c-3.1-3.1-3.1-8.2%2C0-11.3l21.6-21.7c1.5-1.5%2C3.5-2.3%2C5.6-2.3c2.1%2C0%2C4.1%2C0.8%2C5.6%2C2.3l75.7%2C74.7l75.7-74.7%20%20%20c1.5-1.5%2C3.5-2.3%2C5.6-2.3c2.1%2C0%2C4.1%2C0.8%2C5.6%2C2.3l21.6%2C21.7c3.1%2C3.1%2C3.1%2C8.2%2C0%2C11.3l-75.9%2C75L364.3%2C332.5z%22%2F%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E",circle2:"data:image/svg+xml,%3Csvg%20viewBox%3D%220%200%2096%2096%22%20%20%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%20%20%20%20%3Cstyle%20type%3D%22text%2Fcss%22%3E%20%20%20%20%20%20%20%20.st0%7B%20%20%20%20%20%20%20%20%20%20%20%20fill%3A%23fff%3B%20%20%20%20%20%20%20%20%7D%20%3C%2Fstyle%3E%20%20%20%20%3Cg%3E%20%20%20%20%20%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M48%2C0A48%2C48%2C0%2C1%2C0%2C96%2C48%2C48.0512%2C48.0512%2C0%2C0%2C0%2C48%2C0Zm0%2C84A36%2C36%2C0%2C1%2C1%2C84%2C48%2C36.0393%2C36.0393%2C0%2C0%2C1%2C48%2C84Z%22%2F%3E%20%20%20%20%20%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M64.2422%2C31.7578a5.9979%2C5.9979%2C0%2C0%2C0-8.4844%2C0L48%2C39.5156l-7.7578-7.7578a5.9994%2C5.9994%2C0%2C0%2C0-8.4844%2C8.4844L39.5156%2C48l-7.7578%2C7.7578a5.9994%2C5.9994%2C0%2C1%2C0%2C8.4844%2C8.4844L48%2C56.4844l7.7578%2C7.7578a5.9994%2C5.9994%2C0%2C0%2C0%2C8.4844-8.4844L56.4844%2C48l7.7578-7.7578A5.9979%2C5.9979%2C0%2C0%2C0%2C64.2422%2C31.7578Z%22%2F%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E",close:"data:image/svg+xml,%3Csvg%20height%3D%22135.467mm%22%20style%3D%22shape-rendering%3AgeometricPrecision%3B%20text-rendering%3AgeometricPrecision%3B%20image-rendering%3AoptimizeQuality%3B%20fill-rule%3Aevenodd%3B%20clip-rule%3Aevenodd%22%20viewBox%3D%220%200%2013547%2013547%22%20width%3D%22135.467mm%22%20xml%3Aspace%3D%22preserve%22%20%20%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20%20%20%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%3Cdefs%3E%20%20%20%20%20%20%20%20%3Cstyle%20type%3D%22text%2Fcss%22%3E%20%20%20%20%20%20%20%20%20%20%20%20.fil0%20%7Bfill%3Anone%7D%20%20%20%20%20%20%20%20%20%20%20%20.fil1%20%7Bfill%3A%23fff%7D%20%20%20%20%20%20%20%20%3C%2Fstyle%3E%20%20%20%20%3C%2Fdefs%3E%20%20%20%20%3Cg%20id%3D%22Ebene_x0020_1%22%3E%20%20%20%20%20%20%20%20%3Cpolygon%20class%3D%22fil0%22%20points%3D%220%2C0%2013547%2C0%2013547%2C13547%200%2C13547%20%22%2F%3E%20%20%20%20%20%20%20%20%3Cpath%20class%3D%22fil1%22%20d%3D%22M714%2012832l12118%200%200%20-12117%20-12118%200%200%2012117zm4188%20-2990l1871%20-1871%201871%201871%201197%20-1197%20-1871%20-1871%201871%20-1871%20-1197%20-1197%20-1871%201871%20-1871%20-1871%20-1197%201197%201871%201871%20-1871%201871%201197%201197z%22%2F%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E",cancel:"data:image/svg+xml,%3Csvg%20height%3D%22512px%22%20id%3D%22Layer_1%22%20style%3D%22enable-background%3Anew%200%200%20512%20512%3B%22%20version%3D%221.1%22%20viewBox%3D%220%200%20512%20512%22%20width%3D%22512px%22%20xml%3Aspace%3D%22preserve%22%20%20%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20%20%20%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%3Cstyle%20type%3D%22text%2Fcss%22%3E%20%20%20%20%20%20%20%20.st0%7B%20%20%20%20%20%20%20%20%20%20%20%20fill%3A%23fff%3B%20%20%20%20%20%20%20%20%7D%20%3C%2Fstyle%3E%20%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M443.6%2C387.1L312.4%2C255.4l131.5-130c5.4-5.4%2C5.4-14.2%2C0-19.6l-37.4-37.6c-2.6-2.6-6.1-4-9.8-4c-3.7%2C0-7.2%2C1.5-9.8%2C4%20%20L256%2C197.8L124.9%2C68.3c-2.6-2.6-6.1-4-9.8-4c-3.7%2C0-7.2%2C1.5-9.8%2C4L68%2C105.9c-5.4%2C5.4-5.4%2C14.2%2C0%2C19.6l131.5%2C130L68.4%2C387.1%20%20c-2.6%2C2.6-4.1%2C6.1-4.1%2C9.8c0%2C3.7%2C1.4%2C7.2%2C4.1%2C9.8l37.4%2C37.6c2.7%2C2.7%2C6.2%2C4.1%2C9.8%2C4.1c3.5%2C0%2C7.1-1.3%2C9.8-4.1L256%2C313.1l130.7%2C131.1%20%20c2.7%2C2.7%2C6.2%2C4.1%2C9.8%2C4.1c3.5%2C0%2C7.1-1.3%2C9.8-4.1l37.4-37.6c2.6-2.6%2C4.1-6.1%2C4.1-9.8C447.7%2C393.2%2C446.2%2C389.7%2C443.6%2C387.1z%22%2F%3E%3C%2Fsvg%3E"};function l(e){var n,s,o=t.useRef(null);return s=e.outsideClick,t.useEffect((function(){function e(e){n.current&&!n.current.contains(e.target)&&s()}return document.addEventListener("mousedown",e),function(){document.removeEventListener("mousedown",e)}}),[n=o]),i.createElement("div",{ref:o},e.children)}var r=function(e){var t,r;function c(t){var n;return(n=e.call(this,t)||this).state={inputValue:"",options:t.options,filteredOptions:t.options,unfilteredOptions:t.options,selectedValues:Object.assign([],t.selectedValues),preSelectedValues:Object.assign([],t.selectedValues),toggleOptionsList:!1,highlightOption:t.avoidHighlightFirstOption?-1:0,showCheckbox:t.showCheckbox,keepSearchTerm:t.keepSearchTerm,groupedObject:[],closeIconType:o[t.closeIcon]||o.circle},n.optionTimeout=null,n.searchWrapper=i.createRef(),n.searchBox=i.createRef(),n.onChange=n.onChange.bind(s(n)),n.onKeyPress=n.onKeyPress.bind(s(n)),n.onFocus=n.onFocus.bind(s(n)),n.onBlur=n.onBlur.bind(s(n)),n.renderMultiselectContainer=n.renderMultiselectContainer.bind(s(n)),n.renderSelectedList=n.renderSelectedList.bind(s(n)),n.onRemoveSelectedItem=n.onRemoveSelectedItem.bind(s(n)),n.toggelOptionList=n.toggelOptionList.bind(s(n)),n.onArrowKeyNavigation=n.onArrowKeyNavigation.bind(s(n)),n.onSelectItem=n.onSelectItem.bind(s(n)),n.filterOptionsByInput=n.filterOptionsByInput.bind(s(n)),n.removeSelectedValuesFromOptions=n.removeSelectedValuesFromOptions.bind(s(n)),n.isSelectedValue=n.isSelectedValue.bind(s(n)),n.fadeOutSelection=n.fadeOutSelection.bind(s(n)),n.isDisablePreSelectedValues=n.isDisablePreSelectedValues.bind(s(n)),n.renderGroupByOptions=n.renderGroupByOptions.bind(s(n)),n.renderNormalOption=n.renderNormalOption.bind(s(n)),n.listenerCallback=n.listenerCallback.bind(s(n)),n.resetSelectedValues=n.resetSelectedValues.bind(s(n)),n.getSelectedItems=n.getSelectedItems.bind(s(n)),n.getSelectedItemsCount=n.getSelectedItemsCount.bind(s(n)),n.hideOnClickOutside=n.hideOnClickOutside.bind(s(n)),n.onCloseOptionList=n.onCloseOptionList.bind(s(n)),n.isVisible=n.isVisible.bind(s(n)),n}r=e,(t=c).prototype=Object.create(r.prototype),t.prototype.constructor=t,n(t,r);var a=c.prototype;return a.initialSetValue=function(){var e=this.props,t=e.groupBy,i=this.state.options;e.showCheckbox||e.singleSelect||this.removeSelectedValuesFromOptions(!1),t&&this.groupByOptions(i)},a.resetSelectedValues=function(){var e=this,t=this.state.unfilteredOptions;return new Promise((function(i){e.setState({selectedValues:[],preSelectedValues:[],options:t,filteredOptions:t},(function(){i(),e.initialSetValue()}))}))},a.getSelectedItems=function(){return this.state.selectedValues},a.getSelectedItemsCount=function(){return this.state.selectedValues.length},a.componentDidMount=function(){this.initialSetValue(),this.searchWrapper.current.addEventListener("click",this.listenerCallback)},a.componentDidUpdate=function(e){var t=this.props,i=t.options,n=t.selectedValues,s=e.selectedValues;JSON.stringify(e.options)!==JSON.stringify(i)&&this.setState({options:i,filteredOptions:i,unfilteredOptions:i},this.initialSetValue),JSON.stringify(s)!==JSON.stringify(n)&&this.setState({selectedValues:Object.assign([],n),preSelectedValues:Object.assign([],n)},this.initialSetValue)},a.listenerCallback=function(){this.searchBox.current.focus()},a.componentWillUnmount=function(){this.optionTimeout&&clearTimeout(this.optionTimeout),this.searchWrapper.current.removeEventListener("click",this.listenerCallback)},a.removeSelectedValuesFromOptions=function(e){var t=this.props,i=t.isObject,n=t.displayValue,s=t.groupBy,o=this.state,l=o.selectedValues,r=void 0===l?[]:l,c=o.unfilteredOptions;if(!e&&s&&this.groupByOptions(o.options),r.length||e){if(i){var a=c.filter((function(e){return-1===r.findIndex((function(t){return t[n]===e[n]}))}));return s&&this.groupByOptions(a),void this.setState({options:a,filteredOptions:a},this.filterOptionsByInput)}var p=c.filter((function(e){return-1===r.indexOf(e)}));this.setState({options:p,filteredOptions:p},this.filterOptionsByInput)}},a.groupByOptions=function(e){var t=this.props.groupBy,i=e.reduce((function(e,i){var n=i[t]||"Others";return e[n]=e[n]||[],e[n].push(i),e}),Object.create({}));this.setState({groupedObject:i})},a.onChange=function(e){var t=this.props.onSearch;this.setState({inputValue:e.target.value},this.filterOptionsByInput),t&&t(e.target.value)},a.onKeyPress=function(e){var t=this.props.onKeyPressFn;t&&t(e,e.target.value)},a.filterOptionsByInput=function(){var e,t=this,i=this.state,n=i.inputValue,s=this.props,o=s.displayValue;e=i.filteredOptions.filter(s.isObject?function(e){return t.matchValues(e[o],n)}:function(e){return t.matchValues(e,n)}),this.groupByOptions(e),this.setState({options:e})},a.matchValues=function(e,t){return this.props.caseSensitiveSearch?e.indexOf(t)>-1:e.toLowerCase?e.toLowerCase().indexOf(t.toLowerCase())>-1:e.toString().indexOf(t)>-1},a.onArrowKeyNavigation=function(e){var t=this.state,i=t.options,n=t.highlightOption,s=t.toggleOptionsList,o=t.selectedValues;if(8!==e.keyCode||t.inputValue||this.props.disablePreSelectedValues||!o.length||this.onRemoveSelectedItem(o.length-1),i.length)if(38===e.keyCode)this.setState(n>0?function(e){return{highlightOption:e.highlightOption-1}}:{highlightOption:i.length-1});else if(40===e.keyCode)this.setState(n<i.length-1?function(e){return{highlightOption:e.highlightOption+1}}:{highlightOption:0});else if("Enter"===e.key&&i.length&&s){if(-1===n)return;this.onSelectItem(i[n])}},a.onRemoveSelectedItem=function(e){var t,i=this,n=this.state.selectedValues,s=this.props,o=s.onRemove,l=s.showCheckbox,r=s.displayValue;t=s.isObject?n.findIndex((function(t){return t[r]===e[r]})):n.indexOf(e),n.splice(t,1),o(n,e),this.setState({selectedValues:n},(function(){l||i.removeSelectedValuesFromOptions(!0)})),this.props.closeOnSelect||this.searchBox.current.focus()},a.onSelectItem=function(e){var t=this,i=this.state.selectedValues,n=this.props,s=n.selectionLimit,o=n.onSelect,l=n.singleSelect,r=n.showCheckbox;if(this.state.keepSearchTerm||this.setState({inputValue:""}),l)return this.onSingleSelect(e),void o([e],e);this.isSelectedValue(e)?this.onRemoveSelectedItem(e):s!=i.length&&(i.push(e),o(i,e),this.setState({selectedValues:i},(function(){r?t.filterOptionsByInput():t.removeSelectedValuesFromOptions(!0)})),this.props.closeOnSelect||this.searchBox.current.focus())},a.onSingleSelect=function(e){this.setState({selectedValues:[e],toggleOptionsList:!1})},a.isSelectedValue=function(e){var t=this.props,i=t.displayValue,n=this.state.selectedValues;return t.isObject?n.filter((function(t){return t[i]===e[i]})).length>0:n.filter((function(t){return t===e})).length>0},a.renderOptionList=function(){var e=this.props,t=e.groupBy,n=e.style,s=e.emptyRecordMsg,o=e.loadingMessage,l=void 0===o?"loading...":o,r=this.state.options;return e.loading?i.createElement("ul",{className:"optionContainer",style:n.optionContainer},"string"==typeof l&&i.createElement("span",{style:n.loadingMessage,className:"notFound"},l),"string"!=typeof l&&l):i.createElement("ul",{className:"optionContainer",style:n.optionContainer},0===r.length&&i.createElement("span",{style:n.notFound,className:"notFound"},s),t?this.renderGroupByOptions():this.renderNormalOption())},a.renderGroupByOptions=function(){var e=this,t=this.props,n=t.isObject,s=void 0!==n&&n,o=t.displayValue,l=t.showCheckbox,r=t.style,c=t.singleSelect,a=this.state.groupedObject;return Object.keys(a).map((function(t){return i.createElement(i.Fragment,{key:t},i.createElement("li",{className:"groupHeading",style:r.groupHeading},t),a[t].map((function(t,n){var a=e.isSelectedValue(t);return i.createElement("li",{key:"option"+n,style:r.option,className:"groupChildEle option "+(a?"selected":"")+" "+(e.fadeOutSelection(t)?"disableSelection":"")+" "+(e.isDisablePreSelectedValues(t)?"disableSelection":""),onClick:function(){return e.onSelectItem(t)}},l&&!c&&i.createElement("input",{type:"checkbox",className:"checkbox",readOnly:!0,checked:a}),e.props.optionValueDecorator(s?t[o]:(t||"").toString(),t))})))}))},a.renderNormalOption=function(){var e=this,t=this.props,n=t.isObject,s=void 0!==n&&n,o=t.displayValue,l=t.showCheckbox,r=t.style,c=t.singleSelect,a=this.state.highlightOption;return this.state.options.map((function(t,n){var p=e.isSelectedValue(t);return i.createElement("li",{key:"option"+n,style:r.option,className:"option "+(p?"selected":"")+" "+(a===n?"highlightOption highlight":"")+" "+(e.fadeOutSelection(t)?"disableSelection":"")+" "+(e.isDisablePreSelectedValues(t)?"disableSelection":""),onClick:function(){return e.onSelectItem(t)}},l&&!c&&i.createElement("input",{type:"checkbox",readOnly:!0,className:"checkbox",checked:p}),e.props.optionValueDecorator(s?t[o]:(t||"").toString(),t))}))},a.renderSelectedList=function(){var e=this,t=this.props,n=t.isObject,s=void 0!==n&&n,o=t.displayValue,l=t.style,r=t.singleSelect,c=t.customCloseIcon,a=this.state,p=a.closeIconType;return a.selectedValues.map((function(t,n){return i.createElement("span",{className:"chip  "+(r&&"singleChip")+" "+(e.isDisablePreSelectedValues(t)&&"disableSelection"),key:n,style:l.chips},e.props.selectedValueDecorator(s?t[o]:(t||"").toString(),t),!e.isDisablePreSelectedValues(t)&&(c?i.createElement("i",{className:"custom-close",onClick:function(){return e.onRemoveSelectedItem(t)}},c):i.createElement("img",{className:"icon_cancel closeIcon",src:p,onClick:function(){return e.onRemoveSelectedItem(t)}})))}))},a.isDisablePreSelectedValues=function(e){var t=this.props,i=t.displayValue,n=this.state.preSelectedValues;return!(!t.disablePreSelectedValues||!n.length)&&(t.isObject?n.filter((function(t){return t[i]===e[i]})).length>0:n.filter((function(t){return t===e})).length>0)},a.fadeOutSelection=function(e){var t=this.props,i=t.selectionLimit;if(!t.singleSelect){var n=this.state.selectedValues;return-1!=i&&i==n.length&&(i==n.length?!t.showCheckbox||!this.isSelectedValue(e):void 0)}},a.toggelOptionList=function(){this.setState({toggleOptionsList:!this.state.toggleOptionsList,highlightOption:this.props.avoidHighlightFirstOption?-1:0})},a.onCloseOptionList=function(){this.setState({toggleOptionsList:!1,highlightOption:this.props.avoidHighlightFirstOption?-1:0,inputValue:""})},a.onFocus=function(){this.state.toggleOptionsList?clearTimeout(this.optionTimeout):this.toggelOptionList()},a.onBlur=function(){this.setState({inputValue:""},this.filterOptionsByInput),this.optionTimeout=setTimeout(this.onCloseOptionList,250)},a.isVisible=function(e){return!!e&&!!(e.offsetWidth||e.offsetHeight||e.getClientRects().length)},a.hideOnClickOutside=function(){var e=this,t=document.getElementsByClassName("multiselect-container")[0];document.addEventListener("click",(function(i){t&&!t.contains(i.target)&&e.isVisible(t)&&e.toggelOptionList()}))},a.renderMultiselectContainer=function(){var e=this.state,t=e.inputValue,n=e.toggleOptionsList,s=e.selectedValues,o=this.props,l=o.placeholder,r=o.style,c=o.singleSelect,a=o.id,p=o.name,u=o.hidePlaceholder,d=o.disable,h=o.showArrow,C=o.customArrow;return i.createElement("div",{className:"multiselect-container multiSelectContainer "+(d?"disable_ms":"")+" "+(o.className||""),id:a||"multiselectContainerReact",style:r.multiselectContainer},i.createElement("div",{className:"search-wrapper searchWrapper "+(c?"singleSelect":""),ref:this.searchWrapper,style:r.searchBox,onClick:c?this.toggelOptionList:function(){}},!o.hideSelectedList&&this.renderSelectedList(),i.createElement("input",{type:"text",ref:this.searchBox,className:"searchBox "+(c&&s.length?"display-none":""),id:(a||"search")+"_input",name:(p||"search_name")+"_input",onChange:this.onChange,onKeyPress:this.onKeyPress,value:t,onFocus:this.onFocus,onBlur:this.onBlur,placeholder:c&&s.length||u&&s.length?"":l,onKeyDown:this.onArrowKeyNavigation,style:r.inputField,autoComplete:"off",disabled:c||d}),(c||h)&&i.createElement(i.Fragment,null,C?i.createElement("span",{className:"icon_down_dir"},C):i.createElement("img",{src:"data:image/svg+xml,%3Csvg%20height%3D%2232%22%20viewBox%3D%220%200%2032%2032%22%20width%3D%2232%22%20%20%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%20%20%20%20%3Cg%20id%3D%22background%22%3E%20%20%20%20%20%20%20%20%3Crect%20fill%3D%22none%22%20height%3D%2232%22%20width%3D%2232%22%2F%3E%20%20%20%20%3C%2Fg%3E%20%20%20%20%3Cg%20id%3D%22arrow_x5F_down%22%3E%20%20%20%20%20%20%20%20%3Cpolygon%20points%3D%222.002%2C10%2016.001%2C24%2030.002%2C10%20%20%22%2F%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E",className:"icon_cancel icon_down_dir"}))),i.createElement("div",{className:"optionListContainer "+(n?"displayBlock":"displayNone"),onMouseDown:function(e){e.preventDefault()}},this.renderOptionList()))},a.render=function(){return i.createElement(l,{outsideClick:this.onCloseOptionList},this.renderMultiselectContainer())},c}(i.Component);r.defaultProps={options:[],disablePreSelectedValues:!1,selectedValues:[],isObject:!0,displayValue:"model",showCheckbox:!1,selectionLimit:-1,placeholder:"Select",groupBy:"",style:{},emptyRecordMsg:"No Options Available",onSelect:function(){},onRemove:function(){},onKeyPressFn:function(){},closeIcon:"circle2",singleSelect:!1,caseSensitiveSearch:!1,id:"",name:"",closeOnSelect:!0,avoidHighlightFirstOption:!1,hidePlaceholder:!1,showArrow:!1,keepSearchTerm:!1,customCloseIcon:"",className:"",customArrow:void 0,selectedValueDecorator:function(e){return e},optionValueDecorator:function(e){return e}},exports.Multiselect=r,exports.default=r;
	//# sourceMappingURL=multiselect-react-dropdown.cjs.production.min.js.map


/***/ },
/* 1350 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var define = __webpack_require__(150);
	var callBind = __webpack_require__(252);
	
	var implementation = __webpack_require__(590);
	var getPolyfill = __webpack_require__(591);
	var shim = __webpack_require__(1351);
	
	var polyfill = callBind(getPolyfill(), Object);
	
	define(polyfill, {
		getPolyfill: getPolyfill,
		implementation: implementation,
		shim: shim
	});
	
	module.exports = polyfill;


/***/ },
/* 1351 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var getPolyfill = __webpack_require__(591);
	var define = __webpack_require__(150);
	
	module.exports = function shimObjectIs() {
		var polyfill = getPolyfill();
		define(Object, { is: polyfill }, {
			is: function testObjectIs() {
				return Object.is !== polyfill;
			}
		});
		return polyfill;
	};


/***/ },
/* 1352 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var keysShim;
	if (!Object.keys) {
		// modified from https://github.com/es-shims/es5-shim
		var has = Object.prototype.hasOwnProperty;
		var toStr = Object.prototype.toString;
		var isArgs = __webpack_require__(593); // eslint-disable-line global-require
		var isEnumerable = Object.prototype.propertyIsEnumerable;
		var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
		var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
		var dontEnums = [
			'toString',
			'toLocaleString',
			'valueOf',
			'hasOwnProperty',
			'isPrototypeOf',
			'propertyIsEnumerable',
			'constructor'
		];
		var equalsConstructorPrototype = function (o) {
			var ctor = o.constructor;
			return ctor && ctor.prototype === o;
		};
		var excludedKeys = {
			$applicationCache: true,
			$console: true,
			$external: true,
			$frame: true,
			$frameElement: true,
			$frames: true,
			$innerHeight: true,
			$innerWidth: true,
			$onmozfullscreenchange: true,
			$onmozfullscreenerror: true,
			$outerHeight: true,
			$outerWidth: true,
			$pageXOffset: true,
			$pageYOffset: true,
			$parent: true,
			$scrollLeft: true,
			$scrollTop: true,
			$scrollX: true,
			$scrollY: true,
			$self: true,
			$webkitIndexedDB: true,
			$webkitStorageInfo: true,
			$window: true
		};
		var hasAutomationEqualityBug = (function () {
			/* global window */
			if (typeof window === 'undefined') { return false; }
			for (var k in window) {
				try {
					if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
						try {
							equalsConstructorPrototype(window[k]);
						} catch (e) {
							return true;
						}
					}
				} catch (e) {
					return true;
				}
			}
			return false;
		}());
		var equalsConstructorPrototypeIfNotBuggy = function (o) {
			/* global window */
			if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
				return equalsConstructorPrototype(o);
			}
			try {
				return equalsConstructorPrototype(o);
			} catch (e) {
				return false;
			}
		};
	
		keysShim = function keys(object) {
			var isObject = object !== null && typeof object === 'object';
			var isFunction = toStr.call(object) === '[object Function]';
			var isArguments = isArgs(object);
			var isString = isObject && toStr.call(object) === '[object String]';
			var theKeys = [];
	
			if (!isObject && !isFunction && !isArguments) {
				throw new TypeError('Object.keys called on a non-object');
			}
	
			var skipProto = hasProtoEnumBug && isFunction;
			if (isString && object.length > 0 && !has.call(object, 0)) {
				for (var i = 0; i < object.length; ++i) {
					theKeys.push(String(i));
				}
			}
	
			if (isArguments && object.length > 0) {
				for (var j = 0; j < object.length; ++j) {
					theKeys.push(String(j));
				}
			} else {
				for (var name in object) {
					if (!(skipProto && name === 'prototype') && has.call(object, name)) {
						theKeys.push(String(name));
					}
				}
			}
	
			if (hasDontEnumBug) {
				var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);
	
				for (var k = 0; k < dontEnums.length; ++k) {
					if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
						theKeys.push(dontEnums[k]);
					}
				}
			}
			return theKeys;
		};
	}
	module.exports = keysShim;


/***/ },
/* 1353 */
/***/ function(module, exports) {

	module.exports = Paginator;
	
	// Paginator constructor
	//
	// `per_page` is the number of results per page, `length` is the number of
	// pages to display. They default to `25` and `10` respectively.
	function Paginator(per_page, length) {
	  // You really should be calling this with `new Paginator`, but WHATEVER.
	  if (!(this instanceof Paginator)) {
	    return new Paginator(per_page, length);
	  }
	
	  // Woo, defaults!
	  this.per_page = per_page || 25;
	  this.length = length || 10;
	}
	
	// Build an object with all the necessary information for outputting pagination
	// controls.
	//
	// (new Paginator(paginator.build(100, 2)
	Paginator.prototype.build = function(total_results, current_page) {
	  // We want the number of pages, rounded up to the nearest page.
	  var total_pages = Math.ceil(total_results / this.per_page);
	
	  // Ensure both total_results and current_page are treated as Numbers
	  total_results = parseInt(total_results, 10);
	  current_page  = parseInt(current_page, 10) || 1;
	
	  // Obviously we can't be on a negative or 0 page.
	  if (current_page < 1) { current_page = 1; }
	  // If the user has done something like /page/99999 we want to clamp that back
	  // down.
	  if (current_page > total_pages) { current_page = total_pages; }
	
	  // This is the first page to be displayed as a numbered link.
	  var first_page = Math.max(1, current_page - Math.floor(this.length / 2));
	
	  // And here's the last page to be displayed specifically.
	  var last_page = Math.min(total_pages, current_page + Math.floor(this.length / 2));
	
	  // This is triggered if we're at or near one of the extremes; we won't have
	  // enough page links. We need to adjust our bounds accordingly.
	  if (last_page - first_page + 1 < this.length) {
	    if (current_page < (total_pages / 2)) {
	      last_page = Math.min(total_pages, last_page + (this.length - (last_page - first_page)));
	    } else {
	      first_page = Math.max(1, first_page - (this.length - (last_page - first_page)));
	    }
	  }
	
	  // This can be triggered if the user wants an odd number of pages.
	  if (last_page - first_page + 1 > this.length) {
	    // We want to move towards whatever extreme we're closest to at the time.
	    if (current_page > (total_pages / 2)) {
	      first_page++;
	    } else {
	      last_page--;
	    }
	  }
	
	  // First result on the page. This, along with the field below, can be used to
	  // do "showing x to y of z results" style things.
	  var first_result = this.per_page * (current_page - 1);
	  if (first_result < 0) { first_result = 0; }
	
	  // Last result on the page.
	  var last_result = (this.per_page * current_page) - 1;
	  if (last_result < 0) { last_result = 0; }
	  if (last_result > Math.max(total_results - 1, 0)) { last_result = Math.max(total_results - 1, 0); }
	
	  // GIMME THAT OBJECT
	  return {
	    total_pages: total_pages,
	    pages: Math.min(last_page - first_page + 1, total_pages),
	    current_page: current_page,
	    first_page: first_page,
	    last_page: last_page,
	    previous_page: current_page - 1,
	    next_page: current_page + 1,
	    has_previous_page: current_page > 1,
	    has_next_page: current_page < total_pages,
	    total_results: total_results,
	    results: Math.min(last_result - first_result + 1, total_results),
	    first_result: first_result,
	    last_result: last_result,
	  };
	};


/***/ },
/* 1354 */
/***/ function(module, exports, __webpack_require__) {

	// Top level file is just a mixin of submodules & constants
	'use strict';
	
	var assign    = __webpack_require__(99).assign;
	
	var deflate   = __webpack_require__(1355);
	var inflate   = __webpack_require__(1356);
	var constants = __webpack_require__(596);
	
	var pako = {};
	
	assign(pako, deflate, inflate, constants);
	
	module.exports = pako;


/***/ },
/* 1355 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	
	var zlib_deflate = __webpack_require__(1357);
	var utils        = __webpack_require__(99);
	var strings      = __webpack_require__(594);
	var msg          = __webpack_require__(277);
	var ZStream      = __webpack_require__(598);
	
	var toString = Object.prototype.toString;
	
	/* Public constants ==========================================================*/
	/* ===========================================================================*/
	
	var Z_NO_FLUSH      = 0;
	var Z_FINISH        = 4;
	
	var Z_OK            = 0;
	var Z_STREAM_END    = 1;
	var Z_SYNC_FLUSH    = 2;
	
	var Z_DEFAULT_COMPRESSION = -1;
	
	var Z_DEFAULT_STRATEGY    = 0;
	
	var Z_DEFLATED  = 8;
	
	/* ===========================================================================*/
	
	
	/**
	 * class Deflate
	 *
	 * Generic JS-style wrapper for zlib calls. If you don't need
	 * streaming behaviour - use more simple functions: [[deflate]],
	 * [[deflateRaw]] and [[gzip]].
	 **/
	
	/* internal
	 * Deflate.chunks -> Array
	 *
	 * Chunks of output data, if [[Deflate#onData]] not overridden.
	 **/
	
	/**
	 * Deflate.result -> Uint8Array|Array
	 *
	 * Compressed result, generated by default [[Deflate#onData]]
	 * and [[Deflate#onEnd]] handlers. Filled after you push last chunk
	 * (call [[Deflate#push]] with `Z_FINISH` / `true` param)  or if you
	 * push a chunk with explicit flush (call [[Deflate#push]] with
	 * `Z_SYNC_FLUSH` param).
	 **/
	
	/**
	 * Deflate.err -> Number
	 *
	 * Error code after deflate finished. 0 (Z_OK) on success.
	 * You will not need it in real life, because deflate errors
	 * are possible only on wrong options or bad `onData` / `onEnd`
	 * custom handlers.
	 **/
	
	/**
	 * Deflate.msg -> String
	 *
	 * Error message, if [[Deflate.err]] != 0
	 **/
	
	
	/**
	 * new Deflate(options)
	 * - options (Object): zlib deflate options.
	 *
	 * Creates new deflator instance with specified params. Throws exception
	 * on bad params. Supported options:
	 *
	 * - `level`
	 * - `windowBits`
	 * - `memLevel`
	 * - `strategy`
	 * - `dictionary`
	 *
	 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
	 * for more information on these.
	 *
	 * Additional options, for internal needs:
	 *
	 * - `chunkSize` - size of generated data chunks (16K by default)
	 * - `raw` (Boolean) - do raw deflate
	 * - `gzip` (Boolean) - create gzip wrapper
	 * - `to` (String) - if equal to 'string', then result will be "binary string"
	 *    (each char code [0..255])
	 * - `header` (Object) - custom header for gzip
	 *   - `text` (Boolean) - true if compressed data believed to be text
	 *   - `time` (Number) - modification time, unix timestamp
	 *   - `os` (Number) - operation system code
	 *   - `extra` (Array) - array of bytes with extra data (max 65536)
	 *   - `name` (String) - file name (binary string)
	 *   - `comment` (String) - comment (binary string)
	 *   - `hcrc` (Boolean) - true if header crc should be added
	 *
	 * ##### Example:
	 *
	 * ```javascript
	 * var pako = require('pako')
	 *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
	 *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
	 *
	 * var deflate = new pako.Deflate({ level: 3});
	 *
	 * deflate.push(chunk1, false);
	 * deflate.push(chunk2, true);  // true -> last chunk
	 *
	 * if (deflate.err) { throw new Error(deflate.err); }
	 *
	 * console.log(deflate.result);
	 * ```
	 **/
	function Deflate(options) {
	  if (!(this instanceof Deflate)) return new Deflate(options);
	
	  this.options = utils.assign({
	    level: Z_DEFAULT_COMPRESSION,
	    method: Z_DEFLATED,
	    chunkSize: 16384,
	    windowBits: 15,
	    memLevel: 8,
	    strategy: Z_DEFAULT_STRATEGY,
	    to: ''
	  }, options || {});
	
	  var opt = this.options;
	
	  if (opt.raw && (opt.windowBits > 0)) {
	    opt.windowBits = -opt.windowBits;
	  }
	
	  else if (opt.gzip && (opt.windowBits > 0) && (opt.windowBits < 16)) {
	    opt.windowBits += 16;
	  }
	
	  this.err    = 0;      // error code, if happens (0 = Z_OK)
	  this.msg    = '';     // error message
	  this.ended  = false;  // used to avoid multiple onEnd() calls
	  this.chunks = [];     // chunks of compressed data
	
	  this.strm = new ZStream();
	  this.strm.avail_out = 0;
	
	  var status = zlib_deflate.deflateInit2(
	    this.strm,
	    opt.level,
	    opt.method,
	    opt.windowBits,
	    opt.memLevel,
	    opt.strategy
	  );
	
	  if (status !== Z_OK) {
	    throw new Error(msg[status]);
	  }
	
	  if (opt.header) {
	    zlib_deflate.deflateSetHeader(this.strm, opt.header);
	  }
	
	  if (opt.dictionary) {
	    var dict;
	    // Convert data if needed
	    if (typeof opt.dictionary === 'string') {
	      // If we need to compress text, change encoding to utf8.
	      dict = strings.string2buf(opt.dictionary);
	    } else if (toString.call(opt.dictionary) === '[object ArrayBuffer]') {
	      dict = new Uint8Array(opt.dictionary);
	    } else {
	      dict = opt.dictionary;
	    }
	
	    status = zlib_deflate.deflateSetDictionary(this.strm, dict);
	
	    if (status !== Z_OK) {
	      throw new Error(msg[status]);
	    }
	
	    this._dict_set = true;
	  }
	}
	
	/**
	 * Deflate#push(data[, mode]) -> Boolean
	 * - data (Uint8Array|Array|ArrayBuffer|String): input data. Strings will be
	 *   converted to utf8 byte sequence.
	 * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
	 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
	 *
	 * Sends input data to deflate pipe, generating [[Deflate#onData]] calls with
	 * new compressed chunks. Returns `true` on success. The last data block must have
	 * mode Z_FINISH (or `true`). That will flush internal pending buffers and call
	 * [[Deflate#onEnd]]. For interim explicit flushes (without ending the stream) you
	 * can use mode Z_SYNC_FLUSH, keeping the compression context.
	 *
	 * On fail call [[Deflate#onEnd]] with error code and return false.
	 *
	 * We strongly recommend to use `Uint8Array` on input for best speed (output
	 * array format is detected automatically). Also, don't skip last param and always
	 * use the same type in your code (boolean or number). That will improve JS speed.
	 *
	 * For regular `Array`-s make sure all elements are [0..255].
	 *
	 * ##### Example
	 *
	 * ```javascript
	 * push(chunk, false); // push one of data chunks
	 * ...
	 * push(chunk, true);  // push last chunk
	 * ```
	 **/
	Deflate.prototype.push = function (data, mode) {
	  var strm = this.strm;
	  var chunkSize = this.options.chunkSize;
	  var status, _mode;
	
	  if (this.ended) { return false; }
	
	  _mode = (mode === ~~mode) ? mode : ((mode === true) ? Z_FINISH : Z_NO_FLUSH);
	
	  // Convert data if needed
	  if (typeof data === 'string') {
	    // If we need to compress text, change encoding to utf8.
	    strm.input = strings.string2buf(data);
	  } else if (toString.call(data) === '[object ArrayBuffer]') {
	    strm.input = new Uint8Array(data);
	  } else {
	    strm.input = data;
	  }
	
	  strm.next_in = 0;
	  strm.avail_in = strm.input.length;
	
	  do {
	    if (strm.avail_out === 0) {
	      strm.output = new utils.Buf8(chunkSize);
	      strm.next_out = 0;
	      strm.avail_out = chunkSize;
	    }
	    status = zlib_deflate.deflate(strm, _mode);    /* no bad return value */
	
	    if (status !== Z_STREAM_END && status !== Z_OK) {
	      this.onEnd(status);
	      this.ended = true;
	      return false;
	    }
	    if (strm.avail_out === 0 || (strm.avail_in === 0 && (_mode === Z_FINISH || _mode === Z_SYNC_FLUSH))) {
	      if (this.options.to === 'string') {
	        this.onData(strings.buf2binstring(utils.shrinkBuf(strm.output, strm.next_out)));
	      } else {
	        this.onData(utils.shrinkBuf(strm.output, strm.next_out));
	      }
	    }
	  } while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== Z_STREAM_END);
	
	  // Finalize on the last chunk.
	  if (_mode === Z_FINISH) {
	    status = zlib_deflate.deflateEnd(this.strm);
	    this.onEnd(status);
	    this.ended = true;
	    return status === Z_OK;
	  }
	
	  // callback interim results if Z_SYNC_FLUSH.
	  if (_mode === Z_SYNC_FLUSH) {
	    this.onEnd(Z_OK);
	    strm.avail_out = 0;
	    return true;
	  }
	
	  return true;
	};
	
	
	/**
	 * Deflate#onData(chunk) -> Void
	 * - chunk (Uint8Array|Array|String): output data. Type of array depends
	 *   on js engine support. When string output requested, each chunk
	 *   will be string.
	 *
	 * By default, stores data blocks in `chunks[]` property and glue
	 * those in `onEnd`. Override this handler, if you need another behaviour.
	 **/
	Deflate.prototype.onData = function (chunk) {
	  this.chunks.push(chunk);
	};
	
	
	/**
	 * Deflate#onEnd(status) -> Void
	 * - status (Number): deflate status. 0 (Z_OK) on success,
	 *   other if not.
	 *
	 * Called once after you tell deflate that the input stream is
	 * complete (Z_FINISH) or should be flushed (Z_SYNC_FLUSH)
	 * or if an error happened. By default - join collected chunks,
	 * free memory and fill `results` / `err` properties.
	 **/
	Deflate.prototype.onEnd = function (status) {
	  // On success - join
	  if (status === Z_OK) {
	    if (this.options.to === 'string') {
	      this.result = this.chunks.join('');
	    } else {
	      this.result = utils.flattenChunks(this.chunks);
	    }
	  }
	  this.chunks = [];
	  this.err = status;
	  this.msg = this.strm.msg;
	};
	
	
	/**
	 * deflate(data[, options]) -> Uint8Array|Array|String
	 * - data (Uint8Array|Array|String): input data to compress.
	 * - options (Object): zlib deflate options.
	 *
	 * Compress `data` with deflate algorithm and `options`.
	 *
	 * Supported options are:
	 *
	 * - level
	 * - windowBits
	 * - memLevel
	 * - strategy
	 * - dictionary
	 *
	 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
	 * for more information on these.
	 *
	 * Sugar (options):
	 *
	 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
	 *   negative windowBits implicitly.
	 * - `to` (String) - if equal to 'string', then result will be "binary string"
	 *    (each char code [0..255])
	 *
	 * ##### Example:
	 *
	 * ```javascript
	 * var pako = require('pako')
	 *   , data = Uint8Array([1,2,3,4,5,6,7,8,9]);
	 *
	 * console.log(pako.deflate(data));
	 * ```
	 **/
	function deflate(input, options) {
	  var deflator = new Deflate(options);
	
	  deflator.push(input, true);
	
	  // That will never happens, if you don't cheat with options :)
	  if (deflator.err) { throw deflator.msg || msg[deflator.err]; }
	
	  return deflator.result;
	}
	
	
	/**
	 * deflateRaw(data[, options]) -> Uint8Array|Array|String
	 * - data (Uint8Array|Array|String): input data to compress.
	 * - options (Object): zlib deflate options.
	 *
	 * The same as [[deflate]], but creates raw data, without wrapper
	 * (header and adler32 crc).
	 **/
	function deflateRaw(input, options) {
	  options = options || {};
	  options.raw = true;
	  return deflate(input, options);
	}
	
	
	/**
	 * gzip(data[, options]) -> Uint8Array|Array|String
	 * - data (Uint8Array|Array|String): input data to compress.
	 * - options (Object): zlib deflate options.
	 *
	 * The same as [[deflate]], but create gzip wrapper instead of
	 * deflate one.
	 **/
	function gzip(input, options) {
	  options = options || {};
	  options.gzip = true;
	  return deflate(input, options);
	}
	
	
	exports.Deflate = Deflate;
	exports.deflate = deflate;
	exports.deflateRaw = deflateRaw;
	exports.gzip = gzip;


/***/ },
/* 1356 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	
	var zlib_inflate = __webpack_require__(1360);
	var utils        = __webpack_require__(99);
	var strings      = __webpack_require__(594);
	var c            = __webpack_require__(596);
	var msg          = __webpack_require__(277);
	var ZStream      = __webpack_require__(598);
	var GZheader     = __webpack_require__(1358);
	
	var toString = Object.prototype.toString;
	
	/**
	 * class Inflate
	 *
	 * Generic JS-style wrapper for zlib calls. If you don't need
	 * streaming behaviour - use more simple functions: [[inflate]]
	 * and [[inflateRaw]].
	 **/
	
	/* internal
	 * inflate.chunks -> Array
	 *
	 * Chunks of output data, if [[Inflate#onData]] not overridden.
	 **/
	
	/**
	 * Inflate.result -> Uint8Array|Array|String
	 *
	 * Uncompressed result, generated by default [[Inflate#onData]]
	 * and [[Inflate#onEnd]] handlers. Filled after you push last chunk
	 * (call [[Inflate#push]] with `Z_FINISH` / `true` param) or if you
	 * push a chunk with explicit flush (call [[Inflate#push]] with
	 * `Z_SYNC_FLUSH` param).
	 **/
	
	/**
	 * Inflate.err -> Number
	 *
	 * Error code after inflate finished. 0 (Z_OK) on success.
	 * Should be checked if broken data possible.
	 **/
	
	/**
	 * Inflate.msg -> String
	 *
	 * Error message, if [[Inflate.err]] != 0
	 **/
	
	
	/**
	 * new Inflate(options)
	 * - options (Object): zlib inflate options.
	 *
	 * Creates new inflator instance with specified params. Throws exception
	 * on bad params. Supported options:
	 *
	 * - `windowBits`
	 * - `dictionary`
	 *
	 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
	 * for more information on these.
	 *
	 * Additional options, for internal needs:
	 *
	 * - `chunkSize` - size of generated data chunks (16K by default)
	 * - `raw` (Boolean) - do raw inflate
	 * - `to` (String) - if equal to 'string', then result will be converted
	 *   from utf8 to utf16 (javascript) string. When string output requested,
	 *   chunk length can differ from `chunkSize`, depending on content.
	 *
	 * By default, when no options set, autodetect deflate/gzip data format via
	 * wrapper header.
	 *
	 * ##### Example:
	 *
	 * ```javascript
	 * var pako = require('pako')
	 *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
	 *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
	 *
	 * var inflate = new pako.Inflate({ level: 3});
	 *
	 * inflate.push(chunk1, false);
	 * inflate.push(chunk2, true);  // true -> last chunk
	 *
	 * if (inflate.err) { throw new Error(inflate.err); }
	 *
	 * console.log(inflate.result);
	 * ```
	 **/
	function Inflate(options) {
	  if (!(this instanceof Inflate)) return new Inflate(options);
	
	  this.options = utils.assign({
	    chunkSize: 16384,
	    windowBits: 0,
	    to: ''
	  }, options || {});
	
	  var opt = this.options;
	
	  // Force window size for `raw` data, if not set directly,
	  // because we have no header for autodetect.
	  if (opt.raw && (opt.windowBits >= 0) && (opt.windowBits < 16)) {
	    opt.windowBits = -opt.windowBits;
	    if (opt.windowBits === 0) { opt.windowBits = -15; }
	  }
	
	  // If `windowBits` not defined (and mode not raw) - set autodetect flag for gzip/deflate
	  if ((opt.windowBits >= 0) && (opt.windowBits < 16) &&
	      !(options && options.windowBits)) {
	    opt.windowBits += 32;
	  }
	
	  // Gzip header has no info about windows size, we can do autodetect only
	  // for deflate. So, if window size not set, force it to max when gzip possible
	  if ((opt.windowBits > 15) && (opt.windowBits < 48)) {
	    // bit 3 (16) -> gzipped data
	    // bit 4 (32) -> autodetect gzip/deflate
	    if ((opt.windowBits & 15) === 0) {
	      opt.windowBits |= 15;
	    }
	  }
	
	  this.err    = 0;      // error code, if happens (0 = Z_OK)
	  this.msg    = '';     // error message
	  this.ended  = false;  // used to avoid multiple onEnd() calls
	  this.chunks = [];     // chunks of compressed data
	
	  this.strm   = new ZStream();
	  this.strm.avail_out = 0;
	
	  var status  = zlib_inflate.inflateInit2(
	    this.strm,
	    opt.windowBits
	  );
	
	  if (status !== c.Z_OK) {
	    throw new Error(msg[status]);
	  }
	
	  this.header = new GZheader();
	
	  zlib_inflate.inflateGetHeader(this.strm, this.header);
	
	  // Setup dictionary
	  if (opt.dictionary) {
	    // Convert data if needed
	    if (typeof opt.dictionary === 'string') {
	      opt.dictionary = strings.string2buf(opt.dictionary);
	    } else if (toString.call(opt.dictionary) === '[object ArrayBuffer]') {
	      opt.dictionary = new Uint8Array(opt.dictionary);
	    }
	    if (opt.raw) { //In raw mode we need to set the dictionary early
	      status = zlib_inflate.inflateSetDictionary(this.strm, opt.dictionary);
	      if (status !== c.Z_OK) {
	        throw new Error(msg[status]);
	      }
	    }
	  }
	}
	
	/**
	 * Inflate#push(data[, mode]) -> Boolean
	 * - data (Uint8Array|Array|ArrayBuffer|String): input data
	 * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
	 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
	 *
	 * Sends input data to inflate pipe, generating [[Inflate#onData]] calls with
	 * new output chunks. Returns `true` on success. The last data block must have
	 * mode Z_FINISH (or `true`). That will flush internal pending buffers and call
	 * [[Inflate#onEnd]]. For interim explicit flushes (without ending the stream) you
	 * can use mode Z_SYNC_FLUSH, keeping the decompression context.
	 *
	 * On fail call [[Inflate#onEnd]] with error code and return false.
	 *
	 * We strongly recommend to use `Uint8Array` on input for best speed (output
	 * format is detected automatically). Also, don't skip last param and always
	 * use the same type in your code (boolean or number). That will improve JS speed.
	 *
	 * For regular `Array`-s make sure all elements are [0..255].
	 *
	 * ##### Example
	 *
	 * ```javascript
	 * push(chunk, false); // push one of data chunks
	 * ...
	 * push(chunk, true);  // push last chunk
	 * ```
	 **/
	Inflate.prototype.push = function (data, mode) {
	  var strm = this.strm;
	  var chunkSize = this.options.chunkSize;
	  var dictionary = this.options.dictionary;
	  var status, _mode;
	  var next_out_utf8, tail, utf8str;
	
	  // Flag to properly process Z_BUF_ERROR on testing inflate call
	  // when we check that all output data was flushed.
	  var allowBufError = false;
	
	  if (this.ended) { return false; }
	  _mode = (mode === ~~mode) ? mode : ((mode === true) ? c.Z_FINISH : c.Z_NO_FLUSH);
	
	  // Convert data if needed
	  if (typeof data === 'string') {
	    // Only binary strings can be decompressed on practice
	    strm.input = strings.binstring2buf(data);
	  } else if (toString.call(data) === '[object ArrayBuffer]') {
	    strm.input = new Uint8Array(data);
	  } else {
	    strm.input = data;
	  }
	
	  strm.next_in = 0;
	  strm.avail_in = strm.input.length;
	
	  do {
	    if (strm.avail_out === 0) {
	      strm.output = new utils.Buf8(chunkSize);
	      strm.next_out = 0;
	      strm.avail_out = chunkSize;
	    }
	
	    status = zlib_inflate.inflate(strm, c.Z_NO_FLUSH);    /* no bad return value */
	
	    if (status === c.Z_NEED_DICT && dictionary) {
	      status = zlib_inflate.inflateSetDictionary(this.strm, dictionary);
	    }
	
	    if (status === c.Z_BUF_ERROR && allowBufError === true) {
	      status = c.Z_OK;
	      allowBufError = false;
	    }
	
	    if (status !== c.Z_STREAM_END && status !== c.Z_OK) {
	      this.onEnd(status);
	      this.ended = true;
	      return false;
	    }
	
	    if (strm.next_out) {
	      if (strm.avail_out === 0 || status === c.Z_STREAM_END || (strm.avail_in === 0 && (_mode === c.Z_FINISH || _mode === c.Z_SYNC_FLUSH))) {
	
	        if (this.options.to === 'string') {
	
	          next_out_utf8 = strings.utf8border(strm.output, strm.next_out);
	
	          tail = strm.next_out - next_out_utf8;
	          utf8str = strings.buf2string(strm.output, next_out_utf8);
	
	          // move tail
	          strm.next_out = tail;
	          strm.avail_out = chunkSize - tail;
	          if (tail) { utils.arraySet(strm.output, strm.output, next_out_utf8, tail, 0); }
	
	          this.onData(utf8str);
	
	        } else {
	          this.onData(utils.shrinkBuf(strm.output, strm.next_out));
	        }
	      }
	    }
	
	    // When no more input data, we should check that internal inflate buffers
	    // are flushed. The only way to do it when avail_out = 0 - run one more
	    // inflate pass. But if output data not exists, inflate return Z_BUF_ERROR.
	    // Here we set flag to process this error properly.
	    //
	    // NOTE. Deflate does not return error in this case and does not needs such
	    // logic.
	    if (strm.avail_in === 0 && strm.avail_out === 0) {
	      allowBufError = true;
	    }
	
	  } while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== c.Z_STREAM_END);
	
	  if (status === c.Z_STREAM_END) {
	    _mode = c.Z_FINISH;
	  }
	
	  // Finalize on the last chunk.
	  if (_mode === c.Z_FINISH) {
	    status = zlib_inflate.inflateEnd(this.strm);
	    this.onEnd(status);
	    this.ended = true;
	    return status === c.Z_OK;
	  }
	
	  // callback interim results if Z_SYNC_FLUSH.
	  if (_mode === c.Z_SYNC_FLUSH) {
	    this.onEnd(c.Z_OK);
	    strm.avail_out = 0;
	    return true;
	  }
	
	  return true;
	};
	
	
	/**
	 * Inflate#onData(chunk) -> Void
	 * - chunk (Uint8Array|Array|String): output data. Type of array depends
	 *   on js engine support. When string output requested, each chunk
	 *   will be string.
	 *
	 * By default, stores data blocks in `chunks[]` property and glue
	 * those in `onEnd`. Override this handler, if you need another behaviour.
	 **/
	Inflate.prototype.onData = function (chunk) {
	  this.chunks.push(chunk);
	};
	
	
	/**
	 * Inflate#onEnd(status) -> Void
	 * - status (Number): inflate status. 0 (Z_OK) on success,
	 *   other if not.
	 *
	 * Called either after you tell inflate that the input stream is
	 * complete (Z_FINISH) or should be flushed (Z_SYNC_FLUSH)
	 * or if an error happened. By default - join collected chunks,
	 * free memory and fill `results` / `err` properties.
	 **/
	Inflate.prototype.onEnd = function (status) {
	  // On success - join
	  if (status === c.Z_OK) {
	    if (this.options.to === 'string') {
	      // Glue & convert here, until we teach pako to send
	      // utf8 aligned strings to onData
	      this.result = this.chunks.join('');
	    } else {
	      this.result = utils.flattenChunks(this.chunks);
	    }
	  }
	  this.chunks = [];
	  this.err = status;
	  this.msg = this.strm.msg;
	};
	
	
	/**
	 * inflate(data[, options]) -> Uint8Array|Array|String
	 * - data (Uint8Array|Array|String): input data to decompress.
	 * - options (Object): zlib inflate options.
	 *
	 * Decompress `data` with inflate/ungzip and `options`. Autodetect
	 * format via wrapper header by default. That's why we don't provide
	 * separate `ungzip` method.
	 *
	 * Supported options are:
	 *
	 * - windowBits
	 *
	 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
	 * for more information.
	 *
	 * Sugar (options):
	 *
	 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
	 *   negative windowBits implicitly.
	 * - `to` (String) - if equal to 'string', then result will be converted
	 *   from utf8 to utf16 (javascript) string. When string output requested,
	 *   chunk length can differ from `chunkSize`, depending on content.
	 *
	 *
	 * ##### Example:
	 *
	 * ```javascript
	 * var pako = require('pako')
	 *   , input = pako.deflate([1,2,3,4,5,6,7,8,9])
	 *   , output;
	 *
	 * try {
	 *   output = pako.inflate(input);
	 * } catch (err)
	 *   console.log(err);
	 * }
	 * ```
	 **/
	function inflate(input, options) {
	  var inflator = new Inflate(options);
	
	  inflator.push(input, true);
	
	  // That will never happens, if you don't cheat with options :)
	  if (inflator.err) { throw inflator.msg || msg[inflator.err]; }
	
	  return inflator.result;
	}
	
	
	/**
	 * inflateRaw(data[, options]) -> Uint8Array|Array|String
	 * - data (Uint8Array|Array|String): input data to decompress.
	 * - options (Object): zlib inflate options.
	 *
	 * The same as [[inflate]], but creates raw data, without wrapper
	 * (header and adler32 crc).
	 **/
	function inflateRaw(input, options) {
	  options = options || {};
	  options.raw = true;
	  return inflate(input, options);
	}
	
	
	/**
	 * ungzip(data[, options]) -> Uint8Array|Array|String
	 * - data (Uint8Array|Array|String): input data to decompress.
	 * - options (Object): zlib inflate options.
	 *
	 * Just shortcut to [[inflate]], because it autodetects format
	 * by header.content. Done for convenience.
	 **/
	
	
	exports.Inflate = Inflate;
	exports.inflate = inflate;
	exports.inflateRaw = inflateRaw;
	exports.ungzip  = inflate;


/***/ },
/* 1357 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// (C) 1995-2013 Jean-loup Gailly and Mark Adler
	// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	//
	// This software is provided 'as-is', without any express or implied
	// warranty. In no event will the authors be held liable for any damages
	// arising from the use of this software.
	//
	// Permission is granted to anyone to use this software for any purpose,
	// including commercial applications, and to alter it and redistribute it
	// freely, subject to the following restrictions:
	//
	// 1. The origin of this software must not be misrepresented; you must not
	//   claim that you wrote the original software. If you use this software
	//   in a product, an acknowledgment in the product documentation would be
	//   appreciated but is not required.
	// 2. Altered source versions must be plainly marked as such, and must not be
	//   misrepresented as being the original software.
	// 3. This notice may not be removed or altered from any source distribution.
	
	var utils   = __webpack_require__(99);
	var trees   = __webpack_require__(1362);
	var adler32 = __webpack_require__(595);
	var crc32   = __webpack_require__(597);
	var msg     = __webpack_require__(277);
	
	/* Public constants ==========================================================*/
	/* ===========================================================================*/
	
	
	/* Allowed flush values; see deflate() and inflate() below for details */
	var Z_NO_FLUSH      = 0;
	var Z_PARTIAL_FLUSH = 1;
	//var Z_SYNC_FLUSH    = 2;
	var Z_FULL_FLUSH    = 3;
	var Z_FINISH        = 4;
	var Z_BLOCK         = 5;
	//var Z_TREES         = 6;
	
	
	/* Return codes for the compression/decompression functions. Negative values
	 * are errors, positive values are used for special but normal events.
	 */
	var Z_OK            = 0;
	var Z_STREAM_END    = 1;
	//var Z_NEED_DICT     = 2;
	//var Z_ERRNO         = -1;
	var Z_STREAM_ERROR  = -2;
	var Z_DATA_ERROR    = -3;
	//var Z_MEM_ERROR     = -4;
	var Z_BUF_ERROR     = -5;
	//var Z_VERSION_ERROR = -6;
	
	
	/* compression levels */
	//var Z_NO_COMPRESSION      = 0;
	//var Z_BEST_SPEED          = 1;
	//var Z_BEST_COMPRESSION    = 9;
	var Z_DEFAULT_COMPRESSION = -1;
	
	
	var Z_FILTERED            = 1;
	var Z_HUFFMAN_ONLY        = 2;
	var Z_RLE                 = 3;
	var Z_FIXED               = 4;
	var Z_DEFAULT_STRATEGY    = 0;
	
	/* Possible values of the data_type field (though see inflate()) */
	//var Z_BINARY              = 0;
	//var Z_TEXT                = 1;
	//var Z_ASCII               = 1; // = Z_TEXT
	var Z_UNKNOWN             = 2;
	
	
	/* The deflate compression method */
	var Z_DEFLATED  = 8;
	
	/*============================================================================*/
	
	
	var MAX_MEM_LEVEL = 9;
	/* Maximum value for memLevel in deflateInit2 */
	var MAX_WBITS = 15;
	/* 32K LZ77 window */
	var DEF_MEM_LEVEL = 8;
	
	
	var LENGTH_CODES  = 29;
	/* number of length codes, not counting the special END_BLOCK code */
	var LITERALS      = 256;
	/* number of literal bytes 0..255 */
	var L_CODES       = LITERALS + 1 + LENGTH_CODES;
	/* number of Literal or Length codes, including the END_BLOCK code */
	var D_CODES       = 30;
	/* number of distance codes */
	var BL_CODES      = 19;
	/* number of codes used to transfer the bit lengths */
	var HEAP_SIZE     = 2 * L_CODES + 1;
	/* maximum heap size */
	var MAX_BITS  = 15;
	/* All codes must not exceed MAX_BITS bits */
	
	var MIN_MATCH = 3;
	var MAX_MATCH = 258;
	var MIN_LOOKAHEAD = (MAX_MATCH + MIN_MATCH + 1);
	
	var PRESET_DICT = 0x20;
	
	var INIT_STATE = 42;
	var EXTRA_STATE = 69;
	var NAME_STATE = 73;
	var COMMENT_STATE = 91;
	var HCRC_STATE = 103;
	var BUSY_STATE = 113;
	var FINISH_STATE = 666;
	
	var BS_NEED_MORE      = 1; /* block not completed, need more input or more output */
	var BS_BLOCK_DONE     = 2; /* block flush performed */
	var BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */
	var BS_FINISH_DONE    = 4; /* finish done, accept no more input or output */
	
	var OS_CODE = 0x03; // Unix :) . Don't detect, use this default.
	
	function err(strm, errorCode) {
	  strm.msg = msg[errorCode];
	  return errorCode;
	}
	
	function rank(f) {
	  return ((f) << 1) - ((f) > 4 ? 9 : 0);
	}
	
	function zero(buf) { var len = buf.length; while (--len >= 0) { buf[len] = 0; } }
	
	
	/* =========================================================================
	 * Flush as much pending output as possible. All deflate() output goes
	 * through this function so some applications may wish to modify it
	 * to avoid allocating a large strm->output buffer and copying into it.
	 * (See also read_buf()).
	 */
	function flush_pending(strm) {
	  var s = strm.state;
	
	  //_tr_flush_bits(s);
	  var len = s.pending;
	  if (len > strm.avail_out) {
	    len = strm.avail_out;
	  }
	  if (len === 0) { return; }
	
	  utils.arraySet(strm.output, s.pending_buf, s.pending_out, len, strm.next_out);
	  strm.next_out += len;
	  s.pending_out += len;
	  strm.total_out += len;
	  strm.avail_out -= len;
	  s.pending -= len;
	  if (s.pending === 0) {
	    s.pending_out = 0;
	  }
	}
	
	
	function flush_block_only(s, last) {
	  trees._tr_flush_block(s, (s.block_start >= 0 ? s.block_start : -1), s.strstart - s.block_start, last);
	  s.block_start = s.strstart;
	  flush_pending(s.strm);
	}
	
	
	function put_byte(s, b) {
	  s.pending_buf[s.pending++] = b;
	}
	
	
	/* =========================================================================
	 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
	 * IN assertion: the stream state is correct and there is enough room in
	 * pending_buf.
	 */
	function putShortMSB(s, b) {
	//  put_byte(s, (Byte)(b >> 8));
	//  put_byte(s, (Byte)(b & 0xff));
	  s.pending_buf[s.pending++] = (b >>> 8) & 0xff;
	  s.pending_buf[s.pending++] = b & 0xff;
	}
	
	
	/* ===========================================================================
	 * Read a new buffer from the current input stream, update the adler32
	 * and total number of bytes read.  All deflate() input goes through
	 * this function so some applications may wish to modify it to avoid
	 * allocating a large strm->input buffer and copying from it.
	 * (See also flush_pending()).
	 */
	function read_buf(strm, buf, start, size) {
	  var len = strm.avail_in;
	
	  if (len > size) { len = size; }
	  if (len === 0) { return 0; }
	
	  strm.avail_in -= len;
	
	  // zmemcpy(buf, strm->next_in, len);
	  utils.arraySet(buf, strm.input, strm.next_in, len, start);
	  if (strm.state.wrap === 1) {
	    strm.adler = adler32(strm.adler, buf, len, start);
	  }
	
	  else if (strm.state.wrap === 2) {
	    strm.adler = crc32(strm.adler, buf, len, start);
	  }
	
	  strm.next_in += len;
	  strm.total_in += len;
	
	  return len;
	}
	
	
	/* ===========================================================================
	 * Set match_start to the longest match starting at the given string and
	 * return its length. Matches shorter or equal to prev_length are discarded,
	 * in which case the result is equal to prev_length and match_start is
	 * garbage.
	 * IN assertions: cur_match is the head of the hash chain for the current
	 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
	 * OUT assertion: the match length is not greater than s->lookahead.
	 */
	function longest_match(s, cur_match) {
	  var chain_length = s.max_chain_length;      /* max hash chain length */
	  var scan = s.strstart; /* current string */
	  var match;                       /* matched string */
	  var len;                           /* length of current match */
	  var best_len = s.prev_length;              /* best match length so far */
	  var nice_match = s.nice_match;             /* stop if match long enough */
	  var limit = (s.strstart > (s.w_size - MIN_LOOKAHEAD)) ?
	      s.strstart - (s.w_size - MIN_LOOKAHEAD) : 0/*NIL*/;
	
	  var _win = s.window; // shortcut
	
	  var wmask = s.w_mask;
	  var prev  = s.prev;
	
	  /* Stop when cur_match becomes <= limit. To simplify the code,
	   * we prevent matches with the string of window index 0.
	   */
	
	  var strend = s.strstart + MAX_MATCH;
	  var scan_end1  = _win[scan + best_len - 1];
	  var scan_end   = _win[scan + best_len];
	
	  /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
	   * It is easy to get rid of this optimization if necessary.
	   */
	  // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");
	
	  /* Do not waste too much time if we already have a good match: */
	  if (s.prev_length >= s.good_match) {
	    chain_length >>= 2;
	  }
	  /* Do not look for matches beyond the end of the input. This is necessary
	   * to make deflate deterministic.
	   */
	  if (nice_match > s.lookahead) { nice_match = s.lookahead; }
	
	  // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");
	
	  do {
	    // Assert(cur_match < s->strstart, "no future");
	    match = cur_match;
	
	    /* Skip to next match if the match length cannot increase
	     * or if the match length is less than 2.  Note that the checks below
	     * for insufficient lookahead only occur occasionally for performance
	     * reasons.  Therefore uninitialized memory will be accessed, and
	     * conditional jumps will be made that depend on those values.
	     * However the length of the match is limited to the lookahead, so
	     * the output of deflate is not affected by the uninitialized values.
	     */
	
	    if (_win[match + best_len]     !== scan_end  ||
	        _win[match + best_len - 1] !== scan_end1 ||
	        _win[match]                !== _win[scan] ||
	        _win[++match]              !== _win[scan + 1]) {
	      continue;
	    }
	
	    /* The check at best_len-1 can be removed because it will be made
	     * again later. (This heuristic is not always a win.)
	     * It is not necessary to compare scan[2] and match[2] since they
	     * are always equal when the other bytes match, given that
	     * the hash keys are equal and that HASH_BITS >= 8.
	     */
	    scan += 2;
	    match++;
	    // Assert(*scan == *match, "match[2]?");
	
	    /* We check for insufficient lookahead only every 8th comparison;
	     * the 256th check will be made at strstart+258.
	     */
	    do {
	      /*jshint noempty:false*/
	    } while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	             scan < strend);
	
	    // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");
	
	    len = MAX_MATCH - (strend - scan);
	    scan = strend - MAX_MATCH;
	
	    if (len > best_len) {
	      s.match_start = cur_match;
	      best_len = len;
	      if (len >= nice_match) {
	        break;
	      }
	      scan_end1  = _win[scan + best_len - 1];
	      scan_end   = _win[scan + best_len];
	    }
	  } while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);
	
	  if (best_len <= s.lookahead) {
	    return best_len;
	  }
	  return s.lookahead;
	}
	
	
	/* ===========================================================================
	 * Fill the window when the lookahead becomes insufficient.
	 * Updates strstart and lookahead.
	 *
	 * IN assertion: lookahead < MIN_LOOKAHEAD
	 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
	 *    At least one byte has been read, or avail_in == 0; reads are
	 *    performed for at least two bytes (required for the zip translate_eol
	 *    option -- not supported here).
	 */
	function fill_window(s) {
	  var _w_size = s.w_size;
	  var p, n, m, more, str;
	
	  //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");
	
	  do {
	    more = s.window_size - s.lookahead - s.strstart;
	
	    // JS ints have 32 bit, block below not needed
	    /* Deal with !@#$% 64K limit: */
	    //if (sizeof(int) <= 2) {
	    //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
	    //        more = wsize;
	    //
	    //  } else if (more == (unsigned)(-1)) {
	    //        /* Very unlikely, but possible on 16 bit machine if
	    //         * strstart == 0 && lookahead == 1 (input done a byte at time)
	    //         */
	    //        more--;
	    //    }
	    //}
	
	
	    /* If the window is almost full and there is insufficient lookahead,
	     * move the upper half to the lower one to make room in the upper half.
	     */
	    if (s.strstart >= _w_size + (_w_size - MIN_LOOKAHEAD)) {
	
	      utils.arraySet(s.window, s.window, _w_size, _w_size, 0);
	      s.match_start -= _w_size;
	      s.strstart -= _w_size;
	      /* we now have strstart >= MAX_DIST */
	      s.block_start -= _w_size;
	
	      /* Slide the hash table (could be avoided with 32 bit values
	       at the expense of memory usage). We slide even when level == 0
	       to keep the hash table consistent if we switch back to level > 0
	       later. (Using level 0 permanently is not an optimal usage of
	       zlib, so we don't care about this pathological case.)
	       */
	
	      n = s.hash_size;
	      p = n;
	      do {
	        m = s.head[--p];
	        s.head[p] = (m >= _w_size ? m - _w_size : 0);
	      } while (--n);
	
	      n = _w_size;
	      p = n;
	      do {
	        m = s.prev[--p];
	        s.prev[p] = (m >= _w_size ? m - _w_size : 0);
	        /* If n is not on any hash chain, prev[n] is garbage but
	         * its value will never be used.
	         */
	      } while (--n);
	
	      more += _w_size;
	    }
	    if (s.strm.avail_in === 0) {
	      break;
	    }
	
	    /* If there was no sliding:
	     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
	     *    more == window_size - lookahead - strstart
	     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
	     * => more >= window_size - 2*WSIZE + 2
	     * In the BIG_MEM or MMAP case (not yet supported),
	     *   window_size == input_size + MIN_LOOKAHEAD  &&
	     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
	     * Otherwise, window_size == 2*WSIZE so more >= 2.
	     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
	     */
	    //Assert(more >= 2, "more < 2");
	    n = read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
	    s.lookahead += n;
	
	    /* Initialize the hash value now that we have some input: */
	    if (s.lookahead + s.insert >= MIN_MATCH) {
	      str = s.strstart - s.insert;
	      s.ins_h = s.window[str];
	
	      /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */
	      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + 1]) & s.hash_mask;
	//#if MIN_MATCH != 3
	//        Call update_hash() MIN_MATCH-3 more times
	//#endif
	      while (s.insert) {
	        /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
	        s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;
	
	        s.prev[str & s.w_mask] = s.head[s.ins_h];
	        s.head[s.ins_h] = str;
	        str++;
	        s.insert--;
	        if (s.lookahead + s.insert < MIN_MATCH) {
	          break;
	        }
	      }
	    }
	    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
	     * but this is not important since only literal bytes will be emitted.
	     */
	
	  } while (s.lookahead < MIN_LOOKAHEAD && s.strm.avail_in !== 0);
	
	  /* If the WIN_INIT bytes after the end of the current data have never been
	   * written, then zero those bytes in order to avoid memory check reports of
	   * the use of uninitialized (or uninitialised as Julian writes) bytes by
	   * the longest match routines.  Update the high water mark for the next
	   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
	   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
	   */
	//  if (s.high_water < s.window_size) {
	//    var curr = s.strstart + s.lookahead;
	//    var init = 0;
	//
	//    if (s.high_water < curr) {
	//      /* Previous high water mark below current data -- zero WIN_INIT
	//       * bytes or up to end of window, whichever is less.
	//       */
	//      init = s.window_size - curr;
	//      if (init > WIN_INIT)
	//        init = WIN_INIT;
	//      zmemzero(s->window + curr, (unsigned)init);
	//      s->high_water = curr + init;
	//    }
	//    else if (s->high_water < (ulg)curr + WIN_INIT) {
	//      /* High water mark at or above current data, but below current data
	//       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
	//       * to end of window, whichever is less.
	//       */
	//      init = (ulg)curr + WIN_INIT - s->high_water;
	//      if (init > s->window_size - s->high_water)
	//        init = s->window_size - s->high_water;
	//      zmemzero(s->window + s->high_water, (unsigned)init);
	//      s->high_water += init;
	//    }
	//  }
	//
	//  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
	//    "not enough room for search");
	}
	
	/* ===========================================================================
	 * Copy without compression as much as possible from the input stream, return
	 * the current block state.
	 * This function does not insert new strings in the dictionary since
	 * uncompressible data is probably not useful. This function is used
	 * only for the level=0 compression option.
	 * NOTE: this function should be optimized to avoid extra copying from
	 * window to pending_buf.
	 */
	function deflate_stored(s, flush) {
	  /* Stored blocks are limited to 0xffff bytes, pending_buf is limited
	   * to pending_buf_size, and each stored block has a 5 byte header:
	   */
	  var max_block_size = 0xffff;
	
	  if (max_block_size > s.pending_buf_size - 5) {
	    max_block_size = s.pending_buf_size - 5;
	  }
	
	  /* Copy as much as possible from input to output: */
	  for (;;) {
	    /* Fill the window as much as possible: */
	    if (s.lookahead <= 1) {
	
	      //Assert(s->strstart < s->w_size+MAX_DIST(s) ||
	      //  s->block_start >= (long)s->w_size, "slide too late");
	//      if (!(s.strstart < s.w_size + (s.w_size - MIN_LOOKAHEAD) ||
	//        s.block_start >= s.w_size)) {
	//        throw  new Error("slide too late");
	//      }
	
	      fill_window(s);
	      if (s.lookahead === 0 && flush === Z_NO_FLUSH) {
	        return BS_NEED_MORE;
	      }
	
	      if (s.lookahead === 0) {
	        break;
	      }
	      /* flush the current block */
	    }
	    //Assert(s->block_start >= 0L, "block gone");
	//    if (s.block_start < 0) throw new Error("block gone");
	
	    s.strstart += s.lookahead;
	    s.lookahead = 0;
	
	    /* Emit a stored block if pending_buf will be full: */
	    var max_start = s.block_start + max_block_size;
	
	    if (s.strstart === 0 || s.strstart >= max_start) {
	      /* strstart == 0 is possible when wraparound on 16-bit machine */
	      s.lookahead = s.strstart - max_start;
	      s.strstart = max_start;
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	
	
	    }
	    /* Flush if we may have to slide, otherwise block_start may become
	     * negative and the data will be gone:
	     */
	    if (s.strstart - s.block_start >= (s.w_size - MIN_LOOKAHEAD)) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	  }
	
	  s.insert = 0;
	
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	
	  if (s.strstart > s.block_start) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	
	  return BS_NEED_MORE;
	}
	
	/* ===========================================================================
	 * Compress as much as possible from the input stream, return the current
	 * block state.
	 * This function does not perform lazy evaluation of matches and inserts
	 * new strings in the dictionary only for unmatched strings or for short
	 * matches. It is used only for the fast compression options.
	 */
	function deflate_fast(s, flush) {
	  var hash_head;        /* head of the hash chain */
	  var bflush;           /* set if current block must be flushed */
	
	  for (;;) {
	    /* Make sure that we always have enough lookahead, except
	     * at the end of the input file. We need MAX_MATCH bytes
	     * for the next match, plus MIN_MATCH bytes to insert the
	     * string following the next match.
	     */
	    if (s.lookahead < MIN_LOOKAHEAD) {
	      fill_window(s);
	      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
	        return BS_NEED_MORE;
	      }
	      if (s.lookahead === 0) {
	        break; /* flush the current block */
	      }
	    }
	
	    /* Insert the string window[strstart .. strstart+2] in the
	     * dictionary, and set hash_head to the head of the hash chain:
	     */
	    hash_head = 0/*NIL*/;
	    if (s.lookahead >= MIN_MATCH) {
	      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
	      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	      s.head[s.ins_h] = s.strstart;
	      /***/
	    }
	
	    /* Find the longest match, discarding those <= prev_length.
	     * At this point we have always match_length < MIN_MATCH
	     */
	    if (hash_head !== 0/*NIL*/ && ((s.strstart - hash_head) <= (s.w_size - MIN_LOOKAHEAD))) {
	      /* To simplify the code, we prevent matches with the string
	       * of window index 0 (in particular we have to avoid a match
	       * of the string with itself at the start of the input file).
	       */
	      s.match_length = longest_match(s, hash_head);
	      /* longest_match() sets match_start */
	    }
	    if (s.match_length >= MIN_MATCH) {
	      // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only
	
	      /*** _tr_tally_dist(s, s.strstart - s.match_start,
	                     s.match_length - MIN_MATCH, bflush); ***/
	      bflush = trees._tr_tally(s, s.strstart - s.match_start, s.match_length - MIN_MATCH);
	
	      s.lookahead -= s.match_length;
	
	      /* Insert new strings in the hash table only if the match length
	       * is not too large. This saves time but degrades compression.
	       */
	      if (s.match_length <= s.max_lazy_match/*max_insert_length*/ && s.lookahead >= MIN_MATCH) {
	        s.match_length--; /* string at strstart already in table */
	        do {
	          s.strstart++;
	          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	          s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
	          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	          s.head[s.ins_h] = s.strstart;
	          /***/
	          /* strstart never exceeds WSIZE-MAX_MATCH, so there are
	           * always MIN_MATCH bytes ahead.
	           */
	        } while (--s.match_length !== 0);
	        s.strstart++;
	      } else
	      {
	        s.strstart += s.match_length;
	        s.match_length = 0;
	        s.ins_h = s.window[s.strstart];
	        /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */
	        s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + 1]) & s.hash_mask;
	
	//#if MIN_MATCH != 3
	//                Call UPDATE_HASH() MIN_MATCH-3 more times
	//#endif
	        /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
	         * matter since it will be recomputed at next deflate call.
	         */
	      }
	    } else {
	      /* No match, output a literal byte */
	      //Tracevv((stderr,"%c", s.window[s.strstart]));
	      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
	      bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
	
	      s.lookahead--;
	      s.strstart++;
	    }
	    if (bflush) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	  }
	  s.insert = ((s.strstart < (MIN_MATCH - 1)) ? s.strstart : MIN_MATCH - 1);
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	  if (s.last_lit) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	  return BS_BLOCK_DONE;
	}
	
	/* ===========================================================================
	 * Same as above, but achieves better compression. We use a lazy
	 * evaluation for matches: a match is finally adopted only if there is
	 * no better match at the next window position.
	 */
	function deflate_slow(s, flush) {
	  var hash_head;          /* head of hash chain */
	  var bflush;              /* set if current block must be flushed */
	
	  var max_insert;
	
	  /* Process the input block. */
	  for (;;) {
	    /* Make sure that we always have enough lookahead, except
	     * at the end of the input file. We need MAX_MATCH bytes
	     * for the next match, plus MIN_MATCH bytes to insert the
	     * string following the next match.
	     */
	    if (s.lookahead < MIN_LOOKAHEAD) {
	      fill_window(s);
	      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
	        return BS_NEED_MORE;
	      }
	      if (s.lookahead === 0) { break; } /* flush the current block */
	    }
	
	    /* Insert the string window[strstart .. strstart+2] in the
	     * dictionary, and set hash_head to the head of the hash chain:
	     */
	    hash_head = 0/*NIL*/;
	    if (s.lookahead >= MIN_MATCH) {
	      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
	      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	      s.head[s.ins_h] = s.strstart;
	      /***/
	    }
	
	    /* Find the longest match, discarding those <= prev_length.
	     */
	    s.prev_length = s.match_length;
	    s.prev_match = s.match_start;
	    s.match_length = MIN_MATCH - 1;
	
	    if (hash_head !== 0/*NIL*/ && s.prev_length < s.max_lazy_match &&
	        s.strstart - hash_head <= (s.w_size - MIN_LOOKAHEAD)/*MAX_DIST(s)*/) {
	      /* To simplify the code, we prevent matches with the string
	       * of window index 0 (in particular we have to avoid a match
	       * of the string with itself at the start of the input file).
	       */
	      s.match_length = longest_match(s, hash_head);
	      /* longest_match() sets match_start */
	
	      if (s.match_length <= 5 &&
	         (s.strategy === Z_FILTERED || (s.match_length === MIN_MATCH && s.strstart - s.match_start > 4096/*TOO_FAR*/))) {
	
	        /* If prev_match is also MIN_MATCH, match_start is garbage
	         * but we will ignore the current match anyway.
	         */
	        s.match_length = MIN_MATCH - 1;
	      }
	    }
	    /* If there was a match at the previous step and the current
	     * match is not better, output the previous match:
	     */
	    if (s.prev_length >= MIN_MATCH && s.match_length <= s.prev_length) {
	      max_insert = s.strstart + s.lookahead - MIN_MATCH;
	      /* Do not insert strings in hash table beyond this. */
	
	      //check_match(s, s.strstart-1, s.prev_match, s.prev_length);
	
	      /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
	                     s.prev_length - MIN_MATCH, bflush);***/
	      bflush = trees._tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - MIN_MATCH);
	      /* Insert in hash table all strings up to the end of the match.
	       * strstart-1 and strstart are already inserted. If there is not
	       * enough lookahead, the last two strings are not inserted in
	       * the hash table.
	       */
	      s.lookahead -= s.prev_length - 1;
	      s.prev_length -= 2;
	      do {
	        if (++s.strstart <= max_insert) {
	          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	          s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
	          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	          s.head[s.ins_h] = s.strstart;
	          /***/
	        }
	      } while (--s.prev_length !== 0);
	      s.match_available = 0;
	      s.match_length = MIN_MATCH - 1;
	      s.strstart++;
	
	      if (bflush) {
	        /*** FLUSH_BLOCK(s, 0); ***/
	        flush_block_only(s, false);
	        if (s.strm.avail_out === 0) {
	          return BS_NEED_MORE;
	        }
	        /***/
	      }
	
	    } else if (s.match_available) {
	      /* If there was no match at the previous position, output a
	       * single literal. If there was a match but the current match
	       * is longer, truncate the previous match to a single literal.
	       */
	      //Tracevv((stderr,"%c", s->window[s->strstart-1]));
	      /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
	      bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);
	
	      if (bflush) {
	        /*** FLUSH_BLOCK_ONLY(s, 0) ***/
	        flush_block_only(s, false);
	        /***/
	      }
	      s.strstart++;
	      s.lookahead--;
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	    } else {
	      /* There is no previous match to compare with, wait for
	       * the next step to decide.
	       */
	      s.match_available = 1;
	      s.strstart++;
	      s.lookahead--;
	    }
	  }
	  //Assert (flush != Z_NO_FLUSH, "no flush?");
	  if (s.match_available) {
	    //Tracevv((stderr,"%c", s->window[s->strstart-1]));
	    /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
	    bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);
	
	    s.match_available = 0;
	  }
	  s.insert = s.strstart < MIN_MATCH - 1 ? s.strstart : MIN_MATCH - 1;
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	  if (s.last_lit) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	
	  return BS_BLOCK_DONE;
	}
	
	
	/* ===========================================================================
	 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
	 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
	 * deflate switches away from Z_RLE.)
	 */
	function deflate_rle(s, flush) {
	  var bflush;            /* set if current block must be flushed */
	  var prev;              /* byte at distance one to match */
	  var scan, strend;      /* scan goes up to strend for length of run */
	
	  var _win = s.window;
	
	  for (;;) {
	    /* Make sure that we always have enough lookahead, except
	     * at the end of the input file. We need MAX_MATCH bytes
	     * for the longest run, plus one for the unrolled loop.
	     */
	    if (s.lookahead <= MAX_MATCH) {
	      fill_window(s);
	      if (s.lookahead <= MAX_MATCH && flush === Z_NO_FLUSH) {
	        return BS_NEED_MORE;
	      }
	      if (s.lookahead === 0) { break; } /* flush the current block */
	    }
	
	    /* See how many times the previous byte repeats */
	    s.match_length = 0;
	    if (s.lookahead >= MIN_MATCH && s.strstart > 0) {
	      scan = s.strstart - 1;
	      prev = _win[scan];
	      if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
	        strend = s.strstart + MAX_MATCH;
	        do {
	          /*jshint noempty:false*/
	        } while (prev === _win[++scan] && prev === _win[++scan] &&
	                 prev === _win[++scan] && prev === _win[++scan] &&
	                 prev === _win[++scan] && prev === _win[++scan] &&
	                 prev === _win[++scan] && prev === _win[++scan] &&
	                 scan < strend);
	        s.match_length = MAX_MATCH - (strend - scan);
	        if (s.match_length > s.lookahead) {
	          s.match_length = s.lookahead;
	        }
	      }
	      //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
	    }
	
	    /* Emit match if have run of MIN_MATCH or longer, else emit literal */
	    if (s.match_length >= MIN_MATCH) {
	      //check_match(s, s.strstart, s.strstart - 1, s.match_length);
	
	      /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/
	      bflush = trees._tr_tally(s, 1, s.match_length - MIN_MATCH);
	
	      s.lookahead -= s.match_length;
	      s.strstart += s.match_length;
	      s.match_length = 0;
	    } else {
	      /* No match, output a literal byte */
	      //Tracevv((stderr,"%c", s->window[s->strstart]));
	      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
	      bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
	
	      s.lookahead--;
	      s.strstart++;
	    }
	    if (bflush) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	  }
	  s.insert = 0;
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	  if (s.last_lit) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	  return BS_BLOCK_DONE;
	}
	
	/* ===========================================================================
	 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
	 * (It will be regenerated if this run of deflate switches away from Huffman.)
	 */
	function deflate_huff(s, flush) {
	  var bflush;             /* set if current block must be flushed */
	
	  for (;;) {
	    /* Make sure that we have a literal to write. */
	    if (s.lookahead === 0) {
	      fill_window(s);
	      if (s.lookahead === 0) {
	        if (flush === Z_NO_FLUSH) {
	          return BS_NEED_MORE;
	        }
	        break;      /* flush the current block */
	      }
	    }
	
	    /* Output a literal byte */
	    s.match_length = 0;
	    //Tracevv((stderr,"%c", s->window[s->strstart]));
	    /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
	    bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
	    s.lookahead--;
	    s.strstart++;
	    if (bflush) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	  }
	  s.insert = 0;
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	  if (s.last_lit) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	  return BS_BLOCK_DONE;
	}
	
	/* Values for max_lazy_match, good_match and max_chain_length, depending on
	 * the desired pack level (0..9). The values given below have been tuned to
	 * exclude worst case performance for pathological files. Better values may be
	 * found for specific files.
	 */
	function Config(good_length, max_lazy, nice_length, max_chain, func) {
	  this.good_length = good_length;
	  this.max_lazy = max_lazy;
	  this.nice_length = nice_length;
	  this.max_chain = max_chain;
	  this.func = func;
	}
	
	var configuration_table;
	
	configuration_table = [
	  /*      good lazy nice chain */
	  new Config(0, 0, 0, 0, deflate_stored),          /* 0 store only */
	  new Config(4, 4, 8, 4, deflate_fast),            /* 1 max speed, no lazy matches */
	  new Config(4, 5, 16, 8, deflate_fast),           /* 2 */
	  new Config(4, 6, 32, 32, deflate_fast),          /* 3 */
	
	  new Config(4, 4, 16, 16, deflate_slow),          /* 4 lazy matches */
	  new Config(8, 16, 32, 32, deflate_slow),         /* 5 */
	  new Config(8, 16, 128, 128, deflate_slow),       /* 6 */
	  new Config(8, 32, 128, 256, deflate_slow),       /* 7 */
	  new Config(32, 128, 258, 1024, deflate_slow),    /* 8 */
	  new Config(32, 258, 258, 4096, deflate_slow)     /* 9 max compression */
	];
	
	
	/* ===========================================================================
	 * Initialize the "longest match" routines for a new zlib stream
	 */
	function lm_init(s) {
	  s.window_size = 2 * s.w_size;
	
	  /*** CLEAR_HASH(s); ***/
	  zero(s.head); // Fill with NIL (= 0);
	
	  /* Set the default configuration parameters:
	   */
	  s.max_lazy_match = configuration_table[s.level].max_lazy;
	  s.good_match = configuration_table[s.level].good_length;
	  s.nice_match = configuration_table[s.level].nice_length;
	  s.max_chain_length = configuration_table[s.level].max_chain;
	
	  s.strstart = 0;
	  s.block_start = 0;
	  s.lookahead = 0;
	  s.insert = 0;
	  s.match_length = s.prev_length = MIN_MATCH - 1;
	  s.match_available = 0;
	  s.ins_h = 0;
	}
	
	
	function DeflateState() {
	  this.strm = null;            /* pointer back to this zlib stream */
	  this.status = 0;            /* as the name implies */
	  this.pending_buf = null;      /* output still pending */
	  this.pending_buf_size = 0;  /* size of pending_buf */
	  this.pending_out = 0;       /* next pending byte to output to the stream */
	  this.pending = 0;           /* nb of bytes in the pending buffer */
	  this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip */
	  this.gzhead = null;         /* gzip header information to write */
	  this.gzindex = 0;           /* where in extra, name, or comment */
	  this.method = Z_DEFLATED; /* can only be DEFLATED */
	  this.last_flush = -1;   /* value of flush param for previous deflate call */
	
	  this.w_size = 0;  /* LZ77 window size (32K by default) */
	  this.w_bits = 0;  /* log2(w_size)  (8..16) */
	  this.w_mask = 0;  /* w_size - 1 */
	
	  this.window = null;
	  /* Sliding window. Input bytes are read into the second half of the window,
	   * and move to the first half later to keep a dictionary of at least wSize
	   * bytes. With this organization, matches are limited to a distance of
	   * wSize-MAX_MATCH bytes, but this ensures that IO is always
	   * performed with a length multiple of the block size.
	   */
	
	  this.window_size = 0;
	  /* Actual size of window: 2*wSize, except when the user input buffer
	   * is directly used as sliding window.
	   */
	
	  this.prev = null;
	  /* Link to older string with same hash index. To limit the size of this
	   * array to 64K, this link is maintained only for the last 32K strings.
	   * An index in this array is thus a window index modulo 32K.
	   */
	
	  this.head = null;   /* Heads of the hash chains or NIL. */
	
	  this.ins_h = 0;       /* hash index of string to be inserted */
	  this.hash_size = 0;   /* number of elements in hash table */
	  this.hash_bits = 0;   /* log2(hash_size) */
	  this.hash_mask = 0;   /* hash_size-1 */
	
	  this.hash_shift = 0;
	  /* Number of bits by which ins_h must be shifted at each input
	   * step. It must be such that after MIN_MATCH steps, the oldest
	   * byte no longer takes part in the hash key, that is:
	   *   hash_shift * MIN_MATCH >= hash_bits
	   */
	
	  this.block_start = 0;
	  /* Window position at the beginning of the current output block. Gets
	   * negative when the window is moved backwards.
	   */
	
	  this.match_length = 0;      /* length of best match */
	  this.prev_match = 0;        /* previous match */
	  this.match_available = 0;   /* set if previous match exists */
	  this.strstart = 0;          /* start of string to insert */
	  this.match_start = 0;       /* start of matching string */
	  this.lookahead = 0;         /* number of valid bytes ahead in window */
	
	  this.prev_length = 0;
	  /* Length of the best match at previous step. Matches not greater than this
	   * are discarded. This is used in the lazy match evaluation.
	   */
	
	  this.max_chain_length = 0;
	  /* To speed up deflation, hash chains are never searched beyond this
	   * length.  A higher limit improves compression ratio but degrades the
	   * speed.
	   */
	
	  this.max_lazy_match = 0;
	  /* Attempt to find a better match only when the current match is strictly
	   * smaller than this value. This mechanism is used only for compression
	   * levels >= 4.
	   */
	  // That's alias to max_lazy_match, don't use directly
	  //this.max_insert_length = 0;
	  /* Insert new strings in the hash table only if the match length is not
	   * greater than this length. This saves time but degrades compression.
	   * max_insert_length is used only for compression levels <= 3.
	   */
	
	  this.level = 0;     /* compression level (1..9) */
	  this.strategy = 0;  /* favor or force Huffman coding*/
	
	  this.good_match = 0;
	  /* Use a faster search when the previous match is longer than this */
	
	  this.nice_match = 0; /* Stop searching when current match exceeds this */
	
	              /* used by trees.c: */
	
	  /* Didn't use ct_data typedef below to suppress compiler warning */
	
	  // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
	  // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
	  // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */
	
	  // Use flat array of DOUBLE size, with interleaved fata,
	  // because JS does not support effective
	  this.dyn_ltree  = new utils.Buf16(HEAP_SIZE * 2);
	  this.dyn_dtree  = new utils.Buf16((2 * D_CODES + 1) * 2);
	  this.bl_tree    = new utils.Buf16((2 * BL_CODES + 1) * 2);
	  zero(this.dyn_ltree);
	  zero(this.dyn_dtree);
	  zero(this.bl_tree);
	
	  this.l_desc   = null;         /* desc. for literal tree */
	  this.d_desc   = null;         /* desc. for distance tree */
	  this.bl_desc  = null;         /* desc. for bit length tree */
	
	  //ush bl_count[MAX_BITS+1];
	  this.bl_count = new utils.Buf16(MAX_BITS + 1);
	  /* number of codes at each bit length for an optimal tree */
	
	  //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
	  this.heap = new utils.Buf16(2 * L_CODES + 1);  /* heap used to build the Huffman trees */
	  zero(this.heap);
	
	  this.heap_len = 0;               /* number of elements in the heap */
	  this.heap_max = 0;               /* element of largest frequency */
	  /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
	   * The same heap array is used to build all trees.
	   */
	
	  this.depth = new utils.Buf16(2 * L_CODES + 1); //uch depth[2*L_CODES+1];
	  zero(this.depth);
	  /* Depth of each subtree used as tie breaker for trees of equal frequency
	   */
	
	  this.l_buf = 0;          /* buffer index for literals or lengths */
	
	  this.lit_bufsize = 0;
	  /* Size of match buffer for literals/lengths.  There are 4 reasons for
	   * limiting lit_bufsize to 64K:
	   *   - frequencies can be kept in 16 bit counters
	   *   - if compression is not successful for the first block, all input
	   *     data is still in the window so we can still emit a stored block even
	   *     when input comes from standard input.  (This can also be done for
	   *     all blocks if lit_bufsize is not greater than 32K.)
	   *   - if compression is not successful for a file smaller than 64K, we can
	   *     even emit a stored file instead of a stored block (saving 5 bytes).
	   *     This is applicable only for zip (not gzip or zlib).
	   *   - creating new Huffman trees less frequently may not provide fast
	   *     adaptation to changes in the input data statistics. (Take for
	   *     example a binary file with poorly compressible code followed by
	   *     a highly compressible string table.) Smaller buffer sizes give
	   *     fast adaptation but have of course the overhead of transmitting
	   *     trees more frequently.
	   *   - I can't count above 4
	   */
	
	  this.last_lit = 0;      /* running index in l_buf */
	
	  this.d_buf = 0;
	  /* Buffer index for distances. To simplify the code, d_buf and l_buf have
	   * the same number of elements. To use different lengths, an extra flag
	   * array would be necessary.
	   */
	
	  this.opt_len = 0;       /* bit length of current block with optimal trees */
	  this.static_len = 0;    /* bit length of current block with static trees */
	  this.matches = 0;       /* number of string matches in current block */
	  this.insert = 0;        /* bytes at end of window left to insert */
	
	
	  this.bi_buf = 0;
	  /* Output buffer. bits are inserted starting at the bottom (least
	   * significant bits).
	   */
	  this.bi_valid = 0;
	  /* Number of valid bits in bi_buf.  All bits above the last valid bit
	   * are always zero.
	   */
	
	  // Used for window memory init. We safely ignore it for JS. That makes
	  // sense only for pointers and memory check tools.
	  //this.high_water = 0;
	  /* High water mark offset in window for initialized bytes -- bytes above
	   * this are set to zero in order to avoid memory check warnings when
	   * longest match routines access bytes past the input.  This is then
	   * updated to the new high water mark.
	   */
	}
	
	
	function deflateResetKeep(strm) {
	  var s;
	
	  if (!strm || !strm.state) {
	    return err(strm, Z_STREAM_ERROR);
	  }
	
	  strm.total_in = strm.total_out = 0;
	  strm.data_type = Z_UNKNOWN;
	
	  s = strm.state;
	  s.pending = 0;
	  s.pending_out = 0;
	
	  if (s.wrap < 0) {
	    s.wrap = -s.wrap;
	    /* was made negative by deflate(..., Z_FINISH); */
	  }
	  s.status = (s.wrap ? INIT_STATE : BUSY_STATE);
	  strm.adler = (s.wrap === 2) ?
	    0  // crc32(0, Z_NULL, 0)
	  :
	    1; // adler32(0, Z_NULL, 0)
	  s.last_flush = Z_NO_FLUSH;
	  trees._tr_init(s);
	  return Z_OK;
	}
	
	
	function deflateReset(strm) {
	  var ret = deflateResetKeep(strm);
	  if (ret === Z_OK) {
	    lm_init(strm.state);
	  }
	  return ret;
	}
	
	
	function deflateSetHeader(strm, head) {
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  if (strm.state.wrap !== 2) { return Z_STREAM_ERROR; }
	  strm.state.gzhead = head;
	  return Z_OK;
	}
	
	
	function deflateInit2(strm, level, method, windowBits, memLevel, strategy) {
	  if (!strm) { // === Z_NULL
	    return Z_STREAM_ERROR;
	  }
	  var wrap = 1;
	
	  if (level === Z_DEFAULT_COMPRESSION) {
	    level = 6;
	  }
	
	  if (windowBits < 0) { /* suppress zlib wrapper */
	    wrap = 0;
	    windowBits = -windowBits;
	  }
	
	  else if (windowBits > 15) {
	    wrap = 2;           /* write gzip wrapper instead */
	    windowBits -= 16;
	  }
	
	
	  if (memLevel < 1 || memLevel > MAX_MEM_LEVEL || method !== Z_DEFLATED ||
	    windowBits < 8 || windowBits > 15 || level < 0 || level > 9 ||
	    strategy < 0 || strategy > Z_FIXED) {
	    return err(strm, Z_STREAM_ERROR);
	  }
	
	
	  if (windowBits === 8) {
	    windowBits = 9;
	  }
	  /* until 256-byte window bug fixed */
	
	  var s = new DeflateState();
	
	  strm.state = s;
	  s.strm = strm;
	
	  s.wrap = wrap;
	  s.gzhead = null;
	  s.w_bits = windowBits;
	  s.w_size = 1 << s.w_bits;
	  s.w_mask = s.w_size - 1;
	
	  s.hash_bits = memLevel + 7;
	  s.hash_size = 1 << s.hash_bits;
	  s.hash_mask = s.hash_size - 1;
	  s.hash_shift = ~~((s.hash_bits + MIN_MATCH - 1) / MIN_MATCH);
	
	  s.window = new utils.Buf8(s.w_size * 2);
	  s.head = new utils.Buf16(s.hash_size);
	  s.prev = new utils.Buf16(s.w_size);
	
	  // Don't need mem init magic for JS.
	  //s.high_water = 0;  /* nothing written to s->window yet */
	
	  s.lit_bufsize = 1 << (memLevel + 6); /* 16K elements by default */
	
	  s.pending_buf_size = s.lit_bufsize * 4;
	
	  //overlay = (ushf *) ZALLOC(strm, s->lit_bufsize, sizeof(ush)+2);
	  //s->pending_buf = (uchf *) overlay;
	  s.pending_buf = new utils.Buf8(s.pending_buf_size);
	
	  // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
	  //s->d_buf = overlay + s->lit_bufsize/sizeof(ush);
	  s.d_buf = 1 * s.lit_bufsize;
	
	  //s->l_buf = s->pending_buf + (1+sizeof(ush))*s->lit_bufsize;
	  s.l_buf = (1 + 2) * s.lit_bufsize;
	
	  s.level = level;
	  s.strategy = strategy;
	  s.method = method;
	
	  return deflateReset(strm);
	}
	
	function deflateInit(strm, level) {
	  return deflateInit2(strm, level, Z_DEFLATED, MAX_WBITS, DEF_MEM_LEVEL, Z_DEFAULT_STRATEGY);
	}
	
	
	function deflate(strm, flush) {
	  var old_flush, s;
	  var beg, val; // for gzip header write only
	
	  if (!strm || !strm.state ||
	    flush > Z_BLOCK || flush < 0) {
	    return strm ? err(strm, Z_STREAM_ERROR) : Z_STREAM_ERROR;
	  }
	
	  s = strm.state;
	
	  if (!strm.output ||
	      (!strm.input && strm.avail_in !== 0) ||
	      (s.status === FINISH_STATE && flush !== Z_FINISH)) {
	    return err(strm, (strm.avail_out === 0) ? Z_BUF_ERROR : Z_STREAM_ERROR);
	  }
	
	  s.strm = strm; /* just in case */
	  old_flush = s.last_flush;
	  s.last_flush = flush;
	
	  /* Write the header */
	  if (s.status === INIT_STATE) {
	
	    if (s.wrap === 2) { // GZIP header
	      strm.adler = 0;  //crc32(0L, Z_NULL, 0);
	      put_byte(s, 31);
	      put_byte(s, 139);
	      put_byte(s, 8);
	      if (!s.gzhead) { // s->gzhead == Z_NULL
	        put_byte(s, 0);
	        put_byte(s, 0);
	        put_byte(s, 0);
	        put_byte(s, 0);
	        put_byte(s, 0);
	        put_byte(s, s.level === 9 ? 2 :
	                    (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
	                     4 : 0));
	        put_byte(s, OS_CODE);
	        s.status = BUSY_STATE;
	      }
	      else {
	        put_byte(s, (s.gzhead.text ? 1 : 0) +
	                    (s.gzhead.hcrc ? 2 : 0) +
	                    (!s.gzhead.extra ? 0 : 4) +
	                    (!s.gzhead.name ? 0 : 8) +
	                    (!s.gzhead.comment ? 0 : 16)
	        );
	        put_byte(s, s.gzhead.time & 0xff);
	        put_byte(s, (s.gzhead.time >> 8) & 0xff);
	        put_byte(s, (s.gzhead.time >> 16) & 0xff);
	        put_byte(s, (s.gzhead.time >> 24) & 0xff);
	        put_byte(s, s.level === 9 ? 2 :
	                    (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
	                     4 : 0));
	        put_byte(s, s.gzhead.os & 0xff);
	        if (s.gzhead.extra && s.gzhead.extra.length) {
	          put_byte(s, s.gzhead.extra.length & 0xff);
	          put_byte(s, (s.gzhead.extra.length >> 8) & 0xff);
	        }
	        if (s.gzhead.hcrc) {
	          strm.adler = crc32(strm.adler, s.pending_buf, s.pending, 0);
	        }
	        s.gzindex = 0;
	        s.status = EXTRA_STATE;
	      }
	    }
	    else // DEFLATE header
	    {
	      var header = (Z_DEFLATED + ((s.w_bits - 8) << 4)) << 8;
	      var level_flags = -1;
	
	      if (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2) {
	        level_flags = 0;
	      } else if (s.level < 6) {
	        level_flags = 1;
	      } else if (s.level === 6) {
	        level_flags = 2;
	      } else {
	        level_flags = 3;
	      }
	      header |= (level_flags << 6);
	      if (s.strstart !== 0) { header |= PRESET_DICT; }
	      header += 31 - (header % 31);
	
	      s.status = BUSY_STATE;
	      putShortMSB(s, header);
	
	      /* Save the adler32 of the preset dictionary: */
	      if (s.strstart !== 0) {
	        putShortMSB(s, strm.adler >>> 16);
	        putShortMSB(s, strm.adler & 0xffff);
	      }
	      strm.adler = 1; // adler32(0L, Z_NULL, 0);
	    }
	  }
	
	//#ifdef GZIP
	  if (s.status === EXTRA_STATE) {
	    if (s.gzhead.extra/* != Z_NULL*/) {
	      beg = s.pending;  /* start of bytes to update crc */
	
	      while (s.gzindex < (s.gzhead.extra.length & 0xffff)) {
	        if (s.pending === s.pending_buf_size) {
	          if (s.gzhead.hcrc && s.pending > beg) {
	            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	          }
	          flush_pending(strm);
	          beg = s.pending;
	          if (s.pending === s.pending_buf_size) {
	            break;
	          }
	        }
	        put_byte(s, s.gzhead.extra[s.gzindex] & 0xff);
	        s.gzindex++;
	      }
	      if (s.gzhead.hcrc && s.pending > beg) {
	        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	      }
	      if (s.gzindex === s.gzhead.extra.length) {
	        s.gzindex = 0;
	        s.status = NAME_STATE;
	      }
	    }
	    else {
	      s.status = NAME_STATE;
	    }
	  }
	  if (s.status === NAME_STATE) {
	    if (s.gzhead.name/* != Z_NULL*/) {
	      beg = s.pending;  /* start of bytes to update crc */
	      //int val;
	
	      do {
	        if (s.pending === s.pending_buf_size) {
	          if (s.gzhead.hcrc && s.pending > beg) {
	            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	          }
	          flush_pending(strm);
	          beg = s.pending;
	          if (s.pending === s.pending_buf_size) {
	            val = 1;
	            break;
	          }
	        }
	        // JS specific: little magic to add zero terminator to end of string
	        if (s.gzindex < s.gzhead.name.length) {
	          val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
	        } else {
	          val = 0;
	        }
	        put_byte(s, val);
	      } while (val !== 0);
	
	      if (s.gzhead.hcrc && s.pending > beg) {
	        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	      }
	      if (val === 0) {
	        s.gzindex = 0;
	        s.status = COMMENT_STATE;
	      }
	    }
	    else {
	      s.status = COMMENT_STATE;
	    }
	  }
	  if (s.status === COMMENT_STATE) {
	    if (s.gzhead.comment/* != Z_NULL*/) {
	      beg = s.pending;  /* start of bytes to update crc */
	      //int val;
	
	      do {
	        if (s.pending === s.pending_buf_size) {
	          if (s.gzhead.hcrc && s.pending > beg) {
	            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	          }
	          flush_pending(strm);
	          beg = s.pending;
	          if (s.pending === s.pending_buf_size) {
	            val = 1;
	            break;
	          }
	        }
	        // JS specific: little magic to add zero terminator to end of string
	        if (s.gzindex < s.gzhead.comment.length) {
	          val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
	        } else {
	          val = 0;
	        }
	        put_byte(s, val);
	      } while (val !== 0);
	
	      if (s.gzhead.hcrc && s.pending > beg) {
	        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	      }
	      if (val === 0) {
	        s.status = HCRC_STATE;
	      }
	    }
	    else {
	      s.status = HCRC_STATE;
	    }
	  }
	  if (s.status === HCRC_STATE) {
	    if (s.gzhead.hcrc) {
	      if (s.pending + 2 > s.pending_buf_size) {
	        flush_pending(strm);
	      }
	      if (s.pending + 2 <= s.pending_buf_size) {
	        put_byte(s, strm.adler & 0xff);
	        put_byte(s, (strm.adler >> 8) & 0xff);
	        strm.adler = 0; //crc32(0L, Z_NULL, 0);
	        s.status = BUSY_STATE;
	      }
	    }
	    else {
	      s.status = BUSY_STATE;
	    }
	  }
	//#endif
	
	  /* Flush as much pending output as possible */
	  if (s.pending !== 0) {
	    flush_pending(strm);
	    if (strm.avail_out === 0) {
	      /* Since avail_out is 0, deflate will be called again with
	       * more output space, but possibly with both pending and
	       * avail_in equal to zero. There won't be anything to do,
	       * but this is not an error situation so make sure we
	       * return OK instead of BUF_ERROR at next call of deflate:
	       */
	      s.last_flush = -1;
	      return Z_OK;
	    }
	
	    /* Make sure there is something to do and avoid duplicate consecutive
	     * flushes. For repeated and useless calls with Z_FINISH, we keep
	     * returning Z_STREAM_END instead of Z_BUF_ERROR.
	     */
	  } else if (strm.avail_in === 0 && rank(flush) <= rank(old_flush) &&
	    flush !== Z_FINISH) {
	    return err(strm, Z_BUF_ERROR);
	  }
	
	  /* User must not provide more input after the first FINISH: */
	  if (s.status === FINISH_STATE && strm.avail_in !== 0) {
	    return err(strm, Z_BUF_ERROR);
	  }
	
	  /* Start a new block or continue the current one.
	   */
	  if (strm.avail_in !== 0 || s.lookahead !== 0 ||
	    (flush !== Z_NO_FLUSH && s.status !== FINISH_STATE)) {
	    var bstate = (s.strategy === Z_HUFFMAN_ONLY) ? deflate_huff(s, flush) :
	      (s.strategy === Z_RLE ? deflate_rle(s, flush) :
	        configuration_table[s.level].func(s, flush));
	
	    if (bstate === BS_FINISH_STARTED || bstate === BS_FINISH_DONE) {
	      s.status = FINISH_STATE;
	    }
	    if (bstate === BS_NEED_MORE || bstate === BS_FINISH_STARTED) {
	      if (strm.avail_out === 0) {
	        s.last_flush = -1;
	        /* avoid BUF_ERROR next call, see above */
	      }
	      return Z_OK;
	      /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
	       * of deflate should use the same flush parameter to make sure
	       * that the flush is complete. So we don't have to output an
	       * empty block here, this will be done at next call. This also
	       * ensures that for a very small output buffer, we emit at most
	       * one empty block.
	       */
	    }
	    if (bstate === BS_BLOCK_DONE) {
	      if (flush === Z_PARTIAL_FLUSH) {
	        trees._tr_align(s);
	      }
	      else if (flush !== Z_BLOCK) { /* FULL_FLUSH or SYNC_FLUSH */
	
	        trees._tr_stored_block(s, 0, 0, false);
	        /* For a full flush, this empty block will be recognized
	         * as a special marker by inflate_sync().
	         */
	        if (flush === Z_FULL_FLUSH) {
	          /*** CLEAR_HASH(s); ***/             /* forget history */
	          zero(s.head); // Fill with NIL (= 0);
	
	          if (s.lookahead === 0) {
	            s.strstart = 0;
	            s.block_start = 0;
	            s.insert = 0;
	          }
	        }
	      }
	      flush_pending(strm);
	      if (strm.avail_out === 0) {
	        s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */
	        return Z_OK;
	      }
	    }
	  }
	  //Assert(strm->avail_out > 0, "bug2");
	  //if (strm.avail_out <= 0) { throw new Error("bug2");}
	
	  if (flush !== Z_FINISH) { return Z_OK; }
	  if (s.wrap <= 0) { return Z_STREAM_END; }
	
	  /* Write the trailer */
	  if (s.wrap === 2) {
	    put_byte(s, strm.adler & 0xff);
	    put_byte(s, (strm.adler >> 8) & 0xff);
	    put_byte(s, (strm.adler >> 16) & 0xff);
	    put_byte(s, (strm.adler >> 24) & 0xff);
	    put_byte(s, strm.total_in & 0xff);
	    put_byte(s, (strm.total_in >> 8) & 0xff);
	    put_byte(s, (strm.total_in >> 16) & 0xff);
	    put_byte(s, (strm.total_in >> 24) & 0xff);
	  }
	  else
	  {
	    putShortMSB(s, strm.adler >>> 16);
	    putShortMSB(s, strm.adler & 0xffff);
	  }
	
	  flush_pending(strm);
	  /* If avail_out is zero, the application will call deflate again
	   * to flush the rest.
	   */
	  if (s.wrap > 0) { s.wrap = -s.wrap; }
	  /* write the trailer only once! */
	  return s.pending !== 0 ? Z_OK : Z_STREAM_END;
	}
	
	function deflateEnd(strm) {
	  var status;
	
	  if (!strm/*== Z_NULL*/ || !strm.state/*== Z_NULL*/) {
	    return Z_STREAM_ERROR;
	  }
	
	  status = strm.state.status;
	  if (status !== INIT_STATE &&
	    status !== EXTRA_STATE &&
	    status !== NAME_STATE &&
	    status !== COMMENT_STATE &&
	    status !== HCRC_STATE &&
	    status !== BUSY_STATE &&
	    status !== FINISH_STATE
	  ) {
	    return err(strm, Z_STREAM_ERROR);
	  }
	
	  strm.state = null;
	
	  return status === BUSY_STATE ? err(strm, Z_DATA_ERROR) : Z_OK;
	}
	
	
	/* =========================================================================
	 * Initializes the compression dictionary from the given byte
	 * sequence without producing any compressed output.
	 */
	function deflateSetDictionary(strm, dictionary) {
	  var dictLength = dictionary.length;
	
	  var s;
	  var str, n;
	  var wrap;
	  var avail;
	  var next;
	  var input;
	  var tmpDict;
	
	  if (!strm/*== Z_NULL*/ || !strm.state/*== Z_NULL*/) {
	    return Z_STREAM_ERROR;
	  }
	
	  s = strm.state;
	  wrap = s.wrap;
	
	  if (wrap === 2 || (wrap === 1 && s.status !== INIT_STATE) || s.lookahead) {
	    return Z_STREAM_ERROR;
	  }
	
	  /* when using zlib wrappers, compute Adler-32 for provided dictionary */
	  if (wrap === 1) {
	    /* adler32(strm->adler, dictionary, dictLength); */
	    strm.adler = adler32(strm.adler, dictionary, dictLength, 0);
	  }
	
	  s.wrap = 0;   /* avoid computing Adler-32 in read_buf */
	
	  /* if dictionary would fill window, just replace the history */
	  if (dictLength >= s.w_size) {
	    if (wrap === 0) {            /* already empty otherwise */
	      /*** CLEAR_HASH(s); ***/
	      zero(s.head); // Fill with NIL (= 0);
	      s.strstart = 0;
	      s.block_start = 0;
	      s.insert = 0;
	    }
	    /* use the tail */
	    // dictionary = dictionary.slice(dictLength - s.w_size);
	    tmpDict = new utils.Buf8(s.w_size);
	    utils.arraySet(tmpDict, dictionary, dictLength - s.w_size, s.w_size, 0);
	    dictionary = tmpDict;
	    dictLength = s.w_size;
	  }
	  /* insert dictionary into window and hash */
	  avail = strm.avail_in;
	  next = strm.next_in;
	  input = strm.input;
	  strm.avail_in = dictLength;
	  strm.next_in = 0;
	  strm.input = dictionary;
	  fill_window(s);
	  while (s.lookahead >= MIN_MATCH) {
	    str = s.strstart;
	    n = s.lookahead - (MIN_MATCH - 1);
	    do {
	      /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
	      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;
	
	      s.prev[str & s.w_mask] = s.head[s.ins_h];
	
	      s.head[s.ins_h] = str;
	      str++;
	    } while (--n);
	    s.strstart = str;
	    s.lookahead = MIN_MATCH - 1;
	    fill_window(s);
	  }
	  s.strstart += s.lookahead;
	  s.block_start = s.strstart;
	  s.insert = s.lookahead;
	  s.lookahead = 0;
	  s.match_length = s.prev_length = MIN_MATCH - 1;
	  s.match_available = 0;
	  strm.next_in = next;
	  strm.input = input;
	  strm.avail_in = avail;
	  s.wrap = wrap;
	  return Z_OK;
	}
	
	
	exports.deflateInit = deflateInit;
	exports.deflateInit2 = deflateInit2;
	exports.deflateReset = deflateReset;
	exports.deflateResetKeep = deflateResetKeep;
	exports.deflateSetHeader = deflateSetHeader;
	exports.deflate = deflate;
	exports.deflateEnd = deflateEnd;
	exports.deflateSetDictionary = deflateSetDictionary;
	exports.deflateInfo = 'pako deflate (from Nodeca project)';
	
	/* Not implemented
	exports.deflateBound = deflateBound;
	exports.deflateCopy = deflateCopy;
	exports.deflateParams = deflateParams;
	exports.deflatePending = deflatePending;
	exports.deflatePrime = deflatePrime;
	exports.deflateTune = deflateTune;
	*/


/***/ },
/* 1358 */
/***/ function(module, exports) {

	'use strict';
	
	// (C) 1995-2013 Jean-loup Gailly and Mark Adler
	// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	//
	// This software is provided 'as-is', without any express or implied
	// warranty. In no event will the authors be held liable for any damages
	// arising from the use of this software.
	//
	// Permission is granted to anyone to use this software for any purpose,
	// including commercial applications, and to alter it and redistribute it
	// freely, subject to the following restrictions:
	//
	// 1. The origin of this software must not be misrepresented; you must not
	//   claim that you wrote the original software. If you use this software
	//   in a product, an acknowledgment in the product documentation would be
	//   appreciated but is not required.
	// 2. Altered source versions must be plainly marked as such, and must not be
	//   misrepresented as being the original software.
	// 3. This notice may not be removed or altered from any source distribution.
	
	function GZheader() {
	  /* true if compressed data believed to be text */
	  this.text       = 0;
	  /* modification time */
	  this.time       = 0;
	  /* extra flags (not used when writing a gzip file) */
	  this.xflags     = 0;
	  /* operating system */
	  this.os         = 0;
	  /* pointer to extra field or Z_NULL if none */
	  this.extra      = null;
	  /* extra field length (valid if extra != Z_NULL) */
	  this.extra_len  = 0; // Actually, we don't need it in JS,
	                       // but leave for few code modifications
	
	  //
	  // Setup limits is not necessary because in js we should not preallocate memory
	  // for inflate use constant limit in 65536 bytes
	  //
	
	  /* space at extra (only when reading header) */
	  // this.extra_max  = 0;
	  /* pointer to zero-terminated file name or Z_NULL */
	  this.name       = '';
	  /* space at name (only when reading header) */
	  // this.name_max   = 0;
	  /* pointer to zero-terminated comment or Z_NULL */
	  this.comment    = '';
	  /* space at comment (only when reading header) */
	  // this.comm_max   = 0;
	  /* true if there was or will be a header crc */
	  this.hcrc       = 0;
	  /* true when done reading gzip header (not used when writing a gzip file) */
	  this.done       = false;
	}
	
	module.exports = GZheader;


/***/ },
/* 1359 */
/***/ function(module, exports) {

	'use strict';
	
	// (C) 1995-2013 Jean-loup Gailly and Mark Adler
	// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	//
	// This software is provided 'as-is', without any express or implied
	// warranty. In no event will the authors be held liable for any damages
	// arising from the use of this software.
	//
	// Permission is granted to anyone to use this software for any purpose,
	// including commercial applications, and to alter it and redistribute it
	// freely, subject to the following restrictions:
	//
	// 1. The origin of this software must not be misrepresented; you must not
	//   claim that you wrote the original software. If you use this software
	//   in a product, an acknowledgment in the product documentation would be
	//   appreciated but is not required.
	// 2. Altered source versions must be plainly marked as such, and must not be
	//   misrepresented as being the original software.
	// 3. This notice may not be removed or altered from any source distribution.
	
	// See state defs from inflate.js
	var BAD = 30;       /* got a data error -- remain here until reset */
	var TYPE = 12;      /* i: waiting for type bits, including last-flag bit */
	
	/*
	   Decode literal, length, and distance codes and write out the resulting
	   literal and match bytes until either not enough input or output is
	   available, an end-of-block is encountered, or a data error is encountered.
	   When large enough input and output buffers are supplied to inflate(), for
	   example, a 16K input buffer and a 64K output buffer, more than 95% of the
	   inflate execution time is spent in this routine.
	
	   Entry assumptions:
	
	        state.mode === LEN
	        strm.avail_in >= 6
	        strm.avail_out >= 258
	        start >= strm.avail_out
	        state.bits < 8
	
	   On return, state.mode is one of:
	
	        LEN -- ran out of enough output space or enough available input
	        TYPE -- reached end of block code, inflate() to interpret next block
	        BAD -- error in block data
	
	   Notes:
	
	    - The maximum input bits used by a length/distance pair is 15 bits for the
	      length code, 5 bits for the length extra, 15 bits for the distance code,
	      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
	      Therefore if strm.avail_in >= 6, then there is enough input to avoid
	      checking for available input while decoding.
	
	    - The maximum bytes that a single length/distance pair can output is 258
	      bytes, which is the maximum length that can be coded.  inflate_fast()
	      requires strm.avail_out >= 258 for each loop to avoid checking for
	      output space.
	 */
	module.exports = function inflate_fast(strm, start) {
	  var state;
	  var _in;                    /* local strm.input */
	  var last;                   /* have enough input while in < last */
	  var _out;                   /* local strm.output */
	  var beg;                    /* inflate()'s initial strm.output */
	  var end;                    /* while out < end, enough space available */
	//#ifdef INFLATE_STRICT
	  var dmax;                   /* maximum distance from zlib header */
	//#endif
	  var wsize;                  /* window size or zero if not using window */
	  var whave;                  /* valid bytes in the window */
	  var wnext;                  /* window write index */
	  // Use `s_window` instead `window`, avoid conflict with instrumentation tools
	  var s_window;               /* allocated sliding window, if wsize != 0 */
	  var hold;                   /* local strm.hold */
	  var bits;                   /* local strm.bits */
	  var lcode;                  /* local strm.lencode */
	  var dcode;                  /* local strm.distcode */
	  var lmask;                  /* mask for first level of length codes */
	  var dmask;                  /* mask for first level of distance codes */
	  var here;                   /* retrieved table entry */
	  var op;                     /* code bits, operation, extra bits, or */
	                              /*  window position, window bytes to copy */
	  var len;                    /* match length, unused bytes */
	  var dist;                   /* match distance */
	  var from;                   /* where to copy match from */
	  var from_source;
	
	
	  var input, output; // JS specific, because we have no pointers
	
	  /* copy state to local variables */
	  state = strm.state;
	  //here = state.here;
	  _in = strm.next_in;
	  input = strm.input;
	  last = _in + (strm.avail_in - 5);
	  _out = strm.next_out;
	  output = strm.output;
	  beg = _out - (start - strm.avail_out);
	  end = _out + (strm.avail_out - 257);
	//#ifdef INFLATE_STRICT
	  dmax = state.dmax;
	//#endif
	  wsize = state.wsize;
	  whave = state.whave;
	  wnext = state.wnext;
	  s_window = state.window;
	  hold = state.hold;
	  bits = state.bits;
	  lcode = state.lencode;
	  dcode = state.distcode;
	  lmask = (1 << state.lenbits) - 1;
	  dmask = (1 << state.distbits) - 1;
	
	
	  /* decode literals and length/distances until end-of-block or not enough
	     input data or output space */
	
	  top:
	  do {
	    if (bits < 15) {
	      hold += input[_in++] << bits;
	      bits += 8;
	      hold += input[_in++] << bits;
	      bits += 8;
	    }
	
	    here = lcode[hold & lmask];
	
	    dolen:
	    for (;;) { // Goto emulation
	      op = here >>> 24/*here.bits*/;
	      hold >>>= op;
	      bits -= op;
	      op = (here >>> 16) & 0xff/*here.op*/;
	      if (op === 0) {                          /* literal */
	        //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
	        //        "inflate:         literal '%c'\n" :
	        //        "inflate:         literal 0x%02x\n", here.val));
	        output[_out++] = here & 0xffff/*here.val*/;
	      }
	      else if (op & 16) {                     /* length base */
	        len = here & 0xffff/*here.val*/;
	        op &= 15;                           /* number of extra bits */
	        if (op) {
	          if (bits < op) {
	            hold += input[_in++] << bits;
	            bits += 8;
	          }
	          len += hold & ((1 << op) - 1);
	          hold >>>= op;
	          bits -= op;
	        }
	        //Tracevv((stderr, "inflate:         length %u\n", len));
	        if (bits < 15) {
	          hold += input[_in++] << bits;
	          bits += 8;
	          hold += input[_in++] << bits;
	          bits += 8;
	        }
	        here = dcode[hold & dmask];
	
	        dodist:
	        for (;;) { // goto emulation
	          op = here >>> 24/*here.bits*/;
	          hold >>>= op;
	          bits -= op;
	          op = (here >>> 16) & 0xff/*here.op*/;
	
	          if (op & 16) {                      /* distance base */
	            dist = here & 0xffff/*here.val*/;
	            op &= 15;                       /* number of extra bits */
	            if (bits < op) {
	              hold += input[_in++] << bits;
	              bits += 8;
	              if (bits < op) {
	                hold += input[_in++] << bits;
	                bits += 8;
	              }
	            }
	            dist += hold & ((1 << op) - 1);
	//#ifdef INFLATE_STRICT
	            if (dist > dmax) {
	              strm.msg = 'invalid distance too far back';
	              state.mode = BAD;
	              break top;
	            }
	//#endif
	            hold >>>= op;
	            bits -= op;
	            //Tracevv((stderr, "inflate:         distance %u\n", dist));
	            op = _out - beg;                /* max distance in output */
	            if (dist > op) {                /* see if copy from window */
	              op = dist - op;               /* distance back in window */
	              if (op > whave) {
	                if (state.sane) {
	                  strm.msg = 'invalid distance too far back';
	                  state.mode = BAD;
	                  break top;
	                }
	
	// (!) This block is disabled in zlib defaults,
	// don't enable it for binary compatibility
	//#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
	//                if (len <= op - whave) {
	//                  do {
	//                    output[_out++] = 0;
	//                  } while (--len);
	//                  continue top;
	//                }
	//                len -= op - whave;
	//                do {
	//                  output[_out++] = 0;
	//                } while (--op > whave);
	//                if (op === 0) {
	//                  from = _out - dist;
	//                  do {
	//                    output[_out++] = output[from++];
	//                  } while (--len);
	//                  continue top;
	//                }
	//#endif
	              }
	              from = 0; // window index
	              from_source = s_window;
	              if (wnext === 0) {           /* very common case */
	                from += wsize - op;
	                if (op < len) {         /* some from window */
	                  len -= op;
	                  do {
	                    output[_out++] = s_window[from++];
	                  } while (--op);
	                  from = _out - dist;  /* rest from output */
	                  from_source = output;
	                }
	              }
	              else if (wnext < op) {      /* wrap around window */
	                from += wsize + wnext - op;
	                op -= wnext;
	                if (op < len) {         /* some from end of window */
	                  len -= op;
	                  do {
	                    output[_out++] = s_window[from++];
	                  } while (--op);
	                  from = 0;
	                  if (wnext < len) {  /* some from start of window */
	                    op = wnext;
	                    len -= op;
	                    do {
	                      output[_out++] = s_window[from++];
	                    } while (--op);
	                    from = _out - dist;      /* rest from output */
	                    from_source = output;
	                  }
	                }
	              }
	              else {                      /* contiguous in window */
	                from += wnext - op;
	                if (op < len) {         /* some from window */
	                  len -= op;
	                  do {
	                    output[_out++] = s_window[from++];
	                  } while (--op);
	                  from = _out - dist;  /* rest from output */
	                  from_source = output;
	                }
	              }
	              while (len > 2) {
	                output[_out++] = from_source[from++];
	                output[_out++] = from_source[from++];
	                output[_out++] = from_source[from++];
	                len -= 3;
	              }
	              if (len) {
	                output[_out++] = from_source[from++];
	                if (len > 1) {
	                  output[_out++] = from_source[from++];
	                }
	              }
	            }
	            else {
	              from = _out - dist;          /* copy direct from output */
	              do {                        /* minimum length is three */
	                output[_out++] = output[from++];
	                output[_out++] = output[from++];
	                output[_out++] = output[from++];
	                len -= 3;
	              } while (len > 2);
	              if (len) {
	                output[_out++] = output[from++];
	                if (len > 1) {
	                  output[_out++] = output[from++];
	                }
	              }
	            }
	          }
	          else if ((op & 64) === 0) {          /* 2nd level distance code */
	            here = dcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
	            continue dodist;
	          }
	          else {
	            strm.msg = 'invalid distance code';
	            state.mode = BAD;
	            break top;
	          }
	
	          break; // need to emulate goto via "continue"
	        }
	      }
	      else if ((op & 64) === 0) {              /* 2nd level length code */
	        here = lcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
	        continue dolen;
	      }
	      else if (op & 32) {                     /* end-of-block */
	        //Tracevv((stderr, "inflate:         end of block\n"));
	        state.mode = TYPE;
	        break top;
	      }
	      else {
	        strm.msg = 'invalid literal/length code';
	        state.mode = BAD;
	        break top;
	      }
	
	      break; // need to emulate goto via "continue"
	    }
	  } while (_in < last && _out < end);
	
	  /* return unused bytes (on entry, bits < 8, so in won't go too far back) */
	  len = bits >> 3;
	  _in -= len;
	  bits -= len << 3;
	  hold &= (1 << bits) - 1;
	
	  /* update state and return */
	  strm.next_in = _in;
	  strm.next_out = _out;
	  strm.avail_in = (_in < last ? 5 + (last - _in) : 5 - (_in - last));
	  strm.avail_out = (_out < end ? 257 + (end - _out) : 257 - (_out - end));
	  state.hold = hold;
	  state.bits = bits;
	  return;
	};


/***/ },
/* 1360 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// (C) 1995-2013 Jean-loup Gailly and Mark Adler
	// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	//
	// This software is provided 'as-is', without any express or implied
	// warranty. In no event will the authors be held liable for any damages
	// arising from the use of this software.
	//
	// Permission is granted to anyone to use this software for any purpose,
	// including commercial applications, and to alter it and redistribute it
	// freely, subject to the following restrictions:
	//
	// 1. The origin of this software must not be misrepresented; you must not
	//   claim that you wrote the original software. If you use this software
	//   in a product, an acknowledgment in the product documentation would be
	//   appreciated but is not required.
	// 2. Altered source versions must be plainly marked as such, and must not be
	//   misrepresented as being the original software.
	// 3. This notice may not be removed or altered from any source distribution.
	
	var utils         = __webpack_require__(99);
	var adler32       = __webpack_require__(595);
	var crc32         = __webpack_require__(597);
	var inflate_fast  = __webpack_require__(1359);
	var inflate_table = __webpack_require__(1361);
	
	var CODES = 0;
	var LENS = 1;
	var DISTS = 2;
	
	/* Public constants ==========================================================*/
	/* ===========================================================================*/
	
	
	/* Allowed flush values; see deflate() and inflate() below for details */
	//var Z_NO_FLUSH      = 0;
	//var Z_PARTIAL_FLUSH = 1;
	//var Z_SYNC_FLUSH    = 2;
	//var Z_FULL_FLUSH    = 3;
	var Z_FINISH        = 4;
	var Z_BLOCK         = 5;
	var Z_TREES         = 6;
	
	
	/* Return codes for the compression/decompression functions. Negative values
	 * are errors, positive values are used for special but normal events.
	 */
	var Z_OK            = 0;
	var Z_STREAM_END    = 1;
	var Z_NEED_DICT     = 2;
	//var Z_ERRNO         = -1;
	var Z_STREAM_ERROR  = -2;
	var Z_DATA_ERROR    = -3;
	var Z_MEM_ERROR     = -4;
	var Z_BUF_ERROR     = -5;
	//var Z_VERSION_ERROR = -6;
	
	/* The deflate compression method */
	var Z_DEFLATED  = 8;
	
	
	/* STATES ====================================================================*/
	/* ===========================================================================*/
	
	
	var    HEAD = 1;       /* i: waiting for magic header */
	var    FLAGS = 2;      /* i: waiting for method and flags (gzip) */
	var    TIME = 3;       /* i: waiting for modification time (gzip) */
	var    OS = 4;         /* i: waiting for extra flags and operating system (gzip) */
	var    EXLEN = 5;      /* i: waiting for extra length (gzip) */
	var    EXTRA = 6;      /* i: waiting for extra bytes (gzip) */
	var    NAME = 7;       /* i: waiting for end of file name (gzip) */
	var    COMMENT = 8;    /* i: waiting for end of comment (gzip) */
	var    HCRC = 9;       /* i: waiting for header crc (gzip) */
	var    DICTID = 10;    /* i: waiting for dictionary check value */
	var    DICT = 11;      /* waiting for inflateSetDictionary() call */
	var        TYPE = 12;      /* i: waiting for type bits, including last-flag bit */
	var        TYPEDO = 13;    /* i: same, but skip check to exit inflate on new block */
	var        STORED = 14;    /* i: waiting for stored size (length and complement) */
	var        COPY_ = 15;     /* i/o: same as COPY below, but only first time in */
	var        COPY = 16;      /* i/o: waiting for input or output to copy stored block */
	var        TABLE = 17;     /* i: waiting for dynamic block table lengths */
	var        LENLENS = 18;   /* i: waiting for code length code lengths */
	var        CODELENS = 19;  /* i: waiting for length/lit and distance code lengths */
	var            LEN_ = 20;      /* i: same as LEN below, but only first time in */
	var            LEN = 21;       /* i: waiting for length/lit/eob code */
	var            LENEXT = 22;    /* i: waiting for length extra bits */
	var            DIST = 23;      /* i: waiting for distance code */
	var            DISTEXT = 24;   /* i: waiting for distance extra bits */
	var            MATCH = 25;     /* o: waiting for output space to copy string */
	var            LIT = 26;       /* o: waiting for output space to write literal */
	var    CHECK = 27;     /* i: waiting for 32-bit check value */
	var    LENGTH = 28;    /* i: waiting for 32-bit length (gzip) */
	var    DONE = 29;      /* finished check, done -- remain here until reset */
	var    BAD = 30;       /* got a data error -- remain here until reset */
	var    MEM = 31;       /* got an inflate() memory error -- remain here until reset */
	var    SYNC = 32;      /* looking for synchronization bytes to restart inflate() */
	
	/* ===========================================================================*/
	
	
	
	var ENOUGH_LENS = 852;
	var ENOUGH_DISTS = 592;
	//var ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);
	
	var MAX_WBITS = 15;
	/* 32K LZ77 window */
	var DEF_WBITS = MAX_WBITS;
	
	
	function zswap32(q) {
	  return  (((q >>> 24) & 0xff) +
	          ((q >>> 8) & 0xff00) +
	          ((q & 0xff00) << 8) +
	          ((q & 0xff) << 24));
	}
	
	
	function InflateState() {
	  this.mode = 0;             /* current inflate mode */
	  this.last = false;          /* true if processing last block */
	  this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip */
	  this.havedict = false;      /* true if dictionary provided */
	  this.flags = 0;             /* gzip header method and flags (0 if zlib) */
	  this.dmax = 0;              /* zlib header max distance (INFLATE_STRICT) */
	  this.check = 0;             /* protected copy of check value */
	  this.total = 0;             /* protected copy of output count */
	  // TODO: may be {}
	  this.head = null;           /* where to save gzip header information */
	
	  /* sliding window */
	  this.wbits = 0;             /* log base 2 of requested window size */
	  this.wsize = 0;             /* window size or zero if not using window */
	  this.whave = 0;             /* valid bytes in the window */
	  this.wnext = 0;             /* window write index */
	  this.window = null;         /* allocated sliding window, if needed */
	
	  /* bit accumulator */
	  this.hold = 0;              /* input bit accumulator */
	  this.bits = 0;              /* number of bits in "in" */
	
	  /* for string and stored block copying */
	  this.length = 0;            /* literal or length of data to copy */
	  this.offset = 0;            /* distance back to copy string from */
	
	  /* for table and code decoding */
	  this.extra = 0;             /* extra bits needed */
	
	  /* fixed and dynamic code tables */
	  this.lencode = null;          /* starting table for length/literal codes */
	  this.distcode = null;         /* starting table for distance codes */
	  this.lenbits = 0;           /* index bits for lencode */
	  this.distbits = 0;          /* index bits for distcode */
	
	  /* dynamic table building */
	  this.ncode = 0;             /* number of code length code lengths */
	  this.nlen = 0;              /* number of length code lengths */
	  this.ndist = 0;             /* number of distance code lengths */
	  this.have = 0;              /* number of code lengths in lens[] */
	  this.next = null;              /* next available space in codes[] */
	
	  this.lens = new utils.Buf16(320); /* temporary storage for code lengths */
	  this.work = new utils.Buf16(288); /* work area for code table building */
	
	  /*
	   because we don't have pointers in js, we use lencode and distcode directly
	   as buffers so we don't need codes
	  */
	  //this.codes = new utils.Buf32(ENOUGH);       /* space for code tables */
	  this.lendyn = null;              /* dynamic table for length/literal codes (JS specific) */
	  this.distdyn = null;             /* dynamic table for distance codes (JS specific) */
	  this.sane = 0;                   /* if false, allow invalid distance too far */
	  this.back = 0;                   /* bits back of last unprocessed length/lit */
	  this.was = 0;                    /* initial length of match */
	}
	
	function inflateResetKeep(strm) {
	  var state;
	
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  state = strm.state;
	  strm.total_in = strm.total_out = state.total = 0;
	  strm.msg = ''; /*Z_NULL*/
	  if (state.wrap) {       /* to support ill-conceived Java test suite */
	    strm.adler = state.wrap & 1;
	  }
	  state.mode = HEAD;
	  state.last = 0;
	  state.havedict = 0;
	  state.dmax = 32768;
	  state.head = null/*Z_NULL*/;
	  state.hold = 0;
	  state.bits = 0;
	  //state.lencode = state.distcode = state.next = state.codes;
	  state.lencode = state.lendyn = new utils.Buf32(ENOUGH_LENS);
	  state.distcode = state.distdyn = new utils.Buf32(ENOUGH_DISTS);
	
	  state.sane = 1;
	  state.back = -1;
	  //Tracev((stderr, "inflate: reset\n"));
	  return Z_OK;
	}
	
	function inflateReset(strm) {
	  var state;
	
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  state = strm.state;
	  state.wsize = 0;
	  state.whave = 0;
	  state.wnext = 0;
	  return inflateResetKeep(strm);
	
	}
	
	function inflateReset2(strm, windowBits) {
	  var wrap;
	  var state;
	
	  /* get the state */
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  state = strm.state;
	
	  /* extract wrap request from windowBits parameter */
	  if (windowBits < 0) {
	    wrap = 0;
	    windowBits = -windowBits;
	  }
	  else {
	    wrap = (windowBits >> 4) + 1;
	    if (windowBits < 48) {
	      windowBits &= 15;
	    }
	  }
	
	  /* set number of window bits, free window if different */
	  if (windowBits && (windowBits < 8 || windowBits > 15)) {
	    return Z_STREAM_ERROR;
	  }
	  if (state.window !== null && state.wbits !== windowBits) {
	    state.window = null;
	  }
	
	  /* update state and reset the rest of it */
	  state.wrap = wrap;
	  state.wbits = windowBits;
	  return inflateReset(strm);
	}
	
	function inflateInit2(strm, windowBits) {
	  var ret;
	  var state;
	
	  if (!strm) { return Z_STREAM_ERROR; }
	  //strm.msg = Z_NULL;                 /* in case we return an error */
	
	  state = new InflateState();
	
	  //if (state === Z_NULL) return Z_MEM_ERROR;
	  //Tracev((stderr, "inflate: allocated\n"));
	  strm.state = state;
	  state.window = null/*Z_NULL*/;
	  ret = inflateReset2(strm, windowBits);
	  if (ret !== Z_OK) {
	    strm.state = null/*Z_NULL*/;
	  }
	  return ret;
	}
	
	function inflateInit(strm) {
	  return inflateInit2(strm, DEF_WBITS);
	}
	
	
	/*
	 Return state with length and distance decoding tables and index sizes set to
	 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
	 If BUILDFIXED is defined, then instead this routine builds the tables the
	 first time it's called, and returns those tables the first time and
	 thereafter.  This reduces the size of the code by about 2K bytes, in
	 exchange for a little execution time.  However, BUILDFIXED should not be
	 used for threaded applications, since the rewriting of the tables and virgin
	 may not be thread-safe.
	 */
	var virgin = true;
	
	var lenfix, distfix; // We have no pointers in JS, so keep tables separate
	
	function fixedtables(state) {
	  /* build fixed huffman tables if first call (may not be thread safe) */
	  if (virgin) {
	    var sym;
	
	    lenfix = new utils.Buf32(512);
	    distfix = new utils.Buf32(32);
	
	    /* literal/length table */
	    sym = 0;
	    while (sym < 144) { state.lens[sym++] = 8; }
	    while (sym < 256) { state.lens[sym++] = 9; }
	    while (sym < 280) { state.lens[sym++] = 7; }
	    while (sym < 288) { state.lens[sym++] = 8; }
	
	    inflate_table(LENS,  state.lens, 0, 288, lenfix,   0, state.work, { bits: 9 });
	
	    /* distance table */
	    sym = 0;
	    while (sym < 32) { state.lens[sym++] = 5; }
	
	    inflate_table(DISTS, state.lens, 0, 32,   distfix, 0, state.work, { bits: 5 });
	
	    /* do this just once */
	    virgin = false;
	  }
	
	  state.lencode = lenfix;
	  state.lenbits = 9;
	  state.distcode = distfix;
	  state.distbits = 5;
	}
	
	
	/*
	 Update the window with the last wsize (normally 32K) bytes written before
	 returning.  If window does not exist yet, create it.  This is only called
	 when a window is already in use, or when output has been written during this
	 inflate call, but the end of the deflate stream has not been reached yet.
	 It is also called to create a window for dictionary data when a dictionary
	 is loaded.
	
	 Providing output buffers larger than 32K to inflate() should provide a speed
	 advantage, since only the last 32K of output is copied to the sliding window
	 upon return from inflate(), and since all distances after the first 32K of
	 output will fall in the output data, making match copies simpler and faster.
	 The advantage may be dependent on the size of the processor's data caches.
	 */
	function updatewindow(strm, src, end, copy) {
	  var dist;
	  var state = strm.state;
	
	  /* if it hasn't been done already, allocate space for the window */
	  if (state.window === null) {
	    state.wsize = 1 << state.wbits;
	    state.wnext = 0;
	    state.whave = 0;
	
	    state.window = new utils.Buf8(state.wsize);
	  }
	
	  /* copy state->wsize or less output bytes into the circular window */
	  if (copy >= state.wsize) {
	    utils.arraySet(state.window, src, end - state.wsize, state.wsize, 0);
	    state.wnext = 0;
	    state.whave = state.wsize;
	  }
	  else {
	    dist = state.wsize - state.wnext;
	    if (dist > copy) {
	      dist = copy;
	    }
	    //zmemcpy(state->window + state->wnext, end - copy, dist);
	    utils.arraySet(state.window, src, end - copy, dist, state.wnext);
	    copy -= dist;
	    if (copy) {
	      //zmemcpy(state->window, end - copy, copy);
	      utils.arraySet(state.window, src, end - copy, copy, 0);
	      state.wnext = copy;
	      state.whave = state.wsize;
	    }
	    else {
	      state.wnext += dist;
	      if (state.wnext === state.wsize) { state.wnext = 0; }
	      if (state.whave < state.wsize) { state.whave += dist; }
	    }
	  }
	  return 0;
	}
	
	function inflate(strm, flush) {
	  var state;
	  var input, output;          // input/output buffers
	  var next;                   /* next input INDEX */
	  var put;                    /* next output INDEX */
	  var have, left;             /* available input and output */
	  var hold;                   /* bit buffer */
	  var bits;                   /* bits in bit buffer */
	  var _in, _out;              /* save starting available input and output */
	  var copy;                   /* number of stored or match bytes to copy */
	  var from;                   /* where to copy match bytes from */
	  var from_source;
	  var here = 0;               /* current decoding table entry */
	  var here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
	  //var last;                   /* parent table entry */
	  var last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
	  var len;                    /* length to copy for repeats, bits to drop */
	  var ret;                    /* return code */
	  var hbuf = new utils.Buf8(4);    /* buffer for gzip header crc calculation */
	  var opts;
	
	  var n; // temporary var for NEED_BITS
	
	  var order = /* permutation of code lengths */
	    [ 16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15 ];
	
	
	  if (!strm || !strm.state || !strm.output ||
	      (!strm.input && strm.avail_in !== 0)) {
	    return Z_STREAM_ERROR;
	  }
	
	  state = strm.state;
	  if (state.mode === TYPE) { state.mode = TYPEDO; }    /* skip check */
	
	
	  //--- LOAD() ---
	  put = strm.next_out;
	  output = strm.output;
	  left = strm.avail_out;
	  next = strm.next_in;
	  input = strm.input;
	  have = strm.avail_in;
	  hold = state.hold;
	  bits = state.bits;
	  //---
	
	  _in = have;
	  _out = left;
	  ret = Z_OK;
	
	  inf_leave: // goto emulation
	  for (;;) {
	    switch (state.mode) {
	      case HEAD:
	        if (state.wrap === 0) {
	          state.mode = TYPEDO;
	          break;
	        }
	        //=== NEEDBITS(16);
	        while (bits < 16) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        if ((state.wrap & 2) && hold === 0x8b1f) {  /* gzip header */
	          state.check = 0/*crc32(0L, Z_NULL, 0)*/;
	          //=== CRC2(state.check, hold);
	          hbuf[0] = hold & 0xff;
	          hbuf[1] = (hold >>> 8) & 0xff;
	          state.check = crc32(state.check, hbuf, 2, 0);
	          //===//
	
	          //=== INITBITS();
	          hold = 0;
	          bits = 0;
	          //===//
	          state.mode = FLAGS;
	          break;
	        }
	        state.flags = 0;           /* expect zlib header */
	        if (state.head) {
	          state.head.done = false;
	        }
	        if (!(state.wrap & 1) ||   /* check if zlib header allowed */
	          (((hold & 0xff)/*BITS(8)*/ << 8) + (hold >> 8)) % 31) {
	          strm.msg = 'incorrect header check';
	          state.mode = BAD;
	          break;
	        }
	        if ((hold & 0x0f)/*BITS(4)*/ !== Z_DEFLATED) {
	          strm.msg = 'unknown compression method';
	          state.mode = BAD;
	          break;
	        }
	        //--- DROPBITS(4) ---//
	        hold >>>= 4;
	        bits -= 4;
	        //---//
	        len = (hold & 0x0f)/*BITS(4)*/ + 8;
	        if (state.wbits === 0) {
	          state.wbits = len;
	        }
	        else if (len > state.wbits) {
	          strm.msg = 'invalid window size';
	          state.mode = BAD;
	          break;
	        }
	        state.dmax = 1 << len;
	        //Tracev((stderr, "inflate:   zlib header ok\n"));
	        strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
	        state.mode = hold & 0x200 ? DICTID : TYPE;
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	        break;
	      case FLAGS:
	        //=== NEEDBITS(16); */
	        while (bits < 16) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        state.flags = hold;
	        if ((state.flags & 0xff) !== Z_DEFLATED) {
	          strm.msg = 'unknown compression method';
	          state.mode = BAD;
	          break;
	        }
	        if (state.flags & 0xe000) {
	          strm.msg = 'unknown header flags set';
	          state.mode = BAD;
	          break;
	        }
	        if (state.head) {
	          state.head.text = ((hold >> 8) & 1);
	        }
	        if (state.flags & 0x0200) {
	          //=== CRC2(state.check, hold);
	          hbuf[0] = hold & 0xff;
	          hbuf[1] = (hold >>> 8) & 0xff;
	          state.check = crc32(state.check, hbuf, 2, 0);
	          //===//
	        }
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	        state.mode = TIME;
	        /* falls through */
	      case TIME:
	        //=== NEEDBITS(32); */
	        while (bits < 32) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        if (state.head) {
	          state.head.time = hold;
	        }
	        if (state.flags & 0x0200) {
	          //=== CRC4(state.check, hold)
	          hbuf[0] = hold & 0xff;
	          hbuf[1] = (hold >>> 8) & 0xff;
	          hbuf[2] = (hold >>> 16) & 0xff;
	          hbuf[3] = (hold >>> 24) & 0xff;
	          state.check = crc32(state.check, hbuf, 4, 0);
	          //===
	        }
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	        state.mode = OS;
	        /* falls through */
	      case OS:
	        //=== NEEDBITS(16); */
	        while (bits < 16) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        if (state.head) {
	          state.head.xflags = (hold & 0xff);
	          state.head.os = (hold >> 8);
	        }
	        if (state.flags & 0x0200) {
	          //=== CRC2(state.check, hold);
	          hbuf[0] = hold & 0xff;
	          hbuf[1] = (hold >>> 8) & 0xff;
	          state.check = crc32(state.check, hbuf, 2, 0);
	          //===//
	        }
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	        state.mode = EXLEN;
	        /* falls through */
	      case EXLEN:
	        if (state.flags & 0x0400) {
	          //=== NEEDBITS(16); */
	          while (bits < 16) {
	            if (have === 0) { break inf_leave; }
	            have--;
	            hold += input[next++] << bits;
	            bits += 8;
	          }
	          //===//
	          state.length = hold;
	          if (state.head) {
	            state.head.extra_len = hold;
	          }
	          if (state.flags & 0x0200) {
	            //=== CRC2(state.check, hold);
	            hbuf[0] = hold & 0xff;
	            hbuf[1] = (hold >>> 8) & 0xff;
	            state.check = crc32(state.check, hbuf, 2, 0);
	            //===//
	          }
	          //=== INITBITS();
	          hold = 0;
	          bits = 0;
	          //===//
	        }
	        else if (state.head) {
	          state.head.extra = null/*Z_NULL*/;
	        }
	        state.mode = EXTRA;
	        /* falls through */
	      case EXTRA:
	        if (state.flags & 0x0400) {
	          copy = state.length;
	          if (copy > have) { copy = have; }
	          if (copy) {
	            if (state.head) {
	              len = state.head.extra_len - state.length;
	              if (!state.head.extra) {
	                // Use untyped array for more convenient processing later
	                state.head.extra = new Array(state.head.extra_len);
	              }
	              utils.arraySet(
	                state.head.extra,
	                input,
	                next,
	                // extra field is limited to 65536 bytes
	                // - no need for additional size check
	                copy,
	                /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
	                len
	              );
	              //zmemcpy(state.head.extra + len, next,
	              //        len + copy > state.head.extra_max ?
	              //        state.head.extra_max - len : copy);
	            }
	            if (state.flags & 0x0200) {
	              state.check = crc32(state.check, input, copy, next);
	            }
	            have -= copy;
	            next += copy;
	            state.length -= copy;
	          }
	          if (state.length) { break inf_leave; }
	        }
	        state.length = 0;
	        state.mode = NAME;
	        /* falls through */
	      case NAME:
	        if (state.flags & 0x0800) {
	          if (have === 0) { break inf_leave; }
	          copy = 0;
	          do {
	            // TODO: 2 or 1 bytes?
	            len = input[next + copy++];
	            /* use constant limit because in js we should not preallocate memory */
	            if (state.head && len &&
	                (state.length < 65536 /*state.head.name_max*/)) {
	              state.head.name += String.fromCharCode(len);
	            }
	          } while (len && copy < have);
	
	          if (state.flags & 0x0200) {
	            state.check = crc32(state.check, input, copy, next);
	          }
	          have -= copy;
	          next += copy;
	          if (len) { break inf_leave; }
	        }
	        else if (state.head) {
	          state.head.name = null;
	        }
	        state.length = 0;
	        state.mode = COMMENT;
	        /* falls through */
	      case COMMENT:
	        if (state.flags & 0x1000) {
	          if (have === 0) { break inf_leave; }
	          copy = 0;
	          do {
	            len = input[next + copy++];
	            /* use constant limit because in js we should not preallocate memory */
	            if (state.head && len &&
	                (state.length < 65536 /*state.head.comm_max*/)) {
	              state.head.comment += String.fromCharCode(len);
	            }
	          } while (len && copy < have);
	          if (state.flags & 0x0200) {
	            state.check = crc32(state.check, input, copy, next);
	          }
	          have -= copy;
	          next += copy;
	          if (len) { break inf_leave; }
	        }
	        else if (state.head) {
	          state.head.comment = null;
	        }
	        state.mode = HCRC;
	        /* falls through */
	      case HCRC:
	        if (state.flags & 0x0200) {
	          //=== NEEDBITS(16); */
	          while (bits < 16) {
	            if (have === 0) { break inf_leave; }
	            have--;
	            hold += input[next++] << bits;
	            bits += 8;
	          }
	          //===//
	          if (hold !== (state.check & 0xffff)) {
	            strm.msg = 'header crc mismatch';
	            state.mode = BAD;
	            break;
	          }
	          //=== INITBITS();
	          hold = 0;
	          bits = 0;
	          //===//
	        }
	        if (state.head) {
	          state.head.hcrc = ((state.flags >> 9) & 1);
	          state.head.done = true;
	        }
	        strm.adler = state.check = 0;
	        state.mode = TYPE;
	        break;
	      case DICTID:
	        //=== NEEDBITS(32); */
	        while (bits < 32) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        strm.adler = state.check = zswap32(hold);
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	        state.mode = DICT;
	        /* falls through */
	      case DICT:
	        if (state.havedict === 0) {
	          //--- RESTORE() ---
	          strm.next_out = put;
	          strm.avail_out = left;
	          strm.next_in = next;
	          strm.avail_in = have;
	          state.hold = hold;
	          state.bits = bits;
	          //---
	          return Z_NEED_DICT;
	        }
	        strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
	        state.mode = TYPE;
	        /* falls through */
	      case TYPE:
	        if (flush === Z_BLOCK || flush === Z_TREES) { break inf_leave; }
	        /* falls through */
	      case TYPEDO:
	        if (state.last) {
	          //--- BYTEBITS() ---//
	          hold >>>= bits & 7;
	          bits -= bits & 7;
	          //---//
	          state.mode = CHECK;
	          break;
	        }
	        //=== NEEDBITS(3); */
	        while (bits < 3) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        state.last = (hold & 0x01)/*BITS(1)*/;
	        //--- DROPBITS(1) ---//
	        hold >>>= 1;
	        bits -= 1;
	        //---//
	
	        switch ((hold & 0x03)/*BITS(2)*/) {
	          case 0:                             /* stored block */
	            //Tracev((stderr, "inflate:     stored block%s\n",
	            //        state.last ? " (last)" : ""));
	            state.mode = STORED;
	            break;
	          case 1:                             /* fixed block */
	            fixedtables(state);
	            //Tracev((stderr, "inflate:     fixed codes block%s\n",
	            //        state.last ? " (last)" : ""));
	            state.mode = LEN_;             /* decode codes */
	            if (flush === Z_TREES) {
	              //--- DROPBITS(2) ---//
	              hold >>>= 2;
	              bits -= 2;
	              //---//
	              break inf_leave;
	            }
	            break;
	          case 2:                             /* dynamic block */
	            //Tracev((stderr, "inflate:     dynamic codes block%s\n",
	            //        state.last ? " (last)" : ""));
	            state.mode = TABLE;
	            break;
	          case 3:
	            strm.msg = 'invalid block type';
	            state.mode = BAD;
	        }
	        //--- DROPBITS(2) ---//
	        hold >>>= 2;
	        bits -= 2;
	        //---//
	        break;
	      case STORED:
	        //--- BYTEBITS() ---// /* go to byte boundary */
	        hold >>>= bits & 7;
	        bits -= bits & 7;
	        //---//
	        //=== NEEDBITS(32); */
	        while (bits < 32) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        if ((hold & 0xffff) !== ((hold >>> 16) ^ 0xffff)) {
	          strm.msg = 'invalid stored block lengths';
	          state.mode = BAD;
	          break;
	        }
	        state.length = hold & 0xffff;
	        //Tracev((stderr, "inflate:       stored length %u\n",
	        //        state.length));
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	        state.mode = COPY_;
	        if (flush === Z_TREES) { break inf_leave; }
	        /* falls through */
	      case COPY_:
	        state.mode = COPY;
	        /* falls through */
	      case COPY:
	        copy = state.length;
	        if (copy) {
	          if (copy > have) { copy = have; }
	          if (copy > left) { copy = left; }
	          if (copy === 0) { break inf_leave; }
	          //--- zmemcpy(put, next, copy); ---
	          utils.arraySet(output, input, next, copy, put);
	          //---//
	          have -= copy;
	          next += copy;
	          left -= copy;
	          put += copy;
	          state.length -= copy;
	          break;
	        }
	        //Tracev((stderr, "inflate:       stored end\n"));
	        state.mode = TYPE;
	        break;
	      case TABLE:
	        //=== NEEDBITS(14); */
	        while (bits < 14) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        state.nlen = (hold & 0x1f)/*BITS(5)*/ + 257;
	        //--- DROPBITS(5) ---//
	        hold >>>= 5;
	        bits -= 5;
	        //---//
	        state.ndist = (hold & 0x1f)/*BITS(5)*/ + 1;
	        //--- DROPBITS(5) ---//
	        hold >>>= 5;
	        bits -= 5;
	        //---//
	        state.ncode = (hold & 0x0f)/*BITS(4)*/ + 4;
	        //--- DROPBITS(4) ---//
	        hold >>>= 4;
	        bits -= 4;
	        //---//
	//#ifndef PKZIP_BUG_WORKAROUND
	        if (state.nlen > 286 || state.ndist > 30) {
	          strm.msg = 'too many length or distance symbols';
	          state.mode = BAD;
	          break;
	        }
	//#endif
	        //Tracev((stderr, "inflate:       table sizes ok\n"));
	        state.have = 0;
	        state.mode = LENLENS;
	        /* falls through */
	      case LENLENS:
	        while (state.have < state.ncode) {
	          //=== NEEDBITS(3);
	          while (bits < 3) {
	            if (have === 0) { break inf_leave; }
	            have--;
	            hold += input[next++] << bits;
	            bits += 8;
	          }
	          //===//
	          state.lens[order[state.have++]] = (hold & 0x07);//BITS(3);
	          //--- DROPBITS(3) ---//
	          hold >>>= 3;
	          bits -= 3;
	          //---//
	        }
	        while (state.have < 19) {
	          state.lens[order[state.have++]] = 0;
	        }
	        // We have separate tables & no pointers. 2 commented lines below not needed.
	        //state.next = state.codes;
	        //state.lencode = state.next;
	        // Switch to use dynamic table
	        state.lencode = state.lendyn;
	        state.lenbits = 7;
	
	        opts = { bits: state.lenbits };
	        ret = inflate_table(CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
	        state.lenbits = opts.bits;
	
	        if (ret) {
	          strm.msg = 'invalid code lengths set';
	          state.mode = BAD;
	          break;
	        }
	        //Tracev((stderr, "inflate:       code lengths ok\n"));
	        state.have = 0;
	        state.mode = CODELENS;
	        /* falls through */
	      case CODELENS:
	        while (state.have < state.nlen + state.ndist) {
	          for (;;) {
	            here = state.lencode[hold & ((1 << state.lenbits) - 1)];/*BITS(state.lenbits)*/
	            here_bits = here >>> 24;
	            here_op = (here >>> 16) & 0xff;
	            here_val = here & 0xffff;
	
	            if ((here_bits) <= bits) { break; }
	            //--- PULLBYTE() ---//
	            if (have === 0) { break inf_leave; }
	            have--;
	            hold += input[next++] << bits;
	            bits += 8;
	            //---//
	          }
	          if (here_val < 16) {
	            //--- DROPBITS(here.bits) ---//
	            hold >>>= here_bits;
	            bits -= here_bits;
	            //---//
	            state.lens[state.have++] = here_val;
	          }
	          else {
	            if (here_val === 16) {
	              //=== NEEDBITS(here.bits + 2);
	              n = here_bits + 2;
	              while (bits < n) {
	                if (have === 0) { break inf_leave; }
	                have--;
	                hold += input[next++] << bits;
	                bits += 8;
	              }
	              //===//
	              //--- DROPBITS(here.bits) ---//
	              hold >>>= here_bits;
	              bits -= here_bits;
	              //---//
	              if (state.have === 0) {
	                strm.msg = 'invalid bit length repeat';
	                state.mode = BAD;
	                break;
	              }
	              len = state.lens[state.have - 1];
	              copy = 3 + (hold & 0x03);//BITS(2);
	              //--- DROPBITS(2) ---//
	              hold >>>= 2;
	              bits -= 2;
	              //---//
	            }
	            else if (here_val === 17) {
	              //=== NEEDBITS(here.bits + 3);
	              n = here_bits + 3;
	              while (bits < n) {
	                if (have === 0) { break inf_leave; }
	                have--;
	                hold += input[next++] << bits;
	                bits += 8;
	              }
	              //===//
	              //--- DROPBITS(here.bits) ---//
	              hold >>>= here_bits;
	              bits -= here_bits;
	              //---//
	              len = 0;
	              copy = 3 + (hold & 0x07);//BITS(3);
	              //--- DROPBITS(3) ---//
	              hold >>>= 3;
	              bits -= 3;
	              //---//
	            }
	            else {
	              //=== NEEDBITS(here.bits + 7);
	              n = here_bits + 7;
	              while (bits < n) {
	                if (have === 0) { break inf_leave; }
	                have--;
	                hold += input[next++] << bits;
	                bits += 8;
	              }
	              //===//
	              //--- DROPBITS(here.bits) ---//
	              hold >>>= here_bits;
	              bits -= here_bits;
	              //---//
	              len = 0;
	              copy = 11 + (hold & 0x7f);//BITS(7);
	              //--- DROPBITS(7) ---//
	              hold >>>= 7;
	              bits -= 7;
	              //---//
	            }
	            if (state.have + copy > state.nlen + state.ndist) {
	              strm.msg = 'invalid bit length repeat';
	              state.mode = BAD;
	              break;
	            }
	            while (copy--) {
	              state.lens[state.have++] = len;
	            }
	          }
	        }
	
	        /* handle error breaks in while */
	        if (state.mode === BAD) { break; }
	
	        /* check for end-of-block code (better have one) */
	        if (state.lens[256] === 0) {
	          strm.msg = 'invalid code -- missing end-of-block';
	          state.mode = BAD;
	          break;
	        }
	
	        /* build code tables -- note: do not change the lenbits or distbits
	           values here (9 and 6) without reading the comments in inftrees.h
	           concerning the ENOUGH constants, which depend on those values */
	        state.lenbits = 9;
	
	        opts = { bits: state.lenbits };
	        ret = inflate_table(LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
	        // We have separate tables & no pointers. 2 commented lines below not needed.
	        // state.next_index = opts.table_index;
	        state.lenbits = opts.bits;
	        // state.lencode = state.next;
	
	        if (ret) {
	          strm.msg = 'invalid literal/lengths set';
	          state.mode = BAD;
	          break;
	        }
	
	        state.distbits = 6;
	        //state.distcode.copy(state.codes);
	        // Switch to use dynamic table
	        state.distcode = state.distdyn;
	        opts = { bits: state.distbits };
	        ret = inflate_table(DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
	        // We have separate tables & no pointers. 2 commented lines below not needed.
	        // state.next_index = opts.table_index;
	        state.distbits = opts.bits;
	        // state.distcode = state.next;
	
	        if (ret) {
	          strm.msg = 'invalid distances set';
	          state.mode = BAD;
	          break;
	        }
	        //Tracev((stderr, 'inflate:       codes ok\n'));
	        state.mode = LEN_;
	        if (flush === Z_TREES) { break inf_leave; }
	        /* falls through */
	      case LEN_:
	        state.mode = LEN;
	        /* falls through */
	      case LEN:
	        if (have >= 6 && left >= 258) {
	          //--- RESTORE() ---
	          strm.next_out = put;
	          strm.avail_out = left;
	          strm.next_in = next;
	          strm.avail_in = have;
	          state.hold = hold;
	          state.bits = bits;
	          //---
	          inflate_fast(strm, _out);
	          //--- LOAD() ---
	          put = strm.next_out;
	          output = strm.output;
	          left = strm.avail_out;
	          next = strm.next_in;
	          input = strm.input;
	          have = strm.avail_in;
	          hold = state.hold;
	          bits = state.bits;
	          //---
	
	          if (state.mode === TYPE) {
	            state.back = -1;
	          }
	          break;
	        }
	        state.back = 0;
	        for (;;) {
	          here = state.lencode[hold & ((1 << state.lenbits) - 1)];  /*BITS(state.lenbits)*/
	          here_bits = here >>> 24;
	          here_op = (here >>> 16) & 0xff;
	          here_val = here & 0xffff;
	
	          if (here_bits <= bits) { break; }
	          //--- PULLBYTE() ---//
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	          //---//
	        }
	        if (here_op && (here_op & 0xf0) === 0) {
	          last_bits = here_bits;
	          last_op = here_op;
	          last_val = here_val;
	          for (;;) {
	            here = state.lencode[last_val +
	                    ((hold & ((1 << (last_bits + last_op)) - 1))/*BITS(last.bits + last.op)*/ >> last_bits)];
	            here_bits = here >>> 24;
	            here_op = (here >>> 16) & 0xff;
	            here_val = here & 0xffff;
	
	            if ((last_bits + here_bits) <= bits) { break; }
	            //--- PULLBYTE() ---//
	            if (have === 0) { break inf_leave; }
	            have--;
	            hold += input[next++] << bits;
	            bits += 8;
	            //---//
	          }
	          //--- DROPBITS(last.bits) ---//
	          hold >>>= last_bits;
	          bits -= last_bits;
	          //---//
	          state.back += last_bits;
	        }
	        //--- DROPBITS(here.bits) ---//
	        hold >>>= here_bits;
	        bits -= here_bits;
	        //---//
	        state.back += here_bits;
	        state.length = here_val;
	        if (here_op === 0) {
	          //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
	          //        "inflate:         literal '%c'\n" :
	          //        "inflate:         literal 0x%02x\n", here.val));
	          state.mode = LIT;
	          break;
	        }
	        if (here_op & 32) {
	          //Tracevv((stderr, "inflate:         end of block\n"));
	          state.back = -1;
	          state.mode = TYPE;
	          break;
	        }
	        if (here_op & 64) {
	          strm.msg = 'invalid literal/length code';
	          state.mode = BAD;
	          break;
	        }
	        state.extra = here_op & 15;
	        state.mode = LENEXT;
	        /* falls through */
	      case LENEXT:
	        if (state.extra) {
	          //=== NEEDBITS(state.extra);
	          n = state.extra;
	          while (bits < n) {
	            if (have === 0) { break inf_leave; }
	            have--;
	            hold += input[next++] << bits;
	            bits += 8;
	          }
	          //===//
	          state.length += hold & ((1 << state.extra) - 1)/*BITS(state.extra)*/;
	          //--- DROPBITS(state.extra) ---//
	          hold >>>= state.extra;
	          bits -= state.extra;
	          //---//
	          state.back += state.extra;
	        }
	        //Tracevv((stderr, "inflate:         length %u\n", state.length));
	        state.was = state.length;
	        state.mode = DIST;
	        /* falls through */
	      case DIST:
	        for (;;) {
	          here = state.distcode[hold & ((1 << state.distbits) - 1)];/*BITS(state.distbits)*/
	          here_bits = here >>> 24;
	          here_op = (here >>> 16) & 0xff;
	          here_val = here & 0xffff;
	
	          if ((here_bits) <= bits) { break; }
	          //--- PULLBYTE() ---//
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	          //---//
	        }
	        if ((here_op & 0xf0) === 0) {
	          last_bits = here_bits;
	          last_op = here_op;
	          last_val = here_val;
	          for (;;) {
	            here = state.distcode[last_val +
	                    ((hold & ((1 << (last_bits + last_op)) - 1))/*BITS(last.bits + last.op)*/ >> last_bits)];
	            here_bits = here >>> 24;
	            here_op = (here >>> 16) & 0xff;
	            here_val = here & 0xffff;
	
	            if ((last_bits + here_bits) <= bits) { break; }
	            //--- PULLBYTE() ---//
	            if (have === 0) { break inf_leave; }
	            have--;
	            hold += input[next++] << bits;
	            bits += 8;
	            //---//
	          }
	          //--- DROPBITS(last.bits) ---//
	          hold >>>= last_bits;
	          bits -= last_bits;
	          //---//
	          state.back += last_bits;
	        }
	        //--- DROPBITS(here.bits) ---//
	        hold >>>= here_bits;
	        bits -= here_bits;
	        //---//
	        state.back += here_bits;
	        if (here_op & 64) {
	          strm.msg = 'invalid distance code';
	          state.mode = BAD;
	          break;
	        }
	        state.offset = here_val;
	        state.extra = (here_op) & 15;
	        state.mode = DISTEXT;
	        /* falls through */
	      case DISTEXT:
	        if (state.extra) {
	          //=== NEEDBITS(state.extra);
	          n = state.extra;
	          while (bits < n) {
	            if (have === 0) { break inf_leave; }
	            have--;
	            hold += input[next++] << bits;
	            bits += 8;
	          }
	          //===//
	          state.offset += hold & ((1 << state.extra) - 1)/*BITS(state.extra)*/;
	          //--- DROPBITS(state.extra) ---//
	          hold >>>= state.extra;
	          bits -= state.extra;
	          //---//
	          state.back += state.extra;
	        }
	//#ifdef INFLATE_STRICT
	        if (state.offset > state.dmax) {
	          strm.msg = 'invalid distance too far back';
	          state.mode = BAD;
	          break;
	        }
	//#endif
	        //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
	        state.mode = MATCH;
	        /* falls through */
	      case MATCH:
	        if (left === 0) { break inf_leave; }
	        copy = _out - left;
	        if (state.offset > copy) {         /* copy from window */
	          copy = state.offset - copy;
	          if (copy > state.whave) {
	            if (state.sane) {
	              strm.msg = 'invalid distance too far back';
	              state.mode = BAD;
	              break;
	            }
	// (!) This block is disabled in zlib defaults,
	// don't enable it for binary compatibility
	//#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
	//          Trace((stderr, "inflate.c too far\n"));
	//          copy -= state.whave;
	//          if (copy > state.length) { copy = state.length; }
	//          if (copy > left) { copy = left; }
	//          left -= copy;
	//          state.length -= copy;
	//          do {
	//            output[put++] = 0;
	//          } while (--copy);
	//          if (state.length === 0) { state.mode = LEN; }
	//          break;
	//#endif
	          }
	          if (copy > state.wnext) {
	            copy -= state.wnext;
	            from = state.wsize - copy;
	          }
	          else {
	            from = state.wnext - copy;
	          }
	          if (copy > state.length) { copy = state.length; }
	          from_source = state.window;
	        }
	        else {                              /* copy from output */
	          from_source = output;
	          from = put - state.offset;
	          copy = state.length;
	        }
	        if (copy > left) { copy = left; }
	        left -= copy;
	        state.length -= copy;
	        do {
	          output[put++] = from_source[from++];
	        } while (--copy);
	        if (state.length === 0) { state.mode = LEN; }
	        break;
	      case LIT:
	        if (left === 0) { break inf_leave; }
	        output[put++] = state.length;
	        left--;
	        state.mode = LEN;
	        break;
	      case CHECK:
	        if (state.wrap) {
	          //=== NEEDBITS(32);
	          while (bits < 32) {
	            if (have === 0) { break inf_leave; }
	            have--;
	            // Use '|' instead of '+' to make sure that result is signed
	            hold |= input[next++] << bits;
	            bits += 8;
	          }
	          //===//
	          _out -= left;
	          strm.total_out += _out;
	          state.total += _out;
	          if (_out) {
	            strm.adler = state.check =
	                /*UPDATE(state.check, put - _out, _out);*/
	                (state.flags ? crc32(state.check, output, _out, put - _out) : adler32(state.check, output, _out, put - _out));
	
	          }
	          _out = left;
	          // NB: crc32 stored as signed 32-bit int, zswap32 returns signed too
	          if ((state.flags ? hold : zswap32(hold)) !== state.check) {
	            strm.msg = 'incorrect data check';
	            state.mode = BAD;
	            break;
	          }
	          //=== INITBITS();
	          hold = 0;
	          bits = 0;
	          //===//
	          //Tracev((stderr, "inflate:   check matches trailer\n"));
	        }
	        state.mode = LENGTH;
	        /* falls through */
	      case LENGTH:
	        if (state.wrap && state.flags) {
	          //=== NEEDBITS(32);
	          while (bits < 32) {
	            if (have === 0) { break inf_leave; }
	            have--;
	            hold += input[next++] << bits;
	            bits += 8;
	          }
	          //===//
	          if (hold !== (state.total & 0xffffffff)) {
	            strm.msg = 'incorrect length check';
	            state.mode = BAD;
	            break;
	          }
	          //=== INITBITS();
	          hold = 0;
	          bits = 0;
	          //===//
	          //Tracev((stderr, "inflate:   length matches trailer\n"));
	        }
	        state.mode = DONE;
	        /* falls through */
	      case DONE:
	        ret = Z_STREAM_END;
	        break inf_leave;
	      case BAD:
	        ret = Z_DATA_ERROR;
	        break inf_leave;
	      case MEM:
	        return Z_MEM_ERROR;
	      case SYNC:
	        /* falls through */
	      default:
	        return Z_STREAM_ERROR;
	    }
	  }
	
	  // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"
	
	  /*
	     Return from inflate(), updating the total counts and the check value.
	     If there was no progress during the inflate() call, return a buffer
	     error.  Call updatewindow() to create and/or update the window state.
	     Note: a memory error from inflate() is non-recoverable.
	   */
	
	  //--- RESTORE() ---
	  strm.next_out = put;
	  strm.avail_out = left;
	  strm.next_in = next;
	  strm.avail_in = have;
	  state.hold = hold;
	  state.bits = bits;
	  //---
	
	  if (state.wsize || (_out !== strm.avail_out && state.mode < BAD &&
	                      (state.mode < CHECK || flush !== Z_FINISH))) {
	    if (updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out)) {
	      state.mode = MEM;
	      return Z_MEM_ERROR;
	    }
	  }
	  _in -= strm.avail_in;
	  _out -= strm.avail_out;
	  strm.total_in += _in;
	  strm.total_out += _out;
	  state.total += _out;
	  if (state.wrap && _out) {
	    strm.adler = state.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/
	      (state.flags ? crc32(state.check, output, _out, strm.next_out - _out) : adler32(state.check, output, _out, strm.next_out - _out));
	  }
	  strm.data_type = state.bits + (state.last ? 64 : 0) +
	                    (state.mode === TYPE ? 128 : 0) +
	                    (state.mode === LEN_ || state.mode === COPY_ ? 256 : 0);
	  if (((_in === 0 && _out === 0) || flush === Z_FINISH) && ret === Z_OK) {
	    ret = Z_BUF_ERROR;
	  }
	  return ret;
	}
	
	function inflateEnd(strm) {
	
	  if (!strm || !strm.state /*|| strm->zfree == (free_func)0*/) {
	    return Z_STREAM_ERROR;
	  }
	
	  var state = strm.state;
	  if (state.window) {
	    state.window = null;
	  }
	  strm.state = null;
	  return Z_OK;
	}
	
	function inflateGetHeader(strm, head) {
	  var state;
	
	  /* check state */
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  state = strm.state;
	  if ((state.wrap & 2) === 0) { return Z_STREAM_ERROR; }
	
	  /* save header structure */
	  state.head = head;
	  head.done = false;
	  return Z_OK;
	}
	
	function inflateSetDictionary(strm, dictionary) {
	  var dictLength = dictionary.length;
	
	  var state;
	  var dictid;
	  var ret;
	
	  /* check state */
	  if (!strm /* == Z_NULL */ || !strm.state /* == Z_NULL */) { return Z_STREAM_ERROR; }
	  state = strm.state;
	
	  if (state.wrap !== 0 && state.mode !== DICT) {
	    return Z_STREAM_ERROR;
	  }
	
	  /* check for correct dictionary identifier */
	  if (state.mode === DICT) {
	    dictid = 1; /* adler32(0, null, 0)*/
	    /* dictid = adler32(dictid, dictionary, dictLength); */
	    dictid = adler32(dictid, dictionary, dictLength, 0);
	    if (dictid !== state.check) {
	      return Z_DATA_ERROR;
	    }
	  }
	  /* copy dictionary to window using updatewindow(), which will amend the
	   existing dictionary if appropriate */
	  ret = updatewindow(strm, dictionary, dictLength, dictLength);
	  if (ret) {
	    state.mode = MEM;
	    return Z_MEM_ERROR;
	  }
	  state.havedict = 1;
	  // Tracev((stderr, "inflate:   dictionary set\n"));
	  return Z_OK;
	}
	
	exports.inflateReset = inflateReset;
	exports.inflateReset2 = inflateReset2;
	exports.inflateResetKeep = inflateResetKeep;
	exports.inflateInit = inflateInit;
	exports.inflateInit2 = inflateInit2;
	exports.inflate = inflate;
	exports.inflateEnd = inflateEnd;
	exports.inflateGetHeader = inflateGetHeader;
	exports.inflateSetDictionary = inflateSetDictionary;
	exports.inflateInfo = 'pako inflate (from Nodeca project)';
	
	/* Not implemented
	exports.inflateCopy = inflateCopy;
	exports.inflateGetDictionary = inflateGetDictionary;
	exports.inflateMark = inflateMark;
	exports.inflatePrime = inflatePrime;
	exports.inflateSync = inflateSync;
	exports.inflateSyncPoint = inflateSyncPoint;
	exports.inflateUndermine = inflateUndermine;
	*/


/***/ },
/* 1361 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// (C) 1995-2013 Jean-loup Gailly and Mark Adler
	// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	//
	// This software is provided 'as-is', without any express or implied
	// warranty. In no event will the authors be held liable for any damages
	// arising from the use of this software.
	//
	// Permission is granted to anyone to use this software for any purpose,
	// including commercial applications, and to alter it and redistribute it
	// freely, subject to the following restrictions:
	//
	// 1. The origin of this software must not be misrepresented; you must not
	//   claim that you wrote the original software. If you use this software
	//   in a product, an acknowledgment in the product documentation would be
	//   appreciated but is not required.
	// 2. Altered source versions must be plainly marked as such, and must not be
	//   misrepresented as being the original software.
	// 3. This notice may not be removed or altered from any source distribution.
	
	var utils = __webpack_require__(99);
	
	var MAXBITS = 15;
	var ENOUGH_LENS = 852;
	var ENOUGH_DISTS = 592;
	//var ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);
	
	var CODES = 0;
	var LENS = 1;
	var DISTS = 2;
	
	var lbase = [ /* Length codes 257..285 base */
	  3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31,
	  35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0
	];
	
	var lext = [ /* Length codes 257..285 extra */
	  16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18,
	  19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78
	];
	
	var dbase = [ /* Distance codes 0..29 base */
	  1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193,
	  257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145,
	  8193, 12289, 16385, 24577, 0, 0
	];
	
	var dext = [ /* Distance codes 0..29 extra */
	  16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22,
	  23, 23, 24, 24, 25, 25, 26, 26, 27, 27,
	  28, 28, 29, 29, 64, 64
	];
	
	module.exports = function inflate_table(type, lens, lens_index, codes, table, table_index, work, opts)
	{
	  var bits = opts.bits;
	      //here = opts.here; /* table entry for duplication */
	
	  var len = 0;               /* a code's length in bits */
	  var sym = 0;               /* index of code symbols */
	  var min = 0, max = 0;          /* minimum and maximum code lengths */
	  var root = 0;              /* number of index bits for root table */
	  var curr = 0;              /* number of index bits for current table */
	  var drop = 0;              /* code bits to drop for sub-table */
	  var left = 0;                   /* number of prefix codes available */
	  var used = 0;              /* code entries in table used */
	  var huff = 0;              /* Huffman code */
	  var incr;              /* for incrementing code, index */
	  var fill;              /* index for replicating entries */
	  var low;               /* low bits for current root entry */
	  var mask;              /* mask for low root bits */
	  var next;             /* next available space in table */
	  var base = null;     /* base value table to use */
	  var base_index = 0;
	//  var shoextra;    /* extra bits table to use */
	  var end;                    /* use base and extra for symbol > end */
	  var count = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */
	  var offs = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */
	  var extra = null;
	  var extra_index = 0;
	
	  var here_bits, here_op, here_val;
	
	  /*
	   Process a set of code lengths to create a canonical Huffman code.  The
	   code lengths are lens[0..codes-1].  Each length corresponds to the
	   symbols 0..codes-1.  The Huffman code is generated by first sorting the
	   symbols by length from short to long, and retaining the symbol order
	   for codes with equal lengths.  Then the code starts with all zero bits
	   for the first code of the shortest length, and the codes are integer
	   increments for the same length, and zeros are appended as the length
	   increases.  For the deflate format, these bits are stored backwards
	   from their more natural integer increment ordering, and so when the
	   decoding tables are built in the large loop below, the integer codes
	   are incremented backwards.
	
	   This routine assumes, but does not check, that all of the entries in
	   lens[] are in the range 0..MAXBITS.  The caller must assure this.
	   1..MAXBITS is interpreted as that code length.  zero means that that
	   symbol does not occur in this code.
	
	   The codes are sorted by computing a count of codes for each length,
	   creating from that a table of starting indices for each length in the
	   sorted table, and then entering the symbols in order in the sorted
	   table.  The sorted table is work[], with that space being provided by
	   the caller.
	
	   The length counts are used for other purposes as well, i.e. finding
	   the minimum and maximum length codes, determining if there are any
	   codes at all, checking for a valid set of lengths, and looking ahead
	   at length counts to determine sub-table sizes when building the
	   decoding tables.
	   */
	
	  /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */
	  for (len = 0; len <= MAXBITS; len++) {
	    count[len] = 0;
	  }
	  for (sym = 0; sym < codes; sym++) {
	    count[lens[lens_index + sym]]++;
	  }
	
	  /* bound code lengths, force root to be within code lengths */
	  root = bits;
	  for (max = MAXBITS; max >= 1; max--) {
	    if (count[max] !== 0) { break; }
	  }
	  if (root > max) {
	    root = max;
	  }
	  if (max === 0) {                     /* no symbols to code at all */
	    //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
	    //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
	    //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
	    table[table_index++] = (1 << 24) | (64 << 16) | 0;
	
	
	    //table.op[opts.table_index] = 64;
	    //table.bits[opts.table_index] = 1;
	    //table.val[opts.table_index++] = 0;
	    table[table_index++] = (1 << 24) | (64 << 16) | 0;
	
	    opts.bits = 1;
	    return 0;     /* no symbols, but wait for decoding to report error */
	  }
	  for (min = 1; min < max; min++) {
	    if (count[min] !== 0) { break; }
	  }
	  if (root < min) {
	    root = min;
	  }
	
	  /* check for an over-subscribed or incomplete set of lengths */
	  left = 1;
	  for (len = 1; len <= MAXBITS; len++) {
	    left <<= 1;
	    left -= count[len];
	    if (left < 0) {
	      return -1;
	    }        /* over-subscribed */
	  }
	  if (left > 0 && (type === CODES || max !== 1)) {
	    return -1;                      /* incomplete set */
	  }
	
	  /* generate offsets into symbol table for each length for sorting */
	  offs[1] = 0;
	  for (len = 1; len < MAXBITS; len++) {
	    offs[len + 1] = offs[len] + count[len];
	  }
	
	  /* sort symbols by length, by symbol order within each length */
	  for (sym = 0; sym < codes; sym++) {
	    if (lens[lens_index + sym] !== 0) {
	      work[offs[lens[lens_index + sym]]++] = sym;
	    }
	  }
	
	  /*
	   Create and fill in decoding tables.  In this loop, the table being
	   filled is at next and has curr index bits.  The code being used is huff
	   with length len.  That code is converted to an index by dropping drop
	   bits off of the bottom.  For codes where len is less than drop + curr,
	   those top drop + curr - len bits are incremented through all values to
	   fill the table with replicated entries.
	
	   root is the number of index bits for the root table.  When len exceeds
	   root, sub-tables are created pointed to by the root entry with an index
	   of the low root bits of huff.  This is saved in low to check for when a
	   new sub-table should be started.  drop is zero when the root table is
	   being filled, and drop is root when sub-tables are being filled.
	
	   When a new sub-table is needed, it is necessary to look ahead in the
	   code lengths to determine what size sub-table is needed.  The length
	   counts are used for this, and so count[] is decremented as codes are
	   entered in the tables.
	
	   used keeps track of how many table entries have been allocated from the
	   provided *table space.  It is checked for LENS and DIST tables against
	   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
	   the initial root table size constants.  See the comments in inftrees.h
	   for more information.
	
	   sym increments through all symbols, and the loop terminates when
	   all codes of length max, i.e. all codes, have been processed.  This
	   routine permits incomplete codes, so another loop after this one fills
	   in the rest of the decoding tables with invalid code markers.
	   */
	
	  /* set up for code type */
	  // poor man optimization - use if-else instead of switch,
	  // to avoid deopts in old v8
	  if (type === CODES) {
	    base = extra = work;    /* dummy value--not used */
	    end = 19;
	
	  } else if (type === LENS) {
	    base = lbase;
	    base_index -= 257;
	    extra = lext;
	    extra_index -= 257;
	    end = 256;
	
	  } else {                    /* DISTS */
	    base = dbase;
	    extra = dext;
	    end = -1;
	  }
	
	  /* initialize opts for loop */
	  huff = 0;                   /* starting code */
	  sym = 0;                    /* starting code symbol */
	  len = min;                  /* starting code length */
	  next = table_index;              /* current table to fill in */
	  curr = root;                /* current table index bits */
	  drop = 0;                   /* current bits to drop from code for index */
	  low = -1;                   /* trigger new sub-table when len > root */
	  used = 1 << root;          /* use root table entries */
	  mask = used - 1;            /* mask for comparing low */
	
	  /* check available table space */
	  if ((type === LENS && used > ENOUGH_LENS) ||
	    (type === DISTS && used > ENOUGH_DISTS)) {
	    return 1;
	  }
	
	  /* process all codes and make table entries */
	  for (;;) {
	    /* create table entry */
	    here_bits = len - drop;
	    if (work[sym] < end) {
	      here_op = 0;
	      here_val = work[sym];
	    }
	    else if (work[sym] > end) {
	      here_op = extra[extra_index + work[sym]];
	      here_val = base[base_index + work[sym]];
	    }
	    else {
	      here_op = 32 + 64;         /* end of block */
	      here_val = 0;
	    }
	
	    /* replicate for those indices with low len bits equal to huff */
	    incr = 1 << (len - drop);
	    fill = 1 << curr;
	    min = fill;                 /* save offset to next table */
	    do {
	      fill -= incr;
	      table[next + (huff >> drop) + fill] = (here_bits << 24) | (here_op << 16) | here_val |0;
	    } while (fill !== 0);
	
	    /* backwards increment the len-bit code huff */
	    incr = 1 << (len - 1);
	    while (huff & incr) {
	      incr >>= 1;
	    }
	    if (incr !== 0) {
	      huff &= incr - 1;
	      huff += incr;
	    } else {
	      huff = 0;
	    }
	
	    /* go to next symbol, update count, len */
	    sym++;
	    if (--count[len] === 0) {
	      if (len === max) { break; }
	      len = lens[lens_index + work[sym]];
	    }
	
	    /* create new sub-table if needed */
	    if (len > root && (huff & mask) !== low) {
	      /* if first time, transition to sub-tables */
	      if (drop === 0) {
	        drop = root;
	      }
	
	      /* increment past last table */
	      next += min;            /* here min is 1 << curr */
	
	      /* determine length of next table */
	      curr = len - drop;
	      left = 1 << curr;
	      while (curr + drop < max) {
	        left -= count[curr + drop];
	        if (left <= 0) { break; }
	        curr++;
	        left <<= 1;
	      }
	
	      /* check for enough space */
	      used += 1 << curr;
	      if ((type === LENS && used > ENOUGH_LENS) ||
	        (type === DISTS && used > ENOUGH_DISTS)) {
	        return 1;
	      }
	
	      /* point entry in root table to sub-table */
	      low = huff & mask;
	      /*table.op[low] = curr;
	      table.bits[low] = root;
	      table.val[low] = next - opts.table_index;*/
	      table[low] = (root << 24) | (curr << 16) | (next - table_index) |0;
	    }
	  }
	
	  /* fill in remaining table entry if code is incomplete (guaranteed to have
	   at most one remaining entry, since if the code is incomplete, the
	   maximum code length that was allowed to get this far is one bit) */
	  if (huff !== 0) {
	    //table.op[next + huff] = 64;            /* invalid code marker */
	    //table.bits[next + huff] = len - drop;
	    //table.val[next + huff] = 0;
	    table[next + huff] = ((len - drop) << 24) | (64 << 16) |0;
	  }
	
	  /* set return parameters */
	  //opts.table_index += used;
	  opts.bits = root;
	  return 0;
	};


/***/ },
/* 1362 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// (C) 1995-2013 Jean-loup Gailly and Mark Adler
	// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	//
	// This software is provided 'as-is', without any express or implied
	// warranty. In no event will the authors be held liable for any damages
	// arising from the use of this software.
	//
	// Permission is granted to anyone to use this software for any purpose,
	// including commercial applications, and to alter it and redistribute it
	// freely, subject to the following restrictions:
	//
	// 1. The origin of this software must not be misrepresented; you must not
	//   claim that you wrote the original software. If you use this software
	//   in a product, an acknowledgment in the product documentation would be
	//   appreciated but is not required.
	// 2. Altered source versions must be plainly marked as such, and must not be
	//   misrepresented as being the original software.
	// 3. This notice may not be removed or altered from any source distribution.
	
	/* eslint-disable space-unary-ops */
	
	var utils = __webpack_require__(99);
	
	/* Public constants ==========================================================*/
	/* ===========================================================================*/
	
	
	//var Z_FILTERED          = 1;
	//var Z_HUFFMAN_ONLY      = 2;
	//var Z_RLE               = 3;
	var Z_FIXED               = 4;
	//var Z_DEFAULT_STRATEGY  = 0;
	
	/* Possible values of the data_type field (though see inflate()) */
	var Z_BINARY              = 0;
	var Z_TEXT                = 1;
	//var Z_ASCII             = 1; // = Z_TEXT
	var Z_UNKNOWN             = 2;
	
	/*============================================================================*/
	
	
	function zero(buf) { var len = buf.length; while (--len >= 0) { buf[len] = 0; } }
	
	// From zutil.h
	
	var STORED_BLOCK = 0;
	var STATIC_TREES = 1;
	var DYN_TREES    = 2;
	/* The three kinds of block type */
	
	var MIN_MATCH    = 3;
	var MAX_MATCH    = 258;
	/* The minimum and maximum match lengths */
	
	// From deflate.h
	/* ===========================================================================
	 * Internal compression state.
	 */
	
	var LENGTH_CODES  = 29;
	/* number of length codes, not counting the special END_BLOCK code */
	
	var LITERALS      = 256;
	/* number of literal bytes 0..255 */
	
	var L_CODES       = LITERALS + 1 + LENGTH_CODES;
	/* number of Literal or Length codes, including the END_BLOCK code */
	
	var D_CODES       = 30;
	/* number of distance codes */
	
	var BL_CODES      = 19;
	/* number of codes used to transfer the bit lengths */
	
	var HEAP_SIZE     = 2 * L_CODES + 1;
	/* maximum heap size */
	
	var MAX_BITS      = 15;
	/* All codes must not exceed MAX_BITS bits */
	
	var Buf_size      = 16;
	/* size of bit buffer in bi_buf */
	
	
	/* ===========================================================================
	 * Constants
	 */
	
	var MAX_BL_BITS = 7;
	/* Bit length codes must not exceed MAX_BL_BITS bits */
	
	var END_BLOCK   = 256;
	/* end of block literal code */
	
	var REP_3_6     = 16;
	/* repeat previous bit length 3-6 times (2 bits of repeat count) */
	
	var REPZ_3_10   = 17;
	/* repeat a zero length 3-10 times  (3 bits of repeat count) */
	
	var REPZ_11_138 = 18;
	/* repeat a zero length 11-138 times  (7 bits of repeat count) */
	
	/* eslint-disable comma-spacing,array-bracket-spacing */
	var extra_lbits =   /* extra bits for each length code */
	  [0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0];
	
	var extra_dbits =   /* extra bits for each distance code */
	  [0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13];
	
	var extra_blbits =  /* extra bits for each bit length code */
	  [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7];
	
	var bl_order =
	  [16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15];
	/* eslint-enable comma-spacing,array-bracket-spacing */
	
	/* The lengths of the bit length codes are sent in order of decreasing
	 * probability, to avoid transmitting the lengths for unused bit length codes.
	 */
	
	/* ===========================================================================
	 * Local data. These are initialized only once.
	 */
	
	// We pre-fill arrays with 0 to avoid uninitialized gaps
	
	var DIST_CODE_LEN = 512; /* see definition of array dist_code below */
	
	// !!!! Use flat array instead of structure, Freq = i*2, Len = i*2+1
	var static_ltree  = new Array((L_CODES + 2) * 2);
	zero(static_ltree);
	/* The static literal tree. Since the bit lengths are imposed, there is no
	 * need for the L_CODES extra codes used during heap construction. However
	 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
	 * below).
	 */
	
	var static_dtree  = new Array(D_CODES * 2);
	zero(static_dtree);
	/* The static distance tree. (Actually a trivial tree since all codes use
	 * 5 bits.)
	 */
	
	var _dist_code    = new Array(DIST_CODE_LEN);
	zero(_dist_code);
	/* Distance codes. The first 256 values correspond to the distances
	 * 3 .. 258, the last 256 values correspond to the top 8 bits of
	 * the 15 bit distances.
	 */
	
	var _length_code  = new Array(MAX_MATCH - MIN_MATCH + 1);
	zero(_length_code);
	/* length code for each normalized match length (0 == MIN_MATCH) */
	
	var base_length   = new Array(LENGTH_CODES);
	zero(base_length);
	/* First normalized length for each code (0 = MIN_MATCH) */
	
	var base_dist     = new Array(D_CODES);
	zero(base_dist);
	/* First normalized distance for each code (0 = distance of 1) */
	
	
	function StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {
	
	  this.static_tree  = static_tree;  /* static tree or NULL */
	  this.extra_bits   = extra_bits;   /* extra bits for each code or NULL */
	  this.extra_base   = extra_base;   /* base index for extra_bits */
	  this.elems        = elems;        /* max number of elements in the tree */
	  this.max_length   = max_length;   /* max bit length for the codes */
	
	  // show if `static_tree` has data or dummy - needed for monomorphic objects
	  this.has_stree    = static_tree && static_tree.length;
	}
	
	
	var static_l_desc;
	var static_d_desc;
	var static_bl_desc;
	
	
	function TreeDesc(dyn_tree, stat_desc) {
	  this.dyn_tree = dyn_tree;     /* the dynamic tree */
	  this.max_code = 0;            /* largest code with non zero frequency */
	  this.stat_desc = stat_desc;   /* the corresponding static tree */
	}
	
	
	
	function d_code(dist) {
	  return dist < 256 ? _dist_code[dist] : _dist_code[256 + (dist >>> 7)];
	}
	
	
	/* ===========================================================================
	 * Output a short LSB first on the stream.
	 * IN assertion: there is enough room in pendingBuf.
	 */
	function put_short(s, w) {
	//    put_byte(s, (uch)((w) & 0xff));
	//    put_byte(s, (uch)((ush)(w) >> 8));
	  s.pending_buf[s.pending++] = (w) & 0xff;
	  s.pending_buf[s.pending++] = (w >>> 8) & 0xff;
	}
	
	
	/* ===========================================================================
	 * Send a value on a given number of bits.
	 * IN assertion: length <= 16 and value fits in length bits.
	 */
	function send_bits(s, value, length) {
	  if (s.bi_valid > (Buf_size - length)) {
	    s.bi_buf |= (value << s.bi_valid) & 0xffff;
	    put_short(s, s.bi_buf);
	    s.bi_buf = value >> (Buf_size - s.bi_valid);
	    s.bi_valid += length - Buf_size;
	  } else {
	    s.bi_buf |= (value << s.bi_valid) & 0xffff;
	    s.bi_valid += length;
	  }
	}
	
	
	function send_code(s, c, tree) {
	  send_bits(s, tree[c * 2]/*.Code*/, tree[c * 2 + 1]/*.Len*/);
	}
	
	
	/* ===========================================================================
	 * Reverse the first len bits of a code, using straightforward code (a faster
	 * method would use a table)
	 * IN assertion: 1 <= len <= 15
	 */
	function bi_reverse(code, len) {
	  var res = 0;
	  do {
	    res |= code & 1;
	    code >>>= 1;
	    res <<= 1;
	  } while (--len > 0);
	  return res >>> 1;
	}
	
	
	/* ===========================================================================
	 * Flush the bit buffer, keeping at most 7 bits in it.
	 */
	function bi_flush(s) {
	  if (s.bi_valid === 16) {
	    put_short(s, s.bi_buf);
	    s.bi_buf = 0;
	    s.bi_valid = 0;
	
	  } else if (s.bi_valid >= 8) {
	    s.pending_buf[s.pending++] = s.bi_buf & 0xff;
	    s.bi_buf >>= 8;
	    s.bi_valid -= 8;
	  }
	}
	
	
	/* ===========================================================================
	 * Compute the optimal bit lengths for a tree and update the total bit length
	 * for the current block.
	 * IN assertion: the fields freq and dad are set, heap[heap_max] and
	 *    above are the tree nodes sorted by increasing frequency.
	 * OUT assertions: the field len is set to the optimal bit length, the
	 *     array bl_count contains the frequencies for each bit length.
	 *     The length opt_len is updated; static_len is also updated if stree is
	 *     not null.
	 */
	function gen_bitlen(s, desc)
	//    deflate_state *s;
	//    tree_desc *desc;    /* the tree descriptor */
	{
	  var tree            = desc.dyn_tree;
	  var max_code        = desc.max_code;
	  var stree           = desc.stat_desc.static_tree;
	  var has_stree       = desc.stat_desc.has_stree;
	  var extra           = desc.stat_desc.extra_bits;
	  var base            = desc.stat_desc.extra_base;
	  var max_length      = desc.stat_desc.max_length;
	  var h;              /* heap index */
	  var n, m;           /* iterate over the tree elements */
	  var bits;           /* bit length */
	  var xbits;          /* extra bits */
	  var f;              /* frequency */
	  var overflow = 0;   /* number of elements with bit length too large */
	
	  for (bits = 0; bits <= MAX_BITS; bits++) {
	    s.bl_count[bits] = 0;
	  }
	
	  /* In a first pass, compute the optimal bit lengths (which may
	   * overflow in the case of the bit length tree).
	   */
	  tree[s.heap[s.heap_max] * 2 + 1]/*.Len*/ = 0; /* root of the heap */
	
	  for (h = s.heap_max + 1; h < HEAP_SIZE; h++) {
	    n = s.heap[h];
	    bits = tree[tree[n * 2 + 1]/*.Dad*/ * 2 + 1]/*.Len*/ + 1;
	    if (bits > max_length) {
	      bits = max_length;
	      overflow++;
	    }
	    tree[n * 2 + 1]/*.Len*/ = bits;
	    /* We overwrite tree[n].Dad which is no longer needed */
	
	    if (n > max_code) { continue; } /* not a leaf node */
	
	    s.bl_count[bits]++;
	    xbits = 0;
	    if (n >= base) {
	      xbits = extra[n - base];
	    }
	    f = tree[n * 2]/*.Freq*/;
	    s.opt_len += f * (bits + xbits);
	    if (has_stree) {
	      s.static_len += f * (stree[n * 2 + 1]/*.Len*/ + xbits);
	    }
	  }
	  if (overflow === 0) { return; }
	
	  // Trace((stderr,"\nbit length overflow\n"));
	  /* This happens for example on obj2 and pic of the Calgary corpus */
	
	  /* Find the first bit length which could increase: */
	  do {
	    bits = max_length - 1;
	    while (s.bl_count[bits] === 0) { bits--; }
	    s.bl_count[bits]--;      /* move one leaf down the tree */
	    s.bl_count[bits + 1] += 2; /* move one overflow item as its brother */
	    s.bl_count[max_length]--;
	    /* The brother of the overflow item also moves one step up,
	     * but this does not affect bl_count[max_length]
	     */
	    overflow -= 2;
	  } while (overflow > 0);
	
	  /* Now recompute all bit lengths, scanning in increasing frequency.
	   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
	   * lengths instead of fixing only the wrong ones. This idea is taken
	   * from 'ar' written by Haruhiko Okumura.)
	   */
	  for (bits = max_length; bits !== 0; bits--) {
	    n = s.bl_count[bits];
	    while (n !== 0) {
	      m = s.heap[--h];
	      if (m > max_code) { continue; }
	      if (tree[m * 2 + 1]/*.Len*/ !== bits) {
	        // Trace((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
	        s.opt_len += (bits - tree[m * 2 + 1]/*.Len*/) * tree[m * 2]/*.Freq*/;
	        tree[m * 2 + 1]/*.Len*/ = bits;
	      }
	      n--;
	    }
	  }
	}
	
	
	/* ===========================================================================
	 * Generate the codes for a given tree and bit counts (which need not be
	 * optimal).
	 * IN assertion: the array bl_count contains the bit length statistics for
	 * the given tree and the field len is set for all tree elements.
	 * OUT assertion: the field code is set for all tree elements of non
	 *     zero code length.
	 */
	function gen_codes(tree, max_code, bl_count)
	//    ct_data *tree;             /* the tree to decorate */
	//    int max_code;              /* largest code with non zero frequency */
	//    ushf *bl_count;            /* number of codes at each bit length */
	{
	  var next_code = new Array(MAX_BITS + 1); /* next code value for each bit length */
	  var code = 0;              /* running code value */
	  var bits;                  /* bit index */
	  var n;                     /* code index */
	
	  /* The distribution counts are first used to generate the code values
	   * without bit reversal.
	   */
	  for (bits = 1; bits <= MAX_BITS; bits++) {
	    next_code[bits] = code = (code + bl_count[bits - 1]) << 1;
	  }
	  /* Check that the bit counts in bl_count are consistent. The last code
	   * must be all ones.
	   */
	  //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
	  //        "inconsistent bit counts");
	  //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));
	
	  for (n = 0;  n <= max_code; n++) {
	    var len = tree[n * 2 + 1]/*.Len*/;
	    if (len === 0) { continue; }
	    /* Now reverse the bits */
	    tree[n * 2]/*.Code*/ = bi_reverse(next_code[len]++, len);
	
	    //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
	    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
	  }
	}
	
	
	/* ===========================================================================
	 * Initialize the various 'constant' tables.
	 */
	function tr_static_init() {
	  var n;        /* iterates over tree elements */
	  var bits;     /* bit counter */
	  var length;   /* length value */
	  var code;     /* code value */
	  var dist;     /* distance index */
	  var bl_count = new Array(MAX_BITS + 1);
	  /* number of codes at each bit length for an optimal tree */
	
	  // do check in _tr_init()
	  //if (static_init_done) return;
	
	  /* For some embedded targets, global variables are not initialized: */
	/*#ifdef NO_INIT_GLOBAL_POINTERS
	  static_l_desc.static_tree = static_ltree;
	  static_l_desc.extra_bits = extra_lbits;
	  static_d_desc.static_tree = static_dtree;
	  static_d_desc.extra_bits = extra_dbits;
	  static_bl_desc.extra_bits = extra_blbits;
	#endif*/
	
	  /* Initialize the mapping length (0..255) -> length code (0..28) */
	  length = 0;
	  for (code = 0; code < LENGTH_CODES - 1; code++) {
	    base_length[code] = length;
	    for (n = 0; n < (1 << extra_lbits[code]); n++) {
	      _length_code[length++] = code;
	    }
	  }
	  //Assert (length == 256, "tr_static_init: length != 256");
	  /* Note that the length 255 (match length 258) can be represented
	   * in two different ways: code 284 + 5 bits or code 285, so we
	   * overwrite length_code[255] to use the best encoding:
	   */
	  _length_code[length - 1] = code;
	
	  /* Initialize the mapping dist (0..32K) -> dist code (0..29) */
	  dist = 0;
	  for (code = 0; code < 16; code++) {
	    base_dist[code] = dist;
	    for (n = 0; n < (1 << extra_dbits[code]); n++) {
	      _dist_code[dist++] = code;
	    }
	  }
	  //Assert (dist == 256, "tr_static_init: dist != 256");
	  dist >>= 7; /* from now on, all distances are divided by 128 */
	  for (; code < D_CODES; code++) {
	    base_dist[code] = dist << 7;
	    for (n = 0; n < (1 << (extra_dbits[code] - 7)); n++) {
	      _dist_code[256 + dist++] = code;
	    }
	  }
	  //Assert (dist == 256, "tr_static_init: 256+dist != 512");
	
	  /* Construct the codes of the static literal tree */
	  for (bits = 0; bits <= MAX_BITS; bits++) {
	    bl_count[bits] = 0;
	  }
	
	  n = 0;
	  while (n <= 143) {
	    static_ltree[n * 2 + 1]/*.Len*/ = 8;
	    n++;
	    bl_count[8]++;
	  }
	  while (n <= 255) {
	    static_ltree[n * 2 + 1]/*.Len*/ = 9;
	    n++;
	    bl_count[9]++;
	  }
	  while (n <= 279) {
	    static_ltree[n * 2 + 1]/*.Len*/ = 7;
	    n++;
	    bl_count[7]++;
	  }
	  while (n <= 287) {
	    static_ltree[n * 2 + 1]/*.Len*/ = 8;
	    n++;
	    bl_count[8]++;
	  }
	  /* Codes 286 and 287 do not exist, but we must include them in the
	   * tree construction to get a canonical Huffman tree (longest code
	   * all ones)
	   */
	  gen_codes(static_ltree, L_CODES + 1, bl_count);
	
	  /* The static distance tree is trivial: */
	  for (n = 0; n < D_CODES; n++) {
	    static_dtree[n * 2 + 1]/*.Len*/ = 5;
	    static_dtree[n * 2]/*.Code*/ = bi_reverse(n, 5);
	  }
	
	  // Now data ready and we can init static trees
	  static_l_desc = new StaticTreeDesc(static_ltree, extra_lbits, LITERALS + 1, L_CODES, MAX_BITS);
	  static_d_desc = new StaticTreeDesc(static_dtree, extra_dbits, 0,          D_CODES, MAX_BITS);
	  static_bl_desc = new StaticTreeDesc(new Array(0), extra_blbits, 0,         BL_CODES, MAX_BL_BITS);
	
	  //static_init_done = true;
	}
	
	
	/* ===========================================================================
	 * Initialize a new block.
	 */
	function init_block(s) {
	  var n; /* iterates over tree elements */
	
	  /* Initialize the trees. */
	  for (n = 0; n < L_CODES;  n++) { s.dyn_ltree[n * 2]/*.Freq*/ = 0; }
	  for (n = 0; n < D_CODES;  n++) { s.dyn_dtree[n * 2]/*.Freq*/ = 0; }
	  for (n = 0; n < BL_CODES; n++) { s.bl_tree[n * 2]/*.Freq*/ = 0; }
	
	  s.dyn_ltree[END_BLOCK * 2]/*.Freq*/ = 1;
	  s.opt_len = s.static_len = 0;
	  s.last_lit = s.matches = 0;
	}
	
	
	/* ===========================================================================
	 * Flush the bit buffer and align the output on a byte boundary
	 */
	function bi_windup(s)
	{
	  if (s.bi_valid > 8) {
	    put_short(s, s.bi_buf);
	  } else if (s.bi_valid > 0) {
	    //put_byte(s, (Byte)s->bi_buf);
	    s.pending_buf[s.pending++] = s.bi_buf;
	  }
	  s.bi_buf = 0;
	  s.bi_valid = 0;
	}
	
	/* ===========================================================================
	 * Copy a stored block, storing first the length and its
	 * one's complement if requested.
	 */
	function copy_block(s, buf, len, header)
	//DeflateState *s;
	//charf    *buf;    /* the input data */
	//unsigned len;     /* its length */
	//int      header;  /* true if block header must be written */
	{
	  bi_windup(s);        /* align on byte boundary */
	
	  if (header) {
	    put_short(s, len);
	    put_short(s, ~len);
	  }
	//  while (len--) {
	//    put_byte(s, *buf++);
	//  }
	  utils.arraySet(s.pending_buf, s.window, buf, len, s.pending);
	  s.pending += len;
	}
	
	/* ===========================================================================
	 * Compares to subtrees, using the tree depth as tie breaker when
	 * the subtrees have equal frequency. This minimizes the worst case length.
	 */
	function smaller(tree, n, m, depth) {
	  var _n2 = n * 2;
	  var _m2 = m * 2;
	  return (tree[_n2]/*.Freq*/ < tree[_m2]/*.Freq*/ ||
	         (tree[_n2]/*.Freq*/ === tree[_m2]/*.Freq*/ && depth[n] <= depth[m]));
	}
	
	/* ===========================================================================
	 * Restore the heap property by moving down the tree starting at node k,
	 * exchanging a node with the smallest of its two sons if necessary, stopping
	 * when the heap property is re-established (each father smaller than its
	 * two sons).
	 */
	function pqdownheap(s, tree, k)
	//    deflate_state *s;
	//    ct_data *tree;  /* the tree to restore */
	//    int k;               /* node to move down */
	{
	  var v = s.heap[k];
	  var j = k << 1;  /* left son of k */
	  while (j <= s.heap_len) {
	    /* Set j to the smallest of the two sons: */
	    if (j < s.heap_len &&
	      smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) {
	      j++;
	    }
	    /* Exit if v is smaller than both sons */
	    if (smaller(tree, v, s.heap[j], s.depth)) { break; }
	
	    /* Exchange v with the smallest son */
	    s.heap[k] = s.heap[j];
	    k = j;
	
	    /* And continue down the tree, setting j to the left son of k */
	    j <<= 1;
	  }
	  s.heap[k] = v;
	}
	
	
	// inlined manually
	// var SMALLEST = 1;
	
	/* ===========================================================================
	 * Send the block data compressed using the given Huffman trees
	 */
	function compress_block(s, ltree, dtree)
	//    deflate_state *s;
	//    const ct_data *ltree; /* literal tree */
	//    const ct_data *dtree; /* distance tree */
	{
	  var dist;           /* distance of matched string */
	  var lc;             /* match length or unmatched char (if dist == 0) */
	  var lx = 0;         /* running index in l_buf */
	  var code;           /* the code to send */
	  var extra;          /* number of extra bits to send */
	
	  if (s.last_lit !== 0) {
	    do {
	      dist = (s.pending_buf[s.d_buf + lx * 2] << 8) | (s.pending_buf[s.d_buf + lx * 2 + 1]);
	      lc = s.pending_buf[s.l_buf + lx];
	      lx++;
	
	      if (dist === 0) {
	        send_code(s, lc, ltree); /* send a literal byte */
	        //Tracecv(isgraph(lc), (stderr," '%c' ", lc));
	      } else {
	        /* Here, lc is the match length - MIN_MATCH */
	        code = _length_code[lc];
	        send_code(s, code + LITERALS + 1, ltree); /* send the length code */
	        extra = extra_lbits[code];
	        if (extra !== 0) {
	          lc -= base_length[code];
	          send_bits(s, lc, extra);       /* send the extra length bits */
	        }
	        dist--; /* dist is now the match distance - 1 */
	        code = d_code(dist);
	        //Assert (code < D_CODES, "bad d_code");
	
	        send_code(s, code, dtree);       /* send the distance code */
	        extra = extra_dbits[code];
	        if (extra !== 0) {
	          dist -= base_dist[code];
	          send_bits(s, dist, extra);   /* send the extra distance bits */
	        }
	      } /* literal or match pair ? */
	
	      /* Check that the overlay between pending_buf and d_buf+l_buf is ok: */
	      //Assert((uInt)(s->pending) < s->lit_bufsize + 2*lx,
	      //       "pendingBuf overflow");
	
	    } while (lx < s.last_lit);
	  }
	
	  send_code(s, END_BLOCK, ltree);
	}
	
	
	/* ===========================================================================
	 * Construct one Huffman tree and assigns the code bit strings and lengths.
	 * Update the total bit length for the current block.
	 * IN assertion: the field freq is set for all tree elements.
	 * OUT assertions: the fields len and code are set to the optimal bit length
	 *     and corresponding code. The length opt_len is updated; static_len is
	 *     also updated if stree is not null. The field max_code is set.
	 */
	function build_tree(s, desc)
	//    deflate_state *s;
	//    tree_desc *desc; /* the tree descriptor */
	{
	  var tree     = desc.dyn_tree;
	  var stree    = desc.stat_desc.static_tree;
	  var has_stree = desc.stat_desc.has_stree;
	  var elems    = desc.stat_desc.elems;
	  var n, m;          /* iterate over heap elements */
	  var max_code = -1; /* largest code with non zero frequency */
	  var node;          /* new node being created */
	
	  /* Construct the initial heap, with least frequent element in
	   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
	   * heap[0] is not used.
	   */
	  s.heap_len = 0;
	  s.heap_max = HEAP_SIZE;
	
	  for (n = 0; n < elems; n++) {
	    if (tree[n * 2]/*.Freq*/ !== 0) {
	      s.heap[++s.heap_len] = max_code = n;
	      s.depth[n] = 0;
	
	    } else {
	      tree[n * 2 + 1]/*.Len*/ = 0;
	    }
	  }
	
	  /* The pkzip format requires that at least one distance code exists,
	   * and that at least one bit should be sent even if there is only one
	   * possible code. So to avoid special checks later on we force at least
	   * two codes of non zero frequency.
	   */
	  while (s.heap_len < 2) {
	    node = s.heap[++s.heap_len] = (max_code < 2 ? ++max_code : 0);
	    tree[node * 2]/*.Freq*/ = 1;
	    s.depth[node] = 0;
	    s.opt_len--;
	
	    if (has_stree) {
	      s.static_len -= stree[node * 2 + 1]/*.Len*/;
	    }
	    /* node is 0 or 1 so it does not have extra bits */
	  }
	  desc.max_code = max_code;
	
	  /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
	   * establish sub-heaps of increasing lengths:
	   */
	  for (n = (s.heap_len >> 1/*int /2*/); n >= 1; n--) { pqdownheap(s, tree, n); }
	
	  /* Construct the Huffman tree by repeatedly combining the least two
	   * frequent nodes.
	   */
	  node = elems;              /* next internal node of the tree */
	  do {
	    //pqremove(s, tree, n);  /* n = node of least frequency */
	    /*** pqremove ***/
	    n = s.heap[1/*SMALLEST*/];
	    s.heap[1/*SMALLEST*/] = s.heap[s.heap_len--];
	    pqdownheap(s, tree, 1/*SMALLEST*/);
	    /***/
	
	    m = s.heap[1/*SMALLEST*/]; /* m = node of next least frequency */
	
	    s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */
	    s.heap[--s.heap_max] = m;
	
	    /* Create a new node father of n and m */
	    tree[node * 2]/*.Freq*/ = tree[n * 2]/*.Freq*/ + tree[m * 2]/*.Freq*/;
	    s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
	    tree[n * 2 + 1]/*.Dad*/ = tree[m * 2 + 1]/*.Dad*/ = node;
	
	    /* and insert the new node in the heap */
	    s.heap[1/*SMALLEST*/] = node++;
	    pqdownheap(s, tree, 1/*SMALLEST*/);
	
	  } while (s.heap_len >= 2);
	
	  s.heap[--s.heap_max] = s.heap[1/*SMALLEST*/];
	
	  /* At this point, the fields freq and dad are set. We can now
	   * generate the bit lengths.
	   */
	  gen_bitlen(s, desc);
	
	  /* The field len is now set, we can generate the bit codes */
	  gen_codes(tree, max_code, s.bl_count);
	}
	
	
	/* ===========================================================================
	 * Scan a literal or distance tree to determine the frequencies of the codes
	 * in the bit length tree.
	 */
	function scan_tree(s, tree, max_code)
	//    deflate_state *s;
	//    ct_data *tree;   /* the tree to be scanned */
	//    int max_code;    /* and its largest code of non zero frequency */
	{
	  var n;                     /* iterates over all tree elements */
	  var prevlen = -1;          /* last emitted length */
	  var curlen;                /* length of current code */
	
	  var nextlen = tree[0 * 2 + 1]/*.Len*/; /* length of next code */
	
	  var count = 0;             /* repeat count of the current code */
	  var max_count = 7;         /* max repeat count */
	  var min_count = 4;         /* min repeat count */
	
	  if (nextlen === 0) {
	    max_count = 138;
	    min_count = 3;
	  }
	  tree[(max_code + 1) * 2 + 1]/*.Len*/ = 0xffff; /* guard */
	
	  for (n = 0; n <= max_code; n++) {
	    curlen = nextlen;
	    nextlen = tree[(n + 1) * 2 + 1]/*.Len*/;
	
	    if (++count < max_count && curlen === nextlen) {
	      continue;
	
	    } else if (count < min_count) {
	      s.bl_tree[curlen * 2]/*.Freq*/ += count;
	
	    } else if (curlen !== 0) {
	
	      if (curlen !== prevlen) { s.bl_tree[curlen * 2]/*.Freq*/++; }
	      s.bl_tree[REP_3_6 * 2]/*.Freq*/++;
	
	    } else if (count <= 10) {
	      s.bl_tree[REPZ_3_10 * 2]/*.Freq*/++;
	
	    } else {
	      s.bl_tree[REPZ_11_138 * 2]/*.Freq*/++;
	    }
	
	    count = 0;
	    prevlen = curlen;
	
	    if (nextlen === 0) {
	      max_count = 138;
	      min_count = 3;
	
	    } else if (curlen === nextlen) {
	      max_count = 6;
	      min_count = 3;
	
	    } else {
	      max_count = 7;
	      min_count = 4;
	    }
	  }
	}
	
	
	/* ===========================================================================
	 * Send a literal or distance tree in compressed form, using the codes in
	 * bl_tree.
	 */
	function send_tree(s, tree, max_code)
	//    deflate_state *s;
	//    ct_data *tree; /* the tree to be scanned */
	//    int max_code;       /* and its largest code of non zero frequency */
	{
	  var n;                     /* iterates over all tree elements */
	  var prevlen = -1;          /* last emitted length */
	  var curlen;                /* length of current code */
	
	  var nextlen = tree[0 * 2 + 1]/*.Len*/; /* length of next code */
	
	  var count = 0;             /* repeat count of the current code */
	  var max_count = 7;         /* max repeat count */
	  var min_count = 4;         /* min repeat count */
	
	  /* tree[max_code+1].Len = -1; */  /* guard already set */
	  if (nextlen === 0) {
	    max_count = 138;
	    min_count = 3;
	  }
	
	  for (n = 0; n <= max_code; n++) {
	    curlen = nextlen;
	    nextlen = tree[(n + 1) * 2 + 1]/*.Len*/;
	
	    if (++count < max_count && curlen === nextlen) {
	      continue;
	
	    } else if (count < min_count) {
	      do { send_code(s, curlen, s.bl_tree); } while (--count !== 0);
	
	    } else if (curlen !== 0) {
	      if (curlen !== prevlen) {
	        send_code(s, curlen, s.bl_tree);
	        count--;
	      }
	      //Assert(count >= 3 && count <= 6, " 3_6?");
	      send_code(s, REP_3_6, s.bl_tree);
	      send_bits(s, count - 3, 2);
	
	    } else if (count <= 10) {
	      send_code(s, REPZ_3_10, s.bl_tree);
	      send_bits(s, count - 3, 3);
	
	    } else {
	      send_code(s, REPZ_11_138, s.bl_tree);
	      send_bits(s, count - 11, 7);
	    }
	
	    count = 0;
	    prevlen = curlen;
	    if (nextlen === 0) {
	      max_count = 138;
	      min_count = 3;
	
	    } else if (curlen === nextlen) {
	      max_count = 6;
	      min_count = 3;
	
	    } else {
	      max_count = 7;
	      min_count = 4;
	    }
	  }
	}
	
	
	/* ===========================================================================
	 * Construct the Huffman tree for the bit lengths and return the index in
	 * bl_order of the last bit length code to send.
	 */
	function build_bl_tree(s) {
	  var max_blindex;  /* index of last bit length code of non zero freq */
	
	  /* Determine the bit length frequencies for literal and distance trees */
	  scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
	  scan_tree(s, s.dyn_dtree, s.d_desc.max_code);
	
	  /* Build the bit length tree: */
	  build_tree(s, s.bl_desc);
	  /* opt_len now includes the length of the tree representations, except
	   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
	   */
	
	  /* Determine the number of bit length codes to send. The pkzip format
	   * requires that at least 4 bit length codes be sent. (appnote.txt says
	   * 3 but the actual value used is 4.)
	   */
	  for (max_blindex = BL_CODES - 1; max_blindex >= 3; max_blindex--) {
	    if (s.bl_tree[bl_order[max_blindex] * 2 + 1]/*.Len*/ !== 0) {
	      break;
	    }
	  }
	  /* Update opt_len to include the bit length tree and counts */
	  s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
	  //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
	  //        s->opt_len, s->static_len));
	
	  return max_blindex;
	}
	
	
	/* ===========================================================================
	 * Send the header for a block using dynamic Huffman trees: the counts, the
	 * lengths of the bit length codes, the literal tree and the distance tree.
	 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
	 */
	function send_all_trees(s, lcodes, dcodes, blcodes)
	//    deflate_state *s;
	//    int lcodes, dcodes, blcodes; /* number of codes for each tree */
	{
	  var rank;                    /* index in bl_order */
	
	  //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
	  //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
	  //        "too many codes");
	  //Tracev((stderr, "\nbl counts: "));
	  send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */
	  send_bits(s, dcodes - 1,   5);
	  send_bits(s, blcodes - 4,  4); /* not -3 as stated in appnote.txt */
	  for (rank = 0; rank < blcodes; rank++) {
	    //Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
	    send_bits(s, s.bl_tree[bl_order[rank] * 2 + 1]/*.Len*/, 3);
	  }
	  //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));
	
	  send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */
	  //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));
	
	  send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */
	  //Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
	}
	
	
	/* ===========================================================================
	 * Check if the data type is TEXT or BINARY, using the following algorithm:
	 * - TEXT if the two conditions below are satisfied:
	 *    a) There are no non-portable control characters belonging to the
	 *       "black list" (0..6, 14..25, 28..31).
	 *    b) There is at least one printable character belonging to the
	 *       "white list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
	 * - BINARY otherwise.
	 * - The following partially-portable control characters form a
	 *   "gray list" that is ignored in this detection algorithm:
	 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
	 * IN assertion: the fields Freq of dyn_ltree are set.
	 */
	function detect_data_type(s) {
	  /* black_mask is the bit mask of black-listed bytes
	   * set bits 0..6, 14..25, and 28..31
	   * 0xf3ffc07f = binary 11110011111111111100000001111111
	   */
	  var black_mask = 0xf3ffc07f;
	  var n;
	
	  /* Check for non-textual ("black-listed") bytes. */
	  for (n = 0; n <= 31; n++, black_mask >>>= 1) {
	    if ((black_mask & 1) && (s.dyn_ltree[n * 2]/*.Freq*/ !== 0)) {
	      return Z_BINARY;
	    }
	  }
	
	  /* Check for textual ("white-listed") bytes. */
	  if (s.dyn_ltree[9 * 2]/*.Freq*/ !== 0 || s.dyn_ltree[10 * 2]/*.Freq*/ !== 0 ||
	      s.dyn_ltree[13 * 2]/*.Freq*/ !== 0) {
	    return Z_TEXT;
	  }
	  for (n = 32; n < LITERALS; n++) {
	    if (s.dyn_ltree[n * 2]/*.Freq*/ !== 0) {
	      return Z_TEXT;
	    }
	  }
	
	  /* There are no "black-listed" or "white-listed" bytes:
	   * this stream either is empty or has tolerated ("gray-listed") bytes only.
	   */
	  return Z_BINARY;
	}
	
	
	var static_init_done = false;
	
	/* ===========================================================================
	 * Initialize the tree data structures for a new zlib stream.
	 */
	function _tr_init(s)
	{
	
	  if (!static_init_done) {
	    tr_static_init();
	    static_init_done = true;
	  }
	
	  s.l_desc  = new TreeDesc(s.dyn_ltree, static_l_desc);
	  s.d_desc  = new TreeDesc(s.dyn_dtree, static_d_desc);
	  s.bl_desc = new TreeDesc(s.bl_tree, static_bl_desc);
	
	  s.bi_buf = 0;
	  s.bi_valid = 0;
	
	  /* Initialize the first block of the first file: */
	  init_block(s);
	}
	
	
	/* ===========================================================================
	 * Send a stored block
	 */
	function _tr_stored_block(s, buf, stored_len, last)
	//DeflateState *s;
	//charf *buf;       /* input block */
	//ulg stored_len;   /* length of input block */
	//int last;         /* one if this is the last block for a file */
	{
	  send_bits(s, (STORED_BLOCK << 1) + (last ? 1 : 0), 3);    /* send block type */
	  copy_block(s, buf, stored_len, true); /* with header */
	}
	
	
	/* ===========================================================================
	 * Send one empty static block to give enough lookahead for inflate.
	 * This takes 10 bits, of which 7 may remain in the bit buffer.
	 */
	function _tr_align(s) {
	  send_bits(s, STATIC_TREES << 1, 3);
	  send_code(s, END_BLOCK, static_ltree);
	  bi_flush(s);
	}
	
	
	/* ===========================================================================
	 * Determine the best encoding for the current block: dynamic trees, static
	 * trees or store, and output the encoded block to the zip file.
	 */
	function _tr_flush_block(s, buf, stored_len, last)
	//DeflateState *s;
	//charf *buf;       /* input block, or NULL if too old */
	//ulg stored_len;   /* length of input block */
	//int last;         /* one if this is the last block for a file */
	{
	  var opt_lenb, static_lenb;  /* opt_len and static_len in bytes */
	  var max_blindex = 0;        /* index of last bit length code of non zero freq */
	
	  /* Build the Huffman trees unless a stored block is forced */
	  if (s.level > 0) {
	
	    /* Check if the file is binary or text */
	    if (s.strm.data_type === Z_UNKNOWN) {
	      s.strm.data_type = detect_data_type(s);
	    }
	
	    /* Construct the literal and distance trees */
	    build_tree(s, s.l_desc);
	    // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
	    //        s->static_len));
	
	    build_tree(s, s.d_desc);
	    // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
	    //        s->static_len));
	    /* At this point, opt_len and static_len are the total bit lengths of
	     * the compressed block data, excluding the tree representations.
	     */
	
	    /* Build the bit length tree for the above two trees, and get the index
	     * in bl_order of the last bit length code to send.
	     */
	    max_blindex = build_bl_tree(s);
	
	    /* Determine the best encoding. Compute the block lengths in bytes. */
	    opt_lenb = (s.opt_len + 3 + 7) >>> 3;
	    static_lenb = (s.static_len + 3 + 7) >>> 3;
	
	    // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
	    //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
	    //        s->last_lit));
	
	    if (static_lenb <= opt_lenb) { opt_lenb = static_lenb; }
	
	  } else {
	    // Assert(buf != (char*)0, "lost buf");
	    opt_lenb = static_lenb = stored_len + 5; /* force a stored block */
	  }
	
	  if ((stored_len + 4 <= opt_lenb) && (buf !== -1)) {
	    /* 4: two words for the lengths */
	
	    /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
	     * Otherwise we can't have processed more than WSIZE input bytes since
	     * the last block flush, because compression would have been
	     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
	     * transform a block into a stored block.
	     */
	    _tr_stored_block(s, buf, stored_len, last);
	
	  } else if (s.strategy === Z_FIXED || static_lenb === opt_lenb) {
	
	    send_bits(s, (STATIC_TREES << 1) + (last ? 1 : 0), 3);
	    compress_block(s, static_ltree, static_dtree);
	
	  } else {
	    send_bits(s, (DYN_TREES << 1) + (last ? 1 : 0), 3);
	    send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
	    compress_block(s, s.dyn_ltree, s.dyn_dtree);
	  }
	  // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
	  /* The above check is made mod 2^32, for files larger than 512 MB
	   * and uLong implemented on 32 bits.
	   */
	  init_block(s);
	
	  if (last) {
	    bi_windup(s);
	  }
	  // Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
	  //       s->compressed_len-7*last));
	}
	
	/* ===========================================================================
	 * Save the match info and tally the frequency counts. Return true if
	 * the current block must be flushed.
	 */
	function _tr_tally(s, dist, lc)
	//    deflate_state *s;
	//    unsigned dist;  /* distance of matched string */
	//    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
	{
	  //var out_length, in_length, dcode;
	
	  s.pending_buf[s.d_buf + s.last_lit * 2]     = (dist >>> 8) & 0xff;
	  s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist & 0xff;
	
	  s.pending_buf[s.l_buf + s.last_lit] = lc & 0xff;
	  s.last_lit++;
	
	  if (dist === 0) {
	    /* lc is the unmatched char */
	    s.dyn_ltree[lc * 2]/*.Freq*/++;
	  } else {
	    s.matches++;
	    /* Here, lc is the match length - MIN_MATCH */
	    dist--;             /* dist = match distance - 1 */
	    //Assert((ush)dist < (ush)MAX_DIST(s) &&
	    //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
	    //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");
	
	    s.dyn_ltree[(_length_code[lc] + LITERALS + 1) * 2]/*.Freq*/++;
	    s.dyn_dtree[d_code(dist) * 2]/*.Freq*/++;
	  }
	
	// (!) This block is disabled in zlib defaults,
	// don't enable it for binary compatibility
	
	//#ifdef TRUNCATE_BLOCK
	//  /* Try to guess if it is profitable to stop the current block here */
	//  if ((s.last_lit & 0x1fff) === 0 && s.level > 2) {
	//    /* Compute an upper bound for the compressed length */
	//    out_length = s.last_lit*8;
	//    in_length = s.strstart - s.block_start;
	//
	//    for (dcode = 0; dcode < D_CODES; dcode++) {
	//      out_length += s.dyn_dtree[dcode*2]/*.Freq*/ * (5 + extra_dbits[dcode]);
	//    }
	//    out_length >>>= 3;
	//    //Tracev((stderr,"\nlast_lit %u, in %ld, out ~%ld(%ld%%) ",
	//    //       s->last_lit, in_length, out_length,
	//    //       100L - out_length*100L/in_length));
	//    if (s.matches < (s.last_lit>>1)/*int /2*/ && out_length < (in_length>>1)/*int /2*/) {
	//      return true;
	//    }
	//  }
	//#endif
	
	  return (s.last_lit === s.lit_bufsize - 1);
	  /* We avoid equality with lit_bufsize because of wraparound at 64K
	   * on 16 bit machines and because stored blocks are restricted to
	   * 64K-1 bytes.
	   */
	}
	
	exports._tr_init  = _tr_init;
	exports._tr_stored_block = _tr_stored_block;
	exports._tr_flush_block  = _tr_flush_block;
	exports._tr_tally = _tr_tally;
	exports._tr_align = _tr_align;


/***/ },
/* 1363 */
/***/ function(module, exports, __webpack_require__) {

	var isarray = __webpack_require__(1311)
	
	/**
	 * Expose `pathToRegexp`.
	 */
	module.exports = pathToRegexp
	module.exports.parse = parse
	module.exports.compile = compile
	module.exports.tokensToFunction = tokensToFunction
	module.exports.tokensToRegExp = tokensToRegExp
	
	/**
	 * The main path matching regexp utility.
	 *
	 * @type {RegExp}
	 */
	var PATH_REGEXP = new RegExp([
	  // Match escaped characters that would otherwise appear in future matches.
	  // This allows the user to escape special characters that won't transform.
	  '(\\\\.)',
	  // Match Express-style parameters and un-named parameters with a prefix
	  // and optional suffixes. Matches appear as:
	  //
	  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
	  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
	  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
	  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
	].join('|'), 'g')
	
	/**
	 * Parse a string for the raw tokens.
	 *
	 * @param  {string}  str
	 * @param  {Object=} options
	 * @return {!Array}
	 */
	function parse (str, options) {
	  var tokens = []
	  var key = 0
	  var index = 0
	  var path = ''
	  var defaultDelimiter = options && options.delimiter || '/'
	  var res
	
	  while ((res = PATH_REGEXP.exec(str)) != null) {
	    var m = res[0]
	    var escaped = res[1]
	    var offset = res.index
	    path += str.slice(index, offset)
	    index = offset + m.length
	
	    // Ignore already escaped sequences.
	    if (escaped) {
	      path += escaped[1]
	      continue
	    }
	
	    var next = str[index]
	    var prefix = res[2]
	    var name = res[3]
	    var capture = res[4]
	    var group = res[5]
	    var modifier = res[6]
	    var asterisk = res[7]
	
	    // Push the current path onto the tokens.
	    if (path) {
	      tokens.push(path)
	      path = ''
	    }
	
	    var partial = prefix != null && next != null && next !== prefix
	    var repeat = modifier === '+' || modifier === '*'
	    var optional = modifier === '?' || modifier === '*'
	    var delimiter = res[2] || defaultDelimiter
	    var pattern = capture || group
	
	    tokens.push({
	      name: name || key++,
	      prefix: prefix || '',
	      delimiter: delimiter,
	      optional: optional,
	      repeat: repeat,
	      partial: partial,
	      asterisk: !!asterisk,
	      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
	    })
	  }
	
	  // Match any characters still remaining.
	  if (index < str.length) {
	    path += str.substr(index)
	  }
	
	  // If the path exists, push it onto the end.
	  if (path) {
	    tokens.push(path)
	  }
	
	  return tokens
	}
	
	/**
	 * Compile a string to a template function for the path.
	 *
	 * @param  {string}             str
	 * @param  {Object=}            options
	 * @return {!function(Object=, Object=)}
	 */
	function compile (str, options) {
	  return tokensToFunction(parse(str, options), options)
	}
	
	/**
	 * Prettier encoding of URI path segments.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeURIComponentPretty (str) {
	  return encodeURI(str).replace(/[\/?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeAsterisk (str) {
	  return encodeURI(str).replace(/[?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Expose a method for transforming tokens into the path function.
	 */
	function tokensToFunction (tokens, options) {
	  // Compile all the tokens into regexps.
	  var matches = new Array(tokens.length)
	
	  // Compile all the patterns before compilation.
	  for (var i = 0; i < tokens.length; i++) {
	    if (typeof tokens[i] === 'object') {
	      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', flags(options))
	    }
	  }
	
	  return function (obj, opts) {
	    var path = ''
	    var data = obj || {}
	    var options = opts || {}
	    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent
	
	    for (var i = 0; i < tokens.length; i++) {
	      var token = tokens[i]
	
	      if (typeof token === 'string') {
	        path += token
	
	        continue
	      }
	
	      var value = data[token.name]
	      var segment
	
	      if (value == null) {
	        if (token.optional) {
	          // Prepend partial segment prefixes.
	          if (token.partial) {
	            path += token.prefix
	          }
	
	          continue
	        } else {
	          throw new TypeError('Expected "' + token.name + '" to be defined')
	        }
	      }
	
	      if (isarray(value)) {
	        if (!token.repeat) {
	          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
	        }
	
	        if (value.length === 0) {
	          if (token.optional) {
	            continue
	          } else {
	            throw new TypeError('Expected "' + token.name + '" to not be empty')
	          }
	        }
	
	        for (var j = 0; j < value.length; j++) {
	          segment = encode(value[j])
	
	          if (!matches[i].test(segment)) {
	            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
	          }
	
	          path += (j === 0 ? token.prefix : token.delimiter) + segment
	        }
	
	        continue
	      }
	
	      segment = token.asterisk ? encodeAsterisk(value) : encode(value)
	
	      if (!matches[i].test(segment)) {
	        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
	      }
	
	      path += token.prefix + segment
	    }
	
	    return path
	  }
	}
	
	/**
	 * Escape a regular expression string.
	 *
	 * @param  {string} str
	 * @return {string}
	 */
	function escapeString (str) {
	  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
	}
	
	/**
	 * Escape the capturing group by escaping special characters and meaning.
	 *
	 * @param  {string} group
	 * @return {string}
	 */
	function escapeGroup (group) {
	  return group.replace(/([=!:$\/()])/g, '\\$1')
	}
	
	/**
	 * Attach the keys as a property of the regexp.
	 *
	 * @param  {!RegExp} re
	 * @param  {Array}   keys
	 * @return {!RegExp}
	 */
	function attachKeys (re, keys) {
	  re.keys = keys
	  return re
	}
	
	/**
	 * Get the flags for a regexp from the options.
	 *
	 * @param  {Object} options
	 * @return {string}
	 */
	function flags (options) {
	  return options && options.sensitive ? '' : 'i'
	}
	
	/**
	 * Pull out keys from a regexp.
	 *
	 * @param  {!RegExp} path
	 * @param  {!Array}  keys
	 * @return {!RegExp}
	 */
	function regexpToRegexp (path, keys) {
	  // Use a negative lookahead to match only capturing groups.
	  var groups = path.source.match(/\((?!\?)/g)
	
	  if (groups) {
	    for (var i = 0; i < groups.length; i++) {
	      keys.push({
	        name: i,
	        prefix: null,
	        delimiter: null,
	        optional: false,
	        repeat: false,
	        partial: false,
	        asterisk: false,
	        pattern: null
	      })
	    }
	  }
	
	  return attachKeys(path, keys)
	}
	
	/**
	 * Transform an array into a regexp.
	 *
	 * @param  {!Array}  path
	 * @param  {Array}   keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function arrayToRegexp (path, keys, options) {
	  var parts = []
	
	  for (var i = 0; i < path.length; i++) {
	    parts.push(pathToRegexp(path[i], keys, options).source)
	  }
	
	  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))
	
	  return attachKeys(regexp, keys)
	}
	
	/**
	 * Create a path regexp from string input.
	 *
	 * @param  {string}  path
	 * @param  {!Array}  keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function stringToRegexp (path, keys, options) {
	  return tokensToRegExp(parse(path, options), keys, options)
	}
	
	/**
	 * Expose a function for taking tokens and returning a RegExp.
	 *
	 * @param  {!Array}          tokens
	 * @param  {(Array|Object)=} keys
	 * @param  {Object=}         options
	 * @return {!RegExp}
	 */
	function tokensToRegExp (tokens, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options)
	    keys = []
	  }
	
	  options = options || {}
	
	  var strict = options.strict
	  var end = options.end !== false
	  var route = ''
	
	  // Iterate over the tokens and create our regexp string.
	  for (var i = 0; i < tokens.length; i++) {
	    var token = tokens[i]
	
	    if (typeof token === 'string') {
	      route += escapeString(token)
	    } else {
	      var prefix = escapeString(token.prefix)
	      var capture = '(?:' + token.pattern + ')'
	
	      keys.push(token)
	
	      if (token.repeat) {
	        capture += '(?:' + prefix + capture + ')*'
	      }
	
	      if (token.optional) {
	        if (!token.partial) {
	          capture = '(?:' + prefix + '(' + capture + '))?'
	        } else {
	          capture = prefix + '(' + capture + ')?'
	        }
	      } else {
	        capture = prefix + '(' + capture + ')'
	      }
	
	      route += capture
	    }
	  }
	
	  var delimiter = escapeString(options.delimiter || '/')
	  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter
	
	  // In non-strict mode we allow a slash at the end of match. If the path to
	  // match already ends with a slash, we remove it for consistency. The slash
	  // is valid at the end of a path match, not in the middle. This is important
	  // in non-ending mode, where "/test/" shouldn't match "/test//route".
	  if (!strict) {
	    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
	  }
	
	  if (end) {
	    route += '$'
	  } else {
	    // In non-ending mode, we need the capturing groups to match as much as
	    // possible by using a positive lookahead to the end or next path segment.
	    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
	  }
	
	  return attachKeys(new RegExp('^' + route, flags(options)), keys)
	}
	
	/**
	 * Normalize the given path string, returning a regular expression.
	 *
	 * An empty array can be passed in for the keys, which will hold the
	 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
	 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
	 *
	 * @param  {(string|RegExp|Array)} path
	 * @param  {(Array|Object)=}       keys
	 * @param  {Object=}               options
	 * @return {!RegExp}
	 */
	function pathToRegexp (path, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options)
	    keys = []
	  }
	
	  options = options || {}
	
	  if (path instanceof RegExp) {
	    return regexpToRegexp(path, /** @type {!Array} */ (keys))
	  }
	
	  if (isarray(path)) {
	    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
	  }
	
	  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
	}


/***/ },
/* 1364 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**!
	 * @fileOverview Kickass library to create and place poppers near their reference elements.
	 * @version 1.16.1-lts
	 * @license
	 * Copyright (c) 2016 Federico Zivolo and contributors
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy
	 * of this software and associated documentation files (the "Software"), to deal
	 * in the Software without restriction, including without limitation the rights
	 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	 * copies of the Software, and to permit persons to whom the Software is
	 * furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all
	 * copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	 * SOFTWARE.
	 */
	(function (global, factory) {
		 true ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(global.Popper = factory());
	}(this, (function () { 'use strict';
	
	var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';
	
	var timeoutDuration = function () {
	  var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
	  for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
	    if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
	      return 1;
	    }
	  }
	  return 0;
	}();
	
	function microtaskDebounce(fn) {
	  var called = false;
	  return function () {
	    if (called) {
	      return;
	    }
	    called = true;
	    window.Promise.resolve().then(function () {
	      called = false;
	      fn();
	    });
	  };
	}
	
	function taskDebounce(fn) {
	  var scheduled = false;
	  return function () {
	    if (!scheduled) {
	      scheduled = true;
	      setTimeout(function () {
	        scheduled = false;
	        fn();
	      }, timeoutDuration);
	    }
	  };
	}
	
	var supportsMicroTasks = isBrowser && window.Promise;
	
	/**
	* Create a debounced version of a method, that's asynchronously deferred
	* but called in the minimum time possible.
	*
	* @method
	* @memberof Popper.Utils
	* @argument {Function} fn
	* @returns {Function}
	*/
	var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;
	
	/**
	 * Check if the given variable is a function
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Any} functionToCheck - variable to check
	 * @returns {Boolean} answer to: is a function?
	 */
	function isFunction(functionToCheck) {
	  var getType = {};
	  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
	}
	
	/**
	 * Get CSS computed property of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Eement} element
	 * @argument {String} property
	 */
	function getStyleComputedProperty(element, property) {
	  if (element.nodeType !== 1) {
	    return [];
	  }
	  // NOTE: 1 DOM access here
	  var window = element.ownerDocument.defaultView;
	  var css = window.getComputedStyle(element, null);
	  return property ? css[property] : css;
	}
	
	/**
	 * Returns the parentNode or the host of the element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} parent
	 */
	function getParentNode(element) {
	  if (element.nodeName === 'HTML') {
	    return element;
	  }
	  return element.parentNode || element.host;
	}
	
	/**
	 * Returns the scrolling parent of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} scroll parent
	 */
	function getScrollParent(element) {
	  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
	  if (!element) {
	    return document.body;
	  }
	
	  switch (element.nodeName) {
	    case 'HTML':
	    case 'BODY':
	      return element.ownerDocument.body;
	    case '#document':
	      return element.body;
	  }
	
	  // Firefox want us to check `-x` and `-y` variations as well
	
	  var _getStyleComputedProp = getStyleComputedProperty(element),
	      overflow = _getStyleComputedProp.overflow,
	      overflowX = _getStyleComputedProp.overflowX,
	      overflowY = _getStyleComputedProp.overflowY;
	
	  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
	    return element;
	  }
	
	  return getScrollParent(getParentNode(element));
	}
	
	/**
	 * Returns the reference node of the reference object, or the reference object itself.
	 * @method
	 * @memberof Popper.Utils
	 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
	 * @returns {Element} parent
	 */
	function getReferenceNode(reference) {
	  return reference && reference.referenceNode ? reference.referenceNode : reference;
	}
	
	var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
	var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);
	
	/**
	 * Determines if the browser is Internet Explorer
	 * @method
	 * @memberof Popper.Utils
	 * @param {Number} version to check
	 * @returns {Boolean} isIE
	 */
	function isIE(version) {
	  if (version === 11) {
	    return isIE11;
	  }
	  if (version === 10) {
	    return isIE10;
	  }
	  return isIE11 || isIE10;
	}
	
	/**
	 * Returns the offset parent of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} offset parent
	 */
	function getOffsetParent(element) {
	  if (!element) {
	    return document.documentElement;
	  }
	
	  var noOffsetParent = isIE(10) ? document.body : null;
	
	  // NOTE: 1 DOM access here
	  var offsetParent = element.offsetParent || null;
	  // Skip hidden elements which don't have an offsetParent
	  while (offsetParent === noOffsetParent && element.nextElementSibling) {
	    offsetParent = (element = element.nextElementSibling).offsetParent;
	  }
	
	  var nodeName = offsetParent && offsetParent.nodeName;
	
	  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
	    return element ? element.ownerDocument.documentElement : document.documentElement;
	  }
	
	  // .offsetParent will return the closest TH, TD or TABLE in case
	  // no offsetParent is present, I hate this job...
	  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
	    return getOffsetParent(offsetParent);
	  }
	
	  return offsetParent;
	}
	
	function isOffsetContainer(element) {
	  var nodeName = element.nodeName;
	
	  if (nodeName === 'BODY') {
	    return false;
	  }
	  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
	}
	
	/**
	 * Finds the root node (document, shadowDOM root) of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} node
	 * @returns {Element} root node
	 */
	function getRoot(node) {
	  if (node.parentNode !== null) {
	    return getRoot(node.parentNode);
	  }
	
	  return node;
	}
	
	/**
	 * Finds the offset parent common to the two provided nodes
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element1
	 * @argument {Element} element2
	 * @returns {Element} common offset parent
	 */
	function findCommonOffsetParent(element1, element2) {
	  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
	  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
	    return document.documentElement;
	  }
	
	  // Here we make sure to give as "start" the element that comes first in the DOM
	  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
	  var start = order ? element1 : element2;
	  var end = order ? element2 : element1;
	
	  // Get common ancestor container
	  var range = document.createRange();
	  range.setStart(start, 0);
	  range.setEnd(end, 0);
	  var commonAncestorContainer = range.commonAncestorContainer;
	
	  // Both nodes are inside #document
	
	  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
	    if (isOffsetContainer(commonAncestorContainer)) {
	      return commonAncestorContainer;
	    }
	
	    return getOffsetParent(commonAncestorContainer);
	  }
	
	  // one of the nodes is inside shadowDOM, find which one
	  var element1root = getRoot(element1);
	  if (element1root.host) {
	    return findCommonOffsetParent(element1root.host, element2);
	  } else {
	    return findCommonOffsetParent(element1, getRoot(element2).host);
	  }
	}
	
	/**
	 * Gets the scroll value of the given element in the given side (top and left)
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @argument {String} side `top` or `left`
	 * @returns {number} amount of scrolled pixels
	 */
	function getScroll(element) {
	  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';
	
	  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
	  var nodeName = element.nodeName;
	
	  if (nodeName === 'BODY' || nodeName === 'HTML') {
	    var html = element.ownerDocument.documentElement;
	    var scrollingElement = element.ownerDocument.scrollingElement || html;
	    return scrollingElement[upperSide];
	  }
	
	  return element[upperSide];
	}
	
	/*
	 * Sum or subtract the element scroll values (left and top) from a given rect object
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} rect - Rect object you want to change
	 * @param {HTMLElement} element - The element from the function reads the scroll values
	 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
	 * @return {Object} rect - The modifier rect object
	 */
	function includeScroll(rect, element) {
	  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  var scrollTop = getScroll(element, 'top');
	  var scrollLeft = getScroll(element, 'left');
	  var modifier = subtract ? -1 : 1;
	  rect.top += scrollTop * modifier;
	  rect.bottom += scrollTop * modifier;
	  rect.left += scrollLeft * modifier;
	  rect.right += scrollLeft * modifier;
	  return rect;
	}
	
	/*
	 * Helper to detect borders of a given element
	 * @method
	 * @memberof Popper.Utils
	 * @param {CSSStyleDeclaration} styles
	 * Result of `getStyleComputedProperty` on the given element
	 * @param {String} axis - `x` or `y`
	 * @return {number} borders - The borders size of the given axis
	 */
	
	function getBordersSize(styles, axis) {
	  var sideA = axis === 'x' ? 'Left' : 'Top';
	  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';
	
	  return parseFloat(styles['border' + sideA + 'Width']) + parseFloat(styles['border' + sideB + 'Width']);
	}
	
	function getSize(axis, body, html, computedStyle) {
	  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
	}
	
	function getWindowSizes(document) {
	  var body = document.body;
	  var html = document.documentElement;
	  var computedStyle = isIE(10) && getComputedStyle(html);
	
	  return {
	    height: getSize('Height', body, html, computedStyle),
	    width: getSize('Width', body, html, computedStyle)
	  };
	}
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	
	
	
	
	var defineProperty = function (obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	/**
	 * Given element offsets, generate an output similar to getBoundingClientRect
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Object} offsets
	 * @returns {Object} ClientRect like output
	 */
	function getClientRect(offsets) {
	  return _extends({}, offsets, {
	    right: offsets.left + offsets.width,
	    bottom: offsets.top + offsets.height
	  });
	}
	
	/**
	 * Get bounding client rect of given element
	 * @method
	 * @memberof Popper.Utils
	 * @param {HTMLElement} element
	 * @return {Object} client rect
	 */
	function getBoundingClientRect(element) {
	  var rect = {};
	
	  // IE10 10 FIX: Please, don't ask, the element isn't
	  // considered in DOM in some circumstances...
	  // This isn't reproducible in IE10 compatibility mode of IE11
	  try {
	    if (isIE(10)) {
	      rect = element.getBoundingClientRect();
	      var scrollTop = getScroll(element, 'top');
	      var scrollLeft = getScroll(element, 'left');
	      rect.top += scrollTop;
	      rect.left += scrollLeft;
	      rect.bottom += scrollTop;
	      rect.right += scrollLeft;
	    } else {
	      rect = element.getBoundingClientRect();
	    }
	  } catch (e) {}
	
	  var result = {
	    left: rect.left,
	    top: rect.top,
	    width: rect.right - rect.left,
	    height: rect.bottom - rect.top
	  };
	
	  // subtract scrollbar size from sizes
	  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
	  var width = sizes.width || element.clientWidth || result.width;
	  var height = sizes.height || element.clientHeight || result.height;
	
	  var horizScrollbar = element.offsetWidth - width;
	  var vertScrollbar = element.offsetHeight - height;
	
	  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
	  // we make this check conditional for performance reasons
	  if (horizScrollbar || vertScrollbar) {
	    var styles = getStyleComputedProperty(element);
	    horizScrollbar -= getBordersSize(styles, 'x');
	    vertScrollbar -= getBordersSize(styles, 'y');
	
	    result.width -= horizScrollbar;
	    result.height -= vertScrollbar;
	  }
	
	  return getClientRect(result);
	}
	
	function getOffsetRectRelativeToArbitraryNode(children, parent) {
	  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  var isIE10 = isIE(10);
	  var isHTML = parent.nodeName === 'HTML';
	  var childrenRect = getBoundingClientRect(children);
	  var parentRect = getBoundingClientRect(parent);
	  var scrollParent = getScrollParent(children);
	
	  var styles = getStyleComputedProperty(parent);
	  var borderTopWidth = parseFloat(styles.borderTopWidth);
	  var borderLeftWidth = parseFloat(styles.borderLeftWidth);
	
	  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
	  if (fixedPosition && isHTML) {
	    parentRect.top = Math.max(parentRect.top, 0);
	    parentRect.left = Math.max(parentRect.left, 0);
	  }
	  var offsets = getClientRect({
	    top: childrenRect.top - parentRect.top - borderTopWidth,
	    left: childrenRect.left - parentRect.left - borderLeftWidth,
	    width: childrenRect.width,
	    height: childrenRect.height
	  });
	  offsets.marginTop = 0;
	  offsets.marginLeft = 0;
	
	  // Subtract margins of documentElement in case it's being used as parent
	  // we do this only on HTML because it's the only element that behaves
	  // differently when margins are applied to it. The margins are included in
	  // the box of the documentElement, in the other cases not.
	  if (!isIE10 && isHTML) {
	    var marginTop = parseFloat(styles.marginTop);
	    var marginLeft = parseFloat(styles.marginLeft);
	
	    offsets.top -= borderTopWidth - marginTop;
	    offsets.bottom -= borderTopWidth - marginTop;
	    offsets.left -= borderLeftWidth - marginLeft;
	    offsets.right -= borderLeftWidth - marginLeft;
	
	    // Attach marginTop and marginLeft because in some circumstances we may need them
	    offsets.marginTop = marginTop;
	    offsets.marginLeft = marginLeft;
	  }
	
	  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
	    offsets = includeScroll(offsets, parent);
	  }
	
	  return offsets;
	}
	
	function getViewportOffsetRectRelativeToArtbitraryNode(element) {
	  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var html = element.ownerDocument.documentElement;
	  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
	  var width = Math.max(html.clientWidth, window.innerWidth || 0);
	  var height = Math.max(html.clientHeight, window.innerHeight || 0);
	
	  var scrollTop = !excludeScroll ? getScroll(html) : 0;
	  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;
	
	  var offset = {
	    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
	    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
	    width: width,
	    height: height
	  };
	
	  return getClientRect(offset);
	}
	
	/**
	 * Check if the given element is fixed or is inside a fixed parent
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @argument {Element} customContainer
	 * @returns {Boolean} answer to "isFixed?"
	 */
	function isFixed(element) {
	  var nodeName = element.nodeName;
	  if (nodeName === 'BODY' || nodeName === 'HTML') {
	    return false;
	  }
	  if (getStyleComputedProperty(element, 'position') === 'fixed') {
	    return true;
	  }
	  var parentNode = getParentNode(element);
	  if (!parentNode) {
	    return false;
	  }
	  return isFixed(parentNode);
	}
	
	/**
	 * Finds the first parent of an element that has a transformed property defined
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} first transformed parent or documentElement
	 */
	
	function getFixedPositionOffsetParent(element) {
	  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
	  if (!element || !element.parentElement || isIE()) {
	    return document.documentElement;
	  }
	  var el = element.parentElement;
	  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
	    el = el.parentElement;
	  }
	  return el || document.documentElement;
	}
	
	/**
	 * Computed the boundaries limits and return them
	 * @method
	 * @memberof Popper.Utils
	 * @param {HTMLElement} popper
	 * @param {HTMLElement} reference
	 * @param {number} padding
	 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
	 * @param {Boolean} fixedPosition - Is in fixed position mode
	 * @returns {Object} Coordinates of the boundaries
	 */
	function getBoundaries(popper, reference, padding, boundariesElement) {
	  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
	
	  // NOTE: 1 DOM access here
	
	  var boundaries = { top: 0, left: 0 };
	  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
	
	  // Handle viewport case
	  if (boundariesElement === 'viewport') {
	    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
	  } else {
	    // Handle other cases based on DOM element used as boundaries
	    var boundariesNode = void 0;
	    if (boundariesElement === 'scrollParent') {
	      boundariesNode = getScrollParent(getParentNode(reference));
	      if (boundariesNode.nodeName === 'BODY') {
	        boundariesNode = popper.ownerDocument.documentElement;
	      }
	    } else if (boundariesElement === 'window') {
	      boundariesNode = popper.ownerDocument.documentElement;
	    } else {
	      boundariesNode = boundariesElement;
	    }
	
	    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);
	
	    // In case of HTML, we need a different computation
	    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
	      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
	          height = _getWindowSizes.height,
	          width = _getWindowSizes.width;
	
	      boundaries.top += offsets.top - offsets.marginTop;
	      boundaries.bottom = height + offsets.top;
	      boundaries.left += offsets.left - offsets.marginLeft;
	      boundaries.right = width + offsets.left;
	    } else {
	      // for all the other DOM elements, this one is good
	      boundaries = offsets;
	    }
	  }
	
	  // Add paddings
	  padding = padding || 0;
	  var isPaddingNumber = typeof padding === 'number';
	  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
	  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
	  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
	  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;
	
	  return boundaries;
	}
	
	function getArea(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return width * height;
	}
	
	/**
	 * Utility used to transform the `auto` placement to the placement with more
	 * available space.
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
	  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
	
	  if (placement.indexOf('auto') === -1) {
	    return placement;
	  }
	
	  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);
	
	  var rects = {
	    top: {
	      width: boundaries.width,
	      height: refRect.top - boundaries.top
	    },
	    right: {
	      width: boundaries.right - refRect.right,
	      height: boundaries.height
	    },
	    bottom: {
	      width: boundaries.width,
	      height: boundaries.bottom - refRect.bottom
	    },
	    left: {
	      width: refRect.left - boundaries.left,
	      height: boundaries.height
	    }
	  };
	
	  var sortedAreas = Object.keys(rects).map(function (key) {
	    return _extends({
	      key: key
	    }, rects[key], {
	      area: getArea(rects[key])
	    });
	  }).sort(function (a, b) {
	    return b.area - a.area;
	  });
	
	  var filteredAreas = sortedAreas.filter(function (_ref2) {
	    var width = _ref2.width,
	        height = _ref2.height;
	    return width >= popper.clientWidth && height >= popper.clientHeight;
	  });
	
	  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;
	
	  var variation = placement.split('-')[1];
	
	  return computedPlacement + (variation ? '-' + variation : '');
	}
	
	/**
	 * Get offsets to the reference element
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} state
	 * @param {Element} popper - the popper element
	 * @param {Element} reference - the reference element (the popper will be relative to this)
	 * @param {Element} fixedPosition - is in fixed position mode
	 * @returns {Object} An object containing the offsets which will be applied to the popper
	 */
	function getReferenceOffsets(state, popper, reference) {
	  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	
	  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
	  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
	}
	
	/**
	 * Get the outer sizes of the given element (offset size + margins)
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Object} object containing width and height properties
	 */
	function getOuterSizes(element) {
	  var window = element.ownerDocument.defaultView;
	  var styles = window.getComputedStyle(element);
	  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
	  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
	  var result = {
	    width: element.offsetWidth + y,
	    height: element.offsetHeight + x
	  };
	  return result;
	}
	
	/**
	 * Get the opposite placement of the given one
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement
	 * @returns {String} flipped placement
	 */
	function getOppositePlacement(placement) {
	  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
	  return placement.replace(/left|right|bottom|top/g, function (matched) {
	    return hash[matched];
	  });
	}
	
	/**
	 * Get offsets to the popper
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} position - CSS position the Popper will get applied
	 * @param {HTMLElement} popper - the popper element
	 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
	 * @param {String} placement - one of the valid placement options
	 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
	 */
	function getPopperOffsets(popper, referenceOffsets, placement) {
	  placement = placement.split('-')[0];
	
	  // Get popper node sizes
	  var popperRect = getOuterSizes(popper);
	
	  // Add position, width and height to our offsets object
	  var popperOffsets = {
	    width: popperRect.width,
	    height: popperRect.height
	  };
	
	  // depending by the popper placement we have to compute its offsets slightly differently
	  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
	  var mainSide = isHoriz ? 'top' : 'left';
	  var secondarySide = isHoriz ? 'left' : 'top';
	  var measurement = isHoriz ? 'height' : 'width';
	  var secondaryMeasurement = !isHoriz ? 'height' : 'width';
	
	  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
	  if (placement === secondarySide) {
	    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
	  } else {
	    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
	  }
	
	  return popperOffsets;
	}
	
	/**
	 * Mimics the `find` method of Array
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Array} arr
	 * @argument prop
	 * @argument value
	 * @returns index or -1
	 */
	function find(arr, check) {
	  // use native find if supported
	  if (Array.prototype.find) {
	    return arr.find(check);
	  }
	
	  // use `filter` to obtain the same behavior of `find`
	  return arr.filter(check)[0];
	}
	
	/**
	 * Return the index of the matching object
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Array} arr
	 * @argument prop
	 * @argument value
	 * @returns index or -1
	 */
	function findIndex(arr, prop, value) {
	  // use native findIndex if supported
	  if (Array.prototype.findIndex) {
	    return arr.findIndex(function (cur) {
	      return cur[prop] === value;
	    });
	  }
	
	  // use `find` + `indexOf` if `findIndex` isn't supported
	  var match = find(arr, function (obj) {
	    return obj[prop] === value;
	  });
	  return arr.indexOf(match);
	}
	
	/**
	 * Loop trough the list of modifiers and run them in order,
	 * each of them will then edit the data object.
	 * @method
	 * @memberof Popper.Utils
	 * @param {dataObject} data
	 * @param {Array} modifiers
	 * @param {String} ends - Optional modifier name used as stopper
	 * @returns {dataObject}
	 */
	function runModifiers(modifiers, data, ends) {
	  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));
	
	  modifiersToRun.forEach(function (modifier) {
	    if (modifier['function']) {
	      // eslint-disable-line dot-notation
	      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
	    }
	    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
	    if (modifier.enabled && isFunction(fn)) {
	      // Add properties to offsets to make them a complete clientRect object
	      // we do this before each modifier to make sure the previous one doesn't
	      // mess with these values
	      data.offsets.popper = getClientRect(data.offsets.popper);
	      data.offsets.reference = getClientRect(data.offsets.reference);
	
	      data = fn(data, modifier);
	    }
	  });
	
	  return data;
	}
	
	/**
	 * Updates the position of the popper, computing the new offsets and applying
	 * the new style.<br />
	 * Prefer `scheduleUpdate` over `update` because of performance reasons.
	 * @method
	 * @memberof Popper
	 */
	function update() {
	  // if popper is destroyed, don't perform any further update
	  if (this.state.isDestroyed) {
	    return;
	  }
	
	  var data = {
	    instance: this,
	    styles: {},
	    arrowStyles: {},
	    attributes: {},
	    flipped: false,
	    offsets: {}
	  };
	
	  // compute reference element offsets
	  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);
	
	  // compute auto placement, store placement inside the data object,
	  // modifiers will be able to edit `placement` if needed
	  // and refer to originalPlacement to know the original value
	  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);
	
	  // store the computed placement inside `originalPlacement`
	  data.originalPlacement = data.placement;
	
	  data.positionFixed = this.options.positionFixed;
	
	  // compute the popper offsets
	  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);
	
	  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';
	
	  // run the modifiers
	  data = runModifiers(this.modifiers, data);
	
	  // the first `update` will call `onCreate` callback
	  // the other ones will call `onUpdate` callback
	  if (!this.state.isCreated) {
	    this.state.isCreated = true;
	    this.options.onCreate(data);
	  } else {
	    this.options.onUpdate(data);
	  }
	}
	
	/**
	 * Helper used to know if the given modifier is enabled.
	 * @method
	 * @memberof Popper.Utils
	 * @returns {Boolean}
	 */
	function isModifierEnabled(modifiers, modifierName) {
	  return modifiers.some(function (_ref) {
	    var name = _ref.name,
	        enabled = _ref.enabled;
	    return enabled && name === modifierName;
	  });
	}
	
	/**
	 * Get the prefixed supported property name
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} property (camelCase)
	 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
	 */
	function getSupportedPropertyName(property) {
	  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
	  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);
	
	  for (var i = 0; i < prefixes.length; i++) {
	    var prefix = prefixes[i];
	    var toCheck = prefix ? '' + prefix + upperProp : property;
	    if (typeof document.body.style[toCheck] !== 'undefined') {
	      return toCheck;
	    }
	  }
	  return null;
	}
	
	/**
	 * Destroys the popper.
	 * @method
	 * @memberof Popper
	 */
	function destroy() {
	  this.state.isDestroyed = true;
	
	  // touch DOM only if `applyStyle` modifier is enabled
	  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
	    this.popper.removeAttribute('x-placement');
	    this.popper.style.position = '';
	    this.popper.style.top = '';
	    this.popper.style.left = '';
	    this.popper.style.right = '';
	    this.popper.style.bottom = '';
	    this.popper.style.willChange = '';
	    this.popper.style[getSupportedPropertyName('transform')] = '';
	  }
	
	  this.disableEventListeners();
	
	  // remove the popper if user explicitly asked for the deletion on destroy
	  // do not use `remove` because IE11 doesn't support it
	  if (this.options.removeOnDestroy) {
	    this.popper.parentNode.removeChild(this.popper);
	  }
	  return this;
	}
	
	/**
	 * Get the window associated with the element
	 * @argument {Element} element
	 * @returns {Window}
	 */
	function getWindow(element) {
	  var ownerDocument = element.ownerDocument;
	  return ownerDocument ? ownerDocument.defaultView : window;
	}
	
	function attachToScrollParents(scrollParent, event, callback, scrollParents) {
	  var isBody = scrollParent.nodeName === 'BODY';
	  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
	  target.addEventListener(event, callback, { passive: true });
	
	  if (!isBody) {
	    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
	  }
	  scrollParents.push(target);
	}
	
	/**
	 * Setup needed event listeners used to update the popper position
	 * @method
	 * @memberof Popper.Utils
	 * @private
	 */
	function setupEventListeners(reference, options, state, updateBound) {
	  // Resize event listener on window
	  state.updateBound = updateBound;
	  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });
	
	  // Scroll event listener on scroll parents
	  var scrollElement = getScrollParent(reference);
	  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
	  state.scrollElement = scrollElement;
	  state.eventsEnabled = true;
	
	  return state;
	}
	
	/**
	 * It will add resize/scroll events and start recalculating
	 * position of the popper element when they are triggered.
	 * @method
	 * @memberof Popper
	 */
	function enableEventListeners() {
	  if (!this.state.eventsEnabled) {
	    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
	  }
	}
	
	/**
	 * Remove event listeners used to update the popper position
	 * @method
	 * @memberof Popper.Utils
	 * @private
	 */
	function removeEventListeners(reference, state) {
	  // Remove resize event listener on window
	  getWindow(reference).removeEventListener('resize', state.updateBound);
	
	  // Remove scroll event listener on scroll parents
	  state.scrollParents.forEach(function (target) {
	    target.removeEventListener('scroll', state.updateBound);
	  });
	
	  // Reset state
	  state.updateBound = null;
	  state.scrollParents = [];
	  state.scrollElement = null;
	  state.eventsEnabled = false;
	  return state;
	}
	
	/**
	 * It will remove resize/scroll events and won't recalculate popper position
	 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
	 * unless you call `update` method manually.
	 * @method
	 * @memberof Popper
	 */
	function disableEventListeners() {
	  if (this.state.eventsEnabled) {
	    cancelAnimationFrame(this.scheduleUpdate);
	    this.state = removeEventListeners(this.reference, this.state);
	  }
	}
	
	/**
	 * Tells if a given input is a number
	 * @method
	 * @memberof Popper.Utils
	 * @param {*} input to check
	 * @return {Boolean}
	 */
	function isNumeric(n) {
	  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
	}
	
	/**
	 * Set the style to the given popper
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element - Element to apply the style to
	 * @argument {Object} styles
	 * Object with a list of properties and values which will be applied to the element
	 */
	function setStyles(element, styles) {
	  Object.keys(styles).forEach(function (prop) {
	    var unit = '';
	    // add unit if the value is numeric and is one of the following
	    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
	      unit = 'px';
	    }
	    element.style[prop] = styles[prop] + unit;
	  });
	}
	
	/**
	 * Set the attributes to the given popper
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element - Element to apply the attributes to
	 * @argument {Object} styles
	 * Object with a list of properties and values which will be applied to the element
	 */
	function setAttributes(element, attributes) {
	  Object.keys(attributes).forEach(function (prop) {
	    var value = attributes[prop];
	    if (value !== false) {
	      element.setAttribute(prop, attributes[prop]);
	    } else {
	      element.removeAttribute(prop);
	    }
	  });
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} data.styles - List of style properties - values to apply to popper element
	 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The same data object
	 */
	function applyStyle(data) {
	  // any property present in `data.styles` will be applied to the popper,
	  // in this way we can make the 3rd party modifiers add custom styles to it
	  // Be aware, modifiers could override the properties defined in the previous
	  // lines of this modifier!
	  setStyles(data.instance.popper, data.styles);
	
	  // any property present in `data.attributes` will be applied to the popper,
	  // they will be set as HTML attributes of the element
	  setAttributes(data.instance.popper, data.attributes);
	
	  // if arrowElement is defined and arrowStyles has some properties
	  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
	    setStyles(data.arrowElement, data.arrowStyles);
	  }
	
	  return data;
	}
	
	/**
	 * Set the x-placement attribute before everything else because it could be used
	 * to add margins to the popper margins needs to be calculated to get the
	 * correct popper offsets.
	 * @method
	 * @memberof Popper.modifiers
	 * @param {HTMLElement} reference - The reference element used to position the popper
	 * @param {HTMLElement} popper - The HTML element used as popper
	 * @param {Object} options - Popper.js options
	 */
	function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
	  // compute reference element offsets
	  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);
	
	  // compute auto placement, store placement inside the data object,
	  // modifiers will be able to edit `placement` if needed
	  // and refer to originalPlacement to know the original value
	  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);
	
	  popper.setAttribute('x-placement', placement);
	
	  // Apply `position` to popper before anything else because
	  // without the position applied we can't guarantee correct computations
	  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });
	
	  return options;
	}
	
	/**
	 * @function
	 * @memberof Popper.Utils
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
	 * @returns {Object} The popper's position offsets rounded
	 *
	 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
	 * good as it can be within reason.
	 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
	 *
	 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
	 * as well on High DPI screens).
	 *
	 * Firefox prefers no rounding for positioning and does not have blurriness on
	 * high DPI screens.
	 *
	 * Only horizontal placement and left/right values need to be considered.
	 */
	function getRoundedOffsets(data, shouldRound) {
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	  var round = Math.round,
	      floor = Math.floor;
	
	  var noRound = function noRound(v) {
	    return v;
	  };
	
	  var referenceWidth = round(reference.width);
	  var popperWidth = round(popper.width);
	
	  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
	  var isVariation = data.placement.indexOf('-') !== -1;
	  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
	  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;
	
	  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
	  var verticalToInteger = !shouldRound ? noRound : round;
	
	  return {
	    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
	    top: verticalToInteger(popper.top),
	    bottom: verticalToInteger(popper.bottom),
	    right: horizontalToInteger(popper.right)
	  };
	}
	
	var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function computeStyle(data, options) {
	  var x = options.x,
	      y = options.y;
	  var popper = data.offsets.popper;
	
	  // Remove this legacy support in Popper.js v2
	
	  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
	    return modifier.name === 'applyStyle';
	  }).gpuAcceleration;
	  if (legacyGpuAccelerationOption !== undefined) {
	    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
	  }
	  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;
	
	  var offsetParent = getOffsetParent(data.instance.popper);
	  var offsetParentRect = getBoundingClientRect(offsetParent);
	
	  // Styles
	  var styles = {
	    position: popper.position
	  };
	
	  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);
	
	  var sideA = x === 'bottom' ? 'top' : 'bottom';
	  var sideB = y === 'right' ? 'left' : 'right';
	
	  // if gpuAcceleration is set to `true` and transform is supported,
	  //  we use `translate3d` to apply the position to the popper we
	  // automatically use the supported prefixed version if needed
	  var prefixedProperty = getSupportedPropertyName('transform');
	
	  // now, let's make a step back and look at this code closely (wtf?)
	  // If the content of the popper grows once it's been positioned, it
	  // may happen that the popper gets misplaced because of the new content
	  // overflowing its reference element
	  // To avoid this problem, we provide two options (x and y), which allow
	  // the consumer to define the offset origin.
	  // If we position a popper on top of a reference element, we can set
	  // `x` to `top` to make the popper grow towards its top instead of
	  // its bottom.
	  var left = void 0,
	      top = void 0;
	  if (sideA === 'bottom') {
	    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
	    // and not the bottom of the html element
	    if (offsetParent.nodeName === 'HTML') {
	      top = -offsetParent.clientHeight + offsets.bottom;
	    } else {
	      top = -offsetParentRect.height + offsets.bottom;
	    }
	  } else {
	    top = offsets.top;
	  }
	  if (sideB === 'right') {
	    if (offsetParent.nodeName === 'HTML') {
	      left = -offsetParent.clientWidth + offsets.right;
	    } else {
	      left = -offsetParentRect.width + offsets.right;
	    }
	  } else {
	    left = offsets.left;
	  }
	  if (gpuAcceleration && prefixedProperty) {
	    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
	    styles[sideA] = 0;
	    styles[sideB] = 0;
	    styles.willChange = 'transform';
	  } else {
	    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
	    var invertTop = sideA === 'bottom' ? -1 : 1;
	    var invertLeft = sideB === 'right' ? -1 : 1;
	    styles[sideA] = top * invertTop;
	    styles[sideB] = left * invertLeft;
	    styles.willChange = sideA + ', ' + sideB;
	  }
	
	  // Attributes
	  var attributes = {
	    'x-placement': data.placement
	  };
	
	  // Update `data` attributes, styles and arrowStyles
	  data.attributes = _extends({}, attributes, data.attributes);
	  data.styles = _extends({}, styles, data.styles);
	  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);
	
	  return data;
	}
	
	/**
	 * Helper used to know if the given modifier depends from another one.<br />
	 * It checks if the needed modifier is listed and enabled.
	 * @method
	 * @memberof Popper.Utils
	 * @param {Array} modifiers - list of modifiers
	 * @param {String} requestingName - name of requesting modifier
	 * @param {String} requestedName - name of requested modifier
	 * @returns {Boolean}
	 */
	function isModifierRequired(modifiers, requestingName, requestedName) {
	  var requesting = find(modifiers, function (_ref) {
	    var name = _ref.name;
	    return name === requestingName;
	  });
	
	  var isRequired = !!requesting && modifiers.some(function (modifier) {
	    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
	  });
	
	  if (!isRequired) {
	    var _requesting = '`' + requestingName + '`';
	    var requested = '`' + requestedName + '`';
	    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
	  }
	  return isRequired;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function arrow(data, options) {
	  var _data$offsets$arrow;
	
	  // arrow depends on keepTogether in order to work
	  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
	    return data;
	  }
	
	  var arrowElement = options.element;
	
	  // if arrowElement is a string, suppose it's a CSS selector
	  if (typeof arrowElement === 'string') {
	    arrowElement = data.instance.popper.querySelector(arrowElement);
	
	    // if arrowElement is not found, don't run the modifier
	    if (!arrowElement) {
	      return data;
	    }
	  } else {
	    // if the arrowElement isn't a query selector we must check that the
	    // provided DOM node is child of its popper node
	    if (!data.instance.popper.contains(arrowElement)) {
	      console.warn('WARNING: `arrow.element` must be child of its popper element!');
	      return data;
	    }
	  }
	
	  var placement = data.placement.split('-')[0];
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var isVertical = ['left', 'right'].indexOf(placement) !== -1;
	
	  var len = isVertical ? 'height' : 'width';
	  var sideCapitalized = isVertical ? 'Top' : 'Left';
	  var side = sideCapitalized.toLowerCase();
	  var altSide = isVertical ? 'left' : 'top';
	  var opSide = isVertical ? 'bottom' : 'right';
	  var arrowElementSize = getOuterSizes(arrowElement)[len];
	
	  //
	  // extends keepTogether behavior making sure the popper and its
	  // reference have enough pixels in conjunction
	  //
	
	  // top/left side
	  if (reference[opSide] - arrowElementSize < popper[side]) {
	    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
	  }
	  // bottom/right side
	  if (reference[side] + arrowElementSize > popper[opSide]) {
	    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
	  }
	  data.offsets.popper = getClientRect(data.offsets.popper);
	
	  // compute center of the popper
	  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;
	
	  // Compute the sideValue using the updated popper offsets
	  // take popper margin in account because we don't have this info available
	  var css = getStyleComputedProperty(data.instance.popper);
	  var popperMarginSide = parseFloat(css['margin' + sideCapitalized]);
	  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width']);
	  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;
	
	  // prevent arrowElement from being placed not contiguously to its popper
	  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);
	
	  data.arrowElement = arrowElement;
	  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);
	
	  return data;
	}
	
	/**
	 * Get the opposite placement variation of the given one
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement variation
	 * @returns {String} flipped placement variation
	 */
	function getOppositeVariation(variation) {
	  if (variation === 'end') {
	    return 'start';
	  } else if (variation === 'start') {
	    return 'end';
	  }
	  return variation;
	}
	
	/**
	 * List of accepted placements to use as values of the `placement` option.<br />
	 * Valid placements are:
	 * - `auto`
	 * - `top`
	 * - `right`
	 * - `bottom`
	 * - `left`
	 *
	 * Each placement can have a variation from this list:
	 * - `-start`
	 * - `-end`
	 *
	 * Variations are interpreted easily if you think of them as the left to right
	 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
	 * is right.<br />
	 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
	 *
	 * Some valid examples are:
	 * - `top-end` (on top of reference, right aligned)
	 * - `right-start` (on right of reference, top aligned)
	 * - `bottom` (on bottom, centered)
	 * - `auto-end` (on the side with more space available, alignment depends by placement)
	 *
	 * @static
	 * @type {Array}
	 * @enum {String}
	 * @readonly
	 * @method placements
	 * @memberof Popper
	 */
	var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];
	
	// Get rid of `auto` `auto-start` and `auto-end`
	var validPlacements = placements.slice(3);
	
	/**
	 * Given an initial placement, returns all the subsequent placements
	 * clockwise (or counter-clockwise).
	 *
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement - A valid placement (it accepts variations)
	 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
	 * @returns {Array} placements including their variations
	 */
	function clockwise(placement) {
	  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var index = validPlacements.indexOf(placement);
	  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
	  return counter ? arr.reverse() : arr;
	}
	
	var BEHAVIORS = {
	  FLIP: 'flip',
	  CLOCKWISE: 'clockwise',
	  COUNTERCLOCKWISE: 'counterclockwise'
	};
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function flip(data, options) {
	  // if `inner` modifier is enabled, we can't use the `flip` modifier
	  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
	    return data;
	  }
	
	  if (data.flipped && data.placement === data.originalPlacement) {
	    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
	    return data;
	  }
	
	  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);
	
	  var placement = data.placement.split('-')[0];
	  var placementOpposite = getOppositePlacement(placement);
	  var variation = data.placement.split('-')[1] || '';
	
	  var flipOrder = [];
	
	  switch (options.behavior) {
	    case BEHAVIORS.FLIP:
	      flipOrder = [placement, placementOpposite];
	      break;
	    case BEHAVIORS.CLOCKWISE:
	      flipOrder = clockwise(placement);
	      break;
	    case BEHAVIORS.COUNTERCLOCKWISE:
	      flipOrder = clockwise(placement, true);
	      break;
	    default:
	      flipOrder = options.behavior;
	  }
	
	  flipOrder.forEach(function (step, index) {
	    if (placement !== step || flipOrder.length === index + 1) {
	      return data;
	    }
	
	    placement = data.placement.split('-')[0];
	    placementOpposite = getOppositePlacement(placement);
	
	    var popperOffsets = data.offsets.popper;
	    var refOffsets = data.offsets.reference;
	
	    // using floor because the reference offsets may contain decimals we are not going to consider here
	    var floor = Math.floor;
	    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);
	
	    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
	    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
	    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
	    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);
	
	    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;
	
	    // flip the variation if required
	    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
	
	    // flips variation if reference element overflows boundaries
	    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);
	
	    // flips variation if popper content overflows boundaries
	    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);
	
	    var flippedVariation = flippedVariationByRef || flippedVariationByContent;
	
	    if (overlapsRef || overflowsBoundaries || flippedVariation) {
	      // this boolean to detect any flip loop
	      data.flipped = true;
	
	      if (overlapsRef || overflowsBoundaries) {
	        placement = flipOrder[index + 1];
	      }
	
	      if (flippedVariation) {
	        variation = getOppositeVariation(variation);
	      }
	
	      data.placement = placement + (variation ? '-' + variation : '');
	
	      // this object contains `position`, we want to preserve it along with
	      // any additional property we may add in the future
	      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));
	
	      data = runModifiers(data.instance.modifiers, data, 'flip');
	    }
	  });
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function keepTogether(data) {
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var placement = data.placement.split('-')[0];
	  var floor = Math.floor;
	  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
	  var side = isVertical ? 'right' : 'bottom';
	  var opSide = isVertical ? 'left' : 'top';
	  var measurement = isVertical ? 'width' : 'height';
	
	  if (popper[side] < floor(reference[opSide])) {
	    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
	  }
	  if (popper[opSide] > floor(reference[side])) {
	    data.offsets.popper[opSide] = floor(reference[side]);
	  }
	
	  return data;
	}
	
	/**
	 * Converts a string containing value + unit into a px value number
	 * @function
	 * @memberof {modifiers~offset}
	 * @private
	 * @argument {String} str - Value + unit string
	 * @argument {String} measurement - `height` or `width`
	 * @argument {Object} popperOffsets
	 * @argument {Object} referenceOffsets
	 * @returns {Number|String}
	 * Value in pixels, or original string if no values were extracted
	 */
	function toValue(str, measurement, popperOffsets, referenceOffsets) {
	  // separate value from unit
	  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
	  var value = +split[1];
	  var unit = split[2];
	
	  // If it's not a number it's an operator, I guess
	  if (!value) {
	    return str;
	  }
	
	  if (unit.indexOf('%') === 0) {
	    var element = void 0;
	    switch (unit) {
	      case '%p':
	        element = popperOffsets;
	        break;
	      case '%':
	      case '%r':
	      default:
	        element = referenceOffsets;
	    }
	
	    var rect = getClientRect(element);
	    return rect[measurement] / 100 * value;
	  } else if (unit === 'vh' || unit === 'vw') {
	    // if is a vh or vw, we calculate the size based on the viewport
	    var size = void 0;
	    if (unit === 'vh') {
	      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
	    } else {
	      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
	    }
	    return size / 100 * value;
	  } else {
	    // if is an explicit pixel unit, we get rid of the unit and keep the value
	    // if is an implicit unit, it's px, and we return just the value
	    return value;
	  }
	}
	
	/**
	 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
	 * @function
	 * @memberof {modifiers~offset}
	 * @private
	 * @argument {String} offset
	 * @argument {Object} popperOffsets
	 * @argument {Object} referenceOffsets
	 * @argument {String} basePlacement
	 * @returns {Array} a two cells array with x and y offsets in numbers
	 */
	function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
	  var offsets = [0, 0];
	
	  // Use height if placement is left or right and index is 0 otherwise use width
	  // in this way the first offset will use an axis and the second one
	  // will use the other one
	  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;
	
	  // Split the offset string to obtain a list of values and operands
	  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
	  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
	    return frag.trim();
	  });
	
	  // Detect if the offset string contains a pair of values or a single one
	  // they could be separated by comma or space
	  var divider = fragments.indexOf(find(fragments, function (frag) {
	    return frag.search(/,|\s/) !== -1;
	  }));
	
	  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
	    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
	  }
	
	  // If divider is found, we divide the list of values and operands to divide
	  // them by ofset X and Y.
	  var splitRegex = /\s*,\s*|\s+/;
	  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];
	
	  // Convert the values with units to absolute pixels to allow our computations
	  ops = ops.map(function (op, index) {
	    // Most of the units rely on the orientation of the popper
	    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
	    var mergeWithPrevious = false;
	    return op
	    // This aggregates any `+` or `-` sign that aren't considered operators
	    // e.g.: 10 + +5 => [10, +, +5]
	    .reduce(function (a, b) {
	      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
	        a[a.length - 1] = b;
	        mergeWithPrevious = true;
	        return a;
	      } else if (mergeWithPrevious) {
	        a[a.length - 1] += b;
	        mergeWithPrevious = false;
	        return a;
	      } else {
	        return a.concat(b);
	      }
	    }, [])
	    // Here we convert the string values into number values (in px)
	    .map(function (str) {
	      return toValue(str, measurement, popperOffsets, referenceOffsets);
	    });
	  });
	
	  // Loop trough the offsets arrays and execute the operations
	  ops.forEach(function (op, index) {
	    op.forEach(function (frag, index2) {
	      if (isNumeric(frag)) {
	        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
	      }
	    });
	  });
	  return offsets;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @argument {Number|String} options.offset=0
	 * The offset value as described in the modifier description
	 * @returns {Object} The data object, properly modified
	 */
	function offset(data, _ref) {
	  var offset = _ref.offset;
	  var placement = data.placement,
	      _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var basePlacement = placement.split('-')[0];
	
	  var offsets = void 0;
	  if (isNumeric(+offset)) {
	    offsets = [+offset, 0];
	  } else {
	    offsets = parseOffset(offset, popper, reference, basePlacement);
	  }
	
	  if (basePlacement === 'left') {
	    popper.top += offsets[0];
	    popper.left -= offsets[1];
	  } else if (basePlacement === 'right') {
	    popper.top += offsets[0];
	    popper.left += offsets[1];
	  } else if (basePlacement === 'top') {
	    popper.left += offsets[0];
	    popper.top -= offsets[1];
	  } else if (basePlacement === 'bottom') {
	    popper.left += offsets[0];
	    popper.top += offsets[1];
	  }
	
	  data.popper = popper;
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function preventOverflow(data, options) {
	  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);
	
	  // If offsetParent is the reference element, we really want to
	  // go one step up and use the next offsetParent as reference to
	  // avoid to make this modifier completely useless and look like broken
	  if (data.instance.reference === boundariesElement) {
	    boundariesElement = getOffsetParent(boundariesElement);
	  }
	
	  // NOTE: DOM access here
	  // resets the popper's position so that the document size can be calculated excluding
	  // the size of the popper element itself
	  var transformProp = getSupportedPropertyName('transform');
	  var popperStyles = data.instance.popper.style; // assignment to help minification
	  var top = popperStyles.top,
	      left = popperStyles.left,
	      transform = popperStyles[transformProp];
	
	  popperStyles.top = '';
	  popperStyles.left = '';
	  popperStyles[transformProp] = '';
	
	  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);
	
	  // NOTE: DOM access here
	  // restores the original style properties after the offsets have been computed
	  popperStyles.top = top;
	  popperStyles.left = left;
	  popperStyles[transformProp] = transform;
	
	  options.boundaries = boundaries;
	
	  var order = options.priority;
	  var popper = data.offsets.popper;
	
	  var check = {
	    primary: function primary(placement) {
	      var value = popper[placement];
	      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
	        value = Math.max(popper[placement], boundaries[placement]);
	      }
	      return defineProperty({}, placement, value);
	    },
	    secondary: function secondary(placement) {
	      var mainSide = placement === 'right' ? 'left' : 'top';
	      var value = popper[mainSide];
	      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
	        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
	      }
	      return defineProperty({}, mainSide, value);
	    }
	  };
	
	  order.forEach(function (placement) {
	    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
	    popper = _extends({}, popper, check[side](placement));
	  });
	
	  data.offsets.popper = popper;
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function shift(data) {
	  var placement = data.placement;
	  var basePlacement = placement.split('-')[0];
	  var shiftvariation = placement.split('-')[1];
	
	  // if shift shiftvariation is specified, run the modifier
	  if (shiftvariation) {
	    var _data$offsets = data.offsets,
	        reference = _data$offsets.reference,
	        popper = _data$offsets.popper;
	
	    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
	    var side = isVertical ? 'left' : 'top';
	    var measurement = isVertical ? 'width' : 'height';
	
	    var shiftOffsets = {
	      start: defineProperty({}, side, reference[side]),
	      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
	    };
	
	    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
	  }
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function hide(data) {
	  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
	    return data;
	  }
	
	  var refRect = data.offsets.reference;
	  var bound = find(data.instance.modifiers, function (modifier) {
	    return modifier.name === 'preventOverflow';
	  }).boundaries;
	
	  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
	    // Avoid unnecessary DOM access if visibility hasn't changed
	    if (data.hide === true) {
	      return data;
	    }
	
	    data.hide = true;
	    data.attributes['x-out-of-boundaries'] = '';
	  } else {
	    // Avoid unnecessary DOM access if visibility hasn't changed
	    if (data.hide === false) {
	      return data;
	    }
	
	    data.hide = false;
	    data.attributes['x-out-of-boundaries'] = false;
	  }
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function inner(data) {
	  var placement = data.placement;
	  var basePlacement = placement.split('-')[0];
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;
	
	  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;
	
	  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);
	
	  data.placement = getOppositePlacement(placement);
	  data.offsets.popper = getClientRect(popper);
	
	  return data;
	}
	
	/**
	 * Modifier function, each modifier can have a function of this type assigned
	 * to its `fn` property.<br />
	 * These functions will be called on each update, this means that you must
	 * make sure they are performant enough to avoid performance bottlenecks.
	 *
	 * @function ModifierFn
	 * @argument {dataObject} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {dataObject} The data object, properly modified
	 */
	
	/**
	 * Modifiers are plugins used to alter the behavior of your poppers.<br />
	 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
	 * needed by the library.
	 *
	 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
	 * All the other properties are configurations that could be tweaked.
	 * @namespace modifiers
	 */
	var modifiers = {
	  /**
	   * Modifier used to shift the popper on the start or end of its reference
	   * element.<br />
	   * It will read the variation of the `placement` property.<br />
	   * It can be one either `-end` or `-start`.
	   * @memberof modifiers
	   * @inner
	   */
	  shift: {
	    /** @prop {number} order=100 - Index used to define the order of execution */
	    order: 100,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: shift
	  },
	
	  /**
	   * The `offset` modifier can shift your popper on both its axis.
	   *
	   * It accepts the following units:
	   * - `px` or unit-less, interpreted as pixels
	   * - `%` or `%r`, percentage relative to the length of the reference element
	   * - `%p`, percentage relative to the length of the popper element
	   * - `vw`, CSS viewport width unit
	   * - `vh`, CSS viewport height unit
	   *
	   * For length is intended the main axis relative to the placement of the popper.<br />
	   * This means that if the placement is `top` or `bottom`, the length will be the
	   * `width`. In case of `left` or `right`, it will be the `height`.
	   *
	   * You can provide a single value (as `Number` or `String`), or a pair of values
	   * as `String` divided by a comma or one (or more) white spaces.<br />
	   * The latter is a deprecated method because it leads to confusion and will be
	   * removed in v2.<br />
	   * Additionally, it accepts additions and subtractions between different units.
	   * Note that multiplications and divisions aren't supported.
	   *
	   * Valid examples are:
	   * ```
	   * 10
	   * '10%'
	   * '10, 10'
	   * '10%, 10'
	   * '10 + 10%'
	   * '10 - 5vh + 3%'
	   * '-10px + 5vh, 5px - 6%'
	   * ```
	   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
	   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
	   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  offset: {
	    /** @prop {number} order=200 - Index used to define the order of execution */
	    order: 200,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: offset,
	    /** @prop {Number|String} offset=0
	     * The offset value as described in the modifier description
	     */
	    offset: 0
	  },
	
	  /**
	   * Modifier used to prevent the popper from being positioned outside the boundary.
	   *
	   * A scenario exists where the reference itself is not within the boundaries.<br />
	   * We can say it has "escaped the boundaries" — or just "escaped".<br />
	   * In this case we need to decide whether the popper should either:
	   *
	   * - detach from the reference and remain "trapped" in the boundaries, or
	   * - if it should ignore the boundary and "escape with its reference"
	   *
	   * When `escapeWithReference` is set to`true` and reference is completely
	   * outside its boundaries, the popper will overflow (or completely leave)
	   * the boundaries in order to remain attached to the edge of the reference.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  preventOverflow: {
	    /** @prop {number} order=300 - Index used to define the order of execution */
	    order: 300,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: preventOverflow,
	    /**
	     * @prop {Array} [priority=['left','right','top','bottom']]
	     * Popper will try to prevent overflow following these priorities by default,
	     * then, it could overflow on the left and on top of the `boundariesElement`
	     */
	    priority: ['left', 'right', 'top', 'bottom'],
	    /**
	     * @prop {number} padding=5
	     * Amount of pixel used to define a minimum distance between the boundaries
	     * and the popper. This makes sure the popper always has a little padding
	     * between the edges of its container
	     */
	    padding: 5,
	    /**
	     * @prop {String|HTMLElement} boundariesElement='scrollParent'
	     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
	     * `viewport` or any DOM element.
	     */
	    boundariesElement: 'scrollParent'
	  },
	
	  /**
	   * Modifier used to make sure the reference and its popper stay near each other
	   * without leaving any gap between the two. Especially useful when the arrow is
	   * enabled and you want to ensure that it points to its reference element.
	   * It cares only about the first axis. You can still have poppers with margin
	   * between the popper and its reference element.
	   * @memberof modifiers
	   * @inner
	   */
	  keepTogether: {
	    /** @prop {number} order=400 - Index used to define the order of execution */
	    order: 400,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: keepTogether
	  },
	
	  /**
	   * This modifier is used to move the `arrowElement` of the popper to make
	   * sure it is positioned between the reference element and its popper element.
	   * It will read the outer size of the `arrowElement` node to detect how many
	   * pixels of conjunction are needed.
	   *
	   * It has no effect if no `arrowElement` is provided.
	   * @memberof modifiers
	   * @inner
	   */
	  arrow: {
	    /** @prop {number} order=500 - Index used to define the order of execution */
	    order: 500,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: arrow,
	    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
	    element: '[x-arrow]'
	  },
	
	  /**
	   * Modifier used to flip the popper's placement when it starts to overlap its
	   * reference element.
	   *
	   * Requires the `preventOverflow` modifier before it in order to work.
	   *
	   * **NOTE:** this modifier will interrupt the current update cycle and will
	   * restart it if it detects the need to flip the placement.
	   * @memberof modifiers
	   * @inner
	   */
	  flip: {
	    /** @prop {number} order=600 - Index used to define the order of execution */
	    order: 600,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: flip,
	    /**
	     * @prop {String|Array} behavior='flip'
	     * The behavior used to change the popper's placement. It can be one of
	     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
	     * placements (with optional variations)
	     */
	    behavior: 'flip',
	    /**
	     * @prop {number} padding=5
	     * The popper will flip if it hits the edges of the `boundariesElement`
	     */
	    padding: 5,
	    /**
	     * @prop {String|HTMLElement} boundariesElement='viewport'
	     * The element which will define the boundaries of the popper position.
	     * The popper will never be placed outside of the defined boundaries
	     * (except if `keepTogether` is enabled)
	     */
	    boundariesElement: 'viewport',
	    /**
	     * @prop {Boolean} flipVariations=false
	     * The popper will switch placement variation between `-start` and `-end` when
	     * the reference element overlaps its boundaries.
	     *
	     * The original placement should have a set variation.
	     */
	    flipVariations: false,
	    /**
	     * @prop {Boolean} flipVariationsByContent=false
	     * The popper will switch placement variation between `-start` and `-end` when
	     * the popper element overlaps its reference boundaries.
	     *
	     * The original placement should have a set variation.
	     */
	    flipVariationsByContent: false
	  },
	
	  /**
	   * Modifier used to make the popper flow toward the inner of the reference element.
	   * By default, when this modifier is disabled, the popper will be placed outside
	   * the reference element.
	   * @memberof modifiers
	   * @inner
	   */
	  inner: {
	    /** @prop {number} order=700 - Index used to define the order of execution */
	    order: 700,
	    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
	    enabled: false,
	    /** @prop {ModifierFn} */
	    fn: inner
	  },
	
	  /**
	   * Modifier used to hide the popper when its reference element is outside of the
	   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
	   * be used to hide with a CSS selector the popper when its reference is
	   * out of boundaries.
	   *
	   * Requires the `preventOverflow` modifier before it in order to work.
	   * @memberof modifiers
	   * @inner
	   */
	  hide: {
	    /** @prop {number} order=800 - Index used to define the order of execution */
	    order: 800,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: hide
	  },
	
	  /**
	   * Computes the style that will be applied to the popper element to gets
	   * properly positioned.
	   *
	   * Note that this modifier will not touch the DOM, it just prepares the styles
	   * so that `applyStyle` modifier can apply it. This separation is useful
	   * in case you need to replace `applyStyle` with a custom implementation.
	   *
	   * This modifier has `850` as `order` value to maintain backward compatibility
	   * with previous versions of Popper.js. Expect the modifiers ordering method
	   * to change in future major versions of the library.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  computeStyle: {
	    /** @prop {number} order=850 - Index used to define the order of execution */
	    order: 850,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: computeStyle,
	    /**
	     * @prop {Boolean} gpuAcceleration=true
	     * If true, it uses the CSS 3D transformation to position the popper.
	     * Otherwise, it will use the `top` and `left` properties
	     */
	    gpuAcceleration: true,
	    /**
	     * @prop {string} [x='bottom']
	     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
	     * Change this if your popper should grow in a direction different from `bottom`
	     */
	    x: 'bottom',
	    /**
	     * @prop {string} [x='left']
	     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
	     * Change this if your popper should grow in a direction different from `right`
	     */
	    y: 'right'
	  },
	
	  /**
	   * Applies the computed styles to the popper element.
	   *
	   * All the DOM manipulations are limited to this modifier. This is useful in case
	   * you want to integrate Popper.js inside a framework or view library and you
	   * want to delegate all the DOM manipulations to it.
	   *
	   * Note that if you disable this modifier, you must make sure the popper element
	   * has its position set to `absolute` before Popper.js can do its work!
	   *
	   * Just disable this modifier and define your own to achieve the desired effect.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  applyStyle: {
	    /** @prop {number} order=900 - Index used to define the order of execution */
	    order: 900,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: applyStyle,
	    /** @prop {Function} */
	    onLoad: applyStyleOnLoad,
	    /**
	     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
	     * @prop {Boolean} gpuAcceleration=true
	     * If true, it uses the CSS 3D transformation to position the popper.
	     * Otherwise, it will use the `top` and `left` properties
	     */
	    gpuAcceleration: undefined
	  }
	};
	
	/**
	 * The `dataObject` is an object containing all the information used by Popper.js.
	 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
	 * @name dataObject
	 * @property {Object} data.instance The Popper.js instance
	 * @property {String} data.placement Placement applied to popper
	 * @property {String} data.originalPlacement Placement originally defined on init
	 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
	 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
	 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
	 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
	 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
	 * @property {Object} data.boundaries Offsets of the popper boundaries
	 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
	 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
	 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
	 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
	 */
	
	/**
	 * Default options provided to Popper.js constructor.<br />
	 * These can be overridden using the `options` argument of Popper.js.<br />
	 * To override an option, simply pass an object with the same
	 * structure of the `options` object, as the 3rd argument. For example:
	 * ```
	 * new Popper(ref, pop, {
	 *   modifiers: {
	 *     preventOverflow: { enabled: false }
	 *   }
	 * })
	 * ```
	 * @type {Object}
	 * @static
	 * @memberof Popper
	 */
	var Defaults = {
	  /**
	   * Popper's placement.
	   * @prop {Popper.placements} placement='bottom'
	   */
	  placement: 'bottom',
	
	  /**
	   * Set this to true if you want popper to position it self in 'fixed' mode
	   * @prop {Boolean} positionFixed=false
	   */
	  positionFixed: false,
	
	  /**
	   * Whether events (resize, scroll) are initially enabled.
	   * @prop {Boolean} eventsEnabled=true
	   */
	  eventsEnabled: true,
	
	  /**
	   * Set to true if you want to automatically remove the popper when
	   * you call the `destroy` method.
	   * @prop {Boolean} removeOnDestroy=false
	   */
	  removeOnDestroy: false,
	
	  /**
	   * Callback called when the popper is created.<br />
	   * By default, it is set to no-op.<br />
	   * Access Popper.js instance with `data.instance`.
	   * @prop {onCreate}
	   */
	  onCreate: function onCreate() {},
	
	  /**
	   * Callback called when the popper is updated. This callback is not called
	   * on the initialization/creation of the popper, but only on subsequent
	   * updates.<br />
	   * By default, it is set to no-op.<br />
	   * Access Popper.js instance with `data.instance`.
	   * @prop {onUpdate}
	   */
	  onUpdate: function onUpdate() {},
	
	  /**
	   * List of modifiers used to modify the offsets before they are applied to the popper.
	   * They provide most of the functionalities of Popper.js.
	   * @prop {modifiers}
	   */
	  modifiers: modifiers
	};
	
	/**
	 * @callback onCreate
	 * @param {dataObject} data
	 */
	
	/**
	 * @callback onUpdate
	 * @param {dataObject} data
	 */
	
	// Utils
	// Methods
	var Popper = function () {
	  /**
	   * Creates a new Popper.js instance.
	   * @class Popper
	   * @param {Element|referenceObject} reference - The reference element used to position the popper
	   * @param {Element} popper - The HTML / XML element used as the popper
	   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
	   * @return {Object} instance - The generated Popper.js instance
	   */
	  function Popper(reference, popper) {
	    var _this = this;
	
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    classCallCheck(this, Popper);
	
	    this.scheduleUpdate = function () {
	      return requestAnimationFrame(_this.update);
	    };
	
	    // make update() debounced, so that it only runs at most once-per-tick
	    this.update = debounce(this.update.bind(this));
	
	    // with {} we create a new object with the options inside it
	    this.options = _extends({}, Popper.Defaults, options);
	
	    // init state
	    this.state = {
	      isDestroyed: false,
	      isCreated: false,
	      scrollParents: []
	    };
	
	    // get reference and popper elements (allow jQuery wrappers)
	    this.reference = reference && reference.jquery ? reference[0] : reference;
	    this.popper = popper && popper.jquery ? popper[0] : popper;
	
	    // Deep merge modifiers options
	    this.options.modifiers = {};
	    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
	      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
	    });
	
	    // Refactoring modifiers' list (Object => Array)
	    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
	      return _extends({
	        name: name
	      }, _this.options.modifiers[name]);
	    })
	    // sort the modifiers by order
	    .sort(function (a, b) {
	      return a.order - b.order;
	    });
	
	    // modifiers have the ability to execute arbitrary code when Popper.js get inited
	    // such code is executed in the same order of its modifier
	    // they could add new properties to their options configuration
	    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
	    this.modifiers.forEach(function (modifierOptions) {
	      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
	        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
	      }
	    });
	
	    // fire the first update to position the popper in the right place
	    this.update();
	
	    var eventsEnabled = this.options.eventsEnabled;
	    if (eventsEnabled) {
	      // setup event listeners, they will take care of update the position in specific situations
	      this.enableEventListeners();
	    }
	
	    this.state.eventsEnabled = eventsEnabled;
	  }
	
	  // We can't use class properties because they don't get listed in the
	  // class prototype and break stuff like Sinon stubs
	
	
	  createClass(Popper, [{
	    key: 'update',
	    value: function update$$1() {
	      return update.call(this);
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy$$1() {
	      return destroy.call(this);
	    }
	  }, {
	    key: 'enableEventListeners',
	    value: function enableEventListeners$$1() {
	      return enableEventListeners.call(this);
	    }
	  }, {
	    key: 'disableEventListeners',
	    value: function disableEventListeners$$1() {
	      return disableEventListeners.call(this);
	    }
	
	    /**
	     * Schedules an update. It will run on the next UI update available.
	     * @method scheduleUpdate
	     * @memberof Popper
	     */
	
	
	    /**
	     * Collection of utilities useful when writing custom modifiers.
	     * Starting from version 1.7, this method is available only if you
	     * include `popper-utils.js` before `popper.js`.
	     *
	     * **DEPRECATION**: This way to access PopperUtils is deprecated
	     * and will be removed in v2! Use the PopperUtils module directly instead.
	     * Due to the high instability of the methods contained in Utils, we can't
	     * guarantee them to follow semver. Use them at your own risk!
	     * @static
	     * @private
	     * @type {Object}
	     * @deprecated since version 1.8
	     * @member Utils
	     * @memberof Popper
	     */
	
	  }]);
	  return Popper;
	}();
	
	/**
	 * The `referenceObject` is an object that provides an interface compatible with Popper.js
	 * and lets you use it as replacement of a real DOM node.<br />
	 * You can use this method to position a popper relatively to a set of coordinates
	 * in case you don't have a DOM node to use as reference.
	 *
	 * ```
	 * new Popper(referenceObject, popperNode);
	 * ```
	 *
	 * NB: This feature isn't supported in Internet Explorer 10.
	 * @name referenceObject
	 * @property {Function} data.getBoundingClientRect
	 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
	 * @property {number} data.clientWidth
	 * An ES6 getter that will return the width of the virtual reference element.
	 * @property {number} data.clientHeight
	 * An ES6 getter that will return the height of the virtual reference element.
	 */
	
	
	Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
	Popper.placements = placements;
	Popper.Defaults = Defaults;
	
	return Popper;
	
	})));
	//# sourceMappingURL=popper.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1365 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = __webpack_require__(1366);
	
	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bigint: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,
	
	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };
	
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 1366 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ },
/* 1367 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strictUriEncode = __webpack_require__(1622);
	var objectAssign = __webpack_require__(58);
	
	function encoderForArrayFormat(opts) {
		switch (opts.arrayFormat) {
			case 'index':
				return function (key, value, index) {
					return value === null ? [
						encode(key, opts),
						'[',
						index,
						']'
					].join('') : [
						encode(key, opts),
						'[',
						encode(index, opts),
						']=',
						encode(value, opts)
					].join('');
				};
	
			case 'bracket':
				return function (key, value) {
					return value === null ? encode(key, opts) : [
						encode(key, opts),
						'[]=',
						encode(value, opts)
					].join('');
				};
	
			default:
				return function (key, value) {
					return value === null ? encode(key, opts) : [
						encode(key, opts),
						'=',
						encode(value, opts)
					].join('');
				};
		}
	}
	
	function parserForArrayFormat(opts) {
		var result;
	
		switch (opts.arrayFormat) {
			case 'index':
				return function (key, value, accumulator) {
					result = /\[(\d*)\]$/.exec(key);
	
					key = key.replace(/\[\d*\]$/, '');
	
					if (!result) {
						accumulator[key] = value;
						return;
					}
	
					if (accumulator[key] === undefined) {
						accumulator[key] = {};
					}
	
					accumulator[key][result[1]] = value;
				};
	
			case 'bracket':
				return function (key, value, accumulator) {
					result = /(\[\])$/.exec(key);
					key = key.replace(/\[\]$/, '');
	
					if (!result) {
						accumulator[key] = value;
						return;
					} else if (accumulator[key] === undefined) {
						accumulator[key] = [value];
						return;
					}
	
					accumulator[key] = [].concat(accumulator[key], value);
				};
	
			default:
				return function (key, value, accumulator) {
					if (accumulator[key] === undefined) {
						accumulator[key] = value;
						return;
					}
	
					accumulator[key] = [].concat(accumulator[key], value);
				};
		}
	}
	
	function encode(value, opts) {
		if (opts.encode) {
			return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
		}
	
		return value;
	}
	
	function keysSorter(input) {
		if (Array.isArray(input)) {
			return input.sort();
		} else if (typeof input === 'object') {
			return keysSorter(Object.keys(input)).sort(function (a, b) {
				return Number(a) - Number(b);
			}).map(function (key) {
				return input[key];
			});
		}
	
		return input;
	}
	
	exports.extract = function (str) {
		return str.split('?')[1] || '';
	};
	
	exports.parse = function (str, opts) {
		opts = objectAssign({arrayFormat: 'none'}, opts);
	
		var formatter = parserForArrayFormat(opts);
	
		// Create an object with no prototype
		// https://github.com/sindresorhus/query-string/issues/47
		var ret = Object.create(null);
	
		if (typeof str !== 'string') {
			return ret;
		}
	
		str = str.trim().replace(/^(\?|#|&)/, '');
	
		if (!str) {
			return ret;
		}
	
		str.split('&').forEach(function (param) {
			var parts = param.replace(/\+/g, ' ').split('=');
			// Firefox (pre 40) decodes `%3D` to `=`
			// https://github.com/sindresorhus/query-string/pull/37
			var key = parts.shift();
			var val = parts.length > 0 ? parts.join('=') : undefined;
	
			// missing `=` should be `null`:
			// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
			val = val === undefined ? null : decodeURIComponent(val);
	
			formatter(decodeURIComponent(key), val, ret);
		});
	
		return Object.keys(ret).sort().reduce(function (result, key) {
			var val = ret[key];
			if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
				// Sort object keys, not values
				result[key] = keysSorter(val);
			} else {
				result[key] = val;
			}
	
			return result;
		}, Object.create(null));
	};
	
	exports.stringify = function (obj, opts) {
		var defaults = {
			encode: true,
			strict: true,
			arrayFormat: 'none'
		};
	
		opts = objectAssign(defaults, opts);
	
		var formatter = encoderForArrayFormat(opts);
	
		return obj ? Object.keys(obj).sort().map(function (key) {
			var val = obj[key];
	
			if (val === undefined) {
				return '';
			}
	
			if (val === null) {
				return encode(key, opts);
			}
	
			if (Array.isArray(val)) {
				var result = [];
	
				val.slice().forEach(function (val2) {
					if (val2 === undefined) {
						return;
					}
	
					result.push(formatter(key, val2, result.length));
				});
	
				return result.join('&');
			}
	
			return encode(key, opts) + '=' + encode(val, opts);
		}).filter(function (x) {
			return x.length > 0;
		}).join('&') : '';
	};


/***/ },
/* 1368 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _arrays = _interopRequireDefault(__webpack_require__(1619));
	
	var _Autowhatever = _interopRequireDefault(__webpack_require__(1369));
	
	var _theme = __webpack_require__(1373);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var alwaysTrue = function alwaysTrue() {
	  return true;
	};
	
	var defaultShouldRenderSuggestions = function defaultShouldRenderSuggestions(value) {
	  return value.trim().length > 0;
	};
	
	var defaultRenderSuggestionsContainer = function defaultRenderSuggestionsContainer(_ref) {
	  var containerProps = _ref.containerProps,
	      children = _ref.children;
	  return /*#__PURE__*/_react["default"].createElement("div", containerProps, children);
	};
	
	var REASON_SUGGESTIONS_REVEALED = 'suggestions-revealed';
	var REASON_SUGGESTIONS_UPDATED = 'suggestions-updated';
	var REASON_SUGGESTION_SELECTED = 'suggestion-selected';
	var REASON_INPUT_FOCUSED = 'input-focused';
	var REASON_INPUT_CHANGED = 'input-changed';
	var REASON_INPUT_BLURRED = 'input-blurred';
	var REASON_ESCAPE_PRESSED = 'escape-pressed';
	
	var Autosuggest = /*#__PURE__*/function (_Component) {
	  _inherits(Autosuggest, _Component);
	
	  var _super = _createSuper(Autosuggest);
	
	  function Autosuggest(_ref2) {
	    var _this;
	
	    var _alwaysRenderSuggestions = _ref2.alwaysRenderSuggestions;
	
	    _classCallCheck(this, Autosuggest);
	
	    _this = _super.call(this);
	
	    _defineProperty(_assertThisInitialized(_this), "onDocumentMouseDown", function (event) {
	      _this.justClickedOnSuggestionsContainer = false;
	      var node = event.detail && event.detail.target || // This is for testing only. Please show me a better way to emulate this.
	      event.target;
	
	      while (node !== null && node !== document) {
	        if (node.getAttribute && node.getAttribute('data-suggestion-index') !== null) {
	          // Suggestion was clicked
	          return;
	        }
	
	        if (node === _this.suggestionsContainer) {
	          // Something else inside suggestions container was clicked
	          _this.justClickedOnSuggestionsContainer = true;
	          return;
	        }
	
	        node = node.parentNode;
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "storeAutowhateverRef", function (autowhatever) {
	      if (autowhatever !== null) {
	        _this.autowhatever = autowhatever;
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onSuggestionMouseEnter", function (event, _ref3) {
	      var sectionIndex = _ref3.sectionIndex,
	          itemIndex = _ref3.itemIndex;
	
	      _this.updateHighlightedSuggestion(sectionIndex, itemIndex);
	
	      if (event.target === _this.pressedSuggestion) {
	        _this.justSelectedSuggestion = true;
	      }
	
	      _this.justMouseEntered = true;
	      setTimeout(function () {
	        _this.justMouseEntered = false;
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "highlightFirstSuggestion", function () {
	      _this.updateHighlightedSuggestion(_this.props.multiSection ? 0 : null, 0);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onDocumentMouseUp", function () {
	      if (_this.pressedSuggestion && !_this.justSelectedSuggestion) {
	        _this.input.focus();
	      }
	
	      _this.pressedSuggestion = null;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onSuggestionMouseDown", function (event) {
	      // Checking if this.justSelectedSuggestion is already true to not duplicate touch events in chrome
	      // See: https://github.com/facebook/react/issues/9809#issuecomment-413978405
	      if (!_this.justSelectedSuggestion) {
	        _this.justSelectedSuggestion = true;
	        _this.pressedSuggestion = event.target;
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onSuggestionsClearRequested", function () {
	      var onSuggestionsClearRequested = _this.props.onSuggestionsClearRequested;
	      onSuggestionsClearRequested && onSuggestionsClearRequested();
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onSuggestionSelected", function (event, data) {
	      var _this$props = _this.props,
	          alwaysRenderSuggestions = _this$props.alwaysRenderSuggestions,
	          onSuggestionSelected = _this$props.onSuggestionSelected,
	          onSuggestionsFetchRequested = _this$props.onSuggestionsFetchRequested;
	      onSuggestionSelected && onSuggestionSelected(event, data);
	
	      var keepSuggestionsOnSelect = _this.props.shouldKeepSuggestionsOnSelect(data.suggestion);
	
	      if (alwaysRenderSuggestions || keepSuggestionsOnSelect) {
	        onSuggestionsFetchRequested({
	          value: data.suggestionValue,
	          reason: REASON_SUGGESTION_SELECTED
	        });
	      } else {
	        _this.onSuggestionsClearRequested();
	      }
	
	      _this.resetHighlightedSuggestion();
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onSuggestionClick", function (event) {
	      var _this$props2 = _this.props,
	          alwaysRenderSuggestions = _this$props2.alwaysRenderSuggestions,
	          focusInputOnSuggestionClick = _this$props2.focusInputOnSuggestionClick;
	
	      var _this$getSuggestionIn = _this.getSuggestionIndices(_this.findSuggestionElement(event.target)),
	          sectionIndex = _this$getSuggestionIn.sectionIndex,
	          suggestionIndex = _this$getSuggestionIn.suggestionIndex;
	
	      var clickedSuggestion = _this.getSuggestion(sectionIndex, suggestionIndex);
	
	      var clickedSuggestionValue = _this.props.getSuggestionValue(clickedSuggestion);
	
	      _this.maybeCallOnChange(event, clickedSuggestionValue, 'click');
	
	      _this.onSuggestionSelected(event, {
	        suggestion: clickedSuggestion,
	        suggestionValue: clickedSuggestionValue,
	        suggestionIndex: suggestionIndex,
	        sectionIndex: sectionIndex,
	        method: 'click'
	      });
	
	      var keepSuggestionsOnSelect = _this.props.shouldKeepSuggestionsOnSelect(clickedSuggestion);
	
	      if (!(alwaysRenderSuggestions || keepSuggestionsOnSelect)) {
	        _this.closeSuggestions();
	      }
	
	      if (focusInputOnSuggestionClick === true) {
	        _this.input.focus();
	      } else {
	        _this.onBlur();
	      }
	
	      setTimeout(function () {
	        _this.justSelectedSuggestion = false;
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onBlur", function () {
	      var _this$props3 = _this.props,
	          inputProps = _this$props3.inputProps,
	          shouldRenderSuggestions = _this$props3.shouldRenderSuggestions;
	      var value = inputProps.value,
	          onBlur = inputProps.onBlur;
	
	      var highlightedSuggestion = _this.getHighlightedSuggestion();
	
	      var shouldRender = shouldRenderSuggestions(value, REASON_INPUT_BLURRED);
	
	      _this.setState({
	        isFocused: false,
	        highlightedSectionIndex: null,
	        highlightedSuggestionIndex: null,
	        highlightedSuggestion: null,
	        valueBeforeUpDown: null,
	        isCollapsed: !shouldRender
	      });
	
	      onBlur && onBlur(_this.blurEvent, {
	        highlightedSuggestion: highlightedSuggestion
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onSuggestionMouseLeave", function (event) {
	      _this.resetHighlightedSuggestion(false); // shouldResetValueBeforeUpDown
	
	
	      if (_this.justSelectedSuggestion && event.target === _this.pressedSuggestion) {
	        _this.justSelectedSuggestion = false;
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onSuggestionTouchStart", function () {
	      _this.justSelectedSuggestion = true; // todo: event.preventDefault when https://github.com/facebook/react/issues/2043
	      // todo: gets released so onSuggestionMouseDown won't fire in chrome
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onSuggestionTouchMove", function () {
	      _this.justSelectedSuggestion = false;
	      _this.pressedSuggestion = null;
	
	      _this.input.focus();
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "itemProps", function (_ref4) {
	      var sectionIndex = _ref4.sectionIndex,
	          itemIndex = _ref4.itemIndex;
	      return {
	        'data-section-index': sectionIndex,
	        'data-suggestion-index': itemIndex,
	        onMouseEnter: _this.onSuggestionMouseEnter,
	        onMouseLeave: _this.onSuggestionMouseLeave,
	        onMouseDown: _this.onSuggestionMouseDown,
	        onTouchStart: _this.onSuggestionTouchStart,
	        onTouchMove: _this.onSuggestionTouchMove,
	        onClick: _this.onSuggestionClick
	      };
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "renderSuggestionsContainer", function (_ref5) {
	      var containerProps = _ref5.containerProps,
	          children = _ref5.children;
	      var renderSuggestionsContainer = _this.props.renderSuggestionsContainer;
	      return renderSuggestionsContainer({
	        containerProps: containerProps,
	        children: children,
	        query: _this.getQuery()
	      });
	    });
	
	    _this.state = {
	      isFocused: false,
	      isCollapsed: !_alwaysRenderSuggestions,
	      highlightedSectionIndex: null,
	      highlightedSuggestionIndex: null,
	      highlightedSuggestion: null,
	      valueBeforeUpDown: null
	    };
	    _this.justPressedUpDown = false;
	    _this.justMouseEntered = false;
	    _this.pressedSuggestion = null;
	    return _this;
	  }
	
	  _createClass(Autosuggest, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      document.addEventListener('mousedown', this.onDocumentMouseDown);
	      document.addEventListener('mouseup', this.onDocumentMouseUp);
	      this.input = this.autowhatever.input;
	      this.suggestionsContainer = this.autowhatever.itemsContainer;
	    } // eslint-disable-next-line camelcase, react/sort-comp
	
	  }, {
	    key: "UNSAFE_componentWillReceiveProps",
	    value: function UNSAFE_componentWillReceiveProps(nextProps) {
	      // When highlightFirstSuggestion becomes deactivated, if the first suggestion was
	      // set, we should reset the suggestion back to the unselected default state.
	      var shouldResetHighlighting = this.state.highlightedSuggestionIndex === 0 && this.props.highlightFirstSuggestion && !nextProps.highlightFirstSuggestion;
	
	      if ((0, _arrays["default"])(nextProps.suggestions, this.props.suggestions)) {
	        if (nextProps.highlightFirstSuggestion && nextProps.suggestions.length > 0 && this.justPressedUpDown === false && this.justMouseEntered === false) {
	          this.highlightFirstSuggestion();
	        } else if (shouldResetHighlighting) {
	          this.resetHighlightedSuggestion();
	        }
	      } else {
	        if (this.willRenderSuggestions(nextProps, REASON_SUGGESTIONS_UPDATED)) {
	          if (this.state.isCollapsed && !this.justSelectedSuggestion) {
	            this.revealSuggestions();
	          }
	
	          if (shouldResetHighlighting) {
	            this.resetHighlightedSuggestion();
	          }
	        } else {
	          this.resetHighlightedSuggestion();
	        }
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps, prevState) {
	      var _this$props4 = this.props,
	          suggestions = _this$props4.suggestions,
	          onSuggestionHighlighted = _this$props4.onSuggestionHighlighted,
	          highlightFirstSuggestion = _this$props4.highlightFirstSuggestion;
	
	      if (!(0, _arrays["default"])(suggestions, prevProps.suggestions) && suggestions.length > 0 && highlightFirstSuggestion) {
	        this.highlightFirstSuggestion();
	        return;
	      }
	
	      if (onSuggestionHighlighted) {
	        var highlightedSuggestion = this.getHighlightedSuggestion();
	        var prevHighlightedSuggestion = prevState.highlightedSuggestion;
	
	        if (highlightedSuggestion != prevHighlightedSuggestion) {
	          onSuggestionHighlighted({
	            suggestion: highlightedSuggestion
	          });
	        }
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      document.removeEventListener('mousedown', this.onDocumentMouseDown);
	      document.removeEventListener('mouseup', this.onDocumentMouseUp);
	    }
	  }, {
	    key: "updateHighlightedSuggestion",
	    value: function updateHighlightedSuggestion(sectionIndex, suggestionIndex, prevValue) {
	      var _this2 = this;
	
	      this.setState(function (state) {
	        var valueBeforeUpDown = state.valueBeforeUpDown;
	
	        if (suggestionIndex === null) {
	          valueBeforeUpDown = null;
	        } else if (valueBeforeUpDown === null && typeof prevValue !== 'undefined') {
	          valueBeforeUpDown = prevValue;
	        }
	
	        return {
	          highlightedSectionIndex: sectionIndex,
	          highlightedSuggestionIndex: suggestionIndex,
	          highlightedSuggestion: suggestionIndex === null ? null : _this2.getSuggestion(sectionIndex, suggestionIndex),
	          valueBeforeUpDown: valueBeforeUpDown
	        };
	      });
	    }
	  }, {
	    key: "resetHighlightedSuggestion",
	    value: function resetHighlightedSuggestion() {
	      var shouldResetValueBeforeUpDown = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	      this.setState(function (state) {
	        var valueBeforeUpDown = state.valueBeforeUpDown;
	        return {
	          highlightedSectionIndex: null,
	          highlightedSuggestionIndex: null,
	          highlightedSuggestion: null,
	          valueBeforeUpDown: shouldResetValueBeforeUpDown ? null : valueBeforeUpDown
	        };
	      });
	    }
	  }, {
	    key: "revealSuggestions",
	    value: function revealSuggestions() {
	      this.setState({
	        isCollapsed: false
	      });
	    }
	  }, {
	    key: "closeSuggestions",
	    value: function closeSuggestions() {
	      this.setState({
	        highlightedSectionIndex: null,
	        highlightedSuggestionIndex: null,
	        highlightedSuggestion: null,
	        valueBeforeUpDown: null,
	        isCollapsed: true
	      });
	    }
	  }, {
	    key: "getSuggestion",
	    value: function getSuggestion(sectionIndex, suggestionIndex) {
	      var _this$props5 = this.props,
	          suggestions = _this$props5.suggestions,
	          multiSection = _this$props5.multiSection,
	          getSectionSuggestions = _this$props5.getSectionSuggestions;
	
	      if (multiSection) {
	        return getSectionSuggestions(suggestions[sectionIndex])[suggestionIndex];
	      }
	
	      return suggestions[suggestionIndex];
	    }
	  }, {
	    key: "getHighlightedSuggestion",
	    value: function getHighlightedSuggestion() {
	      var _this$state = this.state,
	          highlightedSectionIndex = _this$state.highlightedSectionIndex,
	          highlightedSuggestionIndex = _this$state.highlightedSuggestionIndex;
	
	      if (highlightedSuggestionIndex === null) {
	        return null;
	      }
	
	      return this.getSuggestion(highlightedSectionIndex, highlightedSuggestionIndex);
	    }
	  }, {
	    key: "getSuggestionValueByIndex",
	    value: function getSuggestionValueByIndex(sectionIndex, suggestionIndex) {
	      var getSuggestionValue = this.props.getSuggestionValue;
	      return getSuggestionValue(this.getSuggestion(sectionIndex, suggestionIndex));
	    }
	  }, {
	    key: "getSuggestionIndices",
	    value: function getSuggestionIndices(suggestionElement) {
	      var sectionIndex = suggestionElement.getAttribute('data-section-index');
	      var suggestionIndex = suggestionElement.getAttribute('data-suggestion-index');
	      return {
	        sectionIndex: typeof sectionIndex === 'string' ? parseInt(sectionIndex, 10) : null,
	        suggestionIndex: parseInt(suggestionIndex, 10)
	      };
	    }
	  }, {
	    key: "findSuggestionElement",
	    value: function findSuggestionElement(startNode) {
	      var node = startNode;
	
	      do {
	        if (node.getAttribute && node.getAttribute('data-suggestion-index') !== null) {
	          return node;
	        }
	
	        node = node.parentNode;
	      } while (node !== null);
	
	      console.error('Clicked element:', startNode); // eslint-disable-line no-console
	
	      throw new Error("Couldn't find suggestion element");
	    }
	  }, {
	    key: "maybeCallOnChange",
	    value: function maybeCallOnChange(event, newValue, method) {
	      var _this$props$inputProp = this.props.inputProps,
	          value = _this$props$inputProp.value,
	          onChange = _this$props$inputProp.onChange;
	
	      if (newValue !== value) {
	        onChange(event, {
	          newValue: newValue,
	          method: method
	        });
	      }
	    }
	  }, {
	    key: "willRenderSuggestions",
	    value: function willRenderSuggestions(props, reason) {
	      var suggestions = props.suggestions,
	          inputProps = props.inputProps,
	          shouldRenderSuggestions = props.shouldRenderSuggestions;
	      var value = inputProps.value;
	      return suggestions.length > 0 && shouldRenderSuggestions(value, reason);
	    }
	  }, {
	    key: "getQuery",
	    value: function getQuery() {
	      var inputProps = this.props.inputProps;
	      var value = inputProps.value;
	      var valueBeforeUpDown = this.state.valueBeforeUpDown;
	      return (valueBeforeUpDown === null ? value : valueBeforeUpDown).trim();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var _this$props6 = this.props,
	          suggestions = _this$props6.suggestions,
	          renderInputComponent = _this$props6.renderInputComponent,
	          onSuggestionsFetchRequested = _this$props6.onSuggestionsFetchRequested,
	          renderSuggestion = _this$props6.renderSuggestion,
	          inputProps = _this$props6.inputProps,
	          multiSection = _this$props6.multiSection,
	          renderSectionTitle = _this$props6.renderSectionTitle,
	          id = _this$props6.id,
	          getSectionSuggestions = _this$props6.getSectionSuggestions,
	          theme = _this$props6.theme,
	          getSuggestionValue = _this$props6.getSuggestionValue,
	          alwaysRenderSuggestions = _this$props6.alwaysRenderSuggestions,
	          highlightFirstSuggestion = _this$props6.highlightFirstSuggestion,
	          containerProps = _this$props6.containerProps;
	      var _this$state2 = this.state,
	          isFocused = _this$state2.isFocused,
	          isCollapsed = _this$state2.isCollapsed,
	          highlightedSectionIndex = _this$state2.highlightedSectionIndex,
	          highlightedSuggestionIndex = _this$state2.highlightedSuggestionIndex,
	          valueBeforeUpDown = _this$state2.valueBeforeUpDown;
	      var shouldRenderSuggestions = alwaysRenderSuggestions ? alwaysTrue : this.props.shouldRenderSuggestions;
	      var value = inputProps.value,
	          _onFocus = inputProps.onFocus,
	          _onKeyDown = inputProps.onKeyDown;
	      var willRenderSuggestions = this.willRenderSuggestions(this.props, 'render');
	      var isOpen = alwaysRenderSuggestions || isFocused && !isCollapsed && willRenderSuggestions;
	      var items = isOpen ? suggestions : [];
	
	      var autowhateverInputProps = _objectSpread({}, inputProps, {
	        onFocus: function onFocus(event) {
	          if (!_this3.justSelectedSuggestion && !_this3.justClickedOnSuggestionsContainer) {
	            var shouldRender = shouldRenderSuggestions(value, REASON_INPUT_FOCUSED);
	
	            _this3.setState({
	              isFocused: true,
	              isCollapsed: !shouldRender
	            });
	
	            _onFocus && _onFocus(event);
	
	            if (shouldRender) {
	              onSuggestionsFetchRequested({
	                value: value,
	                reason: REASON_INPUT_FOCUSED
	              });
	            }
	          }
	        },
	        onBlur: function onBlur(event) {
	          if (_this3.justClickedOnSuggestionsContainer) {
	            _this3.input.focus();
	
	            return;
	          }
	
	          _this3.blurEvent = event;
	
	          if (!_this3.justSelectedSuggestion) {
	            _this3.onBlur();
	
	            _this3.onSuggestionsClearRequested();
	          }
	        },
	        onChange: function onChange(event) {
	          var value = event.target.value;
	          var shouldRender = shouldRenderSuggestions(value, REASON_INPUT_CHANGED);
	
	          _this3.maybeCallOnChange(event, value, 'type');
	
	          if (_this3.suggestionsContainer) {
	            _this3.suggestionsContainer.scrollTop = 0;
	          }
	
	          _this3.setState(_objectSpread({}, highlightFirstSuggestion ? {} : {
	            highlightedSectionIndex: null,
	            highlightedSuggestionIndex: null,
	            highlightedSuggestion: null
	          }, {
	            valueBeforeUpDown: null,
	            isCollapsed: !shouldRender
	          }));
	
	          if (shouldRender) {
	            onSuggestionsFetchRequested({
	              value: value,
	              reason: REASON_INPUT_CHANGED
	            });
	          } else {
	            _this3.onSuggestionsClearRequested();
	          }
	        },
	        onKeyDown: function onKeyDown(event, data) {
	          var keyCode = event.keyCode;
	
	          switch (keyCode) {
	            case 40: // ArrowDown
	
	            case 38:
	              // ArrowUp
	              if (isCollapsed) {
	                if (shouldRenderSuggestions(value, REASON_SUGGESTIONS_REVEALED)) {
	                  onSuggestionsFetchRequested({
	                    value: value,
	                    reason: REASON_SUGGESTIONS_REVEALED
	                  });
	
	                  _this3.revealSuggestions();
	
	                  event.preventDefault(); // We act on the key.
	                }
	              } else if (suggestions.length > 0) {
	                var newHighlightedSectionIndex = data.newHighlightedSectionIndex,
	                    newHighlightedItemIndex = data.newHighlightedItemIndex;
	                var newValue;
	
	                if (newHighlightedItemIndex === null) {
	                  // valueBeforeUpDown can be null if, for example, user
	                  // hovers on the first suggestion and then pressed Up.
	                  // If that happens, use the original input value.
	                  newValue = valueBeforeUpDown === null ? value : valueBeforeUpDown;
	                } else {
	                  newValue = _this3.getSuggestionValueByIndex(newHighlightedSectionIndex, newHighlightedItemIndex);
	                }
	
	                _this3.updateHighlightedSuggestion(newHighlightedSectionIndex, newHighlightedItemIndex, value);
	
	                _this3.maybeCallOnChange(event, newValue, keyCode === 40 ? 'down' : 'up');
	
	                event.preventDefault(); // We act on the key.
	              }
	
	              _this3.justPressedUpDown = true;
	              setTimeout(function () {
	                _this3.justPressedUpDown = false;
	              });
	              break;
	            // Enter
	
	            case 13:
	              {
	                // See #388
	                if (event.keyCode === 229) {
	                  break;
	                }
	
	                var highlightedSuggestion = _this3.getHighlightedSuggestion();
	
	                if (isOpen && !alwaysRenderSuggestions) {
	                  _this3.closeSuggestions();
	                }
	
	                if (highlightedSuggestion != null) {
	                  event.preventDefault();
	
	                  var _newValue = getSuggestionValue(highlightedSuggestion);
	
	                  _this3.maybeCallOnChange(event, _newValue, 'enter');
	
	                  _this3.onSuggestionSelected(event, {
	                    suggestion: highlightedSuggestion,
	                    suggestionValue: _newValue,
	                    suggestionIndex: highlightedSuggestionIndex,
	                    sectionIndex: highlightedSectionIndex,
	                    method: 'enter'
	                  });
	
	                  _this3.justSelectedSuggestion = true;
	                  setTimeout(function () {
	                    _this3.justSelectedSuggestion = false;
	                  });
	                }
	
	                break;
	              }
	            // Escape
	
	            case 27:
	              {
	                if (isOpen) {
	                  // If input.type === 'search', the browser clears the input
	                  // when Escape is pressed. We want to disable this default
	                  // behaviour so that, when suggestions are shown, we just hide
	                  // them, without clearing the input.
	                  event.preventDefault();
	                }
	
	                var willCloseSuggestions = isOpen && !alwaysRenderSuggestions;
	
	                if (valueBeforeUpDown === null) {
	                  // Didn't interact with Up/Down
	                  if (!willCloseSuggestions) {
	                    var _newValue2 = '';
	
	                    _this3.maybeCallOnChange(event, _newValue2, 'escape');
	
	                    if (shouldRenderSuggestions(_newValue2, REASON_ESCAPE_PRESSED)) {
	                      onSuggestionsFetchRequested({
	                        value: _newValue2,
	                        reason: REASON_ESCAPE_PRESSED
	                      });
	                    } else {
	                      _this3.onSuggestionsClearRequested();
	                    }
	                  }
	                } else {
	                  // Interacted with Up/Down
	                  _this3.maybeCallOnChange(event, valueBeforeUpDown, 'escape');
	                }
	
	                if (willCloseSuggestions) {
	                  _this3.onSuggestionsClearRequested();
	
	                  _this3.closeSuggestions();
	                } else {
	                  _this3.resetHighlightedSuggestion();
	                }
	
	                break;
	              }
	          }
	
	          _onKeyDown && _onKeyDown(event);
	        }
	      });
	
	      var renderSuggestionData = {
	        query: this.getQuery()
	      };
	      return /*#__PURE__*/_react["default"].createElement(_Autowhatever["default"], {
	        multiSection: multiSection,
	        items: items,
	        renderInputComponent: renderInputComponent,
	        renderItemsContainer: this.renderSuggestionsContainer,
	        renderItem: renderSuggestion,
	        renderItemData: renderSuggestionData,
	        renderSectionTitle: renderSectionTitle,
	        getSectionItems: getSectionSuggestions,
	        highlightedSectionIndex: highlightedSectionIndex,
	        highlightedItemIndex: highlightedSuggestionIndex,
	        containerProps: containerProps,
	        inputProps: autowhateverInputProps,
	        itemProps: this.itemProps,
	        theme: (0, _theme.mapToAutowhateverTheme)(theme),
	        id: id,
	        ref: this.storeAutowhateverRef
	      });
	    }
	  }]);
	
	  return Autosuggest;
	}(_react.Component);
	
	exports["default"] = Autosuggest;
	
	_defineProperty(Autosuggest, "propTypes", {
	  suggestions: _propTypes["default"].array.isRequired,
	  onSuggestionsFetchRequested: function onSuggestionsFetchRequested(props, propName) {
	    var onSuggestionsFetchRequested = props[propName];
	
	    if (typeof onSuggestionsFetchRequested !== 'function') {
	      throw new Error("'onSuggestionsFetchRequested' must be implemented. See: https://github.com/moroshko/react-autosuggest#onSuggestionsFetchRequestedProp");
	    }
	  },
	  onSuggestionsClearRequested: function onSuggestionsClearRequested(props, propName) {
	    var onSuggestionsClearRequested = props[propName];
	
	    if (props.alwaysRenderSuggestions === false && typeof onSuggestionsClearRequested !== 'function') {
	      throw new Error("'onSuggestionsClearRequested' must be implemented. See: https://github.com/moroshko/react-autosuggest#onSuggestionsClearRequestedProp");
	    }
	  },
	  shouldKeepSuggestionsOnSelect: _propTypes["default"].func,
	  onSuggestionSelected: _propTypes["default"].func,
	  onSuggestionHighlighted: _propTypes["default"].func,
	  renderInputComponent: _propTypes["default"].func,
	  renderSuggestionsContainer: _propTypes["default"].func,
	  getSuggestionValue: _propTypes["default"].func.isRequired,
	  renderSuggestion: _propTypes["default"].func.isRequired,
	  inputProps: function inputProps(props, propName) {
	    var inputProps = props[propName];
	
	    if (!inputProps) {
	      throw new Error("'inputProps' must be passed.");
	    }
	
	    if (!Object.prototype.hasOwnProperty.call(inputProps, 'value')) {
	      throw new Error("'inputProps' must have 'value'.");
	    }
	
	    if (!Object.prototype.hasOwnProperty.call(inputProps, 'onChange')) {
	      throw new Error("'inputProps' must have 'onChange'.");
	    }
	  },
	  shouldRenderSuggestions: _propTypes["default"].func,
	  alwaysRenderSuggestions: _propTypes["default"].bool,
	  multiSection: _propTypes["default"].bool,
	  renderSectionTitle: function renderSectionTitle(props, propName) {
	    var renderSectionTitle = props[propName];
	
	    if (props.multiSection === true && typeof renderSectionTitle !== 'function') {
	      throw new Error("'renderSectionTitle' must be implemented. See: https://github.com/moroshko/react-autosuggest#renderSectionTitleProp");
	    }
	  },
	  getSectionSuggestions: function getSectionSuggestions(props, propName) {
	    var getSectionSuggestions = props[propName];
	
	    if (props.multiSection === true && typeof getSectionSuggestions !== 'function') {
	      throw new Error("'getSectionSuggestions' must be implemented. See: https://github.com/moroshko/react-autosuggest#getSectionSuggestionsProp");
	    }
	  },
	  focusInputOnSuggestionClick: _propTypes["default"].bool,
	  highlightFirstSuggestion: _propTypes["default"].bool,
	  theme: _propTypes["default"].object,
	  id: _propTypes["default"].string,
	  containerProps: _propTypes["default"].object // Arbitrary container props
	
	});
	
	_defineProperty(Autosuggest, "defaultProps", {
	  renderSuggestionsContainer: defaultRenderSuggestionsContainer,
	  shouldRenderSuggestions: defaultShouldRenderSuggestions,
	  alwaysRenderSuggestions: false,
	  multiSection: false,
	  shouldKeepSuggestionsOnSelect: function shouldKeepSuggestionsOnSelect() {
	    return false;
	  },
	  focusInputOnSuggestionClick: true,
	  highlightFirstSuggestion: false,
	  theme: _theme.defaultTheme,
	  id: '1',
	  containerProps: {}
	});

/***/ },
/* 1369 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _sectionIterator = _interopRequireDefault(__webpack_require__(1616));
	
	var _reactThemeable = _interopRequireDefault(__webpack_require__(1517));
	
	var _SectionTitle = _interopRequireDefault(__webpack_require__(1372));
	
	var _ItemList = _interopRequireDefault(__webpack_require__(1371));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var emptyObject = {};
	
	var defaultRenderInputComponent = function defaultRenderInputComponent(props) {
	  return /*#__PURE__*/_react["default"].createElement("input", props);
	};
	
	var defaultRenderItemsContainer = function defaultRenderItemsContainer(_ref) {
	  var containerProps = _ref.containerProps,
	      children = _ref.children;
	  return /*#__PURE__*/_react["default"].createElement("div", containerProps, children);
	};
	
	var defaultTheme = {
	  container: 'react-autowhatever__container',
	  containerOpen: 'react-autowhatever__container--open',
	  input: 'react-autowhatever__input',
	  inputOpen: 'react-autowhatever__input--open',
	  inputFocused: 'react-autowhatever__input--focused',
	  itemsContainer: 'react-autowhatever__items-container',
	  itemsContainerOpen: 'react-autowhatever__items-container--open',
	  itemsList: 'react-autowhatever__items-list',
	  item: 'react-autowhatever__item',
	  itemFirst: 'react-autowhatever__item--first',
	  itemHighlighted: 'react-autowhatever__item--highlighted',
	  sectionContainer: 'react-autowhatever__section-container',
	  sectionContainerFirst: 'react-autowhatever__section-container--first',
	  sectionTitle: 'react-autowhatever__section-title'
	};
	
	var Autowhatever = /*#__PURE__*/function (_Component) {
	  _inherits(Autowhatever, _Component);
	
	  var _super = _createSuper(Autowhatever);
	
	  function Autowhatever(props) {
	    var _this;
	
	    _classCallCheck(this, Autowhatever);
	
	    _this = _super.call(this, props);
	
	    _defineProperty(_assertThisInitialized(_this), "storeInputReference", function (input) {
	      if (input !== null) {
	        _this.input = input;
	      }
	
	      var userRef = _this.props.inputProps.ref;
	
	      if (userRef) {
	        if (typeof userRef === 'function') {
	          userRef(input);
	        } else if (_typeof(userRef) === 'object' && Object.prototype.hasOwnProperty.call(userRef, 'current')) {
	          userRef.current = input;
	        }
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "storeItemsContainerReference", function (itemsContainer) {
	      if (itemsContainer !== null) {
	        _this.itemsContainer = itemsContainer;
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onHighlightedItemChange", function (highlightedItem) {
	      _this.highlightedItem = highlightedItem;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "getItemId", function (sectionIndex, itemIndex) {
	      if (itemIndex === null) {
	        return null;
	      }
	
	      var id = _this.props.id;
	      var section = sectionIndex === null ? '' : "section-".concat(sectionIndex);
	      return "react-autowhatever-".concat(id, "-").concat(section, "-item-").concat(itemIndex);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onFocus", function (event) {
	      var inputProps = _this.props.inputProps;
	
	      _this.setState({
	        isInputFocused: true
	      });
	
	      inputProps.onFocus && inputProps.onFocus(event);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onBlur", function (event) {
	      var inputProps = _this.props.inputProps;
	
	      _this.setState({
	        isInputFocused: false
	      });
	
	      inputProps.onBlur && inputProps.onBlur(event);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onKeyDown", function (event) {
	      var _this$props = _this.props,
	          inputProps = _this$props.inputProps,
	          highlightedSectionIndex = _this$props.highlightedSectionIndex,
	          highlightedItemIndex = _this$props.highlightedItemIndex;
	      var keyCode = event.keyCode;
	
	      switch (keyCode) {
	        case 40: // ArrowDown
	
	        case 38:
	          {
	            // ArrowUp
	            var nextPrev = keyCode === 40 ? 'next' : 'prev';
	
	            var _this$sectionIterator = _this.sectionIterator[nextPrev]([highlightedSectionIndex, highlightedItemIndex]),
	                _this$sectionIterator2 = _slicedToArray(_this$sectionIterator, 2),
	                newHighlightedSectionIndex = _this$sectionIterator2[0],
	                newHighlightedItemIndex = _this$sectionIterator2[1];
	
	            inputProps.onKeyDown(event, {
	              newHighlightedSectionIndex: newHighlightedSectionIndex,
	              newHighlightedItemIndex: newHighlightedItemIndex
	            });
	            break;
	          }
	
	        default:
	          inputProps.onKeyDown(event, {
	            highlightedSectionIndex: highlightedSectionIndex,
	            highlightedItemIndex: highlightedItemIndex
	          });
	      }
	    });
	
	    _this.highlightedItem = null;
	    _this.state = {
	      isInputFocused: false
	    };
	
	    _this.setSectionsItems(props);
	
	    _this.setSectionIterator(props);
	
	    _this.setTheme(props);
	
	    return _this;
	  }
	
	  _createClass(Autowhatever, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.ensureHighlightedItemIsVisible();
	    } // eslint-disable-next-line camelcase, react/sort-comp
	
	  }, {
	    key: "UNSAFE_componentWillReceiveProps",
	    value: function UNSAFE_componentWillReceiveProps(nextProps) {
	      if (nextProps.items !== this.props.items) {
	        this.setSectionsItems(nextProps);
	      }
	
	      if (nextProps.items !== this.props.items || nextProps.multiSection !== this.props.multiSection) {
	        this.setSectionIterator(nextProps);
	      }
	
	      if (nextProps.theme !== this.props.theme) {
	        this.setTheme(nextProps);
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      this.ensureHighlightedItemIsVisible();
	    }
	  }, {
	    key: "setSectionsItems",
	    value: function setSectionsItems(props) {
	      if (props.multiSection) {
	        this.sectionsItems = props.items.map(function (section) {
	          return props.getSectionItems(section);
	        });
	        this.sectionsLengths = this.sectionsItems.map(function (items) {
	          return items.length;
	        });
	        this.allSectionsAreEmpty = this.sectionsLengths.every(function (itemsCount) {
	          return itemsCount === 0;
	        });
	      }
	    }
	  }, {
	    key: "setSectionIterator",
	    value: function setSectionIterator(props) {
	      this.sectionIterator = (0, _sectionIterator["default"])({
	        multiSection: props.multiSection,
	        data: props.multiSection ? this.sectionsLengths : props.items.length
	      });
	    }
	  }, {
	    key: "setTheme",
	    value: function setTheme(props) {
	      this.theme = (0, _reactThemeable["default"])(props.theme);
	    }
	  }, {
	    key: "renderSections",
	    value: function renderSections() {
	      var _this2 = this;
	
	      if (this.allSectionsAreEmpty) {
	        return null;
	      }
	
	      var theme = this.theme;
	      var _this$props2 = this.props,
	          id = _this$props2.id,
	          items = _this$props2.items,
	          renderItem = _this$props2.renderItem,
	          renderItemData = _this$props2.renderItemData,
	          renderSectionTitle = _this$props2.renderSectionTitle,
	          highlightedSectionIndex = _this$props2.highlightedSectionIndex,
	          highlightedItemIndex = _this$props2.highlightedItemIndex,
	          itemProps = _this$props2.itemProps;
	      return items.map(function (section, sectionIndex) {
	        var keyPrefix = "react-autowhatever-".concat(id, "-");
	        var sectionKeyPrefix = "".concat(keyPrefix, "section-").concat(sectionIndex, "-");
	        var isFirstSection = sectionIndex === 0; // `key` is provided by theme()
	
	        /* eslint-disable react/jsx-key */
	
	        return /*#__PURE__*/_react["default"].createElement("div", theme("".concat(sectionKeyPrefix, "container"), 'sectionContainer', isFirstSection && 'sectionContainerFirst'), /*#__PURE__*/_react["default"].createElement(_SectionTitle["default"], {
	          section: section,
	          renderSectionTitle: renderSectionTitle,
	          theme: theme,
	          sectionKeyPrefix: sectionKeyPrefix
	        }), /*#__PURE__*/_react["default"].createElement(_ItemList["default"], {
	          items: _this2.sectionsItems[sectionIndex],
	          itemProps: itemProps,
	          renderItem: renderItem,
	          renderItemData: renderItemData,
	          sectionIndex: sectionIndex,
	          highlightedItemIndex: highlightedSectionIndex === sectionIndex ? highlightedItemIndex : null,
	          onHighlightedItemChange: _this2.onHighlightedItemChange,
	          getItemId: _this2.getItemId,
	          theme: theme,
	          keyPrefix: keyPrefix,
	          ref: _this2.storeItemsListReference
	        }));
	        /* eslint-enable react/jsx-key */
	      });
	    }
	  }, {
	    key: "renderItems",
	    value: function renderItems() {
	      var items = this.props.items;
	
	      if (items.length === 0) {
	        return null;
	      }
	
	      var theme = this.theme;
	      var _this$props3 = this.props,
	          id = _this$props3.id,
	          renderItem = _this$props3.renderItem,
	          renderItemData = _this$props3.renderItemData,
	          highlightedSectionIndex = _this$props3.highlightedSectionIndex,
	          highlightedItemIndex = _this$props3.highlightedItemIndex,
	          itemProps = _this$props3.itemProps;
	      return /*#__PURE__*/_react["default"].createElement(_ItemList["default"], {
	        items: items,
	        itemProps: itemProps,
	        renderItem: renderItem,
	        renderItemData: renderItemData,
	        highlightedItemIndex: highlightedSectionIndex === null ? highlightedItemIndex : null,
	        onHighlightedItemChange: this.onHighlightedItemChange,
	        getItemId: this.getItemId,
	        theme: theme,
	        keyPrefix: "react-autowhatever-".concat(id, "-")
	      });
	    }
	  }, {
	    key: "ensureHighlightedItemIsVisible",
	    value: function ensureHighlightedItemIsVisible() {
	      var highlightedItem = this.highlightedItem;
	
	      if (!highlightedItem) {
	        return;
	      }
	
	      var itemsContainer = this.itemsContainer;
	      var itemOffsetRelativeToContainer = highlightedItem.offsetParent === itemsContainer ? highlightedItem.offsetTop : highlightedItem.offsetTop - itemsContainer.offsetTop;
	      var scrollTop = itemsContainer.scrollTop; // Top of the visible area
	
	      if (itemOffsetRelativeToContainer < scrollTop) {
	        // Item is off the top of the visible area
	        scrollTop = itemOffsetRelativeToContainer;
	      } else if (itemOffsetRelativeToContainer + highlightedItem.offsetHeight > scrollTop + itemsContainer.offsetHeight) {
	        // Item is off the bottom of the visible area
	        scrollTop = itemOffsetRelativeToContainer + highlightedItem.offsetHeight - itemsContainer.offsetHeight;
	      }
	
	      if (scrollTop !== itemsContainer.scrollTop) {
	        itemsContainer.scrollTop = scrollTop;
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var theme = this.theme;
	      var _this$props4 = this.props,
	          id = _this$props4.id,
	          multiSection = _this$props4.multiSection,
	          renderInputComponent = _this$props4.renderInputComponent,
	          renderItemsContainer = _this$props4.renderItemsContainer,
	          highlightedSectionIndex = _this$props4.highlightedSectionIndex,
	          highlightedItemIndex = _this$props4.highlightedItemIndex;
	      var isInputFocused = this.state.isInputFocused;
	      var renderedItems = multiSection ? this.renderSections() : this.renderItems();
	      var isOpen = renderedItems !== null;
	      var ariaActivedescendant = this.getItemId(highlightedSectionIndex, highlightedItemIndex);
	      var itemsContainerId = "react-autowhatever-".concat(id);
	
	      var containerProps = _objectSpread({
	        role: 'combobox',
	        'aria-haspopup': 'listbox',
	        'aria-owns': itemsContainerId,
	        'aria-expanded': isOpen
	      }, theme("react-autowhatever-".concat(id, "-container"), 'container', isOpen && 'containerOpen'), {}, this.props.containerProps);
	
	      var inputComponent = renderInputComponent(_objectSpread({
	        type: 'text',
	        value: '',
	        autoComplete: 'off',
	        'aria-autocomplete': 'list',
	        'aria-controls': itemsContainerId,
	        'aria-activedescendant': ariaActivedescendant
	      }, theme("react-autowhatever-".concat(id, "-input"), 'input', isOpen && 'inputOpen', isInputFocused && 'inputFocused'), {}, this.props.inputProps, {
	        onFocus: this.onFocus,
	        onBlur: this.onBlur,
	        onKeyDown: this.props.inputProps.onKeyDown && this.onKeyDown,
	        ref: this.storeInputReference
	      }));
	      var itemsContainer = renderItemsContainer({
	        containerProps: _objectSpread({
	          id: itemsContainerId,
	          role: 'listbox'
	        }, theme("react-autowhatever-".concat(id, "-items-container"), 'itemsContainer', isOpen && 'itemsContainerOpen'), {
	          ref: this.storeItemsContainerReference
	        }),
	        children: renderedItems
	      });
	      return /*#__PURE__*/_react["default"].createElement("div", containerProps, inputComponent, itemsContainer);
	    }
	  }]);
	
	  return Autowhatever;
	}(_react.Component);
	
	exports["default"] = Autowhatever;
	
	_defineProperty(Autowhatever, "propTypes", {
	  id: _propTypes["default"].string,
	  // Used in aria-* attributes. If multiple Autowhatever's are rendered on a page, they must have unique ids.
	  multiSection: _propTypes["default"].bool,
	  // Indicates whether a multi section layout should be rendered.
	  renderInputComponent: _propTypes["default"].func,
	  // When specified, it is used to render the input element.
	  renderItemsContainer: _propTypes["default"].func,
	  // Renders the items container.
	  items: _propTypes["default"].array.isRequired,
	  // Array of items or sections to render.
	  renderItem: _propTypes["default"].func,
	  // This function renders a single item.
	  renderItemData: _propTypes["default"].object,
	  // Arbitrary data that will be passed to renderItem()
	  renderSectionTitle: _propTypes["default"].func,
	  // This function gets a section and renders its title.
	  getSectionItems: _propTypes["default"].func,
	  // This function gets a section and returns its items, which will be passed into `renderItem` for rendering.
	  containerProps: _propTypes["default"].object,
	  // Arbitrary container props
	  inputProps: _propTypes["default"].object,
	  // Arbitrary input props
	  itemProps: _propTypes["default"].oneOfType([// Arbitrary item props
	  _propTypes["default"].object, _propTypes["default"].func]),
	  highlightedSectionIndex: _propTypes["default"].number,
	  // Section index of the highlighted item
	  highlightedItemIndex: _propTypes["default"].number,
	  // Highlighted item index (within a section)
	  theme: _propTypes["default"].oneOfType([// Styles. See: https://github.com/markdalgleish/react-themeable
	  _propTypes["default"].object, _propTypes["default"].array])
	});
	
	_defineProperty(Autowhatever, "defaultProps", {
	  id: '1',
	  multiSection: false,
	  renderInputComponent: defaultRenderInputComponent,
	  renderItemsContainer: defaultRenderItemsContainer,
	  renderItem: function renderItem() {
	    throw new Error('`renderItem` must be provided');
	  },
	  renderItemData: emptyObject,
	  renderSectionTitle: function renderSectionTitle() {
	    throw new Error('`renderSectionTitle` must be provided');
	  },
	  getSectionItems: function getSectionItems() {
	    throw new Error('`getSectionItems` must be provided');
	  },
	  containerProps: emptyObject,
	  inputProps: emptyObject,
	  itemProps: emptyObject,
	  highlightedSectionIndex: null,
	  highlightedItemIndex: null,
	  theme: defaultTheme
	});

/***/ },
/* 1370 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _compareObjects = _interopRequireDefault(__webpack_require__(278));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var Item = /*#__PURE__*/function (_Component) {
	  _inherits(Item, _Component);
	
	  var _super = _createSuper(Item);
	
	  function Item() {
	    var _this;
	
	    _classCallCheck(this, Item);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _super.call.apply(_super, [this].concat(args));
	
	    _defineProperty(_assertThisInitialized(_this), "storeItemReference", function (item) {
	      if (item !== null) {
	        _this.item = item;
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onMouseEnter", function (event) {
	      var _this$props = _this.props,
	          sectionIndex = _this$props.sectionIndex,
	          itemIndex = _this$props.itemIndex;
	
	      _this.props.onMouseEnter(event, {
	        sectionIndex: sectionIndex,
	        itemIndex: itemIndex
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onMouseLeave", function (event) {
	      var _this$props2 = _this.props,
	          sectionIndex = _this$props2.sectionIndex,
	          itemIndex = _this$props2.itemIndex;
	
	      _this.props.onMouseLeave(event, {
	        sectionIndex: sectionIndex,
	        itemIndex: itemIndex
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onMouseDown", function (event) {
	      var _this$props3 = _this.props,
	          sectionIndex = _this$props3.sectionIndex,
	          itemIndex = _this$props3.itemIndex;
	
	      _this.props.onMouseDown(event, {
	        sectionIndex: sectionIndex,
	        itemIndex: itemIndex
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onClick", function (event) {
	      var _this$props4 = _this.props,
	          sectionIndex = _this$props4.sectionIndex,
	          itemIndex = _this$props4.itemIndex;
	
	      _this.props.onClick(event, {
	        sectionIndex: sectionIndex,
	        itemIndex: itemIndex
	      });
	    });
	
	    return _this;
	  }
	
	  _createClass(Item, [{
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps) {
	      return (0, _compareObjects["default"])(nextProps, this.props, ['renderItemData']);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props5 = this.props,
	          isHighlighted = _this$props5.isHighlighted,
	          item = _this$props5.item,
	          renderItem = _this$props5.renderItem,
	          renderItemData = _this$props5.renderItemData,
	          restProps = _objectWithoutProperties(_this$props5, ["isHighlighted", "item", "renderItem", "renderItemData"]);
	
	      delete restProps.sectionIndex;
	      delete restProps.itemIndex;
	
	      if (typeof restProps.onMouseEnter === 'function') {
	        restProps.onMouseEnter = this.onMouseEnter;
	      }
	
	      if (typeof restProps.onMouseLeave === 'function') {
	        restProps.onMouseLeave = this.onMouseLeave;
	      }
	
	      if (typeof restProps.onMouseDown === 'function') {
	        restProps.onMouseDown = this.onMouseDown;
	      }
	
	      if (typeof restProps.onClick === 'function') {
	        restProps.onClick = this.onClick;
	      }
	
	      return /*#__PURE__*/_react["default"].createElement("li", _extends({
	        role: "option"
	      }, restProps, {
	        ref: this.storeItemReference
	      }), renderItem(item, _objectSpread({
	        isHighlighted: isHighlighted
	      }, renderItemData)));
	    }
	  }]);
	
	  return Item;
	}(_react.Component);
	
	exports["default"] = Item;
	
	_defineProperty(Item, "propTypes", {
	  sectionIndex: _propTypes["default"].number,
	  isHighlighted: _propTypes["default"].bool.isRequired,
	  itemIndex: _propTypes["default"].number.isRequired,
	  item: _propTypes["default"].any.isRequired,
	  renderItem: _propTypes["default"].func.isRequired,
	  renderItemData: _propTypes["default"].object.isRequired,
	  onMouseEnter: _propTypes["default"].func,
	  onMouseLeave: _propTypes["default"].func,
	  onMouseDown: _propTypes["default"].func,
	  onClick: _propTypes["default"].func
	});

/***/ },
/* 1371 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _Item = _interopRequireDefault(__webpack_require__(1370));
	
	var _compareObjects = _interopRequireDefault(__webpack_require__(278));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var ItemsList = /*#__PURE__*/function (_Component) {
	  _inherits(ItemsList, _Component);
	
	  var _super = _createSuper(ItemsList);
	
	  function ItemsList() {
	    var _this;
	
	    _classCallCheck(this, ItemsList);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _super.call.apply(_super, [this].concat(args));
	
	    _defineProperty(_assertThisInitialized(_this), "storeHighlightedItemReference", function (highlightedItem) {
	      _this.props.onHighlightedItemChange(highlightedItem === null ? null : highlightedItem.item);
	    });
	
	    return _this;
	  }
	
	  _createClass(ItemsList, [{
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps) {
	      return (0, _compareObjects["default"])(nextProps, this.props, ['itemProps']);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _this$props = this.props,
	          items = _this$props.items,
	          itemProps = _this$props.itemProps,
	          renderItem = _this$props.renderItem,
	          renderItemData = _this$props.renderItemData,
	          sectionIndex = _this$props.sectionIndex,
	          highlightedItemIndex = _this$props.highlightedItemIndex,
	          getItemId = _this$props.getItemId,
	          theme = _this$props.theme,
	          keyPrefix = _this$props.keyPrefix;
	      var sectionPrefix = sectionIndex === null ? keyPrefix : "".concat(keyPrefix, "section-").concat(sectionIndex, "-");
	      var isItemPropsFunction = typeof itemProps === 'function';
	      return /*#__PURE__*/_react["default"].createElement("ul", _extends({
	        role: "listbox"
	      }, theme("".concat(sectionPrefix, "items-list"), 'itemsList')), items.map(function (item, itemIndex) {
	        var isFirst = itemIndex === 0;
	        var isHighlighted = itemIndex === highlightedItemIndex;
	        var itemKey = "".concat(sectionPrefix, "item-").concat(itemIndex);
	        var itemPropsObj = isItemPropsFunction ? itemProps({
	          sectionIndex: sectionIndex,
	          itemIndex: itemIndex
	        }) : itemProps;
	
	        var allItemProps = _objectSpread({
	          id: getItemId(sectionIndex, itemIndex),
	          'aria-selected': isHighlighted
	        }, theme(itemKey, 'item', isFirst && 'itemFirst', isHighlighted && 'itemHighlighted'), {}, itemPropsObj);
	
	        if (isHighlighted) {
	          allItemProps.ref = _this2.storeHighlightedItemReference;
	        } // `key` is provided by theme()
	
	        /* eslint-disable react/jsx-key */
	
	
	        return /*#__PURE__*/_react["default"].createElement(_Item["default"], _extends({}, allItemProps, {
	          sectionIndex: sectionIndex,
	          isHighlighted: isHighlighted,
	          itemIndex: itemIndex,
	          item: item,
	          renderItem: renderItem,
	          renderItemData: renderItemData
	        }));
	        /* eslint-enable react/jsx-key */
	      }));
	    }
	  }]);
	
	  return ItemsList;
	}(_react.Component);
	
	exports["default"] = ItemsList;
	
	_defineProperty(ItemsList, "propTypes", {
	  items: _propTypes["default"].array.isRequired,
	  itemProps: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].func]),
	  renderItem: _propTypes["default"].func.isRequired,
	  renderItemData: _propTypes["default"].object.isRequired,
	  sectionIndex: _propTypes["default"].number,
	  highlightedItemIndex: _propTypes["default"].number,
	  onHighlightedItemChange: _propTypes["default"].func.isRequired,
	  getItemId: _propTypes["default"].func.isRequired,
	  theme: _propTypes["default"].func.isRequired,
	  keyPrefix: _propTypes["default"].string.isRequired
	});
	
	_defineProperty(ItemsList, "defaultProps", {
	  sectionIndex: null
	});

/***/ },
/* 1372 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _compareObjects = _interopRequireDefault(__webpack_require__(278));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var SectionTitle = /*#__PURE__*/function (_Component) {
	  _inherits(SectionTitle, _Component);
	
	  var _super = _createSuper(SectionTitle);
	
	  function SectionTitle() {
	    _classCallCheck(this, SectionTitle);
	
	    return _super.apply(this, arguments);
	  }
	
	  _createClass(SectionTitle, [{
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps) {
	      return (0, _compareObjects["default"])(nextProps, this.props);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          section = _this$props.section,
	          renderSectionTitle = _this$props.renderSectionTitle,
	          theme = _this$props.theme,
	          sectionKeyPrefix = _this$props.sectionKeyPrefix;
	      var sectionTitle = renderSectionTitle(section);
	
	      if (!sectionTitle) {
	        return null;
	      }
	
	      return /*#__PURE__*/_react["default"].createElement("div", theme("".concat(sectionKeyPrefix, "title"), 'sectionTitle'), sectionTitle);
	    }
	  }]);
	
	  return SectionTitle;
	}(_react.Component);
	
	exports["default"] = SectionTitle;
	
	_defineProperty(SectionTitle, "propTypes", {
	  section: _propTypes["default"].any.isRequired,
	  renderSectionTitle: _propTypes["default"].func.isRequired,
	  theme: _propTypes["default"].func.isRequired,
	  sectionKeyPrefix: _propTypes["default"].string.isRequired
	});

/***/ },
/* 1373 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.mapToAutowhateverTheme = exports.defaultTheme = void 0;
	var defaultTheme = {
	  container: 'react-autosuggest__container',
	  containerOpen: 'react-autosuggest__container--open',
	  input: 'react-autosuggest__input',
	  inputOpen: 'react-autosuggest__input--open',
	  inputFocused: 'react-autosuggest__input--focused',
	  suggestionsContainer: 'react-autosuggest__suggestions-container',
	  suggestionsContainerOpen: 'react-autosuggest__suggestions-container--open',
	  suggestionsList: 'react-autosuggest__suggestions-list',
	  suggestion: 'react-autosuggest__suggestion',
	  suggestionFirst: 'react-autosuggest__suggestion--first',
	  suggestionHighlighted: 'react-autosuggest__suggestion--highlighted',
	  sectionContainer: 'react-autosuggest__section-container',
	  sectionContainerFirst: 'react-autosuggest__section-container--first',
	  sectionTitle: 'react-autosuggest__section-title'
	};
	exports.defaultTheme = defaultTheme;
	
	var mapToAutowhateverTheme = function mapToAutowhateverTheme(theme) {
	  var result = {};
	
	  for (var key in theme) {
	    switch (key) {
	      case 'suggestionsContainer':
	        result['itemsContainer'] = theme[key];
	        break;
	
	      case 'suggestionsContainerOpen':
	        result['itemsContainerOpen'] = theme[key];
	        break;
	
	      case 'suggestion':
	        result['item'] = theme[key];
	        break;
	
	      case 'suggestionFirst':
	        result['itemFirst'] = theme[key];
	        break;
	
	      case 'suggestionHighlighted':
	        result['itemHighlighted'] = theme[key];
	        break;
	
	      case 'suggestionsList':
	        result['itemsList'] = theme[key];
	        break;
	
	      default:
	        result[key] = theme[key];
	    }
	  }
	
	  return result;
	};
	
	exports.mapToAutowhateverTheme = mapToAutowhateverTheme;

/***/ },
/* 1374 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.noop = noop;
	exports.returnTrue = returnTrue;
	exports.charIsNumber = charIsNumber;
	exports.escapeRegExp = escapeRegExp;
	exports.fixLeadingZero = fixLeadingZero;
	exports.splitString = splitString;
	exports.limitToScale = limitToScale;
	exports.roundToPrecision = roundToPrecision;
	exports.omit = omit;
	exports.setCaretPosition = setCaretPosition;
	
	
	// basic noop function
	function noop() {}
	function returnTrue() {
	  return true;
	}
	
	function charIsNumber(char) {
	  return !!(char || '').match(/\d/);
	}
	
	function escapeRegExp(str) {
	  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
	}
	
	function fixLeadingZero(numStr) {
	  if (!numStr) return numStr;
	  var isNegative = numStr[0] === '-';
	  if (isNegative) numStr = numStr.substring(1, numStr.length);
	  var parts = numStr.split('.');
	  var beforeDecimal = parts[0].replace(/^0+/, '') || '0';
	  var afterDecimal = parts[1] || '';
	
	  return '' + (isNegative ? '-' : '') + beforeDecimal + (afterDecimal ? '.' + afterDecimal : '');
	}
	
	function splitString(str, index) {
	  return [str.substring(0, index), str.substring(index)];
	}
	
	/**
	 * limit decimal numbers to given scale
	 * Not used .fixedTo because that will break with big numbers
	 */
	function limitToScale(numStr, scale, fixedDecimalScale) {
	  var str = '';
	  var filler = fixedDecimalScale ? '0' : '';
	  for (var i = 0; i <= scale - 1; i++) {
	    str += numStr[i] || filler;
	  }
	  return str;
	}
	
	/**
	 * This method is required to round prop value to given scale.
	 * Not used .round or .fixedTo because that will break with big numbers
	 */
	function roundToPrecision(numStr, scale, fixedDecimalScale) {
	  var numberParts = numStr.split('.');
	  var roundedDecimalParts = parseFloat('0.' + (numberParts[1] || '0')).toFixed(scale).split('.');
	  var intPart = numberParts[0].split('').reverse().reduce(function (roundedStr, current, idx) {
	    if (roundedStr.length > idx) {
	      return (Number(roundedStr[0]) + Number(current)).toString() + roundedStr.substring(1, roundedStr.length);
	    }
	    return current + roundedStr;
	  }, roundedDecimalParts[0]);
	
	  var decimalPart = limitToScale(roundedDecimalParts[1] || '', (numberParts[1] || '').length, fixedDecimalScale);
	
	  return intPart + (decimalPart ? '.' + decimalPart : '');
	}
	
	function omit(obj, keyMaps) {
	  var filteredObj = {};
	  Object.keys(obj).forEach(function (key) {
	    if (!keyMaps[key]) filteredObj[key] = obj[key];
	  });
	  return filteredObj;
	}
	
	/** set the caret positon in an input field **/
	function setCaretPosition(el, caretPos) {
	  el.value = el.value;
	  // ^ this is used to not only get "focus", but
	  // to make sure we don't have it everything -selected-
	  // (it causes an issue in chrome, and having it doesn't hurt any other browser)
	  if (el !== null) {
	    if (el.createTextRange) {
	      var range = el.createTextRange();
	      range.move('character', caretPos);
	      range.select();
	      return true;
	    }
	    // (el.selectionStart === 0 added for Firefox bug)
	    if (el.selectionStart || el.selectionStart === 0) {
	      el.focus();
	      el.setSelectionRange(caretPos, caretPos);
	      return true;
	    }
	
	    // fail city, fortunately this never happens (as far as I've tested) :)
	    el.focus();
	    return false;
	  }
	}
	
	var thousandGroupSpacing = exports.thousandGroupSpacing = {
	  two: '2',
	  twoScaled: '2s',
	  three: '3',
	  four: '4'
	};

/***/ },
/* 1375 */
/***/ function(module, exports, __webpack_require__) {

	/** @license React v16.14.0
	 * react-dom-server.browser.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var k=__webpack_require__(58),l=__webpack_require__(1);function q(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
	var t="function"===typeof Symbol&&Symbol.for,aa=t?Symbol.for("react.portal"):60106,u=t?Symbol.for("react.fragment"):60107,ba=t?Symbol.for("react.strict_mode"):60108,ca=t?Symbol.for("react.profiler"):60114,v=t?Symbol.for("react.provider"):60109,da=t?Symbol.for("react.context"):60110,ea=t?Symbol.for("react.concurrent_mode"):60111,fa=t?Symbol.for("react.forward_ref"):60112,B=t?Symbol.for("react.suspense"):60113,ha=t?Symbol.for("react.suspense_list"):60120,ia=t?Symbol.for("react.memo"):60115,ja=t?Symbol.for("react.lazy"):
	60116,ka=t?Symbol.for("react.block"):60121,la=t?Symbol.for("react.fundamental"):60117,ma=t?Symbol.for("react.scope"):60119;function na(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(c){0===a._status&&(c=c.default,a._status=1,a._result=c)},function(c){0===a._status&&(a._status=2,a._result=c)})}}
	function C(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case u:return"Fragment";case aa:return"Portal";case ca:return"Profiler";case ba:return"StrictMode";case B:return"Suspense";case ha:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case da:return"Context.Consumer";case v:return"Context.Provider";case fa:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":"ForwardRef");
	case ia:return C(a.type);case ka:return C(a.render);case ja:if(a=1===a._status?a._result:null)return C(a)}return null}var D=l.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;D.hasOwnProperty("ReactCurrentDispatcher")||(D.ReactCurrentDispatcher={current:null});D.hasOwnProperty("ReactCurrentBatchConfig")||(D.ReactCurrentBatchConfig={suspense:null});var oa={};function E(a,b){for(var c=a._threadCount|0;c<=b;c++)a[c]=a._currentValue2,a._threadCount=c+1}
	function pa(a,b,c,d){if(d&&(d=a.contextType,"object"===typeof d&&null!==d))return E(d,c),d[c];if(a=a.contextTypes){c={};for(var f in a)c[f]=b[f];b=c}else b=oa;return b}for(var F=new Uint16Array(16),H=0;15>H;H++)F[H]=H+1;F[15]=0;
	var qa=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,ra=Object.prototype.hasOwnProperty,sa={},ta={};
	function ua(a){if(ra.call(ta,a))return!0;if(ra.call(sa,a))return!1;if(qa.test(a))return ta[a]=!0;sa[a]=!0;return!1}function va(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
	function wa(a,b,c,d){if(null===b||"undefined"===typeof b||va(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function J(a,b,c,d,f,g){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=f;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=g}var K={};
	"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){K[a]=new J(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];K[b]=new J(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){K[a]=new J(a,2,!1,a.toLowerCase(),null,!1)});
	["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){K[a]=new J(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){K[a]=new J(a,3,!1,a.toLowerCase(),null,!1)});
	["checked","multiple","muted","selected"].forEach(function(a){K[a]=new J(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){K[a]=new J(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){K[a]=new J(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){K[a]=new J(a,5,!1,a.toLowerCase(),null,!1)});var L=/[\-:]([a-z])/g;function M(a){return a[1].toUpperCase()}
	"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(L,
	M);K[b]=new J(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(L,M);K[b]=new J(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(L,M);K[b]=new J(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){K[a]=new J(a,1,!1,a.toLowerCase(),null,!1)});
	K.xlinkHref=new J("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){K[a]=new J(a,1,!1,a.toLowerCase(),null,!0)});var xa=/["'&<>]/;
	function N(a){if("boolean"===typeof a||"number"===typeof a)return""+a;a=""+a;var b=xa.exec(a);if(b){var c="",d,f=0;for(d=b.index;d<a.length;d++){switch(a.charCodeAt(d)){case 34:b="&quot;";break;case 38:b="&amp;";break;case 39:b="&#x27;";break;case 60:b="&lt;";break;case 62:b="&gt;";break;default:continue}f!==d&&(c+=a.substring(f,d));f=d+1;c+=b}a=f!==d?c+a.substring(f,d):c}return a}
	function ya(a,b){var c=K.hasOwnProperty(a)?K[a]:null;var d;if(d="style"!==a)d=null!==c?0===c.type:!(2<a.length)||"o"!==a[0]&&"O"!==a[0]||"n"!==a[1]&&"N"!==a[1]?!1:!0;if(d||wa(a,b,c,!1))return"";if(null!==c){a=c.attributeName;d=c.type;if(3===d||4===d&&!0===b)return a+'=""';c.sanitizeURL&&(b=""+b);return a+'="'+(N(b)+'"')}return ua(a)?a+'="'+(N(b)+'"'):""}function za(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}
	var Aa="function"===typeof Object.is?Object.is:za,O=null,P=null,Q=null,R=!1,S=!1,U=null,V=0;function W(){if(null===O)throw Error(q(321));return O}function Ba(){if(0<V)throw Error(q(312));return{memoizedState:null,queue:null,next:null}}function Ca(){null===Q?null===P?(R=!1,P=Q=Ba()):(R=!0,Q=P):null===Q.next?(R=!1,Q=Q.next=Ba()):(R=!0,Q=Q.next);return Q}function Da(a,b,c,d){for(;S;)S=!1,V+=1,Q=null,c=a(b,d);P=O=null;V=0;Q=U=null;return c}function Ea(a,b){return"function"===typeof b?b(a):b}
	function Fa(a,b,c){O=W();Q=Ca();if(R){var d=Q.queue;b=d.dispatch;if(null!==U&&(c=U.get(d),void 0!==c)){U.delete(d);d=Q.memoizedState;do d=a(d,c.action),c=c.next;while(null!==c);Q.memoizedState=d;return[d,b]}return[Q.memoizedState,b]}a=a===Ea?"function"===typeof b?b():b:void 0!==c?c(b):b;Q.memoizedState=a;a=Q.queue={last:null,dispatch:null};a=a.dispatch=Ga.bind(null,O,a);return[Q.memoizedState,a]}
	function Ga(a,b,c){if(!(25>V))throw Error(q(301));if(a===O)if(S=!0,a={action:c,next:null},null===U&&(U=new Map),c=U.get(b),void 0===c)U.set(b,a);else{for(b=c;null!==b.next;)b=b.next;b.next=a}}function Ha(){}
	var X=0,Ia={readContext:function(a){var b=X;E(a,b);return a[b]},useContext:function(a){W();var b=X;E(a,b);return a[b]},useMemo:function(a,b){O=W();Q=Ca();b=void 0===b?null:b;if(null!==Q){var c=Q.memoizedState;if(null!==c&&null!==b){a:{var d=c[1];if(null===d)d=!1;else{for(var f=0;f<d.length&&f<b.length;f++)if(!Aa(b[f],d[f])){d=!1;break a}d=!0}}if(d)return c[0]}}a=a();Q.memoizedState=[a,b];return a},useReducer:Fa,useRef:function(a){O=W();Q=Ca();var b=Q.memoizedState;return null===b?(a={current:a},Q.memoizedState=
	a):b},useState:function(a){return Fa(Ea,a)},useLayoutEffect:function(){},useCallback:function(a){return a},useImperativeHandle:Ha,useEffect:Ha,useDebugValue:Ha,useResponder:function(a,b){return{props:b,responder:a}},useDeferredValue:function(a){W();return a},useTransition:function(){W();return[function(a){a()},!1]}},Ja={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
	function Ka(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}
	var La={area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0},Ma=k({menuitem:!0},La),Y={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,
	gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},Na=["Webkit","ms","Moz","O"];Object.keys(Y).forEach(function(a){Na.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);Y[b]=Y[a]})});
	var Oa=/([A-Z])/g,Pa=/^ms-/,Z=l.Children.toArray,Qa=D.ReactCurrentDispatcher,Ra={listing:!0,pre:!0,textarea:!0},Sa=/^[a-zA-Z][a-zA-Z:_\.\-\d]*$/,Ta={},Ua={};function Va(a){if(void 0===a||null===a)return a;var b="";l.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}var Wa=Object.prototype.hasOwnProperty,Xa={children:null,dangerouslySetInnerHTML:null,suppressContentEditableWarning:null,suppressHydrationWarning:null};function Ya(a,b){if(void 0===a)throw Error(q(152,C(b)||"Component"));}
	function Za(a,b,c){function d(d,g){var e=g.prototype&&g.prototype.isReactComponent,f=pa(g,b,c,e),x=[],h=!1,m={isMounted:function(){return!1},enqueueForceUpdate:function(){if(null===x)return null},enqueueReplaceState:function(a,c){h=!0;x=[c]},enqueueSetState:function(a,c){if(null===x)return null;x.push(c)}};if(e){if(e=new g(d.props,f,m),"function"===typeof g.getDerivedStateFromProps){var w=g.getDerivedStateFromProps.call(null,d.props,e.state);null!=w&&(e.state=k({},e.state,w))}}else if(O={},e=g(d.props,
	f,m),e=Da(g,d.props,e,f),null==e||null==e.render){a=e;Ya(a,g);return}e.props=d.props;e.context=f;e.updater=m;m=e.state;void 0===m&&(e.state=m=null);if("function"===typeof e.UNSAFE_componentWillMount||"function"===typeof e.componentWillMount)if("function"===typeof e.componentWillMount&&"function"!==typeof g.getDerivedStateFromProps&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&"function"!==typeof g.getDerivedStateFromProps&&e.UNSAFE_componentWillMount(),x.length){m=x;var r=
	h;x=null;h=!1;if(r&&1===m.length)e.state=m[0];else{w=r?m[0]:e.state;var y=!0;for(r=r?1:0;r<m.length;r++){var p=m[r];p="function"===typeof p?p.call(e,w,d.props,f):p;null!=p&&(y?(y=!1,w=k({},w,p)):k(w,p))}e.state=w}}else x=null;a=e.render();Ya(a,g);if("function"===typeof e.getChildContext&&(d=g.childContextTypes,"object"===typeof d)){var A=e.getChildContext();for(var T in A)if(!(T in d))throw Error(q(108,C(g)||"Unknown",T));}A&&(b=k({},b,A))}for(;l.isValidElement(a);){var f=a,g=f.type;if("function"!==
	typeof g)break;d(f,g)}return{child:a,context:b}}
	var $a=function(){function a(a,b){l.isValidElement(a)?a.type!==u?a=[a]:(a=a.props.children,a=l.isValidElement(a)?[a]:Z(a)):a=Z(a);a={type:null,domNamespace:Ja.html,children:a,childIndex:0,context:oa,footer:""};var c=F[0];if(0===c){var g=F;c=g.length;var d=2*c;if(!(65536>=d))throw Error(q(304));var h=new Uint16Array(d);h.set(g);F=h;F[0]=c+1;for(g=c;g<d-1;g++)F[g]=g+1;F[d-1]=0}else F[0]=F[c];this.threadID=c;this.stack=[a];this.exhausted=!1;this.currentSelectValue=null;this.previousWasTextNode=!1;this.makeStaticMarkup=
	b;this.suspenseDepth=0;this.contextIndex=-1;this.contextStack=[];this.contextValueStack=[]}var b=a.prototype;b.destroy=function(){if(!this.exhausted){this.exhausted=!0;this.clearProviders();var a=this.threadID;F[a]=F[0];F[0]=a}};b.pushProvider=function(a){var c=++this.contextIndex,b=a.type._context,g=this.threadID;E(b,g);var x=b[g];this.contextStack[c]=b;this.contextValueStack[c]=x;b[g]=a.props.value};b.popProvider=function(){var a=this.contextIndex,b=this.contextStack[a],f=this.contextValueStack[a];
	this.contextStack[a]=null;this.contextValueStack[a]=null;this.contextIndex--;b[this.threadID]=f};b.clearProviders=function(){for(var a=this.contextIndex;0<=a;a--)this.contextStack[a][this.threadID]=this.contextValueStack[a]};b.read=function(a){if(this.exhausted)return null;var b=X;X=this.threadID;var c=Qa.current;Qa.current=Ia;try{for(var g=[""],x=!1;g[0].length<a;){if(0===this.stack.length){this.exhausted=!0;var h=this.threadID;F[h]=F[0];F[0]=h;break}var e=this.stack[this.stack.length-1];if(x||e.childIndex>=
	e.children.length){var I=e.footer;""!==I&&(this.previousWasTextNode=!1);this.stack.pop();if("select"===e.type)this.currentSelectValue=null;else if(null!=e.type&&null!=e.type.type&&e.type.type.$$typeof===v)this.popProvider(e.type);else if(e.type===B){this.suspenseDepth--;var G=g.pop();if(x){x=!1;var n=e.fallbackFrame;if(!n)throw Error(q(303));this.stack.push(n);g[this.suspenseDepth]+="\x3c!--$!--\x3e";continue}else g[this.suspenseDepth]+=G}g[this.suspenseDepth]+=I}else{var m=e.children[e.childIndex++],
	w="";try{w+=this.render(m,e.context,e.domNamespace)}catch(r){if(null!=r&&"function"===typeof r.then)throw Error(q(294));throw r;}finally{}g.length<=this.suspenseDepth&&g.push("");g[this.suspenseDepth]+=w}}return g[0]}finally{Qa.current=c,X=b}};b.render=function(a,b,f){if("string"===typeof a||"number"===typeof a){f=""+a;if(""===f)return"";if(this.makeStaticMarkup)return N(f);if(this.previousWasTextNode)return"\x3c!-- --\x3e"+N(f);this.previousWasTextNode=!0;return N(f)}b=Za(a,b,this.threadID);a=b.child;
	b=b.context;if(null===a||!1===a)return"";if(!l.isValidElement(a)){if(null!=a&&null!=a.$$typeof){f=a.$$typeof;if(f===aa)throw Error(q(257));throw Error(q(258,f.toString()));}a=Z(a);this.stack.push({type:null,domNamespace:f,children:a,childIndex:0,context:b,footer:""});return""}var c=a.type;if("string"===typeof c)return this.renderDOM(a,b,f);switch(c){case ba:case ea:case ca:case ha:case u:return a=Z(a.props.children),this.stack.push({type:null,domNamespace:f,children:a,childIndex:0,context:b,footer:""}),
	"";case B:throw Error(q(294));}if("object"===typeof c&&null!==c)switch(c.$$typeof){case fa:O={};var d=c.render(a.props,a.ref);d=Da(c.render,a.props,d,a.ref);d=Z(d);this.stack.push({type:null,domNamespace:f,children:d,childIndex:0,context:b,footer:""});return"";case ia:return a=[l.createElement(c.type,k({ref:a.ref},a.props))],this.stack.push({type:null,domNamespace:f,children:a,childIndex:0,context:b,footer:""}),"";case v:return c=Z(a.props.children),f={type:a,domNamespace:f,children:c,childIndex:0,
	context:b,footer:""},this.pushProvider(a),this.stack.push(f),"";case da:c=a.type;d=a.props;var h=this.threadID;E(c,h);c=Z(d.children(c[h]));this.stack.push({type:a,domNamespace:f,children:c,childIndex:0,context:b,footer:""});return"";case la:throw Error(q(338));case ja:switch(c=a.type,na(c),c._status){case 1:return a=[l.createElement(c._result,k({ref:a.ref},a.props))],this.stack.push({type:null,domNamespace:f,children:a,childIndex:0,context:b,footer:""}),"";case 2:throw c._result;default:throw Error(q(295));
	}case ma:throw Error(q(343));}throw Error(q(130,null==c?c:typeof c,""));};b.renderDOM=function(a,b,f){var c=a.type.toLowerCase();f===Ja.html&&Ka(c);if(!Ta.hasOwnProperty(c)){if(!Sa.test(c))throw Error(q(65,c));Ta[c]=!0}var d=a.props;if("input"===c)d=k({type:void 0},d,{defaultChecked:void 0,defaultValue:void 0,value:null!=d.value?d.value:d.defaultValue,checked:null!=d.checked?d.checked:d.defaultChecked});else if("textarea"===c){var h=d.value;if(null==h){h=d.defaultValue;var e=d.children;if(null!=e){if(null!=
	h)throw Error(q(92));if(Array.isArray(e)){if(!(1>=e.length))throw Error(q(93));e=e[0]}h=""+e}null==h&&(h="")}d=k({},d,{value:void 0,children:""+h})}else if("select"===c)this.currentSelectValue=null!=d.value?d.value:d.defaultValue,d=k({},d,{value:void 0});else if("option"===c){e=this.currentSelectValue;var I=Va(d.children);if(null!=e){var G=null!=d.value?d.value+"":I;h=!1;if(Array.isArray(e))for(var n=0;n<e.length;n++){if(""+e[n]===G){h=!0;break}}else h=""+e===G;d=k({selected:void 0,children:void 0},
	d,{selected:h,children:I})}}if(h=d){if(Ma[c]&&(null!=h.children||null!=h.dangerouslySetInnerHTML))throw Error(q(137,c,""));if(null!=h.dangerouslySetInnerHTML){if(null!=h.children)throw Error(q(60));if(!("object"===typeof h.dangerouslySetInnerHTML&&"__html"in h.dangerouslySetInnerHTML))throw Error(q(61));}if(null!=h.style&&"object"!==typeof h.style)throw Error(q(62,""));}h=d;e=this.makeStaticMarkup;I=1===this.stack.length;G="<"+a.type;for(z in h)if(Wa.call(h,z)){var m=h[z];if(null!=m){if("style"===
	z){n=void 0;var w="",r="";for(n in m)if(m.hasOwnProperty(n)){var y=0===n.indexOf("--"),p=m[n];if(null!=p){if(y)var A=n;else if(A=n,Ua.hasOwnProperty(A))A=Ua[A];else{var T=A.replace(Oa,"-$1").toLowerCase().replace(Pa,"-ms-");A=Ua[A]=T}w+=r+A+":";r=n;y=null==p||"boolean"===typeof p||""===p?"":y||"number"!==typeof p||0===p||Y.hasOwnProperty(r)&&Y[r]?(""+p).trim():p+"px";w+=y;r=";"}}m=w||null}n=null;b:if(y=c,p=h,-1===y.indexOf("-"))y="string"===typeof p.is;else switch(y){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":y=
	!1;break b;default:y=!0}y?Xa.hasOwnProperty(z)||(n=z,n=ua(n)&&null!=m?n+'="'+(N(m)+'"'):""):n=ya(z,m);n&&(G+=" "+n)}}e||I&&(G+=' data-reactroot=""');var z=G;h="";La.hasOwnProperty(c)?z+="/>":(z+=">",h="</"+a.type+">");a:{e=d.dangerouslySetInnerHTML;if(null!=e){if(null!=e.__html){e=e.__html;break a}}else if(e=d.children,"string"===typeof e||"number"===typeof e){e=N(e);break a}e=null}null!=e?(d=[],Ra.hasOwnProperty(c)&&"\n"===e.charAt(0)&&(z+="\n"),z+=e):d=Z(d.children);a=a.type;f=null==f||"http://www.w3.org/1999/xhtml"===
	f?Ka(a):"http://www.w3.org/2000/svg"===f&&"foreignObject"===a?"http://www.w3.org/1999/xhtml":f;this.stack.push({domNamespace:f,type:c,children:d,childIndex:0,context:b,footer:h});this.previousWasTextNode=!1;return z};return a}(),ab={renderToString:function(a){a=new $a(a,!1);try{return a.read(Infinity)}finally{a.destroy()}},renderToStaticMarkup:function(a){a=new $a(a,!0);try{return a.read(Infinity)}finally{a.destroy()}},renderToNodeStream:function(){throw Error(q(207));},renderToStaticNodeStream:function(){throw Error(q(208));
	},version:"16.14.0"};module.exports=ab.default||ab;


/***/ },
/* 1376 */
/***/ function(module, exports, __webpack_require__) {

	/** @license React v16.14.0
	 * react-dom.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	/*
	 Modernizr 3.0.0pre (Custom Build) | MIT
	*/
	'use strict';var aa=__webpack_require__(1),n=__webpack_require__(58),r=__webpack_require__(1615);function u(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}if(!aa)throw Error(u(227));
	function ba(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}var da=!1,ea=null,fa=!1,ha=null,ia={onError:function(a){da=!0;ea=a}};function ja(a,b,c,d,e,f,g,h,k){da=!1;ea=null;ba.apply(ia,arguments)}function ka(a,b,c,d,e,f,g,h,k){ja.apply(this,arguments);if(da){if(da){var l=ea;da=!1;ea=null}else throw Error(u(198));fa||(fa=!0,ha=l)}}var la=null,ma=null,na=null;
	function oa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=na(c);ka(d,b,void 0,a);a.currentTarget=null}var pa=null,qa={};
	function ra(){if(pa)for(var a in qa){var b=qa[a],c=pa.indexOf(a);if(!(-1<c))throw Error(u(96,a));if(!sa[c]){if(!b.extractEvents)throw Error(u(97,a));sa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;if(ta.hasOwnProperty(h))throw Error(u(99,h));ta[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ua(k[e],g,h);e=!0}else f.registrationName?(ua(f.registrationName,g,h),e=!0):e=!1;if(!e)throw Error(u(98,d,a));}}}}
	function ua(a,b,c){if(va[a])throw Error(u(100,a));va[a]=b;wa[a]=b.eventTypes[c].dependencies}var sa=[],ta={},va={},wa={};function xa(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];if(!qa.hasOwnProperty(c)||qa[c]!==d){if(qa[c])throw Error(u(102,c));qa[c]=d;b=!0}}b&&ra()}var ya=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),za=null,Aa=null,Ba=null;
	function Ca(a){if(a=ma(a)){if("function"!==typeof za)throw Error(u(280));var b=a.stateNode;b&&(b=la(b),za(a.stateNode,a.type,b))}}function Da(a){Aa?Ba?Ba.push(a):Ba=[a]:Aa=a}function Ea(){if(Aa){var a=Aa,b=Ba;Ba=Aa=null;Ca(a);if(b)for(a=0;a<b.length;a++)Ca(b[a])}}function Fa(a,b){return a(b)}function Ga(a,b,c,d,e){return a(b,c,d,e)}function Ha(){}var Ia=Fa,Ja=!1,Ka=!1;function La(){if(null!==Aa||null!==Ba)Ha(),Ea()}
	function Ma(a,b,c){if(Ka)return a(b,c);Ka=!0;try{return Ia(a,b,c)}finally{Ka=!1,La()}}var Na=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Oa=Object.prototype.hasOwnProperty,Pa={},Qa={};
	function Ra(a){if(Oa.call(Qa,a))return!0;if(Oa.call(Pa,a))return!1;if(Na.test(a))return Qa[a]=!0;Pa[a]=!0;return!1}function Sa(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
	function Ta(a,b,c,d){if(null===b||"undefined"===typeof b||Sa(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function v(a,b,c,d,e,f){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f}var C={};
	"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){C[a]=new v(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];C[b]=new v(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){C[a]=new v(a,2,!1,a.toLowerCase(),null,!1)});
	["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){C[a]=new v(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){C[a]=new v(a,3,!1,a.toLowerCase(),null,!1)});
	["checked","multiple","muted","selected"].forEach(function(a){C[a]=new v(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){C[a]=new v(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){C[a]=new v(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){C[a]=new v(a,5,!1,a.toLowerCase(),null,!1)});var Ua=/[\-:]([a-z])/g;function Va(a){return a[1].toUpperCase()}
	"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Ua,
	Va);C[b]=new v(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!1)});
	C.xlinkHref=new v("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!0)});var Wa=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Wa.hasOwnProperty("ReactCurrentDispatcher")||(Wa.ReactCurrentDispatcher={current:null});Wa.hasOwnProperty("ReactCurrentBatchConfig")||(Wa.ReactCurrentBatchConfig={suspense:null});
	function Xa(a,b,c,d){var e=C.hasOwnProperty(b)?C[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Ta(b,c,e,d)&&(c=null),d||null===e?Ra(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
	var Ya=/^(.*)[\\\/]/,E="function"===typeof Symbol&&Symbol.for,Za=E?Symbol.for("react.element"):60103,$a=E?Symbol.for("react.portal"):60106,ab=E?Symbol.for("react.fragment"):60107,bb=E?Symbol.for("react.strict_mode"):60108,cb=E?Symbol.for("react.profiler"):60114,db=E?Symbol.for("react.provider"):60109,eb=E?Symbol.for("react.context"):60110,fb=E?Symbol.for("react.concurrent_mode"):60111,gb=E?Symbol.for("react.forward_ref"):60112,hb=E?Symbol.for("react.suspense"):60113,ib=E?Symbol.for("react.suspense_list"):
	60120,jb=E?Symbol.for("react.memo"):60115,kb=E?Symbol.for("react.lazy"):60116,lb=E?Symbol.for("react.block"):60121,mb="function"===typeof Symbol&&Symbol.iterator;function nb(a){if(null===a||"object"!==typeof a)return null;a=mb&&a[mb]||a["@@iterator"];return"function"===typeof a?a:null}function ob(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)})}}
	function pb(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case ab:return"Fragment";case $a:return"Portal";case cb:return"Profiler";case bb:return"StrictMode";case hb:return"Suspense";case ib:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case eb:return"Context.Consumer";case db:return"Context.Provider";case gb:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
	"ForwardRef");case jb:return pb(a.type);case lb:return pb(a.render);case kb:if(a=1===a._status?a._result:null)return pb(a)}return null}function qb(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=pb(a.type);c=null;d&&(c=pb(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Ya,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
	function rb(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function sb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
	function tb(a){var b=sb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
	null;delete a[b]}}}}function xb(a){a._valueTracker||(a._valueTracker=tb(a))}function yb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=sb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function zb(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
	function Ab(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=rb(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Bb(a,b){b=b.checked;null!=b&&Xa(a,"checked",b,!1)}
	function Cb(a,b){Bb(a,b);var c=rb(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Db(a,b.type,c):b.hasOwnProperty("defaultValue")&&Db(a,b.type,rb(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
	function Eb(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
	function Db(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}function Fb(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}function Gb(a,b){a=n({children:void 0},b);if(b=Fb(b.children))a.children=b;return a}
	function Hb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+rb(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
	function Ib(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(u(91));return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Jb(a,b){var c=b.value;if(null==c){c=b.children;b=b.defaultValue;if(null!=c){if(null!=b)throw Error(u(92));if(Array.isArray(c)){if(!(1>=c.length))throw Error(u(93));c=c[0]}b=c}null==b&&(b="");c=b}a._wrapperState={initialValue:rb(c)}}
	function Kb(a,b){var c=rb(b.value),d=rb(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function Lb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b)}var Mb={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
	function Nb(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Ob(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Nb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
	var Pb,Qb=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Mb.svg||"innerHTML"in a)a.innerHTML=b;else{Pb=Pb||document.createElement("div");Pb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=Pb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
	function Rb(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}function Sb(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Tb={animationend:Sb("Animation","AnimationEnd"),animationiteration:Sb("Animation","AnimationIteration"),animationstart:Sb("Animation","AnimationStart"),transitionend:Sb("Transition","TransitionEnd")},Ub={},Vb={};
	ya&&(Vb=document.createElement("div").style,"AnimationEvent"in window||(delete Tb.animationend.animation,delete Tb.animationiteration.animation,delete Tb.animationstart.animation),"TransitionEvent"in window||delete Tb.transitionend.transition);function Wb(a){if(Ub[a])return Ub[a];if(!Tb[a])return a;var b=Tb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Vb)return Ub[a]=b[c];return a}
	var Xb=Wb("animationend"),Yb=Wb("animationiteration"),Zb=Wb("animationstart"),$b=Wb("transitionend"),ac="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),bc=new ("function"===typeof WeakMap?WeakMap:Map);function cc(a){var b=bc.get(a);void 0===b&&(b=new Map,bc.set(a,b));return b}
	function dc(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.effectTag&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function ec(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function fc(a){if(dc(a)!==a)throw Error(u(188));}
	function gc(a){var b=a.alternate;if(!b){b=dc(a);if(null===b)throw Error(u(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return fc(e),a;if(f===d)return fc(e),b;f=f.sibling}throw Error(u(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
	c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw Error(u(189));}}if(c.alternate!==d)throw Error(u(190));}if(3!==c.tag)throw Error(u(188));return c.stateNode.current===c?a:b}function hc(a){a=gc(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
	function ic(a,b){if(null==b)throw Error(u(30));if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function jc(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var kc=null;
	function lc(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)oa(a,b[d],c[d]);else b&&oa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function mc(a){null!==a&&(kc=ic(kc,a));a=kc;kc=null;if(a){jc(a,lc);if(kc)throw Error(u(95));if(fa)throw a=ha,fa=!1,ha=null,a;}}
	function nc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function oc(a){if(!ya)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}var pc=[];function qc(a){a.topLevelType=null;a.nativeEvent=null;a.targetInst=null;a.ancestors.length=0;10>pc.length&&pc.push(a)}
	function rc(a,b,c,d){if(pc.length){var e=pc.pop();e.topLevelType=a;e.eventSystemFlags=d;e.nativeEvent=b;e.targetInst=c;return e}return{topLevelType:a,eventSystemFlags:d,nativeEvent:b,targetInst:c,ancestors:[]}}
	function sc(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d=c;if(3===d.tag)d=d.stateNode.containerInfo;else{for(;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo}if(!d)break;b=c.tag;5!==b&&6!==b||a.ancestors.push(c);c=tc(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=nc(a.nativeEvent);d=a.topLevelType;var f=a.nativeEvent,g=a.eventSystemFlags;0===c&&(g|=64);for(var h=null,k=0;k<sa.length;k++){var l=sa[k];l&&(l=l.extractEvents(d,b,f,e,g))&&(h=
	ic(h,l))}mc(h)}}function uc(a,b,c){if(!c.has(a)){switch(a){case "scroll":vc(b,"scroll",!0);break;case "focus":case "blur":vc(b,"focus",!0);vc(b,"blur",!0);c.set("blur",null);c.set("focus",null);break;case "cancel":case "close":oc(a)&&vc(b,a,!0);break;case "invalid":case "submit":case "reset":break;default:-1===ac.indexOf(a)&&F(a,b)}c.set(a,null)}}
	var wc,xc,yc,zc=!1,Ac=[],Bc=null,Cc=null,Dc=null,Ec=new Map,Fc=new Map,Gc=[],Hc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "),Ic="focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
	function Jc(a,b){var c=cc(b);Hc.forEach(function(a){uc(a,b,c)});Ic.forEach(function(a){uc(a,b,c)})}function Kc(a,b,c,d,e){return{blockedOn:a,topLevelType:b,eventSystemFlags:c|32,nativeEvent:e,container:d}}
	function Lc(a,b){switch(a){case "focus":case "blur":Bc=null;break;case "dragenter":case "dragleave":Cc=null;break;case "mouseover":case "mouseout":Dc=null;break;case "pointerover":case "pointerout":Ec.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":Fc.delete(b.pointerId)}}function Mc(a,b,c,d,e,f){if(null===a||a.nativeEvent!==f)return a=Kc(b,c,d,e,f),null!==b&&(b=Nc(b),null!==b&&xc(b)),a;a.eventSystemFlags|=d;return a}
	function Oc(a,b,c,d,e){switch(b){case "focus":return Bc=Mc(Bc,a,b,c,d,e),!0;case "dragenter":return Cc=Mc(Cc,a,b,c,d,e),!0;case "mouseover":return Dc=Mc(Dc,a,b,c,d,e),!0;case "pointerover":var f=e.pointerId;Ec.set(f,Mc(Ec.get(f)||null,a,b,c,d,e));return!0;case "gotpointercapture":return f=e.pointerId,Fc.set(f,Mc(Fc.get(f)||null,a,b,c,d,e)),!0}return!1}
	function Pc(a){var b=tc(a.target);if(null!==b){var c=dc(b);if(null!==c)if(b=c.tag,13===b){if(b=ec(c),null!==b){a.blockedOn=b;r.unstable_runWithPriority(a.priority,function(){yc(c)});return}}else if(3===b&&c.stateNode.hydrate){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null}function Qc(a){if(null!==a.blockedOn)return!1;var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);if(null!==b){var c=Nc(b);null!==c&&xc(c);a.blockedOn=b;return!1}return!0}
	function Sc(a,b,c){Qc(a)&&c.delete(b)}function Tc(){for(zc=!1;0<Ac.length;){var a=Ac[0];if(null!==a.blockedOn){a=Nc(a.blockedOn);null!==a&&wc(a);break}var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);null!==b?a.blockedOn=b:Ac.shift()}null!==Bc&&Qc(Bc)&&(Bc=null);null!==Cc&&Qc(Cc)&&(Cc=null);null!==Dc&&Qc(Dc)&&(Dc=null);Ec.forEach(Sc);Fc.forEach(Sc)}function Uc(a,b){a.blockedOn===b&&(a.blockedOn=null,zc||(zc=!0,r.unstable_scheduleCallback(r.unstable_NormalPriority,Tc)))}
	function Vc(a){function b(b){return Uc(b,a)}if(0<Ac.length){Uc(Ac[0],a);for(var c=1;c<Ac.length;c++){var d=Ac[c];d.blockedOn===a&&(d.blockedOn=null)}}null!==Bc&&Uc(Bc,a);null!==Cc&&Uc(Cc,a);null!==Dc&&Uc(Dc,a);Ec.forEach(b);Fc.forEach(b);for(c=0;c<Gc.length;c++)d=Gc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<Gc.length&&(c=Gc[0],null===c.blockedOn);)Pc(c),null===c.blockedOn&&Gc.shift()}
	var Wc={},Yc=new Map,Zc=new Map,$c=["abort","abort",Xb,"animationEnd",Yb,"animationIteration",Zb,"animationStart","canplay","canPlay","canplaythrough","canPlayThrough","durationchange","durationChange","emptied","emptied","encrypted","encrypted","ended","ended","error","error","gotpointercapture","gotPointerCapture","load","load","loadeddata","loadedData","loadedmetadata","loadedMetadata","loadstart","loadStart","lostpointercapture","lostPointerCapture","playing","playing","progress","progress","seeking",
	"seeking","stalled","stalled","suspend","suspend","timeupdate","timeUpdate",$b,"transitionEnd","waiting","waiting"];function ad(a,b){for(var c=0;c<a.length;c+=2){var d=a[c],e=a[c+1],f="on"+(e[0].toUpperCase()+e.slice(1));f={phasedRegistrationNames:{bubbled:f,captured:f+"Capture"},dependencies:[d],eventPriority:b};Zc.set(d,b);Yc.set(d,f);Wc[e]=f}}
	ad("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "),0);
	ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "),1);ad($c,2);for(var bd="change selectionchange textInput compositionstart compositionend compositionupdate".split(" "),cd=0;cd<bd.length;cd++)Zc.set(bd[cd],0);
	var dd=r.unstable_UserBlockingPriority,ed=r.unstable_runWithPriority,fd=!0;function F(a,b){vc(b,a,!1)}function vc(a,b,c){var d=Zc.get(b);switch(void 0===d?2:d){case 0:d=gd.bind(null,b,1,a);break;case 1:d=hd.bind(null,b,1,a);break;default:d=id.bind(null,b,1,a)}c?a.addEventListener(b,d,!0):a.addEventListener(b,d,!1)}function gd(a,b,c,d){Ja||Ha();var e=id,f=Ja;Ja=!0;try{Ga(e,a,b,c,d)}finally{(Ja=f)||La()}}function hd(a,b,c,d){ed(dd,id.bind(null,a,b,c,d))}
	function id(a,b,c,d){if(fd)if(0<Ac.length&&-1<Hc.indexOf(a))a=Kc(null,a,b,c,d),Ac.push(a);else{var e=Rc(a,b,c,d);if(null===e)Lc(a,d);else if(-1<Hc.indexOf(a))a=Kc(e,a,b,c,d),Ac.push(a);else if(!Oc(e,a,b,c,d)){Lc(a,d);a=rc(a,d,null,b);try{Ma(sc,a)}finally{qc(a)}}}}
	function Rc(a,b,c,d){c=nc(d);c=tc(c);if(null!==c){var e=dc(c);if(null===e)c=null;else{var f=e.tag;if(13===f){c=ec(e);if(null!==c)return c;c=null}else if(3===f){if(e.stateNode.hydrate)return 3===e.tag?e.stateNode.containerInfo:null;c=null}else e!==c&&(c=null)}}a=rc(a,d,c,b);try{Ma(sc,a)}finally{qc(a)}return null}
	var jd={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
	floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},kd=["Webkit","ms","Moz","O"];Object.keys(jd).forEach(function(a){kd.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);jd[b]=jd[a]})});function ld(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||jd.hasOwnProperty(a)&&jd[a]?(""+b).trim():b+"px"}
	function md(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=ld(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var nd=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
	function od(a,b){if(b){if(nd[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(u(137,a,""));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(u(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw Error(u(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(u(62,""));}}
	function pd(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var qd=Mb.html;function rd(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=cc(a);b=wa[b];for(var d=0;d<b.length;d++)uc(b[d],a,c)}function sd(){}
	function td(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function ud(a){for(;a&&a.firstChild;)a=a.firstChild;return a}function vd(a,b){var c=ud(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=ud(c)}}
	function wd(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?wd(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}function xd(){for(var a=window,b=td();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=td(a.document)}return b}
	function yd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}var zd="$",Ad="/$",Bd="$?",Cd="$!",Dd=null,Ed=null;function Fd(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
	function Gd(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var Hd="function"===typeof setTimeout?setTimeout:void 0,Id="function"===typeof clearTimeout?clearTimeout:void 0;function Jd(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}
	function Kd(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if(c===zd||c===Cd||c===Bd){if(0===b)return a;b--}else c===Ad&&b++}a=a.previousSibling}return null}var Ld=Math.random().toString(36).slice(2),Md="__reactInternalInstance$"+Ld,Nd="__reactEventHandlers$"+Ld,Od="__reactContainere$"+Ld;
	function tc(a){var b=a[Md];if(b)return b;for(var c=a.parentNode;c;){if(b=c[Od]||c[Md]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=Kd(a);null!==a;){if(c=a[Md])return c;a=Kd(a)}return b}a=c;c=a.parentNode}return null}function Nc(a){a=a[Md]||a[Od];return!a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function Pd(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(u(33));}function Qd(a){return a[Nd]||null}
	function Rd(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}
	function Sd(a,b){var c=a.stateNode;if(!c)return null;var d=la(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":case "onMouseEnter":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==typeof c)throw Error(u(231,
	b,typeof c));return c}function Td(a,b,c){if(b=Sd(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a)}function Ud(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Rd(b);for(b=c.length;0<b--;)Td(c[b],"captured",a);for(b=0;b<c.length;b++)Td(c[b],"bubbled",a)}}
	function Vd(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Sd(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a))}function Wd(a){a&&a.dispatchConfig.registrationName&&Vd(a._targetInst,null,a)}function Xd(a){jc(a,Ud)}var Yd=null,Zd=null,$d=null;
	function ae(){if($d)return $d;var a,b=Zd,c=b.length,d,e="value"in Yd?Yd.value:Yd.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return $d=e.slice(a,1<d?1-d:void 0)}function be(){return!0}function ce(){return!1}
	function G(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?be:ce;this.isPropagationStopped=ce;return this}
	n(G.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=be)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=be)},persist:function(){this.isPersistent=be},isPersistent:ce,destructor:function(){var a=this.constructor.Interface,
	b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=ce;this._dispatchInstances=this._dispatchListeners=null}});G.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
	G.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;de(c);return c};de(G);function ee(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
	function fe(a){if(!(a instanceof this))throw Error(u(279));a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function de(a){a.eventPool=[];a.getPooled=ee;a.release=fe}var ge=G.extend({data:null}),he=G.extend({data:null}),ie=[9,13,27,32],je=ya&&"CompositionEvent"in window,ke=null;ya&&"documentMode"in document&&(ke=document.documentMode);
	var le=ya&&"TextEvent"in window&&!ke,me=ya&&(!je||ke&&8<ke&&11>=ke),ne=String.fromCharCode(32),oe={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
	captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},pe=!1;
	function qe(a,b){switch(a){case "keyup":return-1!==ie.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function re(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var se=!1;function te(a,b){switch(a){case "compositionend":return re(b);case "keypress":if(32!==b.which)return null;pe=!0;return ne;case "textInput":return a=b.data,a===ne&&pe?null:a;default:return null}}
	function ue(a,b){if(se)return"compositionend"===a||!je&&qe(a,b)?(a=ae(),$d=Zd=Yd=null,se=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return me&&"ko"!==b.locale?null:b.data;default:return null}}
	var ve={eventTypes:oe,extractEvents:function(a,b,c,d){var e;if(je)b:{switch(a){case "compositionstart":var f=oe.compositionStart;break b;case "compositionend":f=oe.compositionEnd;break b;case "compositionupdate":f=oe.compositionUpdate;break b}f=void 0}else se?qe(a,c)&&(f=oe.compositionEnd):"keydown"===a&&229===c.keyCode&&(f=oe.compositionStart);f?(me&&"ko"!==c.locale&&(se||f!==oe.compositionStart?f===oe.compositionEnd&&se&&(e=ae()):(Yd=d,Zd="value"in Yd?Yd.value:Yd.textContent,se=!0)),f=ge.getPooled(f,
	b,c,d),e?f.data=e:(e=re(c),null!==e&&(f.data=e)),Xd(f),e=f):e=null;(a=le?te(a,c):ue(a,c))?(b=he.getPooled(oe.beforeInput,b,c,d),b.data=a,Xd(b)):b=null;return null===e?b:null===b?e:[e,b]}},we={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function xe(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!we[a.type]:"textarea"===b?!0:!1}
	var ye={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function ze(a,b,c){a=G.getPooled(ye.change,a,b,c);a.type="change";Da(c);Xd(a);return a}var Ae=null,Be=null;function Ce(a){mc(a)}function De(a){var b=Pd(a);if(yb(b))return a}function Ee(a,b){if("change"===a)return b}var Fe=!1;ya&&(Fe=oc("input")&&(!document.documentMode||9<document.documentMode));
	function Ge(){Ae&&(Ae.detachEvent("onpropertychange",He),Be=Ae=null)}function He(a){if("value"===a.propertyName&&De(Be))if(a=ze(Be,a,nc(a)),Ja)mc(a);else{Ja=!0;try{Fa(Ce,a)}finally{Ja=!1,La()}}}function Ie(a,b,c){"focus"===a?(Ge(),Ae=b,Be=c,Ae.attachEvent("onpropertychange",He)):"blur"===a&&Ge()}function Je(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return De(Be)}function Ke(a,b){if("click"===a)return De(b)}function Le(a,b){if("input"===a||"change"===a)return De(b)}
	var Me={eventTypes:ye,_isInputEventSupported:Fe,extractEvents:function(a,b,c,d){var e=b?Pd(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=Ee;else if(xe(e))if(Fe)g=Le;else{g=Je;var h=Ie}else(f=e.nodeName)&&"input"===f.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(g=Ke);if(g&&(g=g(a,b)))return ze(g,c,d);h&&h(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Db(e,"number",e.value)}},Ne=G.extend({view:null,detail:null}),
	Oe={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Pe(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Oe[a])?!!b[a]:!1}function Qe(){return Pe}
	var Re=0,Se=0,Te=!1,Ue=!1,Ve=Ne.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Qe,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=Re;Re=a.screenX;return Te?"mousemove"===a.type?a.screenX-b:0:(Te=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
	var b=Se;Se=a.screenY;return Ue?"mousemove"===a.type?a.screenY-b:0:(Ue=!0,0)}}),We=Ve.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),Xe={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
	dependencies:["pointerout","pointerover"]}},Ye={eventTypes:Xe,extractEvents:function(a,b,c,d,e){var f="mouseover"===a||"pointerover"===a,g="mouseout"===a||"pointerout"===a;if(f&&0===(e&32)&&(c.relatedTarget||c.fromElement)||!g&&!f)return null;f=d.window===d?d:(f=d.ownerDocument)?f.defaultView||f.parentWindow:window;if(g){if(g=b,b=(b=c.relatedTarget||c.toElement)?tc(b):null,null!==b){var h=dc(b);if(b!==h||5!==b.tag&&6!==b.tag)b=null}}else g=null;if(g===b)return null;if("mouseout"===a||"mouseover"===
	a){var k=Ve;var l=Xe.mouseLeave;var m=Xe.mouseEnter;var p="mouse"}else if("pointerout"===a||"pointerover"===a)k=We,l=Xe.pointerLeave,m=Xe.pointerEnter,p="pointer";a=null==g?f:Pd(g);f=null==b?f:Pd(b);l=k.getPooled(l,g,c,d);l.type=p+"leave";l.target=a;l.relatedTarget=f;c=k.getPooled(m,b,c,d);c.type=p+"enter";c.target=f;c.relatedTarget=a;d=g;p=b;if(d&&p)a:{k=d;m=p;g=0;for(a=k;a;a=Rd(a))g++;a=0;for(b=m;b;b=Rd(b))a++;for(;0<g-a;)k=Rd(k),g--;for(;0<a-g;)m=Rd(m),a--;for(;g--;){if(k===m||k===m.alternate)break a;
	k=Rd(k);m=Rd(m)}k=null}else k=null;m=k;for(k=[];d&&d!==m;){g=d.alternate;if(null!==g&&g===m)break;k.push(d);d=Rd(d)}for(d=[];p&&p!==m;){g=p.alternate;if(null!==g&&g===m)break;d.push(p);p=Rd(p)}for(p=0;p<k.length;p++)Vd(k[p],"bubbled",l);for(p=d.length;0<p--;)Vd(d[p],"captured",c);return 0===(e&64)?[l]:[l,c]}};function Ze(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var $e="function"===typeof Object.is?Object.is:Ze,af=Object.prototype.hasOwnProperty;
	function bf(a,b){if($e(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!af.call(b,c[d])||!$e(a[c[d]],b[c[d]]))return!1;return!0}
	var cf=ya&&"documentMode"in document&&11>=document.documentMode,df={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},ef=null,ff=null,gf=null,hf=!1;
	function jf(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(hf||null==ef||ef!==td(c))return null;c=ef;"selectionStart"in c&&yd(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return gf&&bf(gf,c)?null:(gf=c,a=G.getPooled(df.select,ff,a,b),a.type="select",a.target=ef,Xd(a),a)}
	var kf={eventTypes:df,extractEvents:function(a,b,c,d,e,f){e=f||(d.window===d?d.document:9===d.nodeType?d:d.ownerDocument);if(!(f=!e)){a:{e=cc(e);f=wa.onSelect;for(var g=0;g<f.length;g++)if(!e.has(f[g])){e=!1;break a}e=!0}f=!e}if(f)return null;e=b?Pd(b):window;switch(a){case "focus":if(xe(e)||"true"===e.contentEditable)ef=e,ff=b,gf=null;break;case "blur":gf=ff=ef=null;break;case "mousedown":hf=!0;break;case "contextmenu":case "mouseup":case "dragend":return hf=!1,jf(c,d);case "selectionchange":if(cf)break;
	case "keydown":case "keyup":return jf(c,d)}return null}},lf=G.extend({animationName:null,elapsedTime:null,pseudoElement:null}),mf=G.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),nf=Ne.extend({relatedTarget:null});function of(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
	var pf={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},qf={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
	116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},rf=Ne.extend({key:function(a){if(a.key){var b=pf[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=of(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?qf[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Qe,charCode:function(a){return"keypress"===
	a.type?of(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?of(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),sf=Ve.extend({dataTransfer:null}),tf=Ne.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Qe}),uf=G.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),vf=Ve.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
	a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),wf={eventTypes:Wc,extractEvents:function(a,b,c,d){var e=Yc.get(a);if(!e)return null;switch(a){case "keypress":if(0===of(c))return null;case "keydown":case "keyup":a=rf;break;case "blur":case "focus":a=nf;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=
	Ve;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=sf;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=tf;break;case Xb:case Yb:case Zb:a=lf;break;case $b:a=uf;break;case "scroll":a=Ne;break;case "wheel":a=vf;break;case "copy":case "cut":case "paste":a=mf;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=
	We;break;default:a=G}b=a.getPooled(e,b,c,d);Xd(b);return b}};if(pa)throw Error(u(101));pa=Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));ra();var xf=Nc;la=Qd;ma=xf;na=Pd;xa({SimpleEventPlugin:wf,EnterLeaveEventPlugin:Ye,ChangeEventPlugin:Me,SelectEventPlugin:kf,BeforeInputEventPlugin:ve});var yf=[],zf=-1;function H(a){0>zf||(a.current=yf[zf],yf[zf]=null,zf--)}
	function I(a,b){zf++;yf[zf]=a.current;a.current=b}var Af={},J={current:Af},K={current:!1},Bf=Af;function Cf(a,b){var c=a.type.contextTypes;if(!c)return Af;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function L(a){a=a.childContextTypes;return null!==a&&void 0!==a}
	function Df(){H(K);H(J)}function Ef(a,b,c){if(J.current!==Af)throw Error(u(168));I(J,b);I(K,c)}function Ff(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw Error(u(108,pb(b)||"Unknown",e));return n({},c,{},d)}function Gf(a){a=(a=a.stateNode)&&a.__reactInternalMemoizedMergedChildContext||Af;Bf=J.current;I(J,a);I(K,K.current);return!0}
	function Hf(a,b,c){var d=a.stateNode;if(!d)throw Error(u(169));c?(a=Ff(a,b,Bf),d.__reactInternalMemoizedMergedChildContext=a,H(K),H(J),I(J,a)):H(K);I(K,c)}
	var If=r.unstable_runWithPriority,Jf=r.unstable_scheduleCallback,Kf=r.unstable_cancelCallback,Lf=r.unstable_requestPaint,Mf=r.unstable_now,Nf=r.unstable_getCurrentPriorityLevel,Of=r.unstable_ImmediatePriority,Pf=r.unstable_UserBlockingPriority,Qf=r.unstable_NormalPriority,Rf=r.unstable_LowPriority,Sf=r.unstable_IdlePriority,Tf={},Uf=r.unstable_shouldYield,Vf=void 0!==Lf?Lf:function(){},Wf=null,Xf=null,Yf=!1,Zf=Mf(),$f=1E4>Zf?Mf:function(){return Mf()-Zf};
	function ag(){switch(Nf()){case Of:return 99;case Pf:return 98;case Qf:return 97;case Rf:return 96;case Sf:return 95;default:throw Error(u(332));}}function bg(a){switch(a){case 99:return Of;case 98:return Pf;case 97:return Qf;case 96:return Rf;case 95:return Sf;default:throw Error(u(332));}}function cg(a,b){a=bg(a);return If(a,b)}function dg(a,b,c){a=bg(a);return Jf(a,b,c)}function eg(a){null===Wf?(Wf=[a],Xf=Jf(Of,fg)):Wf.push(a);return Tf}function gg(){if(null!==Xf){var a=Xf;Xf=null;Kf(a)}fg()}
	function fg(){if(!Yf&&null!==Wf){Yf=!0;var a=0;try{var b=Wf;cg(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});Wf=null}catch(c){throw null!==Wf&&(Wf=Wf.slice(a+1)),Jf(Of,gg),c;}finally{Yf=!1}}}function hg(a,b,c){c/=10;return 1073741821-(((1073741821-a+b/10)/c|0)+1)*c}function ig(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}var jg={current:null},kg=null,lg=null,mg=null;function ng(){mg=lg=kg=null}
	function og(a){var b=jg.current;H(jg);a.type._context._currentValue=b}function pg(a,b){for(;null!==a;){var c=a.alternate;if(a.childExpirationTime<b)a.childExpirationTime=b,null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);else if(null!==c&&c.childExpirationTime<b)c.childExpirationTime=b;else break;a=a.return}}function qg(a,b){kg=a;mg=lg=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(a.expirationTime>=b&&(rg=!0),a.firstContext=null)}
	function sg(a,b){if(mg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)mg=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===lg){if(null===kg)throw Error(u(308));lg=b;kg.dependencies={expirationTime:0,firstContext:b,responders:null}}else lg=lg.next=b}return a._currentValue}var tg=!1;function ug(a){a.updateQueue={baseState:a.memoizedState,baseQueue:null,shared:{pending:null},effects:null}}
	function vg(a,b){a=a.updateQueue;b.updateQueue===a&&(b.updateQueue={baseState:a.baseState,baseQueue:a.baseQueue,shared:a.shared,effects:a.effects})}function wg(a,b){a={expirationTime:a,suspenseConfig:b,tag:0,payload:null,callback:null,next:null};return a.next=a}function xg(a,b){a=a.updateQueue;if(null!==a){a=a.shared;var c=a.pending;null===c?b.next=b:(b.next=c.next,c.next=b);a.pending=b}}
	function yg(a,b){var c=a.alternate;null!==c&&vg(c,a);a=a.updateQueue;c=a.baseQueue;null===c?(a.baseQueue=b.next=b,b.next=b):(b.next=c.next,c.next=b)}
	function zg(a,b,c,d){var e=a.updateQueue;tg=!1;var f=e.baseQueue,g=e.shared.pending;if(null!==g){if(null!==f){var h=f.next;f.next=g.next;g.next=h}f=g;e.shared.pending=null;h=a.alternate;null!==h&&(h=h.updateQueue,null!==h&&(h.baseQueue=g))}if(null!==f){h=f.next;var k=e.baseState,l=0,m=null,p=null,x=null;if(null!==h){var z=h;do{g=z.expirationTime;if(g<d){var ca={expirationTime:z.expirationTime,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null};null===x?(p=x=
	ca,m=k):x=x.next=ca;g>l&&(l=g)}else{null!==x&&(x=x.next={expirationTime:1073741823,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null});Ag(g,z.suspenseConfig);a:{var D=a,t=z;g=b;ca=c;switch(t.tag){case 1:D=t.payload;if("function"===typeof D){k=D.call(ca,k,g);break a}k=D;break a;case 3:D.effectTag=D.effectTag&-4097|64;case 0:D=t.payload;g="function"===typeof D?D.call(ca,k,g):D;if(null===g||void 0===g)break a;k=n({},k,g);break a;case 2:tg=!0}}null!==z.callback&&
	(a.effectTag|=32,g=e.effects,null===g?e.effects=[z]:g.push(z))}z=z.next;if(null===z||z===h)if(g=e.shared.pending,null===g)break;else z=f.next=g.next,g.next=h,e.baseQueue=f=g,e.shared.pending=null}while(1)}null===x?m=k:x.next=p;e.baseState=m;e.baseQueue=x;Bg(l);a.expirationTime=l;a.memoizedState=k}}
	function Cg(a,b,c){a=b.effects;b.effects=null;if(null!==a)for(b=0;b<a.length;b++){var d=a[b],e=d.callback;if(null!==e){d.callback=null;d=e;e=c;if("function"!==typeof d)throw Error(u(191,d));d.call(e)}}}var Dg=Wa.ReactCurrentBatchConfig,Eg=(new aa.Component).refs;function Fg(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;0===a.expirationTime&&(a.updateQueue.baseState=c)}
	var Jg={isMounted:function(a){return(a=a._reactInternalFiber)?dc(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Gg(),d=Dg.suspense;
	c=Hg(c,a,d);d=wg(c,d);d.tag=2;void 0!==b&&null!==b&&(d.callback=b);xg(a,d);Ig(a,c)}};function Kg(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!bf(c,d)||!bf(e,f):!0}
	function Lg(a,b,c){var d=!1,e=Af;var f=b.contextType;"object"===typeof f&&null!==f?f=sg(f):(e=L(b)?Bf:J.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Cf(a,e):Af);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Jg;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
	function Mg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Jg.enqueueReplaceState(b,b.state,null)}
	function Ng(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Eg;ug(a);var f=b.contextType;"object"===typeof f&&null!==f?e.context=sg(f):(f=L(b)?Bf:J.current,e.context=Cf(a,f));zg(a,c,e,d);e.state=a.memoizedState;f=b.getDerivedStateFromProps;"function"===typeof f&&(Fg(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||
	(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Jg.enqueueReplaceState(e,e.state,null),zg(a,c,e,d),e.state=a.memoizedState);"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Og=Array.isArray;
	function Pg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(u(309));var d=c.stateNode}if(!d)throw Error(u(147,a));var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Eg&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw Error(u(284));if(!c._owner)throw Error(u(290,a));}return a}
	function Qg(a,b){if("textarea"!==a.type)throw Error(u(31,"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,""));}
	function Rg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b){a=Sg(a,b);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
	2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Tg(c,a.mode,d),b.return=a,b;b=e(b,c);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props),d.ref=Pg(a,b,c),d.return=a,d;d=Ug(c.type,c.key,c.props,null,a.mode,d);d.ref=Pg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
	c.implementation)return b=Vg(c,a.mode,d),b.return=a,b;b=e(b,c.children||[]);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=Wg(c,a.mode,d,f),b.return=a,b;b=e(b,c);b.return=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Tg(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Za:return c=Ug(b.type,b.key,b.props,null,a.mode,c),c.ref=Pg(a,null,b),c.return=a,c;case $a:return b=Vg(b,a.mode,c),b.return=a,b}if(Og(b)||
	nb(b))return b=Wg(b,a.mode,c,null),b.return=a,b;Qg(a,b)}return null}function x(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Za:return c.key===e?c.type===ab?m(a,b,c.props.children,d,e):k(a,b,c,d):null;case $a:return c.key===e?l(a,b,c,d):null}if(Og(c)||nb(c))return null!==e?null:m(a,b,c,d,null);Qg(a,c)}return null}function z(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
	a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Za:return a=a.get(null===d.key?c:d.key)||null,d.type===ab?m(b,a,d.props.children,e,d.key):k(b,a,d,e);case $a:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Og(d)||nb(d))return a=a.get(c)||null,m(b,a,d,e,null);Qg(b,d)}return null}function ca(e,g,h,k){for(var l=null,t=null,m=g,y=g=0,A=null;null!==m&&y<h.length;y++){m.index>y?(A=m,m=null):A=m.sibling;var q=x(e,m,h[y],k);if(null===q){null===m&&(m=A);break}a&&
	m&&null===q.alternate&&b(e,m);g=f(q,g,y);null===t?l=q:t.sibling=q;t=q;m=A}if(y===h.length)return c(e,m),l;if(null===m){for(;y<h.length;y++)m=p(e,h[y],k),null!==m&&(g=f(m,g,y),null===t?l=m:t.sibling=m,t=m);return l}for(m=d(e,m);y<h.length;y++)A=z(m,e,y,h[y],k),null!==A&&(a&&null!==A.alternate&&m.delete(null===A.key?y:A.key),g=f(A,g,y),null===t?l=A:t.sibling=A,t=A);a&&m.forEach(function(a){return b(e,a)});return l}function D(e,g,h,l){var k=nb(h);if("function"!==typeof k)throw Error(u(150));h=k.call(h);
	if(null==h)throw Error(u(151));for(var m=k=null,t=g,y=g=0,A=null,q=h.next();null!==t&&!q.done;y++,q=h.next()){t.index>y?(A=t,t=null):A=t.sibling;var D=x(e,t,q.value,l);if(null===D){null===t&&(t=A);break}a&&t&&null===D.alternate&&b(e,t);g=f(D,g,y);null===m?k=D:m.sibling=D;m=D;t=A}if(q.done)return c(e,t),k;if(null===t){for(;!q.done;y++,q=h.next())q=p(e,q.value,l),null!==q&&(g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);return k}for(t=d(e,t);!q.done;y++,q=h.next())q=z(t,e,y,q.value,l),null!==q&&(a&&null!==
	q.alternate&&t.delete(null===q.key?y:q.key),g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);a&&t.forEach(function(a){return b(e,a)});return k}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ab&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Za:a:{l=f.key;for(k=d;null!==k;){if(k.key===l){switch(k.tag){case 7:if(f.type===ab){c(a,k.sibling);d=e(k,f.props.children);d.return=a;a=d;break a}break;default:if(k.elementType===f.type){c(a,
	k.sibling);d=e(k,f.props);d.ref=Pg(a,k,f);d.return=a;a=d;break a}}c(a,k);break}else b(a,k);k=k.sibling}f.type===ab?(d=Wg(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Ug(f.type,f.key,f.props,null,a.mode,h),h.ref=Pg(a,d,f),h.return=a,a=h)}return g(a);case $a:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[]);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=
	d.sibling}d=Vg(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f),d.return=a,a=d):(c(a,d),d=Tg(f,a.mode,h),d.return=a,a=d),g(a);if(Og(f))return ca(a,d,f,h);if(nb(f))return D(a,d,f,h);l&&Qg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:throw a=a.type,Error(u(152,a.displayName||a.name||"Component"));}return c(a,d)}}var Xg=Rg(!0),Yg=Rg(!1),Zg={},$g={current:Zg},ah={current:Zg},bh={current:Zg};
	function ch(a){if(a===Zg)throw Error(u(174));return a}function dh(a,b){I(bh,b);I(ah,a);I($g,Zg);a=b.nodeType;switch(a){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:Ob(null,"");break;default:a=8===a?b.parentNode:b,b=a.namespaceURI||null,a=a.tagName,b=Ob(b,a)}H($g);I($g,b)}function eh(){H($g);H(ah);H(bh)}function fh(a){ch(bh.current);var b=ch($g.current);var c=Ob(b,a.type);b!==c&&(I(ah,a),I($g,c))}function gh(a){ah.current===a&&(H($g),H(ah))}var M={current:0};
	function hh(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||c.data===Bd||c.data===Cd))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.effectTag&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}function ih(a,b){return{responder:a,props:b}}
	var jh=Wa.ReactCurrentDispatcher,kh=Wa.ReactCurrentBatchConfig,lh=0,N=null,O=null,P=null,mh=!1;function Q(){throw Error(u(321));}function nh(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!$e(a[c],b[c]))return!1;return!0}
	function oh(a,b,c,d,e,f){lh=f;N=b;b.memoizedState=null;b.updateQueue=null;b.expirationTime=0;jh.current=null===a||null===a.memoizedState?ph:qh;a=c(d,e);if(b.expirationTime===lh){f=0;do{b.expirationTime=0;if(!(25>f))throw Error(u(301));f+=1;P=O=null;b.updateQueue=null;jh.current=rh;a=c(d,e)}while(b.expirationTime===lh)}jh.current=sh;b=null!==O&&null!==O.next;lh=0;P=O=N=null;mh=!1;if(b)throw Error(u(300));return a}
	function th(){var a={memoizedState:null,baseState:null,baseQueue:null,queue:null,next:null};null===P?N.memoizedState=P=a:P=P.next=a;return P}function uh(){if(null===O){var a=N.alternate;a=null!==a?a.memoizedState:null}else a=O.next;var b=null===P?N.memoizedState:P.next;if(null!==b)P=b,O=a;else{if(null===a)throw Error(u(310));O=a;a={memoizedState:O.memoizedState,baseState:O.baseState,baseQueue:O.baseQueue,queue:O.queue,next:null};null===P?N.memoizedState=P=a:P=P.next=a}return P}
	function vh(a,b){return"function"===typeof b?b(a):b}
	function wh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=O,e=d.baseQueue,f=c.pending;if(null!==f){if(null!==e){var g=e.next;e.next=f.next;f.next=g}d.baseQueue=e=f;c.pending=null}if(null!==e){e=e.next;d=d.baseState;var h=g=f=null,k=e;do{var l=k.expirationTime;if(l<lh){var m={expirationTime:k.expirationTime,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null};null===h?(g=h=m,f=d):h=h.next=m;l>N.expirationTime&&
	(N.expirationTime=l,Bg(l))}else null!==h&&(h=h.next={expirationTime:1073741823,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null}),Ag(l,k.suspenseConfig),d=k.eagerReducer===a?k.eagerState:a(d,k.action);k=k.next}while(null!==k&&k!==e);null===h?f=d:h.next=g;$e(d,b.memoizedState)||(rg=!0);b.memoizedState=d;b.baseState=f;b.baseQueue=h;c.lastRenderedState=d}return[b.memoizedState,c.dispatch]}
	function xh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=c.dispatch,e=c.pending,f=b.memoizedState;if(null!==e){c.pending=null;var g=e=e.next;do f=a(f,g.action),g=g.next;while(g!==e);$e(f,b.memoizedState)||(rg=!0);b.memoizedState=f;null===b.baseQueue&&(b.baseState=f);c.lastRenderedState=f}return[f,d]}
	function yh(a){var b=th();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={pending:null,dispatch:null,lastRenderedReducer:vh,lastRenderedState:a};a=a.dispatch=zh.bind(null,N,a);return[b.memoizedState,a]}function Ah(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};b=N.updateQueue;null===b?(b={lastEffect:null},N.updateQueue=b,b.lastEffect=a.next=a):(c=b.lastEffect,null===c?b.lastEffect=a.next=a:(d=c.next,c.next=a,a.next=d,b.lastEffect=a));return a}
	function Bh(){return uh().memoizedState}function Ch(a,b,c,d){var e=th();N.effectTag|=a;e.memoizedState=Ah(1|b,c,void 0,void 0===d?null:d)}function Dh(a,b,c,d){var e=uh();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&nh(d,g.deps)){Ah(b,c,f,d);return}}N.effectTag|=a;e.memoizedState=Ah(1|b,c,f,d)}function Eh(a,b){return Ch(516,4,a,b)}function Fh(a,b){return Dh(516,4,a,b)}function Gh(a,b){return Dh(4,2,a,b)}
	function Hh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function Ih(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Dh(4,2,Hh.bind(null,b,a),c)}function Jh(){}function Kh(a,b){th().memoizedState=[a,void 0===b?null:b];return a}function Lh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}
	function Mh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a}function Nh(a,b,c){var d=ag();cg(98>d?98:d,function(){a(!0)});cg(97<d?97:d,function(){var d=kh.suspense;kh.suspense=void 0===b?null:b;try{a(!1),c()}finally{kh.suspense=d}})}
	function zh(a,b,c){var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e={expirationTime:d,suspenseConfig:e,action:c,eagerReducer:null,eagerState:null,next:null};var f=b.pending;null===f?e.next=e:(e.next=f.next,f.next=e);b.pending=e;f=a.alternate;if(a===N||null!==f&&f===N)mh=!0,e.expirationTime=lh,N.expirationTime=lh;else{if(0===a.expirationTime&&(null===f||0===f.expirationTime)&&(f=b.lastRenderedReducer,null!==f))try{var g=b.lastRenderedState,h=f(g,c);e.eagerReducer=f;e.eagerState=h;if($e(h,g))return}catch(k){}finally{}Ig(a,
	d)}}
	var sh={readContext:sg,useCallback:Q,useContext:Q,useEffect:Q,useImperativeHandle:Q,useLayoutEffect:Q,useMemo:Q,useReducer:Q,useRef:Q,useState:Q,useDebugValue:Q,useResponder:Q,useDeferredValue:Q,useTransition:Q},ph={readContext:sg,useCallback:Kh,useContext:sg,useEffect:Eh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Ch(4,2,Hh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Ch(4,2,a,b)},useMemo:function(a,b){var c=th();b=void 0===b?null:b;a=a();c.memoizedState=[a,
	b];return a},useReducer:function(a,b,c){var d=th();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={pending:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=zh.bind(null,N,a);return[d.memoizedState,a]},useRef:function(a){var b=th();a={current:a};return b.memoizedState=a},useState:yh,useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=yh(a),d=c[0],e=c[1];Eh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=
	c}},[a,b]);return d},useTransition:function(a){var b=yh(!1),c=b[0];b=b[1];return[Kh(Nh.bind(null,b,a),[b,a]),c]}},qh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:wh,useRef:Bh,useState:function(){return wh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=wh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=
	wh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,b,a),[b,a]),c]}},rh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:xh,useRef:Bh,useState:function(){return xh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=xh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=xh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,
	b,a),[b,a]),c]}},Oh=null,Ph=null,Qh=!1;function Rh(a,b){var c=Sh(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
	function Th(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
	function Uh(a){if(Qh){var b=Ph;if(b){var c=b;if(!Th(a,b)){b=Jd(c.nextSibling);if(!b||!Th(a,b)){a.effectTag=a.effectTag&-1025|2;Qh=!1;Oh=a;return}Rh(Oh,c)}Oh=a;Ph=Jd(b.firstChild)}else a.effectTag=a.effectTag&-1025|2,Qh=!1,Oh=a}}function Vh(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;Oh=a}
	function Wh(a){if(a!==Oh)return!1;if(!Qh)return Vh(a),Qh=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!Gd(b,a.memoizedProps))for(b=Ph;b;)Rh(a,b),b=Jd(b.nextSibling);Vh(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(u(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if(c===Ad){if(0===b){Ph=Jd(a.nextSibling);break a}b--}else c!==zd&&c!==Cd&&c!==Bd||b++}a=a.nextSibling}Ph=null}}else Ph=Oh?Jd(a.stateNode.nextSibling):null;return!0}
	function Xh(){Ph=Oh=null;Qh=!1}var Yh=Wa.ReactCurrentOwner,rg=!1;function R(a,b,c,d){b.child=null===a?Yg(b,null,c,d):Xg(b,a.child,c,d)}function Zh(a,b,c,d,e){c=c.render;var f=b.ref;qg(b,e);d=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,d,e);return b.child}
	function ai(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!bi(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,ci(a,b,g,d,e,f);a=Ug(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:bf,c(e,d)&&a.ref===b.ref))return $h(a,b,f);b.effectTag|=1;a=Sg(g,d);a.ref=b.ref;a.return=b;return b.child=a}
	function ci(a,b,c,d,e,f){return null!==a&&bf(a.memoizedProps,d)&&a.ref===b.ref&&(rg=!1,e<f)?(b.expirationTime=a.expirationTime,$h(a,b,f)):di(a,b,c,d,f)}function ei(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function di(a,b,c,d,e){var f=L(c)?Bf:J.current;f=Cf(b,f);qg(b,e);c=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,c,e);return b.child}
	function fi(a,b,c,d,e){if(L(c)){var f=!0;Gf(b)}else f=!1;qg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),Lg(b,c,d),Ng(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l));var m=c.getDerivedStateFromProps,p="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;p||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
	"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l);tg=!1;var x=b.memoizedState;g.state=x;zg(b,d,g,e);k=b.memoizedState;h!==d||x!==k||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),k=b.memoizedState),(h=tg||Kg(b,c,h,d,x,k,l))?(p||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&g.UNSAFE_componentWillMount()),"function"===
	typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,vg(a,b),h=b.memoizedProps,g.props=b.type===b.elementType?h:ig(b.type,h),k=g.context,l=c.contextType,"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l)),m=c.getDerivedStateFromProps,(p="function"===typeof m||"function"===
	typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l),tg=!1,k=b.memoizedState,g.state=k,zg(b,d,g,e),x=b.memoizedState,h!==d||k!==x||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),x=b.memoizedState),(m=tg||Kg(b,c,h,d,k,x,l))?(p||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,
	x,l),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,x,l)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=d,b.memoizedState=x),g.props=d,g.state=x,g.context=l,d=m):
	("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return gi(a,b,c,d,f,e)}
	function gi(a,b,c,d,e,f){ei(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Hf(b,c,!1),$h(a,b,f);d=b.stateNode;Yh.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=Xg(b,a.child,null,f),b.child=Xg(b,null,h,f)):R(a,b,h,f);b.memoizedState=d.state;e&&Hf(b,c,!0);return b.child}function hi(a){var b=a.stateNode;b.pendingContext?Ef(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Ef(a,b.context,!1);dh(a,b.containerInfo)}
	var ii={dehydrated:null,retryTime:0};
	function ji(a,b,c){var d=b.mode,e=b.pendingProps,f=M.current,g=!1,h;(h=0!==(b.effectTag&64))||(h=0!==(f&2)&&(null===a||null!==a.memoizedState));h?(g=!0,b.effectTag&=-65):null!==a&&null===a.memoizedState||void 0===e.fallback||!0===e.unstable_avoidThisFallback||(f|=1);I(M,f&1);if(null===a){void 0!==e.fallback&&Uh(b);if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=
	b;e.sibling=c;b.memoizedState=ii;b.child=e;return c}d=e.children;b.memoizedState=null;return b.child=Yg(b,null,d,c)}if(null!==a.memoizedState){a=a.child;d=a.sibling;if(g){e=e.fallback;c=Sg(a,a.pendingProps);c.return=b;if(0===(b.mode&2)&&(g=null!==b.memoizedState?b.child.child:b.child,g!==a.child))for(c.child=g;null!==g;)g.return=c,g=g.sibling;d=Sg(d,e);d.return=b;c.sibling=d;c.childExpirationTime=0;b.memoizedState=ii;b.child=c;return d}c=Xg(b,a.child,e.children,c);b.memoizedState=null;return b.child=
	c}a=a.child;if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;e.child=a;null!==a&&(a.return=e);if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=b;e.sibling=c;c.effectTag|=2;e.childExpirationTime=0;b.memoizedState=ii;b.child=e;return c}b.memoizedState=null;return b.child=Xg(b,a,e.children,c)}
	function ki(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);pg(a.return,b)}function li(a,b,c,d,e,f){var g=a.memoizedState;null===g?a.memoizedState={isBackwards:b,rendering:null,renderingStartTime:0,last:d,tail:c,tailExpiration:0,tailMode:e,lastEffect:f}:(g.isBackwards=b,g.rendering=null,g.renderingStartTime=0,g.last=d,g.tail=c,g.tailExpiration=0,g.tailMode=e,g.lastEffect=f)}
	function mi(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;R(a,b,d.children,c);d=M.current;if(0!==(d&2))d=d&1|2,b.effectTag|=64;else{if(null!==a&&0!==(a.effectTag&64))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&ki(a,c);else if(19===a.tag)ki(a,c);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}I(M,d);if(0===(b.mode&2))b.memoizedState=
	null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===hh(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);li(b,!1,e,c,f,b.lastEffect);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===hh(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}li(b,!0,c,null,f,b.lastEffect);break;case "together":li(b,!1,null,null,void 0,b.lastEffect);break;default:b.memoizedState=null}return b.child}
	function $h(a,b,c){null!==a&&(b.dependencies=a.dependencies);var d=b.expirationTime;0!==d&&Bg(d);if(b.childExpirationTime<c)return null;if(null!==a&&b.child!==a.child)throw Error(u(153));if(null!==b.child){a=b.child;c=Sg(a,a.pendingProps);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Sg(a,a.pendingProps),c.return=b;c.sibling=null}return b.child}var ni,oi,pi,qi;
	ni=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};oi=function(){};
	pi=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;ch($g.current);a=null;switch(c){case "input":f=zb(g,f);d=zb(g,d);a=[];break;case "option":f=Gb(g,f);d=Gb(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=Ib(g,f);d=Ib(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=sd)}od(c,d);var h,k;c=null;for(h in f)if(!d.hasOwnProperty(h)&&f.hasOwnProperty(h)&&null!=f[h])if("style"===
	h)for(k in g=f[h],g)g.hasOwnProperty(k)&&(c||(c={}),c[k]="");else"dangerouslySetInnerHTML"!==h&&"children"!==h&&"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(va.hasOwnProperty(h)?a||(a=[]):(a=a||[]).push(h,null));for(h in d){var l=d[h];g=null!=f?f[h]:void 0;if(d.hasOwnProperty(h)&&l!==g&&(null!=l||null!=g))if("style"===h)if(g){for(k in g)!g.hasOwnProperty(k)||l&&l.hasOwnProperty(k)||(c||(c={}),c[k]="");for(k in l)l.hasOwnProperty(k)&&g[k]!==l[k]&&(c||(c={}),
	c[k]=l[k])}else c||(a||(a=[]),a.push(h,c)),c=l;else"dangerouslySetInnerHTML"===h?(l=l?l.__html:void 0,g=g?g.__html:void 0,null!=l&&g!==l&&(a=a||[]).push(h,l)):"children"===h?g===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(h,""+l):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&(va.hasOwnProperty(h)?(null!=l&&rd(e,h),a||g===l||(a=[])):(a=a||[]).push(h,l))}c&&(a=a||[]).push("style",c);e=a;if(b.updateQueue=e)b.effectTag|=4}};
	qi=function(a,b,c,d){c!==d&&(b.effectTag|=4)};function ri(a,b){switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
	function si(a,b,c){var d=b.pendingProps;switch(b.tag){case 2:case 16:case 15:case 0:case 11:case 7:case 8:case 12:case 9:case 14:return null;case 1:return L(b.type)&&Df(),null;case 3:return eh(),H(K),H(J),c=b.stateNode,c.pendingContext&&(c.context=c.pendingContext,c.pendingContext=null),null!==a&&null!==a.child||!Wh(b)||(b.effectTag|=4),oi(b),null;case 5:gh(b);c=ch(bh.current);var e=b.type;if(null!==a&&null!=b.stateNode)pi(a,b,e,d,c),a.ref!==b.ref&&(b.effectTag|=128);else{if(!d){if(null===b.stateNode)throw Error(u(166));
	return null}a=ch($g.current);if(Wh(b)){d=b.stateNode;e=b.type;var f=b.memoizedProps;d[Md]=b;d[Nd]=f;switch(e){case "iframe":case "object":case "embed":F("load",d);break;case "video":case "audio":for(a=0;a<ac.length;a++)F(ac[a],d);break;case "source":F("error",d);break;case "img":case "image":case "link":F("error",d);F("load",d);break;case "form":F("reset",d);F("submit",d);break;case "details":F("toggle",d);break;case "input":Ab(d,f);F("invalid",d);rd(c,"onChange");break;case "select":d._wrapperState=
	{wasMultiple:!!f.multiple};F("invalid",d);rd(c,"onChange");break;case "textarea":Jb(d,f),F("invalid",d),rd(c,"onChange")}od(e,f);a=null;for(var g in f)if(f.hasOwnProperty(g)){var h=f[g];"children"===g?"string"===typeof h?d.textContent!==h&&(a=["children",h]):"number"===typeof h&&d.textContent!==""+h&&(a=["children",""+h]):va.hasOwnProperty(g)&&null!=h&&rd(c,g)}switch(e){case "input":xb(d);Eb(d,f,!0);break;case "textarea":xb(d);Lb(d);break;case "select":case "option":break;default:"function"===typeof f.onClick&&
	(d.onclick=sd)}c=a;b.updateQueue=c;null!==c&&(b.effectTag|=4)}else{g=9===c.nodeType?c:c.ownerDocument;a===qd&&(a=Nb(e));a===qd?"script"===e?(a=g.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):"string"===typeof d.is?a=g.createElement(e,{is:d.is}):(a=g.createElement(e),"select"===e&&(g=a,d.multiple?g.multiple=!0:d.size&&(g.size=d.size))):a=g.createElementNS(a,e);a[Md]=b;a[Nd]=d;ni(a,b,!1,!1);b.stateNode=a;g=pd(e,d);switch(e){case "iframe":case "object":case "embed":F("load",
	a);h=d;break;case "video":case "audio":for(h=0;h<ac.length;h++)F(ac[h],a);h=d;break;case "source":F("error",a);h=d;break;case "img":case "image":case "link":F("error",a);F("load",a);h=d;break;case "form":F("reset",a);F("submit",a);h=d;break;case "details":F("toggle",a);h=d;break;case "input":Ab(a,d);h=zb(a,d);F("invalid",a);rd(c,"onChange");break;case "option":h=Gb(a,d);break;case "select":a._wrapperState={wasMultiple:!!d.multiple};h=n({},d,{value:void 0});F("invalid",a);rd(c,"onChange");break;case "textarea":Jb(a,
	d);h=Ib(a,d);F("invalid",a);rd(c,"onChange");break;default:h=d}od(e,h);var k=h;for(f in k)if(k.hasOwnProperty(f)){var l=k[f];"style"===f?md(a,l):"dangerouslySetInnerHTML"===f?(l=l?l.__html:void 0,null!=l&&Qb(a,l)):"children"===f?"string"===typeof l?("textarea"!==e||""!==l)&&Rb(a,l):"number"===typeof l&&Rb(a,""+l):"suppressContentEditableWarning"!==f&&"suppressHydrationWarning"!==f&&"autoFocus"!==f&&(va.hasOwnProperty(f)?null!=l&&rd(c,f):null!=l&&Xa(a,f,l,g))}switch(e){case "input":xb(a);Eb(a,d,!1);
	break;case "textarea":xb(a);Lb(a);break;case "option":null!=d.value&&a.setAttribute("value",""+rb(d.value));break;case "select":a.multiple=!!d.multiple;c=d.value;null!=c?Hb(a,!!d.multiple,c,!1):null!=d.defaultValue&&Hb(a,!!d.multiple,d.defaultValue,!0);break;default:"function"===typeof h.onClick&&(a.onclick=sd)}Fd(e,d)&&(b.effectTag|=4)}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)qi(a,b,a.memoizedProps,d);else{if("string"!==typeof d&&null===b.stateNode)throw Error(u(166));
	c=ch(bh.current);ch($g.current);Wh(b)?(c=b.stateNode,d=b.memoizedProps,c[Md]=b,c.nodeValue!==d&&(b.effectTag|=4)):(c=(9===c.nodeType?c:c.ownerDocument).createTextNode(d),c[Md]=b,b.stateNode=c)}return null;case 13:H(M);d=b.memoizedState;if(0!==(b.effectTag&64))return b.expirationTime=c,b;c=null!==d;d=!1;null===a?void 0!==b.memoizedProps.fallback&&Wh(b):(e=a.memoizedState,d=null!==e,c||null===e||(e=a.child.sibling,null!==e&&(f=b.firstEffect,null!==f?(b.firstEffect=e,e.nextEffect=f):(b.firstEffect=b.lastEffect=
	e,e.nextEffect=null),e.effectTag=8)));if(c&&!d&&0!==(b.mode&2))if(null===a&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(M.current&1))S===ti&&(S=ui);else{if(S===ti||S===ui)S=vi;0!==wi&&null!==T&&(xi(T,U),yi(T,wi))}if(c||d)b.effectTag|=4;return null;case 4:return eh(),oi(b),null;case 10:return og(b),null;case 17:return L(b.type)&&Df(),null;case 19:H(M);d=b.memoizedState;if(null===d)return null;e=0!==(b.effectTag&64);f=d.rendering;if(null===f)if(e)ri(d,!1);else{if(S!==ti||null!==a&&0!==(a.effectTag&
	64))for(f=b.child;null!==f;){a=hh(f);if(null!==a){b.effectTag|=64;ri(d,!1);e=a.updateQueue;null!==e&&(b.updateQueue=e,b.effectTag|=4);null===d.lastEffect&&(b.firstEffect=null);b.lastEffect=d.lastEffect;for(d=b.child;null!==d;)e=d,f=c,e.effectTag&=2,e.nextEffect=null,e.firstEffect=null,e.lastEffect=null,a=e.alternate,null===a?(e.childExpirationTime=0,e.expirationTime=f,e.child=null,e.memoizedProps=null,e.memoizedState=null,e.updateQueue=null,e.dependencies=null):(e.childExpirationTime=a.childExpirationTime,
	e.expirationTime=a.expirationTime,e.child=a.child,e.memoizedProps=a.memoizedProps,e.memoizedState=a.memoizedState,e.updateQueue=a.updateQueue,f=a.dependencies,e.dependencies=null===f?null:{expirationTime:f.expirationTime,firstContext:f.firstContext,responders:f.responders}),d=d.sibling;I(M,M.current&1|2);return b.child}f=f.sibling}}else{if(!e)if(a=hh(f),null!==a){if(b.effectTag|=64,e=!0,c=a.updateQueue,null!==c&&(b.updateQueue=c,b.effectTag|=4),ri(d,!0),null===d.tail&&"hidden"===d.tailMode&&!f.alternate)return b=
	b.lastEffect=d.lastEffect,null!==b&&(b.nextEffect=null),null}else 2*$f()-d.renderingStartTime>d.tailExpiration&&1<c&&(b.effectTag|=64,e=!0,ri(d,!1),b.expirationTime=b.childExpirationTime=c-1);d.isBackwards?(f.sibling=b.child,b.child=f):(c=d.last,null!==c?c.sibling=f:b.child=f,d.last=f)}return null!==d.tail?(0===d.tailExpiration&&(d.tailExpiration=$f()+500),c=d.tail,d.rendering=c,d.tail=c.sibling,d.lastEffect=b.lastEffect,d.renderingStartTime=$f(),c.sibling=null,b=M.current,I(M,e?b&1|2:b&1),c):null}throw Error(u(156,
	b.tag));}function zi(a){switch(a.tag){case 1:L(a.type)&&Df();var b=a.effectTag;return b&4096?(a.effectTag=b&-4097|64,a):null;case 3:eh();H(K);H(J);b=a.effectTag;if(0!==(b&64))throw Error(u(285));a.effectTag=b&-4097|64;return a;case 5:return gh(a),null;case 13:return H(M),b=a.effectTag,b&4096?(a.effectTag=b&-4097|64,a):null;case 19:return H(M),null;case 4:return eh(),null;case 10:return og(a),null;default:return null}}function Ai(a,b){return{value:a,source:b,stack:qb(b)}}
	var Bi="function"===typeof WeakSet?WeakSet:Set;function Ci(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=qb(c));null!==c&&pb(c.type);b=b.value;null!==a&&1===a.tag&&pb(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function Di(a,b){try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Ei(a,c)}}function Fi(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Ei(a,c)}else b.current=null}
	function Gi(a,b){switch(b.tag){case 0:case 11:case 15:case 22:return;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:ig(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}return;case 3:case 5:case 6:case 4:case 17:return}throw Error(u(163));}
	function Hi(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.destroy;c.destroy=void 0;void 0!==d&&d()}c=c.next}while(c!==b)}}function Ii(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.create;c.destroy=d()}c=c.next}while(c!==b)}}
	function Ji(a,b,c){switch(c.tag){case 0:case 11:case 15:case 22:Ii(3,c);return;case 1:a=c.stateNode;if(c.effectTag&4)if(null===b)a.componentDidMount();else{var d=c.elementType===c.type?b.memoizedProps:ig(c.type,b.memoizedProps);a.componentDidUpdate(d,b.memoizedState,a.__reactInternalSnapshotBeforeUpdate)}b=c.updateQueue;null!==b&&Cg(c,b,a);return;case 3:b=c.updateQueue;if(null!==b){a=null;if(null!==c.child)switch(c.child.tag){case 5:a=c.child.stateNode;break;case 1:a=c.child.stateNode}Cg(c,b,a)}return;
	case 5:a=c.stateNode;null===b&&c.effectTag&4&&Fd(c.type,c.memoizedProps)&&a.focus();return;case 6:return;case 4:return;case 12:return;case 13:null===c.memoizedState&&(c=c.alternate,null!==c&&(c=c.memoizedState,null!==c&&(c=c.dehydrated,null!==c&&Vc(c))));return;case 19:case 17:case 20:case 21:return}throw Error(u(163));}
	function Ki(a,b,c){"function"===typeof Li&&Li(b);switch(b.tag){case 0:case 11:case 14:case 15:case 22:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var d=a.next;cg(97<c?97:c,function(){var a=d;do{var c=a.destroy;if(void 0!==c){var g=b;try{c()}catch(h){Ei(g,h)}}a=a.next}while(a!==d)})}break;case 1:Fi(b);c=b.stateNode;"function"===typeof c.componentWillUnmount&&Di(b,c);break;case 5:Fi(b);break;case 4:Mi(a,b,c)}}
	function Ni(a){var b=a.alternate;a.return=null;a.child=null;a.memoizedState=null;a.updateQueue=null;a.dependencies=null;a.alternate=null;a.firstEffect=null;a.lastEffect=null;a.pendingProps=null;a.memoizedProps=null;a.stateNode=null;null!==b&&Ni(b)}function Oi(a){return 5===a.tag||3===a.tag||4===a.tag}
	function Pi(a){a:{for(var b=a.return;null!==b;){if(Oi(b)){var c=b;break a}b=b.return}throw Error(u(160));}b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw Error(u(161));}c.effectTag&16&&(Rb(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Oi(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&2)continue b;
	if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}d?Qi(a,c,b):Ri(a,c,b)}
	function Qi(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?8===c.nodeType?c.parentNode.insertBefore(a,b):c.insertBefore(a,b):(8===c.nodeType?(b=c.parentNode,b.insertBefore(a,c)):(b=c,b.appendChild(a)),c=c._reactRootContainer,null!==c&&void 0!==c||null!==b.onclick||(b.onclick=sd));else if(4!==d&&(a=a.child,null!==a))for(Qi(a,b,c),a=a.sibling;null!==a;)Qi(a,b,c),a=a.sibling}
	function Ri(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?c.insertBefore(a,b):c.appendChild(a);else if(4!==d&&(a=a.child,null!==a))for(Ri(a,b,c),a=a.sibling;null!==a;)Ri(a,b,c),a=a.sibling}
	function Mi(a,b,c){for(var d=b,e=!1,f,g;;){if(!e){e=d.return;a:for(;;){if(null===e)throw Error(u(160));f=e.stateNode;switch(e.tag){case 5:g=!1;break a;case 3:f=f.containerInfo;g=!0;break a;case 4:f=f.containerInfo;g=!0;break a}e=e.return}e=!0}if(5===d.tag||6===d.tag){a:for(var h=a,k=d,l=c,m=k;;)if(Ki(h,m,l),null!==m.child&&4!==m.tag)m.child.return=m,m=m.child;else{if(m===k)break a;for(;null===m.sibling;){if(null===m.return||m.return===k)break a;m=m.return}m.sibling.return=m.return;m=m.sibling}g?(h=
	f,k=d.stateNode,8===h.nodeType?h.parentNode.removeChild(k):h.removeChild(k)):f.removeChild(d.stateNode)}else if(4===d.tag){if(null!==d.child){f=d.stateNode.containerInfo;g=!0;d.child.return=d;d=d.child;continue}}else if(Ki(a,d,c),null!==d.child){d.child.return=d;d=d.child;continue}if(d===b)break;for(;null===d.sibling;){if(null===d.return||d.return===b)return;d=d.return;4===d.tag&&(e=!1)}d.sibling.return=d.return;d=d.sibling}}
	function Si(a,b){switch(b.tag){case 0:case 11:case 14:case 15:case 22:Hi(3,b);return;case 1:return;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[Nd]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Bb(c,d);pd(a,e);b=pd(a,d);for(e=0;e<f.length;e+=2){var g=f[e],h=f[e+1];"style"===g?md(c,h):"dangerouslySetInnerHTML"===g?Qb(c,h):"children"===g?Rb(c,h):Xa(c,g,h,b)}switch(a){case "input":Cb(c,d);break;
	case "textarea":Kb(c,d);break;case "select":b=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,a=d.value,null!=a?Hb(c,!!d.multiple,a,!1):b!==!!d.multiple&&(null!=d.defaultValue?Hb(c,!!d.multiple,d.defaultValue,!0):Hb(c,!!d.multiple,d.multiple?[]:"",!1))}}}return;case 6:if(null===b.stateNode)throw Error(u(162));b.stateNode.nodeValue=b.memoizedProps;return;case 3:b=b.stateNode;b.hydrate&&(b.hydrate=!1,Vc(b.containerInfo));return;case 12:return;case 13:c=b;null===b.memoizedState?
	d=!1:(d=!0,c=b.child,Ti=$f());if(null!==c)a:for(a=c;;){if(5===a.tag)f=a.stateNode,d?(f=f.style,"function"===typeof f.setProperty?f.setProperty("display","none","important"):f.display="none"):(f=a.stateNode,e=a.memoizedProps.style,e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null,f.style.display=ld("display",e));else if(6===a.tag)a.stateNode.nodeValue=d?"":a.memoizedProps;else if(13===a.tag&&null!==a.memoizedState&&null===a.memoizedState.dehydrated){f=a.child.sibling;f.return=a;a=
	f;continue}else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===c)break;for(;null===a.sibling;){if(null===a.return||a.return===c)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}Ui(b);return;case 19:Ui(b);return;case 17:return}throw Error(u(163));}function Ui(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Bi);b.forEach(function(b){var d=Vi.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}
	var Wi="function"===typeof WeakMap?WeakMap:Map;function Xi(a,b,c){c=wg(c,null);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Yi||(Yi=!0,Zi=d);Ci(a,b)};return c}
	function $i(a,b,c){c=wg(c,null);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){Ci(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===aj?aj=new Set([this]):aj.add(this),Ci(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
	var bj=Math.ceil,cj=Wa.ReactCurrentDispatcher,dj=Wa.ReactCurrentOwner,V=0,ej=8,fj=16,gj=32,ti=0,hj=1,ij=2,ui=3,vi=4,jj=5,W=V,T=null,X=null,U=0,S=ti,kj=null,lj=1073741823,mj=1073741823,nj=null,wi=0,oj=!1,Ti=0,pj=500,Y=null,Yi=!1,Zi=null,aj=null,qj=!1,rj=null,sj=90,tj=null,uj=0,vj=null,wj=0;function Gg(){return(W&(fj|gj))!==V?1073741821-($f()/10|0):0!==wj?wj:wj=1073741821-($f()/10|0)}
	function Hg(a,b,c){b=b.mode;if(0===(b&2))return 1073741823;var d=ag();if(0===(b&4))return 99===d?1073741823:1073741822;if((W&fj)!==V)return U;if(null!==c)a=hg(a,c.timeoutMs|0||5E3,250);else switch(d){case 99:a=1073741823;break;case 98:a=hg(a,150,100);break;case 97:case 96:a=hg(a,5E3,250);break;case 95:a=2;break;default:throw Error(u(326));}null!==T&&a===U&&--a;return a}
	function Ig(a,b){if(50<uj)throw uj=0,vj=null,Error(u(185));a=xj(a,b);if(null!==a){var c=ag();1073741823===b?(W&ej)!==V&&(W&(fj|gj))===V?yj(a):(Z(a),W===V&&gg()):Z(a);(W&4)===V||98!==c&&99!==c||(null===tj?tj=new Map([[a,b]]):(c=tj.get(a),(void 0===c||c>b)&&tj.set(a,b)))}}
	function xj(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}null!==e&&(T===e&&(Bg(b),S===vi&&xi(e,U)),yi(e,b));return e}
	function zj(a){var b=a.lastExpiredTime;if(0!==b)return b;b=a.firstPendingTime;if(!Aj(a,b))return b;var c=a.lastPingedTime;a=a.nextKnownPendingLevel;a=c>a?c:a;return 2>=a&&b!==a?0:a}
	function Z(a){if(0!==a.lastExpiredTime)a.callbackExpirationTime=1073741823,a.callbackPriority=99,a.callbackNode=eg(yj.bind(null,a));else{var b=zj(a),c=a.callbackNode;if(0===b)null!==c&&(a.callbackNode=null,a.callbackExpirationTime=0,a.callbackPriority=90);else{var d=Gg();1073741823===b?d=99:1===b||2===b?d=95:(d=10*(1073741821-b)-10*(1073741821-d),d=0>=d?99:250>=d?98:5250>=d?97:95);if(null!==c){var e=a.callbackPriority;if(a.callbackExpirationTime===b&&e>=d)return;c!==Tf&&Kf(c)}a.callbackExpirationTime=
	b;a.callbackPriority=d;b=1073741823===b?eg(yj.bind(null,a)):dg(d,Bj.bind(null,a),{timeout:10*(1073741821-b)-$f()});a.callbackNode=b}}}
	function Bj(a,b){wj=0;if(b)return b=Gg(),Cj(a,b),Z(a),null;var c=zj(a);if(0!==c){b=a.callbackNode;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&c===U||Ej(a,c);if(null!==X){var d=W;W|=fj;var e=Fj();do try{Gj();break}catch(h){Hj(a,h)}while(1);ng();W=d;cj.current=e;if(S===hj)throw b=kj,Ej(a,c),xi(a,c),Z(a),b;if(null===X)switch(e=a.finishedWork=a.current.alternate,a.finishedExpirationTime=c,d=S,T=null,d){case ti:case hj:throw Error(u(345));case ij:Cj(a,2<c?2:c);break;case ui:xi(a,c);d=a.lastSuspendedTime;
	c===d&&(a.nextKnownPendingLevel=Ij(e));if(1073741823===lj&&(e=Ti+pj-$f(),10<e)){if(oj){var f=a.lastPingedTime;if(0===f||f>=c){a.lastPingedTime=c;Ej(a,c);break}}f=zj(a);if(0!==f&&f!==c)break;if(0!==d&&d!==c){a.lastPingedTime=d;break}a.timeoutHandle=Hd(Jj.bind(null,a),e);break}Jj(a);break;case vi:xi(a,c);d=a.lastSuspendedTime;c===d&&(a.nextKnownPendingLevel=Ij(e));if(oj&&(e=a.lastPingedTime,0===e||e>=c)){a.lastPingedTime=c;Ej(a,c);break}e=zj(a);if(0!==e&&e!==c)break;if(0!==d&&d!==c){a.lastPingedTime=
	d;break}1073741823!==mj?d=10*(1073741821-mj)-$f():1073741823===lj?d=0:(d=10*(1073741821-lj)-5E3,e=$f(),c=10*(1073741821-c)-e,d=e-d,0>d&&(d=0),d=(120>d?120:480>d?480:1080>d?1080:1920>d?1920:3E3>d?3E3:4320>d?4320:1960*bj(d/1960))-d,c<d&&(d=c));if(10<d){a.timeoutHandle=Hd(Jj.bind(null,a),d);break}Jj(a);break;case jj:if(1073741823!==lj&&null!==nj){f=lj;var g=nj;d=g.busyMinDurationMs|0;0>=d?d=0:(e=g.busyDelayMs|0,f=$f()-(10*(1073741821-f)-(g.timeoutMs|0||5E3)),d=f<=e?0:e+d-f);if(10<d){xi(a,c);a.timeoutHandle=
	Hd(Jj.bind(null,a),d);break}}Jj(a);break;default:throw Error(u(329));}Z(a);if(a.callbackNode===b)return Bj.bind(null,a)}}return null}
	function yj(a){var b=a.lastExpiredTime;b=0!==b?b:1073741823;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&b===U||Ej(a,b);if(null!==X){var c=W;W|=fj;var d=Fj();do try{Kj();break}catch(e){Hj(a,e)}while(1);ng();W=c;cj.current=d;if(S===hj)throw c=kj,Ej(a,b),xi(a,b),Z(a),c;if(null!==X)throw Error(u(261));a.finishedWork=a.current.alternate;a.finishedExpirationTime=b;T=null;Jj(a);Z(a)}return null}function Lj(){if(null!==tj){var a=tj;tj=null;a.forEach(function(a,c){Cj(c,a);Z(c)});gg()}}
	function Mj(a,b){var c=W;W|=1;try{return a(b)}finally{W=c,W===V&&gg()}}function Nj(a,b){var c=W;W&=-2;W|=ej;try{return a(b)}finally{W=c,W===V&&gg()}}
	function Ej(a,b){a.finishedWork=null;a.finishedExpirationTime=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,Id(c));if(null!==X)for(c=X.return;null!==c;){var d=c;switch(d.tag){case 1:d=d.type.childContextTypes;null!==d&&void 0!==d&&Df();break;case 3:eh();H(K);H(J);break;case 5:gh(d);break;case 4:eh();break;case 13:H(M);break;case 19:H(M);break;case 10:og(d)}c=c.return}T=a;X=Sg(a.current,null);U=b;S=ti;kj=null;mj=lj=1073741823;nj=null;wi=0;oj=!1}
	function Hj(a,b){do{try{ng();jh.current=sh;if(mh)for(var c=N.memoizedState;null!==c;){var d=c.queue;null!==d&&(d.pending=null);c=c.next}lh=0;P=O=N=null;mh=!1;if(null===X||null===X.return)return S=hj,kj=b,X=null;a:{var e=a,f=X.return,g=X,h=b;b=U;g.effectTag|=2048;g.firstEffect=g.lastEffect=null;if(null!==h&&"object"===typeof h&&"function"===typeof h.then){var k=h;if(0===(g.mode&2)){var l=g.alternate;l?(g.updateQueue=l.updateQueue,g.memoizedState=l.memoizedState,g.expirationTime=l.expirationTime):(g.updateQueue=
	null,g.memoizedState=null)}var m=0!==(M.current&1),p=f;do{var x;if(x=13===p.tag){var z=p.memoizedState;if(null!==z)x=null!==z.dehydrated?!0:!1;else{var ca=p.memoizedProps;x=void 0===ca.fallback?!1:!0!==ca.unstable_avoidThisFallback?!0:m?!1:!0}}if(x){var D=p.updateQueue;if(null===D){var t=new Set;t.add(k);p.updateQueue=t}else D.add(k);if(0===(p.mode&2)){p.effectTag|=64;g.effectTag&=-2981;if(1===g.tag)if(null===g.alternate)g.tag=17;else{var y=wg(1073741823,null);y.tag=2;xg(g,y)}g.expirationTime=1073741823;
	break a}h=void 0;g=b;var A=e.pingCache;null===A?(A=e.pingCache=new Wi,h=new Set,A.set(k,h)):(h=A.get(k),void 0===h&&(h=new Set,A.set(k,h)));if(!h.has(g)){h.add(g);var q=Oj.bind(null,e,k,g);k.then(q,q)}p.effectTag|=4096;p.expirationTime=b;break a}p=p.return}while(null!==p);h=Error((pb(g.type)||"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+qb(g))}S!==
	jj&&(S=ij);h=Ai(h,g);p=f;do{switch(p.tag){case 3:k=h;p.effectTag|=4096;p.expirationTime=b;var B=Xi(p,k,b);yg(p,B);break a;case 1:k=h;var w=p.type,ub=p.stateNode;if(0===(p.effectTag&64)&&("function"===typeof w.getDerivedStateFromError||null!==ub&&"function"===typeof ub.componentDidCatch&&(null===aj||!aj.has(ub)))){p.effectTag|=4096;p.expirationTime=b;var vb=$i(p,k,b);yg(p,vb);break a}}p=p.return}while(null!==p)}X=Pj(X)}catch(Xc){b=Xc;continue}break}while(1)}
	function Fj(){var a=cj.current;cj.current=sh;return null===a?sh:a}function Ag(a,b){a<lj&&2<a&&(lj=a);null!==b&&a<mj&&2<a&&(mj=a,nj=b)}function Bg(a){a>wi&&(wi=a)}function Kj(){for(;null!==X;)X=Qj(X)}function Gj(){for(;null!==X&&!Uf();)X=Qj(X)}function Qj(a){var b=Rj(a.alternate,a,U);a.memoizedProps=a.pendingProps;null===b&&(b=Pj(a));dj.current=null;return b}
	function Pj(a){X=a;do{var b=X.alternate;a=X.return;if(0===(X.effectTag&2048)){b=si(b,X,U);if(1===U||1!==X.childExpirationTime){for(var c=0,d=X.child;null!==d;){var e=d.expirationTime,f=d.childExpirationTime;e>c&&(c=e);f>c&&(c=f);d=d.sibling}X.childExpirationTime=c}if(null!==b)return b;null!==a&&0===(a.effectTag&2048)&&(null===a.firstEffect&&(a.firstEffect=X.firstEffect),null!==X.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=X.firstEffect),a.lastEffect=X.lastEffect),1<X.effectTag&&(null!==
	a.lastEffect?a.lastEffect.nextEffect=X:a.firstEffect=X,a.lastEffect=X))}else{b=zi(X);if(null!==b)return b.effectTag&=2047,b;null!==a&&(a.firstEffect=a.lastEffect=null,a.effectTag|=2048)}b=X.sibling;if(null!==b)return b;X=a}while(null!==X);S===ti&&(S=jj);return null}function Ij(a){var b=a.expirationTime;a=a.childExpirationTime;return b>a?b:a}function Jj(a){var b=ag();cg(99,Sj.bind(null,a,b));return null}
	function Sj(a,b){do Dj();while(null!==rj);if((W&(fj|gj))!==V)throw Error(u(327));var c=a.finishedWork,d=a.finishedExpirationTime;if(null===c)return null;a.finishedWork=null;a.finishedExpirationTime=0;if(c===a.current)throw Error(u(177));a.callbackNode=null;a.callbackExpirationTime=0;a.callbackPriority=90;a.nextKnownPendingLevel=0;var e=Ij(c);a.firstPendingTime=e;d<=a.lastSuspendedTime?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:d<=a.firstSuspendedTime&&(a.firstSuspendedTime=
	d-1);d<=a.lastPingedTime&&(a.lastPingedTime=0);d<=a.lastExpiredTime&&(a.lastExpiredTime=0);a===T&&(X=T=null,U=0);1<c.effectTag?null!==c.lastEffect?(c.lastEffect.nextEffect=c,e=c.firstEffect):e=c:e=c.firstEffect;if(null!==e){var f=W;W|=gj;dj.current=null;Dd=fd;var g=xd();if(yd(g)){if("selectionStart"in g)var h={start:g.selectionStart,end:g.selectionEnd};else a:{h=(h=g.ownerDocument)&&h.defaultView||window;var k=h.getSelection&&h.getSelection();if(k&&0!==k.rangeCount){h=k.anchorNode;var l=k.anchorOffset,
	m=k.focusNode;k=k.focusOffset;try{h.nodeType,m.nodeType}catch(wb){h=null;break a}var p=0,x=-1,z=-1,ca=0,D=0,t=g,y=null;b:for(;;){for(var A;;){t!==h||0!==l&&3!==t.nodeType||(x=p+l);t!==m||0!==k&&3!==t.nodeType||(z=p+k);3===t.nodeType&&(p+=t.nodeValue.length);if(null===(A=t.firstChild))break;y=t;t=A}for(;;){if(t===g)break b;y===h&&++ca===l&&(x=p);y===m&&++D===k&&(z=p);if(null!==(A=t.nextSibling))break;t=y;y=t.parentNode}t=A}h=-1===x||-1===z?null:{start:x,end:z}}else h=null}h=h||{start:0,end:0}}else h=
	null;Ed={activeElementDetached:null,focusedElem:g,selectionRange:h};fd=!1;Y=e;do try{Tj()}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=e;do try{for(g=a,h=b;null!==Y;){var q=Y.effectTag;q&16&&Rb(Y.stateNode,"");if(q&128){var B=Y.alternate;if(null!==B){var w=B.ref;null!==w&&("function"===typeof w?w(null):w.current=null)}}switch(q&1038){case 2:Pi(Y);Y.effectTag&=-3;break;case 6:Pi(Y);Y.effectTag&=-3;Si(Y.alternate,Y);break;case 1024:Y.effectTag&=-1025;break;case 1028:Y.effectTag&=
	-1025;Si(Y.alternate,Y);break;case 4:Si(Y.alternate,Y);break;case 8:l=Y,Mi(g,l,h),Ni(l)}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);w=Ed;B=xd();q=w.focusedElem;h=w.selectionRange;if(B!==q&&q&&q.ownerDocument&&wd(q.ownerDocument.documentElement,q)){null!==h&&yd(q)&&(B=h.start,w=h.end,void 0===w&&(w=B),"selectionStart"in q?(q.selectionStart=B,q.selectionEnd=Math.min(w,q.value.length)):(w=(B=q.ownerDocument||document)&&B.defaultView||window,w.getSelection&&
	(w=w.getSelection(),l=q.textContent.length,g=Math.min(h.start,l),h=void 0===h.end?g:Math.min(h.end,l),!w.extend&&g>h&&(l=h,h=g,g=l),l=vd(q,g),m=vd(q,h),l&&m&&(1!==w.rangeCount||w.anchorNode!==l.node||w.anchorOffset!==l.offset||w.focusNode!==m.node||w.focusOffset!==m.offset)&&(B=B.createRange(),B.setStart(l.node,l.offset),w.removeAllRanges(),g>h?(w.addRange(B),w.extend(m.node,m.offset)):(B.setEnd(m.node,m.offset),w.addRange(B))))));B=[];for(w=q;w=w.parentNode;)1===w.nodeType&&B.push({element:w,left:w.scrollLeft,
	top:w.scrollTop});"function"===typeof q.focus&&q.focus();for(q=0;q<B.length;q++)w=B[q],w.element.scrollLeft=w.left,w.element.scrollTop=w.top}fd=!!Dd;Ed=Dd=null;a.current=c;Y=e;do try{for(q=a;null!==Y;){var ub=Y.effectTag;ub&36&&Ji(q,Y.alternate,Y);if(ub&128){B=void 0;var vb=Y.ref;if(null!==vb){var Xc=Y.stateNode;switch(Y.tag){case 5:B=Xc;break;default:B=Xc}"function"===typeof vb?vb(B):vb.current=B}}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=
	null;Vf();W=f}else a.current=c;if(qj)qj=!1,rj=a,sj=b;else for(Y=e;null!==Y;)b=Y.nextEffect,Y.nextEffect=null,Y=b;b=a.firstPendingTime;0===b&&(aj=null);1073741823===b?a===vj?uj++:(uj=0,vj=a):uj=0;"function"===typeof Uj&&Uj(c.stateNode,d);Z(a);if(Yi)throw Yi=!1,a=Zi,Zi=null,a;if((W&ej)!==V)return null;gg();return null}function Tj(){for(;null!==Y;){var a=Y.effectTag;0!==(a&256)&&Gi(Y.alternate,Y);0===(a&512)||qj||(qj=!0,dg(97,function(){Dj();return null}));Y=Y.nextEffect}}
	function Dj(){if(90!==sj){var a=97<sj?97:sj;sj=90;return cg(a,Vj)}}function Vj(){if(null===rj)return!1;var a=rj;rj=null;if((W&(fj|gj))!==V)throw Error(u(331));var b=W;W|=gj;for(a=a.current.firstEffect;null!==a;){try{var c=a;if(0!==(c.effectTag&512))switch(c.tag){case 0:case 11:case 15:case 22:Hi(5,c),Ii(5,c)}}catch(d){if(null===a)throw Error(u(330));Ei(a,d)}c=a.nextEffect;a.nextEffect=null;a=c}W=b;gg();return!0}
	function Wj(a,b,c){b=Ai(c,b);b=Xi(a,b,1073741823);xg(a,b);a=xj(a,1073741823);null!==a&&Z(a)}function Ei(a,b){if(3===a.tag)Wj(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){Wj(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===aj||!aj.has(d))){a=Ai(b,a);a=$i(c,a,1073741823);xg(c,a);c=xj(c,1073741823);null!==c&&Z(c);break}}c=c.return}}
	function Oj(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);T===a&&U===c?S===vi||S===ui&&1073741823===lj&&$f()-Ti<pj?Ej(a,U):oj=!0:Aj(a,c)&&(b=a.lastPingedTime,0!==b&&b<c||(a.lastPingedTime=c,Z(a)))}function Vi(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=0;0===b&&(b=Gg(),b=Hg(b,a,null));a=xj(a,b);null!==a&&Z(a)}var Rj;
	Rj=function(a,b,c){var d=b.expirationTime;if(null!==a){var e=b.pendingProps;if(a.memoizedProps!==e||K.current)rg=!0;else{if(d<c){rg=!1;switch(b.tag){case 3:hi(b);Xh();break;case 5:fh(b);if(b.mode&4&&1!==c&&e.hidden)return b.expirationTime=b.childExpirationTime=1,null;break;case 1:L(b.type)&&Gf(b);break;case 4:dh(b,b.stateNode.containerInfo);break;case 10:d=b.memoizedProps.value;e=b.type._context;I(jg,e._currentValue);e._currentValue=d;break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;
	if(0!==d&&d>=c)return ji(a,b,c);I(M,M.current&1);b=$h(a,b,c);return null!==b?b.sibling:null}I(M,M.current&1);break;case 19:d=b.childExpirationTime>=c;if(0!==(a.effectTag&64)){if(d)return mi(a,b,c);b.effectTag|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null);I(M,M.current);if(!d)return null}return $h(a,b,c)}rg=!1}}else rg=!1;b.expirationTime=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Cf(b,J.current);qg(b,c);e=oh(null,
	b,d,a,e,c);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;b.memoizedState=null;b.updateQueue=null;if(L(d)){var f=!0;Gf(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;ug(b);var g=d.getDerivedStateFromProps;"function"===typeof g&&Fg(b,d,g,a);e.updater=Jg;b.stateNode=e;e._reactInternalFiber=b;Ng(b,d,a,c);b=gi(null,b,d,!0,f,c)}else b.tag=0,R(null,b,e,c),b=b.child;return b;case 16:a:{e=b.elementType;null!==a&&(a.alternate=
	null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;ob(e);if(1!==e._status)throw e._result;e=e._result;b.type=e;f=b.tag=Xj(e);a=ig(e,a);switch(f){case 0:b=di(null,b,e,a,c);break a;case 1:b=fi(null,b,e,a,c);break a;case 11:b=Zh(null,b,e,a,c);break a;case 14:b=ai(null,b,e,ig(e.type,a),d,c);break a}throw Error(u(306,e,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),di(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),fi(a,b,d,e,c);
	case 3:hi(b);d=b.updateQueue;if(null===a||null===d)throw Error(u(282));d=b.pendingProps;e=b.memoizedState;e=null!==e?e.element:null;vg(a,b);zg(b,d,null,c);d=b.memoizedState.element;if(d===e)Xh(),b=$h(a,b,c);else{if(e=b.stateNode.hydrate)Ph=Jd(b.stateNode.containerInfo.firstChild),Oh=b,e=Qh=!0;if(e)for(c=Yg(b,null,d,c),b.child=c;c;)c.effectTag=c.effectTag&-3|1024,c=c.sibling;else R(a,b,d,c),Xh();b=b.child}return b;case 5:return fh(b),null===a&&Uh(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:
	null,g=e.children,Gd(d,e)?g=null:null!==f&&Gd(d,f)&&(b.effectTag|=16),ei(a,b),b.mode&4&&1!==c&&e.hidden?(b.expirationTime=b.childExpirationTime=1,b=null):(R(a,b,g,c),b=b.child),b;case 6:return null===a&&Uh(b),null;case 13:return ji(a,b,c);case 4:return dh(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Xg(b,null,d,c):R(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),Zh(a,b,d,e,c);case 7:return R(a,b,b.pendingProps,c),b.child;case 8:return R(a,
	b,b.pendingProps.children,c),b.child;case 12:return R(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;var h=b.type._context;I(jg,h._currentValue);h._currentValue=f;if(null!==g)if(h=g.value,f=$e(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0,0===f){if(g.children===e.children&&!K.current){b=$h(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var k=h.dependencies;if(null!==
	k){g=h.child;for(var l=k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===h.tag&&(l=wg(c,null),l.tag=2,xg(h,l));h.expirationTime<c&&(h.expirationTime=c);l=h.alternate;null!==l&&l.expirationTime<c&&(l.expirationTime=c);pg(h.return,c);k.expirationTime<c&&(k.expirationTime=c);break}l=l.next}}else g=10===h.tag?h.type===b.type?null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=
	g}R(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,qg(b,c),e=sg(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,R(a,b,d,c),b.child;case 14:return e=b.type,f=ig(e,b.pendingProps),f=ig(e.type,f),ai(a,b,e,f,d,c);case 15:return ci(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,L(d)?(a=!0,Gf(b)):a=!1,qg(b,c),Lg(b,d,e),Ng(b,d,e,c),gi(null,
	b,d,!0,a,c);case 19:return mi(a,b,c)}throw Error(u(156,b.tag));};var Uj=null,Li=null;function Yj(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Uj=function(a){try{b.onCommitFiberRoot(c,a,void 0,64===(a.current.effectTag&64))}catch(e){}};Li=function(a){try{b.onCommitFiberUnmount(c,a)}catch(e){}}}catch(d){}return!0}
	function Zj(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function Sh(a,b,c,d){return new Zj(a,b,c,d)}
	function bi(a){a=a.prototype;return!(!a||!a.isReactComponent)}function Xj(a){if("function"===typeof a)return bi(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===gb)return 11;if(a===jb)return 14}return 2}
	function Sg(a,b){var c=a.alternate;null===c?(c=Sh(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{expirationTime:b.expirationTime,
	firstContext:b.firstContext,responders:b.responders};c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
	function Ug(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)bi(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case ab:return Wg(c.children,e,f,b);case fb:g=8;e|=7;break;case bb:g=8;e|=1;break;case cb:return a=Sh(12,c,b,e|8),a.elementType=cb,a.type=cb,a.expirationTime=f,a;case hb:return a=Sh(13,c,b,e),a.type=hb,a.elementType=hb,a.expirationTime=f,a;case ib:return a=Sh(19,c,b,e),a.elementType=ib,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case db:g=
	10;break a;case eb:g=9;break a;case gb:g=11;break a;case jb:g=14;break a;case kb:g=16;d=null;break a;case lb:g=22;break a}throw Error(u(130,null==a?a:typeof a,""));}b=Sh(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function Wg(a,b,c,d){a=Sh(7,a,d,b);a.expirationTime=c;return a}function Tg(a,b,c){a=Sh(6,a,null,b);a.expirationTime=c;return a}
	function Vg(a,b,c){b=Sh(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
	function ak(a,b,c){this.tag=b;this.current=null;this.containerInfo=a;this.pingCache=this.pendingChildren=null;this.finishedExpirationTime=0;this.finishedWork=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=null;this.callbackPriority=90;this.lastExpiredTime=this.lastPingedTime=this.nextKnownPendingLevel=this.lastSuspendedTime=this.firstSuspendedTime=this.firstPendingTime=0}
	function Aj(a,b){var c=a.firstSuspendedTime;a=a.lastSuspendedTime;return 0!==c&&c>=b&&a<=b}function xi(a,b){var c=a.firstSuspendedTime,d=a.lastSuspendedTime;c<b&&(a.firstSuspendedTime=b);if(d>b||0===c)a.lastSuspendedTime=b;b<=a.lastPingedTime&&(a.lastPingedTime=0);b<=a.lastExpiredTime&&(a.lastExpiredTime=0)}
	function yi(a,b){b>a.firstPendingTime&&(a.firstPendingTime=b);var c=a.firstSuspendedTime;0!==c&&(b>=c?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:b>=a.lastSuspendedTime&&(a.lastSuspendedTime=b+1),b>a.nextKnownPendingLevel&&(a.nextKnownPendingLevel=b))}function Cj(a,b){var c=a.lastExpiredTime;if(0===c||c>b)a.lastExpiredTime=b}
	function bk(a,b,c,d){var e=b.current,f=Gg(),g=Dg.suspense;f=Hg(f,e,g);a:if(c){c=c._reactInternalFiber;b:{if(dc(c)!==c||1!==c.tag)throw Error(u(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(L(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return}while(null!==h);throw Error(u(171));}if(1===c.tag){var k=c.type;if(L(k)){c=Ff(c,k,h);break a}}c=h}else c=Af;null===b.context?b.context=c:b.pendingContext=c;b=wg(f,g);b.payload={element:a};d=void 0===
	d?null:d;null!==d&&(b.callback=d);xg(e,b);Ig(e,f);return f}function ck(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function dk(a,b){a=a.memoizedState;null!==a&&null!==a.dehydrated&&a.retryTime<b&&(a.retryTime=b)}function ek(a,b){dk(a,b);(a=a.alternate)&&dk(a,b)}
	function fk(a,b,c){c=null!=c&&!0===c.hydrate;var d=new ak(a,b,c),e=Sh(3,null,null,2===b?7:1===b?3:0);d.current=e;e.stateNode=d;ug(e);a[Od]=d.current;c&&0!==b&&Jc(a,9===a.nodeType?a:a.ownerDocument);this._internalRoot=d}fk.prototype.render=function(a){bk(a,this._internalRoot,null,null)};fk.prototype.unmount=function(){var a=this._internalRoot,b=a.containerInfo;bk(null,a,null,function(){b[Od]=null})};
	function gk(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}function hk(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new fk(a,0,b?{hydrate:!0}:void 0)}
	function ik(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f._internalRoot;if("function"===typeof e){var h=e;e=function(){var a=ck(g);h.call(a)}}bk(b,g,a,e)}else{f=c._reactRootContainer=hk(c,d);g=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=ck(g);k.call(a)}}Nj(function(){bk(b,g,a,e)})}return ck(g)}function jk(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:$a,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
	wc=function(a){if(13===a.tag){var b=hg(Gg(),150,100);Ig(a,b);ek(a,b)}};xc=function(a){13===a.tag&&(Ig(a,3),ek(a,3))};yc=function(a){if(13===a.tag){var b=Gg();b=Hg(b,a,null);Ig(a,b);ek(a,b)}};
	za=function(a,b,c){switch(b){case "input":Cb(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Qd(d);if(!e)throw Error(u(90));yb(d);Cb(d,e)}}}break;case "textarea":Kb(a,c);break;case "select":b=c.value,null!=b&&Hb(a,!!c.multiple,b,!1)}};Fa=Mj;
	Ga=function(a,b,c,d,e){var f=W;W|=4;try{return cg(98,a.bind(null,b,c,d,e))}finally{W=f,W===V&&gg()}};Ha=function(){(W&(1|fj|gj))===V&&(Lj(),Dj())};Ia=function(a,b){var c=W;W|=2;try{return a(b)}finally{W=c,W===V&&gg()}};function kk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!gk(b))throw Error(u(200));return jk(a,b,null,c)}var lk={Events:[Nc,Pd,Qd,xa,ta,Xd,function(a){jc(a,Wd)},Da,Ea,id,mc,Dj,{current:!1}]};
	(function(a){var b=a.findFiberByHostInstance;return Yj(n({},a,{overrideHookState:null,overrideProps:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:Wa.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=hc(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null}))})({findFiberByHostInstance:tc,bundleType:0,version:"16.14.0",
	rendererPackageName:"react-dom"});exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=lk;exports.createPortal=kk;exports.findDOMNode=function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(void 0===b){if("function"===typeof a.render)throw Error(u(188));throw Error(u(268,Object.keys(a)));}a=hc(b);a=null===a?null:a.stateNode;return a};
	exports.flushSync=function(a,b){if((W&(fj|gj))!==V)throw Error(u(187));var c=W;W|=1;try{return cg(99,a.bind(null,b))}finally{W=c,gg()}};exports.hydrate=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!0,c)};exports.render=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!1,c)};
	exports.unmountComponentAtNode=function(a){if(!gk(a))throw Error(u(40));return a._reactRootContainer?(Nj(function(){ik(null,null,a,!1,function(){a._reactRootContainer=null;a[Od]=null})}),!0):!1};exports.unstable_batchedUpdates=Mj;exports.unstable_createPortal=function(a,b){return kk(a,b,2<arguments.length&&void 0!==arguments[2]?arguments[2]:null)};
	exports.unstable_renderSubtreeIntoContainer=function(a,b,c,d){if(!gk(c))throw Error(u(200));if(null==a||void 0===a._reactInternalFiber)throw Error(u(38));return ik(a,b,c,!1,d)};exports.version="16.14.0";


/***/ },
/* 1377 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(1375);
	} else {
	  module.exports = require('./cjs/react-dom-server.browser.development.js');
	}


/***/ },
/* 1378 */
/***/ function(module, exports) {

	/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */
	
	var hasElementType = typeof Element !== 'undefined';
	var hasMap = typeof Map === 'function';
	var hasSet = typeof Set === 'function';
	var hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;
	
	// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
	
	function equal(a, b) {
	  // START: fast-deep-equal es6/index.js 3.1.3
	  if (a === b) return true;
	
	  if (a && b && typeof a == 'object' && typeof b == 'object') {
	    if (a.constructor !== b.constructor) return false;
	
	    var length, i, keys;
	    if (Array.isArray(a)) {
	      length = a.length;
	      if (length != b.length) return false;
	      for (i = length; i-- !== 0;)
	        if (!equal(a[i], b[i])) return false;
	      return true;
	    }
	
	    // START: Modifications:
	    // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
	    //    to co-exist with es5.
	    // 2. Replace `for of` with es5 compliant iteration using `for`.
	    //    Basically, take:
	    //
	    //    ```js
	    //    for (i of a.entries())
	    //      if (!b.has(i[0])) return false;
	    //    ```
	    //
	    //    ... and convert to:
	    //
	    //    ```js
	    //    it = a.entries();
	    //    while (!(i = it.next()).done)
	    //      if (!b.has(i.value[0])) return false;
	    //    ```
	    //
	    //    **Note**: `i` access switches to `i.value`.
	    var it;
	    if (hasMap && (a instanceof Map) && (b instanceof Map)) {
	      if (a.size !== b.size) return false;
	      it = a.entries();
	      while (!(i = it.next()).done)
	        if (!b.has(i.value[0])) return false;
	      it = a.entries();
	      while (!(i = it.next()).done)
	        if (!equal(i.value[1], b.get(i.value[0]))) return false;
	      return true;
	    }
	
	    if (hasSet && (a instanceof Set) && (b instanceof Set)) {
	      if (a.size !== b.size) return false;
	      it = a.entries();
	      while (!(i = it.next()).done)
	        if (!b.has(i.value[0])) return false;
	      return true;
	    }
	    // END: Modifications
	
	    if (hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
	      length = a.length;
	      if (length != b.length) return false;
	      for (i = length; i-- !== 0;)
	        if (a[i] !== b[i]) return false;
	      return true;
	    }
	
	    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
	    // START: Modifications:
	    // Apply guards for `Object.create(null)` handling. See:
	    // - https://github.com/FormidableLabs/react-fast-compare/issues/64
	    // - https://github.com/epoberezkin/fast-deep-equal/issues/49
	    if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === 'function' && typeof b.valueOf === 'function') return a.valueOf() === b.valueOf();
	    if (a.toString !== Object.prototype.toString && typeof a.toString === 'function' && typeof b.toString === 'function') return a.toString() === b.toString();
	    // END: Modifications
	
	    keys = Object.keys(a);
	    length = keys.length;
	    if (length !== Object.keys(b).length) return false;
	
	    for (i = length; i-- !== 0;)
	      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
	    // END: fast-deep-equal
	
	    // START: react-fast-compare
	    // custom handling for DOM elements
	    if (hasElementType && a instanceof Element) return false;
	
	    // custom handling for React/Preact
	    for (i = length; i-- !== 0;) {
	      if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) {
	        // React-specific: avoid traversing React elements' _owner
	        // Preact-specific: avoid traversing Preact elements' __v and __o
	        //    __v = $_original / $_vnode
	        //    __o = $_owner
	        // These properties contain circular references and are not needed when
	        // comparing the actual elements (and not their owners)
	        // .$$typeof and ._store on just reasonable markers of elements
	
	        continue;
	      }
	
	      // all other properties should be traversed as usual
	      if (!equal(a[keys[i]], b[keys[i]])) return false;
	    }
	    // END: react-fast-compare
	
	    // START: fast-deep-equal
	    return true;
	  }
	
	  return a !== a && b !== b;
	}
	// end fast-deep-equal
	
	module.exports = function isEqual(a, b) {
	  try {
	    return equal(a, b);
	  } catch (error) {
	    if (((error.message || '').match(/stack|recursion/i))) {
	      // warn on circular references, don't crash
	      // browsers give this different errors name and messages:
	      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
	      // firefox: "InternalError", too much recursion"
	      // edge: "Error", "Out of stack space"
	      console.warn('react-fast-compare cannot handle circular refs');
	      return false;
	    }
	    // some other error. we should definitely know about these
	    throw error;
	  }
	};


/***/ },
/* 1379 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(1);
	var React__default = _interopDefault(React);
	var PropTypes = _interopDefault(__webpack_require__(3));
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  return _extends.apply(this, arguments);
	}
	
	function _objectWithoutPropertiesLoose(source, excluded) {
	  if (source == null) return {};
	  var target = {};
	  var sourceKeys = Object.keys(source);
	  var key, i;
	
	  for (i = 0; i < sourceKeys.length; i++) {
	    key = sourceKeys[i];
	    if (excluded.indexOf(key) >= 0) continue;
	    target[key] = source[key];
	  }
	
	  return target;
	}
	
	function _objectWithoutProperties(source, excluded) {
	  if (source == null) return {};
	
	  var target = _objectWithoutPropertiesLoose(source, excluded);
	
	  var key, i;
	
	  if (Object.getOwnPropertySymbols) {
	    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
	
	    for (i = 0; i < sourceSymbolKeys.length; i++) {
	      key = sourceSymbolKeys[i];
	      if (excluded.indexOf(key) >= 0) continue;
	      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
	      target[key] = source[key];
	    }
	  }
	
	  return target;
	}
	
	var Activity = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "22 12 18 12 15 21 9 3 6 12 2 12"
	  }));
	});
	Activity.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Activity.displayName = 'Activity';
	
	var Airplay = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M5 17H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-1"
	  }), /*#__PURE__*/React__default.createElement("polygon", {
	    points: "12 15 17 21 7 21 12 15"
	  }));
	});
	Airplay.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Airplay.displayName = 'Airplay';
	
	var AlertCircle = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("circle", {
	    cx: "12",
	    cy: "12",
	    r: "10"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "12",
	    y1: "8",
	    x2: "12",
	    y2: "12"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "12",
	    y1: "16",
	    x2: "12.01",
	    y2: "16"
	  }));
	});
	AlertCircle.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	AlertCircle.displayName = 'AlertCircle';
	
	var AlertOctagon = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("polygon", {
	    points: "7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "12",
	    y1: "8",
	    x2: "12",
	    y2: "12"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "12",
	    y1: "16",
	    x2: "12.01",
	    y2: "16"
	  }));
	});
	AlertOctagon.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	AlertOctagon.displayName = 'AlertOctagon';
	
	var AlertTriangle = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "12",
	    y1: "9",
	    x2: "12",
	    y2: "13"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "12",
	    y1: "17",
	    x2: "12.01",
	    y2: "17"
	  }));
	});
	AlertTriangle.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	AlertTriangle.displayName = 'AlertTriangle';
	
	var AlignCenter = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("line", {
	    x1: "18",
	    y1: "10",
	    x2: "6",
	    y2: "10"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "21",
	    y1: "6",
	    x2: "3",
	    y2: "6"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "21",
	    y1: "14",
	    x2: "3",
	    y2: "14"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "18",
	    y1: "18",
	    x2: "6",
	    y2: "18"
	  }));
	});
	AlignCenter.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	AlignCenter.displayName = 'AlignCenter';
	
	var AlignJustify = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("line", {
	    x1: "21",
	    y1: "10",
	    x2: "3",
	    y2: "10"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "21",
	    y1: "6",
	    x2: "3",
	    y2: "6"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "21",
	    y1: "14",
	    x2: "3",
	    y2: "14"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "21",
	    y1: "18",
	    x2: "3",
	    y2: "18"
	  }));
	});
	AlignJustify.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	AlignJustify.displayName = 'AlignJustify';
	
	var AlignLeft = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("line", {
	    x1: "17",
	    y1: "10",
	    x2: "3",
	    y2: "10"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "21",
	    y1: "6",
	    x2: "3",
	    y2: "6"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "21",
	    y1: "14",
	    x2: "3",
	    y2: "14"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "17",
	    y1: "18",
	    x2: "3",
	    y2: "18"
	  }));
	});
	AlignLeft.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	AlignLeft.displayName = 'AlignLeft';
	
	var AlignRight = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("line", {
	    x1: "21",
	    y1: "10",
	    x2: "7",
	    y2: "10"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "21",
	    y1: "6",
	    x2: "3",
	    y2: "6"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "21",
	    y1: "14",
	    x2: "3",
	    y2: "14"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "21",
	    y1: "18",
	    x2: "7",
	    y2: "18"
	  }));
	});
	AlignRight.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	AlignRight.displayName = 'AlignRight';
	
	var Anchor = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("circle", {
	    cx: "12",
	    cy: "5",
	    r: "3"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "12",
	    y1: "22",
	    x2: "12",
	    y2: "8"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M5 12H2a10 10 0 0 0 20 0h-3"
	  }));
	});
	Anchor.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Anchor.displayName = 'Anchor';
	
	var Aperture = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("circle", {
	    cx: "12",
	    cy: "12",
	    r: "10"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "14.31",
	    y1: "8",
	    x2: "20.05",
	    y2: "17.94"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "9.69",
	    y1: "8",
	    x2: "21.17",
	    y2: "8"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "7.38",
	    y1: "12",
	    x2: "13.12",
	    y2: "2.06"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "9.69",
	    y1: "16",
	    x2: "3.95",
	    y2: "6.06"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "14.31",
	    y1: "16",
	    x2: "2.83",
	    y2: "16"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "16.62",
	    y1: "12",
	    x2: "10.88",
	    y2: "21.94"
	  }));
	});
	Aperture.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Aperture.displayName = 'Aperture';
	
	var Archive = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "21 8 21 21 3 21 3 8"
	  }), /*#__PURE__*/React__default.createElement("rect", {
	    x: "1",
	    y: "3",
	    width: "22",
	    height: "5"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "10",
	    y1: "12",
	    x2: "14",
	    y2: "12"
	  }));
	});
	Archive.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Archive.displayName = 'Archive';
	
	var ArrowDownCircle = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("circle", {
	    cx: "12",
	    cy: "12",
	    r: "10"
	  }), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "8 12 12 16 16 12"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "12",
	    y1: "8",
	    x2: "12",
	    y2: "16"
	  }));
	});
	ArrowDownCircle.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	ArrowDownCircle.displayName = 'ArrowDownCircle';
	
	var ArrowDownLeft = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("line", {
	    x1: "17",
	    y1: "7",
	    x2: "7",
	    y2: "17"
	  }), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "17 17 7 17 7 7"
	  }));
	});
	ArrowDownLeft.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	ArrowDownLeft.displayName = 'ArrowDownLeft';
	
	var ArrowDownRight = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("line", {
	    x1: "7",
	    y1: "7",
	    x2: "17",
	    y2: "17"
	  }), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "17 7 17 17 7 17"
	  }));
	});
	ArrowDownRight.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	ArrowDownRight.displayName = 'ArrowDownRight';
	
	var ArrowDown = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("line", {
	    x1: "12",
	    y1: "5",
	    x2: "12",
	    y2: "19"
	  }), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "19 12 12 19 5 12"
	  }));
	});
	ArrowDown.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	ArrowDown.displayName = 'ArrowDown';
	
	var ArrowLeftCircle = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("circle", {
	    cx: "12",
	    cy: "12",
	    r: "10"
	  }), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "12 8 8 12 12 16"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "16",
	    y1: "12",
	    x2: "8",
	    y2: "12"
	  }));
	});
	ArrowLeftCircle.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	ArrowLeftCircle.displayName = 'ArrowLeftCircle';
	
	var ArrowLeft = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("line", {
	    x1: "19",
	    y1: "12",
	    x2: "5",
	    y2: "12"
	  }), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "12 19 5 12 12 5"
	  }));
	});
	ArrowLeft.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	ArrowLeft.displayName = 'ArrowLeft';
	
	var ArrowRightCircle = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("circle", {
	    cx: "12",
	    cy: "12",
	    r: "10"
	  }), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "12 16 16 12 12 8"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "8",
	    y1: "12",
	    x2: "16",
	    y2: "12"
	  }));
	});
	ArrowRightCircle.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	ArrowRightCircle.displayName = 'ArrowRightCircle';
	
	var ArrowRight = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("line", {
	    x1: "5",
	    y1: "12",
	    x2: "19",
	    y2: "12"
	  }), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "12 5 19 12 12 19"
	  }));
	});
	ArrowRight.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	ArrowRight.displayName = 'ArrowRight';
	
	var ArrowUpCircle = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("circle", {
	    cx: "12",
	    cy: "12",
	    r: "10"
	  }), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "16 12 12 8 8 12"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "12",
	    y1: "16",
	    x2: "12",
	    y2: "8"
	  }));
	});
	ArrowUpCircle.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	ArrowUpCircle.displayName = 'ArrowUpCircle';
	
	var ArrowUpLeft = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("line", {
	    x1: "17",
	    y1: "17",
	    x2: "7",
	    y2: "7"
	  }), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "7 17 7 7 17 7"
	  }));
	});
	ArrowUpLeft.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	ArrowUpLeft.displayName = 'ArrowUpLeft';
	
	var ArrowUpRight = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("line", {
	    x1: "7",
	    y1: "17",
	    x2: "17",
	    y2: "7"
	  }), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "7 7 17 7 17 17"
	  }));
	});
	ArrowUpRight.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	ArrowUpRight.displayName = 'ArrowUpRight';
	
	var ArrowUp = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("line", {
	    x1: "12",
	    y1: "19",
	    x2: "12",
	    y2: "5"
	  }), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "5 12 12 5 19 12"
	  }));
	});
	ArrowUp.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	ArrowUp.displayName = 'ArrowUp';
	
	var AtSign = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("circle", {
	    cx: "12",
	    cy: "12",
	    r: "4"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-3.92 7.94"
	  }));
	});
	AtSign.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	AtSign.displayName = 'AtSign';
	
	var Award = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("circle", {
	    cx: "12",
	    cy: "8",
	    r: "7"
	  }), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "8.21 13.89 7 23 12 20 17 23 15.79 13.88"
	  }));
	});
	Award.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Award.displayName = 'Award';
	
	var BarChart2 = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("line", {
	    x1: "18",
	    y1: "20",
	    x2: "18",
	    y2: "10"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "12",
	    y1: "20",
	    x2: "12",
	    y2: "4"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "6",
	    y1: "20",
	    x2: "6",
	    y2: "14"
	  }));
	});
	BarChart2.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	BarChart2.displayName = 'BarChart2';
	
	var BarChart = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("line", {
	    x1: "12",
	    y1: "20",
	    x2: "12",
	    y2: "10"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "18",
	    y1: "20",
	    x2: "18",
	    y2: "4"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "6",
	    y1: "20",
	    x2: "6",
	    y2: "16"
	  }));
	});
	BarChart.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	BarChart.displayName = 'BarChart';
	
	var BatteryCharging = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M5 18H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h3.19M15 6h2a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-3.19"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "23",
	    y1: "13",
	    x2: "23",
	    y2: "11"
	  }), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "11 6 7 12 13 12 9 18"
	  }));
	});
	BatteryCharging.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	BatteryCharging.displayName = 'BatteryCharging';
	
	var Battery = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("rect", {
	    x: "1",
	    y: "6",
	    width: "18",
	    height: "12",
	    rx: "2",
	    ry: "2"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "23",
	    y1: "13",
	    x2: "23",
	    y2: "11"
	  }));
	});
	Battery.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Battery.displayName = 'Battery';
	
	var BellOff = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M13.73 21a2 2 0 0 1-3.46 0"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M18.63 13A17.89 17.89 0 0 1 18 8"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M6.26 6.26A5.86 5.86 0 0 0 6 8c0 7-3 9-3 9h14"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M18 8a6 6 0 0 0-9.33-5"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "1",
	    y1: "1",
	    x2: "23",
	    y2: "23"
	  }));
	});
	BellOff.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	BellOff.displayName = 'BellOff';
	
	var Bell = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M13.73 21a2 2 0 0 1-3.46 0"
	  }));
	});
	Bell.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Bell.displayName = 'Bell';
	
	var Bluetooth = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "6.5 6.5 17.5 17.5 12 23 12 1 17.5 6.5 6.5 17.5"
	  }));
	});
	Bluetooth.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Bluetooth.displayName = 'Bluetooth';
	
	var Bold = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M6 4h8a4 4 0 0 1 4 4 4 4 0 0 1-4 4H6z"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M6 12h9a4 4 0 0 1 4 4 4 4 0 0 1-4 4H6z"
	  }));
	});
	Bold.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Bold.displayName = 'Bold';
	
	var BookOpen = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"
	  }));
	});
	BookOpen.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	BookOpen.displayName = 'BookOpen';
	
	var Book = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M4 19.5A2.5 2.5 0 0 1 6.5 17H20"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"
	  }));
	});
	Book.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Book.displayName = 'Book';
	
	var Bookmark = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"
	  }));
	});
	Bookmark.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Bookmark.displayName = 'Bookmark';
	
	var Box = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"
	  }), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "3.27 6.96 12 12.01 20.73 6.96"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "12",
	    y1: "22.08",
	    x2: "12",
	    y2: "12"
	  }));
	});
	Box.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Box.displayName = 'Box';
	
	var Briefcase = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("rect", {
	    x: "2",
	    y: "7",
	    width: "20",
	    height: "14",
	    rx: "2",
	    ry: "2"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"
	  }));
	});
	Briefcase.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Briefcase.displayName = 'Briefcase';
	
	var Calendar = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("rect", {
	    x: "3",
	    y: "4",
	    width: "18",
	    height: "18",
	    rx: "2",
	    ry: "2"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "16",
	    y1: "2",
	    x2: "16",
	    y2: "6"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "8",
	    y1: "2",
	    x2: "8",
	    y2: "6"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "3",
	    y1: "10",
	    x2: "21",
	    y2: "10"
	  }));
	});
	Calendar.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Calendar.displayName = 'Calendar';
	
	var CameraOff = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("line", {
	    x1: "1",
	    y1: "1",
	    x2: "23",
	    y2: "23"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M21 21H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h3m3-3h6l2 3h4a2 2 0 0 1 2 2v9.34m-7.72-2.06a4 4 0 1 1-5.56-5.56"
	  }));
	});
	CameraOff.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	CameraOff.displayName = 'CameraOff';
	
	var Camera = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"
	  }), /*#__PURE__*/React__default.createElement("circle", {
	    cx: "12",
	    cy: "13",
	    r: "4"
	  }));
	});
	Camera.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Camera.displayName = 'Camera';
	
	var Cast = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M2 16.1A5 5 0 0 1 5.9 20M2 12.05A9 9 0 0 1 9.95 20M2 8V6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-6"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "2",
	    y1: "20",
	    x2: "2.01",
	    y2: "20"
	  }));
	});
	Cast.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Cast.displayName = 'Cast';
	
	var CheckCircle = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M22 11.08V12a10 10 0 1 1-5.93-9.14"
	  }), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "22 4 12 14.01 9 11.01"
	  }));
	});
	CheckCircle.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	CheckCircle.displayName = 'CheckCircle';
	
	var CheckSquare = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "9 11 12 14 22 4"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"
	  }));
	});
	CheckSquare.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	CheckSquare.displayName = 'CheckSquare';
	
	var Check = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "20 6 9 17 4 12"
	  }));
	});
	Check.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Check.displayName = 'Check';
	
	var ChevronDown = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "6 9 12 15 18 9"
	  }));
	});
	ChevronDown.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	ChevronDown.displayName = 'ChevronDown';
	
	var ChevronLeft = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "15 18 9 12 15 6"
	  }));
	});
	ChevronLeft.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	ChevronLeft.displayName = 'ChevronLeft';
	
	var ChevronRight = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "9 18 15 12 9 6"
	  }));
	});
	ChevronRight.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	ChevronRight.displayName = 'ChevronRight';
	
	var ChevronUp = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "18 15 12 9 6 15"
	  }));
	});
	ChevronUp.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	ChevronUp.displayName = 'ChevronUp';
	
	var ChevronsDown = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "7 13 12 18 17 13"
	  }), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "7 6 12 11 17 6"
	  }));
	});
	ChevronsDown.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	ChevronsDown.displayName = 'ChevronsDown';
	
	var ChevronsLeft = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "11 17 6 12 11 7"
	  }), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "18 17 13 12 18 7"
	  }));
	});
	ChevronsLeft.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	ChevronsLeft.displayName = 'ChevronsLeft';
	
	var ChevronsRight = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "13 17 18 12 13 7"
	  }), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "6 17 11 12 6 7"
	  }));
	});
	ChevronsRight.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	ChevronsRight.displayName = 'ChevronsRight';
	
	var ChevronsUp = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "17 11 12 6 7 11"
	  }), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "17 18 12 13 7 18"
	  }));
	});
	ChevronsUp.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	ChevronsUp.displayName = 'ChevronsUp';
	
	var Chrome = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("circle", {
	    cx: "12",
	    cy: "12",
	    r: "10"
	  }), /*#__PURE__*/React__default.createElement("circle", {
	    cx: "12",
	    cy: "12",
	    r: "4"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "21.17",
	    y1: "8",
	    x2: "12",
	    y2: "8"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "3.95",
	    y1: "6.06",
	    x2: "8.54",
	    y2: "14"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "10.88",
	    y1: "21.94",
	    x2: "15.46",
	    y2: "14"
	  }));
	});
	Chrome.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Chrome.displayName = 'Chrome';
	
	var Circle = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("circle", {
	    cx: "12",
	    cy: "12",
	    r: "10"
	  }));
	});
	Circle.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Circle.displayName = 'Circle';
	
	var Clipboard = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"
	  }), /*#__PURE__*/React__default.createElement("rect", {
	    x: "8",
	    y: "2",
	    width: "8",
	    height: "4",
	    rx: "1",
	    ry: "1"
	  }));
	});
	Clipboard.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Clipboard.displayName = 'Clipboard';
	
	var Clock = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("circle", {
	    cx: "12",
	    cy: "12",
	    r: "10"
	  }), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "12 6 12 12 16 14"
	  }));
	});
	Clock.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Clock.displayName = 'Clock';
	
	var CloudDrizzle = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("line", {
	    x1: "8",
	    y1: "19",
	    x2: "8",
	    y2: "21"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "8",
	    y1: "13",
	    x2: "8",
	    y2: "15"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "16",
	    y1: "19",
	    x2: "16",
	    y2: "21"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "16",
	    y1: "13",
	    x2: "16",
	    y2: "15"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "12",
	    y1: "21",
	    x2: "12",
	    y2: "23"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "12",
	    y1: "15",
	    x2: "12",
	    y2: "17"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M20 16.58A5 5 0 0 0 18 7h-1.26A8 8 0 1 0 4 15.25"
	  }));
	});
	CloudDrizzle.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	CloudDrizzle.displayName = 'CloudDrizzle';
	
	var CloudLightning = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M19 16.9A5 5 0 0 0 18 7h-1.26a8 8 0 1 0-11.62 9"
	  }), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "13 11 9 17 15 17 11 23"
	  }));
	});
	CloudLightning.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	CloudLightning.displayName = 'CloudLightning';
	
	var CloudOff = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M22.61 16.95A5 5 0 0 0 18 10h-1.26a8 8 0 0 0-7.05-6M5 5a8 8 0 0 0 4 15h9a5 5 0 0 0 1.7-.3"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "1",
	    y1: "1",
	    x2: "23",
	    y2: "23"
	  }));
	});
	CloudOff.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	CloudOff.displayName = 'CloudOff';
	
	var CloudRain = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("line", {
	    x1: "16",
	    y1: "13",
	    x2: "16",
	    y2: "21"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "8",
	    y1: "13",
	    x2: "8",
	    y2: "21"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "12",
	    y1: "15",
	    x2: "12",
	    y2: "23"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M20 16.58A5 5 0 0 0 18 7h-1.26A8 8 0 1 0 4 15.25"
	  }));
	});
	CloudRain.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	CloudRain.displayName = 'CloudRain';
	
	var CloudSnow = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M20 17.58A5 5 0 0 0 18 8h-1.26A8 8 0 1 0 4 16.25"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "8",
	    y1: "16",
	    x2: "8.01",
	    y2: "16"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "8",
	    y1: "20",
	    x2: "8.01",
	    y2: "20"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "12",
	    y1: "18",
	    x2: "12.01",
	    y2: "18"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "12",
	    y1: "22",
	    x2: "12.01",
	    y2: "22"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "16",
	    y1: "16",
	    x2: "16.01",
	    y2: "16"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "16",
	    y1: "20",
	    x2: "16.01",
	    y2: "20"
	  }));
	});
	CloudSnow.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	CloudSnow.displayName = 'CloudSnow';
	
	var Cloud = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z"
	  }));
	});
	Cloud.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Cloud.displayName = 'Cloud';
	
	var Code = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "16 18 22 12 16 6"
	  }), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "8 6 2 12 8 18"
	  }));
	});
	Code.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Code.displayName = 'Code';
	
	var Codepen = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("polygon", {
	    points: "12 2 22 8.5 22 15.5 12 22 2 15.5 2 8.5 12 2"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "12",
	    y1: "22",
	    x2: "12",
	    y2: "15.5"
	  }), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "22 8.5 12 15.5 2 8.5"
	  }), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "2 15.5 12 8.5 22 15.5"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "12",
	    y1: "2",
	    x2: "12",
	    y2: "8.5"
	  }));
	});
	Codepen.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Codepen.displayName = 'Codepen';
	
	var Codesandbox = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"
	  }), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "7.5 4.21 12 6.81 16.5 4.21"
	  }), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "7.5 19.79 7.5 14.6 3 12"
	  }), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "21 12 16.5 14.6 16.5 19.79"
	  }), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "3.27 6.96 12 12.01 20.73 6.96"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "12",
	    y1: "22.08",
	    x2: "12",
	    y2: "12"
	  }));
	});
	Codesandbox.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Codesandbox.displayName = 'Codesandbox';
	
	var Coffee = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M18 8h1a4 4 0 0 1 0 8h-1"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M2 8h16v9a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8z"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "6",
	    y1: "1",
	    x2: "6",
	    y2: "4"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "10",
	    y1: "1",
	    x2: "10",
	    y2: "4"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "14",
	    y1: "1",
	    x2: "14",
	    y2: "4"
	  }));
	});
	Coffee.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Coffee.displayName = 'Coffee';
	
	var Columns = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M12 3h7a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-7m0-18H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h7m0-18v18"
	  }));
	});
	Columns.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Columns.displayName = 'Columns';
	
	var Command = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M18 3a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3 3 3 0 0 0 3-3 3 3 0 0 0-3-3H6a3 3 0 0 0-3 3 3 3 0 0 0 3 3 3 3 0 0 0 3-3V6a3 3 0 0 0-3-3 3 3 0 0 0-3 3 3 3 0 0 0 3 3h12a3 3 0 0 0 3-3 3 3 0 0 0-3-3z"
	  }));
	});
	Command.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Command.displayName = 'Command';
	
	var Compass = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("circle", {
	    cx: "12",
	    cy: "12",
	    r: "10"
	  }), /*#__PURE__*/React__default.createElement("polygon", {
	    points: "16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76"
	  }));
	});
	Compass.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Compass.displayName = 'Compass';
	
	var Copy = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("rect", {
	    x: "9",
	    y: "9",
	    width: "13",
	    height: "13",
	    rx: "2",
	    ry: "2"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"
	  }));
	});
	Copy.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Copy.displayName = 'Copy';
	
	var CornerDownLeft = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "9 10 4 15 9 20"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M20 4v7a4 4 0 0 1-4 4H4"
	  }));
	});
	CornerDownLeft.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	CornerDownLeft.displayName = 'CornerDownLeft';
	
	var CornerDownRight = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "15 10 20 15 15 20"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M4 4v7a4 4 0 0 0 4 4h12"
	  }));
	});
	CornerDownRight.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	CornerDownRight.displayName = 'CornerDownRight';
	
	var CornerLeftDown = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "14 15 9 20 4 15"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M20 4h-7a4 4 0 0 0-4 4v12"
	  }));
	});
	CornerLeftDown.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	CornerLeftDown.displayName = 'CornerLeftDown';
	
	var CornerLeftUp = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "14 9 9 4 4 9"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M20 20h-7a4 4 0 0 1-4-4V4"
	  }));
	});
	CornerLeftUp.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	CornerLeftUp.displayName = 'CornerLeftUp';
	
	var CornerRightDown = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "10 15 15 20 20 15"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M4 4h7a4 4 0 0 1 4 4v12"
	  }));
	});
	CornerRightDown.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	CornerRightDown.displayName = 'CornerRightDown';
	
	var CornerRightUp = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "10 9 15 4 20 9"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M4 20h7a4 4 0 0 0 4-4V4"
	  }));
	});
	CornerRightUp.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	CornerRightUp.displayName = 'CornerRightUp';
	
	var CornerUpLeft = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "9 14 4 9 9 4"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M20 20v-7a4 4 0 0 0-4-4H4"
	  }));
	});
	CornerUpLeft.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	CornerUpLeft.displayName = 'CornerUpLeft';
	
	var CornerUpRight = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "15 14 20 9 15 4"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M4 20v-7a4 4 0 0 1 4-4h12"
	  }));
	});
	CornerUpRight.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	CornerUpRight.displayName = 'CornerUpRight';
	
	var Cpu = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("rect", {
	    x: "4",
	    y: "4",
	    width: "16",
	    height: "16",
	    rx: "2",
	    ry: "2"
	  }), /*#__PURE__*/React__default.createElement("rect", {
	    x: "9",
	    y: "9",
	    width: "6",
	    height: "6"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "9",
	    y1: "1",
	    x2: "9",
	    y2: "4"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "15",
	    y1: "1",
	    x2: "15",
	    y2: "4"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "9",
	    y1: "20",
	    x2: "9",
	    y2: "23"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "15",
	    y1: "20",
	    x2: "15",
	    y2: "23"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "20",
	    y1: "9",
	    x2: "23",
	    y2: "9"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "20",
	    y1: "14",
	    x2: "23",
	    y2: "14"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "1",
	    y1: "9",
	    x2: "4",
	    y2: "9"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "1",
	    y1: "14",
	    x2: "4",
	    y2: "14"
	  }));
	});
	Cpu.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Cpu.displayName = 'Cpu';
	
	var CreditCard = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("rect", {
	    x: "1",
	    y: "4",
	    width: "22",
	    height: "16",
	    rx: "2",
	    ry: "2"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "1",
	    y1: "10",
	    x2: "23",
	    y2: "10"
	  }));
	});
	CreditCard.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	CreditCard.displayName = 'CreditCard';
	
	var Crop = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M6.13 1L6 16a2 2 0 0 0 2 2h15"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M1 6.13L16 6a2 2 0 0 1 2 2v15"
	  }));
	});
	Crop.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Crop.displayName = 'Crop';
	
	var Crosshair = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("circle", {
	    cx: "12",
	    cy: "12",
	    r: "10"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "22",
	    y1: "12",
	    x2: "18",
	    y2: "12"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "6",
	    y1: "12",
	    x2: "2",
	    y2: "12"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "12",
	    y1: "6",
	    x2: "12",
	    y2: "2"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "12",
	    y1: "22",
	    x2: "12",
	    y2: "18"
	  }));
	});
	Crosshair.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Crosshair.displayName = 'Crosshair';
	
	var Database = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("ellipse", {
	    cx: "12",
	    cy: "5",
	    rx: "9",
	    ry: "3"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M21 12c0 1.66-4 3-9 3s-9-1.34-9-3"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5"
	  }));
	});
	Database.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Database.displayName = 'Database';
	
	var Delete = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M21 4H8l-7 8 7 8h13a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "18",
	    y1: "9",
	    x2: "12",
	    y2: "15"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "12",
	    y1: "9",
	    x2: "18",
	    y2: "15"
	  }));
	});
	Delete.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Delete.displayName = 'Delete';
	
	var Disc = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("circle", {
	    cx: "12",
	    cy: "12",
	    r: "10"
	  }), /*#__PURE__*/React__default.createElement("circle", {
	    cx: "12",
	    cy: "12",
	    r: "3"
	  }));
	});
	Disc.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Disc.displayName = 'Disc';
	
	var DivideCircle = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("line", {
	    x1: "8",
	    y1: "12",
	    x2: "16",
	    y2: "12"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "12",
	    y1: "16",
	    x2: "12",
	    y2: "16"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "12",
	    y1: "8",
	    x2: "12",
	    y2: "8"
	  }), /*#__PURE__*/React__default.createElement("circle", {
	    cx: "12",
	    cy: "12",
	    r: "10"
	  }));
	});
	DivideCircle.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	DivideCircle.displayName = 'DivideCircle';
	
	var DivideSquare = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("rect", {
	    x: "3",
	    y: "3",
	    width: "18",
	    height: "18",
	    rx: "2",
	    ry: "2"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "8",
	    y1: "12",
	    x2: "16",
	    y2: "12"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "12",
	    y1: "16",
	    x2: "12",
	    y2: "16"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "12",
	    y1: "8",
	    x2: "12",
	    y2: "8"
	  }));
	});
	DivideSquare.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	DivideSquare.displayName = 'DivideSquare';
	
	var Divide = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("circle", {
	    cx: "12",
	    cy: "6",
	    r: "2"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "5",
	    y1: "12",
	    x2: "19",
	    y2: "12"
	  }), /*#__PURE__*/React__default.createElement("circle", {
	    cx: "12",
	    cy: "18",
	    r: "2"
	  }));
	});
	Divide.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Divide.displayName = 'Divide';
	
	var DollarSign = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("line", {
	    x1: "12",
	    y1: "1",
	    x2: "12",
	    y2: "23"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"
	  }));
	});
	DollarSign.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	DollarSign.displayName = 'DollarSign';
	
	var DownloadCloud = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "8 17 12 21 16 17"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "12",
	    y1: "12",
	    x2: "12",
	    y2: "21"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M20.88 18.09A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.29"
	  }));
	});
	DownloadCloud.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	DownloadCloud.displayName = 'DownloadCloud';
	
	var Download = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"
	  }), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "7 10 12 15 17 10"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "12",
	    y1: "15",
	    x2: "12",
	    y2: "3"
	  }));
	});
	Download.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Download.displayName = 'Download';
	
	var Dribbble = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("circle", {
	    cx: "12",
	    cy: "12",
	    r: "10"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M8.56 2.75c4.37 6.03 6.02 9.42 8.03 17.72m2.54-15.38c-3.72 4.35-8.94 5.66-16.88 5.85m19.5 1.9c-3.5-.93-6.63-.82-8.94 0-2.58.92-5.01 2.86-7.44 6.32"
	  }));
	});
	Dribbble.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Dribbble.displayName = 'Dribbble';
	
	var Droplet = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M12 2.69l5.66 5.66a8 8 0 1 1-11.31 0z"
	  }));
	});
	Droplet.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Droplet.displayName = 'Droplet';
	
	var Edit2 = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"
	  }));
	});
	Edit2.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Edit2.displayName = 'Edit2';
	
	var Edit3 = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M12 20h9"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"
	  }));
	});
	Edit3.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Edit3.displayName = 'Edit3';
	
	var Edit = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"
	  }));
	});
	Edit.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Edit.displayName = 'Edit';
	
	var ExternalLink = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"
	  }), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "15 3 21 3 21 9"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "10",
	    y1: "14",
	    x2: "21",
	    y2: "3"
	  }));
	});
	ExternalLink.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	ExternalLink.displayName = 'ExternalLink';
	
	var EyeOff = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "1",
	    y1: "1",
	    x2: "23",
	    y2: "23"
	  }));
	});
	EyeOff.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	EyeOff.displayName = 'EyeOff';
	
	var Eye = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"
	  }), /*#__PURE__*/React__default.createElement("circle", {
	    cx: "12",
	    cy: "12",
	    r: "3"
	  }));
	});
	Eye.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Eye.displayName = 'Eye';
	
	var Facebook = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"
	  }));
	});
	Facebook.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Facebook.displayName = 'Facebook';
	
	var FastForward = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("polygon", {
	    points: "13 19 22 12 13 5 13 19"
	  }), /*#__PURE__*/React__default.createElement("polygon", {
	    points: "2 19 11 12 2 5 2 19"
	  }));
	});
	FastForward.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	FastForward.displayName = 'FastForward';
	
	var Feather = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M20.24 12.24a6 6 0 0 0-8.49-8.49L5 10.5V19h8.5z"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "16",
	    y1: "8",
	    x2: "2",
	    y2: "22"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "17.5",
	    y1: "15",
	    x2: "9",
	    y2: "15"
	  }));
	});
	Feather.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Feather.displayName = 'Feather';
	
	var Figma = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M5 5.5A3.5 3.5 0 0 1 8.5 2H12v7H8.5A3.5 3.5 0 0 1 5 5.5z"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M12 2h3.5a3.5 3.5 0 1 1 0 7H12V2z"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M12 12.5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 1 1-7 0z"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M5 19.5A3.5 3.5 0 0 1 8.5 16H12v3.5a3.5 3.5 0 1 1-7 0z"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M5 12.5A3.5 3.5 0 0 1 8.5 9H12v7H8.5A3.5 3.5 0 0 1 5 12.5z"
	  }));
	});
	Figma.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Figma.displayName = 'Figma';
	
	var FileMinus = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
	  }), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "14 2 14 8 20 8"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "9",
	    y1: "15",
	    x2: "15",
	    y2: "15"
	  }));
	});
	FileMinus.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	FileMinus.displayName = 'FileMinus';
	
	var FilePlus = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
	  }), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "14 2 14 8 20 8"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "12",
	    y1: "18",
	    x2: "12",
	    y2: "12"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "9",
	    y1: "15",
	    x2: "15",
	    y2: "15"
	  }));
	});
	FilePlus.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	FilePlus.displayName = 'FilePlus';
	
	var FileText = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
	  }), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "14 2 14 8 20 8"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "16",
	    y1: "13",
	    x2: "8",
	    y2: "13"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "16",
	    y1: "17",
	    x2: "8",
	    y2: "17"
	  }), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "10 9 9 9 8 9"
	  }));
	});
	FileText.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	FileText.displayName = 'FileText';
	
	var File = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"
	  }), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "13 2 13 9 20 9"
	  }));
	});
	File.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	File.displayName = 'File';
	
	var Film = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("rect", {
	    x: "2",
	    y: "2",
	    width: "20",
	    height: "20",
	    rx: "2.18",
	    ry: "2.18"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "7",
	    y1: "2",
	    x2: "7",
	    y2: "22"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "17",
	    y1: "2",
	    x2: "17",
	    y2: "22"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "2",
	    y1: "12",
	    x2: "22",
	    y2: "12"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "2",
	    y1: "7",
	    x2: "7",
	    y2: "7"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "2",
	    y1: "17",
	    x2: "7",
	    y2: "17"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "17",
	    y1: "17",
	    x2: "22",
	    y2: "17"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "17",
	    y1: "7",
	    x2: "22",
	    y2: "7"
	  }));
	});
	Film.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Film.displayName = 'Film';
	
	var Filter = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("polygon", {
	    points: "22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"
	  }));
	});
	Filter.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Filter.displayName = 'Filter';
	
	var Flag = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "4",
	    y1: "22",
	    x2: "4",
	    y2: "15"
	  }));
	});
	Flag.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Flag.displayName = 'Flag';
	
	var FolderMinus = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "9",
	    y1: "14",
	    x2: "15",
	    y2: "14"
	  }));
	});
	FolderMinus.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	FolderMinus.displayName = 'FolderMinus';
	
	var FolderPlus = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "12",
	    y1: "11",
	    x2: "12",
	    y2: "17"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "9",
	    y1: "14",
	    x2: "15",
	    y2: "14"
	  }));
	});
	FolderPlus.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	FolderPlus.displayName = 'FolderPlus';
	
	var Folder = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"
	  }));
	});
	Folder.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Folder.displayName = 'Folder';
	
	var Framer = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M5 16V9h14V2H5l14 14h-7m-7 0l7 7v-7m-7 0h7"
	  }));
	});
	Framer.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Framer.displayName = 'Framer';
	
	var Frown = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("circle", {
	    cx: "12",
	    cy: "12",
	    r: "10"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M16 16s-1.5-2-4-2-4 2-4 2"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "9",
	    y1: "9",
	    x2: "9.01",
	    y2: "9"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "15",
	    y1: "9",
	    x2: "15.01",
	    y2: "9"
	  }));
	});
	Frown.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Frown.displayName = 'Frown';
	
	var Gift = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "20 12 20 22 4 22 4 12"
	  }), /*#__PURE__*/React__default.createElement("rect", {
	    x: "2",
	    y: "7",
	    width: "20",
	    height: "5"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "12",
	    y1: "22",
	    x2: "12",
	    y2: "7"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"
	  }));
	});
	Gift.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Gift.displayName = 'Gift';
	
	var GitBranch = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("line", {
	    x1: "6",
	    y1: "3",
	    x2: "6",
	    y2: "15"
	  }), /*#__PURE__*/React__default.createElement("circle", {
	    cx: "18",
	    cy: "6",
	    r: "3"
	  }), /*#__PURE__*/React__default.createElement("circle", {
	    cx: "6",
	    cy: "18",
	    r: "3"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M18 9a9 9 0 0 1-9 9"
	  }));
	});
	GitBranch.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	GitBranch.displayName = 'GitBranch';
	
	var GitCommit = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("circle", {
	    cx: "12",
	    cy: "12",
	    r: "4"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "1.05",
	    y1: "12",
	    x2: "7",
	    y2: "12"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "17.01",
	    y1: "12",
	    x2: "22.96",
	    y2: "12"
	  }));
	});
	GitCommit.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	GitCommit.displayName = 'GitCommit';
	
	var GitMerge = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("circle", {
	    cx: "18",
	    cy: "18",
	    r: "3"
	  }), /*#__PURE__*/React__default.createElement("circle", {
	    cx: "6",
	    cy: "6",
	    r: "3"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M6 21V9a9 9 0 0 0 9 9"
	  }));
	});
	GitMerge.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	GitMerge.displayName = 'GitMerge';
	
	var GitPullRequest = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("circle", {
	    cx: "18",
	    cy: "18",
	    r: "3"
	  }), /*#__PURE__*/React__default.createElement("circle", {
	    cx: "6",
	    cy: "6",
	    r: "3"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M13 6h3a2 2 0 0 1 2 2v7"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "6",
	    y1: "9",
	    x2: "6",
	    y2: "21"
	  }));
	});
	GitPullRequest.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	GitPullRequest.displayName = 'GitPullRequest';
	
	var GitHub = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22"
	  }));
	});
	GitHub.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	GitHub.displayName = 'GitHub';
	
	var Gitlab = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M22.65 14.39L12 22.13 1.35 14.39a.84.84 0 0 1-.3-.94l1.22-3.78 2.44-7.51A.42.42 0 0 1 4.82 2a.43.43 0 0 1 .58 0 .42.42 0 0 1 .11.18l2.44 7.49h8.1l2.44-7.51A.42.42 0 0 1 18.6 2a.43.43 0 0 1 .58 0 .42.42 0 0 1 .11.18l2.44 7.51L23 13.45a.84.84 0 0 1-.35.94z"
	  }));
	});
	Gitlab.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Gitlab.displayName = 'Gitlab';
	
	var Globe = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("circle", {
	    cx: "12",
	    cy: "12",
	    r: "10"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "2",
	    y1: "12",
	    x2: "22",
	    y2: "12"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"
	  }));
	});
	Globe.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Globe.displayName = 'Globe';
	
	var Grid = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("rect", {
	    x: "3",
	    y: "3",
	    width: "7",
	    height: "7"
	  }), /*#__PURE__*/React__default.createElement("rect", {
	    x: "14",
	    y: "3",
	    width: "7",
	    height: "7"
	  }), /*#__PURE__*/React__default.createElement("rect", {
	    x: "14",
	    y: "14",
	    width: "7",
	    height: "7"
	  }), /*#__PURE__*/React__default.createElement("rect", {
	    x: "3",
	    y: "14",
	    width: "7",
	    height: "7"
	  }));
	});
	Grid.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Grid.displayName = 'Grid';
	
	var HardDrive = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("line", {
	    x1: "22",
	    y1: "12",
	    x2: "2",
	    y2: "12"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "6",
	    y1: "16",
	    x2: "6.01",
	    y2: "16"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "10",
	    y1: "16",
	    x2: "10.01",
	    y2: "16"
	  }));
	});
	HardDrive.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	HardDrive.displayName = 'HardDrive';
	
	var Hash = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("line", {
	    x1: "4",
	    y1: "9",
	    x2: "20",
	    y2: "9"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "4",
	    y1: "15",
	    x2: "20",
	    y2: "15"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "10",
	    y1: "3",
	    x2: "8",
	    y2: "21"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "16",
	    y1: "3",
	    x2: "14",
	    y2: "21"
	  }));
	});
	Hash.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Hash.displayName = 'Hash';
	
	var Headphones = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M3 18v-6a9 9 0 0 1 18 0v6"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z"
	  }));
	});
	Headphones.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Headphones.displayName = 'Headphones';
	
	var Heart = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"
	  }));
	});
	Heart.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Heart.displayName = 'Heart';
	
	var HelpCircle = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("circle", {
	    cx: "12",
	    cy: "12",
	    r: "10"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "12",
	    y1: "17",
	    x2: "12.01",
	    y2: "17"
	  }));
	});
	HelpCircle.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	HelpCircle.displayName = 'HelpCircle';
	
	var Hexagon = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"
	  }));
	});
	Hexagon.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Hexagon.displayName = 'Hexagon';
	
	var Home = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"
	  }), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "9 22 9 12 15 12 15 22"
	  }));
	});
	Home.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Home.displayName = 'Home';
	
	var Image = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("rect", {
	    x: "3",
	    y: "3",
	    width: "18",
	    height: "18",
	    rx: "2",
	    ry: "2"
	  }), /*#__PURE__*/React__default.createElement("circle", {
	    cx: "8.5",
	    cy: "8.5",
	    r: "1.5"
	  }), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "21 15 16 10 5 21"
	  }));
	});
	Image.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Image.displayName = 'Image';
	
	var Inbox = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "22 12 16 12 14 15 10 15 8 12 2 12"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"
	  }));
	});
	Inbox.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Inbox.displayName = 'Inbox';
	
	var Info = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("circle", {
	    cx: "12",
	    cy: "12",
	    r: "10"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "12",
	    y1: "16",
	    x2: "12",
	    y2: "12"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "12",
	    y1: "8",
	    x2: "12.01",
	    y2: "8"
	  }));
	});
	Info.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Info.displayName = 'Info';
	
	var Instagram = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("rect", {
	    x: "2",
	    y: "2",
	    width: "20",
	    height: "20",
	    rx: "5",
	    ry: "5"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "17.5",
	    y1: "6.5",
	    x2: "17.51",
	    y2: "6.5"
	  }));
	});
	Instagram.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Instagram.displayName = 'Instagram';
	
	var Italic = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("line", {
	    x1: "19",
	    y1: "4",
	    x2: "10",
	    y2: "4"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "14",
	    y1: "20",
	    x2: "5",
	    y2: "20"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "15",
	    y1: "4",
	    x2: "9",
	    y2: "20"
	  }));
	});
	Italic.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Italic.displayName = 'Italic';
	
	var Key = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M21 2l-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.778 7.778 5.5 5.5 0 0 1 7.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4"
	  }));
	});
	Key.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Key.displayName = 'Key';
	
	var Layers = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("polygon", {
	    points: "12 2 2 7 12 12 22 7 12 2"
	  }), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "2 17 12 22 22 17"
	  }), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "2 12 12 17 22 12"
	  }));
	});
	Layers.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Layers.displayName = 'Layers';
	
	var Layout = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("rect", {
	    x: "3",
	    y: "3",
	    width: "18",
	    height: "18",
	    rx: "2",
	    ry: "2"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "3",
	    y1: "9",
	    x2: "21",
	    y2: "9"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "9",
	    y1: "21",
	    x2: "9",
	    y2: "9"
	  }));
	});
	Layout.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Layout.displayName = 'Layout';
	
	var LifeBuoy = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("circle", {
	    cx: "12",
	    cy: "12",
	    r: "10"
	  }), /*#__PURE__*/React__default.createElement("circle", {
	    cx: "12",
	    cy: "12",
	    r: "4"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "4.93",
	    y1: "4.93",
	    x2: "9.17",
	    y2: "9.17"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "14.83",
	    y1: "14.83",
	    x2: "19.07",
	    y2: "19.07"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "14.83",
	    y1: "9.17",
	    x2: "19.07",
	    y2: "4.93"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "14.83",
	    y1: "9.17",
	    x2: "18.36",
	    y2: "5.64"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "4.93",
	    y1: "19.07",
	    x2: "9.17",
	    y2: "14.83"
	  }));
	});
	LifeBuoy.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	LifeBuoy.displayName = 'LifeBuoy';
	
	var Link2 = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M15 7h3a5 5 0 0 1 5 5 5 5 0 0 1-5 5h-3m-6 0H6a5 5 0 0 1-5-5 5 5 0 0 1 5-5h3"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "8",
	    y1: "12",
	    x2: "16",
	    y2: "12"
	  }));
	});
	Link2.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Link2.displayName = 'Link2';
	
	var Link = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"
	  }));
	});
	Link.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Link.displayName = 'Link';
	
	var Linkedin = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"
	  }), /*#__PURE__*/React__default.createElement("rect", {
	    x: "2",
	    y: "9",
	    width: "4",
	    height: "12"
	  }), /*#__PURE__*/React__default.createElement("circle", {
	    cx: "4",
	    cy: "4",
	    r: "2"
	  }));
	});
	Linkedin.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Linkedin.displayName = 'Linkedin';
	
	var List = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("line", {
	    x1: "8",
	    y1: "6",
	    x2: "21",
	    y2: "6"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "8",
	    y1: "12",
	    x2: "21",
	    y2: "12"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "8",
	    y1: "18",
	    x2: "21",
	    y2: "18"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "3",
	    y1: "6",
	    x2: "3.01",
	    y2: "6"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "3",
	    y1: "12",
	    x2: "3.01",
	    y2: "12"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "3",
	    y1: "18",
	    x2: "3.01",
	    y2: "18"
	  }));
	});
	List.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	List.displayName = 'List';
	
	var Loader = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("line", {
	    x1: "12",
	    y1: "2",
	    x2: "12",
	    y2: "6"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "12",
	    y1: "18",
	    x2: "12",
	    y2: "22"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "4.93",
	    y1: "4.93",
	    x2: "7.76",
	    y2: "7.76"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "16.24",
	    y1: "16.24",
	    x2: "19.07",
	    y2: "19.07"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "2",
	    y1: "12",
	    x2: "6",
	    y2: "12"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "18",
	    y1: "12",
	    x2: "22",
	    y2: "12"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "4.93",
	    y1: "19.07",
	    x2: "7.76",
	    y2: "16.24"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "16.24",
	    y1: "7.76",
	    x2: "19.07",
	    y2: "4.93"
	  }));
	});
	Loader.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Loader.displayName = 'Loader';
	
	var Lock = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("rect", {
	    x: "3",
	    y: "11",
	    width: "18",
	    height: "11",
	    rx: "2",
	    ry: "2"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M7 11V7a5 5 0 0 1 10 0v4"
	  }));
	});
	Lock.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Lock.displayName = 'Lock';
	
	var LogIn = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"
	  }), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "10 17 15 12 10 7"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "15",
	    y1: "12",
	    x2: "3",
	    y2: "12"
	  }));
	});
	LogIn.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	LogIn.displayName = 'LogIn';
	
	var LogOut = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"
	  }), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "16 17 21 12 16 7"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "21",
	    y1: "12",
	    x2: "9",
	    y2: "12"
	  }));
	});
	LogOut.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	LogOut.displayName = 'LogOut';
	
	var Mail = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"
	  }), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "22,6 12,13 2,6"
	  }));
	});
	Mail.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Mail.displayName = 'Mail';
	
	var MapPin = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"
	  }), /*#__PURE__*/React__default.createElement("circle", {
	    cx: "12",
	    cy: "10",
	    r: "3"
	  }));
	});
	MapPin.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	MapPin.displayName = 'MapPin';
	
	var Map = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("polygon", {
	    points: "1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2 1 6"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "8",
	    y1: "2",
	    x2: "8",
	    y2: "18"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "16",
	    y1: "6",
	    x2: "16",
	    y2: "22"
	  }));
	});
	Map.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Map.displayName = 'Map';
	
	var Maximize2 = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "15 3 21 3 21 9"
	  }), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "9 21 3 21 3 15"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "21",
	    y1: "3",
	    x2: "14",
	    y2: "10"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "3",
	    y1: "21",
	    x2: "10",
	    y2: "14"
	  }));
	});
	Maximize2.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Maximize2.displayName = 'Maximize2';
	
	var Maximize = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3"
	  }));
	});
	Maximize.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Maximize.displayName = 'Maximize';
	
	var Meh = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("circle", {
	    cx: "12",
	    cy: "12",
	    r: "10"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "8",
	    y1: "15",
	    x2: "16",
	    y2: "15"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "9",
	    y1: "9",
	    x2: "9.01",
	    y2: "9"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "15",
	    y1: "9",
	    x2: "15.01",
	    y2: "9"
	  }));
	});
	Meh.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Meh.displayName = 'Meh';
	
	var Menu = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("line", {
	    x1: "3",
	    y1: "12",
	    x2: "21",
	    y2: "12"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "3",
	    y1: "6",
	    x2: "21",
	    y2: "6"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "3",
	    y1: "18",
	    x2: "21",
	    y2: "18"
	  }));
	});
	Menu.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Menu.displayName = 'Menu';
	
	var MessageCircle = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"
	  }));
	});
	MessageCircle.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	MessageCircle.displayName = 'MessageCircle';
	
	var MessageSquare = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"
	  }));
	});
	MessageSquare.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	MessageSquare.displayName = 'MessageSquare';
	
	var MicOff = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("line", {
	    x1: "1",
	    y1: "1",
	    x2: "23",
	    y2: "23"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M9 9v3a3 3 0 0 0 5.12 2.12M15 9.34V4a3 3 0 0 0-5.94-.6"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M17 16.95A7 7 0 0 1 5 12v-2m14 0v2a7 7 0 0 1-.11 1.23"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "12",
	    y1: "19",
	    x2: "12",
	    y2: "23"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "8",
	    y1: "23",
	    x2: "16",
	    y2: "23"
	  }));
	});
	MicOff.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	MicOff.displayName = 'MicOff';
	
	var Mic = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M19 10v2a7 7 0 0 1-14 0v-2"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "12",
	    y1: "19",
	    x2: "12",
	    y2: "23"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "8",
	    y1: "23",
	    x2: "16",
	    y2: "23"
	  }));
	});
	Mic.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Mic.displayName = 'Mic';
	
	var Minimize2 = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "4 14 10 14 10 20"
	  }), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "20 10 14 10 14 4"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "14",
	    y1: "10",
	    x2: "21",
	    y2: "3"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "3",
	    y1: "21",
	    x2: "10",
	    y2: "14"
	  }));
	});
	Minimize2.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Minimize2.displayName = 'Minimize2';
	
	var Minimize = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M8 3v3a2 2 0 0 1-2 2H3m18 0h-3a2 2 0 0 1-2-2V3m0 18v-3a2 2 0 0 1 2-2h3M3 16h3a2 2 0 0 1 2 2v3"
	  }));
	});
	Minimize.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Minimize.displayName = 'Minimize';
	
	var MinusCircle = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("circle", {
	    cx: "12",
	    cy: "12",
	    r: "10"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "8",
	    y1: "12",
	    x2: "16",
	    y2: "12"
	  }));
	});
	MinusCircle.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	MinusCircle.displayName = 'MinusCircle';
	
	var MinusSquare = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("rect", {
	    x: "3",
	    y: "3",
	    width: "18",
	    height: "18",
	    rx: "2",
	    ry: "2"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "8",
	    y1: "12",
	    x2: "16",
	    y2: "12"
	  }));
	});
	MinusSquare.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	MinusSquare.displayName = 'MinusSquare';
	
	var Minus = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("line", {
	    x1: "5",
	    y1: "12",
	    x2: "19",
	    y2: "12"
	  }));
	});
	Minus.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Minus.displayName = 'Minus';
	
	var Monitor = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("rect", {
	    x: "2",
	    y: "3",
	    width: "20",
	    height: "14",
	    rx: "2",
	    ry: "2"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "8",
	    y1: "21",
	    x2: "16",
	    y2: "21"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "12",
	    y1: "17",
	    x2: "12",
	    y2: "21"
	  }));
	});
	Monitor.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Monitor.displayName = 'Monitor';
	
	var Moon = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"
	  }));
	});
	Moon.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Moon.displayName = 'Moon';
	
	var MoreHorizontal = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("circle", {
	    cx: "12",
	    cy: "12",
	    r: "1"
	  }), /*#__PURE__*/React__default.createElement("circle", {
	    cx: "19",
	    cy: "12",
	    r: "1"
	  }), /*#__PURE__*/React__default.createElement("circle", {
	    cx: "5",
	    cy: "12",
	    r: "1"
	  }));
	});
	MoreHorizontal.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	MoreHorizontal.displayName = 'MoreHorizontal';
	
	var MoreVertical = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("circle", {
	    cx: "12",
	    cy: "12",
	    r: "1"
	  }), /*#__PURE__*/React__default.createElement("circle", {
	    cx: "12",
	    cy: "5",
	    r: "1"
	  }), /*#__PURE__*/React__default.createElement("circle", {
	    cx: "12",
	    cy: "19",
	    r: "1"
	  }));
	});
	MoreVertical.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	MoreVertical.displayName = 'MoreVertical';
	
	var MousePointer = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M3 3l7.07 16.97 2.51-7.39 7.39-2.51L3 3z"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M13 13l6 6"
	  }));
	});
	MousePointer.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	MousePointer.displayName = 'MousePointer';
	
	var Move = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "5 9 2 12 5 15"
	  }), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "9 5 12 2 15 5"
	  }), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "15 19 12 22 9 19"
	  }), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "19 9 22 12 19 15"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "2",
	    y1: "12",
	    x2: "22",
	    y2: "12"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "12",
	    y1: "2",
	    x2: "12",
	    y2: "22"
	  }));
	});
	Move.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Move.displayName = 'Move';
	
	var Music = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M9 18V5l12-2v13"
	  }), /*#__PURE__*/React__default.createElement("circle", {
	    cx: "6",
	    cy: "18",
	    r: "3"
	  }), /*#__PURE__*/React__default.createElement("circle", {
	    cx: "18",
	    cy: "16",
	    r: "3"
	  }));
	});
	Music.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Music.displayName = 'Music';
	
	var Navigation2 = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("polygon", {
	    points: "12 2 19 21 12 17 5 21 12 2"
	  }));
	});
	Navigation2.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Navigation2.displayName = 'Navigation2';
	
	var Navigation = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("polygon", {
	    points: "3 11 22 2 13 21 11 13 3 11"
	  }));
	});
	Navigation.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Navigation.displayName = 'Navigation';
	
	var Octagon = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("polygon", {
	    points: "7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"
	  }));
	});
	Octagon.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Octagon.displayName = 'Octagon';
	
	var Package = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("line", {
	    x1: "16.5",
	    y1: "9.4",
	    x2: "7.5",
	    y2: "4.21"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"
	  }), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "3.27 6.96 12 12.01 20.73 6.96"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "12",
	    y1: "22.08",
	    x2: "12",
	    y2: "12"
	  }));
	});
	Package.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Package.displayName = 'Package';
	
	var Paperclip = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"
	  }));
	});
	Paperclip.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Paperclip.displayName = 'Paperclip';
	
	var PauseCircle = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("circle", {
	    cx: "12",
	    cy: "12",
	    r: "10"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "10",
	    y1: "15",
	    x2: "10",
	    y2: "9"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "14",
	    y1: "15",
	    x2: "14",
	    y2: "9"
	  }));
	});
	PauseCircle.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	PauseCircle.displayName = 'PauseCircle';
	
	var Pause = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("rect", {
	    x: "6",
	    y: "4",
	    width: "4",
	    height: "16"
	  }), /*#__PURE__*/React__default.createElement("rect", {
	    x: "14",
	    y: "4",
	    width: "4",
	    height: "16"
	  }));
	});
	Pause.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Pause.displayName = 'Pause';
	
	var PenTool = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M12 19l7-7 3 3-7 7-3-3z"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M18 13l-1.5-7.5L2 2l3.5 14.5L13 18l5-5z"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M2 2l7.586 7.586"
	  }), /*#__PURE__*/React__default.createElement("circle", {
	    cx: "11",
	    cy: "11",
	    r: "2"
	  }));
	});
	PenTool.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	PenTool.displayName = 'PenTool';
	
	var Percent = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("line", {
	    x1: "19",
	    y1: "5",
	    x2: "5",
	    y2: "19"
	  }), /*#__PURE__*/React__default.createElement("circle", {
	    cx: "6.5",
	    cy: "6.5",
	    r: "2.5"
	  }), /*#__PURE__*/React__default.createElement("circle", {
	    cx: "17.5",
	    cy: "17.5",
	    r: "2.5"
	  }));
	});
	Percent.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Percent.displayName = 'Percent';
	
	var PhoneCall = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M15.05 5A5 5 0 0 1 19 8.95M15.05 1A9 9 0 0 1 23 8.94m-1 7.98v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
	  }));
	});
	PhoneCall.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	PhoneCall.displayName = 'PhoneCall';
	
	var PhoneForwarded = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "19 1 23 5 19 9"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "15",
	    y1: "5",
	    x2: "23",
	    y2: "5"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
	  }));
	});
	PhoneForwarded.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	PhoneForwarded.displayName = 'PhoneForwarded';
	
	var PhoneIncoming = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "16 2 16 8 22 8"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "23",
	    y1: "1",
	    x2: "16",
	    y2: "8"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
	  }));
	});
	PhoneIncoming.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	PhoneIncoming.displayName = 'PhoneIncoming';
	
	var PhoneMissed = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("line", {
	    x1: "23",
	    y1: "1",
	    x2: "17",
	    y2: "7"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "17",
	    y1: "1",
	    x2: "23",
	    y2: "7"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
	  }));
	});
	PhoneMissed.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	PhoneMissed.displayName = 'PhoneMissed';
	
	var PhoneOff = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M10.68 13.31a16 16 0 0 0 3.41 2.6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7 2 2 0 0 1 1.72 2v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.42 19.42 0 0 1-3.33-2.67m-2.67-3.34a19.79 19.79 0 0 1-3.07-8.63A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "23",
	    y1: "1",
	    x2: "1",
	    y2: "23"
	  }));
	});
	PhoneOff.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	PhoneOff.displayName = 'PhoneOff';
	
	var PhoneOutgoing = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "23 7 23 1 17 1"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "16",
	    y1: "8",
	    x2: "23",
	    y2: "1"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
	  }));
	});
	PhoneOutgoing.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	PhoneOutgoing.displayName = 'PhoneOutgoing';
	
	var Phone = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
	  }));
	});
	Phone.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Phone.displayName = 'Phone';
	
	var PieChart = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M21.21 15.89A10 10 0 1 1 8 2.83"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M22 12A10 10 0 0 0 12 2v10z"
	  }));
	});
	PieChart.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	PieChart.displayName = 'PieChart';
	
	var PlayCircle = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("circle", {
	    cx: "12",
	    cy: "12",
	    r: "10"
	  }), /*#__PURE__*/React__default.createElement("polygon", {
	    points: "10 8 16 12 10 16 10 8"
	  }));
	});
	PlayCircle.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	PlayCircle.displayName = 'PlayCircle';
	
	var Play = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("polygon", {
	    points: "5 3 19 12 5 21 5 3"
	  }));
	});
	Play.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Play.displayName = 'Play';
	
	var PlusCircle = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("circle", {
	    cx: "12",
	    cy: "12",
	    r: "10"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "12",
	    y1: "8",
	    x2: "12",
	    y2: "16"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "8",
	    y1: "12",
	    x2: "16",
	    y2: "12"
	  }));
	});
	PlusCircle.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	PlusCircle.displayName = 'PlusCircle';
	
	var PlusSquare = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("rect", {
	    x: "3",
	    y: "3",
	    width: "18",
	    height: "18",
	    rx: "2",
	    ry: "2"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "12",
	    y1: "8",
	    x2: "12",
	    y2: "16"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "8",
	    y1: "12",
	    x2: "16",
	    y2: "12"
	  }));
	});
	PlusSquare.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	PlusSquare.displayName = 'PlusSquare';
	
	var Plus = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("line", {
	    x1: "12",
	    y1: "5",
	    x2: "12",
	    y2: "19"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "5",
	    y1: "12",
	    x2: "19",
	    y2: "12"
	  }));
	});
	Plus.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Plus.displayName = 'Plus';
	
	var Pocket = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M4 3h16a2 2 0 0 1 2 2v6a10 10 0 0 1-10 10A10 10 0 0 1 2 11V5a2 2 0 0 1 2-2z"
	  }), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "8 10 12 14 16 10"
	  }));
	});
	Pocket.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Pocket.displayName = 'Pocket';
	
	var Power = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M18.36 6.64a9 9 0 1 1-12.73 0"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "12",
	    y1: "2",
	    x2: "12",
	    y2: "12"
	  }));
	});
	Power.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Power.displayName = 'Power';
	
	var Printer = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "6 9 6 2 18 2 18 9"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"
	  }), /*#__PURE__*/React__default.createElement("rect", {
	    x: "6",
	    y: "14",
	    width: "12",
	    height: "8"
	  }));
	});
	Printer.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Printer.displayName = 'Printer';
	
	var Radio = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("circle", {
	    cx: "12",
	    cy: "12",
	    r: "2"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M16.24 7.76a6 6 0 0 1 0 8.49m-8.48-.01a6 6 0 0 1 0-8.49m11.31-2.82a10 10 0 0 1 0 14.14m-14.14 0a10 10 0 0 1 0-14.14"
	  }));
	});
	Radio.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Radio.displayName = 'Radio';
	
	var RefreshCcw = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "1 4 1 10 7 10"
	  }), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "23 20 23 14 17 14"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M20.49 9A9 9 0 0 0 5.64 5.64L1 10m22 4l-4.64 4.36A9 9 0 0 1 3.51 15"
	  }));
	});
	RefreshCcw.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	RefreshCcw.displayName = 'RefreshCcw';
	
	var RefreshCw = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "23 4 23 10 17 10"
	  }), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "1 20 1 14 7 14"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"
	  }));
	});
	RefreshCw.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	RefreshCw.displayName = 'RefreshCw';
	
	var Repeat = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "17 1 21 5 17 9"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M3 11V9a4 4 0 0 1 4-4h14"
	  }), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "7 23 3 19 7 15"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M21 13v2a4 4 0 0 1-4 4H3"
	  }));
	});
	Repeat.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Repeat.displayName = 'Repeat';
	
	var Rewind = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("polygon", {
	    points: "11 19 2 12 11 5 11 19"
	  }), /*#__PURE__*/React__default.createElement("polygon", {
	    points: "22 19 13 12 22 5 22 19"
	  }));
	});
	Rewind.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Rewind.displayName = 'Rewind';
	
	var RotateCcw = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "1 4 1 10 7 10"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M3.51 15a9 9 0 1 0 2.13-9.36L1 10"
	  }));
	});
	RotateCcw.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	RotateCcw.displayName = 'RotateCcw';
	
	var RotateCw = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "23 4 23 10 17 10"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M20.49 15a9 9 0 1 1-2.12-9.36L23 10"
	  }));
	});
	RotateCw.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	RotateCw.displayName = 'RotateCw';
	
	var Rss = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M4 11a9 9 0 0 1 9 9"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M4 4a16 16 0 0 1 16 16"
	  }), /*#__PURE__*/React__default.createElement("circle", {
	    cx: "5",
	    cy: "19",
	    r: "1"
	  }));
	});
	Rss.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Rss.displayName = 'Rss';
	
	var Save = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"
	  }), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "17 21 17 13 7 13 7 21"
	  }), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "7 3 7 8 15 8"
	  }));
	});
	Save.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Save.displayName = 'Save';
	
	var Scissors = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("circle", {
	    cx: "6",
	    cy: "6",
	    r: "3"
	  }), /*#__PURE__*/React__default.createElement("circle", {
	    cx: "6",
	    cy: "18",
	    r: "3"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "20",
	    y1: "4",
	    x2: "8.12",
	    y2: "15.88"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "14.47",
	    y1: "14.48",
	    x2: "20",
	    y2: "20"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "8.12",
	    y1: "8.12",
	    x2: "12",
	    y2: "12"
	  }));
	});
	Scissors.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Scissors.displayName = 'Scissors';
	
	var Search = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("circle", {
	    cx: "11",
	    cy: "11",
	    r: "8"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "21",
	    y1: "21",
	    x2: "16.65",
	    y2: "16.65"
	  }));
	});
	Search.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Search.displayName = 'Search';
	
	var Send = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("line", {
	    x1: "22",
	    y1: "2",
	    x2: "11",
	    y2: "13"
	  }), /*#__PURE__*/React__default.createElement("polygon", {
	    points: "22 2 15 22 11 13 2 9 22 2"
	  }));
	});
	Send.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Send.displayName = 'Send';
	
	var Server = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("rect", {
	    x: "2",
	    y: "2",
	    width: "20",
	    height: "8",
	    rx: "2",
	    ry: "2"
	  }), /*#__PURE__*/React__default.createElement("rect", {
	    x: "2",
	    y: "14",
	    width: "20",
	    height: "8",
	    rx: "2",
	    ry: "2"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "6",
	    y1: "6",
	    x2: "6.01",
	    y2: "6"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "6",
	    y1: "18",
	    x2: "6.01",
	    y2: "18"
	  }));
	});
	Server.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Server.displayName = 'Server';
	
	var Settings = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("circle", {
	    cx: "12",
	    cy: "12",
	    r: "3"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"
	  }));
	});
	Settings.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Settings.displayName = 'Settings';
	
	var Share2 = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("circle", {
	    cx: "18",
	    cy: "5",
	    r: "3"
	  }), /*#__PURE__*/React__default.createElement("circle", {
	    cx: "6",
	    cy: "12",
	    r: "3"
	  }), /*#__PURE__*/React__default.createElement("circle", {
	    cx: "18",
	    cy: "19",
	    r: "3"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "8.59",
	    y1: "13.51",
	    x2: "15.42",
	    y2: "17.49"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "15.41",
	    y1: "6.51",
	    x2: "8.59",
	    y2: "10.49"
	  }));
	});
	Share2.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Share2.displayName = 'Share2';
	
	var Share = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"
	  }), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "16 6 12 2 8 6"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "12",
	    y1: "2",
	    x2: "12",
	    y2: "15"
	  }));
	});
	Share.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Share.displayName = 'Share';
	
	var ShieldOff = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M19.69 14a6.9 6.9 0 0 0 .31-2V5l-8-3-3.16 1.18"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M4.73 4.73L4 5v7c0 6 8 10 8 10a20.29 20.29 0 0 0 5.62-4.38"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "1",
	    y1: "1",
	    x2: "23",
	    y2: "23"
	  }));
	});
	ShieldOff.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	ShieldOff.displayName = 'ShieldOff';
	
	var Shield = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"
	  }));
	});
	Shield.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Shield.displayName = 'Shield';
	
	var ShoppingBag = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "3",
	    y1: "6",
	    x2: "21",
	    y2: "6"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M16 10a4 4 0 0 1-8 0"
	  }));
	});
	ShoppingBag.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	ShoppingBag.displayName = 'ShoppingBag';
	
	var ShoppingCart = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("circle", {
	    cx: "9",
	    cy: "21",
	    r: "1"
	  }), /*#__PURE__*/React__default.createElement("circle", {
	    cx: "20",
	    cy: "21",
	    r: "1"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"
	  }));
	});
	ShoppingCart.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	ShoppingCart.displayName = 'ShoppingCart';
	
	var Shuffle = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "16 3 21 3 21 8"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "4",
	    y1: "20",
	    x2: "21",
	    y2: "3"
	  }), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "21 16 21 21 16 21"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "15",
	    y1: "15",
	    x2: "21",
	    y2: "21"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "4",
	    y1: "4",
	    x2: "9",
	    y2: "9"
	  }));
	});
	Shuffle.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Shuffle.displayName = 'Shuffle';
	
	var Sidebar = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("rect", {
	    x: "3",
	    y: "3",
	    width: "18",
	    height: "18",
	    rx: "2",
	    ry: "2"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "9",
	    y1: "3",
	    x2: "9",
	    y2: "21"
	  }));
	});
	Sidebar.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Sidebar.displayName = 'Sidebar';
	
	var SkipBack = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("polygon", {
	    points: "19 20 9 12 19 4 19 20"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "5",
	    y1: "19",
	    x2: "5",
	    y2: "5"
	  }));
	});
	SkipBack.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	SkipBack.displayName = 'SkipBack';
	
	var SkipForward = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("polygon", {
	    points: "5 4 15 12 5 20 5 4"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "19",
	    y1: "5",
	    x2: "19",
	    y2: "19"
	  }));
	});
	SkipForward.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	SkipForward.displayName = 'SkipForward';
	
	var Slack = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M14.5 10c-.83 0-1.5-.67-1.5-1.5v-5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5z"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M20.5 10H19V8.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M9.5 14c.83 0 1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5S8 21.33 8 20.5v-5c0-.83.67-1.5 1.5-1.5z"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M3.5 14H5v1.5c0 .83-.67 1.5-1.5 1.5S2 16.33 2 15.5 2.67 14 3.5 14z"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M14 14.5c0-.83.67-1.5 1.5-1.5h5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-5c-.83 0-1.5-.67-1.5-1.5z"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M15.5 19H14v1.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5-.67-1.5-1.5-1.5z"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M10 9.5C10 8.67 9.33 8 8.5 8h-5C2.67 8 2 8.67 2 9.5S2.67 11 3.5 11h5c.83 0 1.5-.67 1.5-1.5z"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M8.5 5H10V3.5C10 2.67 9.33 2 8.5 2S7 2.67 7 3.5 7.67 5 8.5 5z"
	  }));
	});
	Slack.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Slack.displayName = 'Slack';
	
	var Slash = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("circle", {
	    cx: "12",
	    cy: "12",
	    r: "10"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "4.93",
	    y1: "4.93",
	    x2: "19.07",
	    y2: "19.07"
	  }));
	});
	Slash.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Slash.displayName = 'Slash';
	
	var Sliders = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("line", {
	    x1: "4",
	    y1: "21",
	    x2: "4",
	    y2: "14"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "4",
	    y1: "10",
	    x2: "4",
	    y2: "3"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "12",
	    y1: "21",
	    x2: "12",
	    y2: "12"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "12",
	    y1: "8",
	    x2: "12",
	    y2: "3"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "20",
	    y1: "21",
	    x2: "20",
	    y2: "16"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "20",
	    y1: "12",
	    x2: "20",
	    y2: "3"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "1",
	    y1: "14",
	    x2: "7",
	    y2: "14"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "9",
	    y1: "8",
	    x2: "15",
	    y2: "8"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "17",
	    y1: "16",
	    x2: "23",
	    y2: "16"
	  }));
	});
	Sliders.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Sliders.displayName = 'Sliders';
	
	var Smartphone = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("rect", {
	    x: "5",
	    y: "2",
	    width: "14",
	    height: "20",
	    rx: "2",
	    ry: "2"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "12",
	    y1: "18",
	    x2: "12.01",
	    y2: "18"
	  }));
	});
	Smartphone.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Smartphone.displayName = 'Smartphone';
	
	var Smile = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("circle", {
	    cx: "12",
	    cy: "12",
	    r: "10"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M8 14s1.5 2 4 2 4-2 4-2"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "9",
	    y1: "9",
	    x2: "9.01",
	    y2: "9"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "15",
	    y1: "9",
	    x2: "15.01",
	    y2: "9"
	  }));
	});
	Smile.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Smile.displayName = 'Smile';
	
	var Speaker = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("rect", {
	    x: "4",
	    y: "2",
	    width: "16",
	    height: "20",
	    rx: "2",
	    ry: "2"
	  }), /*#__PURE__*/React__default.createElement("circle", {
	    cx: "12",
	    cy: "14",
	    r: "4"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "12",
	    y1: "6",
	    x2: "12.01",
	    y2: "6"
	  }));
	});
	Speaker.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Speaker.displayName = 'Speaker';
	
	var Square = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("rect", {
	    x: "3",
	    y: "3",
	    width: "18",
	    height: "18",
	    rx: "2",
	    ry: "2"
	  }));
	});
	Square.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Square.displayName = 'Square';
	
	var Star = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("polygon", {
	    points: "12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"
	  }));
	});
	Star.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Star.displayName = 'Star';
	
	var StopCircle = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("circle", {
	    cx: "12",
	    cy: "12",
	    r: "10"
	  }), /*#__PURE__*/React__default.createElement("rect", {
	    x: "9",
	    y: "9",
	    width: "6",
	    height: "6"
	  }));
	});
	StopCircle.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	StopCircle.displayName = 'StopCircle';
	
	var Sun = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("circle", {
	    cx: "12",
	    cy: "12",
	    r: "5"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "12",
	    y1: "1",
	    x2: "12",
	    y2: "3"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "12",
	    y1: "21",
	    x2: "12",
	    y2: "23"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "4.22",
	    y1: "4.22",
	    x2: "5.64",
	    y2: "5.64"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "18.36",
	    y1: "18.36",
	    x2: "19.78",
	    y2: "19.78"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "1",
	    y1: "12",
	    x2: "3",
	    y2: "12"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "21",
	    y1: "12",
	    x2: "23",
	    y2: "12"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "4.22",
	    y1: "19.78",
	    x2: "5.64",
	    y2: "18.36"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "18.36",
	    y1: "5.64",
	    x2: "19.78",
	    y2: "4.22"
	  }));
	});
	Sun.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Sun.displayName = 'Sun';
	
	var Sunrise = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M17 18a5 5 0 0 0-10 0"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "12",
	    y1: "2",
	    x2: "12",
	    y2: "9"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "4.22",
	    y1: "10.22",
	    x2: "5.64",
	    y2: "11.64"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "1",
	    y1: "18",
	    x2: "3",
	    y2: "18"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "21",
	    y1: "18",
	    x2: "23",
	    y2: "18"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "18.36",
	    y1: "11.64",
	    x2: "19.78",
	    y2: "10.22"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "23",
	    y1: "22",
	    x2: "1",
	    y2: "22"
	  }), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "8 6 12 2 16 6"
	  }));
	});
	Sunrise.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Sunrise.displayName = 'Sunrise';
	
	var Sunset = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M17 18a5 5 0 0 0-10 0"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "12",
	    y1: "9",
	    x2: "12",
	    y2: "2"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "4.22",
	    y1: "10.22",
	    x2: "5.64",
	    y2: "11.64"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "1",
	    y1: "18",
	    x2: "3",
	    y2: "18"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "21",
	    y1: "18",
	    x2: "23",
	    y2: "18"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "18.36",
	    y1: "11.64",
	    x2: "19.78",
	    y2: "10.22"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "23",
	    y1: "22",
	    x2: "1",
	    y2: "22"
	  }), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "16 5 12 9 8 5"
	  }));
	});
	Sunset.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Sunset.displayName = 'Sunset';
	
	var Table = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M9 3H5a2 2 0 0 0-2 2v4m6-6h10a2 2 0 0 1 2 2v4M9 3v18m0 0h10a2 2 0 0 0 2-2V9M9 21H5a2 2 0 0 1-2-2V9m0 0h18"
	  }));
	});
	Table.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Table.displayName = 'Table';
	
	var Tablet = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("rect", {
	    x: "4",
	    y: "2",
	    width: "16",
	    height: "20",
	    rx: "2",
	    ry: "2"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "12",
	    y1: "18",
	    x2: "12.01",
	    y2: "18"
	  }));
	});
	Tablet.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Tablet.displayName = 'Tablet';
	
	var Tag = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "7",
	    y1: "7",
	    x2: "7.01",
	    y2: "7"
	  }));
	});
	Tag.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Tag.displayName = 'Tag';
	
	var Target = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("circle", {
	    cx: "12",
	    cy: "12",
	    r: "10"
	  }), /*#__PURE__*/React__default.createElement("circle", {
	    cx: "12",
	    cy: "12",
	    r: "6"
	  }), /*#__PURE__*/React__default.createElement("circle", {
	    cx: "12",
	    cy: "12",
	    r: "2"
	  }));
	});
	Target.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Target.displayName = 'Target';
	
	var Terminal = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "4 17 10 11 4 5"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "12",
	    y1: "19",
	    x2: "20",
	    y2: "19"
	  }));
	});
	Terminal.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Terminal.displayName = 'Terminal';
	
	var Thermometer = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M14 14.76V3.5a2.5 2.5 0 0 0-5 0v11.26a4.5 4.5 0 1 0 5 0z"
	  }));
	});
	Thermometer.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Thermometer.displayName = 'Thermometer';
	
	var ThumbsDown = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M10 15v4a3 3 0 0 0 3 3l4-9V2H5.72a2 2 0 0 0-2 1.7l-1.38 9a2 2 0 0 0 2 2.3zm7-13h2.67A2.31 2.31 0 0 1 22 4v7a2.31 2.31 0 0 1-2.33 2H17"
	  }));
	});
	ThumbsDown.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	ThumbsDown.displayName = 'ThumbsDown';
	
	var ThumbsUp = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3"
	  }));
	});
	ThumbsUp.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	ThumbsUp.displayName = 'ThumbsUp';
	
	var ToggleLeft = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("rect", {
	    x: "1",
	    y: "5",
	    width: "22",
	    height: "14",
	    rx: "7",
	    ry: "7"
	  }), /*#__PURE__*/React__default.createElement("circle", {
	    cx: "8",
	    cy: "12",
	    r: "3"
	  }));
	});
	ToggleLeft.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	ToggleLeft.displayName = 'ToggleLeft';
	
	var ToggleRight = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("rect", {
	    x: "1",
	    y: "5",
	    width: "22",
	    height: "14",
	    rx: "7",
	    ry: "7"
	  }), /*#__PURE__*/React__default.createElement("circle", {
	    cx: "16",
	    cy: "12",
	    r: "3"
	  }));
	});
	ToggleRight.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	ToggleRight.displayName = 'ToggleRight';
	
	var Tool = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"
	  }));
	});
	Tool.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Tool.displayName = 'Tool';
	
	var Trash2 = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "3 6 5 6 21 6"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "10",
	    y1: "11",
	    x2: "10",
	    y2: "17"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "14",
	    y1: "11",
	    x2: "14",
	    y2: "17"
	  }));
	});
	Trash2.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Trash2.displayName = 'Trash2';
	
	var Trash = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "3 6 5 6 21 6"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"
	  }));
	});
	Trash.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Trash.displayName = 'Trash';
	
	var Trello = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("rect", {
	    x: "3",
	    y: "3",
	    width: "18",
	    height: "18",
	    rx: "2",
	    ry: "2"
	  }), /*#__PURE__*/React__default.createElement("rect", {
	    x: "7",
	    y: "7",
	    width: "3",
	    height: "9"
	  }), /*#__PURE__*/React__default.createElement("rect", {
	    x: "14",
	    y: "7",
	    width: "3",
	    height: "5"
	  }));
	});
	Trello.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Trello.displayName = 'Trello';
	
	var TrendingDown = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "23 18 13.5 8.5 8.5 13.5 1 6"
	  }), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "17 18 23 18 23 12"
	  }));
	});
	TrendingDown.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	TrendingDown.displayName = 'TrendingDown';
	
	var TrendingUp = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "23 6 13.5 15.5 8.5 10.5 1 18"
	  }), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "17 6 23 6 23 12"
	  }));
	});
	TrendingUp.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	TrendingUp.displayName = 'TrendingUp';
	
	var Triangle = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
	  }));
	});
	Triangle.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Triangle.displayName = 'Triangle';
	
	var Truck = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("rect", {
	    x: "1",
	    y: "3",
	    width: "15",
	    height: "13"
	  }), /*#__PURE__*/React__default.createElement("polygon", {
	    points: "16 8 20 8 23 11 23 16 16 16 16 8"
	  }), /*#__PURE__*/React__default.createElement("circle", {
	    cx: "5.5",
	    cy: "18.5",
	    r: "2.5"
	  }), /*#__PURE__*/React__default.createElement("circle", {
	    cx: "18.5",
	    cy: "18.5",
	    r: "2.5"
	  }));
	});
	Truck.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Truck.displayName = 'Truck';
	
	var Tv = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("rect", {
	    x: "2",
	    y: "7",
	    width: "20",
	    height: "15",
	    rx: "2",
	    ry: "2"
	  }), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "17 2 12 7 7 2"
	  }));
	});
	Tv.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Tv.displayName = 'Tv';
	
	var Twitch = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M21 2H3v16h5v4l4-4h5l4-4V2zm-10 9V7m5 4V7"
	  }));
	});
	Twitch.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Twitch.displayName = 'Twitch';
	
	var Twitter = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z"
	  }));
	});
	Twitter.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Twitter.displayName = 'Twitter';
	
	var Type = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "4 7 4 4 20 4 20 7"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "9",
	    y1: "20",
	    x2: "15",
	    y2: "20"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "12",
	    y1: "4",
	    x2: "12",
	    y2: "20"
	  }));
	});
	Type.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Type.displayName = 'Type';
	
	var Umbrella = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M23 12a11.05 11.05 0 0 0-22 0zm-5 7a3 3 0 0 1-6 0v-7"
	  }));
	});
	Umbrella.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Umbrella.displayName = 'Umbrella';
	
	var Underline = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M6 3v7a6 6 0 0 0 6 6 6 6 0 0 0 6-6V3"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "4",
	    y1: "21",
	    x2: "20",
	    y2: "21"
	  }));
	});
	Underline.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Underline.displayName = 'Underline';
	
	var Unlock = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("rect", {
	    x: "3",
	    y: "11",
	    width: "18",
	    height: "11",
	    rx: "2",
	    ry: "2"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M7 11V7a5 5 0 0 1 9.9-1"
	  }));
	});
	Unlock.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Unlock.displayName = 'Unlock';
	
	var UploadCloud = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "16 16 12 12 8 16"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "12",
	    y1: "12",
	    x2: "12",
	    y2: "21"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3"
	  }), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "16 16 12 12 8 16"
	  }));
	});
	UploadCloud.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	UploadCloud.displayName = 'UploadCloud';
	
	var Upload = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"
	  }), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "17 8 12 3 7 8"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "12",
	    y1: "3",
	    x2: "12",
	    y2: "15"
	  }));
	});
	Upload.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Upload.displayName = 'Upload';
	
	var UserCheck = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"
	  }), /*#__PURE__*/React__default.createElement("circle", {
	    cx: "8.5",
	    cy: "7",
	    r: "4"
	  }), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "17 11 19 13 23 9"
	  }));
	});
	UserCheck.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	UserCheck.displayName = 'UserCheck';
	
	var UserMinus = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"
	  }), /*#__PURE__*/React__default.createElement("circle", {
	    cx: "8.5",
	    cy: "7",
	    r: "4"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "23",
	    y1: "11",
	    x2: "17",
	    y2: "11"
	  }));
	});
	UserMinus.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	UserMinus.displayName = 'UserMinus';
	
	var UserPlus = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"
	  }), /*#__PURE__*/React__default.createElement("circle", {
	    cx: "8.5",
	    cy: "7",
	    r: "4"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "20",
	    y1: "8",
	    x2: "20",
	    y2: "14"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "23",
	    y1: "11",
	    x2: "17",
	    y2: "11"
	  }));
	});
	UserPlus.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	UserPlus.displayName = 'UserPlus';
	
	var UserX = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"
	  }), /*#__PURE__*/React__default.createElement("circle", {
	    cx: "8.5",
	    cy: "7",
	    r: "4"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "18",
	    y1: "8",
	    x2: "23",
	    y2: "13"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "23",
	    y1: "8",
	    x2: "18",
	    y2: "13"
	  }));
	});
	UserX.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	UserX.displayName = 'UserX';
	
	var User = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"
	  }), /*#__PURE__*/React__default.createElement("circle", {
	    cx: "12",
	    cy: "7",
	    r: "4"
	  }));
	});
	User.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	User.displayName = 'User';
	
	var Users = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"
	  }), /*#__PURE__*/React__default.createElement("circle", {
	    cx: "9",
	    cy: "7",
	    r: "4"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M23 21v-2a4 4 0 0 0-3-3.87"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M16 3.13a4 4 0 0 1 0 7.75"
	  }));
	});
	Users.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Users.displayName = 'Users';
	
	var VideoOff = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M16 16v1a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h2m5.66 0H14a2 2 0 0 1 2 2v3.34l1 1L23 7v10"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "1",
	    y1: "1",
	    x2: "23",
	    y2: "23"
	  }));
	});
	VideoOff.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	VideoOff.displayName = 'VideoOff';
	
	var Video = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("polygon", {
	    points: "23 7 16 12 23 17 23 7"
	  }), /*#__PURE__*/React__default.createElement("rect", {
	    x: "1",
	    y: "5",
	    width: "15",
	    height: "14",
	    rx: "2",
	    ry: "2"
	  }));
	});
	Video.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Video.displayName = 'Video';
	
	var Voicemail = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("circle", {
	    cx: "5.5",
	    cy: "11.5",
	    r: "4.5"
	  }), /*#__PURE__*/React__default.createElement("circle", {
	    cx: "18.5",
	    cy: "11.5",
	    r: "4.5"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "5.5",
	    y1: "16",
	    x2: "18.5",
	    y2: "16"
	  }));
	});
	Voicemail.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Voicemail.displayName = 'Voicemail';
	
	var Volume1 = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("polygon", {
	    points: "11 5 6 9 2 9 2 15 6 15 11 19 11 5"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M15.54 8.46a5 5 0 0 1 0 7.07"
	  }));
	});
	Volume1.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Volume1.displayName = 'Volume1';
	
	var Volume2 = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("polygon", {
	    points: "11 5 6 9 2 9 2 15 6 15 11 19 11 5"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07"
	  }));
	});
	Volume2.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Volume2.displayName = 'Volume2';
	
	var VolumeX = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("polygon", {
	    points: "11 5 6 9 2 9 2 15 6 15 11 19 11 5"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "23",
	    y1: "9",
	    x2: "17",
	    y2: "15"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "17",
	    y1: "9",
	    x2: "23",
	    y2: "15"
	  }));
	});
	VolumeX.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	VolumeX.displayName = 'VolumeX';
	
	var Volume = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("polygon", {
	    points: "11 5 6 9 2 9 2 15 6 15 11 19 11 5"
	  }));
	});
	Volume.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Volume.displayName = 'Volume';
	
	var Watch = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("circle", {
	    cx: "12",
	    cy: "12",
	    r: "7"
	  }), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "12 9 12 12 13.5 13.5"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M16.51 17.35l-.35 3.83a2 2 0 0 1-2 1.82H9.83a2 2 0 0 1-2-1.82l-.35-3.83m.01-10.7l.35-3.83A2 2 0 0 1 9.83 1h4.35a2 2 0 0 1 2 1.82l.35 3.83"
	  }));
	});
	Watch.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Watch.displayName = 'Watch';
	
	var WifiOff = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("line", {
	    x1: "1",
	    y1: "1",
	    x2: "23",
	    y2: "23"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M16.72 11.06A10.94 10.94 0 0 1 19 12.55"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M5 12.55a10.94 10.94 0 0 1 5.17-2.39"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M10.71 5.05A16 16 0 0 1 22.58 9"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M1.42 9a15.91 15.91 0 0 1 4.7-2.88"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M8.53 16.11a6 6 0 0 1 6.95 0"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "12",
	    y1: "20",
	    x2: "12.01",
	    y2: "20"
	  }));
	});
	WifiOff.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	WifiOff.displayName = 'WifiOff';
	
	var Wifi = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M5 12.55a11 11 0 0 1 14.08 0"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M1.42 9a16 16 0 0 1 21.16 0"
	  }), /*#__PURE__*/React__default.createElement("path", {
	    d: "M8.53 16.11a6 6 0 0 1 6.95 0"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "12",
	    y1: "20",
	    x2: "12.01",
	    y2: "20"
	  }));
	});
	Wifi.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Wifi.displayName = 'Wifi';
	
	var Wind = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M9.59 4.59A2 2 0 1 1 11 8H2m10.59 11.41A2 2 0 1 0 14 16H2m15.73-8.27A2.5 2.5 0 1 1 19.5 12H2"
	  }));
	});
	Wind.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Wind.displayName = 'Wind';
	
	var XCircle = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("circle", {
	    cx: "12",
	    cy: "12",
	    r: "10"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "15",
	    y1: "9",
	    x2: "9",
	    y2: "15"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "9",
	    y1: "9",
	    x2: "15",
	    y2: "15"
	  }));
	});
	XCircle.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	XCircle.displayName = 'XCircle';
	
	var XOctagon = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("polygon", {
	    points: "7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "15",
	    y1: "9",
	    x2: "9",
	    y2: "15"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "9",
	    y1: "9",
	    x2: "15",
	    y2: "15"
	  }));
	});
	XOctagon.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	XOctagon.displayName = 'XOctagon';
	
	var XSquare = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("rect", {
	    x: "3",
	    y: "3",
	    width: "18",
	    height: "18",
	    rx: "2",
	    ry: "2"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "9",
	    y1: "9",
	    x2: "15",
	    y2: "15"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "15",
	    y1: "9",
	    x2: "9",
	    y2: "15"
	  }));
	});
	XSquare.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	XSquare.displayName = 'XSquare';
	
	var X = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("line", {
	    x1: "18",
	    y1: "6",
	    x2: "6",
	    y2: "18"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "6",
	    y1: "6",
	    x2: "18",
	    y2: "18"
	  }));
	});
	X.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	X.displayName = 'X';
	
	var Youtube = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("path", {
	    d: "M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.25 29 29 0 0 0-.46-5.33z"
	  }), /*#__PURE__*/React__default.createElement("polygon", {
	    points: "9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02"
	  }));
	});
	Youtube.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Youtube.displayName = 'Youtube';
	
	var ZapOff = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "12.41 6.75 13 2 10.57 4.92"
	  }), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "18.57 12.91 21 10 15.66 10"
	  }), /*#__PURE__*/React__default.createElement("polyline", {
	    points: "8 8 3 14 12 14 11 22 16 16"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "1",
	    y1: "1",
	    x2: "23",
	    y2: "23"
	  }));
	});
	ZapOff.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	ZapOff.displayName = 'ZapOff';
	
	var Zap = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("polygon", {
	    points: "13 2 3 14 12 14 11 22 21 10 12 10 13 2"
	  }));
	});
	Zap.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Zap.displayName = 'Zap';
	
	var ZoomIn = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("circle", {
	    cx: "11",
	    cy: "11",
	    r: "8"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "21",
	    y1: "21",
	    x2: "16.65",
	    y2: "16.65"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "11",
	    y1: "8",
	    x2: "11",
	    y2: "14"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "8",
	    y1: "11",
	    x2: "14",
	    y2: "11"
	  }));
	});
	ZoomIn.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	ZoomIn.displayName = 'ZoomIn';
	
	var ZoomOut = React.forwardRef(function (_ref, ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 24 : _ref$size,
	      rest = _objectWithoutProperties(_ref, ["color", "size"]);
	
	  return /*#__PURE__*/React__default.createElement("svg", _extends({
	    ref: ref,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: color,
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }, rest), /*#__PURE__*/React__default.createElement("circle", {
	    cx: "11",
	    cy: "11",
	    r: "8"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "21",
	    y1: "21",
	    x2: "16.65",
	    y2: "16.65"
	  }), /*#__PURE__*/React__default.createElement("line", {
	    x1: "8",
	    y1: "11",
	    x2: "14",
	    y2: "11"
	  }));
	});
	ZoomOut.propTypes = {
	  color: PropTypes.string,
	  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	ZoomOut.displayName = 'ZoomOut';
	
	exports.Activity = Activity;
	exports.Airplay = Airplay;
	exports.AlertCircle = AlertCircle;
	exports.AlertOctagon = AlertOctagon;
	exports.AlertTriangle = AlertTriangle;
	exports.AlignCenter = AlignCenter;
	exports.AlignJustify = AlignJustify;
	exports.AlignLeft = AlignLeft;
	exports.AlignRight = AlignRight;
	exports.Anchor = Anchor;
	exports.Aperture = Aperture;
	exports.Archive = Archive;
	exports.ArrowDown = ArrowDown;
	exports.ArrowDownCircle = ArrowDownCircle;
	exports.ArrowDownLeft = ArrowDownLeft;
	exports.ArrowDownRight = ArrowDownRight;
	exports.ArrowLeft = ArrowLeft;
	exports.ArrowLeftCircle = ArrowLeftCircle;
	exports.ArrowRight = ArrowRight;
	exports.ArrowRightCircle = ArrowRightCircle;
	exports.ArrowUp = ArrowUp;
	exports.ArrowUpCircle = ArrowUpCircle;
	exports.ArrowUpLeft = ArrowUpLeft;
	exports.ArrowUpRight = ArrowUpRight;
	exports.AtSign = AtSign;
	exports.Award = Award;
	exports.BarChart = BarChart;
	exports.BarChart2 = BarChart2;
	exports.Battery = Battery;
	exports.BatteryCharging = BatteryCharging;
	exports.Bell = Bell;
	exports.BellOff = BellOff;
	exports.Bluetooth = Bluetooth;
	exports.Bold = Bold;
	exports.Book = Book;
	exports.BookOpen = BookOpen;
	exports.Bookmark = Bookmark;
	exports.Box = Box;
	exports.Briefcase = Briefcase;
	exports.Calendar = Calendar;
	exports.Camera = Camera;
	exports.CameraOff = CameraOff;
	exports.Cast = Cast;
	exports.Check = Check;
	exports.CheckCircle = CheckCircle;
	exports.CheckSquare = CheckSquare;
	exports.ChevronDown = ChevronDown;
	exports.ChevronLeft = ChevronLeft;
	exports.ChevronRight = ChevronRight;
	exports.ChevronUp = ChevronUp;
	exports.ChevronsDown = ChevronsDown;
	exports.ChevronsLeft = ChevronsLeft;
	exports.ChevronsRight = ChevronsRight;
	exports.ChevronsUp = ChevronsUp;
	exports.Chrome = Chrome;
	exports.Circle = Circle;
	exports.Clipboard = Clipboard;
	exports.Clock = Clock;
	exports.Cloud = Cloud;
	exports.CloudDrizzle = CloudDrizzle;
	exports.CloudLightning = CloudLightning;
	exports.CloudOff = CloudOff;
	exports.CloudRain = CloudRain;
	exports.CloudSnow = CloudSnow;
	exports.Code = Code;
	exports.Codepen = Codepen;
	exports.Codesandbox = Codesandbox;
	exports.Coffee = Coffee;
	exports.Columns = Columns;
	exports.Command = Command;
	exports.Compass = Compass;
	exports.Copy = Copy;
	exports.CornerDownLeft = CornerDownLeft;
	exports.CornerDownRight = CornerDownRight;
	exports.CornerLeftDown = CornerLeftDown;
	exports.CornerLeftUp = CornerLeftUp;
	exports.CornerRightDown = CornerRightDown;
	exports.CornerRightUp = CornerRightUp;
	exports.CornerUpLeft = CornerUpLeft;
	exports.CornerUpRight = CornerUpRight;
	exports.Cpu = Cpu;
	exports.CreditCard = CreditCard;
	exports.Crop = Crop;
	exports.Crosshair = Crosshair;
	exports.Database = Database;
	exports.Delete = Delete;
	exports.Disc = Disc;
	exports.Divide = Divide;
	exports.DivideCircle = DivideCircle;
	exports.DivideSquare = DivideSquare;
	exports.DollarSign = DollarSign;
	exports.Download = Download;
	exports.DownloadCloud = DownloadCloud;
	exports.Dribbble = Dribbble;
	exports.Droplet = Droplet;
	exports.Edit = Edit;
	exports.Edit2 = Edit2;
	exports.Edit3 = Edit3;
	exports.ExternalLink = ExternalLink;
	exports.Eye = Eye;
	exports.EyeOff = EyeOff;
	exports.Facebook = Facebook;
	exports.FastForward = FastForward;
	exports.Feather = Feather;
	exports.Figma = Figma;
	exports.File = File;
	exports.FileMinus = FileMinus;
	exports.FilePlus = FilePlus;
	exports.FileText = FileText;
	exports.Film = Film;
	exports.Filter = Filter;
	exports.Flag = Flag;
	exports.Folder = Folder;
	exports.FolderMinus = FolderMinus;
	exports.FolderPlus = FolderPlus;
	exports.Framer = Framer;
	exports.Frown = Frown;
	exports.Gift = Gift;
	exports.GitBranch = GitBranch;
	exports.GitCommit = GitCommit;
	exports.GitHub = GitHub;
	exports.GitMerge = GitMerge;
	exports.GitPullRequest = GitPullRequest;
	exports.Gitlab = Gitlab;
	exports.Globe = Globe;
	exports.Grid = Grid;
	exports.HardDrive = HardDrive;
	exports.Hash = Hash;
	exports.Headphones = Headphones;
	exports.Heart = Heart;
	exports.HelpCircle = HelpCircle;
	exports.Hexagon = Hexagon;
	exports.Home = Home;
	exports.Image = Image;
	exports.Inbox = Inbox;
	exports.Info = Info;
	exports.Instagram = Instagram;
	exports.Italic = Italic;
	exports.Key = Key;
	exports.Layers = Layers;
	exports.Layout = Layout;
	exports.LifeBuoy = LifeBuoy;
	exports.Link = Link;
	exports.Link2 = Link2;
	exports.Linkedin = Linkedin;
	exports.List = List;
	exports.Loader = Loader;
	exports.Lock = Lock;
	exports.LogIn = LogIn;
	exports.LogOut = LogOut;
	exports.Mail = Mail;
	exports.Map = Map;
	exports.MapPin = MapPin;
	exports.Maximize = Maximize;
	exports.Maximize2 = Maximize2;
	exports.Meh = Meh;
	exports.Menu = Menu;
	exports.MessageCircle = MessageCircle;
	exports.MessageSquare = MessageSquare;
	exports.Mic = Mic;
	exports.MicOff = MicOff;
	exports.Minimize = Minimize;
	exports.Minimize2 = Minimize2;
	exports.Minus = Minus;
	exports.MinusCircle = MinusCircle;
	exports.MinusSquare = MinusSquare;
	exports.Monitor = Monitor;
	exports.Moon = Moon;
	exports.MoreHorizontal = MoreHorizontal;
	exports.MoreVertical = MoreVertical;
	exports.MousePointer = MousePointer;
	exports.Move = Move;
	exports.Music = Music;
	exports.Navigation = Navigation;
	exports.Navigation2 = Navigation2;
	exports.Octagon = Octagon;
	exports.Package = Package;
	exports.Paperclip = Paperclip;
	exports.Pause = Pause;
	exports.PauseCircle = PauseCircle;
	exports.PenTool = PenTool;
	exports.Percent = Percent;
	exports.Phone = Phone;
	exports.PhoneCall = PhoneCall;
	exports.PhoneForwarded = PhoneForwarded;
	exports.PhoneIncoming = PhoneIncoming;
	exports.PhoneMissed = PhoneMissed;
	exports.PhoneOff = PhoneOff;
	exports.PhoneOutgoing = PhoneOutgoing;
	exports.PieChart = PieChart;
	exports.Play = Play;
	exports.PlayCircle = PlayCircle;
	exports.Plus = Plus;
	exports.PlusCircle = PlusCircle;
	exports.PlusSquare = PlusSquare;
	exports.Pocket = Pocket;
	exports.Power = Power;
	exports.Printer = Printer;
	exports.Radio = Radio;
	exports.RefreshCcw = RefreshCcw;
	exports.RefreshCw = RefreshCw;
	exports.Repeat = Repeat;
	exports.Rewind = Rewind;
	exports.RotateCcw = RotateCcw;
	exports.RotateCw = RotateCw;
	exports.Rss = Rss;
	exports.Save = Save;
	exports.Scissors = Scissors;
	exports.Search = Search;
	exports.Send = Send;
	exports.Server = Server;
	exports.Settings = Settings;
	exports.Share = Share;
	exports.Share2 = Share2;
	exports.Shield = Shield;
	exports.ShieldOff = ShieldOff;
	exports.ShoppingBag = ShoppingBag;
	exports.ShoppingCart = ShoppingCart;
	exports.Shuffle = Shuffle;
	exports.Sidebar = Sidebar;
	exports.SkipBack = SkipBack;
	exports.SkipForward = SkipForward;
	exports.Slack = Slack;
	exports.Slash = Slash;
	exports.Sliders = Sliders;
	exports.Smartphone = Smartphone;
	exports.Smile = Smile;
	exports.Speaker = Speaker;
	exports.Square = Square;
	exports.Star = Star;
	exports.StopCircle = StopCircle;
	exports.Sun = Sun;
	exports.Sunrise = Sunrise;
	exports.Sunset = Sunset;
	exports.Table = Table;
	exports.Tablet = Tablet;
	exports.Tag = Tag;
	exports.Target = Target;
	exports.Terminal = Terminal;
	exports.Thermometer = Thermometer;
	exports.ThumbsDown = ThumbsDown;
	exports.ThumbsUp = ThumbsUp;
	exports.ToggleLeft = ToggleLeft;
	exports.ToggleRight = ToggleRight;
	exports.Tool = Tool;
	exports.Trash = Trash;
	exports.Trash2 = Trash2;
	exports.Trello = Trello;
	exports.TrendingDown = TrendingDown;
	exports.TrendingUp = TrendingUp;
	exports.Triangle = Triangle;
	exports.Truck = Truck;
	exports.Tv = Tv;
	exports.Twitch = Twitch;
	exports.Twitter = Twitter;
	exports.Type = Type;
	exports.Umbrella = Umbrella;
	exports.Underline = Underline;
	exports.Unlock = Unlock;
	exports.Upload = Upload;
	exports.UploadCloud = UploadCloud;
	exports.User = User;
	exports.UserCheck = UserCheck;
	exports.UserMinus = UserMinus;
	exports.UserPlus = UserPlus;
	exports.UserX = UserX;
	exports.Users = Users;
	exports.Video = Video;
	exports.VideoOff = VideoOff;
	exports.Voicemail = Voicemail;
	exports.Volume = Volume;
	exports.Volume1 = Volume1;
	exports.Volume2 = Volume2;
	exports.VolumeX = VolumeX;
	exports.Watch = Watch;
	exports.Wifi = Wifi;
	exports.WifiOff = WifiOff;
	exports.Wind = Wind;
	exports.X = X;
	exports.XCircle = XCircle;
	exports.XOctagon = XOctagon;
	exports.XSquare = XSquare;
	exports.Youtube = Youtube;
	exports.Zap = Zap;
	exports.ZapOff = ZapOff;
	exports.ZoomIn = ZoomIn;
	exports.ZoomOut = ZoomOut;


/***/ },
/* 1380 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1433);
	
	__webpack_require__(1430);
	
	__webpack_require__(1432);
	
	__webpack_require__(627);
	
	__webpack_require__(1420);
	
	__webpack_require__(1422);
	
	__webpack_require__(628);
	
	__webpack_require__(1424);
	
	__webpack_require__(1425);
	
	__webpack_require__(1426);
	
	__webpack_require__(1427);
	
	__webpack_require__(1428);
	
	__webpack_require__(1435);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _events = __webpack_require__(155);
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(43));
	
	var _objectAssign = _interopRequireDefault(__webpack_require__(58));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var styles = {
	  progressWrapper: {
	    height: '10px',
	    marginTop: '10px',
	    width: '400px',
	    "float": 'left',
	    overflow: 'hidden',
	    backgroundColor: '#f5f5f5',
	    borderRadius: '4px',
	    WebkitBoxShadow: 'inset 0 1px 2px rgba(0,0,0,.1)',
	    boxShadow: 'inset 0 1px 2px rgba(0,0,0,.1)'
	  },
	  progressBar: {
	    "float": 'left',
	    width: '0',
	    height: '100%',
	    fontSize: '12px',
	    lineHeight: '20px',
	    color: '#fff',
	    textAlign: 'center',
	    backgroundColor: '#337ab7',
	    WebkitBoxShadow: 'inset 0 -1px 0 rgba(0,0,0,.15)',
	    boxShadow: 'inset 0 -1px 0 rgba(0,0,0,.15)',
	    WebkitTransition: 'width .6s ease',
	    Otransition: 'width .6s ease',
	    transition: 'width .6s ease'
	  },
	  cancelButton: {
	    marginTop: '5px',
	    WebkitAppearance: 'none',
	    padding: 0,
	    cursor: 'pointer',
	    background: '0 0',
	    border: 0,
	    "float": 'left',
	    fontSize: '21px',
	    fontWeight: 700,
	    lineHeight: 1,
	    color: '#000',
	    textShadow: '0 1px 0 #fff',
	    filter: 'alpha(opacity=20)',
	    opacity: '.2'
	  }
	};
	
	var FileUploadProgress =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(FileUploadProgress, _React$Component);
	
	  function FileUploadProgress(props) {
	    var _this;
	
	    _classCallCheck(this, FileUploadProgress);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(FileUploadProgress).call(this, props));
	    _this.proxy = new _events.EventEmitter();
	    _this.state = {
	      progress: -1,
	      hasError: false
	    };
	    return _this;
	  }
	
	  _createClass(FileUploadProgress, [{
	    key: "cancelUpload",
	    value: function cancelUpload() {
	      this.proxy.emit('abort');
	      this.setState({
	        progress: -1,
	        hasError: false
	      });
	    }
	  }, {
	    key: "onSubmit",
	    value: function onSubmit(e) {
	      e.preventDefault();
	      this.setState({
	        progress: 0,
	        hasError: false
	      }, this._doUpload);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var formElement = this.props.formRenderer(this.onSubmit.bind(this));
	      var progessElement = this.props.progressRenderer(this.state.progress, this.state.hasError, this.cancelUpload.bind(this));
	      return _react["default"].createElement("div", null, formElement, progessElement);
	    }
	  }, {
	    key: "_getFormData",
	    value: function _getFormData() {
	      if (this.props.formGetter) {
	        return this.props.formGetter();
	      }
	
	      return new FormData(_reactDom["default"].findDOMNode(this.refs.form));
	    }
	  }, {
	    key: "_doUpload",
	    value: function _doUpload() {
	      var _this2 = this;
	
	      var form = this._getFormData();
	
	      var req = new XMLHttpRequest();
	      req.open(this.props.method, this.props.url);
	      req.addEventListener('load', function (e) {
	        _this2.proxy.removeAllListeners(['abort']);
	
	        var newState = {
	          progress: 100
	        };
	
	        if (req.status >= 200 && req.status <= 299) {
	          _this2.setState(newState, function () {
	            _this2.props.onLoad(e, req);
	          });
	        } else {
	          newState.hasError = true;
	
	          _this2.setState(newState, function () {
	            _this2.props.onError(e, req);
	          });
	        }
	      }, false);
	      req.addEventListener('error', function (e) {
	        _this2.setState({
	          hasError: true
	        }, function () {
	          _this2.props.onError(e, req);
	        });
	      }, false);
	      req.upload.addEventListener('progress', function (e) {
	        var progress = 0;
	
	        if (e.total !== 0) {
	          progress = parseInt(e.loaded / e.total * 100, 10);
	        }
	
	        _this2.setState({
	          progress: progress
	        }, function () {
	          _this2.props.onProgress(e, req, progress);
	        });
	      }, false);
	      req.addEventListener('abort', function (e) {
	        _this2.setState({
	          progress: -1
	        }, function () {
	          _this2.props.onAbort(e, req);
	        });
	      }, false);
	      this.proxy.once('abort', function () {
	        req.abort();
	      });
	      this.props.beforeSend(req).send(this.props.formCustomizer(form));
	    }
	  }]);
	
	  return FileUploadProgress;
	}(_react["default"].Component);
	
	FileUploadProgress.propTypes = {
	  url: _propTypes["default"].string.isRequired,
	  method: _propTypes["default"].string.isRequired,
	  formGetter: _propTypes["default"].func,
	  formRenderer: _propTypes["default"].func,
	  progressRenderer: _propTypes["default"].func,
	  formCustomizer: _propTypes["default"].func,
	  beforeSend: _propTypes["default"].func,
	  onProgress: _propTypes["default"].func,
	  onLoad: _propTypes["default"].func,
	  onError: _propTypes["default"].func,
	  onAbort: _propTypes["default"].func
	};
	FileUploadProgress.defaultProps = {
	  formRenderer: function formRenderer(onSubmit) {
	    return _react["default"].createElement("form", {
	      className: "_react_fileupload_form_content",
	      ref: "form",
	      method: "post",
	      onSubmit: onSubmit
	    }, _react["default"].createElement("div", null, _react["default"].createElement("input", {
	      type: "file",
	      name: "file"
	    })), _react["default"].createElement("input", {
	      type: "submit"
	    }));
	  },
	  progressRenderer: function progressRenderer(progress, hasError, cancelHandler) {
	    if (hasError || progress > -1) {
	      var barStyle = (0, _objectAssign["default"])({}, styles.progressBar);
	      barStyle.width = "".concat(progress, "%");
	
	      var message = _react["default"].createElement("span", null, "Uploading ...");
	
	      if (hasError) {
	        barStyle.backgroundColor = '#d9534f';
	        message = _react["default"].createElement("span", {
	          style: {
	            color: '#a94442'
	          }
	        }, "Failed to upload ...");
	      } else if (progress === 100) {
	        message = _react["default"].createElement("span", null, "Successfully uploaded");
	      }
	
	      return _react["default"].createElement("div", {
	        className: "_react_fileupload_progress_content"
	      }, _react["default"].createElement("div", {
	        style: styles.progressWrapper
	      }, _react["default"].createElement("div", {
	        className: "_react_fileupload_progress_bar",
	        style: barStyle
	      })), _react["default"].createElement("button", {
	        className: "_react_fileupload_progress_cancel",
	        style: styles.cancelButton,
	        onClick: cancelHandler
	      }, _react["default"].createElement("span", null, "\xD7")), _react["default"].createElement("div", {
	        style: {
	          clear: 'left'
	        }
	      }, message));
	    }
	
	    return '';
	  },
	  formCustomizer: function formCustomizer(form) {
	    return form;
	  },
	  beforeSend: function beforeSend(request) {
	    return request;
	  },
	  onProgress: function onProgress(e, request, progress) {},
	  onLoad: function onLoad(e, request) {},
	  onError: function onError(e, request) {},
	  onAbort: function onAbort(e, request) {}
	};
	var _default = FileUploadProgress;
	exports["default"] = _default;

/***/ },
/* 1381 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(628);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _FileUploadProgress = _interopRequireDefault(__webpack_require__(1380));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _default = _FileUploadProgress["default"];
	exports["default"] = _default;

/***/ },
/* 1382 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var isPossiblePrototype = __webpack_require__(1400);
	
	var $String = String;
	var $TypeError = TypeError;
	
	module.exports = function (argument) {
	  if (isPossiblePrototype(argument)) return argument;
	  throw new $TypeError("Can't set " + $String(argument) + ' as a prototype');
	};


/***/ },
/* 1383 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var wellKnownSymbol = __webpack_require__(76);
	var create = __webpack_require__(130);
	var defineProperty = __webpack_require__(75).f;
	
	var UNSCOPABLES = wellKnownSymbol('unscopables');
	var ArrayPrototype = Array.prototype;
	
	// Array.prototype[@@unscopables]
	// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
	if (ArrayPrototype[UNSCOPABLES] === undefined) {
	  defineProperty(ArrayPrototype, UNSCOPABLES, {
	    configurable: true,
	    value: create(null)
	  });
	}
	
	// add a key to Array.prototype[@@unscopables]
	module.exports = function (key) {
	  ArrayPrototype[UNSCOPABLES][key] = true;
	};


/***/ },
/* 1384 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var bind = __webpack_require__(1392);
	var IndexedObject = __webpack_require__(607);
	var toObject = __webpack_require__(167);
	var lengthOfArrayLike = __webpack_require__(613);
	var arraySpeciesCreate = __webpack_require__(1386);
	var createProperty = __webpack_require__(1387);
	
	// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
	var createMethod = function (TYPE) {
	  var IS_MAP = TYPE === 1;
	  var IS_FILTER = TYPE === 2;
	  var IS_SOME = TYPE === 3;
	  var IS_EVERY = TYPE === 4;
	  var IS_FIND_INDEX = TYPE === 6;
	  var IS_FILTER_REJECT = TYPE === 7;
	  var NO_HOLES = TYPE === 5 || IS_FIND_INDEX;
	  return function ($this, callbackfn, that) {
	    var O = toObject($this);
	    var self = IndexedObject(O);
	    var length = lengthOfArrayLike(self);
	    var boundFunction = bind(callbackfn, that);
	    var index = 0;
	    var resIndex = 0;
	    var target = IS_MAP ? arraySpeciesCreate($this, length) : IS_FILTER || IS_FILTER_REJECT ? arraySpeciesCreate($this, 0) : undefined;
	    var value, result;
	    for (;length > index; index++) if (NO_HOLES || index in self) {
	      value = self[index];
	      result = boundFunction(value, index, O);
	      if (TYPE) {
	        if (IS_MAP) createProperty(target, index, result);    // map
	        else if (result) switch (TYPE) {
	          case 3: return true;                                // some
	          case 5: return value;                               // find
	          case 6: return index;                               // findIndex
	          case 2: createProperty(target, resIndex++, value);  // filter
	        } else switch (TYPE) {
	          case 4: return false;                               // every
	          case 7: createProperty(target, resIndex++, value);  // filterReject
	        }
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
	  };
	};
	
	module.exports = {
	  // `Array.prototype.forEach` method
	  // https://tc39.es/ecma262/#sec-array.prototype.foreach
	  forEach: createMethod(0),
	  // `Array.prototype.map` method
	  // https://tc39.es/ecma262/#sec-array.prototype.map
	  map: createMethod(1),
	  // `Array.prototype.filter` method
	  // https://tc39.es/ecma262/#sec-array.prototype.filter
	  filter: createMethod(2),
	  // `Array.prototype.some` method
	  // https://tc39.es/ecma262/#sec-array.prototype.some
	  some: createMethod(3),
	  // `Array.prototype.every` method
	  // https://tc39.es/ecma262/#sec-array.prototype.every
	  every: createMethod(4),
	  // `Array.prototype.find` method
	  // https://tc39.es/ecma262/#sec-array.prototype.find
	  find: createMethod(5),
	  // `Array.prototype.findIndex` method
	  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
	  findIndex: createMethod(6),
	  // `Array.prototype.filterReject` method
	  // https://github.com/tc39/proposal-array-filtering
	  filterReject: createMethod(7)
	};


/***/ },
/* 1385 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var isArray = __webpack_require__(609);
	var isConstructor = __webpack_require__(1398);
	var isObject = __webpack_require__(74);
	var wellKnownSymbol = __webpack_require__(76);
	
	var SPECIES = wellKnownSymbol('species');
	var $Array = Array;
	
	// a part of `ArraySpeciesCreate` abstract operation
	// https://tc39.es/ecma262/#sec-arrayspeciescreate
	module.exports = function (originalArray) {
	  var C;
	  if (isArray(originalArray)) {
	    C = originalArray.constructor;
	    // cross-realm fallback
	    if (isConstructor(C) && (C === $Array || isArray(C.prototype))) C = undefined;
	    else if (isObject(C)) {
	      C = C[SPECIES];
	      if (C === null) C = undefined;
	    }
	  } return C === undefined ? $Array : C;
	};


/***/ },
/* 1386 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var arraySpeciesConstructor = __webpack_require__(1385);
	
	// `ArraySpeciesCreate` abstract operation
	// https://tc39.es/ecma262/#sec-arrayspeciescreate
	module.exports = function (originalArray, length) {
	  return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
	};


/***/ },
/* 1387 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var DESCRIPTORS = __webpack_require__(62);
	var definePropertyModule = __webpack_require__(75);
	var createPropertyDescriptor = __webpack_require__(162);
	
	module.exports = function (object, key, value) {
	  if (DESCRIPTORS) definePropertyModule.f(object, key, createPropertyDescriptor(0, value));
	  else object[key] = value;
	};


/***/ },
/* 1388 */
/***/ function(module, exports) {

	'use strict';
	// iterable DOM collections
	// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
	module.exports = {
	  CSSRuleList: 0,
	  CSSStyleDeclaration: 0,
	  CSSValueList: 0,
	  ClientRectList: 0,
	  DOMRectList: 0,
	  DOMStringList: 0,
	  DOMTokenList: 1,
	  DataTransferItemList: 0,
	  FileList: 0,
	  HTMLAllCollection: 0,
	  HTMLCollection: 0,
	  HTMLFormElement: 0,
	  HTMLSelectElement: 0,
	  MediaList: 0,
	  MimeTypeArray: 0,
	  NamedNodeMap: 0,
	  NodeList: 1,
	  PaintRequestList: 0,
	  Plugin: 0,
	  PluginArray: 0,
	  SVGLengthList: 0,
	  SVGNumberList: 0,
	  SVGPathSegList: 0,
	  SVGPointList: 0,
	  SVGStringList: 0,
	  SVGTransformList: 0,
	  SourceBufferList: 0,
	  StyleSheetList: 0,
	  TextTrackCueList: 0,
	  TextTrackList: 0,
	  TouchList: 0
	};


/***/ },
/* 1389 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
	var documentCreateElement = __webpack_require__(282);
	
	var classList = documentCreateElement('span').classList;
	var DOMTokenListPrototype = classList && classList.constructor && classList.constructor.prototype;
	
	module.exports = DOMTokenListPrototype === Object.prototype ? undefined : DOMTokenListPrototype;


/***/ },
/* 1390 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var globalThis = __webpack_require__(54);
	
	var navigator = globalThis.navigator;
	var userAgent = navigator && navigator.userAgent;
	
	module.exports = userAgent ? String(userAgent) : '';


/***/ },
/* 1391 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var globalThis = __webpack_require__(54);
	var userAgent = __webpack_require__(1390);
	
	var process = globalThis.process;
	var Deno = globalThis.Deno;
	var versions = process && process.versions || Deno && Deno.version;
	var v8 = versions && versions.v8;
	var match, version;
	
	if (v8) {
	  match = v8.split('.');
	  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
	  // but their correct versions are not interesting for us
	  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
	}
	
	// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
	// so check `userAgent` even if `.v8` exists, but 0
	if (!version && userAgent) {
	  match = userAgent.match(/Edge\/(\d+)/);
	  if (!match || match[1] >= 74) {
	    match = userAgent.match(/Chrome\/(\d+)/);
	    if (match) version = +match[1];
	  }
	}
	
	module.exports = version;


/***/ },
/* 1392 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var uncurryThis = __webpack_require__(1395);
	var aCallable = __webpack_require__(203);
	var NATIVE_BIND = __webpack_require__(205);
	
	var bind = uncurryThis(uncurryThis.bind);
	
	// optional / simple context binding
	module.exports = function (fn, that) {
	  aCallable(fn);
	  return that === undefined ? fn : NATIVE_BIND ? bind(fn, that) : function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ },
/* 1393 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var uncurryThis = __webpack_require__(44);
	var aCallable = __webpack_require__(203);
	var isObject = __webpack_require__(74);
	var hasOwn = __webpack_require__(51);
	var arraySlice = __webpack_require__(600);
	var NATIVE_BIND = __webpack_require__(205);
	
	var $Function = Function;
	var concat = uncurryThis([].concat);
	var join = uncurryThis([].join);
	var factories = {};
	
	var construct = function (C, argsLength, args) {
	  if (!hasOwn(factories, argsLength)) {
	    var list = [];
	    var i = 0;
	    for (; i < argsLength; i++) list[i] = 'a[' + i + ']';
	    factories[argsLength] = $Function('C,a', 'return new C(' + join(list, ',') + ')');
	  } return factories[argsLength](C, args);
	};
	
	// `Function.prototype.bind` method implementation
	// https://tc39.es/ecma262/#sec-function.prototype.bind
	// eslint-disable-next-line es/no-function-prototype-bind -- detection
	module.exports = NATIVE_BIND ? $Function.bind : function bind(that /* , ...args */) {
	  var F = aCallable(this);
	  var Prototype = F.prototype;
	  var partArgs = arraySlice(arguments, 1);
	  var boundFunction = function bound(/* args... */) {
	    var args = concat(partArgs, arraySlice(arguments));
	    return this instanceof boundFunction ? construct(F, args.length, args) : F.apply(that, args);
	  };
	  if (isObject(Prototype)) boundFunction.prototype = Prototype;
	  return boundFunction;
	};


/***/ },
/* 1394 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var uncurryThis = __webpack_require__(44);
	var aCallable = __webpack_require__(203);
	
	module.exports = function (object, key, method) {
	  try {
	    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
	    return uncurryThis(aCallable(Object.getOwnPropertyDescriptor(object, key)[method]));
	  } catch (error) { /* empty */ }
	};


/***/ },
/* 1395 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var classofRaw = __webpack_require__(128);
	var uncurryThis = __webpack_require__(44);
	
	module.exports = function (fn) {
	  // Nashorn bug:
	  //   https://github.com/zloirock/core-js/issues/1128
	  //   https://github.com/zloirock/core-js/issues/1130
	  if (classofRaw(fn) === 'Function') return uncurryThis(fn);
	};


/***/ },
/* 1396 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var aCallable = __webpack_require__(203);
	var isNullOrUndefined = __webpack_require__(610);
	
	// `GetMethod` abstract operation
	// https://tc39.es/ecma262/#sec-getmethod
	module.exports = function (V, P) {
	  var func = V[P];
	  return isNullOrUndefined(func) ? undefined : aCallable(func);
	};


/***/ },
/* 1397 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var getBuiltIn = __webpack_require__(113);
	
	module.exports = getBuiltIn('document', 'documentElement');


/***/ },
/* 1398 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var uncurryThis = __webpack_require__(44);
	var fails = __webpack_require__(50);
	var isCallable = __webpack_require__(52);
	var classof = __webpack_require__(280);
	var getBuiltIn = __webpack_require__(113);
	var inspectSource = __webpack_require__(608);
	
	var noop = function () { /* empty */ };
	var construct = getBuiltIn('Reflect', 'construct');
	var constructorRegExp = /^\s*(?:class|function)\b/;
	var exec = uncurryThis(constructorRegExp.exec);
	var INCORRECT_TO_STRING = !constructorRegExp.test(noop);
	
	var isConstructorModern = function isConstructor(argument) {
	  if (!isCallable(argument)) return false;
	  try {
	    construct(noop, [], argument);
	    return true;
	  } catch (error) {
	    return false;
	  }
	};
	
	var isConstructorLegacy = function isConstructor(argument) {
	  if (!isCallable(argument)) return false;
	  switch (classof(argument)) {
	    case 'AsyncFunction':
	    case 'GeneratorFunction':
	    case 'AsyncGeneratorFunction': return false;
	  }
	  try {
	    // we can't check .prototype since constructors produced by .bind haven't it
	    // `Function#toString` throws on some built-it function in some legacy engines
	    // (for example, `DOMQuad` and similar in FF41-)
	    return INCORRECT_TO_STRING || !!exec(constructorRegExp, inspectSource(argument));
	  } catch (error) {
	    return true;
	  }
	};
	
	isConstructorLegacy.sham = true;
	
	// `IsConstructor` abstract operation
	// https://tc39.es/ecma262/#sec-isconstructor
	module.exports = !construct || fails(function () {
	  var called;
	  return isConstructorModern(isConstructorModern.call)
	    || !isConstructorModern(Object)
	    || !isConstructorModern(function () { called = true; })
	    || called;
	}) ? isConstructorLegacy : isConstructorModern;


/***/ },
/* 1399 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var fails = __webpack_require__(50);
	var isCallable = __webpack_require__(52);
	
	var replacement = /#|\.prototype\./;
	
	var isForced = function (feature, detection) {
	  var value = data[normalize(feature)];
	  return value === POLYFILL ? true
	    : value === NATIVE ? false
	    : isCallable(detection) ? fails(detection)
	    : !!detection;
	};
	
	var normalize = isForced.normalize = function (string) {
	  return String(string).replace(replacement, '.').toLowerCase();
	};
	
	var data = isForced.data = {};
	var NATIVE = isForced.NATIVE = 'N';
	var POLYFILL = isForced.POLYFILL = 'P';
	
	module.exports = isForced;


/***/ },
/* 1400 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var isObject = __webpack_require__(74);
	
	module.exports = function (argument) {
	  return isObject(argument) || argument === null;
	};


/***/ },
/* 1401 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var isObject = __webpack_require__(74);
	var getInternalState = __webpack_require__(163).get;
	
	module.exports = function isRawJSON(O) {
	  if (!isObject(O)) return false;
	  var state = getInternalState(O);
	  return !!state && state.type === 'RawJSON';
	};


/***/ },
/* 1402 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var IteratorPrototype = __webpack_require__(612).IteratorPrototype;
	var create = __webpack_require__(130);
	var createPropertyDescriptor = __webpack_require__(162);
	var setToStringTag = __webpack_require__(208);
	var Iterators = __webpack_require__(284);
	
	var returnThis = function () { return this; };
	
	module.exports = function (IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
	  var TO_STRING_TAG = NAME + ' Iterator';
	  IteratorConstructor.prototype = create(IteratorPrototype, { next: createPropertyDescriptor(+!ENUMERABLE_NEXT, next) });
	  setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
	  Iterators[TO_STRING_TAG] = returnThis;
	  return IteratorConstructor;
	};


/***/ },
/* 1403 */
/***/ function(module, exports) {

	'use strict';
	var ceil = Math.ceil;
	var floor = Math.floor;
	
	// `Math.trunc` method
	// https://tc39.es/ecma262/#sec-math.trunc
	// eslint-disable-next-line es/no-math-trunc -- safe
	module.exports = Math.trunc || function trunc(x) {
	  var n = +x;
	  return (n > 0 ? floor : ceil)(n);
	};


/***/ },
/* 1404 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	/* eslint-disable es/no-json -- safe */
	var fails = __webpack_require__(50);
	
	module.exports = !fails(function () {
	  var unsafeInt = '9007199254740993';
	  // eslint-disable-next-line es/no-json-rawjson -- feature detection
	  var raw = JSON.rawJSON(unsafeInt);
	  // eslint-disable-next-line es/no-json-israwjson -- feature detection
	  return !JSON.isRawJSON(raw) || JSON.stringify(raw) !== unsafeInt;
	});


/***/ },
/* 1405 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var globalThis = __webpack_require__(54);
	var fails = __webpack_require__(50);
	var uncurryThis = __webpack_require__(44);
	var toString = __webpack_require__(101);
	var trim = __webpack_require__(1413).trim;
	var whitespaces = __webpack_require__(626);
	
	var $parseInt = globalThis.parseInt;
	var Symbol = globalThis.Symbol;
	var ITERATOR = Symbol && Symbol.iterator;
	var hex = /^[+-]?0x/i;
	var exec = uncurryThis(hex.exec);
	var FORCED = $parseInt(whitespaces + '08') !== 8 || $parseInt(whitespaces + '0x16') !== 22
	  // MS Edge 18- broken with boxed symbols
	  || (ITERATOR && !fails(function () { $parseInt(Object(ITERATOR)); }));
	
	// `parseInt` method
	// https://tc39.es/ecma262/#sec-parseint-string-radix
	module.exports = FORCED ? function parseInt(string, radix) {
	  var S = trim(toString(string));
	  return $parseInt(S, (radix >>> 0) || (exec(hex, S) ? 16 : 10));
	} : $parseInt;


/***/ },
/* 1406 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	/* eslint-disable es/no-object-getownpropertynames -- safe */
	var classof = __webpack_require__(128);
	var toIndexedObject = __webpack_require__(114);
	var $getOwnPropertyNames = __webpack_require__(286).f;
	var arraySlice = __webpack_require__(600);
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return $getOwnPropertyNames(it);
	  } catch (error) {
	    return arraySlice(windowNames);
	  }
	};
	
	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && classof(it) === 'Window'
	    ? getWindowNames(it)
	    : $getOwnPropertyNames(toIndexedObject(it));
	};


/***/ },
/* 1407 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var TO_STRING_TAG_SUPPORT = __webpack_require__(293);
	var classof = __webpack_require__(280);
	
	// `Object.prototype.toString` method implementation
	// https://tc39.es/ecma262/#sec-object.prototype.tostring
	module.exports = TO_STRING_TAG_SUPPORT ? {}.toString : function toString() {
	  return '[object ' + classof(this) + ']';
	};


/***/ },
/* 1408 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var call = __webpack_require__(100);
	var isCallable = __webpack_require__(52);
	var isObject = __webpack_require__(74);
	
	var $TypeError = TypeError;
	
	// `OrdinaryToPrimitive` abstract operation
	// https://tc39.es/ecma262/#sec-ordinarytoprimitive
	module.exports = function (input, pref) {
	  var fn, val;
	  if (pref === 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
	  if (isCallable(fn = input.valueOf) && !isObject(val = call(fn, input))) return val;
	  if (pref !== 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
	  throw new $TypeError("Can't convert object to primitive value");
	};


/***/ },
/* 1409 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var getBuiltIn = __webpack_require__(113);
	var uncurryThis = __webpack_require__(44);
	var getOwnPropertyNamesModule = __webpack_require__(286);
	var getOwnPropertySymbolsModule = __webpack_require__(287);
	var anObject = __webpack_require__(161);
	
	var concat = uncurryThis([].concat);
	
	// all object keys, includes non-enumerable and symbols
	module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
	  var keys = getOwnPropertyNamesModule.f(anObject(it));
	  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
	  return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
	};


/***/ },
/* 1410 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var uncurryThis = __webpack_require__(44);
	var hasOwn = __webpack_require__(51);
	
	var $SyntaxError = SyntaxError;
	var $parseInt = parseInt;
	var fromCharCode = String.fromCharCode;
	var at = uncurryThis(''.charAt);
	var slice = uncurryThis(''.slice);
	var exec = uncurryThis(/./.exec);
	
	var codePoints = {
	  '\\"': '"',
	  '\\\\': '\\',
	  '\\/': '/',
	  '\\b': '\b',
	  '\\f': '\f',
	  '\\n': '\n',
	  '\\r': '\r',
	  '\\t': '\t'
	};
	
	var IS_4_HEX_DIGITS = /^[\da-f]{4}$/i;
	// eslint-disable-next-line regexp/no-control-character -- safe
	var IS_C0_CONTROL_CODE = /^[\u0000-\u001F]$/;
	
	module.exports = function (source, i) {
	  var unterminated = true;
	  var value = '';
	  while (i < source.length) {
	    var chr = at(source, i);
	    if (chr === '\\') {
	      var twoChars = slice(source, i, i + 2);
	      if (hasOwn(codePoints, twoChars)) {
	        value += codePoints[twoChars];
	        i += 2;
	      } else if (twoChars === '\\u') {
	        i += 2;
	        var fourHexDigits = slice(source, i, i + 4);
	        if (!exec(IS_4_HEX_DIGITS, fourHexDigits)) throw new $SyntaxError('Bad Unicode escape at: ' + i);
	        value += fromCharCode($parseInt(fourHexDigits, 16));
	        i += 4;
	      } else throw new $SyntaxError('Unknown escape sequence: "' + twoChars + '"');
	    } else if (chr === '"') {
	      unterminated = false;
	      i++;
	      break;
	    } else {
	      if (exec(IS_C0_CONTROL_CODE, chr)) throw new $SyntaxError('Bad control character in string literal at: ' + i);
	      value += chr;
	      i++;
	    }
	  }
	  if (unterminated) throw new $SyntaxError('Unterminated string at: ' + i);
	  return { value: value, end: i };
	};


/***/ },
/* 1411 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var globalThis = __webpack_require__(54);
	
	module.exports = globalThis;


/***/ },
/* 1412 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var uncurryThis = __webpack_require__(44);
	var toIntegerOrInfinity = __webpack_require__(291);
	var toString = __webpack_require__(101);
	var requireObjectCoercible = __webpack_require__(165);
	
	var charAt = uncurryThis(''.charAt);
	var charCodeAt = uncurryThis(''.charCodeAt);
	var stringSlice = uncurryThis(''.slice);
	
	var createMethod = function (CONVERT_TO_STRING) {
	  return function ($this, pos) {
	    var S = toString(requireObjectCoercible($this));
	    var position = toIntegerOrInfinity(pos);
	    var size = S.length;
	    var first, second;
	    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
	    first = charCodeAt(S, position);
	    return first < 0xD800 || first > 0xDBFF || position + 1 === size
	      || (second = charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF
	        ? CONVERT_TO_STRING
	          ? charAt(S, position)
	          : first
	        : CONVERT_TO_STRING
	          ? stringSlice(S, position, position + 2)
	          : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
	  };
	};
	
	module.exports = {
	  // `String.prototype.codePointAt` method
	  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
	  codeAt: createMethod(false),
	  // `String.prototype.at` method
	  // https://github.com/mathiasbynens/String.prototype.at
	  charAt: createMethod(true)
	};


/***/ },
/* 1413 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var uncurryThis = __webpack_require__(44);
	var requireObjectCoercible = __webpack_require__(165);
	var toString = __webpack_require__(101);
	var whitespaces = __webpack_require__(626);
	
	var replace = uncurryThis(''.replace);
	var ltrim = RegExp('^[' + whitespaces + ']+');
	var rtrim = RegExp('(^|[^' + whitespaces + '])[' + whitespaces + ']+$');
	
	// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
	var createMethod = function (TYPE) {
	  return function ($this) {
	    var string = toString(requireObjectCoercible($this));
	    if (TYPE & 1) string = replace(string, ltrim, '');
	    if (TYPE & 2) string = replace(string, rtrim, '$1');
	    return string;
	  };
	};
	
	module.exports = {
	  // `String.prototype.{ trimLeft, trimStart }` methods
	  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
	  start: createMethod(1),
	  // `String.prototype.{ trimRight, trimEnd }` methods
	  // https://tc39.es/ecma262/#sec-string.prototype.trimend
	  end: createMethod(2),
	  // `String.prototype.trim` method
	  // https://tc39.es/ecma262/#sec-string.prototype.trim
	  trim: createMethod(3)
	};


/***/ },
/* 1414 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var call = __webpack_require__(100);
	var getBuiltIn = __webpack_require__(113);
	var wellKnownSymbol = __webpack_require__(76);
	var defineBuiltIn = __webpack_require__(129);
	
	module.exports = function () {
	  var Symbol = getBuiltIn('Symbol');
	  var SymbolPrototype = Symbol && Symbol.prototype;
	  var valueOf = SymbolPrototype && SymbolPrototype.valueOf;
	  var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');
	
	  if (SymbolPrototype && !SymbolPrototype[TO_PRIMITIVE]) {
	    // `Symbol.prototype[@@toPrimitive]` method
	    // https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
	    // eslint-disable-next-line no-unused-vars -- required for .length
	    defineBuiltIn(SymbolPrototype, TO_PRIMITIVE, function (hint) {
	      return call(valueOf, this);
	    }, { arity: 1 });
	  }
	};


/***/ },
/* 1415 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var uncurryThis = __webpack_require__(44);
	
	// `thisNumberValue` abstract operation
	// https://tc39.es/ecma262/#sec-thisnumbervalue
	module.exports = uncurryThis(1.1.valueOf);


/***/ },
/* 1416 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var toIntegerOrInfinity = __webpack_require__(291);
	
	var max = Math.max;
	var min = Math.min;
	
	// Helper for a popular repeating case of the spec:
	// Let integer be ? ToInteger(index).
	// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
	module.exports = function (index, length) {
	  var integer = toIntegerOrInfinity(index);
	  return integer < 0 ? max(integer + length, 0) : min(integer, length);
	};


/***/ },
/* 1417 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var toIntegerOrInfinity = __webpack_require__(291);
	
	var min = Math.min;
	
	// `ToLength` abstract operation
	// https://tc39.es/ecma262/#sec-tolength
	module.exports = function (argument) {
	  var len = toIntegerOrInfinity(argument);
	  return len > 0 ? min(len, 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
	};


/***/ },
/* 1418 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var call = __webpack_require__(100);
	var isObject = __webpack_require__(74);
	var isSymbol = __webpack_require__(207);
	var getMethod = __webpack_require__(1396);
	var ordinaryToPrimitive = __webpack_require__(1408);
	var wellKnownSymbol = __webpack_require__(76);
	
	var $TypeError = TypeError;
	var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');
	
	// `ToPrimitive` abstract operation
	// https://tc39.es/ecma262/#sec-toprimitive
	module.exports = function (input, pref) {
	  if (!isObject(input) || isSymbol(input)) return input;
	  var exoticToPrim = getMethod(input, TO_PRIMITIVE);
	  var result;
	  if (exoticToPrim) {
	    if (pref === undefined) pref = 'default';
	    result = call(exoticToPrim, input, pref);
	    if (!isObject(result) || isSymbol(result)) return result;
	    throw new $TypeError("Can't convert object to primitive value");
	  }
	  if (pref === undefined) pref = 'number';
	  return ordinaryToPrimitive(input, pref);
	};


/***/ },
/* 1419 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var globalThis = __webpack_require__(54);
	var isCallable = __webpack_require__(52);
	
	var WeakMap = globalThis.WeakMap;
	
	module.exports = isCallable(WeakMap) && /native code/.test(String(WeakMap));


/***/ },
/* 1420 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// TODO: Remove from `core-js@4`
	var $ = __webpack_require__(67);
	var bind = __webpack_require__(1393);
	
	// `Function.prototype.bind` method
	// https://tc39.es/ecma262/#sec-function.prototype.bind
	// eslint-disable-next-line es/no-function-prototype-bind -- detection
	$({ target: 'Function', proto: true, forced: Function.bind !== bind }, {
	  bind: bind
	});


/***/ },
/* 1421 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(67);
	var getBuiltIn = __webpack_require__(113);
	var call = __webpack_require__(100);
	var uncurryThis = __webpack_require__(44);
	var fails = __webpack_require__(50);
	var isArray = __webpack_require__(609);
	var isCallable = __webpack_require__(52);
	var isObject = __webpack_require__(74);
	var create = __webpack_require__(130);
	var isRawJSON = __webpack_require__(1401);
	var isSymbol = __webpack_require__(207);
	var classof = __webpack_require__(128);
	var thisNumberValue = __webpack_require__(1415);
	var includes = __webpack_require__(599).includes;
	var hasOwn = __webpack_require__(51);
	var toString = __webpack_require__(101);
	var parseJSONString = __webpack_require__(1410);
	var uid = __webpack_require__(210);
	var NATIVE_SYMBOL = __webpack_require__(131);
	var NATIVE_RAW_JSON = __webpack_require__(1404);
	
	var $String = String;
	var $TypeError = TypeError;
	var $stringify = getBuiltIn('JSON', 'stringify');
	var $BigInt = getBuiltIn('BigInt');
	var stringValueOf = uncurryThis(''.valueOf);
	var booleanValueOf = uncurryThis(true.valueOf);
	var bigIntValueOf = $BigInt && uncurryThis($BigInt.prototype.valueOf);
	var exec = uncurryThis(/./.exec);
	var charAt = uncurryThis(''.charAt);
	var charCodeAt = uncurryThis(''.charCodeAt);
	var replace = uncurryThis(''.replace);
	var slice = uncurryThis(''.slice);
	var push = uncurryThis([].push);
	var pop = uncurryThis([].pop);
	var numberToString = uncurryThis(1.1.toString);
	
	var surrogates = /[\uD800-\uDFFF]/g;
	var leadingSurrogates = /^[\uD800-\uDBFF]$/;
	var trailingSurrogates = /^[\uDC00-\uDFFF]$/;
	var digits = /^\d+$/;
	
	// a placeholder of a raw JSON value
	var RAW_MARK = uid();
	// a prefix of keys of a reordered object, see `createOrderedObject`
	var KEY_MARK = uid();
	// the last key of a reordered object, marks the end of its serialization
	var END_MARK = uid();
	var RAW_MARK_LENGTH = RAW_MARK.length;
	var KEY_MARK_LENGTH = KEY_MARK.length;
	
	var WRONG_SYMBOLS_CONVERSION = !NATIVE_SYMBOL || fails(function () {
	  var symbol = getBuiltIn('Symbol')('stringify detection');
	  // MS Edge converts symbol values to JSON as {}
	  return $stringify([symbol]) !== '[null]'
	    // WebKit converts symbol values to JSON as null
	    || $stringify({ a: symbol }) !== '{}'
	    // V8 throws on boxed symbols
	    || $stringify(Object(symbol)) !== '{}';
	});
	
	// https://github.com/tc39/proposal-well-formed-stringify
	var ILL_FORMED_UNICODE = fails(function () {
	  return $stringify('\uDF06\uD834') !== '"\\udf06\\ud834"'
	    || $stringify('\uDEAD') !== '"\\udead"';
	});
	
	var isRawJSONValue = NATIVE_RAW_JSON ? getBuiltIn('JSON', 'isRawJSON') : isRawJSON;
	
	var stringifyWithProperSymbolsConversion = WRONG_SYMBOLS_CONVERSION ? function (it, replacer, space) {
	  return $stringify(it, function (key, value) {
	    var replaced = call(replacer, this, key, value);
	    if (!isSymbol(replaced)) return replaced;
	  }, space);
	} : $stringify;
	
	var fixIllFormedJSON = function (match, offset, string) {
	  var prev = charAt(string, offset - 1);
	  var next = charAt(string, offset + 1);
	  if (
	    (exec(leadingSurrogates, match) && !exec(trailingSurrogates, next)) ||
	    (exec(trailingSurrogates, match) && !exec(leadingSurrogates, prev))
	  ) {
	    return '\\u' + numberToString(charCodeAt(match, 0), 16);
	  } return match;
	};
	
	// `PropertyList` of `JSON.stringify`
	// https://tc39.es/ecma262/#sec-json.stringify
	var getPropertyList = function (replacer) {
	  if (!isArray(replacer)) return;
	  var rawLength = replacer.length;
	  var propertyList = [];
	  // a null prototype object is used as a set of already added keys to keep the deduplication linear
	  var addedKeys = create(null);
	  for (var i = 0; i < rawLength; i++) {
	    var element = replacer[i];
	    var key;
	    if (typeof element == 'string') key = element;
	    else if (typeof element == 'number' || classof(element) === 'Number' || classof(element) === 'String') key = toString(element);
	    else continue;
	    if (!hasOwn(addedKeys, key)) {
	      addedKeys[key] = true;
	      push(propertyList, key);
	    }
	  }
	  return propertyList;
	};
	
	// values with such an internal slot are unwrapped by `SerializeJSONProperty` instead of being serialized as objects
	var hasInternalSlot = function (valueOf, it) {
	  try {
	    valueOf(it);
	    return true;
	  } catch (error) {
	    return false;
	  }
	};
	
	// the slot check is expensive, so it's performed only for the kind reported by the value itself -
	// a value lying about its kind via `Symbol.toStringTag` is serialized as an ordinary object
	var isBoxedPrimitive = function (it) {
	  var kind = classof(it);
	  return (kind === 'Number' && hasInternalSlot(thisNumberValue, it))
	    || (kind === 'String' && hasInternalSlot(stringValueOf, it))
	    || (kind === 'Boolean' && hasInternalSlot(booleanValueOf, it))
	    || (!!bigIntValueOf && kind === 'BigInt' && hasInternalSlot(bigIntValueOf, it));
	};
	
	// only objects serialized by `SerializeJSONObject` are affected by the property list
	var isSerializedAsObject = function (it) {
	  if (!isObject(it) || isCallable(it) || isArray(it)) return false;
	  try {
	    return !isBoxedPrimitive(it);
	  // `classof` reads `Symbol.toStringTag`, so a proxy could throw - it has no internal slots anyway
	  } catch (error) {
	    return true;
	  }
	};
	
	// the engine unwraps it in the same order as it would read the original property,
	// so the property is read lazily and `toJSON` is called once and with the original key
	var createElementHolder = function (holder, key) {
	  return {
	    toJSON: function () {
	      var element = holder[key];
	      if (isObject(element) || typeof element == 'bigint') {
	        var elementToJSON = element.toJSON;
	        if (isCallable(elementToJSON)) element = call(elementToJSON, element, key);
	      } return element;
	    }
	  };
	};
	
	// own keys of objects are sorted - integer-like keys are moved to the beginning,
	// so such keys should be marked and restored in the serialized string
	var getKeyPrefix = function (propertyList) {
	  for (var i = 0, length = propertyList.length; i < length; i++) {
	    if (exec(digits, propertyList[i])) return KEY_MARK;
	  } return '';
	};
	
	// `SerializeJSONObject` iterates the property list, so the value is replaced with an object with keys in this order
	var createOrderedObject = function (value, propertyList, keyPrefix) {
	  // keys are not marked if the property list has no integer-like keys, so `Object.prototype`
	  // with a setter, a non-writable property or `__proto__` should not intercept the assignment
	  var ordered = create(null);
	  for (var i = 0, length = propertyList.length; i < length; i++) {
	    var key = propertyList[i];
	    ordered[keyPrefix + key] = createElementHolder(value, key);
	  }
	  ordered[END_MARK] = null;
	  return ordered;
	};
	
	// `JSON.stringify` method
	// https://tc39.es/ecma262/#sec-json.stringify
	// https://github.com/tc39/proposal-json-parse-with-source
	if ($stringify) $({ target: 'JSON', stat: true, arity: 3, forced: WRONG_SYMBOLS_CONVERSION || ILL_FORMED_UNICODE || !NATIVE_RAW_JSON }, {
	  stringify: function stringify(text, replacer, space) {
	    var replacerFunction = isCallable(replacer) ? replacer : undefined;
	    var propertyList = replacerFunction ? undefined : getPropertyList(replacer);
	    var keyPrefix = propertyList && getKeyPrefix(propertyList);
	    var rawStrings = [];
	    var openObjects = [];
	    var parentOrdered = [];
	    var currentOrdered;
	    var marked = false;
	    var root = true;
	
	    var json = stringifyWithProperSymbolsConversion(text, function (key, value) {
	      // some old implementations (like WebKit) could pass numbers as keys
	      key = $String(key);
	
	      if (propertyList) {
	        if (key === END_MARK) {
	          pop(openObjects);
	          currentOrdered = pop(parentOrdered);
	          return;
	        }
	        if (root) root = false;
	        // the innermost reordered object already contains only keys of the property list and arrays are not
	        // affected by it, the rest of objects (like objects with a fake `Symbol.toStringTag`) are filtered here
	        else if (this !== currentOrdered && !isArray(this) && !includes(propertyList, key)) return;
	      } else if (replacerFunction) value = call(replacerFunction, this, key, value);
	
	      if (isRawJSONValue(value)) {
	        if (NATIVE_RAW_JSON) return value;
	        marked = true;
	        return RAW_MARK + (push(rawStrings, value.rawJSON) - 1);
	      }
	
	      if (propertyList && isSerializedAsObject(value)) {
	        // reordered objects are new each time, so cycles should be detected before the engine does it
	        if (includes(openObjects, value)) throw new $TypeError('Converting circular structure to JSON');
	        var ordered = createOrderedObject(value, propertyList, keyPrefix);
	        push(openObjects, value);
	        push(parentOrdered, currentOrdered);
	        currentOrdered = ordered;
	        if (keyPrefix) marked = true;
	        return ordered;
	      }
	
	      return value;
	    }, space);
	
	    if (typeof json != 'string') return json;
	
	    if (ILL_FORMED_UNICODE) json = replace(json, surrogates, fixIllFormedJSON);
	
	    if (!marked) return json;
	
	    var result = '';
	    var length = json.length;
	
	    for (var i = 0; i < length; i++) {
	      var chr = charAt(json, i);
	      if (chr === '"') {
	        var end = parseJSONString(json, ++i).end - 1;
	        var string = slice(json, i, end);
	        if (slice(string, 0, RAW_MARK_LENGTH) === RAW_MARK) result += rawStrings[slice(string, RAW_MARK_LENGTH)];
	        else if (slice(string, 0, KEY_MARK_LENGTH) === KEY_MARK) result += '"' + slice(string, KEY_MARK_LENGTH) + '"';
	        else result += '"' + string + '"';
	        i = end;
	      } else result += chr;
	    }
	
	    return result;
	  }
	});


/***/ },
/* 1422 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// TODO: Remove from `core-js@4`
	var $ = __webpack_require__(67);
	var DESCRIPTORS = __webpack_require__(62);
	var create = __webpack_require__(130);
	
	// `Object.create` method
	// https://tc39.es/ecma262/#sec-object.create
	$({ target: 'Object', stat: true, sham: !DESCRIPTORS }, {
	  create: create
	});


/***/ },
/* 1423 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(67);
	var NATIVE_SYMBOL = __webpack_require__(131);
	var fails = __webpack_require__(50);
	var getOwnPropertySymbolsModule = __webpack_require__(287);
	var toObject = __webpack_require__(167);
	
	// V8 ~ Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
	// https://bugs.chromium.org/p/v8/issues/detail?id=3443
	var FORCED = !NATIVE_SYMBOL || fails(function () { getOwnPropertySymbolsModule.f(1); });
	
	// `Object.getOwnPropertySymbols` method
	// https://tc39.es/ecma262/#sec-object.getownpropertysymbols
	$({ target: 'Object', stat: true, forced: FORCED }, {
	  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
	    var $getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
	    return $getOwnPropertySymbols ? $getOwnPropertySymbols(toObject(it)) : [];
	  }
	});


/***/ },
/* 1424 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(67);
	var fails = __webpack_require__(50);
	var toObject = __webpack_require__(167);
	var nativeGetPrototypeOf = __webpack_require__(288);
	var CORRECT_PROTOTYPE_GETTER = __webpack_require__(602);
	
	var FAILS_ON_PRIMITIVES = fails(function () { nativeGetPrototypeOf(1); });
	
	// `Object.getPrototypeOf` method
	// https://tc39.es/ecma262/#sec-object.getprototypeof
	$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES, sham: !CORRECT_PROTOTYPE_GETTER }, {
	  getPrototypeOf: function getPrototypeOf(it) {
	    return nativeGetPrototypeOf(toObject(it));
	  }
	});
	


/***/ },
/* 1425 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(67);
	var setPrototypeOf = __webpack_require__(619);
	
	// `Object.setPrototypeOf` method
	// https://tc39.es/ecma262/#sec-object.setprototypeof
	$({ target: 'Object', stat: true }, {
	  setPrototypeOf: setPrototypeOf
	});


/***/ },
/* 1426 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var TO_STRING_TAG_SUPPORT = __webpack_require__(293);
	var defineBuiltIn = __webpack_require__(129);
	var toString = __webpack_require__(1407);
	
	// `Object.prototype.toString` method
	// https://tc39.es/ecma262/#sec-object.prototype.tostring
	if (!TO_STRING_TAG_SUPPORT) {
	  defineBuiltIn(Object.prototype, 'toString', toString, { unsafe: true });
	}


/***/ },
/* 1427 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(67);
	var $parseInt = __webpack_require__(1405);
	
	// `parseInt` method
	// https://tc39.es/ecma262/#sec-parseint-string-radix
	$({ global: true, forced: parseInt !== $parseInt }, {
	  parseInt: $parseInt
	});


/***/ },
/* 1428 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var charAt = __webpack_require__(1412).charAt;
	var toString = __webpack_require__(101);
	var InternalStateModule = __webpack_require__(163);
	var defineIterator = __webpack_require__(611);
	var createIterResultObject = __webpack_require__(603);
	
	var STRING_ITERATOR = 'String Iterator';
	var setInternalState = InternalStateModule.set;
	var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);
	
	// `String.prototype[@@iterator]` method
	// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
	defineIterator(String, 'String', function (iterated) {
	  setInternalState(this, {
	    type: STRING_ITERATOR,
	    string: toString(iterated),
	    index: 0
	  });
	// `%StringIteratorPrototype%.next` method
	// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
	}, function next() {
	  var state = getInternalState(this);
	  var string = state.string;
	  var index = state.index;
	  var point;
	  if (index >= string.length) return createIterResultObject(undefined, true);
	  point = charAt(string, index);
	  state.index += point.length;
	  return createIterResultObject(point, false);
	});


/***/ },
/* 1429 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(67);
	var globalThis = __webpack_require__(54);
	var call = __webpack_require__(100);
	var uncurryThis = __webpack_require__(44);
	var IS_PURE = __webpack_require__(164);
	var DESCRIPTORS = __webpack_require__(62);
	var NATIVE_SYMBOL = __webpack_require__(131);
	var fails = __webpack_require__(50);
	var hasOwn = __webpack_require__(51);
	var isPrototypeOf = __webpack_require__(289);
	var anObject = __webpack_require__(161);
	var toIndexedObject = __webpack_require__(114);
	var toPropertyKey = __webpack_require__(292);
	var $toString = __webpack_require__(101);
	var createPropertyDescriptor = __webpack_require__(162);
	var nativeObjectCreate = __webpack_require__(130);
	var objectKeys = __webpack_require__(617);
	var getOwnPropertyNamesModule = __webpack_require__(286);
	var getOwnPropertyNamesExternal = __webpack_require__(1406);
	var getOwnPropertySymbolsModule = __webpack_require__(287);
	var getOwnPropertyDescriptorModule = __webpack_require__(285);
	var definePropertyModule = __webpack_require__(75);
	var definePropertiesModule = __webpack_require__(615);
	var propertyIsEnumerableModule = __webpack_require__(618);
	var defineBuiltIn = __webpack_require__(129);
	var defineBuiltInAccessor = __webpack_require__(604);
	var shared = __webpack_require__(166);
	var sharedKey = __webpack_require__(209);
	var hiddenKeys = __webpack_require__(206);
	var uid = __webpack_require__(210);
	var wellKnownSymbol = __webpack_require__(76);
	var wrappedWellKnownSymbolModule = __webpack_require__(625);
	var defineWellKnownSymbol = __webpack_require__(624);
	var defineSymbolToPrimitive = __webpack_require__(1414);
	var setToStringTag = __webpack_require__(208);
	var InternalStateModule = __webpack_require__(163);
	var $forEach = __webpack_require__(1384).forEach;
	
	var HIDDEN = sharedKey('hidden');
	var SYMBOL = 'Symbol';
	var PROTOTYPE = 'prototype';
	
	var setInternalState = InternalStateModule.set;
	var getInternalState = InternalStateModule.getterFor(SYMBOL);
	
	var ObjectPrototype = Object[PROTOTYPE];
	var $Symbol = globalThis.Symbol;
	var SymbolPrototype = $Symbol && $Symbol[PROTOTYPE];
	var RangeError = globalThis.RangeError;
	var TypeError = globalThis.TypeError;
	var QObject = globalThis.QObject;
	var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
	var nativeDefineProperty = definePropertyModule.f;
	var nativeGetOwnPropertyNames = getOwnPropertyNamesExternal.f;
	var nativePropertyIsEnumerable = propertyIsEnumerableModule.f;
	var push = uncurryThis([].push);
	
	var AllSymbols = shared('symbols');
	var ObjectPrototypeSymbols = shared('op-symbols');
	var WellKnownSymbolsStore = shared('wks');
	
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var USE_SETTER = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var fallbackDefineProperty = function (O, P, Attributes) {
	  var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor(ObjectPrototype, P);
	  if (ObjectPrototypeDescriptor) delete ObjectPrototype[P];
	  nativeDefineProperty(O, P, Attributes);
	  if (ObjectPrototypeDescriptor && O !== ObjectPrototype) {
	    nativeDefineProperty(ObjectPrototype, P, ObjectPrototypeDescriptor);
	  } return O;
	};
	
	var setSymbolDescriptor = DESCRIPTORS && fails(function () {
	  return nativeObjectCreate(nativeDefineProperty({}, 'a', {
	    get: function () { return nativeDefineProperty(this, 'a', { value: 7 }).a; }
	  })).a !== 7;
	}) ? fallbackDefineProperty : nativeDefineProperty;
	
	var wrap = function (tag, description) {
	  var symbol = AllSymbols[tag] = nativeObjectCreate(SymbolPrototype);
	  setInternalState(symbol, {
	    type: SYMBOL,
	    tag: tag,
	    description: description
	  });
	  if (!DESCRIPTORS) symbol.description = description;
	  return symbol;
	};
	
	var $defineProperty = function defineProperty(O, P, Attributes) {
	  if (O === ObjectPrototype) $defineProperty(ObjectPrototypeSymbols, P, Attributes);
	  anObject(O);
	  var key = toPropertyKey(P);
	  anObject(Attributes);
	  if (hasOwn(AllSymbols, key)) {
	    // first definition - default non-enumerable; redefinition - preserve existing state
	    if (!('enumerable' in Attributes) ? !hasOwn(O, key) || (hasOwn(O, HIDDEN) && O[HIDDEN][key]) : !Attributes.enumerable) {
	      if (!hasOwn(O, HIDDEN)) nativeDefineProperty(O, HIDDEN, createPropertyDescriptor(1, nativeObjectCreate(null)));
	      O[HIDDEN][key] = true;
	    } else {
	      if (hasOwn(O, HIDDEN) && O[HIDDEN][key]) O[HIDDEN][key] = false;
	      Attributes = nativeObjectCreate(Attributes, { enumerable: createPropertyDescriptor(0, false) });
	    } return setSymbolDescriptor(O, key, Attributes);
	  } return nativeDefineProperty(O, key, Attributes);
	};
	
	var $defineProperties = function defineProperties(O, Properties) {
	  anObject(O);
	  var properties = toIndexedObject(Properties);
	  var keys = objectKeys(properties).concat($getOwnPropertySymbols(properties));
	  $forEach(keys, function (key) {
	    if (!DESCRIPTORS || call($propertyIsEnumerable, properties, key)) $defineProperty(O, key, properties[key]);
	  });
	  return O;
	};
	
	var $create = function create(O, Properties) {
	  return Properties === undefined ? nativeObjectCreate(O) : $defineProperties(nativeObjectCreate(O), Properties);
	};
	
	var $propertyIsEnumerable = function propertyIsEnumerable(V) {
	  var P = toPropertyKey(V);
	  var enumerable = call(nativePropertyIsEnumerable, this, P);
	  if (this === ObjectPrototype && hasOwn(AllSymbols, P) && !hasOwn(ObjectPrototypeSymbols, P)) return false;
	  return enumerable || !hasOwn(this, P) || !hasOwn(AllSymbols, P) || hasOwn(this, HIDDEN) && this[HIDDEN][P]
	    ? enumerable : true;
	};
	
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
	  var it = toIndexedObject(O);
	  var key = toPropertyKey(P);
	  if (it === ObjectPrototype && hasOwn(AllSymbols, key) && !hasOwn(ObjectPrototypeSymbols, key)) return;
	  var descriptor = nativeGetOwnPropertyDescriptor(it, key);
	  if (descriptor && hasOwn(AllSymbols, key) && !(hasOwn(it, HIDDEN) && it[HIDDEN][key])) {
	    descriptor.enumerable = true;
	  }
	  return descriptor;
	};
	
	var $getOwnPropertyNames = function getOwnPropertyNames(O) {
	  var names = nativeGetOwnPropertyNames(toIndexedObject(O));
	  var result = [];
	  $forEach(names, function (key) {
	    if (!hasOwn(AllSymbols, key) && !hasOwn(hiddenKeys, key)) push(result, key);
	  });
	  return result;
	};
	
	var $getOwnPropertySymbols = function (O) {
	  var IS_OBJECT_PROTOTYPE = O === ObjectPrototype;
	  var names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject(O));
	  var result = [];
	  $forEach(names, function (key) {
	    if (hasOwn(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || hasOwn(ObjectPrototype, key))) {
	      push(result, AllSymbols[key]);
	    }
	  });
	  return result;
	};
	
	// `Symbol` constructor
	// https://tc39.es/ecma262/#sec-symbol-constructor
	if (!NATIVE_SYMBOL) {
	  $Symbol = function Symbol() {
	    if (isPrototypeOf(SymbolPrototype, this)) throw new TypeError('Symbol is not a constructor');
	    var description = !arguments.length || arguments[0] === undefined ? undefined : $toString(arguments[0]);
	    var tag = uid(description);
	    var setter = function (value) {
	      var $this = this === undefined ? globalThis : this;
	      if ($this === ObjectPrototype) call(setter, ObjectPrototypeSymbols, value);
	      if (hasOwn($this, HIDDEN) && hasOwn($this[HIDDEN], tag)) $this[HIDDEN][tag] = false;
	      var descriptor = createPropertyDescriptor(1, value);
	      try {
	        setSymbolDescriptor($this, tag, descriptor);
	      } catch (error) {
	        if (!(error instanceof RangeError)) throw error;
	        fallbackDefineProperty($this, tag, descriptor);
	      }
	    };
	    if (DESCRIPTORS && USE_SETTER) setSymbolDescriptor(ObjectPrototype, tag, { configurable: true, set: setter });
	    return wrap(tag, description);
	  };
	
	  SymbolPrototype = $Symbol[PROTOTYPE];
	
	  defineBuiltIn(SymbolPrototype, 'toString', function toString() {
	    return getInternalState(this).tag;
	  });
	
	  defineBuiltIn($Symbol, 'withoutSetter', function (description) {
	    return wrap(uid(description), description);
	  });
	
	  propertyIsEnumerableModule.f = $propertyIsEnumerable;
	  definePropertyModule.f = $defineProperty;
	  definePropertiesModule.f = $defineProperties;
	  getOwnPropertyDescriptorModule.f = $getOwnPropertyDescriptor;
	  getOwnPropertyNamesModule.f = getOwnPropertyNamesExternal.f = $getOwnPropertyNames;
	  getOwnPropertySymbolsModule.f = $getOwnPropertySymbols;
	
	  wrappedWellKnownSymbolModule.f = function (name) {
	    return wrap(wellKnownSymbol(name), name);
	  };
	
	  if (DESCRIPTORS) {
	    // https://tc39.es/ecma262/#sec-symbol.prototype.description
	    defineBuiltInAccessor(SymbolPrototype, 'description', {
	      configurable: true,
	      get: function description() {
	        return getInternalState(this).description;
	      }
	    });
	    if (!IS_PURE) {
	      defineBuiltIn(ObjectPrototype, 'propertyIsEnumerable', $propertyIsEnumerable, { unsafe: true });
	    }
	  }
	}
	
	$({ global: true, constructor: true, wrap: true, forced: !NATIVE_SYMBOL, sham: !NATIVE_SYMBOL }, {
	  Symbol: $Symbol
	});
	
	$forEach(objectKeys(WellKnownSymbolsStore), function (name) {
	  defineWellKnownSymbol(name);
	});
	
	$({ target: SYMBOL, stat: true, forced: !NATIVE_SYMBOL }, {
	  useSetter: function () { USE_SETTER = true; },
	  useSimple: function () { USE_SETTER = false; }
	});
	
	$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL, sham: !DESCRIPTORS }, {
	  // `Object.create` method
	  // https://tc39.es/ecma262/#sec-object.create
	  create: $create,
	  // `Object.defineProperty` method
	  // https://tc39.es/ecma262/#sec-object.defineproperty
	  defineProperty: $defineProperty,
	  // `Object.defineProperties` method
	  // https://tc39.es/ecma262/#sec-object.defineproperties
	  defineProperties: $defineProperties,
	  // `Object.getOwnPropertyDescriptor` method
	  // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor
	});
	
	$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL }, {
	  // `Object.getOwnPropertyNames` method
	  // https://tc39.es/ecma262/#sec-object.getownpropertynames
	  getOwnPropertyNames: $getOwnPropertyNames
	});
	
	// `Symbol.prototype[@@toPrimitive]` method
	// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
	defineSymbolToPrimitive();
	
	// `Symbol.prototype[@@toStringTag]` property
	// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
	setToStringTag($Symbol, SYMBOL);
	
	hiddenKeys[HIDDEN] = true;


/***/ },
/* 1430 */
/***/ function(module, exports, __webpack_require__) {

	// `Symbol.prototype.description` getter
	// https://tc39.es/ecma262/#sec-symbol.prototype.description
	'use strict';
	var $ = __webpack_require__(67);
	var DESCRIPTORS = __webpack_require__(62);
	var globalThis = __webpack_require__(54);
	var call = __webpack_require__(100);
	var uncurryThis = __webpack_require__(44);
	var hasOwn = __webpack_require__(51);
	var isCallable = __webpack_require__(52);
	var isPrototypeOf = __webpack_require__(289);
	var toString = __webpack_require__(101);
	var defineBuiltInAccessor = __webpack_require__(604);
	var copyConstructorProperties = __webpack_require__(601);
	
	var NativeSymbol = globalThis.Symbol;
	var SymbolPrototype = NativeSymbol && NativeSymbol.prototype;
	
	if (DESCRIPTORS && isCallable(NativeSymbol) && (!('description' in SymbolPrototype) ||
	  // Safari 12 bug
	  NativeSymbol().description !== undefined
	)) {
	  var EmptyStringDescriptionStore = {};
	  // wrap Symbol constructor for correct work with undefined description
	  var SymbolWrapper = function Symbol() {
	    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : toString(arguments[0]);
	    var result = isPrototypeOf(SymbolPrototype, this)
	      // eslint-disable-next-line sonarjs/inconsistent-function-call -- ok
	      ? new NativeSymbol(description)
	      // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
	      : description === undefined ? NativeSymbol() : NativeSymbol(description);
	    if (description === '') EmptyStringDescriptionStore[result] = true;
	    return result;
	  };
	
	  copyConstructorProperties(SymbolWrapper, NativeSymbol);
	  // wrap Symbol.for for correct handling of empty string descriptions
	  var nativeFor = SymbolWrapper['for'];
	  SymbolWrapper['for'] = { 'for': function (key) {
	    var stringKey = toString(key);
	    var symbol = call(nativeFor, this, stringKey);
	    if (stringKey === '') EmptyStringDescriptionStore[symbol] = true;
	    return symbol;
	  } }['for'];
	  SymbolWrapper.prototype = SymbolPrototype;
	  SymbolPrototype.constructor = SymbolWrapper;
	
	  var NATIVE_SYMBOL = String(NativeSymbol('description detection')) === 'Symbol(description detection)';
	  var thisSymbolValue = uncurryThis(SymbolPrototype.valueOf);
	  var symbolDescriptiveString = uncurryThis(SymbolPrototype.toString);
	  var regexp = /^Symbol\((.*)\)[^)]+$/;
	  var replace = uncurryThis(''.replace);
	  var stringSlice = uncurryThis(''.slice);
	
	  defineBuiltInAccessor(SymbolPrototype, 'description', {
	    configurable: true,
	    get: function description() {
	      var symbol = thisSymbolValue(this);
	      if (hasOwn(EmptyStringDescriptionStore, symbol)) return '';
	      var string = symbolDescriptiveString(symbol);
	      var desc = NATIVE_SYMBOL ? stringSlice(string, 7, -1) : replace(string, regexp, '$1');
	      return desc === '' ? undefined : desc;
	    }
	  });
	
	  $({ global: true, constructor: true, forced: true }, {
	    Symbol: SymbolWrapper
	  });
	}


/***/ },
/* 1431 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(67);
	var getBuiltIn = __webpack_require__(113);
	var hasOwn = __webpack_require__(51);
	var toString = __webpack_require__(101);
	var shared = __webpack_require__(166);
	var NATIVE_SYMBOL_REGISTRY = __webpack_require__(620);
	
	var StringToSymbolRegistry = shared('string-to-symbol-registry');
	var SymbolToStringRegistry = shared('symbol-to-string-registry');
	
	// `Symbol.for` method
	// https://tc39.es/ecma262/#sec-symbol.for
	$({ target: 'Symbol', stat: true, forced: !NATIVE_SYMBOL_REGISTRY }, {
	  'for': function (key) {
	    var string = toString(key);
	    if (hasOwn(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
	    var symbol = getBuiltIn('Symbol')(string);
	    StringToSymbolRegistry[string] = symbol;
	    SymbolToStringRegistry[symbol] = string;
	    return symbol;
	  }
	});


/***/ },
/* 1432 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var defineWellKnownSymbol = __webpack_require__(624);
	
	// `Symbol.iterator` well-known symbol
	// https://tc39.es/ecma262/#sec-symbol.iterator
	defineWellKnownSymbol('iterator');


/***/ },
/* 1433 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// TODO: Remove this module from `core-js@4` since it's split to modules listed below
	__webpack_require__(1429);
	__webpack_require__(1431);
	__webpack_require__(1434);
	__webpack_require__(1421);
	__webpack_require__(1423);


/***/ },
/* 1434 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(67);
	var hasOwn = __webpack_require__(51);
	var isSymbol = __webpack_require__(207);
	var tryToString = __webpack_require__(621);
	var shared = __webpack_require__(166);
	var NATIVE_SYMBOL_REGISTRY = __webpack_require__(620);
	
	var SymbolToStringRegistry = shared('symbol-to-string-registry');
	
	// `Symbol.keyFor` method
	// https://tc39.es/ecma262/#sec-symbol.keyfor
	$({ target: 'Symbol', stat: true, forced: !NATIVE_SYMBOL_REGISTRY }, {
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw new TypeError(tryToString(sym) + ' is not a symbol');
	    if (hasOwn(SymbolToStringRegistry, sym)) return SymbolToStringRegistry[sym];
	  }
	});


/***/ },
/* 1435 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var globalThis = __webpack_require__(54);
	var DOMIterables = __webpack_require__(1388);
	var DOMTokenListPrototype = __webpack_require__(1389);
	var ArrayIteratorMethods = __webpack_require__(627);
	var createNonEnumerableProperty = __webpack_require__(204);
	var setToStringTag = __webpack_require__(208);
	var wellKnownSymbol = __webpack_require__(76);
	
	var ITERATOR = wellKnownSymbol('iterator');
	var ArrayValues = ArrayIteratorMethods.values;
	
	var handlePrototype = function (CollectionPrototype, COLLECTION_NAME) {
	  if (CollectionPrototype) {
	    // some Chrome versions have non-configurable methods on DOMTokenList
	    if (CollectionPrototype[ITERATOR] !== ArrayValues) try {
	      createNonEnumerableProperty(CollectionPrototype, ITERATOR, ArrayValues);
	    } catch (error) {
	      CollectionPrototype[ITERATOR] = ArrayValues;
	    }
	    setToStringTag(CollectionPrototype, COLLECTION_NAME, true);
	    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
	      // some Chrome versions have non-configurable methods on DOMTokenList
	      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
	        createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
	      } catch (error) {
	        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
	      }
	    }
	  }
	};
	
	for (var COLLECTION_NAME in DOMIterables) {
	  handlePrototype(globalThis[COLLECTION_NAME] && globalThis[COLLECTION_NAME].prototype, COLLECTION_NAME);
	}
	
	handlePrototype(DOMTokenListPrototype, 'DOMTokenList');


/***/ },
/* 1436 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	var runtime = (function (exports) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; };
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  function define(obj, key, value) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	    return obj[key];
	  }
	  try {
	    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
	    define({}, "");
	  } catch (err) {
	    define = function(obj, key, value) {
	      return obj[key] = value;
	    };
	  }
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) });
	
	    return generator;
	  }
	  exports.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  define(IteratorPrototype, iteratorSymbol, function () {
	    return this;
	  });
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = GeneratorFunctionPrototype;
	  defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: true });
	  defineProperty(
	    GeneratorFunctionPrototype,
	    "constructor",
	    { value: GeneratorFunction, configurable: true }
	  );
	  GeneratorFunction.displayName = define(
	    GeneratorFunctionPrototype,
	    toStringTagSymbol,
	    "GeneratorFunction"
	  );
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      define(prototype, method, function(arg) {
	        return this._invoke(method, arg);
	      });
	    });
	  }
	
	  exports.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  exports.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      define(genFun, toStringTagSymbol, "GeneratorFunction");
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  exports.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator, PromiseImpl) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return PromiseImpl.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return PromiseImpl.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration.
	          result.value = unwrapped;
	          resolve(result);
	        }, function(error) {
	          // If a rejected Promise was yielded, throw the rejection back
	          // into the async generator function so it can be handled there.
	          return invoke("throw", error, resolve, reject);
	        });
	      }
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new PromiseImpl(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    defineProperty(this, "_invoke", { value: enqueue });
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
	    return this;
	  });
	  exports.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
	    if (PromiseImpl === void 0) PromiseImpl = Promise;
	
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList),
	      PromiseImpl
	    );
	
	    return exports.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var methodName = context.method;
	    var method = delegate.iterator[methodName];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method, or a missing .next mehtod, always terminate the
	      // yield* loop.
	      context.delegate = null;
	
	      // Note: ["return"] must be used for ES3 parsing compatibility.
	      if (methodName === "throw" && delegate.iterator["return"]) {
	        // If the delegate iterator has a return method, give it a
	        // chance to clean up.
	        context.method = "return";
	        context.arg = undefined;
	        maybeInvokeDelegate(delegate, context);
	
	        if (context.method === "throw") {
	          // If maybeInvokeDelegate(context) changed context.method from
	          // "return" to "throw", let that override the TypeError below.
	          return ContinueSentinel;
	        }
	      }
	      if (methodName !== "return") {
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a '" + methodName + "' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  define(Gp, toStringTagSymbol, "Generator");
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  define(Gp, iteratorSymbol, function() {
	    return this;
	  });
	
	  define(Gp, "toString", function() {
	    return "[object Generator]";
	  });
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  exports.keys = function(val) {
	    var object = Object(val);
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  exports.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	
	  // Regardless of whether this script is executing as a CommonJS module
	  // or not, return the runtime object so that we can declare the variable
	  // regeneratorRuntime in the outer scope, which allows this module to be
	  // injected easily by `bin/regenerator --include-runtime script.js`.
	  return exports;
	
	}(
	  // If this script is executing as a CommonJS module, use module.exports
	  // as the regeneratorRuntime namespace. Otherwise create a new empty
	  // object. Either way, the resulting object will be used to initialize
	  // the regeneratorRuntime variable at the top of this file.
	   true ? module.exports : {}
	));
	
	try {
	  regeneratorRuntime = runtime;
	} catch (accidentalStrictMode) {
	  // This module should not be running in strict mode, so the above
	  // assignment should always work unless something is misconfigured. Just
	  // in case runtime.js accidentally runs in strict mode, in modern engines
	  // we can explicitly access globalThis. In older engines we can escape
	  // strict mode using a global Function call. This could conceivably fail
	  // if a Content Security Policy forbids using Function, but in that case
	  // the proper solution is to fix the accidental strict mode problem. If
	  // you've misconfigured your bundler to force strict mode and applied a
	  // CSP to forbid Function, and you're not willing to fix either of those
	  // problems, please detail your unique predicament in a GitHub issue.
	  if (typeof globalThis === "object") {
	    globalThis.regeneratorRuntime = runtime;
	  } else {
	    Function("r", "regeneratorRuntime = r")(runtime);
	  }
	}


/***/ },
/* 1437 */
/***/ function(module, exports) {

	/** @license React v17.0.2
	 * react-is.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	'use strict';var b=60103,c=60106,d=60107,e=60108,f=60114,g=60109,h=60110,k=60112,l=60113,m=60120,n=60115,p=60116,q=60121,r=60122,u=60117,v=60129,w=60131;
	if("function"===typeof Symbol&&Symbol.for){var x=Symbol.for;b=x("react.element");c=x("react.portal");d=x("react.fragment");e=x("react.strict_mode");f=x("react.profiler");g=x("react.provider");h=x("react.context");k=x("react.forward_ref");l=x("react.suspense");m=x("react.suspense_list");n=x("react.memo");p=x("react.lazy");q=x("react.block");r=x("react.server.block");u=x("react.fundamental");v=x("react.debug_trace_mode");w=x("react.legacy_hidden")}
	function y(a){if("object"===typeof a&&null!==a){var t=a.$$typeof;switch(t){case b:switch(a=a.type,a){case d:case f:case e:case l:case m:return a;default:switch(a=a&&a.$$typeof,a){case h:case k:case p:case n:case g:return a;default:return t}}case c:return t}}}var z=g,A=b,B=k,C=d,D=p,E=n,F=c,G=f,H=e,I=l;exports.ContextConsumer=h;exports.ContextProvider=z;exports.Element=A;exports.ForwardRef=B;exports.Fragment=C;exports.Lazy=D;exports.Memo=E;exports.Portal=F;exports.Profiler=G;exports.StrictMode=H;
	exports.Suspense=I;exports.isAsyncMode=function(){return!1};exports.isConcurrentMode=function(){return!1};exports.isContextConsumer=function(a){return y(a)===h};exports.isContextProvider=function(a){return y(a)===g};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===b};exports.isForwardRef=function(a){return y(a)===k};exports.isFragment=function(a){return y(a)===d};exports.isLazy=function(a){return y(a)===p};exports.isMemo=function(a){return y(a)===n};
	exports.isPortal=function(a){return y(a)===c};exports.isProfiler=function(a){return y(a)===f};exports.isStrictMode=function(a){return y(a)===e};exports.isSuspense=function(a){return y(a)===l};exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===d||a===f||a===v||a===e||a===l||a===m||a===w||"object"===typeof a&&null!==a&&(a.$$typeof===p||a.$$typeof===n||a.$$typeof===g||a.$$typeof===h||a.$$typeof===k||a.$$typeof===u||a.$$typeof===q||a[0]===r)?!0:!1};
	exports.typeOf=y;


/***/ },
/* 1438 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var Page =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(Page, _Component);
	
	  function Page() {
	    _classCallCheck(this, Page);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(Page).apply(this, arguments));
	  }
	
	  _createClass(Page, [{
	    key: "handleClick",
	    value: function handleClick(e) {
	      var _this$props = this.props,
	          isDisabled = _this$props.isDisabled,
	          pageNumber = _this$props.pageNumber;
	      e.preventDefault();
	
	      if (isDisabled) {
	        return;
	      }
	
	      this.props.onClick(pageNumber);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _cx;
	
	      var _this$props2 = this.props,
	          pageText = _this$props2.pageText,
	          pageNumber = _this$props2.pageNumber,
	          activeClass = _this$props2.activeClass,
	          itemClass = _this$props2.itemClass,
	          linkClass = _this$props2.linkClass,
	          activeLinkClass = _this$props2.activeLinkClass,
	          disabledClass = _this$props2.disabledClass,
	          isActive = _this$props2.isActive,
	          isDisabled = _this$props2.isDisabled,
	          href = _this$props2.href,
	          ariaLabel = _this$props2.ariaLabel;
	      var css = (0, _classnames["default"])(itemClass, (_cx = {}, _defineProperty(_cx, activeClass, isActive), _defineProperty(_cx, disabledClass, isDisabled), _cx));
	      var linkCss = (0, _classnames["default"])(linkClass, _defineProperty({}, activeLinkClass, isActive));
	      return _react["default"].createElement("li", {
	        className: css,
	        onClick: this.handleClick.bind(this)
	      }, _react["default"].createElement("a", {
	        className: linkCss,
	        href: href,
	        "aria-label": ariaLabel
	      }, pageText));
	    }
	  }]);
	
	  return Page;
	}(_react.Component);
	
	exports["default"] = Page;
	
	_defineProperty(Page, "propTypes", {
	  pageText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].element]),
	  pageNumber: _propTypes["default"].number.isRequired,
	  onClick: _propTypes["default"].func.isRequired,
	  isActive: _propTypes["default"].bool.isRequired,
	  isDisabled: _propTypes["default"].bool,
	  activeClass: _propTypes["default"].string,
	  activeLinkClass: _propTypes["default"].string,
	  itemClass: _propTypes["default"].string,
	  linkClass: _propTypes["default"].string,
	  disabledClass: _propTypes["default"].string,
	  href: _propTypes["default"].string
	});
	
	_defineProperty(Page, "defaultProps", {
	  activeClass: "active",
	  disabledClass: "disabled",
	  itemClass: undefined,
	  linkClass: undefined,
	  activeLinkCLass: undefined,
	  isActive: false,
	  isDisabled: false,
	  href: "#"
	});

/***/ },
/* 1439 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	var _react = _interopRequireDefault(__webpack_require__(1));
	var _jsonToCsvExport = _interopRequireDefault(__webpack_require__(1314));
	var _excluded = ["data", "filename", "delimiter", "headers"];
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	var CsvDownloadButton = function CsvDownloadButton(props) {
	  var data = props.data,
	    filename = props.filename,
	    delimiter = props.delimiter,
	    headers = props.headers,
	    others = _objectWithoutProperties(props, _excluded);
	  return /*#__PURE__*/_react["default"].createElement("button", _extends({
	    onClick: function onClick() {
	      return (0, _jsonToCsvExport["default"])({
	        data: data,
	        filename: filename,
	        delimiter: delimiter,
	        headers: headers
	      });
	    }
	  }, others), props.children || 'Download Data');
	};
	var _default = CsvDownloadButton;
	exports["default"] = _default;

/***/ },
/* 1440 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var Notification = /*#__PURE__*/function (_React$Component) {
	  _inherits(Notification, _React$Component);
	
	  var _super = _createSuper(Notification);
	
	  function Notification() {
	    var _this;
	
	    _classCallCheck(this, Notification);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _super.call.apply(_super, [this].concat(args));
	
	    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
	      var timeOut = _this.props.timeOut;
	
	      if (timeOut !== 0) {
	        _this.timer = setTimeout(_this.requestHide, timeOut);
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
	      if (_this.timer) {
	        clearTimeout(_this.timer);
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "handleClick", function () {
	      var onClick = _this.props.onClick;
	
	      if (onClick) {
	        onClick();
	      }
	
	      _this.requestHide();
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "requestHide", function () {
	      var onRequestHide = _this.props.onRequestHide;
	
	      if (onRequestHide) {
	        onRequestHide();
	      }
	    });
	
	    return _this;
	  }
	
	  _createClass(Notification, [{
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          type = _this$props.type,
	          message = _this$props.message;
	      var title = this.props.title;
	      var className = (0, _classnames.default)(['notification', "notification-".concat(type)]);
	      title = title ? /*#__PURE__*/_react.default.createElement("h4", {
	        className: "title"
	      }, title) : null;
	      return /*#__PURE__*/_react.default.createElement("div", {
	        className: className,
	        onClick: this.handleClick
	      }, /*#__PURE__*/_react.default.createElement("div", {
	        className: "notification-message",
	        role: "alert"
	      }, title, /*#__PURE__*/_react.default.createElement("div", {
	        className: "message"
	      }, message)));
	    }
	  }]);
	
	  return Notification;
	}(_react.default.Component);
	
	_defineProperty(Notification, "propTypes", {
	  type: _propTypes.default.oneOf(['info', 'success', 'warning', 'error']),
	  title: _propTypes.default.node,
	  message: _propTypes.default.node,
	  timeOut: _propTypes.default.number,
	  onClick: _propTypes.default.func,
	  onRequestHide: _propTypes.default.func
	});
	
	_defineProperty(Notification, "defaultProps", {
	  type: 'info',
	  title: null,
	  message: null,
	  timeOut: 5000,
	  onClick: function onClick() {},
	  onRequestHide: function onRequestHide() {}
	});
	
	var _default = Notification;
	exports.default = _default;

/***/ },
/* 1441 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _NotificationManager = _interopRequireDefault(__webpack_require__(629));
	
	var _Notifications = _interopRequireDefault(__webpack_require__(630));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var NotificationContainer = /*#__PURE__*/function (_React$Component) {
	  _inherits(NotificationContainer, _React$Component);
	
	  var _super = _createSuper(NotificationContainer);
	
	  function NotificationContainer() {
	    var _this;
	
	    _classCallCheck(this, NotificationContainer);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _super.call.apply(_super, [this].concat(args));
	
	    _defineProperty(_assertThisInitialized(_this), "state", {
	      notifications: []
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
	      _NotificationManager.default.addChangeListener(_this.handleStoreChange);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
	      _NotificationManager.default.removeChangeListener(_this.handleStoreChange);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "handleStoreChange", function (notifications) {
	      _this.setState({
	        notifications: notifications
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "handleRequestHide", function (notification) {
	      _NotificationManager.default.remove(notification);
	    });
	
	    return _this;
	  }
	
	  _createClass(NotificationContainer, [{
	    key: "render",
	    value: function render() {
	      var notifications = this.state.notifications;
	      var _this$props = this.props,
	          enterTimeout = _this$props.enterTimeout,
	          leaveTimeout = _this$props.leaveTimeout;
	      return /*#__PURE__*/_react.default.createElement(_Notifications.default, {
	        enterTimeout: enterTimeout,
	        leaveTimeout: leaveTimeout,
	        notifications: notifications,
	        onRequestHide: this.handleRequestHide
	      });
	    }
	  }]);
	
	  return NotificationContainer;
	}(_react.default.Component);
	
	_defineProperty(NotificationContainer, "propTypes", {
	  enterTimeout: _propTypes.default.number,
	  leaveTimeout: _propTypes.default.number
	});
	
	_defineProperty(NotificationContainer, "defaultProps", {
	  enterTimeout: 400,
	  leaveTimeout: 400
	});
	
	var _default = NotificationContainer;
	exports.default = _default;

/***/ },
/* 1442 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports,'__esModule',{value:true});var react=__webpack_require__(1),reactDom=__webpack_require__(43);function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	
	  _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;
	    return o;
	  };
	
	  return _setPrototypeOf(o, p);
	}
	
	function _objectWithoutPropertiesLoose(source, excluded) {
	  if (source == null) return {};
	  var target = {};
	  var sourceKeys = Object.keys(source);
	  var key, i;
	
	  for (i = 0; i < sourceKeys.length; i++) {
	    key = sourceKeys[i];
	    if (excluded.indexOf(key) >= 0) continue;
	    target[key] = source[key];
	  }
	
	  return target;
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return self;
	}/**
	 * Check whether some DOM node is our Component's node.
	 */
	function isNodeFound(current, componentNode, ignoreClass) {
	  if (current === componentNode) {
	    return true;
	  } // SVG <use/> elements do not technically reside in the rendered DOM, so
	  // they do not have classList directly, but they offer a link to their
	  // corresponding element, which can have classList. This extra check is for
	  // that case.
	  // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
	  // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17
	
	
	  if (current.correspondingElement) {
	    return current.correspondingElement.classList.contains(ignoreClass);
	  }
	
	  return current.classList.contains(ignoreClass);
	}
	/**
	 * Try to find our node in a hierarchy of nodes, returning the document
	 * node as highest node if our node is not found in the path up.
	 */
	
	function findHighest(current, componentNode, ignoreClass) {
	  if (current === componentNode) {
	    return true;
	  } // If source=local then this event came from 'somewhere'
	  // inside and should be ignored. We could handle this with
	  // a layered approach, too, but that requires going back to
	  // thinking in terms of Dom node nesting, running counter
	  // to React's 'you shouldn't care about the DOM' philosophy.
	  // Also cover shadowRoot node by checking current.host
	
	
	  while (current.parentNode || current.host) {
	    // Only check normal node without shadowRoot
	    if (current.parentNode && isNodeFound(current, componentNode, ignoreClass)) {
	      return true;
	    }
	
	    current = current.parentNode || current.host;
	  }
	
	  return current;
	}
	/**
	 * Check if the browser scrollbar was clicked
	 */
	
	function clickedScrollbar(evt) {
	  return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
	}// ideally will get replaced with external dep
	// when rafrex/detect-passive-events#4 and rafrex/detect-passive-events#5 get merged in
	var testPassiveEventSupport = function testPassiveEventSupport() {
	  if (typeof window === 'undefined' || typeof window.addEventListener !== 'function') {
	    return;
	  }
	
	  var passive = false;
	  var options = Object.defineProperty({}, 'passive', {
	    get: function get() {
	      passive = true;
	    }
	  });
	
	  var noop = function noop() {};
	
	  window.addEventListener('testPassiveEventSupport', noop, options);
	  window.removeEventListener('testPassiveEventSupport', noop, options);
	  return passive;
	};function autoInc(seed) {
	  if (seed === void 0) {
	    seed = 0;
	  }
	
	  return function () {
	    return ++seed;
	  };
	}
	
	var uid = autoInc();var passiveEventSupport;
	var handlersMap = {};
	var enabledInstances = {};
	var touchEvents = ['touchstart', 'touchmove'];
	var IGNORE_CLASS_NAME = 'ignore-react-onclickoutside';
	/**
	 * Options for addEventHandler and removeEventHandler
	 */
	
	function getEventHandlerOptions(instance, eventName) {
	  var handlerOptions = {};
	  var isTouchEvent = touchEvents.indexOf(eventName) !== -1;
	
	  if (isTouchEvent && passiveEventSupport) {
	    handlerOptions.passive = !instance.props.preventDefault;
	  }
	
	  return handlerOptions;
	}
	/**
	 * This function generates the HOC function that you'll use
	 * in order to impart onOutsideClick listening to an
	 * arbitrary component. It gets called at the end of the
	 * bootstrapping code to yield an instance of the
	 * onClickOutsideHOC function defined inside setupHOC().
	 */
	
	
	function onClickOutsideHOC(WrappedComponent, config) {
	  var _class, _temp;
	
	  var componentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  return _temp = _class = /*#__PURE__*/function (_Component) {
	    _inheritsLoose(onClickOutside, _Component);
	
	    function onClickOutside(props) {
	      var _this;
	
	      _this = _Component.call(this, props) || this;
	
	      _this.__outsideClickHandler = function (event) {
	        if (typeof _this.__clickOutsideHandlerProp === 'function') {
	          _this.__clickOutsideHandlerProp(event);
	
	          return;
	        }
	
	        var instance = _this.getInstance();
	
	        if (typeof instance.props.handleClickOutside === 'function') {
	          instance.props.handleClickOutside(event);
	          return;
	        }
	
	        if (typeof instance.handleClickOutside === 'function') {
	          instance.handleClickOutside(event);
	          return;
	        }
	
	        throw new Error("WrappedComponent: " + componentName + " lacks a handleClickOutside(event) function for processing outside click events.");
	      };
	
	      _this.__getComponentNode = function () {
	        var instance = _this.getInstance();
	
	        if (config && typeof config.setClickOutsideRef === 'function') {
	          return config.setClickOutsideRef()(instance);
	        }
	
	        if (typeof instance.setClickOutsideRef === 'function') {
	          return instance.setClickOutsideRef();
	        }
	
	        return reactDom.findDOMNode(instance);
	      };
	
	      _this.enableOnClickOutside = function () {
	        if (typeof document === 'undefined' || enabledInstances[_this._uid]) {
	          return;
	        }
	
	        if (typeof passiveEventSupport === 'undefined') {
	          passiveEventSupport = testPassiveEventSupport();
	        }
	
	        enabledInstances[_this._uid] = true;
	        var events = _this.props.eventTypes;
	
	        if (!events.forEach) {
	          events = [events];
	        }
	
	        handlersMap[_this._uid] = function (event) {
	          if (_this.componentNode === null) return;
	          if (_this.initTimeStamp > event.timeStamp) return;
	
	          if (_this.props.preventDefault) {
	            event.preventDefault();
	          }
	
	          if (_this.props.stopPropagation) {
	            event.stopPropagation();
	          }
	
	          if (_this.props.excludeScrollbar && clickedScrollbar(event)) return;
	          var current = event.composed && event.composedPath && event.composedPath().shift() || event.target;
	
	          if (findHighest(current, _this.componentNode, _this.props.outsideClickIgnoreClass) !== document) {
	            return;
	          }
	
	          _this.__outsideClickHandler(event);
	        };
	
	        events.forEach(function (eventName) {
	          document.addEventListener(eventName, handlersMap[_this._uid], getEventHandlerOptions(_assertThisInitialized(_this), eventName));
	        });
	      };
	
	      _this.disableOnClickOutside = function () {
	        delete enabledInstances[_this._uid];
	        var fn = handlersMap[_this._uid];
	
	        if (fn && typeof document !== 'undefined') {
	          var events = _this.props.eventTypes;
	
	          if (!events.forEach) {
	            events = [events];
	          }
	
	          events.forEach(function (eventName) {
	            return document.removeEventListener(eventName, fn, getEventHandlerOptions(_assertThisInitialized(_this), eventName));
	          });
	          delete handlersMap[_this._uid];
	        }
	      };
	
	      _this.getRef = function (ref) {
	        return _this.instanceRef = ref;
	      };
	
	      _this._uid = uid();
	      _this.initTimeStamp = performance.now();
	      return _this;
	    }
	    /**
	     * Access the WrappedComponent's instance.
	     */
	
	
	    var _proto = onClickOutside.prototype;
	
	    _proto.getInstance = function getInstance() {
	      if (WrappedComponent.prototype && !WrappedComponent.prototype.isReactComponent) {
	        return this;
	      }
	
	      var ref = this.instanceRef;
	      return ref.getInstance ? ref.getInstance() : ref;
	    };
	
	    /**
	     * Add click listeners to the current document,
	     * linked to this component's state.
	     */
	    _proto.componentDidMount = function componentDidMount() {
	      // If we are in an environment without a DOM such
	      // as shallow rendering or snapshots then we exit
	      // early to prevent any unhandled errors being thrown.
	      if (typeof document === 'undefined' || !document.createElement) {
	        return;
	      }
	
	      var instance = this.getInstance();
	
	      if (config && typeof config.handleClickOutside === 'function') {
	        this.__clickOutsideHandlerProp = config.handleClickOutside(instance);
	
	        if (typeof this.__clickOutsideHandlerProp !== 'function') {
	          throw new Error("WrappedComponent: " + componentName + " lacks a function for processing outside click events specified by the handleClickOutside config option.");
	        }
	      }
	
	      this.componentNode = this.__getComponentNode(); // return early so we dont initiate onClickOutside
	
	      if (this.props.disableOnClickOutside) return;
	      this.enableOnClickOutside();
	    };
	
	    _proto.componentDidUpdate = function componentDidUpdate() {
	      this.componentNode = this.__getComponentNode();
	    }
	    /**
	     * Remove all document's event listeners for this component
	     */
	    ;
	
	    _proto.componentWillUnmount = function componentWillUnmount() {
	      this.disableOnClickOutside();
	    }
	    /**
	     * Can be called to explicitly enable event listening
	     * for clicks and touches outside of this element.
	     */
	    ;
	
	    /**
	     * Pass-through render
	     */
	    _proto.render = function render() {
	      // eslint-disable-next-line no-unused-vars
	      var _this$props = this.props;
	          _this$props.excludeScrollbar;
	          var props = _objectWithoutPropertiesLoose(_this$props, ["excludeScrollbar"]);
	
	      if (WrappedComponent.prototype && WrappedComponent.prototype.isReactComponent) {
	        props.ref = this.getRef;
	      } else {
	        props.wrappedRef = this.getRef;
	      }
	
	      props.disableOnClickOutside = this.disableOnClickOutside;
	      props.enableOnClickOutside = this.enableOnClickOutside;
	      return react.createElement(WrappedComponent, props);
	    };
	
	    return onClickOutside;
	  }(react.Component), _class.displayName = "OnClickOutside(" + componentName + ")", _class.defaultProps = {
	    eventTypes: ['mousedown', 'touchstart'],
	    excludeScrollbar: config && config.excludeScrollbar || false,
	    outsideClickIgnoreClass: IGNORE_CLASS_NAME,
	    preventDefault: false,
	    stopPropagation: false
	  }, _class.getClass = function () {
	    return WrappedComponent.getClass ? WrappedComponent.getClass() : WrappedComponent;
	  }, _temp;
	}exports.IGNORE_CLASS_NAME=IGNORE_CLASS_NAME;exports.default=onClickOutsideHOC;

/***/ },
/* 1443 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(452);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _helpers = __webpack_require__(1444);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * Copyright (c) 2016-present, Ken Hibino.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * Licensed under the MIT License (MIT).
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * See https://kenny-hibino.github.io/react-places-autocomplete
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */
	
	// transform snake_case to camelCase
	var formattedSuggestion = function formattedSuggestion(structured_formatting) {
	  return {
	    mainText: structured_formatting.main_text,
	    secondaryText: structured_formatting.secondary_text
	  };
	};
	
	var PlacesAutocomplete = function (_React$Component) {
	  _inherits(PlacesAutocomplete, _React$Component);
	
	  function PlacesAutocomplete(props) {
	    _classCallCheck(this, PlacesAutocomplete);
	
	    var _this = _possibleConstructorReturn(this, (PlacesAutocomplete.__proto__ || Object.getPrototypeOf(PlacesAutocomplete)).call(this, props));
	
	    _this.init = function () {
	      if (!window.google) {
	        throw new Error('[react-places-autocomplete]: Google Maps JavaScript API library must be loaded. See: https://github.com/kenny-hibino/react-places-autocomplete#load-google-library');
	      }
	
	      if (!window.google.maps.places) {
	        throw new Error('[react-places-autocomplete]: Google Maps Places library must be loaded. Please add `libraries=places` to the src URL. See: https://github.com/kenny-hibino/react-places-autocomplete#load-google-library');
	      }
	
	      _this.autocompleteService = new window.google.maps.places.AutocompleteService();
	      _this.autocompleteOK = window.google.maps.places.PlacesServiceStatus.OK;
	      _this.setState(function (state) {
	        if (state.ready) {
	          return null;
	        } else {
	          return { ready: true };
	        }
	      });
	    };
	
	    _this.autocompleteCallback = function (predictions, status) {
	      _this.setState({ loading: false });
	      if (status !== _this.autocompleteOK) {
	        _this.props.onError(status, _this.clearSuggestions);
	        return;
	      }
	      var highlightFirstSuggestion = _this.props.highlightFirstSuggestion;
	
	      _this.setState({
	        suggestions: predictions.map(function (p, idx) {
	          return {
	            id: p.id,
	            description: p.description,
	            placeId: p.place_id,
	            active: highlightFirstSuggestion && idx === 0 ? true : false,
	            index: idx,
	            formattedSuggestion: formattedSuggestion(p.structured_formatting),
	            matchedSubstrings: p.matched_substrings,
	            terms: p.terms,
	            types: p.types
	          };
	        })
	      });
	    };
	
	    _this.fetchPredictions = function () {
	      var value = _this.props.value;
	
	      if (value.length) {
	        _this.setState({ loading: true });
	        _this.autocompleteService.getPlacePredictions(_extends({}, _this.props.searchOptions, {
	          input: value
	        }), _this.autocompleteCallback);
	      }
	    };
	
	    _this.clearSuggestions = function () {
	      _this.setState({ suggestions: [] });
	    };
	
	    _this.clearActive = function () {
	      _this.setState({
	        suggestions: _this.state.suggestions.map(function (suggestion) {
	          return _extends({}, suggestion, {
	            active: false
	          });
	        })
	      });
	    };
	
	    _this.handleSelect = function (address, placeId, suggestion) {
	      _this.clearSuggestions();
	      if (_this.props.onSelect) {
	        _this.props.onSelect(address, placeId, suggestion);
	      } else {
	        _this.props.onChange(address);
	      }
	    };
	
	    _this.getActiveSuggestion = function () {
	      return _this.state.suggestions.find(function (suggestion) {
	        return suggestion.active;
	      });
	    };
	
	    _this.selectActiveAtIndex = function (index) {
	      var activeName = _this.state.suggestions.find(function (suggestion) {
	        return suggestion.index === index;
	      }).description;
	      _this.setActiveAtIndex(index);
	      _this.props.onChange(activeName);
	    };
	
	    _this.selectUserInputValue = function () {
	      _this.clearActive();
	      _this.props.onChange(_this.state.userInputValue);
	    };
	
	    _this.handleEnterKey = function () {
	      var activeSuggestion = _this.getActiveSuggestion();
	      if (activeSuggestion === undefined) {
	        _this.handleSelect(_this.props.value, null, null);
	      } else {
	        _this.handleSelect(activeSuggestion.description, activeSuggestion.placeId, activeSuggestion);
	      }
	    };
	
	    _this.handleDownKey = function () {
	      if (_this.state.suggestions.length === 0) {
	        return;
	      }
	
	      var activeSuggestion = _this.getActiveSuggestion();
	      if (activeSuggestion === undefined) {
	        _this.selectActiveAtIndex(0);
	      } else if (activeSuggestion.index === _this.state.suggestions.length - 1) {
	        _this.selectUserInputValue();
	      } else {
	        _this.selectActiveAtIndex(activeSuggestion.index + 1);
	      }
	    };
	
	    _this.handleUpKey = function () {
	      if (_this.state.suggestions.length === 0) {
	        return;
	      }
	
	      var activeSuggestion = _this.getActiveSuggestion();
	      if (activeSuggestion === undefined) {
	        _this.selectActiveAtIndex(_this.state.suggestions.length - 1);
	      } else if (activeSuggestion.index === 0) {
	        _this.selectUserInputValue();
	      } else {
	        _this.selectActiveAtIndex(activeSuggestion.index - 1);
	      }
	    };
	
	    _this.handleInputKeyDown = function (event) {
	      /* eslint-disable indent */
	      switch (event.key) {
	        case 'Enter':
	          event.preventDefault();
	          _this.handleEnterKey();
	          break;
	        case 'ArrowDown':
	          event.preventDefault(); // prevent the cursor from moving
	          _this.handleDownKey();
	          break;
	        case 'ArrowUp':
	          event.preventDefault(); // prevent the cursor from moving
	          _this.handleUpKey();
	          break;
	        case 'Escape':
	          _this.clearSuggestions();
	          break;
	      }
	      /* eslint-enable indent */
	    };
	
	    _this.setActiveAtIndex = function (index) {
	      _this.setState({
	        suggestions: _this.state.suggestions.map(function (suggestion, idx) {
	          if (idx === index) {
	            return _extends({}, suggestion, { active: true });
	          } else {
	            return _extends({}, suggestion, { active: false });
	          }
	        })
	      });
	    };
	
	    _this.handleInputChange = function (event) {
	      var value = event.target.value;
	
	      _this.props.onChange(value);
	      _this.setState({ userInputValue: value });
	      if (!value) {
	        _this.clearSuggestions();
	        return;
	      }
	      if (_this.props.shouldFetchSuggestions) {
	        _this.debouncedFetchPredictions();
	      }
	    };
	
	    _this.handleInputOnBlur = function () {
	      if (!_this.mousedownOnSuggestion) {
	        _this.clearSuggestions();
	      }
	    };
	
	    _this.getActiveSuggestionId = function () {
	      var activeSuggestion = _this.getActiveSuggestion();
	      return activeSuggestion ? 'PlacesAutocomplete__suggestion-' + activeSuggestion.placeId : undefined;
	    };
	
	    _this.getIsExpanded = function () {
	      return _this.state.suggestions.length > 0;
	    };
	
	    _this.getInputProps = function () {
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      if (options.hasOwnProperty('value')) {
	        throw new Error('[react-places-autocomplete]: getInputProps does not accept `value`. Use `value` prop instead');
	      }
	
	      if (options.hasOwnProperty('onChange')) {
	        throw new Error('[react-places-autocomplete]: getInputProps does not accept `onChange`. Use `onChange` prop instead');
	      }
	
	      var defaultInputProps = {
	        type: 'text',
	        autoComplete: 'off',
	        role: 'combobox',
	        'aria-autocomplete': 'list',
	        'aria-expanded': _this.getIsExpanded(),
	        'aria-activedescendant': _this.getActiveSuggestionId(),
	        disabled: !_this.state.ready
	      };
	
	      return _extends({}, defaultInputProps, options, {
	        onKeyDown: (0, _helpers.compose)(_this.handleInputKeyDown, options.onKeyDown),
	        onBlur: (0, _helpers.compose)(_this.handleInputOnBlur, options.onBlur),
	        value: _this.props.value,
	        onChange: function onChange(event) {
	          _this.handleInputChange(event);
	        }
	      });
	    };
	
	    _this.getSuggestionItemProps = function (suggestion) {
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      var handleSuggestionMouseEnter = _this.handleSuggestionMouseEnter.bind(_this, suggestion.index);
	      var handleSuggestionClick = _this.handleSuggestionClick.bind(_this, suggestion);
	
	      return _extends({}, options, {
	        key: suggestion.id,
	        id: _this.getActiveSuggestionId(),
	        role: 'option',
	        onMouseEnter: (0, _helpers.compose)(handleSuggestionMouseEnter, options.onMouseEnter),
	        onMouseLeave: (0, _helpers.compose)(_this.handleSuggestionMouseLeave, options.onMouseLeave),
	        onMouseDown: (0, _helpers.compose)(_this.handleSuggestionMouseDown, options.onMouseDown),
	        onMouseUp: (0, _helpers.compose)(_this.handleSuggestionMouseUp, options.onMouseUp),
	        onTouchStart: (0, _helpers.compose)(_this.handleSuggestionTouchStart, options.onTouchStart),
	        onTouchEnd: (0, _helpers.compose)(_this.handleSuggestionMouseUp, options.onTouchEnd),
	        onClick: (0, _helpers.compose)(handleSuggestionClick, options.onClick)
	      });
	    };
	
	    _this.handleSuggestionMouseEnter = function (index) {
	      _this.setActiveAtIndex(index);
	    };
	
	    _this.handleSuggestionMouseLeave = function () {
	      _this.mousedownOnSuggestion = false;
	      _this.clearActive();
	    };
	
	    _this.handleSuggestionMouseDown = function (event) {
	      event.preventDefault();
	      _this.mousedownOnSuggestion = true;
	    };
	
	    _this.handleSuggestionTouchStart = function () {
	      _this.mousedownOnSuggestion = true;
	    };
	
	    _this.handleSuggestionMouseUp = function () {
	      _this.mousedownOnSuggestion = false;
	    };
	
	    _this.handleSuggestionClick = function (suggestion, event) {
	      if (event && event.preventDefault) {
	        event.preventDefault();
	      }
	      var description = suggestion.description,
	          placeId = suggestion.placeId;
	
	      _this.handleSelect(description, placeId, suggestion);
	      setTimeout(function () {
	        _this.mousedownOnSuggestion = false;
	      });
	    };
	
	    _this.state = {
	      loading: false,
	      suggestions: [],
	      userInputValue: props.value,
	      ready: !props.googleCallbackName
	    };
	
	    _this.debouncedFetchPredictions = (0, _lodash2.default)(_this.fetchPredictions, props.debounce);
	    return _this;
	  }
	
	  _createClass(PlacesAutocomplete, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var googleCallbackName = this.props.googleCallbackName;
	
	      if (googleCallbackName) {
	        var isPlacesLoaded = window.google && window.google.maps && window.google.maps.places;
	        if (!isPlacesLoaded) {
	          window[googleCallbackName] = this.init;
	        } else {
	          this.init();
	        }
	      } else {
	        this.init();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var googleCallbackName = this.props.googleCallbackName;
	
	      if (googleCallbackName && window[googleCallbackName]) {
	        delete window[googleCallbackName];
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.props.children({
	        getInputProps: this.getInputProps,
	        getSuggestionItemProps: this.getSuggestionItemProps,
	        loading: this.state.loading,
	        suggestions: this.state.suggestions
	      });
	    }
	  }]);
	
	  return PlacesAutocomplete;
	}(_react2.default.Component);
	
	PlacesAutocomplete.propTypes = {
	  onChange: _propTypes2.default.func.isRequired,
	  value: _propTypes2.default.string.isRequired,
	  children: _propTypes2.default.func.isRequired,
	  onError: _propTypes2.default.func,
	  onSelect: _propTypes2.default.func,
	  searchOptions: _propTypes2.default.shape({
	    bounds: _propTypes2.default.object,
	    componentRestrictions: _propTypes2.default.object,
	    location: _propTypes2.default.object,
	    offset: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	    radius: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	    types: _propTypes2.default.array
	  }),
	  debounce: _propTypes2.default.number,
	  highlightFirstSuggestion: _propTypes2.default.bool,
	  shouldFetchSuggestions: _propTypes2.default.bool,
	  googleCallbackName: _propTypes2.default.string
	};
	
	PlacesAutocomplete.defaultProps = {
	  /* eslint-disable no-unused-vars, no-console */
	  onError: function onError(status, _clearSuggestions) {
	    return console.error('[react-places-autocomplete]: error happened when fetching data from Google Maps API.\nPlease check the docs here (https://developers.google.com/maps/documentation/javascript/places#place_details_responses)\nStatus: ', status);
	  },
	  /* eslint-enable no-unused-vars, no-console */
	  searchOptions: {},
	  debounce: 200,
	  highlightFirstSuggestion: false,
	  shouldFetchSuggestions: true
	};
	
	exports.default = PlacesAutocomplete;

/***/ },
/* 1444 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var compose = exports.compose = function compose() {
	  for (var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++) {
	    fns[_key] = arguments[_key];
	  }
	
	  return function () {
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    fns.forEach(function (fn) {
	      return fn && fn.apply(undefined, args);
	    });
	  };
	};
	
	var pick = exports.pick = function pick(obj) {
	  for (var _len3 = arguments.length, props = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
	    props[_key3 - 1] = arguments[_key3];
	  }
	
	  return props.reduce(function (newObj, prop) {
	    if (obj && obj.hasOwnProperty(prop)) {
	      newObj[prop] = obj[prop];
	    }
	    return newObj;
	  }, {});
	};

/***/ },
/* 1445 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var geocodeByAddress = exports.geocodeByAddress = function geocodeByAddress(address) {
	  var geocoder = new window.google.maps.Geocoder();
	  var OK = window.google.maps.GeocoderStatus.OK;
	
	  return new Promise(function (resolve, reject) {
	    geocoder.geocode({ address: address }, function (results, status) {
	      if (status !== OK) {
	        reject(status);
	      }
	      resolve(results);
	    });
	  });
	};
	
	var getLatLng = exports.getLatLng = function getLatLng(result) {
	  return new Promise(function (resolve, reject) {
	    try {
	      var latLng = {
	        lat: result.geometry.location.lat(),
	        lng: result.geometry.location.lng()
	      };
	      resolve(latLng);
	    } catch (e) {
	      reject(e);
	    }
	  });
	};
	
	var geocodeByPlaceId = exports.geocodeByPlaceId = function geocodeByPlaceId(placeId) {
	  var geocoder = new window.google.maps.Geocoder();
	  var OK = window.google.maps.GeocoderStatus.OK;
	
	  return new Promise(function (resolve, reject) {
	    geocoder.geocode({ placeId: placeId }, function (results, status) {
	      if (status !== OK) {
	        reject(status);
	      }
	      resolve(results);
	    });
	  });
	};

/***/ },
/* 1446 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Popper;
	exports.placements = exports.InnerPopper = void 0;
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(13));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(34));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(12));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(24));
	
	var _deepEqual = _interopRequireDefault(__webpack_require__(1177));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _popper = _interopRequireDefault(__webpack_require__(1448));
	
	var _Manager = __webpack_require__(295);
	
	var _utils = __webpack_require__(631);
	
	var initialStyle = {
	  position: 'absolute',
	  top: 0,
	  left: 0,
	  opacity: 0,
	  pointerEvents: 'none'
	};
	var initialArrowStyle = {};
	
	var InnerPopper =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(InnerPopper, _React$Component);
	
	  function InnerPopper() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "state", {
	      data: undefined,
	      placement: undefined
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "popperInstance", void 0);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "popperNode", null);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "arrowNode", null);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "setPopperNode", function (popperNode) {
	      if (!popperNode || _this.popperNode === popperNode) return;
	      (0, _utils.setRef)(_this.props.innerRef, popperNode);
	      _this.popperNode = popperNode;
	
	      _this.updatePopperInstance();
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "setArrowNode", function (arrowNode) {
	      _this.arrowNode = arrowNode;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "updateStateModifier", {
	      enabled: true,
	      order: 900,
	      fn: function fn(data) {
	        var placement = data.placement;
	
	        _this.setState({
	          data: data,
	          placement: placement
	        });
	
	        return data;
	      }
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "getOptions", function () {
	      return {
	        placement: _this.props.placement,
	        eventsEnabled: _this.props.eventsEnabled,
	        positionFixed: _this.props.positionFixed,
	        modifiers: (0, _extends2.default)({}, _this.props.modifiers, {
	          arrow: (0, _extends2.default)({}, _this.props.modifiers && _this.props.modifiers.arrow, {
	            enabled: !!_this.arrowNode,
	            element: _this.arrowNode
	          }),
	          applyStyle: {
	            enabled: false
	          },
	          updateStateModifier: _this.updateStateModifier
	        })
	      };
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "getPopperStyle", function () {
	      return !_this.popperNode || !_this.state.data ? initialStyle : (0, _extends2.default)({
	        position: _this.state.data.offsets.popper.position
	      }, _this.state.data.styles);
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "getPopperPlacement", function () {
	      return !_this.state.data ? undefined : _this.state.placement;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "getArrowStyle", function () {
	      return !_this.arrowNode || !_this.state.data ? initialArrowStyle : _this.state.data.arrowStyles;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "getOutOfBoundariesState", function () {
	      return _this.state.data ? _this.state.data.hide : undefined;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "destroyPopperInstance", function () {
	      if (!_this.popperInstance) return;
	
	      _this.popperInstance.destroy();
	
	      _this.popperInstance = null;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "updatePopperInstance", function () {
	      _this.destroyPopperInstance();
	
	      var _assertThisInitialize = (0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)),
	          popperNode = _assertThisInitialize.popperNode;
	
	      var referenceElement = _this.props.referenceElement;
	      if (!referenceElement || !popperNode) return;
	      _this.popperInstance = new _popper.default(referenceElement, popperNode, _this.getOptions());
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "scheduleUpdate", function () {
	      if (_this.popperInstance) {
	        _this.popperInstance.scheduleUpdate();
	      }
	    });
	    return _this;
	  }
	
	  var _proto = InnerPopper.prototype;
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
	    // If the Popper.js options have changed, update the instance (destroy + create)
	    if (this.props.placement !== prevProps.placement || this.props.referenceElement !== prevProps.referenceElement || this.props.positionFixed !== prevProps.positionFixed || !(0, _deepEqual.default)(this.props.modifiers, prevProps.modifiers, {
	      strict: true
	    })) {
	      // develop only check that modifiers isn't being updated needlessly
	      if (false) {
	        if (this.props.modifiers !== prevProps.modifiers && this.props.modifiers != null && prevProps.modifiers != null && (0, _utils.shallowEqual)(this.props.modifiers, prevProps.modifiers)) {
	          console.warn("'modifiers' prop reference updated even though all values appear the same.\nConsider memoizing the 'modifiers' object to avoid needless rendering.");
	        }
	      }
	
	      this.updatePopperInstance();
	    } else if (this.props.eventsEnabled !== prevProps.eventsEnabled && this.popperInstance) {
	      this.props.eventsEnabled ? this.popperInstance.enableEventListeners() : this.popperInstance.disableEventListeners();
	    } // A placement difference in state means popper determined a new placement
	    // apart from the props value. By the time the popper element is rendered with
	    // the new position Popper has already measured it, if the place change triggers
	    // a size change it will result in a misaligned popper. So we schedule an update to be sure.
	
	
	    if (prevState.placement !== this.state.placement) {
	      this.scheduleUpdate();
	    }
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    (0, _utils.setRef)(this.props.innerRef, null);
	    this.destroyPopperInstance();
	  };
	
	  _proto.render = function render() {
	    return (0, _utils.unwrapArray)(this.props.children)({
	      ref: this.setPopperNode,
	      style: this.getPopperStyle(),
	      placement: this.getPopperPlacement(),
	      outOfBoundaries: this.getOutOfBoundariesState(),
	      scheduleUpdate: this.scheduleUpdate,
	      arrowProps: {
	        ref: this.setArrowNode,
	        style: this.getArrowStyle()
	      }
	    });
	  };
	
	  return InnerPopper;
	}(React.Component);
	
	exports.InnerPopper = InnerPopper;
	(0, _defineProperty2.default)(InnerPopper, "defaultProps", {
	  placement: 'bottom',
	  eventsEnabled: true,
	  referenceElement: undefined,
	  positionFixed: false
	});
	var placements = _popper.default.placements;
	exports.placements = placements;
	
	function Popper(_ref) {
	  var referenceElement = _ref.referenceElement,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["referenceElement"]);
	  return React.createElement(_Manager.ManagerReferenceNodeContext.Consumer, null, function (referenceNode) {
	    return React.createElement(InnerPopper, (0, _extends2.default)({
	      referenceElement: referenceElement !== undefined ? referenceElement : referenceNode
	    }, props));
	  });
	}

/***/ },
/* 1447 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Reference;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(34));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(12));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(24));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _warning = _interopRequireDefault(__webpack_require__(691));
	
	var _Manager = __webpack_require__(295);
	
	var _utils = __webpack_require__(631);
	
	var InnerReference =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(InnerReference, _React$Component);
	
	  function InnerReference() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "refHandler", function (node) {
	      (0, _utils.setRef)(_this.props.innerRef, node);
	      (0, _utils.safeInvoke)(_this.props.setReferenceNode, node);
	    });
	    return _this;
	  }
	
	  var _proto = InnerReference.prototype;
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    (0, _utils.setRef)(this.props.innerRef, null);
	  };
	
	  _proto.render = function render() {
	    (0, _warning.default)(Boolean(this.props.setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
	    return (0, _utils.unwrapArray)(this.props.children)({
	      ref: this.refHandler
	    });
	  };
	
	  return InnerReference;
	}(React.Component);
	
	function Reference(props) {
	  return React.createElement(_Manager.ManagerReferenceNodeSetterContext.Consumer, null, function (setReferenceNode) {
	    return React.createElement(InnerReference, (0, _extends2.default)({
	      setReferenceNode: setReferenceNode
	    }, props));
	  });
	}

/***/ },
/* 1448 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**!
	 * @fileOverview Kickass library to create and place poppers near their reference elements.
	 * @version 1.16.1
	 * @license
	 * Copyright (c) 2016 Federico Zivolo and contributors
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy
	 * of this software and associated documentation files (the "Software"), to deal
	 * in the Software without restriction, including without limitation the rights
	 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	 * copies of the Software, and to permit persons to whom the Software is
	 * furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all
	 * copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	 * SOFTWARE.
	 */
	(function (global, factory) {
		 true ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(global.Popper = factory());
	}(this, (function () { 'use strict';
	
	var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';
	
	var timeoutDuration = function () {
	  var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
	  for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
	    if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
	      return 1;
	    }
	  }
	  return 0;
	}();
	
	function microtaskDebounce(fn) {
	  var called = false;
	  return function () {
	    if (called) {
	      return;
	    }
	    called = true;
	    window.Promise.resolve().then(function () {
	      called = false;
	      fn();
	    });
	  };
	}
	
	function taskDebounce(fn) {
	  var scheduled = false;
	  return function () {
	    if (!scheduled) {
	      scheduled = true;
	      setTimeout(function () {
	        scheduled = false;
	        fn();
	      }, timeoutDuration);
	    }
	  };
	}
	
	var supportsMicroTasks = isBrowser && window.Promise;
	
	/**
	* Create a debounced version of a method, that's asynchronously deferred
	* but called in the minimum time possible.
	*
	* @method
	* @memberof Popper.Utils
	* @argument {Function} fn
	* @returns {Function}
	*/
	var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;
	
	/**
	 * Check if the given variable is a function
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Any} functionToCheck - variable to check
	 * @returns {Boolean} answer to: is a function?
	 */
	function isFunction(functionToCheck) {
	  var getType = {};
	  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
	}
	
	/**
	 * Get CSS computed property of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Eement} element
	 * @argument {String} property
	 */
	function getStyleComputedProperty(element, property) {
	  if (element.nodeType !== 1) {
	    return [];
	  }
	  // NOTE: 1 DOM access here
	  var window = element.ownerDocument.defaultView;
	  var css = window.getComputedStyle(element, null);
	  return property ? css[property] : css;
	}
	
	/**
	 * Returns the parentNode or the host of the element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} parent
	 */
	function getParentNode(element) {
	  if (element.nodeName === 'HTML') {
	    return element;
	  }
	  return element.parentNode || element.host;
	}
	
	/**
	 * Returns the scrolling parent of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} scroll parent
	 */
	function getScrollParent(element) {
	  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
	  if (!element) {
	    return document.body;
	  }
	
	  switch (element.nodeName) {
	    case 'HTML':
	    case 'BODY':
	      return element.ownerDocument.body;
	    case '#document':
	      return element.body;
	  }
	
	  // Firefox want us to check `-x` and `-y` variations as well
	
	  var _getStyleComputedProp = getStyleComputedProperty(element),
	      overflow = _getStyleComputedProp.overflow,
	      overflowX = _getStyleComputedProp.overflowX,
	      overflowY = _getStyleComputedProp.overflowY;
	
	  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
	    return element;
	  }
	
	  return getScrollParent(getParentNode(element));
	}
	
	/**
	 * Returns the reference node of the reference object, or the reference object itself.
	 * @method
	 * @memberof Popper.Utils
	 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
	 * @returns {Element} parent
	 */
	function getReferenceNode(reference) {
	  return reference && reference.referenceNode ? reference.referenceNode : reference;
	}
	
	var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
	var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);
	
	/**
	 * Determines if the browser is Internet Explorer
	 * @method
	 * @memberof Popper.Utils
	 * @param {Number} version to check
	 * @returns {Boolean} isIE
	 */
	function isIE(version) {
	  if (version === 11) {
	    return isIE11;
	  }
	  if (version === 10) {
	    return isIE10;
	  }
	  return isIE11 || isIE10;
	}
	
	/**
	 * Returns the offset parent of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} offset parent
	 */
	function getOffsetParent(element) {
	  if (!element) {
	    return document.documentElement;
	  }
	
	  var noOffsetParent = isIE(10) ? document.body : null;
	
	  // NOTE: 1 DOM access here
	  var offsetParent = element.offsetParent || null;
	  // Skip hidden elements which don't have an offsetParent
	  while (offsetParent === noOffsetParent && element.nextElementSibling) {
	    offsetParent = (element = element.nextElementSibling).offsetParent;
	  }
	
	  var nodeName = offsetParent && offsetParent.nodeName;
	
	  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
	    return element ? element.ownerDocument.documentElement : document.documentElement;
	  }
	
	  // .offsetParent will return the closest TH, TD or TABLE in case
	  // no offsetParent is present, I hate this job...
	  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
	    return getOffsetParent(offsetParent);
	  }
	
	  return offsetParent;
	}
	
	function isOffsetContainer(element) {
	  var nodeName = element.nodeName;
	
	  if (nodeName === 'BODY') {
	    return false;
	  }
	  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
	}
	
	/**
	 * Finds the root node (document, shadowDOM root) of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} node
	 * @returns {Element} root node
	 */
	function getRoot(node) {
	  if (node.parentNode !== null) {
	    return getRoot(node.parentNode);
	  }
	
	  return node;
	}
	
	/**
	 * Finds the offset parent common to the two provided nodes
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element1
	 * @argument {Element} element2
	 * @returns {Element} common offset parent
	 */
	function findCommonOffsetParent(element1, element2) {
	  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
	  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
	    return document.documentElement;
	  }
	
	  // Here we make sure to give as "start" the element that comes first in the DOM
	  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
	  var start = order ? element1 : element2;
	  var end = order ? element2 : element1;
	
	  // Get common ancestor container
	  var range = document.createRange();
	  range.setStart(start, 0);
	  range.setEnd(end, 0);
	  var commonAncestorContainer = range.commonAncestorContainer;
	
	  // Both nodes are inside #document
	
	  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
	    if (isOffsetContainer(commonAncestorContainer)) {
	      return commonAncestorContainer;
	    }
	
	    return getOffsetParent(commonAncestorContainer);
	  }
	
	  // one of the nodes is inside shadowDOM, find which one
	  var element1root = getRoot(element1);
	  if (element1root.host) {
	    return findCommonOffsetParent(element1root.host, element2);
	  } else {
	    return findCommonOffsetParent(element1, getRoot(element2).host);
	  }
	}
	
	/**
	 * Gets the scroll value of the given element in the given side (top and left)
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @argument {String} side `top` or `left`
	 * @returns {number} amount of scrolled pixels
	 */
	function getScroll(element) {
	  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';
	
	  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
	  var nodeName = element.nodeName;
	
	  if (nodeName === 'BODY' || nodeName === 'HTML') {
	    var html = element.ownerDocument.documentElement;
	    var scrollingElement = element.ownerDocument.scrollingElement || html;
	    return scrollingElement[upperSide];
	  }
	
	  return element[upperSide];
	}
	
	/*
	 * Sum or subtract the element scroll values (left and top) from a given rect object
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} rect - Rect object you want to change
	 * @param {HTMLElement} element - The element from the function reads the scroll values
	 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
	 * @return {Object} rect - The modifier rect object
	 */
	function includeScroll(rect, element) {
	  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  var scrollTop = getScroll(element, 'top');
	  var scrollLeft = getScroll(element, 'left');
	  var modifier = subtract ? -1 : 1;
	  rect.top += scrollTop * modifier;
	  rect.bottom += scrollTop * modifier;
	  rect.left += scrollLeft * modifier;
	  rect.right += scrollLeft * modifier;
	  return rect;
	}
	
	/*
	 * Helper to detect borders of a given element
	 * @method
	 * @memberof Popper.Utils
	 * @param {CSSStyleDeclaration} styles
	 * Result of `getStyleComputedProperty` on the given element
	 * @param {String} axis - `x` or `y`
	 * @return {number} borders - The borders size of the given axis
	 */
	
	function getBordersSize(styles, axis) {
	  var sideA = axis === 'x' ? 'Left' : 'Top';
	  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';
	
	  return parseFloat(styles['border' + sideA + 'Width']) + parseFloat(styles['border' + sideB + 'Width']);
	}
	
	function getSize(axis, body, html, computedStyle) {
	  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
	}
	
	function getWindowSizes(document) {
	  var body = document.body;
	  var html = document.documentElement;
	  var computedStyle = isIE(10) && getComputedStyle(html);
	
	  return {
	    height: getSize('Height', body, html, computedStyle),
	    width: getSize('Width', body, html, computedStyle)
	  };
	}
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	
	
	
	
	var defineProperty = function (obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	/**
	 * Given element offsets, generate an output similar to getBoundingClientRect
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Object} offsets
	 * @returns {Object} ClientRect like output
	 */
	function getClientRect(offsets) {
	  return _extends({}, offsets, {
	    right: offsets.left + offsets.width,
	    bottom: offsets.top + offsets.height
	  });
	}
	
	/**
	 * Get bounding client rect of given element
	 * @method
	 * @memberof Popper.Utils
	 * @param {HTMLElement} element
	 * @return {Object} client rect
	 */
	function getBoundingClientRect(element) {
	  var rect = {};
	
	  // IE10 10 FIX: Please, don't ask, the element isn't
	  // considered in DOM in some circumstances...
	  // This isn't reproducible in IE10 compatibility mode of IE11
	  try {
	    if (isIE(10)) {
	      rect = element.getBoundingClientRect();
	      var scrollTop = getScroll(element, 'top');
	      var scrollLeft = getScroll(element, 'left');
	      rect.top += scrollTop;
	      rect.left += scrollLeft;
	      rect.bottom += scrollTop;
	      rect.right += scrollLeft;
	    } else {
	      rect = element.getBoundingClientRect();
	    }
	  } catch (e) {}
	
	  var result = {
	    left: rect.left,
	    top: rect.top,
	    width: rect.right - rect.left,
	    height: rect.bottom - rect.top
	  };
	
	  // subtract scrollbar size from sizes
	  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
	  var width = sizes.width || element.clientWidth || result.width;
	  var height = sizes.height || element.clientHeight || result.height;
	
	  var horizScrollbar = element.offsetWidth - width;
	  var vertScrollbar = element.offsetHeight - height;
	
	  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
	  // we make this check conditional for performance reasons
	  if (horizScrollbar || vertScrollbar) {
	    var styles = getStyleComputedProperty(element);
	    horizScrollbar -= getBordersSize(styles, 'x');
	    vertScrollbar -= getBordersSize(styles, 'y');
	
	    result.width -= horizScrollbar;
	    result.height -= vertScrollbar;
	  }
	
	  return getClientRect(result);
	}
	
	function getOffsetRectRelativeToArbitraryNode(children, parent) {
	  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  var isIE10 = isIE(10);
	  var isHTML = parent.nodeName === 'HTML';
	  var childrenRect = getBoundingClientRect(children);
	  var parentRect = getBoundingClientRect(parent);
	  var scrollParent = getScrollParent(children);
	
	  var styles = getStyleComputedProperty(parent);
	  var borderTopWidth = parseFloat(styles.borderTopWidth);
	  var borderLeftWidth = parseFloat(styles.borderLeftWidth);
	
	  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
	  if (fixedPosition && isHTML) {
	    parentRect.top = Math.max(parentRect.top, 0);
	    parentRect.left = Math.max(parentRect.left, 0);
	  }
	  var offsets = getClientRect({
	    top: childrenRect.top - parentRect.top - borderTopWidth,
	    left: childrenRect.left - parentRect.left - borderLeftWidth,
	    width: childrenRect.width,
	    height: childrenRect.height
	  });
	  offsets.marginTop = 0;
	  offsets.marginLeft = 0;
	
	  // Subtract margins of documentElement in case it's being used as parent
	  // we do this only on HTML because it's the only element that behaves
	  // differently when margins are applied to it. The margins are included in
	  // the box of the documentElement, in the other cases not.
	  if (!isIE10 && isHTML) {
	    var marginTop = parseFloat(styles.marginTop);
	    var marginLeft = parseFloat(styles.marginLeft);
	
	    offsets.top -= borderTopWidth - marginTop;
	    offsets.bottom -= borderTopWidth - marginTop;
	    offsets.left -= borderLeftWidth - marginLeft;
	    offsets.right -= borderLeftWidth - marginLeft;
	
	    // Attach marginTop and marginLeft because in some circumstances we may need them
	    offsets.marginTop = marginTop;
	    offsets.marginLeft = marginLeft;
	  }
	
	  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
	    offsets = includeScroll(offsets, parent);
	  }
	
	  return offsets;
	}
	
	function getViewportOffsetRectRelativeToArtbitraryNode(element) {
	  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var html = element.ownerDocument.documentElement;
	  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
	  var width = Math.max(html.clientWidth, window.innerWidth || 0);
	  var height = Math.max(html.clientHeight, window.innerHeight || 0);
	
	  var scrollTop = !excludeScroll ? getScroll(html) : 0;
	  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;
	
	  var offset = {
	    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
	    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
	    width: width,
	    height: height
	  };
	
	  return getClientRect(offset);
	}
	
	/**
	 * Check if the given element is fixed or is inside a fixed parent
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @argument {Element} customContainer
	 * @returns {Boolean} answer to "isFixed?"
	 */
	function isFixed(element) {
	  var nodeName = element.nodeName;
	  if (nodeName === 'BODY' || nodeName === 'HTML') {
	    return false;
	  }
	  if (getStyleComputedProperty(element, 'position') === 'fixed') {
	    return true;
	  }
	  var parentNode = getParentNode(element);
	  if (!parentNode) {
	    return false;
	  }
	  return isFixed(parentNode);
	}
	
	/**
	 * Finds the first parent of an element that has a transformed property defined
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} first transformed parent or documentElement
	 */
	
	function getFixedPositionOffsetParent(element) {
	  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
	  if (!element || !element.parentElement || isIE()) {
	    return document.documentElement;
	  }
	  var el = element.parentElement;
	  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
	    el = el.parentElement;
	  }
	  return el || document.documentElement;
	}
	
	/**
	 * Computed the boundaries limits and return them
	 * @method
	 * @memberof Popper.Utils
	 * @param {HTMLElement} popper
	 * @param {HTMLElement} reference
	 * @param {number} padding
	 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
	 * @param {Boolean} fixedPosition - Is in fixed position mode
	 * @returns {Object} Coordinates of the boundaries
	 */
	function getBoundaries(popper, reference, padding, boundariesElement) {
	  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
	
	  // NOTE: 1 DOM access here
	
	  var boundaries = { top: 0, left: 0 };
	  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
	
	  // Handle viewport case
	  if (boundariesElement === 'viewport') {
	    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
	  } else {
	    // Handle other cases based on DOM element used as boundaries
	    var boundariesNode = void 0;
	    if (boundariesElement === 'scrollParent') {
	      boundariesNode = getScrollParent(getParentNode(reference));
	      if (boundariesNode.nodeName === 'BODY') {
	        boundariesNode = popper.ownerDocument.documentElement;
	      }
	    } else if (boundariesElement === 'window') {
	      boundariesNode = popper.ownerDocument.documentElement;
	    } else {
	      boundariesNode = boundariesElement;
	    }
	
	    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);
	
	    // In case of HTML, we need a different computation
	    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
	      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
	          height = _getWindowSizes.height,
	          width = _getWindowSizes.width;
	
	      boundaries.top += offsets.top - offsets.marginTop;
	      boundaries.bottom = height + offsets.top;
	      boundaries.left += offsets.left - offsets.marginLeft;
	      boundaries.right = width + offsets.left;
	    } else {
	      // for all the other DOM elements, this one is good
	      boundaries = offsets;
	    }
	  }
	
	  // Add paddings
	  padding = padding || 0;
	  var isPaddingNumber = typeof padding === 'number';
	  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
	  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
	  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
	  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;
	
	  return boundaries;
	}
	
	function getArea(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return width * height;
	}
	
	/**
	 * Utility used to transform the `auto` placement to the placement with more
	 * available space.
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
	  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
	
	  if (placement.indexOf('auto') === -1) {
	    return placement;
	  }
	
	  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);
	
	  var rects = {
	    top: {
	      width: boundaries.width,
	      height: refRect.top - boundaries.top
	    },
	    right: {
	      width: boundaries.right - refRect.right,
	      height: boundaries.height
	    },
	    bottom: {
	      width: boundaries.width,
	      height: boundaries.bottom - refRect.bottom
	    },
	    left: {
	      width: refRect.left - boundaries.left,
	      height: boundaries.height
	    }
	  };
	
	  var sortedAreas = Object.keys(rects).map(function (key) {
	    return _extends({
	      key: key
	    }, rects[key], {
	      area: getArea(rects[key])
	    });
	  }).sort(function (a, b) {
	    return b.area - a.area;
	  });
	
	  var filteredAreas = sortedAreas.filter(function (_ref2) {
	    var width = _ref2.width,
	        height = _ref2.height;
	    return width >= popper.clientWidth && height >= popper.clientHeight;
	  });
	
	  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;
	
	  var variation = placement.split('-')[1];
	
	  return computedPlacement + (variation ? '-' + variation : '');
	}
	
	/**
	 * Get offsets to the reference element
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} state
	 * @param {Element} popper - the popper element
	 * @param {Element} reference - the reference element (the popper will be relative to this)
	 * @param {Element} fixedPosition - is in fixed position mode
	 * @returns {Object} An object containing the offsets which will be applied to the popper
	 */
	function getReferenceOffsets(state, popper, reference) {
	  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	
	  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
	  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
	}
	
	/**
	 * Get the outer sizes of the given element (offset size + margins)
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Object} object containing width and height properties
	 */
	function getOuterSizes(element) {
	  var window = element.ownerDocument.defaultView;
	  var styles = window.getComputedStyle(element);
	  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
	  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
	  var result = {
	    width: element.offsetWidth + y,
	    height: element.offsetHeight + x
	  };
	  return result;
	}
	
	/**
	 * Get the opposite placement of the given one
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement
	 * @returns {String} flipped placement
	 */
	function getOppositePlacement(placement) {
	  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
	  return placement.replace(/left|right|bottom|top/g, function (matched) {
	    return hash[matched];
	  });
	}
	
	/**
	 * Get offsets to the popper
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} position - CSS position the Popper will get applied
	 * @param {HTMLElement} popper - the popper element
	 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
	 * @param {String} placement - one of the valid placement options
	 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
	 */
	function getPopperOffsets(popper, referenceOffsets, placement) {
	  placement = placement.split('-')[0];
	
	  // Get popper node sizes
	  var popperRect = getOuterSizes(popper);
	
	  // Add position, width and height to our offsets object
	  var popperOffsets = {
	    width: popperRect.width,
	    height: popperRect.height
	  };
	
	  // depending by the popper placement we have to compute its offsets slightly differently
	  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
	  var mainSide = isHoriz ? 'top' : 'left';
	  var secondarySide = isHoriz ? 'left' : 'top';
	  var measurement = isHoriz ? 'height' : 'width';
	  var secondaryMeasurement = !isHoriz ? 'height' : 'width';
	
	  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
	  if (placement === secondarySide) {
	    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
	  } else {
	    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
	  }
	
	  return popperOffsets;
	}
	
	/**
	 * Mimics the `find` method of Array
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Array} arr
	 * @argument prop
	 * @argument value
	 * @returns index or -1
	 */
	function find(arr, check) {
	  // use native find if supported
	  if (Array.prototype.find) {
	    return arr.find(check);
	  }
	
	  // use `filter` to obtain the same behavior of `find`
	  return arr.filter(check)[0];
	}
	
	/**
	 * Return the index of the matching object
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Array} arr
	 * @argument prop
	 * @argument value
	 * @returns index or -1
	 */
	function findIndex(arr, prop, value) {
	  // use native findIndex if supported
	  if (Array.prototype.findIndex) {
	    return arr.findIndex(function (cur) {
	      return cur[prop] === value;
	    });
	  }
	
	  // use `find` + `indexOf` if `findIndex` isn't supported
	  var match = find(arr, function (obj) {
	    return obj[prop] === value;
	  });
	  return arr.indexOf(match);
	}
	
	/**
	 * Loop trough the list of modifiers and run them in order,
	 * each of them will then edit the data object.
	 * @method
	 * @memberof Popper.Utils
	 * @param {dataObject} data
	 * @param {Array} modifiers
	 * @param {String} ends - Optional modifier name used as stopper
	 * @returns {dataObject}
	 */
	function runModifiers(modifiers, data, ends) {
	  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));
	
	  modifiersToRun.forEach(function (modifier) {
	    if (modifier['function']) {
	      // eslint-disable-line dot-notation
	      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
	    }
	    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
	    if (modifier.enabled && isFunction(fn)) {
	      // Add properties to offsets to make them a complete clientRect object
	      // we do this before each modifier to make sure the previous one doesn't
	      // mess with these values
	      data.offsets.popper = getClientRect(data.offsets.popper);
	      data.offsets.reference = getClientRect(data.offsets.reference);
	
	      data = fn(data, modifier);
	    }
	  });
	
	  return data;
	}
	
	/**
	 * Updates the position of the popper, computing the new offsets and applying
	 * the new style.<br />
	 * Prefer `scheduleUpdate` over `update` because of performance reasons.
	 * @method
	 * @memberof Popper
	 */
	function update() {
	  // if popper is destroyed, don't perform any further update
	  if (this.state.isDestroyed) {
	    return;
	  }
	
	  var data = {
	    instance: this,
	    styles: {},
	    arrowStyles: {},
	    attributes: {},
	    flipped: false,
	    offsets: {}
	  };
	
	  // compute reference element offsets
	  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);
	
	  // compute auto placement, store placement inside the data object,
	  // modifiers will be able to edit `placement` if needed
	  // and refer to originalPlacement to know the original value
	  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);
	
	  // store the computed placement inside `originalPlacement`
	  data.originalPlacement = data.placement;
	
	  data.positionFixed = this.options.positionFixed;
	
	  // compute the popper offsets
	  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);
	
	  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';
	
	  // run the modifiers
	  data = runModifiers(this.modifiers, data);
	
	  // the first `update` will call `onCreate` callback
	  // the other ones will call `onUpdate` callback
	  if (!this.state.isCreated) {
	    this.state.isCreated = true;
	    this.options.onCreate(data);
	  } else {
	    this.options.onUpdate(data);
	  }
	}
	
	/**
	 * Helper used to know if the given modifier is enabled.
	 * @method
	 * @memberof Popper.Utils
	 * @returns {Boolean}
	 */
	function isModifierEnabled(modifiers, modifierName) {
	  return modifiers.some(function (_ref) {
	    var name = _ref.name,
	        enabled = _ref.enabled;
	    return enabled && name === modifierName;
	  });
	}
	
	/**
	 * Get the prefixed supported property name
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} property (camelCase)
	 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
	 */
	function getSupportedPropertyName(property) {
	  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
	  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);
	
	  for (var i = 0; i < prefixes.length; i++) {
	    var prefix = prefixes[i];
	    var toCheck = prefix ? '' + prefix + upperProp : property;
	    if (typeof document.body.style[toCheck] !== 'undefined') {
	      return toCheck;
	    }
	  }
	  return null;
	}
	
	/**
	 * Destroys the popper.
	 * @method
	 * @memberof Popper
	 */
	function destroy() {
	  this.state.isDestroyed = true;
	
	  // touch DOM only if `applyStyle` modifier is enabled
	  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
	    this.popper.removeAttribute('x-placement');
	    this.popper.style.position = '';
	    this.popper.style.top = '';
	    this.popper.style.left = '';
	    this.popper.style.right = '';
	    this.popper.style.bottom = '';
	    this.popper.style.willChange = '';
	    this.popper.style[getSupportedPropertyName('transform')] = '';
	  }
	
	  this.disableEventListeners();
	
	  // remove the popper if user explicitly asked for the deletion on destroy
	  // do not use `remove` because IE11 doesn't support it
	  if (this.options.removeOnDestroy) {
	    this.popper.parentNode.removeChild(this.popper);
	  }
	  return this;
	}
	
	/**
	 * Get the window associated with the element
	 * @argument {Element} element
	 * @returns {Window}
	 */
	function getWindow(element) {
	  var ownerDocument = element.ownerDocument;
	  return ownerDocument ? ownerDocument.defaultView : window;
	}
	
	function attachToScrollParents(scrollParent, event, callback, scrollParents) {
	  var isBody = scrollParent.nodeName === 'BODY';
	  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
	  target.addEventListener(event, callback, { passive: true });
	
	  if (!isBody) {
	    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
	  }
	  scrollParents.push(target);
	}
	
	/**
	 * Setup needed event listeners used to update the popper position
	 * @method
	 * @memberof Popper.Utils
	 * @private
	 */
	function setupEventListeners(reference, options, state, updateBound) {
	  // Resize event listener on window
	  state.updateBound = updateBound;
	  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });
	
	  // Scroll event listener on scroll parents
	  var scrollElement = getScrollParent(reference);
	  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
	  state.scrollElement = scrollElement;
	  state.eventsEnabled = true;
	
	  return state;
	}
	
	/**
	 * It will add resize/scroll events and start recalculating
	 * position of the popper element when they are triggered.
	 * @method
	 * @memberof Popper
	 */
	function enableEventListeners() {
	  if (!this.state.eventsEnabled) {
	    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
	  }
	}
	
	/**
	 * Remove event listeners used to update the popper position
	 * @method
	 * @memberof Popper.Utils
	 * @private
	 */
	function removeEventListeners(reference, state) {
	  // Remove resize event listener on window
	  getWindow(reference).removeEventListener('resize', state.updateBound);
	
	  // Remove scroll event listener on scroll parents
	  state.scrollParents.forEach(function (target) {
	    target.removeEventListener('scroll', state.updateBound);
	  });
	
	  // Reset state
	  state.updateBound = null;
	  state.scrollParents = [];
	  state.scrollElement = null;
	  state.eventsEnabled = false;
	  return state;
	}
	
	/**
	 * It will remove resize/scroll events and won't recalculate popper position
	 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
	 * unless you call `update` method manually.
	 * @method
	 * @memberof Popper
	 */
	function disableEventListeners() {
	  if (this.state.eventsEnabled) {
	    cancelAnimationFrame(this.scheduleUpdate);
	    this.state = removeEventListeners(this.reference, this.state);
	  }
	}
	
	/**
	 * Tells if a given input is a number
	 * @method
	 * @memberof Popper.Utils
	 * @param {*} input to check
	 * @return {Boolean}
	 */
	function isNumeric(n) {
	  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
	}
	
	/**
	 * Set the style to the given popper
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element - Element to apply the style to
	 * @argument {Object} styles
	 * Object with a list of properties and values which will be applied to the element
	 */
	function setStyles(element, styles) {
	  Object.keys(styles).forEach(function (prop) {
	    var unit = '';
	    // add unit if the value is numeric and is one of the following
	    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
	      unit = 'px';
	    }
	    element.style[prop] = styles[prop] + unit;
	  });
	}
	
	/**
	 * Set the attributes to the given popper
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element - Element to apply the attributes to
	 * @argument {Object} styles
	 * Object with a list of properties and values which will be applied to the element
	 */
	function setAttributes(element, attributes) {
	  Object.keys(attributes).forEach(function (prop) {
	    var value = attributes[prop];
	    if (value !== false) {
	      element.setAttribute(prop, attributes[prop]);
	    } else {
	      element.removeAttribute(prop);
	    }
	  });
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} data.styles - List of style properties - values to apply to popper element
	 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The same data object
	 */
	function applyStyle(data) {
	  // any property present in `data.styles` will be applied to the popper,
	  // in this way we can make the 3rd party modifiers add custom styles to it
	  // Be aware, modifiers could override the properties defined in the previous
	  // lines of this modifier!
	  setStyles(data.instance.popper, data.styles);
	
	  // any property present in `data.attributes` will be applied to the popper,
	  // they will be set as HTML attributes of the element
	  setAttributes(data.instance.popper, data.attributes);
	
	  // if arrowElement is defined and arrowStyles has some properties
	  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
	    setStyles(data.arrowElement, data.arrowStyles);
	  }
	
	  return data;
	}
	
	/**
	 * Set the x-placement attribute before everything else because it could be used
	 * to add margins to the popper margins needs to be calculated to get the
	 * correct popper offsets.
	 * @method
	 * @memberof Popper.modifiers
	 * @param {HTMLElement} reference - The reference element used to position the popper
	 * @param {HTMLElement} popper - The HTML element used as popper
	 * @param {Object} options - Popper.js options
	 */
	function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
	  // compute reference element offsets
	  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);
	
	  // compute auto placement, store placement inside the data object,
	  // modifiers will be able to edit `placement` if needed
	  // and refer to originalPlacement to know the original value
	  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);
	
	  popper.setAttribute('x-placement', placement);
	
	  // Apply `position` to popper before anything else because
	  // without the position applied we can't guarantee correct computations
	  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });
	
	  return options;
	}
	
	/**
	 * @function
	 * @memberof Popper.Utils
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
	 * @returns {Object} The popper's position offsets rounded
	 *
	 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
	 * good as it can be within reason.
	 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
	 *
	 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
	 * as well on High DPI screens).
	 *
	 * Firefox prefers no rounding for positioning and does not have blurriness on
	 * high DPI screens.
	 *
	 * Only horizontal placement and left/right values need to be considered.
	 */
	function getRoundedOffsets(data, shouldRound) {
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	  var round = Math.round,
	      floor = Math.floor;
	
	  var noRound = function noRound(v) {
	    return v;
	  };
	
	  var referenceWidth = round(reference.width);
	  var popperWidth = round(popper.width);
	
	  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
	  var isVariation = data.placement.indexOf('-') !== -1;
	  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
	  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;
	
	  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
	  var verticalToInteger = !shouldRound ? noRound : round;
	
	  return {
	    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
	    top: verticalToInteger(popper.top),
	    bottom: verticalToInteger(popper.bottom),
	    right: horizontalToInteger(popper.right)
	  };
	}
	
	var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function computeStyle(data, options) {
	  var x = options.x,
	      y = options.y;
	  var popper = data.offsets.popper;
	
	  // Remove this legacy support in Popper.js v2
	
	  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
	    return modifier.name === 'applyStyle';
	  }).gpuAcceleration;
	  if (legacyGpuAccelerationOption !== undefined) {
	    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
	  }
	  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;
	
	  var offsetParent = getOffsetParent(data.instance.popper);
	  var offsetParentRect = getBoundingClientRect(offsetParent);
	
	  // Styles
	  var styles = {
	    position: popper.position
	  };
	
	  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);
	
	  var sideA = x === 'bottom' ? 'top' : 'bottom';
	  var sideB = y === 'right' ? 'left' : 'right';
	
	  // if gpuAcceleration is set to `true` and transform is supported,
	  //  we use `translate3d` to apply the position to the popper we
	  // automatically use the supported prefixed version if needed
	  var prefixedProperty = getSupportedPropertyName('transform');
	
	  // now, let's make a step back and look at this code closely (wtf?)
	  // If the content of the popper grows once it's been positioned, it
	  // may happen that the popper gets misplaced because of the new content
	  // overflowing its reference element
	  // To avoid this problem, we provide two options (x and y), which allow
	  // the consumer to define the offset origin.
	  // If we position a popper on top of a reference element, we can set
	  // `x` to `top` to make the popper grow towards its top instead of
	  // its bottom.
	  var left = void 0,
	      top = void 0;
	  if (sideA === 'bottom') {
	    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
	    // and not the bottom of the html element
	    if (offsetParent.nodeName === 'HTML') {
	      top = -offsetParent.clientHeight + offsets.bottom;
	    } else {
	      top = -offsetParentRect.height + offsets.bottom;
	    }
	  } else {
	    top = offsets.top;
	  }
	  if (sideB === 'right') {
	    if (offsetParent.nodeName === 'HTML') {
	      left = -offsetParent.clientWidth + offsets.right;
	    } else {
	      left = -offsetParentRect.width + offsets.right;
	    }
	  } else {
	    left = offsets.left;
	  }
	  if (gpuAcceleration && prefixedProperty) {
	    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
	    styles[sideA] = 0;
	    styles[sideB] = 0;
	    styles.willChange = 'transform';
	  } else {
	    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
	    var invertTop = sideA === 'bottom' ? -1 : 1;
	    var invertLeft = sideB === 'right' ? -1 : 1;
	    styles[sideA] = top * invertTop;
	    styles[sideB] = left * invertLeft;
	    styles.willChange = sideA + ', ' + sideB;
	  }
	
	  // Attributes
	  var attributes = {
	    'x-placement': data.placement
	  };
	
	  // Update `data` attributes, styles and arrowStyles
	  data.attributes = _extends({}, attributes, data.attributes);
	  data.styles = _extends({}, styles, data.styles);
	  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);
	
	  return data;
	}
	
	/**
	 * Helper used to know if the given modifier depends from another one.<br />
	 * It checks if the needed modifier is listed and enabled.
	 * @method
	 * @memberof Popper.Utils
	 * @param {Array} modifiers - list of modifiers
	 * @param {String} requestingName - name of requesting modifier
	 * @param {String} requestedName - name of requested modifier
	 * @returns {Boolean}
	 */
	function isModifierRequired(modifiers, requestingName, requestedName) {
	  var requesting = find(modifiers, function (_ref) {
	    var name = _ref.name;
	    return name === requestingName;
	  });
	
	  var isRequired = !!requesting && modifiers.some(function (modifier) {
	    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
	  });
	
	  if (!isRequired) {
	    var _requesting = '`' + requestingName + '`';
	    var requested = '`' + requestedName + '`';
	    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
	  }
	  return isRequired;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function arrow(data, options) {
	  var _data$offsets$arrow;
	
	  // arrow depends on keepTogether in order to work
	  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
	    return data;
	  }
	
	  var arrowElement = options.element;
	
	  // if arrowElement is a string, suppose it's a CSS selector
	  if (typeof arrowElement === 'string') {
	    arrowElement = data.instance.popper.querySelector(arrowElement);
	
	    // if arrowElement is not found, don't run the modifier
	    if (!arrowElement) {
	      return data;
	    }
	  } else {
	    // if the arrowElement isn't a query selector we must check that the
	    // provided DOM node is child of its popper node
	    if (!data.instance.popper.contains(arrowElement)) {
	      console.warn('WARNING: `arrow.element` must be child of its popper element!');
	      return data;
	    }
	  }
	
	  var placement = data.placement.split('-')[0];
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var isVertical = ['left', 'right'].indexOf(placement) !== -1;
	
	  var len = isVertical ? 'height' : 'width';
	  var sideCapitalized = isVertical ? 'Top' : 'Left';
	  var side = sideCapitalized.toLowerCase();
	  var altSide = isVertical ? 'left' : 'top';
	  var opSide = isVertical ? 'bottom' : 'right';
	  var arrowElementSize = getOuterSizes(arrowElement)[len];
	
	  //
	  // extends keepTogether behavior making sure the popper and its
	  // reference have enough pixels in conjunction
	  //
	
	  // top/left side
	  if (reference[opSide] - arrowElementSize < popper[side]) {
	    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
	  }
	  // bottom/right side
	  if (reference[side] + arrowElementSize > popper[opSide]) {
	    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
	  }
	  data.offsets.popper = getClientRect(data.offsets.popper);
	
	  // compute center of the popper
	  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;
	
	  // Compute the sideValue using the updated popper offsets
	  // take popper margin in account because we don't have this info available
	  var css = getStyleComputedProperty(data.instance.popper);
	  var popperMarginSide = parseFloat(css['margin' + sideCapitalized]);
	  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width']);
	  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;
	
	  // prevent arrowElement from being placed not contiguously to its popper
	  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);
	
	  data.arrowElement = arrowElement;
	  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);
	
	  return data;
	}
	
	/**
	 * Get the opposite placement variation of the given one
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement variation
	 * @returns {String} flipped placement variation
	 */
	function getOppositeVariation(variation) {
	  if (variation === 'end') {
	    return 'start';
	  } else if (variation === 'start') {
	    return 'end';
	  }
	  return variation;
	}
	
	/**
	 * List of accepted placements to use as values of the `placement` option.<br />
	 * Valid placements are:
	 * - `auto`
	 * - `top`
	 * - `right`
	 * - `bottom`
	 * - `left`
	 *
	 * Each placement can have a variation from this list:
	 * - `-start`
	 * - `-end`
	 *
	 * Variations are interpreted easily if you think of them as the left to right
	 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
	 * is right.<br />
	 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
	 *
	 * Some valid examples are:
	 * - `top-end` (on top of reference, right aligned)
	 * - `right-start` (on right of reference, top aligned)
	 * - `bottom` (on bottom, centered)
	 * - `auto-end` (on the side with more space available, alignment depends by placement)
	 *
	 * @static
	 * @type {Array}
	 * @enum {String}
	 * @readonly
	 * @method placements
	 * @memberof Popper
	 */
	var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];
	
	// Get rid of `auto` `auto-start` and `auto-end`
	var validPlacements = placements.slice(3);
	
	/**
	 * Given an initial placement, returns all the subsequent placements
	 * clockwise (or counter-clockwise).
	 *
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement - A valid placement (it accepts variations)
	 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
	 * @returns {Array} placements including their variations
	 */
	function clockwise(placement) {
	  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var index = validPlacements.indexOf(placement);
	  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
	  return counter ? arr.reverse() : arr;
	}
	
	var BEHAVIORS = {
	  FLIP: 'flip',
	  CLOCKWISE: 'clockwise',
	  COUNTERCLOCKWISE: 'counterclockwise'
	};
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function flip(data, options) {
	  // if `inner` modifier is enabled, we can't use the `flip` modifier
	  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
	    return data;
	  }
	
	  if (data.flipped && data.placement === data.originalPlacement) {
	    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
	    return data;
	  }
	
	  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);
	
	  var placement = data.placement.split('-')[0];
	  var placementOpposite = getOppositePlacement(placement);
	  var variation = data.placement.split('-')[1] || '';
	
	  var flipOrder = [];
	
	  switch (options.behavior) {
	    case BEHAVIORS.FLIP:
	      flipOrder = [placement, placementOpposite];
	      break;
	    case BEHAVIORS.CLOCKWISE:
	      flipOrder = clockwise(placement);
	      break;
	    case BEHAVIORS.COUNTERCLOCKWISE:
	      flipOrder = clockwise(placement, true);
	      break;
	    default:
	      flipOrder = options.behavior;
	  }
	
	  flipOrder.forEach(function (step, index) {
	    if (placement !== step || flipOrder.length === index + 1) {
	      return data;
	    }
	
	    placement = data.placement.split('-')[0];
	    placementOpposite = getOppositePlacement(placement);
	
	    var popperOffsets = data.offsets.popper;
	    var refOffsets = data.offsets.reference;
	
	    // using floor because the reference offsets may contain decimals we are not going to consider here
	    var floor = Math.floor;
	    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);
	
	    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
	    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
	    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
	    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);
	
	    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;
	
	    // flip the variation if required
	    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
	
	    // flips variation if reference element overflows boundaries
	    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);
	
	    // flips variation if popper content overflows boundaries
	    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);
	
	    var flippedVariation = flippedVariationByRef || flippedVariationByContent;
	
	    if (overlapsRef || overflowsBoundaries || flippedVariation) {
	      // this boolean to detect any flip loop
	      data.flipped = true;
	
	      if (overlapsRef || overflowsBoundaries) {
	        placement = flipOrder[index + 1];
	      }
	
	      if (flippedVariation) {
	        variation = getOppositeVariation(variation);
	      }
	
	      data.placement = placement + (variation ? '-' + variation : '');
	
	      // this object contains `position`, we want to preserve it along with
	      // any additional property we may add in the future
	      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));
	
	      data = runModifiers(data.instance.modifiers, data, 'flip');
	    }
	  });
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function keepTogether(data) {
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var placement = data.placement.split('-')[0];
	  var floor = Math.floor;
	  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
	  var side = isVertical ? 'right' : 'bottom';
	  var opSide = isVertical ? 'left' : 'top';
	  var measurement = isVertical ? 'width' : 'height';
	
	  if (popper[side] < floor(reference[opSide])) {
	    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
	  }
	  if (popper[opSide] > floor(reference[side])) {
	    data.offsets.popper[opSide] = floor(reference[side]);
	  }
	
	  return data;
	}
	
	/**
	 * Converts a string containing value + unit into a px value number
	 * @function
	 * @memberof {modifiers~offset}
	 * @private
	 * @argument {String} str - Value + unit string
	 * @argument {String} measurement - `height` or `width`
	 * @argument {Object} popperOffsets
	 * @argument {Object} referenceOffsets
	 * @returns {Number|String}
	 * Value in pixels, or original string if no values were extracted
	 */
	function toValue(str, measurement, popperOffsets, referenceOffsets) {
	  // separate value from unit
	  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
	  var value = +split[1];
	  var unit = split[2];
	
	  // If it's not a number it's an operator, I guess
	  if (!value) {
	    return str;
	  }
	
	  if (unit.indexOf('%') === 0) {
	    var element = void 0;
	    switch (unit) {
	      case '%p':
	        element = popperOffsets;
	        break;
	      case '%':
	      case '%r':
	      default:
	        element = referenceOffsets;
	    }
	
	    var rect = getClientRect(element);
	    return rect[measurement] / 100 * value;
	  } else if (unit === 'vh' || unit === 'vw') {
	    // if is a vh or vw, we calculate the size based on the viewport
	    var size = void 0;
	    if (unit === 'vh') {
	      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
	    } else {
	      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
	    }
	    return size / 100 * value;
	  } else {
	    // if is an explicit pixel unit, we get rid of the unit and keep the value
	    // if is an implicit unit, it's px, and we return just the value
	    return value;
	  }
	}
	
	/**
	 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
	 * @function
	 * @memberof {modifiers~offset}
	 * @private
	 * @argument {String} offset
	 * @argument {Object} popperOffsets
	 * @argument {Object} referenceOffsets
	 * @argument {String} basePlacement
	 * @returns {Array} a two cells array with x and y offsets in numbers
	 */
	function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
	  var offsets = [0, 0];
	
	  // Use height if placement is left or right and index is 0 otherwise use width
	  // in this way the first offset will use an axis and the second one
	  // will use the other one
	  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;
	
	  // Split the offset string to obtain a list of values and operands
	  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
	  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
	    return frag.trim();
	  });
	
	  // Detect if the offset string contains a pair of values or a single one
	  // they could be separated by comma or space
	  var divider = fragments.indexOf(find(fragments, function (frag) {
	    return frag.search(/,|\s/) !== -1;
	  }));
	
	  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
	    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
	  }
	
	  // If divider is found, we divide the list of values and operands to divide
	  // them by ofset X and Y.
	  var splitRegex = /\s*,\s*|\s+/;
	  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];
	
	  // Convert the values with units to absolute pixels to allow our computations
	  ops = ops.map(function (op, index) {
	    // Most of the units rely on the orientation of the popper
	    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
	    var mergeWithPrevious = false;
	    return op
	    // This aggregates any `+` or `-` sign that aren't considered operators
	    // e.g.: 10 + +5 => [10, +, +5]
	    .reduce(function (a, b) {
	      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
	        a[a.length - 1] = b;
	        mergeWithPrevious = true;
	        return a;
	      } else if (mergeWithPrevious) {
	        a[a.length - 1] += b;
	        mergeWithPrevious = false;
	        return a;
	      } else {
	        return a.concat(b);
	      }
	    }, [])
	    // Here we convert the string values into number values (in px)
	    .map(function (str) {
	      return toValue(str, measurement, popperOffsets, referenceOffsets);
	    });
	  });
	
	  // Loop trough the offsets arrays and execute the operations
	  ops.forEach(function (op, index) {
	    op.forEach(function (frag, index2) {
	      if (isNumeric(frag)) {
	        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
	      }
	    });
	  });
	  return offsets;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @argument {Number|String} options.offset=0
	 * The offset value as described in the modifier description
	 * @returns {Object} The data object, properly modified
	 */
	function offset(data, _ref) {
	  var offset = _ref.offset;
	  var placement = data.placement,
	      _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var basePlacement = placement.split('-')[0];
	
	  var offsets = void 0;
	  if (isNumeric(+offset)) {
	    offsets = [+offset, 0];
	  } else {
	    offsets = parseOffset(offset, popper, reference, basePlacement);
	  }
	
	  if (basePlacement === 'left') {
	    popper.top += offsets[0];
	    popper.left -= offsets[1];
	  } else if (basePlacement === 'right') {
	    popper.top += offsets[0];
	    popper.left += offsets[1];
	  } else if (basePlacement === 'top') {
	    popper.left += offsets[0];
	    popper.top -= offsets[1];
	  } else if (basePlacement === 'bottom') {
	    popper.left += offsets[0];
	    popper.top += offsets[1];
	  }
	
	  data.popper = popper;
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function preventOverflow(data, options) {
	  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);
	
	  // If offsetParent is the reference element, we really want to
	  // go one step up and use the next offsetParent as reference to
	  // avoid to make this modifier completely useless and look like broken
	  if (data.instance.reference === boundariesElement) {
	    boundariesElement = getOffsetParent(boundariesElement);
	  }
	
	  // NOTE: DOM access here
	  // resets the popper's position so that the document size can be calculated excluding
	  // the size of the popper element itself
	  var transformProp = getSupportedPropertyName('transform');
	  var popperStyles = data.instance.popper.style; // assignment to help minification
	  var top = popperStyles.top,
	      left = popperStyles.left,
	      transform = popperStyles[transformProp];
	
	  popperStyles.top = '';
	  popperStyles.left = '';
	  popperStyles[transformProp] = '';
	
	  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);
	
	  // NOTE: DOM access here
	  // restores the original style properties after the offsets have been computed
	  popperStyles.top = top;
	  popperStyles.left = left;
	  popperStyles[transformProp] = transform;
	
	  options.boundaries = boundaries;
	
	  var order = options.priority;
	  var popper = data.offsets.popper;
	
	  var check = {
	    primary: function primary(placement) {
	      var value = popper[placement];
	      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
	        value = Math.max(popper[placement], boundaries[placement]);
	      }
	      return defineProperty({}, placement, value);
	    },
	    secondary: function secondary(placement) {
	      var mainSide = placement === 'right' ? 'left' : 'top';
	      var value = popper[mainSide];
	      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
	        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
	      }
	      return defineProperty({}, mainSide, value);
	    }
	  };
	
	  order.forEach(function (placement) {
	    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
	    popper = _extends({}, popper, check[side](placement));
	  });
	
	  data.offsets.popper = popper;
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function shift(data) {
	  var placement = data.placement;
	  var basePlacement = placement.split('-')[0];
	  var shiftvariation = placement.split('-')[1];
	
	  // if shift shiftvariation is specified, run the modifier
	  if (shiftvariation) {
	    var _data$offsets = data.offsets,
	        reference = _data$offsets.reference,
	        popper = _data$offsets.popper;
	
	    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
	    var side = isVertical ? 'left' : 'top';
	    var measurement = isVertical ? 'width' : 'height';
	
	    var shiftOffsets = {
	      start: defineProperty({}, side, reference[side]),
	      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
	    };
	
	    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
	  }
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function hide(data) {
	  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
	    return data;
	  }
	
	  var refRect = data.offsets.reference;
	  var bound = find(data.instance.modifiers, function (modifier) {
	    return modifier.name === 'preventOverflow';
	  }).boundaries;
	
	  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
	    // Avoid unnecessary DOM access if visibility hasn't changed
	    if (data.hide === true) {
	      return data;
	    }
	
	    data.hide = true;
	    data.attributes['x-out-of-boundaries'] = '';
	  } else {
	    // Avoid unnecessary DOM access if visibility hasn't changed
	    if (data.hide === false) {
	      return data;
	    }
	
	    data.hide = false;
	    data.attributes['x-out-of-boundaries'] = false;
	  }
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function inner(data) {
	  var placement = data.placement;
	  var basePlacement = placement.split('-')[0];
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;
	
	  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;
	
	  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);
	
	  data.placement = getOppositePlacement(placement);
	  data.offsets.popper = getClientRect(popper);
	
	  return data;
	}
	
	/**
	 * Modifier function, each modifier can have a function of this type assigned
	 * to its `fn` property.<br />
	 * These functions will be called on each update, this means that you must
	 * make sure they are performant enough to avoid performance bottlenecks.
	 *
	 * @function ModifierFn
	 * @argument {dataObject} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {dataObject} The data object, properly modified
	 */
	
	/**
	 * Modifiers are plugins used to alter the behavior of your poppers.<br />
	 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
	 * needed by the library.
	 *
	 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
	 * All the other properties are configurations that could be tweaked.
	 * @namespace modifiers
	 */
	var modifiers = {
	  /**
	   * Modifier used to shift the popper on the start or end of its reference
	   * element.<br />
	   * It will read the variation of the `placement` property.<br />
	   * It can be one either `-end` or `-start`.
	   * @memberof modifiers
	   * @inner
	   */
	  shift: {
	    /** @prop {number} order=100 - Index used to define the order of execution */
	    order: 100,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: shift
	  },
	
	  /**
	   * The `offset` modifier can shift your popper on both its axis.
	   *
	   * It accepts the following units:
	   * - `px` or unit-less, interpreted as pixels
	   * - `%` or `%r`, percentage relative to the length of the reference element
	   * - `%p`, percentage relative to the length of the popper element
	   * - `vw`, CSS viewport width unit
	   * - `vh`, CSS viewport height unit
	   *
	   * For length is intended the main axis relative to the placement of the popper.<br />
	   * This means that if the placement is `top` or `bottom`, the length will be the
	   * `width`. In case of `left` or `right`, it will be the `height`.
	   *
	   * You can provide a single value (as `Number` or `String`), or a pair of values
	   * as `String` divided by a comma or one (or more) white spaces.<br />
	   * The latter is a deprecated method because it leads to confusion and will be
	   * removed in v2.<br />
	   * Additionally, it accepts additions and subtractions between different units.
	   * Note that multiplications and divisions aren't supported.
	   *
	   * Valid examples are:
	   * ```
	   * 10
	   * '10%'
	   * '10, 10'
	   * '10%, 10'
	   * '10 + 10%'
	   * '10 - 5vh + 3%'
	   * '-10px + 5vh, 5px - 6%'
	   * ```
	   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
	   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
	   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  offset: {
	    /** @prop {number} order=200 - Index used to define the order of execution */
	    order: 200,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: offset,
	    /** @prop {Number|String} offset=0
	     * The offset value as described in the modifier description
	     */
	    offset: 0
	  },
	
	  /**
	   * Modifier used to prevent the popper from being positioned outside the boundary.
	   *
	   * A scenario exists where the reference itself is not within the boundaries.<br />
	   * We can say it has "escaped the boundaries" — or just "escaped".<br />
	   * In this case we need to decide whether the popper should either:
	   *
	   * - detach from the reference and remain "trapped" in the boundaries, or
	   * - if it should ignore the boundary and "escape with its reference"
	   *
	   * When `escapeWithReference` is set to`true` and reference is completely
	   * outside its boundaries, the popper will overflow (or completely leave)
	   * the boundaries in order to remain attached to the edge of the reference.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  preventOverflow: {
	    /** @prop {number} order=300 - Index used to define the order of execution */
	    order: 300,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: preventOverflow,
	    /**
	     * @prop {Array} [priority=['left','right','top','bottom']]
	     * Popper will try to prevent overflow following these priorities by default,
	     * then, it could overflow on the left and on top of the `boundariesElement`
	     */
	    priority: ['left', 'right', 'top', 'bottom'],
	    /**
	     * @prop {number} padding=5
	     * Amount of pixel used to define a minimum distance between the boundaries
	     * and the popper. This makes sure the popper always has a little padding
	     * between the edges of its container
	     */
	    padding: 5,
	    /**
	     * @prop {String|HTMLElement} boundariesElement='scrollParent'
	     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
	     * `viewport` or any DOM element.
	     */
	    boundariesElement: 'scrollParent'
	  },
	
	  /**
	   * Modifier used to make sure the reference and its popper stay near each other
	   * without leaving any gap between the two. Especially useful when the arrow is
	   * enabled and you want to ensure that it points to its reference element.
	   * It cares only about the first axis. You can still have poppers with margin
	   * between the popper and its reference element.
	   * @memberof modifiers
	   * @inner
	   */
	  keepTogether: {
	    /** @prop {number} order=400 - Index used to define the order of execution */
	    order: 400,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: keepTogether
	  },
	
	  /**
	   * This modifier is used to move the `arrowElement` of the popper to make
	   * sure it is positioned between the reference element and its popper element.
	   * It will read the outer size of the `arrowElement` node to detect how many
	   * pixels of conjunction are needed.
	   *
	   * It has no effect if no `arrowElement` is provided.
	   * @memberof modifiers
	   * @inner
	   */
	  arrow: {
	    /** @prop {number} order=500 - Index used to define the order of execution */
	    order: 500,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: arrow,
	    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
	    element: '[x-arrow]'
	  },
	
	  /**
	   * Modifier used to flip the popper's placement when it starts to overlap its
	   * reference element.
	   *
	   * Requires the `preventOverflow` modifier before it in order to work.
	   *
	   * **NOTE:** this modifier will interrupt the current update cycle and will
	   * restart it if it detects the need to flip the placement.
	   * @memberof modifiers
	   * @inner
	   */
	  flip: {
	    /** @prop {number} order=600 - Index used to define the order of execution */
	    order: 600,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: flip,
	    /**
	     * @prop {String|Array} behavior='flip'
	     * The behavior used to change the popper's placement. It can be one of
	     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
	     * placements (with optional variations)
	     */
	    behavior: 'flip',
	    /**
	     * @prop {number} padding=5
	     * The popper will flip if it hits the edges of the `boundariesElement`
	     */
	    padding: 5,
	    /**
	     * @prop {String|HTMLElement} boundariesElement='viewport'
	     * The element which will define the boundaries of the popper position.
	     * The popper will never be placed outside of the defined boundaries
	     * (except if `keepTogether` is enabled)
	     */
	    boundariesElement: 'viewport',
	    /**
	     * @prop {Boolean} flipVariations=false
	     * The popper will switch placement variation between `-start` and `-end` when
	     * the reference element overlaps its boundaries.
	     *
	     * The original placement should have a set variation.
	     */
	    flipVariations: false,
	    /**
	     * @prop {Boolean} flipVariationsByContent=false
	     * The popper will switch placement variation between `-start` and `-end` when
	     * the popper element overlaps its reference boundaries.
	     *
	     * The original placement should have a set variation.
	     */
	    flipVariationsByContent: false
	  },
	
	  /**
	   * Modifier used to make the popper flow toward the inner of the reference element.
	   * By default, when this modifier is disabled, the popper will be placed outside
	   * the reference element.
	   * @memberof modifiers
	   * @inner
	   */
	  inner: {
	    /** @prop {number} order=700 - Index used to define the order of execution */
	    order: 700,
	    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
	    enabled: false,
	    /** @prop {ModifierFn} */
	    fn: inner
	  },
	
	  /**
	   * Modifier used to hide the popper when its reference element is outside of the
	   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
	   * be used to hide with a CSS selector the popper when its reference is
	   * out of boundaries.
	   *
	   * Requires the `preventOverflow` modifier before it in order to work.
	   * @memberof modifiers
	   * @inner
	   */
	  hide: {
	    /** @prop {number} order=800 - Index used to define the order of execution */
	    order: 800,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: hide
	  },
	
	  /**
	   * Computes the style that will be applied to the popper element to gets
	   * properly positioned.
	   *
	   * Note that this modifier will not touch the DOM, it just prepares the styles
	   * so that `applyStyle` modifier can apply it. This separation is useful
	   * in case you need to replace `applyStyle` with a custom implementation.
	   *
	   * This modifier has `850` as `order` value to maintain backward compatibility
	   * with previous versions of Popper.js. Expect the modifiers ordering method
	   * to change in future major versions of the library.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  computeStyle: {
	    /** @prop {number} order=850 - Index used to define the order of execution */
	    order: 850,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: computeStyle,
	    /**
	     * @prop {Boolean} gpuAcceleration=true
	     * If true, it uses the CSS 3D transformation to position the popper.
	     * Otherwise, it will use the `top` and `left` properties
	     */
	    gpuAcceleration: true,
	    /**
	     * @prop {string} [x='bottom']
	     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
	     * Change this if your popper should grow in a direction different from `bottom`
	     */
	    x: 'bottom',
	    /**
	     * @prop {string} [x='left']
	     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
	     * Change this if your popper should grow in a direction different from `right`
	     */
	    y: 'right'
	  },
	
	  /**
	   * Applies the computed styles to the popper element.
	   *
	   * All the DOM manipulations are limited to this modifier. This is useful in case
	   * you want to integrate Popper.js inside a framework or view library and you
	   * want to delegate all the DOM manipulations to it.
	   *
	   * Note that if you disable this modifier, you must make sure the popper element
	   * has its position set to `absolute` before Popper.js can do its work!
	   *
	   * Just disable this modifier and define your own to achieve the desired effect.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  applyStyle: {
	    /** @prop {number} order=900 - Index used to define the order of execution */
	    order: 900,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: applyStyle,
	    /** @prop {Function} */
	    onLoad: applyStyleOnLoad,
	    /**
	     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
	     * @prop {Boolean} gpuAcceleration=true
	     * If true, it uses the CSS 3D transformation to position the popper.
	     * Otherwise, it will use the `top` and `left` properties
	     */
	    gpuAcceleration: undefined
	  }
	};
	
	/**
	 * The `dataObject` is an object containing all the information used by Popper.js.
	 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
	 * @name dataObject
	 * @property {Object} data.instance The Popper.js instance
	 * @property {String} data.placement Placement applied to popper
	 * @property {String} data.originalPlacement Placement originally defined on init
	 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
	 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
	 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
	 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
	 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
	 * @property {Object} data.boundaries Offsets of the popper boundaries
	 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
	 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
	 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
	 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
	 */
	
	/**
	 * Default options provided to Popper.js constructor.<br />
	 * These can be overridden using the `options` argument of Popper.js.<br />
	 * To override an option, simply pass an object with the same
	 * structure of the `options` object, as the 3rd argument. For example:
	 * ```
	 * new Popper(ref, pop, {
	 *   modifiers: {
	 *     preventOverflow: { enabled: false }
	 *   }
	 * })
	 * ```
	 * @type {Object}
	 * @static
	 * @memberof Popper
	 */
	var Defaults = {
	  /**
	   * Popper's placement.
	   * @prop {Popper.placements} placement='bottom'
	   */
	  placement: 'bottom',
	
	  /**
	   * Set this to true if you want popper to position it self in 'fixed' mode
	   * @prop {Boolean} positionFixed=false
	   */
	  positionFixed: false,
	
	  /**
	   * Whether events (resize, scroll) are initially enabled.
	   * @prop {Boolean} eventsEnabled=true
	   */
	  eventsEnabled: true,
	
	  /**
	   * Set to true if you want to automatically remove the popper when
	   * you call the `destroy` method.
	   * @prop {Boolean} removeOnDestroy=false
	   */
	  removeOnDestroy: false,
	
	  /**
	   * Callback called when the popper is created.<br />
	   * By default, it is set to no-op.<br />
	   * Access Popper.js instance with `data.instance`.
	   * @prop {onCreate}
	   */
	  onCreate: function onCreate() {},
	
	  /**
	   * Callback called when the popper is updated. This callback is not called
	   * on the initialization/creation of the popper, but only on subsequent
	   * updates.<br />
	   * By default, it is set to no-op.<br />
	   * Access Popper.js instance with `data.instance`.
	   * @prop {onUpdate}
	   */
	  onUpdate: function onUpdate() {},
	
	  /**
	   * List of modifiers used to modify the offsets before they are applied to the popper.
	   * They provide most of the functionalities of Popper.js.
	   * @prop {modifiers}
	   */
	  modifiers: modifiers
	};
	
	/**
	 * @callback onCreate
	 * @param {dataObject} data
	 */
	
	/**
	 * @callback onUpdate
	 * @param {dataObject} data
	 */
	
	// Utils
	// Methods
	var Popper = function () {
	  /**
	   * Creates a new Popper.js instance.
	   * @class Popper
	   * @param {Element|referenceObject} reference - The reference element used to position the popper
	   * @param {Element} popper - The HTML / XML element used as the popper
	   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
	   * @return {Object} instance - The generated Popper.js instance
	   */
	  function Popper(reference, popper) {
	    var _this = this;
	
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    classCallCheck(this, Popper);
	
	    this.scheduleUpdate = function () {
	      return requestAnimationFrame(_this.update);
	    };
	
	    // make update() debounced, so that it only runs at most once-per-tick
	    this.update = debounce(this.update.bind(this));
	
	    // with {} we create a new object with the options inside it
	    this.options = _extends({}, Popper.Defaults, options);
	
	    // init state
	    this.state = {
	      isDestroyed: false,
	      isCreated: false,
	      scrollParents: []
	    };
	
	    // get reference and popper elements (allow jQuery wrappers)
	    this.reference = reference && reference.jquery ? reference[0] : reference;
	    this.popper = popper && popper.jquery ? popper[0] : popper;
	
	    // Deep merge modifiers options
	    this.options.modifiers = {};
	    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
	      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
	    });
	
	    // Refactoring modifiers' list (Object => Array)
	    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
	      return _extends({
	        name: name
	      }, _this.options.modifiers[name]);
	    })
	    // sort the modifiers by order
	    .sort(function (a, b) {
	      return a.order - b.order;
	    });
	
	    // modifiers have the ability to execute arbitrary code when Popper.js get inited
	    // such code is executed in the same order of its modifier
	    // they could add new properties to their options configuration
	    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
	    this.modifiers.forEach(function (modifierOptions) {
	      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
	        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
	      }
	    });
	
	    // fire the first update to position the popper in the right place
	    this.update();
	
	    var eventsEnabled = this.options.eventsEnabled;
	    if (eventsEnabled) {
	      // setup event listeners, they will take care of update the position in specific situations
	      this.enableEventListeners();
	    }
	
	    this.state.eventsEnabled = eventsEnabled;
	  }
	
	  // We can't use class properties because they don't get listed in the
	  // class prototype and break stuff like Sinon stubs
	
	
	  createClass(Popper, [{
	    key: 'update',
	    value: function update$$1() {
	      return update.call(this);
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy$$1() {
	      return destroy.call(this);
	    }
	  }, {
	    key: 'enableEventListeners',
	    value: function enableEventListeners$$1() {
	      return enableEventListeners.call(this);
	    }
	  }, {
	    key: 'disableEventListeners',
	    value: function disableEventListeners$$1() {
	      return disableEventListeners.call(this);
	    }
	
	    /**
	     * Schedules an update. It will run on the next UI update available.
	     * @method scheduleUpdate
	     * @memberof Popper
	     */
	
	
	    /**
	     * Collection of utilities useful when writing custom modifiers.
	     * Starting from version 1.7, this method is available only if you
	     * include `popper-utils.js` before `popper.js`.
	     *
	     * **DEPRECATION**: This way to access PopperUtils is deprecated
	     * and will be removed in v2! Use the PopperUtils module directly instead.
	     * Due to the high instability of the methods contained in Utils, we can't
	     * guarantee them to follow semver. Use them at your own risk!
	     * @static
	     * @private
	     * @type {Object}
	     * @deprecated since version 1.8
	     * @member Utils
	     * @memberof Popper
	     */
	
	  }]);
	  return Popper;
	}();
	
	/**
	 * The `referenceObject` is an object that provides an interface compatible with Popper.js
	 * and lets you use it as replacement of a real DOM node.<br />
	 * You can use this method to position a popper relatively to a set of coordinates
	 * in case you don't have a DOM node to use as reference.
	 *
	 * ```
	 * new Popper(referenceObject, popperNode);
	 * ```
	 *
	 * NB: This feature isn't supported in Internet Explorer 10.
	 * @name referenceObject
	 * @property {Function} data.getBoundingClientRect
	 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
	 * @property {number} data.clientWidth
	 * An ES6 getter that will return the width of the virtual reference element.
	 * @property {number} data.clientHeight
	 * An ES6 getter that will return the height of the virtual reference element.
	 */
	
	
	Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
	Popper.placements = placements;
	Popper.Defaults = Defaults;
	
	return Popper;
	
	})));
	//# sourceMappingURL=popper.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1449 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _resizeObserverPolyfill = __webpack_require__(660);
	
	var _resizeObserverPolyfill2 = _interopRequireDefault(_resizeObserverPolyfill);
	
	var _utils = __webpack_require__(1450);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint no-debugger: "warn" */
	
	
	/**
	 * Predefined constants
	 * @type {Object}
	 */
	var constants = {
	  orientation: {
	    horizontal: {
	      dimension: 'width',
	      direction: 'left',
	      reverseDirection: 'right',
	      coordinate: 'x'
	    },
	    vertical: {
	      dimension: 'height',
	      direction: 'top',
	      reverseDirection: 'bottom',
	      coordinate: 'y'
	    }
	  }
	};
	
	var Slider = function (_Component) {
	  _inherits(Slider, _Component);
	
	  function Slider(props, context) {
	    _classCallCheck(this, Slider);
	
	    var _this = _possibleConstructorReturn(this, (Slider.__proto__ || Object.getPrototypeOf(Slider)).call(this, props, context));
	
	    _this.handleFormat = function (value) {
	      var format = _this.props.format;
	
	      return format ? format(value) : value;
	    };
	
	    _this.handleUpdate = function () {
	      if (!_this.slider) {
	        // for shallow rendering
	        return;
	      }
	      var orientation = _this.props.orientation;
	
	      var dimension = (0, _utils.capitalize)(constants.orientation[orientation].dimension);
	      var sliderPos = _this.slider['offset' + dimension];
	      var handlePos = _this.handle['offset' + dimension];
	
	      _this.setState({
	        limit: sliderPos - handlePos,
	        grab: handlePos / 2
	      });
	    };
	
	    _this.handleStart = function (e) {
	      var onChangeStart = _this.props.onChangeStart;
	
	      document.addEventListener('mousemove', _this.handleDrag);
	      document.addEventListener('mouseup', _this.handleEnd);
	      _this.setState({
	        active: true
	      }, function () {
	        onChangeStart && onChangeStart(e);
	      });
	    };
	
	    _this.handleDrag = function (e) {
	      e.stopPropagation();
	      var onChange = _this.props.onChange;
	      var _e$target = e.target,
	          className = _e$target.className,
	          classList = _e$target.classList,
	          dataset = _e$target.dataset;
	
	      if (!onChange || className === 'rangeslider__labels') return;
	
	      var value = _this.position(e);
	
	      if (classList && classList.contains('rangeslider__label-item') && dataset.value) {
	        value = parseFloat(dataset.value);
	      }
	
	      onChange && onChange(value, e);
	    };
	
	    _this.handleEnd = function (e) {
	      var onChangeComplete = _this.props.onChangeComplete;
	
	      _this.setState({
	        active: false
	      }, function () {
	        onChangeComplete && onChangeComplete(e);
	      });
	      document.removeEventListener('mousemove', _this.handleDrag);
	      document.removeEventListener('mouseup', _this.handleEnd);
	    };
	
	    _this.handleKeyDown = function (e) {
	      e.preventDefault();
	      var keyCode = e.keyCode;
	      var _this$props = _this.props,
	          value = _this$props.value,
	          min = _this$props.min,
	          max = _this$props.max,
	          step = _this$props.step,
	          onChange = _this$props.onChange;
	
	      var sliderValue = void 0;
	
	      switch (keyCode) {
	        case 38:
	        case 39:
	          sliderValue = value + step > max ? max : value + step;
	          onChange && onChange(sliderValue, e);
	          break;
	        case 37:
	        case 40:
	          sliderValue = value - step < min ? min : value - step;
	          onChange && onChange(sliderValue, e);
	          break;
	      }
	    };
	
	    _this.getPositionFromValue = function (value) {
	      var limit = _this.state.limit;
	      var _this$props2 = _this.props,
	          min = _this$props2.min,
	          max = _this$props2.max;
	
	      var diffMaxMin = max - min;
	      var diffValMin = value - min;
	      var percentage = diffValMin / diffMaxMin;
	      var pos = Math.round(percentage * limit);
	
	      return pos;
	    };
	
	    _this.getValueFromPosition = function (pos) {
	      var limit = _this.state.limit;
	      var _this$props3 = _this.props,
	          orientation = _this$props3.orientation,
	          min = _this$props3.min,
	          max = _this$props3.max,
	          step = _this$props3.step;
	
	      var percentage = (0, _utils.clamp)(pos, 0, limit) / (limit || 1);
	      var baseVal = step * Math.round(percentage * (max - min) / step);
	      var value = orientation === 'horizontal' ? baseVal + min : max - baseVal;
	
	      return (0, _utils.clamp)(value, min, max);
	    };
	
	    _this.position = function (e) {
	      var grab = _this.state.grab;
	      var _this$props4 = _this.props,
	          orientation = _this$props4.orientation,
	          reverse = _this$props4.reverse;
	
	
	      var node = _this.slider;
	      var coordinateStyle = constants.orientation[orientation].coordinate;
	      var directionStyle = reverse ? constants.orientation[orientation].reverseDirection : constants.orientation[orientation].direction;
	      var clientCoordinateStyle = 'client' + (0, _utils.capitalize)(coordinateStyle);
	      var coordinate = !e.touches ? e[clientCoordinateStyle] : e.touches[0][clientCoordinateStyle];
	      var direction = node.getBoundingClientRect()[directionStyle];
	      var pos = reverse ? direction - coordinate - grab : coordinate - direction - grab;
	      var value = _this.getValueFromPosition(pos);
	
	      return value;
	    };
	
	    _this.coordinates = function (pos) {
	      var _this$state = _this.state,
	          limit = _this$state.limit,
	          grab = _this$state.grab;
	      var orientation = _this.props.orientation;
	
	      var value = _this.getValueFromPosition(pos);
	      var position = _this.getPositionFromValue(value);
	      var handlePos = orientation === 'horizontal' ? position + grab : position;
	      var fillPos = orientation === 'horizontal' ? handlePos : limit - handlePos;
	
	      return {
	        fill: fillPos,
	        handle: handlePos,
	        label: handlePos
	      };
	    };
	
	    _this.renderLabels = function (labels) {
	      return _react2.default.createElement(
	        'ul',
	        {
	          ref: function ref(sl) {
	            _this.labels = sl;
	          },
	          className: (0, _classnames2.default)('rangeslider__labels')
	        },
	        labels
	      );
	    };
	
	    _this.state = {
	      active: false,
	      limit: 0,
	      grab: 0
	    };
	    return _this;
	  }
	
	  _createClass(Slider, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.handleUpdate();
	      var resizeObserver = new _resizeObserverPolyfill2.default(this.handleUpdate);
	      resizeObserver.observe(this.slider);
	    }
	
	    /**
	     * Format label/tooltip value
	     * @param  {Number} - value
	     * @return {Formatted Number}
	     */
	
	
	    /**
	     * Update slider state on change
	     * @return {void}
	     */
	
	
	    /**
	     * Attach event listeners to mousemove/mouseup events
	     * @return {void}
	     */
	
	
	    /**
	     * Handle drag/mousemove event
	     * @param  {Object} e - Event object
	     * @return {void}
	     */
	
	
	    /**
	     * Detach event listeners to mousemove/mouseup events
	     * @return {void}
	     */
	
	
	    /**
	     * Support for key events on the slider handle
	     * @param  {Object} e - Event object
	     * @return {void}
	     */
	
	
	    /**
	     * Calculate position of slider based on its value
	     * @param  {number} value - Current value of slider
	     * @return {position} pos - Calculated position of slider based on value
	     */
	
	
	    /**
	     * Translate position of slider to slider value
	     * @param  {number} pos - Current position/coordinates of slider
	     * @return {number} value - Slider value
	     */
	
	
	    /**
	     * Calculate position of slider based on value
	     * @param  {Object} e - Event object
	     * @return {number} value - Slider value
	     */
	
	
	    /**
	     * Grab coordinates of slider
	     * @param  {Object} pos - Position object
	     * @return {Object} - Slider fill/handle coordinates
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          value = _props.value,
	          orientation = _props.orientation,
	          className = _props.className,
	          tooltip = _props.tooltip,
	          reverse = _props.reverse,
	          labels = _props.labels,
	          min = _props.min,
	          max = _props.max,
	          handleLabel = _props.handleLabel;
	      var active = this.state.active;
	
	      var dimension = constants.orientation[orientation].dimension;
	      var direction = reverse ? constants.orientation[orientation].reverseDirection : constants.orientation[orientation].direction;
	      var position = this.getPositionFromValue(value);
	      var coords = this.coordinates(position);
	      var fillStyle = _defineProperty({}, dimension, coords.fill + 'px');
	      var handleStyle = _defineProperty({}, direction, coords.handle + 'px');
	      var showTooltip = tooltip && active;
	
	      var labelItems = [];
	      var labelKeys = Object.keys(labels);
	
	      if (labelKeys.length > 0) {
	        labelKeys = labelKeys.sort(function (a, b) {
	          return reverse ? a - b : b - a;
	        });
	
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = labelKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var key = _step.value;
	
	            var labelPosition = this.getPositionFromValue(key);
	            var labelCoords = this.coordinates(labelPosition);
	            var labelStyle = _defineProperty({}, direction, labelCoords.label + 'px');
	
	            labelItems.push(_react2.default.createElement(
	              'li',
	              {
	                key: key,
	                className: (0, _classnames2.default)('rangeslider__label-item'),
	                'data-value': key,
	                onMouseDown: this.handleDrag,
	                onTouchStart: this.handleStart,
	                onTouchEnd: this.handleEnd,
	                style: labelStyle
	              },
	              this.props.labels[key]
	            ));
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	      }
	
	      return _react2.default.createElement(
	        'div',
	        {
	          ref: function ref(s) {
	            _this2.slider = s;
	          },
	          className: (0, _classnames2.default)('rangeslider', 'rangeslider-' + orientation, { 'rangeslider-reverse': reverse }, className),
	          onMouseDown: this.handleDrag,
	          onMouseUp: this.handleEnd,
	          onTouchStart: this.handleStart,
	          onTouchEnd: this.handleEnd,
	          'aria-valuemin': min,
	          'aria-valuemax': max,
	          'aria-valuenow': value,
	          'aria-orientation': orientation
	        },
	        _react2.default.createElement('div', { className: 'rangeslider__fill', style: fillStyle }),
	        _react2.default.createElement(
	          'div',
	          {
	            ref: function ref(sh) {
	              _this2.handle = sh;
	            },
	            className: 'rangeslider__handle',
	            onMouseDown: this.handleStart,
	            onTouchMove: this.handleDrag,
	            onTouchEnd: this.handleEnd,
	            onKeyDown: this.handleKeyDown,
	            style: handleStyle,
	            tabIndex: 0
	          },
	          showTooltip ? _react2.default.createElement(
	            'div',
	            {
	              ref: function ref(st) {
	                _this2.tooltip = st;
	              },
	              className: 'rangeslider__handle-tooltip'
	            },
	            _react2.default.createElement(
	              'span',
	              null,
	              this.handleFormat(value)
	            )
	          ) : null,
	          _react2.default.createElement(
	            'div',
	            { className: 'rangeslider__handle-label' },
	            handleLabel
	          )
	        ),
	        labels ? this.renderLabels(labelItems) : null
	      );
	    }
	  }]);
	
	  return Slider;
	}(_react.Component);
	
	Slider.propTypes = {
	  min: _propTypes2.default.number,
	  max: _propTypes2.default.number,
	  step: _propTypes2.default.number,
	  value: _propTypes2.default.number,
	  orientation: _propTypes2.default.string,
	  tooltip: _propTypes2.default.bool,
	  reverse: _propTypes2.default.bool,
	  labels: _propTypes2.default.object,
	  handleLabel: _propTypes2.default.string,
	  format: _propTypes2.default.func,
	  onChangeStart: _propTypes2.default.func,
	  onChange: _propTypes2.default.func,
	  onChangeComplete: _propTypes2.default.func
	};
	Slider.defaultProps = {
	  min: 0,
	  max: 100,
	  step: 1,
	  value: 0,
	  orientation: 'horizontal',
	  tooltip: true,
	  reverse: false,
	  labels: {},
	  handleLabel: ''
	};
	exports.default = Slider;

/***/ },
/* 1450 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.capitalize = capitalize;
	exports.clamp = clamp;
	/**
	 * Capitalize first letter of string
	 * @private
	 * @param  {string} - String
	 * @return {string} - String with first letter capitalized
	 */
	function capitalize(str) {
	  return str.charAt(0).toUpperCase() + str.substr(1);
	}
	
	/**
	 * Clamp position between a range
	 * @param  {number} - Value to be clamped
	 * @param  {number} - Minimum value in range
	 * @param  {number} - Maximum value in range
	 * @return {number} - Clamped value
	 */
	function clamp(value, min, max) {
	  return Math.min(Math.max(value, min), max);
	}

/***/ },
/* 1451 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";function _interopDefault(e){return e&&"object"==typeof e&&"default"in e?e.default:e}Object.defineProperty(exports,"__esModule",{value:!0});var reactRouter=__webpack_require__(1453),React=_interopDefault(__webpack_require__(1)),history=__webpack_require__(438);__webpack_require__(3),__webpack_require__(134);var invariant=_interopDefault(__webpack_require__(307));function _extends(){return(_extends=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var o in r)Object.prototype.hasOwnProperty.call(r,o)&&(e[o]=r[o])}return e}).apply(this,arguments)}function _inheritsLoose(e,t){e.prototype=Object.create(t.prototype),_setPrototypeOf(e.prototype.constructor=e,t)}function _setPrototypeOf(e,t){return(_setPrototypeOf=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}function _objectWithoutPropertiesLoose(e,t){if(null==e)return{};var r,o,n={},a=Object.keys(e);for(o=0;o<a.length;o++)r=a[o],0<=t.indexOf(r)||(n[r]=e[r]);return n}var BrowserRouter=function(n){function e(){for(var e,t=arguments.length,r=new Array(t),o=0;o<t;o++)r[o]=arguments[o];return(e=n.call.apply(n,[this].concat(r))||this).history=history.createBrowserHistory(e.props),e}return _inheritsLoose(e,n),e.prototype.render=function(){return React.createElement(reactRouter.Router,{history:this.history,children:this.props.children})},e}(React.Component),HashRouter=function(n){function e(){for(var e,t=arguments.length,r=new Array(t),o=0;o<t;o++)r[o]=arguments[o];return(e=n.call.apply(n,[this].concat(r))||this).history=history.createHashHistory(e.props),e}return _inheritsLoose(e,n),e.prototype.render=function(){return React.createElement(reactRouter.Router,{history:this.history,children:this.props.children})},e}(React.Component),resolveToLocation=function(e,t){return"function"==typeof e?e(t):e},normalizeToLocation=function(e,t){return"string"==typeof e?history.createLocation(e,null,null,t):e},forwardRefShim=function(e){return e},forwardRef=React.forwardRef;function isModifiedEvent(e){return!!(e.metaKey||e.altKey||e.ctrlKey||e.shiftKey)}void 0===forwardRef&&(forwardRef=forwardRefShim);var LinkAnchor=forwardRef(function(e,t){var r=e.innerRef,o=e.navigate,n=e.onClick,a=_objectWithoutPropertiesLoose(e,["innerRef","navigate","onClick"]),i=a.target,c=_extends({},a,{onClick:function(t){try{n&&n(t)}catch(e){throw t.preventDefault(),e}t.defaultPrevented||0!==t.button||i&&"_self"!==i||isModifiedEvent(t)||(t.preventDefault(),o())}});return c.ref=forwardRefShim!==forwardRef&&t||r,React.createElement("a",c)}),Link=forwardRef(function(e,a){var t=e.component,i=void 0===t?LinkAnchor:t,c=e.replace,u=e.to,f=e.innerRef,s=_objectWithoutPropertiesLoose(e,["component","replace","to","innerRef"]);return React.createElement(reactRouter.__RouterContext.Consumer,null,function(r){r||invariant(!1);var o=r.history,e=normalizeToLocation(resolveToLocation(u,r.location),r.location),t=e?o.createHref(e):"",n=_extends({},s,{href:t,navigate:function(){var e=resolveToLocation(u,r.location),t=history.createPath(r.location)===history.createPath(normalizeToLocation(e));(c||t?o.replace:o.push)(e)}});return forwardRefShim!==forwardRef?n.ref=a||f:n.innerRef=f,React.createElement(i,n)})}),forwardRefShim$1=function(e){return e},forwardRef$1=React.forwardRef;function joinClassnames(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];return t.filter(function(e){return e}).join(" ")}void 0===forwardRef$1&&(forwardRef$1=forwardRefShim$1);var NavLink=forwardRef$1(function(e,s){var t=e["aria-current"],l=void 0===t?"page":t,r=e.activeClassName,p=void 0===r?"active":r,R=e.activeStyle,h=e.className,y=e.exact,d=e.isActive,m=e.location,v=e.sensitive,b=e.strict,P=e.style,w=e.to,x=e.innerRef,g=_objectWithoutPropertiesLoose(e,["aria-current","activeClassName","activeStyle","className","exact","isActive","location","sensitive","strict","style","to","innerRef"]);return React.createElement(reactRouter.__RouterContext.Consumer,null,function(e){e||invariant(!1);var t=m||e.location,r=normalizeToLocation(resolveToLocation(w,t),t),o=r.pathname,n=o&&o.replace(/([.+*?=^!:${}()[\]|/\\])/g,"\\$1"),a=n?reactRouter.matchPath(t.pathname,{path:n,exact:y,sensitive:v,strict:b}):null,i=!!(d?d(a,t):a),c="function"==typeof h?h(i):h,u="function"==typeof P?P(i):P;i&&(c=joinClassnames(c,p),u=_extends({},u,R));var f=_extends({"aria-current":i&&l||null,className:c,style:u,to:r},g);return forwardRefShim$1!==forwardRef$1?f.ref=s||x:f.innerRef=x,React.createElement(Link,f)})});Object.defineProperty(exports,"MemoryRouter",{enumerable:!0,get:function(){return reactRouter.MemoryRouter}}),Object.defineProperty(exports,"Prompt",{enumerable:!0,get:function(){return reactRouter.Prompt}}),Object.defineProperty(exports,"Redirect",{enumerable:!0,get:function(){return reactRouter.Redirect}}),Object.defineProperty(exports,"Route",{enumerable:!0,get:function(){return reactRouter.Route}}),Object.defineProperty(exports,"Router",{enumerable:!0,get:function(){return reactRouter.Router}}),Object.defineProperty(exports,"StaticRouter",{enumerable:!0,get:function(){return reactRouter.StaticRouter}}),Object.defineProperty(exports,"Switch",{enumerable:!0,get:function(){return reactRouter.Switch}}),Object.defineProperty(exports,"generatePath",{enumerable:!0,get:function(){return reactRouter.generatePath}}),Object.defineProperty(exports,"matchPath",{enumerable:!0,get:function(){return reactRouter.matchPath}}),Object.defineProperty(exports,"useHistory",{enumerable:!0,get:function(){return reactRouter.useHistory}}),Object.defineProperty(exports,"useLocation",{enumerable:!0,get:function(){return reactRouter.useLocation}}),Object.defineProperty(exports,"useParams",{enumerable:!0,get:function(){return reactRouter.useParams}}),Object.defineProperty(exports,"useRouteMatch",{enumerable:!0,get:function(){return reactRouter.useRouteMatch}}),Object.defineProperty(exports,"withRouter",{enumerable:!0,get:function(){return reactRouter.withRouter}}),exports.BrowserRouter=BrowserRouter,exports.HashRouter=HashRouter,exports.Link=Link,exports.NavLink=NavLink;
	//# sourceMappingURL=react-router-dom.min.js.map


/***/ },
/* 1452 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";function _interopDefault(t){return t&&"object"==typeof t&&"default"in t?t.default:t}Object.defineProperty(exports,"__esModule",{value:!0});var React=_interopDefault(__webpack_require__(1)),PropTypes=_interopDefault(__webpack_require__(3)),history=__webpack_require__(438);__webpack_require__(134);var invariant=_interopDefault(__webpack_require__(307)),pathToRegexp=_interopDefault(__webpack_require__(1363));__webpack_require__(1455);var hoistStatics=_interopDefault(__webpack_require__(157));function _extends(){return(_extends=Object.assign||function(t){for(var e=1;e<arguments.length;e++){var n=arguments[e];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(t[o]=n[o])}return t}).apply(this,arguments)}function _inheritsLoose(t,e){t.prototype=Object.create(e.prototype),_setPrototypeOf(t.prototype.constructor=t,e)}function _setPrototypeOf(t,e){return(_setPrototypeOf=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}function _objectWithoutPropertiesLoose(t,e){if(null==t)return{};var n,o,r={},i=Object.keys(t);for(o=0;o<i.length;o++)n=i[o],0<=e.indexOf(n)||(r[n]=t[n]);return r}var MAX_SIGNED_31_BIT_INT=1073741823,commonjsGlobal="undefined"!=typeof globalThis?globalThis:"undefined"!=typeof window?window:"undefined"!=typeof global?global:{};function getUniqueId(){var t="__global_unique_id__";return commonjsGlobal[t]=(commonjsGlobal[t]||0)+1}function objectIs(t,e){return t===e?0!==t||1/t==1/e:t!=t&&e!=e}function createEventEmitter(n){var o=[];return{on:function(t){o.push(t)},off:function(e){o=o.filter(function(t){return t!==e})},get:function(){return n},set:function(t,e){n=t,o.forEach(function(t){return t(n,e)})}}}function onlyChild(t){return Array.isArray(t)?t[0]:t}function createReactContext(n,i){var t,e,o="__create-react-context-"+getUniqueId()+"__",r=function(r){function t(){for(var t,e=arguments.length,n=new Array(e),o=0;o<e;o++)n[o]=arguments[o];return(t=r.call.apply(r,[this].concat(n))||this).emitter=createEventEmitter(t.props.value),t}_inheritsLoose(t,r);var e=t.prototype;return e.getChildContext=function(){var t;return(t={})[o]=this.emitter,t},e.componentWillReceiveProps=function(t){if(this.props.value!==t.value){var e,n=this.props.value,o=t.value;objectIs(n,o)?e=0:(e="function"==typeof i?i(n,o):MAX_SIGNED_31_BIT_INT,0!==(e|=0)&&this.emitter.set(t.value,e))}},e.render=function(){return this.props.children},t}(React.Component);r.childContextTypes=((t={})[o]=PropTypes.object.isRequired,t);var a=function(r){function t(){for(var n,t=arguments.length,e=new Array(t),o=0;o<t;o++)e[o]=arguments[o];return(n=r.call.apply(r,[this].concat(e))||this).observedBits=void 0,n.state={value:n.getValue()},n.onUpdate=function(t,e){0!=((0|n.observedBits)&e)&&n.setState({value:n.getValue()})},n}_inheritsLoose(t,r);var e=t.prototype;return e.componentWillReceiveProps=function(t){var e=t.observedBits;this.observedBits=null==e?MAX_SIGNED_31_BIT_INT:e},e.componentDidMount=function(){this.context[o]&&this.context[o].on(this.onUpdate);var t=this.props.observedBits;this.observedBits=null==t?MAX_SIGNED_31_BIT_INT:t},e.componentWillUnmount=function(){this.context[o]&&this.context[o].off(this.onUpdate)},e.getValue=function(){return this.context[o]?this.context[o].get():n},e.render=function(){return onlyChild(this.props.children)(this.state.value)},t}(React.Component);return a.contextTypes=((e={})[o]=PropTypes.object,e),{Provider:r,Consumer:a}}var createContext=React.createContext||createReactContext,createNamedContext=function(t){var e=createContext();return e.displayName=t,e},historyContext=createNamedContext("Router-History"),context=createNamedContext("Router"),Router=function(n){function t(t){var e;return(e=n.call(this,t)||this).state={location:t.history.location},e._isMounted=!1,e._pendingLocation=null,t.staticContext||(e.unlisten=t.history.listen(function(t){e._pendingLocation=t})),e}_inheritsLoose(t,n),t.computeRootMatch=function(t){return{path:"/",url:"/",params:{},isExact:"/"===t}};var e=t.prototype;return e.componentDidMount=function(){var e=this;this._isMounted=!0,this.unlisten&&this.unlisten(),this.props.staticContext||(this.unlisten=this.props.history.listen(function(t){e._isMounted&&e.setState({location:t})})),this._pendingLocation&&this.setState({location:this._pendingLocation})},e.componentWillUnmount=function(){this.unlisten&&(this.unlisten(),this._isMounted=!1,this._pendingLocation=null)},e.render=function(){return React.createElement(context.Provider,{value:{history:this.props.history,location:this.state.location,match:t.computeRootMatch(this.state.location.pathname),staticContext:this.props.staticContext}},React.createElement(historyContext.Provider,{children:this.props.children||null,value:this.props.history}))},t}(React.Component),MemoryRouter=function(r){function t(){for(var t,e=arguments.length,n=new Array(e),o=0;o<e;o++)n[o]=arguments[o];return(t=r.call.apply(r,[this].concat(n))||this).history=history.createMemoryHistory(t.props),t}return _inheritsLoose(t,r),t.prototype.render=function(){return React.createElement(Router,{history:this.history,children:this.props.children})},t}(React.Component),Lifecycle=function(t){function e(){return t.apply(this,arguments)||this}_inheritsLoose(e,t);var n=e.prototype;return n.componentDidMount=function(){this.props.onMount&&this.props.onMount.call(this,this)},n.componentDidUpdate=function(t){this.props.onUpdate&&this.props.onUpdate.call(this,this,t)},n.componentWillUnmount=function(){this.props.onUnmount&&this.props.onUnmount.call(this,this)},n.render=function(){return null},e}(React.Component);function Prompt(t){var o=t.message,e=t.when,r=void 0===e||e;return React.createElement(context.Consumer,null,function(t){if(t||invariant(!1),!r||t.staticContext)return null;var n=t.history.block;return React.createElement(Lifecycle,{onMount:function(t){t.release=n(o)},onUpdate:function(t,e){e.message!==o&&(t.release(),t.release=n(o))},onUnmount:function(t){t.release()},message:o})})}var cache={},cacheLimit=1e4,cacheCount=0;function compilePath(t){if(cache[t])return cache[t];var e=pathToRegexp.compile(t);return cacheCount<cacheLimit&&(cache[t]=e,cacheCount++),e}function generatePath(t,e){return void 0===t&&(t="/"),void 0===e&&(e={}),"/"===t?t:compilePath(t)(e,{pretty:!0})}function Redirect(t){var i=t.computedMatch,a=t.to,e=t.push,c=void 0!==e&&e;return React.createElement(context.Consumer,null,function(t){t||invariant(!1);var e=t.history,n=t.staticContext,o=c?e.push:e.replace,r=history.createLocation(i?"string"==typeof a?generatePath(a,i.params):_extends({},a,{pathname:generatePath(a.pathname,i.params)}):a);return n?(o(r),null):React.createElement(Lifecycle,{onMount:function(){o(r)},onUpdate:function(t,e){var n=history.createLocation(e.to);history.locationsAreEqual(n,_extends({},r,{key:n.key}))||o(r)},to:a})})}var cache$1={},cacheLimit$1=1e4,cacheCount$1=0;function compilePath$1(t,e){var n=""+e.end+e.strict+e.sensitive,o=cache$1[n]||(cache$1[n]={});if(o[t])return o[t];var r=[],i={regexp:pathToRegexp(t,r,e),keys:r};return cacheCount$1<cacheLimit$1&&(o[t]=i,cacheCount$1++),i}function matchPath(u,t){void 0===t&&(t={}),"string"!=typeof t&&!Array.isArray(t)||(t={path:t});var e=t,n=e.path,o=e.exact,p=void 0!==o&&o,r=e.strict,h=void 0!==r&&r,i=e.sensitive,l=void 0!==i&&i;return[].concat(n).reduce(function(t,e){if(!e&&""!==e)return null;if(t)return t;var n=compilePath$1(e,{end:p,strict:h,sensitive:l}),o=n.regexp,r=n.keys,i=o.exec(u);if(!i)return null;var a=i[0],c=i.slice(1),s=u===a;return p&&!s?null:{path:e,url:"/"===e&&""===a?"/":a,isExact:s,params:r.reduce(function(t,e,n){return t[e.name]=c[n],t},{})}},null)}function isEmptyChildren(t){return 0===React.Children.count(t)}var Route=function(t){function e(){return t.apply(this,arguments)||this}return _inheritsLoose(e,t),e.prototype.render=function(){var c=this;return React.createElement(context.Consumer,null,function(t){t||invariant(!1);var e=c.props.location||t.location,n=_extends({},t,{location:e,match:c.props.computedMatch?c.props.computedMatch:c.props.path?matchPath(e.pathname,c.props):t.match}),o=c.props,r=o.children,i=o.component,a=o.render;return Array.isArray(r)&&isEmptyChildren(r)&&(r=null),React.createElement(context.Provider,{value:n},n.match?r?"function"==typeof r?r(n):r:i?React.createElement(i,n):a?a(n):null:"function"==typeof r?r(n):null)})},e}(React.Component);function addLeadingSlash(t){return"/"===t.charAt(0)?t:"/"+t}function addBasename(t,e){return t?_extends({},e,{pathname:addLeadingSlash(t)+e.pathname}):e}function stripBasename(t,e){if(!t)return e;var n=addLeadingSlash(t);return 0!==e.pathname.indexOf(n)?e:_extends({},e,{pathname:e.pathname.substr(n.length)})}function createURL(t){return"string"==typeof t?t:history.createPath(t)}function staticHandler(t){return function(){invariant(!1)}}function noop(){}var StaticRouter=function(r){function t(){for(var e,t=arguments.length,n=new Array(t),o=0;o<t;o++)n[o]=arguments[o];return(e=r.call.apply(r,[this].concat(n))||this).handlePush=function(t){return e.navigateTo(t,"PUSH")},e.handleReplace=function(t){return e.navigateTo(t,"REPLACE")},e.handleListen=function(){return noop},e.handleBlock=function(){return noop},e}_inheritsLoose(t,r);var e=t.prototype;return e.navigateTo=function(t,e){var n=this.props,o=n.basename,r=void 0===o?"":o,i=n.context,a=void 0===i?{}:i;a.action=e,a.location=addBasename(r,history.createLocation(t)),a.url=createURL(a.location)},e.render=function(){var t=this.props,e=t.basename,n=void 0===e?"":e,o=t.context,r=void 0===o?{}:o,i=t.location,a=void 0===i?"/":i,c=_objectWithoutPropertiesLoose(t,["basename","context","location"]),s={createHref:function(t){return addLeadingSlash(n+createURL(t))},action:"POP",location:stripBasename(n,history.createLocation(a)),push:this.handlePush,replace:this.handleReplace,go:staticHandler(),goBack:staticHandler(),goForward:staticHandler(),listen:this.handleListen,block:this.handleBlock};return React.createElement(Router,_extends({},c,{history:s,staticContext:r}))},t}(React.Component),Switch=function(t){function e(){return t.apply(this,arguments)||this}return _inheritsLoose(e,t),e.prototype.render=function(){var t=this;return React.createElement(context.Consumer,null,function(n){n||invariant(!1);var o,r,i=t.props.location||n.location;return React.Children.forEach(t.props.children,function(t){if(null==r&&React.isValidElement(t)){var e=(o=t).props.path||t.props.from;r=e?matchPath(i.pathname,_extends({},t.props,{path:e})):n.match}}),r?React.cloneElement(o,{location:i,computedMatch:r}):null})},e}(React.Component);function withRouter(o){function t(t){var e=t.wrappedComponentRef,n=_objectWithoutPropertiesLoose(t,["wrappedComponentRef"]);return React.createElement(context.Consumer,null,function(t){return t||invariant(!1),React.createElement(o,_extends({},n,t,{ref:e}))})}var e="withRouter("+(o.displayName||o.name)+")";return t.displayName=e,t.WrappedComponent=o,hoistStatics(t,o)}var useContext=React.useContext;function useHistory(){return useContext(historyContext)}function useLocation(){return useContext(context).location}function useParams(){var t=useContext(context).match;return t?t.params:{}}function useRouteMatch(t){var e=useLocation(),n=useContext(context).match;return t?matchPath(e.pathname,t):n}exports.MemoryRouter=MemoryRouter,exports.Prompt=Prompt,exports.Redirect=Redirect,exports.Route=Route,exports.Router=Router,exports.StaticRouter=StaticRouter,exports.Switch=Switch,exports.__HistoryContext=historyContext,exports.__RouterContext=context,exports.generatePath=generatePath,exports.matchPath=matchPath,exports.useHistory=useHistory,exports.useLocation=useLocation,exports.useParams=useParams,exports.useRouteMatch=useRouteMatch,exports.withRouter=withRouter;
	//# sourceMappingURL=react-router.min.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1453 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	if (true) {
	  module.exports = __webpack_require__(1452);
	} else {
	  module.exports = require("./cjs/react-router.js");
	}


/***/ },
/* 1454 */
1303,
/* 1455 */
[1664, 1454],
/* 1456 */
/***/ function(module, exports, __webpack_require__) {

	// @remove-on-eject-begin
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	// @remove-on-eject-end
	'use strict';
	
	if (typeof Promise === 'undefined') {
	  // Rejection tracking prevents a common issue where React gets into an
	  // inconsistent state due to an error, but it gets swallowed by a Promise,
	  // and the user has no idea what causes React's erratic future behavior.
	  __webpack_require__(1458).enable();
	  window.Promise = __webpack_require__(1457);
	}
	
	// fetch() polyfill for making API calls.
	__webpack_require__(1661);
	
	// Object.assign() is commonly used with React.
	// It will use the native implementation if it's present and isn't buggy.
	Object.assign = __webpack_require__(58);


/***/ },
/* 1457 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	//This file contains the ES6 extensions to the core Promises/A+ API
	
	var Promise = __webpack_require__(632);
	
	module.exports = Promise;
	
	/* Static Functions */
	
	var TRUE = valuePromise(true);
	var FALSE = valuePromise(false);
	var NULL = valuePromise(null);
	var UNDEFINED = valuePromise(undefined);
	var ZERO = valuePromise(0);
	var EMPTYSTRING = valuePromise('');
	
	function valuePromise(value) {
	  var p = new Promise(Promise._61);
	  p._81 = 1;
	  p._65 = value;
	  return p;
	}
	Promise.resolve = function (value) {
	  if (value instanceof Promise) return value;
	
	  if (value === null) return NULL;
	  if (value === undefined) return UNDEFINED;
	  if (value === true) return TRUE;
	  if (value === false) return FALSE;
	  if (value === 0) return ZERO;
	  if (value === '') return EMPTYSTRING;
	
	  if (typeof value === 'object' || typeof value === 'function') {
	    try {
	      var then = value.then;
	      if (typeof then === 'function') {
	        return new Promise(then.bind(value));
	      }
	    } catch (ex) {
	      return new Promise(function (resolve, reject) {
	        reject(ex);
	      });
	    }
	  }
	  return valuePromise(value);
	};
	
	Promise.all = function (arr) {
	  var args = Array.prototype.slice.call(arr);
	
	  return new Promise(function (resolve, reject) {
	    if (args.length === 0) return resolve([]);
	    var remaining = args.length;
	    function res(i, val) {
	      if (val && (typeof val === 'object' || typeof val === 'function')) {
	        if (val instanceof Promise && val.then === Promise.prototype.then) {
	          while (val._81 === 3) {
	            val = val._65;
	          }
	          if (val._81 === 1) return res(i, val._65);
	          if (val._81 === 2) reject(val._65);
	          val.then(function (val) {
	            res(i, val);
	          }, reject);
	          return;
	        } else {
	          var then = val.then;
	          if (typeof then === 'function') {
	            var p = new Promise(then.bind(val));
	            p.then(function (val) {
	              res(i, val);
	            }, reject);
	            return;
	          }
	        }
	      }
	      args[i] = val;
	      if (--remaining === 0) {
	        resolve(args);
	      }
	    }
	    for (var i = 0; i < args.length; i++) {
	      res(i, args[i]);
	    }
	  });
	};
	
	Promise.reject = function (value) {
	  return new Promise(function (resolve, reject) {
	    reject(value);
	  });
	};
	
	Promise.race = function (values) {
	  return new Promise(function (resolve, reject) {
	    values.forEach(function(value){
	      Promise.resolve(value).then(resolve, reject);
	    });
	  });
	};
	
	/* Prototype Methods */
	
	Promise.prototype['catch'] = function (onRejected) {
	  return this.then(null, onRejected);
	};


/***/ },
/* 1458 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Promise = __webpack_require__(632);
	
	var DEFAULT_WHITELIST = [
	  ReferenceError,
	  TypeError,
	  RangeError
	];
	
	var enabled = false;
	exports.disable = disable;
	function disable() {
	  enabled = false;
	  Promise._10 = null;
	  Promise._97 = null;
	}
	
	exports.enable = enable;
	function enable(options) {
	  options = options || {};
	  if (enabled) disable();
	  enabled = true;
	  var id = 0;
	  var displayId = 0;
	  var rejections = {};
	  Promise._10 = function (promise) {
	    if (
	      promise._81 === 2 && // IS REJECTED
	      rejections[promise._72]
	    ) {
	      if (rejections[promise._72].logged) {
	        onHandled(promise._72);
	      } else {
	        clearTimeout(rejections[promise._72].timeout);
	      }
	      delete rejections[promise._72];
	    }
	  };
	  Promise._97 = function (promise, err) {
	    if (promise._45 === 0) { // not yet handled
	      promise._72 = id++;
	      rejections[promise._72] = {
	        displayId: null,
	        error: err,
	        timeout: setTimeout(
	          onUnhandled.bind(null, promise._72),
	          // For reference errors and type errors, this almost always
	          // means the programmer made a mistake, so log them after just
	          // 100ms
	          // otherwise, wait 2 seconds to see if they get handled
	          matchWhitelist(err, DEFAULT_WHITELIST)
	            ? 100
	            : 2000
	        ),
	        logged: false
	      };
	    }
	  };
	  function onUnhandled(id) {
	    if (
	      options.allRejections ||
	      matchWhitelist(
	        rejections[id].error,
	        options.whitelist || DEFAULT_WHITELIST
	      )
	    ) {
	      rejections[id].displayId = displayId++;
	      if (options.onUnhandled) {
	        rejections[id].logged = true;
	        options.onUnhandled(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      } else {
	        rejections[id].logged = true;
	        logError(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      }
	    }
	  }
	  function onHandled(id) {
	    if (rejections[id].logged) {
	      if (options.onHandled) {
	        options.onHandled(rejections[id].displayId, rejections[id].error);
	      } else if (!rejections[id].onUnhandled) {
	        console.warn(
	          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
	        );
	        console.warn(
	          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
	          rejections[id].displayId + '.'
	        );
	      }
	    }
	  }
	}
	
	function logError(id, error) {
	  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
	  var errStr = (error && (error.stack || error)) + '';
	  errStr.split('\n').forEach(function (line) {
	    console.warn('  ' + line);
	  });
	}
	
	function matchWhitelist(error, list) {
	  return list.some(function (cls) {
	    return error instanceof cls;
	  });
	}

/***/ },
/* 1459 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __importDefault = (this && this.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var createIcon_1 = __importDefault(__webpack_require__(45));
	var EmailIcon = (0, createIcon_1.default)({
	    color: '#7f7f7f',
	    networkName: 'email',
	    path: 'M17,22v20h30V22H17z M41.1,25L32,32.1L22.9,25H41.1z M20,39V26.6l12,9.3l12-9.3V39H20z',
	});
	exports.default = EmailIcon;


/***/ },
/* 1460 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __importDefault = (this && this.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var objectToGetParams_1 = __importDefault(__webpack_require__(38));
	var createShareButton_1 = __importDefault(__webpack_require__(46));
	function emailLink(url, _a) {
	    var subject = _a.subject, body = _a.body, separator = _a.separator;
	    return 'mailto:' + (0, objectToGetParams_1.default)({ subject: subject, body: body ? body + separator + url : url });
	}
	var EmailShareButton = (0, createShareButton_1.default)('email', emailLink, function (props) { return ({
	    subject: props.subject,
	    body: props.body,
	    separator: props.separator || ' ',
	}); }, {
	    openShareDialogOnClick: false,
	    onClick: function (_, link) {
	        window.location.href = link;
	    },
	});
	exports.default = EmailShareButton;


/***/ },
/* 1461 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __importDefault = (this && this.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var createIcon_1 = __importDefault(__webpack_require__(45));
	var FacebookIcon = (0, createIcon_1.default)({
	    color: '#3b5998',
	    networkName: 'facebook',
	    path: 'M34.1,47V33.3h4.6l0.7-5.3h-5.3v-3.4c0-1.5,0.4-2.6,2.6-2.6l2.8,0v-4.8c-0.5-0.1-2.2-0.2-4.1-0.2 c-4.1,0-6.9,2.5-6.9,7V28H24v5.3h4.6V47H34.1z',
	});
	exports.default = FacebookIcon;


/***/ },
/* 1462 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __importDefault = (this && this.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var createIcon_1 = __importDefault(__webpack_require__(45));
	var FacebookMessengerIcon = (0, createIcon_1.default)({
	    color: '#2196F3',
	    networkName: 'facebookmessenger',
	    path: 'M 53.066406 21.871094 C 52.667969 21.339844 51.941406 21.179688 51.359375 21.496094 L 37.492188 29.058594 L 28.867188 21.660156 C 28.339844 21.207031 27.550781 21.238281 27.054688 21.730469 L 11.058594 37.726562 C 10.539062 38.25 10.542969 39.09375 11.0625 39.613281 C 11.480469 40.027344 12.121094 40.121094 12.640625 39.839844 L 26.503906 32.28125 L 35.136719 39.679688 C 35.667969 40.132812 36.457031 40.101562 36.949219 39.609375 L 52.949219 23.613281 C 53.414062 23.140625 53.464844 22.398438 53.066406 21.871094 Z M 53.066406 21.871094',
	});
	exports.default = FacebookMessengerIcon;


/***/ },
/* 1463 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __importDefault = (this && this.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var objectToGetParams_1 = __importDefault(__webpack_require__(38));
	var createShareButton_1 = __importDefault(__webpack_require__(46));
	function facebookMessengerLink(url, _a) {
	    var appId = _a.appId, redirectUri = _a.redirectUri, to = _a.to;
	    return ('https://www.facebook.com/dialog/send' +
	        (0, objectToGetParams_1.default)({
	            link: url,
	            redirect_uri: redirectUri || url,
	            app_id: appId,
	            to: to,
	        }));
	}
	var FacebookMessengerShareButton = (0, createShareButton_1.default)('facebookmessenger', facebookMessengerLink, function (props) { return ({
	    appId: props.appId,
	    redirectUri: props.redirectUri,
	    to: props.to,
	}); }, {
	    windowWidth: 1000,
	    windowHeight: 820,
	});
	exports.default = FacebookMessengerShareButton;


/***/ },
/* 1464 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __importDefault = (this && this.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var assert_1 = __importDefault(__webpack_require__(49));
	var objectToGetParams_1 = __importDefault(__webpack_require__(38));
	var createShareButton_1 = __importDefault(__webpack_require__(46));
	function facebookLink(url, _a) {
	    var quote = _a.quote, hashtag = _a.hashtag;
	    (0, assert_1.default)(url, 'facebook.url');
	    return ('https://www.facebook.com/sharer/sharer.php' +
	        (0, objectToGetParams_1.default)({
	            u: url,
	            quote: quote,
	            hashtag: hashtag,
	        }));
	}
	var FacebookShareButton = (0, createShareButton_1.default)('facebook', facebookLink, function (props) { return ({
	    quote: props.quote,
	    hashtag: props.hashtag,
	}); }, {
	    windowWidth: 550,
	    windowHeight: 400,
	});
	exports.default = FacebookShareButton;


/***/ },
/* 1465 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __importDefault = (this && this.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var jsonp_1 = __importDefault(__webpack_require__(109));
	var createShareCount_1 = __importDefault(__webpack_require__(115));
	function getFacebookShareCount(shareUrl, callback) {
	    var endpoint = "https://graph.facebook.com/?id=".concat(shareUrl, "&fields=og_object{engagement}");
	    (0, jsonp_1.default)(endpoint, function (err, data) {
	        callback(!err && data && data.og_object && data.og_object.engagement
	            ? data.og_object.engagement.count
	            : undefined);
	    });
	}
	exports.default = (0, createShareCount_1.default)(getFacebookShareCount);


/***/ },
/* 1466 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __importDefault = (this && this.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var createIcon_1 = __importDefault(__webpack_require__(45));
	var HatenaIcon = (0, createIcon_1.default)({
	    color: '#009ad9',
	    networkName: 'hatena',
	    path: 'M 36.164062 33.554688 C 34.988281 32.234375 33.347656 31.5 31.253906 31.34375 C 33.125 30.835938 34.476562 30.09375 35.335938 29.09375 C 36.191406 28.09375 36.609375 26.78125 36.609375 25.101562 C 36.628906 23.875 36.332031 22.660156 35.75 21.578125 C 35.160156 20.558594 34.292969 19.71875 33.253906 19.160156 C 32.304688 18.640625 31.175781 18.265625 29.847656 18.042969 C 28.523438 17.824219 26.195312 17.730469 22.867188 17.730469 L 14.769531 17.730469 L 14.769531 47.269531 L 23.113281 47.269531 C 26.46875 47.269531 28.886719 47.15625 30.367188 46.929688 C 31.851562 46.695312 33.085938 46.304688 34.085938 45.773438 C 35.289062 45.148438 36.28125 44.179688 36.933594 42.992188 C 37.597656 41.796875 37.933594 40.402344 37.933594 38.816406 C 37.933594 36.621094 37.347656 34.867188 36.164062 33.554688 Z M 22.257812 24.269531 L 23.984375 24.269531 C 25.988281 24.269531 27.332031 24.496094 28.015625 24.945312 C 28.703125 25.402344 29.042969 26.183594 29.042969 27.285156 C 29.042969 28.390625 28.664062 29.105469 27.9375 29.550781 C 27.210938 29.992188 25.84375 30.199219 23.855469 30.199219 L 22.257812 30.199219 Z M 29.121094 41.210938 C 28.328125 41.691406 26.976562 41.925781 25.078125 41.925781 L 22.257812 41.925781 L 22.257812 35.488281 L 25.195312 35.488281 C 27.144531 35.488281 28.496094 35.738281 29.210938 36.230469 C 29.925781 36.726562 30.304688 37.582031 30.304688 38.832031 C 30.304688 40.078125 29.914062 40.742188 29.105469 41.222656 Z M 29.121094 41.210938 M 46.488281 39.792969 C 44.421875 39.792969 42.742188 41.46875 42.742188 43.535156 C 42.742188 45.605469 44.421875 47.28125 46.488281 47.28125 C 48.554688 47.28125 50.230469 45.605469 50.230469 43.535156 C 50.230469 41.46875 48.554688 39.792969 46.488281 39.792969 Z M 46.488281 39.792969 M 43.238281 17.730469 L 49.738281 17.730469 L 49.738281 37.429688 L 43.238281 37.429688 Z M 43.238281 17.730469 ',
	});
	exports.default = HatenaIcon;


/***/ },
/* 1467 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __importDefault = (this && this.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var assert_1 = __importDefault(__webpack_require__(49));
	var createShareButton_1 = __importDefault(__webpack_require__(46));
	function hatenaLink(url, _a) {
	    var title = _a.title;
	    (0, assert_1.default)(url, 'hatena.url');
	    return "http://b.hatena.ne.jp/add?mode=confirm&url=".concat(url, "&title=").concat(title);
	}
	var HatenaShareButton = (0, createShareButton_1.default)('hatena', hatenaLink, function (props) { return ({
	    title: props.title,
	}); }, {
	    windowWidth: 660,
	    windowHeight: 460,
	    windowPosition: 'windowCenter',
	});
	exports.default = HatenaShareButton;


/***/ },
/* 1468 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __importDefault = (this && this.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var jsonp_1 = __importDefault(__webpack_require__(109));
	var objectToGetParams_1 = __importDefault(__webpack_require__(38));
	var createShareCount_1 = __importDefault(__webpack_require__(115));
	function getHatenaShareCount(shareUrl, callback) {
	    var url = 'https://bookmark.hatenaapis.com/count/entry';
	    (0, jsonp_1.default)(url +
	        (0, objectToGetParams_1.default)({
	            url: shareUrl,
	        }), function (err, data) {
	        callback(data ? data : undefined);
	    });
	}
	exports.default = (0, createShareCount_1.default)(getHatenaShareCount);


/***/ },
/* 1469 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __importDefault = (this && this.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var createIcon_1 = __importDefault(__webpack_require__(45));
	var InstapaperIcon = (0, createIcon_1.default)({
	    color: '#1F1F1F',
	    networkName: 'instapaper',
	    path: 'M35.688 43.012c0 2.425.361 2.785 3.912 3.056V48H24.401v-1.932c3.555-.27 3.912-.63 3.912-3.056V20.944c0-2.379-.36-2.785-3.912-3.056V16H39.6v1.888c-3.55.27-3.912.675-3.912 3.056v22.068h.001z',
	});
	exports.default = InstapaperIcon;


/***/ },
/* 1470 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __importDefault = (this && this.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var assert_1 = __importDefault(__webpack_require__(49));
	var createShareButton_1 = __importDefault(__webpack_require__(46));
	var objectToGetParams_1 = __importDefault(__webpack_require__(38));
	function instapaperLink(url, _a) {
	    var title = _a.title, description = _a.description;
	    (0, assert_1.default)(url, 'instapaper.url');
	    return ('http://www.instapaper.com/hello2' +
	        (0, objectToGetParams_1.default)({
	            url: url,
	            title: title,
	            description: description,
	        }));
	}
	var InstapaperShareButton = (0, createShareButton_1.default)('instapaper', instapaperLink, function (props) { return ({
	    title: props.title,
	    description: props.description,
	}); }, {
	    windowWidth: 500,
	    windowHeight: 500,
	    windowPosition: 'windowCenter',
	});
	exports.default = InstapaperShareButton;


/***/ },
/* 1471 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __importDefault = (this && this.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var createIcon_1 = __importDefault(__webpack_require__(45));
	var LineIcon = (0, createIcon_1.default)({
	    color: '#00b800',
	    networkName: 'line',
	    path: 'M52.62 30.138c0 3.693-1.432 7.019-4.42 10.296h.001c-4.326 4.979-14 11.044-16.201 11.972-2.2.927-1.876-.591-1.786-1.112l.294-1.765c.069-.527.142-1.343-.066-1.865-.232-.574-1.146-.872-1.817-1.016-9.909-1.31-17.245-8.238-17.245-16.51 0-9.226 9.251-16.733 20.62-16.733 11.37 0 20.62 7.507 20.62 16.733zM27.81 25.68h-1.446a.402.402 0 0 0-.402.401v8.985c0 .221.18.4.402.4h1.446a.401.401 0 0 0 .402-.4v-8.985a.402.402 0 0 0-.402-.401zm9.956 0H36.32a.402.402 0 0 0-.402.401v5.338L31.8 25.858a.39.39 0 0 0-.031-.04l-.002-.003-.024-.025-.008-.007a.313.313 0 0 0-.032-.026.255.255 0 0 1-.021-.014l-.012-.007-.021-.012-.013-.006-.023-.01-.013-.005-.024-.008-.014-.003-.023-.005-.017-.002-.021-.003-.021-.002h-1.46a.402.402 0 0 0-.402.401v8.985c0 .221.18.4.402.4h1.446a.401.401 0 0 0 .402-.4v-5.337l4.123 5.568c.028.04.063.072.101.099l.004.003a.236.236 0 0 0 .025.015l.012.006.019.01a.154.154 0 0 1 .019.008l.012.004.028.01.005.001a.442.442 0 0 0 .104.013h1.446a.4.4 0 0 0 .401-.4v-8.985a.402.402 0 0 0-.401-.401zm-13.442 7.537h-3.93v-7.136a.401.401 0 0 0-.401-.401h-1.447a.4.4 0 0 0-.401.401v8.984a.392.392 0 0 0 .123.29c.072.068.17.111.278.111h5.778a.4.4 0 0 0 .401-.401v-1.447a.401.401 0 0 0-.401-.401zm21.429-5.287c.222 0 .401-.18.401-.402v-1.446a.401.401 0 0 0-.401-.402h-5.778a.398.398 0 0 0-.279.113l-.005.004-.006.008a.397.397 0 0 0-.111.276v8.984c0 .108.043.206.112.278l.005.006a.401.401 0 0 0 .284.117h5.778a.4.4 0 0 0 .401-.401v-1.447a.401.401 0 0 0-.401-.401h-3.93v-1.519h3.93c.222 0 .401-.18.401-.402V29.85a.401.401 0 0 0-.401-.402h-3.93V27.93h3.93z',
	});
	exports.default = LineIcon;


/***/ },
/* 1472 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __importDefault = (this && this.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var assert_1 = __importDefault(__webpack_require__(49));
	var createShareButton_1 = __importDefault(__webpack_require__(46));
	var objectToGetParams_1 = __importDefault(__webpack_require__(38));
	function lineLink(url, _a) {
	    var title = _a.title;
	    (0, assert_1.default)(url, 'line.url');
	    return ('https://social-plugins.line.me/lineit/share' +
	        (0, objectToGetParams_1.default)({
	            url: url,
	            text: title,
	        }));
	}
	var LineShareButton = (0, createShareButton_1.default)('line', lineLink, function (props) { return ({
	    title: props.title,
	}); }, {
	    windowWidth: 500,
	    windowHeight: 500,
	});
	exports.default = LineShareButton;


/***/ },
/* 1473 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __importDefault = (this && this.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var createIcon_1 = __importDefault(__webpack_require__(45));
	var LinkedinIcon = (0, createIcon_1.default)({
	    color: '#007fb1',
	    networkName: 'linkedin',
	    path: 'M20.4,44h5.4V26.6h-5.4V44z M23.1,18c-1.7,0-3.1,1.4-3.1,3.1c0,1.7,1.4,3.1,3.1,3.1 c1.7,0,3.1-1.4,3.1-3.1C26.2,19.4,24.8,18,23.1,18z M39.5,26.2c-2.6,0-4.4,1.4-5.1,2.8h-0.1v-2.4h-5.2V44h5.4v-8.6 c0-2.3,0.4-4.5,3.2-4.5c2.8,0,2.8,2.6,2.8,4.6V44H46v-9.5C46,29.8,45,26.2,39.5,26.2z',
	});
	exports.default = LinkedinIcon;


/***/ },
/* 1474 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __importDefault = (this && this.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var assert_1 = __importDefault(__webpack_require__(49));
	var objectToGetParams_1 = __importDefault(__webpack_require__(38));
	var createShareButton_1 = __importDefault(__webpack_require__(46));
	function linkedinLink(url, _a) {
	    var title = _a.title, summary = _a.summary, source = _a.source;
	    (0, assert_1.default)(url, 'linkedin.url');
	    return ('https://linkedin.com/shareArticle' +
	        (0, objectToGetParams_1.default)({ url: url, mini: 'true', title: title, summary: summary, source: source }));
	}
	var LinkedinShareButton = (0, createShareButton_1.default)('linkedin', linkedinLink, function (_a) {
	    var title = _a.title, summary = _a.summary, source = _a.source;
	    return ({ title: title, summary: summary, source: source });
	}, {
	    windowWidth: 750,
	    windowHeight: 600,
	});
	exports.default = LinkedinShareButton;


/***/ },
/* 1475 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __importDefault = (this && this.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var createIcon_1 = __importDefault(__webpack_require__(45));
	var LivejournalIcon = (0, createIcon_1.default)({
	    color: '#21A5D8',
	    networkName: 'livejournal',
	    path: 'M18.3407821,28.1764706 L21.9441341,31.789916 L33.0055865,42.882353 C33.0055865,42.882353 33.0893855,42.9663866 33.0893855,42.9663866 L46.6648046,47 C46.6648046,47 46.6648046,47 46.7486034,47 C46.8324022,47 46.8324022,47 46.9162012,46.9159664 C47,46.8319327 47,46.8319327 47,46.7478991 L42.9776536,33.1344537 C42.9776536,33.1344537 42.9776536,33.1344537 42.8938548,33.0504202 L31.1620111,21.3697479 L31.1620111,21.3697479 L28.1452514,18.2605042 C27.3072626,17.4201681 26.5530726,17 25.7150838,17 C24.2905028,17 23.0335195,18.3445378 21.5251397,19.8571429 C21.273743,20.1092437 20.9385475,20.4453781 20.6871508,20.697479 C20.3519553,21.0336134 20.1005586,21.2857143 19.849162,21.5378151 C18.3407821,22.9663866 17.0837989,24.2268908 17,25.7394958 C17.0837989,26.4957983 17.5027933,27.3361345 18.3407821,28.1764706 Z M39.9012319,39.6134454 C39.7336341,39.4453781 39.4822374,37.6806724 40.2364275,36.8403362 C40.9906174,36.0840337 41.6610084,36 42.1638017,36 C42.3313995,36 42.4989973,36 42.5827961,36 L44.8453659,43.5630253 L43.5883828,44.8235295 L36.0464833,42.5546218 C35.9626843,42.2184874 35.8788855,41.2100841 36.8844722,40.2016807 C37.2196676,39.8655463 37.8900587,39.6134454 38.5604498,39.6134454 C39.147042,39.6134454 39.5660364,39.7815126 39.5660364,39.7815126 C39.6498353,39.8655463 39.8174331,39.8655463 39.8174331,39.7815126 C39.9850307,39.7815126 39.9850307,39.697479 39.9012319,39.6134454 Z',
	});
	exports.default = LivejournalIcon;


/***/ },
/* 1476 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __importDefault = (this && this.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var assert_1 = __importDefault(__webpack_require__(49));
	var objectToGetParams_1 = __importDefault(__webpack_require__(38));
	var createShareButton_1 = __importDefault(__webpack_require__(46));
	function livejournalLink(url, _a) {
	    var title = _a.title, description = _a.description;
	    (0, assert_1.default)(url, 'livejournal.url');
	    return ('https://www.livejournal.com/update.bml' +
	        (0, objectToGetParams_1.default)({
	            subject: title,
	            event: description,
	        }));
	}
	var LivejournalShareButton = (0, createShareButton_1.default)('livejournal', livejournalLink, function (props) { return ({
	    title: props.title,
	    description: props.description,
	}); }, {
	    windowWidth: 660,
	    windowHeight: 460,
	});
	exports.default = LivejournalShareButton;


/***/ },
/* 1477 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __importDefault = (this && this.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var createIcon_1 = __importDefault(__webpack_require__(45));
	var MailruIcon = (0, createIcon_1.default)({
	    color: '#168DE2',
	    networkName: 'mailru',
	    path: 'M39.7107745,17 C41.6619755,17 43.3204965,18.732852 43.3204965,21.0072202 C43.3204965,23.2815885 41.7595357,25.0144404 39.7107745,25.0144404 C37.7595732,25.0144404 36.1010522,23.2815885 36.1010522,21.0072202 C36.1010522,18.732852 37.7595732,17 39.7107745,17 Z M24.3938451,17 C26.3450463,17 28.0035672,18.732852 28.0035672,21.0072202 C28.0035672,23.2815885 26.4426063,25.0144404 24.3938451,25.0144404 C22.4426439,25.0144404 20.7841229,23.2815885 20.7841229,21.0072202 C20.7841229,18.732852 22.4426439,17 24.3938451,17 Z M51.9057817,43.4259928 C51.7106617,44.0758123 51.4179815,44.6173285 50.9301812,44.9422383 C50.637501,45.1588448 50.2472607,45.267148 49.8570205,45.267148 C49.07654,45.267148 48.3936197,44.833935 48.0033795,44.0758123 L46.2472985,40.7184115 L45.759498,41.2599278 C42.5400162,44.9422383 37.466893,47 32.0035297,47 C26.5401664,47 21.5646034,44.9422383 18.2475614,41.2599278 L17.7597611,40.7184115 L16.00368,44.0758123 C15.6134398,44.833935 14.9305194,45.267148 14.1500389,45.267148 C13.7597986,45.267148 13.3695584,45.1588448 13.0768782,44.9422383 C12.0037176,44.2924187 11.7110374,42.7761733 12.2963978,41.5848375 L16.7841605,33.0288807 C17.1744007,32.270758 17.8573211,31.8375453 18.6378016,31.8375453 C19.0280418,31.8375453 19.4182821,31.9458485 19.7109623,32.1624548 C20.7841229,32.8122743 21.0768031,34.3285197 20.4914427,35.5198555 L20.1012025,36.2779783 L20.2963226,36.602888 C22.4426439,39.9602888 27.0279667,42.234657 31.9059697,42.234657 C36.7839727,42.234657 41.3692955,40.068592 43.5156167,36.602888 L43.7107367,36.2779783 L43.3204965,35.6281587 C43.0278165,35.0866425 42.9302562,34.436823 43.1253765,33.7870035 C43.3204965,33.137184 43.6131767,32.5956678 44.100977,32.270758 C44.3936572,32.0541515 44.7838975,31.9458485 45.1741377,31.9458485 C45.9546182,31.9458485 46.6375385,32.3790613 47.0277787,33.137184 L51.5155415,41.6931408 C52.003342,42.234657 52.100902,42.8844765 51.9057817,43.4259928 Z',
	});
	exports.default = MailruIcon;


/***/ },
/* 1478 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __importDefault = (this && this.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var assert_1 = __importDefault(__webpack_require__(49));
	var objectToGetParams_1 = __importDefault(__webpack_require__(38));
	var createShareButton_1 = __importDefault(__webpack_require__(46));
	function mailruLink(url, _a) {
	    var title = _a.title, description = _a.description, imageUrl = _a.imageUrl;
	    (0, assert_1.default)(url, 'mailru.url');
	    return ('https://connect.mail.ru/share' +
	        (0, objectToGetParams_1.default)({
	            url: url,
	            title: title,
	            description: description,
	            image_url: imageUrl,
	        }));
	}
	var MailruShareButton = (0, createShareButton_1.default)('mailru', mailruLink, function (props) { return ({
	    title: props.title,
	    description: props.description,
	    imageUrl: props.imageUrl,
	}); }, {
	    windowWidth: 660,
	    windowHeight: 460,
	});
	exports.default = MailruShareButton;


/***/ },
/* 1479 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __importDefault = (this && this.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var createIcon_1 = __importDefault(__webpack_require__(45));
	var OKIcon = (0, createIcon_1.default)({
	    color: '#f2720c',
	    networkName: 'ok',
	    path: 'M39,30c-1,0-3,2-7,2s-6-2-7-2c-1.1,0-2,0.9-2,2c0,1,0.6,1.5,1,1.7c1.2,0.7,5,2.3,5,2.3l-4.3,5.4   c0,0-0.8,0.9-0.8,1.6c0,1.1,0.9,2,2,2c1,0,1.5-0.7,1.5-0.7S32,39,32,39c0,0,4.5,5.3,4.5,5.3S37,45,38,45c1.1,0,2-0.9,2-2   c0-0.6-0.8-1.6-0.8-1.6L35,36c0,0,3.8-1.6,5-2.3c0.4-0.3,1-0.7,1-1.7C41,30.9,40.1,30,39,30z M32,15c-3.9,0-7,3.1-7,7s3.1,7,7,7c3.9,0,7-3.1,7-7S35.9,15,32,15z M32,25.5   c-1.9,0-3.5-1.6-3.5-3.5c0-1.9,1.6-3.5,3.5-3.5c1.9,0,3.5,1.6,3.5,3.5C35.5,23.9,33.9,22.5,35,22.5z ',
	});
	exports.default = OKIcon;


/***/ },
/* 1480 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __importDefault = (this && this.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var assert_1 = __importDefault(__webpack_require__(49));
	var objectToGetParams_1 = __importDefault(__webpack_require__(38));
	var createShareButton_1 = __importDefault(__webpack_require__(46));
	function okLink(url, _a) {
	    var title = _a.title, description = _a.description, image = _a.image;
	    (0, assert_1.default)(url, 'ok.url');
	    return ('https://connect.ok.ru/offer' +
	        (0, objectToGetParams_1.default)({
	            url: url,
	            title: title,
	            description: description,
	            imageUrl: image,
	        }));
	}
	var OKShareButton = (0, createShareButton_1.default)('ok', okLink, function (props) { return ({
	    title: props.title,
	    description: props.description,
	    image: props.image,
	}); }, {
	    windowWidth: 588,
	    windowHeight: 480,
	    windowPosition: 'screenCenter',
	});
	exports.default = OKShareButton;


/***/ },
/* 1481 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __importDefault = (this && this.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var jsonp_1 = __importDefault(__webpack_require__(109));
	var objectToGetParams_1 = __importDefault(__webpack_require__(38));
	var createShareCount_1 = __importDefault(__webpack_require__(115));
	function getOKShareCount(shareUrl, callback) {
	    if (!window.OK) {
	        window.OK = {
	            Share: {
	                count: function count(index, _count) {
	                    window.OK.callbacks[index](_count);
	                },
	            },
	            callbacks: [],
	        };
	    }
	    var url = 'https://connect.ok.ru/dk';
	    var index = window.OK.callbacks.length;
	    window.ODKL = {
	        updateCount: function (index, count) {
	            var callbackIndex = index === '' ? 0 : parseInt(index.replace('react-share-', ''), 10);
	            window.OK.callbacks[callbackIndex](count === '' ? undefined : parseInt(count, 10));
	        },
	    };
	    window.OK.callbacks.push(callback);
	    return (0, jsonp_1.default)(url +
	        (0, objectToGetParams_1.default)({
	            'st.cmd': 'extLike',
	            uid: "react-share-".concat(index),
	            ref: shareUrl,
	        }));
	}
	exports.default = (0, createShareCount_1.default)(getOKShareCount);


/***/ },
/* 1482 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __importDefault = (this && this.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var createIcon_1 = __importDefault(__webpack_require__(45));
	var PinterestIcon = (0, createIcon_1.default)({
	    color: '#cb2128',
	    networkName: 'pinterest',
	    path: 'M32,16c-8.8,0-16,7.2-16,16c0,6.6,3.9,12.2,9.6,14.7c0-1.1,0-2.5,0.3-3.7 c0.3-1.3,2.1-8.7,2.1-8.7s-0.5-1-0.5-2.5c0-2.4,1.4-4.1,3.1-4.1c1.5,0,2.2,1.1,2.2,2.4c0,1.5-0.9,3.7-1.4,5.7 c-0.4,1.7,0.9,3.1,2.5,3.1c3,0,5.1-3.9,5.1-8.5c0-3.5-2.4-6.1-6.7-6.1c-4.9,0-7.9,3.6-7.9,7.7c0,1.4,0.4,2.4,1.1,3.1 c0.3,0.3,0.3,0.5,0.2,0.9c-0.1,0.3-0.3,1-0.3,1.3c-0.1,0.4-0.4,0.6-0.8,0.4c-2.2-0.9-3.3-3.4-3.3-6.1c0-4.5,3.8-10,11.4-10 c6.1,0,10.1,4.4,10.1,9.2c0,6.3-3.5,11-8.6,11c-1.7,0-3.4-0.9-3.9-2c0,0-0.9,3.7-1.1,4.4c-0.3,1.2-1,2.5-1.6,3.4 c1.4,0.4,3,0.7,4.5,0.7c8.8,0,16-7.2,16-16C48,23.2,40.8,16,32,16z',
	});
	exports.default = PinterestIcon;


/***/ },
/* 1483 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __importDefault = (this && this.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var assert_1 = __importDefault(__webpack_require__(49));
	var objectToGetParams_1 = __importDefault(__webpack_require__(38));
	var createShareButton_1 = __importDefault(__webpack_require__(46));
	function pinterestLink(url, _a) {
	    var media = _a.media, description = _a.description;
	    (0, assert_1.default)(url, 'pinterest.url');
	    (0, assert_1.default)(media, 'pinterest.media');
	    return ('https://pinterest.com/pin/create/button/' +
	        (0, objectToGetParams_1.default)({
	            url: url,
	            media: media,
	            description: description,
	        }));
	}
	var PinterestShareButton = (0, createShareButton_1.default)('pinterest', pinterestLink, function (props) { return ({
	    media: props.media,
	    description: props.description,
	}); }, {
	    windowWidth: 1000,
	    windowHeight: 730,
	});
	exports.default = PinterestShareButton;


/***/ },
/* 1484 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __importDefault = (this && this.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var jsonp_1 = __importDefault(__webpack_require__(109));
	var objectToGetParams_1 = __importDefault(__webpack_require__(38));
	var createShareCount_1 = __importDefault(__webpack_require__(115));
	function getPinterestShareCount(shareUrl, callback) {
	    var url = 'https://api.pinterest.com/v1/urls/count.json';
	    (0, jsonp_1.default)(url +
	        (0, objectToGetParams_1.default)({
	            url: shareUrl,
	        }), function (err, data) {
	        callback(data ? data.count : undefined);
	    });
	}
	exports.default = (0, createShareCount_1.default)(getPinterestShareCount);


/***/ },
/* 1485 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __importDefault = (this && this.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var createIcon_1 = __importDefault(__webpack_require__(45));
	var PocketIcon = (0, createIcon_1.default)({
	    color: '#EF3F56',
	    networkName: 'pocket',
	    path: 'M41.084 29.065l-7.528 7.882a2.104 2.104 0 0 1-1.521.666 2.106 2.106 0 0 1-1.522-.666l-7.528-7.882c-.876-.914-.902-2.43-.065-3.384.84-.955 2.228-.987 3.1-.072l6.015 6.286 6.022-6.286c.88-.918 2.263-.883 3.102.071.841.938.82 2.465-.06 3.383l-.015.002zm6.777-10.976C47.463 16.84 46.361 16 45.14 16H18.905c-1.2 0-2.289.82-2.716 2.044-.125.363-.189.743-.189 1.125v10.539l.112 2.096c.464 4.766 2.73 8.933 6.243 11.838.06.053.125.102.19.153l.04.033c1.882 1.499 3.986 2.514 6.259 3.014a14.662 14.662 0 0 0 6.13.052c.118-.042.235-.065.353-.087.03 0 .065-.022.098-.042a15.395 15.395 0 0 0 6.011-2.945l.039-.045.18-.153c3.502-2.902 5.765-7.072 6.248-11.852L48 29.674v-10.52c0-.366-.041-.728-.161-1.08l.022.015z',
	});
	exports.default = PocketIcon;


/***/ },
/* 1486 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __importDefault = (this && this.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var assert_1 = __importDefault(__webpack_require__(49));
	var createShareButton_1 = __importDefault(__webpack_require__(46));
	var objectToGetParams_1 = __importDefault(__webpack_require__(38));
	function pocketLink(url, _a) {
	    var title = _a.title;
	    (0, assert_1.default)(url, 'pocket.url');
	    return ('https://getpocket.com/save' +
	        (0, objectToGetParams_1.default)({
	            url: url,
	            title: title,
	        }));
	}
	var PocketShareButton = (0, createShareButton_1.default)('pocket', pocketLink, function (props) { return ({
	    title: props.title,
	}); }, {
	    windowWidth: 500,
	    windowHeight: 500,
	});
	exports.default = PocketShareButton;


/***/ },
/* 1487 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __importDefault = (this && this.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var createIcon_1 = __importDefault(__webpack_require__(45));
	var RedditIcon = (0, createIcon_1.default)({
	    color: '#ff4500',
	    networkName: 'reddit',
	    path: 'm 52.8165,31.942362 c 0,-2.4803 -2.0264,-4.4965 -4.5169,-4.4965 -1.2155,0 -2.3171,0.4862 -3.128,1.2682 -3.077,-2.0247 -7.2403,-3.3133 -11.8507,-3.4782 l 2.5211,-7.9373 6.8272,1.5997 -0.0102,0.0986 c 0,2.0281 1.6575,3.6771 3.6958,3.6771 2.0366,0 3.6924,-1.649 3.6924,-3.6771 0,-2.0281 -1.6575,-3.6788 -3.6924,-3.6788 -1.564,0 -2.8968,0.9758 -3.4357,2.3443 l -7.3593,-1.7255 c -0.3213,-0.0782 -0.6477,0.1071 -0.748,0.4233 L 32,25.212062 c -4.8246,0.0578 -9.1953,1.3566 -12.41,3.4425 -0.8058,-0.7446 -1.8751,-1.2104 -3.0583,-1.2104 -2.4905,0 -4.5152,2.0179 -4.5152,4.4982 0,1.649 0.9061,3.0787 2.2389,3.8607 -0.0884,0.4794 -0.1462,0.9639 -0.1462,1.4569 0,6.6487 8.1736,12.0581 18.2223,12.0581 10.0487,0 18.224,-5.4094 18.224,-12.0581 0,-0.4658 -0.0493,-0.9248 -0.1275,-1.377 1.4144,-0.7599 2.3885,-2.2304 2.3885,-3.9406 z m -29.2808,3.0872 c 0,-1.4756 1.207,-2.6775 2.6894,-2.6775 1.4824,0 2.6877,1.2019 2.6877,2.6775 0,1.4756 -1.2053,2.6758 -2.6877,2.6758 -1.4824,0 -2.6894,-1.2002 -2.6894,-2.6758 z m 15.4037,7.9373 c -1.3549,1.3481 -3.4816,2.0043 -6.5008,2.0043 l -0.0221,-0.0051 -0.0221,0.0051 c -3.0209,0 -5.1476,-0.6562 -6.5008,-2.0043 -0.2465,-0.2448 -0.2465,-0.6443 0,-0.8891 0.2465,-0.2465 0.6477,-0.2465 0.8942,0 1.105,1.0999 2.9393,1.6337 5.6066,1.6337 l 0.0221,0.0051 0.0221,-0.0051 c 2.6673,0 4.5016,-0.5355 5.6066,-1.6354 0.2465,-0.2465 0.6477,-0.2448 0.8942,0 0.2465,0.2465 0.2465,0.6443 0,0.8908 z m -0.3213,-5.2615 c -1.4824,0 -2.6877,-1.2002 -2.6877,-2.6758 0,-1.4756 1.2053,-2.6775 2.6877,-2.6775 1.4824,0 2.6877,1.2019 2.6877,2.6775 0,1.4756 -1.2053,2.6758 -2.6877,2.6758 z',
	});
	exports.default = RedditIcon;


/***/ },
/* 1488 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __importDefault = (this && this.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var assert_1 = __importDefault(__webpack_require__(49));
	var objectToGetParams_1 = __importDefault(__webpack_require__(38));
	var createShareButton_1 = __importDefault(__webpack_require__(46));
	function redditLink(url, _a) {
	    var title = _a.title;
	    (0, assert_1.default)(url, 'reddit.url');
	    return ('https://www.reddit.com/submit' +
	        (0, objectToGetParams_1.default)({
	            url: url,
	            title: title,
	        }));
	}
	var RedditShareButton = (0, createShareButton_1.default)('reddit', redditLink, function (props) { return ({
	    title: props.title,
	}); }, {
	    windowWidth: 660,
	    windowHeight: 460,
	    windowPosition: 'windowCenter',
	});
	exports.default = RedditShareButton;


/***/ },
/* 1489 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __importDefault = (this && this.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var jsonp_1 = __importDefault(__webpack_require__(109));
	var createShareCount_1 = __importDefault(__webpack_require__(115));
	function getRedditShareCount(shareUrl, callback) {
	    var endpoint = "https://www.reddit.com/api/info.json?limit=1&url=".concat(shareUrl);
	    (0, jsonp_1.default)(endpoint, { param: 'jsonp' }, function (err, response) {
	        callback(!err &&
	            response &&
	            response.data &&
	            response.data.children.length > 0 &&
	            response.data.children[0].data.score
	            ? response.data.children[0].data.score
	            : undefined);
	    });
	}
	exports.default = (0, createShareCount_1.default)(getRedditShareCount);


/***/ },
/* 1490 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        if (typeof b !== "function" && b !== null)
	            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (this && this.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	var __generator = (this && this.__generator) || function (thisArg, body) {
	    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	    function verb(n) { return function (v) { return step([n, v]); }; }
	    function step(op) {
	        if (f) throw new TypeError("Generator is already executing.");
	        while (_) try {
	            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	            if (y = 0, t) op = [op[0] & 2, t.value];
	            switch (op[0]) {
	                case 0: case 1: t = op; break;
	                case 4: _.label++; return { value: op[1], done: false };
	                case 5: _.label++; y = op[1]; op = [0]; continue;
	                case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                default:
	                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                    if (t[2]) _.ops.pop();
	                    _.trys.pop(); continue;
	            }
	            op = body.call(thisArg, _);
	        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	    }
	};
	var __rest = (this && this.__rest) || function (s, e) {
	    var t = {};
	    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
	        t[p] = s[p];
	    if (s != null && typeof Object.getOwnPropertySymbols === "function")
	        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
	                t[p[i]] = s[p[i]];
	        }
	    return t;
	};
	var __importDefault = (this && this.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var react_1 = __importStar(__webpack_require__(1));
	var classnames_1 = __importDefault(__webpack_require__(9));
	var isPromise = function (obj) {
	    return !!obj && (typeof obj === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
	};
	var getBoxPositionOnWindowCenter = function (width, height) { return ({
	    left: window.outerWidth / 2 + (window.screenX || window.screenLeft || 0) - width / 2,
	    top: window.outerHeight / 2 + (window.screenY || window.screenTop || 0) - height / 2,
	}); };
	var getBoxPositionOnScreenCenter = function (width, height) { return ({
	    top: (window.screen.height - height) / 2,
	    left: (window.screen.width - width) / 2,
	}); };
	function windowOpen(url, _a, onClose) {
	    var height = _a.height, width = _a.width, configRest = __rest(_a, ["height", "width"]);
	    var config = __assign({ height: height, width: width, location: 'no', toolbar: 'no', status: 'no', directories: 'no', menubar: 'no', scrollbars: 'yes', resizable: 'no', centerscreen: 'yes', chrome: 'yes' }, configRest);
	    var shareDialog = window.open(url, '', Object.keys(config)
	        .map(function (key) { return "".concat(key, "=").concat(config[key]); })
	        .join(', '));
	    if (onClose) {
	        var interval_1 = window.setInterval(function () {
	            try {
	                if (shareDialog === null || shareDialog.closed) {
	                    window.clearInterval(interval_1);
	                    onClose(shareDialog);
	                }
	            }
	            catch (e) {
	                /* eslint-disable no-console */
	                console.error(e);
	                /* eslint-enable no-console */
	            }
	        }, 1000);
	    }
	    return shareDialog;
	}
	var ShareButton = /** @class */ (function (_super) {
	    __extends(ShareButton, _super);
	    function ShareButton() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.openShareDialog = function (link) {
	            var _a = _this.props, onShareWindowClose = _a.onShareWindowClose, _b = _a.windowHeight, windowHeight = _b === void 0 ? 400 : _b, _c = _a.windowPosition, windowPosition = _c === void 0 ? 'windowCenter' : _c, _d = _a.windowWidth, windowWidth = _d === void 0 ? 550 : _d;
	            var windowConfig = __assign({ height: windowHeight, width: windowWidth }, (windowPosition === 'windowCenter'
	                ? getBoxPositionOnWindowCenter(windowWidth, windowHeight)
	                : getBoxPositionOnScreenCenter(windowWidth, windowHeight)));
	            windowOpen(link, windowConfig, onShareWindowClose);
	        };
	        _this.handleClick = function (event) { return __awaiter(_this, void 0, void 0, function () {
	            var _a, beforeOnClick, disabled, networkLink, onClick, url, openShareDialogOnClick, opts, link, returnVal;
	            return __generator(this, function (_b) {
	                switch (_b.label) {
	                    case 0:
	                        _a = this.props, beforeOnClick = _a.beforeOnClick, disabled = _a.disabled, networkLink = _a.networkLink, onClick = _a.onClick, url = _a.url, openShareDialogOnClick = _a.openShareDialogOnClick, opts = _a.opts;
	                        link = networkLink(url, opts);
	                        if (disabled) {
	                            return [2 /*return*/];
	                        }
	                        event.preventDefault();
	                        if (!beforeOnClick) return [3 /*break*/, 2];
	                        returnVal = beforeOnClick();
	                        if (!isPromise(returnVal)) return [3 /*break*/, 2];
	                        return [4 /*yield*/, returnVal];
	                    case 1:
	                        _b.sent();
	                        _b.label = 2;
	                    case 2:
	                        if (openShareDialogOnClick) {
	                            this.openShareDialog(link);
	                        }
	                        if (onClick) {
	                            onClick(event, link);
	                        }
	                        return [2 /*return*/];
	                }
	            });
	        }); };
	        return _this;
	    }
	    ShareButton.prototype.render = function () {
	        var _a = this.props, beforeOnClick = _a.beforeOnClick, children = _a.children, className = _a.className, disabled = _a.disabled, disabledStyle = _a.disabledStyle, forwardedRef = _a.forwardedRef, networkLink = _a.networkLink, networkName = _a.networkName, onShareWindowClose = _a.onShareWindowClose, openShareDialogOnClick = _a.openShareDialogOnClick, opts = _a.opts, resetButtonStyle = _a.resetButtonStyle, style = _a.style, url = _a.url, windowHeight = _a.windowHeight, windowPosition = _a.windowPosition, windowWidth = _a.windowWidth, rest = __rest(_a, ["beforeOnClick", "children", "className", "disabled", "disabledStyle", "forwardedRef", "networkLink", "networkName", "onShareWindowClose", "openShareDialogOnClick", "opts", "resetButtonStyle", "style", "url", "windowHeight", "windowPosition", "windowWidth"]);
	        var newClassName = (0, classnames_1.default)('react-share__ShareButton', {
	            'react-share__ShareButton--disabled': !!disabled,
	            disabled: !!disabled,
	        }, className);
	        var newStyle = resetButtonStyle
	            ? __assign(__assign({ backgroundColor: 'transparent', border: 'none', padding: 0, font: 'inherit', color: 'inherit', cursor: 'pointer' }, style), (disabled && disabledStyle)) : __assign(__assign({}, style), (disabled && disabledStyle));
	        return (react_1.default.createElement("button", __assign({}, rest, { "aria-label": rest['aria-label'] || networkName, className: newClassName, onClick: this.handleClick, ref: forwardedRef, style: newStyle }), children));
	    };
	    ShareButton.defaultProps = {
	        disabledStyle: { opacity: 0.6 },
	        openShareDialogOnClick: true,
	        resetButtonStyle: true,
	    };
	    return ShareButton;
	}(react_1.Component));
	exports.default = ShareButton;


/***/ },
/* 1491 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __importDefault = (this && this.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var createIcon_1 = __importDefault(__webpack_require__(45));
	var TelegramIcon = (0, createIcon_1.default)({
	    color: '#37aee2',
	    networkName: 'telegram',
	    path: 'm45.90873,15.44335c-0.6901,-0.0281 -1.37668,0.14048 -1.96142,0.41265c-0.84989,0.32661 -8.63939,3.33986 -16.5237,6.39174c-3.9685,1.53296 -7.93349,3.06593 -10.98537,4.24067c-3.05012,1.1765 -5.34694,2.05098 -5.4681,2.09312c-0.80775,0.28096 -1.89996,0.63566 -2.82712,1.72788c-0.23354,0.27218 -0.46884,0.62161 -0.58825,1.10275c-0.11941,0.48114 -0.06673,1.09222 0.16682,1.5716c0.46533,0.96052 1.25376,1.35737 2.18443,1.71383c3.09051,0.99037 6.28638,1.93508 8.93263,2.8236c0.97632,3.44171 1.91401,6.89571 2.84116,10.34268c0.30554,0.69185 0.97105,0.94823 1.65764,0.95525l-0.00351,0.03512c0,0 0.53908,0.05268 1.06412,-0.07375c0.52679,-0.12292 1.18879,-0.42846 1.79109,-0.99212c0.662,-0.62161 2.45836,-2.38812 3.47683,-3.38552l7.6736,5.66477l0.06146,0.03512c0,0 0.84989,0.59703 2.09312,0.68132c0.62161,0.04214 1.4399,-0.07726 2.14229,-0.59176c0.70766,-0.51626 1.1765,-1.34683 1.396,-2.29506c0.65673,-2.86224 5.00979,-23.57745 5.75257,-27.00686l-0.02107,0.08077c0.51977,-1.93157 0.32837,-3.70159 -0.87096,-4.74991c-0.60054,-0.52152 -1.2924,-0.7498 -1.98425,-0.77965l0,0.00176zm-0.2072,3.29069c0.04741,0.0439 0.0439,0.0439 0.00351,0.04741c-0.01229,-0.00351 0.14048,0.2072 -0.15804,1.32576l-0.01229,0.04214l-0.00878,0.03863c-0.75858,3.50668 -5.15554,24.40802 -5.74203,26.96472c-0.08077,0.34417 -0.11414,0.31959 -0.09482,0.29852c-0.1756,-0.02634 -0.50045,-0.16506 -0.52679,-0.1756l-13.13468,-9.70175c4.4988,-4.33199 9.09945,-8.25307 13.744,-12.43229c0.8218,-0.41265 0.68483,-1.68573 -0.29852,-1.70681c-1.04305,0.24584 -1.92279,0.99564 -2.8798,1.47502c-5.49971,3.2626 -11.11882,6.13186 -16.55882,9.49279c-2.792,-0.97105 -5.57873,-1.77704 -8.15298,-2.57601c2.2336,-0.89555 4.00889,-1.55579 5.75608,-2.23009c3.05188,-1.1765 7.01687,-2.7042 10.98537,-4.24067c7.94051,-3.06944 15.92667,-6.16346 16.62028,-6.43037l0.05619,-0.02283l0.05268,-0.02283c0.19316,-0.0878 0.30378,-0.09658 0.35471,-0.10009c0,0 -0.01756,-0.05795 -0.00351,-0.04566l-0.00176,0zm-20.91715,22.0638l2.16687,1.60145c-0.93418,0.91311 -1.81743,1.77353 -2.45485,2.38812l0.28798,-3.98957',
	});
	exports.default = TelegramIcon;


/***/ },
/* 1492 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __importDefault = (this && this.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var assert_1 = __importDefault(__webpack_require__(49));
	var objectToGetParams_1 = __importDefault(__webpack_require__(38));
	var createShareButton_1 = __importDefault(__webpack_require__(46));
	function telegramLink(url, _a) {
	    var title = _a.title;
	    (0, assert_1.default)(url, 'telegram.url');
	    return ('https://telegram.me/share/url' +
	        (0, objectToGetParams_1.default)({
	            url: url,
	            text: title,
	        }));
	}
	var TelegramShareButton = (0, createShareButton_1.default)('telegram', telegramLink, function (props) { return ({
	    title: props.title,
	}); }, {
	    windowWidth: 550,
	    windowHeight: 400,
	});
	exports.default = TelegramShareButton;


/***/ },
/* 1493 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __importDefault = (this && this.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var createIcon_1 = __importDefault(__webpack_require__(45));
	var TumblrIcon = (0, createIcon_1.default)({
	    color: '#2c4762',
	    networkName: 'tumblr',
	    path: 'M39.2,41c-0.6,0.3-1.6,0.5-2.4,0.5c-2.4,0.1-2.9-1.7-2.9-3v-9.3h6v-4.5h-6V17c0,0-4.3,0-4.4,0 c-0.1,0-0.2,0.1-0.2,0.2c-0.3,2.3-1.4,6.4-5.9,8.1v3.9h3V39c0,3.4,2.5,8.1,9,8c2.2,0,4.7-1,5.2-1.8L39.2,41z',
	});
	exports.default = TumblrIcon;


/***/ },
/* 1494 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __importDefault = (this && this.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var assert_1 = __importDefault(__webpack_require__(49));
	var objectToGetParams_1 = __importDefault(__webpack_require__(38));
	var createShareButton_1 = __importDefault(__webpack_require__(46));
	function tumblrLink(url, _a) {
	    var title = _a.title, caption = _a.caption, tags = _a.tags, posttype = _a.posttype;
	    (0, assert_1.default)(url, 'tumblr.url');
	    return ('https://www.tumblr.com/widgets/share/tool' +
	        (0, objectToGetParams_1.default)({
	            canonicalUrl: url,
	            title: title,
	            caption: caption,
	            tags: tags,
	            posttype: posttype,
	        }));
	}
	var TumblrShareButton = (0, createShareButton_1.default)('tumblr', tumblrLink, function (props) { return ({
	    title: props.title,
	    tags: (props.tags || []).join(','),
	    caption: props.caption,
	    posttype: props.posttype || 'link',
	}); }, {
	    windowWidth: 660,
	    windowHeight: 460,
	});
	exports.default = TumblrShareButton;


/***/ },
/* 1495 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __importDefault = (this && this.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var jsonp_1 = __importDefault(__webpack_require__(109));
	var objectToGetParams_1 = __importDefault(__webpack_require__(38));
	var createShareCount_1 = __importDefault(__webpack_require__(115));
	function getTumblrShareCount(shareUrl, callback) {
	    var endpoint = 'https://api.tumblr.com/v2/share/stats';
	    return (0, jsonp_1.default)(endpoint +
	        (0, objectToGetParams_1.default)({
	            url: shareUrl,
	        }), function (err, data) {
	        callback(!err && data && data.response ? data.response.note_count : undefined);
	    });
	}
	exports.default = (0, createShareCount_1.default)(getTumblrShareCount);


/***/ },
/* 1496 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __importDefault = (this && this.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var createIcon_1 = __importDefault(__webpack_require__(45));
	var TwitterIcon = (0, createIcon_1.default)({
	    color: '#00aced',
	    networkName: 'twitter',
	    path: 'M48,22.1c-1.2,0.5-2.4,0.9-3.8,1c1.4-0.8,2.4-2.1,2.9-3.6c-1.3,0.8-2.7,1.3-4.2,1.6 C41.7,19.8,40,19,38.2,19c-3.6,0-6.6,2.9-6.6,6.6c0,0.5,0.1,1,0.2,1.5c-5.5-0.3-10.3-2.9-13.5-6.9c-0.6,1-0.9,2.1-0.9,3.3 c0,2.3,1.2,4.3,2.9,5.5c-1.1,0-2.1-0.3-3-0.8c0,0,0,0.1,0,0.1c0,3.2,2.3,5.8,5.3,6.4c-0.6,0.1-1.1,0.2-1.7,0.2c-0.4,0-0.8,0-1.2-0.1 c0.8,2.6,3.3,4.5,6.1,4.6c-2.2,1.8-5.1,2.8-8.2,2.8c-0.5,0-1.1,0-1.6-0.1c2.9,1.9,6.4,2.9,10.1,2.9c12.1,0,18.7-10,18.7-18.7 c0-0.3,0-0.6,0-0.8C46,24.5,47.1,23.4,48,22.1z',
	});
	exports.default = TwitterIcon;


/***/ },
/* 1497 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __importDefault = (this && this.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var assert_1 = __importDefault(__webpack_require__(49));
	var objectToGetParams_1 = __importDefault(__webpack_require__(38));
	var createShareButton_1 = __importDefault(__webpack_require__(46));
	function twitterLink(url, _a) {
	    var title = _a.title, via = _a.via, _b = _a.hashtags, hashtags = _b === void 0 ? [] : _b, _c = _a.related, related = _c === void 0 ? [] : _c;
	    (0, assert_1.default)(url, 'twitter.url');
	    (0, assert_1.default)(Array.isArray(hashtags), 'twitter.hashtags is not an array');
	    (0, assert_1.default)(Array.isArray(related), 'twitter.related is not an array');
	    return ('https://twitter.com/share' +
	        (0, objectToGetParams_1.default)({
	            url: url,
	            text: title,
	            via: via,
	            hashtags: hashtags.length > 0 ? hashtags.join(',') : undefined,
	            related: related.length > 0 ? related.join(',') : undefined,
	        }));
	}
	var TwitterShareButton = (0, createShareButton_1.default)('twitter', twitterLink, function (props) { return ({
	    hashtags: props.hashtags,
	    title: props.title,
	    via: props.via,
	    related: props.related,
	}); }, {
	    windowWidth: 550,
	    windowHeight: 400,
	});
	exports.default = TwitterShareButton;


/***/ },
/* 1498 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __importDefault = (this && this.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var createIcon_1 = __importDefault(__webpack_require__(45));
	var VKIcon = (0, createIcon_1.default)({
	    color: '#45668e',
	    networkName: 'vk',
	    path: 'M44.94,44.84h-0.2c-2.17-.36-3.66-1.92-4.92-3.37C39.1,40.66,38,38.81,36.7,39c-1.85.3-.93,3.52-1.71,4.9-0.62,1.11-3.29.91-5.12,0.71-5.79-.62-8.75-3.77-11.35-7.14A64.13,64.13,0,0,1,11.6,26a10.59,10.59,0,0,1-1.51-4.49C11,20.7,12.56,21,14.11,21c1.31,0,3.36-.29,4.32.2C19,21.46,19.57,23,20,24a37.18,37.18,0,0,0,3.31,5.82c0.56,0.81,1.41,2.35,2.41,2.14s1.06-2.63,1.1-4.18c0-1.77,0-4-.5-4.9S25,22,24.15,21.47c0.73-1.49,2.72-1.63,5.12-1.63,2,0,4.84-.23,5.62,1.12s0.25,3.85.2,5.71c-0.06,2.09-.41,4.25,1,5.21,1.09-.12,1.68-1.2,2.31-2A28,28,0,0,0,41.72,24c0.44-1,.91-2.65,1.71-3,1.21-.47,3.15-0.1,4.92-0.1,1.46,0,4.05-.41,4.52.61,0.39,0.85-.75,3-1.1,3.57a61.88,61.88,0,0,1-4.12,5.61c-0.58.78-1.78,2-1.71,3.27,0.05,0.94,1,1.67,1.71,2.35a33.12,33.12,0,0,1,3.92,4.18c0.47,0.62,1.5,2,1.4,2.76C52.66,45.81,46.88,44.24,44.94,44.84Z',
	});
	exports.default = VKIcon;


/***/ },
/* 1499 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __importDefault = (this && this.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var assert_1 = __importDefault(__webpack_require__(49));
	var objectToGetParams_1 = __importDefault(__webpack_require__(38));
	var createShareButton_1 = __importDefault(__webpack_require__(46));
	function vkLink(url, _a) {
	    var title = _a.title, image = _a.image, noParse = _a.noParse, noVkLinks = _a.noVkLinks;
	    (0, assert_1.default)(url, 'vk.url');
	    return ('https://vk.com/share.php' +
	        (0, objectToGetParams_1.default)({
	            url: url,
	            title: title,
	            image: image,
	            noparse: noParse ? 1 : 0,
	            no_vk_links: noVkLinks ? 1 : 0,
	        }));
	}
	var VKShareButton = (0, createShareButton_1.default)('vk', vkLink, function (props) { return ({
	    title: props.title,
	    image: props.image,
	    noParse: props.noParse,
	    noVkLinks: props.noVkLinks,
	}); }, {
	    windowWidth: 660,
	    windowHeight: 460,
	});
	exports.default = VKShareButton;


/***/ },
/* 1500 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __importDefault = (this && this.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var jsonp_1 = __importDefault(__webpack_require__(109));
	var objectToGetParams_1 = __importDefault(__webpack_require__(38));
	var createShareCount_1 = __importDefault(__webpack_require__(115));
	function getVKShareCount(shareUrl, callback) {
	    if (!window.VK)
	        window.VK = {};
	    window.VK.Share = {
	        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
	        count: function (index, count) { return window.VK.callbacks[index](count); },
	    };
	    window.VK.callbacks = [];
	    var url = 'https://vk.com/share.php';
	    var index = window.VK.callbacks.length;
	    window.VK.callbacks.push(callback);
	    return (0, jsonp_1.default)(url +
	        (0, objectToGetParams_1.default)({
	            act: 'count',
	            index: index,
	            url: shareUrl,
	        }));
	}
	exports.default = (0, createShareCount_1.default)(getVKShareCount);


/***/ },
/* 1501 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __importDefault = (this && this.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var createIcon_1 = __importDefault(__webpack_require__(45));
	var ViberIcon = (0, createIcon_1.default)({
	    color: '#7C529E',
	    networkName: 'viber',
	    path: 'm31.0,12.3c9.0,0.2 16.4,6.2 18.0,15.2c0.2,1.5 0.3,3.0 0.4,4.6a1.0,1.0 0 0 1 -0.8,1.2l-0.1,0a1.1,1.1 0 0 1 -1.0,-1.2l0,0c-0.0,-1.2 -0.1,-2.5 -0.3,-3.8a16.1,16.1 0 0 0 -13.0,-13.5c-1.0,-0.1 -2.0,-0.2 -3.0,-0.3c-0.6,-0.0 -1.4,-0.1 -1.6,-0.8a1.1,1.1 0 0 1 0.9,-1.2l0.6,0l0.0,-0.0zm10.6,39.2a19.9,19.9 0 0 1 -2.1,-0.6c-6.9,-2.9 -13.2,-6.6 -18.3,-12.2a47.5,47.5 0 0 1 -7.0,-10.7c-0.8,-1.8 -1.6,-3.7 -2.4,-5.6c-0.6,-1.7 0.3,-3.4 1.4,-4.7a11.3,11.3 0 0 1 3.7,-2.8a2.4,2.4 0 0 1 3.0,0.7a39.0,39.0 0 0 1 4.7,6.5a3.1,3.1 0 0 1 -0.8,4.2c-0.3,0.2 -0.6,0.5 -1.0,0.8a3.3,3.3 0 0 0 -0.7,0.7a2.1,2.1 0 0 0 -0.1,1.9c1.7,4.9 4.7,8.7 9.7,10.8a5.0,5.0 0 0 0 2.5,0.6c1.5,-0.1 2.0,-1.8 3.1,-2.7a2.9,2.9 0 0 1 3.5,-0.1c1.1,0.7 2.2,1.4 3.3,2.2a37.8,37.8 0 0 1 3.1,2.4a2.4,2.4 0 0 1 0.7,3.0a10.4,10.4 0 0 1 -4.4,4.8a10.8,10.8 0 0 1 -1.9,0.6c-0.7,-0.2 0.6,-0.2 0,0l0.0,0l0,-0.0zm3.1,-21.4a4.2,4.2 0 0 1 -0.0,0.6a1.0,1.0 0 0 1 -1.9,0.1a2.7,2.7 0 0 1 -0.1,-0.8a10.9,10.9 0 0 0 -1.4,-5.5a10.2,10.2 0 0 0 -4.2,-4.0a12.3,12.3 0 0 0 -3.4,-1.0c-0.5,-0.0 -1.0,-0.1 -1.5,-0.2a0.9,0.9 0 0 1 -0.9,-1.0l0,-0.1a0.9,0.9 0 0 1 0.9,-0.9l0.1,0a14.1,14.1 0 0 1 5.9,1.5a11.9,11.9 0 0 1 6.5,9.3c0,0.1 0.0,0.3 0.0,0.5c0,0.4 0.0,0.9 0.0,1.5l0,0l0.0,0.0zm-5.6,-0.2a1.1,1.1 0 0 1 -1.2,-0.9l0,-0.1a11.3,11.3 0 0 0 -0.2,-1.4a4.0,4.0 0 0 0 -1.5,-2.3a3.9,3.9 0 0 0 -1.2,-0.5c-0.5,-0.1 -1.1,-0.1 -1.6,-0.2a1.0,1.0 0 0 1 -0.8,-1.1l0,0l0,0a1.0,1.0 0 0 1 1.1,-0.8c3.4,0.2 6.0,2.0 6.3,6.2a2.8,2.8 0 0 1 0,0.8a0.8,0.8 0 0 1 -0.8,0.7l0,0l0.0,-0.0z',
	});
	exports.default = ViberIcon;


/***/ },
/* 1502 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __importDefault = (this && this.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var assert_1 = __importDefault(__webpack_require__(49));
	var objectToGetParams_1 = __importDefault(__webpack_require__(38));
	var createShareButton_1 = __importDefault(__webpack_require__(46));
	function viberLink(url, _a) {
	    var title = _a.title, separator = _a.separator;
	    (0, assert_1.default)(url, 'viber.url');
	    return ('viber://forward' +
	        (0, objectToGetParams_1.default)({
	            text: title ? title + separator + url : url,
	        }));
	}
	var ViberShareButton = (0, createShareButton_1.default)('viber', viberLink, function (props) { return ({
	    title: props.title,
	    separator: props.separator || ' ',
	}); }, {
	    windowWidth: 660,
	    windowHeight: 460,
	});
	exports.default = ViberShareButton;


/***/ },
/* 1503 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __importDefault = (this && this.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var createIcon_1 = __importDefault(__webpack_require__(45));
	var WeiboIcon = (0, createIcon_1.default)({
	    color: '#CD201F',
	    networkName: 'weibo',
	    path: 'M40.9756152,15.0217119 C40.5000732,15.0546301 39.9999314,15.1204666 39.5325878,15.2192213 C38.6634928,15.4085016 38.0977589,16.2643757 38.2863368,17.1284787 C38.4667163,18.0008129 39.3194143,18.5686519 40.1885094,18.3793715 C42.8613908,17.8115326 45.7720411,18.6427174 47.7316073,20.8153207 C49.6911735,22.996153 50.2077122,25.975254 49.3714112,28.5840234 C49.1008441,29.4316684 49.5763861,30.3533789 50.4208857,30.6249537 C51.2653852,30.8965286 52.1754769,30.4192153 52.4542425,29.5715703 C53.6349013,25.9011885 52.9133876,21.7699494 50.1585171,18.7085538 C48.0923641,16.4042776 45.2063093,15.1533848 42.3530505,15.0217119 C41.8775084,14.9970227 41.4511594,14.9887937 40.9756152,15.0217119 Z M27.9227762,19.8277737 C24.9957268,20.140498 20.863421,22.4365431 17.2312548,26.0822378 C13.2711279,30.0571148 11,34.2871065 11,37.9328012 C11,44.9032373 19.8713401,49.125 28.5786978,49.125 C39.9917329,49.125 47.600423,42.4261409 47.600423,37.1427636 C47.600423,33.9496952 44.9603397,32.1638816 42.549827,31.4149913 C41.9594976,31.2339421 41.5167516,31.1434164 41.8283133,30.3616079 C42.5006339,28.66632 42.6236176,27.1932286 41.8939054,26.1480742 C40.5328692,24.1894405 36.7203236,24.2881952 32.448635,26.0822378 C32.448635,26.0822378 31.1203949,26.6912261 31.4647526,25.6213825 C32.1206742,23.4981576 32.0304845,21.712342 31.0056075,20.6836478 C30.2840938,19.9512176 29.2510184,19.6878718 27.9227762,19.8277737 Z M42.0906819,20.6836478 C41.6233383,20.6589586 41.1723917,20.716566 40.7132466,20.8153207 C39.9671353,20.9716828 39.4997917,21.7781784 39.6637721,22.5270687 C39.8277525,23.275959 40.5574647,23.7450433 41.303576,23.5804521 C42.1972686,23.3911718 43.2057485,23.6380596 43.8616701,24.3704897 C44.5175916,25.1029198 44.6733735,26.0657797 44.3864073,26.9381118 C44.1486363,27.6705419 44.5093932,28.4770397 45.2391054,28.7156963 C45.9688176,28.9461239 46.780521,28.5922524 47.0100936,27.8598223 C47.584026,26.0740087 47.2396661,24.0248493 45.8950269,22.5270687 C44.886547,21.4078489 43.4845162,20.7494842 42.0906819,20.6836478 Z M29.496988,29.9665891 C35.3100922,30.1723275 39.9917329,33.0691319 40.3852858,37.0769272 C40.8362324,41.6607904 35.5970585,45.9319315 28.6442899,46.6232144 C21.6915214,47.3144973 15.6488446,44.154347 15.197898,39.5787128 C14.7469514,34.9948495 20.059916,30.7237084 27.004486,30.0324256 C27.8735831,29.950131 28.6688875,29.9336709 29.496988,29.9665891 Z M25.5614586,34.3776322 C23.183744,34.5916017 20.9372116,35.9577073 19.9205332,37.9328012 C18.5348994,40.6238672 19.9041362,43.6029661 23.0689567,44.582284 C26.340366,45.5945202 30.1857056,44.0638213 31.5303448,41.1587879 C32.8503864,38.3195909 31.1613894,35.3734082 27.9227762,34.5751416 C27.1438688,34.3776322 26.356763,34.3035667 25.5614586,34.3776322 Z M24.052839,38.7228388 C24.3316067,38.7310678 24.5857748,38.8215935 24.8399449,38.9203482 C25.8648218,39.3400561 26.1845841,40.4428158 25.5614586,41.4221338 C24.9219361,42.3932227 23.5690963,42.8623069 22.5442194,42.4096807 C21.5357395,41.9652856 21.2487754,40.8542948 21.8882979,39.9078951 C22.3638421,39.2001542 23.2247386,38.7146097 24.052839,38.7228388 Z',
	});
	exports.default = WeiboIcon;


/***/ },
/* 1504 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __importDefault = (this && this.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var assert_1 = __importDefault(__webpack_require__(49));
	var objectToGetParams_1 = __importDefault(__webpack_require__(38));
	var createShareButton_1 = __importDefault(__webpack_require__(46));
	function weiboLink(url, _a) {
	    var title = _a.title, image = _a.image;
	    (0, assert_1.default)(url, 'weibo.url');
	    return ('http://service.weibo.com/share/share.php' +
	        (0, objectToGetParams_1.default)({
	            url: url,
	            title: title,
	            pic: image,
	        }));
	}
	var WeiboShareButton = (0, createShareButton_1.default)('weibo', weiboLink, function (props) { return ({
	    title: props.title,
	    image: props.image,
	}); }, {
	    windowWidth: 660,
	    windowHeight: 550,
	    windowPosition: 'screenCenter',
	});
	exports.default = WeiboShareButton;


/***/ },
/* 1505 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __importDefault = (this && this.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var createIcon_1 = __importDefault(__webpack_require__(45));
	var WhatsappIcon = (0, createIcon_1.default)({
	    color: '#25D366',
	    networkName: 'whatsapp',
	    path: 'm42.32286,33.93287c-0.5178,-0.2589 -3.04726,-1.49644 -3.52105,-1.66732c-0.4712,-0.17346 -0.81554,-0.2589 -1.15987,0.2589c-0.34175,0.51004 -1.33075,1.66474 -1.63108,2.00648c-0.30032,0.33658 -0.60064,0.36247 -1.11327,0.12945c-0.5178,-0.2589 -2.17994,-0.80259 -4.14759,-2.56312c-1.53269,-1.37217 -2.56312,-3.05503 -2.86603,-3.57283c-0.30033,-0.5178 -0.03366,-0.80259 0.22524,-1.06149c0.23301,-0.23301 0.5178,-0.59547 0.7767,-0.90616c0.25372,-0.31068 0.33657,-0.5178 0.51262,-0.85437c0.17088,-0.36246 0.08544,-0.64725 -0.04402,-0.90615c-0.12945,-0.2589 -1.15987,-2.79613 -1.58964,-3.80584c-0.41424,-1.00971 -0.84142,-0.88027 -1.15987,-0.88027c-0.29773,-0.02588 -0.64208,-0.02588 -0.98382,-0.02588c-0.34693,0 -0.90616,0.12945 -1.37736,0.62136c-0.4712,0.5178 -1.80194,1.76053 -1.80194,4.27186c0,2.51134 1.84596,4.945 2.10227,5.30747c0.2589,0.33657 3.63497,5.51458 8.80262,7.74113c1.23237,0.5178 2.1903,0.82848 2.94111,1.08738c1.23237,0.38836 2.35599,0.33657 3.24402,0.20712c0.99159,-0.15534 3.04985,-1.24272 3.47963,-2.45956c0.44013,-1.21683 0.44013,-2.22654 0.31068,-2.45955c-0.12945,-0.23301 -0.46601,-0.36247 -0.98382,-0.59548m-9.40068,12.84407l-0.02589,0c-3.05503,0 -6.08417,-0.82849 -8.72495,-2.38189l-0.62136,-0.37023l-6.47252,1.68286l1.73463,-6.29129l-0.41424,-0.64725c-1.70875,-2.71846 -2.6149,-5.85116 -2.6149,-9.07706c0,-9.39809 7.68934,-17.06155 17.15993,-17.06155c4.58253,0 8.88029,1.78642 12.11655,5.02268c3.23625,3.21036 5.02267,7.50812 5.02267,12.06476c-0.0078,9.3981 -7.69712,17.06155 -17.14699,17.06155m14.58906,-31.58846c-3.93529,-3.80584 -9.1133,-5.95471 -14.62789,-5.95471c-11.36055,0 -20.60848,9.2065 -20.61625,20.52564c0,3.61684 0.94757,7.14565 2.75211,10.26282l-2.92557,10.63564l10.93337,-2.85309c3.0136,1.63108 6.4052,2.4958 9.85634,2.49839l0.01037,0c11.36574,0 20.61884,-9.2091 20.62403,-20.53082c0,-5.48093 -2.14111,-10.64081 -6.03239,-14.51915',
	});
	exports.default = WhatsappIcon;


/***/ },
/* 1506 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __importDefault = (this && this.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var assert_1 = __importDefault(__webpack_require__(49));
	var objectToGetParams_1 = __importDefault(__webpack_require__(38));
	var createShareButton_1 = __importDefault(__webpack_require__(46));
	function isMobileOrTablet() {
	    return /(android|iphone|ipad|mobile)/i.test(navigator.userAgent);
	}
	function whatsappLink(url, _a) {
	    var title = _a.title, separator = _a.separator;
	    (0, assert_1.default)(url, 'whatsapp.url');
	    return ('https://' +
	        (isMobileOrTablet() ? 'api' : 'web') +
	        '.whatsapp.com/send' +
	        (0, objectToGetParams_1.default)({
	            text: title ? title + separator + url : url,
	        }));
	}
	var WhatsappShareButton = (0, createShareButton_1.default)('whatsapp', whatsappLink, function (props) { return ({
	    title: props.title,
	    separator: props.separator || ' ',
	}); }, {
	    windowWidth: 550,
	    windowHeight: 400,
	});
	exports.default = WhatsappShareButton;


/***/ },
/* 1507 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __importDefault = (this && this.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var createIcon_1 = __importDefault(__webpack_require__(45));
	var WorkplaceIcon = (0, createIcon_1.default)({
	    color: '#3b3d4a',
	    networkName: 'workplace',
	    path: 'M34.019,10.292c0.21,0.017,0.423,0.034,0.636,0.049 c3.657,0.262,6.976,1.464,9.929,3.635c3.331,2.448,5.635,5.65,6.914,9.584c0.699,2.152,0.983,4.365,0.885,6.623 c-0.136,3.171-1.008,6.13-2.619,8.867c-0.442,0.75-0.908,1.492-1.495,2.141c-0.588,0.651-1.29,1.141-2.146,1.383 c-1.496,0.426-3.247-0.283-3.961-1.642c-0.26-0.494-0.442-1.028-0.654-1.548c-1.156-2.838-2.311-5.679-3.465-8.519 c-0.017-0.042-0.037-0.082-0.065-0.145c-0.101,0.245-0.192,0.472-0.284,0.698c-1.237,3.051-2.475,6.103-3.711,9.155 c-0.466,1.153-1.351,1.815-2.538,2.045c-1.391,0.267-2.577-0.154-3.496-1.247c-0.174-0.209-0.31-0.464-0.415-0.717 c-2.128-5.22-4.248-10.442-6.37-15.665c-0.012-0.029-0.021-0.059-0.036-0.104c0.054-0.003,0.103-0.006,0.15-0.006 c1.498-0.001,2.997,0,4.495-0.004c0.12-0.001,0.176,0.03,0.222,0.146c1.557,3.846,3.117,7.691,4.679,11.536 c0.018,0.046,0.039,0.091,0.067,0.159c0.273-0.673,0.536-1.32,0.797-1.968c1.064-2.627,2.137-5.25,3.19-7.883 c0.482-1.208,1.376-1.917,2.621-2.135c1.454-0.255,2.644,0.257,3.522,1.449c0.133,0.18,0.229,0.393,0.313,0.603 c1.425,3.495,2.848,6.991,4.269,10.488c0.02,0.047,0.04,0.093,0.073,0.172c0.196-0.327,0.385-0.625,0.559-0.935 c0.783-1.397,1.323-2.886,1.614-4.461c0.242-1.312,0.304-2.634,0.187-3.962c-0.242-2.721-1.16-5.192-2.792-7.38 c-2.193-2.939-5.086-4.824-8.673-5.625c-1.553-0.346-3.124-0.405-4.705-0.257c-3.162,0.298-6.036,1.366-8.585,3.258 c-3.414,2.534-5.638,5.871-6.623,10.016c-0.417,1.76-0.546,3.547-0.384,5.348c0.417,4.601,2.359,8.444,5.804,11.517 c2.325,2.073,5.037,3.393,8.094,3.989c1.617,0.317,3.247,0.395,4.889,0.242c1-0.094,1.982-0.268,2.952-0.529 c0.04-0.01,0.081-0.018,0.128-0.028c0,1.526,0,3.047,0,4.586c-0.402,0.074-0.805,0.154-1.21,0.221 c-0.861,0.14-1.728,0.231-2.601,0.258c-0.035,0.002-0.071,0.013-0.108,0.021c-0.493,0-0.983,0-1.476,0 c-0.049-0.007-0.1-0.018-0.149-0.022c-0.315-0.019-0.629-0.033-0.945-0.058c-1.362-0.105-2.702-0.346-4.017-0.716 c-3.254-0.914-6.145-2.495-8.66-4.752c-2.195-1.971-3.926-4.29-5.176-6.963c-1.152-2.466-1.822-5.057-1.993-7.774 c-0.014-0.226-0.033-0.451-0.05-0.676c0-0.502,0-1.003,0-1.504c0.008-0.049,0.02-0.099,0.022-0.148 c0.036-1.025,0.152-2.043,0.338-3.052c0.481-2.616,1.409-5.066,2.8-7.331c2.226-3.625,5.25-6.386,9.074-8.254 c2.536-1.24,5.217-1.947,8.037-2.126c0.23-0.015,0.461-0.034,0.691-0.051C33.052,10.292,33.535,10.292,34.019,10.292z',
	});
	exports.default = WorkplaceIcon;


/***/ },
/* 1508 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __importDefault = (this && this.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var assert_1 = __importDefault(__webpack_require__(49));
	var objectToGetParams_1 = __importDefault(__webpack_require__(38));
	var createShareButton_1 = __importDefault(__webpack_require__(46));
	function workplaceLink(url, _a) {
	    var quote = _a.quote, hashtag = _a.hashtag;
	    (0, assert_1.default)(url, 'workplace.url');
	    return ('https://work.facebook.com/sharer.php' +
	        (0, objectToGetParams_1.default)({
	            u: url,
	            quote: quote,
	            hashtag: hashtag,
	        }));
	}
	var WorkplaceShareButton = (0, createShareButton_1.default)('workplace', workplaceLink, function (props) { return ({
	    quote: props.quote,
	    hashtag: props.hashtag,
	}); }, {
	    windowWidth: 550,
	    windowHeight: 400,
	});
	exports.default = WorkplaceShareButton;


/***/ },
/* 1509 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(1);
	var React__default = _interopDefault(React);
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	}
	
	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  subClass.__proto__ = superClass;
	}
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect =
	    /*#__PURE__*/
	    function (_PureComponent) {
	      _inheritsLoose(SideEffect, _PureComponent);
	
	      function SideEffect() {
	        return _PureComponent.apply(this, arguments) || this;
	      }
	
	      // Try to use displayName of wrapped component
	      // Expose canUseDOM so tests can monkeypatch it
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      var _proto = SideEffect.prototype;
	
	      _proto.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      _proto.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      _proto.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      _proto.render = function render() {
	        return React__default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(React.PureComponent);
	
	    _defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
	
	    _defineProperty(SideEffect, "canUseDOM", canUseDOM);
	
	    return SideEffect;
	  };
	}
	
	module.exports = withSideEffect;


/***/ },
/* 1510 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.NextArrow = exports.PrevArrow = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _innerSliderUtils = __webpack_require__(171);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var PrevArrow = /*#__PURE__*/function (_React$PureComponent) {
	  _inherits(PrevArrow, _React$PureComponent);
	
	  var _super = _createSuper(PrevArrow);
	
	  function PrevArrow() {
	    _classCallCheck(this, PrevArrow);
	
	    return _super.apply(this, arguments);
	  }
	
	  _createClass(PrevArrow, [{
	    key: "clickHandler",
	    value: function clickHandler(options, e) {
	      if (e) {
	        e.preventDefault();
	      }
	
	      this.props.clickHandler(options, e);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var prevClasses = {
	        "slick-arrow": true,
	        "slick-prev": true
	      };
	      var prevHandler = this.clickHandler.bind(this, {
	        message: "previous"
	      });
	
	      if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
	        prevClasses["slick-disabled"] = true;
	        prevHandler = null;
	      }
	
	      var prevArrowProps = {
	        key: "0",
	        "data-role": "none",
	        className: (0, _classnames["default"])(prevClasses),
	        style: {
	          display: "block"
	        },
	        onClick: prevHandler
	      };
	      var customProps = {
	        currentSlide: this.props.currentSlide,
	        slideCount: this.props.slideCount
	      };
	      var prevArrow;
	
	      if (this.props.prevArrow) {
	        prevArrow = /*#__PURE__*/_react["default"].cloneElement(this.props.prevArrow, _objectSpread(_objectSpread({}, prevArrowProps), customProps));
	      } else {
	        prevArrow = /*#__PURE__*/_react["default"].createElement("button", _extends({
	          key: "0",
	          type: "button"
	        }, prevArrowProps), " ", "Previous");
	      }
	
	      return prevArrow;
	    }
	  }]);
	
	  return PrevArrow;
	}(_react["default"].PureComponent);
	
	exports.PrevArrow = PrevArrow;
	
	var NextArrow = /*#__PURE__*/function (_React$PureComponent2) {
	  _inherits(NextArrow, _React$PureComponent2);
	
	  var _super2 = _createSuper(NextArrow);
	
	  function NextArrow() {
	    _classCallCheck(this, NextArrow);
	
	    return _super2.apply(this, arguments);
	  }
	
	  _createClass(NextArrow, [{
	    key: "clickHandler",
	    value: function clickHandler(options, e) {
	      if (e) {
	        e.preventDefault();
	      }
	
	      this.props.clickHandler(options, e);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var nextClasses = {
	        "slick-arrow": true,
	        "slick-next": true
	      };
	      var nextHandler = this.clickHandler.bind(this, {
	        message: "next"
	      });
	
	      if (!(0, _innerSliderUtils.canGoNext)(this.props)) {
	        nextClasses["slick-disabled"] = true;
	        nextHandler = null;
	      }
	
	      var nextArrowProps = {
	        key: "1",
	        "data-role": "none",
	        className: (0, _classnames["default"])(nextClasses),
	        style: {
	          display: "block"
	        },
	        onClick: nextHandler
	      };
	      var customProps = {
	        currentSlide: this.props.currentSlide,
	        slideCount: this.props.slideCount
	      };
	      var nextArrow;
	
	      if (this.props.nextArrow) {
	        nextArrow = /*#__PURE__*/_react["default"].cloneElement(this.props.nextArrow, _objectSpread(_objectSpread({}, nextArrowProps), customProps));
	      } else {
	        nextArrow = /*#__PURE__*/_react["default"].createElement("button", _extends({
	          key: "1",
	          type: "button"
	        }, nextArrowProps), " ", "Next");
	      }
	
	      return nextArrow;
	    }
	  }]);
	
	  return NextArrow;
	}(_react["default"].PureComponent);
	
	exports.NextArrow = NextArrow;

/***/ },
/* 1511 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var defaultProps = {
	  accessibility: true,
	  adaptiveHeight: false,
	  afterChange: null,
	  appendDots: function appendDots(dots) {
	    return /*#__PURE__*/_react["default"].createElement("ul", {
	      style: {
	        display: "block"
	      }
	    }, dots);
	  },
	  arrows: true,
	  autoplay: false,
	  autoplaySpeed: 3000,
	  beforeChange: null,
	  centerMode: false,
	  centerPadding: "50px",
	  className: "",
	  cssEase: "ease",
	  customPaging: function customPaging(i) {
	    return /*#__PURE__*/_react["default"].createElement("button", null, i + 1);
	  },
	  dots: false,
	  dotsClass: "slick-dots",
	  draggable: true,
	  easing: "linear",
	  edgeFriction: 0.35,
	  fade: false,
	  focusOnSelect: false,
	  infinite: true,
	  initialSlide: 0,
	  lazyLoad: null,
	  nextArrow: null,
	  onEdge: null,
	  onInit: null,
	  onLazyLoadError: null,
	  onReInit: null,
	  pauseOnDotsHover: false,
	  pauseOnFocus: false,
	  pauseOnHover: true,
	  prevArrow: null,
	  responsive: null,
	  rows: 1,
	  rtl: false,
	  slide: "div",
	  slidesPerRow: 1,
	  slidesToScroll: 1,
	  slidesToShow: 1,
	  speed: 500,
	  swipe: true,
	  swipeEvent: null,
	  swipeToSlide: false,
	  touchMove: true,
	  touchThreshold: 5,
	  useCSS: true,
	  useTransform: true,
	  variableWidth: false,
	  vertical: false,
	  waitForAnimate: true
	};
	var _default = defaultProps;
	exports["default"] = _default;

/***/ },
/* 1512 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Dots = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _innerSliderUtils = __webpack_require__(171);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var getDotCount = function getDotCount(spec) {
	  var dots;
	
	  if (spec.infinite) {
	    dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
	  } else {
	    dots = Math.ceil((spec.slideCount - spec.slidesToShow) / spec.slidesToScroll) + 1;
	  }
	
	  return dots;
	};
	
	var Dots = /*#__PURE__*/function (_React$PureComponent) {
	  _inherits(Dots, _React$PureComponent);
	
	  var _super = _createSuper(Dots);
	
	  function Dots() {
	    _classCallCheck(this, Dots);
	
	    return _super.apply(this, arguments);
	  }
	
	  _createClass(Dots, [{
	    key: "clickHandler",
	    value: function clickHandler(options, e) {
	      // In Autoplay the focus stays on clicked button even after transition
	      // to next slide. That only goes away by click somewhere outside
	      e.preventDefault();
	      this.props.clickHandler(options);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          onMouseEnter = _this$props.onMouseEnter,
	          onMouseOver = _this$props.onMouseOver,
	          onMouseLeave = _this$props.onMouseLeave,
	          infinite = _this$props.infinite,
	          slidesToScroll = _this$props.slidesToScroll,
	          slidesToShow = _this$props.slidesToShow,
	          slideCount = _this$props.slideCount,
	          currentSlide = _this$props.currentSlide;
	      var dotCount = getDotCount({
	        slideCount: slideCount,
	        slidesToScroll: slidesToScroll,
	        slidesToShow: slidesToShow,
	        infinite: infinite
	      });
	      var mouseEvents = {
	        onMouseEnter: onMouseEnter,
	        onMouseOver: onMouseOver,
	        onMouseLeave: onMouseLeave
	      };
	      var dots = [];
	
	      for (var i = 0; i < dotCount; i++) {
	        var _rightBound = (i + 1) * slidesToScroll - 1;
	
	        var rightBound = infinite ? _rightBound : (0, _innerSliderUtils.clamp)(_rightBound, 0, slideCount - 1);
	
	        var _leftBound = rightBound - (slidesToScroll - 1);
	
	        var leftBound = infinite ? _leftBound : (0, _innerSliderUtils.clamp)(_leftBound, 0, slideCount - 1);
	        var className = (0, _classnames["default"])({
	          "slick-active": infinite ? currentSlide >= leftBound && currentSlide <= rightBound : currentSlide === leftBound
	        });
	        var dotOptions = {
	          message: "dots",
	          index: i,
	          slidesToScroll: slidesToScroll,
	          currentSlide: currentSlide
	        };
	        var onClick = this.clickHandler.bind(this, dotOptions);
	        dots = dots.concat( /*#__PURE__*/_react["default"].createElement("li", {
	          key: i,
	          className: className
	        }, /*#__PURE__*/_react["default"].cloneElement(this.props.customPaging(i), {
	          onClick: onClick
	        })));
	      }
	
	      return /*#__PURE__*/_react["default"].cloneElement(this.props.appendDots(dots), _objectSpread({
	        className: this.props.dotsClass
	      }, mouseEvents));
	    }
	  }]);
	
	  return Dots;
	}(_react["default"].PureComponent);
	
	exports.Dots = Dots;

/***/ },
/* 1513 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	var initialState = {
	  animating: false,
	  autoplaying: null,
	  currentDirection: 0,
	  currentLeft: null,
	  currentSlide: 0,
	  direction: 1,
	  dragging: false,
	  edgeDragged: false,
	  initialized: false,
	  lazyLoadedList: [],
	  listHeight: null,
	  listWidth: null,
	  scrolling: false,
	  slideCount: null,
	  slideHeight: null,
	  slideWidth: null,
	  swipeLeft: null,
	  swiped: false,
	  // used by swipeEvent. differentites between touch and swipe.
	  swiping: false,
	  touchObject: {
	    startX: 0,
	    startY: 0,
	    curX: 0,
	    curY: 0
	  },
	  trackStyle: {},
	  trackWidth: 0,
	  targetSlide: 0
	};
	var _default = initialState;
	exports["default"] = _default;

/***/ },
/* 1514 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.InnerSlider = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _initialState = _interopRequireDefault(__webpack_require__(1513));
	
	var _lodash = _interopRequireDefault(__webpack_require__(452));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _innerSliderUtils = __webpack_require__(171);
	
	var _track = __webpack_require__(1516);
	
	var _dots = __webpack_require__(1512);
	
	var _arrows = __webpack_require__(1510);
	
	var _resizeObserverPolyfill = _interopRequireDefault(__webpack_require__(660));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var InnerSlider = /*#__PURE__*/function (_React$Component) {
	  _inherits(InnerSlider, _React$Component);
	
	  var _super = _createSuper(InnerSlider);
	
	  function InnerSlider(props) {
	    var _this;
	
	    _classCallCheck(this, InnerSlider);
	
	    _this = _super.call(this, props);
	
	    _defineProperty(_assertThisInitialized(_this), "listRefHandler", function (ref) {
	      return _this.list = ref;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "trackRefHandler", function (ref) {
	      return _this.track = ref;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "adaptHeight", function () {
	      if (_this.props.adaptiveHeight && _this.list) {
	        var elem = _this.list.querySelector("[data-index=\"".concat(_this.state.currentSlide, "\"]"));
	
	        _this.list.style.height = (0, _innerSliderUtils.getHeight)(elem) + "px";
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
	      _this.props.onInit && _this.props.onInit();
	
	      if (_this.props.lazyLoad) {
	        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_objectSpread(_objectSpread({}, _this.props), _this.state));
	
	        if (slidesToLoad.length > 0) {
	          _this.setState(function (prevState) {
	            return {
	              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
	            };
	          });
	
	          if (_this.props.onLazyLoad) {
	            _this.props.onLazyLoad(slidesToLoad);
	          }
	        }
	      }
	
	      var spec = _objectSpread({
	        listRef: _this.list,
	        trackRef: _this.track
	      }, _this.props);
	
	      _this.updateState(spec, true, function () {
	        _this.adaptHeight();
	
	        _this.props.autoplay && _this.autoPlay("update");
	      });
	
	      if (_this.props.lazyLoad === "progressive") {
	        _this.lazyLoadTimer = setInterval(_this.progressiveLazyLoad, 1000);
	      }
	
	      _this.ro = new _resizeObserverPolyfill["default"](function () {
	        if (_this.state.animating) {
	          _this.onWindowResized(false); // don't set trackStyle hence don't break animation
	
	
	          _this.callbackTimers.push(setTimeout(function () {
	            return _this.onWindowResized();
	          }, _this.props.speed));
	        } else {
	          _this.onWindowResized();
	        }
	      });
	
	      _this.ro.observe(_this.list);
	
	      document.querySelectorAll && Array.prototype.forEach.call(document.querySelectorAll(".slick-slide"), function (slide) {
	        slide.onfocus = _this.props.pauseOnFocus ? _this.onSlideFocus : null;
	        slide.onblur = _this.props.pauseOnFocus ? _this.onSlideBlur : null;
	      });
	
	      if (window.addEventListener) {
	        window.addEventListener("resize", _this.onWindowResized);
	      } else {
	        window.attachEvent("onresize", _this.onWindowResized);
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
	      if (_this.animationEndCallback) {
	        clearTimeout(_this.animationEndCallback);
	      }
	
	      if (_this.lazyLoadTimer) {
	        clearInterval(_this.lazyLoadTimer);
	      }
	
	      if (_this.callbackTimers.length) {
	        _this.callbackTimers.forEach(function (timer) {
	          return clearTimeout(timer);
	        });
	
	        _this.callbackTimers = [];
	      }
	
	      if (window.addEventListener) {
	        window.removeEventListener("resize", _this.onWindowResized);
	      } else {
	        window.detachEvent("onresize", _this.onWindowResized);
	      }
	
	      if (_this.autoplayTimer) {
	        clearInterval(_this.autoplayTimer);
	      }
	
	      _this.ro.disconnect();
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (prevProps) {
	      _this.checkImagesLoad();
	
	      _this.props.onReInit && _this.props.onReInit();
	
	      if (_this.props.lazyLoad) {
	        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_objectSpread(_objectSpread({}, _this.props), _this.state));
	
	        if (slidesToLoad.length > 0) {
	          _this.setState(function (prevState) {
	            return {
	              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
	            };
	          });
	
	          if (_this.props.onLazyLoad) {
	            _this.props.onLazyLoad(slidesToLoad);
	          }
	        }
	      } // if (this.props.onLazyLoad) {
	      //   this.props.onLazyLoad([leftMostSlide])
	      // }
	
	
	      _this.adaptHeight();
	
	      var spec = _objectSpread(_objectSpread({
	        listRef: _this.list,
	        trackRef: _this.track
	      }, _this.props), _this.state);
	
	      var setTrackStyle = _this.didPropsChange(prevProps);
	
	      setTrackStyle && _this.updateState(spec, setTrackStyle, function () {
	        if (_this.state.currentSlide >= _react["default"].Children.count(_this.props.children)) {
	          _this.changeSlide({
	            message: "index",
	            index: _react["default"].Children.count(_this.props.children) - _this.props.slidesToShow,
	            currentSlide: _this.state.currentSlide
	          });
	        }
	
	        if (_this.props.autoplay) {
	          _this.autoPlay("update");
	        } else {
	          _this.pause("paused");
	        }
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onWindowResized", function (setTrackStyle) {
	      if (_this.debouncedResize) _this.debouncedResize.cancel();
	      _this.debouncedResize = (0, _lodash["default"])(function () {
	        return _this.resizeWindow(setTrackStyle);
	      }, 50);
	
	      _this.debouncedResize();
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "resizeWindow", function () {
	      var setTrackStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	      var isTrackMounted = Boolean(_this.track && _this.track.node); // prevent warning: setting state on unmounted component (server side rendering)
	
	      if (!isTrackMounted) return;
	
	      var spec = _objectSpread(_objectSpread({
	        listRef: _this.list,
	        trackRef: _this.track
	      }, _this.props), _this.state);
	
	      _this.updateState(spec, setTrackStyle, function () {
	        if (_this.props.autoplay) _this.autoPlay("update");else _this.pause("paused");
	      }); // animating state should be cleared while resizing, otherwise autoplay stops working
	
	
	      _this.setState({
	        animating: false
	      });
	
	      clearTimeout(_this.animationEndCallback);
	      delete _this.animationEndCallback;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "updateState", function (spec, setTrackStyle, callback) {
	      var updatedState = (0, _innerSliderUtils.initializedState)(spec);
	      spec = _objectSpread(_objectSpread(_objectSpread({}, spec), updatedState), {}, {
	        slideIndex: updatedState.currentSlide
	      });
	      var targetLeft = (0, _innerSliderUtils.getTrackLeft)(spec);
	      spec = _objectSpread(_objectSpread({}, spec), {}, {
	        left: targetLeft
	      });
	      var trackStyle = (0, _innerSliderUtils.getTrackCSS)(spec);
	
	      if (setTrackStyle || _react["default"].Children.count(_this.props.children) !== _react["default"].Children.count(spec.children)) {
	        updatedState["trackStyle"] = trackStyle;
	      }
	
	      _this.setState(updatedState, callback);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "ssrInit", function () {
	      if (_this.props.variableWidth) {
	        var _trackWidth = 0,
	            _trackLeft = 0;
	        var childrenWidths = [];
	        var preClones = (0, _innerSliderUtils.getPreClones)(_objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
	          slideCount: _this.props.children.length
	        }));
	        var postClones = (0, _innerSliderUtils.getPostClones)(_objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
	          slideCount: _this.props.children.length
	        }));
	
	        _this.props.children.forEach(function (child) {
	          childrenWidths.push(child.props.style.width);
	          _trackWidth += child.props.style.width;
	        });
	
	        for (var i = 0; i < preClones; i++) {
	          _trackLeft += childrenWidths[childrenWidths.length - 1 - i];
	          _trackWidth += childrenWidths[childrenWidths.length - 1 - i];
	        }
	
	        for (var _i = 0; _i < postClones; _i++) {
	          _trackWidth += childrenWidths[_i];
	        }
	
	        for (var _i2 = 0; _i2 < _this.state.currentSlide; _i2++) {
	          _trackLeft += childrenWidths[_i2];
	        }
	
	        var _trackStyle = {
	          width: _trackWidth + "px",
	          left: -_trackLeft + "px"
	        };
	
	        if (_this.props.centerMode) {
	          var currentWidth = "".concat(childrenWidths[_this.state.currentSlide], "px");
	          _trackStyle.left = "calc(".concat(_trackStyle.left, " + (100% - ").concat(currentWidth, ") / 2 ) ");
	        }
	
	        return {
	          trackStyle: _trackStyle
	        };
	      }
	
	      var childrenCount = _react["default"].Children.count(_this.props.children);
	
	      var spec = _objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
	        slideCount: childrenCount
	      });
	
	      var slideCount = (0, _innerSliderUtils.getPreClones)(spec) + (0, _innerSliderUtils.getPostClones)(spec) + childrenCount;
	      var trackWidth = 100 / _this.props.slidesToShow * slideCount;
	      var slideWidth = 100 / slideCount;
	      var trackLeft = -slideWidth * ((0, _innerSliderUtils.getPreClones)(spec) + _this.state.currentSlide) * trackWidth / 100;
	
	      if (_this.props.centerMode) {
	        trackLeft += (100 - slideWidth * trackWidth / 100) / 2;
	      }
	
	      var trackStyle = {
	        width: trackWidth + "%",
	        left: trackLeft + "%"
	      };
	      return {
	        slideWidth: slideWidth + "%",
	        trackStyle: trackStyle
	      };
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "checkImagesLoad", function () {
	      var images = _this.list.querySelectorAll && _this.list.querySelectorAll(".slick-slide img") || [];
	      var imagesCount = images.length,
	          loadedCount = 0;
	      Array.prototype.forEach.call(images, function (image) {
	        var handler = function handler() {
	          return ++loadedCount && loadedCount >= imagesCount && _this.onWindowResized();
	        };
	
	        if (!image.onclick) {
	          image.onclick = function () {
	            return image.parentNode.focus();
	          };
	        } else {
	          var prevClickHandler = image.onclick;
	
	          image.onclick = function () {
	            prevClickHandler();
	            image.parentNode.focus();
	          };
	        }
	
	        if (!image.onload) {
	          if (_this.props.lazyLoad) {
	            image.onload = function () {
	              _this.adaptHeight();
	
	              _this.callbackTimers.push(setTimeout(_this.onWindowResized, _this.props.speed));
	            };
	          } else {
	            image.onload = handler;
	
	            image.onerror = function () {
	              handler();
	              _this.props.onLazyLoadError && _this.props.onLazyLoadError();
	            };
	          }
	        }
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "progressiveLazyLoad", function () {
	      var slidesToLoad = [];
	
	      var spec = _objectSpread(_objectSpread({}, _this.props), _this.state);
	
	      for (var index = _this.state.currentSlide; index < _this.state.slideCount + (0, _innerSliderUtils.getPostClones)(spec); index++) {
	        if (_this.state.lazyLoadedList.indexOf(index) < 0) {
	          slidesToLoad.push(index);
	          break;
	        }
	      }
	
	      for (var _index = _this.state.currentSlide - 1; _index >= -(0, _innerSliderUtils.getPreClones)(spec); _index--) {
	        if (_this.state.lazyLoadedList.indexOf(_index) < 0) {
	          slidesToLoad.push(_index);
	          break;
	        }
	      }
	
	      if (slidesToLoad.length > 0) {
	        _this.setState(function (state) {
	          return {
	            lazyLoadedList: state.lazyLoadedList.concat(slidesToLoad)
	          };
	        });
	
	        if (_this.props.onLazyLoad) {
	          _this.props.onLazyLoad(slidesToLoad);
	        }
	      } else {
	        if (_this.lazyLoadTimer) {
	          clearInterval(_this.lazyLoadTimer);
	          delete _this.lazyLoadTimer;
	        }
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "slideHandler", function (index) {
	      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      var _this$props = _this.props,
	          asNavFor = _this$props.asNavFor,
	          beforeChange = _this$props.beforeChange,
	          onLazyLoad = _this$props.onLazyLoad,
	          speed = _this$props.speed,
	          afterChange = _this$props.afterChange; // capture currentslide before state is updated
	
	      var currentSlide = _this.state.currentSlide;
	
	      var _slideHandler = (0, _innerSliderUtils.slideHandler)(_objectSpread(_objectSpread(_objectSpread({
	        index: index
	      }, _this.props), _this.state), {}, {
	        trackRef: _this.track,
	        useCSS: _this.props.useCSS && !dontAnimate
	      })),
	          state = _slideHandler.state,
	          nextState = _slideHandler.nextState;
	
	      if (!state) return;
	      beforeChange && beforeChange(currentSlide, state.currentSlide);
	      var slidesToLoad = state.lazyLoadedList.filter(function (value) {
	        return _this.state.lazyLoadedList.indexOf(value) < 0;
	      });
	      onLazyLoad && slidesToLoad.length > 0 && onLazyLoad(slidesToLoad);
	
	      if (!_this.props.waitForAnimate && _this.animationEndCallback) {
	        clearTimeout(_this.animationEndCallback);
	        afterChange && afterChange(currentSlide);
	        delete _this.animationEndCallback;
	      }
	
	      _this.setState(state, function () {
	        // asNavForIndex check is to avoid recursive calls of slideHandler in waitForAnimate=false mode
	        if (asNavFor && _this.asNavForIndex !== index) {
	          _this.asNavForIndex = index;
	          asNavFor.innerSlider.slideHandler(index);
	        }
	
	        if (!nextState) return;
	        _this.animationEndCallback = setTimeout(function () {
	          var animating = nextState.animating,
	              firstBatch = _objectWithoutProperties(nextState, ["animating"]);
	
	          _this.setState(firstBatch, function () {
	            _this.callbackTimers.push(setTimeout(function () {
	              return _this.setState({
	                animating: animating
	              });
	            }, 10));
	
	            afterChange && afterChange(state.currentSlide);
	            delete _this.animationEndCallback;
	          });
	        }, speed);
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "changeSlide", function (options) {
	      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      var spec = _objectSpread(_objectSpread({}, _this.props), _this.state);
	
	      var targetSlide = (0, _innerSliderUtils.changeSlide)(spec, options);
	      if (targetSlide !== 0 && !targetSlide) return;
	
	      if (dontAnimate === true) {
	        _this.slideHandler(targetSlide, dontAnimate);
	      } else {
	        _this.slideHandler(targetSlide);
	      }
	
	      _this.props.autoplay && _this.autoPlay("update");
	
	      if (_this.props.focusOnSelect) {
	        var nodes = _this.list.querySelectorAll(".slick-current");
	
	        nodes[0] && nodes[0].focus();
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "clickHandler", function (e) {
	      if (_this.clickable === false) {
	        e.stopPropagation();
	        e.preventDefault();
	      }
	
	      _this.clickable = true;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "keyHandler", function (e) {
	      var dir = (0, _innerSliderUtils.keyHandler)(e, _this.props.accessibility, _this.props.rtl);
	      dir !== "" && _this.changeSlide({
	        message: dir
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "selectHandler", function (options) {
	      _this.changeSlide(options);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "disableBodyScroll", function () {
	      var preventDefault = function preventDefault(e) {
	        e = e || window.event;
	        if (e.preventDefault) e.preventDefault();
	        e.returnValue = false;
	      };
	
	      window.ontouchmove = preventDefault;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "enableBodyScroll", function () {
	      window.ontouchmove = null;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "swipeStart", function (e) {
	      if (_this.props.verticalSwiping) {
	        _this.disableBodyScroll();
	      }
	
	      var state = (0, _innerSliderUtils.swipeStart)(e, _this.props.swipe, _this.props.draggable);
	      state !== "" && _this.setState(state);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "swipeMove", function (e) {
	      var state = (0, _innerSliderUtils.swipeMove)(e, _objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
	        trackRef: _this.track,
	        listRef: _this.list,
	        slideIndex: _this.state.currentSlide
	      }));
	      if (!state) return;
	
	      if (state["swiping"]) {
	        _this.clickable = false;
	      }
	
	      _this.setState(state);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "swipeEnd", function (e) {
	      var state = (0, _innerSliderUtils.swipeEnd)(e, _objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
	        trackRef: _this.track,
	        listRef: _this.list,
	        slideIndex: _this.state.currentSlide
	      }));
	      if (!state) return;
	      var triggerSlideHandler = state["triggerSlideHandler"];
	      delete state["triggerSlideHandler"];
	
	      _this.setState(state);
	
	      if (triggerSlideHandler === undefined) return;
	
	      _this.slideHandler(triggerSlideHandler);
	
	      if (_this.props.verticalSwiping) {
	        _this.enableBodyScroll();
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "touchEnd", function (e) {
	      _this.swipeEnd(e);
	
	      _this.clickable = true;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "slickPrev", function () {
	      // this and fellow methods are wrapped in setTimeout
	      // to make sure initialize setState has happened before
	      // any of such methods are called
	      _this.callbackTimers.push(setTimeout(function () {
	        return _this.changeSlide({
	          message: "previous"
	        });
	      }, 0));
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "slickNext", function () {
	      _this.callbackTimers.push(setTimeout(function () {
	        return _this.changeSlide({
	          message: "next"
	        });
	      }, 0));
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "slickGoTo", function (slide) {
	      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      slide = Number(slide);
	      if (isNaN(slide)) return "";
	
	      _this.callbackTimers.push(setTimeout(function () {
	        return _this.changeSlide({
	          message: "index",
	          index: slide,
	          currentSlide: _this.state.currentSlide
	        }, dontAnimate);
	      }, 0));
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "play", function () {
	      var nextIndex;
	
	      if (_this.props.rtl) {
	        nextIndex = _this.state.currentSlide - _this.props.slidesToScroll;
	      } else {
	        if ((0, _innerSliderUtils.canGoNext)(_objectSpread(_objectSpread({}, _this.props), _this.state))) {
	          nextIndex = _this.state.currentSlide + _this.props.slidesToScroll;
	        } else {
	          return false;
	        }
	      }
	
	      _this.slideHandler(nextIndex);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "autoPlay", function (playType) {
	      if (_this.autoplayTimer) {
	        clearInterval(_this.autoplayTimer);
	      }
	
	      var autoplaying = _this.state.autoplaying;
	
	      if (playType === "update") {
	        if (autoplaying === "hovered" || autoplaying === "focused" || autoplaying === "paused") {
	          return;
	        }
	      } else if (playType === "leave") {
	        if (autoplaying === "paused" || autoplaying === "focused") {
	          return;
	        }
	      } else if (playType === "blur") {
	        if (autoplaying === "paused" || autoplaying === "hovered") {
	          return;
	        }
	      }
	
	      _this.autoplayTimer = setInterval(_this.play, _this.props.autoplaySpeed + 50);
	
	      _this.setState({
	        autoplaying: "playing"
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "pause", function (pauseType) {
	      if (_this.autoplayTimer) {
	        clearInterval(_this.autoplayTimer);
	        _this.autoplayTimer = null;
	      }
	
	      var autoplaying = _this.state.autoplaying;
	
	      if (pauseType === "paused") {
	        _this.setState({
	          autoplaying: "paused"
	        });
	      } else if (pauseType === "focused") {
	        if (autoplaying === "hovered" || autoplaying === "playing") {
	          _this.setState({
	            autoplaying: "focused"
	          });
	        }
	      } else {
	        // pauseType  is 'hovered'
	        if (autoplaying === "playing") {
	          _this.setState({
	            autoplaying: "hovered"
	          });
	        }
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onDotsOver", function () {
	      return _this.props.autoplay && _this.pause("hovered");
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onDotsLeave", function () {
	      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onTrackOver", function () {
	      return _this.props.autoplay && _this.pause("hovered");
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onTrackLeave", function () {
	      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onSlideFocus", function () {
	      return _this.props.autoplay && _this.pause("focused");
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onSlideBlur", function () {
	      return _this.props.autoplay && _this.state.autoplaying === "focused" && _this.autoPlay("blur");
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "render", function () {
	      var className = (0, _classnames["default"])("slick-slider", _this.props.className, {
	        "slick-vertical": _this.props.vertical,
	        "slick-initialized": true
	      });
	
	      var spec = _objectSpread(_objectSpread({}, _this.props), _this.state);
	
	      var trackProps = (0, _innerSliderUtils.extractObject)(spec, ["fade", "cssEase", "speed", "infinite", "centerMode", "focusOnSelect", "currentSlide", "lazyLoad", "lazyLoadedList", "rtl", "slideWidth", "slideHeight", "listHeight", "vertical", "slidesToShow", "slidesToScroll", "slideCount", "trackStyle", "variableWidth", "unslick", "centerPadding", "targetSlide", "useCSS"]);
	      var pauseOnHover = _this.props.pauseOnHover;
	      trackProps = _objectSpread(_objectSpread({}, trackProps), {}, {
	        onMouseEnter: pauseOnHover ? _this.onTrackOver : null,
	        onMouseLeave: pauseOnHover ? _this.onTrackLeave : null,
	        onMouseOver: pauseOnHover ? _this.onTrackOver : null,
	        focusOnSelect: _this.props.focusOnSelect && _this.clickable ? _this.selectHandler : null
	      });
	      var dots;
	
	      if (_this.props.dots === true && _this.state.slideCount >= _this.props.slidesToShow) {
	        var dotProps = (0, _innerSliderUtils.extractObject)(spec, ["dotsClass", "slideCount", "slidesToShow", "currentSlide", "slidesToScroll", "clickHandler", "children", "customPaging", "infinite", "appendDots"]);
	        var pauseOnDotsHover = _this.props.pauseOnDotsHover;
	        dotProps = _objectSpread(_objectSpread({}, dotProps), {}, {
	          clickHandler: _this.changeSlide,
	          onMouseEnter: pauseOnDotsHover ? _this.onDotsLeave : null,
	          onMouseOver: pauseOnDotsHover ? _this.onDotsOver : null,
	          onMouseLeave: pauseOnDotsHover ? _this.onDotsLeave : null
	        });
	        dots = /*#__PURE__*/_react["default"].createElement(_dots.Dots, dotProps);
	      }
	
	      var prevArrow, nextArrow;
	      var arrowProps = (0, _innerSliderUtils.extractObject)(spec, ["infinite", "centerMode", "currentSlide", "slideCount", "slidesToShow", "prevArrow", "nextArrow"]);
	      arrowProps.clickHandler = _this.changeSlide;
	
	      if (_this.props.arrows) {
	        prevArrow = /*#__PURE__*/_react["default"].createElement(_arrows.PrevArrow, arrowProps);
	        nextArrow = /*#__PURE__*/_react["default"].createElement(_arrows.NextArrow, arrowProps);
	      }
	
	      var verticalHeightStyle = null;
	
	      if (_this.props.vertical) {
	        verticalHeightStyle = {
	          height: _this.state.listHeight
	        };
	      }
	
	      var centerPaddingStyle = null;
	
	      if (_this.props.vertical === false) {
	        if (_this.props.centerMode === true) {
	          centerPaddingStyle = {
	            padding: "0px " + _this.props.centerPadding
	          };
	        }
	      } else {
	        if (_this.props.centerMode === true) {
	          centerPaddingStyle = {
	            padding: _this.props.centerPadding + " 0px"
	          };
	        }
	      }
	
	      var listStyle = _objectSpread(_objectSpread({}, verticalHeightStyle), centerPaddingStyle);
	
	      var touchMove = _this.props.touchMove;
	      var listProps = {
	        className: "slick-list",
	        style: listStyle,
	        onClick: _this.clickHandler,
	        onMouseDown: touchMove ? _this.swipeStart : null,
	        onMouseMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
	        onMouseUp: touchMove ? _this.swipeEnd : null,
	        onMouseLeave: _this.state.dragging && touchMove ? _this.swipeEnd : null,
	        onTouchStart: touchMove ? _this.swipeStart : null,
	        onTouchMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
	        onTouchEnd: touchMove ? _this.touchEnd : null,
	        onTouchCancel: _this.state.dragging && touchMove ? _this.swipeEnd : null,
	        onKeyDown: _this.props.accessibility ? _this.keyHandler : null
	      };
	      var innerSliderProps = {
	        className: className,
	        dir: "ltr",
	        style: _this.props.style
	      };
	
	      if (_this.props.unslick) {
	        listProps = {
	          className: "slick-list"
	        };
	        innerSliderProps = {
	          className: className
	        };
	      }
	
	      return /*#__PURE__*/_react["default"].createElement("div", innerSliderProps, !_this.props.unslick ? prevArrow : "", /*#__PURE__*/_react["default"].createElement("div", _extends({
	        ref: _this.listRefHandler
	      }, listProps), /*#__PURE__*/_react["default"].createElement(_track.Track, _extends({
	        ref: _this.trackRefHandler
	      }, trackProps), _this.props.children)), !_this.props.unslick ? nextArrow : "", !_this.props.unslick ? dots : "");
	    });
	
	    _this.list = null;
	    _this.track = null;
	    _this.state = _objectSpread(_objectSpread({}, _initialState["default"]), {}, {
	      currentSlide: _this.props.initialSlide,
	      slideCount: _react["default"].Children.count(_this.props.children)
	    });
	    _this.callbackTimers = [];
	    _this.clickable = true;
	    _this.debouncedResize = null;
	
	    var ssrState = _this.ssrInit();
	
	    _this.state = _objectSpread(_objectSpread({}, _this.state), ssrState);
	    return _this;
	  }
	
	  _createClass(InnerSlider, [{
	    key: "didPropsChange",
	    value: function didPropsChange(prevProps) {
	      var setTrackStyle = false;
	
	      for (var _i3 = 0, _Object$keys = Object.keys(this.props); _i3 < _Object$keys.length; _i3++) {
	        var key = _Object$keys[_i3];
	
	        if (!prevProps.hasOwnProperty(key)) {
	          setTrackStyle = true;
	          break;
	        }
	
	        if (_typeof(prevProps[key]) === "object" || typeof prevProps[key] === "function") {
	          continue;
	        }
	
	        if (prevProps[key] !== this.props[key]) {
	          setTrackStyle = true;
	          break;
	        }
	      }
	
	      return setTrackStyle || _react["default"].Children.count(this.props.children) !== _react["default"].Children.count(prevProps.children);
	    }
	  }]);
	
	  return InnerSlider;
	}(_react["default"].Component);
	
	exports.InnerSlider = InnerSlider;

/***/ },
/* 1515 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _innerSlider = __webpack_require__(1514);
	
	var _json2mq = _interopRequireDefault(__webpack_require__(1315));
	
	var _defaultProps = _interopRequireDefault(__webpack_require__(1511));
	
	var _innerSliderUtils = __webpack_require__(171);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var enquire = (0, _innerSliderUtils.canUseDOM)() && __webpack_require__(1258);
	
	var Slider = /*#__PURE__*/function (_React$Component) {
	  _inherits(Slider, _React$Component);
	
	  var _super = _createSuper(Slider);
	
	  function Slider(props) {
	    var _this;
	
	    _classCallCheck(this, Slider);
	
	    _this = _super.call(this, props);
	
	    _defineProperty(_assertThisInitialized(_this), "innerSliderRefHandler", function (ref) {
	      return _this.innerSlider = ref;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "slickPrev", function () {
	      return _this.innerSlider.slickPrev();
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "slickNext", function () {
	      return _this.innerSlider.slickNext();
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "slickGoTo", function (slide) {
	      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      return _this.innerSlider.slickGoTo(slide, dontAnimate);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "slickPause", function () {
	      return _this.innerSlider.pause("paused");
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "slickPlay", function () {
	      return _this.innerSlider.autoPlay("play");
	    });
	
	    _this.state = {
	      breakpoint: null
	    };
	    _this._responsiveMediaHandlers = [];
	    return _this;
	  }
	
	  _createClass(Slider, [{
	    key: "media",
	    value: function media(query, handler) {
	      // javascript handler for  css media query
	      enquire.register(query, handler);
	
	      this._responsiveMediaHandlers.push({
	        query: query,
	        handler: handler
	      });
	    } // handles responsive breakpoints
	
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      // performance monitoring
	      //if (process.env.NODE_ENV !== 'production') {
	      //const { whyDidYouUpdate } = require('why-did-you-update')
	      //whyDidYouUpdate(React)
	      //}
	      if (this.props.responsive) {
	        var breakpoints = this.props.responsive.map(function (breakpt) {
	          return breakpt.breakpoint;
	        }); // sort them in increasing order of their numerical value
	
	        breakpoints.sort(function (x, y) {
	          return x - y;
	        });
	        breakpoints.forEach(function (breakpoint, index) {
	          // media query for each breakpoint
	          var bQuery;
	
	          if (index === 0) {
	            bQuery = (0, _json2mq["default"])({
	              minWidth: 0,
	              maxWidth: breakpoint
	            });
	          } else {
	            bQuery = (0, _json2mq["default"])({
	              minWidth: breakpoints[index - 1] + 1,
	              maxWidth: breakpoint
	            });
	          } // when not using server side rendering
	
	
	          (0, _innerSliderUtils.canUseDOM)() && _this2.media(bQuery, function () {
	            _this2.setState({
	              breakpoint: breakpoint
	            });
	          });
	        }); // Register media query for full screen. Need to support resize from small to large
	        // convert javascript object to media query string
	
	        var query = (0, _json2mq["default"])({
	          minWidth: breakpoints.slice(-1)[0]
	        });
	        (0, _innerSliderUtils.canUseDOM)() && this.media(query, function () {
	          _this2.setState({
	            breakpoint: null
	          });
	        });
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this._responsiveMediaHandlers.forEach(function (obj) {
	        enquire.unregister(obj.query, obj.handler);
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var settings;
	      var newProps;
	
	      if (this.state.breakpoint) {
	        newProps = this.props.responsive.filter(function (resp) {
	          return resp.breakpoint === _this3.state.breakpoint;
	        });
	        settings = newProps[0].settings === "unslick" ? "unslick" : _objectSpread(_objectSpread(_objectSpread({}, _defaultProps["default"]), this.props), newProps[0].settings);
	      } else {
	        settings = _objectSpread(_objectSpread({}, _defaultProps["default"]), this.props);
	      } // force scrolling by one if centerMode is on
	
	
	      if (settings.centerMode) {
	        if (settings.slidesToScroll > 1 && ("production") !== "production") {
	          console.warn("slidesToScroll should be equal to 1 in centerMode, you are using ".concat(settings.slidesToScroll));
	        }
	
	        settings.slidesToScroll = 1;
	      } // force showing one slide and scrolling by one if the fade mode is on
	
	
	      if (settings.fade) {
	        if (settings.slidesToShow > 1 && ("production") !== "production") {
	          console.warn("slidesToShow should be equal to 1 when fade is true, you're using ".concat(settings.slidesToShow));
	        }
	
	        if (settings.slidesToScroll > 1 && ("production") !== "production") {
	          console.warn("slidesToScroll should be equal to 1 when fade is true, you're using ".concat(settings.slidesToScroll));
	        }
	
	        settings.slidesToShow = 1;
	        settings.slidesToScroll = 1;
	      } // makes sure that children is an array, even when there is only 1 child
	
	
	      var children = _react["default"].Children.toArray(this.props.children); // Children may contain false or null, so we should filter them
	      // children may also contain string filled with spaces (in certain cases where we use jsx strings)
	
	
	      children = children.filter(function (child) {
	        if (typeof child === "string") {
	          return !!child.trim();
	        }
	
	        return !!child;
	      }); // rows and slidesPerRow logic is handled here
	
	      if (settings.variableWidth && (settings.rows > 1 || settings.slidesPerRow > 1)) {
	        console.warn("variableWidth is not supported in case of rows > 1 or slidesPerRow > 1");
	        settings.variableWidth = false;
	      }
	
	      var newChildren = [];
	      var currentWidth = null;
	
	      for (var i = 0; i < children.length; i += settings.rows * settings.slidesPerRow) {
	        var newSlide = [];
	
	        for (var j = i; j < i + settings.rows * settings.slidesPerRow; j += settings.slidesPerRow) {
	          var row = [];
	
	          for (var k = j; k < j + settings.slidesPerRow; k += 1) {
	            if (settings.variableWidth && children[k].props.style) {
	              currentWidth = children[k].props.style.width;
	            }
	
	            if (k >= children.length) break;
	            row.push( /*#__PURE__*/_react["default"].cloneElement(children[k], {
	              key: 100 * i + 10 * j + k,
	              tabIndex: -1,
	              style: {
	                width: "".concat(100 / settings.slidesPerRow, "%"),
	                display: "inline-block"
	              }
	            }));
	          }
	
	          newSlide.push( /*#__PURE__*/_react["default"].createElement("div", {
	            key: 10 * i + j
	          }, row));
	        }
	
	        if (settings.variableWidth) {
	          newChildren.push( /*#__PURE__*/_react["default"].createElement("div", {
	            key: i,
	            style: {
	              width: currentWidth
	            }
	          }, newSlide));
	        } else {
	          newChildren.push( /*#__PURE__*/_react["default"].createElement("div", {
	            key: i
	          }, newSlide));
	        }
	      }
	
	      if (settings === "unslick") {
	        var className = "regular slider " + (this.props.className || "");
	        return /*#__PURE__*/_react["default"].createElement("div", {
	          className: className
	        }, children);
	      } else if (newChildren.length <= settings.slidesToShow) {
	        settings.unslick = true;
	      }
	
	      return /*#__PURE__*/_react["default"].createElement(_innerSlider.InnerSlider, _extends({
	        style: this.props.style,
	        ref: this.innerSliderRefHandler
	      }, settings), newChildren);
	    }
	  }]);
	
	  return Slider;
	}(_react["default"].Component);
	
	exports["default"] = Slider;

/***/ },
/* 1516 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Track = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _innerSliderUtils = __webpack_require__(171);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	// given specifications/props for a slide, fetch all the classes that need to be applied to the slide
	var getSlideClasses = function getSlideClasses(spec) {
	  var slickActive, slickCenter, slickCloned;
	  var centerOffset, index;
	
	  if (spec.rtl) {
	    index = spec.slideCount - 1 - spec.index;
	  } else {
	    index = spec.index;
	  }
	
	  slickCloned = index < 0 || index >= spec.slideCount;
	
	  if (spec.centerMode) {
	    centerOffset = Math.floor(spec.slidesToShow / 2);
	    slickCenter = (index - spec.currentSlide) % spec.slideCount === 0;
	
	    if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) {
	      slickActive = true;
	    }
	  } else {
	    slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
	  }
	
	  var focusedSlide;
	
	  if (spec.targetSlide < 0) {
	    focusedSlide = spec.targetSlide + spec.slideCount;
	  } else if (spec.targetSlide >= spec.slideCount) {
	    focusedSlide = spec.targetSlide - spec.slideCount;
	  } else {
	    focusedSlide = spec.targetSlide;
	  }
	
	  var slickCurrent = index === focusedSlide;
	  return {
	    "slick-slide": true,
	    "slick-active": slickActive,
	    "slick-center": slickCenter,
	    "slick-cloned": slickCloned,
	    "slick-current": slickCurrent // dubious in case of RTL
	
	  };
	};
	
	var getSlideStyle = function getSlideStyle(spec) {
	  var style = {};
	
	  if (spec.variableWidth === undefined || spec.variableWidth === false) {
	    style.width = spec.slideWidth;
	  }
	
	  if (spec.fade) {
	    style.position = "relative";
	
	    if (spec.vertical) {
	      style.top = -spec.index * parseInt(spec.slideHeight);
	    } else {
	      style.left = -spec.index * parseInt(spec.slideWidth);
	    }
	
	    style.opacity = spec.currentSlide === spec.index ? 1 : 0;
	
	    if (spec.useCSS) {
	      style.transition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
	    }
	  }
	
	  return style;
	};
	
	var getKey = function getKey(child, fallbackKey) {
	  return child.key || fallbackKey;
	};
	
	var renderSlides = function renderSlides(spec) {
	  var key;
	  var slides = [];
	  var preCloneSlides = [];
	  var postCloneSlides = [];
	
	  var childrenCount = _react["default"].Children.count(spec.children);
	
	  var startIndex = (0, _innerSliderUtils.lazyStartIndex)(spec);
	  var endIndex = (0, _innerSliderUtils.lazyEndIndex)(spec);
	
	  _react["default"].Children.forEach(spec.children, function (elem, index) {
	    var child;
	    var childOnClickOptions = {
	      message: "children",
	      index: index,
	      slidesToScroll: spec.slidesToScroll,
	      currentSlide: spec.currentSlide
	    }; // in case of lazyLoad, whether or not we want to fetch the slide
	
	    if (!spec.lazyLoad || spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0) {
	      child = elem;
	    } else {
	      child = /*#__PURE__*/_react["default"].createElement("div", null);
	    }
	
	    var childStyle = getSlideStyle(_objectSpread(_objectSpread({}, spec), {}, {
	      index: index
	    }));
	    var slideClass = child.props.className || "";
	    var slideClasses = getSlideClasses(_objectSpread(_objectSpread({}, spec), {}, {
	      index: index
	    })); // push a cloned element of the desired slide
	
	    slides.push( /*#__PURE__*/_react["default"].cloneElement(child, {
	      key: "original" + getKey(child, index),
	      "data-index": index,
	      className: (0, _classnames["default"])(slideClasses, slideClass),
	      tabIndex: "-1",
	      "aria-hidden": !slideClasses["slick-active"],
	      style: _objectSpread(_objectSpread({
	        outline: "none"
	      }, child.props.style || {}), childStyle),
	      onClick: function onClick(e) {
	        child.props && child.props.onClick && child.props.onClick(e);
	
	        if (spec.focusOnSelect) {
	          spec.focusOnSelect(childOnClickOptions);
	        }
	      }
	    })); // if slide needs to be precloned or postcloned
	
	    if (spec.infinite && spec.fade === false) {
	      var preCloneNo = childrenCount - index;
	
	      if (preCloneNo <= (0, _innerSliderUtils.getPreClones)(spec) && childrenCount !== spec.slidesToShow) {
	        key = -preCloneNo;
	
	        if (key >= startIndex) {
	          child = elem;
	        }
	
	        slideClasses = getSlideClasses(_objectSpread(_objectSpread({}, spec), {}, {
	          index: key
	        }));
	        preCloneSlides.push( /*#__PURE__*/_react["default"].cloneElement(child, {
	          key: "precloned" + getKey(child, key),
	          "data-index": key,
	          tabIndex: "-1",
	          className: (0, _classnames["default"])(slideClasses, slideClass),
	          "aria-hidden": !slideClasses["slick-active"],
	          style: _objectSpread(_objectSpread({}, child.props.style || {}), childStyle),
	          onClick: function onClick(e) {
	            child.props && child.props.onClick && child.props.onClick(e);
	
	            if (spec.focusOnSelect) {
	              spec.focusOnSelect(childOnClickOptions);
	            }
	          }
	        }));
	      }
	
	      if (childrenCount !== spec.slidesToShow) {
	        key = childrenCount + index;
	
	        if (key < endIndex) {
	          child = elem;
	        }
	
	        slideClasses = getSlideClasses(_objectSpread(_objectSpread({}, spec), {}, {
	          index: key
	        }));
	        postCloneSlides.push( /*#__PURE__*/_react["default"].cloneElement(child, {
	          key: "postcloned" + getKey(child, key),
	          "data-index": key,
	          tabIndex: "-1",
	          className: (0, _classnames["default"])(slideClasses, slideClass),
	          "aria-hidden": !slideClasses["slick-active"],
	          style: _objectSpread(_objectSpread({}, child.props.style || {}), childStyle),
	          onClick: function onClick(e) {
	            child.props && child.props.onClick && child.props.onClick(e);
	
	            if (spec.focusOnSelect) {
	              spec.focusOnSelect(childOnClickOptions);
	            }
	          }
	        }));
	      }
	    }
	  });
	
	  if (spec.rtl) {
	    return preCloneSlides.concat(slides, postCloneSlides).reverse();
	  } else {
	    return preCloneSlides.concat(slides, postCloneSlides);
	  }
	};
	
	var Track = /*#__PURE__*/function (_React$PureComponent) {
	  _inherits(Track, _React$PureComponent);
	
	  var _super = _createSuper(Track);
	
	  function Track() {
	    var _this;
	
	    _classCallCheck(this, Track);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _super.call.apply(_super, [this].concat(args));
	
	    _defineProperty(_assertThisInitialized(_this), "node", null);
	
	    _defineProperty(_assertThisInitialized(_this), "handleRef", function (ref) {
	      _this.node = ref;
	    });
	
	    return _this;
	  }
	
	  _createClass(Track, [{
	    key: "render",
	    value: function render() {
	      var slides = renderSlides(this.props);
	      var _this$props = this.props,
	          onMouseEnter = _this$props.onMouseEnter,
	          onMouseOver = _this$props.onMouseOver,
	          onMouseLeave = _this$props.onMouseLeave;
	      var mouseEvents = {
	        onMouseEnter: onMouseEnter,
	        onMouseOver: onMouseOver,
	        onMouseLeave: onMouseLeave
	      };
	      return /*#__PURE__*/_react["default"].createElement("div", _extends({
	        ref: this.handleRef,
	        className: "slick-track",
	        style: this.props.trackStyle
	      }, mouseEvents), slides);
	    }
	  }]);
	
	  return Track;
	}(_react["default"].PureComponent);
	
	exports.Track = Track;

/***/ },
/* 1517 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }
	
	var _objectAssign = __webpack_require__(1518);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var truthy = function truthy(x) {
	  return x;
	};
	
	exports['default'] = function (input) {
	  var _ref = Array.isArray(input) && input.length === 2 ? input : [input, null];
	
	  var _ref2 = _slicedToArray(_ref, 2);
	
	  var theme = _ref2[0];
	  var classNameDecorator = _ref2[1];
	
	  return function (key) {
	    for (var _len = arguments.length, names = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      names[_key - 1] = arguments[_key];
	    }
	
	    var styles = names.map(function (name) {
	      return theme[name];
	    }).filter(truthy);
	
	    return typeof styles[0] === 'string' || typeof classNameDecorator === 'function' ? { key: key, className: classNameDecorator ? classNameDecorator.apply(undefined, _toConsumableArray(styles)) : styles.join(' ') } : { key: key, style: _objectAssign2['default'].apply(undefined, [{}].concat(_toConsumableArray(styles))) };
	  };
	};
	
	module.exports = exports['default'];

/***/ },
/* 1518 */
/***/ function(module, exports) {

	'use strict';
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function ToObject(val) {
		if (val == null) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function ownEnumerableKeys(obj) {
		var keys = Object.getOwnPropertyNames(obj);
	
		if (Object.getOwnPropertySymbols) {
			keys = keys.concat(Object.getOwnPropertySymbols(obj));
		}
	
		return keys.filter(function (key) {
			return propIsEnumerable.call(obj, key);
		});
	}
	
	module.exports = Object.assign || function (target, source) {
		var from;
		var keys;
		var to = ToObject(target);
	
		for (var s = 1; s < arguments.length; s++) {
			from = arguments[s];
			keys = ownEnumerableKeys(Object(from));
	
			for (var i = 0; i < keys.length; i++) {
				to[keys[i]] = from[keys[i]];
			}
		}
	
		return to;
	};


/***/ },
/* 1519 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _addClass2 = _interopRequireDefault(__webpack_require__(1178));
	
	var _removeClass = _interopRequireDefault(__webpack_require__(1180));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _Transition = _interopRequireDefault(__webpack_require__(298));
	
	var _PropTypes = __webpack_require__(635);
	
	var _reflow = __webpack_require__(636);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	var _addClass = function addClass(node, classes) {
	  return node && classes && classes.split(' ').forEach(function (c) {
	    return (0, _addClass2.default)(node, c);
	  });
	};
	
	var removeClass = function removeClass(node, classes) {
	  return node && classes && classes.split(' ').forEach(function (c) {
	    return (0, _removeClass.default)(node, c);
	  });
	};
	/**
	 * A transition component inspired by the excellent
	 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
	 * use it if you're using CSS transitions or animations. It's built upon the
	 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
	 * component, so it inherits all of its props.
	 *
	 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
	 * and `exit` states of the transition. The first class is applied and then a
	 * second `*-active` class in order to activate the CSS transition. After the
	 * transition, matching `*-done` class names are applied to persist the
	 * transition state.
	 *
	 * ```jsx
	 * function App() {
	 *   const [inProp, setInProp] = useState(false);
	 *   return (
	 *     <div>
	 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
	 *         <div>
	 *           {"I'll receive my-node-* classes"}
	 *         </div>
	 *       </CSSTransition>
	 *       <button type="button" onClick={() => setInProp(true)}>
	 *         Click to Enter
	 *       </button>
	 *     </div>
	 *   );
	 * }
	 * ```
	 *
	 * When the `in` prop is set to `true`, the child component will first receive
	 * the class `example-enter`, then the `example-enter-active` will be added in
	 * the next tick. `CSSTransition` [forces a
	 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
	 * between before adding the `example-enter-active`. This is an important trick
	 * because it allows us to transition between `example-enter` and
	 * `example-enter-active` even though they were added immediately one after
	 * another. Most notably, this is what makes it possible for us to animate
	 * _appearance_.
	 *
	 * ```css
	 * .my-node-enter {
	 *   opacity: 0;
	 * }
	 * .my-node-enter-active {
	 *   opacity: 1;
	 *   transition: opacity 200ms;
	 * }
	 * .my-node-exit {
	 *   opacity: 1;
	 * }
	 * .my-node-exit-active {
	 *   opacity: 0;
	 *   transition: opacity 200ms;
	 * }
	 * ```
	 *
	 * `*-active` classes represent which styles you want to animate **to**, so it's
	 * important to add `transition` declaration only to them, otherwise transitions
	 * might not behave as intended! This might not be obvious when the transitions
	 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
	 * the example above (minus `transition`), but it becomes apparent in more
	 * complex transitions.
	 *
	 * **Note**: If you're using the
	 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
	 * prop, make sure to define styles for `.appear-*` classes as well.
	 */
	
	
	var CSSTransition = /*#__PURE__*/function (_React$Component) {
	  _inheritsLoose(CSSTransition, _React$Component);
	
	  function CSSTransition() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	    _this.appliedClasses = {
	      appear: {},
	      enter: {},
	      exit: {}
	    };
	
	    _this.onEnter = function (maybeNode, maybeAppearing) {
	      var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing),
	          node = _this$resolveArgument[0],
	          appearing = _this$resolveArgument[1];
	
	      _this.removeClasses(node, 'exit');
	
	      _this.addClass(node, appearing ? 'appear' : 'enter', 'base');
	
	      if (_this.props.onEnter) {
	        _this.props.onEnter(maybeNode, maybeAppearing);
	      }
	    };
	
	    _this.onEntering = function (maybeNode, maybeAppearing) {
	      var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing),
	          node = _this$resolveArgument2[0],
	          appearing = _this$resolveArgument2[1];
	
	      var type = appearing ? 'appear' : 'enter';
	
	      _this.addClass(node, type, 'active');
	
	      if (_this.props.onEntering) {
	        _this.props.onEntering(maybeNode, maybeAppearing);
	      }
	    };
	
	    _this.onEntered = function (maybeNode, maybeAppearing) {
	      var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing),
	          node = _this$resolveArgument3[0],
	          appearing = _this$resolveArgument3[1];
	
	      var type = appearing ? 'appear' : 'enter';
	
	      _this.removeClasses(node, type);
	
	      _this.addClass(node, type, 'done');
	
	      if (_this.props.onEntered) {
	        _this.props.onEntered(maybeNode, maybeAppearing);
	      }
	    };
	
	    _this.onExit = function (maybeNode) {
	      var _this$resolveArgument4 = _this.resolveArguments(maybeNode),
	          node = _this$resolveArgument4[0];
	
	      _this.removeClasses(node, 'appear');
	
	      _this.removeClasses(node, 'enter');
	
	      _this.addClass(node, 'exit', 'base');
	
	      if (_this.props.onExit) {
	        _this.props.onExit(maybeNode);
	      }
	    };
	
	    _this.onExiting = function (maybeNode) {
	      var _this$resolveArgument5 = _this.resolveArguments(maybeNode),
	          node = _this$resolveArgument5[0];
	
	      _this.addClass(node, 'exit', 'active');
	
	      if (_this.props.onExiting) {
	        _this.props.onExiting(maybeNode);
	      }
	    };
	
	    _this.onExited = function (maybeNode) {
	      var _this$resolveArgument6 = _this.resolveArguments(maybeNode),
	          node = _this$resolveArgument6[0];
	
	      _this.removeClasses(node, 'exit');
	
	      _this.addClass(node, 'exit', 'done');
	
	      if (_this.props.onExited) {
	        _this.props.onExited(maybeNode);
	      }
	    };
	
	    _this.resolveArguments = function (maybeNode, maybeAppearing) {
	      return _this.props.nodeRef ? [_this.props.nodeRef.current, maybeNode] // here `maybeNode` is actually `appearing`
	      : [maybeNode, maybeAppearing];
	    };
	
	    _this.getClassNames = function (type) {
	      var classNames = _this.props.classNames;
	      var isStringClassNames = typeof classNames === 'string';
	      var prefix = isStringClassNames && classNames ? classNames + "-" : '';
	      var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
	      var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
	      var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
	      return {
	        baseClassName: baseClassName,
	        activeClassName: activeClassName,
	        doneClassName: doneClassName
	      };
	    };
	
	    return _this;
	  }
	
	  var _proto = CSSTransition.prototype;
	
	  _proto.addClass = function addClass(node, type, phase) {
	    var className = this.getClassNames(type)[phase + "ClassName"];
	
	    var _this$getClassNames = this.getClassNames('enter'),
	        doneClassName = _this$getClassNames.doneClassName;
	
	    if (type === 'appear' && phase === 'done' && doneClassName) {
	      className += " " + doneClassName;
	    } // This is to force a repaint,
	    // which is necessary in order to transition styles when adding a class name.
	
	
	    if (phase === 'active') {
	      if (node) (0, _reflow.forceReflow)(node);
	    }
	
	    if (className) {
	      this.appliedClasses[type][phase] = className;
	
	      _addClass(node, className);
	    }
	  };
	
	  _proto.removeClasses = function removeClasses(node, type) {
	    var _this$appliedClasses$ = this.appliedClasses[type],
	        baseClassName = _this$appliedClasses$.base,
	        activeClassName = _this$appliedClasses$.active,
	        doneClassName = _this$appliedClasses$.done;
	    this.appliedClasses[type] = {};
	
	    if (baseClassName) {
	      removeClass(node, baseClassName);
	    }
	
	    if (activeClassName) {
	      removeClass(node, activeClassName);
	    }
	
	    if (doneClassName) {
	      removeClass(node, doneClassName);
	    }
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        _ = _this$props.classNames,
	        props = _objectWithoutPropertiesLoose(_this$props, ["classNames"]);
	
	    return /*#__PURE__*/_react.default.createElement(_Transition.default, _extends({}, props, {
	      onEnter: this.onEnter,
	      onEntered: this.onEntered,
	      onEntering: this.onEntering,
	      onExit: this.onExit,
	      onExiting: this.onExiting,
	      onExited: this.onExited
	    }));
	  };
	
	  return CSSTransition;
	}(_react.default.Component);
	
	CSSTransition.defaultProps = {
	  classNames: ''
	};
	CSSTransition.propTypes =  false ? _extends({}, _Transition.default.propTypes, {
	  /**
	   * The animation classNames applied to the component as it appears, enters,
	   * exits or has finished the transition. A single name can be provided, which
	   * will be suffixed for each stage, e.g. `classNames="fade"` applies:
	   *
	   * - `fade-appear`, `fade-appear-active`, `fade-appear-done`
	   * - `fade-enter`, `fade-enter-active`, `fade-enter-done`
	   * - `fade-exit`, `fade-exit-active`, `fade-exit-done`
	   *
	   * A few details to note about how these classes are applied:
	   *
	   * 1. They are _joined_ with the ones that are already defined on the child
	   *    component, so if you want to add some base styles, you can use
	   *    `className` without worrying that it will be overridden.
	   *
	   * 2. If the transition component mounts with `in={false}`, no classes are
	   *    applied yet. You might be expecting `*-exit-done`, but if you think
	   *    about it, a component cannot finish exiting if it hasn't entered yet.
	   *
	   * 2. `fade-appear-done` and `fade-enter-done` will _both_ be applied. This
	   *    allows you to define different behavior for when appearing is done and
	   *    when regular entering is done, using selectors like
	   *    `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply
	   *    an epic entrance animation when element first appears in the DOM using
	   *    [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
	   *    simply use `fade-enter-done` for defining both cases.
	   *
	   * Each individual classNames can also be specified independently like:
	   *
	   * ```js
	   * classNames={{
	   *  appear: 'my-appear',
	   *  appearActive: 'my-active-appear',
	   *  appearDone: 'my-done-appear',
	   *  enter: 'my-enter',
	   *  enterActive: 'my-active-enter',
	   *  enterDone: 'my-done-enter',
	   *  exit: 'my-exit',
	   *  exitActive: 'my-active-exit',
	   *  exitDone: 'my-done-exit',
	   * }}
	   * ```
	   *
	   * If you want to set these classes using CSS Modules:
	   *
	   * ```js
	   * import styles from './styles.css';
	   * ```
	   *
	   * you might want to use camelCase in your CSS file, that way could simply
	   * spread them instead of listing them one by one:
	   *
	   * ```js
	   * classNames={{ ...styles }}
	   * ```
	   *
	   * @type {string | {
	   *  appear?: string,
	   *  appearActive?: string,
	   *  appearDone?: string,
	   *  enter?: string,
	   *  enterActive?: string,
	   *  enterDone?: string,
	   *  exit?: string,
	   *  exitActive?: string,
	   *  exitDone?: string,
	   * }}
	   */
	  classNames: _PropTypes.classNamesShape,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
	   * applied.
	   *
	   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter-active' or
	   * 'appear-active' class is applied.
	   *
	   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntering: _propTypes.default.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter' or
	   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
	   *
	   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntered: _propTypes.default.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit' class is
	   * applied.
	   *
	   * **Note**: when `nodeRef` prop is passed, `node` is not passed
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
	   *
	   * **Note**: when `nodeRef` prop is passed, `node` is not passed
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExiting: _propTypes.default.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit' classes
	   * are **removed** and the `exit-done` class is added to the DOM node.
	   *
	   * **Note**: when `nodeRef` prop is passed, `node` is not passed
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExited: _propTypes.default.func
	}) : {};
	var _default = CSSTransition;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1520 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(43));
	
	var _TransitionGroup = _interopRequireDefault(__webpack_require__(633));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	/**
	 * The `<ReplaceTransition>` component is a specialized `Transition` component
	 * that animates between two children.
	 *
	 * ```jsx
	 * <ReplaceTransition in>
	 *   <Fade><div>I appear first</div></Fade>
	 *   <Fade><div>I replace the above</div></Fade>
	 * </ReplaceTransition>
	 * ```
	 */
	var ReplaceTransition = /*#__PURE__*/function (_React$Component) {
	  _inheritsLoose(ReplaceTransition, _React$Component);
	
	  function ReplaceTransition() {
	    var _this;
	
	    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
	      _args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;
	
	    _this.handleEnter = function () {
	      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      return _this.handleLifecycle('onEnter', 0, args);
	    };
	
	    _this.handleEntering = function () {
	      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	        args[_key3] = arguments[_key3];
	      }
	
	      return _this.handleLifecycle('onEntering', 0, args);
	    };
	
	    _this.handleEntered = function () {
	      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	        args[_key4] = arguments[_key4];
	      }
	
	      return _this.handleLifecycle('onEntered', 0, args);
	    };
	
	    _this.handleExit = function () {
	      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
	        args[_key5] = arguments[_key5];
	      }
	
	      return _this.handleLifecycle('onExit', 1, args);
	    };
	
	    _this.handleExiting = function () {
	      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
	        args[_key6] = arguments[_key6];
	      }
	
	      return _this.handleLifecycle('onExiting', 1, args);
	    };
	
	    _this.handleExited = function () {
	      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
	        args[_key7] = arguments[_key7];
	      }
	
	      return _this.handleLifecycle('onExited', 1, args);
	    };
	
	    return _this;
	  }
	
	  var _proto = ReplaceTransition.prototype;
	
	  _proto.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
	    var _child$props;
	
	    var children = this.props.children;
	
	    var child = _react.default.Children.toArray(children)[idx];
	
	    if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);
	
	    if (this.props[handler]) {
	      var maybeNode = child.props.nodeRef ? undefined : _reactDom.default.findDOMNode(this);
	      this.props[handler](maybeNode);
	    }
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        children = _this$props.children,
	        inProp = _this$props.in,
	        props = _objectWithoutPropertiesLoose(_this$props, ["children", "in"]);
	
	    var _React$Children$toArr = _react.default.Children.toArray(children),
	        first = _React$Children$toArr[0],
	        second = _React$Children$toArr[1];
	
	    delete props.onEnter;
	    delete props.onEntering;
	    delete props.onEntered;
	    delete props.onExit;
	    delete props.onExiting;
	    delete props.onExited;
	    return /*#__PURE__*/_react.default.createElement(_TransitionGroup.default, props, inProp ? _react.default.cloneElement(first, {
	      key: 'first',
	      onEnter: this.handleEnter,
	      onEntering: this.handleEntering,
	      onEntered: this.handleEntered
	    }) : _react.default.cloneElement(second, {
	      key: 'second',
	      onEnter: this.handleExit,
	      onEntering: this.handleExiting,
	      onEntered: this.handleExited
	    }));
	  };
	
	  return ReplaceTransition;
	}(_react.default.Component);
	
	ReplaceTransition.propTypes =  false ? {
	  in: _propTypes.default.bool.isRequired,
	  children: function children(props, propName) {
	    if (_react.default.Children.count(props[propName]) !== 2) return new Error("\"" + propName + "\" must be exactly two transition components.");
	    return null;
	  }
	} : {};
	var _default = ReplaceTransition;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1521 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = exports.modes = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _Transition = __webpack_require__(298);
	
	var _TransitionGroupContext = _interopRequireDefault(__webpack_require__(299));
	
	var _leaveRenders, _enterRenders;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	function areChildrenDifferent(oldChildren, newChildren) {
	  if (oldChildren === newChildren) return false;
	
	  if (_react.default.isValidElement(oldChildren) && _react.default.isValidElement(newChildren) && oldChildren.key != null && oldChildren.key === newChildren.key) {
	    return false;
	  }
	
	  return true;
	}
	/**
	 * Enum of modes for SwitchTransition component
	 * @enum { string }
	 */
	
	
	var modes = {
	  out: 'out-in',
	  in: 'in-out'
	};
	exports.modes = modes;
	
	var callHook = function callHook(element, name, cb) {
	  return function () {
	    var _element$props;
	
	    element.props[name] && (_element$props = element.props)[name].apply(_element$props, arguments);
	    cb();
	  };
	};
	
	var leaveRenders = (_leaveRenders = {}, _leaveRenders[modes.out] = function (_ref) {
	  var current = _ref.current,
	      changeState = _ref.changeState;
	  return _react.default.cloneElement(current, {
	    in: false,
	    onExited: callHook(current, 'onExited', function () {
	      changeState(_Transition.ENTERING, null);
	    })
	  });
	}, _leaveRenders[modes.in] = function (_ref2) {
	  var current = _ref2.current,
	      changeState = _ref2.changeState,
	      children = _ref2.children;
	  return [current, _react.default.cloneElement(children, {
	    in: true,
	    onEntered: callHook(children, 'onEntered', function () {
	      changeState(_Transition.ENTERING);
	    })
	  })];
	}, _leaveRenders);
	var enterRenders = (_enterRenders = {}, _enterRenders[modes.out] = function (_ref3) {
	  var children = _ref3.children,
	      changeState = _ref3.changeState;
	  return _react.default.cloneElement(children, {
	    in: true,
	    onEntered: callHook(children, 'onEntered', function () {
	      changeState(_Transition.ENTERED, _react.default.cloneElement(children, {
	        in: true
	      }));
	    })
	  });
	}, _enterRenders[modes.in] = function (_ref4) {
	  var current = _ref4.current,
	      children = _ref4.children,
	      changeState = _ref4.changeState;
	  return [_react.default.cloneElement(current, {
	    in: false,
	    onExited: callHook(current, 'onExited', function () {
	      changeState(_Transition.ENTERED, _react.default.cloneElement(children, {
	        in: true
	      }));
	    })
	  }), _react.default.cloneElement(children, {
	    in: true
	  })];
	}, _enterRenders);
	/**
	 * A transition component inspired by the [vue transition modes](https://vuejs.org/v2/guide/transitions.html#Transition-Modes).
	 * You can use it when you want to control the render between state transitions.
	 * Based on the selected mode and the child's key which is the `Transition` or `CSSTransition` component, the `SwitchTransition` makes a consistent transition between them.
	 *
	 * If the `out-in` mode is selected, the `SwitchTransition` waits until the old child leaves and then inserts a new child.
	 * If the `in-out` mode is selected, the `SwitchTransition` inserts a new child first, waits for the new child to enter and then removes the old child.
	 *
	 * **Note**: If you want the animation to happen simultaneously
	 * (that is, to have the old child removed and a new child inserted **at the same time**),
	 * you should use
	 * [`TransitionGroup`](https://reactcommunity.org/react-transition-group/transition-group)
	 * instead.
	 *
	 * ```jsx
	 * function App() {
	 *  const [state, setState] = useState(false);
	 *  return (
	 *    <SwitchTransition>
	 *      <CSSTransition
	 *        key={state ? "Goodbye, world!" : "Hello, world!"}
	 *        addEndListener={(node, done) => node.addEventListener("transitionend", done, false)}
	 *        classNames='fade'
	 *      >
	 *        <button onClick={() => setState(state => !state)}>
	 *          {state ? "Goodbye, world!" : "Hello, world!"}
	 *        </button>
	 *      </CSSTransition>
	 *    </SwitchTransition>
	 *  );
	 * }
	 * ```
	 *
	 * ```css
	 * .fade-enter{
	 *    opacity: 0;
	 * }
	 * .fade-exit{
	 *    opacity: 1;
	 * }
	 * .fade-enter-active{
	 *    opacity: 1;
	 * }
	 * .fade-exit-active{
	 *    opacity: 0;
	 * }
	 * .fade-enter-active,
	 * .fade-exit-active{
	 *    transition: opacity 500ms;
	 * }
	 * ```
	 */
	
	var SwitchTransition = /*#__PURE__*/function (_React$Component) {
	  _inheritsLoose(SwitchTransition, _React$Component);
	
	  function SwitchTransition() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	    _this.state = {
	      status: _Transition.ENTERED,
	      current: null
	    };
	    _this.appeared = false;
	
	    _this.changeState = function (status, current) {
	      if (current === void 0) {
	        current = _this.state.current;
	      }
	
	      _this.setState({
	        status: status,
	        current: current
	      });
	    };
	
	    return _this;
	  }
	
	  var _proto = SwitchTransition.prototype;
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.appeared = true;
	  };
	
	  SwitchTransition.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
	    if (props.children == null) {
	      return {
	        current: null
	      };
	    }
	
	    if (state.status === _Transition.ENTERING && props.mode === modes.in) {
	      return {
	        status: _Transition.ENTERING
	      };
	    }
	
	    if (state.current && areChildrenDifferent(state.current, props.children)) {
	      return {
	        status: _Transition.EXITING
	      };
	    }
	
	    return {
	      current: _react.default.cloneElement(props.children, {
	        in: true
	      })
	    };
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        children = _this$props.children,
	        mode = _this$props.mode,
	        _this$state = this.state,
	        status = _this$state.status,
	        current = _this$state.current;
	    var data = {
	      children: children,
	      current: current,
	      changeState: this.changeState,
	      status: status
	    };
	    var component;
	
	    switch (status) {
	      case _Transition.ENTERING:
	        component = enterRenders[mode](data);
	        break;
	
	      case _Transition.EXITING:
	        component = leaveRenders[mode](data);
	        break;
	
	      case _Transition.ENTERED:
	        component = current;
	    }
	
	    return /*#__PURE__*/_react.default.createElement(_TransitionGroupContext.default.Provider, {
	      value: {
	        isMounting: !this.appeared
	      }
	    }, component);
	  };
	
	  return SwitchTransition;
	}(_react.default.Component);
	
	SwitchTransition.propTypes =  false ? {
	  /**
	   * Transition modes.
	   * `out-in`: Current element transitions out first, then when complete, the new element transitions in.
	   * `in-out`: New element transitions in first, then when complete, the current element transitions out.
	   *
	   * @type {'out-in'|'in-out'}
	   */
	  mode: _propTypes.default.oneOf([modes.in, modes.out]),
	
	  /**
	   * Any `Transition` or `CSSTransition` component.
	   */
	  children: _propTypes.default.oneOfType([_propTypes.default.element.isRequired])
	} : {};
	SwitchTransition.defaultProps = {
	  mode: modes.out
	};
	var _default = SwitchTransition;
	exports.default = _default;

/***/ },
/* 1522 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.getChildMapping = getChildMapping;
	exports.mergeChildMappings = mergeChildMappings;
	exports.getInitialChildMapping = getInitialChildMapping;
	exports.getNextChildMapping = getNextChildMapping;
	
	var _react = __webpack_require__(1);
	
	/**
	 * Given `this.props.children`, return an object mapping key to child.
	 *
	 * @param {*} children `this.props.children`
	 * @return {object} Mapping of key to child
	 */
	function getChildMapping(children, mapFn) {
	  var mapper = function mapper(child) {
	    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
	  };
	
	  var result = Object.create(null);
	  if (children) _react.Children.map(children, function (c) {
	    return c;
	  }).forEach(function (child) {
	    // run the map function here instead so that the key is the computed one
	    result[child.key] = mapper(child);
	  });
	  return result;
	}
	/**
	 * When you're adding or removing children some may be added or removed in the
	 * same render pass. We want to show *both* since we want to simultaneously
	 * animate elements in and out. This function takes a previous set of keys
	 * and a new set of keys and merges them with its best guess of the correct
	 * ordering. In the future we may expose some of the utilities in
	 * ReactMultiChild to make this easy, but for now React itself does not
	 * directly have this concept of the union of prevChildren and nextChildren
	 * so we implement it here.
	 *
	 * @param {object} prev prev children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @param {object} next next children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @return {object} a key set that contains all keys in `prev` and all keys
	 * in `next` in a reasonable order.
	 */
	
	
	function mergeChildMappings(prev, next) {
	  prev = prev || {};
	  next = next || {};
	
	  function getValueForKey(key) {
	    return key in next ? next[key] : prev[key];
	  } // For each key of `next`, the list of keys to insert before that key in
	  // the combined list
	
	
	  var nextKeysPending = Object.create(null);
	  var pendingKeys = [];
	
	  for (var prevKey in prev) {
	    if (prevKey in next) {
	      if (pendingKeys.length) {
	        nextKeysPending[prevKey] = pendingKeys;
	        pendingKeys = [];
	      }
	    } else {
	      pendingKeys.push(prevKey);
	    }
	  }
	
	  var i;
	  var childMapping = {};
	
	  for (var nextKey in next) {
	    if (nextKeysPending[nextKey]) {
	      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	        var pendingNextKey = nextKeysPending[nextKey][i];
	        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
	      }
	    }
	
	    childMapping[nextKey] = getValueForKey(nextKey);
	  } // Finally, add the keys which didn't appear before any key in `next`
	
	
	  for (i = 0; i < pendingKeys.length; i++) {
	    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	  }
	
	  return childMapping;
	}
	
	function getProp(child, prop, props) {
	  return props[prop] != null ? props[prop] : child.props[prop];
	}
	
	function getInitialChildMapping(props, onExited) {
	  return getChildMapping(props.children, function (child) {
	    return (0, _react.cloneElement)(child, {
	      onExited: onExited.bind(null, child),
	      in: true,
	      appear: getProp(child, 'appear', props),
	      enter: getProp(child, 'enter', props),
	      exit: getProp(child, 'exit', props)
	    });
	  });
	}
	
	function getNextChildMapping(nextProps, prevChildMapping, onExited) {
	  var nextChildMapping = getChildMapping(nextProps.children);
	  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
	  Object.keys(children).forEach(function (key) {
	    var child = children[key];
	    if (!(0, _react.isValidElement)(child)) return;
	    var hasPrev = (key in prevChildMapping);
	    var hasNext = (key in nextChildMapping);
	    var prevChild = prevChildMapping[key];
	    var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
	
	    if (hasNext && (!hasPrev || isLeaving)) {
	      // console.log('entering', key)
	      children[key] = (0, _react.cloneElement)(child, {
	        onExited: onExited.bind(null, child),
	        in: true,
	        exit: getProp(child, 'exit', nextProps),
	        enter: getProp(child, 'enter', nextProps)
	      });
	    } else if (!hasNext && hasPrev && !isLeaving) {
	      // item is old (exiting)
	      // console.log('leaving', key)
	      children[key] = (0, _react.cloneElement)(child, {
	        in: false
	      });
	    } else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
	      // item hasn't changed transition states
	      // copy over the last transition props;
	      // console.log('unchanged', key)
	      children[key] = (0, _react.cloneElement)(child, {
	        onExited: onExited.bind(null, child),
	        in: prevChild.props.in,
	        exit: getProp(child, 'exit', nextProps),
	        enter: getProp(child, 'enter', nextProps)
	      });
	    }
	  });
	  return children;
	}

/***/ },
/* 1523 */
/***/ function(module, exports, __webpack_require__) {

	/** @license React v16.14.0
	 * react.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var l=__webpack_require__(58),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113,z=n?Symbol.for("react.memo"):60115,A=n?Symbol.for("react.lazy"):
	60116,B="function"===typeof Symbol&&Symbol.iterator;function C(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
	var D={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},E={};function F(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(C(85));this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
	function G(){}G.prototype=F.prototype;function H(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}var I=H.prototype=new G;I.constructor=H;l(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
	function M(a,b,c){var e,d={},g=null,k=null;if(null!=b)for(e in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,e)&&!L.hasOwnProperty(e)&&(d[e]=b[e]);var f=arguments.length-2;if(1===f)d.children=c;else if(1<f){for(var h=Array(f),m=0;m<f;m++)h[m]=arguments[m+2];d.children=h}if(a&&a.defaultProps)for(e in f=a.defaultProps,f)void 0===d[e]&&(d[e]=f[e]);return{$$typeof:p,type:a,key:g,ref:k,props:d,_owner:J.current}}
	function N(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function O(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var P=/\/+/g,Q=[];function R(a,b,c,e){if(Q.length){var d=Q.pop();d.result=a;d.keyPrefix=b;d.func=c;d.context=e;d.count=0;return d}return{result:a,keyPrefix:b,func:c,context:e,count:0}}
	function S(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>Q.length&&Q.push(a)}
	function T(a,b,c,e){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return c(e,a,""===b?"."+U(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+U(d,k);g+=T(d,f,c,e)}else if(null===a||"object"!==typeof a?f=null:(f=B&&a[B]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),k=
	0;!(d=a.next()).done;)d=d.value,f=b+U(d,k++),g+=T(d,f,c,e);else if("object"===d)throw c=""+a,Error(C(31,"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,""));return g}function V(a,b,c){return null==a?0:T(a,"",b,c)}function U(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function W(a,b){a.func.call(a.context,b,a.count++)}
	function aa(a,b,c){var e=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?X(a,e,c,function(a){return a}):null!=a&&(O(a)&&(a=N(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(P,"$&/")+"/")+c)),e.push(a))}function X(a,b,c,e,d){var g="";null!=c&&(g=(""+c).replace(P,"$&/")+"/");b=R(b,g,e,d);V(a,aa,b);S(b)}var Y={current:null};function Z(){var a=Y.current;if(null===a)throw Error(C(321));return a}
	var ba={ReactCurrentDispatcher:Y,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:l};exports.Children={map:function(a,b,c){if(null==a)return a;var e=[];X(a,e,null,b,c);return e},forEach:function(a,b,c){if(null==a)return a;b=R(null,null,b,c);V(a,W,b);S(b)},count:function(a){return V(a,function(){return null},null)},toArray:function(a){var b=[];X(a,b,null,function(a){return a});return b},only:function(a){if(!O(a))throw Error(C(143));return a}};
	exports.Component=F;exports.Fragment=r;exports.Profiler=u;exports.PureComponent=H;exports.StrictMode=t;exports.Suspense=y;exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=ba;
	exports.cloneElement=function(a,b,c){if(null===a||void 0===a)throw Error(C(267,a));var e=l({},a.props),d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=J.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)K.call(b,h)&&!L.hasOwnProperty(h)&&(e[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)e.children=c;else if(1<h){f=Array(h);for(var m=0;m<h;m++)f[m]=arguments[m+2];e.children=f}return{$$typeof:p,type:a.type,
	key:d,ref:g,props:e,_owner:k}};exports.createContext=function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a};exports.createElement=M;exports.createFactory=function(a){var b=M.bind(null,a);b.type=a;return b};exports.createRef=function(){return{current:null}};exports.forwardRef=function(a){return{$$typeof:x,render:a}};exports.isValidElement=O;
	exports.lazy=function(a){return{$$typeof:A,_ctor:a,_status:-1,_result:null}};exports.memo=function(a,b){return{$$typeof:z,type:a,compare:void 0===b?null:b}};exports.useCallback=function(a,b){return Z().useCallback(a,b)};exports.useContext=function(a,b){return Z().useContext(a,b)};exports.useDebugValue=function(){};exports.useEffect=function(a,b){return Z().useEffect(a,b)};exports.useImperativeHandle=function(a,b,c){return Z().useImperativeHandle(a,b,c)};
	exports.useLayoutEffect=function(a,b){return Z().useLayoutEffect(a,b)};exports.useMemo=function(a,b){return Z().useMemo(a,b)};exports.useReducer=function(a,b,c){return Z().useReducer(a,b,c)};exports.useRef=function(a){return Z().useRef(a)};exports.useState=function(a){return Z().useState(a)};exports.version="16.14.0";


/***/ },
/* 1524 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _utils = __webpack_require__(11);
	
	var propTypes = {
	  color: _propTypes.default.string,
	  pill: _propTypes.default.bool,
	  tag: _utils.tagPropType,
	  innerRef: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func, _propTypes.default.string]),
	  children: _propTypes.default.node,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  color: 'secondary',
	  pill: false,
	  tag: 'span'
	};
	
	var Badge = function Badge(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      color = props.color,
	      innerRef = props.innerRef,
	      pill = props.pill,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "color", "innerRef", "pill", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'badge', 'badge-' + color, pill ? 'badge-pill' : false), cssModule);
	
	  if (attributes.href && Tag === 'span') {
	    Tag = 'a';
	  }
	
	  return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes,
	    ref: innerRef
	  }));
	};
	
	Badge.propTypes = propTypes;
	Badge.defaultProps = defaultProps;
	var _default = Badge;
	exports.default = _default;

/***/ },
/* 1525 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _utils = __webpack_require__(11);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  listTag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  listClassName: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  children: _propTypes.default.node,
	  'aria-label': _propTypes.default.string
	};
	var defaultProps = {
	  tag: 'nav',
	  listTag: 'ol',
	  'aria-label': 'breadcrumb'
	};
	
	var Breadcrumb = function Breadcrumb(props) {
	  var className = props.className,
	      listClassName = props.listClassName,
	      cssModule = props.cssModule,
	      children = props.children,
	      Tag = props.tag,
	      ListTag = props.listTag,
	      label = props['aria-label'],
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "listClassName", "cssModule", "children", "tag", "listTag", "aria-label"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className), cssModule);
	  var listClasses = (0, _utils.mapToCssModules)((0, _classnames.default)('breadcrumb', listClassName), cssModule);
	  return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes,
	    "aria-label": label
	  }), _react.default.createElement(ListTag, {
	    className: listClasses
	  }, children));
	};
	
	Breadcrumb.propTypes = propTypes;
	Breadcrumb.defaultProps = defaultProps;
	var _default = Breadcrumb;
	exports.default = _default;

/***/ },
/* 1526 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _utils = __webpack_require__(11);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  active: _propTypes.default.bool,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'li'
	};
	
	var BreadcrumbItem = function BreadcrumbItem(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      active = props.active,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "active", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, active ? 'active' : false, 'breadcrumb-item'), cssModule);
	  return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes,
	    "aria-current": active ? 'page' : undefined
	  }));
	};
	
	BreadcrumbItem.propTypes = propTypes;
	BreadcrumbItem.defaultProps = defaultProps;
	var _default = BreadcrumbItem;
	exports.default = _default;

/***/ },
/* 1527 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _utils = __webpack_require__(11);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  'aria-label': _propTypes.default.string,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  role: _propTypes.default.string,
	  size: _propTypes.default.string,
	  vertical: _propTypes.default.bool
	};
	var defaultProps = {
	  tag: 'div',
	  role: 'group'
	};
	
	var ButtonGroup = function ButtonGroup(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      size = props.size,
	      vertical = props.vertical,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "size", "vertical", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, size ? 'btn-group-' + size : false, vertical ? 'btn-group-vertical' : 'btn-group'), cssModule);
	  return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	ButtonGroup.propTypes = propTypes;
	ButtonGroup.defaultProps = defaultProps;
	var _default = ButtonGroup;
	exports.default = _default;

/***/ },
/* 1528 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(13));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(12));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(34));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _Button = _interopRequireDefault(__webpack_require__(301));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _utils = __webpack_require__(11);
	
	var propTypes = {
	  onClick: _propTypes.default.func,
	  onBlur: _propTypes.default.func,
	  onFocus: _propTypes.default.func,
	  defaultValue: _propTypes.default.bool
	};
	var defaultProps = {
	  defaultValue: false
	};
	
	var ButtonToggle =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(ButtonToggle, _React$Component);
	
	  function ButtonToggle(props) {
	    var _this;
	
	    _this = _React$Component.call(this, props) || this;
	    _this.state = {
	      toggled: props.defaultValue,
	      focus: false
	    };
	    _this.onBlur = _this.onBlur.bind((0, _assertThisInitialized2.default)(_this));
	    _this.onFocus = _this.onFocus.bind((0, _assertThisInitialized2.default)(_this));
	    _this.onClick = _this.onClick.bind((0, _assertThisInitialized2.default)(_this));
	    return _this;
	  }
	
	  var _proto = ButtonToggle.prototype;
	
	  _proto.onBlur = function onBlur(e) {
	    if (this.props.onBlur) {
	      this.props.onBlur(e);
	    }
	
	    this.setState({
	      focus: false
	    });
	  };
	
	  _proto.onFocus = function onFocus(e) {
	    if (this.props.onFocus) {
	      this.props.onFocus(e);
	    }
	
	    this.setState({
	      focus: true
	    });
	  };
	
	  _proto.onClick = function onClick(e) {
	    if (this.props.onClick) {
	      this.props.onClick(e);
	    }
	
	    this.setState(function (_ref) {
	      var toggled = _ref.toggled;
	      return {
	        toggled: !toggled
	      };
	    });
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        className = _this$props.className,
	        attributes = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["className"]);
	    var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, {
	      focus: this.state.focus
	    }), this.props.cssModule);
	    return _react.default.createElement(_Button.default, (0, _extends2.default)({
	      active: this.state.toggled,
	      onBlur: this.onBlur,
	      onFocus: this.onFocus,
	      onClick: this.onClick,
	      className: classes
	    }, attributes));
	  };
	
	  return ButtonToggle;
	}(_react.default.Component);
	
	ButtonToggle.propTypes = propTypes;
	ButtonToggle.defaultProps = defaultProps;
	var _default = ButtonToggle;
	exports.default = _default;

/***/ },
/* 1529 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _utils = __webpack_require__(11);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  'aria-label': _propTypes.default.string,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  role: _propTypes.default.string
	};
	var defaultProps = {
	  tag: 'div',
	  role: 'toolbar'
	};
	
	var ButtonToolbar = function ButtonToolbar(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'btn-toolbar'), cssModule);
	  return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	ButtonToolbar.propTypes = propTypes;
	ButtonToolbar.defaultProps = defaultProps;
	var _default = ButtonToolbar;
	exports.default = _default;

/***/ },
/* 1530 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _utils = __webpack_require__(11);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  inverse: _propTypes.default.bool,
	  color: _propTypes.default.string,
	  body: _propTypes.default.bool,
	  outline: _propTypes.default.bool,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  innerRef: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string, _propTypes.default.func])
	};
	var defaultProps = {
	  tag: 'div'
	};
	
	var Card = function Card(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      color = props.color,
	      body = props.body,
	      inverse = props.inverse,
	      outline = props.outline,
	      Tag = props.tag,
	      innerRef = props.innerRef,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "color", "body", "inverse", "outline", "tag", "innerRef"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'card', inverse ? 'text-white' : false, body ? 'card-body' : false, color ? (outline ? 'border' : 'bg') + "-" + color : false), cssModule);
	  return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes,
	    ref: innerRef
	  }));
	};
	
	Card.propTypes = propTypes;
	Card.defaultProps = defaultProps;
	var _default = Card;
	exports.default = _default;

/***/ },
/* 1531 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _utils = __webpack_require__(11);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  innerRef: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string, _propTypes.default.func])
	};
	var defaultProps = {
	  tag: 'div'
	};
	
	var CardBody = function CardBody(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      innerRef = props.innerRef,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "innerRef", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'card-body'), cssModule);
	  return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes,
	    ref: innerRef
	  }));
	};
	
	CardBody.propTypes = propTypes;
	CardBody.defaultProps = defaultProps;
	var _default = CardBody;
	exports.default = _default;

/***/ },
/* 1532 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _utils = __webpack_require__(11);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'div'
	};
	
	var CardColumns = function CardColumns(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'card-columns'), cssModule);
	  return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	CardColumns.propTypes = propTypes;
	CardColumns.defaultProps = defaultProps;
	var _default = CardColumns;
	exports.default = _default;

/***/ },
/* 1533 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _utils = __webpack_require__(11);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'div'
	};
	
	var CardDeck = function CardDeck(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'card-deck'), cssModule);
	  return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	CardDeck.propTypes = propTypes;
	CardDeck.defaultProps = defaultProps;
	var _default = CardDeck;
	exports.default = _default;

/***/ },
/* 1534 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _utils = __webpack_require__(11);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'div'
	};
	
	var CardFooter = function CardFooter(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'card-footer'), cssModule);
	  return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	CardFooter.propTypes = propTypes;
	CardFooter.defaultProps = defaultProps;
	var _default = CardFooter;
	exports.default = _default;

/***/ },
/* 1535 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _utils = __webpack_require__(11);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'div'
	};
	
	var CardGroup = function CardGroup(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'card-group'), cssModule);
	  return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	CardGroup.propTypes = propTypes;
	CardGroup.defaultProps = defaultProps;
	var _default = CardGroup;
	exports.default = _default;

/***/ },
/* 1536 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _utils = __webpack_require__(11);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'div'
	};
	
	var CardHeader = function CardHeader(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'card-header'), cssModule);
	  return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	CardHeader.propTypes = propTypes;
	CardHeader.defaultProps = defaultProps;
	var _default = CardHeader;
	exports.default = _default;

/***/ },
/* 1537 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _utils = __webpack_require__(11);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  top: _propTypes.default.bool,
	  bottom: _propTypes.default.bool,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'img'
	};
	
	var CardImg = function CardImg(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      top = props.top,
	      bottom = props.bottom,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "top", "bottom", "tag"]);
	  var cardImgClassName = 'card-img';
	
	  if (top) {
	    cardImgClassName = 'card-img-top';
	  }
	
	  if (bottom) {
	    cardImgClassName = 'card-img-bottom';
	  }
	
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, cardImgClassName), cssModule);
	  return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	CardImg.propTypes = propTypes;
	CardImg.defaultProps = defaultProps;
	var _default = CardImg;
	exports.default = _default;

/***/ },
/* 1538 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _utils = __webpack_require__(11);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'div'
	};
	
	var CardImgOverlay = function CardImgOverlay(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'card-img-overlay'), cssModule);
	  return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	CardImgOverlay.propTypes = propTypes;
	CardImgOverlay.defaultProps = defaultProps;
	var _default = CardImgOverlay;
	exports.default = _default;

/***/ },
/* 1539 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _utils = __webpack_require__(11);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  innerRef: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func, _propTypes.default.string]),
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'a'
	};
	
	var CardLink = function CardLink(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      innerRef = props.innerRef,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "tag", "innerRef"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'card-link'), cssModule);
	  return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    ref: innerRef,
	    className: classes
	  }));
	};
	
	CardLink.propTypes = propTypes;
	CardLink.defaultProps = defaultProps;
	var _default = CardLink;
	exports.default = _default;

/***/ },
/* 1540 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _utils = __webpack_require__(11);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'div'
	};
	
	var CardSubtitle = function CardSubtitle(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'card-subtitle'), cssModule);
	  return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	CardSubtitle.propTypes = propTypes;
	CardSubtitle.defaultProps = defaultProps;
	var _default = CardSubtitle;
	exports.default = _default;

/***/ },
/* 1541 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _utils = __webpack_require__(11);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'p'
	};
	
	var CardText = function CardText(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'card-text'), cssModule);
	  return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	CardText.propTypes = propTypes;
	CardText.defaultProps = defaultProps;
	var _default = CardText;
	exports.default = _default;

/***/ },
/* 1542 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _utils = __webpack_require__(11);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'div'
	};
	
	var CardTitle = function CardTitle(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'card-title'), cssModule);
	  return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	CardTitle.propTypes = propTypes;
	CardTitle.defaultProps = defaultProps;
	var _default = CardTitle;
	exports.default = _default;

/***/ },
/* 1543 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _utils = __webpack_require__(11);
	
	var colWidths = ['xs', 'sm', 'md', 'lg', 'xl'];
	
	var stringOrNumberProp = _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]);
	
	var columnProps = _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.number, _propTypes.default.string, _propTypes.default.shape({
	  size: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.number, _propTypes.default.string]),
	  order: stringOrNumberProp,
	  offset: stringOrNumberProp
	})]);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  xs: columnProps,
	  sm: columnProps,
	  md: columnProps,
	  lg: columnProps,
	  xl: columnProps,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  widths: _propTypes.default.array
	};
	var defaultProps = {
	  tag: 'div',
	  widths: colWidths
	};
	
	var getColumnSizeClass = function getColumnSizeClass(isXs, colWidth, colSize) {
	  if (colSize === true || colSize === '') {
	    return isXs ? 'col' : "col-" + colWidth;
	  } else if (colSize === 'auto') {
	    return isXs ? 'col-auto' : "col-" + colWidth + "-auto";
	  }
	
	  return isXs ? "col-" + colSize : "col-" + colWidth + "-" + colSize;
	};
	
	var Col = function Col(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      widths = props.widths,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "widths", "tag"]);
	  var colClasses = [];
	  widths.forEach(function (colWidth, i) {
	    var columnProp = props[colWidth];
	    delete attributes[colWidth];
	
	    if (!columnProp && columnProp !== '') {
	      return;
	    }
	
	    var isXs = !i;
	
	    if ((0, _utils.isObject)(columnProp)) {
	      var _classNames;
	
	      var colSizeInterfix = isXs ? '-' : "-" + colWidth + "-";
	      var colClass = getColumnSizeClass(isXs, colWidth, columnProp.size);
	      colClasses.push((0, _utils.mapToCssModules)((0, _classnames.default)((_classNames = {}, _classNames[colClass] = columnProp.size || columnProp.size === '', _classNames["order" + colSizeInterfix + columnProp.order] = columnProp.order || columnProp.order === 0, _classNames["offset" + colSizeInterfix + columnProp.offset] = columnProp.offset || columnProp.offset === 0, _classNames)), cssModule));
	    } else {
	      var _colClass = getColumnSizeClass(isXs, colWidth, columnProp);
	
	      colClasses.push(_colClass);
	    }
	  });
	
	  if (!colClasses.length) {
	    colClasses.push('col');
	  }
	
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, colClasses), cssModule);
	  return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	Col.propTypes = propTypes;
	Col.defaultProps = defaultProps;
	var _default = Col;
	exports.default = _default;

/***/ },
/* 1544 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _utils = __webpack_require__(11);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  fluid: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'div'
	};
	
	var Container = function Container(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      fluid = props.fluid,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "fluid", "tag"]);
	  var containerClass = 'container';
	
	  if (fluid === true) {
	    containerClass = 'container-fluid';
	  } else if (fluid) {
	    containerClass = "container-" + fluid;
	  }
	
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, containerClass), cssModule);
	  return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	Container.propTypes = propTypes;
	Container.defaultProps = defaultProps;
	var _default = Container;
	exports.default = _default;

/***/ },
/* 1545 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _utils = __webpack_require__(11);
	
	var _CustomFileInput = _interopRequireDefault(__webpack_require__(644));
	
	var propTypes = {
	  className: _propTypes.default.string,
	  id: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]).isRequired,
	  type: _propTypes.default.string.isRequired,
	  label: _propTypes.default.node,
	  inline: _propTypes.default.bool,
	  valid: _propTypes.default.bool,
	  invalid: _propTypes.default.bool,
	  bsSize: _propTypes.default.string,
	  htmlFor: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.array, _propTypes.default.func]),
	  innerRef: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string, _propTypes.default.func])
	};
	
	function CustomInput(props) {
	  var className = props.className,
	      label = props.label,
	      inline = props.inline,
	      valid = props.valid,
	      invalid = props.invalid,
	      cssModule = props.cssModule,
	      children = props.children,
	      bsSize = props.bsSize,
	      innerRef = props.innerRef,
	      htmlFor = props.htmlFor,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "label", "inline", "valid", "invalid", "cssModule", "children", "bsSize", "innerRef", "htmlFor"]);
	  var type = attributes.type;
	  var customClass = (0, _utils.mapToCssModules)((0, _classnames.default)(className, "custom-" + type, bsSize ? "custom-" + type + "-" + bsSize : false), cssModule);
	  var validationClassNames = (0, _utils.mapToCssModules)((0, _classnames.default)(invalid && 'is-invalid', valid && 'is-valid'), cssModule);
	  var labelHtmlFor = htmlFor || attributes.id;
	
	  if (type === 'select') {
	    var _type = attributes.type,
	        rest = (0, _objectWithoutPropertiesLoose2.default)(attributes, ["type"]);
	    return _react.default.createElement("select", (0, _extends2.default)({}, rest, {
	      ref: innerRef,
	      className: (0, _classnames.default)(validationClassNames, customClass)
	    }), children);
	  }
	
	  if (type === 'file') {
	    return _react.default.createElement(_CustomFileInput.default, props);
	  }
	
	  if (type !== 'checkbox' && type !== 'radio' && type !== 'switch') {
	    return _react.default.createElement("input", (0, _extends2.default)({}, attributes, {
	      ref: innerRef,
	      className: (0, _classnames.default)(validationClassNames, customClass)
	    }));
	  }
	
	  var wrapperClasses = (0, _classnames.default)(customClass, (0, _utils.mapToCssModules)((0, _classnames.default)('custom-control', {
	    'custom-control-inline': inline
	  }), cssModule));
	  return _react.default.createElement("div", {
	    className: wrapperClasses
	  }, _react.default.createElement("input", (0, _extends2.default)({}, attributes, {
	    type: type === 'switch' ? 'checkbox' : type,
	    ref: innerRef,
	    className: (0, _classnames.default)(validationClassNames, (0, _utils.mapToCssModules)('custom-control-input', cssModule))
	  })), _react.default.createElement("label", {
	    className: (0, _utils.mapToCssModules)('custom-control-label', cssModule),
	    htmlFor: labelHtmlFor
	  }, label), children);
	}
	
	CustomInput.propTypes = propTypes;
	var _default = CustomInput;
	exports.default = _default;

/***/ },
/* 1546 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(13));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(12));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(34));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _DropdownContext = __webpack_require__(172);
	
	var _utils = __webpack_require__(11);
	
	var propTypes = {
	  children: _propTypes.default.node,
	  active: _propTypes.default.bool,
	  disabled: _propTypes.default.bool,
	  divider: _propTypes.default.bool,
	  tag: _utils.tagPropType,
	  header: _propTypes.default.bool,
	  onClick: _propTypes.default.func,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  toggle: _propTypes.default.bool
	};
	var defaultProps = {
	  tag: 'button',
	  toggle: true
	};
	
	var DropdownItem =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(DropdownItem, _React$Component);
	
	  function DropdownItem(props) {
	    var _this;
	
	    _this = _React$Component.call(this, props) || this;
	    _this.onClick = _this.onClick.bind((0, _assertThisInitialized2.default)(_this));
	    _this.getTabIndex = _this.getTabIndex.bind((0, _assertThisInitialized2.default)(_this));
	    return _this;
	  }
	
	  var _proto = DropdownItem.prototype;
	
	  _proto.onClick = function onClick(e) {
	    if (this.props.disabled || this.props.header || this.props.divider) {
	      e.preventDefault();
	      return;
	    }
	
	    if (this.props.onClick) {
	      this.props.onClick(e);
	    }
	
	    if (this.props.toggle) {
	      this.context.toggle(e);
	    }
	  };
	
	  _proto.getTabIndex = function getTabIndex() {
	    if (this.props.disabled || this.props.header || this.props.divider) {
	      return '-1';
	    }
	
	    return '0';
	  };
	
	  _proto.render = function render() {
	    var tabIndex = this.getTabIndex();
	    var role = tabIndex > -1 ? 'menuitem' : undefined;
	
	    var _omit = (0, _utils.omit)(this.props, ['toggle']),
	        className = _omit.className,
	        cssModule = _omit.cssModule,
	        divider = _omit.divider,
	        Tag = _omit.tag,
	        header = _omit.header,
	        active = _omit.active,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_omit, ["className", "cssModule", "divider", "tag", "header", "active"]);
	
	    var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, {
	      disabled: props.disabled,
	      'dropdown-item': !divider && !header,
	      active: active,
	      'dropdown-header': header,
	      'dropdown-divider': divider
	    }), cssModule);
	
	    if (Tag === 'button') {
	      if (header) {
	        Tag = 'h6';
	      } else if (divider) {
	        Tag = 'div';
	      } else if (props.href) {
	        Tag = 'a';
	      }
	    }
	
	    return _react.default.createElement(Tag, (0, _extends2.default)({
	      type: Tag === 'button' && (props.onClick || this.props.toggle) ? 'button' : undefined
	    }, props, {
	      tabIndex: tabIndex,
	      role: role,
	      className: classes,
	      onClick: this.onClick
	    }));
	  };
	
	  return DropdownItem;
	}(_react.default.Component);
	
	DropdownItem.propTypes = propTypes;
	DropdownItem.defaultProps = defaultProps;
	DropdownItem.contextType = _DropdownContext.DropdownContext;
	var _default = DropdownItem;
	exports.default = _default;

/***/ },
/* 1547 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectSpread3 = _interopRequireDefault(__webpack_require__(47));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(13));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(34));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _reactPopper = __webpack_require__(169);
	
	var _DropdownContext = __webpack_require__(172);
	
	var _utils = __webpack_require__(11);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  children: _propTypes.default.node.isRequired,
	  right: _propTypes.default.bool,
	  flip: _propTypes.default.bool,
	  modifiers: _propTypes.default.object,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  persist: _propTypes.default.bool,
	  positionFixed: _propTypes.default.bool
	};
	var defaultProps = {
	  tag: 'div',
	  flip: true
	};
	var noFlipModifier = {
	  flip: {
	    enabled: false
	  }
	};
	var directionPositionMap = {
	  up: 'top',
	  left: 'left',
	  right: 'right',
	  down: 'bottom'
	};
	
	var DropdownMenu =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(DropdownMenu, _React$Component);
	
	  function DropdownMenu() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = DropdownMenu.prototype;
	
	  _proto.render = function render() {
	    var _this = this;
	
	    var _this$props = this.props,
	        className = _this$props.className,
	        cssModule = _this$props.cssModule,
	        right = _this$props.right,
	        tag = _this$props.tag,
	        flip = _this$props.flip,
	        modifiers = _this$props.modifiers,
	        persist = _this$props.persist,
	        positionFixed = _this$props.positionFixed,
	        attrs = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["className", "cssModule", "right", "tag", "flip", "modifiers", "persist", "positionFixed"]);
	    var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'dropdown-menu', {
	      'dropdown-menu-right': right,
	      show: this.context.isOpen
	    }), cssModule);
	    var Tag = tag;
	
	    if (persist || this.context.isOpen && !this.context.inNavbar) {
	      var position1 = directionPositionMap[this.context.direction] || 'bottom';
	      var position2 = right ? 'end' : 'start';
	      var poperPlacement = position1 + "-" + position2;
	      var poperModifiers = !flip ? (0, _objectSpread3.default)({}, modifiers, {}, noFlipModifier) : modifiers;
	      var popperPositionFixed = !!positionFixed;
	      return _react.default.createElement(_reactPopper.Popper, {
	        placement: poperPlacement,
	        modifiers: poperModifiers,
	        positionFixed: popperPositionFixed
	      }, function (_ref) {
	        var ref = _ref.ref,
	            style = _ref.style,
	            placement = _ref.placement;
	        return _react.default.createElement(Tag, (0, _extends2.default)({
	          tabIndex: "-1",
	          role: "menu",
	          ref: ref,
	          style: style
	        }, attrs, {
	          "aria-hidden": !_this.context.isOpen,
	          className: classes,
	          "x-placement": placement
	        }));
	      });
	    }
	
	    return _react.default.createElement(Tag, (0, _extends2.default)({
	      tabIndex: "-1",
	      role: "menu"
	    }, attrs, {
	      "aria-hidden": !this.context.isOpen,
	      className: classes,
	      "x-placement": attrs.placement
	    }));
	  };
	
	  return DropdownMenu;
	}(_react.default.Component);
	
	;
	DropdownMenu.propTypes = propTypes;
	DropdownMenu.defaultProps = defaultProps;
	DropdownMenu.contextType = _DropdownContext.DropdownContext;
	var _default = DropdownMenu;
	exports.default = _default;

/***/ },
/* 1548 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(13));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(12));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(34));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _reactPopper = __webpack_require__(169);
	
	var _DropdownContext = __webpack_require__(172);
	
	var _utils = __webpack_require__(11);
	
	var _Button = _interopRequireDefault(__webpack_require__(301));
	
	var propTypes = {
	  caret: _propTypes.default.bool,
	  color: _propTypes.default.string,
	  children: _propTypes.default.node,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  disabled: _propTypes.default.bool,
	  onClick: _propTypes.default.func,
	  'aria-haspopup': _propTypes.default.bool,
	  split: _propTypes.default.bool,
	  tag: _utils.tagPropType,
	  nav: _propTypes.default.bool
	};
	var defaultProps = {
	  'aria-haspopup': true,
	  color: 'secondary'
	};
	
	var DropdownToggle =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(DropdownToggle, _React$Component);
	
	  function DropdownToggle(props) {
	    var _this;
	
	    _this = _React$Component.call(this, props) || this;
	    _this.onClick = _this.onClick.bind((0, _assertThisInitialized2.default)(_this));
	    return _this;
	  }
	
	  var _proto = DropdownToggle.prototype;
	
	  _proto.onClick = function onClick(e) {
	    if (this.props.disabled || this.context.disabled) {
	      e.preventDefault();
	      return;
	    }
	
	    if (this.props.nav && !this.props.tag) {
	      e.preventDefault();
	    }
	
	    if (this.props.onClick) {
	      this.props.onClick(e);
	    }
	
	    this.context.toggle(e);
	  };
	
	  _proto.render = function render() {
	    var _this2 = this;
	
	    var _this$props = this.props,
	        className = _this$props.className,
	        color = _this$props.color,
	        cssModule = _this$props.cssModule,
	        caret = _this$props.caret,
	        split = _this$props.split,
	        nav = _this$props.nav,
	        tag = _this$props.tag,
	        innerRef = _this$props.innerRef,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["className", "color", "cssModule", "caret", "split", "nav", "tag", "innerRef"]);
	    var ariaLabel = props['aria-label'] || 'Toggle Dropdown';
	    var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, {
	      'dropdown-toggle': caret || split,
	      'dropdown-toggle-split': split,
	      'nav-link': nav
	    }), cssModule);
	
	    var children = props.children || _react.default.createElement("span", {
	      className: "sr-only"
	    }, ariaLabel);
	
	    var Tag;
	
	    if (nav && !tag) {
	      Tag = 'a';
	      props.href = '#';
	    } else if (!tag) {
	      Tag = _Button.default;
	      props.color = color;
	      props.cssModule = cssModule;
	    } else {
	      Tag = tag;
	    }
	
	    if (this.context.inNavbar) {
	      return _react.default.createElement(Tag, (0, _extends2.default)({}, props, {
	        className: classes,
	        onClick: this.onClick,
	        "aria-expanded": this.context.isOpen,
	        children: children
	      }));
	    }
	
	    return _react.default.createElement(_reactPopper.Reference, {
	      innerRef: innerRef
	    }, function (_ref) {
	      var _ref2;
	
	      var ref = _ref.ref;
	      return _react.default.createElement(Tag, (0, _extends2.default)({}, props, (_ref2 = {}, _ref2[typeof Tag === 'string' ? 'ref' : 'innerRef'] = ref, _ref2), {
	        className: classes,
	        onClick: _this2.onClick,
	        "aria-expanded": _this2.context.isOpen,
	        children: children
	      }));
	    });
	  };
	
	  return DropdownToggle;
	}(_react.default.Component);
	
	DropdownToggle.propTypes = propTypes;
	DropdownToggle.defaultProps = defaultProps;
	DropdownToggle.contextType = _DropdownContext.DropdownContext;
	var _default = DropdownToggle;
	exports.default = _default;

/***/ },
/* 1549 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(13));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(12));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(34));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _utils = __webpack_require__(11);
	
	var propTypes = {
	  children: _propTypes.default.node,
	  inline: _propTypes.default.bool,
	  tag: _utils.tagPropType,
	  innerRef: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func, _propTypes.default.string]),
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'form'
	};
	
	var Form =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inheritsLoose2.default)(Form, _Component);
	
	  function Form(props) {
	    var _this;
	
	    _this = _Component.call(this, props) || this;
	    _this.getRef = _this.getRef.bind((0, _assertThisInitialized2.default)(_this));
	    _this.submit = _this.submit.bind((0, _assertThisInitialized2.default)(_this));
	    return _this;
	  }
	
	  var _proto = Form.prototype;
	
	  _proto.getRef = function getRef(ref) {
	    if (this.props.innerRef) {
	      this.props.innerRef(ref);
	    }
	
	    this.ref = ref;
	  };
	
	  _proto.submit = function submit() {
	    if (this.ref) {
	      this.ref.submit();
	    }
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        className = _this$props.className,
	        cssModule = _this$props.cssModule,
	        inline = _this$props.inline,
	        Tag = _this$props.tag,
	        innerRef = _this$props.innerRef,
	        attributes = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["className", "cssModule", "inline", "tag", "innerRef"]);
	    var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, inline ? 'form-inline' : false), cssModule);
	    return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	      ref: innerRef,
	      className: classes
	    }));
	  };
	
	  return Form;
	}(_react.Component);
	
	Form.propTypes = propTypes;
	Form.defaultProps = defaultProps;
	var _default = Form;
	exports.default = _default;

/***/ },
/* 1550 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _utils = __webpack_require__(11);
	
	var propTypes = {
	  children: _propTypes.default.node,
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  valid: _propTypes.default.bool,
	  tooltip: _propTypes.default.bool
	};
	var defaultProps = {
	  tag: 'div',
	  valid: undefined
	};
	
	var FormFeedback = function FormFeedback(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      valid = props.valid,
	      tooltip = props.tooltip,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "valid", "tooltip", "tag"]);
	  var validMode = tooltip ? 'tooltip' : 'feedback';
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, valid ? "valid-" + validMode : "invalid-" + validMode), cssModule);
	  return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	FormFeedback.propTypes = propTypes;
	FormFeedback.defaultProps = defaultProps;
	var _default = FormFeedback;
	exports.default = _default;

/***/ },
/* 1551 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _utils = __webpack_require__(11);
	
	var propTypes = {
	  children: _propTypes.default.node,
	  row: _propTypes.default.bool,
	  check: _propTypes.default.bool,
	  inline: _propTypes.default.bool,
	  disabled: _propTypes.default.bool,
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'div'
	};
	
	var FormGroup = function FormGroup(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      row = props.row,
	      disabled = props.disabled,
	      check = props.check,
	      inline = props.inline,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "row", "disabled", "check", "inline", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, row ? 'row' : false, check ? 'form-check' : 'form-group', check && inline ? 'form-check-inline' : false, check && disabled ? 'disabled' : false), cssModule);
	
	  if (Tag === 'fieldset') {
	    attributes.disabled = disabled;
	  }
	
	  return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	FormGroup.propTypes = propTypes;
	FormGroup.defaultProps = defaultProps;
	var _default = FormGroup;
	exports.default = _default;

/***/ },
/* 1552 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _utils = __webpack_require__(11);
	
	var propTypes = {
	  children: _propTypes.default.node,
	  inline: _propTypes.default.bool,
	  tag: _utils.tagPropType,
	  color: _propTypes.default.string,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'small',
	  color: 'muted'
	};
	
	var FormText = function FormText(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      inline = props.inline,
	      color = props.color,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "inline", "color", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, !inline ? 'form-text' : false, color ? "text-" + color : false), cssModule);
	  return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	FormText.propTypes = propTypes;
	FormText.defaultProps = defaultProps;
	var _default = FormText;
	exports.default = _default;

/***/ },
/* 1553 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(13));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(12));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(34));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _utils = __webpack_require__(11);
	
	/* eslint react/prefer-stateless-function: 0 */
	var propTypes = {
	  children: _propTypes.default.node,
	  type: _propTypes.default.string,
	  size: _propTypes.default.string,
	  bsSize: _propTypes.default.string,
	  valid: _propTypes.default.bool,
	  invalid: _propTypes.default.bool,
	  tag: _utils.tagPropType,
	  innerRef: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func, _propTypes.default.string]),
	  plaintext: _propTypes.default.bool,
	  addon: _propTypes.default.bool,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  type: 'text'
	};
	
	var Input =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Input, _React$Component);
	
	  function Input(props) {
	    var _this;
	
	    _this = _React$Component.call(this, props) || this;
	    _this.getRef = _this.getRef.bind((0, _assertThisInitialized2.default)(_this));
	    _this.focus = _this.focus.bind((0, _assertThisInitialized2.default)(_this));
	    return _this;
	  }
	
	  var _proto = Input.prototype;
	
	  _proto.getRef = function getRef(ref) {
	    if (this.props.innerRef) {
	      this.props.innerRef(ref);
	    }
	
	    this.ref = ref;
	  };
	
	  _proto.focus = function focus() {
	    if (this.ref) {
	      this.ref.focus();
	    }
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        className = _this$props.className,
	        cssModule = _this$props.cssModule,
	        type = _this$props.type,
	        bsSize = _this$props.bsSize,
	        valid = _this$props.valid,
	        invalid = _this$props.invalid,
	        tag = _this$props.tag,
	        addon = _this$props.addon,
	        plaintext = _this$props.plaintext,
	        innerRef = _this$props.innerRef,
	        attributes = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["className", "cssModule", "type", "bsSize", "valid", "invalid", "tag", "addon", "plaintext", "innerRef"]);
	    var checkInput = ['radio', 'checkbox'].indexOf(type) > -1;
	    var isNotaNumber = new RegExp('\\D', 'g');
	    var fileInput = type === 'file';
	    var textareaInput = type === 'textarea';
	    var selectInput = type === 'select';
	    var Tag = tag || (selectInput || textareaInput ? type : 'input');
	    var formControlClass = 'form-control';
	
	    if (plaintext) {
	      formControlClass = formControlClass + "-plaintext";
	      Tag = tag || 'input';
	    } else if (fileInput) {
	      formControlClass = formControlClass + "-file";
	    } else if (checkInput) {
	      if (addon) {
	        formControlClass = null;
	      } else {
	        formControlClass = 'form-check-input';
	      }
	    }
	
	    if (attributes.size && isNotaNumber.test(attributes.size)) {
	      (0, _utils.warnOnce)('Please use the prop "bsSize" instead of the "size" to bootstrap\'s input sizing.');
	      bsSize = attributes.size;
	      delete attributes.size;
	    }
	
	    var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, invalid && 'is-invalid', valid && 'is-valid', bsSize ? "form-control-" + bsSize : false, formControlClass), cssModule);
	
	    if (Tag === 'input' || tag && typeof tag === 'function') {
	      attributes.type = type;
	    }
	
	    if (attributes.children && !(plaintext || type === 'select' || typeof Tag !== 'string' || Tag === 'select')) {
	      (0, _utils.warnOnce)("Input with a type of \"" + type + "\" cannot have children. Please use \"value\"/\"defaultValue\" instead.");
	      delete attributes.children;
	    }
	
	    return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	      ref: innerRef,
	      className: classes
	    }));
	  };
	
	  return Input;
	}(_react.default.Component);
	
	Input.propTypes = propTypes;
	Input.defaultProps = defaultProps;
	var _default = Input;
	exports.default = _default;

/***/ },
/* 1554 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _utils = __webpack_require__(11);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  size: _propTypes.default.string,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'div'
	};
	
	var InputGroup = function InputGroup(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      size = props.size,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "tag", "size"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'input-group', size ? "input-group-" + size : null), cssModule);
	  return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	InputGroup.propTypes = propTypes;
	InputGroup.defaultProps = defaultProps;
	var _default = InputGroup;
	exports.default = _default;

/***/ },
/* 1555 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _utils = __webpack_require__(11);
	
	var _InputGroupText = _interopRequireDefault(__webpack_require__(645));
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  addonType: _propTypes.default.oneOf(['prepend', 'append']).isRequired,
	  children: _propTypes.default.node,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'div'
	};
	
	var InputGroupAddon = function InputGroupAddon(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      addonType = props.addonType,
	      children = props.children,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "tag", "addonType", "children"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'input-group-' + addonType), cssModule); // Convenience to assist with transition
	
	  if (typeof children === 'string') {
	    return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	      className: classes
	    }), _react.default.createElement(_InputGroupText.default, {
	      children: children
	    }));
	  }
	
	  return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes,
	    children: children
	  }));
	};
	
	InputGroupAddon.propTypes = propTypes;
	InputGroupAddon.defaultProps = defaultProps;
	var _default = InputGroupAddon;
	exports.default = _default;

/***/ },
/* 1556 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _Dropdown = _interopRequireDefault(__webpack_require__(212));
	
	var propTypes = {
	  addonType: _propTypes.default.oneOf(['prepend', 'append']).isRequired,
	  children: _propTypes.default.node
	};
	
	var InputGroupButtonDropdown = function InputGroupButtonDropdown(props) {
	  return _react.default.createElement(_Dropdown.default, props);
	};
	
	InputGroupButtonDropdown.propTypes = propTypes;
	var _default = InputGroupButtonDropdown;
	exports.default = _default;

/***/ },
/* 1557 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _utils = __webpack_require__(11);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  fluid: _propTypes.default.bool,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'div'
	};
	
	var Jumbotron = function Jumbotron(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      fluid = props.fluid,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "tag", "fluid"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'jumbotron', fluid ? 'jumbotron-fluid' : false), cssModule);
	  return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	Jumbotron.propTypes = propTypes;
	Jumbotron.defaultProps = defaultProps;
	var _default = Jumbotron;
	exports.default = _default;

/***/ },
/* 1558 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _utils = __webpack_require__(11);
	
	var colWidths = ['xs', 'sm', 'md', 'lg', 'xl'];
	
	var stringOrNumberProp = _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]);
	
	var columnProps = _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.shape({
	  size: stringOrNumberProp,
	  order: stringOrNumberProp,
	  offset: stringOrNumberProp
	})]);
	
	var propTypes = {
	  children: _propTypes.default.node,
	  hidden: _propTypes.default.bool,
	  check: _propTypes.default.bool,
	  size: _propTypes.default.string,
	  for: _propTypes.default.string,
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  xs: columnProps,
	  sm: columnProps,
	  md: columnProps,
	  lg: columnProps,
	  xl: columnProps,
	  widths: _propTypes.default.array
	};
	var defaultProps = {
	  tag: 'label',
	  widths: colWidths
	};
	
	var getColumnSizeClass = function getColumnSizeClass(isXs, colWidth, colSize) {
	  if (colSize === true || colSize === '') {
	    return isXs ? 'col' : "col-" + colWidth;
	  } else if (colSize === 'auto') {
	    return isXs ? 'col-auto' : "col-" + colWidth + "-auto";
	  }
	
	  return isXs ? "col-" + colSize : "col-" + colWidth + "-" + colSize;
	};
	
	var Label = function Label(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      hidden = props.hidden,
	      widths = props.widths,
	      Tag = props.tag,
	      check = props.check,
	      size = props.size,
	      htmlFor = props.for,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "hidden", "widths", "tag", "check", "size", "for"]);
	  var colClasses = [];
	  widths.forEach(function (colWidth, i) {
	    var columnProp = props[colWidth];
	    delete attributes[colWidth];
	
	    if (!columnProp && columnProp !== '') {
	      return;
	    }
	
	    var isXs = !i;
	    var colClass;
	
	    if ((0, _utils.isObject)(columnProp)) {
	      var _classNames;
	
	      var colSizeInterfix = isXs ? '-' : "-" + colWidth + "-";
	      colClass = getColumnSizeClass(isXs, colWidth, columnProp.size);
	      colClasses.push((0, _utils.mapToCssModules)((0, _classnames.default)((_classNames = {}, _classNames[colClass] = columnProp.size || columnProp.size === '', _classNames["order" + colSizeInterfix + columnProp.order] = columnProp.order || columnProp.order === 0, _classNames["offset" + colSizeInterfix + columnProp.offset] = columnProp.offset || columnProp.offset === 0, _classNames))), cssModule);
	    } else {
	      colClass = getColumnSizeClass(isXs, colWidth, columnProp);
	      colClasses.push(colClass);
	    }
	  });
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, hidden ? 'sr-only' : false, check ? 'form-check-label' : false, size ? "col-form-label-" + size : false, colClasses, colClasses.length ? 'col-form-label' : false), cssModule);
	  return _react.default.createElement(Tag, (0, _extends2.default)({
	    htmlFor: htmlFor
	  }, attributes, {
	    className: classes
	  }));
	};
	
	Label.propTypes = propTypes;
	Label.defaultProps = defaultProps;
	var _default = Label;
	exports.default = _default;

/***/ },
/* 1559 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _utils = __webpack_require__(11);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  flush: _propTypes.default.bool,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  horizontal: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string])
	};
	var defaultProps = {
	  tag: 'ul',
	  horizontal: false
	};
	
	var getHorizontalClass = function getHorizontalClass(horizontal) {
	  if (horizontal === false) {
	    return false;
	  } else if (horizontal === true || horizontal === "xs") {
	    return "list-group-horizontal";
	  }
	
	  return "list-group-horizontal-" + horizontal;
	};
	
	var ListGroup = function ListGroup(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      flush = props.flush,
	      horizontal = props.horizontal,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "tag", "flush", "horizontal"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'list-group', // list-group-horizontal cannot currently be mixed with list-group-flush
	  // we only try to apply horizontal classes if flush is false
	  flush ? 'list-group-flush' : getHorizontalClass(horizontal)), cssModule);
	  return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	ListGroup.propTypes = propTypes;
	ListGroup.defaultProps = defaultProps;
	var _default = ListGroup;
	exports.default = _default;

/***/ },
/* 1560 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _utils = __webpack_require__(11);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  active: _propTypes.default.bool,
	  disabled: _propTypes.default.bool,
	  color: _propTypes.default.string,
	  action: _propTypes.default.bool,
	  className: _propTypes.default.any,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'li'
	};
	
	var handleDisabledOnClick = function handleDisabledOnClick(e) {
	  e.preventDefault();
	};
	
	var ListGroupItem = function ListGroupItem(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      active = props.active,
	      disabled = props.disabled,
	      action = props.action,
	      color = props.color,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "tag", "active", "disabled", "action", "color"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, active ? 'active' : false, disabled ? 'disabled' : false, action ? 'list-group-item-action' : false, color ? "list-group-item-" + color : false, 'list-group-item'), cssModule); // Prevent click event when disabled.
	
	  if (disabled) {
	    attributes.onClick = handleDisabledOnClick;
	  }
	
	  return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	ListGroupItem.propTypes = propTypes;
	ListGroupItem.defaultProps = defaultProps;
	var _default = ListGroupItem;
	exports.default = _default;

/***/ },
/* 1561 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _utils = __webpack_require__(11);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  className: _propTypes.default.any,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'h5'
	};
	
	var ListGroupItemHeading = function ListGroupItemHeading(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'list-group-item-heading'), cssModule);
	  return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	ListGroupItemHeading.propTypes = propTypes;
	ListGroupItemHeading.defaultProps = defaultProps;
	var _default = ListGroupItemHeading;
	exports.default = _default;

/***/ },
/* 1562 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _utils = __webpack_require__(11);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  className: _propTypes.default.any,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'p'
	};
	
	var ListGroupItemText = function ListGroupItemText(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'list-group-item-text'), cssModule);
	  return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	ListGroupItemText.propTypes = propTypes;
	ListGroupItemText.defaultProps = defaultProps;
	var _default = ListGroupItemText;
	exports.default = _default;

/***/ },
/* 1563 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _utils = __webpack_require__(11);
	
	var propTypes = {
	  body: _propTypes.default.bool,
	  bottom: _propTypes.default.bool,
	  children: _propTypes.default.node,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  heading: _propTypes.default.bool,
	  left: _propTypes.default.bool,
	  list: _propTypes.default.bool,
	  middle: _propTypes.default.bool,
	  object: _propTypes.default.bool,
	  right: _propTypes.default.bool,
	  tag: _utils.tagPropType,
	  top: _propTypes.default.bool
	};
	
	var Media = function Media(props) {
	  var body = props.body,
	      bottom = props.bottom,
	      className = props.className,
	      cssModule = props.cssModule,
	      heading = props.heading,
	      left = props.left,
	      list = props.list,
	      middle = props.middle,
	      object = props.object,
	      right = props.right,
	      tag = props.tag,
	      top = props.top,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["body", "bottom", "className", "cssModule", "heading", "left", "list", "middle", "object", "right", "tag", "top"]);
	  var defaultTag;
	
	  if (heading) {
	    defaultTag = 'h4';
	  } else if (attributes.href) {
	    defaultTag = 'a';
	  } else if (attributes.src || object) {
	    defaultTag = 'img';
	  } else if (list) {
	    defaultTag = 'ul';
	  } else {
	    defaultTag = 'div';
	  }
	
	  var Tag = tag || defaultTag;
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, {
	    'media-body': body,
	    'media-heading': heading,
	    'media-left': left,
	    'media-right': right,
	    'media-top': top,
	    'media-bottom': bottom,
	    'media-middle': middle,
	    'media-object': object,
	    'media-list': list,
	    media: !body && !heading && !left && !right && !top && !bottom && !middle && !object && !list
	  }), cssModule);
	  return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	Media.propTypes = propTypes;
	var _default = Media;
	exports.default = _default;

/***/ },
/* 1564 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _objectSpread4 = _interopRequireDefault(__webpack_require__(47));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(12));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(34));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _Portal = _interopRequireDefault(__webpack_require__(1580));
	
	var _Fade = _interopRequireDefault(__webpack_require__(173));
	
	var _utils = __webpack_require__(11);
	
	function noop() {}
	
	var FadePropTypes = _propTypes.default.shape(_Fade.default.propTypes);
	
	var propTypes = {
	  isOpen: _propTypes.default.bool,
	  autoFocus: _propTypes.default.bool,
	  centered: _propTypes.default.bool,
	  scrollable: _propTypes.default.bool,
	  size: _propTypes.default.string,
	  toggle: _propTypes.default.func,
	  keyboard: _propTypes.default.bool,
	  role: _propTypes.default.string,
	  labelledBy: _propTypes.default.string,
	  backdrop: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.oneOf(['static'])]),
	  onEnter: _propTypes.default.func,
	  onExit: _propTypes.default.func,
	  onOpened: _propTypes.default.func,
	  onClosed: _propTypes.default.func,
	  children: _propTypes.default.node,
	  className: _propTypes.default.string,
	  wrapClassName: _propTypes.default.string,
	  modalClassName: _propTypes.default.string,
	  backdropClassName: _propTypes.default.string,
	  contentClassName: _propTypes.default.string,
	  external: _propTypes.default.node,
	  fade: _propTypes.default.bool,
	  cssModule: _propTypes.default.object,
	  zIndex: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	  backdropTransition: FadePropTypes,
	  modalTransition: FadePropTypes,
	  innerRef: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string, _propTypes.default.func]),
	  unmountOnClose: _propTypes.default.bool,
	  returnFocusAfterClose: _propTypes.default.bool
	};
	var propsToOmit = Object.keys(propTypes);
	var defaultProps = {
	  isOpen: false,
	  autoFocus: true,
	  centered: false,
	  scrollable: false,
	  role: 'dialog',
	  backdrop: true,
	  keyboard: true,
	  zIndex: 1050,
	  fade: true,
	  onOpened: noop,
	  onClosed: noop,
	  modalTransition: {
	    timeout: _utils.TransitionTimeouts.Modal
	  },
	  backdropTransition: {
	    mountOnEnter: true,
	    timeout: _utils.TransitionTimeouts.Fade // uses standard fade transition
	
	  },
	  unmountOnClose: true,
	  returnFocusAfterClose: true
	};
	
	var Modal =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Modal, _React$Component);
	
	  function Modal(props) {
	    var _this;
	
	    _this = _React$Component.call(this, props) || this;
	    _this._element = null;
	    _this._originalBodyPadding = null;
	    _this.getFocusableChildren = _this.getFocusableChildren.bind((0, _assertThisInitialized2.default)(_this));
	    _this.handleBackdropClick = _this.handleBackdropClick.bind((0, _assertThisInitialized2.default)(_this));
	    _this.handleBackdropMouseDown = _this.handleBackdropMouseDown.bind((0, _assertThisInitialized2.default)(_this));
	    _this.handleEscape = _this.handleEscape.bind((0, _assertThisInitialized2.default)(_this));
	    _this.handleStaticBackdropAnimation = _this.handleStaticBackdropAnimation.bind((0, _assertThisInitialized2.default)(_this));
	    _this.handleTab = _this.handleTab.bind((0, _assertThisInitialized2.default)(_this));
	    _this.onOpened = _this.onOpened.bind((0, _assertThisInitialized2.default)(_this));
	    _this.onClosed = _this.onClosed.bind((0, _assertThisInitialized2.default)(_this));
	    _this.manageFocusAfterClose = _this.manageFocusAfterClose.bind((0, _assertThisInitialized2.default)(_this));
	    _this.clearBackdropAnimationTimeout = _this.clearBackdropAnimationTimeout.bind((0, _assertThisInitialized2.default)(_this));
	    _this.state = {
	      isOpen: false,
	      showStaticBackdropAnimation: false
	    };
	    return _this;
	  }
	
	  var _proto = Modal.prototype;
	
	  _proto.componentDidMount = function componentDidMount() {
	    var _this$props = this.props,
	        isOpen = _this$props.isOpen,
	        autoFocus = _this$props.autoFocus,
	        onEnter = _this$props.onEnter;
	
	    if (isOpen) {
	      this.init();
	      this.setState({
	        isOpen: true
	      });
	
	      if (autoFocus) {
	        this.setFocus();
	      }
	    }
	
	    if (onEnter) {
	      onEnter();
	    }
	
	    this._isMounted = true;
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
	    if (this.props.isOpen && !prevProps.isOpen) {
	      this.init();
	      this.setState({
	        isOpen: true
	      }); // let render() renders Modal Dialog first
	
	      return;
	    } // now Modal Dialog is rendered and we can refer this._element and this._dialog
	
	
	    if (this.props.autoFocus && this.state.isOpen && !prevState.isOpen) {
	      this.setFocus();
	    }
	
	    if (this._element && prevProps.zIndex !== this.props.zIndex) {
	      this._element.style.zIndex = this.props.zIndex;
	    }
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.clearBackdropAnimationTimeout();
	
	    if (this.props.onExit) {
	      this.props.onExit();
	    }
	
	    if (this._element) {
	      this.destroy();
	
	      if (this.props.isOpen) {
	        this.close();
	      }
	    }
	
	    this._isMounted = false;
	  };
	
	  _proto.onOpened = function onOpened(node, isAppearing) {
	    this.props.onOpened();
	    (this.props.modalTransition.onEntered || noop)(node, isAppearing);
	  };
	
	  _proto.onClosed = function onClosed(node) {
	    var unmountOnClose = this.props.unmountOnClose; // so all methods get called before it is unmounted
	
	    this.props.onClosed();
	    (this.props.modalTransition.onExited || noop)(node);
	
	    if (unmountOnClose) {
	      this.destroy();
	    }
	
	    this.close();
	
	    if (this._isMounted) {
	      this.setState({
	        isOpen: false
	      });
	    }
	  };
	
	  _proto.setFocus = function setFocus() {
	    if (this._dialog && this._dialog.parentNode && typeof this._dialog.parentNode.focus === 'function') {
	      this._dialog.parentNode.focus();
	    }
	  };
	
	  _proto.getFocusableChildren = function getFocusableChildren() {
	    return this._element.querySelectorAll(_utils.focusableElements.join(', '));
	  };
	
	  _proto.getFocusedChild = function getFocusedChild() {
	    var currentFocus;
	    var focusableChildren = this.getFocusableChildren();
	
	    try {
	      currentFocus = document.activeElement;
	    } catch (err) {
	      currentFocus = focusableChildren[0];
	    }
	
	    return currentFocus;
	  } // not mouseUp because scrollbar fires it, shouldn't close when user scrolls
	  ;
	
	  _proto.handleBackdropClick = function handleBackdropClick(e) {
	    if (e.target === this._mouseDownElement) {
	      e.stopPropagation();
	      var backdrop = this._dialog ? this._dialog.parentNode : null;
	
	      if (backdrop && e.target === backdrop && this.props.backdrop === 'static') {
	        this.handleStaticBackdropAnimation();
	      }
	
	      if (!this.props.isOpen || this.props.backdrop !== true) return;
	
	      if (backdrop && e.target === backdrop && this.props.toggle) {
	        this.props.toggle(e);
	      }
	    }
	  };
	
	  _proto.handleTab = function handleTab(e) {
	    if (e.which !== 9) return;
	    var focusableChildren = this.getFocusableChildren();
	    var totalFocusable = focusableChildren.length;
	    if (totalFocusable === 0) return;
	    var currentFocus = this.getFocusedChild();
	    var focusedIndex = 0;
	
	    for (var i = 0; i < totalFocusable; i += 1) {
	      if (focusableChildren[i] === currentFocus) {
	        focusedIndex = i;
	        break;
	      }
	    }
	
	    if (e.shiftKey && focusedIndex === 0) {
	      e.preventDefault();
	      focusableChildren[totalFocusable - 1].focus();
	    } else if (!e.shiftKey && focusedIndex === totalFocusable - 1) {
	      e.preventDefault();
	      focusableChildren[0].focus();
	    }
	  };
	
	  _proto.handleBackdropMouseDown = function handleBackdropMouseDown(e) {
	    this._mouseDownElement = e.target;
	  };
	
	  _proto.handleEscape = function handleEscape(e) {
	    if (this.props.isOpen && e.keyCode === _utils.keyCodes.esc && this.props.toggle) {
	      if (this.props.keyboard) {
	        e.preventDefault();
	        e.stopPropagation();
	        this.props.toggle(e);
	      } else if (this.props.backdrop === 'static') {
	        e.preventDefault();
	        e.stopPropagation();
	        this.handleStaticBackdropAnimation();
	      }
	    }
	  };
	
	  _proto.handleStaticBackdropAnimation = function handleStaticBackdropAnimation() {
	    var _this2 = this;
	
	    this.clearBackdropAnimationTimeout();
	    this.setState({
	      showStaticBackdropAnimation: true
	    });
	    this._backdropAnimationTimeout = setTimeout(function () {
	      _this2.setState({
	        showStaticBackdropAnimation: false
	      });
	    }, 100);
	  };
	
	  _proto.init = function init() {
	    try {
	      this._triggeringElement = document.activeElement;
	    } catch (err) {
	      this._triggeringElement = null;
	    }
	
	    if (!this._element) {
	      this._element = document.createElement('div');
	
	      this._element.setAttribute('tabindex', '-1');
	
	      this._element.style.position = 'relative';
	      this._element.style.zIndex = this.props.zIndex;
	      document.body.appendChild(this._element);
	    }
	
	    this._originalBodyPadding = (0, _utils.getOriginalBodyPadding)();
	    (0, _utils.conditionallyUpdateScrollbar)();
	
	    if (Modal.openCount === 0) {
	      document.body.className = (0, _classnames.default)(document.body.className, (0, _utils.mapToCssModules)('modal-open', this.props.cssModule));
	    }
	
	    Modal.openCount += 1;
	  };
	
	  _proto.destroy = function destroy() {
	    if (this._element) {
	      document.body.removeChild(this._element);
	      this._element = null;
	    }
	
	    this.manageFocusAfterClose();
	  };
	
	  _proto.manageFocusAfterClose = function manageFocusAfterClose() {
	    if (this._triggeringElement) {
	      var returnFocusAfterClose = this.props.returnFocusAfterClose;
	      if (this._triggeringElement.focus && returnFocusAfterClose) this._triggeringElement.focus();
	      this._triggeringElement = null;
	    }
	  };
	
	  _proto.close = function close() {
	    if (Modal.openCount <= 1) {
	      var modalOpenClassName = (0, _utils.mapToCssModules)('modal-open', this.props.cssModule); // Use regex to prevent matching `modal-open` as part of a different class, e.g. `my-modal-opened`
	
	      var modalOpenClassNameRegex = new RegExp("(^| )" + modalOpenClassName + "( |$)");
	      document.body.className = document.body.className.replace(modalOpenClassNameRegex, ' ').trim();
	    }
	
	    this.manageFocusAfterClose();
	    Modal.openCount = Math.max(0, Modal.openCount - 1);
	    (0, _utils.setScrollbarWidth)(this._originalBodyPadding);
	  };
	
	  _proto.renderModalDialog = function renderModalDialog() {
	    var _classNames,
	        _this3 = this;
	
	    var attributes = (0, _utils.omit)(this.props, propsToOmit);
	    var dialogBaseClass = 'modal-dialog';
	    return _react.default.createElement("div", (0, _extends2.default)({}, attributes, {
	      className: (0, _utils.mapToCssModules)((0, _classnames.default)(dialogBaseClass, this.props.className, (_classNames = {}, _classNames["modal-" + this.props.size] = this.props.size, _classNames[dialogBaseClass + "-centered"] = this.props.centered, _classNames[dialogBaseClass + "-scrollable"] = this.props.scrollable, _classNames)), this.props.cssModule),
	      role: "document",
	      ref: function ref(c) {
	        _this3._dialog = c;
	      }
	    }), _react.default.createElement("div", {
	      className: (0, _utils.mapToCssModules)((0, _classnames.default)('modal-content', this.props.contentClassName), this.props.cssModule)
	    }, this.props.children));
	  };
	
	  _proto.render = function render() {
	    var unmountOnClose = this.props.unmountOnClose;
	
	    if (!!this._element && (this.state.isOpen || !unmountOnClose)) {
	      var isModalHidden = !!this._element && !this.state.isOpen && !unmountOnClose;
	      this._element.style.display = isModalHidden ? 'none' : 'block';
	      var _this$props2 = this.props,
	          wrapClassName = _this$props2.wrapClassName,
	          modalClassName = _this$props2.modalClassName,
	          backdropClassName = _this$props2.backdropClassName,
	          cssModule = _this$props2.cssModule,
	          isOpen = _this$props2.isOpen,
	          backdrop = _this$props2.backdrop,
	          role = _this$props2.role,
	          labelledBy = _this$props2.labelledBy,
	          external = _this$props2.external,
	          innerRef = _this$props2.innerRef;
	      var modalAttributes = {
	        onClick: this.handleBackdropClick,
	        onMouseDown: this.handleBackdropMouseDown,
	        onKeyUp: this.handleEscape,
	        onKeyDown: this.handleTab,
	        style: {
	          display: 'block'
	        },
	        'aria-labelledby': labelledBy,
	        role: role,
	        tabIndex: '-1'
	      };
	      var hasTransition = this.props.fade;
	      var modalTransition = (0, _objectSpread4.default)({}, _Fade.default.defaultProps, {}, this.props.modalTransition, {
	        baseClass: hasTransition ? this.props.modalTransition.baseClass : '',
	        timeout: hasTransition ? this.props.modalTransition.timeout : 0
	      });
	      var backdropTransition = (0, _objectSpread4.default)({}, _Fade.default.defaultProps, {}, this.props.backdropTransition, {
	        baseClass: hasTransition ? this.props.backdropTransition.baseClass : '',
	        timeout: hasTransition ? this.props.backdropTransition.timeout : 0
	      });
	      var Backdrop = backdrop && (hasTransition ? _react.default.createElement(_Fade.default, (0, _extends2.default)({}, backdropTransition, {
	        in: isOpen && !!backdrop,
	        cssModule: cssModule,
	        className: (0, _utils.mapToCssModules)((0, _classnames.default)('modal-backdrop', backdropClassName), cssModule)
	      })) : _react.default.createElement("div", {
	        className: (0, _utils.mapToCssModules)((0, _classnames.default)('modal-backdrop', 'show', backdropClassName), cssModule)
	      }));
	      return _react.default.createElement(_Portal.default, {
	        node: this._element
	      }, _react.default.createElement("div", {
	        className: (0, _utils.mapToCssModules)(wrapClassName)
	      }, _react.default.createElement(_Fade.default, (0, _extends2.default)({}, modalAttributes, modalTransition, {
	        in: isOpen,
	        onEntered: this.onOpened,
	        onExited: this.onClosed,
	        cssModule: cssModule,
	        className: (0, _utils.mapToCssModules)((0, _classnames.default)('modal', modalClassName, this.state.showStaticBackdropAnimation && 'modal-static'), cssModule),
	        innerRef: innerRef
	      }), external, this.renderModalDialog()), Backdrop));
	    }
	
	    return null;
	  };
	
	  _proto.clearBackdropAnimationTimeout = function clearBackdropAnimationTimeout() {
	    if (this._backdropAnimationTimeout) {
	      clearTimeout(this._backdropAnimationTimeout);
	      this._backdropAnimationTimeout = undefined;
	    }
	  };
	
	  return Modal;
	}(_react.default.Component);
	
	Modal.propTypes = propTypes;
	Modal.defaultProps = defaultProps;
	Modal.openCount = 0;
	var _default = Modal;
	exports.default = _default;

/***/ },
/* 1565 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _utils = __webpack_require__(11);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'div'
	};
	
	var ModalBody = function ModalBody(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'modal-body'), cssModule);
	  return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	ModalBody.propTypes = propTypes;
	ModalBody.defaultProps = defaultProps;
	var _default = ModalBody;
	exports.default = _default;

/***/ },
/* 1566 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _utils = __webpack_require__(11);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'div'
	};
	
	var ModalFooter = function ModalFooter(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'modal-footer'), cssModule);
	  return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	ModalFooter.propTypes = propTypes;
	ModalFooter.defaultProps = defaultProps;
	var _default = ModalFooter;
	exports.default = _default;

/***/ },
/* 1567 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _utils = __webpack_require__(11);
	
	var propTypes = {
	  tabs: _propTypes.default.bool,
	  pills: _propTypes.default.bool,
	  vertical: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),
	  horizontal: _propTypes.default.string,
	  justified: _propTypes.default.bool,
	  fill: _propTypes.default.bool,
	  navbar: _propTypes.default.bool,
	  card: _propTypes.default.bool,
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'ul',
	  vertical: false
	};
	
	var getVerticalClass = function getVerticalClass(vertical) {
	  if (vertical === false) {
	    return false;
	  } else if (vertical === true || vertical === 'xs') {
	    return 'flex-column';
	  }
	
	  return "flex-" + vertical + "-column";
	};
	
	var Nav = function Nav(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      tabs = props.tabs,
	      pills = props.pills,
	      vertical = props.vertical,
	      horizontal = props.horizontal,
	      justified = props.justified,
	      fill = props.fill,
	      navbar = props.navbar,
	      card = props.card,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "tabs", "pills", "vertical", "horizontal", "justified", "fill", "navbar", "card", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, navbar ? 'navbar-nav' : 'nav', horizontal ? "justify-content-" + horizontal : false, getVerticalClass(vertical), {
	    'nav-tabs': tabs,
	    'card-header-tabs': card && tabs,
	    'nav-pills': pills,
	    'card-header-pills': card && pills,
	    'nav-justified': justified,
	    'nav-fill': fill
	  }), cssModule);
	  return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	Nav.propTypes = propTypes;
	Nav.defaultProps = defaultProps;
	var _default = Nav;
	exports.default = _default;

/***/ },
/* 1568 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _utils = __webpack_require__(11);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  active: _propTypes.default.bool,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'li'
	};
	
	var NavItem = function NavItem(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      active = props.active,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "active", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'nav-item', active ? 'active' : false), cssModule);
	  return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	NavItem.propTypes = propTypes;
	NavItem.defaultProps = defaultProps;
	var _default = NavItem;
	exports.default = _default;

/***/ },
/* 1569 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(13));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(12));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(34));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _utils = __webpack_require__(11);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  innerRef: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func, _propTypes.default.string]),
	  disabled: _propTypes.default.bool,
	  active: _propTypes.default.bool,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  onClick: _propTypes.default.func,
	  href: _propTypes.default.any
	};
	var defaultProps = {
	  tag: 'a'
	};
	
	var NavLink =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(NavLink, _React$Component);
	
	  function NavLink(props) {
	    var _this;
	
	    _this = _React$Component.call(this, props) || this;
	    _this.onClick = _this.onClick.bind((0, _assertThisInitialized2.default)(_this));
	    return _this;
	  }
	
	  var _proto = NavLink.prototype;
	
	  _proto.onClick = function onClick(e) {
	    if (this.props.disabled) {
	      e.preventDefault();
	      return;
	    }
	
	    if (this.props.href === '#') {
	      e.preventDefault();
	    }
	
	    if (this.props.onClick) {
	      this.props.onClick(e);
	    }
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        className = _this$props.className,
	        cssModule = _this$props.cssModule,
	        active = _this$props.active,
	        Tag = _this$props.tag,
	        innerRef = _this$props.innerRef,
	        attributes = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["className", "cssModule", "active", "tag", "innerRef"]);
	    var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'nav-link', {
	      disabled: attributes.disabled,
	      active: active
	    }), cssModule);
	    return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	      ref: innerRef,
	      onClick: this.onClick,
	      className: classes
	    }));
	  };
	
	  return NavLink;
	}(_react.default.Component);
	
	NavLink.propTypes = propTypes;
	NavLink.defaultProps = defaultProps;
	var _default = NavLink;
	exports.default = _default;

/***/ },
/* 1570 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _utils = __webpack_require__(11);
	
	var propTypes = {
	  light: _propTypes.default.bool,
	  dark: _propTypes.default.bool,
	  full: _propTypes.default.bool,
	  fixed: _propTypes.default.string,
	  sticky: _propTypes.default.string,
	  color: _propTypes.default.string,
	  role: _propTypes.default.string,
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  expand: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string])
	};
	var defaultProps = {
	  tag: 'nav',
	  expand: false
	};
	
	var getExpandClass = function getExpandClass(expand) {
	  if (expand === false) {
	    return false;
	  } else if (expand === true || expand === 'xs') {
	    return 'navbar-expand';
	  }
	
	  return "navbar-expand-" + expand;
	};
	
	var Navbar = function Navbar(props) {
	  var _classNames;
	
	  var expand = props.expand,
	      className = props.className,
	      cssModule = props.cssModule,
	      light = props.light,
	      dark = props.dark,
	      fixed = props.fixed,
	      sticky = props.sticky,
	      color = props.color,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["expand", "className", "cssModule", "light", "dark", "fixed", "sticky", "color", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'navbar', getExpandClass(expand), (_classNames = {
	    'navbar-light': light,
	    'navbar-dark': dark
	  }, _classNames["bg-" + color] = color, _classNames["fixed-" + fixed] = fixed, _classNames["sticky-" + sticky] = sticky, _classNames)), cssModule);
	  return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	Navbar.propTypes = propTypes;
	Navbar.defaultProps = defaultProps;
	var _default = Navbar;
	exports.default = _default;

/***/ },
/* 1571 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _utils = __webpack_require__(11);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'a'
	};
	
	var NavbarBrand = function NavbarBrand(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'navbar-brand'), cssModule);
	  return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	NavbarBrand.propTypes = propTypes;
	NavbarBrand.defaultProps = defaultProps;
	var _default = NavbarBrand;
	exports.default = _default;

/***/ },
/* 1572 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _utils = __webpack_require__(11);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'span'
	};
	
	var NavbarText = function NavbarText(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      active = props.active,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "active", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'navbar-text'), cssModule);
	  return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	NavbarText.propTypes = propTypes;
	NavbarText.defaultProps = defaultProps;
	var _default = NavbarText;
	exports.default = _default;

/***/ },
/* 1573 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _utils = __webpack_require__(11);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  type: _propTypes.default.string,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  children: _propTypes.default.node
	};
	var defaultProps = {
	  tag: 'button',
	  type: 'button'
	};
	
	var NavbarToggler = function NavbarToggler(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      children = props.children,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "children", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'navbar-toggler'), cssModule);
	  return _react.default.createElement(Tag, (0, _extends2.default)({
	    "aria-label": "Toggle navigation"
	  }, attributes, {
	    className: classes
	  }), children || _react.default.createElement("span", {
	    className: (0, _utils.mapToCssModules)('navbar-toggler-icon', cssModule)
	  }));
	};
	
	NavbarToggler.propTypes = propTypes;
	NavbarToggler.defaultProps = defaultProps;
	var _default = NavbarToggler;
	exports.default = _default;

/***/ },
/* 1574 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _utils = __webpack_require__(11);
	
	var propTypes = {
	  children: _propTypes.default.node,
	  className: _propTypes.default.string,
	  listClassName: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  size: _propTypes.default.string,
	  tag: _utils.tagPropType,
	  listTag: _utils.tagPropType,
	  'aria-label': _propTypes.default.string
	};
	var defaultProps = {
	  tag: 'nav',
	  listTag: 'ul',
	  'aria-label': 'pagination'
	};
	
	var Pagination = function Pagination(props) {
	  var _classNames;
	
	  var className = props.className,
	      listClassName = props.listClassName,
	      cssModule = props.cssModule,
	      size = props.size,
	      Tag = props.tag,
	      ListTag = props.listTag,
	      label = props['aria-label'],
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "listClassName", "cssModule", "size", "tag", "listTag", "aria-label"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className), cssModule);
	  var listClasses = (0, _utils.mapToCssModules)((0, _classnames.default)(listClassName, 'pagination', (_classNames = {}, _classNames["pagination-" + size] = !!size, _classNames)), cssModule);
	  return _react.default.createElement(Tag, {
	    className: classes,
	    "aria-label": label
	  }, _react.default.createElement(ListTag, (0, _extends2.default)({}, attributes, {
	    className: listClasses
	  })));
	};
	
	Pagination.propTypes = propTypes;
	Pagination.defaultProps = defaultProps;
	var _default = Pagination;
	exports.default = _default;

/***/ },
/* 1575 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _utils = __webpack_require__(11);
	
	var propTypes = {
	  active: _propTypes.default.bool,
	  children: _propTypes.default.node,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  disabled: _propTypes.default.bool,
	  tag: _utils.tagPropType
	};
	var defaultProps = {
	  tag: 'li'
	};
	
	var PaginationItem = function PaginationItem(props) {
	  var active = props.active,
	      className = props.className,
	      cssModule = props.cssModule,
	      disabled = props.disabled,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["active", "className", "cssModule", "disabled", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'page-item', {
	    active: active,
	    disabled: disabled
	  }), cssModule);
	  return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	PaginationItem.propTypes = propTypes;
	PaginationItem.defaultProps = defaultProps;
	var _default = PaginationItem;
	exports.default = _default;

/***/ },
/* 1576 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _utils = __webpack_require__(11);
	
	var propTypes = {
	  'aria-label': _propTypes.default.string,
	  children: _propTypes.default.node,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  next: _propTypes.default.bool,
	  previous: _propTypes.default.bool,
	  first: _propTypes.default.bool,
	  last: _propTypes.default.bool,
	  tag: _utils.tagPropType
	};
	var defaultProps = {
	  tag: 'a'
	};
	
	var PaginationLink = function PaginationLink(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      next = props.next,
	      previous = props.previous,
	      first = props.first,
	      last = props.last,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "next", "previous", "first", "last", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'page-link'), cssModule);
	  var defaultAriaLabel;
	
	  if (previous) {
	    defaultAriaLabel = 'Previous';
	  } else if (next) {
	    defaultAriaLabel = 'Next';
	  } else if (first) {
	    defaultAriaLabel = 'First';
	  } else if (last) {
	    defaultAriaLabel = 'Last';
	  }
	
	  var ariaLabel = props['aria-label'] || defaultAriaLabel;
	  var defaultCaret;
	
	  if (previous) {
	    defaultCaret = "\u2039";
	  } else if (next) {
	    defaultCaret = "\u203A";
	  } else if (first) {
	    defaultCaret = "\xAB";
	  } else if (last) {
	    defaultCaret = "\xBB";
	  }
	
	  var children = props.children;
	
	  if (children && Array.isArray(children) && children.length === 0) {
	    children = null;
	  }
	
	  if (!attributes.href && Tag === 'a') {
	    Tag = 'button';
	  }
	
	  if (previous || next || first || last) {
	    children = [_react.default.createElement("span", {
	      "aria-hidden": "true",
	      key: "caret"
	    }, children || defaultCaret), _react.default.createElement("span", {
	      className: "sr-only",
	      key: "sr"
	    }, ariaLabel)];
	  }
	
	  return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes,
	    "aria-label": ariaLabel
	  }), children);
	};
	
	PaginationLink.propTypes = propTypes;
	PaginationLink.defaultProps = defaultProps;
	var _default = PaginationLink;
	exports.default = _default;

/***/ },
/* 1577 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _utils = __webpack_require__(11);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'div'
	};
	
	var PopoverBody = function PopoverBody(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'popover-body'), cssModule);
	  return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	PopoverBody.propTypes = propTypes;
	PopoverBody.defaultProps = defaultProps;
	var _default = PopoverBody;
	exports.default = _default;

/***/ },
/* 1578 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _utils = __webpack_require__(11);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'h3'
	};
	
	var PopoverHeader = function PopoverHeader(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'popover-header'), cssModule);
	  return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	PopoverHeader.propTypes = propTypes;
	PopoverHeader.defaultProps = defaultProps;
	var _default = PopoverHeader;
	exports.default = _default;

/***/ },
/* 1579 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(11);
	
	var PopperTargetHelper = function PopperTargetHelper(props, context) {
	  context.popperManager.setTargetNode((0, _utils.getTarget)(props.target));
	  return null;
	};
	
	PopperTargetHelper.contextTypes = {
	  popperManager: _propTypes.default.object.isRequired
	};
	PopperTargetHelper.propTypes = {
	  target: _utils.targetPropType.isRequired
	};
	var _default = PopperTargetHelper;
	exports.default = _default;

/***/ },
/* 1580 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(34));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(43));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(11);
	
	var propTypes = {
	  children: _propTypes.default.node.isRequired,
	  node: _propTypes.default.any
	};
	
	var Portal =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Portal, _React$Component);
	
	  function Portal() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = Portal.prototype;
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    if (this.defaultNode) {
	      document.body.removeChild(this.defaultNode);
	    }
	
	    this.defaultNode = null;
	  };
	
	  _proto.render = function render() {
	    if (!_utils.canUseDOM) {
	      return null;
	    }
	
	    if (!this.props.node && !this.defaultNode) {
	      this.defaultNode = document.createElement('div');
	      document.body.appendChild(this.defaultNode);
	    }
	
	    return _reactDom.default.createPortal(this.props.children, this.props.node || this.defaultNode);
	  };
	
	  return Portal;
	}(_react.default.Component);
	
	Portal.propTypes = propTypes;
	var _default = Portal;
	exports.default = _default;

/***/ },
/* 1581 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _utils = __webpack_require__(11);
	
	var propTypes = {
	  children: _propTypes.default.node,
	  bar: _propTypes.default.bool,
	  multi: _propTypes.default.bool,
	  tag: _utils.tagPropType,
	  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  max: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  animated: _propTypes.default.bool,
	  striped: _propTypes.default.bool,
	  color: _propTypes.default.string,
	  className: _propTypes.default.string,
	  barClassName: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'div',
	  value: 0,
	  max: 100
	};
	
	var Progress = function Progress(props) {
	  var children = props.children,
	      className = props.className,
	      barClassName = props.barClassName,
	      cssModule = props.cssModule,
	      value = props.value,
	      max = props.max,
	      animated = props.animated,
	      striped = props.striped,
	      color = props.color,
	      bar = props.bar,
	      multi = props.multi,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["children", "className", "barClassName", "cssModule", "value", "max", "animated", "striped", "color", "bar", "multi", "tag"]);
	  var percent = (0, _utils.toNumber)(value) / (0, _utils.toNumber)(max) * 100;
	  var progressClasses = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'progress'), cssModule);
	  var progressBarClasses = (0, _utils.mapToCssModules)((0, _classnames.default)('progress-bar', bar ? className || barClassName : barClassName, animated ? 'progress-bar-animated' : null, color ? "bg-" + color : null, striped || animated ? 'progress-bar-striped' : null), cssModule);
	  var ProgressBar = multi ? children : _react.default.createElement("div", {
	    className: progressBarClasses,
	    style: {
	      width: percent + "%"
	    },
	    role: "progressbar",
	    "aria-valuenow": value,
	    "aria-valuemin": "0",
	    "aria-valuemax": max,
	    children: children
	  });
	
	  if (bar) {
	    return ProgressBar;
	  }
	
	  return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: progressClasses,
	    children: ProgressBar
	  }));
	};
	
	Progress.propTypes = propTypes;
	Progress.defaultProps = defaultProps;
	var _default = Progress;
	exports.default = _default;

/***/ },
/* 1582 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _utils = __webpack_require__(11);
	
	var rowColWidths = ['xs', 'sm', 'md', 'lg', 'xl'];
	
	var rowColsPropType = _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  noGutters: _propTypes.default.bool,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  form: _propTypes.default.bool,
	  xs: rowColsPropType,
	  sm: rowColsPropType,
	  md: rowColsPropType,
	  lg: rowColsPropType,
	  xl: rowColsPropType
	};
	var defaultProps = {
	  tag: 'div',
	  widths: rowColWidths
	};
	
	var Row = function Row(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      noGutters = props.noGutters,
	      Tag = props.tag,
	      form = props.form,
	      widths = props.widths,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "noGutters", "tag", "form", "widths"]);
	  var colClasses = [];
	  widths.forEach(function (colWidth, i) {
	    var colSize = props[colWidth];
	    delete attributes[colWidth];
	
	    if (!colSize) {
	      return;
	    }
	
	    var isXs = !i;
	    colClasses.push(isXs ? "row-cols-" + colSize : "row-cols-" + colWidth + "-" + colSize);
	  });
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, noGutters ? 'no-gutters' : null, form ? 'form-row' : 'row', colClasses), cssModule);
	  return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	Row.propTypes = propTypes;
	Row.defaultProps = defaultProps;
	var _default = Row;
	exports.default = _default;

/***/ },
/* 1583 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _utils = __webpack_require__(11);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  type: _propTypes.default.string,
	  size: _propTypes.default.string,
	  color: _propTypes.default.string,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  children: _propTypes.default.string
	};
	var defaultProps = {
	  tag: 'div',
	  type: 'border',
	  children: 'Loading...'
	};
	
	var Spinner = function Spinner(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      type = props.type,
	      size = props.size,
	      color = props.color,
	      children = props.children,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "type", "size", "color", "children", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, size ? "spinner-" + type + "-" + size : false, "spinner-" + type, color ? "text-" + color : false), cssModule);
	  return _react.default.createElement(Tag, (0, _extends2.default)({
	    role: "status"
	  }, attributes, {
	    className: classes
	  }), children && _react.default.createElement("span", {
	    className: (0, _utils.mapToCssModules)('sr-only', cssModule)
	  }, children));
	};
	
	Spinner.propTypes = propTypes;
	Spinner.defaultProps = defaultProps;
	var _default = Spinner;
	exports.default = _default;

/***/ },
/* 1584 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(34));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _reactLifecyclesCompat = __webpack_require__(294);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _TabContext = __webpack_require__(648);
	
	var _utils = __webpack_require__(11);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  activeTab: _propTypes.default.any,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'div'
	};
	
	var TabContent =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inheritsLoose2.default)(TabContent, _Component);
	
	  TabContent.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
	    if (prevState.activeTab !== nextProps.activeTab) {
	      return {
	        activeTab: nextProps.activeTab
	      };
	    }
	
	    return null;
	  };
	
	  function TabContent(props) {
	    var _this;
	
	    _this = _Component.call(this, props) || this;
	    _this.state = {
	      activeTab: _this.props.activeTab
	    };
	    return _this;
	  }
	
	  var _proto = TabContent.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        className = _this$props.className,
	        cssModule = _this$props.cssModule,
	        Tag = _this$props.tag;
	    var attributes = (0, _utils.omit)(this.props, Object.keys(propTypes));
	    var classes = (0, _utils.mapToCssModules)((0, _classnames.default)('tab-content', className), cssModule);
	    return _react.default.createElement(_TabContext.TabContext.Provider, {
	      value: {
	        activeTabId: this.state.activeTab
	      }
	    }, _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	      className: classes
	    })));
	  };
	
	  return TabContent;
	}(_react.Component);
	
	(0, _reactLifecyclesCompat.polyfill)(TabContent);
	var _default = TabContent;
	exports.default = _default;
	TabContent.propTypes = propTypes;
	TabContent.defaultProps = defaultProps;

/***/ },
/* 1585 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = TabPane;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _TabContext = __webpack_require__(648);
	
	var _utils = __webpack_require__(11);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  tabId: _propTypes.default.any
	};
	var defaultProps = {
	  tag: 'div'
	};
	
	function TabPane(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      tabId = props.tabId,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "tabId", "tag"]);
	
	  var getClasses = function getClasses(activeTabId) {
	    return (0, _utils.mapToCssModules)((0, _classnames.default)('tab-pane', className, {
	      active: tabId === activeTabId
	    }), cssModule);
	  };
	
	  return _react.default.createElement(_TabContext.TabContext.Consumer, null, function (_ref) {
	    var activeTabId = _ref.activeTabId;
	    return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	      className: getClasses(activeTabId)
	    }));
	  });
	}
	
	TabPane.propTypes = propTypes;
	TabPane.defaultProps = defaultProps;

/***/ },
/* 1586 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _utils = __webpack_require__(11);
	
	var propTypes = {
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  size: _propTypes.default.string,
	  bordered: _propTypes.default.bool,
	  borderless: _propTypes.default.bool,
	  striped: _propTypes.default.bool,
	  dark: _propTypes.default.bool,
	  hover: _propTypes.default.bool,
	  responsive: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),
	  tag: _utils.tagPropType,
	  responsiveTag: _utils.tagPropType,
	  innerRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.string, _propTypes.default.object])
	};
	var defaultProps = {
	  tag: 'table',
	  responsiveTag: 'div'
	};
	
	var Table = function Table(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      size = props.size,
	      bordered = props.bordered,
	      borderless = props.borderless,
	      striped = props.striped,
	      dark = props.dark,
	      hover = props.hover,
	      responsive = props.responsive,
	      Tag = props.tag,
	      ResponsiveTag = props.responsiveTag,
	      innerRef = props.innerRef,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "size", "bordered", "borderless", "striped", "dark", "hover", "responsive", "tag", "responsiveTag", "innerRef"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'table', size ? 'table-' + size : false, bordered ? 'table-bordered' : false, borderless ? 'table-borderless' : false, striped ? 'table-striped' : false, dark ? 'table-dark' : false, hover ? 'table-hover' : false), cssModule);
	
	  var table = _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    ref: innerRef,
	    className: classes
	  }));
	
	  if (responsive) {
	    var responsiveClassName = (0, _utils.mapToCssModules)(responsive === true ? 'table-responsive' : "table-responsive-" + responsive, cssModule);
	    return _react.default.createElement(ResponsiveTag, {
	      className: responsiveClassName
	    }, table);
	  }
	
	  return table;
	};
	
	Table.propTypes = propTypes;
	Table.defaultProps = defaultProps;
	var _default = Table;
	exports.default = _default;

/***/ },
/* 1587 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(13));
	
	var _objectSpread4 = _interopRequireDefault(__webpack_require__(47));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _utils = __webpack_require__(11);
	
	var _Fade = _interopRequireDefault(__webpack_require__(173));
	
	var propTypes = {
	  children: _propTypes.default.node,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  fade: _propTypes.default.bool,
	  isOpen: _propTypes.default.bool,
	  tag: _utils.tagPropType,
	  transition: _propTypes.default.shape(_Fade.default.propTypes),
	  innerRef: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string, _propTypes.default.func])
	};
	var defaultProps = {
	  isOpen: true,
	  tag: 'div',
	  fade: true,
	  transition: (0, _objectSpread4.default)({}, _Fade.default.defaultProps, {
	    unmountOnExit: true
	  })
	};
	
	function Toast(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      isOpen = props.isOpen,
	      children = props.children,
	      transition = props.transition,
	      fade = props.fade,
	      innerRef = props.innerRef,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "tag", "isOpen", "children", "transition", "fade", "innerRef"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'toast'), cssModule);
	  var toastTransition = (0, _objectSpread4.default)({}, _Fade.default.defaultProps, {}, transition, {
	    baseClass: fade ? transition.baseClass : '',
	    timeout: fade ? transition.timeout : 0
	  });
	  return _react.default.createElement(_Fade.default, (0, _extends2.default)({}, attributes, toastTransition, {
	    tag: Tag,
	    className: classes,
	    in: isOpen,
	    role: "alert",
	    innerRef: innerRef
	  }), children);
	}
	
	Toast.propTypes = propTypes;
	Toast.defaultProps = defaultProps;
	var _default = Toast;
	exports.default = _default;

/***/ },
/* 1588 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _utils = __webpack_require__(11);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  innerRef: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string, _propTypes.default.func])
	};
	var defaultProps = {
	  tag: 'div'
	};
	
	var ToastBody = function ToastBody(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      innerRef = props.innerRef,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "innerRef", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'toast-body'), cssModule);
	  return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes,
	    ref: innerRef
	  }));
	};
	
	ToastBody.propTypes = propTypes;
	ToastBody.defaultProps = defaultProps;
	var _default = ToastBody;
	exports.default = _default;

/***/ },
/* 1589 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _utils = __webpack_require__(11);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  icon: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
	  wrapTag: _utils.tagPropType,
	  toggle: _propTypes.default.func,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  children: _propTypes.default.node,
	  closeAriaLabel: _propTypes.default.string,
	  charCode: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  close: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'strong',
	  wrapTag: 'div',
	  tagClassName: 'mr-auto',
	  closeAriaLabel: 'Close',
	  charCode: 215
	};
	
	var ToastHeader = function ToastHeader(props) {
	  var closeButton;
	  var icon;
	  var className = props.className,
	      cssModule = props.cssModule,
	      children = props.children,
	      toggle = props.toggle,
	      Tag = props.tag,
	      WrapTag = props.wrapTag,
	      closeAriaLabel = props.closeAriaLabel,
	      charCode = props.charCode,
	      close = props.close,
	      tagClassName = props.tagClassName,
	      iconProp = props.icon,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "children", "toggle", "tag", "wrapTag", "closeAriaLabel", "charCode", "close", "tagClassName", "icon"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'toast-header'), cssModule);
	
	  if (!close && toggle) {
	    var closeIcon = typeof charCode === 'number' ? String.fromCharCode(charCode) : charCode;
	    closeButton = _react.default.createElement("button", {
	      type: "button",
	      onClick: toggle,
	      className: (0, _utils.mapToCssModules)('close', cssModule),
	      "aria-label": closeAriaLabel
	    }, _react.default.createElement("span", {
	      "aria-hidden": "true"
	    }, closeIcon));
	  }
	
	  if (typeof iconProp === "string") {
	    icon = _react.default.createElement("svg", {
	      className: (0, _utils.mapToCssModules)("rounded text-" + iconProp),
	      width: "20",
	      height: "20",
	      xmlns: "http://www.w3.org/2000/svg",
	      preserveAspectRatio: "xMidYMid slice",
	      focusable: "false",
	      role: "img"
	    }, _react.default.createElement("rect", {
	      fill: "currentColor",
	      width: "100%",
	      height: "100%"
	    }));
	  } else if (iconProp) {
	    icon = iconProp;
	  }
	
	  return _react.default.createElement(WrapTag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }), icon, _react.default.createElement(Tag, {
	    className: (0, _utils.mapToCssModules)((0, _classnames.default)(tagClassName, {
	      "ml-2": icon != null
	    }), cssModule)
	  }, children), close || closeButton);
	};
	
	ToastHeader.propTypes = propTypes;
	ToastHeader.defaultProps = defaultProps;
	var _default = ToastHeader;
	exports.default = _default;

/***/ },
/* 1590 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(12));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(34));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _Alert = _interopRequireDefault(__webpack_require__(637));
	
	var UncontrolledAlert =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inheritsLoose2.default)(UncontrolledAlert, _Component);
	
	  function UncontrolledAlert(props) {
	    var _this;
	
	    _this = _Component.call(this, props) || this;
	    _this.state = {
	      isOpen: true
	    };
	    _this.toggle = _this.toggle.bind((0, _assertThisInitialized2.default)(_this));
	    return _this;
	  }
	
	  var _proto = UncontrolledAlert.prototype;
	
	  _proto.toggle = function toggle() {
	    this.setState({
	      isOpen: !this.state.isOpen
	    });
	  };
	
	  _proto.render = function render() {
	    return _react.default.createElement(_Alert.default, (0, _extends2.default)({
	      isOpen: this.state.isOpen,
	      toggle: this.toggle
	    }, this.props));
	  };
	
	  return UncontrolledAlert;
	}(_react.Component);
	
	var _default = UncontrolledAlert;
	exports.default = _default;

/***/ },
/* 1591 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _objectSpread3 = _interopRequireDefault(__webpack_require__(47));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(12));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(34));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _ButtonDropdown = _interopRequireDefault(__webpack_require__(638));
	
	var _utils = __webpack_require__(11);
	
	var omitKeys = ['defaultOpen'];
	
	var UncontrolledButtonDropdown =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inheritsLoose2.default)(UncontrolledButtonDropdown, _Component);
	
	  function UncontrolledButtonDropdown(props) {
	    var _this;
	
	    _this = _Component.call(this, props) || this;
	    _this.state = {
	      isOpen: props.defaultOpen || false
	    };
	    _this.toggle = _this.toggle.bind((0, _assertThisInitialized2.default)(_this));
	    return _this;
	  }
	
	  var _proto = UncontrolledButtonDropdown.prototype;
	
	  _proto.toggle = function toggle() {
	    this.setState({
	      isOpen: !this.state.isOpen
	    });
	  };
	
	  _proto.render = function render() {
	    return _react.default.createElement(_ButtonDropdown.default, (0, _extends2.default)({
	      isOpen: this.state.isOpen,
	      toggle: this.toggle
	    }, (0, _utils.omit)(this.props, omitKeys)));
	  };
	
	  return UncontrolledButtonDropdown;
	}(_react.Component);
	
	exports.default = UncontrolledButtonDropdown;
	UncontrolledButtonDropdown.propTypes = (0, _objectSpread3.default)({
	  defaultOpen: _propTypes.default.bool
	}, _ButtonDropdown.default.propTypes);

/***/ },
/* 1592 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(13));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(12));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(34));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _Carousel = _interopRequireDefault(__webpack_require__(639));
	
	var _CarouselItem = _interopRequireDefault(__webpack_require__(302));
	
	var _CarouselControl = _interopRequireDefault(__webpack_require__(641));
	
	var _CarouselIndicators = _interopRequireDefault(__webpack_require__(642));
	
	var _CarouselCaption = _interopRequireDefault(__webpack_require__(640));
	
	var propTypes = {
	  items: _propTypes.default.array.isRequired,
	  indicators: _propTypes.default.bool,
	  controls: _propTypes.default.bool,
	  autoPlay: _propTypes.default.bool,
	  defaultActiveIndex: _propTypes.default.number,
	  activeIndex: _propTypes.default.number,
	  next: _propTypes.default.func,
	  previous: _propTypes.default.func,
	  goToIndex: _propTypes.default.func
	};
	
	var UncontrolledCarousel =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inheritsLoose2.default)(UncontrolledCarousel, _Component);
	
	  function UncontrolledCarousel(props) {
	    var _this;
	
	    _this = _Component.call(this, props) || this;
	    _this.animating = false;
	    _this.state = {
	      activeIndex: props.defaultActiveIndex || 0
	    };
	    _this.next = _this.next.bind((0, _assertThisInitialized2.default)(_this));
	    _this.previous = _this.previous.bind((0, _assertThisInitialized2.default)(_this));
	    _this.goToIndex = _this.goToIndex.bind((0, _assertThisInitialized2.default)(_this));
	    _this.onExiting = _this.onExiting.bind((0, _assertThisInitialized2.default)(_this));
	    _this.onExited = _this.onExited.bind((0, _assertThisInitialized2.default)(_this));
	    return _this;
	  }
	
	  var _proto = UncontrolledCarousel.prototype;
	
	  _proto.onExiting = function onExiting() {
	    this.animating = true;
	  };
	
	  _proto.onExited = function onExited() {
	    this.animating = false;
	  };
	
	  _proto.next = function next() {
	    if (this.animating) return;
	    var nextIndex = this.state.activeIndex === this.props.items.length - 1 ? 0 : this.state.activeIndex + 1;
	    this.setState({
	      activeIndex: nextIndex
	    });
	  };
	
	  _proto.previous = function previous() {
	    if (this.animating) return;
	    var nextIndex = this.state.activeIndex === 0 ? this.props.items.length - 1 : this.state.activeIndex - 1;
	    this.setState({
	      activeIndex: nextIndex
	    });
	  };
	
	  _proto.goToIndex = function goToIndex(newIndex) {
	    if (this.animating) return;
	    this.setState({
	      activeIndex: newIndex
	    });
	  };
	
	  _proto.render = function render() {
	    var _this2 = this;
	
	    var _this$props = this.props,
	        defaultActiveIndex = _this$props.defaultActiveIndex,
	        autoPlay = _this$props.autoPlay,
	        indicators = _this$props.indicators,
	        controls = _this$props.controls,
	        items = _this$props.items,
	        goToIndex = _this$props.goToIndex,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["defaultActiveIndex", "autoPlay", "indicators", "controls", "items", "goToIndex"]);
	    var activeIndex = this.state.activeIndex;
	    var slides = items.map(function (item) {
	      var key = item.key || item.src;
	      return _react.default.createElement(_CarouselItem.default, {
	        onExiting: _this2.onExiting,
	        onExited: _this2.onExited,
	        key: key
	      }, _react.default.createElement("img", {
	        className: "d-block w-100",
	        src: item.src,
	        alt: item.altText
	      }), _react.default.createElement(_CarouselCaption.default, {
	        captionText: item.caption,
	        captionHeader: item.header || item.caption
	      }));
	    });
	    return _react.default.createElement(_Carousel.default, (0, _extends2.default)({
	      activeIndex: activeIndex,
	      next: this.next,
	      previous: this.previous,
	      ride: autoPlay ? 'carousel' : undefined
	    }, props), indicators && _react.default.createElement(_CarouselIndicators.default, {
	      items: items,
	      activeIndex: props.activeIndex || activeIndex,
	      onClickHandler: goToIndex || this.goToIndex
	    }), slides, controls && _react.default.createElement(_CarouselControl.default, {
	      direction: "prev",
	      directionText: "Previous",
	      onClickHandler: props.previous || this.previous
	    }), controls && _react.default.createElement(_CarouselControl.default, {
	      direction: "next",
	      directionText: "Next",
	      onClickHandler: props.next || this.next
	    }));
	  };
	
	  return UncontrolledCarousel;
	}(_react.Component);
	
	UncontrolledCarousel.propTypes = propTypes;
	UncontrolledCarousel.defaultProps = {
	  controls: true,
	  indicators: true,
	  autoPlay: true
	};
	var _default = UncontrolledCarousel;
	exports.default = _default;

/***/ },
/* 1593 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(12));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(34));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _Collapse = _interopRequireDefault(__webpack_require__(643));
	
	var _utils = __webpack_require__(11);
	
	var omitKeys = ['toggleEvents', 'defaultOpen'];
	var propTypes = {
	  defaultOpen: _propTypes.default.bool,
	  toggler: _propTypes.default.string.isRequired,
	  toggleEvents: _propTypes.default.arrayOf(_propTypes.default.string)
	};
	var defaultProps = {
	  toggleEvents: _utils.defaultToggleEvents
	};
	
	var UncontrolledCollapse =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inheritsLoose2.default)(UncontrolledCollapse, _Component);
	
	  function UncontrolledCollapse(props) {
	    var _this;
	
	    _this = _Component.call(this, props) || this;
	    _this.togglers = null;
	    _this.removeEventListeners = null;
	    _this.toggle = _this.toggle.bind((0, _assertThisInitialized2.default)(_this));
	    _this.state = {
	      isOpen: props.defaultOpen || false
	    };
	    return _this;
	  }
	
	  var _proto = UncontrolledCollapse.prototype;
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.togglers = (0, _utils.findDOMElements)(this.props.toggler);
	
	    if (this.togglers.length) {
	      this.removeEventListeners = (0, _utils.addMultipleEventListeners)(this.togglers, this.toggle, this.props.toggleEvents);
	    }
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    if (this.togglers.length && this.removeEventListeners) {
	      this.removeEventListeners();
	    }
	  };
	
	  _proto.toggle = function toggle(e) {
	    this.setState(function (_ref) {
	      var isOpen = _ref.isOpen;
	      return {
	        isOpen: !isOpen
	      };
	    });
	    e.preventDefault();
	  };
	
	  _proto.render = function render() {
	    return _react.default.createElement(_Collapse.default, (0, _extends2.default)({
	      isOpen: this.state.isOpen
	    }, (0, _utils.omit)(this.props, omitKeys)));
	  };
	
	  return UncontrolledCollapse;
	}(_react.Component);
	
	UncontrolledCollapse.propTypes = propTypes;
	UncontrolledCollapse.defaultProps = defaultProps;
	var _default = UncontrolledCollapse;
	exports.default = _default;

/***/ },
/* 1594 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _objectSpread3 = _interopRequireDefault(__webpack_require__(47));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(12));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(34));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _Dropdown = _interopRequireDefault(__webpack_require__(212));
	
	var _utils = __webpack_require__(11);
	
	var omitKeys = ['defaultOpen'];
	
	var UncontrolledDropdown =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inheritsLoose2.default)(UncontrolledDropdown, _Component);
	
	  function UncontrolledDropdown(props) {
	    var _this;
	
	    _this = _Component.call(this, props) || this;
	    _this.state = {
	      isOpen: props.defaultOpen || false
	    };
	    _this.toggle = _this.toggle.bind((0, _assertThisInitialized2.default)(_this));
	    return _this;
	  }
	
	  var _proto = UncontrolledDropdown.prototype;
	
	  _proto.toggle = function toggle(e) {
	    this.setState({
	      isOpen: !this.state.isOpen
	    });
	
	    if (this.props.onToggle) {
	      this.props.onToggle(e, !this.state.isOpen);
	    }
	  };
	
	  _proto.render = function render() {
	    return _react.default.createElement(_Dropdown.default, (0, _extends2.default)({
	      isOpen: this.state.isOpen,
	      toggle: this.toggle
	    }, (0, _utils.omit)(this.props, omitKeys)));
	  };
	
	  return UncontrolledDropdown;
	}(_react.Component);
	
	exports.default = UncontrolledDropdown;
	UncontrolledDropdown.propTypes = (0, _objectSpread3.default)({
	  defaultOpen: _propTypes.default.bool,
	  onToggle: _propTypes.default.func
	}, _Dropdown.default.propTypes);

/***/ },
/* 1595 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _objectSpread3 = _interopRequireDefault(__webpack_require__(47));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(12));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(34));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _Popover = _interopRequireDefault(__webpack_require__(646));
	
	var _utils = __webpack_require__(11);
	
	var omitKeys = ['defaultOpen'];
	
	var UncontrolledPopover =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inheritsLoose2.default)(UncontrolledPopover, _Component);
	
	  function UncontrolledPopover(props) {
	    var _this;
	
	    _this = _Component.call(this, props) || this;
	    _this.state = {
	      isOpen: props.defaultOpen || false
	    };
	    _this.toggle = _this.toggle.bind((0, _assertThisInitialized2.default)(_this));
	    return _this;
	  }
	
	  var _proto = UncontrolledPopover.prototype;
	
	  _proto.toggle = function toggle() {
	    this.setState({
	      isOpen: !this.state.isOpen
	    });
	  };
	
	  _proto.render = function render() {
	    return _react.default.createElement(_Popover.default, (0, _extends2.default)({
	      isOpen: this.state.isOpen,
	      toggle: this.toggle
	    }, (0, _utils.omit)(this.props, omitKeys)));
	  };
	
	  return UncontrolledPopover;
	}(_react.Component);
	
	exports.default = UncontrolledPopover;
	UncontrolledPopover.propTypes = (0, _objectSpread3.default)({
	  defaultOpen: _propTypes.default.bool
	}, _Popover.default.propTypes);

/***/ },
/* 1596 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _objectSpread3 = _interopRequireDefault(__webpack_require__(47));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(12));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(34));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _Tooltip = _interopRequireDefault(__webpack_require__(649));
	
	var _utils = __webpack_require__(11);
	
	var omitKeys = ['defaultOpen'];
	
	var UncontrolledTooltip =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inheritsLoose2.default)(UncontrolledTooltip, _Component);
	
	  function UncontrolledTooltip(props) {
	    var _this;
	
	    _this = _Component.call(this, props) || this;
	    _this.state = {
	      isOpen: props.defaultOpen || false
	    };
	    _this.toggle = _this.toggle.bind((0, _assertThisInitialized2.default)(_this));
	    return _this;
	  }
	
	  var _proto = UncontrolledTooltip.prototype;
	
	  _proto.toggle = function toggle() {
	    this.setState({
	      isOpen: !this.state.isOpen
	    });
	  };
	
	  _proto.render = function render() {
	    return _react.default.createElement(_Tooltip.default, (0, _extends2.default)({
	      isOpen: this.state.isOpen,
	      toggle: this.toggle
	    }, (0, _utils.omit)(this.props, omitKeys)));
	  };
	
	  return UncontrolledTooltip;
	}(_react.Component);
	
	exports.default = UncontrolledTooltip;
	UncontrolledTooltip.propTypes = (0, _objectSpread3.default)({
	  defaultOpen: _propTypes.default.bool
	}, _Tooltip.default.propTypes);

/***/ },
/* 1597 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = addClass;
	
	var _hasClass = _interopRequireDefault(__webpack_require__(1598));
	
	function addClass(element, className) {
	  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
	}
	
	module.exports = exports["default"];

/***/ },
/* 1598 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = hasClass;
	
	function hasClass(element, className) {
	  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
	}
	
	module.exports = exports["default"];

/***/ },
/* 1599 */
/***/ function(module, exports) {

	'use strict';
	
	function replaceClassName(origClass, classToRemove) {
	  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
	}
	
	module.exports = function removeClass(element, className) {
	  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
	};

/***/ },
/* 1600 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(3));
	
	var _addClass = _interopRequireDefault(__webpack_require__(1597));
	
	var _removeClass = _interopRequireDefault(__webpack_require__(1599));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _Transition = _interopRequireDefault(__webpack_require__(651));
	
	var _PropTypes = __webpack_require__(653);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	var addClass = function addClass(node, classes) {
	  return node && classes && classes.split(' ').forEach(function (c) {
	    return (0, _addClass.default)(node, c);
	  });
	};
	
	var removeClass = function removeClass(node, classes) {
	  return node && classes && classes.split(' ').forEach(function (c) {
	    return (0, _removeClass.default)(node, c);
	  });
	};
	/**
	 * A transition component inspired by the excellent
	 * [ng-animate](http://www.nganimate.org/) library, you should use it if you're
	 * using CSS transitions or animations. It's built upon the
	 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
	 * component, so it inherits all of its props.
	 *
	 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
	 * and `exit` states of the transition. The first class is applied and then a
	 * second `*-active` class in order to activate the CSSS transition. After the
	 * transition, matching `*-done` class names are applied to persist the
	 * transition state.
	 *
	 * ```jsx
	 * function App() {
	 *   const [inProp, setInProp] = useState(false);
	 *   return (
	 *     <div>
	 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
	 *         <div>
	 *           {"I'll receive my-node-* classes"}
	 *         </div>
	 *       </CSSTransition>
	 *       <button type="button" onClick={() => setInProp(true)}>
	 *         Click to Enter
	 *       </button>
	 *     </div>
	 *   );
	 * }
	 * ```
	 *
	 * When the `in` prop is set to `true`, the child component will first receive
	 * the class `example-enter`, then the `example-enter-active` will be added in
	 * the next tick. `CSSTransition` [forces a
	 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
	 * between before adding the `example-enter-active`. This is an important trick
	 * because it allows us to transition between `example-enter` and
	 * `example-enter-active` even though they were added immediately one after
	 * another. Most notably, this is what makes it possible for us to animate
	 * _appearance_.
	 *
	 * ```css
	 * .my-node-enter {
	 *   opacity: 0;
	 * }
	 * .my-node-enter-active {
	 *   opacity: 1;
	 *   transition: opacity 200ms;
	 * }
	 * .my-node-exit {
	 *   opacity: 1;
	 * }
	 * .my-node-exit-active {
	 *   opacity: 0;
	 *   transition: opacity: 200ms;
	 * }
	 * ```
	 *
	 * `*-active` classes represent which styles you want to animate **to**.
	 */
	
	
	var CSSTransition =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(CSSTransition, _React$Component);
	
	  function CSSTransition() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	
	    _this.onEnter = function (node, appearing) {
	      var _this$getClassNames = _this.getClassNames(appearing ? 'appear' : 'enter'),
	          className = _this$getClassNames.className;
	
	      _this.removeClasses(node, 'exit');
	
	      addClass(node, className);
	
	      if (_this.props.onEnter) {
	        _this.props.onEnter(node, appearing);
	      }
	    };
	
	    _this.onEntering = function (node, appearing) {
	      var _this$getClassNames2 = _this.getClassNames(appearing ? 'appear' : 'enter'),
	          activeClassName = _this$getClassNames2.activeClassName;
	
	      _this.reflowAndAddClass(node, activeClassName);
	
	      if (_this.props.onEntering) {
	        _this.props.onEntering(node, appearing);
	      }
	    };
	
	    _this.onEntered = function (node, appearing) {
	      var appearClassName = _this.getClassNames('appear').doneClassName;
	
	      var enterClassName = _this.getClassNames('enter').doneClassName;
	
	      var doneClassName = appearing ? appearClassName + " " + enterClassName : enterClassName;
	
	      _this.removeClasses(node, appearing ? 'appear' : 'enter');
	
	      addClass(node, doneClassName);
	
	      if (_this.props.onEntered) {
	        _this.props.onEntered(node, appearing);
	      }
	    };
	
	    _this.onExit = function (node) {
	      var _this$getClassNames3 = _this.getClassNames('exit'),
	          className = _this$getClassNames3.className;
	
	      _this.removeClasses(node, 'appear');
	
	      _this.removeClasses(node, 'enter');
	
	      addClass(node, className);
	
	      if (_this.props.onExit) {
	        _this.props.onExit(node);
	      }
	    };
	
	    _this.onExiting = function (node) {
	      var _this$getClassNames4 = _this.getClassNames('exit'),
	          activeClassName = _this$getClassNames4.activeClassName;
	
	      _this.reflowAndAddClass(node, activeClassName);
	
	      if (_this.props.onExiting) {
	        _this.props.onExiting(node);
	      }
	    };
	
	    _this.onExited = function (node) {
	      var _this$getClassNames5 = _this.getClassNames('exit'),
	          doneClassName = _this$getClassNames5.doneClassName;
	
	      _this.removeClasses(node, 'exit');
	
	      addClass(node, doneClassName);
	
	      if (_this.props.onExited) {
	        _this.props.onExited(node);
	      }
	    };
	
	    _this.getClassNames = function (type) {
	      var classNames = _this.props.classNames;
	      var isStringClassNames = typeof classNames === 'string';
	      var prefix = isStringClassNames && classNames ? classNames + '-' : '';
	      var className = isStringClassNames ? prefix + type : classNames[type];
	      var activeClassName = isStringClassNames ? className + '-active' : classNames[type + 'Active'];
	      var doneClassName = isStringClassNames ? className + '-done' : classNames[type + 'Done'];
	      return {
	        className: className,
	        activeClassName: activeClassName,
	        doneClassName: doneClassName
	      };
	    };
	
	    return _this;
	  }
	
	  var _proto = CSSTransition.prototype;
	
	  _proto.removeClasses = function removeClasses(node, type) {
	    var _this$getClassNames6 = this.getClassNames(type),
	        className = _this$getClassNames6.className,
	        activeClassName = _this$getClassNames6.activeClassName,
	        doneClassName = _this$getClassNames6.doneClassName;
	
	    className && removeClass(node, className);
	    activeClassName && removeClass(node, activeClassName);
	    doneClassName && removeClass(node, doneClassName);
	  };
	
	  _proto.reflowAndAddClass = function reflowAndAddClass(node, className) {
	    // This is for to force a repaint,
	    // which is necessary in order to transition styles when adding a class name.
	    if (className) {
	      /* eslint-disable no-unused-expressions */
	      node && node.scrollTop;
	      /* eslint-enable no-unused-expressions */
	
	      addClass(node, className);
	    }
	  };
	
	  _proto.render = function render() {
	    var props = _extends({}, this.props);
	
	    delete props.classNames;
	    return _react.default.createElement(_Transition.default, _extends({}, props, {
	      onEnter: this.onEnter,
	      onEntered: this.onEntered,
	      onEntering: this.onEntering,
	      onExit: this.onExit,
	      onExiting: this.onExiting,
	      onExited: this.onExited
	    }));
	  };
	
	  return CSSTransition;
	}(_react.default.Component);
	
	CSSTransition.defaultProps = {
	  classNames: ''
	};
	CSSTransition.propTypes =  false ? _extends({}, _Transition.default.propTypes, {
	  /**
	   * The animation classNames applied to the component as it enters, exits or
	   * has finished the transition. A single name can be provided and it will be
	   * suffixed for each stage: e.g.
	   *
	   * `classNames="fade"` applies `fade-enter`, `fade-enter-active`,
	   * `fade-enter-done`, `fade-exit`, `fade-exit-active`, `fade-exit-done`,
	   * `fade-appear`, `fade-appear-active`, and `fade-appear-done`.
	   *
	   * **Note**: `fade-appear-done` and `fade-enter-done` will _both_ be applied.
	   * This allows you to define different behavior for when appearing is done and
	   * when regular entering is done, using selectors like
	   * `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply an
	   * epic entrance animation when element first appears in the DOM using
	   * [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
	   * simply use `fade-enter-done` for defining both cases.
	   *
	   * Each individual classNames can also be specified independently like:
	   *
	   * ```js
	   * classNames={{
	   *  appear: 'my-appear',
	   *  appearActive: 'my-active-appear',
	   *  appearDone: 'my-done-appear',
	   *  enter: 'my-enter',
	   *  enterActive: 'my-active-enter',
	   *  enterDone: 'my-done-enter',
	   *  exit: 'my-exit',
	   *  exitActive: 'my-active-exit',
	   *  exitDone: 'my-done-exit',
	   * }}
	   * ```
	   *
	   * If you want to set these classes using CSS Modules:
	   *
	   * ```js
	   * import styles from './styles.css';
	   * ```
	   *
	   * you might want to use camelCase in your CSS file, that way could simply
	   * spread them instead of listing them one by one:
	   *
	   * ```js
	   * classNames={{ ...styles }}
	   * ```
	   *
	   * @type {string | {
	   *  appear?: string,
	   *  appearActive?: string,
	   *  appearDone?: string,
	   *  enter?: string,
	   *  enterActive?: string,
	   *  enterDone?: string,
	   *  exit?: string,
	   *  exitActive?: string,
	   *  exitDone?: string,
	   * }}
	   */
	  classNames: _PropTypes.classNamesShape,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
	   * applied.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEnter: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter-active' or
	   * 'appear-active' class is applied.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntering: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter' or
	   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntered: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit' class is
	   * applied.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExit: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExiting: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit' classes
	   * are **removed** and the `exit-done` class is added to the DOM node.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExited: PropTypes.func
	}) : {};
	var _default = CSSTransition;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1601 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactDom = __webpack_require__(43);
	
	var _TransitionGroup = _interopRequireDefault(__webpack_require__(652));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	/**
	 * The `<ReplaceTransition>` component is a specialized `Transition` component
	 * that animates between two children.
	 *
	 * ```jsx
	 * <ReplaceTransition in>
	 *   <Fade><div>I appear first</div></Fade>
	 *   <Fade><div>I replace the above</div></Fade>
	 * </ReplaceTransition>
	 * ```
	 */
	var ReplaceTransition =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(ReplaceTransition, _React$Component);
	
	  function ReplaceTransition() {
	    var _this;
	
	    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
	      _args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;
	
	    _this.handleEnter = function () {
	      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      return _this.handleLifecycle('onEnter', 0, args);
	    };
	
	    _this.handleEntering = function () {
	      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	        args[_key3] = arguments[_key3];
	      }
	
	      return _this.handleLifecycle('onEntering', 0, args);
	    };
	
	    _this.handleEntered = function () {
	      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	        args[_key4] = arguments[_key4];
	      }
	
	      return _this.handleLifecycle('onEntered', 0, args);
	    };
	
	    _this.handleExit = function () {
	      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
	        args[_key5] = arguments[_key5];
	      }
	
	      return _this.handleLifecycle('onExit', 1, args);
	    };
	
	    _this.handleExiting = function () {
	      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
	        args[_key6] = arguments[_key6];
	      }
	
	      return _this.handleLifecycle('onExiting', 1, args);
	    };
	
	    _this.handleExited = function () {
	      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
	        args[_key7] = arguments[_key7];
	      }
	
	      return _this.handleLifecycle('onExited', 1, args);
	    };
	
	    return _this;
	  }
	
	  var _proto = ReplaceTransition.prototype;
	
	  _proto.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
	    var _child$props;
	
	    var children = this.props.children;
	
	    var child = _react.default.Children.toArray(children)[idx];
	
	    if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);
	    if (this.props[handler]) this.props[handler]((0, _reactDom.findDOMNode)(this));
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        children = _this$props.children,
	        inProp = _this$props.in,
	        props = _objectWithoutPropertiesLoose(_this$props, ["children", "in"]);
	
	    var _React$Children$toArr = _react.default.Children.toArray(children),
	        first = _React$Children$toArr[0],
	        second = _React$Children$toArr[1];
	
	    delete props.onEnter;
	    delete props.onEntering;
	    delete props.onEntered;
	    delete props.onExit;
	    delete props.onExiting;
	    delete props.onExited;
	    return _react.default.createElement(_TransitionGroup.default, props, inProp ? _react.default.cloneElement(first, {
	      key: 'first',
	      onEnter: this.handleEnter,
	      onEntering: this.handleEntering,
	      onEntered: this.handleEntered
	    }) : _react.default.cloneElement(second, {
	      key: 'second',
	      onEnter: this.handleExit,
	      onEntering: this.handleExiting,
	      onEntered: this.handleExited
	    }));
	  };
	
	  return ReplaceTransition;
	}(_react.default.Component);
	
	ReplaceTransition.propTypes =  false ? {
	  in: _propTypes.default.bool.isRequired,
	  children: function children(props, propName) {
	    if (_react.default.Children.count(props[propName]) !== 2) return new Error("\"" + propName + "\" must be exactly two transition components.");
	    return null;
	  }
	} : {};
	var _default = ReplaceTransition;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1602 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.getChildMapping = getChildMapping;
	exports.mergeChildMappings = mergeChildMappings;
	exports.getInitialChildMapping = getInitialChildMapping;
	exports.getNextChildMapping = getNextChildMapping;
	
	var _react = __webpack_require__(1);
	
	/**
	 * Given `this.props.children`, return an object mapping key to child.
	 *
	 * @param {*} children `this.props.children`
	 * @return {object} Mapping of key to child
	 */
	function getChildMapping(children, mapFn) {
	  var mapper = function mapper(child) {
	    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
	  };
	
	  var result = Object.create(null);
	  if (children) _react.Children.map(children, function (c) {
	    return c;
	  }).forEach(function (child) {
	    // run the map function here instead so that the key is the computed one
	    result[child.key] = mapper(child);
	  });
	  return result;
	}
	/**
	 * When you're adding or removing children some may be added or removed in the
	 * same render pass. We want to show *both* since we want to simultaneously
	 * animate elements in and out. This function takes a previous set of keys
	 * and a new set of keys and merges them with its best guess of the correct
	 * ordering. In the future we may expose some of the utilities in
	 * ReactMultiChild to make this easy, but for now React itself does not
	 * directly have this concept of the union of prevChildren and nextChildren
	 * so we implement it here.
	 *
	 * @param {object} prev prev children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @param {object} next next children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @return {object} a key set that contains all keys in `prev` and all keys
	 * in `next` in a reasonable order.
	 */
	
	
	function mergeChildMappings(prev, next) {
	  prev = prev || {};
	  next = next || {};
	
	  function getValueForKey(key) {
	    return key in next ? next[key] : prev[key];
	  } // For each key of `next`, the list of keys to insert before that key in
	  // the combined list
	
	
	  var nextKeysPending = Object.create(null);
	  var pendingKeys = [];
	
	  for (var prevKey in prev) {
	    if (prevKey in next) {
	      if (pendingKeys.length) {
	        nextKeysPending[prevKey] = pendingKeys;
	        pendingKeys = [];
	      }
	    } else {
	      pendingKeys.push(prevKey);
	    }
	  }
	
	  var i;
	  var childMapping = {};
	
	  for (var nextKey in next) {
	    if (nextKeysPending[nextKey]) {
	      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	        var pendingNextKey = nextKeysPending[nextKey][i];
	        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
	      }
	    }
	
	    childMapping[nextKey] = getValueForKey(nextKey);
	  } // Finally, add the keys which didn't appear before any key in `next`
	
	
	  for (i = 0; i < pendingKeys.length; i++) {
	    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	  }
	
	  return childMapping;
	}
	
	function getProp(child, prop, props) {
	  return props[prop] != null ? props[prop] : child.props[prop];
	}
	
	function getInitialChildMapping(props, onExited) {
	  return getChildMapping(props.children, function (child) {
	    return (0, _react.cloneElement)(child, {
	      onExited: onExited.bind(null, child),
	      in: true,
	      appear: getProp(child, 'appear', props),
	      enter: getProp(child, 'enter', props),
	      exit: getProp(child, 'exit', props)
	    });
	  });
	}
	
	function getNextChildMapping(nextProps, prevChildMapping, onExited) {
	  var nextChildMapping = getChildMapping(nextProps.children);
	  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
	  Object.keys(children).forEach(function (key) {
	    var child = children[key];
	    if (!(0, _react.isValidElement)(child)) return;
	    var hasPrev = key in prevChildMapping;
	    var hasNext = key in nextChildMapping;
	    var prevChild = prevChildMapping[key];
	    var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
	
	    if (hasNext && (!hasPrev || isLeaving)) {
	      // console.log('entering', key)
	      children[key] = (0, _react.cloneElement)(child, {
	        onExited: onExited.bind(null, child),
	        in: true,
	        exit: getProp(child, 'exit', nextProps),
	        enter: getProp(child, 'enter', nextProps)
	      });
	    } else if (!hasNext && hasPrev && !isLeaving) {
	      // item is old (exiting)
	      // console.log('leaving', key)
	      children[key] = (0, _react.cloneElement)(child, {
	        in: false
	      });
	    } else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
	      // item hasn't changed transition states
	      // copy over the last transition props;
	      // console.log('unchanged', key)
	      children[key] = (0, _react.cloneElement)(child, {
	        onExited: onExited.bind(null, child),
	        in: prevChild.props.in,
	        exit: getProp(child, 'exit', nextProps),
	        enter: getProp(child, 'enter', nextProps)
	      });
	    }
	  });
	  return children;
	}

/***/ },
/* 1603 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(116);


/***/ },
/* 1604 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a passthrough stream.
	// basically just the most minimal sort of Transform stream.
	// Every written chunk gets output as-is.
	
	'use strict';
	
	module.exports = PassThrough;
	
	var Transform = __webpack_require__(655);
	
	/*<replacement>*/
	var util = Object.create(__webpack_require__(147));
	util.inherits = __webpack_require__(126);
	/*</replacement>*/
	
	util.inherits(PassThrough, Transform);
	
	function PassThrough(options) {
	  if (!(this instanceof PassThrough)) return new PassThrough(options);
	
	  Transform.call(this, options);
	}
	
	PassThrough.prototype._transform = function (chunk, encoding, cb) {
	  cb(null, chunk);
	};

/***/ },
/* 1605 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Buffer = __webpack_require__(213).Buffer;
	var util = __webpack_require__(1663);
	
	function copyBuffer(src, target, offset) {
	  src.copy(target, offset);
	}
	
	module.exports = function () {
	  function BufferList() {
	    _classCallCheck(this, BufferList);
	
	    this.head = null;
	    this.tail = null;
	    this.length = 0;
	  }
	
	  BufferList.prototype.push = function push(v) {
	    var entry = { data: v, next: null };
	    if (this.length > 0) this.tail.next = entry;else this.head = entry;
	    this.tail = entry;
	    ++this.length;
	  };
	
	  BufferList.prototype.unshift = function unshift(v) {
	    var entry = { data: v, next: this.head };
	    if (this.length === 0) this.tail = entry;
	    this.head = entry;
	    ++this.length;
	  };
	
	  BufferList.prototype.shift = function shift() {
	    if (this.length === 0) return;
	    var ret = this.head.data;
	    if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
	    --this.length;
	    return ret;
	  };
	
	  BufferList.prototype.clear = function clear() {
	    this.head = this.tail = null;
	    this.length = 0;
	  };
	
	  BufferList.prototype.join = function join(s) {
	    if (this.length === 0) return '';
	    var p = this.head;
	    var ret = '' + p.data;
	    while (p = p.next) {
	      ret += s + p.data;
	    }return ret;
	  };
	
	  BufferList.prototype.concat = function concat(n) {
	    if (this.length === 0) return Buffer.alloc(0);
	    var ret = Buffer.allocUnsafe(n >>> 0);
	    var p = this.head;
	    var i = 0;
	    while (p) {
	      copyBuffer(p.data, ret, i);
	      i += p.data.length;
	      p = p.next;
	    }
	    return ret;
	  };
	
	  return BufferList;
	}();
	
	if (util && util.inspect && util.inspect.custom) {
	  module.exports.prototype[util.inspect.custom] = function () {
	    var obj = util.inspect({ length: this.length });
	    return this.constructor.name + ' ' + obj;
	  };
	}

/***/ },
/* 1606 */
1071,
/* 1607 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(305).PassThrough


/***/ },
/* 1608 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(305).Transform


/***/ },
/* 1609 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(304);


/***/ },
/* 1610 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var define = __webpack_require__(150);
	var callBind = __webpack_require__(252);
	
	var implementation = __webpack_require__(658);
	var getPolyfill = __webpack_require__(659);
	var shim = __webpack_require__(1611);
	
	var flagsBound = callBind(getPolyfill());
	
	define(flagsBound, {
		getPolyfill: getPolyfill,
		implementation: implementation,
		shim: shim
	});
	
	module.exports = flagsBound;


/***/ },
/* 1611 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var supportsDescriptors = __webpack_require__(150).supportsDescriptors;
	var getPolyfill = __webpack_require__(659);
	var gOPD = __webpack_require__(125);
	var defineProperty = Object.defineProperty;
	var $TypeError = __webpack_require__(425);
	var getProto = __webpack_require__(435);
	var regex = /a/;
	
	module.exports = function shimFlags() {
		if (!supportsDescriptors || !getProto) {
			throw new $TypeError('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
		}
		var polyfill = getPolyfill();
		var proto = getProto(regex);
		var descriptor = gOPD(proto, 'flags');
		if (!descriptor || descriptor.get !== polyfill) {
			defineProperty(proto, 'flags', {
				configurable: true,
				enumerable: false,
				get: polyfill
			});
		}
		return polyfill;
	};


/***/ },
/* 1612 */
/***/ function(module, exports) {

	"use strict";function isAbsolute(e){return"/"===e.charAt(0)}function spliceOne(e,t){for(var s=t,n=s+1,i=e.length;n<i;s+=1,n+=1)e[s]=e[n];e.pop()}function resolvePathname(e,t){void 0===t&&(t="");var s,n=e&&e.split("/")||[],i=t&&t.split("/")||[],l=e&&isAbsolute(e),r=t&&isAbsolute(t),o=l||r;if(e&&isAbsolute(e)?i=n:n.length&&(i.pop(),i=i.concat(n)),!i.length)return"/";if(i.length){var u=i[i.length-1];s="."===u||".."===u||""===u}else s=!1;for(var a=0,c=i.length;0<=c;c--){var f=i[c];"."===f?spliceOne(i,c):".."===f?(spliceOne(i,c),a++):a&&(spliceOne(i,c),a--)}if(!o)for(;a--;a)i.unshift("..");!o||""===i[0]||i[0]&&isAbsolute(i[0])||i.unshift("");var h=i.join("/");return s&&"/"!==h.substr(-1)&&(h+="/"),h}module.exports=resolvePathname;


/***/ },
/* 1613 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(1612);
	} else {
	  module.exports = require('./cjs/resolve-pathname.js');
	}


/***/ },
/* 1614 */
/***/ function(module, exports) {

	/** @license React v0.19.1
	 * scheduler.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var f,g,h,k,l;
	if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,t=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(t,0),b;}},u=Date.now();exports.unstable_now=function(){return Date.now()-u};f=function(a){null!==p?setTimeout(f,0,a):(p=a,setTimeout(t,0))};g=function(a,b){q=setTimeout(a,b)};h=function(){clearTimeout(q)};k=function(){return!1};l=exports.unstable_forceFrameRate=function(){}}else{var w=window.performance,x=window.Date,
	y=window.setTimeout,z=window.clearTimeout;if("undefined"!==typeof console){var A=window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");"function"!==typeof A&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills")}if("object"===
	typeof w&&"function"===typeof w.now)exports.unstable_now=function(){return w.now()};else{var B=x.now();exports.unstable_now=function(){return x.now()-B}}var C=!1,D=null,E=-1,F=5,G=0;k=function(){return exports.unstable_now()>=G};l=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):F=0<a?Math.floor(1E3/a):5};var H=new MessageChannel,I=H.port2;H.port1.onmessage=
	function(){if(null!==D){var a=exports.unstable_now();G=a+F;try{D(!0,a)?I.postMessage(null):(C=!1,D=null)}catch(b){throw I.postMessage(null),b;}}else C=!1};f=function(a){D=a;C||(C=!0,I.postMessage(null))};g=function(a,b){E=y(function(){a(exports.unstable_now())},b)};h=function(){z(E);E=-1}}function J(a,b){var c=a.length;a.push(b);a:for(;;){var d=c-1>>>1,e=a[d];if(void 0!==e&&0<K(e,b))a[d]=b,a[c]=e,c=d;else break a}}function L(a){a=a[0];return void 0===a?null:a}
	function M(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>K(n,c))void 0!==r&&0>K(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>K(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function K(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var N=[],O=[],P=1,Q=null,R=3,S=!1,T=!1,U=!1;
	function V(a){for(var b=L(O);null!==b;){if(null===b.callback)M(O);else if(b.startTime<=a)M(O),b.sortIndex=b.expirationTime,J(N,b);else break;b=L(O)}}function W(a){U=!1;V(a);if(!T)if(null!==L(N))T=!0,f(X);else{var b=L(O);null!==b&&g(W,b.startTime-a)}}
	function X(a,b){T=!1;U&&(U=!1,h());S=!0;var c=R;try{V(b);for(Q=L(N);null!==Q&&(!(Q.expirationTime>b)||a&&!k());){var d=Q.callback;if(null!==d){Q.callback=null;R=Q.priorityLevel;var e=d(Q.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?Q.callback=e:Q===L(N)&&M(N);V(b)}else M(N);Q=L(N)}if(null!==Q)var m=!0;else{var n=L(O);null!==n&&g(W,n.startTime-b);m=!1}return m}finally{Q=null,R=c,S=!1}}
	function Y(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}var Z=l;exports.unstable_IdlePriority=5;exports.unstable_ImmediatePriority=1;exports.unstable_LowPriority=4;exports.unstable_NormalPriority=3;exports.unstable_Profiling=null;exports.unstable_UserBlockingPriority=2;exports.unstable_cancelCallback=function(a){a.callback=null};exports.unstable_continueExecution=function(){T||S||(T=!0,f(X))};
	exports.unstable_getCurrentPriorityLevel=function(){return R};exports.unstable_getFirstCallbackNode=function(){return L(N)};exports.unstable_next=function(a){switch(R){case 1:case 2:case 3:var b=3;break;default:b=R}var c=R;R=b;try{return a()}finally{R=c}};exports.unstable_pauseExecution=function(){};exports.unstable_requestPaint=Z;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=R;R=a;try{return b()}finally{R=c}};
	exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();if("object"===typeof c&&null!==c){var e=c.delay;e="number"===typeof e&&0<e?d+e:d;c="number"===typeof c.timeout?c.timeout:Y(a)}else c=Y(a),e=d;c=e+c;a={id:P++,callback:b,priorityLevel:a,startTime:e,expirationTime:c,sortIndex:-1};e>d?(a.sortIndex=e,J(O,a),null===L(N)&&a===L(O)&&(U?h():U=!0,g(W,e-d))):(a.sortIndex=c,J(N,a),T||S||(T=!0,f(X)));return a};
	exports.unstable_shouldYield=function(){var a=exports.unstable_now();V(a);var b=L(N);return b!==Q&&null!==Q&&null!==b&&null!==b.callback&&b.startTime<=a&&b.expirationTime<Q.expirationTime||k()};exports.unstable_wrapCallback=function(a){var b=R;return function(){var c=R;R=b;try{return a.apply(this,arguments)}finally{R=c}}};


/***/ },
/* 1615 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(1614);
	} else {
	  module.exports = require('./cjs/scheduler.development.js');
	}


/***/ },
/* 1616 */
/***/ function(module, exports) {

	"use strict";
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	module.exports = function (_ref) {
	  var data = _ref.data;
	  var multiSection = _ref.multiSection;
	
	  function nextNonEmptySectionIndex(sectionIndex) {
	    if (sectionIndex === null) {
	      sectionIndex = 0;
	    } else {
	      sectionIndex++;
	    }
	
	    while (sectionIndex < data.length && data[sectionIndex] === 0) {
	      sectionIndex++;
	    }
	
	    return sectionIndex === data.length ? null : sectionIndex;
	  }
	
	  function prevNonEmptySectionIndex(sectionIndex) {
	    if (sectionIndex === null) {
	      sectionIndex = data.length - 1;
	    } else {
	      sectionIndex--;
	    }
	
	    while (sectionIndex >= 0 && data[sectionIndex] === 0) {
	      sectionIndex--;
	    }
	
	    return sectionIndex === -1 ? null : sectionIndex;
	  }
	
	  function next(position) {
	    var _position = _slicedToArray(position, 2);
	
	    var sectionIndex = _position[0];
	    var itemIndex = _position[1];
	
	
	    if (multiSection) {
	      if (itemIndex === null || itemIndex === data[sectionIndex] - 1) {
	        sectionIndex = nextNonEmptySectionIndex(sectionIndex);
	
	        if (sectionIndex === null) {
	          return [null, null];
	        }
	
	        return [sectionIndex, 0];
	      }
	
	      return [sectionIndex, itemIndex + 1];
	    }
	
	    if (data === 0 || itemIndex === data - 1) {
	      return [null, null];
	    }
	
	    if (itemIndex === null) {
	      return [null, 0];
	    }
	
	    return [null, itemIndex + 1];
	  }
	
	  function prev(position) {
	    var _position2 = _slicedToArray(position, 2);
	
	    var sectionIndex = _position2[0];
	    var itemIndex = _position2[1];
	
	
	    if (multiSection) {
	      if (itemIndex === null || itemIndex === 0) {
	        sectionIndex = prevNonEmptySectionIndex(sectionIndex);
	
	        if (sectionIndex === null) {
	          return [null, null];
	        }
	
	        return [sectionIndex, data[sectionIndex] - 1];
	      }
	
	      return [sectionIndex, itemIndex - 1];
	    }
	
	    if (data === 0 || itemIndex === 0) {
	      return [null, null];
	    }
	
	    if (itemIndex === null) {
	      return [null, data - 1];
	    }
	
	    return [null, itemIndex - 1];
	  }
	
	  function isLast(position) {
	    return next(position)[1] === null;
	  }
	
	  return {
	    next: next,
	    prev: prev,
	    isLast: isLast
	  };
	};


/***/ },
/* 1617 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var GetIntrinsic = __webpack_require__(272);
	var define = __webpack_require__(261);
	var hasDescriptors = __webpack_require__(273)();
	var gOPD = __webpack_require__(125);
	
	var $TypeError = __webpack_require__(120);
	var $floor = GetIntrinsic('%Math.floor%');
	
	/** @type {import('.')} */
	module.exports = function setFunctionLength(fn, length) {
		if (typeof fn !== 'function') {
			throw new $TypeError('`fn` is not a function');
		}
		if (typeof length !== 'number' || length < 0 || length > 0xFFFFFFFF || $floor(length) !== length) {
			throw new $TypeError('`length` must be a positive 32-bit integer');
		}
	
		var loose = arguments.length > 2 && !!arguments[2];
	
		var functionLengthIsConfigurable = true;
		var functionLengthIsWritable = true;
		if ('length' in fn && gOPD) {
			var desc = gOPD(fn, 'length');
			if (desc && !desc.configurable) {
				functionLengthIsConfigurable = false;
			}
			if (desc && !desc.writable) {
				functionLengthIsWritable = false;
			}
		}
	
		if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
			if (hasDescriptors) {
				define(/** @type {Parameters<define>[0]} */ (fn), 'length', length, true, true);
			} else {
				define(/** @type {Parameters<define>[0]} */ (fn), 'length', length);
			}
		}
		return fn;
	};


/***/ },
/* 1618 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var define = __webpack_require__(261);
	var hasDescriptors = __webpack_require__(273)();
	var functionsHaveConfigurableNames = __webpack_require__(1298).functionsHaveConfigurableNames();
	
	var $TypeError = __webpack_require__(120);
	
	/** @type {import('.')} */
	module.exports = function setFunctionName(fn, name) {
		if (typeof fn !== 'function') {
			throw new $TypeError('`fn` is not a function');
		}
		var loose = arguments.length > 2 && !!arguments[2];
		if (!loose || functionsHaveConfigurableNames) {
			if (hasDescriptors) {
				define(/** @type {Parameters<define>[0]} */ (fn), 'name', name, true, true);
			} else {
				define(/** @type {Parameters<define>[0]} */ (fn), 'name', name);
			}
		}
		return fn;
	};


/***/ },
/* 1619 */
/***/ function(module, exports) {

	'use strict';
	
	function shallowEqualArrays(arrA, arrB) {
	  if (arrA === arrB) {
	    return true;
	  }
	
	  if (!arrA || !arrB) {
	    return false;
	  }
	
	  var len = arrA.length;
	
	  if (arrB.length !== len) {
	    return false;
	  }
	
	  for (var i = 0; i < len; i++) {
	    if (arrA[i] !== arrB[i]) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqualArrays;


/***/ },
/* 1620 */
/***/ function(module, exports) {

	//
	
	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	  if (ret !== void 0) {
	    return !!ret;
	  }
	
	  if (objA === objB) {
	    return true;
	  }
	
	  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	  // Test for A's keys different from B.
	  for (var idx = 0; idx < keysA.length; idx++) {
	    var key = keysA[idx];
	
	    if (!bHasOwnProperty(key)) {
	      return false;
	    }
	
	    var valueA = objA[key];
	    var valueB = objB[key];
	
	    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	    if (ret === false || (ret === void 0 && valueA !== valueB)) {
	      return false;
	    }
	  }
	
	  return true;
	};


/***/ },
/* 1621 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	module.exports = Stream;
	
	var EE = __webpack_require__(155).EventEmitter;
	var inherits = __webpack_require__(126);
	
	inherits(Stream, EE);
	Stream.Readable = __webpack_require__(305);
	Stream.Writable = __webpack_require__(1609);
	Stream.Duplex = __webpack_require__(1603);
	Stream.Transform = __webpack_require__(1608);
	Stream.PassThrough = __webpack_require__(1607);
	
	// Backwards-compat with node 0.4.x
	Stream.Stream = Stream;
	
	
	
	// old-style streams.  Note that the pipe method (the only relevant
	// part of this class) is overridden in the Readable class.
	
	function Stream() {
	  EE.call(this);
	}
	
	Stream.prototype.pipe = function(dest, options) {
	  var source = this;
	
	  function ondata(chunk) {
	    if (dest.writable) {
	      if (false === dest.write(chunk) && source.pause) {
	        source.pause();
	      }
	    }
	  }
	
	  source.on('data', ondata);
	
	  function ondrain() {
	    if (source.readable && source.resume) {
	      source.resume();
	    }
	  }
	
	  dest.on('drain', ondrain);
	
	  // If the 'end' option is not supplied, dest.end() will be called when
	  // source gets the 'end' or 'close' events.  Only dest.end() once.
	  if (!dest._isStdio && (!options || options.end !== false)) {
	    source.on('end', onend);
	    source.on('close', onclose);
	  }
	
	  var didOnEnd = false;
	  function onend() {
	    if (didOnEnd) return;
	    didOnEnd = true;
	
	    dest.end();
	  }
	
	
	  function onclose() {
	    if (didOnEnd) return;
	    didOnEnd = true;
	
	    if (typeof dest.destroy === 'function') dest.destroy();
	  }
	
	  // don't leave dangling pipes when there are errors.
	  function onerror(er) {
	    cleanup();
	    if (EE.listenerCount(this, 'error') === 0) {
	      throw er; // Unhandled stream error in pipe.
	    }
	  }
	
	  source.on('error', onerror);
	  dest.on('error', onerror);
	
	  // remove all the event listeners that were added.
	  function cleanup() {
	    source.removeListener('data', ondata);
	    dest.removeListener('drain', ondrain);
	
	    source.removeListener('end', onend);
	    source.removeListener('close', onclose);
	
	    source.removeListener('error', onerror);
	    dest.removeListener('error', onerror);
	
	    source.removeListener('end', cleanup);
	    source.removeListener('close', cleanup);
	
	    dest.removeListener('close', cleanup);
	  }
	
	  source.on('end', cleanup);
	  source.on('close', cleanup);
	
	  dest.on('close', cleanup);
	
	  dest.emit('pipe', source);
	
	  // Allow for unix-like usage: A.pipe(B).pipe(C)
	  return dest;
	};


/***/ },
/* 1622 */
/***/ function(module, exports) {

	'use strict';
	module.exports = function (str) {
		return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
			return '%' + c.charCodeAt(0).toString(16).toUpperCase();
		});
	};


/***/ },
/* 1623 */
/***/ function(module, exports) {

	var camel2hyphen = function (str) {
	  return str
	          .replace(/[A-Z]/g, function (match) {
	            return '-' + match.toLowerCase();
	          })
	          .toLowerCase();
	};
	
	module.exports = camel2hyphen;

/***/ },
/* 1624 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {"use strict";function e(e){return e&&"object"==typeof e&&"default"in e?e.default:e}Object.defineProperty(exports,"__esModule",{value:!0});var t=__webpack_require__(168),n=__webpack_require__(1),r=e(n),o=e(__webpack_require__(1620)),s=e(__webpack_require__(703)),i=e(__webpack_require__(704)),a=e(__webpack_require__(1625)),c=e(__webpack_require__(157));function u(){return(u=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e}).apply(this,arguments)}var l=function(e,t){for(var n=[e[0]],r=0,o=t.length;r<o;r+=1)n.push(t[r],e[r+1]);return n},d=function(e){return null!==e&&"object"==typeof e&&"[object Object]"===(e.toString?e.toString():Object.prototype.toString.call(e))&&!t.typeOf(e)},h=Object.freeze([]),p=Object.freeze({});function f(e){return"function"==typeof e}function m(e){return"production"!==("production")&&"string"==typeof e&&e||e.displayName||e.name||"Component"}function y(e){return e&&"string"==typeof e.styledComponentId}var v="undefined"!=typeof process&&void 0!==({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_USERURL":"https://www.bewise.in/","REACT_APP_TINY_EDITOR":"te4wakzk2tutx8pwzcbikp01f6cqsemlyubqa6juufgdrwmm","REACT_APP_RAZORPAY_LIVE":"rzp_live_B1Rc514TPFi72L","REACT_APP_GOOGLE_CAPTCHA_SITE_KEY":"6Le5HyAqAAAAAPcf0Em_niWQ8eWnVwTIbQdwU0pW","REACT_APP_API_PATH":"https://api.bewise.in/api/","REACT_APP_RAZORPAY_TEST":"rzp_live_B1Rc514TPFi72L","REACT_APP_ASSET_PATH":"https://bewiseblobprod.blob.core.windows.net/assets/bewise/uploads/","REACT_APP_GOOGLE_CAPTCHA_SECRET_KEY":"6Le5HyAqAAAAADaxdwTC-cyLAsOI27illPepM6Wu"})&&(({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_USERURL":"https://www.bewise.in/","REACT_APP_TINY_EDITOR":"te4wakzk2tutx8pwzcbikp01f6cqsemlyubqa6juufgdrwmm","REACT_APP_RAZORPAY_LIVE":"rzp_live_B1Rc514TPFi72L","REACT_APP_GOOGLE_CAPTCHA_SITE_KEY":"6Le5HyAqAAAAAPcf0Em_niWQ8eWnVwTIbQdwU0pW","REACT_APP_API_PATH":"https://api.bewise.in/api/","REACT_APP_RAZORPAY_TEST":"rzp_live_B1Rc514TPFi72L","REACT_APP_ASSET_PATH":"https://bewiseblobprod.blob.core.windows.net/assets/bewise/uploads/","REACT_APP_GOOGLE_CAPTCHA_SECRET_KEY":"6Le5HyAqAAAAADaxdwTC-cyLAsOI27illPepM6Wu"}).REACT_APP_SC_ATTR||({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_USERURL":"https://www.bewise.in/","REACT_APP_TINY_EDITOR":"te4wakzk2tutx8pwzcbikp01f6cqsemlyubqa6juufgdrwmm","REACT_APP_RAZORPAY_LIVE":"rzp_live_B1Rc514TPFi72L","REACT_APP_GOOGLE_CAPTCHA_SITE_KEY":"6Le5HyAqAAAAAPcf0Em_niWQ8eWnVwTIbQdwU0pW","REACT_APP_API_PATH":"https://api.bewise.in/api/","REACT_APP_RAZORPAY_TEST":"rzp_live_B1Rc514TPFi72L","REACT_APP_ASSET_PATH":"https://bewiseblobprod.blob.core.windows.net/assets/bewise/uploads/","REACT_APP_GOOGLE_CAPTCHA_SECRET_KEY":"6Le5HyAqAAAAADaxdwTC-cyLAsOI27illPepM6Wu"}).SC_ATTR)||"data-styled",g="undefined"!=typeof window&&"HTMLElement"in window,S=Boolean("boolean"==typeof SC_DISABLE_SPEEDY?SC_DISABLE_SPEEDY:"undefined"!=typeof process&&void 0!==({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_USERURL":"https://www.bewise.in/","REACT_APP_TINY_EDITOR":"te4wakzk2tutx8pwzcbikp01f6cqsemlyubqa6juufgdrwmm","REACT_APP_RAZORPAY_LIVE":"rzp_live_B1Rc514TPFi72L","REACT_APP_GOOGLE_CAPTCHA_SITE_KEY":"6Le5HyAqAAAAAPcf0Em_niWQ8eWnVwTIbQdwU0pW","REACT_APP_API_PATH":"https://api.bewise.in/api/","REACT_APP_RAZORPAY_TEST":"rzp_live_B1Rc514TPFi72L","REACT_APP_ASSET_PATH":"https://bewiseblobprod.blob.core.windows.net/assets/bewise/uploads/","REACT_APP_GOOGLE_CAPTCHA_SECRET_KEY":"6Le5HyAqAAAAADaxdwTC-cyLAsOI27illPepM6Wu"})&&(void 0!==({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_USERURL":"https://www.bewise.in/","REACT_APP_TINY_EDITOR":"te4wakzk2tutx8pwzcbikp01f6cqsemlyubqa6juufgdrwmm","REACT_APP_RAZORPAY_LIVE":"rzp_live_B1Rc514TPFi72L","REACT_APP_GOOGLE_CAPTCHA_SITE_KEY":"6Le5HyAqAAAAAPcf0Em_niWQ8eWnVwTIbQdwU0pW","REACT_APP_API_PATH":"https://api.bewise.in/api/","REACT_APP_RAZORPAY_TEST":"rzp_live_B1Rc514TPFi72L","REACT_APP_ASSET_PATH":"https://bewiseblobprod.blob.core.windows.net/assets/bewise/uploads/","REACT_APP_GOOGLE_CAPTCHA_SECRET_KEY":"6Le5HyAqAAAAADaxdwTC-cyLAsOI27illPepM6Wu"}).REACT_APP_SC_DISABLE_SPEEDY&&""!==({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_USERURL":"https://www.bewise.in/","REACT_APP_TINY_EDITOR":"te4wakzk2tutx8pwzcbikp01f6cqsemlyubqa6juufgdrwmm","REACT_APP_RAZORPAY_LIVE":"rzp_live_B1Rc514TPFi72L","REACT_APP_GOOGLE_CAPTCHA_SITE_KEY":"6Le5HyAqAAAAAPcf0Em_niWQ8eWnVwTIbQdwU0pW","REACT_APP_API_PATH":"https://api.bewise.in/api/","REACT_APP_RAZORPAY_TEST":"rzp_live_B1Rc514TPFi72L","REACT_APP_ASSET_PATH":"https://bewiseblobprod.blob.core.windows.net/assets/bewise/uploads/","REACT_APP_GOOGLE_CAPTCHA_SECRET_KEY":"6Le5HyAqAAAAADaxdwTC-cyLAsOI27illPepM6Wu"}).REACT_APP_SC_DISABLE_SPEEDY?"false"!==({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_USERURL":"https://www.bewise.in/","REACT_APP_TINY_EDITOR":"te4wakzk2tutx8pwzcbikp01f6cqsemlyubqa6juufgdrwmm","REACT_APP_RAZORPAY_LIVE":"rzp_live_B1Rc514TPFi72L","REACT_APP_GOOGLE_CAPTCHA_SITE_KEY":"6Le5HyAqAAAAAPcf0Em_niWQ8eWnVwTIbQdwU0pW","REACT_APP_API_PATH":"https://api.bewise.in/api/","REACT_APP_RAZORPAY_TEST":"rzp_live_B1Rc514TPFi72L","REACT_APP_ASSET_PATH":"https://bewiseblobprod.blob.core.windows.net/assets/bewise/uploads/","REACT_APP_GOOGLE_CAPTCHA_SECRET_KEY":"6Le5HyAqAAAAADaxdwTC-cyLAsOI27illPepM6Wu"}).REACT_APP_SC_DISABLE_SPEEDY&&({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_USERURL":"https://www.bewise.in/","REACT_APP_TINY_EDITOR":"te4wakzk2tutx8pwzcbikp01f6cqsemlyubqa6juufgdrwmm","REACT_APP_RAZORPAY_LIVE":"rzp_live_B1Rc514TPFi72L","REACT_APP_GOOGLE_CAPTCHA_SITE_KEY":"6Le5HyAqAAAAAPcf0Em_niWQ8eWnVwTIbQdwU0pW","REACT_APP_API_PATH":"https://api.bewise.in/api/","REACT_APP_RAZORPAY_TEST":"rzp_live_B1Rc514TPFi72L","REACT_APP_ASSET_PATH":"https://bewiseblobprod.blob.core.windows.net/assets/bewise/uploads/","REACT_APP_GOOGLE_CAPTCHA_SECRET_KEY":"6Le5HyAqAAAAADaxdwTC-cyLAsOI27illPepM6Wu"}).REACT_APP_SC_DISABLE_SPEEDY:void 0!==({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_USERURL":"https://www.bewise.in/","REACT_APP_TINY_EDITOR":"te4wakzk2tutx8pwzcbikp01f6cqsemlyubqa6juufgdrwmm","REACT_APP_RAZORPAY_LIVE":"rzp_live_B1Rc514TPFi72L","REACT_APP_GOOGLE_CAPTCHA_SITE_KEY":"6Le5HyAqAAAAAPcf0Em_niWQ8eWnVwTIbQdwU0pW","REACT_APP_API_PATH":"https://api.bewise.in/api/","REACT_APP_RAZORPAY_TEST":"rzp_live_B1Rc514TPFi72L","REACT_APP_ASSET_PATH":"https://bewiseblobprod.blob.core.windows.net/assets/bewise/uploads/","REACT_APP_GOOGLE_CAPTCHA_SECRET_KEY":"6Le5HyAqAAAAADaxdwTC-cyLAsOI27illPepM6Wu"}).SC_DISABLE_SPEEDY&&""!==({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_USERURL":"https://www.bewise.in/","REACT_APP_TINY_EDITOR":"te4wakzk2tutx8pwzcbikp01f6cqsemlyubqa6juufgdrwmm","REACT_APP_RAZORPAY_LIVE":"rzp_live_B1Rc514TPFi72L","REACT_APP_GOOGLE_CAPTCHA_SITE_KEY":"6Le5HyAqAAAAAPcf0Em_niWQ8eWnVwTIbQdwU0pW","REACT_APP_API_PATH":"https://api.bewise.in/api/","REACT_APP_RAZORPAY_TEST":"rzp_live_B1Rc514TPFi72L","REACT_APP_ASSET_PATH":"https://bewiseblobprod.blob.core.windows.net/assets/bewise/uploads/","REACT_APP_GOOGLE_CAPTCHA_SECRET_KEY":"6Le5HyAqAAAAADaxdwTC-cyLAsOI27illPepM6Wu"}).SC_DISABLE_SPEEDY?"false"!==({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_USERURL":"https://www.bewise.in/","REACT_APP_TINY_EDITOR":"te4wakzk2tutx8pwzcbikp01f6cqsemlyubqa6juufgdrwmm","REACT_APP_RAZORPAY_LIVE":"rzp_live_B1Rc514TPFi72L","REACT_APP_GOOGLE_CAPTCHA_SITE_KEY":"6Le5HyAqAAAAAPcf0Em_niWQ8eWnVwTIbQdwU0pW","REACT_APP_API_PATH":"https://api.bewise.in/api/","REACT_APP_RAZORPAY_TEST":"rzp_live_B1Rc514TPFi72L","REACT_APP_ASSET_PATH":"https://bewiseblobprod.blob.core.windows.net/assets/bewise/uploads/","REACT_APP_GOOGLE_CAPTCHA_SECRET_KEY":"6Le5HyAqAAAAADaxdwTC-cyLAsOI27illPepM6Wu"}).SC_DISABLE_SPEEDY&&({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_USERURL":"https://www.bewise.in/","REACT_APP_TINY_EDITOR":"te4wakzk2tutx8pwzcbikp01f6cqsemlyubqa6juufgdrwmm","REACT_APP_RAZORPAY_LIVE":"rzp_live_B1Rc514TPFi72L","REACT_APP_GOOGLE_CAPTCHA_SITE_KEY":"6Le5HyAqAAAAAPcf0Em_niWQ8eWnVwTIbQdwU0pW","REACT_APP_API_PATH":"https://api.bewise.in/api/","REACT_APP_RAZORPAY_TEST":"rzp_live_B1Rc514TPFi72L","REACT_APP_ASSET_PATH":"https://bewiseblobprod.blob.core.windows.net/assets/bewise/uploads/","REACT_APP_GOOGLE_CAPTCHA_SECRET_KEY":"6Le5HyAqAAAAADaxdwTC-cyLAsOI27illPepM6Wu"}).SC_DISABLE_SPEEDY:"production"!==("production"))),w={},E= false?{1:"Cannot create styled-component for component: %s.\n\n",2:"Can't collect styles once you've consumed a `ServerStyleSheet`'s styles! `ServerStyleSheet` is a one off instance for each server-side render cycle.\n\n- Are you trying to reuse it across renders?\n- Are you accidentally calling collectStyles twice?\n\n",3:"Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.\n\n",4:"The `StyleSheetManager` expects a valid target or sheet prop!\n\n- Does this error occur on the client and is your target falsy?\n- Does this error occur on the server and is the sheet falsy?\n\n",5:"The clone method cannot be used on the client!\n\n- Are you running in a client-like environment on the server?\n- Are you trying to run SSR on the client?\n\n",6:"Trying to insert a new style tag, but the given Node is unmounted!\n\n- Are you using a custom target that isn't mounted?\n- Does your document not have a valid head element?\n- Have you accidentally removed a style tag manually?\n\n",7:'ThemeProvider: Please return an object from your "theme" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n',8:'ThemeProvider: Please make your "theme" prop an object.\n\n',9:"Missing document `<head>`\n\n",10:"Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021\n\n",11:"_This error was replaced with a dev-time warning, it will be deleted for v4 final._ [createGlobalStyle] received children which will not be rendered. Please use the component without passing children elements.\n\n",12:"It seems you are interpolating a keyframe declaration (%s) into an untagged string. This was supported in styled-components v3, but is not longer supported in v4 as keyframes are now injected on-demand. Please wrap your string in the css\\`\\` helper which ensures the styles are injected correctly. See https://www.styled-components.com/docs/api#css\n\n",13:"%s is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.\n\n",14:'ThemeProvider: "theme" prop is required.\n\n',15:"A stylis plugin has been supplied that is not named. We need a name for each plugin to be able to prevent styling collisions between different stylis configurations within the same app. Before you pass your plugin to `<StyleSheetManager stylisPlugins={[]}>`, please make sure each plugin is uniquely-named, e.g.\n\n```js\nObject.defineProperty(importedPlugin, 'name', { value: 'some-unique-name' });\n```\n\n",16:"Reached the limit of how many styled components may be created at group %s.\nYou may only create up to 1,073,741,824 components. If you're creating components dynamically,\nas for instance in your render method then you may be running into this limitation.\n\n",17:"CSSStyleSheet could not be found on HTMLStyleElement.\nHas styled-components' style tag been unmounted or altered by another script?\n"}:{};function b(){for(var e=arguments.length<=0?void 0:arguments[0],t=[],n=1,r=arguments.length;n<r;n+=1)t.push(n<0||arguments.length<=n?void 0:arguments[n]);return t.forEach((function(t){e=e.replace(/%[a-z]/,t)})),e}function _(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];throw true?new Error("An error occurred. See https://git.io/JUIaE#"+e+" for more information."+(n.length>0?" Args: "+n.join(", "):"")):new Error(b.apply(void 0,[E[e]].concat(n)).trim())}var C=function(){function e(e){this.groupSizes=new Uint32Array(512),this.length=512,this.tag=e}var t=e.prototype;return t.indexOfGroup=function(e){for(var t=0,n=0;n<e;n++)t+=this.groupSizes[n];return t},t.insertRules=function(e,t){if(e>=this.groupSizes.length){for(var n=this.groupSizes,r=n.length,o=r;e>=o;)(o<<=1)<0&&_(16,""+e);this.groupSizes=new Uint32Array(o),this.groupSizes.set(n),this.length=o;for(var s=r;s<o;s++)this.groupSizes[s]=0}for(var i=this.indexOfGroup(e+1),a=0,c=t.length;a<c;a++)this.tag.insertRule(i,t[a])&&(this.groupSizes[e]++,i++)},t.clearGroup=function(e){if(e<this.length){var t=this.groupSizes[e],n=this.indexOfGroup(e),r=n+t;this.groupSizes[e]=0;for(var o=n;o<r;o++)this.tag.deleteRule(n)}},t.getGroup=function(e){var t="";if(e>=this.length||0===this.groupSizes[e])return t;for(var n=this.groupSizes[e],r=this.indexOfGroup(e),o=r+n,s=r;s<o;s++)t+=this.tag.getRule(s)+"/*!sc*/\n";return t},e}(),N=new Map,A=new Map,I=1,P=function(e){if(N.has(e))return N.get(e);for(;A.has(I);)I++;var t=I++;return"production"!==("production")&&((0|t)<0||t>1<<30)&&_(16,""+t),N.set(e,t),A.set(t,e),t},x=function(e){return A.get(e)},O=function(e,t){t>=I&&(I=t+1),N.set(e,t),A.set(t,e)},R="style["+v+'][data-styled-version="5.3.11"]',T=new RegExp("^"+v+'\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'),j=function(e,t,n){for(var r,o=n.split(","),s=0,i=o.length;s<i;s++)(r=o[s])&&e.registerName(t,r)},D=function(e,t){for(var n=(t.textContent||"").split("/*!sc*/\n"),r=[],o=0,s=n.length;o<s;o++){var i=n[o].trim();if(i){var a=i.match(T);if(a){var c=0|parseInt(a[1],10),u=a[2];0!==c&&(O(u,c),j(e,u,a[3]),e.getTag().insertRules(c,r)),r.length=0}else r.push(i)}}},k=function(){return"undefined"!=typeof __webpack_nonce__?__webpack_nonce__:null},V=function(e){var t=document.head,n=e||t,r=document.createElement("style"),o=function(e){for(var t=e.childNodes,n=t.length;n>=0;n--){var r=t[n];if(r&&1===r.nodeType&&r.hasAttribute(v))return r}}(n),s=void 0!==o?o.nextSibling:null;r.setAttribute(v,"active"),r.setAttribute("data-styled-version","5.3.11");var i=k();return i&&r.setAttribute("nonce",i),n.insertBefore(r,s),r},M=function(){function e(e){var t=this.element=V(e);t.appendChild(document.createTextNode("")),this.sheet=function(e){if(e.sheet)return e.sheet;for(var t=document.styleSheets,n=0,r=t.length;n<r;n++){var o=t[n];if(o.ownerNode===e)return o}_(17)}(t),this.length=0}var t=e.prototype;return t.insertRule=function(e,t){try{return this.sheet.insertRule(t,e),this.length++,!0}catch(e){return!1}},t.deleteRule=function(e){this.sheet.deleteRule(e),this.length--},t.getRule=function(e){var t=this.sheet.cssRules[e];return void 0!==t&&"string"==typeof t.cssText?t.cssText:""},e}(),B=function(){function e(e){var t=this.element=V(e);this.nodes=t.childNodes,this.length=0}var t=e.prototype;return t.insertRule=function(e,t){if(e<=this.length&&e>=0){var n=document.createTextNode(t),r=this.nodes[e];return this.element.insertBefore(n,r||null),this.length++,!0}return!1},t.deleteRule=function(e){this.element.removeChild(this.nodes[e]),this.length--},t.getRule=function(e){return e<this.length?this.nodes[e].textContent:""},e}(),z=function(){function e(e){this.rules=[],this.length=0}var t=e.prototype;return t.insertRule=function(e,t){return e<=this.length&&(this.rules.splice(e,0,t),this.length++,!0)},t.deleteRule=function(e){this.rules.splice(e,1),this.length--},t.getRule=function(e){return e<this.length?this.rules[e]:""},e}(),q=g,G={isServer:!g,useCSSOMInjection:!S},L=function(){function e(e,t,n){void 0===e&&(e=p),void 0===t&&(t={}),this.options=u({},G,{},e),this.gs=t,this.names=new Map(n),this.server=!!e.isServer,!this.server&&g&&q&&(q=!1,function(e){for(var t=document.querySelectorAll(R),n=0,r=t.length;n<r;n++){var o=t[n];o&&"active"!==o.getAttribute(v)&&(D(e,o),o.parentNode&&o.parentNode.removeChild(o))}}(this))}e.registerId=function(e){return P(e)};var t=e.prototype;return t.reconstructWithOptions=function(t,n){return void 0===n&&(n=!0),new e(u({},this.options,{},t),this.gs,n&&this.names||void 0)},t.allocateGSInstance=function(e){return this.gs[e]=(this.gs[e]||0)+1},t.getTag=function(){return this.tag||(this.tag=(n=(t=this.options).isServer,r=t.useCSSOMInjection,o=t.target,e=n?new z(o):r?new M(o):new B(o),new C(e)));var e,t,n,r,o},t.hasNameForId=function(e,t){return this.names.has(e)&&this.names.get(e).has(t)},t.registerName=function(e,t){if(P(e),this.names.has(e))this.names.get(e).add(t);else{var n=new Set;n.add(t),this.names.set(e,n)}},t.insertRules=function(e,t,n){this.registerName(e,t),this.getTag().insertRules(P(e),n)},t.clearNames=function(e){this.names.has(e)&&this.names.get(e).clear()},t.clearRules=function(e){this.getTag().clearGroup(P(e)),this.clearNames(e)},t.clearTag=function(){this.tag=void 0},t.toString=function(){return function(e){for(var t=e.getTag(),n=t.length,r="",o=0;o<n;o++){var s=x(o);if(void 0!==s){var i=e.names.get(s),a=t.getGroup(o);if(i&&a&&i.size){var c=v+".g"+o+'[id="'+s+'"]',u="";void 0!==i&&i.forEach((function(e){e.length>0&&(u+=e+",")})),r+=""+a+c+'{content:"'+u+'"}/*!sc*/\n'}}}return r}(this)},e}(),F=/(a)(d)/gi,Y=function(e){return String.fromCharCode(e+(e>25?39:97))};function H(e){var t,n="";for(t=Math.abs(e);t>52;t=t/52|0)n=Y(t%52)+n;return(Y(t%52)+n).replace(F,"$1-$2")}var $=function(e,t){for(var n=t.length;n;)e=33*e^t.charCodeAt(--n);return e},W=function(e){return $(5381,e)};function U(e){for(var t=0;t<e.length;t+=1){var n=e[t];if(f(n)&&!y(n))return!1}return!0}var J=W("5.3.11"),X=function(){function e(e,t,n){this.rules=e,this.staticRulesId="",this.isStatic="production"===("production")&&(void 0===n||n.isStatic)&&U(e),this.componentId=t,this.baseHash=$(J,t),this.baseStyle=n,L.registerId(t)}return e.prototype.generateAndInjectStyles=function(e,t,n){var r=this.componentId,o=[];if(this.baseStyle&&o.push(this.baseStyle.generateAndInjectStyles(e,t,n)),this.isStatic&&!n.hash)if(this.staticRulesId&&t.hasNameForId(r,this.staticRulesId))o.push(this.staticRulesId);else{var s=me(this.rules,e,t,n).join(""),i=H($(this.baseHash,s)>>>0);if(!t.hasNameForId(r,i)){var a=n(s,"."+i,void 0,r);t.insertRules(r,i,a)}o.push(i),this.staticRulesId=i}else{for(var c=this.rules.length,u=$(this.baseHash,n.hash),l="",d=0;d<c;d++){var h=this.rules[d];if("string"==typeof h)l+=h,"production"!==("production")&&(u=$(u,h+d));else if(h){var p=me(h,e,t,n),f=Array.isArray(p)?p.join(""):p;u=$(u,f+d),l+=f}}if(l){var m=H(u>>>0);if(!t.hasNameForId(r,m)){var y=n(l,"."+m,void 0,r);t.insertRules(r,m,y)}o.push(m)}}return o.join(" ")},e}(),Z=/^\s*\/\/.*$/gm,K=[":","[",".","#"];function Q(e){var t,n,r,o,i=void 0===e?p:e,a=i.options,c=void 0===a?p:a,u=i.plugins,l=void 0===u?h:u,d=new s(c),f=[],m=function(e){function t(t){if(t)try{e(t+"}")}catch(e){}}return function(n,r,o,s,i,a,c,u,l,d){switch(n){case 1:if(0===l&&64===r.charCodeAt(0))return e(r+";"),"";break;case 2:if(0===u)return r+"/*|*/";break;case 3:switch(u){case 102:case 112:return e(o[0]+r),"";default:return r+(0===d?"/*|*/":"")}case-2:r.split("/*|*/}").forEach(t)}}}((function(e){f.push(e)})),y=function(e,r,s){return 0===r&&-1!==K.indexOf(s[n.length])||s.match(o)?e:"."+t};function v(e,s,i,a){void 0===a&&(a="&");var c=e.replace(Z,""),u=s&&i?i+" "+s+" { "+c+" }":c;return t=a,n=s,r=new RegExp("\\"+n+"\\b","g"),o=new RegExp("(\\"+n+"\\b){2,}"),d(i||!s?"":s,u)}return d.use([].concat(l,[function(e,t,o){2===e&&o.length&&o[0].lastIndexOf(n)>0&&(o[0]=o[0].replace(r,y))},m,function(e){if(-2===e){var t=f;return f=[],t}}])),v.hash=l.length?l.reduce((function(e,t){return t.name||_(15),$(e,t.name)}),5381).toString():"",v}var ee=r.createContext(),te=ee.Consumer,ne=r.createContext(),re=(ne.Consumer,new L),oe=Q();function se(){return n.useContext(ee)||re}function ie(){return n.useContext(ne)||oe}function ae(e){var t=n.useState(e.stylisPlugins),s=t[0],i=t[1],a=se(),c=n.useMemo((function(){var t=a;return e.sheet?t=e.sheet:e.target&&(t=t.reconstructWithOptions({target:e.target},!1)),e.disableCSSOMInjection&&(t=t.reconstructWithOptions({useCSSOMInjection:!1})),t}),[e.disableCSSOMInjection,e.sheet,e.target]),u=n.useMemo((function(){return Q({options:{prefix:!e.disableVendorPrefixes},plugins:s})}),[e.disableVendorPrefixes,s]);return n.useEffect((function(){o(s,e.stylisPlugins)||i(e.stylisPlugins)}),[e.stylisPlugins]),r.createElement(ee.Provider,{value:c},r.createElement(ne.Provider,{value:u}, false?r.Children.only(e.children):e.children))}var ce=function(){function e(e,t){var n=this;this.inject=function(e,t){void 0===t&&(t=oe);var r=n.name+t.hash;e.hasNameForId(n.id,r)||e.insertRules(n.id,r,t(n.rules,r,"@keyframes"))},this.toString=function(){return _(12,String(n.name))},this.name=e,this.id="sc-keyframes-"+e,this.rules=t}return e.prototype.getName=function(e){return void 0===e&&(e=oe),this.name+e.hash},e}(),ue=/([A-Z])/,le=/([A-Z])/g,de=/^ms-/,he=function(e){return"-"+e.toLowerCase()};function pe(e){return ue.test(e)?e.replace(le,he).replace(de,"-ms-"):e}var fe=function(e){return null==e||!1===e||""===e};function me(e,n,r,o){if(Array.isArray(e)){for(var s,a=[],c=0,u=e.length;c<u;c+=1)""!==(s=me(e[c],n,r,o))&&(Array.isArray(s)?a.push.apply(a,s):a.push(s));return a}if(fe(e))return"";if(y(e))return"."+e.styledComponentId;if(f(e)){if("function"!=typeof(h=e)||h.prototype&&h.prototype.isReactComponent||!n)return e;var l=e(n);return"production"!==("production")&&t.isElement(l)&&console.warn(m(e)+" is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details."),me(l,n,r,o)}var h;return e instanceof ce?r?(e.inject(r,o),e.getName(o)):e:d(e)?function e(t,n){var r,o,s=[];for(var a in t)t.hasOwnProperty(a)&&!fe(t[a])&&(Array.isArray(t[a])&&t[a].isCss||f(t[a])?s.push(pe(a)+":",t[a],";"):d(t[a])?s.push.apply(s,e(t[a],a)):s.push(pe(a)+": "+(r=a,null==(o=t[a])||"boolean"==typeof o||""===o?"":"number"!=typeof o||0===o||r in i||r.startsWith("--")?String(o).trim():o+"px")+";"));return n?[n+" {"].concat(s,["}"]):s}(e):e.toString()}var ye=function(e){return Array.isArray(e)&&(e.isCss=!0),e};function ve(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];return f(e)||d(e)?ye(me(l(h,[e].concat(n)))):0===n.length&&1===e.length&&"string"==typeof e[0]?e:ye(me(l(e,n)))}var ge=/invalid hook call/i,Se=new Set,we=function(e,t){if(false){var r="The component "+e+(t?' with the id of "'+t+'"':"")+" has been created dynamically.\nYou may see this warning because you've called styled inside another component.\nTo resolve this only create new StyledComponents outside of any render method and function component.",o=console.error;try{var s=!0;console.error=function(e){if(ge.test(e))s=!1,Se.delete(r);else{for(var t=arguments.length,n=new Array(t>1?t-1:0),i=1;i<t;i++)n[i-1]=arguments[i];o.apply(void 0,[e].concat(n))}},n.useRef(),s&&!Se.has(r)&&(console.warn(r),Se.add(r))}catch(e){ge.test(e.message)&&Se.delete(r)}finally{console.error=o}}},Ee=function(e,t,n){return void 0===n&&(n=p),e.theme!==n.theme&&e.theme||t||n.theme},be=/[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g,_e=/(^-|-$)/g;function Ce(e){return e.replace(be,"-").replace(_e,"")}var Ne=function(e){return H(W(e)>>>0)};function Ae(e){return"string"==typeof e&&("production"===("production")||e.charAt(0)===e.charAt(0).toLowerCase())}var Ie=function(e){return"function"==typeof e||"object"==typeof e&&null!==e&&!Array.isArray(e)},Pe=function(e){return"__proto__"!==e&&"constructor"!==e&&"prototype"!==e};function xe(e,t,n){var r=e[n];Ie(t)&&Ie(r)?Oe(r,t):e[n]=t}function Oe(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];for(var o=0,s=n;o<s.length;o++){var i=s[o];if(Ie(i))for(var a in i)Pe(a)&&xe(e,i[a],a)}return e}var Re=r.createContext(),Te=Re.Consumer,je={};function De(e,t,o){var s=y(e),i=!Ae(e),l=t.attrs,d=void 0===l?h:l,v=t.componentId,g=void 0===v?function(e,t){var n="string"!=typeof e?"sc":Ce(e);je[n]=(je[n]||0)+1;var r=n+"-"+Ne("5.3.11"+n+je[n]);return t?t+"-"+r:r}(t.displayName,t.parentComponentId):v,S=t.displayName,w=void 0===S?function(e){return Ae(e)?"styled."+e:"Styled("+m(e)+")"}(e):S,E=t.displayName&&t.componentId?Ce(t.displayName)+"-"+t.componentId:t.componentId||g,b=s&&e.attrs?Array.prototype.concat(e.attrs,d).filter(Boolean):d,_=t.shouldForwardProp;s&&e.shouldForwardProp&&(_=t.shouldForwardProp?function(n,r,o){return e.shouldForwardProp(n,r,o)&&t.shouldForwardProp(n,r,o)}:e.shouldForwardProp);var C,N=new X(o,E,s?e.componentStyle:void 0),A=N.isStatic&&0===d.length,I=function(e,t){return function(e,t,r,o){var s=e.attrs,i=e.componentStyle,c=e.defaultProps,l=e.foldedComponentIds,d=e.shouldForwardProp,h=e.styledComponentId,m=e.target,y=function(e,t,n){void 0===e&&(e=p);var r=u({},t,{theme:e}),o={};return n.forEach((function(e){var t,n,s,i=e;for(t in f(i)&&(i=i(r)),i)r[t]=o[t]="className"===t?(n=o[t],s=i[t],n&&s?n+" "+s:n||s):i[t]})),[r,o]}(Ee(t,n.useContext(Re),c)||p,t,s),v=y[0],g=y[1],S=function(e,t,n,r){var o=se(),s=ie(),i=t?e.generateAndInjectStyles(p,o,s):e.generateAndInjectStyles(n,o,s);return"production"!==("production")&&!t&&r&&r(i),i}(i,o,v, false?e.warnTooManyClasses:void 0),w=r,E=g.$as||t.$as||g.as||t.as||m,b=Ae(E),_=g!==t?u({},t,{},g):t,C={};for(var N in _)"$"!==N[0]&&"as"!==N&&("forwardedAs"===N?C.as=_[N]:(d?d(N,a,E):!b||a(N))&&(C[N]=_[N]));return t.style&&g.style!==t.style&&(C.style=u({},t.style,{},g.style)),C.className=Array.prototype.concat(l,h,S!==h?S:null,t.className,g.className).filter(Boolean).join(" "),C.ref=w,n.createElement(E,C)}(C,e,t,A)};return I.displayName=w,(C=r.forwardRef(I)).attrs=b,C.componentStyle=N,C.displayName=w,C.shouldForwardProp=_,C.foldedComponentIds=s?Array.prototype.concat(e.foldedComponentIds,e.styledComponentId):h,C.styledComponentId=E,C.target=s?e.target:e,C.withComponent=function(e){var n=t.componentId,r=function(e,t){if(null==e)return{};var n,r,o={},s=Object.keys(e);for(r=0;r<s.length;r++)n=s[r],t.indexOf(n)>=0||(o[n]=e[n]);return o}(t,["componentId"]),s=n&&n+"-"+(Ae(e)?e:Ce(m(e)));return De(e,u({},r,{attrs:b,componentId:s}),o)},Object.defineProperty(C,"defaultProps",{get:function(){return this._foldedDefaultProps},set:function(t){this._foldedDefaultProps=s?Oe({},e.defaultProps,t):t}}),"production"!==("production")&&(we(w,E),C.warnTooManyClasses=function(e,t){var n={},r=!1;return function(o){if(!r&&(n[o]=!0,Object.keys(n).length>=200)){var s=t?' with the id of "'+t+'"':"";console.warn("Over 200 classes were generated for component "+e+s+".\nConsider using the attrs method, together with a style object for frequently changed styles.\nExample:\n  const Component = styled.div.attrs(props => ({\n    style: {\n      background: props.background,\n    },\n  }))`width: 100%;`\n\n  <Component />"),r=!0,n={}}}}(w,E)),Object.defineProperty(C,"toString",{value:function(){return"."+C.styledComponentId}}),i&&c(C,e,{attrs:!0,componentStyle:!0,displayName:!0,foldedComponentIds:!0,shouldForwardProp:!0,styledComponentId:!0,target:!0,withComponent:!0}),C}var ke=function(e){return function e(n,r,o){if(void 0===o&&(o=p),!t.isValidElementType(r))return _(1,String(r));var s=function(){return n(r,o,ve.apply(void 0,arguments))};return s.withConfig=function(t){return e(n,r,u({},o,{},t))},s.attrs=function(t){return e(n,r,u({},o,{attrs:Array.prototype.concat(o.attrs,t).filter(Boolean)}))},s}(De,e)};["a","abbr","address","area","article","aside","audio","b","base","bdi","bdo","big","blockquote","body","br","button","canvas","caption","cite","code","col","colgroup","data","datalist","dd","del","details","dfn","dialog","div","dl","dt","em","embed","fieldset","figcaption","figure","footer","form","h1","h2","h3","h4","h5","h6","head","header","hgroup","hr","html","i","iframe","img","input","ins","kbd","keygen","label","legend","li","link","main","map","mark","marquee","menu","menuitem","meta","meter","nav","noscript","object","ol","optgroup","option","output","p","param","picture","pre","progress","q","rp","rt","ruby","s","samp","script","section","select","small","source","span","strong","style","sub","summary","sup","table","tbody","td","textarea","tfoot","th","thead","time","title","tr","track","u","ul","var","video","wbr","circle","clipPath","defs","ellipse","foreignObject","g","image","line","linearGradient","marker","mask","path","pattern","polygon","polyline","radialGradient","rect","stop","svg","text","textPath","tspan"].forEach((function(e){ke[e]=ke(e)}));var Ve=function(){function e(e,t){this.rules=e,this.componentId=t,this.isStatic=U(e),L.registerId(this.componentId+1)}var t=e.prototype;return t.createStyles=function(e,t,n,r){var o=r(me(this.rules,t,n,r).join(""),""),s=this.componentId+e;n.insertRules(s,s,o)},t.removeStyles=function(e,t){t.clearRules(this.componentId+e)},t.renderStyles=function(e,t,n,r){e>2&&L.registerId(this.componentId+e),this.removeStyles(e,n),this.createStyles(e,t,n,r)},e}(),Me=function(){function e(){var e=this;this._emitSheetCSS=function(){var t=e.instance.toString();if(!t)return"";var n=k();return"<style "+[n&&'nonce="'+n+'"',v+'="true"','data-styled-version="5.3.11"'].filter(Boolean).join(" ")+">"+t+"</style>"},this.getStyleTags=function(){return e.sealed?_(2):e._emitSheetCSS()},this.getStyleElement=function(){var t;if(e.sealed)return _(2);var n=((t={})[v]="",t["data-styled-version"]="5.3.11",t.dangerouslySetInnerHTML={__html:e.instance.toString()},t),o=k();return o&&(n.nonce=o),[r.createElement("style",u({},n,{key:"sc-0-0"}))]},this.seal=function(){e.sealed=!0},this.instance=new L({isServer:!0}),this.sealed=!1}var t=e.prototype;return t.collectStyles=function(e){return this.sealed?_(2):r.createElement(ae,{sheet:this.instance},e)},t.interleaveWithNodeStream=function(e){return _(3)},e}(),Be={StyleSheet:L,masterSheet:re};"production"!==("production")&&"undefined"!=typeof navigator&&"ReactNative"===navigator.product&&console.warn("It looks like you've imported 'styled-components' on React Native.\nPerhaps you're looking to import 'styled-components/native'?\nRead more about this at https://www.styled-components.com/docs/basics#react-native"),"production"!==("production")&&"test"!==("production")&&"undefined"!=typeof window&&(window["__styled-components-init__"]=window["__styled-components-init__"]||0,1===window["__styled-components-init__"]&&console.warn("It looks like there are several instances of 'styled-components' initialized in this application. This may cause dynamic styles to not render properly, errors during the rehydration process, a missing theme prop, and makes your application bigger without good reason.\n\nSee https://s-c.sh/2BAXzed for more info."),window["__styled-components-init__"]+=1),exports.ServerStyleSheet=Me,exports.StyleSheetConsumer=te,exports.StyleSheetContext=ee,exports.StyleSheetManager=ae,exports.ThemeConsumer=Te,exports.ThemeContext=Re,exports.ThemeProvider=function(e){var t=n.useContext(Re),o=n.useMemo((function(){return function(e,t){if(!e)return _(14);if(f(e)){var n=e(t);return true?n:_(7)}return Array.isArray(e)||"object"!=typeof e?_(8):t?u({},t,{},e):e}(e.theme,t)}),[e.theme,t]);return e.children?r.createElement(Re.Provider,{value:o},e.children):null},exports.__PRIVATE__=Be,exports.createGlobalStyle=function(e){for(var t=arguments.length,o=new Array(t>1?t-1:0),s=1;s<t;s++)o[s-1]=arguments[s];var i=ve.apply(void 0,[e].concat(o)),a="sc-global-"+Ne(JSON.stringify(i)),c=new Ve(i,a);function l(e){var t=se(),o=ie(),s=n.useContext(Re),u=n.useRef(t.allocateGSInstance(a)).current;return"production"!==("production")&&r.Children.count(e.children)&&console.warn("The global style component "+a+" was given child JSX. createGlobalStyle does not render children."),"production"!==("production")&&i.some((function(e){return"string"==typeof e&&-1!==e.indexOf("@import")}))&&console.warn("Please do not use @import CSS syntax in createGlobalStyle at this time, as the CSSOM APIs we use in production do not handle it well. Instead, we recommend using a library such as react-helmet to inject a typical <link> meta tag to the stylesheet, or simply embedding it manually in your index.html <head> section for a simpler app."),t.server&&d(u,e,t,s,o),n.useLayoutEffect((function(){if(!t.server)return d(u,e,t,s,o),function(){return c.removeStyles(u,t)}}),[u,e,t,s,o]),null}function d(e,t,n,r,o){if(c.isStatic)c.renderStyles(e,w,n,o);else{var s=u({},t,{theme:Ee(t,r,l.defaultProps)});c.renderStyles(e,s,n,o)}}return"production"!==("production")&&we(a),r.memo(l)},exports.css=ve,exports.default=ke,exports.isStyledComponent=y,exports.keyframes=function(e){"production"!==("production")&&"undefined"!=typeof navigator&&"ReactNative"===navigator.product&&console.warn("`keyframes` cannot be used on ReactNative, only on the web. To do animation in ReactNative please use Animated.");for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];var o=ve.apply(void 0,[e].concat(n)).join(""),s=Ne(o);return new ce(s,o)},exports.useTheme=function(){return n.useContext(Re)},exports.version="5.3.11",exports.withTheme=function(e){var t=r.forwardRef((function(t,o){var s=n.useContext(Re),i=e.defaultProps,a=Ee(t,s,i);return"production"!==("production")&&void 0===a&&console.warn('[withTheme] You are not using a ThemeProvider nor passing a theme prop or a theme in defaultProps in component class "'+m(e)+'"'),r.createElement(e,u({},t,{theme:a,ref:o}))}));return c(t,e),t.displayName="WithTheme("+m(e)+")",t};
	//# sourceMappingURL=styled-components.browser.cjs.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(111)))

/***/ },
/* 1625 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(1626);
	} else {
	  module.exports = require("./emotion-is-prop-valid.cjs.dev.js");
	}


/***/ },
/* 1626 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var memoize = __webpack_require__(1627);
	
	function _interopDefault (e) { return e && e.__esModule ? e : { 'default': e }; }
	
	var memoize__default = /*#__PURE__*/_interopDefault(memoize);
	
	// eslint-disable-next-line no-undef
	var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
	
	var isPropValid = /* #__PURE__ */memoize__default["default"](function (prop) {
	  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
	  /* o */
	  && prop.charCodeAt(1) === 110
	  /* n */
	  && prop.charCodeAt(2) < 91;
	}
	/* Z+1 */
	);
	
	exports["default"] = isPropValid;


/***/ },
/* 1627 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(1628);
	} else {
	  module.exports = require("./emotion-memoize.cjs.dev.js");
	}


/***/ },
/* 1628 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function memoize(fn) {
	  var cache = Object.create(null);
	  return function (arg) {
	    if (cache[arg] === undefined) cache[arg] = fn(arg);
	    return cache[arg];
	  };
	}
	
	exports["default"] = memoize;


/***/ },
/* 1629 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/////////////////////////////////////////////////////////////////////////////////
	/* UAParser.js v0.7.38
	   Copyright © 2012-2021 Faisal Salman <f@faisalman.com>
	   MIT License *//*
	   Detect Browser, Engine, OS, CPU, and Device type/model from User-Agent data.
	   Supports browser & node.js environment. 
	   Demo   : https://faisalman.github.io/ua-parser-js
	   Source : https://github.com/faisalman/ua-parser-js */
	/////////////////////////////////////////////////////////////////////////////////
	
	(function (window, undefined) {
	
	    'use strict';
	
	    //////////////
	    // Constants
	    /////////////
	
	
	    var LIBVERSION  = '0.7.38',
	        EMPTY       = '',
	        UNKNOWN     = '?',
	        FUNC_TYPE   = 'function',
	        UNDEF_TYPE  = 'undefined',
	        OBJ_TYPE    = 'object',
	        STR_TYPE    = 'string',
	        MAJOR       = 'major',
	        MODEL       = 'model',
	        NAME        = 'name',
	        TYPE        = 'type',
	        VENDOR      = 'vendor',
	        VERSION     = 'version',
	        ARCHITECTURE= 'architecture',
	        CONSOLE     = 'console',
	        MOBILE      = 'mobile',
	        TABLET      = 'tablet',
	        SMARTTV     = 'smarttv',
	        WEARABLE    = 'wearable',
	        EMBEDDED    = 'embedded',
	        UA_MAX_LENGTH = 500;
	
	    var AMAZON  = 'Amazon',
	        APPLE   = 'Apple',
	        ASUS    = 'ASUS',
	        BLACKBERRY = 'BlackBerry',
	        BROWSER = 'Browser',
	        CHROME  = 'Chrome',
	        EDGE    = 'Edge',
	        FIREFOX = 'Firefox',
	        GOOGLE  = 'Google',
	        HUAWEI  = 'Huawei',
	        LG      = 'LG',
	        MICROSOFT = 'Microsoft',
	        MOTOROLA  = 'Motorola',
	        OPERA   = 'Opera',
	        SAMSUNG = 'Samsung',
	        SHARP   = 'Sharp',
	        SONY    = 'Sony',
	        XIAOMI  = 'Xiaomi',
	        ZEBRA   = 'Zebra',
	        FACEBOOK    = 'Facebook',
	        CHROMIUM_OS = 'Chromium OS',
	        MAC_OS  = 'Mac OS';
	
	    ///////////
	    // Helper
	    //////////
	
	    var extend = function (regexes, extensions) {
	            var mergedRegexes = {};
	            for (var i in regexes) {
	                if (extensions[i] && extensions[i].length % 2 === 0) {
	                    mergedRegexes[i] = extensions[i].concat(regexes[i]);
	                } else {
	                    mergedRegexes[i] = regexes[i];
	                }
	            }
	            return mergedRegexes;
	        },
	        enumerize = function (arr) {
	            var enums = {};
	            for (var i=0; i<arr.length; i++) {
	                enums[arr[i].toUpperCase()] = arr[i];
	            }
	            return enums;
	        },
	        has = function (str1, str2) {
	            return typeof str1 === STR_TYPE ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : false;
	        },
	        lowerize = function (str) {
	            return str.toLowerCase();
	        },
	        majorize = function (version) {
	            return typeof(version) === STR_TYPE ? version.replace(/[^\d\.]/g, EMPTY).split('.')[0] : undefined;
	        },
	        trim = function (str, len) {
	            if (typeof(str) === STR_TYPE) {
	                str = str.replace(/^\s\s*/, EMPTY);
	                return typeof(len) === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
	            }
	    };
	
	    ///////////////
	    // Map helper
	    //////////////
	
	    var rgxMapper = function (ua, arrays) {
	
	            var i = 0, j, k, p, q, matches, match;
	
	            // loop through all regexes maps
	            while (i < arrays.length && !matches) {
	
	                var regex = arrays[i],       // even sequence (0,2,4,..)
	                    props = arrays[i + 1];   // odd sequence (1,3,5,..)
	                j = k = 0;
	
	                // try matching uastring with regexes
	                while (j < regex.length && !matches) {
	
	                    if (!regex[j]) { break; }
	                    matches = regex[j++].exec(ua);
	
	                    if (!!matches) {
	                        for (p = 0; p < props.length; p++) {
	                            match = matches[++k];
	                            q = props[p];
	                            // check if given property is actually array
	                            if (typeof q === OBJ_TYPE && q.length > 0) {
	                                if (q.length === 2) {
	                                    if (typeof q[1] == FUNC_TYPE) {
	                                        // assign modified match
	                                        this[q[0]] = q[1].call(this, match);
	                                    } else {
	                                        // assign given value, ignore regex match
	                                        this[q[0]] = q[1];
	                                    }
	                                } else if (q.length === 3) {
	                                    // check whether function or regex
	                                    if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) {
	                                        // call function (usually string mapper)
	                                        this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
	                                    } else {
	                                        // sanitize match using given regex
	                                        this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
	                                    }
	                                } else if (q.length === 4) {
	                                        this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
	                                }
	                            } else {
	                                this[q] = match ? match : undefined;
	                            }
	                        }
	                    }
	                }
	                i += 2;
	            }
	        },
	
	        strMapper = function (str, map) {
	
	            for (var i in map) {
	                // check if current value is array
	                if (typeof map[i] === OBJ_TYPE && map[i].length > 0) {
	                    for (var j = 0; j < map[i].length; j++) {
	                        if (has(map[i][j], str)) {
	                            return (i === UNKNOWN) ? undefined : i;
	                        }
	                    }
	                } else if (has(map[i], str)) {
	                    return (i === UNKNOWN) ? undefined : i;
	                }
	            }
	            return str;
	    };
	
	    ///////////////
	    // String map
	    //////////////
	
	    // Safari < 3.0
	    var oldSafariMap = {
	            '1.0'   : '/8',
	            '1.2'   : '/1',
	            '1.3'   : '/3',
	            '2.0'   : '/412',
	            '2.0.2' : '/416',
	            '2.0.3' : '/417',
	            '2.0.4' : '/419',
	            '?'     : '/'
	        },
	        windowsVersionMap = {
	            'ME'        : '4.90',
	            'NT 3.11'   : 'NT3.51',
	            'NT 4.0'    : 'NT4.0',
	            '2000'      : 'NT 5.0',
	            'XP'        : ['NT 5.1', 'NT 5.2'],
	            'Vista'     : 'NT 6.0',
	            '7'         : 'NT 6.1',
	            '8'         : 'NT 6.2',
	            '8.1'       : 'NT 6.3',
	            '10'        : ['NT 6.4', 'NT 10.0'],
	            'RT'        : 'ARM'
	    };
	
	    //////////////
	    // Regex map
	    /////////////
	
	    var regexes = {
	
	        browser : [[
	
	            /\b(?:crmo|crios)\/([\w\.]+)/i                                      // Chrome for Android/iOS
	            ], [VERSION, [NAME, 'Chrome']], [
	            /edg(?:e|ios|a)?\/([\w\.]+)/i                                       // Microsoft Edge
	            ], [VERSION, [NAME, 'Edge']], [
	
	            // Presto based
	            /(opera mini)\/([-\w\.]+)/i,                                        // Opera Mini
	            /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,                 // Opera Mobi/Tablet
	            /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i                           // Opera
	            ], [NAME, VERSION], [
	            /opios[\/ ]+([\w\.]+)/i                                             // Opera mini on iphone >= 8.0
	            ], [VERSION, [NAME, OPERA+' Mini']], [
	            /\bop(?:rg)?x\/([\w\.]+)/i                                          // Opera GX
	            ], [VERSION, [NAME, OPERA+' GX']], [
	            /\bopr\/([\w\.]+)/i                                                 // Opera Webkit
	            ], [VERSION, [NAME, OPERA]], [
	
	            // Mixed
	            /\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i            // Baidu
	            ], [VERSION, [NAME, 'Baidu']], [
	            /(kindle)\/([\w\.]+)/i,                                             // Kindle
	            /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,      // Lunascape/Maxthon/Netfront/Jasmine/Blazer
	            // Trident based
	            /(avant|iemobile|slim)\s?(?:browser)?[\/ ]?([\w\.]*)/i,             // Avant/IEMobile/SlimBrowser
	            /(?:ms|\()(ie) ([\w\.]+)/i,                                         // Internet Explorer
	
	            // Webkit/KHTML based                                               // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
	            /(flock|rockmelt|midori|epiphany|silk|skyfire|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i,
	                                                                                // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ, aka ShouQ
	            /(heytap|ovi)browser\/([\d\.]+)/i,                                  // Heytap/Ovi
	            /(weibo)__([\d\.]+)/i                                               // Weibo
	            ], [NAME, VERSION], [
	            /\bddg\/([\w\.]+)/i                                                 // DuckDuckGo
	            ], [VERSION, [NAME, 'DuckDuckGo']], [
	            /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i                 // UCBrowser
	            ], [VERSION, [NAME, 'UC'+BROWSER]], [
	            /microm.+\bqbcore\/([\w\.]+)/i,                                     // WeChat Desktop for Windows Built-in Browser
	            /\bqbcore\/([\w\.]+).+microm/i,
	            /micromessenger\/([\w\.]+)/i                                        // WeChat
	            ], [VERSION, [NAME, 'WeChat']], [
	            /konqueror\/([\w\.]+)/i                                             // Konqueror
	            ], [VERSION, [NAME, 'Konqueror']], [
	            /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i                       // IE11
	            ], [VERSION, [NAME, 'IE']], [
	            /ya(?:search)?browser\/([\w\.]+)/i                                  // Yandex
	            ], [VERSION, [NAME, 'Yandex']], [
	            /slbrowser\/([\w\.]+)/i                                             // Smart Lenovo Browser
	            ], [VERSION, [NAME, 'Smart Lenovo '+BROWSER]], [
	            /(avast|avg)\/([\w\.]+)/i                                           // Avast/AVG Secure Browser
	            ], [[NAME, /(.+)/, '$1 Secure '+BROWSER], VERSION], [
	            /\bfocus\/([\w\.]+)/i                                               // Firefox Focus
	            ], [VERSION, [NAME, FIREFOX+' Focus']], [
	            /\bopt\/([\w\.]+)/i                                                 // Opera Touch
	            ], [VERSION, [NAME, OPERA+' Touch']], [
	            /coc_coc\w+\/([\w\.]+)/i                                            // Coc Coc Browser
	            ], [VERSION, [NAME, 'Coc Coc']], [
	            /dolfin\/([\w\.]+)/i                                                // Dolphin
	            ], [VERSION, [NAME, 'Dolphin']], [
	            /coast\/([\w\.]+)/i                                                 // Opera Coast
	            ], [VERSION, [NAME, OPERA+' Coast']], [
	            /miuibrowser\/([\w\.]+)/i                                           // MIUI Browser
	            ], [VERSION, [NAME, 'MIUI '+BROWSER]], [
	            /fxios\/([-\w\.]+)/i                                                // Firefox for iOS
	            ], [VERSION, [NAME, FIREFOX]], [
	            /\bqihu|(qi?ho?o?|360)browser/i                                     // 360
	            ], [[NAME, '360 ' + BROWSER]], [
	            /(oculus|sailfish|huawei|vivo)browser\/([\w\.]+)/i
	            ], [[NAME, /(.+)/, '$1 ' + BROWSER], VERSION], [                    // Oculus/Sailfish/HuaweiBrowser/VivoBrowser
	            /samsungbrowser\/([\w\.]+)/i                                        // Samsung Internet
	            ], [VERSION, [NAME, SAMSUNG + ' Internet']], [
	            /(comodo_dragon)\/([\w\.]+)/i                                       // Comodo Dragon
	            ], [[NAME, /_/g, ' '], VERSION], [
	            /metasr[\/ ]?([\d\.]+)/i                                            // Sogou Explorer
	            ], [VERSION, [NAME, 'Sogou Explorer']], [
	            /(sogou)mo\w+\/([\d\.]+)/i                                          // Sogou Mobile
	            ], [[NAME, 'Sogou Mobile'], VERSION], [
	            /(electron)\/([\w\.]+) safari/i,                                    // Electron-based App
	            /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,                   // Tesla
	            /m?(qqbrowser|2345Explorer)[\/ ]?([\w\.]+)/i                        // QQBrowser/2345 Browser
	            ], [NAME, VERSION], [
	            /(lbbrowser)/i,                                                     // LieBao Browser
	            /\[(linkedin)app\]/i                                                // LinkedIn App for iOS & Android
	            ], [NAME], [
	
	            // WebView
	            /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i       // Facebook App for iOS & Android
	            ], [[NAME, FACEBOOK], VERSION], [
	            /(Klarna)\/([\w\.]+)/i,                                             // Klarna Shopping Browser for iOS & Android
	            /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,                             // Kakao App
	            /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,                                  // Naver InApp
	            /safari (line)\/([\w\.]+)/i,                                        // Line App for iOS
	            /\b(line)\/([\w\.]+)\/iab/i,                                        // Line App for Android
	            /(alipay)client\/([\w\.]+)/i,                                       // Alipay
	            /(twitter)(?:and| f.+e\/([\w\.]+))/i,                               // Twitter
	            /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i                     // Chromium/Instagram/Snapchat
	            ], [NAME, VERSION], [
	            /\bgsa\/([\w\.]+) .*safari\//i                                      // Google Search Appliance on iOS
	            ], [VERSION, [NAME, 'GSA']], [
	            /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i                        // TikTok
	            ], [VERSION, [NAME, 'TikTok']], [
	
	            /headlesschrome(?:\/([\w\.]+)| )/i                                  // Chrome Headless
	            ], [VERSION, [NAME, CHROME+' Headless']], [
	
	            / wv\).+(chrome)\/([\w\.]+)/i                                       // Chrome WebView
	            ], [[NAME, CHROME+' WebView'], VERSION], [
	
	            /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i           // Android Browser
	            ], [VERSION, [NAME, 'Android '+BROWSER]], [
	
	            /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i       // Chrome/OmniWeb/Arora/Tizen/Nokia
	            ], [NAME, VERSION], [
	
	            /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i                      // Mobile Safari
	            ], [VERSION, [NAME, 'Mobile Safari']], [
	            /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i                // Safari & Safari Mobile
	            ], [VERSION, NAME], [
	            /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i                      // Safari < 3.0
	            ], [NAME, [VERSION, strMapper, oldSafariMap]], [
	
	            /(webkit|khtml)\/([\w\.]+)/i
	            ], [NAME, VERSION], [
	
	            // Gecko based
	            /(navigator|netscape\d?)\/([-\w\.]+)/i                              // Netscape
	            ], [[NAME, 'Netscape'], VERSION], [
	            /mobile vr; rv:([\w\.]+)\).+firefox/i                               // Firefox Reality
	            ], [VERSION, [NAME, FIREFOX+' Reality']], [
	            /ekiohf.+(flow)\/([\w\.]+)/i,                                       // Flow
	            /(swiftfox)/i,                                                      // Swiftfox
	            /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,
	                                                                                // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror/Klar
	            /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
	                                                                                // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
	            /(firefox)\/([\w\.]+)/i,                                            // Other Firefox-based
	            /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,                         // Mozilla
	
	            // Other
	            /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
	                                                                                // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir/Obigo/Mosaic/Go/ICE/UP.Browser
	            /(links) \(([\w\.]+)/i,                                             // Links
	            /panasonic;(viera)/i                                                // Panasonic Viera
	            ], [NAME, VERSION], [
	            
	            /(cobalt)\/([\w\.]+)/i                                              // Cobalt
	            ], [NAME, [VERSION, /master.|lts./, ""]]
	        ],
	
	        cpu : [[
	
	            /(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i                     // AMD64 (x64)
	            ], [[ARCHITECTURE, 'amd64']], [
	
	            /(ia32(?=;))/i                                                      // IA32 (quicktime)
	            ], [[ARCHITECTURE, lowerize]], [
	
	            /((?:i[346]|x)86)[;\)]/i                                            // IA32 (x86)
	            ], [[ARCHITECTURE, 'ia32']], [
	
	            /\b(aarch64|arm(v?8e?l?|_?64))\b/i                                 // ARM64
	            ], [[ARCHITECTURE, 'arm64']], [
	
	            /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i                                   // ARMHF
	            ], [[ARCHITECTURE, 'armhf']], [
	
	            // PocketPC mistakenly identified as PowerPC
	            /windows (ce|mobile); ppc;/i
	            ], [[ARCHITECTURE, 'arm']], [
	
	            /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i                            // PowerPC
	            ], [[ARCHITECTURE, /ower/, EMPTY, lowerize]], [
	
	            /(sun4\w)[;\)]/i                                                    // SPARC
	            ], [[ARCHITECTURE, 'sparc']], [
	
	            /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
	                                                                                // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
	            ], [[ARCHITECTURE, lowerize]]
	        ],
	
	        device : [[
	
	            //////////////////////////
	            // MOBILES & TABLETS
	            /////////////////////////
	
	            // Samsung
	            /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
	            ], [MODEL, [VENDOR, SAMSUNG], [TYPE, TABLET]], [
	            /\b((?:s[cgp]h|gt|sm)-\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
	            /samsung[- ]([-\w]+)/i,
	            /sec-(sgh\w+)/i
	            ], [MODEL, [VENDOR, SAMSUNG], [TYPE, MOBILE]], [
	
	            // Apple
	            /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i                          // iPod/iPhone
	            ], [MODEL, [VENDOR, APPLE], [TYPE, MOBILE]], [
	            /\((ipad);[-\w\),; ]+apple/i,                                       // iPad
	            /applecoremedia\/[\w\.]+ \((ipad)/i,
	            /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
	            ], [MODEL, [VENDOR, APPLE], [TYPE, TABLET]], [
	            /(macintosh);/i
	            ], [MODEL, [VENDOR, APPLE]], [
	
	            // Sharp
	            /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
	            ], [MODEL, [VENDOR, SHARP], [TYPE, MOBILE]], [
	
	            // Huawei
	            /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
	            ], [MODEL, [VENDOR, HUAWEI], [TYPE, TABLET]], [
	            /(?:huawei|honor)([-\w ]+)[;\)]/i,
	            /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
	            ], [MODEL, [VENDOR, HUAWEI], [TYPE, MOBILE]], [
	
	            // Xiaomi
	            /\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,                  // Xiaomi POCO
	            /\b; (\w+) build\/hm\1/i,                                           // Xiaomi Hongmi 'numeric' models
	            /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,                             // Xiaomi Hongmi
	            /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,                   // Xiaomi Redmi
	            /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,        // Xiaomi Redmi 'numeric' models
	            /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i // Xiaomi Mi
	            ], [[MODEL, /_/g, ' '], [VENDOR, XIAOMI], [TYPE, MOBILE]], [
	            /oid[^\)]+; (2\d{4}(283|rpbf)[cgl])( bui|\))/i,                     // Redmi Pad
	            /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i                        // Mi Pad tablets
	            ],[[MODEL, /_/g, ' '], [VENDOR, XIAOMI], [TYPE, TABLET]], [
	
	            // OPPO
	            /; (\w+) bui.+ oppo/i,
	            /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
	            ], [MODEL, [VENDOR, 'OPPO'], [TYPE, MOBILE]], [
	            /\b(opd2\d{3}a?) bui/i
	            ], [MODEL, [VENDOR, 'OPPO'], [TYPE, TABLET]], [
	
	            // Vivo
	            /vivo (\w+)(?: bui|\))/i,
	            /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
	            ], [MODEL, [VENDOR, 'Vivo'], [TYPE, MOBILE]], [
	
	            // Realme
	            /\b(rmx[1-3]\d{3})(?: bui|;|\))/i
	            ], [MODEL, [VENDOR, 'Realme'], [TYPE, MOBILE]], [
	
	            // Motorola
	            /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
	            /\bmot(?:orola)?[- ](\w*)/i,
	            /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
	            ], [MODEL, [VENDOR, MOTOROLA], [TYPE, MOBILE]], [
	            /\b(mz60\d|xoom[2 ]{0,2}) build\//i
	            ], [MODEL, [VENDOR, MOTOROLA], [TYPE, TABLET]], [
	
	            // LG
	            /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
	            ], [MODEL, [VENDOR, LG], [TYPE, TABLET]], [
	            /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
	            /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
	            /\blg-?([\d\w]+) bui/i
	            ], [MODEL, [VENDOR, LG], [TYPE, MOBILE]], [
	
	            // Lenovo
	            /(ideatab[-\w ]+)/i,
	            /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
	            ], [MODEL, [VENDOR, 'Lenovo'], [TYPE, TABLET]], [
	
	            // Nokia
	            /(?:maemo|nokia).*(n900|lumia \d+)/i,
	            /nokia[-_ ]?([-\w\.]*)/i
	            ], [[MODEL, /_/g, ' '], [VENDOR, 'Nokia'], [TYPE, MOBILE]], [
	
	            // Google
	            /(pixel c)\b/i                                                      // Google Pixel C
	            ], [MODEL, [VENDOR, GOOGLE], [TYPE, TABLET]], [
	            /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i                         // Google Pixel
	            ], [MODEL, [VENDOR, GOOGLE], [TYPE, MOBILE]], [
	
	            // Sony
	            /droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
	            ], [MODEL, [VENDOR, SONY], [TYPE, MOBILE]], [
	            /sony tablet [ps]/i,
	            /\b(?:sony)?sgp\w+(?: bui|\))/i
	            ], [[MODEL, 'Xperia Tablet'], [VENDOR, SONY], [TYPE, TABLET]], [
	
	            // OnePlus
	            / (kb2005|in20[12]5|be20[12][59])\b/i,
	            /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
	            ], [MODEL, [VENDOR, 'OnePlus'], [TYPE, MOBILE]], [
	
	            // Amazon
	            /(alexa)webm/i,
	            /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i,                             // Kindle Fire without Silk / Echo Show
	            /(kf[a-z]+)( bui|\)).+silk\//i                                      // Kindle Fire HD
	            ], [MODEL, [VENDOR, AMAZON], [TYPE, TABLET]], [
	            /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i                     // Fire Phone
	            ], [[MODEL, /(.+)/g, 'Fire Phone $1'], [VENDOR, AMAZON], [TYPE, MOBILE]], [
	
	            // BlackBerry
	            /(playbook);[-\w\),; ]+(rim)/i                                      // BlackBerry PlayBook
	            ], [MODEL, VENDOR, [TYPE, TABLET]], [
	            /\b((?:bb[a-f]|st[hv])100-\d)/i,
	            /\(bb10; (\w+)/i                                                    // BlackBerry 10
	            ], [MODEL, [VENDOR, BLACKBERRY], [TYPE, MOBILE]], [
	
	            // Asus
	            /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
	            ], [MODEL, [VENDOR, ASUS], [TYPE, TABLET]], [
	            / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
	            ], [MODEL, [VENDOR, ASUS], [TYPE, MOBILE]], [
	
	            // HTC
	            /(nexus 9)/i                                                        // HTC Nexus 9
	            ], [MODEL, [VENDOR, 'HTC'], [TYPE, TABLET]], [
	            /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,                         // HTC
	
	            // ZTE
	            /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
	            /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i         // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
	            ], [VENDOR, [MODEL, /_/g, ' '], [TYPE, MOBILE]], [
	
	            // Acer
	            /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
	            ], [MODEL, [VENDOR, 'Acer'], [TYPE, TABLET]], [
	
	            // Meizu
	            /droid.+; (m[1-5] note) bui/i,
	            /\bmz-([-\w]{2,})/i
	            ], [MODEL, [VENDOR, 'Meizu'], [TYPE, MOBILE]], [
	                
	            // Ulefone
	            /; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i
	            ], [MODEL, [VENDOR, 'Ulefone'], [TYPE, MOBILE]], [
	
	            // MIXED
	            /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron|infinix|tecno)[-_ ]?([-\w]*)/i,
	                                                                                // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
	            /(hp) ([\w ]+\w)/i,                                                 // HP iPAQ
	            /(asus)-?(\w+)/i,                                                   // Asus
	            /(microsoft); (lumia[\w ]+)/i,                                      // Microsoft Lumia
	            /(lenovo)[-_ ]?([-\w]+)/i,                                          // Lenovo
	            /(jolla)/i,                                                         // Jolla
	            /(oppo) ?([\w ]+) bui/i                                             // OPPO
	            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
	
	            /(kobo)\s(ereader|touch)/i,                                         // Kobo
	            /(archos) (gamepad2?)/i,                                            // Archos
	            /(hp).+(touchpad(?!.+tablet)|tablet)/i,                             // HP TouchPad
	            /(kindle)\/([\w\.]+)/i,                                             // Kindle
	            /(nook)[\w ]+build\/(\w+)/i,                                        // Nook
	            /(dell) (strea[kpr\d ]*[\dko])/i,                                   // Dell Streak
	            /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,                                  // Le Pan Tablets
	            /(trinity)[- ]*(t\d{3}) bui/i,                                      // Trinity Tablets
	            /(gigaset)[- ]+(q\w{1,9}) bui/i,                                    // Gigaset Tablets
	            /(vodafone) ([\w ]+)(?:\)| bui)/i                                   // Vodafone
	            ], [VENDOR, MODEL, [TYPE, TABLET]], [
	
	            /(surface duo)/i                                                    // Surface Duo
	            ], [MODEL, [VENDOR, MICROSOFT], [TYPE, TABLET]], [
	            /droid [\d\.]+; (fp\du?)(?: b|\))/i                                 // Fairphone
	            ], [MODEL, [VENDOR, 'Fairphone'], [TYPE, MOBILE]], [
	            /(u304aa)/i                                                         // AT&T
	            ], [MODEL, [VENDOR, 'AT&T'], [TYPE, MOBILE]], [
	            /\bsie-(\w*)/i                                                      // Siemens
	            ], [MODEL, [VENDOR, 'Siemens'], [TYPE, MOBILE]], [
	            /\b(rct\w+) b/i                                                     // RCA Tablets
	            ], [MODEL, [VENDOR, 'RCA'], [TYPE, TABLET]], [
	            /\b(venue[\d ]{2,7}) b/i                                            // Dell Venue Tablets
	            ], [MODEL, [VENDOR, 'Dell'], [TYPE, TABLET]], [
	            /\b(q(?:mv|ta)\w+) b/i                                              // Verizon Tablet
	            ], [MODEL, [VENDOR, 'Verizon'], [TYPE, TABLET]], [
	            /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i                       // Barnes & Noble Tablet
	            ], [MODEL, [VENDOR, 'Barnes & Noble'], [TYPE, TABLET]], [
	            /\b(tm\d{3}\w+) b/i
	            ], [MODEL, [VENDOR, 'NuVision'], [TYPE, TABLET]], [
	            /\b(k88) b/i                                                        // ZTE K Series Tablet
	            ], [MODEL, [VENDOR, 'ZTE'], [TYPE, TABLET]], [
	            /\b(nx\d{3}j) b/i                                                   // ZTE Nubia
	            ], [MODEL, [VENDOR, 'ZTE'], [TYPE, MOBILE]], [
	            /\b(gen\d{3}) b.+49h/i                                              // Swiss GEN Mobile
	            ], [MODEL, [VENDOR, 'Swiss'], [TYPE, MOBILE]], [
	            /\b(zur\d{3}) b/i                                                   // Swiss ZUR Tablet
	            ], [MODEL, [VENDOR, 'Swiss'], [TYPE, TABLET]], [
	            /\b((zeki)?tb.*\b) b/i                                              // Zeki Tablets
	            ], [MODEL, [VENDOR, 'Zeki'], [TYPE, TABLET]], [
	            /\b([yr]\d{2}) b/i,
	            /\b(dragon[- ]+touch |dt)(\w{5}) b/i                                // Dragon Touch Tablet
	            ], [[VENDOR, 'Dragon Touch'], MODEL, [TYPE, TABLET]], [
	            /\b(ns-?\w{0,9}) b/i                                                // Insignia Tablets
	            ], [MODEL, [VENDOR, 'Insignia'], [TYPE, TABLET]], [
	            /\b((nxa|next)-?\w{0,9}) b/i                                        // NextBook Tablets
	            ], [MODEL, [VENDOR, 'NextBook'], [TYPE, TABLET]], [
	            /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i                  // Voice Xtreme Phones
	            ], [[VENDOR, 'Voice'], MODEL, [TYPE, MOBILE]], [
	            /\b(lvtel\-)?(v1[12]) b/i                                           // LvTel Phones
	            ], [[VENDOR, 'LvTel'], MODEL, [TYPE, MOBILE]], [
	            /\b(ph-1) /i                                                        // Essential PH-1
	            ], [MODEL, [VENDOR, 'Essential'], [TYPE, MOBILE]], [
	            /\b(v(100md|700na|7011|917g).*\b) b/i                               // Envizen Tablets
	            ], [MODEL, [VENDOR, 'Envizen'], [TYPE, TABLET]], [
	            /\b(trio[-\w\. ]+) b/i                                              // MachSpeed Tablets
	            ], [MODEL, [VENDOR, 'MachSpeed'], [TYPE, TABLET]], [
	            /\btu_(1491) b/i                                                    // Rotor Tablets
	            ], [MODEL, [VENDOR, 'Rotor'], [TYPE, TABLET]], [
	            /(shield[\w ]+) b/i                                                 // Nvidia Shield Tablets
	            ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, TABLET]], [
	            /(sprint) (\w+)/i                                                   // Sprint Phones
	            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
	            /(kin\.[onetw]{3})/i                                                // Microsoft Kin
	            ], [[MODEL, /\./g, ' '], [VENDOR, MICROSOFT], [TYPE, MOBILE]], [
	            /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i             // Zebra
	            ], [MODEL, [VENDOR, ZEBRA], [TYPE, TABLET]], [
	            /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
	            ], [MODEL, [VENDOR, ZEBRA], [TYPE, MOBILE]], [
	
	            ///////////////////
	            // SMARTTVS
	            ///////////////////
	
	            /smart-tv.+(samsung)/i                                              // Samsung
	            ], [VENDOR, [TYPE, SMARTTV]], [
	            /hbbtv.+maple;(\d+)/i
	            ], [[MODEL, /^/, 'SmartTV'], [VENDOR, SAMSUNG], [TYPE, SMARTTV]], [
	            /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i        // LG SmartTV
	            ], [[VENDOR, LG], [TYPE, SMARTTV]], [
	            /(apple) ?tv/i                                                      // Apple TV
	            ], [VENDOR, [MODEL, APPLE+' TV'], [TYPE, SMARTTV]], [
	            /crkey/i                                                            // Google Chromecast
	            ], [[MODEL, CHROME+'cast'], [VENDOR, GOOGLE], [TYPE, SMARTTV]], [
	            /droid.+aft(\w+)( bui|\))/i                                         // Fire TV
	            ], [MODEL, [VENDOR, AMAZON], [TYPE, SMARTTV]], [
	            /\(dtv[\);].+(aquos)/i,
	            /(aquos-tv[\w ]+)\)/i                                               // Sharp
	            ], [MODEL, [VENDOR, SHARP], [TYPE, SMARTTV]],[
	            /(bravia[\w ]+)( bui|\))/i                                              // Sony
	            ], [MODEL, [VENDOR, SONY], [TYPE, SMARTTV]], [
	            /(mitv-\w{5}) bui/i                                                 // Xiaomi
	            ], [MODEL, [VENDOR, XIAOMI], [TYPE, SMARTTV]], [
	            /Hbbtv.*(technisat) (.*);/i                                         // TechniSAT
	            ], [VENDOR, MODEL, [TYPE, SMARTTV]], [
	            /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,                          // Roku
	            /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i         // HbbTV devices
	            ], [[VENDOR, trim], [MODEL, trim], [TYPE, SMARTTV]], [
	            /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i                   // SmartTV from Unidentified Vendors
	            ], [[TYPE, SMARTTV]], [
	
	            ///////////////////
	            // CONSOLES
	            ///////////////////
	
	            /(ouya)/i,                                                          // Ouya
	            /(nintendo) ([wids3utch]+)/i                                        // Nintendo
	            ], [VENDOR, MODEL, [TYPE, CONSOLE]], [
	            /droid.+; (shield) bui/i                                            // Nvidia
	            ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, CONSOLE]], [
	            /(playstation [345portablevi]+)/i                                   // Playstation
	            ], [MODEL, [VENDOR, SONY], [TYPE, CONSOLE]], [
	            /\b(xbox(?: one)?(?!; xbox))[\); ]/i                                // Microsoft Xbox
	            ], [MODEL, [VENDOR, MICROSOFT], [TYPE, CONSOLE]], [
	
	            ///////////////////
	            // WEARABLES
	            ///////////////////
	
	            /((pebble))app/i                                                    // Pebble
	            ], [VENDOR, MODEL, [TYPE, WEARABLE]], [
	            /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i                              // Apple Watch
	            ], [MODEL, [VENDOR, APPLE], [TYPE, WEARABLE]], [
	            /droid.+; (glass) \d/i                                              // Google Glass
	            ], [MODEL, [VENDOR, GOOGLE], [TYPE, WEARABLE]], [
	            /droid.+; (wt63?0{2,3})\)/i
	            ], [MODEL, [VENDOR, ZEBRA], [TYPE, WEARABLE]], [
	            /(quest( \d| pro)?)/i                                               // Oculus Quest
	            ], [MODEL, [VENDOR, FACEBOOK], [TYPE, WEARABLE]], [
	
	            ///////////////////
	            // EMBEDDED
	            ///////////////////
	
	            /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i                              // Tesla
	            ], [VENDOR, [TYPE, EMBEDDED]], [
	            /(aeobc)\b/i                                                        // Echo Dot
	            ], [MODEL, [VENDOR, AMAZON], [TYPE, EMBEDDED]], [
	
	            ////////////////////
	            // MIXED (GENERIC)
	            ///////////////////
	
	            /droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i    // Android Phones from Unidentified Vendors
	            ], [MODEL, [TYPE, MOBILE]], [
	            /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i       // Android Tablets from Unidentified Vendors
	            ], [MODEL, [TYPE, TABLET]], [
	            /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i                      // Unidentifiable Tablet
	            ], [[TYPE, TABLET]], [
	            /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i    // Unidentifiable Mobile
	            ], [[TYPE, MOBILE]], [
	            /(android[-\w\. ]{0,9});.+buil/i                                    // Generic Android Device
	            ], [MODEL, [VENDOR, 'Generic']]
	        ],
	
	        engine : [[
	
	            /windows.+ edge\/([\w\.]+)/i                                       // EdgeHTML
	            ], [VERSION, [NAME, EDGE+'HTML']], [
	
	            /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i                         // Blink
	            ], [VERSION, [NAME, 'Blink']], [
	
	            /(presto)\/([\w\.]+)/i,                                             // Presto
	            /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i, // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m/Goanna
	            /ekioh(flow)\/([\w\.]+)/i,                                          // Flow
	            /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,                           // KHTML/Tasman/Links
	            /(icab)[\/ ]([23]\.[\d\.]+)/i,                                      // iCab
	            /\b(libweb)/i
	            ], [NAME, VERSION], [
	
	            /rv\:([\w\.]{1,9})\b.+(gecko)/i                                     // Gecko
	            ], [VERSION, NAME]
	        ],
	
	        os : [[
	
	            // Windows
	            /microsoft (windows) (vista|xp)/i                                   // Windows (iTunes)
	            ], [NAME, VERSION], [
	            /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i             // Windows Phone
	            ], [NAME, [VERSION, strMapper, windowsVersionMap]], [
	            /windows nt 6\.2; (arm)/i,                                        // Windows RT
	            /windows[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i,
	            /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i
	            ], [[VERSION, strMapper, windowsVersionMap], [NAME, 'Windows']], [
	
	            // iOS/macOS
	            /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,              // iOS
	            /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,
	            /cfnetwork\/.+darwin/i
	            ], [[VERSION, /_/g, '.'], [NAME, 'iOS']], [
	            /(mac os x) ?([\w\. ]*)/i,
	            /(macintosh|mac_powerpc\b)(?!.+haiku)/i                             // Mac OS
	            ], [[NAME, MAC_OS], [VERSION, /_/g, '.']], [
	
	            // Mobile OSes
	            /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i                    // Android-x86/HarmonyOS
	            ], [VERSION, NAME], [                                               // Android/WebOS/QNX/Bada/RIM/Maemo/MeeGo/Sailfish OS
	            /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,
	            /(blackberry)\w*\/([\w\.]*)/i,                                      // Blackberry
	            /(tizen|kaios)[\/ ]([\w\.]+)/i,                                     // Tizen/KaiOS
	            /\((series40);/i                                                    // Series 40
	            ], [NAME, VERSION], [
	            /\(bb(10);/i                                                        // BlackBerry 10
	            ], [VERSION, [NAME, BLACKBERRY]], [
	            /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i         // Symbian
	            ], [VERSION, [NAME, 'Symbian']], [
	            /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i // Firefox OS
	            ], [VERSION, [NAME, FIREFOX+' OS']], [
	            /web0s;.+rt(tv)/i,
	            /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i                              // WebOS
	            ], [VERSION, [NAME, 'webOS']], [
	            /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i                              // watchOS
	            ], [VERSION, [NAME, 'watchOS']], [
	
	            // Google Chromecast
	            /crkey\/([\d\.]+)/i                                                 // Google Chromecast
	            ], [VERSION, [NAME, CHROME+'cast']], [
	            /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i                                  // Chromium OS
	            ], [[NAME, CHROMIUM_OS], VERSION],[
	
	            // Smart TVs
	            /panasonic;(viera)/i,                                               // Panasonic Viera
	            /(netrange)mmh/i,                                                   // Netrange
	            /(nettv)\/(\d+\.[\w\.]+)/i,                                         // NetTV
	
	            // Console
	            /(nintendo|playstation) ([wids345portablevuch]+)/i,                 // Nintendo/Playstation
	            /(xbox); +xbox ([^\);]+)/i,                                         // Microsoft Xbox (360, One, X, S, Series X, Series S)
	
	            // Other
	            /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,                            // Joli/Palm
	            /(mint)[\/\(\) ]?(\w*)/i,                                           // Mint
	            /(mageia|vectorlinux)[; ]/i,                                        // Mageia/VectorLinux
	            /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
	                                                                                // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
	            /(hurd|linux) ?([\w\.]*)/i,                                         // Hurd/Linux
	            /(gnu) ?([\w\.]*)/i,                                                // GNU
	            /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i, // FreeBSD/NetBSD/OpenBSD/PC-BSD/GhostBSD/DragonFly
	            /(haiku) (\w+)/i                                                    // Haiku
	            ], [NAME, VERSION], [
	            /(sunos) ?([\w\.\d]*)/i                                             // Solaris
	            ], [[NAME, 'Solaris'], VERSION], [
	            /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,                              // Solaris
	            /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,                                  // AIX
	            /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i, // BeOS/OS2/AmigaOS/MorphOS/OpenVMS/Fuchsia/HP-UX/SerenityOS
	            /(unix) ?([\w\.]*)/i                                                // UNIX
	            ], [NAME, VERSION]
	        ]
	    };
	
	    /////////////////
	    // Constructor
	    ////////////////
	
	    var UAParser = function (ua, extensions) {
	
	        if (typeof ua === OBJ_TYPE) {
	            extensions = ua;
	            ua = undefined;
	        }
	
	        if (!(this instanceof UAParser)) {
	            return new UAParser(ua, extensions).getResult();
	        }
	
	        var _navigator = (typeof window !== UNDEF_TYPE && window.navigator) ? window.navigator : undefined;
	        var _ua = ua || ((_navigator && _navigator.userAgent) ? _navigator.userAgent : EMPTY);
	        var _uach = (_navigator && _navigator.userAgentData) ? _navigator.userAgentData : undefined;
	        var _rgxmap = extensions ? extend(regexes, extensions) : regexes;
	        var _isSelfNav = _navigator && _navigator.userAgent == _ua;
	
	        this.getBrowser = function () {
	            var _browser = {};
	            _browser[NAME] = undefined;
	            _browser[VERSION] = undefined;
	            rgxMapper.call(_browser, _ua, _rgxmap.browser);
	            _browser[MAJOR] = majorize(_browser[VERSION]);
	            // Brave-specific detection
	            if (_isSelfNav && _navigator && _navigator.brave && typeof _navigator.brave.isBrave == FUNC_TYPE) {
	                _browser[NAME] = 'Brave';
	            }
	            return _browser;
	        };
	        this.getCPU = function () {
	            var _cpu = {};
	            _cpu[ARCHITECTURE] = undefined;
	            rgxMapper.call(_cpu, _ua, _rgxmap.cpu);
	            return _cpu;
	        };
	        this.getDevice = function () {
	            var _device = {};
	            _device[VENDOR] = undefined;
	            _device[MODEL] = undefined;
	            _device[TYPE] = undefined;
	            rgxMapper.call(_device, _ua, _rgxmap.device);
	            if (_isSelfNav && !_device[TYPE] && _uach && _uach.mobile) {
	                _device[TYPE] = MOBILE;
	            }
	            // iPadOS-specific detection: identified as Mac, but has some iOS-only properties
	            if (_isSelfNav && _device[MODEL] == 'Macintosh' && _navigator && typeof _navigator.standalone !== UNDEF_TYPE && _navigator.maxTouchPoints && _navigator.maxTouchPoints > 2) {
	                _device[MODEL] = 'iPad';
	                _device[TYPE] = TABLET;
	            }
	            return _device;
	        };
	        this.getEngine = function () {
	            var _engine = {};
	            _engine[NAME] = undefined;
	            _engine[VERSION] = undefined;
	            rgxMapper.call(_engine, _ua, _rgxmap.engine);
	            return _engine;
	        };
	        this.getOS = function () {
	            var _os = {};
	            _os[NAME] = undefined;
	            _os[VERSION] = undefined;
	            rgxMapper.call(_os, _ua, _rgxmap.os);
	            if (_isSelfNav && !_os[NAME] && _uach && _uach.platform && _uach.platform != 'Unknown') {
	                _os[NAME] = _uach.platform  
	                                    .replace(/chrome os/i, CHROMIUM_OS)
	                                    .replace(/macos/i, MAC_OS);           // backward compatibility
	            }
	            return _os;
	        };
	        this.getResult = function () {
	            return {
	                ua      : this.getUA(),
	                browser : this.getBrowser(),
	                engine  : this.getEngine(),
	                os      : this.getOS(),
	                device  : this.getDevice(),
	                cpu     : this.getCPU()
	            };
	        };
	        this.getUA = function () {
	            return _ua;
	        };
	        this.setUA = function (ua) {
	            _ua = (typeof ua === STR_TYPE && ua.length > UA_MAX_LENGTH) ? trim(ua, UA_MAX_LENGTH) : ua;
	            return this;
	        };
	        this.setUA(_ua);
	        return this;
	    };
	
	    UAParser.VERSION = LIBVERSION;
	    UAParser.BROWSER =  enumerize([NAME, VERSION, MAJOR]);
	    UAParser.CPU = enumerize([ARCHITECTURE]);
	    UAParser.DEVICE = enumerize([MODEL, VENDOR, TYPE, CONSOLE, MOBILE, SMARTTV, TABLET, WEARABLE, EMBEDDED]);
	    UAParser.ENGINE = UAParser.OS = enumerize([NAME, VERSION]);
	
	    ///////////
	    // Export
	    //////////
	
	    // check js environment
	    if (typeof(exports) !== UNDEF_TYPE) {
	        // nodejs env
	        if (typeof module !== UNDEF_TYPE && module.exports) {
	            exports = module.exports = UAParser;
	        }
	        exports.UAParser = UAParser;
	    } else {
	        // requirejs env (optional)
	        if ("function" === FUNC_TYPE && __webpack_require__(1659)) {
	            !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	                return UAParser;
	            }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	        } else if (typeof window !== UNDEF_TYPE) {
	            // browser env
	            window.UAParser = UAParser;
	        }
	    }
	
	    // jQuery/Zepto specific (optional)
	    // Note:
	    //   In AMD env the global scope should be kept clean, but jQuery is an exception.
	    //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
	    //   and we should catch that.
	    var $ = typeof window !== UNDEF_TYPE && (window.jQuery || window.Zepto);
	    if ($ && !$.ua) {
	        var parser = new UAParser();
	        $.ua = parser.getResult();
	        $.ua.get = function () {
	            return parser.getUA();
	        };
	        $.ua.set = function (ua) {
	            parser.setUA(ua);
	            var result = parser.getResult();
	            for (var prop in result) {
	                $.ua[prop] = result[prop];
	            }
	        };
	    }
	
	})(typeof window === 'object' ? window : this);


/***/ },
/* 1630 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var cookie = _interopRequireWildcard(__webpack_require__(372));
	
	var _utils = __webpack_require__(1631);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	var __assign = void 0 && (void 0).__assign || function () {
	  __assign = Object.assign || function (t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	      s = arguments[i];
	
	      for (var p in s) {
	        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	      }
	    }
	
	    return t;
	  };
	
	  return __assign.apply(this, arguments);
	};
	
	var Cookies =
	/** @class */
	function () {
	  function Cookies(cookies, options) {
	    var _this = this;
	
	    this.changeListeners = [];
	    this.HAS_DOCUMENT_COOKIE = false;
	    this.cookies = (0, _utils.parseCookies)(cookies, options);
	    new Promise(function () {
	      _this.HAS_DOCUMENT_COOKIE = (0, _utils.hasDocumentCookie)();
	    })["catch"](function () {});
	  }
	
	  Cookies.prototype._updateBrowserValues = function (parseOptions) {
	    if (!this.HAS_DOCUMENT_COOKIE) {
	      return;
	    }
	
	    this.cookies = cookie.parse(document.cookie, parseOptions);
	  };
	
	  Cookies.prototype._emitChange = function (params) {
	    for (var i = 0; i < this.changeListeners.length; ++i) {
	      this.changeListeners[i](params);
	    }
	  };
	
	  Cookies.prototype.get = function (name, options, parseOptions) {
	    if (options === void 0) {
	      options = {};
	    }
	
	    this._updateBrowserValues(parseOptions);
	
	    return (0, _utils.readCookie)(this.cookies[name], options);
	  };
	
	  Cookies.prototype.getAll = function (options, parseOptions) {
	    if (options === void 0) {
	      options = {};
	    }
	
	    this._updateBrowserValues(parseOptions);
	
	    var result = {};
	
	    for (var name_1 in this.cookies) {
	      result[name_1] = (0, _utils.readCookie)(this.cookies[name_1], options);
	    }
	
	    return result;
	  };
	
	  Cookies.prototype.set = function (name, value, options) {
	    var _a;
	
	    if (_typeof(value) === 'object') {
	      value = JSON.stringify(value);
	    }
	
	    this.cookies = __assign(__assign({}, this.cookies), (_a = {}, _a[name] = value, _a));
	
	    if (this.HAS_DOCUMENT_COOKIE) {
	      document.cookie = cookie.serialize(name, value, options);
	    }
	
	    this._emitChange({
	      name: name,
	      value: value,
	      options: options
	    });
	  };
	
	  Cookies.prototype.remove = function (name, options) {
	    var finalOptions = options = __assign(__assign({}, options), {
	      expires: new Date(1970, 1, 1, 0, 0, 1),
	      maxAge: 0
	    });
	
	    this.cookies = __assign({}, this.cookies);
	    delete this.cookies[name];
	
	    if (this.HAS_DOCUMENT_COOKIE) {
	      document.cookie = cookie.serialize(name, '', finalOptions);
	    }
	
	    this._emitChange({
	      name: name,
	      value: undefined,
	      options: options
	    });
	  };
	
	  Cookies.prototype.addChangeListener = function (callback) {
	    this.changeListeners.push(callback);
	  };
	
	  Cookies.prototype.removeChangeListener = function (callback) {
	    var idx = this.changeListeners.indexOf(callback);
	
	    if (idx >= 0) {
	      this.changeListeners.splice(idx, 1);
	    }
	  };
	
	  return Cookies;
	}();
	
	var _default = Cookies;
	exports["default"] = _default;
	module.exports = exports.default;

/***/ },
/* 1631 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.hasDocumentCookie = hasDocumentCookie;
	exports.cleanCookies = cleanCookies;
	exports.parseCookies = parseCookies;
	exports.isParsingCookie = isParsingCookie;
	exports.readCookie = readCookie;
	
	var cookie = _interopRequireWildcard(__webpack_require__(372));
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function hasDocumentCookie() {
	  // Can we get/set cookies on document.cookie?
	  return (typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && typeof document.cookie === 'string';
	}
	
	function cleanCookies() {
	  document.cookie.split(';').forEach(function (c) {
	    document.cookie = c.replace(/^ +/, '').replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/');
	  });
	}
	
	function parseCookies(cookies, options) {
	  if (typeof cookies === 'string') {
	    return cookie.parse(cookies, options);
	  } else if (_typeof(cookies) === 'object' && cookies !== null) {
	    return cookies;
	  } else {
	    return {};
	  }
	}
	
	function isParsingCookie(value, doNotParse) {
	  if (typeof doNotParse === 'undefined') {
	    // We guess if the cookie start with { or [, it has been serialized
	    doNotParse = !value || value[0] !== '{' && value[0] !== '[' && value[0] !== '"';
	  }
	
	  return !doNotParse;
	}
	
	function readCookie(value, options) {
	  if (options === void 0) {
	    options = {};
	  }
	
	  var cleanValue = cleanupCookieValue(value);
	
	  if (isParsingCookie(cleanValue, options.doNotParse)) {
	    try {
	      return JSON.parse(cleanValue);
	    } catch (e) {// At least we tried
	    }
	  } // Ignore clean value if we failed the deserialization
	  // It is not relevant anymore to trim those values
	
	
	  return value;
	}
	
	function cleanupCookieValue(value) {
	  // express prepend j: before serializing a cookie
	  if (value && value[0] === 'j' && value[1] === ':') {
	    return value.substr(2);
	  }
	
	  return value;
	}

/***/ },
/* 1632 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/bewise-logo-new.125629f8.png";

/***/ },
/* 1633 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 1634 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {
	/**
	 * Module exports.
	 */
	
	module.exports = deprecate;
	
	/**
	 * Mark that a method should not be used.
	 * Returns a modified function which warns once by default.
	 *
	 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
	 *
	 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
	 * will throw an Error when invoked.
	 *
	 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
	 * will invoke `console.trace()` instead of `console.error()`.
	 *
	 * @param {Function} fn - the function to deprecate
	 * @param {String} msg - the string to print to the console when `fn` is invoked
	 * @returns {Function} a new "deprecated" version of `fn`
	 * @api public
	 */
	
	function deprecate (fn, msg) {
	  if (config('noDeprecation')) {
	    return fn;
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (config('throwDeprecation')) {
	        throw new Error(msg);
	      } else if (config('traceDeprecation')) {
	        console.trace(msg);
	      } else {
	        console.warn(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	}
	
	/**
	 * Checks `localStorage` for boolean values for the given `name`.
	 *
	 * @param {String} name
	 * @returns {Boolean}
	 * @api private
	 */
	
	function config (name) {
	  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
	  try {
	    if (!global.localStorage) return false;
	  } catch (_) {
	    return false;
	  }
	  var val = global.localStorage[name];
	  if (null == val) return false;
	  return String(val).toLowerCase() === 'true';
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1635 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "v1", {
	  enumerable: true,
	  get: function () {
	    return _v.default;
	  }
	});
	Object.defineProperty(exports, "v3", {
	  enumerable: true,
	  get: function () {
	    return _v2.default;
	  }
	});
	Object.defineProperty(exports, "v4", {
	  enumerable: true,
	  get: function () {
	    return _v3.default;
	  }
	});
	Object.defineProperty(exports, "v5", {
	  enumerable: true,
	  get: function () {
	    return _v4.default;
	  }
	});
	
	var _v = _interopRequireDefault(__webpack_require__(1638));
	
	var _v2 = _interopRequireDefault(__webpack_require__(1639));
	
	var _v3 = _interopRequireDefault(__webpack_require__(1640));
	
	var _v4 = _interopRequireDefault(__webpack_require__(1641));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1636 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	/*
	 * Browser-compatible JavaScript MD5
	 *
	 * Modification of JavaScript MD5
	 * https://github.com/blueimp/JavaScript-MD5
	 *
	 * Copyright 2011, Sebastian Tschan
	 * https://blueimp.net
	 *
	 * Licensed under the MIT license:
	 * https://opensource.org/licenses/MIT
	 *
	 * Based on
	 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
	 * Digest Algorithm, as defined in RFC 1321.
	 * Version 2.2 Copyright (C) Paul Johnston 1999 - 2009
	 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
	 * Distributed under the BSD License
	 * See http://pajhome.org.uk/crypt/md5 for more info.
	 */
	function md5(bytes) {
	  if (typeof bytes == 'string') {
	    var msg = unescape(encodeURIComponent(bytes)); // UTF8 escape
	
	    bytes = new Array(msg.length);
	
	    for (var i = 0; i < msg.length; i++) bytes[i] = msg.charCodeAt(i);
	  }
	
	  return md5ToHexEncodedArray(wordsToMd5(bytesToWords(bytes), bytes.length * 8));
	}
	/*
	 * Convert an array of little-endian words to an array of bytes
	 */
	
	
	function md5ToHexEncodedArray(input) {
	  var i;
	  var x;
	  var output = [];
	  var length32 = input.length * 32;
	  var hexTab = '0123456789abcdef';
	  var hex;
	
	  for (i = 0; i < length32; i += 8) {
	    x = input[i >> 5] >>> i % 32 & 0xff;
	    hex = parseInt(hexTab.charAt(x >>> 4 & 0x0f) + hexTab.charAt(x & 0x0f), 16);
	    output.push(hex);
	  }
	
	  return output;
	}
	/*
	 * Calculate the MD5 of an array of little-endian words, and a bit length.
	 */
	
	
	function wordsToMd5(x, len) {
	  /* append padding */
	  x[len >> 5] |= 0x80 << len % 32;
	  x[(len + 64 >>> 9 << 4) + 14] = len;
	  var i;
	  var olda;
	  var oldb;
	  var oldc;
	  var oldd;
	  var a = 1732584193;
	  var b = -271733879;
	  var c = -1732584194;
	  var d = 271733878;
	
	  for (i = 0; i < x.length; i += 16) {
	    olda = a;
	    oldb = b;
	    oldc = c;
	    oldd = d;
	    a = md5ff(a, b, c, d, x[i], 7, -680876936);
	    d = md5ff(d, a, b, c, x[i + 1], 12, -389564586);
	    c = md5ff(c, d, a, b, x[i + 2], 17, 606105819);
	    b = md5ff(b, c, d, a, x[i + 3], 22, -1044525330);
	    a = md5ff(a, b, c, d, x[i + 4], 7, -176418897);
	    d = md5ff(d, a, b, c, x[i + 5], 12, 1200080426);
	    c = md5ff(c, d, a, b, x[i + 6], 17, -1473231341);
	    b = md5ff(b, c, d, a, x[i + 7], 22, -45705983);
	    a = md5ff(a, b, c, d, x[i + 8], 7, 1770035416);
	    d = md5ff(d, a, b, c, x[i + 9], 12, -1958414417);
	    c = md5ff(c, d, a, b, x[i + 10], 17, -42063);
	    b = md5ff(b, c, d, a, x[i + 11], 22, -1990404162);
	    a = md5ff(a, b, c, d, x[i + 12], 7, 1804603682);
	    d = md5ff(d, a, b, c, x[i + 13], 12, -40341101);
	    c = md5ff(c, d, a, b, x[i + 14], 17, -1502002290);
	    b = md5ff(b, c, d, a, x[i + 15], 22, 1236535329);
	    a = md5gg(a, b, c, d, x[i + 1], 5, -165796510);
	    d = md5gg(d, a, b, c, x[i + 6], 9, -1069501632);
	    c = md5gg(c, d, a, b, x[i + 11], 14, 643717713);
	    b = md5gg(b, c, d, a, x[i], 20, -373897302);
	    a = md5gg(a, b, c, d, x[i + 5], 5, -701558691);
	    d = md5gg(d, a, b, c, x[i + 10], 9, 38016083);
	    c = md5gg(c, d, a, b, x[i + 15], 14, -660478335);
	    b = md5gg(b, c, d, a, x[i + 4], 20, -405537848);
	    a = md5gg(a, b, c, d, x[i + 9], 5, 568446438);
	    d = md5gg(d, a, b, c, x[i + 14], 9, -1019803690);
	    c = md5gg(c, d, a, b, x[i + 3], 14, -187363961);
	    b = md5gg(b, c, d, a, x[i + 8], 20, 1163531501);
	    a = md5gg(a, b, c, d, x[i + 13], 5, -1444681467);
	    d = md5gg(d, a, b, c, x[i + 2], 9, -51403784);
	    c = md5gg(c, d, a, b, x[i + 7], 14, 1735328473);
	    b = md5gg(b, c, d, a, x[i + 12], 20, -1926607734);
	    a = md5hh(a, b, c, d, x[i + 5], 4, -378558);
	    d = md5hh(d, a, b, c, x[i + 8], 11, -2022574463);
	    c = md5hh(c, d, a, b, x[i + 11], 16, 1839030562);
	    b = md5hh(b, c, d, a, x[i + 14], 23, -35309556);
	    a = md5hh(a, b, c, d, x[i + 1], 4, -1530992060);
	    d = md5hh(d, a, b, c, x[i + 4], 11, 1272893353);
	    c = md5hh(c, d, a, b, x[i + 7], 16, -155497632);
	    b = md5hh(b, c, d, a, x[i + 10], 23, -1094730640);
	    a = md5hh(a, b, c, d, x[i + 13], 4, 681279174);
	    d = md5hh(d, a, b, c, x[i], 11, -358537222);
	    c = md5hh(c, d, a, b, x[i + 3], 16, -722521979);
	    b = md5hh(b, c, d, a, x[i + 6], 23, 76029189);
	    a = md5hh(a, b, c, d, x[i + 9], 4, -640364487);
	    d = md5hh(d, a, b, c, x[i + 12], 11, -421815835);
	    c = md5hh(c, d, a, b, x[i + 15], 16, 530742520);
	    b = md5hh(b, c, d, a, x[i + 2], 23, -995338651);
	    a = md5ii(a, b, c, d, x[i], 6, -198630844);
	    d = md5ii(d, a, b, c, x[i + 7], 10, 1126891415);
	    c = md5ii(c, d, a, b, x[i + 14], 15, -1416354905);
	    b = md5ii(b, c, d, a, x[i + 5], 21, -57434055);
	    a = md5ii(a, b, c, d, x[i + 12], 6, 1700485571);
	    d = md5ii(d, a, b, c, x[i + 3], 10, -1894986606);
	    c = md5ii(c, d, a, b, x[i + 10], 15, -1051523);
	    b = md5ii(b, c, d, a, x[i + 1], 21, -2054922799);
	    a = md5ii(a, b, c, d, x[i + 8], 6, 1873313359);
	    d = md5ii(d, a, b, c, x[i + 15], 10, -30611744);
	    c = md5ii(c, d, a, b, x[i + 6], 15, -1560198380);
	    b = md5ii(b, c, d, a, x[i + 13], 21, 1309151649);
	    a = md5ii(a, b, c, d, x[i + 4], 6, -145523070);
	    d = md5ii(d, a, b, c, x[i + 11], 10, -1120210379);
	    c = md5ii(c, d, a, b, x[i + 2], 15, 718787259);
	    b = md5ii(b, c, d, a, x[i + 9], 21, -343485551);
	    a = safeAdd(a, olda);
	    b = safeAdd(b, oldb);
	    c = safeAdd(c, oldc);
	    d = safeAdd(d, oldd);
	  }
	
	  return [a, b, c, d];
	}
	/*
	 * Convert an array bytes to an array of little-endian words
	 * Characters >255 have their high-byte silently ignored.
	 */
	
	
	function bytesToWords(input) {
	  var i;
	  var output = [];
	  output[(input.length >> 2) - 1] = undefined;
	
	  for (i = 0; i < output.length; i += 1) {
	    output[i] = 0;
	  }
	
	  var length8 = input.length * 8;
	
	  for (i = 0; i < length8; i += 8) {
	    output[i >> 5] |= (input[i / 8] & 0xff) << i % 32;
	  }
	
	  return output;
	}
	/*
	 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
	 * to work around bugs in some JS interpreters.
	 */
	
	
	function safeAdd(x, y) {
	  var lsw = (x & 0xffff) + (y & 0xffff);
	  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
	  return msw << 16 | lsw & 0xffff;
	}
	/*
	 * Bitwise rotate a 32-bit number to the left.
	 */
	
	
	function bitRotateLeft(num, cnt) {
	  return num << cnt | num >>> 32 - cnt;
	}
	/*
	 * These functions implement the four basic operations the algorithm uses.
	 */
	
	
	function md5cmn(q, a, b, x, s, t) {
	  return safeAdd(bitRotateLeft(safeAdd(safeAdd(a, q), safeAdd(x, t)), s), b);
	}
	
	function md5ff(a, b, c, d, x, s, t) {
	  return md5cmn(b & c | ~b & d, a, b, x, s, t);
	}
	
	function md5gg(a, b, c, d, x, s, t) {
	  return md5cmn(b & d | c & ~d, a, b, x, s, t);
	}
	
	function md5hh(a, b, c, d, x, s, t) {
	  return md5cmn(b ^ c ^ d, a, b, x, s, t);
	}
	
	function md5ii(a, b, c, d, x, s, t) {
	  return md5cmn(c ^ (b | ~d), a, b, x, s, t);
	}
	
	var _default = md5;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1637 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	// Adapted from Chris Veness' SHA1 code at
	// http://www.movable-type.co.uk/scripts/sha1.html
	function f(s, x, y, z) {
	  switch (s) {
	    case 0:
	      return x & y ^ ~x & z;
	
	    case 1:
	      return x ^ y ^ z;
	
	    case 2:
	      return x & y ^ x & z ^ y & z;
	
	    case 3:
	      return x ^ y ^ z;
	  }
	}
	
	function ROTL(x, n) {
	  return x << n | x >>> 32 - n;
	}
	
	function sha1(bytes) {
	  var K = [0x5a827999, 0x6ed9eba1, 0x8f1bbcdc, 0xca62c1d6];
	  var H = [0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476, 0xc3d2e1f0];
	
	  if (typeof bytes == 'string') {
	    var msg = unescape(encodeURIComponent(bytes)); // UTF8 escape
	
	    bytes = new Array(msg.length);
	
	    for (var i = 0; i < msg.length; i++) bytes[i] = msg.charCodeAt(i);
	  }
	
	  bytes.push(0x80);
	  var l = bytes.length / 4 + 2;
	  var N = Math.ceil(l / 16);
	  var M = new Array(N);
	
	  for (var i = 0; i < N; i++) {
	    M[i] = new Array(16);
	
	    for (var j = 0; j < 16; j++) {
	      M[i][j] = bytes[i * 64 + j * 4] << 24 | bytes[i * 64 + j * 4 + 1] << 16 | bytes[i * 64 + j * 4 + 2] << 8 | bytes[i * 64 + j * 4 + 3];
	    }
	  }
	
	  M[N - 1][14] = (bytes.length - 1) * 8 / Math.pow(2, 32);
	  M[N - 1][14] = Math.floor(M[N - 1][14]);
	  M[N - 1][15] = (bytes.length - 1) * 8 & 0xffffffff;
	
	  for (var i = 0; i < N; i++) {
	    var W = new Array(80);
	
	    for (var t = 0; t < 16; t++) W[t] = M[i][t];
	
	    for (var t = 16; t < 80; t++) {
	      W[t] = ROTL(W[t - 3] ^ W[t - 8] ^ W[t - 14] ^ W[t - 16], 1);
	    }
	
	    var a = H[0];
	    var b = H[1];
	    var c = H[2];
	    var d = H[3];
	    var e = H[4];
	
	    for (var t = 0; t < 80; t++) {
	      var s = Math.floor(t / 20);
	      var T = ROTL(a, 5) + f(s, b, c, d) + e + K[s] + W[t] >>> 0;
	      e = d;
	      d = c;
	      c = ROTL(b, 30) >>> 0;
	      b = a;
	      a = T;
	    }
	
	    H[0] = H[0] + a >>> 0;
	    H[1] = H[1] + b >>> 0;
	    H[2] = H[2] + c >>> 0;
	    H[3] = H[3] + d >>> 0;
	    H[4] = H[4] + e >>> 0;
	  }
	
	  return [H[0] >> 24 & 0xff, H[0] >> 16 & 0xff, H[0] >> 8 & 0xff, H[0] & 0xff, H[1] >> 24 & 0xff, H[1] >> 16 & 0xff, H[1] >> 8 & 0xff, H[1] & 0xff, H[2] >> 24 & 0xff, H[2] >> 16 & 0xff, H[2] >> 8 & 0xff, H[2] & 0xff, H[3] >> 24 & 0xff, H[3] >> 16 & 0xff, H[3] >> 8 & 0xff, H[3] & 0xff, H[4] >> 24 & 0xff, H[4] >> 16 & 0xff, H[4] >> 8 & 0xff, H[4] & 0xff];
	}
	
	var _default = sha1;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1638 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _rng = _interopRequireDefault(__webpack_require__(664));
	
	var _bytesToUuid = _interopRequireDefault(__webpack_require__(311));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// **`v1()` - Generate time-based UUID**
	//
	// Inspired by https://github.com/LiosK/UUID.js
	// and http://docs.python.org/library/uuid.html
	var _nodeId;
	
	var _clockseq; // Previous uuid creation time
	
	
	var _lastMSecs = 0;
	var _lastNSecs = 0; // See https://github.com/uuidjs/uuid for API details
	
	function v1(options, buf, offset) {
	  var i = buf && offset || 0;
	  var b = buf || [];
	  options = options || {};
	  var node = options.node || _nodeId;
	  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq; // node and clockseq need to be initialized to random values if they're not
	  // specified.  We do this lazily to minimize issues related to insufficient
	  // system entropy.  See #189
	
	  if (node == null || clockseq == null) {
	    var seedBytes = options.random || (options.rng || _rng.default)();
	
	    if (node == null) {
	      // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
	      node = _nodeId = [seedBytes[0] | 0x01, seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]];
	    }
	
	    if (clockseq == null) {
	      // Per 4.2.2, randomize (14 bit) clockseq
	      clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
	    }
	  } // UUID timestamps are 100 nano-second units since the Gregorian epoch,
	  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
	  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
	  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
	
	
	  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime(); // Per 4.2.1.2, use count of uuid's generated during the current clock
	  // cycle to simulate higher resolution clock
	
	  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1; // Time since last uuid creation (in msecs)
	
	  var dt = msecs - _lastMSecs + (nsecs - _lastNSecs) / 10000; // Per 4.2.1.2, Bump clockseq on clock regression
	
	  if (dt < 0 && options.clockseq === undefined) {
	    clockseq = clockseq + 1 & 0x3fff;
	  } // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
	  // time interval
	
	
	  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
	    nsecs = 0;
	  } // Per 4.2.1.2 Throw error if too many uuids are requested
	
	
	  if (nsecs >= 10000) {
	    throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
	  }
	
	  _lastMSecs = msecs;
	  _lastNSecs = nsecs;
	  _clockseq = clockseq; // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
	
	  msecs += 12219292800000; // `time_low`
	
	  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
	  b[i++] = tl >>> 24 & 0xff;
	  b[i++] = tl >>> 16 & 0xff;
	  b[i++] = tl >>> 8 & 0xff;
	  b[i++] = tl & 0xff; // `time_mid`
	
	  var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
	  b[i++] = tmh >>> 8 & 0xff;
	  b[i++] = tmh & 0xff; // `time_high_and_version`
	
	  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
	
	  b[i++] = tmh >>> 16 & 0xff; // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
	
	  b[i++] = clockseq >>> 8 | 0x80; // `clock_seq_low`
	
	  b[i++] = clockseq & 0xff; // `node`
	
	  for (var n = 0; n < 6; ++n) {
	    b[i + n] = node[n];
	  }
	
	  return buf ? buf : (0, _bytesToUuid.default)(b);
	}
	
	var _default = v1;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1639 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _v = _interopRequireDefault(__webpack_require__(665));
	
	var _md = _interopRequireDefault(__webpack_require__(1636));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	const v3 = (0, _v.default)('v3', 0x30, _md.default);
	var _default = v3;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1640 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _rng = _interopRequireDefault(__webpack_require__(664));
	
	var _bytesToUuid = _interopRequireDefault(__webpack_require__(311));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function v4(options, buf, offset) {
	  var i = buf && offset || 0;
	
	  if (typeof options == 'string') {
	    buf = options === 'binary' ? new Array(16) : null;
	    options = null;
	  }
	
	  options = options || {};
	
	  var rnds = options.random || (options.rng || _rng.default)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
	
	
	  rnds[6] = rnds[6] & 0x0f | 0x40;
	  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
	
	  if (buf) {
	    for (var ii = 0; ii < 16; ++ii) {
	      buf[i + ii] = rnds[ii];
	    }
	  }
	
	  return buf || (0, _bytesToUuid.default)(rnds);
	}
	
	var _default = v4;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1641 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _v = _interopRequireDefault(__webpack_require__(665));
	
	var _sha = _interopRequireDefault(__webpack_require__(1637));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	const v5 = (0, _v.default)('v5', 0x50, _sha.default);
	var _default = v5;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1642 */
/***/ function(module, exports) {

	"use strict";function valueOf(e){return e.valueOf?e.valueOf():Object.prototype.valueOf.call(e)}function valueEqual(u,r){if(u===r)return!0;if(null==u||null==r)return!1;if(Array.isArray(u))return Array.isArray(r)&&u.length===r.length&&u.every(function(e,u){return valueEqual(e,r[u])});if("object"!=typeof u&&"object"!=typeof r)return!1;var e=valueOf(u),t=valueOf(r);return e!==u||t!==r?valueEqual(e,t):Object.keys(Object.assign({},u,r)).every(function(e){return valueEqual(u[e],r[e])})}module.exports=valueEqual;


/***/ },
/* 1643 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(1642);
	} else {
	  module.exports = require('./cjs/value-equal.js');
	}


/***/ },
/* 1644 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(47));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(19));
	
	var _redux = __webpack_require__(1658);
	
	var _reducers = _interopRequireDefault(__webpack_require__(689));
	
	var playerActions = _interopRequireWildcard(__webpack_require__(226));
	
	var videoActions = _interopRequireWildcard(__webpack_require__(312));
	
	var Manager =
	/*#__PURE__*/
	function () {
	  function Manager(store) {
	    (0, _classCallCheck2["default"])(this, Manager);
	    this.store = store || (0, _redux.createStore)(_reducers["default"]);
	    this.video = null;
	    this.rootElement = null;
	  }
	
	  (0, _createClass2["default"])(Manager, [{
	    key: "getActions",
	    value: function getActions() {
	      var manager = this;
	      var dispatch = this.store.dispatch;
	      var actions = (0, _objectSpread2["default"])({}, playerActions, videoActions);
	
	      function bindActionCreator(actionCreator) {
	        return function bindAction() {
	          // eslint-disable-next-line prefer-rest-params
	          var action = actionCreator.apply(manager, arguments);
	
	          if (typeof action !== 'undefined') {
	            dispatch(action);
	          }
	        };
	      }
	
	      return Object.keys(actions).filter(function (key) {
	        return typeof actions[key] === 'function';
	      }).reduce(function (boundActions, key) {
	        boundActions[key] = bindActionCreator(actions[key]);
	        return boundActions;
	      }, {});
	    }
	  }, {
	    key: "getState",
	    value: function getState() {
	      return this.store.getState();
	    } // subscribe state change
	
	  }, {
	    key: "subscribeToStateChange",
	    value: function subscribeToStateChange(listener, getState) {
	      if (!getState) {
	        getState = this.getState.bind(this);
	      }
	
	      var prevState = getState();
	
	      var handleChange = function handleChange() {
	        var state = getState();
	
	        if (state === prevState) {
	          return;
	        }
	
	        var prevStateCopy = prevState;
	        prevState = state;
	        listener(state, prevStateCopy);
	      };
	
	      return this.store.subscribe(handleChange);
	    } // subscribe to operation state change
	
	  }, {
	    key: "subscribeToOperationStateChange",
	    value: function subscribeToOperationStateChange(listener) {
	      var _this = this;
	
	      return this.subscribeToStateChange(listener, function () {
	        return _this.getState().operation;
	      });
	    } // subscribe to player state change
	
	  }, {
	    key: "subscribeToPlayerStateChange",
	    value: function subscribeToPlayerStateChange(listener) {
	      var _this2 = this;
	
	      return this.subscribeToStateChange(listener, function () {
	        return _this2.getState().player;
	      });
	    }
	  }]);
	  return Manager;
	}();
	
	exports["default"] = Manager;

/***/ },
/* 1645 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(47));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(24));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(25));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(19));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(40));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(39));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(12));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(22));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _Manager = _interopRequireDefault(__webpack_require__(1644));
	
	var _BigPlayButton = _interopRequireDefault(__webpack_require__(667));
	
	var _LoadingSpinner = _interopRequireDefault(__webpack_require__(669));
	
	var _PosterImage = _interopRequireDefault(__webpack_require__(670));
	
	var _Video = _interopRequireDefault(__webpack_require__(672));
	
	var _Bezel = _interopRequireDefault(__webpack_require__(666));
	
	var _Shortcut = _interopRequireDefault(__webpack_require__(671));
	
	var _ControlBar = _interopRequireDefault(__webpack_require__(673));
	
	var browser = _interopRequireWildcard(__webpack_require__(1657));
	
	var _dom = __webpack_require__(227);
	
	var _utils = __webpack_require__(87);
	
	var _fullscreen = _interopRequireDefault(__webpack_require__(690));
	
	var propTypes = {
	  children: _propTypes["default"].any,
	  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  height: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  fluid: _propTypes["default"].bool,
	  muted: _propTypes["default"].bool,
	  playsInline: _propTypes["default"].bool,
	  aspectRatio: _propTypes["default"].string,
	  className: _propTypes["default"].string,
	  videoId: _propTypes["default"].string,
	  startTime: _propTypes["default"].number,
	  loop: _propTypes["default"].bool,
	  autoPlay: _propTypes["default"].bool,
	  src: _propTypes["default"].string,
	  poster: _propTypes["default"].string,
	  preload: _propTypes["default"].oneOf(['auto', 'metadata', 'none']),
	  onLoadStart: _propTypes["default"].func,
	  onWaiting: _propTypes["default"].func,
	  onCanPlay: _propTypes["default"].func,
	  onCanPlayThrough: _propTypes["default"].func,
	  onPlaying: _propTypes["default"].func,
	  onEnded: _propTypes["default"].func,
	  onSeeking: _propTypes["default"].func,
	  onSeeked: _propTypes["default"].func,
	  onPlay: _propTypes["default"].func,
	  onPause: _propTypes["default"].func,
	  onProgress: _propTypes["default"].func,
	  onDurationChange: _propTypes["default"].func,
	  onError: _propTypes["default"].func,
	  onSuspend: _propTypes["default"].func,
	  onAbort: _propTypes["default"].func,
	  onEmptied: _propTypes["default"].func,
	  onStalled: _propTypes["default"].func,
	  onLoadedMetadata: _propTypes["default"].func,
	  onLoadedData: _propTypes["default"].func,
	  onTimeUpdate: _propTypes["default"].func,
	  onRateChange: _propTypes["default"].func,
	  onVolumeChange: _propTypes["default"].func,
	  store: _propTypes["default"].object
	};
	var defaultProps = {
	  fluid: true,
	  muted: false,
	  playsInline: false,
	  preload: 'auto',
	  aspectRatio: 'auto'
	};
	
	var Player =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(Player, _Component);
	
	  function Player(props) {
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, Player);
	    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Player).call(this, props));
	    _this.controlsHideTimer = null;
	    _this.video = null; // the Video component
	
	    _this.manager = new _Manager["default"](props.store);
	    _this.actions = _this.manager.getActions();
	
	    _this.manager.subscribeToPlayerStateChange(_this.handleStateChange.bind((0, _assertThisInitialized2["default"])(_this)));
	
	    _this.getStyle = _this.getStyle.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleResize = _this.handleResize.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.getChildren = _this.getChildren.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleMouseMove = (0, _utils.throttle)(_this.handleMouseMove.bind((0, _assertThisInitialized2["default"])(_this)), 250);
	    _this.handleMouseDown = _this.handleMouseDown.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.startControlsTimer = _this.startControlsTimer.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleFullScreenChange = _this.handleFullScreenChange.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleKeyDown = _this.handleKeyDown.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleFocus = _this.handleFocus.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleBlur = _this.handleBlur.bind((0, _assertThisInitialized2["default"])(_this));
	    return _this;
	  }
	
	  (0, _createClass2["default"])(Player, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.handleResize();
	      window.addEventListener('resize', this.handleResize);
	
	      _fullscreen["default"].addEventListener(this.handleFullScreenChange);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      // Remove event listener
	      window.removeEventListener('resize', this.handleResize);
	
	      _fullscreen["default"].removeEventListener(this.handleFullScreenChange);
	
	      if (this.controlsHideTimer) {
	        window.clearTimeout(this.controlsHideTimer);
	      }
	    }
	  }, {
	    key: "getDefaultChildren",
	    value: function getDefaultChildren(originalChildren) {
	      var _this2 = this;
	
	      return [_react["default"].createElement(_Video["default"], {
	        ref: function ref(c) {
	          _this2.video = c;
	          _this2.manager.video = _this2.video;
	        },
	        key: "video",
	        order: 0.0
	      }, originalChildren), _react["default"].createElement(_PosterImage["default"], {
	        key: "poster-image",
	        order: 1.0
	      }), _react["default"].createElement(_LoadingSpinner["default"], {
	        key: "loading-spinner",
	        order: 2.0
	      }), _react["default"].createElement(_Bezel["default"], {
	        key: "bezel",
	        order: 3.0
	      }), _react["default"].createElement(_BigPlayButton["default"], {
	        key: "big-play-button",
	        order: 4.0
	      }), _react["default"].createElement(_ControlBar["default"], {
	        key: "control-bar",
	        order: 5.0
	      }), _react["default"].createElement(_Shortcut["default"], {
	        key: "shortcut",
	        order: 99.0
	      })];
	    }
	  }, {
	    key: "getChildren",
	    value: function getChildren(props) {
	      var _ = props.className,
	          originalChildren = props.children,
	          propsWithoutChildren = (0, _objectWithoutProperties2["default"])(props, ["className", "children"]);
	
	      var children = _react["default"].Children.toArray(this.props.children).filter(function (e) {
	        return !(0, _utils.isVideoChild)(e);
	      });
	
	      var defaultChildren = this.getDefaultChildren(originalChildren);
	      return (0, _utils.mergeAndSortChildren)(defaultChildren, children, propsWithoutChildren);
	    }
	  }, {
	    key: "setWidthOrHeight",
	    value: function setWidthOrHeight(style, name, value) {
	      var styleVal;
	
	      if (typeof value === 'string') {
	        if (value === 'auto') {
	          styleVal = 'auto';
	        } else if (value.match(/\d+%/)) {
	          styleVal = value;
	        }
	      } else if (typeof value === 'number') {
	        styleVal = "".concat(value, "px");
	      }
	
	      Object.assign(style, (0, _defineProperty2["default"])({}, name, styleVal));
	    }
	  }, {
	    key: "getStyle",
	    value: function getStyle() {
	      var _this$props = this.props,
	          fluid = _this$props.fluid,
	          propsAspectRatio = _this$props.aspectRatio,
	          propsHeight = _this$props.height,
	          propsWidth = _this$props.width;
	
	      var _this$manager$getStat = this.manager.getState(),
	          player = _this$manager$getStat.player;
	
	      var style = {};
	      var width;
	      var height;
	      var aspectRatio; // The aspect ratio is either used directly or to calculate width and height.
	
	      if (propsAspectRatio !== undefined && propsAspectRatio !== 'auto') {
	        // Use any aspectRatio that's been specifically set
	        aspectRatio = propsAspectRatio;
	      } else if (player.videoWidth) {
	        // Otherwise try to get the aspect ratio from the video metadata
	        aspectRatio = "".concat(player.videoWidth, ":").concat(player.videoHeight);
	      } else {
	        // Or use a default. The video element's is 2:1, but 16:9 is more common.
	        aspectRatio = '16:9';
	      } // Get the ratio as a decimal we can use to calculate dimensions
	
	
	      var ratioParts = aspectRatio.split(':');
	      var ratioMultiplier = ratioParts[1] / ratioParts[0];
	
	      if (propsWidth !== undefined) {
	        // Use any width that's been specifically set
	        width = propsWidth;
	      } else if (propsHeight !== undefined) {
	        // Or calulate the width from the aspect ratio if a height has been set
	        width = propsHeight / ratioMultiplier;
	      } else {
	        // Or use the video's metadata, or use the video el's default of 300
	        width = player.videoWidth || 400;
	      }
	
	      if (propsHeight !== undefined) {
	        // Use any height that's been specifically set
	        height = propsHeight;
	      } else {
	        // Otherwise calculate the height from the ratio and the width
	        height = width * ratioMultiplier;
	      }
	
	      if (fluid) {
	        style.paddingTop = "".concat(ratioMultiplier * 100, "%");
	      } else {
	        // If Width contains "auto", set "auto" in style
	        this.setWidthOrHeight(style, 'width', width);
	        this.setWidthOrHeight(style, 'height', height);
	      }
	
	      return style;
	    } // get redux state
	    // { player, operation }
	
	  }, {
	    key: "getState",
	    value: function getState() {
	      return this.manager.getState();
	    } // get playback rate
	
	  }, {
	    key: "play",
	    // play the video
	    value: function play() {
	      this.video.play();
	    } // pause the video
	
	  }, {
	    key: "pause",
	    value: function pause() {
	      this.video.pause();
	    } // Change the video source and re-load the video:
	
	  }, {
	    key: "load",
	    value: function load() {
	      this.video.load();
	    } // Add a new text track to the video
	
	  }, {
	    key: "addTextTrack",
	    value: function addTextTrack() {
	      var _this$video;
	
	      (_this$video = this.video).addTextTrack.apply(_this$video, arguments);
	    } // Check if your browser can play different types of video:
	
	  }, {
	    key: "canPlayType",
	    value: function canPlayType() {
	      var _this$video2;
	
	      (_this$video2 = this.video).canPlayType.apply(_this$video2, arguments);
	    } // seek video by time
	
	  }, {
	    key: "seek",
	    value: function seek(time) {
	      this.video.seek(time);
	    } // jump forward x seconds
	
	  }, {
	    key: "forward",
	    value: function forward(seconds) {
	      this.video.forward(seconds);
	    } // jump back x seconds
	
	  }, {
	    key: "replay",
	    value: function replay(seconds) {
	      this.video.replay(seconds);
	    } // enter or exist full screen
	
	  }, {
	    key: "toggleFullscreen",
	    value: function toggleFullscreen() {
	      this.video.toggleFullscreen();
	    } // subscribe to player state change
	
	  }, {
	    key: "subscribeToStateChange",
	    value: function subscribeToStateChange(listener) {
	      return this.manager.subscribeToPlayerStateChange(listener);
	    } // player resize
	
	  }, {
	    key: "handleResize",
	    value: function handleResize() {}
	  }, {
	    key: "handleFullScreenChange",
	    value: function handleFullScreenChange(event) {
	      if (event.target === this.manager.rootElement) {
	        this.actions.handleFullscreenChange(_fullscreen["default"].isFullscreen);
	      }
	    }
	  }, {
	    key: "handleMouseDown",
	    value: function handleMouseDown() {
	      this.startControlsTimer();
	    }
	  }, {
	    key: "handleMouseMove",
	    value: function handleMouseMove() {
	      this.startControlsTimer();
	    }
	  }, {
	    key: "handleKeyDown",
	    value: function handleKeyDown() {
	      this.startControlsTimer();
	    }
	  }, {
	    key: "startControlsTimer",
	    value: function startControlsTimer() {
	      var _this3 = this;
	
	      var controlBarActiveTime = 3000;
	
	      _react["default"].Children.forEach(this.props.children, function (element) {
	        if (!_react["default"].isValidElement(element) || element.type !== _ControlBar["default"]) {
	          return;
	        }
	
	        var autoHideTime = element.props.autoHideTime;
	
	        if (typeof autoHideTime === 'number') {
	          controlBarActiveTime = autoHideTime;
	        }
	      });
	
	      this.actions.userActivate(true);
	      clearTimeout(this.controlsHideTimer);
	      this.controlsHideTimer = setTimeout(function () {
	        _this3.actions.userActivate(false);
	      }, controlBarActiveTime);
	    }
	  }, {
	    key: "handleStateChange",
	    value: function handleStateChange(state, prevState) {
	      if (state.isFullscreen !== prevState.isFullscreen) {
	        this.handleResize(); // focus root when switching fullscreen mode to avoid confusion #276
	
	        (0, _dom.focusNode)(this.manager.rootElement);
	      }
	
	      this.forceUpdate(); // re-render
	    }
	  }, {
	    key: "handleFocus",
	    value: function handleFocus() {
	      this.actions.activate(true);
	    }
	  }, {
	    key: "handleBlur",
	    value: function handleBlur() {
	      this.actions.activate(false);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this4 = this;
	
	      var fluid = this.props.fluid;
	
	      var _this$manager$getStat2 = this.manager.getState(),
	          player = _this$manager$getStat2.player;
	
	      var paused = player.paused,
	          hasStarted = player.hasStarted,
	          waiting = player.waiting,
	          seeking = player.seeking,
	          isFullscreen = player.isFullscreen,
	          userActivity = player.userActivity;
	      var props = (0, _objectSpread2["default"])({}, this.props, {
	        player: player,
	        actions: this.actions,
	        manager: this.manager,
	        store: this.manager.store,
	        video: this.video ? this.video.video : null
	      });
	      var children = this.getChildren(props);
	      return _react["default"].createElement("div", {
	        className: (0, _classnames["default"])({
	          'video-react-controls-enabled': true,
	          'video-react-has-started': hasStarted,
	          'video-react-paused': paused,
	          'video-react-playing': !paused,
	          'video-react-waiting': waiting,
	          'video-react-seeking': seeking,
	          'video-react-fluid': fluid,
	          'video-react-fullscreen': isFullscreen,
	          'video-react-user-inactive': !userActivity,
	          'video-react-user-active': userActivity,
	          'video-react-workinghover': !browser.IS_IOS
	        }, 'video-react', this.props.className),
	        style: this.getStyle(),
	        ref: function ref(c) {
	          _this4.manager.rootElement = c;
	        },
	        role: "region",
	        onTouchStart: this.handleMouseDown,
	        onMouseDown: this.handleMouseDown,
	        onTouchMove: this.handleMouseMove,
	        onMouseMove: this.handleMouseMove,
	        onKeyDown: this.handleKeyDown,
	        onFocus: this.handleFocus,
	        onBlur: this.handleBlur,
	        tabIndex: "-1"
	      }, children);
	    }
	  }, {
	    key: "playbackRate",
	    get: function get() {
	      return this.video.playbackRate;
	    } // set playback rate
	    // speed of video
	    ,
	    set: function set(rate) {
	      this.video.playbackRate = rate;
	    }
	  }, {
	    key: "muted",
	    get: function get() {
	      return this.video.muted;
	    },
	    set: function set(val) {
	      this.video.muted = val;
	    }
	  }, {
	    key: "volume",
	    get: function get() {
	      return this.video.volume;
	    },
	    set: function set(val) {
	      this.video.volume = val;
	    } // video width
	
	  }, {
	    key: "videoWidth",
	    get: function get() {
	      return this.video.videoWidth;
	    } // video height
	
	  }, {
	    key: "videoHeight",
	    get: function get() {
	      return this.video.videoHeight;
	    }
	  }]);
	  return Player;
	}(_react.Component);
	
	exports["default"] = Player;
	Player.contextTypes = {
	  store: _propTypes["default"].object
	};
	Player.propTypes = propTypes;
	Player.defaultProps = defaultProps;
	Player.displayName = 'Player';

/***/ },
/* 1646 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(19));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(40));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(39));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(12));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(22));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _MenuButton = _interopRequireDefault(__webpack_require__(315));
	
	var propTypes = {
	  player: _propTypes["default"].object,
	  actions: _propTypes["default"].object,
	  className: _propTypes["default"].string,
	  offMenuText: _propTypes["default"].string,
	  showOffMenu: _propTypes["default"].bool,
	  kinds: _propTypes["default"].array
	};
	var defaultProps = {
	  offMenuText: 'Off',
	  showOffMenu: true,
	  kinds: ['captions', 'subtitles'] // `kind`s of TextTrack to look for to associate it with this menu.
	
	};
	
	var ClosedCaptionButton =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(ClosedCaptionButton, _Component);
	
	  function ClosedCaptionButton(props, context) {
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, ClosedCaptionButton);
	    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(ClosedCaptionButton).call(this, props, context));
	    _this.getTextTrackItems = _this.getTextTrackItems.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.updateState = _this.updateState.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleSelectItem = _this.handleSelectItem.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.state = _this.getTextTrackItems();
	    return _this;
	  }
	
	  (0, _createClass2["default"])(ClosedCaptionButton, [{
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      this.updateState();
	    }
	  }, {
	    key: "getTextTrackItems",
	    value: function getTextTrackItems() {
	      var _this$props = this.props,
	          kinds = _this$props.kinds,
	          player = _this$props.player,
	          offMenuText = _this$props.offMenuText,
	          showOffMenu = _this$props.showOffMenu;
	      var textTracks = player.textTracks,
	          activeTextTrack = player.activeTextTrack;
	      var textTrackItems = {
	        items: [],
	        selectedIndex: 0
	      };
	      var tracks = Array.from(textTracks || []);
	
	      if (tracks.length === 0) {
	        return textTrackItems;
	      }
	
	      if (showOffMenu) {
	        textTrackItems.items.push({
	          label: offMenuText || 'Off',
	          value: null
	        });
	      }
	
	      tracks.forEach(function (textTrack) {
	        // ignore invalid text track kind
	        if (kinds.length && !kinds.includes(textTrack.kind)) {
	          return;
	        }
	
	        textTrackItems.items.push({
	          label: textTrack.label,
	          value: textTrack.language
	        });
	      });
	      textTrackItems.selectedIndex = textTrackItems.items.findIndex(function (item) {
	        return activeTextTrack && activeTextTrack.language === item.value;
	      });
	
	      if (textTrackItems.selectedIndex === -1) {
	        textTrackItems.selectedIndex = 0;
	      }
	
	      return textTrackItems;
	    }
	  }, {
	    key: "updateState",
	    value: function updateState() {
	      var textTrackItems = this.getTextTrackItems();
	
	      if (textTrackItems.selectedIndex !== this.state.selectedIndex || !this.textTrackItemsAreEqual(textTrackItems.items, this.state.items)) {
	        this.setState(textTrackItems);
	      }
	    }
	  }, {
	    key: "textTrackItemsAreEqual",
	    value: function textTrackItemsAreEqual(items1, items2) {
	      if (items1.length !== items2.length) {
	        return false;
	      }
	
	      for (var i = 0; i < items1.length; i++) {
	        if (!items2[i] || items1[i].label !== items2[i].label || items1[i].value !== items2[i].value) {
	          return false;
	        }
	      }
	
	      return true;
	    }
	  }, {
	    key: "handleSelectItem",
	    value: function handleSelectItem(index) {
	      var _this$props2 = this.props,
	          player = _this$props2.player,
	          actions = _this$props2.actions,
	          showOffMenu = _this$props2.showOffMenu;
	      var textTracks = player.textTracks; // For the 'subtitles-off' button, the first condition will never match
	      // so all subtitles will be turned off
	
	      Array.from(textTracks).forEach(function (textTrack, i) {
	        // if it shows the `Off` menu, the first item is `Off`
	        if (index === (showOffMenu ? i + 1 : i)) {
	          textTrack.mode = 'showing';
	          actions.activateTextTrack(textTrack);
	        } else {
	          textTrack.mode = 'hidden';
	        }
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$state = this.state,
	          items = _this$state.items,
	          selectedIndex = _this$state.selectedIndex;
	      return _react["default"].createElement(_MenuButton["default"], {
	        className: (0, _classnames["default"])('video-react-closed-caption', this.props.className),
	        onSelectItem: this.handleSelectItem,
	        items: items,
	        selectedIndex: selectedIndex
	      }, _react["default"].createElement("span", {
	        className: "video-react-control-text"
	      }, "Closed Caption"));
	    }
	  }]);
	  return ClosedCaptionButton;
	}(_react.Component);
	
	ClosedCaptionButton.propTypes = propTypes;
	ClosedCaptionButton.defaultProps = defaultProps;
	ClosedCaptionButton.displayName = 'ClosedCaptionButton';
	var _default = ClosedCaptionButton;
	exports["default"] = _default;

/***/ },
/* 1647 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(19));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(40));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(39));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(22));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _PlaybackRateMenuButton = _interopRequireDefault(__webpack_require__(314));
	
	var _utils = __webpack_require__(87);
	
	var PlaybackRate =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(PlaybackRate, _Component);
	
	  function PlaybackRate(props, context) {
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, PlaybackRate);
	    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(PlaybackRate).call(this, props, context));
	    (0, _utils.deprecatedWarning)('PlaybackRate', 'PlaybackRateMenuButton');
	    return _this;
	  }
	
	  (0, _createClass2["default"])(PlaybackRate, [{
	    key: "render",
	    value: function render() {
	      return _react["default"].createElement(_PlaybackRateMenuButton["default"], this.props);
	    }
	  }]);
	  return PlaybackRate;
	}(_react.Component);
	
	exports["default"] = PlaybackRate;
	PlaybackRate.displayName = 'PlaybackRate';

/***/ },
/* 1648 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(19));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(40));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(39));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(12));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(22));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var propTypes = {
	  children: _propTypes["default"].any
	};
	
	var Menu =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(Menu, _Component);
	
	  function Menu(props, context) {
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, Menu);
	    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Menu).call(this, props, context));
	    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
	    return _this;
	  }
	
	  (0, _createClass2["default"])(Menu, [{
	    key: "handleClick",
	    value: function handleClick(event) {
	      event.preventDefault(); // event.stopPropagation();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react["default"].createElement("div", {
	        className: "video-react-menu video-react-lock-showing",
	        role: "presentation",
	        onClick: this.handleClick
	      }, _react["default"].createElement("ul", {
	        className: "video-react-menu-content"
	      }, this.props.children));
	    }
	  }]);
	  return Menu;
	}(_react.Component);
	
	exports["default"] = Menu;
	Menu.propTypes = propTypes;
	Menu.displayName = 'Menu';

/***/ },
/* 1649 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(19));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(40));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(39));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(12));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(22));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var propTypes = {
	  item: _propTypes["default"].object,
	  index: _propTypes["default"].number,
	  activateIndex: _propTypes["default"].number,
	  onSelectItem: _propTypes["default"].func
	};
	
	var MenuItem =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(MenuItem, _Component);
	
	  function MenuItem(props, context) {
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, MenuItem);
	    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(MenuItem).call(this, props, context));
	    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
	    return _this;
	  }
	
	  (0, _createClass2["default"])(MenuItem, [{
	    key: "handleClick",
	    value: function handleClick() {
	      var _this$props = this.props,
	          index = _this$props.index,
	          onSelectItem = _this$props.onSelectItem;
	      onSelectItem(index);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          item = _this$props2.item,
	          index = _this$props2.index,
	          activateIndex = _this$props2.activateIndex;
	      return _react["default"].createElement("li", {
	        className: (0, _classnames["default"])({
	          'video-react-menu-item': true,
	          'video-react-selected': index === activateIndex
	        }),
	        role: "menuitem",
	        onClick: this.handleClick
	      }, item.label, _react["default"].createElement("span", {
	        className: "video-react-control-text"
	      }));
	    }
	  }]);
	  return MenuItem;
	}(_react.Component);
	
	exports["default"] = MenuItem;
	MenuItem.propTypes = propTypes;
	MenuItem.displayName = 'MenuItem';

/***/ },
/* 1650 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(19));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(40));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(39));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(12));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(22));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var propTypes = {
	  player: _propTypes["default"].object,
	  children: _propTypes["default"].any
	};
	
	var Popup =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(Popup, _Component);
	
	  function Popup(props, context) {
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, Popup);
	    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Popup).call(this, props, context));
	    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
	    return _this;
	  }
	
	  (0, _createClass2["default"])(Popup, [{
	    key: "handleClick",
	    value: function handleClick(event) {
	      event.preventDefault(); // event.stopPropagation();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var children = this.props.children;
	      return _react["default"].createElement("div", {
	        className: "video-react-menu",
	        onClick: this.handleClick
	      }, _react["default"].createElement("div", {
	        className: "video-react-menu-content"
	      }, children));
	    }
	  }]);
	  return Popup;
	}(_react.Component);
	
	exports["default"] = Popup;
	Popup.propTypes = propTypes;
	Popup.displayName = 'Popup';

/***/ },
/* 1651 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = PopupButton;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(47));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _ClickableComponent = _interopRequireDefault(__webpack_require__(668));
	
	var _Popup = _interopRequireDefault(__webpack_require__(1650));
	
	var propTypes = {
	  inline: _propTypes["default"].bool,
	  onClick: _propTypes["default"].func.isRequired,
	  onFocus: _propTypes["default"].func,
	  onBlur: _propTypes["default"].func,
	  className: _propTypes["default"].string
	};
	var defaultProps = {
	  inline: true
	};
	
	function PopupButton(props) {
	  var inline = props.inline,
	      className = props.className;
	  var ps = (0, _objectSpread2["default"])({}, props);
	  delete ps.children;
	  delete ps.inline;
	  delete ps.className;
	  return _react["default"].createElement(_ClickableComponent["default"], (0, _extends2["default"])({
	    className: (0, _classnames["default"])(className, {
	      'video-react-menu-button-inline': !!inline,
	      'video-react-menu-button-popup': !inline
	    }, 'video-react-control video-react-button video-react-menu-button')
	  }, ps), _react["default"].createElement(_Popup["default"], props));
	}
	
	PopupButton.propTypes = propTypes;
	PopupButton.defaultProps = defaultProps;
	PopupButton.displayName = 'PopupButton';

/***/ },
/* 1652 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(19));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(40));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(39));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(12));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(22));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _Slider = _interopRequireDefault(__webpack_require__(313));
	
	var _VolumeLevel = _interopRequireDefault(__webpack_require__(1653));
	
	var propTypes = {
	  actions: _propTypes["default"].object,
	  player: _propTypes["default"].object,
	  className: _propTypes["default"].string,
	  onFocus: _propTypes["default"].func,
	  onBlur: _propTypes["default"].func
	};
	
	var VolumeBar =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(VolumeBar, _Component);
	
	  function VolumeBar(props, context) {
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, VolumeBar);
	    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(VolumeBar).call(this, props, context));
	    _this.state = {
	      percentage: '0%'
	    };
	    _this.handleMouseMove = _this.handleMouseMove.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handlePercentageChange = _this.handlePercentageChange.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.checkMuted = _this.checkMuted.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.getPercent = _this.getPercent.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.stepForward = _this.stepForward.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.stepBack = _this.stepBack.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleFocus = _this.handleFocus.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleBlur = _this.handleBlur.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
	    return _this;
	  }
	
	  (0, _createClass2["default"])(VolumeBar, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {}
	  }, {
	    key: "getPercent",
	    value: function getPercent() {
	      var player = this.props.player;
	
	      if (player.muted) {
	        return 0;
	      }
	
	      return player.volume;
	    }
	  }, {
	    key: "checkMuted",
	    value: function checkMuted() {
	      var _this$props = this.props,
	          player = _this$props.player,
	          actions = _this$props.actions;
	
	      if (player.muted) {
	        actions.mute(false);
	      }
	    }
	  }, {
	    key: "handleMouseMove",
	    value: function handleMouseMove(event) {
	      var actions = this.props.actions;
	      this.checkMuted();
	      var distance = this.slider.calculateDistance(event);
	      actions.changeVolume(distance);
	    }
	  }, {
	    key: "stepForward",
	    value: function stepForward() {
	      var _this$props2 = this.props,
	          player = _this$props2.player,
	          actions = _this$props2.actions;
	      this.checkMuted();
	      actions.changeVolume(player.volume + 0.1);
	    }
	  }, {
	    key: "stepBack",
	    value: function stepBack() {
	      var _this$props3 = this.props,
	          player = _this$props3.player,
	          actions = _this$props3.actions;
	      this.checkMuted();
	      actions.changeVolume(player.volume - 0.1);
	    }
	  }, {
	    key: "handleFocus",
	    value: function handleFocus(e) {
	      if (this.props.onFocus) {
	        this.props.onFocus(e);
	      }
	    }
	  }, {
	    key: "handleBlur",
	    value: function handleBlur(e) {
	      if (this.props.onBlur) {
	        this.props.onBlur(e);
	      }
	    }
	  }, {
	    key: "handlePercentageChange",
	    value: function handlePercentageChange(percentage) {
	      if (percentage !== this.state.percentage) {
	        this.setState({
	          percentage: percentage
	        });
	      }
	    }
	  }, {
	    key: "handleClick",
	    value: function handleClick(event) {
	      event.stopPropagation();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _this$props4 = this.props,
	          player = _this$props4.player,
	          className = _this$props4.className;
	      var volume = (player.volume * 100).toFixed(2);
	      return _react["default"].createElement(_Slider["default"], (0, _extends2["default"])({
	        ref: function ref(c) {
	          _this2.slider = c;
	        },
	        label: "volume level",
	        valuenow: volume,
	        valuetext: "".concat(volume, "%"),
	        onMouseMove: this.handleMouseMove,
	        onFocus: this.handleFocus,
	        onBlur: this.handleBlur,
	        onClick: this.handleClick,
	        sliderActive: this.handleFocus,
	        sliderInactive: this.handleBlur,
	        getPercent: this.getPercent,
	        onPercentageChange: this.handlePercentageChange,
	        stepForward: this.stepForward,
	        stepBack: this.stepBack
	      }, this.props, {
	        className: (0, _classnames["default"])(className, 'video-react-volume-bar video-react-slider-bar')
	      }), _react["default"].createElement(_VolumeLevel["default"], this.props));
	    }
	  }]);
	  return VolumeBar;
	}(_react.Component);
	
	VolumeBar.propTypes = propTypes;
	VolumeBar.displayName = 'VolumeBar';
	var _default = VolumeBar;
	exports["default"] = _default;

/***/ },
/* 1653 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var propTypes = {
	  percentage: _propTypes["default"].string,
	  vertical: _propTypes["default"].bool,
	  className: _propTypes["default"].string
	};
	var defaultProps = {
	  percentage: '100%',
	  vertical: false
	};
	
	function VolumeLevel(_ref) {
	  var percentage = _ref.percentage,
	      vertical = _ref.vertical,
	      className = _ref.className;
	  var style = {};
	
	  if (vertical) {
	    style.height = percentage;
	  } else {
	    style.width = percentage;
	  }
	
	  return _react["default"].createElement("div", {
	    className: (0, _classnames["default"])(className, 'video-react-volume-level'),
	    style: style
	  }, _react["default"].createElement("span", {
	    className: "video-react-control-text"
	  }));
	}
	
	VolumeLevel.propTypes = propTypes;
	VolumeLevel.defaultProps = defaultProps;
	VolumeLevel.displayName = 'VolumeLevel';
	var _default = VolumeLevel;
	exports["default"] = _default;

/***/ },
/* 1654 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(10);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "Player", {
	  enumerable: true,
	  get: function get() {
	    return _Player["default"];
	  }
	});
	Object.defineProperty(exports, "Video", {
	  enumerable: true,
	  get: function get() {
	    return _Video["default"];
	  }
	});
	Object.defineProperty(exports, "BigPlayButton", {
	  enumerable: true,
	  get: function get() {
	    return _BigPlayButton["default"];
	  }
	});
	Object.defineProperty(exports, "LoadingSpinner", {
	  enumerable: true,
	  get: function get() {
	    return _LoadingSpinner["default"];
	  }
	});
	Object.defineProperty(exports, "PosterImage", {
	  enumerable: true,
	  get: function get() {
	    return _PosterImage["default"];
	  }
	});
	Object.defineProperty(exports, "Slider", {
	  enumerable: true,
	  get: function get() {
	    return _Slider["default"];
	  }
	});
	Object.defineProperty(exports, "Bezel", {
	  enumerable: true,
	  get: function get() {
	    return _Bezel["default"];
	  }
	});
	Object.defineProperty(exports, "Shortcut", {
	  enumerable: true,
	  get: function get() {
	    return _Shortcut["default"];
	  }
	});
	Object.defineProperty(exports, "ControlBar", {
	  enumerable: true,
	  get: function get() {
	    return _ControlBar["default"];
	  }
	});
	Object.defineProperty(exports, "PlayToggle", {
	  enumerable: true,
	  get: function get() {
	    return _PlayToggle["default"];
	  }
	});
	Object.defineProperty(exports, "ForwardControl", {
	  enumerable: true,
	  get: function get() {
	    return _ForwardControl["default"];
	  }
	});
	Object.defineProperty(exports, "ReplayControl", {
	  enumerable: true,
	  get: function get() {
	    return _ReplayControl["default"];
	  }
	});
	Object.defineProperty(exports, "FullscreenToggle", {
	  enumerable: true,
	  get: function get() {
	    return _FullscreenToggle["default"];
	  }
	});
	Object.defineProperty(exports, "ProgressControl", {
	  enumerable: true,
	  get: function get() {
	    return _ProgressControl["default"];
	  }
	});
	Object.defineProperty(exports, "SeekBar", {
	  enumerable: true,
	  get: function get() {
	    return _SeekBar["default"];
	  }
	});
	Object.defineProperty(exports, "PlayProgressBar", {
	  enumerable: true,
	  get: function get() {
	    return _PlayProgressBar["default"];
	  }
	});
	Object.defineProperty(exports, "LoadProgressBar", {
	  enumerable: true,
	  get: function get() {
	    return _LoadProgressBar["default"];
	  }
	});
	Object.defineProperty(exports, "MouseTimeDisplay", {
	  enumerable: true,
	  get: function get() {
	    return _MouseTimeDisplay["default"];
	  }
	});
	Object.defineProperty(exports, "VolumeMenuButton", {
	  enumerable: true,
	  get: function get() {
	    return _VolumeMenuButton["default"];
	  }
	});
	Object.defineProperty(exports, "PlaybackRateMenuButton", {
	  enumerable: true,
	  get: function get() {
	    return _PlaybackRateMenuButton["default"];
	  }
	});
	Object.defineProperty(exports, "PlaybackRate", {
	  enumerable: true,
	  get: function get() {
	    return _PlaybackRate["default"];
	  }
	});
	Object.defineProperty(exports, "ClosedCaptionButton", {
	  enumerable: true,
	  get: function get() {
	    return _ClosedCaptionButton["default"];
	  }
	});
	Object.defineProperty(exports, "RemainingTimeDisplay", {
	  enumerable: true,
	  get: function get() {
	    return _RemainingTimeDisplay["default"];
	  }
	});
	Object.defineProperty(exports, "CurrentTimeDisplay", {
	  enumerable: true,
	  get: function get() {
	    return _CurrentTimeDisplay["default"];
	  }
	});
	Object.defineProperty(exports, "DurationDisplay", {
	  enumerable: true,
	  get: function get() {
	    return _DurationDisplay["default"];
	  }
	});
	Object.defineProperty(exports, "TimeDivider", {
	  enumerable: true,
	  get: function get() {
	    return _TimeDivider["default"];
	  }
	});
	Object.defineProperty(exports, "MenuButton", {
	  enumerable: true,
	  get: function get() {
	    return _MenuButton["default"];
	  }
	});
	Object.defineProperty(exports, "playerReducer", {
	  enumerable: true,
	  get: function get() {
	    return _reducers.playerReducer;
	  }
	});
	Object.defineProperty(exports, "operationReducer", {
	  enumerable: true,
	  get: function get() {
	    return _reducers.operationReducer;
	  }
	});
	exports.videoActions = exports.playerActions = void 0;
	
	var _Player = _interopRequireDefault(__webpack_require__(1645));
	
	var _Video = _interopRequireDefault(__webpack_require__(672));
	
	var _BigPlayButton = _interopRequireDefault(__webpack_require__(667));
	
	var _LoadingSpinner = _interopRequireDefault(__webpack_require__(669));
	
	var _PosterImage = _interopRequireDefault(__webpack_require__(670));
	
	var _Slider = _interopRequireDefault(__webpack_require__(313));
	
	var _Bezel = _interopRequireDefault(__webpack_require__(666));
	
	var _Shortcut = _interopRequireDefault(__webpack_require__(671));
	
	var _ControlBar = _interopRequireDefault(__webpack_require__(673));
	
	var _PlayToggle = _interopRequireDefault(__webpack_require__(680));
	
	var _ForwardControl = _interopRequireDefault(__webpack_require__(674));
	
	var _ReplayControl = _interopRequireDefault(__webpack_require__(682));
	
	var _FullscreenToggle = _interopRequireDefault(__webpack_require__(676));
	
	var _ProgressControl = _interopRequireDefault(__webpack_require__(681));
	
	var _SeekBar = _interopRequireDefault(__webpack_require__(683));
	
	var _PlayProgressBar = _interopRequireDefault(__webpack_require__(679));
	
	var _LoadProgressBar = _interopRequireDefault(__webpack_require__(677));
	
	var _MouseTimeDisplay = _interopRequireDefault(__webpack_require__(678));
	
	var _VolumeMenuButton = _interopRequireDefault(__webpack_require__(684));
	
	var _PlaybackRateMenuButton = _interopRequireDefault(__webpack_require__(314));
	
	var _PlaybackRate = _interopRequireDefault(__webpack_require__(1647));
	
	var _ClosedCaptionButton = _interopRequireDefault(__webpack_require__(1646));
	
	var _RemainingTimeDisplay = _interopRequireDefault(__webpack_require__(687));
	
	var _CurrentTimeDisplay = _interopRequireDefault(__webpack_require__(685));
	
	var _DurationDisplay = _interopRequireDefault(__webpack_require__(686));
	
	var _TimeDivider = _interopRequireDefault(__webpack_require__(688));
	
	var _MenuButton = _interopRequireDefault(__webpack_require__(315));
	
	var playerActions = _interopRequireWildcard(__webpack_require__(226));
	
	exports.playerActions = playerActions;
	
	var videoActions = _interopRequireWildcard(__webpack_require__(312));
	
	exports.videoActions = videoActions;
	
	var _reducers = __webpack_require__(689);

/***/ },
/* 1655 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = operation;
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(47));
	
	var _player = __webpack_require__(226);
	
	var initialState = {
	  count: 0,
	  operation: {
	    action: '',
	    source: ''
	  }
	};
	
	function operation() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments.length > 1 ? arguments[1] : undefined;
	
	  switch (action.type) {
	    case _player.OPERATE:
	      return (0, _objectSpread2["default"])({}, state, {
	        count: state.count + 1,
	        operation: (0, _objectSpread2["default"])({}, state.operation, action.operation)
	      });
	
	    default:
	      return state;
	  }
	}

/***/ },
/* 1656 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = player;
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(47));
	
	var _video = __webpack_require__(312);
	
	var _player = __webpack_require__(226);
	
	var initialState = {
	  currentSrc: null,
	  duration: 0,
	  currentTime: 0,
	  seekingTime: 0,
	  buffered: null,
	  waiting: false,
	  seeking: false,
	  paused: true,
	  autoPaused: false,
	  ended: false,
	  playbackRate: 1,
	  muted: false,
	  volume: 1,
	  readyState: 0,
	  networkState: 0,
	  videoWidth: 0,
	  videoHeight: 0,
	  hasStarted: false,
	  userActivity: true,
	  isActive: false,
	  isFullscreen: false,
	  activeTextTrack: null
	};
	
	function player() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments.length > 1 ? arguments[1] : undefined;
	
	  switch (action.type) {
	    case _player.USER_ACTIVATE:
	      return (0, _objectSpread2["default"])({}, state, {
	        userActivity: action.activity
	      });
	
	    case _player.PLAYER_ACTIVATE:
	      return (0, _objectSpread2["default"])({}, state, {
	        isActive: action.activity
	      });
	
	    case _player.FULLSCREEN_CHANGE:
	      return (0, _objectSpread2["default"])({}, state, {
	        isFullscreen: !!action.isFullscreen
	      });
	
	    case _video.SEEKING_TIME:
	      return (0, _objectSpread2["default"])({}, state, {
	        seekingTime: action.time
	      });
	
	    case _video.END_SEEKING:
	      return (0, _objectSpread2["default"])({}, state, {
	        seekingTime: 0
	      });
	
	    case _video.LOAD_START:
	      return (0, _objectSpread2["default"])({}, state, action.videoProps, {
	        hasStarted: false,
	        ended: false
	      });
	
	    case _video.CAN_PLAY:
	      return (0, _objectSpread2["default"])({}, state, action.videoProps, {
	        waiting: false
	      });
	
	    case _video.WAITING:
	      return (0, _objectSpread2["default"])({}, state, action.videoProps, {
	        waiting: true
	      });
	
	    case _video.CAN_PLAY_THROUGH:
	    case _video.PLAYING:
	      return (0, _objectSpread2["default"])({}, state, action.videoProps, {
	        waiting: false
	      });
	
	    case _video.PLAY:
	      return (0, _objectSpread2["default"])({}, state, action.videoProps, {
	        ended: false,
	        paused: false,
	        autoPaused: false,
	        waiting: false,
	        hasStarted: true
	      });
	
	    case _video.PAUSE:
	      return (0, _objectSpread2["default"])({}, state, action.videoProps, {
	        paused: true
	      });
	
	    case _video.END:
	      return (0, _objectSpread2["default"])({}, state, action.videoProps, {
	        ended: true
	      });
	
	    case _video.SEEKING:
	      return (0, _objectSpread2["default"])({}, state, action.videoProps, {
	        seeking: true
	      });
	
	    case _video.SEEKED:
	      return (0, _objectSpread2["default"])({}, state, action.videoProps, {
	        seeking: false
	      });
	
	    case _video.ERROR:
	      return (0, _objectSpread2["default"])({}, state, action.videoProps, {
	        error: 'UNKNOWN ERROR',
	        ended: true
	      });
	
	    case _video.DURATION_CHANGE:
	    case _video.TIME_UPDATE:
	    case _video.VOLUME_CHANGE:
	    case _video.PROGRESS_CHANGE:
	    case _video.RATE_CHANGE:
	    case _video.SUSPEND:
	    case _video.ABORT:
	    case _video.EMPTIED:
	    case _video.STALLED:
	    case _video.LOADED_META_DATA:
	    case _video.LOADED_DATA:
	    case _video.RESIZE:
	      return (0, _objectSpread2["default"])({}, state, action.videoProps);
	
	    case _video.ACTIVATE_TEXT_TRACK:
	      return (0, _objectSpread2["default"])({}, state, {
	        activeTextTrack: action.textTrack
	      });
	
	    default:
	      return state;
	  }
	}

/***/ },
/* 1657 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.IS_IOS = exports.IS_IPOD = exports.IS_IPHONE = exports.IS_IPAD = void 0;
	var USER_AGENT = typeof window !== 'undefined' && window.navigator ? window.navigator.userAgent : ''; // const webkitVersionMap = (/AppleWebKit\/([\d.]+)/i).exec(USER_AGENT);
	// const appleWebkitVersion = webkitVersionMap ? parseFloat(webkitVersionMap.pop()) : null;
	
	/*
	 * Device is an iPhone
	 *
	 * @type {Boolean}
	 * @constant
	 * @private
	 */
	
	var IS_IPAD = /iPad/i.test(USER_AGENT); // The Facebook app's UIWebView identifies as both an iPhone and iPad, so
	// to identify iPhones, we need to exclude iPads.
	// http://artsy.github.io/blog/2012/10/18/the-perils-of-ios-user-agent-sniffing/
	
	exports.IS_IPAD = IS_IPAD;
	var IS_IPHONE = /iPhone/i.test(USER_AGENT) && !IS_IPAD;
	exports.IS_IPHONE = IS_IPHONE;
	var IS_IPOD = /iPod/i.test(USER_AGENT);
	exports.IS_IPOD = IS_IPOD;
	var IS_IOS = IS_IPHONE || IS_IPAD || IS_IPOD;
	exports.IS_IOS = IS_IOS;

/***/ },
/* 1658 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var _objectSpread = __webpack_require__(701);
	
	function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }
	
	var _objectSpread__default = /*#__PURE__*/_interopDefaultLegacy(_objectSpread);
	
	/**
	 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
	 *
	 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
	 * during build.
	 * @param {number} code
	 */
	function formatProdErrorMessage(code) {
	  return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
	}
	
	// Inlined version of the `symbol-observable` polyfill
	var $$observable = (function () {
	  return typeof Symbol === 'function' && Symbol.observable || '@@observable';
	})();
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var randomString = function randomString() {
	  return Math.random().toString(36).substring(7).split('').join('.');
	};
	
	var ActionTypes = {
	  INIT: "@@redux/INIT" + randomString(),
	  REPLACE: "@@redux/REPLACE" + randomString(),
	  PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
	    return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
	  }
	};
	
	/**
	 * @param {any} obj The object to inspect.
	 * @returns {boolean} True if the argument appears to be a plain object.
	 */
	function isPlainObject(obj) {
	  if (typeof obj !== 'object' || obj === null) return false;
	  var proto = obj;
	
	  while (Object.getPrototypeOf(proto) !== null) {
	    proto = Object.getPrototypeOf(proto);
	  }
	
	  return Object.getPrototypeOf(obj) === proto;
	}
	
	// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
	function miniKindOf(val) {
	  if (val === void 0) return 'undefined';
	  if (val === null) return 'null';
	  var type = typeof val;
	
	  switch (type) {
	    case 'boolean':
	    case 'string':
	    case 'number':
	    case 'symbol':
	    case 'function':
	      {
	        return type;
	      }
	  }
	
	  if (Array.isArray(val)) return 'array';
	  if (isDate(val)) return 'date';
	  if (isError(val)) return 'error';
	  var constructorName = ctorName(val);
	
	  switch (constructorName) {
	    case 'Symbol':
	    case 'Promise':
	    case 'WeakMap':
	    case 'WeakSet':
	    case 'Map':
	    case 'Set':
	      return constructorName;
	  } // other
	
	
	  return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
	}
	
	function ctorName(val) {
	  return typeof val.constructor === 'function' ? val.constructor.name : null;
	}
	
	function isError(val) {
	  return val instanceof Error || typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number';
	}
	
	function isDate(val) {
	  if (val instanceof Date) return true;
	  return typeof val.toDateString === 'function' && typeof val.getDate === 'function' && typeof val.setDate === 'function';
	}
	
	function kindOf(val) {
	  var typeOfVal = typeof val;
	
	  if (false) {
	    typeOfVal = miniKindOf(val);
	  }
	
	  return typeOfVal;
	}
	
	/**
	 * @deprecated
	 *
	 * **We recommend using the `configureStore` method
	 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
	 *
	 * Redux Toolkit is our recommended approach for writing Redux logic today,
	 * including store setup, reducers, data fetching, and more.
	 *
	 * **For more details, please read this Redux docs page:**
	 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
	 *
	 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
	 * simplifies setup and helps avoid common bugs.
	 *
	 * You should not be using the `redux` core package by itself today, except for learning purposes.
	 * The `createStore` method from the core `redux` package will not be removed, but we encourage
	 * all users to migrate to using Redux Toolkit for all Redux code.
	 *
	 * If you want to use `createStore` without this visual deprecation warning, use
	 * the `legacy_createStore` import instead:
	 *
	 * `import { legacy_createStore as createStore} from 'redux'`
	 *
	 */
	
	function createStore(reducer, preloadedState, enhancer) {
	  var _ref2;
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') {
	    throw new Error( true ? formatProdErrorMessage(0) : 'It looks like you are passing several store enhancers to ' + 'createStore(). This is not supported. Instead, compose them ' + 'together to a single function. See https://redux.js.org/tutorials/fundamentals/part-4-store#creating-a-store-with-enhancers for an example.');
	  }
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = preloadedState;
	    preloadedState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error( true ? formatProdErrorMessage(1) : "Expected the enhancer to be a function. Instead, received: '" + kindOf(enhancer) + "'");
	    }
	
	    return enhancer(createStore)(reducer, preloadedState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error( true ? formatProdErrorMessage(2) : "Expected the root reducer to be a function. Instead, received: '" + kindOf(reducer) + "'");
	  }
	
	  var currentReducer = reducer;
	  var currentState = preloadedState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	  /**
	   * This makes a shallow copy of currentListeners so we can use
	   * nextListeners as a temporary list while dispatching.
	   *
	   * This prevents any bugs around consumers calling
	   * subscribe/unsubscribe in the middle of a dispatch.
	   */
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	
	
	  function getState() {
	    if (isDispatching) {
	      throw new Error( true ? formatProdErrorMessage(3) : 'You may not call store.getState() while the reducer is executing. ' + 'The reducer has already received the state as an argument. ' + 'Pass it down from the top reducer instead of reading it from the store.');
	    }
	
	    return currentState;
	  }
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all state changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	
	
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error( true ? formatProdErrorMessage(4) : "Expected the listener to be a function. Instead, received: '" + kindOf(listener) + "'");
	    }
	
	    if (isDispatching) {
	      throw new Error( true ? formatProdErrorMessage(5) : 'You may not call store.subscribe() while the reducer is executing. ' + 'If you would like to be notified after the store has been updated, subscribe from a ' + 'component and invoke store.getState() in the callback to access the latest state. ' + 'See https://redux.js.org/api/store#subscribelistener for more details.');
	    }
	
	    var isSubscribed = true;
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      if (isDispatching) {
	        throw new Error( true ? formatProdErrorMessage(6) : 'You may not unsubscribe from a store listener while the reducer is executing. ' + 'See https://redux.js.org/api/store#subscribelistener for more details.');
	      }
	
	      isSubscribed = false;
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	      currentListeners = null;
	    };
	  }
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	
	
	  function dispatch(action) {
	    if (!isPlainObject(action)) {
	      throw new Error( true ? formatProdErrorMessage(7) : "Actions must be plain objects. Instead, the actual type was: '" + kindOf(action) + "'. You may need to add middleware to your store setup to handle dispatching other values, such as 'redux-thunk' to handle dispatching functions. See https://redux.js.org/tutorials/fundamentals/part-4-store#middleware and https://redux.js.org/tutorials/fundamentals/part-6-async-logic#using-the-redux-thunk-middleware for examples.");
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error( true ? formatProdErrorMessage(8) : 'Actions may not have an undefined "type" property. You may have misspelled an action type string constant.');
	    }
	
	    if (isDispatching) {
	      throw new Error( true ? formatProdErrorMessage(9) : 'Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	
	    for (var i = 0; i < listeners.length; i++) {
	      var listener = listeners[i];
	      listener();
	    }
	
	    return action;
	  }
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	
	
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error( true ? formatProdErrorMessage(10) : "Expected the nextReducer to be a function. Instead, received: '" + kindOf(nextReducer));
	    }
	
	    currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
	    // Any reducers that existed in both the new and old rootReducer
	    // will receive the previous state. This effectively populates
	    // the new state tree with any relevant data from the old one.
	
	    dispatch({
	      type: ActionTypes.REPLACE
	    });
	  }
	  /**
	   * Interoperability point for observable/reactive libraries.
	   * @returns {observable} A minimal observable of state changes.
	   * For more information, see the observable proposal:
	   * https://github.com/tc39/proposal-observable
	   */
	
	
	  function observable() {
	    var _ref;
	
	    var outerSubscribe = subscribe;
	    return _ref = {
	      /**
	       * The minimal observable subscription method.
	       * @param {Object} observer Any object that can be used as an observer.
	       * The observer object should have a `next` method.
	       * @returns {subscription} An object with an `unsubscribe` method that can
	       * be used to unsubscribe the observable from the store, and prevent further
	       * emission of values from the observable.
	       */
	      subscribe: function subscribe(observer) {
	        if (typeof observer !== 'object' || observer === null) {
	          throw new Error( true ? formatProdErrorMessage(11) : "Expected the observer to be an object. Instead, received: '" + kindOf(observer) + "'");
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = outerSubscribe(observeState);
	        return {
	          unsubscribe: unsubscribe
	        };
	      }
	    }, _ref[$$observable] = function () {
	      return this;
	    }, _ref;
	  } // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	
	
	  dispatch({
	    type: ActionTypes.INIT
	  });
	  return _ref2 = {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  }, _ref2[$$observable] = observable, _ref2;
	}
	/**
	 * Creates a Redux store that holds the state tree.
	 *
	 * **We recommend using `configureStore` from the
	 * `@reduxjs/toolkit` package**, which replaces `createStore`:
	 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
	 *
	 * The only way to change the data in the store is to call `dispatch()` on it.
	 *
	 * There should only be a single store in your app. To specify how different
	 * parts of the state tree respond to actions, you may combine several reducers
	 * into a single reducer function by using `combineReducers`.
	 *
	 * @param {Function} reducer A function that returns the next state tree, given
	 * the current state tree and the action to handle.
	 *
	 * @param {any} [preloadedState] The initial state. You may optionally specify it
	 * to hydrate the state from the server in universal apps, or to restore a
	 * previously serialized user session.
	 * If you use `combineReducers` to produce the root reducer function, this must be
	 * an object with the same shape as `combineReducers` keys.
	 *
	 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
	 * to enhance the store with third-party capabilities such as middleware,
	 * time travel, persistence, etc. The only store enhancer that ships with Redux
	 * is `applyMiddleware()`.
	 *
	 * @returns {Store} A Redux store that lets you read the state, dispatch actions
	 * and subscribe to changes.
	 */
	
	var legacy_createStore = createStore;
	
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	
	
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	  } catch (e) {} // eslint-disable-line no-empty
	
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!isPlainObject(inputState)) {
	    return "The " + argumentName + " has unexpected type of \"" + kindOf(inputState) + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
	  });
	  unexpectedKeys.forEach(function (key) {
	    unexpectedKeyCache[key] = true;
	  });
	  if (action && action.type === ActionTypes.REPLACE) return;
	
	  if (unexpectedKeys.length > 0) {
	    return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
	  }
	}
	
	function assertReducerShape(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, {
	      type: ActionTypes.INIT
	    });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error( true ? formatProdErrorMessage(12) : "The slice reducer for key \"" + key + "\" returned undefined during initialization. " + "If the state passed to the reducer is undefined, you must " + "explicitly return the initial state. The initial state may " + "not be undefined. If you don't want to set a value for this reducer, " + "you can use null instead of undefined.");
	    }
	
	    if (typeof reducer(undefined, {
	      type: ActionTypes.PROBE_UNKNOWN_ACTION()
	    }) === 'undefined') {
	      throw new Error( true ? formatProdErrorMessage(13) : "The slice reducer for key \"" + key + "\" returned undefined when probed with a random type. " + ("Don't try to handle '" + ActionTypes.INIT + "' or other actions in \"redux/*\" ") + "namespace. They are considered private. Instead, you must return the " + "current state for any unknown actions, unless it is undefined, " + "in which case you must return the initial state, regardless of the " + "action type. The initial state may not be undefined, but can be null.");
	    }
	  });
	}
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	
	
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	
	    if (false) {
	      if (typeof reducers[key] === 'undefined') {
	        warning("No reducer provided for key \"" + key + "\"");
	      }
	    }
	
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	
	  var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
	  // keys multiple times.
	
	  var unexpectedKeyCache;
	
	  if (false) {
	    unexpectedKeyCache = {};
	  }
	
	  var shapeAssertionError;
	
	  try {
	    assertReducerShape(finalReducers);
	  } catch (e) {
	    shapeAssertionError = e;
	  }
	
	  return function combination(state, action) {
	    if (state === void 0) {
	      state = {};
	    }
	
	    if (shapeAssertionError) {
	      throw shapeAssertionError;
	    }
	
	    if (false) {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
	
	      if (warningMessage) {
	        warning(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	
	    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
	      var _key = finalReducerKeys[_i];
	      var reducer = finalReducers[_key];
	      var previousStateForKey = state[_key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	
	      if (typeof nextStateForKey === 'undefined') {
	        var actionType = action && action.type;
	        throw new Error( true ? formatProdErrorMessage(14) : "When called with an action of type " + (actionType ? "\"" + String(actionType) + "\"" : '(unknown type)') + ", the slice reducer for key \"" + _key + "\" returned undefined. " + "To ignore an action, you must explicitly return the previous state. " + "If you want this reducer to hold no value, you can return null instead of undefined.");
	      }
	
	      nextState[_key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	
	    hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
	    return hasChanged ? nextState : state;
	  };
	}
	
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(this, arguments));
	  };
	}
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass an action creator as the first argument,
	 * and get a dispatch wrapped function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	
	
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if (typeof actionCreators !== 'object' || actionCreators === null) {
	    throw new Error( true ? formatProdErrorMessage(16) : "bindActionCreators expected an object or a function, but instead received: '" + kindOf(actionCreators) + "'. " + "Did you write \"import ActionCreators from\" instead of \"import * as ActionCreators from\"?");
	  }
	
	  var boundActionCreators = {};
	
	  for (var key in actionCreators) {
	    var actionCreator = actionCreators[key];
	
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	
	  return boundActionCreators;
	}
	
	/**
	 * Composes single-argument functions from right to left. The rightmost
	 * function can take multiple arguments as it provides the signature for
	 * the resulting composite function.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing the argument functions
	 * from right to left. For example, compose(f, g, h) is identical to doing
	 * (...args) => f(g(h(...args))).
	 */
	function compose() {
	  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(void 0, arguments));
	    };
	  });
	}
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function () {
	      var store = createStore.apply(void 0, arguments);
	
	      var _dispatch = function dispatch() {
	        throw new Error( true ? formatProdErrorMessage(15) : 'Dispatching while constructing your middleware is not allowed. ' + 'Other middleware would not be applied to this dispatch.');
	      };
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch() {
	          return _dispatch.apply(void 0, arguments);
	        }
	      };
	      var chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = compose.apply(void 0, chain)(store.dispatch);
	      return _objectSpread__default['default'](_objectSpread__default['default']({}, store), {}, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}
	
	exports.__DO_NOT_USE__ActionTypes = ActionTypes;
	exports.applyMiddleware = applyMiddleware;
	exports.bindActionCreators = bindActionCreators;
	exports.combineReducers = combineReducers;
	exports.compose = compose;
	exports.createStore = createStore;
	exports.legacy_createStore = legacy_createStore;


/***/ },
/* 1659 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {module.exports = __webpack_amd_options__;
	
	/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ },
/* 1660 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 1661 */
/***/ function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ]
	
	    var isDataView = function(obj) {
	      return obj && DataView.prototype.isPrototypeOf(obj)
	    }
	
	    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
	      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	    }
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var oldValue = this.map[name]
	    this.map[name] = oldValue ? oldValue+','+value : value
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    name = normalizeName(name)
	    return this.has(name) ? this.map[name] : null
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value)
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this)
	      }
	    }
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsArrayBuffer(blob)
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsText(blob)
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf)
	    var chars = new Array(view.length)
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i])
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength)
	      view.set(new Uint8Array(buf))
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (!body) {
	        this._bodyText = ''
	      } else if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer)
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer])
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body)
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      }
	    }
	
	    this.text = function() {
	      var rejected = consumed(this)
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	
	    if (input instanceof Request) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = String(input)
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, { body: this._bodyInit })
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers()
	    rawHeaders.split(/\r?\n/).forEach(function(line) {
	      var parts = line.split(':')
	      var key = parts.shift().trim()
	      if (key) {
	        var value = parts.join(':').trim()
	        headers.append(key, value)
	      }
	    })
	    return headers
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = 'status' in options ? options.status : 200
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = 'statusText' in options ? options.statusText : 'OK'
	    this.headers = new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init)
	      var xhr = new XMLHttpRequest()
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        }
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ },
/* 1662 */
/***/ function(module, exports) {

	/* (ignored) */

/***/ },
/* 1663 */
1662,
/* 1664 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(__webpack_module_template_argument_0__);
	} else {
	  module.exports = require('./cjs/react-is.development.js');
	}


/***/ }
/******/ ])));


// WEBPACK FOOTER //
// static/js/main.b8455427.js